webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1137);
	module.exports = __webpack_require__(801);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.copyTextToClipboard = exports.getOrderNoteShareString = exports.enumtranslate = exports.translation = undefined;
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Main method for translating texts
	var translation = exports.translation = function translation(textKey, params, comment) {
	  var space = ' ';
	  var intVal = parseInt(textKey);
	  if (isNaN(intVal)) return textKey;
	
	  var state = _store2.default.getState().i18nState;
	  var langMessages = state.translations[state.lang];
	
	  if (langMessages === undefined) {
	    return space;
	  }
	
	  var message = langMessages[textKey];
	  if (message === undefined || message === '') {
	    return space;
	  }
	
	  if (params !== undefined) {
	    for (var k in params) {
	      var reg = new RegExp('{' + k + '}', 'g');
	      message = message.replace(reg, params[k]);
	    }
	  }
	
	  return message;
	};
	
	// Gets dictionary-key for enum. Optionally updating the enums data from API if enum could not be found.
	var enumtranslate = exports.enumtranslate = function enumtranslate(key, numb) {
	  var getIfMissing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var enums = _store2.default.getState().common.enums_new;
	
	  if (typeof enums[key] !== 'undefined') {
	    return enums[key][numb];
	  }
	  if (getIfMissing === true) {
	    // If enum is missing, try to reload from API
	    if (window.isGettingEnums !== true) {
	      window.isGettingEnums = true;
	      console.log('Missing enum for key ', key, 'number', numb, '. Reloading enums...');
	      var url = _constants.API_URL + '/Enums/Get';
	      _axios2.default.get(url).then(function (res) {
	        _store2.default.dispatch({
	          type: _constants.SET_ENUMS,
	          enums: res.data
	        });
	        console.log('Got enums', res);
	        window.isGettingEnums = false;
	      }, function (err) {
	        console.error('Error getting enums', err);
	        window.isGettingEnums = false;
	      });
	    }
	  }
	  return numb;
	};
	
	// Gets a string with the types the orderNote is shared with
	var getOrderNoteShareString = exports.getOrderNoteShareString = function getOrderNoteShareString(noteShareType) {
	  var result = '';
	
	  if (noteShareType === '') throw new Error('empty');
	  if (isNaN(noteShareType)) throw new Error('not a number');
	  noteShareType = Number(noteShareType);
	
	  // internal
	  if ((noteShareType & 1) === 1) {
	    result += translation(341) + ', ';
	  }
	
	  // customer
	  if ((noteShareType & 2) === 2) {
	    result += translation(17859) + ', ';
	  }
	
	  // paintshop
	  if ((noteShareType & 4) === 4) {
	    result += translation(17860) + ', ';
	  }
	
	  // paint WP
	  if ((noteShareType & 8) === 8) {
	    result += translation(1878) + ', ';
	  }
	
	  return result.replace(/,\s+$/g, '');
	};
	
	// Copies the provided text to the clipboard
	var copyTextToClipboard = exports.copyTextToClipboard = function copyTextToClipboard(text) {
	  if (navigator.clipboard) {
	    navigator.clipboard.writeText(text);
	  } else {
	    var textArea = document.createElement('textarea');
	    textArea.value = text;
	    textArea.style.top = '0';
	    textArea.style.left = '0';
	    textArea.style.position = 'fixed';
	    document.body.appendChild(textArea);
	    textArea.focus();
	    textArea.select();
	    document.execCommand('copy');
	    document.body.removeChild(textArea);
	  }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1886);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(1887);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.19.3
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(1769)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.19.3';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// API URL
	var API_BASE = exports.API_BASE = ("https://live-backend.apromas.com");
	var API_URL = exports.API_URL = ("https://live-backend.apromas.com/API");
	var FILE_STORAGE = exports.FILE_STORAGE = ("");
	var FILE_STORAGE_API = exports.FILE_STORAGE_API = ("https://storage.apromas.com/API");
	
	var CarRentalSystemTypes = exports.CarRentalSystemTypes = {
	  NONE: 0,
	  RENTLOG: 1
	};
	
	var RenderTypes = exports.RenderTypes = {
	  NONE: 0,
	  FORMATTER: 1,
	  INPUT: 2,
	  CHECKBOX: 3,
	  DATETIME: 4,
	  SELECTLIST: 5,
	  RADIOLIST: 6,
	  CHECKBOXLIST: 7,
	  INPUTFIELD2: 8,
	  SELECTLIST2: 9,
	  INPUTICON: 10,
	  CHECKBOXICON: 11,
	  TEXTAREA: 12
	};
	
	var OrderSteps = exports.OrderSteps = {
	  NEW_ORDER: 1,
	  DISASSEMBLY: 101,
	  REPAIR: 102,
	  BODY_PAINTING: 105,
	  PREPARING: 2,
	  FILLING: 3,
	  SANDING: 4,
	  PAINTING: 5,
	  FINISHING: 6,
	  ASSEMBLY: 103,
	  BODY_FINISHING: 104,
	  DELIVERY: 7,
	  ARCHIVE: 8
	
	};
	
	var SparepartStatus = exports.SparepartStatus = {
	  NONE: 0,
	  UNKNOWN: 1,
	  NOTINUSE: 2,
	  INSTOCK: 4,
	  ORDERED: 8,
	  RECEIVED: 16,
	  DEFECTIVE: 32,
	  INCORRECT: 64,
	  BACKORDER: 128
	};
	
	var OrderTypes = exports.OrderTypes = {
	  Insurance: 1,
	  Selling: 2,
	  FactoryWarranty: 3,
	  Other: 4,
	  Complaint: 5,
	  Private: 6
	};
	
	var DracarAllowOrderTypes = exports.DracarAllowOrderTypes = [OrderTypes.Insurance, OrderTypes.FactoryWarranty, OrderTypes.Private, OrderTypes.Selling];
	
	var AccountingSystemTypes = exports.AccountingSystemTypes = {
	  None: 0,
	  Economic: 1,
	  Helios: 2,
	  C5: 3,
	  // KeyLoop/Dracar
	  Dracar: 4,
	  // 24SevenOffice
	  TFSO: 5,
	  // KeyLoop/AutoLine
	  AutoLine: 6
	};
	
	var DracarJobFeeSettingType = exports.DracarJobFeeSettingType = {
	  LABOR_1: 1, // 1
	  BODYSHOP_ENVIRONMENT_2: 2, // 68D
	  SUNDRYPARTS_MATERIAL_3: 3, // 36D
	  SUNDRYPARTS_TOTAL_4: 4, // 37D
	  HOLLOW_CAVITY_SEALANT_5: 5, // 30D
	  PAINT_6: 6, // 53D
	  PAINT_ENVIRONMENT_7: 7, // 58D
	  DIFFERENCE_INSURANCE_8: 8, // 99D
	  AUTOLINE_CONSUMABLES_9: 9 // WFOR
	};
	
	var BookingTimesSectionType = exports.BookingTimesSectionType = {
	  Pickup: 0, // 'Pickup'
	  Production: 1, // 'ProductionDate'
	  Delivery: 2, // 'Delivery',
	  LeadTime: 3 // LeadTime determine body workdays. default is 5
	};
	
	var AssessmentReporType = exports.AssessmentReporType = {
	  Unknown: 0,
	  Forsi: 1,
	  ForsiManual: 2,
	  DBS: 3
	};
	
	var AssessmentSystemType = exports.AssessmentSystemType = {
	  None: 0,
	  Forsi: 1,
	  DBS: 2
	};
	
	var DepartmentType = exports.DepartmentType = {
	  Paint: 0,
	  Body: 1,
	  Both: 2
	
	  // Browsers & Devices (TODO: add browser checks here)
	};var isiOS = exports.isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	
	// Auth constants
	var SET_CURRENT_USER = exports.SET_CURRENT_USER = 'SET_CURRENT_USER';
	var SET_USER_PERMISSIONS = exports.SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
	var LOGIN_AS_USER = exports.LOGIN_AS_USER = 'LOGIN_AS_USER';
	var SET_LOGIN_AS = exports.SET_LOGIN_AS = 'SET_LOGIN_AS';
	var SET_LOGINTIMER = exports.SET_LOGINTIMER = 'SET_LOGINTIMER';
	var SET_WORKSCREEN = exports.SET_WORKSCREEN = 'SET_WORKSCREEN';
	var SET_PREV_WORKSCREEN = exports.SET_PREV_WORKSCREEN = 'SET_PREV_WORKSCREEN';
	var SET_ACCOUNTING_TYPE = exports.SET_ACCOUNTING_TYPE = 'SET_ACCOUNTING_TYPE';
	var SET_ALLOW_NO_CUSTOMER = exports.SET_ALLOW_NO_CUSTOMER = 'SET_ALLOW_NO_CUSTOMER';
	var SET_CAR_RENTALSYSTEM_TYPE = exports.SET_CAR_RENTALSYSTEM_TYPE = 'SET_CAR_RENTALSYSTEM_TYPE';
	var SET_COMPANY_HAVE_ASSIGNED_ESG = exports.SET_COMPANY_HAVE_ASSIGNED_ESG = 'SET_COMPANY_HAVE_ASSIGNED_ESG';
	// Orders constants
	var SET_ORDER = exports.SET_ORDER = 'SET_ORDER';
	var SET_ORDERS = exports.SET_ORDERS = 'SET_ORDERS';
	var SET_ORDER_BOOKING_TIMES = exports.SET_ORDER_BOOKING_TIMES = 'SET_ORDER_BOOKING_TIMES';
	var SET_WORKSCREEN_ORDERS = exports.SET_WORKSCREEN_ORDERS = 'SET_WORKSCREEN_ORDERS';
	var SET_WORKCARD_ORDER = exports.SET_WORKCARD_ORDER = 'SET_WORKCARD_ORDER';
	var SET_ORDERS_ERRORS = exports.SET_ORDERS_ERRORS = 'SET_ORDERS_ERRORS';
	var SET_ORDER_FILTER = exports.SET_ORDER_FILTER = 'SET_ORDER_FILTER';
	var SET_ORDERLIST_FILTER = exports.SET_ORDERLIST_FILTER = 'SET_ORDERLIST_FILTER';
	var SET_WORKSCREEN_ORDER_FILTER = exports.SET_WORKSCREEN_ORDER_FILTER = 'SET_WORKSCREEN_ORDER_FILTER';
	var SET_CUSTOMER_ORDER_FILTER = exports.SET_CUSTOMER_ORDER_FILTER = 'SET_CUSTOMER_ORDER_FILTER';
	var SET_WP_ORDER_FILTER = exports.SET_WP_ORDER_FILTER = 'SET_WP_ORDER_FILTER';
	var RESET_ORDER_FILTER = exports.RESET_ORDER_FILTER = 'RESET_ORDER_FILTER';
	var RESET_ORDERLIST_FILTER = exports.RESET_ORDERLIST_FILTER = 'RESET_ORDERLIST_FILTER';
	var RESET_WORKSCREEN_ORDER_FILTER = exports.RESET_WORKSCREEN_ORDER_FILTER = 'RESET_WORKSCREEN_ORDER_FILTER';
	var RESET_CUSTOMER_ORDER_FILTER = exports.RESET_CUSTOMER_ORDER_FILTER = 'RESET_CUSTOMER_ORDER_FILTER';
	var RESET_WP_ORDER_FILTER = exports.RESET_WP_ORDER_FILTER = 'RESET_WP_ORDER_FILTER';
	var SET_SIMPLESEARCH = exports.SET_SIMPLESEARCH = 'SET_SIMPLESEARCH';
	var SET_SIMPLESEARCH_WORKSCREEN = exports.SET_SIMPLESEARCH_WORKSCREEN = 'SET_SIMPLESEARCH_WORKSCREEN';
	var RESET_SIMPLESEARCH = exports.RESET_SIMPLESEARCH = 'RESET_SIMPLESEARCH';
	var RESET_SIMPLESEARCH_WORKSCREEN = exports.RESET_SIMPLESEARCH_WORKSCREEN = 'RESET_SIMPLESEARCH_WORKSCREEN';
	var SET_ORDERS_SEARCH = exports.SET_ORDERS_SEARCH = 'SET_ORDERS_SEARCH';
	var SET_LAST_VISITED_ORDER = exports.SET_LAST_VISITED_ORDER = 'SET_LAST_VISITED_ORDER';
	
	// Assign
	var SET_ACTIVE_EMPLOYEES = exports.SET_ACTIVE_EMPLOYEES = 'SET_ACTIVE_EMPLOYEES';
	var SET_STEP_ASSIGNMENTS = exports.SET_STEP_ASSIGNMENTS = 'SET_STEP_ASSIGNMENTS';
	
	// Price calculation
	var SET_PRICECALC_PRICES = exports.SET_PRICECALC_PRICES = 'SET_PRICECALC_PRICES';
	var OPEN_POPUP_PARTS = exports.OPEN_POPUP_PARTS = 'OPEN_POPUP_PARTS';
	var SET_CAR_PARTS = exports.SET_CAR_PARTS = 'SET_CAR_PARTS';
	var SET_CAR_PRICEPARTS = exports.SET_CAR_PRICEPARTS = 'SET_CAR_PRICEPARTS';
	var SET_CAR_SELECTED_PARTS = exports.SET_CAR_SELECTED_PARTS = 'SET_CAR_SELECTED_PARTS';
	var SET_CAR_ITEMS = exports.SET_CAR_ITEMS = 'SET_CAR_ITEMS';
	
	// Backdrop
	var OPEN_MENU = exports.OPEN_MENU = 'OPEN_MENU';
	var OPEN_POPUP = exports.OPEN_POPUP = 'OPEN_POPUP';
	var OPEN_POPUP_BG = exports.OPEN_POPUP_BG = 'OPEN_POPUP_BG';
	var SET_INFO_MODAL = exports.SET_INFO_MODAL = 'SET_INFO_MODAL';
	var BODY_SCROLL = exports.BODY_SCROLL = 'BODY_SCROLL';
	
	// Common
	var UPDATE_TASKS_WORKSCREEN = exports.UPDATE_TASKS_WORKSCREEN = 'UPDATE_TASKS_WORKSCREEN';
	var SET_PRICEMODEL_LIST = exports.SET_PRICEMODEL_LIST = 'SET_PRICEMODEL_LIST';
	var SET_PHONECODES = exports.SET_PHONECODES = 'SET_PHONECODES';
	var SET_VEHICLE_LOOKUP_SEVICES = exports.SET_VEHICLE_LOOKUP_SEVICES = 'SET_VEHICLE_LOOKUP_SEVICES';
	var SET_CUSTOMERS = exports.SET_CUSTOMERS = 'SET_CUSTOMERS';
	var SET_ACTIVE_CUSTOMER = exports.SET_ACTIVE_CUSTOMER = 'SET_ACTIVE_CUSTOMER';
	var SET_CUSTOMERGROUPS = exports.SET_CUSTOMERGROUPS = 'SET_CUSTOMERGROUPS';
	var SET_COMPANIES = exports.SET_COMPANIES = 'SET_COMPANIES';
	var SET_BRANDS = exports.SET_BRANDS = 'SET_BRANDS';
	var SET_ENUMS = exports.SET_ENUMS = 'SET_ENUMS';
	var SET_COUNTRIES = exports.SET_COUNTRIES = 'SET_COUNTRIES';
	var SET_DEFAULT_PHONECODE = exports.SET_DEFAULT_PHONECODE = 'SET_DEFAULT_PHONECODE';
	var SET_DEFAULT_LANGUAGE = exports.SET_DEFAULT_LANGUAGE = 'SET_DEFAULT_LANGUAGE';
	var SET_CURRENCY_CODE = exports.SET_CURRENCY_CODE = 'SET_CURRENCY_CODE';
	var SET_HAS_PAINT_PARTNER = exports.SET_HAS_PAINT_PARTNER = 'SET_HAS_PAINT_PARTNER';
	var SET_HAS_PARTNER = exports.SET_HAS_PARTNER = 'SET_HAS_PARTNER';
	// export const SET_ALLOWCARRENTALOVERVIEW = 'SET_ALLOWCARRENTALOVERVIEW'
	var SET_DEPARTMENT_TYPE = exports.SET_DEPARTMENT_TYPE = 'SET_DEPARTMENT_TYPE';
	var SET_ALLOW_CHANGE_DELIVERY = exports.SET_ALLOW_CHANGE_DELIVERY = 'SET_ALLOW_CHANGE_DELIVERY';
	var SET_ORDERLIST_USE_TIME_PICUP = exports.SET_ORDERLIST_USE_TIME_PICUP = 'SET_ORDERLIST_USE_TIME_PICUP';
	var SET_SHOP_ACTIVE_PUNCHCLOCK = exports.SET_SHOP_ACTIVE_PUNCHCLOCK = 'SET_SHOP_ACTIVE_PUNCHCLOCK';
	var SET_NEW_ORDERS_GROUPING = exports.SET_NEW_ORDERS_GROUPING = 'SET_NEW_ORDERS_GROUPING';
	var SET_EMPLOYEES = exports.SET_EMPLOYEES = 'SET_EMPLOYEES';
	var SET_HEADERINFO = exports.SET_HEADERINFO = 'SET_HEADERINFO';
	var SET_HEADERINFO_FORSI = exports.SET_HEADERINFO_FORSI = 'SET_HEADERINFO_FORSI';
	var SET_HEADERINFO_UPDATES = exports.SET_HEADERINFO_UPDATES = 'SET_HEADERINFO_UPDATES';
	var SET_HEADERINFO_EVALUATION = exports.SET_HEADERINFO_EVALUATION = 'SET_HEADERINFO_EVALUATION';
	var SET_HEADERINFO_MESSAGES = exports.SET_HEADERINFO_MESSAGES = 'SET_HEADERINFO_MESSAGES';
	var SET_HEADERINFO_TASKS = exports.SET_HEADERINFO_TASKS = 'SET_HEADERINFO_TASKS';
	var SET_HEADERINFO_CHAINNOTIFICATION = exports.SET_HEADERINFO_CHAINNOTIFICATION = 'SET_HEADERINFO_CHAINNOTIFICATION';
	var SET_HEADERINFO_ORDERS = exports.SET_HEADERINFO_ORDERS = 'SET_HEADERINFO_ORDERS';
	var SET_HEADERINFO_BOOKINGPORTALDRAFTS = exports.SET_HEADERINFO_BOOKINGPORTALDRAFTS = 'SET_HEADERINFO_BOOKINGPORTALDRAFTS';
	var SET_COLLABORATING_PARTNERS = exports.SET_COLLABORATING_PARTNERS = 'SET_COLLABORATING_PARTNERS';
	var SET_BODY_DEFAULT_LEAD_TIME = exports.SET_BODY_DEFAULT_LEAD_TIME = 'SET_BODY_DEFAULT_LEAD_TIME';
	var ALL_LANGS = exports.ALL_LANGS = [{
	  LanguageName: 'Danish',
	  SelfLangName: 'Dansk',
	  Image: '/images/svgs/menuicons/Dansk.svg',
	  LanguageCode: 'DK'
	}, {
	  LanguageName: 'English',
	  SelfLangName: 'English',
	  Image: '/images/svgs/menuicons/English.svg',
	  LanguageCode: 'EN'
	}, {
	  LanguageName: 'Swedish',
	  SelfLangName: 'Svenska',
	  Image: '/images/svgs/menuicons/Svenska.svg',
	  LanguageCode: 'S'
	}, {
	  LanguageName: 'Norwegian',
	  SelfLangName: 'Norsk',
	  Image: '/images/svgs/menuicons/Norsk.svg',
	  LanguageCode: 'NO'
	}];
	
	// Commit
	
	// File
	var SET_UPLOADS = exports.SET_UPLOADS = 'SET_UPLOADS';
	var FINISH_UPLOADS = exports.FINISH_UPLOADS = 'FINISH_UPLOADS';
	
	// Car
	var SET_CAR_ACTIVE_STATE = exports.SET_CAR_ACTIVE_STATE = 'SET_CAR_ACTIVE_STATE';
	
	// UI
	var SET_PAGE_TITLE = exports.SET_PAGE_TITLE = 'SET_PAGE_TITLE';
	var SET_PAGE_TITLE_EXTRA = exports.SET_PAGE_TITLE_EXTRA = 'SET_PAGE_TITLE_EXTRA';
	var SET_POPUPS = exports.SET_POPUPS = 'SET_POPUPS';
	var SET_HELPICON_POPUP_UPDATES = exports.SET_HELPICON_POPUP_UPDATES = 'SET_HELPICON_POPUP_UPDATES';
	var SET_OVERLAYS = exports.SET_OVERLAYS = 'SET_OVERLAYS';
	var SET_SLIDEPANELS = exports.SET_SLIDEPANELS = 'SET_SLIDEPANELS';
	
	// Spare parts
	var SET_SPARE_PARTS_ORDERING = exports.SET_SPARE_PARTS_ORDERING = 'SET_SPARE_PARTS_ORDERING';
	var SET_SPARE_PARTS_RECEPTION = exports.SET_SPARE_PARTS_RECEPTION = 'SET_SPARE_PARTS_RECEPTION';
	var SET_SPARE_PARTS_FOR_MATCHING = exports.SET_SPARE_PARTS_FOR_MATCHING = 'SET_SPARE_PARTS_FOR_MATCHING';
	
	// Embedded booking
	var SET_EMBEDDED_BOOKING_CARDATA = exports.SET_EMBEDDED_BOOKING_CARDATA = 'SET_EMBEDDED_BOOKING_CARDATA';
	var SET_EMBEDDED_BOOKING_IMAGES = exports.SET_EMBEDDED_BOOKING_IMAGES = 'SET_EMBEDDED_BOOKING_IMAGES';
	var SET_EMBEDDED_BOOKING_DAMAGE_COMMENT = exports.SET_EMBEDDED_BOOKING_DAMAGE_COMMENT = 'SET_EMBEDDED_BOOKING_DAMAGE_COMMENT';
	var SET_EMBEDDED_BOOKING_OTHERINFO = exports.SET_EMBEDDED_BOOKING_OTHERINFO = 'SET_EMBEDDED_BOOKING_OTHERINFO';
	var SET_EMBEDDED_BOOKING_CONTACTINFO = exports.SET_EMBEDDED_BOOKING_CONTACTINFO = 'SET_EMBEDDED_BOOKING_CONTACTINFO';
	var SET_EMBEDDED_BOOKING_DATA = exports.SET_EMBEDDED_BOOKING_DATA = 'SET_EMBEDDED_BOOKING_DATA';
	
	var SET_EMBEDDED_INSURANCE_COMPANIES = exports.SET_EMBEDDED_INSURANCE_COMPANIES = 'SET_EMBEDDED_INSURANCE_COMPANIES';
	var SET_EMBEDDED_CARRENTAL_ALTERNATIVES = exports.SET_EMBEDDED_CARRENTAL_ALTERNATIVES = 'SET_EMBEDDED_CARRENTAL_ALTERNATIVES';
	
	// Overview
	var SET_DELIVERY_STATUS = exports.SET_DELIVERY_STATUS = 'SET_DELIVERY_STATUS';
	var SET_PICKUP_STATUS = exports.SET_PICKUP_STATUS = 'SET_PICKUP_STATU';
	var SET_PRODUCTION_STATUS = exports.SET_PRODUCTION_STATUS = 'SET_PRODUCTION_STATUS ';

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Collection of icons that are part of the element components. (directly related to the general UI components)
	 *
	 * REMEMBER: Icon file paths/filenames are case sensitive once deployed! So make sure the casing matches exactly!
	 *
	 */
	var ElementIcons = exports.ElementIcons = {
	  // Radio element
	  Radio_Normal: { fileName: '/images/elements/radio/radio-normal.svg', xOffset: 0, yOffset: 0 },
	  Radio_Selected: { fileName: '/images/elements/radio/radio-selected.svg', xOffset: 0, yOffset: 0 },
	  Radio_Hover: { fileName: '/images/elements/radio/radio-hover.svg', xOffset: 0, yOffset: 0 },
	  Radio_Disabled: { fileName: '/images/elements/radio/radio-disabled.svg', xOffset: 0, yOffset: 0 },
	  Radio_SelectedDisabled: { fileName: '/images/elements/radio/radio-selected-disabled.svg', xOffset: 0, yOffset: 0 },
	
	  // Check element
	  Check_Normal: { fileName: '/images/elements/check/checkbox-normal.svg', xOffset: 0, yOffset: 0 },
	  Check_Selected: { fileName: '/images/elements/check/checkbox-selected.svg', xOffset: 0, yOffset: 0 },
	  Check_Selected_Check: { fileName: '/images/elements/check/icon-checked.svg', xOffset: 6, yOffset: 0, width: 12, height: 12 },
	  Check_Hover: { fileName: '/images/elements/check/checkbox-hover.svg', xOffset: 0, yOffset: 0 },
	  Check_Disabled: { fileName: '/images/elements/check/checkbox-disabled.svg', xOffset: 0, yOffset: 0 },
	  Check_SelectedDisabled: { fileName: '/images/elements/check/checkbox-selected-disabled.svg', xOffset: 0, yOffset: 0 },
	  Check_IndeterminateSelected: { fileName: '/images/elements/check/checkbox-indeterminate-selected.svg', xOffset: 0, yOffset: 0 },
	  Check_IndeterminateDisabled: { fileName: '/images/elements/check/checkbox-indeterminate-disabled.svg', xOffset: 0, yOffset: 0 },
	
	  // Switch element
	  Switch_Off: { fileName: '/images/elements/switch/switch-off.svg' },
	  Switch_On: { fileName: '/images/elements/switch/switch-on.svg' },
	
	  // Text element
	  Text_Success: { fileName: '/images/elements/text/text-success.svg' },
	
	  // ----------------------------------------------------
	  // The icons below here should be moved to other Icon object. This object should contain icons only directly used by elements.
	  // Inspection check & cancel
	  Inspection_Check: { fileName: '/images/icons/Green_chekmark.png', width: 16, height: 16, yOffset: 4 },
	  Inspection_Cancel: { fileName: '/images/icons/Red_marking.png', width: 16, height: 16, yOffset: 4 },
	
	  // Misc
	  Indent: { fileName: '/images/svgs/Indent.svg' },
	
	  Hide: { fileName: '/images/svgs/eye-hide.svg' },
	  Show: { fileName: '/images/svgs/eye-show.svg' },
	  Edit: { fileName: '/images/icons/edit_16.png', width: 16, height: 16 },
	  Info: { fileName: '/images/elements/misc/Info.svg' },
	  Chevron_Right: { fileName: '/images/elements/misc/Chevron-Right.svg' },
	  Drag_Icon: { fileName: '/images/svgs/action-swipe-dot.svg' },
	  Log_Icon: { fileName: '/images/svgs/log.svg' },
	  Delete: { fileName: '/images/icons/Delete.png' },
	  Infinity: { fileName: '/images/svgs/infinity.svg' },
	  Info_Circle: { fileName: '/images/svgs/Cirkle_info-black.svg' },
	  Customer: { fileName: '/images/icons/Customer_16.png' },
	  Files: { fileName: '/images/svgs/workscreen/add-files.svg' },
	  Close: { fileName: '/images/icons/close_24-Black.png' },
	  Add_Circle: { fileName: '/images/icons/circle_plus22.png' },
	  Add_Circle_Black: { fileName: '/images/icons/circle_plus22-black.png' },
	  Plus_White: { fileName: '/images/icons/Plus-White.png' },
	  Minus_White: { fileName: '/images/icons/Minus-White_16px.png' },
	  Arrow_Left_White: { fileName: '/images/svgs/Arrow-left-white.svg' },
	  Arrow_Right_White: { fileName: '/images/svgs/Arrow-right-white.svg' },
	  Arrow_Left_Gray: { fileName: '/images/svgs/ordrer/arrow-left-gray.svg' },
	  Arrow_Left_Lightgray: { fileName: '/images/svgs/ordrer/arrow-left-lightgray.svg' },
	  Arrow_Right_Gray: { fileName: '/images/svgs/ordrer/arrow-right-gray.svg' },
	  Arrow_Right_Lightgray: { fileName: '/images/svgs/ordrer/arrow-right-lightgray.svg' },
	  Menu_Dots_Black: { fileName: '/images/svgs/menuicons/Menu_dots-Black.svg' },
	  Go_Back_Black: { fileName: '/images/svgs/go-back.svg' },
	
	  // Search state
	  Include: { fileName: '/images/icons/Include_in_search22.png' },
	  Empty: { fileName: '/images/icons/Empty_22.png' },
	  Filled_In: { fileName: '/images/icons/Filled_in_22.png' },
	  Exclude: { fileName: '/images/icons/Exclude_from_search_22.png' },
	
	  // Price calculation
	  Workflow: { fileName: '/images/svgs/pricecalculation/workflow.svg' },
	  Spare_Parts: { fileName: '/images/svgs/pricecalculation/spare-parts.svg' },
	
	  Warning: { fileName: '/images/svgs/capacitymanagement/warning-red.svg' }
	};
	
	var GeneralIcons = exports.GeneralIcons = {
	  Apromas_Logo: { fileName: '/images/svgs/apromas-logo.svg' },
	  Qars_Logo: { fileName: '/images/Q-grey.svg' },
	  BadgeOverlay_Circle_White: { fileName: '/images/svgs/taksering/badge-overlay-circle-white.svg' },
	  Info_Circle_Grey: { fileName: '/images/icons/Cirkle_info-grey25x25px.png' },
	  Print: { fileName: '/images/svgs/Print.svg' },
	  Arrow_Left_Blue: { fileName: '/images/svgs/arrow-left-blue.svg' },
	  Arrow_Right_Blue: { fileName: '/images/svgs/arrow-right-blue.svg' }
	};
	
	var FileIcons = exports.FileIcons = {
	  Download_Black: { fileName: '/images/svgs/download.svg' }
	
	  // Localization - put flags and related symbols here.
	};var Localization = exports.Localization = {
	  EU_Star: { fileName: '/images/svgs/localization/eu-stars.svg' }
	
	  // TODO: Merge StepIcons into FilterIcons
	};var FilterIcons = exports.FilterIcons = {
	  Magnifier_Black: { fileName: '/images/svgs/Search-black.svg' }
	};
	
	var StepIcons = exports.StepIcons = {
	  Bodyshop_Coating: { fileName: '/images/svgs/bodyshop-steps/Coating-blue.svg' },
	  Bodyshop_Bodywork: { fileName: '/images/svgs/bodyshop-steps/bodywork-2-blue.svg' }
	};
	
	var CarIcons = exports.CarIcons = {
	  Small: { fileName: '/images/icons/car/car-icon_S.png' },
	  Medium: { fileName: '/images/icons/car/car-icon_M.png' },
	  Large: { fileName: '/images/icons/car/car-icon_L.png' }
	
	  // Find better name for this icon-set (stuff related to employee vs. order type actions).
	};var AssignmentIcons = exports.AssignmentIcons = {
	  Assign_Employee_Black: { fileName: '/images/icons/Assign-Black.png' },
	  Warning: { fileName: '/images/svgs/capacitymanagement/warning-red.svg' }
	
	  /**
	   * Icons for commonly used buttons. (don't add buttons here for specialized purposes)
	   */
	};var ButtonIcons = exports.ButtonIcons = {
	  Add_Plus_16: { fileName: '/images/elements/buttons/add-plus-black-16.svg', xOffset: -1, yOffset: -1 },
	  Add_Plus_Link_16: { fileName: '/images/elements/buttons/add-plus-blue-16.svg', xOffset: -1, yOffset: -1 },
	  Remove_Minus_Alert_16: { fileName: '/images/elements/buttons/remove-minus-red-16.svg', xOffset: -1, yOffset: -1 },
	  Remove_Bin_Alert_16: { fileName: '/images/elements/buttons/remove-bin-red-16.svg', xOffset: -1, yOffset: -1 },
	  Arrow_Link_16: { fileName: '/images/elements/buttons/arrow-blue-16.svg', xOffset: -1, yOffset: -1 },
	
	  Add_Plus_20: { fileName: '/images/elements/buttons/add-plus-black-20.svg', xOffset: -1, yOffset: -1 },
	  Add_Plus_Link_20: { fileName: '/images/elements/buttons/add-plus-blue-20.svg', xOffset: -1, yOffset: -1 },
	  Remove_Minus_Alert_20: { fileName: '/images/elements/buttons/remove-minus-red-20.svg', xOffset: -1, yOffset: -1 },
	  Remove_Bin_Alert_20: { fileName: '/images/elements/buttons/remove-bin-red-20.svg', xOffset: -1, yOffset: -1 },
	  Arrow_Link_20: { fileName: '/images/elements/buttons/arrow-blue-20.svg', xOffset: -1, yOffset: -1 },
	
	  Add_Plus_24: { fileName: '/images/elements/buttons/add-plus-black-24.svg', xOffset: -1, yOffset: -1 },
	  Add_Plus_Link_24: { fileName: '/images/elements/buttons/add-plus-blue-24.svg', xOffset: -1, yOffset: -1 },
	  Remove_Minus_Alert_24: { fileName: '/images/elements/buttons/remove-minus-red-24.svg', xOffset: -1, yOffset: -1 },
	  Remove_Bin_Alert_24: { fileName: '/images/elements/buttons/remove-bin-red-24.svg', xOffset: -1, yOffset: -1 },
	  Arrow_Link_24: { fileName: '/images/elements/buttons/arrow-blue-24.svg', xOffset: -1, yOffset: -1 }
	};
	
	var NumPadIcons = exports.NumPadIcons = {
	  Delete_Red: { fileName: '/images/elements/buttons/delete-red.svg' }
	
	  /**
	   * Icons representing order steps
	   */
	};var OrderStepIcons = exports.OrderStepIcons = {
	  Quality_Check_New: { fileName: '/images/icons/step_icons/Neworder-Black_16px.png', height: 16 },
	  Quality_Check_Pretreatment: { fileName: '/images/icons/step_icons/Pretretment-Black_16px.png', height: 16 },
	  Quality_Check_Filler: { fileName: '/images/icons/step_icons/Filer-Black_16px.png', height: 16 },
	  Quality_Check_Sanding: { fileName: '/images/icons/step_icons/Sanding-Black_16px.png', height: 16 },
	  Quality_Check_Coating: { fileName: '/images/icons/step_icons/coating-Black_16px.png', height: 16 },
	  Quality_Check_Preparing: { fileName: '/images/icons/step_icons/Preparing-black.png', height: 16 },
	  Quality_Check_Handover: { fileName: '/images/icons/step_icons/Handsover-Black_16px.png', height: 16 }
	};
	
	var QualityCheckIcons = exports.QualityCheckIcons = {
	  Quality_Check_New: { fileName: '/images/svgs/workscreen/neworder.svg' },
	  Quality_Check_Disassembly: { fileName: '/images/svgs/workscreen/demount.svg' },
	  Quality_Check_Repair: { fileName: '/images/svgs/workscreen/reparation.svg' },
	  Quality_Check_Pretreatment: { fileName: '/images/svgs/workscreen/pretreatment.svg' },
	  Quality_Check_Filler: { fileName: '/images/svgs/workscreen/filler.svg' },
	  Quality_Check_Sanding: { fileName: '/images/svgs/workscreen/sanding.svg' },
	  Quality_Check_Coating: { fileName: '/images/svgs/workscreen/coating.svg' },
	  Quality_Check_Preparing: { fileName: '/images/svgs/workscreen/preparing.svg' },
	  Quality_Check_Assembly: { fileName: '/images/svgs/workscreen/mount.svg' },
	  Quality_Check_Preparing_Body: { fileName: '/images/svgs/workscreen/clean.svg' },
	  Quality_Check_Handover: { fileName: '/images/svgs/workscreen/delivered.svg' },
	  Quality_Check_Finished: { fileName: '/images/svgs/inspection/price.svg' }
	};
	
	var OrderTypeIcons = exports.OrderTypeIcons = {
	  Insurance_Black: { fileName: '/images/svgs/ordrer/Insurance-black.svg' },
	  Insurance_White: { fileName: '/images/svgs/ordrer/Insurance-white.svg' },
	  Salescar_Black: { fileName: '/images/svgs/ordrer/Salescar-black.svg' },
	  Salescar_White: { fileName: '/images/svgs/ordrer/Salescar-white.svg' },
	  Garanteed_Black: { fileName: '/images/svgs/ordrer/Garanteed-black.svg' },
	  Garanteed_White: { fileName: '/images/svgs/ordrer/Garanteed-white.svg' },
	  Complaint_Black: { fileName: '/images/svgs/ordrer/Complaint-black.svg' },
	  Complaint_White: { fileName: '/images/svgs/ordrer/Complaint-white.svg' },
	  Private_Black: { fileName: '/images/svgs/ordrer/Private_c-black.svg' },
	  Private_White: { fileName: '/images/svgs/ordrer/Private_c-white.svg' },
	  Other_Black: { fileName: '/images/svgs/ordrer/Other-black.svg' },
	  Other_White: { fileName: '/images/svgs/ordrer/Other-white.svg' }
	};
	
	var TransportTypeIcons = exports.TransportTypeIcons = {
	  Can_Drive: { fileName: '/images/icons/can_drive16.png' },
	  Loose_Part: { fileName: '/images/svgs/transport/loose part-black.svg' },
	  Transport: { fileName: '/images/icons/transport16.png' }
	};
	
	var InvoiceIcons = exports.InvoiceIcons = {
	  Sent_To_Invoice: { fileName: '/images/svgs/invoice/posted-not-billed.svg', width: 24, height: 24 },
	  Marked_As_Invoice: { fileName: '/images/svgs/invoice/billed-not-posted.svg', width: 24, height: 24 },
	  Sent_And_Marked: { fileName: '/images/svgs/invoice/Payment-ok-VS.svg', width: 24, height: 24 },
	  Invoice_Reset_Approved: { fileName: '/images/svgs/invoice/approved-for-invoicing_reset.svg' },
	  Invoice_Reset: { fileName: '/images/svgs/invoice/reset-invoising.svg' },
	  Total_Price: { fileName: '/images/svgs/invoice/Total_price.svg' },
	  Ready_Invoice: { fileName: '/images/svgs/invoice/ready-for-invoice.svg' },
	  Invoiced: { fileName: '/images/svgs/invoice/Payment-ok.svg' }
	
	};
	
	var OrderDepartmentIcons = exports.OrderDepartmentIcons = {
	  Body: { fileName: '/images/svgs/workscreen/bodywork.svg' },
	  Paint: { fileName: '/images/svgs/workscreen/coating.svg' }
	};
	
	var HeaderIcons = exports.HeaderIcons = {
	  Estimation_Request_White: { fileName: '/images/svgs/header-icons/additional-support-added-all-white.svg' },
	  Payment_Notification_White: { fileName: '/images/svgs/header-icons/Payment-notification-all-white.svg' },
	  Forsi_Not_Active_White: { fileName: '/images/svgs/header-icons/FORSI-not-active-all-white.svg' },
	  Update_With_Circle_White: { fileName: '/images/svgs/header-icons/Update-VS-white-circle.svg' },
	  Message_With_Circle_White: { fileName: '/images/svgs/header-icons/Message-circle-all-white.svg' },
	  Task_With_Circle_White: { fileName: '/images/svgs/header-icons/Task-circle-white.svg' },
	  Update_White: { fileName: '/images/svgs/header-icons/Update-VS-white.svg' },
	  Order_With_Circle_White: { fileName: '/images/svgs/header-icons/my-orders-white.svg' },
	  BookingRequest_White: { fileName: '/images/svgs/header-icons/car-owner-booking-request-white.svg' }
	};
	
	var OrderAssessmentIcons = exports.OrderAssessmentIcons = {
	  Extent: { fileName: '/images/svgs/taksering/Charging-Black.svg' },
	  Invoice_Awaiting: { fileName: '/images/svgs/invoicelog/price-change-sent_black.svg' },
	  Invoice_Approved_Rejected: { fileName: '/images/svgs/invoicelog/price-change-approved_black.svg' },
	  Main_Report: { fileName: '/images/svgs/invoicelog/main-report-received.svg' },
	  Main_Report_White: { fileName: '/images/svgs/invoicelog/main-report-received-white.svg' },
	
	  Charged_Later_Recieved: { fileName: '/images/svgs/taksering/charged-later-recieved.svg' },
	  Charged_Later_Sent: { fileName: '/images/svgs/taksering/charged-later-sent.svg' },
	  Update_Approved: { fileName: '/images/svgs/taksering/update-approved.svg' },
	  Main_Report_Update_Not_Approved: { fileName: '/images/svgs/taksering/update-not-approved.svg' },
	  Main_Report_Loaded: { fileName: '/images/svgs/taksering/main-report-loaded.svg' },
	  Main_Report_Approved: { fileName: '/images/svgs/taksering/main-report-approved.svg' },
	  Main_Report_Not_Approved: { fileName: '/images/svgs/taksering/main-report-not-approved.svg' },
	
	  Additional_Report: { fileName: '/images/svgs/invoicelog/additional-report-received.svg' },
	  After_Evaluation: { fileName: '/images/svgs/invoicelog/afterevaluation-sent.svg' },
	  Addon_Price: { fileName: '/images/svgs/taksering/Additional-sales-VS.svg' },
	  Estimation_Request: { fileName: '/images/svgs/taksering/additional-support_VS.svg' },
	  Estimation_Request_White: { fileName: '/images/svgs/taksering/additional-support_VS-white.svg' },
	  Estimation: { fileName: '/images/svgs/taksering/additional-support-added.svg' },
	  Estimation_Complete: { fileName: '/images/svgs/taksering/damage-assessment.svg' },
	  Workcard: { fileName: '/images/svgs/taksering/work-card.svg' },
	  Assesment_History: { fileName: '/images/svgs/invoicelog/assesment-history.svg' },
	  Ready_Invoice: { fileName: '/images/svgs/invoicelog/ready-for-invoice.svg' },
	  Sent_To_Invoice: { fileName: '/images/svgs/invoice/posted-not-billed.svg' },
	  Invoiced: { fileName: '/images/svgs/invoice/Payment-ok.svg' },
	  Crediting: { fileName: '/images/svgs/invoicelog/crediting.svg' },
	  Credit_Note: { fileName: '/images/svgs/invoicelog/credit-note.svg' },
	  Invoice: { fileName: '/images/svgs/invoicelog/invoice.svg' },
	  Addon: { fileName: '/images/svgs/invoicelog/additional-sales-new.svg' },
	  Total_Price: { fileName: '/images/svgs/invoice/Total_price.svg' },
	  Payment_Notif: { fileName: '/images/svgs/invoicelog/payment-notification.svg' },
	  ForsiNotActive_White: { fileName: '/images/svgs/FORSI-not-active-white.svg' }
	};
	
	var ClockIcons = exports.ClockIcons = {
	  Punch_In: { fileName: '/images/icons/Punch-clock-in-Black.png' },
	  Punch_Out: { fileName: '/images/icons/Punch-clock-out-Black.png' },
	  Punch_Out_Red: { fileName: '/images/icons/Punch-clock-out-Red.png' }
	};
	
	var EvaluationHistoryIcons = exports.EvaluationHistoryIcons = {
	  Invoice_Add: { fileName: '/images/svgs/taksering/add-to-invoice.svg' },
	  Deviation: { fileName: '/images/icons/Internal-Deviation.png' },
	  Comment: { fileName: '/images/svgs/comment/comment-new.svg' },
	  Order_Data: { fileName: '/images/svgs/ordrer/Car-info-VS.svg' }
	};
	
	var MyPageIcons = exports.MyPageIcons = {
	  My_Messages: { fileName: '/images/svgs/menuicons/Messages-Black.svg' },
	  My_Orders: { fileName: '/images/svgs/Orders-black.svg' },
	  My_Tasks: { fileName: '/images/svgs/menuicons/Task-Black.svg' }
	};
	
	var MassInvoiceIcons = exports.MassInvoiceIcons = {
	  Reg_No: { fileName: '/images/svgs/invoice/reg-no.svg' },
	  Type_Model: { fileName: '/images/svgs/invoice/Type-model.svg' },
	  Customer: { fileName: '/images/svgs/invoice/Customer.svg' },
	  Handsover: { fileName: '/images/svgs/listheader/Handsover-New.svg' },
	  Total_price: { fileName: '/images/svgs/invoice/Total_price.svg' }
	};
	
	var ColorIcons = exports.ColorIcons = {
	  Color_Name: { fileName: '/images/svgs/color/Color.svg' },
	  Color_Code: { fileName: '/images/svgs/color/Color_code.svg' },
	  Color_Variant: { fileName: '/images/svgs/color/color-variation.svg' },
	  Color_Amount: { fileName: '/images/svgs/color/Color_amount-VS.svg' },
	  Color_Ready: { fileName: '/images/svgs/color/Color-ok.svg' }
	};
	
	var ProductionStatus = exports.ProductionStatus = {
	  Step_New: { fileName: '/images/svgs/workscreen/neworder.svg' },
	  Step_BodyShopDisassemply: { fileName: '/images/svgs/workscreen/demount.svg' },
	  Step_BodyShopRepair: { fileName: '/images/svgs/workscreen/reparation.svg' },
	  Step_Preparing: { fileName: '/images/svgs/workscreen/clean.svg' },
	  Step_Filler: { fileName: '/images/svgs/workscreen/filler.svg' },
	  Step_Archived: { fileName: '/images/svgs/inspection/price.svg' },
	  Step_Painting: { fileName: '/images/svgs/workscreen/coating.svg' },
	  Step_Finishing: { fileName: '/images/svgs/workscreen/preparing.svg' },
	  Step_BodyShopAssembly: { fileName: '/images/svgs/workscreen/mount.svg' },
	  Step_BodyShopFinishing: { fileName: '/images/svgs/workscreen/clean.svg' },
	  Step_Handover: { fileName: '/images/svgs/workscreen/delivered.svg' },
	  Step_Finished: { fileName: '/images/svgs/taksering/main-report-loaded.svg' },
	  Step_Completed: { fileName: '/images/svgs/workscreen/Completed-Black.svg' },
	  Step_Expected: { fileName: '/images/svgs/workscreen/neworder.svg' }
	};
	
	var AssignmentStepStatus = exports.AssignmentStepStatus = {
	  // 1
	  Step_New_Black: { fileName: '/images/svgs/steps/neworder_black.svg' },
	  Step_New_Red: { fileName: '/images/svgs/steps/neworder_red.svg' },
	  Step_New_White: { fileName: '/images/svgs/steps/neworder_white.svg' },
	
	  // 101
	  Step_BodyShopDisassemply_Black: { fileName: '/images/svgs/steps/demount_black.svg' },
	  Step_BodyShopDisassemply_White: { fileName: '/images/svgs/steps/demount_white.svg' },
	  Step_BodyShopDisassemply_Red: { fileName: '/images/svgs/steps/demount_red.svg' },
	
	  // 102
	  Step_BodyShopRepair_Black: { fileName: '/images/svgs/steps/reparation_black.svg' },
	  Step_BodyShopRepair_White: { fileName: '/images/svgs/steps/reparation_white.svg' },
	  Step_BodyShopRepair_Red: { fileName: '/images/svgs/steps/reparation_red.svg' },
	
	  // 2
	  Step_Preparing_Black: { fileName: '/images/svgs/steps/pretreatment_black.svg' },
	  Step_Preparing_White: { fileName: '/images/svgs/steps/pretreatment_white.svg' },
	  Step_Preparing_Red: { fileName: '/images/svgs/steps/pretreatment_red.svg' },
	
	  // 3
	  Step_Filling_Black: { fileName: '/images/svgs/steps/filler_black.svg' },
	  Step_Filling_White: { fileName: '/images/svgs/steps/filler_white.svg' },
	  Step_Filling_Red: { fileName: '/images/svgs/steps/filler_red.svg' },
	
	  // 4
	  Step_Sanding_Black: { fileName: '/images/svgs/steps/sanding_black.svg' },
	  Step_Sanding_White: { fileName: '/images/svgs/steps/sanding_white.svg' },
	  Step_Sanding_Red: { fileName: '/images/svgs/steps/sanding_red.svg' },
	
	  // 5
	  Step_Painting_Black: { fileName: '/images/svgs/steps/coating_black.svg' },
	  Step_Painting_White: { fileName: '/images/svgs/steps/coating_white.svg' },
	  Step_Painting_Red: { fileName: '/images/svgs/steps/coating_red.svg' },
	
	  // 6
	  Step_Finishing_Black: { fileName: '/images/svgs/steps/preparing_black.svg' },
	  Step_Finishing_White: { fileName: '/images/svgs/steps/preparing_white.svg' },
	  Step_Finishing_Red: { fileName: '/images/svgs/steps/preparing_red.svg' },
	
	  // 103
	  Step_BodyShopAssembly_Black: { fileName: '/images/svgs/steps/mount_black.svg' },
	  Step_BodyShopAssembly_White: { fileName: '/images/svgs/steps/mount_white.svg' },
	  Step_BodyShopAssembly_Red: { fileName: '/images/svgs/steps/mount_red.svg' },
	
	  // 104
	  Step_BodyShopFinishing_Black: { fileName: '/images/svgs/steps/clean_black.svg' },
	  Step_BodyShopFinishing_White: { fileName: '/images/svgs/steps/clean_white.svg' },
	  Step_BodyShopFinishing_Red: { fileName: '/images/svgs/steps/clean_red.svg' },
	
	  // 105
	  Step_BodyShopPainting_Black: { fileName: '/images/svgs/steps/coating_black.svg' },
	  Step_BodyShopPainting_White: { fileName: '/images/svgs/steps/coating_white.svg' },
	  Step_BodyShopPainting_Red: { fileName: '/images/svgs/steps/coating_red.svg' }
	};
	
	var MainMenuIcons = exports.MainMenuIcons = {
	  /* Adresses_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Addresses.svg' },
	  Adresses_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Addresses.svg' },
	  CarRental_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Rentals.svg' },
	  CarRental_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Rentals.svg' },
	  Chain_Black: { fileName: '/images/svgs/header-icons/Workscreen-black.svg' },
	  Chain_White: { fileName: '/images/svgs/header-icons/Workscreen-White.svg' },
	  Customers_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Clients.svg' },
	  Customers_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Clients.svg' },
	  Employees_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Employees.svg' },
	  Employees_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Employees.svg' },
	  Forsi_Black: { fileName: '/images/icons/menu/Forsi-Black30x30px.png' },
	  Forsi_White: { fileName: '/images/icons/menu/Forsi-White30x30px.png' },
	  HourReport_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Time-Report.svg' },
	  HourReport_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Time-Report.svg' },
	  Insurance_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Insurance-Companies.svg' },
	  Insurance_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Insurance-Companies.svg' },
	  Messages_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Messages.svg' },
	  Messages_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Messages.svg' },
	  OrderList_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Orders.svg' },
	  OrderList_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Orders.svg' },
	  Partners_Black: { fileName: '/images/icons/menu/Partners-Black.png' },
	  Partners_White: { fileName: '/images/icons/menu/Partners-White.png' },
	  PriceLists_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Price-Lists.svg' },
	  PriceLists_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Price-Lists.svg' },
	  PunchClock_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Punch-Clock.svg' },
	  PunchClock_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Punch-Clock.svg' },
	  QualityCheck_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Quality-Assurance.svg' },
	  QualityCheck_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Quality-Assurance.svg' },
	  Settings_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Settings.svg' },
	  Settings_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Settings.svg' },
	  // Subcontractors_Black: { fileName: '/images/icons/menu/reseller.svg' }
	  Shops_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Clients.svg' },
	  Shops_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Clients.svg' },
	  Statistics_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Statistics.svg' },
	  Statistics_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Statistics.svg' },
	  Tasks_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Tasks.svg' },
	  Tasks_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Tasks.svg' },
	  WorkScreen_Black: { fileName: '/images/svgs/header-icons/Workscreen-black.svg' },
	  WorkScreen_White: { fileName: '/images/svgs/header-icons/Workscreen-White.svg' } */
	
	  Adresses_Black: { fileName: '/images/svgs/menuicons/Other-adress-black.svg' },
	  Adresses_White: { fileName: '/images/svgs/header-icons/Other-adress-white.svg' },
	  Chain_Black: { fileName: '/images/svgs/menuicons/Workscreen-black.svg' }, // was images/icons/orderlist301.png but there is no such file??
	  Chain_White: { fileName: '/images/svgs/header-icons/Workscreen-white.svg' },
	  Shops_Black: { fileName: '/images/svgs/menuicons/Customers-Black.svg' },
	  Shops_White: { fileName: '/images/svgs/header-icons/Customers-White.svg' },
	  Partners_Black: { fileName: '/images/svgs/menuicons/Partners-Black.svg' },
	  Partners_White: { fileName: '/images/svgs/header-icons/Partners-white.svg' },
	  OrderList_Black: { fileName: '/images/svgs/menuicons/Orders-black.svg' },
	  OrderList_White: { fileName: '/images/svgs/header-icons/Orders-white.svg' },
	  WorkScreen_Black: { fileName: '/images/svgs/menuicons/Workscreen-black.svg' },
	  WorkScreen_White: { fileName: '/images/svgs/header-icons/Workscreen-white.svg' },
	  Insurance_Black: { fileName: '/images/svgs/ordrer/Insurance-black.svg' },
	  Insurance_White: { fileName: '/images/svgs/ordrer/Insurance-white.svg' },
	  Forsi_Black: { fileName: '/images/svgs/menuicons/Forsi-Black.svg' },
	  Forsi_White: { fileName: '/images/svgs/header-icons/Forsi-White.svg' },
	  PriceLists_Black: { fileName: '/images/svgs/menuicons/Prices-Black.svg' },
	  PriceLists_White: { fileName: '/images/svgs/header-icons/Prices-White.svg' },
	  QualityCheck_Black: { fileName: '/images/svgs/menuicons/qualitycontrol-black.svg' },
	  QualityCheck_White: { fileName: '/images/svgs/header-icons/qualitycontrol-white.svg' },
	  Customers_Black: { fileName: '/images/svgs/menuicons/Customers-Black.svg' },
	  Customers_White: { fileName: '/images/svgs/header-icons/Customers-White.svg' },
	  Employees_Black: { fileName: '/images/svgs/menuicons/Employees-black.svg' },
	  Employees_White: { fileName: '/images/svgs/header-icons/Employees-white.svg' },
	  PunchClock_Black: { fileName: '/images/svgs/menuicons/Punch-clock-black.svg' },
	  PunchClock_White: { fileName: '/images/svgs/header-icons/Punch-clock-white.svg' },
	  HourReport_Black: { fileName: '/images/svgs/menuicons/Timer-black.svg' },
	  HourReport_White: { fileName: '/images/svgs/header-icons/Timer-white.svg' },
	  CarRental_Black: { fileName: '/images/svgs/menuicons/lend.svg' },
	  CarRental_White: { fileName: '/images/svgs/menuicons/lend-White.svg' },
	  Statistics_Black: { fileName: '/images/svgs/menuicons/Statistics-black.svg' },
	  Statistics_White: { fileName: '/images/svgs/header-icons/Statistics-white.svg' },
	  Tasks_Black: { fileName: '/images/svgs/menuicons/Task-Black.svg' },
	  Tasks_White: { fileName: '/images/svgs/menuicons/Task-White.svg' },
	  Messages_Black: { fileName: '/images/svgs/menuicons/Messages-Black.svg' },
	  Messages_White: { fileName: '/images/svgs/header-icons/Messages-white.svg' },
	  Settings_Black: { fileName: '/images/svgs/menuicons/Settings-black.svg' },
	  Settings_White: { fileName: '/images/svgs/header-icons/Settings-white.svg' },
	  Subcontractors_Black: { fileName: '/images/icons/menu/reseller.svg' },
	  Subcontractors_White: { fileName: '/images/svgs/header-icons/reseller-white.svg' },
	  SpareParts_Black: { fileName: '/images/svgs/menuicons/spare-parts-black.svg' },
	  SpareParts_White: { fileName: '/images/svgs/header-icons/spare-parts-white.svg' },
	  CollaboratingPartners_Black: { fileName: '/images/svgs/menuicons/New-order-red-referred-black.svg' },
	  CollaboratingPartners_White: { fileName: '/images/svgs/header-icons/New-order-referred-white.svg' },
	  PasswordChange_White: { fileName: '/images/svgs/menuicons/Change_password-white.svg' }
	};
	
	var ModalIcons = exports.ModalIcons = {
	  WorkHours_Log: { fileName: '/images/svgs/log-white.svg' },
	  Stop_Order: { fileName: '/images/icons/Stop-White.png' },
	  Estimation: { fileName: '/images/icons/additional-support-white_VS.svg' },
	  Refer_Order: { fileName: '/images/icons/Referred_white30.png' },
	  Quality_Check: { fileName: '/images/icons/menu/qualitycontrol-White.png' },
	  Plus: { fileName: '/images/icons/circle_plus22.png' },
	  Camera: { fileName: '/images/icons/Camera_white.png' },
	  Note: { fileName: '/images/icons/note-white.png' },
	  Shared_Screen: { fileName: '/images/icons/shared-screen-white.svg' },
	  Forward: { fileName: '/images/icons/Forward-White.png' },
	  Backward: { fileName: '/images/icons/Backward-White.png' },
	  Mass_Invoice: { fileName: '/images/svgs/listheader/mass-invoiceing-white.svg' },
	  Total_Wreck: { fileName: '/images/icons/total-wreck-white.svg' },
	  Employees_White: { fileName: '/images/icons/menu/Employees-white-30x30.png' },
	  Link: { fileName: '/images/icons/Link-White.png' },
	  Help: { fileName: '/images/icons/Help-White.png' },
	  Payment_Notif: { fileName: '/images/icons/payment-notification_white.svg' },
	  Repport_Data: { fileName: '/images/svgs/modalicons/Repportdata-white.svg' },
	  CarRental: { fileName: '/images/svgs/menuicons/lend-White.svg' }
	};
	
	var DashboardIcons = exports.DashboardIcons = {
	  External_Link_Blue: { fileName: '/images/icons/Click-pil-16-Blue.png' },
	  Dashboard_Blue: { fileName: '/images/icons/Dashboard-30-Blue.png' },
	  Report_Data_Blue: { fileName: '/images/icons/Repportdata30-Blue.png' },
	  Arrow_Black: { fileName: '/images/svgs/statistics/Click-pil-black.svg' },
	  Arrow_White: { fileName: '/images/svgs/statistics/Click-pil-white.svg' },
	  Dashboard_Black: { fileName: '/images/svgs/statistics/Dashboard-black.svg' },
	  Dashboard_White: { fileName: '/images/svgs/statistics/Dashboard-white.svg' },
	  Report_Data_Black: { fileName: '/images/svgs/statistics/Repportdata-black.svg' },
	  Report_Data_White: { fileName: '/images/svgs/statistics/Repportdata-white.svg' }
	};
	
	var MarkImageIcons = exports.MarkImageIcons = {
	  Rotate: { fileName: '/images/svgs/actions/Rotate-picture.svg' },
	  Add_PC: { fileName: '/images/svgs/actions/Add-pc.svg' },
	  Add_Phone: { fileName: '/images/svgs/actions/Ad-selection.svg' },
	  Delete: { fileName: '/images/svgs/actions/Delete-selection.svg' },
	  Approve: { fileName: '/images/svgs/actions/Aprove-selection.svg' },
	  Close: { fileName: '/images/svgs/actions/close-side.svg' }
	};
	
	var ReferenceIcons = exports.ReferenceIcons = {
	  Referred: { fileName: '/images/icons/referred-order-white-red.svg' },
	  Referred_Approved: { fileName: 'images/svgs/referal/referred-order-green.svg' },
	  Referred_NotApproved: { fileName: '/images/icons/referred-order-white.svg' },
	  Customer: { fileName: '/images/svgs/invoice/Customer.svg' },
	  Comment: { fileName: '/images/svgs/comment/comment-new.svg' },
	  Referred_From: { fileName: 'images/svgs/referal/referred-order.svg' },
	  Extent: { fileName: 'images/svgs/inspection/assessment.svg' },
	  Info: { fileName: 'images/svgs/referal/Car-info-VS.svg' }
	};
	
	var SparePartModuleIcons = exports.SparePartModuleIcons = {
	  OK: { fileName: '/images/svgs/status/OK.svg' },
	  Warning: { fileName: '/images/svgs/status/Warning.svg' },
	  Attention: { fileName: '/images/svgs/status/Attention.svg' },
	  Coating: { fileName: '/images/svgs/steps/Coating.svg' },
	  Pickup: { fileName: '/images/svgs/ordrer/Pickup.svg' },
	  Defective: { fileName: '/images/svgs/status/Defective.svg' },
	  Incorrect: { fileName: '/images/svgs/status/Incorrect.svg' },
	  Back: { fileName: '/images/elements/buttons/Back.svg' },
	  Urgent: { fileName: '/images/svgs/ordrer/Urgent.svg' }
	};
	
	var EmbeddedBookingIcons = exports.EmbeddedBookingIcons = {
	  Camera: { fileName: '/images/svgs/embeddedbooking/kamera.svg' },
	  Arrow: { fileName: '/images/svgs/embeddedbooking/pil-steps.svg' },
	  Photo_Guide_1: { fileName: '/images/svgs/embeddedbooking/empty.svg' },
	  Photo_Guide_2: { fileName: '/images/svgs/embeddedbooking/distance.svg' },
	  Photo_Guide_3: { fileName: '/images/svgs/embeddedbooking/entirecar.svg' },
	  Photo_Guide_4: { fileName: '/images/svgs/embeddedbooking/nearby.svg' },
	  Photo_Guide_5: { fileName: '/images/svgs/embeddedbooking/closeup-straight.svg' },
	  Photo_Guide_6: { fileName: '/images/svgs/embeddedbooking/closeup-otherangles.svg' },
	  Upload_Image: { fileName: '/images/svgs/embeddedbooking/upload.svg' },
	  Left_Arrow: { fileName: '/images/svgs/embeddedbooking/leftarrow.svg' },
	  Right_Arrow: { fileName: '/images/svgs/embeddedbooking/rightarrow.svg' },
	  Edit_Pencil: { fileName: '/images/svgs/embeddedbooking/editpencil.svg' }
	};
	
	var CarRentalIcons = exports.CarRentalIcons = {
	  OK: { fileName: '/images/svgs/status/OK.svg' },
	  Warning: { fileName: '/images/svgs/status/Warning.svg' }
	};
	
	var CapacityManagementIcons = exports.CapacityManagementIcons = {
	  Loose_Part: { fileName: '/images/svgs/transport/loose part-black.svg' },
	  Job_Done: { fileName: '/images/svgs/capacitymanagement/check-green.svg' },
	  Issue: { fileName: '/images/svgs/capacitymanagement/warning-red.svg' },
	  CarRental_Black: { fileName: '/images/svgs/capacitymanagement/lend.svg' },
	  OrderList_Black: { fileName: '/images/svgs/capacitymanagement/Orders-black.svg' },
	  Chain_Black: { fileName: '/images/svgs/capacitymanagement/Workscreen-black.svg' },
	  Indent: { fileName: '/images/svgs/Indent.svg' },
	  Assign: { fileName: '/images/svgs/capacitymanagement/Assign.svg' },
	  Filter: { fileName: '/images/svgs/capacitymanagement/Filter.svg' },
	  info: { fileName: '/images/svgs/capacitymanagement/info.svg' },
	  Calendar: { fileName: '/images/svgs/capacitymanagement/calendar_24.svg' },
	  List_View: { fileName: '/images/svgs/capacitymanagement/list_view.svg' },
	
	  Completed: { fileName: '/images/svgs/capacitymanagement/Completed.svg' },
	  Warning_assign: { fileName: '/images/svgs/capacitymanagement/Warning_assign.svg' },
	  Warning_delayed: { fileName: '/images/svgs/capacitymanagement/Warning_delayed.svg' },
	  warning_painter: { fileName: '/images/svgs/capacitymanagement/warning_painter.svg' },
	  Warning_spare_part: { fileName: '/images/svgs/capacitymanagement/Warning_spare_part.svg' },
	  Warning_Order_stop: { fileName: '/images/svgs/capacitymanagement/Warning_order_stop.svg' },
	  Warning_attention_white: { fileName: '/images/svgs/capacitymanagement/Warning_attention_white.svg' },
	
	  Arrow_Down: { fileName: '/images/svgs/capacitymanagement/Arrow_Down.svg' },
	  Arrow_Right: { fileName: '/images/svgs/capacitymanagement/Arrow_Right.svg' },
	  Group_Arrow_Down: { fileName: '/images/svgs/capacitymanagement/Group-Arrow-Down.svg' },
	  Group_Arrow_Right: { fileName: '/images/svgs/capacitymanagement/Group-Arrow-Right.svg' }
	};
	
	var TimeLineIcons = exports.TimeLineIcons = {
	  Ok_Green: { fileName: '/images/svgs/capacitymanagement/check-green.svg' },
	  Exclamation_Red: { fileName: '/images/svgs/capacitymanagement/warning-red.svg' }
	};
	
	var CarOwnerPortalIcons = exports.CarOwnerPortalIcons = {
	  Message: { fileName: '/images/svgs/carownerportal/message.svg' },
	  Active: { fileName: '/images/svgs/status/OK.svg' },
	  NotSent: { fileName: '/images/svgs/status/Attention.svg' },
	  Awaiting: { fileName: '/images/svgs/carownerportal/awaiting.svg' },
	  Declined: { fileName: '/images/svgs/carownerportal/declined.svg' }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1771)();
	}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasAccess = hasAccess;
	exports.hasPermission = hasPermission;
	exports.hasPartnerSubscriptionPermission = hasPartnerSubscriptionPermission;
	exports.hasSubscriptionPermission = hasSubscriptionPermission;
	exports.hasAccessToAssign = hasAccessToAssign;
	exports.isTopOfStackChain = isTopOfStackChain;
	exports.isLoginFromShopOwner = isLoginFromShopOwner;
	exports.isLoginFromShop = isLoginFromShop;
	exports.isLoginFromChainOrSuper = isLoginFromChainOrSuper;
	exports.isLoginFromWP = isLoginFromWP;
	exports.hasDepartmentType = hasDepartmentType;
	exports.hasPaintShop = hasPaintShop;
	exports.hasBodyShop = hasBodyShop;
	exports.hasCombinedBodyPaintShop = hasCombinedBodyPaintShop;
	/**
	 * @module utils/auth
	 */
	
	function hasAccess(levels, level) {
	  if (levels.indexOf(level) !== -1) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	/**
	 * ``` ```
	 * @deprecated, Use `hasSubscriptionPermission` instead, it uses the newer subscription modules
	 */
	function hasPermission(authObject, ids, availableFree, availablePro) {
	  console.log('USING WRONG PERMISSION FUNCTION!!!, CHANGE IT!!');
	  // Object.keys(authObject.permissions.EmployeePermissions).length === 0 ||
	  if (!authObject || authObject.permissions || authObject.permissions.EmployeePermissions === undefined || typeof authObject.permissions.EmployeePermissions === 'undefined') return false;
	  if (authObject.permissions.ShopSubscriptionType === 1) {
	    if (!availableFree) return false;
	  } else {
	    if (availablePro !== undefined) {
	      if (!availablePro) return false;
	    }
	  }
	  // console.log('Check permission for id: ', id)
	
	  // Check permission array
	  var permissionIds = authObject.permissions.EmployeePermissions.map(function (v) {
	    return v.Id;
	  });
	
	  if (ids.constructor === Array) {
	    // settings only
	    // if ids is an array, it needs one true
	    var hasOnePermission = false;
	    for (var i = 0; i < ids.length; i++) {
	      if (ids[i].constructor === Array) {
	        // if ids[i] is an array, it all needs to be true
	        var allPermissions = true;
	        for (var j = 0; j < ids[i].length; j++) {
	          if (permissionIds.indexOf(ids[i][j]) === -1) {
	            allPermissions = false;
	          }
	        }
	        if (allPermissions) {
	          hasOnePermission = true;
	        }
	      } else {
	        // if ids[i] is an int
	        if (permissionIds.indexOf(ids[i]) !== -1) hasOnePermission = true;
	      }
	    }
	    return hasOnePermission;
	  } else {
	    // if ids is an int (everything else than settings)
	    if (ids !== 0 && permissionIds.indexOf(ids) === -1) return false;
	  }
	
	  return true;
	}
	
	function hasPartnerSubscriptionPermission(authObject, subscriptionValue) {
	  if (subscriptionValue === undefined || subscriptionValue === null) subscriptionValue = -10; // None as default
	  if (!authObject || !authObject.permissions) return false;
	  if (authObject.permissions.PartnerSubscriptionValue < subscriptionValue) {
	    return false;
	  }
	
	  return true;
	}
	
	function hasSubscriptionPermission(authObject, subscriptionValue, ids) {
	  if (!authObject || !authObject.permissions || authObject.permissions.EmployeePermissions === undefined || typeof authObject.permissions.EmployeePermissions === 'undefined') return false;
	  if (subscriptionValue === undefined || subscriptionValue === null) subscriptionValue = -10; // None as default
	  if (authObject.permissions.ShopSubscriptionValue < subscriptionValue) {
	    return false;
	  }
	
	  if (ids === undefined || ids === null || ids.length === 0) {
	    return true;
	  }
	
	  // Check permission array
	  var permissionIds = authObject.permissions.EmployeePermissions.map(function (v) {
	    return v.Id;
	  });
	
	  if (ids.constructor === Array) {
	    // settings only
	    // if ids is an array, it needs one true
	    var hasOnePermission = false;
	    for (var i = 0; i < ids.length; i++) {
	      if (ids[i].constructor === Array) {
	        // if ids[i] is an array, it all needs to be true
	        var allPermissions = true;
	        for (var j = 0; j < ids[i].length; j++) {
	          if (permissionIds.indexOf(ids[i][j]) === -1) {
	            allPermissions = false;
	          }
	        }
	        if (allPermissions) {
	          hasOnePermission = true;
	        }
	      } else {
	        // if ids[i] is an int
	        if (permissionIds.indexOf(ids[i]) !== -1) hasOnePermission = true;
	      }
	    }
	    return hasOnePermission;
	  } else {
	    // if ids is an int (everything else than settings)
	    if (ids !== 0 && permissionIds.indexOf(ids) === -1) return false;
	  }
	
	  return true;
	}
	
	/**
	 * Determines whether a user is within one of the chains allowed to use order assigning.
	 * @param authObject The authObject who´s user to check for.
	 * @example hasAccessToAssign(this.props.auth)
	 */
	function hasAccessToAssign(authObject) {
	  // Only allowed for QARS and AkzoNobel Norge chains - 2021-11-08
	  // return (authObject !== undefined && authObject !== null && authObject.user !== undefined && authObject.user !== null && [2, 7].includes(parseInt(authObject.user.ChainId)))
	  return true;
	}
	
	function isTopOfStackChain(inactiveUsers) {
	  if (inactiveUsers.length !== 0) {
	    if (inactiveUsers[0].UserType === 2) return true;
	  }
	  return false;
	}
	
	function isLoginFromShopOwner(inactiveUsers) {
	  var found = false;
	  inactiveUsers.map(function (val) {
	    if (val.UserType === 7 || val.UserType === 8) found = true;
	  });
	  return found;
	}
	
	function isLoginFromShop(inactiveUsers) {
	  var found = false;
	  inactiveUsers.map(function (val) {
	    if (val.UserType === 5) found = true;
	  });
	  return found;
	}
	
	function isLoginFromChainOrSuper(inactiveUsers) {
	  var found = false;
	  inactiveUsers.map(function (val) {
	    if (val.UserType === 1 || val.UserType === 2) found = true;
	  });
	  return found;
	}
	
	function isLoginFromWP(inactiveUsers) {
	  var found = false;
	  inactiveUsers.map(function (val) {
	    if (val.UserType === 6) found = true;
	  });
	  return found;
	}
	
	function hasDepartmentType(authObject, validDepartmentTypes, UserType, shopsToCheck) {
	  // if it isn't a userType that needs a specifik department, return true
	  if (shopsToCheck.indexOf(UserType) === -1) return true;
	
	  if (authObject.departmentType === undefined || typeof authObject.departmentType === 'undefined' || validDepartmentTypes === undefined) return false;
	  if (validDepartmentTypes.indexOf(authObject.departmentType) !== -1) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function hasPaintShop(authObject) {
	  if (authObject.departmentType === undefined || typeof authObject.departmentType === 'undefined') return false;
	  if (authObject.departmentType === 0 || authObject.departmentType === 2) {
	    // PaintShop and Both
	    return true;
	  }
	  return false;
	}
	
	function hasBodyShop(authObject) {
	  if (authObject.departmentType === undefined || typeof authObject.departmentType === 'undefined') return false;
	  if (authObject.departmentType === 1 || authObject.departmentType === 2) {
	    // BodyShop and Both
	    return true;
	  }
	  return false;
	}
	
	function hasCombinedBodyPaintShop(authObject) {
	  if (authObject.departmentType === undefined || typeof authObject.departmentType === 'undefined') return false;
	  if (authObject.departmentType === 2) {
	    // PaintShop and BodyShop
	    return true;
	  }
	  return false;
	}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(338);
	
	__webpack_require__(1578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux'
	
	// import Icon from '../icon'
	
	var Button = function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button(props) {
	    _classCallCheck(this, Button);
	
	    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	    _this.state = {};
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      // console.log('Button onClick triggered!', e)
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return ' size-large';
	        case 'm':
	          return ' size-medium';
	        case 's':
	          return ' size-small';
	      }
	    }
	  }, {
	    key: 'getSolidClass',
	    value: function getSolidClass() {
	      switch (this.props.style) {
	        case undefined:
	        case null:
	        case 'default':
	        case 'cta':
	        case 'primary':
	          return ' solid-cta-base-700';
	        case 'link':
	        case 'secondary':
	          return ' solid-link-base-700';
	        case 'alert':
	          return ' solid-alert-base-700';
	        case 'active':
	          return 'solid-brand-base-700';
	      }
	      return '';
	    }
	  }, {
	    key: 'getBorderClass',
	    value: function getBorderClass() {
	      if (this.props.noBorder) return '';
	      switch (this.props.style) {
	        case undefined:
	        case null:
	        case 'default':
	        case 'cta':
	        case 'primary':
	          return ' border-1-pt-cta-base-700';
	        case 'link':
	        case 'secondary':
	          return ' border-1-pt-link-700-base';
	        case 'alert':
	          return ' border-1-pt-alert-base-700';
	        case 'active':
	          return ' border-1-pt-brand-2-base-700';
	      }
	      return '';
	    }
	  }, {
	    key: 'getSpacingClass',
	    value: function getSpacingClass() {
	      switch (this.props.spacing) {
	        case undefined:
	        case null:
	        case 0:
	        case '0':
	          return '';
	      }
	      return ' pg-mb-' + this.props.spacing;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var css = 'element-button' + this.getSizeClass() + this.getBorderClass() + this.getSpacingClass();
	
	      if (this.props.round) {
	        css += ' round';
	      }
	
	      if (this.props.dimmed) {
	        css += ' dimmed';
	      }
	      switch (this.props.style) {
	        case 'default':
	        case 'cta':
	        case 'primary':
	          return css + ' cta';
	        case 'link':
	        case 'secondary':
	          return css + ' link';
	        case 'alert':
	          return css + ' alert';
	        case 'anchor':
	          return css + ' anchor';
	        case 'active':
	          return css + ' active';
	      }
	
	      return css;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var ariaClass = '';
	      if (this.props.ariaText !== null) {
	        ariaClass = ' hint--' + this.props.ariaPos;
	      }
	      var labelText = this.props.labelText;
	      if (typeof labelText === 'number') labelText = (0, _helpers.translation)(labelText);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-button' + ariaClass, 'aria-label': this.props.ariaText },
	        _react2.default.createElement(
	          'button',
	          {
	            id: this.props.id,
	            type: this.props.noSubmit ? 'button' : null // Apparently HTML <button> type default is 'submit' and not 'button' (!?)
	            , className: this.getStyle(),
	            name: this.props.name,
	            onClick: this.onClick.bind(this),
	            disabled: this.props.disabled,
	            'data-action': this.props.action,
	            'data-type': this.props.dataType,
	            autoFocus: this.props.setFocus
	          },
	          this.props.leftChildren ? this.props.children : null,
	          this.props.labelText !== null && labelText,
	          !this.props.leftChildren ? this.props.children : null
	        )
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.Component);
	
	Button.defaultProps = {
	  id: null,
	  size: 'l',
	  style: 'default',
	  round: false,
	  labelText: null,
	  onClick: null,
	  name: null,
	  disabled: false,
	  spacing: 1,
	  action: null,
	  dataType: null,
	  ariaText: null,
	  ariaPos: 'left',
	  noSubmit: false,
	  noBorder: false
	
	  // Button.contextTypes = {
	  //  router: React.PropTypes.object.isRequired
	  // }
	
	  // function mapStateToProps (state) {
	  //   return {
	  //     auth: state.auth
	  //   }
	  // }
	
	  // export default connect(mapStateToProps, {
	
	  // })(Button)
	
	};exports.default = Button;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(44);
	var core = __webpack_require__(118);
	var hide = __webpack_require__(97);
	var redefine = __webpack_require__(98);
	var ctx = __webpack_require__(110);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSvg = __webpack_require__(1958);
	
	var _reactSvg2 = _interopRequireDefault(_reactSvg);
	
	__webpack_require__(1598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders regular image or svg icons. 2 icon sources can be specified to overlay one on top of another.
	 * Supports 4 render sizes as follows:
	 * - l  - Large  (48x48)
	 * - m  - Medium (32x32)
	 * - s  - Small  (24x24)
	 * - xs - extra small (20x20)
	 * - t  - Tiny   (16x16)
	 *
	 * Look at default props for reference.
	 */
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      // console.log('Icon onClick triggered!', e)
	      if (this.props.onClick) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return ' size-large';
	        case 'm':
	          return ' size-medium';
	        case 's':
	          return ' size-small';
	        case 'xs':
	          return ' size-x-small';
	        case 't':
	          return ' size-tiny'; // (used for ex. help icon which can be 16x16)
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var css = 'element-icon' + this.getSizeClass();
	      if (this.props.onClick) {
	        css += ' clickable';
	      }
	      if (this.props.className) {
	        css += ' ' + this.props.className;
	      }
	
	      var renderIcon = function renderIcon(icon, number) {
	        if (!icon || !icon.fileName || icon.fileName === '') return null;
	        if (icon.fileName === undefined) {
	          console.error('Invalid format of icon!: ', icon, 'Expects { fileName: "..." }');
	          return null;
	        }
	        // let style = {
	        //   left: icon.xOffset,
	        //   top: icon.yOffset
	        // }
	        var iconStyle = {
	          left: icon.xOffset,
	          top: icon.yOffset
	        };
	        if (!isNaN(_this2.props.rotation) && _this2.props.rotation !== 0) {
	          iconStyle.transform = 'rotate(' + _this2.props.rotation + 'deg)';
	        }
	        // Added this only for Rental Car Overview, to overwrite with inline style when necessary
	        var style = Object.assign(iconStyle, _this2.props.style);
	
	        if (icon.width !== undefined && icon.width !== null) {
	          style.width = icon.width;
	        }
	        if (icon.height !== undefined && icon.height !== null) {
	          style.height = icon.height;
	        }
	
	        var imgCss = 'img' + number + ' ' + _this2.props.imgClassName;
	
	        // Render with click through for svg icons when no click handler is provided.
	        var clickThrough = ' click-through';
	        if (typeof _this2.props.onClick === 'function') {
	          clickThrough = '';
	        }
	
	        // Render as svg or regular img tag?
	        if (icon.fileName.endsWith('.svg') && _this2.props.injectSvg) {
	          var emptyCb = function emptyCb() {};
	          var setStyleCb = function setStyleCb(svg) {
	            svg.setAttribute('style', icon.svgStyle);
	          };
	
	          return _react2.default.createElement(
	            'div',
	            { className: imgCss + clickThrough, style: style, onClick: _this2.onClick.bind(_this2) },
	            _react2.default.createElement(_reactSvg2.default, { src: icon.fileName, beforeInjection: typeof icon.svgStyle === 'string' ? setStyleCb : emptyCb })
	          );
	        }
	        return _react2.default.createElement('img', { src: icon.fileName, className: imgCss, style: style, onClick: _this2.onClick.bind(_this2) });
	      };
	
	      var ariaClass = '';
	      if (this.props.ariaText !== null) {
	        ariaClass = ' hint--' + this.props.ariaPos;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: css + ariaClass, 'aria-label': this.props.ariaText },
	        renderIcon(this.props.icon, 1),
	        renderIcon(this.props.icon2, 2)
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.defaultProps = {
	  size: 's', // t: 16px, xs: 20px s: 24px, m: 32px, l: 48px
	  icon: { fileName: null, xOffset: 0, yOffset: 0 },
	  icon2: null, // Icon2 acts as an overlay
	  className: '', // css class for svgs
	  injectSvg: false,
	  imgClassName: '',
	  ariaText: null,
	  ariaPos: 'left',
	  rotation: 0
	  // onClick: null
	};
	
	exports.default = Icon;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1631);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import '../elements.scss'
	
	var Text = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text(props) {
	    _classCallCheck(this, Text);
	
	    var _this = _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, props));
	
	    _this.state = {
	      showHint: false
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.showIcon = true;
	    return _this;
	  }
	
	  _createClass(Text, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      // console.log('Text onChange triggered! ', e)
	      if (this.props.onChange !== null) {
	        this.showIcon = false;
	        this.props.onChange(e);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      // console.log('Text onBlur triggered! ', e)
	      if (this.props.onBlur !== null) {
	        this.showIcon = true;
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(e) {
	      // console.log('Text onFocus triggered!', e)
	      if (this.props.onFocus !== null) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      // console.log('Text onKeyDown triggered!', e)
	      if (this.props.onKeyDown !== null) {
	        this.props.onKeyDown(e);
	      }
	    }
	  }, {
	    key: 'onKeyPress',
	    value: function onKeyPress(e) {
	      // console.log('Text onKeyPress triggered!', e)
	      if (this.props.onKeyPress !== null) {
	        this.props.onKeyPress(e);
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      // console.log('Text onClick triggered!', e)
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return 'size-large';
	        case 'm':
	          return 'size-medium';
	        case 's':
	          return 'size-small';
	      }
	    }
	  }, {
	    key: 'getIconSize',
	    value: function getIconSize() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 's':
	        case 'm':
	          return 't';
	        case 'l':
	          return 's';
	      }
	    }
	  }, {
	    key: 'getIconClass',
	    value: function getIconClass() {
	      var iconClass = this.props.showValidationIcon && this.showIcon ? 'text-success' : '';
	      return iconClass;
	    }
	  }, {
	    key: 'getCustomClass',
	    value: function getCustomClass() {
	      return this.props.className;
	    }
	  }, {
	    key: 'getSolidClass',
	    value: function getSolidClass() {
	      return '';
	    }
	  }, {
	    key: 'getBorderClass',
	    value: function getBorderClass() {
	      return this.props.redBorder ? ' red-border' : '';
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-text' + this.getSolidClass() + this.getBorderClass();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderInput = function renderInput() {
	        return [_react2.default.createElement('input', {
	          ref: 'input',
	          className: _this2.getSizeClass() + _this2.getBorderClass() + ' ' + _this2.getCustomClass(),
	          type: _this2.props.isPassword ? 'password' : 'text',
	          id: _this2.props.id,
	          name: _this2.props.name,
	          value: _this2.props.value,
	          onChange: _this2.onChange.bind(_this2),
	          onBlur: _this2.onBlur.bind(_this2),
	          onFocus: _this2.onFocus.bind(_this2),
	          onKeyDown: _this2.onKeyDown.bind(_this2),
	          onKeyPress: _this2.onKeyPress.bind(_this2),
	          onClick: _this2.onClick.bind(_this2),
	          readOnly: _this2.props.readOnly,
	          required: _this2.props.required,
	          placeholder: _this2.props.placeholder,
	          disabled: _this2.props.disabled,
	          defaultValue: _this2.props.defaultValue,
	          maxLength: _this2.props.maxLength,
	          autoComplete: _this2.props.autoComplete,
	          key: 'text'
	        }), _this2.props.showValidationIcon && _this2.showIcon && _react2.default.createElement(_icon2.default, { key: 'icon', icon: _icons.ElementIcons.Text_Success, className: _this2.getIconClass(), size: _this2.getIconSize(), injectSvg: true })];
	      };
	
	      var renderWrapper = function renderWrapper(content) {
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          {
	            labelText: _this2.props.labelText,
	            hintText: _this2.props.hintText,
	            helpText: _this2.props.helpText,
	            errorText: _this2.props.errorText,
	            'for': _this2.props.id
	          },
	          content
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        !this.props.simple && this.props.labelText !== null ? renderWrapper(renderInput()) : renderInput()
	      );
	    }
	  }]);
	
	  return Text;
	}(_react.Component);
	
	Text.defaultProps = {
	  size: 'l',
	  style: 'default',
	  labelText: null,
	  hintText: null,
	  helpText: null,
	  onChange: null,
	  onKeyDown: null,
	  onKeyPress: null,
	  onBlur: null,
	  onFocus: null,
	  onClick: null,
	  readOnly: false,
	  required: false,
	  // value: '', // For defaultValue to work, this must be able to be undefined
	  placeholder: '',
	  errorText: null,
	  disabled: false,
	  maxLength: null,
	  isPassword: false,
	  autoComplete: null,
	  simple: false,
	  className: '',
	  showValidationIcon: false,
	  redBorder: false
	};
	
	exports.default = Text;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1601);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	/**
	 * Implements a component to wrap child components and displaying a label, hint and error-text around it.
	 * - Help text is shown in a small popup when user clicks the (?) icon.
	 * - Hint text is always shown unless error text is specified.
	 * - Error text is always shown if specified.
	 */
	var LabelWrapper = function (_Component) {
	  _inherits(LabelWrapper, _Component);
	
	  function LabelWrapper(props) {
	    _classCallCheck(this, LabelWrapper);
	
	    var _this = _possibleConstructorReturn(this, (LabelWrapper.__proto__ || Object.getPrototypeOf(LabelWrapper)).call(this, props));
	
	    _this.state = {
	      showHint: false,
	      showHelp: false
	    };
	    _this.toggleShowHint = _this.toggleShowHint.bind(_this);
	    return _this;
	  }
	
	  _createClass(LabelWrapper, [{
	    key: 'toggleShowHint',
	    value: function toggleShowHint() {
	      this.setState({ showHint: !this.state.showHint });
	    }
	  }, {
	    key: 'renderTop',
	    value: function renderTop() {
	      var hasLabel = this.props.labelText !== null;
	      var hasHelp = this.props.helpText !== null;
	
	      if (!hasLabel) return null;
	      var labelText = this.props.labelText;
	      var helpText = this.props.helpText;
	      if (typeof labelText === 'number') labelText = (0, _helpers.translation)(labelText);
	      if (typeof helpText === 'number') helpText = (0, _helpers.translation)(helpText);
	      return _react2.default.createElement(
	        'div',
	        { className: 'top' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: this.props.for },
	          labelText
	        ),
	        hasHelp && _react2.default.createElement(_helpIcon2.default, { helpText: helpText })
	      );
	    }
	  }, {
	    key: 'renderBottom',
	    value: function renderBottom() {
	      if (this.props.labelText === null || this.props.errorText === null && this.props.hintText === null) return null;
	
	      // Show hint or error text
	      var text = this.props.hintText !== null ? this.props.hintText : '';
	      var isError = false;
	      if (this.props.errorText !== null) {
	        text = this.props.errorText;
	        isError = true;
	      }
	      var labelCss = 'pg-ml-2 ' + (isError ? 'error' : 'hint');
	      return _react2.default.createElement(
	        'div',
	        { className: 'bottom' },
	        _react2.default.createElement(
	          'span',
	          { className: labelCss },
	          text
	        )
	      );
	    }
	  }, {
	    key: 'getSpacingClass',
	    value: function getSpacingClass() {
	      var spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing;
	      if (spacing < 1) return '';
	      return ' pg-mb-' + spacing;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var propClassNames = this.props.className ? ' ' + this.props.className : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-label-wrapper' + propClassNames + this.getSpacingClass() },
	        this.renderTop(),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          this.props.children
	        ),
	        !this.props.simple && this.renderBottom()
	      );
	    }
	  }]);
	
	  return LabelWrapper;
	}(_react.Component);
	
	LabelWrapper.defaultProps = {
	  labelText: 'Tekst mangler!',
	  for: null,
	  hintText: null,
	  helpText: null,
	  errorText: null,
	  simple: false,
	  spacing: 2,
	  className: null
	};
	
	exports.default = LabelWrapper;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1611);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux'
	
	var Panel = function (_Component) {
	  _inherits(Panel, _Component);
	
	  function Panel(props) {
	    _classCallCheck(this, Panel);
	
	    var _this = _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Panel, [{
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return 'size-large';
	        case 'm':
	          return 'size-medium';
	        case 's':
	          return 'size-small';
	      }
	    }
	  }, {
	    key: 'getTitleStyle',
	    value: function getTitleStyle() {
	      return 'title ' + this.getSizeClass();
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(actions) {
	      // if (this.props.title === null) return null
	      if (typeof this.props.title === 'function') return this.props.title();
	
	      return _react2.default.createElement(
	        _panelHeader2.default,
	        { text: this.props.title, icon: this.props.icon },
	        this.props.helpText !== null && _react2.default.createElement(_helpIcon2.default, { helpText: this.props.helpText }),
	        actions
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var actions = null;
	      var children = this.props.children;
	
	      if (children && children[0]) {
	        if (_react2.default.isValidElement(children[0]) && children[0].type.displayName === 'Actions') {
	          var _children = children,
	              _children2 = _toArray(_children),
	              cActions = _children2[0],
	              rest = _children2.slice(1);
	
	          actions = cActions;
	          children = rest;
	        }
	      }
	
	      var containerCss = 'container';
	      if (this.props.clearfix) containerCss += ' clearfix';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-panel', 'data-col': this.props.dataCol, id: this.props.id },
	        this.renderTitle(actions),
	        _react2.default.createElement(
	          'div',
	          { className: containerCss },
	          children
	        )
	      );
	    }
	  }]);
	
	  return Panel;
	}(_react.Component);
	
	Panel.defaultProps = {
	  title: null,
	  helpText: null,
	  size: 'l',
	  actions: [],
	  dataCol: null,
	  clearfix: false,
	  id: null,
	  icon: null
	};
	
	exports.default = Panel;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import variables from '../_mixins.scss'
	
	var Grid = function (_Component) {
	  _inherits(Grid, _Component);
	
	  function Grid(props) {
	    _classCallCheck(this, Grid);
	
	    // this.gridRef = null
	    // this.gridWidth = 0
	
	    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props));
	
	    _this.state = {
	      cols: []
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    // this.setRef = this.setRef.bind(this)
	    // this.handleResize = this.handleResize.bind(this)
	    // this.getGapSize = this.getGapSize.bind(this)
	    // this.updateGridSize = this.updateGridSize.bind(this)
	    return _this;
	  }
	
	  // componentDidMount () {
	  //   window.addEventListener('resize', this.handleResize, this)
	
	  //   this.updateGridSize()
	  // }
	
	  // componentWillUnmount () {
	  //   window.removeEventListener('resize', this.handleResize, this)
	  // }
	
	  // setRef (node) {
	  //   this.gridRef = node
	  // }
	
	  // handleResize () {
	  //   if (this.gridWidth !== this.gridRef.offsetWidth) {
	  //     console.log('resizing grid', this.gridWidth)
	  //     this.updateGridSize()
	  //   }
	  // }
	
	  // getGapSize () {
	  //   const { gap } = this.props
	
	  //   return parseInt(Object.values(variables)[gap - 1], 10)
	  // }
	
	  // updateGridSize () {
	  //   if (this.gridRef) {
	  //     const columns = this.props.cols
	  //     const gap = this.getGapSize()
	  //     const childrenCount = this.props.children.length === undefined ? 0 : this.props.children.length
	
	  //     this.gridWidth = this.gridRef.offsetWidth
	
	  //     let lengthDiff = 0
	  //     if (childrenCount > columns.length) {
	  //       lengthDiff = childrenCount - columns.length
	  //     }
	  //     let sum = lengthDiff
	  //     for (let i = 0; i < columns.length; i++) {
	  //       sum += columns[i]
	  //     }
	
	  //     const avgLength = this.gridWidth / sum
	
	  //     // Find the nearest on the lower side to the avgLength
	  //     // Example: if avg is 15 and variables is [8, 16, 24] it returns 8
	  //     const scales = Object.values(variables)
	  //     let colWidth = 0
	  //     for (let i = 0; i < scales.length; i++) {
	  //       const currentInt = parseInt(scales[i])
	  //       if ((currentInt + gap) < avgLength) {
	  //         colWidth = currentInt
	  //       }
	  //     }
	
	  //     console.log('VARIABLES', { sum, avgLength, colWidth, width: this.gridWidth, childrenCount, gap })
	
	  //     // let gridColumns = []
	  //     // for (let i = 0; i < columns.length; i++) {
	  //     //   gridColumns.push(columns[i] * colWidth)
	  //     // }
	  //     // if (lengthDiff > 0) {
	  //     //   // Add columns for rest of children
	  //     //   for (let i = 0; i < lengthDiff; i++) {
	  //     //     gridColumns.push(colWidth)
	  //     //   }
	  //     // }
	  //     let gridColumns = ''
	  //     for (let i = 0; i < columns.length; i++) {
	  //       gridColumns += (columns[i] * colWidth) + 'px '
	  //     }
	  //     if (lengthDiff > 0) {
	  //       // Add columns for rest of children
	  //       for (let i = 0; i < lengthDiff; i++) {
	  //         gridColumns += colWidth + 'px '
	  //       }
	  //     }
	
	  //     this.gridRef.style.gridTemplateColumns = gridColumns
	  //     this.gridRef.style.gridGap = gap + 'px'
	  //     // this.setState({
	  //     //   cols: gridColumns
	  //     // }, () => console.timeEnd('updateGridSize' + rnd))
	  //   }
	  // }
	
	  _createClass(Grid, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getChildCount',
	    value: function getChildCount(children) {
	      if (children.length === undefined) {
	        return 0;
	      }
	
	      return children.reduce(function (sum, child) {
	        if (!child) return sum;
	
	        if (Array.isArray(child)) {
	          return sum + child.length;
	        }
	
	        return sum + 1;
	      }, 0);
	    }
	  }, {
	    key: 'getGridColumns',
	    value: function getGridColumns() {
	      var _props = this.props,
	          cols = _props.cols,
	          children = _props.children;
	
	      if (typeof cols === 'string') return cols;
	
	      var childrenCount = _react2.default.Children.toArray(children).length; // this.getChildCount(children)
	
	      var columns = cols.reduce(function (prev, col) {
	        if (Array.isArray(col)) {
	          // [3, 2] => repeat(3, 2fr)
	          return {
	            length: prev.length + col[0],
	            cols: prev.cols + (' repeat(' + col[0] + ', ' + col[1] + 'fr)')
	          };
	        }
	
	        var newCol = ' ' + col + 'fr';
	        if (typeof col === 'string') {
	          newCol = ' ' + col;
	        }
	
	        return {
	          length: prev.length + 1,
	          cols: (prev.cols + newCol).trim()
	        };
	      }, { length: 0, cols: '' });
	
	      var extraColsCount = 0;
	      if (childrenCount > columns.length) {
	        extraColsCount = childrenCount - columns.length;
	      }
	
	      // const definedCols = columns.length > 0 ? columns.join('fr ') + 'fr' : ''
	      var columnUnit = this.props.evenColumns ? 'minmax(0, 1fr)' : '1fr';
	      var extraCols = extraColsCount > 0 ? ' repeat(' + extraColsCount + ', ' + columnUnit + ')' : '';
	
	      var gridTemplateColumns = columns.cols + extraCols;
	      // console.log('[GTC]', { gridTemplateColumns, cols: columns.length, children: childrenCount })
	      return gridTemplateColumns;
	    }
	  }, {
	    key: 'getGridStyle',
	    value: function getGridStyle() {
	      var _props2 = this.props,
	          justify = _props2.justify,
	          align = _props2.align;
	
	      var validValues = ['start', 'center', 'end'];
	
	      var style = '';
	      if (validValues.includes(justify)) {
	        style += ' justify-' + justify;
	      }
	      if (validValues.includes(align)) {
	        style += ' align-' + align;
	      }
	
	      return style;
	    }
	  }, {
	    key: 'getRowSpanClass',
	    value: function getRowSpanClass() {
	      if (this.props.rowSpan) {
	        return ' rs-' + this.props.rowSpan;
	      }
	
	      return '';
	    }
	  }, {
	    key: 'getSpacingClass',
	    value: function getSpacingClass() {
	      switch (this.props.spacing) {
	        case undefined:
	        case null:
	        case 0:
	          return '';
	      }
	      return ' pg-mb-' + this.props.spacing;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var extraClass = '';
	      if (this.props.className) {
	        extraClass += ' ' + this.props.className;
	      }
	      if (this.props.nogap) {
	        extraClass += ' no-grid-gap';
	      }
	
	      return 'element-grid' + this.getGridStyle() + this.getRowSpanClass() + this.getSpacingClass() + extraClass;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.children) return null;
	      // const gridStyle = {
	      //   gridTemplateColumns: this.state.cols.reduce((columnStr, col) => `${columnStr}${col}px `, ''),
	      //   gridGap: this.getGapSize()
	      // }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          // ref={this.setRef}
	          className: this.getStyle(),
	          style: { gridTemplateColumns: this.getGridColumns() },
	          onClick: this.onClick
	          // style={gridStyle}
	        },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Grid;
	}(_react.Component);
	
	Grid.defaultProps = {
	  cols: [],
	  rowSpan: null,
	  gap: 1,
	  className: '',
	  justify: null, // [ 'start', 'center', 'end' ]
	  align: null, // [ 'start', 'center', 'end' ]
	  spacing: 0,
	  onClick: null,
	  nogap: false,
	  evenColumns: false
	};
	
	exports.default = Grid;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1600);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Inline = function (_Component) {
	  _inherits(Inline, _Component);
	
	  function Inline(props) {
	    _classCallCheck(this, Inline);
	
	    var _this = _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Inline, [{
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return ' size-large';
	        case 'm':
	          return ' size-medium';
	        case 's':
	          return ' size-small';
	      }
	    }
	  }, {
	    key: 'getSpacingClass',
	    value: function getSpacingClass() {
	      var spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing;
	      if (spacing < 1) return '';
	      return ' pg-mb-' + spacing;
	    }
	  }, {
	    key: 'getAlignChildrenClass',
	    value: function getAlignChildrenClass() {
	      switch (this.props.alignChildren) {
	        case undefined:
	        case null:
	        case 'top':
	          return ' align-start';
	        case 'center':
	          return ' align-center';
	        case 'bottom':
	          return ' align-end';
	      }
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var style = 'element-inline' + this.getSpacingClass() + this.getAlignChildrenClass(); // + this.getSizeClass()
	
	      if (this.props.block) style += ' element-inline--block';
	
	      if (this.props.fullWidth) style += ' full-width';
	      return style;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var children = this.props.children;
	      if (children !== undefined && children !== null && !Array.isArray(children)) {
	        children = [children];
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        children !== undefined && children !== null && children.map(function (child, key) {
	          var style = 'inline-item';
	          if (_this2.props.fillChildNum.includes(key)) {
	            style += ' inline-item--fill';
	          }
	          if (child === false) return null;
	          return _react2.default.createElement(
	            'div',
	            { className: style, key: key },
	            child
	          );
	        })
	      );
	    }
	  }]);
	
	  return Inline;
	}(_react.Component);
	
	Inline.defaultProps = {
	  // size: 's',
	  spacing: 1, // Spacing can currently range from 0 to 8
	  block: false,
	  fillChildNum: [],
	  alignChildren: 'center', // top, center, bottom
	  fullWidth: false
	};
	
	exports.default = Inline;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.padNumber = padNumber;
	exports.formatDate = formatDate;
	exports.renderDateTimeDesc = renderDateTimeDesc;
	exports.renderDate = renderDate;
	exports.renderTime = renderTime;
	exports.renderTimeOnly = renderTimeOnly;
	exports.getDateDiff = getDateDiff;
	exports.renderDateTime = renderDateTime;
	exports.renderShortDate = renderShortDate;
	exports.renderDateDiff = renderDateDiff;
	exports.renderFullDate = renderFullDate;
	exports.setHourMin = setHourMin;
	exports.getWeekDay = getWeekDay;
	exports.getRelativeDateTime = getRelativeDateTime;
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @module utils/time
	 */
	
	function padNumber(n, width, z) {
	  z = z || '0';
	  n = n + '';
	  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	}
	
	function formatDate(date) {
	  var isNullable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if ((date === null || date === '') && isNullable) return null;
	  if (date === null || date === '') return '1990-01-01T00:00:00';
	  if (typeof date.format === 'function') {
	    return date.format('YYYY-MM-DDTHH:mm:ss');
	  }
	  return date;
	}
	
	/**
	 * Renders descriptive date and time.
	 * Ex. Monday, 10 Jan · 13.37
	 */
	function renderDateTimeDesc(dateTime) {
	  var locale = 'en';
	  var languageName = window.localStorage.getItem('user_language');
	  switch (languageName) {
	    case 'Danish':
	      locale = 'da';
	      break;
	    case 'English':
	      locale = 'en';
	      break;
	    case 'Swedish':
	      locale = 'se';
	      break;
	    case 'Norwegian':
	      locale = 'nb_NO';
	      break;
	  }
	
	  var mom = (0, _moment2.default)(dateTime).locale(locale);
	  var dayOfWeek = mom.format('dddd');
	  var day = mom.format('D');
	  var month = mom.format('MMM');
	  var hour = mom.format('k'); // "k" of all things...!
	  var min = mom.format('mm');
	  dayOfWeek = dayOfWeek.slice(0, 1).toUpperCase() + dayOfWeek.slice(1);
	  month = month.slice(0, 1).toUpperCase() + month.slice(1);
	  return dayOfWeek + ', ' + day + ' ' + month + ' \xB7 ' + hour + ':' + min;
	}
	
	function renderDate(dateTime) {
	  if (!dateTime) return null;
	  return (0, _moment2.default)(dateTime).format('DD-MM-YYYY');
	}
	
	/**
	 * @description Renders time as HH:MM DIFF
	 * @example
	 * let time = renderTime('2015-12-23T08:00:00')
	 * @param  {string|date} time String or date object
	 * @return {string} Returns formatted string
	 */
	function renderTime(time) {
	  if (time === '' || time == null) return '';
	
	  // Create window.CustomDate object
	  var d = window.CustomDate(time);
	
	  // Check if date object is valid
	  if (isNaN(d.getTime())) {
	    return '';
	  }
	
	  // Hours + pad zero
	  var hours = '' + d.getHours();
	  hours = '00'.substring(0, 2 - hours.length) + hours;
	
	  // Minutes + pad zero
	  var minutes = '' + d.getMinutes();
	  minutes = '00'.substring(0, 2 - minutes.length) + minutes;
	
	  var cdate = window.CustomDate();
	  // Month + pad zero
	  var month = '' + (cdate.getMonth() + 1);
	  month = '00'.substring(0, 2 - month.length) + month;
	
	  // Day + pad zero
	  var day = '' + cdate.getDate();
	  day = '00'.substring(0, 2 - day.length) + day;
	  var dd = cdate.getFullYear() + '-' + month + '-' + day + ' ' + '00' + ':' + '00' + ':00'; // +  '00:00:00'
	  var customDate = window.CustomDate(dd);
	
	  var ddate = window.CustomDate(d);
	  // Month + pad zero
	  var dmonth = '' + (ddate.getMonth() + 1);
	  dmonth = '00'.substring(0, 2 - dmonth.length) + dmonth;
	
	  // Day + pad zero
	  var dday = '' + ddate.getDate();
	  dday = '00'.substring(0, 2 - dday.length) + dday;
	  var ddd = ddate.getFullYear() + '-' + dmonth + '-' + dday + ' ' + '00' + ':' + '00' + ':00'; // +  '00:00:00'
	  var dcustomDate = window.CustomDate(ddd);
	
	  // Diff today and time
	  var diff = Math.floor((dcustomDate - customDate) / (1000 * 60 * 60 * 24));
	
	  // Sign
	  var sign = diff > 0 ? '+' : '';
	  if (diff === 0) {
	    sign = '';
	    diff = '';
	  }
	
	  // Return string with HOURS:MINUTES DIFF
	  return hours + ':' + minutes + ' ' + sign + '' + diff;
	}
	
	/**
	 * @description Renders time as HH:MM
	 * @example
	 * let time = renderTime('2015-12-23T08:00:00')
	 * @param  {string|date} time String or date object
	 * @return {string} Returns formatted string
	 */
	function renderTimeOnly(time) {
	  if (time === '' || time == null) return '';
	
	  // Create window.CustomDate object
	  var d = window.CustomDate(time);
	
	  // Check if date object is valid
	  if (isNaN(d.getTime())) {
	    return '';
	  }
	
	  // Hours + pad zero
	  var hours = '' + d.getHours();
	  hours = '00'.substring(0, 2 - hours.length) + hours;
	
	  // Minutes + pad zero
	  var minutes = '' + d.getMinutes();
	  minutes = '00'.substring(0, 2 - minutes.length) + minutes;
	
	  // Return string with HOURS:MINUTES DIFF
	  return hours + ':' + minutes;
	}
	
	function getDateDiff(time) {
	  if (time === '' || time == null) return '';
	
	  // Create window.CustomDate object
	  var d = window.CustomDate(time);
	
	  // Check if date object is valid
	  if (isNaN(d.getTime())) {
	    return '';
	  }
	
	  var cdate = window.CustomDate();
	  // Month + pad zero
	  var month = '' + (cdate.getMonth() + 1);
	  month = '00'.substring(0, 2 - month.length) + month;
	
	  // Day + pad zero
	  var day = '' + cdate.getDate();
	  day = '00'.substring(0, 2 - day.length) + day;
	  var dd = cdate.getFullYear() + '-' + month + '-' + day + ' ' + '00' + ':' + '00' + ':00'; // +  '00:00:00'
	  var customDate = window.CustomDate(dd);
	
	  var ddate = window.CustomDate(d);
	  // Month + pad zero
	  var dmonth = '' + (ddate.getMonth() + 1);
	  dmonth = '00'.substring(0, 2 - dmonth.length) + dmonth;
	
	  // Day + pad zero
	  var dday = '' + ddate.getDate();
	  dday = '00'.substring(0, 2 - dday.length) + dday;
	  var ddd = ddate.getFullYear() + '-' + dmonth + '-' + dday + ' ' + '00' + ':' + '00' + ':00'; // +  '00:00:00'
	  var dcustomDate = window.CustomDate(ddd);
	
	  // Diff today and time
	  var diff = Math.floor((dcustomDate - customDate) / (1000 * 60 * 60 * 24));
	
	  return diff;
	}
	
	/**
	 * @description Renders time for API
	 * @example
	 * let time = renderDateTime('15-11-2016', '00:00:59')
	 * @param  {String} time String with time
	 * @param  {String} hourminutes String with fixed hh:mm:ss
	 * @return {String} Returns formatted string
	 */
	function renderDateTime(time, hourminutes) {
	  if (time === '' || time == null) return '';
	
	  if (typeof time.format === 'function') {
	    return time.format('YYYY-MM-DD') + ' ' + hourminutes;
	  }
	
	  var nTime = time.split('-');
	  nTime = nTime[1] + '-' + nTime[0] + '-' + nTime[2];
	
	  // Create window.CustomDate object
	  var d = window.CustomDate(nTime);
	
	  // Check if date object is valid
	  if (isNaN(d.getTime())) {
	    return '';
	  }
	
	  // Month + pad zero
	  var month = '' + (d.getMonth() + 1);
	  month = '00'.substring(0, 2 - month.length) + month;
	
	  // Day + pad zero
	  var day = '' + d.getDate();
	  day = '00'.substring(0, 2 - day.length) + day;
	
	  return d.getFullYear() + '-' + month + '-' + day + ' ' + hourminutes;
	}
	/**
	 * @param {Datetime} datetime
	 * @param {boolean} weekday
	 * @param {boolean} parentheses
	 * @param {string} seperator
	 * @returns
	 */
	function renderShortDate(datetime) {
	  var weekday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var parentheses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var seperator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' • ';
	
	  var date = (0, _moment2.default)(datetime);
	
	  if (!date.isValid()) {
	    return false;
	  }
	
	  var shortdate = date.format('DD-MM [' + seperator + '] HH:mm');
	
	  // With weekday?
	  shortdate = weekday ? getWeekDay(datetime, true) + ' ' + shortdate : shortdate;
	
	  // Enclose in parentheses?
	  shortdate = parentheses ? '(' + shortdate + ')' : shortdate;
	
	  return shortdate;
	}
	
	function renderDateDiff(datetime, relativeToDatetime) {
	  var date = (0, _moment2.default)(datetime);
	  var relativeTodate = (0, _moment2.default)(relativeToDatetime);
	
	  if (!date.isValid() || !relativeTodate.isValid()) {
	    return false;
	  }
	
	  // How many days ahead/behind
	  return date.diff(relativeTodate, 'days');
	}
	
	/**
	 * @description Renders time as dd-mm-YYYY H:i
	 * @example
	 * let time = renderFullDate('2015-12-23T08:00:00')
	 * @param  {string|date} time String or date object
	 * @return {string} Returns formatted string
	 */
	function renderFullDate(time, includeTime, onlyTime) {
	  if (time === '' || time == null) return '';
	
	  // Create window.CustomDate object
	  var d = window.CustomDate(time);
	
	  // Check if date object is valid
	  if (isNaN(d.getTime())) {
	    return '';
	  }
	
	  // Day + pad zero
	  var day = '' + d.getDate();
	  day = '00'.substring(0, 2 - day.length) + day;
	
	  // Month + pad zero
	  var month = '' + (d.getMonth() + 1);
	  month = '00'.substring(0, 2 - month.length) + month;
	
	  // Hours + pad zero
	  var hours = '' + d.getHours();
	  hours = '00'.substring(0, 2 - hours.length) + hours;
	
	  // Minutes + pad zero
	  var minutes = '' + d.getMinutes();
	  minutes = '00'.substring(0, 2 - minutes.length) + minutes;
	
	  var hoursAndMinutes = ' - ' + hours + ':' + minutes;
	  if (typeof includeTime !== 'undefined') {
	    if (!includeTime) {
	      hoursAndMinutes = '';
	    }
	  }
	  if (typeof onlyTime !== 'undefined') {
	    return hoursAndMinutes.replace(' - ', '');
	  }
	
	  // Return string
	  // console.log('Render date: ', d, ' as ', d.getUTCFullYear(), d.getFullYear())
	  // seems utcfullyear returns wrong year if date is ex. 01-01-2018 (gives 01-01-2017) Switched to getFullYear
	  return day + '-' + month + '-' + d.getFullYear() + hoursAndMinutes;
	}
	
	/**
	 * @description Inserts hours & minutes in datetime string
	 * @example
	 * let newTime = setHourMin('2017-05-01T08:00:00', '12:55')
	 * @param {string} dateTime Datetime string
	 * @param {string} hhmm Hours and minutes to insert into datetime string
	 * @return {string} Returns formatted string
	 */
	function setHourMin(dateTime, hhmm) {
	  // Format is 2017-04-02T10:41:16
	  if (hhmm !== null && hhmm.length === 4) {
	    if (hhmm.indexOf(':') === -1) {
	      hhmm = hhmm.substring(0, 2) + ':' + hhmm.substring(2, 4);
	    } else if (hhmm.indexOf(':') === 1) {
	      hhmm = '0' + hhmm;
	    }
	  }
	  if (dateTime === null) return hhmm;
	  return dateTime.substring(0, 11) + hhmm;
	}
	
	/**
	 * @param {datetime} datetime Datetime
	 */
	function getWeekDay(datetime) {
	  var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var date = new Date(datetime);
	  var weekday = date.getDay();
	  var day = void 0;
	
	  switch (weekday) {
	    case 0:
	      // sunday
	      day = (0, _helpers.translation)('175');
	      break;
	    case 1:
	      // monday
	      day = (0, _helpers.translation)('169');
	      break;
	    case 2:
	      // ..
	      day = (0, _helpers.translation)('170');
	      break;
	    case 3:
	      // ..
	      day = (0, _helpers.translation)('171');
	      break;
	    case 4:
	      // ..
	      day = (0, _helpers.translation)('172');
	      break;
	    case 5:
	      // friday
	      day = (0, _helpers.translation)('173');
	      break;
	    case 6:
	      // saturday
	      day = (0, _helpers.translation)('174');
	      break;
	  }
	
	  return short ? day.substring(0, 3) : day;
	}
	
	/**
	 * @description Formats a date relative to now
	 * @example const relativeDate = getRelativeDateTime('2020-01-21T08:00:00')
	 * @param {datetime} datetime Datetime
	 * @return {string} Date string relative to now
	 */
	function getRelativeDateTime(datetime) {
	  if (!datetime) return '';
	
	  var date = (0, _moment2.default)(datetime);
	  var today = (0, _moment2.default)();
	  var pre = '';
	  var relativeToday = '';
	
	  var diff = today.dayOfYear() - date.dayOfYear();
	  if (!diff) {
	    relativeToday = '238';
	  } else if (diff === -1) {
	    relativeToday = '16532';
	  } else if (diff === 1) {
	    relativeToday = '16533';
	  } else {
	    switch (date.day()) {
	      case 0:
	        relativeToday = '175';
	        break;
	      case 1:
	        relativeToday = '169';
	        break;
	      case 2:
	        relativeToday = '170';
	        break;
	      case 3:
	        relativeToday = '171';
	        break;
	      case 4:
	        relativeToday = '172';
	        break;
	      case 5:
	        relativeToday = '173';
	        break;
	      case 6:
	        relativeToday = '174';
	        break;
	    }
	
	    if (diff > 0 && diff <= 6) {
	      pre = '15062'; // "Last"
	    }
	  }
	
	  var preValue = pre ? (0, _helpers.translation)(pre) + ' ' : '';
	  var relative = '' + preValue + (0, _helpers.translation)(relativeToday) + ', ' + date.format((0, _helpers.translation)('16534'));
	
	  return relative;
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1585);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var Col = function (_Component) {
	  _inherits(Col, _Component);
	
	  function Col() {
	    _classCallCheck(this, Col);
	
	    return _possibleConstructorReturn(this, (Col.__proto__ || Object.getPrototypeOf(Col)).apply(this, arguments));
	  }
	
	  _createClass(Col, [{
	    key: 'getSpanClass',
	    value: function getSpanClass() {
	      return ' s-' + this.props.span;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-column' + this.getSpanClass();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle(), id: this.props.id },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Col;
	}(_react.Component);
	
	Col.defaultProps = {
	  span: 1,
	  id: null
	};
	
	exports.default = Col;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	__webpack_require__(338);
	
	__webpack_require__(1580);
	
	var _icons = __webpack_require__(6);
	
	var _constants = __webpack_require__(5);
	
	var _detect = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux'
	// import { translation } from '../../../utils/helpers'
	
	
	var Check = function (_Component) {
	  _inherits(Check, _Component);
	
	  function Check(props) {
	    _classCallCheck(this, Check);
	
	    var _this = _possibleConstructorReturn(this, (Check.__proto__ || Object.getPrototypeOf(Check)).call(this, props));
	
	    _this.state = {};
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Check, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var updateComp = false;
	      if (nextProps.id !== this.props.id) {
	        updateComp = true;
	      }
	      if (nextProps.name !== this.props.name) {
	        updateComp = true;
	      }
	      if (nextProps.value !== this.props.value) {
	        updateComp = true;
	      }
	      if (nextProps.onChange !== this.props.onChange) {
	        if (this.props.onChange && nextProps.onChange) {
	          if (this.props.onChange.toString() !== nextProps.onChange.toString()) {
	            updateComp = true;
	          }
	        } else {
	          updateComp = true;
	        }
	      }
	      if (nextProps.checked !== this.props.checked) {
	        updateComp = true;
	      }
	      if (nextProps.labelText !== this.props.labelText) {
	        updateComp = true;
	      }
	      if (nextProps.size !== this.props.size) {
	        updateComp = true;
	      }
	      if (nextProps.style !== this.props.style) {
	        updateComp = true;
	      }
	      if (nextProps.helpText !== this.props.helpText) {
	        updateComp = true;
	      }
	      if (nextProps.labelAlignment !== this.props.labelAlignment) {
	        updateComp = true;
	      }
	      if (nextProps.onClick !== this.props.onClick) {
	        if (this.props.onClick && nextProps.onClick) {
	          if (this.props.onClick.toString() !== nextProps.onClick.toString()) {
	            updateComp = true;
	          }
	        } else {
	          updateComp = true;
	        }
	      }
	      if (nextProps.disabled !== this.props.disabled) {
	        updateComp = true;
	      }
	      if (nextProps.readOnly !== this.props.readOnly) {
	        updateComp = true;
	      }
	      if (nextProps.required !== this.props.required) {
	        updateComp = true;
	      }
	      if (nextProps.width !== this.props.width) {
	        updateComp = true;
	      }
	      if (nextProps.spacing !== this.props.spacing) {
	        updateComp = true;
	      }
	      if (nextProps.simple !== this.props.simple) {
	        updateComp = true;
	      }
	      // console.log('ShouldUpdate? ', updateComp, 'THIS', this.props, 'NEXT', nextProps) //nextProps.onChange.toString() === this.props.onChange.toString(), nextProps.onChange.toString().length, this.props.onChange.toString().length,  nextProps.onChange.toString(), this.props.onChange.toString() )//nextProps, this.props)
	      return updateComp;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      // console.log('Check onChange triggered! ', e)
	      if (this.props.onChange !== null) {
	        this.props.onChange(e);
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      // console.log('Check onClick triggered! ', e)
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return ' size-large';
	        case 'm':
	          return ' size-medium';
	        case 's':
	          return ' size-small';
	      }
	    }
	  }, {
	    key: 'getSolidClass',
	    value: function getSolidClass() {
	      return '';
	    }
	  }, {
	    key: 'getBorderClass',
	    value: function getBorderClass() {
	      return '';
	    }
	  }, {
	    key: 'getWidthClass',
	    value: function getWidthClass() {
	      if (this.props.width === null) return '';
	      var width = typeof this.props.width === 'number' ? width : parseInt(this.props.width);
	      return ' cnt-w-' + width;
	    }
	  }, {
	    key: 'getSpacingClass',
	    value: function getSpacingClass() {
	      if (this.props.simple) return '';
	
	      var spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing;
	      if (spacing === 0) return '';
	      if (spacing < 0) return ' pg-my-default';
	      return ' pg-my-' + spacing;
	    }
	  }, {
	    key: 'getIconSize',
	    value: function getIconSize() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 's':
	          return 's';
	        case 'm':
	        case 'l':
	          return 'm';
	      }
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-check' + this.getSizeClass() + this.getSpacingClass() + this.getWidthClass() + this.getSolidClass() + this.getBorderClass();
	    }
	  }, {
	    key: 'getContainerStyle',
	    value: function getContainerStyle() {
	      if (this.props.simple) return 'container';
	
	      var containerStyles = 'container';
	
	      switch (this.props.labelAlignment) {
	        case 'r':
	          containerStyles += ' label-right';
	          break;
	        case 'l':
	          containerStyles += ' label-left';
	          break;
	      }
	
	      if (this.props.size === 'l') {
	        if (this.props.disabled) {
	          containerStyles += ' container--disabled';
	        } else if (this.props.checked) {
	          containerStyles += ' container--checked';
	        }
	      }
	
	      return containerStyles;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var simple = this.props.simple;
	
	      var iconSize = this.getIconSize();
	      var iosCustomNormal = '';
	      var iosCustomHover = '';
	      var isiPadPro = (0, _detect.isTouchDevice)() && /MacIntel/.test(navigator.platform);
	      var iosDevice = _constants.isiOS || isiPadPro;
	      if (iosDevice) {
	        iosCustomNormal = ' customIos-normal';
	        iosCustomHover = ' customIos-hover';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              }, className: this.getContainerStyle() },
	            !simple && _react2.default.createElement(
	              _label2.default,
	              null,
	              this.props.labelText
	            ),
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              id: this.props.id,
	              name: this.props.name,
	              value: this.props.value,
	              onChange: this.onChange,
	              onClick: this.onClick,
	              checked: this.props.checked
	              // indeterminate={this.props.indeterminate}
	              , disabled: this.props.disabled,
	              readOnly: this.props.readOnly,
	              required: this.props.required
	            }),
	            !this.props.disabled && !this.props.indeterminate && this.props.checked && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_Selected, className: 'check-checked', icon2: _icons.ElementIcons.Check_Selected_Check, size: iconSize, injectSvg: true }),
	            !this.props.disabled && !this.props.indeterminate && !this.props.checked && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_Normal, className: 'check-normal' + iosCustomNormal, size: iconSize, injectSvg: true }),
	            this.props.disabled && !this.props.indeterminate && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_Disabled, className: 'check-disabled', size: iconSize, injectSvg: true }),
	            this.props.disabled && !this.props.indeterminate && this.props.checked && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_SelectedDisabled, className: 'check-checked-disabled', size: iconSize, injectSvg: true }),
	            !iosDevice && !this.props.disabled && !this.props.indeterminate && !this.props.checked && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_Hover, className: 'check-hover' + iosCustomHover, size: iconSize, injectSvg: true }),
	            !this.props.disabled && this.props.indeterminate && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_IndeterminateSelected, className: 'check-indeterminate-selected', size: iconSize, injectSvg: true }),
	            this.props.disabled && this.props.indeterminate && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_IndeterminateDisabled, className: 'check-indeterminate-disabled', size: iconSize, injectSvg: true })
	          )
	        ),
	        !simple && this.props.helpText && _react2.default.createElement(_helpIcon2.default, { helpText: this.props.helpText })
	      );
	    }
	  }]);
	
	  return Check;
	}(_react.Component);
	
	Check.defaultProps = {
	  size: 's',
	  style: 'default',
	  labelText: null,
	  helpText: null,
	  labelAlignment: 'r',
	  onChange: null,
	  onClick: null,
	  value: false,
	  checked: null,
	  indeterminate: false,
	  disabled: false,
	  readOnly: false,
	  required: false,
	  width: null,
	  spacing: -1,
	  simple: false
	};
	
	exports.default = Check;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Divider(props) {
	  var getSizeClass = function getSizeClass() {
	    if (typeof props.size === 'number' && props.size > 0 && props.size < 7) {
	      return 'pg-my-' + props.size;
	    }
	
	    return 'pg-my-1';
	  };
	
	  var classes = 'element-divider ' + getSizeClass();
	  if (props.noLine || props.noline) {
	    classes += ' element-divider__noLine';
	  }
	
	  if (props.vertical) {
	    classes += ' element-divider__vertical';
	  }
	
	  return _react2.default.createElement('hr', { className: classes });
	}
	
	Divider.defaultProps = {
	  noLine: false,
	  vertical: false,
	  size: 1
	};
	
	exports.default = Divider;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetOrderFilter = resetOrderFilter;
	exports.setOrdersFilter = setOrdersFilter;
	exports.setOrdersSearch = setOrdersSearch;
	exports.SetWorkcardOrderAction = SetWorkcardOrderAction;
	exports.SetOrderAction = SetOrderAction;
	exports.setOrderErrors = setOrderErrors;
	exports.resetSimplesearchType = resetSimplesearchType;
	exports.setSimplesearchType = setSimplesearchType;
	exports.SetOrders = SetOrders;
	exports.SetWorkscreenOrders = SetWorkscreenOrders;
	exports.SetOrdersUpdated = SetOrdersUpdated;
	exports.resetFilter = resetFilter;
	exports.resetSimplesearch = resetSimplesearch;
	exports.setSimplesearch = setSimplesearch;
	exports.resetOrder = resetOrder;
	exports.getRejectedEvaluations = getRejectedEvaluations;
	exports.getOrdersNew = getOrdersNew;
	exports.getOrders = getOrders;
	exports.getOrderSorting = getOrderSorting;
	exports.updateOrderList = updateOrderList;
	exports.updateWorkscreenList = updateWorkscreenList;
	exports.updateOrderListSingle = updateOrderListSingle;
	exports.getOrdersAdvanced = getOrdersAdvanced;
	exports.moveOrder = moveOrder;
	exports.getSteps = getSteps;
	exports.getStepsAhead = getStepsAhead;
	exports.getStepsBehind = getStepsBehind;
	exports.getNextStep = getNextStep;
	exports.getOrder = getOrder;
	exports.getOrderSimple = getOrderSimple;
	exports.getOrderClean = getOrderClean;
	exports.saveOrder = saveOrder;
	exports.updateDeliveryTime = updateDeliveryTime;
	exports.bookOrder = bookOrder;
	exports.setOrder = setOrder;
	exports.setWorkcardOrder = setWorkcardOrder;
	exports.createOrder = createOrder;
	exports.createOrderEstimation = createOrderEstimation;
	exports.skipOrderCheck = skipOrderCheck;
	exports.deleteOrder = deleteOrder;
	exports.deleteOrderSimple = deleteOrderSimple;
	exports.ConnectOrder = ConnectOrder;
	exports.getOrderVehicleData = getOrderVehicleData;
	exports.getForsiData = getForsiData;
	exports.isFileReady = isFileReady;
	exports.getFileIcon = getFileIcon;
	exports.createFileContainer = createFileContainer;
	exports.uploadFileToOrder = uploadFileToOrder;
	exports.uploadMultipleFiles = uploadMultipleFiles;
	exports.uploadImageMarkings = uploadImageMarkings;
	exports.createPhotoDoc = createPhotoDoc;
	exports.deleteFileFromOrder = deleteFileFromOrder;
	exports.deleteDeviationFileFromOrder = deleteDeviationFileFromOrder;
	exports.getPickupTimes = getPickupTimes;
	exports.getAvailablePickupTimes = getAvailablePickupTimes;
	exports.getNextDeliveryTimes = getNextDeliveryTimes;
	exports.getDeliveryTimes = getDeliveryTimes;
	exports.startOrder = startOrder;
	exports.stopOrder = stopOrder;
	exports.getOrderInspection = getOrderInspection;
	exports.saveOrderInspection = saveOrderInspection;
	exports.getManualMerge = getManualMerge;
	exports.ManualMerge = ManualMerge;
	exports.getLinkOrderData = getLinkOrderData;
	exports.LinkOrders = LinkOrders;
	exports.ReferenceOrder = ReferenceOrder;
	exports.GetReferenceOrderInfo = GetReferenceOrderInfo;
	exports.ReferenceEdit = ReferenceEdit;
	exports.GetLog = GetLog;
	exports.GetOrderNotifications = GetOrderNotifications;
	exports.GetDeadlineTimes = GetDeadlineTimes;
	exports.UpdateProductionDate = UpdateProductionDate;
	exports.UpdateDeliveryDate = UpdateDeliveryDate;
	exports.StopLockOrder = StopLockOrder;
	exports.GetNewDeliveryForResume = GetNewDeliveryForResume;
	exports.getArchivedOrders = getArchivedOrders;
	exports.updatePaint = updatePaint;
	exports.updatePrice = updatePrice;
	exports.updateRekvNumber = updateRekvNumber;
	exports.setCustomer = setCustomer;
	exports.hasExtent = hasExtent;
	exports.GetExtends = GetExtends;
	exports.getOrdersInStep = getOrdersInStep;
	exports.GetDeliveryChange = GetDeliveryChange;
	exports.getOrderFiles = getOrderFiles;
	exports.UpdateOrderFileSelection = UpdateOrderFileSelection;
	exports.GetAssessmentItemsInOrderInspection = GetAssessmentItemsInOrderInspection;
	exports.UpdateEconomicMatch = UpdateEconomicMatch;
	exports.GetInvoiceLog = GetInvoiceLog;
	exports.GetOrderInvoiceLog = GetOrderInvoiceLog;
	exports.DeleteExifData = DeleteExifData;
	exports.rotateImages = rotateImages;
	exports.markAsWrecked = markAsWrecked;
	exports.resetReport = resetReport;
	exports.getExtentInfo = getExtentInfo;
	exports.setLastVisitedOrderId = setLastVisitedOrderId;
	exports.clearLastVisitedOrderId = clearLastVisitedOrderId;
	exports.mustOrderUpdateDueToSocket = mustOrderUpdateDueToSocket;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	var _auth = __webpack_require__(8);
	
	var _upload = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
	                                                                                                                                                                                                     * @module actions/orders
	                                                                                                                                                                                                     */
	
	
	// import { filterSearch } from '../utils/filter'
	
	
	function resetOrderFilter(source) {
	  switch (source) {
	    case 'orderlist':
	      return {
	        type: _constants.RESET_ORDERLIST_FILTER
	      };
	    case 'workscreen':
	      return {
	        type: _constants.RESET_WORKSCREEN_ORDER_FILTER
	      };
	    case 'customer':
	      return {
	        type: _constants.RESET_CUSTOMER_ORDER_FILTER
	      };
	    case 'wp':
	      return {
	        type: _constants.RESET_WP_ORDER_FILTER
	      };
	  }
	  // return {
	  //   type: RESET_ORDER_FILTER
	  // }
	}
	
	function setOrdersFilter(filter, source) {
	  // set local storage for filter
	  // window.localStorage.setItem('user_token', token)
	  // window.localStorage.setItem('user_data', JSON.stringify(res.data))
	  // console.log('setOrdersFilter filter, source', filter, source)
	  switch (source) {
	    case 'orderlist':
	      window.localStorage.setItem('filterOrderlist', JSON.stringify(filter));
	      return {
	        type: _constants.SET_ORDERLIST_FILTER,
	        filter: filter
	      };
	    case 'workscreen':
	      window.localStorage.setItem('filterWorkscreen', JSON.stringify(filter));
	      return {
	        type: _constants.SET_WORKSCREEN_ORDER_FILTER,
	        filter: filter
	      };
	    case 'customer':
	      window.localStorage.setItem('filterCustomer', JSON.stringify(filter));
	      return {
	        type: _constants.SET_CUSTOMER_ORDER_FILTER,
	        filter: filter
	      };
	    case 'wp':
	      window.localStorage.setItem('filterWP', JSON.stringify(filter));
	      return {
	        type: _constants.SET_WP_ORDER_FILTER,
	        filter: filter
	      };
	  }
	
	  // window.localStorage.setItem('ordersFilter', JSON.stringify(filter))
	  // return {
	  //   type: SET_ORDER_FILTER,
	  //   filter
	  // }
	}
	function setOrdersSearch(isSearching) {
	  return {
	    type: _constants.SET_ORDERS_SEARCH,
	    isSearching: isSearching
	  };
	}
	
	function SetWorkcardOrderAction(order) {
	  return {
	    type: _constants.SET_WORKCARD_ORDER,
	    order: order
	  };
	}
	function SetOrderAction(order) {
	  return {
	    type: _constants.SET_ORDER,
	    order: order
	  };
	}
	
	function setOrderErrors(error) {
	  return {
	    type: _constants.SET_ORDERS_ERRORS,
	    error: error
	  };
	}
	
	function resetSimplesearchType(source) {
	  var simpleSearch = { save: true, value: '' };
	  if (source === 'workscreen') {
	    window.localStorage.setItem('simplesearchWorkscreen', JSON.stringify(simpleSearch));
	    return {
	      type: _constants.RESET_SIMPLESEARCH_WORKSCREEN
	    };
	  } else {
	    window.localStorage.setItem('simpleSearch', JSON.stringify(simpleSearch));
	    return {
	      type: _constants.RESET_SIMPLESEARCH
	    };
	  }
	}
	
	function setSimplesearchType(simplesearch, source) {
	  if (source === 'workscreen') {
	    window.localStorage.setItem('simplesearchWorkscreen', JSON.stringify(simplesearch));
	    return {
	      type: _constants.SET_SIMPLESEARCH_WORKSCREEN,
	      simplesearch: simplesearch
	    };
	  } else {
	    window.localStorage.setItem('simpleSearch', JSON.stringify(simplesearch));
	    return {
	      type: _constants.SET_SIMPLESEARCH,
	      simplesearch: simplesearch
	    };
	  }
	}
	
	/**
	 * @description Returns payload for dispatching SET_ORDERS
	 * @param {Object} orders Object containing orders
	 */
	function SetOrders(orders) {
	  return {
	    type: _constants.SET_ORDERS,
	    orders: orders
	  };
	}
	/**
	 * @description Returns payload for dispatching SET_ORDERS
	 * @param {Object} orders Object containing orders
	 */
	function SetWorkscreenOrders(orders) {
	  return {
	    type: _constants.SET_WORKSCREEN_ORDERS,
	    orders: orders
	  };
	}
	
	/**
	 * @description Returns payload for dispatching SET_ORDERS
	 * @param {Object} orders Object containing orders
	 */
	function SetOrdersUpdated(order, groupIndex, itemIndex) {
	  return {
	    type: _constants.SET_ORDERS,
	    newUpdatedOrder: order,
	    newUpdatedOrderGroupIndex: groupIndex,
	    newUpdatedOrderItemIndex: itemIndex
	  };
	}
	
	function resetFilter(source) {
	  return function (dispatch) {
	    dispatch(resetOrderFilter(source));
	  };
	}
	
	function resetSimplesearch(source) {
	  return function (dispatch) {
	    dispatch(resetSimplesearchType(source));
	  };
	}
	
	function setSimplesearch(simplesearch, source) {
	  return function (dispatch) {
	    dispatch(setSimplesearchType(simplesearch, source));
	  };
	}
	
	/**
	 * @description Resets the order to {}
	 * @param {Object} order Object order
	 */
	function resetOrder() {
	  return function (dispatch) {
	    dispatch(setOrder({}));
	  };
	}
	
	/**
	 * @description Get rejected evaluations from API
	 * @return {Promise} Axios promise
	 */
	function getRejectedEvaluations(orderId) {
	  var url = _constants.API_URL + '/Order/RejectedEvaluations/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	/**
	 * @description New way to get orders
	 * @return {Promise} Axios promise
	 */
	function getOrdersNew(data) {
	  // console.log('getNewOrder data', data)
	  var url = _constants.API_URL + '/Order/Search';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Getting orders from API and dispatching SetOrders
	 * @return {Promise} Axios promise
	 */
	function getOrders(search) {
	  // console.log('search', search)
	  var url = _constants.API_URL + '/FilterOrders' + search;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      var value = res.data.value[0];
	      dispatch(SetOrders(value.Steps));
	      dispatch(setOrderErrors(false));
	      return res;
	    }, function (err) {
	      if (err) {
	        dispatch(setOrderErrors(true));
	        return err;
	      }
	    });
	  };
	}
	
	function getOrderSorting(step, orderIds) {
	  // console.log('Get order sorting ', step, orderIds)
	  var url = _constants.API_URL + '/Order/OrderSearchSorting';
	  var data = {
	    StepId: step,
	    OrderIds: orderIds
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      return res;
	    }, function (err) {
	      if (err) {
	        return err;
	      }
	    });
	  };
	}
	
	/**
	 * @description Updating redux state with new orders
	 */
	function updateOrderList(orders) {
	  // console.log('updateOrderList', orders)
	  return function (dispatch) {
	    dispatch(SetOrders(orders));
	    dispatch(setOrderErrors(false));
	  };
	}
	function updateWorkscreenList(orders) {
	  // console.log('updateWorkscreenList', orders)
	  return function (dispatch) {
	    dispatch(SetWorkscreenOrders(orders));
	  };
	}
	
	/**
	 * @description Updating redux state with new orders single item
	 */
	function updateOrderListSingle(order, groupIndex, itemIndex) {
	  // console.log('testSingleUpdate')
	  return function (dispatch) {
	    dispatch(SetOrdersUpdated(order, groupIndex, itemIndex));
	    dispatch(setOrderErrors(false));
	  };
	}
	
	/**
	 * @description Getting orders from API (advanced) and dispatching SetOrders
	 * @return {Promise} Axios promise
	 */
	function getOrdersAdvanced(data, userType) {
	  // console.log('getOrdersAdvanced', data)
	  var url = _constants.API_URL + '/Order/Search';
	  var filterData = JSON.parse(JSON.stringify(data));
	  // Never fetch archived orders
	  // filterData.process.Completed = false
	  // New Draft logic
	  if (typeof filterData.process !== 'undefined') {
	    if ((0, _auth.hasAccess)([4], userType)) {
	      filterData.CreatedByRole = 4;
	    } else {
	      if (filterData.process.draft1) {
	        // clients
	        filterData.CreatedByRole = 3;
	      }
	      if (filterData.process.draft2) {
	        // self
	        filterData.CreatedByRole = 4;
	      }
	      if (filterData.process.draft1 && filterData.process.draft2) {
	        filterData.CreatedByRole = null;
	      }
	    }
	  }
	  // console.log('find orders', filterData)
	  return function (dispatch) {
	    return _axios2.default.post(url, filterData).then(function (res) {
	      var value = res.data[0];
	      var errors = { NoOrders: true };
	      dispatch(SetOrders(value.Steps));
	      dispatch(setOrdersSearch(false));
	      value.Steps.map(function (val) {
	        if (val.Orders.length > 0) {
	          errors = false;
	        }
	      });
	      dispatch(setOrderErrors(errors));
	      return res;
	    }, function (err) {
	      if (err) {
	        dispatch(setOrderErrors(true));
	        return err;
	      }
	    });
	  };
	}
	
	/**
	 * @description Moving an order
	 * @return {Promise} Axios promise
	 */
	function moveOrder(data) {
	  var url = _constants.API_URL + '/Order/MoveOrder';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Requests info on available steps for an order.
	 * @param {Order id} orderId
	 */
	function getSteps(orderId) {
	  var url = _constants.API_URL + '/GetSteps/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Requests info on available steps for an order that are ahead of its current step.
	 * @param {Order id} orderId
	 * @param {True to include the order's current step in the result} includeCurrentStep
	 */
	function getStepsAhead(orderId) {
	  var includeCurrentStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var url = _constants.API_URL + '/GetStepsAhead/' + orderId;
	  if (includeCurrentStep === true) {
	    url += '?includeCurrent=true';
	  }
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Requests info on available steps for an order that are behind its current step.
	 * @param {Order id} orderId
	 * @param {True to include the order's current step in the result} includeCurrentStep
	 */
	function getStepsBehind(orderId) {
	  var includeCurrentStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var url = _constants.API_URL + '/GetStepsBehind/' + orderId;
	  if (includeCurrentStep === true) {
	    url += '?includeCurrent=true';
	  }
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function getNextStep(orderId) {
	  var url = _constants.API_URL + '/GetNextStep/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting order from api and dispatching SetOrder
	 * @return {Promise} Axios promise
	 */
	function getOrder(orderID) {
	  var url = _constants.API_URL + '/WorkCard/Get/' + orderID;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      var valueShown = res.data.EstimatedProcessTime;
	      if (valueShown === null || Number.isNaN(valueShown) || valueShown === 0) {
	        valueShown = null;
	      } else {
	        valueShown /= 60;
	      }
	      res.data.EstimatedProcessTimeShown = valueShown;
	      dispatch(SetOrderAction(res.data));
	      dispatch(SetWorkcardOrderAction(res.data));
	      return res;
	    });
	  };
	}
	
	function getOrderSimple(orderID) {
	  var url = _constants.API_URL + '/WorkCard/Get/' + orderID;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      return res;
	    });
	  };
	}
	
	function getOrderClean(orderID) {
	  var url = _constants.API_URL + '/WorkCard/Get/' + orderID;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Saving an order
	 * @return {Promise} Axios promise
	 */
	function saveOrder(data) {
	  var url = _constants.API_URL + '/WorkCard/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	/**
	 * @description Update delivery time
	 * @return {Promise} Axios promise
	 */
	function updateDeliveryTime(data) {
	  var url = _constants.API_URL + '/WorkCard/DeliveryTime/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Booking an order
	 * @return {Promise} Axios promise
	 */
	function bookOrder(data) {
	  var url = _constants.API_URL + '/Order/Book/Paint';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Setting the order
	 */
	function setOrder(data) {
	  var valueShown = data.EstimatedProcessTime;
	  if (valueShown === null || Number.isNaN(valueShown) || valueShown === 0) {
	    valueShown = null;
	  } else {
	    valueShown /= 60;
	  }
	  data.EstimatedProcessTimeShown = valueShown;
	  return function (dispatch) {
	    dispatch(SetOrderAction(data));
	  };
	}
	/**
	 * @description Setting the order
	 */
	function setWorkcardOrder(data) {
	  return function (dispatch) {
	    dispatch(SetWorkcardOrderAction(data));
	  };
	}
	
	/**
	 * @description Creating an order using the API
	 * @return {Promise} Axios promise
	 */
	function createOrder(data) {
	  var url = _constants.FILE_STORAGE_API + '/order/create';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Creating estimation order using the API
	 * @return {Promise} Axios promise
	 */
	function createOrderEstimation(data) {
	  var url = _constants.FILE_STORAGE_API + '/order/evaluation/create';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Skips order check
	 * @return {Promise} Axios promise
	 */
	function skipOrderCheck(data) {
	  var url = _constants.API_URL + '/Order/OrderCheck/Skip';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Deletes an order using the API
	 * @return {Promise} Axios promise
	 */
	function deleteOrder(id, step, index) {
	  var url = _constants.API_URL + '/order/delete/' + id;
	  return function (dispatch, getState) {
	    return _axios2.default.post(url, {}).then(function (res) {
	      var orders = [].concat(_toConsumableArray(getState().orders.orders));
	      // delete orders[step].Orders[index].IsDeleted
	      if (index === undefined) {
	        index = orders[step].Orders.findIndex(function (o) {
	          return o.Id === id;
	        });
	      }
	      orders[step].Orders[index].IsDeleted = true;
	      dispatch(SetOrders(orders));
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Deletes an order using the API - SIMPLE
	 * @return {Promise} Axios promise
	 */
	function deleteOrderSimple(id) {
	  var url = _constants.API_URL + '/order/delete/' + id;
	  return function (dispatch) {
	    return _axios2.default.post(url, {});
	  };
	}
	
	/**
	 * @description Connect an old and new order
	 * @return {Promise} Axios promise
	 */
	function ConnectOrder(data) {
	  var url = _constants.API_URL + '/order/connectorders';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Getting vehicle data from api and returning axios promise
	 * @return {Promise} Axios promise
	 */
	function getOrderVehicleData(vehicleInfo, vehicleInfoType) {
	  var url = _constants.API_URL + '/Order/Vehicle';
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      VehicleInfo: vehicleInfo,
	      VehicleInfoType: vehicleInfoType
	    });
	  };
	}
	
	/**
	 * @description Getting forsi data from api and returning axios promise
	 * @return {Promise} Axios promise
	 */
	function getForsiData(id) {
	  var url = _constants.FILE_STORAGE_API + '/Report/Fetch/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Check if file processing is complete server side
	 * @return {Promise} Axios promise
	 */
	function isFileReady(orderFileId) {
	  var url = _constants.FILE_STORAGE_API + '/FileService/IsFileReady/' + orderFileId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting icon url for a filename
	 * @return {Promise} Axios promise
	 */
	function getFileIcon(fileName) {
	  var url = _constants.API_URL + '/FileService/GetIcon?fileName=' + fileName;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function createFileContainer() {
	  var orderPriceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var deviationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var url = _constants.FILE_STORAGE_API + '/FileService/CreateFileContainer';
	  var params = [];
	  if (orderPriceId !== null) params.push('OrderPriceId=' + orderPriceId);
	  if (deviationId !== null) params.push('DeviationId=' + deviationId);
	
	  for (var i = 0; i < params.length; i++) {
	    if (i === 0) {
	      url += '?' + params[i];
	    } else {
	      url += '&' + params[i];
	    }
	  }
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Uploading a file to an order
	 * @return {Promise} Axios promise
	 */
	function uploadFileToOrder(file, orderid, type, priceid, fileContainerId) {
	  var url = _constants.FILE_STORAGE_API + '/FileService/Upload?OrderID=' + orderid;
	  if (fileContainerId !== undefined && fileContainerId !== null) {
	    url += '&fileContainerId=' + fileContainerId;
	  }
	  var data = new window.FormData();
	  data.append(file.name, file);
	  if (typeof type !== 'undefined') {
	    data.append('Type', type);
	  }
	  if (typeof priceid !== 'undefined') {
	    data.append('OrderPriceId', priceid);
	  }
	
	  // if iOS image rotate
	  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	  if (isiOS && file.type.indexOf('image/') !== -1) {
	    // file.rotation = 1
	    data.append('Rotation_' + 0, file.rotation);
	  }
	  // return dispatch => {
	  //   let key = Math.floor(Math.random() * 10000000)
	  //   const config = {
	  //     onUploadProgress: evt => {
	  //       updateUploads(key, file, evt)
	  //     }
	  //   }
	  //   return axios.post(url, data, config)
	  // }
	
	  // console.log('uploadFileToOrder')
	  return (0, _upload.queueUpload)(url, file, data);
	}
	
	/**
	 * @description Uploading multiples files to an order
	 * @return {Promise} Axios promise
	 */
	function uploadMultipleFiles(files, orderid, type, priceid, fileContainerId, orderNoteId) {
	  var url = _constants.FILE_STORAGE_API + '/FileService/Upload?OrderID=' + orderid;
	  var data = new window.FormData();
	  if (fileContainerId !== undefined && fileContainerId !== null) {
	    url += '&fileContainerId=' + fileContainerId;
	  }
	  if (orderNoteId !== undefined && orderNoteId !== null) {
	    url += '&orderNoteId=' + orderNoteId;
	  }
	  // console.log('uploadMultipleFiles', files, orderid, 'fileContainerId', fileContainerId)
	  files.map(function (val, index) {
	    // console.log('index', index)
	    if (typeof val.file === 'undefined') {
	      data.append(val.name, val);
	    } else {
	      data.append(val.file.name, val.file);
	    }
	    if (typeof val.rotation !== 'undefined') {
	      // console.log('index', index, val.rotation)
	      data.append('Rotation_' + index, val.rotation);
	    }
	  });
	  if (typeof type !== 'undefined') {
	    data.append('Type', type);
	  }
	  if (typeof priceid !== 'undefined') {
	    data.append('OrderPriceId', priceid);
	  }
	
	  return (0, _upload.queueUpload)(url, null, data);
	  // return dispatch => {
	  //   let key = Math.floor(Math.random() * 10000000)
	  //   const config = {
	  //     onUploadProgress: evt => {
	  //       updateUploads(key, file, evt)
	  //     }
	  //   }
	  //   return axios.post(url, data, config)
	  // }
	}
	
	/**
	 * @description Uploading markings to files
	 * @return {Promise} Axios promise
	 */
	function uploadImageMarkings(data) {
	  var url = _constants.FILE_STORAGE_API + '/FileService/UploadMarkings';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Connects images to photodocumentation
	 * @return {Promise} Axios promise
	 */
	function createPhotoDoc(data) {
	  var url = _constants.FILE_STORAGE_API + '/Order/Photodocumentation/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Deletes a files from an order
	 * @return {Promise} Axios promise
	 */
	function deleteFileFromOrder(file) {
	  var url = _constants.FILE_STORAGE_API + '/FileService/Delete/';
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      ItemID: file.OrderFileID
	    });
	  };
	}
	
	function deleteDeviationFileFromOrder(file) {
	  var fileId = typeof file.OrderFileID !== 'undefined' ? file.OrderFileID : file.OrderFile.OrderFileID;
	  var url = _constants.FILE_STORAGE_API + '/FileService/Delete/';
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      ItemID: fileId
	    });
	  };
	}
	
	/**
	 * @description Gets/validates pickup times.
	 * @return {Promise} Axios promise
	 */
	function getPickupTimes(pickupDate, pickupTime, customerId, department) {
	  var url = _constants.API_URL + '/Order/ValidatePickupTime/';
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      PickupDate: pickupDate,
	      PickupTime: pickupTime,
	      CustomerId: customerId,
	      Department: department
	    });
	  };
	}
	
	/**
	 * @description Gets/validates pickup times.
	 * @return {Promise} Axios promise
	 */
	function getAvailablePickupTimes(data) {
	  var url = _constants.API_URL + '/Order/PickupTimes/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Gets next delivery times.
	 * @return {Promise} Axios promise
	 */
	function getNextDeliveryTimes(pickupDate, pickupTime, customerId, orderPrice, orderType, isLoosePart, orderId, department) {
	  var url = _constants.API_URL + '/Order/NextDeliveryTime/';
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      PickupDate: pickupDate,
	      PickupTime: pickupTime,
	      CustomerId: customerId,
	      OrderPrice: orderPrice,
	      OrderType: orderType,
	      IsLoosePart: isLoosePart,
	      OrderId: orderId,
	      Department: department
	    });
	  };
	}
	
	/**
	 * @description Gets valid delivery times.
	 * @return {Promise} Axios promise
	 */
	function getDeliveryTimes(deliveryDate, department, orderId) {
	  var url = _constants.API_URL + '/Order/DeliveryTimes/';
	
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      DeliveryDate: deliveryDate,
	      Department: department,
	      OrderId: orderId
	    });
	  };
	}
	
	/**
	 * @description Start order
	 * @return {Promise} Axios promise
	 */
	function startOrder(data) {
	  var url = _constants.API_URL + '/Order/Start';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Stop order
	 * @return {Promise} Axios promise
	 */
	function stopOrder(data) {
	  var url = _constants.API_URL + '/Order/Stop';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get order inspection
	 * @return {Promise} Axios promise
	 */
	function getOrderInspection(id) {
	  var url = _constants.API_URL + '/OrderInspection/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save order inspection
	 * @return {Promise} Axios promise
	 */
	function saveOrderInspection(data) {
	  var url = _constants.API_URL + '/OrderInspection/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get ManualMerge Orders
	 * @return {Promise} Axios promise
	 */
	function getManualMerge(id) {
	  var url = _constants.API_URL + '/Order/ManualMerge/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Merge Orders
	 * @return {Promise} Axios promise
	 */
	function ManualMerge(data) {
	  var url = _constants.API_URL + '/Order/ManualMerge';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get link order data
	 * @return {Promise} Axios promise
	 */
	function getLinkOrderData(id) {
	  var url = _constants.API_URL + '/Order/LinkMatch/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Link Orders
	 * @return {Promise} Axios promise
	 */
	function LinkOrders(data) {
	  var url = _constants.API_URL + '/Order/Link';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Reference Order
	 * @return {Promise} Axios promise
	 */
	function ReferenceOrder(data) {
	  var url = _constants.API_URL + '/Order/Reference';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description get Reference Order info
	 * @return {Promise} Axios promise
	 */
	function GetReferenceOrderInfo(id) {
	  var url = _constants.API_URL + '/Order/Reference/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description edit the reference (approve og decline)
	 * @return {Promise} Axios promise
	 */
	function ReferenceEdit(data) {
	  var url = _constants.API_URL + '/Order/Reference/edit';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get Log
	 * @return {Promise} Axios promise
	 */
	function GetLog(id) {
	  var url = _constants.API_URL + '/Order/Log/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get Order Notifications
	 * @return {Promise} Axios promise
	 */
	function GetOrderNotifications(id) {
	  var url = _constants.API_URL + '/Order/Notifications/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get Order deadlines
	 * @return {Promise} Axios promise
	 */
	function GetDeadlineTimes(id) {
	  var url = _constants.API_URL + '/Order/GetDeadlineTimes/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Update ProductionDate
	 * @return {Promise} Axios promise
	 */
	function UpdateProductionDate(data) {
	  var url = _constants.API_URL + '/Order/Productiondate/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Update DeliveryDate
	 * @return {Promise} Axios promise
	 */
	function UpdateDeliveryDate(data) {
	  var url = _constants.API_URL + '/Order/Productiondate/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Stop order in current step
	 * @return {Promise} Axios promise
	 */
	function StopLockOrder(data) {
	  var url = _constants.API_URL + '/Order/StopLock/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get new delivery time for resume of the stopped order
	 * @return {Promise} Axios promise
	 */
	function GetNewDeliveryForResume(orderId) {
	  var url = _constants.API_URL + '/Order/ResumeOrderNewDelivery/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Fetches archived orders
	 * @return {Promise} Axios promise
	 */
	function getArchivedOrders(data) {
	  var url = _constants.API_URL + '/Order/GetArchived';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Updates paint on order
	 * @return {Promise} Axios promise
	 */
	function updatePaint(data) {
	  var url = _constants.API_URL + '/Order/UpdatePaint/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function updatePrice(data) {
	  var url = _constants.API_URL + '/Order/UpdatePrice/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function updateRekvNumber(data) {
	  var url = _constants.API_URL + '/Order/UpdateRekvNumber/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function setCustomer(orderId, customerId) {
	  var url = _constants.API_URL + '/Order/SetCustomer/';
	  var data = {
	    OrderId: orderId,
	    CustomerId: customerId
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function hasExtent(orderId) {
	  var url = _constants.API_URL + '/Order/HasManualExtent?orderId=' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get order extends
	 * @return {Promise} Axios promise
	 */
	function GetExtends(id) {
	  var url = _constants.API_URL + '/Order/Extends/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get orders that is being workt on nown ad the employees
	 * @return {Promise} Axios promise
	 */
	function getOrdersInStep(step) {
	  var url = _constants.API_URL + '/Order/OrdersWorkStep/' + step;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	/**
	 * @description Get delivery changes
	 * @return {Promise} Axios promise
	 */
	function GetDeliveryChange(date) {
	  var url = _constants.API_URL + '/Order/GetDeliveryChange/';
	  return function (dispatch) {
	    return _axios2.default.post(url, date);
	  };
	}
	
	/**
	 * @description Getting order files
	 * type: 0 or undefined = all, 1 = images, 2 = files
	 * @return {Promise} Axios promise
	 */
	function getOrderFiles(orderID, type) {
	  // let url = API_URL + '/Order/OrderFiles/Get/' + orderID
	  // return dispatch => {
	  //   return axios.get(url).then(res => {
	  //     dispatch(SetOrderAction(res.data.orderFile))
	  //     return res
	  //   })
	  // }
	  var url = _constants.FILE_STORAGE_API + '/Order/OrderFiles/Get/' + orderID;
	  if (type !== undefined) {
	    url += '?type=' + type;
	  }
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Update OrderFileSelection
	 * @return {Promise} Axios promise
	 */
	function UpdateOrderFileSelection(data) {
	  var url = _constants.API_URL + '/Order/OrderFileSelection/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Getting items for Assessment in order inspection
	 * @return {Promise} Axios promise
	 */
	function GetAssessmentItemsInOrderInspection(id, department) {
	  var url = _constants.API_URL + '/Order/AssessmentItems/Get/' + id + (typeof department !== 'undefined' ? '?department=' + department : '');
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Update Economic match type
	 * @return {Promise} Axios promise
	 */
	function UpdateEconomicMatch(data) {
	  var url = _constants.API_URL + '/Order/HandleEconomicMatch';
	  // console.log(data)
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Update Economic match type
	 * @return {Promise} Axios promise
	 */
	function GetInvoiceLog(orderId) {
	  var url = _constants.API_URL + '/Order/InvoiceLog/Get/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	/**
	 * @description Update Economic match type
	 * @return {Promise} Axios promise
	 */
	function GetOrderInvoiceLog(orderId) {
	  var url = _constants.API_URL + '/GetLog/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	/**
	 * @description Update ProductionDate
	 * @return {Promise} Axios promise
	 */
	function DeleteExifData(images) {
	  var url = _constants.FILE_STORAGE_API + '/Order/DeleteExifData';
	  var data = [];
	  images.map(function (val) {
	    data.push({
	      Base64: val.imageUrl,
	      Name: val.file.name
	    });
	  });
	  return (0, _upload.queueUpload)(url, null, data);
	  // return dispatch => {
	  //   return axios.post(url, data)
	  // }
	}
	
	/**
	 * @description Rotate image
	 * @return {Promise} Axios promise
	 */
	function rotateImages(images) {
	  var url = _constants.FILE_STORAGE_API + '/FileService/rotateImages';
	
	  return function (dispatch) {
	    return _axios2.default.post(url, images);
	  };
	}
	
	/**
	 * @description Mark the order as totally wrecked
	 * @return {Promise} Axios promise
	 */
	function markAsWrecked(orderId) {
	  var url = _constants.API_URL + '/Order/MarkAsWrecked';
	  return function (dispatch) {
	    return _axios2.default.post(url, orderId);
	  };
	}
	
	/**
	 * @description Delete report from order extent
	 * @return {Promise} Axios promise
	 */
	function resetReport(orderId) {
	  var url = _constants.FILE_STORAGE_API + '/Order/Report/Delete';
	  return function (dispatch) {
	    return _axios2.default.post(url, orderId).then(function (res) {
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Gets information on the current type of extent (base and addon) for an order.
	 * @param {Number} orderId
	 * @return {Promise} Axios promise
	 */
	function getExtentInfo(orderId) {
	  var url = _constants.API_URL + '/Order/ExtentInfo/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Set the orderId of the last visited order
	 */
	function setLastVisitedOrderId(orderId) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_LAST_VISITED_ORDER,
	      orderId: orderId
	    });
	  };
	}
	
	/**
	 * @description Clear the orderId of the last visited order
	 */
	function clearLastVisitedOrderId() {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_LAST_VISITED_ORDER,
	      orderId: undefined
	    });
	  };
	}
	
	/**
	 *
	 * @param {Array} identificationIds
	 * the orderIds from the socket to be update
	 * @param {Array} myOrders
	 * the orders you can see in the list right now
	 * @returns
	 * true if the identificationIds included in myOrders, otherwise false
	 */
	function mustOrderUpdateDueToSocket(identificationIds, myOrders) {
	  // console.log('MustOrderUpdateDueToSocket', myOrders)
	  var orders = myOrders.map(function (x) {
	    return x.Orders;
	  }).filter(function (x) {
	    return x.length > 0;
	  });
	  var orderIds = [];
	  for (var index = 0; index < orders.length; index++) {
	    var elements = orders[index];
	    for (var i = 0; i < elements.length; i++) {
	      orderIds.push(elements[i].Id);
	    }
	  }
	
	  var isIncluded = orderIds.some(function (x) {
	    return identificationIds.includes(x);
	  });
	  // console.log('orderIds', orderIds)
	  // console.log('identificationIds', identificationIds)
	  // console.log('isIncluded', isIncluded)
	
	  if (isIncluded) return true;
	  return false;
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(774);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(27);
	
	__webpack_require__(1592);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _Activator = __webpack_require__(1068);
	
	var _Activator2 = _interopRequireDefault(_Activator);
	
	var _SelectBox = __webpack_require__(1070);
	
	var _SelectBox2 = _interopRequireDefault(_SelectBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	/**
	 * Implements a component to show a drop down.
	 * - When use of prop "options", send an array containing { label: 0, value: 0 }.
	 *  - label is the displayed text value
	 *  - value is the returned value when selected
	 */
	var DropDown = function (_Component) {
	  _inherits(DropDown, _Component);
	
	  function DropDown(props) {
	    _classCallCheck(this, DropDown);
	
	    var _this = _possibleConstructorReturn(this, (DropDown.__proto__ || Object.getPrototypeOf(DropDown)).call(this, props));
	
	    _this.state = {
	      isOpen: false,
	      value: null,
	      options: [],
	      selectedOptions: [],
	
	      activatorStateClass: '',
	      openOnTop: false
	    };
	
	    _this.setRef = _this.setRef.bind(_this);
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.toggleOpen = _this.toggleOpen.bind(_this);
	    _this.isSelected = _this.isSelected.bind(_this);
	    _this.findSelectedOptions = _this.findSelectedOptions.bind(_this);
	    _this.getStateStyle = _this.getStateStyle.bind(_this);
	    return _this;
	  }
	
	  _createClass(DropDown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mouseup', this.handleClickOutside, this);
	      document.addEventListener('keydown', this.handleKeyDown, this);
	      document.addEventListener('touchmove', this.handleScroll, false);
	      var _props = this.props,
	          value = _props.value,
	          isMulti = _props.isMulti;
	
	
	      var selectedValues = value;
	
	      if (isMulti && !Array.isArray(selectedValues)) {
	        selectedValues = [selectedValues];
	      }
	
	      var options = this.getMappedOptions(this.props);
	      var selectedOptions = this.findSelectedOptions(options, selectedValues);
	
	      this.setState({
	        value: selectedValues,
	        options: options,
	        selectedOptions: selectedOptions
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(nextProps.value, this.props.value) || !(0, _lodash.isEqual)(nextProps.children, this.props.children) || !(0, _lodash.isEqual)(nextProps.options, this.props.options)) {
	        var options = this.getMappedOptions(nextProps);
	        var selectedOptions = this.findSelectedOptions(options, nextProps.value);
	
	        this.setState({
	          value: nextProps.value,
	          options: options,
	          selectedOptions: selectedOptions
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mouseup', this.handleClickOutside, this);
	      document.removeEventListener('keydown', this.handleKeyDown, this);
	      document.removeEventListener('touchmove', this.handleScroll);
	    }
	  }, {
	    key: 'getSpacingClass',
	    value: function getSpacingClass() {
	      if (this.props.spacing === undefined || this.props.spacing === null) return '';
	
	      var spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing;
	      if (spacing === 0) return '';
	      if (spacing < 0) return ' pg-mb-special';
	      return ' pg-mb-' + spacing;
	    }
	  }, {
	    key: 'getStateStyle',
	    value: function getStateStyle() {
	      if (this.state.isOpen) {
	        return ' open';
	      } else {
	        return ' closed';
	      }
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var classes = 'element-dropdown' + this.getSpacingClass() + this.getStateStyle();
	      if (this.state.openOnTop) {
	        classes += ' openOnTop';
	      }
	      if (this.props.className) {
	        classes += ' ' + this.props.className;
	      }
	
	      return classes;
	    }
	  }, {
	    key: 'setRef',
	    value: function setRef(node) {
	      this.dropDownRef = node;
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(e) {
	      if (this.dropDownRef && !this.dropDownRef.contains(e.target) && this.state.isOpen) {
	        this.toggleOpen();
	      }
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(e) {
	      if (this.dropDownRef && !this.dropDownRef.contains(e.target) && this.state.isOpen) {
	        this.toggleOpen();
	      }
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      var _this2 = this;
	
	      // console.log('e', e, 'open', this.state.isOpen)
	      if (!this.state.isOpen) return;
	      var options = this.getMappedOptions(this.props);
	      var option = this.getClosestMatch(e.key, options);
	      if (option !== null) {
	        this.setState({ value: option.value, selectedOptions: option }, function () {
	          // Scroll to selected item
	          var listElement = _this2.dropDownRef.getElementsByClassName('drop__menu-list')[0].getElementsByClassName('drop__option--is-selected')[0];
	
	          var isIExplorer = navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1;
	          var isEdge = navigator.userAgent.indexOf('Edge') > -1;
	          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	          if (isIExplorer || isEdge || isSafari) {
	            listElement.scrollIntoView(false);
	          } else {
	            listElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	          }
	        });
	      }
	    }
	
	    /**
	     * Gets the closest matching option for a given character (match against beginning character of each word in option labels.)
	     * @param {String} char
	     * @param {*} options
	     */
	
	  }, {
	    key: 'getClosestMatch',
	    value: function getClosestMatch(char, options) {
	      char = char.toLowerCase();
	      if (options.filter(function (x) {
	        return Array.isArray(x.options) && x.options.length > 0;
	      })) {
	        options = options.concat(options.filter(function (x) {
	          return Array.isArray(x.options) && x.options.length > 0;
	        }).flatMap(function (x) {
	          return x.options;
	        }));
	      }
	      var labels = options.map(function (o) {
	        return o.label.toLowerCase();
	      });
	
	      var maxLength = 0;
	      for (var i = 0; i < labels.length; i++) {
	        var words = labels[i].split(' ');
	        labels[i] = words.reduce(function (combined, word) {
	          return combined + word.substr(0, 1);
	        }, '');
	        if (labels[i].length > maxLength) {
	          maxLength = labels[i].length;
	        }
	      }
	
	      for (var l = 0; l < maxLength; l++) {
	        for (var _i = 0; _i < options.length; _i++) {
	          if (labels[_i].substr(l, 1) === char) {
	            return options[_i];
	          }
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getMappedOptions',
	    value: function getMappedOptions(props) {
	      var children = props.children,
	          options = props.options;
	      // console.log('DropDown', { children, options })
	
	      if (!children) {
	        return options;
	      }
	
	      var mapOption = function mapOption(_ref) {
	        var _ref$props = _ref.props,
	            children = _ref$props.children,
	            props = _objectWithoutProperties(_ref$props, ['children']);
	
	        return _extends({ label: children }, props);
	      };
	      var mapGroup = function mapGroup(_ref2) {
	        var _ref2$props = _ref2.props,
	            label = _ref2$props.label,
	            children = _ref2$props.children,
	            props = _objectWithoutProperties(_ref2$props, ['label', 'children']);
	
	        var groupOptions = [];
	
	        if (children) {
	          // Map all the groups options to objects
	          groupOptions = children.reduce(objectifyChild, []);
	        }
	
	        return _extends({
	          label: label,
	          options: groupOptions
	        }, props);
	      };
	
	      var objectifyChild = function objectifyChild(mapped, child) {
	        if (!child) {
	          return mapped;
	        }
	
	        // Is group
	        if (child.type === 'optgroup') {
	          return [].concat(_toConsumableArray(mapped), [mapGroup(child)]);
	        }
	
	        if (Array.isArray(child)) {
	          // Map all array values to objects
	          return [].concat(_toConsumableArray(mapped), _toConsumableArray(child.reduce(objectifyChild, [])));
	        }
	
	        return [].concat(_toConsumableArray(mapped), [mapOption(child)]);
	      };
	
	      // Objectify all the children
	      return children.reduce(objectifyChild, []);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      console.log('DropDown onChange triggered!', e);
	      if (this.props.onChange !== null) {
	        this.props.onChange(e);
	
	        if (!this.props.isMulti) {
	          this.toggleOpen();
	        }
	      }
	    }
	  }, {
	    key: 'toggleOpen',
	    value: function toggleOpen() {
	      var _this3 = this;
	
	      var isOpen = !this.state.isOpen;
	      if (typeof this.props.onOpenChange === 'function') {
	        this.props.onOpenChange(this.props.name, isOpen);
	      }
	
	      if (isOpen) {
	        // Determine position of options after dom render
	        setTimeout(function () {
	          var openOnTop = _this3.dropDownRef && window.innerHeight - _this3.dropDownRef.getBoundingClientRect().bottom < 300;
	          var modalContent = document.getElementsByClassName('modal--content')[0];
	          if (modalContent) {
	            var modalContentBottom = modalContent.getBoundingClientRect().bottom;
	            var spaceAbove = _this3.dropDownRef.getBoundingClientRect().top - modalContent.getBoundingClientRect().top;
	            var spaceBelow = modalContent.getBoundingClientRect().bottom - _this3.dropDownRef.getBoundingClientRect().bottom;
	
	            // console.log('spaceAbove: ', spaceAbove, 'spaceBelow: ', spaceBelow, '(spaceBelow > spaceAbove) = ', spaceBelow > spaceAbove)
	            openOnTop = openOnTop || modalContentBottom && modalContentBottom - _this3.dropDownRef.getBoundingClientRect().bottom < 300;
	
	            if (spaceBelow > spaceAbove) {
	              openOnTop = false;
	            }
	          }
	
	          _this3.setState({
	            openOnTop: openOnTop
	          });
	        }, 150);
	      }
	
	      this.setState({
	        isOpen: isOpen,
	        activatorStateClass: isOpen ? 'drop__activator--is-focused' : ''
	      });
	    }
	  }, {
	    key: 'isSelected',
	    value: function isSelected(option) {
	      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (value === null) {
	        value = this.state.value;
	      }
	      if (value === null) return false;
	
	      if (this.props.isMulti) {
	        return value.findIndex(function (opt) {
	          return opt === option.value;
	        }) > -1;
	      } else {
	        // if (value === option.value) console.log('DROPDOWN - value, option.value ', value, option.value)
	        return value === option.value;
	      }
	    }
	  }, {
	    key: 'findSelectedOptions',
	    value: function findSelectedOptions(options) {
	      var _this4 = this;
	
	      var selectedValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (!options) return [];
	      // console.log('DROPDOWN - selectedValues ', selectedValues)
	
	      if (this.props.isGrouping) {
	        // Filter groups to return selected values
	        var selectedOptions = options.reduce(function (selected, group) {
	          var filtered = selected;
	
	          if (group.options) {
	            filtered = [].concat(_toConsumableArray(selected), _toConsumableArray(group.options.filter(function (opt) {
	              return _this4.isSelected(opt, selectedValues);
	            })));
	          } else {
	            if (_this4.isSelected(group, selectedValues)) {
	              filtered = [].concat(_toConsumableArray(selected), [group]);
	            }
	          }
	
	          return filtered;
	        }, []);
	
	        return selectedOptions;
	      } else if (this.props.isMulti) {
	        return options.filter(function (opt) {
	          return _this4.isSelected(opt, selectedValues);
	        });
	      } else {
	        return options.find(function (opt) {
	          return _this4.isSelected(opt, selectedValues);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          activatorStateClass = _state.activatorStateClass,
	          selectedOptions = _state.selectedOptions;
	      var _props2 = this.props,
	          name = _props2.name,
	          options = _props2.options,
	          disabled = _props2.disabled,
	          children = _props2.children,
	          labelText = _props2.labelText,
	          helpText = _props2.helpText,
	          isMulti = _props2.isMulti,
	          isGrouping = _props2.isGrouping,
	          isSearchable = _props2.isSearchable;
	
	      if (options === null && !children) return null;
	
	      // console.log('DropDown', { name, options, children, selectedOptions })
	
	      var isOpen = this.state.isOpen;
	
	
	      var renderDropDown = function renderDropDown() {
	        var getLabel = function getLabel() {
	          var getSelected = function getSelected() {
	            if (!selectedOptions) return '';
	
	            if ((isMulti || isGrouping) && Array.isArray(selectedOptions)) {
	              return [].concat(_toConsumableArray(new Set(selectedOptions.map(function (opt) {
	                return opt.label;
	              })))).join(', ');
	            }
	
	            return selectedOptions.label;
	          };
	
	          // Get selected label OR first of options
	          var label = getSelected() || _this5.state.options.length > 0 && _this5.state.options[0].label;
	          if (!label && label !== '') return 'Select...';
	          return label;
	        };
	        var content = [_react2.default.createElement(_Activator2.default, {
	          classNamePrefix: 'drop',
	          className: activatorStateClass,
	          disabled: disabled,
	          onClick: _this5.toggleOpen,
	          labelText: getLabel(),
	          size: _this5.props.size,
	          style: { minWidth: _this5.props.minWidth },
	          key: 0
	        }), _react2.default.createElement(_SelectBox2.default, {
	          name: name,
	          value: selectedOptions,
	          disabled: disabled,
	          isMulti: isMulti,
	          isSearchable: isSearchable,
	          options: _this5.state.options,
	          isSelected: _this5.isSelected,
	          onChange: _this5.onChange,
	          show: isOpen,
	          openOnTop: _this5.state.openOnTop,
	          key: 1
	        })];
	
	        return _react2.default.createElement(
	          'div',
	          { ref: _this5.setRef, className: _this5.getStyle() },
	          _this5.state.openOnTop ? content.reverse() : content
	        );
	      };
	
	      var renderWrapper = function renderWrapper(content) {
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          {
	            labelText: labelText,
	            helpText: helpText
	          },
	          content
	        );
	      };
	
	      return this.props.labelText !== null ? renderWrapper(renderDropDown()) : renderDropDown();
	    }
	  }]);
	
	  return DropDown;
	}(_react.Component);
	
	DropDown.defaultProps = {
	  size: 'l',
	  style: 'default',
	  labelText: null,
	  helpText: null,
	  onChange: null,
	  value: null,
	  options: null,
	  disabled: false,
	  isMulti: false,
	  isGrouping: false,
	  spacing: 0,
	  minWidth: null
	};
	
	exports.default = DropDown;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1602);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Label = function (_Component) {
	  _inherits(Label, _Component);
	
	  function Label(props) {
	    _classCallCheck(this, Label);
	
	    var _this = _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Label, [{
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return 'size-large';
	        case 'm':
	          return 'size-medium';
	        case 's':
	          return 'size-small';
	      }
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-label ' + this.getSizeClass();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      if (typeof children === 'number') children = (0, _helpers.translation)(children);
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        children
	      );
	    }
	  }]);
	
	  return Label;
	}(_react.Component);
	
	Label.defaultProps = {
	  size: 's'
	};
	
	exports.default = Label;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @module actions/common
	                                                                                                                                                                                                                                                                   */
	
	
	exports.setHelpIconPopupUpdates = setHelpIconPopupUpdates;
	exports.setPopups = setPopups;
	exports.getPopups = getPopups;
	exports.isPopupOpen = isPopupOpen;
	exports.isPopupOnTop = isPopupOnTop;
	exports.openPopup = openPopup;
	exports.closePopup = closePopup;
	exports.closeAllPopups = closeAllPopups;
	exports.setOverlays = setOverlays;
	exports.getOverlays = getOverlays;
	exports.isOverlayOpen = isOverlayOpen;
	exports.isOverlayOnTop = isOverlayOnTop;
	exports.openOverlay = openOverlay;
	exports.closeOverlay = closeOverlay;
	exports.closeAllOverlays = closeAllOverlays;
	exports.setSlidePanels = setSlidePanels;
	exports.getSlidePanels = getSlidePanels;
	exports.isSlidePanelOpen = isSlidePanelOpen;
	exports.isSlidePanelOnTop = isSlidePanelOnTop;
	exports.openSlidePanel = openSlidePanel;
	exports.closeSlidePanel = closeSlidePanel;
	exports.closeAllSlidePanels = closeAllSlidePanels;
	exports.setPageTitle = setPageTitle;
	exports.setPageTitleExtra = setPageTitleExtra;
	exports.setHeaderInfo = setHeaderInfo;
	exports.setPhoneCodes = setPhoneCodes;
	exports.setVehicleLookupServices = setVehicleLookupServices;
	exports.setBrands = setBrands;
	exports.setEnums = setEnums;
	exports.setCountries = setCountries;
	exports.getBrands = getBrands;
	exports.getEnums = getEnums;
	exports.getHeaderInfo = getHeaderInfo;
	exports.getCustomerLanguage = getCustomerLanguage;
	exports.getShopLanguage = getShopLanguage;
	exports.getSubscriptions = getSubscriptions;
	exports.getSupportLink = getSupportLink;
	
	var _lodash = __webpack_require__(27);
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Sets entire helpicon popup stack
	 * @param {Number} number
	 */
	function setHelpIconPopupUpdates(number) {
	  return {
	    type: _constants.SET_HELPICON_POPUP_UPDATES,
	    number: number
	  };
	}
	
	/**
	 * Sets entire popup stack
	 * @param {Array} popups
	 */
	function setPopups(popups) {
	  return {
	    type: _constants.SET_POPUPS,
	    popups: popups
	  };
	}
	
	/**
	 * Gets entire popup stack
	 */
	function getPopups() {
	  return function (dispatch, getState) {
	    return getState().common.popups;
	  };
	}
	
	/**
	 * Checks if a popupId is on the open stack
	 * @param {String} popupId
	 */
	function isPopupOpen(popupId) {
	  return function (dispatch) {
	    var popups = dispatch(getPopups());
	    for (var i = 0; i < popups.length; i++) {
	      var popup = popups[i];
	      if (popup.id === popupId) return true;
	    }
	    return false;
	  };
	}
	
	/**
	 * Checks if a popupId is on top of the stack
	 * @param {String} popupId
	 */
	function isPopupOnTop(popupId) {
	  return function (dispatch) {
	    var popups = dispatch(getPopups());
	    return popups[popups.length - 1].id === popupId;
	  };
	}
	
	/**
	 * Pushes a popupId on to the open stack
	 * @param {String} popupId
	 */
	function openPopup(popupId) {
	  return function (dispatch) {
	    if (!dispatch(isPopupOpen(popupId))) {
	      var popups = dispatch(getPopups());
	      popups.push({ id: popupId });
	      console.log('Open popup: ', popupId);
	      dispatch(setPopups(popups));
	    }
	  };
	}
	
	/**
	 * Pops a popupId from the open stack if it is the first in line (ensures popups are handled in the correct order)
	 * @param {String} popupId
	 * @param {bool} force Forces the popupId to be removed from the stack wherever it may be in the order.
	 */
	function closePopup(popupId, force) {
	  return function (dispatch) {
	    var popups = dispatch(getPopups());
	    if (popups.length === 0) return;
	    for (var i = 0; i < popups.length; i++) {
	      var popup = popups[i];
	      if (popup.id === popupId && (force || i === popups.length - 1)) {
	        popups.splice(i, 1);
	        console.log('Close popup: ', popupId);
	        dispatch(setPopups(popups));
	      }
	    }
	  };
	}
	
	function closeAllPopups() {
	  return function (dispatch) {
	    dispatch(setPopups([]));
	  };
	}
	
	/**
	 * Sets entire overlay stack
	 * @param {Array} overlays
	 */
	function setOverlays(overlays) {
	  return {
	    type: _constants.SET_OVERLAYS,
	    overlays: overlays
	  };
	}
	
	/**
	 * Gets entire overlay stack
	 */
	function getOverlays() {
	  return function (dispatch, getState) {
	    return getState().common.overlays;
	  };
	}
	
	/**
	 * Checks if a overlayId is on the open stack
	 * @param {String} overlayId
	 */
	function isOverlayOpen(overlayId) {
	  return function (dispatch) {
	    var overlays = dispatch(getOverlays());
	    for (var i = 0; i < overlays.length; i++) {
	      var overlay = overlays[i];
	      if (overlay.id === overlayId) {
	        return true;
	      }
	    }
	    return false;
	  };
	}
	
	/**
	 * Checks if a overlayId is on top of the stack
	 * @param {String} overlayId
	 */
	function isOverlayOnTop(overlayId) {
	  return function (dispatch) {
	    var overlays = dispatch(getOverlays());
	    return overlays[overlays.length - 1].id === overlayId;
	  };
	}
	
	/**
	 * Pushes a overlayId on to the open stack
	 * @param {String} overlayId
	 */
	function openOverlay(overlayId) {
	  return function (dispatch) {
	    if (!dispatch(isOverlayOpen(overlayId))) {
	      var overlays = dispatch(getOverlays());
	      overlays.push({ id: overlayId });
	      console.log('Open overlay: ', overlayId);
	      dispatch(setOverlays(overlays));
	    }
	  };
	}
	
	/**
	 * Pops a overlayId from the open stack if it is the first in line (ensures overlays are handled in the correct order)
	 * @param {String} overlayId
	 * @param {bool} force Forces the overlayId to be removed from the stack wherever it may be in the order.
	 */
	function closeOverlay(overlayId, force) {
	  return function (dispatch) {
	    var overlays = dispatch(getOverlays());
	    if (overlays.length === 0) return;
	    for (var i = 0; i < overlays.length; i++) {
	      var overlay = overlays[i];
	      if (overlay.id === overlayId && (force || i === overlays.length - 1)) {
	        overlays.splice(i, 1);
	        console.log('Close overlay: ', overlayId);
	        dispatch(setOverlays(overlays));
	      }
	    }
	  };
	}
	
	function closeAllOverlays() {
	  return function (dispatch) {
	    dispatch(setOverlays([]));
	  };
	}
	
	/**
	 * Sets entire slidePanel stack
	 * @param {Array} slidePanels
	 */
	function setSlidePanels(slidePanels) {
	  return {
	    type: _constants.SET_SLIDEPANELS,
	    slidePanels: slidePanels
	  };
	}
	
	/**
	 * Gets entire slidePanel stack
	 */
	function getSlidePanels() {
	  return function (dispatch, getState) {
	    return getState().common.slidePanels;
	  };
	}
	
	/**
	 * Checks if a slidePanelId is on the open stack
	 * @param {String} slidePanelId
	 */
	function isSlidePanelOpen(slidePanelId) {
	  return function (dispatch) {
	    var slidePanels = dispatch(getSlidePanels());
	    for (var i = 0; i < slidePanels.length; i++) {
	      var slidePanel = slidePanels[i];
	      if (slidePanel.id === slidePanelId) return true;
	    }
	    return false;
	  };
	}
	
	/**
	 * Checks if a slidePanelId is on top of the stack
	 * @param {String} slidePanelId
	 */
	function isSlidePanelOnTop(slidePanelId) {
	  return function (dispatch) {
	    var slidePanels = dispatch(getSlidePanels());
	    return slidePanels[slidePanels.length - 1].id === slidePanelId;
	  };
	}
	
	/**
	 * Pushes a slidePanelId on to the open stack
	 * @param {String} slidePanelId
	 */
	function openSlidePanel(slidePanelId) {
	  return function (dispatch) {
	    if (!dispatch(isSlidePanelOpen(slidePanelId))) {
	      var slidePanels = dispatch(getSlidePanels());
	      slidePanels.push({ id: slidePanelId });
	      console.log('Open slidePanel: ', slidePanelId);
	      dispatch(setSlidePanels(slidePanels));
	    }
	  };
	}
	
	/**
	 * Pops a slidePanelId from the open stack if it is the first in line (ensures slidePanels are handled in the correct order)
	 * @param {String} slidePanelId
	 * @param {bool} force Forces the slidePanelId to be removed from the stack wherever it may be in the order.
	 */
	function closeSlidePanel(slidePanelId, force) {
	  return function (dispatch) {
	    var slidePanels = dispatch(getSlidePanels());
	    if (slidePanels.length === 0) return;
	    for (var i = 0; i < slidePanels.length; i++) {
	      var slidePanel = slidePanels[i];
	      if (slidePanel.id === slidePanelId && (force || i === slidePanels.length - 1)) {
	        slidePanels.splice(i, 1);
	        console.log('Close slidePanel: ', slidePanelId);
	        dispatch(setSlidePanels(slidePanels));
	      }
	    }
	  };
	}
	
	function closeAllSlidePanels() {
	  return function (dispatch) {
	    dispatch(setSlidePanels([]));
	  };
	}
	
	/**
	 * Sets the page header
	 * @param {Object} titleData {title, icon}
	 */
	function setPageTitle(titleData) {
	  return function (dispatch, getState) {
	    if (typeof titleData.title === 'function') {
	      titleData = _extends({}, titleData, {
	        title: titleData.title(getState().auth.departmentType)
	      });
	    }
	
	    if (!(0, _lodash.isEqual)(getState().common.pageTitle)) {
	      dispatch({
	        type: _constants.SET_PAGE_TITLE,
	        pageTitle: titleData
	      });
	    }
	  };
	}
	
	function setPageTitleExtra(extra) {
	  return function (dispatch, getState) {
	    if (getState().common.pageTitle.extra !== extra) {
	      dispatch({
	        type: _constants.SET_PAGE_TITLE_EXTRA,
	        pageTitleExtra: extra
	      });
	    }
	  };
	}
	
	/**
	 * @description Sets header information
	 * @return {Promise} Axios promise
	 */
	function setHeaderInfo(type, name, data) {
	  return function (dispatch) {
	    dispatch(_defineProperty({
	      type: type
	    }, name, data));
	  };
	}
	
	/**
	 * @description Sets the phonecodes
	 * @return {Promise} Axios promise
	 */
	function setPhoneCodes(phonecodes) {
	  return {
	    type: _constants.SET_PHONECODES,
	    phonecodes: phonecodes
	  };
	}
	
	/**
	 * @description Sets the vehicleLookupServices
	 * @return {Promise} Axios promise
	 */
	function setVehicleLookupServices(vehicleLookupServices) {
	  return {
	    type: _constants.SET_VEHICLE_LOOKUP_SEVICES,
	    vehicleLookupServices: vehicleLookupServices
	  };
	}
	
	/**
	 * @description Sets the brands
	 * @return {Promise} Axios promise
	 */
	function setBrands(brands) {
	  return {
	    type: _constants.SET_BRANDS,
	    brands: brands
	  };
	}
	
	/**
	 * @description Sets the enums
	 * @return {Promise} Axios promise
	 */
	function setEnums(enums) {
	  return {
	    type: _constants.SET_ENUMS,
	    enums: enums
	  };
	}
	
	/**
	 * @description Sets the countries
	 * @return {Promise} Axios promise
	 */
	function setCountries(countries) {
	  return {
	    type: _constants.SET_COUNTRIES,
	    countries: countries
	  };
	}
	
	/**
	 * @description Getting brands from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	function getBrands() {
	  var url = _constants.API_URL + '/Brand';
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_BRANDS,
	        brands: res.data
	      });
	    }, function () {
	      dispatch({
	        type: _constants.SET_BRANDS,
	        brands: [{
	          Id: 1,
	          Name: '2000'
	        }]
	      });
	    });
	  };
	}
	
	function getEnums() {
	  var url = _constants.API_URL + '/Enums/Get';
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_ENUMS,
	        enums: res.data
	      });
	      return res;
	    });
	  };
	}
	
	function getHeaderInfo(id) {
	  var url = _constants.API_URL + '/Users/GetHeaderInfo/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_HEADERINFO,
	        headerInfo: res.data
	      });
	      return res;
	    });
	  };
	}
	
	function getCustomerLanguage(customerId) {
	  var url = _constants.API_URL + '/Resources/Language/Customer/Get/' + customerId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function getShopLanguage(shopId) {
	  var url = _constants.API_URL + '/Resources/Language/Shop/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function getSubscriptions() {
	  var url = _constants.API_URL + '/Resources/Subscriptions/Get';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting supportlink from api
	 * @return {Promise} Axios promise
	 */
	function getSupportLink() {
	  var url = _constants.API_URL + '/Resources/CreateSupportLink/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _helpers = __webpack_require__(2);
	
	var _common = __webpack_require__(25);
	
	__webpack_require__(1533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Icon from '../../elements/icon'
	
	// import Null from '../../elements/null'
	// import { Icons } from '../../elements/icons'
	
	// Utils
	
	
	// import styles
	
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.router === undefined) return;
	      var pathname = this.props.router.location.pathname;
	      if (pathname.indexOf('/orders/') > -1 || pathname.indexOf('/pricecalculation/') > -1) {
	        window.onresize = this.checkForOverlaps;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.router === undefined) return;
	      var pageTitleExtra = this.props.pageTitleExtra;
	      if (pageTitleExtra !== undefined && pageTitleExtra !== null && this.props.pageTitle.extra !== pageTitleExtra) {
	        this.props.setPageTitleExtra(pageTitleExtra);
	      }
	      var pathname = this.props.router.location.pathname;
	      if (pathname.indexOf('/orders/') > -1 || pathname.indexOf('/pricecalculation/') > -1) {
	        this.checkForOverlaps();
	      }
	    }
	  }, {
	    key: 'checkForOverlaps',
	    value: function checkForOverlaps() {
	      var item = document.getElementsByClassName('header')[0];
	      if (item === undefined) return;
	
	      var text = item.getElementsByClassName('orderIdentification')[0];
	      if (text === undefined) return;
	      text = text.childNodes[1].childNodes;
	      if (text.length === 1) return;
	      text = text[1];
	
	      var navigation = item.lastChild.lastChild.childNodes[1];
	
	      if (text !== undefined && navigation !== undefined && text.getBoundingClientRect !== undefined && navigation.getBoundingClientRect !== undefined) {
	        var boundingText = text.getBoundingClientRect();
	        var boundingNavigation = navigation.getBoundingClientRect();
	
	        if (boundingText.right > boundingNavigation.left) {
	          text.style.display = 'none';
	        } else {
	          text.style.display = '';
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Extra class
	      var extraClass = '';
	      if (this.props.lightBlue) {
	        extraClass = 'lightBlue';
	      }
	      // Icon
	      var icon = '';
	      if (typeof this.props.icon !== 'undefined') {
	        icon = _react2.default.createElement('img', { src: '/images/icons/' + this.props.icon, className: 'header__icon' });
	      } else if (typeof this.props.svg !== 'undefined') {
	        icon = _react2.default.createElement('img', { src: this.props.svg, className: 'header__icon' });
	      }
	
	      var hasTitle = icon || this.props.title;
	      return _react2.default.createElement(
	        'div',
	        { className: 'header ' + extraClass },
	        this.props.renderLeftBefore !== null && _react2.default.createElement(
	          'span',
	          null,
	          this.props.renderLeftBefore()
	        ),
	        hasTitle && _react2.default.createElement(
	          'span',
	          null,
	          icon,
	          this.props.title,
	          '\xA0'
	        ),
	        this.props.renderLeft !== null && _react2.default.createElement(
	          'span',
	          null,
	          this.props.renderLeft()
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'content' },
	          this.props.children
	        ),
	        _react2.default.createElement('span', { className: 'filler' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'buttons' },
	          this.props.renderRight !== null && this.props.renderRight(),
	          this.props.renderButtons !== null && [_react2.default.createElement('span', { className: 'spacing', key: 'spacer_1' }), this.props.renderButtons()],
	          this.props.showBack && _react2.default.createElement('span', { className: 'spacing', key: 'spacer_2' }),
	          this.props.showBack && this.props.headerButtonsGoBack(this.props.router, _helpers.translation)
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	Header.propTypes = {
	  renderRight: _propTypes2.default.func
	};
	
	Header.defaultProps = {
	  renderRight: null,
	  renderLeft: null,
	  renderLeftBefore: null,
	  renderButtons: null,
	  headerButtonsGoBack: function headerButtonsGoBack(router, t) {
	    var goBack = function goBack() {
	      var routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders']);
	      if (routeItem !== null) {
	        if (routeItem.pathname === '/orders') {
	          router.replace(routeItem.pathname + '?orderid=' + router.params.orderID);
	        } else {
	          router.replace(routeItem.pathname);
	        }
	      } else {
	        router.goBack();
	      }
	    };
	    return _react2.default.createElement(_closeButton2.default, { key: 'close', onClick: goBack, ariaText: t('2060') });
	  }
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    pageTitle: state.common.pageTitle
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  setPageTitle: _common.setPageTitle,
	  setPageTitleExtra: _common.setPageTitleExtra
	})(Header);

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(683);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	var _constants = __webpack_require__(5);
	
	var _detect = __webpack_require__(102);
	
	__webpack_require__(1615);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux'
	// import { translation } from '../../../utils/helpers'
	
	
	var Radio = function (_Component) {
	  _inherits(Radio, _Component);
	
	  function Radio(props) {
	    _classCallCheck(this, Radio);
	
	    var _this = _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).call(this, props));
	
	    _this.state = {};
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Radio, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var updateComp = false;
	      if (nextProps.id !== this.props.id) {
	        updateComp = true;
	      }
	      if (nextProps.name !== this.props.name) {
	        updateComp = true;
	      }
	      if (nextProps.value !== this.props.value) {
	        updateComp = true;
	      }
	      if (nextProps.onChange !== this.props.onChange) {
	        if (this.props.onChange && nextProps.onChange) {
	          if (this.props.onChange.toString() !== nextProps.onChange.toString()) {
	            updateComp = true;
	          }
	        } else {
	          updateComp = true;
	        }
	      }
	      if (nextProps.checked !== this.props.checked) {
	        updateComp = true;
	      }
	      if (nextProps.labelText !== this.props.labelText) {
	        var npType = typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps);
	        var cpType = _typeof(this.props.labelText);
	        if (npType === cpType && (npType === 'object' || cpType === 'object')) {
	          // If we are dealing with an object, we have to check if the rendered html differs from eachother.
	          if (_react2.default.isValidElement(npType) && _react2.default.isValidElement(cpType)) {
	            if (_server2.default.renderToStaticMarkup(nextProps.labelText) !== _server2.default.renderToStaticMarkup(this.props.labelText)) {
	              updateComp = true;
	            }
	          } else {
	            updateComp = true;
	          }
	        } else {
	          updateComp = true;
	        }
	      }
	      if (nextProps.size !== this.props.size) {
	        updateComp = true;
	      }
	      if (nextProps.style !== this.props.style) {
	        updateComp = true;
	      }
	      if (nextProps.helpText !== this.props.helpText) {
	        updateComp = true;
	      }
	      if (nextProps.labelAlignment !== this.props.labelAlignment) {
	        updateComp = true;
	      }
	      if (nextProps.onClick !== this.props.onClick) {
	        if (this.props.onClick && nextProps.onClick) {
	          if (this.props.onClick.toString() !== nextProps.onClick.toString()) {
	            updateComp = true;
	          }
	        } else {
	          updateComp = true;
	        }
	      }
	      if (nextProps.disabled !== this.props.disabled) {
	        updateComp = true;
	      }
	      if (nextProps.readOnly !== this.props.readOnly) {
	        updateComp = true;
	      }
	      if (nextProps.width !== this.props.width) {
	        updateComp = true;
	      }
	      if (nextProps.spacing !== this.props.spacing) {
	        updateComp = true;
	      }
	      if (nextProps.simple !== this.props.simple) {
	        updateComp = true;
	      }
	
	      // console.log('radio', this.props.name, updateComp)
	
	      return updateComp;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      // console.log('Radio onChange triggered! ', e)
	      if (this.props.onChange !== null) {
	        this.props.onChange(e);
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      // console.log('Radio onClick triggered! ', e)
	      e.stopPropagation();
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return ' size-large';
	        case 'm':
	          return ' size-medium';
	        case 's':
	          return ' size-small';
	      }
	    }
	  }, {
	    key: 'getSolidClass',
	    value: function getSolidClass() {
	      return '';
	    }
	  }, {
	    key: 'getBorderClass',
	    value: function getBorderClass() {
	      return '';
	    }
	  }, {
	    key: 'getWidthClass',
	    value: function getWidthClass() {
	      if (this.props.width === null) return '';
	      var width = typeof this.props.width === 'number' ? width : parseInt(this.props.width);
	      return ' content-w-' + width;
	    }
	  }, {
	    key: 'getSpacingClass',
	    value: function getSpacingClass() {
	      if (this.props.simple) return '';
	
	      var spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing;
	      if (spacing === 0) return '';
	      if (spacing < 0) return ' pg-my-default';
	      return ' pg-my-' + spacing;
	    }
	  }, {
	    key: 'getIconSize',
	    value: function getIconSize() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 's':
	          return 's';
	        case 'm':
	        case 'l':
	          return 'm';
	      }
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-radio' + this.getSizeClass() + this.getSpacingClass() + this.getWidthClass() + this.getSolidClass() + this.getBorderClass();
	    }
	  }, {
	    key: 'getContainerStyle',
	    value: function getContainerStyle() {
	      if (this.props.simple) return 'container';
	
	      var containerStyles = 'container';
	
	      switch (this.props.labelAlignment) {
	        case 'r':
	          containerStyles += ' label-right';
	          break;
	        case 'l':
	          containerStyles += ' label-left';
	          break;
	      }
	
	      if (this.props.size === 'l') {
	        if (this.props.disabled) {
	          containerStyles += ' container--disabled';
	        } else if (this.props.checked) {
	          containerStyles += ' container--checked';
	        }
	      }
	
	      return containerStyles;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var simple = this.props.simple;
	
	      var iconSize = this.getIconSize();
	      var iosCustomNormal = '';
	      var iosCustomHover = '';
	      var isiPadPro = (0, _detect.isTouchDevice)() && /MacIntel/.test(navigator.platform);
	      var iosDevice = _constants.isiOS || isiPadPro;
	      if (iosDevice) {
	        iosCustomNormal = ' customIos-normal';
	        iosCustomHover = ' customIos-hover';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle(), onClick: this.onClick, 'data-value': this.props.value },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { className: this.getContainerStyle() },
	            !simple && _react2.default.createElement(
	              _label2.default,
	              null,
	              this.props.labelText
	            ),
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: this.props.id,
	              name: this.props.name,
	              value: this.props.value,
	              onChange: this.onChange,
	              checked: this.props.checked,
	              disabled: this.props.disabled,
	              readOnly: this.props.readOnly
	            }),
	            !this.props.disabled && this.props.checked && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Radio_Selected, className: 'radio-checked', size: iconSize, injectSvg: true }),
	            !this.props.disabled && !this.props.checked && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Radio_Normal, className: 'radio-normal' + iosCustomNormal, size: iconSize, injectSvg: true }),
	            this.props.disabled && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Radio_Disabled, className: 'radio-disabled', size: iconSize, injectSvg: true }),
	            this.props.disabled && this.props.checked && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Radio_SelectedDisabled, className: 'radio-checked-disabled', size: iconSize, injectSvg: true }),
	            !iosDevice && !this.props.disabled && !this.props.checked && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Radio_Hover, className: 'radio-hover' + iosCustomHover, size: iconSize, injectSvg: true })
	          )
	        ),
	        !simple && this.props.helpText && _react2.default.createElement(_helpIcon2.default, { helpText: this.props.helpText })
	      );
	    }
	  }]);
	
	  return Radio;
	}(_react.Component);
	
	Radio.defaultProps = {
	  size: 's',
	  style: 'default',
	  labelText: null,
	  helpText: null,
	  labelAlignment: 'r',
	  onChange: null,
	  onClick: null,
	  value: false,
	  checked: false,
	  disabled: false,
	  readOnly: false,
	  width: null,
	  spacing: -1,
	  simple: false
	};
	
	exports.default = Radio;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.triggerMenuAction = triggerMenuAction;
	exports.triggerPopupAction = triggerPopupAction;
	exports.triggerPopupActionBG = triggerPopupActionBG;
	exports.triggerBodyScroll = triggerBodyScroll;
	exports.triggerMenu = triggerMenu;
	exports.setInfoModal = setInfoModal;
	exports.triggerPopup = triggerPopup;
	
	var _constants = __webpack_require__(5);
	
	function triggerMenuAction(state) {
	  return {
	    type: _constants.OPEN_MENU,
	    state: state
	  };
	} /**
	   * @module actions/backdrop
	   */
	function triggerPopupAction(state) {
	  return {
	    type: _constants.OPEN_POPUP,
	    state: state
	  };
	}
	
	function triggerPopupActionBG(state) {
	  return {
	    type: _constants.OPEN_POPUP_BG,
	    state: state
	  };
	}
	
	function triggerBodyScroll(bodyScroll) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.BODY_SCROLL,
	      bodyScroll: bodyScroll
	    });
	  };
	}
	
	function triggerMenu(state) {
	  return function (dispatch) {
	    dispatch(triggerMenuAction(state));
	  };
	}
	
	function setInfoModal(content) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_INFO_MODAL,
	      content: content
	    });
	  };
	}
	
	function triggerPopup(state, type) {
	  return function (dispatch) {
	    if (type === 'bg') {
	      dispatch(triggerPopupActionBG(state));
	    } else {
	      dispatch(triggerPopupAction(state));
	    }
	  };
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(77);
	
	var _helpers = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(3);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_Component) {
	  _inherits(Portal, _Component);
	
	  function Portal(props) {
	    _classCallCheck(this, Portal);
	
	    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));
	
	    _this.portalElement = null;
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var p = this.props.portalId && document.getElementById(this.props.portalId);
	      if (!p) {
	        p = document.createElement('div');
	        p.id = this.props.portalId;
	        document.body.appendChild(p);
	      }
	      this.portalElement = p;
	      this.componentDidUpdate();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onPortalClose();
	      document.body.removeChild(this.portalElement);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var renderChild = function renderChild() {
	        if (_this2.props.dontSendT) return _react2.default.cloneElement(_this2.props.children);
	        return _react2.default.cloneElement(_this2.props.children, { t: _helpers.translation || _this2.props.t });
	      };
	      (0, _reactDom.render)(_react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _store2.default },
	        _react2.default.createElement(
	          'div',
	          { className: this.props.className },
	          renderChild()
	        )
	      ), this.portalElement);
	    }
	  }]);
	
	  return Portal;
	}(_react.Component);
	
	exports.default = Portal;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	__webpack_require__(1546);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	// import PopupHeader from '../../elements/popupHeader'
	
	// import Grid from '../../elements/grid'
	// import Inline from '../../elements/inline'
	
	
	// import { Icons } from '../../elements/icons'
	// import styles
	
	
	// Utils
	
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal(props) {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
	
	    _this.hideOnOuterClick = _this.hideOnOuterClick.bind(_this);
	    _this.state = {
	      show: props.show,
	      hideContainer: false,
	      loading: false,
	      reRender: false
	    };
	    _this.onOrientationChange = _this.onOrientationChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: 'onOrientationChange',
	    value: function onOrientationChange() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.setState({
	          reRender: true
	        });
	      }, 500);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Listen for orientation changes
	      window.addEventListener('orientationchange', this.onOrientationChange, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props, nextState) {
	      var hideContainer = false;
	      if (props.hideContainer === true) {
	        hideContainer = true;
	      }
	      if (this.state.show !== props.show) {
	        // on iPhone, try to scroll 1 pixel down to make the address and bottom bar minimize
	        if (props.show) {
	          /iPhone/i.test(navigator.userAgent) && !window.location.hash && setTimeout(function () {
	            var appNode = _reactDom2.default.findDOMNode(document.getElementById('app'));
	            // window.alert('scroll ' + appNode.scrollTop + ' ' + appNode.scrollHeight)
	            appNode.scrollTop = appNode.scrollTop + 100;
	            appNode.scrollBy(0, 1);
	            // appNode.scrollTo(appNode.scrollLeft, appNode.scrollTop + 100)
	            // window.alert('scroll ' + appNode.scrollTop)
	          }, 1000);
	        } else {
	          /iPhone/i.test(navigator.userAgent) && !window.location.hash && setTimeout(function () {
	            var appNode = _reactDom2.default.findDOMNode(document.getElementById('app'));
	            appNode.scrollBy(0, -1);
	            // appNode.scrollTop = appNode.scrollTop - 100
	          }, 500);
	        }
	      }
	      this.setState({
	        show: props.show,
	        hideContainer: hideContainer
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('orientationchange', this.onOrientationChange, false);
	    }
	  }, {
	    key: 'hideOnOuterClick',
	    value: function hideOnOuterClick(event) {
	      if (this.props.clickOutsideClose) {
	        if (event.target.dataset.modal && this.props.onClose instanceof Function) {
	          this.props.onClose(event);
	        }
	      }
	    }
	  }, {
	    key: 'isLoading',
	    value: function isLoading(loading) {
	      var _this3 = this;
	
	      this.setState({
	        loading: loading
	      }, function () {
	        if (loading) {
	          var el = _reactDom2.default.findDOMNode(_this3.refs.content);
	          el.scrollTop = 0;
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.show) return null;
	      // Translate
	      var t = _helpers.translation;
	      if (typeof t === 'undefined') t = this.props.t;
	      // Class
	      var contentClass = 'modal--content clearfix ';
	      if (this.props.overflowHidden) {
	        contentClass += 'overflowhidden';
	      }
	      // let icon = ''
	      // if (typeof this.props.icon !== 'undefined') {
	      //   icon = <img src={'/images/icons/' + this.props.icon} className='header__icon' />
	      // }
	
	      var containerClass = 'modal__container';
	      if (this.state.hideContainer) {
	        containerClass += ' hide';
	      }
	      var isLoading = this.state.loading || this.props.isLoading;
	      if (isLoading) {
	        containerClass += ' isLoading';
	      }
	
	      var modalIcon = '';
	      if (typeof this.props.icon !== 'undefined') {
	        modalIcon = _react2.default.createElement(_icon2.default, { icon: this.props.icon });
	        containerClass += ' show-icon';
	      } else if (!this.props.hideX) {
	        containerClass += ' show-icon';
	      }
	
	      var scrollOutside = function scrollOutside(e) {
	        e.persist();
	        // window.alert('scroll outside ' + e.target.classList)
	        if (e.target.classList.contains('modal__wrapper') || e.target.classList.contains('modal__center')) {
	          if (e.cancelBubble !== undefined) {
	            e.cancelBubble = true;
	          }
	          if (typeof e.stopPropagation === 'function') {
	            e.stopPropagation();
	          }
	          if (typeof e.preventDefault === 'function') {
	            e.preventDefault();
	          }
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal__wrapper', onClick: this.hideOnOuterClick, 'data-modal': 'true', onScroll: scrollOutside, onTouchMove: scrollOutside },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal__center' },
	          _react2.default.createElement(
	            'div',
	            { className: containerClass },
	            this.props.icon && _react2.default.createElement(
	              'div',
	              { className: 'icon-modal' },
	              modalIcon
	            ),
	            !this.props.hideX && _react2.default.createElement(
	              'div',
	              { className: 'hint--left modal--close', 'aria-label': t('2061') },
	              _react2.default.createElement(_closeButton2.default, { onClick: this.props.onClose })
	            ),
	            isLoading && _react2.default.createElement(
	              'div',
	              { className: 'modal__backdrop' },
	              _react2.default.createElement(
	                'span',
	                { className: 'animated-background' },
	                _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'sr-only' },
	                  t('13382'),
	                  '...'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal__scroll' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal--header' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.header
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: contentClass, ref: 'content' },
	                this.props.children
	              )
	            ),
	            this.props.bottomBarProps !== null && _react2.default.createElement(
	              'div',
	              { className: 'modal__bottomBar' },
	              _react2.default.createElement(_bottomBar2.default, _extends({
	                cancelLabelText: !this.props.hideX && (0, _helpers.translation)('1155'),
	                onCancelClick: !this.props.hideX && this.props.onClose
	              }, this.props.bottomBarProps, {
	                disabled: typeof this.props.bottomBarProps.disabled === 'function' ? this.props.bottomBarProps.disabled(this.state.loading) : this.props.bottomBarProps.disabled
	              }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.defaultProps = {
	  clickOutsideClose: true,
	  isLoading: false,
	  bottomBarProps: null
	};
	
	exports.default = Modal;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modalHeader = __webpack_require__(176);
	
	var _modalHeader2 = _interopRequireDefault(_modalHeader);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	__webpack_require__(1499);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// import styles
	
	
	var Confirm = function (_Component) {
	  _inherits(Confirm, _Component);
	
	  function Confirm(props) {
	    _classCallCheck(this, Confirm);
	
	    var _this = _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call(this, props));
	
	    _this.state = {
	      disabled: false
	    };
	    return _this;
	  }
	
	  _createClass(Confirm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        disabled: this.props.disabled === true
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // console.log('[Confirm]props', nextProps)
	      if (this.state.disabled !== nextProps.disabled) {
	        this.setState({
	          disabled: nextProps.disabled === true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var higher = this.props.higher ? 'higher' : '';
	      var disabled = this.state.disabled;
	      return _react2.default.createElement(
	        'div',
	        { className: 'confirm__modal__wrapper' },
	        _react2.default.createElement('div', { className: 'backdrop__modal ' + higher }),
	        _react2.default.createElement(
	          'div',
	          { className: 'confirm__modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'confirm__content' },
	            _react2.default.createElement(_modalHeader2.default, { text: this.props.t('13425') }),
	            _react2.default.createElement(
	              'div',
	              { className: 'pg-pb-2' },
	              this.props.renderText(this.props)
	            )
	          ),
	          _react2.default.createElement(_bottomBar2.default, {
	            disabled: disabled,
	            actionLabelText: this.props.confirmText(this.props),
	            onActionClick: function onActionClick(e) {
	              return _this2.props.confirm(e);
	            },
	            cancelLabelText: this.props.notConfirmText(this.props),
	            onCancelClick: function onCancelClick() {
	              return _this2.props.notConfirm();
	            },
	            cancelStyle: this.props.cancelStyle,
	            actionStyle: this.props.actionStyle
	          })
	        )
	      );
	    }
	  }]);
	
	  return Confirm;
	}(_react.Component);
	
	Confirm.defaultProps = {
	  renderText: function renderText(props) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      props.t('403')
	    );
	  },
	  confirmText: function confirmText(props) {
	    return props.t('47');
	  },
	  notConfirmText: function notConfirmText(props) {
	    return props.t('48');
	  }
	};
	exports.default = Confirm;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Row = function (_Component) {
	  _inherits(Row, _Component);
	
	  function Row(props) {
	    _classCallCheck(this, Row);
	
	    var _this = _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Row, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element row clearfix' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Row;
	}(_react.Component);
	
	Row.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Row);

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	__webpack_require__(1632);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Textarea = function (_Component) {
	  _inherits(Textarea, _Component);
	
	  function Textarea(props) {
	    _classCallCheck(this, Textarea);
	
	    var _this = _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props));
	
	    _this.state = {};
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Textarea, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      // console.log('Text onChange triggered! ', e)
	      if (this.props.onChange !== null) {
	        this.props.onChange(e);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      // console.log('Text onBlur triggered! ', e)
	      if (this.props.onBlur !== null) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return 'size-large';
	        case 'm':
	          return 'size-medium';
	        case 's':
	          return 'size-small';
	      }
	    }
	  }, {
	    key: 'getSolidClass',
	    value: function getSolidClass() {
	      return '';
	    }
	  }, {
	    key: 'getBorderClass',
	    value: function getBorderClass() {
	      return '';
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-textarea' + this.getSolidClass() + this.getBorderClass();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderInput = function renderInput() {
	        return _react2.default.createElement('textarea', {
	          className: _this2.getSizeClass(),
	          name: _this2.props.name,
	          value: _this2.props.value,
	          onChange: _this2.onChange,
	          onBlur: _this2.onBlur,
	          placeholder: _this2.props.placeholder,
	          disabled: _this2.props.disabled
	        });
	      };
	
	      var renderWrapper = function renderWrapper(content) {
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          {
	            labelText: _this2.props.labelText,
	            hintText: _this2.props.hintText,
	            helpText: _this2.props.helpText,
	            errorText: _this2.props.errorText
	          },
	          content
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        !this.props.simple && this.props.labelText !== null ? renderWrapper(renderInput()) : renderInput()
	      );
	    }
	  }]);
	
	  return Textarea;
	}(_react.Component);
	
	Textarea.defaultProps = {
	  size: 'l',
	  labelText: null,
	  hintText: null,
	  helpText: null,
	  onChange: null,
	  onBlur: null,
	  placeholder: '',
	  errorText: null,
	  disabled: false,
	  simple: false
	};
	
	exports.default = Textarea;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1616);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux'
	
	var RemoveButton = function (_Component) {
	  _inherits(RemoveButton, _Component);
	
	  function RemoveButton(props) {
	    _classCallCheck(this, RemoveButton);
	
	    var _this = _possibleConstructorReturn(this, (RemoveButton.__proto__ || Object.getPrototypeOf(RemoveButton)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(RemoveButton, [{
	    key: 'render',
	    value: function render() {
	      var buttonProps = _extends({}, this.props);
	      var icon = null;
	      switch (this.props.size) {
	        case 's':
	          icon = this.props.minus ? _icons.ButtonIcons.Remove_Minus_Alert_16 : _icons.ButtonIcons.Remove_Bin_Alert_16;
	          break;
	        case 'm':
	          icon = this.props.minus ? _icons.ButtonIcons.Remove_Minus_Alert_20 : _icons.ButtonIcons.Remove_Bin_Alert_20;
	          break;
	        case 'l':
	          icon = this.props.minus ? _icons.ButtonIcons.Remove_Minus_Alert_24 : _icons.ButtonIcons.Remove_Bin_Alert_24;
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-removebutton' },
	        _react2.default.createElement(
	          _button2.default,
	          buttonProps,
	          _react2.default.createElement(_icon2.default, { size: this.props.size, icon: icon, injectSvg: true })
	        )
	      );
	    }
	  }]);
	
	  return RemoveButton;
	}(_react.Component);
	
	RemoveButton.defaultProps = {
	  dimmed: true,
	  minus: false,
	  size: 'l',
	  style: 'alert',
	  spacing: 0
	
	  // RemoveButton.contextTypes = {
	  //  router: React.PropTypes.object.isRequired
	  // }
	
	  // function mapStateToProps (state) {
	  //  return {
	  //    auth: state.auth
	  //  }
	  // }
	
	  // export default connect(mapStateToProps, {
	  //
	  // })(RemoveButton)
	
	};exports.default = RemoveButton;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(338);
	
	__webpack_require__(1624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux'
	
	// Elements
	// import LabelWrapper from '../labelWrapper'
	
	
	// Watch out with importing state.common together with using this switch, it can cause problems where it does not trigger onChange()
	
	var Switch = function (_Component) {
	  _inherits(Switch, _Component);
	
	  function Switch(props) {
	    _classCallCheck(this, Switch);
	
	    var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));
	
	    _this.state = {};
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Switch, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      // console.log('Switch onChange triggered! ', e)
	      if (this.props.onChange !== null) {
	        this.props.onChange(e);
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      // console.log('Switch onClick triggered! ', e)
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return ' size-large';
	        case 'm':
	          return ' size-medium';
	        case 's':
	          return ' size-small';
	      }
	    }
	  }, {
	    key: 'getSolidClass',
	    value: function getSolidClass() {
	      return '';
	    }
	  }, {
	    key: 'getBorderClass',
	    value: function getBorderClass() {
	      return '';
	    }
	  }, {
	    key: 'getWidthClass',
	    value: function getWidthClass() {
	      if (this.props.width === null) return '';
	      var width = typeof this.props.width === 'number' ? width : parseInt(this.props.width);
	      return ' cnt-w-' + width;
	    }
	  }, {
	    key: 'getSpacingClass',
	    value: function getSpacingClass() {
	      var spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing;
	      if (spacing < 1) return '';
	      return ' pg-my-' + spacing;
	    }
	  }, {
	    key: 'getContainerStyle',
	    value: function getContainerStyle() {
	      switch (this.props.labelAlignment) {
	        case 'r':
	          return 'container label-right';
	        case 'l':
	          return 'container label-left';
	      }
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-switch' + this.getSizeClass() + this.getSpacingClass() + this.getWidthClass() + this.getSolidClass() + this.getBorderClass();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var simple = this.props.simple;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              }, className: this.getContainerStyle(), disabled: this.props.disabled },
	            !simple && _react2.default.createElement(
	              _label2.default,
	              null,
	              this.props.labelText
	            ),
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              id: this.props.id,
	              name: this.props.name,
	              value: this.props.value,
	              onChange: this.onChange.bind(this),
	              checked: this.props.checked,
	              onClick: this.onClick.bind(this),
	              disabled: this.props.disabled
	            }),
	            _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Switch_On, className: 'on', size: this.props.size, injectSvg: true }),
	            _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Switch_Off, className: 'off', size: this.props.size, injectSvg: true })
	          )
	        ),
	        !simple && this.props.helpText && _react2.default.createElement(_helpIcon2.default, { helpText: this.props.helpText })
	      );
	    }
	  }]);
	
	  return Switch;
	}(_react.Component);
	
	Switch.defaultProps = {
	  size: 's',
	  style: 'default',
	  labelText: null,
	  helpText: null,
	  labelAlignment: 'r',
	  onChange: null,
	  onClick: null,
	  value: false,
	  checked: false,
	  width: null,
	  spacing: 2,
	  simple: false
	};
	
	exports.default = Switch;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EventEmitter = __webpack_require__(2017).EventEmitter;
	var emitter = new EventEmitter();
	emitter.setMaxListeners(1000);
	
	exports.default = emitter;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1610);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders a header, optionally with an icon and/or helptext.
	 * Any child components will be aligned to the right edge of the header.
	 */
	var PanelHeader = function (_Component) {
	  _inherits(PanelHeader, _Component);
	
	  function PanelHeader(props) {
	    _classCallCheck(this, PanelHeader);
	
	    var _this = _possibleConstructorReturn(this, (PanelHeader.__proto__ || Object.getPrototypeOf(PanelHeader)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(PanelHeader, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Empty header with correct spacing in relation to other headers
	      var text = this.props.text;
	      if (typeof text === 'number') text = (0, _helpers.translation)(text);
	      var headerText = function headerText() {
	        return _react2.default.createElement(
	          'h3',
	          null,
	          '\u200B'
	        );
	      };
	      if (this.props.text) {
	        headerText = function headerText() {
	          return _react2.default.createElement(
	            'h3',
	            null,
	            text
	          );
	        };
	      }
	
	      var header = function header() {
	        return headerText();
	      };
	      if (this.props.icon !== null) {
	        header = function header() {
	          return _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [1], alignChildren: 'center', block: true },
	            _react2.default.createElement(_icon2.default, { size: 's', icon: _this2.props.icon }),
	            headerText()
	          );
	        };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-header' },
	        header(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return PanelHeader;
	}(_react.Component);
	
	PanelHeader.defaultProps = {
	  text: 'Header text',
	  icon: null,
	  helpText: null
	};
	
	exports.default = PanelHeader;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatCurrency = formatCurrency;
	exports.formatCurrency2 = formatCurrency2;
	exports.reverseFormatCurrency = reverseFormatCurrency;
	exports.reverseFormatCurrency2 = reverseFormatCurrency2;
	exports.replaceAll = replaceAll;
	/**
	 * @module utils/currency
	 */
	
	function numberFormat(number, decimals, decPoint, thousandsSep) {
	  decPoint = typeof decPoint !== 'undefined' ? decPoint : '.';
	  thousandsSep = typeof thousandsSep !== 'undefined' ? thousandsSep : ',';
	
	  var parts = number.toFixed(decimals).split('.');
	  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
	
	  return parts.join(decPoint);
	}
	
	function formatCurrency(number, decimals) {
	  if (isNaN(number)) number = 0;
	  if (typeof number === 'undefined') {
	    return 'N/A';
	  }
	  if (decimals === undefined) {
	    decimals = 2;
	  }
	  // let numb = numberFormat(number, decimals, ',', '.')
	  var numb = numberFormat(parseFloat(number), decimals, ',', '.');
	  return numb;
	  // return number.toFixed(2).replace('.', ',')
	}
	
	function formatCurrency2(number, decimals) {
	  var original = number;
	  if (number === '') return '';
	  if (typeof number === 'undefined') {
	    return 0;
	  }
	  if (number === '') return '';
	  number = number.toString();
	  var result = number;
	  if (decimals === undefined) {
	    decimals = 2;
	  }
	  if (number.indexOf('.') !== -1 || number.indexOf(',') !== -1) {
	    // If , is before . format is UK
	    if (number.indexOf(',') < number.indexOf('.')) {
	      // console.log('Number', number, ' UK format')
	      result = numberFormat(parseFloat(number), decimals, ',', '.');
	    } else {}
	    // Format is DK
	    // console.log('Number', number, ' DK format')
	    // if (number.indexOf(',') === -1) result += (',' + '0'.repeat(decimals))
	
	    // result += (',' + '0'.repeat(decimals))
	  } else {
	    if (typeof original === 'number' && decimals > 0) result += ',' + '0'.repeat(2);
	  }
	  // console.log('Was', original, 'Format', number, 'to', result)
	  return result;
	}
	
	// Formats 1.000,00 as 1000.00 (to string)
	function reverseFormatCurrency(number) {
	  if (!(typeof number === 'string' || typeof number === 'number')) return number;
	  if (typeof number === 'number') {
	    number = number.toString();
	  }
	  number = replaceAll(number, '.', '');
	  return replaceAll(number, ',', '.');
	}
	
	// Formats 1.000,00 as 1000.00 (to number)
	function reverseFormatCurrency2(number) {
	  if (typeof number === 'number') return number;
	  if (typeof number === 'undefined') return 0;
	  number = number.toString();
	  number = replaceAll(number, '.', '');
	  number = replaceAll(number, ',', '.');
	  var result = parseFloat(number);
	  if (isNaN(result)) result = 0;
	  return result;
	}
	
	function replaceAll(str, search, replacement) {
	  return str.split(search).join(replacement);
	}

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(143);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(377);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(187);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1902);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(692);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1898);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1913);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1899);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1900);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(694);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1901);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(378);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1911);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(699);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1904);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1905);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1909);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(696);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2006)();
	}


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _arrowButton = __webpack_require__(200);
	
	var _arrowButton2 = _interopRequireDefault(_arrowButton);
	
	__webpack_require__(1622);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	// Utils
	
	
	var SideMenu = function (_Component) {
	  _inherits(SideMenu, _Component);
	
	  function SideMenu(props) {
	    _classCallCheck(this, SideMenu);
	
	    var _this = _possibleConstructorReturn(this, (SideMenu.__proto__ || Object.getPrototypeOf(SideMenu)).call(this, props));
	
	    _this.state = {
	      collapsed: false,
	      filter: '',
	      showInactive: props.defaultShowInactive
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SideMenu, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value,
	          checked = _e$target.checked;
	
	
	      if (name === 'showInactive') {
	        value = checked;
	      }
	
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems() {
	      var _this2 = this;
	
	      var _props = this.props,
	          showFilter = _props.showFilter,
	          hideInactiveCheck = _props.hideInactiveCheck,
	          disableFilter = _props.disableFilter;
	
	      if (!showFilter && hideInactiveCheck || disableFilter) {
	        return this.props.children;
	      }
	
	      var _state = this.state,
	          filter = _state.filter,
	          showInactive = _state.showInactive;
	
	      var children = _react2.default.Children.toArray(this.props.children);
	
	      // Filter method
	      var filterChildren = function filterChildren(filteredChildren, child, key) {
	        var _child$props = child.props,
	            label = _child$props.label,
	            isTitle = _child$props.isTitle,
	            isFixed = _child$props.isFixed,
	            className = _child$props.className;
	
	        if (label === undefined && !isFixed && className !== 'filter') return filteredChildren;
	
	        // Filter on childs children
	        if (child.props.children) {
	          var newProps = _extends({}, child.props, {
	            key: key,
	            children: isFixed ? _react2.default.Children.toArray(child.props.children) : _react2.default.Children.toArray(child.props.children).reduce(filterChildren, [])
	          });
	
	          var withFilteredChildren = _react2.default.cloneElement(child, newProps);
	          return [].concat(_toConsumableArray(filteredChildren), [withFilteredChildren]);
	        }
	
	        // Filter on label
	        var matchesFilter = !filter || label.toLowerCase().includes(filter.toLowerCase());
	
	        // Filter on activity
	        if (isTitle || isFixed) {
	          return [].concat(_toConsumableArray(filteredChildren), [child]);
	        }
	
	        if (matchesFilter) {
	          if (_this2.props.customFilter(child.props, showInactive)) {
	            return [].concat(_toConsumableArray(filteredChildren), [child]);
	          }
	        }
	
	        return filteredChildren;
	      };
	
	      return children.reduce(filterChildren, []);
	    }
	  }, {
	    key: 'renderCollapseButton',
	    value: function renderCollapseButton() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'collapse-btn' },
	        _react2.default.createElement(_arrowButton2.default, { size: 'm', dir: this.state.collapsed ? 'right' : 'down', onClick: function onClick() {
	            _this3.setState({ collapsed: !_this3.state.collapsed });
	          } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          showFilter = _props2.showFilter,
	          hideInactiveCheck = _props2.hideInactiveCheck,
	          disableFilter = _props2.disableFilter;
	
	
	      var shouldRenderFilter = true;
	      if (!showFilter && hideInactiveCheck || disableFilter) {
	        shouldRenderFilter = false;
	      }
	
	      var onItemClick = function onItemClick(e) {
	        // Collapse menu when a side menu item is clicked
	        if (typeof e.target.classList.contains === 'function' && e.target.classList.contains('element-sidemenu-item__label')) {
	          // console.log('Clicked an item!')
	          if (!_this4.state.collapsed) {
	            _this4.setState({ collapsed: true });
	          }
	        }
	      };
	
	      var additionalCss = '';
	      if (this.state.collapsed) additionalCss = ' collapsed';
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-sidemenu' + additionalCss, onClick: onItemClick },
	        this.renderCollapseButton(),
	        shouldRenderFilter && _react2.default.createElement(
	          'div',
	          { className: 'filterOptions' },
	          showFilter && _react2.default.createElement(
	            _sideMenuCustomItem2.default,
	            null,
	            _react2.default.createElement(_text2.default, {
	              name: 'filter',
	              value: this.state.filter,
	              onChange: this.onChange
	            })
	          ),
	          !hideInactiveCheck && _react2.default.createElement(
	            _sideMenuCustomItem2.default,
	            null,
	            _react2.default.createElement(_check2.default, {
	              name: 'showInactive',
	              checked: this.state.showInactive,
	              onChange: this.onChange,
	              labelText: (0, _helpers.translation)('1859'),
	              spacing: 0
	            })
	          )
	        ),
	        this.filterItems()
	      );
	    }
	  }]);
	
	  return SideMenu;
	}(_react.Component);
	
	SideMenu.defaultProps = {
	  showFilter: true,
	  // hideFilter: false,
	  hideInactiveCheck: false,
	  disableFilter: false,
	  defaultShowInactive: false,
	  customFilter: function customFilter(props, showInactive) {
	    return showInactive || !props.inactive;
	  }
	};
	
	exports.default = SideMenu;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getContactInformation = getContactInformation;
	exports.saveContactInformation = saveContactInformation;
	exports.getPunchClockInformation = getPunchClockInformation;
	exports.savePunchClockInformation = savePunchClockInformation;
	exports.getForsiInformation = getForsiInformation;
	exports.saveForsiInformation = saveForsiInformation;
	exports.getInvoicingInformation = getInvoicingInformation;
	exports.saveInvoicingInformation = saveInvoicingInformation;
	exports.getProductNumbersReport = getProductNumbersReport;
	exports.getProductNumbers = getProductNumbers;
	exports.saveProductNumbersReport = saveProductNumbersReport;
	exports.saveProductNumbers = saveProductNumbers;
	exports.getDracarStores = getDracarStores;
	exports.saveDracarStores = saveDracarStores;
	exports.getClosingDaysInformation = getClosingDaysInformation;
	exports.saveClosingDaysInformation = saveClosingDaysInformation;
	exports.getProcessTimeInformation = getProcessTimeInformation;
	exports.saveProcessTimeInformation = saveProcessTimeInformation;
	exports.getBufferTimeDistribution = getBufferTimeDistribution;
	exports.saveBufferTimeDistribution = saveBufferTimeDistribution;
	exports.getOrderInspectionInformation = getOrderInspectionInformation;
	exports.saveOrderInspectionInformation = saveOrderInspectionInformation;
	exports.getBookingInformation = getBookingInformation;
	exports.saveBookingInformation = saveBookingInformation;
	exports.getAgreementsDeliveryInformation = getAgreementsDeliveryInformation;
	exports.getDeliveryInformation = getDeliveryInformation;
	exports.saveDeliveryInformation = saveDeliveryInformation;
	exports.getNotificationInformation = getNotificationInformation;
	exports.saveNotificationInformation = saveNotificationInformation;
	exports.getViewSettings = getViewSettings;
	exports.saveViewSettings = saveViewSettings;
	exports.getSupportAccess = getSupportAccess;
	exports.saveSupportAccess = saveSupportAccess;
	exports.getPaintToolInformation = getPaintToolInformation;
	exports.savePaintToolInformation = savePaintToolInformation;
	exports.getCarRentalInformation = getCarRentalInformation;
	exports.saveCarRentalInformation = saveCarRentalInformation;
	exports.getProcessManagementInformation = getProcessManagementInformation;
	exports.saveProcessManagementInformation = saveProcessManagementInformation;
	exports.getBookingPortalInformation = getBookingPortalInformation;
	exports.saveBookingPortalInformation = saveBookingPortalInformation;
	exports.getCarOwnerPortalInformation = getCarOwnerPortalInformation;
	exports.saveCarOwnerPortalInformation = saveCarOwnerPortalInformation;
	exports.getStatusNotificationInformation = getStatusNotificationInformation;
	exports.saveStatusNotificationInformation = saveStatusNotificationInformation;
	exports.deleteStatusNotification = deleteStatusNotification;
	exports.addStatusNotification = addStatusNotification;
	exports.getPortalStyling = getPortalStyling;
	exports.postPortalStyling = postPortalStyling;
	exports.getDataByOrderId = getDataByOrderId;
	exports.getStylePortalWeb = getStylePortalWeb;
	exports.getLogoPortalStyling = getLogoPortalStyling;
	exports.updateAllowNotifications = updateAllowNotifications;
	exports.updateNotificationRead = updateNotificationRead;
	exports.getAccountingSystemField = getAccountingSystemField;
	exports.deleteAccountingSystemField = deleteAccountingSystemField;
	exports.updateAccountingSystemField = updateAccountingSystemField;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get contact information from api
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/settings
	 */
	function getContactInformation() {
	  var url = _constants.API_URL + '/Setting/Contact/Get';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save contact information to api
	 * @return {Promise} Axios promise
	 */
	function saveContactInformation(data) {
	  var url = _constants.API_URL + '/Setting/Contact/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get punchclock information from api
	 * @return {Promise} Axios promise
	 */
	function getPunchClockInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/PunchClock/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save punchclock information to api
	 * @return {Promise} Axios promise
	 */
	function savePunchClockInformation(data) {
	  var url = _constants.API_URL + '/Setting/PunchClock/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get forsi information from api
	 * @return {Promise} Axios promise
	 */
	function getForsiInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/Forsi/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save forsi information to api
	 * @return {Promise} Axios promise
	 */
	function saveForsiInformation(data) {
	  var url = _constants.API_URL + '/Setting/Forsi/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get invoicing information from api
	 * @return {Promise} Axios promise
	 */
	function getInvoicingInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/Invoicing/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save invoicing information to api
	 * @return {Promise} Axios promise
	 */
	function saveInvoicingInformation(data) {
	  var url = _constants.API_URL + '/Setting/Invoicing/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get product numbers report information from api
	 * @return {Promise} Axios promise
	 */
	function getProductNumbersReport() {
	  var url = _constants.API_URL + '/Setting/Invoicing/ProductNumbersReport/Get/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get product numbers other information from api
	 * @return {Promise} Axios promise
	 */
	function getProductNumbers(shopId) {
	  var url = _constants.API_URL + '/Setting/Invoicing/ProductNumbers/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save product numbers report information to api
	 * @return {Promise} Axios promise
	 */
	function saveProductNumbersReport(data) {
	  var url = _constants.API_URL + '/Setting/Invoicing/ProductNumbersReport/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Save product numbers other information to api
	 * @return {Promise} Axios promise
	 */
	function saveProductNumbers(data) {
	  var url = _constants.API_URL + '/Setting/Invoicing/ProductNumbers/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get dracar company stores information from api
	 * @return {Promise} Axios promise
	 */
	function getDracarStores(shopId) {
	  var url = _constants.API_URL + '/Setting/Invoicing/DracarStores/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save dracar company stores information to api
	 * @return {Promise} Axios promise
	 */
	function saveDracarStores(data) {
	  var url = _constants.API_URL + '/Setting/Invoicing/DracarStores/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get closing days information from api
	 * @return {Promise} Axios promise
	 */
	function getClosingDaysInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/ClosingDays/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save closing days information to api
	 * @return {Promise} Axios promise
	 */
	function saveClosingDaysInformation(data) {
	  var url = _constants.API_URL + '/Setting/ClosingDays/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get process time information from api
	 * @return {Promise} Axios promise
	 */
	function getProcessTimeInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/ProcessTime/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save process time information to api
	 * @return {Promise} Axios promise
	 */
	function saveProcessTimeInformation(data) {
	  var url = _constants.API_URL + '/Setting/ProcessTime/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get BufferTime Distribution from api
	 * @return {Promise} Axios promise
	 */
	function getBufferTimeDistribution() {
	  var url = _constants.API_URL + '/Setting/BufferTimeDistribution/Get/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save BufferTime Distribution to api
	 * @return {Promise} Axios promise
	 */
	function saveBufferTimeDistribution(data) {
	  var url = _constants.API_URL + '/Setting/BufferTimeDistribution/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get order inspection information from api
	 * @return {Promise} Axios promise
	 */
	function getOrderInspectionInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/OrderInspection/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save order inspection information to api
	 * @return {Promise} Axios promise
	 */
	function saveOrderInspectionInformation(data) {
	  var url = _constants.API_URL + '/Setting/OrderInspection/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get booking information from api
	 * @return {Promise} Axios promise
	 */
	function getBookingInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/Booking/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save booking information to api
	 * @return {Promise} Axios promise
	 */
	function saveBookingInformation(data) {
	  var url = _constants.API_URL + '/Setting/Booking/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get Delivery information from api
	 * @return {Promise} Axios promise
	 */
	function getAgreementsDeliveryInformation(customerId, shopId) {
	  var url = _constants.API_URL + '/Setting/Delivery/Agreement/Get/';
	  var data = {
	    CustomerId: customerId,
	    ShopId: shopId,
	    PriceModelId: 0
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get Delivery information from api
	 * @return {Promise} Axios promise
	 */
	function getDeliveryInformation(customerId, shopId, priceModelId) {
	  var url = _constants.API_URL + '/Setting/Delivery/Get';
	  if (priceModelId === 'undefined' || priceModelId === 'null') priceModelId = 0;
	  var data = {
	    CustomerId: customerId,
	    ShopId: shopId,
	    PriceModelId: priceModelId
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Save Delivery information to api
	 * @return {Promise} Axios promise
	 */
	function saveDeliveryInformation(data) {
	  var url = _constants.API_URL + '/Setting/Delivery/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get Notification information from api
	 * @return {Promise} Axios promise
	 */
	function getNotificationInformation() {
	  var url = _constants.API_URL + '/Setting/Notification/Get/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save Notification information to api
	 * @return {Promise} Axios promise
	 */
	function saveNotificationInformation(data) {
	  var url = _constants.API_URL + '/Setting/Notification/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get ViewSetting information from api
	 * @return {Promise} Axios promise
	 */
	function getViewSettings(shopId) {
	  var url = _constants.API_URL + '/Setting/ViewSettings/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save ViewSetting information to api
	 * @return {Promise} Axios promise
	 */
	function saveViewSettings(data) {
	  var url = _constants.API_URL + '/Setting/ViewSettings/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get SupportAccess information from api
	 * @return {Promise} Axios promise
	 */
	function getSupportAccess(shopId) {
	  var url = _constants.API_URL + '/Setting/SupportAccess/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save SupportAcces information to api
	 * @return {Promise} Axios promise
	 */
	function saveSupportAccess(data) {
	  var url = _constants.API_URL + '/Setting/SupportAccess/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get PaintTool information from api
	 * @return {Promise} Axios promise
	 */
	function getPaintToolInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/PaintTool/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save PaintTool information to api
	 * @return {Promise} Axios promise
	 */
	function savePaintToolInformation(data) {
	  var url = _constants.API_URL + '/Setting/PaintTool/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get CarRental information from api
	 * @return {Promise} Axios promise
	 */
	function getCarRentalInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/CarRental/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save CarRental information to api
	 * @return {Promise} Axios promise
	 */
	function saveCarRentalInformation(data) {
	  var url = _constants.API_URL + '/Setting/CarRental/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get ProcessManagement information from api
	 * @return {Promise} Axios promise
	 */
	function getProcessManagementInformation(shopId) {
	  var url = _constants.API_URL + '/Setting/ProcessManagement/Get/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save ProcessManagement information to api
	 * @return {Promise} Axios promise
	 */
	function saveProcessManagementInformation(data) {
	  var url = _constants.API_URL + '/Setting/ProcessManagement/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get BookingPortal information from api
	 * @return {Promise} Axios promise
	 */
	function getBookingPortalInformation() {
	  var url = _constants.API_URL + '/Setting/BookingPortal/Get/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save BookingPortal information to api
	 * @return {Promise} Axios promise
	 */
	function saveBookingPortalInformation(data) {
	  var url = _constants.API_URL + '/Setting/BookingPortal/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get CarOwnerPortal information from api
	 * @return {Promise} Axios promise
	 */
	function getCarOwnerPortalInformation() {
	  var url = _constants.API_URL + '/Setting/CarOwnerPortal/Get';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save CarOwnerPortal information to api
	 * @return {Promise} Axios promise
	 */
	function saveCarOwnerPortalInformation(data) {
	  var url = _constants.API_URL + '/Setting/CarOwnerPortal/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get StatusNotification information from api
	 * @return {Promise} Axios promise
	 */
	function getStatusNotificationInformation() {
	  var url = _constants.API_URL + '/Setting/CarOwnerNotificationSettings/Get/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save StatusNotification information to api
	 * @return {Promise} Axios promise
	 */
	function saveStatusNotificationInformation(data) {
	  var url = _constants.API_URL + '/Setting/CarOwnerNotificationSettings/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Save StatusNotification information to api
	 * @return {Promise} Axios promise
	 */
	function deleteStatusNotification(data) {
	  var url = _constants.API_URL + '/Setting/CarOwnerNotificationSettings/Delete';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Save StatusNotification information to api
	 * @return {Promise} Axios promise
	 */
	function addStatusNotification() {
	  var url = _constants.API_URL + '/Setting/CarOwnerNotificationSettings/Add';
	  return function (dispatch) {
	    return _axios2.default.post(url);
	  };
	}
	
	/**
	 * @description GET Setting Portal Styling
	 * @return {Promise} Axios promise
	 */
	function getPortalStyling() {
	  return function (dispatch) {
	    return _axios2.default.get(_constants.API_URL + '/CompanyStyling/Get');
	  };
	}
	
	/**
	 * @description Save Setting Portal Styling
	 * @return {Promise} Axios promise
	 */
	function postPortalStyling(data) {
	  return function (dispatch) {
	    return _axios2.default.post(_constants.API_URL + '/CompanyStyling/Post', data);
	  };
	}
	
	/**
	 * @description get Data By OrderId
	 * @return {Promise} Axios promise
	 */
	function getDataByOrderId(id) {
	  return function (dispatch) {
	    return _axios2.default.get(_constants.API_URL + '/CarOwnerPortal/CarOwnerPortalLogging/GetAllByOrderId/' + id);
	  };
	}
	
	/**
	 * @description get Setting Portal Styling
	 * @return {Promise} Axios promise
	 */
	function getStylePortalWeb() {
	  return function (dispatch) {
	    return _axios2.default.get(_constants.API_URL + '/CompanyStyling/Get');
	  };
	}
	/**
	 * @description get logo
	 * @return {Promise} Axios promise
	 */
	function getLogoPortalStyling(id) {
	  return function (dispatch) {
	    return _axios2.default.get(_constants.API_URL + '/CompanyStyling/GetLogo');
	  };
	}
	
	/**
	 * @description set notification types (email/sms) allowed to send to car owner
	 * @return {Promise} Axios promise
	 */
	function updateAllowNotifications(data) {
	  return function (dispatch) {
	    return _axios2.default.post(_constants.API_URL + '/CarOwnerPortal/NotificationsAllowed/Post', data);
	  };
	}
	
	/**
	 * @description set IsRead OrderData
	 * @return {Promise} Axios promise
	 */
	function updateNotificationRead(data) {
	  return function (dispatch) {
	    return _axios2.default.post(_constants.API_URL + '/CarOwnerPortal/NotificationRead/Post/', data);
	  };
	}
	
	/**
	 * @description get accounting system field
	 * @return {Promise} Axios promise
	 */
	function getAccountingSystemField() {
	  return function (dispatch) {
	    return _axios2.default.get(_constants.API_URL + '/Setting/Invoicing/GetAccountingSystemField');
	  };
	}
	
	/**
	 * @description delete accounting system field
	 * @return {Promise} Axios promise
	 */
	function deleteAccountingSystemField(id) {
	  return function (dispatch) {
	    return _axios2.default.post(_constants.API_URL + '/Setting/Invoicing/DeleteAccountingSystemField/Post/' + id);
	  };
	}
	
	/**
	 * @description update accounting system field
	 * @return {Promise} Axios promise
	 */
	function updateAccountingSystemField(data) {
	  return function (dispatch) {
	    return _axios2.default.post(_constants.API_URL + '/Setting/Invoicing/UpdateAccountingSystemField/Post', data);
	  };
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1545);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	var LeftMenuContent = function (_Component) {
	  _inherits(LeftMenuContent, _Component);
	
	  function LeftMenuContent() {
	    _classCallCheck(this, LeftMenuContent);
	
	    return _possibleConstructorReturn(this, (LeftMenuContent.__proto__ || Object.getPrototypeOf(LeftMenuContent)).apply(this, arguments));
	  }
	
	  _createClass(LeftMenuContent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'left__menu__content' },
	        _react2.default.createElement(
	          'div',
	          this.props,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return LeftMenuContent;
	}(_react.Component);
	
	exports.default = LeftMenuContent;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1621);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var SideMenuItem = function (_Component) {
	  _inherits(SideMenuItem, _Component);
	
	  function SideMenuItem(props) {
	    _classCallCheck(this, SideMenuItem);
	
	    var _this = _possibleConstructorReturn(this, (SideMenuItem.__proto__ || Object.getPrototypeOf(SideMenuItem)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(SideMenuItem, [{
	    key: 'onClick',
	    value: function onClick() {
	      console.log('SideMenuItem onClick triggered!');
	      if (this.props.onClick !== null) {
	        this.props.onClick();
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return ' size-large';
	        case 'm':
	          return ' size-medium';
	        case 's':
	          return ' size-small';
	      }
	    }
	  }, {
	    key: 'getSelectedStyle',
	    value: function getSelectedStyle() {
	      return ' element-sidemenu-item__label--selected';
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var external = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var _props = this.props,
	          inactive = _props.inactive,
	          selected = _props.selected,
	          onClick = _props.onClick,
	          isTitle = _props.isTitle;
	
	      var classes = 'element-sidemenu-item__label';
	
	      if (inactive) {
	        classes += ' element-sidemenu-item__label--inactive';
	      }
	
	      if (selected) {
	        classes += this.getSelectedStyle();
	      }
	
	      if (onClick === null && !external) {
	        classes += ' element-sidemenu-item__label--dormant';
	      }
	
	      if (isTitle) {
	        classes += ' element-sidemenu-item__label--title';
	      }
	
	      return classes + this.getSizeClass();
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var _props2 = this.props,
	          label = _props2.label,
	          renderLabel = _props2.renderLabel;
	
	
	      if (renderLabel !== null) {
	        return renderLabel(label, this.getStyle(true), this.getSelectedStyle());
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle(), onClick: this.onClick },
	        label
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-sidemenu-item' },
	        this.renderLabel(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return SideMenuItem;
	}(_react.Component);
	
	SideMenuItem.defaultProps = {
	  size: 'l',
	  label: null,
	  selected: false,
	  inactive: null,
	  onClick: null,
	  isTitle: false,
	  renderLabel: null // () => {}
	};
	
	exports.default = SideMenuItem;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatetime = __webpack_require__(1774);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	__webpack_require__(1589);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var DateTime = function (_Component) {
	  _inherits(DateTime, _Component);
	
	  function DateTime(props) {
	    _classCallCheck(this, DateTime);
	
	    var _this = _possibleConstructorReturn(this, (DateTime.__proto__ || Object.getPrototypeOf(DateTime)).call(this, props));
	
	    _this.state = {};
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.renderInput = _this.renderInput.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateTime, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      // console.log('Datetime onChange triggered!', e)
	      if (this.props.onChange !== null) {
	        this.props.onChange(e);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      // console.log('Datetime onBlur triggered!', e)
	      if (this.props.onBlur !== null) {
	        this.props.onBlur(e);
	      }
	    }
	
	    // getSizeClass () {
	    //   switch (this.props.size) {
	    //     case undefined:
	    //     case null:
	    //     case 'l':
	    //       return 'size-large'
	    //     case 'm':
	    //       return 'size-medium'
	    //     case 's':
	    //       return 'size-small'
	    //   }
	    // }
	
	  }, {
	    key: 'getSolidClass',
	    value: function getSolidClass() {
	      return '';
	    }
	  }, {
	    key: 'getBorderClass',
	    value: function getBorderClass() {
	      return '';
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      if (this.props.disabled) {
	        // Disabled styling
	      } else {
	        return 'element-datetime ' + ' ' + this.getSolidClass() + ' ' + this.getBorderClass() + ' ';
	      }
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput(props, openCalendar, closeCalendar) {
	      return _react2.default.createElement(_text2.default, _extends({}, props, { onClick: openCalendar, onBlur: closeCalendar, size: this.props.size }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          inputProps = _props.inputProps,
	          disabled = _props.disabled,
	          timeFormat = _props.timeFormat,
	          closeOnSelect = _props.closeOnSelect,
	          isValidDate = _props.isValidDate,
	          timeConstraints = _props.timeConstraints,
	          labelText = _props.labelText,
	          helpText = _props.helpText;
	      var className = this.props.className;
	
	
	      var renderDatetime = function renderDatetime() {
	        if (_this2.props.alignDatePickerRight) {
	          className += ' align-rdt-right';
	        }
	
	        return _react2.default.createElement(_reactDatetime2.default, {
	          className: className,
	          value: value,
	          inputProps: inputProps,
	          onChange: _this2.onChange,
	          onBlur: _this2.onBlur,
	          disabled: disabled,
	
	          isValidDate: isValidDate,
	          dateFormat: 'DD-MM-YYYY',
	          timeFormat: timeFormat,
	          closeOnSelect: closeOnSelect,
	          renderInput: _this2.renderInput,
	          timeConstraints: timeConstraints
	        });
	      };
	
	      var renderWrapper = function renderWrapper(content) {
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          {
	            labelText: labelText,
	            helpText: helpText
	          },
	          content
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        this.props.labelText !== null ? renderWrapper(renderDatetime()) : renderDatetime()
	      );
	    }
	  }]);
	
	  return DateTime;
	}(_react.Component);
	
	DateTime.defaultProps = {
	  size: 'l',
	  style: 'default',
	  labelText: null,
	  helpText: null,
	  value: null,
	  onChange: null,
	  onBlur: null,
	  disabled: false,
	  isValidDate: function isValidDate() {
	    return true;
	  },
	  timeConstraints: null,
	  alignDatePickerRight: false
	};
	
	exports.default = DateTime;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	__webpack_require__(1630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	var TableRow = function (_Component) {
	  _inherits(TableRow, _Component);
	
	  function TableRow(props) {
	    _classCallCheck(this, TableRow);
	
	    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(TableRow, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getVariantStyle',
	    value: function getVariantStyle() {
	      var header = this.props.header;
	
	
	      if (header) {
	        return ' table-header';
	      }
	
	      return ' table-row';
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var classNames = 'element-table-row' + this.getVariantStyle();
	
	      if (this.props.className) {
	        classNames += ' ' + this.props.className;
	      }
	
	      if (this.props.selected) {
	        classNames += ' table-row--selected';
	      }
	
	      if (typeof this.props.onClick === 'function') {
	        classNames += ' table-row--clickable';
	      }
	
	      return classNames;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cols = _props.cols,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        _grid2.default,
	        {
	          align: this.props.align,
	          cols: cols,
	          className: this.getStyle(),
	          onClick: this.onClick
	        },
	        children
	      );
	    }
	  }]);
	
	  return TableRow;
	}(_react.Component);
	
	TableRow.defaultProps = {
	  header: false,
	  cols: [],
	  selected: false,
	  align: null,
	  onClick: null
	};
	
	exports.default = TableRow;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(250)('wks');
	var uid = __webpack_require__(164);
	var Symbol = __webpack_require__(44).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	var Gallery = function (_Component) {
	  _inherits(Gallery, _Component);
	
	  function Gallery(props) {
	    _classCallCheck(this, Gallery);
	
	    var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, props));
	
	    _this.state = {
	      loading: []
	    };
	    return _this;
	  }
	
	  _createClass(Gallery, [{
	    key: 'renderFile',
	    value: function renderFile(item, key) {
	      // let url = API_BASE + item.ThumbURL
	      // let fullUrl = API_BASE + item.FileURL
	      var url = _constants.FILE_STORAGE + item.ThumbURL;
	      var fullUrl = _constants.FILE_STORAGE + item.FileURL;
	      console.log('url', url);
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        _react2.default.createElement(
	          'a',
	          { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': item.FileName },
	          _react2.default.createElement('img', { src: url })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var loading = this.state.loading;
	
	      for (var j = loading.length; j < this.props.files.length; j++) {
	        loading.push(true);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'gallery clearfix' },
	        this.props.renderImage !== undefined ? this.props.files.map(this.props.renderImage) : null
	      );
	    }
	  }]);
	
	  return Gallery;
	}(_react.Component);
	
	Gallery.propTypes = {
	  renderImage: _react2.default.PropTypes.func.isRequired
	};
	
	exports.default = Gallery;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	
	  if (obj != null) {
	    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	        if (desc && (desc.get || desc.set)) {
	          Object.defineProperty(newObj, key, desc);
	        } else {
	          newObj[key] = obj[key];
	        }
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1572);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddButton = function (_Component) {
	  _inherits(AddButton, _Component);
	
	  function AddButton(props) {
	    _classCallCheck(this, AddButton);
	
	    var _this = _possibleConstructorReturn(this, (AddButton.__proto__ || Object.getPrototypeOf(AddButton)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(AddButton, [{
	    key: 'render',
	    value: function render() {
	      var buttonProps = _extends({}, this.props);
	      var icon = null;
	      switch (this.props.size) {
	        case 's':
	          icon = this.props.style === 'link' ? _icons.ButtonIcons.Add_Plus_Link_16 : _icons.ButtonIcons.Add_Plus_16;
	          break;
	        case 'm':
	          icon = this.props.style === 'link' ? _icons.ButtonIcons.Add_Plus_Link_20 : _icons.ButtonIcons.Add_Plus_20;
	          break;
	        case 'l':
	          icon = this.props.style === 'link' ? _icons.ButtonIcons.Add_Plus_Link_24 : _icons.ButtonIcons.Add_Plus_24;
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-addbutton' },
	        _react2.default.createElement(
	          _button2.default,
	          buttonProps,
	          _react2.default.createElement(_icon2.default, { size: this.props.size, icon: icon, injectSvg: true })
	        )
	      );
	    }
	  }]);
	
	  return AddButton;
	}(_react.Component);
	
	AddButton.defaultProps = {
	  size: 'l',
	  style: 'link',
	  spacing: 0
	
	  // AddButton.contextTypes = {
	  //   router: React.PropTypes.object.isRequired
	  // }
	
	};function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(AddButton);
	// export default AddButton

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1584);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CloseButton = function (_Component) {
	  _inherits(CloseButton, _Component);
	
	  function CloseButton(props) {
	    _classCallCheck(this, CloseButton);
	
	    var _this = _possibleConstructorReturn(this, (CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CloseButton, [{
	    key: 'render',
	    value: function render() {
	      var buttonProps = _extends({}, this.props);
	
	      var icon = null;
	      switch (this.props.size) {
	        case 's':
	          icon = _icons.ButtonIcons.Add_Plus_Link_16;
	          break;
	        case 'm':
	          icon = _icons.ButtonIcons.Add_Plus_Link_20;
	          break;
	        case 'l':
	          icon = _icons.ButtonIcons.Add_Plus_Link_24;
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-closebutton' },
	        _react2.default.createElement(
	          _button2.default,
	          buttonProps,
	          _react2.default.createElement(_icon2.default, { size: this.props.size, icon: icon, injectSvg: true })
	        )
	      );
	    }
	  }]);
	
	  return CloseButton;
	}(_react.Component);
	
	CloseButton.defaultProps = {
	  size: 'l',
	  style: 'link',
	  round: true,
	  spacing: 0
	};
	
	exports.default = CloseButton;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(765);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(766);
	
	var assertThisInitialized = __webpack_require__(64);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setCurrentUser = setCurrentUser;
	exports.setPrevWorkscreen = setPrevWorkscreen;
	exports.setDepartmentType = setDepartmentType;
	exports.logout = logout;
	exports.login = login;
	exports.getAuthResources = getAuthResources;
	exports.changePassword = changePassword;
	exports.changePasswordByToken = changePasswordByToken;
	exports.validatePasswordResetToken = validatePasswordResetToken;
	exports.changePincode = changePincode;
	exports.checkActionToken = checkActionToken;
	exports.submitActionToken = submitActionToken;
	exports.loginAs = loginAs;
	exports.logOutAs = logOutAs;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _setAuthorizationToken = __webpack_require__(206);
	
	var _constants = __webpack_require__(5);
	
	var _orders = __webpack_require__(21);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _actions = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Returns payload for dispatching SET_CURRENT_USER
	 * @param {Object} user Object containing user data
	 */
	/**
	 * @module actions/auth
	 */
	function setCurrentUser(user) {
	  return {
	    type: _constants.SET_CURRENT_USER,
	    user: user
	  };
	}
	function setPrevWorkscreen(workscreen) {
	  // console.log('[actions/auth] setPrevWorkscreen', workscreen)
	  return {
	    type: _constants.SET_PREV_WORKSCREEN,
	    prevWorkscreen: workscreen
	  };
	}
	
	function setDepartmentType(departmentType) {
	  return {
	    type: _constants.SET_DEPARTMENT_TYPE,
	    departmentType: departmentType
	  };
	}
	/**
	 * @description Logs out user by removing localstorage data, removing Axios authorization and dispatching setCurrentUser with empty Object
	 */
	function logout() {
	  return function (dispatch) {
	    window.localStorage.removeItem('user_token');
	    window.localStorage.removeItem('user_data');
	    window.localStorage.removeItem('user_language');
	    window.localStorage.removeItem('inactiveUsers');
	    window.localStorage.removeItem('loginAsUser');
	    window.localStorage.removeItem('filterOrderlist');
	    window.localStorage.removeItem('filterWorkscreen');
	    window.localStorage.removeItem('filterCustomer');
	    window.localStorage.removeItem('filterWP');
	    window.localStorage.removeItem('simpleSearch');
	    window.localStorage.removeItem('simplesearchWorkscreen');
	    window.localStorage.removeItem('carRentalOverviewSettings');
	    // window.localStorage.setItem('workscreen_view', null)
	    (0, _setAuthorizationToken.setAuthorizationToken)(false);
	    (0, _setAuthorizationToken.setDeviceToken)(false);
	    dispatch(setCurrentUser({}));
	    dispatch({
	      type: _constants.RESET_SIMPLESEARCH
	    });
	    dispatch({
	      type: _constants.RESET_SIMPLESEARCH_WORKSCREEN
	    });
	    // dispatch({
	    //   type: RESET_ORDER_FILTER
	    // })
	  };
	}
	
	/**
	 * @description Logs in user by adding localstorage data, setting Axios authorization and dispatching setCurrentUser with user object
	 * @param  {Object} data Object that will be posted to url
	 */
	function login(data) {
	  return function (dispatch) {
	    window.localStorage.clear();
	    // console.log('cleared local storage')
	    return _axios2.default.post(_constants.API_URL + '/Users/Login/', data).then(function (res) {
	      var token = res.data.Token;
	      window.localStorage.setItem('user_token', token);
	      window.localStorage.setItem('user_data', JSON.stringify(res.data));
	      // window.localStorage.setItem('department_type', JSON.stringify(res.data.DepartmentType))
	      // window.localStorage.setItem('user_language', 'English')
	      window.localStorage.removeItem('CapacityOverviewfilter');
	      (0, _setAuthorizationToken.setAuthorizationToken)(token);
	      (0, _setAuthorizationToken.setDeviceToken)(res.data.DeviceToken);
	      dispatch(setCurrentUser(res.data));
	      dispatch({
	        type: _constants.RESET_SIMPLESEARCH
	      });
	      // reset filters
	      if (res.data.UserType === 4) {
	        // customer
	        dispatch({
	          type: _constants.RESET_CUSTOMER_ORDER_FILTER
	        });
	      } else if (res.data.UserType === 6) {
	        // wp
	        dispatch({
	          type: _constants.RESET_WP_ORDER_FILTER
	        });
	      } else {
	        // shop
	        dispatch({
	          type: _constants.RESET_SIMPLESEARCH_WORKSCREEN
	        });
	        dispatch({
	          type: _constants.RESET_ORDERLIST_FILTER
	        });
	        dispatch({
	          type: _constants.RESET_WORKSCREEN_ORDER_FILTER
	        });
	      }
	      // dispatch({
	      //   type: RESET_ORDER_FILTER
	      // })
	
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Returns payload for dispatching SET_USER_PERMISSIONS
	 */
	function setUserPermissions(permissions) {
	  return {
	    type: _constants.SET_USER_PERMISSIONS,
	    permissions: permissions
	  };
	}
	
	function setAccountingType(AccountingSystem) {
	  return {
	    type: _constants.SET_ACCOUNTING_TYPE,
	    accountingSystem: AccountingSystem
	  };
	}
	
	function setCarRentalSystemType(CarRentalSystem) {
	  return {
	    type: _constants.SET_CAR_RENTALSYSTEM_TYPE,
	    carRentalSystem: CarRentalSystem
	  };
	}
	
	function setWorkscreen(Workscreen) {
	  return {
	    type: _constants.SET_WORKSCREEN,
	    myscreen: Workscreen
	  };
	}
	
	function setCustomers(Customers) {
	  return {
	    type: _constants.SET_CUSTOMERS,
	    customers: Customers
	  };
	}
	
	function setCompanies(Companies) {
	  return {
	    type: _constants.SET_COMPANIES,
	    companies: Companies
	  };
	}
	
	function setEmployees(Employees) {
	  return {
	    type: _constants.SET_EMPLOYEES,
	    employees: Employees
	  };
	}
	
	function setDefaultPhonecode(Phonecode) {
	  return {
	    type: _constants.SET_DEFAULT_PHONECODE,
	    phonecode: Phonecode
	  };
	}
	
	function setDefaultLanguage(Language) {
	  return {
	    type: _constants.SET_DEFAULT_LANGUAGE,
	    language: Language
	  };
	}
	
	function setCurrencyCode(CurrencyCode) {
	  return {
	    type: _constants.SET_CURRENCY_CODE,
	    currencyCode: CurrencyCode
	  };
	}
	
	function setHasPaintPartner(HasPaintPartner) {
	  return {
	    type: _constants.SET_HAS_PAINT_PARTNER,
	    hasPaintPartner: HasPaintPartner
	  };
	}
	
	function setBodyShopDefaultLeadTime(BodyShopDefaultLeadTime) {
	  return {
	    type: _constants.SET_BODY_DEFAULT_LEAD_TIME,
	    bodyShopDefaultLeadTime: BodyShopDefaultLeadTime
	  };
	}
	
	function setHasPartner(hasPartner, partnerName, partnerForsiBodyShopId) {
	  return {
	    type: _constants.SET_HAS_PARTNER,
	    hasPartner: hasPartner,
	    partnerName: partnerName,
	    partnerForsiBodyShopId: partnerForsiBodyShopId
	  };
	}
	
	function setAllowChangeDelivery(customerAllowChangeDelivery) {
	  return {
	    type: _constants.SET_ALLOW_CHANGE_DELIVERY,
	    customerAllowChangeDelivery: customerAllowChangeDelivery
	  };
	}
	
	function setAllowNoCustomer(allowNoCustomer) {
	  return {
	    type: _constants.SET_ALLOW_NO_CUSTOMER,
	    payload: allowNoCustomer || false
	  };
	}
	
	function setOrderlistUseTimePickup(useTimeForPickup) {
	  return {
	    type: _constants.SET_ORDERLIST_USE_TIME_PICUP,
	    shopUseTimeForPickupOnOrderList: useTimeForPickup
	  };
	}
	
	function setShopActivePunchclock(isActive) {
	  return {
	    type: _constants.SET_SHOP_ACTIVE_PUNCHCLOCK,
	    shopPunchClockActive: isActive
	  };
	}
	
	function setNewOrdersGrouping(grouping) {
	  return {
	    type: _constants.SET_NEW_ORDERS_GROUPING,
	    grouping: grouping
	  };
	}
	
	function setCompanyHaveAssignedESG(haveESGAssign) {
	  return {
	    type: _constants.SET_COMPANY_HAVE_ASSIGNED_ESG,
	    companyHaveAssignedESG: haveESGAssign
	  };
	}
	
	/**
	 * @description Gets the resources for logged in users
	 */
	function getAuthResources() {
	  return function (dispatch) {
	    return _axios2.default.get(_constants.API_URL + '/Resources/Token/Get').then(function (res) {
	      dispatch(setUserPermissions(res.data.Permissions));
	      if (!res.data.MyWorkScreen.Active) {
	        var storedview = Number(window.localStorage.getItem('workscreen_view'));
	        if (!isNaN(storedview) && storedview === 7) {
	          window.localStorage.setItem('workscreen_view', null);
	          _events2.default.emit('WORKSCREEN_VIEW_CHANGED', null);
	        }
	        var storedDepartment = parseInt(window.localStorage.getItem('department_type'));
	        if (parseInt(storedDepartment) !== parseInt(res.data.ShopDepartment)) {
	          var view = '1';
	          switch (parseInt(res.data.ShopDepartment)) {
	            case 0:
	              view = '0';
	              break;
	            case 1:
	              view = '2';
	              break;
	            case 2:
	              view = '1';
	              break;
	          }
	          storedview = view;
	        }
	        window.localStorage.setItem('workscreen_view', storedview);
	      } else {
	        window.localStorage.setItem('workscreen_view', '7');
	        _events2.default.emit('WORKSCREEN_VIEW_CHANGED', '7');
	      }
	      // To prevent department type to be default value for a moment on brower update
	      if (parseInt(window.localStorage.getItem('department_type')) !== res.data.ShopDepartment) {
	        window.localStorage.setItem('department_type', JSON.stringify(res.data.ShopDepartment));
	      }
	      dispatch(setAccountingType(res.data.AccountingSystem));
	      dispatch(setCarRentalSystemType(res.data.CarRentalSystem));
	      dispatch(setWorkscreen(res.data.MyWorkScreen));
	      dispatch(setCustomers(res.data.Customers));
	      dispatch(setCompanies(res.data.Companies));
	      dispatch(setEmployees(res.data.Employees));
	      dispatch(setDefaultPhonecode(res.data.DefaultPhoneCode));
	      dispatch(setDefaultLanguage(res.data.DefaultLanguage));
	      dispatch(setHasPartner(res.data.HasPartner, res.data.PartnerName, res.data.PartnerForsiBodyShopId));
	      dispatch(setDepartmentType(res.data.ShopDepartment));
	      dispatch(setAllowChangeDelivery(res.data.CustomerAllowChangeDelivery));
	      dispatch(setAllowNoCustomer(res.data.AllowNoCustomer));
	      dispatch(setOrderlistUseTimePickup(res.data.ShopUseTimeForPickupOnOrderList));
	      dispatch(setShopActivePunchclock(res.data.ShopPunchClockActive));
	      dispatch(setNewOrdersGrouping(res.data.NewOrdersGrouping));
	      dispatch(setCurrencyCode(res.data.CurrencyCode));
	      dispatch(setHasPaintPartner(res.data.HasPaintPartner));
	      dispatch(setBodyShopDefaultLeadTime(res.data.BodyShopDefaultLeadTime));
	      dispatch(setCompanyHaveAssignedESG(res.data.CompanyHaveAssignedESG));
	      if (!window.localStorage.user_language) {
	        window.localStorage.setItem('user_language', res.data.DefaultLanguage);
	        dispatch((0, _actions.setLanguageAction)(res.data.DefaultLanguage));
	      }
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Changes the password for user
	 */
	function changePassword(data) {
	  var url = _constants.API_URL + '/Users/ChangePassword';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function changePasswordByToken(token, newPassword) {
	  var url = _constants.API_URL + '/Users/ChangePasswordByToken';
	  var data = { Token: token, NewPassword: newPassword };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function validatePasswordResetToken(token) {
	  var url = _constants.API_URL + '/Users/ValidatePasswordResetToken/' + token;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Changes or sets the pincode for user
	 */
	function changePincode(data) {
	  var url = _constants.API_URL + '/Users/ChangePincode';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Check if ActivationToken exist
	 */
	function checkActionToken(data) {
	  var url = _constants.API_URL + '/Users/Token';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Post ActivationToken data
	 */
	function submitActionToken(data) {
	  var url = _constants.API_URL + '/Users/Token/Activate';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Login as another user
	 */
	function loginAs(userId, CompanyId, support, impersonate, pinCode) {
	  console.log('Called loginAs...');
	  CompanyId = typeof CompanyId === 'undefined' ? 0 : CompanyId;
	  userId = CompanyId > 0 ? 0 : userId;
	  var url = _constants.API_URL + '/Users/LoginAs';
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      UserId: userId,
	      CompanyId: CompanyId,
	      Support: support,
	      Impersonate: impersonate,
	      PinCode: pinCode
	    }).then(function (res) {
	      (0, _setAuthorizationToken.setAuthorizationToken)(res.data.Token);
	      (0, _setAuthorizationToken.setDeviceToken)(res.data.DeviceToken);
	      var ord = [];
	      dispatch((0, _orders.SetWorkscreenOrders)(ord));
	      // Call /Api/Resources/Token
	      setTimeout(function () {
	        dispatch(getAuthResources());
	      }, 50);
	      setTimeout(function () {
	        dispatch({
	          type: _constants.LOGIN_AS_USER,
	          user: res.data,
	          companyId: CompanyId
	        });
	        _events2.default.emit(_constants.UPDATE_TASKS_WORKSCREEN);
	      }, 100);
	      window.localStorage.removeItem('filterOrderlist');
	      window.localStorage.removeItem('filterWorkscreen');
	      window.localStorage.removeItem('filterCustomer');
	      window.localStorage.removeItem('filterWP');
	      window.localStorage.removeItem('simpleSearch');
	      window.localStorage.removeItem('simplesearchWorkscreen');
	      window.localStorage.removeItem('CapacityOverviewfilter');
	      setTimeout(function () {
	        dispatch({
	          type: _constants.RESET_SIMPLESEARCH
	        });
	        dispatch({
	          type: _constants.RESET_SIMPLESEARCH_WORKSCREEN
	        });
	        // reset filters
	        if (res.data.UserType === 4) {
	          // customer
	          dispatch({
	            type: _constants.RESET_CUSTOMER_ORDER_FILTER
	          });
	        } else if (res.data.UserType === 6) {
	          // wp
	          dispatch({
	            type: _constants.RESET_WP_ORDER_FILTER
	          });
	        } else {
	          // shop
	          // console.log('RESET orderlist and workscreen filters')
	          dispatch({
	            type: _constants.RESET_ORDERLIST_FILTER
	          });
	          dispatch({
	            type: _constants.RESET_WORKSCREEN_ORDER_FILTER
	          });
	        }
	        // dispatch({
	        //   type: RESET_ORDER_FILTER
	        // })
	        document.dispatchEvent(new window.CustomEvent('click', { bubbles: true, cancelable: false, view: window }));
	      }, 150);
	      return res;
	    });
	  };
	}
	
	function logOutAs(ToOriginalUser) {
	  return function (dispatch, getState) {
	    var _getState$auth = getState().auth,
	        user = _getState$auth.user,
	        inactiveUsers = _getState$auth.inactiveUsers;
	
	
	    var last = inactiveUsers[inactiveUsers.length - 1];
	    for (var i = inactiveUsers.length - 1; i >= 0; i--) {
	      var inactiveUser = inactiveUsers[i];
	      if (inactiveUser.UserType !== user.UserType) {
	        last = inactiveUser;
	        break;
	      }
	    }
	    console.log('logOutAs', inactiveUsers, last);
	
	    if (ToOriginalUser === true) {
	      last = inactiveUsers[0];
	    }
	    if (last !== undefined) {
	      last.hasLoggedInBefore = true;
	    }
	
	    if (last.UserType === 7) last.PrevWorkscreenView = 0; // If shop owner login set workscreenView to "Full screen"
	
	    // console.log('Log out - reset filters')
	    // reset filters
	    dispatch({ // customer
	      type: _constants.RESET_CUSTOMER_ORDER_FILTER
	    });
	    dispatch({ // wp
	      type: _constants.RESET_WP_ORDER_FILTER
	    });
	    dispatch({ // shop - orderlist
	      type: _constants.RESET_ORDERLIST_FILTER
	    });
	    dispatch({ // shop - workscreen
	      type: _constants.RESET_WORKSCREEN_ORDER_FILTER
	    });
	
	    // console.log('logout to', last)
	    (0, _setAuthorizationToken.setAuthorizationToken)(last.Token);
	    (0, _setAuthorizationToken.setDeviceToken)(last.DeviceToken);
	    dispatch(setCurrentUser(last));
	    dispatch(setPrevWorkscreen(last.PrevWorkscreenView));
	    dispatch({
	      type: _constants.LOGIN_AS_USER,
	      user: null,
	      newUser: last
	    });
	    dispatch({
	      type: _constants.RESET_SIMPLESEARCH
	    });
	    dispatch({
	      type: _constants.RESET_SIMPLESEARCH_WORKSCREEN
	    });
	    // dispatch({
	    //   type: RESET_ORDER_FILTER
	    // })
	    // Call /Api/Resources/Token
	    setTimeout(function () {
	      dispatch(getAuthResources());
	    }, 50);
	    return Promise.resolve();
	  };
	}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var SideMenuCustomItem = function (_Component) {
	  _inherits(SideMenuCustomItem, _Component);
	
	  function SideMenuCustomItem() {
	    _classCallCheck(this, SideMenuCustomItem);
	
	    return _possibleConstructorReturn(this, (SideMenuCustomItem.__proto__ || Object.getPrototypeOf(SideMenuCustomItem)).apply(this, arguments));
	  }
	
	  _createClass(SideMenuCustomItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-sidemenu-custom' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return SideMenuCustomItem;
	}(_react.Component);
	
	exports.default = SideMenuCustomItem;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(47)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(39);
	var IE8_DOM_DEFINE = __webpack_require__(487);
	var toPrimitive = __webpack_require__(122);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(70) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(121);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomers = getCustomers;
	exports.setActiveCustomer = setActiveCustomer;
	exports.getShopCustomers = getShopCustomers;
	exports.getCustomer = getCustomer;
	exports.CreateSaveCustomer = CreateSaveCustomer;
	exports.ValidateCVRAndPNumber = ValidateCVRAndPNumber;
	exports.updateCustomerSettings = updateCustomerSettings;
	exports.getCustomerSettings = getCustomerSettings;
	exports.getCustomerContact = getCustomerContact;
	exports.getCustomerContacts = getCustomerContacts;
	exports.CreateSaveCustomerContact = CreateSaveCustomerContact;
	exports.sendPassword = sendPassword;
	exports.getCustomerMergeInfo = getCustomerMergeInfo;
	exports.PostCustomerMergeInfo = PostCustomerMergeInfo;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting customers from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/customers
	 */
	function getCustomers(id, activeCustomerId) {
	  id = typeof id !== 'undefined' ? id : 0;
	  var url = _constants.API_URL + '/Customer/Get?companyId=' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_CUSTOMERS,
	        customers: res.data
	      });
	      if (activeCustomerId) {
	        dispatch(setActiveCustomer(activeCustomerId));
	      }
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Dispatch event to set active customer
	 * @return Action
	 */
	function setActiveCustomer(customerId) {
	  return {
	    type: _constants.SET_ACTIVE_CUSTOMER,
	    payload: customerId
	  };
	}
	
	/**
	 * @description Getting customers from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	function getShopCustomers(shopId) {
	  var url = _constants.API_URL + '/Customer/' + shopId;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_CUSTOMERS,
	        customers: res.data
	      });
	      return res;
	    });
	  };
	}
	/**
	 * @description Getting customer from API
	 * @return {Promise} Axios promise
	 */
	function getCustomer(id) {
	  var url = _constants.API_URL + '/Customer/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a customer
	 * @return {Promise} Axios promise
	 */
	function CreateSaveCustomer(data) {
	  var url = _constants.API_URL + '/Customer/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Validates CVR and PNumber if such already exists for specified Country
	 * @return {Promise} Axios promise
	 */
	function ValidateCVRAndPNumber(data) {
	  var url = _constants.API_URL + '/Customer/ValidateCvrAndPNumber';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Updating customer settings
	 * @return {Promise} Axios promise
	 */
	function updateCustomerSettings(data) {
	  var url = _constants.API_URL + '/Customer/Settings/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	/**
	 * @description Updating customer settings
	 * @return {Promise} Axios promise
	 */
	function getCustomerSettings(id) {
	  var url = _constants.API_URL + '/Customer/Settings/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting customer contact from API
	 * @return {Promise} Axios promise
	 */
	function getCustomerContact(id) {
	  var url = _constants.API_URL + '/Contact/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting customer contacts from API
	 * @return {Promise} Axios promise
	 */
	function getCustomerContacts(id) {
	  var url = _constants.API_URL + '/Contact/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a customer contact
	 * @return {Promise} Axios promise
	 */
	function CreateSaveCustomerContact(data) {
	  var url = _constants.API_URL + '/Contact/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Send password to contact
	 * @return {Promise} Axios promise
	 */
	function sendPassword(data) {
	  var url = _constants.API_URL + '/Contact/SendLogin';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description get customer merge info
	 * @return {Promise} Axios promise
	 */
	function getCustomerMergeInfo(id) {
	  var url = _constants.API_URL + '/Customer/GetCustomerMergeInfo/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description post customer merge info
	 * @return {Promise} Axios promise
	 */
	function PostCustomerMergeInfo(data) {
	  var url = _constants.API_URL + '/Customer/PostCustomerMergeInfo/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPriceLists = getPriceLists;
	exports.getPriceList = getPriceList;
	exports.updatePriceList = updatePriceList;
	exports.reorderPriceListItem = reorderPriceListItem;
	exports.getPriceInformations = getPriceInformations;
	exports.getPriceInformation = getPriceInformation;
	exports.getShopCustomerAgreement = getShopCustomerAgreement;
	exports.createPriceListFrom = createPriceListFrom;
	exports.getPriceListimports = getPriceListimports;
	exports.getPriceModelLog = getPriceModelLog;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting price lists from the API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/priceModel
	 */
	function getPriceLists(CustomerId, workProviderId) {
	  var url = _constants.API_URL + '/Pricemodel/get?CustomerId=' + CustomerId + '&workProviderId=' + workProviderId;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_PRICEMODEL_LIST,
	        pricemodels: res.data
	      });
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Getting price list from the API
	 * @return {Promise} Axios promise
	 */
	function getPriceList(id) {
	  var customerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var url = _constants.API_URL + '/PriceModel/Get/' + id;
	  if (customerId !== undefined && customerId > 0) url += '?CustomerId=' + customerId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Updates pricelist
	 * @return {Promise} Axios promise
	 */
	function updatePriceList(data) {
	  var url = _constants.API_URL + '/PriceModel/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Reorder items in price lists.
	 * @return {Promise} Axios promise
	 */
	function reorderPriceListItem(item) {
	  var url = _constants.API_URL + '/Pricemodel/SortTasks';
	  return function (dispatch) {
	    return _axios2.default.post(url, item);
	  };
	}
	
	/**
	 * @description Getting the tasks, services and extras using the API
	 * @return {Promise} Axios promise
	 */
	function getPriceInformations(type, brand, customerId, deviation, IsEstimation, isAddon, orderId, isBodyShop) {
	  var otherDamage = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
	
	  var data = {
	    type: type,
	    brand: brand,
	    customerId: customerId,
	    deviation: deviation,
	    IsOtherDamage: otherDamage,
	    IsEstimation: IsEstimation,
	    isAddon: isAddon,
	    orderId: orderId,
	    isBodyShop: isBodyShop
	  };
	  return getPriceInformation(data);
	}
	
	/**
	 * @description Getting the tasks, services and extras using the API
	 * @return {Promise} Axios promise
	 */
	function getPriceInformation(request) {
	  var url = _constants.API_URL + '/Pricemodel/Parttasks/';
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      OrderType: request.type,
	      BrandName: request.brand,
	      CustomerId: request.customerId,
	      Deviation: request.deviation,
	      IsOtherDamage: request.IsOtherDamage,
	      IsEstimation: request.IsEstimation,
	      IsAddon: request.isAddon,
	      OrderId: request.orderId,
	      IsBodyShop: request.isBodyShop
	    });
	  };
	}
	
	function getShopCustomerAgreement(id, customerId, companyId) {
	  var url = _constants.API_URL + '/PriceModel/ShopCustomers/Get/' + id + '?customerId=' + customerId + '&companyId=' + companyId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creates price list from parent.
	 * @return {Promise} Axios promise
	 */
	function createPriceListFrom(data) {
	  var url = _constants.API_URL + '/Pricemodel/Create';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Gets list of pricemodels available to inherit.
	 * @return {Promise} Axios promise
	 */
	function getPriceListimports(customerId) {
	  var url = _constants.API_URL + '/Pricemodel/imports?CustomerId=' + customerId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get price model log.
	 * @return {Promise} Axios promise
	 */
	function getPriceModelLog(id, userId, fromTime, toTime) {
	  var url = _constants.API_URL + '/PriceModel/ChangeLog';
	  return function (dispatch) {
	    var data = {
	      PriceModelId: id,
	      UserId: userId,
	      FromTime: fromTime,
	      ToTime: toTime
	    };
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1627);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableContainer = function (_Component) {
	  _inherits(TableContainer, _Component);
	
	  function TableContainer() {
	    _classCallCheck(this, TableContainer);
	
	    return _possibleConstructorReturn(this, (TableContainer.__proto__ || Object.getPrototypeOf(TableContainer)).apply(this, arguments));
	  }
	
	  _createClass(TableContainer, [{
	    key: 'getStyle',
	    value: function getStyle() {
	      var classNames = 'element-table-row-container';
	
	      if (this.props.fullWidth) {
	        classNames += ' element-table-row-container--full-width';
	      }
	      if (this.props.fullHeight) {
	        classNames += ' element-table-row-container--full-height';
	      }
	
	      return classNames;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        this.props.children
	      );
	    }
	  }]);
	
	  return TableContainer;
	}(_react.Component);
	
	TableContainer.defaultProps = {
	  fullWidth: false,
	  fullHeight: false
	};
	
	exports.default = TableContainer;

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getShops = getShops;
	exports.getPremiumShops = getPremiumShops;
	exports.getPaintShops = getPaintShops;
	exports.getShopsWithCustomers = getShopsWithCustomers;
	exports.getShop = getShop;
	exports.getShopUsers = getShopUsers;
	exports.CreateSaveShop = CreateSaveShop;
	exports.ValidateCVRAndPNumber = ValidateCVRAndPNumber;
	exports.GetPartners = GetPartners;
	exports.getPartnersForOrder = getPartnersForOrder;
	exports.GetSmallDashboard = GetSmallDashboard;
	exports.UpdateEstimationAnswer = UpdateEstimationAnswer;
	exports.GetCarRental = GetCarRental;
	exports.GetSimpleCarRentals = GetSimpleCarRentals;
	exports.UpdateCarRental = UpdateCarRental;
	exports.GetOpenCarRentalNumbers = GetOpenCarRentalNumbers;
	exports.GetCarRentalLog = GetCarRentalLog;
	exports.GetTempInoperative = GetTempInoperative;
	exports.MakeTempInoperative = MakeTempInoperative;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting employees from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/customers
	 */
	function getShops(id) {
	  id = typeof id !== 'undefined' ? id : 0;
	  var url = _constants.API_URL + '/Shop/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_CUSTOMERS,
	        shops: res.data
	      });
	      return res;
	    });
	  };
	}
	/**
	 * @description Getting premium shops for Partners from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	function getPremiumShops(id, department) {
	  id = typeof id !== 'undefined' ? id : 0;
	  var url = _constants.API_URL + '/PremiumShop/' + id;
	  if (department !== undefined && department !== null) {
	    url += '?department=' + department;
	  }
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_CUSTOMERS,
	        shops: res.data
	      });
	      return res;
	    });
	  };
	}
	/**
	 * @description Getting paint shops for Partners from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	function getPaintShops(id) {
	  id = typeof id !== 'undefined' ? id : 0;
	  var url = _constants.API_URL + '/PaintShop/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_CUSTOMERS,
	        shops: res.data
	      });
	      return res;
	    });
	  };
	}
	/**
	 * @description Getting employees from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	function getShopsWithCustomers(id) {
	  id = typeof id !== 'undefined' ? id : 0;
	  var url = _constants.API_URL + '/Shop/' + id + '?active=1';
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_CUSTOMERS,
	        shops: res.data
	      });
	      return res;
	    });
	  };
	}
	/**
	 * @description Getting customer from API
	 * @return {Promise} Axios promise
	 */
	function getShop(id) {
	  var url = _constants.API_URL + '/Shop/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting shopowner and employees
	 * @return {Promise} Axios promise
	 */
	function getShopUsers(id) {
	  var url = _constants.API_URL + '/Shop/GetShopUsers/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a customer
	 * @return {Promise} Axios promise
	 */
	function CreateSaveShop(data) {
	  var url = _constants.API_URL + '/Shop/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	/**
	 * @description Validates CVR and PNumber if such already exists for specified Country
	 * @return {Promise} Axios promise
	 */
	function ValidateCVRAndPNumber(data) {
	  var url = _constants.API_URL + '/Shop/ValidateCVRAndPNumber';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	/**
	 * @description Getting shop partners
	 * @return {Promise} Axios promise
	 */
	function GetPartners() {
	  var url = _constants.API_URL + '/Shop/Partners';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * Created by: Bjørn
	 * Date: 2018-01-17
	 * @description Getting shop partners
	 * @return {Promise} Axios promise
	 */
	function getPartnersForOrder(id) {
	  var url = _constants.API_URL + '/Shop/PartnersForOrder/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting shop small dashboard
	 * @return {Promise} Axios promise
	 */
	function GetSmallDashboard() {
	  var url = _constants.API_URL + '/Shop/Reports/SmallDashboard';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Update EstimationAnswer
	 * @return {Promise} Axios promise
	 */
	function UpdateEstimationAnswer(data) {
	  var url = _constants.API_URL + '/Shop/SetEstimationAnswer';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	/**
	 * @description Get all rental cars
	 * @return {Promise} Axios promise
	 */
	function GetCarRental(rentalCarId) {
	  var url = _constants.API_URL + '/CarRental/Get/' + rentalCarId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get all rental cars
	 * @return {Promise} Axios promise
	 */
	function GetSimpleCarRentals(id, orderId) {
	  id = typeof id !== 'undefined' ? id : 0;
	  orderId = typeof orderId !== 'undefined' ? orderId : 0;
	  var url = _constants.API_URL + '/SimpleCarRentals/Get/' + id + '/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get all rental cars
	 * @return {Promise} Axios promise
	 */
	function UpdateCarRental(editedCarRental) {
	  var url = _constants.API_URL + '/CarRentals/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, editedCarRental);
	  };
	}
	
	/**
	 * @description Get rental car numbers
	 * @return {Promise} Axios promise
	 */
	function GetOpenCarRentalNumbers() {
	  var url = _constants.API_URL + '/CarRental/GetOpenCarRentalNumbers/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get log for rental car by rentalCarId
	 * @return {Promise} Axios promise
	 */
	function GetCarRentalLog(rentalCarId) {
	  rentalCarId = typeof rentalCarId !== 'undefined' ? rentalCarId : 0;
	  var url = _constants.API_URL + '/CarRental/Log/' + rentalCarId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get rental car temporary unavailable
	 * @return {Promise} Axios promise
	 */
	function GetTempInoperative(rentalCarId) {
	  rentalCarId = typeof rentalCarId !== 'undefined' ? rentalCarId : 0;
	  var url = _constants.API_URL + '/CarRental/TempInactive/Get/' + rentalCarId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Make rental car temporary unavailable
	 * @return {Promise} Axios promise
	 */
	function MakeTempInoperative(data) {
	  var url = _constants.API_URL + '/CarRental/TempInactive/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(119);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _currency = __webpack_require__(41);
	
	__webpack_require__(1522);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// import Expand from '../../../elements/expand'
	
	/**
	 * General line rendering component for extent.
	 * 'Text' and 'Amount' can both be simple values, or functions.
	 * When 'CanExpand' is true, the line will be rendered with an arrow to allow expanding children.
	 * When 'CanExpand' is false, children will always be rendered.
	 */
	var Line = function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line(props) {
	    _classCallCheck(this, Line);
	
	    var _this = _possibleConstructorReturn(this, (Line.__proto__ || Object.getPrototypeOf(Line)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    return _this;
	  }
	
	  _createClass(Line, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var canDelete = function canDelete() {
	        if (!(_this2.props.onDelete === undefined || _this2.props.onDelete === null) && typeof _this2.props.onDelete === 'function') return true;
	        return false;
	      };
	      var renderDelete = function renderDelete() {
	        if (canDelete()) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'delete' },
	            _react2.default.createElement(_removeButton2.default, { size: 's', minus: true, onClick: _this2.props.onDelete })
	          );
	        }
	      };
	
	      var renderText = function renderText() {
	        if (_this2.props.text === undefined || _this2.props.text === null) return _react2.default.createElement('div', { className: 'text' });
	        if (typeof _this2.props.text === 'function') {
	          return _this2.props.text();
	        }
	        var css = '';
	
	        if (_this2.props.bold || _this2.props.boldText) css += ' bold';
	        if (_this2.props.subLine) {
	          css += ' subLine';
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'text' + css },
	          _this2.props.text
	        );
	      };
	
	      var renderAmount = function renderAmount() {
	        if (_this2.props.amount === undefined || _this2.props.amount === null) return null;
	        if (typeof _this2.props.amount === 'function') {
	          return _this2.props.amount();
	        }
	        var css = '';
	        if (_this2.props.bold || _this2.props.boldAmount) css += ' bold';
	        if (_this2.props.isTotal) css += ' total';
	        if (_this2.props.isBlue) css += ' blue';
	
	        // If CanExpand is true, render with arrow that allows expanding props.children
	        // (when CanExpand is true, the main amount is always rendered as non-editable)
	        if (_this2.props.canExpand) {
	          var arrowClass = _this2.state.open ? 'fa fa-chevron-up' : 'fa fa-chevron-down';
	          css += _this2.state.open ? ' canOpen isOpen' : ' canOpen';
	          var _amount = _this2.state.open && _this2.props.amountOpen !== undefined ? _this2.props.amountOpen : _this2.props.amount;
	          return _react2.default.createElement(
	            'div',
	            { className: 'amount' + css },
	            _react2.default.createElement('i', { className: arrowClass, onClick: function onClick() {
	                _this2.setState({ open: !_this2.state.open }, function () {
	                  if (_this2.props.onOpenChange !== undefined) {
	                    _this2.props.onOpenChange(_this2.props.name, _this2.state.open);
	                  }
	                });
	              } }),
	            _react2.default.createElement(
	              'span',
	              null,
	              _amount === '' || _amount === null ? '' : (0, _currency.formatCurrency)(_amount, 2)
	            )
	          );
	        }
	
	        var amount = _this2.props.noFormat ? _this2.props.amount : (0, _currency.formatCurrency)(_this2.props.amount);
	        if (amount === 'NaN') amount = '';
	        return _react2.default.createElement(
	          'div',
	          { className: 'amount' + css },
	          _react2.default.createElement(
	            'div',
	            null,
	            amount,
	            ' ',
	            _this2.props.currencyType && _this2.props.currencyType
	          )
	        );
	      };
	
	      var css = ' ';
	      var subCss = '';
	      if (this.props.spacing === true) css += 'spacing';
	      if (this.props.className !== undefined) css += ' ' + this.props.className;
	      // if (this.props.isVat) css += ' borderbuttom'   // Line component should not be specialized to this level
	      if (canDelete()) subCss += ' indent';
	      var cols = null;
	      if (this.props.subLine) {
	        cols = ['min-content', 1, 'min-content'];
	      } else {
	        cols = [1, 'min-content'];
	      }
	      return _react2.default.createElement(
	        'div',
	        { key: this.props.renderKey, className: 'extent-line clearfix' + css },
	        renderDelete(),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, align: 'center' },
	          this.props.subLine && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Indent, size: 't', injectSvg: true }),
	          renderText(),
	          this.props.hideAmount || renderAmount()
	        ),
	        this.props.children !== undefined && this.props.children !== null && (!this.props.canExpand || this.state.open) && _react2.default.createElement(
	          'div',
	          { className: 'sublines clearfix' + subCss },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Line;
	}(_react.Component);
	
	exports.default = Line;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(1576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// import { translation } from '../../../../utils/helpers'
	
	var BottomBar = function (_Component) {
	  _inherits(BottomBar, _Component);
	
	  function BottomBar(props) {
	    _classCallCheck(this, BottomBar);
	
	    var _this = _possibleConstructorReturn(this, (BottomBar.__proto__ || Object.getPrototypeOf(BottomBar)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BottomBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          center = _props.center,
	          actionStyle = _props.actionStyle,
	          cancelStyle = _props.cancelStyle,
	          actionLabelText = _props.actionLabelText,
	          onActionClick = _props.onActionClick,
	          cancelLabelText = _props.cancelLabelText,
	          onCancelClick = _props.onCancelClick;
	
	
	      var extraClass = '';
	      if (disabled) extraClass = ' disabled';
	      if (this.props.className != null) {
	        extraClass += ' ' + this.props.className;
	      }
	
	      var cancelBtn = _react2.default.createElement(_button2.default, {
	        style: cancelStyle,
	        spacing: 0,
	        size: 'l',
	        onClick: onCancelClick,
	        labelText: cancelLabelText,
	        setFocus: false
	      });
	
	      var acceptBtn = _react2.default.createElement(_button2.default, {
	        style: actionStyle,
	        spacing: 0,
	        size: 'l',
	        onClick: onActionClick,
	        disabled: disabled,
	        labelText: actionLabelText,
	        setFocus: true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-bottom-bar' + extraClass },
	        actionLabelText && !center && acceptBtn,
	        (this.props.children || center) && _react2.default.createElement(
	          'div',
	          { className: 'center-buttons' },
	          actionLabelText && center && acceptBtn,
	          this.props.children,
	          cancelLabelText && center && cancelBtn
	        ),
	        cancelLabelText && !center && _react2.default.createElement(
	          'div',
	          { className: 'right' },
	          cancelBtn
	        )
	      );
	    }
	  }]);
	
	  return BottomBar;
	}(_react.Component);
	
	BottomBar.defaultProps = {
	  disabled: false,
	  center: false,
	  actionStyle: 'primary',
	  cancelStyle: 'anchor',
	  actionLabelText: null,
	  cancelLabelText: null,
	  onActionClick: function onActionClick() {},
	  onCancelClick: function onCancelClick() {}
	};
	
	exports.default = BottomBar;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(389);
	
	var _reduxThunk = __webpack_require__(1980);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(996);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default)));
	
	exports.default = store;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1504);
	
	var _currency = __webpack_require__(41);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import PropTypes from 'prop-types'
	
	
	// Components
	
	
	var DecimalInput = function (_Component) {
	  _inherits(DecimalInput, _Component);
	
	  function DecimalInput(props) {
	    _classCallCheck(this, DecimalInput);
	
	    var _this = _possibleConstructorReturn(this, (DecimalInput.__proto__ || Object.getPrototypeOf(DecimalInput)).call(this, props));
	
	    _this.state = {
	      stringValue: (0, _currency.formatCurrency2)(props.value, _this.getDecimals()),
	      decimalValue: (0, _currency.reverseFormatCurrency2)(props.value)
	    };
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.getDecimals = _this.getDecimals.bind(_this);
	    _this.onKeyPress = _this.onKeyPress.bind(_this);
	    _this.transformValue = _this.transformValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(DecimalInput, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      this.setState({
	        stringValue: (0, _currency.formatCurrency2)(newProps.value, this.getDecimals()),
	        decimalValue: (0, _currency.reverseFormatCurrency2)(newProps.value)
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var value = this.transformValue(e.target.value, true);
	      this.setState({
	        stringValue: value,
	        decimalValue: (0, _currency.reverseFormatCurrency2)(value)
	      });
	      if (this.props.onChange !== undefined) {
	        this.props.onChange({
	          target: {
	            name: e.target.name,
	            value: value
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var shouldAdd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.setState({
	        stringValue: (0, _currency.formatCurrency2)(this.state.decimalValue, this.getDecimals())
	      });
	      if (this.props.onBlur !== undefined) {
	        this.props.onBlur({
	          name: this.props.name,
	          value: this.state.decimalValue,
	          shouldAdd: shouldAdd
	        });
	      } else {
	        console.error('DecimalInput is missing handler for onBlur. Inputs will not be handled.', this.props.name, this.state.decimalValue);
	      }
	    }
	  }, {
	    key: 'onKeyPress',
	    value: function onKeyPress(e) {
	      if (e.key === 'Enter') {
	        this.onBlur(e, true);
	      }
	    }
	  }, {
	    key: 'getDecimals',
	    value: function getDecimals() {
	      if (this.props.decimals === undefined || typeof this.props.decimals !== 'number') {
	        return 2;
	      } else {
	        return this.props.decimals;
	      }
	    }
	  }, {
	    key: 'transformValue',
	    value: function transformValue(value) {
	      var toClean = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (this.props.transformValue) {
	        return this.props.transformValue(value, toClean);
	      }
	      return value;
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(e) {
	      var endPos = e.target.value.length;
	      if (e.target.value.includes('%')) {
	        endPos -= 2;
	      }
	      e.target.setSelectionRange(0, endPos);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // let classes = this.props.className
	      // if (this.props.rightAlign) {
	      //   classes += ' decimal__rightAlign'
	      // }
	
	      return _react2.default.createElement(_text2.default, {
	        name: this.props.name,
	        value: this.transformValue(this.state.stringValue),
	        onChange: this.onInputChange,
	        onBlur: this.onBlur,
	        onKeyDown: this.onKeyPress,
	        onFocus: this.onFocus,
	        disabled: this.props.disabled,
	        labelText: this.props.labelText,
	        helpText: this.props.helpText,
	        size: this.props.size
	      });
	    }
	  }]);
	
	  return DecimalInput;
	}(_react.Component);
	
	DecimalInput.propTypes = {
	  // auth: React.PropTypes.object.isRequired,
	  name: _react2.default.PropTypes.string.isRequired
	
	  // DecimalInput.contextTypes = {
	  //   router: React.PropTypes.object.isRequired,
	  //   t: React.PropTypes.func.isRequired
	  // }
	
	};function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(DecimalInput);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(27);
	
	var _attrAccept = __webpack_require__(773);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	var _async = __webpack_require__(147);
	
	var _async2 = _interopRequireDefault(_async);
	
	__webpack_require__(1506);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	var Dropzone = function (_Component) {
	  _inherits(Dropzone, _Component);
	
	  function Dropzone(props) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props));
	
	    _this.state = {
	      isDragActive: false,
	      isDragReject: false
	    };
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onDragLeave = _this.onDragLeave.bind(_this);
	    _this.onDragEnter = _this.onDragEnter.bind(_this);
	    _this.onDragOver = _this.onDragOver.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.fileAccepted = _this.fileAccepted.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dropzone, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _lodash.isEqual)(this.props, nextProps) || !(0, _lodash.isEqual)(this.state, nextState);
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() {
	      this.refs.fileInput.click();
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave() {
	      this.setState({
	        isDragActive: false,
	        isDragReject: false
	      });
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(e) {
	      e.preventDefault();
	      try {
	        e.dataTransfer.dropEffect = 'copy';
	      } catch (err) {}
	      return false;
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(e) {
	      e.preventDefault();
	
	      var dataTransferItems = e.dataTransfer && e.dataTransfer.items ? e.dataTransfer.items : [];
	      var allFilesAccepted = this.allFilesAccepted(Array.prototype.slice.call(dataTransferItems));
	
	      this.setState({
	        isDragActive: allFilesAccepted,
	        isDragReject: !allFilesAccepted
	      });
	    }
	  }, {
	    key: 'rotateBase64',
	    value: function rotateBase64(base64Image) {
	      return new Promise(function (resolve, reject) {
	        // create an off-screen canvas
	        var offScreenCanvas = document.createElement('canvas');
	        var offScreenCanvasCtx = offScreenCanvas.getContext('2d');
	
	        // create Image
	        var img = new window.Image();
	        img.src = base64Image;
	
	        // on image load
	        img.onload = function () {
	          // set its dimension to rotated size
	          offScreenCanvas.height = img.width;
	          offScreenCanvas.width = img.height;
	
	          // rotate and draw source image into the off-screen canvas:
	          offScreenCanvasCtx.rotate(Math.PI / 2);
	          offScreenCanvasCtx.translate(0, -offScreenCanvas.width);
	          offScreenCanvasCtx.drawImage(img, 0, 0);
	
	          // encode image to data-uri with base64
	          resolve(offScreenCanvas.toDataURL('image/jpeg'));
	        };
	
	        // on image error
	        img.onerror = function (err) {
	          reject(err);
	        };
	      });
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      this.setState({
	        isDragActive: false,
	        isDragReject: false
	      });
	
	      if (this.props.onDrop) {
	        this.props.onDrop();
	      }
	
	      var droppedFiles = e.dataTransfer ? e.dataTransfer.files : e.target.files;
	      var acceptedFiles = [];
	      var rejectedFiles = [];
	
	      _async2.default.each(droppedFiles, function (file, cb) {
	        if (_this2.fileAccepted(file)) {
	          // if (this.props.accept === 'image/*') {
	          // Check if image
	          if (file.type.indexOf('image/') !== -1 && _this2.props.includeCircles) {
	            var reader = new window.FileReader();
	            reader.onloadend = function (e) {
	              var newFile = {};
	              newFile.file = file;
	              newFile.circles = [];
	              newFile.imageUrl = e.target.result;
	              newFile.rotation = 0;
	              acceptedFiles.push(newFile);
	              cb();
	            };
	            reader.readAsDataURL(file);
	          } else {
	            acceptedFiles.push(file);
	            cb();
	          }
	        } else {
	          rejectedFiles.push(file);
	          cb();
	        }
	      }, function () {
	        if (acceptedFiles.length > 0) {
	          if (_this2.props.onDropAccepted) {
	            _this2.props.onDropAccepted(acceptedFiles);
	          }
	        }
	        if (rejectedFiles.length > 0) {
	          if (_this2.props.onDropRejected) {
	            _this2.props.onDropRejected(rejectedFiles);
	          }
	        }
	        document.getElementById('dropzone_input').value = '';
	      });
	    }
	  }, {
	    key: 'fileAccepted',
	    value: function fileAccepted(file) {
	      if (this.props.accept === '*') {
	        return true;
	      }
	      return (0, _attrAccept2.default)(file, this.props.accept);
	    }
	  }, {
	    key: 'allFilesAccepted',
	    value: function allFilesAccepted(files) {
	      return files.every(this.fileAccepted);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = '';
	      var _state = this.state,
	          isDragActive = _state.isDragActive,
	          isDragReject = _state.isDragReject;
	
	
	      if (isDragActive) {
	        className += 'active';
	      }
	
	      if (isDragReject) {
	        className += ' rejected';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'dropzone ' + className, onClick: this.onClick, onDragLeave: this.onDragLeave, onDragEnter: this.onDragEnter, onDragOver: this.onDragOver, onDrop: this.onDrop },
	        _react2.default.createElement('input', { id: 'dropzone_input', style: { display: 'none' }, type: 'file', ref: 'fileInput', onChange: this.onDrop, capture: this.props.capture, multiple: true }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Dropzone;
	}(_react.Component);
	
	Dropzone.defaultProps = {
	  accept: 'application/pdf,image/jpeg,image/jpeg,image/png,image/gif,image/bmp,image/x-windows-bmp,application/mspowerpoint,application/powerpoint,application/vndms-powerpoint,application/x-mspowerpoint,application/msword,application/excel,application/vndms-excel,application/x-excel,application/x-msexcel,text/plain,application/mspowerpoint,application/vndms-powerpoint,application/rtf,application/x-rtf,text/richtext,application/wordperfect,application/x-wpwin,application/vndopenxmlformats-officedocumentspreadsheetmlsheet,application/vndopenxmlformats-officedocumentpresentationmlpresentation,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.presentation,application/vnd.oasis.opendocument.spreadsheet,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
	};
	
	exports.default = Dropzone;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	__webpack_require__(1558);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// elements
	
	
	// import styles
	
	
	var Phone = function (_Component) {
	  _inherits(Phone, _Component);
	
	  function Phone(props) {
	    _classCallCheck(this, Phone);
	
	    var _this = _possibleConstructorReturn(this, (Phone.__proto__ || Object.getPrototypeOf(Phone)).call(this, props));
	
	    _this.state = {
	      PhoneNumber: '',
	      PhoneCode: {
	        Id: 1,
	        Code: '',
	        MinNrLength: 0,
	        MaxNrLength: 0
	      }
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Phone, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var codeId = 1;
	      if (this.props.code !== null) {
	        if (typeof this.props.code.Id !== 'undefined') codeId = this.props.code.Id;
	      }
	      this.setState({
	        PhoneCode: _extends({}, this.PhoneCode, {
	          Id: codeId
	        }),
	        PhoneNumber: this.props.number
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.phonecodes.length === 0) {
	        console.log('No phone codes!', this.props);
	      }
	      var codeId = 1;
	      if (nextProps.code !== null) {
	        if (typeof nextProps.code.Id !== 'undefined') codeId = nextProps.code.Id;
	      }
	      this.setState({
	        PhoneCode: _extends({}, this.PhoneCode, {
	          Id: codeId
	        }),
	        PhoneNumber: nextProps.number
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this2 = this;
	
	      var value = e.target.value;
	      if (e.target.name === 'PhoneNumber') e.persist();
	      if (e.target.name === 'PhoneCode') {
	        value = _extends({}, this.state.phoneCode, {
	          Id: e.target.value
	        });
	      }
	      this.setState(_defineProperty({}, e.target.name, value), function () {
	        _this2.props.onChange({
	          target: {
	            name: e.target.name,
	            value: value
	          }
	        });
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      if (typeof this.props.onBlur !== 'undefined') {
	        this.props.onBlur({
	          target: {
	            name: e.target.name,
	            value: e.target.value
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderCodes = function renderCodes(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.Id },
	          val.Code
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'phone' },
	        _react2.default.createElement(
	          _inline2.default,
	          null,
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'PhoneCode', onChange: this.onInputChange, value: this.state.PhoneCode.Id, disabled: this.props.disabled || false },
	            this.props.phonecodes.map(renderCodes)
	          ),
	          _react2.default.createElement(_text2.default, { id: this.props.Id, className: this.props.PhoneNumberClassName, name: 'PhoneNumber', onChange: this.onInputChange, onBlur: this.onBlur, value: this.state.PhoneNumber, disabled: this.props.disabled || false, placeholder: this.props.placeholder })
	        )
	      );
	    }
	  }]);
	
	  return Phone;
	}(_react.Component);
	
	Phone.defaultProps = {
	  PhoneNumberClassName: ''
	};
	
	function mapStateToProps(state) {
	  return {
	    phonecodes: state.common.phonecodes
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Phone);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1567);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserInfo = function (_Component) {
	  _inherits(UserInfo, _Component);
	
	  function UserInfo() {
	    _classCallCheck(this, UserInfo);
	
	    return _possibleConstructorReturn(this, (UserInfo.__proto__ || Object.getPrototypeOf(UserInfo)).apply(this, arguments));
	  }
	
	  _createClass(UserInfo, [{
	    key: 'render',
	    value: function render() {
	      var user = this.props.user;
	
	      if (user === null || user === undefined) return _react2.default.createElement('div', null);
	      return _react2.default.createElement(
	        'div',
	        { className: 'user-info' },
	        _react2.default.createElement(
	          'div',
	          null,
	          user.Name
	        ),
	        user.CompanyName && _react2.default.createElement(
	          'div',
	          null,
	          user.CompanyName
	        )
	      );
	    }
	  }]);
	
	  return UserInfo;
	}(_react.Component);
	
	exports.default = UserInfo;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1417);
	
	var _icons = __webpack_require__(6);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// Elements
	
	
	var InspectionItem = function (_PureComponent) {
	  _inherits(InspectionItem, _PureComponent);
	
	  function InspectionItem(props) {
	    _classCallCheck(this, InspectionItem);
	
	    var _this = _possibleConstructorReturn(this, (InspectionItem.__proto__ || Object.getPrototypeOf(InspectionItem)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(InspectionItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(title) {
	      var _this2 = this;
	
	      // Image
	      var image = 'Red_marking';
	      if (this.props.checked) image = 'Green_chekmark';
	      // On Click
	      var onChangeMarking = function onChangeMarking() {
	        _this2.props.onHeaderClick();
	      };
	      var iconClass = 'icon';
	      if (title.className) iconClass = title.className;
	      // Return
	      var titleClass = 'title';
	      if (this.props.showCheckmark) titleClass += ' clicker';
	      return _react2.default.createElement(
	        'div',
	        { className: titleClass, onClick: onChangeMarking },
	        _react2.default.createElement('img', { className: iconClass, src: title.icon }),
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)(title.text)
	        ),
	        this.props.showCheckmark && _react2.default.createElement('img', { className: 'checkmark', src: '/images/icons/' + image + '.png' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var text = (0, _helpers.translation)(this.props.title.text);
	      if (this.props.noTranslation) {
	        text = this.props.title.text;
	      }
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: text },
	        this.props.showCheckmark && _react2.default.createElement(
	          _actions2.default,
	          null,
	          _react2.default.createElement(_icon2.default, {
	            icon: this.props.checked ? _icons.ElementIcons.Inspection_Check : _icons.ElementIcons.Inspection_Cancel,
	            onClick: this.props.onHeaderClick
	          })
	        ),
	        this.props.renderContent()
	      );
	    }
	  }]);
	
	  return InspectionItem;
	}(_react.PureComponent);
	
	InspectionItem.defaultProps = {
	  title: { icon: '/images/svgs/Cirkle_info-black.svg', text: 'placeholder' },
	  showCheckmark: true,
	  onHeaderClick: function onHeaderClick() {},
	  renderContent: function renderContent() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      ' content placeholder'
	    );
	  }
	};
	InspectionItem.propTypes = {
	  showCheckmark: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool,
	  title: _propTypes2.default.object.isRequired,
	  renderContent: _propTypes2.default.func.isRequired,
	  onHeaderClick: _propTypes2.default.func.isRequired
	};
	InspectionItem.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(InspectionItem);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _common = __webpack_require__(25);
	
	__webpack_require__(1595);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var HelpIcon = function (_Component) {
	  _inherits(HelpIcon, _Component);
	
	  function HelpIcon(props) {
	    _classCallCheck(this, HelpIcon);
	
	    var _this = _possibleConstructorReturn(this, (HelpIcon.__proto__ || Object.getPrototypeOf(HelpIcon)).call(this, props));
	
	    _this.state = {
	      currentUpdate: -1,
	      styleFix: {}
	    };
	
	    _this.toggleShow = _this.toggleShow.bind(_this);
	    return _this;
	  }
	
	  _createClass(HelpIcon, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.currentUpdate === this.props.updates && Object.keys(this.state.styleFix).length === 0) {
	        var fix = this.fixIsOutsideOfScreen();
	        if (Object.keys(fix).length !== 0) {
	          this.setState({
	            styleFix: fix
	          });
	        }
	      }
	    }
	  }, {
	    key: 'toggleShow',
	    value: function toggleShow(e) {
	      var _this2 = this;
	
	      e.stopPropagation(); // Doesn't work
	      // console.log('HelpIcon onClick triggered!', e)
	
	      var resetUpdate = function resetUpdate() {
	        _this2.setState({
	          currentUpdate: -1,
	          styleFix: {}
	        });
	        window.removeEventListener('click', resetUpdate);
	      };
	
	      var newUpdate = this.props.updates + 1;
	      if (this.state.currentUpdate === this.props.updates) {
	        this.setState({
	          currentUpdate: -1
	        });
	      } else {
	        this.setState({
	          currentUpdate: newUpdate
	        });
	        window.setTimeout(function () {
	          window.addEventListener('click', resetUpdate);
	        }, 10);
	      }
	
	      this.props.setHelpIconPopupUpdates(newUpdate);
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var className = 'element-help-icon';
	      if (this.props.white) className += '__white';
	      return className;
	    }
	  }, {
	    key: 'fixIsOutsideOfScreen',
	    value: function fixIsOutsideOfScreen() {
	      var elem = document.querySelector('.element-help-icon__popover');
	      var style = {};
	      if (elem !== undefined && elem !== null) {
	        var bounding = elem.getBoundingClientRect();
	        // outside of screen to right
	        if (bounding.right > (window.innerWidth || document.documentElement.clientWidth)) {
	          var moveX = window.innerWidth ? bounding.right - window.innerWidth : bounding.right - document.documentElement.clientWidth;
	          var calc = bounding.width / 2 + moveX;
	          style = { transform: 'translateX(' + -calc + 'px)' };
	        }
	        // outside of screen to left
	        if (bounding.left < 0) {
	          var _calc = bounding.width / 2 + bounding.left;
	          style = { transform: 'translateX(' + -_calc + 'px)' };
	        }
	      }
	      return style;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.helpText) return null;
	      var helpText = this.props.helpText;
	      if (typeof helpText === 'number') helpText = (0, _helpers.translation)(helpText);
	
	      // Size doesn't match standard sizes, ...nvm. added tiny
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle(), onClick: this.toggleShow },
	        _react2.default.createElement(_icon2.default, { icon: this.props.altIcon !== null ? this.props.altIcon : _icons.ElementIcons.Info, size: this.props.size, injectSvg: true }),
	        this.state.currentUpdate === this.props.updates && _react2.default.createElement(
	          'div',
	          { className: 'element-help-icon__popover', style: this.state.styleFix },
	          helpText
	        )
	      );
	    }
	  }]);
	
	  return HelpIcon;
	}(_react.Component);
	
	HelpIcon.defaultProps = {
	  size: 't',
	  helpText: null,
	  altIcon: null,
	  white: false
	};
	
	function mapStateToProps(state) {
	  return {
	    updates: state.common.helpIconPopupUpdates
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  setHelpIconPopupUpdates: _common.setHelpIconPopupUpdates
	})(HelpIcon);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1625);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var TabBar = function (_Component) {
	  _inherits(TabBar, _Component);
	
	  function TabBar(props) {
	    _classCallCheck(this, TabBar);
	
	    var _this = _possibleConstructorReturn(this, (TabBar.__proto__ || Object.getPrototypeOf(TabBar)).call(this, props));
	
	    _this.state = {
	      activeItem: null
	    };
	    return _this;
	  }
	
	  _createClass(TabBar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-tab-bar' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return TabBar;
	}(_react.Component);
	
	exports.default = TabBar;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeOrderTypeImage = makeOrderTypeImage;
	exports.makeOrderTypeIcon = makeOrderTypeIcon;
	exports.makeTransportIcon = makeTransportIcon;
	exports.makeOrderInvoiceIcon = makeOrderInvoiceIcon;
	exports.makeOrderAssessmentIcon = makeOrderAssessmentIcon;
	exports.makeOrderPageTitleObject = makeOrderPageTitleObject;
	exports.makeOrderTitle = makeOrderTitle;
	exports.getStepName = getStepName;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Makes the order type image
	 * @return {string} Returns string
	 */
	/**
	 * @module utils/order
	 */
	function makeOrderTypeImage(id, white) {
	  var image = '';
	  switch (id) {
	    case 1:
	      image = 'Insurance-black';
	      break;
	    case 2:
	      image = 'Salescar-black';
	      break;
	    case 3:
	      image = 'Garanteed-black';
	      break;
	    case 5:
	      image = 'Complaint-black';
	      break;
	    case 6:
	      image = 'Private_c-black';
	      break;
	    default:
	      image = 'Other-black';
	      break;
	  }
	  if (white) image = image.replace('black', 'white');
	  return '/images/svgs/ordrer/' + image + '.svg';
	}
	
	/**
	 * @description Makes the order type icon
	 * @return {object} Returns object
	 */
	function makeOrderTypeIcon(orderType, white) {
	  var icon = void 0;
	  switch (orderType) {
	    case 1:
	      icon = white ? _icons.OrderTypeIcons.Insurance_White : _icons.OrderTypeIcons.Insurance_Black;
	      break;
	    case 2:
	      icon = white ? _icons.OrderTypeIcons.Salescar_White : _icons.OrderTypeIcons.Salescar_Black;
	      break;
	    case 3:
	      icon = white ? _icons.OrderTypeIcons.Garanteed_White : _icons.OrderTypeIcons.Garanteed_Black;
	      break;
	    case 5:
	      icon = white ? _icons.OrderTypeIcons.Complaint_White : _icons.OrderTypeIcons.Complaint_Black;
	      break;
	    case 6:
	      icon = white ? _icons.OrderTypeIcons.Private_White : _icons.OrderTypeIcons.Private_Black;
	      break;
	    default:
	      icon = white ? _icons.OrderTypeIcons.Other_White : _icons.OrderTypeIcons.Other_Black;
	      break;
	  }
	  return icon;
	}
	
	/**
	 * @description Makes the transport type icon
	 * @return {object} Returns object
	 */
	function makeTransportIcon(id) {
	  var icon = void 0;
	  switch (id) {
	    case 1:
	      icon = _icons.TransportTypeIcons.Can_Drive;
	      break;
	    case 2:
	      icon = _icons.TransportTypeIcons.Loose_Part;
	      break;
	    default:
	      icon = _icons.TransportTypeIcons.Transport;
	      break;
	  }
	  return icon;
	}
	
	/**
	 * @description Makes the order invoice icon
	 * @return {object} Returns object
	 */
	function makeOrderInvoiceIcon(val) {
	  var icon = void 0;
	  switch (val) {
	    case 0:
	      icon = _icons.InvoiceIcons.Sent_To_Invoice;
	      break;
	    case 1:
	      icon = _icons.InvoiceIcons.Marked_As_Invoice;
	      break;
	    case 2:
	      icon = _icons.InvoiceIcons.Sent_And_Marked;
	      break;
	  }
	  return icon;
	}
	
	/**
	 * @description Makes the order assessment icon
	 * @return {object} Returns object
	 */
	function makeOrderAssessmentIcon(title, complete) {
	  var icon = void 0;
	  switch (title) {
	    case 14983:
	      // Extent
	      icon = _icons.OrderAssessmentIcons.Extent;
	      break;
	    case 2716:
	      // Awaiting, Price change sent
	      icon = _icons.OrderAssessmentIcons.Invoice_Awaiting;
	      break;
	    case 2714: // Approved
	    case 2715:
	      // Rejected
	      icon = _icons.OrderAssessmentIcons.Invoice_Approved_Rejected;
	      break;
	    case 936: // Main report
	    case 14963:
	      icon = _icons.OrderAssessmentIcons.Main_Report_Loaded;
	      break;
	    case 937: // Additional report
	    case 14916:
	      icon = _icons.OrderAssessmentIcons.Additional_Report;
	      break;
	    case 1037: // After evaluation
	    case 14962:
	      icon = _icons.OrderAssessmentIcons.After_Evaluation;
	      break;
	    case 1396:
	      // Addon price
	      icon = _icons.OrderAssessmentIcons.Addon_Price;
	      break;
	    case 13363:
	      // Estimation
	      if (complete) {
	        icon = _icons.OrderAssessmentIcons.Estimation_Complete;
	      } else {
	        icon = _icons.OrderAssessmentIcons.Estimation;
	      }
	      break;
	    case 159:
	      // Workcard
	      icon = _icons.OrderAssessmentIcons.Workcard;
	      break;
	    case 1139:
	      // Ready for invoice
	      icon = _icons.OrderAssessmentIcons.Ready_Invoice;
	      break;
	    case 13042: // Sent to invoice
	    case 15322:
	    case 15267:
	    case 14959:
	      // Resent to invoice
	      icon = _icons.OrderAssessmentIcons.Sent_To_Invoice;
	      break;
	    case 1136:
	      // Invoiced
	      icon = _icons.OrderAssessmentIcons.Invoiced;
	      break;
	    case 14958:
	      // Crediting
	      icon = _icons.OrderAssessmentIcons.Crediting;
	      break;
	    case 14960:
	      // Credit note
	      icon = _icons.OrderAssessmentIcons.Credit_Note;
	      break;
	    case 14961:
	      // Invoice
	      icon = _icons.OrderAssessmentIcons.Invoice;
	      break;
	    case 14984: // Addon
	    case 1275:
	      // Addon changed
	      icon = _icons.OrderAssessmentIcons.Addon;
	      break;
	    default:
	      icon = _icons.ElementIcons.Info_Circle;
	      break;
	  }
	  return icon;
	}
	
	function makeOrderPageTitleObject(order) {
	  var result = { icon: null, title: null };
	  if (typeof order.Id === 'undefined') return result;
	
	  var title = '';
	  result.icon = makeOrderTypeIcon(order.OrderType, true);
	
	  // RegNumber
	  if (order.RegNumber) {
	    title = order.RegNumber;
	  }
	
	  // Model
	  if (order.Model) {
	    var temp = '';
	    if (order.RegNumber) {
	      temp += ', ';
	    }
	    temp += order.Model;
	    title += temp;
	  }
	
	  // Title empty
	  if (title === '') {
	    title = order.Id + '';
	  }
	  result.title = title;
	  return result;
	}
	
	/**
	 * @description Makes the order title
	 * @param {Object} order Order object
	 * @return {string} Returns string
	 */
	function makeOrderTitle(order, t, enumKey, onlyTitle, white, includePrint) {
	  if (typeof order.Id === 'undefined') return '';
	
	  var title = '';
	  var titleReg = '';
	  var titleModel = '';
	
	  var image = makeOrderTypeImage(order.OrderType, white);
	
	  var segmented = !onlyTitle && !includePrint;
	
	  // RegNumber
	  if (order.RegNumber) {
	    if (segmented) {
	      titleReg = _react2.default.createElement(
	        'span',
	        null,
	        order.RegNumber
	      );
	    } else {
	      title = order.RegNumber;
	    }
	  }
	
	  // Model
	  if (order.Model) {
	    var temp = '';
	    if (order.RegNumber) {
	      temp += ', ';
	    }
	    temp += order.Model;
	    if (segmented) {
	      titleModel = _react2.default.createElement(
	        'span',
	        null,
	        temp
	      );
	    } else {
	      title += temp;
	    }
	  }
	
	  if (segmented) {
	    title = _react2.default.createElement(
	      'div',
	      null,
	      titleReg,
	      titleModel
	    );
	  }
	
	  // Title empty
	  if (title === '') {
	    title += order.Id;
	  }
	
	  if (onlyTitle) return title;
	
	  if (includePrint) {
	    return [_react2.default.createElement(
	      'div',
	      { className: 'orderIdentification print', key: '1' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'hint--right', 'aria-label': t(enumKey('OrderTypes', order.OrderType)) },
	          _react2.default.createElement('img', { src: makeOrderTypeImage(order.OrderType, false) })
	        )
	      ),
	      title
	    ), _react2.default.createElement(
	      'div',
	      { className: 'orderIdentification', key: '2' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'hint--right', 'aria-label': t(enumKey('OrderTypes', order.OrderType)) },
	          _react2.default.createElement('img', { src: image })
	        )
	      ),
	      title
	    )];
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'orderIdentification' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'hint--right', 'aria-label': t(enumKey('OrderTypes', order.OrderType)) },
	        _react2.default.createElement('img', { src: image })
	      )
	    ),
	    title
	  );
	}
	
	/**
	 * @description Makes the step title
	 * @return {string} Returns string
	 */
	function getStepName(id) {
	  switch (parseInt(id, 10)) {
	    case 1:
	      return 164;
	    case 2:
	      return 96;
	    case 3:
	      return 160;
	    case 4:
	      return 158;
	    case 5:
	      return 161;
	    case 6:
	      return 162;
	    case 7:
	      return 163;
	    case 8:
	      return 23;
	    case 101:
	      return 617;
	    case 102:
	      return 618;
	    case 103:
	      return 619;
	    case 104:
	      return 162;
	    case 105:
	      return 161;
	    default:
	      return '';
	  }
	}

/***/ }),
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1626);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabItem = function (_Component) {
	  _inherits(TabItem, _Component);
	
	  function TabItem(props) {
	    _classCallCheck(this, TabItem);
	
	    var _this = _possibleConstructorReturn(this, (TabItem.__proto__ || Object.getPrototypeOf(TabItem)).call(this, props));
	
	    _this.state = {};
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(TabItem, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return 'size-large';
	        case 'm':
	          return 'size-medium';
	        case 's':
	          return 'size-small';
	      }
	    }
	  }, {
	    key: 'getActiveClass',
	    value: function getActiveClass() {
	      return this.props.active ? ' active' : '';
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-tab-item ' + this.getSizeClass();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        { className: this.getStyle() },
	        this.props.children !== undefined && this.props.children !== null && this.props.children,
	        (this.props.children === undefined || this.props.children === null) && _react2.default.createElement(
	          'div',
	          { className: 'tab-item' + this.getActiveClass(), onClick: this.onClick },
	          this.props.labelText
	        )
	      );
	    }
	  }]);
	
	  return TabItem;
	}(_react.Component);
	
	TabItem.defaultProps = {
	  size: 'l',
	  labelText: null,
	  value: null,
	  name: null,
	  onClick: null,
	  active: false
	};
	
	exports.default = TabItem;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(71);
	var createDesc = __webpack_require__(160);
	module.exports = __webpack_require__(70) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(44);
	var hide = __webpack_require__(97);
	var has = __webpack_require__(96);
	var SRC = __webpack_require__(164)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(118).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var fails = __webpack_require__(47);
	var defined = __webpack_require__(119);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createEmotion = _interopDefault(__webpack_require__(1343));
	
	var context = typeof global !== 'undefined' ? global : {};
	
	var _createEmotion = createEmotion(context),
	    flush = _createEmotion.flush,
	    hydrate = _createEmotion.hydrate,
	    cx = _createEmotion.cx,
	    merge = _createEmotion.merge,
	    getRegisteredStyles = _createEmotion.getRegisteredStyles,
	    injectGlobal = _createEmotion.injectGlobal,
	    keyframes = _createEmotion.keyframes,
	    css = _createEmotion.css,
	    sheet = _createEmotion.sheet,
	    caches = _createEmotion.caches;
	
	exports.flush = flush;
	exports.hydrate = hydrate;
	exports.cx = cx;
	exports.merge = merge;
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.injectGlobal = injectGlobal;
	exports.keyframes = keyframes;
	exports.css = css;
	exports.sheet = sheet;
	exports.caches = caches;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(400);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTouchDevice = isTouchDevice;
	exports.canSvg = canSvg;
	exports.getBrowserName = getBrowserName;
	/**
	 * @module utils/detect
	 */
	
	function isTouchDevice() {
	  var value = 'ontouchstart' in window || navigator.maxTouchPoints;
	  return value;
	}
	
	function canSvg() {
	  return !!(document.createElementNS && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect);
	}
	
	// Use to get browsername.
	function getBrowserName() {
	  // The order matters here, and this may report false positives for unlisted browsers.
	  var userAgent = navigator.userAgent;
	
	  if (userAgent.includes('Firefox')) {
	    // "Mozilla/5.0 (X11; Linux i686; rv:104.0) Gecko/20100101 Firefox/104.0"
	    return 'Firefox';
	  } else if (userAgent.includes('SamsungBrowser')) {
	    // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36"
	    return '';
	  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
	    // "Mozilla/5.0 (Macintosh; Intel Mac OS X 12_5_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36 OPR/90.0.4480.54"
	    return 'Opera_OPR';
	  } else if (userAgent.includes('Trident')) {
	    // "Mozilla/4.0 (compatible; MSIE 7.0; Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729)"
	    return 'Internet_Explorer';
	  } else if (userAgent.includes('Edge')) {
	    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
	    return 'Edge_Legacy';
	  } else if (userAgent.includes('Edg')) {
	    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36 Edg/104.0.1293.70"
	    return 'Edge_Chromium';
	  } else if (userAgent.includes('Chrome')) {
	    // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36"
	    return 'Chrome';
	  } else if (userAgent.includes('Safari')) {
	    // "Mozilla/5.0 (iPhone; CPU iPhone OS 15_6_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6 Mobile/15E148 Safari/604.1"
	    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
	    if (isSafari) {
	      return 'Safari';
	    }
	  } else {
	    return '';
	  }
	}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(209);
	var createDesc = __webpack_require__(160);
	var toIObject = __webpack_require__(105);
	var toPrimitive = __webpack_require__(122);
	var has = __webpack_require__(96);
	var IE8_DOM_DEFINE = __webpack_require__(487);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(70) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(96);
	var toObject = __webpack_require__(80);
	var IE_PROTO = __webpack_require__(326)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(208);
	var defined = __webpack_require__(119);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomerGroups = getCustomerGroups;
	exports.getCustomerGroup = getCustomerGroup;
	exports.getShopCustomers = getShopCustomers;
	exports.getChainCustomers = getChainCustomers;
	exports.CreateSaveCustomerGroup = CreateSaveCustomerGroup;
	exports.addCustomerGroupCustomers = addCustomerGroupCustomers;
	exports.removeCustomerGroupCustomer = removeCustomerGroupCustomer;
	exports.getShopsForCustomerGroup = getShopsForCustomerGroup;
	exports.getCustomerGroupAgreements = getCustomerGroupAgreements;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get list of customergroups from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/customerGroup
	 */
	function getCustomerGroups() {
	  var url = _constants.API_URL + '/CustomerGroup';
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_CUSTOMERGROUPS,
	        customergroups: res.data
	      });
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Get customer group from API
	 * @return {Promise} Axios promise
	 */
	function getCustomerGroup(id) {
	  var url = _constants.API_URL + '/CustomerGroup/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting customers from customergroup, with shop name from the API
	 * @return {Promise} Axios promise
	 */
	function getShopCustomers(customerGroupId) {
	  var url = _constants.API_URL + '/CustomerGroup/ShopCustomers/' + customerGroupId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get chain customers from API
	 * @return {Promise} Axios promise
	 */
	function getChainCustomers(chainId) {
	  var url = _constants.API_URL + '/CustomerGroup/ChainCustomers/' + chainId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	/**
	 * @description Create/save customer group
	 * @return {Promise} Axios promise
	 */
	function CreateSaveCustomerGroup(data) {
	  var url = _constants.API_URL + '/CustomerGroup/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	/**
	 * @description add customers to customer group
	 * @return {Promise} Axios promise
	 */
	function addCustomerGroupCustomers(data) {
	  var url = _constants.API_URL + '/CustomerGroup/Customer/Add';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	/**
	 * @description Remove customer from customergroup
	 * @return {Promise} Axios promise
	 */
	function removeCustomerGroupCustomer(data) {
	  var url = _constants.API_URL + '/CustomerGroup/Customer/Remove';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Getting shops for customergroup from API
	 * @return {Promise} Axios promise
	 */
	function getShopsForCustomerGroup(id) {
	  var url = _constants.API_URL + '/CustomerGroup/Shop/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get customerGroup agreements by companyId
	 * @return {Promise} Axios promise
	 */
	function getCustomerGroupAgreements(id) {
	  var url = _constants.API_URL + '/CustomerGroup/Shop/Agreements/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getListSimple = getListSimple;
	exports.getSupplier = getSupplier;
	exports.createSaveSupplier = createSaveSupplier;
	exports.getSparePartsOrdering = getSparePartsOrdering;
	exports.createSparePart = createSparePart;
	exports.getSparePartsReception = getSparePartsReception;
	exports.getSparePartsForMatching = getSparePartsForMatching;
	exports.updateSparePartsOrdering = updateSparePartsOrdering;
	exports.updateSparePartsReception = updateSparePartsReception;
	exports.getOrderingSparePartSuppliers = getOrderingSparePartSuppliers;
	exports.getOrderingSparePartDetails = getOrderingSparePartDetails;
	exports.getReceptionSparePartDetails = getReceptionSparePartDetails;
	exports.updateSparePartDeliverySetting = updateSparePartDeliverySetting;
	exports.matchingSpareParts = matchingSpareParts;
	exports.getFilterOrderingSparePartsDetails = getFilterOrderingSparePartsDetails;
	exports.getFilterReceptionSparePartsDetails = getFilterReceptionSparePartsDetails;
	exports.getSparepartList = getSparepartList;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* @description Getting simple list of suppliers from API
	* @return {Promise} Axios promise
	*/
	/**
	* @module actions/Spareparts
	*/
	function getListSimple(filter) {
	  var url = _constants.API_URL + '/Spareparts/Supplier/GetListSimple/' + filter;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	* @description Getting supplier from API
	* @return {Promise} Axios promise
	*/
	function getSupplier(id) {
	  var url = _constants.API_URL + '/Spareparts/Supplier/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	* @description Creating/saving a supplier
	* @return {Promise} Axios promise
	*/
	function createSaveSupplier(data) {
	  var url = _constants.API_URL + '/Spareparts/Supplier/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function getSparePartsPayload(data) {
	  return {
	    spareParts: data.SpareParts,
	    comments: data.SparePartComments,
	    filter: data.Filter
	  };
	}
	
	/**
	* @description Getting spareparts when ordering from API
	* @return {Promise} Axios promise
	*/
	function getSparePartsOrdering(filter) {
	  var url = _constants.API_URL + '/Spareparts/ordering/';
	  return function (dispatch) {
	    return _axios2.default.post(url, filter).then(function (res) {
	      dispatch({
	        type: _constants.SET_SPARE_PARTS_ORDERING,
	        payload: getSparePartsPayload(res.data)
	      });
	
	      return res;
	    });
	  };
	}
	
	/**
	* @description Creating a spare part
	* @return {Promise} Axios promise
	*/
	function createSparePart(data) {
	  var url = _constants.API_URL + '/Spareparts/create';
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      dispatch({
	        type: _constants.SET_SPARE_PARTS_ORDERING,
	        payload: getSparePartsPayload(res.data)
	      });
	    });
	  };
	}
	
	/**
	* @description Getting spareparts when receiving from API
	* @return {Promise} Axios promise
	*/
	function getSparePartsReception(filter) {
	  var url = _constants.API_URL + '/Spareparts/reception/';
	  return function (dispatch) {
	    return _axios2.default.post(url, filter).then(function (res) {
	      dispatch({
	        type: _constants.SET_SPARE_PARTS_RECEPTION,
	        payload: getSparePartsPayload(res.data)
	      });
	    });
	  };
	}
	
	/**
	* @description Getting spareparts when matching from API
	* @return {Promise} Axios promise
	*/
	function getSparePartsForMatching(filter) {
	  var url = _constants.API_URL + '/Spareparts/getForMatching/';
	  return function (dispatch) {
	    return _axios2.default.post(url, filter).then(function (res) {
	      dispatch({
	        type: _constants.SET_SPARE_PARTS_FOR_MATCHING,
	        payload: getSparePartsPayload(res.data)
	      });
	    });
	  };
	}
	
	/**
	* @description Update spareparts when ordering
	* @return {Promise} Axios promise
	*/
	function updateSparePartsOrdering(sparePartsBody) {
	  var url = _constants.API_URL + '/Spareparts/updateOrdering';
	  return function (dispatch) {
	    return _axios2.default.post(url, sparePartsBody).then(function (res) {
	      dispatch({
	        type: _constants.SET_SPARE_PARTS_ORDERING,
	        payload: getSparePartsPayload(res.data)
	      });
	      return res;
	    });
	  };
	}
	
	/**
	* @description Update spareparts when receiving
	* @return {Promise} Axios promise
	*/
	function updateSparePartsReception(sparePartsBody) {
	  var url = _constants.API_URL + '/Spareparts/updateReception';
	  return function (dispatch) {
	    return _axios2.default.post(url, sparePartsBody).then(function (res) {
	      dispatch({
	        type: _constants.SET_SPARE_PARTS_RECEPTION,
	        payload: getSparePartsPayload(res.data)
	      });
	    });
	  };
	}
	
	/**
	* @description Getting sparepart suppliers available to order from API
	* @return {Promise} Axios promise
	*/
	function getOrderingSparePartSuppliers(orderId, deliveryType) {
	  var url = _constants.API_URL + '/Spareparts/ordering/GetSparePartSuppliers/' + orderId + '/' + deliveryType;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	* @description Get details of an ordering sparepart
	* @return {Promise} Axios promise
	*/
	function getOrderingSparePartDetails(sparePart) {
	  var url = _constants.API_URL + '/Spareparts/ordering/getSparePartDetails/';
	  return function (dispatch) {
	    return _axios2.default.post(url, sparePart);
	  };
	}
	
	/**
	* @description Get details of a reception sparepart
	* @return {Promise} Axios promise
	*/
	function getReceptionSparePartDetails(sparePart) {
	  var url = _constants.API_URL + '/Spareparts/reception/getSparePartDetails/';
	  return function (dispatch) {
	    return _axios2.default.post(url, sparePart);
	  };
	}
	
	/**
	* @description Update supplier delivery setting
	* @return {Promise} Axios promise
	*/
	function updateSparePartDeliverySetting(setting) {
	  var url = _constants.API_URL + '/Spareparts/Supplier/DeliverySettings/';
	  return function (dispatch) {
	    return _axios2.default.post(url, setting);
	  };
	}
	
	/**
	* @description Match two spare parts
	* @return {Promise} Axios promise
	*/
	function matchingSpareParts(sparePart) {
	  var url = _constants.API_URL + '/Spareparts/matchingSpareParts/';
	  return function (dispatch) {
	    return _axios2.default.post(url, sparePart).then(function (res) {
	      dispatch({
	        type: _constants.SET_SPARE_PARTS_ORDERING,
	        payload: getSparePartsPayload(res.data)
	      });
	      return res;
	    });
	  };
	}
	
	/**
	* @description Get filter details of ordering
	* @return {Promise} Axios promise
	*/
	function getFilterOrderingSparePartsDetails(filterDetails) {
	  var url = _constants.API_URL + '/Spareparts/ordering/filterSparePartsDetails/';
	  return function (dispatch) {
	    return _axios2.default.post(url, filterDetails);
	  };
	}
	
	/**
	* @description Get filter details of reception
	* @return {Promise} Axios promise
	*/
	function getFilterReceptionSparePartsDetails(filterDetails) {
	  var url = _constants.API_URL + '/Spareparts/reception/filterSparePartsDetails/';
	  return function (dispatch) {
	    return _axios2.default.post(url, filterDetails);
	  };
	}
	
	/**
	* @description Get list of spareparts for grouped list view
	* @return {Promise} Axios promise
	*/
	function getSparepartList(orderId) {
	  var url = _constants.API_URL + '/Spareparts/list/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(88);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(47);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ESGLevelTypes = exports.ESGScopeTypes = undefined;
	exports.getChainSchemas = getChainSchemas;
	exports.getSelectableSchemaYears = getSelectableSchemaYears;
	exports.postSchema = postSchema;
	exports.getAssociatedCompanies = getAssociatedCompanies;
	exports.getHaveCompanyEnteredData = getHaveCompanyEnteredData;
	exports.postAddCompanyToSchema = postAddCompanyToSchema;
	exports.postRemoveCompanyFromSchema = postRemoveCompanyFromSchema;
	exports.postCreateNewChemaYear = postCreateNewChemaYear;
	exports.getScopesForYear = getScopesForYear;
	exports.postScope = postScope;
	exports.postCategory = postCategory;
	exports.postLine = postLine;
	exports.getIsDataEntered = getIsDataEntered;
	exports.getCompanySchemaAssociations = getCompanySchemaAssociations;
	exports.getCompanyScopesForSchemaYear = getCompanyScopesForSchemaYear;
	exports.postCompanyLine = postCompanyLine;
	exports.getIsCompanyUsingManualReportingForSchemaYear = getIsCompanyUsingManualReportingForSchemaYear;
	exports.postIsCompanyUsingManualReportingForSchemaYear = postIsCompanyUsingManualReportingForSchemaYear;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get schemas for current chain
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/address
	 */
	function getChainSchemas() {
	  var url = _constants.API_URL + '/esg/chain/GetSchemas';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get selectable years for a civen schema
	 * @return {Promise} Axios promise
	 */
	function getSelectableSchemaYears(schemaId) {
	  var url = _constants.API_URL + ('/esg/chain/GetSelectableSchemaYears/' + schemaId);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Post schema
	 * @return {Promise} Axios promise
	 */
	function postSchema(data) {
	  var url = _constants.API_URL + '/esg/chain/PostSchema';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get companies associated with a given schemas at a specific year
	 * @return {Promise} Axios promise
	 */
	function getAssociatedCompanies(schemaId, year) {
	  var url = _constants.API_URL + ('/esg/chain/GetAssociatedCompanies/' + schemaId + '/' + year);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Determine if a company have entered data to a schema on a specific year
	 * @return {Promise} Axios promise
	 */
	function getHaveCompanyEnteredData(schemaId, year, companyId) {
	  var url = _constants.API_URL + ('/esg/chain/GetHaveCompnyEnteredData/' + schemaId + '/' + year + '/' + companyId);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Add a company to a specific shema year
	 * @return {Promise} Axios promise
	 */
	function postAddCompanyToSchema(schemaId, year, companyId) {
	  var url = _constants.API_URL + ('/esg/chain/AddCompanyToSchema/' + schemaId + '/' + year + '/' + companyId);
	  return function (dispatch) {
	    return _axios2.default.post(url);
	  };
	}
	
	/**
	 * @description Remove a company from a specific shema year
	 * @return {Promise} Axios promise
	 */
	function postRemoveCompanyFromSchema(schemaId, year, companyId) {
	  var url = _constants.API_URL + ('/esg/chain/RemoveCompanyFromSchema/' + schemaId + '/' + year + '/' + companyId);
	  return function (dispatch) {
	    return _axios2.default.post(url);
	  };
	}
	
	/**
	 * @description Create a new year of given schemas, either a copy of a year or as a new blank
	 * @param copyFromYear Set to undefened to create a new blank year
	 * @return {Promise} Axios promise
	 */
	function postCreateNewChemaYear(schemaId, copyFromYear) {
	  var url = _constants.API_URL + ('/esg/chain/CreateNewChemaYear/' + schemaId + '/' + copyFromYear);
	  return function (dispatch) {
	    return _axios2.default.post(url);
	  };
	}
	
	/**
	 * @description Get scopes for a given schemas at a specific year
	 * @return {Promise} Axios promise
	 */
	function getScopesForYear(schemaId, year, type) {
	  var url = _constants.API_URL + ('/esg/chain/GetScopesForYear/' + schemaId + '/' + year + '/' + type);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	var ESGScopeTypes = exports.ESGScopeTypes = {
	  Default: 0,
	  ManualReporting: 1
	
	  /**
	   * @description Post a scope for a schema
	   * @return {Promise} Axios promise
	   */
	};function postScope(scopeInfo) {
	  var url = _constants.API_URL + '/esg/chain/PostScope';
	  return function (dispatch) {
	    return _axios2.default.post(url, scopeInfo);
	  };
	}
	
	/**
	 * @description Post a category for a scope
	 * @return {Promise} Axios promise
	 */
	function postCategory(categoryInfo) {
	  var url = _constants.API_URL + '/esg/chain/PostCategory';
	  return function (dispatch) {
	    return _axios2.default.post(url, categoryInfo);
	  };
	}
	
	/**
	 * @description Post a line for a category
	 * @return {Promise} Axios promise
	 */
	function postLine(postInfo) {
	  var url = _constants.API_URL + '/esg/chain/PostLine';
	  return function (dispatch) {
	    return _axios2.default.post(url, postInfo);
	  };
	}
	
	/**
	 * @description Get bool determining if one or more companies have entered data in a specific: Schema, Scope, Category or Line
	 * @param level Schema = 0, Scope = 1, Category = 2, Line = 3
	 * @return {Promise} Axios promise
	 */
	function getIsDataEntered(level, id) {
	  var url = _constants.API_URL + ('/esg/chain/IsDataEntered/' + level + '/' + id);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	var ESGLevelTypes = exports.ESGLevelTypes = {
	  Schema: 0,
	  Scope: 1,
	  Category: 2,
	  Line: 3
	
	  // Cmpany endpoints
	  /**
	   * @description Get list of years the current company is associatet with
	   * @return {Promise} Axios promise
	   */
	};function getCompanySchemaAssociations() {
	  var url = _constants.API_URL + '/esg/company/getSchemaAssociations';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get list of scopes, categories and lines for the company at a given schema and year
	 * @return {Promise} Axios promise
	 */
	function getCompanyScopesForSchemaYear(schemaId, year, type) {
	  var url = _constants.API_URL + ('/esg/company/GetScopesForSchemaYear/' + schemaId + '/' + year + '/' + type);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save company line data
	 * @return {Promise} Axios promise
	 */
	function postCompanyLine(companyLine) {
	  var url = _constants.API_URL + '/esg/company/PostLine';
	  return function (dispatch) {
	    return _axios2.default.post(url, companyLine);
	  };
	}
	
	/**
	 * @description Determine if current company is using manual reporting for a given shema and year
	 * @return {Promise} Axios promise
	 */
	function getIsCompanyUsingManualReportingForSchemaYear(schemaId, year) {
	  var url = _constants.API_URL + ('/esg/company/GetIsUsingManualReporting/' + schemaId + '/' + year);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Determine if current company is using manual reporting for a given shema and year
	 * @return {Promise} Axios promise
	 */
	function postIsCompanyUsingManualReportingForSchemaYear(schemaId, year, newValue) {
	  var url = _constants.API_URL + '/esg/company/PostIsUsingManualReporting';
	  return function (dispatch) {
	    return _axios2.default.post(url, { schemaId: schemaId, year: year, newValue: newValue });
	  };
	}

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createNote = createNote;
	exports.deleteNote = deleteNote;
	exports.getOrderNotes = getOrderNotes;
	exports.SetRead = SetRead;
	exports.getStandardNotes = getStandardNotes;
	exports.createOrDeleteStandardNote = createOrDeleteStandardNote;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Creating an note using the API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/notes
	 */
	function createNote(data) {
	  var url = _constants.API_URL + '/OrderNote/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Deleting an note using the API
	 * @return {Promise} Axios promise
	 */
	function deleteNote(id) {
	  var url = _constants.API_URL + '/OrderNote/Delete';
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      ItemID: id
	    });
	  };
	}
	
	/**
	 * @description Getting order notes
	 * @return {Promise} Axios promise
	 */
	function getOrderNotes(id) {
	  var url = _constants.API_URL + '/OrderNote/Get/OrderList/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function SetRead(data) {
	  var url = _constants.API_URL + '/OrderNote/SetRead/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Getting company standard notes
	 * @return {Promise} Axios promise
	 */
	function getStandardNotes() {
	  var url = _constants.API_URL + '/Shop/Notes/Get/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating a company standard note
	 * @return {Promise} Axios promise
	 */
	function createOrDeleteStandardNote(data) {
	  var url = _constants.API_URL + '/Shop/Notes/Post/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetPrice = resetPrice;
	exports.showPopupParts = showPopupParts;
	exports.setCarParts = setCarParts;
	exports.setCarPriceParts = setCarPriceParts;
	exports.setCarSelectedParts = setCarSelectedParts;
	exports.setCarItems = setCarItems;
	exports.updateOtherOrderPrice = updateOtherOrderPrice;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @module actions/price
	 */
	function resetPrice() {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_PRICECALC_PRICES,
	      price: {}
	    });
	  };
	}
	function showPopupParts(show, selectedBodyPart, partSide) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.OPEN_POPUP_PARTS,
	      showPopupForParts: show,
	      selectedBodyPart: selectedBodyPart,
	      selectedBodyPartSide: partSide
	    });
	  };
	}
	function setCarParts(carParts) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_CAR_PARTS,
	      carParts: carParts
	    });
	  };
	}
	function setCarPriceParts(carPriceParts) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_CAR_PRICEPARTS,
	      carPriceParts: carPriceParts
	    });
	  };
	}
	function setCarSelectedParts(carSelectedParts) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_CAR_SELECTED_PARTS,
	      carSelectedParts: carSelectedParts
	    });
	  };
	}
	function setCarItems(carItems) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_CAR_ITEMS,
	      carItems: carItems
	    });
	  };
	}
	
	function updateOtherOrderPrice(data) {
	  var url = _constants.API_URL + '/Order/updateOtherOrderPrice/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Actions = function (_Component) {
	  _inherits(Actions, _Component);
	
	  function Actions() {
	    _classCallCheck(this, Actions);
	
	    return _possibleConstructorReturn(this, (Actions.__proto__ || Object.getPrototypeOf(Actions)).apply(this, arguments));
	  }
	
	  _createClass(Actions, [{
	    key: 'render',
	    value: function render() {
	      var children = _react2.default.Children.toArray(this.props.children);
	
	      if (children.length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _grid2.default,
	        { align: 'center' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Actions;
	}(_react.Component);
	
	Actions.displayName = 'Actions';
	
	exports.default = Actions;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(110);
	var IObject = __webpack_require__(208);
	var toObject = __webpack_require__(80);
	var toLength = __webpack_require__(72);
	var asc = __webpack_require__(311);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(10);
	var core = __webpack_require__(118);
	var fails = __webpack_require__(47);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(49);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(527);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1928)();
	}


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTime = formatTime;
	exports.isVideoChild = isVideoChild;
	exports.mergeAndSortChildren = mergeAndSortChildren;
	exports.deprecatedWarning = deprecatedWarning;
	exports.throttle = throttle;
	exports.mediaProperties = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(395));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(138));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(275));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	// NaN is the only value in javascript which is not equal to itself.
	// eslint-disable-next-line no-self-compare
	var isNaN = Number.isNaN || function (value) {
	  return value !== value;
	};
	/**
	 * @file format-time.js
	 *
	 * Format seconds as a time string, H:MM:SS or M:SS
	 * Supplying a guide (in seconds) will force a number of leading zeros
	 * to cover the length of the guide
	 *
	 * @param  {Number} seconds Number of seconds to be turned into a string
	 * @param  {Number} guide   Number (in seconds) to model the string after
	 * @return {String}         Time formatted as H:MM:SS or M:SS
	 * @private
	 * @function formatTime
	 */
	
	
	function formatTime() {
	  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
	  var s = Math.floor(seconds % 60);
	  var m = Math.floor(seconds / 60 % 60);
	  var h = Math.floor(seconds / 3600);
	  var gm = Math.floor(guide / 60 % 60);
	  var gh = Math.floor(guide / 3600); // handle invalid times
	
	  if (isNaN(seconds) || seconds === Infinity) {
	    // '-' is false for all relational operators (e.g. <, >=) so this setting
	    // will add the minimum number of fields specified by the guide
	    h = '-';
	    m = '-';
	    s = '-';
	  } // Check if we need to show hours
	
	
	  h = h > 0 || gh > 0 ? "".concat(h, ":") : ''; // If hours are showing, we may need to add a leading zero.
	  // Always show at least one digit of minutes.
	
	  m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":"); // Check if leading zero is need for seconds
	
	  s = s < 10 ? "0".concat(s) : s;
	  return h + m + s;
	} // Check if the element belongs to a video element
	// only accept <source />, <track />,
	// <MyComponent isVideoChild />
	// elements
	
	
	function isVideoChild(c) {
	  if (c.props && c.props.isVideoChild) {
	    return true;
	  }
	
	  return c.type === 'source' || c.type === 'track';
	}
	
	var find = function find(elements, func) {
	  return elements.filter(func)[0];
	}; // check if two components are the same type
	
	
	var isTypeEqual = function isTypeEqual(component1, component2) {
	  var type1 = component1.type;
	  var type2 = component2.type;
	
	  if (typeof type1 === 'string' || typeof type2 === 'string') {
	    return type1 === type2;
	  }
	
	  if (typeof type1 === 'function' && typeof type2 === 'function') {
	    return type1.displayName === type2.displayName;
	  }
	
	  return false;
	}; // merge default children
	// sort them by `order` property
	// filter them by `disabled` property
	
	
	function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
	  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	  var children = _react["default"].Children.toArray(_children);
	
	  var order = _parentProps.order,
	      parentProps = (0, _objectWithoutProperties2["default"])(_parentProps, ["order"]); // ignore order from parent
	
	  return children.filter(function (e) {
	    return !e.props.disabled;
	  }) // filter the disabled components
	  .concat(defaultChildren.filter(function (c) {
	    return !find(children, function (component) {
	      return isTypeEqual(component, c);
	    });
	  })).map(function (element) {
	    var defaultComponent = find(defaultChildren, function (c) {
	      return isTypeEqual(c, element);
	    });
	    var defaultProps = defaultComponent ? defaultComponent.props : {};
	    var props = (0, _objectSpread2["default"])({}, parentProps, defaultProps, element.props);
	
	    var e = _react["default"].cloneElement(element, props, element.props.children);
	
	    return e;
	  }).sort(function (a, b) {
	    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
	  });
	}
	/**
	 * Temporary utility for generating the warnings
	 */
	
	
	function deprecatedWarning(oldMethodCall, newMethodCall) {
	  // eslint-disable-next-line no-console
	  console.warn("WARNING: ".concat(oldMethodCall, " will be deprecated soon! Please use ").concat(newMethodCall, " instead."));
	}
	
	function throttle(callback, limit) {
	  var _arguments = arguments;
	  var wait = false;
	  return function () {
	    if (!wait) {
	      // eslint-disable-next-line prefer-rest-params
	      callback.apply(void 0, (0, _toConsumableArray2["default"])(_arguments));
	      wait = true;
	      setTimeout(function () {
	        wait = false;
	      }, limit);
	    }
	  };
	}
	
	var mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];
	exports.mediaProperties = mediaProperties;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getChains = getChains;
	exports.getChainStats = getChainStats;
	exports.getChain = getChain;
	exports.createSaveChain = createSaveChain;
	exports.getAdminChains = getAdminChains;
	exports.getAdminChain = getAdminChain;
	exports.createSaveAdminChain = createSaveAdminChain;
	exports.getForsiList = getForsiList;
	exports.updateForsiList = updateForsiList;
	exports.getCurrencies = getCurrencies;
	exports.getHttpIntegrationLogs = getHttpIntegrationLogs;
	exports.getDBSLogs = getDBSLogs;
	exports.getForsiTokenLogs = getForsiTokenLogs;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get all chains from api
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/chains
	 */
	function getChains() {
	  var url = _constants.API_URL + '/Chain/Get';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get chain stats from api
	 * @return {Promise} Axios promise
	 */
	function getChainStats(data) {
	  var url = _constants.API_URL + '/Permissions/PermissionsHistory';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get chain by id from api
	 * @return {Promise} Axios promise
	 */
	function getChain(ChainId) {
	  var url = _constants.API_URL + '/Chain/Get/' + ChainId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get update / insert chain to api
	 * @return {Promise} Axios promise
	 */
	function createSaveChain(data) {
	  var url = _constants.API_URL + '/Chain/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function getAdminChains(ChainId) {
	  var url = _constants.API_URL + '/ChainAdmin/' + ChainId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get chain by id from api
	 * @return {Promise} Axios promise
	 */
	function getAdminChain(UserId) {
	  var url = _constants.API_URL + '/ChainAdmin/Get/' + UserId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get update / insert chain to api
	 * @return {Promise} Axios promise
	 */
	function createSaveAdminChain(data) {
	  var url = _constants.API_URL + '/ChainAdmin/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get all forsilist chains from api
	 * @return {Promise} Axios promise
	 */
	function getForsiList() {
	  var url = _constants.API_URL + '/Chain/ForsiList';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function updateForsiList(id, active) {
	  var url = _constants.API_URL + '/Chain/ForsiList/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, {
	      ShopId: id,
	      Active: active
	    });
	  };
	}
	
	function getCurrencies() {
	  var url = _constants.API_URL + '/Currency/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function getHttpIntegrationLogs(type) {
	  var url = _constants.API_URL + ('/Chain/IntegrationLogs/http/' + type);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function getDBSLogs() {
	  var url = _constants.API_URL + '/Chain/IntegrationLogs/dbs';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function getForsiTokenLogs() {
	  var url = _constants.API_URL + '/Chain/IntegrationLogs/forsiToken';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEmployees = getEmployees;
	exports.getEmployee = getEmployee;
	exports.CreateSaveEmployee = CreateSaveEmployee;
	exports.ChangePassword = ChangePassword;
	exports.UpdateWorkHours = UpdateWorkHours;
	exports.GetWorkHourLogs = GetWorkHourLogs;
	exports.CreateEmployee = CreateEmployee;
	exports.getImpersonationAccess = getImpersonationAccess;
	exports.saveImpersonationAccess = saveImpersonationAccess;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting employees from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/customers
	 */
	function getEmployees(id) {
	  id = typeof id !== 'undefined' ? id : 0;
	  var url = _constants.API_URL + '/Employee/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_EMPLOYEES,
	        employees: res.data
	      });
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Getting customer from API
	 * @return {Promise} Axios promise
	 */
	function getEmployee(id) {
	  var url = _constants.API_URL + '/Employee/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a customer
	 * @return {Promise} Axios promise
	 */
	function CreateSaveEmployee(data) {
	  var url = _constants.API_URL + '/Employee/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Creating/saving a customer
	 * @return {Promise} Axios promise
	 */
	function ChangePassword(data) {
	  var url = _constants.API_URL + '/Users/ChangePassword';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Saving workhours
	 * @return {Promise} Axios promise
	 */
	function UpdateWorkHours(data) {
	  var url = _constants.API_URL + '/Employee/Workhours/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get workhourLogs
	 * @return {Promise} Axios promise
	 */
	function GetWorkHourLogs(UserId) {
	  var url = _constants.API_URL + '/Employee/Get/HistoricalWorkHours/' + UserId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Create base userinfo for employee
	 * @return {Promise} Axios promise
	 */
	function CreateEmployee(data) {
	  var url = _constants.API_URL + '/Employee/Create/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Getting user Support Access  from API
	 * @return {Promise} Axios promise
	 */
	function getImpersonationAccess() {
	  var url = _constants.API_URL + '/Employee/ImpersonationAccess/Get/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description saving user Support Access
	 * @return {Promise} Axios promise
	 */
	function saveImpersonationAccess(data) {
	  var url = _constants.API_URL + '/Employee/ImpersonationAccess/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setLanguageAction = setLanguageAction;
	exports.setTranslationsAction = setTranslationsAction;
	exports.setLanguages = setLanguages;
	exports.setLanguage = setLanguage;
	exports.setNextLanguage = setNextLanguage;
	exports.getLanguages = getLanguages;
	exports.getLanguageInfos = getLanguageInfos;
	exports.getLanguageInfo = getLanguageInfo;
	exports.setTranslations = setTranslations;
	exports.InitLanguage = InitLanguage;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(352);
	
	__webpack_require__(353);
	
	__webpack_require__(355);
	
	__webpack_require__(354);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Returns payload for dispatching REDUX_I18N_SET_LANGUAGE
	 * @param {String} lang Language representation string to switch to
	 */
	/**
	 * @module language/actions
	 */
	
	function setLanguageAction(lang) {
	  return {
	    type: 'REDUX_I18N_SET_LANGUAGE',
	    lang: lang
	  };
	}
	
	/**
	 * @description Returns payload for dispatching REDUX_I18N_SET_TRANSLATIONS
	 * @param {Object} translations Object containing all the translations
	 */
	
	// import locale file(s)
	function setTranslationsAction(translations) {
	  return function (dispatch) {
	    dispatch({
	      type: 'REDUX_I18N_SET_TRANSLATIONS',
	      translations: translations
	    });
	    // Makes Search/workcard to be called multiple times on reloads
	    // EventEmitter.emit('FORCE_UPDATE')
	  };
	}
	
	function setLanguages(languages) {
	  return function (dispatch) {
	    dispatch({
	      type: 'REDUX_I18N_SET_LANGUAGES',
	      languages: languages
	    });
	  };
	}
	
	/**
	 * @description Sets a new language
	 * @param {String} lang Language representation string to switch to
	 */
	function setLanguage(lang) {
	  return function (dispatch) {
	    window.localStorage.setItem('user_language', lang);
	    // Set locale for moment
	    var locale = 'en';
	    switch (lang) {
	      case 'Danish':
	        locale = 'da';
	        break;
	      case 'English':
	        locale = 'en-gb';
	        break;
	      case 'Swedish':
	        locale = 'sv';
	        break;
	      case 'Norwegian':
	        locale = 'nn';
	        break;
	    }
	    _moment2.default.locale(locale, {
	      week: {
	        dow: 1
	      }
	    });
	
	    dispatch(setLanguageAction(lang));
	    _events2.default.emit('USER_CHANGED_LANG');
	  };
	}
	
	/**
	 * @description Sets language to the next
	 */
	function setNextLanguage(currentLang) {
	  return function (dispatch) {
	    var allLangs = getLanguages();
	    var currentLangIndex = 0;
	    for (var i = 0; i < allLangs.length; i++) {
	      if (allLangs[i] === currentLang) {
	        currentLangIndex = i;
	      }
	    }
	    var nextLangIndex = currentLangIndex + 1;
	    if (nextLangIndex >= allLangs.length) {
	      nextLangIndex = 0;
	    }
	    var nextLang = allLangs[nextLangIndex];
	    window.localStorage.setItem('user_language', nextLang);
	    dispatch(setLanguageAction(nextLang));
	  };
	}
	
	/**
	 * @description Get all languages
	 */
	function getLanguages() {
	  var langs = ['Danish', 'English', 'Swedish', 'Norwegian'];
	  return langs;
	}
	
	/**
	 * @description Get all language infos
	 */
	function getLanguageInfos() {
	  return function (dispatch) {
	    return _constants.ALL_LANGS;
	  };
	}
	
	/**
	 * @description Get all language info
	 */
	function getLanguageInfo(lang) {
	  return function (dispatch) {
	    var langs = _constants.ALL_LANGS;
	    var langInfo = void 0;
	    for (var i = 0; i < langs.length; i++) {
	      if (langs[i].LanguageName === lang) {
	        langInfo = langs[i];
	      }
	    }
	    if (langInfo === undefined) {
	      langInfo = langs[0];
	    }
	    return langInfo;
	  };
	}
	
	/**
	 * @description Sets new translations
	 * @param {String} lang Language representation string to switch to
	 */
	function setTranslations(translations) {
	  return function (dispatch) {
	    dispatch(setTranslationsAction(translations));
	  };
	}
	
	/**
	 * @description Fetches translations from server and dispatching setTranslations
	 */
	function InitLanguage() {
	  return new Promise(function (resolve, reject) {
	    var translations = {};
	    // axios.get(API_URL + '/Resources/Get').then((res) => {
	    //   let languages = res.data.Languages
	
	    var globalResource = window.localStorage.getItem('globalResource'); // getting globalResource from localStorage
	    var globalHash = window.localStorage.getItem('globalHash'); // getting globalHash from localStorage
	    if (globalResource == null || globalHash == null) {
	      // If globalResource/globalHash is null then get data
	      _axios2.default.get(_constants.API_URL + '/Resources/Get').then(function (res) {
	        var languages = res.data.Languages;
	        var langs = [];
	        languages.forEach(function (val, index) {
	          langs.push(val.Name);
	          var cultureTranslations = {};
	          val.Dictionaries.map(function (dictionary, index) {
	            cultureTranslations[dictionary.ID] = dictionary.Value;
	          });
	          translations[val.Name] = cultureTranslations;
	        });
	        window.localStorage.setItem('globalHash', res.data.ResourceHash);
	        window.localStorage.setItem('globalResource', JSON.stringify(res.data));
	        var data = {
	          data: res.data,
	          translations: translations,
	          langs: langs
	        };
	        resolve(data);
	      }, function (err) {
	        reject(err);
	      });
	    } else {
	      // if globalResource/globalHash exist use those data.
	      var languages = JSON.parse(globalResource).Languages;
	      var langs = [];
	      languages.forEach(function (val, index) {
	        langs.push(val.Name);
	        var cultureTranslations = {};
	        val.Dictionaries.map(function (dictionary, index) {
	          cultureTranslations[dictionary.ID] = dictionary.Value;
	        });
	        translations[val.Name] = cultureTranslations;
	      });
	      var data = {
	        data: JSON.parse(globalResource),
	        translations: translations,
	        langs: langs
	      };
	      resolve(data);
	
	      _axios2.default.post(_constants.API_URL + '/Resources/CheckHash', '{Hash:\'' + globalHash + '\'}').then(function (res) {
	        if (!res.data.Match) {
	          var _languages = res.data.Resources.Languages;
	          var _langs = [];
	          _languages.forEach(function (val, index) {
	            _langs.push(val.Name);
	            var cultureTranslations = {};
	            val.Dictionaries.map(function (dictionary, index) {
	              cultureTranslations[dictionary.ID] = dictionary.Value;
	            });
	            translations[val.Name] = cultureTranslations;
	          });
	          var _data = {
	            data: res.data.Resources,
	            translations: translations,
	            langs: _langs
	          };
	          window.localStorage.setItem('globalHash', res.data.Resources.ResourceHash);
	          window.localStorage.setItem('globalResource', JSON.stringify(res.data.Resources));
	          resolve(_data);
	        }
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  });
	}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HelpText = function (_Component) {
	  _inherits(HelpText, _Component);
	
	  function HelpText(props) {
	    _classCallCheck(this, HelpText);
	
	    var _this = _possibleConstructorReturn(this, (HelpText.__proto__ || Object.getPrototypeOf(HelpText)).call(this, props));
	
	    _this.state = {
	      show: false
	    };
	    _this.togglePortal = _this.togglePortal.bind(_this);
	    return _this;
	  }
	
	  _createClass(HelpText, [{
	    key: 'togglePortal',
	    value: function togglePortal(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      //    this.setState({
	      //      show: !this.state.show
	      //    })
	
	      if (!this.state.show) {
	        this.setState({
	          show: true
	        });
	        window.setTimeout(function () {
	          window.addEventListener('click', _this2.togglePortal);
	        }, 10);
	      } else {
	        window.removeEventListener('click', this.togglePortal);
	        window.setTimeout(function () {
	          _this2.setState({
	            show: false
	          });
	        }, 10);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var extraClass = '';
	      var transparentClass = '';
	      if (this.props.left) {
	        extraClass += 'leftText';
	      }
	      if (this.props.bottom) {
	        extraClass += 'bottomText';
	      }
	      var imgsrc = '/images/icons/Cirkle_info-grey10x10px.png';
	      // let imgsrc = '/images/svgs/Cirkle_info-white.svg'
	      var newClass = 'svg10';
	      if (this.props.larger) {
	        imgsrc = '/images/icons/Cirkle_info-grey25x25px.png';
	        transparentClass = 'transp';
	        newClass = '';
	      }
	      if (this.props.green) {
	        imgsrc = '/images/icons/Cirkle_info-green10x10px.png';
	        newClass = '';
	      }
	      if (this.props.red) {
	        imgsrc = '/images/icons/Cirkle_info-red10x10px.png';
	        newClass = '';
	      }
	      if (this.props.black) {
	        imgsrc = '/images/icons/Cirkle_info-Black.png';
	        newClass = 'svg10';
	      }
	      if (this.props.white) {
	        imgsrc = '/images/svgs/Cirkle_info-white.svg';
	        newClass = 'svg10';
	      }
	      if (this.props.screen && this.props.screen === 'workcard') {
	        imgsrc = '/images/svgs/Cirkle_info-black.svg';
	        transparentClass = 'transparentHelper';
	        newClass = '';
	        // console.log('test')
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'helpText ' + extraClass },
	        _react2.default.createElement(
	          'span',
	          { className: transparentClass, onClick: this.togglePortal },
	          _react2.default.createElement('img', { className: newClass, src: imgsrc })
	        ),
	        this.state.show && _react2.default.createElement(
	          'div',
	          { className: 'helperTextModal', style: this.props.style, onClick: this.togglePortal },
	          _react2.default.createElement('img', { src: '/images/icons/close_24-Black.png' }),
	          this.props.text
	        )
	      );
	    }
	  }]);
	
	  return HelpText;
	}(_react.Component);
	
	HelpText.defaultProps = {
	  style: {}
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(HelpText);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _common = __webpack_require__(25);
	
	__webpack_require__(1608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay(props) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));
	
	    _this.isShowing = false;
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Force remove overlayId from stack when unmounting
	      this.props.closeOverlay(this.props.overlayId, true);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // Trigger callbacks when overlay changes between shown/hidden
	      var isOpen = this.props.isOverlayOpen(this.props.overlayId);
	      if (isOpen !== this.isShowing) {
	        if (isOpen) {
	          this.props.onShow();
	        } else {
	          this.props.onHide();
	        }
	        this.isShowing = isOpen;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isOpen = this.props.isOverlayOpen(this.props.overlayId);
	
	      if (!isOpen) return null;
	      var overlayClass = 'element-overlay';
	      if (this.props.noContentScroll) overlayClass += ' no-content-scroll';
	      if (this.props.extraClassName) overlayClass += ' ' + this.props.extraClassName;
	
	      return _react2.default.createElement(
	        'div',
	        { className: overlayClass },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	Overlay.propTypes = {
	  overlayId: _react2.default.PropTypes.string.isRequired
	};
	
	Overlay.defaultProps = {
	  onShow: function onShow() {},
	  onHide: function onHide() {}
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    overlaysLength: state.common.overlays.length // (makes react detect the change, not sure why it doesn't detect this through the array)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  closeOverlay: _common.closeOverlay,
	  isOverlayOpen: _common.isOverlayOpen
	})(Overlay);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	__webpack_require__(1629);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	var TableHeader = function (_Component) {
	  _inherits(TableHeader, _Component);
	
	  function TableHeader() {
	    _classCallCheck(this, TableHeader);
	
	    return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
	  }
	
	  _createClass(TableHeader, [{
	    key: 'getVariantStyle',
	    value: function getVariantStyle() {
	      var simple = this.props.simple;
	
	
	      if (simple) {
	        return ' table-header--simple';
	      }
	
	      return ' table-header';
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var classNames = this.getVariantStyle();
	
	      if (this.props.expand) {
	        classNames += ' table-header--expand';
	      }
	      if (this.props.className) {
	        classNames += ' ' + this.props.className;
	      }
	
	      return classNames;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cols = _props.cols,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        _grid2.default,
	        {
	          cols: cols,
	          className: 'element-table-header' + this.getStyle()
	        },
	        children
	      );
	    }
	  }]);
	
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.displayName = 'TableHeader';
	
	TableHeader.defaultProps = {
	  simple: false,
	  cols: [],
	  expand: false
	};
	
	exports.default = TableHeader;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(508);
	var $export = __webpack_require__(10);
	var shared = __webpack_require__(250)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(511))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(70)) {
	  var LIBRARY = __webpack_require__(156);
	  var global = __webpack_require__(44);
	  var fails = __webpack_require__(47);
	  var $export = __webpack_require__(10);
	  var $typed = __webpack_require__(252);
	  var $buffer = __webpack_require__(332);
	  var ctx = __webpack_require__(110);
	  var anInstance = __webpack_require__(154);
	  var propertyDesc = __webpack_require__(160);
	  var hide = __webpack_require__(97);
	  var redefineAll = __webpack_require__(161);
	  var toInteger = __webpack_require__(121);
	  var toLength = __webpack_require__(72);
	  var toIndex = __webpack_require__(506);
	  var toAbsoluteIndex = __webpack_require__(163);
	  var toPrimitive = __webpack_require__(122);
	  var has = __webpack_require__(96);
	  var classof = __webpack_require__(207);
	  var isObject = __webpack_require__(49);
	  var toObject = __webpack_require__(80);
	  var isArrayIter = __webpack_require__(318);
	  var create = __webpack_require__(157);
	  var getPrototypeOf = __webpack_require__(104);
	  var gOPN = __webpack_require__(158).f;
	  var getIterFn = __webpack_require__(334);
	  var uid = __webpack_require__(164);
	  var wks = __webpack_require__(56);
	  var createArrayMethod = __webpack_require__(117);
	  var createArrayIncludes = __webpack_require__(239);
	  var speciesConstructor = __webpack_require__(251);
	  var ArrayIterators = __webpack_require__(335);
	  var Iterators = __webpack_require__(179);
	  var $iterDetect = __webpack_require__(245);
	  var setSpecies = __webpack_require__(162);
	  var arrayFill = __webpack_require__(310);
	  var arrayCopyWithin = __webpack_require__(479);
	  var $DP = __webpack_require__(71);
	  var $GOPD = __webpack_require__(103);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1914);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 137 */,
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(274);
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InitLanguage = exports.setTranslations = exports.getLanguageInfo = exports.getLanguageInfos = exports.setNextLanguage = exports.setLanguage = exports.setLanguages = exports.i18nState = undefined;
	
	var _reducer = __webpack_require__(802);
	
	Object.defineProperty(exports, 'i18nState', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.i18nState;
	  }
	});
	
	var _actions = __webpack_require__(129);
	
	Object.defineProperty(exports, 'setLanguages', {
	  enumerable: true,
	  get: function get() {
	    return _actions.setLanguages;
	  }
	});
	Object.defineProperty(exports, 'setLanguage', {
	  enumerable: true,
	  get: function get() {
	    return _actions.setLanguage;
	  }
	});
	Object.defineProperty(exports, 'setNextLanguage', {
	  enumerable: true,
	  get: function get() {
	    return _actions.setNextLanguage;
	  }
	});
	Object.defineProperty(exports, 'getLanguageInfos', {
	  enumerable: true,
	  get: function get() {
	    return _actions.getLanguageInfos;
	  }
	});
	Object.defineProperty(exports, 'getLanguageInfo', {
	  enumerable: true,
	  get: function get() {
	    return _actions.getLanguageInfo;
	  }
	});
	Object.defineProperty(exports, 'setTranslations', {
	  enumerable: true,
	  get: function get() {
	    return _actions.setTranslations;
	  }
	});
	Object.defineProperty(exports, 'InitLanguage', {
	  enumerable: true,
	  get: function get() {
	    return _actions.InitLanguage;
	  }
	});
	
	var _reactRedux = __webpack_require__(3);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    lang: state.i18nState.lang
	  };
	});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _arrowButton = __webpack_require__(200);
	
	var _arrowButton2 = _interopRequireDefault(_arrowButton);
	
	__webpack_require__(1628);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var TableExpand = function (_Component) {
	  _inherits(TableExpand, _Component);
	
	  function TableExpand(props) {
	    _classCallCheck(this, TableExpand);
	
	    var _this = _possibleConstructorReturn(this, (TableExpand.__proto__ || Object.getPrototypeOf(TableExpand)).call(this, props));
	
	    _this.state = {
	      expand: props.expand || false
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.updateExpand = _this.updateExpand.bind(_this);
	    return _this;
	  }
	
	  _createClass(TableExpand, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.expand !== undefined && nextProps.expand !== this.state.expand) {
	        this.updateExpand(nextProps.expand);
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() {
	      console.log('tableExpand onClick', this.props.expand, !this.state.expand);
	
	      if (this.props.onClick !== null) {
	        this.props.onClick(!this.state.expand);
	      } else {
	        this.updateExpand(!this.state.expand);
	      }
	    }
	  }, {
	    key: 'updateExpand',
	    value: function updateExpand(expand) {
	      this.setState({
	        expand: typeof expand === 'boolean' ? expand : !this.state.expand
	      });
	    }
	  }, {
	    key: 'mapHeader',
	    value: function mapHeader(tHeader) {
	      var thChildren = _react2.default.Children.toArray(tHeader.props.children);
	      var childrenCount = thChildren.length;
	
	      var arrowDir = this.state.expand ? 'down' : 'right';
	      // Pass expand indicator to the header
	      var newChildren = [].concat(_toConsumableArray(thChildren), [_react2.default.createElement(
	        'div',
	        { className: 'element-table-expand__indicator', key: 'indicator' },
	        _react2.default.createElement(_arrowButton2.default, { size: 'm', dir: arrowDir })
	      )]);
	
	      // Add extra column to the headers cols prop
	      var cols = tHeader.props.cols;
	      if (cols.length === 0) {
	        cols = new Array(childrenCount).fill(1);
	      }
	
	      var newCols = void 0;
	      if (typeof cols === 'string') {
	        newCols = cols += ' min-content';
	      } else {
	        newCols = [].concat(_toConsumableArray(cols), ['min-content']);
	      }
	
	      return _react2.default.cloneElement(tHeader, {
	        children: newChildren,
	        cols: newCols,
	        expand: this.state.expand
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      var header = null;
	      var rows = null;
	      if (children[0].type.displayName === 'TableHeader') {
	        var _children = _toArray(children),
	            tHeader = _children[0],
	            tRows = _children.slice(1);
	
	        header = this.mapHeader(tHeader);
	        rows = tRows;
	      }
	
	      if (header === null) {
	        console.error('TableExpand must include a TableHeader');
	      }
	
	      var contentClass = this.state.expand ? ' element-table-expand__content--expand' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-table-expand' },
	        _react2.default.createElement(
	          'div',
	          { onClick: this.onClick },
	          header
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'element-table-expand__content' + contentClass },
	          rows
	        )
	      );
	    }
	  }]);
	
	  return TableExpand;
	}(_react.Component);
	
	TableExpand.defaultProps = {
	  onClick: null,
	  children: []
	};
	
	exports.default = TableExpand;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(56)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(97)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(164)('meta');
	var isObject = __webpack_require__(49);
	var has = __webpack_require__(96);
	var setDesc = __webpack_require__(71).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(47)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, process, global, module) {(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.async = global.async || {})));
	}(this, (function (exports) { 'use strict';
	
	function slice(arrayLike, start) {
	    start = start|0;
	    var newLen = Math.max(arrayLike.length - start, 0);
	    var newArr = Array(newLen);
	    for(var idx = 0; idx < newLen; idx++)  {
	        newArr[idx] = arrayLike[start + idx];
	    }
	    return newArr;
	}
	
	/**
	 * Creates a continuation function with some arguments already applied.
	 *
	 * Useful as a shorthand when combined with other control flow functions. Any
	 * arguments passed to the returned function are added to the arguments
	 * originally passed to apply.
	 *
	 * @name apply
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {Function} fn - The function you want to eventually apply all
	 * arguments to. Invokes with (arguments...).
	 * @param {...*} arguments... - Any number of arguments to automatically apply
	 * when the continuation is called.
	 * @returns {Function} the partially-applied function
	 * @example
	 *
	 * // using apply
	 * async.parallel([
	 *     async.apply(fs.writeFile, 'testfile1', 'test1'),
	 *     async.apply(fs.writeFile, 'testfile2', 'test2')
	 * ]);
	 *
	 *
	 * // the same process without using apply
	 * async.parallel([
	 *     function(callback) {
	 *         fs.writeFile('testfile1', 'test1', callback);
	 *     },
	 *     function(callback) {
	 *         fs.writeFile('testfile2', 'test2', callback);
	 *     }
	 * ]);
	 *
	 * // It's possible to pass any number of additional arguments when calling the
	 * // continuation:
	 *
	 * node> var fn = async.apply(sys.puts, 'one');
	 * node> fn('two', 'three');
	 * one
	 * two
	 * three
	 */
	var apply = function(fn/*, ...args*/) {
	    var args = slice(arguments, 1);
	    return function(/*callArgs*/) {
	        var callArgs = slice(arguments);
	        return fn.apply(null, args.concat(callArgs));
	    };
	};
	
	var initialParams = function (fn) {
	    return function (/*...args, callback*/) {
	        var args = slice(arguments);
	        var callback = args.pop();
	        fn.call(this, args, callback);
	    };
	};
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
	var hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';
	
	function fallback(fn) {
	    setTimeout(fn, 0);
	}
	
	function wrap(defer) {
	    return function (fn/*, ...args*/) {
	        var args = slice(arguments, 1);
	        defer(function () {
	            fn.apply(null, args);
	        });
	    };
	}
	
	var _defer;
	
	if (hasSetImmediate) {
	    _defer = setImmediate;
	} else if (hasNextTick) {
	    _defer = process.nextTick;
	} else {
	    _defer = fallback;
	}
	
	var setImmediate$1 = wrap(_defer);
	
	/**
	 * Take a sync function and make it async, passing its return value to a
	 * callback. This is useful for plugging sync functions into a waterfall,
	 * series, or other async functions. Any arguments passed to the generated
	 * function will be passed to the wrapped function (except for the final
	 * callback argument). Errors thrown will be passed to the callback.
	 *
	 * If the function passed to `asyncify` returns a Promise, that promises's
	 * resolved/rejected state will be used to call the callback, rather than simply
	 * the synchronous return value.
	 *
	 * This also means you can asyncify ES2017 `async` functions.
	 *
	 * @name asyncify
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @alias wrapSync
	 * @category Util
	 * @param {Function} func - The synchronous function, or Promise-returning
	 * function to convert to an {@link AsyncFunction}.
	 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
	 * invoked with `(args..., callback)`.
	 * @example
	 *
	 * // passing a regular synchronous function
	 * async.waterfall([
	 *     async.apply(fs.readFile, filename, "utf8"),
	 *     async.asyncify(JSON.parse),
	 *     function (data, next) {
	 *         // data is the result of parsing the text.
	 *         // If there was a parsing error, it would have been caught.
	 *     }
	 * ], callback);
	 *
	 * // passing a function returning a promise
	 * async.waterfall([
	 *     async.apply(fs.readFile, filename, "utf8"),
	 *     async.asyncify(function (contents) {
	 *         return db.model.create(contents);
	 *     }),
	 *     function (model, next) {
	 *         // `model` is the instantiated model object.
	 *         // If there was an error, this function would be skipped.
	 *     }
	 * ], callback);
	 *
	 * // es2017 example, though `asyncify` is not needed if your JS environment
	 * // supports async functions out of the box
	 * var q = async.queue(async.asyncify(async function(file) {
	 *     var intermediateStep = await processFile(file);
	 *     return await somePromise(intermediateStep)
	 * }));
	 *
	 * q.push(files);
	 */
	function asyncify(func) {
	    return initialParams(function (args, callback) {
	        var result;
	        try {
	            result = func.apply(this, args);
	        } catch (e) {
	            return callback(e);
	        }
	        // if result is Promise object
	        if (isObject(result) && typeof result.then === 'function') {
	            result.then(function(value) {
	                invokeCallback(callback, null, value);
	            }, function(err) {
	                invokeCallback(callback, err.message ? err : new Error(err));
	            });
	        } else {
	            callback(null, result);
	        }
	    });
	}
	
	function invokeCallback(callback, error, value) {
	    try {
	        callback(error, value);
	    } catch (e) {
	        setImmediate$1(rethrow, e);
	    }
	}
	
	function rethrow(error) {
	    throw error;
	}
	
	var supportsSymbol = typeof Symbol === 'function';
	
	function isAsync(fn) {
	    return supportsSymbol && fn[Symbol.toStringTag] === 'AsyncFunction';
	}
	
	function wrapAsync(asyncFn) {
	    return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
	}
	
	function applyEach$1(eachfn) {
	    return function(fns/*, ...args*/) {
	        var args = slice(arguments, 1);
	        var go = initialParams(function(args, callback) {
	            var that = this;
	            return eachfn(fns, function (fn, cb) {
	                wrapAsync(fn).apply(that, args.concat(cb));
	            }, callback);
	        });
	        if (args.length) {
	            return go.apply(this, args);
	        }
	        else {
	            return go;
	        }
	    };
	}
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Built-in value references. */
	var Symbol$1 = root.Symbol;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
	      tag = value[symToStringTag$1];
	
	  try {
	    value[symToStringTag$1] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag$1] = tag;
	    } else {
	      delete value[symToStringTag$1];
	    }
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$1.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString$1.call(value);
	}
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]';
	var undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]';
	var funcTag = '[object Function]';
	var genTag = '[object GeneratorFunction]';
	var proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	// A temporary value used to identify if the loop should be broken.
	// See #1064, #1293
	var breakLoop = {};
	
	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	function once(fn) {
	    return function () {
	        if (fn === null) return;
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	
	var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;
	
	var getIterator = function (coll) {
	    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
	};
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty$2.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$1 = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER$1 : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]';
	var arrayTag = '[object Array]';
	var boolTag = '[object Boolean]';
	var dateTag = '[object Date]';
	var errorTag = '[object Error]';
	var funcTag$1 = '[object Function]';
	var mapTag = '[object Map]';
	var numberTag = '[object Number]';
	var objectTag = '[object Object]';
	var regexpTag = '[object RegExp]';
	var setTag = '[object Set]';
	var stringTag = '[object String]';
	var weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]';
	var dataViewTag = '[object DataView]';
	var float32Tag = '[object Float32Array]';
	var float64Tag = '[object Float64Array]';
	var int8Tag = '[object Int8Array]';
	var int16Tag = '[object Int16Array]';
	var int32Tag = '[object Int32Array]';
	var uint8Tag = '[object Uint8Array]';
	var uint8ClampedTag = '[object Uint8ClampedArray]';
	var uint16Tag = '[object Uint16Array]';
	var uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/** Detect free variable `exports`. */
	var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports$1 && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/** Used for built-in method references. */
	var objectProto$2 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty$1.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var objectProto$5 = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;
	
	  return value === proto;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/** Used for built-in method references. */
	var objectProto$4 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	function createArrayIterator(coll) {
	    var i = -1;
	    var len = coll.length;
	    return function next() {
	        return ++i < len ? {value: coll[i], key: i} : null;
	    }
	}
	
	function createES2015Iterator(iterator) {
	    var i = -1;
	    return function next() {
	        var item = iterator.next();
	        if (item.done)
	            return null;
	        i++;
	        return {value: item.value, key: i};
	    }
	}
	
	function createObjectIterator(obj) {
	    var okeys = keys(obj);
	    var i = -1;
	    var len = okeys.length;
	    return function next() {
	        var key = okeys[++i];
	        return i < len ? {value: obj[key], key: key} : null;
	    };
	}
	
	function iterator(coll) {
	    if (isArrayLike(coll)) {
	        return createArrayIterator(coll);
	    }
	
	    var iterator = getIterator(coll);
	    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
	}
	
	function onlyOnce(fn) {
	    return function() {
	        if (fn === null) throw new Error("Callback was already called.");
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	
	function _eachOfLimit(limit) {
	    return function (obj, iteratee, callback) {
	        callback = once(callback || noop);
	        if (limit <= 0 || !obj) {
	            return callback(null);
	        }
	        var nextElem = iterator(obj);
	        var done = false;
	        var running = 0;
	
	        function iterateeCallback(err, value) {
	            running -= 1;
	            if (err) {
	                done = true;
	                callback(err);
	            }
	            else if (value === breakLoop || (done && running <= 0)) {
	                done = true;
	                return callback(null);
	            }
	            else {
	                replenish();
	            }
	        }
	
	        function replenish () {
	            while (running < limit && !done) {
	                var elem = nextElem();
	                if (elem === null) {
	                    done = true;
	                    if (running <= 0) {
	                        callback(null);
	                    }
	                    return;
	                }
	                running += 1;
	                iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
	            }
	        }
	
	        replenish();
	    };
	}
	
	/**
	 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name eachOfLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.eachOf]{@link module:Collections.eachOf}
	 * @alias forEachOfLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each
	 * item in `coll`. The `key` is the item's key, or index in the case of an
	 * array.
	 * Invoked with (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	function eachOfLimit(coll, limit, iteratee, callback) {
	    _eachOfLimit(limit)(coll, wrapAsync(iteratee), callback);
	}
	
	function doLimit(fn, limit) {
	    return function (iterable, iteratee, callback) {
	        return fn(iterable, limit, iteratee, callback);
	    };
	}
	
	// eachOf implementation optimized for array-likes
	function eachOfArrayLike(coll, iteratee, callback) {
	    callback = once(callback || noop);
	    var index = 0,
	        completed = 0,
	        length = coll.length;
	    if (length === 0) {
	        callback(null);
	    }
	
	    function iteratorCallback(err, value) {
	        if (err) {
	            callback(err);
	        } else if ((++completed === length) || value === breakLoop) {
	            callback(null);
	        }
	    }
	
	    for (; index < length; index++) {
	        iteratee(coll[index], index, onlyOnce(iteratorCallback));
	    }
	}
	
	// a generic version of eachOf which can handle array, object, and iterator cases.
	var eachOfGeneric = doLimit(eachOfLimit, Infinity);
	
	/**
	 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
	 * to the iteratee.
	 *
	 * @name eachOf
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias forEachOf
	 * @category Collection
	 * @see [async.each]{@link module:Collections.each}
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each
	 * item in `coll`.
	 * The `key` is the item's key, or index in the case of an array.
	 * Invoked with (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 * @example
	 *
	 * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
	 * var configs = {};
	 *
	 * async.forEachOf(obj, function (value, key, callback) {
	 *     fs.readFile(__dirname + value, "utf8", function (err, data) {
	 *         if (err) return callback(err);
	 *         try {
	 *             configs[key] = JSON.parse(data);
	 *         } catch (e) {
	 *             return callback(e);
	 *         }
	 *         callback();
	 *     });
	 * }, function (err) {
	 *     if (err) console.error(err.message);
	 *     // configs is now a map of JSON data
	 *     doSomethingWith(configs);
	 * });
	 */
	var eachOf = function(coll, iteratee, callback) {
	    var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
	    eachOfImplementation(coll, wrapAsync(iteratee), callback);
	};
	
	function doParallel(fn) {
	    return function (obj, iteratee, callback) {
	        return fn(eachOf, obj, wrapAsync(iteratee), callback);
	    };
	}
	
	function _asyncMap(eachfn, arr, iteratee, callback) {
	    callback = callback || noop;
	    arr = arr || [];
	    var results = [];
	    var counter = 0;
	    var _iteratee = wrapAsync(iteratee);
	
	    eachfn(arr, function (value, _, callback) {
	        var index = counter++;
	        _iteratee(value, function (err, v) {
	            results[index] = v;
	            callback(err);
	        });
	    }, function (err) {
	        callback(err, results);
	    });
	}
	
	/**
	 * Produces a new collection of values by mapping each value in `coll` through
	 * the `iteratee` function. The `iteratee` is called with an item from `coll`
	 * and a callback for when it has finished processing. Each of these callback
	 * takes 2 arguments: an `error`, and the transformed item from `coll`. If
	 * `iteratee` passes an error to its callback, the main `callback` (for the
	 * `map` function) is immediately called with the error.
	 *
	 * Note, that since this function applies the `iteratee` to each item in
	 * parallel, there is no guarantee that the `iteratee` functions will complete
	 * in order. However, the results array will be in the same order as the
	 * original `coll`.
	 *
	 * If `map` is passed an Object, the results will be an Array.  The results
	 * will roughly be in the order of the original Objects' keys (but this can
	 * vary across JavaScript engines).
	 *
	 * @name map
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with the transformed item.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Results is an Array of the
	 * transformed items from the `coll`. Invoked with (err, results).
	 * @example
	 *
	 * async.map(['file1','file2','file3'], fs.stat, function(err, results) {
	 *     // results is now an array of stats for each file
	 * });
	 */
	var map = doParallel(_asyncMap);
	
	/**
	 * Applies the provided arguments to each function in the array, calling
	 * `callback` after all functions have completed. If you only provide the first
	 * argument, `fns`, then it will return a function which lets you pass in the
	 * arguments as if it were a single function call. If more arguments are
	 * provided, `callback` is required while `args` is still optional.
	 *
	 * @name applyEach
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s
	 * to all call with the same arguments
	 * @param {...*} [args] - any number of separate arguments to pass to the
	 * function.
	 * @param {Function} [callback] - the final argument should be the callback,
	 * called when all functions have completed processing.
	 * @returns {Function} - If only the first argument, `fns`, is provided, it will
	 * return a function which lets you pass in the arguments as if it were a single
	 * function call. The signature is `(..args, callback)`. If invoked with any
	 * arguments, `callback` is required.
	 * @example
	 *
	 * async.applyEach([enableSearch, updateSchema], 'bucket', callback);
	 *
	 * // partial application example:
	 * async.each(
	 *     buckets,
	 *     async.applyEach([enableSearch, updateSchema]),
	 *     callback
	 * );
	 */
	var applyEach = applyEach$1(map);
	
	function doParallelLimit(fn) {
	    return function (obj, limit, iteratee, callback) {
	        return fn(_eachOfLimit(limit), obj, wrapAsync(iteratee), callback);
	    };
	}
	
	/**
	 * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name mapLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.map]{@link module:Collections.map}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with the transformed item.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Results is an array of the
	 * transformed items from the `coll`. Invoked with (err, results).
	 */
	var mapLimit = doParallelLimit(_asyncMap);
	
	/**
	 * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
	 *
	 * @name mapSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.map]{@link module:Collections.map}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with the transformed item.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Results is an array of the
	 * transformed items from the `coll`. Invoked with (err, results).
	 */
	var mapSeries = doLimit(mapLimit, 1);
	
	/**
	 * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
	 *
	 * @name applyEachSeries
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.applyEach]{@link module:ControlFlow.applyEach}
	 * @category Control Flow
	 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s to all
	 * call with the same arguments
	 * @param {...*} [args] - any number of separate arguments to pass to the
	 * function.
	 * @param {Function} [callback] - the final argument should be the callback,
	 * called when all functions have completed processing.
	 * @returns {Function} - If only the first argument is provided, it will return
	 * a function which lets you pass in the arguments as if it were a single
	 * function call.
	 */
	var applyEachSeries = applyEach$1(mapSeries);
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	/**
	 * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
	 * their requirements. Each function can optionally depend on other functions
	 * being completed first, and each function is run as soon as its requirements
	 * are satisfied.
	 *
	 * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
	 * will stop. Further tasks will not execute (so any other functions depending
	 * on it will not run), and the main `callback` is immediately called with the
	 * error.
	 *
	 * {@link AsyncFunction}s also receive an object containing the results of functions which
	 * have completed so far as the first argument, if they have dependencies. If a
	 * task function has no dependencies, it will only be passed a callback.
	 *
	 * @name auto
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Object} tasks - An object. Each of its properties is either a
	 * function or an array of requirements, with the {@link AsyncFunction} itself the last item
	 * in the array. The object's key of a property serves as the name of the task
	 * defined by that property, i.e. can be used when specifying requirements for
	 * other tasks. The function receives one or two arguments:
	 * * a `results` object, containing the results of the previously executed
	 *   functions, only passed if the task has any dependencies,
	 * * a `callback(err, result)` function, which must be called when finished,
	 *   passing an `error` (which can be `null`) and the result of the function's
	 *   execution.
	 * @param {number} [concurrency=Infinity] - An optional `integer` for
	 * determining the maximum number of tasks that can be run in parallel. By
	 * default, as many as possible.
	 * @param {Function} [callback] - An optional callback which is called when all
	 * the tasks have been completed. It receives the `err` argument if any `tasks`
	 * pass an error to their callback. Results are always returned; however, if an
	 * error occurs, no further `tasks` will be performed, and the results object
	 * will only contain partial results. Invoked with (err, results).
	 * @returns undefined
	 * @example
	 *
	 * async.auto({
	 *     // this function will just be passed a callback
	 *     readData: async.apply(fs.readFile, 'data.txt', 'utf-8'),
	 *     showData: ['readData', function(results, cb) {
	 *         // results.readData is the file's contents
	 *         // ...
	 *     }]
	 * }, callback);
	 *
	 * async.auto({
	 *     get_data: function(callback) {
	 *         console.log('in get_data');
	 *         // async code to get some data
	 *         callback(null, 'data', 'converted to array');
	 *     },
	 *     make_folder: function(callback) {
	 *         console.log('in make_folder');
	 *         // async code to create a directory to store a file in
	 *         // this is run at the same time as getting the data
	 *         callback(null, 'folder');
	 *     },
	 *     write_file: ['get_data', 'make_folder', function(results, callback) {
	 *         console.log('in write_file', JSON.stringify(results));
	 *         // once there is some data and the directory exists,
	 *         // write the data to a file in the directory
	 *         callback(null, 'filename');
	 *     }],
	 *     email_link: ['write_file', function(results, callback) {
	 *         console.log('in email_link', JSON.stringify(results));
	 *         // once the file is written let's email a link to it...
	 *         // results.write_file contains the filename returned by write_file.
	 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
	 *     }]
	 * }, function(err, results) {
	 *     console.log('err = ', err);
	 *     console.log('results = ', results);
	 * });
	 */
	var auto = function (tasks, concurrency, callback) {
	    if (typeof concurrency === 'function') {
	        // concurrency is optional, shift the args.
	        callback = concurrency;
	        concurrency = null;
	    }
	    callback = once(callback || noop);
	    var keys$$1 = keys(tasks);
	    var numTasks = keys$$1.length;
	    if (!numTasks) {
	        return callback(null);
	    }
	    if (!concurrency) {
	        concurrency = numTasks;
	    }
	
	    var results = {};
	    var runningTasks = 0;
	    var hasError = false;
	
	    var listeners = Object.create(null);
	
	    var readyTasks = [];
	
	    // for cycle detection:
	    var readyToCheck = []; // tasks that have been identified as reachable
	    // without the possibility of returning to an ancestor task
	    var uncheckedDependencies = {};
	
	    baseForOwn(tasks, function (task, key) {
	        if (!isArray(task)) {
	            // no dependencies
	            enqueueTask(key, [task]);
	            readyToCheck.push(key);
	            return;
	        }
	
	        var dependencies = task.slice(0, task.length - 1);
	        var remainingDependencies = dependencies.length;
	        if (remainingDependencies === 0) {
	            enqueueTask(key, task);
	            readyToCheck.push(key);
	            return;
	        }
	        uncheckedDependencies[key] = remainingDependencies;
	
	        arrayEach(dependencies, function (dependencyName) {
	            if (!tasks[dependencyName]) {
	                throw new Error('async.auto task `' + key +
	                    '` has a non-existent dependency `' +
	                    dependencyName + '` in ' +
	                    dependencies.join(', '));
	            }
	            addListener(dependencyName, function () {
	                remainingDependencies--;
	                if (remainingDependencies === 0) {
	                    enqueueTask(key, task);
	                }
	            });
	        });
	    });
	
	    checkForDeadlocks();
	    processQueue();
	
	    function enqueueTask(key, task) {
	        readyTasks.push(function () {
	            runTask(key, task);
	        });
	    }
	
	    function processQueue() {
	        if (readyTasks.length === 0 && runningTasks === 0) {
	            return callback(null, results);
	        }
	        while(readyTasks.length && runningTasks < concurrency) {
	            var run = readyTasks.shift();
	            run();
	        }
	
	    }
	
	    function addListener(taskName, fn) {
	        var taskListeners = listeners[taskName];
	        if (!taskListeners) {
	            taskListeners = listeners[taskName] = [];
	        }
	
	        taskListeners.push(fn);
	    }
	
	    function taskComplete(taskName) {
	        var taskListeners = listeners[taskName] || [];
	        arrayEach(taskListeners, function (fn) {
	            fn();
	        });
	        processQueue();
	    }
	
	
	    function runTask(key, task) {
	        if (hasError) return;
	
	        var taskCallback = onlyOnce(function(err, result) {
	            runningTasks--;
	            if (arguments.length > 2) {
	                result = slice(arguments, 1);
	            }
	            if (err) {
	                var safeResults = {};
	                baseForOwn(results, function(val, rkey) {
	                    safeResults[rkey] = val;
	                });
	                safeResults[key] = result;
	                hasError = true;
	                listeners = Object.create(null);
	
	                callback(err, safeResults);
	            } else {
	                results[key] = result;
	                taskComplete(key);
	            }
	        });
	
	        runningTasks++;
	        var taskFn = wrapAsync(task[task.length - 1]);
	        if (task.length > 1) {
	            taskFn(results, taskCallback);
	        } else {
	            taskFn(taskCallback);
	        }
	    }
	
	    function checkForDeadlocks() {
	        // Kahn's algorithm
	        // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
	        // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
	        var currentTask;
	        var counter = 0;
	        while (readyToCheck.length) {
	            currentTask = readyToCheck.pop();
	            counter++;
	            arrayEach(getDependents(currentTask), function (dependent) {
	                if (--uncheckedDependencies[dependent] === 0) {
	                    readyToCheck.push(dependent);
	                }
	            });
	        }
	
	        if (counter !== numTasks) {
	            throw new Error(
	                'async.auto cannot execute tasks due to a recursive dependency'
	            );
	        }
	    }
	
	    function getDependents(taskName) {
	        var result = [];
	        baseForOwn(tasks, function (task, key) {
	            if (isArray(task) && baseIndexOf(task, taskName, 0) >= 0) {
	                result.push(key);
	            }
	        });
	        return result;
	    }
	};
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined;
	var symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff';
	var rsComboMarksRange = '\\u0300-\\u036f';
	var reComboHalfMarksRange = '\\ufe20-\\ufe2f';
	var rsComboSymbolsRange = '\\u20d0-\\u20ff';
	var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	var rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	/** Used to compose unicode character classes. */
	var rsAstralRange$1 = '\\ud800-\\udfff';
	var rsComboMarksRange$1 = '\\u0300-\\u036f';
	var reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f';
	var rsComboSymbolsRange$1 = '\\u20d0-\\u20ff';
	var rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
	var rsVarRange$1 = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange$1 + ']';
	var rsCombo = '[' + rsComboRange$1 + ']';
	var rsFitz = '\\ud83c[\\udffb-\\udfff]';
	var rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')';
	var rsNonAstral = '[^' + rsAstralRange$1 + ']';
	var rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}';
	var rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]';
	var rsZWJ$1 = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?';
	var rsOptVar = '[' + rsVarRange$1 + ']?';
	var rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*';
	var rsSeq = rsOptVar + reOptMod + rsOptJoin;
	var rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrim, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	var FN_ARGS = /^(?:async\s+)?(function)?\s*[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /(=.+)?(\s*)$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	
	function parseParams(func) {
	    func = func.toString().replace(STRIP_COMMENTS, '');
	    func = func.match(FN_ARGS)[2].replace(' ', '');
	    func = func ? func.split(FN_ARG_SPLIT) : [];
	    func = func.map(function (arg){
	        return trim(arg.replace(FN_ARG, ''));
	    });
	    return func;
	}
	
	/**
	 * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
	 * tasks are specified as parameters to the function, after the usual callback
	 * parameter, with the parameter names matching the names of the tasks it
	 * depends on. This can provide even more readable task graphs which can be
	 * easier to maintain.
	 *
	 * If a final callback is specified, the task results are similarly injected,
	 * specified as named parameters after the initial error parameter.
	 *
	 * The autoInject function is purely syntactic sugar and its semantics are
	 * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
	 *
	 * @name autoInject
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.auto]{@link module:ControlFlow.auto}
	 * @category Control Flow
	 * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
	 * the form 'func([dependencies...], callback). The object's key of a property
	 * serves as the name of the task defined by that property, i.e. can be used
	 * when specifying requirements for other tasks.
	 * * The `callback` parameter is a `callback(err, result)` which must be called
	 *   when finished, passing an `error` (which can be `null`) and the result of
	 *   the function's execution. The remaining parameters name other tasks on
	 *   which the task is dependent, and the results from those tasks are the
	 *   arguments of those parameters.
	 * @param {Function} [callback] - An optional callback which is called when all
	 * the tasks have been completed. It receives the `err` argument if any `tasks`
	 * pass an error to their callback, and a `results` object with any completed
	 * task results, similar to `auto`.
	 * @example
	 *
	 * //  The example from `auto` can be rewritten as follows:
	 * async.autoInject({
	 *     get_data: function(callback) {
	 *         // async code to get some data
	 *         callback(null, 'data', 'converted to array');
	 *     },
	 *     make_folder: function(callback) {
	 *         // async code to create a directory to store a file in
	 *         // this is run at the same time as getting the data
	 *         callback(null, 'folder');
	 *     },
	 *     write_file: function(get_data, make_folder, callback) {
	 *         // once there is some data and the directory exists,
	 *         // write the data to a file in the directory
	 *         callback(null, 'filename');
	 *     },
	 *     email_link: function(write_file, callback) {
	 *         // once the file is written let's email a link to it...
	 *         // write_file contains the filename returned by write_file.
	 *         callback(null, {'file':write_file, 'email':'user@example.com'});
	 *     }
	 * }, function(err, results) {
	 *     console.log('err = ', err);
	 *     console.log('email_link = ', results.email_link);
	 * });
	 *
	 * // If you are using a JS minifier that mangles parameter names, `autoInject`
	 * // will not work with plain functions, since the parameter names will be
	 * // collapsed to a single letter identifier.  To work around this, you can
	 * // explicitly specify the names of the parameters your task function needs
	 * // in an array, similar to Angular.js dependency injection.
	 *
	 * // This still has an advantage over plain `auto`, since the results a task
	 * // depends on are still spread into arguments.
	 * async.autoInject({
	 *     //...
	 *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
	 *         callback(null, 'filename');
	 *     }],
	 *     email_link: ['write_file', function(write_file, callback) {
	 *         callback(null, {'file':write_file, 'email':'user@example.com'});
	 *     }]
	 *     //...
	 * }, function(err, results) {
	 *     console.log('err = ', err);
	 *     console.log('email_link = ', results.email_link);
	 * });
	 */
	function autoInject(tasks, callback) {
	    var newTasks = {};
	
	    baseForOwn(tasks, function (taskFn, key) {
	        var params;
	        var fnIsAsync = isAsync(taskFn);
	        var hasNoDeps =
	            (!fnIsAsync && taskFn.length === 1) ||
	            (fnIsAsync && taskFn.length === 0);
	
	        if (isArray(taskFn)) {
	            params = taskFn.slice(0, -1);
	            taskFn = taskFn[taskFn.length - 1];
	
	            newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
	        } else if (hasNoDeps) {
	            // no dependencies, use the function as-is
	            newTasks[key] = taskFn;
	        } else {
	            params = parseParams(taskFn);
	            if (taskFn.length === 0 && !fnIsAsync && params.length === 0) {
	                throw new Error("autoInject task functions require explicit parameters.");
	            }
	
	            // remove callback param
	            if (!fnIsAsync) params.pop();
	
	            newTasks[key] = params.concat(newTask);
	        }
	
	        function newTask(results, taskCb) {
	            var newArgs = arrayMap(params, function (name) {
	                return results[name];
	            });
	            newArgs.push(taskCb);
	            wrapAsync(taskFn).apply(null, newArgs);
	        }
	    });
	
	    auto(newTasks, callback);
	}
	
	// Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
	// used for queues. This implementation assumes that the node provided by the user can be modified
	// to adjust the next and last properties. We implement only the minimal functionality
	// for queue support.
	function DLL() {
	    this.head = this.tail = null;
	    this.length = 0;
	}
	
	function setInitial(dll, node) {
	    dll.length = 1;
	    dll.head = dll.tail = node;
	}
	
	DLL.prototype.removeLink = function(node) {
	    if (node.prev) node.prev.next = node.next;
	    else this.head = node.next;
	    if (node.next) node.next.prev = node.prev;
	    else this.tail = node.prev;
	
	    node.prev = node.next = null;
	    this.length -= 1;
	    return node;
	};
	
	DLL.prototype.empty = function () {
	    while(this.head) this.shift();
	    return this;
	};
	
	DLL.prototype.insertAfter = function(node, newNode) {
	    newNode.prev = node;
	    newNode.next = node.next;
	    if (node.next) node.next.prev = newNode;
	    else this.tail = newNode;
	    node.next = newNode;
	    this.length += 1;
	};
	
	DLL.prototype.insertBefore = function(node, newNode) {
	    newNode.prev = node.prev;
	    newNode.next = node;
	    if (node.prev) node.prev.next = newNode;
	    else this.head = newNode;
	    node.prev = newNode;
	    this.length += 1;
	};
	
	DLL.prototype.unshift = function(node) {
	    if (this.head) this.insertBefore(this.head, node);
	    else setInitial(this, node);
	};
	
	DLL.prototype.push = function(node) {
	    if (this.tail) this.insertAfter(this.tail, node);
	    else setInitial(this, node);
	};
	
	DLL.prototype.shift = function() {
	    return this.head && this.removeLink(this.head);
	};
	
	DLL.prototype.pop = function() {
	    return this.tail && this.removeLink(this.tail);
	};
	
	DLL.prototype.toArray = function () {
	    var arr = Array(this.length);
	    var curr = this.head;
	    for(var idx = 0; idx < this.length; idx++) {
	        arr[idx] = curr.data;
	        curr = curr.next;
	    }
	    return arr;
	};
	
	DLL.prototype.remove = function (testFn) {
	    var curr = this.head;
	    while(!!curr) {
	        var next = curr.next;
	        if (testFn(curr)) {
	            this.removeLink(curr);
	        }
	        curr = next;
	    }
	    return this;
	};
	
	function queue(worker, concurrency, payload) {
	    if (concurrency == null) {
	        concurrency = 1;
	    }
	    else if(concurrency === 0) {
	        throw new Error('Concurrency must not be zero');
	    }
	
	    var _worker = wrapAsync(worker);
	    var numRunning = 0;
	    var workersList = [];
	
	    var processingScheduled = false;
	    function _insert(data, insertAtFront, callback) {
	        if (callback != null && typeof callback !== 'function') {
	            throw new Error('task callback must be a function');
	        }
	        q.started = true;
	        if (!isArray(data)) {
	            data = [data];
	        }
	        if (data.length === 0 && q.idle()) {
	            // call drain immediately if there are no tasks
	            return setImmediate$1(function() {
	                q.drain();
	            });
	        }
	
	        for (var i = 0, l = data.length; i < l; i++) {
	            var item = {
	                data: data[i],
	                callback: callback || noop
	            };
	
	            if (insertAtFront) {
	                q._tasks.unshift(item);
	            } else {
	                q._tasks.push(item);
	            }
	        }
	
	        if (!processingScheduled) {
	            processingScheduled = true;
	            setImmediate$1(function() {
	                processingScheduled = false;
	                q.process();
	            });
	        }
	    }
	
	    function _next(tasks) {
	        return function(err){
	            numRunning -= 1;
	
	            for (var i = 0, l = tasks.length; i < l; i++) {
	                var task = tasks[i];
	
	                var index = baseIndexOf(workersList, task, 0);
	                if (index === 0) {
	                    workersList.shift();
	                } else if (index > 0) {
	                    workersList.splice(index, 1);
	                }
	
	                task.callback.apply(task, arguments);
	
	                if (err != null) {
	                    q.error(err, task.data);
	                }
	            }
	
	            if (numRunning <= (q.concurrency - q.buffer) ) {
	                q.unsaturated();
	            }
	
	            if (q.idle()) {
	                q.drain();
	            }
	            q.process();
	        };
	    }
	
	    var isProcessing = false;
	    var q = {
	        _tasks: new DLL(),
	        concurrency: concurrency,
	        payload: payload,
	        saturated: noop,
	        unsaturated:noop,
	        buffer: concurrency / 4,
	        empty: noop,
	        drain: noop,
	        error: noop,
	        started: false,
	        paused: false,
	        push: function (data, callback) {
	            _insert(data, false, callback);
	        },
	        kill: function () {
	            q.drain = noop;
	            q._tasks.empty();
	        },
	        unshift: function (data, callback) {
	            _insert(data, true, callback);
	        },
	        remove: function (testFn) {
	            q._tasks.remove(testFn);
	        },
	        process: function () {
	            // Avoid trying to start too many processing operations. This can occur
	            // when callbacks resolve synchronously (#1267).
	            if (isProcessing) {
	                return;
	            }
	            isProcessing = true;
	            while(!q.paused && numRunning < q.concurrency && q._tasks.length){
	                var tasks = [], data = [];
	                var l = q._tasks.length;
	                if (q.payload) l = Math.min(l, q.payload);
	                for (var i = 0; i < l; i++) {
	                    var node = q._tasks.shift();
	                    tasks.push(node);
	                    workersList.push(node);
	                    data.push(node.data);
	                }
	
	                numRunning += 1;
	
	                if (q._tasks.length === 0) {
	                    q.empty();
	                }
	
	                if (numRunning === q.concurrency) {
	                    q.saturated();
	                }
	
	                var cb = onlyOnce(_next(tasks));
	                _worker(data, cb);
	            }
	            isProcessing = false;
	        },
	        length: function () {
	            return q._tasks.length;
	        },
	        running: function () {
	            return numRunning;
	        },
	        workersList: function () {
	            return workersList;
	        },
	        idle: function() {
	            return q._tasks.length + numRunning === 0;
	        },
	        pause: function () {
	            q.paused = true;
	        },
	        resume: function () {
	            if (q.paused === false) { return; }
	            q.paused = false;
	            setImmediate$1(q.process);
	        }
	    };
	    return q;
	}
	
	/**
	 * A cargo of tasks for the worker function to complete. Cargo inherits all of
	 * the same methods and event callbacks as [`queue`]{@link module:ControlFlow.queue}.
	 * @typedef {Object} CargoObject
	 * @memberOf module:ControlFlow
	 * @property {Function} length - A function returning the number of items
	 * waiting to be processed. Invoke like `cargo.length()`.
	 * @property {number} payload - An `integer` for determining how many tasks
	 * should be process per round. This property can be changed after a `cargo` is
	 * created to alter the payload on-the-fly.
	 * @property {Function} push - Adds `task` to the `queue`. The callback is
	 * called once the `worker` has finished processing the task. Instead of a
	 * single task, an array of `tasks` can be submitted. The respective callback is
	 * used for every task in the list. Invoke like `cargo.push(task, [callback])`.
	 * @property {Function} saturated - A callback that is called when the
	 * `queue.length()` hits the concurrency and further tasks will be queued.
	 * @property {Function} empty - A callback that is called when the last item
	 * from the `queue` is given to a `worker`.
	 * @property {Function} drain - A callback that is called when the last item
	 * from the `queue` has returned from the `worker`.
	 * @property {Function} idle - a function returning false if there are items
	 * waiting or being processed, or true if not. Invoke like `cargo.idle()`.
	 * @property {Function} pause - a function that pauses the processing of tasks
	 * until `resume()` is called. Invoke like `cargo.pause()`.
	 * @property {Function} resume - a function that resumes the processing of
	 * queued tasks when the queue is paused. Invoke like `cargo.resume()`.
	 * @property {Function} kill - a function that removes the `drain` callback and
	 * empties remaining tasks from the queue forcing it to go idle. Invoke like `cargo.kill()`.
	 */
	
	/**
	 * Creates a `cargo` object with the specified payload. Tasks added to the
	 * cargo will be processed altogether (up to the `payload` limit). If the
	 * `worker` is in progress, the task is queued until it becomes available. Once
	 * the `worker` has completed some tasks, each callback of those tasks is
	 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
	 * for how `cargo` and `queue` work.
	 *
	 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
	 * at a time, cargo passes an array of tasks to a single worker, repeating
	 * when the worker is finished.
	 *
	 * @name cargo
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.queue]{@link module:ControlFlow.queue}
	 * @category Control Flow
	 * @param {AsyncFunction} worker - An asynchronous function for processing an array
	 * of queued tasks. Invoked with `(tasks, callback)`.
	 * @param {number} [payload=Infinity] - An optional `integer` for determining
	 * how many tasks should be processed per round; if omitted, the default is
	 * unlimited.
	 * @returns {module:ControlFlow.CargoObject} A cargo object to manage the tasks. Callbacks can
	 * attached as certain properties to listen for specific events during the
	 * lifecycle of the cargo and inner queue.
	 * @example
	 *
	 * // create a cargo object with payload 2
	 * var cargo = async.cargo(function(tasks, callback) {
	 *     for (var i=0; i<tasks.length; i++) {
	 *         console.log('hello ' + tasks[i].name);
	 *     }
	 *     callback();
	 * }, 2);
	 *
	 * // add some items
	 * cargo.push({name: 'foo'}, function(err) {
	 *     console.log('finished processing foo');
	 * });
	 * cargo.push({name: 'bar'}, function(err) {
	 *     console.log('finished processing bar');
	 * });
	 * cargo.push({name: 'baz'}, function(err) {
	 *     console.log('finished processing baz');
	 * });
	 */
	function cargo(worker, payload) {
	    return queue(worker, 1, payload);
	}
	
	/**
	 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
	 *
	 * @name eachOfSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.eachOf]{@link module:Collections.eachOf}
	 * @alias forEachOfSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * Invoked with (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Invoked with (err).
	 */
	var eachOfSeries = doLimit(eachOfLimit, 1);
	
	/**
	 * Reduces `coll` into a single value using an async `iteratee` to return each
	 * successive step. `memo` is the initial state of the reduction. This function
	 * only operates in series.
	 *
	 * For performance reasons, it may make sense to split a call to this function
	 * into a parallel map, and then use the normal `Array.prototype.reduce` on the
	 * results. This function is for situations where each step in the reduction
	 * needs to be async; if you can get the data before reducing it, then it's
	 * probably a good idea to do so.
	 *
	 * @name reduce
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias inject
	 * @alias foldl
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {*} memo - The initial state of the reduction.
	 * @param {AsyncFunction} iteratee - A function applied to each item in the
	 * array to produce the next step in the reduction.
	 * The `iteratee` should complete with the next state of the reduction.
	 * If the iteratee complete with an error, the reduction is stopped and the
	 * main `callback` is immediately called with the error.
	 * Invoked with (memo, item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result is the reduced value. Invoked with
	 * (err, result).
	 * @example
	 *
	 * async.reduce([1,2,3], 0, function(memo, item, callback) {
	 *     // pointless async:
	 *     process.nextTick(function() {
	 *         callback(null, memo + item)
	 *     });
	 * }, function(err, result) {
	 *     // result is now equal to the last value of memo, which is 6
	 * });
	 */
	function reduce(coll, memo, iteratee, callback) {
	    callback = once(callback || noop);
	    var _iteratee = wrapAsync(iteratee);
	    eachOfSeries(coll, function(x, i, callback) {
	        _iteratee(memo, x, function(err, v) {
	            memo = v;
	            callback(err);
	        });
	    }, function(err) {
	        callback(err, memo);
	    });
	}
	
	/**
	 * Version of the compose function that is more natural to read. Each function
	 * consumes the return value of the previous function. It is the equivalent of
	 * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
	 *
	 * Each function is executed with the `this` binding of the composed function.
	 *
	 * @name seq
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.compose]{@link module:ControlFlow.compose}
	 * @category Control Flow
	 * @param {...AsyncFunction} functions - the asynchronous functions to compose
	 * @returns {Function} a function that composes the `functions` in order
	 * @example
	 *
	 * // Requires lodash (or underscore), express3 and dresende's orm2.
	 * // Part of an app, that fetches cats of the logged user.
	 * // This example uses `seq` function to avoid overnesting and error
	 * // handling clutter.
	 * app.get('/cats', function(request, response) {
	 *     var User = request.models.User;
	 *     async.seq(
	 *         _.bind(User.get, User),  // 'User.get' has signature (id, callback(err, data))
	 *         function(user, fn) {
	 *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
	 *         }
	 *     )(req.session.user_id, function (err, cats) {
	 *         if (err) {
	 *             console.error(err);
	 *             response.json({ status: 'error', message: err.message });
	 *         } else {
	 *             response.json({ status: 'ok', message: 'Cats found', data: cats });
	 *         }
	 *     });
	 * });
	 */
	function seq(/*...functions*/) {
	    var _functions = arrayMap(arguments, wrapAsync);
	    return function(/*...args*/) {
	        var args = slice(arguments);
	        var that = this;
	
	        var cb = args[args.length - 1];
	        if (typeof cb == 'function') {
	            args.pop();
	        } else {
	            cb = noop;
	        }
	
	        reduce(_functions, args, function(newargs, fn, cb) {
	            fn.apply(that, newargs.concat(function(err/*, ...nextargs*/) {
	                var nextargs = slice(arguments, 1);
	                cb(err, nextargs);
	            }));
	        },
	        function(err, results) {
	            cb.apply(that, [err].concat(results));
	        });
	    };
	}
	
	/**
	 * Creates a function which is a composition of the passed asynchronous
	 * functions. Each function consumes the return value of the function that
	 * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
	 * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
	 *
	 * Each function is executed with the `this` binding of the composed function.
	 *
	 * @name compose
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {...AsyncFunction} functions - the asynchronous functions to compose
	 * @returns {Function} an asynchronous function that is the composed
	 * asynchronous `functions`
	 * @example
	 *
	 * function add1(n, callback) {
	 *     setTimeout(function () {
	 *         callback(null, n + 1);
	 *     }, 10);
	 * }
	 *
	 * function mul3(n, callback) {
	 *     setTimeout(function () {
	 *         callback(null, n * 3);
	 *     }, 10);
	 * }
	 *
	 * var add1mul3 = async.compose(mul3, add1);
	 * add1mul3(4, function (err, result) {
	 *     // result now equals 15
	 * });
	 */
	var compose = function(/*...args*/) {
	    return seq.apply(null, slice(arguments).reverse());
	};
	
	var _concat = Array.prototype.concat;
	
	/**
	 * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name concatLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.concat]{@link module:Collections.concat}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
	 * which should use an array as its result. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is an array
	 * containing the concatenated results of the `iteratee` function. Invoked with
	 * (err, results).
	 */
	var concatLimit = function(coll, limit, iteratee, callback) {
	    callback = callback || noop;
	    var _iteratee = wrapAsync(iteratee);
	    mapLimit(coll, limit, function(val, callback) {
	        _iteratee(val, function(err /*, ...args*/) {
	            if (err) return callback(err);
	            return callback(null, slice(arguments, 1));
	        });
	    }, function(err, mapResults) {
	        var result = [];
	        for (var i = 0; i < mapResults.length; i++) {
	            if (mapResults[i]) {
	                result = _concat.apply(result, mapResults[i]);
	            }
	        }
	
	        return callback(err, result);
	    });
	};
	
	/**
	 * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
	 * the concatenated list. The `iteratee`s are called in parallel, and the
	 * results are concatenated as they return. There is no guarantee that the
	 * results array will be returned in the original order of `coll` passed to the
	 * `iteratee` function.
	 *
	 * @name concat
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
	 * which should use an array as its result. Invoked with (item, callback).
	 * @param {Function} [callback(err)] - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is an array
	 * containing the concatenated results of the `iteratee` function. Invoked with
	 * (err, results).
	 * @example
	 *
	 * async.concat(['dir1','dir2','dir3'], fs.readdir, function(err, files) {
	 *     // files is now a list of filenames that exist in the 3 directories
	 * });
	 */
	var concat = doLimit(concatLimit, Infinity);
	
	/**
	 * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
	 *
	 * @name concatSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.concat]{@link module:Collections.concat}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
	 * The iteratee should complete with an array an array of results.
	 * Invoked with (item, callback).
	 * @param {Function} [callback(err)] - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is an array
	 * containing the concatenated results of the `iteratee` function. Invoked with
	 * (err, results).
	 */
	var concatSeries = doLimit(concatLimit, 1);
	
	/**
	 * Returns a function that when called, calls-back with the values provided.
	 * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
	 * [`auto`]{@link module:ControlFlow.auto}.
	 *
	 * @name constant
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {...*} arguments... - Any number of arguments to automatically invoke
	 * callback with.
	 * @returns {AsyncFunction} Returns a function that when invoked, automatically
	 * invokes the callback with the previous given arguments.
	 * @example
	 *
	 * async.waterfall([
	 *     async.constant(42),
	 *     function (value, next) {
	 *         // value === 42
	 *     },
	 *     //...
	 * ], callback);
	 *
	 * async.waterfall([
	 *     async.constant(filename, "utf8"),
	 *     fs.readFile,
	 *     function (fileData, next) {
	 *         //...
	 *     }
	 *     //...
	 * ], callback);
	 *
	 * async.auto({
	 *     hostname: async.constant("https://server.net/"),
	 *     port: findFreePort,
	 *     launchServer: ["hostname", "port", function (options, cb) {
	 *         startServer(options, cb);
	 *     }],
	 *     //...
	 * }, callback);
	 */
	var constant = function(/*...values*/) {
	    var values = slice(arguments);
	    var args = [null].concat(values);
	    return function (/*...ignoredArgs, callback*/) {
	        var callback = arguments[arguments.length - 1];
	        return callback.apply(this, args);
	    };
	};
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	function _createTester(check, getResult) {
	    return function(eachfn, arr, iteratee, cb) {
	        cb = cb || noop;
	        var testPassed = false;
	        var testResult;
	        eachfn(arr, function(value, _, callback) {
	            iteratee(value, function(err, result) {
	                if (err) {
	                    callback(err);
	                } else if (check(result) && !testResult) {
	                    testPassed = true;
	                    testResult = getResult(true, value);
	                    callback(null, breakLoop);
	                } else {
	                    callback();
	                }
	            });
	        }, function(err) {
	            if (err) {
	                cb(err);
	            } else {
	                cb(null, testPassed ? testResult : getResult(false));
	            }
	        });
	    };
	}
	
	function _findGetResult(v, x) {
	    return x;
	}
	
	/**
	 * Returns the first value in `coll` that passes an async truth test. The
	 * `iteratee` is applied in parallel, meaning the first iteratee to return
	 * `true` will fire the detect `callback` with that result. That means the
	 * result might not be the first item in the original `coll` (in terms of order)
	 * that passes the test.
	
	 * If order within the original `coll` is important, then look at
	 * [`detectSeries`]{@link module:Collections.detectSeries}.
	 *
	 * @name detect
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias find
	 * @category Collections
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
	 * The iteratee must complete with a boolean value as its result.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the `iteratee` functions have finished.
	 * Result will be the first item in the array that passes the truth test
	 * (iteratee) or the value `undefined` if none passed. Invoked with
	 * (err, result).
	 * @example
	 *
	 * async.detect(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, result) {
	 *     // result now equals the first file in the list that exists
	 * });
	 */
	var detect = doParallel(_createTester(identity, _findGetResult));
	
	/**
	 * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name detectLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.detect]{@link module:Collections.detect}
	 * @alias findLimit
	 * @category Collections
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
	 * The iteratee must complete with a boolean value as its result.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the `iteratee` functions have finished.
	 * Result will be the first item in the array that passes the truth test
	 * (iteratee) or the value `undefined` if none passed. Invoked with
	 * (err, result).
	 */
	var detectLimit = doParallelLimit(_createTester(identity, _findGetResult));
	
	/**
	 * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
	 *
	 * @name detectSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.detect]{@link module:Collections.detect}
	 * @alias findSeries
	 * @category Collections
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
	 * The iteratee must complete with a boolean value as its result.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the `iteratee` functions have finished.
	 * Result will be the first item in the array that passes the truth test
	 * (iteratee) or the value `undefined` if none passed. Invoked with
	 * (err, result).
	 */
	var detectSeries = doLimit(detectLimit, 1);
	
	function consoleFunc(name) {
	    return function (fn/*, ...args*/) {
	        var args = slice(arguments, 1);
	        args.push(function (err/*, ...args*/) {
	            var args = slice(arguments, 1);
	            if (typeof console === 'object') {
	                if (err) {
	                    if (console.error) {
	                        console.error(err);
	                    }
	                } else if (console[name]) {
	                    arrayEach(args, function (x) {
	                        console[name](x);
	                    });
	                }
	            }
	        });
	        wrapAsync(fn).apply(null, args);
	    };
	}
	
	/**
	 * Logs the result of an [`async` function]{@link AsyncFunction} to the
	 * `console` using `console.dir` to display the properties of the resulting object.
	 * Only works in Node.js or in browsers that support `console.dir` and
	 * `console.error` (such as FF and Chrome).
	 * If multiple arguments are returned from the async function,
	 * `console.dir` is called on each argument in order.
	 *
	 * @name dir
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} function - The function you want to eventually apply
	 * all arguments to.
	 * @param {...*} arguments... - Any number of arguments to apply to the function.
	 * @example
	 *
	 * // in a module
	 * var hello = function(name, callback) {
	 *     setTimeout(function() {
	 *         callback(null, {hello: name});
	 *     }, 1000);
	 * };
	 *
	 * // in the node repl
	 * node> async.dir(hello, 'world');
	 * {hello: 'world'}
	 */
	var dir = consoleFunc('dir');
	
	/**
	 * The post-check version of [`during`]{@link module:ControlFlow.during}. To reflect the difference in
	 * the order of operations, the arguments `test` and `fn` are switched.
	 *
	 * Also a version of [`doWhilst`]{@link module:ControlFlow.doWhilst} with asynchronous `test` function.
	 * @name doDuring
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.during]{@link module:ControlFlow.during}
	 * @category Control Flow
	 * @param {AsyncFunction} fn - An async function which is called each time
	 * `test` passes. Invoked with (callback).
	 * @param {AsyncFunction} test - asynchronous truth test to perform before each
	 * execution of `fn`. Invoked with (...args, callback), where `...args` are the
	 * non-error args from the previous callback of `fn`.
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `fn` has stopped. `callback`
	 * will be passed an error if one occurred, otherwise `null`.
	 */
	function doDuring(fn, test, callback) {
	    callback = onlyOnce(callback || noop);
	    var _fn = wrapAsync(fn);
	    var _test = wrapAsync(test);
	
	    function next(err/*, ...args*/) {
	        if (err) return callback(err);
	        var args = slice(arguments, 1);
	        args.push(check);
	        _test.apply(this, args);
	    }
	
	    function check(err, truth) {
	        if (err) return callback(err);
	        if (!truth) return callback(null);
	        _fn(next);
	    }
	
	    check(null, true);
	
	}
	
	/**
	 * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
	 * the order of operations, the arguments `test` and `iteratee` are switched.
	 *
	 * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
	 *
	 * @name doWhilst
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.whilst]{@link module:ControlFlow.whilst}
	 * @category Control Flow
	 * @param {AsyncFunction} iteratee - A function which is called each time `test`
	 * passes. Invoked with (callback).
	 * @param {Function} test - synchronous truth test to perform after each
	 * execution of `iteratee`. Invoked with any non-error callback results of
	 * `iteratee`.
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `iteratee` has stopped.
	 * `callback` will be passed an error and any arguments passed to the final
	 * `iteratee`'s callback. Invoked with (err, [results]);
	 */
	function doWhilst(iteratee, test, callback) {
	    callback = onlyOnce(callback || noop);
	    var _iteratee = wrapAsync(iteratee);
	    var next = function(err/*, ...args*/) {
	        if (err) return callback(err);
	        var args = slice(arguments, 1);
	        if (test.apply(this, args)) return _iteratee(next);
	        callback.apply(null, [null].concat(args));
	    };
	    _iteratee(next);
	}
	
	/**
	 * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
	 * argument ordering differs from `until`.
	 *
	 * @name doUntil
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
	 * @category Control Flow
	 * @param {AsyncFunction} iteratee - An async function which is called each time
	 * `test` fails. Invoked with (callback).
	 * @param {Function} test - synchronous truth test to perform after each
	 * execution of `iteratee`. Invoked with any non-error callback results of
	 * `iteratee`.
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has passed and repeated execution of `iteratee` has stopped. `callback`
	 * will be passed an error and any arguments passed to the final `iteratee`'s
	 * callback. Invoked with (err, [results]);
	 */
	function doUntil(iteratee, test, callback) {
	    doWhilst(iteratee, function() {
	        return !test.apply(this, arguments);
	    }, callback);
	}
	
	/**
	 * Like [`whilst`]{@link module:ControlFlow.whilst}, except the `test` is an asynchronous function that
	 * is passed a callback in the form of `function (err, truth)`. If error is
	 * passed to `test` or `fn`, the main callback is immediately called with the
	 * value of the error.
	 *
	 * @name during
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.whilst]{@link module:ControlFlow.whilst}
	 * @category Control Flow
	 * @param {AsyncFunction} test - asynchronous truth test to perform before each
	 * execution of `fn`. Invoked with (callback).
	 * @param {AsyncFunction} fn - An async function which is called each time
	 * `test` passes. Invoked with (callback).
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `fn` has stopped. `callback`
	 * will be passed an error, if one occurred, otherwise `null`.
	 * @example
	 *
	 * var count = 0;
	 *
	 * async.during(
	 *     function (callback) {
	 *         return callback(null, count < 5);
	 *     },
	 *     function (callback) {
	 *         count++;
	 *         setTimeout(callback, 1000);
	 *     },
	 *     function (err) {
	 *         // 5 seconds have passed
	 *     }
	 * );
	 */
	function during(test, fn, callback) {
	    callback = onlyOnce(callback || noop);
	    var _fn = wrapAsync(fn);
	    var _test = wrapAsync(test);
	
	    function next(err) {
	        if (err) return callback(err);
	        _test(check);
	    }
	
	    function check(err, truth) {
	        if (err) return callback(err);
	        if (!truth) return callback(null);
	        _fn(next);
	    }
	
	    _test(check);
	}
	
	function _withoutIndex(iteratee) {
	    return function (value, index, callback) {
	        return iteratee(value, callback);
	    };
	}
	
	/**
	 * Applies the function `iteratee` to each item in `coll`, in parallel.
	 * The `iteratee` is called with an item from the list, and a callback for when
	 * it has finished. If the `iteratee` passes an error to its `callback`, the
	 * main `callback` (for the `each` function) is immediately called with the
	 * error.
	 *
	 * Note, that since this function applies `iteratee` to each item in parallel,
	 * there is no guarantee that the iteratee functions will complete in order.
	 *
	 * @name each
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias forEach
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to
	 * each item in `coll`. Invoked with (item, callback).
	 * The array index is not passed to the iteratee.
	 * If you need the index, use `eachOf`.
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 * @example
	 *
	 * // assuming openFiles is an array of file names and saveFile is a function
	 * // to save the modified contents of that file:
	 *
	 * async.each(openFiles, saveFile, function(err){
	 *   // if any of the saves produced an error, err would equal that error
	 * });
	 *
	 * // assuming openFiles is an array of file names
	 * async.each(openFiles, function(file, callback) {
	 *
	 *     // Perform operation on file here.
	 *     console.log('Processing file ' + file);
	 *
	 *     if( file.length > 32 ) {
	 *       console.log('This file name is too long');
	 *       callback('File name too long');
	 *     } else {
	 *       // Do work to process file here
	 *       console.log('File processed');
	 *       callback();
	 *     }
	 * }, function(err) {
	 *     // if any of the file processing produced an error, err would equal that error
	 *     if( err ) {
	 *       // One of the iterations produced an error.
	 *       // All processing will now stop.
	 *       console.log('A file failed to process');
	 *     } else {
	 *       console.log('All files have been processed successfully');
	 *     }
	 * });
	 */
	function eachLimit(coll, iteratee, callback) {
	    eachOf(coll, _withoutIndex(wrapAsync(iteratee)), callback);
	}
	
	/**
	 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name eachLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.each]{@link module:Collections.each}
	 * @alias forEachLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The array index is not passed to the iteratee.
	 * If you need the index, use `eachOfLimit`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	function eachLimit$1(coll, limit, iteratee, callback) {
	    _eachOfLimit(limit)(coll, _withoutIndex(wrapAsync(iteratee)), callback);
	}
	
	/**
	 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
	 *
	 * @name eachSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.each]{@link module:Collections.each}
	 * @alias forEachSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each
	 * item in `coll`.
	 * The array index is not passed to the iteratee.
	 * If you need the index, use `eachOfSeries`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	var eachSeries = doLimit(eachLimit$1, 1);
	
	/**
	 * Wrap an async function and ensure it calls its callback on a later tick of
	 * the event loop.  If the function already calls its callback on a next tick,
	 * no extra deferral is added. This is useful for preventing stack overflows
	 * (`RangeError: Maximum call stack size exceeded`) and generally keeping
	 * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
	 * contained. ES2017 `async` functions are returned as-is -- they are immune
	 * to Zalgo's corrupting influences, as they always resolve on a later tick.
	 *
	 * @name ensureAsync
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} fn - an async function, one that expects a node-style
	 * callback as its last argument.
	 * @returns {AsyncFunction} Returns a wrapped function with the exact same call
	 * signature as the function passed in.
	 * @example
	 *
	 * function sometimesAsync(arg, callback) {
	 *     if (cache[arg]) {
	 *         return callback(null, cache[arg]); // this would be synchronous!!
	 *     } else {
	 *         doSomeIO(arg, callback); // this IO would be asynchronous
	 *     }
	 * }
	 *
	 * // this has a risk of stack overflows if many results are cached in a row
	 * async.mapSeries(args, sometimesAsync, done);
	 *
	 * // this will defer sometimesAsync's callback if necessary,
	 * // preventing stack overflows
	 * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
	 */
	function ensureAsync(fn) {
	    if (isAsync(fn)) return fn;
	    return initialParams(function (args, callback) {
	        var sync = true;
	        args.push(function () {
	            var innerArgs = arguments;
	            if (sync) {
	                setImmediate$1(function () {
	                    callback.apply(null, innerArgs);
	                });
	            } else {
	                callback.apply(null, innerArgs);
	            }
	        });
	        fn.apply(this, args);
	        sync = false;
	    });
	}
	
	function notId(v) {
	    return !v;
	}
	
	/**
	 * Returns `true` if every element in `coll` satisfies an async test. If any
	 * iteratee call returns `false`, the main `callback` is immediately called.
	 *
	 * @name every
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias all
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collection in parallel.
	 * The iteratee must complete with a boolean result value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result will be either `true` or `false`
	 * depending on the values of the async tests. Invoked with (err, result).
	 * @example
	 *
	 * async.every(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, result) {
	 *     // if result is true then every file exists
	 * });
	 */
	var every = doParallel(_createTester(notId, notId));
	
	/**
	 * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name everyLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.every]{@link module:Collections.every}
	 * @alias allLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collection in parallel.
	 * The iteratee must complete with a boolean result value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result will be either `true` or `false`
	 * depending on the values of the async tests. Invoked with (err, result).
	 */
	var everyLimit = doParallelLimit(_createTester(notId, notId));
	
	/**
	 * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
	 *
	 * @name everySeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.every]{@link module:Collections.every}
	 * @alias allSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collection in series.
	 * The iteratee must complete with a boolean result value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result will be either `true` or `false`
	 * depending on the values of the async tests. Invoked with (err, result).
	 */
	var everySeries = doLimit(everyLimit, 1);
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	function filterArray(eachfn, arr, iteratee, callback) {
	    var truthValues = new Array(arr.length);
	    eachfn(arr, function (x, index, callback) {
	        iteratee(x, function (err, v) {
	            truthValues[index] = !!v;
	            callback(err);
	        });
	    }, function (err) {
	        if (err) return callback(err);
	        var results = [];
	        for (var i = 0; i < arr.length; i++) {
	            if (truthValues[i]) results.push(arr[i]);
	        }
	        callback(null, results);
	    });
	}
	
	function filterGeneric(eachfn, coll, iteratee, callback) {
	    var results = [];
	    eachfn(coll, function (x, index, callback) {
	        iteratee(x, function (err, v) {
	            if (err) {
	                callback(err);
	            } else {
	                if (v) {
	                    results.push({index: index, value: x});
	                }
	                callback();
	            }
	        });
	    }, function (err) {
	        if (err) {
	            callback(err);
	        } else {
	            callback(null, arrayMap(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), baseProperty('value')));
	        }
	    });
	}
	
	function _filter(eachfn, coll, iteratee, callback) {
	    var filter = isArrayLike(coll) ? filterArray : filterGeneric;
	    filter(eachfn, coll, wrapAsync(iteratee), callback || noop);
	}
	
	/**
	 * Returns a new array of all the values in `coll` which pass an async truth
	 * test. This operation is performed in parallel, but the results array will be
	 * in the same order as the original.
	 *
	 * @name filter
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias select
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 * @example
	 *
	 * async.filter(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, results) {
	 *     // results now equals an array of the existing files
	 * });
	 */
	var filter = doParallel(_filter);
	
	/**
	 * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name filterLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.filter]{@link module:Collections.filter}
	 * @alias selectLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 */
	var filterLimit = doParallelLimit(_filter);
	
	/**
	 * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
	 *
	 * @name filterSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.filter]{@link module:Collections.filter}
	 * @alias selectSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results)
	 */
	var filterSeries = doLimit(filterLimit, 1);
	
	/**
	 * Calls the asynchronous function `fn` with a callback parameter that allows it
	 * to call itself again, in series, indefinitely.
	
	 * If an error is passed to the callback then `errback` is called with the
	 * error, and execution stops, otherwise it will never be called.
	 *
	 * @name forever
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {AsyncFunction} fn - an async function to call repeatedly.
	 * Invoked with (next).
	 * @param {Function} [errback] - when `fn` passes an error to it's callback,
	 * this function will be called, and execution stops. Invoked with (err).
	 * @example
	 *
	 * async.forever(
	 *     function(next) {
	 *         // next is suitable for passing to things that need a callback(err [, whatever]);
	 *         // it will result in this function being called again.
	 *     },
	 *     function(err) {
	 *         // if next is called with a value in its first parameter, it will appear
	 *         // in here as 'err', and execution will stop.
	 *     }
	 * );
	 */
	function forever(fn, errback) {
	    var done = onlyOnce(errback || noop);
	    var task = wrapAsync(ensureAsync(fn));
	
	    function next(err) {
	        if (err) return done(err);
	        task(next);
	    }
	    next();
	}
	
	/**
	 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name groupByLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.groupBy]{@link module:Collections.groupBy}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with a `key` to group the value under.
	 * Invoked with (value, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Result is an `Object` whoses
	 * properties are arrays of values which returned the corresponding key.
	 */
	var groupByLimit = function(coll, limit, iteratee, callback) {
	    callback = callback || noop;
	    var _iteratee = wrapAsync(iteratee);
	    mapLimit(coll, limit, function(val, callback) {
	        _iteratee(val, function(err, key) {
	            if (err) return callback(err);
	            return callback(null, {key: key, val: val});
	        });
	    }, function(err, mapResults) {
	        var result = {};
	        // from MDN, handle object having an `hasOwnProperty` prop
	        var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	        for (var i = 0; i < mapResults.length; i++) {
	            if (mapResults[i]) {
	                var key = mapResults[i].key;
	                var val = mapResults[i].val;
	
	                if (hasOwnProperty.call(result, key)) {
	                    result[key].push(val);
	                } else {
	                    result[key] = [val];
	                }
	            }
	        }
	
	        return callback(err, result);
	    });
	};
	
	/**
	 * Returns a new object, where each value corresponds to an array of items, from
	 * `coll`, that returned the corresponding key. That is, the keys of the object
	 * correspond to the values passed to the `iteratee` callback.
	 *
	 * Note: Since this function applies the `iteratee` to each item in parallel,
	 * there is no guarantee that the `iteratee` functions will complete in order.
	 * However, the values for each key in the `result` will be in the same order as
	 * the original `coll`. For Objects, the values will roughly be in the order of
	 * the original Objects' keys (but this can vary across JavaScript engines).
	 *
	 * @name groupBy
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with a `key` to group the value under.
	 * Invoked with (value, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Result is an `Object` whoses
	 * properties are arrays of values which returned the corresponding key.
	 * @example
	 *
	 * async.groupBy(['userId1', 'userId2', 'userId3'], function(userId, callback) {
	 *     db.findById(userId, function(err, user) {
	 *         if (err) return callback(err);
	 *         return callback(null, user.age);
	 *     });
	 * }, function(err, result) {
	 *     // result is object containing the userIds grouped by age
	 *     // e.g. { 30: ['userId1', 'userId3'], 42: ['userId2']};
	 * });
	 */
	var groupBy = doLimit(groupByLimit, Infinity);
	
	/**
	 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
	 *
	 * @name groupBySeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.groupBy]{@link module:Collections.groupBy}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with a `key` to group the value under.
	 * Invoked with (value, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Result is an `Object` whoses
	 * properties are arrays of values which returned the corresponding key.
	 */
	var groupBySeries = doLimit(groupByLimit, 1);
	
	/**
	 * Logs the result of an `async` function to the `console`. Only works in
	 * Node.js or in browsers that support `console.log` and `console.error` (such
	 * as FF and Chrome). If multiple arguments are returned from the async
	 * function, `console.log` is called on each argument in order.
	 *
	 * @name log
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} function - The function you want to eventually apply
	 * all arguments to.
	 * @param {...*} arguments... - Any number of arguments to apply to the function.
	 * @example
	 *
	 * // in a module
	 * var hello = function(name, callback) {
	 *     setTimeout(function() {
	 *         callback(null, 'hello ' + name);
	 *     }, 1000);
	 * };
	 *
	 * // in the node repl
	 * node> async.log(hello, 'world');
	 * 'hello world'
	 */
	var log = consoleFunc('log');
	
	/**
	 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name mapValuesLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.mapValues]{@link module:Collections.mapValues}
	 * @category Collection
	 * @param {Object} obj - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - A function to apply to each value and key
	 * in `coll`.
	 * The iteratee should complete with the transformed value as its result.
	 * Invoked with (value, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. `result` is a new object consisting
	 * of each key from `obj`, with each transformed value on the right-hand side.
	 * Invoked with (err, result).
	 */
	function mapValuesLimit(obj, limit, iteratee, callback) {
	    callback = once(callback || noop);
	    var newObj = {};
	    var _iteratee = wrapAsync(iteratee);
	    eachOfLimit(obj, limit, function(val, key, next) {
	        _iteratee(val, key, function (err, result) {
	            if (err) return next(err);
	            newObj[key] = result;
	            next();
	        });
	    }, function (err) {
	        callback(err, newObj);
	    });
	}
	
	/**
	 * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
	 *
	 * Produces a new Object by mapping each value of `obj` through the `iteratee`
	 * function. The `iteratee` is called each `value` and `key` from `obj` and a
	 * callback for when it has finished processing. Each of these callbacks takes
	 * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
	 * passes an error to its callback, the main `callback` (for the `mapValues`
	 * function) is immediately called with the error.
	 *
	 * Note, the order of the keys in the result is not guaranteed.  The keys will
	 * be roughly in the order they complete, (but this is very engine-specific)
	 *
	 * @name mapValues
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Object} obj - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each value and key
	 * in `coll`.
	 * The iteratee should complete with the transformed value as its result.
	 * Invoked with (value, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. `result` is a new object consisting
	 * of each key from `obj`, with each transformed value on the right-hand side.
	 * Invoked with (err, result).
	 * @example
	 *
	 * async.mapValues({
	 *     f1: 'file1',
	 *     f2: 'file2',
	 *     f3: 'file3'
	 * }, function (file, key, callback) {
	 *   fs.stat(file, callback);
	 * }, function(err, result) {
	 *     // result is now a map of stats for each file, e.g.
	 *     // {
	 *     //     f1: [stats for file1],
	 *     //     f2: [stats for file2],
	 *     //     f3: [stats for file3]
	 *     // }
	 * });
	 */
	
	var mapValues = doLimit(mapValuesLimit, Infinity);
	
	/**
	 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
	 *
	 * @name mapValuesSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.mapValues]{@link module:Collections.mapValues}
	 * @category Collection
	 * @param {Object} obj - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each value and key
	 * in `coll`.
	 * The iteratee should complete with the transformed value as its result.
	 * Invoked with (value, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. `result` is a new object consisting
	 * of each key from `obj`, with each transformed value on the right-hand side.
	 * Invoked with (err, result).
	 */
	var mapValuesSeries = doLimit(mapValuesLimit, 1);
	
	function has(obj, key) {
	    return key in obj;
	}
	
	/**
	 * Caches the results of an async function. When creating a hash to store
	 * function results against, the callback is omitted from the hash and an
	 * optional hash function can be used.
	 *
	 * If no hash function is specified, the first argument is used as a hash key,
	 * which may work reasonably if it is a string or a data type that converts to a
	 * distinct string. Note that objects and arrays will not behave reasonably.
	 * Neither will cases where the other arguments are significant. In such cases,
	 * specify your own hash function.
	 *
	 * The cache of results is exposed as the `memo` property of the function
	 * returned by `memoize`.
	 *
	 * @name memoize
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} fn - The async function to proxy and cache results from.
	 * @param {Function} hasher - An optional function for generating a custom hash
	 * for storing results. It has all the arguments applied to it apart from the
	 * callback, and must be synchronous.
	 * @returns {AsyncFunction} a memoized version of `fn`
	 * @example
	 *
	 * var slow_fn = function(name, callback) {
	 *     // do something
	 *     callback(null, result);
	 * };
	 * var fn = async.memoize(slow_fn);
	 *
	 * // fn can now be used as if it were slow_fn
	 * fn('some name', function() {
	 *     // callback
	 * });
	 */
	function memoize(fn, hasher) {
	    var memo = Object.create(null);
	    var queues = Object.create(null);
	    hasher = hasher || identity;
	    var _fn = wrapAsync(fn);
	    var memoized = initialParams(function memoized(args, callback) {
	        var key = hasher.apply(null, args);
	        if (has(memo, key)) {
	            setImmediate$1(function() {
	                callback.apply(null, memo[key]);
	            });
	        } else if (has(queues, key)) {
	            queues[key].push(callback);
	        } else {
	            queues[key] = [callback];
	            _fn.apply(null, args.concat(function(/*args*/) {
	                var args = slice(arguments);
	                memo[key] = args;
	                var q = queues[key];
	                delete queues[key];
	                for (var i = 0, l = q.length; i < l; i++) {
	                    q[i].apply(null, args);
	                }
	            }));
	        }
	    });
	    memoized.memo = memo;
	    memoized.unmemoized = fn;
	    return memoized;
	}
	
	/**
	 * Calls `callback` on a later loop around the event loop. In Node.js this just
	 * calls `process.nextTicl`.  In the browser it will use `setImmediate` if
	 * available, otherwise `setTimeout(callback, 0)`, which means other higher
	 * priority events may precede the execution of `callback`.
	 *
	 * This is used internally for browser-compatibility purposes.
	 *
	 * @name nextTick
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @see [async.setImmediate]{@link module:Utils.setImmediate}
	 * @category Util
	 * @param {Function} callback - The function to call on a later loop around
	 * the event loop. Invoked with (args...).
	 * @param {...*} args... - any number of additional arguments to pass to the
	 * callback on the next tick.
	 * @example
	 *
	 * var call_order = [];
	 * async.nextTick(function() {
	 *     call_order.push('two');
	 *     // call_order now equals ['one','two']
	 * });
	 * call_order.push('one');
	 *
	 * async.setImmediate(function (a, b, c) {
	 *     // a, b, and c equal 1, 2, and 3
	 * }, 1, 2, 3);
	 */
	var _defer$1;
	
	if (hasNextTick) {
	    _defer$1 = process.nextTick;
	} else if (hasSetImmediate) {
	    _defer$1 = setImmediate;
	} else {
	    _defer$1 = fallback;
	}
	
	var nextTick = wrap(_defer$1);
	
	function _parallel(eachfn, tasks, callback) {
	    callback = callback || noop;
	    var results = isArrayLike(tasks) ? [] : {};
	
	    eachfn(tasks, function (task, key, callback) {
	        wrapAsync(task)(function (err, result) {
	            if (arguments.length > 2) {
	                result = slice(arguments, 1);
	            }
	            results[key] = result;
	            callback(err);
	        });
	    }, function (err) {
	        callback(err, results);
	    });
	}
	
	/**
	 * Run the `tasks` collection of functions in parallel, without waiting until
	 * the previous function has completed. If any of the functions pass an error to
	 * its callback, the main `callback` is immediately called with the value of the
	 * error. Once the `tasks` have completed, the results are passed to the final
	 * `callback` as an array.
	 *
	 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
	 * parallel execution of code.  If your tasks do not use any timers or perform
	 * any I/O, they will actually be executed in series.  Any synchronous setup
	 * sections for each task will happen one after the other.  JavaScript remains
	 * single-threaded.
	 *
	 * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
	 * execution of other tasks when a task fails.
	 *
	 * It is also possible to use an object instead of an array. Each property will
	 * be run as a function and the results will be passed to the final `callback`
	 * as an object instead of an array. This can be a more readable way of handling
	 * results from {@link async.parallel}.
	 *
	 * @name parallel
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection of
	 * [async functions]{@link AsyncFunction} to run.
	 * Each async function can complete with any number of optional `result` values.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed successfully. This function gets a results array
	 * (or object) containing all the result arguments passed to the task callbacks.
	 * Invoked with (err, results).
	 *
	 * @example
	 * async.parallel([
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // the results array will equal ['one','two'] even though
	 *     // the second function had a shorter timeout.
	 * });
	 *
	 * // an example using an object instead of an array
	 * async.parallel({
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 1);
	 *         }, 200);
	 *     },
	 *     two: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 2);
	 *         }, 100);
	 *     }
	 * }, function(err, results) {
	 *     // results is now equals to: {one: 1, two: 2}
	 * });
	 */
	function parallelLimit(tasks, callback) {
	    _parallel(eachOf, tasks, callback);
	}
	
	/**
	 * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name parallelLimit
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.parallel]{@link module:ControlFlow.parallel}
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection of
	 * [async functions]{@link AsyncFunction} to run.
	 * Each async function can complete with any number of optional `result` values.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed successfully. This function gets a results array
	 * (or object) containing all the result arguments passed to the task callbacks.
	 * Invoked with (err, results).
	 */
	function parallelLimit$1(tasks, limit, callback) {
	    _parallel(_eachOfLimit(limit), tasks, callback);
	}
	
	/**
	 * A queue of tasks for the worker function to complete.
	 * @typedef {Object} QueueObject
	 * @memberOf module:ControlFlow
	 * @property {Function} length - a function returning the number of items
	 * waiting to be processed. Invoke with `queue.length()`.
	 * @property {boolean} started - a boolean indicating whether or not any
	 * items have been pushed and processed by the queue.
	 * @property {Function} running - a function returning the number of items
	 * currently being processed. Invoke with `queue.running()`.
	 * @property {Function} workersList - a function returning the array of items
	 * currently being processed. Invoke with `queue.workersList()`.
	 * @property {Function} idle - a function returning false if there are items
	 * waiting or being processed, or true if not. Invoke with `queue.idle()`.
	 * @property {number} concurrency - an integer for determining how many `worker`
	 * functions should be run in parallel. This property can be changed after a
	 * `queue` is created to alter the concurrency on-the-fly.
	 * @property {Function} push - add a new task to the `queue`. Calls `callback`
	 * once the `worker` has finished processing the task. Instead of a single task,
	 * a `tasks` array can be submitted. The respective callback is used for every
	 * task in the list. Invoke with `queue.push(task, [callback])`,
	 * @property {Function} unshift - add a new task to the front of the `queue`.
	 * Invoke with `queue.unshift(task, [callback])`.
	 * @property {Function} remove - remove items from the queue that match a test
	 * function.  The test function will be passed an object with a `data` property,
	 * and a `priority` property, if this is a
	 * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
	 * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
	 * `function ({data, priority}) {}` and returns a Boolean.
	 * @property {Function} saturated - a callback that is called when the number of
	 * running workers hits the `concurrency` limit, and further tasks will be
	 * queued.
	 * @property {Function} unsaturated - a callback that is called when the number
	 * of running workers is less than the `concurrency` & `buffer` limits, and
	 * further tasks will not be queued.
	 * @property {number} buffer - A minimum threshold buffer in order to say that
	 * the `queue` is `unsaturated`.
	 * @property {Function} empty - a callback that is called when the last item
	 * from the `queue` is given to a `worker`.
	 * @property {Function} drain - a callback that is called when the last item
	 * from the `queue` has returned from the `worker`.
	 * @property {Function} error - a callback that is called when a task errors.
	 * Has the signature `function(error, task)`.
	 * @property {boolean} paused - a boolean for determining whether the queue is
	 * in a paused state.
	 * @property {Function} pause - a function that pauses the processing of tasks
	 * until `resume()` is called. Invoke with `queue.pause()`.
	 * @property {Function} resume - a function that resumes the processing of
	 * queued tasks when the queue is paused. Invoke with `queue.resume()`.
	 * @property {Function} kill - a function that removes the `drain` callback and
	 * empties remaining tasks from the queue forcing it to go idle. No more tasks
	 * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
	 */
	
	/**
	 * Creates a `queue` object with the specified `concurrency`. Tasks added to the
	 * `queue` are processed in parallel (up to the `concurrency` limit). If all
	 * `worker`s are in progress, the task is queued until one becomes available.
	 * Once a `worker` completes a `task`, that `task`'s callback is called.
	 *
	 * @name queue
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {AsyncFunction} worker - An async function for processing a queued task.
	 * If you want to handle errors from an individual task, pass a callback to
	 * `q.push()`. Invoked with (task, callback).
	 * @param {number} [concurrency=1] - An `integer` for determining how many
	 * `worker` functions should be run in parallel.  If omitted, the concurrency
	 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
	 * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can
	 * attached as certain properties to listen for specific events during the
	 * lifecycle of the queue.
	 * @example
	 *
	 * // create a queue object with concurrency 2
	 * var q = async.queue(function(task, callback) {
	 *     console.log('hello ' + task.name);
	 *     callback();
	 * }, 2);
	 *
	 * // assign a callback
	 * q.drain = function() {
	 *     console.log('all items have been processed');
	 * };
	 *
	 * // add some items to the queue
	 * q.push({name: 'foo'}, function(err) {
	 *     console.log('finished processing foo');
	 * });
	 * q.push({name: 'bar'}, function (err) {
	 *     console.log('finished processing bar');
	 * });
	 *
	 * // add some items to the queue (batch-wise)
	 * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
	 *     console.log('finished processing item');
	 * });
	 *
	 * // add some items to the front of the queue
	 * q.unshift({name: 'bar'}, function (err) {
	 *     console.log('finished processing bar');
	 * });
	 */
	var queue$1 = function (worker, concurrency) {
	    var _worker = wrapAsync(worker);
	    return queue(function (items, cb) {
	        _worker(items[0], cb);
	    }, concurrency, 1);
	};
	
	/**
	 * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
	 * completed in ascending priority order.
	 *
	 * @name priorityQueue
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.queue]{@link module:ControlFlow.queue}
	 * @category Control Flow
	 * @param {AsyncFunction} worker - An async function for processing a queued task.
	 * If you want to handle errors from an individual task, pass a callback to
	 * `q.push()`.
	 * Invoked with (task, callback).
	 * @param {number} concurrency - An `integer` for determining how many `worker`
	 * functions should be run in parallel.  If omitted, the concurrency defaults to
	 * `1`.  If the concurrency is `0`, an error is thrown.
	 * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are two
	 * differences between `queue` and `priorityQueue` objects:
	 * * `push(task, priority, [callback])` - `priority` should be a number. If an
	 *   array of `tasks` is given, all tasks will be assigned the same priority.
	 * * The `unshift` method was removed.
	 */
	var priorityQueue = function(worker, concurrency) {
	    // Start with a normal queue
	    var q = queue$1(worker, concurrency);
	
	    // Override push to accept second parameter representing priority
	    q.push = function(data, priority, callback) {
	        if (callback == null) callback = noop;
	        if (typeof callback !== 'function') {
	            throw new Error('task callback must be a function');
	        }
	        q.started = true;
	        if (!isArray(data)) {
	            data = [data];
	        }
	        if (data.length === 0) {
	            // call drain immediately if there are no tasks
	            return setImmediate$1(function() {
	                q.drain();
	            });
	        }
	
	        priority = priority || 0;
	        var nextNode = q._tasks.head;
	        while (nextNode && priority >= nextNode.priority) {
	            nextNode = nextNode.next;
	        }
	
	        for (var i = 0, l = data.length; i < l; i++) {
	            var item = {
	                data: data[i],
	                priority: priority,
	                callback: callback
	            };
	
	            if (nextNode) {
	                q._tasks.insertBefore(nextNode, item);
	            } else {
	                q._tasks.push(item);
	            }
	        }
	        setImmediate$1(q.process);
	    };
	
	    // Remove unshift function
	    delete q.unshift;
	
	    return q;
	};
	
	/**
	 * Runs the `tasks` array of functions in parallel, without waiting until the
	 * previous function has completed. Once any of the `tasks` complete or pass an
	 * error to its callback, the main `callback` is immediately called. It's
	 * equivalent to `Promise.race()`.
	 *
	 * @name race
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
	 * to run. Each function can complete with an optional `result` value.
	 * @param {Function} callback - A callback to run once any of the functions have
	 * completed. This function gets an error or result from the first function that
	 * completed. Invoked with (err, result).
	 * @returns undefined
	 * @example
	 *
	 * async.race([
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ],
	 * // main callback
	 * function(err, result) {
	 *     // the result will be equal to 'two' as it finishes earlier
	 * });
	 */
	function race(tasks, callback) {
	    callback = once(callback || noop);
	    if (!isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
	    if (!tasks.length) return callback();
	    for (var i = 0, l = tasks.length; i < l; i++) {
	        wrapAsync(tasks[i])(callback);
	    }
	}
	
	/**
	 * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
	 *
	 * @name reduceRight
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.reduce]{@link module:Collections.reduce}
	 * @alias foldr
	 * @category Collection
	 * @param {Array} array - A collection to iterate over.
	 * @param {*} memo - The initial state of the reduction.
	 * @param {AsyncFunction} iteratee - A function applied to each item in the
	 * array to produce the next step in the reduction.
	 * The `iteratee` should complete with the next state of the reduction.
	 * If the iteratee complete with an error, the reduction is stopped and the
	 * main `callback` is immediately called with the error.
	 * Invoked with (memo, item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result is the reduced value. Invoked with
	 * (err, result).
	 */
	function reduceRight (array, memo, iteratee, callback) {
	    var reversed = slice(array).reverse();
	    reduce(reversed, memo, iteratee, callback);
	}
	
	/**
	 * Wraps the async function in another function that always completes with a
	 * result object, even when it errors.
	 *
	 * The result object has either the property `error` or `value`.
	 *
	 * @name reflect
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} fn - The async function you want to wrap
	 * @returns {Function} - A function that always passes null to it's callback as
	 * the error. The second argument to the callback will be an `object` with
	 * either an `error` or a `value` property.
	 * @example
	 *
	 * async.parallel([
	 *     async.reflect(function(callback) {
	 *         // do some stuff ...
	 *         callback(null, 'one');
	 *     }),
	 *     async.reflect(function(callback) {
	 *         // do some more stuff but error ...
	 *         callback('bad stuff happened');
	 *     }),
	 *     async.reflect(function(callback) {
	 *         // do some more stuff ...
	 *         callback(null, 'two');
	 *     })
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // values
	 *     // results[0].value = 'one'
	 *     // results[1].error = 'bad stuff happened'
	 *     // results[2].value = 'two'
	 * });
	 */
	function reflect(fn) {
	    var _fn = wrapAsync(fn);
	    return initialParams(function reflectOn(args, reflectCallback) {
	        args.push(function callback(error, cbArg) {
	            if (error) {
	                reflectCallback(null, { error: error });
	            } else {
	                var value;
	                if (arguments.length <= 2) {
	                    value = cbArg;
	                } else {
	                    value = slice(arguments, 1);
	                }
	                reflectCallback(null, { value: value });
	            }
	        });
	
	        return _fn.apply(this, args);
	    });
	}
	
	/**
	 * A helper function that wraps an array or an object of functions with `reflect`.
	 *
	 * @name reflectAll
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @see [async.reflect]{@link module:Utils.reflect}
	 * @category Util
	 * @param {Array|Object|Iterable} tasks - The collection of
	 * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
	 * @returns {Array} Returns an array of async functions, each wrapped in
	 * `async.reflect`
	 * @example
	 *
	 * let tasks = [
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         // do some more stuff but error ...
	 *         callback(new Error('bad stuff happened'));
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ];
	 *
	 * async.parallel(async.reflectAll(tasks),
	 * // optional callback
	 * function(err, results) {
	 *     // values
	 *     // results[0].value = 'one'
	 *     // results[1].error = Error('bad stuff happened')
	 *     // results[2].value = 'two'
	 * });
	 *
	 * // an example using an object instead of an array
	 * let tasks = {
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     two: function(callback) {
	 *         callback('two');
	 *     },
	 *     three: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'three');
	 *         }, 100);
	 *     }
	 * };
	 *
	 * async.parallel(async.reflectAll(tasks),
	 * // optional callback
	 * function(err, results) {
	 *     // values
	 *     // results.one.value = 'one'
	 *     // results.two.error = 'two'
	 *     // results.three.value = 'three'
	 * });
	 */
	function reflectAll(tasks) {
	    var results;
	    if (isArray(tasks)) {
	        results = arrayMap(tasks, reflect);
	    } else {
	        results = {};
	        baseForOwn(tasks, function(task, key) {
	            results[key] = reflect.call(this, task);
	        });
	    }
	    return results;
	}
	
	function reject$1(eachfn, arr, iteratee, callback) {
	    _filter(eachfn, arr, function(value, cb) {
	        iteratee(value, function(err, v) {
	            cb(err, !v);
	        });
	    }, callback);
	}
	
	/**
	 * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
	 *
	 * @name reject
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.filter]{@link module:Collections.filter}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - An async truth test to apply to each item in
	 * `coll`.
	 * The should complete with a boolean value as its `result`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 * @example
	 *
	 * async.reject(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, results) {
	 *     // results now equals an array of missing files
	 *     createFiles(results);
	 * });
	 */
	var reject = doParallel(reject$1);
	
	/**
	 * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name rejectLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.reject]{@link module:Collections.reject}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - An async truth test to apply to each item in
	 * `coll`.
	 * The should complete with a boolean value as its `result`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 */
	var rejectLimit = doParallelLimit(reject$1);
	
	/**
	 * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
	 *
	 * @name rejectSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.reject]{@link module:Collections.reject}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - An async truth test to apply to each item in
	 * `coll`.
	 * The should complete with a boolean value as its `result`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 */
	var rejectSeries = doLimit(rejectLimit, 1);
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant$1(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * Attempts to get a successful response from `task` no more than `times` times
	 * before returning an error. If the task is successful, the `callback` will be
	 * passed the result of the successful task. If all attempts fail, the callback
	 * will be passed the error and result (if any) of the final attempt.
	 *
	 * @name retry
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @see [async.retryable]{@link module:ControlFlow.retryable}
	 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
	 * object with `times` and `interval` or a number.
	 * * `times` - The number of attempts to make before giving up.  The default
	 *   is `5`.
	 * * `interval` - The time to wait between retries, in milliseconds.  The
	 *   default is `0`. The interval may also be specified as a function of the
	 *   retry count (see example).
	 * * `errorFilter` - An optional synchronous function that is invoked on
	 *   erroneous result. If it returns `true` the retry attempts will continue;
	 *   if the function returns `false` the retry flow is aborted with the current
	 *   attempt's error and result being returned to the final callback.
	 *   Invoked with (err).
	 * * If `opts` is a number, the number specifies the number of times to retry,
	 *   with the default interval of `0`.
	 * @param {AsyncFunction} task - An async function to retry.
	 * Invoked with (callback).
	 * @param {Function} [callback] - An optional callback which is called when the
	 * task has succeeded, or after the final failed attempt. It receives the `err`
	 * and `result` arguments of the last attempt at completing the `task`. Invoked
	 * with (err, results).
	 *
	 * @example
	 *
	 * // The `retry` function can be used as a stand-alone control flow by passing
	 * // a callback, as shown below:
	 *
	 * // try calling apiMethod 3 times
	 * async.retry(3, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod 3 times, waiting 200 ms between each retry
	 * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod 10 times with exponential backoff
	 * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
	 * async.retry({
	 *   times: 10,
	 *   interval: function(retryCount) {
	 *     return 50 * Math.pow(2, retryCount);
	 *   }
	 * }, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod the default 5 times no delay between each retry
	 * async.retry(apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod only when error condition satisfies, all other
	 * // errors will abort the retry control flow and return to final callback
	 * async.retry({
	 *   errorFilter: function(err) {
	 *     return err.message === 'Temporary error'; // only retry on a specific error
	 *   }
	 * }, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // to retry individual methods that are not as reliable within other
	 * // control flow functions, use the `retryable` wrapper:
	 * async.auto({
	 *     users: api.getUsers.bind(api),
	 *     payments: async.retryable(3, api.getPayments.bind(api))
	 * }, function(err, results) {
	 *     // do something with the results
	 * });
	 *
	 */
	function retry(opts, task, callback) {
	    var DEFAULT_TIMES = 5;
	    var DEFAULT_INTERVAL = 0;
	
	    var options = {
	        times: DEFAULT_TIMES,
	        intervalFunc: constant$1(DEFAULT_INTERVAL)
	    };
	
	    function parseTimes(acc, t) {
	        if (typeof t === 'object') {
	            acc.times = +t.times || DEFAULT_TIMES;
	
	            acc.intervalFunc = typeof t.interval === 'function' ?
	                t.interval :
	                constant$1(+t.interval || DEFAULT_INTERVAL);
	
	            acc.errorFilter = t.errorFilter;
	        } else if (typeof t === 'number' || typeof t === 'string') {
	            acc.times = +t || DEFAULT_TIMES;
	        } else {
	            throw new Error("Invalid arguments for async.retry");
	        }
	    }
	
	    if (arguments.length < 3 && typeof opts === 'function') {
	        callback = task || noop;
	        task = opts;
	    } else {
	        parseTimes(options, opts);
	        callback = callback || noop;
	    }
	
	    if (typeof task !== 'function') {
	        throw new Error("Invalid arguments for async.retry");
	    }
	
	    var _task = wrapAsync(task);
	
	    var attempt = 1;
	    function retryAttempt() {
	        _task(function(err) {
	            if (err && attempt++ < options.times &&
	                (typeof options.errorFilter != 'function' ||
	                    options.errorFilter(err))) {
	                setTimeout(retryAttempt, options.intervalFunc(attempt));
	            } else {
	                callback.apply(null, arguments);
	            }
	        });
	    }
	
	    retryAttempt();
	}
	
	/**
	 * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
	 * wraps a task and makes it retryable, rather than immediately calling it
	 * with retries.
	 *
	 * @name retryable
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.retry]{@link module:ControlFlow.retry}
	 * @category Control Flow
	 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
	 * options, exactly the same as from `retry`
	 * @param {AsyncFunction} task - the asynchronous function to wrap.
	 * This function will be passed any arguments passed to the returned wrapper.
	 * Invoked with (...args, callback).
	 * @returns {AsyncFunction} The wrapped function, which when invoked, will
	 * retry on an error, based on the parameters specified in `opts`.
	 * This function will accept the same parameters as `task`.
	 * @example
	 *
	 * async.auto({
	 *     dep1: async.retryable(3, getFromFlakyService),
	 *     process: ["dep1", async.retryable(3, function (results, cb) {
	 *         maybeProcessData(results.dep1, cb);
	 *     })]
	 * }, callback);
	 */
	var retryable = function (opts, task) {
	    if (!task) {
	        task = opts;
	        opts = null;
	    }
	    var _task = wrapAsync(task);
	    return initialParams(function (args, callback) {
	        function taskFn(cb) {
	            _task.apply(null, args.concat(cb));
	        }
	
	        if (opts) retry(opts, taskFn, callback);
	        else retry(taskFn, callback);
	
	    });
	};
	
	/**
	 * Run the functions in the `tasks` collection in series, each one running once
	 * the previous function has completed. If any functions in the series pass an
	 * error to its callback, no more functions are run, and `callback` is
	 * immediately called with the value of the error. Otherwise, `callback`
	 * receives an array of results when `tasks` have completed.
	 *
	 * It is also possible to use an object instead of an array. Each property will
	 * be run as a function, and the results will be passed to the final `callback`
	 * as an object instead of an array. This can be a more readable way of handling
	 *  results from {@link async.series}.
	 *
	 * **Note** that while many implementations preserve the order of object
	 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
	 * explicitly states that
	 *
	 * > The mechanics and order of enumerating the properties is not specified.
	 *
	 * So if you rely on the order in which your series of functions are executed,
	 * and want this to work on all platforms, consider using an array.
	 *
	 * @name series
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection containing
	 * [async functions]{@link AsyncFunction} to run in series.
	 * Each function can complete with any number of optional `result` values.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed. This function gets a results array (or object)
	 * containing all the result arguments passed to the `task` callbacks. Invoked
	 * with (err, result).
	 * @example
	 * async.series([
	 *     function(callback) {
	 *         // do some stuff ...
	 *         callback(null, 'one');
	 *     },
	 *     function(callback) {
	 *         // do some more stuff ...
	 *         callback(null, 'two');
	 *     }
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // results is now equal to ['one', 'two']
	 * });
	 *
	 * async.series({
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 1);
	 *         }, 200);
	 *     },
	 *     two: function(callback){
	 *         setTimeout(function() {
	 *             callback(null, 2);
	 *         }, 100);
	 *     }
	 * }, function(err, results) {
	 *     // results is now equal to: {one: 1, two: 2}
	 * });
	 */
	function series(tasks, callback) {
	    _parallel(eachOfSeries, tasks, callback);
	}
	
	/**
	 * Returns `true` if at least one element in the `coll` satisfies an async test.
	 * If any iteratee call returns `true`, the main `callback` is immediately
	 * called.
	 *
	 * @name some
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias any
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collections in parallel.
	 * The iteratee should complete with a boolean `result` value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the iteratee functions have finished.
	 * Result will be either `true` or `false` depending on the values of the async
	 * tests. Invoked with (err, result).
	 * @example
	 *
	 * async.some(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, result) {
	 *     // if result is true then at least one of the files exists
	 * });
	 */
	var some = doParallel(_createTester(Boolean, identity));
	
	/**
	 * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name someLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.some]{@link module:Collections.some}
	 * @alias anyLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collections in parallel.
	 * The iteratee should complete with a boolean `result` value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the iteratee functions have finished.
	 * Result will be either `true` or `false` depending on the values of the async
	 * tests. Invoked with (err, result).
	 */
	var someLimit = doParallelLimit(_createTester(Boolean, identity));
	
	/**
	 * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
	 *
	 * @name someSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.some]{@link module:Collections.some}
	 * @alias anySeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collections in series.
	 * The iteratee should complete with a boolean `result` value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the iteratee functions have finished.
	 * Result will be either `true` or `false` depending on the values of the async
	 * tests. Invoked with (err, result).
	 */
	var someSeries = doLimit(someLimit, 1);
	
	/**
	 * Sorts a list by the results of running each `coll` value through an async
	 * `iteratee`.
	 *
	 * @name sortBy
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with a value to use as the sort criteria as
	 * its `result`.
	 * Invoked with (item, callback).
	 * @param {Function} callback - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is the items
	 * from the original `coll` sorted by the values returned by the `iteratee`
	 * calls. Invoked with (err, results).
	 * @example
	 *
	 * async.sortBy(['file1','file2','file3'], function(file, callback) {
	 *     fs.stat(file, function(err, stats) {
	 *         callback(err, stats.mtime);
	 *     });
	 * }, function(err, results) {
	 *     // results is now the original array of files sorted by
	 *     // modified date
	 * });
	 *
	 * // By modifying the callback parameter the
	 * // sorting order can be influenced:
	 *
	 * // ascending order
	 * async.sortBy([1,9,3,5], function(x, callback) {
	 *     callback(null, x);
	 * }, function(err,result) {
	 *     // result callback
	 * });
	 *
	 * // descending order
	 * async.sortBy([1,9,3,5], function(x, callback) {
	 *     callback(null, x*-1);    //<- x*-1 instead of x, turns the order around
	 * }, function(err,result) {
	 *     // result callback
	 * });
	 */
	function sortBy (coll, iteratee, callback) {
	    var _iteratee = wrapAsync(iteratee);
	    map(coll, function (x, callback) {
	        _iteratee(x, function (err, criteria) {
	            if (err) return callback(err);
	            callback(null, {value: x, criteria: criteria});
	        });
	    }, function (err, results) {
	        if (err) return callback(err);
	        callback(null, arrayMap(results.sort(comparator), baseProperty('value')));
	    });
	
	    function comparator(left, right) {
	        var a = left.criteria, b = right.criteria;
	        return a < b ? -1 : a > b ? 1 : 0;
	    }
	}
	
	/**
	 * Sets a time limit on an asynchronous function. If the function does not call
	 * its callback within the specified milliseconds, it will be called with a
	 * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
	 *
	 * @name timeout
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} asyncFn - The async function to limit in time.
	 * @param {number} milliseconds - The specified time limit.
	 * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
	 * to timeout Error for more information..
	 * @returns {AsyncFunction} Returns a wrapped function that can be used with any
	 * of the control flow functions.
	 * Invoke this function with the same parameters as you would `asyncFunc`.
	 * @example
	 *
	 * function myFunction(foo, callback) {
	 *     doAsyncTask(foo, function(err, data) {
	 *         // handle errors
	 *         if (err) return callback(err);
	 *
	 *         // do some stuff ...
	 *
	 *         // return processed data
	 *         return callback(null, data);
	 *     });
	 * }
	 *
	 * var wrapped = async.timeout(myFunction, 1000);
	 *
	 * // call `wrapped` as you would `myFunction`
	 * wrapped({ bar: 'bar' }, function(err, data) {
	 *     // if `myFunction` takes < 1000 ms to execute, `err`
	 *     // and `data` will have their expected values
	 *
	 *     // else `err` will be an Error with the code 'ETIMEDOUT'
	 * });
	 */
	function timeout(asyncFn, milliseconds, info) {
	    var fn = wrapAsync(asyncFn);
	
	    return initialParams(function (args, callback) {
	        var timedOut = false;
	        var timer;
	
	        function timeoutCallback() {
	            var name = asyncFn.name || 'anonymous';
	            var error  = new Error('Callback function "' + name + '" timed out.');
	            error.code = 'ETIMEDOUT';
	            if (info) {
	                error.info = info;
	            }
	            timedOut = true;
	            callback(error);
	        }
	
	        args.push(function () {
	            if (!timedOut) {
	                callback.apply(null, arguments);
	                clearTimeout(timer);
	            }
	        });
	
	        // setup timer and call original function
	        timer = setTimeout(timeoutCallback, milliseconds);
	        fn.apply(null, args);
	    });
	}
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil;
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	/**
	 * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name timesLimit
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.times]{@link module:ControlFlow.times}
	 * @category Control Flow
	 * @param {number} count - The number of times to run the function.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - The async function to call `n` times.
	 * Invoked with the iteration index and a callback: (n, next).
	 * @param {Function} callback - see [async.map]{@link module:Collections.map}.
	 */
	function timeLimit(count, limit, iteratee, callback) {
	    var _iteratee = wrapAsync(iteratee);
	    mapLimit(baseRange(0, count, 1), limit, _iteratee, callback);
	}
	
	/**
	 * Calls the `iteratee` function `n` times, and accumulates results in the same
	 * manner you would use with [map]{@link module:Collections.map}.
	 *
	 * @name times
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.map]{@link module:Collections.map}
	 * @category Control Flow
	 * @param {number} n - The number of times to run the function.
	 * @param {AsyncFunction} iteratee - The async function to call `n` times.
	 * Invoked with the iteration index and a callback: (n, next).
	 * @param {Function} callback - see {@link module:Collections.map}.
	 * @example
	 *
	 * // Pretend this is some complicated async factory
	 * var createUser = function(id, callback) {
	 *     callback(null, {
	 *         id: 'user' + id
	 *     });
	 * };
	 *
	 * // generate 5 users
	 * async.times(5, function(n, next) {
	 *     createUser(n, function(err, user) {
	 *         next(err, user);
	 *     });
	 * }, function(err, users) {
	 *     // we should now have 5 users
	 * });
	 */
	var times = doLimit(timeLimit, Infinity);
	
	/**
	 * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
	 *
	 * @name timesSeries
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.times]{@link module:ControlFlow.times}
	 * @category Control Flow
	 * @param {number} n - The number of times to run the function.
	 * @param {AsyncFunction} iteratee - The async function to call `n` times.
	 * Invoked with the iteration index and a callback: (n, next).
	 * @param {Function} callback - see {@link module:Collections.map}.
	 */
	var timesSeries = doLimit(timeLimit, 1);
	
	/**
	 * A relative of `reduce`.  Takes an Object or Array, and iterates over each
	 * element in series, each step potentially mutating an `accumulator` value.
	 * The type of the accumulator defaults to the type of collection passed in.
	 *
	 * @name transform
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {*} [accumulator] - The initial state of the transform.  If omitted,
	 * it will default to an empty Object or Array, depending on the type of `coll`
	 * @param {AsyncFunction} iteratee - A function applied to each item in the
	 * collection that potentially modifies the accumulator.
	 * Invoked with (accumulator, item, key, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result is the transformed accumulator.
	 * Invoked with (err, result).
	 * @example
	 *
	 * async.transform([1,2,3], function(acc, item, index, callback) {
	 *     // pointless async:
	 *     process.nextTick(function() {
	 *         acc.push(item * 2)
	 *         callback(null)
	 *     });
	 * }, function(err, result) {
	 *     // result is now equal to [2, 4, 6]
	 * });
	 *
	 * @example
	 *
	 * async.transform({a: 1, b: 2, c: 3}, function (obj, val, key, callback) {
	 *     setImmediate(function () {
	 *         obj[key] = val * 2;
	 *         callback();
	 *     })
	 * }, function (err, result) {
	 *     // result is equal to {a: 2, b: 4, c: 6}
	 * })
	 */
	function transform (coll, accumulator, iteratee, callback) {
	    if (arguments.length <= 3) {
	        callback = iteratee;
	        iteratee = accumulator;
	        accumulator = isArray(coll) ? [] : {};
	    }
	    callback = once(callback || noop);
	    var _iteratee = wrapAsync(iteratee);
	
	    eachOf(coll, function(v, k, cb) {
	        _iteratee(accumulator, v, k, cb);
	    }, function(err) {
	        callback(err, accumulator);
	    });
	}
	
	/**
	 * It runs each task in series but stops whenever any of the functions were
	 * successful. If one of the tasks were successful, the `callback` will be
	 * passed the result of the successful task. If all tasks fail, the callback
	 * will be passed the error and result (if any) of the final attempt.
	 *
	 * @name tryEach
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection containing functions to
	 * run, each function is passed a `callback(err, result)` it must call on
	 * completion with an error `err` (which can be `null`) and an optional `result`
	 * value.
	 * @param {Function} [callback] - An optional callback which is called when one
	 * of the tasks has succeeded, or all have failed. It receives the `err` and
	 * `result` arguments of the last attempt at completing the `task`. Invoked with
	 * (err, results).
	 * @example
	 * async.tryEach([
	 *     function getDataFromFirstWebsite(callback) {
	 *         // Try getting the data from the first website
	 *         callback(err, data);
	 *     },
	 *     function getDataFromSecondWebsite(callback) {
	 *         // First website failed,
	 *         // Try getting the data from the backup website
	 *         callback(err, data);
	 *     }
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     Now do something with the data.
	 * });
	 *
	 */
	function tryEach(tasks, callback) {
	    var error = null;
	    var result;
	    callback = callback || noop;
	    eachSeries(tasks, function(task, callback) {
	        wrapAsync(task)(function (err, res/*, ...args*/) {
	            if (arguments.length > 2) {
	                result = slice(arguments, 1);
	            } else {
	                result = res;
	            }
	            error = err;
	            callback(!err);
	        });
	    }, function () {
	        callback(error, result);
	    });
	}
	
	/**
	 * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
	 * unmemoized form. Handy for testing.
	 *
	 * @name unmemoize
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @see [async.memoize]{@link module:Utils.memoize}
	 * @category Util
	 * @param {AsyncFunction} fn - the memoized function
	 * @returns {AsyncFunction} a function that calls the original unmemoized function
	 */
	function unmemoize(fn) {
	    return function () {
	        return (fn.unmemoized || fn).apply(null, arguments);
	    };
	}
	
	/**
	 * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
	 * stopped, or an error occurs.
	 *
	 * @name whilst
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Function} test - synchronous truth test to perform before each
	 * execution of `iteratee`. Invoked with ().
	 * @param {AsyncFunction} iteratee - An async function which is called each time
	 * `test` passes. Invoked with (callback).
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `iteratee` has stopped. `callback`
	 * will be passed an error and any arguments passed to the final `iteratee`'s
	 * callback. Invoked with (err, [results]);
	 * @returns undefined
	 * @example
	 *
	 * var count = 0;
	 * async.whilst(
	 *     function() { return count < 5; },
	 *     function(callback) {
	 *         count++;
	 *         setTimeout(function() {
	 *             callback(null, count);
	 *         }, 1000);
	 *     },
	 *     function (err, n) {
	 *         // 5 seconds have passed, n = 5
	 *     }
	 * );
	 */
	function whilst(test, iteratee, callback) {
	    callback = onlyOnce(callback || noop);
	    var _iteratee = wrapAsync(iteratee);
	    if (!test()) return callback(null);
	    var next = function(err/*, ...args*/) {
	        if (err) return callback(err);
	        if (test()) return _iteratee(next);
	        var args = slice(arguments, 1);
	        callback.apply(null, [null].concat(args));
	    };
	    _iteratee(next);
	}
	
	/**
	 * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
	 * stopped, or an error occurs. `callback` will be passed an error and any
	 * arguments passed to the final `iteratee`'s callback.
	 *
	 * The inverse of [whilst]{@link module:ControlFlow.whilst}.
	 *
	 * @name until
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.whilst]{@link module:ControlFlow.whilst}
	 * @category Control Flow
	 * @param {Function} test - synchronous truth test to perform before each
	 * execution of `iteratee`. Invoked with ().
	 * @param {AsyncFunction} iteratee - An async function which is called each time
	 * `test` fails. Invoked with (callback).
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has passed and repeated execution of `iteratee` has stopped. `callback`
	 * will be passed an error and any arguments passed to the final `iteratee`'s
	 * callback. Invoked with (err, [results]);
	 */
	function until(test, iteratee, callback) {
	    whilst(function() {
	        return !test.apply(this, arguments);
	    }, iteratee, callback);
	}
	
	/**
	 * Runs the `tasks` array of functions in series, each passing their results to
	 * the next in the array. However, if any of the `tasks` pass an error to their
	 * own callback, the next function is not executed, and the main `callback` is
	 * immediately called with the error.
	 *
	 * @name waterfall
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
	 * to run.
	 * Each function should complete with any number of `result` values.
	 * The `result` values will be passed as arguments, in order, to the next task.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed. This will be passed the results of the last task's
	 * callback. Invoked with (err, [results]).
	 * @returns undefined
	 * @example
	 *
	 * async.waterfall([
	 *     function(callback) {
	 *         callback(null, 'one', 'two');
	 *     },
	 *     function(arg1, arg2, callback) {
	 *         // arg1 now equals 'one' and arg2 now equals 'two'
	 *         callback(null, 'three');
	 *     },
	 *     function(arg1, callback) {
	 *         // arg1 now equals 'three'
	 *         callback(null, 'done');
	 *     }
	 * ], function (err, result) {
	 *     // result now equals 'done'
	 * });
	 *
	 * // Or, with named functions:
	 * async.waterfall([
	 *     myFirstFunction,
	 *     mySecondFunction,
	 *     myLastFunction,
	 * ], function (err, result) {
	 *     // result now equals 'done'
	 * });
	 * function myFirstFunction(callback) {
	 *     callback(null, 'one', 'two');
	 * }
	 * function mySecondFunction(arg1, arg2, callback) {
	 *     // arg1 now equals 'one' and arg2 now equals 'two'
	 *     callback(null, 'three');
	 * }
	 * function myLastFunction(arg1, callback) {
	 *     // arg1 now equals 'three'
	 *     callback(null, 'done');
	 * }
	 */
	var waterfall = function(tasks, callback) {
	    callback = once(callback || noop);
	    if (!isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
	    if (!tasks.length) return callback();
	    var taskIndex = 0;
	
	    function nextTask(args) {
	        var task = wrapAsync(tasks[taskIndex++]);
	        args.push(onlyOnce(next));
	        task.apply(null, args);
	    }
	
	    function next(err/*, ...args*/) {
	        if (err || taskIndex === tasks.length) {
	            return callback.apply(null, arguments);
	        }
	        nextTask(slice(arguments, 1));
	    }
	
	    nextTask([]);
	};
	
	/**
	 * An "async function" in the context of Async is an asynchronous function with
	 * a variable number of parameters, with the final parameter being a callback.
	 * (`function (arg1, arg2, ..., callback) {}`)
	 * The final callback is of the form `callback(err, results...)`, which must be
	 * called once the function is completed.  The callback should be called with a
	 * Error as its first argument to signal that an error occurred.
	 * Otherwise, if no error occurred, it should be called with `null` as the first
	 * argument, and any additional `result` arguments that may apply, to signal
	 * successful completion.
	 * The callback must be called exactly once, ideally on a later tick of the
	 * JavaScript event loop.
	 *
	 * This type of function is also referred to as a "Node-style async function",
	 * or a "continuation passing-style function" (CPS). Most of the methods of this
	 * library are themselves CPS/Node-style async functions, or functions that
	 * return CPS/Node-style async functions.
	 *
	 * Wherever we accept a Node-style async function, we also directly accept an
	 * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
	 * In this case, the `async` function will not be passed a final callback
	 * argument, and any thrown error will be used as the `err` argument of the
	 * implicit callback, and the return value will be used as the `result` value.
	 * (i.e. a `rejected` of the returned Promise becomes the `err` callback
	 * argument, and a `resolved` value becomes the `result`.)
	 *
	 * Note, due to JavaScript limitations, we can only detect native `async`
	 * functions and not transpilied implementations.
	 * Your environment must have `async`/`await` support for this to work.
	 * (e.g. Node > v7.6, or a recent version of a modern browser).
	 * If you are using `async` functions through a transpiler (e.g. Babel), you
	 * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
	 * because the `async function` will be compiled to an ordinary function that
	 * returns a promise.
	 *
	 * @typedef {Function} AsyncFunction
	 * @static
	 */
	
	/**
	 * Async is a utility module which provides straight-forward, powerful functions
	 * for working with asynchronous JavaScript. Although originally designed for
	 * use with [Node.js](http://nodejs.org) and installable via
	 * `npm install --save async`, it can also be used directly in the browser.
	 * @module async
	 * @see AsyncFunction
	 */
	
	
	/**
	 * A collection of `async` functions for manipulating collections, such as
	 * arrays and objects.
	 * @module Collections
	 */
	
	/**
	 * A collection of `async` functions for controlling the flow through a script.
	 * @module ControlFlow
	 */
	
	/**
	 * A collection of `async` utility functions.
	 * @module Utils
	 */
	
	var index = {
	    apply: apply,
	    applyEach: applyEach,
	    applyEachSeries: applyEachSeries,
	    asyncify: asyncify,
	    auto: auto,
	    autoInject: autoInject,
	    cargo: cargo,
	    compose: compose,
	    concat: concat,
	    concatLimit: concatLimit,
	    concatSeries: concatSeries,
	    constant: constant,
	    detect: detect,
	    detectLimit: detectLimit,
	    detectSeries: detectSeries,
	    dir: dir,
	    doDuring: doDuring,
	    doUntil: doUntil,
	    doWhilst: doWhilst,
	    during: during,
	    each: eachLimit,
	    eachLimit: eachLimit$1,
	    eachOf: eachOf,
	    eachOfLimit: eachOfLimit,
	    eachOfSeries: eachOfSeries,
	    eachSeries: eachSeries,
	    ensureAsync: ensureAsync,
	    every: every,
	    everyLimit: everyLimit,
	    everySeries: everySeries,
	    filter: filter,
	    filterLimit: filterLimit,
	    filterSeries: filterSeries,
	    forever: forever,
	    groupBy: groupBy,
	    groupByLimit: groupByLimit,
	    groupBySeries: groupBySeries,
	    log: log,
	    map: map,
	    mapLimit: mapLimit,
	    mapSeries: mapSeries,
	    mapValues: mapValues,
	    mapValuesLimit: mapValuesLimit,
	    mapValuesSeries: mapValuesSeries,
	    memoize: memoize,
	    nextTick: nextTick,
	    parallel: parallelLimit,
	    parallelLimit: parallelLimit$1,
	    priorityQueue: priorityQueue,
	    queue: queue$1,
	    race: race,
	    reduce: reduce,
	    reduceRight: reduceRight,
	    reflect: reflect,
	    reflectAll: reflectAll,
	    reject: reject,
	    rejectLimit: rejectLimit,
	    rejectSeries: rejectSeries,
	    retry: retry,
	    retryable: retryable,
	    seq: seq,
	    series: series,
	    setImmediate: setImmediate$1,
	    some: some,
	    someLimit: someLimit,
	    someSeries: someSeries,
	    sortBy: sortBy,
	    timeout: timeout,
	    times: times,
	    timesLimit: timeLimit,
	    timesSeries: timesSeries,
	    transform: transform,
	    tryEach: tryEach,
	    unmemoize: unmemoize,
	    until: until,
	    waterfall: waterfall,
	    whilst: whilst,
	
	    // aliases
	    all: every,
	    allLimit: everyLimit,
	    allSeries: everySeries,
	    any: some,
	    anyLimit: someLimit,
	    anySeries: someSeries,
	    find: detect,
	    findLimit: detectLimit,
	    findSeries: detectSeries,
	    forEach: eachLimit,
	    forEachSeries: eachSeries,
	    forEachLimit: eachLimit$1,
	    forEachOf: eachOf,
	    forEachOfSeries: eachOfSeries,
	    forEachOfLimit: eachOfLimit,
	    inject: reduce,
	    foldl: reduce,
	    foldr: reduceRight,
	    select: filter,
	    selectLimit: filterLimit,
	    selectSeries: filterSeries,
	    wrapSync: asyncify
	};
	
	exports['default'] = index;
	exports.apply = apply;
	exports.applyEach = applyEach;
	exports.applyEachSeries = applyEachSeries;
	exports.asyncify = asyncify;
	exports.auto = auto;
	exports.autoInject = autoInject;
	exports.cargo = cargo;
	exports.compose = compose;
	exports.concat = concat;
	exports.concatLimit = concatLimit;
	exports.concatSeries = concatSeries;
	exports.constant = constant;
	exports.detect = detect;
	exports.detectLimit = detectLimit;
	exports.detectSeries = detectSeries;
	exports.dir = dir;
	exports.doDuring = doDuring;
	exports.doUntil = doUntil;
	exports.doWhilst = doWhilst;
	exports.during = during;
	exports.each = eachLimit;
	exports.eachLimit = eachLimit$1;
	exports.eachOf = eachOf;
	exports.eachOfLimit = eachOfLimit;
	exports.eachOfSeries = eachOfSeries;
	exports.eachSeries = eachSeries;
	exports.ensureAsync = ensureAsync;
	exports.every = every;
	exports.everyLimit = everyLimit;
	exports.everySeries = everySeries;
	exports.filter = filter;
	exports.filterLimit = filterLimit;
	exports.filterSeries = filterSeries;
	exports.forever = forever;
	exports.groupBy = groupBy;
	exports.groupByLimit = groupByLimit;
	exports.groupBySeries = groupBySeries;
	exports.log = log;
	exports.map = map;
	exports.mapLimit = mapLimit;
	exports.mapSeries = mapSeries;
	exports.mapValues = mapValues;
	exports.mapValuesLimit = mapValuesLimit;
	exports.mapValuesSeries = mapValuesSeries;
	exports.memoize = memoize;
	exports.nextTick = nextTick;
	exports.parallel = parallelLimit;
	exports.parallelLimit = parallelLimit$1;
	exports.priorityQueue = priorityQueue;
	exports.queue = queue$1;
	exports.race = race;
	exports.reduce = reduce;
	exports.reduceRight = reduceRight;
	exports.reflect = reflect;
	exports.reflectAll = reflectAll;
	exports.reject = reject;
	exports.rejectLimit = rejectLimit;
	exports.rejectSeries = rejectSeries;
	exports.retry = retry;
	exports.retryable = retryable;
	exports.seq = seq;
	exports.series = series;
	exports.setImmediate = setImmediate$1;
	exports.some = some;
	exports.someLimit = someLimit;
	exports.someSeries = someSeries;
	exports.sortBy = sortBy;
	exports.timeout = timeout;
	exports.times = times;
	exports.timesLimit = timeLimit;
	exports.timesSeries = timesSeries;
	exports.transform = transform;
	exports.tryEach = tryEach;
	exports.unmemoize = unmemoize;
	exports.until = until;
	exports.waterfall = waterfall;
	exports.whilst = whilst;
	exports.all = every;
	exports.allLimit = everyLimit;
	exports.allSeries = everySeries;
	exports.any = some;
	exports.anyLimit = someLimit;
	exports.anySeries = someSeries;
	exports.find = detect;
	exports.findLimit = detectLimit;
	exports.findSeries = detectSeries;
	exports.forEach = eachLimit;
	exports.forEachSeries = eachSeries;
	exports.forEachLimit = eachLimit$1;
	exports.forEachOf = eachOf;
	exports.forEachOfSeries = eachOfSeries;
	exports.forEachOfLimit = eachOfLimit;
	exports.inject = reduce;
	exports.foldl = reduce;
	exports.foldr = reduceRight;
	exports.select = filter;
	exports.selectLimit = filterLimit;
	exports.selectSeries = filterSeries;
	exports.wrapSync = asyncify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(760).setImmediate, __webpack_require__(170), (function() { return this; }()), __webpack_require__(146)(module)))

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setEmployees = setEmployees;
	exports.getOrderData = getOrderData;
	exports.getOrderDataNew = getOrderDataNew;
	exports.assignUsers = assignUsers;
	exports.getUserAssignments = getUserAssignments;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @module actions/address
	 */
	function setEmployees(employees) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_ACTIVE_EMPLOYEES,
	      employees: employees
	    });
	  };
	}
	
	/**
	 * @description Getting orders data
	 * @return {Promise} Axios promise
	 */
	function getOrderData(data) {
	  var url = _constants.API_URL + '/Assign/Get';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Getting orders data
	 * @return {Promise} Axios promise
	 */
	function getOrderDataNew(data) {
	  var url = _constants.API_URL + '/Assign/Get';
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      dispatch({
	        type: _constants.SET_STEP_ASSIGNMENTS,
	        StepAssignments: res.data.StepAssignments
	      });
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Assigns the users
	 * @return {Promise} Axios promise
	 */
	function assignUsers(data) {
	  var url = _constants.API_URL + '/Assign/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Getting user assignments
	 * @return {Promise} Axios promise
	 */
	function getUserAssignments(id) {
	  var url = _constants.API_URL + '/Assign/GetUserAssignments/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveEmbeddedBooking = saveEmbeddedBooking;
	exports.getBookingPortalWelcomeMessageFromToken = getBookingPortalWelcomeMessageFromToken;
	exports.getBookingPortalRedirectUrlFromToken = getBookingPortalRedirectUrlFromToken;
	exports.setEmbeddedBookingData = setEmbeddedBookingData;
	exports.setEmbeddedBookingCardata = setEmbeddedBookingCardata;
	exports.setEmbeddedBookingImages = setEmbeddedBookingImages;
	exports.setEmbeddedBookingDamageComment = setEmbeddedBookingDamageComment;
	exports.setEmbeddedBookingOtherInfo = setEmbeddedBookingOtherInfo;
	exports.setEmbeddedBookingContactInfo = setEmbeddedBookingContactInfo;
	exports.setEmbeddedInsuranceCompanies = setEmbeddedInsuranceCompanies;
	exports.setEmbeddedCarRentalAlts = setEmbeddedCarRentalAlts;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Save embedded booking data using the api
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/EmbeddedBooking
	 */
	function saveEmbeddedBooking(data) {
	  var url = _constants.API_URL + '/EmbeddedBooking/Post/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      dispatch(setEmbeddedBookingData(res.data));
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Get booking portal welcome message
	 * @return {Promise} Axios promise
	 */
	function getBookingPortalWelcomeMessageFromToken(token) {
	  var url = _constants.API_URL + '/EmbeddedBooking/GetBookingPortalWelcomeMessage';
	  var data = { token: token };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function getBookingPortalRedirectUrlFromToken(token, usageString) {
	  var usage = 0;
	  switch (usageString) {
	    case 'bookingportal':
	      usage = 1;
	      break;
	  }
	  var url = _constants.API_URL + '/EmbeddedBooking/GetBookingPortalRedirectUrl';
	  var data = { token: token, usage: usage };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function setEmbeddedBookingData(data) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_EMBEDDED_BOOKING_DATA,
	      data: data
	    });
	  };
	}
	
	function setEmbeddedBookingCardata(carData) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_EMBEDDED_BOOKING_CARDATA,
	      carData: carData
	    });
	  };
	}
	
	function setEmbeddedBookingImages(images) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_EMBEDDED_BOOKING_IMAGES,
	      images: images
	    });
	  };
	}
	
	function setEmbeddedBookingDamageComment(damageComment) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_EMBEDDED_BOOKING_DAMAGE_COMMENT,
	      damageComment: damageComment
	    });
	  };
	}
	
	function setEmbeddedBookingOtherInfo(otherInfo) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_EMBEDDED_BOOKING_OTHERINFO,
	      otherInfo: otherInfo
	    });
	  };
	}
	
	function setEmbeddedBookingContactInfo(contactInfo) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_EMBEDDED_BOOKING_CONTACTINFO,
	      contactInfo: contactInfo
	    });
	  };
	}
	
	function setEmbeddedInsuranceCompanies(insuranceCompanies) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_EMBEDDED_INSURANCE_COMPANIES,
	      insuranceCompanies: insuranceCompanies
	    });
	  };
	}
	
	function setEmbeddedCarRentalAlts(carRentalAlts) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_EMBEDDED_CARRENTAL_ALTERNATIVES,
	      carRentalAlts: carRentalAlts
	    });
	  };
	}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.invoiceOrder = invoiceOrder;
	exports.invoiceHistory = invoiceHistory;
	exports.approveOrderInvoice = approveOrderInvoice;
	exports.markAsInvoiced = markAsInvoiced;
	exports.getInvoiceStatus = getInvoiceStatus;
	exports.massInvoiceOrders = massInvoiceOrders;
	exports.massMarkInvoiced = massMarkInvoiced;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Invoice an order
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/invoicing
	 */
	function invoiceOrder(data) {
	  var url = _constants.API_URL + '/Invoice/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	/**
	 * @description Get last invoice history
	 * @return {Promise} Axios promise
	 */
	function invoiceHistory(orderid) {
	  var url = _constants.API_URL + '/LastInvoiceHistory/' + orderid;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	/**
	 * @description Approve order for invoice
	 * @return {Promise} Axios promise
	 */
	function approveOrderInvoice(orderId, undo) {
	  var url = _constants.API_URL + '/InvoiceReady';
	  var data = {
	    OrderId: orderId,
	    Undo: undo
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Mark order as invoiced
	 * @return {Promise} Axios promise
	 */
	function markAsInvoiced(orderId) {
	  var url = _constants.API_URL + '/MarkInvoiced';
	  var data = {
	    OrderId: orderId
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get order invoice status
	 * @return {Promise} Axios promise
	 */
	function getInvoiceStatus(orderId) {
	  var url = _constants.API_URL + '/GetInvoiceStatus/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description MassInvoice orders
	 * @return {Promise} Axios promise
	 */
	function massInvoiceOrders(data) {
	  var url = _constants.API_URL + '/MassInvoice';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Mass mark as invoiced
	 * @return {Promise} Axios promise
	 */
	function massMarkInvoiced(ids) {
	  var url = _constants.API_URL + '/MassMarkInvoiced';
	  return function (dispatch) {
	    return _axios2.default.post(url, ids);
	  };
	}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.myPageInformation = myPageInformation;
	exports.getMyMessages = getMyMessages;
	exports.getMessage = getMessage;
	exports.getMyOrders = getMyOrders;
	exports.getMyTasks = getMyTasks;
	exports.getOccurenceFiles = getOccurenceFiles;
	exports.startOtherTask = startOtherTask;
	exports.stopOtherTask = stopOtherTask;
	exports.assignUser = assignUser;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description My page information
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/mypage
	 */
	function myPageInformation(id) {
	  var url = _constants.API_URL + '/Users/MyPageInfo/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description My messages
	 * @return {Promise} Axios promise
	 */
	function getMyMessages(id) {
	  var url = _constants.API_URL + '/Message/GetUser/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get message
	 * @return {Promise} Axios promise
	 */
	function getMessage(id) {
	  var url = _constants.API_URL + '/Message/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description My orders
	 * @return {Promise} Axios promise
	 */
	function getMyOrders(id) {
	  var url = _constants.API_URL + '/Order/UserOrders/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description My tasks
	 * @return {Promise} Axios promise
	 */
	function getMyTasks(id) {
	  var url = _constants.API_URL + '/OtherTask/GetEmployeeOccurrences/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get occurence task
	 * @return {Promise} Axios promise
	 */
	function getOccurenceFiles(id) {
	  var url = _constants.API_URL + '/OtherTask/GetOccurrenceFiles/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Start other task
	 * @return {Promise} Axios promise
	 */
	function startOtherTask(data) {
	  var url = _constants.API_URL + '/OtherTask/Start';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Stop other task
	 * @return {Promise} Axios promise
	 */
	function stopOtherTask(data) {
	  var url = _constants.API_URL + '/OtherTask/Stop';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Assign current user to an occurrence
	 * @return {Promise} Axios promise
	 */
	function assignUser(OccurrenceId) {
	  var url = _constants.API_URL + '/OtherTask/Assign/' + OccurrenceId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	var _PriceLine = __webpack_require__(439);
	
	var _PriceLine2 = _interopRequireDefault(_PriceLine);
	
	var _EstimationLine = __webpack_require__(437);
	
	var _EstimationLine2 = _interopRequireDefault(_EstimationLine);
	
	var _ComplaintLine = __webpack_require__(1034);
	
	var _ComplaintLine2 = _interopRequireDefault(_ComplaintLine);
	
	var _DeviationLine = __webpack_require__(1036);
	
	var _DeviationLine2 = _interopRequireDefault(_DeviationLine);
	
	var _OtherDamageLine = __webpack_require__(1040);
	
	var _OtherDamageLine2 = _interopRequireDefault(_OtherDamageLine);
	
	__webpack_require__(1525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Line components
	
	
	var Part = function (_Component) {
	  _inherits(Part, _Component);
	
	  function Part() {
	    _classCallCheck(this, Part);
	
	    return _possibleConstructorReturn(this, (Part.__proto__ || Object.getPrototypeOf(Part)).apply(this, arguments));
	  }
	
	  _createClass(Part, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var tasks = this.props.part.Tasks;
	      var estimationTasks = this.props.part.EstimationTasks;
	      var complaints = this.props.part.Complaints;
	      var deviationReasons = this.props.part.DeviationReasons;
	      var customDeviationReasons = this.props.part.CustomDeviationReasons;
	      var otherDamages = this.props.part.OtherDamages;
	
	      if (this.props.includeForsiAssociatedTasks === undefined || this.props.includeForsiAssociatedTasks === false) {
	        if (estimationTasks && estimationTasks.length > 0 && estimationTasks.filter(function (x) {
	          return x.PaintLineId < 1;
	        }).length === 0) return null;
	      }
	
	      if (this.props.onlyAdditionalParts && !this.props.part.IsAdditional) return null;
	      var partName = (0, _helpers.translation)(this.props.part.Part.DictionaryKey);
	      var side = null;
	      var frontBack = null;
	
	      if (this.props.part.Part.TaskSide !== 0) {
	        switch (this.props.part.Part.TaskSide) {
	          case 1:
	            side = (0, _helpers.translation)('213'); // Left
	            break;
	          case 2:
	            side = (0, _helpers.translation)('214'); // Right
	            break;
	          case 5:
	            side = (0, _helpers.translation)('213'); // Left
	            frontBack = (0, _helpers.translation)('287'); // Front
	            break;
	          case 6:
	            side = (0, _helpers.translation)('214'); // Right
	            frontBack = (0, _helpers.translation)('287'); // Front
	            break;
	          case 7:
	            side = (0, _helpers.translation)('213'); // Left
	            frontBack = (0, _helpers.translation)('288'); // Back
	            break;
	          case 8:
	            side = (0, _helpers.translation)('214'); // Right
	            frontBack = (0, _helpers.translation)('288'); // Back
	            break;
	        }
	      }
	
	      var partAndLocation = '';
	      if (side !== null) partAndLocation += side + ' ';
	      partAndLocation += partName + ' ';
	      if (frontBack !== null) partAndLocation += frontBack;
	
	      if (partAndLocation.trim() === '') {
	        partAndLocation = (0, _helpers.translation)(227); // Other
	      }
	
	      var pNumber = this.props.part.Part.PNumber ? ' (' + this.props.part.Part.PNumber + ')' : '';
	
	      var renderOrderTaskPrice = function renderOrderTaskPrice(item, key) {
	        if (item.OrderTaskId === undefined || item.IsDeleted) return null;
	        return _react2.default.createElement(_PriceLine2.default, _extends({}, _this2.props, {
	          key: 'task_' + (item.OrderTaskId || key),
	          orderTaskPrice: item,
	          noPrice: _this2.props.noPrice
	        }));
	      };
	
	      var renderOrderEstimationTasks = function renderOrderEstimationTasks(item, key) {
	        if (item.OrderEstimationTaskId === undefined || item.IsDeleted) return null;
	
	        if ((_this2.props.includeForsiAssociatedTasks === undefined || _this2.props.includeForsiAssociatedTasks === false) && item.PaintLineId > 0) return null;
	        return _react2.default.createElement(_EstimationLine2.default, _extends({}, _this2.props, {
	          key: 'estimationtask_' + (item.OrderEstimationTaskId || key),
	          orderEstimationTask: item
	        }));
	      };
	
	      var renderComplaints = function renderComplaints(item, key) {
	        if (item === undefined || item.IsDeleted) return null;
	        return _react2.default.createElement(_ComplaintLine2.default, _extends({}, _this2.props, {
	          key: 'complaint_' + (item.ComplaintType || key),
	          complaint: item
	        }));
	      };
	
	      var renderDeviationReasons = function renderDeviationReasons(item, key) {
	        if (item === undefined || item.IsDeleted) return null;
	        return _react2.default.createElement(_DeviationLine2.default, _extends({}, _this2.props, {
	          key: 'deviation_' + (item.DeviationReasonId || key),
	          reason: item
	        }));
	      };
	
	      var renderCustomDeviationReasons = function renderCustomDeviationReasons(item, key) {
	        if (item === undefined || item.IsDeleted) return null;
	        return _react2.default.createElement(_DeviationLine2.default, _extends({}, _this2.props, {
	          key: 'deviation_' + (item.CustomDeviationReasonId || key),
	          isCustomReason: true,
	          reason: item
	        }));
	      };
	
	      var renderOtherDamage = function renderOtherDamage(item, key) {
	        if (item === undefined || item.IsDeleted) return null;
	        return _react2.default.createElement(_OtherDamageLine2.default, _extends({}, _this2.props, {
	          key: 'otherDmg_' + (item.Id || key),
	          damage: item
	        }));
	      };
	
	      // let key = this.props.part.PartItemId + '_' + this.props.part.PartSide
	      if (partAndLocation.includes('undefined')) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'partname' },
	          partAndLocation !== undefined ? partAndLocation : '',
	          pNumber !== undefined ? pNumber : ''
	        ),
	        tasks !== undefined && tasks.map(renderOrderTaskPrice),
	        complaints !== undefined && complaints.map(renderComplaints),
	        estimationTasks !== undefined && estimationTasks.map(renderOrderEstimationTasks),
	        deviationReasons !== undefined && deviationReasons.map(renderDeviationReasons),
	        customDeviationReasons !== undefined && customDeviationReasons.map(renderCustomDeviationReasons),
	        otherDamages !== undefined && otherDamages.map(renderOtherDamage)
	      );
	    }
	  }]);
	
	  return Part;
	}(_react.Component);
	
	Part.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	  // enum: React.PropTypes.func.isRequired
	};
	
	exports.default = Part;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _price = __webpack_require__(115);
	
	var _orderPrice = __webpack_require__(193);
	
	var _priceModel = __webpack_require__(75);
	
	var _orders = __webpack_require__(21);
	
	var _customers = __webpack_require__(74);
	
	var _shops = __webpack_require__(79);
	
	var _notes = __webpack_require__(114);
	
	var _auth = __webpack_require__(8);
	
	var _backdrop = __webpack_require__(29);
	
	var _Price = __webpack_require__(1043);
	
	var _Price2 = _interopRequireDefault(_Price);
	
	var _Estimation = __webpack_require__(292);
	
	var _Estimation2 = _interopRequireDefault(_Estimation);
	
	var _Complaint = __webpack_require__(1035);
	
	var _Complaint2 = _interopRequireDefault(_Complaint);
	
	var _Other = __webpack_require__(1042);
	
	var _Other2 = _interopRequireDefault(_Other);
	
	var _Deviation = __webpack_require__(1037);
	
	var _Deviation2 = _interopRequireDefault(_Deviation);
	
	var _ManualBody = __webpack_require__(438);
	
	var _ManualBody2 = _interopRequireDefault(_ManualBody);
	
	var _OtherDamages = __webpack_require__(1041);
	
	var _OtherDamages2 = _interopRequireDefault(_OtherDamages);
	
	var _AssessmentForsi = __webpack_require__(436);
	
	var _AssessmentForsi2 = _interopRequireDefault(_AssessmentForsi);
	
	var _AssessmentDBS = __webpack_require__(435);
	
	var _AssessmentDBS2 = _interopRequireDefault(_AssessmentDBS);
	
	var _expand = __webpack_require__(175);
	
	var _expand2 = _interopRequireDefault(_expand);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1530);
	
	var _helpers = __webpack_require__(2);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _CombinedPrice = __webpack_require__(1033);
	
	var _CombinedPrice2 = _interopRequireDefault(_CombinedPrice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import PropTypes from 'prop-types'
	
	// import { isEqual } from 'lodash'
	
	
	// import { FILE_STORAGE } from '../../../constants'
	
	// Actions
	
	
	// Components
	
	// import Null from '../../elements/null'
	
	
	var ORDER_BASE = 'base';
	var ORDER_ADDON = 'addon';
	var ORDER_EVAL = 'eval';
	var ORDER_AFTEREVAL = 'aftereval';
	var ORDER_INTDEV = 'intdeviation';
	var ORDER_EXTDEV = 'extdeviation';
	var ORDER_OTHDMG = 'otherdamage';
	
	var EXTENT_NONE = 'none';
	var EXTENT_PRICE = 'price';
	var EXTENT_EST = 'estimation';
	var EXTENT_DEV = 'deviation';
	var EXTENT_COMPL = 'complaint';
	var EXTENT_OTHER = 'other';
	var EXTENT_MANUAL_BODY = 'manual_body';
	var EXTENT_OTHER_DAMAGE = 'other_damage';
	var EXTENT_COMBINED_PRICE = 'combined_price';
	var EXTENT_ASSESSMENT_FORSI = 'assessment_forsi';
	var EXTENT_ASSESSMENT_DBS = 'assessment_dbs';
	
	/**
	 * Corresponds to enum used in getExtentInfo API.
	 */
	var EXTENTINFO_TYPES = {
	  None: 0,
	  ForsiReport: 1,
	  // ManualForsi: 2,
	  DBSReport: 3,
	  // ManualDBS: 4,
	  PriceCalculation: 5,
	  Complaint: 6,
	  Estimation: 7,
	  Other: 8
	  /**
	   * Component for displaying one or more extents of different types. Specify in props which extents are wanted, such as 'base', 'addon', 'aftereval' etc. (refer to ORDER_* constants above)
	   */
	};
	var Extent = function (_Component) {
	  _inherits(Extent, _Component);
	
	  function Extent(props) {
	    var _this$componentConfig;
	
	    _classCallCheck(this, Extent);
	
	    var _this = _possibleConstructorReturn(this, (Extent.__proto__ || Object.getPrototypeOf(Extent)).call(this, props));
	
	    _this.state = {
	      order: null,
	      extentInfo: null,
	      department: 0,
	      isLoading: false,
	      noOrderPrice: false,
	      extentData: [{
	        orderPrice: null,
	        partTasks: null,
	        isLoading: true,
	        noOrderPrice: false
	      }],
	      showAgreementPrice: 0
	    };
	
	    _this.componentConfig = (_this$componentConfig = {}, _defineProperty(_this$componentConfig, EXTENT_NONE, null), _defineProperty(_this$componentConfig, EXTENT_PRICE, _Price2.default), _defineProperty(_this$componentConfig, EXTENT_EST, _Estimation2.default), _defineProperty(_this$componentConfig, EXTENT_OTHER, _Other2.default), _defineProperty(_this$componentConfig, EXTENT_COMPL, _Complaint2.default), _defineProperty(_this$componentConfig, EXTENT_DEV, _Deviation2.default), _defineProperty(_this$componentConfig, EXTENT_MANUAL_BODY, _ManualBody2.default), _defineProperty(_this$componentConfig, EXTENT_OTHER_DAMAGE, _OtherDamages2.default), _defineProperty(_this$componentConfig, EXTENT_COMBINED_PRICE, _CombinedPrice2.default), _defineProperty(_this$componentConfig, EXTENT_ASSESSMENT_FORSI, _AssessmentForsi2.default), _defineProperty(_this$componentConfig, EXTENT_ASSESSMENT_DBS, _AssessmentDBS2.default), _this$componentConfig);
	
	    _this.saveOrder = _this.saveOrder.bind(_this);
	    _this.loadOrder = _this.loadOrder.bind(_this);
	    _this.saveOrderPrice = _this.saveOrderPrice.bind(_this);
	    _this.getExtentInfo = _this.getExtentInfo.bind(_this);
	    _this.loadExtentData = _this.loadExtentData.bind(_this);
	    return _this;
	  }
	
	  _createClass(Extent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props, newProps) {
	      var _this2 = this;
	
	      var prevProps = this.props;
	      newProps = newProps.order !== undefined ? newProps : props;
	      var needUpdate = false;
	      if (newProps.order !== undefined) {
	        // Conditions under which (sub)components needs to fetch updated data.
	        if (typeof newProps.order === 'number' && newProps.order !== prevProps.order) {
	          needUpdate = true;
	        }
	
	        if (!needUpdate) {
	          var orderFields = ['Id', 'Delivery', 'IsAssessmentOk', 'IsDraft'];
	          for (var key in orderFields) {
	            if (newProps.order[orderFields[key]] !== prevProps.order[orderFields[key]]) {
	              needUpdate = true;
	              break;
	            }
	          }
	        }
	      }
	
	      var setOrderPrice = function setOrderPrice(propsOrderPrice) {
	        if (propsOrderPrice === undefined) return null;
	        var extentData = _this2.state.extentData;
	        for (var i = 0; i < extentData.length; i++) {
	          if (_this2.compareOrderPriceAssociation(extentData[i].orderPrice, propsOrderPrice)) {
	            extentData[i].orderPrice = propsOrderPrice;
	            _this2.setState({ extentData: extentData });
	          }
	        }
	      };
	
	      if (needUpdate) {
	        // Delay setting orderPrice until after new data is loaded.
	        this.loadData(newProps).then(function () {
	          setOrderPrice(newProps.price);
	        });
	      } else {
	        setOrderPrice(newProps.price);
	      }
	    }
	
	    /**
	     * Loads order (or gets it from prop object directly), and loads OrderPrices where relevant.
	     * @param {object} newProps
	     */
	
	  }, {
	    key: 'loadData',
	    value: function loadData(newProps) {
	      var _this3 = this;
	
	      // console.log('Extent -> loadData', newProps)
	      // Init extentData from extentArgs in props
	      var extentArgs = [].concat(_toConsumableArray(newProps.extents));
	      var extentData = [];
	      extentArgs.map(function (v, k) {
	        extentData.push({ orderPrice: null, partTasks: null, isLoading: true });
	      });
	      this.setState({
	        extentData: extentData,
	        showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1'
	      });
	      return new Promise(function (resolve) {
	        // Store or get order data
	        return _this3.loadOrder(false, newProps.order).then(function () {
	          // Get extent data for each extent
	          extentArgs.map(function (v, k) {
	            _this3.loadExtentData(k).then(function () {
	              // console.log('Extent data loaded for ' + extentArgs[k].type)
	            });
	            _this3.loadPartTasks(k).catch(function (e) {});
	          });
	          resolve();
	        });
	      });
	    }
	  }, {
	    key: 'loadOrder',
	    value: function loadOrder() {
	      var _this4 = this;
	
	      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var overrideOrder = arguments[1];
	
	      var order = overrideOrder !== undefined ? overrideOrder : this.props.order;
	      // console.log('Extent -> LoadOrder(), refresh', refresh, 'this.state.order', this.state.order)
	      if (typeof order === 'number' || refresh === true && this.state.order !== null) {
	        // order was given as ID or want to refresh. Load order.
	        var orderId = order;
	        if (refresh && this.state.order !== null) {
	          orderId = this.state.order.Id;
	        }
	        this.getExtentInfo(orderId);
	        return this.props.getOrder(orderId).then(function (res) {
	          var order = res.data;
	          _this4.setState({
	            order: order
	          });
	        });
	      } else if ((typeof order === 'undefined' ? 'undefined' : _typeof(order)) === 'object' && typeof order.Id === 'number') {
	        // order was given as object. Use object.
	        this.getExtentInfo(order.Id);
	        return new Promise(function (resolve) {
	          _this4.setState({ order: order }, function () {
	            resolve();
	          });
	        });
	      } else {
	        console.error('Order ID or object not provided to Extent!');
	      }
	      return Promise.reject();
	    }
	  }, {
	    key: 'getExtentInfo',
	    value: function getExtentInfo(orderId) {
	      var _this5 = this;
	
	      this.props.getExtentInfo(orderId).then(function (res) {
	        // console.table(res.data)
	        _this5.setState({
	          extentInfo: res.data
	        });
	      });
	    }
	  }, {
	    key: 'saveOrder',
	    value: function saveOrder(order) {
	      var _this6 = this;
	
	      return new Promise(function (resolve, reject) {
	        _this6.props.saveOrder(order).then(function (res) {
	          _this6.setState({
	            order: res.data
	          }, function () {
	            _events2.default.emit('Extent_Updated');
	            resolve();
	          });
	        }, function (err) {
	          console.log('Error saving order!', err.response);
	          _events2.default.emit('Extent_Updated');
	          reject();
	        });
	      });
	    }
	  }, {
	    key: 'saveOrderPrice',
	    value: function saveOrderPrice(orderPrice) {
	      var _this7 = this;
	
	      return new Promise(function (resolve, reject) {
	        var index = _this7.state.extentData.findIndex(function (extent) {
	          return extent.orderPrice && extent.orderPrice.OrderPriceId === orderPrice.OrderPriceId;
	        });
	        _this7.props.updatePrices(orderPrice).then(function (res) {
	          if (index >= 0) {
	            // orderPrice present in state. Update.
	            var extentData = [].concat(_toConsumableArray(_this7.state.extentData));
	            extentData[index].orderPrice = res.data;
	            _this7.setState({
	              extentData: extentData
	            }, function () {
	              _events2.default.emit('Extent_Updated');
	              resolve();
	            });
	          } else resolve();
	        }, function (err) {
	          console.log('Error saving OrderPrice!', err.response);
	          _events2.default.emit('Extent_Updated');
	          reject();
	        });
	      });
	    }
	  }, {
	    key: 'loadPartTasks',
	    value: function loadPartTasks(extentIndex) {
	      var _this8 = this;
	
	      var extentArgs = this.props.extents[extentIndex];
	      var orderId = _typeof(this.state.order) === 'object' ? this.state.order.Id : this.state.order;
	      var orderType = this.state.order.OrderType;
	      var customerId = this.state.order.CustomerId;
	      var brandName = this.state.order.BrandName.Name;
	      var isBodyShop = this.props.department > 0;
	
	      var isEstimation = false;
	      var deviation = null;
	      var isAddon = false;
	      var otherDamage = false;
	
	      switch (extentArgs.type) {
	        case ORDER_BASE:
	          break;
	        case ORDER_ADDON:
	          isAddon = true;
	          break;
	        case ORDER_EVAL:
	          isEstimation = true;
	          break;
	        case ORDER_AFTEREVAL:
	          isEstimation = true;
	          break;
	        case ORDER_INTDEV:
	          deviation = 1;
	          break;
	        case ORDER_EXTDEV:
	          deviation = 2;
	          break;
	        case ORDER_OTHDMG:
	          otherDamage = true;
	          break;
	      }
	      return new Promise(function (resolve, reject) {
	        if (_this8.isOrderPriceExtent(extentArgs)) {
	          _this8.props.getPriceInformations(orderType, brandName, customerId, deviation, isEstimation, isAddon, orderId, isBodyShop, otherDamage).then(function (res) {
	            // Store for extent
	            var extentData = _this8.state.extentData;
	            extentData[extentIndex].partTasks = res.data;
	            _this8.setState({
	              extentData: extentData
	            }, function () {
	              if (typeof resolve === 'function') {
	                resolve();
	              }
	            });
	          }, function (err) {
	            console.log('Error getting parttask data', err.response);
	            if (typeof reject === 'function') {
	              reject();
	            }
	          });
	        } else {
	          if (typeof resolve === 'function') {
	            resolve();
	          }
	        }
	      });
	    }
	
	    /**
	     * Loads extent data, such as an OrderPrice for extent at given index.
	     * @param {number} extentIndex
	     */
	
	  }, {
	    key: 'loadExtentData',
	    value: function loadExtentData(extentIndex) {
	      var _this9 = this;
	
	      var extentArgs = this.props.extents[extentIndex];
	      return new Promise(function (resolve, reject) {
	        if (_this9.isOrderPriceExtent(extentArgs)) {
	          var addon = false;
	          var evaluation = false;
	          var afterevaluation = false;
	          var deviation = 0;
	          var otherDamage = false;
	          var getOnly = extentArgs.getOnly !== undefined ? extentArgs.getOnly : !extentArgs.editable;
	          var getEditing = extentArgs.editable;
	          var useSelectedEval = extentArgs.useSelectedEvaluation;
	          var department = _this9.props.department;
	
	          // Set parameters for OrderPrice/Get
	          switch (extentArgs.type) {
	            case ORDER_BASE:
	              break;
	            case ORDER_ADDON:
	              addon = true;
	              break;
	            case ORDER_EVAL:
	              evaluation = true;
	              break;
	            case ORDER_AFTEREVAL:
	              afterevaluation = true;
	              break;
	            case ORDER_INTDEV:
	              deviation = 1;
	              break;
	            case ORDER_EXTDEV:
	              deviation = 2;
	              break;
	            case ORDER_OTHDMG:
	              otherDamage = true;
	              break;
	          }
	
	          var extentData = _this9.state.extentData;
	
	          if (_this9.props.prices === null || !_this9.compareOrderPriceAssociation(extentData[extentIndex].orderPrice, _this9.props.price)) {
	            extentData[extentIndex].isLoading = true;
	            _this9.setState({ extentData: extentData }, function () {
	              // console.log('Load orderprice (' + extentArgs.type + ')...', this.state.order.Id)
	              _this9.props.getPrices(_this9.state.order.Id, addon, evaluation, afterevaluation, deviation, otherDamage, getEditing, useSelectedEval, department, getOnly).then(function (res) {
	                extentData = _this9.state.extentData;
	                extentData[extentIndex].orderPrice = res.data;
	                extentData[extentIndex].isLoading = false;
	                extentData[extentIndex].noOrderPrice = false;
	                _this9.setState({ extentData: extentData }, function () {
	                  _events2.default.emit('Extent_Updated');
	                  if (typeof resolve === 'function') {
	                    resolve();
	                  }
	                });
	              }, function () {
	                if (!_this9.props.editable) {
	                  extentData = _this9.state.extentData;
	                  extentData[extentIndex].isLoading = false;
	                  extentData[extentIndex].noOrderPrice = true;
	                  _this9.setState({ extentData: extentData }, function () {
	                    _events2.default.emit('Extent_Updated');
	                    if (typeof reject === 'function') {
	                      reject();
	                    }
	                  });
	                } else {
	                  _events2.default.emit('Extent_Updated');
	                  if (typeof reject === 'function') {
	                    reject();
	                  }
	                }
	              });
	            });
	          }
	        }
	        if (typeof resolve === 'function') {
	          resolve();
	        }
	      });
	    }
	
	    /**
	     * Compares 2 orderPrices to check if they represent the same 'type' of extent (since OrderPriceId can change but still represent the same shown extent)
	     * Useful when checking OrderPrice updates in reducer, when multiple OrderPrices must be supported (showing Base together with Addon fx).
	     * @param {object} orderPriceA
	     * @param {object} orderPriceB
	     */
	
	  }, {
	    key: 'compareOrderPriceAssociation',
	    value: function compareOrderPriceAssociation(orderPriceA, orderPriceB) {
	      if (orderPriceA === null !== (orderPriceB === null)) return false;
	      if (orderPriceA.OrderId !== orderPriceB.OrderId) return false;
	      if (orderPriceA.Department !== orderPriceB.Department) return false;
	      if (orderPriceA.IsAddonPrice !== orderPriceB.IsAddonPrice) return false;
	      if (orderPriceA.IsEvaluation !== orderPriceB.IsEvaluation) return false;
	      if (orderPriceA.IsAfterEvaluation !== orderPriceB.IsAfterEvaluation) return false;
	      if (orderPriceA.IsComplaint !== orderPriceB.IsComplaint) return false;
	      if (orderPriceA.IsInternalDeviation !== orderPriceB.IsInternalDeviation) return false;
	      if (orderPriceA.IsExternalDeviation !== orderPriceB.IsExternalDeviation) return false;
	      if (orderPriceA.UseEstimation !== orderPriceB.UseEstimation) return false;
	      return true;
	    }
	  }, {
	    key: 'isOrderPriceExtent',
	    value: function isOrderPriceExtent(extentType) {
	      if (this.state.order === null) {
	        return null;
	      }
	
	      var orderTypes = [1, 2, 3, 5, 6];
	      var orderExtentTypes = [ORDER_ADDON, ORDER_EVAL, ORDER_AFTEREVAL, ORDER_INTDEV, ORDER_EXTDEV, ORDER_OTHDMG];
	
	      if (orderTypes.includes(this.state.order.OrderType) || orderExtentTypes.includes(extentType)) {
	        return true;
	      }
	      return false;
	    }
	
	    /**
	     * Returns type of component for extent at given index.
	     * @param {number} extentIndex
	     */
	
	  }, {
	    key: 'getExtentComponentType',
	    value: function getExtentComponentType(extentIndex) {
	      var orderType = this.state.order.OrderType;
	      var selectedEvaluationType = this.state.order.SelectedEvaluationType;
	      var hasOrderPrice = this.state.extentData[extentIndex].orderPrice !== null;
	      var useEstimation = hasOrderPrice && this.state.extentData[extentIndex].orderPrice.UseEstimation;
	      var hasReport = this.state.order.Report !== null && (this.props.department === 0 ? this.state.order.Report.Paint !== null : this.state.order.Report.Body !== null);
	
	      var extentArgs = this.props.extents[extentIndex];
	      var extentType = null;
	
	      var extentInfoType = EXTENTINFO_TYPES.None;
	      if (extentArgs.type === ORDER_BASE || extentArgs.type === ORDER_ADDON) {
	        var baseOrAddon = extentArgs.type === ORDER_BASE ? 'Base' : 'Addon';
	        var paintOrBody = this.props.department === 0 ? 'Paint' : 'Body';
	
	        if (this.state.extentInfo) {
	          extentInfoType = this.state.extentInfo[paintOrBody + baseOrAddon];
	        }
	      }
	
	      var defaultBaseExtentPerOrder = {
	        1: EXTENT_EST,
	        2: EXTENT_PRICE,
	        3: EXTENT_PRICE,
	        4: EXTENT_OTHER,
	        5: EXTENT_COMPL,
	        6: EXTENT_PRICE
	      };
	
	      extentType = defaultBaseExtentPerOrder[orderType];
	
	      // console.log('0', extentArgs, extentArgs.type, this.props)
	
	      switch (extentArgs.type) {
	        case ORDER_BASE:
	          break;
	        case ORDER_ADDON:
	          extentType = EXTENT_PRICE;
	          break;
	        case ORDER_EVAL:
	        case ORDER_AFTEREVAL:
	          extentType = EXTENT_EST;
	          break;
	        case ORDER_INTDEV:
	        case ORDER_EXTDEV:
	          extentType = EXTENT_DEV;
	          break;
	        case ORDER_OTHDMG:
	          extentType = EXTENT_OTHER_DAMAGE;
	          break;
	      }
	      // In case of displaying paint base extent for shop with no estimation or price lists (ex. bodyshop with no paint partner)
	      if (this.props.auth.departmentType === 1 && this.props.department === 0 && extentArgs.type === ORDER_BASE && extentType === EXTENT_PRICE && !useEstimation && extentInfoType !== EXTENTINFO_TYPES.PriceCalculation) {
	        extentType = EXTENT_OTHER;
	      }
	
	      if (useEstimation && extentArgs.type !== ORDER_OTHDMG) {
	        extentType = EXTENT_EST;
	      }
	
	      // If Forsi and DBS report      //  extentInfoType !== EXTENTINFO_TYPES.PriceCalculation
	      if (extentArgs.type === ORDER_BASE || extentArgs.type === ORDER_EVAL) {
	        switch (extentInfoType) {
	          case EXTENTINFO_TYPES.ForsiReport:
	            if (hasReport) {
	              extentType = EXTENT_ASSESSMENT_FORSI;
	            } else if (this.props.department !== 0) {
	              extentType = EXTENT_MANUAL_BODY;
	            }
	            break;
	          case EXTENTINFO_TYPES.DBSReport:
	            if (hasReport) {
	              extentType = EXTENT_ASSESSMENT_DBS;
	            } else if (this.props.department !== 0) {
	              extentType = EXTENT_MANUAL_BODY;
	            }
	            break;
	        }
	      }
	
	      if (extentArgs.type === ORDER_BASE && extentArgs.useSelectedEvaluation === true) {
	        if (selectedEvaluationType === 4) {
	          extentType = EXTENT_EST;
	        }
	      }
	
	      if (extentArgs.combined && this.props.department === 1 && extentArgs.type === ORDER_BASE) {
	        extentType = EXTENT_COMBINED_PRICE;
	      }
	
	      var result = this.componentConfig[extentType];
	      if (result === undefined) {
	        console.error('Could not get component type for: ' + extentType);
	      }
	      return this.componentConfig[extentType];
	    }
	
	    /**
	     * Adjusts the order objects ShowPrices property according to department and partner permission
	     * @param {Number} extentIndex
	     * @param {Object} order
	     */
	
	  }, {
	    key: 'adjustShowPrices',
	    value: function adjustShowPrices(extentIndex, order) {
	      if (order !== null) {
	        var extentArgs = this.props.extents[extentIndex];
	        if (this.isOrderPriceExtent(extentArgs.Type) && this.state.extentData[extentIndex].orderPrice !== null) {
	          // let orderPrice = this.state.extentData[extentIndex].orderPrice
	          if (this.props.auth.hasPartner && this.props.auth.departmentType === 1 && extentArgs.type === ORDER_BASE && this.props.department === 0 && (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) {
	            // ShowPrices overriden to true because paint partner is allowed to view prices
	            var dirtyOrder = _extends({}, order);
	            dirtyOrder.ShowPrices = true;
	            return dirtyOrder;
	          }
	        }
	      }
	      return order;
	    }
	  }, {
	    key: 'renderAgreementPriceCheck',
	    value: function renderAgreementPriceCheck(extentArgs) {
	      var _this10 = this;
	
	      var onChange = function onChange(e) {
	        // e.preventDefault()
	        if (e !== undefined) {
	          if (e.target.name === 'showAgreementPrice') {
	            var show = window.localStorage.getItem('showAgreementPrice') === '1';
	            window.localStorage.setItem('showAgreementPrice', show ? 0 : 1);
	            _this10.setState({
	              showAgreementPrice: !show
	            });
	          }
	        }
	      };
	
	      // Only main paint extent to render checkbox
	      if (this.props.department !== 0 || extentArgs.type !== 'base') return null;
	      // Only wp
	      if (!(0, _auth.hasAccess)([6], this.props.auth.user.UserType) || this.props.order.IsDummy) return null;
	
	      return _react2.default.createElement(_check2.default, {
	        name: 'showAgreementPrice',
	        id: 'sshowAgreementPrice',
	        checked: this.state.showAgreementPrice,
	        onChange: onChange.bind(this),
	        labelText: (0, _helpers.translation)('12318')
	      });
	    }
	  }, {
	    key: 'renderExtent',
	    value: function renderExtent(extentIndex) {
	      var _this11 = this;
	
	      var error = null;
	      if (this.props.extents.length - 1 < extentIndex) {
	        error = 'Extent index ' + extentIndex + 'out of range!';
	      }
	      var extentArgs = this.props.extents[extentIndex];
	      if (extentArgs.type === undefined || extentArgs.type === null || extentArgs.type === '') {
	        error = 'No extent type specified for extent[' + extentIndex + ']';
	      }
	
	      var renderSpinner = function renderSpinner() {
	        return _react2.default.createElement(
	          'div',
	          { key: 'extent_' + extentIndex, className: 'extent-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'spinner' },
	            _react2.default.createElement('div', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	          )
	        );
	      };
	
	      if (this.isOrderPriceExtent(extentArgs.type)) {
	        if (this.state.extentData[extentIndex].orderPrice === null && !this.state.extentData[extentIndex].noOrderPrice) {
	          return renderSpinner();
	        }
	      }
	      if (error !== null) {
	        console.error(error);
	        return;
	      }
	      var refName = 'extent_' + extentIndex;
	      var order = this.adjustShowPrices(extentIndex, this.state.order);
	
	      var extentProps = {
	        order: order,
	        extentInfo: this.state.extentInfo,
	        editable: extentArgs.combined ? false : extentArgs.editable,
	        showEditLink: extentArgs.showEditLink,
	        overrideInnerTitle: extentArgs.overrideInnerTitle !== undefined ? extentArgs.overrideInnerTitle : null,
	        viewMode: extentArgs.viewMode !== undefined ? extentArgs.viewMode : null,
	        showOnlyWork: extentArgs.showOnlyWork === true,
	        renderInside: extentArgs.renderInside !== undefined ? extentArgs.renderInside : null,
	        saveOrder: this.saveOrder,
	        saveOrderPrice: this.saveOrderPrice,
	        loadOrder: this.loadOrder,
	        isCustomer: (0, _auth.hasAccess)([4], this.props.auth.user.UserType),
	        isWp: (0, _auth.hasAccess)([6], this.props.auth.user.UserType),
	        showAgreementPrice: this.state.showAgreementPrice === true,
	        isAgreement: this.props.order.IsAgreement,
	        department: this.props.department,
	        partTasks: this.state.extentData[extentIndex].partTasks,
	        orderPrice: this.state.extentData[extentIndex].orderPrice,
	        useSelectedEvaluation: extentArgs.useSelectedEvaluation,
	        goBack: this.props.goBack,
	        router: this.props.router,
	        onRef: function onRef(ref) {
	          _this11[refName] = ref;
	          _this11.forceUpdate();
	        }
	
	        // console.log('render extent -> extentProps', extentProps)
	
	      };var extentComponentType = this.getExtentComponentType(extentIndex);
	      if (extentComponentType === null) return null;
	      var extentComponent = _react2.default.createElement(extentComponentType, extentProps);
	
	      var extentTitle = 'Implement getTitle function for this component!';
	      var extentTitleAria = 'Implement getTitleAria function for this component!';
	      // let extentIcon = null
	      var extentEditUrl = null;
	
	      var ref = this[refName];
	      if (ref !== undefined && ref !== null) {
	        // console.log('ref Extent [' + extentIndex + ']', ref)
	        if (ref.getTitle !== undefined) extentTitle = ref.getTitle();
	        if (ref.getTitleAria !== undefined) extentTitleAria = ref.getTitleAria();
	        // if (ref.getIcon !== undefined) extentIcon = ref.getIcon()
	        if (ref.getEditUrl !== undefined) extentEditUrl = ref.getEditUrl();
	      }
	
	      if (extentArgs.overrideTitle !== undefined) {
	        extentTitle = extentArgs.overrideTitle;
	      }
	
	      var renderExtentHeading = function renderExtentHeading(content) {
	        if (extentArgs.editable || extentArgs.noTitle) return content;
	        if (typeof extentTitle === 'function') {
	          return _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('889') /* extentTitle */, defaultOpen: true },
	            _react2.default.createElement(
	              _actions2.default,
	              null,
	              extentTitle()
	            ),
	            content
	          );
	        }
	
	        if (extentArgs.showEditLink && extentEditUrl !== null) {
	          return _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('889') /* extentTitle */, defaultOpen: true },
	            _react2.default.createElement(
	              _actions2.default,
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: extentEditUrl, key: '1' },
	                _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't', ariaText: extentTitleAria, ariaPos: 'top' })
	              )
	            ),
	            content
	          );
	        }
	        return _react2.default.createElement(
	          _expand2.default,
	          { title: (0, _helpers.translation)('889') /* extentTitle */, defaultOpen: true },
	          content
	        );
	      };
	      var contentCss = 'extent-content';
	      if (extentArgs.editable === true) {
	        contentCss += ' editable';
	      }
	      // let departmentDebug = this.props.department === 0 ? 'paint' : 'body'
	      // <div>(Debug info) Extent container for {extentArgs.type}/{departmentDebug} ({extentComponentType.displayName})</div>
	      return _react2.default.createElement(
	        'div',
	        { key: 'extent_' + extentIndex, className: 'extent-container' },
	        renderExtentHeading(_react2.default.createElement(
	          'div',
	          { className: contentCss },
	          this.renderAgreementPriceCheck(extentArgs),
	          extentComponent
	        ))
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      // console.log('Extent -> Render ->this.props', this.props)
	      if (this.state.order === null) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'extents' },
	          _react2.default.createElement(
	            'div',
	            { className: 'extent-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'spinner' },
	              _react2.default.createElement('div', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'extents' },
	        this.props.extents.map(function (v, k) {
	          return _this12.renderExtent(k);
	        })
	      );
	    }
	  }]);
	
	  return Extent;
	}(_react.Component);
	
	Extent.propTypes = {
	  order: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.object]),
	  department: _react2.default.PropTypes.number.isRequired,
	  extents: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    type: _react2.default.PropTypes.string.isRequired,
	    editable: _react2.default.PropTypes.bool.isRequired,
	    showEditLink: _react2.default.PropTypes.bool,
	    overrideTitle: _react2.default.PropTypes.string,
	    overrideInnerTitle: _react2.default.PropTypes.string,
	    viewMode: _react2.default.PropTypes.string, // undefined, 'hover', ... add as needed
	    showOnlyWork: _react2.default.PropTypes.bool,
	    useSelectedEvaluation: _react2.default.PropTypes.bool
	  })).isRequired,
	  getPrices: _react2.default.PropTypes.func.isRequired,
	  updatePrices: _react2.default.PropTypes.func.isRequired
	};
	
	Extent.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	  // router: PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    complaintTypes: state.common.enums.complaintTypes,
	    price: state.price.price
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPrices: _orderPrice.getPrices,
	  updatePrices: _orderPrice.updatePrices,
	  deleteDeviationFileFromOrder: _orders.deleteDeviationFileFromOrder,
	  setOrder: _orders.setOrder,
	  getOrder: _orders.getOrder,
	  getExtentInfo: _orders.getExtentInfo,
	  saveOrder: _orders.saveOrder,
	  uploadMultipleFiles: _orders.uploadMultipleFiles,
	  createNote: _notes.createNote,
	  triggerPopup: _backdrop.triggerPopup,
	  triggerPopupActionBG: _backdrop.triggerPopupActionBG,
	  getCustomer: _customers.getCustomer,
	  getShop: _shops.getShop,
	  getOrderFiles: _orders.getOrderFiles,
	  UpdateOrderFileSelection: _orders.UpdateOrderFileSelection,
	  setCarPriceParts: _price.setCarPriceParts,
	  createFileContainer: _orders.createFileContainer,
	  getPriceInformations: _priceModel.getPriceInformations
	}, null, { withRef: true })(Extent);

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(110);
	var call = __webpack_require__(490);
	var isArrayIter = __webpack_require__(318);
	var anObject = __webpack_require__(39);
	var toLength = __webpack_require__(72);
	var getIterFn = __webpack_require__(334);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(39);
	var dPs = __webpack_require__(496);
	var enumBugKeys = __webpack_require__(314);
	var IE_PROTO = __webpack_require__(326)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(313)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(316).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(498);
	var hiddenKeys = __webpack_require__(314).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(498);
	var enumBugKeys = __webpack_require__(314);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(98);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(44);
	var dP = __webpack_require__(71);
	var DESCRIPTORS = __webpack_require__(70);
	var SPECIES = __webpack_require__(56)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(121);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1715),
	    getValue = __webpack_require__(1734);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAgreementConstraints = getAgreementConstraints;
	exports.getAgreementConstraint = getAgreementConstraint;
	exports.createSaveAgreementConstraint = createSaveAgreementConstraint;
	exports.createPriceAgreement = createPriceAgreement;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get WP agreement constraint list from API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/agreementConstraint
	 */
	function getAgreementConstraints(partnerID) {
	  var url = _constants.API_URL + '/AgreementConstraint/GetForWP/' + partnerID;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting WP agreement constraint from API
	 * @return {Promise} Axios promise
	 */
	function getAgreementConstraint(id) {
	  var url = _constants.API_URL + '/AgreementConstraint/get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a partner
	 * @return {Promise} Axios promise
	 */
	function createSaveAgreementConstraint(data) {
	  var url = _constants.API_URL + '/AgreementConstraint/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function createPriceAgreement(data) {
	  var url = _constants.API_URL + '/AgreementConstraint/PriceModel/CreateWithConstraints';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getInsuranceCompanies = getInsuranceCompanies;
	exports.getInsuranceCompany = getInsuranceCompany;
	exports.CreateSaveInsuranceCompany = CreateSaveInsuranceCompany;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting insurance companies from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/insurancecompanies
	 */
	function getInsuranceCompanies() {
	  var url = _constants.API_URL + '/Insurance/Companies/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting forsi company from API
	 * @return {Promise} Axios promise
	 */
	function getInsuranceCompany(id) {
	  var url = _constants.API_URL + '/Insurance/Companies/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a forsi company
	 * @return {Promise} Axios promise
	 */
	function CreateSaveInsuranceCompany(data) {
	  var url = _constants.API_URL + '/Insurance/Companies/post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPunchStats = getPunchStats;
	exports.getPunchStatsCurrentUser = getPunchStatsCurrentUser;
	exports.editPunchStats = editPunchStats;
	exports.getUserPunchStats = getUserPunchStats;
	exports.getPunchClockStats = getPunchClockStats;
	exports.getShopPunchTimeReport = getShopPunchTimeReport;
	exports.getEmployeePunchTimes = getEmployeePunchTimes;
	exports.editEmployeePunchTimes = editEmployeePunchTimes;
	exports.getMultipleShopPunchTimeReport = getMultipleShopPunchTimeReport;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get punch clock stats
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/messages
	 */
	function getPunchStats() {
	  var url = _constants.API_URL + '/PunchClock/GetPunch/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get punch clock stats for current user
	 * @return {Promise} Axios promise
	 */
	function getPunchStatsCurrentUser() {
	  var url = _constants.API_URL + '/PunchClock/GetPunchUser/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Edit punch clock stats
	 * @return {Promise} Axios promise
	 */
	function editPunchStats(data) {
	  var url = _constants.API_URL + '/PunchClock/Punch/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get punch clock stats
	 * @return {Promise} Axios promise
	 */
	function getUserPunchStats(data) {
	  var url = _constants.API_URL + '/PunchClock/GetUserStats/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get punch clock stats for a specific user
	 * @return {Promise} Axios promise
	 */
	function getPunchClockStats(id) {
	  var url = _constants.API_URL + '/PunchClock/UserPunchStats/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Retrieves a time report for punch times, for a specific user in a specific time range
	 * @return {Promise} Axios promise
	 */
	function getShopPunchTimeReport(userId, fromDateTime, toDateTime) {
	  var url = _constants.API_URL + '/Shop/Reports/PunchTimes';
	  var data = {
	    UserId: userId,
	    FromTime: fromDateTime,
	    ToTime: toDateTime
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get punch times for employee
	 * @return {Promise} Axios promise
	 */
	function getEmployeePunchTimes(userId, fromDateTime, toDateTime) {
	  var url = _constants.API_URL + '/Shop/Reports/EmployeePunchTimes';
	  var data = {
	    UserId: userId,
	    FromTime: fromDateTime,
	    ToTime: toDateTime
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Edit punch times for employee
	 * @return {Promise} Axios promise
	 */
	function editEmployeePunchTimes(data) {
	  var url = _constants.API_URL + '/Shop/Reports/EmployeePunchTimesPost';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Multiple punch times
	 * @return {Promise} Axios promise
	 */
	function getMultipleShopPunchTimeReport(data) {
	  var url = _constants.FILE_STORAGE_API + '/Shop/Reports/MultiplePunchTimes';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _common = __webpack_require__(25);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	__webpack_require__(1553);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverlayHeader = function (_Component) {
	  _inherits(OverlayHeader, _Component);
	
	  function OverlayHeader(props) {
	    _classCallCheck(this, OverlayHeader);
	
	    var _this = _possibleConstructorReturn(this, (OverlayHeader.__proto__ || Object.getPrototypeOf(OverlayHeader)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(OverlayHeader, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (typeof this.props.onClose === 'function') this.props.onClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderCloseButton = function renderCloseButton() {
	        if (!_this2.props.closeButton) return null;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'close' },
	          _react2.default.createElement(_closeButton2.default, { onClick: function onClick() {
	              return _this2.props.closeOverlay(_this2.props.overlayId);
	            } })
	        );
	      };
	
	      var className = 'overlay-header element-overlay-top ' + (this.props.className || '');
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        renderCloseButton(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return OverlayHeader;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	OverlayHeader.defaultProps = {
	  closeButton: true,
	  onClose: undefined // Callback on overlay close
	};
	
	OverlayHeader.propTypes = {
	  overlayId: _react2.default.PropTypes.string.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  closeOverlay: _common.closeOverlay
	})(OverlayHeader);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1593);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Expand = function (_Component) {
	  _inherits(Expand, _Component);
	
	  function Expand(props) {
	    _classCallCheck(this, Expand);
	
	    var _this = _possibleConstructorReturn(this, (Expand.__proto__ || Object.getPrototypeOf(Expand)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onActionClick = _this.onActionClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Expand, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _this2 = this;
	
	      this.setState({
	        open: !this.state.open
	      }, function () {
	        if (_this2.props.onClick !== undefined) {
	          _this2.props.onClick(_this2.state.open);
	        }
	      });
	    }
	  }, {
	    key: 'onActionClick',
	    value: function onActionClick(e) {
	      e.stopPropagation();
	
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.defaultOpen === true) {
	        // this.setState({open: true})
	        this.onClick();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var actions = null;
	      var children = this.props.children;
	
	      var firstChild = children[0];
	      if (_react2.default.isValidElement(firstChild) && firstChild.type.displayName === 'Actions') {
	        var _children = children,
	            _children2 = _toArray(_children),
	            cActions = _children2[0],
	            rest = _children2.slice(1);
	
	        actions = cActions;
	        children = rest;
	      }
	
	      var chevronClass = 'element-expand__chevron--right';
	      var contentClass = 'element-expand__content--hide';
	      if (this.state.open) {
	        chevronClass = 'element-expand__chevron--down';
	        contentClass = '';
	      }
	
	      var renderWithActions = function renderWithActions() {
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [2], fullWidth: true },
	          _react2.default.createElement(
	            'h3',
	            { className: 'element-expand__title' },
	            _this3.props.title
	          ),
	          _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Chevron_Right, className: chevronClass, injectSvg: true }),
	          _react2.default.createElement('div', null),
	          _react2.default.createElement(
	            'div',
	            { onClick: _this3.onActionClick },
	            actions
	          )
	        );
	      };
	
	      var renderWithoutActions = function renderWithoutActions() {
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: _this3.props.alignRight ? [0] : [2], fullWidth: true },
	          _this3.props.alignRight && _react2.default.createElement('span', null),
	          _react2.default.createElement(
	            'h3',
	            { className: 'element-expand__title' },
	            _this3.props.title
	          ),
	          _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Chevron_Right, className: chevronClass, injectSvg: true })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-expand' },
	        _react2.default.createElement(
	          'div',
	          { className: 'element-expand__header', onClick: this.onClick },
	          actions ? renderWithActions() : renderWithoutActions()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: contentClass },
	          children
	        )
	      );
	    }
	  }]);
	
	  return Expand;
	}(_react.Component);
	
	Expand.defaultProps = {
	  title: '',
	  actions: [],
	  rightAlignAction: false,
	  alignRight: false
	};
	
	exports.default = Expand;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1603);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalHeader = function (_Component) {
	  _inherits(ModalHeader, _Component);
	
	  function ModalHeader(props) {
	    _classCallCheck(this, ModalHeader);
	
	    var _this = _possibleConstructorReturn(this, (ModalHeader.__proto__ || Object.getPrototypeOf(ModalHeader)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalHeader, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Empty header with correct spacing in relation to other headers
	      var headerText = function headerText() {
	        return _react2.default.createElement(
	          'h3',
	          null,
	          '\u200B'
	        );
	      };
	      if (this.props.text) {
	        headerText = function headerText() {
	          return _react2.default.createElement(
	            'h3',
	            null,
	            _this2.props.text
	          );
	        };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-modal-header' },
	        headerText(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ModalHeader;
	}(_react.Component);
	
	ModalHeader.defaultProps = {
	  text: 'Header text'
	};
	
	exports.default = ModalHeader;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverlayContent = function (_Component) {
	  _inherits(OverlayContent, _Component);
	
	  function OverlayContent() {
	    _classCallCheck(this, OverlayContent);
	
	    return _possibleConstructorReturn(this, (OverlayContent.__proto__ || Object.getPrototypeOf(OverlayContent)).apply(this, arguments));
	  }
	
	  _createClass(OverlayContent, [{
	    key: 'render',
	    value: function render() {
	      var noScroll = this.props.noScroll;
	
	
	      var classNames = 'element-overlay-content';
	      if (!noScroll) {
	        classNames += ' element-overlay-content__scroll';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames },
	        this.props.children
	      );
	    }
	  }]);
	
	  return OverlayContent;
	}(_react.Component);
	
	OverlayContent.defaultProps = {
	  noScroll: false
	};
	
	exports.default = OverlayContent;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.transformPercent = transformPercent;
	function transformPercent(value, toClean) {
	  if (toClean) {
	    var cleanedValue = value.replace(/\s%/, '');
	    if (/\s$/.test(cleanedValue)) {
	      return cleanedValue.slice(0, -2);
	    }
	    return cleanedValue;
	  } else {
	    return value + ' %';
	  }
	}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(71).f;
	var has = __webpack_require__(96);
	var TAG = __webpack_require__(56)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var defined = __webpack_require__(119);
	var fails = __webpack_require__(47);
	var spaces = __webpack_require__(330);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1775);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(144);
	
	var _Actions = __webpack_require__(267);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 190 */,
/* 191 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enableCarOwnerPortalAccess = enableCarOwnerPortalAccess;
	exports.uploadLogo = uploadLogo;
	exports.getLogo = getLogo;
	exports.deleteLogo = deleteLogo;
	exports.getCarOwnerStatus = getCarOwnerStatus;
	exports.updateCarOwner = updateCarOwner;
	exports.getTimeLineStatus = getTimeLineStatus;
	exports.sendInvitation = sendInvitation;
	exports.tokenLogin = tokenLogin;
	exports.acceptTOS = acceptTOS;
	exports.logout = logout;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _upload = __webpack_require__(309);
	
	var _setAuthorizationToken = __webpack_require__(206);
	
	var _actions = __webpack_require__(129);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description enable car owner portal access
	 * @return {Promise} Axios promise
	 */
	function enableCarOwnerPortalAccess(data) {
	  var url = _constants.API_URL + '/CarOwnerPortal/EnableCarOwnerPortalAccess';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description upload logo
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/carownerportal
	 */
	function uploadLogo(file) {
	  var url = _constants.FILE_STORAGE_API + '/CompanyStyling/UploadLogo';
	  var data = new window.FormData();
	  data.append(file.name, file);
	  return (0, _upload.queueUpload)(url, file, data);
	}
	
	/**
	 * @description get logo
	 * @return {Promise} Axios promise
	 */
	function getLogo() {
	  var url = _constants.API_URL + '/CompanyStyling/GetLogo';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description delete logo
	 * @return {Promise} Axios promise
	 */
	function deleteLogo() {
	  var url = _constants.API_URL + '/CompanyStyling/DeleteLogo';
	  return function (dispatch) {
	    return _axios2.default.delete(url);
	  };
	}
	
	/**
	 * @description GetStatus/{orderId}
	 * @return {Promise} Axios promise
	 */
	function getCarOwnerStatus(orderId) {
	  return function (dispatch) {
	    return _axios2.default.get(_constants.API_URL + '/CarOwnerPortal/GetStatus/' + orderId);
	  };
	}
	/**
	 * @description UpdateCarOwner
	 * @return {Promise} Axios promise
	 */
	function updateCarOwner(data) {
	  var url = _constants.API_URL + '/CarOwnerPortal/UpdateCarOwner';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description get logo
	 * @return {Promise} Axios promise
	 */
	function getTimeLineStatus(orderId) {
	  var url = _constants.API_URL + ('/CarOwnerPortal/GetTimeLineStatus/' + orderId);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description SendInvitation
	 * @return {Promise} Axios promise
	 */
	function sendInvitation(data) {
	  var url = _constants.API_URL + '/CarOwnerPortal/SendInvitation';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description verify token
	 * @return {Promise} Axios promise
	 */
	function tokenLogin(token) {
	  window.localStorage.clear();
	  return function (dispatch) {
	    return _axios2.default.post(_constants.API_URL + '/CarOwnerPortal/Login/' + token).then(function (res) {
	      var token = res.data.Token;
	      window.localStorage.setItem('user_token', token);
	      window.localStorage.setItem('user_data', JSON.stringify(res.data));
	      (0, _setAuthorizationToken.setAuthorizationToken)(token);
	      (0, _setAuthorizationToken.setDeviceToken)(res.data.DeviceToken);
	      dispatch(setCurrentUser(res.data));
	      if (!window.localStorage.user_language) {
	        window.localStorage.setItem('user_language', res.data.DefaultLanguage);
	        dispatch((0, _actions.setLanguageAction)(res.data.DefaultLanguage));
	      }
	
	      return res;
	    });
	  };
	}
	
	/**
	 * @description set acceptance of terms of service
	 * @return {Promise} Axios promise
	 */
	function acceptTOS(data) {
	  return function (dispatch) {
	    return _axios2.default.post(_constants.API_URL + '/CarOwnerPortal/AcceptTOS', data);
	  };
	}
	
	function setCurrentUser(user) {
	  return {
	    type: _constants.SET_CURRENT_USER,
	    user: user
	  };
	}
	
	function logout() {
	  return function (dispatch) {
	    window.localStorage.removeItem('user_token');
	    window.localStorage.removeItem('user_data');
	    window.localStorage.removeItem('user_language');
	    (0, _setAuthorizationToken.setAuthorizationToken)(false);
	    (0, _setAuthorizationToken.setDeviceToken)(false);
	    dispatch(setCurrentUser({}));
	  };
	}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPrices = getPrices;
	exports.updatePrices = updatePrices;
	exports.approvePrices = approvePrices;
	exports.rejectPrices = rejectPrices;
	exports.getPricesForApproval = getPricesForApproval;
	exports.getPricesForShopApproval = getPricesForShopApproval;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting the price using the API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/orderPrice
	 */
	function getPrices(orderID, addon, evaluation, afterevaluation, deviation, otherDamage, editing, useSelectedEvaluation, department, getOnly) {
	  var url = _constants.API_URL + '/Orderprice/Get';
	  deviation = deviation === false ? 0 : deviation;
	  if (useSelectedEvaluation === undefined || useSelectedEvaluation == null) {
	    useSelectedEvaluation = false;
	  }
	  if (getOnly === undefined || getOnly == null) {
	    getOnly = false;
	  }
	  var data = {
	    OrderId: orderID,
	    Addon: addon,
	    Evaluation: evaluation,
	    AfterEvaluation: afterevaluation,
	    Deviation: deviation,
	    OtherDamage: otherDamage,
	    GetEditing: editing,
	    UseSelectedEvaluation: useSelectedEvaluation,
	    Department: department,
	    GetOnly: getOnly
	
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      dispatch({
	        type: _constants.SET_PRICECALC_PRICES,
	        price: res.data
	      });
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Getting the updated price using the API
	 * @return {Promise} Axios promise
	 */
	function updatePrices(data) {
	  var url = _constants.API_URL + '/Orderprice/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      dispatch({
	        type: _constants.SET_PRICECALC_PRICES,
	        price: res.data
	      });
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Approve price changes using the API
	 * @return {Promise} Axios promise
	 */
	function approvePrices(token, name, comment) {
	  var url = _constants.API_URL + '/Orderprice/CustomerApproval/Approve';
	  var data = {
	    ApprovalToken: token,
	    Name: name,
	    Comment: comment
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Approve price changes using the API
	 * @return {Promise} Axios promise
	 */
	function rejectPrices(token, name, comment) {
	  var url = _constants.API_URL + '/Orderprice/CustomerApproval/Reject';
	  var data = {
	    ApprovalToken: token,
	    Name: name,
	    Comment: comment
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Getting price for approval by token
	 * @return {Promise} Axios promise
	 */
	function getPricesForApproval(token) {
	  var url = _constants.API_URL + '/Orderprice/CustomerApproval/Get/' + token;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Approve price changes using the API
	 * @return {Promise} Axios promise
	 */
	function getPricesForShopApproval(orderId, type, department) {
	  var url = _constants.API_URL + '/OrderPrice/ShopApproval/Get';
	  var data = {
	    OrderId: orderId,
	    Type: type,
	    Department: department
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      return res;
	    });
	  };
	}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTasks = getTasks;
	exports.getTask = getTask;
	exports.createUpdateTask = createUpdateTask;
	exports.getDeadline = getDeadline;
	exports.postOccurrenceFile = postOccurrenceFile;
	exports.fileUpload = fileUpload;
	exports.fileDelete = fileDelete;
	exports.getCategories = getCategories;
	exports.getOccurrenceNotes = getOccurrenceNotes;
	exports.getOccurrenceAssigns = getOccurrenceAssigns;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get all tasks from api
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/tasks
	 */
	function getTasks(data) {
	  var url = _constants.FILE_STORAGE_API + '/OtherTask/GetList';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get task by id from api
	 * @return {Promise} Axios promise
	 */
	function getTask(id) {
	  var url = _constants.FILE_STORAGE_API + '/OtherTask/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get update / insert task to api
	 * @return {Promise} Axios promise
	 */
	function createUpdateTask(data) {
	  var url = _constants.API_URL + '/OtherTask/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function getDeadline(data) {
	  var url = _constants.API_URL + '/OtherTask/Deadline';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Add orderFile to OtherTaskOccurrence
	 * @return {Promise} Axios promise
	 */
	function postOccurrenceFile(data) {
	  var url = _constants.API_URL + '/OtherTask/PostOccurrenceFile';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Upload file
	 * @return ..
	 */
	function fileUpload(file) {
	  var url = _constants.FILE_STORAGE_API + '/fileservice/upload?orderID=0';
	  var data = new window.FormData();
	  data.append(file.name, file);
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Delete file
	 * @return ..
	 */
	function fileDelete(data) {
	  console.log(data);
	  var url = _constants.FILE_STORAGE_API + '/FileService/Delete';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get all categories from api
	 * @return {Promise} Axios promise
	 */
	function getCategories() {
	  var url = _constants.API_URL + '/OtherTask/Categories/0';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get all Othertask occurrence notes from api
	 * @return {Promise} Axios promise
	 */
	function getOccurrenceNotes(occurrenceId) {
	  var url = _constants.API_URL + '/OtherTask/GetOccurrenceNotes/' + occurrenceId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get all assigned users to an occurrence
	 * @return {Promise} Axios promise
	 */
	function getOccurrenceAssigns(occurrenceId) {
	  var url = _constants.API_URL + '/OtherTask/GetOccurrenceAssigns/' + occurrenceId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPartners = getPartners;
	exports.getPartner = getPartner;
	exports.CreateSavePartner = CreateSavePartner;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting partners from API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/workProvider
	 */
	function getPartners() {
	  var url = _constants.API_URL + '/WorkProvider/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting partner from API
	 * @return {Promise} Axios promise
	 */
	function getPartner(partnerID) {
	  var url = _constants.API_URL + '/WorkProvider/Get/' + partnerID;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a partner
	 * @return {Promise} Axios promise
	 */
	function CreateSavePartner(data) {
	  var url = _constants.API_URL + '/WorkProvider/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1412);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _HelpText = __webpack_require__(130);
	
	var _HelpText2 = _interopRequireDefault(_HelpText);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _assign = __webpack_require__(148);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// import components
	
	
	// Actions
	
	
	// Utils
	
	
	var AssignBox = function (_Component) {
	  _inherits(AssignBox, _Component);
	
	  function AssignBox(props) {
	    _classCallCheck(this, AssignBox);
	
	    var _this = _possibleConstructorReturn(this, (AssignBox.__proto__ || Object.getPrototypeOf(AssignBox)).call(this, props));
	
	    _this.state = {
	      employees: []
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.renderEmployee = _this.renderEmployee.bind(_this);
	    _this.headerLeft = _this.headerLeft.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssignBox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAssignEmployees();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.setEmployees([]);
	    }
	  }, {
	    key: 'getAssignEmployees',
	    value: function getAssignEmployees() {
	      var _this2 = this;
	
	      this.props.getUserAssignments(0).then(function (res) {
	        _this2.setState({
	          employees: res.data.UserAssignments
	        });
	      }, function () {
	        console.log('Getting assigned users failed');
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      var _this3 = this;
	
	      var onClick = function onClick() {
	        if (typeof _this3.props.closeAssign === 'function') {
	          _this3.props.closeAssign();
	        }
	      };
	
	      return _react2.default.createElement(_closeButton2.default, { onClick: onClick, ariaText: (0, _helpers.translation)('235'), ariaPos: this.props.ariaPos });
	    }
	  }, {
	    key: 'isEmployeeActive',
	    value: function isEmployeeActive(employeeId) {
	      var found = false;
	      this.props.activeEmployees.map(function (val) {
	        if (val === employeeId) {
	          found = true;
	        }
	      });
	      return found;
	    }
	  }, {
	    key: 'onEmployeeClick',
	    value: function onEmployeeClick(employee) {
	      var isActive = this.isEmployeeActive(employee.UserId);
	      var activeEmployees = [];
	      if (!isActive) {
	        // activeEmployees = [...this.props.activeEmployees]
	        activeEmployees.push(employee.UserId);
	      } else {
	        activeEmployees = [].concat(_toConsumableArray(this.props.activeEmployees)).filter(function (val) {
	          return val !== employee.UserId;
	        });
	      }
	      this.props.setEmployees(activeEmployees);
	      this.props.onEmployeeChange(activeEmployees);
	    }
	  }, {
	    key: 'renderEmployee',
	    value: function renderEmployee(employee, key) {
	      var _this4 = this;
	
	      var extraClass = '';
	      var activeColor = 'Black';
	      // Active class
	      if (this.isEmployeeActive(employee.UserId)) {
	        extraClass = 'active';
	        activeColor = 'White';
	      }
	      var employeeHeigth = '136';
	      if (this.props.auth.departmentType === 1) employeeHeigth = '65';
	      var renderEmployeeTime = function renderEmployeeTime() {
	        var employeeTime = '';
	        if (_this4.props.auth.departmentType !== 1) {
	          employeeTime = [_react2.default.createElement(
	            'div',
	            { className: 'hint--top-right', 'aria-label': (0, _helpers.translation)('2252') },
	            employee.RemainingWorkTime
	          ), _react2.default.createElement(
	            'div',
	            { className: 'overTime hint--top-right', 'aria-label': (0, _helpers.translation)('455') },
	            employee.OverTime || '00:00'
	          ), _react2.default.createElement(
	            'div',
	            { className: 'extraWork hint--top-right', 'aria-label': (0, _helpers.translation)('2253') },
	            employee.ExtraWorkTime
	          ), _react2.default.createElement(
	            'div',
	            { className: 'tasks hint--top-right', 'aria-label': (0, _helpers.translation)('233') },
	            _react2.default.createElement('img', { src: '/images/icons/Task_16x16-' + activeColor + '.png' }),
	            employee.OtherWorkCount
	          )];
	        } else {
	          employeeTime = _react2.default.createElement(
	            'div',
	            { className: 'hint--top-right', 'aria-label': (0, _helpers.translation)('2252') },
	            employee.TotalTime
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          (0, _auth.hasSubscriptionPermission)(_this4.props.auth, 20) && employeeTime
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, className: 'employee ' + extraClass, style: { height: employeeHeigth + 'px' }, onClick: this.onEmployeeClick.bind(this, employee) },
	        _react2.default.createElement(
	          'div',
	          { className: 'initials hint--' + this.props.assignAriaPos, 'aria-label': employee.Name },
	          _react2.default.createElement('img', { src: '/images/icons/Ring-' + activeColor + '.png' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            employee.UserInitials
	          )
	        ),
	        renderEmployeeTime()
	      );
	    }
	
	    // <div className='hint--top-right' aria-label={translation('2252')}>{employee.RemainingWorkTime}</div>
	    // <div className='overTime hint--top-right' aria-label={translation('455')}>+{employee.OverTime || '00:00'}</div>
	    // <div className='extraWork hint--top-right' aria-label={translation('2253')}>+{employee.ExtraWorkTime}</div>
	    // <div className='tasks hint--top-right' aria-label={translation('233')}><img src={'/images/icons/Task_16x16-' + activeColor + '.png'} />+{employee.OtherWorkCount}</div>
	
	  }, {
	    key: 'headerLeft',
	    value: function headerLeft() {
	      return _react2.default.createElement(_HelpText2.default, { text: (0, _helpers.translation)('2338'), right: true, white: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var width = this.state.employees.length * 60 + 'px';
	      var assignBoxHeight = '186';
	      if (this.props.auth.departmentType === 1) assignBoxHeight = '115';
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) assignBoxHeight = '100';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'assignUserBox', style: { height: assignBoxHeight + 'px' } },
	        !this.props.hideHeader && _react2.default.createElement(_Header2.default, { router: this.props.router, title: (0, _helpers.translation)('1856'), renderLeftBefore: function renderLeftBefore() {
	            return _react2.default.createElement(_icon2.default, { style: { top: '8px', 'margin-right': '8px' }, size: 'm', icon: _icons.AssignmentIcons.Assign_Employee_Black });
	          }, renderRight: this.headerButtonsRight }),
	        _react2.default.createElement(
	          'div',
	          { className: 'assignEmployeesOuter' },
	          this.props.hideHeader && _react2.default.createElement(
	            'div',
	            { className: 'inside-close-button' },
	            this.headerButtonsRight()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assignEmployees', style: { width: width } },
	            this.state.employees.map(this.renderEmployee)
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssignBox;
	}(_react.Component);
	
	AssignBox.defaultProps = {
	  assignAriaPos: 'right'
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    activeEmployees: state.assign.activeEmployees
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getUserAssignments: _assign.getUserAssignments,
	  setEmployees: _assign.setEmployees
	}, null, { withRef: true })(AssignBox);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _employees = __webpack_require__(128);
	
	var _customers = __webpack_require__(74);
	
	var _chains = __webpack_require__(127);
	
	var _workProviderContact = __webpack_require__(283);
	
	var _shopowners = __webpack_require__(282);
	
	var _users = __webpack_require__(800);
	
	__webpack_require__(1500);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Actions
	
	
	// import styles
	
	
	var CreateUser = function (_Component) {
	  _inherits(CreateUser, _Component);
	
	  function CreateUser(props) {
	    _classCallCheck(this, CreateUser);
	
	    var _this = _possibleConstructorReturn(this, (CreateUser.__proto__ || Object.getPrototypeOf(CreateUser)).call(this, props));
	
	    _this.default = {
	      UserId: 0,
	      Name: '',
	      Email: '',
	      Confirmed: false,
	      CustomerId: _this.props.customerID && _this.props.customerID,
	      ChainId: _this.props.chainID && _this.props.chainID,
	      WorkProviderId: _this.props.wpID && _this.props.wpID,
	      ResendActivationMail: false,
	      UserType: 0
	    };
	    _this.state = {
	      UserId: 0,
	      Name: '',
	      Email: '',
	      Confirmed: false,
	      CustomerId: _this.props.customerID && _this.props.customerID,
	      ChainId: _this.props.chainID && _this.props.chainID,
	      WorkProviderId: _this.props.wpID && _this.props.wpID,
	      ResendActivationMail: false,
	      UserType: 0
	    };
	
	    _this.updateUser = _this.updateUser.bind(_this);
	    _this.getInfo = _this.getInfo.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(CreateUser, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateUser(this.props.user);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      if (next !== this.props) {
	        this.updateUser(next.user);
	      }
	    }
	  }, {
	    key: 'updateUser',
	    value: function updateUser(user) {
	      var _this2 = this;
	
	      if (user) {
	        if (this.state.UserId !== user.UserId && user.UserId > 0) {
	          if (this.props.isEmployee) {
	            this.props.getEmployee(user.UserId).then(function (res) {
	              user = res.data;
	              _this2.setState({
	                UserId: user.UserId,
	                Name: user.Name,
	                Email: user.Email,
	                Confirmed: user.Confirmed,
	                UserType: user.UserType
	              });
	            });
	          } else if (this.props.isContact) {
	            this.props.getCustomerContact(user.UserId).then(function (res) {
	              user = res.data;
	              _this2.setState({
	                UserId: user.UserId,
	                Name: user.Name,
	                Email: user.Email,
	                Confirmed: user.Confirmed,
	                CustomerId: user.CustomerId,
	                UserType: user.UserType
	              });
	            });
	          } else if (this.props.isChainAdmin) {
	            this.props.getAdminChain(user.UserId).then(function (res) {
	              user = res.data;
	              _this2.setState({
	                UserId: user.UserId,
	                Name: user.Name,
	                Email: user.Email,
	                Confirmed: user.Confirmed,
	                ChainId: user.ChainId,
	                UserType: user.UserType
	              });
	            });
	          } else if (this.props.isWPContact) {
	            this.props.getPartnerContact(user.UserId).then(function (res) {
	              user = res.data;
	              _this2.setState({
	                UserId: user.UserId,
	                Name: user.Name,
	                Email: user.Email,
	                Confirmed: user.Confirmed,
	                WorkProviderId: user.WorkProviderId,
	                UserType: user.UserType
	              });
	            });
	          } else if (this.props.isShopOwner) {
	            this.props.getShopOwner(user.UserId).then(function (res) {
	              user = res.data;
	              _this2.setState({
	                UserId: user.UserId,
	                Name: user.Name,
	                Email: user.Email,
	                Confirmed: user.Confirmed,
	                UserType: user.UserType
	              });
	            });
	          }
	        }
	
	        this.setState({
	          UserId: user.UserId,
	          Name: user.Name,
	          Email: user.Email,
	          Confirmed: user.Confirmed,
	          CustomerId: user.CustomerId,
	          ChainId: user.ChainId,
	          WorkProviderId: user.WorkProviderId,
	          UserType: user.UserType
	        });
	      } else {
	        this.setState(_extends({}, this.default));
	      }
	    }
	  }, {
	    key: 'createUser',
	    value: function createUser() {
	      var _this3 = this;
	
	      var resend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var errorMessage = function errorMessage(error, userType) {
	        var messageText = '';
	        if (error < 5) {
	          switch (userType) {
	            case 'employee':
	              messageText += (0, _helpers.translation)('16334');
	              break;
	            case 'contact':
	              messageText += (0, _helpers.translation)('16340');
	              break;
	            case 'chainAdmin':
	              messageText += (0, _helpers.translation)('17948');
	              break;
	            case 'wpContact':
	              messageText += (0, _helpers.translation)('17950');
	              break;
	            case 'shopOwner':
	              messageText += (0, _helpers.translation)('17953');
	              break;
	            default:
	              break;
	          }
	        }
	        if (messageText !== '') messageText += ' ';
	        switch (error) {
	          case 1:
	            messageText += (0, _helpers.translation)('16329');
	            break;
	          case 2:
	            messageText += (0, _helpers.translation)('16336');
	            break;
	          case 3:
	            messageText += (0, _helpers.translation)('16335');
	            break;
	          case 4:
	            messageText += (0, _helpers.translation)('16338');
	            break;
	          case 5:
	            messageText += (0, _helpers.translation)('16337');
	            break;
	          case 6:
	            messageText += (0, _helpers.translation)('1794');
	            break;
	          default:
	            break;
	        }
	        messageText += '<br>';
	        return messageText;
	      };
	      var state = this.state;
	      if (resend) state.ResendActivationMail = true;
	
	      var userType = this.props.isEmployee ? 'employee' : this.props.isContact ? 'contact' : this.props.isChainAdmin ? 'chainAdmin' : this.props.isWPContact ? 'wpContact' : this.props.isShopOwner ? 'shopOwner' : '';
	      state.UserType = this.props.isEmployee ? 5 : this.props.isContact ? 9 : this.props.isChainAdmin ? 2 : this.props.isWPContact ? 10 : this.props.isShopOwner ? 3 : 0;
	
	      this.props.createBaseUser(state).then(function (res) {
	        _this3.props.onSuccess(res.data);
	      }).catch(function (err) {
	        var errors = err.response.data;
	        if (Array.isArray(errors)) {
	          var message = errors.map(function (error) {
	            return errorMessage(error, userType);
	          });
	          window.toastr.error(message, (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error(errors, (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var onBlur = function onBlur() {
	        if (_this4.state.UserId > 0) {
	          _this4.createUser();
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'create-user--screen' },
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: this.props.title },
	            _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('30'), name: 'Name', value: this.state.Name || '', onChange: this.onInputChange, onBlur: onBlur }),
	            _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('1052'), name: 'Email', value: this.state.Email || '', onChange: this.onInputChange, onBlur: onBlur }),
	            this.state.Confirmed !== true && this.state.UserId > 0 && _react2.default.createElement(_button2.default, { style: 'link', labelText: (0, _helpers.translation)('16319'), onClick: function onClick() {
	                return _this4.createUser(true);
	              } })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var name = e.target.name;
	      var value = e.target.value;
	
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'getInfo',
	    value: function getInfo() {
	      return {
	        Name: this.state.Name,
	        Email: this.state.Email
	      };
	    }
	  }]);
	
	  return CreateUser;
	}(_react.Component);
	
	CreateUser.prototypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	function mapStateToProps(state) {
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getEmployee: _employees.getEmployee,
	  getCustomerContact: _customers.getCustomerContact,
	  getAdminChain: _chains.getAdminChain,
	  getPartnerContact: _workProviderContact.getPartnerContact,
	  getShopOwner: _shopowners.getShopOwner,
	  createBaseUser: _users.createBaseUser
	}, null, { withRef: true })(CreateUser);

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Utils
	// import { renderFullDate } from '../../../../utils/time'
	// import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
	
	
	var AssessmentReportSums = function (_Component) {
	  _inherits(AssessmentReportSums, _Component);
	
	  function AssessmentReportSums() {
	    _classCallCheck(this, AssessmentReportSums);
	
	    return _possibleConstructorReturn(this, (AssessmentReportSums.__proto__ || Object.getPrototypeOf(AssessmentReportSums)).apply(this, arguments));
	  }
	
	  _createClass(AssessmentReportSums, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.report) return null;
	      // let parent = this._reactInternalInstance._currentElement._owner._instance
	      // console.log('AssessmentReportSums -> render', this.props.report, 'parent', parent)
	      var currencyType = (0, _helpers.translation)(this.props.currencyCode);
	
	      var renderReportSums = function renderReportSums(sum, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'sum', key: 'sum_' + i },
	          _react2.default.createElement(_Line2.default, { boldText: true, text: sum.Text + ':', amount: sum.TotalPrice, currencyType: currencyType })
	        );
	      };
	
	      var renderDivider = function renderDivider() {
	        return _react2.default.createElement('div', { className: 'divider' });
	      };
	
	      var sumsToRender = (this.props.report.Summation || []).filter(function (x) {
	        return x.DisplayDepartment === _this2.props.department || _this2.props.department === 2;
	      });
	      if (Array.isArray(this.props.includeSumTypes)) {
	        sumsToRender = sumsToRender.filter(function (x) {
	          return _this2.props.includeSumTypes.includes(x.SumType);
	        });
	      }
	      if (Array.isArray(this.props.excludeSumTypes)) {
	        sumsToRender = sumsToRender.filter(function (x) {
	          return !_this2.props.excludeSumTypes.includes(x.SumType);
	        });
	      }
	
	      var totalWithEnv = 0;
	      var total = 0;
	      var report = this.props.report;
	      switch (this.props.department) {
	        case 0:
	          // PaintShop
	          total = report.Paint.TotalPrice;
	          totalWithEnv = report.Paint.TotalPriceWithEnv;
	          break;
	        case 1:
	          // BodyShop
	          total = report.Body.TotalPrice;
	          totalWithEnv = report.Body.TotalPriceWithEnv;
	          break;
	        case 2:
	          // Both PaintShop and BodyShop
	          total = (report.Body && report.Body.TotalPrice) + (report.Paint && report.Paint.TotalPrice);
	          totalWithEnv = (report.Body && report.Body.TotalPriceWithEnv) + (report.Paint && report.Paint.TotalPriceWithEnv);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'assessment-report-sums' },
	        sumsToRender.filter(function (x) {
	          return x.SumType !== 4;
	        }).map(renderReportSums),
	        this.props.includeTotal && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Line2.default, { boldText: true, text: (0, _helpers.translation)(18392) + ':', amount: total, bold: this.props.includeTotalDivider, currencyType: (0, _helpers.translation)(this.props.currencyCode) })
	        ),
	        this.props.includeTotalDivider && this.props.includeTotal && renderDivider(),
	        sumsToRender.filter(function (x) {
	          return x.SumType === 4;
	        }).map(renderReportSums),
	        this.props.includeTotal && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Line2.default, { boldText: true, text: (0, _helpers.translation)(393) + ':', amount: totalWithEnv, bold: this.props.includeTotalDivider, currencyType: (0, _helpers.translation)(this.props.currencyCode) })
	        )
	      );
	    }
	  }]);
	
	  return AssessmentReportSums;
	}(_react.Component);
	
	AssessmentReportSums.defaultProps = {
	  includeTotal: true,
	  includeTotalDivider: true
	  // excludeSumTypes: [0]
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	    // currencyCode: state.common.currencyCode
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(AssessmentReportSums);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1529);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {  } from '../../../elements/icons'
	
	// Elements
	
	
	// import Icon from '../../../elements/icon'
	var AssessmentReportFiles = function (_Component) {
	  _inherits(AssessmentReportFiles, _Component);
	
	  function AssessmentReportFiles(props) {
	    _classCallCheck(this, AssessmentReportFiles);
	
	    var _this = _possibleConstructorReturn(this, (AssessmentReportFiles.__proto__ || Object.getPrototypeOf(AssessmentReportFiles)).call(this, props));
	
	    _this.state = {
	      selectedFile: null
	    };
	    return _this;
	  }
	
	  _createClass(AssessmentReportFiles, [{
	    key: 'renderUpload',
	    value: function renderUpload() {
	      var _this2 = this;
	
	      var chainAssessmentSystem = this.props.auth.permissions.ChainAssessmentSystem;
	
	      var onDropAccepted = function onDropAccepted(files) {
	        var file = files[0];
	
	        var errorToastMessage = 15194; // FORSI - ERROR
	        if (chainAssessmentSystem === 2) errorToastMessage = 18110; // DBS - ERROR
	
	        // let successToastMessage = 15193 // FORSI - SUCCESS
	        // if (chainAssessmentSystem === 2) successToastMessage = 18111 // DBS - SUCCESS
	
	        if (file.type === 'application/pdf') {
	          _this2.props.uploadFileToOrder(file, _this2.props.order.Id, 12).then(function (res) {
	            if (!res) {
	              // Toastr
	              window.toastr.error((0, _helpers.translation)(errorToastMessage), (0, _helpers.translation)('216'));
	            } else {
	              // Toastr
	              // window.toastr.success(translation(successToastMessage), translation('13424'))
	              if (_this2.props.onUploadSuccess !== undefined) {
	                _this2.props.onUploadSuccess(res);
	              }
	            }
	          }, function (err) {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(errorToastMessage), (0, _helpers.translation)('216'));
	            if (_this2.props.onUploadError !== undefined) {
	              _this2.props.onUploadSuccess(err.response);
	            }
	          });
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(errorToastMessage), (0, _helpers.translation)('216'));
	        }
	      };
	
	      var title = 15192; // FORSI
	      if (chainAssessmentSystem === 2) title = 18112; // DBS
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'browse clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'h-line' },
	          (0, _helpers.translation)(title)
	        ),
	        _react2.default.createElement(
	          _Dropzone2.default
	          // onDrop={onDrop}
	          ,
	          { onDropAccepted: onDropAccepted
	            // onDropRejected={onDropRejected}
	            , includeCircles: false },
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)(13397)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderReportFile',
	    value: function renderReportFile(file, key) {
	      var _this3 = this;
	
	      // if (file.ActualFileName === null) return null
	      if (file.FileName === null) return null;
	      var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token);
	      var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	      var fileTitle = file.FileName;
	      // switch (file.Type) {
	      //   case 13:
	      //     fileTitle = 14836 // 'Lakrapport @'
	      //     break
	      //   case 14:
	      //     fileTitle = 15199 // 'Karosserirapport @'
	      //     break
	      //   case 15:
	      //     fileTitle = 14837 // 'Reservedelsrapport @'
	      //     break
	      // }
	
	      switch (file.SectionType) {
	        case 1:
	          fileTitle = 14836; // 'Lakrapport @'
	          break;
	        case 2:
	          fileTitle = 15199; // 'Karosserirapport @'
	          break;
	        case 4:
	          fileTitle = 14837; // 'Reservedelsrapport @'
	          break;
	      }
	      var renderDate = function renderDate() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'date' },
	          (0, _time.renderFullDate)(_this3.props.order.Report.CreatedDate)
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { key: key, className: 'rp-report-file clearfix' },
	        _react2.default.createElement(
	          'a',
	          { target: '_BLANK', href: newFileUrl },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: ['max-content', 'min-content', 1], align: 'center' },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(fileTitle)
	            ),
	            _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	            this.props.showDates && renderDate()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderBody = this.props.renderBody;
	      var renderPaint = this.props.renderPaint;
	      var renderSparePart = this.props.renderSparePart;
	      var assessmentEnable = [1, 2].includes(this.props.auth.permissions.ChainAssessmentSystem); // Forsi or DBS is available for the company
	      var paintDepartment = this.props.order.OrderDepartment === 0;
	      var bodyFile = void 0;
	      var paintFile = void 0;
	      var sparePartFile = void 0;
	
	      // let files = this.props.order.RPReportFiles
	      var files = this.props.order.Report ? this.props.order.Report.Attachments : [];
	      if (files.length > 0) {
	        // paintFile = files.find(f => f.Type === 13)
	        // bodyFile = files.find(f => f.Type === 14)
	        // sparePartFile = files.find(f => f.Type === 15)
	
	        paintFile = files.find(function (f) {
	          return f.SectionType === 1;
	        });
	        bodyFile = files.find(function (f) {
	          return f.SectionType === 2;
	        });
	        sparePartFile = files.find(function (f) {
	          return f.SectionType === 4;
	        });
	      }
	      var hidden = this.props.editable !== true && files.length === 0;
	      return _react2.default.createElement(
	        'div',
	        { className: 'rp-file-box' + (hidden ? ' hidden' : '') },
	        assessmentEnable && this.props.editable && this.renderUpload(),
	        !paintDepartment && renderBody && bodyFile !== undefined && this.renderReportFile(bodyFile, 1),
	        renderPaint && paintFile !== undefined && this.renderReportFile(paintFile, 2),
	        !paintDepartment && renderSparePart && sparePartFile !== undefined && this.renderReportFile(sparePartFile, 3)
	      );
	    }
	  }]);
	
	  return AssessmentReportFiles;
	}(_react.Component);
	
	AssessmentReportFiles.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  uploadFileToOrder: _orders.uploadFileToOrder
	})(AssessmentReportFiles);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1573);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux'
	
	var ArrowButton = function (_Component) {
	  _inherits(ArrowButton, _Component);
	
	  function ArrowButton(props) {
	    _classCallCheck(this, ArrowButton);
	
	    var _this = _possibleConstructorReturn(this, (ArrowButton.__proto__ || Object.getPrototypeOf(ArrowButton)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ArrowButton, [{
	    key: 'render',
	    value: function render() {
	      var buttonProps = _extends({}, this.props);
	      var icon = null;
	      switch (this.props.size) {
	        case 's':
	          icon = _icons.ButtonIcons.Arrow_Link_16;
	          break;
	        case 'm':
	          icon = _icons.ButtonIcons.Arrow_Link_20;
	          break;
	        case 'l':
	          icon = _icons.ButtonIcons.Arrow_Link_24;
	          break;
	      }
	
	      var rotation = 0;
	      switch (this.props.dir) {
	        case 'left':
	        case 'l':
	          rotation = 180;
	          break;
	        case 'right':
	        case 'r':
	          rotation = 0;
	          break;
	        case 'top':
	        case 't':
	          rotation = 270;
	          break;
	        case 'down':
	        case 'd':
	          rotation = 90;
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-arrowbutton' },
	        _react2.default.createElement(
	          _button2.default,
	          buttonProps,
	          _react2.default.createElement(_icon2.default, { size: this.props.size, icon: null, icon2: icon, injectSvg: true, rotation: rotation })
	        )
	      );
	    }
	  }]);
	
	  return ArrowButton;
	}(_react.Component);
	
	ArrowButton.defaultProps = {
	  size: 'l',
	  style: 'link',
	  round: true,
	  spacing: 0,
	  dir: 'right'
	};
	
	ArrowButton.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = ArrowButton;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1596);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// import Grid from '../grid'
	
	var IconAccordion = function (_Component) {
	  _inherits(IconAccordion, _Component);
	
	  function IconAccordion(props) {
	    _classCallCheck(this, IconAccordion);
	
	    var _this = _possibleConstructorReturn(this, (IconAccordion.__proto__ || Object.getPrototypeOf(IconAccordion)).call(this, props));
	
	    _this.state = {};
	
	    _this.renderIcon = _this.renderIcon.bind(_this);
	    return _this;
	  }
	
	  _createClass(IconAccordion, [{
	    key: 'getSize',
	    value: function getSize() {
	      switch (this.props.size) {
	        case 's':
	          return 'accordion-2';
	        default:
	        case 'm':
	          return 'accordion-3';
	        case 'l':
	          return 'accordion-4';
	      }
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(iconObj, index) {
	      if (typeof iconObj.icon === 'undefined' && typeof iconObj.customComponent === 'undefined') {
	        console.error('IconAccordion icons must be an array of type \'{ icon: ..., ... }\' OR \'{ customComponent: ..., ... }\'');
	      }
	
	      var icon = iconObj.icon,
	          customComponent = iconObj.customComponent,
	          noCircle = iconObj.noCircle,
	          iconProps = _objectWithoutProperties(iconObj, ['icon', 'customComponent', 'noCircle']);
	
	      var count = this.props.icons.length;
	      var iconSize = this.props.size;
	
	      var classNames = '';
	      if (!noCircle) {
	        classNames = 'element-icon-accordion__icon--circle';
	
	        switch (this.props.size) {
	          case 's':
	            iconSize = 't';
	            classNames += ' size-small';
	            break;
	          case 'm':
	          default:
	            iconSize = 's';
	            classNames += ' size-medium';
	            break;
	          case 'l':
	            iconSize = 'm';
	            classNames += ' size-large';
	            break;
	        }
	      }
	
	      var component = null;
	      if (icon) {
	        component = _react2.default.createElement(_icon2.default, _extends({
	          icon: icon,
	          size: iconSize,
	          injectSvg: true
	        }, iconProps));
	      } else if (customComponent) {
	        var _Component2 = customComponent;
	        component = _react2.default.createElement(_Component2, _extends({ size: iconSize }, iconProps));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames, style: { zIndex: count - index }, key: index },
	        component
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-icon-accordion ' + this.getSize() },
	        this.props.icons.map(this.renderIcon)
	      );
	    }
	  }]);
	
	  return IconAccordion;
	}(_react.Component);
	
	IconAccordion.defaultProps = {
	  size: 'm'
	};
	
	exports.default = IconAccordion;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _common = __webpack_require__(25);
	
	__webpack_require__(1623);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SlidePanel = function (_Component) {
	  _inherits(SlidePanel, _Component);
	
	  function SlidePanel() {
	    _classCallCheck(this, SlidePanel);
	
	    return _possibleConstructorReturn(this, (SlidePanel.__proto__ || Object.getPrototypeOf(SlidePanel)).apply(this, arguments));
	  }
	
	  _createClass(SlidePanel, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Force remove slidePanelId from stack when unmounting
	      this.props.closeSlidePanel(this.props.slidePanelId, true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.isSlidePanelOpen(this.props.slidePanelId)) return null;
	      var slidePanelClass = 'element-slidePanel';
	      if (this.props.extraClassName) slidePanelClass += ' ' + this.props.extraClassName;
	      if (this.props.isLoading) slidePanelClass += ' isLoading';
	      return _react2.default.createElement(
	        'div',
	        { className: slidePanelClass },
	        this.props.isLoading && _react2.default.createElement(
	          'div',
	          { className: 'loadingBackdrop' },
	          _react2.default.createElement(
	            'span',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'sr-only' },
	              (0, _helpers.translation)('13382'),
	              '...'
	            )
	          )
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return SlidePanel;
	}(_react.Component);
	
	SlidePanel.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	SlidePanel.propTypes = {
	  slidePanelId: _react2.default.PropTypes.string.isRequired
	};
	
	SlidePanel.defaultProps = {
	  isLoading: false
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    slidePanelsLength: state.common.slidePanels.length // (makes react detect the change, not sure why it doesn't detect this through the array)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  closeSlidePanel: _common.closeSlidePanel,
	  isSlidePanelOpen: _common.isSlidePanelOpen
	})(SlidePanel);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _notes = __webpack_require__(114);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _constants = __webpack_require__(5);
	
	var _icons = __webpack_require__(6);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	__webpack_require__(1657);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import components
	
	
	// Utils
	
	
	// import styles
	
	
	var NotesModal = function (_Component) {
	  _inherits(NotesModal, _Component);
	
	  function NotesModal(props) {
	    _classCallCheck(this, NotesModal);
	
	    var _this = _possibleConstructorReturn(this, (NotesModal.__proto__ || Object.getPrototypeOf(NotesModal)).call(this, props));
	
	    _this.state = {
	      show: false,
	      showEdit: false,
	      note: props.note,
	      standardNotes: [],
	      isLoading: false,
	      error: ''
	    };
	    _this.manipulateNote = _this.manipulateNote.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.addStandardNote = _this.addStandardNote.bind(_this);
	    _this.addNoteText = _this.addNoteText.bind(_this);
	    _this.deleteNoteText = _this.deleteNoteText.bind(_this);
	    _this.checkAndUpdateStandardNotes = _this.checkAndUpdateStandardNotes.bind(_this);
	    _this.updateStandardNote = _this.updateStandardNote.bind(_this);
	    // this.renderStandardNotes = this.renderStandardNotes.bind(this)
	    return _this;
	  }
	
	  _createClass(NotesModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.checkAndUpdateStandardNotes(this.props.standardNotes) === false) {
	        // Get standardNotes if not from props
	        this.props.getStandardNotes().then(function (res) {
	          _this2.setState({
	            standardNotes: res.data
	          });
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (props.show !== this.state.show) {
	        this.setState({
	          show: props.show,
	          note: props.note,
	          isLoading: false,
	          error: ''
	        });
	      }
	
	      this.checkAndUpdateStandardNotes(props.standardNotes);
	    }
	  }, {
	    key: 'checkAndUpdateStandardNotes',
	    value: function checkAndUpdateStandardNotes(standardNotes) {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	
	      if (Array.isArray(standardNotes)) {
	        this.setState({
	          standardNotes: standardNotes
	        });
	
	        return true; // Did update
	      }
	
	      return false; // Didn't update
	    }
	  }, {
	    key: 'manipulateNote',
	    value: function manipulateNote(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      this.setState({ isLoading: true, error: '' });
	
	      setTimeout(function () {
	        if (_this3.validateInputs()) {
	          var orderID = _this3.state.note.OrderID;
	          var NoteTypeID = _this3.state.note.NoteTypeID;
	          var SourceID = typeof _this3.state.note.SourceID !== 'undefined' ? _this3.state.note.SourceID : 2;
	          var CustomInspectionId = typeof _this3.state.note.CustomInspectionId !== 'undefined' ? _this3.state.note.CustomInspectionId : 0;
	          if (_this3.props.note.Note !== '') {
	            var newNote = {
	              Note: _this3.state.note.Note,
	              NoteTypeID: NoteTypeID,
	              OrderID: orderID,
	              NoteID: _this3.state.note.NoteID,
	              SourceID: SourceID,
	              ApplyToInvoice: _this3.state.note.ApplyToInvoice,
	              ShowToCustomer: _this3.state.note.ShowToCustomer,
	              ShowToPaintShop: _this3.state.note.ShowToPaintShop,
	              CustomInspectionId: CustomInspectionId
	
	              // Edit note
	            };_this3.props.createNote(newNote).then(function (res) {
	              _this3.props.onSuccess(res.data);
	              _this3.props.onClose(false);
	              // Toastr
	              // window.toastr.success(translation('1931'), translation('13424'))
	            }, function (err) {
	              if (err) {
	                _this3.setState({
	                  isLoading: false
	                });
	                // Toastr
	                window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	              }
	            });
	          } else {
	            if (_this3.props.auth.user.CustomerId !== '-1') {
	              NoteTypeID = 0;
	            } else {
	              NoteTypeID = _this3.state.note.NoteTypeID;
	            }
	
	            // // IF NoteTypeID === 0
	            // if (NoteTypeID === 0) {
	            //   NoteTypeID = 1
	            // }
	
	            var _newNote = {
	              Note: _this3.state.note.Note,
	              NoteTypeID: NoteTypeID,
	              OrderID: orderID,
	              SourceID: SourceID,
	              ApplyToInvoice: _this3.state.note.ApplyToInvoice,
	              ShowToCustomer: _this3.state.note.ShowToCustomer,
	              ShowToPaintShop: _this3.state.note.ShowToPaintShop,
	              CustomInspectionId: CustomInspectionId
	
	              // Create note
	            };_this3.props.createNote(_newNote).then(function (res) {
	              _this3.props.onSuccess(res.data);
	              _this3.props.onClose(false);
	              // Toastr
	              // window.toastr.success(translation('1931'), translation('13424'))
	            }, function (err) {
	              if (err) {
	                _this3.setState({
	                  isLoading: false
	                });
	                // Toastr
	                window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	              }
	            });
	          }
	        } else {
	          _this3.setState({
	            isLoading: false
	          });
	          window.toastr.error((0, _helpers.translation)('13430'), (0, _helpers.translation)('216'));
	        }
	      }, 50);
	    }
	  }, {
	    key: 'validateInputs',
	    value: function validateInputs() {
	      if (this.state.note.Note === '') {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var isPaintShop = this.props.auth.departmentType === _constants.DepartmentType.Paint;
	      // called at "onClick" for checkbox... for some reason "onChange" doesn't work here
	      if (e.target.type === 'checkbox') {
	        if (e.target.name === 'ApplyToInvoice' || e.target.name === 'ShowToCustomer' || e.target.name === 'ShowToPaintShop') {
	          var extra = {};
	
	          if (e.target.name === 'ShowToCustomer') {
	            extra.NoteTypeID = 0;
	            if (!this.state.note.ShowToCustomer) {
	              extra.NoteTypeID = isPaintShop ? 1 : 0;
	            }
	          }
	
	          if (e.target.name === 'ShowToPaintShop') {
	            if (this.state.note.ShowToPaintShop) {
	              extra.NoteTypeID = 0;
	            } else {
	              extra.NoteTypeID = 1;
	            }
	          }
	
	          this.setState({
	            note: _extends({}, this.state.note, _defineProperty({}, e.target.name, !this.state.note[e.target.name]), extra)
	          });
	        } else {
	          this.setState({
	            note: _extends({}, this.state.note, {
	              NoteTypeID: this.state.note.NoteTypeID === 0 ? 1 : 0
	            })
	          });
	        }
	      } else {
	        this.setState({
	          note: _extends({}, this.state.note, {
	            Note: e.target.value
	          })
	        });
	      }
	    }
	  }, {
	    key: 'addStandardNote',
	    value: function addStandardNote(e) {
	      e.preventDefault();
	      var inputText = document.getElementsByName('standardNote')[0];
	      var noteText = document.getElementsByName('standardNote')[0].value;
	      if (noteText !== '') {
	        var newStandardNote = {
	          Id: 0,
	          Note: noteText,
	          IsDeleted: false
	        };
	        this.updateStandardNote(newStandardNote);
	        inputText.value = '';
	      }
	    }
	  }, {
	    key: 'addNoteText',
	    value: function addNoteText(text) {
	      var noteText = this.state.note.Note;
	      if (noteText === '') {
	        noteText = text;
	      } else {
	        noteText += '\n';
	        noteText = noteText.concat(text);
	      }
	      this.setState({
	        note: _extends({}, this.state.note, {
	          Note: noteText
	        })
	      });
	    }
	  }, {
	    key: 'deleteNoteText',
	    value: function deleteNoteText(note) {
	      note.IsDeleted = true;
	      this.updateStandardNote(note);
	    }
	  }, {
	    key: 'updateStandardNote',
	    value: function updateStandardNote(note) {
	      var _this4 = this;
	
	      this.props.createOrDeleteStandardNote(note).then(function (res) {
	        _this4.setState({
	          standardNotes: res.data
	        });
	        if (typeof _this4.props.onStandardNoteUpdate === 'function') {
	          _this4.props.onStandardNoteUpdate(res.data);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      if (typeof this.props.note.Note === 'undefined') return null;
	
	      var modalTitle = (0, _helpers.translation)('13356');
	      var isBodyShop = this.props.auth.departmentType === _constants.DepartmentType.Body;
	      var isReferred = this.props.order.IsReferredIn || this.props.order.IsReferredOut;
	      var isReferredBody = isBodyShop && isReferred;
	
	      var bottomBarProps = {
	        disabled: this.state.isLoading,
	        actionLabelText: (0, _helpers.translation)('13358'),
	        onActionClick: this.manipulateNote
	      };
	      if (typeof this.props.note.IsMine !== 'undefined') {
	        bottomBarProps = {
	          disabled: this.state.isLoading,
	          actionLabelText: (0, _helpers.translation)('13357'),
	          onActionClick: this.manipulateNote
	        };
	        modalTitle = (0, _helpers.translation)('13357');
	      }
	
	      var renderStandardNotes = function renderStandardNotes() {
	        if (_this5.state.standardNotes.length <= 0) return null;
	        var sNotes = [].concat(_toConsumableArray(_this5.state.standardNotes));
	        // var last = sNotes.length - 1
	        // let divClass = 'noteText clearfix'
	        var renderedNotes = sNotes.map(function (note, i) {
	          var deleteNoteTextTest = function deleteNoteTextTest() {
	            _this5.deleteNoteText(note);
	          };
	          // if (i === last) {
	          //   divClass += ' space'
	          // }
	          // console.log(i) // this.deleteNoteText.bind(this, note)
	          return _react2.default.createElement(
	            'div',
	            { key: i },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'span',
	                null,
	                note.Note
	              ),
	              _this5.state.showEdit === true && _react2.default.createElement(_removeButton2.default, { size: 's', onClick: deleteNoteTextTest }),
	              _react2.default.createElement(_addButton2.default, { size: 's', onClick: _this5.addNoteText.bind(_this5, note.Note) })
	            )
	          );
	          // return (
	          //   <div key={i} className={divClass}>
	          //     <span>{note.Note}</span>
	          //     <div className='standardNoteActions'>
	          //       {this.state.showEdit === true && (<div className='remove' onClick={() => this.deleteNoteText(note)}><img src='/images/icons/Delete_16.png' /></div>)}
	          //       <div className='add' onClick={() => this.addNoteText(note.Note)}><img src='/images/icons/Plus-White.png' /></div>
	          //     </div>
	          //   </div>
	          // )
	        });
	        return renderedNotes;
	      };
	      var toggleEdit = function toggleEdit() {
	        _this5.setState({
	          showEdit: !_this5.state.showEdit
	        });
	      };
	      var defaultNoteTitle = (0, _helpers.translation)('15095');
	      if (this.state.standardNotes.length <= 0) {
	        defaultNoteTitle = (0, _helpers.translation)('15207');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'notes__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: modalTitle,
	            icon: _icons.ModalIcons.Note,
	            bottomBarProps: bottomBarProps
	          }),
	          this.state.error && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.state.error
	          ),
	          _react2.default.createElement(_textarea2.default, { name: 'Note', onChange: this.onInputChange, value: this.state.note.Note }),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: _react2.default.createElement(
	                _inline2.default,
	                { fillChildNum: [0], fullWidth: true },
	                defaultNoteTitle,
	                ' ',
	                _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't', onClick: toggleEdit.bind(this) })
	              ) },
	            renderStandardNotes()
	          ),
	          this.state.showEdit === true && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('15201') },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(_text2.default, { name: 'standardNote' }),
	              _react2.default.createElement(_addButton2.default, { onClick: this.addStandardNote })
	            )
	          ),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(_check2.default, { id: 'ApplyToInvoice', name: 'ApplyToInvoice', value: 'yes', onClick: this.onInputChange, checked: this.state.note.ApplyToInvoice, labelText: (0, _helpers.translation)('1785') }),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(_check2.default, { id: 'ShowToCustomer', name: 'ShowToCustomer', value: 'yes', onClick: this.onInputChange, checked: this.state.note.ShowToCustomer, labelText: (0, _helpers.translation)(isBodyShop ? 17874 : 17857) }),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && (isBodyShop || (0, _auth.hasAccess)([6], this.props.auth.user.UserType)) && _react2.default.createElement(_check2.default, { id: 'ShowToPaintShop', name: 'ShowToPaintShop', value: 'yes', onClick: this.onInputChange, checked: this.state.note.ShowToPaintShop, disabled: isReferredBody && !this.state.note.ShowToCustomer, labelText: (0, _helpers.translation)(isBodyShop ? 17875 : 17858) })
	        )
	      );
	    }
	  }]);
	
	  return NotesModal;
	}(_react.Component);
	
	NotesModal.propTypes = {
	  createNote: _propTypes2.default.func.isRequired,
	  order: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { createNote: _notes.createNote, getStandardNotes: _notes.getStandardNotes, createOrDeleteStandardNote: _notes.createOrDeleteStandardNote })(NotesModal);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(1667);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _PhotoDocModal = __webpack_require__(469);
	
	var _PhotoDocModal2 = _interopRequireDefault(_PhotoDocModal);
	
	var _orders = __webpack_require__(21);
	
	var _qualitychecksettings = __webpack_require__(281);
	
	var _order = __webpack_require__(92);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Modals
	
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var QualityCheckModal = function (_Component) {
	  _inherits(QualityCheckModal, _Component);
	
	  function QualityCheckModal(props) {
	    _classCallCheck(this, QualityCheckModal);
	
	    var _this = _possibleConstructorReturn(this, (QualityCheckModal.__proto__ || Object.getPrototypeOf(QualityCheckModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      confirm: false,
	      data: {},
	      rawData: [{}],
	      PaintThickness: '',
	      SelectedOrderFiles: [[]],
	      WarrantyCode: '',
	      photodocStart: false,
	      photodocEnd: false,
	      otherModalOpen: false,
	      item: {
	        Id: 0,
	        StepId: 0,
	        To: 0
	      },
	      validStepsAhead: [],
	      validStepsBehind: []
	    };
	    _this.renderGroup = _this.renderGroup.bind(_this);
	    _this.startOrder = _this.startOrder.bind(_this);
	    _this.acceptQualityCheck = _this.acceptQualityCheck.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.closePhotoModal = _this.closePhotoModal.bind(_this);
	    _this.renderMultipleChecks = _this.renderMultipleChecks.bind(_this);
	    _this.renderQualityCheckMultiple = _this.renderQualityCheckMultiple.bind(_this);
	    _this.renderPaintThicknesses = _this.renderPaintThicknesses.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    _this.moveOrder = _this.moveOrder.bind(_this);
	    _this.renderPhotoSection = _this.renderPhotoSection.bind(_this);
	    _this.setCustomQualityCheckStatus = _this.setCustomQualityCheckStatus.bind(_this);
	    _this.renderCustomCheckMultiple = _this.renderCustomCheckMultiple.bind(_this);
	    _this.getValidSteps = _this.getValidSteps.bind(_this);
	    _this.validateMoveToStep = _this.validateMoveToStep.bind(_this);
	    _this.checkAllChecksPerformed = _this.checkAllChecksPerformed.bind(_this);
	    return _this;
	  }
	
	  _createClass(QualityCheckModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.move === true) {
	        var data = JSON.parse(JSON.stringify(this.props.data[0].Checks));
	        data.shift();
	        var dataChecks = this.props.data[0].Checks[0];
	        var defaultLTW = this.state.WarrantyCode;
	        if (dataChecks.QualityChecks[0] && dataChecks.QualityChecks[0].DefaultLTWCode !== undefined) {
	          defaultLTW = dataChecks.QualityChecks[0].DefaultLTWCode;
	        }
	        this.setState({
	          data: dataChecks,
	          rawData: data,
	          WarrantyCode: defaultLTW
	        }, function () {
	          var orderId = _this2.state.data.OrderId;
	          _this2.getValidSteps(orderId).then(function () {
	            if (_this2.state.data.QualityChecks[0]) {
	              _this2.setState({
	                item: {
	                  Id: orderId,
	                  StepId: _this2.state.data.QualityChecks[0].StepId,
	                  To: _this2.validateMoveToStep(_this2.state.data.QualityChecks[_this2.state.data.QualityChecks.length - 1].StepId)
	                }
	              });
	            } else if (_this2.state.data.ProcessComments[0]) {
	              _this2.setState({
	                item: {
	                  Id: orderId,
	                  StepId: _this2.state.data.ProcessComments[0].StepId,
	                  To: _this2.validateMoveToStep(_this2.state.data.ProcessComments[_this2.state.data.ProcessComments.length - 1].StepId)
	                }
	              });
	            }
	          });
	        });
	      } else if (this.props.data.res !== undefined) {
	        var _data = JSON.parse(JSON.stringify(this.props.data.res));
	        _data.shift();
	        var dataRes = this.props.data.res[0];
	        var _defaultLTW = this.state.WarrantyCode;
	        if (dataRes !== undefined && dataRes !== null && dataRes.QualityCheck.DefaultLTWCode !== undefined) {
	          _defaultLTW = dataRes.QualityCheck.DefaultLTWCode;
	        }
	        this.setState({
	          data: dataRes,
	          rawData: _data,
	          WarrantyCode: _defaultLTW
	        }, function () {
	          _this2.setState({
	            item: {
	              Id: _this2.state.data.QualityCheck.OrderId,
	              StepId: _this2.state.data.QualityCheck.StepId,
	              To: _this2.state.data.QualityCheck.StepId
	            }
	          }, function () {
	            _this2.getValidSteps(_this2.state.item.Id);
	          });
	        });
	      } else {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'getValidSteps',
	    value: function getValidSteps(orderId) {
	      var _this3 = this;
	
	      var ahead = this.props.getStepsAhead(orderId, false).then(function (res) {
	        _this3.setState({ validStepsAhead: res.data });
	      });
	      var behind = this.props.getStepsBehind(orderId, false).then(function (res) {
	        _this3.setState({ validStepsBehind: res.data });
	      });
	      return Promise.all([ahead, behind]);
	    }
	
	    /**
	     * Checks that the step is valid to move to. If not, the next step after current step will be returned.
	     * @param {*} step
	     */
	
	  }, {
	    key: 'validateMoveToStep',
	    value: function validateMoveToStep(step) {
	      if (typeof step === 'string') step = parseInt(step);
	      var indexAhead = this.state.validStepsAhead.findIndex(function (s) {
	        return s.Step === step;
	      });
	      var indexBehind = this.state.validStepsBehind.findIndex(function (s) {
	        return s.Step === step;
	      });
	      var adjustedStep = step;
	      if (indexAhead === -1 && indexBehind === -1) {
	        adjustedStep = this.state.validStepsAhead[0].Step;
	      }
	      return adjustedStep;
	    }
	
	    // Paint = 1
	    // Quality check = 2
	    // Photo = 3
	    // Garanti = 4
	    // Custom = 5
	
	  }, {
	    key: 'renderProcessComments',
	    value: function renderProcessComments() {
	      var ProcessComments = this.state.data.ProcessComments;
	      // Check if theres any comments
	
	      var anyComments = false;
	      ProcessComments.map(function (val) {
	        if (val.StepComments.length !== 0) anyComments = true;
	      });
	      if (!anyComments) return null;
	      // Render process step
	      var renderProcessStep = function renderProcessStep(item, key) {
	        if (item.StepComments.length === 0) return null;
	        return _react2.default.createElement(
	          'div',
	          { key: key, className: 'processCommentItem' },
	          _react2.default.createElement(
	            'strong',
	            null,
	            (0, _helpers.translation)((0, _order.getStepName)(item.StepId))
	          ),
	          item.StepComments.map(function (v, idx) {
	            var text = v.StartOrEnd === 1 ? (0, _helpers.translation)('271') + ' - ' : (0, _helpers.translation)('2062') + ' - ';
	            if (v.StartOrEnd === 3) text = '';
	            return _react2.default.createElement(
	              'div',
	              { key: idx },
	              text,
	              v.Comment
	            );
	          })
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'qualityGroup' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          (0, _helpers.translation)('1925')
	        ),
	        ProcessComments.map(renderProcessStep)
	      );
	    }
	  }, {
	    key: 'renderMultipleChecks',
	    value: function renderMultipleChecks() {
	      var paintThicknesses = [];
	      var photoChecks = [];
	      var warrantyFailed = false;
	      var checks = [];
	      var customChecks = [];
	
	      this.state.data.QualityChecks.map(function (val) {
	        val.CheckStatus.map(function (v, index) {
	          var checkStart = true;
	          var checkEnd = true;
	
	          if ((checkStart || checkEnd) && !v.IsEndPerformed || !v.IsStartPerformed) {
	            switch (v.QualityCheckTaskType) {
	              case 1:
	                if (typeof paintThicknesses[val.StepId] === 'undefined') {
	                  paintThicknesses[val.StepId] = [];
	                }
	                v.OrderId = val.OrderId;
	                if (checkStart && !v.IsStartPerformed) {
	                  var v1 = _extends({}, v);
	                  v1.checkType = 'Start';
	                  paintThicknesses[val.StepId].push(v1);
	                }
	                if (checkEnd && !v.IsEndPerformed) {
	                  var v2 = _extends({}, v);
	                  v2.checkType = 'End';
	                  paintThicknesses[val.StepId].push(v2);
	                }
	                break;
	              case 2:
	                if (typeof checks[val.StepId] === 'undefined') {
	                  checks[val.StepId] = [];
	                }
	                v.OrderId = val.OrderId;
	                if (checkStart && !v.IsStartPerformed) {
	                  var _v = _extends({}, v);
	                  _v.checkType = 'Start';
	                  checks[val.StepId].push(_v);
	                }
	                if (checkEnd && !v.IsEndPerformed) {
	                  var _v2 = _extends({}, v);
	                  _v2.checkType = 'End';
	                  checks[val.StepId].push(_v2);
	                }
	                break;
	              case 3:
	                if (typeof photoChecks[val.StepId] === 'undefined') {
	                  photoChecks[val.StepId] = [];
	                }
	                v.OrderId = val.OrderId;
	                if (checkStart && !v.IsStartPerformed) {
	                  var _v3 = _extends({}, v);
	                  _v3.checkType = 'Start';
	                  photoChecks[val.StepId].push(_v3);
	                }
	                if (checkEnd && !v.IsEndPerformed) {
	                  var _v4 = _extends({}, v);
	                  _v4.checkType = 'End';
	                  photoChecks[val.StepId].push(_v4);
	                }
	                break;
	              case 4:
	                warrantyFailed = true;
	                break;
	              case 5:
	                if (typeof customChecks[val.StepId] === 'undefined') {
	                  customChecks[val.StepId] = [];
	                }
	                v.OrderId = val.OrderId;
	                if (checkStart && !v.IsStartPerformed) {
	                  var _v5 = _extends({}, v);
	                  _v5.checkType = 'Start';
	                  _v5.index = index;
	                  _v5.StepId = val.StepId;
	                  customChecks[val.StepId].push(_v5);
	                }
	                if (checkEnd && !v.IsEndPerformed) {
	                  var _v6 = _extends({}, v);
	                  _v6.checkType = 'End';
	                  _v6.index = index;
	                  _v6.StepId = val.StepId;
	                  customChecks[val.StepId].push(_v6);
	                }
	                break;
	            }
	          }
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        paintThicknesses.map(this.renderPaintThicknesses),
	        checks.map(this.renderQualityCheckMultiple),
	        photoChecks.map(this.renderPhotoSection),
	        warrantyFailed && this.renderWarrantyCode('warranty_0'),
	        customChecks.map(this.renderCustomCheckMultiple)
	      );
	    }
	  }, {
	    key: 'renderGroup',
	    value: function renderGroup(item, key) {
	      if (item.IsStartPerformed) return null;
	      switch (item.QualityCheckTaskType) {
	        case 1:
	          return this.renderPaintThickness(item, key);
	        case 2:
	          return this.renderQualityCheck(item, key);
	        case 3:
	          return this.renderPhotoSection(item, key);
	        case 4:
	          return this.renderWarrantyCode(key);
	        case 5:
	          return this.renderCustomChecks(item, key);
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var name = e.target.name;
	      var value = e.target.value;
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var value = (0, _currency.formatCurrency)(parseFloat((0, _currency.reverseFormatCurrency)(e.target.value)));
	      this.setState(_defineProperty({}, e.target.name, value));
	    }
	  }, {
	    key: 'renderPaintThickness',
	    value: function renderPaintThickness(item, key) {
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { key: key, labelText: (0, _helpers.translation)('370') },
	        _react2.default.createElement(_text2.default, { value: this.state.PaintThickness, name: 'PaintThickness', onChange: this.onChange, onBlur: this.onBlur })
	      );
	    }
	  }, {
	    key: 'renderPaintThicknesses',
	    value: function renderPaintThicknesses(item, key) {
	      var _this4 = this;
	
	      if (item.length === 0) return null;
	      var renderPaint = function renderPaint(itm, k) {
	        var type = itm.checkType;
	        var ref = key + '_' + type + '_paint';
	        type = type === 'End' ? '2062' : '1223';
	        var onBlur = function onBlur(e) {
	          var value = (0, _currency.formatCurrency)(parseFloat((0, _currency.reverseFormatCurrency)(e.target.value)));
	          _this4.refs[ref].value = value;
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: k, className: 'multipleQualityCheck' },
	          _react2.default.createElement(
	            'div',
	            { className: 'helperText' },
	            (0, _helpers.translation)(type)
	          ),
	          _react2.default.createElement(_text2.default, { onBlur: onBlur, ref: ref, 'data-step': key })
	        );
	      };
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { key: key, labelText: (0, _helpers.translation)('370') + ' - ' + (0, _helpers.translation)((0, _order.getStepName)(key)) },
	        item.map(renderPaint)
	      );
	    }
	  }, {
	    key: 'goToDeviation',
	    value: function goToDeviation() {
	      if (this.state.item.StepId === 2) {
	        this.props.router.push('/pricecalculation/' + this.state.item.Id + '/6');
	      } else {
	        this.props.router.push('/pricecalculation/' + this.state.item.Id + '/5');
	      }
	      this.props.onClose();
	    }
	  }, {
	    key: 'renderQualityCheckMultiple',
	    value: function renderQualityCheckMultiple(item, key) {
	      var _this5 = this;
	
	      if (item.length === 0) return null;
	      var renderCheck = function renderCheck(itm, k) {
	        var type = itm.checkType;
	        type = type === 'End' ? '2062' : '1223';
	        var deviationTextId = '310';
	        if (_this5.state.item.StepId === 2) {
	          deviationTextId = '311';
	        }
	        return _react2.default.createElement(
	          'div',
	          { key: k, className: 'multipleQualityCheck' },
	          _react2.default.createElement(
	            'div',
	            { className: 'helperText' },
	            (0, _helpers.translation)(type)
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0, 1], fullWidth: true },
	            _react2.default.createElement(_button2.default, { style: 'link', onClick: _this5.acceptQualityCheck.bind(_this5, itm.OrderId, key, itm), labelText: (0, _helpers.translation)('956') }),
	            _react2.default.createElement(_button2.default, { style: 'link', onClick: _this5.goToDeviation.bind(_this5), labelText: (0, _helpers.translation)(deviationTextId) })
	          )
	        );
	      };
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { key: key, labelText: (0, _helpers.translation)('342') + ' - ' + (0, _helpers.translation)((0, _order.getStepName)(key)) },
	        item.map(renderCheck)
	      );
	    }
	  }, {
	    key: 'renderQualityCheck',
	    value: function renderQualityCheck(item, key) {
	      var deviationTextId = '310';
	      if (this.state.item.StepId === 2) {
	        deviationTextId = '311';
	      }
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { key: key, labelText: (0, _helpers.translation)('342') },
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0, 1], fullWidth: true },
	          _react2.default.createElement(_button2.default, { style: 'link', onClick: this.acceptQualityCheck.bind(this, undefined, undefined, undefined), labelText: (0, _helpers.translation)('956') }),
	          _react2.default.createElement(_button2.default, { style: 'link', onClick: this.goToDeviation.bind(this), labelText: (0, _helpers.translation)(deviationTextId) })
	        )
	      );
	    }
	  }, {
	    key: 'acceptQualityCheck',
	    value: function acceptQualityCheck(orderId, stepId, item) {
	      var _this6 = this;
	
	      var updateStart = false;
	      var updateEnd = true;
	      var orderCheckId = 0;
	      var stepFrom = 0;
	      var stepTo = 0;
	      var orderNoteStart = '';
	      var orderNoteEnd = '';
	      var statusAtStart = 0;
	      var statusAtEnd = 0;
	      var qualityCheckTaskType = 2;
	      var qualityCheckTaskId = null; // Regular QualityCheck tasks use the tasktype for identifying. Custom checks has to use the task id, since multiple tasks in same step can have same type.
	      if (typeof orderId === 'undefined') {
	        orderId = this.state.data.QualityCheck.OrderId;
	        stepId = this.state.data.QualityCheck.StepId;
	        updateStart = true;
	        updateEnd = false;
	      }
	      // If data comes from item:
	      if (typeof item !== 'undefined') {
	        orderCheckId = item.OrderCheckId;
	        if (item.checkType === 'Start') {
	          updateStart = true;
	          updateEnd = false;
	        } else {
	          updateStart = false;
	          updateEnd = true;
	        }
	        stepFrom = this.state.item.StepId;
	
	        // Apparently the 'To' step can come from item in state or from props
	        stepTo = this.state.item.To;
	        if (Array.isArray(this.props.data) && this.props.data[0] !== undefined && this.props.data[0].StepTo !== undefined) {
	          stepTo = this.props.data[0].StepTo;
	        }
	
	        orderNoteStart = item.OrderNoteStart;
	        orderNoteEnd = item.OrderNoteEnd;
	        statusAtStart = item.StatusAtStart;
	        statusAtEnd = item.StatusAtEnd;
	        qualityCheckTaskType = item.QualityCheckTaskType;
	        qualityCheckTaskId = item.QualityCheckTaskId;
	      }
	
	      // Validate target step.
	      stepTo = this.validateMoveToStep(stepTo);
	
	      // Gather data to send in request.
	      var data = {
	        OrderCheckId: orderCheckId,
	        OrderId: orderId,
	        StepId: stepId,
	        UpdateStart: updateStart,
	        UpdateEnd: updateEnd,
	        StepFrom: stepFrom,
	        StepTo: stepTo,
	        OrderNoteStart: orderNoteStart,
	        OrderNoteEnd: orderNoteEnd,
	        StatusAtStart: statusAtStart,
	        StatusAtEnd: statusAtEnd,
	        QualityCheckTaskType: qualityCheckTaskType,
	        QualityCheckTaskId: qualityCheckTaskId
	      };
	
	      this.props.updateOrderCheck(data).then(function (res) {
	        // 2 cases when doing order checks: Either user is trying to move an order, or trying to start it.
	        if (_this6.props.move) {
	          _this6.setState({
	            data: _extends({}, _this6.state.data, {
	              QualityChecks: res.data
	            })
	          }, function () {
	            // If all checks have been performed, attempt to move order.
	            var allChecksPerformed = _this6.checkAllChecksPerformed(_this6.state.data.QualityChecks);
	            if (allChecksPerformed) {
	              _this6.moveOrder(false);
	            }
	          });
	        } else {
	          _this6.setState({
	            data: _extends({}, _this6.state.data, {
	              QualityCheck: res.data[0]
	            })
	          }, function () {
	            _this6.startOrder();
	          });
	        }
	      }, function () {
	        console.log('Error updating quality check');
	      });
	    }
	  }, {
	    key: 'checkAllChecksPerformed',
	    value: function checkAllChecksPerformed(qualityCheckData) {
	      var qualityChecks = qualityCheckData;
	      var allChecksPerformed = true;
	      for (var q = 0; q < qualityChecks.length; q++) {
	        if (qualityChecks[q].EndFailed || qualityChecks[q].StartFailed) {
	          allChecksPerformed = false;
	          break;
	        }
	        for (var c = 0; c < qualityChecks[q].CheckStatus; c++) {
	          var status = qualityChecks[q].CheckStatus[c];
	          if (!status.IsStartPerformed || !status.IsEndPerformed) {
	            allChecksPerformed = false;
	            break;
	          }
	        }
	      }
	      return allChecksPerformed;
	    }
	  }, {
	    key: 'renderPhotoSection',
	    value: function renderPhotoSection(item, key) {
	      var _this7 = this;
	
	      if (item.length === 0) return null;
	      var renderPhotoD = function renderPhotoD(itm, k) {
	        var openPhotoDoc = function openPhotoDoc() {
	          _this7.setState({
	            photodocStart: itm.checkType === 'Start',
	            photodocEnd: itm.checkType === 'End',
	            stepId: key,
	            otherModalOpen: true
	          });
	        };
	        var type = itm.checkType;
	        type = type === 'End' ? '2062' : '1223';
	        return _react2.default.createElement(_button2.default, { style: 'link', key: k, onClick: openPhotoDoc.bind(_this7), labelText: (0, _helpers.translation)('2065') + ' - ' + (0, _helpers.translation)(type) });
	      };
	      if (item.length > 0 && item.map !== undefined) {
	        // Multiple photo checks
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { key: key, labelText: (0, _helpers.translation)('2065') + ' - ' + (0, _helpers.translation)((0, _order.getStepName)(key)) },
	          item.map(renderPhotoD)
	        );
	      }
	      // Single photo check
	      var openPhoto = function openPhoto() {
	        _this7.setState({
	          photodocStart: true,
	          photodocEnd: false,
	          otherModalOpen: true
	        });
	      };
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { key: key, labelText: (0, _helpers.translation)('2065') },
	        _react2.default.createElement(_button2.default, { onClick: openPhoto.bind(this), labelText: (0, _helpers.translation)('2065'), style: 'link' })
	      );
	    }
	  }, {
	    key: 'renderWarrantyCode',
	    value: function renderWarrantyCode(key) {
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { key: key, labelText: (0, _helpers.translation)('13396') },
	        _react2.default.createElement(_text2.default, { value: this.state.WarrantyCode, name: 'WarrantyCode', onChange: this.onChange })
	      );
	    }
	  }, {
	    key: 'renderCustomCheckMultiple',
	    value: function renderCustomCheckMultiple(item, key) {
	      var _this8 = this;
	
	      if (item.length === 0) return null;
	      var renderCheck = function renderCheck(itm, k) {
	        var type = itm.checkType;
	        var name = itm.index + '_' + type;
	        type = type === 'End' ? '2062' : '1223';
	        var onChange = function onChange(e) {
	          var nameString = e.target.name.split('_');
	          var index = parseInt(nameString[0]);
	          var noteType = nameString[1] === 'Start' ? 'OrderNoteStart' : 'OrderNoteEnd';
	          var checkStatuses = _this8.state.data.QualityChecks[0].CheckStatus;
	          checkStatuses[index][noteType] = e.target.value;
	          var qualityChecks = _this8.state.data.QualityChecks;
	          qualityChecks[0].CheckStatus = checkStatuses;
	          _this8.setState({
	            data: _extends({}, _this8.state.data, {
	              QualityChecks: [].concat(_toConsumableArray(qualityChecks))
	            })
	          });
	        };
	        var label = itm.QualityCheckTaskName + ' - ' + (0, _helpers.translation)((0, _order.getStepName)(itm.StepId));
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { key: k, labelText: label, className: 'multipleQualityCheck-custom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'helperText' },
	            (0, _helpers.translation)(type)
	          ),
	          _react2.default.createElement(_text2.default, { name: name, onChange: onChange, value: itm.Note }),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0, 1], fullWidth: true },
	            _react2.default.createElement(_button2.default, { style: 'link', onClick: _this8.setCustomQualityCheckStatus.bind(_this8, itm, 2, itm.checkType, key), labelText: (0, _helpers.translation)('1141') }),
	            _react2.default.createElement(_button2.default, { style: 'link', onClick: _this8.setCustomQualityCheckStatus.bind(_this8, itm, 1, itm.checkType, key), labelText: (0, _helpers.translation)('17855') })
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        item.map(renderCheck)
	      );
	    }
	  }, {
	    key: 'renderCustomChecks',
	    value: function renderCustomChecks(item, key) {
	      var _this9 = this;
	
	      var STATUS_APPROVED = 2;
	      var STATUS_NOT_APPROVED = 1;
	      var type = void 0;
	      if (!item.IsEndPerformed) type = 'End';
	      if (!item.IsStartPerformed) type = 'Start';
	
	      var onChange = function onChange(e) {
	        item[e.target.name] = e.target.value;
	        _this9.setState(_extends({}, _this9.state.data.QualityCheck.CheckStatus));
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: item.QualityCheckTaskName, className: 'multipleQualityCheck-custom' },
	          type === 'Start' && _react2.default.createElement(_text2.default, { value: item.OrderNoteStart || '', name: 'OrderNoteStart', onChange: onChange }),
	          type === 'End' && _react2.default.createElement(_text2.default, { value: item.OrderNoteEnd || '', name: 'OrderNoteEnd', onChange: onChange }),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0, 1], fullWidth: true },
	            _react2.default.createElement(_button2.default, { style: 'link', onClick: this.setCustomQualityCheckStatus.bind(this, item, STATUS_APPROVED, type, item), labelText: (0, _helpers.translation)('1141') }),
	            _react2.default.createElement(_button2.default, { style: 'link', onClick: this.setCustomQualityCheckStatus.bind(this, item, STATUS_NOT_APPROVED, type, item), labelText: (0, _helpers.translation)('17855') })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'setCustomQualityCheckStatus',
	    value: function setCustomQualityCheckStatus(item, status, type, key) {
	      if (type === 'End') {
	        item.StatusAtEnd = status;
	        item.UpdateEnd = true;
	      } else {
	        item.StatusAtStart = status;
	        item.UpdateStart = true;
	      }
	      item.checkType = type;
	      this.acceptQualityCheck(item.OrderId, key, item);
	    }
	  }, {
	    key: 'startOrder',
	    value: function startOrder(CheckOnly) {
	      var _this10 = this;
	
	      var PaintThickness = this.state.PaintThickness === '' ? 0 : parseFloat((0, _currency.reverseFormatCurrency)(this.state.PaintThickness));
	      var data = {
	        Orders: [{
	          OrderId: this.state.data.QualityCheck.OrderId,
	          WarrantyCode: this.state.WarrantyCode,
	          PaintThickness: PaintThickness
	        }],
	        UserIds: this.props.data.UserIds,
	        WorkOnAll: this.props.data.WorkOnAll,
	        CheckOnly: true
	      };
	
	      for (var i = 0; i < this.state.rawData.length; i++) {
	        if (this.state.item.Id === this.state.rawData[i].OrderId) continue;
	
	        var order = {
	          OrderId: this.state.rawData[i].OrderId,
	          WarrantyCode: ''
	        };
	        data.Orders.push(order);
	      }
	
	      this.props.startOrder(data).then(function (res) {
	        if (res.data.filter(function (x) {
	          return x.QualityCheck.StartFailed === true;
	        }).length === 0) {
	          // let message = data.Orders.length > 1 ? translation('13519') : translation('13518')
	          // window.toastr.success(message, translation('13424'))
	          _this10.props.onClose();
	          return null;
	        }
	        _this10.setState({
	          PaintThickness: '',
	          WarrantyCode: '',
	          data: res.data[0]
	        }, function () {
	          _this10.setState({
	            item: {
	              Id: _this10.state.data.QualityCheck.OrderId,
	              StepId: _this10.state.data.QualityCheck.StepId,
	              To: _this10.validateMoveToStep(_this10.state.data.QualityCheck.StepId)
	            }
	          });
	        });
	      }, function () {
	        var message = data.Orders.length > 1 ? (0, _helpers.translation)('12337') : (0, _helpers.translation)('1923');
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'moveOrder',
	    value: function moveOrder(CheckOnly) {
	      var _this11 = this;
	
	      var paintThicknesses = [];
	      Object.keys(this.refs).map(function (val) {
	        if (_this11.refs[val].value !== '') {
	          var UpdateEnd = val.indexOf('End') !== -1;
	          var UpdateStart = val.indexOf('Start') !== -1;
	          paintThicknesses.push({
	            StepId: parseInt(_this11.refs[val].props['data-step']),
	            PaintThickness: parseFloat((0, _currency.reverseFormatCurrency)(_this11.refs[val].value)),
	            UpdateEnd: UpdateEnd,
	            UpdateStart: UpdateStart
	          });
	        }
	      });
	
	      var orders = [{
	        OrderId: this.state.item.Id,
	        PaintThicknesses: paintThicknesses,
	        WarrantyCode: this.state.WarrantyCode
	      }];
	
	      for (var i = 0; i < this.props.data[0].OrderIds.length; i++) {
	        if (this.state.item.Id === this.props.data[0].OrderIds[i]) continue;
	
	        var order = {
	          OrderId: this.props.data[0].OrderIds[i],
	          WarrantyCode: ''
	        };
	        orders.push(order);
	      }
	
	      // Apparently the 'To' step can come from item in state or from props
	      var stepTo = this.state.item.To;
	      if (Array.isArray(this.props.data) && this.props.data[0] !== undefined && this.props.data[0].StepTo !== undefined) {
	        stepTo = this.props.data[0].StepTo;
	      }
	
	      var moveData = {
	        Orders: orders,
	        UserId: 0,
	        MoveAll: false,
	        StepFrom: this.state.item.StepId,
	        StepTo: this.validateMoveToStep(stepTo),
	        Comment: '',
	        FilterSettings: {},
	        CheckOnly: CheckOnly,
	        DontReturnOrders: stepTo === 8
	      };
	
	      this.props.moveOrder(moveData).then(function (res) {
	        if (!res.data.MoveFailed) {
	          if (CheckOnly) {
	            _this11.moveOrder(false);
	          } else {
	            // let message = orders.length > 1 ? translation('12338') : translation('1909')
	            // window.toastr.success(message, translation('13424'))
	            if (_this11.props.onMoveSuccess !== undefined) {
	              _this11.props.onMoveSuccess(res.data, orders);
	            }
	            _this11.props.onClose();
	            return null;
	          }
	        }
	
	        var element = document.getElementsByClassName('modal--content clearfix')[0];
	        var inputs = element.getElementsByTagName('input');
	        for (var _i = 0; _i < inputs.length; _i++) {
	          inputs[_i].value = '';
	        }
	        if (_this11.state.data.QualityChecks[0] && res.data.Checks[0]) {
	          var defaultLTW = '';
	          var dataChecks = res.data.Checks[0];
	          if (dataChecks !== undefined && dataChecks.QualityChecks[0] && dataChecks.QualityChecks[0].DefaultLTWCode !== undefined) {
	            defaultLTW = dataChecks.QualityChecks[0].DefaultLTWCode;
	          }
	          _this11.setState({
	            PaintThickness: '',
	            WarrantyCode: defaultLTW,
	            data: res.data.Checks[0],
	            item: {
	              Id: res.data.Checks[0].OrderId, // need to be from res, to handle mass order move
	              StepId: _this11.state.data.QualityChecks[0].StepId,
	              To: _this11.validateMoveToStep(_this11.state.data.QualityChecks[_this11.state.data.QualityChecks.length - 1].StepId)
	            }
	          });
	        } else if (_this11.state.data.ProcessComments[0]) {
	          _this11.setState({
	            PaintThickness: '',
	            WarrantyCode: '',
	            data: res.data.Checks[0],
	            item: {
	              Id: _this11.state.data.OrderId,
	              StepId: _this11.state.data.ProcessComments[0].StepId,
	              To: _this11.validateMoveToStep(_this11.state.data.ProcessComments[_this11.state.data.ProcessComments.length - 1].StepId)
	            }
	          });
	        }
	      }, function (res) {
	        // Toastr
	        var message = void 0;
	        if (res.response.data.IsStopped === true) message = (0, _helpers.translation)('12347');else if (res.response.data.IsReffered === true) message = (0, _helpers.translation)('2704');else message = orders.length > 1 ? (0, _helpers.translation)('12339') : (0, _helpers.translation)('1731');
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'stepHasComments',
	    value: function stepHasComments(data) {
	      var ProcessComments = data.ProcessComments;
	      var anyComments = false;
	      if (ProcessComments === undefined) {
	        data.Checks.map(function (check) {
	          check.ProcessComments.map(function (val) {
	            if (val.StepComments.length !== 0) {
	              anyComments = true;
	            }
	          });
	        });
	      } else {
	        ProcessComments.map(function (val) {
	          if (val.StepComments.length !== 0) anyComments = true;
	        });
	      }
	
	      return anyComments;
	    }
	  }, {
	    key: 'sumQCchecks',
	    value: function sumQCchecks(checks) {
	      // :()
	      var checkStatuses = [];
	      checks.map(function (x) {
	        var index = checkStatuses.findIndex(function (y) {
	          return y.QualityCheckTaskType === 5 && x.QualityCheckTaskType === 5 && y.QualityCheckTaskId === x.QualityCheckTaskId || y.QualityCheckTaskType !== 5 && y.QualityCheckTaskType === x.QualityCheckTaskType;
	        });
	        if (index >= 0) {
	          checkStatuses[index].IsEndPerformed = checkStatuses[index].IsEndPerformed && x.IsEndPerformed;
	          checkStatuses[index].IsStartPerformed = checkStatuses[index].IsStartPerformed && x.IsStartPerformed;
	          checkStatuses[index].HasMultipule = true;
	        } else {
	          checkStatuses.push(x);
	        }
	      });
	
	      return checkStatuses;
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      if (this.state.data === undefined) return null;
	      if (Object.keys(this.state.data).length === 0) return null;
	      // Button
	      var groupName = '1928';
	      var button = _react2.default.createElement(_button2.default, { onClick: this.startOrder.bind(this, false), labelText: (0, _helpers.translation)('1928'), style: 'link' });
	      if (this.props.move) {
	        button = _react2.default.createElement(_button2.default, { onClick: this.moveOrder.bind(this, false), labelText: (0, _helpers.translation)('709'), style: 'link' });
	        groupName = '709';
	      }
	      // Checks
	      if (this.props.move) {
	        if (!this.state.data.MoveFailed && !this.stepHasComments(this.state.data)) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('1927')
	          );
	        }
	        if (!this.state.data.MoveFailed) {
	          button = _react2.default.createElement(_button2.default, { onClick: this.onClose.bind(this, false), labelText: (0, _helpers.translation)('956'), style: 'link' });
	        }
	      } else {
	        if (!this.state.data.QualityCheck.StartFailed && !this.stepHasComments(this.state.data)) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('1926')
	          );
	        }
	        if (!this.state.data.QualityCheck.StartFailed) {
	          button = _react2.default.createElement(_button2.default, { onClick: this.onClose.bind(this, false), labelText: (0, _helpers.translation)('1928'), style: 'link' });
	        }
	      }
	
	      // Return
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderProcessComments(),
	        !this.props.move && this.sumQCchecks(this.state.data.QualityCheck.CheckStatus).map(this.renderGroup),
	        this.props.move && this.renderMultipleChecks(),
	        button !== '' && _react2.default.createElement(_divider2.default, { size: 3, noLine: true }),
	        button !== '' && _react2.default.createElement(
	          _labelWrapper2.default,
	          { className: 'qualityGroup', labelText: (0, _helpers.translation)(groupName) },
	          button
	        )
	      );
	    }
	  }, {
	    key: 'closePhotoModal',
	    value: function closePhotoModal() {
	      this.setState({
	        photodocStart: false,
	        photodocEnd: false,
	        otherModalOpen: false
	      });
	    }
	  }, {
	    key: 'onClosePortal',
	    value: function onClosePortal() {}
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      var data = this.state.data;
	
	      if (this.props.move) {
	        var moveData = {
	          MoveFailed: data.MoveFailed,
	          StepTo: this.state.item.To,
	          StepFrom: this.state.item.StepId
	        };
	        var orders = [{
	          OrderId: data.OrderId
	        }];
	        // let message = translation('1909')
	        if (!this.state.data.MoveFailed && !this.stepHasComments(this.state.data)) {
	          // window.toastr.success(message, translation('13424'))
	        }
	        this.props.onClose();
	        if (!this.props.onlyProcessComments) {
	          this.props.onMoveSuccess(moveData, orders);
	        }
	      } else {
	        if (data.QualityCheck.StartFailed || data.QualityCheck.EndFailed) {
	          this.setState({
	            confirm: true
	          });
	        } else {
	          this.props.onClose();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      // Confirm
	      var onPortalClose = function onPortalClose() {
	        _this12.setState({
	          confirm: false
	        });
	      };
	      var onConfirm = function onConfirm() {
	        _this12.setState({
	          confirm: false
	        }, function () {
	          var data = {
	            OrderId: _this12.state.item.Id,
	            StepId: _this12.state.item.StepId
	          };
	          _this12.props.skipOrderCheck(data);
	          _this12.props.onClose();
	        });
	      };
	      var confirmText = function confirmText(props) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          props.t('2199')
	        );
	      };
	      var setImages = function setImages() {
	        if (_this12.props.move) {
	          _this12.moveOrder(true);
	        } else {
	          _this12.startOrder(true);
	        }
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Portal2.default,
	          { dontSendT: true, onPortalClose: this.onClosePortal, className: 'qualityModalOuterPortal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'qualityModalOuter' },
	            _react2.default.createElement(
	              'div',
	              { className: 'quality__modal' },
	              _react2.default.createElement(
	                _Modal2.default,
	                _extends({}, this.props, {
	                  hideContainer: this.state.otherModalOpen,
	                  header: (0, _helpers.translation)('1929') + (this.state.data !== undefined ? this.state.data.Title === undefined ? '' : ' ' + this.state.data.Title : ''),
	                  overflowHidden: this.state.overflowHidden,
	                  onClose: this.onClose,
	                  icon: _icons.ModalIcons.Quality_Check,
	                  t: _helpers.translation }),
	                this.renderView()
	              )
	            ),
	            this.state.photodocStart && _react2.default.createElement(_PhotoDocModal2.default, {
	              stepId: this.state.stepId,
	              show: this.state.photodocStart,
	              item: this.state.item,
	              onClose: this.closePhotoModal,
	              store: _store2.default,
	              setImages: setImages.bind(this),
	              QualityCheckPhotoStart: true,
	              t: _helpers.translation,
	              enumfunc: _helpers.enumtranslate }),
	            this.state.photodocEnd && _react2.default.createElement(_PhotoDocModal2.default, {
	              stepId: this.state.stepId,
	              show: this.state.photodocEnd,
	              item: this.state.item,
	              onClose: this.closePhotoModal,
	              store: _store2.default,
	              setImages: setImages.bind(this),
	              QualityCheckPhotoEnd: true,
	              t: _helpers.translation,
	              enumfunc: _helpers.enumtranslate })
	          )
	        ),
	        this.state.confirm !== false && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirmModal', onPortalClose: onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onPortalClose, higher: true, renderText: confirmText })
	        )
	      );
	    }
	  }]);
	
	  return QualityCheckModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateOrderCheck: _qualitychecksettings.updateOrderCheck,
	  startOrder: _orders.startOrder,
	  moveOrder: _orders.moveOrder,
	  skipOrderCheck: _orders.skipOrderCheck,
	  getStepsAhead: _orders.getStepsAhead,
	  getStepsBehind: _orders.getStepsBehind
	})(QualityCheckModal);

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.Search = Search;
	exports.formatArrayToString = formatArrayToString;
	/**
	 * @module utils/array
	 */
	
	function Search(array, name, value) {
	  for (var i = 0; i < array.length; i++) {
	    if (array[i][name] === value) {
	      return array[i];
	    }
	  }
	  return false;
	}
	/**
	 * if the Note consists of string array cobines the array in one string and sets the new line characters
	 * in order to format text in UI
	 * @param {*} array
	 */
	function formatArrayToString(array) {
	  if ((typeof array === 'undefined' ? 'undefined' : _typeof(array)) === 'object') {
	    var str = '';
	    for (var i = 0; i < array.length; i++) {
	      str += array[i] + '\n';
	    }
	    return str;
	  } else {
	    return array;
	  }
	}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setAuthorizationToken = setAuthorizationToken;
	exports.setDeviceToken = setDeviceToken;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Sets or deletes Axios default Authorization header
	 * @param  {token | boolean} token User token or false
	 * @return {undefined}
	 */
	function setAuthorizationToken(token) {
	  if (token) {
	    _axios2.default.defaults.headers.common['Authorization'] = 'Basic ' + token;
	    // axios.defaults.headers.common['Authorization'] = token
	  } else {
	    delete _axios2.default.defaults.headers.common['Authorization'];
	  }
	}
	
	/**
	 * @description Sets or deletes Axios default x-device-token header
	 * @param  {token | boolean} token Device token or false
	 * @return {undefined}
	 */
	/**
	 * @module utils/setAuthorizationToken
	 */
	function setDeviceToken(token) {
	  if (token) {
	    _axios2.default.defaults.headers.common['x-device-token'] = token;
	  } else {
	    delete _axios2.default.defaults.headers.common['x-device-token'];
	  }
	}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(109);
	var TAG = __webpack_require__(56)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(109);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(340),
	    getRawTag = __webpack_require__(1733),
	    objectToString = __webpack_require__(1758);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(125);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;
	exports.clamp = clamp;
	exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.safePreventDefault = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function clamp(number, lowerBound, upperBound) {
	  return Math.max(lowerBound, Math.min(number, upperBound));
	}
	
	var safePreventDefault = function safePreventDefault(event) {
	  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];
	
	  if (!passiveEvents.includes(event._reactName)) {
	    event.preventDefault();
	  }
	};
	
	exports.safePreventDefault = safePreventDefault;
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react["default"].Children.count(spec.children);
	
	  var listNode = spec.listRef;
	  var listWidth = Math.ceil(getWidth(listNode));
	  var trackNode = spec.trackRef && spec.trackRef.node;
	  var trackWidth = Math.ceil(getWidth(trackNode));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }));
	  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  var lazyLoadedList = spec.lazyLoadedList;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList = lazyLoadedList.concat(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList,
	      targetSlide: animationSlide
	    };
	    nextState = {
	      animating: false,
	      targetSlide: animationSlide
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    if (!infinite && animationSlide + slidesToShow >= slideCount) {
	      finalSlide = slideCount - slidesToShow;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    if (lazyLoad) {
	      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	        currentSlide: animationSlide
	      })));
	    }
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        swipeLeft: null,
	        targetSlide: targetSlide
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      previousTargetSlide = spec.targetSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide - slidesToScroll;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide + slidesToScroll;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && safePreventDefault(e);
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return safePreventDefault(e);
	  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread(_objectSpread({}, state), {}, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    safePreventDefault(e);
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe,
	      targetSlide = spec.targetSlide,
	      currentSlide = spec.currentSlide,
	      infinite = spec.infinite;
	
	  if (!dragging) {
	    if (swipe) safePreventDefault(e);
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    safePreventDefault(e);
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	    var activeSlide = infinite ? currentSlide : targetSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = activeSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = activeSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = activeSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	    var slickList = spec.listRef;
	    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread(_objectSpread({}, style), {}, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = trackRef && trackRef.node;
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setCarActiveState = setCarActiveState;
	
	var _constants = __webpack_require__(5);
	
	/**
	 * @description Set the active state of the car component
	 * @return {Object} Redux action
	 */
	function setCarActiveState(isActive) {
	  return {
	    type: _constants.SET_CAR_ACTIVE_STATE,
	    isActive: isActive
	  };
	} /**
	   * @module actions/car
	   */

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetCarRentalOverview = GetCarRentalOverview;
	exports.MoveOrderCarRental = MoveOrderCarRental;
	exports.GetAvailableCars = GetAvailableCars;
	exports.ValidateAssignments = ValidateAssignments;
	exports.GetAssignments = GetAssignments;
	exports.UpdateAssignments = UpdateAssignments;
	exports.GetCarTypes = GetCarTypes;
	exports.GetCarClasses = GetCarClasses;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting overview for rentalcars
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/carrental
	 */
	function GetCarRentalOverview(data) {
	  var url = _constants.API_URL + '/CarRental/Overview';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Move order to other car rental
	 * @return {Promise} Axios promise
	 */
	function MoveOrderCarRental(data) {
	  var url = _constants.API_URL + '/CarRental/MoveOrder';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * Gets information about car availability
	 * @param {Number} orderId
	 */
	function GetAvailableCars(orderId, start, end) {
	  var url = _constants.API_URL + '/CarRental/GetAvailableCars';
	  var data = { OrderId: orderId, Start: start, End: end };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * Validates if a list of assigments are valid for an order
	 * @param {Number} orderId
	 * @param {Array} assignments - Array of: { CarRentalId, Start, End })
	 */
	function ValidateAssignments(orderId, assignments) {
	  var url = _constants.API_URL + '/CarRental/ValidateAssignments';
	  var data = { OrderId: orderId, Assignments: assignments };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * Gets information about carrental assignments/periods
	 * @param {Number} orderId
	 * @param {Boolean} includeInactive
	 */
	function GetAssignments(orderId, includeInactive) {
	  var clearInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var url = _constants.API_URL + '/CarRental/GetAssignments';
	  var data = { OrderId: orderId, GetInactive: includeInactive, ClearInactive: clearInactive };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * Updates carrental assignments/periods
	 * @param {Number} orderId
	 * @param {Boolean} getInactive Set to true, to include inactive assignments/periods in response.
	 * @param {Boolean} activate Set to true, to activate the passed in assignments.
	 * @param {Array} Array of assignment objects. { PeriodId, CarRentalId, CarNumber, Identity, Start, End }
	 */
	function UpdateAssignments(orderId, getInactive, activate, assignments) {
	  var url = _constants.API_URL + '/CarRental/UpdateAssignments';
	  var data = { OrderId: orderId, GetInactive: getInactive, Activate: activate, Assignments: assignments };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	* @description GetCarTypes from api
	* @return {Promise} Axios promise
	*/
	function GetCarTypes() {
	  var url = _constants.API_URL + '/CarRental/GetCarTypes';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	* @description GetCarClasses from api
	* @return {Promise} Axios promise
	*/
	function GetCarClasses() {
	  var url = _constants.API_URL + '/CarRental/GetCarClasses';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.searchDracarCustomer = searchDracarCustomer;
	exports.searchDracarCompany = searchDracarCompany;
	exports.searchDracarVehicle = searchDracarVehicle;
	exports.checkForDracarVehicle = checkForDracarVehicle;
	exports.validateOrder = validateOrder;
	exports.validateDracarCustomer = validateDracarCustomer;
	exports.validateDracarVehicle = validateDracarVehicle;
	exports.createDracarRepairOrder = createDracarRepairOrder;
	exports.getDracarRepairOrder = getDracarRepairOrder;
	exports.checkVehicleForCustomers = checkVehicleForCustomers;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @module actions/customers
	 */
	function searchDracarCustomer(data) {
	  var url = _constants.API_URL + '/Dracar/Search/Customer';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function searchDracarCompany(data) {
	  var url = _constants.API_URL + '/Dracar/Search/Company';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function searchDracarVehicle(data) {
	  var url = _constants.API_URL + '/Dracar/Search/Vehicle';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function checkForDracarVehicle(data) {
	  var url = _constants.API_URL + '/Dracar/Search/CheckVehicle';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function validateOrder(data) {
	  var url = _constants.API_URL + '/Dracar/Validate/Order';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function validateDracarCustomer(data) {
	  var url = _constants.API_URL + '/Dracar/Validate/Customer';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function validateDracarVehicle(data) {
	  var url = _constants.API_URL + '/Dracar/Validate/Vehicle';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function createDracarRepairOrder(data) {
	  var url = _constants.API_URL + '/Dracar/Create/RepairOrder';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function getDracarRepairOrder(data) {
	  var url = _constants.API_URL + '/Dracar/RepairOrder/Get';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function checkVehicleForCustomers(data) {
	  var url = _constants.API_URL + '/Dracar/VehicleCustomers';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getProductionStatus = getProductionStatus;
	exports.getPickupStatus = getPickupStatus;
	exports.getDeliveryStatus = getDeliveryStatus;
	exports.setDeliveryStatus = setDeliveryStatus;
	exports.setPickupStatus = setPickupStatus;
	exports.setProductionStatus = setProductionStatus;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get the productions status of all orders
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/overview
	 */
	function getProductionStatus() {
	  var url = _constants.API_URL + '/overview/0';
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch(setProductionStatus(res.data));
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Get the pickup status of all orders
	 * @return {Promise} Axios promise
	 */
	function getPickupStatus() {
	  var url = _constants.API_URL + '/overview/1';
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch(setPickupStatus(res.data));
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Get the delivery status of all orders
	 * @return {Promise} Axios promise
	 */
	function getDeliveryStatus() {
	  var url = _constants.API_URL + '/overview/2';
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch(setDeliveryStatus(res.data));
	      return res;
	    });
	  };
	}
	
	function setDeliveryStatus(data) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_DELIVERY_STATUS,
	      data: data
	    });
	  };
	}
	
	function setPickupStatus(data) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_PICKUP_STATUS,
	      data: data
	    });
	  };
	}
	
	function setProductionStatus(data) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_PRODUCTION_STATUS,
	      data: data
	    });
	  };
	}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1360);
	
	var _actions = __webpack_require__(129);
	
	var _Footer = __webpack_require__(1045);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var Auth = function (_Component) {
	  _inherits(Auth, _Component);
	
	  function Auth(props) {
	    _classCallCheck(this, Auth);
	
	    var _this = _possibleConstructorReturn(this, (Auth.__proto__ || Object.getPrototypeOf(Auth)).call(this, props));
	
	    _this.state = {
	      isLanguageOpen: false
	    };
	    _this.toggleLanguageMenu = _this.toggleLanguageMenu.bind(_this);
	    _this.changeLanguage = _this.changeLanguage.bind(_this);
	    _this.changeLanguageInfo = _this.changeLanguageInfo.bind(_this);
	    _this.renderLangNames = _this.renderLangNames.bind(_this);
	    return _this;
	  }
	
	  _createClass(Auth, [{
	    key: 'changeLanguage',
	    value: function changeLanguage(e) {
	      e.preventDefault();
	      var lang = window.localStorage.getItem('user_language');
	      if (lang === undefined || lang === null) {
	        lang = 'Danish';
	      }
	      this.props.setLanguage(lang);
	    }
	  }, {
	    key: 'toggleLanguageMenu',
	    value: function toggleLanguageMenu(open) {
	      open = typeof open.target !== 'undefined' ? !this.state.isLanguageOpen : open;
	      this.setState({
	        isLanguageOpen: open
	      });
	    }
	  }, {
	    key: 'changeLanguageInfo',
	    value: function changeLanguageInfo(langInfo) {
	      this.toggleLanguageMenu({ target: false });
	      var lang = langInfo.LanguageName;
	      this.props.setLanguage(lang);
	    }
	  }, {
	    key: 'renderLangNames',
	    value: function renderLangNames(val, key) {
	      return _react2.default.createElement(
	        'div',
	        { key: key, className: 'langname' },
	        _react2.default.createElement('img', { src: val.Image }),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'a',
	            { onClick: this.changeLanguageInfo.bind(this, val), href: '#' },
	            ' ',
	            val.SelfLangName
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var activeLang = window.localStorage.getItem('user_language'); // (window.localStorage.getItem('user_language') === 'Danish') ? 'Danish' : 'English'
	      var langInfo = this.props.getLanguageInfo(activeLang);
	      var languageTriggerClass = 'fa fa-chevron-down';
	      if (activeLang === undefined || activeLang === null) {
	        activeLang = 'Danish';
	      }
	      var languageMenu = '';
	      if (this.state.isLanguageOpen) {
	        languageTriggerClass = 'fa fa-chevron-up';
	        var langInfos = this.props.getLanguageInfos();
	        languageMenu = _react2.default.createElement(
	          'div',
	          { className: 'dropdown__menu' },
	          langInfos.map(this.renderLangNames)
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'auth__screen' },
	        _react2.default.createElement(
	          'div',
	          { className: 'auth-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'scroll-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'top_header' },
	              _react2.default.createElement('img', { src: '/images/logo.png', className: 'logo' }),
	              _react2.default.createElement(_divider2.default, { vertical: true }),
	              _react2.default.createElement(
	                'div',
	                { className: 'info' },
	                _react2.default.createElement(
	                  'div',
	                  { onClick: this.toggleLanguageMenu, className: 'language_trigger' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'language' },
	                    langInfo.LanguageCode
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('i', { className: languageTriggerClass })
	                  )
	                ),
	                languageMenu
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'auth__screen--inner' },
	              this.props.children
	            )
	          ),
	          _react2.default.createElement(_Footer2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Auth;
	}(_react.Component);
	
	Auth.propTypes = {
	  setLanguage: _propTypes2.default.func.isRequired,
	  getLanguageInfos: _propTypes2.default.func.isRequired,
	  getLanguageInfo: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  setLanguage: _actions.setLanguage,
	  getLanguageInfos: _actions.getLanguageInfos,
	  getLanguageInfo: _actions.getLanguageInfo
	})(Auth);

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	__webpack_require__(1413);
	
	var _DateChangePopup = __webpack_require__(432);
	
	var _DateChangePopup2 = _interopRequireDefault(_DateChangePopup);
	
	var _DateActions = __webpack_require__(431);
	
	var _DateActions2 = _interopRequireDefault(_DateActions);
	
	var _assign = __webpack_require__(148);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _iconAccordion = __webpack_require__(201);
	
	var _iconAccordion2 = _interopRequireDefault(_iconAccordion);
	
	var _icons = __webpack_require__(6);
	
	var _constants = __webpack_require__(5);
	
	var _avatar = __webpack_require__(234);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// import components
	
	
	// Actions
	
	
	// import utils
	
	
	var AssignItem = function (_Component) {
	  _inherits(AssignItem, _Component);
	
	  function AssignItem(props) {
	    _classCallCheck(this, AssignItem);
	
	    var _this = _possibleConstructorReturn(this, (AssignItem.__proto__ || Object.getPrototypeOf(AssignItem)).call(this, props));
	
	    _this.state = {
	      item: {}
	    };
	    _this.renderStep = _this.renderStep.bind(_this);
	    _this.onStepClick = _this.onStepClick.bind(_this);
	    _this.navigateToOrder = _this.navigateToOrder.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssignItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        item: this.props.item
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(this.props.item, nextProps.item)) {
	        this.setState({
	          item: nextProps.item
	        });
	      }
	    }
	
	    /*
	    shouldComponentUpdate (nextProps) {
	      return true
	      /*
	      console.log(!isEqual(this.state.item, nextProps.item), nextProps.item)
	      if (!isEqual(this.state.item, nextProps.item) || Object.keys(this.state.item).length === 0) {
	        return true
	      }
	      return false
	      /
	    }
	    */
	
	  }, {
	    key: 'renderTime',
	    value: function renderTime(time) {
	      if (this.props.auth.user.CustomerId === '-1') {
	        return (0, _time.renderTime)(time);
	      } else {
	        return (0, _time.renderFullDate)(time);
	      }
	    }
	  }, {
	    key: 'getStepIcon',
	    value: function getStepIcon(id, color) {
	      // the second img red is used on mousse over
	      switch (id) {
	        case _constants.OrderSteps.NEW_ORDER:
	          // 1
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_New_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_New_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_New_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_New_Red, size: 't' })
	          );
	        case _constants.OrderSteps.PREPARING:
	          // 2
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Preparing_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Preparing_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Preparing_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_Preparing_Red, size: 't' })
	          );
	        case _constants.OrderSteps.FILLING:
	          // 3
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Filling_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Filling_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Filling_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_Filling_Red, size: 't' })
	          );
	        case _constants.OrderSteps.SANDING:
	          // 4
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Sanding_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Sanding_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Sanding_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_Sanding_Red, size: 't' })
	          );
	        case _constants.OrderSteps.PAINTING:
	          // 5
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Painting_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Painting_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Painting_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_Painting_Red, size: 't' })
	          );
	        case _constants.OrderSteps.FINISHING:
	          // 6
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Finishing_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Finishing_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_Finishing_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_Finishing_Red, size: 't' })
	          );
	        case _constants.OrderSteps.DELIVERY:
	          // 7
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_New_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_New_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_New_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_New_Red, size: 't' })
	          );
	        case _constants.OrderSteps.DISASSEMBLY:
	          // BodyShopDisassembly 101
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopDisassemply_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopDisassemply_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopDisassemply_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopDisassemply_Red, size: 't' })
	          );
	        case _constants.OrderSteps.REPAIR:
	          // BodyShopRepair 102
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopRepair_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopRepair_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopRepair_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopRepair_Red, size: 't' })
	          );
	        case _constants.OrderSteps.ASSEMBLY:
	          // BodyShopAssembly 103
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopAssembly_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopAssembly_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopAssembly_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopAssembly_Red, size: 't' })
	          );
	        case _constants.OrderSteps.BODY_FINISHING:
	          // BodyShopFinishing 104
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopFinishing_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopFinishing_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopFinishing_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopFinishing_Red, size: 't' })
	          );
	        case _constants.OrderSteps.BODY_PAINTING:
	          // BodyShopPainting 105
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon-box' },
	            color === 'black' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopPainting_Black, size: 't' }),
	            color === 'white' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopPainting_White, size: 't' }),
	            color === 'red' && _react2.default.createElement(_icon2.default, { imgClassName: 'main-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopPainting_Red, size: 't' }),
	            _react2.default.createElement(_icon2.default, { imgClassName: 'hover-icon', icon: _icons.AssignmentStepStatus.Step_BodyShopPainting_Red, size: 't' })
	          );
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'onStepClick',
	    value: function onStepClick(step, assignedUsersIds) {
	      var _this2 = this;
	
	      var bodyAllowedSteps = [103, 104, 7];
	      // let restriction = !hasSubscriptionPermission(this.props.auth, 20) && assignedUsersIds.length > 0 && !assignedUsersIds.includes(this.props.activeEmployees[0])
	      if (step >= this.state.item.CurrentStep && step !== 105 || this.state.item.CurrentStep === 105 && bodyAllowedSteps.includes(step) || step === 7) {
	        if (this.props.activeEmployees.length === 0) {
	          window.toastr.error((0, _helpers.translation)('1858'), (0, _helpers.translation)('216'));
	        } else {
	          var data = {
	            UserIds: this.props.activeEmployees,
	            OrderId: this.state.item.OrderId,
	            StepId: step
	          };
	          this.props.assignUsers(data).then(function (res) {
	            _this2.setState({
	              item: res.data
	            });
	            _this2.props.onAssignUsers();
	          }, function () {
	            window.toastr.error((0, _helpers.translation)('1898'), (0, _helpers.translation)('216'));
	          });
	        }
	      }
	    }
	  }, {
	    key: 'renderStep',
	    value: function renderStep(step, key) {
	      var _this3 = this;
	
	      if (step.Step === 105 && this.state.item.CurrentStep !== 105) return null;
	      // Extra class
	      var extraClass = '';
	      var iconColor = 'black';
	      var unAssignClass = '';
	      if (step.AssignedUsersIds.length === 0) {
	        unAssignClass = ' unAssignStep';
	        extraClass = unAssignClass;
	      }
	
	      if (this.props.auth.departmentType !== 1) {
	        if (step.Step === this.state.item.CurrentStep) {
	          extraClass = 'currentStep' + unAssignClass;
	        } else if (step.Step < this.state.item.CurrentStep) {
	          extraClass = 'disabled';
	        }
	        if (step.IsAssigned && step.Step >= this.state.item.CurrentStep) {
	          extraClass = ' active';
	        }
	      } else {
	        var stepArr = [1, 101, 102, 103, 104, 7];
	        var bodyDisabledSteps = [1, 101, 102];
	        if (step.Step === this.state.item.CurrentStep) {
	          extraClass = 'currentStep' + unAssignClass;
	        } else if (stepArr.indexOf(step.Step) < stepArr.indexOf(this.state.item.CurrentStep) || this.state.item.CurrentStep === 105 && bodyDisabledSteps.includes(step.Step)) {
	          extraClass = 'disabled';
	        }
	        if (step.IsAssigned && stepArr.indexOf(step.Step) >= stepArr.indexOf(this.state.item.CurrentStep)) {
	          extraClass = ' active';
	        }
	        if (step.Step === 105) {
	          extraClass += ' disabled';
	        }
	      }
	
	      if (this.props.disabled) {
	        extraClass = ' disabled';
	      }
	
	      // get icon color
	      if (extraClass.indexOf('unAssignStep') !== -1) {
	        iconColor = 'red';
	      }
	      if (extraClass.indexOf('active') !== -1) {
	        iconColor = 'white';
	      }
	
	      var renderAriaText = function renderAriaText(key, val) {
	        if (step.AssignedUsers.length !== 0) {
	          if (step.Initials.length > 2 && val === '+') {
	            return step.AssignedUsers.slice(key, step.AssignedUsers.length).join(', ');
	          }
	          return step.AssignedUsers[key];
	        }
	      };
	
	      // Initials
	      var renderInitials = function renderInitials() {
	        var assignedUsers = '';
	        if (step.AssignedUsers.length !== 0) {
	          var userInitials = step.Initials;
	          if (step.Initials.length > 2) {
	            userInitials = step.Initials.slice(0, 1);
	            userInitials.push('+');
	          }
	          var customComponent = userInitials.map(function (x, key) {
	            return { customComponent: _avatar2.default, initials: x, noCircle: true, ariaText: renderAriaText(key, x), ariaPos: _this3.props.assignAriaPos, useHtmlTitleTag: _this3.props.useHtmlTitleTag };
	          });
	          assignedUsers = _react2.default.createElement(_iconAccordion2.default, { icons: customComponent, size: 's' });
	        } else {
	          if (extraClass !== 'disabled') {
	            assignedUsers = _react2.default.createElement(_icon2.default, { icon: _icons.AssignmentIcons.Warning, size: 's', injectSvg: true });
	          }
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'stepInitials' },
	          _react2.default.createElement(
	            'div',
	            null,
	            assignedUsers
	          ),
	          assignedUsers === '' && step.Initials
	        );
	      };
	      var itemWidth = 100 / (this.props.auth.departmentType === 1 && this.state.item.CurrentStep !== 105 ? 6 : 7) + '%';
	
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'step__item ' + extraClass, style: { width: itemWidth }, key: key, onClick: this.onStepClick.bind(this, step.Step, step.AssignedUsersIds) },
	        _react2.default.createElement(
	          'div',
	          { className: 'step__icons' },
	          this.getStepIcon(step.Step, iconColor)
	        ),
	        renderInitials(),
	        _react2.default.createElement(
	          'div',
	          { className: 'step__time' },
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && step.AssignedTime
	        )
	      );
	    }
	  }, {
	    key: 'navigateToOrder',
	    value: function navigateToOrder() {
	      var item = this.state.item;
	
	      this.props.router.push({
	        pathname: '/orders/' + item.OrderId,
	        state: {
	          lastview: 'assign'
	        }
	      });
	    }
	  }, {
	    key: 'generateTitle',
	    value: function generateTitle() {
	      var item = this.state.item;
	
	      var title = '';
	
	      // Model
	      if (item.Model) {
	        title += item.Model;
	      }
	
	      // RegNumber
	      if (item.RegNumber) {
	        if (item.Model) {
	          title += ', ';
	        }
	        title += item.RegNumber;
	      }
	
	      // Title empty
	      if (title === '') {
	        title += item.OrderId;
	      }
	
	      return title;
	    }
	  }, {
	    key: 'renderProduction',
	    value: function renderProduction() {
	      var _this4 = this;
	
	      if (!(0, _auth.hasAccess)([3, 7], this.props.auth.user.UserType) || this.props.DontShowDeadline) return null;
	      var canChange = (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 13);
	
	      var item = this.state.item;
	
	      var renderActionOpener = function renderActionOpener(triggerOpen) {
	        return _react2.default.createElement(
	          'div',
	          { onClick: triggerOpen, className: 'hint--left' + (canChange ? ' hasCursor' : ''), 'aria-label': (0, _helpers.translation)('193') },
	          (0, _auth.hasSubscriptionPermission)(_this4.props.auth, 10, 2) && _this4.renderTime(item.Delivery)
	        );
	      };
	      var renderActionMenu = function renderActionMenu(triggerPopup) {
	        if (!canChange) return null;
	        var onSuccess = function onSuccess() {
	          triggerPopup();
	          _this4.props.getAssignOrderData();
	        };
	        return _react2.default.createElement(_DateActions2.default, { item: item, orderId: item.OrderId, location: 'assign', onSuccess: onSuccess });
	      };
	      return _react2.default.createElement(_DateChangePopup2.default, { selfClick: true, renderActionOpener: renderActionOpener, renderActionMenu: renderActionMenu });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var item = this.state.item;
	
	      if (item === null) return null;
	      if (Object.keys(item).length === 0) return null;
	      var extraClass = '';
	      if (item.IsStarted) extraClass = 'active';
	      return _react2.default.createElement(
	        'div',
	        { className: 'assign__item ' + extraClass, 'data-index': this.props.index },
	        _react2.default.createElement(
	          'div',
	          { className: 'title clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'left', onClick: this.navigateToOrder },
	            this.generateTitle()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            this.renderProduction()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clearfix stepsController' },
	          item.Assignments.map(this.renderStep)
	        )
	      );
	    }
	  }]);
	
	  return AssignItem;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    activeEmployees: state.assign.activeEmployees
	  };
	}
	
	AssignItem.defaultProps = {
	  assignAriaPos: 'bottom'
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  assignUsers: _assign.assignUsers
	})(AssignItem);

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Dragula = __webpack_require__(290);
	
	var _Dragula2 = _interopRequireDefault(_Dragula);
	
	var _PriceItem = __webpack_require__(946);
	
	var _PriceItem2 = _interopRequireDefault(_PriceItem);
	
	__webpack_require__(1446);
	
	__webpack_require__(336);
	
	var _helpers = __webpack_require__(2);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableExpand = __webpack_require__(140);
	
	var _tableExpand2 = _interopRequireDefault(_tableExpand);
	
	var _tableHeader = __webpack_require__(132);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { hasAccess } from '../../../utils/auth'
	
	// import HelpText from '../../../shared/components/HelpText'
	
	// Utils
	
	
	// Elements
	
	
	var PriceItemGroup = function (_Component) {
	  _inherits(PriceItemGroup, _Component);
	
	  function PriceItemGroup(props) {
	    _classCallCheck(this, PriceItemGroup);
	
	    var _this = _possibleConstructorReturn(this, (PriceItemGroup.__proto__ || Object.getPrototypeOf(PriceItemGroup)).call(this, props));
	
	    _this.state = {
	      config: { // Example config data
	        itemIdField: 'TaskPriceId', // Name of Id field for items in the list.
	        itemOrderField: 'SortIndex', // Name of field that will be used/set in drag/reorder operations
	        itemOrderLockedField: 'SortIndexLocked', // Field to use when determining if an item can be moved or not
	        editable: true,
	        whitebox: true,
	        draggable: true, // Allow and display drag column
	        title: 'No title', // Text or dictionary key
	        groupCss: 'partitem__list', // name of css class that will be applied to the UL
	        itemCss: 'taskpriceItem', // name of css class that will be applied to each LI
	        allowAdd: true,
	        allowDelete: true,
	        fields: [{
	          name: 'TaskName',
	          header: 123, // text or dictionary key
	          type: 'text',
	          editable: false, // editable for existing entries or not
	          hide: false,
	          css: 'taskname-class'
	        }, {
	          name: 'AE',
	          header: 'LU',
	          type: 'ae',
	          editable: true,
	          hide: false,
	          css: ''
	        }, {
	          name: 'Gross',
	          header: 'Bruttoo',
	          type: 'currency',
	          editable: false,
	          hide: false,
	          css: ''
	        }, {
	          name: 'DropDownExample',
	          header: 'Dropdown',
	          type: 'select',
	          options: [{ 0: 'First' }, { 1: 'Second' }], // if 'options' is a function, it is expected to take field-name as argument and return an array of option values
	          editable: false,
	          hide: false,
	          css: ''
	        }],
	        newItemInputs: ['TaskName', 'AE'], // Open fields for new entries
	        groupField: 'PartItemId' // This field will be pre-filled from 'groupId' from provided props
	      },
	      items: []
	    };
	    _this.dragula = null;
	    _this.stateFromProps = _this.stateFromProps.bind(_this);
	    _this.enableScroll = _this.enableScroll.bind(_this);
	    _this.disableScroll = _this.disableScroll.bind(_this);
	    // this.canScroll = true
	    _this.appElement = document.getElementById('app');
	    _this.canScroll = true;
	    return _this;
	  }
	
	  _createClass(PriceItemGroup, [{
	    key: 'stateFromProps',
	    value: function stateFromProps(props) {
	      var state = this.state;
	      if (props.config !== undefined && props.config !== null) {
	        // config is allowed to be either an object or a function
	        if (typeof props.config === 'function') {
	          state.config = props.config();
	        } else {
	          state.config = props.config;
	        }
	      }
	      if (props.items === undefined || props.items === null) {
	        state.items = [];
	      } else {
	        state.items = props.items;
	      }
	
	      return state;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var state = this.stateFromProps(this.props);
	      this.setState(_extends({}, state));
	      setTimeout(function () {
	        return _this2.setupDragula();
	      }, 100);
	      this.enableScroll();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.enableScroll();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var state = this.stateFromProps(newProps);
	      this.setState(_extends({}, state));
	    }
	  }, {
	    key: 'setupDragula',
	    value: function setupDragula() {
	      var _this3 = this;
	
	      if (this.state.config.draggable && this.state.config.editable) {
	        var container = _reactDom2.default.findDOMNode(this).getElementsByClassName('drag_container')[0];
	        var options = {
	          direction: 'vertical',
	          revertOnSpill: true,
	          // mirrorContainer: container,
	          ignoreInputTextSelection: true,
	          accepts: function accepts(el, target, source, sibling) {
	            if (target !== source || sibling === null) return false;
	            // if (sibling.className.contains('gu-mirror')) return false
	            var names = sibling.className.split(' ');
	            for (var c = 0; c < names.length; c++) {
	              if (['priceitem_header', 'gu-mirror', 'priceitem_nomove'].includes(names[c])) {
	                return false;
	              }
	            }
	            return true;
	          },
	          invalid: function invalid(el, handle) {
	            var isInvalid = ['hint--bottom', 'workers', 'buttons', 'priceitem_static', 'priceitem_header'].includes(handle.className);
	            return isInvalid;
	          },
	          moves: function moves(el, container, handle) {
	            return handle.classList.contains('handle');
	          }
	        };
	
	        this.dragula = new _Dragula2.default([container], options).on('drag', function (el, source) {
	          //   //this.dragula.on('drag', () => {})
	          _this3.disableScroll();
	        }).on('drop', function (el) {
	          // this.enableScroll()
	          _this3.enableScroll();
	          var newPosition = -1;
	          // Determine new index of element in drop target.
	          var index = el.dataset.index;
	          var allItems = _reactDom2.default.findDOMNode(_this3).getElementsByClassName('drag_container')[0].children;
	          for (var i = 0; i < allItems.length; i++) {
	            if (el === allItems[i]) {
	              newPosition = i;
	              break;
	            }
	          }
	          if (newPosition !== -1) {
	            // console.log('moved ', this.state.items[index], 'to', newPosition)
	            if (_this3.props.onDragged !== undefined && _this3.props.onDragged !== null) {
	              _this3.props.onDragged(_this3.state.items[index], newPosition);
	            }
	          }
	        }).on('dragend', function (el, container) {
	          _this3.enableScroll();
	          // this.dragula.on('drag', (el, source) => {
	          //   // this.dragula.on('drag', () => {})
	          //   // this.disableScroll()
	          // })
	        });
	      } else {
	        // Destroy dracula if he exist here
	        if (this.dragula !== null) {
	          this.dragula.destroy();
	          this.enableScroll();
	        }
	      }
	    }
	  }, {
	    key: 'enableScroll',
	    value: function enableScroll() {
	      // console.log('enable scroll')
	      if (!this.canScroll) {
	        if (this.appElement.classList.contains('lock-screen')) {
	          this.appElement.classList.remove('lock-screen');
	        }
	        this.canScroll = true;
	      }
	    }
	  }, {
	    key: 'disableScroll',
	    value: function disableScroll() {
	      // console.log('disable scroll')
	      if (this.canScroll) {
	        if (!this.appElement.classList.contains('lock-screen')) {
	          this.appElement.classList.add(['lock-screen']);
	        }
	        this.canScroll = false;
	      }
	    }
	  }, {
	    key: 'generateColWidths',
	    value: function generateColWidths(fields, hasDragColumn, hasAction) {
	      var cols = '';
	
	      if (hasDragColumn) {
	        cols += 'min-content ';
	      }
	
	      cols += fields.filter(function (f) {
	        return !f.hide;
	      }).map(function (f) {
	        return f.col ? f.col : 1;
	      }).join('fr ') + 'fr';
	
	      if (hasAction) {
	        cols += ' 27px';
	      }
	
	      return cols;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var items = this.state.items;
	      // let boxCss = this.state.config.whitebox ? 'white__box' : ''
	      var groupCss = this.state.config.groupCss;
	      var itemIdField = this.state.config.itemIdField;
	      var title = this.props.title;
	      if (title === undefined || title === null) {
	        title = this.state.config.title;
	      }
	      if (typeof title === 'number') {
	        title = (0, _helpers.translation)(title);
	      }
	      var hasTitle = title !== undefined && title !== null;
	      if (groupCss === undefined) {
	        groupCss = '';
	      }
	
	      var renderItem = function renderItem(val, key) {
	        return _react2.default.createElement(_PriceItem2.default, {
	          item: val,
	          config: _this4.state.config,
	          key: itemIdField + '_' + val[itemIdField],
	          itemClass: _this4.props.itemClass,
	          disabled: _this4.props.disabled,
	          onDelete: _this4.props.onDelete,
	          onUpdate: _this4.props.onUpdate,
	          generateColWidths: _this4.generateColWidths,
	          groupId: _this4.props.groupId,
	          index: key });
	      };
	
	      var renderAddItem = function renderAddItem() {
	        return _react2.default.createElement(_PriceItem2.default, {
	          item: null,
	          config: _this4.state.config,
	          key: itemIdField + '_new',
	          disabled: _this4.props.disabled,
	          onAdd: _this4.props.onAdd,
	          generateColWidths: _this4.generateColWidths,
	          groupId: _this4.props.groupId,
	          index: null });
	      };
	
	      var renderHeader = function renderHeader() {
	        if (_this4.state.config.fields === undefined) return;
	        var helpText = _this4.state.config.headerHelp;
	        var hasHeaderHelp = helpText !== undefined && helpText !== null;
	        if (typeof helpText === 'number') helpText = (0, _helpers.translation)(helpText);
	
	        var renderHeaderItem = function renderHeaderItem(field, key) {
	          if (field.hide === true) return null;
	          var header = field.header;
	          if (typeof header === 'number') header = (0, _helpers.translation)(header);
	          if (field.headerAppend !== undefined && field.headerAppend !== null) header += field.headerAppend;
	
	          var ariaLabel = field.ariaLabel;
	          if (typeof ariaLabel === 'number') ariaLabel = (0, _helpers.translation)(ariaLabel);
	          var hasAria = ariaLabel !== undefined && ariaLabel !== null;
	
	          var ariaHintClass = '';
	          if (hasAria && field.ariaHintClass !== undefined && field.ariaHintClass !== null) {
	            ariaHintClass = field.ariaHintClass;
	          }
	
	          return _react2.default.createElement(
	            'span',
	            { className: ariaHintClass, 'aria-label': hasAria ? ariaLabel : null, key: key },
	            header
	          );
	        };
	
	        var shouldRenderDragColumn = _this4.state.config.draggable && _this4.state.config.editable;
	        var hasAction = _this4.state.config.editable && (_this4.state.config.allowDelete || _this4.state.config.allowAdd);
	        var cols = _this4.generateColWidths(_this4.state.config.fields, shouldRenderDragColumn, hasAction || hasHeaderHelp);
	
	        return _react2.default.createElement(
	          'li',
	          { className: 'priceitem priceitem_static priceitem_header' },
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true, cols: cols },
	            shouldRenderDragColumn && _react2.default.createElement('div', { className: 'dragcolumn' }),
	            _this4.state.config.fields.map(renderHeaderItem),
	            hasHeaderHelp && _react2.default.createElement(_helpIcon2.default, { helpText: (0, _helpers.translation)(helpText) })
	          )
	        );
	        // return (
	        //   <li className='clearfix form priceitem priceitem_static priceitem_header'>
	        //     {this.state.config.draggable && this.state.config.editable && <div className='dragcolumn' />}
	        //     {this.state.config.fields.map(renderHeaderItem)}
	        //     {hasHeaderHelp && headerHelp}
	        //   </li>
	        // )
	      };
	
	      var renderTitleHelp = function renderTitleHelp() {
	        var text = _this4.state.config.titleHelp;
	        if (text === undefined || text === null) return null;
	        if (typeof text === 'number') text = (0, _helpers.translation)(text);
	
	        return text;
	        // return (<HelpText className='helpText' text={text} left />)
	      };
	
	      var renderContent = function renderContent() {
	        return _react2.default.createElement(
	          'ul',
	          { className: 'drag_container' },
	          renderHeader(),
	          items.map(renderItem),
	          _this4.state.config.allowAdd && _this4.state.config.editable && renderAddItem()
	        );
	      };
	
	      if (this.state.config.whitebox) {
	        return _react2.default.createElement(
	          _tableContainer2.default,
	          { fullWidth: true },
	          _react2.default.createElement(
	            _tableExpand2.default,
	            null,
	            hasTitle && _react2.default.createElement(
	              _tableHeader2.default,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                title,
	                _react2.default.createElement(_helpIcon2.default, { helpText: renderTitleHelp() })
	              )
	            ),
	            renderContent()
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        hasTitle && _react2.default.createElement(
	          _tableHeader2.default,
	          { simple: true },
	          _react2.default.createElement(
	            'span',
	            null,
	            title,
	            _react2.default.createElement(_helpIcon2.default, { helpText: renderTitleHelp() })
	          )
	        ),
	        renderContent()
	      );
	
	      // const renderContent = () => {
	      //   return (
	      //     <ul className='drag_container'>
	      //       {renderHeader()}
	      //       {items.map(renderItem)}
	      //       {this.state.config.allowAdd && this.state.config.editable && renderAddItem()}
	      //     </ul>
	      //   )
	      // }
	
	      // if (this.state.config.whitebox) {
	      //   return (
	      //     <Panel title={hasTitle && title} helpText={hasTitle && renderTitleHelp()}>
	      //       {renderContent()}
	      //     </Panel>
	      //   )
	      // }
	
	      // return (
	      //   <div>
	      //     {hasTitle && <Header text={title} helpText={renderTitleHelp()} />}
	      //     {renderContent()}
	      //   </div>
	      // )
	    }
	  }]);
	
	  return PriceItemGroup;
	}(_react.Component);
	
	PriceItemGroup.propTypes = {
	  auth: _propTypes2.default.object.isRequired,
	  items: _propTypes2.default.array.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(PriceItemGroup);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	__webpack_require__(1462);
	
	var _settings = __webpack_require__(51);
	
	var _priceModel = __webpack_require__(75);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Components
	// import HelpText from '../../../shared/components/HelpText'
	
	// Utils
	
	
	var Delivery = function (_Component) {
	  _inherits(Delivery, _Component);
	
	  function Delivery(props) {
	    _classCallCheck(this, Delivery);
	
	    var _this = _possibleConstructorReturn(this, (Delivery.__proto__ || Object.getPrototypeOf(Delivery)).call(this, props));
	
	    _this.state = {
	      Delivery: {
	        CustomerId: 0,
	        ShopId: 0,
	        PriceModelId: props.agreementId !== undefined && props.agreementId !== null ? props.agreementId : 0,
	        AllowChangeDelivery: false,
	        LogDateChanges: false,
	        UseDefaultDelivery: true,
	        DefaultHours: 0,
	        DeliveryPlusDriving: false,
	        DeliveryHourPrices: []
	      },
	      NewItem: {
	        Id: 0,
	        PriceFrom: 0,
	        PriceTo: 0,
	        Hours: 1,
	        PlusDriving: false,
	        IsDeleted: false,
	        ApplyType: 0
	      },
	      isShop: props.isShop === true,
	      isAgreement: props.isAgreement === true,
	      isMainAgreement: props.isMainAgreement === true,
	      isLoaded: false,
	      price: props.isAgreement === true ? props.agreementPrice !== undefined ? props.agreementPrice : {} : {},
	      isLoading: false // To prevent double clicking on add, resulting in creation of duplicates
	    };
	    _this.setItemToDelivery = _this.setItemToDelivery.bind(_this);
	    return _this;
	  }
	
	  _createClass(Delivery, [{
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        Delivery: {
	          CustomerId: 0,
	          ShopId: 0,
	          PriceModelId: this.props.agreementId !== undefined && this.props.agreementId !== null ? this.props.agreementId : 0,
	          AllowChangeDelivery: false,
	          LogDateChanges: false,
	          UseDefaultDelivery: true,
	          DefaultHours: 0,
	          DeliveryPlusDriving: false,
	          DeliveryHourPrices: []
	        },
	        NewItem: {
	          Id: 0,
	          PriceFrom: 0,
	          PriceTo: 0,
	          Hours: 1,
	          PlusDriving: false,
	          IsDeleted: false,
	          ApplyType: 0
	        },
	        price: this.props.isAgreement === true ? this.props.agreementPrice !== undefined ? this.props.agreementPrice : {} : {},
	        isShop: this.props.isShop === true,
	        isAgreement: this.props.isAgreement === true,
	        isMainAgreement: this.props.isMainAgreement === true,
	        isLoaded: false
	      });
	    }
	  }, {
	    key: 'setItemToDelivery',
	    value: function setItemToDelivery() {
	      if (!this.state.isAgreement && this.state.isShop) {
	        this.setState({
	          Delivery: this.props.item,
	          NewItem: {
	            Id: 0,
	            PriceFrom: 0,
	            PriceTo: 0,
	            Hours: 1,
	            PlusDriving: false,
	            IsDeleted: false,
	            ApplyType: 0
	          },
	          price: {},
	          isShop: this.props.isShop === true,
	          isAgreement: this.props.isAgreement === true,
	          isMainAgreement: this.props.isMainAgreement === true,
	          isLoaded: false
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      this.setItemToDelivery();
	      if (!this.state.isAgreement && !this.state.isShop && !this.state.isMainAgreement) {
	        this.getDeliveryInformation(this.props);
	      } else if (this.state.isAgreement && !this.state.isShop) {
	        if (this.props.agreementPrice === undefined || this.props.agreementPrice.PriceModelId === undefined) {
	          this.getCustomerAgreement(this.props.agreementId, this.props.selectedCustomerId, this.props.selectedShopId);
	        } else {
	          this.getPriceModelDeliveryInformation(this.props.agreementPrice.PriceModelId);
	        }
	      } else if (this.state.isShop || this.state.isMainAgreement) {
	        var id = this.props.agreementId;
	        if (this.state.isShop) this.getDeliveryInformation(this.props);
	        if (this.state.isMainAgreement) {
	          this.getPriceModelDeliveryInformation(this.state.Delivery.PriceModelId);
	          id = this.state.Delivery.PriceModelId;
	        }
	        this.props.getPriceList(id).then(function (res) {
	          _this2.setState({
	            price: res.data
	          }, function () {
	            _this2.updateApplyType();
	          });
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        });
	      }
	    }
	  }, {
	    key: 'getCustomerAgreement',
	    value: function getCustomerAgreement(agreementId, customerId, companyId) {
	      var _this3 = this;
	
	      // console.log('getCustomerAgreement', agreementId, customerId)
	      this.resetCreate();
	      this.props.getShopCustomerAgreement(agreementId, customerId, companyId).then(function (res) {
	        var _state = _extends({}, _this3.state),
	            Delivery = _state.Delivery;
	
	        if (!_this3.state.isShop) Delivery.PriceModelId = res.data.PriceModelId;
	        _this3.setState({
	          price: res.data,
	          Delivery: Delivery,
	          isLoaded: true
	        }, function () {
	          if (!_this3.state.isShop) {
	            _this3.getPriceModelDeliveryInformation(_this3.state.price.PriceModelId);
	          } else {
	            _this3.getPriceModelDeliveryInformation(_this3.state.Delivery.PriceModelId);
	          }
	        });
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this3.props.onShouldUpdate();
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.state.isShop && !this.state.isAgreement && (this.props.agreementPrice === undefined || nextProps.agreementPrice === undefined || nextProps.params === undefined || nextProps.params.type === undefined || !(0, _lodash.isEqual)(nextProps.params.type, this.props.params.type))) {
	        this.getDeliveryInformation(nextProps);
	        return;
	      }
	      if (this.props.agreementPrice !== undefined && nextProps.agreementPrice !== undefined && !(0, _lodash.isEqual)(this.props.agreementPrice.PriceModelId, nextProps.agreementPrice.PriceModelId)) {
	        // console.log('willAgreementPrice')
	        this.getPriceModelDeliveryInformation(nextProps.agreementPrice.PriceModelId);
	        return;
	        // } else
	        // if (!this.state.isShop && this.state.isAgreement && !isEqual(nextProps.selectedCustomerId, this.props.selectedCustomerId) && nextProps.selectedCustomerId > 0 && isEqual(this.props.agreementPrice.PriceModelId, nextProps.agreementPrice.PriceModelId)) {
	        //   this.getCustomerAgreement(nextProps.agreementId, nextProps.selectedCustomerId)
	      }
	      if (this.state.isShop && this.state.isAgreement && !(0, _lodash.isEqual)(nextProps.CustomerId, this.props.CustomerId)) {
	        this.getDeliveryInformation(nextProps);
	        return;
	        // this.getCustomerAgreement(nextProps.agreementId, nextProps.CustomerId)
	      }
	    }
	  }, {
	    key: 'getPriceModelDeliveryInformation',
	    value: function getPriceModelDeliveryInformation(priceModelId) {
	      var _this4 = this;
	
	      // console.log('getPriceModelDeliveryInformation ', priceModelId)
	      this.props.getDeliveryInformation(0, 0, priceModelId).then(function (res) {
	        _this4.setDeliveryState(res);
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getDeliveryInformation',
	    value: function getDeliveryInformation(nextProps) {
	      var _this5 = this;
	
	      var shopId = this.props.auth.user.ShopId;
	      var customerId = nextProps.CustomerId;
	      var priceModelId = nextProps.PriceModelId;
	      if (customerId === undefined) customerId = 0;
	      if (priceModelId === undefined) priceModelId = 0;
	      if (nextProps.isShop === true) {
	        customerId = nextProps.item.CustomerId;
	        priceModelId = nextProps.item.PriceModelId;
	      }
	      this.props.getDeliveryInformation(customerId, shopId, priceModelId).then(function (res) {
	        _this5.setDeliveryState(res);
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'setDeliveryState',
	    value: function setDeliveryState(res) {
	      var _this6 = this;
	
	      if (res.data.UseDefaultDelivery !== this.state.Delivery.UseDefaultDelivery && typeof this.props.onLayoutChange === 'function') {
	        var colSpan = res.data.UseDefaultDelivery ? '1' : '3';
	        this.props.onLayoutChange(colSpan);
	      }
	      this.setState({
	        Delivery: res.data,
	        NewItem: {
	          Id: 0,
	          PriceFrom: 0,
	          PriceTo: 0,
	          Hours: 1,
	          PlusDriving: false,
	          IsDeleted: false,
	          ApplyType: 0
	        },
	        isLoaded: true
	      }, function () {
	        _this6.updateApplyType();
	      });
	    }
	  }, {
	    key: 'updateDeliveryInformation',
	    value: function updateDeliveryInformation(delivery) {
	      var _this7 = this;
	
	      this.setState({ isLoading: true });
	      return this.props.saveDeliveryInformation(delivery).then(function (res) {
	        _this7.setState({ isLoading: false });
	        _this7.setDeliveryState(res);
	        // window.toastr.success(translation('1845'), translation('13424'))
	        return res;
	      }, function (err) {
	        // console.log('err', err.response.data)
	        _this7.setState({ isLoading: false });
	        if (err.response.data !== null) {
	          var errorKey = err.response.data.DictionaryKey;
	          window.toastr.error((0, _helpers.translation)(errorKey), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('1846'), (0, _helpers.translation)('216'));
	        }
	        return err;
	      });
	    }
	  }, {
	    key: 'getApplyType',
	    value: function getApplyType() {
	      var type = 0;
	
	      var _state2 = _extends({}, this.state),
	          price = _state2.price;
	      // console.log('getApplyType: price', price, this.state)
	
	
	      if (price !== undefined && price.PriceType !== undefined) {
	        switch (price.PriceType) {
	          case 1:
	            type = 3;
	            break;
	          case 2:
	            type = 7;
	            break;
	          case 3:
	            type = 4;
	            break;
	          case 5:
	            type = 2;
	            break;
	          default:
	            break;
	        }
	      }
	      return type;
	    }
	  }, {
	    key: 'updateApplyType',
	    value: function updateApplyType() {
	      this.setState({
	        NewItem: _extends({}, this.state.NewItem, {
	          ApplyType: this.getApplyType()
	        })
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.updateDeliveryInformation(this.state.Delivery);
	    }
	  }, {
	    key: 'getHours',
	    value: function getHours() {
	      var hours = {
	        1: '1 ' + (0, _helpers.translation)('18103'),
	        2: '2 ' + (0, _helpers.translation)('542'),
	        3: '3 ' + (0, _helpers.translation)('542'),
	        4: '4 ' + (0, _helpers.translation)('542'),
	        5: '5 ' + (0, _helpers.translation)('542'),
	        6: '6 ' + (0, _helpers.translation)('542'),
	        7: '7 ' + (0, _helpers.translation)('542'),
	        8: '8 ' + (0, _helpers.translation)('542'),
	        24: '24 ' + (0, _helpers.translation)('542') + ' (1 ' + (0, _helpers.translation)('18105') + ')',
	        48: '48 ' + (0, _helpers.translation)('542') + ' (2 ' + (0, _helpers.translation)('18105') + ')',
	        72: '72 ' + (0, _helpers.translation)('542') + ' (3 ' + (0, _helpers.translation)('18105') + ')',
	        96: '96 ' + (0, _helpers.translation)('542') + ' (4 ' + (0, _helpers.translation)('18105') + ')',
	        120: '120 ' + (0, _helpers.translation)('542') + ' (5 ' + (0, _helpers.translation)('18105') + ')',
	        144: '144 ' + (0, _helpers.translation)('542') + ' (6 ' + (0, _helpers.translation)('18105') + ')',
	        168: '168 ' + (0, _helpers.translation)('542') + ' (7 ' + (0, _helpers.translation)('18105') + ')',
	        192: '192 ' + (0, _helpers.translation)('542') + ' (8 ' + (0, _helpers.translation)('18105') + ')',
	        216: '216 ' + (0, _helpers.translation)('542') + ' (9 ' + (0, _helpers.translation)('18105') + ')',
	        240: '240 ' + (0, _helpers.translation)('542') + ' (10 ' + (0, _helpers.translation)('18105') + ')',
	        264: '264 ' + (0, _helpers.translation)('542') + ' (11 ' + (0, _helpers.translation)('18105') + ')',
	        288: '288 ' + (0, _helpers.translation)('542') + ' (12 ' + (0, _helpers.translation)('18105') + ')'
	      };
	      return hours;
	    }
	  }, {
	    key: 'getPriceType',
	    value: function getPriceType() {
	      switch (this.state.Delivery.PriceType) {
	        case 1:
	          return (0, _helpers.translation)('71');
	        case 2:
	          return (0, _helpers.translation)('785');
	        case 3:
	          return (0, _helpers.translation)('13361');
	        case 5:
	          return (0, _helpers.translation)('13360');
	        case 6:
	          return (0, _helpers.translation)('301');
	        case 0:
	          return (0, _helpers.translation)('73');
	        default:
	          return undefined;
	      }
	    }
	  }, {
	    key: 'renderAgreement',
	    value: function renderAgreement() {
	      if (!this.state.isShop) return undefined;
	      var titletext = (0, _helpers.translation)('196');
	      if (this.state.Delivery.WorkProviderName !== undefined && this.state.Delivery.WorkProviderName !== null) {
	        titletext += ' - ' + this.state.Delivery.WorkProviderName;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_panelHeader2.default, { text: titletext }),
	        _react2.default.createElement(_text2.default, { name: 'PriceModelName', value: this.state.Delivery.PriceModelName, disabled: true, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_text2.default, { name: 'OrderType', value: this.getPriceType(), disabled: true, labelText: (0, _helpers.translation)('69') }),
	        this.renderBrands()
	      );
	    }
	  }, {
	    key: 'renderBrands',
	    value: function renderBrands() {
	      var price = this.state.price;
	
	      var renderBrand = function renderBrand(val, key) {
	        return _react2.default.createElement(
	          _label2.default,
	          { key: key },
	          val.BrandName
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13473') }),
	        price.BrandSelectionType === 0 && _react2.default.createElement(_radio2.default, { id: 'brands_all', name: 'BrandSelectionType', value: '0', readOnly: true, checked: true, labelText: (0, _helpers.translation)('381') }),
	        price.BrandSelectionType === 1 && _react2.default.createElement(
	          'div',
	          null,
	          price.PriceModelBrands.map(renderBrand)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      var isCustomer = this.props.type === 'customer';
	      var isAgreement = !this.state.isShop && this.state.isAgreement;
	      var delivery = this.state.Delivery;
	      var hours = this.getHours();
	
	      var cols = [0.75, 0.75, 2, 0.75, 1, 'min-content'];
	      var size = 'm';
	      var renderDeliveryHourPrice = function renderDeliveryHourPrice(item, key) {
	        var applyType = item.ApplyType === 0 ? '381' : (0, _helpers.enumtranslate)('ApplyType', item.ApplyType);
	        var deleteItem = function deleteItem() {
	          if (_this8.state.isShop) return;
	          var prices = _extends({}, _this8.state.Delivery);
	          prices.DeliveryHourPrices[key].IsDeleted = true;
	          _this8.updateDeliveryInformation(prices);
	        };
	
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { cols: cols, key: key },
	          _react2.default.createElement(
	            'div',
	            null,
	            item.PriceFrom
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            item.PriceTo
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            hours[item.Hours]
	          ),
	          _react2.default.createElement(_check2.default, { value: '0', checked: item.PlusDriving, disabled: true, simple: true }),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(applyType)
	          ),
	          !_this8.state.isShop && !_this8.state.Delivery.DeliveryFromParent && _react2.default.createElement(_removeButton2.default, { onClick: deleteItem, size: size })
	        );
	      };
	
	      var addItem = function addItem() {
	        var deliveryClone = JSON.parse(JSON.stringify(_this8.state.Delivery));
	        var newItem = _extends({}, _this8.state.NewItem);
	        deliveryClone.DeliveryHourPrices.push(newItem);
	        _this8.updateDeliveryInformation(deliveryClone);
	      };
	
	      var renderNewDeliveryHourPrice = function renderNewDeliveryHourPrice() {
	        if (_this8.state.isShop || _this8.state.Delivery.DeliveryFromParent || !_this8.state.isLoaded) return undefined;
	        var price = _this8.state.NewItem;
	        // price.ApplyType = this.getApplyType()
	        var onChange = function onChange(e) {
	          e.persist();
	          var value = e.target.value;
	          if (e.target.type === 'checkbox') {
	            value = e.target.checked;
	          }
	          if (e.target.name === 'PriceFrom' || e.target.name === 'PriceTo') {
	            value = parseInt(value);
	            if (isNaN(value)) value = '';
	          }
	
	          _this8.setState({
	            NewItem: _extends({}, _this8.state.NewItem, _defineProperty({}, e.target.name, value))
	          }, function () {
	            // console.log(e.target.name, value, this.state.NewItem)
	          });
	        };
	
	        var onBlur = function onBlur(e) {
	          e.persist();
	          var value = e.target.value;
	          var name = e.target.name;
	          if (name === 'PriceFrom' || name === 'PriceTo') {
	            if (value === '' || value === null) {
	              value = 0;
	            }
	          }
	          _this8.setState({
	            NewItem: _extends({}, _this8.state.NewItem, _defineProperty({}, name, value))
	          });
	        };
	
	        var hours = _this8.getHours();
	        var disabled = _this8.state.isMainAgreement || _this8.state.isAgreement;
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { cols: cols },
	          _react2.default.createElement(_text2.default, { name: 'PriceFrom', value: price.PriceFrom, onChange: onChange, onBlur: onBlur, size: size }),
	          _react2.default.createElement(_text2.default, { name: 'PriceTo', value: price.PriceTo, onChange: onChange, onBlur: onBlur, size: size }),
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'Hours', onChange: onChange, value: _this8.state.NewItem.Hours, disabled: _this8.state.Delivery.DeliveryFromParent, size: size },
	            Object.keys(hours).map(function (key) {
	              return _react2.default.createElement(
	                'option',
	                { value: key, key: 'Hour_' + key },
	                hours[key]
	              );
	            })
	          ),
	          _react2.default.createElement(_check2.default, { name: 'PlusDriving', value: '1', checked: price.PlusDriving, onChange: onChange, disabled: _this8.state.Delivery.DeliveryFromParent, simple: true }),
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'ApplyType', onChange: onChange, value: _this8.state.NewItem.ApplyType, disabled: disabled, size: size },
	            _react2.default.createElement(
	              'option',
	              { value: '0' },
	              (0, _helpers.translation)('381')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '1' },
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('ApplyType', 1))
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '2' },
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('ApplyType', 2))
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '3' },
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('ApplyType', 3))
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '4' },
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('ApplyType', 4))
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '7' },
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('ApplyType', 7))
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '5' },
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('ApplyType', 5))
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '6' },
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('ApplyType', 6))
	            )
	          ),
	          _react2.default.createElement(_addButton2.default, { onClick: addItem, size: size, disabled: _this8.state.isLoading })
	        );
	      };
	      var Delivery = _extends({}, this.state.Delivery);
	
	      var onChange = function onChange(e) {
	        e.persist();
	        var value = e.target.value;
	        if (e.target.type === 'checkbox') {
	          value = e.target.checked;
	        } else if (e.target.type === 'select-one') {
	          value = parseInt(value);
	        }
	        _this8.setState({
	          Delivery: _extends({}, _this8.state.Delivery, _defineProperty({}, e.target.name, value))
	        }, function () {
	          if (e.target.name === 'UseDefaultDelivery' && typeof _this8.props.onLayoutChange === 'function') {
	            var colSpan = _this8.state.Delivery.UseDefaultDelivery ? '1' : '3';
	            _this8.props.onLayoutChange(colSpan);
	          }
	          if (e.target.type === 'checkbox' || e.target.type === 'radio' || e.target.type === 'select-one' || e.target.type === 'DeliveryFromParent') {
	            _this8.onBlur(e);
	          }
	        });
	      };
	
	      var renderContent = function renderContent() {
	        var hours = _this8.getHours();
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('196') },
	          _this8.renderAgreement(),
	          isAgreement && _react2.default.createElement(_check2.default, { name: 'DeliveryFromParent', value: '1', checked: delivery.DeliveryFromParent, onChange: onChange, disabled: !_this8.state.isLoaded, labelText: (0, _helpers.translation)('1921'), helpText: (0, _helpers.translation)('1950') }),
	          isCustomer && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_check2.default, { name: 'AllowChangeDelivery', value: '1', checked: delivery.AllowChangeDelivery, onChange: onChange, labelText: (0, _helpers.translation)('1622'), helpText: (0, _helpers.translation)('1948') }),
	            (0, _auth.hasSubscriptionPermission)(_this8.props.auth, 20) && _react2.default.createElement(_check2.default, { name: 'UseDefaultDelivery', value: '1', checked: delivery.UseDefaultDelivery, onChange: onChange, labelText: (0, _helpers.translation)('1921'), helpText: (0, _helpers.translation)('1950') })
	          ),
	          (0, _auth.hasSubscriptionPermission)(_this8.props.auth, 20) && (!isCustomer || !delivery.UseDefaultDelivery) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('1531'), helpText: (0, _helpers.translation)('1951') },
	              _react2.default.createElement(
	                _inline2.default,
	                { fillChildNum: [0], block: true },
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  {
	                    name: 'DefaultHours',
	                    onChange: onChange,
	                    value: delivery.DefaultHours + '' || '',
	                    disabled: _this8.state.isShop || _this8.state.Delivery.DeliveryFromParent || !_this8.state.isLoaded
	                  },
	                  Object.keys(hours).map(function (key) {
	                    console.log('newHours[key]', hours[key]);
	                    console.log('key', key);
	                    return _react2.default.createElement(
	                      'option',
	                      { value: key, key: 'DefaultHours_' + key },
	                      hours[key]
	                    );
	                  })
	                ),
	                _react2.default.createElement(_check2.default, {
	                  name: 'DeliveryPlusDriving',
	                  value: '1',
	                  checked: delivery.DeliveryPlusDriving,
	                  onChange: onChange,
	                  disabled: _this8.state.isShop || _this8.state.Delivery.DeliveryFromParent || !_this8.state.isLoaded,
	                  labelText: (0, _helpers.translation)('1527')
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _tableRow2.default,
	                { header: true, cols: cols.fill('32px', cols.length - 1) },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('1529')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('1530')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('15370')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('1527')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('18104')
	                ),
	                _react2.default.createElement(_helpIcon2.default, { helpText: (0, _helpers.translation)('1952') })
	              ),
	              renderNewDeliveryHourPrice(),
	              Delivery.DeliveryHourPrices.map(renderDeliveryHourPrice)
	            )
	          )
	        );
	      };
	
	      if (this.props.type === 'shop') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'deliveryhour__page' },
	          _react2.default.createElement(
	            _col2.default,
	            { span: '6' },
	            renderContent()
	          )
	        );
	      }
	
	      return renderContent();
	    }
	  }]);
	
	  return Delivery;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getDeliveryInformation: _settings.getDeliveryInformation,
	  saveDeliveryInformation: _settings.saveDeliveryInformation,
	  getShopCustomerAgreement: _priceModel.getShopCustomerAgreement,
	  getPriceList: _priceModel.getPriceList
	})(Delivery);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(337);
	
	var _detect = __webpack_require__(102);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Utils
	
	
	var ActionMenu = function (_PureComponent) {
	  _inherits(ActionMenu, _PureComponent);
	
	  function ActionMenu(props) {
	    _classCallCheck(this, ActionMenu);
	
	    var _this = _possibleConstructorReturn(this, (ActionMenu.__proto__ || Object.getPrototypeOf(ActionMenu)).call(this, props));
	
	    _this.state = {
	      isOpen: false
	    };
	    _this.triggerOpen = _this.triggerOpen.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(ActionMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._mounted = true;
	      if (typeof this.props.open !== 'undefined') {
	        if (this.props.open) {
	          this.triggerOpen();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (typeof nextProps.open !== 'undefined') {
	        if (this.props.open !== nextProps.open) {
	          if (nextProps.open) {
	            this.triggerOpen();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.handleClick, false);
	      this._mounted = false;
	    }
	  }, {
	    key: 'triggerOpen',
	    value: function triggerOpen() {
	      if (!this.state.isOpen) {
	        document.removeEventListener('click', this.handleClick, false);
	        document.addEventListener('click', this.handleClick, false);
	        if (typeof this.props.onOpen === 'function') this.props.onOpen();
	      } else {
	        document.removeEventListener('click', this.handleClick, false);
	      }
	      this.setState({
	        isOpen: !this.state.isOpen
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var component = _reactDom2.default.findDOMNode(this.refs.component);
	      if (e.target === component || component.contains(e.target)) {
	        if (e.target.tagName.toLowerCase() === 'a') {
	          this.props.handleClick(e.target);
	          if (e.target.dataset.action !== 'delete') {
	            if (this._mounted) {
	              this.triggerOpen();
	            }
	          }
	        }
	      } else {
	        if (this._mounted) {
	          this.triggerOpen();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var actionMenu = '';
	      if (this.state.isOpen) {
	        actionMenu = this.props.renderActionMenu();
	      }
	      var options = {};
	      if (!this.props.noAriaLabel) {
	        options = {
	          className: 'hint--left',
	          'aria-label': (0, _helpers.translation)('14720')
	        };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        options,
	        _react2.default.createElement(
	          'div',
	          { className: this.props.className(), ref: 'component' },
	          this.props.renderActionOpener(this.triggerOpen, this.props.type, this.props.isStarted),
	          actionMenu
	        )
	      );
	    }
	  }]);
	
	  return ActionMenu;
	}(_react.PureComponent);
	
	ActionMenu.propTypes = {
	  renderActionMenu: _propTypes2.default.func.isRequired,
	  renderActionOpener: _propTypes2.default.func.isRequired
	};
	
	ActionMenu.defaultProps = {
	
	  className: function className() {
	    return 'action__menu';
	  },
	  renderActionOpener: function renderActionOpener(triggerOpen, type, isStarted) {
	    var imageUrl = 'icons/menu_dots16.png';
	    var extraClass = '';
	    if (isStarted) {
	      imageUrl = 'svgs/menuicons/Menu-dots-white.svg';
	      // } else {
	      //   imageUrl = 'svgs/menuicons/Menu_dots-Black.svg'
	    }
	    if (type === 'workscreen' && (0, _detect.isTouchDevice)()) {
	      imageUrl = isStarted ? 'icons/action-swipe-dots-white-22x22.png' : 'icons/action-swipe-dot-22x.png';
	      extraClass = 'actionSwipe';
	    }
	    return _react2.default.createElement(
	      'span',
	      { onClick: triggerOpen, className: 'action_opener ' + extraClass },
	      _react2.default.createElement('img', { src: '/images/' + imageUrl, className: 'action_image ' + extraClass })
	    );
	  },
	  renderActionMenu: function renderActionMenu() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'poppedup' },
	      'POPUP'
	    );
	  }
	};
	
	exports.default = ActionMenu;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRangeslider = __webpack_require__(1884);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(1496);
	
	var _detect = __webpack_require__(102);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Elements
	
	
	var CircleImage = function (_Component) {
	  _inherits(CircleImage, _Component);
	
	  function CircleImage(props) {
	    _classCallCheck(this, CircleImage);
	
	    var _this = _possibleConstructorReturn(this, (CircleImage.__proto__ || Object.getPrototypeOf(CircleImage)).call(this, props));
	
	    _this.state = {
	      image: {},
	      circles: [],
	      mc: undefined,
	      rotateCircles: false,
	      oldImage: {},
	      base64: '',
	      circleimageModalWidth: 0,
	      currentWidth: 0,
	      currentHeight: 0,
	      rotatedWidth: 0,
	      rotatedHeight: 0,
	      maxWidth: 0,
	      isSubmit: false,
	      sliderOpened: false
	      // landscape: true
	    };
	    _this.circleSize = _this.circleSize.bind(_this);
	    _this.addCircle = _this.addCircle.bind(_this);
	    _this.clearCircles = _this.clearCircles.bind(_this);
	    _this.rotateCircle = _this.rotateCircle.bind(_this);
	    _this.renderCircle = _this.renderCircle.bind(_this);
	    _this.submitImage = _this.submitImage.bind(_this);
	    _this.onCircleImageClose = _this.onCircleImageClose.bind(_this);
	    _this.hammerTime = _this.hammerTime.bind(_this);
	    _this.initHammer = _this.initHammer.bind(_this);
	    _this.destroyHammer = _this.destroyHammer.bind(_this);
	    _this.rotateCircleWithImage = _this.rotateCircleWithImage.bind(_this);
	    _this.screenRotation = _this.screenRotation.bind(_this);
	    _this.onOrientationChange = _this.onOrientationChange.bind(_this);
	    _this.setCurrentAndRotateSize = _this.setCurrentAndRotateSize.bind(_this);
	    _this.renderSlider = _this.renderSlider.bind(_this);
	    // this.sliderHandleFix = this.sliderHandleFix.bind(this)
	    return _this;
	  }
	
	  _createClass(CircleImage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var image = this.props.image;
	      // to stop oldImage from updating with this.props.image
	      var oldImage = {
	        image: {
	          ImageSize: {
	            Height: image.image.ImageSize.Height,
	            Width: image.image.ImageSize.Width
	          },
	          circles: [],
	          file: image.image.file,
	          imageUrl: image.image.imageUrl,
	          rotation: image.image.rotation,
	          base64: image.image.base64
	        },
	        index: image.index
	
	        // Listen for orientation changes
	      };window.addEventListener('orientationchange', this.onOrientationChange);
	
	      var circleimageModalWidth = document.getElementsByClassName('modal__container')[0].getBoundingClientRect().width;
	      image.image.circles.map(function (circle, index) {
	        // circle.top = Math.floor((this.props.image.image.circles[index].top) * circleimageModalWidth / this.props.newOrderModalWidth) + 25
	        // circle.left = Math.floor((this.props.image.image.circles[index].left) * circleimageModalWidth / this.props.newOrderModalWidth) + 25
	      });
	
	      this.setState({
	        oldImage: oldImage,
	        image: image,
	        base64: image.image.imageUrl,
	        circles: image.image.circles,
	        circleimageModalWidth: circleimageModalWidth
	      });
	
	      var img = new window.Image();
	      img.onload = function () {
	        // set its dimension to rotated size
	        _this2.setCurrentAndRotateSize(img.width, img.height);
	      };
	      img.src = this.props.image.image.base64;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var image = _extends({}, this.state.image);
	      image.image.ImageSize = {
	        Width: parseInt(this.state.currentWidth),
	        Height: parseInt(this.state.currentHeight)
	      };
	      this.destroyHammer();
	      // this.props.submitImage(image, false)
	      if (!this.state.isSubmit) {
	        this.props.onCircleImageClose(this.state.oldImage, true);
	      }
	
	      window.removeEventListener('orientationchange', this.onOrientationChange);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var image = _extends({}, this.state.image);
	      image.image.ImageSize = {
	        Width: parseInt(this.state.currentWidth),
	        Height: parseInt(this.state.currentHeight)
	      };
	      if (typeof this.state.mc === 'undefined') {
	        this.initHammer();
	      } else {
	        this.hammerTime();
	      }
	    }
	  }, {
	    key: 'setCurrentAndRotateSize',
	    value: function setCurrentAndRotateSize(imageWidth, imageHeight) {
	      var maxWidth = this.refs.image_wrap.getBoundingClientRect().width;
	      var currentWidth = imageWidth;
	      var currentHeight = imageHeight;
	      var rotatedWidth = imageHeight;
	      var rotatedHeight = imageWidth;
	
	      if (imageWidth >= maxWidth) {
	        currentWidth = maxWidth;
	        currentHeight = imageHeight / imageWidth * maxWidth;
	      }
	
	      if (imageHeight >= maxWidth) {
	        rotatedWidth = maxWidth;
	        rotatedHeight = imageWidth / imageHeight * maxWidth;
	      }
	
	      this.setState({
	        currentWidth: currentWidth,
	        currentHeight: currentHeight,
	        rotatedWidth: rotatedWidth,
	        rotatedHeight: rotatedHeight
	      });
	    }
	  }, {
	    key: 'onOrientationChange',
	    value: function onOrientationChange() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        var oldWidth = _this3.state.currentWidth;
	        var oldHeight = _this3.state.currentHeight;
	        console.log('onOrientationChange', oldWidth, oldHeight);
	
	        var img = new window.Image();
	        img.onload = function () {
	          // set its dimension to rotated size
	          _this3.setCurrentAndRotateSize(img.width, img.height);
	          // let landscape = img.width - img.height > 0
	          _this3.screenRotation(oldWidth, oldHeight);
	          _this3.setState({
	            rotateCircles: false
	            // landscape: landscape
	          });
	        };
	        img.src = _this3.props.image.image.base64;
	      }, 500);
	    }
	  }, {
	    key: 'submitImage',
	    value: function submitImage(e) {
	      var _this4 = this;
	
	      // e.preventDefault()
	      var image = _extends({}, this.state.image);
	      image.image.circles = this.state.circles;
	      image.image.circles.map(function (circle, index) {
	        circle.top = Math.floor(_this4.state.circles[index].top);
	        circle.left = Math.floor(_this4.state.circles[index].left);
	      });
	
	      if (image.image.circles.length !== 0) {
	        image.image.circles[image.image.circles.length - 1].active = false;
	      }
	
	      image.image.ImageSize = {
	        Width: parseInt(this.state.currentWidth),
	        Height: parseInt(this.state.currentHeight)
	      };
	
	      this.setState({
	        isSubmit: true
	      });
	      this.props.submitImage(image, true);
	    }
	  }, {
	    key: 'onCircleImageClose',
	    value: function onCircleImageClose(e) {
	      // e.preventDefault()
	      this.props.onCircleImageClose(this.state.oldImage, true);
	    }
	  }, {
	    key: 'circleSize',
	    value: function circleSize(size) {
	      this.destroyHammer();
	      var circles = this.state.circles;
	
	      if (size) {
	        if (circles[circles.length - 1].scale < 3) {
	          circles[circles.length - 1].scale += 0.1;
	        }
	      } else {
	        if (circles[circles.length - 1].scale > 0.5) {
	          circles[circles.length - 1].scale -= 0.1;
	        }
	      }
	      this.setState({
	        mc: undefined,
	        circles: circles
	      });
	    }
	  }, {
	    key: 'addCircle',
	    value: function addCircle() {
	      if (typeof this.state.mc !== 'undefined') {
	        this.destroyHammer();
	      }
	      var circles = this.state.circles;
	
	      circles.map(function (val, index) {
	        val.active = false;
	        return val;
	      });
	      circles.push({
	        top: 0,
	        left: 0,
	        scale: 1,
	        active: true
	      });
	      this.setState({
	        mc: undefined,
	        circles: circles,
	        sliderOpened: true
	      }, function () {});
	    }
	  }, {
	    key: 'clearCircles',
	    value: function clearCircles() {
	      this.destroyHammer();
	      this.setState({
	        mc: undefined,
	        circles: [],
	        sliderOpened: false
	      });
	    }
	  }, {
	    key: 'initHammer',
	    value: function initHammer() {
	      this.setState({
	        mc: new window.Hammer.Manager(window.jQuery('#pnlDamagePhoto, .activemark')[0])
	      });
	    }
	  }, {
	    key: 'destroyHammer',
	    value: function destroyHammer() {
	      if (typeof this.state.mc !== 'undefined') {
	        this.state.mc.destroy();
	      }
	    }
	  }, {
	    key: 'hammerTime',
	    value: function hammerTime() {
	      var _this5 = this;
	
	      if (this.state.circles.length === 0) return null;
	      var index = this.state.circles.length - 1;
	      var image = this.state.circles[index];
	
	      var pan = new window.Hammer.Pan();
	      this.state.mc.add(pan);
	      var pinch = new window.Hammer.Pinch().recognizeWith(pan).set({ enable: true });
	      // let pinch = new window.Hammer.Pinch()
	      this.state.mc.add(pinch);
	
	      var startTop = 0;
	      var startLeft = 0;
	
	      var getXandY = function getXandY(event) {
	        var container = window.jQuery('#pnlDamagePhoto');
	        var mark = window.jQuery('.activemark');
	        var markWidth = mark.width();
	        var markHeight = mark.height();
	        var leftScaleModifier = 0;
	        var topScaleModifier = 0;
	
	        if (startTop === 0) {
	          startTop = parseInt(mark.css('top'), 10);
	        }
	        if (startLeft === 0) {
	          startLeft = parseInt(mark.css('left'), 10);
	        }
	
	        if (image.scale !== 1) {
	          markWidth = markWidth * image.scale;
	          markHeight = markHeight * image.scale;
	          leftScaleModifier = (mark.width() - markWidth) / 2;
	          topScaleModifier = (mark.height() - markHeight) / 2;
	        }
	
	        // Width bounds
	        var x = null;
	        var leftBound = startLeft + event.deltaX + leftScaleModifier > 0;
	        var rightBound = startLeft + event.deltaX <= container.width() - markWidth - leftScaleModifier;
	        if (leftBound && rightBound) {
	          x = event.deltaX + startLeft;
	        }
	
	        // Height bounds
	        var y = null;
	        var topBound = startTop + event.deltaY + topScaleModifier >= 0;
	        var bottomBound = startTop + event.deltaY <= container.height() - markHeight - topScaleModifier;
	        if (topBound && bottomBound) {
	          y = event.deltaY + startTop;
	        }
	
	        return {
	          x: x,
	          y: y
	        };
	      };
	
	      this.state.mc.on('panmove', function (event) {
	        var mark = window.jQuery('.activemark');
	        var coordinates = getXandY(event);
	        if (coordinates.x !== null) {
	          mark.css('left', coordinates.x + 'px');
	        }
	        if (coordinates.y !== null) {
	          mark.css('top', coordinates.y + 'px');
	        }
	      });
	
	      this.state.mc.on('panend', function (event) {
	        var circles = _this5.state.circles;
	
	        var mark = window.jQuery('.activemark');
	        circles[index].top = parseInt(mark.css('top'), 10);
	        circles[index].left = parseInt(mark.css('left'), 10);
	        _this5.destroyHammer();
	        _this5.setState({
	          mc: undefined,
	          circles: circles
	        });
	      });
	
	      this.state.mc.on('pinchin pinchout', function (event) {
	        var mark = window.jQuery('.activemark');
	        var scale = event.scale;
	        var transform = 'scale(' + scale + ')';
	        mark.css('webkitTransform', transform);
	      });
	
	      this.state.mc.on('pinchend', function (event) {
	        var circles = _this5.state.circles;
	
	        var mark = window.jQuery('.activemark');
	        var curTransform = new window.WebKitCSSMatrix(window.getComputedStyle(mark[0]).webkitTransform);
	        circles[index].scale = parseInt(curTransform.a);
	        if (circles[index].scale > 3) {
	          circles[index].scale = 3;
	        } else if (circles[index].scale < 0.5) {
	          circles[index].scale = 0.5;
	        }
	        _this5.destroyHammer();
	        _this5.setState({
	          mc: undefined,
	          circles: circles
	        });
	      });
	    }
	  }, {
	    key: 'rotateBase64',
	    value: function rotateBase64(base64Image) {
	      return new Promise(function (resolve, reject) {
	        // create an off-screen canvas
	        var offScreenCanvas = document.createElement('canvas');
	        var offScreenCanvasCtx = offScreenCanvas.getContext('2d');
	
	        // create Image
	        var img = new window.Image();
	        img.src = base64Image;
	
	        // on image load
	        img.onload = function () {
	          // set its dimension to rotated size
	          offScreenCanvas.height = img.width;
	          offScreenCanvas.width = img.height;
	
	          // rotate and draw source image into the off-screen canvas:
	          offScreenCanvasCtx.rotate(Math.PI / 2);
	          offScreenCanvasCtx.translate(0, -offScreenCanvas.width);
	          offScreenCanvasCtx.drawImage(img, 0, 0);
	
	          // encode image to data-uri with base64
	          resolve(offScreenCanvas.toDataURL('image/jpeg', 100));
	        };
	
	        // on image error
	        img.onerror = function (err) {
	          reject(err);
	        };
	      });
	    }
	  }, {
	    key: 'screenRotation',
	    value: function screenRotation(_oldWidth, _oldHeight) {
	      var _this6 = this;
	
	      var image = this.state.image;
	      if (image.image.ImageSize.Height !== 0) {
	        var circles = this.state.circles;
	        circles.map(function (circle, index) {
	          var oldWidth = _oldWidth;
	          var oldHeight = _oldHeight;
	          var newTotalWidth = _this6.state.currentWidth;
	          var newTotalHeight = _this6.state.currentHeight;
	          console.log('screenRotation', oldWidth, oldHeight, _this6.state.currentWidth, _this6.state.currentHeight);
	
	          var left = (circle.left + 25) / oldWidth * newTotalWidth - 25;
	          var top = (circle.top + 25) / oldHeight * newTotalHeight - 25;
	          circle.left = left;
	          circle.top = top;
	        });
	      }
	    }
	  }, {
	    key: 'rotateCircleWithImage',
	    value: function rotateCircleWithImage() {
	      var image = this.state.image;
	      var oldWidth = this.state.currentWidth;
	      var oldHeight = this.state.currentHeight;
	      var newTotalWidth = this.state.rotatedWidth;
	      var newTotalHeight = this.state.rotatedHeight;
	      if (image.image.ImageSize.Height !== 0) {
	        var circles = this.state.circles;
	        circles.map(function (circle, index) {
	          var oldPercentWidth = (circle.left + 25) / oldWidth * 100;
	          var newPercentHeight = (circle.top + 25) / oldHeight * 100;
	          var newPercentCircleWidth = 100 - newPercentHeight;
	          var newPercentCircleHeight = oldPercentWidth;
	          circle.left = newTotalWidth * newPercentCircleWidth / 100 - 25;
	          circle.top = newTotalHeight * newPercentCircleHeight / 100 - 25;
	        });
	      }
	      this.setState({
	        rotateCircles: false,
	        currentWidth: newTotalWidth,
	        currentHeight: newTotalHeight,
	        rotatedWidth: oldWidth,
	        rotatedHeight: oldHeight
	      });
	    }
	  }, {
	    key: 'rotateCircle',
	    value: function rotateCircle() {
	      var _this7 = this;
	
	      var image = _extends({}, this.state.image);
	      if (image.image.rotation === 3) {
	        image.image.rotation = 0;
	      } else {
	        image.image.rotation = image.image.rotation + 1;
	      }
	      this.rotateBase64(image.image.base64).then(function (base64image) {
	        setTimeout(function () {
	          _this7.rotateCircleWithImage();
	        }, 1);
	        image.image.ImageSize.Width = _this7.refs.circleImageItem.getBoundingClientRect().width;
	        image.image.ImageSize.Height = _this7.refs.circleImageItem.getBoundingClientRect().height;
	        image.image.base64 = base64image;
	        image.image.circles = _this7.state.circles;
	        _this7.setState({
	          image: image,
	          rotateCircles: true
	        });
	      }, function () {
	        window.toastr.error(_this7.t('2233'), _this7.t('216'));
	      });
	    }
	  }, {
	    key: 'renderCircle',
	    value: function renderCircle(circle, index) {
	      var style = {
	        WebkitTransform: 'scale(' + circle.scale + ')',
	        top: circle.top + 'px',
	        left: circle.left + 'px'
	      };
	      if (circle.active) {
	        return _react2.default.createElement('div', {
	          style: style,
	          key: index,
	          className: 'mark activemark' });
	      } else {
	        return _react2.default.createElement('div', {
	          style: style,
	          key: index,
	          className: 'mark inactivemark noselect',
	          draggable: 'true' });
	      }
	    }
	  }, {
	    key: 'renderSlider',
	    value: function renderSlider() {
	      var _this8 = this;
	
	      if (this.state.circles.length === 0 || !this.state.sliderOpened) return null;
	      var onSlide = function onSlide(size) {
	        var circles = _this8.state.circles;
	        if (circles[circles.length - 1].active) {
	          circles[circles.length - 1].scale = size;
	          _this8.setState({
	            circles: circles
	          });
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'sliderDiv' },
	        _react2.default.createElement(_reactRangeslider2.default, {
	          min: 0.5,
	          max: 3,
	          step: 0.1,
	          value: this.state.circles[this.state.circles.length - 1].scale,
	          orientation: 'vertical',
	          reverse: true,
	          tooltip: false,
	          onChange: onSlide
	        })
	      );
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(icon) {
	      return _react2.default.createElement(_icon2.default, {
	        size: 's',
	        icon: icon,
	        injectSvg: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          image = _state.image,
	          circles = _state.circles;
	
	      if (typeof image.image === 'undefined') return null;
	      // Drag image disable
	      var onDragImage = function onDragImage(e) {
	        e.preventDefault();
	        return false;
	      };
	      // Rotation class
	      var rotationClass = 'rotation-' + image.image.rotation;
	
	      var buttonSize = '';
	      // if ((!this.state.sliderOpened) && !isTouchDevice()) buttonSize = 'newSize'
	
	      var mobileClass = 'mobilePic';
	      return _react2.default.createElement(
	        'div',
	        null,
	        (0, _detect.isTouchDevice)() ? _react2.default.createElement(
	          'div',
	          { className: 'touch' },
	          _react2.default.createElement(
	            'div',
	            { className: 'four_buttons' },
	            _react2.default.createElement(_button2.default, { onClick: this.rotateCircle, style: 'link', labelText: this.renderIcon(_icons.MarkImageIcons.Rotate), size: 'm' }),
	            _react2.default.createElement('div', { className: 'photodivider' }),
	            _react2.default.createElement(_button2.default, { onClick: this.addCircle, style: 'link', labelText: this.renderIcon(_icons.MarkImageIcons.Add_Phone), size: 'm' }),
	            _react2.default.createElement(_button2.default, { onClick: this.clearCircles, style: 'link', labelText: this.renderIcon(_icons.MarkImageIcons.Delete), size: 'm' }),
	            _react2.default.createElement('div', { className: 'photodivider' }),
	            _react2.default.createElement(_button2.default, { onClick: this.submitImage, style: 'link', labelText: this.renderIcon(_icons.MarkImageIcons.Approve), size: 'm' }),
	            _react2.default.createElement(_button2.default, { onClick: this.onCircleImageClose, style: 'link', labelText: this.renderIcon(_icons.MarkImageIcons.Close), size: 'm' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { ref: 'image_wrap', className: 'image_wrap ' + mobileClass },
	            _react2.default.createElement(
	              'div',
	              { id: 'pnlDamagePhoto', className: rotationClass, ref: 'pnlDamagePhoto' },
	              _react2.default.createElement('img', { id: 'circleImageItem', src: image.image.base64, ref: 'circleImageItem', className: 'noselect ' + rotationClass, onDrag: onDragImage, onDragStart: onDragImage, draggable: 'false' }),
	              circles.map(this.renderCircle)
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'circle__image addOrderPopup clearfix ' + rotationClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'four_buttons ' + buttonSize },
	            _react2.default.createElement(_button2.default, { onClick: this.rotateCircle, 'aria-label': this.t('15047'), style: 'link', labelText: this.renderIcon(_icons.MarkImageIcons.Rotate) }),
	            _react2.default.createElement('div', { className: 'photodivider' }),
	            _react2.default.createElement(_button2.default, { onClick: this.addCircle, 'aria-label': this.t('15048'), style: 'link', labelText: this.renderIcon(_icons.MarkImageIcons.Add_PC) }),
	            _react2.default.createElement(_button2.default, { onClick: this.clearCircles, 'aria-label': this.t('15049'), style: 'link', labelText: this.renderIcon(_icons.MarkImageIcons.Delete) }),
	            _react2.default.createElement('div', { className: 'photodivider' }),
	            _react2.default.createElement(_button2.default, { onClick: this.submitImage, 'aria-label': this.t('15050'), style: 'link', labelText: this.renderIcon(_icons.MarkImageIcons.Approve) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'circle__image__img-section' },
	            this.renderSlider(),
	            _react2.default.createElement(
	              'div',
	              { ref: 'image_wrap', className: 'image_wrap' },
	              _react2.default.createElement(
	                'div',
	                { id: 'pnlDamagePhoto', className: rotationClass, ref: 'pnlDamagePhoto' },
	                _react2.default.createElement('img', { id: 'circleImageItem', src: image.image.base64, ref: 'circleImageItem', className: 'noselect ' + rotationClass, onDrag: onDragImage, onDragStart: onDragImage, draggable: 'false' }),
	                circles.map(this.renderCircle)
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 't',
	    value: function t(val) {
	      if (_typeof(this.context) !== undefined && typeof _helpers.translation !== 'undefined') {
	        return (0, _helpers.translation)(val);
	      }
	      return this.props.t(val);
	    }
	  }]);
	
	  return CircleImage;
	}(_react.Component);
	
	exports.default = CircleImage;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1517);
	
	var _notes = __webpack_require__(114);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _array = __webpack_require__(205);
	
	var _constants = __webpack_require__(5);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var Comment = function (_Component) {
	  _inherits(Comment, _Component);
	
	  function Comment(props) {
	    _classCallCheck(this, Comment);
	
	    var _this = _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).call(this, props));
	
	    _this.isSaving = false;
	
	    _this.state = {
	      order: props.order !== undefined && props.order !== null ? props.order : null,
	      note: {
	        Note: '',
	        OrderPrices: [],
	        DeviationId: 0,
	        OrderID: 0,
	        NoteTypeID: 0,
	        ApplyToInvoice: false,
	        ShowToCustomer: false,
	        ShowToPaintShop: false
	      },
	      hasChanged: false
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.createSave = _this.createSave.bind(_this);
	    _this.ensureSaved = _this.ensureSaved.bind(_this);
	    return _this;
	  }
	
	  _createClass(Comment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	
	      if (this.props.onRef) {
	        this.props.onRef(this.ensureSaved);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      if (_typeof(next.order) !== 'object') return;
	
	      var comment = next.comment || {};
	
	      this.setState({
	        order: next.order,
	        note: _extends({}, this.state.note, comment)
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      var value = e.target.value;
	      var extra = {};
	
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	        if (e.target.name === 'NoteTypeID') {
	          value = value ? 1 : 0;
	        }
	      }
	
	      if (e.target.name === 'ShowToCustomer' && !value) {
	        extra.ShowToPaintShop = false;
	      }
	
	      this.setState({
	        note: _extends({}, this.state.note, _defineProperty({}, e.target.name, value), extra),
	        hasChanged: true
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this2.createSave(e, true);
	        }
	      });
	    }
	  }, {
	    key: 'ensureSaved',
	    value: function ensureSaved() {
	      var _this3 = this;
	
	      var wait = function wait(until, doAfter) {
	        if (until() === true) return doAfter();
	
	        setTimeout(function () {
	          wait(until, doAfter);
	        }, 100);
	      };
	
	      if (this.state.hasChanged && !this.isSaving) {
	        return this.createSave();
	      } else {
	        // Wait until it is done saving
	        return new Promise(function (resolve) {
	          wait(function () {
	            return !_this3.isSaving;
	          }, function () {
	            return resolve();
	          });
	        });
	      }
	    }
	  }, {
	    key: 'createSave',
	    value: function createSave(e, fromCheckbox) {
	      var _this4 = this;
	
	      this.isSaving = true;
	      return new Promise(function (resolve) {
	        var note = _this4.state.note;
	
	        if ((note.NoteID === 0 || note.NoteID === undefined) && fromCheckbox === true) return null;
	        note.OrderID = _this4.state.order.Id;
	        if (typeof _this4.props.orderPriceId === 'number') {
	          if (note.OrderPrices === null) note.OrderPrices = [];
	          note.OrderPrices.push(_this4.props.orderPriceId);
	        }
	        if (typeof _this4.props.deviationId === 'number') note.DeviationId = _this4.props.deviationId;
	        if (typeof _this4.props.changeSource === 'number') note.SourceID = _this4.props.changeSource;
	
	        if (note.SourceID === 19) {
	          note.ReturnType = 1;
	        }
	
	        if (typeof note.Note !== 'string') {
	          note.Note = note.Note.join('\n');
	        }
	
	        _this4.props.createNote(note).then(function (res) {
	          var newNote = res.data;
	
	          if (_this4.props.setComment) {
	            _this4.props.setComment(newNote).then(function () {
	              resolve();
	              _this4.isSaving = false;
	            });
	          } else {
	            resolve();
	            _this4.isSaving = false;
	          }
	          _this4.setState({
	            note: newNote
	          });
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('1917'), (0, _helpers.translation)('216'));
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      if (!this.state.order) return null;
	      var transferDeviation = this.props.transferDeviation;
	
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var isInternalDeviation = this.props.changeSource === 9;
	      var isBodyShop = this.props.auth.departmentType === _constants.DepartmentType.Body;
	      var isReferred = this.state.order.IsReferredIn || this.state.order.IsReferredOut;
	      var isReferredBody = isBodyShop && isReferred;
	      var disableTransferToInvoice = true;
	      if (transferDeviation === undefined || transferDeviation === null || transferDeviation) disableTransferToInvoice = false;
	
	      var renderOptions = function renderOptions() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'comment_options' },
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)(isBodyShop ? 17874 : 17857), id: 'Comment_ShowToCustomer', name: 'ShowToCustomer', onChange: _this5.onChange, checked: _this5.state.note.ShowToCustomer }),
	          (isBodyShop || (0, _auth.hasAccess)([6], _this5.props.auth.user.UserType)) && _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)(isBodyShop ? 17875 : 17858), disabled: isReferredBody && !_this5.state.note.ShowToCustomer, id: 'Comment_ShowToPaintShop', name: 'ShowToPaintShop', onChange: _this5.onChange, checked: _this5.state.note.ShowToPaintShop }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('1785'), id: 'Comment_TransferToInvoice', name: 'ApplyToInvoice', onChange: _this5.onChange, checked: _this5.state.note.ApplyToInvoice, disabled: disableTransferToInvoice })
	        );
	      };
	
	      // Render
	      return _react2.default.createElement(
	        'div',
	        { className: 'price_comments' },
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('149') }),
	        _react2.default.createElement(_textarea2.default, { name: 'Note', onBlur: this.createSave, value: (0, _array.formatArrayToString)(this.state.note.Note), onChange: this.onChange }),
	        !isCustomer && !isInternalDeviation && renderOptions(),
	        this.state.order.IsEvaluated && this.props.renderEval && _react2.default.createElement(
	          'div',
	          { className: 'whoDiditBox' },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('372'),
	            ' ',
	            (0, _time.renderFullDate)(this.state.order.IsEvaluatedDate)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('763'),
	            ' ',
	            this.state.order.IsEvaluatedBy
	          )
	        )
	      );
	    }
	  }]);
	
	  return Comment;
	}(_react.Component);
	
	Comment.PropTypes = {
	  changeSource: _react2.default.PropTypes.number.isRequired,
	  order: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createNote: _notes.createNote
	})(Comment);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1526);
	
	var _constants = __webpack_require__(5);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _PhotoMarkModal = __webpack_require__(1103);
	
	var _PhotoMarkModal2 = _interopRequireDefault(_PhotoMarkModal);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Modals
	
	
	// Elements
	
	// import Grid from '../../../elements/grid'
	
	
	var Photo = function (_Component) {
	  _inherits(Photo, _Component);
	
	  function Photo(props) {
	    _classCallCheck(this, Photo);
	
	    var _this = _possibleConstructorReturn(this, (Photo.__proto__ || Object.getPrototypeOf(Photo)).call(this, props));
	
	    _this.state = {
	      price: _this.props.orderPrice !== undefined ? _this.props.orderPrice : null,
	      order: _this.props.order !== undefined ? _this.props.order : null,
	      confirmImage: false,
	      upload: {
	        errors: []
	      },
	      addedImages: [],
	      selectedImages: {}
	    };
	    _this.isCheckCalling = false;
	
	    _this.ensureFileContainer = _this.ensureFileContainer.bind(_this);
	    _this.onDropAccepted = _this.onDropAccepted.bind(_this);
	    _this.checkboxChange = _this.checkboxChange.bind(_this);
	    _this.markExisting = _this.markExisting.bind(_this);
	    _this.doUpload = _this.doUpload.bind(_this);
	    return _this;
	  }
	
	  _createClass(Photo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      if (_typeof(next.orderPrice) !== 'object' || _typeof(next.order) !== 'object') return;
	
	      // Prevent removing added images when old order data is received in props.
	      if (this.state.order !== undefined && this.state.order !== null && this.state.order.OrderFiles !== null && (next.order.OrderFiles === null || next.order.OrderFiles.length !== this.state.order.OrderFiles.length)) return;
	
	      var order = this.state.order;
	      var price = this.state.price;
	      if (_typeof(next.orderPrice) === 'object') {
	        price = next.orderPrice;
	      }
	
	      if (order !== null && order.OrderFiles !== null && price !== null && price.Files !== null) {
	        this.markExisting(order.OrderFiles, price.Files);
	      }
	
	      this.setState({
	        order: order,
	        price: price
	      });
	    }
	  }, {
	    key: 'markExisting',
	    value: function markExisting(markIn, lookIn) {
	      var fromOrder = markIn;
	      var fromPrice = lookIn;
	
	      if (fromOrder !== null && fromOrder.length > 0 && fromPrice !== null && fromPrice.length > 0) {
	        var _loop = function _loop(o) {
	          if (fromPrice.findIndex(function (file) {
	            return file.OrderFileID === fromOrder[o].OrderFileID;
	          }) !== -1) {
	            fromOrder[o].newFile = true;
	          }
	        };
	
	        for (var o = 0; o < fromOrder.length; o++) {
	          _loop(o);
	        }
	      }
	    }
	  }, {
	    key: 'checkboxChange',
	    value: function checkboxChange(e) {
	      // in some cases this triggers multiple times at the same time. Only allow one call to enter at a time,
	      if (this.isCheckCalling) return;
	      this.isCheckCalling = true;
	
	      var input = e.target;
	      if (e.target.tagName === 'DIV') {
	        // if div click
	        input = e.target.children[0];
	        input.checked = !input.checked;
	      } else if (e.target.tagName === 'B') {
	        // if b click
	        input = e.target.parentElement.children[0];
	        input.checked = !input.checked;
	      }
	
	      this.setState({
	        selectedImages: _extends({}, this.state.selectedImages, _defineProperty({}, e.target.id, e.target.checked))
	      }, function () {
	        // console.log('selectedImages', this.state.selectedImages)
	      });
	
	      var selected = [];
	      var inp = document.getElementsByTagName('input');
	      for (var i = 0; i < inp.length; i++) {
	        if (inp[i].name === 'checkbox_image' && inp[i].checked === true) {
	          selected.push({
	            OrderFileID: inp[i].id
	          });
	        }
	      }
	      var price = this.state.price;
	
	      price.SelectedOldFiles = selected;
	
	      var type = 5;
	      if (price.IsEvaluation) type = 6;
	      if (price.IsInternalDeviation) type = 2;
	      if (price.IsExternalDeviation) type = 3;
	      if (price.IsAfterEvaluation) type = 4;
	
	      var typeId = price.OrderPriceId;
	      if (type === 2 || type === 3) {
	        typeId = price.Deviations[0].DeviationId;
	      }
	
	      var fileIds = selected.map(function (s) {
	        return s.OrderFileID;
	      });
	
	      this.props.UpdateOrderFileSelection({
	        OrderFileIds: fileIds,
	        Type: type,
	        TypeId: typeId
	      });
	
	      this.isCheckCalling = false;
	    }
	  }, {
	    key: 'renderImages',
	    value: function renderImages() {
	      var _this2 = this;
	
	      if (!this.state.order) return null;
	
	      var renderImage = function renderImage(image, index) {
	        if (!image.IsImage) return null;
	        var deleteFile = function deleteFile() {
	          _this2.setState({
	            confirmImage: image
	          });
	        };
	
	        var isOlFile = false; // = this.state.price.Deviations[0] && this.state.price.Deviations[0].DeviationFiles.filter(x => x.OrderFile.OrderFileID === image.OrderFileID).length === 1
	        if (image.newFile === true || isOlFile) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'span',
	                { className: 'delete' },
	                _react2.default.createElement(_removeButton2.default, { size: 's', onClick: deleteFile })
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: image.FileURL, 'data-lightbox': 'gallery_2' },
	                _react2.default.createElement('img', { className: 'testImg', id: image.OrderFileID, name: 'oldImages', src: image.ThumbURL })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'divCheckbox' },
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('1218'), id: image.OrderFileID, name: 'checkbox_image', checked: true, readOnly: true })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'a',
	                { href: image.FileURL, 'data-lightbox': 'gallery_2' },
	                _react2.default.createElement('img', { className: 'testImg' + (!_this2.state.price.SelectedOldFiles || _this2.state.price.SelectedOldFiles.indexOf(function (x) {
	                    return x.OrderFileID === image.OrderFileID;
	                  }) === -1 ? ' faded' : ''), id: image.OrderFileID, name: 'oldImages', src: image.ThumbURL })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'divCheckbox', onClick: _this2.checkboxChange },
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('1218'), id: image.OrderFileID, name: 'checkbox_image', onChange: _this2.checkboxChange, checked: _this2.state.selectedImages[image.OrderFileID] === true })
	            )
	          );
	        }
	      };
	
	      // Return
	      return _react2.default.createElement(_Gallery2.default, { files: this.state.order.OrderFiles, renderImage: renderImage });
	    }
	  }, {
	    key: 'closePhotoMarkModal',
	    value: function closePhotoMarkModal(update) {
	      var _this3 = this;
	
	      this.props.triggerPopup(false);
	      this.setState({
	        photomark: _extends({}, this.state.photomark, {
	          open: false
	        })
	      }, function () {
	        if (update) {
	          if (_this3.props.deviation === false) {
	            _this3.props.getOrder(_this3.props.order.Id); // get workcard again to display added markings.
	          }
	          _this3.setState({
	            imageKey: Math.random()
	          });
	        }
	      });
	    }
	  }, {
	    key: 'ensureFileContainer',
	    value: function ensureFileContainer() {
	      var _this4 = this;
	
	      var orderPriceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var deviationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (this.state.fileContainerId === undefined || this.state.fileContainerId === null) {
	        return this.props.createFileContainer(orderPriceId, deviationId).then(function (res) {
	          _this4.setState({
	            fileContainerId: res.data.FileContainerId
	          });
	        });
	      } else {
	        return Promise.resolve();
	      }
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      var type = 11;
	      if (this.state.price.IsAfterEvaluation) type = 2;
	      if (this.state.price.IsEvaluation) type = 3;
	      if (this.state.price.IsInternalDeviation) type = 7;
	      if (this.state.price.IsExternalDeviation) type = 8;
	      if (this.state.price.IsOtherDamage) type = 16;
	
	      return type;
	    }
	  }, {
	    key: 'doUpload',
	    value: function doUpload(files) {
	      var _this5 = this;
	
	      var priceObj = _extends({}, this.state.price);
	      var type = this.getType();
	      var isDeviation = [7, 8].includes(type);
	
	      var orderPriceId = priceObj.OrderPriceId;
	      var deviationId = null;
	      if (isDeviation) {
	        orderPriceId = null;
	        deviationId = priceObj.Deviations[0].DeviationId;
	      }
	
	      return new Promise(function (resolve, reject) {
	        _this5.ensureFileContainer(orderPriceId, deviationId).then(function () {
	          var fileContainerId = _this5.state.fileContainerId;
	          _this5.props.uploadMultipleFiles(files, _this5.state.order.Id, type, priceObj.OrderPriceId, fileContainerId).then(function (res) {
	            if (isDeviation) {
	              // Save file to deviations
	              res.data.map(function (uplVal) {
	                priceObj.Deviations[0].DeviationFiles.push({
	                  FileName: uplVal.ActualFileName,
	                  DeviationId: priceObj.Deviations[0].DeviationId,
	                  OrderFile: uplVal
	                });
	              });
	              _this5.setState({
	                price: priceObj
	              }, function () {
	                _this5.props.saveOrderPrice(_this5.state.price).then(function () {
	                  // this.props.loadOrder(true)
	                  resolve(res);
	                });
	              });
	              return;
	            } else {
	              // Not deviation
	              resolve(res);
	            }
	          }, function (err) {
	            reject(err);
	          });
	        });
	      });
	    }
	  }, {
	    key: 'onDropAccepted',
	    value: function onDropAccepted(files) {
	      var _this6 = this;
	
	      this.doUpload(files).then(function (res) {
	        var images = [].concat(_toConsumableArray(_this6.state.order.OrderFiles));
	        res.data.forEach(function (orderFile) {
	          images.push({
	            FileURL: _constants.FILE_STORAGE + orderFile.RealFileURL,
	            ThumbURL: _constants.FILE_STORAGE + orderFile.RealThumbURL,
	            OrderFileID: orderFile.OrderFileID,
	            IsImage: true,
	            newFile: true
	          });
	        }, _this6);
	
	        _this6.setState({
	          order: _extends({}, _this6.state.order, {
	            OrderFiles: images
	          })
	        });
	      }, function (err) {
	        // Upload failed error
	        console.log('upload err', err);
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onDropRejected',
	    value: function onDropRejected(files) {
	      var newErrors = [];
	      files.map(function (val, index) {
	        newErrors.push((0, _helpers.translation)('1207') + ': ' + val.name + ' ' + (0, _helpers.translation)('13405') + '.');
	      });
	      this.setState({ upload: { errors: newErrors } });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var isMultipleUpload = true;
	
	      // Confirm
	      var onPortalClose = function onPortalClose() {
	        _this7.setState({
	          confirmImage: false
	        });
	      };
	      var onConfirm = function onConfirm() {
	        _this7.props.deleteDeviationFileFromOrder(_this7.state.confirmImage).then(function (res) {
	          for (var i = 0; i < _this7.state.order.OrderFiles.length; i++) {
	            if (_this7.state.order.OrderFiles[i].OrderFileID === _this7.state.confirmImage.OrderFileID) {
	              _this7.state.order.OrderFiles.splice(i, 1);
	              i--;
	            }
	          }
	          onPortalClose();
	        }, function () {
	          onPortalClose();
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('1918'), (0, _helpers.translation)('216'));
	        });
	      };
	
	      var renderError = function renderError(error, index) {
	        return _react2.default.createElement(
	          'p',
	          { key: index },
	          error
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'price_photo' },
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('1011') }),
	        this.state.upload.errors.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.state.upload.errors.map(renderError)
	        ),
	        _react2.default.createElement(
	          _Dropzone2.default,
	          {
	            onDrop: function onDrop() {
	              _this7.setState({ upload: { errors: [] } });
	            },
	            onDropAccepted: this.onDropAccepted,
	            onDropRejected: this.onDropRejected.bind(this),
	            multiple: isMultipleUpload,
	            includeCircles: false },
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)('13397')
	          )
	        ),
	        this.renderImages(),
	        this.state.confirmImage !== false && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onPortalClose })
	        ),
	        false && this.state.photomark.open && _react2.default.createElement(_PhotoMarkModal2.default, {
	          show: this.state.photomark.open,
	          image: this.state.photomark.image,
	          onClose: this.closePhotoMarkModal.bind(this) })
	      );
	    }
	  }]);
	
	  return Photo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  deleteDeviationFileFromOrder: _orders.deleteDeviationFileFromOrder,
	  createFileContainer: _orders.createFileContainer,
	  uploadMultipleFiles: _orders.uploadMultipleFiles,
	  UpdateOrderFileSelection: _orders.UpdateOrderFileSelection
	})(Photo);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1574);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Avatar = function (_Component) {
	  _inherits(Avatar, _Component);
	
	  function Avatar() {
	    _classCallCheck(this, Avatar);
	
	    return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
	  }
	
	  _createClass(Avatar, [{
	    key: 'getSize',
	    value: function getSize() {
	      switch (this.props.size) {
	        case 't':
	          return ' size-tiny';
	        case 's':
	          return ' size-small';
	        default:
	        case 'm':
	          return ' size-medium';
	        case 'l':
	          return ' size-large';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          initials = _props.initials,
	          status = _props.status;
	
	
	      var ariaClass = '';
	      if (this.props.ariaText !== null && !this.props.useHtmlTitleTag) {
	        ariaClass = ' hint--' + this.props.ariaPos;
	      }
	
	      var titleText = null;
	      var ariaText = this.props.ariaText;
	      /*
	      this.props.useHtmlTitleTag
	      useHtmlTitleTag define to use html standard title tag to show on mouse over instead of aria-label
	      */
	      if (this.props.useHtmlTitleTag) {
	        titleText = this.props.ariaText;
	        ariaText = null;
	      }
	
	      var classNames = 'avatar' + this.getSize();
	      if (this.props.disabled) classNames += ' disabled';
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames + ariaClass, 'aria-label': ariaText, title: titleText },
	        _react2.default.createElement(
	          'span',
	          { className: 'avatar__content' },
	          initials
	        ),
	        status && _react2.default.createElement('i', { className: 'avatar__status' })
	      );
	    }
	  }]);
	
	  return Avatar;
	}(_react.Component);
	
	Avatar.defaultProps = {
	  initials: null,
	  status: null,
	  disabled: false,
	  ariaText: null,
	  ariaPos: 'left',
	  useHtmlTitleTag: false
	};
	
	exports.default = Avatar;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _arrowButton = __webpack_require__(200);
	
	var _arrowButton2 = _interopRequireDefault(_arrowButton);
	
	__webpack_require__(1575);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackButton = function (_Component) {
	  _inherits(BackButton, _Component);
	
	  function BackButton() {
	    _classCallCheck(this, BackButton);
	
	    return _possibleConstructorReturn(this, (BackButton.__proto__ || Object.getPrototypeOf(BackButton)).apply(this, arguments));
	  }
	
	  _createClass(BackButton, [{
	    key: 'render',
	    value: function render() {
	      var buttonProps = _extends({}, this.props);
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-backbutton' },
	        _react2.default.createElement(_arrowButton2.default, _extends({}, buttonProps, { dir: 'left' }))
	      );
	    }
	  }]);
	
	  return BackButton;
	}(_react.Component);
	
	BackButton.defaultProps = {
	  size: 'l',
	  style: 'link',
	  round: true,
	  spacing: 0
	};
	
	BackButton.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = BackButton;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Does absolutely nothing! except preventing child components from rendering
	// Can be used as an inline comment-out feature.
	var Null = function (_Component) {
	  _inherits(Null, _Component);
	
	  function Null() {
	    _classCallCheck(this, Null);
	
	    return _possibleConstructorReturn(this, (Null.__proto__ || Object.getPrototypeOf(Null)).apply(this, arguments));
	  }
	
	  _createClass(Null, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Null;
	}(_react.Component);
	
	exports.default = Null;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _orders = __webpack_require__(21);
	
	__webpack_require__(1637);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _CircleImage = __webpack_require__(231);
	
	var _CircleImage2 = _interopRequireDefault(_CircleImage);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Evaluation = __webpack_require__(291);
	
	var _Evaluation2 = _interopRequireDefault(_Evaluation);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	
	
	// import components
	
	
	// Elements
	
	
	var CreateEstimationModal = function (_Component) {
	  _inherits(CreateEstimationModal, _Component);
	
	  function CreateEstimationModal(props) {
	    _classCallCheck(this, CreateEstimationModal);
	
	    var _this = _possibleConstructorReturn(this, (CreateEstimationModal.__proto__ || Object.getPrototypeOf(CreateEstimationModal)).call(this, props));
	
	    _this.state = _this.resetState(props);
	    _this.createEstimation = _this.createEstimation.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.submitImage = _this.submitImage.bind(_this);
	
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onDropAccepted = _this.onDropAccepted.bind(_this);
	    _this.onDropRejected = _this.onDropRejected.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(CreateEstimationModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState(this.resetState(this.props));
	      var images = this.state.images;
	
	      var id = this.props.id;
	      if (id === undefined) id = this.props.orderId;
	
	      this.props.getOrderFiles(id, 1).then(function (res) {
	        res.data.forEach(function (element) {
	          images.push({
	            imagePath: _constants.FILE_STORAGE + element.FileURL,
	            thumbPath: _constants.FILE_STORAGE + element.ThumbURL,
	            OrderFileID: element.OrderFileID
	          });
	        }, _this2);
	        _this2.setState({
	          images: images
	        });
	      });
	    }
	  }, {
	    key: 't',
	    value: function t(val) {
	      if (typeof _helpers.translation !== 'undefined') {
	        return (0, _helpers.translation)(val);
	      }
	      return this.props.t(val);
	    }
	  }, {
	    key: 'resetState',
	    value: function resetState(setState) {
	      var newState = {
	        confirm: false,
	        isLoading: false,
	        tabView: 'step1',
	        images: [],
	        files: [],
	        upload: {
	          shouldCapture: true,
	          errors: []
	        },
	        selectedImages: {},
	        activeImage: {},
	        orderId: this.props.orderId !== undefined ? this.props.orderId : -1,
	        rejections: [],
	        overflowHidden: false,
	        Estimation_comment: ''
	      };
	      return newState;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // with "mapStateToProps" on newWorkCard having state.common, is hitting componentWillReceiveProps at every click
	      // this.setState(this.resetState(nextProps))
	    }
	  }, {
	    key: 'createEstimation',
	    value: function createEstimation(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      this.setState({ isLoading: true });
	
	      var createEstimation = function createEstimation(files) {
	        if (files === undefined || files.length === 0) {
	          window.toastr.error((0, _helpers.translation)('13014'), (0, _helpers.translation)('216'));
	          _this3.setState({
	            isLoading: false
	          });
	          return null;
	        }
	        var returnOrder = false;
	        if (_this3.props.returnOrder !== undefined && _this3.props.returnOrder) {
	          returnOrder = true;
	        }
	        var data = {
	          OrderId: _this3.state.orderId > 0 ? _this3.state.orderId : _this3.props.id,
	          Case: {
	            Comment: _this3.state.Estimation_comment
	          },
	          ImageTypes: files,
	          ReturnOrder: returnOrder
	        };
	        _this3.props.createOrderEstimation(data).then(function (res) {
	          // console.log('CreateEstimationModal props', this.props)
	          if (_this3.props.onSave !== undefined) {
	            _this3.props.onSave(res.data);
	          }
	
	          // if (this.props.onClose !== undefined) {
	          //   this.props.onClose()
	          // }
	          _this3.props.onClose();
	          // Toastr
	          // window.toastr.success(translation('2235'), translation('13424'))
	          // Redirect
	          // let id = this.state.orderId > 0 ? this.state.orderId : this.props.id
	          // this.props.router.push('/orders/' + id)
	        }, function () {
	          _this3.setErrors({
	            isLoading: false
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('2236'), (0, _helpers.translation)('216'));
	        });
	      };
	
	      var finishedFiles = [];
	      var inputs = document.getElementsByTagName('input');
	      for (var i = 0; i < inputs.length; i++) {
	        if (inputs[i].name === 'checkbox_image' && inputs[i].checked === true) {
	          finishedFiles.push({
	            OrderFileId: inputs[i].id
	          });
	        }
	      }
	      if (finishedFiles === 0 && this.state.files.length === 0) {
	        createEstimation(finishedFiles);
	      } else {
	        var files = [].concat(_toConsumableArray(this.state.images)).concat(this.state.files);
	        var id = this.state.orderId > 0 ? this.state.orderId : this.props.id;
	        if (id === undefined) id = this.props.orderId;
	        this.props.uploadMultipleFiles(files, id).then(function (fileResponse) {
	          var uploadedFiles = fileResponse.data;
	          var imageMarkings = [];
	          uploadedFiles.map(function (val, index) {
	            finishedFiles.push({
	              OrderFileID: val.OrderFileID,
	              ImageType: 2
	            });
	            if (val.IsImage) {
	              var markings = [];
	              if (_this3.state.images[index] !== undefined && _this3.state.images[index].circles !== undefined) {
	                _this3.state.images[index].circles.map(function (circle, circleIdx) {
	                  markings.push({
	                    PositionX: circle.left,
	                    PositionY: circle.top,
	                    Scale: parseFloat(circle.scale.toFixed(2)),
	                    Size: 50
	                  });
	                });
	              }
	              if (markings.length !== 0) {
	                imageMarkings.push({
	                  ImageSize: _this3.state.images[index].ImageSize,
	                  OrderFileID: val.OrderFileID,
	                  Markings: markings
	                });
	              } else {
	                // console.log('add to files')
	                finishedFiles.push({
	                  OrderFileID: val.OrderFileID,
	                  ImageType: -1
	                });
	              }
	            }
	          });
	          if (imageMarkings.length !== 0) {
	            _this3.props.uploadImageMarkings(imageMarkings);
	          }
	          createEstimation(finishedFiles);
	        }, function () {
	          _this3.setErrors({
	            isLoading: false
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13440'), (0, _helpers.translation)('216'));
	        });
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      if (e.target.name === 'Estimation') {
	        if (!e.target.checked) {
	          e.target.value = '0';
	        }
	      }
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'renderStep1',
	    value: function renderStep1() {
	      var _this4 = this;
	
	      var errors = this.state.upload.errors;
	      // Render estimation comment
	
	      var renderEstimationComment = function renderEstimationComment() {
	        var comment = _this4.state.Estimation_comment;
	        return _react2.default.createElement(_textarea2.default, { name: 'Estimation_comment', onChange: _this4.onInputChange, value: comment, labelText: (0, _helpers.translation)('13364') });
	      };
	      var setEstimationComment = function setEstimationComment(comment) {
	        _this4.setState({
	          Estimation_comment: comment
	        });
	      };
	      // Render errors
	      var renderError = function renderError(error, index) {
	        return _react2.default.createElement(
	          'p',
	          { key: index },
	          error
	        );
	      };
	      // Render
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'clearfix' },
	          this.props.topMessage !== undefined && this.props.topMessage.length !== 0 && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.props.topMessage.map(renderError)
	          ),
	          errors.length !== 0 && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            errors.map(renderError)
	          ),
	          _react2.default.createElement(_Evaluation2.default, { orderId: this.props.id, noParts: true, noCompleted: true, setEstimationComment: setEstimationComment.bind(this) }),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('13719')
	          ),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          _react2.default.createElement(
	            _Dropzone2.default,
	            {
	              onDrop: this.onDrop,
	              onDropAccepted: this.onDropAccepted,
	              onDropRejected: this.onDropRejected,
	              includeCircles: true },
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)('13397')
	            )
	          ),
	          this.renderFiles(),
	          this.renderImages()
	        ),
	        renderEstimationComment()
	      );
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop() {
	      this.setState({ upload: _extends({}, this.state.upload, { errors: [] }) });
	    }
	  }, {
	    key: 'onDropAccepted',
	    value: function onDropAccepted(files) {
	      var _this5 = this;
	
	      var documents = [].concat(_toConsumableArray(this.state.files));
	      var images = this.state.images;
	      var addedImages = [];
	
	      // let id = this.state.orderId > 0 ? this.state.orderId : this.props.id
	      // if (id === undefined) id = this.props.orderId
	      // this.props.uploadMultipleFiles(files, id).then((fileResponse) => {
	      //   let uploadedFiles = fileResponse.data
	      //   let imageMarkings = []
	      //   uploadedFiles.map((val, index) => {
	      //     finishedFiles.push({
	      //       OrderFileID: val.OrderFileID,
	      //       ImageType: 2
	      //     })
	      //     if (val.IsImage) {
	      //       let markings = []
	      //       if (this.state.images[index] !== undefined && this.state.images[index].circles !== undefined) {
	      //         this.state.images[index].circles.map((circle, circleIdx) => {
	      //           markings.push({
	      //             PositionX: circle.left,
	      //             PositionY: circle.top,
	      //             Scale: parseFloat(circle.scale.toFixed(2)),
	      //             Size: 50
	      //           })
	      //         })
	      //       }
	      //       if (markings.length !== 0) {
	      //         imageMarkings.push({
	      //           ImageSize: this.state.images[index].ImageSize,
	      //           OrderFileID: val.OrderFileID,
	      //           Markings: markings
	      //         })
	      //       }
	      //     }
	      //   })
	      //   if (imageMarkings.length !== 0) {
	      //     this.props.uploadImageMarkings(imageMarkings)
	      //   }
	      // }
	
	      files.map(function (val) {
	        if (typeof val.file === 'undefined') {
	          documents.push(val);
	        } else {
	          addedImages.push(val);
	        }
	      });
	
	      images.map(function (val) {
	        if (typeof val.ImageSize === 'undefined') {
	          val.ImageSize = {
	            Width: 0,
	            Height: 0
	          };
	        }
	      });
	      this.props.DeleteExifData(addedImages).then(function (res) {
	        var k = images.length;
	        for (var i = 0; i < addedImages.length; i++) {
	          if (typeof addedImages[i].ImageSize === 'undefined') {
	            // var image = new Image()
	            // image.src = files[0].imageUrl
	            // image.onLoad((e) => {
	            //   console.log('image size', image.width, image.height)
	            // })
	            addedImages[i].ImageSize = {
	              Width: 0,
	              Height: 0
	            };
	          }
	          images.push(addedImages[i]);
	          images[k + i].imageUrl = res.data[i];
	        }
	        _this5.setState({
	          images: images,
	          files: documents
	        }, function () {
	          // console.log('images in state ', this.state)
	        });
	      });
	      // }, () => {
	
	      // })
	    }
	  }, {
	    key: 'onDropRejected',
	    value: function onDropRejected(files) {
	      var newErrors = [];
	      files.map(function (val, index) {
	        newErrors.push('File: ' + val.name + ' is not allowed.');
	      });
	      this.setState({ upload: _extends({}, this.state.upload, { errors: newErrors }) });
	    }
	  }, {
	    key: 'deleteImage',
	    value: function deleteImage(image, index) {
	      this.setState({
	        confirm: index
	      });
	    }
	  }, {
	    key: 'renderFiles',
	    value: function renderFiles() {
	      var _this6 = this;
	
	      var files = this.state.files;
	      var removeFile = function removeFile(index) {
	        var oldFiles = _this6.state.files;
	        // console.log('Remove file at index ', index)
	        var newFiles = [].concat(_toConsumableArray(oldFiles)).filter(function (item, i) {
	          // console.log('filter: ', i, '(' + index + ' = ' + i + ')')
	          return i !== index;
	        });
	
	        _this6.setState({
	          files: newFiles
	        });
	      };
	      var renderFile = function renderFile(file, index) {
	        if (file.file === null) return null;
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.name;
	
	        // let newFileUrl = API_URL + '/FileService/DownloadNoHeader?fileName=' + file.ActualFileName + '&token=' + this.props.auth.user.Token
	        // let thumbUrl = API_URL + '/FileService/DownloadNoHeader?fileName=' + file.ThumbURL + '&token=' + this.props.auth.user.Token
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-document clearfix' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          _react2.default.createElement(
	            'span',
	            null,
	            file.name
	          ),
	          _this6.props.auth.user.CustomerId === '-1' && _react2.default.createElement('img', { className: 'file-delete', src: '/images/icons/Delete_16.png', onClick: function onClick() {
	              return removeFile(index);
	            } })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'estimation_documents' },
	        files.map(renderFile)
	      );
	    }
	  }, {
	    key: 'renderRejectedImages',
	    value: function renderRejectedImages(rejectedImages) {
	      var renderRejectedImage = function renderRejectedImage(image, index) {
	        var url = _constants.API_BASE + image.ThumbURL;
	        var fullUrl = _constants.API_BASE + image.FileURL;
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-image' },
	          _react2.default.createElement(
	            'a',
	            { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	            _react2.default.createElement('img', { src: url })
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'estimation_images' },
	        _react2.default.createElement(_Gallery2.default, { files: rejectedImages, renderImage: renderRejectedImage })
	      );
	    }
	  }, {
	    key: 'renderImages',
	    value: function renderImages() {
	      var _this7 = this;
	
	      var imageCheckChange = function imageCheckChange(e) {
	        _this7.setState({ selectedImages: _extends({}, _this7.state.selectedImages, _defineProperty({}, e.target.id, e.target.checked)) });
	      };
	      var images = this.state.images;
	      // Render image
	
	      var renderImage = function renderImage(image, index) {
	        if (image.imageUrl !== undefined) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'div',
	                { className: 'delete' },
	                _react2.default.createElement(_removeButton2.default, _extends({}, _this7.props, { onClick: function onClick() {
	                    return _this7.deleteImage(image, index);
	                  }, size: 's' }))
	              ),
	              _react2.default.createElement('img', { className: 'img2', src: image.imageUrl, onClick: function onClick() {/* this.goToImage(image, index)} */} })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'divCheckbox' },
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: _this7.t('1218'), checked: 'true', contentEditable: 'false', name: 'checkbox_image' })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'a',
	                { href: image.imagePath, 'data-lightbox': 'gallery' },
	                _react2.default.createElement('img', { className: 'img3', id: image.OrderFileID, name: 'oldImages', src: image.thumbPath })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'divCheckbox' },
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: _this7.t('1218'), id: image.OrderFileID, name: 'checkbox_image', onChange: imageCheckChange, checked: _this7.state.selectedImages[image.OrderFileID] === true })
	            )
	          );
	        }
	      };
	      // Confirm
	      var onPortalClose = function onPortalClose() {
	        _this7.setState({
	          confirm: false
	        });
	      };
	      var onConfirm = function onConfirm() {
	        var images = [].concat(_toConsumableArray(_this7.state.images));
	        images.splice(_this7.state.confirm, 1);
	        _this7.setState({
	          confirm: false,
	          images: images
	        });
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'estimation_images' },
	        _react2.default.createElement(_Gallery2.default, { files: images, renderImage: renderImage }),
	        this.state.confirm !== false && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onPortalClose })
	        )
	      );
	    }
	  }, {
	    key: 'goToImage',
	    value: function goToImage(image, index) {
	      this.setState({
	        tabView: 'step2',
	        activeImage: {
	          image: image,
	          index: index
	        }
	      });
	    }
	  }, {
	    key: 'submitImage',
	    value: function submitImage(image) {
	      var images = [].concat(_toConsumableArray(this.state.images));
	      images[image.index] = image.image;
	      this.setState({
	        tabView: 'step1',
	        images: images
	      });
	    }
	  }, {
	    key: 'renderStep2',
	    value: function renderStep2() {
	      var _this8 = this;
	
	      var circleDrag = function circleDrag(active) {
	        _this8.setState({ overflowHidden: false });
	      };
	      return _react2.default.createElement(_CircleImage2.default, { submitImage: this.submitImage, image: this.state.activeImage, onDrag: circleDrag });
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      if (this.state.tabView === 'step2') {
	        this.setState({
	          tabView: 'step1'
	        });
	      } else {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var tabView = _react2.default.createElement('div', null);
	      var headerTitle = (0, _helpers.translation)('13363');
	      var bottomBarProps = null;
	
	      if (this.state.tabView === 'step1') {
	        tabView = this.renderStep1();
	        bottomBarProps = {
	          disabled: this.state.isLoading,
	          actionLabelText: (0, _helpers.translation)('27'),
	          onActionClick: this.createEstimation
	        };
	      } else if (this.state.tabView === 'step2') {
	        tabView = this.renderStep2();
	      }
	
	      var clickOutsideClose = false;
	      return _react2.default.createElement(
	        'div',
	        { className: 'createestimation__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: headerTitle,
	            overflowHidden: this.state.overflowHidden,
	            clickOutsideClose: clickOutsideClose,
	            onClose: this.onClose,
	            icon: _icons.ModalIcons.Estimation,
	            bottomBarProps: bottomBarProps
	          }),
	          tabView
	        )
	      );
	    }
	  }]);
	
	  return CreateEstimationModal;
	}(_react.Component);
	
	CreateEstimationModal.propTypes = {
	  createOrderEstimation: _propTypes2.default.func.isRequired,
	  uploadMultipleFiles: _propTypes2.default.func.isRequired,
	  hasSubscriptionPermission: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createOrderEstimation: _orders.createOrderEstimation,
	  uploadMultipleFiles: _orders.uploadMultipleFiles,
	  uploadImageMarkings: _orders.uploadImageMarkings,
	  hasSubscriptionPermission: _auth.hasSubscriptionPermission,
	  getRejectedEvaluations: _orders.getRejectedEvaluations,
	  getOrderFiles: _orders.getOrderFiles,
	  DeleteExifData: _orders.DeleteExifData
	})(CreateEstimationModal);

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _detect = __webpack_require__(102);
	
	__webpack_require__(1654);
	
	var _helpers = __webpack_require__(2);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _NewPaintDraft = __webpack_require__(1099);
	
	var _NewPaintDraft2 = _interopRequireDefault(_NewPaintDraft);
	
	var _NewBodyDraft = __webpack_require__(1098);
	
	var _NewBodyDraft2 = _interopRequireDefault(_NewBodyDraft);
	
	var _icons = __webpack_require__(6);
	
	var _orders = __webpack_require__(21);
	
	var _language = __webpack_require__(139);
	
	var _common = __webpack_require__(25);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Utils
	
	
	// import components
	
	// import Button from '../../../shared/elements/button'
	
	
	// import Popup from '../../../shared/elements/popup'
	
	// Actions
	
	
	// Language
	
	
	// Redux
	
	
	// import popupHeader from '../../elements/popupHeader'
	
	var NewOrdersModal = function (_Component) {
	  _inherits(NewOrdersModal, _Component);
	
	  function NewOrdersModal(props) {
	    _classCallCheck(this, NewOrdersModal);
	
	    var _this = _possibleConstructorReturn(this, (NewOrdersModal.__proto__ || Object.getPrototypeOf(NewOrdersModal)).call(this, props));
	
	    _this.state = {
	      tabView: 'draft',
	      headerTitle: '14802',
	      onClose: _this.onClose,
	      overflowHidden: false,
	      bottomBarProps: {}
	    };
	
	    _this.uploadImageMarkings = _this.uploadImageMarkings.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    _this.redirectToOrder = _this.redirectToOrder.bind(_this);
	    _this.updateModal = _this.updateModal.bind(_this);
	    _this.onDraftCreated = _this.onDraftCreated.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewOrdersModal, [{
	    key: 'resetState',
	    value: function resetState(props) {
	      var newState = {
	        tabView: 'draft',
	
	        headerTitle: '14802',
	        onClose: this.onClose,
	        overflowHidden: false
	      };
	      return newState;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState(this.resetState());
	
	      // get resources if missing
	      var common = this.props.common;
	      if (common.phonecodes.length === 0 || common.brands.length === 0 || common.countries.length === 0) {
	        (0, _language.InitLanguage)().then(function (res) {
	          // Set translations
	          _store2.default.dispatch((0, _language.setTranslations)(res.translations));
	          _store2.default.dispatch((0, _language.setLanguages)(res.langs));
	
	          // Set rest
	          _store2.default.dispatch((0, _common.setPhoneCodes)(res.data.PhoneCodes));
	          _store2.default.dispatch((0, _common.setBrands)(res.data.Brands));
	          _store2.default.dispatch((0, _common.setEnums)(res.data.Enums));
	          _store2.default.dispatch((0, _common.setCountries)(res.data.Countries));
	
	          // Set user language
	          if (typeof window.localStorage.user_language !== 'undefined') {
	            _store2.default.dispatch((0, _language.setLanguage)(window.localStorage.user_language));
	          }
	        });
	      }
	    }
	
	    // componentWillReceiveProps (nextProps) {
	    //   if (!isEqual(nextProps, this.props)) {
	    //     this.setState(this.resetState(nextProps))
	    //   }
	    // }
	
	  }, {
	    key: 'uploadImageMarkings',
	    value: function uploadImageMarkings(images) {
	      var uploadedFiles = images;
	      var finishedFiles = [];
	      var imageMarkings = [];
	      var orderFileIds = [];
	
	      uploadedFiles.forEach(function (file) {
	        finishedFiles = [].concat(_toConsumableArray(finishedFiles), [{ OrderFileId: file.OrderFileID }]);
	        // orderFileIds.push(val.OrderFileID)
	
	        var markings = [];
	        if (file.circles !== undefined) {
	          markings = file.circles.map(function (circle) {
	            return {
	              PositionX: circle.left,
	              PositionY: circle.top,
	              Scale: parseFloat(circle.scale.toFixed(2)),
	              Size: 50
	            };
	          });
	        }
	        if (markings.length !== 0 || file.rotation) {
	          var img = {
	            ImageSize: file.ImageSize,
	            OrderFileID: file.OrderFileID,
	            Markings: markings,
	            Rotation: file.rotation
	          };
	          imageMarkings = [].concat(_toConsumableArray(imageMarkings), [img]);
	        }
	      });
	
	      var inputs = document.getElementsByTagName('input');
	      for (var i = 0; i < inputs.length; i++) {
	        if (inputs[i].name === 'checkbox_image' && inputs[i].checked === true) {
	          finishedFiles.push({
	            OrderFileId: inputs[i].id
	          });
	          orderFileIds.push(inputs[i].id);
	        }
	      }
	
	      if (imageMarkings.length !== 0) {
	        return this.props.uploadImageMarkings(imageMarkings);
	      } else {
	        return Promise.resolve();
	      }
	    }
	  }, {
	    key: 'redirectToOrder',
	    value: function redirectToOrder(orderId) {
	      this.props.onClose();
	      console.log('Redirect to order...', orderId, this.props.options);
	      var routeState = { createdNew: true };
	      if (this.props.options) {
	        routeState.assignments = [];
	        if (this.props.options.employee && this.props.options.steps) {
	          routeState.assignments.push({ userId: this.props.options.employee.UserId, steps: this.props.options.steps });
	        }
	        routeState.bookingDestination = this.props.options.bookingDestination;
	      }
	      console.log('RouteState: ', routeState);
	      // this.props.router.push('/orders/' + orderId)
	      this.props.router.push({
	        pathname: '/orders/' + orderId,
	        state: routeState
	      });
	    }
	  }, {
	    key: 'updateModal',
	    value: function updateModal(_ref) {
	      var tabView = _ref.tabView,
	          headerTitle = _ref.headerTitle,
	          onModalClose = _ref.onModalClose,
	          overflowHidden = _ref.overflowHidden,
	          bottomBarProps = _ref.bottomBarProps;
	
	      var data = {};
	
	      if (tabView) data.tabView = tabView;
	      if (headerTitle) data.headerTitle = headerTitle;
	      if (onModalClose) data.onClose = onModalClose;
	      // if (isCircleimageOpen) data.isCircleimageOpen = isCircleimageOpen
	      if (overflowHidden) data.overflowHidden = overflowHidden;
	      if (bottomBarProps) data.bottomBarProps = bottomBarProps;
	
	      this.setState(data);
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      if (this.state.tabView === 'image') {
	        this.setState({
	          tabView: 'draft'
	        });
	      } else {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'onDraftCreated',
	    value: function onDraftCreated(orderId) {
	      console.log('Draft created');
	      this.props.onDraftCreated && this.props.onDraftCreated(orderId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalClass = 'neworder__modal';
	      if ((0, _detect.isTouchDevice)() && this.props.bodyShop) {
	        modalClass = 'touch neworder__modal';
	      }
	      if (this.state.tabView === 'image') {
	        modalClass = 'circleimage_modal';
	      }
	
	      var draftProps = {
	        tabView: this.state.tabView,
	        uploadImageMarkings: this.uploadImageMarkings,
	        redirectToOrder: this.redirectToOrder,
	        modal: this.refs.modal,
	        updateModal: this.updateModal,
	        onModalClose: this.props.onClose,
	        router: this.props.router
	        // newOrderModalWidth: this.state.newOrderModalWidth
	      };
	      var view = void 0;
	      if (this.props.bodyShop) {
	        view = _react2.default.createElement(_NewBodyDraft2.default, _extends({}, draftProps, { carRentalDefaultInfo: this.props.carRentalDefaultInfo, options: this.props.options, onDraftCreated: this.onDraftCreated }));
	      } else {
	        view = _react2.default.createElement(_NewPaintDraft2.default, draftProps);
	      }
	
	      var bottomBarProps = null;
	      if (this.state.tabView === 'draft' || this.state.tabView === 'complaint') {
	        bottomBarProps = _extends({
	          disabled: function disabled(loading) {
	            return loading;
	          }
	        }, this.state.bottomBarProps);
	      }
	
	      // return (
	      //   <Popup popupId='newOrder' ref='modal'>
	      //     <popupHeader>{translation(this.state.headerTitle)}</popupHeader>
	      //     {view}
	      //   </Popup>
	      // )
	
	      return _react2.default.createElement(
	        'div',
	        { className: modalClass },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({ ref: 'modal' }, this.props, {
	            header: (0, _helpers.translation)(this.state.headerTitle),
	            overflowHidden: this.state.overflowHidden,
	            clickOutsideClose: false,
	            onClose: this.state.onClose,
	            icon: _icons.ModalIcons.Plus,
	            bottomBarProps: bottomBarProps
	          }),
	          view
	        )
	      );
	    }
	  }]);
	
	  return NewOrdersModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  uploadImageMarkings: _orders.uploadImageMarkings
	})(NewOrdersModal);

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(105);
	var toLength = __webpack_require__(72);
	var toAbsoluteIndex = __webpack_require__(163);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(44);
	var $export = __webpack_require__(10);
	var redefine = __webpack_require__(98);
	var redefineAll = __webpack_require__(161);
	var meta = __webpack_require__(142);
	var forOf = __webpack_require__(155);
	var anInstance = __webpack_require__(154);
	var isObject = __webpack_require__(49);
	var fails = __webpack_require__(47);
	var $iterDetect = __webpack_require__(245);
	var setToStringTag = __webpack_require__(180);
	var inheritIfRequired = __webpack_require__(317);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(97);
	var redefine = __webpack_require__(98);
	var fails = __webpack_require__(47);
	var defined = __webpack_require__(119);
	var wks = __webpack_require__(56);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(39);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(109);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(49);
	var cof = __webpack_require__(109);
	var MATCH = __webpack_require__(56)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(56)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(156) || !__webpack_require__(47)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(44)[K];
	});


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(10);
	var aFunction = __webpack_require__(88);
	var ctx = __webpack_require__(110);
	var forOf = __webpack_require__(155);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(10);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(44);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(39);
	var aFunction = __webpack_require__(88);
	var SPECIES = __webpack_require__(56)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(44);
	var hide = __webpack_require__(97);
	var uid = __webpack_require__(164);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1746),
	    listCacheDelete = __webpack_require__(1747),
	    listCacheGet = __webpack_require__(1748),
	    listCacheHas = __webpack_require__(1749),
	    listCacheSet = __webpack_require__(1750);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(532);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(524),
	    baseAssignValue = __webpack_require__(525);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1744);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(165);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(77);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.props.disableOnClickOutside) return;
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          var handlerOptions = null;
	          var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	          if (isTouchEvent && passiveEventSupport) {
	            handlerOptions = {
	              passive: !_this.props.preventDefault
	            };
	          }
	
	          document.addEventListener(eventName, handlersMap[_this._uid], handlerOptions);
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn);
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
	        }
	      }
	
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _memoizeOne = _interopRequireDefault(__webpack_require__(538));
	
	var _Menu = __webpack_require__(384);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(715));
	
	var _filters = __webpack_require__(713);
	
	var _index = __webpack_require__(1949);
	
	var _index2 = __webpack_require__(1933);
	
	var _utils = __webpack_require__(271);
	
	var _builtins = __webpack_require__(1940);
	
	var _index3 = __webpack_require__(385);
	
	var _styles = __webpack_require__(716);
	
	var _theme = __webpack_require__(717);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultProps = {
	  backspaceRemovesValue: true,
	  blurInputOnSelect: (0, _utils.isTouchCapable)(),
	  captureMenuScroll: !(0, _utils.isTouchCapable)(),
	  closeMenuOnSelect: true,
	  closeMenuOnScroll: false,
	  components: {},
	  controlShouldRenderValue: true,
	  escapeClearsValue: false,
	  filterOption: (0, _filters.createFilter)(),
	  formatGroupLabel: _builtins.formatGroupLabel,
	  getOptionLabel: _builtins.getOptionLabel,
	  getOptionValue: _builtins.getOptionValue,
	  isDisabled: false,
	  isLoading: false,
	  isMulti: false,
	  isRtl: false,
	  isSearchable: true,
	  isOptionDisabled: _builtins.isOptionDisabled,
	  loadingMessage: function loadingMessage() {
	    return 'Loading...';
	  },
	  maxMenuHeight: 300,
	  minMenuHeight: 140,
	  menuIsOpen: false,
	  menuPlacement: 'bottom',
	  menuPosition: 'absolute',
	  menuShouldBlockScroll: false,
	  menuShouldScrollIntoView: !(0, _utils.isMobileDevice)(),
	  noOptionsMessage: function noOptionsMessage() {
	    return 'No options';
	  },
	  openMenuOnFocus: false,
	  openMenuOnClick: true,
	  options: [],
	  pageSize: 5,
	  placeholder: 'Select...',
	  screenReaderStatus: function screenReaderStatus(_ref) {
	    var count = _ref.count;
	    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
	  },
	  styles: {},
	  tabIndex: '0',
	  tabSelectsValue: true
	};
	exports.defaultProps = defaultProps;
	var instanceId = 1;
	
	var Select =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Select, _Component);
	
	  // Misc. Instance Properties
	  // ------------------------------
	  // TODO
	  // Refs
	  // ------------------------------
	  // Lifecycle
	  // ------------------------------
	  function Select(_props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      ariaLiveSelection: '',
	      ariaLiveContext: '',
	      focusedOption: null,
	      focusedValue: null,
	      inputIsHidden: false,
	      isFocused: false,
	      menuOptions: {
	        render: [],
	        focusable: []
	      },
	      selectValue: []
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockOptionHover", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isComposing", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearFocusValueOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "commonProps", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "components", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasGroups", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchX", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchY", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputIsHiddenAfterUpdate", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "instancePrefix", '');
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openAfterFocus", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToFocusedOptionOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userIsDragging", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getControlRef", function (ref) {
	      _this.controlRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusedOptionRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusedOptionRef", function (ref) {
	      _this.focusedOptionRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuListRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuListRef", function (ref) {
	      _this.menuListRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputRef", function (ref) {
	      _this.inputRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cacheComponents", function (components) {
	      _this.components = (0, _index3.defaultComponents)({
	        components: components
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focus", _this.focusInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blur", _this.blurInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          name = _this$props.name;
	      onChange(newValue, _objectSpread({}, actionMeta, {
	        name: name
	      }));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setValue", function (newValue) {
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
	      var option = arguments.length > 2 ? arguments[2] : undefined;
	      var _this$props2 = _this.props,
	          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
	          isMulti = _this$props2.isMulti;
	
	      _this.onInputChange('', {
	        action: 'set-value'
	      });
	
	      if (closeMenuOnSelect) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } // when the select value should change, we should reset focusedValue
	
	
	      _this.clearFocusValueOnUpdate = true;
	
	      _this.onChange(newValue, {
	        action: action,
	        option: option
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (newValue) {
	      var _this$props3 = _this.props,
	          blurInputOnSelect = _this$props3.blurInputOnSelect,
	          isMulti = _this$props3.isMulti;
	      var selectValue = _this.state.selectValue;
	
	      if (isMulti) {
	        if (_this.isOptionSelected(newValue, selectValue)) {
	          var candidate = _this.getOptionValue(newValue);
	
	          _this.setValue(selectValue.filter(function (i) {
	            return _this.getOptionValue(i) !== candidate;
	          }), 'deselect-option', newValue);
	
	          _this.announceAriaLiveSelection({
	            event: 'deselect-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          if (!_this.isOptionDisabled(newValue, selectValue)) {
	            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);
	
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue)
	              }
	            });
	          } else {
	            // announce that option is disabled
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue),
	                isDisabled: true
	              }
	            });
	          }
	        }
	      } else {
	        if (!_this.isOptionDisabled(newValue, selectValue)) {
	          _this.setValue(newValue, 'select-option');
	
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          // announce that option is disabled
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue),
	              isDisabled: true
	            }
	          });
	        }
	      }
	
	      if (blurInputOnSelect) {
	        _this.blurInput();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeValue", function (removedValue) {
	      var selectValue = _this.state.selectValue;
	
	      var candidate = _this.getOptionValue(removedValue);
	
	      _this.onChange(selectValue.filter(function (i) {
	        return _this.getOptionValue(i) !== candidate;
	      }), {
	        action: 'remove-value',
	        removedValue: removedValue
	      });
	
	      _this.announceAriaLiveSelection({
	        event: 'remove-value',
	        context: {
	          value: removedValue ? _this.getOptionLabel(removedValue) : ''
	        }
	      });
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearValue", function () {
	      var isMulti = _this.props.isMulti;
	
	      _this.onChange(isMulti ? [] : null, {
	        action: 'clear'
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popValue", function () {
	      var selectValue = _this.state.selectValue;
	      var lastSelectedValue = selectValue[selectValue.length - 1];
	
	      _this.announceAriaLiveSelection({
	        event: 'pop-value',
	        context: {
	          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
	        }
	      });
	
	      _this.onChange(selectValue.slice(0, selectValue.length - 1), {
	        action: 'pop-value',
	        removedValue: lastSelectedValue
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionLabel", function (data) {
	      return _this.props.getOptionLabel(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionValue", function (data) {
	      return _this.props.getOptionValue(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, props) {
	      var base = _styles.defaultStyles[key](props);
	
	      base.boxSizing = 'border-box';
	      var custom = _this.props.styles[key];
	      return custom ? custom(base, props) : base;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElementId", function (element) {
	      return "".concat(_this.instancePrefix, "-").concat(element);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveDescendentId", function () {
	      var menuIsOpen = _this.props.menuIsOpen;
	      var _this$state = _this.state,
	          menuOptions = _this$state.menuOptions,
	          focusedOption = _this$state.focusedOption;
	      if (!focusedOption || !menuIsOpen) return undefined;
	      var index = menuOptions.focusable.indexOf(focusedOption);
	      var option = menuOptions.render[index];
	      return option && option.key;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveSelection", function (_ref2) {
	      var event = _ref2.event,
	          context = _ref2.context;
	
	      _this.setState({
	        ariaLiveSelection: (0, _index2.valueEventAriaMessage)(event, context)
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveContext", function (_ref3) {
	      var event = _ref3.event,
	          context = _ref3.context;
	
	      _this.setState({
	        ariaLiveContext: (0, _index2.instructionsAriaMessage)(event, _objectSpread({}, context, {
	          label: _this.props['aria-label']
	        }))
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseDown", function (event) {
	      if (event.button !== 0) {
	        return;
	      }
	
	      event.stopPropagation();
	      event.preventDefault();
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseMove", function (event) {
	      _this.blockOptionHover = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlMouseDown", function (event) {
	      var openMenuOnClick = _this.props.openMenuOnClick;
	
	      if (!_this.state.isFocused) {
	        if (openMenuOnClick) {
	          _this.openAfterFocus = true;
	        }
	
	        _this.focusInput();
	      } else if (!_this.props.menuIsOpen) {
	        if (openMenuOnClick) {
	          _this.openMenu('first');
	        }
	      } else {
	        //$FlowFixMe
	        if (event.target.tagName !== 'INPUT') {
	          _this.onMenuClose();
	        }
	      } //$FlowFixMe
	
	
	      if (event.target.tagName !== 'INPUT') {
	        event.preventDefault();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      if (_this.props.isDisabled) return;
	      var _this$props4 = _this.props,
	          isMulti = _this$props4.isMulti,
	          menuIsOpen = _this$props4.menuIsOpen;
	
	      _this.focusInput();
	
	      if (menuIsOpen) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } else {
	        _this.openMenu('first');
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      _this.clearValue();
	
	      event.stopPropagation();
	      _this.openAfterFocus = false;
	      setTimeout(function () {
	        return _this.focusInput();
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (event) {
	      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
	        if (event.target instanceof HTMLElement && (0, _utils.isDocumentElement)(event.target)) {
	          _this.props.onMenuClose();
	        }
	      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
	        if (_this.props.closeMenuOnScroll(event)) {
	          _this.props.onMenuClose();
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionStart", function () {
	      _this.isComposing = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionEnd", function () {
	      _this.isComposing = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (_ref4) {
	      var touches = _ref4.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      _this.initialTouchX = touch.clientX;
	      _this.initialTouchY = touch.clientY;
	      _this.userIsDragging = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (_ref5) {
	      var touches = _ref5.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
	      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
	      var moveThreshold = 5;
	      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchEnd", function (event) {
	      if (_this.userIsDragging) return; // close the menu if the user taps outside
	      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
	      // on events on child elements, not the document (which we've attached this handler to).
	
	      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
	        _this.blurInput();
	      } // reset move vars
	
	
	      _this.initialTouchX = 0;
	      _this.initialTouchY = 0;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onControlMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onClearIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onDropdownIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (event) {
	      var inputValue = event.currentTarget.value;
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.onInputChange(inputValue, {
	        action: 'input-change'
	      });
	
	      _this.onMenuOpen();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputFocus", function (event) {
	      var _this$props5 = _this.props,
	          isSearchable = _this$props5.isSearchable,
	          isMulti = _this$props5.isMulti;
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	
	      _this.setState({
	        isFocused: true
	      });
	
	      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
	        _this.openMenu('first');
	      }
	
	      _this.openAfterFocus = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputBlur", function (event) {
	      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
	        _this.inputRef.focus();
	
	        return;
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	
	      _this.onInputChange('', {
	        action: 'input-blur'
	      });
	
	      _this.onMenuClose();
	
	      _this.setState({
	        focusedValue: null,
	        isFocused: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOptionHover", function (focusedOption) {
	      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
	        return;
	      }
	
	      _this.setState({
	        focusedOption: focusedOption
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldHideSelectedOptions", function () {
	      var _this$props6 = _this.props,
	          hideSelectedOptions = _this$props6.hideSelectedOptions,
	          isMulti = _this$props6.isMulti;
	      if (hideSelectedOptions === undefined) return isMulti;
	      return hideSelectedOptions;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
	      var _this$props7 = _this.props,
	          isMulti = _this$props7.isMulti,
	          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
	          escapeClearsValue = _this$props7.escapeClearsValue,
	          inputValue = _this$props7.inputValue,
	          isClearable = _this$props7.isClearable,
	          isDisabled = _this$props7.isDisabled,
	          menuIsOpen = _this$props7.menuIsOpen,
	          onKeyDown = _this$props7.onKeyDown,
	          tabSelectsValue = _this$props7.tabSelectsValue,
	          openMenuOnFocus = _this$props7.openMenuOnFocus;
	      var _this$state2 = _this.state,
	          focusedOption = _this$state2.focusedOption,
	          focusedValue = _this$state2.focusedValue,
	          selectValue = _this$state2.selectValue;
	      if (isDisabled) return;
	
	      if (typeof onKeyDown === 'function') {
	        onKeyDown(event);
	
	        if (event.defaultPrevented) {
	          return;
	        }
	      } // Block option hover events when the user has just pressed a key
	
	
	      _this.blockOptionHover = true;
	
	      switch (event.key) {
	        case 'ArrowLeft':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('previous');
	
	          break;
	
	        case 'ArrowRight':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('next');
	
	          break;
	
	        case 'Delete':
	        case 'Backspace':
	          if (inputValue) return;
	
	          if (focusedValue) {
	            _this.removeValue(focusedValue);
	          } else {
	            if (!backspaceRemovesValue) return;
	
	            if (isMulti) {
	              _this.popValue();
	            } else if (isClearable) {
	              _this.clearValue();
	            }
	          }
	
	          break;
	
	        case 'Tab':
	          if (_this.isComposing) return;
	
	          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
	          // option is already selected; it breaks the flow of navigation
	          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
	            return;
	          }
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'Enter':
	          if (event.keyCode === 229) {
	            // ignore the keydown event from an Input Method Editor(IME)
	            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
	            break;
	          }
	
	          if (menuIsOpen) {
	            if (!focusedOption) return;
	            if (_this.isComposing) return;
	
	            _this.selectOption(focusedOption);
	
	            break;
	          }
	
	          return;
	
	        case 'Escape':
	          if (menuIsOpen) {
	            _this.inputIsHiddenAfterUpdate = false;
	
	            _this.onInputChange('', {
	              action: 'menu-close'
	            });
	
	            _this.onMenuClose();
	          } else if (isClearable && escapeClearsValue) {
	            _this.clearValue();
	          }
	
	          break;
	
	        case ' ':
	          // space
	          if (inputValue) {
	            return;
	          }
	
	          if (!menuIsOpen) {
	            _this.openMenu('first');
	
	            break;
	          }
	
	          if (!focusedOption) return;
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'ArrowUp':
	          if (menuIsOpen) {
	            _this.focusOption('up');
	          } else {
	            _this.openMenu('last');
	          }
	
	          break;
	
	        case 'ArrowDown':
	          if (menuIsOpen) {
	            _this.focusOption('down');
	          } else {
	            _this.openMenu('first');
	          }
	
	          break;
	
	        case 'PageUp':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pageup');
	
	          break;
	
	        case 'PageDown':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pagedown');
	
	          break;
	
	        case 'Home':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('first');
	
	          break;
	
	        case 'End':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('last');
	
	          break;
	
	        default:
	          return;
	      }
	
	      event.preventDefault();
	    });
	
	    var value = _props.value;
	    _this.cacheComponents = (0, _memoizeOne.default)(_this.cacheComponents, _reactFastCompare.default).bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    _this.cacheComponents(_props.components);
	
	    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
	
	    var _selectValue = (0, _utils.cleanValue)(value);
	
	    var _menuOptions = _this.buildMenuOptions(_props, _selectValue);
	
	    _this.state.menuOptions = _menuOptions;
	    _this.state.selectValue = _selectValue;
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListeningComposition();
	      this.startListeningToTouch();
	
	      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
	        // Listen to all scroll events, and filter them out inside of 'onScroll'
	        document.addEventListener('scroll', this.onScroll, true);
	      }
	
	      if (this.props.autoFocus) {
	        this.focusInput();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props8 = this.props,
	          options = _this$props8.options,
	          value = _this$props8.value,
	          inputValue = _this$props8.inputValue; // re-cache custom components
	
	      this.cacheComponents(nextProps.components); // rebuild the menu options
	
	      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
	        var selectValue = (0, _utils.cleanValue)(nextProps.value);
	        var menuOptions = this.buildMenuOptions(nextProps, selectValue);
	        var focusedValue = this.getNextFocusedValue(selectValue);
	        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
	        this.setState({
	          menuOptions: menuOptions,
	          selectValue: selectValue,
	          focusedOption: focusedOption,
	          focusedValue: focusedValue
	        });
	      } // some updates should toggle the state of the input visibility
	
	
	      if (this.inputIsHiddenAfterUpdate != null) {
	        this.setState({
	          inputIsHidden: this.inputIsHiddenAfterUpdate
	        });
	        delete this.inputIsHiddenAfterUpdate;
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props9 = this.props,
	          isDisabled = _this$props9.isDisabled,
	          menuIsOpen = _this$props9.menuIsOpen;
	      var isFocused = this.state.isFocused;
	
	      if ( // ensure focus is restored correctly when the control becomes enabled
	      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
	      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
	        this.focusInput();
	      } // scroll the focused option into view if necessary
	
	
	      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
	        (0, _utils.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
	      }
	
	      this.scrollToFocusedOptionOnUpdate = false;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListeningComposition();
	      this.stopListeningToTouch();
	      document.removeEventListener('scroll', this.onScroll, true);
	    }
	  }, {
	    key: "onMenuOpen",
	    // ==============================
	    // Consumer Handlers
	    // ==============================
	    value: function onMenuOpen() {
	      this.props.onMenuOpen();
	    }
	  }, {
	    key: "onMenuClose",
	    value: function onMenuClose() {
	      var _this$props10 = this.props,
	          isSearchable = _this$props10.isSearchable,
	          isMulti = _this$props10.isMulti;
	      this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	      this.onInputChange('', {
	        action: 'menu-close'
	      });
	      this.props.onMenuClose();
	    }
	  }, {
	    key: "onInputChange",
	    value: function onInputChange(newValue, actionMeta) {
	      this.props.onInputChange(newValue, actionMeta);
	    } // ==============================
	    // Methods
	    // ==============================
	
	  }, {
	    key: "focusInput",
	    value: function focusInput() {
	      if (!this.inputRef) return;
	      this.inputRef.focus();
	    }
	  }, {
	    key: "blurInput",
	    value: function blurInput() {
	      if (!this.inputRef) return;
	      this.inputRef.blur();
	    } // aliased for consumers
	
	  }, {
	    key: "openMenu",
	    value: function openMenu(focusOption) {
	      var _this$state3 = this.state,
	          menuOptions = _this$state3.menuOptions,
	          selectValue = _this$state3.selectValue,
	          isFocused = _this$state3.isFocused;
	      var isMulti = this.props.isMulti;
	      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;
	
	      if (!isMulti) {
	        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
	
	        if (selectedIndex > -1) {
	          openAtIndex = selectedIndex;
	        }
	      } // only scroll if the menu isn't already open
	
	
	      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
	      this.inputIsHiddenAfterUpdate = false;
	      this.onMenuOpen();
	      this.setState({
	        focusedValue: null,
	        focusedOption: menuOptions.focusable[openAtIndex]
	      });
	      this.announceAriaLiveContext({
	        event: 'menu'
	      });
	    }
	  }, {
	    key: "focusValue",
	    value: function focusValue(direction) {
	      var _this$props11 = this.props,
	          isMulti = _this$props11.isMulti,
	          isSearchable = _this$props11.isSearchable;
	      var _this$state4 = this.state,
	          selectValue = _this$state4.selectValue,
	          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
	
	      if (!isMulti) return;
	      this.setState({
	        focusedOption: null
	      });
	      var focusedIndex = selectValue.indexOf(focusedValue);
	
	      if (!focusedValue) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'value'
	        });
	      }
	
	      var lastIndex = selectValue.length - 1;
	      var nextFocus = -1;
	      if (!selectValue.length) return;
	
	      switch (direction) {
	        case 'previous':
	          if (focusedIndex === 0) {
	            // don't cycle from the start to the end
	            nextFocus = 0;
	          } else if (focusedIndex === -1) {
	            // if nothing is focused, focus the last value first
	            nextFocus = lastIndex;
	          } else {
	            nextFocus = focusedIndex - 1;
	          }
	
	          break;
	
	        case 'next':
	          if (focusedIndex > -1 && focusedIndex < lastIndex) {
	            nextFocus = focusedIndex + 1;
	          }
	
	          break;
	      }
	
	      if (nextFocus === -1) {
	        this.announceAriaLiveContext({
	          event: 'input',
	          context: {
	            isSearchable: isSearchable,
	            isMulti: isMulti
	          }
	        });
	      }
	
	      this.setState({
	        inputIsHidden: nextFocus === -1 ? false : true,
	        focusedValue: selectValue[nextFocus]
	      });
	    }
	  }, {
	    key: "focusOption",
	    value: function focusOption() {
	      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
	      var pageSize = this.props.pageSize;
	      var _this$state5 = this.state,
	          focusedOption = _this$state5.focusedOption,
	          menuOptions = _this$state5.menuOptions;
	      var options = menuOptions.focusable;
	      if (!options.length) return;
	      var nextFocus = 0; // handles 'first'
	
	      var focusedIndex = options.indexOf(focusedOption);
	
	      if (!focusedOption) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'menu'
	        });
	      }
	
	      if (direction === 'up') {
	        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
	      } else if (direction === 'down') {
	        nextFocus = (focusedIndex + 1) % options.length;
	      } else if (direction === 'pageup') {
	        nextFocus = focusedIndex - pageSize;
	        if (nextFocus < 0) nextFocus = 0;
	      } else if (direction === 'pagedown') {
	        nextFocus = focusedIndex + pageSize;
	        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
	      } else if (direction === 'last') {
	        nextFocus = options.length - 1;
	      }
	
	      this.scrollToFocusedOptionOnUpdate = true;
	      this.setState({
	        focusedOption: options[nextFocus],
	        focusedValue: null
	      });
	      this.announceAriaLiveContext({
	        event: 'menu',
	        context: {
	          isDisabled: (0, _builtins.isOptionDisabled)(options[nextFocus])
	        }
	      });
	    }
	  }, {
	    key: "getTheme",
	    // ==============================
	    // Getters
	    // ==============================
	    value: function getTheme() {
	      // Use the default theme if there are no customizations.
	      if (!this.props.theme) {
	        return _theme.defaultTheme;
	      } // If the theme prop is a function, assume the function
	      // knows how to merge the passed-in default theme with
	      // its own modifications.
	
	
	      if (typeof this.props.theme === 'function') {
	        return this.props.theme(_theme.defaultTheme);
	      } // Otherwise, if a plain theme object was passed in,
	      // overlay it with the default theme.
	
	
	      return _objectSpread({}, _theme.defaultTheme, this.props.theme);
	    }
	  }, {
	    key: "getCommonProps",
	    value: function getCommonProps() {
	      var clearValue = this.clearValue,
	          getStyles = this.getStyles,
	          setValue = this.setValue,
	          selectOption = this.selectOption,
	          props = this.props;
	      var classNamePrefix = props.classNamePrefix,
	          isMulti = props.isMulti,
	          isRtl = props.isRtl,
	          options = props.options;
	      var selectValue = this.state.selectValue;
	      var hasValue = this.hasValue();
	
	      var getValue = function getValue() {
	        return selectValue;
	      };
	
	      var cx = _utils.classNames.bind(null, classNamePrefix);
	
	      return {
	        cx: cx,
	        clearValue: clearValue,
	        getStyles: getStyles,
	        getValue: getValue,
	        hasValue: hasValue,
	        isMulti: isMulti,
	        isRtl: isRtl,
	        options: options,
	        selectOption: selectOption,
	        setValue: setValue,
	        selectProps: props,
	        theme: this.getTheme()
	      };
	    }
	  }, {
	    key: "getNextFocusedValue",
	    value: function getNextFocusedValue(nextSelectValue) {
	      if (this.clearFocusValueOnUpdate) {
	        this.clearFocusValueOnUpdate = false;
	        return null;
	      }
	
	      var _this$state6 = this.state,
	          focusedValue = _this$state6.focusedValue,
	          lastSelectValue = _this$state6.selectValue;
	      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
	
	      if (lastFocusedIndex > -1) {
	        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
	
	        if (nextFocusedIndex > -1) {
	          // the focused value is still in the selectValue, return it
	          return focusedValue;
	        } else if (lastFocusedIndex < nextSelectValue.length) {
	          // the focusedValue is not present in the next selectValue array by
	          // reference, so return the new value at the same index
	          return nextSelectValue[lastFocusedIndex];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getNextFocusedOption",
	    value: function getNextFocusedOption(options) {
	      var lastFocusedOption = this.state.focusedOption;
	      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
	    }
	  }, {
	    key: "hasValue",
	    value: function hasValue() {
	      var selectValue = this.state.selectValue;
	      return selectValue.length > 0;
	    }
	  }, {
	    key: "hasOptions",
	    value: function hasOptions() {
	      return !!this.state.menuOptions.render.length;
	    }
	  }, {
	    key: "countOptions",
	    value: function countOptions() {
	      return this.state.menuOptions.focusable.length;
	    }
	  }, {
	    key: "isClearable",
	    value: function isClearable() {
	      var _this$props12 = this.props,
	          isClearable = _this$props12.isClearable,
	          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
	      // multi select, by default, IS clearable
	
	      if (isClearable === undefined) return isMulti;
	      return isClearable;
	    }
	  }, {
	    key: "isOptionDisabled",
	    value: function isOptionDisabled(option, selectValue) {
	      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
	    }
	  }, {
	    key: "isOptionSelected",
	    value: function isOptionSelected(option, selectValue) {
	      var _this2 = this;
	
	      if (selectValue.indexOf(option) > -1) return true;
	
	      if (typeof this.props.isOptionSelected === 'function') {
	        return this.props.isOptionSelected(option, selectValue);
	      }
	
	      var candidate = this.getOptionValue(option);
	      return selectValue.some(function (i) {
	        return _this2.getOptionValue(i) === candidate;
	      });
	    }
	  }, {
	    key: "filterOption",
	    value: function filterOption(option, inputValue) {
	      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
	    }
	  }, {
	    key: "formatOptionLabel",
	    value: function formatOptionLabel(data, context) {
	      if (typeof this.props.formatOptionLabel === 'function') {
	        var inputValue = this.props.inputValue;
	        var selectValue = this.state.selectValue;
	        return this.props.formatOptionLabel(data, {
	          context: context,
	          inputValue: inputValue,
	          selectValue: selectValue
	        });
	      } else {
	        return this.getOptionLabel(data);
	      }
	    }
	  }, {
	    key: "formatGroupLabel",
	    value: function formatGroupLabel(data) {
	      return this.props.formatGroupLabel(data);
	    } // ==============================
	    // Mouse Handlers
	    // ==============================
	
	  }, {
	    key: "startListeningComposition",
	    // ==============================
	    // Composition Handlers
	    // ==============================
	    value: function startListeningComposition() {
	      if (document && document.addEventListener) {
	        document.addEventListener('compositionstart', this.onCompositionStart, false);
	        document.addEventListener('compositionend', this.onCompositionEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningComposition",
	    value: function stopListeningComposition() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('compositionstart', this.onCompositionStart);
	        document.removeEventListener('compositionend', this.onCompositionEnd);
	      }
	    }
	  }, {
	    key: "startListeningToTouch",
	    // ==============================
	    // Touch Handlers
	    // ==============================
	    value: function startListeningToTouch() {
	      if (document && document.addEventListener) {
	        document.addEventListener('touchstart', this.onTouchStart, false);
	        document.addEventListener('touchmove', this.onTouchMove, false);
	        document.addEventListener('touchend', this.onTouchEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningToTouch",
	    value: function stopListeningToTouch() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('touchstart', this.onTouchStart);
	        document.removeEventListener('touchmove', this.onTouchMove);
	        document.removeEventListener('touchend', this.onTouchEnd);
	      }
	    }
	  }, {
	    key: "buildMenuOptions",
	    // ==============================
	    // Menu Options
	    // ==============================
	    value: function buildMenuOptions(props, selectValue) {
	      var _this3 = this;
	
	      var _props$inputValue = props.inputValue,
	          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
	          options = props.options;
	
	      var toOption = function toOption(option, id) {
	        var isDisabled = _this3.isOptionDisabled(option, selectValue);
	
	        var isSelected = _this3.isOptionSelected(option, selectValue);
	
	        var label = _this3.getOptionLabel(option);
	
	        var value = _this3.getOptionValue(option);
	
	        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
	          label: label,
	          value: value,
	          data: option
	        }, inputValue)) {
	          return;
	        }
	
	        var onHover = isDisabled ? undefined : function () {
	          return _this3.onOptionHover(option);
	        };
	        var onSelect = isDisabled ? undefined : function () {
	          return _this3.selectOption(option);
	        };
	        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
	        return {
	          innerProps: {
	            id: optionId,
	            onClick: onSelect,
	            onMouseMove: onHover,
	            onMouseOver: onHover,
	            tabIndex: -1
	          },
	          data: option,
	          isDisabled: isDisabled,
	          isSelected: isSelected,
	          key: optionId,
	          label: label,
	          type: 'option',
	          value: value
	        };
	      };
	
	      return options.reduce(function (acc, item, itemIndex) {
	        if (item.options) {
	          // TODO needs a tidier implementation
	          if (!_this3.hasGroups) _this3.hasGroups = true;
	          var items = item.options;
	          var children = items.map(function (child, i) {
	            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
	            if (option) acc.focusable.push(child);
	            return option;
	          }).filter(Boolean);
	
	          if (children.length) {
	            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
	            acc.render.push({
	              type: 'group',
	              key: groupId,
	              data: item,
	              options: children
	            });
	          }
	        } else {
	          var option = toOption(item, "".concat(itemIndex));
	
	          if (option) {
	            acc.render.push(option);
	            acc.focusable.push(item);
	          }
	        }
	
	        return acc;
	      }, {
	        render: [],
	        focusable: []
	      });
	    } // ==============================
	    // Renderers
	    // ==============================
	
	  }, {
	    key: "constructAriaLiveMessage",
	    value: function constructAriaLiveMessage() {
	      var _this$state7 = this.state,
	          ariaLiveContext = _this$state7.ariaLiveContext,
	          selectValue = _this$state7.selectValue,
	          focusedValue = _this$state7.focusedValue,
	          focusedOption = _this$state7.focusedOption;
	      var _this$props13 = this.props,
	          options = _this$props13.options,
	          menuIsOpen = _this$props13.menuIsOpen,
	          inputValue = _this$props13.inputValue,
	          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.
	
	      var focusedValueMsg = focusedValue ? (0, _index2.valueFocusAriaMessage)({
	        focusedValue: focusedValue,
	        getOptionLabel: this.getOptionLabel,
	        selectValue: selectValue
	      }) : ''; // An aria live message representing the currently focused option in the select.
	
	      var focusedOptionMsg = focusedOption && menuIsOpen ? (0, _index2.optionFocusAriaMessage)({
	        focusedOption: focusedOption,
	        getOptionLabel: this.getOptionLabel,
	        options: options
	      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
	
	      var resultsMsg = (0, _index2.resultsAriaMessage)({
	        inputValue: inputValue,
	        screenReaderMessage: screenReaderStatus({
	          count: this.countOptions()
	        })
	      });
	      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
	    }
	  }, {
	    key: "renderInput",
	    value: function renderInput() {
	      var _this$props14 = this.props,
	          isDisabled = _this$props14.isDisabled,
	          isSearchable = _this$props14.isSearchable,
	          inputId = _this$props14.inputId,
	          inputValue = _this$props14.inputValue,
	          tabIndex = _this$props14.tabIndex;
	      var Input = this.components.Input;
	      var inputIsHidden = this.state.inputIsHidden;
	      var id = inputId || this.getElementId('input');
	
	      if (!isSearchable) {
	        // use a dummy input to maintain focus/blur functionality
	        return _react.default.createElement(_index.DummyInput, {
	          id: id,
	          innerRef: this.getInputRef,
	          onBlur: this.onInputBlur,
	          onChange: _utils.noop,
	          onFocus: this.onInputFocus,
	          readOnly: true,
	          disabled: isDisabled,
	          tabIndex: tabIndex,
	          value: ""
	        });
	      } // aria attributes makes the JSX "noisy", separated for clarity
	
	
	      var ariaAttributes = {
	        'aria-autocomplete': 'list',
	        'aria-label': this.props['aria-label'],
	        'aria-labelledby': this.props['aria-labelledby']
	      };
	      var _this$commonProps = this.commonProps,
	          cx = _this$commonProps.cx,
	          theme = _this$commonProps.theme,
	          selectProps = _this$commonProps.selectProps;
	      return _react.default.createElement(Input, _extends({
	        autoCapitalize: "none",
	        autoComplete: "off",
	        autoCorrect: "off",
	        cx: cx,
	        getStyles: this.getStyles,
	        id: id,
	        innerRef: this.getInputRef,
	        isDisabled: isDisabled,
	        isHidden: inputIsHidden,
	        onBlur: this.onInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.onInputFocus,
	        selectProps: selectProps,
	        spellCheck: "false",
	        tabIndex: tabIndex,
	        theme: theme,
	        type: "text",
	        value: inputValue
	      }, ariaAttributes));
	    }
	  }, {
	    key: "renderPlaceholderOrValue",
	    value: function renderPlaceholderOrValue() {
	      var _this4 = this;
	
	      var _this$components = this.components,
	          MultiValue = _this$components.MultiValue,
	          MultiValueContainer = _this$components.MultiValueContainer,
	          MultiValueLabel = _this$components.MultiValueLabel,
	          MultiValueRemove = _this$components.MultiValueRemove,
	          SingleValue = _this$components.SingleValue,
	          Placeholder = _this$components.Placeholder;
	      var commonProps = this.commonProps;
	      var _this$props15 = this.props,
	          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
	          isDisabled = _this$props15.isDisabled,
	          isMulti = _this$props15.isMulti,
	          inputValue = _this$props15.inputValue,
	          placeholder = _this$props15.placeholder;
	      var _this$state8 = this.state,
	          selectValue = _this$state8.selectValue,
	          focusedValue = _this$state8.focusedValue,
	          isFocused = _this$state8.isFocused;
	
	      if (!this.hasValue() || !controlShouldRenderValue) {
	        return inputValue ? null : _react.default.createElement(Placeholder, _extends({}, commonProps, {
	          key: "placeholder",
	          isDisabled: isDisabled,
	          isFocused: isFocused
	        }), placeholder);
	      }
	
	      if (isMulti) {
	        var selectValues = selectValue.map(function (opt) {
	          var isOptionFocused = opt === focusedValue;
	          return _react.default.createElement(MultiValue, _extends({}, commonProps, {
	            components: {
	              Container: MultiValueContainer,
	              Label: MultiValueLabel,
	              Remove: MultiValueRemove
	            },
	            isFocused: isOptionFocused,
	            isDisabled: isDisabled,
	            key: _this4.getOptionValue(opt),
	            removeProps: {
	              onClick: function onClick() {
	                return _this4.removeValue(opt);
	              },
	              onTouchEnd: function onTouchEnd() {
	                return _this4.removeValue(opt);
	              },
	              onMouseDown: function onMouseDown(e) {
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            },
	            data: opt
	          }), _this4.formatOptionLabel(opt, 'value'));
	        });
	        return selectValues;
	      }
	
	      if (inputValue) {
	        return null;
	      }
	
	      var singleValue = selectValue[0];
	      return _react.default.createElement(SingleValue, _extends({}, commonProps, {
	        data: singleValue,
	        isDisabled: isDisabled
	      }), this.formatOptionLabel(singleValue, 'value'));
	    }
	  }, {
	    key: "renderClearIndicator",
	    value: function renderClearIndicator() {
	      var ClearIndicator = this.components.ClearIndicator;
	      var commonProps = this.commonProps;
	      var _this$props16 = this.props,
	          isDisabled = _this$props16.isDisabled,
	          isLoading = _this$props16.isLoading;
	      var isFocused = this.state.isFocused;
	
	      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
	        return null;
	      }
	
	      var innerProps = {
	        onMouseDown: this.onClearIndicatorMouseDown,
	        onTouchEnd: this.onClearIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return _react.default.createElement(ClearIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderLoadingIndicator",
	    value: function renderLoadingIndicator() {
	      var LoadingIndicator = this.components.LoadingIndicator;
	      var commonProps = this.commonProps;
	      var _this$props17 = this.props,
	          isDisabled = _this$props17.isDisabled,
	          isLoading = _this$props17.isLoading;
	      var isFocused = this.state.isFocused;
	      if (!LoadingIndicator || !isLoading) return null;
	      var innerProps = {
	        'aria-hidden': 'true'
	      };
	      return _react.default.createElement(LoadingIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderIndicatorSeparator",
	    value: function renderIndicatorSeparator() {
	      var _this$components2 = this.components,
	          DropdownIndicator = _this$components2.DropdownIndicator,
	          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
	
	      if (!DropdownIndicator || !IndicatorSeparator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      return _react.default.createElement(IndicatorSeparator, _extends({}, commonProps, {
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderDropdownIndicator",
	    value: function renderDropdownIndicator() {
	      var DropdownIndicator = this.components.DropdownIndicator;
	      if (!DropdownIndicator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      var innerProps = {
	        onMouseDown: this.onDropdownIndicatorMouseDown,
	        onTouchEnd: this.onDropdownIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return _react.default.createElement(DropdownIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this5 = this;
	
	      var _this$components3 = this.components,
	          Group = _this$components3.Group,
	          GroupHeading = _this$components3.GroupHeading,
	          Menu = _this$components3.Menu,
	          MenuList = _this$components3.MenuList,
	          MenuPortal = _this$components3.MenuPortal,
	          LoadingMessage = _this$components3.LoadingMessage,
	          NoOptionsMessage = _this$components3.NoOptionsMessage,
	          Option = _this$components3.Option;
	      var commonProps = this.commonProps;
	      var _this$state9 = this.state,
	          focusedOption = _this$state9.focusedOption,
	          menuOptions = _this$state9.menuOptions;
	      var _this$props18 = this.props,
	          captureMenuScroll = _this$props18.captureMenuScroll,
	          inputValue = _this$props18.inputValue,
	          isLoading = _this$props18.isLoading,
	          loadingMessage = _this$props18.loadingMessage,
	          minMenuHeight = _this$props18.minMenuHeight,
	          maxMenuHeight = _this$props18.maxMenuHeight,
	          menuIsOpen = _this$props18.menuIsOpen,
	          menuPlacement = _this$props18.menuPlacement,
	          menuPosition = _this$props18.menuPosition,
	          menuPortalTarget = _this$props18.menuPortalTarget,
	          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
	          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
	          noOptionsMessage = _this$props18.noOptionsMessage,
	          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
	          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
	      if (!menuIsOpen) return null; // TODO: Internal Option Type here
	
	      var render = function render(props) {
	        // for performance, the menu options in state aren't changed when the
	        // focused option changes so we calculate additional props based on that
	        var isFocused = focusedOption === props.data;
	        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
	        return _react.default.createElement(Option, _extends({}, commonProps, props, {
	          isFocused: isFocused
	        }), _this5.formatOptionLabel(props.data, 'menu'));
	      };
	
	      var menuUI;
	
	      if (this.hasOptions()) {
	        menuUI = menuOptions.render.map(function (item) {
	          if (item.type === 'group') {
	            var type = item.type,
	                group = _objectWithoutProperties(item, ["type"]);
	
	            var headingId = "".concat(item.key, "-heading");
	            return _react.default.createElement(Group, _extends({}, commonProps, group, {
	              Heading: GroupHeading,
	              headingProps: {
	                id: headingId
	              },
	              label: _this5.formatGroupLabel(item.data)
	            }), item.options.map(function (option) {
	              return render(option);
	            }));
	          } else if (item.type === 'option') {
	            return render(item);
	          }
	        });
	      } else if (isLoading) {
	        var message = loadingMessage({
	          inputValue: inputValue
	        });
	        if (message === null) return null;
	        menuUI = _react.default.createElement(LoadingMessage, commonProps, message);
	      } else {
	        var _message = noOptionsMessage({
	          inputValue: inputValue
	        });
	
	        if (_message === null) return null;
	        menuUI = _react.default.createElement(NoOptionsMessage, commonProps, _message);
	      }
	
	      var menuPlacementProps = {
	        minMenuHeight: minMenuHeight,
	        maxMenuHeight: maxMenuHeight,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition,
	        menuShouldScrollIntoView: menuShouldScrollIntoView
	      };
	
	      var menuElement = _react.default.createElement(_Menu.MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref6) {
	        var ref = _ref6.ref,
	            _ref6$placerProps = _ref6.placerProps,
	            placement = _ref6$placerProps.placement,
	            maxHeight = _ref6$placerProps.maxHeight;
	        return _react.default.createElement(Menu, _extends({}, commonProps, menuPlacementProps, {
	          innerRef: ref,
	          innerProps: {
	            onMouseDown: _this5.onMenuMouseDown,
	            onMouseMove: _this5.onMenuMouseMove
	          },
	          isLoading: isLoading,
	          placement: placement
	        }), _react.default.createElement(_index.ScrollCaptor, {
	          isEnabled: captureMenuScroll,
	          onTopArrive: onMenuScrollToTop,
	          onBottomArrive: onMenuScrollToBottom
	        }, _react.default.createElement(_index.ScrollBlock, {
	          isEnabled: menuShouldBlockScroll
	        }, _react.default.createElement(MenuList, _extends({}, commonProps, {
	          innerRef: _this5.getMenuListRef,
	          isLoading: isLoading,
	          maxHeight: maxHeight
	        }), menuUI))));
	      }); // positioning behaviour is almost identical for portalled and fixed,
	      // so we use the same component. the actual portalling logic is forked
	      // within the component based on `menuPosition`
	
	
	      return menuPortalTarget || menuPosition === 'fixed' ? _react.default.createElement(MenuPortal, _extends({}, commonProps, {
	        appendTo: menuPortalTarget,
	        controlElement: this.controlRef,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition
	      }), menuElement) : menuElement;
	    }
	  }, {
	    key: "renderFormField",
	    value: function renderFormField() {
	      var _this6 = this;
	
	      var _this$props19 = this.props,
	          delimiter = _this$props19.delimiter,
	          isDisabled = _this$props19.isDisabled,
	          isMulti = _this$props19.isMulti,
	          name = _this$props19.name;
	      var selectValue = this.state.selectValue;
	      if (!name || isDisabled) return;
	
	      if (isMulti) {
	        if (delimiter) {
	          var value = selectValue.map(function (opt) {
	            return _this6.getOptionValue(opt);
	          }).join(delimiter);
	          return _react.default.createElement("input", {
	            name: name,
	            type: "hidden",
	            value: value
	          });
	        } else {
	          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
	            return _react.default.createElement("input", {
	              key: "i-".concat(i),
	              name: name,
	              type: "hidden",
	              value: _this6.getOptionValue(opt)
	            });
	          }) : _react.default.createElement("input", {
	            name: name,
	            type: "hidden"
	          });
	          return _react.default.createElement("div", null, input);
	        }
	      } else {
	        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
	
	        return _react.default.createElement("input", {
	          name: name,
	          type: "hidden",
	          value: _value
	        });
	      }
	    }
	  }, {
	    key: "renderLiveRegion",
	    value: function renderLiveRegion() {
	      if (!this.state.isFocused) return null;
	      return _react.default.createElement(_index.A11yText, {
	        "aria-live": "assertive"
	      }, _react.default.createElement("p", {
	        id: "aria-selection-event"
	      }, "\xA0", this.state.ariaLiveSelection), _react.default.createElement("p", {
	        id: "aria-context"
	      }, "\xA0", this.constructAriaLiveMessage()));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$components4 = this.components,
	          Control = _this$components4.Control,
	          IndicatorsContainer = _this$components4.IndicatorsContainer,
	          SelectContainer = _this$components4.SelectContainer,
	          ValueContainer = _this$components4.ValueContainer;
	      var _this$props20 = this.props,
	          className = _this$props20.className,
	          id = _this$props20.id,
	          isDisabled = _this$props20.isDisabled,
	          menuIsOpen = _this$props20.menuIsOpen;
	      var isFocused = this.state.isFocused;
	      var commonProps = this.commonProps = this.getCommonProps();
	      return _react.default.createElement(SelectContainer, _extends({}, commonProps, {
	        className: className,
	        innerProps: {
	          id: id,
	          onKeyDown: this.onKeyDown
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }), this.renderLiveRegion(), _react.default.createElement(Control, _extends({}, commonProps, {
	        innerRef: this.getControlRef,
	        innerProps: {
	          onMouseDown: this.onControlMouseDown,
	          onTouchEnd: this.onControlTouchEnd
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused,
	        menuIsOpen: menuIsOpen
	      }), _react.default.createElement(ValueContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderPlaceholderOrValue(), this.renderInput()), _react.default.createElement(IndicatorsContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
	    }
	  }]);
	
	  return Select;
	}(_react.Component);
	
	exports.default = Select;
	
	_defineProperty(Select, "defaultProps", defaultProps);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultProps = {
	  defaultInputValue: '',
	  defaultMenuIsOpen: false,
	  defaultValue: null
	};
	exports.defaultProps = defaultProps;
	
	var manageState = function manageState(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(StateManager, _Component);
	
	    function StateManager() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, StateManager);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
	        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
	        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (value, actionMeta) {
	        _this.callProp('onChange', value, actionMeta);
	
	        _this.setState({
	          value: value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (value, actionMeta) {
	        // TODO: for backwards compatibility, we allow the prop to return a new
	        // value, but now inputValue is a controllable prop we probably shouldn't
	        var newValue = _this.callProp('onInputChange', value, actionMeta);
	
	        _this.setState({
	          inputValue: newValue !== undefined ? newValue : value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuOpen", function () {
	        _this.callProp('onMenuOpen');
	
	        _this.setState({
	          menuIsOpen: true
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuClose", function () {
	        _this.callProp('onMenuClose');
	
	        _this.setState({
	          menuIsOpen: false
	        });
	      });
	
	      return _this;
	    }
	
	    _createClass(StateManager, [{
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "getProp",
	      value: function getProp(key) {
	        return this.props[key] !== undefined ? this.props[key] : this.state[key];
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "callProp",
	      value: function callProp(name) {
	        if (typeof this.props[name] === 'function') {
	          var _this$props;
	
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          return (_this$props = this.props)[name].apply(_this$props, args);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            defaultInputValue = _this$props2.defaultInputValue,
	            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
	            defaultValue = _this$props2.defaultValue,
	            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
	
	        return _react.default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          inputValue: this.getProp('inputValue'),
	          menuIsOpen: this.getProp('menuIsOpen'),
	          onChange: this.onChange,
	          onInputChange: this.onInputChange,
	          onMenuClose: this.onMenuClose,
	          onMenuOpen: this.onMenuOpen,
	          value: this.getProp('value')
	        }));
	      }
	    }]);
	
	    return StateManager;
	  }(_react.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	};
	
	var _default = manageState;
	exports.default = _default;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.classNames = classNames;
	exports.handleInputChange = handleInputChange;
	exports.isDocumentElement = isDocumentElement;
	exports.normalizedHeight = normalizedHeight;
	exports.getScrollTop = getScrollTop;
	exports.scrollTo = scrollTo;
	exports.getScrollParent = getScrollParent;
	exports.animatedScrollTo = animatedScrollTo;
	exports.scrollIntoView = scrollIntoView;
	exports.getBoundingClientObj = getBoundingClientObj;
	exports.toKey = toKey;
	exports.isTouchCapable = isTouchCapable;
	exports.isMobileDevice = isMobileDevice;
	exports.cleanValue = exports.emptyString = exports.noop = void 0;
	
	var _raf = _interopRequireDefault(__webpack_require__(1773));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	// ==============================
	// NO OP
	// ==============================
	var noop = function noop() {};
	
	exports.noop = noop;
	
	var emptyString = function emptyString() {
	  return '';
	}; // ==============================
	// Class Name Prefixer
	// ==============================
	
	/**
	 String representation of component state for styling with class names.
	
	 Expects an array of strings OR a string/object pair:
	 - className(['comp', 'comp-arg', 'comp-arg-2'])
	   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
	 - className('comp', { some: true, state: false })
	   @returns 'react-select__comp react-select__comp--some'
	*/
	
	
	exports.emptyString = emptyString;
	
	function applyPrefixToName(prefix, name) {
	  if (!name) {
	    return prefix;
	  } else if (name[0] === '-') {
	    return prefix + name;
	  } else {
	    return prefix + '__' + name;
	  }
	}
	
	function classNames(prefix, cssKey, state, className) {
	  var arr = [cssKey, className];
	
	  if (state && prefix) {
	    for (var key in state) {
	      if (state.hasOwnProperty(key) && state[key]) {
	        arr.push("".concat(applyPrefixToName(prefix, key)));
	      }
	    }
	  }
	
	  return arr.filter(function (i) {
	    return i;
	  }).map(function (i) {
	    return String(i).trim();
	  }).join(' ');
	} // ==============================
	// Clean Value
	// ==============================
	
	
	var cleanValue = function cleanValue(value) {
	  if (Array.isArray(value)) return value.filter(Boolean);
	  if (_typeof(value) === 'object' && value !== null) return [value];
	  return [];
	}; // ==============================
	// Handle Input Change
	// ==============================
	
	
	exports.cleanValue = cleanValue;
	
	function handleInputChange(inputValue, actionMeta, onInputChange) {
	  if (onInputChange) {
	    var newValue = onInputChange(inputValue, actionMeta);
	    if (typeof newValue === 'string') return newValue;
	  }
	
	  return inputValue;
	} // ==============================
	// Scroll Helpers
	// ==============================
	
	
	function isDocumentElement(el) {
	  return [document.documentElement, document.body, window].indexOf(el) > -1;
	} // Normalized Scroll Top
	// ------------------------------
	
	
	function normalizedHeight(el) {
	  if (isDocumentElement(el)) {
	    return window.innerHeight;
	  }
	
	  return el.clientHeight;
	} // Normalized scrollTo & scrollTop
	// ------------------------------
	
	
	function getScrollTop(el) {
	  if (isDocumentElement(el)) {
	    return window.pageYOffset;
	  }
	
	  return el.scrollTop;
	}
	
	function scrollTo(el, top) {
	  // with a scroll distance, we perform scroll on the element
	  if (isDocumentElement(el)) {
	    window.scrollTo(0, top);
	    return;
	  }
	
	  el.scrollTop = top;
	} // Get Scroll Parent
	// ------------------------------
	
	
	function getScrollParent(element) {
	  var style = getComputedStyle(element);
	  var excludeStaticParent = style.position === 'absolute';
	  var overflowRx = /(auto|scroll)/;
	  var docEl = document.documentElement; // suck it, flow...
	
	  if (style.position === 'fixed') return docEl;
	
	  for (var parent = element; parent = parent.parentElement;) {
	    style = getComputedStyle(parent);
	
	    if (excludeStaticParent && style.position === 'static') {
	      continue;
	    }
	
	    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
	      return parent;
	    }
	  }
	
	  return docEl;
	} // Animated Scroll To
	// ------------------------------
	
	/**
	  @param t: time (elapsed)
	  @param b: initial value
	  @param c: amount of change
	  @param d: duration
	*/
	
	
	function easeOutCubic(t, b, c, d) {
	  return c * ((t = t / d - 1) * t * t + 1) + b;
	}
	
	function animatedScrollTo(element, to) {
	  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
	  var start = getScrollTop(element);
	  var change = to - start;
	  var increment = 10;
	  var currentTime = 0;
	
	  function animateScroll() {
	    currentTime += increment;
	    var val = easeOutCubic(currentTime, start, change, duration);
	    scrollTo(element, val);
	
	    if (currentTime < duration) {
	      (0, _raf.default)(animateScroll);
	    } else {
	      callback(element);
	    }
	  }
	
	  animateScroll();
	} // Scroll Into View
	// ------------------------------
	
	
	function scrollIntoView(menuEl, focusedEl) {
	  var menuRect = menuEl.getBoundingClientRect();
	  var focusedRect = focusedEl.getBoundingClientRect();
	  var overScroll = focusedEl.offsetHeight / 3;
	
	  if (focusedRect.bottom + overScroll > menuRect.bottom) {
	    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
	  } else if (focusedRect.top - overScroll < menuRect.top) {
	    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
	  }
	} // ==============================
	// Get bounding client object
	// ==============================
	// cannot get keys using array notation with DOMRect
	
	
	function getBoundingClientObj(element) {
	  var rect = element.getBoundingClientRect();
	  return {
	    bottom: rect.bottom,
	    height: rect.height,
	    left: rect.left,
	    right: rect.right,
	    top: rect.top,
	    width: rect.width
	  };
	}
	
	// ==============================
	// String to Key (kebabify)
	// ==============================
	function toKey(str) {
	  return str.replace(/\W/g, '-');
	} // ==============================
	// Touch Capability Detector
	// ==============================
	
	
	function isTouchCapable() {
	  try {
	    document.createEvent('TouchEvent');
	    return true;
	  } catch (e) {
	    return false;
	  }
	} // ==============================
	// Mobile Device Detector
	// ==============================
	
	
	function isMobileDevice() {
	  try {
	    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	  } catch (e) {
	    return false;
	  }
	}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleFullscreenChange = handleFullscreenChange;
	exports.activate = activate;
	exports.userActivate = userActivate;
	exports.play = play;
	exports.pause = pause;
	exports.togglePlay = togglePlay;
	exports.seek = seek;
	exports.forward = forward;
	exports.replay = replay;
	exports.changeRate = changeRate;
	exports.changeVolume = changeVolume;
	exports.mute = mute;
	exports.toggleFullscreen = toggleFullscreen;
	exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = void 0;
	
	var _fullscreen = _interopRequireDefault(__webpack_require__(758));
	
	var OPERATE = 'video-react/OPERATE';
	exports.OPERATE = OPERATE;
	var FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
	exports.FULLSCREEN_CHANGE = FULLSCREEN_CHANGE;
	var PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
	exports.PLAYER_ACTIVATE = PLAYER_ACTIVATE;
	var USER_ACTIVATE = 'video-react/USER_ACTIVATE';
	exports.USER_ACTIVATE = USER_ACTIVATE;
	
	function handleFullscreenChange(isFullscreen) {
	  return {
	    type: FULLSCREEN_CHANGE,
	    isFullscreen: isFullscreen
	  };
	}
	
	function activate(activity) {
	  return {
	    type: PLAYER_ACTIVATE,
	    activity: activity
	  };
	}
	
	function userActivate(activity) {
	  return {
	    type: USER_ACTIVATE,
	    activity: activity
	  };
	}
	
	function play() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'play',
	    source: ''
	  };
	  this.video.play();
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function pause() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'pause',
	    source: ''
	  };
	  this.video.pause();
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function togglePlay() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'toggle-play',
	    source: ''
	  };
	  this.video.togglePlay();
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	} // seek video by time
	
	
	function seek(time) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'seek',
	    source: ''
	  };
	  this.video.seek(time);
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	} // jump forward x seconds
	
	
	function forward(seconds) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: "forward-".concat(seconds),
	    source: ''
	  };
	  this.video.forward(seconds);
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	} // jump back x seconds
	
	
	function replay(seconds) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: "replay-".concat(seconds),
	    source: ''
	  };
	  this.video.replay(seconds);
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function changeRate(rate) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'change-rate',
	    source: ''
	  };
	  this.video.playbackRate = rate;
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function changeVolume(volume) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'change-volume',
	    source: ''
	  };
	  var v = volume;
	
	  if (volume < 0) {
	    v = 0;
	  }
	
	  if (volume > 1) {
	    v = 1;
	  }
	
	  this.video.volume = v;
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function mute(muted) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: muted ? 'muted' : 'unmuted',
	    source: ''
	  };
	  this.video.muted = muted;
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function toggleFullscreen(player) {
	  if (_fullscreen["default"].enabled) {
	    if (_fullscreen["default"].isFullscreen) {
	      _fullscreen["default"].exit();
	    } else {
	      _fullscreen["default"].request(this.rootElement);
	    }
	
	    return {
	      type: OPERATE,
	      operation: {
	        action: 'toggle-fullscreen',
	        source: ''
	      }
	    };
	  }
	
	  return {
	    type: FULLSCREEN_CHANGE,
	    isFullscreen: !player.isFullscreen
	  };
	}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findElPosition = findElPosition;
	exports.getPointerPosition = getPointerPosition;
	exports.blurNode = blurNode;
	exports.focusNode = focusNode;
	exports.hasClass = hasClass;
	
	/**
	 * Offset Left
	 * getBoundingClientRect technique from
	 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
	 *
	 * @function findElPosition
	 * @param {ReactNodeRef} el React Node ref from which to get offset
	 * @return {Object}
	 */
	function findElPosition(el) {
	  var box;
	
	  if (el.getBoundingClientRect && el.parentNode) {
	    box = el.getBoundingClientRect();
	  }
	
	  if (!box) {
	    return {
	      left: 0,
	      top: 0
	    };
	  }
	
	  var _document = document,
	      body = _document.body,
	      docEl = _document.documentElement;
	  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	  var scrollLeft = window.pageXOffset || body.scrollLeft;
	  var left = box.left + scrollLeft - clientLeft;
	  var clientTop = docEl.clientTop || body.clientTop || 0;
	  var scrollTop = window.pageYOffset || body.scrollTop;
	  var top = box.top + scrollTop - clientTop; // Android sometimes returns slightly off decimal values, so need to round
	
	  return {
	    left: Math.round(left),
	    top: Math.round(top)
	  };
	}
	/**
	 * Get pointer position in a React Node ref
	 * Returns an object with x and y coordinates.
	 * The base on the coordinates are the bottom left of the element.
	 *
	 * @function getPointerPosition
	 * @param {ReactNodeRef} el React Node ref on which to get the pointer position on
	 * @param {Event} event Event object
	 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
	 */
	
	
	function getPointerPosition(el, event) {
	  var position = {};
	  var box = findElPosition(el);
	  var boxW = el.offsetWidth;
	  var boxH = el.offsetHeight;
	  var boxY = box.top;
	  var boxX = box.left;
	  var evtPageY = event.pageY;
	  var evtPageX = event.pageX;
	
	  if (event.changedTouches) {
	    evtPageX = event.changedTouches[0].pageX;
	    evtPageY = event.changedTouches[0].pageY;
	  }
	
	  position.y = Math.max(0, Math.min(1, (boxY - evtPageY + boxH) / boxH));
	  position.x = Math.max(0, Math.min(1, (evtPageX - boxX) / boxW));
	  return position;
	} // blur an element
	
	
	function blurNode(reactNode) {
	  if (reactNode && reactNode.blur) {
	    reactNode.blur();
	  }
	} // focus an element
	
	
	function focusNode(reactNode) {
	  if (reactNode && reactNode.focus) {
	    reactNode.focus();
	  }
	} // check if an element has a class name
	
	
	function hasClass(elm, cls) {
	  var classes = elm.className.split(' ');
	
	  for (var i = 0; i < classes.length; i++) {
	    if (classes[i].toLowerCase() === cls.toLowerCase()) {
	      return true;
	    }
	  }
	
	  return false;
	}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(394);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(101);
	var normalizeHeaderName = __webpack_require__(788);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(396);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(396);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(170)))

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAddressses = getAddressses;
	exports.createSaveAddress = createSaveAddress;
	exports.deleteAddress = deleteAddress;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting addresses from api
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/address
	 */
	function getAddressses(customerId) {
	  var url = _constants.API_URL + '/CustomerClient/';
	  if (customerId !== undefined) {
	    url = url + customerId;
	  } else {
	    url = url + 0;
	  }
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Saves/Creates an address
	 * @return {Promise} Axios promise
	 */
	function createSaveAddress(data) {
	  var url = _constants.API_URL + '/CustomerClient/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Delete an address
	 * @return {Promise} Axios promise
	 */
	function deleteAddress(data) {
	  var url = _constants.API_URL + '/CustomerClient/Delete';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBookingTime = getBookingTime;
	exports.saveBookingTime = saveBookingTime;
	exports.GetValidDelivery = GetValidDelivery;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting booking times
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/bookingTime
	 */
	function getBookingTime(orderId) {
	  var url = _constants.API_URL + '/BookingTime/Get/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url, { headers: { 'Cache-Control': 'no-cache, no-store' } }); // Prevents simultanous requests from stalling on Chrome
	  };
	}
	
	/**
	 * @description Update booking times
	 * @return {Promise} Axios promise
	 */
	function saveBookingTime(data) {
	  var url = _constants.API_URL + '/BookingTime/Post/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      dispatch({
	        type: _constants.SET_ORDER_BOOKING_TIMES,
	        data: res.data
	      });
	      return res;
	    });
	  };
	}
	
	function GetValidDelivery(data) {
	  var url = _constants.API_URL + '/BookingTime/GetValidDelivery/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.postNote = postNote;
	exports.deleteNote = deleteNote;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Creating an note using the API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/notes
	 */
	function postNote(data) {
	  var url = _constants.API_URL + '/Notes/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Deleting an note using the API
	 * @return {Promise} Axios promise
	 */
	function deleteNote(id) {
	  var url = _constants.API_URL + '/Notes/Delete/' + id;
	  return function (dispatch) {
	    return _axios2.default.post(url, {});
	  };
	}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMessage = getMessage;
	exports.createUpdateMessage = createUpdateMessage;
	exports.deleteMessage = deleteMessage;
	exports.getMessageChain = getMessageChain;
	exports.getMessageCompany = getMessageCompany;
	exports.fileUpload = fileUpload;
	exports.fileDelete = fileDelete;
	exports.updateNewsShowStatus = updateNewsShowStatus;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get message by id
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/messages
	 */
	function getMessage(id) {
	  var url = _constants.API_URL + '/Message/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Post update / insert message to api
	 * @return {Promise} Axios promise
	 */
	function createUpdateMessage(data) {
	  var url = _constants.API_URL + '/Message/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description delete message to api
	 * @return {Promise} Axios promise
	 */
	function deleteMessage(id) {
	  var url = _constants.API_URL + '/Message/Delete/' + id;
	  return function (dispatch) {
	    return _axios2.default.post(url);
	  };
	}
	
	/**
	 * @description Get all chain messages from api
	 * @return {Promise} Axios promise
	 */
	function getMessageChain(id) {
	  var url = _constants.API_URL + '/Message/GetChain/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get all company messages by id from api
	 * @return {Promise} Axios promise
	 */
	function getMessageCompany(id) {
	  var url = _constants.API_URL + '/Message/GetCompany/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Upload file
	 * @return ..
	 */
	function fileUpload(file, type) {
	  var url = _constants.FILE_STORAGE_API + '/fileservice/upload?orderID=0';
	  var data = new window.FormData();
	  data.append(file.name, file);
	  if (typeof type !== 'undefined') {
	    data.append('Type', type);
	  }
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Delete file
	 * @return ..
	 */
	function fileDelete(data) {
	  var url = _constants.FILE_STORAGE_API + '/FileService/Delete';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Update news show status
	 * @return ..
	 */
	function updateNewsShowStatus(data) {
	  var url = _constants.FILE_STORAGE_API + '/Message/UpdateShowStatus/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getQualityCheckSettingsList = getQualityCheckSettingsList;
	exports.getQualityCheckSettings = getQualityCheckSettings;
	exports.getAgreementQualityCheckSettings = getAgreementQualityCheckSettings;
	exports.updateQualityCheckSettings = updateQualityCheckSettings;
	exports.updateOrderCheck = updateOrderCheck;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Gets the QualityCheck settings list for a chain/shop from the API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/prices
	 */
	function getQualityCheckSettingsList(chainId, shopId) {
	  var data = {
	    ChainId: chainId,
	    ShopId: shopId
	  };
	  var url = _constants.API_URL + '/QualityCheck/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Gets QualityCheck settings from the API
	 * @return {Promise} Axios promise
	 */
	function getQualityCheckSettings(id) {
	  var url = _constants.API_URL + '/QualityCheck/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Gets QualityCheck settings from the API
	 * @return {Promise} Axios promise
	 */
	function getAgreementQualityCheckSettings(priceModelId) {
	  var url = _constants.API_URL + '/QualityCheck/PriceModel/' + priceModelId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	/**
	 * @description Updates the QualityCheck settings through the API
	 * @return {Promise} Axios promise
	 */
	function updateQualityCheckSettings(data) {
	  var url = _constants.API_URL + '/QualityCheck/Post/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Update order check
	 * @return {Promise} Axios promise
	 */
	function updateOrderCheck(data) {
	  var url = _constants.API_URL + '/Order/OrderCheck/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getShopOwners = getShopOwners;
	exports.getShopOwner = getShopOwner;
	exports.CreateSaveShopOwner = CreateSaveShopOwner;
	exports.getShopList = getShopList;
	exports.updateShop = updateShop;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting employees from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/customers
	 */
	function getShopOwners(id) {
	  id = typeof id !== 'undefined' ? id : 0;
	  var url = _constants.API_URL + '/ShopOwner/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_CUSTOMERS,
	        shopowners: res.data
	      });
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Getting shop owner from API
	 * @return {Promise} Axios promise
	 */
	function getShopOwner(id) {
	  var url = _constants.API_URL + '/ShopOwner/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a shop owner
	 * @return {Promise} Axios promise
	 */
	function CreateSaveShopOwner(data) {
	  var url = _constants.API_URL + '/ShopOwner/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Getting shop from API
	 * @return {Promise} Axios promise
	 */
	function getShopList(id) {
	  var url = _constants.API_URL + '/Shop/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Add/Remove shop for shop owner
	 * @return {Promise} Axios promise
	 */
	function updateShop(data) {
	  var url = _constants.API_URL + '/ShopOwner/Shop/Post/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPartnerContacts = getPartnerContacts;
	exports.getPartnerContact = getPartnerContact;
	exports.CreateSavePartnerContact = CreateSavePartnerContact;
	exports.sendPartnerPassword = sendPartnerPassword;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting partner contact list from API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/workProviderContact
	 */
	function getPartnerContacts(partnerID) {
	  var url = _constants.API_URL + '/WorkProviderContact/' + partnerID;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting partner contact from API
	 * @return {Promise} Axios promise
	 */
	function getPartnerContact(partnerContactID) {
	  var url = _constants.API_URL + '/WorkProviderContact/get/' + partnerContactID;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a partner contact
	 * @return {Promise} Axios promise
	 */
	function CreateSavePartnerContact(data) {
	  var url = _constants.API_URL + '/WorkProviderContact/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Creating/saving a customer
	 * @return {Promise} Axios promise
	 */
	function sendPartnerPassword(data) {
	  var url = _constants.API_URL + '/WorkProviderContact/SendLogin/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _mypage = __webpack_require__(151);
	
	var _tasks = __webpack_require__(194);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _Comments = __webpack_require__(875);
	
	var _Comments2 = _interopRequireDefault(_Comments);
	
	var _Files = __webpack_require__(876);
	
	var _Files2 = _interopRequireDefault(_Files);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _auth = __webpack_require__(8);
	
	__webpack_require__(1409);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _image = __webpack_require__(452);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	// import { ElementIcons } from '../../../../shared/elements/icons'
	// import Icon from '../../../../shared/elements/icon'
	
	
	var MyTasksTask = function (_Component) {
	  _inherits(MyTasksTask, _Component);
	
	  function MyTasksTask(props) {
	    _classCallCheck(this, MyTasksTask);
	
	    var _this = _possibleConstructorReturn(this, (MyTasksTask.__proto__ || Object.getPrototypeOf(MyTasksTask)).call(this, props));
	
	    _this.state = {
	      task: {},
	      scrollOffset: 0
	    };
	    return _this;
	  }
	
	  _createClass(MyTasksTask, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateTaskFromProps(this.props.item);
	
	      if (this.props.modal === true) {
	        this.setScroll(false);
	      }
	
	      setTimeout(function () {
	        var backdrop = document.getElementsByClassName('backdrop')[0];
	        if (backdrop) {
	          backdrop.style = 'display: none;';
	        }
	        backdrop = document.getElementsByClassName('updating--state')[0];
	        if (backdrop) {
	          backdrop.style = 'display: none;';
	        }
	      }, 100);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.item && nextProps.item.OccurrenceId !== this.props.item.OccurrenceId) {
	        this.updateTaskFromProps(nextProps.item);
	      }
	
	      if (nextProps.modal === true && this.props.modal === false) {
	        this.setScroll(false);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setScroll(true);
	
	      var backdrop = document.getElementsByClassName('backdrop')[0];
	      if (backdrop) {
	        backdrop.style = undefined;
	      }
	
	      backdrop = document.getElementsByClassName('updating--state')[0];
	      if (backdrop) {
	        backdrop.style = undefined;
	      }
	    }
	  }, {
	    key: 'updateTaskFromProps',
	    value: function updateTaskFromProps(task) {
	      this.setState({
	        task: _extends({}, task, {
	          Assigns: []
	        })
	      });
	      this.getFiles(task.OccurrenceId);
	      this.getAssigns(task.OccurrenceId);
	    }
	  }, {
	    key: 'getAssigns',
	    value: function getAssigns(id) {
	      var _this2 = this;
	
	      this.props.getOccurrenceAssigns(id).then(function (res) {
	        _this2.setState({
	          task: _extends({}, _this2.state.task, {
	            Assigns: res.data
	          })
	        });
	      });
	    }
	  }, {
	    key: 'setScroll',
	    value: function setScroll(show) {
	      var app = document.getElementById('app');
	      if (show) {
	        app.style = null;
	        app.scrollTop = this.state.scrollOffset;
	      } else if (show === false) {
	        this.setState({
	          scrollOffset: app.scrollTop
	        }, function () {
	          app.scrollTop = 0;
	          app.style.overflow = 'hidden';
	        });
	      }
	    }
	  }, {
	    key: 'getFiles',
	    value: function getFiles(id) {
	      var _this3 = this;
	
	      this.props.getOccurenceFiles(id).then(function (res) {
	        _this3.setState({
	          task: _extends({}, _this3.state.task, {
	            Files: res.data
	          })
	        });
	      });
	    }
	  }, {
	    key: 'renderAttachments',
	    value: function renderAttachments(files) {
	      if (!Array.isArray(files) || files.length === 0) return null;
	
	      var imgFiles = [];
	      var otherFiles = [];
	      files.forEach(function (file) {
	        return file.IsImage ? imgFiles.push(file) : otherFiles.push(file);
	      });
	
	      var renderFile = function renderFile(file, index) {
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	        return _react2.default.createElement(
	          'li',
	          { key: index, className: 'file-document' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          _react2.default.createElement(
	            'a',
	            { target: '_BLANK', href: file.FileURL },
	            file.FileName
	          )
	        );
	      };
	      // Render image
	      var renderImage = function renderImage(image, key) {
	        return _react2.default.createElement(_image2.default, { key: key, imageFile: image });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_divider2.default, null),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('352') },
	          otherFiles.length !== 0 && _react2.default.createElement(
	            'div',
	            { className: 'docs' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              otherFiles.map(renderFile)
	            )
	          ),
	          imgFiles.length !== 0 && _react2.default.createElement(_Gallery2.default, { files: imgFiles, renderImage: renderImage })
	        )
	      );
	    }
	  }, {
	    key: 'content',
	    value: function content(task) {
	      var spans = window.innerWidth <= 930 ? '1' : '2';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'myTasksTask__screen' },
	        _react2.default.createElement(
	          _col2.default,
	          { span: spans },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)(task.Category) },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('1021') },
	              (0, _helpers.translation)(task.Category)
	            ),
	            task.Description.split('\n').map(function (line, key) {
	              return _react2.default.createElement(
	                'span',
	                { key: key },
	                line,
	                _react2.default.createElement('br', null)
	              );
	            }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('15086') },
	              task.Assigns.map(function (x, key) {
	                return _react2.default.createElement(
	                  'div',
	                  { key: key },
	                  x
	                );
	              })
	            ),
	            window.innerWidth <= 760 && _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)(1232) },
	              _react2.default.createElement(
	                'div',
	                { className: 'deadline-date' },
	                (0, _time.renderFullDate)(task.Deadline, false)
	              )
	            ),
	            task.Files && this.renderAttachments(task.Files.OtherTaskFiles)
	          )
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { span: spans },
	          _react2.default.createElement(_Files2.default, { OccurrenceId: task.OccurrenceId, files: task.Files ? task.Files.OtherTaskOccurrenceFiles : [] })
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { span: spans },
	          _react2.default.createElement(_Comments2.default, { OccurrenceId: task.OccurrenceId })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      var task = this.state.task;
	
	      if (typeof task === 'undefined') return null;
	      if (Object.keys(task).length === 0) return null;
	
	      // const makeTime = () => {
	      //   return renderFullDate(task.Deadline, false)
	      // }
	      // let labelText = (
	      //   <Grid cols={[1, 'max-content']}>
	      //     {task.Title}
	      //   </Grid>
	      // )
	      // let deadlineText = (
	      //   <Grid cols={[1, 'max-content']}>
	      //     {translation('1232')}
	      //   </Grid>
	      // )
	
	      // if (this.props.modal !== true) {
	      //   return this.content(task)
	      // }
	
	      return this.content(task);
	
	      /*
	      return (
	        <div className='myTaskOverlay' data-modal='true'>
	          <Panel>
	            <Grid cols={[1, 1, 1]} spacing={1} align='center'>
	              <LabelWrapper labelText={labelText}>
	                {translation(task.Category)}
	              </LabelWrapper>
	              <LabelWrapper labelText={deadlineText}>
	                {makeTime()}
	              </LabelWrapper>
	              <div className='closeButton'>
	                <CloseButton size='l' onClick={this.props.onClose} />
	              </div>
	            </Grid>
	          </Panel>
	          <div className='content'>
	            {this.content(task)}
	          </div>
	        </div>
	      )
	      */
	    }
	  }]);
	
	  return MyTasksTask;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOccurenceFiles: _mypage.getOccurenceFiles,
	  getOccurrenceAssigns: _tasks.getOccurrenceAssigns
	})(MyTasksTask);

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _PriceModelLogModal = __webpack_require__(470);
	
	var _PriceModelLogModal2 = _interopRequireDefault(_PriceModelLogModal);
	
	var _priceModel = __webpack_require__(75);
	
	var _customers = __webpack_require__(74);
	
	var _backdrop = __webpack_require__(29);
	
	var _common = __webpack_require__(25);
	
	var _customerGroup = __webpack_require__(107);
	
	var _config = __webpack_require__(933);
	
	__webpack_require__(1438);
	
	__webpack_require__(336);
	
	var _currency = __webpack_require__(41);
	
	var _percent = __webpack_require__(178);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _PriceItemGroup = __webpack_require__(228);
	
	var _PriceItemGroup2 = _interopRequireDefault(_PriceItemGroup);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableExpand = __webpack_require__(140);
	
	var _tableExpand2 = _interopRequireDefault(_tableExpand);
	
	var _tableHeader = __webpack_require__(132);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Datetime from 'react-datetime'
	
	// Modals
	
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	// formatCurrency, reverseFormatCurrency
	
	
	// import components
	
	// import Extras from '../Extras'
	
	
	// Elements
	
	
	var AgreementDetails = function (_Component) {
	  _inherits(AgreementDetails, _Component);
	
	  function AgreementDetails(props) {
	    _classCallCheck(this, AgreementDetails);
	
	    var _this = _possibleConstructorReturn(this, (AgreementDetails.__proto__ || Object.getPrototypeOf(AgreementDetails)).call(this, props));
	
	    _this.state = {
	      IsWorking: false,
	      showPriceModelLog: false,
	      log: [{
	        ChangeTable: 0,
	        ChangeTableId: 0,
	        ChangeField: 0,
	        PartItemId: 0,
	        ChangeType: 0,
	        ChangedById: 0,
	        ChangedByName: null,
	        ChangedAt: '',
	        From: 0,
	        To: 0,
	        FromText: null,
	        ToText: null
	      }],
	      priceOriginal: {},
	      price: {},
	      parts: [],
	      new_startprice: {
	        Price: '',
	        AE: '',
	        Mat: '',
	        Env: '',
	        Net: '',
	        Discount: '',
	        Total: '',
	        Type: 0
	      },
	      new_startprice1: {
	        Price: '',
	        AE: '',
	        Mat: '',
	        Env: '',
	        Net: '',
	        Discount: '',
	        Total: '',
	        Type: 1
	      },
	      new_addonstarttime: {
	        Name: '',
	        AE: '',
	        Mat: '',
	        Price: '',
	        Env: '',
	        Net: '',
	        Discount: '',
	        Total: ''
	      },
	      new_addonpart: {
	        Name: '',
	        AE: '',
	        Mat: ''
	      },
	      new_indexAdjust: {
	        IndexAdjustmentId: 0,
	        Date: '',
	        Amount: 0,
	        IsApplied: false,
	        IsDeleted: false
	      },
	      confirm: {
	        open: false,
	        type: 0
	      },
	      confirmDelete: {
	        open: false
	      },
	      confirmDeactivate: {
	        open: false
	      },
	      confirmActivate: {
	        open: false
	      },
	      ShopId: 0,
	      customers: [],
	      dimensions: {
	        width: 0,
	        height: 0
	      },
	      customersList: [],
	      isCustomer: false,
	      isShop: false,
	      selectedCustomerId: props.selectedCustomerId !== undefined && props.selectedCustomerId !== null ? props.selectedCustomerId : -1,
	      isMain: props.isMain !== undefined ? props.isMain : false
	    };
	    _this.AERounding = 5;
	    _this.switchRecommended = _this.switchRecommended.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onInputBlur = _this.onInputBlur.bind(_this);
	    // this.renderPartItem = this.renderPartItem.bind(this)
	    // this.renderPartItemTask = this.renderPartItemTask.bind(this)
	    _this.changeType = _this.changeType.bind(_this);
	    _this.renderAddonParts = _this.renderAddonParts.bind(_this);
	    _this.renderPriceModelLog = _this.renderPriceModelLog.bind(_this);
	    _this.renderIndexAdjustments = _this.renderIndexAdjustments.bind(_this);
	    _this.showPriceModelLog = _this.showPriceModelLog.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	
	    _this.moveItem = _this.moveItem.bind(_this);
	    _this.getItemListName = _this.getItemListName.bind(_this);
	    _this.getItemIdField = _this.getItemIdField.bind(_this);
	    _this.updateOrAddItem = _this.updateOrAddItem.bind(_this);
	    _this.deleteItem = _this.deleteItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(AgreementDetails, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.isMain) {
	        this.getPriceList(this.props);
	      } else {
	        // if (this.props.agreementPrice !== undefined && this.props.agreementPrice.PriceModelId !== undefined) {
	        //   this.setState({
	        //     price: this.props.agreementPrice,
	        //     priceOriginal: this.props.agreementPrice
	        //   }, () => {
	        //     this.mapParts(this.state.price)
	        //     // console.log('mapped')
	        //   })
	        // }
	        this.setState({
	          price: {},
	          priceOriginal: {},
	          parts: [],
	          new_startprice: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 0
	          },
	          new_startprice1: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 1
	          },
	          new_addonstarttime: {
	            Name: '',
	            AE: '',
	            Mat: '',
	            Price: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: ''
	          },
	          new_addonpart: {
	            Name: '',
	            AE: '',
	            Mat: ''
	          },
	          new_indexAdjust: {
	            IndexAdjustmentId: 0,
	            Date: '',
	            Amount: 0,
	            IsApplied: false,
	            IsDeleted: false
	          },
	          Log: [{
	            ChangeTable: 0,
	            ChangeTableId: 0,
	            ChangeField: 0,
	            PartItemId: 0,
	            ChangeType: 0,
	            ChangedById: 0,
	            ChangedByName: null,
	            ChangedAt: '',
	            From: 0,
	            To: 0,
	            FromText: null,
	            ToText: null
	          }]
	        });
	      }
	      this.getCustomersList(this.props);
	      this.state.isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      this.state.isShop = (0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType);
	      window.addEventListener('resize', this.updateDimensions);
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'getCustomersList',
	    value: function getCustomersList(props) {
	      var _this2 = this;
	
	      return props.getShopCustomers(props.item.CustomerGroupId).then(function (res) {
	        _this2.setState({
	          customersList: res.data
	        });
	        return res;
	      }, function () {
	        console.log('Err fetching price lists data');
	        return null;
	      });
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this3 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this3.state.dimensions.width;
	          if (width > higherThan && width < lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this4 = this;
	
	      if (!(0, _lodash.isEqual)(nextProps.item, this.props.item)) {
	        this.setState({
	          price: {},
	          priceOriginal: {},
	          parts: [],
	          new_startprice: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 0
	          },
	          new_startprice1: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 1
	          },
	          new_addonstarttime: {
	            Name: '',
	            AE: '',
	            Mat: '',
	            Price: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: ''
	          },
	          new_addonpart: {
	            Name: '',
	            AE: '',
	            Mat: ''
	          },
	          new_indexAdjust: {
	            IndexAdjustmentId: 0,
	            Date: '',
	            Amount: 0,
	            IsApplied: false,
	            IsDeleted: false
	          },
	          Log: [{
	            ChangeTable: 0,
	            ChangeTableId: 0,
	            ChangeField: 0,
	            PartItemId: 0,
	            ChangeType: 0,
	            ChangedById: 0,
	            ChangedByName: null,
	            ChangedAt: '',
	            From: 0,
	            To: 0,
	            FromText: null,
	            ToText: null
	          }],
	          customersList: [],
	          isMain: nextProps.isMain !== undefined ? nextProps.isMain : false
	        }, function () {
	          // console.log('getPriceList')
	          _this4.getPriceList(nextProps);
	          _this4.getCustomersList(nextProps);
	        });
	      }
	      var hasAgreementPrice = this.props.agreementPrice !== undefined && this.props.agreementPrice.PriceModelId !== undefined;
	      var hasAgreementPriceNext = nextProps.agreementPrice !== undefined && nextProps.agreementPrice.PriceModelId !== undefined;
	      var hasBothAgPrice = hasAgreementPrice && hasAgreementPriceNext;
	      var isEqualPMId = hasBothAgPrice && (0, _lodash.isEqual)(this.props.agreementPrice.PriceModelId, nextProps.agreementPrice.PriceModelId);
	      var isEqualTab = (0, _lodash.isEqual)(nextProps.selectedTabIndex, this.props.selectedTabIndex);
	      var isEqualCustomerId = (0, _lodash.isEqual)(nextProps.selectedCustomerId, this.props.selectedCustomerId);
	      // Get agreement again when clicking away from shops tab
	      if (!isEqualTab && nextProps.selectedTabIndex !== 1) {
	        // console.log('getPriceModel')
	        if (!isEqualPMId) {
	          // console.log('getPriceModel1')
	          this.getPriceModel(nextProps, this.props.agreementId);
	        } else {
	          // console.log('getPriceModel2')
	          this.mapParts(nextProps.agreementPrice);
	        }
	      }
	      if (!isEqualCustomerId && nextProps.selectedCustomerId > 0) {
	        if (!isEqualPMId) {
	          //   this.getCustomerAgreement(nextProps.agreementId, nextProps.selectedCustomerId)
	          // } else {
	          this.setState({
	            price: nextProps.agreementPrice,
	            priceOriginal: (0, _lodash.cloneDeep)(nextProps.agreementPrice)
	          }, function () {
	            // console.log('changed customer')
	            _this4.mapParts(nextProps.agreementPrice);
	          });
	        }
	      }
	      if (isEqualCustomerId && nextProps.selectedCustomerId > 0 && (!hasAgreementPrice && hasAgreementPriceNext || hasBothAgPrice)) {
	        this.setState({
	          price: nextProps.agreementPrice,
	          priceOriginal: (0, _lodash.cloneDeep)(nextProps.agreementPrice),
	          agreementPrice: nextProps.agreementPrice
	        }, function () {
	          // console.log('reload from server')
	          _this4.mapParts(_this4.state.price);
	        });
	      }
	      // console.log('hasAgreementPrice', hasAgreementPrice, 'hasAgreementPriceNext', hasAgreementPriceNext, 'isEqualCustomerId', isEqualCustomerId, 'isEqualPMId', isEqualPMId)
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      // Fix to missing brands
	      if (nextProps.brands === null || nextProps.brands.length === 0) {
	        this.props.getBrands();
	      }
	    }
	  }, {
	    key: 'getCustomerAgreement',
	    value: function getCustomerAgreement(agreementId, customerId, companyId) {
	      var _this5 = this;
	
	      if (agreementId > 0 && customerId > 0) {
	        this.props.getShopCustomerAgreement(agreementId, customerId, companyId).then(function (res) {
	          _this5.setState({
	            price: res.data,
	            priceOriginal: res.data
	          });
	          _this5.mapParts(res.data);
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	          _this5.props.onShouldUpdate();
	        });
	      }
	    }
	  }, {
	    key: 'getPriceModel',
	    value: function getPriceModel(props, id) {
	      var _this6 = this;
	
	      if ((this.state.selectedCustomerId === -1 || props.selectedTabIndex === 0) && this.state.isMain && props.item !== null && props.item.PriceModelId > 0) {
	        props.getPriceList(id).then(function (res) {
	          _this6.setState({
	            price: res.data,
	            priceOriginal: (0, _lodash.cloneDeep)(res.data)
	          });
	          _this6.mapParts(res.data);
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	          _this6.props.onShouldUpdate();
	        });
	      } else {
	        this.getCustomerAgreement(id, this.props.selectedCustomerId, this.props.selectedShopId);
	      }
	    }
	  }, {
	    key: 'getPriceList',
	    value: function getPriceList(props) {
	      this.getPriceModel(props, props.item.PriceModelId);
	    }
	  }, {
	    key: 'shouldUpdatePrices',
	    value: function shouldUpdatePrices(val1, val2) {
	      return val1 !== val2;
	    }
	  }, {
	    key: 'updatePrices',
	    value: function updatePrices(price) {
	      var _this7 = this;
	
	      var setPriceState = function setPriceState(data) {
	        // console.log('updatePrices', data)
	        _this7.setState({
	          price: data,
	          priceOriginal: (0, _lodash.cloneDeep)(data),
	          new_startprice: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 0
	          },
	          new_startprice1: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 1
	          },
	          new_addonstarttime: {
	            Name: '',
	            AE: '',
	            Mat: '',
	            Price: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: ''
	          },
	          new_addonpart: {
	            Name: '',
	            AE: '',
	            Mat: ''
	          },
	          new_indexAdjust: {
	            IndexAdjustmentId: 0,
	            Date: '',
	            Amount: 0,
	            IsApplied: '',
	            IsDeleted: false
	          },
	          ShopId: 0,
	          customers: [],
	          Log: [{
	            ChangeTable: 0,
	            ChangeTableId: 0,
	            ChangeField: 0,
	            PartItemId: 0,
	            ChangeType: 0,
	            ChangedById: 0,
	            ChangedByName: null,
	            ChangedAt: '',
	            From: 0,
	            To: 0,
	            FromText: null,
	            ToText: null
	          }],
	          // selectedShopId: -1,
	          customersList: []
	        });
	        _this7.mapParts(data);
	        _this7.getCustomersList(_this7.props);
	      };
	      this.setState({ IsWorking: true });
	      return this.props.updatePriceList(price).then(function (res) {
	        setPriceState(res.data);
	        _this7.setState({ IsWorking: false });
	        // Toastr
	        // window.toastr.success(translation('13444'), translation('13424'))
	        // Return
	        return res;
	      }, function (err) {
	        _this7.setState({ IsWorking: false });
	        // console.log('Error response ', err.response.data.Error)
	        var errorDescription = null;
	        switch (err.response.data.Error) {
	          case 1:
	            // Conflict with existing
	            errorDescription = '1793';
	            break;
	          case 2:
	            // Not allowed
	            errorDescription = '16487';
	            break;
	          case 5:
	            // Main agreement not active
	            errorDescription = '16488';
	            break;
	          case 6:
	            // Need Premium
	            errorDescription = '16489';
	            break;
	          case 7:
	            // Not a WP
	            errorDescription = '16490';
	            break;
	          case 1000:
	            // Unspecified error
	            errorDescription = '1795';
	            break;
	        }
	        if (errorDescription !== null) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445') + ':</br>' + (0, _helpers.translation)(errorDescription), (0, _helpers.translation)('216'));
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        }
	
	        // console.log('error ', err.response)
	        setPriceState(err.response.data);
	        // this.props.router.push('/prices')
	        // Return
	        return err;
	      });
	    }
	  }, {
	    key: 'onlyShow',
	    value: function onlyShow() {
	      var useRecommended = this.state.price.UseRecommended;
	      var isWP = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      if (!isWP) {
	        if (this.props.customer) return true;
	        return useRecommended;
	      }
	      return false;
	    }
	  }, {
	    key: 'mapParts',
	    value: function mapParts(data) {
	      var newData = [];
	      // Parts
	      data.Parts.map(function (val, index) {
	        newData[val.PartItemId] = {
	          part: val,
	          tasks: []
	        };
	      });
	      // Tasks
	      data.TaskPrices.map(function (val, index) {
	        newData[val.PartItem.PartItemId].tasks.push(val);
	      });
	      this.setState({
	        parts: newData
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this8 = this;
	
	      e.persist();
	      var value = (0, _percent.transformPercent)(e.target.value, true);
	      var name = e.target.name;
	
	      if (name === 'Active') {
	        var popup = {
	          confirmDeactivate: {
	            open: true
	          }
	        };
	        if (e.target.checked) {
	          popup = {
	            confirmActivate: {
	              open: true,
	              type: 'Active'
	            }
	          };
	        }
	
	        this.setState(popup);
	        return;
	      }
	
	      if (name === 'ActiveFromParent') {
	        if (e.target.checked && this.props.item.Active && !this.state.price.Active) {
	          // link when main agreement active and sub agreement inactive
	          this.setState({
	            confirmActivate: {
	              open: true,
	              type: 'ActiveFromParent'
	            }
	          });
	          return;
	        }
	      }
	
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	
	      if (e.target.name === 'Comment') {
	        value = e.target.value;
	      }
	
	      this.setState({
	        price: _extends({}, this.state.price, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this8.updatePrices(_this8.state.price).then(function (res) {
	            // if (name === 'Active') {
	            // this.props.getPriceLists(this.props)
	            // }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'switchRecommended',
	    value: function switchRecommended(e) {
	      var value = e.target.value === 'yes';
	      var price = _extends({}, this.state.price);
	      price.UseRecommended = value;
	      this.updatePrices(price);
	    }
	  }, {
	    key: 'onInputBlur',
	    value: function onInputBlur(e) {
	      var _this9 = this;
	
	      var name = e.target.name;
	      if (name === 'PriceHourly') {
	        var value = e.target.value === '' ? '0' : e.target.value;
	        this.state.price.PriceHourly = (0, _currency.reverseFormatCurrency2)(value);
	      }
	      if (name === 'PriceMaterial') {
	        var _value = e.target.value === '' ? '0' : (0, _percent.transformPercent)(e.target.value, true);
	        this.state.price.PriceMaterial = (0, _currency.reverseFormatCurrency2)(_value);
	      }
	      if (name === 'PriceEnvironment') {
	        var _value2 = e.target.value === '' ? '0' : (0, _percent.transformPercent)(e.target.value, true);
	        this.state.price.PriceEnvironment = (0, _currency.reverseFormatCurrency2)(_value2);
	      }
	      if (name === 'PriceDiscount') {
	        var _value3 = e.target.value === '' ? '0' : (0, _percent.transformPercent)(e.target.value, true);
	        this.state.price.PriceDiscount = (0, _currency.reverseFormatCurrency2)(_value3);
	      }
	      if (this.shouldUpdatePrices(this.state.price[e.target.name], this.state.priceOriginal[e.target.name])) {
	        this.updatePrices(this.state.price).then(function (res) {
	          if (name === 'Name') {
	            _this9.props.getPriceLists(_this9.props);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType(e) {
	      var _this10 = this;
	
	      var value = parseInt(e.target.value);
	      this.setState({
	        price: _extends({}, this.state.price, _defineProperty({}, e.target.name, value))
	      }, function () {
	        _this10.updatePrices(_this10.state.price).then(function (res) {
	          _this10.props.getPriceLists(_this10.props);
	        });
	      });
	    }
	  }, {
	    key: 'renderPrices',
	    value: function renderPrices() {
	      var _this11 = this;
	
	      var isCustomer = this.state.isCustomer; // || this.state.isShop
	      if (isCustomer) return null;
	      // let isCustomer = this.props.customer
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	      var price = this.state.price;
	
	      var isDisabled = !(0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      // Render environment discount
	      var renderEnviDiscount = function renderEnviDiscount() {
	        if (_this11.shouldRender(1) || (0, _auth.hasAccess)([6], _this11.props.auth.user.UserType)) {
	          return _react2.default.createElement(_switch2.default, { name: 'IsEnvironmentDiscount', onChange: _this11.onInputChange, checked: price.IsEnvironmentDiscount, disabled: isDisabled, labelText: (0, _helpers.translation)('1236') });
	        }
	        return null;
	      };
	      // IF Customer
	      if (this.props.customer && price.UseRecommended) {
	        isDisabled = true;
	      }
	      var priceHourly = (0, _currency.formatCurrency2)(price.PriceHourly === undefined || price.PriceHourly === '' ? '0' : price.PriceHourly);
	      var priceMaterial = (0, _percent.transformPercent)((0, _currency.formatCurrency2)(price.PriceMaterial === undefined || price.PriceMaterial === '' ? '0' : price.PriceMaterial));
	      var priceEnvironment = (0, _percent.transformPercent)((0, _currency.formatCurrency2)(price.PriceEnvironment === undefined || price.PriceEnvironment === '' ? '0' : price.PriceEnvironment));
	      // let priceDiscount = transformPercent(formatCurrency2((price.PriceDiscount === undefined || price.PriceDiscount === '') ? '0' : price.PriceDiscount))
	
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13354') },
	        _react2.default.createElement(_text2.default, {
	          name: 'PriceHourly',
	          value: priceHourly,
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('419'),
	          helpText: (0, _helpers.translation)('1954')
	        }),
	        _react2.default.createElement(_text2.default, {
	          name: 'PriceMaterial',
	          value: priceMaterial,
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          onFocus: _percent.onPercentFocus,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('417'),
	          helpText: (0, _helpers.translation)('1955')
	        }),
	        _react2.default.createElement(_text2.default, {
	          name: 'PriceEnvironment',
	          value: priceEnvironment,
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          onFocus: _percent.onPercentFocus,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('13339'),
	          helpText: (0, _helpers.translation)('1956')
	        }),
	        renderEnviDiscount(),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1867') },
	          _react2.default.createElement(
	            'span',
	            null,
	            price.ParentPriceModelName
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSize',
	    value: function renderSize() {
	      // let isCustomer = this.state.isCustomer
	      var isWP = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      // let isCustomer = this.props.customer
	      // if (hasAccess([6], this.props.auth.user.UserType) || this.props.partners) return null
	      var price = this.state.price;
	
	      var isDisabled = this.onlyShow();
	      isDisabled = ! /* isCustomer || */isWP;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13340') },
	        _react2.default.createElement(_text2.default, {
	          name: 'SizeSmall',
	          value: (0, _percent.transformPercent)(price.SizeSmall),
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          onFocus: _percent.onPercentFocus,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('1264') + ' (%)',
	          helpText: (0, _helpers.translation)('1957')
	        }),
	        _react2.default.createElement(_text2.default, {
	          disabled: true,
	          value: '0',
	          labelText: (0, _helpers.translation)('1265'),
	          helpText: (0, _helpers.translation)('1958')
	        }),
	        _react2.default.createElement(_text2.default, {
	          name: 'SizeLarge',
	          value: (0, _percent.transformPercent)(price.SizeLarge),
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          onFocus: _percent.onPercentFocus,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('1266') + ' (%)',
	          helpText: (0, _helpers.translation)('1959')
	        })
	      );
	    }
	  }, {
	    key: 'renderAddons',
	    value: function renderAddons(dimensions) {
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      if (this.state.price.AddonStartTimes === undefined) return null;
	      if (isCustomer && this.state.price.AddonStartTimes.length === 0 && this.state.price.AddonParts.length === 0) return null;
	
	      if (!this.dimensionShow(dimensions)) return null;
	      // Do not render if estimation type model
	      if (this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	
	      return _react2.default.createElement(
	        _tableContainer2.default,
	        { fullWidth: true },
	        _react2.default.createElement(
	          _tableExpand2.default,
	          null,
	          _react2.default.createElement(
	            _tableHeader2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1792'),
	              _react2.default.createElement(_helpIcon2.default, { helpText: (0, _helpers.translation)('1961') })
	            )
	          ),
	          this.renderAddonStartTimes(),
	          this.renderAddonParts()
	        )
	      );
	    }
	  }, {
	    key: 'renderAddonParts',
	    value: function renderAddonParts() {
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      // let isCustomer = this.props.customer
	      // Do not render if estimation type model
	      if (isCustomer && this.state.price.AddonParts.length === 0) return null;
	      if (this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	
	      var price = this.state.price;
	      // const deleteItem = (key) => {
	      //   let price = { ...this.state.price }
	      //   price.AddonParts[key].IsDeleted = true
	      //   this.updatePrices(price)
	      // }
	
	      // Render item
	      // const renderAddonPart = (val, key) => {
	      //   // console.log('', )
	      //   let ref1 = 'addonPartNAME_' + val.AddonPartId
	      //   let ref2 = 'addonPartAE_' + val.AddonPartId
	      //   let ref3 = 'addonPartMAT_' + val.AddonPartId
	
	      //   const onEditAddonPart = (e) => {
	      //     // console.log('Edit addonstart time: ', e.target)
	      //     let price = JSON.parse(JSON.stringify(this.state.price))
	      //     if (e.target.name === 'AE') {
	      //       price.AddonParts[key].AE = reverseFormatCurrency2(this.refs[ref2].value)
	      //       if (this.shouldUpdatePrices(price.AddonParts[key].AE, this.state.price.AddonParts[key].AE)) {
	      //         this.updatePrices(price).then(() => {
	      //           this.refs[ref2].value = formatCurrency2(price.AddonParts[key].AE)
	      //           // this.refs[ref2].value = val.AE
	      //         })
	      //       }
	      //     } else if (e.target.name === 'Name') {
	      //       price.AddonParts[key].Name = this.refs[ref1].value
	      //       if (this.shouldUpdatePrices(price.AddonParts[key].Name, this.state.price.AddonParts[key].Name)) {
	      //         this.updatePrices(price).then(() => {
	      //           this.refs[ref1].value = price.AddonParts[key].Name
	      //           // this.refs[ref1].value = price.AddonParts[key].Name
	      //         })
	      //       }
	      //     } else if (e.target.name === 'Mat') {
	      //       price.AddonParts[key].Mat = reverseFormatCurrency2(this.refs[ref3].value)
	      //       if (this.shouldUpdatePrices(price.AddonParts[key].Mat, this.state.price.AddonParts[key].Mat)) {
	      //         this.updatePrices(price).then(() => {
	      //           this.refs[ref3].value = formatCurrency2(price.AddonParts[key].Mat)
	      //           // this.refs[ref3].value = parseInt(val.Mat)
	      //         })
	      //       }
	      //     }
	      //   }
	      //   const renderName = () => {
	      //     if (!this.onlyShow()) {
	      //       return (
	      //         <div className='addonpart_name'>
	      //           <input type='text' defaultValue={val.Name} ref={ref1} onBlur={onEditAddonPart} name='Name' key={'addonPart1_' + val.AddonPartId + '_' + val.Name} />
	      //         </div>
	      //       )
	      //     }
	      //     return (
	      //       <div className='addonpart_name'>{val.Name}</div>
	      //     )
	      //   }
	
	      //   const renderWorkUnits = () => {
	      //     if (!this.onlyShow()) {
	      //       return (
	      //         <div className='addon_workUnits'>
	      //           <input type='text' defaultValue={formatCurrency2(val.AE)} ref={ref2} onBlur={onEditAddonPart} name='AE' key={'addonPart2_' + val.AddonPartId + '_' + val.AE} />
	      //         </div>
	      //       )
	      //     }
	      //     return (
	      //       <div className='addon_workUnits'>{val.AE}</div>
	      //     )
	      //   }
	
	      //   const renderMat = () => {
	      //     if (!this.onlyShow()) {
	      //       return (
	      //         <div className='mat'>
	      //           <input type='text' defaultValue={formatCurrency2(val.Mat)} ref={ref3} onBlur={onEditAddonPart} name='Mat' key={'addonPart3_' + val.AddonPartId + '_' + val.Mat} />
	      //         </div>
	      //       )
	      //     }
	      //     return (
	      //       <div className='mat'>{val.Mat}</div>
	      //     )
	      //   }
	
	      //   // Return
	      //   return (
	      //     <li key={key} className='clearfix form'>
	      //       {renderName()}
	      //       {renderWorkUnits()}
	      //       {renderMat()}
	      //       {!this.onlyShow() && (
	      //         <div className='buttonWrap'>
	      //           <span className='delete' onClick={deleteItem.bind(this, key)}><img src='/images/icons/Minus-White_16px.png' /></span>
	      //         </div>
	      //       )}
	      //     </li>
	      //   )
	      // }
	
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        config: (0, _config.getAddonPartConfig)((0, _config.createConfigContext)(this.props.auth, this.state.price)),
	        items: price.AddonParts,
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking });
	      // return (
	      //   <ul className='addonparts'>
	      //     <li className='clearfix'>
	      //       <div className='addonpart_name'>{translation('888')}</div>
	      //       <div className='addon_workUnits'>{translation('885')} (%)</div>
	      //       <div className='mat'>{translation('13443')} (%)</div>
	      //       <HelpText className='helpText' text={translation('1963')} left />
	      //       <div className='buttonWrap' />
	      //     </li>
	      //     {price.AddonParts.map(renderAddonPart)}
	      //     {!this.onlyShow() && this.addMoreAddonParts()}
	      //   </ul>
	      // )
	    }
	  }, {
	    key: 'addMoreAddonParts',
	    value: function addMoreAddonParts() {
	      var _this12 = this;
	
	      // let { price } = this.state
	      // Functions
	      var onChange = function onChange(e) {
	        _this12.setState({
	          new_addonpart: _extends({}, _this12.state.new_addonpart, _defineProperty({}, e.target.name, e.target.value))
	        });
	      };
	      var addItem = function addItem() {
	        var price = _extends({}, _this12.state.price);
	        var newItem = _extends({}, _this12.state.new_addonpart);
	        // newItem.Price = parseFloat(reverseFormatCurrency(newItem.Price))
	        if ((0, _auth.hasAccess)([2, 3, 6, 7], _this12.props.auth.user.UserType)) {
	          // newItem.Name = ''
	          newItem.AE = (0, _currency.reverseFormatCurrency2)(newItem.AE);
	          newItem.Mat = (0, _currency.reverseFormatCurrency2)(newItem.Mat);
	        }
	        if (typeof newItem.AE !== 'number' || isNaN(newItem.AE)) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13430'), (0, _helpers.translation)('216'));
	        } else if (typeof newItem.Mat !== 'number' || isNaN(newItem.Mat)) {
	          // newItem.Mat = 0
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13430'), (0, _helpers.translation)('216'));
	        } else {
	          price.AddonParts.push(newItem);
	          _this12.updatePrices(price);
	        }
	      };
	
	      var onBlur = function onBlur(e) {
	        // let price = {...this.state.price}
	        var newItem = _extends({}, _this12.state.new_addonpart);
	        // newItem.AE = reverseFormatCurrency2(newItem.AE, 5)
	        // newItem.Mat = reverseFormatCurrency2(newItem.Mat)
	        // newItem.Net = reverseFormatCurrency2(newItem.Net)
	        // newItem.Discount = reverseFormatCurrency2(newItem.Discount)
	        var value = e.target.value;
	        if (e.target.name !== 'Name') {
	          value = (0, _currency.reverseFormatCurrency2)(value);
	          // if (e.target.name === 'AE') {
	          // } else {
	          //   value = reverseFormatCurrency2(value)
	          // }
	        }
	        newItem[e.target.name] = value;
	
	        _this12.setState({
	          new_addonpart: newItem
	        });
	      };
	
	      // Return
	      return _react2.default.createElement(
	        'li',
	        { className: 'clearfix form' },
	        _react2.default.createElement(
	          'div',
	          { className: 'addonpart_name' },
	          !(0, _auth.hasAccess)([2, 3, 6, 7], this.props.auth.user.UserType) && _react2.default.createElement(
	            'span',
	            null,
	            '\xA0'
	          ),
	          (0, _auth.hasAccess)([2, 3, 6, 7], this.props.auth.user.UserType) && _react2.default.createElement('input', { type: 'text', onBlur: onBlur, onChange: onChange, value: this.state.new_addonpart.Name, name: 'Name' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'addon_workUnits' },
	          !(0, _auth.hasAccess)([2, 3, 6, 7], this.props.auth.user.UserType) && _react2.default.createElement(
	            'span',
	            null,
	            '\xA0'
	          ),
	          (0, _auth.hasAccess)([2, 3, 6, 7], this.props.auth.user.UserType) && _react2.default.createElement('input', { type: 'text', onBlur: onBlur, onChange: onChange, value: (0, _currency.formatCurrency2)(this.state.new_addonpart.AE), name: 'AE' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mat' },
	          !(0, _auth.hasAccess)([2, 3, 6, 7], this.props.auth.user.UserType) && _react2.default.createElement(
	            'span',
	            null,
	            '\xA0'
	          ),
	          (0, _auth.hasAccess)([2, 3, 6, 7], this.props.auth.user.UserType) && _react2.default.createElement('input', { type: 'text', onBlur: onBlur, onChange: onChange, value: (0, _currency.formatCurrency2)(this.state.new_addonpart.Mat), name: 'Mat' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'buttonWrap' },
	          _react2.default.createElement(
	            'span',
	            { className: 'delete', onClick: addItem },
	            _react2.default.createElement('img', { src: '/images/icons/Plus-White.png' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAddonStartTimes',
	    value: function renderAddonStartTimes() {
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      if (isCustomer && this.state.price.AddonStartTimes.length === 0) return null;
	      // let isCustomer = this.props.customer
	      // Do not render if estimation type model
	      if (this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	
	      var price = this.state.price;
	
	      // Delete item
	      // const deleteItem = (key) => {
	      //   let price = { ...this.state.price }
	      //   price.AddonStartTimes[key].IsDeleted = true
	      //   this.updatePrices(price)
	      // }
	
	      // Render item
	      // const renderAddonStartTime = (val, key) => {
	      //   let refNAME = 'addonStartTimeNAME_' + val.AddonStartTimeId
	      //   let refAE = 'addonStartTimeAE_' + val.AddonStartTimeId
	      //   let refMAT = 'addonStartTimeMAT_' + val.AddonStartTimeId
	      //   let refDISCOUNT = 'addonStartTimeDISCOUNT_' + val.AddonStartTimeId
	      //   let refNET = 'addonStartTimeNET_' + val.AddonStartTimeId
	
	      //   const onEditAddonStartTime = (e) => {
	      //     let value = e.target.value
	      //     let price = JSON.parse(JSON.stringify(this.state.price))
	      //     switch (e.target.name) {
	      //       case 'AE':
	      //         price.AddonStartTimes[key].AE = reverseFormatCurrency2(this.refs[refAE].value)
	      //         if (this.shouldUpdatePrices(price.AddonStartTimes[key].AE, this.state.price.AddonStartTimes[key].AE)) {
	      //           this.updatePrices(price).then(() => {
	      //             this.refs[refAE].value = formatCurrency2(price.AddonStartTimes[key].AE, this.AERounding)
	      //           })
	      //         }
	      //         break
	      //       case 'Name':
	      //         price.AddonStartTimes[key].Name = this.refs[refNAME].value
	      //         if (this.shouldUpdatePrices(price.AddonStartTimes[key].Name, this.state.price.AddonStartTimes[key].Name)) {
	      //           this.updatePrices(price).then(() => {
	      //             this.refs[refNAME].value = price.AddonStartTimes[key].Name
	      //           })
	      //         }
	      //         break
	      //       case 'Mat':
	      //         price.AddonStartTimes[key].Mat = reverseFormatCurrency2(value)
	      //         if (this.shouldUpdatePrices(price.AddonStartTimes[key].Mat, this.state.price.AddonStartTimes[key].Mat)) {
	      //           this.updatePrices(price).then(() => {
	      //             this.refs[refMAT].value = formatCurrency2(price.AddonStartTimes[key].Mat)
	      //             // this.refs[refMAT].value = formatCurrency(parseFloat(price.AddonStartTimes[key].Mat.toString()))
	      //             // this.refs[refMAT].value = formatCurrency(parseFloat(reverseFormatCurrency(price.AddonStartTimes[key].Mat.toString())))
	      //           })
	      //         }
	      //         break
	      //       case 'Discount':
	      //         // value = parseFloat(value)
	      //         price.AddonStartTimes[key].Discount = reverseFormatCurrency2(value) // value // this.refs[ref5].value
	      //         // price.AddonStartTimes[key].Discount = value // this.refs[ref4].value   value always 0 ???
	      //         if (this.shouldUpdatePrices(price.AddonStartTimes[key].Discount, this.state.price.AddonStartTimes[key].Discount)) {
	      //           this.updatePrices(price).then(() => {
	      //             this.refs[refDISCOUNT].value = formatCurrency2(price.AddonStartTimes[key].Discount)
	      //             // this.refs[refDISCOUNT].value = formatCurrency(parseFloat(price.AddonStartTimes[key].Discount.toString()))
	      //             // this.refs[refDISCOUNT].value = price.AddonStartTimes[key].Discount
	      //             // console.log('After update. ref4 ', this.refs[ref4])
	      //             // console.log('After update. price ', price.AddonStartTimes[key])
	      //           })
	      //         }
	      //         break
	      //       case 'Net':
	      //         price.AddonStartTimes[key].Net = reverseFormatCurrency2(value) // value // this.refs[ref5].value
	      //         if (this.shouldUpdatePrices(price.AddonStartTimes[key].Net, this.state.price.AddonStartTimes[key].Net)) {
	      //           this.updatePrices(price).then(() => {
	      //             this.refs[refNET].value = formatCurrency2(price.AddonStartTimes[key].Net)
	      //             // this.refs[refNET].value = price.AddonStartTimes[key].Net
	      //           })
	      //         }
	      //         break
	      //     }
	      //   }
	      //   const renderName = () => {
	      //     if (!this.onlyShow()) {
	      //       return (
	      //         <div className='name'>
	      //           <input type='text' defaultValue={val.Name} ref={refNAME} onBlur={onEditAddonStartTime} name='Name' key={'addonStartTime1_' + val.AddonStartTimeId + '_' + val.Name} />
	      //         </div>
	      //       )
	      //     }
	      //     return (
	      //       <div className='name'>{val.Name}</div>
	      //     )
	      //   }
	
	      //   const renderWorkUnits = () => {
	      //     if (!this.onlyShow()) {
	      //       return (
	      //         <div className='workUnits'>
	      //           <input type='text' defaultValue={formatCurrency2(val.AE, this.AERounding)} ref={refAE} onBlur={onEditAddonStartTime} name='AE' key={'addonStartTime2_' + val.AddonStartTimeId + '_' + val.AE} />
	      //         </div>
	      //       )
	      //     }
	      //     return (
	      //       <div className='workUnits'>{val.AE}</div>
	      //     )
	      //   }
	
	      //   const renderMat = () => {
	      //     if (!this.onlyShow()) {
	      //       return (
	      //         <div className='mat'>
	      //           <input type='text' defaultValue={formatCurrency2(val.Mat)} ref={refMAT} onBlur={onEditAddonStartTime} name='Mat' key={'addonStartTime3_' + val.AddonStartTimeId + '_' + val.Mat} />
	      //         </div>
	      //       )
	      //     }
	      //     return (
	      //       <div className='mat'>{formatCurrency2(val.Mat)}</div>
	      //     )
	      //   }
	
	      //   const renderDiscount = () => {
	      //     // if (hasAccess([4], this.props.auth.user.UserType)) return <div>&nbsp;</div>
	      //     //  if (!this.props.customer && !hasAccess([6], this.props.auth.user.UserType)) return <div className='discount' />
	      //     if (!this.onlyShow()) {
	      //       return (
	      //         <div className='discount'>
	      //           <input type='text' defaultValue={formatCurrency2(val.Discount)} ref={refDISCOUNT} onBlur={onEditAddonStartTime} name='Discount' key={'addonStartTime4_' + val.AddonStartTimeId + '_' + val.Discount} />
	      //         </div>
	      //       )
	      //     }
	      //     if (this.state.isCustomer) return <div className='discount'>&nbsp;</div>
	      //     return (
	      //       <div className='discount'>{formatCurrency2(val.Discount)}</div>
	      //     )
	      //   }
	
	      //   const renderNet = () => {
	      //     // if (!this.props.customer && !hasAccess([6], this.props.auth.user.UserType)) return <div className='net' />
	      //     if (this.state.isCustomer) return <div className='net'>&nbsp;</div>
	      //     if (!this.onlyShow()) {
	      //       return (
	      //         <div className='net'>
	      //           <input type='text' defaultValue={formatCurrency2(val.Net)} ref={refNET} onBlur={onEditAddonStartTime} name='Net' key={'addonStartTime5_' + val.AddonStartTimeId + '_' + val.Net} />
	      //         </div>
	      //       )
	      //     }
	      //     return (
	      //       <div className='net'>{formatCurrency2(val.Net)}</div>
	      //     )
	      //   }
	
	      //   const renderPrice = () => {
	      //     return (
	      //       <div className='price'>{formatCurrency2(val.Price)}</div>
	      //     )
	      //   }
	
	      //   const renderEnv = () => {
	      //     return (
	      //       <div className='env'>{formatCurrency2(val.Env)}</div>
	      //     )
	      //   }
	
	      //   const renderTotal = () => {
	      //     if (this.state.isCustomer) return <div className='total'>&nbsp;</div>
	      //     return (
	      //       <div className='total'>{formatCurrency2(val.Total)}</div>
	      //     )
	      //   }
	      //   console.log('isCustomer', isCustomer, 'this.state.isCustomer', this.state.isCustomer, 'onlyShow', this.onlyShow())
	      //   if (isCustomer) {
	      //     return (
	      //       <li key={key} className='clearfix form'>
	      //         {renderName()}
	      //         {renderWorkUnits()}
	      //         {renderMat()}
	      //         {renderPrice()}
	      //         {renderEnv()}
	      //         {!this.onlyShow() && (
	      //           <div className='buttonWrap'>
	      //             <span className='delete' onClick={deleteItem.bind(this, key)}><img src='/images/icons/Minus-White_16px.png' /></span>
	      //           </div>
	      //         )}
	      //       </li>
	      //     )
	      //   }
	      //   // Return
	      //   return (
	      //     <li key={key} className='clearfix form'>
	      //       {renderName()}
	      //       {renderWorkUnits()}
	      //       {renderMat()}
	      //       {renderPrice()}
	      //       {renderDiscount()}
	      //       {renderNet()}
	      //       {renderEnv()}
	      //       {renderTotal()}
	      //       {!this.onlyShow() && (
	      //         <div className='buttonWrap'>
	      //           <span className='delete' onClick={deleteItem.bind(this, key)}><img src='/images/icons/Minus-White_16px.png' /></span>
	      //         </div>
	      //       )}
	      //     </li>
	      //   )
	      // }
	      // if (isCustomer) {
	      //   return (
	      //     <ul className='starttimes'>
	      //       <li className='clearfix'>
	      //         <div className='name'>{translation('1195')}</div>
	      //         <div className='workUnits'>{translation('885')}</div>
	      //         <div className='mat'>{translation('13443')}</div>
	      //         <div className='price'>{translation('13350')}</div>
	      //         <div className='env'>{translation('1044')}</div>
	      //         <HelpText className='helpText' text={translation('1962')} left />
	      //         <div className='buttonWrap' />
	      //       </li>
	      //       {price.AddonStartTimes.map(renderAddonStartTime)}
	      //       {!this.onlyShow() && this.addMoreAddonStartTimes()}
	      //     </ul>
	      //   )
	      // }
	
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        config: (0, _config.getAddonStartTimeConfig)((0, _config.createConfigContext)(this.props.auth, this.state.price)),
	        items: price.AddonStartTimes,
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking });
	      // return (
	      //   <ul className='starttimes'>
	      //     <li className='clearfix'>
	      //       <div className='name'>{translation('1195')}</div>
	      //       <div className='workUnits'>{translation('885')}</div>
	      //       <div className='mat'>{translation('13443')}</div>
	      //       <div className='price'>{translation('13350')}</div>
	      //       <div className='discount'>{translation('1199')} (%)</div>
	      //       <div className='net'>{translation('1305')}</div>
	      //       <div className='env'>{translation('1044')}</div>
	      //       <div className='total'>{translation('393')}</div>
	      //       <HelpText className='helpText' text={translation('1962')} left />
	      //       <div className='buttonWrap' />
	      //     </li>
	      //     {price.AddonStartTimes.map(renderAddonStartTime)}
	      //     {!this.onlyShow() && this.addMoreAddonStartTimes()}
	      //   </ul>
	      // )
	    }
	
	    // addMoreAddonStartTimes () {
	    //   // let { price } = this.state
	    //   // Functions
	    //   const onChange = (e) => {
	    //     let value = e.target.value
	    //     // if (e.target.name !== 'Name') {
	    //     //   value = parseFloat(reverseFormatCurrency(value))
	    //     // }
	    //     this.setState({
	    //       new_addonstarttime: {
	    //         ...this.state.new_addonstarttime,
	    //         [e.target.name]: value
	    //       }
	    //     }, () => {
	    //       // console.log('newItem.AE ', this.state.new_addonstarttime.AE)
	    //     })
	    //   }
	
	    //   const onBlur = (e) => {
	    //     // Format fields on new_addonstarttime
	    //     let newItem = this.state.new_addonstarttime
	    //     newItem.AE = reverseFormatCurrency2(newItem.AE, 5)
	    //     newItem.Mat = reverseFormatCurrency2(newItem.Mat)
	    //     newItem.Net = reverseFormatCurrency2(newItem.Net)
	    //     newItem.Discount = reverseFormatCurrency2(newItem.Discount)
	    //     // newItem.AE = (parseFloat(reverseFormatCurrency(newItem.AE)))
	    //     // newItem.Mat = (parseFloat(reverseFormatCurrency(newItem.Mat)))
	    //     // newItem.Net = (parseFloat(reverseFormatCurrency(newItem.Net)))
	
	    //     // console.log('newItem.Mat ', newItem.Mat)
	    //     this.setState({
	    //       new_addonstarttime: newItem
	    //     })
	    //   }
	
	    //   const addItem = () => {
	    //     let price = { ...this.state.price }
	    //     let newItem = { ...this.state.new_addonstarttime }
	    //     // newItem.Price = parseFloat(reverseFormatCurrency(newItem.Price))
	    //     if (hasAccess([2, 3, 6, 7], this.props.auth.user.UserType)) {
	    //       // newItem.Name = ''
	
	    //       newItem.AE = reverseFormatCurrency2(newItem.AE, 5)
	    //       newItem.Mat = reverseFormatCurrency2(newItem.Mat)
	    //       newItem.Discount = reverseFormatCurrency2(newItem.Discount)
	    //       newItem.Net = reverseFormatCurrency2(newItem.Net)
	
	    //       // newItem.AE = formatCurrency(reverseFormatCurrency2(newItem.AE))
	    //       // newItem.Mat = formatCurrency(reverseFormatCurrency2(newItem.Mat))
	    //       // newItem.Discount = formatCurrency(reverseFormatCurrency2(newItem.Discount))
	    //       // newItem.Net = formatCurrency(reverseFormatCurrency2(newItem.Net))
	    //     }
	    //     if (typeof newItem.AE !== 'number' || isNaN(newItem.AE)) {
	    //       // Toastr
	    //       window.toastr.error(translation('13430'), translation('216'))
	    //     } else {
	    //       price.AddonStartTimes.push(newItem)
	    //       this.updatePrices(price)
	    //     }
	    //   }
	    //   // Return
	    //   return (
	    //     <li className='clearfix form'>
	    //       <div className='name'>
	    //         {!hasAccess([2, 3, 6, 7], this.props.auth.user.UserType) && <span>&nbsp;</span>}
	    //         {hasAccess([2, 3, 6, 7], this.props.auth.user.UserType) && <input type='text' onChange={onChange} value={this.state.new_addonstarttime.Name} name='Name' />}
	    //       </div>
	    //       <div className='workUnits'>
	    //         {!hasAccess([2, 3, 6, 7], this.props.auth.user.UserType) && <span>&nbsp;</span>}
	    //         {hasAccess([2, 3, 6, 7], this.props.auth.user.UserType) && <input type='text' onChange={onChange} onBlur={onBlur} value={formatCurrency2(this.state.new_addonstarttime.AE, 5)} name='AE' />}
	    //       </div>
	    //       <div className='mat'>
	    //         {!hasAccess([2, 3, 6, 7], this.props.auth.user.UserType) && <span>&nbsp;</span>}
	    //         {hasAccess([2, 3, 6, 7], this.props.auth.user.UserType) && <input type='text' onChange={onChange} onBlur={onBlur} value={formatCurrency2(this.state.new_addonstarttime.Mat)} name='Mat' />}
	    //       </div>
	    //       <div className='price'>&nbsp;</div>
	    //       <div className='discount'>
	    //         {!this.props.customer && <span>&nbsp;</span>}
	    //         {this.props.customer && <input type='text' onBlur={onBlur} onChange={onChange} value={formatCurrency2(this.state.new_addonstarttime.Discount)} name='Discount' />}
	    //       </div>
	    //       <div className='net'>
	    //         {!this.props.customer && <span>&nbsp;</span>}
	    //         {this.props.customer && <input type='text' onBlur={onBlur} onChange={onChange} value={formatCurrency2(this.state.new_addonstarttime.Net)} name='Net' />}
	    //       </div>
	    //       <div className='env'>&nbsp;</div>
	    //       <div className='total'>&nbsp;</div>
	    //       <div className='buttonWrap'>
	    //         <span className='delete' onClick={addItem}><img src='/images/icons/Plus-White.png' /></span>
	    //       </div>
	    //     </li>
	    //   )
	    // }
	
	  }, {
	    key: 'renderStartPrice',
	    value: function renderStartPrice(dimensions, type) {
	      var _this13 = this;
	
	      if (!this.dimensionShow(dimensions)) return null;
	      // Old config.
	      // let canEditPrice = !hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
	      // let canEditAE = hasAccess([2], this.props.auth.user.UserType)
	      // let canEditMat = hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
	      // let canEditDiscount = hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
	      // let canEditNet = hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
	
	      // New config.
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	
	      if (isCustomer && this.state.price.StartPrices.length === 0) return null;
	      // let isCustomer = this.props.customer
	      var canEditPrice = false; // !this.onlyShow() // !this.state.isCustomer
	      var canEditAE = !this.onlyShow(); // hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer
	      var canEditMat = !this.onlyShow(); // hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer // && !this.onlyShow()
	      var canEditDiscount = !this.onlyShow(); // hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer // && !this.onlyShow()
	      var canEditNet = !this.onlyShow(); // hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer // && !this.onlyShow()
	
	      var canEditNewAE = !this.onlyShow(); // hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer
	      var canEditNewMat = !this.onlyShow(); // hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer
	
	      var showDiscount = !this.state.isCustomer; // (hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer) // && !this.onlyShow()
	      var showNet = (0, _auth.hasAccess)([2, 3, 5, 6, 7], this.props.auth.user.UserType) || isCustomer; // && !this.onlyShow()
	
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	
	      var cols = [1, [7, 2], 1];
	      var price = this.state.price;
	
	
	      var deleteItem = function deleteItem(key) {
	        var price = _extends({}, _this13.state.price);
	        price.StartPrices[key].IsDeleted = true;
	        _this13.updatePrices(price);
	      };
	
	      var renderStartprice = function renderStartprice(val, key) {
	        if (val.Type !== type) return null;
	
	        var size = 's';
	
	        var onChange = function onChange(e) {
	          var StartPrices = _this13.state.price.StartPrices;
	          var _e$target = e.target,
	              name = _e$target.name,
	              value = _e$target.value;
	
	
	          StartPrices[key][name] = value;
	
	          _this13.setState({
	            price: _extends({}, _this13.state.price, {
	              StartPrices: StartPrices
	            })
	          });
	        };
	
	        var onBlur = function onBlur(e, shouldAdd) {
	          if (_this13.state.IsWorking) return;
	          var _state = _this13.state,
	              price = _state.price,
	              priceOriginal = _state.priceOriginal;
	          var name = e.name;
	
	          if (_this13.shouldUpdatePrices(price.StartPrices[key][name], priceOriginal.StartPrices[key][name])) {
	            var newPrice = price;
	            price.StartPrices[key][name] = (0, _currency.reverseFormatCurrency2)(price.StartPrices[key][name]);
	            newPrice = _extends({}, price, {
	              StartPrices: price.StartPrices
	            });
	            _this13.updatePrices(newPrice);
	          }
	        };
	
	        // Functions
	        var renderPrice = function renderPrice() {
	          if (canEditPrice) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'Price',
	              value: val.Price,
	              onChange: onChange,
	              onBlur: onBlur,
	              size: size,
	              disabled: _this13.state.IsWorking
	            });
	          }
	          return _react2.default.createElement(
	            'div',
	            { className: 'price' },
	            (0, _currency.formatCurrency2)(val.Price)
	          );
	        };
	
	        var renderWorkunits = function renderWorkunits() {
	          if (canEditAE) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'AE',
	              value: val.AE,
	              onChange: onChange,
	              onBlur: onBlur,
	              decimals: _this13.AERounding,
	              size: size,
	              disabled: _this13.state.IsWorking
	            });
	          }
	          return _react2.default.createElement(
	            'div',
	            { className: 'workUnits_small' },
	            (0, _currency.formatCurrency2)(val.AE, _this13.AERounding)
	          );
	        };
	
	        var renderMat = function renderMat() {
	          if (canEditMat) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'Mat',
	              value: val.Mat,
	              onChange: onChange,
	              onBlur: onBlur,
	              size: size,
	              disabled: _this13.state.IsWorking
	            });
	          }
	          return _react2.default.createElement(
	            'div',
	            { className: 'mat' },
	            (0, _currency.formatCurrency2)(val.Mat)
	          );
	        };
	
	        var renderNet = function renderNet() {
	          if (!showNet) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'net' },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\xA0'
	              )
	            );
	          }
	
	          if (canEditNet) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'Net',
	              value: val.Net,
	              onChange: onChange,
	              onBlur: onBlur,
	              size: size,
	              disabled: _this13.state.IsWorking
	            });
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'Net' },
	            (0, _currency.formatCurrency2)(val.Net)
	          );
	        };
	
	        var renderDiscount = function renderDiscount() {
	          if (!showDiscount) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'discount' },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\xA0'
	              )
	            );
	          }
	
	          if (canEditDiscount) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'Discount',
	              value: val.Discount,
	              onChange: onChange,
	              onBlur: onBlur,
	              onFocus: _percent.onPercentFocus,
	              transformValue: _percent.transformPercent,
	              size: size,
	              disabled: _this13.state.IsWorking
	            });
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'discount' },
	            (0, _percent.transformPercent)((0, _currency.formatCurrency2)(val.Discount))
	          );
	        };
	
	        if (isCustomer) {
	          return _react2.default.createElement(
	            _tableRow2.default,
	            { cols: cols, key: key },
	            _react2.default.createElement(
	              'span',
	              null,
	              val.Order
	            ),
	            renderWorkunits(),
	            renderMat(),
	            renderPrice(),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _currency.formatCurrency2)(val.Env)
	            )
	          );
	        }
	
	        // Return
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { cols: cols, key: key },
	          _react2.default.createElement(
	            'span',
	            null,
	            val.Order,
	            '.'
	          ),
	          renderWorkunits(),
	          renderMat(),
	          renderPrice(),
	          renderDiscount(),
	          renderNet(),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _currency.formatCurrency2)(val.Env)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _currency.formatCurrency2)(val.Total)
	          ),
	          !_this13.onlyShow() && !isCustomer && _react2.default.createElement(_removeButton2.default, { onClick: deleteItem.bind(_this13, key), size: size, disabled: _this13.state.IsWorking })
	        );
	      };
	      var addMoreStartprices = function addMoreStartprices() {
	        var price = _this13.state.price;
	
	        var startPriceKey = 'new_startprice';
	        if (type > 0) startPriceKey += type;
	
	        var lastEditable = '';
	        if (canEditAE) lastEditable = 'AE';
	        if (canEditMat) lastEditable = 'Mat';
	        if (canEditPrice) lastEditable = 'Price';
	        if (canEditDiscount) lastEditable = 'Discount';
	        if (canEditNet) lastEditable = 'Net';
	
	        // Functions
	        var onChange = function onChange(e) {
	          var value = e.target.value;
	          _this13.setState(_defineProperty({}, startPriceKey, _extends({}, _this13.state[startPriceKey], _defineProperty({}, e.target.name, value))));
	        };
	        var formatPrice = function formatPrice(e) {
	          var value = e.target.value === '' ? '0' : e.target.value;
	          _this13.setState(_defineProperty({}, startPriceKey, _extends({}, _this13.state[startPriceKey], _defineProperty({}, e.target.name, (0, _currency.formatCurrency2)((0, _currency.reverseFormatCurrency2)(value))))));
	        };
	        var onKeyDown = function onKeyDown(e) {
	          if (e.key === 'Enter' || e.key === 'Tab') {
	            if (e.target.name === lastEditable) {
	              addItem();
	            }
	          }
	        };
	        var addItem = function addItem() {
	          var price = _extends({}, _this13.state.price);
	          var newItem = _extends({}, _this13.state[startPriceKey]);
	          newItem.Price = (0, _currency.reverseFormatCurrency2)(newItem.Price);
	          if ((0, _auth.hasAccess)([2], _this13.props.auth.user.UserType)) {
	            newItem.Price = 0;
	          }
	
	          newItem.AE = (0, _currency.reverseFormatCurrency2)(newItem.AE);
	          newItem.Mat = (0, _currency.reverseFormatCurrency2)(newItem.Mat);
	          newItem.Env = (0, _currency.reverseFormatCurrency2)(newItem.Env);
	          newItem.Net = (0, _currency.reverseFormatCurrency2)(newItem.Net);
	          newItem.Discount = (0, _currency.reverseFormatCurrency2)(newItem.Discount);
	          newItem.Type = type;
	
	          newItem.Price = typeof newItem.Price !== 'number' || isNaN(newItem.Price) ? 0 : newItem.Price;
	          newItem.AE = typeof newItem.AE !== 'number' || isNaN(newItem.AE) ? 0 : newItem.AE;
	          newItem.Mat = typeof newItem.Mat !== 'number' || isNaN(newItem.Mat) ? 0 : newItem.Mat;
	          newItem.Net = typeof newItem.Net !== 'number' || isNaN(newItem.Net) ? 0 : newItem.Net;
	          newItem.Env = typeof newItem.Env !== 'number' || isNaN(newItem.Env) ? 0 : newItem.Env;
	          newItem.Discount = typeof newItem.Discount !== 'number' || isNaN(newItem.Discount) ? 0 : newItem.Discount;
	
	          // if (typeof newItem.Price !== 'number' || isNaN(newItem.Price)) {
	          //   // Toastr
	          //   window.toastr.error(translation('13430'), translation('216'))
	          // } else {
	          price.StartPrices.push(newItem);
	          _this13.updatePrices(price);
	          // }
	        };
	        // Return
	        if (isCustomer) return null;
	
	        var count = 0;
	        if (price.StartPrices !== undefined) {
	          count = price.StartPrices.filter(function (val) {
	            return val.Type === type;
	          }).length;
	        }
	
	        var size = 's';
	
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { cols: cols },
	          _react2.default.createElement(
	            'span',
	            null,
	            count + 1,
	            '.'
	          ),
	          !(canEditAE || canEditNewAE) && _react2.default.createElement('span', null),
	          (canEditAE || canEditNewAE) && _react2.default.createElement(_text2.default, { name: 'AE', value: (0, _currency.formatCurrency2)(_this13.state[startPriceKey].AE, _this13.AERounding), onChange: onChange, onKeyDown: onKeyDown, size: size }),
	          !(canEditMat || canEditNewMat) && _react2.default.createElement('span', null),
	          (canEditMat || canEditNewMat) && _react2.default.createElement(_text2.default, { name: 'Mat', value: _this13.state[startPriceKey].Mat, onChange: onChange, onKeyDown: onKeyDown, size: size }),
	          !canEditPrice && _react2.default.createElement('span', null),
	          canEditPrice && _react2.default.createElement(_text2.default, { name: 'Price', value: _this13.state[startPriceKey].Price, onChange: onChange, onBlur: formatPrice, onKeyDown: onKeyDown, size: size }),
	          showDiscount && canEditDiscount && _react2.default.createElement(_text2.default, { name: 'Discount', value: _this13.state[startPriceKey].Discount, onChange: onChange, onKeyDown: onKeyDown, size: size }) || _react2.default.createElement('span', null),
	          !canEditNet && _react2.default.createElement('span', null),
	          canEditNet && _react2.default.createElement(_text2.default, { name: 'Net', value: _this13.state[startPriceKey].Net, onChange: onChange, onKeyDown: onKeyDown, size: size }),
	          _react2.default.createElement('span', null),
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(_addButton2.default, { onClick: addItem, size: size })
	        );
	      };
	
	      // Set title depending on startprice type being rendered.
	      var title = '';
	      var helpText = '';
	      switch (type) {
	        case 0:
	          title = (0, _helpers.translation)('2247'); // car
	          helpText = (0, _helpers.translation)('1960');
	          break;
	        case 1:
	          title = (0, _helpers.translation)('2246'); // no car
	          helpText = (0, _helpers.translation)('1960');
	          break;
	      }
	      if (isCustomer) {
	        cols = [1, [4, 2]];
	
	        return _react2.default.createElement(
	          _tableContainer2.default,
	          { fullWidth: true },
	          _react2.default.createElement(
	            _tableExpand2.default,
	            null,
	            _react2.default.createElement(
	              _tableHeader2.default,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                title,
	                _react2.default.createElement(_helpIcon2.default, { helpText: helpText })
	              )
	            ),
	            _react2.default.createElement(
	              _tableRow2.default,
	              { header: true, cols: cols },
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('13346')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('885')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('13443')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('641')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('1044')
	              )
	            ),
	            price.StartPrices.map(renderStartprice)
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _tableContainer2.default,
	        { fullWidth: true },
	        _react2.default.createElement(
	          _tableExpand2.default,
	          null,
	          _react2.default.createElement(
	            _tableHeader2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              title,
	              _react2.default.createElement(_helpIcon2.default, { helpText: helpText })
	            )
	          ),
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true, cols: cols },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('13346')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('885')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('13443')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('641')
	            ),
	            (0, _auth.hasAccess)([3, 5, 6, 7], this.props.auth.user.UserType) && _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1199'),
	              ' (%)'
	            ) || _react2.default.createElement('span', null),
	            showNet && _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1305')
	            ) || _react2.default.createElement('span', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1044')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('393')
	            ),
	            _react2.default.createElement('span', null)
	          ),
	          price.StartPrices !== undefined && price.StartPrices.map(renderStartprice),
	          !this.onlyShow() && addMoreStartprices()
	        )
	      );
	      // return (
	      //   <div className='white__box'>
	      //     <div className='title'>{title} <HelpText className='helpText' text={helpText} left /></div>
	      //     <ul className='startprices'>
	      //       <li className='clearfix'>
	      //         <div className='order'>{translation('13346')}</div>
	      //         <div className='workUnits_small'>{translation('885')}</div>
	      //         <div className='mat'>{translation('13443')}</div>
	      //         <div className='price'>{translation('641')}</div>
	      //         {hasAccess([3, 5, 6, 7], this.props.auth.user.UserType) && (
	      //           <div className='discount'>{translation('1199')} (%)</div>)}
	      //         {!hasAccess([3, 5, 6, 7], this.props.auth.user.UserType) && (
	      //           <div className='discount'><span>&nbsp;</span></div>)}
	      //         {showNet && (
	      //           <div className='net'>{translation('1305')}</div>)}
	      //         {!showNet && (<div className='net'><span>&nbsp;</span></div>)}
	      //         <div className='env'>{translation('1044')}</div>
	      //         <div className='total'>{translation('393')}</div>
	      //         <div className='buttonWrap' />
	      //       </li>
	      //       {price.StartPrices !== undefined && price.StartPrices.map(renderStartprice)}
	      //       {!this.onlyShow() && addMoreStartprices()}
	      //     </ul>
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'renderPriceParts',
	    value: function renderPriceParts(classnameList) {
	      var _this14 = this;
	
	      if (this.state.parts.length === 0 || this.state.price.UseEstimationList) return null;
	      var parts = /* this.state.parts.length > 0 ? */this.state.parts; /* : this.state.bodyParts */
	      var config = /* this.state.parts.length > 0 ? */(0, _config.getTaskPriceConfig)((0, _config.createConfigContext)(this.props.auth, this.state.price)); /* : getBodyTaskPriceConfig */
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.state.price.PriceType === 5) return _react2.default.createElement('div', { className: 'col' });
	
	      // console.log('Agreements - this.props.partners && hasAccess([2], this.props.auth.user.UserType) ', this.props.partners, hasAccess([2], this.props.auth.user.UserType))
	      var showCustomerPartners = this.props.partners && (0, _auth.hasAccess)([2], this.props.auth.user.UserType);
	      // if (this.props.partners) {
	      //   if (hasAccess([2], this.props.auth.user.UserType)) {
	      //     return (
	      //       <div className={classnameList}>
	      //         {this.renderStartPrice([[0, 1500]], 0)}
	      //         {this.renderStartPrice([[0, 1500]], 1)}
	      //         {this.renderAddons([[0, 1500]])}
	      //         {this.renderCustomersPartners()}
	      //       </div>
	      //     )
	      //   }
	      // }
	
	      var renderContent = function renderContent() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          !showCustomerPartners && _this14.renderDiscountPrice(),
	          !showCustomerPartners && _this14.renderExtras(),
	          _this14.renderStartPrice([[0, 10000]], 0),
	          _this14.renderStartPrice([[0, 10000]], 1),
	          _this14.renderAddons([[0, 10000]]),
	          !showCustomerPartners && parts.map(_this14.renderTaskPriceParts.bind(_this14, config)),
	          showCustomerPartners && _this14.renderCustomersPartners()
	        );
	      };
	
	      if (classnameList) {
	        return _react2.default.createElement(
	          _col2.default,
	          { span: '4' },
	          renderContent()
	        );
	      }
	
	      return renderContent();
	    }
	
	    // Should render
	    // Customer: 1 - Shop: 2
	
	  }, {
	    key: 'shouldRender',
	    value: function shouldRender(type) {
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        return type === 2;
	      }
	      // if (this.state.price.Name === null && this.state.price.CustomerId === 0 && type === 2) {
	      if (this.state.price.CustomerId === 0 && type === 2) {
	        return true;
	      }
	      // if ((this.state.price.Name !== null || this.state.price.CustomerId !== 0) && type === 1) {
	      if (this.state.price.CustomerId !== 0 && type === 1) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'renderTaskPriceParts',
	    value: function renderTaskPriceParts(config, val, key) {
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        config: config,
	        items: val.tasks,
	        groupId: val.part.PartItemId,
	        title: (0, _helpers.translation)(val.part.DictionaryKey),
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking,
	        key: key });
	    }
	  }, {
	    key: 'deleteItem',
	    value: function deleteItem(item) {
	      item.IsDeleted = true;
	      this.updateOrAddItem(item);
	    }
	  }, {
	    key: 'moveItem',
	    value: function moveItem(item, newPosition) {
	      var _this15 = this;
	
	      if (item.SortIndex === undefined) return; // Need sort index to make reordering work.
	      var oldSortIndex = item.SortIndex;
	
	      var listName = this.getItemListName(item);
	      var idField = this.getItemIdField(item);
	      var price = _extends({}, this.state.price);
	      var hasPartId = item.PartItemId !== undefined;
	      var hasPartItem = item.PartItem !== undefined && item.PartItem.PartItemId !== undefined;
	      var list = price[listName];
	
	      console.log(hasPartId, hasPartItem);
	      item.SortIndex = newPosition;
	      this.props.reorderPriceListItem(item).then(function (res) {
	        var _loop = function _loop(i) {
	          var listItem = list.find(function (li) {
	            return li[idField] === res.data[i][idField];
	          });
	          if (listItem !== undefined) {
	            listItem.SortIndex = res.data[i].SortIndex;
	          }
	        };
	
	        // Assign sortindex from result to all items
	        for (var i = 0; i < res.data.length; i++) {
	          _loop(i);
	        }
	      }, function () {
	        // If reorder failed on server, revert to old position.
	        item.SortIndex = oldSortIndex;
	
	        // show error toast
	      }).finally(function () {
	        // Sort list containing item, to make sure the list and visual dom matches.
	        var sorter = function sorter(a, b) {
	          if (hasPartId) {
	            if (a.PartItemId !== b.PartItemId) return a.PartItemId - b.PartItemId;
	          } else if (hasPartItem) {
	            if (a.PartItem.PartItemId !== b.PartItem.PartItemId) return a.PartItem.PartItemId - b.PartItem.PartItemId;
	          }
	          return a.SortIndex - b.SortIndex;
	        };
	
	        if (list !== null) {
	          list = list.sort(function (a, b) {
	            return sorter(a, b);
	          });
	          price[listName] = list;
	          _this15.setState({
	            price: price
	          }, function () {
	            _this15.forceUpdate();
	          });
	          // console.log('updated list', list.filter((a) => a.SortIndex !== null).map(i => { return { Id: i[this.getItemIdField(i)], TaskName: i.TaskName, SortIndex: i.SortIndex, PartItemId: (hasPartId ? i.PartItemId : i.PartItem.PartItemId) } }))
	        }
	      });
	    }
	  }, {
	    key: 'updateOrAddItem',
	    value: function updateOrAddItem(item) {
	      var doPost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var idField = this.getItemIdField(item);
	      console.log('idField ', idField);
	      var listName = this.getItemListName(item);
	      console.log('listName ', listName);
	      if (listName === null || idField === null) {
	        console.error('Could not update or add item!', item);
	        return;
	      }
	
	      console.log('Updating item', item, 'adding to ', listName, '(id ' + item[idField] + ')');
	      var price = _extends({}, this.state.price);
	      var list = price[listName];
	      if (item[idField] > 0) {
	        for (var i; i < list.length; i++) {
	          var oldItem = list[i];
	          if (oldItem[idField] === item[idField]) {
	            list[i] = item;
	            // updated = true
	            break;
	          }
	        }
	      } else {
	        item[idField] = 0;
	        list.push(item);
	      }
	      price[listName] = list;
	
	      // Finally send to api.
	      if (doPost) {
	        this.updatePrices(price);
	      }
	    }
	  }, {
	    key: 'getItemIdField',
	    value: function getItemIdField(item) {
	      // Find id field
	      var idFields = [];
	      var fields = Object.keys(item);
	      for (var f in fields) {
	        var field = fields[f];
	        if (field.toLowerCase().endsWith('id')) {
	          idFields.push(field);
	        }
	      }
	
	      // Determine correct id field.
	      for (var _f in idFields) {
	        if (item[idFields[_f]] === undefined || item[idFields[_f]] === null || !(typeof item[idFields[_f]] === 'number')) continue;
	        switch (idFields[_f].toLowerCase()) {
	          case 'taskpriceid':
	          case 'bodytaskpriceid':
	          case 'estimationtaskid':
	          case 'servicetaskid':
	          case 'addonstarttimeid':
	          case 'addonpartid':
	            return idFields[_f];
	        }
	      }
	      console.error('Could not determine Id field of item!', item);
	      return null;
	    }
	  }, {
	    key: 'getItemListName',
	    value: function getItemListName(item) {
	      // Find id field
	      var idFields = [];
	      var fields = Object.keys(item);
	      for (var f in fields) {
	        var field = fields[f];
	        if (field.toLowerCase().endsWith('id')) {
	          idFields.push(field);
	        }
	      }
	      console.log('getItemListName id fields', idFields);
	      // Determine correct id field.
	      for (var _f2 in idFields) {
	        if (item[idFields[_f2]] === undefined || item[idFields[_f2]] === null || !(typeof item[idFields[_f2]] === 'number')) continue;
	        switch (idFields[_f2].toLowerCase()) {
	          case 'taskpriceid':
	            return 'TaskPrices';
	          case 'bodytaskpriceid':
	            return 'BodyTaskPrices';
	          case 'estimationtaskid':
	            return 'EstimationTasks';
	          case 'servicetaskid':
	            return 'ServiceTasks';
	          case 'addonstarttimeid':
	            return 'AddonStartTimes';
	          case 'addonpartid':
	            return 'AddonParts';
	        }
	      }
	
	      console.error('Could not determine List name of item!', item);
	      return null;
	    }
	
	    // renderPartItem (val, key) {
	    //   // let noTasks = val.tasks === 'undefined' || val.tasks.length === 0
	    //   // let isAgreement = this.state.price.CustomerGroupId > 0
	    //   let ref1 = 'task_' + val.part.PartItemId
	    //   let ref2 = 'price_' + val.part.PartItemId
	    //   let ref3 = 'disc_' + val.part.PartItemId
	    //   let ref4 = 'net_' + val.part.PartItemId
	    //   let ref5 = 'AE_' + val.part.PartItemId
	    //   const addItem = () => {
	    //     let price = { ...this.state.price }
	    //     let taskName = this.refs[ref1].value
	    //     let priceVal = this.refs[ref2].value
	
	    //     let newItem = {
	    //       PartItem: {
	    //         PartItemId: val.part.PartItemId
	    //       },
	    //       TaskName: taskName,
	    //       Labor: 0
	    //     }
	
	    //     // if (this.shouldRender(1)) {
	    //     let discount = reverseFormatCurrency2(this.refs[ref3].value)
	    //     let netPrice = reverseFormatCurrency2(this.refs[ref4].value)
	    //     let gross = reverseFormatCurrency2(priceVal)
	    //     let aeVal = reverseFormatCurrency2(this.refs[ref5].value, 5)
	
	    //     discount = (isNaN(discount)) ? 0 : discount
	    //     netPrice = (isNaN(netPrice)) ? 0 : netPrice
	    //     gross = (isNaN(gross)) ? 0 : gross
	
	    //     newItem.Gross = gross
	    //     newItem.Discount = discount
	    //     newItem.Net = netPrice
	    //     newItem.AE = aeVal
	
	    //     price.TaskPrices.push(newItem)
	    //     this.updatePrices(price).then((res) => {
	    //       // Reset values
	    //       this.refs[ref1].value = ''
	    //       this.refs[ref2].value = ''
	    //       this.refs[ref3].value = ''
	    //       this.refs[ref4].value = ''
	    //       this.refs[ref5].value = ''
	    //     })
	    //     // } else {
	    //     //   if (hasAccess([2, 3, 5, 7, 6], this.props.auth.user.UserType)) {
	    //     //     newItem.AE = reverseFormatCurrency2(priceVal)
	    //     //   } else {
	    //     //     newItem.Labor = reverseFormatCurrency2(priceVal)
	    //     //   }
	    //     //   if (typeof newItem.Labor !== 'number' || isNaN(newItem.Labor) || newItem.TaskName === '') {
	    //     //     // Toastr
	    //     //     window.toastr.error(translation('13430'), translation('216'))
	    //     //   } else {
	    //     //     price.TaskPrices.push(newItem)
	    //     //     this.updatePrices(price).then((res) => {
	    //     //       // Reset values
	    //     //       this.refs[ref1].value = ''
	    //     //       this.refs[ref2].value = ''
	    //     //     })
	    //     //   }
	    //     // }
	    //   }
	    //   // formatPrice
	    //   const formatPrice = (e) => {
	    //     this.refs[e.target.name].value = formatCurrency2(reverseFormatCurrency2(e.target.value))
	    //   }
	    //   // Render price / work units
	    //   const renderNewPartTask = () => {
	    //     return (
	    //       <li className='clearfix form'>
	    //         <div>
	    //           <input type='text' ref={ref1} />
	    //         </div>
	    //         <div>
	    //           <input type='text' ref={ref5} name={ref5} />
	    //         </div>
	    //         <div />
	    //         <div>
	    //           <input type='text' ref={ref3} name={ref3} />
	    //         </div>
	    //         <div>
	    //           <input type='hidden' ref={ref4} onBlur={formatPrice} name={ref4} />
	    //         </div>
	    //         <div />
	    //         <div />
	    //         <div>
	    //           <input type='hidden' ref={ref2} onBlur={formatPrice} name={ref2} />
	    //         </div>
	    //         <div />
	    //         <div />
	    //         <div />
	    //         <div className='buttonWrap'>
	    //           <span className='delete' onClick={addItem}><img src='/images/icons/Plus-White.png' /></span>
	    //         </div>
	    //       </li>
	    //     )
	    //   }
	    //   // if (noTasks && isAgreement) return undefined
	    //   // 885 AE
	    //   // 13376 Samlet
	    //   // 1199 Rabat
	    //   // 1392 Nettopris
	    //   // 1044 Miljø
	    //   // 393 I Alt
	    //   if (this.state.isCustomer) {
	    //     return (
	    //       <div className='white__box' key={key}>
	    //         <div className='title'>{translation(val.part.DictionaryKey)}</div>
	    //         <ul className='partitem__list'>
	    //           <li className='clearfix'>
	    //             <div>{translation('1203')}</div>
	    //             <div>{translation('885')}</div>
	    //             <div>{translation('13376')}</div>
	    //             <div>{translation('1044')}</div>
	    //           </li>
	    //           {val.tasks.map(this.renderPartItemTask)}
	    //         </ul>
	    //       </div>
	    //     )
	    //   }
	    //   return (
	    //     <div className='white__box' key={key}>
	    //       <div className='title'>{translation(val.part.DictionaryKey)}</div>
	    //       <ul className='partitem__list'>
	    //         <li className='clearfix'>
	    //           <div>{translation('1203')}</div>
	    //           <div>{translation('885')}</div>
	    //           <div>{translation('13376')}</div>
	    //           {!this.state.isCustomer && (<div>{translation('1199')} (%)</div>)}
	    //           {this.state.isCustomer && (<div>&nbsp;</div>)}
	    //           <div>{translation('1392')}</div>
	    //           <div>{translation('1044')}</div>
	    //           <div>{translation('393')}</div>
	    //         </li>
	    //         {val.tasks.map(this.renderPartItemTask)}
	    //         {!this.state.isCustomer && !this.state.isShop && renderNewPartTask()}
	    //       </ul>
	    //     </div>
	    //   )
	    // }
	
	    // renderPartItemTask (val, key) {
	    //   let isCustomer = this.state.isCustomer
	    //   // let isCustomer = this.props.customer
	    //   let ref1 = 'labor_' + val.TaskPriceId
	    //   let ref2 = 'ae_' + val.TaskPriceId
	    //   let ref3 = 'disc_' + val.TaskPriceId
	    //   let ref4 = 'net_' + val.TaskPriceId
	    //   const deleteItem = () => {
	    //     let price = { ...this.state.price }
	    //     price.TaskPrices.map((v, k) => {
	    //       if (v.TaskPriceId === val.TaskPriceId) {
	    //         v.IsDeleted = true
	    //       }
	    //     })
	    //     this.updatePrices(price)
	    //   }
	    //   const editPrice = (e) => {
	    //     e.persist()
	    //     let priceOriginal = this.state.priceOriginal
	    //     let price = { ...this.state.price }
	    //     let valKey = 0
	    //     let compare1 = 0
	    //     let compare2 = 0
	    //     price.TaskPrices.map((v, k) => {
	    //       if (v.TaskPriceId === val.TaskPriceId) {
	    //         valKey = k
	    //         switch (e.target.name) {
	    //           case 'AE':
	    //             compare2 = priceOriginal.TaskPrices[k].AE
	    //             v.AE = reverseFormatCurrency2(this.refs[ref2].value, 5)
	    //             compare1 = v.AE
	    //             break
	    //           case 'Gross':
	    //             compare2 = priceOriginal.TaskPrices[k].Gross
	    //             v.Gross = reverseFormatCurrency2(this.refs[ref1].value)
	    //             compare1 = v.Gross
	    //             break
	    //           case 'Net':
	    //             compare2 = priceOriginal.TaskPrices[k].Net
	    //             v.Net = reverseFormatCurrency2(this.refs[ref4].value)
	    //             compare1 = v.Net
	    //             break
	    //           case 'Discount':
	    //             compare2 = priceOriginal.TaskPrices[k].Discount
	    //             v.Discount = reverseFormatCurrency2(this.refs[ref3].value)
	    //             compare1 = v.Discount
	    //             break
	    //           default:
	    //             compare2 = priceOriginal.TaskPrices[k].Labor
	    //             v.Labor = reverseFormatCurrency2(this.refs[ref1].value)
	    //             compare1 = v.Labor
	    //             break
	    //         }
	    //       }
	    //     })
	    //     if (this.shouldUpdatePrices(compare1, compare2)) {
	    //       this.updatePrices(price).then((res) => {
	    //         let nVal = res.data.TaskPrices[valKey]
	    //         switch (e.target.name) {
	    //           case 'AE':
	    //             this.refs[ref2].value = formatCurrency2(nVal.AE, 5)
	    //             break
	    //           case 'Gross':
	    //             this.refs[ref1].value = formatCurrency2(nVal.Gross)
	    //             break
	    //           case 'Net':
	    //             this.refs[ref3].value = formatCurrency2(nVal.Discount)
	    //             this.refs[ref4].value = formatCurrency2(nVal.Net)
	    //             break
	    //           case 'Discount':
	    //             this.refs[ref3].value = formatCurrency2(nVal.Discount)
	    //             this.refs[ref4].value = formatCurrency2(nVal.Net)
	    //             break
	    //           default:
	    //             this.refs[ref1].value = formatCurrency2(nVal.Labor)
	    //             break
	    //         }
	    //       })
	    //     }
	    //   }
	    //   // Labor
	    //   // const renderLabor = () => {
	    //   //   if (!hasAccess([6], this.props.auth.user.UserType)) { // } && !this.onlyShow()) {
	    //   //     return (
	    //   //       <div>
	    //   //         <input type='text' defaultValue={formatCurrency2(val.Labor)} ref={ref1} onBlur={editPrice} name='Price' key={'price_' + val.TaskPriceId + '_' + val.Labor} />
	    //   //       </div>
	    //   //     )
	    //   //   }
	    //   //   return (
	    //   //     <div>{formatCurrency2(val.Labor)}</div>
	    //   //   )
	    //   // }
	    //   // Work Units
	    //   const renderWorkunits = () => {
	    //     if (hasAccess([6], this.props.auth.user.UserType)) {
	    //       return (
	    //         <div>
	    //           <input type='text' defaultValue={formatCurrency2(val.AE, 5)} ref={ref2} onBlur={editPrice} name='AE' key={'ae_' + val.TaskPriceId + '_' + val.AE} />
	    //         </div>
	    //       )
	    //     }
	    //     return (
	    //       <div>{val.AE}</div>
	    //     )
	    //   }
	    //   // Gross
	    //   const renderGross = () => {
	    //     if (this.shouldRender(1)) {
	    //       // if ((this.props.customer && !this.state.price.UseRecommended) || !this.props.customer) {
	    //       if (!this.props.customer) {
	    //         return (
	    //           <div>
	    //             {!this.onlyShow() && (<input type='text' defaultValue={formatCurrency2(val.Gross)} ref={ref1} onBlur={editPrice} name='Gross' key={'gross_' + val.TaskPriceId + '_' + val.Gross} />)}
	    //             {this.onlyShow() && (<div>{formatCurrency2(val.Gross)}</div>)}
	    //           </div>
	    //         )
	    //       }
	    //     }
	    //     return <div>{formatCurrency2(val.Gross)}</div>
	    //   }
	    //   // Discount
	    //   const renderDiscount = () => {
	    //     return (
	    //       <div>
	    //         {!this.onlyShow() && (<input type='text' defaultValue={formatCurrency2(val.Discount)} onBlur={editPrice} ref={ref3} name='Discount' key={'discount_' + val.TaskPriceId + '_' + val.Discount} />)}
	    //         {isCustomer && (<div>&nbsp;</div>)}
	    //         {this.onlyShow() && !isCustomer && (<div>{formatCurrency2(val.Discount)}</div>)}
	    //       </div>
	    //     )
	    //   }
	    //   // Net price
	    //   const renderNet = () => {
	    //     return (
	    //       <div>
	    //         {!this.onlyShow() && (<input type='text' defaultValue={formatCurrency2(val.Net)} ref={ref4} onBlur={editPrice} name='Net' key={'net_' + val.TaskPriceId + '_' + val.Net} />)}
	    //         {this.onlyShow() && (<div>{formatCurrency2(val.Net)}</div>)}
	    //       </div>
	    //     )
	    //   }
	    //   if (this.state.isCustomer) {
	    //     return (
	    //       <li key={key} className='clearfix form'>
	    //         <div>{val.TaskName}</div>
	    //         {renderWorkunits()}
	    //         {renderGross()}
	    //         <div>{formatCurrency2(val.Environment)}</div>
	    //       </li>
	    //     )
	    //   }
	    //   // Return
	    //   return (
	    //     <li key={key} className='clearfix form'>
	    //       <div>{val.TaskName}</div>
	    //       {renderWorkunits()}
	    //       {renderGross()}
	    //       {renderDiscount()}
	    //       {renderNet()}
	    //       <div>{formatCurrency2(val.Environment)}</div>
	    //       <div>{formatCurrency2(val.Total)}</div>
	    //       {!this.onlyShow() && !isCustomer && (
	    //         <div className='buttonWrap'>
	    //           <span className='delete' onClick={deleteItem}><img src='/images/icons/Minus-White_16px.png' /></span>
	    //         </div>
	    //       )}
	    //     </li>
	    //   )
	    // }
	
	  }, {
	    key: 'renderCustomAgreement',
	    value: function renderCustomAgreement() {
	      var _this16 = this;
	
	      // if (this.state.price.Name === null) return null
	      var price = this.state.price;
	
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var isShop = (0, _auth.hasAccess)([3, 5, 7, 8], this.props.auth.user.UserType);
	      var name = price.Name;
	      var isWP = (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.state.selectedShopId !== -1;
	      if (this.props.selectedCustomerId !== -1) name = price.ParentPriceModelName;
	      // let isCustomer = this.props.customer
	      var renderAgreement = function renderAgreement() {
	        var onDelete = function onDelete() {
	          _this16.setState({
	            confirmDelete: {
	              open: true
	            }
	          });
	        };
	        // const onDeactivate = () => {
	        //   this.setState({
	        //     confirmDeactivate: {
	        //       open: true
	        //     }
	        //   })
	        // }
	        var isMain = _this16.props.isMain !== undefined && _this16.props.isMain !== null && _this16.props.isMain && (0, _auth.hasAccess)([6], _this16.props.auth.user.UserType);
	        var disableComment = !(0, _auth.hasAccess)([6], _this16.props.auth.user.UserType); // this.props.isMain !== undefined && this.props.isMain !== null && this.props.isMain
	        // Set to true to enable delete agreements
	        var canDelete = false;
	        var helptxt = isMain && (0, _helpers.translation)('12265');
	        console.log(helptxt);
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('13472') },
	          _react2.default.createElement(_text2.default, { name: 'Name', value: name, disabled: true, onBlur: _this16.onInputBlur, labelText: (0, _helpers.translation)('30') }),
	          !isCustomer && _react2.default.createElement(_textarea2.default, { type: 'text', name: 'Comment', value: price.Comment, disabled: disableComment, onChange: _this16.onInputChange, onBlur: _this16.onInputBlur, labelText: (0, _helpers.translation)('149') }),
	          _react2.default.createElement(_switch2.default, { name: 'Active', onChange: _this16.onInputChange, checked: price.Active, disabled: isCustomer || isShop, labelText: (0, _helpers.translation)('295'), helpText: isMain ? (0, _helpers.translation)('12265') : null }),
	          isWP && !isMain && _react2.default.createElement(_switch2.default, { name: 'ActiveFromParent', onChange: _this16.onInputChange, checked: price.ActiveFromParent, disabled: isCustomer || isShop, labelText: (0, _helpers.translation)('16673') }),
	          _react2.default.createElement(
	            'div',
	            null,
	            isWP && canDelete && _react2.default.createElement(_button2.default, { style: 'alert', onClick: onDelete, labelText: (0, _helpers.translation)('12264') }),
	            !isCustomer && _react2.default.createElement(_button2.default, { style: 'link', onClick: _this16.showPriceModelLog, labelText: (0, _helpers.translation)('1865') }),
	            _react2.default.createElement(_PriceModelLogModal2.default, { priceModelId: price.PriceModelId, show: _this16.state.showPriceModelLog, onClose: _this16.showPriceModelLog })
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderAgreement(),
	        this.renderOrderTypes(),
	        this.renderCustomers(),
	        this.renderBrands()
	      );
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      return true;
	    }
	  }, {
	    key: 'showPriceModelLog',
	    value: function showPriceModelLog() {
	      this.props.triggerPopup(!this.state.showPriceModelLog);
	      this.setState({
	        showPriceModelLog: !this.state.showPriceModelLog
	      });
	    }
	  }, {
	    key: 'renderSubContractors',
	    value: function renderSubContractors() {
	      var _this17 = this;
	
	      if (!(0, _auth.hasAccess)([600], this.props.auth.user.UserType)) return null;
	      var price = this.state.price;
	      // Render sub contractor
	
	      var renderContractor = function renderContractor(item, key) {
	        var onInputBlur = function onInputBlur(e) {
	          var price = _extends({}, _this17.state.price);
	          price.PriceModelSubContractors[key][e.target.name] = e.target.value;
	          _this17.updatePrices(price);
	        };
	        var onInputChange = function onInputChange(e) {
	          var price = _extends({}, _this17.state.price);
	          var name = e.target.name.split('_')[0];
	          price.PriceModelSubContractors[key][name] = e.target.value === 'yes';
	          _this17.updatePrices(price);
	        };
	        // Keys
	        var key1 = 'PriceHourly_' + item.SubContractorId + '_' + item.PriceHourly;
	        var key2 = 'PriceMaterial_' + item.SubContractorId + '_' + item.PriceMaterial;
	        var key3 = 'PriceEnvironment_' + item.SubContractorId + '_' + item.PriceEnvironment;
	        var key4 = 'PriceDiscount_' + item.SubContractorId + '_' + item.PriceDiscount;
	        // Render customers
	        var customers = [];
	        price.PriceModelCustomers.map(function (val) {
	          if (val.ShopId === item.CompanyId) {
	            customers.push(val.CustomerName);
	          }
	        });
	        var customersHtml = "<span class='hint--bottom-left' aria-label='" + customers.join('&#xa;') + "'><img src='/images/icons/menu/Customers-Black.png' /></span>";
	        // Return
	        return _react2.default.createElement(
	          'div',
	          { className: 'form fifty', key: key },
	          _react2.default.createElement(
	            'strong',
	            { className: 'clearfix' },
	            item.CompanyName,
	            ' ',
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: customersHtml } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('419')
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'PriceHourly', defaultValue: item.PriceHourly, onBlur: onInputBlur, key: key1 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('13338'),
	              ' (%)'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'PriceMaterial', defaultValue: item.PriceMaterial, onBlur: onInputBlur, key: key2 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('13339'),
	              ' (%)'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'PriceEnvironment', defaultValue: item.PriceEnvironment, onBlur: onInputBlur, key: key3 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('1199'),
	              ' (%)'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'PriceDiscount', defaultValue: item.PriceDiscount, onBlur: onInputBlur, key: key4 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group radio__custom__outer' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('1236')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'radio__custom__wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'radio__custom' },
	                _react2.default.createElement('input', { type: 'radio', id: 'discount_yes_' + item.SubContractorId, name: 'IsEnvironmentDiscount_' + item.SubContractorId, value: 'yes', onChange: onInputChange, checked: item.IsEnvironmentDiscount }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'discount_yes_' + item.SubContractorId },
	                  (0, _helpers.translation)('47')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'radio__custom' },
	                _react2.default.createElement('input', { type: 'radio', id: 'discount_no_' + item.SubContractorId, name: 'IsEnvironmentDiscount_' + item.SubContractorId, value: 'no', onChange: onInputChange, checked: !item.IsEnvironmentDiscount }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'discount_no_' + item.SubContractorId },
	                  (0, _helpers.translation)('48')
	                )
	              )
	            )
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(
	          'div',
	          { className: 'white__box subcontractors_list' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            (0, _helpers.translation)('1737')
	          ),
	          price.PriceModelSubContractors.map(renderContractor)
	        )
	      );
	    }
	  }, {
	    key: 'renderOrderTypes',
	    value: function renderOrderTypes() {
	      var isDisabled = true; // !hasAccess([6], this.props.auth.user.UserType)
	      var price = this.state.price;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('525') },
	        _react2.default.createElement(_radio2.default, { id: 'ordertype_1', name: 'PriceType', value: '1', onChange: this.changeType, checked: price.PriceType === 1, disabled: isDisabled, labelText: (0, _helpers.translation)('71') }),
	        _react2.default.createElement(_radio2.default, { id: 'ordertype_3', name: 'PriceType', value: '3', onChange: this.changeType, checked: price.PriceType === 3, disabled: isDisabled, labelText: (0, _helpers.translation)('13361') }),
	        _react2.default.createElement(_radio2.default, { id: 'ordertype_2', name: 'PriceType', value: '2', onChange: this.changeType, checked: price.PriceType === 2, disabled: isDisabled, labelText: (0, _helpers.translation)('785') }),
	        _react2.default.createElement(_radio2.default, { id: 'ordertype_8', name: 'PriceType', value: '8', onChange: this.changeType, checked: price.PriceType === 8, disabled: isDisabled, labelText: (0, _helpers.translation)('1396') })
	      );
	    }
	  }, {
	    key: 'renderCustomersPartners',
	    value: function renderCustomersPartners() {
	      var _this18 = this;
	
	      var price = _extends({}, this.state.price);
	      // Render shop
	      var renderShop = function renderShop(val, key) {
	        var onChange = function onChange(e) {
	          e.persist();
	          _this18.setState({
	            ShopId: parseInt(e.target.value),
	            customers: []
	          }, function () {
	            _this18.props.getCustomers(e.target.value).then(function (res) {
	              _this18.setState({
	                customers: res.data
	              });
	            }, function () {
	              console.log('Err getting customers');
	            });
	          });
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'radio__custom', key: key },
	          _react2.default.createElement('input', { type: 'radio', id: 'ShopId_' + val.ShopId, name: 'ShopId', value: val.ShopId, onChange: onChange, checked: _this18.state.ShopId === val.ShopId }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'ShopId_' + val.ShopId },
	            val.ShopName
	          )
	        );
	      };
	      // Render customer
	      var renderCustomer = function renderCustomer(val, key) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'checkbox__custom', key: key },
	          _react2.default.createElement('input', { type: 'checkbox', id: 'CustomerId_' + val.CustomerId, name: 'CustomerId', value: val.CustomerId, ref: 'CustomerId_' + val.CustomerId }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'CustomerId_' + val.CustomerId },
	            val.Name
	          )
	        );
	      };
	      // Add
	      var addItems = function addItems() {
	        var selectedCustomers = [];
	        var price = _extends({}, _this18.state.price);
	        Object.keys(_this18.refs).map(function (val, key) {
	          if (val.indexOf('CustomerId') !== -1) {
	            if (_this18.refs[val].checked) {
	              selectedCustomers.push(val.split('_')[1]);
	              // Add customer
	              price.PriceModelCustomers.push({
	                CustomerId: val.split('_')[1]
	              });
	            }
	          }
	        });
	        if (selectedCustomers.length === 0) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('1736'), (0, _helpers.translation)('216'));
	        } else {
	          // Add shop
	          price.PriceModelSubContractors.push({
	            CompanyId: _this18.state.ShopId
	          });
	          // Update prices
	          _this18.updatePrices(price);
	        }
	      };
	      // Render SubContractor
	      var renderSubcontractor = function renderSubcontractor(item, key) {
	        var customers = price.PriceModelCustomers.filter(function (val) {
	          return val.ShopId === item.CompanyId;
	        });
	        if (customers.length === 0) return null;
	        var renderCustomer = function renderCustomer(val, k) {
	          var deleteItem = function deleteItem() {
	            var price = _extends({}, _this18.state.price);
	            price.PriceModelCustomers.map(function (item) {
	              if (item.CustomerId === val.CustomerId) {
	                item.IsDeleted = true;
	              }
	            });
	            _this18.updatePrices(price);
	          };
	          return _react2.default.createElement(
	            'li',
	            { key: k, className: 'clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'customer' },
	              val.CustomerName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'buttonWrap' },
	              _react2.default.createElement(
	                'span',
	                { className: 'delete', onClick: deleteItem },
	                _react2.default.createElement('img', { src: '/images/icons/Minus-White_16px.png' })
	              )
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            'strong',
	            null,
	            item.CompanyName
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement('li', null),
	            customers.map(renderCustomer)
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'white__box partnerCustomers' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          (0, _helpers.translation)('14')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'scrollable_list' },
	          this.props.companies.map(renderShop)
	        ),
	        this.state.customers.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'scrollable_list' },
	          this.state.customers.map(renderCustomer)
	        ),
	        this.state.ShopId !== 0 && _react2.default.createElement(
	          'button',
	          { className: 'button full primary', onClick: addItems },
	          (0, _helpers.translation)('1208')
	        ),
	        price.PriceModelSubContractors.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'subcontractors' },
	          price.PriceModelSubContractors.map(renderSubcontractor)
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      var _this19 = this;
	
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) || this.props.partners) return null;
	      if ((0, _auth.hasAccess)([2, 3, 4, 7], this.props.auth.user.UserType)) return null;
	      var price = this.state.price;
	      var customers = this.props.customers;
	
	      var ref = 'customersid';
	      // Add customers
	      var addItem = function addItem() {
	        var id = parseInt(_this19.refs[ref].value);
	        if (id !== 0) {
	          var _price = _extends({}, _this19.state.price);
	          _price.PriceModelCustomers.push({
	            CustomerId: id
	          });
	          _this19.updatePrices(_price).then(function () {
	            _this19.refs[ref].value = 0;
	          });
	        }
	      };
	      // Render customer
	      var renderCustomer = function renderCustomer(val, key) {
	        // Delete item
	        var deleteItem = function deleteItem(e) {
	          var price = _extends({}, _this19.state.price);
	          price.PriceModelCustomers[key].IsDeleted = true;
	          _this19.updatePrices(price);
	        };
	        // Return
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: key },
	          _react2.default.createElement(
	            'div',
	            { className: 'customer' },
	            val.CustomerName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'buttonWrap' },
	            _react2.default.createElement(
	              'span',
	              { className: 'delete', onClick: deleteItem },
	              _react2.default.createElement('img', { src: '/images/icons/Minus-White_16px.png' })
	            )
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'white__box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          (0, _helpers.translation)('14')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'radio__custom__wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'radio__custom' },
	              _react2.default.createElement('input', { type: 'radio', id: 'customers_all', name: 'CustomerSelectionType', value: '0', onChange: this.changeType, checked: price.CustomerSelectionType === 0 }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'customers_all' },
	                (0, _helpers.translation)('381')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'radio__custom' },
	              _react2.default.createElement('input', { type: 'radio', id: 'customers_selected', name: 'CustomerSelectionType', value: '1', onChange: this.changeType, checked: price.CustomerSelectionType === 1 }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'customers_selected' },
	                (0, _helpers.translation)('13475')
	              )
	            )
	          ),
	          price.CustomerSelectionType === 1 && _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement('li', null),
	            price.PriceModelCustomers.map(renderCustomer),
	            _react2.default.createElement(
	              'li',
	              { className: 'clearfix form' },
	              _react2.default.createElement(
	                'div',
	                { className: 'customer' },
	                _react2.default.createElement(
	                  'select',
	                  { ref: ref },
	                  _react2.default.createElement('option', { value: '0' }),
	                  customers.map(function (val, key) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: val.CustomerId, key: key },
	                      val.Name
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'buttonWrap' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'delete', onClick: addItem },
	                  _react2.default.createElement('img', { src: '/images/icons/Plus-White.png' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderBrands',
	    value: function renderBrands() {
	      var price = this.state.price;
	
	
	      var renderBrand = function renderBrand(val, key) {
	        return _react2.default.createElement(
	          _label2.default,
	          { key: key },
	          val.BrandName
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13473') },
	        price.BrandSelectionType === 0 && _react2.default.createElement(_radio2.default, { name: 'BrandSelectionType', value: '0', disabled: true, checked: 'true', labelText: (0, _helpers.translation)('381') }),
	        price.BrandSelectionType === 1 && _react2.default.createElement(
	          'div',
	          null,
	          price.PriceModelBrands.map(renderBrand)
	        )
	      );
	    }
	
	    // Renders the fixed unit/discount box
	
	  }, {
	    key: 'renderDiscountPrice',
	    value: function renderDiscountPrice() {
	      var _this20 = this;
	
	      var price = _extends({}, this.state.price);
	      // let ref1 = 'discount_unit'
	      // let ref2 = 'discount_discount'
	      var isMain = this.state.isMain;
	      var newTaskPrice = (0, _currency.formatCurrency2)(price.NewTaskPrice);
	      var unitDiscount = (0, _percent.transformPercent)((0, _currency.formatCurrency2)(price.NewTaskDiscount));
	      var useTaskDiscount = price.UseNewTaskDiscount;
	      var useNewTaskPrice = price.UseNewTaskPrice;
	      // this.refs[ref1].value = price.FixedUnitPrice
	      // this.refs[ref2].value = price.FixedDiscount
	      // Apply
	      var apply = function apply(type, e) {
	        if (type === 'unit') {
	          // price.FixedUnitPrice = reverseFormatCurrency2(this.refs[ref1].value)
	          price.FixedUnitPrice = (0, _currency.reverseFormatCurrency2)(newTaskPrice);
	          price.NewTaskPrice = (0, _currency.reverseFormatCurrency2)(newTaskPrice);
	          price.FixedDiscount = 0;
	          price.FixedPriceType = 1;
	        } else if (type === 'discount') {
	          price.FixedUnitPrice = 0;
	          price.FixedPriceType = 2;
	          // price.FixedDiscount = reverseFormatCurrency2(this.refs[ref2].value)
	          // price.NewTaskDiscount = reverseFormatCurrency2(this.refs[ref2].value)
	          price.FixedDiscount = (0, _currency.reverseFormatCurrency2)(unitDiscount);
	          price.NewTaskDiscount = (0, _currency.reverseFormatCurrency2)(unitDiscount);
	        }
	        _this20.updatePrices(price).then(function () {
	          // this.refs[ref1].value = ''
	          // this.refs[ref2].value = isMain ? '' : reverseFormatCurrency2(this.refs[ref2].value)
	          unitDiscount = (0, _currency.reverseFormatCurrency2)(unitDiscount);
	          newTaskPrice = (0, _currency.reverseFormatCurrency2)(newTaskPrice);
	          _this20.setState({
	            confirm: {
	              open: false,
	              type: 0
	            }
	          });
	        });
	      };
	      // Format price
	      var formatPrice = function formatPrice(e) {
	        var value = (0, _percent.transformPercent)(e.target.value, true) === '' ? '0' : (0, _percent.transformPercent)(e.target.value, true);
	        var currencyValue = (0, _currency.formatCurrency2)((0, _currency.reverseFormatCurrency2)(value));
	        if (e.target.name === 'unit') {
	          // this.refs[ref1].value = currencyValue
	          newTaskPrice = currencyValue;
	          if (!isMain) {
	            var _price2 = _extends({}, _this20.state.price);
	            _price2.NewTaskPrice = (0, _currency.reverseFormatCurrency2)(currencyValue);
	            _this20.updatePrices(_price2);
	          }
	        } else {
	          unitDiscount = currencyValue;
	          // this.refs[ref2].value = currencyValue
	          if (!isMain) {
	            var _price3 = _extends({}, _this20.state.price);
	            _price3.NewTaskDiscount = (0, _currency.reverseFormatCurrency2)(currencyValue);
	            _this20.updatePrices(_price3);
	          }
	        }
	      };
	      // Open portal
	      var openPortal = function openPortal(type) {
	        _this20.setState({
	          confirm: {
	            open: true,
	            type: type
	          }
	        });
	      };
	      var renderText = function renderText() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)('2017')
	        );
	      };
	      if (this.onlyShow()) return undefined;
	
	      var onChangeDiscount = function onChangeDiscount(e) {
	        var value = (0, _percent.transformPercent)(e.target.value, true);
	        if (e.target.name === 'discount') {
	          _this20.setState({
	            price: _extends({}, _this20.state.price, {
	              NewTaskDiscount: value
	            })
	          }, function () {});
	        } else if (e.target.name === 'unit') {
	          _this20.setState({
	            price: _extends({}, _this20.state.price, {
	              NewTaskPrice: value
	            })
	          }, function () {});
	        }
	      };
	      var onChange = function onChange(e) {
	        e.persist();
	        var value = e.target.value;
	        var name = e.target.name;
	        if (e.target.type === 'checkbox') {
	          value = e.target.checked;
	        }
	        if (name === 'UseNewTaskPrice' || name === 'UseNewTaskDiscount') {
	          var _useNewTaskPrice = false;
	          var useNewTaskDiscount = false;
	          if (name === 'UseNewTaskDiscount') {
	            useNewTaskDiscount = value;
	          } else {
	            _useNewTaskPrice = value;
	          }
	
	          _this20.setState({
	            price: _extends({}, _this20.state.price, {
	              UseNewTaskPrice: _useNewTaskPrice,
	              UseNewTaskDiscount: useNewTaskDiscount
	            })
	          }, function () {
	            // console.log(e.target.name, e.target.checked, this.state.price)
	            _this20.updatePrices(_this20.state.price);
	          });
	        } else {
	          _this20.setState({
	            price: _extends({}, _this20.state.price, _defineProperty({}, e.target.name, value))
	          }, function () {
	            // console.log(e.target.name, e.target.checked, this.state.price)
	            _this20.updatePrices(_this20.state.price);
	          });
	        }
	      };
	      // Return
	      //  <input type='text' ref={ref1} onBlur={formatPrice} name='unit' />
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('2258') },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [3, 2, 1] },
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('13476'), helpText: (0, _helpers.translation)('2080') }),
	          _react2.default.createElement(_text2.default, { name: 'unit', value: newTaskPrice, onChange: onChangeDiscount, onBlur: formatPrice, size: 'm' }),
	          _react2.default.createElement(_button2.default, { onClick: openPortal.bind(this, 'unit'), labelText: (0, _helpers.translation)('1218'), size: 'm' })
	        ),
	        !isMain && _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(_check2.default, { name: 'UseNewTaskPrice', value: '1', checked: useNewTaskPrice, onChange: onChange, labelText: (0, _helpers.translation)('13549'), helpText: (0, _helpers.translation)('13550') })
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [3, 2, 1] },
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('13477') + ' (%)', helpText: (0, _helpers.translation)('2081') }),
	          _react2.default.createElement(_text2.default, { name: 'discount', value: unitDiscount, onChange: onChangeDiscount, onBlur: formatPrice, onFocus: _percent.onPercentFocus, size: 'm' }),
	          _react2.default.createElement(_button2.default, { onClick: openPortal.bind(this, 'discount'), labelText: (0, _helpers.translation)('1218'), size: 'm' })
	        ),
	        !isMain && _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(_check2.default, { name: 'UseNewTaskDiscount', value: '1', checked: useTaskDiscount, onChange: onChange, labelText: (0, _helpers.translation)('12312'), helpText: (0, _helpers.translation)('12313') })
	        ),
	        this.state.confirm.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: this.onPortalClose.bind(this, 'confirm') },
	          _react2.default.createElement(_Confirm2.default, { renderText: renderText, confirm: apply.bind(this, this.state.confirm.type), notConfirm: this.onPortalClose.bind(this, 'confirm') })
	        )
	      );
	      // return (
	      //   <div className='white__box'>
	      //     <div className='title'>{translation('2258')}</div>
	      //     <ul className='discount__list'>
	      //       <li />
	      //       <li className='clearfix form'>
	      //         <div>{translation('13476')} <HelpText className='helpText' text={translation('2080')} /></div>
	      //         <div>
	      //           <input type='text' onChange={onChangeDiscount} value={newTaskPrice} onBlur={formatPrice} name='unit' />
	      //         </div>
	      //         <div className='buttonWrap'>
	      //           <button className='button full primary' onClick={openPortal.bind(this, 'unit')}>
	      //             <img src='/images/icons/circle_plus22.png' />{translation('1218')}
	      //           </button>
	      //         </div>
	      //       </li>
	      //       {!isMain && (<li className='clearfix form'>
	      //         <div className='checkbox__custom__wrapper'>
	      //           <div className='checkbox__custom'>
	      //             <input type='checkbox' name='UseNewTaskPrice' id='UseNewTaskPrice' value='1' checked={useNewTaskPrice} onChange={onChange} />
	      //             <label htmlFor='UseNewTaskPrice' >{translation('13549')}
	      //               <HelpText className='helpText' text={translation('13550')} />
	      //             </label>
	      //           </div>
	      //         </div>
	      //       </li>)}
	      //       <li className='clearfix form'>
	      //         <div>{translation('13477')} (%) <HelpText className='helpText' text={translation('2081')} /></div>
	      //         <div>
	      //           {!isMain && (<input type='text' onChange={onChangeDiscount} value={unitDiscount} onBlur={formatPrice} onFocus={onPercentFocus} name='discount' />)}
	      //           {isMain && (<input type='text' onChange={onChangeDiscount} value={unitDiscount} onBlur={formatPrice} onFocus={onPercentFocus} name='discount' />)}
	      //         </div>
	      //         <div className='buttonWrap'>
	      //           <button className='button full primary' onClick={openPortal.bind(this, 'discount')}>
	      //             <img src='/images/icons/circle_plus22.png' />{translation('1218')}
	      //           </button>
	      //         </div>
	      //       </li>
	      //       {!isMain && (<li className='clearfix form'>
	      //         <div className='checkbox__custom__wrapper'>
	      //           <div className='checkbox__custom'>
	      //             <input type='checkbox' name='UseNewTaskDiscount' id='UseNewTaskDiscount' value='1' checked={useTaskDiscount} onChange={onChange} />
	      //             <label htmlFor='UseNewTaskDiscount'>{translation('12312')}
	      //               <HelpText className='helpText' text={translation('12313')} />
	      //             </label>
	      //           </div>
	      //         </div>
	      //       </li>)}
	      //     </ul>
	      //     {this.state.confirm.open && (
	      //       <Portal className='deleteModal' onPortalClose={this.onPortalClose.bind(this, 'confirm')}>
	      //         <Confirm renderText={renderText} confirm={apply.bind(this, this.state.confirm.type)} notConfirm={this.onPortalClose.bind(this, 'confirm')} />
	      //       </Portal>
	      //     )}
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'renderIndexAdjustments',
	    value: function renderIndexAdjustments() {
	      var _this21 = this;
	
	      // Do not render if estimation type model
	      if (this.state.price.PriceType === 5) return null;
	
	      // console.log('UserType = ', this.props.auth.user.UserType, (this.props.partners ? 'Partner = true' : 'partner = fale'))
	      // Render for wp, and shop type users editing a customer
	      var access = false;
	      // if (hasAccess([3, 5, 7], this.props.auth.user.UserType) && this.props.customer) access = true
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) access = true;
	      if (access === false) return; // Det er sent..
	
	      if (this.props.partners) {
	        // Do not render for wp/chain
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	      var price = _extends({}, this.state.price);
	      // let indexAdjustments = [...price.IndexAdjustments]
	      var cols = [4, 4, 1];
	
	      var renderNew = function renderNew() {
	        var newItem = _this21.state.new_indexAdjust;
	
	        var addItem = function addItem() {
	          if (newItem.Date === null || newItem.Date === '') return;
	          newItem.Date = (0, _time.formatDate)(newItem.Date);
	          price.IndexAdjustments.push(newItem);
	          _this21.updatePrices(price);
	        };
	
	        var onChange = function onChange(e) {
	          var value = '';
	          var name = '';
	          if (typeof e.target !== 'undefined') {
	            value = parseFloat((0, _percent.transformPercent)(e.target.value, true) || '0');
	            name = e.target.name;
	          } else {
	            value = e;
	            name = 'Date';
	          }
	          _this21.setState({
	            new_indexAdjust: _extends({}, _this21.state.new_indexAdjust, _defineProperty({}, name, value))
	          }, function () {
	            // console.log('New index adjust ', this.state.new_indexAdjust)
	          });
	        };
	
	        var inputProps = {
	          name: 'Date',
	          placeholder: (0, _helpers.translation)('1728'),
	          readOnly: true
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: cols },
	          _react2.default.createElement(_datetime2.default, {
	            inputProps: inputProps,
	            dateFormat: 'DD-MM-YYYY',
	            timeFormat: false,
	            closeOnSelect: true,
	            value: newItem.Date,
	            onChange: onChange,
	            size: 's'
	          }),
	          _react2.default.createElement(_text2.default, {
	            name: 'Amount',
	            value: (0, _percent.transformPercent)(newItem.Amount),
	            onChange: onChange,
	            onFocus: _percent.onPercentFocus,
	            size: 's'
	          }),
	          _react2.default.createElement(_addButton2.default, { onClick: addItem, size: 's' })
	        );
	      };
	
	      var renderIndexAdjustLine = function renderIndexAdjustLine(val, key) {
	        var deleteItem = function deleteItem(e) {
	          var price = _extends({}, _this21.state.price);
	          price.IndexAdjustments[key].IsDeleted = true;
	          _this21.updatePrices(price);
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, key: key, spacing: 1 },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _time.renderFullDate)(val.Date, false)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _percent.transformPercent)(parseFloat(val.Amount))
	          ),
	          !val.IsApplied && _react2.default.createElement(_removeButton2.default, { onClick: deleteItem, size: 's' }),
	          val.IsApplied && _react2.default.createElement('span', null)
	        );
	      };
	
	      var hasIndexAdjustments = price.IndexAdjustments !== undefined;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1876'), helpText: (0, _helpers.translation)('2085') },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: cols },
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('388') }),
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('1877') + ' (%)' })
	        ),
	        hasIndexAdjustments && price.IndexAdjustments.map(renderIndexAdjustLine),
	        renderNew()
	      );
	    }
	  }, {
	    key: 'renderPriceModelLog',
	    value: function renderPriceModelLog() {
	      // Do not render if estimation type model
	      if (this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	
	      var log = this.state.log;
	
	      var renderLogLine = function renderLogLine(val, key) {
	        var changeText = (0, _helpers.translation)('1873');
	        var addedText = (0, _helpers.translation)('1874');
	        var removedText = (0, _helpers.translation)('1875');
	
	        var text = '';
	        var fieldName = '';
	        var tableName = '';
	        var fromVal = val.FromText !== null && val.FromText !== '' ? val.FromText : val.From;
	        var toVal = val.ToText !== null && val.ToText !== '' ? val.ToText : val.To;
	        var changedBy = val.ChangedByName;
	        var changedTime = val.ChangedAt;
	
	        switch (val.ChangeTable) {
	          case 0:
	            tableName = '';
	            break;
	          case 1:
	            tableName = (0, _helpers.translation)('1867');
	            break;
	          case 2:
	            tableName = (0, _helpers.translation)('1227');
	            break;
	          case 3:
	            tableName = (0, _helpers.translation)('13344');
	            break;
	          case 4:
	            tableName = (0, _helpers.translation)('13374');
	            break;
	          case 12:
	            tableName = (0, _helpers.translation)('1871');
	            break;
	          case 13:
	            tableName = (0, _helpers.translation)('1872');
	            break;
	        }
	
	        switch (val.ChangeField) {
	          case 1:
	            fieldName = (0, _helpers.translation)('30');
	            break;
	          case 2:
	            fieldName = (0, _helpers.translation)('295');
	            break;
	          case 9:
	            fieldName = (0, _helpers.translation)('419');
	            break;
	          case 10:
	            fieldName = (0, _helpers.translation)('13443');
	            break;
	          case 11:
	            fieldName = (0, _helpers.translation)('1044');
	            break;
	          case 12:
	            fieldName = (0, _helpers.translation)('1199');
	            break;
	          case 13:
	            fieldName = (0, _helpers.translation)('885');
	            break;
	          case 14:
	            fieldName = (0, _helpers.translation)('13350');
	            break;
	          case 15:
	            fieldName = (0, _helpers.translation)('13431');
	            break;
	          case 16:
	            fieldName = (0, _helpers.translation)('1305');
	            break;
	          case 17:
	            fieldName = (0, _helpers.translation)('393');
	            break;
	        }
	
	        switch (val.changeType) {
	          case 0:
	            text = changeText;
	            break;
	          case 1:
	            text = addedText;
	            break;
	          case 2:
	            text = removedText;
	            break;
	        }
	        text = text.replace('[table]', tableName);
	        text = text.replace('[field]', fieldName);
	        text = text.replace('[fromvalue]', fromVal);
	        text = text.replace('[tovalue]', toVal);
	        text = text.replace('[user]', changedBy);
	        text = text.replace('[time]', changedTime);
	
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: key },
	          _react2.default.createElement(
	            'div',
	            null,
	            changedTime
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            text
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'white__box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          (0, _helpers.translation)('1866')
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'changelog' },
	          _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              (0, _helpers.translation)('388')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text' },
	              (0, _helpers.translation)('1489')
	            )
	          ),
	          log.map(renderLogLine)
	        )
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	    }
	  }, {
	    key: 'renderExtras',
	    value: function renderExtras() {
	      if (this.state.selectedCustomerId > 0 || (this.state.isShop || this.state.isCustomer) && this.state.price.ServiceTasks.length > 0) {
	        return _react2.default.createElement(_PriceItemGroup2.default, {
	          config: (0, _config.getServiceTaskConfig)((0, _config.createConfigContext)(this.props.auth, this.state.price)),
	          items: this.state.price.ServiceTasks,
	          onAdd: this.updateOrAddItem,
	          onDelete: this.deleteItem,
	          onUpdate: this.updateOrAddItem,
	          onDragged: this.moveItem,
	          disabled: this.state.IsWorking });
	        // return <Extras item={this.state.price} showExtras showServices customer={this.props.customer} />
	      }
	      return undefined;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this22 = this;
	
	      // console.log('details')
	      // if (Object.keys(this.state.price).length === 0) return null
	      var renderIndexAdjustmentsRight = (0, _auth.hasAccess)([600], this.props.auth.user.UserType);
	      if (this.props.selectedTabIndex === 1 && this.props.selectedCustomerId < 0) {
	        return null;
	      }
	      var confirmDelete = function confirmDelete(props) {
	        var ctext = _this22.props.isMain && (0, _auth.hasAccess)([6], _this22.props.auth.user.UserType) ? props.t('12266') : props.t('403');
	        return _react2.default.createElement(
	          'div',
	          null,
	          ctext
	        );
	      };
	      var confirmDeactivate = function confirmDeactivate(props) {
	        var ctext = _this22.props.isMain && (0, _auth.hasAccess)([6], _this22.props.auth.user.UserType) ? props.t('12267') : props.t('16840');
	        if (!_this22.props.isMain && (0, _auth.hasAccess)([6], _this22.props.auth.user.UserType) && _this22.state.price.ActiveFromParent) {
	          ctext = props.t('16675');
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          ctext
	        );
	      };
	      var confirmActivate = function confirmActivate(props) {
	        var ctext = _this22.state.confirmActivate.type === 'ActiveFromParent' ? props.t('16674') : props.t('16841');
	        return _react2.default.createElement(
	          'div',
	          null,
	          ctext
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'details__screen' },
	        _react2.default.createElement(
	          'fieldset',
	          { disabled: this.props.creating },
	          _react2.default.createElement(
	            _row2.default,
	            null,
	            _react2.default.createElement(
	              _col2.default,
	              { span: '2' },
	              this.renderCustomAgreement(),
	              this.renderPrices(),
	              this.renderSize(),
	              !renderIndexAdjustmentsRight && this.renderIndexAdjustments()
	            ),
	            this.renderPriceParts('col'),
	            this.renderSubContractors(),
	            renderIndexAdjustmentsRight && _react2.default.createElement(
	              _col2.default,
	              null,
	              this.renderIndexAdjustments()
	            )
	          )
	        ),
	        this.state.confirmDelete.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDelete') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirmDelete.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDelete'), higher: true, renderText: confirmDelete })
	        ),
	        this.state.confirmDeactivate.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDeactivate') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirmDeactivate.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDeactivate'), higher: true, renderText: confirmDeactivate })
	        ),
	        this.state.confirmActivate.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmActivate') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirmActivate.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmActivate'), higher: true, renderText: confirmActivate })
	        )
	      );
	    }
	  }, {
	    key: 'onConfirmActivate',
	    value: function onConfirmActivate() {
	      var _this23 = this;
	
	      this.onPortalClose('confirmActivate');
	      var extra = {};
	      if (this.state.confirmActivate.type === 'ActiveFromParent') extra = { ActiveFromParent: true };
	
	      this.setState({
	        price: _extends({}, this.state.price, {
	          Active: true
	        }, extra)
	      }, function () {
	        _this23.updatePrices(_this23.state.price).then(function (res) {
	          // this.props.getPriceLists(this.props)
	        });
	      });
	    }
	  }, {
	    key: 'onConfirmDeactivate',
	    value: function onConfirmDeactivate() {
	      var _this24 = this;
	
	      this.onPortalClose('confirmDeactivate');
	      this.setState({
	        price: _extends({}, this.state.price, {
	          Active: false,
	          ActiveFromParent: false // only applies to sub agreements - check in backend
	        })
	      }, function () {
	        _this24.updatePrices(_this24.state.price).then(function (res) {
	          // this.props.getPriceLists(this.props)
	        });
	      });
	    }
	  }, {
	    key: 'onConfirmDelete',
	    value: function onConfirmDelete() {
	      var _this25 = this;
	
	      this.onPortalClose('confirmDelete');
	      var price = _extends({}, this.state.price);
	      price.IsDeleted = true;
	      this.updatePrices(price).then(function () {
	        _this25.props.onShouldUpdate();
	      });
	    }
	  }]);
	
	  return AgreementDetails;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers,
	    companies: state.common.companies,
	    brands: state.common.brands
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceList: _priceModel.getPriceList,
	  updatePriceList: _priceModel.updatePriceList,
	  reorderPriceListItem: _priceModel.reorderPriceListItem,
	  getCustomers: _customers.getCustomers,
	  triggerPopup: _backdrop.triggerPopup,
	  getBrands: _common.getBrands,
	  getShopsForCustomerGroup: _customerGroup.getShopsForCustomerGroup,
	  getShopCustomerAgreement: _priceModel.getShopCustomerAgreement,
	  getShopCustomers: _customerGroup.getShopCustomers
	})(AgreementDetails);

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _priceModel = __webpack_require__(75);
	
	var _customers = __webpack_require__(74);
	
	var _backdrop = __webpack_require__(29);
	
	var _customerGroup = __webpack_require__(107);
	
	var _common = __webpack_require__(25);
	
	var _agreementConstraint = __webpack_require__(171);
	
	var _currency = __webpack_require__(41);
	
	var _percent = __webpack_require__(178);
	
	__webpack_require__(1439);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Datetime from 'react-datetime'
	
	// Modals
	// import PriceModelLogModal from '../../../../shared/modals/PriceModelLogModal'
	
	// Actions
	
	// formatCurrency, reverseFormatCurrency
	
	
	// import styles
	
	
	// Utils
	// formatCurrency, reverseFormatCurrency
	
	
	// import components
	
	// import HelpText from '../../../../shared/components/HelpText'
	
	// Elements
	
	
	var Insurance = function (_Component) {
	  _inherits(Insurance, _Component);
	
	  function Insurance(props) {
	    _classCallCheck(this, Insurance);
	
	    var _this = _possibleConstructorReturn(this, (Insurance.__proto__ || Object.getPrototypeOf(Insurance)).call(this, props));
	
	    _this.state = {
	      constraint: {},
	      price: props.agreementPrice !== undefined && props.agreementPrice.PriceModelId !== undefined ? props.agreementPrice : {
	        Active: false,
	        ActiveFromParent: false,
	        Name: '',
	        ParentPriceModelName: '',
	        PriceCalculationType: 0,
	        IsDeleted: false,
	        IsEnvironmentDiscount: false,
	        PriceDiscount: 0
	      },
	      agreementPrice: props.agreementPrice !== undefined && props.agreementPrice.PriceModelId !== undefined ? props.agreementPrice : undefined,
	      confirm: {
	        open: false,
	        type: 0
	      },
	      confirmDelete: {
	        open: false
	      },
	      confirmDeactivate: {
	        open: false
	      },
	      confirmActivate: {
	        open: false
	      },
	      selectedTabIndex: props.selectedTabIndex,
	      isNew: true,
	      selectedCustomerId: props.selectedCustomerId !== undefined && props.selectedCustomerId !== null ? props.selectedCustomerId : -1
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onInputBlur = _this.onInputBlur.bind(_this);
	    _this.changeType = _this.changeType.bind(_this);
	    _this.onCreateAgreement = _this.onCreateAgreement.bind(_this);
	    _this.getPrice = _this.getPrice.bind(_this);
	    return _this;
	  }
	
	  _createClass(Insurance, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.state.isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      this.state.isShop = (0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType);
	      if (this.state.agreementPrice === undefined) {
	        this.getPriceList(this.props);
	      } else {
	        console.log('setstateDidMount', this.state, this.props);
	        this.setState({
	          price: this.state.agreementPrice,
	          priceOriginal: this.state.agreementPrice,
	          isNew: false
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!(0, _lodash.isEqual)(nextProps.item, this.props.item)) {
	        this.setState({
	          priceOriginal: {},
	          constraint: {},
	          price: {
	            Active: false,
	            ActiveFromParent: false,
	            Name: '',
	            ParentPriceModelName: '',
	            PriceCalculationType: 0,
	            IsDeleted: false,
	            IsEnvironmentDiscount: false,
	            PriceDiscount: 0
	          },
	          confirm: {
	            open: false,
	            type: 0
	          },
	          confirmDelete: {
	            open: false
	          }
	        }, function () {
	          if (nextProps.item !== null && nextProps.item !== undefined) {
	            console.log('getPriceList');
	            _this2.getPriceList(nextProps);
	          }
	        });
	      }
	      // Get agreement again when clicking away from shops tab
	      if (!(0, _lodash.isEqual)(nextProps.selectedTabIndex, this.state.selectedTabIndex) && nextProps.selectedTabIndex === 0) {
	        console.log('tab change');
	        this.getPriceModel(nextProps, this.props.agreementId);
	      }
	      if (!(0, _lodash.isEqual)(nextProps.selectedCustomerId, this.props.selectedCustomerId) && nextProps.selectedCustomerId > 0) {
	        console.log('customer change');
	        this.getCustomerAgreement(nextProps.agreementId, nextProps.selectedCustomerId);
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      // Fix to missing brands
	      if (nextProps.brands === null || nextProps.brands.length === 0) {
	        // this.props.getBrands()
	      }
	    }
	  }, {
	    key: 'mapConstraints',
	    value: function mapConstraints(constraint) {
	      this.setState({
	        price: {
	          Active: false,
	          ActiveFromParent: false,
	          Name: constraint.Name,
	          ParentPriceModelId: constraint.AgreementConstraintId,
	          ParentPriceModelName: constraint.Name,
	          WorkProvider: constraint.WorkProvider,
	          PriceType: constraint.PriceType,
	          CustomerGroupId: constraint.CustomerGroupId,
	          BrandSelectionType: constraint.BrandSelectionType,
	          PriceModelBrands: constraint.ConstraintBrands,
	          Comment: constraint.Comment,
	          PriceCalculationType: 0,
	          IsDeleted: false,
	          IsEnvironmentDiscount: false,
	          PriceDiscount: 0,
	          PriceHourly: 0
	        },
	        isNew: true
	      });
	    }
	  }, {
	    key: 'getPrice',
	    value: function getPrice(props, id) {
	      var _this3 = this;
	
	      props.getPriceList(id).then(function (res) {
	        _this3.setState({
	          price: res.data,
	          priceOriginal: res.data,
	          isNew: false,
	          constraint: {}
	        });
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this3.props.onShouldUpdate();
	      });
	    }
	  }, {
	    key: 'getCustomerAgreement',
	    value: function getCustomerAgreement(agreementId, customerId, companyId) {
	      var _this4 = this;
	
	      this.props.getShopCustomerAgreement(agreementId, customerId, companyId).then(function (res) {
	        _this4.setState({
	          price: res.data,
	          priceOriginal: res.data,
	          isNew: false,
	          constraint: {}
	        });
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this4.props.onShouldUpdate();
	      });
	    }
	  }, {
	    key: 'getPriceModel',
	    value: function getPriceModel(props, id) {
	      var _this5 = this;
	
	      if ((this.state.selectedCustomerId === -1 || props.selectedTabIndex === 0) && props.isMain && props.item !== null && props.item.PriceModelId > 0) {
	        this.getPrice(props, id);
	      } else if (props.item === null || Number(props.item.PriceModelId === undefined || props.item.PriceModelId <= 0)) {
	        props.getAgreementConstraint(props.item.AgreementConstraintId).then(function (res) {
	          _this5.setState({
	            constraint: res.data,
	            isNew: true
	          });
	          _this5.mapConstraints(res.data);
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	          _this5.props.onShouldUpdate();
	        });
	      } else {
	        this.getCustomerAgreement(id, this.state.selectedCustomerId, this.props.selectedShopId);
	      }
	    }
	  }, {
	    key: 'getPriceList',
	    value: function getPriceList(props) {
	      this.getPriceModel(props, props.item.PriceModelId);
	    }
	  }, {
	    key: 'shouldUpdatePrices',
	    value: function shouldUpdatePrices(val1, val2) {
	      return val1 !== val2;
	    }
	  }, {
	    key: 'updatePrices',
	    value: function updatePrices(price) {
	      var _this6 = this;
	
	      var setPriceState = function setPriceState(data) {
	        _this6.setState({
	          price: data,
	          priceOriginal: data,
	          isNew: false,
	          constraint: {}
	        });
	      };
	      return this.props.updatePriceList(price).then(function (res) {
	        setPriceState(res.data);
	        // Toastr
	        // window.toastr.success(translation('13444'), translation('13424'))
	        // Return
	        return res;
	      }, function (err) {
	        // console.log('Error response ', err.response.data.Error)
	        var errorDescription = null;
	        switch (err.response.data.Error) {
	          case 1:
	            // Conflict with existing
	            errorDescription = '1793';
	            break;
	          case 2:
	            // Not allowed
	            errorDescription = '1794';
	            break;
	          case 1000:
	            // Unspecified error
	            errorDescription = '1795';
	            break;
	        }
	        if (errorDescription !== null) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445') + ':</br>' + (0, _helpers.translation)(errorDescription), (0, _helpers.translation)('216'));
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        }
	
	        // console.log('error ', err.response)
	        setPriceState(err.response.data);
	        // this.props.router.push('/prices')
	        // Return
	        return err;
	      });
	    }
	  }, {
	    key: 'onlyShow',
	    value: function onlyShow() {
	      if (!(0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this7 = this;
	
	      e.persist();
	      var value = e.target.value;
	      var name = e.target.name;
	
	      if (name === 'Active' && !e.target.checked) {
	        this.setState({
	          confirmDeactivate: {
	            open: true
	          }
	        });
	        return;
	      }
	      if (name === 'ActiveFromParent') {
	        if (e.target.checked && this.props.item.Active && !this.state.price.Active) {
	          // link when main agreement active and sub agreement inactive
	          this.setState({
	            confirmActivate: {
	              open: true
	            }
	          });
	          return;
	        }
	      }
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      if (name === 'selectedCustomerId') {
	        // let id = this.props.item.PriceModelId
	        this.setState({
	          selectedCustomerId: value
	        }, function () {
	          if (Number(value) !== -1) _this7.getPrice(_this7.props, value);
	        });
	      } else if (name === 'PriceHourly') {
	        this.setState({
	          price: _extends({}, this.state.price, {
	            PriceHourly: value
	          })
	        });
	      } else {
	        var val = name === 'PriceDiscount' ? (0, _percent.transformPercent)(value, true) : value;
	        this.setState({
	          price: _extends({}, this.state.price, _defineProperty({}, e.target.name, val))
	        }, function () {
	          if (e.target.type === 'checkbox') {
	            _this7.updatePrices(_this7.state.price).then(function (res) {
	              if (name === 'Active') {
	                _this7.props.getPriceLists(_this7.props);
	              }
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onCreateAgreement',
	    value: function onCreateAgreement() {
	      var _this8 = this;
	
	      var data = {
	        ParentPriceModelId: 0,
	        CustomerGroupId: this.state.constraint.CustomerGroupId,
	        AgreementConstraintId: this.state.constraint.AgreementConstraintId
	      };
	      this.props.createPriceAgreement(data).then(function (res) {
	        // window.toastr.success(translation('12271'), translation('13424'))
	        _this8.props.onShouldUpdate();
	        _this8.getPriceList(_this8.props);
	        _this8.props.router.push('/agreements/' + _this8.state.constraint.AgreementConstraintId);
	      }, function (err) {
	        console.log(err);
	        window.toastr.error((0, _helpers.translation)('12272'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onInputBlur',
	    value: function onInputBlur(e) {
	      var _this9 = this;
	
	      var name = e.target.name;
	      if (this.shouldUpdatePrices(this.state.price[e.target.name], this.state.priceOriginal[e.target.name])) {
	        if (name === 'PriceHourly') {
	          var value = e.target.value === '' ? '0' : e.target.value;
	          this.state.price.PriceHourly = (0, _currency.reverseFormatCurrency2)(value);
	        }
	        if (name === 'PriceDiscount') {
	          var _value = (0, _percent.transformPercent)(e.target.value, true) === '' ? '0' : (0, _percent.transformPercent)(e.target.value, true);
	          this.state.price.PriceDiscount = (0, _currency.reverseFormatCurrency2)(_value);
	        }
	        this.updatePrices(this.state.price).then(function (res) {
	          if (name === 'Name') {
	            _this9.props.getPriceLists(_this9.props);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType(e) {
	      var _this10 = this;
	
	      var value = parseInt(e.target.value);
	      this.setState({
	        price: _extends({}, this.state.price, _defineProperty({}, e.target.name, value))
	      }, function () {
	        _this10.updatePrices(_this10.state.price).then(function (res) {
	          _this10.props.getPriceLists(_this10.props);
	        });
	      });
	    }
	
	    // Should render
	    // Customer: 1 - Shop: 2
	
	  }, {
	    key: 'shouldRender',
	    value: function shouldRender(type) {
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        return type === 2;
	      }
	      // if (this.state.price.Name === null && this.state.price.CustomerId === 0 && type === 2) {
	      if (this.state.price.CustomerId === 0 && type === 2) {
	        return true;
	      }
	      // if ((this.state.price.Name !== null || this.state.price.CustomerId !== 0) && type === 1) {
	      if (this.state.price.CustomerId !== 0 && type === 1) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'renderPriceCalculationTypes',
	    value: function renderPriceCalculationTypes() {
	      var price = this.state.price;
	
	      if (price.PriceType === 6 || price.PriceType === 0 || price.UseEstimationList) {
	        return null;
	      }
	
	      var isDisabled = !(0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var isWp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1256') },
	        _react2.default.createElement(_text2.default, {
	          name: 'PriceHourly',
	          value: (0, _currency.formatCurrency2)(price.PriceHourly),
	          disabled: isDisabled,
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          labelText: (0, _helpers.translation)('419')
	        }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1256') },
	          _react2.default.createElement(_radio2.default, { name: 'PriceCalculationType', value: '0', onChange: this.changeType, checked: price.PriceCalculationType === 0, disabled: !isWp, labelText: (0, _helpers.translation)('12273'), helpText: (0, _helpers.translation)('12274') }),
	          _react2.default.createElement(_radio2.default, { name: 'PriceCalculationType', value: '1', onChange: this.changeType, checked: price.PriceCalculationType === 1, disabled: !isWp, labelText: (0, _helpers.translation)('12275'), helpText: (0, _helpers.translation)('12276') }),
	          _react2.default.createElement(_radio2.default, { name: 'PriceCalculationType', value: '2', onChange: this.changeType, checked: price.PriceCalculationType === 2, disabled: !isWp, labelText: (0, _helpers.translation)('12277'), helpText: (0, _helpers.translation)('12278') })
	        )
	      );
	    }
	  }, {
	    key: 'renderDiscount',
	    value: function renderDiscount() {
	      var isCustomer = !(0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var price = this.state.price;
	
	      var pricediscount = (0, _currency.formatCurrency2)(price.PriceDiscount);
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1197') },
	        _react2.default.createElement(_text2.default, {
	          name: 'PriceDiscount',
	          value: (0, _percent.transformPercent)(pricediscount),
	          disabled: isCustomer,
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          onFocus: _percent.onPercentFocus,
	          labelText: (0, _helpers.translation)('1199') + ' (%)'
	        }),
	        price.PriceType !== 6 && _react2.default.createElement(_switch2.default, {
	          name: 'IsEnvironmentDiscount',
	          onChange: this.onInputChange,
	          checked: price.IsEnvironmentDiscount,
	          disabled: isCustomer,
	          labelText: (0, _helpers.translation)('1236')
	        })
	      );
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      return true;
	    }
	  }, {
	    key: 'renderBrands',
	    value: function renderBrands() {
	      var price = this.state.price;
	
	      var brands = price.PriceModelBrands;
	
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('13473') },
	        _react2.default.createElement(_radio2.default, { name: 'BrandSelectionType', disabled: true, checked: price.BrandSelectionType === 0, labelText: (0, _helpers.translation)('381') }),
	        _react2.default.createElement(_radio2.default, { name: 'BrandSelectionType', disabled: true, checked: price.BrandSelectionType !== 0, labelText: (0, _helpers.translation)('13475') }),
	        price.BrandSelectionType === 1 && brands.map(function (b, key) {
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            b.BrandName
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderOrderTypes',
	    value: function renderOrderTypes() {
	      var _this11 = this;
	
	      var isCustomer = (0, _auth.hasAccess)([4, 6], this.props.auth.user.UserType);
	      // let isCustomer = this.props.customer
	      // if (hasAccess([6], this.props.auth.user.UserType)) return null
	      if ((0, _auth.hasAccess)([3, 7], this.props.auth.user.UserType) && !this.props.customer) return null;
	      if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType) && !this.props.partners) return null; // If chain creating work provider..
	      // console.log('ordertype', this.props.auth.user.UserType)
	      var price = this.state.price;
	
	
	      var renderOrderTypeInput = function renderOrderTypeInput(value, key) {
	        var dictionaryKey = void 0;
	        switch (value) {
	          case 0:
	            dictionaryKey = '73';
	            break;
	          case 5:
	            dictionaryKey = '13360';
	            break;
	          case 6:
	            dictionaryKey = '301';
	            break;
	          case 1:
	            dictionaryKey = '71';
	            break;
	          case 2:
	            dictionaryKey = '785';
	            break;
	          case 3:
	            dictionaryKey = '13361';
	            break;
	          case 8:
	            dictionaryKey = '1396';
	            break;
	        }
	
	        return _react2.default.createElement(_radio2.default, {
	          name: 'PriceType',
	          value: value,
	          onChange: _this11.changeType,
	          checked: price.PriceType === value,
	          disabled: isCustomer,
	          labelText: (0, _helpers.translation)(dictionaryKey),
	          key: key
	        });
	      };
	
	      // Return
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('525') },
	        price.UseEstimationList ? [1, 2, 3, 8].map(renderOrderTypeInput) : [5, 6, 0].map(renderOrderTypeInput)
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	    }
	  }, {
	    key: 'renderAgreement',
	    value: function renderAgreement() {
	      var _this12 = this;
	
	      // if (this.state.price.Name === null) return null
	      var price = this.state.price;
	
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var isWP = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var isShop = (0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType);
	      var canDelete = !this.state.isNew && !isCustomer && !isWP && !isShop;
	      var canCreate = this.state.isNew;
	      var isMain = this.props.isMain !== undefined && this.props.isMain !== null && this.props.isMain && (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      // let name = price.Name
	      // let isWP = false // hasAccess([6], this.props.auth.user.UserType) && this.state.selectedShopId !== -1
	      // if (this.state.selectedCustomerId !== -1) name = price.ParentPriceModelName
	      // let isCustomer = this.props.customer
	      var onDelete = function onDelete() {
	        _this12.setState({
	          confirmDelete: {
	            open: true
	          }
	        });
	      };
	
	      var priceList = void 0;
	      if (price.UseEstimationList) {
	        priceList = (0, _helpers.translation)('433');
	      } else {
	        priceList = price.ParentPriceModelName || (0, _helpers.translation)('433');
	      }
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13472') },
	        _react2.default.createElement(_text2.default, { name: 'Name', value: price.Name, disabled: isCustomer, onBlur: this.onInputBlur, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_textarea2.default, { name: 'Comment', value: price.Comment, onChange: this.onInputChange, onBlur: this.onInputBlur, disabled: isCustomer || isShop, labelText: (0, _helpers.translation)('149') }),
	        _react2.default.createElement(_switch2.default, { name: 'Active', checked: price.Active, onChange: this.onInputChange, disabled: this.state.isNew || isCustomer || isShop, labelText: (0, _helpers.translation)('295') }),
	        isWP && !isMain && _react2.default.createElement(_switch2.default, { name: 'ActiveFromParent', onChange: this.onInputChange, checked: price.ActiveFromParent, disabled: isCustomer || isShop, labelText: (0, _helpers.translation)('16673') }),
	        this.renderOrderTypes(),
	        this.renderBrands(),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1867') },
	          priceList
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          canDelete && _react2.default.createElement(_button2.default, { onClick: onDelete, labelText: (0, _helpers.translation)('12279') }),
	          canCreate && _react2.default.createElement(_button2.default, { onClick: this.onCreateAgreement, labelText: (0, _helpers.translation)('12280') })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this13 = this;
	
	      console.log('here');
	      if (this.props.selectedTabIndex === 1 && this.state.selectedCustomerId < 0) {
	        return null;
	      }
	      var confirmDeactivate = function confirmDeactivate(props) {
	        var ctext = _this13.props.isMain && (0, _auth.hasAccess)([6], _this13.props.auth.user.UserType) ? props.t('12267') : props.t('403');
	        if (!_this13.props.isMain && (0, _auth.hasAccess)([6], _this13.props.auth.user.UserType) && _this13.state.price.ActiveFromParent) {
	          ctext = props.t('16675');
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          ctext
	        );
	      };
	      var confirmActivate = function confirmActivate(props) {
	        var ctext = props.t('16674');
	        return _react2.default.createElement(
	          'div',
	          null,
	          ctext
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'fieldset',
	          { disabled: this.props.creating },
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderAgreement()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            !this.state.isNew && this.renderPriceCalculationTypes(),
	            !this.state.isNew && this.renderDiscount()
	          )
	        ),
	        this.state.confirmDelete.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDelete') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDelete') })
	        ),
	        this.state.confirmDeactivate.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDeactivate') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirmDeactivate.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDeactivate'), higher: true, renderText: confirmDeactivate })
	        ),
	        this.state.confirmActivate.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmActivate') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirmActivate.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmActivate'), higher: true, renderText: confirmActivate })
	        )
	      );
	    }
	  }, {
	    key: 'onConfirmActivate',
	    value: function onConfirmActivate() {
	      var _this14 = this;
	
	      this.onPortalClose('confirmActivate');
	      this.setState({
	        price: _extends({}, this.state.price, {
	          Active: true,
	          ActiveFromParent: true
	        })
	      }, function () {
	        _this14.updatePrices(_this14.state.price).then(function (res) {
	          // this.props.getPriceLists(this.props)
	        });
	      });
	    }
	  }, {
	    key: 'onConfirmDeactivate',
	    value: function onConfirmDeactivate() {
	      var _this15 = this;
	
	      this.onPortalClose('confirmDeactivate');
	      this.setState({
	        price: _extends({}, this.state.price, {
	          Active: false,
	          ActiveFromParent: false // only applies to sub agreements - check in backend
	        })
	      }, function () {
	        _this15.updatePrices(_this15.state.price).then(function (res) {
	          // this.props.getPriceLists(this.props)
	        });
	      });
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm() {
	      var _this16 = this;
	
	      this.onPortalClose('confirmDelete');
	      var price = _extends({}, this.state.price);
	      price.IsDeleted = true;
	      this.updatePrices(price).then(function () {
	        _this16.props.onShouldUpdate();
	      });
	    }
	  }]);
	
	  return Insurance;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers,
	    companies: state.common.companies,
	    brands: state.common.brands
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceList: _priceModel.getPriceList,
	  updatePriceList: _priceModel.updatePriceList,
	  getCustomers: _customers.getCustomers,
	  // getPriceModelLog,
	  triggerPopup: _backdrop.triggerPopup,
	  getBrands: _common.getBrands,
	  getShopsForCustomerGroup: _customerGroup.getShopsForCustomerGroup,
	  getShopCustomerAgreement: _priceModel.getShopCustomerAgreement,
	  getShopCustomers: _customerGroup.getShopCustomers,
	  getAgreementConstraint: _agreementConstraint.getAgreementConstraint,
	  createPriceAgreement: _agreementConstraint.createPriceAgreement
	})(Insurance);

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _qualitychecksettings = __webpack_require__(281);
	
	var _priceModel = __webpack_require__(75);
	
	var _common = __webpack_require__(25);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _QualityCheckSettingsBox = __webpack_require__(953);
	
	var _QualityCheckSettingsBox2 = _interopRequireDefault(_QualityCheckSettingsBox);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	__webpack_require__(1452);
	
	__webpack_require__(518);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import actions
	
	// Utils
	
	
	// import components
	
	
	var QualityCheckSettingsChild = function (_Component) {
	  _inherits(QualityCheckSettingsChild, _Component);
	
	  function QualityCheckSettingsChild(props) {
	    _classCallCheck(this, QualityCheckSettingsChild);
	
	    var _this = _possibleConstructorReturn(this, (QualityCheckSettingsChild.__proto__ || Object.getPrototypeOf(QualityCheckSettingsChild)).call(this, props));
	
	    _this.state = {
	      activeItem: {
	        Active: true,
	        BrandSelectionType: 0,
	        ChainId: 0,
	        ShopId: 0,
	        IsDeleted: false,
	        Name: null,
	        PriceModelId: 0,
	        QualityCheckBrands: [],
	        QualityCheckCustomers: [],
	        QualityCheckModelId: 0,
	        QualityCheckOrderType: 1,
	        QualityCheckTasks: _this.generateEmptyTasks(),
	        QualityCheckTaskGroups: [],
	        Department: 0
	      },
	      CurrentBrand: '0',
	      CurrentCustomer: '0',
	      confirmDelete: {
	        open: false
	      },
	      isAgreement: props.isAgreement === true,
	      isMainAgreement: _this.props.isMainAgreement === true,
	      disabled: false,
	      isLoaded: false,
	      price: props.isAgreement === true ? props.agreementPrice !== undefined ? props.agreementPrice : {} : {},
	
	      dimensions: {}
	    };
	    _this.getQualityCheckSettings = _this.getQualityCheckSettings.bind(_this);
	    _this.updateQualityCheckSettings = _this.updateQualityCheckSettings.bind(_this);
	    _this.changeType = _this.changeType.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onInputBlur = _this.onInputBlur.bind(_this);
	    _this.generateEmptyTasks = _this.generateEmptyTasks.bind(_this);
	    _this.resetCreate = _this.resetCreate.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(QualityCheckSettingsChild, [{
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        activeItem: {
	          Active: true,
	          BrandSelectionType: 0,
	          ChainId: 0,
	          ShopId: 0,
	          IsDeleted: false,
	          Name: null,
	          PriceModelId: 0,
	          QualityCheckBrands: [],
	          QualityCheckCustomers: [],
	          QualityCheckModelId: 0,
	          QualityCheckOrderType: 1,
	          QualityCheckTasks: this.generateEmptyTasks(),
	          QualityCheckTaskGroups: [],
	          Department: 0
	        },
	        CurrentBrand: '0',
	        CurrentCustomer: '0',
	        confirmDelete: {
	          open: false
	        },
	        price: this.props.isAgreement === true ? this.props.agreementPrice !== undefined ? this.props.agreementPrice : {} : {},
	        isAgreement: this.props.isAgreement === true,
	        isMainAgreement: this.props.isMainAgreement === true,
	        disabled: false,
	        isLoaded: false
	      });
	    }
	  }, {
	    key: 'generateEmptyTasks',
	    value: function generateEmptyTasks() {
	      var tasks = [];
	      for (var i = 1; i < 8; i++) {
	        for (var j = 1; j < 5; j++) {
	          tasks.push({
	            ModifiedEnd: false,
	            ModifiedStart: false,
	            PerformAtEnd: false,
	            PerformAtStart: false,
	            QualityCheckTaskId: 0,
	            QualityCheckTaskType: j,
	            StepNr: i
	          });
	        }
	      }
	      return tasks;
	    }
	  }, {
	    key: 'getCustomerAgreement',
	    value: function getCustomerAgreement(agreementId, customerId, companyId) {
	      var _this2 = this;
	
	      // console.log('getCustomerAgreement', agreementId, customerId)
	      this.resetCreate();
	      if (this.state.price !== undefined && this.state.price.PriceModelId !== undefined) {
	        this.getQualityCheckSettings(this.state.price.PriceModelId);
	        return;
	      }
	
	      this.props.getShopCustomerAgreement(agreementId, customerId, companyId).then(function (res) {
	        var _state = _extends({}, _this2.state),
	            activeItem = _state.activeItem;
	
	        activeItem.PriceModelId = res.data.PriceModelId;
	        _this2.setState({
	          price: res.data,
	          activeItem: activeItem
	        }, function () {
	          _this2.getQualityCheckSettings(_this2.state.price.PriceModelId);
	        });
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this2.props.onShouldUpdate();
	      });
	    }
	  }, {
	    key: 'getAgreement',
	    value: function getAgreement(agreementId) {
	      var _this3 = this;
	
	      // console.log('getAgreement', agreementId)
	      this.resetCreate();
	      this.props.getPriceList(agreementId).then(function (res) {
	        var _state2 = _extends({}, _this3.state),
	            activeItem = _state2.activeItem;
	
	        activeItem.PriceModelId = res.data.PriceModelId;
	        _this3.setState({
	          price: res.data,
	          activeItem: activeItem
	        }, function () {
	          _this3.getQualityCheckSettings(_this3.state.price.PriceModelId);
	        });
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this3.props.onShouldUpdate();
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // if (!this.hasAccessToPage()) {
	      //   this.props.router.push('/prices')
	      // console.log(this.state)
	      if (this.state.isAgreement && this.state.agreementPrice !== undefined) {
	        this.getQualityCheckSettings(this.state.agreementPrice.PriceModelId);
	      } else if (!this.state.isAgreement && !this.state.isMainAgreement) {
	        this.getQualityCheckSettings(this.props.params.type);
	      } else if (this.state.isAgreement && !this.state.isMainAgreement) {
	        this.getCustomerAgreement(this.props.agreementId, this.props.selectedCustomerId, this.props.selectedShopId);
	      } else if (this.state.isMainAgreement && !this.state.isAgreement) {
	        this.getAgreement(this.props.agreementId);
	      }
	      var brands = this.props.brands;
	
	      if (brands.length === 0) {
	        this.props.getBrands();
	      }
	
	      window.addEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.state.isAgreement && !(0, _lodash.isEqual)(nextProps.params.type, this.props.params.type)) {
	        this.getQualityCheckSettings(nextProps.params.type);
	      }
	      if (this.state.isAgreement && !(0, _lodash.isEqual)(this.props.agreementPrice.PriceModelId, nextProps.agreementPrice.PriceModelId) && (0, _lodash.isEqual)(nextProps.selectedCustomerId, this.props.selectedCustomerId)) {
	        this.getQualityCheckSettings(nextProps.agreementPrice.PriceModelId);
	      }
	      if (this.state.isMainAgreement && !(0, _lodash.isEqual)(nextProps.params.type, this.props.params.type)) {
	        this.getAgreement(this.props.agreementId);
	      }
	      var brands = this.props.brands;
	
	      if (brands.length === 0) {
	        this.props.getBrands();
	      }
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      if (!this.qualityRef) {
	        return;
	      }
	
	      this.setState({
	        dimensions: {
	          width: this.qualityRef.clientWidth,
	          height: this.qualityRef.clientHeight
	        }
	      });
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this4 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this4.state.dimensions.width;
	          if (width > higherThan && width <= lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'updateQualityCheckSettings',
	    value: function updateQualityCheckSettings(data) {
	      var _this5 = this;
	
	      return this.props.updateQualityCheckSettings(data).then(function (res) {
	        _this5.props.updateList();
	        _this5.setState({
	          activeItem: res.data
	        });
	        // Toastr
	        // window.toastr.success(translation('1813'), translation('13424'))
	        return res;
	      }, function (err) {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('1814'), (0, _helpers.translation)('216'));
	        return err;
	      });
	    }
	  }, {
	    key: 'getQualityCheckSettings',
	    value: function getQualityCheckSettings(id) {
	      var _this6 = this;
	
	      this.resetCreate();
	      // console.log('Get quality model id ', id)
	      if (this.state.isAgreement || this.state.isMainAgreement) {
	        this.props.getAgreementQualityCheckSettings(id).then(function (res) {
	          _this6.setState({
	            activeItem: res.data,
	            isLoaded: true
	          });
	          // console.log('Received model: ', res.data)
	          return res;
	        }, function () {
	          console.log('Err fetching quality check model data');
	          return null;
	        });
	      } else if (!this.state.isAgreement && !this.state.isMainAgreement) {
	        this.props.getQualityCheckSettings(id).then(function (res) {
	          _this6.setState({
	            activeItem: res.data,
	            disabled: res.data.PriceModelId > 0,
	            isLoaded: true
	          });
	          // console.log('Received model: ', res.data)
	          return res;
	        }, function () {
	          console.log('Err fetching quality check model data');
	          return null;
	        });
	      }
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType(e) {
	      var _this7 = this;
	
	      var value = parseInt(e.target.value);
	      this.setState({
	        activeItem: _extends({}, this.state.activeItem, _defineProperty({}, e.target.name, value))
	      }, function () {
	        _this7.updateQualityCheckSettings(_this7.state.activeItem);
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this8 = this;
	
	      e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      this.setState({
	        activeItem: _extends({}, this.state.activeItem, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this8.updateQualityCheckSettings(_this8.state.activeItem).then(function (res) {
	            if (e.target.name === 'Active') {
	              _this8.props.updateList();
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'onInputBlur',
	    value: function onInputBlur(e) {
	      var _this9 = this;
	
	      e.persist();
	      // if (this.shouldUpdatePrices(this.state.price[e.target.name], this.state.priceOriginal[e.target.name])) {
	      this.updateQualityCheckSettings(this.state.activeItem).then(function (res) {
	        if (e.target.name === 'Name') {
	          _this9.props.updateList();
	        }
	      });
	      // }
	    }
	  }, {
	    key: 'renderBrands',
	    value: function renderBrands() {
	      var _this10 = this;
	
	      // if (this.state.activeItem === undefined) return null
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) && !this.state.isAgreement) return null;
	      var quality = this.state.activeItem;
	      var brands = this.props.brands;
	      // Add customers
	
	      var addItem = function addItem() {
	        if (_this10.state.disabled) return null;
	        var id = parseInt(_this10.state.CurrentBrand);
	        if (id !== 0) {
	          var _quality = _extends({}, _this10.state.activeItem);
	          _quality.QualityCheckBrands.push({
	            BrandNameId: id
	          });
	          _this10.updateQualityCheckSettings(_quality).then(function () {
	            _this10.setState({
	              CurrentBrand: '0'
	            });
	          });
	        }
	      };
	      var onChange = function onChange(e) {
	        if (e.target.name === 'brands') {
	          _this10.setState({
	            CurrentBrand: e.target.value
	          });
	        }
	      };
	      // Render brand
	      var renderBrand = function renderBrand(val, key) {
	        // Delete item
	        var deleteItem = function deleteItem(e) {
	          var disabled = _extends({}, _this10.state.disabled);
	          if (disabled === true) return null;
	          quality.QualityCheckBrands[key].Active = false;
	          _this10.updateQualityCheckSettings(quality);
	        };
	        // Return
	        return _react2.default.createElement(
	          _inline2.default,
	          { key: key, block: true, fillChildNum: [0] },
	          val.BrandName,
	          !_this10.state.disabled && _react2.default.createElement(_removeButton2.default, { minus: true, size: 'm', onClick: deleteItem })
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'brand-selection' },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('145'), helpText: (0, _helpers.translation)('1940') },
	          _react2.default.createElement(_radio2.default, { id: 'brands_all', name: 'BrandSelectionType', value: '0', onChange: this.changeType, checked: quality.BrandSelectionType === 0, disabled: this.state.disabled, labelText: (0, _helpers.translation)('381') }),
	          _react2.default.createElement(_radio2.default, { id: 'brands_selected', name: 'BrandSelectionType', value: '1', onChange: this.changeType, checked: quality.BrandSelectionType === 1, disabled: this.state.disabled, labelText: (0, _helpers.translation)('13475') }),
	          quality.BrandSelectionType === 1 && _react2.default.createElement(
	            'div',
	            null,
	            quality.QualityCheckBrands.map(renderBrand),
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [0] },
	              !this.state.disabled && _react2.default.createElement(
	                _dropDown2.default,
	                { name: 'brands', value: this.state.CurrentBrand, onChange: onChange },
	                _react2.default.createElement('option', { value: '0' }),
	                brands.map(function (val, key) {
	                  return _react2.default.createElement(
	                    'option',
	                    { value: val.Id, key: key },
	                    (0, _helpers.translation)(val.Name)
	                  );
	                })
	              ),
	              !this.state.disabled && _react2.default.createElement(_addButton2.default, { onClick: addItem })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderActive',
	    value: function renderActive() {
	      var _this11 = this;
	
	      var quality = this.state.activeItem;
	
	      var onDelete = function onDelete() {
	        _this11.setState({
	          confirmDelete: {
	            open: true
	          }
	        });
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('295'), helpText: (0, _helpers.translation)('15170') },
	        _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onInputChange, checked: quality.Active, disabled: this.state.disabled, labelText: (0, _helpers.translation)('295'), helpText: (0, _helpers.translation)('1967') }),
	        _react2.default.createElement(_text2.default, { name: 'Name', value: quality.Name || '', onChange: this.onInputChange, onBlur: this.onInputBlur, disabled: this.state.disabled, labelText: (0, _helpers.translation)('30') }),
	        !this.state.disabled && _react2.default.createElement(_button2.default, { style: 'alert', onClick: onDelete, labelText: (0, _helpers.translation)('1812') })
	      );
	    }
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      var _this12 = this;
	
	      // if (hasAccess([6], this.props.auth.user.UserType) || this.props.partners) return null
	      // if (hasAccess([2, 3], this.props.auth.user.UserType)) return null
	      var quality = this.state.activeItem;
	      var customers = this.props.customers;
	      // Add customers
	
	      var addItem = function addItem() {
	        if (_this12.state.disabled) return null;
	        var id = parseInt(_this12.state.CurrentCustomer);
	        if (id !== 0) {
	          var _quality2 = _extends({}, _this12.state.activeItem);
	          _quality2.QualityCheckCustomers.push({
	            CustomerId: id
	          });
	          _this12.updateQualityCheckSettings(_quality2).then(function () {
	            _this12.setState({
	              CurrentCustomer: '0'
	            });
	          });
	        }
	      };
	      var onChange = function onChange(e) {
	        if (e.target.name === 'customer') {
	          _this12.setState({
	            CurrentCustomer: e.target.value
	          });
	        }
	      };
	      // Render customer
	      var renderCustomer = function renderCustomer(val, key) {
	        // Delete item
	        var deleteItem = function deleteItem(e) {
	          if (_this12.state.disabled) return null;
	          var quality = _extends({}, _this12.state.activeItem);
	          quality.QualityCheckCustomers[key].Active = false;
	          _this12.updateQualityCheckSettings(quality);
	        };
	        // Return
	        return _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0], key: key },
	          val.CustomerName,
	          !_this12.state.disabled && _react2.default.createElement(_removeButton2.default, { minus: true, size: 'm', onClick: deleteItem })
	        );
	      };
	
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'customer-selection' },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('14'), helpText: (0, _helpers.translation)('15171') },
	          quality.QualityCheckCustomers.map(renderCustomer),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            !this.state.disabled && _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'customer', value: this.state.CurrentCustomer, onChange: onChange },
	              _react2.default.createElement('option', { value: '0' }),
	              customers.map(function (val, key) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: val.CustomerId, key: key },
	                  val.Name
	                );
	              })
	            ),
	            !this.state.disabled && _react2.default.createElement(_addButton2.default, { onClick: addItem })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderOrderTypes',
	    value: function renderOrderTypes() {
	      var quality = this.state.activeItem;
	
	      // let { price } = this.state
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('525'), helpText: (0, _helpers.translation)('1939') },
	        _react2.default.createElement(_radio2.default, { id: 'ordertype_2', name: 'QualityCheckOrderType', value: '2', onChange: this.changeType, checked: quality.QualityCheckOrderType === 2, disabled: this.state.disabled, labelText: (0, _helpers.translation)('785') }),
	        _react2.default.createElement(_radio2.default, { id: 'ordertype_1', name: 'QualityCheckOrderType', value: '1', onChange: this.changeType, checked: quality.QualityCheckOrderType === 1, disabled: this.state.disabled, labelText: (0, _helpers.translation)('71') }),
	        _react2.default.createElement(_radio2.default, { id: 'ordertype_3', name: 'QualityCheckOrderType', value: '3', onChange: this.changeType, checked: quality.QualityCheckOrderType === 3, disabled: this.state.disabled, labelText: (0, _helpers.translation)('13361') }),
	        _react2.default.createElement(_radio2.default, { id: 'ordertype_4', name: 'QualityCheckOrderType', value: '4', onChange: this.changeType, checked: quality.QualityCheckOrderType === 4, disabled: this.state.disabled, labelText: (0, _helpers.translation)('13360') }),
	        _react2.default.createElement(_radio2.default, { id: 'ordertype_5', name: 'QualityCheckOrderType', value: '5', onChange: this.changeType, checked: quality.QualityCheckOrderType === 5, disabled: this.state.disabled, labelText: (0, _helpers.translation)('301') })
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm() {
	      var _this13 = this;
	
	      this.onPortalClose('confirmDelete');
	      var quality = _extends({}, this.state.activeItem);
	      quality.IsDeleted = true;
	      this.updateQualityCheckSettings(quality).then(function () {
	        _this13.props.updateList();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this14 = this;
	
	      if (this.state.activeItem.QualityCheckModelId === 0 && this.state.disabled) {
	        return (
	          // None selected
	          _react2.default.createElement('div', null)
	        );
	      }
	      var quality = this.state.activeItem;
	
	      var onTasksChange = function onTasksChange(tasks) {
	        _this14.setState({
	          activeItem: _extends({}, _this14.state.activeItem, {
	            QualityCheckTasks: tasks
	          })
	        });
	        var qualityCopy = _extends({}, _this14.state.activeItem);
	        qualityCopy.QualityCheckTasks = tasks;
	        _this14.updateQualityCheckSettings(qualityCopy);
	      };
	
	      var updateGroups = function updateGroups(groups) {
	        var activeItem = _extends({}, _this14.state.activeItem, {
	          QualityCheckTaskGroups: groups
	        });
	        _this14.updateQualityCheckSettings(activeItem);
	      };
	
	      var showCustomOptions = quality.Name !== null && !this.state.isAgreement && !this.state.isMainAgreement;
	      // showCustomOptions = true // temporary
	
	      var renderCustomGroups = function renderCustomGroups() {
	        // Filter custom groups.
	        var customGroups = quality.QualityCheckTaskGroups.filter(function (g) {
	          return g.Type === 5;
	        });
	        return customGroups.map(function (g) {
	          return _react2.default.createElement(_QualityCheckSettingsBox2.default, {
	            key: 'group_' + g.QualityCheckTaskGroupId,
	            taskType: 5,
	            group: g,
	            quality: quality,
	            isLoaded: _this14.state.isLoaded,
	            onChange: onTasksChange,
	            updateGroups: updateGroups
	          });
	        });
	      };
	
	      var renderAddCustom = function renderAddCustom() {
	        var addGroup = function addGroup() {
	          var newGroup = {
	            QualityCheckTaskGroupId: 0,
	            Type: 5,
	            CustomName: (0, _helpers.translation)(17856)
	          };
	          var data = _extends({}, _this14.state.activeItem, { QualityCheckTaskGroups: [].concat(_toConsumableArray(_this14.state.activeItem.QualityCheckTaskGroups), [newGroup]) });
	          _this14.updateQualityCheckSettings(data);
	        };
	
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: 17856 },
	          _react2.default.createElement(_button2.default, { style: 'link', labelText: 1208, onClick: addGroup })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(node) {
	            _this14.qualityRef = node;
	          } },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          !this.state.isLoaded && _react2.default.createElement(
	            'p',
	            { className: 'loading' },
	            _react2.default.createElement(_divider2.default, { noLine: true }),
	            _react2.default.createElement(
	              'div',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	            )
	          ),
	          this.state.isLoaded && this.dimensionShow([[0, 640]]) && [_react2.default.createElement(
	            _col2.default,
	            { key: 0 },
	            _react2.default.createElement(_QualityCheckSettingsBox2.default, { taskType: 1, quality: quality, isLoaded: this.state.isLoaded, onChange: onTasksChange }),
	            _react2.default.createElement(_QualityCheckSettingsBox2.default, { taskType: 2, quality: quality, isLoaded: this.state.isLoaded, onChange: onTasksChange }),
	            _react2.default.createElement(_QualityCheckSettingsBox2.default, { taskType: 3, quality: quality, isLoaded: this.state.isLoaded, onChange: onTasksChange }),
	            _react2.default.createElement(_QualityCheckSettingsBox2.default, { taskType: 4, quality: quality, isLoaded: this.state.isLoaded, onChange: onTasksChange }),
	            quality.Department === 1 && renderCustomGroups(),
	            quality.Department === 1 && renderAddCustom()
	          ), showCustomOptions && _react2.default.createElement(
	            _col2.default,
	            { key: 1 },
	            this.renderActive(),
	            this.renderOrderTypes(),
	            this.renderBrands(),
	            this.renderCustomers()
	          )],
	          this.state.isLoaded && !this.dimensionShow([[0, 640]]) && _react2.default.createElement(
	            'div',
	            { className: 'qualitycheck__screen__page' },
	            showCustomOptions ? _react2.default.createElement(
	              _col2.default,
	              null,
	              this.renderActive(),
	              this.renderOrderTypes(),
	              this.renderBrands(),
	              this.renderCustomers()
	            ) : _react2.default.createElement('div', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'qualitycheck__screen__content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qualitycheck__screen__boxes' },
	                _react2.default.createElement(_QualityCheckSettingsBox2.default, { taskType: 1, quality: quality, isLoaded: this.state.isLoaded, onChange: onTasksChange }),
	                _react2.default.createElement(_QualityCheckSettingsBox2.default, { taskType: 2, quality: quality, isLoaded: this.state.isLoaded, onChange: onTasksChange }),
	                _react2.default.createElement(_QualityCheckSettingsBox2.default, { taskType: 3, quality: quality, isLoaded: this.state.isLoaded, onChange: onTasksChange }),
	                _react2.default.createElement(_QualityCheckSettingsBox2.default, { taskType: 4, quality: quality, isLoaded: this.state.isLoaded, onChange: onTasksChange }),
	                quality.Department === 1 && renderCustomGroups()
	              ),
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                quality.Department === 1 && renderAddCustom()
	              )
	            )
	          ),
	          this.state.confirmDelete.open && _react2.default.createElement(
	            _Portal2.default,
	            { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDelete') },
	            _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDelete') })
	          )
	        )
	      );
	    }
	  }]);
	
	  return QualityCheckSettingsChild;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers,
	    brands: state.common.brands
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getQualityCheckSettings: _qualitychecksettings.getQualityCheckSettings,
	  getAgreementQualityCheckSettings: _qualitychecksettings.getAgreementQualityCheckSettings,
	  updateQualityCheckSettings: _qualitychecksettings.updateQualityCheckSettings,
	  getShopCustomerAgreement: _priceModel.getShopCustomerAgreement,
	  getPriceList: _priceModel.getPriceList,
	  getBrands: _common.getBrands
	})(QualityCheckSettingsChild);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(337);
	
	var _time = __webpack_require__(17);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var ResendText = function (_PureComponent) {
	  _inherits(ResendText, _PureComponent);
	
	  function ResendText(props) {
	    _classCallCheck(this, ResendText);
	
	    var _this = _possibleConstructorReturn(this, (ResendText.__proto__ || Object.getPrototypeOf(ResendText)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ResendText, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({});
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // console.log('[OrderActions] props', nextProps)
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderText = function renderText() {
	        if (_this2.props.isLoadingLastHistory) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	          );
	        }
	        if (!_this2.props.lastHistory || _this2.props.lastHistory.FoundHistory !== true) {
	          return null;
	        }
	        var name = _this2.props.lastHistory.UserName;
	        var date = (0, _time.renderFullDate)(_this2.props.lastHistory.Date);
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _grid2.default,
	            { justify: 'start', spacing: 1 },
	            _react2.default.createElement(
	              'span',
	              null,
	              _this2.props.t('14937')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              name
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { justify: 'start', spacing: 1 },
	            _react2.default.createElement(
	              'span',
	              null,
	              _this2.props.t('14938')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              date
	            )
	          ),
	          _this2.props.lastHistory.EconomicInvoiceId > 0 && _react2.default.createElement(
	            _grid2.default,
	            { justify: 'start', spacing: 1 },
	            _react2.default.createElement(
	              'span',
	              null,
	              _this2.props.t('14924')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _this2.props.lastHistory.EconomicInvoiceId
	            )
	          ),
	          _this2.props.lastHistory.EconomicAddonInvoiceId > 0 && _react2.default.createElement(
	            _grid2.default,
	            { justify: 'start', spacing: 1 },
	            _react2.default.createElement(
	              'span',
	              null,
	              _this2.props.t('14925')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _this2.props.lastHistory.EconomicAddonInvoiceId
	            )
	          ),
	          _this2.props.lastHistory.EconomicKickbackInvoiceId > 0 && _react2.default.createElement(
	            _grid2.default,
	            { justify: 'start', spacing: 1 },
	            _react2.default.createElement(
	              'span',
	              null,
	              _this2.props.t('14926')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _this2.props.lastHistory.EconomicKickbackInvoiceId
	            )
	          ),
	          _this2.props.assessment && _react2.default.createElement(
	            'div',
	            null,
	            _this2.props.t('14927'),
	            ' ',
	            _this2.props.t('14949')
	          ),
	          !_this2.props.assessment && _react2.default.createElement(
	            'div',
	            null,
	            _this2.props.t('14927'),
	            ' ',
	            _this2.props.t('14939')
	          )
	        );
	      };
	      var resendText = !this.props.lastHistory || !this.props.lastHistory.FoundHistory ? this.props.t('13507') : this.props.assessment ? '' + this.props.t('14950') + '.' : '' + this.props.t('13706') + '.';
	      if (this.props.isLoadingLastHistory) {
	        resendText = '';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'pg-mb-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pg-my-2' },
	          resendText
	        ),
	        renderText(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ResendText;
	}(_react.PureComponent);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(ResendText);

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	__webpack_require__(1481);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _time = __webpack_require__(17);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _icons = __webpack_require__(6);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	var _constants = __webpack_require__(5);
	
	var _Wrapper = __webpack_require__(428);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Elements
	
	
	var DEPARTMENTTYPE = {
	  Paint: 0,
	  Body: 1
	};
	
	var BookingTimesSectionTypeName = {
	  Pickup: 'Pickup',
	  Production: 'Production',
	  Delivery: 'Delivery',
	  LeadTime: 'LeadTime'
	};
	var isLeadTimeBoxChanged = false;
	
	var BookingTimes = function (_Component) {
	  _inherits(BookingTimes, _Component);
	
	  function BookingTimes(props) {
	    _classCallCheck(this, BookingTimes);
	
	    var _this = _possibleConstructorReturn(this, (BookingTimes.__proto__ || Object.getPrototypeOf(BookingTimes)).call(this, props));
	
	    _this.renderContent = _this.renderContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(BookingTimes, [{
	    key: 'getBookingSectionTypeName',
	    value: function getBookingSectionTypeName(type) {
	      switch (type) {
	        case _constants.BookingTimesSectionType.Pickup:
	          return BookingTimesSectionTypeName.Pickup;
	        case _constants.BookingTimesSectionType.Production:
	          return BookingTimesSectionTypeName.Production;
	        case _constants.BookingTimesSectionType.Delivery:
	          return BookingTimesSectionTypeName.Delivery;
	        case _constants.BookingTimesSectionType.LeadTime:
	          return BookingTimesSectionTypeName.LeadTime;
	      }
	    }
	  }, {
	    key: 'getShopTypeName',
	    value: function getShopTypeName(type) {
	      switch (type) {
	        case DEPARTMENTTYPE.Paint:
	          return 'Paint';
	        case DEPARTMENTTYPE.Body:
	          return 'Body';
	      }
	    }
	  }, {
	    key: 'getPaintDictionaryKey',
	    value: function getPaintDictionaryKey(bookingTimesSectionType) {
	      var from = this.props.Component;
	      var key = void 0;
	      switch (bookingTimesSectionType) {
	        case _constants.BookingTimesSectionType.Pickup:
	          key = from === 'OrderInspection' ? 14814 : 579;
	          break;
	        case _constants.BookingTimesSectionType.Delivery:
	          key = from === 'OrderInspection' ? 14815 : 193;
	          break;
	      }
	      return key;
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent(state, setState, saveBookingTime) {
	      var _this2 = this;
	
	      var renderBookingTimesSection = function renderBookingTimesSection(bookingTimesSectionType, DictionaryKey, shopSection, department) {
	        if (!shopSection) return null; // If section is null, the user don´t have access
	
	        var Date = shopSection.Date,
	            ValidTimes = shopSection.ValidTimes,
	            Time = shopSection.Time,
	            CanEdit = shopSection.CanEdit;
	
	        var customDate = window.CustomDate(Date);
	        var disabled = !CanEdit || state.isLoading;
	        var inputProps = {
	          readOnly: true,
	          disabled: disabled
	        };
	
	        var onChange = function onChange(e) {
	          var _extends4;
	
	          var bookingSectionName = _this2.getBookingSectionTypeName(bookingTimesSectionType);
	          var obj = _this2.getShopTypeName(department);
	
	          var value = void 0,
	              name = void 0,
	              date = void 0,
	              time = void 0;
	          if (e.target && e.target.name === 'Time') {
	            // for time change
	            name = e.target.name;
	            value = e.target.value;
	            time = value;
	            date = Date;
	          } else {
	            // for date change
	            value = e.format('YYYY-MM-DDTHH:mm:ss');
	            name = 'Date';
	            time = Time;
	            date = e.format('YYYY-MM-DDTHH:mm:ss');
	          }
	
	          setState(_extends({}, state, (_extends4 = {}, _defineProperty(_extends4, obj, _extends({}, state[obj], _defineProperty({}, bookingSectionName, _extends({}, state[obj][bookingSectionName], _defineProperty({}, name, value))))), _defineProperty(_extends4, 'isLoading', true), _defineProperty(_extends4, 'EditedBookingTime', {
	            Date: date,
	            Time: time,
	            Department: department,
	            OrderId: _this2.props.OrderId,
	            BookingTimeType: bookingTimesSectionType
	          }), _extends4)), function () {
	            return saveBookingTime();
	          });
	        };
	
	        var formatTime = function formatTime(time) {
	          return time.substring(0, 5);
	        };
	
	        var warningText = null;
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)(DictionaryKey), errorText: warningText },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [2, 1] },
	            _react2.default.createElement(_datetime2.default, {
	              inputProps: inputProps,
	              closeOnSelect: true,
	              dateFormat: 'DD-MM-YYYY',
	              timeFormat: false,
	              value: customDate,
	              name: 'Date',
	              onChange: onChange,
	              disabled: disabled }),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'Time', value: formatTime(Time), onChange: onChange, disabled: disabled },
	              ValidTimes && ValidTimes.map(function (val, index) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: index, value: formatTime(val) },
	                  formatTime(val)
	                );
	              }),
	              !ValidTimes && _react2.default.createElement(
	                'option',
	                { value: formatTime(Time) },
	                formatTime(Time)
	              )
	            )
	          )
	        );
	      };
	
	      var renderProductionLine = function renderProductionLine(shopSection) {
	        if (!shopSection || shopSection.Date === null) return;
	        var momentDate = (0, _moment2.default)(shopSection.Date);
	        var newDate = momentDate.format('YYYY-MM-DD') + ' ' + shopSection.Time;
	        var relativeTime = (0, _time.getRelativeDateTime)(newDate);
	        var productionTime = (0, _helpers.translation)('13394') + ': ' + relativeTime;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'productionLine' },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            productionTime
	          ),
	          _react2.default.createElement('br', null)
	        );
	      };
	
	      var renderBodyShopLeadTime = function renderBodyShopLeadTime(bookingTimesSectionType, shopSection, department) {
	        if (!shopSection || shopSection.LeadTime === null) return;
	
	        var onChange = function onChange(e) {
	          if (e.target && e.target.name === 'LeadTime') {
	            var _extends6;
	
	            var obj = _this2.getShopTypeName(department);
	            var value = parseInt(e.target.value);
	            if (isNaN(value)) {
	              value = '';
	            }
	            var leadTime = value;
	            if (value === '' || value < 1 || value > 99) {
	              window.toastr.error((0, _helpers.translation)('18340'), (0, _helpers.translation)('216'));
	              leadTime = null;
	            }
	
	            isLeadTimeBoxChanged = true;
	            setState(_extends({}, state, (_extends6 = {}, _defineProperty(_extends6, obj, _extends({}, state[obj], _defineProperty({}, name, value))), _defineProperty(_extends6, 'EditedBookingTime', {
	              Department: department,
	              OrderId: _this2.props.OrderId,
	              BookingTimeType: bookingTimesSectionType,
	              LeadTime: leadTime
	            }), _extends6)));
	          }
	        };
	
	        var onBlur = function onBlur(e) {
	          if (isLeadTimeBoxChanged) {
	            saveBookingTime();
	          }
	        };
	        var name = 'LeadTime';
	        return _react2.default.createElement(_text2.default, { key: name, labelText: (0, _helpers.translation)(18341), type: 'text', name: name, value: Body.LeadTime, onChange: onChange, onBlur: onBlur, autoComplete: 'off' });
	      };
	
	      var Body = state.Body,
	          Paint = state.Paint;
	      var _props = this.props,
	          FromBody = _props.FromBody,
	          FromPaint = _props.FromPaint,
	          ShowLeadTime = _props.ShowLeadTime;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        Body && FromBody && renderBookingTimesSection(_constants.BookingTimesSectionType.Pickup, 14827, Body.Pickup, DEPARTMENTTYPE.Body),
	        Paint && FromPaint && renderBookingTimesSection(_constants.BookingTimesSectionType.Pickup, this.getPaintDictionaryKey(_constants.BookingTimesSectionType.Pickup), Paint.Pickup, DEPARTMENTTYPE.Paint),
	        ' ',
	        Paint && FromPaint && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.renderAffectedAlert(Paint.Pickup, state),
	        Paint && FromPaint && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && renderProductionLine(Paint.Production),
	        Paint && FromPaint && renderBookingTimesSection(_constants.BookingTimesSectionType.Delivery, this.getPaintDictionaryKey(_constants.BookingTimesSectionType.Delivery), Paint.Delivery, DEPARTMENTTYPE.Paint),
	        Body && FromBody && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && renderProductionLine(Body.Production),
	        Body && FromBody && renderBookingTimesSection(_constants.BookingTimesSectionType.Delivery, 193, Body.Delivery, DEPARTMENTTYPE.Body),
	        ' ',
	        Body && FromBody && this.renderAffectedAlert(Body.Delivery, state),
	        Body && FromBody && ShowLeadTime && renderBodyShopLeadTime(_constants.BookingTimesSectionType.LeadTime, Body, DEPARTMENTTYPE.Body)
	      );
	    }
	  }, {
	    key: 'renderAffectedAlert',
	    value: function renderAffectedAlert(shopSection, state) {
	      if (!shopSection || !shopSection.AffectedMessage) return;
	      var _shopSection$Affected = shopSection.AffectedMessage,
	          AffectedAlert = _shopSection$Affected.AffectedAlert,
	          AffectedInfos = _shopSection$Affected.AffectedInfos;
	
	      if (!AffectedAlert) return;
	      var dateStart = '';
	      var dateEnd = '';
	      var infoText = [];
	
	      AffectedInfos && AffectedInfos.map(function (val, index) {
	        if (val.AffectedTimes && val.AffectedTimes[0].DateTime) {
	          dateStart = (0, _time.getRelativeDateTime)(val.AffectedTimes[0].DateTime);
	        }
	        if (val.AffectedTimes && val.AffectedTimes[0].TimeSpan) {
	          dateStart = val.AffectedTimes[0].TimeSpan;
	        }
	
	        dateEnd = val.AffectedTimes && val.AffectedTimes[1] && val.AffectedTimes[1].DateTime;
	        infoText.push((0, _helpers.translation)(val.TextKey).replace('{0}', dateStart).replace('{1}', (0, _time.getRelativeDateTime)(dateEnd)));
	      });
	
	      var relativeTime = (0, _time.getRelativeDateTime)(AffectedAlert.AffectedTime);
	      var alertMessage = (0, _helpers.translation)(AffectedAlert.TextKey).replace('{0}', relativeTime);
	
	      var renderInfoText = function renderInfoText(item, key) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { key: key },
	            item
	          ),
	          _react2.default.createElement('br', null)
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { align: 'center', cols: ['min-content', 10, 'min-content'] },
	          _react2.default.createElement(_icon2.default, { size: 's', icon: _icons.ElementIcons.Warning }),
	          _react2.default.createElement(
	            'span',
	            { className: 'alert-message' },
	            alertMessage
	          ),
	          _react2.default.createElement(_helpIcon2.default, { helpText: infoText.map(renderInfoText), size: 's' })
	        ),
	        _react2.default.createElement('br', null)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Wrapper2.default,
	        { OrderId: this.props.OrderId, onUpdated: this.props.onUpdated },
	        this.renderContent
	      );
	    }
	  }]);
	
	  return BookingTimes;
	}(_react.Component);
	
	BookingTimes.defaultProps = {
	  FromBody: false,
	  FromPaint: false,
	  ShowLeadTime: false
	};
	
	BookingTimes.propTypes = {
	  FromBody: _propTypes2.default.bool.isRequired,
	  FromPaint: _propTypes2.default.bool.isRequired,
	  OrderId: _propTypes2.default.number.isRequired,
	  Component: _propTypes2.default.string,
	  ShowLeadTime: _propTypes2.default.bool.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(BookingTimes);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*eslint-disable */
	'use strict';
	
	var emitter = __webpack_require__(1340);
	var crossvent = __webpack_require__(1345);
	var classes = __webpack_require__(1026);
	var doc = document;
	var documentElement = doc.documentElement;
	
	function dragula(initialContainers, options) {
	  var len = arguments.length;
	  if (len === 1 && Array.isArray(initialContainers) === false) {
	    options = initialContainers;
	    initialContainers = [];
	  }
	  var _mirror; // mirror image
	  var _source; // source container
	  var _item; // item being dragged
	  var _offsetX; // reference x
	  var _offsetY; // reference y
	  var _moveX; // reference move x
	  var _moveY; // reference move y
	  var _initialSibling; // reference sibling when grabbed
	  var _currentSibling; // reference sibling now
	  var _copy; // item used for copying
	  var _renderTimer; // timer for setTimeout renderMirrorImage
	  var _lastDropTarget = null; // last container item was over
	  var _grabbed; // holds mousedown context until first mousemove
	
	  var o = options || {};
	  if (o.moves === void 0) {
	    o.moves = always;
	  }
	  if (o.accepts === void 0) {
	    o.accepts = always;
	  }
	  if (o.invalid === void 0) {
	    o.invalid = invalidTarget;
	  }
	  if (o.containers === void 0) {
	    o.containers = initialContainers || [];
	  }
	  if (o.isContainer === void 0) {
	    o.isContainer = never;
	  }
	  if (o.copy === void 0) {
	    o.copy = false;
	  }
	  if (o.copySortSource === void 0) {
	    o.copySortSource = false;
	  }
	  if (o.revertOnSpill === void 0) {
	    o.revertOnSpill = false;
	  }
	  if (o.removeOnSpill === void 0) {
	    o.removeOnSpill = false;
	  }
	  if (o.direction === void 0) {
	    o.direction = 'vertical';
	  }
	  if (o.ignoreInputTextSelection === void 0) {
	    o.ignoreInputTextSelection = true;
	  }
	  if (o.mirrorContainer === void 0) {
	    o.mirrorContainer = doc.body;
	  }
	
	  var drake = emitter({
	    containers: o.containers,
	    start: manualStart,
	    end: end,
	    cancel: cancel,
	    remove: remove,
	    destroy: destroy,
	    canMove: canMove,
	    dragging: false
	  });
	
	  if (o.removeOnSpill === true) {
	    drake.on('over', spillOver).on('out', spillOut);
	  }
	
	  events();
	
	  return drake;
	
	  function isContainer(el) {
	    return drake.containers.indexOf(el) !== -1 || o.isContainer(el);
	  }
	
	  function events(remove) {
	    var op = remove ? 'remove' : 'add';
	    touchy(documentElement, op, 'mousedown', grab);
	    touchy(documentElement, op, 'mouseup', release);
	  }
	
	  function eventualMovements(remove) {
	    var op = remove ? 'remove' : 'add';
	    touchy(documentElement, op, 'mousemove', startBecauseMouseMoved);
	  }
	
	  function movements(remove) {
	    var op = remove ? 'remove' : 'add';
	    crossvent[op](documentElement, 'selectstart', preventGrabbed); // IE8
	    crossvent[op](documentElement, 'click', preventGrabbed);
	  }
	
	  function destroy() {
	    events(true);
	    release({});
	  }
	
	  function preventGrabbed(e) {
	    if (_grabbed) {
	      e.preventDefault();
	    }
	  }
	
	  function grab(e) {
	    _moveX = e.clientX;
	    _moveY = e.clientY;
	
	    var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
	    if (ignore) {
	      return; // we only care about honest-to-god left clicks and touch events
	    }
	    var item = e.target;
	    var context = canStart(item);
	    if (!context) {
	      return;
	    }
	    _grabbed = context;
	    eventualMovements();
	    if (e.type === 'mousedown') {
	      if (isInput(item)) {
	        // see also: https://github.com/bevacqua/dragula/issues/208
	        item.focus(); // fixes https://github.com/bevacqua/dragula/issues/176
	      } else {
	        e.preventDefault(); // fixes https://github.com/bevacqua/dragula/issues/155
	      }
	    }
	  }
	
	  function startBecauseMouseMoved(e) {
	    if (!_grabbed) {
	      return;
	    }
	    if (whichMouseButton(e) === 0) {
	      release({});
	      return; // when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
	    }
	    // truthy check fixes #239, equality fixes #207
	    if (e.clientX !== void 0 && e.clientX === _moveX && e.clientY !== void 0 && e.clientY === _moveY) {
	      return;
	    }
	    if (o.ignoreInputTextSelection) {
	      var clientX = getCoord('clientX', e);
	      var clientY = getCoord('clientY', e);
	      var elementBehindCursor = doc.elementFromPoint(clientX, clientY);
	      if (isInput(elementBehindCursor)) {
	        return;
	      }
	    }
	
	    if (_grabbed.item !== undefined && _grabbed.item.className !== undefined && _grabbed.item.className.includes('gu-nonselectable')) return;
	
	    var grabbed = _grabbed; // call to end() unsets _grabbed
	    eventualMovements(true);
	    movements();
	    end();
	    start(grabbed);
	
	    var offset = getOffset(_item);
	    _offsetX = getCoord('pageX', e) - offset.left;
	    _offsetY = getCoord('pageY', e) - offset.top;
	
	    classes.add(_copy || _item, 'gu-transit');
	    renderMirrorImage();
	    drag(e);
	  }
	
	  function canStart(item) {
	    if (drake.dragging && _mirror) {
	      return;
	    }
	    if (isContainer(item)) {
	      return; // don't drag container itself
	    }
	    var handle = item;
	    while (getParent(item) && isContainer(getParent(item)) === false) {
	      if (o.invalid(item, handle)) {
	        return;
	      }
	      item = getParent(item); // drag target should be a top element
	      if (!item) {
	        return;
	      }
	    }
	    var source = getParent(item);
	    if (!source) {
	      return;
	    }
	    if (o.invalid(item, handle)) {
	      return;
	    }
	
	    var movable = o.moves(item, source, handle, nextEl(item));
	    if (!movable) {
	      return;
	    }
	
	    return {
	      item: item,
	      source: source
	    };
	  }
	
	  function canMove(item) {
	    return !!canStart(item);
	  }
	
	  function manualStart(item) {
	    var context = canStart(item);
	    if (context) {
	      start(context);
	    }
	  }
	
	  function start(context) {
	    if (isCopy(context.item, context.source)) {
	      _copy = context.item.cloneNode(true);
	      drake.emit('cloned', _copy, context.item, 'copy');
	    }
	
	    _source = context.source;
	    _item = context.item;
	    _initialSibling = _currentSibling = nextEl(context.item);
	
	    drake.dragging = true;
	    drake.emit('drag', _item, _source);
	  }
	
	  function invalidTarget() {
	    return false;
	  }
	
	  function end() {
	    if (!drake.dragging) {
	      return;
	    }
	    var item = _copy || _item;
	    drop(item, getParent(item));
	  }
	
	  function ungrab() {
	    _grabbed = false;
	    eventualMovements(true);
	    movements(true);
	  }
	
	  function release(e) {
	    ungrab();
	
	    if (!drake.dragging) {
	      return;
	    }
	    var item = _copy || _item;
	    var clientX = getCoord('clientX', e);
	    var clientY = getCoord('clientY', e);
	    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
	    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
	    if (dropTarget && (_copy && o.copySortSource || !_copy || dropTarget !== _source)) {
	      drop(item, dropTarget);
	    } else if (o.removeOnSpill) {
	      remove();
	    } else {
	      cancel();
	    }
	  }
	
	  function drop(item, target) {
	    var parent = getParent(item);
	    if (_copy && o.copySortSource && target === _source) {
	      parent.removeChild(_item);
	    }
	    if (isInitialPlacement(target)) {
	      drake.emit('cancel', item, _source, _source);
	    } else {
	      drake.emit('drop', item, target, _source, _currentSibling);
	    }
	    cleanup();
	  }
	
	  function remove() {
	    if (!drake.dragging) {
	      return;
	    }
	    var item = _copy || _item;
	    var parent = getParent(item);
	    if (parent) {
	      parent.removeChild(item);
	    }
	    drake.emit(_copy ? 'cancel' : 'remove', item, parent, _source);
	    cleanup();
	  }
	
	  function cancel(revert) {
	    if (!drake.dragging) {
	      return;
	    }
	    var reverts = arguments.length > 0 ? revert : o.revertOnSpill;
	    var item = _copy || _item;
	    var parent = getParent(item);
	    var initial = isInitialPlacement(parent);
	    if (initial === false && reverts) {
	      if (_copy) {
	        if (parent) {
	          parent.removeChild(_copy);
	        }
	      } else {
	        _source.insertBefore(item, _initialSibling);
	      }
	    }
	    if (initial || reverts) {
	      drake.emit('cancel', item, _source, _source);
	    } else {
	      drake.emit('drop', item, parent, _source, _currentSibling);
	    }
	    cleanup();
	  }
	
	  function cleanup() {
	    var item = _copy || _item;
	    ungrab();
	    removeMirrorImage();
	    if (item) {
	      classes.rm(item, 'gu-transit');
	    }
	    if (_renderTimer) {
	      clearTimeout(_renderTimer);
	    }
	    drake.dragging = false;
	    if (_lastDropTarget) {
	      drake.emit('out', item, _lastDropTarget, _source);
	    }
	    drake.emit('dragend', item);
	    _source = _item = _copy = _initialSibling = _currentSibling = _renderTimer = _lastDropTarget = null;
	  }
	
	  function isInitialPlacement(target, s) {
	    var sibling;
	    if (s !== void 0) {
	      sibling = s;
	    } else if (_mirror) {
	      sibling = _currentSibling;
	    } else {
	      sibling = nextEl(_copy || _item);
	    }
	    return target === _source && sibling === _initialSibling;
	  }
	
	  function findDropTarget(elementBehindCursor, clientX, clientY) {
	    var target = elementBehindCursor;
	    while (target && !accepted()) {
	      target = getParent(target);
	    }
	    return target;
	
	    function accepted() {
	      var droppable = isContainer(target);
	      if (droppable === false) {
	        return false;
	      }
	
	      var immediate = getImmediateChild(target, elementBehindCursor);
	      var reference = getReference(target, immediate, clientX, clientY);
	      var initial = isInitialPlacement(target, reference);
	      if (initial) {
	        return true; // should always be able to drop it right back where it was
	      }
	      return o.accepts(_item, target, _source, reference);
	    }
	  }
	
	  function drag(e) {
	    if (!_mirror) {
	      return;
	    }
	    e.preventDefault();
	
	    var clientX = getCoord('clientX', e);
	    var clientY = getCoord('clientY', e);
	    var x = clientX - _offsetX;
	    var y = clientY - _offsetY;
	
	    _mirror.style.left = x + 'px';
	    _mirror.style.top = y + 'px';
	
	    var item = _copy || _item;
	    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
	    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
	    var changed = dropTarget !== null && dropTarget !== _lastDropTarget;
	    if (changed || dropTarget === null) {
	      out();
	      _lastDropTarget = dropTarget;
	      over();
	    }
	    var parent = getParent(item);
	    if (dropTarget === _source && _copy && !o.copySortSource) {
	      if (parent) {
	        parent.removeChild(item);
	      }
	      return;
	    }
	    var reference;
	    var immediate = getImmediateChild(dropTarget, elementBehindCursor);
	    if (immediate !== null) {
	      reference = getReference(dropTarget, immediate, clientX, clientY);
	    } else if (o.revertOnSpill === true && !_copy) {
	      reference = _initialSibling;
	      dropTarget = _source;
	    } else {
	      if (_copy && parent) {
	        parent.removeChild(item);
	      }
	      return;
	    }
	    if (reference === null && changed || reference !== item && reference !== nextEl(item)) {
	      _currentSibling = reference;
	      dropTarget.insertBefore(item, reference);
	      drake.emit('shadow', item, dropTarget, _source);
	    }
	    function moved(type) {
	      drake.emit(type, item, _lastDropTarget, _source);
	    }
	    function over() {
	      if (changed) {
	        moved('over');
	      }
	    }
	    function out() {
	      if (_lastDropTarget) {
	        moved('out');
	      }
	    }
	  }
	
	  function spillOver(el) {
	    classes.rm(el, 'gu-hide');
	  }
	
	  function spillOut(el) {
	    if (drake.dragging) {
	      classes.add(el, 'gu-hide');
	    }
	  }
	
	  function renderMirrorImage() {
	    if (_mirror) {
	      return;
	    }
	    var rect = _item.getBoundingClientRect();
	    _mirror = _item.cloneNode(true);
	    _mirror.style.width = getRectWidth(rect) + 'px';
	    _mirror.style.height = getRectHeight(rect) + 'px';
	    classes.rm(_mirror, 'gu-transit');
	    classes.add(_mirror, 'gu-mirror');
	    o.mirrorContainer.appendChild(_mirror);
	    touchy(documentElement, 'add', 'mousemove', drag);
	    classes.add(o.mirrorContainer, 'gu-unselectable');
	    drake.emit('cloned', _mirror, _item, 'mirror');
	  }
	
	  function removeMirrorImage() {
	    if (_mirror) {
	      classes.rm(o.mirrorContainer, 'gu-unselectable');
	      touchy(documentElement, 'remove', 'mousemove', drag);
	      getParent(_mirror).removeChild(_mirror);
	      _mirror = null;
	    }
	  }
	
	  function getImmediateChild(dropTarget, target) {
	    var immediate = target;
	    while (immediate !== dropTarget && getParent(immediate) !== dropTarget) {
	      immediate = getParent(immediate);
	    }
	    if (immediate === documentElement) {
	      return null;
	    }
	    return immediate;
	  }
	
	  function getReference(dropTarget, target, x, y) {
	    var horizontal = o.direction === 'horizontal';
	    var reference = target !== dropTarget ? inside() : outside();
	    return reference;
	
	    function outside() {
	      // slower, but able to figure out any position
	      var len = dropTarget.children.length;
	      var i;
	      var el;
	      var rect;
	      for (i = 0; i < len; i++) {
	        el = dropTarget.children[i];
	        rect = el.getBoundingClientRect();
	        if (horizontal && rect.left + rect.width / 2 > x) {
	          return el;
	        }
	        if (!horizontal && rect.top + rect.height / 2 > y) {
	          return el;
	        }
	      }
	      return null;
	    }
	
	    function inside() {
	      // faster, but only available if dropped inside a child element
	      var rect = target.getBoundingClientRect();
	      if (horizontal) {
	        return resolve(x > rect.left + getRectWidth(rect) / 2);
	      }
	      return resolve(y > rect.top + getRectHeight(rect) / 2);
	    }
	
	    function resolve(after) {
	      return after ? nextEl(target) : target;
	    }
	  }
	
	  function isCopy(item, container) {
	    return typeof o.copy === 'boolean' ? o.copy : o.copy(item, container);
	  }
	}
	
	function touchy(el, op, type, fn) {
	  var touch = {
	    mouseup: 'touchend',
	    mousedown: 'touchstart',
	    mousemove: 'touchmove'
	  };
	  var pointers = {
	    mouseup: 'pointerup',
	    mousedown: 'pointerdown',
	    mousemove: 'pointermove'
	  };
	  var microsoft = {
	    mouseup: 'MSPointerUp',
	    mousedown: 'MSPointerDown',
	    mousemove: 'MSPointerMove'
	  };
	  if (global.navigator.pointerEnabled) {
	    crossvent[op](el, pointers[type], fn);
	  } else if (global.navigator.msPointerEnabled) {
	    crossvent[op](el, microsoft[type], fn);
	  } else {
	    crossvent[op](el, touch[type], fn);
	    crossvent[op](el, type, fn);
	  }
	}
	
	function whichMouseButton(e) {
	  if (e.touches !== void 0) {
	    return e.touches.length;
	  }
	  if (e.which !== void 0 && e.which !== 0) {
	    return e.which;
	  } // see https://github.com/bevacqua/dragula/issues/261
	  if (e.buttons !== void 0) {
	    return e.buttons;
	  }
	  var button = e.button;
	  if (button !== void 0) {
	    // see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
	    return button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
	  }
	}
	
	function getOffset(el) {
	  var rect = el.getBoundingClientRect();
	  return {
	    left: rect.left + getScroll('scrollLeft', 'pageXOffset'),
	    top: rect.top + getScroll('scrollTop', 'pageYOffset')
	  };
	}
	
	function getScroll(scrollProp, offsetProp) {
	  if (typeof global[offsetProp] !== 'undefined') {
	    return global[offsetProp];
	  }
	  if (documentElement.clientHeight) {
	    return documentElement[scrollProp];
	  }
	  return doc.body[scrollProp];
	}
	
	function getElementBehindPoint(point, x, y) {
	  var p = point || {};
	  var state = p.className;
	  var el;
	  p.className += ' gu-hide';
	  el = doc.elementFromPoint(x, y);
	  p.className = state;
	  return el;
	}
	
	function never() {
	  return false;
	}
	function always() {
	  return true;
	}
	function getRectWidth(rect) {
	  return rect.width || rect.right - rect.left;
	}
	function getRectHeight(rect) {
	  return rect.height || rect.bottom - rect.top;
	}
	function getParent(el) {
	  return el.parentNode === doc ? null : el.parentNode;
	}
	function isInput(el) {
	  return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || isEditable(el);
	}
	function isEditable(el) {
	  if (!el) {
	    return false;
	  } // no parents were editable
	  if (el.contentEditable === 'false') {
	    return false;
	  } // stop the lookup
	  if (el.contentEditable === 'true') {
	    return true;
	  } // found a contentEditable element in the chain
	  return isEditable(getParent(el)); // contentEditable is set to 'inherit'
	}
	
	function nextEl(el) {
	  return el.nextElementSibling || manually();
	  function manually() {
	    var sibling = el;
	    do {
	      sibling = sibling.nextSibling;
	    } while (sibling && sibling.nodeType !== 1);
	    return sibling;
	  }
	}
	
	function getEventHost(e) {
	  // on touchend event, we have to use `e.changedTouches`
	  // see http://stackoverflow.com/questions/7192563/touchend-event-properties
	  // see https://github.com/bevacqua/dragula/issues/34
	  if (e.targetTouches && e.targetTouches.length) {
	    return e.targetTouches[0];
	  }
	  if (e.changedTouches && e.changedTouches.length) {
	    return e.changedTouches[0];
	  }
	  return e;
	}
	
	function getCoord(coord, e) {
	  var host = getEventHost(e);
	  var missMap = {
	    pageX: 'clientX', // IE8
	    pageY: 'clientY' // IE8
	  };
	  if (coord in missMap && !(coord in host) && missMap[coord] in host) {
	    coord = missMap[coord];
	  }
	  return host[coord];
	}
	
	module.exports = dragula;
	/*eslint-enable */
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1510);
	
	var _constants = __webpack_require__(5);
	
	var _documentation = __webpack_require__(407);
	
	var _orders = __webpack_require__(21);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _array = __webpack_require__(205);
	
	var _Part = __webpack_require__(152);
	
	var _Part2 = _interopRequireDefault(_Part);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import HelpText from '../../../shared/components/HelpText'
	
	// import styles
	
	
	// Constants
	
	
	// Actions
	
	
	// Utils
	
	// Elements
	
	
	var Evaluation = function (_Component) {
	  _inherits(Evaluation, _Component);
	
	  function Evaluation(props) {
	    _classCallCheck(this, Evaluation);
	
	    var _this = _possibleConstructorReturn(this, (Evaluation.__proto__ || Object.getPrototypeOf(Evaluation)).call(this, props));
	
	    _this.state = {
	      isLoading: false,
	      evaluation: props.evaluation,
	      rejections: []
	    };
	    _this.renderEvaluation = _this.renderEvaluation.bind(_this);
	    _this.renderRejectedImages = _this.renderRejectedImages.bind(_this);
	    _this.getRejections = _this.getRejections.bind(_this);
	    _this.getDocEvaluations = _this.getDocEvaluations.bind(_this);
	    return _this;
	  }
	
	  _createClass(Evaluation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getRejections(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.orderId !== nextProps.orderId) {
	        this.getRejections(nextProps);
	      }
	    }
	  }, {
	    key: 'getDocEvaluations',
	    value: function getDocEvaluations(orderId) {
	      var _this2 = this;
	
	      return this.props.getDocEvaluations(orderId).then(function (res) {
	        _this2.setState({
	          evaluation: res.data.Estimation
	        });
	        return res;
	      });
	    }
	  }, {
	    key: 'getRejections',
	    value: function getRejections(props) {
	      var _this3 = this;
	
	      if (props.orderId !== undefined && props.orderId > 0) {
	        this.setState({
	          isLoading: true
	        }, function () {
	          if (props.evaluation === undefined || props.evaluation === null) {
	            _this3.getDocEvaluations(props.orderId);
	          } else {
	            _this3.setState({
	              evaluation: props.evaluation
	            });
	          }
	          _this3.props.getRejectedEvaluations(props.orderId).then(function (res) {
	            var data = res.data;
	            _this3.setState({
	              rejections: data
	            }, function () {
	              _this3.setState({
	                isLoading: false
	              }, function () {
	                if (_this3.state.rejections !== undefined && _this3.state.rejecions !== null && _this3.state.rejections.length > 0) {
	                  var lastIndex = _this3.state.rejections.length - 1;
	                  var lastCreationInfo = _this3.state.rejections[lastIndex].CreationInfo;
	                  if (lastCreationInfo.Comment !== null && _this3.props.setEstimationComment !== undefined) {
	                    _this3.props.setEstimationComment(lastCreationInfo.Comment);
	                  }
	                }
	              });
	              // console.log('success', this.state)
	            });
	          }, function () {
	            _this3.setState({
	              isLoading: false
	            });
	            console.log('failed');
	          });
	        });
	      }
	    }
	  }, {
	    key: 'renderRejectedImages',
	    value: function renderRejectedImages(rejectedImages) {
	      var renderRejectedImage = function renderRejectedImage(image, index) {
	        var url = _constants.FILE_STORAGE + image.ThumbURL;
	        var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-image' },
	          _react2.default.createElement(
	            'a',
	            { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	            _react2.default.createElement('img', { src: url })
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'estimation_images' },
	        _react2.default.createElement(_Gallery2.default, { files: rejectedImages, renderImage: renderRejectedImage })
	      );
	    }
	  }, {
	    key: 'renderEvaluation',
	    value: function renderEvaluation() {
	      var _this4 = this;
	
	      var renderRejections = function renderRejections() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'clearfix estimation__comment' },
	          _this4.state.rejections.map(renderRejection)
	        );
	      };
	      var renderRejection = function renderRejection(val, index) {
	        var creationInfo = val.CreationInfo;
	        var rejectionInfo = val.RejectionInfo;
	        var images = val.Images;
	
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13035') }),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _array.formatArrayToString)(creationInfo.Comment)
	            ),
	            images !== null && _this4.renderRejectedImages(images),
	            _react2.default.createElement(_divider2.default, { noLine: true }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('13387') },
	              (0, _time.renderFullDate)(creationInfo.Date)
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('263') },
	              _react2.default.createElement(_UserInfo2.default, { user: creationInfo.UserInfo })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              creationInfo.Company
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13714') }),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _array.formatArrayToString)(rejectionInfo.Comment)
	            ),
	            _react2.default.createElement(_divider2.default, { noLine: true }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('372') },
	              (0, _time.renderFullDate)(rejectionInfo.Date)
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('763') },
	              _react2.default.createElement(_UserInfo2.default, { user: rejectionInfo.UserInfo })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              rejectionInfo.Company
	            ),
	            _react2.default.createElement(_divider2.default, null)
	          )
	        );
	      };
	      var evaluation = this.state.evaluation;
	      var renderTop = function renderTop(evaluation) {
	        var noEvaluation = evaluation === undefined || evaluation === null || evaluation.InitialCreationTime === null && evaluation.CompletedTime === null || evaluation.InitialCreationTime === null && evaluation.CompletedTime !== null;
	        if (noEvaluation) {
	          return null;
	          // return (
	          //   <div>
	          //     {translation('13534')}
	          //   </div>
	          // )
	        }
	        if (_this4.props.noCompleted) return null;
	        var comment = evaluation.InitialComment;
	        var date = evaluation.InitialCreationTime;
	        var customerName = evaluation.InitialCustomerName;
	        var photos = evaluation.InitialPhotos;
	        // let photos = evaluation.Photos
	        var mail = evaluation.InitialUserMail !== undefined ? evaluation.InitialUserMail : '';
	        var phone = evaluation.InitialUserPhone !== undefined ? evaluation.InitialUserPhone : '';
	
	        var hasMailOrPhone = mail !== null && mail.length > 0 || phone !== null && phone.length > 0;
	        var renderImage = function renderImage(item, key) {
	          var url = _constants.FILE_STORAGE + item.ThumbURL;
	          var fullUrl = _constants.FILE_STORAGE + item.FileURL;
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            _react2.default.createElement(
	              'a',
	              { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': item.FileName },
	              _react2.default.createElement('img', { src: url })
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13035') }),
	          comment && _react2.default.createElement(
	            'div',
	            null,
	            comment
	          ),
	          photos !== null && photos.length > 0 && _react2.default.createElement(_Gallery2.default, { renderImage: renderImage, files: photos }),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13387') },
	            (0, _time.renderFullDate)(date)
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('263'), helpText: hasMailOrPhone && mail + '\n' + phone },
	            _react2.default.createElement(_UserInfo2.default, { user: evaluation.InitialUserInfo })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            customerName
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        );
	      };
	
	      var renderCompletedInfo = function renderCompletedInfo(evaluation) {
	        if (evaluation === undefined || evaluation === null || evaluation.CompletedTime === null || _this4.props.noCompleted) {
	          return null;
	        }
	        var date = evaluation.CompletedTime;
	        // let shopName = evaluation.CompletedByUserName + ' (' + evaluation.CompletedByCompanyName + ')'
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('372') },
	            (0, _time.renderFullDate)(date)
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('763'), helpText: (evaluation.CompletedByUserMail.length > 0 || evaluation.CompletedByUserPhone.length > 0) && evaluation.CompletedByUserMail + '\n' + evaluation.CompletedByUserPhone },
	            _react2.default.createElement(_UserInfo2.default, { user: evaluation.CompletedByUserInfo })
	          )
	        );
	      };
	
	      var renderBottom = function renderBottom(evaluation) {
	        if (evaluation === undefined || evaluation === null || _this4.props.isEdit || !_this4.props.isEdit && (evaluation.EvaluationId === null || evaluation.EvaluationId === 0)) return null;
	        var parts = evaluation.Parts;
	        var refinishTypes = evaluation.RefinishTypes;
	        var startTimes = evaluation.StartTimes;
	        var hourPrices = evaluation.HourPrices;
	        var materialsShares = evaluation.MaterialsShares;
	        var photos = evaluation.Photos;
	        var comment = '';
	        if (evaluation.Comment !== null && evaluation.Comment.Note !== null) {
	          comment = evaluation.Comment.Note;
	        }
	
	        var renderPart = function renderPart(val, key) {
	          // let partDict = val.Part.DictionaryKey
	          // let tasks = val.EstimationTasks
	          // let taskSide = val.Part.TaskSide
	
	          // // Set text for side
	          // switch (taskSide) {
	          //   case 0:
	          //     taskSide = '' // none
	          //     break
	          //   case 1:
	          //     taskSide = translation('213') // left
	          //     break
	          //   case 2:
	          //     taskSide = translation('214') // right
	          //     break
	          //   case 3:
	          //     taskSide = translation('287') // front
	          //     break
	          //   case 4:
	          //     taskSide = translation('288') // back
	          //     break
	          //   case 5:
	          //     taskSide = translation('213') + ' ' + translation('287') // left front
	          //     break
	          //   case 6:
	          //     taskSide = translation('214') + ' ' + translation('287') // right front
	          //     break
	          //   case 7:
	          //     taskSide = translation('213') + ' ' + translation('288') // left back
	          //     break
	          //   case 8:
	          //     taskSide = translation('214') + ' ' + translation('288') // right back
	          //     break
	          // }
	
	          // const renderTask = (val, key) => {
	          //   let taskName = val.TaskName
	          //   let extent = val.Extent
	          //   let extentType = extent !== null ? extent.Type : ''
	          //   let extras = val.Extras
	
	          //   const renderTaskExtra = (val, key) => {
	          //     let extraName = val.Name
	          //     let extraAe = val.AE
	          //     let extraMat = val.Material
	          //     return (
	          //       <div className='taskExtra' key={'extra_' + key}>{extraName} ({extraAe} {translation('885')}, {extraMat} {translation('13443')})</div>
	          //     )
	          //   }
	
	          //   return (
	          //     <div className='taskEntry' key={'task_' + key}>
	          //       <div>{taskName} {extentType}</div>
	          //       <div>
	          //         {extras.map(renderTaskExtra)}
	          //       </div>
	          //     </div>
	          //   )
	          // }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'extent-content', key: key },
	            _react2.default.createElement(_Part2.default, { part: val })
	          );
	          // return (
	          //   <div key={'part_' + key}>
	          //     <h3>{translation(partDict)} {taskSide}</h3>
	          //     <div className='taskBox'>
	          //       {tasks.map(renderTask)}
	          //     </div>
	          //   </div>
	          // )
	        };
	
	        var renderEstimationTypes = function renderEstimationTypes(titleCode, estimationTypes) {
	          if (!estimationTypes || estimationTypes.length === 0) return null;
	
	          return _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(titleCode) },
	            estimationTypes.map(function (type, key) {
	              return _react2.default.createElement(
	                'div',
	                { key: key },
	                type
	              );
	            })
	          );
	        };
	
	        var renderImage = function renderImage(item, key) {
	          var url = _constants.FILE_STORAGE + item.ThumbURL;
	          var fullUrl = _constants.FILE_STORAGE + item.FileURL;
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            _react2.default.createElement(
	              'a',
	              { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': item.FileName },
	              _react2.default.createElement('img', { src: url })
	            )
	          );
	        };
	
	        var hideParts = _this4.props.noParts;
	        return _react2.default.createElement(
	          'div',
	          null,
	          evaluation.CompletedTime !== null && _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('14944') }),
	          !hideParts && _react2.default.createElement(
	            'div',
	            null,
	            parts.map(renderPart)
	          ),
	          !hideParts && renderEstimationTypes('161', refinishTypes),
	          !hideParts && renderEstimationTypes('1195', startTimes),
	          !hideParts && renderEstimationTypes('419', hourPrices),
	          !hideParts && renderEstimationTypes('415', materialsShares),
	          photos !== null && photos.length > 0 && [_react2.default.createElement(_Gallery2.default, { renderImage: renderImage, files: photos, key: 'gallery' }), _react2.default.createElement(_divider2.default, { noLine: true, key: 'divider' })],
	          comment !== '' && [_react2.default.createElement(
	            'div',
	            { key: 'comment' },
	            (0, _array.formatArrayToString)(comment)
	          ), _react2.default.createElement(_divider2.default, { noLine: true, key: 'divider' })]
	        );
	      };
	      var loadingSpinner = function loadingSpinner() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'animated-background' },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'sr-only' },
	            (0, _helpers.translation)('13382'),
	            '...'
	          )
	        );
	      };
	      if (this.state.isLoading) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          loadingSpinner()
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderRejections(),
	        renderTop(evaluation),
	        renderBottom(evaluation),
	        renderCompletedInfo(evaluation)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'evaluations__screen' },
	        this.renderEvaluation()
	      );
	    }
	  }]);
	
	  return Evaluation;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    order: state.orders.order
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getDocPhoto: _documentation.getDocPhoto,
	  getDocEvaluations: _documentation.getDocEvaluations,
	  getRejectedEvaluations: _orders.getRejectedEvaluations
	})(Evaluation);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1521);
	
	var _Part = __webpack_require__(152);
	
	var _Part2 = _interopRequireDefault(_Part);
	
	var _Photo = __webpack_require__(233);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _Comment = __webpack_require__(232);
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	var _EstimationExtents = __webpack_require__(1038);
	
	var _EstimationExtents2 = _interopRequireDefault(_EstimationExtents);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _PriceApprovalModal = __webpack_require__(304);
	
	var _PriceApprovalModal2 = _interopRequireDefault(_PriceApprovalModal);
	
	var _ConfirmPricechanges = __webpack_require__(430);
	
	var _ConfirmPricechanges2 = _interopRequireDefault(_ConfirmPricechanges);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _RPReportFiles = __webpack_require__(199);
	
	var _RPReportFiles2 = _interopRequireDefault(_RPReportFiles);
	
	var _RejectEvaluationModal = __webpack_require__(1114);
	
	var _RejectEvaluationModal2 = _interopRequireDefault(_RejectEvaluationModal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _car = __webpack_require__(222);
	
	var _orderPrice = __webpack_require__(193);
	
	var _orders = __webpack_require__(21);
	
	var _backdrop = __webpack_require__(29);
	
	var _price = __webpack_require__(115);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import EstimationsList from '../../../components/EstimationsList'
	
	
	// Elements
	
	
	// constants
	
	
	var Estimation = function (_Component) {
	  _inherits(Estimation, _Component);
	
	  function Estimation(props) {
	    _classCallCheck(this, Estimation);
	
	    var _this = _possibleConstructorReturn(this, (Estimation.__proto__ || Object.getPrototypeOf(Estimation)).call(this, props));
	
	    _this.state = {
	      price: props.orderPrice !== undefined ? props.orderPrice : null,
	      order: props.order !== undefined ? props.order : null,
	      renderEstimationForForsi: false,
	      // shopMustApprove: null,
	      confirmDialog: {
	        open: false
	      },
	      rejection: {
	        open: false,
	        id: -1
	      },
	      extentIndicationType: 0,
	      extentIndicationConfirm: {
	        open: false
	      }
	    };
	
	    _this.orderpriceSave = _this.orderpriceSave.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onDelete = _this.onDelete.bind(_this);
	    _this.backToWorkcard = _this.backToWorkcard.bind(_this);
	    _this.onPortalClose = _this.onPortalClose.bind(_this);
	    _this.orderpriceSave = _this.orderpriceSave.bind(_this);
	    return _this;
	  }
	
	  _createClass(Estimation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.onRef !== undefined) this.props.onRef(this);
	      // let order = null
	      // if (this.props.order !== undefined) {
	      //   order = this.props.order
	      // }
	      var isEvaluation = this.props.orderPrice.IsEvaluation && this.props.router !== undefined && this.props.router.params !== undefined && this.props.router.params.addon === '3';
	      var isAfterEvaluation = this.props.orderPrice.IsAfterEvaluation;
	      var hasReport = this.props.order && this.props.order.Report && [_constants.AssessmentReporType.ForsiManual, _constants.AssessmentReporType.DBS].includes(this.props.order.Report.ReportType);
	      if (hasReport && !this.props.orderPrice.IsAddonPrice && !isEvaluation && !isAfterEvaluation) {
	        this.setState({
	          extentIndicationType: 1
	        }, function () {
	          _this2.props.setCarActiveState(false);
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onRef !== undefined) this.props.onRef(undefined);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      var orderPrice = null;
	      var order = null;
	      if (next.orderPrice !== undefined) {
	        orderPrice = next.orderPrice;
	      } else if (this.state.orderPrice === null && this.props.orderPrice !== undefined) {
	        orderPrice = this.props.orderPrice;
	      }
	
	      if (next.order !== undefined) {
	        order = next.order;
	      } else if (this.state.order === null && this.props.order !== undefined) {
	        order = this.props.order;
	      }
	
	      var renderEstimationForForsi = false;
	      if (this.props.useSelectedEvaluation && orderPrice !== null && this.props.renderAdditional === true /* && orderPrice.OrderId === 0 */ && order.Report !== null && [4, 5, 6, 7].includes(order.SelectedEvaluationType)) {
	        // This is an empty orderprice only containing parts for selected evaluation. Should render component like for after evaluations.
	        // orderPrice.IsAfterEvaluation = true
	        renderEstimationForForsi = true;
	      }
	
	      this.setState({
	        price: orderPrice,
	        order: order,
	        renderEstimationForForsi: renderEstimationForForsi
	      });
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(1396);
	      }
	
	      if (this.props.useSelectedEvaluation === true) {
	        if (this.props.orderPrice.IsEvaluation && this.props.order.SelectedEvaluationType === 3) {
	          return (0, _helpers.translation)(13363);
	        }
	        if (this.props.orderPrice.IsAfterEvaluation && this.props.order.SelectedEvaluationType === 4) {
	          return (0, _helpers.translation)(14921);
	        }
	      }
	      switch (this.props.order.OrderType) {
	        case 1:
	          return (0, _helpers.translation)(13360);
	        case 2:
	          return (0, _helpers.translation)(71);
	        case 3:
	          return (0, _helpers.translation)(13361);
	        case 6:
	          return (0, _helpers.translation)(785);
	      }
	      return 'No title';
	    }
	  }, {
	    key: 'getTitleAria',
	    value: function getTitleAria() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(34) + ' ' + (0, _helpers.translation)(1396);
	      }
	      return (0, _helpers.translation)(2705);
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return '/images/svgs/taksering/Additional-sales-new.svg';
	      }
	      switch (this.props.order.OrderType) {
	        case 1:
	          return '/images/svgs/ordrer/Insurance-black.svg';
	        case 2:
	          return '/images/svgs/ordrer/Salescar-black.svg';
	        case 3:
	          return '/images/svgs/ordrer/Garanteed-black.svg';
	        case 6:
	          return '/images/svgs/ordrer/Private_c-black.svg';
	      }
	      return null;
	    }
	  }, {
	    key: 'getEditUrl',
	    value: function getEditUrl() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.UseEstimation && !this.props.orderPrice.IsAfterEvaluation && !this.props.orderPrice.IsEvaluation || this.props.order.OrderType === 1) {
	        if (this.props.order !== null && this.props.department === 0 && this.props.order.IsAssessmentOk === true || this.props.department === 1 && this.props.order.IsBodyShopAssessmentOk) return null;
	        // if (this.props.order !== null && this.props.order.IsReferredIn === true) return null
	        if (this.props.order !== null && ((0, _auth.hasAccess)([4], this.props.auth.user.UserType) || (0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType) && this.props.auth.user.DepartmentType === 1) && this.props.order.IsDraft !== true && this.props.orderPrice.Department === 0) return null;
	      }
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return null;
	      if (this.props.orderPrice.IsAfterEvaluation || this.props.orderPrice.IsEvaluation) return null;
	
	      return '/pricecalculation/' + this.props.order.Id + '/1';
	    }
	  }, {
	    key: 'orderpriceSave',
	    value: function orderpriceSave(e) {
	      var _this3 = this;
	
	      var name = e.name === 'Price' ? 'Total' : e.name;
	      this.setState({
	        price: _extends({}, this.state.price, _defineProperty({}, name, e.value))
	      }, function () {
	        _this3.props.saveOrderPrice(_this3.state.price);
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var property = e.target.name === 'Price' ? 'Total' : e.target.name;
	      this.setState({
	        price: _extends({}, this.state.price, _defineProperty({}, property, e.target.value))
	      });
	    }
	  }, {
	    key: 'renderExtentIndication',
	    value: function renderExtentIndication() {
	      var _this4 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      if (this.state.price.IsEvaluation || this.state.price.IsAfterEvaluation || this.state.price.IsAddonPrice) return null;
	
	      var onChange = function onChange(e) {
	        var _e$target = e.target,
	            name = _e$target.name,
	            value = _e$target.value;
	
	        value = parseInt(value, 10);
	
	        if (value === 1) {
	          _this4.props.showPopupParts(false);
	        }
	
	        var hasReport = _this4.props.order.Report !== null && [_constants.AssessmentReporType.ForsiManual, _constants.AssessmentReporType.DBS].includes(_this4.props.order.Report.ReportType);
	        // if (value === 0 && this.props.order.RpReport !== null) {
	        if (value === 0 && hasReport) {
	          return _this4.setState({
	            extentIndicationConfirm: _extends({}, _this4.state.extentIndicationConfirm, {
	              open: true
	            })
	          });
	        }
	
	        _this4.setState(_defineProperty({}, name, value), function () {
	          _this4.props.setCarActiveState(_this4.state.extentIndicationType !== 1);
	        });
	      };
	
	      var onConfirm = function onConfirm() {
	        _this4.props.resetReport(_this4.props.order.Id).then(function () {
	          _this4.props.loadOrder(true).then(function () {
	            _this4.setState({
	              extentIndicationType: 0,
	              extentIndicationConfirm: _extends({}, _this4.state.extentIndicationConfirm, {
	                open: false
	              })
	            }, function () {
	              // Get updated orderPrice
	              _this4.props.getPrices(_this4.props.order.Id, false, false, false, false, false, false, false, 0, true);
	              _this4.props.setCarActiveState(true);
	            });
	          });
	        });
	      };
	
	      var onNotConfirm = function onNotConfirm() {
	        _this4.setState({
	          extentIndicationConfirm: _extends({}, _this4.state.extentIndicationConfirm, {
	            open: false
	          })
	        });
	      };
	
	      var assessmentEnable = [_constants.AssessmentSystemType.Forsi, _constants.AssessmentSystemType.DBS].includes(this.props.auth.permissions.ChainAssessmentSystem);
	      return _react2.default.createElement(
	        'div',
	        null,
	        assessmentEnable && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: 15275 },
	          _react2.default.createElement(_radio2.default, { id: 'estimation', name: 'extentIndicationType', labelText: 15277, value: 0, onChange: onChange, checked: this.state.extentIndicationType === 0 }),
	          _react2.default.createElement(_radio2.default, { id: 'report', name: 'extentIndicationType', labelText: 15276, value: 1, onChange: onChange, checked: this.state.extentIndicationType === 1 })
	        ),
	        this.state.extentIndicationConfirm.open && _react2.default.createElement(_Confirm2.default, { confirm: onConfirm.bind(this), notConfirm: onNotConfirm.bind(this), renderText: function renderText() {
	            return (0, _helpers.translation)('15282');
	          }, t: _helpers.translation })
	      );
	    }
	  }, {
	    key: 'renderReportUpload',
	    value: function renderReportUpload() {
	      var _this5 = this;
	
	      if (this.state.order === null) return null;
	      if (this.state.extentIndicationType === 0) return null;
	
	      var onBlur = function onBlur(args) {
	        if (_this5.props.order[args.name] !== undefined && _this5.props.order[args.name] !== args.value) {
	          var _Other;
	
	          var data = {
	            OrderID: _this5.props.order.Id,
	            Other: (_Other = {}, _defineProperty(_Other, args.name, args.value), _defineProperty(_Other, 'IsDirty', true), _Other)
	          };
	          _this5.props.saveOrder(data);
	        }
	      };
	
	      var renderManualPriceLines = function renderManualPriceLines() {
	        if (_this5.props.order.ReportType === _constants.AssessmentReporType.DBS) return null; // use to hide manual paint price
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            (0, _helpers.translation)('1913')
	          ),
	          _react2.default.createElement(_DecimalInput2.default, { labelText: 641, name: 'Price', onBlur: onBlur, value: _this5.state.order.Price || 0, rightAlign: true }),
	          _react2.default.createElement(_DecimalInput2.default, { labelText: 15195, name: 'Environment', onBlur: onBlur, value: _this5.state.order.Environment || 0, rightAlign: true })
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'white__box' },
	        renderManualPriceLines(),
	        this.renderRPReportFiles(),
	        _react2.default.createElement(_button2.default, { labelText: 956, onClick: this.props.goBack })
	      );
	    }
	  }, {
	    key: 'renderManualPriceEdit',
	    value: function renderManualPriceEdit() {
	      if (this.state.order === null) return null;
	      if (this.state.price.IsEvaluation || this.state.price.IsAfterEvaluation || !this.props.editable) return null;
	      if (this.state.extentIndicationType === 1) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('1913') }),
	        _react2.default.createElement(_DecimalInput2.default, { labelText: (0, _helpers.translation)('641'), name: 'Price', onBlur: this.orderpriceSave, onChange: this.onInputChange, value: this.state.price.Total, rightAlign: true }),
	        _react2.default.createElement(_DecimalInput2.default, { labelText: (0, _helpers.translation)('13339'), name: 'Environment', onBlur: this.orderpriceSave, onChange: this.onInputChange, value: this.state.price.Environment, rightAlign: true })
	      );
	    }
	  }, {
	    key: 'renderManualPrice',
	    value: function renderManualPrice() {
	      if (!this.props.order || !this.props.order.ShowPrices) return null;
	      if (this.props.editable || this.state.price.IsAfterEvaluation || this.state.price.IsEvaluation || this.state.renderEstimationForForsi) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('641') + ':', amount: this.state.price.Total || '0,00' }),
	        _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('13339') + ':', amount: this.state.price.Environment || '0,00' })
	      );
	
	      // return (
	      //   <div>
	      //     <div className='clearfix control__group'>
	      //       <label>{translation('641')}</label>
	      //       <span>{this.state.price.Total || '0,00'}</span>
	      //     </div>
	
	      //     <div className='clearfix control__group'>
	      //       <label>{translation('13339')}</label>
	      //       <span>{this.state.price.Environment || '0,00'}</span>
	      //     </div>
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(OrderEstimationTaskId) {
	      var _this6 = this;
	
	      var parts = this.state.price.Parts.map(function (part) {
	        var task = part.EstimationTasks.filter(function (task) {
	          return task.OrderEstimationTaskId === OrderEstimationTaskId;
	        });
	        if (_typeof(task[0]) === 'object') task[0].IsDeleted = true;
	        return part;
	      });
	
	      this.setState({
	        price: _extends({}, this.state.price, {
	          Parts: parts
	        })
	      }, function () {
	        return _this6.props.saveOrderPrice(_this6.state.price);
	      });
	    }
	
	    // Back to workcard function
	
	  }, {
	    key: 'backToWorkcard',
	    value: function backToWorkcard() {
	      var _this7 = this;
	
	      var orderPrice = this.props.orderPrice;
	      var confirmChangeAndGoBack = function confirmChangeAndGoBack() {
	        if (orderPrice.IsEvaluation || !_this7.props.order.IsDraft) /*  && !orderPrice.IsAddonPrice */{
	            // console.log('RequireShopApproval', this.props.orderPrice.RequireShopApproval)
	            if (_this7.props.orderPrice.RequireShopApproval || _this7.props.orderPrice.IsAfterEvaluation && _this7.props.orderPrice.HasChanged) {
	              _this7.props.triggerPopup(true);
	              _this7.setState({
	                // shopMustApprove: true,
	                confirmDialog: {
	                  // mustApprove: true,
	                  open: true
	                }
	              });
	            } else {
	              _this7.props.goBack();
	            }
	          } else {
	          _this7.props.goBack();
	        }
	      };
	
	      if (this.props.editable) {
	        setTimeout(function () {
	          // Price/price changes
	          var orderPrice = _this7.props.orderPrice;
	          // if (orderPrice.RequireShopApproval) {
	          //   // priceObj.SendToApproval = true
	          // }
	          if (orderPrice.IsEvaluation && _this7.props.order.IsDraft) {}
	          // orderPrice.SendToApproval = true
	
	          // console.log('orderPrice', orderPrice)
	          _this7.props.saveOrderPrice(orderPrice).then(function () {
	            confirmChangeAndGoBack();
	          });
	        }, 800);
	      } else {
	        this.props.goBack();
	      }
	    }
	  }, {
	    key: 'renderConfirm',
	    value: function renderConfirm() {
	      var _this8 = this;
	
	      var onClose = function onClose() {
	        var goBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        _this8.setState({
	          confirmDialog: _extends({}, _this8.state.confirmDialog, {
	            open: false
	          })
	        });
	        if (goBack) _this8.props.goBack();
	      };
	
	      if (this.state.confirmDialog.open) {
	        if (this.props.orderPrice.RequireShopApproval) {
	          return _react2.default.createElement(_PriceApprovalModal2.default, {
	            orderId: this.props.order.Id,
	            show: this.state.confirmDialog.open && this.props.orderPrice.RequireShopApproval === true,
	            RequireCustomerApproval: this.props.orderPrice.RequireCustomerApproval,
	            closeModal: onClose.bind(this, false),
	            overflowHidden: false
	          });
	        } else {
	          return _react2.default.createElement(
	            _Portal2.default,
	            { className: 'confirm_popup', onPortalClose: function onPortalClose() {
	                return;
	              } },
	            _react2.default.createElement(_ConfirmPricechanges2.default, { changes: this.props.orderPrice.RequireCustomerApproval, confirm: onClose.bind(this) })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'renderAfterevaluation',
	    value: function renderAfterevaluation() {
	      // console.log('renderAfterevaluation', this.state.price)
	
	      if (!this.state.price.IsAfterEvaluation) return null;
	      var showHeader = this.props.overrideInnerTitle === undefined || this.props.overrideInnerTitle === null || this.props.overrideInnerTitle !== undefined && this.props.overrideInnerTitle !== null && this.props.overrideInnerTitle.length > 0;
	      // if (this.props.isApproval) console.log('Estimation renderAfterevaluation EDITABLE', this.props.editable)
	      return _react2.default.createElement(
	        'div',
	        null,
	        showHeader && _react2.default.createElement(_panelHeader2.default, { text: this.props.overrideInnerTitle === undefined || this.props.overrideInnerTitle === null ? (0, _helpers.translation)('1277') : this.props.overrideInnerTitle }),
	        _react2.default.createElement(_EstimationExtents2.default, {
	          renderReport: this.state.price.Report !== null,
	          onDelete: this.onDelete,
	          editable: this.props.editable,
	          orderPrice: this.state.price,
	          partTasks: this.props.partTasks,
	          saveOrderPrice: this.props.saveOrderPrice,
	          currencyCode: this.props.currencyCode,
	          order: this.props.order
	        })
	      );
	    }
	
	    // renderSendToCustomer () {
	    //   if (!this.props.editable) return null
	    //   if (!this.state.price.IsAfterEvaluation) return null
	    //   if (this.state.price.selectedAfterEvaluation) return null
	    //   let { price } = this.state
	    //   const trigger = () => {
	    //     let price = { ...this.state.price }
	    //     price.SendToCustomer = !price.SendToCustomer
	    //     this.props.saveOrderPrice(price)
	    //     this.setState({
	    //       hasChanged: true
	    //     })
	    //   }
	
	    //   price.SendToCustomer = !this.state.hasChanged ? true : price.SendToCustomer
	
	    //   return (
	    //     <div>
	    //       <PanelHeader text={translation('1022')} />
	    //       <Check labelText={translation('1022')} id='SendToCustomer' name='SendToCustomer' onChange={trigger} checked={price.SendToCustomer} />
	    //     </div>
	    //   )
	    // }
	
	  }, {
	    key: 'renderParts',
	    value: function renderParts() {
	      var _this9 = this;
	
	      var includeForsiAssociated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var onlyAdditional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var combinedParts = [];
	      var parts = this.state.price.Parts;
	      var additionalParts = this.state.price.AdditionalParts;
	
	      parts.forEach(function (part) {
	        combinedParts.push(part);
	      });
	
	      var combineArrays = function combineArrays(array1, array2, comparer) {
	        if (array1 === null) array1 = [];
	        if (array2 === null) array2 = [];
	        var combined = [];
	        array1.forEach(function (item) {
	          combined.push(item);
	        });
	        array2.forEach(function (item2) {
	          var combinedIndex = combined.findIndex(function (item1) {
	            return comparer(item1, item2);
	          });
	          if (combinedIndex === -1) {
	            combined.push(item2);
	          }
	        });
	
	        return combined;
	      };
	
	      // Merge AdditionalParts and Parts array.
	      if (additionalParts !== null && additionalParts.length > 0) {
	        additionalParts.forEach(function (part) {
	          var combinedPartIndex = combinedParts.findIndex(function (p) {
	            return p.Part.PartItemId === part.Part.PartItemId && p.Part.TaskSide === part.Part.TaskSide || p.IsAdditional === part.IsAdditional;
	          });
	          if (combinedPartIndex > -1) {
	            combinedParts[combinedPartIndex].EstimationTasks = combineArrays(combinedParts[combinedPartIndex].EstimationTasks, part.EstimationTasks, function (task1, task2) {
	              return task1.EstimationTaskId === task2.EstimationTaskId;
	            });
	          } else {
	            combinedParts.push(part);
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        combinedParts.map(function (val) {
	          return _react2.default.createElement(_Part2.default, {
	            key: 'part_' + val.Part.PartItemId + '_' + val.Part.TaskSide + (val.IsAdditional ? '_additional' : ''),
	            order: _this9.state.order,
	            orderPrice: _this9.state.price,
	            part: val,
	            includeForsiAssociatedTasks: !_this9.props.editable && includeForsiAssociated /* this.state.renderEstimationForForsi */,
	            onDelete: _this9.props.editable === true && _this9.onDelete,
	            onlyAdditionalParts: onlyAdditional,
	            editable: _this9.props.editable
	          });
	        })
	      );
	    }
	  }, {
	    key: 'renderExtent',
	    value: function renderExtent() {
	      if (this.state.price === undefined || this.state.price === null) return;
	      if (this.state.extentIndicationType === 1) return null;
	      var css = 'price__view estimation__extent';
	      if (this.props.editable) {
	        css = 'price__view estimation__extent editable';
	      }
	
	      var IsAfterEvaluation = this.state.price.IsAfterEvaluation;
	      var title = this.props.overrideInnerTitle; // <div>&nbsp;</div> // This controls 2nd title, below after evaluation/forsi.
	
	      if (title === undefined || title === null) {
	        if (IsAfterEvaluation) {
	          title = (0, _helpers.translation)(891);
	        } else {
	          title = (0, _helpers.translation)(889);
	        }
	      }
	
	      var hasReport = this.state.price.Report !== null && this.state.price.Report.ReportId !== 0;
	      // let hasAdditionalTasks = checkHasAddedTasks()
	
	      var hasAdditionalParts = this.state.price.AdditionalParts !== null && this.state.price.AdditionalParts.length > 0;
	      var isEval = this.state.order !== null && this.state.order.IsEvaluation && this.props.router !== undefined && this.props.router.params !== undefined && this.props.router.params.addon === '3';
	
	      var renderRejectEval = (0, _auth.hasAccess)([6, 3, 5, 7], this.props.auth.user.UserType) && this.props.editable && isEval && this.state.order.IsEvaluated === false && this.state.order.IsEvaluationRejected === false;
	      var renderEval = (0, _auth.hasAccess)([6, 3, 5, 7], this.props.auth.user.UserType) && isEval;
	
	      var noteChangeSource = 11;
	      if (this.state.price.IsAfterEvaluation) noteChangeSource = 7;
	      if (this.state.price.IsEvaluation) noteChangeSource = 8;
	      var comment = this.state.price.Notes.find(function (n) {
	        return n.SourceID === noteChangeSource;
	      });
	
	      var hasCommentAndPhotoAccess = (0, _auth.hasSubscriptionPermission)(this.props.auth, 10);
	      if (this.props.auth.departmentType === 1 && this.props.department === 0 && this.props.auth.hasPartner) {
	        hasCommentAndPhotoAccess = (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10);
	      }
	
	      // let includeForsiAssociated = this.props.renderAdditional === true || true
	      // let onlyAdditional = true
	
	      var includeForsiAssociated = true;
	      var onlyAdditional = this.props.renderAdditional;
	
	      return _react2.default.createElement(
	        'div',
	        { className: css },
	        this.props.viewMode === 'mobile' && this.props.renderInside(),
	        this.renderAfterevaluation(),
	        (hasReport || !IsAfterEvaluation) && (this.props.renderAdditional && hasAdditionalParts || this.props.editable) && title !== null && _react2.default.createElement(_panelHeader2.default, { text: title }),
	        _react2.default.createElement(
	          'div',
	          { className: 'estimationtasks' },
	          this.renderParts(includeForsiAssociated, onlyAdditional)
	        ),
	        (IsAfterEvaluation && hasReport || !this.state.price.IsAfterEvaluation && (this.state.price.UseEstimation || this.state.order !== undefined && this.state.order !== null && this.state.order.OrderType === 1) || this.state.price.IsEvaluation) && _react2.default.createElement(_EstimationExtents2.default, {
	          editable: this.props.editable,
	          orderPrice: this.state.price,
	          partTasks: this.props.partTasks,
	          saveOrderPrice: this.props.saveOrderPrice,
	          currencyCode: this.props.currencyCode
	        }),
	        this.props.editable && hasCommentAndPhotoAccess && _react2.default.createElement(_Photo2.default, {
	          saveOrderPrice: this.props.saveOrderPrice,
	          orderPrice: this.state.price,
	          order: this.state.order
	        }),
	        this.props.editable && hasCommentAndPhotoAccess && _react2.default.createElement(_Comment2.default, {
	          comment: comment,
	          changeSource: noteChangeSource,
	          orderPriceId: this.state.price.OrderPriceId,
	          order: this.state.order,
	          renderEval: renderEval
	        }),
	        this.props.editable && this.renderOkButton(),
	        renderRejectEval && this.renderReject(),
	        renderEval && this.state.rejection.open && _react2.default.createElement(_RejectEvaluationModal2.default, {
	          orderPrice: this.state.price,
	          show: this.state.rejection.open,
	          id: this.state.rejection.id,
	          updatePrices: this.props.saveOrderPrice,
	          onClose: this.onPortalClose,
	          goBack: this.props.goBack })
	      );
	    }
	  }, {
	    key: 'renderOkButton',
	    value: function renderOkButton() {
	      // const goBack = () => {
	      //   this.setState({
	      //     price: {
	      //       ...this.state.price,
	      //       SendToApproval: true
	      //     }
	      //   }, () => {
	      //     this.orderpriceSave()
	      //     setTimeout(this.props.goBack, 1000)
	      //   })
	      // }
	
	      var orderPrice = this.props.orderPrice;
	      if (orderPrice.RequireApproval) {
	        return _react2.default.createElement(_button2.default, { onClick: this.backToWorkcard.bind(this), labelText: (0, _helpers.translation)('791') });
	      }
	      return _react2.default.createElement(_button2.default, { onClick: this.backToWorkcard, labelText: (0, _helpers.translation)('956') });
	    }
	  }, {
	    key: 'renderReject',
	    value: function renderReject() {
	      var _this10 = this;
	
	      var showRejectModal = function showRejectModal() {
	        _this10.setState({
	          rejection: {
	            open: true,
	            id: -1
	          }
	          // , () => console.log(this.state.rejection)
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'reject__link' },
	        _react2.default.createElement(
	          'a',
	          { onClick: showRejectModal },
	          (0, _helpers.translation)('13716')
	        )
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose() {
	      this.setState({
	        rejection: _extends({}, this.state.rejection, {
	          open: false
	        })
	      });
	    }
	  }, {
	    key: 'renderRPReportFiles',
	    value: function renderRPReportFiles() {
	      var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.props.order === undefined || hide) return null;
	      if (!this.props.editable) {
	        return _react2.default.createElement(_RPReportFiles2.default, {
	          order: this.props.order,
	          renderBody: this.props.department === 1,
	          renderPaint: this.props.department === 0,
	          showDates: true
	        });
	      } else {
	        return _react2.default.createElement(_RPReportFiles2.default, {
	          order: this.props.order,
	          editable: true,
	          renderPaint: true,
	          renderBody: true,
	          renderSparePart: true,
	          onUploadSuccess: this.props.loadOrder.bind(this, true)
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // if (this.props.isApproval) console.log('Estimation state.price', this.state.price)
	      if (!this.state.price) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderRPReportFiles(true),
	        this.props.editable && this.renderExtentIndication(),
	        this.props.editable && this.renderReportUpload(),
	        this.renderManualPriceEdit(),
	        this.renderExtent(),
	        this.renderManualPrice(),
	        this.renderConfirm()
	      );
	    }
	  }]);
	
	  return Estimation;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  getPrices: _orderPrice.getPrices,
	  resetReport: _orders.resetReport,
	  setCarActiveState: _car.setCarActiveState,
	  showPopupParts: _price.showPopupParts
	})(Estimation);

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * How to use:
	 * <HoverPopup
	 *   UseClick={useClick} // Used to enable on click events
	 *   UseHover={useHover} // Used to enable on mouse hover event
	 *   orderId={item.Id} // Used to make the popup unique
	 *   getVerticalScrollOffset={this.props.getVerticalScrollOffset} // Method used to getting the vertical scroll offset
	 *   getHorizontalScrollOffset={this.props.getHorizontalScrollOffset} // Method used to getting the horizontal scroll offset
	 *   scrollColumn={this.props.step} // number used if the page has multiple scroll containers like WorkScreen
	 *   PopupContent={lines} > // Used to send content inside the popup
	 *    <img src={imgPath + image} className='PaintBodyStatus' /> // Put the HoverPopup outside the area that should be affected by the click og hover event
	 * </HoverPopup>
	 */
	
	var HoverPopup = function (_Component) {
	  _inherits(HoverPopup, _Component);
	
	  function HoverPopup(props) {
	    _classCallCheck(this, HoverPopup);
	
	    var _this = _possibleConstructorReturn(this, (HoverPopup.__proto__ || Object.getPrototypeOf(HoverPopup)).call(this, props));
	
	    _this.state = {
	      show: false,
	      isHovering: false,
	      positionTop: undefined,
	      positionLeft: undefined,
	      positionBottom: undefined
	    };
	    _this.togglePortal = _this.togglePortal.bind(_this);
	    _this.handleMouseHover = _this.handleMouseHover.bind(_this);
	    _this.handleMouseHoverEnter = _this.handleMouseHoverEnter.bind(_this);
	    _this.handleMouseHoverLeave = _this.handleMouseHoverLeave.bind(_this);
	    _this.handlePopupPosition = _this.handlePopupPosition.bind(_this);
	    return _this;
	  }
	
	  _createClass(HoverPopup, [{
	    key: 'togglePortal',
	    value: function togglePortal(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      if (this.props.UseClick !== true) return null;
	      if (!this.state.show) {
	        this.setState({
	          show: true,
	          positionTop: undefined,
	          positionLeft: undefined,
	          positionBottom: undefined
	        }, function () {
	          window.setTimeout(function () {
	            window.addEventListener('click', _this2.togglePortal);
	            _this2.handlePopupPosition();
	          }, 10);
	        });
	      } else {
	        window.removeEventListener('click', this.togglePortal);
	        this.setState({
	          show: false
	        });
	      }
	    }
	  }, {
	    key: 'handlePopupPosition',
	    value: function handlePopupPosition() {
	      var refName = 'child' + this.props.orderId;
	      var el = this.refs[refName];
	      var bounds = el && el.getBoundingClientRect();
	      var positionTop = this.state.positionTop;
	      var positionLeft = this.state.positionLeft;
	      var positionBottom = this.state.positionBottom;
	      var viewHeight = window.innerHeight;
	      if (bounds !== null) {
	        positionTop = bounds.top;
	        positionLeft = bounds.left;
	        positionBottom = bounds.bottom;
	        if (this.props.getVerticalScrollOffset !== undefined) {
	          var topOffset = this.props.getVerticalScrollOffset(this.props.scrollColumn);
	          var outsideScreenPx = positionBottom - (viewHeight + topOffset);
	          if (outsideScreenPx > 0) {
	            // if below screen, set bottom position
	            positionBottom = outsideScreenPx;
	            positionTop = undefined;
	          } else {
	            positionTop = positionTop - topOffset;
	            positionBottom = undefined;
	          }
	        }
	        if (this.props.getHorizontalScrollOffset !== undefined) {
	          var leftOffset = this.props.getHorizontalScrollOffset();
	          positionLeft = positionLeft - leftOffset;
	        }
	      }
	      this.setState({
	        positionTop: positionTop,
	        positionLeft: positionLeft,
	        positionBottom: positionBottom
	      });
	    }
	  }, {
	    key: 'handleMouseHover',
	    value: function handleMouseHover(value) {
	      var _this3 = this;
	
	      if (this.props.UseHover !== true) return null;
	      var isHovering = this.state.isHovering;
	      if (value !== undefined) {
	        isHovering = value;
	      }
	      if (!isHovering) {
	        this.setState({
	          isHovering: true,
	          positionTop: undefined,
	          positionLeft: undefined,
	          positionBottom: undefined
	        }, function () {
	          _this3.handlePopupPosition();
	        });
	      } else {
	        this.setState({
	          isHovering: false
	        });
	      }
	    }
	  }, {
	    key: 'handleMouseHoverEnter',
	    value: function handleMouseHoverEnter() {
	      var _this4 = this;
	
	      if (this.props.UseHover !== true) return null;
	      this.setState({
	        isHovering: true,
	        positionTop: undefined,
	        positionLeft: undefined,
	        positionBottom: undefined
	      }, function () {
	        _this4.handlePopupPosition();
	      });
	    }
	  }, {
	    key: 'handleMouseHoverLeave',
	    value: function handleMouseHoverLeave() {
	      if (this.props.UseHover !== true) return null;
	      this.setState({
	        isHovering: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var popupStyle = {};
	      if (this.state.positionTop !== undefined) {
	        popupStyle = {
	          top: this.state.positionTop
	        };
	      }
	      if (this.state.positionLeft !== undefined) {
	        popupStyle = _extends({}, popupStyle, {
	          left: this.state.positionLeft
	        });
	      }
	      if (this.state.positionBottom !== undefined) {
	        popupStyle = _extends({}, popupStyle, {
	          bottom: this.state.positionBottom
	        });
	      }
	      var hoverClass = 'hoverinfoclass';
	      var customStyle = {};
	      var refName = 'child' + this.props.orderId;
	      if (this.props.customStyle !== undefined) {
	        hoverClass = '';
	        customStyle = this.props.customStyle;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: hoverClass, style: customStyle, onClick: this.togglePortal, onMouseEnter: this.handleMouseHover.bind(this, false), onMouseLeave: this.handleMouseHover.bind(this, true) },
	        this.props.children,
	        (this.state.show || this.state.isHovering) && this.props.PopupContent !== undefined && _react2.default.createElement(
	          'div',
	          { ref: refName, className: 'hoverPopup', style: popupStyle },
	          this.props.PopupContent
	        )
	      );
	    }
	  }]);
	
	  return HoverPopup;
	}(_react.Component);
	
	HoverPopup.defaultProps = {
	  style: {}
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(HoverPopup);

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _auth = __webpack_require__(8);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _helpers = __webpack_require__(2);
	
	var _constants = __webpack_require__(5);
	
	var _invoicing = __webpack_require__(150);
	
	var _icons = __webpack_require__(6);
	
	var _InvoicePopup = __webpack_require__(442);
	
	var _InvoicePopup2 = _interopRequireDefault(_InvoicePopup);
	
	var _StatusBox = __webpack_require__(298);
	
	var _StatusBox2 = _interopRequireDefault(_StatusBox);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	__webpack_require__(1540);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	
	// import styles
	
	
	// import Grid from '../../elements/grid'
	// import Icon from '../../elements/icon'
	// import Button from '../../elements/button'
	
	var Invoice = function (_Component) {
	  _inherits(Invoice, _Component);
	
	  function Invoice(props) {
	    _classCallCheck(this, Invoice);
	
	    var _this = _possibleConstructorReturn(this, (Invoice.__proto__ || Object.getPrototypeOf(Invoice)).call(this, props));
	
	    _this.state = {
	      invoiceItem: {},
	      showInvoicePopup: false,
	      showCommentNotice: false,
	      showAddonNotice: false,
	      showSpinner: {
	        invoicing: false
	      }
	    };
	    _this.renderInvoiceStatus = _this.renderInvoiceStatus.bind(_this);
	    _this.updateOrder = _this.updateOrder.bind(_this);
	    _this.updateInvoiceItem = _this.updateInvoiceItem.bind(_this);
	    _this.showSpinner = _this.showSpinner.bind(_this);
	    _this.updateFromSocket = _this.updateFromSocket.bind(_this);
	
	    _this.updating = false;
	    return _this;
	  }
	
	  _createClass(Invoice, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _events2.default.addListener('ORDER_SOCKET', this.updateFromSocket, this);
	      this.updateInvoiceItem(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      this.updateInvoiceItem(newProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _events2.default.removeListener('ORDER_SOCKET', this.updateFromSocket);
	    }
	  }, {
	    key: 'updateFromSocket',
	    value: function updateFromSocket(json) {
	      // console.log('Invoice component - updateFromSocket', json)
	      if (json.Type === 'ORDER_UPDATE' && json.Data !== undefined && json.Data !== null && json.Data.Id === this.state.invoiceItem.Id) {
	        // if (json.DeviceToken === this.props.auth.user.DeviceToken) return
	        // Above prevented updating state after invoicing (invoicing returns empty string on success) - this lets the component get the invoicing socket msg.
	        this.setState({
	          invoiceItem: _extends({}, this.state.invoiceItem, json.Data)
	        });
	      }
	    }
	  }, {
	    key: 'updateInvoiceItem',
	    value: function updateInvoiceItem(props) {
	      var _this2 = this;
	
	      var invoiceItem = _extends({}, this.state.invoiceItem);
	      if (props.invoiceOrder !== undefined) {
	        invoiceItem = props.invoiceOrder;
	        this.setState({
	          invoiceItem: invoiceItem,
	          showCommentNotice: true,
	          showAddonNotice: true
	        });
	      } else if (props.invoiceOrderId !== undefined) {
	        if (!this.updating) {
	          // Prevent component from spamming requests to API.
	          this.updating = true;
	          this.props.getInvoiceStatus(props.invoiceOrderId).then(function (res) {
	            _this2.updating = false;
	            invoiceItem = res.data;
	            // console.log('updateInvoiceItem: get invoice status res.data ', res.data)
	            _this2.setState({
	              invoiceItem: invoiceItem,
	              showCommentNotice: true,
	              showAddonNotice: true
	            });
	          });
	        }
	      }
	    }
	  }, {
	    key: 'updateOrder',
	    value: function updateOrder(data) {
	      if (this.props.updateOrder !== undefined) {
	        this.props.updateOrder(data);
	        console.log('Invoice component: data in update order ', data);
	      }
	      this.setState({
	        invoiceItem: data
	      });
	      // if (this.props.updateOrder === undefined) {
	
	      //   this.updateInvoiceItem()
	      // }
	    }
	  }, {
	    key: 'showSpinner',
	    value: function showSpinner(element, enabled) {
	      var spinner = this.state.showSpinner;
	      spinner[element] = enabled;
	      this.setState({
	        showSpinner: spinner
	      });
	    }
	  }, {
	    key: 'renderInvoiceStatus',
	    value: function renderInvoiceStatus() {
	      var _this3 = this;
	
	      if (this.state.showSpinner.invoicing === true) {
	        return [_react2.default.createElement('div', { className: 'divider', key: '1' }), _react2.default.createElement(
	          'div',
	          { className: 'invoice', key: '2' },
	          _react2.default.createElement(
	            'span',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	          )
	        )];
	      }
	
	      var iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var isReady = !iswp && this.state.invoiceItem.ReadyForInvoice === 1 || iswp && this.state.invoiceItem.ReadyForInvoiceByWP;
	      var isMarked = !iswp && this.state.invoiceItem.IsMarkInvoiced || iswp && this.state.invoiceItem.IsMarkInvoicedByWP;
	      var isInvoiced = !iswp && this.state.invoiceItem.IsInvoiced || iswp && this.state.invoiceItem.IsInvoicedByWP;
	      // let hasAddon = this.props.invoiceOrder.HasAddonPrice
	      var dracarNonMatchesFound = this.state.invoiceItem ? this.state.invoiceItem.DracarNonMatchingPartsExists : false;
	      var invoiceStatusIsResat = this.state.invoiceItem.InvoiceStatusIsResat;
	      var invoiceIcon = _icons.SparePartModuleIcons.Attention;
	      var invoiceText = '1140';
	      var invoiceColor = 'orange';
	      // Dracar check - no need to worry about spare parts, if they do not use Dracar
	      if (!this.props.auth.permissions.DracarUsable) {
	        dracarNonMatchesFound = false;
	      }
	
	      // Ready for invoice
	      if (isReady) {
	        invoiceText = '1139';
	        invoiceIcon = _icons.SparePartModuleIcons.Attention;
	
	        // Invoice status reset
	        if (invoiceStatusIsResat) {
	          // if it is resat and approved
	          invoiceIcon = _icons.SparePartModuleIcons.Attention;
	          invoiceText = (0, _helpers.translation)('15003');
	        }
	      } else {
	        // Invoice status reset
	        if (invoiceStatusIsResat) {
	          // if it is resat and not approved
	          invoiceIcon = _icons.SparePartModuleIcons.Attention;
	          invoiceText = (0, _helpers.translation)('15006');
	        }
	      }
	      if (isMarked) {
	        invoiceText = '13510';
	        invoiceIcon = _icons.SparePartModuleIcons.OK;
	        invoiceColor = 'green';
	      }
	      if (isInvoiced && !isMarked) {
	        invoiceText = '13511';
	        invoiceIcon = _icons.SparePartModuleIcons.OK;
	        invoiceColor = 'green';
	      }
	
	      // Is invoiced and marked
	      if (isInvoiced && isMarked && !invoiceStatusIsResat) {
	        invoiceText = '13512';
	        invoiceIcon = _icons.SparePartModuleIcons.OK;
	        invoiceColor = 'green';
	      }
	
	      // console.log('isReady - isInvoiced - isMarked - invoiceStatusIsResat ', isReady, isInvoiced, isMarked, invoiceStatusIsResat)
	      if (dracarNonMatchesFound && this.props.auth.accountingSystem === _constants.AccountingSystemTypes.Dracar && _constants.DracarAllowOrderTypes.includes(this.state.invoiceItem.OrderType)) {
	        invoiceIcon = _icons.InvoiceIcons.Total_Price;
	        invoiceText = '1140';
	      }
	
	      var invoicePopup = function invoicePopup(close) {
	        if (_this3.state.invoiceItem.IsWrecked) window.toastr.error((0, _helpers.translation)('16663'), (0, _helpers.translation)('216'));else {
	          _this3.setState({
	            showInvoicePopup: !_this3.state.showInvoicePopup
	          });
	        }
	      };
	
	      var action = void 0;
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 30) || (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 6) && isReady && !(isMarked && isInvoiced)) {
	        action = invoicePopup;
	      }
	
	      return _react2.default.createElement(_StatusBox2.default, {
	        onClick: !(isMarked && isInvoiced) ? action : null,
	        icon: invoiceIcon,
	        color: invoiceColor,
	        title: (0, _helpers.translation)(13486).toUpperCase(),
	        subTitle: (0, _helpers.translation)(invoiceText),
	        chevron: this.state.showInvoicePopup
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var isDraft = this.props.auth.departmentType !== 1 ? this.state.invoiceItem.IsDraft : this.state.invoiceItem.BodyShopIsDraft;
	      if (isDraft) return null;
	      if (!(0, _auth.hasAccess)([3, 5, 6, 7], this.props.auth.user.UserType)) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      var isWp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var invoiceItem = this.state.invoiceItem;
	
	      var dracarSettings = void 0;
	
	      // Should be moved to backend, when this component gets reworked
	      if (this.props.auth.permissions.DracarUsable) {
	        dracarSettings = {
	          dracarNonMatchesFound: invoiceItem.DracarNonMatchingPartsExists,
	          dracarOrderSet: invoiceItem.DracarRepairOrderSet,
	          dracarActive: this.props.auth.permissions.DracarAllowed,
	          isDracarOtherOrder: !_constants.DracarAllowOrderTypes.includes(invoiceItem.OrderType), // other orderType order when using Dracar
	          isRpReport: invoiceItem.ReportType === 2
	        };
	      }
	
	      // do not invoice permanently referred out orders
	      if (!isWp && invoiceItem.IsReferredOut && invoiceItem.OrderConnection !== undefined && invoiceItem.OrderConnection !== null) {
	        if (invoiceItem.OrderConnection.MoveType !== undefined && invoiceItem.OrderConnection.MoveType !== null && invoiceItem.OrderConnection.MoveType === 1) {
	          var referredName = invoiceItem.OrderConnection.TransferedToCompanyName;
	          if (invoiceItem.OrderConnection.TransferedToCompanyName === undefined || invoiceItem.OrderConnection.TransferedToCompanyName === null) {
	            referredName = '';
	          }
	          var referText = (0, _helpers.translation)('15355').replace('[company]', referredName);
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_panelHeader2.default, { text: '' }),
	            _react2.default.createElement(
	              'ul',
	              { className: 'white__box invoice_wrapper' },
	              _react2.default.createElement(
	                'label',
	                { className: 'no_invoice' },
	                referText
	              )
	            )
	          );
	        }
	      }
	
	      var onClose = function onClose() {
	        _this4.setState({ showInvoicePopup: false });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.hasHeader && _react2.default.createElement(_panelHeader2.default, { text: '' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'white__box invoice_wrapper' },
	          !isDraft && this.renderInvoiceStatus(),
	          this.state.invoiceItem.IsOldReferral && _react2.default.createElement(
	            'li',
	            { className: 'migrated-flag' },
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)(534)
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)(16413)
	            )
	          )
	        ),
	        this.state.showInvoicePopup && _react2.default.createElement(
	          'div',
	          { className: 'invoicePopup_container' },
	          _react2.default.createElement(_InvoicePopup2.default, {
	            item: this.state.invoiceItem,
	            updateOrder: this.updateOrder,
	            close: onClose,
	            showSpinner: this.showSpinner,
	            dracarSettings: dracarSettings
	          })
	        )
	      );
	    }
	  }]);
	
	  return Invoice;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getInvoiceStatus: _invoicing.getInvoiceStatus
	})(Invoice);

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1543);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LicensePlate = function (_Component) {
	  _inherits(LicensePlate, _Component);
	
	  function LicensePlate() {
	    _classCallCheck(this, LicensePlate);
	
	    return _possibleConstructorReturn(this, (LicensePlate.__proto__ || Object.getPrototypeOf(LicensePlate)).apply(this, arguments));
	  }
	
	  _createClass(LicensePlate, [{
	    key: 'renderNationality',
	    value: function renderNationality() {
	      var icon = _icons.Localization.EU_Star;
	      return _react2.default.createElement(
	        'div',
	        { className: 'nationality' },
	        _react2.default.createElement(
	          'div',
	          { className: 'icon' },
	          _react2.default.createElement(_icon2.default, { icon: icon, size: 't' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cc' },
	          this.props.countryCode
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'licenseplate' },
	        this.renderNationality(),
	        _react2.default.createElement(
	          'div',
	          { className: 'regnr' },
	          this.props.regNr
	        )
	      );
	    }
	  }]);
	
	  return LicensePlate;
	}(_react.Component);
	
	LicensePlate.defaultProps = {
	  regNr: 'XX 12 123',
	  countryCode: 'dk'
	};
	
	exports.default = LicensePlate;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _common = __webpack_require__(25);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	__webpack_require__(1552);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverlayHeaderBare = function (_Component) {
	  _inherits(OverlayHeaderBare, _Component);
	
	  function OverlayHeaderBare(props) {
	    _classCallCheck(this, OverlayHeaderBare);
	
	    var _this = _possibleConstructorReturn(this, (OverlayHeaderBare.__proto__ || Object.getPrototypeOf(OverlayHeaderBare)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(OverlayHeaderBare, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (typeof this.props.onClose === 'function') this.props.onClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderCloseButton = function renderCloseButton() {
	        if (!_this2.props.closeButton) return null;
	
	        var closeButtonComp = _react2.default.createElement(_closeButton2.default, { onClick: function onClick() {
	            return _this2.props.closeOverlay(_this2.props.overlayId);
	          } });
	
	        if (_this2.props.custom) {
	          closeButtonComp = _react2.default.createElement(
	            _button2.default,
	            { size: 'm', spacing: 0, style: 'link', onClick: function onClick() {
	                return _this2.props.closeOverlay(_this2.props.overlayId);
	              } },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)(16669)
	            )
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'close' },
	          closeButtonComp
	        );
	      };
	
	      var className = 'overlay-header element-overlay-top ' + (this.props.className || '');
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        renderCloseButton(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return OverlayHeaderBare;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	OverlayHeaderBare.defaultProps = {
	  closeButton: true,
	  onClose: undefined, // Callback on overlay close
	  custom: false,
	  label: ''
	};
	
	OverlayHeaderBare.propTypes = {
	  overlayId: _react2.default.PropTypes.string.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  closeOverlay: _common.closeOverlay
	})(OverlayHeaderBare);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1557);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _OverviewOrderItem = __webpack_require__(1058);
	
	var _OverviewOrderItem2 = _interopRequireDefault(_OverviewOrderItem);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	
	var Overview = function (_Component) {
	  _inherits(Overview, _Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));
	
	    _this.pageRef = null;
	
	    _this.state = {
	      isLoading: false,
	      statusGroups: [],
	      itemsPerPage: 0,
	      showAllCars: false
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.renderStatusGroup = _this.renderStatusGroup.bind(_this);
	    _this.setRef = _this.setRef.bind(_this);
	    _this.updateInterval = null;
	    return _this;
	  }
	
	  _createClass(Overview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.addEventListener('resize', this.handleResize);
	      this.updateInterval = setInterval(function () {
	        _this2.updateData();
	      }, 60000);
	      this.updateData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      clearInterval(this.updateInterval);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      if (this.pageRef !== null) {
	        var pageHeight = this.pageRef.clientHeight;
	        var itemHeight = 100;
	
	        var titleHeight = 178;
	        var paddingHeight = 48 * 2;
	        var itemsPerPage = Math.floor((pageHeight - titleHeight - paddingHeight - 64) / itemHeight);
	
	        if (this.state.itemsPerPage !== itemsPerPage) {
	          this.setState({
	            itemsPerPage: itemsPerPage
	          });
	        }
	      }
	    }
	  }, {
	    key: 'updateData',
	    value: function updateData() {
	      var _this3 = this;
	
	      this.setState({ isLoading: true }, function () {
	        _this3.props.getItems().then(function (res) {
	          _this3.setState({
	            statusGroups: res.data.Columns,
	            isLoading: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'setRef',
	    value: function setRef(comp) {
	      var firstSetRef = this.pageRef === null;
	      this.pageRef = comp;
	
	      if (firstSetRef) {
	        this.handleResize();
	      }
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        showAllCars: true
	      });
	    }
	  }, {
	    key: 'renderStatusGroup',
	    value: function renderStatusGroup(statusGroup, key) {
	      var _this4 = this;
	
	      var renderItemList = function renderItemList() {
	        var bricks = [];
	        var brickCount = void 0;
	        var showAllCars = _this4.state.showAllCars;
	        var itemLength = showAllCars ? statusGroup.Items.length : _this4.state.itemsPerPage;
	
	        for (brickCount = 0; brickCount < itemLength && brickCount < statusGroup.Items.length; brickCount++) {
	          var item = statusGroup.Items[brickCount];
	
	          var renderItem = void 0;
	          switch (_this4.props.itemType) {
	            case 'order':
	              renderItem = _react2.default.createElement(_OverviewOrderItem2.default, {
	                OrderId: item.OrderId,
	                BrandName: item.BrandName,
	                Model: item.Model,
	                RegNr: item.RegNr,
	                PlateType: item.PlateType,
	                OrderStep: item.OrderStep,
	                SecondaryText: item.SecondaryText,
	                key: brickCount
	              });
	              break;
	            default:
	              renderItem = null;
	              break;
	          }
	
	          bricks = [].concat(_toConsumableArray(bricks), [renderItem]);
	        }
	
	        var count = statusGroup.ItemCount - brickCount;
	        return _react2.default.createElement(
	          'div',
	          { className: 'overview__orderList' },
	          bricks,
	          !showAllCars && count > 0 && _react2.default.createElement(
	            'div',
	            { className: 'overview__rest', onClick: _this4.toggle.bind(_this4) },
	            count > 0 && '+ ' + count + ' ' + (0, _helpers.translation)('16604'),
	            '\xA0'
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'overview__group', key: key },
	        _react2.default.createElement(
	          'div',
	          { className: 'overview__wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'overview__title' },
	            (0, _helpers.translation)(statusGroup.NameKey)
	          ),
	          statusGroup.SubTitle !== null && _react2.default.createElement(
	            'div',
	            { className: 'overview__subtitle' },
	            statusGroup.SubTitle
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'overview__count' },
	            statusGroup.ItemCount
	          )
	        ),
	        renderItemList()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'overview', ref: this.setRef },
	        this.state.isLoading && _react2.default.createElement(
	          'div',
	          { className: 'animated-background' },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'sr-only' },
	            (0, _helpers.translation)('13382'),
	            '...'
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          { evenColumns: true },
	          this.state.statusGroups.map(this.renderStatusGroup)
	        )
	      );
	    }
	  }]);
	
	  return Overview;
	}(_react.Component);
	
	Overview.defaultProps = {
	  title: '',
	  getItems: undefined,
	  itemType: 'order'
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Overview);

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _box = __webpack_require__(1064);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	__webpack_require__(1563);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatusBox = function (_Component) {
	  _inherits(StatusBox, _Component);
	
	  function StatusBox(props) {
	    _classCallCheck(this, StatusBox);
	
	    var _this = _possibleConstructorReturn(this, (StatusBox.__proto__ || Object.getPrototypeOf(StatusBox)).call(this, props));
	
	    _this.state = {};
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(StatusBox, [{
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-statusbox';
	    }
	  }, {
	    key: 'getClickable',
	    value: function getClickable() {
	      if (this.props.onClick !== null && this.props.onClick !== undefined) {
	        return 'element-box--clickable';
	      }
	      return '';
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      if (this.props.onClick !== null && this.props.onClick !== undefined) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getStatusContent',
	    value: function getStatusContent() {
	      var _props = this.props,
	          icon = _props.icon,
	          title = _props.title,
	          subTitle = _props.subTitle;
	
	
	      return _react2.default.createElement(
	        _inline2.default,
	        { align: 'center', fullWidth: true },
	        _react2.default.createElement(_icon2.default, { size: 'l', icon: icon }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'fontbold' },
	            title
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            null,
	            subTitle
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getChevron',
	    value: function getChevron() {
	      if (!this.props.onClick) return;
	
	      var triggerClass = !this.props.chevron ? 'fa fa-chevron-right' : 'fa fa-chevron-down';
	      return _react2.default.createElement('i', { className: triggerClass });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.getClickable(), onClick: this.onClick },
	        _react2.default.createElement(
	          _box2.default,
	          { color: this.props.color },
	          _react2.default.createElement(
	            'div',
	            { className: this.getStyle() },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: ['1fr', 'min-content'], align: 'center' },
	              this.getStatusContent(),
	              this.getChevron()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StatusBox;
	}(_react.Component);
	
	StatusBox.defaultProps = {
	  onClick: null,
	  // color: 'red', // colors: 'red', 'green', 'orange', 'blue'
	  chevron: false
	};
	
	StatusBox.propTypes = {
	  color: _propTypes2.default.string.isRequired,
	  icon: _propTypes2.default.object.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  subTitle: _propTypes2.default.string.isRequired
	};
	
	exports.default = StatusBox;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1565);
	
	var _modalHeader = __webpack_require__(176);
	
	var _modalHeader2 = _interopRequireDefault(_modalHeader);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Elements
	
	
	var StopOtherOrders = function (_Component) {
	  _inherits(StopOtherOrders, _Component);
	
	  function StopOtherOrders() {
	    _classCallCheck(this, StopOtherOrders);
	
	    return _possibleConstructorReturn(this, (StopOtherOrders.__proto__ || Object.getPrototypeOf(StopOtherOrders)).apply(this, arguments));
	  }
	
	  _createClass(StopOtherOrders, [{
	    key: 'render',
	    value: function render() {
	      var higher = this.props.higher ? 'higher' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'confirm_OrderStop_modal__wrapper' },
	        _react2.default.createElement('div', { className: 'backdrop__modal ' + higher }),
	        _react2.default.createElement(
	          'div',
	          { className: 'confirm__modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'confirm__content' },
	            _react2.default.createElement(_modalHeader2.default, { text: this.props.t('2312') }),
	            this.props.renderText(this.props)
	          ),
	          _react2.default.createElement(_bottomBar2.default, {
	            actionLabelText: this.props.t('381'),
	            onActionClick: this.props.AllOrders,
	            cancelLabelText: this.props.t('2314'),
	            onCancelClick: this.props.NotAllOrders
	          })
	        )
	      );
	    }
	  }]);
	
	  return StopOtherOrders;
	}(_react.Component);
	
	StopOtherOrders.defaultProps = {
	  renderText: function renderText(props) {
	    var txt = '';
	    if (props.Move) {
	      txt = props.t('2316');
	    } else if (props.Stop) {
	      txt = props.t('2315');
	    } else {
	      txt = props.t('2313');
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'pg-pb-2' },
	      txt
	    );
	  }
	};
	
	exports.default = StopOtherOrders;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Circle = function (_PureComponent) {
	  _inherits(Circle, _PureComponent);
	
	  function Circle() {
	    _classCallCheck(this, Circle);
	
	    return _possibleConstructorReturn(this, (Circle.__proto__ || Object.getPrototypeOf(Circle)).apply(this, arguments));
	  }
	
	  _createClass(Circle, [{
	    key: 'getSize',
	    value: function getSize() {
	      switch (this.props.size) {
	        case 't':
	          return ' size-tiny';
	        case 's':
	          return ' size-small';
	        case 'm':
	        default:
	          return ' size-medium';
	        case 'l':
	          return ' size-large';
	      }
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      switch (this.props.color) {
	        case 'green':
	        default:
	          return ' green';
	        case 'red':
	          return ' red';
	        case 'brand-2':
	          return ' brand-2';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: 'element-circle' + this.getSize() + this.getColor() });
	    }
	  }]);
	
	  return Circle;
	}(_react.PureComponent);
	
	Circle.defaultProps = {
	  size: 'm',
	  color: 'green'
	};
	
	exports.default = Circle;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Time = function (_Component) {
	  _inherits(Time, _Component);
	
	  function Time(props) {
	    _classCallCheck(this, Time);
	
	    var _this = _possibleConstructorReturn(this, (Time.__proto__ || Object.getPrototypeOf(Time)).call(this, props));
	
	    _this.state = {};
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Time, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      var val = e.target.value;
	
	      var sub = val.substr(1, 1);
	      var sub2 = val.substr(2, 1);
	      if (isNaN(parseInt(sub))) {
	        if (sub !== ':' && sub !== '') {
	          val = val.replace(sub, ':');
	        }
	      }
	      if (isNaN(parseInt(sub2))) {
	        if (sub2 !== ':' && sub2 !== '') {
	          val = val.replace(sub2, ':');
	        }
	      }
	      val = val.replace('::', ':');
	
	      var event = {
	        target: {
	          name: this.props.name,
	          value: val
	        }
	      };
	
	      if (this.props.onChange !== null) {
	        this.props.onChange(event);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var val = e.target.value;
	
	      if (!/[:]/.test(val)) {
	        if (val.length === 3) {
	          val = val.substr(0, 1) + ':' + val.substr(1, 2);
	        } else if (val.length >= 4) {
	          val = val.substr(0, 2) + ':' + val.substr(2, 2);
	        }
	      }
	
	      var event = {
	        target: {
	          name: this.props.name,
	          value: val
	        }
	      };
	
	      if (this.props.onChange !== null) {
	        this.props.onChange(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_text2.default, _extends({}, this.props, {
	        value: this.props.value,
	        onChange: this.onChange,
	        onBlur: this.onBlur,
	        maxLength: 5
	      }));
	    }
	  }]);
	
	  return Time;
	}(_react.Component);
	
	Time.defaultProps = {
	  onChange: null
	};
	
	exports.default = Time;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1638);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	// import { hasAccess } from '../../../utils/auth'
	
	
	// Elements
	
	
	var DeliveryDateChangeModal = function (_Component) {
	  _inherits(DeliveryDateChangeModal, _Component);
	
	  function DeliveryDateChangeModal(props) {
	    _classCallCheck(this, DeliveryDateChangeModal);
	
	    var _this = _possibleConstructorReturn(this, (DeliveryDateChangeModal.__proto__ || Object.getPrototypeOf(DeliveryDateChangeModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      oldDate: '',
	      newDate: '',
	      shopName: '',
	      clientName: '',
	      reason: 1,
	      comment: '',
	      confirmed: false,
	      isCustomerDraft: false,
	      ApplyToInvoice: false,
	      ShowToCustomer: false
	    };
	    _this.renderForm = _this.renderForm.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    _this.renderCustomerDraftDateChange = _this.renderCustomerDraftDateChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DeliveryDateChangeModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        oldDate: this.props.oldDate,
	        newDate: this.props.newDate,
	        shopName: this.props.shopName,
	        clientName: this.props.clientName,
	        reason: 1,
	        comment: '',
	        confirmed: false
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      this.setState({
	        oldDate: newProps.oldDate,
	        newDate: newProps.newDate,
	        shopName: this.props.shopName,
	        clientName: this.props.clientName,
	        reason: 1,
	        comment: '',
	        confirmed: newProps.confirmed
	      }, function () {
	        // console.log('OldDate', this.state.oldDate, ' NewDate', this.state.newDate)
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      e.persist();
	      var value = e.target.value;
	      var name = '';
	      if (e.target.type === 'radio') {
	        if (e.target.name === 'Reason') {
	          name = 'reason';
	          value = parseInt(value);
	        }
	      }
	      if (e.target.name === 'Comment') {
	        name = 'comment';
	        value = e.target.value;
	      }
	      if (e.target.type === 'checkbox') {
	        name = e.target.name;
	        value = !this.state[name];
	      }
	
	      this.setState(_defineProperty({}, name, value), function () {
	        // this.onBlur(e)
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      if (this.props.isCustomerDraft !== true) {
	        var momentDate = (0, _moment2.default)(this.state.newDate);
	        this.setState({
	          confirmed: true
	        }, function () {
	          // updateFromDeliveryTime
	          _this2.props.onSave({
	            DeliveryChangeReason: _this2.state.reason,
	            DeliveryChangeComment: _this2.state.comment,
	            Confirmed: _this2.state.confirmed,
	            NewDate: momentDate.format('YYYY-MM-DDTHH:mm:ss'),
	            CommentApplyToInvoice: _this2.state.ApplyToInvoice,
	            CommentShowToCustomer: _this2.state.ShowToCustomer
	          });
	        });
	      } else {
	        this.props.onSave(this.props.newDate);
	      }
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      this.setState({
	        confirmed: true
	      }, function () {
	        if (_this3.props.isCustomerDraft !== true) {
	          _this3.props.onClose();
	        } else {
	          _this3.props.onSave(_this3.props.oldDate);
	        }
	      });
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      var _this4 = this;
	
	      var deliveryChangeReason = this.state.reason;
	      var deliveryChangeComment = this.state.comment;
	      var fromDate = (0, _time.renderFullDate)(this.state.oldDate);
	
	      var toDate = (0, _time.renderFullDate)(this.state.newDate, false);
	      var toDateTime = (0, _time.renderFullDate)(this.state.newDate, true, true);
	
	      var client = this.state.clientName;
	      var shop = this.state.shopName;
	
	      // console.log('Dates', fromDate, toDate)
	      var times = this.props.times;
	      var timeString = toDateTime;
	
	      var timeKey = 'Time_' + (0, _moment2.default)(this.state.newDate).format('DD-MM-YYYY_HH:mm') + Math.random();
	
	      var onChangeTime = function onChangeTime(e) {
	        var datetime = _this4.state.newDate;
	        var splitted = e.target.value.split(':');
	        var dateVal = datetime !== null ? window.CustomDate(datetime) : window.CustomDate();
	        var momentDate = (0, _moment2.default)(dateVal);
	        momentDate.set({ hour: splitted[0], minute: splitted[1], second: 0, millisecond: 0 });
	        _this4.setState({
	          newDate: momentDate.format('YYYY-MM-DDTHH:mm:ss')
	        }, function () {
	          // console.log('state', this.state.newDate)
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1109') },
	          _react2.default.createElement(
	            'div',
	            { className: 'date-text' },
	            fromDate
	          )
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1110') },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              toDate + ' - '
	            ),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { value: timeString, onChange: onChangeTime, ref: 'TimeString', key: timeKey },
	              times.map(function (val, index) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: val, key: index },
	                  val
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1111') },
	          _react2.default.createElement(_radio2.default, { id: 'Reason_Shop', name: 'Reason', value: '2', onChange: this.onChange, checked: deliveryChangeReason === 2, labelText: shop }),
	          _react2.default.createElement(_radio2.default, { id: 'Reason_Client', name: 'Reason', value: '1', onChange: this.onChange, checked: deliveryChangeReason === 1, labelText: client })
	        ),
	        _react2.default.createElement(_textarea2.default, { name: 'Comment', value: deliveryChangeComment, onChange: this.onChange, labelText: (0, _helpers.translation)('149') }),
	        _react2.default.createElement(_divider2.default, { noLine: true }),
	        (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(_check2.default, { id: 'ApplyToInvoice', name: 'ApplyToInvoice', value: 'yes', onClick: this.onChange, checked: this.state.ApplyToInvoice, labelText: (0, _helpers.translation)('1785') }),
	        (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(_check2.default, { id: 'ShowToCustomer', name: 'ShowToCustomer', value: 'yes', onClick: this.onChange, checked: this.state.ShowToCustomer, labelText: (0, _helpers.translation)('17857') })
	      );
	    }
	  }, {
	    key: 'renderCustomerDraftDateChange',
	    value: function renderCustomerDraftDateChange() {
	      var fromDate = (0, _time.renderFullDate)(this.state.oldDate);
	      var toDate = (0, _time.renderFullDate)(this.state.newDate);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: 'delivery_dates clearfix' },
	          _react2.default.createElement(
	            'li',
	            { className: 'line wide' },
	            _react2.default.createElement(
	              'div',
	              { className: 'delivery-text wide' },
	              (0, _helpers.translation)('14738')
	            )
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('14737') },
	            _react2.default.createElement(
	              'div',
	              { className: 'delivery-text' },
	              fromDate
	            )
	          ),
	          _react2.default.createElement(_button2.default, { onClick: this.onClose, labelText: (0, _helpers.translation)('14726') }),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('14736') },
	            _react2.default.createElement(
	              'div',
	              { className: 'delivery-text' },
	              toDate
	            )
	          ),
	          _react2.default.createElement(_button2.default, { onClick: this.onSave, labelText: (0, _helpers.translation)('14727') })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.isCustomerDraft !== true) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'deliverychange_modal' },
	          _react2.default.createElement(
	            _Modal2.default,
	            _extends({}, this.props, {
	              header: (0, _helpers.translation)('1108'),
	              overflowHidden: this.state.overflowHidden,
	              icon: _icons.ModalIcons.Plus,
	              bottomBarProps: {
	                actionLabelText: (0, _helpers.translation)('956'),
	                onActionClick: this.onSave
	              }
	            }),
	            this.renderForm()
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'deliverychange_modal' },
	          _react2.default.createElement(
	            _Modal2.default,
	            _extends({}, this.props, { onClose: this.onClose, header: (0, _helpers.translation)('1108'),
	              icon: _icons.ModalIcons.Plus }),
	            this.renderCustomerDraftDateChange()
	          )
	        );
	      }
	    }
	  }]);
	
	  return DeliveryDateChangeModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(DeliveryDateChangeModal);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1659);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import PropTypes from 'prop-types'
	
	// import { saveOrder } from '../../../actions/orders'
	
	// import styles
	
	
	// import components
	
	
	// Utils
	
	
	// Elements
	
	
	var OtherPriceModal = function (_Component) {
	  _inherits(OtherPriceModal, _Component);
	
	  function OtherPriceModal(props) {
	    _classCallCheck(this, OtherPriceModal);
	
	    var _this = _possibleConstructorReturn(this, (OtherPriceModal.__proto__ || Object.getPrototypeOf(OtherPriceModal)).call(this, props));
	
	    _this.state = {
	      show: false,
	      other: {},
	      bodyShopPrice: {},
	      isLoading: false,
	      error: '',
	      order: {}
	    };
	    _this.saveOther = _this.saveOther.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(OtherPriceModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (props.show !== this.state.show) {
	        this.setState({
	          show: props.show,
	          other: props.other,
	          bodyShopPrice: props.bodyShopPrice,
	          order: props.order,
	          isLoading: false,
	          error: ''
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show !== this.state.show) {
	        this.setState({
	          show: this.props.show,
	          other: this.props.other,
	          order: this.props.order,
	          isLoading: false,
	          error: ''
	        });
	      }
	    }
	  }, {
	    key: 'saveOther',
	    value: function saveOther(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var _state = this.state,
	          order = _state.order,
	          other = _state.other,
	          bodyShopPrice = _state.bodyShopPrice;
	
	      this.setState({ isLoading: true, error: '' });
	
	      var data = {
	        OrderID: order.Id,
	        Other: {
	          IsDirty: true,
	          OtherTitle: other.Title || null,
	          OtherDescription: other.Description || null,
	          Price: parseFloat(other.Price),
	          Environment: parseFloat(other.Environment)
	        }
	      };
	
	      if (this.props.department === 1) {
	        data.BodyShopPrice = {
	          IsDirty: true,
	          ManualBodySparePartPrice: parseFloat(bodyShopPrice.ManualBodySparePartPrice),
	          ManualBodyMiscPrice: parseFloat(bodyShopPrice.ManualBodyMiscPrice),
	          ManualBodyWorkPrice: parseFloat(bodyShopPrice.ManualBodyWorkPrice),
	          ManualBodyWorkEnvPrice: parseFloat(bodyShopPrice.ManualBodyWorkEnvPrice)
	        };
	      }
	
	      this.props.saveOrder(data).then(function () {
	        _this2.props.onClose(false);
	      }).catch(function () {
	        _this2.setState({
	          isLoading: false,
	          error: (0, _helpers.translation)('960')
	        });
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var val = e.target.value;
	      var amountFields = ['Price', 'Environment', 'ManualBodySparePartPrice', 'ManualBodyMiscPrice', 'ManualBodyWorkPrice', 'ManualBodyWorkEnvPrice'];
	      if (amountFields.includes(e.target.name)) {
	        val = (0, _currency.reverseFormatCurrency2)(e.target.value);
	      } else {
	        val = e.target.value;
	      }
	      if (e.target.name.startsWith('ManualBody')) {
	        this.setState({
	          bodyShopPrice: _extends({}, this.state.bodyShopPrice, _defineProperty({}, e.target.name, val))
	        });
	      } else {
	        this.setState({
	          other: _extends({}, this.state.other, _defineProperty({}, e.target.name, val))
	        });
	      }
	    }
	  }, {
	    key: 'price',
	    value: function price(name) {
	      if (name.startsWith('ManualBody')) {
	        if (this.state.bodyShopPrice !== undefined && this.state.bodyShopPrice[name] !== undefined) {
	          var stateVal = this.state.bodyShopPrice[name];
	          if (stateVal === null) stateVal = 0;
	          var val = (0, _currency.formatCurrency2)(stateVal, 2);
	          return val;
	        }
	      } else if (this.state.other !== undefined && this.state.other[name] !== undefined) {
	        var _stateVal = this.state.other[name];
	        if (_stateVal === null) _stateVal = 0;
	        var _val = (0, _currency.formatCurrency2)(_stateVal, 2);
	        return _val;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.type === 1) {
	        if (typeof this.props.other.Title === 'undefined') return null;
	      }
	
	      var modalTitle = (0, _helpers.translation)('73');
	      if (this.props.type !== 1) {
	        modalTitle = (0, _helpers.translation)('2096');
	      }
	
	      var onBlur = function onBlur(e) {
	        if (e.target.name.startsWith('ManualBody')) {
	          var val = _this3.state.bodyShopPrice[e.target.name];
	          if (val === null) val = 0;
	          _this3.refs[e.target.name].value = (0, _currency.formatCurrency2)(val, 2);
	        } else {
	          var _val2 = _this3.state.other[e.target.name];
	          if (_val2 === null) _val2 = 0;
	          _this3.refs[e.target.name].value = (0, _currency.formatCurrency2)(_val2, 2);
	        }
	      };
	
	      var onFocus = function onFocus(e) {
	        if (e.target.value === (0, _currency.formatCurrency2)(0)) {
	          e.target.value = '';
	        }
	      };
	
	      var beforeDiscountLabel = this.props.order.HasDiscount ? ' ' + (0, _helpers.translation)('15012') : '';
	
	      var renderBodySparePartAmount = function renderBodySparePartAmount() {
	        return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('637') + beforeDiscountLabel, name: 'ManualBodySparePartPrice', onChange: _this3.onInputChange, onFocus: onFocus, onBlur: onBlur, ref: 'ManualBodySparePartPrice', defaultValue: _this3.price('ManualBodySparePartPrice') });
	      };
	
	      var renderBodyMiscAmount = function renderBodyMiscAmount() {
	        return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('15154') + beforeDiscountLabel, name: 'ManualBodyMiscPrice', onChange: _this3.onInputChange, onFocus: onFocus, onBlur: onBlur, ref: 'ManualBodyMiscPrice', defaultValue: _this3.price('ManualBodyMiscPrice') });
	      };
	
	      var renderBodyWorkPriceAmount = function renderBodyWorkPriceAmount() {
	        return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('416') + beforeDiscountLabel, name: 'ManualBodyWorkPrice', onChange: _this3.onInputChange, onFocus: onFocus, onBlur: onBlur, ref: 'ManualBodyWorkPrice', defaultValue: _this3.price('ManualBodyWorkPrice') });
	      };
	
	      var renderBodyWorkEnvPriceAmount = function renderBodyWorkEnvPriceAmount() {
	        return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('15156') + beforeDiscountLabel, name: 'ManualBodyWorkEnvPrice', onChange: _this3.onInputChange, onFocus: onFocus, onBlur: onBlur, ref: 'ManualBodyWorkEnvPrice', defaultValue: _this3.price('ManualBodyWorkEnvPrice') });
	      };
	
	      var renderPaintPriceAmount = function renderPaintPriceAmount() {
	        return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('641') + beforeDiscountLabel, name: 'Price', onChange: _this3.onInputChange, onFocus: onFocus, onBlur: onBlur, ref: 'Price', defaultValue: _this3.price('Price') });
	      };
	
	      var renderPaintEnvironmentAmount = function renderPaintEnvironmentAmount() {
	        return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('13339') + beforeDiscountLabel, name: 'Environment', onChange: _this3.onInputChange, onFocus: onFocus, onBlur: onBlur, ref: 'Environment', defaultValue: _this3.price('Environment') });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'other__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: modalTitle,
	            bottomBarProps: {
	              disabled: this.state.isLoading,
	              actionLabelText: (0, _helpers.translation)('791'),
	              onActionClick: this.saveOther
	            }
	          }),
	          this.state.error && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.state.error
	          ),
	          this.props.type === 1 && _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('1206'), name: 'Title', onChange: this.onInputChange, value: this.state.other.Title || '' }),
	          this.props.department !== 1 && renderPaintPriceAmount(),
	          this.props.department !== 1 && renderPaintEnvironmentAmount(),
	          this.props.department === 1 && renderBodyWorkPriceAmount(),
	          this.props.department === 1 && renderBodySparePartAmount(),
	          this.props.department === 1 && renderBodyMiscAmount(),
	          this.props.department === 1 && renderBodyWorkEnvPriceAmount(),
	          this.props.type === 1 && _react2.default.createElement(_textarea2.default, { labelText: (0, _helpers.translation)('1021'), name: 'Description', onChange: this.onInputChange, value: this.state.other.Description || '' })
	        )
	      );
	    }
	  }]);
	
	  return OtherPriceModal;
	}(_react.Component);
	
	OtherPriceModal.propTypes = {
	  saveOrder: _react2.default.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  // saveOrder
	})(OtherPriceModal);

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1662);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PriceApproval = __webpack_require__(424);
	
	var _PriceApproval2 = _interopRequireDefault(_PriceApproval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
	// import { translation } from '../../../utils/helpers'
	
	var PriceApprovalModal = function (_Component) {
	  _inherits(PriceApprovalModal, _Component);
	
	  function PriceApprovalModal(props) {
	    _classCallCheck(this, PriceApprovalModal);
	
	    var _this = _possibleConstructorReturn(this, (PriceApprovalModal.__proto__ || Object.getPrototypeOf(PriceApprovalModal)).call(this, props));
	
	    _this.state = {
	      headerText: '',
	      bottomBarProps: null
	    };
	    _this.setHeader = _this.setHeader.bind(_this);
	    _this.setBottomBarProps = _this.setBottomBarProps.bind(_this);
	    return _this;
	  }
	
	  _createClass(PriceApprovalModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {}
	  }, {
	    key: 'setHeader',
	    value: function setHeader(text) {
	      this.setState({ headerText: text });
	    }
	  }, {
	    key: 'setBottomBarProps',
	    value: function setBottomBarProps(bottomBarProps) {
	      this.setState({ bottomBarProps: bottomBarProps });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // overflowHidden={this.state.overflowHidden}
	      return _react2.default.createElement(
	        'div',
	        { className: 'priceapprove__modal mozilla-heright-fix' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: this.state.headerText,
	            bottomBarProps: this.state.bottomBarProps,
	            hideX: true
	          }),
	          this.renderForm()
	        )
	      );
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      return _react2.default.createElement(_PriceApproval2.default, {
	        router: this.props.router,
	        renderModal: true,
	        shopApproval: true,
	        RequireCustomerApproval: this.props.RequireCustomerApproval,
	        orderId: this.props.orderId,
	        modalCloseCB: this.props.closeModal,
	        priceInformation: this.props.priceInformation,
	        showAE: this.props.showAE,
	        setModalHeader: this.setHeader,
	        setBottomBarProps: this.setBottomBarProps
	      });
	    }
	  }]);
	
	  return PriceApprovalModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(PriceApprovalModal);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1668);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ReferenceCancel = __webpack_require__(1111);
	
	var _ReferenceCancel2 = _interopRequireDefault(_ReferenceCancel);
	
	var _ReferenceApproval = __webpack_require__(1109);
	
	var _ReferenceApproval2 = _interopRequireDefault(_ReferenceApproval);
	
	var _MigrationInfo = __webpack_require__(1108);
	
	var _MigrationInfo2 = _interopRequireDefault(_MigrationInfo);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	// import { ReferenceIcons } from '../../elements/icons'
	
	var ReferenceOrderActionModal = function (_Component) {
	  _inherits(ReferenceOrderActionModal, _Component);
	
	  function ReferenceOrderActionModal(props) {
	    _classCallCheck(this, ReferenceOrderActionModal);
	
	    var _this = _possibleConstructorReturn(this, (ReferenceOrderActionModal.__proto__ || Object.getPrototypeOf(ReferenceOrderActionModal)).call(this, props));
	
	    _this.state = {
	      referenceInfo: {
	        OrderConnectionId: 0,
	        TransferedFromCompanyName: '',
	        MoveType: 0,
	        OrderInfo: {
	          Orderid: 0,
	          RegNumber: '',
	          Brand: '',
	          Model: '',
	          Color: '',
	          Price: 0,
	          Pickup: undefined,
	          Delivery: undefined
	        },
	        TransportBefore: '',
	        TransportAfter: '',
	        CustomerId: 0,
	        CustomerName: '',
	        IsWorkProviderOrder: false,
	        PermittedCustomers: [],
	        HasReferredOldway: false
	      },
	      isLoading: true,
	      dimensions: {
	        width: 0,
	        height: 0
	      },
	      showMigrationModal: false,
	      bottomBarProps: null
	    };
	
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.dimensionShow = _this.dimensionShow.bind(_this);
	    _this.getReferenceOrderInfo = _this.getReferenceOrderInfo.bind(_this);
	    _this.setBottomBarProps = _this.setBottomBarProps.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReferenceOrderActionModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!(0, _auth.hasAccess)([1, 2, 3, 4], this.props.auth.user.AccessLevel)) {
	        window.toastr.error((0, _helpers.translation)('16417'), (0, _helpers.translation)('216'));
	        this.props.onClose();
	        return null;
	      }
	
	      this.getReferenceOrderInfo();
	      window.addEventListener('resize', this.updateDimensions);
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this2 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this2.state.dimensions.width;
	          if (width > higherThan && width <= lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'getReferenceOrderInfo',
	    value: function getReferenceOrderInfo() {
	      var _this3 = this;
	
	      this.props.GetReferenceOrderInfo(this.props.id).then(function (res) {
	        _this3.setState({
	          referenceInfo: res.data,
	          isLoading: false
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1932'), (0, _helpers.translation)('216'));
	        _this3.props.onClose();
	      });
	    }
	  }, {
	    key: 'setBottomBarProps',
	    value: function setBottomBarProps(bottomBarProps) {
	      this.setState({ bottomBarProps: bottomBarProps });
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this4 = this;
	
	      var loadingSpinner = function loadingSpinner() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'white__box loading' },
	          _react2.default.createElement(
	            'div',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'sr-only' },
	              (0, _helpers.translation)('13382'),
	              '...'
	            )
	          )
	        );
	      };
	      var isLoading = this.state.isLoading;
	      if (isLoading) {
	        return _react2.default.createElement(
	          'form',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'referenceGroup' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              (0, _helpers.translation)('13382'),
	              '...'
	            ),
	            loadingSpinner()
	          )
	        );
	      }
	
	      var onClose = function onClose(IsApproved) {
	        if (_this4.state.referenceInfo.HasReferredOldway && IsApproved) {
	          _this4.setState({
	            showMigrationModal: true
	          });
	        } else {
	          _this4.props.onClose();
	        }
	      };
	
	      if (this.state.referenceInfo.IsApproved) {
	        return _react2.default.createElement(_ReferenceCancel2.default, {
	          referenceInfo: this.state.referenceInfo,
	          department: this.props.department,
	          dimensionShow: this.dimensionShow,
	          onClose: this.props.onClose,
	          setBottomBarProps: this.setBottomBarProps
	        });
	      } else {
	        return _react2.default.createElement(_ReferenceApproval2.default, {
	          referenceInfo: this.state.referenceInfo,
	          department: this.props.department,
	          dimensionShow: this.dimensionShow,
	          onClose: onClose,
	          setBottomBarProps: this.setBottomBarProps
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Permission is handeld in "componentDidMount"
	
	      var icon = void 0;
	      // if (this.state.referenceInfo.IsApproved) {
	      //   icon = ReferenceIcons.Referred_Approved
	      //   // icon = 'referred-order-white-red.svg'
	      // } else {
	      // icon = ReferenceIcons.Referred_NotApproved
	      // icon = 'referred-order-white.svg'
	      // }
	
	      var headerName = this.props.item.Model ? this.props.item.Model : '' + ' ' + this.props.item.RegNumber;
	
	      if (this.state.showMigrationModal) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'refOrderApproval migration' },
	          _react2.default.createElement(
	            _Modal2.default,
	            _extends({}, this.props, {
	              header: this.state.referenceInfo.CustomerName,
	              overflowHidden: this.state.overflowHidden,
	              onClose: this.props.onClose,
	              bottomBarProps: this.state.bottomBarProps
	            }),
	            _react2.default.createElement(_MigrationInfo2.default, {
	              onClose: this.props.onClose,
	              customerId: this.state.referenceInfo.CustomerId,
	              setBottomBarProps: this.setBottomBarProps
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'refOrderApproval' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('751') + ' - ' + headerName,
	            overflowHidden: this.state.overflowHidden,
	            onClose: this.props.onClose,
	            icon: icon,
	            bottomBarProps: this.state.bottomBarProps
	          }),
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return ReferenceOrderActionModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetReferenceOrderInfo: _orders.GetReferenceOrderInfo
	})(ReferenceOrderActionModal);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _cloneDeep = __webpack_require__(531);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _calendarOverview = __webpack_require__(402);
	
	var _common = __webpack_require__(25);
	
	var _icons = __webpack_require__(6);
	
	var _assign = __webpack_require__(148);
	
	var _employees = __webpack_require__(128);
	
	var _constants = __webpack_require__(5);
	
	var _overlay = __webpack_require__(131);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _calendarHeader = __webpack_require__(1004);
	
	var _calendarHeader2 = _interopRequireDefault(_calendarHeader);
	
	var _calendarFooter = __webpack_require__(1003);
	
	var _calendarFooter2 = _interopRequireDefault(_calendarFooter);
	
	var _calendarRowWeek = __webpack_require__(1011);
	
	var _calendarRowWeek2 = _interopRequireDefault(_calendarRowWeek);
	
	var _calendarRowMonth = __webpack_require__(1010);
	
	var _calendarRowMonth2 = _interopRequireDefault(_calendarRowMonth);
	
	var _calendarRowGroup = __webpack_require__(1009);
	
	var _calendarRowGroup2 = _interopRequireDefault(_calendarRowGroup);
	
	var _calendarOrderInfo = __webpack_require__(1008);
	
	var _calendarOrderInfo2 = _interopRequireDefault(_calendarOrderInfo);
	
	var _overviewOrderInfo = __webpack_require__(1124);
	
	var _overviewOrderInfo2 = _interopRequireDefault(_overviewOrderInfo);
	
	var _overlayContent = __webpack_require__(177);
	
	var _overlayContent2 = _interopRequireDefault(_overlayContent);
	
	var _iconAccordion = __webpack_require__(201);
	
	var _iconAccordion2 = _interopRequireDefault(_iconAccordion);
	
	var _avatar = __webpack_require__(234);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _calendarItemStatus = __webpack_require__(1005);
	
	var _calendarItemStatus2 = _interopRequireDefault(_calendarItemStatus);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _OverlayHeaderBare = __webpack_require__(296);
	
	var _OverlayHeaderBare2 = _interopRequireDefault(_OverlayHeaderBare);
	
	var _calendarItem = __webpack_require__(1007);
	
	var _calendarItem2 = _interopRequireDefault(_calendarItem);
	
	var _calendarContent = __webpack_require__(1002);
	
	var _calendarContent2 = _interopRequireDefault(_calendarContent);
	
	var _calendar = __webpack_require__(1012);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _infoBar = __webpack_require__(1123);
	
	var _infoBar2 = _interopRequireDefault(_infoBar);
	
	var _filterBar = __webpack_require__(1122);
	
	var _filterBar2 = _interopRequireDefault(_filterBar);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1681);
	
	var _calendarItemStep = __webpack_require__(1006);
	
	var _calendarItemStep2 = _interopRequireDefault(_calendarItemStep);
	
	var _FilterSlidePanel = __webpack_require__(1119);
	
	var _FilterSlidePanel2 = _interopRequireDefault(_FilterSlidePanel);
	
	var _progressLine = __webpack_require__(454);
	
	var _progressLine2 = _interopRequireDefault(_progressLine);
	
	var _TimelineSlidePanel = __webpack_require__(1121);
	
	var _TimelineSlidePanel2 = _interopRequireDefault(_TimelineSlidePanel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _scrollToTop = __webpack_require__(1077);
	
	var _scrollToTop2 = _interopRequireDefault(_scrollToTop);
	
	var _circleButton = __webpack_require__(450);
	
	var _circleButton2 = _interopRequireDefault(_circleButton);
	
	var _AssignBox = __webpack_require__(196);
	
	var _AssignBox2 = _interopRequireDefault(_AssignBox);
	
	var _AssignItem = __webpack_require__(227);
	
	var _AssignItem2 = _interopRequireDefault(_AssignItem);
	
	var _NewOrdersModal = __webpack_require__(238);
	
	var _NewOrdersModal2 = _interopRequireDefault(_NewOrdersModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router'
	
	// import CalendarRow from '../../components/Calendar/calendarRow'
	
	// import Null from '../../elements/null'
	
	// import ButtonGroup from '../../elements/buttonGroup'
	// import ButtonGroupButton from '../../elements/buttonGroupButton'
	
	// import Check from '../../elements/check'
	
	// import Label from '../../elements/label'
	// import ArrowButton from '../../elements/arrowButton'
	
	// import CloseButton from '../../elements/closeButton'
	
	
	var SparePartStatus = {
	  None: 0, // Are ready
	  Unknown: 1, // Await order
	  NotInUse: 2,
	  InStock: 4, // Are ready
	  Ordered: 8, // Await receipt
	  Received: 16, // Are ready
	  Defective: 32,
	  Incorrect: 64
	};
	var CalendarViews = {
	  Week: 0,
	  Month: 1,
	  Day: 2
	};
	var itemsHeight = {
	  padding: 72 // all padding from overlay-content
	
	  // calendar item step style
	};var StepClasses = {
	  None: '',
	  BufferStart: 'capacity-calendar-item-step--buffer',
	  BufferEnd: 'capacity-calendar-item-step--buffer',
	  BodyStart: 'capacity-calendar-item-step--green',
	  BodyEnd: 'capacity-calendar-item-step--green',
	  Coating: 'capacity-calendar-item-step--coating',
	  EarliestStartGap: 'capacity-calendar-item-step--coating'
	};
	
	var StepTypes = ['None', 'BufferStart', 'BufferEnd', 'BodyStart', 'BodyEnd', 'Coating', 'BodyStartStatus', 'BodyEndStatus', 'CoatingStatus', 'EarliestStartGap'];
	var StatusTypes = ['None', 'Green', 'Red', 'Yellow'];
	var StatusColors = {
	  None: 'none',
	  Green: 'green',
	  Red: 'red',
	  Yellow: 'yellow'
	};
	
	var OrderCapacityOverview = function (_Component) {
	  _inherits(OrderCapacityOverview, _Component);
	
	  function OrderCapacityOverview(props) {
	    _classCallCheck(this, OrderCapacityOverview);
	
	    var _this = _possibleConstructorReturn(this, (OrderCapacityOverview.__proto__ || Object.getPrototypeOf(OrderCapacityOverview)).call(this, props));
	
	    _this.interval = null;
	    _this.viewScroll = 0;
	    _this.today = (0, _time.formatDate)((0, _moment2.default)().startOf('day'));
	    _this.state = {
	      filter: {
	        unassigned: false,
	        arrived: false,
	        estimationApproved: false,
	        sparePartsAreReady: false,
	        sparePartsAwaitReception: false,
	        sparePartsAreAwaitingOrder: false,
	        selectedEmployees: []
	      },
	      view: CalendarViews.Month,
	      grouped: true,
	      originalOverview: null,
	      filteredOverview: null,
	      topNodeHeight: 0,
	      orderContentHeight: 0,
	      totalCalendarRowsContentHeight: 0,
	      showInfoBar: false,
	      showFilterBar: false,
	      isActiveFilter: false,
	      assign_open: false,
	      createDraft: {
	        open: false,
	        pickup: null,
	        employee: null,
	        steps: []
	      },
	      StepAssignments: [],
	      groupStates: {},
	      assignableEmployees: [],
	      employeesMap: [],
	      activeEmployees: [],
	
	      requestData: {
	        WeekType: 0,
	        CurrentViewRange: (0, _time.formatDate)((0, _moment2.default)().startOf('week'))
	      },
	
	      filterPanelView: '',
	      isFilterSlidePanelOpen: false,
	      isTimeLineSlidePanelOpen: false,
	      selectedTimelineOrderId: null
	    };
	
	    _this.updateState = _this.updateState.bind(_this);
	    _this.checkHeight = _this.checkHeight.bind(_this);
	    _this.renderRow = _this.renderRow.bind(_this);
	    _this.openInfoBar = _this.openInfoBar.bind(_this);
	    _this.closeInfoBar = _this.closeInfoBar.bind(_this);
	    _this.closeFilterBar = _this.closeFilterBar.bind(_this);
	    _this.openFilterBar = _this.openFilterBar.bind(_this);
	    _this.goTo = _this.goTo.bind(_this);
	    _this.filterOverview = _this.filterOverview.bind(_this);
	    _this.filterCarArrived = _this.filterCarArrived.bind(_this);
	    // this.filterUnassigned = this.filterUnassigned.bind(this)
	    _this.filterEstimationApproved = _this.filterEstimationApproved.bind(_this);
	    _this.renderFilter = _this.renderFilter.bind(_this);
	    _this.getCapacityOverview = _this.getCapacityOverview.bind(_this);
	    _this.resetCapacityOverview = _this.resetCapacityOverview.bind(_this);
	    _this.goToThisWeek = _this.goToThisWeek.bind(_this);
	    _this.openFilterSlidePanel = _this.openFilterSlidePanel.bind(_this);
	    _this.filterRows = _this.filterRows.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.openTimelineSlidePanel = _this.openTimelineSlidePanel.bind(_this);
	    _this.closeTimelineSlidePanel = _this.closeTimelineSlidePanel.bind(_this);
	    _this.resetState = _this.resetState.bind(_this);
	    _this.onOverlayShow = _this.onOverlayShow.bind(_this);
	    _this.onOverlayHide = _this.onOverlayHide.bind(_this);
	    _this.getGroupedData = _this.getGroupedData.bind(_this);
	    _this.onRangeUpdated = _this.onRangeUpdated.bind(_this);
	    _this.onMonthDayClicked = _this.onMonthDayClicked.bind(_this);
	    _this.onAssignUsers = _this.onAssignUsers.bind(_this);
	    // this.openAssign = this.openAssign.bind(this)
	    _this.renderCalendarHeaderButtons = _this.renderCalendarHeaderButtons.bind(_this);
	    _this.toggleWeekOrMonth = _this.toggleWeekOrMonth.bind(_this);
	    _this.getAssignOrderData = _this.getAssignOrderData.bind(_this);
	    _this.triggerClickAssign = _this.triggerClickAssign.bind(_this);
	    _this.closeAssignBox = _this.closeAssignBox.bind(_this);
	    _this.toggleGrouped = _this.toggleGrouped.bind(_this);
	    _this.startUpdateInterval = _this.startUpdateInterval.bind(_this);
	    _this.getGroupStates = _this.getGroupStates.bind(_this);
	    _this.createDraft = _this.createDraft.bind(_this);
	    _this.saveViewState = _this.saveViewState.bind(_this);
	    _this.restoreViewState = _this.restoreViewState.bind(_this);
	    _this.onDraftCreated = _this.onDraftCreated.bind(_this);
	    _this.collapseAllGroupsExcept = _this.collapseAllGroupsExcept.bind(_this);
	    _this.triggerAssignEmployee = _this.triggerAssignEmployee.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderCapacityOverview, [{
	    key: 'resetState',
	    value: function resetState() {
	      this.setState({
	        filter: {
	          unassigned: false,
	          arrived: false,
	          estimationApproved: false,
	          sparePartsAreReady: false,
	          sparePartsAwaitReception: false,
	          sparePartsAreAwaitingOrder: false,
	          selectedEmployees: []
	        },
	        view: CalendarViews.Month,
	        grouped: true,
	        originalOverview: null,
	        filteredOverview: null,
	        topNodeHeight: 0,
	        orderContentHeight: 0,
	        showInfoBar: false,
	        showFilterBar: false,
	        isActiveFilter: false,
	        groupStates: {},
	
	        requestData: {
	          WeekType: 0,
	          CurrentViewRange: (0, _time.formatDate)((0, _moment2.default)().startOf('week'))
	        },
	
	        filterPanelView: '',
	        isFilterSlidePanelOpen: false,
	        isTimeLineSlidePanelOpen: false,
	        selectedTimelineOrderId: null
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.onOverlayHide();
	    }
	  }, {
	    key: 'onOverlayShow',
	    value: function onOverlayShow() {
	      var _this2 = this;
	
	      // udate capacity overview every 15sec.
	      if (this.interval !== null) {
	        clearInterval(this.interval);
	        this.interval = null;
	      }
	      // when assignment is open, CapacityOverview should not update
	      if (!this.state.assign_open) {
	        this.startUpdateInterval();
	      }
	      this.resetState();
	      // Get employees before we get capacity data to make sure data can be grouped for any employee
	      this.props.getEmployees().then(function (res) {
	        var employees = res.data.filter(function (x) {
	          return x.Active && x.Confirmed && x.IsAssignableToOrders;
	        }).map(function (x) {
	          return { UserId: x.UserId, Name: x.Name, Initials: x.Initials };
	        });
	        var employeesMap = {};
	        res.data.filter(function (x) {
	          return x.Active && x.Confirmed;
	        }).map(function (x) {
	          employeesMap[x.UserId] = x;
	        });
	        _this2.setState({ assignableEmployees: employees, employeesMap: employeesMap }, function () {
	          console.log('overlay show -> state:', _this2.state);
	          _this2.getCapacityOverview();
	        });
	      });
	      window.addEventListener('resize', this.handleResize);
	      this.props.setEmployees([]);
	    }
	  }, {
	    key: 'startUpdateInterval',
	    value: function startUpdateInterval() {
	      var _this3 = this;
	
	      if (!this.interval) {
	        this.interval = setInterval(function () {
	          _this3.getCapacityOverview();
	        }, 15000);
	      }
	    }
	  }, {
	    key: 'onOverlayHide',
	    value: function onOverlayHide() {
	      window.removeEventListener('resize', null);
	      if (this.interval !== null) {
	        clearInterval(this.interval);
	        this.interval = null;
	        this.originalOverview = null;
	        this.filteredOverview = null;
	      }
	    }
	
	    /**
	     * Saves the view state, to let the exact same view be restored later.
	     */
	
	  }, {
	    key: 'saveViewState',
	    value: function saveViewState(orderId) {
	      var openDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _state = this.state,
	          filter = _state.filter,
	          view = _state.view,
	          grouped = _state.grouped,
	          isActiveFilter = _state.isActiveFilter,
	          assign_open = _state.assign_open,
	          groupStates = _state.groupStates,
	          requestData = _state.requestData;
	
	      var scroll = document.getElementsByClassName('element-overlay')[0].scrollTop;
	      var viewState = { filter: filter, view: view, grouped: grouped, isActiveFilter: isActiveFilter, assign_open: assign_open, groupStates: groupStates, requestData: requestData, orderId: orderId, openDetails: openDetails, scroll: scroll
	
	        // If there is an employee stored for the create draft popup, store their user ID, so it can be expanded when view state is restored.
	      };if (this.state.createDraft.employee && this.state.createDraft.employee.UserId > 0) {
	        viewState.groupStates[this.state.createDraft.employee.UserId] = true;
	      }
	      window.localStorage.setItem('capacity_viewstate', JSON.stringify(viewState));
	    }
	
	    /**
	     * Restores the view state from a previously saved state, and removes the saved state from local storage.
	     */
	
	  }, {
	    key: 'restoreViewState',
	    value: function restoreViewState() {
	      var _this4 = this;
	
	      var viewState = window.localStorage.getItem('capacity_viewstate');
	      console.log('restoreViewState', viewState);
	      if (viewState === null || viewState === undefined) return false;
	      try {
	        viewState = JSON.parse(viewState);
	      } catch (error) {
	        viewState = null;
	        return false;
	      }
	
	      var checkElementInView = function checkElementInView(element) {
	        var rect = element.getBoundingClientRect();
	        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	      };
	      if (viewState) {
	        this.setState(_extends({}, viewState, {
	          selectedTimelineOrderId: viewState.orderId || null
	        }), function () {
	          if (viewState.scroll !== undefined) {
	            setTimeout(function () {
	              // Attempt to scroll to position that was stored.
	              document.getElementsByClassName('element-overlay')[0].scrollTo({ top: viewState.scroll, behavior: 'smooth' });
	              if (viewState.orderId) {
	                // If there is an order Id stored, try to locate the order and scroll to that too.
	                console.log('Try to scroll to', viewState.orderId);
	                setTimeout(function () {
	                  var orderElement = document.body.querySelector('div[data-orderid="' + viewState.orderId + '"]');
	                  if (orderElement && !checkElementInView(orderElement)) {
	                    orderElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
	                  }
	                }, 500);
	              }
	            }, 500);
	          }
	          setTimeout(function () {
	            if (viewState.orderId && viewState.openDetails && _this4.state.filteredOverview) {
	              _this4.openTimelineSlidePanel(viewState.orderId);
	            }
	          }, 500);
	        });
	        window.localStorage.removeItem('capacity_viewstate');
	        return true;
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var _this5 = this;
	
	      this.updateState({
	        orderContentHeight: 0 // reset this before you get the new content height
	      }, function () {
	        _this5.checkHeight();
	      });
	    }
	  }, {
	    key: 'getCapacityOverview',
	    value: function getCapacityOverview() {
	      var _this6 = this;
	
	      this.props.getCapacityOverview(_extends({}, this.state.requestData, { CalendarView: this.state.view, currentTime: this.state.currentTime })).then(function (res) {
	        _this6.state.filter = _this6.restoreFilterFromStorage(_this6.state.filter);
	        _this6.today = (0, _time.formatDate)((0, _moment2.default)().startOf('day'));
	        _this6.state.originalOverview = res.data;
	        if (_this6.restoreViewState()) {
	          // If view settings were restored, refresh data.
	          _this6.getCapacityOverview();
	          return;
	        }
	        _this6.filterOverview(null, { groupStates: _this6.getGroupStates() });
	        if (_this6.state.assign_open) {
	          _this6.getAssignOrderData();
	        }
	      });
	    }
	  }, {
	    key: 'setIsActiveFilter',
	    value: function setIsActiveFilter() {
	      var isActive = false;
	      var isChecked = Object.values(this.state.filter).find(function (x) {
	        return x === true;
	      });
	      if (isChecked) isActive = true;
	      if (this.state.filter.selectedEmployees.length > 0) isActive = true;
	      if (this.state.isActiveFilter === isActive) return;
	      this.setState({
	        isActiveFilter: isActive
	      });
	    }
	
	    // Filters originalOverview and sets filteredOverview in state
	
	  }, {
	    key: 'filterOverview',
	    value: function filterOverview(newFilter, additionalState) {
	      var _this7 = this;
	
	      // console.log('additionalState', additionalState)
	      var overviewCopy = (0, _cloneDeep2.default)(this.state.originalOverview);
	      var filter = this.state.filter;
	      if (newFilter) {
	        this.saveFilterInStorage(newFilter); // from slide in new filter
	        filter = newFilter;
	      }
	
	      overviewCopy = this.filterRows(overviewCopy, filter);
	      this.updateState(_extends({
	        filteredOverview: overviewCopy,
	        filter: filter
	      }, additionalState), function () {
	        _this7.handleResize();
	        _this7.setIsActiveFilter();
	      });
	    }
	  }, {
	    key: 'filterRows',
	    value: function filterRows(overviewCopy, filter) {
	      var _this8 = this;
	
	      if (overviewCopy === null) return null;
	      overviewCopy.Rows = overviewCopy.Rows.filter(function (x) {
	        return _this8.filterCarArrived(filter, x) && _this8.filterEstimationApproved(filter, x) &&
	        // this.filterUnassigned(filter, x) &&
	        _this8.filterSparePartsAreReady(filter, x) && _this8.filterSparePartsAwaitReceipt(filter, x) && _this8.filterSparePartsAreAwaitingOrder(filter, x) && _this8.filterEmployee(filter, x);
	      });
	      return overviewCopy;
	    }
	  }, {
	    key: 'saveFilterInStorage',
	    value: function saveFilterInStorage(value) {
	      window.localStorage.setItem('CapacityOverviewfilter', JSON.stringify(value));
	    }
	  }, {
	    key: 'restoreFilterFromStorage',
	    value: function restoreFilterFromStorage(value) {
	      var storedFilter = window.localStorage.getItem('CapacityOverviewfilter'); // Get the existing data
	
	      // Handle invalid filter data in local storage
	      try {
	        storedFilter = storedFilter ? JSON.parse(storedFilter) : value; // If no existing data, create new object
	      } catch (error) {
	        return value;
	      }
	
	      return storedFilter;
	    }
	  }, {
	    key: 'filterCarArrived',
	    value: function filterCarArrived(filter, row) {
	      if (!filter.arrived) {
	        return true;
	      } else if (row.HasCarArrived) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'filterEstimationApproved',
	    value: function filterEstimationApproved(filter, row) {
	      if (!filter.estimationApproved) {
	        return true;
	      } else if (row.IsEstimationApproved) {
	        return true;
	      }
	      return false;
	    }
	
	    // filterUnassigned (filter, row) {
	    //   if (!filter.unassigned) {
	    //     return true
	    //   } else if (row.HasUnassignedSteps) {
	    //     return true
	    //   }
	    //   return false
	    // }
	
	  }, {
	    key: 'filterSparePartsAreReady',
	    value: function filterSparePartsAreReady(filter, row) {
	      if (!filter.sparePartsAreReady) {
	        return true;
	      } else if (row.SparePartStatusSum === SparePartStatus.InStock || row.SparePartStatusSum === SparePartStatus.Received || row.SparePartStatusSum === SparePartStatus.None) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'filterSparePartsAwaitReceipt',
	    value: function filterSparePartsAwaitReceipt(filter, row) {
	      if (!filter.sparePartsAwaitReception) {
	        return true;
	      } else if (row.SparePartStatusSum === SparePartStatus.Ordered) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'filterSparePartsAreAwaitingOrder',
	    value: function filterSparePartsAreAwaitingOrder(filter, row) {
	      if (!filter.sparePartsAreAwaitingOrder) {
	        return true;
	      } else if (row.SparePartStatusSum === SparePartStatus.Unknown) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'filterEmployee',
	    value: function filterEmployee(filter, row) {
	      var selectedEmployees = filter.selectedEmployees;
	      var employeesInRow = [];
	      var unAssignUser = { UserId: 0 };
	      if (selectedEmployees.length > 0) {
	        row.Assignments.map(function (assignment) {
	          assignment.Employees.map(function (employee) {
	            if (employeesInRow.findIndex(function (x) {
	              return x.UserId === employee.UserId;
	            }) === -1) {
	              employeesInRow.push(employee);
	            }
	          });
	        });
	
	        // unassign filter
	        if (selectedEmployees.findIndex(function (x) {
	          return x === 0;
	        }) !== -1 && row.HasUnassignedSteps) {
	          employeesInRow.push(unAssignUser);
	        }
	
	        if (employeesInRow.length > 0) {
	          var _loop = function _loop(i) {
	            if (selectedEmployees.findIndex(function (x) {
	              return x === employeesInRow[i].UserId;
	            }) !== -1) {
	              return {
	                v: true
	              };
	            }
	          };
	
	          for (var i = 0; i < employeesInRow.length; i++) {
	            var _ret = _loop(i);
	
	            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	          }
	        }
	        return false;
	      }
	      return true;
	    }
	
	    /**
	     * Opens popup to let user create a draft
	     * @param {*} date Pickup date.
	     * @param {*} employee Employee to assign when booking from workcard afterwards.
	     * @param {*} steps Steps to assign the employee to.
	     */
	
	  }, {
	    key: 'createDraft',
	    value: function createDraft(date, employee, steps) {
	      // console.log('Create draft', date, employee, steps)
	      this.setState({
	        createDraft: {
	          open: true,
	          pickup: date,
	          employee: employee,
	          steps: steps
	        }
	      });
	      if (this.interval !== null) {
	        clearInterval(this.interval);
	        this.interval = null;
	      }
	    }
	  }, {
	    key: 'onDraftCreated',
	    value: function onDraftCreated(orderId) {
	      // console.log('Draft created from capacity', this.state.createDraft, orderId)
	      this.saveViewState(orderId);
	      this.onOverlayHide();
	    }
	  }, {
	    key: 'getAssignOrderData',
	    value: function getAssignOrderData(activeEmployees) {
	      var _this9 = this;
	
	      var orderIds = [];
	      this.state.filteredOverview.Rows.map(function (val) {
	        orderIds.push(val.Item.OrderId);
	      });
	
	      this.props.getOrderDataNew({
	        OrderIds: orderIds,
	        UserIds: activeEmployees || this.props.activeEmployees
	      }).then(function (res) {
	        _this9.setState({
	          StepAssignments: res.data.StepAssignments
	          // activeEmployees: activeEmployees || this.props.activeEmployees
	        }, function () {
	          // this.handleGroupeStateWhenAssignOpen(true)
	        });
	      });
	      // this.getAssignOrderData(this.props.activeEmployees,orderIds)
	    }
	  }, {
	    key: 'triggerAssignEmployee',
	    value: function triggerAssignEmployee(activeEmployees) {
	      var _this10 = this;
	
	      this.setState({
	        activeEmployees: activeEmployees || this.props.activeEmployees
	      }, function () {
	        _this10.handleGroupeStateWhenAssignOpen(true);
	        _this10.toggleSingleGroupStates(_this10.state.activeEmployees[0]);
	        _this10.getAssignOrderData();
	      });
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(newState, cb) {
	      var _this11 = this;
	
	      this.setState(newState, function () {
	        _this11.checkHeight();
	        if (cb) cb();
	      });
	    }
	  }, {
	    key: 'checkHeight',
	    value: function checkHeight() {
	      var _this12 = this;
	
	      // Check top node height
	      if (this.refs.overlayContent !== undefined) {
	        var padding = itemsHeight.padding;
	        var calendarHeaderHeight = this.refs.calendarHeaderRef.clientHeight;
	        var calendarFooterHeight = this.refs.calendarFooterRef.clientHeight;
	        var calendarFilterContetHeight = this.refs.topNode.clientHeight;
	        var overlayContent = this.refs.overlayContent.clientHeight;
	        var calendarGroupFooterHeight = this.refs.calendarGroupFooterRef !== undefined ? this.refs.calendarGroupFooterRef.clientHeight : 0;
	        var heightResult = padding + calendarHeaderHeight + calendarFooterHeight + calendarFilterContetHeight + calendarGroupFooterHeight;
	        var orderContentHeight = overlayContent - heightResult;
	
	        var rowCount = 0;
	        var groupHeadingsCount = 0;
	        if (this.state.filteredOverview && Array.isArray(this.state.filteredOverview.Rows)) {
	          if (this.state.grouped) {
	            var groupedData = this.getGroupedData();
	            groupedData.forEach(function (g) {
	              rowCount += _this12.state.groupStates[g.Employee.UserId] ? g.Rows.length : 0;
	              rowCount += 1; // Extra row for the sum line
	              groupHeadingsCount++;
	            });
	          } else {
	            rowCount = this.state.filteredOverview.Rows.length;
	          }
	        }
	        // week row height : 81 ; month row height : 32
	        var rowHeight = this.state.view === CalendarViews.Week ? 81 : 32;
	        var groupHeadingHeight = 40; // this.state.view === CalendarViews.Week ? 40 : 40
	        var totalRowsHeight = Math.max(0, rowCount * rowHeight + groupHeadingsCount * groupHeadingHeight - 1);
	
	        // Update if needed
	        if (this.state.orderContentHeight !== orderContentHeight || totalRowsHeight !== this.state.totalCalendarRowsContentHeight) {
	          this.setState({
	            orderContentHeight: orderContentHeight,
	            totalCalendarRowsContentHeight: totalRowsHeight // (Number of shown orders * 80 height + 1 border) - 1 border for last order
	          });
	        }
	      }
	    }
	  }, {
	    key: 'openFilterSlidePanel',
	    value: function openFilterSlidePanel(title) {
	      var _this13 = this;
	
	      this.setState({
	        filterPanelView: title,
	        selectedTimelineOrderId: null,
	        isFilterSlidePanelOpen: true,
	        isTimeLineSlidePanelOpen: false
	      }, function () {
	        _this13.props.closeSlidePanel('orderTimeline');
	        _this13.props.openSlidePanel('filterOrder');
	      });
	    }
	  }, {
	    key: 'closeFilterSlidePanel',
	    value: function closeFilterSlidePanel() {
	      this.setState({
	        filterPanelView: '',
	        isFilterSlidePanelOpen: false
	      });
	    }
	  }, {
	    key: 'openTimelineSlidePanel',
	    value: function openTimelineSlidePanel(orderId) {
	      var _this14 = this;
	
	      this.setState({
	        filterPanelView: '',
	        selectedTimelineOrderId: orderId,
	        isFilterSlidePanelOpen: false,
	        isTimeLineSlidePanelOpen: true
	      }, function () {
	        _this14.props.closeSlidePanel('filterOrder');
	        _this14.props.openSlidePanel('orderTimeline');
	      });
	    }
	  }, {
	    key: 'closeTimelineSlidePanel',
	    value: function closeTimelineSlidePanel() {
	      this.setState({
	        selectedTimelineOrderId: null,
	        isTimeLineSlidePanelOpen: false
	      });
	    }
	  }, {
	    key: 'openInfoBar',
	    value: function openInfoBar() {
	      var type = !this.state.showInfoBar;
	      this.updateState({
	        showInfoBar: type,
	        orderContentHeight: 0
	      });
	    }
	  }, {
	    key: 'triggerClickAssign',
	    value: function triggerClickAssign() {
	      var _this15 = this;
	
	      this.setState({
	        assign_open: !this.state.assign_open
	      }, function () {
	        // this.toggleGrouped()
	        if (_this15.state.assign_open) {
	          _this15.getAssignOrderData();
	          clearInterval(_this15.interval);
	          _this15.interval = null;
	          if (!_this15.state.grouped) {
	            _this15.toggleGrouped();
	          }
	          _this15.handleGroupeStateWhenAssignOpen(true);
	        } else {
	          _this15.getCapacityOverview();
	          _this15.startUpdateInterval();
	        }
	      });
	      // this.openAssign(type)
	    }
	  }, {
	    key: 'openFilterBar',
	    value: function openFilterBar() {
	      var _this16 = this;
	
	      var type = !this.state.showFilterBar;
	      this.updateState({
	        showFilterBar: type,
	        orderContentHeight: 0
	      }, function () {
	        _this16.closeAssignBox();
	      });
	    }
	  }, {
	    key: 'closeFilterBar',
	    value: function closeFilterBar() {
	      this.updateState({
	        showFilterBar: false,
	        orderContentHeight: 0
	      });
	    }
	  }, {
	    key: 'closeInfoBar',
	    value: function closeInfoBar() {
	      this.updateState({
	        showInfoBar: false,
	        orderContentHeight: 0
	      });
	    }
	  }, {
	    key: 'resetCapacityOverview',
	    value: function resetCapacityOverview() {
	      this.updateState({
	        filter: _extends({}, this.state.filter, {
	          unassigned: false,
	          arrived: false,
	          estimationApproved: false,
	          sparePartsAreReady: false,
	          sparePartsAwaitReception: false,
	          sparePartsAreAwaitingOrder: false,
	          selectedEmployees: []
	        }),
	        filterPanelView: ''
	      });
	    }
	  }, {
	    key: 'handleGroupeStateWhenAssignOpen',
	    value: function handleGroupeStateWhenAssignOpen(openActiveEmployee) {
	      var expandGroups = [0];
	      if (this.state.activeEmployees && openActiveEmployee) {
	        expandGroups.push(this.state.activeEmployees[0]);
	        // this.toggleSingleGroupStates(this.state.activeEmployees[0])
	      }
	
	      // this.collapseAllGroupsExcept(expandGroups)
	      this.collapseAllGroupsExcept([0]);
	      // this.toggleGroupStates(false) // collapse all
	      // this.toggleSingleGroupStates(0) // extended unassinned
	      // extende activeEmployee
	    }
	  }, {
	    key: 'toggleGrouped',
	    value: function toggleGrouped() {
	      var groupedStates = {};
	      var grouped = !this.state.grouped;
	      if (grouped) {
	        groupedStates = this.getGroupStates();
	      }
	      this.updateState({
	        grouped: grouped,
	        groupStates: groupedStates
	      });
	    }
	  }, {
	    key: 'toggleWeekOrMonth',
	    value: function toggleWeekOrMonth() {
	      var _this17 = this;
	
	      var view = this.state.view;
	      var currentViewRange = this.state.requestData.CurrentViewRange;
	
	      switch (this.state.view) {
	        case CalendarViews.Month:
	          view = CalendarViews.Week;
	          currentViewRange = (0, _time.formatDate)((0, _moment2.default)().startOf('week'));
	          break;
	        case CalendarViews.Week:
	          view = CalendarViews.Month;
	          currentViewRange = (0, _time.formatDate)((0, _moment2.default)().startOf('week'));
	          break;
	      }
	      // console.log('Start from ', currentViewRange)
	      this.updateState({
	        view: view,
	        requestData: _extends({}, this.state.requestData, { CurrentViewRange: currentViewRange })
	      }, function () {
	        _this17.getCapacityOverview();
	      });
	    }
	
	    /**
	     * Fetch new data from API for selected range for month view
	     * @param {moment} from
	     * @param {moment} to
	     */
	
	  }, {
	    key: 'onRangeUpdated',
	    value: function onRangeUpdated(from, to) {
	      var _this18 = this;
	
	      // console.log('onRangeUpdated', from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
	      var formattedFromDate = (0, _time.formatDate)(from);
	      if (this.state.requestData.CurrentViewRange === formattedFromDate) return;
	      this.setState({
	        requestData: _extends({}, this.state.requestData, {
	          CurrentViewRange: formattedFromDate
	        })
	      }, function () {
	        _this18.getCapacityOverview();
	      });
	    }
	  }, {
	    key: 'onMonthDayClicked',
	    value: function onMonthDayClicked(date) {
	      var _this19 = this;
	
	      // console.log('onMonthDayClicked', date)
	      // Find start of week, and switch to week view starting with that day.
	      var startOfWeek = (0, _moment2.default)(date).startOf('week');
	      this.setState({
	        view: CalendarViews.Week,
	        requestData: _extends({}, this.state.requestData, {
	          CurrentViewRange: (0, _time.formatDate)(startOfWeek)
	        })
	      }, function () {
	        _this19.getCapacityOverview();
	      });
	    }
	  }, {
	    key: 'goToThisWeek',
	    value: function goToThisWeek() {
	      var _this20 = this;
	
	      this.setState({
	        requestData: {
	          CurrentViewRange: (0, _time.formatDate)((0, _moment2.default)().startOf('week'))
	        }
	      }, function () {
	        _this20.getCapacityOverview();
	      });
	    }
	
	    // getHeightStyle () {
	    //   const height = this.state.orderContentHeight + 168   // 68 = footer
	    //   let heightStyle = {
	    //     // height: height > 1 ? height : 'max-content',
	    //     // overflowY: 'auto'
	    //   }
	    //   return heightStyle
	    // }
	    // getScrollStyle () {
	    //   let hideScrollbar = this.state.isFilterSlidePanelOpen || this.state.isTimeLineSlidePanelOpen || this.state.orderContentHeight < 1
	    //   return {
	    //     overflowY: hideScrollbar ? 'hidden' : ''
	    //   }
	    // }
	
	  }, {
	    key: 'getScrollStyle',
	    value: function getScrollStyle() {
	      var hideScrollbar = this.state.isFilterSlidePanelOpen || this.state.isTimeLineSlidePanelOpen;
	      return {
	        overflowY: hideScrollbar ? 'hidden' : ''
	      };
	    }
	  }, {
	    key: 'goTo',
	    value: function goTo(path) {
	      var newPath = _extends({}, this.context.router.location, {
	        pathname: 'OrderCapacityOverview',
	        search: this.context.router.location.pathname
	      });
	      if (path.includes('orders')) {
	        window.LocalstorageStack.push(newPath);
	      }
	
	      if (this.state.selectedTimelineOrderId) {
	        this.saveViewState(this.state.selectedTimelineOrderId, true);
	      }
	
	      this.props.closeOverlay('OrderCapacityOverview');
	      this.onOverlayHide();
	      var sameLocation = this.context.router.location.pathname === path;
	      this.context.router.push(path);
	      if (sameLocation) {
	        window.location.reload();
	      }
	    }
	  }, {
	    key: 'allEmployees',
	    value: function allEmployees(row) {
	      var allEmployees = [];
	      row.Assignments.map(function (assignment) {
	        if (assignment.Employees.length > 0) {
	          assignment.Employees.map(function (employee) {
	            if (allEmployees.findIndex(function (x) {
	              return x.UserId === employee.UserId;
	            }) === -1) {
	              allEmployees.push(employee);
	            }
	          });
	        }
	      });
	      return allEmployees;
	    }
	
	    // renderInfo (row) {
	    //   let allEmployees = this.allEmployees(row)
	    //   if (row.HasUnassignedSteps) {
	    //     return [
	    //       <span className='calendar-order-info__content__alert' key='0'>{translation('17911')}</span>,
	    //       <span key='1' />
	    //     ]
	    //   }
	    //   let firstEmployeeName = ''
	    //   if (allEmployees.length > 0) firstEmployeeName = allEmployees[0].Name
	    //   if (allEmployees.length > 1) {
	    //     return [
	    //       <span key='0' className='ellipsis'>{firstEmployeeName}</span>,
	    //       <span key='1'>+ {(allEmployees.length - 1)}</span>
	    //     ]
	    //   }
	    //   return [
	    //     <span key='0' className='ellipsis'>{firstEmployeeName}</span>
	    //   ]
	    // }
	
	  }, {
	    key: 'renderEmployeeIconAccordion',
	    value: function renderEmployeeIconAccordion(row) {
	      var allEmployees = this.allEmployees(row);
	      var customComponents = allEmployees.map(function (x) {
	        return { customComponent: _avatar2.default, initials: x.Initials, noCircle: true, ariaText: x.Name, ariaPos: 'top-right' };
	      });
	
	      return _react2.default.createElement(_iconAccordion2.default, { icons: customComponents, size: 's' });
	    }
	  }, {
	    key: 'renderAlertIconAccordion',
	    value: function renderAlertIconAccordion(row) {
	      var alertIcons = [];
	      if (row.HasDelayedDeliveryToCustomer || row.HasDelayedDeliveryToPaint) alertIcons.push({ icon: _icons.CapacityManagementIcons.Warning_delayed, noCircle: true });
	      if (row.HasSparePartsNotOrdered) alertIcons.push({ icon: _icons.CapacityManagementIcons.Warning_spare_part, noCircle: true });
	      if (row.IsOrderStopped) alertIcons.push({ icon: _icons.CapacityManagementIcons.Warning_Order_stop, noCircle: true });
	      if (row.HasUnassignedSteps) alertIcons.push({ icon: _icons.CapacityManagementIcons.Warning_assign, noCircle: true });
	
	      if (alertIcons.length > 0) {
	        return _react2.default.createElement(_iconAccordion2.default, { icons: alertIcons, size: 's' });
	      }
	    }
	  }, {
	    key: 'getConflictAlert',
	    value: function getConflictAlert(row) {
	      var hasConflict = row.HasDelayedDeliveryToPaint || row.HasDelayedDeliveryToPaint || row.HasSparePartsNotOrdered || row.IsOrderStopped || row.HasUnassignedSteps;
	      return hasConflict;
	    }
	  }, {
	    key: 'renderLeftSideIcons',
	    value: function renderLeftSideIcons(row) {
	      var hasConflict = this.getConflictAlert(row);
	      var isOrderCompleted = row.Item.CurrentOrderStep === 7; // delivery step
	      if (hasConflict) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'leftSideIcons' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Warning_attention_white, size: 'm' })
	        );
	      }
	      if (isOrderCompleted) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'leftSideIcons' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Completed, size: 'm' })
	        );
	      }
	    }
	  }, {
	    key: 'onAssignUsers',
	    value: function onAssignUsers() {
	      this.refs.AssignBox.getWrappedInstance().getAssignEmployees();
	      this.getCapacityOverview();
	    }
	  }, {
	    key: 'closeAssignBox',
	    value: function closeAssignBox() {
	      var _this21 = this;
	
	      this.setState({
	        assign_open: false
	      }, function () {
	        _this21.getCapacityOverview();
	        _this21.startUpdateInterval();
	      });
	    }
	  }, {
	    key: 'getGroupStates',
	    value: function getGroupStates() {
	      var groupStates = {};
	
	      this.state.assignableEmployees.map(function (x) {
	        groupStates[x.UserId] = true;
	      });
	      groupStates[0] = true;
	      // Object.keys(this.state.groupStates).forEach((key) => {
	      //   // loop state
	      //   groupStates[key] = this.state.groupStates[key]
	      // })
	
	      groupStates = _extends({}, groupStates, this.state.groupStates);
	      return groupStates;
	    }
	
	    /**
	     * Move en element in array
	     * @param {array} input
	     * @param {index} from
	     * @param {index} to
	     */
	
	  }, {
	    key: 'moveElementInArray',
	    value: function moveElementInArray(input, from, to) {
	      var numberOfDeletedElm = 1;
	      var elm = input.splice(from, numberOfDeletedElm)[0];
	      numberOfDeletedElm = 0;
	      input.splice(to, numberOfDeletedElm, elm);
	      return input;
	    }
	  }, {
	    key: 'getGroupedData',
	    value: function getGroupedData() {
	      var _this22 = this;
	
	      // Group by employees
	      // 1. Gather unique employees from row assignment data.
	      var employees = [];
	      if (this.state.filteredOverview && this.state.filteredOverview.Rows) {
	        this.state.filteredOverview.Rows.forEach(function (row) {
	          row.Assignments.forEach(function (assignment) {
	            assignment.Employees.forEach(function (emp) {
	              if (!employees.some(function (e) {
	                return e.UserId === emp.UserId;
	              }) && (_this22.state.filter.selectedEmployees.length === 0 || _this22.state.filter.selectedEmployees.some(function (x) {
	                return x === emp.UserId;
	              }))) {
	                employees.push(emp);
	              }
	            });
	          });
	        });
	      }
	
	      // 2. Gather unique employees from all employees that are assignable and merge them.
	      if (Array.isArray(this.state.assignableEmployees)) {
	        this.state.assignableEmployees.map(function (emp) {
	          if (!employees.some(function (x) {
	            return x.UserId === emp.UserId;
	          }) && (_this22.state.filter.selectedEmployees.length === 0 || _this22.state.filter.selectedEmployees.some(function (x) {
	            return x === emp.UserId;
	          }))) {
	            employees.push(emp);
	          }
	        });
	      }
	
	      // 3. Sort and add special unassigned employee if filter is empty or it is included in filter. (UserId = 0)
	      employees.sort(function (a, b) {
	        return a.Name.localeCompare(b.Name);
	      });
	      if (!this.state.filteredOverview || !this.state.filteredOverview.Rows) {
	        employees.unshift({ UserId: 0, Name: (0, _helpers.translation)(17911) }); // add unassign at the first position.
	      } else {
	        if (this.state.filter.selectedEmployees.length === 0 || this.state.filter.selectedEmployees.some(function (x) {
	          return x === 0;
	        })) {
	          employees.unshift({ UserId: 0, Name: (0, _helpers.translation)(17911) }); // add unassign at the first position.
	        }
	      }
	
	      // 4. Add rows to each group where they belong. (One row can belong to multiple groups)
	      var groupedData = [];
	      employees.forEach(function (e) {
	        var employeeWithRows = { Employee: e, Rows: [] };
	        if (_this22.state.filteredOverview && _this22.state.filteredOverview.Rows) {
	          _this22.state.filteredOverview.Rows.forEach(function (r) {
	            // add unassign data
	            if (r.HasUnassignedSteps && e.UserId === 0) {
	              employeeWithRows.Rows.push(r);
	            }
	            // add assign user data
	            if (r.Assignments.some(function (a) {
	              return a.Employees.some(function (ae) {
	                return ae.UserId === e.UserId;
	              });
	            })) {
	              employeeWithRows.Rows.push(r);
	            }
	          });
	        }
	
	        groupedData.push(employeeWithRows);
	      });
	
	      return groupedData;
	    }
	
	    /**
	     * Collapse all groups while expanding for each user in the userIds array
	     * @param {Array} userIds Provide user ids for which groups should be expanded
	     */
	
	  }, {
	    key: 'collapseAllGroupsExcept',
	    value: function collapseAllGroupsExcept(userIds) {
	      var groupStates = this.state.groupStates;
	      Object.keys(groupStates).forEach(function (key) {
	        groupStates[key] = userIds.some(function (x) {
	          return String(x) === key;
	        });
	      });
	      this.updateState({
	        groupStates: groupStates
	      });
	    }
	  }, {
	    key: 'toggleSingleGroupStates',
	    value: function toggleSingleGroupStates(employeeId) {
	      if (employeeId === undefined) return;
	      this.updateState({ groupStates: _extends({}, this.state.groupStates, _defineProperty({}, employeeId, !this.state.groupStates[employeeId])) });
	    }
	  }, {
	    key: 'toggleGroupStates',
	    value: function toggleGroupStates(expanded) {
	      var groupStates = this.state.groupStates;
	      Object.keys(groupStates).forEach(function (key) {
	        groupStates[key] = expanded;
	      });
	      this.updateState({
	        groupStates: groupStates
	      });
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(row, key) {
	      var _this23 = this;
	
	      var stepsTypes = [1, 2, 3, 4, 5, 9];
	      var statusTypes = [6, 7, 8];
	
	      var getStepTypeClassName = function getStepTypeClassName(type) {
	        return StepClasses[StepTypes[type]];
	      };
	
	      var getUnAssingedStepClass = function getUnAssingedStepClass(step) {
	        return step.NeedAssignment ? 'capacity-calendar-item-step--isUnAssignStep' : '';
	      };
	
	      var getStatusColor = function getStatusColor(status) {
	        return StatusColors[StatusTypes[status]];
	      };
	
	      var orderInfo = _react2.default.createElement(
	        _calendarOrderInfo2.default,
	        { info: row, onHeaderClick: this.openTimelineSlidePanel.bind(this, row.Item.OrderId), active: row.Item.OrderId === this.state.selectedTimelineOrderId },
	        this.renderLeftSideIcons(row),
	        _react2.default.createElement(
	          _grid2.default,
	          { className: 'calendar-order-info__content__info', cols: ['min-content', 1, 'max-content'], align: 'center' },
	          this.renderAlertIconAccordion(row),
	          this.renderEmployeeIconAccordion(row)
	        )
	      );
	
	      var renderMonthlyOrderInfo = _react2.default.createElement(
	        _overviewOrderInfo2.default,
	        { info: row, onHeaderClick: this.openTimelineSlidePanel.bind(this, row.Item.OrderId), orderInfoIcon: this.renderLeftSideIcons(row), active: row.Item.OrderId === this.state.selectedTimelineOrderId },
	        _react2.default.createElement(
	          'div',
	          { className: 'alarm-iccordion' },
	          this.renderAlertIconAccordion(row)
	        ),
	        this.allEmployees(row).length > 0 && _react2.default.createElement(
	          'div',
	          { className: 'assign-iccordion' },
	          this.renderEmployeeIconAccordion(row)
	        )
	      );
	
	      var renderCoatingNotBookedIcon = function renderCoatingNotBookedIcon(type) {
	        if (StepTypes[type] === 'Coating' && row.HasPaintNotBooked) {
	          return _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.warning_painter, size: 's' });
	        }
	      };
	
	      var renderCalendarItemStatus = function renderCalendarItemStatus(step, statusKey) {
	        return step.Status !== 0 && _react2.default.createElement(
	          _calendarItemStatus2.default,
	          { key: statusKey, step: step },
	          _react2.default.createElement(_progressLine2.default, { color: getStatusColor(step.Status), style: { width: '100%' } })
	        );
	      };
	
	      var renderAssignItem = function renderAssignItem(val, key) {
	        if (val.OrderId !== row.Item.OrderId) return;
	        return _react2.default.createElement(_AssignItem2.default, { router: _this23.props.router, key: key, item: val, step: row.Item.CurrentOrderStep, index: key, onAssignUsers: _this23.onAssignUsers, getAssignOrderData: _this23.getAssignOrderData, assignAriaPos: 'bottom-left' });
	      };
	
	      // calender item step content text
	      var itemStepContent = function itemStepContent(step) {
	        if (_this23.state.view === CalendarViews.Month) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'capacity-calendar-item-step__icon' },
	            renderCoatingNotBookedIcon(step.Type)
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'capacity-calendar-item-step__title' },
	              _react2.default.createElement(
	                _inline2.default,
	                { spacing: 0 },
	                step.TextPrimary,
	                renderCoatingNotBookedIcon(step.Type)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'capacity-calendar-item-step__subtitle' },
	              step.TextSecondary
	            )
	          );
	        }
	      };
	
	      var renderCalenderItemSteps = function renderCalenderItemSteps(step, k) {
	        return _react2.default.createElement(
	          _calendarItemStep2.default,
	          { key: k, step: step },
	          _react2.default.createElement(
	            'div',
	            { className: getStepTypeClassName(step.Type) + ' ' + getUnAssingedStepClass(step) },
	            itemStepContent(step)
	          )
	        );
	      };
	
	      // Show week row
	      var thisStepAssignments = this.state.StepAssignments.filter(function (x) {
	        return x.StepId === row.Item.CurrentOrderStep;
	      });
	      var orderAssignments = void 0;
	      if (thisStepAssignments.length > 0) orderAssignments = thisStepAssignments[0].OrderAssignments;
	      // console.log('orderAssignments', orderAssignments)
	      var renderCalenderRowWeek = function renderCalenderRowWeek() {
	        // this.getAssignOrderData(this.props.activeEmployees, row.Item.OrderId)
	        return _react2.default.createElement(
	          _calendarRowWeek2.default,
	          { rowColumns: _this23.state.originalOverview.Days, info: row, orderInfo: orderInfo, key: key },
	          _react2.default.createElement(
	            _calendarItem2.default,
	            { item: row.Item },
	            row.Item.Steps.map(function (step, stepKey) {
	              if (stepsTypes.includes(step.Type)) {
	                return renderCalenderItemSteps(step, stepKey);
	              } else if (statusTypes.includes(step.Type)) {
	                return renderCalendarItemStatus(step, stepKey);
	              }
	            })
	          ),
	          _this23.state.assign_open && orderAssignments && orderAssignments.length > 0 && orderAssignments.map(renderAssignItem)
	        );
	      };
	
	      // Show month row
	      var renderCalenderRowMonth = function renderCalenderRowMonth() {
	        return _react2.default.createElement(
	          _calendarRowMonth2.default,
	          { rowColumns: _this23.state.originalOverview.Days, info: row, orderInfo: renderMonthlyOrderInfo, key: key },
	          _react2.default.createElement(
	            _calendarItem2.default,
	            { item: row.Item },
	            row.Item.Steps.map(function (step, stepKey) {
	              if (stepsTypes.includes(step.Type)) {
	                return renderCalenderItemSteps(step, stepKey);
	              } else if (statusTypes.includes(step.Type)) {
	                return renderCalendarItemStatus(step, stepKey);
	              }
	            })
	          ),
	          _this23.state.assign_open && orderAssignments && orderAssignments.length > 0 && orderAssignments.map(renderAssignItem)
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'row_' + key, 'data-orderId': row.Item.OrderId },
	        this.state.view === CalendarViews.Week && renderCalenderRowWeek(),
	        this.state.view === CalendarViews.Month && renderCalenderRowMonth()
	      );
	    }
	  }, {
	    key: 'renderOrderCount',
	    value: function renderOrderCount() {
	      if (this.state.originalOverview === null || this.state.filteredOverview == null) return;
	      var numberOfactiveOrders = this.state.originalOverview.Rows.length;
	      var numberOfFilteredOrders = this.state.filteredOverview.Rows.length;
	      var text = (0, _helpers.translation)('17910');
	      text = text.replace('[filtered]', numberOfFilteredOrders).replace('[total]', numberOfactiveOrders);
	      return _react2.default.createElement(
	        'span',
	        { className: 'black-h-1-left orders-showing' },
	        text
	      );
	    }
	  }, {
	    key: 'renderFilter',
	    value: function renderFilter() {
	      var _this24 = this;
	
	      var onchange = function onchange(e) {
	        // console.log('e.target.name', e.target.name)
	        if (e !== undefined) {
	          var filter = _this24.state.filter;
	          if (e.target.name === 'unassigned') {
	            filter.unassigned = !_this24.state.filter.unassigned;
	          }
	          if (e.target.name === 'arrived') {
	            filter.arrived = !_this24.state.filter.arrived;
	          }
	          if (e.target.name === 'estimationApproved') {
	            filter.estimationApproved = !_this24.state.filter.estimationApproved;
	          }
	          _this24.saveFilterInStorage(filter);
	          _this24.setState({
	            filter: filter
	          });
	        }
	        _this24.filterOverview();
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'filter-bar' },
	        _react2.default.createElement(_filterBar2.default, { onClose: this.closeFilterBar, onChange: onchange, filter: this.state.filter, openFilterSlidePanel: this.openFilterSlidePanel.bind(this) })
	      );
	    }
	  }, {
	    key: 'renderTopNavigation',
	    value: function renderTopNavigation() {
	      var _this25 = this;
	
	      return _react2.default.createElement(
	        _grid2.default,
	        { cols: ['max-content', 'max-content', 'max-content'], align: 'center' },
	        _react2.default.createElement(_button2.default, { style: 'link', size: 'm', spacing: 0, onClick: function onClick() {
	            return _this25.goTo('/CarRentals/Overview');
	          }, labelText: _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0 },
	            _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.CarRental_Black, size: 's', injectSvg: true }),
	            (0, _helpers.translation)('17902')
	          ) }),
	        _react2.default.createElement(_button2.default, { style: 'link', size: 'm', spacing: 0, onClick: function onClick() {
	            return _this25.goTo('/orders');
	          }, labelText: _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0 },
	            _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.OrderList_Black, size: 's', injectSvg: true }),
	            (0, _helpers.translation)('14876')
	          ) }),
	        _react2.default.createElement(_button2.default, { style: 'link', size: 'm', spacing: 0, onClick: function onClick() {
	            return _this25.goTo('/workscreen');
	          }, labelText: _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0 },
	            _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Chain_Black, size: 's', injectSvg: true }),
	            (0, _helpers.translation)('18')
	          ) })
	      );
	    }
	  }, {
	    key: 'getFooterStyle',
	    value: function getFooterStyle() {
	      var footerheight = {
	        height: this.state.view === CalendarViews.Month ? 32 : 68
	      };
	      return footerheight;
	    }
	  }, {
	    key: 'renderFooterItems',
	    value: function renderFooterItems(group) {
	      var _this26 = this;
	
	      var _state2 = this.state,
	          filteredOverview = _state2.filteredOverview,
	          originalOverview = _state2.originalOverview,
	          grouped = _state2.grouped,
	          filter = _state2.filter;
	
	      var filteredOrderIds = filteredOverview.Rows.map(function (x) {
	        return x.Item.OrderId;
	      });
	      var groupDaysByWeek = originalOverview.Days.reduce(function (group, value) {
	        if (!group[value.Week]) {
	          group[value.Week] = [];
	        }
	        group[value.Week].push(value);
	        return group;
	      }, {});
	
	      // use to get the total minutes <retunr true otherwise false>
	      var getTotalMinutes = function getTotalMinutes(item) {
	        var totalMinutes = 0;
	
	        var _loop2 = function _loop2(i) {
	          var orderId = item.Orders[i].OrderId;
	          if (filteredOrderIds.findIndex(function (x) {
	            return x === orderId;
	          }) !== -1) {
	            item.Orders[i].Assignments.forEach(function (x) {
	              // Add minutes if employee filter is empty or employee of assignment is included in filter
	              if (grouped && group && group.Employee.UserId === x.UserId || !grouped && (!filter.selectedEmployees || filter.selectedEmployees.length === 0 || filter.selectedEmployees.some(function (e) {
	                return e === x.UserId;
	              }))) {
	                totalMinutes += x.AssignedMinutesWithGain;
	              }
	            });
	          }
	        };
	
	        for (var i = 0; i < item.Orders.length; i++) {
	          _loop2(i);
	        }
	        // if (totalMinutes > 0) console.log('item.Date', item.Date, ' Minutes => ', totalMinutes, ' => ', (totalMinutes / 60))
	        return totalMinutes;
	      };
	      // use to get the sum of the total minutes per week <retunr true otherwise false>
	      var getSumOfTotalMinutes = function getSumOfTotalMinutes(week) {
	        var sum = 0;
	        groupDaysByWeek[week].map(function (item) {
	          sum += getTotalMinutes(item);
	        });
	        // console.log('sum of week ', week, ' => ', groupDaysByWeek[week], ' => ', sum)
	        return sum;
	      };
	      var SATURDAY = 6;
	      var SUNDAY = 0;
	
	      // use to check when we need to show total hours <retunr true otherwise false>
	      var canShowTotalHours = function canShowTotalHours(item) {
	        var canShow = false;
	        // console.log('canShowTotalHours', item)
	        // let dayOfWeek = moment(item.Date).isoWeekday()   // Apparently moment is quite slow when being used frequently, moved logic to API.
	        var dayOfWeek = item.DayOfWeek;
	        var isSaturdayAndSundayClosed = IsSaturdayAndSundayClosed(item.Week);
	        if ((dayOfWeek === SATURDAY || dayOfWeek === SUNDAY) && isSaturdayAndSundayClosed) {
	          canShow = true;
	          // this is only used for week
	        } else if (_this26.state.view === CalendarViews.Week && !isSaturdayAndSundayClosed && dayOfWeek === SUNDAY && item.IsClosed) {
	          canShow = true;
	        }
	        return canShow;
	      };
	
	      // use to check if saturday and sunday is closed <retunr true otherwise false
	      var IsSaturdayAndSundayClosed = function IsSaturdayAndSundayClosed(week) {
	        var isBothWeekDaysClosed = false;
	        var isSaturdayClosed = false;
	        var isSundayClosed = false;
	
	        groupDaysByWeek[week].map(function (item) {
	          var dayOfWeek = item.DayOfWeek;
	          if (dayOfWeek === SATURDAY && item.IsClosed) isSaturdayClosed = true;
	          if (dayOfWeek === SUNDAY && item.IsClosed) isSundayClosed = true;
	        });
	
	        isBothWeekDaysClosed = isSaturdayClosed && isSundayClosed;
	        return isBothWeekDaysClosed;
	      };
	
	      return originalOverview.Days.map(function (item, key) {
	        var totalMinutes = getTotalMinutes(item);
	        var hours = Math.trunc(totalMinutes / 60);
	        var classNames = 'calendar-footer__column';
	        if (group && group.Employee.UserId === 0) classNames += ' unassigned';
	        var time = '';
	
	        var canShowTotalHoursForDay = canShowTotalHours(item);
	
	        // Week items
	        if (_this26.state.view === CalendarViews.Week) {
	          // Format minutes to hours/minutes
	          var sumMinutes = getSumOfTotalMinutes(item.Week);
	          var sumTotalHours = Math.trunc(sumMinutes / 60);
	          var sumTotalMinutes = Math.round(sumMinutes) % 60;
	          var minutes = Math.round(totalMinutes) % 60;
	          var hourText = !canShowTotalHoursForDay ? hours : 'Σ' + sumTotalHours;
	          var hourMinut = !canShowTotalHoursForDay ? minutes : sumTotalMinutes;
	          time = hourText + ':' + ('' + hourMinut).padStart(2, '0') + ' ' + (0, _helpers.translation)('17922');
	          classNames += ' weekly';
	        }
	
	        // Month items
	        if (_this26.state.view === CalendarViews.Month) {
	          // console.log(item.Date)
	          time = Math.round(totalMinutes / 60);
	          if (canShowTotalHoursForDay) {
	            var totalHours = Math.round(getSumOfTotalMinutes(item.Week) / 60);
	            time = 'Σ' + totalHours + '' + (0, _helpers.translation)('17922');
	          }
	
	          // hours = Math.round(totalMinutes / 60)
	          // time = !canShowTotalHoursForDay ? hours : 'Σ' + totalHours + '' + translation('17922')
	          classNames += ' monthly';
	        }
	
	        if (item.IsClosed) {
	          var isBothWeekDaysClosed = IsSaturdayAndSundayClosed(item.Week);
	          classNames += ' closed';
	          var dayOfWeek = item.DayOfWeek;
	          if (dayOfWeek === SATURDAY && isBothWeekDaysClosed) classNames += ' saturday-longweek';
	          if (dayOfWeek === SUNDAY && isBothWeekDaysClosed) {
	            classNames += ' sunday-longweek';
	            time = '';
	          }
	        }
	        var isEmployeeAssignable = !group || group.Employee.UserId === 0 || _this26.state.employeesMap[group.Employee.UserId] && _this26.state.employeesMap[group.Employee.UserId].IsAssignableToOrders;
	
	        // console.log('render footer: ', this.state)
	        var isBeforeToday = item.Date < _this26.today;
	        time = item.IsClosed && !canShowTotalHoursForDay ? '' : time;
	        var defaultAssignToSteps = [_constants.OrderSteps.NEW_ORDER, _constants.OrderSteps.DISASSEMBLY, _constants.OrderSteps.REPAIR, _constants.OrderSteps.ASSEMBLY, _constants.OrderSteps.BODY_FINISHING, _constants.OrderSteps.DELIVERY];
	        return _react2.default.createElement(
	          'div',
	          { className: classNames, key: key },
	          _react2.default.createElement(
	            'div',
	            { className: 'calendar-footer__minute' },
	            time,
	            !item.IsClosed && !isBeforeToday && _this26.state.grouped && isEmployeeAssignable && _react2.default.createElement(
	              'div',
	              { className: 'create-draft-btn', onClick: _this26.createDraft.bind(_this26, item.Date, group.Employee, defaultAssignToSteps) },
	              '+'
	            ),
	            !item.IsClosed && !isBeforeToday && !_this26.state.grouped && isEmployeeAssignable && _react2.default.createElement(
	              'div',
	              { className: 'create-draft-btn', onClick: _this26.createDraft.bind(_this26, item.Date, { UserId: 0 }, defaultAssignToSteps) },
	              '+'
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderHeaderIcons',
	    value: function renderHeaderIcons() {
	      var _this27 = this;
	
	      var style = this.state.isActiveFilter ? 'active' : 'link';
	      return _react2.default.createElement(
	        'div',
	        { className: 'headerIcons' },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: ['max-content', 'max-content', 'max-content'], align: 'center' },
	          _react2.default.createElement(_circleButton2.default, { onClick: function onClick() {
	              return _this27.triggerClickAssign();
	            }, icon: _icons.CapacityManagementIcons.Assign }),
	          ' ',
	          _react2.default.createElement(_circleButton2.default, { style: style, onClick: function onClick() {
	              return _this27.openFilterBar();
	            }, icon: _icons.CapacityManagementIcons.Filter }),
	          ' ',
	          _react2.default.createElement(_circleButton2.default, { onClick: function onClick() {
	              return _this27.openInfoBar();
	            }, icon: _icons.CapacityManagementIcons.info }),
	          ' '
	        )
	      );
	    }
	  }, {
	    key: 'renderCalendarHeaderButtons',
	    value: function renderCalendarHeaderButtons() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'buttons' },
	        _react2.default.createElement(_circleButton2.default, { size: 'm', icon: _icons.CapacityManagementIcons.List_View, onClick: this.toggleGrouped }),
	        _react2.default.createElement(_circleButton2.default, { size: 'm', icon: _icons.CapacityManagementIcons.Calendar, onClick: this.toggleWeekOrMonth })
	      );
	    }
	  }, {
	    key: 'renderContentList',
	    value: function renderContentList() {
	      var hasData = this.state.originalOverview !== null && this.state.originalOverview.Rows !== undefined && this.state.filteredOverview !== null && this.state.filteredOverview.Rows !== undefined;
	      return _react2.default.createElement(
	        _calendarContent2.default,
	        { style: { height: this.state.totalCalendarRowsContentHeight }, ignoreHeight: this.state.topNodeHeight },
	        _react2.default.createElement(
	          'div',
	          { ref: 'calendarRowRef', className: 'calendar-container' },
	          hasData && this.state.filteredOverview.Rows.map(this.renderRow)
	        )
	      );
	    }
	  }, {
	    key: 'renderContentGrouped',
	    value: function renderContentGrouped() {
	      var _this28 = this;
	
	      var hasData = this.state.originalOverview !== null && this.state.originalOverview.Rows !== undefined && this.state.filteredOverview !== null && this.state.filteredOverview.Rows !== undefined;
	      var groupedData = this.getGroupedData();
	      if (groupedData === null || groupedData.length === 0) return;
	      var allGroupsExpanded = Object.keys(this.state.groupStates).every(function (x) {
	        return _this28.state.groupStates[x];
	      });
	
	      var newGroupeData = groupedData;
	      if (this.state.activeEmployees && this.state.assign_open) {
	        var elmIndex = groupedData.findIndex(function (x) {
	          return x.Employee.UserId === _this28.state.activeEmployees[0];
	        });
	        // console.log('renderContentGrouped, groupedData', groupedData)
	        var destinationIndex = groupedData[0].Employee.UserId === 0 ? 1 : 0; // If first empl. is 'unassigned', move active employee below (to index 1), otherwise, move to top (index 0).
	        if (elmIndex > -1) {
	          newGroupeData = this.moveElementInArray(groupedData, elmIndex, destinationIndex);
	        }
	      }
	
	      var renderControls = function renderControls(employee) {
	        var groupExpanded = _this28.state.groupStates[employee.UserId];
	        // let footerClasses = 'calendar-row-group-footer-container' + (!groupFoldState || !thisEmployeeState ? ' headindFooter' : '')
	        return _react2.default.createElement(
	          'div',
	          { className: 'fold-controls' },
	          allGroupsExpanded && _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Group_Arrow_Down, size: 't', onClick: _this28.toggleGroupStates.bind(_this28, false), injectSvg: true }),
	          !allGroupsExpanded && _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Group_Arrow_Right, size: 't', onClick: _this28.toggleGroupStates.bind(_this28, true), injectSvg: true }),
	          groupExpanded && _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Arrow_Down, size: 't', onClick: _this28.toggleSingleGroupStates.bind(_this28, employee.UserId), injectSvg: true }),
	          !groupExpanded && _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Arrow_Right, size: 't', onClick: _this28.toggleSingleGroupStates.bind(_this28, employee.UserId), injectSvg: true })
	        );
	      };
	
	      var renderEmployeeInfo = function renderEmployeeInfo(employee) {
	        var icon = _react2.default.createElement(_avatar2.default, { size: 's', initials: employee.Initials });
	        if (employee.UserId === 0) {
	          icon = _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Warning_assign, size: 's', injectSvg: true });
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'employee-group-heading' },
	          icon,
	          _react2.default.createElement(
	            'span',
	            null,
	            employee.Name
	          )
	        );
	      };
	
	      var getGroupBoxClasses = function getGroupBoxClasses() {
	        // use to adjust the last box height
	        return _this28.state.assign_open ? 'group-box' : '';
	      };
	
	      // const getCustomFooterStyle = (groupFoldState, thisEmployeeState) => {
	      //   if (this.state.view === CalendarViews.Week) {
	      //     footerClasses += !groupFoldState || !thisEmployeeState ? ' headindFooter-week' : ''
	      //   }
	      //   if (this.state.view === CalendarViews.Month) {
	      //     footerClasses += !groupFoldState || !thisEmployeeState ? ' headindFooter-month' : ''
	      //   }
	      //   return footerClasses
	      // }
	      return _react2.default.createElement(
	        _calendarContent2.default,
	        { style: { height: this.state.totalCalendarRowsContentHeight }, ignoreHeight: this.state.topNodeHeight },
	        _react2.default.createElement(
	          'div',
	          { ref: 'calendarRowRef', className: 'calendar-container' },
	          hasData && newGroupeData.map(function (group) {
	            var thisEmployeeState = _this28.state.groupStates[group.Employee.UserId];
	            return _react2.default.createElement(
	              'div',
	              { key: 'group_' + group.Employee.UserId, className: getGroupBoxClasses() },
	              _react2.default.createElement(
	                _calendarRowGroup2.default,
	                { renderInfo: renderEmployeeInfo.bind(_this28, group.Employee), renderControls: renderControls.bind(_this28, group.Employee), open: thisEmployeeState },
	                group.Rows.map(_this28.renderRow)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'calendar-row-group-footer-container', ref: 'calendarGroupFooterRef' },
	                _react2.default.createElement(
	                  _calendarFooter2.default,
	                  { height: _this28.getFooterStyle(), footerItems: _this28.state.originalOverview.Days },
	                  _this28.renderFooterItems(group)
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this29 = this;
	
	      var originalOverview = this.state.originalOverview;
	      var hasData = this.state.originalOverview !== null && this.state.originalOverview.Rows !== undefined && this.state.filteredOverview !== null && this.state.filteredOverview.Rows !== undefined;
	      var hiddecrollStyle = function hiddecrollStyle() {
	        if (_this29.state.isFilterSlidePanelOpen || _this29.state.isTimeLineSlidePanelOpen) {
	          return ' overlay-overflow';
	        }
	        return '';
	      };
	      var footerBoxClass = function footerBoxClass() {
	        return _this29.state.assign_open && _this29.state.view === CalendarViews.Month ? 'month-footer-box' : '';
	      };
	      var closeCreateDraftPopup = function closeCreateDraftPopup() {
	        _this29.setState({ createDraft: _extends({}, _this29.state.createDraft, { open: false }) });
	        _this29.startUpdateInterval();
	      };
	
	      return _react2.default.createElement(
	        _overlay2.default,
	        { overlayId: 'OrderCapacityOverview', extraClassName: 'orderCapacityOverview' + hiddecrollStyle(), onShow: this.onOverlayShow, onHide: this.onOverlayHide },
	        _react2.default.createElement(
	          _OverlayHeaderBare2.default,
	          {
	            overlayId: 'OrderCapacityOverview',
	            closeButton: true,
	            onClose: this.resetCapacityOverview
	          },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: ['min-content', 'max-content', 'max-content', '2fr'], align: 'center' },
	            _react2.default.createElement(_icon2.default, { icon: _icons.GeneralIcons.Apromas_Logo, size: 'l' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'black-h-1-left' },
	              (0, _helpers.translation)('17912')
	            ),
	            this.renderTopNavigation(),
	            this.renderHeaderIcons(),
	            false && _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: 'Fjern mig!' },
	              _react2.default.createElement(_datetime2.default, {
	                closeOnSelect: true,
	                timeFormat: 'HH:mm',
	                value: '',
	                name: 'Date',
	                onBlur: function onBlur(t) {
	                  return _this29.setState({ currentTime: t._d });
	                }
	              })
	            ) /* FOR DEBUG! */
	          )
	        ),
	        _react2.default.createElement(
	          _overlayContent2.default,
	          { noScroll: true },
	          _react2.default.createElement(
	            'div',
	            { className: 'content', ref: 'overlayContent' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content__calendar-filter', ref: 'topNode' },
	              this.state.showInfoBar && _react2.default.createElement(_infoBar2.default, { onClose: this.closeInfoBar }),
	              this.state.showFilterBar && this.renderFilter()
	            ),
	            _react2.default.createElement(
	              _calendar2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'calendar-header-container', ref: 'calendarHeaderRef' },
	                hasData && _react2.default.createElement(_calendarHeader2.default, { headerItems: originalOverview.Days, viewMode: this.state.view === CalendarViews.Month ? 'month' : 'week', onRangeUpdated: this.onRangeUpdated, onItemClick: this.onMonthDayClicked, showFromDate: (0, _moment2.default)(this.state.requestData.CurrentViewRange), renderButtons: this.renderCalendarHeaderButtons })
	              ),
	              this.state.grouped && this.renderContentGrouped() || this.renderContentList(),
	              _react2.default.createElement(
	                'div',
	                { className: 'calendar-footer-container', ref: 'calendarFooterRef' },
	                hasData && !this.state.grouped && _react2.default.createElement(
	                  'div',
	                  { className: footerBoxClass() },
	                  _react2.default.createElement(
	                    _calendarFooter2.default,
	                    { height: this.getFooterStyle(), footerItems: originalOverview.Days },
	                    this.renderFooterItems(null)
	                  )
	                ),
	                hasData && this.state.assign_open && _react2.default.createElement(
	                  'div',
	                  { className: this.state.view === CalendarViews.Month ? 'AssignBox-month' : 'AssignBox-week' },
	                  _react2.default.createElement(_AssignBox2.default, { router: this.props.router, ref: 'AssignBox', closeAssign: function closeAssign() {
	                      _this29.closeAssignBox();
	                    }, onEmployeeChange: this.triggerAssignEmployee, assignAriaPos: 'left', hideHeader: true })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_FilterSlidePanel2.default, {
	            data: this.state.originalOverview,
	            view: this.state.filterPanelView,
	            filterStatus: this.state.filter,
	            onClose: this.closeFilterSlidePanel.bind(this),
	            filterOverview: this.filterOverview,
	            filterCollection: this.filterRows
	          }),
	          _react2.default.createElement(_TimelineSlidePanel2.default, {
	            orderId: this.state.selectedTimelineOrderId,
	            onClose: this.closeTimelineSlidePanel,
	            filterOverview: this.filterOverview,
	            currentTime: this.state.currentTime // FOR DEBUG!
	            , openWorkcard: this.goTo
	          })
	        ),
	        _react2.default.createElement(_scrollToTop2.default, { elementToScrollToClassName: 'element-overlay' }),
	        _react2.default.createElement(_NewOrdersModal2.default, { router: this.context.router,
	          show: this.state.createDraft.open,
	          options: _extends({}, this.state.createDraft, { bookingDestination: 'capacityoverview' }),
	          onClose: closeCreateDraftPopup,
	          onDraftCreated: this.onDraftCreated,
	          bodyShop: true })
	      );
	    }
	  }]);
	
	  return OrderCapacityOverview;
	}(_react.Component);
	
	OrderCapacityOverview.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    activeEmployees: state.assign.activeEmployees
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getCapacityOverview: _calendarOverview.getCapacityOverview,
	  closeOverlay: _common.closeOverlay,
	  openSlidePanel: _common.openSlidePanel,
	  closeSlidePanel: _common.closeSlidePanel,
	  getOrderDataNew: _assign.getOrderDataNew,
	  setEmployees: _assign.setEmployees,
	  getEmployees: _employees.getEmployees
	})(OrderCapacityOverview);

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * @module utils/filter
	                                                                                                                                                                                                                                                                               */
	
	
	exports.isFilterChanged = isFilterChanged;
	exports.isFilterNameChanged = isFilterNameChanged;
	exports.makeContains = makeContains;
	exports.advancedSearch = advancedSearch;
	exports.filterSearch = filterSearch;
	exports.filterCustomer = filterCustomer;
	exports.filterColor = filterColor;
	exports.filterVehicle = filterVehicle;
	exports.filterDelivery = filterDelivery;
	exports.filterIdentification = filterIdentification;
	exports.getOrderFilterData = getOrderFilterData;
	
	var _lodash = __webpack_require__(27);
	
	var _auth = __webpack_require__(8);
	
	var _time = __webpack_require__(17);
	
	/**
	 * @description Checks if filter is changed
	 */
	function isFilterChanged(authObject, simplesearch, filter, initialFilter) {
	  // console.log('IsFilterChanged: simple:', simplesearch, 'filter: ', filter, 'initial:', initialFilter)
	  if (simplesearch !== undefined && simplesearch !== null && simplesearch !== '') {
	    return true;
	  }
	  var filterNames = ['color', 'customer', 'delivery', 'evaluation', 'external_control', 'invoice', 'invoicing', 'movedOrders', 'orderType', 'parts', 'process', 'update', 'vehicle', 'customergroup_customergroupid', 'pricemodel_pricemodelid', 'HasPaintWork', 'HasBodyWork', 'NewOrdersFilter', 'AssignedToMe'];
	  var foundIndex = -1;
	  for (var i = 0; i < filterNames.length; i++) {
	    if (isFilterNameChanged(authObject, filterNames[i], filter, initialFilter)) {
	      foundIndex = i;
	      break;
	    }
	  }
	  return foundIndex > -1;
	}
	function isFilterNameChanged(authObject, name, filter, initialFilter) {
	  if (filter === null) return false;
	  if ((0, _auth.hasAccess)([4], authObject.user.UserType)) {
	    initialFilter.process.Completed = false;
	    initialFilter.process.CompletedThisWeek = false;
	  } else {
	    initialFilter.process.Completed = false;
	    // initialFilter.process.CompletedThisWeek = true  // Should be set in reducer state
	  }
	  if ((0, _auth.hasAccess)([6], authObject.user.UserType)) {
	    initialFilter.process.draft1 = false;
	    initialFilter.process.draft2 = false;
	    initialFilter.process.draft = false;
	  }
	  var checker = filter[name];
	  if ((typeof checker === 'undefined' ? 'undefined' : _typeof(checker)) === 'object') {
	    var checkState = JSON.parse(JSON.stringify(initialFilter[name]));
	    if (authObject.user.CustomerId !== '-1') {
	      if (typeof checkState['external_control'] !== 'undefined' || typeof checker['external_control'] !== 'undefined') {
	        delete checkState['external_control'];
	        delete checker['external_control'];
	      }
	      if (typeof checkState['invoicing'] !== 'undefined' || typeof checker['invoicing'] !== 'undefined') {
	        delete checkState['invoicing'];
	        delete checker['invoicing'];
	      }
	      if (typeof checkState['customer'] !== 'undefined' || typeof checker['customer'] !== 'undefined') {
	        delete checkState['customer'];
	        delete checker['customer'];
	      }
	      if (name === 'update') {
	        delete checkState['missing'];
	        delete checker['missing'];
	      }
	      if (name === 'delivery') {
	        delete checkState['production'];
	        delete checker['production'];
	      }
	      if (name === 'color') {
	        delete checkState['amount'];
	        delete checker['amount'];
	      }
	      if (typeof checkState['customergroup_customergroupid'] !== 'undefined' || typeof checker['customergroup_customergroupid'] !== 'undefined') {
	        delete checkState['customergroup_customergroupid'];
	        delete checker['customergroup_customergroupid'];
	      }
	      if (typeof checkState['pricemodel_pricemodelid'] !== 'undefined' || typeof checker['pricemodel_pricemodelid'] !== 'undefined') {
	        delete checkState['pricemodel_pricemodelid'];
	        delete checker['pricemodel_pricemodelid'];
	      }
	    }
	    return !(0, _lodash.isEqual)(checkState, checker);
	  } else {
	    var _checkState = initialFilter[name];
	    if (name === 'orderType' || name === 'HasBodyWork' || name === 'HasPaintWork' || name === 'NewOrdersFilter') {
	      return checker !== _checkState;
	    }
	    if (filter !== undefined && (filter.customergroup !== undefined && filter.customergroup.CustomerGroupId !== -1 || filter.pricemodel !== undefined && filter.pricemodel.PriceModelId !== -1)) return true;
	    return !checker === _checkState;
	  }
	}
	
	/**
	 * @description Checks if value is empty and pushes it to array
	 * @param  {String} value Value to check
	 * @param  {Array} array Array to push to
	 * @return {Array} Returns array
	 */
	function shouldPushToArray(value, array) {
	  if (value === '') {
	    return array;
	  }
	  array.push(value);
	  return array;
	}
	
	/**
	 * @description Makes a contains string
	 * @param  {String} text Filter request name
	 * @param  {String} value Value to search for
	 * @param  {Integer} option Include, Empty, Filled, Exclude
	 * @return {String} Returns a contains string
	 */
	function makeContains(text, value, option) {
	  if (option === 1 || option === 4) {
	    if (text === '') {
	      return '';
	    }
	  }
	  var testing = '';
	  switch (option) {
	    case 2:
	      return '(' + value + ' eq null)';
	    case 3:
	      return '(' + value + ' ne null)';
	    case 4:
	      testing = ' eq false';
	      break;
	  }
	  return '(contains(tolower(' + value + '), tolower(\'' + text + '\'))' + testing + ')';
	}
	
	/**
	 * @description Makes a greater/less than string
	 * @param  {Object} data Object containing start/end
	 * @param  {String} freq Filter request name
	 * @return {String} Returns a greater/less than string
	 */
	function makeGreaterLessThan(data, freq) {
	  var wrapper = [];
	  if (data.start !== '') {
	    if ((0, _time.renderDateTime)(data.start, '00:00:00') !== '') {
	      wrapper.push(freq + ' gt ' + (0, _time.renderDateTime)(data.start, '00:00:00'));
	    }
	  }
	  if (data.end !== '') {
	    if ((0, _time.renderDateTime)(data.end, '23:59:59') !== '') {
	      wrapper.push(freq + ' lt ' + (0, _time.renderDateTime)(data.end, '23:59:59'));
	    }
	  }
	  if (wrapper.length !== 0) {
	    return '(' + wrapper.join(' and ') + ')';
	  } else {
	    return '';
	  }
	}
	
	/**
	 * @description Advanced search
	 * @param  {Object} data Object containing data to use for filtering
	 * @return {String} Returns filtering string
	 */
	function advancedSearch(data) {
	  var arraySearch = [];
	  // WP Invoiced
	  if (typeof data.wpinvoice !== 'undefined') {
	    switch (data.wpinvoice) {
	      case 'hasInvoiced':
	        arraySearch.push('(HasInvoiced eq true)');
	        break;
	      case 'hasNotInvoiced':
	        arraySearch.push('(HasNotInvoiced eq true)');
	        break;
	    }
	  }
	  // CustomerGroup
	  if (typeof data.customerGroup !== 'undefined') {
	    if (data.customerGroup.customerGroupId !== '0') {
	      arraySearch.push('(CustomerGroupId eq \'' + data.customerGroup.customerGroupId + '\')');
	    }
	  }
	
	  // PriceModel
	  if (typeof data.priceModel !== 'undefined') {
	    if (data.priceModel.priceModelId !== '0') {
	      arraySearch.push('(PriceModelId eq \'' + data.priceModel.priceModelId + '\')');
	    }
	  }
	
	  // OrderType
	  if (typeof data.orderType !== 'undefined') {
	    if (data.orderType !== '0') {
	      arraySearch.push('(OrderType eq \'' + data.orderType + '\')');
	    }
	  }
	
	  // Process step
	  if (typeof data.process !== 'undefined') {
	    switch (data.process.step) {
	      case 'completed':
	        arraySearch.push('(IsCompleted eq true)');
	        break;
	      case 'inprocess':
	        arraySearch.push('(IsInProcess eq true)');
	        break;
	    }
	  }
	
	  // Evaluation
	
	  // Update
	  if (typeof data.update !== 'undefined') {
	    if (data.update.updated) {
	      arraySearch.push('(IsUpdated eq true)');
	    }
	  }
	
	  // Identification
	  if (typeof data.identification !== 'undefined') {
	    if (filterIdentification(data.identification) !== '') {
	      arraySearch.push(filterIdentification(data.identification));
	    }
	  }
	
	  // Delivery
	  if (typeof data.delivery !== 'undefined') {
	    if (filterDelivery(data.delivery) !== '') {
	      arraySearch.push(filterDelivery(data.delivery));
	    }
	  }
	
	  // Vehicle data
	  if (typeof data.vehicle !== 'undefined') {
	    if (filterVehicle(data.vehicle) !== '') {
	      arraySearch.push(filterVehicle(data.vehicle));
	    }
	  }
	
	  // Color
	  if (typeof data.color !== 'undefined') {
	    if (filterColor(data.color) !== '') {
	      arraySearch.push(filterColor(data.color));
	    }
	  }
	
	  // Customer
	  if (typeof data.customer !== 'undefined') {
	    if (filterCustomer(data.customer) !== '') {
	      arraySearch.push(filterCustomer(data.customer));
	    }
	  }
	
	  var searchTerm = '';
	  if (arraySearch.length !== 0) {
	    searchTerm = arraySearch.join(' and ');
	  }
	
	  // Draft
	  if (typeof data.process !== 'undefined') {
	    if (data.process.draft || data.process.step === 'all') {
	      var _searchTerm = arraySearch.join(' and ');
	      if (_searchTerm !== '') {
	        return '(IsDraft eq true) or (' + _searchTerm + ')';
	      } else {
	        return _searchTerm;
	      }
	    }
	  }
	  return searchTerm;
	}
	
	/**
	 * @description Makes a string for filtering Odata orders
	 * @param  {String} search Text to search for
	 * @return {String} Returns transformed text
	 */
	function filterSearch(search) {
	  if (!search) return '';
	
	  search = search.replace(/\s+/g, ' ');
	  if (search && search !== ' ') {
	    var arraySearch = [];
	    if (!isNaN(search)) {
	      arraySearch.push('(Id eq ' + search + ')');
	    }
	    arraySearch.push(makeContains(search, 'RekvNumber', 1));
	    arraySearch.push(makeContains(search, 'Color', 1));
	    arraySearch.push(makeContains(search, 'ColorCode', 1));
	    arraySearch.push(makeContains(search, 'ColorVariant', 1));
	    arraySearch.push(makeContains(search, 'RegNumber', 1));
	    arraySearch.push(makeContains(search, 'Model', 1));
	    arraySearch.push(makeContains(search, 'BrandOriginal', 1));
	    arraySearch.push(makeContains(search, 'ChassisNumber', 1));
	    return arraySearch.join(' or ');
	  } else {
	    return '';
	  }
	}
	
	/**
	 * @description Makes a string for filtering customer
	 * @param  {Object} customerData Object with data about customer value and options
	 * @return {String} Returns filtering string
	 */
	function filterCustomer(customerData) {
	  if (Object.keys(customerData).length === 0) return '';
	
	  var arraySearch = [];
	
	  // customerData.name
	  if (typeof customerData.name !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(customerData.name.value, 'CustomerName', customerData.name.option), arraySearch);
	  }
	
	  // customerData.city
	  if (typeof customerData.city !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(customerData.city.value, 'CustomerCity', customerData.city.option), arraySearch);
	  }
	
	  // customerData.zipcode
	  if (typeof customerData.zipcode !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(customerData.zipcode.value, 'CustomerZip', customerData.zipcode.option), arraySearch);
	  }
	
	  // customerData.phone
	  if (typeof customerData.phone !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(customerData.phone.value, 'CustomerPhone', customerData.phone.option), arraySearch);
	  }
	
	  // customerData.contact_name
	  if (typeof customerData.contact_name !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(customerData.contact_name.value, 'Contact', customerData.contact_name.option), arraySearch);
	  }
	
	  if (arraySearch.length === 0) {
	    return '';
	  }
	  return '(' + arraySearch.join(' and ') + ')';
	}
	
	/**
	 * @description Makes a string for filtering color
	 * @param  {Object} colorData Object with data about color value and options
	 * @return {String} Returns filtering string
	 */
	function filterColor(colorData) {
	  if (Object.keys(colorData).length === 0) return '';
	
	  var arraySearch = [];
	
	  // colorData.color
	  if (typeof colorData.color !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(colorData.color.value, 'Color', colorData.color.option), arraySearch);
	  }
	
	  // colorData.code
	  if (typeof colorData.code !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(colorData.code.value, 'ColorCode', colorData.code.option), arraySearch);
	  }
	
	  // colorData.ctype
	  if (typeof colorData.ctype !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(colorData.ctype.value, 'ColorVariant', colorData.ctype.option), arraySearch);
	  }
	
	  // colorData.amount
	  if (typeof colorData.amount !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(colorData.amount.value, 'ColorAmount', colorData.amount.option), arraySearch);
	  }
	
	  if (arraySearch.length === 0) {
	    return '';
	  }
	  return '(' + arraySearch.join(' or ') + ')';
	}
	
	/**
	 * @description Makes a string for filtering vehicle data
	 * @param  {Object} vehicleData Object with data about vehicle data value and options
	 * @return {String} Returns filtering string
	 */
	function filterVehicle(vehicleData) {
	  if (Object.keys(vehicleData).length === 0) return '';
	
	  var arraySearch = [];
	
	  // vehicleData.regnumber
	  if (typeof vehicleData.regnumber !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(vehicleData.regnumber.value, 'RegNumber', vehicleData.regnumber.option), arraySearch);
	  }
	
	  // vehicleData.brand
	  if (typeof vehicleData.brand !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(vehicleData.brand.value, 'BrandOriginal', vehicleData.brand.option), arraySearch);
	  }
	
	  // vehicleData.model
	  if (typeof vehicleData.model !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(vehicleData.model.value, 'Model', vehicleData.model.option), arraySearch);
	  }
	
	  // vehicleData.year
	  if (typeof vehicleData.year !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(vehicleData.year.value, 'RegistrationDate', vehicleData.year.option), arraySearch);
	  }
	
	  if (arraySearch.length === 0) {
	    return '';
	  }
	  return '(' + arraySearch.join(' or ') + ')';
	}
	
	/**
	 * @description Makes a string for filtering delivery data
	 * @param  {Object} deliveryData Object with data about delivery data value and options
	 * @return {String} Returns filtering string
	 */
	function filterDelivery(deliveryData) {
	  if (Object.keys(deliveryData).length === 0) return '';
	  var arraySearch = [];
	
	  // deliveryData.delivery
	  if (typeof deliveryData.delivery !== 'undefined') {
	    var delivery = makeGreaterLessThan(deliveryData.delivery, 'Delivery');
	    arraySearch = shouldPushToArray(delivery, arraySearch);
	  }
	
	  // deliveryData.production
	  if (typeof deliveryData.production !== 'undefined') {
	    var production = makeGreaterLessThan(deliveryData.production, 'ProductionDate');
	    arraySearch = shouldPushToArray(production, arraySearch);
	  }
	
	  // deliveryData.pickup
	  if (typeof deliveryData.pickup !== 'undefined') {
	    var pickup = makeGreaterLessThan(deliveryData.pickup, 'Pickup');
	    arraySearch = shouldPushToArray(pickup, arraySearch);
	  }
	
	  // deliveryData.transport
	  if (typeof deliveryData.transport !== 'undefined') {
	    if (deliveryData.transport !== 0) {
	      arraySearch.push('(Transport eq ' + deliveryData.transport + ')');
	    }
	  }
	
	  if (arraySearch.length === 0) {
	    return '';
	  }
	  return '(' + arraySearch.join(' and ') + ')';
	}
	
	/**
	 * @description Makes a string for filtering identification data
	 * @param  {Object} identificationData Object with data about identification data value and options
	 * @return {String} Returns filtering string
	 */
	function filterIdentification(identificationData) {
	  if (Object.keys(identificationData).length === 0) return '';
	  var arraySearch = [];
	
	  // identificationData.ordernumber
	  if (typeof identificationData.ordernumber !== 'undefined') {
	    if (identificationData.ordernumber.value !== '') {
	      switch (identificationData.ordernumber.option) {
	        case 1:
	          arraySearch.push('(Id eq ' + identificationData.ordernumber.value + ')');
	          break;
	        case 2:
	          arraySearch.push('(Id eq null)');
	          break;
	        case 3:
	          arraySearch.push('(Id ne null)');
	          break;
	        case 4:
	          arraySearch.push('(Id ne ' + identificationData.ordernumber.value + ')');
	          break;
	      }
	    }
	  }
	
	  // identificationData.rekvnumber
	  if (typeof identificationData.rekvnumber !== 'undefined') {
	    arraySearch = shouldPushToArray(makeContains(identificationData.rekvnumber.value, 'RekvNumber', identificationData.rekvnumber.option), arraySearch);
	  }
	
	  if (arraySearch.length === 0) {
	    return '';
	  }
	  return '(' + arraySearch.join(' and ') + ')';
	}
	
	/**
	 *
	 * @param {*} props
	 * stored datat from this.props
	 * @returns obeject that contains source, filter, simpleSearch, hasSimpleSearch
	 *
	 */
	function getOrderFilterData(props) {
	  // console.log('getfilter props', props)
	  var filter = _extends({}, props.filter);
	  var source = 'orderlist';
	  // sourcePage = props.source === undefined ? sourcePage : source
	  if ((0, _auth.hasAccess)([4], props.auth.user.UserType)) {
	    source = 'customer';
	  } else if ((0, _auth.hasAccess)([6], props.auth.user.UserType)) {
	    source = 'wp';
	  } else if (props.source === 'workscreen') {
	    source = 'workscreen';
	  }
	
	  // get filter from local storage if no filter active/ refresh page
	  if ((0, _lodash.isEqual)(props.filter, props.initialFilter)) {
	    var storedFilter = JSON.parse(window.localStorage.getItem('filterOrderlist'));
	    if ((0, _auth.hasAccess)([4], props.auth.user.UserType)) {
	      storedFilter = JSON.parse(window.localStorage.getItem('filterCustomer'));
	    } else if ((0, _auth.hasAccess)([6], props.auth.user.UserType)) {
	      storedFilter = JSON.parse(window.localStorage.getItem('filterWP'));
	    } else if (props.source === 'workscreen') {
	      storedFilter = JSON.parse(window.localStorage.getItem('filterWorkscreen'));
	    }
	    if (storedFilter !== undefined && storedFilter !== null && storedFilter.delivery !== undefined) {
	      filter = storedFilter;
	    }
	  }
	
	  // Final check to make sure we have a filter
	  if (filter === undefined || filter === null || (0, _lodash.isEqual)(filter, { NewOrdersFilter: 0 })) {
	    filter = props.initialFilter;
	  }
	
	  // get simple search from local storage if none active/ page refresh
	  var simpleSearch = props.simplesearch;
	  var storedSimpleSearch = '';
	  if (props.source === 'workscreen') {
	    storedSimpleSearch = JSON.parse(window.localStorage.getItem('simplesearchWorkscreen'));
	    // console.log('getfilter simplesearchWorkscreen', storedSimpleSearch)
	  } else {
	    storedSimpleSearch = JSON.parse(window.localStorage.getItem('simpleSearch'));
	    // console.log('getfilter storedSimpleSearch', storedSimpleSearch)
	  }
	  if (storedSimpleSearch !== '') {
	    simpleSearch = storedSimpleSearch;
	  }
	
	  var hasSimpleSearch = false;
	  if (simpleSearch !== undefined && simpleSearch !== null && simpleSearch.value !== undefined && simpleSearch.value !== null && simpleSearch.value.length > 0) {
	    hasSimpleSearch = true;
	  }
	
	  var data = {
	    source: source,
	    filter: filter,
	    simpleSearch: simpleSearch,
	    hasSimpleSearch: hasSimpleSearch
	    // console.log('getOrderFilterData', data)
	  };return data;
	}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shouldHaveArrow = shouldHaveArrow;
	/**
	 * @module utils/router
	 */
	
	function shouldHaveArrow() {
	  var topOfStack = window.LocalstorageStack.top();
	  if (!topOfStack) return false;
	  var pathname = topOfStack.pathname;
	  if (pathname === '/workscreen' || pathname === '/workscreen/' || pathname === '/orders' || pathname === '/orders/') return false;
	  return true;
	}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearUploads = clearUploads;
	exports.getUploads = getUploads;
	exports.queueUpload = queueUpload;
	exports.cancelUploads = cancelUploads;
	exports.updateUploads = updateUploads;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _uploads = __webpack_require__(799);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clearUploads() {
	  if (window.uploads !== undefined && window.uploads !== null) {
	    window.uploads.splice(0, window.uploads.length);
	  }
	  updateRedux();
	}
	
	/**
	 * @description gets details about files currently being uploaded
	 * @return {object} Returns object
	 */
	/**
	 * @module utils/upload
	 */
	
	function getUploads() {
	  if (window.uploads === undefined || window.uploads === null) {
	    window.uploads = [];
	  }
	  return window.uploads;
	}
	
	function queueUpload(url, file, data) {
	  return function (dispatch) {
	    var key = Math.floor(Math.random() * 10000000);
	    var CancelToken = _axios2.default.CancelToken;
	    var source = CancelToken.source();
	
	    var config = {
	      cancelToken: source.token,
	      onUploadProgress: function onUploadProgress(evt) {
	        updateUploads(key, file, evt, source.cancel);
	      }
	    };
	    return _axios2.default.post(url, data, config).then(function (res) {
	      dispatch((0, _uploads.finishUploadsIfAllDone)());
	      return res;
	    }).catch(function (thrown) {
	      if (_axios2.default.isCancel(thrown)) {
	        console.log('cancel');
	        clearUploads();
	      } else {
	        console.log('other error');
	        clearUploads();
	      }
	    });
	  };
	}
	
	function cancelUploads() {
	  var uploads = getUploads();
	  if (uploads.length > 0) {
	    for (var i = 0; i < uploads.length; i++) {
	      if (uploads[i].cancel !== null) {
	        uploads[i].cancel();
	      }
	    }
	    clearUploads();
	  }
	  updateRedux();
	}
	
	function updateUploads(key, file, evt, cancel) {
	  var uploads = getUploads();
	  var total = evt.lengthComputable ? evt.total : evt.target.getResponseHeader('content-length') || evt.target.getResponseHeader('x-decompressed-content-length');
	  var fileInfo = {
	    name: '',
	    size: total,
	    type: '',
	    loaded: evt.loaded,
	    lengthComputable: evt.lengthComputable
	  };
	  if (file !== null && file.name !== undefined && file.type !== undefined) {
	    fileInfo.name = file.name;
	    fileInfo.type = file.type;
	  }
	  var entry = {
	    key: key,
	    cancel: cancel,
	    file: fileInfo
	  };
	
	  var index = uploads.findIndex(function (item) {
	    return item.key === entry.key && item.file.name === entry.file.name;
	  });
	  if (index >= 0) {
	    uploads[index] = entry;
	  } else {
	    uploads.push(entry);
	  }
	
	  updateRedux();
	
	  // Clear completed
	  // for (let i = uploads.length - 1; i >= 0; i--) {
	  //   let item = uploads[i]
	  //   if (item.file.loaded >= item.file.size) {
	  //     uploads.splice(i, 1)
	  //   }
	  // }
	  // updateRedux()
	}
	
	function updateRedux() {
	  _store2.default.dispatch((0, _uploads.setUploadsAction)(getUploads()));
	}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(80);
	var toAbsoluteIndex = __webpack_require__(163);
	var toLength = __webpack_require__(72);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1139);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(71);
	var createDesc = __webpack_require__(160);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	var document = __webpack_require__(44).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(56)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(44).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	var setPrototypeOf = __webpack_require__(325).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(179);
	var ITERATOR = __webpack_require__(56)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(157);
	var descriptor = __webpack_require__(160);
	var setToStringTag = __webpack_require__(180);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(97)(IteratorPrototype, __webpack_require__(56)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(156);
	var $export = __webpack_require__(10);
	var redefine = __webpack_require__(98);
	var hide = __webpack_require__(97);
	var has = __webpack_require__(96);
	var Iterators = __webpack_require__(179);
	var $iterCreate = __webpack_require__(319);
	var setToStringTag = __webpack_require__(180);
	var getPrototypeOf = __webpack_require__(104);
	var ITERATOR = __webpack_require__(56)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(44);
	var macrotask = __webpack_require__(331).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(109)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if (Observer) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(88);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(49);
	var anObject = __webpack_require__(39);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(110)(Function.call, __webpack_require__(103).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(250)('keys');
	var uid = __webpack_require__(164);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(121);
	var defined = __webpack_require__(119);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(244);
	var defined = __webpack_require__(119);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(121);
	var defined = __webpack_require__(119);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(110);
	var invoke = __webpack_require__(488);
	var html = __webpack_require__(316);
	var cel = __webpack_require__(313);
	var global = __webpack_require__(44);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(109)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(44);
	var DESCRIPTORS = __webpack_require__(70);
	var LIBRARY = __webpack_require__(156);
	var $typed = __webpack_require__(252);
	var hide = __webpack_require__(97);
	var redefineAll = __webpack_require__(161);
	var fails = __webpack_require__(47);
	var anInstance = __webpack_require__(154);
	var toInteger = __webpack_require__(121);
	var toLength = __webpack_require__(72);
	var toIndex = __webpack_require__(506);
	var gOPN = __webpack_require__(158).f;
	var dP = __webpack_require__(71).f;
	var arrayFill = __webpack_require__(310);
	var setToStringTag = __webpack_require__(180);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(44);
	var core = __webpack_require__(118);
	var LIBRARY = __webpack_require__(156);
	var wksExt = __webpack_require__(507);
	var defineProperty = __webpack_require__(71).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(207);
	var ITERATOR = __webpack_require__(56)('iterator');
	var Iterators = __webpack_require__(179);
	module.exports = __webpack_require__(118).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(141);
	var step = __webpack_require__(491);
	var Iterators = __webpack_require__(179);
	var toIObject = __webpack_require__(105);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(320)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(165),
	    root = __webpack_require__(123);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(123);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(1705);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(529);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1708),
	    stubArray = __webpack_require__(537);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1699),
	    Map = __webpack_require__(339),
	    Promise = __webpack_require__(1702),
	    Set = __webpack_require__(1703),
	    WeakMap = __webpack_require__(1706),
	    baseGetTag = __webpack_require__(211),
	    toSource = __webpack_require__(530);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(527);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(211),
	    getPrototype = __webpack_require__(343),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(522),
	    baseKeys = __webpack_require__(1718),
	    isArrayLike = __webpack_require__(533);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(522),
	    baseKeysIn = __webpack_require__(1719),
	    isArrayLike = __webpack_require__(533);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(125);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(125);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(136);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(125);
	
	var _getRouteParams = __webpack_require__(1908);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(376);
	
	var _RouteUtils = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(189);
	
	var _DOMUtils = __webpack_require__(268);
	
	var _DOMStateStorage = __webpack_require__(700);
	
	var _PathUtils = __webpack_require__(144);
	
	var _ExecutionEnvironment = __webpack_require__(380);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1918);
	
	var _PathUtils = __webpack_require__(144);
	
	var _runTransitionHook = __webpack_require__(382);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(267);
	
	var _LocationUtils = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collapse = exports.collapseDuration = exports.Fade = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(720);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Fade = function Fade(_ref) {
	  var Tag = _ref.component,
	      _ref$duration = _ref.duration,
	      duration = _ref$duration === void 0 ? 1 : _ref$duration,
	      inProp = _ref.in,
	      onExited = _ref.onExited,
	      props = _objectWithoutProperties(_ref, ["component", "duration", "in", "onExited"]);
	
	  var transition = {
	    entering: {
	      opacity: 0
	    },
	    entered: {
	      opacity: 1,
	      transition: "opacity ".concat(duration, "ms")
	    },
	    exiting: {
	      opacity: 0
	    },
	    exited: {
	      opacity: 0
	    }
	  };
	  return _react.default.createElement(_reactTransitionGroup.Transition, {
	    mountOnEnter: true,
	    unmountOnExit: true,
	    in: inProp,
	    timeout: duration
	  }, function (state) {
	    var innerProps = {
	      style: _objectSpread({}, transition[state])
	    };
	    return _react.default.createElement(Tag, _extends({
	      innerProps: innerProps
	    }, props));
	  });
	}; // ==============================
	// Collapse Transition
	// ==============================
	
	
	exports.Fade = Fade;
	var collapseDuration = 260;
	exports.collapseDuration = collapseDuration;
	
	// wrap each MultiValue with a collapse transition; decreases width until
	// finally removing from DOM
	var Collapse =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Collapse, _Component);
	
	  function Collapse() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Collapse);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "duration", collapseDuration);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rafID", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      width: 'auto'
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "transition", {
	      exiting: {
	        width: 0,
	        transition: "width ".concat(_this.duration, "ms ease-out")
	      },
	      exited: {
	        width: 0
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getWidth", function (ref) {
	      if (ref && isNaN(_this.state.width)) {
	        /*
	          Here we're invoking requestAnimationFrame with a callback invoking our
	          call to getBoundingClientRect and setState in order to resolve an edge case
	          around portalling. Certain portalling solutions briefly remove children from the DOM
	          before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
	          while the Select component is in this state.
	        */
	        // cannot use `offsetWidth` because it is rounded
	        _this.rafID = window.requestAnimationFrame(function () {
	          var _ref$getBoundingClien = ref.getBoundingClientRect(),
	              width = _ref$getBoundingClien.width;
	
	          _this.setState({
	            width: width
	          });
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyle", function (width) {
	      return {
	        overflow: 'hidden',
	        whiteSpace: 'nowrap',
	        width: width
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTransition", function (state) {
	      return _this.transition[state];
	    });
	
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.rafID) {
	        window.cancelAnimationFrame(this.rafID);
	      }
	    } // width must be calculated; cannot transition from `undefined` to `number`
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          inProp = _this$props.in;
	      var width = this.state.width;
	      return _react.default.createElement(_reactTransitionGroup.Transition, {
	        enter: false,
	        mountOnEnter: true,
	        unmountOnExit: true,
	        in: inProp,
	        timeout: this.duration
	      }, function (state) {
	        var style = _objectSpread({}, _this2.getStyle(width), _this2.getTransition(state));
	
	        return _react.default.createElement("div", {
	          ref: _this2.getWidth,
	          style: style
	        }, children);
	      });
	    }
	  }]);
	
	  return Collapse;
	}(_react.Component);
	
	exports.Collapse = Collapse;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMenuPlacement = getMenuPlacement;
	exports.MenuPortal = exports.menuPortalCSS = exports.LoadingMessage = exports.NoOptionsMessage = exports.loadingMessageCSS = exports.noOptionsMessageCSS = exports.MenuList = exports.menuListCSS = exports.default = exports.MenuPlacer = exports.menuCSS = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	var _reactDom = __webpack_require__(77);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _utils = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getMenuPlacement(_ref) {
	  var maxHeight = _ref.maxHeight,
	      menuEl = _ref.menuEl,
	      minHeight = _ref.minHeight,
	      placement = _ref.placement,
	      shouldScroll = _ref.shouldScroll,
	      isFixedPosition = _ref.isFixedPosition,
	      theme = _ref.theme;
	  var spacing = theme.spacing;
	  var scrollParent = (0, _utils.getScrollParent)(menuEl);
	  var defaultState = {
	    placement: 'bottom',
	    maxHeight: maxHeight
	  }; // something went wrong, return default state
	
	  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
	  // the menu is rendered
	
	  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
	      scrollHeight = _scrollParent$getBoun.height;
	
	  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
	      menuBottom = _menuEl$getBoundingCl.bottom,
	      menuHeight = _menuEl$getBoundingCl.height,
	      menuTop = _menuEl$getBoundingCl.top;
	
	  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
	      containerTop = _menuEl$offsetParent$.top;
	
	  var viewHeight = window.innerHeight;
	  var scrollTop = (0, _utils.getScrollTop)(scrollParent);
	  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
	  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
	  var viewSpaceAbove = containerTop - marginTop;
	  var viewSpaceBelow = viewHeight - menuTop;
	  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
	  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
	  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
	  var scrollUp = scrollTop + menuTop - marginTop;
	  var scrollDuration = 160;
	
	  switch (placement) {
	    case 'auto':
	    case 'bottom':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceBelow >= menuHeight) {
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
	        }
	
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
	        } // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	
	        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
	        return {
	          placement: 'bottom',
	          maxHeight: constrainedHeight
	        };
	      } // 4. Forked beviour when there isn't enough space below
	      // AUTO: flip the menu, render above
	
	
	      if (placement === 'auto' || isFixedPosition) {
	        // may need to be constrained after flipping
	        var _constrainedHeight = maxHeight;
	        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
	
	        if (spaceAbove >= minHeight) {
	          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight
	        };
	      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
	
	
	      if (placement === 'bottom') {
	        (0, _utils.scrollTo)(scrollParent, scrollDown);
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      }
	
	      break;
	
	    case 'top':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceAbove >= menuHeight) {
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
	        }
	
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight2
	        };
	      } // 4. not enough space, the browser WILL NOT increase scrollable area when
	      // absolutely positioned element rendered above the viewport (only below).
	      // Flip the menu, render below
	
	
	      return {
	        placement: 'bottom',
	        maxHeight: maxHeight
	      };
	
	    default:
	      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
	  } // fulfil contract with flow: implicit return value of undefined
	
	
	  return defaultState;
	} // Menu Component
	// ------------------------------
	
	
	function alignToControl(placement) {
	  var placementToCSSProp = {
	    bottom: 'top',
	    top: 'bottom'
	  };
	  return placement ? placementToCSSProp[placement] : 'bottom';
	}
	
	var coercePlacement = function coercePlacement(p) {
	  return p === 'auto' ? 'bottom' : p;
	};
	
	var menuCSS = function menuCSS(_ref2) {
	  var _ref3;
	
	  var placement = _ref2.placement,
	      _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      spacing = _ref2$theme.spacing,
	      colors = _ref2$theme.colors;
	  return _ref3 = {
	    label: 'menu'
	  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
	}; // NOTE: internal only
	
	
	exports.menuCSS = menuCSS;
	
	var MenuPlacer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MenuPlacer, _Component);
	
	  function MenuPlacer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, MenuPlacer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      maxHeight: _this.props.maxMenuHeight,
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlacement", function (ref) {
	      var _this$props = _this.props,
	          minMenuHeight = _this$props.minMenuHeight,
	          maxMenuHeight = _this$props.maxMenuHeight,
	          menuPlacement = _this$props.menuPlacement,
	          menuPosition = _this$props.menuPosition,
	          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
	          theme = _this$props.theme;
	      var getPortalPlacement = _this.context.getPortalPlacement;
	      if (!ref) return; // DO NOT scroll if position is fixed
	
	      var isFixedPosition = menuPosition === 'fixed';
	      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
	      var state = getMenuPlacement({
	        maxHeight: maxMenuHeight,
	        menuEl: ref,
	        minHeight: minMenuHeight,
	        placement: menuPlacement,
	        shouldScroll: shouldScroll,
	        isFixedPosition: isFixedPosition,
	        theme: theme
	      });
	      if (getPortalPlacement) getPortalPlacement(state);
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getUpdatedProps", function () {
	      var menuPlacement = _this.props.menuPlacement;
	      var placement = _this.state.placement || coercePlacement(menuPlacement);
	      return _objectSpread({}, _this.props, {
	        placement: placement,
	        maxHeight: _this.state.maxHeight
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(MenuPlacer, [{
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return children({
	        ref: this.getPlacement,
	        placerProps: this.getUpdatedProps()
	      });
	    }
	  }]);
	
	  return MenuPlacer;
	}(_react.Component);
	
	exports.MenuPlacer = MenuPlacer;
	
	_defineProperty(MenuPlacer, "contextTypes", {
	  getPortalPlacement: _propTypes.default.func
	});
	
	var Menu = function Menu(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  var cn = cx(
	  /*#__PURE__*/
	  (0, _emotion.css)(getStyles('menu', props)), {
	    menu: true
	  }, className);
	  return _react.default.createElement("div", _extends({
	    className: cn
	  }, innerProps, {
	    ref: innerRef
	  }), children);
	};
	
	var _default = Menu; // ==============================
	// Menu List
	// ==============================
	
	exports.default = _default;
	
	var menuListCSS = function menuListCSS(_ref4) {
	  var maxHeight = _ref4.maxHeight,
	      baseUnit = _ref4.theme.spacing.baseUnit;
	  return {
	    maxHeight: maxHeight,
	    overflowY: 'auto',
	    paddingBottom: baseUnit,
	    paddingTop: baseUnit,
	    position: 'relative',
	    // required for offset[Height, Top] > keyboard scroll
	    WebkitOverflowScrolling: 'touch'
	  };
	};
	
	exports.menuListCSS = menuListCSS;
	
	var MenuList = function MenuList(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isMulti = props.isMulti,
	      innerRef = props.innerRef;
	  return _react.default.createElement("div", {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('menuList', props)), {
	      'menu-list': true,
	      'menu-list--is-multi': isMulti
	    }, className),
	    ref: innerRef
	  }, children);
	}; // ==============================
	// Menu Notices
	// ==============================
	
	
	exports.MenuList = MenuList;
	
	var noticeCSS = function noticeCSS(_ref5) {
	  var _ref5$theme = _ref5.theme,
	      baseUnit = _ref5$theme.spacing.baseUnit,
	      colors = _ref5$theme.colors;
	  return {
	    color: colors.neutral40,
	    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
	    textAlign: 'center'
	  };
	};
	
	var noOptionsMessageCSS = noticeCSS;
	exports.noOptionsMessageCSS = noOptionsMessageCSS;
	var loadingMessageCSS = noticeCSS;
	exports.loadingMessageCSS = loadingMessageCSS;
	
	var NoOptionsMessage = function NoOptionsMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('noOptionsMessage', props)), {
	      'menu-notice': true,
	      'menu-notice--no-options': true
	    }, className)
	  }, innerProps), children);
	};
	
	exports.NoOptionsMessage = NoOptionsMessage;
	NoOptionsMessage.defaultProps = {
	  children: 'No options'
	};
	
	var LoadingMessage = function LoadingMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('loadingMessage', props)), {
	      'menu-notice': true,
	      'menu-notice--loading': true
	    }, className)
	  }, innerProps), children);
	};
	
	exports.LoadingMessage = LoadingMessage;
	LoadingMessage.defaultProps = {
	  children: 'Loading...'
	}; // ==============================
	// Menu Portal
	// ==============================
	
	var menuPortalCSS = function menuPortalCSS(_ref6) {
	  var rect = _ref6.rect,
	      offset = _ref6.offset,
	      position = _ref6.position;
	  return {
	    left: rect.left,
	    position: position,
	    top: offset,
	    width: rect.width,
	    zIndex: 1
	  };
	};
	
	exports.menuPortalCSS = menuPortalCSS;
	
	var MenuPortal =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MenuPortal, _Component2);
	
	  function MenuPortal() {
	    var _getPrototypeOf3;
	
	    var _this2;
	
	    _classCallCheck(this, MenuPortal);
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getPortalPlacement", function (_ref7) {
	      var placement = _ref7.placement;
	      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
	
	      if (placement !== initialPlacement) {
	        _this2.setState({
	          placement: placement
	        });
	      }
	    });
	
	    return _this2;
	  }
	
	  _createClass(MenuPortal, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        getPortalPlacement: this.getPortalPlacement
	      };
	    } // callback for occassions where the menu must "flip"
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          appendTo = _this$props2.appendTo,
	          children = _this$props2.children,
	          controlElement = _this$props2.controlElement,
	          menuPlacement = _this$props2.menuPlacement,
	          position = _this$props2.menuPosition,
	          getStyles = _this$props2.getStyles;
	      var isFixed = position === 'fixed'; // bail early if required elements aren't present
	
	      if (!appendTo && !isFixed || !controlElement) {
	        return null;
	      }
	
	      var placement = this.state.placement || coercePlacement(menuPlacement);
	      var rect = (0, _utils.getBoundingClientObj)(controlElement);
	      var scrollDistance = isFixed ? 0 : window.pageYOffset;
	      var offset = rect[placement] + scrollDistance;
	      var state = {
	        offset: offset,
	        position: position,
	        rect: rect
	      }; // same wrapper element whether fixed or portalled
	
	      var menuWrapper = _react.default.createElement("div", {
	        className:
	        /*#__PURE__*/
	
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('menuPortal', state))
	      }, children);
	
	      return appendTo ? (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper;
	    }
	  }]);
	
	  return MenuPortal;
	}(_react.Component);
	
	exports.MenuPortal = MenuPortal;
	
	_defineProperty(MenuPortal, "childContextTypes", {
	  getPortalPlacement: _propTypes.default.func
	});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultComponents = exports.components = void 0;
	
	var _containers = __webpack_require__(712);
	
	var _indicators = __webpack_require__(386);
	
	var _Control = _interopRequireDefault(__webpack_require__(705));
	
	var _Group = _interopRequireWildcard(__webpack_require__(706));
	
	var _Input = _interopRequireDefault(__webpack_require__(707));
	
	var _Menu = _interopRequireWildcard(__webpack_require__(384));
	
	var _MultiValue = _interopRequireWildcard(__webpack_require__(708));
	
	var _Option = _interopRequireDefault(__webpack_require__(709));
	
	var _Placeholder = _interopRequireDefault(__webpack_require__(710));
	
	var _SingleValue = _interopRequireDefault(__webpack_require__(711));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var components = {
	  ClearIndicator: _indicators.ClearIndicator,
	  Control: _Control.default,
	  DropdownIndicator: _indicators.DropdownIndicator,
	  DownChevron: _indicators.DownChevron,
	  CrossIcon: _indicators.CrossIcon,
	  Group: _Group.default,
	  GroupHeading: _Group.GroupHeading,
	  IndicatorsContainer: _containers.IndicatorsContainer,
	  IndicatorSeparator: _indicators.IndicatorSeparator,
	  Input: _Input.default,
	  LoadingIndicator: _indicators.LoadingIndicator,
	  Menu: _Menu.default,
	  MenuList: _Menu.MenuList,
	  MenuPortal: _Menu.MenuPortal,
	  LoadingMessage: _Menu.LoadingMessage,
	  NoOptionsMessage: _Menu.NoOptionsMessage,
	  MultiValue: _MultiValue.default,
	  MultiValueContainer: _MultiValue.MultiValueContainer,
	  MultiValueLabel: _MultiValue.MultiValueLabel,
	  MultiValueRemove: _MultiValue.MultiValueRemove,
	  Option: _Option.default,
	  Placeholder: _Placeholder.default,
	  SelectContainer: _containers.SelectContainer,
	  SingleValue: _SingleValue.default,
	  ValueContainer: _containers.ValueContainer
	};
	exports.components = components;
	
	var defaultComponents = function defaultComponents(props) {
	  return _objectSpread({}, components, props.components);
	};
	
	exports.defaultComponents = defaultComponents;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoadingIndicator = exports.loadingIndicatorCSS = exports.IndicatorSeparator = exports.indicatorSeparatorCSS = exports.ClearIndicator = exports.clearIndicatorCSS = exports.DropdownIndicator = exports.dropdownIndicatorCSS = exports.DownChevron = exports.CrossIcon = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// ==============================
	// Dropdown & Clear Icons
	// ==============================
	var Svg = function Svg(_ref) {
	  var size = _ref.size,
	      props = _objectWithoutProperties(_ref, ["size"]);
	
	  return _react.default.createElement("svg", _extends({
	    height: size,
	    width: size,
	    viewBox: "0 0 20 20",
	    "aria-hidden": "true",
	    focusable: "false",
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)({
	      display: 'inline-block',
	      fill: 'currentColor',
	      lineHeight: 1,
	      stroke: 'currentColor',
	      strokeWidth: 0
	    })
	  }, props));
	};
	
	var CrossIcon = function CrossIcon(props) {
	  return _react.default.createElement(Svg, _extends({
	    size: 20
	  }, props), _react.default.createElement("path", {
	    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
	  }));
	};
	
	exports.CrossIcon = CrossIcon;
	
	var DownChevron = function DownChevron(props) {
	  return _react.default.createElement(Svg, _extends({
	    size: 20
	  }, props), _react.default.createElement("path", {
	    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
	  }));
	}; // ==============================
	// Dropdown & Clear Buttons
	// ==============================
	
	
	exports.DownChevron = DownChevron;
	
	var baseCSS = function baseCSS(_ref2) {
	  var isFocused = _ref2.isFocused,
	      _ref2$theme = _ref2.theme,
	      baseUnit = _ref2$theme.spacing.baseUnit,
	      colors = _ref2$theme.colors;
	  return {
	    label: 'indicatorContainer',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    ':hover': {
	      color: isFocused ? colors.neutral80 : colors.neutral40
	    }
	  };
	};
	
	var dropdownIndicatorCSS = baseCSS;
	exports.dropdownIndicatorCSS = dropdownIndicatorCSS;
	
	var DropdownIndicator = function DropdownIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('dropdownIndicator', props)), {
	      'indicator': true,
	      'dropdown-indicator': true
	    }, className)
	  }), children || _react.default.createElement(DownChevron, null));
	};
	
	exports.DropdownIndicator = DropdownIndicator;
	var clearIndicatorCSS = baseCSS;
	exports.clearIndicatorCSS = clearIndicatorCSS;
	
	var ClearIndicator = function ClearIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('clearIndicator', props)), {
	      'indicator': true,
	      'clear-indicator': true
	    }, className)
	  }), children || _react.default.createElement(CrossIcon, null));
	}; // ==============================
	// Separator
	// ==============================
	
	
	exports.ClearIndicator = ClearIndicator;
	
	var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
	  var isDisabled = _ref3.isDisabled,
	      _ref3$theme = _ref3.theme,
	      baseUnit = _ref3$theme.spacing.baseUnit,
	      colors = _ref3$theme.colors;
	  return {
	    label: 'indicatorSeparator',
	    alignSelf: 'stretch',
	    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
	    marginBottom: baseUnit * 2,
	    marginTop: baseUnit * 2,
	    width: 1
	  };
	};
	
	exports.indicatorSeparatorCSS = indicatorSeparatorCSS;
	
	var IndicatorSeparator = function IndicatorSeparator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("span", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('indicatorSeparator', props)), {
	      'indicator-separator': true
	    }, className)
	  }));
	}; // ==============================
	// Loading
	// ==============================
	
	
	exports.IndicatorSeparator = IndicatorSeparator;
	var keyframesName = 'react-select-loading-indicator';
	var keyframesInjected = false;
	
	var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
	  var isFocused = _ref4.isFocused,
	      size = _ref4.size,
	      _ref4$theme = _ref4.theme,
	      colors = _ref4$theme.colors,
	      baseUnit = _ref4$theme.spacing.baseUnit;
	  return {
	    label: 'loadingIndicator',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    alignSelf: 'center',
	    fontSize: size,
	    lineHeight: 1,
	    marginRight: size,
	    textAlign: 'center',
	    verticalAlign: 'middle'
	  };
	};
	
	exports.loadingIndicatorCSS = loadingIndicatorCSS;
	
	var LoadingDot = function LoadingDot(_ref5) {
	  var color = _ref5.color,
	      delay = _ref5.delay,
	      offset = _ref5.offset;
	  return _react.default.createElement("span", {
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)({
	      animationDuration: '1s',
	      animationDelay: "".concat(delay, "ms"),
	      animationIterationCount: 'infinite',
	      animationName: keyframesName,
	      animationTimingFunction: 'ease-in-out',
	      backgroundColor: color,
	      borderRadius: '1em',
	      display: 'inline-block',
	      marginLeft: offset ? '1em' : null,
	      height: '1em',
	      verticalAlign: 'top',
	      width: '1em'
	    })
	  });
	};
	
	var LoadingIndicator = function LoadingIndicator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isFocused = props.isFocused,
	      isRtl = props.isRtl,
	      colors = props.theme.colors;
	  var color = isFocused ? colors.neutral80 : colors.neutral20;
	
	  if (!keyframesInjected) {
	    // eslint-disable-next-line no-unused-expressions
	    (0, _emotion.injectGlobal)("@keyframes ", keyframesName, "{0%,80%,100%{opacity:0;}40%{opacity:1;}};");
	    keyframesInjected = true;
	  }
	
	  return _react.default.createElement("div", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('loadingIndicator', props)), {
	      'indicator': true,
	      'loading-indicator': true
	    }, className)
	  }), _react.default.createElement(LoadingDot, {
	    color: color,
	    delay: 0,
	    offset: isRtl
	  }), _react.default.createElement(LoadingDot, {
	    color: color,
	    delay: 160,
	    offset: true
	  }), _react.default.createElement(LoadingDot, {
	    color: color,
	    delay: 320,
	    offset: !isRtl
	  }));
	};
	
	exports.LoadingIndicator = LoadingIndicator;
	LoadingIndicator.defaultProps = {
	  size: 4
	};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(77);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var NodeResolver =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(NodeResolver, _Component);
	
	  function NodeResolver() {
	    _classCallCheck(this, NodeResolver);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NodeResolver).apply(this, arguments));
	  }
	
	  _createClass(NodeResolver, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.innerRef((0, _reactDom.findDOMNode)(this));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.innerRef(null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return NodeResolver;
	}(_react.Component);
	
	exports.default = NodeResolver;

/***/ }),
/* 388 */,
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(729);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1983);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1982);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1981);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(728);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(730);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleLoadStart = handleLoadStart;
	exports.handleCanPlay = handleCanPlay;
	exports.handleWaiting = handleWaiting;
	exports.handleCanPlayThrough = handleCanPlayThrough;
	exports.handlePlaying = handlePlaying;
	exports.handlePlay = handlePlay;
	exports.handlePause = handlePause;
	exports.handleEnd = handleEnd;
	exports.handleSeeking = handleSeeking;
	exports.handleSeeked = handleSeeked;
	exports.handleDurationChange = handleDurationChange;
	exports.handleTimeUpdate = handleTimeUpdate;
	exports.handleVolumeChange = handleVolumeChange;
	exports.handleProgressChange = handleProgressChange;
	exports.handleRateChange = handleRateChange;
	exports.handleSuspend = handleSuspend;
	exports.handleAbort = handleAbort;
	exports.handleEmptied = handleEmptied;
	exports.handleStalled = handleStalled;
	exports.handleLoadedMetaData = handleLoadedMetaData;
	exports.handleLoadedData = handleLoadedData;
	exports.handleResize = handleResize;
	exports.handleError = handleError;
	exports.handleSeekingTime = handleSeekingTime;
	exports.handleEndSeeking = handleEndSeeking;
	exports.activateTextTrack = activateTextTrack;
	exports.ACTIVATE_TEXT_TRACK = exports.ERROR = exports.RESIZE = exports.LOADED_DATA = exports.LOADED_META_DATA = exports.STALLED = exports.EMPTIED = exports.ABORT = exports.SUSPEND = exports.RATE_CHANGE = exports.PROGRESS_CHANGE = exports.VOLUME_CHANGE = exports.TIME_UPDATE = exports.DURATION_CHANGE = exports.END_SEEKING = exports.SEEKING_TIME = exports.SEEKED = exports.SEEKING = exports.END = exports.PAUSE = exports.PLAY = exports.PLAYING = exports.CAN_PLAY_THROUGH = exports.WAITING = exports.CAN_PLAY = exports.LOAD_START = void 0;
	var LOAD_START = 'video-react/LOAD_START';
	exports.LOAD_START = LOAD_START;
	var CAN_PLAY = 'video-react/CAN_PLAY';
	exports.CAN_PLAY = CAN_PLAY;
	var WAITING = 'video-react/WAITING';
	exports.WAITING = WAITING;
	var CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
	exports.CAN_PLAY_THROUGH = CAN_PLAY_THROUGH;
	var PLAYING = 'video-react/PLAYING';
	exports.PLAYING = PLAYING;
	var PLAY = 'video-react/PLAY';
	exports.PLAY = PLAY;
	var PAUSE = 'video-react/PAUSE';
	exports.PAUSE = PAUSE;
	var END = 'video-react/END';
	exports.END = END;
	var SEEKING = 'video-react/SEEKING';
	exports.SEEKING = SEEKING;
	var SEEKED = 'video-react/SEEKED';
	exports.SEEKED = SEEKED;
	var SEEKING_TIME = 'video-react/SEEKING_TIME';
	exports.SEEKING_TIME = SEEKING_TIME;
	var END_SEEKING = 'video-react/END_SEEKING';
	exports.END_SEEKING = END_SEEKING;
	var DURATION_CHANGE = 'video-react/DURATION_CHANGE';
	exports.DURATION_CHANGE = DURATION_CHANGE;
	var TIME_UPDATE = 'video-react/TIME_UPDATE';
	exports.TIME_UPDATE = TIME_UPDATE;
	var VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
	exports.VOLUME_CHANGE = VOLUME_CHANGE;
	var PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
	exports.PROGRESS_CHANGE = PROGRESS_CHANGE;
	var RATE_CHANGE = 'video-react/RATE_CHANGE';
	exports.RATE_CHANGE = RATE_CHANGE;
	var SUSPEND = 'video-react/SUSPEND';
	exports.SUSPEND = SUSPEND;
	var ABORT = 'video-react/ABORT';
	exports.ABORT = ABORT;
	var EMPTIED = 'video-react/EMPTIED';
	exports.EMPTIED = EMPTIED;
	var STALLED = 'video-react/STALLED';
	exports.STALLED = STALLED;
	var LOADED_META_DATA = 'video-react/LOADED_META_DATA';
	exports.LOADED_META_DATA = LOADED_META_DATA;
	var LOADED_DATA = 'video-react/LOADED_DATA';
	exports.LOADED_DATA = LOADED_DATA;
	var RESIZE = 'video-react/RESIZE';
	exports.RESIZE = RESIZE;
	var ERROR = 'video-react/ERROR';
	exports.ERROR = ERROR;
	var ACTIVATE_TEXT_TRACK = 'video-react/ACTIVATE_TEXT_TRACK';
	exports.ACTIVATE_TEXT_TRACK = ACTIVATE_TEXT_TRACK;
	
	function handleLoadStart(videoProps) {
	  return {
	    type: LOAD_START,
	    videoProps: videoProps
	  };
	}
	
	function handleCanPlay(videoProps) {
	  return {
	    type: CAN_PLAY,
	    videoProps: videoProps
	  };
	}
	
	function handleWaiting(videoProps) {
	  return {
	    type: WAITING,
	    videoProps: videoProps
	  };
	}
	
	function handleCanPlayThrough(videoProps) {
	  return {
	    type: CAN_PLAY_THROUGH,
	    videoProps: videoProps
	  };
	}
	
	function handlePlaying(videoProps) {
	  return {
	    type: PLAYING,
	    videoProps: videoProps
	  };
	}
	
	function handlePlay(videoProps) {
	  return {
	    type: PLAY,
	    videoProps: videoProps
	  };
	}
	
	function handlePause(videoProps) {
	  return {
	    type: PAUSE,
	    videoProps: videoProps
	  };
	}
	
	function handleEnd(videoProps) {
	  return {
	    type: END,
	    videoProps: videoProps
	  };
	}
	
	function handleSeeking(videoProps) {
	  return {
	    type: SEEKING,
	    videoProps: videoProps
	  };
	}
	
	function handleSeeked(videoProps) {
	  return {
	    type: SEEKED,
	    videoProps: videoProps
	  };
	}
	
	function handleDurationChange(videoProps) {
	  return {
	    type: DURATION_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleTimeUpdate(videoProps) {
	  return {
	    type: TIME_UPDATE,
	    videoProps: videoProps
	  };
	}
	
	function handleVolumeChange(videoProps) {
	  return {
	    type: VOLUME_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleProgressChange(videoProps) {
	  return {
	    type: PROGRESS_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleRateChange(videoProps) {
	  return {
	    type: RATE_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleSuspend(videoProps) {
	  return {
	    type: SUSPEND,
	    videoProps: videoProps
	  };
	}
	
	function handleAbort(videoProps) {
	  return {
	    type: ABORT,
	    videoProps: videoProps
	  };
	}
	
	function handleEmptied(videoProps) {
	  return {
	    type: EMPTIED,
	    videoProps: videoProps
	  };
	}
	
	function handleStalled(videoProps) {
	  return {
	    type: STALLED,
	    videoProps: videoProps
	  };
	}
	
	function handleLoadedMetaData(videoProps) {
	  return {
	    type: LOADED_META_DATA,
	    videoProps: videoProps
	  };
	}
	
	function handleLoadedData(videoProps) {
	  return {
	    type: LOADED_DATA,
	    videoProps: videoProps
	  };
	}
	
	function handleResize(videoProps) {
	  return {
	    type: RESIZE,
	    videoProps: videoProps
	  };
	}
	
	function handleError(videoProps) {
	  return {
	    type: ERROR,
	    videoProps: videoProps
	  };
	}
	
	function handleSeekingTime(time) {
	  return {
	    type: SEEKING_TIME,
	    time: time
	  };
	}
	
	function handleEndSeeking(time) {
	  return {
	    type: END_SEEKING,
	    time: time
	  };
	}
	
	function activateTextTrack(textTrack) {
	  return {
	    type: ACTIVATE_TEXT_TRACK,
	    textTrack: textTrack
	  };
	}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var Dom = _interopRequireWildcard(__webpack_require__(273));
	
	var propTypes = {
	  className: _propTypes["default"].string,
	  onMouseDown: _propTypes["default"].func,
	  onMouseMove: _propTypes["default"].func,
	  stepForward: _propTypes["default"].func,
	  stepBack: _propTypes["default"].func,
	  sliderActive: _propTypes["default"].func,
	  sliderInactive: _propTypes["default"].func,
	  onMouseUp: _propTypes["default"].func,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  getPercent: _propTypes["default"].func,
	  vertical: _propTypes["default"].bool,
	  children: _propTypes["default"].node,
	  label: _propTypes["default"].string,
	  valuenow: _propTypes["default"].string,
	  valuetext: _propTypes["default"].string
	};
	
	var Slider =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Slider, _Component);
	
	  function Slider(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Slider);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Slider).call(this, props, context));
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.calculateDistance = _this.calculateDistance.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getProgress = _this.getProgress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.state = {
	      active: false
	    };
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Slider, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousemove', this.handleMouseMove, true);
	      document.removeEventListener('mouseup', this.handleMouseUp, true);
	      document.removeEventListener('touchmove', this.handleMouseMove, true);
	      document.removeEventListener('touchend', this.handleMouseUp, true);
	      document.removeEventListener('keydown', this.handleKeyPress, true);
	    }
	  }, {
	    key: "getProgress",
	    value: function getProgress() {
	      var getPercent = this.props.getPercent;
	
	      if (!getPercent) {
	        return 0;
	      }
	
	      var progress = getPercent(); // Protect against no duration and other division issues
	
	      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
	        progress = 0;
	      }
	
	      return progress;
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(event) {
	      var onMouseDown = this.props.onMouseDown; // event.preventDefault();
	      // event.stopPropagation();
	
	      document.addEventListener('mousemove', this.handleMouseMove, true);
	      document.addEventListener('mouseup', this.handleMouseUp, true);
	      document.addEventListener('touchmove', this.handleMouseMove, true);
	      document.addEventListener('touchend', this.handleMouseUp, true);
	      this.setState({
	        active: true
	      });
	
	      if (this.props.sliderActive) {
	        this.props.sliderActive(event);
	      }
	
	      this.handleMouseMove(event);
	
	      if (onMouseDown) {
	        onMouseDown(event);
	      }
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      var onMouseMove = this.props.onMouseMove;
	
	      if (onMouseMove) {
	        onMouseMove(event);
	      }
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(event) {
	      // On iOS safari, a subsequent mouseup event will be fired after touchend.
	      // Its weird event positions make the player seek a wrong time.
	      // calling preventDefault (at touchend phase) will prevent the mouseup event
	      event.preventDefault();
	      var onMouseUp = this.props.onMouseUp;
	      document.removeEventListener('mousemove', this.handleMouseMove, true);
	      document.removeEventListener('mouseup', this.handleMouseUp, true);
	      document.removeEventListener('touchmove', this.handleMouseMove, true);
	      document.removeEventListener('touchend', this.handleMouseUp, true);
	      this.setState({
	        active: false
	      });
	
	      if (this.props.sliderInactive) {
	        this.props.sliderInactive(event);
	      }
	
	      if (onMouseUp) {
	        onMouseUp(event);
	      }
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(e) {
	      document.addEventListener('keydown', this.handleKeyPress, true);
	
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(e) {
	      document.removeEventListener('keydown', this.handleKeyPress, true);
	
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault(); // event.stopPropagation();
	
	      if (this.props.onClick) {
	        this.props.onClick(event);
	      }
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(event) {
	      if (event.which === 37 || event.which === 40) {
	        // Left and Down Arrows
	        event.preventDefault();
	        event.stopPropagation();
	        this.stepBack();
	      } else if (event.which === 38 || event.which === 39) {
	        // Up and Right Arrows
	        event.preventDefault();
	        event.stopPropagation();
	        this.stepForward();
	      }
	    }
	  }, {
	    key: "stepForward",
	    value: function stepForward() {
	      if (this.props.stepForward) {
	        this.props.stepForward();
	      }
	    }
	  }, {
	    key: "stepBack",
	    value: function stepBack() {
	      if (this.props.stepBack) {
	        this.props.stepBack();
	      }
	    }
	  }, {
	    key: "calculateDistance",
	    value: function calculateDistance(event) {
	      var node = this.slider;
	      var position = Dom.getPointerPosition(node, event);
	
	      if (this.props.vertical) {
	        return position.y;
	      }
	
	      return position.x;
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren() {
	      var progress = this.getProgress();
	      var percentage = "".concat((progress * 100).toFixed(2), "%");
	      return _react["default"].Children.map(this.props.children, function (child) {
	        return _react["default"].cloneElement(child, {
	          progress: progress,
	          percentage: percentage
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          vertical = _this$props.vertical,
	          label = _this$props.label,
	          valuenow = _this$props.valuenow,
	          valuetext = _this$props.valuetext;
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])(this.props.className, {
	          'video-react-slider-vertical': vertical,
	          'video-react-slider-horizontal': !vertical,
	          'video-react-sliding': this.state.active
	        }, 'video-react-slider'),
	        ref: function ref(c) {
	          _this2.slider = c;
	        },
	        tabIndex: "0",
	        role: "slider",
	        onMouseDown: this.handleMouseDown,
	        onTouchStart: this.handleMouseDown,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        "aria-label": label || '',
	        "aria-valuenow": valuenow || '',
	        "aria-valuetext": valuetext || '',
	        "aria-valuemin": 0,
	        "aria-valuemax": 100
	      }, this.renderChildren());
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	exports["default"] = Slider;
	Slider.propTypes = propTypes;
	Slider.displayName = 'Slider';

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _MenuButton = _interopRequireDefault(__webpack_require__(393));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  rates: _propTypes["default"].array,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
	};
	
	var PlaybackRateMenuButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PlaybackRateMenuButton, _Component);
	
	  function PlaybackRateMenuButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PlaybackRateMenuButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRateMenuButton).call(this, props, context));
	    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PlaybackRateMenuButton, [{
	    key: "handleSelectItem",
	    value: function handleSelectItem(index) {
	      var _this$props = this.props,
	          rates = _this$props.rates,
	          actions = _this$props.actions;
	
	      if (index >= 0 && index < rates.length) {
	        actions.changeRate(rates[index]);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          rates = _this$props2.rates,
	          player = _this$props2.player;
	      var items = rates.map(function (rate) {
	        return {
	          label: "".concat(rate, "x"),
	          value: rate
	        };
	      });
	      var selectedIndex = rates.indexOf(player.playbackRate) || 0;
	      return _react["default"].createElement(_MenuButton["default"], {
	        className: (0, _classnames["default"])('video-react-playback-rate', this.props.className),
	        onSelectItem: this.handleSelectItem,
	        items: items,
	        selectedIndex: selectedIndex
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Playback Rate"), _react["default"].createElement("div", {
	        className: "video-react-playback-rate-value"
	      }, "".concat(player.playbackRate.toFixed(2), "x")));
	    }
	  }]);
	  return PlaybackRateMenuButton;
	}(_react.Component);
	
	PlaybackRateMenuButton.propTypes = propTypes;
	PlaybackRateMenuButton.defaultProps = defaultProps;
	PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
	var _default = PlaybackRateMenuButton;
	exports["default"] = _default;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _Menu = _interopRequireDefault(__webpack_require__(1996));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(1997));
	
	var _ClickableComponent = _interopRequireDefault(__webpack_require__(736));
	
	var propTypes = {
	  inline: _propTypes["default"].bool,
	  items: _propTypes["default"].array,
	  className: _propTypes["default"].string,
	  onSelectItem: _propTypes["default"].func,
	  children: _propTypes["default"].any,
	  selectedIndex: _propTypes["default"].number
	};
	
	var MenuButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(MenuButton, _Component);
	
	  function MenuButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, MenuButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuButton).call(this, props, context));
	    _this.state = {
	      active: false,
	      activateIndex: props.selectedIndex || 0
	    };
	    _this.commitSelection = _this.commitSelection.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.activateMenuItem = _this.activateMenuItem.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleUpArrow = _this.handleUpArrow.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleDownArrow = _this.handleDownArrow.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleReturn = _this.handleReturn.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleIndexChange = _this.handleIndexChange.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(MenuButton, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.selectedIndex !== this.props.selectedIndex) {
	        this.activateMenuItem(this.props.selectedIndex);
	      }
	    }
	  }, {
	    key: "commitSelection",
	    value: function commitSelection(index) {
	      this.setState({
	        activateIndex: index
	      });
	      this.handleIndexChange(index);
	    }
	  }, {
	    key: "activateMenuItem",
	    value: function activateMenuItem(index) {
	      this.setState({
	        activateIndex: index
	      });
	      this.handleIndexChange(index);
	    }
	  }, {
	    key: "handleIndexChange",
	    value: function handleIndexChange(index) {
	      var onSelectItem = this.props.onSelectItem;
	      onSelectItem(index);
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick() {
	      this.setState(function (prevState) {
	        return {
	          active: !prevState.active
	        };
	      });
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      document.addEventListener('keydown', this.handleKeyPress);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.setState({
	        active: false
	      });
	      document.removeEventListener('keydown', this.handleKeyPress);
	    }
	  }, {
	    key: "handleUpArrow",
	    value: function handleUpArrow(e) {
	      var items = this.props.items;
	
	      if (this.state.active) {
	        e.preventDefault();
	        var newIndex = this.state.activateIndex - 1;
	
	        if (newIndex < 0) {
	          newIndex = items.length ? items.length - 1 : 0;
	        }
	
	        this.activateMenuItem(newIndex);
	      }
	    }
	  }, {
	    key: "handleDownArrow",
	    value: function handleDownArrow(e) {
	      var items = this.props.items;
	
	      if (this.state.active) {
	        e.preventDefault();
	        var newIndex = this.state.activateIndex + 1;
	
	        if (newIndex >= items.length) {
	          newIndex = 0;
	        }
	
	        this.activateMenuItem(newIndex);
	      }
	    }
	  }, {
	    key: "handleTab",
	    value: function handleTab(e) {
	      if (this.state.active) {
	        e.preventDefault();
	        this.commitSelection(this.state.activateIndex);
	      }
	    }
	  }, {
	    key: "handleReturn",
	    value: function handleReturn(e) {
	      e.preventDefault();
	
	      if (this.state.active) {
	        this.commitSelection(this.state.activateIndex);
	      } else {
	        this.setState({
	          active: true
	        });
	      }
	    }
	  }, {
	    key: "handleEscape",
	    value: function handleEscape() {
	      this.setState({
	        active: false,
	        activateIndex: 0
	      });
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(event) {
	      // Escape (27) key
	      if (event.which === 27) {
	        this.handleEscape(event);
	      } else if (event.which === 9) {
	        // Tab (9) key
	        this.handleTab(event);
	      } else if (event.which === 13) {
	        // Enter (13) key
	        this.handleReturn(event);
	      } else if (event.which === 38) {
	        // Up (38) key
	        this.handleUpArrow(event);
	      } else if (event.which === 40) {
	        // Down (40) key press
	        this.handleDownArrow(event);
	      }
	    }
	  }, {
	    key: "handleSelectItem",
	    value: function handleSelectItem(i) {
	      this.commitSelection(i);
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	
	      var items = this.props.items;
	      return _react["default"].createElement(_Menu["default"], null, items.map(function (item, i) {
	        return _react["default"].createElement(_MenuItem["default"], {
	          item: item,
	          index: i,
	          onSelectItem: _this2.handleSelectItem,
	          activateIndex: _this2.state.activateIndex,
	          key: "item-".concat(i++)
	        });
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _this$props = this.props,
	          inline = _this$props.inline,
	          className = _this$props.className;
	      return _react["default"].createElement(_ClickableComponent["default"], {
	        className: (0, _classnames["default"])(className, {
	          'video-react-menu-button-inline': !!inline,
	          'video-react-menu-button-popup': !inline,
	          'video-react-menu-button-active': this.state.active
	        }, 'video-react-control video-react-button video-react-menu-button'),
	        role: "button",
	        tabIndex: "0",
	        ref: function ref(c) {
	          _this3.menuButton = c;
	        },
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, this.props.children, this.renderMenu());
	    }
	  }]);
	  return MenuButton;
	}(_react.Component);
	
	exports["default"] = MenuButton;
	MenuButton.propTypes = propTypes;
	MenuButton.displayName = 'MenuButton';

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(761);
	
	var iterableToArray = __webpack_require__(763);
	
	var nonIterableSpread = __webpack_require__(764);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	var settle = __webpack_require__(780);
	var buildURL = __webpack_require__(783);
	var parseHeaders = __webpack_require__(789);
	var isURLSameOrigin = __webpack_require__(787);
	var createError = __webpack_require__(399);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(782);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(785);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(779);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAgreements = getAgreements;
	exports.getConstraints = getConstraints;
	exports.getCustomerAgrements = getCustomerAgrements;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting Agreements for workprovider from the API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/agreement
	 */
	function getAgreements() {
	  var url = _constants.API_URL + '/Agreement';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting Agreement constraints for workprovider from the API
	 * @return {Promise} Axios promise
	 */
	function getConstraints() {
	  var url = _constants.API_URL + '/Agreement/Get';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	function getCustomerAgrements(customerId) {
	  var url = _constants.API_URL + '/Agreement/Customer/Get/' + customerId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCapacityOverview = getCapacityOverview;
	exports.getOrderTimeline = getOrderTimeline;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get capacity overview
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/calendarOverview
	 */
	function getCapacityOverview(data) {
	  var url = _constants.API_URL + '/CalendarOverview/Capacity';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get order timeline
	 * @return {Promise} Axios promise
	 */
	function getOrderTimeline(orderId, currentTime) {
	  var url = _constants.API_URL + '/CalendarOverview/Capacity/Timeline/' + orderId + '?currentTime=' + currentTime.toJSON();
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetCarRentalAlts = GetCarRentalAlts;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get list of rentalcars alternatives
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/carrentalalternatives
	 */
	function GetCarRentalAlts() {
	  var url = _constants.API_URL + '/CarRentalAlternatives/Get';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCollaboratingPartners = getCollaboratingPartners;
	exports.getCollaboratingPartnerInvoiceSetting = getCollaboratingPartnerInvoiceSetting;
	exports.createSavePartnerInvoiceSetting = createSavePartnerInvoiceSetting;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting CollaboratingPartners from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/collaboratingPartners
	 */
	function getCollaboratingPartners() {
	  var url = _constants.API_URL + '/CollaboratingPartners/CollaboratingPartners';
	  return function (dispatch) {
	    return _axios2.default.get(url).then(function (res) {
	      dispatch({
	        type: _constants.SET_COLLABORATING_PARTNERS,
	        partnerList: res.data
	      });
	      return res;
	    });
	  };
	}
	
	/**
	 * @description Getting CollaboratingPartnerInvoiceSetting from API and dispatching event
	 * @return {Promise} Axios promise
	 */
	function getCollaboratingPartnerInvoiceSetting(parentPartnerId, partnerId) {
	  var url = _constants.API_URL + '/CollaboratingPartners/PartnerInvoiceSetting/Get/';
	  var data = {
	    ParentPartnerShopId: parentPartnerId,
	    PartnerShopId: partnerId
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Creating/saving PartnerInvoiceSetting
	 * @return {Promise} Axios promise
	 */
	function createSavePartnerInvoiceSetting(data) {
	  var url = _constants.API_URL + '/CollaboratingPartners/PartnerInvoiceSetting/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomerGroupContacts = getCustomerGroupContacts;
	exports.getCustomerGroupContact = getCustomerGroupContact;
	exports.createSaveCustomerGroupContact = createSaveCustomerGroupContact;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting partner contact list from API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/customerGroupContact
	 */
	function getCustomerGroupContacts(customerGroupId) {
	  var url = _constants.API_URL + '/CustomerGroupContact/' + customerGroupId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get customer group contact from API
	 * @return {Promise} Axios promise
	 */
	function getCustomerGroupContact(id) {
	  var url = _constants.API_URL + '/CustomerGroupContact/Get/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Create/save customer group contact
	 * @return {Promise} Axios promise
	 */
	function createSaveCustomerGroupContact(data) {
	  var url = _constants.API_URL + '/CustomerGroupContact/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomerContactsInfo = getCustomerContactsInfo;
	exports.updateCustomerWPInfo = updateCustomerWPInfo;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description get Customer contacts
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/customerWP
	 */
	function getCustomerContactsInfo(id) {
	  var url = _constants.API_URL + '/Customer/Workprovider/Contacts/' + id;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Creating/saving a customer
	 * @return {Promise} Axios promise
	 */
	function updateCustomerWPInfo(data) {
	  var url = _constants.API_URL + '/Customer/Workprovider/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDocQuality = getDocQuality;
	exports.getDocProcess = getDocProcess;
	exports.getDocPhoto = getDocPhoto;
	exports.getDocDeviations = getDocDeviations;
	exports.getDocEvaluations = getDocEvaluations;
	exports.getDocOtherDamages = getDocOtherDamages;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting documentation from API
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/documentation
	 */
	function getDocQuality(orderId) {
	  var url = _constants.API_URL + '/QualityCheck/PerformedChecks/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting documentation from API
	 * @return {Promise} Axios promise
	 */
	function getDocProcess(orderId) {
	  var url = _constants.API_URL + '/Order/ProcessTime/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting documentation from API
	 * @return {Promise} Axios promise
	 */
	function getDocPhoto(orderId) {
	  var url = _constants.API_URL + '/Order/PhotoDocumentation/get/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting documentation from API
	 * @return {Promise} Axios promise
	 */
	function getDocDeviations(orderId) {
	  var url = _constants.API_URL + '/Order/Deviations/Get/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting documentation from API
	 * @return {Promise} Axios promise
	 */
	function getDocEvaluations(orderId) {
	  var url = _constants.API_URL + '/Order/Evaluations/Get/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting documentation from API
	 * @return {Promise} Axios promise
	 */
	function getDocOtherDamages(orderId) {
	  var url = _constants.API_URL + '/Order/OtherDamages/Get/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCompaniesFromToken = getCompaniesFromToken;
	exports.loginWithToken = loginWithToken;
	exports.setCurrentUser = setCurrentUser;
	exports.logout = logout;
	exports.getStyle = getStyle;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _setAuthorizationToken = __webpack_require__(206);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCompaniesFromToken(token, usageString) {
	  var usage = 0;
	  switch (usageString) {
	    case 'bookingportal':
	      usage = 1;
	      break;
	  }
	  var url = _constants.API_URL + '/Embedded/Companies/';
	  var data = {
	    token: token,
	    usage: usage
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	function loginWithToken(token, usageString) {
	  var usage = 0;
	  switch (usageString) {
	    case 'bookingportal':
	      usage = 1;
	      break;
	  }
	  var url = _constants.API_URL + '/Embedded/LoginToken/';
	  var data = {
	    token: token,
	    usage: usage
	  };
	
	  return function (dispatch) {
	    window.localStorage.clear();
	    return _axios2.default.post(url, data).then(function (res) {
	      var token = res.data.Token;
	      window.localStorage.setItem('user_token', token);
	      window.localStorage.setItem('user_data', JSON.stringify(res.data));
	      (0, _setAuthorizationToken.setAuthorizationToken)(token);
	      (0, _setAuthorizationToken.setDeviceToken)(res.data.DeviceToken);
	      dispatch(setCurrentUser(res.data));
	      return res;
	    });
	  };
	}
	
	function setCurrentUser(user) {
	  return {
	    type: _constants.SET_CURRENT_USER,
	    user: user
	  };
	}
	
	function logout() {
	  return function (dispatch) {
	    window.localStorage.removeItem('user_token');
	    window.localStorage.removeItem('user_data');
	    window.localStorage.removeItem('user_language');
	    (0, _setAuthorizationToken.setAuthorizationToken)(false);
	    (0, _setAuthorizationToken.setDeviceToken)(false);
	    dispatch(setCurrentUser({}));
	  };
	}
	
	function getStyle(token, usageString) {
	  var usage = 0;
	  switch (usageString) {
	    case 'bookingportal':
	      usage = 1;
	      break;
	  }
	  var url = _constants.API_URL + '/Embedded/Companies/Style/';
	  var data = {
	    token: token,
	    usage: usage
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOrderFileSharing = getOrderFileSharing;
	exports.saveOrderFileSharing = saveOrderFileSharing;
	exports.getOrderFileSizes = getOrderFileSizes;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get order files for sharing purpose
	 * @return {Promise} Axios promise
	 * @param {orderId} orderId
	 */
	/**
	 * @module actions/orderfiles
	 */
	function getOrderFileSharing(orderId) {
	  var url = _constants.API_URL + '/FileService/GetOrderFiles/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Save sharing marking on order files
	 * @return {Promise} Axios promise
	 */
	function saveOrderFileSharing(data) {
	  var url = _constants.API_URL + '/FileService/OrderFileSharing/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get size of order files
	 * @return {Promise} Axios promise
	 */
	function getOrderFileSizes(fileIds) {
	  var url = _constants.FILE_STORAGE_API + '/FileService/OrderFileSizes';
	  return function (dispatch) {
	    return _axios2.default.post(url, fileIds);
	  };
	}

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPriceModelConflicts = getPriceModelConflicts;
	exports.getPriceModelConflictsCustomer = getPriceModelConflictsCustomer;
	exports.updatePriceModelConflicts = updatePriceModelConflicts;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting pricelist conflicts by wpId
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/priceModelConclict
	 */
	function getPriceModelConflicts(wpId) {
	  var url = _constants.API_URL + '/PriceModelConflict/' + wpId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Getting pricelist conflicts for customer
	 * @return {Promise} Axios promise
	 */
	function getPriceModelConflictsCustomer(customerId) {
	  var url = _constants.API_URL + '/PriceModelConflict/Get/' + customerId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description update pricelist conflict
	 * @return {Promise} Axios promise
	 */
	function updatePriceModelConflicts(data) {
	  var url = _constants.API_URL + '/PriceModelConflict/Post/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendSignup = sendSignup;
	exports.upgradeRequest = upgradeRequest;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	var _setAuthorizationToken = __webpack_require__(206);
	
	var _auth = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Sends signup info
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/signup
	 */
	function sendSignup(data) {
	  var url = _constants.API_URL + '/Users/Free/Signup';
	  return function (dispatch) {
	    return _axios2.default.post(url, data).then(function (res) {
	      var token = res.data.Token;
	      window.localStorage.setItem('user_token', token);
	      window.localStorage.setItem('user_data', JSON.stringify(res.data));
	      window.localStorage.setItem('user_language', 'English');
	      (0, _setAuthorizationToken.setAuthorizationToken)(token);
	      (0, _setAuthorizationToken.setDeviceToken)(res.data.DeviceToken);
	      dispatch((0, _auth.setCurrentUser)(res.data));
	      return res;
	    });
	  };
	}
	
	function upgradeRequest(name, phone, userId) {
	  var url = _constants.API_URL + '/Users/RequestPro';
	  var data = {
	    Name: name,
	    PhoneNumber: phone,
	    UserId: userId
	  };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1379);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _customers = __webpack_require__(74);
	
	var _priceModel = __webpack_require__(75);
	
	var _settings = __webpack_require__(51);
	
	var _Delivery = __webpack_require__(229);
	
	var _Delivery2 = _interopRequireDefault(_Delivery);
	
	var _HelpText = __webpack_require__(130);
	
	var _HelpText2 = _interopRequireDefault(_HelpText);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _constants = __webpack_require__(5);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// contants
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      customer: {
	        CustomerId: 0,
	        CountryId: 0,
	        Active: true,
	        ForsiActive: false,
	        ForsiSelf: false,
	        ShowTransport: true,
	        CompanyCVR: '',
	        CompanyPhoneNumber: '',
	        CompanyDepartment: 0,
	        PhoneCode: _this.props.phonecode,
	        Notes: '',
	        PNumber: '',
	        OriginalShopName: '',
	        contractTypeSelected: 0,
	        RentLogContractTypeInfo: null,
	        ContractTypeListFromRentLog: []
	      },
	      deliveryTimes: [],
	      hasAgreementPriceModel: false,
	      workProviderName: '',
	      deliveryHourColSpan: '1'
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.loadData = _this.loadData.bind(_this);
	    _this.addCustomer = _this.addCustomer.bind(_this);
	    _this.saveAddCustomer = _this.saveAddCustomer.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.item /*  && this.props.item.CustomerId */) {
	          this.loadData(this.props.item.CustomerId);
	        }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // console.log('view nextProps', nextProps.item, this.props.item)
	      if (this.props.item.CustomerId !== nextProps.item.CustomerId) {
	        this.loadData(nextProps.item.CustomerId);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      var value = e.target.value;
	      var name = e.target.name;
	
	      if (name === 'contractTypeSelected') {
	        name = 'RentLogContractTypeInfo';
	        if (value === 0) return;
	        var newRentLogContractInfo = {
	          CustomerId: this.props.item.CustomerId,
	          RentLogContractTypeOid: value,
	          CompanyId: this.props.auth.user.ShopId
	        };
	        value = newRentLogContractInfo;
	      }
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      this.setState({
	        type: this.state.type,
	        customer: _extends({}, this.state.customer, _defineProperty({}, name, value))
	      }, function () {
	        if (e.target.type === 'checkbox' || name === 'CompanyDepartment' || name === 'CountryId' || name === 'RentLogContractTypeInfo') {
	          _this2.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(e) {
	      var _this3 = this;
	
	      var value = e.target.value;
	      var name = e.target.name;
	      if (e.target.name === 'PhoneNumber') {
	        name = 'CompanyPhoneNumber';
	        this.setState({
	          customer: _extends({}, this.state.customer, _defineProperty({}, name, value))
	        });
	      } else {
	        this.setState({
	          customer: _extends({}, this.state.customer, {
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        }, function () {
	          _this3.saveAddCustomer();
	        });
	      }
	    }
	  }, {
	    key: 'checkHasAgreementPriceModel',
	    value: function checkHasAgreementPriceModel() {
	      if (this.state.PriceModels.length <= 0) return;
	      var pm = this.state.PriceModels.find(function (_) {
	        return _.AgreementConstraintId > 0;
	      });
	      if (!pm || this.state.hasAgreementPriceModel) return;
	      this.setState({
	        hasAgreementPriceModel: true,
	        workProviderName: pm.WorkProviderName
	      });
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(CustomerId) {
	      var _this4 = this;
	
	      if (CustomerId === undefined || CustomerId <= 0) return this.resetCreate();
	      this.props.getPriceLists(CustomerId, 0).then(function (res) {
	        return _this4.setState({ PriceModels: res.data }, function () {
	          return _this4.checkHasAgreementPriceModel();
	        });
	      }).catch(function (err) {
	        return console.log(err);
	      });
	      this.props.getCustomer(CustomerId).then(function (res) {
	        return _this4.setState({ type: 'edit', customer: res.data });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	      });
	      this.props.getAgreementsDeliveryInformation(CustomerId, this.props.auth.user.ShopId).then(function (res) {
	        return _this4.setState({ deliveryTimes: res.data });
	      }).catch(function (err) {
	        return console.log(err);
	      });
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      var _this5 = this;
	
	      var chainCountryId = null;
	      if (this.props.countries && this.props.auth.user.ChainCountry) {
	        var country = this.props.countries.find(function (c) {
	          return c.CountryName === parseInt(_this5.props.auth.user.ChainCountry);
	        });
	        if (country) chainCountryId = country.Id;
	      }
	
	      this.setState({
	        type: 'create',
	        customer: {
	          CustomerId: 0,
	          CompanyName: '',
	          CompanyAddress: '',
	          CountryId: chainCountryId,
	          CompanyZipCode: '',
	          CompanyCity: '',
	          CompanyCVR: '',
	          CompanyPhoneNumber: '',
	          PhoneCode: this.props.phonecode,
	          Active: true,
	          ForsiActive: false,
	          ForsiCustomerNumber: '',
	          ForsiMinDate: '2017-01-01T00:00:00',
	          ForsiSelf: false,
	          DrivingTime: '',
	          ShowTransport: true,
	          AllowChangeDeliverytime: false,
	          LogDateChanges: false,
	          DebitorNumber: '',
	          DefaultHours: 48,
	          CompanyDepartment: 0,
	          DeliveryCustomerHourPrices: [],
	          Notes: '',
	          PNumber: '',
	          OriginalShopName: ''
	        },
	        deliveryTimes: [],
	        hasAgreementPriceModel: false,
	        workProviderName: '',
	        deliveryHourColSpan: '1'
	      });
	    }
	  }, {
	    key: 'saveAddCustomer',
	    value: function saveAddCustomer() {
	      var _this6 = this;
	
	      var customer = this.state.customer;
	
	      if (customer.CustomerId > 0) {
	        this.props.CreateSaveCustomer(this.state.customer).then(function (res) {
	          _this6.props.onSave(res.data, _this6.state.type);
	          setTimeout(function () {
	            _this6.props.getCustomers();
	          }, 0);
	        }, function (err) {
	          // Toastr
	          if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	            var errors = err.response.data.Errors;
	            var errText = '';
	            for (var i = 0; i < errors.length; i++) {
	              var dictKey = errors[i].DictionaryKey;
	              errText += '<br/>' + (0, _helpers.translation)(dictKey);
	            }
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('13465'), (0, _helpers.translation)('216'));
	          }
	        });
	      }
	      if (customer.CustomerId === undefined || customer.CustomerId === 0) {
	        this.validateCvrAndPNumberNewCustomer();
	      }
	    }
	  }, {
	    key: 'addCustomer',
	    value: function addCustomer() {
	      var _state = this.state,
	          customer = _state.customer,
	          type = _state.type;
	      var _props = this.props,
	          CreateSaveCustomer = _props.CreateSaveCustomer,
	          onSave = _props.onSave;
	
	      CreateSaveCustomer(customer).then(function (res) {
	        return onSave(res.data, type);
	      }).catch(function (err) {
	        if (!err.response.data.Errors) {
	          window.toastr.error((0, _helpers.translation)('13465'), (0, _helpers.translation)('216'));
	        }
	        var errText = err.response.data.Errors.map(function (e) {
	          return (0, _helpers.translation)(e.DictionaryKey);
	        }).join('<br/>');
	        window.toastr.error(errText, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var propName = typeof e === 'string' ? e : e.target.name;
	
	      if (!this.state.customer.CustomerId || this.state.customer.CustomerId <= 0) {
	        return this.validateCvrAndPNumberNewCustomer();
	      }
	      var _state2 = this.state,
	          customer = _state2.customer,
	          type = _state2.type;
	
	      /**
	       * If current prop it returns the new value, else null
	       * @param {String} prop Actual prop
	       * @param {Any} value New value of prop
	       */
	
	      var valueOrNull = function valueOrNull(prop, value) {
	        if (typeof propName === 'string') {
	          return propName === prop ? value : null;
	        }
	        return value;
	      };
	
	      var data = {
	        CustomerId: customer.CustomerId,
	        Active: valueOrNull('Active', customer.Active),
	        CompanyAddress: valueOrNull('CompanyAddress', customer.CompanyAddress),
	        CompanyCity: valueOrNull('CompanyCity', customer.CompanyCity),
	        CompanyCVR: valueOrNull('CompanyCVR', customer.CompanyCVR),
	        CompanyDepartment: valueOrNull('CompanyDepartment', customer.CompanyDepartment),
	        CompanyName: valueOrNull('CompanyName', customer.CompanyName),
	        CompanyPhoneNumber: valueOrNull('CompanyPhoneNumber', customer.CompanyPhoneNumber),
	        CompanyZipCode: valueOrNull('CompanyZipCode', customer.CompanyZipCode),
	        CountryId: valueOrNull('CountryId', customer.CountryId),
	        DebitorNumber: valueOrNull('DebitorNumber', customer.DebitorNumber),
	        DrivingTime: valueOrNull('DrivingTime', customer.DrivingTime),
	        ForsiActive: valueOrNull('ForsiActive', customer.ForsiActive),
	        ForsiCustomerNumber: valueOrNull('ForsiCustomerNumber', customer.ForsiCustomerNumber),
	        ForsiMinDateHasValue: valueOrNull('ForsiMinDate', true),
	        ForsiMinDate: valueOrNull('ForsiMinDate', customer.ForsiMinDate),
	        ForsiSelf: valueOrNull('ForsiSelf', customer.ForsiSelf),
	        MustApprovePriceChanges: valueOrNull('MustApprovePriceChanges', customer.MustApprovePriceChanges),
	        MustApproveAddon: valueOrNull('MustApproveAddon', customer.MustApproveAddon),
	        Notes: valueOrNull('Notes', customer.Notes),
	        OriginalShopName: valueOrNull('OriginalShopName', customer.OriginalShopName),
	        PhoneCode: valueOrNull('CompanyPhoneNumber', customer.PhoneCode),
	        PNumber: valueOrNull('PNumber', customer.PNumber),
	        ShowReferredTo: valueOrNull('ShowReferredTo', customer.ShowReferredTo),
	        ShowTransportHasValue: valueOrNull('ShowTransport', true),
	        ShowTransport: valueOrNull('ShowTransport', customer.ShowTransport),
	        WPDebitorNr: valueOrNull('WPDebitorNr', customer.WPDebitorNr),
	        WPPriceApprovalRequired: valueOrNull('WPPriceApprovalRequired', customer.WPPriceApprovalRequired),
	        RentLogContractTypeInfo: customer.RentLogContractTypeInfo
	      };
	
	      if (type === 'create' || !propName) {
	        data = customer;
	      }
	
	      var _props2 = this.props,
	          CreateSaveCustomer = _props2.CreateSaveCustomer,
	          onSave = _props2.onSave;
	
	      if (customer.CustomerId > 0) {
	        CreateSaveCustomer(data).then(function (res) {
	          return onSave(res.data, type);
	        }).catch(function (err) {
	          if (!err.response.data.Errors) {
	            window.toastr.error((0, _helpers.translation)('13465'), (0, _helpers.translation)('216'));
	          }
	          var errText = err.response.data.Errors.map(function (e) {
	            return (0, _helpers.translation)(e.DictionaryKey);
	          }).join('<br/>');
	          window.toastr.error(errText, (0, _helpers.translation)('216'));
	        });
	      }
	    }
	  }, {
	    key: 'validateCvrAndPNumberNewCustomer',
	    value: function validateCvrAndPNumberNewCustomer() {
	      var cvrAndPNumberDetails = {
	        cvr: this.state.customer.CompanyCVR,
	        countryId: this.state.customer.CountryId,
	        pnumber: this.state.customer.PNumber
	      };
	      this.props.ValidateCVRAndPNumber(cvrAndPNumberDetails).then(function (err) {
	        if (err.data !== undefined && err.data.Error !== null) {
	          var key = err.data.Error.DictionaryKey;
	          var errorText = '';
	          if (key !== 0) errorText += '<br />' + (0, _helpers.translation)(key);
	          window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'onDateChange',
	    value: function onDateChange(e) {
	      var _this7 = this;
	
	      if (!_moment2.default.isMoment(e)) return;
	      var customer = _extends({}, this.state.customer, { ForsiMinDate: e });
	      this.setState({ customer: customer }, function () {
	        return _this7.onBlur('ForsiMinDate');
	      });
	    }
	  }, {
	    key: 'renderCompany',
	    value: function renderCompany() {
	      var _this8 = this;
	
	      var _state3 = this.state,
	          customer = _state3.customer,
	          hasAgreementPriceModel = _state3.hasAgreementPriceModel,
	          workProviderName = _state3.workProviderName;
	
	      var IsPerformingCustomer = this.props.item.IsPerformingCustomer;
	      var disableEdit = IsPerformingCustomer;
	      var _props3 = this.props,
	          countries = _props3.countries,
	          isCustomer = _props3.isCustomer;
	
	      var wpName = workProviderName + ' ' + (0, _helpers.translation)('13452');
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: this.props.isCustomer ? (0, _helpers.translation)('700') : (0, _helpers.translation)('58') },
	        _react2.default.createElement(
	          _dropDown2.default,
	          {
	            name: 'CountryId',
	            disabled: disableEdit,
	            value: customer.CountryId,
	            onChange: this.onChange,
	            labelText: (0, _helpers.translation)('1701')
	          },
	          countries.map(function (country, key) {
	            var label = (0, _helpers.translation)(country.CountryName);
	            return _react2.default.createElement(
	              'option',
	              { value: country.Id, key: key },
	              label
	            );
	          })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'CompanyCVR', value: customer.CompanyCVR || '', onChange: this.onChange, onBlur: this.saveAddCustomer, labelText: (0, _helpers.translation)('41'), disabled: disableEdit }),
	        _react2.default.createElement(_text2.default, { name: 'PNumber', value: customer.PNumber || '', onChange: this.onChange, onBlur: this.saveAddCustomer, labelText: (0, _helpers.translation)('15222'), disabled: disableEdit }),
	        _react2.default.createElement(_text2.default, { name: 'CompanyName', value: customer.CompanyName || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('30'), disabled: disableEdit }),
	        _react2.default.createElement(_text2.default, { name: 'CompanyAddress', value: customer.CompanyAddress || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('25') }),
	        _react2.default.createElement(_text2.default, { name: 'CompanyZipCode', value: customer.CompanyZipCode || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('40') }),
	        _react2.default.createElement(_text2.default, { name: 'CompanyCity', value: customer.CompanyCity || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('37') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('38') },
	          _react2.default.createElement(_Phone2.default, {
	            onChange: this.onPhoneChange,
	            onBlur: function onBlur() {
	              return _this8.onBlur('CompanyPhoneNumber');
	            },
	            code: customer.PhoneCode,
	            number: customer.CompanyPhoneNumber })
	        ),
	        IsPerformingCustomer && _react2.default.createElement(_text2.default, { labelText: 13452, helpText: 1945, name: 'DebitorNumber', value: customer.DebitorNumber || '', onChange: this.onChange, onBlur: this.onBlur }),
	        IsPerformingCustomer && hasAgreementPriceModel && _react2.default.createElement(_text2.default, { labelText: wpName, helpText: 1945, name: 'WPDebitorNr', value: customer.WPDebitorNr || '', onChange: this.onChange, onBlur: this.onBlur }),
	        !isCustomer && _react2.default.createElement(_textarea2.default, { name: 'Notes', onChange: this.onChange, value: customer.Notes || '', onBlur: this.onBlur, labelText: (0, _helpers.translation)('93') }),
	        IsPerformingCustomer && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: 16443 },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            customer.OriginalShopName
	          )
	        ),
	        !this.props.isCustomer && _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onChange, checked: customer.Active, labelText: (0, _helpers.translation)('295') })
	      );
	    }
	  }, {
	    key: 'renderSettings',
	    value: function renderSettings() {
	      var _this9 = this;
	
	      var _props4 = this.props,
	          auth = _props4.auth,
	          isCustomer = _props4.isCustomer;
	
	      if (isCustomer) return null;
	      if (this.props.item.IsPerformingCustomer) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(auth, 10, 0)) return null;
	      var onClick = function onClick(e) {
	        var value = e.currentTarget.dataset.value;
	        if (value === 'yes' && !customer.WPPriceApprovalRequired || value === 'no' && customer.WPPriceApprovalRequired) {
	          var errorText = (0, _helpers.translation)('14745');
	          errorText = errorText.replace(/\[WPName]/gi, _this9.state.workProviderName);
	          window.toastr.error(errorText, (0, _helpers.translation)('216'));
	        }
	      };
	
	      var _state4 = this.state,
	          customer = _state4.customer,
	          workProviderName = _state4.workProviderName;
	
	      var wpName = workProviderName + ' ' + (0, _helpers.translation)('13452');
	      var priceApprovalHelpText = (0, _helpers.translation)('14743');
	      var wpApprovalTitle = (0, _helpers.translation)('14742').replace(/\[WPName]/gi, workProviderName);
	      var wpApporvalHelpText = (0, _helpers.translation)('14744').replace(/\[WPName]/gi, workProviderName);
	
	      var showCustomerCompanyType = !isCustomer && auth.user.DepartmentType === 2;
	      var usedRentLog = this.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.RENTLOG;
	
	      var contractTypeListFromRentLog = [];
	      if (!customer.RentLogContractTypeInfo) contractTypeListFromRentLog.push({ Oid: 0, Name: (0, _helpers.translation)('890') });
	
	      customer.ContractTypeListFromRentLog && customer.ContractTypeListFromRentLog.map(function (val) {
	        contractTypeListFromRentLog.push({ Oid: val.Oid, Name: val.Name });
	      });
	      if (customer.RentLogContractTypeInfo && contractTypeListFromRentLog.length > 1) {
	        contractTypeListFromRentLog.filter(function (x) {
	          return x.Oid !== 0;
	        });
	      }
	
	      var contractTypeSelected = void 0;
	      customer.ContractTypeListFromRentLog && customer.ContractTypeListFromRentLog.map(function (val) {
	        if (customer.RentLogContractTypeInfo && customer.RentLogContractTypeInfo.RentLogContractTypeOid === val.Oid) contractTypeSelected = val.Oid;
	      });
	      var contractTypeOptions = contractTypeListFromRentLog.map(function (b, index) {
	        return _react2.default.createElement(
	          'option',
	          { key: index, value: b.Oid },
	          b.Name
	        );
	      });
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('6') },
	        showCustomerCompanyType && _react2.default.createElement(
	          'div',
	          { className: 'control__group settings' },
	          _react2.default.createElement(
	            'label',
	            null,
	            (0, _helpers.translation)('14857'),
	            ' ',
	            _react2.default.createElement(_HelpText2.default, { text: (0, _helpers.translation)('14858') })
	          ),
	          _react2.default.createElement(
	            'select',
	            { name: 'CompanyDepartment',
	              onChange: this.onChange,
	              value: customer.CompanyDepartment !== null ? customer.CompanyDepartment : 0 },
	            _react2.default.createElement(
	              'option',
	              { value: 0 },
	              (0, _helpers.translation)('161')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 1 },
	              (0, _helpers.translation)('14779')
	            )
	          )
	        ),
	        _react2.default.createElement(_text2.default, { name: 'DrivingTime', value: customer.DrivingTime || '', onChange: this.onChange, onBlur: this.onBlur, disabled: !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0), labelText: (0, _helpers.translation)('13449'), helpText: (0, _helpers.translation)('308') }),
	        _react2.default.createElement(_switch2.default, { name: 'ShowTransport', onChange: this.onChange, checked: customer.ShowTransport, labelText: (0, _helpers.translation)('603'), helpText: (0, _helpers.translation)('1944') }),
	        (0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && this.props.auth.user.DepartmentType !== 1 && _react2.default.createElement(_switch2.default, { name: 'MustApprovePriceChanges', onChange: this.onChange, checked: customer.MustApprovePriceChanges, labelText: (0, _helpers.translation)('2044'), helpText: priceApprovalHelpText }),
	        (0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && this.props.auth.user.DepartmentType !== 1 && _react2.default.createElement(_switch2.default, { name: 'MustApproveAddon', onChange: this.onChange, checked: customer.MustApproveAddon, labelText: (0, _helpers.translation)(16824), helpText: (0, _helpers.translation)(16825) }),
	        this.state.hasAgreementPriceModel && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: wpApprovalTitle, helpText: wpApporvalHelpText },
	          _react2.default.createElement(_radio2.default, { id: 'WPPriceApprovalRequired_yes', name: 'WPPriceApprovalRequired', value: 'yes', onChange: this.onChange, checked: customer.WPPriceApprovalRequired, readOnly: true, disabled: true, labelText: (0, _helpers.translation)('47'), onClick: onClick }),
	          _react2.default.createElement(_radio2.default, { id: 'WPPriceApprovalRequired_no', name: 'WPPriceApprovalRequired', value: 'no', onChange: this.onChange, checked: !customer.WPPriceApprovalRequired, readOnly: true, disabled: true, labelText: (0, _helpers.translation)('48'), onClick: onClick })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'DebitorNumber', value: customer.DebitorNumber || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('13452'), helpText: (0, _helpers.translation)('1945') }),
	        this.state.hasAgreementPriceModel && _react2.default.createElement(_text2.default, { name: 'WPDebitorNr', value: customer.WPDebitorNr || '', onChange: this.onChange, onBlur: this.onBlur, labelText: wpName, helpText: (0, _helpers.translation)('1945') }),
	        usedRentLog && _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'contractTypeSelected', value: contractTypeSelected, onChange: this.onChange, labelText: (0, _helpers.translation)('18130') },
	          contractTypeOptions
	        ),
	        (0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && _react2.default.createElement(_switch2.default, { name: 'ShowReferredTo', onChange: this.onChange, checked: customer.ShowReferredTo, labelText: (0, _helpers.translation)('14931'), helpText: (0, _helpers.translation)('14932') })
	      );
	    }
	  }, {
	    key: 'renderForsi',
	    value: function renderForsi() {
	      if (this.props.item.IsPerformingCustomer) return null;
	      if (this.props.auth.permissions.ChainAssessmentSystem === 2) return null; // DBS
	      var _props5 = this.props,
	          auth = _props5.auth,
	          isCustomer = _props5.isCustomer;
	
	      if (isCustomer) return false;
	      var customer = this.state.customer;
	
	      var showTime = false;
	      var closeOnSelect = true;
	      var date = customer.ForsiMinDate;
	      if (typeof date === 'undefined' || date === null || date === '') {
	        date = window.CustomDate('2017-01-01T00:00:00');
	      } else {
	        date = window.CustomDate(date);
	      }
	      var inputProps = {
	        name: 'ForsiMinDate',
	        readOnly: true
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13438') },
	        _react2.default.createElement(_switch2.default, { name: 'ForsiActive', onChange: this.onChange, checked: customer.ForsiActive, labelText: (0, _helpers.translation)('295') }),
	        _react2.default.createElement(_text2.default, {
	          name: 'ForsiCustomerNumber',
	          value: customer.ForsiCustomerNumber || '',
	          onChange: this.onChange,
	          onBlur: this.onBlur,
	          disabled: customer.IsOwnShop || auth.departmentType === 1 && !(0, _auth.hasSubscriptionPermission)(auth, 30),
	          labelText: (0, _helpers.translation)('14803'),
	          helpText: (0, _helpers.translation)('1947')
	        }),
	        _react2.default.createElement(_datetime2.default, {
	          inputProps: inputProps,
	          dateFormat: 'DD-MM-YYYY',
	          timeFormat: showTime,
	          closeOnSelect: closeOnSelect,
	          value: date,
	          onChange: this.onDateChange.bind(this),
	          labelText: (0, _helpers.translation)('388'),
	          helpText: (0, _helpers.translation)('1946')
	        })
	      );
	    }
	  }, {
	    key: 'renderRightRow',
	    value: function renderRightRow() {
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        !this.props.isCustomer && this.renderContacts(),
	        !this.props.isCustomer && this.renderPrices()
	      );
	    }
	  }, {
	    key: 'renderPrices',
	    value: function renderPrices() {
	      var _this10 = this;
	
	      var _state5 = this.state,
	          customer = _state5.customer,
	          PriceModels = _state5.PriceModels;
	      var auth = this.props.auth;
	
	      if (!(0, _auth.hasSubscriptionPermission)(auth, 10)) return;
	      if (customer.CustomerId === null || customer.CustomerId === 0) return;
	      if (typeof PriceModels === 'undefined') return null;
	
	      // Group lists.
	      var groups = {
	        Undefined: [],
	        Insurance: [],
	        Sales: [],
	        Warranty: [],
	        Private: [],
	        Other: [],
	        Complaint: [],
	        Addon: [],
	        Extra: [],
	        Estimation: [],
	        UnGrouped: []
	      };
	      var groupsBody = {
	        Undefined: [],
	        Insurance: [],
	        Sales: [],
	        Warranty: [],
	        Private: [],
	        Other: [],
	        Complaint: [],
	        Addon: [],
	        Discounts: [],
	        Extra: [],
	        Estimation: [],
	        UnGrouped: []
	      };
	
	      var paintCount = 0;
	      var bodyCount = 0;
	
	      for (var i = 0; i < PriceModels.length; i++) {
	        var item = PriceModels[i];
	        if ([4, 5, 8].indexOf(item.PriceType) !== -1 && !(0, _auth.hasSubscriptionPermission)(auth, 30)) continue;
	        if ([-1, 0, 1, 2, 3].indexOf(item.PriceType) !== -1 && !(0, _auth.hasSubscriptionPermission)(auth, 20)) continue;
	        if ([-10].indexOf(item.PriceType) !== -1 && !(0, _auth.hasSubscriptionPermission)(auth, 10)) continue;
	        var foundGroup = item.Department === 1 ? groupsBody : groups;
	        if (foundGroup === groups) paintCount++;
	        if (foundGroup === groupsBody) bodyCount++;
	        switch (item.PriceType) {
	          case -1:
	            // Undefined
	            foundGroup.Undefined.push(item);
	            break;
	          case 0:
	            // Other
	            foundGroup.Other.push(item);
	            break;
	          case 1:
	            // Salescar
	            foundGroup.Sales.push(item);
	            break;
	          case 2:
	            // Private
	            foundGroup.Private.push(item);
	            break;
	          case 3:
	            // Warranty
	            foundGroup.Warranty.push(item);
	            break;
	          case 4:
	            // Extra
	            foundGroup.UnGrouped.push(item);
	            break;
	          case 5:
	            // Estimation
	            if (item.Name !== null) {
	              foundGroup.Insurance.push(item);
	            } else {
	              if (item.Department === 0) {
	                groups.UnGrouped.push(item);
	              }
	            }
	            break;
	          case 6:
	            // Complaint
	            foundGroup.Complaint.push(item);
	            break;
	          case 8:
	            foundGroup.Addon.push(item);
	            break;
	          // case -10: // Discounts
	          //   if (item.Department === 1) {
	          //     foundGroup.Discounts.push(item)
	          //   } else {
	          //     foundGroup.UnGrouped.push(item)
	          //   }
	          //   break
	        }
	      }
	
	      var renderGroup = function renderGroup(val, key) {
	        var groupTitle = (0, _helpers.translation)(key);
	        if (key === 'UnGrouped') {
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            val.map(renderPrice)
	          );
	        } else if (key === 'Discounts') {
	          return _react2.default.createElement(
	            _labelWrapper2.default,
	            { key: key, labelText: (0, _helpers.translation)('1197') },
	            _this10.state.customer.Discounts !== null && _this10.state.customer.Discounts.map(renderDiscountList)
	          );
	        } else {
	          return _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: groupTitle, key: key },
	            val.length > 0 && val.map(renderPrice)
	          );
	        }
	      };
	
	      var renderDiscountList = function renderDiscountList(val, key) {
	        var text = (0, _helpers.translation)((0, _helpers.enumtranslate)('OrderTypes', val.OrderType));
	        if (val.IsAddonPrice && val.OrderType === 1) {
	          text = (0, _helpers.translation)('1396');
	          return _react2.default.createElement(
	            _label2.default,
	            { key: key },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { key: 'Addon', to: '/customers/' + customer.CustomerId + '/prices/discounts/' + val.Department + '/Addon' },
	              text
	            )
	          );
	        } else {
	          if (val.OrderType === 1) text = (0, _helpers.translation)('70');
	          if (val.OrderType === 4) text = (0, _helpers.translation)('2263');
	          return _react2.default.createElement(
	            _label2.default,
	            { key: key },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { key: val.OrderType, to: '/customers/' + customer.CustomerId + '/prices/discounts/' + val.Department + '/' + val.OrderType },
	              text
	            )
	          );
	        }
	      };
	
	      var renderPrice = function renderPrice(val, key) {
	        var text = val.Name === null || val.Name === '' ? null : val.Name;
	        if (text !== null && (val.Brand !== null || val.WorkProviderName !== null)) {
	          text += ' (';
	          if (val.Brand !== null) {
	            text += val.Brand;
	          }
	          if (val.Brand !== null && val.WorkProviderName !== null) {
	            text += '/';
	          }
	          if (val.WorkProviderName !== null) {
	            text += val.WorkProviderName;
	          }
	          text += ')';
	        }
	        var extraClass = !val.Active ? 'disabled' : '';
	        var link = val.PriceModelId;
	        if (text === null) {
	          switch (val.PriceType) {
	            case 0:
	              text = (0, _helpers.translation)('73'); // salescar
	              break;
	            case 1:
	              text = (0, _helpers.translation)('71'); // salescar
	              break;
	            case 2:
	              text = (0, _helpers.translation)('785'); // private
	              break;
	            case 3:
	              text = (0, _helpers.translation)('13361'); // warranty
	              break;
	            case 4:
	              text = (0, _helpers.translation)('2224');
	              link = 'extras/' + val.Department;
	              break;
	            case 5:
	              text = (0, _helpers.translation)('13363');
	              link = 'estimation/' + val.Department;
	              break;
	            case 6:
	              text = (0, _helpers.translation)('301'); // salescar
	              break;
	            // case -10:
	            //   if (val.Department !== 1) {
	            //     text = translation('1197') // Discounts
	            //     link = 'discounts/' + val.Department
	            //   }
	            //   break
	          }
	        }
	        return _react2.default.createElement(
	          _label2.default,
	          { key: key },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: extraClass, to: '/customers/' + customer.CustomerId + '/prices/' + link },
	            text
	          )
	        );
	      };
	
	      var renderListHeader = function renderListHeader(title) {
	        return _react2.default.createElement(_panelHeader2.default, { text: title });
	      };
	      var renderGroups = function renderGroups(count, header, groups, bodyDiscounts) {
	        if (count === 0) return null;
	        return _react2.default.createElement(
	          'div',
	          null,
	          renderListHeader(header),
	          (0, _auth.hasSubscriptionPermission)(_this10.props.auth, 20) && renderGroup(groups['Undefined'], '2036'),
	          (0, _auth.hasSubscriptionPermission)(_this10.props.auth, 20) && renderGroup(groups['Insurance'], '13360'),
	          (0, _auth.hasSubscriptionPermission)(_this10.props.auth, 20) && renderGroup(groups['Sales'], '71'),
	          (0, _auth.hasSubscriptionPermission)(_this10.props.auth, 20) && renderGroup(groups['Warranty'], '13361'),
	          (0, _auth.hasSubscriptionPermission)(_this10.props.auth, 20) && renderGroup(groups['Private'], '785'),
	          (0, _auth.hasSubscriptionPermission)(_this10.props.auth, 20) && renderGroup(groups['Other'], '73'),
	          (0, _auth.hasSubscriptionPermission)(_this10.props.auth, 30) && renderGroup(groups['Complaint'], '301'),
	          (0, _auth.hasSubscriptionPermission)(_this10.props.auth, 30) && renderGroup(groups['Addon'], '1396'),
	          (0, _auth.hasSubscriptionPermission)(_this10.props.auth, 10) && renderGroup(groups['Discounts'], 'Discounts'),
	          renderGroup(groups['UnGrouped'], 'UnGrouped')
	        );
	      };
	
	      var customTitle = !(0, _auth.hasSubscriptionPermission)(this.props.auth, 20) ? (0, _helpers.translation)('1197') : (0, _helpers.translation)('1172');
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: customTitle },
	        _react2.default.createElement(
	          _actions2.default,
	          null,
	          !this.props.item.IsPerformingCustomer && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/customers/' + customer.CustomerId + '/prices' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': (0, _helpers.translation)('2042') },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't' })
	            )
	          )
	        ),
	        renderGroups(paintCount, (0, _helpers.translation)('161'), groups, false),
	        renderGroups(bodyCount, (0, _helpers.translation)('788'), groupsBody, true)
	      );
	    }
	  }, {
	    key: 'renderContacts',
	    value: function renderContacts() {
	      var customer = this.state.customer;
	
	      if (customer.CustomerId === undefined || customer.CustomerId === 0) return null;
	      // Render contact
	      var renderContact = function renderContact(val, key) {
	        if (!val.Active) return null;
	        return _react2.default.createElement(
	          _label2.default,
	          { key: key },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/customers/' + customer.CustomerId + '/contacts/' + val.UserId },
	            val.Name
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13460') },
	        _react2.default.createElement(
	          _actions2.default,
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/customers/' + customer.CustomerId + '/contacts' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': (0, _helpers.translation)('2043') },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't' })
	            )
	          )
	        ),
	        customer.Contacts !== undefined && customer.Contacts !== null ? customer.Contacts.map(renderContact) : undefined
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      // let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
	      var _state6 = this.state,
	          customer = _state6.customer,
	          deliveryTimes = _state6.deliveryTimes,
	          type = _state6.type;
	
	      var canRender = customer.CustomerId > 0 && type === 'edit' && !this.props.isCustomer && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) && this.props.auth.departmentType !== 1 && !this.props.item.IsPerformingCustomer;
	      var onDeliveryHourLayoutChange = function onDeliveryHourLayoutChange(colSpan) {
	        // console.log('update.....')
	        _this11.setState({
	          deliveryHourColSpan: colSpan
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderCompany()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderSettings(),
	          this.renderForsi()
	        ),
	        type === 'edit' && this.renderRightRow(),
	        _react2.default.createElement(
	          _col2.default,
	          { span: '4' },
	          canRender && _react2.default.createElement(_Delivery2.default, { type: 'customer', isShop: false, CustomerId: customer.CustomerId, onLayoutChange: onDeliveryHourLayoutChange }),
	          canRender && deliveryTimes.map(function (val, index) {
	            return _react2.default.createElement(_Delivery2.default, { key: index, isShop: true, isAgreement: true, item: val, agreementId: val.PriceModelId, CustomerId: val.CustomerId, onLayoutChange: onDeliveryHourLayoutChange });
	          })
	        )
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes,
	    countries: state.common.countries
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  CreateSaveCustomer: _customers.CreateSaveCustomer,
	  getCustomers: _customers.getCustomers,
	  getCustomer: _customers.getCustomer,
	  getPriceLists: _priceModel.getPriceLists,
	  getAgreementsDeliveryInformation: _settings.getAgreementsDeliveryInformation,
	  ValidateCVRAndPNumber: _customers.ValidateCVRAndPNumber
	}, null, { withRef: true })(View);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _esg = __webpack_require__(113);
	
	var _helpers = __webpack_require__(2);
	
	var _currency = __webpack_require__(41);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	__webpack_require__(253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var EntryRestriction = { Hide: 0, CanSee: 1, CanEnterData: 2 };
	
	var Categories = function (_Component) {
	  _inherits(Categories, _Component);
	
	  function Categories(props) {
	    _classCallCheck(this, Categories);
	
	    var _this = _possibleConstructorReturn(this, (Categories.__proto__ || Object.getPrototypeOf(Categories)).call(this, props));
	
	    _this.cols = ['3fr', [2, 2], [6, 1]];
	    _this.maxDecimals = 3;
	    return _this;
	  }
	
	  _createClass(Categories, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var propCategories = this.props.categories;
	      var disableAllInput = this.props.disableAllInput;
	
	      var renderCategory = function renderCategory(category, index) {
	        var applyCategoryChange = function applyCategoryChange(change) {
	          var categories = [].concat(_toConsumableArray(propCategories));
	          categories[index] = _extends({}, category, change);
	          _this2.props.bubbleUpChange({ Categories: categories });
	        };
	
	        var renderLine = function renderLine(line, index) {
	          var applyLineCahnge = function applyLineCahnge(change) {
	            var lines = [].concat(_toConsumableArray(category.Lines));
	            lines[index] = _extends({}, line, change);
	            applyCategoryChange({ Lines: lines });
	          };
	
	          var saveLine = function saveLine() {
	            var data = _extends({}, line);
	            data.Q1Amount = (0, _currency.reverseFormatCurrency2)(data.Q1Amount);
	            data.Q2Amount = (0, _currency.reverseFormatCurrency2)(data.Q2Amount);
	            data.Q3Amount = (0, _currency.reverseFormatCurrency2)(data.Q3Amount);
	            data.Q4Amount = (0, _currency.reverseFormatCurrency2)(data.Q4Amount);
	
	            _this2.props.postCompanyLine(data).then(function (res) {
	              applyLineCahnge(res.data);
	              window.toastr.success((0, _helpers.translation)(893), (0, _helpers.translation)('13424'));
	            }, function () {
	              window.toastr.error((0, _helpers.translation)(960), (0, _helpers.translation)('216'));
	            });
	          };
	
	          var onLineChange = function onLineChange(_ref) {
	            var _ref$target = _ref.target,
	                value = _ref$target.value,
	                name = _ref$target.name;
	            return applyLineCahnge(_defineProperty({}, name, value));
	          };
	          return _react2.default.createElement(
	            _tableRow2.default,
	            { key: index, cols: _this2.cols, className: 'line' },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              line.Name
	            ),
	            line.EntryRestriction === EntryRestriction.Hide && _react2.default.createElement('div', null),
	            line.EntryRestriction === EntryRestriction.CanSee && _react2.default.createElement(
	              _label2.default,
	              null,
	              line.EntryValue
	            ),
	            line.EntryRestriction === EntryRestriction.CanEnterData && _react2.default.createElement(_text2.default, { size: 's', name: 'EntryValue', value: line.EntryValue, onChange: onLineChange, onBlur: function onBlur() {
	                return saveLine();
	              } }),
	            line.UnitRestriction === EntryRestriction.Hide && _react2.default.createElement('div', null),
	            line.UnitRestriction === EntryRestriction.CanSee && _react2.default.createElement(
	              _label2.default,
	              null,
	              line.UnitValue
	            ),
	            line.UnitRestriction === EntryRestriction.CanEnterData && _react2.default.createElement(_text2.default, { size: 's', name: 'UnitValue', value: line.UnitValue, onChange: onLineChange, onBlur: function onBlur() {
	                return saveLine();
	              } }),
	            _react2.default.createElement(_DecimalInput2.default, { size: 's', name: 'Q1Amount', value: line.Q1Amount, onChange: onLineChange, onBlur: function onBlur() {
	                return saveLine();
	              }, decimals: _this2.maxDecimals, disabled: disableAllInput }),
	            _react2.default.createElement(_DecimalInput2.default, { size: 's', name: 'Q2Amount', value: line.Q2Amount, onChange: onLineChange, onBlur: function onBlur() {
	                return saveLine();
	              }, decimals: _this2.maxDecimals, disabled: disableAllInput }),
	            _react2.default.createElement(_DecimalInput2.default, { size: 's', name: 'Q3Amount', value: line.Q3Amount, onChange: onLineChange, onBlur: function onBlur() {
	                return saveLine();
	              }, decimals: _this2.maxDecimals, disabled: disableAllInput }),
	            _react2.default.createElement(_DecimalInput2.default, { size: 's', name: 'Q4Amount', value: line.Q4Amount, onChange: onLineChange, onBlur: function onBlur() {
	                return saveLine();
	              }, decimals: _this2.maxDecimals, disabled: disableAllInput }),
	            _react2.default.createElement(_DecimalInput2.default, { size: 's', name: 'QTotal', value: line.QTotal, disabled: true }),
	            !line.ShowConvertedUnit && _react2.default.createElement('div', null),
	            line.ShowConvertedUnit && _react2.default.createElement(_DecimalInput2.default, { size: 's', name: 'QConverted', value: line.TotalConvertedUnit, disabled: true })
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'pg-mb-3' },
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true, cols: _this2.cols, className: 'category-header' },
	            _react2.default.createElement(
	              _label2.default,
	              { size: 's' },
	              category.Name
	            ),
	            !category.ShowEntryColumn && _react2.default.createElement('div', null),
	            category.ShowEntryColumn && _react2.default.createElement(
	              _label2.default,
	              { size: 's' },
	              category.EntryName
	            ),
	            !category.ShowUnitColumn && _react2.default.createElement('div', null),
	            category.ShowUnitColumn && _react2.default.createElement(
	              _label2.default,
	              { size: 's' },
	              category.UnitName
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              { size: 's' },
	              '1.\xA0' + (0, _helpers.translation)(18426)
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              { size: 's' },
	              '2.\xA0' + (0, _helpers.translation)(18426)
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              { size: 's' },
	              '3.\xA0' + (0, _helpers.translation)(18426)
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              { size: 's' },
	              '4.\xA0' + (0, _helpers.translation)(18426)
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              { size: 's' },
	              (0, _helpers.translation)(13353)
	            ),
	            !category.ShowConvertedUnitColumn && _react2.default.createElement('div', null),
	            category.ShowConvertedUnitColumn && _react2.default.createElement(
	              _label2.default,
	              { size: 's' },
	              category.UnitConversionName
	            )
	          ),
	          category.Lines.map(renderLine)
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        propCategories.map(renderCategory)
	      );
	    }
	  }]);
	
	  return Categories;
	}(_react.Component);
	
	Categories.propTypes = {
	  bubbleUpChange: _propTypes2.default.func.isRequired,
	  categories: _propTypes2.default.arrayOf(_propTypes.object).isRequired,
	  disableAllInput: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(null, {
	  postCompanyLine: _esg.postCompanyLine
	})(Categories);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _mypage = __webpack_require__(151);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _auth = __webpack_require__(8);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Elements
	
	
	var MyMessagesMessage = function (_Component) {
	  _inherits(MyMessagesMessage, _Component);
	
	  function MyMessagesMessage(props) {
	    _classCallCheck(this, MyMessagesMessage);
	
	    var _this = _possibleConstructorReturn(this, (MyMessagesMessage.__proto__ || Object.getPrototypeOf(MyMessagesMessage)).call(this, props));
	
	    _this.state = {
	      message: {}
	    };
	    return _this;
	  }
	
	  _createClass(MyMessagesMessage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof this.props.item !== 'undefined') {
	        this.setState({
	          message: this.props.item
	        });
	      } else {
	        this.getMessage(this.props);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (typeof this.props.item !== 'undefined') {
	        if (nextProps.item.Id !== this.props.item.Id) {
	          this.setState({
	            message: nextProps.item
	          });
	        }
	      } else {
	        if (nextProps.params.msgID !== this.props.params.msgID) {
	          this.getMessage(nextProps);
	        }
	      }
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage(props) {
	      var _this2 = this;
	
	      this.setState({
	        message: {}
	      });
	      this.props.getMessage(props.params.msgID).then(function (res) {
	        _this2.setState({
	          message: res.data
	        });
	        _this2.props.getMessages();
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1908'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderAttachments',
	    value: function renderAttachments(files) {
	      var _this3 = this;
	
	      if (files.length === 0) return null;
	      // // Image files
	      // let imgFiles = [...files]
	      // imgFiles = imgFiles.filter((val, index) => {
	      //   return val.IsImage
	      // })
	      // // Other files
	      // let otherFiles = [...files]
	      // otherFiles = otherFiles.filter((val, index) => {
	      //   return !val.IsImage
	      // })
	      var imgFiles = [];
	      var otherFiles = [];
	      files.forEach(function (file) {
	        file.IsImage ? imgFiles.push(file) : otherFiles.push(file);
	      });
	
	      var renderImage = function renderImage(image, key) {
	        var url = _constants.FILE_STORAGE + image.ThumbURL;
	        var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            'a',
	            { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	            _react2.default.createElement('img', { src: url })
	          )
	        );
	      };
	      var renderFile = function renderFile(file, key) {
	        // if (file.FileURL === null) return null
	        var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(_this3.props.auth.user.Token);
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileNameWithFolders;
	        return _react2.default.createElement(
	          'li',
	          { key: key, className: 'file-document' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          _react2.default.createElement(
	            'a',
	            { className: 'file', target: '_BLANK', href: newFileUrl },
	            file.FileName
	          )
	        );
	      };
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('352') },
	        otherFiles.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'docs' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            otherFiles.map(renderFile)
	          )
	        ),
	        imgFiles.length !== 0 && _react2.default.createElement(_Gallery2.default, { files: imgFiles, renderImage: renderImage })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      var message = this.state.message;
	
	      if (Object.keys(message).length === 0) return null;
	      // console.log(message)
	      var makeTime = function makeTime() {
	        return (0, _time.renderFullDate)(message.CreationDate, true, true);
	      };
	      var labelText = _react2.default.createElement(
	        _grid2.default,
	        { cols: [1, 'max-content'] },
	        message.SenderName,
	        _react2.default.createElement(
	          'span',
	          null,
	          makeTime()
	        )
	      );
	      return _react2.default.createElement(
	        'div',
	        { className: 'myMessagesMessage__screen' },
	        _react2.default.createElement(
	          _panel2.default,
	          null,
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: labelText },
	            message.Title
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          message.Body.split('\n').map(function (line, key) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'description', key: key },
	              line,
	              _react2.default.createElement('br', null)
	            );
	          }),
	          this.renderAttachments(message.MessageFiles)
	        )
	      );
	    }
	  }]);
	
	  return MyMessagesMessage;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getMessage: _mypage.getMessage
	})(MyMessagesMessage);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1410);
	
	var _mypage = __webpack_require__(151);
	
	var _backdrop = __webpack_require__(29);
	
	var _ActionMenu = __webpack_require__(230);
	
	var _ActionMenu2 = _interopRequireDefault(_ActionMenu);
	
	var _Task = __webpack_require__(284);
	
	var _Task2 = _interopRequireDefault(_Task);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _OthertaskHover = __webpack_require__(1056);
	
	var _OthertaskHover2 = _interopRequireDefault(_OthertaskHover);
	
	var _TaskOverlay = __webpack_require__(476);
	
	var _TaskOverlay2 = _interopRequireDefault(_TaskOverlay);
	
	var _helpers = __webpack_require__(2);
	
	var _common = __webpack_require__(25);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _time = __webpack_require__(17);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _icons = __webpack_require__(6);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	
	// Utils
	
	
	// import { hasSubscriptionPermission } from '../../../utils/auth'
	
	
	// Elements
	
	
	var MyTasks = function (_Component) {
	  _inherits(MyTasks, _Component);
	
	  function MyTasks(props) {
	    _classCallCheck(this, MyTasks);
	
	    var _this = _possibleConstructorReturn(this, (MyTasks.__proto__ || Object.getPrototypeOf(MyTasks)).call(this, props));
	
	    _this.state = {
	      tasks: {
	        CommonTasks: [],
	        MyTasks: [],
	        UnAssignedTasks: [],
	        UnspecifiedTasks: []
	      },
	      openTask: {
	        Show: false,
	        Task: null,
	        openTaskAsModal: false
	      }
	    };
	    _this.startTask = _this.startTask.bind(_this);
	    _this.getTasks = _this.getTasks.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(MyTasks, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getTasks();
	      this.checkStartStop(this.props);
	      _events2.default.addListener('UPDATE_TASKS_WORKSCREEN', this.getTasks);
	      _events2.default.addListener('UPDATE_TASKS_MYPAGE', this.getTasks);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _events2.default.removeListener('UPDATE_TASKS_WORKSCREEN', this.getTasks);
	      _events2.default.removeListener('UPDATE_TASKS_MYPAGE', this.getTasks);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.checkStartStop(nextProps);
	    }
	  }, {
	    key: 'checkStartStop',
	    value: function checkStartStop(props) {
	      if (props.occurrenceAction) {
	        var _props$occurrenceActi = props.occurrenceAction,
	            Id = _props$occurrenceActi.Id,
	            action = _props$occurrenceActi.action;
	
	        if (typeof this.props.handledAction === 'function') this.props.handledAction();
	        if (action === 'startStop') {
	          setTimeout(function () {
	            var orc = document.getElementById('taskId-' + Id);
	            if (orc) {
	              orc.getElementsByClassName('workers')[0].click();
	            }
	          }, 1900);
	        } else if (action === 'open') {
	          setTimeout(function () {
	            var orc = document.getElementById('taskId-' + Id);
	            if (orc) {
	              orc.getElementsByClassName('left')[0].click();
	            }
	          }, 100);
	        }
	      }
	    }
	  }, {
	    key: 'getTasks',
	    value: function getTasks() {
	      var _this2 = this;
	
	      this.props.getMyTasks(0).then(function (res) {
	        if (_this2.props.IsWorkscreen) {
	          res.data.MyTasks.map(function (x) {
	            return res.data.CommonTasks.push(x);
	          });
	          res.data.MyTasks = [];
	          res.data.CommonTasks.sort(function (a, b) {
	            return a.Deadline - b.Deadline;
	          });
	        }
	        _this2.setState({
	          tasks: res.data
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('2003'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderChild',
	    value: function renderChild() {
	      var child = '';
	      if (this.props.children !== null) {
	        child = _react2.default.cloneElement(this.props.children, {});
	      }
	      return child;
	    }
	  }, {
	    key: 'renderTasks',
	    value: function renderTasks() {
	      var _this3 = this;
	
	      var renderTask = function renderTask(val, item, key) {
	        var closeConfirm = function closeConfirm() {
	          _this3.setState({
	            confirm: {
	              showConfirmComplete: false
	            }
	          });
	        };
	        var onConfirm = function onConfirm() {
	          closeConfirm();
	          _this3.stopTask(true, _this3.state.confirm.orcId);
	        };
	        if (val && typeof val !== 'string') {
	          key = item;
	          item = val;
	          val = undefined;
	        }
	
	        var className = '';
	        var visited = '';
	        var color = '';
	        var currentUserWorking = '';
	        if (item.IsStarted) className = 'active';
	        if (item.MarkYellow) color = 'yellow';
	        if (item.IsOverdue) color = 'red';
	        if (item.IsCurrentUserWorking) currentUserWorking = 'isWorking ';
	        // Open task
	        var openTask = function openTask(task) {
	          var asmodal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	          if (_this3.props.IsWorkscreen && (0, _auth.hasAccess)([7], _this3.props.auth.user.UserType)) {
	            _this3.props.onStartAsShopLogin({ type: 'task', Id: item.OccurrenceId, action: 'open' });
	            return;
	          }
	
	          if (window.innerWidth <= 760) {
	            _this3.props.triggerPopup(true);
	          }
	          _this3.setState({
	            openTask: {
	              Show: true,
	              Task: item,
	              openTaskAsModal: asmodal
	            }
	          }, function () {
	            if (_this3.props.IsWorkscreen || window.innerWidth <= 760) _this3.props.openOverlay('TaskOverlay');
	          });
	        };
	
	        // Visited
	        if (_this3.state.openTask && _this3.state.openTask.Show && item.OccurrenceId === _this3.state.openTask.Task.OccurrenceId) {
	          visited = ' visited';
	        }
	
	        // const numOfChars = 60
	        var description = item.Description; // false && item.Description.length > numOfChars ? (item.Description.substring(0, numOfChars) + '...') : item.Description
	
	        var fileImg = '/images/svgs/workscreen/File.svg';
	        if (item.IsStarted) {
	          fileImg = '/images/svgs/workscreen/File-white.svg';
	        }
	
	        // Return
	        return _react2.default.createElement(
	          'li',
	          { key: key, className: 'clearfix' },
	          _react2.default.createElement(
	            'div',
	            { id: 'taskId-' + item.OccurrenceId, className: 'task__item' },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [1, 'min-content'], align: 'center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'item ' + className },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: [1, 'max-content'], align: 'end' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'left', onClick: openTask.bind(item) },
	                    _react2.default.createElement(
	                      _OthertaskHover2.default,
	                      { id: item.OccurrenceId, item: item },
	                      _react2.default.createElement(
	                        _labelWrapper2.default,
	                        { labelText: item.Title },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'category' },
	                          (0, _helpers.translation)(item.Category)
	                        )
	                      )
	                    ),
	                    _this3.props.IsWorkscreen !== true && _react2.default.createElement(
	                      'div',
	                      { className: 'messageBody' },
	                      description
	                    ),
	                    _this3.props.IsWorkscreen && item.HasFiles && _react2.default.createElement('img', { src: fileImg, className: 'files' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'right' },
	                    _this3.renderStartStop(val, item),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'deadline ' + currentUserWorking + color },
	                      item.Deadline ? (0, _time.renderFullDate)(item.Deadline, false) : ''
	                    )
	                  )
	                )
	              ),
	              _this3.props.IsWorkscreen !== true && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Chevron_Right, onClick: openTask.bind(item), className: className + visited })
	            )
	          ),
	          _this3.state.confirm && _this3.state.confirm.showConfirmComplete && _this3.state.confirm.orcId === item.OccurrenceId && _react2.default.createElement(
	            _Portal2.default,
	            { onPortalClose: closeConfirm },
	            _react2.default.createElement(_Confirm2.default, {
	              confirm: onConfirm,
	              notConfirm: closeConfirm,
	              renderText: function renderText() {
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('15104')
	                );
	              }
	            })
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'clearfix' },
	        this.props.IsWorkscreen !== true && [_react2.default.createElement(_panelHeader2.default, { key: '1', text: (0, _helpers.translation)('1889') }), _react2.default.createElement(
	          'ul',
	          { key: '2' },
	          this.state.tasks.MyTasks.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'no_tasks' },
	            (0, _helpers.translation)('1226')
	          ) : this.state.tasks.MyTasks.map(renderTask.bind(this, undefined))
	        )],
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('15088') }),
	        _react2.default.createElement(
	          'ul',
	          null,
	          this.state.tasks.CommonTasks.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'no_tasks' },
	            (0, _helpers.translation)('1226')
	          ) : this.state.tasks.CommonTasks.map(renderTask.bind(this, undefined))
	        ),
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('15089') }),
	        _react2.default.createElement(
	          'ul',
	          null,
	          this.state.tasks.UnAssignedTasks.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'no_tasks' },
	            (0, _helpers.translation)('1226')
	          ) : this.state.tasks.UnAssignedTasks.map(renderTask.bind(this, 'assign'))
	        ),
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('15090') }),
	        _react2.default.createElement(
	          'ul',
	          null,
	          this.state.tasks.UnspecifiedTasks.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'no_tasks' },
	            (0, _helpers.translation)('1226')
	          ) : this.state.tasks.UnspecifiedTasks.map(renderTask.bind(this, 'assign'))
	        )
	      );
	    }
	
	    // Function: start task
	
	  }, {
	    key: 'startTask',
	    value: function startTask(id) {
	      var _this4 = this;
	
	      var data = {
	        OccurrenceId: id
	      };
	      this.props.startOtherTask(data).then(function (res) {
	        if (res.status === 204) {
	          window.toastr.error((0, _helpers.translation)(res.data.DictionaryKey), (0, _helpers.translation)('216'));
	        } else {
	          if (_this4.props.IsWorkscreen === true) {
	            res.data.MyTasks.map(function (x) {
	              return res.data.CommonTasks.push(x);
	            });
	            res.data.MyTasks = [];
	            res.data.CommonTasks.sort(function (a, b) {
	              return a.Deadline - b.Deadline;
	            });
	          }
	          _this4.setState({
	            tasks: res.data
	          });
	          _this4.props.getPunchClockStats(); // missing function here!!
	        }
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1906'), (0, _helpers.translation)('216'));
	      });
	    }
	
	    // Function: stop task
	
	  }, {
	    key: 'stopTask',
	    value: function stopTask(FinishTask, id) {
	      var _this5 = this;
	
	      var data = {
	        OccurrenceId: id,
	        UserId: 0,
	        FinishTask: FinishTask
	      };
	      this.props.stopOtherTask(data).then(function (res) {
	        if (res.status === 204) {
	          window.toastr.error((0, _helpers.translation)(res.data.DictionaryKey), (0, _helpers.translation)('216'));
	        } else {
	          if (_this5.props.IsWorkscreen === true) {
	            res.data.MyTasks.map(function (x) {
	              return res.data.CommonTasks.push(x);
	            });
	            res.data.MyTasks = [];
	            res.data.CommonTasks.sort(function (a, b) {
	              return a.Deadline - b.Deadline;
	            });
	          }
	          _this5.setState({
	            tasks: res.data
	          });
	        }
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1907'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderStartStop',
	    value: function renderStartStop(val, item) {
	      var _this6 = this;
	
	      if (val && typeof val !== 'string') {
	        item = val;
	        val = undefined;
	      }
	
	      var initials = function initials() {
	        if (item.Assigns.length > 0) {
	          var names = '';
	          var init = init = item.Assigns[0].Item1;
	
	          if (item.Assigns.length > 1) {
	            init += '+';
	          }
	
	          item.Assigns.map(function (x) {
	            names += x.Item2 + '\n';
	          });
	
	          return _react2.default.createElement(
	            'span',
	            { className: 'hint--bottom', 'aria-label': names },
	            init
	          );
	        }
	      };
	
	      // Return stop task
	      if (item.IsCurrentUserWorking) {
	        var renderActionOpener = function renderActionOpener(opener) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'workers', onClick: opener },
	            _react2.default.createElement('img', { src: '/images/icons/Ring-White.png' }),
	            initials()
	          );
	        };
	        var renderActionMenu = function renderActionMenu() {
	          return _react2.default.createElement(
	            'div',
	            { className: 'poppedup' },
	            _react2.default.createElement(
	              'a',
	              { 'data-action': 'stop' },
	              _react2.default.createElement('img', { src: '/images/icons/Stop-Black.png' }),
	              (0, _helpers.translation)('1224')
	            ),
	            _react2.default.createElement(
	              'a',
	              { 'data-action': 'complete' },
	              _react2.default.createElement('img', { src: '/images/icons/Chekmark-Black-32.png' }),
	              (0, _helpers.translation)('1893')
	            )
	          );
	        };
	        var handleClick = function handleClick(el) {
	          switch (el.dataset.action) {
	            case 'stop':
	              _this6.stopTask(false, item.OccurrenceId);
	              break;
	            case 'complete':
	              _this6.setState({
	                confirm: {
	                  showConfirmComplete: true,
	                  orcId: item.OccurrenceId
	                }
	              });
	              break;
	          }
	        };
	        return _react2.default.createElement(_ActionMenu2.default, { noAriaLabel: true, className: function className() {
	            return 'action__menu close__menu';
	          }, handleClick: handleClick, renderActionOpener: renderActionOpener, renderActionMenu: renderActionMenu });
	      }
	
	      var onClick = function onClick(type) {
	        if (_this6.props.IsWorkscreen && (0, _auth.hasAccess)([5, 7], _this6.props.auth.user.UserType)) {
	          _this6.props.onStartAsShopLogin({ type: 'task', Id: item.OccurrenceId, action: 'startStop' });
	          return false;
	        }
	
	        if (type === 'assign') {
	          _this6.props.assignUser(item.OccurrenceId).then(function (res) {
	            if (res.status === 200) {
	              if (_this6.props.IsWorkscreen === true) {
	                res.data.MyTasks.map(function (x) {
	                  return res.data.CommonTasks.push(x);
	                });
	                res.data.MyTasks = [];
	                res.data.CommonTasks.sort(function (a, b) {
	                  return a.Deadline - b.Deadline;
	                });
	              }
	              _this6.setState({
	                tasks: res.data
	              });
	            }
	          }, function () {
	            window.toastr.error((0, _helpers.translation)('1907'), (0, _helpers.translation)('216'));
	          });
	        } else {
	          _this6.startTask(item.OccurrenceId);
	        }
	      };
	
	      var circleImg = '/images/icons/Ring-Black.png';
	      if (item.IsStarted) {
	        circleImg = '/images/icons/Ring-White.png';
	      }
	      // Return start task
	      return _react2.default.createElement(
	        'div',
	        { className: 'workers', onClick: onClick.bind(val) },
	        _react2.default.createElement('img', { src: circleImg }),
	        initials()
	      );
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.props.triggerPopup(false);
	      this.setState({
	        openTask: {
	          Show: false,
	          openTaskAsModal: false
	        }
	      });
	    }
	  }, {
	    key: 'renderTaskPopup',
	    value: function renderTaskPopup() {
	      if (this.state.openTask.openTaskAsModal || window.innerWidth <= 760) {
	        return _react2.default.createElement(_Task2.default, { modal: true, item: this.state.openTask.Task, onClose: this.onClose });
	      }
	
	      return _react2.default.createElement(_Task2.default, { item: this.state.openTask.Task });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.IsWorkscreen) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.renderTasks(),
	          this.state.openTask.Show && _react2.default.createElement(
	            _Portal2.default,
	            { onPortalClose: this.onClose },
	            _react2.default.createElement(_TaskOverlay2.default, { task: this.state.openTask.Task, onClose: this.onClose })
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'mytasks__screen' },
	          _react2.default.createElement(
	            _col2.default,
	            { id: 'items' },
	            this.props.renderMenu(),
	            this.renderTasks()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderChild()
	          ),
	          this.state.openTask.Show === true && window.innerWidth > 760 && this.renderTaskPopup(),
	          this.state.openTask.Show && window.innerWidth <= 760 && _react2.default.createElement(_TaskOverlay2.default, { task: this.state.openTask.Task, onClose: this.onClose })
	        );
	      }
	    }
	  }]);
	
	  return MyTasks;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getMyTasks: _mypage.getMyTasks,
	  startOtherTask: _mypage.startOtherTask,
	  stopOtherTask: _mypage.stopOtherTask,
	  triggerPopup: _backdrop.triggerPopup,
	  openOverlay: _common.openOverlay,
	  assignUser: _mypage.assignUser
	})(MyTasks);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _orders = __webpack_require__(21);
	
	var _backdrop = __webpack_require__(29);
	
	__webpack_require__(1414);
	
	var _OrderActions = __webpack_require__(427);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _ActionMenu = __webpack_require__(230);
	
	var _ActionMenu2 = _interopRequireDefault(_ActionMenu);
	
	var _HoverExtent = __webpack_require__(441);
	
	var _HoverExtent2 = _interopRequireDefault(_HoverExtent);
	
	var _StopOtherOrders = __webpack_require__(299);
	
	var _StopOtherOrders2 = _interopRequireDefault(_StopOtherOrders);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _HoverPopup = __webpack_require__(293);
	
	var _HoverPopup2 = _interopRequireDefault(_HoverPopup);
	
	var _QualityCheckModal = __webpack_require__(204);
	
	var _QualityCheckModal2 = _interopRequireDefault(_QualityCheckModal);
	
	var _ReferenceOrderActionModal = __webpack_require__(305);
	
	var _ReferenceOrderActionModal2 = _interopRequireDefault(_ReferenceOrderActionModal);
	
	var _auth = __webpack_require__(8);
	
	var _detect = __webpack_require__(102);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _icons = __webpack_require__(6);
	
	var _Taksering = __webpack_require__(419);
	
	var _Taksering2 = _interopRequireDefault(_Taksering);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	
	// Actions
	
	
	// import styles
	
	
	// Components
	
	
	// Modals
	
	
	// Utils
	
	
	// Taksering
	
	
	var Item = function (_PureComponent) {
	  _inherits(Item, _PureComponent);
	
	  function Item(props) {
	    _classCallCheck(this, Item);
	
	    var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));
	
	    _this.startOrderCount = 0;
	    _this.state = {
	      item: undefined,
	      quality: {
	        open: false,
	        data: {}
	      },
	      stopped: {
	        open: false,
	        comment: ''
	      },
	      stopOtherOrders: {
	        open: false,
	        WorkOnAll: null
	      },
	      stopOrders: {
	        open: false,
	        StopAll: null
	      },
	      openlinkedselector: false,
	      checkstart: true,
	      startData: {},
	      isIExplorer: false,
	      isEdge: false,
	      isFireFox: false,
	      orderReferenceApprove: {
	        open: false
	      },
	      image: ''
	    };
	    _this.updateTime = null;
	    _this.startOrder = _this.startOrder.bind(_this);
	    _this.startOrderSuccess = _this.startOrderSuccess.bind(_this);
	    _this.stopOrder = _this.stopOrder.bind(_this);
	    _this.canClick = _this.canClick.bind(_this);
	    _this.checkStartStop = _this.checkStartStop.bind(_this);
	    _this.togglePortal = _this.togglePortal.bind(_this);
	    _this.render = _this.render.bind(_this);
	    _this.goToWorkcard = _this.goToWorkcard.bind(_this);
	    _this.goToInspection = _this.goToInspection.bind(_this);
	    _this.openReferenceApprove = _this.openReferenceApprove.bind(_this);
	    _this.getCircleImages = _this.getCircleImages.bind(_this);
	    _this.closeQualityModal = _this.closeQualityModal.bind(_this);
	    _this.setStopped = _this.setStopped.bind(_this);
	    _this.onReferenceSave = _this.onReferenceSave.bind(_this);
	    _this.renderConfirm = _this.renderConfirm.bind(_this);
	    _this.onConfirmStart = null;
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        item: this.props.item,
	        isIExplorer: this.props.isIExplorer, // navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1,
	        isEdge: this.props.isEdge, // navigator.userAgent.indexOf('Edge') > -1,
	        isFireFox: this.props.isFireFox, // navigator.userAgent.indexOf('Firefox') > -1
	        isTouch: this.props.isTouch !== undefined ? this.props.isTouch : (0, _detect.isTouchDevice)() === true || (0, _detect.isTouchDevice)() > 0
	      }, function () {
	        _this2.checkStartStop(_this2.props);
	        _this2.setState({
	          image: _this2.getCircleImages(_this2.props.item)
	        });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _events2.default.removeListener('OrderStartMenny', this.startOrder.bind(this, true));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      if (nextProps.openStartStop !== this.props.openStartStop) {
	        this.checkStartStop(nextProps);
	      }
	      this.setState({
	        item: nextProps.item,
	        image: this.getCircleImages(nextProps.item)
	      }, function () {
	        return _this3.checkStartStop(nextProps);
	      });
	    }
	  }, {
	    key: 'togglePortal',
	    value: function togglePortal(e) {
	      e.preventDefault();
	      this.setState({
	        stopped: _extends({}, this.state.stopped, {
	          open: false
	        })
	      });
	      document.removeEventListener('click', this.togglePortal, false);
	    }
	  }, {
	    key: 'goToWorkcard',
	    value: function goToWorkcard() {
	      if ((0, _auth.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	        if (typeof this.props.onStartAsShopLogin !== 'undefined') {
	          this.props.onStartAsShopLogin({
	            type: 'workcard',
	            id: this.state.item.Id,
	            step: this.props.step
	          });
	          return false;
	        }
	      } else {
	        this.props.router.push('/orders/' + this.state.item.Id);
	      }
	    }
	  }, {
	    key: 'goToInspection',
	    value: function goToInspection() {
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 30)) {
	        if ((0, _auth.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	          if (typeof this.props.onStartAsShopLogin !== 'undefined') {
	            this.props.onStartAsShopLogin({
	              type: 'inspection',
	              id: this.state.item.Id,
	              step: this.props.step
	            });
	            return false;
	          }
	        } else {
	          this.props.router.push('/orders/' + this.state.item.Id + '/orderinspection');
	        }
	      }
	    }
	  }, {
	    key: 'stepHasComments',
	    value: function stepHasComments(data) {
	      var anyComments = false;
	      data.map(function (x) {
	        x.ProcessComments.map(function (val) {
	          if (val.StepComments.length !== 0) anyComments = true;
	        });
	      });
	      return anyComments;
	    }
	  }, {
	    key: 'checkStartStop',
	    value: function checkStartStop(props) {
	      if (props.openStartStop) {
	        if (typeof this.startStop.click === 'function') {
	          this.startStop.click();
	          this.props.hasOpendStatrStop();
	        }
	      }
	    }
	  }, {
	    key: 'startOrder',
	    value: function startOrder() {
	      var _this4 = this;
	
	      var confirmStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (typeof confirmStart !== 'boolean') confirmStart = false;
	      if ((0, _auth.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	        if (typeof this.props.onStartAsShopLogin !== 'undefined') {
	          var top = 0;
	          var steps = document.getElementsByClassName('drag-content scrollbar');
	          for (var i = 0; i < steps.length; i++) {
	            if (steps[i].dataset.pos === '' + this.props.step) {
	              top = steps[i].scrollTop;
	            }
	          }
	
	          this.props.onStartAsShopLogin({
	            type: 'start',
	            id: this.state.item.Id,
	            scrollOffset: top,
	            step: this.props.step
	          });
	          return false;
	        }
	      }
	
	      var item = this.state.item;
	
	      var data = {
	        Orders: [{
	          OrderId: item.Id,
	          WarrantyCode: null,
	          PaintThickness: null
	        }],
	        UserIds: [],
	        WorkOnAll: this.state.stopOtherOrders.WorkOnAll,
	        CheckOnly: false,
	        ConfirmStart: confirmStart
	
	        // Ensure only one request is sent (protects against double+ clicks)
	      };if (this.startOrderCount++ === 0) {
	        this.props.startOrder(data).then(function (res) {
	          _this4.startOrderCount = 0;
	
	          if (res.data.StopOtherOrders === true) {
	            _this4.props.triggerPopup(true);
	            _this4.setState({
	              stopOtherOrders: _extends({}, _this4.state.stopOtherOrders, {
	                open: true,
	                WorkOnAll: null
	              })
	            });
	          } else if (res.data.length > 0 && res.data.some(function (x) {
	            return x.FrontendAction.Action > 0;
	          })) {
	            // Handle additional actions directed by backend.
	            // const NONE = 0
	            var CONFIRM_START = 1;
	            // const GOTO_WORKCARD = 2
	            var _confirmStart = res.data.some(function (x) {
	              return x.FrontendAction.Action === CONFIRM_START;
	            });
	            if (_confirmStart) {
	              _this4.onConfirmStart = function () {
	                _this4.onConfirmStart = null;
	                _this4.startOrder(true);
	              };
	              _this4.setState({ confirmStart: { open: _confirmStart } });
	              return;
	            }
	          } else if (res.data.length > 0 && (res.data.some(function (x) {
	            return x.QualityCheck.OrderId > 0;
	          }) || _this4.stepHasComments(res.data))) {
	            _this4.props.triggerPopup(true);
	            _this4.setState({
	              quality: {
	                open: true,
	                data: {
	                  res: res.data,
	                  WorkOnAll: _this4.state.stopOtherOrders.WorkOnAll,
	                  UserIds: []
	                },
	                move: false
	              }
	            });
	          }
	          // else {
	          // window.toastr.success(translation('13518'), translation('13424'))
	          _this4.startOrderSuccess(res.data[0]);
	          // }
	        }, function () {
	          _this4.startOrderCount = 0;
	          window.toastr.error((0, _helpers.translation)('1923'), (0, _helpers.translation)('216'));
	        });
	      }
	    }
	  }, {
	    key: 'startOrderSuccess',
	    value: function startOrderSuccess(data) {
	      this.props.triggerPopup(false);
	      this.setState({
	        stopOtherOrders: _extends({}, this.state.stopOtherOrders, {
	          WorkOnAll: null
	        })
	      });
	
	      var item = _extends({}, this.state.item);
	      item.IsStarted = true;
	      item.IsCurrentUserWorking = true;
	      item.PreviouslyStarted = true;
	      this.setState({
	        item: item
	      });
	      if (typeof this.props.startOrderSuccess !== 'undefined') {
	        this.props.startOrderSuccess(item);
	      }
	    }
	  }, {
	    key: 'stopOrder',
	    value: function stopOrder() {
	      var _this5 = this;
	
	      if ((0, _auth.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	        if (typeof this.props.onStartAsShopLogin !== 'undefined') {
	          this.props.onStartAsShopLogin({
	            type: 'stop',
	            id: this.state.item.Id
	          });
	          return false;
	        }
	      }
	
	      var item = this.state.item;
	
	      var data = {
	        OrderId: item.Id,
	        UserId: 0,
	        StopAll: this.state.stopOrders.StopAll
	      };
	
	      this.props.stopOrder(data).then(function (res) {
	        if (res.data.StopAll === true) {
	          _this5.props.triggerPopup(true);
	          _this5.setState({
	            stopOrders: _extends({}, _this5.state.stopOrders, {
	              open: true,
	              StopAll: null
	            })
	          });
	        } else {
	          var _item = res.data;
	          _this5.setState({
	            item: _item
	          });
	          clearTimeout(_this5.updateTime);
	
	          // let message = this.state.stopOrders.StopAll === true ? translation('12340') : translation('15042')
	          // window.toastr.success(message, translation('13424'))
	
	          _this5.setState({
	            stopOrders: _extends({}, _this5.state.stopOrders, {
	              StopAll: null
	            })
	          });
	        }
	      }, function () {
	        var message = _this5.state.stopOrders.StopAll === true ? (0, _helpers.translation)('12342') : (0, _helpers.translation)('12343');
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'closeQualityModal',
	    value: function closeQualityModal() {
	      this.props.triggerPopup(false);
	      this.setState({
	        quality: {
	          open: false,
	          data: {}
	        }
	      });
	    }
	  }, {
	    key: 'setStopped',
	    value: function setStopped() {
	      this.setState({
	        stopped: _extends({}, this.state.stopped, { open: true
	        })
	      });
	      document.addEventListener('click', this.togglePortal, false);
	    }
	  }, {
	    key: 'modalTitle',
	    value: function modalTitle(item) {
	      if (typeof item === 'undefined') item = this.state.item;
	      if (item === undefined) return null;
	      var title = '';
	      // Model
	      if (item.Model) title += item.Model;
	      // RegNumber
	      if (item.RegNumber) {
	        if (item.Model) title += ', ';
	        title += item.RegNumber;
	      }
	      // Title empty
	      if (title === '') title += item.Id || item.OrderId;
	      if (item.Color !== '' && item.Color !== null && typeof item.Color !== 'undefined') title += ', ' + item.Color;
	      return title;
	    }
	  }, {
	    key: 'renderTransportIcon',
	    value: function renderTransportIcon() {
	      var classes = 'hasTextInBubble';
	      var item = this.state.item;
	
	
	      if (this.props.auth.departmentType === 1) {
	        if (item.BodyShopTransport === null || item.BodyShopTransport === 0) {
	          return _react2.default.createElement('div', { className: 'icon' });
	        }
	      } else {
	        if (item.Transport === null || item.Transport === 0) return _react2.default.createElement('div', { className: 'icon' });
	      }
	      var isshop = (0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType);
	      var showDifferentImageVar = false;
	      var transportImage = 'Can-drive-black.svg';
	      var showDifferentImage = 'Can-drive-different-delivery-black.svg';
	      var showBubbleText = (0, _helpers.translation)('2328');
	      if (this.props.auth.departmentType === 1) {
	        if (item.BodyShopTransport === 3) {
	          transportImage = 'Transport-black.svg';
	          showDifferentImage = 'Transport-different-delivery-black.svg';
	          showBubbleText = (0, _helpers.translation)('2329');
	        }
	
	        if (item.IsStarted) {
	          transportImage = transportImage.replace('-black.svg', '-white.svg');
	          showDifferentImage = showDifferentImage.replace('-black.svg', '-white.svg');
	        }
	
	        if (item.BodyShopTransport === 2) {
	          transportImage = 'loosepart_black.svg';
	          showDifferentImage = 'loosepart_black_redcircle.svg';
	          showBubbleText = (0, _helpers.translation)('351');
	        }
	      } else {
	        if (item.Transport === 3) {
	          transportImage = 'Transport-black.svg';
	          showDifferentImage = 'Transport-different-delivery-black.svg';
	          showBubbleText = (0, _helpers.translation)('2329');
	        }
	
	        if (item.IsStarted) {
	          transportImage = transportImage.replace('-black.svg', '-white.svg');
	          showDifferentImage = showDifferentImage.replace('-black.svg', '-white.svg');
	        }
	
	        if (item.Transport === 2) {
	          transportImage = 'loosepart_black.svg';
	          showDifferentImage = 'loosepart_black_redcircle.svg';
	          showBubbleText = (0, _helpers.translation)('351');
	        }
	      }
	
	      if (item.IsStarted) {
	        transportImage = transportImage.replace('_black', '_black_white');
	        showDifferentImage = showDifferentImage.replace('_black', '_black_white');
	      }
	
	      if (this.props.auth.departmentType > 0) {
	        // Check pickup location
	        if ((item.BodyShopPickupAltLocationId !== 0 || item.BodyShopDeliveryAltLocationId !== 0) && item.StepId === 1) {
	          showDifferentImageVar = true;
	          showBubbleText = (0, _helpers.translation)('13418');
	        }
	
	        if (item.BodyShopPickupAltLocationId === 0 && item.HasBodyShopPickupAltLocation === true && item.StepId === 1) {
	          showDifferentImageVar = true;
	          showBubbleText = (0, _helpers.translation)('13418');
	        }
	
	        if (item.BodyShopDeliveryAltLocationId !== 0 && item.StepId > 1 && !item.StepId === 8) {
	          showDifferentImageVar = true;
	          showBubbleText = (0, _helpers.translation)('13419');
	        }
	
	        if (item.BodyShopDeliveryAltLocationId === 0 && item.HasBodyShopDeliveryAltLocation === true && item.StepId === 1) {
	          showDifferentImageVar = true;
	          showBubbleText = (0, _helpers.translation)('13419');
	        }
	
	        if (item.BodyShopDeliveryAltLocationId === 0 && item.HasBodyShopDeliveryAltLocation === true && item.StepId > 1 && !item.StepId === 8) {
	          showDifferentImageVar = true;
	          showBubbleText = (0, _helpers.translation)('13419');
	        }
	      } else {
	        // Check pickup location
	        if ((item.PickupAltLocationId !== 0 || item.DeliveryAltLocationId !== 0) && item.StepId === 1) {
	          showDifferentImageVar = true;
	        }
	        if (item.DeliveryAltLocationId !== 0 && item.StepId > 1 && !item.StepId === 8) {
	          showDifferentImageVar = true;
	        }
	      }
	      if (isshop && (item.IsReferredIn || item.IsReferredOut)) {
	        showDifferentImageVar = true;
	        // showBubbleText = ''
	      }
	      // Returns
	      if (showDifferentImageVar) {
	        if (this.state.isIExplorer || this.state.isFireFox) {
	          classes += ' hasTextInBubbleIE';
	        } else if (this.state.isEdge) {
	          classes += ' hasTextInBubbleEdge';
	        }
	        if (this.state.isTouch) {
	          showBubbleText = '';
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: classes },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--right', 'aria-label': showBubbleText },
	            _react2.default.createElement('img', { src: '/images/svgs/transport/' + showDifferentImage, className: 'icon hasCursor' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              '!'
	            )
	          )
	        );
	      }
	      if (this.state.isTouch) {
	        classes = '';
	        showBubbleText = '';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'hint--right', 'aria-label': showBubbleText },
	        _react2.default.createElement('img', { src: '/images/svgs/transport/' + transportImage, className: 'icon hasCursor' })
	      );
	
	      /* let { item } = this.state
	      let transportImage = 'Can-drive-black.svg'
	      let showBubbleText = translation('154')
	      // let mouseOverString = '154'
	      if (item.Transport === 3) {
	        transportImage = 'Transport.svg'
	        showBubbleText = translation('26')
	        // mouseOverString = '26'
	        if (item.IsStarted) transportImage = transportImage.replace('.svg', '-white.svg')
	      }
	      if (item.Transport === 2) {
	        transportImage = 'loosepart_black.svg'
	        showBubbleText = translation('351')
	      }
	      if (item.IsStarted) transportImage = transportImage.replace('-black.svg', '-white.svg')
	      return (
	        <div className='hint--right' aria-label={showBubbleText}>
	          <img src={'/images/svgs/transport/' + transportImage} className='icon' />
	        </div>
	      ) */
	    }
	  }, {
	    key: 'getEmployeeName',
	    value: function getEmployeeName() {
	      var item = this.state.item;
	
	      // Employee
	
	      var employee = '';
	      if (item.Employees.length !== 0) {
	        employee = item.Employees[0].Initials;
	        if (item.Employees.length !== 1 && employee !== '') {
	          employee += '+';
	        }
	      }
	      // Names popup
	      var namesPopup = '';
	      if (item.Employees.length !== 0) {
	        var names = [];
	        item.Employees.map(function (val) {
	          names.push(val.Name);
	        });
	        var showNames = '';
	        if (!this.state.isTouch) showNames = names.join('&#xa;');
	        namesPopup = "<span class='hint--bottom' aria-label='" + showNames + "'>" + employee + '</span>';
	      }
	      if (namesPopup !== '') {
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: namesPopup } })
	        );
	      }
	      // Return normal
	      return _react2.default.createElement(
	        'span',
	        { className: 'workers_name' },
	        employee
	      );
	    }
	  }, {
	    key: 'getCircleImages',
	    value: function getCircleImages(item) {
	      // let { item } = this.state
	      var image = 'Timespent-';
	      var colored = item.ColoredParts < 0 ? 0 : item.ColoredParts;
	      switch (item.RemainingTimeDelay) {
	        case 0:
	          if (colored === 0) {
	            if (item.IsStarted !== true) {
	              image += 'Black-0';
	            }
	          } else {
	            image += 'Green-' + colored;
	          }
	          break;
	        case 1:
	          image += 'Yellow-8';
	          break;
	        case 2:
	          var coloredX = colored < 8 ? colored : 8;
	          coloredX = coloredX === 0 ? 8 : coloredX;
	          image += 'Red-' + coloredX;
	          break;
	      }
	
	      var color = item.IsStarted && image.indexOf('Black-0') === -1 ? '-White' : '';
	
	      return image + color;
	    }
	  }, {
	    key: 'renderCircle',
	    value: function renderCircle(opener) {
	      var _this6 = this;
	
	      var item = this.state.item;
	
	      if (typeof item.ColoredParts === 'undefined') {
	        return _react2.default.createElement('div', { className: 'workers' });
	      }
	      var image = this.getCircleImages(item);
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) {
	        if (item.IsStarted === true) {
	          image = '../Ring-White';
	        } else {
	          image = '../Ring-Black';
	        }
	      }
	      // let image = this.state.image
	      var EmployeeName = this.getEmployeeName();
	      var onClick = item.IsCurrentUserWorking ? this.stopOrder : this.startOrder;
	      if (opener !== false) {
	        onClick = opener;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'workers', onClick: onClick, ref: function ref(c) {
	            return _this6.startStop = c;
	          } },
	        _react2.default.createElement('img', { src: '/images/icons/circle/' + image + '.png', className: 'worker__image' }),
	        EmployeeName
	      );
	    }
	
	    /**
	     * Start ikon - Hvis man er tildelt
	     * Cirkel ikon uden timer - Hvis man ikke er tildelt
	     * Cirkel ikon - Hvis ordren har været startet
	     * Stop ikon - Hvis ordren er i StepId 1 eller 7
	     */
	
	  }, {
	    key: 'renderWorkers',
	    value: function renderWorkers() {
	      var _this7 = this;
	
	      var item = this.state.item;
	
	      if (item === undefined) return null;
	
	      // Stop icon
	      var renderStopIcon = function renderStopIcon() {
	        // if (item.StepId === 7 || this.props.type === '1') {
	        // if (item.StepId !== 7 && item.StepId !== 1) {
	        var renderActionOpener = function renderActionOpener(opener) {
	          return _this7.renderCircle(opener);
	          /*
	          return (
	            <div className='workers' onClick={opener}>
	              <img src={'/images/icons/Stop-White.png'} />
	            </div>
	          )
	          */
	        };
	        var renderActionMenu = function renderActionMenu() {
	          return _react2.default.createElement(
	            'div',
	            { className: 'poppedup' },
	            _react2.default.createElement(
	              'a',
	              { 'data-action': 'stop' },
	              _react2.default.createElement('img', { src: '/images/icons/pause-sign-32x32.png' }),
	              (0, _helpers.translation)('440')
	            ),
	            _react2.default.createElement(
	              'a',
	              { 'data-action': 'complete' },
	              _react2.default.createElement('img', { src: '/images/icons/Chekmark-Black-32.png' }),
	              (0, _helpers.translation)('1732')
	            )
	          );
	        };
	        var handleClick = function handleClick(el) {
	          switch (el.dataset.action) {
	            case 'stop':
	              _this7.stopOrder();
	              break;
	            case 'complete':
	              _this7.props.MoveOrders({ OrderIds: [_this7.props.item.Id], UserId: 0, StepFrom: item.StepId, StepTo: null /*  (item.StepId + 1) */, Comment: '', FilterSettings: {} });
	              break;
	          }
	        };
	        var className = function className() {
	          return 'action__menu close__menu';
	        };
	        // return null
	
	        return _react2.default.createElement(_ActionMenu2.default, { className: className, step: _this7.props.step, index: _this7.props.index, item: _this7.state.item, handleClick: handleClick, renderActionOpener: renderActionOpener, renderActionMenu: renderActionMenu, noAriaLabel: true });
	        // }
	        /*
	        return (
	          <div className='workers' onClick={this.stopOrder}>
	            <img src={'/images/icons/Stop-White.png'} />
	          </div>
	        )
	        */
	      };
	
	      var renderReferredApprove = function renderReferredApprove() {
	        var item = _this7.state.item;
	
	        if (_this7.props.item.NeedReferredApprove) {
	          if (item.ReferredApproved) return null;
	          var ariaLabel = '';
	          if (!_this7.state.isTouch) ariaLabel = (0, _helpers.translation)('751');
	          return _react2.default.createElement(
	            'div',
	            { className: 'icon hint--top hasBackground workers', 'aria-label': ariaLabel, onClick: _this7.openReferenceApprove },
	            _react2.default.createElement('img', { src: '/images/svgs/New-order-red-referred.svg' })
	          );
	        }
	      };
	
	      // Icon with names in
	      var renderIconWithNames = function renderIconWithNames() {
	        if (item.IsStarted) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'workers', onClick: _this7.startOrder, ref: function ref(c) {
	                return _this7.startStop = c;
	              } },
	            _react2.default.createElement('img', { src: '/images/icons/Ring-White.png' }),
	            _this7.getEmployeeName()
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'workers', onClick: _this7.startOrder, ref: function ref(c) {
	                return _this7.startStop = c;
	              } },
	            _react2.default.createElement('img', { src: '/images/icons/Ring-Black.png' }),
	            _this7.getEmployeeName()
	          );
	        }
	      };
	      if (item.IsStopped) {
	        if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'workers noCursor' },
	            _react2.default.createElement('img', { src: '/images/icons/Stop-31.png' })
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'workers', onClick: this.setStopped, ref: function ref(c) {
	              return _this7.startStop = c;
	            } },
	          _react2.default.createElement('img', { src: '/images/icons/Stop-31.png' })
	        );
	      }
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'workers noCursor' },
	          _react2.default.createElement('img', { src: '/images/icons/Ring-Black.png' }),
	          this.getEmployeeName()
	        );
	      }
	
	      if (this.props.item.NeedReferredApprove) {
	        return renderReferredApprove();
	      }
	
	      // New type
	      // if (this.props.type === '1') {
	      if (this.props.type !== '111') {
	        if (item.IsCurrentUserWorking) {
	          return renderStopIcon();
	        }
	      }
	
	      // Step 1 & 7
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || item.StepId === 1 || item.StepId === 7) {
	        if (item.IsCurrentUserWorking) {
	          return renderStopIcon();
	        }
	        if (item.IsCurrentUserAssigned) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'workers', onClick: this.startOrder, ref: function ref(c) {
	                return _this7.startStop = c;
	              } },
	            _react2.default.createElement('img', { src: '/images/icons/Start-Black.png' })
	          );
	        } else {
	          return renderIconWithNames();
	        }
	      }
	
	      // Order has been started
	      if (item.PreviouslyStarted) {
	        return this.renderCircle(false);
	      }
	
	      // User is assigned
	      if (item.IsCurrentUserAssigned) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'workers', onClick: this.startOrder, ref: function ref(c) {
	              return _this7.startStop = c;
	            } },
	          _react2.default.createElement('img', { src: '/images/icons/Start-Black.png' })
	        );
	      }
	
	      // Order has not been started
	      return renderIconWithNames();
	    }
	  }, {
	    key: 'canClick',
	    value: function canClick(type, id, e) {
	      if ((0, _auth.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	        if (typeof this.props.onStartAsShopLogin !== 'undefined') {
	          e.preventDefault();
	          e.stopPropagation();
	          e.nativeEvent.stopImmediatePropagation();
	          this.props.onStartAsShopLogin({
	            type: type,
	            id: id === 0 ? this.state.item.Id : id
	          });
	          return false;
	        }
	      }
	    }
	  }, {
	    key: 'middleSectionBorder',
	    value: function middleSectionBorder(existingClass) {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20, 0)) {
	        existingClass += ' hasBorder';
	        return existingClass;
	      }
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.state.item.InspectionStepsCompleted === 0) {
	        existingClass += ' hasBorder Red';
	      }
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.state.item.InspectionStepsCompleted !== 0 && this.state.item.InspectionStepsCompleted !== this.state.item.InspectionStepsTotal) {
	        existingClass += ' hasBorder Yellow';
	      } else {
	        existingClass += ' hasBorder';
	      }
	      return existingClass;
	    }
	  }, {
	    key: 'renderInspectionStep',
	    value: function renderInspectionStep() {
	      var item = this.state.item;
	
	      var backgroundClass = 'fullSize inspection';
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0)) return _react2.default.createElement('span', { className: backgroundClass });
	      // Dette er hvad vi viser, hvis vi er et pladeværksted/karosseri
	      // if (this.props.auth.departmentType === 1) {
	      //   return (
	      //     <div className={backgroundClass} />
	      //   )
	      // }
	      backgroundClass = this.middleSectionBorder(backgroundClass);
	      return _react2.default.createElement(
	        'span',
	        { className: backgroundClass },
	        _react2.default.createElement(
	          'div',
	          { onClick: this.canClick.bind(this, 'inspection', 0) },
	          item.InspectionStepsCompleted,
	          ' / ',
	          item.InspectionStepsTotal
	        )
	      );
	    }
	  }, {
	    key: 'renderDisplayTime',
	    value: function renderDisplayTime() {
	      var item = this.state.item;
	
	
	      if (item.DisplayedTimePrt1 === '' && item.DisplayedTimePrt2 === '') return null;
	      var className = 'fullSize displayTime';
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) {
	        switch (item.Delay) {
	          case 1:
	            className += ' hasBorder Yellow';
	            break;
	          case 2:
	            className += ' hasBorder Red';
	            break;
	          default:
	            className += ' hasBorder';
	        }
	      } else {
	        className += ' hasBorder';
	      }
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0)) {
	        className = 'fullSize displayTime';
	      }
	      return _react2.default.createElement(
	        'span',
	        { className: className + ' borderBottom' },
	        item.DisplayedTimePrt1,
	        '\xA0\xA0\xA0',
	        item.DisplayedTimePrt2
	      );
	    }
	  }, {
	    key: 'renderDisplayTimeNew',
	    value: function renderDisplayTimeNew() {
	      var item = this.state.item;
	
	
	      if (item.BodyShopProductionTime === '' && item.ProductionTime === '') {
	        return null;
	      } else {
	        var className = 'fullSize displayTime';
	        if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) {
	          switch (item.Delay) {
	            case 1:
	              className += ' hasBorder Yellow';
	              break;
	            case 2:
	              className += ' hasBorder Red';
	              break;
	            default:
	              className += ' hasBorder';
	          }
	        } else {
	          className += ' hasBorder';
	        }
	
	        return _react2.default.createElement(
	          'span',
	          { className: className + ' borderBottom' },
	          item.DisplayedTimePrt1,
	          '\xA0\xA0\xA0',
	          item.DisplayedTimePrt2
	        );
	      }
	    }
	  }, {
	    key: 'renderNotes',
	    value: function renderNotes() {
	      var icon = void 0;
	      var imgSrc = '';
	      var classes = 'icon hasTextInBubble';
	
	      var ariaLabel = '';
	
	      if (!this.state.item.HasNotes || !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0)) {
	        return _react2.default.createElement('div', { className: 'icon' });
	      }
	
	      // if order has unread notes
	      if (this.state.item.UnreadNotes !== 0) {
	        imgSrc = '/images/svgs/comment/comment-red-circle.svg';
	
	        if (this.state.item.IsStarted) imgSrc = imgSrc.replace('.svg', '-white.svg');
	
	        if (this.state.isIExplorer) {
	          classes += ' hasTextInBubbleIE';
	        } else if (this.state.isEdge) {
	          classes += ' hasTextInBubbleEdge';
	        } else if (this.state.isFireFox) {
	          classes += ' hasTextInBubbleFireFox';
	        }
	
	        if (!this.state.isTouch) {
	          ariaLabel = (0, _helpers.translation)('2339');
	        }
	        icon = _react2.default.createElement(
	          'span',
	          { className: classes },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--right', 'aria-label': ariaLabel },
	            _react2.default.createElement('img', { src: imgSrc, className: 'icon' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              this.state.item.UnreadNotes
	            )
	          )
	        );
	      } else {
	        // Default
	        imgSrc = '/images/svgs/comment/comment-new.svg';
	        if (this.state.item.IsStarted) imgSrc = imgSrc.replace('.svg', '-white.svg');
	
	        if (!this.state.isTouch) {
	          ariaLabel = (0, _helpers.translation)('149');
	        }
	        icon = _react2.default.createElement(
	          'div',
	          { className: 'hint--right', 'aria-label': ariaLabel },
	          _react2.default.createElement('img', { src: imgSrc, className: 'icon' })
	        );
	      }
	      return icon;
	    }
	  }, {
	    key: 'renderColor',
	    value: function renderColor() {
	      var image = null;
	      var openImg = null;
	      var showBubbleText = '';
	      if (this.state.item.ColorIsReady) {
	        image = 'Color-ok.svg';
	        showBubbleText = (0, _helpers.translation)('2075');
	      } else if (this.state.item.ColorVariant !== null && this.state.item.ColorVariant !== '') {
	        image = 'color-variation.svg';
	        showBubbleText = (0, _helpers.translation)('13388');
	      } else if (this.state.item.ColorCode !== null && this.state.item.ColorCode !== '') {
	        image = 'Color_code.svg';
	        showBubbleText = (0, _helpers.translation)('79');
	      } else if (this.state.item.Color !== null && this.state.item.Color !== '') {
	        image = 'Color.svg';
	        showBubbleText = (0, _helpers.translation)('179');
	      }
	      if (this.state.item.IsStarted && image !== null) {
	        image = image.replace('.svg', '-white.svg');
	      }
	      if (this.state.isTouch) showBubbleText = '';
	      openImg = _react2.default.createElement(
	        'div',
	        { className: 'hint--top', 'aria-label': showBubbleText },
	        _react2.default.createElement('img', { src: '/images/svgs/color/' + image, className: 'icon' })
	      );
	      if (image === null) openImg = _react2.default.createElement('div', { className: 'icon' });
	      return openImg;
	    }
	  }, {
	    key: 'renderTaksering',
	    value: function renderTaksering() {
	      var backgroundClass = this.middleSectionBorder('fullSize Taksering');
	
	      // Dette her viser vi i tilfælde af isEvaluation = false og vi der pladeværksted/karosseri
	      if (!this.state.item.isEvaluation && this.props.auth.departmentType === 1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'fullSize Taksering' },
	          _react2.default.createElement('div', { className: 'icon' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: backgroundClass },
	        _react2.default.createElement(_Taksering2.default, { item: this.state.item, type: 'workscreen' })
	      );
	    }
	  }, {
	    key: 'renderMissingPart',
	    value: function renderMissingPart() {
	      var backgroundClass = this.middleSectionBorder('fullSize missingPart');
	      // Dette indhold viser vi i tilfælde af der ikke er en part og vi er pladeværksted/karosseri
	      if (!this.state.item.MissingParts && this.props.auth.departmentType === 1) {
	        return _react2.default.createElement('div', { className: 'fullSize missingPart' });
	      }
	      if (!this.state.item.MissingParts) return _react2.default.createElement('div', { className: backgroundClass });
	
	      var text = this.state.item.MissingPartsMessage;
	      text = text === null ? '' : text;
	      if (text.length > 50) {
	        var breakTextNicely = function breakTextNicely(text, limit) {
	          var parts = text.split(' ');
	          var lines = [];
	          text = parts[0];
	          parts.shift();
	          while (parts.length > 0) {
	            var newText = text + ' ' + parts[0];
	            if (newText.length > limit) {
	              lines.push(text + '\n');
	              text = parts[0];
	            } else {
	              text = newText;
	            }
	            parts.shift();
	          }
	          lines.push(text);
	          return lines.join('');
	        };
	        text = breakTextNicely(text, 50);
	      }
	
	      var message = (0, _helpers.translation)('2322');
	      if (text.length > 0) {
	        message = message + ':\n' + text;
	      }
	
	      var icon = '/images/svgs/missing-parts/missing-parts.svg';
	      if (this.state.item.IsStarted) icon = icon.replace('.svg', '-white.svg');
	      if (this.state.isTouch) message = '';
	      return _react2.default.createElement(
	        'div',
	        { className: backgroundClass },
	        _react2.default.createElement(
	          'span',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--left', 'aria-label': message },
	            _react2.default.createElement('img', { src: icon, style: { width: 25, height: 25, marginTop: -3 } })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRentalCar',
	    value: function renderRentalCar(item) {
	      if (item.HasCarRental === true || item.HasRequestedCarRental === true) {
	        // return if CarRentalAssignments only contains alternative.
	        if (item.CarRentalAssignments.length > 0 && !item.HasCarRentalNotAlternative) return _react2.default.createElement('div', { className: 'icon' });
	
	        var hasNoCarSelected = item.HasRequestedCarRental && item.CarRentalAssignments.length === 0;
	
	        // if (item.CarRentalId !== 0) {
	        var icon = '/images/svgs/ordrer/lend-cirkel.svg';
	        var number = 0;
	        if (item.CarRentalAssignments.length > 0) {
	          number = item.CarRentalAssignments[0].CarNumber;
	        }
	        var whatClass = 'rentCarAmount';
	
	        if (item.IsStarted === true) {
	          icon = '/images/svgs/ordrer/lend-cirkel-white.svg';
	          whatClass = 'rentCarAmount rentCarAmountActive';
	          icon = '/images/svgs/ordrer/lend-cirkel-white.svg';
	          switch (item.CarRentalColliderType) {
	            case 0:
	              icon = '/images/svgs/ordrer/lend-cirkel-white.svg';
	              break;
	            case 1:
	              // icon = '/images/svgs/ordrer/lend-yellowcircle-white.svg'
	              break;
	            case 2:
	              // icon = '/images/svgs/ordrer/lend-redcircle-white.svg'
	              break;
	          }
	        } else {
	          icon = '/images/svgs/ordrer/lend-cirkel.svg';
	          switch (item.CarRentalColliderType) {
	            case 0:
	              icon = '/images/svgs/ordrer/lend-cirkel.svg';
	              break;
	            case 1:
	              icon = '/images/svgs/ordrer/lend-yellowcircle.svg';
	              break;
	            case 2:
	              icon = '/images/svgs/ordrer/lend-redcircle.svg';
	              break;
	          }
	
	          if (hasNoCarSelected) {
	            icon = '/images/svgs/ordrer/lend-redcircle.svg';
	          }
	        }
	
	        if (number > 9) {
	          whatClass += ' rentCarAmountDoubleDigits';
	        }
	
	        if (item.HasCarRental && !item.CurrentShopCanAssignRentalCar) {
	          // Hide rental car number for car from other company.
	          number = '';
	          icon = '/images/svgs/ordrer/lend.svg';
	        }
	
	        var hoverLines = [];
	        var useClick = true;
	        var useHover = true;
	        var carRentalAssignments = item.CarRentalAssignments;
	        if (carRentalAssignments.length > 0) {
	          carRentalAssignments.forEach(function (elem, i) {
	            hoverLines.push(_react2.default.createElement(
	              'p',
	              { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	              elem.Identity
	            ));
	            hoverLines.push(_react2.default.createElement(
	              'p',
	              { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	              (0, _time.renderFullDate)(elem.Start, true)
	            ));
	            hoverLines.push(_react2.default.createElement(
	              'p',
	              { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	              (0, _time.renderFullDate)(elem.End, true)
	            ));
	            if (i < carRentalAssignments.length - 1) {
	              hoverLines.push(_react2.default.createElement('p', { key: item.Id + '_' + Math.random() + '_' + Math.random() }));
	            }
	          });
	        } else {
	          hoverLines.push(_react2.default.createElement(
	            'p',
	            { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	            (0, _time.renderFullDate)(item.BodyShopPickupTime, true)
	          ));
	          hoverLines.push(_react2.default.createElement(
	            'p',
	            { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	            (0, _time.renderFullDate)(item.BodyShopDeliveryTime, true)
	          ));
	        }
	
	        return _react2.default.createElement(
	          _HoverPopup2.default,
	          { UseClick: useClick, UseHover: useHover, orderId: item.Id, getVerticalScrollOffset: this.props.getVerticalScrollOffset, getHorizontalScrollOffset: this.props.getHorizontalScrollOffset, scrollColumn: this.props.step, PopupContent: hoverLines },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'icon' },
	              _react2.default.createElement('img', { src: icon, style: { width: 25, height: 25, marginTop: -3 } })
	            ),
	            !hasNoCarSelected && _react2.default.createElement(
	              'font',
	              { className: whatClass },
	              number
	            )
	          )
	        );
	        // }
	      } else {
	        return _react2.default.createElement('div', { className: 'icon' });
	      }
	    }
	  }, {
	    key: 'renderApprovedReportRecievedIcon',
	    value: function renderApprovedReportRecievedIcon(item) {
	      if (!item.Report) {
	        return this.renderSpacerIcon();
	      }
	
	      var image = '';
	      var mouseText = '';
	      var report = item.Report;
	      var chainUsesDBS = this.props.auth.permissions.ChainAssessmentSystem === 2;
	      var bookingStopped = this.props.item.IsAgreementForsiCreated && !this.props.item.IsEvaluation;
	      var evaluationStopped = this.props.item.IsEvaluation && !this.props.item.IsEvaluated && this.props.item.CustomerWPEvaluationRequired && this.props.item.IsAgreementOrder;
	      var hasUserAccess = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var isMainReportLoadedIcon = false;
	      var IsAssessmentOk = this.props.item.IsAssessmentOk;
	
	
	      if (report !== null && report.ReportVersionNr === 0 && report.IsApproved) {
	        image = _icons.OrderAssessmentIcons.Main_Report_Loaded;
	        mouseText = (0, _helpers.translation)('13023');
	        isMainReportLoadedIcon = true;
	      }
	      if (hasUserAccess && item.LastUpdatedType === 1) {
	        image = _icons.OrderAssessmentIcons.Charged_Later_Recieved;
	        mouseText = (0, _helpers.translation)('1019');
	        isMainReportLoadedIcon = false;
	      }
	      if (!hasUserAccess && item.LastUpdatedType === 1 && this.props.auth.departmentType === 1) {
	        image = _icons.OrderAssessmentIcons.Charged_Later_Recieved;
	        mouseText = (0, _helpers.translation)('1019');
	        isMainReportLoadedIcon = false;
	      }
	      if (!hasUserAccess && item.LastUpdatedType === 1 && this.props.auth.departmentType !== 1) {
	        image = _icons.OrderAssessmentIcons.Charged_Later_Sent;
	        mouseText = (0, _helpers.translation)('13528');
	        isMainReportLoadedIcon = false;
	      }
	      if (report !== null && !chainUsesDBS && report.IsApproved && report.ReportVersionNr > 0) {
	        mouseText = (0, _helpers.translation)('937');
	        isMainReportLoadedIcon = false;
	        if (IsAssessmentOk || hasUserAccess) {
	          image = _icons.OrderAssessmentIcons.Update_Approved;
	          if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.auth.departmentType !== 1) {
	            mouseText = (0, _helpers.translation)('13530');
	          }
	        } else {
	          image = _icons.OrderAssessmentIcons.Main_Report_Update_Not_Approved;
	          mouseText = (0, _helpers.translation)('13531');
	        }
	      }
	      if (item.ForsiReportId) {
	        if ((!this.props.item.IsEvaluationRejected || this.props.item.IsEvaluationRejected && !isMainReportLoadedIcon) && !bookingStopped && !evaluationStopped) {
	          if (!hasUserAccess && this.props.auth.departmentType !== 1) {
	            if (IsAssessmentOk === true) {
	              image = _icons.OrderAssessmentIcons.Main_Report_Approved;
	              mouseText = (0, _helpers.translation)('13513');
	            } else {
	              image = _icons.OrderAssessmentIcons.Main_Report_Not_Approved;
	              mouseText = (0, _helpers.translation)('13526');
	            }
	            mouseText = mouseText.replace('- ', '-\n');
	          }
	        }
	      }
	
	      if (image === '') {
	        return this.renderSpacerIcon();
	      }
	
	      if (item.IsStarted) {
	        if (image && image.fileName) {
	          image = { fileName: image.fileName.replace('.svg', '-white.svg') };
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'hint--right', 'aria-label': mouseText },
	        _react2.default.createElement(_icon2.default, { icon: image, className: 'icon', style: { marginTop: -3 } })
	      );
	    }
	  }, {
	    key: 'renderSpacerIcon',
	    value: function renderSpacerIcon() {
	      return _react2.default.createElement('div', { className: 'icon' });
	    }
	  }, {
	    key: 'renderRekvNumber',
	    value: function renderRekvNumber(item) {
	      var MyRekvNumber = '';
	
	      if (item.BodyShopRekvNumber !== null && item.BodyShopRekvNumber !== '' && item.BodyShopRekvNumber !== 0) {
	        MyRekvNumber = item.BodyShopRekvNumber;
	      }
	
	      if (item.RekvNumber !== null && item.RekvNumber !== '' && item.RekvNumber !== 0 && this.props.auth.departmentType === 0) {
	        MyRekvNumber = item.RekvNumber;
	      }
	
	      if (MyRekvNumber !== '') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'fullSize displayTime RekvNumber' },
	          '# ' + MyRekvNumber
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'fullSize displayTime RekvNumber' },
	          '\xA0'
	        );
	      }
	    }
	  }, {
	    key: 'renderNewItemLine',
	    value: function renderNewItemLine(item) {
	      if (this.props.auth.departmentType !== 0) {
	        // used for custom ipad style bug fix
	        var isiPadPro = (0, _detect.isTouchDevice)() && /MacIntel/.test(navigator.platform);
	        var customIpad = '';
	        if (isiPadPro) {
	          customIpad = ' customIpad-style';
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'lower' + customIpad },
	          _react2.default.createElement(
	            'div',
	            { onClick: this.goToWorkcard, className: 'lower_icons', style: { display: 'inline-block' } },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) || (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 3) ? '/orders/' + item.Id : '', unselectable: 'on', onClick: this.canClick.bind(this, 'workcard', 0) },
	              this.renderRentalCar(item),
	              this.renderApprovedReportRecievedIcon(item),
	              this.renderSpacerIcon()
	            )
	          ),
	          _react2.default.createElement('div', { className: 'divider body' }),
	          _react2.default.createElement(
	            'div',
	            { onClick: this.goToWorkcard, className: 'borderBottom' },
	            this.renderRekvNumber(item)
	          ),
	          _react2.default.createElement('div', { className: 'divider body' }),
	          this.renderPaintBodyStatus(item)
	        );
	      }
	    }
	  }, {
	    key: 'renderPaintBodyStatus',
	    value: function renderPaintBodyStatus(item) {
	      if (item.Id === 944638 || item.Id === 944656 || item.Id === 944658) {
	        // console.log(item)
	      }
	
	      var paintLit = false;
	      var bodyLit = false;
	
	      var paintBooked = false;
	      var bodyBooked = false;
	
	      var paintOrdered = false;
	      var bodyOrdered = false;
	
	      var paintNotOrdered = false;
	      var bodyNotOrdered = false;
	
	      var paintTextItems = [];
	      var bodyTextItems = [];
	      var overallTextItems = [];
	
	      // Order shown as PaintShop, BodyShop or CombinedShop
	      if (item.OrderDepartment === 0 || item.OrderDepartment === 1 || item.OrderDepartment === 2) {
	        paintLit = item.IsPaintOrder;
	        paintBooked = !item.PaintIsDraft;
	        if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	          paintOrdered = item.HasSpareParts && item.PaintSparePartStatusSum === 8;
	          paintNotOrdered = item.HasSpareParts && item.PaintSparePartStatusSum === 1;
	        }
	      }
	
	      // Order shown as BodyShop or CombinedShop
	      if (item.OrderDepartment === 1 || item.OrderDepartment === 2) {
	        bodyLit = item.IsBodyShopOrder;
	        bodyBooked = !item.BodyShopIsDraft;
	        if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	          bodyOrdered = item.HasSpareParts && item.BodySparePartStatusSum === 8;
	          bodyNotOrdered = item.HasSpareParts && item.BodySparePartStatusSum === 1;
	        }
	      }
	
	      var image = 'show-work';
	      var imgPath = '/images/svgs/orderlist/';
	
	      // Check for paint/body work
	      if (paintLit) {
	        image += '_paint-lit';
	        paintTextItems.push((0, _helpers.translation)('14829'));
	      }
	      if (bodyLit) {
	        image += '_body-lit';
	        bodyTextItems.push((0, _helpers.translation)('14830'));
	      }
	
	      if (paintLit && bodyLit) {
	        overallTextItems.push((0, _helpers.translation)('14867'));
	      }
	
	      // Check for paint/body booked
	      if (paintLit && !paintBooked) {
	        image += '_paint-red';
	        paintTextItems.push((0, _helpers.translation)('13045'));
	      } else if (paintNotOrdered && !paintOrdered) {
	        image += '_paint-red';
	      } else if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && paintNotOrdered) {
	        image += '_paint-red';
	        // Check for paint/body spare parts ordered
	      } else if (paintOrdered && !paintNotOrdered) {
	        image += '_paint-yellow';
	      }
	
	      if (bodyLit && !bodyBooked) {
	        image += '_body-red';
	        bodyTextItems.push((0, _helpers.translation)('13046'));
	      } else if (bodyLit && bodyBooked && bodyNotOrdered && !bodyOrdered) {
	        image += '_body-red';
	      } else if (bodyLit && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && bodyNotOrdered) {
	        image += '_body-red';
	      }
	
	      if (bodyLit && bodyBooked && bodyOrdered && !bodyNotOrdered) {
	        image += '_body-yellow';
	      }
	
	      if (item.HasSpareParts === true && item.BodySparePartStatusSum !== 0 && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	        // Body spare parts not ordered
	        if (item.BodySparePartStatusSum === 1) {
	          bodyTextItems.push((0, _helpers.translation)('13048'));
	        }
	
	        // Body spare parts not received
	        if (item.BodySparePartStatusSum === 8) {
	          bodyTextItems.push((0, _helpers.translation)('13050'));
	        }
	
	        // Body spare parts received
	        if (item.BodySparePartStatusSum === 16) {
	          bodyTextItems.push((0, _helpers.translation)('14870'));
	        }
	      }
	
	      if (item.HasSpareParts === true && item.PaintSparePartStatusSum !== 0 && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	        // Paint spare parts not ordered
	        if (item.PaintSparePartStatusSum === 1) {
	          if (bodyLit) {
	            paintTextItems.push((0, _helpers.translation)('13047'));
	          } else {
	            paintTextItems.push((0, _helpers.translation)('638'));
	          }
	        }
	
	        // Paint spare parts not received
	        if (item.PaintSparePartStatusSum === 8) {
	          if (bodyLit) {
	            paintTextItems.push((0, _helpers.translation)('13049'));
	          } else {
	            paintTextItems.push((0, _helpers.translation)('639'));
	          }
	        }
	
	        // Paint spare parts received
	        if (item.PaintSparePartStatusSum === 16) {
	          if (bodyLit) {
	            paintTextItems.push((0, _helpers.translation)('14872'));
	          } else {
	            paintTextItems.push((0, _helpers.translation)('640'));
	          }
	        }
	      }
	
	      /*
	        if (paintNotOrdered && !paintOrdered) {
	        paintTextItems.push(translation('13047'))
	      }
	      if (bodyNotOrdered && !bodyOrdered) {
	        bodyTextItems.push(translation('13048'))
	      }
	      if (paintOrdered && !paintNotOrdered) {
	        paintTextItems.push(translation('13049'))
	      }
	      if (bodyOrdered && !bodyNotOrdered) {
	        bodyTextItems.push(translation('13050'))
	      }
	        */
	
	      image += '.svg';
	
	      var lines = [];
	      var hoverHoverTextLines = function hoverHoverTextLines(val, key) {
	        if (key === 0) {
	          if (lines.length > 0) {
	            lines.push(_react2.default.createElement('p', { key: item.Id + '_' + Math.random() + '_' + Math.random() }));
	          }
	        }
	        lines.push(_react2.default.createElement(
	          'p',
	          { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	          val
	        ));
	      };
	
	      var addOverallText = function addOverallText(val, key) {
	        if (key !== 0) {
	          overallTextItems.push(val);
	        }
	      };
	
	      if (paintLit && bodyLit) {
	        paintTextItems.map(addOverallText);
	        bodyTextItems.map(addOverallText);
	
	        overallTextItems.map(hoverHoverTextLines);
	      } else {
	        paintTextItems.map(hoverHoverTextLines);
	        bodyTextItems.map(hoverHoverTextLines);
	      }
	      var useClick = true;
	      var useHover = true;
	
	      if (lines.length === 0) {
	        lines = (0, _helpers.translation)('14856');
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'fullSize orderStatus' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _HoverPopup2.default,
	            { UseClick: useClick, UseHover: useHover, orderId: item.Id, getVerticalScrollOffset: this.props.getVerticalScrollOffset, getHorizontalScrollOffset: this.props.getHorizontalScrollOffset, scrollColumn: this.props.step, PopupContent: lines },
	            _react2.default.createElement('img', { src: imgPath + image, className: 'PaintBodyStatus' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var item = this.state.item;
	
	      if (typeof item === 'undefined') return null;
	      // if (item.NeedReferredApprove) return null
	      // Active class
	      var className = '';
	      var whatdots = '';
	      if (item.IsStarted) {
	        className = 'active';
	        whatdots = '/images/svgs/menuicons/Menu-dots-white.svg';
	      } else {
	        whatdots = '/images/svgs/menuicons/Menu_dots-Black.svg';
	      }
	
	      var renderLinked = function renderLinked() {
	        if (!(0, _auth.hasSubscriptionPermission)(_this8.props.auth, 30)) return null;
	        if (item.LinkedOrders.length !== 0) {
	          var ariaLabel = '';
	          if (!_this8.state.isTouch) ariaLabel = (0, _helpers.translation)('13525');
	          if (item.IsStarted) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'linkedIcon hint--bottom-left', 'aria-label': ariaLabel, onClick: _this8.startOrder },
	              _react2.default.createElement('img', { src: '/images/svgs/workscreen/link-order-white.svg', style: { width: 15, height: 15 } })
	            );
	          } else {
	            return _react2.default.createElement(
	              'div',
	              { className: 'linkedIcon hint--bottom-left', 'aria-label': ariaLabel, onClick: _this8.startOrder },
	              _react2.default.createElement('img', { src: '/images/svgs/workscreen/link-order.svg', style: { width: 15, height: 15 } })
	            );
	          }
	        }
	      };
	      var stepName = (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', item.StepId));
	      // Render name
	      var renderName = function renderName() {
	        if (item.LinkedOrders.length !== 0 && (0, _auth.hasSubscriptionPermission)(_this8.props.auth, 30)) {
	          var toggleSelector = function toggleSelector(e) {
	            e.preventDefault();
	            if (!_this8.state.openlinkedselector) {
	              _this8.setState({
	                openlinkedselector: true
	              });
	              window.setTimeout(function () {
	                window.removeEventListener('click', toggleSelector);
	                window.addEventListener('click', toggleSelector);
	              }, 10);
	            } else {
	              window.removeEventListener('click', toggleSelector);
	              window.setTimeout(function () {
	                _this8.setState({
	                  openlinkedselector: false
	                });
	              }, 10);
	            }
	          };
	          var title = _this8.modalTitle();
	          var modalTitle = '';
	          if (!_this8.state.isTouch) modalTitle = title;
	          var _renderLinked = function _renderLinked(v, k) {
	            var title = _this8.modalTitle(v);
	            if (_this8.state.isTouch) {
	              return _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/orders/' + v.Id, onClick: _this8.canClick.bind(_this8, 'workcard', v.Id) },
	                k + 2,
	                '. ',
	                title
	              );
	            }
	            return _react2.default.createElement(
	              _HoverExtent2.default,
	              { router: _this8.props.router, id: v.Id, item: v, key: k },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/orders/' + v.Id, onClick: _this8.canClick.bind(_this8, 'workcard', v.Id) },
	                k + 2,
	                '. ',
	                title
	              )
	            );
	          };
	
	          if (!_this8.state.isTouch) modalTitle = title;
	          return _react2.default.createElement(
	            'div',
	            { className: 'name linkedSelectorWrapper' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/orders/' + item.Id, unselectable: 'on', onClick: toggleSelector.bind(_this8) },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint--bottom-right', 'aria-label': modalTitle },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  title
	                )
	              ),
	              _this8.props.type === '0' && _react2.default.createElement(
	                'span',
	                null,
	                item.CustomerName
	              ),
	              _this8.props.type === '1' && _react2.default.createElement(
	                'span',
	                null,
	                stepName
	              )
	            ),
	            _this8.state.openlinkedselector && _react2.default.createElement(
	              'div',
	              { className: 'openlinkedselector' },
	              _this8.state.isTouch && _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/orders/' + item.Id },
	                '1. ',
	                _this8.modalTitle()
	              ),
	              !_this8.state.isTouch && _react2.default.createElement(
	                _HoverExtent2.default,
	                { router: _this8.props.router, id: item.Id, item: item },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/orders/' + item.Id },
	                  '1. ',
	                  _this8.modalTitle()
	                )
	              ),
	              item.LinkedOrders.map(_renderLinked)
	            )
	          );
	        }
	        title = _this8.modalTitle();
	        modalTitle = '';
	        if (!_this8.state.isTouch) modalTitle = title;
	        return _react2.default.createElement(
	          'div',
	          { className: 'name', onClick: _this8.goToWorkcard },
	          _this8.state.isTouch && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: (0, _auth.hasSubscriptionPermission)(_this8.props.auth, 0, 2) || (0, _auth.hasSubscriptionPermission)(_this8.props.auth, 0, 3) ? '/orders/' + item.Id : '', unselectable: 'on', onClick: _this8.canClick.bind(_this8, 'workcard', 0) },
	            _react2.default.createElement(
	              'div',
	              { className: '' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                title
	              )
	            ),
	            _this8.props.type === '0' && _react2.default.createElement(
	              'span',
	              null,
	              item.CustomerName
	            ),
	            _this8.props.type === '1' && _react2.default.createElement(
	              'span',
	              null,
	              stepName
	            )
	          ),
	          !_this8.state.isTouch && _react2.default.createElement(
	            _HoverExtent2.default,
	            { router: _this8.props.router, id: item.Id, item: item },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: (0, _auth.hasSubscriptionPermission)(_this8.props.auth, 0, 2) || (0, _auth.hasSubscriptionPermission)(_this8.props.auth, 0, 3) ? '/orders/' + item.Id : '', unselectable: 'on', onClick: _this8.canClick.bind(_this8, 'workcard', 0) },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint--bottom-right', 'aria-label': modalTitle },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  title
	                )
	              ),
	              _this8.props.type === '0' && _react2.default.createElement(
	                'span',
	                null,
	                item.CustomerName
	              ),
	              _this8.props.type === '1' && _react2.default.createElement(
	                'span',
	                null,
	                stepName
	              )
	            )
	          )
	        );
	      };
	      var isTouch = this.state.isTouch;
	      var hasAcc = (0, _auth.hasAccess)([5, 7], this.props.auth.user.UserType);
	      var menuClass = 'action__menu';
	      if (isTouch) menuClass += ' actionSwipe';
	
	      var renderCircleActions = function renderCircleActions() {
	        var renderActionMenuArea = function renderActionMenuArea() {
	          if (hasAcc) {
	            return _react2.default.createElement(
	              'div',
	              { className: menuClass, onClick: _this8.canClick.bind(_this8, 'action', 0) },
	              _react2.default.createElement(
	                'span',
	                null,
	                isTouch ? _react2.default.createElement('img', { src: '/images/icons/' + (item.IsStarted ? 'action-swipe-dots-white-22x22.png' : 'action-swipe-dot-22x.png') }) : _react2.default.createElement('img', { src: whatdots })
	              )
	            );
	          } else {
	            return _react2.default.createElement(_OrderActions2.default, { router: _this8.props.router, onOrderMove: _this8.props.MoveOrders, onOrderMoveSuccess: _this8.props.onMoveSuccess, open: _this8.props.openAction, itemType: _this8.props.type, item: item, type: 'workscreen', index: _this8.props.index, step: _this8.props.step, isStarted: item.IsStarted });
	          }
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          !item.IsDisplayOnly && (0, _auth.hasSubscriptionPermission)(_this8.props.auth, 10) && _this8.renderWorkers(),
	          !item.IsDisplayOnly && renderActionMenuArea()
	        );
	      };
	      var stopMessage = function stopMessage() {
	        var message = (0, _helpers.translation)(13501) + _this8.props.item.StoppedMessage;
	        if (_this8.props.item.StoppedMessage.length === 0) {
	          message = message.replace(':', '');
	        }
	        return message;
	      };
	      var modalTitle = this.modalTitle(this.state.item);
	      // Return
	      var mouseFix = '';
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 30)) {
	        mouseFix = 'mouseFix';
	      }
	      // not booked in paintshop
	      var popupText = (0, _helpers.translation)(15245);
	      // is booked but not finished in paintshop
	      if (item.IsPaintOrder && !item.PaintIsDraft && !item.IsArchived) {
	        popupText = (0, _helpers.translation)(15268);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'workscreen__item draggable ' + (item.IsDisplayOnly ? 'locked ' : '') + className, 'data-index': this.props.index },
	        _react2.default.createElement(
	          'div',
	          { className: 'upper' },
	          this.state.stopped.open && _react2.default.createElement(
	            'div',
	            { className: 'helpText' },
	            _react2.default.createElement(
	              'div',
	              { className: 'helperTextModal', onClick: this.togglePortal },
	              _react2.default.createElement('img', { src: '/images/icons/close_24-Black.png' }),
	              stopMessage()
	            )
	          ),
	          renderName(),
	          renderLinked(),
	          _react2.default.createElement(
	            'div',
	            { className: 'buttons' },
	            this.props.noCircle !== true && renderCircleActions()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'lower' },
	          _react2.default.createElement(
	            'div',
	            { onClick: this.goToWorkcard, className: 'lower_icons', style: { display: 'inline-block' } },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) || (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 3) ? '/orders/' + item.Id : '', unselectable: 'on', onClick: this.canClick.bind(this, 'workcard', 0) },
	              this.renderTransportIcon(),
	              this.renderNotes(),
	              this.renderColor()
	            )
	          ),
	          this.props.auth.departmentType !== 0 && _react2.default.createElement('div', { className: 'divider dividerTop body' }),
	          this.props.auth.departmentType === 0 && _react2.default.createElement('div', { className: 'divider' }),
	          _react2.default.createElement(
	            'div',
	            { onClick: this.goToInspection, className: 'borderBottom ' + mouseFix },
	            this.renderInspectionStep(),
	            this.renderMissingPart(),
	            _react2.default.createElement(
	              'div',
	              { className: 'borderBottom ' + mouseFix },
	              this.renderTaksering()
	            )
	          ),
	          this.props.auth.departmentType !== 0 && _react2.default.createElement('div', { className: 'divider dividerTop body' }),
	          this.props.auth.departmentType === 0 && _react2.default.createElement('div', { className: 'divider' }),
	          this.renderDisplayTimeNew()
	        ),
	        this.renderNewItemLine(item),
	        this.state.quality.open && _react2.default.createElement(_QualityCheckModal2.default, {
	          router: this.props.router,
	          show: this.state.quality.open,
	          data: this.state.quality.data,
	          name: modalTitle,
	          onSuccess: this.startOrderSuccess,
	          onClose: this.closeQualityModal,
	          move: false }),
	        this.state.stopOtherOrders.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'stopOtherOrders') },
	          _react2.default.createElement(_StopOtherOrders2.default, { Stop: false, AllOrders: this.AllOrders.bind(this, 'stopOtherOrders'), NotAllOrders: this.NotAllOrders.bind(this, 'stopOtherOrders') })
	        ),
	        this.state.stopOrders.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'stopOrders') },
	          _react2.default.createElement(_StopOtherOrders2.default, { Stop: this.state.stopOrders.open, AllOrders: this.AllOrders.bind(this, 'stopOrders'), NotAllOrders: this.NotAllOrders.bind(this, 'stopOrders') })
	        ),
	        this.state.orderReferenceApprove.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'refOrderApproval_popup', onPortalClose: this.onPortalClose.bind(this, 'orderReferenceApprove') },
	          _react2.default.createElement(_ReferenceOrderActionModal2.default, {
	            show: this.state.orderReferenceApprove.open,
	            item: item,
	            id: item.Id,
	            onClose: this.onPortalClose.bind(this, 'orderReferenceApprove'),
	            checkForPopups: this.props.checkForPopups,
	            department: this.props.auth.departmentType })
	        ),
	        this.renderConfirm(popupText, 'confirmStart', this.onConfirmStart)
	      );
	    }
	  }, {
	    key: 'renderConfirm',
	    value: function renderConfirm(text, stateField, onYes, onNo) {
	      var _this9 = this;
	
	      if (this.state[stateField] === undefined || this.state[stateField].open !== true) return null;
	      var onClose = function onClose() {
	        _this9.setState(_defineProperty({}, stateField, { open: false }), function () {
	          if (typeof onNo === 'function') {
	            onNo();
	          }
	        });
	      };
	
	      var onConfirm = function onConfirm() {
	        _this9.setState(_defineProperty({}, stateField, { open: false }), function () {
	          if (typeof onYes === 'function') {
	            onYes();
	          }
	        });
	      };
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { className: 'confirm_popup', onPortalClose: onClose },
	        _react2.default.createElement(_Confirm2.default, { renderText: function renderText() {
	            return _react2.default.createElement(
	              'div',
	              null,
	              text
	            );
	          }, confirm: onConfirm, notConfirm: onClose })
	      );
	    }
	  }, {
	    key: 'openReferenceApprove',
	    value: function openReferenceApprove() {
	      this.props.triggerPopup(true);
	      this.setState({
	        orderReferenceApprove: {
	          open: true,
	          id: this.props.item.id
	        }
	      });
	    }
	  }, {
	    key: 'onReferenceSave',
	    value: function onReferenceSave(state) {
	      if (state === 2) {
	        this.setState({
	          item: _extends({}, this.state.item, {
	            IsDeleted: true
	          })
	        });
	      } else if (state === 1) {
	        this.setState({
	          item: _extends({}, this.state.item, {
	            ReferredApproved: true
	          })
	        });
	      }
	    }
	  }, {
	    key: 'AllOrders',
	    value: function AllOrders(type) {
	      var _this10 = this;
	
	      this.props.triggerPopup(false);
	      if (type === 'stopOtherOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          WorkOnAll: true
	        })), function () {
	          _this10.startOrder();
	        });
	      } else if (type === 'stopOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          StopAll: true
	        })), function () {
	          _this10.stopOrder();
	        });
	      }
	    }
	  }, {
	    key: 'NotAllOrders',
	    value: function NotAllOrders(type) {
	      var _this11 = this;
	
	      this.props.triggerPopup(false);
	      if (type === 'stopOtherOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          WorkOnAll: false
	        })), function () {
	          _this11.startOrder();
	        });
	      } else if (type === 'stopOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          StopAll: false
	        })), function () {
	          _this11.stopOrder();
	        });
	      }
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      var _this12 = this;
	
	      this.props.triggerPopup(false);
	      this.setState(function (prevState) {
	        return _defineProperty({}, type, _extends({}, _this12.state[type], {
	          open: false
	        }));
	      });
	    }
	  }]);
	
	  return Item;
	}(_react.PureComponent);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  startOrder: _orders.startOrder,
	  stopOrder: _orders.stopOrder,
	  triggerPopup: _backdrop.triggerPopup
	})(Item);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _backdrop = __webpack_require__(29);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Constants
	// import HelpText from '../../../shared/components/HelpText'
	
	
	var OrderBookingButton = function (_PureComponent) {
	  _inherits(OrderBookingButton, _PureComponent);
	
	  function OrderBookingButton(props) {
	    _classCallCheck(this, OrderBookingButton);
	
	    var _this = _possibleConstructorReturn(this, (OrderBookingButton.__proto__ || Object.getPrototypeOf(OrderBookingButton)).call(this, props));
	
	    _this.state = {};
	    _this.renderBookExternalLak = _this.renderBookExternalLak.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderBookingButton, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.order !== nextProps.order;
	    }
	  }, {
	    key: 'renderBookExternalLak',
	    value: function renderBookExternalLak() {
	      var _this2 = this;
	
	      var _props = this.props,
	          order = _props.order,
	          regularBooking = _props.regularBooking,
	          disabled = _props.disabled;
	      var _props$auth = this.props.auth,
	          allowNoCustomer = _props$auth.allowNoCustomer,
	          departmentType = _props$auth.departmentType,
	          user = _props$auth.user;
	
	      var missingBodywork = !order.IsBodyShopOrder;
	      var bookingStopped = order.IsAgreementForsiCreated && !order.IsEvaluation;
	      var evaluationStopped = (!order.IsEvaluation || order.IsEvaluation && !order.IsEvaluated) && order.CustomerWPEvaluationRequired && order.IsAgreementOrder || departmentType === 0 && (!order.IsEvaluation || order.IsEvaluation && !order.IsEvaluated) && order.CustomerWPEvaluationRequired && order.IsAgreementOrder;
	      var evaluationRejected = order.IsEvaluation && !order.IsEvaluated && order.IsEvaluationRejected && order.CustomerWPEvaluationRequired && order.IsAgreementOrder;
	      var bookingButtonClass = 'BookPaintBTN';
	      var bookingButtonLabel = '';
	      var bookingStoppedLabel = '';
	      if (bookingStopped) {
	        bookingButtonClass += ' disabled hint--left';
	        bookingButtonLabel += ' ' + (0, _helpers.translation)('13568');
	        bookingStoppedLabel = (0, _helpers.translation)('13568');
	      } else if (evaluationStopped) {
	        var evaluationRequiredTxt = order.IsEvaluation ? (0, _helpers.translation)('13038') : (0, _helpers.translation)('15177');
	        bookingButtonClass += ' disabled hint--left';
	        bookingButtonLabel += ' ' + evaluationRequiredTxt;
	        bookingStoppedLabel = evaluationRequiredTxt;
	      }
	      var bookingStoppedToast = function bookingStoppedToast() {
	        window.toastr.error(order.IsEvaluation ? (0, _helpers.translation)('13038') : (0, _helpers.translation)('15177'));
	        if (!order.IsEvaluation && !order.IsEvaluated) {
	          _this2.props.togglePopup.bind(_this2, 'createEstimationPopup')();
	        }
	      };
	      var requireCustomerStopped = order.ForsiReportId !== null && order.CustomerSelect === 1 && !allowNoCustomer;
	
	      if (regularBooking) {
	        bookingButtonClass = '';
	        bookingButtonLabel = '';
	        bookingStoppedLabel = '';
	        if (departmentType !== 1) {
	          if (requireCustomerStopped || bookingStopped || evaluationStopped || evaluationRejected) {
	            bookingButtonClass += ' disabled hint--left';
	          }
	          if (requireCustomerStopped) {
	            bookingButtonLabel += ' ' + (0, _helpers.translation)('14910');
	            bookingStoppedLabel = (0, _helpers.translation)('14910');
	          } else if (bookingStopped) {
	            bookingButtonLabel += ' ' + (0, _helpers.translation)('13568');
	            bookingStoppedLabel = (0, _helpers.translation)('13568');
	          } else if (evaluationStopped && !evaluationRejected) {
	            var _evaluationRequiredTxt = order.IsEvaluation ? (0, _helpers.translation)('13038') : (0, _helpers.translation)('15177');
	            bookingButtonLabel += ' ' + _evaluationRequiredTxt;
	            bookingStoppedLabel = _evaluationRequiredTxt;
	          } else if (evaluationRejected) {
	            bookingButtonClass += ' disabled hint--left';
	            bookingButtonLabel += ' ' + (0, _helpers.translation)('14929');
	            bookingStoppedLabel = (0, _helpers.translation)('14929');
	          }
	        }
	        var onClick = function onClick() {
	          if (bookingStopped || evaluationRejected) {
	            _this2.props.togglePopup.bind(_this2, 'createEstimationPopup');
	          } else if (evaluationStopped) {
	            bookingStoppedToast();
	          }
	        };
	        var department = order.OrderDepartment;
	        var renderBodyCustomer = order.BodyShopIsDraft === true && (0, _auth.hasAccess)([4], user.UserType);
	        var renderBodyShop = department === 1 && order.BodyShopIsDraft === true && !(0, _auth.hasAccess)([4], user.UserType);
	        if ((department !== 1 && order.IsDraft || renderBodyShop || renderBodyCustomer) !== true) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'actions' },
	          department !== 1 && order.IsDraft && _react2.default.createElement(
	            'div',
	            null,
	            (bookingStopped || evaluationStopped || evaluationRejected) && _react2.default.createElement(
	              'div',
	              {
	                className: 'left hint--left',
	                'aria-label': bookingStoppedLabel
	              },
	              _react2.default.createElement('img', { src: '/images/icons/Stop-31.png', onClick: onClick })
	            ),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) && _react2.default.createElement(
	              _button2.default,
	              {
	                style: 'cta',
	                size: 'm',
	                spacing: 0,
	                className: bookingButtonClass,
	                'aria-label': bookingButtonLabel,
	                disabled: disabled || this.state.updating,
	                onClick: bookingStopped || evaluationRejected ? this.props.togglePopup.bind(this, 'createEstimationPopup') : evaluationStopped ? bookingStoppedToast : this.props.bookOrder.bind(this, undefined, false)
	              },
	              (0, _helpers.translation)('13384')
	            )
	          ),
	          renderBodyShop && _react2.default.createElement(
	            'div',
	            null,
	            departmentType === 0 && (bookingStopped || evaluationStopped || evaluationRejected) && _react2.default.createElement(
	              'div',
	              {
	                className: 'left hint--left',
	                'aria-label': bookingStoppedLabel
	              },
	              _react2.default.createElement('img', { src: '/images/icons/Stop-31.png', onClick: onClick })
	            ),
	            requireCustomerStopped && _react2.default.createElement(
	              'div',
	              {
	                className: 'left hint--left',
	                'aria-label': bookingStoppedLabel
	              },
	              _react2.default.createElement('img', { className: 'customer_stop', src: '/images/svgs/stop-customer.svg', onClick: this.props.togglePopup.bind(this, 'showSetCustomerPopup') })
	            ),
	            !requireCustomerStopped && department !== 0 && order.BodyShopIsDraft && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) && _react2.default.createElement(
	              _button2.default,
	              {
	                style: 'cta',
	                size: 'm',
	                spacing: 0,
	                className: bookingButtonClass,
	                'aria-label': bookingButtonLabel,
	                disabled: disabled || this.state.updating,
	                onClick: bookingStopped /* || evaluationRejected */ ? this.props.togglePopup.bind(this, 'createEstimationPopup') : missingBodywork ? this.props.togglePopup.bind(this, 'confirmMissingBodywork') : this.props.bookOrder.bind(this, undefined, true)
	              },
	              (0, _helpers.translation)('13384')
	            ),
	            requireCustomerStopped && order.BodyShopIsDraft && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) && _react2.default.createElement(
	              _button2.default,
	              {
	                style: 'cta',
	                size: 'm',
	                spacing: 0,
	                className: bookingButtonClass,
	                'aria-label': bookingButtonLabel,
	                disabled: disabled || this.state.updating,
	                onClick: this.props.togglePopup.bind(this, 'showSetCustomerPopup')
	              },
	              (0, _helpers.translation)('13384')
	            )
	          ),
	          renderBodyCustomer && _react2.default.createElement(
	            'div',
	            null,
	            order.BodyShopIsDraft && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) && _react2.default.createElement(
	              _button2.default,
	              {
	                style: 'cta',
	                size: 'm',
	                spacing: 0,
	                className: bookingButtonClass,
	                'aria-label': bookingButtonLabel,
	                disabled: disabled || this.state.updating,
	                onClick: this.props.bookOrder.bind(this, undefined, true)
	              },
	              (0, _helpers.translation)('13384')
	            )
	          )
	        );
	      }
	      // if (departmentType === 1) {
	      if (order.OrderDepartment === 1 && order.HasAvailablePaintPartner) {
	        if (order.IsDraft) {
	          return _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [1], block: true },
	            (bookingStopped || evaluationStopped) && _react2.default.createElement(_icon2.default, { size: 'm', icon: { fileName: '/images/icons/Stop-31.png' }, ariaText: bookingStoppedLabel, onClick: bookingStopped ? this.showCreateEstimationPopup : bookingStoppedToast }),
	            order.IsDraft && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) && _react2.default.createElement(
	              _button2.default,
	              {
	                style: 'link',
	                spacing: 0,
	                className: bookingButtonClass,
	                'aria-label': bookingButtonLabel,
	                disabled: disabled || this.state.updating,
	                onClick: bookingStopped ? this.showCreateEstimationPopup : evaluationStopped ? bookingStoppedToast : this.props.bookOrder.bind(this, undefined, false, false, true)
	              },
	              (0, _helpers.translation)('13384')
	            ),
	            _react2.default.createElement('div', { className: 'clearFix' })
	          );
	        } else {
	          return _react2.default.createElement(_labelWrapper2.default, {
	            labelText: (0, _helpers.translation)('13532'),
	            helpText: (0, _helpers.translation)('13011') + ': ' + order.PublishedBy + '\n' + (0, _helpers.translation)('388') + ': ' + (0, _time.renderFullDate)(order.PublishDate) + '\n' + (0, _helpers.translation)('1052') + ': ' + order.PublishedByMail + '\n' + (0, _helpers.translation)('38') + ': ' + order.PublishedByMobile
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.order) return null;
	
	      if (this.props.regularBooking) {
	        return this.renderBookExternalLak();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: '' },
	        this.renderBookExternalLak()
	      );
	    }
	  }]);
	
	  return OrderBookingButton;
	}(_react.PureComponent);
	
	OrderBookingButton.defaultProps = {
	  isBodyshop: false,
	  disabled: false,
	  onUpdateOrder: function onUpdateOrder() {
	    console.log('onUpdateOrder default');
	  },
	  togglePopup: function togglePopup() {
	    console.log('togglePopup default');
	  },
	  bookOrder: function bookOrder() {
	    console.log('bookOrder default');
	  },
	  regularBooking: false
	};
	
	OrderBookingButton.propTypes = {
	  onUpdateOrder: _propTypes2.default.func,
	  togglePopup: _propTypes2.default.func,
	  bookOrder: _propTypes2.default.func,
	  isBodyshop: _propTypes2.default.bool,
	  regularBooking: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired,
	  disabled: _propTypes2.default.bool.isRequired
	};
	
	OrderBookingButton.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopupActionBG: _backdrop.triggerPopupActionBG
	})(OrderBookingButton);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _customers = __webpack_require__(74);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	__webpack_require__(1426);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	// Actions
	
	
	// Components
	
	
	// Utils
	
	
	// Elements
	
	
	// Styles
	
	
	var SetCustomer = function (_Component) {
	  _inherits(SetCustomer, _Component);
	
	  function SetCustomer(props) {
	    _classCallCheck(this, SetCustomer);
	
	    var _this = _possibleConstructorReturn(this, (SetCustomer.__proto__ || Object.getPrototypeOf(SetCustomer)).call(this, props));
	
	    _this.state = {
	      customerId: null,
	      hasManualBaseExtent: null,
	      hasManualAddonExtent: null,
	      confirm: {
	        open: false
	      },
	      expandModal: false // Used to change size of modal when dropdown is open to prevent styling errors.
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onConfirm = _this.onConfirm.bind(_this);
	    _this.renderConfirmText = _this.renderConfirmText.bind(_this);
	    _this.showConfirm = _this.showConfirm.bind(_this);
	    _this.isConfirmDisabled = _this.isConfirmDisabled.bind(_this);
	    _this.mustConfirm = _this.mustConfirm.bind(_this);
	    _this.onCustomerDropDownOpenChange = _this.onCustomerDropDownOpenChange.bind(_this);
	
	    _this.props.getCustomers(parseInt(_this.props.auth.user.ShopId));
	    _this.props.hasExtent(_this.props.item.Id).then(function (res) {
	      _this.setState({
	        hasManualBaseExtent: res.data.HasManualBaseExtent,
	        hasManualAddonExtent: res.data.HasManualAddonExtent,
	        hasManualBodyShopBaseExtent: res.data.HasManualBodyShopBaseExtent,
	        hasManualBodyShopAddonExtent: res.data.HasManualBodyShopAddonExtent
	      });
	    });
	    return _this;
	  }
	
	  _createClass(SetCustomer, [{
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.setState({
	        customerId: parseInt(e.target.value)
	      });
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm(e) {
	      var _this2 = this;
	
	      this.props.setCustomer(this.props.item.Id, this.state.customerId).then(function (res) {
	        var custData = res.data.Customer;
	        var item = _extends({}, _this2.props.item);
	        item.CustomerId = custData.CustomerId;
	        item.CustomerName = custData.CustomerName;
	        item.CustomerPhone = custData.CustomerPhone;
	        item.CustomerCity = custData.CustomerCity;
	        item.CustomerZip = custData.CustomerZip;
	        item.CustomerSelect = res.data.CustomerSelect;
	        _this2.props.updateOrder(item);
	        _this2.props.close();
	
	        // Toastr
	        // window.toastr.success(translation('14911'), translation('13424'))
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('14912'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'showConfirm',
	    value: function showConfirm(e) {
	      this.setState({
	        confirm: { open: true }
	      });
	    }
	  }, {
	    key: 'onAbort',
	    value: function onAbort(e) {
	      this.setState({
	        confirm: { open: false }
	      });
	    }
	  }, {
	    key: 'renderConfirmText',
	    value: function renderConfirmText() {
	      return (0, _helpers.translation)('14913'); // Et manuelt omfang er angivet for denne ordre... bla bla
	    }
	  }, {
	    key: 'onCustomerDropDownOpenChange',
	    value: function onCustomerDropDownOpenChange(name, open) {
	      this.setState({
	        expandModal: open
	      });
	    }
	  }, {
	    key: 'mustConfirm',
	    value: function mustConfirm() {
	      return this.state.hasManualBaseExtent === true || this.state.hasManualAddonExtent === true || this.state.hasManualBodyShopBaseExtent === true || this.state.hasManualBodyShopAddonExtent === true;
	    }
	  }, {
	    key: 'isConfirmDisabled',
	    value: function isConfirmDisabled() {
	      return this.state.hasManualBaseExtent === null || this.hasManualAddonExtent === null || this.state.hasManualBodyShopBaseExtent === null || this.state.hasManualBodyShopAddonExtent === null || this.state.customerId === 0 || this.state.customerId === null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.inModal) {
	        return this.renderAsModal();
	      } else {
	        return this.renderContent();
	      }
	    }
	  }, {
	    key: 'renderAsModal',
	    value: function renderAsModal() {
	      var modalButtonProps = null;
	      if (this.props.inModal) {
	        modalButtonProps = {
	          disabled: this.isConfirmDisabled(),
	          actionLabelText: (0, _helpers.translation)('14909'),
	          onActionClick: this.mustConfirm() ? this.showConfirm : this.onConfirm
	        };
	      }
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        {
	          show: true,
	          onClose: this.props.close,
	          header: (0, _helpers.translation)('2259'),
	          bottomBarProps: modalButtonProps
	        },
	        this.renderContent()
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.props.item.Id === undefined || this.props.item.Id === null) {
	        return null;
	      }
	      // let mustConfirm = this.state.hasManualBaseExtent === true || this.state.hasManualAddonExtent === true || this.state.hasManualBodyShopBaseExtent === true || this.state.hasManualBodyShopAddonExtent === true
	      // let disabled = this.state.hasManualBaseExtent === null || this.hasManualAddonExtent === null || this.state.hasManualBodyShopBaseExtent === null || this.state.hasManualBodyShopAddonExtent === null || this.state.customerId === 0 || this.state.customerId === null
	      var activeCustomers = this.props.customers.filter(function (_) {
	        return _.Active;
	      });
	      // console.log('disabled ', disabled, 'inModal', this.props.inModal)
	      var additionalClass = this.props.inModal && this.state.expandModal ? ' expandModal' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'poppedup padding colorInlinePopup form setCustomer' + additionalClass },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: !this.props.inModal ? (0, _helpers.translation)('2259') : '' },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { size: this.props.inModal ? 'l' : 'm', value: this.state.customerId, name: 'CustomerId', onChange: this.onInputChange, onOpenChange: this.onCustomerDropDownOpenChange },
	            _react2.default.createElement(
	              'option',
	              { value: '0' },
	              (0, _helpers.translation)('2259')
	            ),
	            activeCustomers.map(function (c, key) {
	              return _react2.default.createElement(
	                'option',
	                { value: c.CustomerId, key: key },
	                c.Name
	              );
	            })
	          ),
	          this.props.inModal && _react2.default.createElement(_divider2.default, { size: 2, noLine: true })
	        ),
	        !this.props.inModal && _react2.default.createElement(_button2.default, { size: 'm', disabled: this.isConfirmDisabled(), onClick: this.mustConfirm() ? this.showConfirm : this.onConfirm, labelText: (0, _helpers.translation)('14909') }),
	        this.state.confirm.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirmModal', onPortalClose: this.onAbort.bind(this) },
	          _react2.default.createElement(_Confirm2.default, { renderText: this.renderConfirmText, confirm: this.onConfirm.bind(this), notConfirm: this.onAbort.bind(this) })
	        )
	      );
	    }
	  }]);
	
	  return SetCustomer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  setCustomer: _orders.setCustomer,
	  getCustomers: _customers.getCustomers,
	  hasExtent: _orders.hasExtent
	})(SetCustomer);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _auth = __webpack_require__(8);
	
	var _time = __webpack_require__(17);
	
	var _CreateEstimationModal = __webpack_require__(237);
	
	var _CreateEstimationModal2 = _interopRequireDefault(_CreateEstimationModal);
	
	var _constants = __webpack_require__(5);
	
	var _InfoPopup = __webpack_require__(1046);
	
	var _InfoPopup2 = _interopRequireDefault(_InfoPopup);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _helpers = __webpack_require__(2);
	
	var _backdrop = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import moment from 'moment'
	
	// Utils
	
	
	// Constants
	
	
	// components
	
	
	// Utils
	
	
	var DEPARTMENTTYPE = {
	  Paint: 0,
	  Body: 1
	};
	
	var Taksering = function (_Component) {
	  _inherits(Taksering, _Component);
	
	  function Taksering(props) {
	    _classCallCheck(this, Taksering);
	
	    var _this = _possibleConstructorReturn(this, (Taksering.__proto__ || Object.getPrototypeOf(Taksering)).call(this, props));
	
	    _this.state = {
	      showInfoPopup: false,
	      estimation: {
	        open: false
	      }
	    };
	    _this.openLink = _this.openLink.bind(_this);
	    return _this;
	  }
	
	  _createClass(Taksering, [{
	    key: 'openLink',
	    value: function openLink(link, allowClick) {
	      if (!allowClick) return;
	      this.props.router.push(link);
	    }
	  }, {
	    key: 'changeIcon',
	    value: function changeIcon(icon) {
	      if (this.props.type === 'workscreen' && this.props.item.IsStarted) icon = icon.replace('.svg', '-white.svg');
	      return icon;
	    }
	  }, {
	    key: 'formatSectionType',
	    value: function formatSectionType(sectionType) {
	      switch (sectionType) {
	        case 1:
	          return DEPARTMENTTYPE.Paint;
	        case 2:
	          return DEPARTMENTTYPE.Body;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var allowClick = this.props.type !== 'workscreen';
	      var image = '';
	      var isMainReportLoadedIcon = false;
	      var report = this.props.item.Report;
	      var attachment = null;
	      if (report !== null) {
	        attachment = report.Attachments.find(function (item) {
	          return _this2.formatSectionType(item.SectionType) === _this2.props.auth.departmentType;
	        });
	      }
	
	      var clickPriceApproval = function clickPriceApproval(e) {
	        if (_this2.props.auth.departmentType === 1 && (0, _auth.hasAccess)([4], _this2.props.auth.user.UserType)) return null;
	        if (typeof _this2.props.onPopupOpen === 'function') _this2.props.onPopupOpen();
	        var orderPriceType = e.target.name.split('.')[1];
	        var token = orderPriceType === 'Extent' ? _this2.props.item.PriceApprovalToken : _this2.props.item.PriceApprovalTokenAddon;
	        _this2.openLink('/priceapproval/' + token, allowClick);
	      };
	      var newFileUrl = '';
	      var bookingStopped = this.props.item.IsAgreementForsiCreated && !this.props.item.IsEvaluation;
	      var evaluationStopped = this.props.item.IsEvaluation && !this.props.item.IsEvaluated && this.props.item.CustomerWPEvaluationRequired && this.props.item.IsAgreementOrder;
	
	      if (this.props.item.NeedReferredApprove && allowClick) {
	        var onClick = function onClick(e) {
	          if (typeof _this2.props.onPopupOpen === 'function') _this2.props.onPopupOpen();
	          _this2.props.openReferenceApprove(e);
	        };
	        return _react2.default.createElement(
	          'span',
	          { className: 'icon hint--left', 'aria-label': (0, _helpers.translation)('751') },
	          _react2.default.createElement('img', { src: '/images/svgs/New-order-red-referred.svg', className: 'hasCursor', onClick: onClick.bind(this) })
	        );
	      } else if (this.props.item.OrderType === 1 && !this.props.item.PriceApprovalTokenAddon) {
	        var IsAssessmentOk = this.props.item.IsAssessmentOk;
	
	        var chainUsesDBS = this.props.auth.permissions.ChainAssessmentSystem === 2;
	        var mouseText = (0, _helpers.translation)('13023');
	
	        // ### New
	        if (report !== null && report.ReportVersionNr === 0 && report.IsApproved) {
	          isMainReportLoadedIcon = true;
	          image = 'main-report-loaded.svg';
	          if (report.Paint && attachment) {
	            newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token);
	          }
	          if (report.Body && attachment) {
	            newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token);
	          }
	        }
	
	        // if (this.props.item.ForsiOrderExtent) {
	        //   isMainReportLoadedIcon = true
	        //   image = 'main-report-loaded.svg'
	        //   newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + this.props.item..OrderFile.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
	        // }
	        // if (this.props.item.BodyShop) {
	        //   isMainReportLoadedIcon = true
	        //   image = 'main-report-loaded.svg'
	        //   newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + this.props.item.BodyShop.OrderFile.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
	        // }
	        // if (this.props.item.Id + '' === '130398') { // 130398 doesn't exit
	        //   // console.log(this.props.item)
	        // }
	
	        var onClickForShop = function onClickForShop() {
	          // if (!allowClick || IsAssessmentOk) return
	          if ((0, _auth.hasAccess)([4], _this2.props.auth.user.UserType) || _this2.props.auth.departmentType === 1) {
	            _this2.props.router.push('/orders/' + _this2.props.item.Id + '?page=2');
	          } else {
	            if (!(0, _auth.hasSubscriptionPermission)(_this2.props.auth, 10)) return null;
	            _this2.props.router.push('/orders/' + _this2.props.item.Id + '/orderinspection');
	          }
	        };
	        // Kunde
	        if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.item.LastUpdatedType === 1) {
	          image = 'charged-later-recieved.svg';
	          isMainReportLoadedIcon = false;
	          mouseText = (0, _helpers.translation)('1019');
	          image = this.changeIcon(image);
	          return _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': mouseText },
	              _react2.default.createElement('img', { src: '/images/svgs/taksering/' + image, className: 'hasCursor', onClick: onClickForShop })
	            )
	          );
	        }
	
	        // Pladev�rksted/Karosseri
	        if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.item.LastUpdatedType === 1 && this.props.auth.departmentType === 1) {
	          image = 'charged-later-recieved.svg';
	          isMainReportLoadedIcon = false;
	          mouseText = (0, _helpers.translation)('1019');
	          image = this.changeIcon(image);
	          return _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': mouseText },
	              _react2.default.createElement('img', { src: '/images/svgs/taksering/' + image, className: 'hasCursor', onClick: onClickForShop })
	            )
	          );
	        }
	
	        // Lak/Integration
	        if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.item.LastUpdatedType === 1 && this.props.auth.departmentType !== 1) {
	          image = 'charged-later-sent.svg';
	          isMainReportLoadedIcon = false;
	          mouseText = (0, _helpers.translation)('13528');
	          image = this.changeIcon(image);
	          return _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': mouseText },
	              _react2.default.createElement('img', { src: '/images/svgs/taksering/' + image, className: 'hasCursor', onClick: onClickForShop })
	            )
	          );
	        }
	
	        // Additional report = V-Nr > 0 / Minus Rp raport || IsApproved
	        // let reportId = this.props.item.ForsiReportId
	        // let hasAddonReport = reportId !== null && reportId.substring(reportId.length - 2, reportId.length - 1) === 'T'
	
	        // (hasAddonReport && this.props.item. !== null)
	        if (report !== null && !chainUsesDBS && report.IsApproved && report.ReportVersionNr > 0) {
	          mouseText = (0, _helpers.translation)('937');
	          if (IsAssessmentOk || (0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	            image = 'update-approved.svg';
	            isMainReportLoadedIcon = false;
	            if (report.Paint && attachment) {
	              // console.log('orderfile', this.props.item..OrderFile)
	              newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token);
	            }
	            if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.auth.departmentType !== 1) {
	              mouseText = (0, _helpers.translation)('13530');
	            }
	            image = this.changeIcon(image);
	            return _react2.default.createElement(
	              'span',
	              { className: 'icon hasTextInBubble' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint--top', 'aria-label': mouseText },
	                _react2.default.createElement(
	                  'a',
	                  { href: newFileUrl, title: attachment ? attachment.FileName : '', target: '_blank' },
	                  _react2.default.createElement('img', { src: '/images/svgs/taksering/' + image, className: 'hasCursor' })
	                )
	              )
	            );
	          } else {
	            image = 'update-not-approved.svg';
	            isMainReportLoadedIcon = false;
	            mouseText = (0, _helpers.translation)('13531');
	            mouseText = mouseText.replace('- ', '-\n');
	            image = this.changeIcon(image);
	            return _react2.default.createElement(
	              'span',
	              { className: 'icon hasTextInBubble' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint--top', 'aria-label': mouseText },
	                _react2.default.createElement('img', { src: '/images/svgs/taksering/' + image, className: 'hasCursor', onClick: onClickForShop })
	              )
	            );
	          }
	        }
	
	        // Main report // V-Nr = 0 - Minus Rp Report
	        if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType) && isMainReportLoadedIcon && report.Paint !== null && !chainUsesDBS) {
	          image = this.changeIcon(image);
	          return _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': mouseText },
	              _react2.default.createElement(
	                'a',
	                { href: newFileUrl, title: attachment ? attachment.FileName : '', target: '_blank' },
	                _react2.default.createElement('img', { src: '/images/svgs/taksering/' + image, className: 'hasCursor' })
	              )
	            )
	          );
	        }
	
	        if (this.props.item.ForsiReportId) {
	          if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.auth.departmentType !== 1) {
	            if (IsAssessmentOk === true) {
	              image = 'main-report-approved.svg';
	              isMainReportLoadedIcon = false;
	              mouseText = (0, _helpers.translation)('13513');
	            } else {
	              image = 'main-report-not-approved.svg';
	              isMainReportLoadedIcon = false;
	              mouseText = (0, _helpers.translation)('13526');
	            }
	            mouseText = mouseText.replace('- ', '-\n');
	          }
	          image = this.changeIcon(image);
	          if ((!this.props.item.IsEvaluationRejected || this.props.item.IsEvaluationRejected && !isMainReportLoadedIcon) && !bookingStopped && !evaluationStopped) {
	            return _react2.default.createElement(
	              'span',
	              { className: 'icon' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint--top', 'aria-label': mouseText },
	                _react2.default.createElement('img', { src: '/images/svgs/taksering/' + image, className: 'hasCursor', onClick: onClickForShop })
	              )
	            );
	          }
	        }
	      } else if (this.props.item.PriceApprovalToken !== null) {
	        // Awaiting price approval?
	        // Not insurance orders
	        var _image = 'price-change-sent.svg';
	        var message = 2716;
	
	        if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	          _image = 'price-change-recieved.svg';
	          message = 2717;
	        }
	
	        if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.auth.departmentType === 1) {
	          _image = 'price-change-recieved.svg';
	          message = 2717;
	        }
	
	        _image = this.changeIcon(_image);
	        var iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	        if (iswp && this.props.auth.departmentType !== 1) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': (0, _helpers.translation)(message) },
	              _react2.default.createElement('img', { src: '/images/svgs/taksering/' + _image })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': (0, _helpers.translation)(message) },
	              _react2.default.createElement('img', { src: '/images/svgs/taksering/' + _image, className: 'hasCursor', name: 'PriceChange.Extent', onClick: clickPriceApproval.bind(this) })
	            )
	          );
	        }
	      } else if (this.props.item.PriceApprovalTokenAddon !== null) {
	        // Awaiting addon price approval
	        // Set image and text as viewed by shop
	        var _image2 = 'price-change-sent.svg';
	        var _message = 2716;
	
	        if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	          // Set image and text as viewed by customer
	          _image2 = 'price-change-recieved.svg';
	          _message = 2717;
	        }
	
	        var _iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	        if (_iswp && this.props.auth.departmentType !== 1) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': (0, _helpers.translation)(_message) },
	              _react2.default.createElement('img', { src: '/images/svgs/taksering/' + _image2 })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': (0, _helpers.translation)(_message) },
	              _react2.default.createElement('img', { src: '/images/svgs/taksering/' + _image2, className: 'hasCursor', name: 'PriceChange.Addon', onClick: clickPriceApproval.bind(this) })
	            )
	          );
	        }
	      } else if (this.props.item.LatestPriceApprovalState !== 0) {
	        var _image3 = '';
	        var _message2 = '';
	        if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.item.LatestPriceApprovalState === 3) {
	          _message2 = 2718;
	        } else if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.item.LatestPriceApprovalState === 4) {
	          _message2 = 2719;
	        } else if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.item.LatestPriceApprovalState === 3 && this.props.auth.departmentType === 1) {
	          _message2 = 2718;
	        } else if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.item.LatestPriceApprovalState === 4 && this.props.auth.departmentType === 1) {
	          _message2 = 2719;
	        } else if (this.props.item.LatestPriceApprovalState === 3) {
	          _message2 = 2714;
	        } else {
	          _message2 = 2715;
	        }
	
	        switch (this.props.item.LatestPriceApprovalState) {
	          case (0, _auth.hasAccess)([4], this.props.auth.user.UserType):
	          case 3:
	            // approved
	            _image3 = 'price-change-approved.svg';
	            break;
	          case 4:
	            // rejected
	            _image3 = 'price-change-rejected.svg';
	            break;
	        }
	
	        _image3 = this.changeIcon(_image3);
	        return _react2.default.createElement(
	          'span',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--left', 'aria-label': (0, _helpers.translation)(_message2) },
	            _react2.default.createElement('img', { src: '/images/svgs/taksering/' + _image3 })
	          )
	        );
	      }
	
	      // Evaluation
	      if (((0, _auth.hasSubscriptionPermission)(this.props.auth, 30) || (0, _auth.hasSubscriptionPermission)(this.props.auth, 0) && (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30)) && (this.props.item.IsEvaluation || bookingStopped || evaluationStopped)) {
	        var _image4 = void 0;
	        var text = void 0;
	        var classes = '';
	        var renderNewEvaluation = function renderNewEvaluation() {
	          if (typeof _this2.props.onPopupOpen === 'function') _this2.props.onPopupOpen();
	          _this2.props.triggerPopup(true);
	          _this2.setState({
	            estimation: {
	              open: true
	            }
	          });
	        };
	        var closeEstimation = function closeEstimation() {
	          _this2.setState({
	            estimation: {
	              open: false
	            }
	          });
	          _this2.props.triggerPopup(false);
	          // this.props.updateOrder(this.props.item)
	        };
	        // console.log('item', this.props.item)
	        if (this.props.item.IsEvaluationRejected || bookingStopped || evaluationStopped) {
	          text = (0, _helpers.translation)('13715');
	          // console.log('[Taksering] item', this.props.item)
	          var imagePath = '/images/svgs/taksering/damage-assessment.svg';
	          if ((0, _auth.hasAccess)([3, 4, 5, 7], this.props.auth.user.UserType)) {
	            imagePath = '/images/svgs/taksering/additional-support-added.svg';
	          }
	          if (this.props.auth.departmentType === 1) {
	            imagePath = '/images/svgs/taksering/additional-support-added.svg';
	          }
	          if (bookingStopped || evaluationStopped) {
	            text = (0, _helpers.translation)('15177');
	          }
	          _image4 = this.changeIcon(imagePath);
	          return _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': text },
	              _react2.default.createElement('img', { src: _image4, className: 'hasCursor', onClick: renderNewEvaluation.bind(this) }),
	              this.state.estimation.open && _react2.default.createElement(_CreateEstimationModal2.default, { router: this.props.router,
	                show: this.state.estimation.open,
	                id: this.props.item.Id,
	                orderId: this.props.item.Id,
	                onClose: closeEstimation.bind(this),
	                onSave: this.props.updateOrder })
	            )
	          );
	        }
	
	        var _onClickForShop = function _onClickForShop() {
	          if (typeof _this2.props.onPopupOpen === 'function') _this2.props.onPopupOpen();
	          if (!(0, _auth.hasAccess)([4], _this2.props.auth.user.UserType)) {
	            if (_this2.props.item.CurrentShopOrWpCanAnswer === true && _this2.props.auth.departmentType !== 1) {
	              _this2.props.router.push('/pricecalculation/' + _this2.props.item.Id + '/3');
	            } else if (!_this2.props.item.IsEvaluated && _this2.props.auth.departmentType !== 1) {
	              if (typeof _this2.props.onPopupOpen === 'function') _this2.props.onPopupOpen();
	              _this2.setState({
	                showInfoPopup: true
	              });
	            }
	          } else {
	            _this2.props.router.push('/orders/' + _this2.props.item.Id + '?page=2');
	          }
	        };
	
	        var onInfoClick = function onInfoClick() {
	          if (typeof _this2.props.onPopupOpen === 'function') _this2.props.onPopupOpen();
	          _this2.setState({
	            showInfoPopup: false
	          });
	        };
	
	        if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.auth.departmentType !== 1) {
	          // Shop
	          if (this.props.item.IsEvaluated) {
	            if (!this.props.item.CustomerWPEvaluationRequired && this.props.item.IsEvaluation && !this.props.item.CurrentShopOrWpCanAnswer && !(0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	              _image4 = this.changeIcon('/images/svgs/taksering/additional-support-added.svg');
	            } else {
	              _image4 = this.changeIcon('/images/svgs/taksering/damage-assessment.svg');
	            }
	            text = (0, _helpers.translation)('13400');
	
	            if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.props.item.IsEvaluatedDate !== null) {
	              text += ' ' + (0, _time.renderFullDate)(this.props.item.IsEvaluatedDate);
	              text += ' - ' + this.props.item.IsEvaluatedBy;
	            }
	          } else {
	            // console.log('[Taksering] item', this.props.item)
	            if (!this.props.item.CustomerWPEvaluationRequired && this.props.item.IsEvaluation && !this.props.item.CurrentShopOrWpCanAnswer && !(0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	              _image4 = this.changeIcon('/images/svgs/taksering/damage-assessment.svg');
	            } else {
	              _image4 = this.changeIcon('/images/svgs/taksering/additional-support-added.svg');
	            }
	            text = (0, _helpers.translation)('13399');
	          }
	          allowClick = true;
	          classes = 'hasCursor';
	        } else {
	          // Customer
	          if (this.props.item.IsEvaluated) {
	            _image4 = this.changeIcon('/images/svgs/taksering/additional-support-added.svg');
	            text = (0, _helpers.translation)('2700');
	          } else {
	            _image4 = this.changeIcon('/images/svgs/taksering/damage-assessment.svg');
	            text = (0, _helpers.translation)('13399');
	          }
	        }
	        var returns = function returns() {
	          return;
	        };
	        return _react2.default.createElement(
	          'span',
	          { className: 'icon ' + classes },
	          _react2.default.createElement(
	            'div',
	            { className: this.props.type === 'workscreen' ? 'hint--top' : 'hint--left', 'aria-label': text },
	            _react2.default.createElement('img', { src: _image4, onClick: _onClickForShop, className: 'hasCursor' })
	          ),
	          this.state.showInfoPopup && _react2.default.createElement(
	            _Portal2.default,
	            { className: 'confirm_popup', onPortalClose: returns },
	            _react2.default.createElement(_InfoPopup2.default, { t: _helpers.translation, Hedder: 534, Text: (0, _helpers.translation)(14715).replace('[wp]', this.props.item.WorkProviderName), click: onInfoClick })
	          )
	        );
	      }
	      return _react2.default.createElement('div', { className: 'icon' });
	    }
	  }]);
	
	  return Taksering;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  triggerPopupActionBG: _backdrop.triggerPopupActionBG
	})(Taksering);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	__webpack_require__(255);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var RadioList = function (_PureComponent) {
	  _inherits(RadioList, _PureComponent);
	
	  function RadioList(props) {
	    _classCallCheck(this, RadioList);
	
	    var _this = _possibleConstructorReturn(this, (RadioList.__proto__ || Object.getPrototypeOf(RadioList)).call(this, props));
	
	    _this.state = {};
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.translate = _this.translate.bind(_this);
	    _this.mapItems = _this.mapItems.bind(_this);
	    return _this;
	  }
	
	  _createClass(RadioList, [{
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.props.onChange(e);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'translate',
	    value: function translate(text) {
	      if (!this.props.translate || isNaN(Number(text))) return text;
	      return (0, _helpers.translation)(text);
	    }
	  }, {
	    key: 'mapItems',
	    value: function mapItems(val, index) {
	      var id = val[this.props.listItemValName[0]];
	      var name = this.props.name;
	      var idName = name + '_' + id + '_input';
	
	      var label = void 0;
	      if (typeof this.props.formatter !== 'undefined') {
	        label = this.props.formatter(val, this.props.listItemValName);
	      } else {
	        label = this.translate(val[this.props.listItemValName[1]]);
	      }
	
	      if (name === 'BodyShopTransport') {
	        return _react2.default.createElement(_check2.default, {
	          id: idName,
	          name: idName,
	          value: id,
	          onChange: this.onInputChange,
	          checked: this.props.value === id.toString() ? 'checked' : false,
	          disabled: this.props.disabled,
	          labelText: label,
	          key: index
	        });
	      } else {
	        return _react2.default.createElement(_radio2.default, {
	          id: idName,
	          name: name,
	          value: id,
	          onChange: this.onInputChange,
	          checked: this.props.value === id.toString() ? 'checked' : false,
	          disabled: this.props.disabled,
	          labelText: label,
	          key: index
	        });
	      }
	
	      // return (
	      //   <div className={className} key={index}>
	      //     <input type={inputType} id={idName} name={name !== 'BodyShopTransport' ? name : idName} value={id} onChange={this.onInputChange} checked={this.props.value === id.toString() ? 'checked' : false} disabled={this.props.disabled} />
	      //     <label htmlFor={idName}>
	      //       {typeof this.props.formatter === 'undefined' && this.translate(val[this.props.listItemValName[1]])}
	      //       {typeof this.props.formatter !== 'undefined' && this.props.formatter(val, this.props.listItemValName)}
	      //     </label>
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: this.props.showTitle && this.translate(this.props.title) },
	        this.props.listItems.map(this.mapItems)
	      );
	      // return (
	      //   <div className='radio__custom__outer inputcomponents__inner'>
	      //     {this.props.showTitle && <label>{this.translate(this.props.title)}</label>}
	      //     <div className='radio__custom__wrapper'>
	      //       {this.props.listItems.map(this.mapItems)}
	      //     </div>
	      //   </div>
	      // )
	    }
	  }]);
	
	  return RadioList;
	}(_react.PureComponent);
	
	RadioList.defaultProps = {
	  disabled: false,
	  onChange: function onChange(e) {
	    console.log('todo');
	  },
	  name: 'None',
	  value: '',
	  title: '*title*',
	  listItems: [],
	  showTitle: true,
	  listItemValName: ['', ''],
	  translate: false
	};
	
	RadioList.propTypes = {
	  formatter: _propTypes2.default.func,
	  mapItems: _propTypes2.default.func,
	  translate: _propTypes2.default.bool,
	  showTitle: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func.isRequired,
	  value: _propTypes2.default.string.isRequired,
	  listItems: _propTypes2.default.array.isRequired,
	  auth: _propTypes2.default.object.isRequired
	};
	
	RadioList.contextTypes = {
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(RadioList);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _RPReportFiles = __webpack_require__(199);
	
	var _RPReportFiles2 = _interopRequireDefault(_RPReportFiles);
	
	var _PremiumList = __webpack_require__(422);
	
	var _PremiumList2 = _interopRequireDefault(_PremiumList);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Utils
	
	
	// Elements
	
	// import LabelWrapper from '../../../../../../shared/elements/labelWrapper'
	
	
	var SparePartList = function (_Component) {
	  _inherits(SparePartList, _Component);
	
	  function SparePartList(props) {
	    _classCallCheck(this, SparePartList);
	
	    var _this = _possibleConstructorReturn(this, (SparePartList.__proto__ || Object.getPrototypeOf(SparePartList)).call(this, props));
	
	    _this.state = {};
	
	    _this.renderPart = _this.renderPart.bind(_this);
	    _this.renderPartNew = _this.renderPartNew.bind(_this);
	    _this.renderTypeOfPart = _this.renderTypeOfPart.bind(_this);
	    _this.getSortedPartsNew = _this.getSortedPartsNew.bind(_this);
	    _this.renderRPReportFiles = _this.renderRPReportFiles.bind(_this);
	    _this.getLowestValuedStatusSortOrder = _this.getLowestValuedStatusSortOrder.bind(_this);
	    return _this;
	  }
	
	  _createClass(SparePartList, [{
	    key: 'renderTypeOfPart',
	    value: function renderTypeOfPart(type) {
	      var parttype = '';
	      if (type === 1) parttype = '(' + (0, _helpers.translation)('1443') + ')';
	      if (type === 2) parttype = '(L)';
	      if (type === 3) parttype = '(M)';
	      if (type === 4) parttype = '(KG)';
	      return parttype;
	    }
	  }, {
	    key: 'renderPart',
	    value: function renderPart(part, key) {
	      var num = part.PartNumber;
	      var text = part.Name;
	      var count = part.Count || part.Qty;
	      var type = part.CountType || part.Unit;
	
	      if (key === 0) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            'div',
	            { className: 'sparePartItem' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sparePartName sparepartTitle' },
	              (0, _helpers.translation)('14819')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sparePartAmount sparepartTitle' },
	              (0, _helpers.translation)('385')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sparePartItem sparePartView' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sparePartName' },
	              _react2.default.createElement(
	                'div',
	                null,
	                num,
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                text,
	                ' ',
	                _react2.default.createElement(
	                  'font',
	                  { className: 'sparepartTitle' },
	                  this.renderTypeOfPart(type)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sparePartAmount' },
	              count
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { key: key, className: 'sparePartItem sparePartView' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sparePartName' },
	            _react2.default.createElement(
	              'div',
	              null,
	              num,
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              text,
	              ' ',
	              _react2.default.createElement(
	                'font',
	                { className: 'sparepartTitle' },
	                this.renderTypeOfPart(type)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sparePartAmount' },
	            count
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getSortedPartsNew',
	    value: function getSortedPartsNew(parts) {
	      var _this2 = this;
	
	      return parts.sort(function (partA, partB) {
	        var a = _this2.getLowestValuedStatusSortOrder(partA.Status);
	        var b = _this2.getLowestValuedStatusSortOrder(partB.Status);
	
	        return a - b;
	      });
	    }
	  }, {
	    key: 'getLowestValuedStatusSortOrder',
	    value: function getLowestValuedStatusSortOrder(status) {
	      if ((status & 1) === 1) {
	        return 100; // sort order
	      } else if ((status & 8) === 8) {
	        return 200;
	      } else if ((status & 64) === 64) {
	        return 300;
	      } else if ((status & 32) === 32) {
	        return 400;
	      } else if ((status & 4) === 4) {
	        return 500;
	      } else if ((status & 16) === 16) {
	        return 600;
	      } else if ((status & 2) === 2) {
	        return 700;
	      }
	    }
	  }, {
	    key: 'renderPartNew',
	    value: function renderPartNew(item, key) {
	      // const icon = ((item.Status & (4 | 16)) !== 0) ? SparePartModuleIcons.OK : SparePartModuleIcons.Warning
	      var icon = _icons.SparePartModuleIcons.Warning;
	      // 127 - ((2 + 4 + 16) === NotInUse | InStock | Received)
	      if ((item.Status & 105) === 0) {
	        icon = _icons.SparePartModuleIcons.OK;
	      }
	
	      var statusText = '';
	      var sortOrderValue = this.getLowestValuedStatusSortOrder(item.Status);
	      switch (sortOrderValue) {
	        case 100:
	          statusText = '14796'; // Not ordered
	          break;
	        case 200:
	          statusText = '16535'; // Not received
	          icon = _icons.SparePartModuleIcons.Attention;
	          break;
	        case 300:
	          statusText = '16454'; // Incorrect
	          break;
	        case 400:
	          statusText = '16453'; // Defective
	          break;
	        case 500:
	          statusText = '14799'; // In stock
	          break;
	        case 600:
	          statusText = '16452'; // Received
	          break;
	        case 700:
	          statusText = '16449'; // Not in use
	          break;
	      }
	      statusText = '(' + (0, _helpers.translation)(statusText) + ')';
	
	      return _react2.default.createElement(
	        _grid2.default,
	        { cols: '24px auto max-content', spacing: 1, key: key },
	        _react2.default.createElement(_icon2.default, { icon: icon }),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: 'auto', nogap: true },
	          _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0 },
	            _react2.default.createElement(
	              'span',
	              null,
	              item.SparePartNumberAlias || item.OriginalSparePartNumber,
	              ' ',
	              statusText
	            ),
	            item.UrgentDelivery && _react2.default.createElement(_icon2.default, { icon: _icons.SparePartModuleIcons.Urgent, ariaText: (0, _helpers.translation)('16578'), ariaPos: 'top', injectSvg: true })
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            item.Description,
	            '\xA0'
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          item.Count
	        )
	      );
	    }
	  }, {
	    key: 'renderRPReportFiles',
	    value: function renderRPReportFiles() {
	      return _react2.default.createElement(_RPReportFiles2.default, {
	        order: this.props.order,
	        renderSparePart: true,
	        showDates: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var hasProPremium = (0, _auth.hasSubscriptionPermission)(this.props.auth, 30);
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var spareParts = this.props.order.SparePartItems;
	      var rpReport = this.props.order.RpReport;
	      var newSpareParts = this.props.order.NewSparePartItems;
	
	      if (newSpareParts.length > 0 && hasProPremium && !isCustomer) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_divider2.default, { size: 2 }),
	          _react2.default.createElement(_PremiumList2.default, { orderId: this.props.order.Id })
	        );
	      } else if (spareParts.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.props.auth.user.UserType !== 4 && _react2.default.createElement(_divider2.default, { size: 2 }),
	          this.props.order.SparePartItems.map(this.renderPart)
	        );
	      } else if (rpReport && rpReport.SparePartLines.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.props.auth.user.UserType !== 4 && _react2.default.createElement(_divider2.default, { size: 2 }),
	          this.renderRPReportFiles(),
	          this.props.order.RpReport && this.props.order.RpReport.SparePartLines.map(this.renderPart)
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SparePartList;
	}(_react.Component);
	
	SparePartList.propTypes = {
	  order: _propTypes2.default.object.isRequired,
	  auth: _propTypes2.default.object.isRequired,
	  showRpFiles: _propTypes2.default.bool.isRequired
	};
	
	SparePartList.defaultProps = {
	  showRpFiles: false
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(SparePartList);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UpdateSparePartPremiumList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _spareparts = __webpack_require__(108);
	
	var _auth = __webpack_require__(8);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _expand = __webpack_require__(175);
	
	var _expand2 = _interopRequireDefault(_expand);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * When called, the component will refetch the spareparts.
	 * If @param orderId is null, all instances will update.
	 * If @param orderId is a number, only the instances with a matchg orderId will update.
	 */
	var UpdateSparePartPremiumList = exports.UpdateSparePartPremiumList = function UpdateSparePartPremiumList() {
	  var orderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	  var event = new CustomEvent('Update-SparePartPremiumList', { detail: { orderId: orderId } });
	  document.dispatchEvent(event);
	};
	
	var SparePartPremiumList = function (_Component) {
	  _inherits(SparePartPremiumList, _Component);
	
	  function SparePartPremiumList(props) {
	    _classCallCheck(this, SparePartPremiumList);
	
	    var _this = _possibleConstructorReturn(this, (SparePartPremiumList.__proto__ || Object.getPrototypeOf(SparePartPremiumList)).call(this, props));
	
	    _this.state = {
	      OrderStep: 0,
	      NotOrdered: [],
	      NotUsedInStep: {
	        Other: [],
	        Ordered: [],
	        Received: [],
	        NotInUse: [],
	        InStock: []
	      },
	      RemovedFromReport: {
	        Other: [],
	        Ordered: [],
	        Received: [],
	        NotInUse: [],
	        InStock: []
	      },
	      Repair: {
	        Other: [],
	        Ordered: [],
	        Received: [],
	        NotInUse: [],
	        InStock: []
	      },
	      Paint: {
	        Other: [],
	        Ordered: [],
	        Received: [],
	        NotInUse: [],
	        InStock: []
	      },
	      Assembly: {
	        Other: [],
	        Ordered: [],
	        Received: [],
	        NotInUse: [],
	        InStock: []
	      }
	    };
	
	    _this.getSparepartList = _this.getSparepartList.bind(_this);
	    _this.eventHandler = _this.eventHandler.bind(_this);
	    return _this;
	  }
	
	  _createClass(SparePartPremiumList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSparepartList(this.props.orderId);
	      document.addEventListener('Update-SparePartPremiumList', this.eventHandler);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('Update-SparePartPremiumList', this.eventHandler);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.orderId !== this.props.orderId) this.getSparepartList(this.props.orderId);
	    }
	  }, {
	    key: 'eventHandler',
	    value: function eventHandler(_ref) {
	      var detail = _ref.detail;
	
	      var orderId = this.props.orderId;
	      if (detail.orderId === null || detail.orderId === orderId) this.getSparepartList(orderId);
	    }
	  }, {
	    key: 'getSparepartList',
	    value: function getSparepartList(orderId) {
	      var _this2 = this;
	
	      this.props.getSparepartList(orderId).then(function (res) {
	        return _this2.setState(res.data);
	      });
	    }
	  }, {
	    key: 'renderPart',
	    value: function renderPart(part, key) {
	      var sku = part.SparePartNumberAlias || part.OriginalSparePartNumber;
	      var description = part.Description;
	      var count = part.Count;
	
	      var warnings = [];
	
	      var icon = _icons.SparePartModuleIcons.OK;
	      var deliveryDateDiff = 0;
	
	      // Because supplier is an array. More dates are possible for a single sparepart item?
	      var deliveryDates = [];
	      part.Suppliers.map(function (supplier) {
	        var deliveryDate = (0, _time.renderShortDate)(supplier.DeliveryDate, true, true);
	        deliveryDate ? deliveryDates.push(deliveryDate.toLowerCase()) : '';
	        deliveryDateDiff = (0, _time.renderDateDiff)(supplier.DeliveryDate, supplier.OldDeliveryDate);
	      });
	
	      // Get status and relevant info for given status
	      switch (part.Status) {
	        case _constants.SparepartStatus.NOTINUSE:
	        case _constants.SparepartStatus.RECEIVED:
	        case _constants.SparepartStatus.INSTOCK:
	          icon = _icons.SparePartModuleIcons.OK;
	          break;
	        case _constants.SparepartStatus.ORDERED:
	          if (deliveryDateDiff > 0) {
	            icon = _icons.TimeLineIcons.Exclamation_Red;
	            var _warningText = (0, _helpers.translation)('18124'); // Delayed
	            _warningText += ' ' + deliveryDates.toString();
	            warnings.push(_warningText);
	          } else {
	            icon = _icons.SparePartModuleIcons.Attention;
	          }
	          break;
	        case _constants.SparepartStatus.UNKNOWN:
	          icon = _icons.SparePartModuleIcons.Warning;
	          break;
	        case _constants.SparepartStatus.DEFECTIVE:
	          warnings.push((0, _helpers.translation)('16453')); // Defective
	          icon = _icons.TimeLineIcons.Exclamation_Red;
	          break;
	        case _constants.SparepartStatus.INCORRECT:
	          warnings.push((0, _helpers.translation)('16454')); // Incorrect
	          icon = _icons.TimeLineIcons.Exclamation_Red;
	          break;
	        case _constants.SparepartStatus.BACKORDER:
	          icon = _icons.TimeLineIcons.Exclamation_Red;
	          var warningText = (0, _helpers.translation)('18108'); // Backorder
	
	          if (deliveryDates.length > 0) {
	            warningText += ' ' + deliveryDates.toString();
	          } else {
	            warningText += ' (' + (0, _helpers.translation)('15392').toLowerCase() + ')';
	          }
	
	          warnings.push(warningText);
	          break;
	      }
	
	      // Unclear when to use Handled and what to use it for
	      /* if (part.Handled === 0) {
	        warnings.length = 0
	        icon = SparePartModuleIcons.Warning
	      } */
	
	      // Show expected delivery date if the state and available information makes sence.
	      var hiddenDateStates = [_constants.SparepartStatus.NOTINUSE, _constants.SparepartStatus.RECEIVED, _constants.SparepartStatus.INSTOCK];
	      var sparepartDate = !hiddenDateStates.includes(part.Status) && deliveryDates.length > 0 ? deliveryDates[0] : '';
	
	      // Render header for first item in list
	      var sparepartHeader = key !== 0 ? '' : _react2.default.createElement(
	        'div',
	        { className: 'sparepartTitle' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sparePartName sparepartSubTitle' },
	          (0, _helpers.translation)('14817')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sparePartAmount sparepartSubTitle' },
	          (0, _helpers.translation)('16441')
	        )
	      );
	
	      // Render the list
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        sparepartHeader,
	        _react2.default.createElement(
	          'div',
	          { className: 'sparePartView sparePartItem' },
	          _react2.default.createElement(_icon2.default, { size: 's', icon: icon }),
	          _react2.default.createElement(
	            'div',
	            { className: 'sparePartName' },
	            _react2.default.createElement(
	              'div',
	              null,
	              sku,
	              ' ',
	              sparepartDate
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              description
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sparePartItemAmount' },
	            count
	          )
	        ),
	        warnings.map(function (warning) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'sparePartWarning' },
	            _react2.default.createElement(_icon2.default, { size: 't', icon: _icons.ElementIcons.Indent, injectSvg: true }),
	            _react2.default.createElement(
	              'div',
	              { className: '' },
	              warning
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Only render for ProPremium
	      var hasProPremium = (0, _auth.hasSubscriptionPermission)(this.props.auth, 30);
	      if (!hasProPremium) {
	        return null;
	      }
	
	      var _state = this.state,
	          OrderStep = _state.OrderStep,
	          RemovedFromReport = _state.RemovedFromReport,
	          NotOrdered = _state.NotOrdered,
	          Repair = _state.Repair,
	          Paint = _state.Paint,
	          Assembly = _state.Assembly,
	          NotUsedInStep = _state.NotUsedInStep;
	
	
	      var showRemovedFromReport = Object.keys(RemovedFromReport.InStock).length > 0 || Object.keys(RemovedFromReport.NotInUse).length > 0 || Object.keys(RemovedFromReport.Ordered).length > 0 || Object.keys(RemovedFromReport.Other).length > 0 || Object.keys(RemovedFromReport.Received).length > 0;
	
	      var showNotOrdered = Object.keys(NotOrdered).length > 0;
	
	      var showRepair = Object.keys(Repair.InStock).length > 0 || Object.keys(Repair.NotInUse).length > 0 || Object.keys(Repair.Ordered).length > 0 || Object.keys(Repair.Other).length > 0 || Object.keys(Repair.Received).length > 0;
	
	      var showPaint = Object.keys(Paint.InStock).length > 0 || Object.keys(Paint.NotInUse).length > 0 || Object.keys(Paint.Ordered).length > 0 || Object.keys(Paint.Other).length > 0 || Object.keys(Paint.Received).length > 0;
	
	      var showAssembly = Object.keys(Assembly.InStock).length > 0 || Object.keys(Assembly.NotInUse).length > 0 || Object.keys(Assembly.Ordered).length > 0 || Object.keys(Assembly.Other).length > 0 || Object.keys(Assembly.Received).length > 0;
	
	      var showNotUsedInStep = Object.keys(NotUsedInStep.InStock).length > 0 || Object.keys(NotUsedInStep.NotInUse).length > 0 || Object.keys(NotUsedInStep.Ordered).length > 0 || Object.keys(NotUsedInStep.Other).length > 0 || Object.keys(NotUsedInStep.Received).length > 0;
	
	      var isAfterRepair = ![0, 1, 101, 102].includes(OrderStep);
	      var isAfterPaint = [103, 104, 7, 8].includes(OrderStep);
	      var isAfterAssembly = [104, 7, 8].includes(OrderStep);
	
	      var repairOpen = !(Object.keys(Repair.Other).length === 0 && Object.keys(Repair.Ordered).length === 0 && isAfterRepair);
	      var paintOpen = !(Object.keys(Paint.Other).length === 0 && Object.keys(Paint.Ordered).length === 0 && isAfterPaint);
	      var assemblyOpen = !(Object.keys(Assembly.Other).length === 0 && Object.keys(Assembly.Ordered).length === 0 && isAfterAssembly);
	      var notUsedInStepOpen = Object.keys(NotUsedInStep.Other).length > 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'premiumList' },
	        showRemovedFromReport && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('16499'), defaultOpen: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'nested' },
	              Object.keys(RemovedFromReport.Other).length > 0 && _react2.default.createElement(
	                'div',
	                null,
	                RemovedFromReport.Other.map(this.renderPart)
	              ),
	              Object.keys(RemovedFromReport.NotInUse).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16449') },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  RemovedFromReport.NotInUse.map(this.renderPart)
	                )
	              ),
	              Object.keys(RemovedFromReport.Ordered).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14797') },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  RemovedFromReport.Ordered.map(this.renderPart)
	                )
	              ),
	              Object.keys(RemovedFromReport.Received).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16452') },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  RemovedFromReport.Received.map(this.renderPart)
	                )
	              ),
	              Object.keys(RemovedFromReport.InStock).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14799') },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  RemovedFromReport.InStock.map(this.renderPart)
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        ),
	        showNotOrdered && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('14796'), defaultOpen: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              NotOrdered.map(this.renderPart)
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        ),
	        showRepair && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('18122') /* Spare parts for repair */, defaultOpen: repairOpen },
	            _react2.default.createElement(
	              'div',
	              { className: 'nested' },
	              Object.keys(Repair.Other).length > 0 && _react2.default.createElement(
	                'div',
	                null,
	                Repair.Other.map(this.renderPart)
	              ),
	              Object.keys(Repair.NotInUse).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16449'), defaultOpen: repairOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Repair.NotInUse.map(this.renderPart)
	                )
	              ),
	              Object.keys(Repair.Ordered).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14797'), defaultOpen: repairOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Repair.Ordered.map(this.renderPart)
	                )
	              ),
	              Object.keys(Repair.Received).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16452'), defaultOpen: repairOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Repair.Received.map(this.renderPart)
	                )
	              ),
	              Object.keys(Repair.InStock).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14799'), defaultOpen: repairOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Repair.InStock.map(this.renderPart)
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        ),
	        showPaint && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('14818'), defaultOpen: paintOpen },
	            _react2.default.createElement(
	              'div',
	              { className: 'nested' },
	              Object.keys(Paint.Other).length > 0 && _react2.default.createElement(
	                'div',
	                null,
	                Paint.Other.map(this.renderPart)
	              ),
	              Object.keys(Paint.NotInUse).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16449'), defaultOpen: paintOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Paint.NotInUse.map(this.renderPart)
	                )
	              ),
	              Object.keys(Paint.Ordered).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14797'), defaultOpen: paintOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Paint.Ordered.map(this.renderPart)
	                )
	              ),
	              Object.keys(Paint.Received).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16452'), defaultOpen: paintOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Paint.Received.map(this.renderPart)
	                )
	              ),
	              Object.keys(Paint.InStock).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14799'), defaultOpen: paintOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Paint.InStock.map(this.renderPart)
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        ),
	        showAssembly && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('14816'), defaultOpen: assemblyOpen },
	            _react2.default.createElement(
	              'div',
	              { className: 'nested' },
	              Object.keys(Assembly.Other).length > 0 && _react2.default.createElement(
	                'div',
	                null,
	                Assembly.Other.map(this.renderPart)
	              ),
	              Object.keys(Assembly.NotInUse).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16449'), defaultOpen: assemblyOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Assembly.NotInUse.map(this.renderPart)
	                )
	              ),
	              Object.keys(Assembly.Ordered).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14797'), defaultOpen: assemblyOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Assembly.Ordered.map(this.renderPart)
	                )
	              ),
	              Object.keys(Assembly.Received).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16452'), defaultOpen: assemblyOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Assembly.Received.map(this.renderPart)
	                )
	              ),
	              Object.keys(Assembly.InStock).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14799'), defaultOpen: assemblyOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Assembly.InStock.map(this.renderPart)
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        ),
	        showNotUsedInStep && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('18123'), defaultOpen: notUsedInStepOpen },
	            _react2.default.createElement(
	              'div',
	              { className: 'nested' },
	              Object.keys(NotUsedInStep.Other).length > 0 && _react2.default.createElement(
	                'div',
	                null,
	                NotUsedInStep.Other.map(this.renderPart)
	              ),
	              Object.keys(NotUsedInStep.NotInUse).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16449'), defaultOpen: notUsedInStepOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  NotUsedInStep.NotInUse.map(this.renderPart)
	                )
	              ),
	              Object.keys(NotUsedInStep.Ordered).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14797'), defaultOpen: notUsedInStepOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  NotUsedInStep.Ordered.map(this.renderPart)
	                )
	              ),
	              Object.keys(NotUsedInStep.Received).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('16452'), defaultOpen: notUsedInStepOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  NotUsedInStep.Received.map(this.renderPart)
	                )
	              ),
	              Object.keys(NotUsedInStep.InStock).length > 0 && _react2.default.createElement(
	                _expand2.default,
	                { title: (0, _helpers.translation)('14799'), defaultOpen: notUsedInStepOpen },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  NotUsedInStep.InStock.map(this.renderPart)
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return SparePartPremiumList;
	}(_react.Component);
	
	SparePartPremiumList.propTypes = {
	  orderId: _propTypes2.default.number.isRequired,
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getSparepartList: _spareparts.getSparepartList
	})(SparePartPremiumList);

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Above1400 = exports.Between1055And1400 = exports.Above1055 = exports.Between650And1401 = exports.Above650 = exports.Below1055 = exports.Below650 = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _backdrop = __webpack_require__(29);
	
	var _notes = __webpack_require__(114);
	
	var _orders = __webpack_require__(21);
	
	var _insurancecompanies = __webpack_require__(172);
	
	var _customers = __webpack_require__(74);
	
	var _orderPrice = __webpack_require__(193);
	
	var _priceModel = __webpack_require__(75);
	
	var _common = __webpack_require__(25);
	
	var _shops = __webpack_require__(79);
	
	var _dracar = __webpack_require__(224);
	
	var _carrental = __webpack_require__(223);
	
	__webpack_require__(1431);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _HelpText = __webpack_require__(130);
	
	var _HelpText2 = _interopRequireDefault(_HelpText);
	
	var _Invoice = __webpack_require__(294);
	
	var _Invoice2 = _interopRequireDefault(_Invoice);
	
	var _NotesModal = __webpack_require__(203);
	
	var _NotesModal2 = _interopRequireDefault(_NotesModal);
	
	var _CreateEstimationModal = __webpack_require__(237);
	
	var _CreateEstimationModal2 = _interopRequireDefault(_CreateEstimationModal);
	
	var _SetCustomer = __webpack_require__(418);
	
	var _SetCustomer2 = _interopRequireDefault(_SetCustomer);
	
	var _PriceApprovalModal = __webpack_require__(304);
	
	var _PriceApprovalModal2 = _interopRequireDefault(_PriceApprovalModal);
	
	var _HandleCarRentalModal = __webpack_require__(1088);
	
	var _HandleCarRentalModal2 = _interopRequireDefault(_HandleCarRentalModal);
	
	var _OkModal = __webpack_require__(1102);
	
	var _OkModal2 = _interopRequireDefault(_OkModal);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _order = __webpack_require__(92);
	
	var _constants = __webpack_require__(5);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _WhiteBox = __webpack_require__(921);
	
	var _WhiteBox2 = _interopRequireDefault(_WhiteBox);
	
	var _OrderExtent = __webpack_require__(919);
	
	var _OrderExtent2 = _interopRequireDefault(_OrderExtent);
	
	var _SpareParts = __webpack_require__(920);
	
	var _SpareParts2 = _interopRequireDefault(_SpareParts);
	
	var _Files = __webpack_require__(914);
	
	var _Files2 = _interopRequireDefault(_Files);
	
	var _InputRender = __webpack_require__(918);
	
	var _InputRender2 = _interopRequireDefault(_InputRender);
	
	var _RadioList = __webpack_require__(420);
	
	var _RadioList2 = _interopRequireDefault(_RadioList);
	
	var _CarRentalContract = __webpack_require__(913);
	
	var _CarRentalContract2 = _interopRequireDefault(_CarRentalContract);
	
	var _OrderBookingButton = __webpack_require__(417);
	
	var _OrderBookingButton2 = _interopRequireDefault(_OrderBookingButton);
	
	var _ConfirmOk = __webpack_require__(429);
	
	var _ConfirmOk2 = _interopRequireDefault(_ConfirmOk);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _ForsiCreateReport = __webpack_require__(440);
	
	var _ForsiCreateReport2 = _interopRequireDefault(_ForsiCreateReport);
	
	var _Dracar = __webpack_require__(1025);
	
	var _Dracar2 = _interopRequireDefault(_Dracar);
	
	var _CarRentalAssignmentList = __webpack_require__(1014);
	
	var _CarRentalAssignmentList2 = _interopRequireDefault(_CarRentalAssignmentList);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _timeSpan = __webpack_require__(456);
	
	var _timeSpan2 = _interopRequireDefault(_timeSpan);
	
	var _language = __webpack_require__(139);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _BookingTimes = __webpack_require__(289);
	
	var _BookingTimes2 = _interopRequireDefault(_BookingTimes);
	
	var _CarOwnerPortalInviteStatus = __webpack_require__(1013);
	
	var _CarOwnerPortalInviteStatus2 = _interopRequireDefault(_CarOwnerPortalInviteStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	
	// Actions
	
	
	// Styles
	
	// Components
	
	
	// import modals
	
	
	// Utils
	
	
	// Constants
	
	// import OrderDate from './OrderDate'
	
	
	// Elements
	
	
	// Language
	
	
	// Redux
	
	
	var Below650 = exports.Below650 = [0, 650];
	var Below1055 = exports.Below1055 = [0, 1055];
	var Above650 = exports.Above650 = [650, 10000];
	var Between650And1401 = exports.Between650And1401 = [650, 1401];
	var Above1055 = exports.Above1055 = [1055, 10000];
	var Between1055And1400 = exports.Between1055And1400 = [1055, 1400];
	var Above1400 = exports.Above1400 = [1400, 10000];
	
	var WorkCard = function (_Component) {
	  _inherits(WorkCard, _Component);
	
	  function WorkCard(props) {
	    _classCallCheck(this, WorkCard);
	
	    var _this = _possibleConstructorReturn(this, (WorkCard.__proto__ || Object.getPrototypeOf(WorkCard)).call(this, props));
	
	    _this.checkOrderTimeoutId = 0;
	    _this.state = {
	      carOwnerPhoneCount: 1,
	      handleCarRentalPopup: {
	        show: false
	      },
	      notePopup: {
	        showNotePopup: false,
	        note: {}
	      },
	      createEstimationPopup: {
	        show: false
	      },
	      showSetCustomerPopup: {
	        show: false
	      },
	      dracarInfoPopup: {
	        show: false
	      },
	      upload: {
	        loading: false,
	        errors: []
	      },
	      altAddress: {
	        delivery: false,
	        pickup: false,
	        BodyShopDelivery: false,
	        BodyShopPickup: false
	      },
	      order: undefined,
	      previousOrder: null,
	      contacts: [],
	      createdNew: false,
	      saved: false,
	      errors: false,
	      success: false,
	      dimensions: {
	        width: 0,
	        height: 0
	      },
	      refreshPrices: false,
	      confirm: {
	        open: false,
	        type: 0
	      },
	      confirmDelete: {
	        open: false,
	        NoteID: 0
	      },
	      confirmPaintNotBooked: {
	        open: false
	      },
	      confirmMissingBodywork: {
	        show: false
	      },
	      priceInformation: null,
	      loosepartChangeConfirmDialogOpen: false,
	      updating: false,
	      InsuranceCompanies: [],
	      canWPEdit: false,
	      invoice: {}
	    };
	    _this.saveWorkcard = _this.saveWorkcard.bind(_this);
	    _this.updateWorkcard = _this.updateWorkcard.bind(_this);
	    _this.bookOrder = _this.bookOrder.bind(_this);
	    _this.onInputChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onCarOwnerBlur = _this.onCarOwnerBlur.bind(_this);
	    _this.onRegBlur = _this.onRegBlur.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.renderCreateEstimationPopup = _this.renderCreateEstimationPopup.bind(_this);
	    _this.onCreateEstimationSave = _this.onCreateEstimationSave.bind(_this);
	    _this.getContacts = _this.getContacts.bind(_this);
	    _this.setupPrint = _this.setupPrint.bind(_this);
	    _this.clearPrint = _this.clearPrint.bind(_this);
	    _this.updateFromOrderSocket = _this.updateFromOrderSocket.bind(_this);
	    _this.renderSetCustomerPopup = _this.renderSetCustomerPopup.bind(_this);
	    _this.renderInsuranceDisplay = _this.renderInsuranceDisplay.bind(_this);
	    _this.saveSingleValue = _this.saveSingleValue.bind(_this);
	    _this.togglePopup = _this.togglePopup.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.getChildContext = _this.getChildContext.bind(_this);
	    _this.getInputRender = _this.getInputRender.bind(_this);
	    _this.renderInvoice = _this.renderInvoice.bind(_this);
	    _this.getPriceInformations = _this.getPriceInformations.bind(_this);
	    _this.renderLoosepartPriceChangePopup = _this.renderLoosepartPriceChangePopup.bind(_this);
	    _this.renderConfirmPaintNotBooked = _this.renderConfirmPaintNotBooked.bind(_this);
	    _this.renderCarRentalList = _this.renderCarRentalList.bind(_this);
	    _this.renderHandleCarRentalPopup = _this.renderHandleCarRentalPopup.bind(_this);
	    _this.renderDracarInfoPopup = _this.renderDracarInfoPopup.bind(_this);
	    _this.onNewOrderCreated = _this.onNewOrderCreated.bind(_this);
	    _this.renderReferred = _this.renderReferred.bind(_this);
	    _this.renderCarOwnerPortal = _this.renderCarOwnerPortal.bind(_this);
	    _this.onTimeSpanBlur = _this.onTimeSpanBlur.bind(_this);
	    _this.onBookingTimesUpdated = _this.onBookingTimesUpdated.bind(_this);
	    // this.showNotePopup = this.showNotePopup.bind(this)
	    console.log('Workcard ctor');
	    return _this;
	  }
	
	  _createClass(WorkCard, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        dimensions: this.state.dimensions,
	        onBlur: this.onBlur,
	        onChange: this.onChange,
	        onUpdateOrder: this.props.onUpdateOrder,
	        saveWorkcard: this.saveWorkcard,
	        disabledForWP: (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && !this.state.canWPEdit
	      };
	    }
	  }, {
	    key: 'getInputRender',
	    value: function getInputRender(translateName, propName, formatter, type, listItems, listItemValName, translate) {
	      var onBlur = void 0; // is undefined on purpose! InputRender will use onBlur from context as long as it is undefined from props
	      if (['RegNumber', 'ChassisNumber'].includes(propName)) onBlur = this.onRegBlur;
	      if (['CarOwnerMail'].includes(propName)) onBlur = this.onCarOwnerBlur;
	      if (propName === 'BodyShopTransport' || propName === 'Transport') {
	        var transformedList = this.removeLoosePart(propName, listItems);
	        if (transformedList !== undefined) {
	          return _react2.default.createElement(_InputRender2.default, { translateName: translateName, formatter: formatter, propName: propName, type: type, listItems: transformedList, listItemValName: listItemValName, onBlur: onBlur, order: this.state.order, translate: translate });
	        }
	      }
	
	      return _react2.default.createElement(_InputRender2.default, { translateName: translateName, formatter: formatter, propName: propName, type: type, listItems: listItems, listItemValName: listItemValName, onBlur: onBlur, order: this.state.order, translate: translate });
	    }
	  }, {
	    key: 'removeLoosePart',
	    value: function removeLoosePart(propName, listItems) {
	      if ((!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && propName === 'BodyShopTransport' || !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10) && propName === 'Transport') && listItems.length > 0) {
	        var list = listItems.slice(0);
	        for (var i = 0; i < listItems.length; i++) {
	          if (listItems[i].Id === 2) {
	            list.splice(i, 1);
	            return list;
	          }
	        }
	        return list;
	      }
	      return listItems;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // get resources if missing
	      var common = this.props.common;
	      if (common.phonecodes.length === 0 || common.brands.length === 0 || common.countries.length === 0) {
	        (0, _language.InitLanguage)().then(function (res) {
	          // Set translations
	          _store2.default.dispatch((0, _language.setTranslations)(res.translations));
	          _store2.default.dispatch((0, _language.setLanguages)(res.langs));
	
	          // Set rest
	          _store2.default.dispatch((0, _common.setPhoneCodes)(res.data.PhoneCodes));
	          _store2.default.dispatch((0, _common.setBrands)(res.data.Brands));
	          _store2.default.dispatch((0, _common.setEnums)(res.data.Enums));
	          _store2.default.dispatch((0, _common.setCountries)(res.data.Countries));
	
	          // Set user language
	          if (typeof window.localStorage.user_language !== 'undefined') {
	            _store2.default.dispatch((0, _language.setLanguage)(window.localStorage.user_language));
	          }
	        });
	      }
	
	      this.setupPrint();
	      this.checkOrder();
	      this.setBodyClass(false);
	      window.addEventListener('resize', this.updateDimensions);
	      this.updateDimensions();
	      this.renderCarRentalList();
	      this.props.getInsuranceCompanies().then(function (res) {
	        _this2.setState({ InsuranceCompanies: res.data.Item2 });
	      });
	
	      if (this.props.router.location.query.notifyPaintNotBooked !== undefined) {
	        // console.log('Should show paint not booked dialog...')
	        this.setState({ confirmPaintNotBooked: { open: true } });
	        this.props.router.replace(this.props.router.location.pathname);
	      }
	
	      // Listen for socket
	      _events2.default.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this);
	
	      // Set order
	      this.setState({
	        order: this.props.order,
	        altAddress: {
	          delivery: this.props.order.DeliveryAltLocationId !== 0,
	          pickup: this.props.order.PickupAltLocationId !== 0,
	          BodyShopDelivery: this.props.order.BodyShopDeliveryAltLocationId !== 0,
	          BodyShopPickup: this.props.order.BodyShopPickupAltLocationId !== 0
	        },
	        contacts: []
	      }, this.getContacts);
	
	      if (this.props.order.PreviousOrder !== undefined && this.props.order.PreviousOrder !== null) {
	        this.props.getOrderClean(this.props.order.PreviousOrder).then(function (res) {
	          var hasForsiReport = res.data.Report !== null && res.data.Report.ReportType === 1;
	          // res.data.ForsiOrderExtent !== null
	          if (hasForsiReport && res.data.Report.Paint) {
	            // console.log('got order', res.data)
	            _this2.setState({ previousOrder: res.data });
	          }
	        });
	      }
	      if (this.props.createdNew === true) {
	        this.setState({ createdNew: true }, this.onNewOrderCreated);
	      }
	      this.app = _reactDom2.default.findDOMNode(document.getElementsByClassName('workcard__screen')[0]);
	      this.app.addEventListener('DOMSubtreeModified', this.checkForPopups);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // If checkOrder() hasn't been executed yet
	      clearTimeout(this.checkOrderTimeoutId);
	      this.setBodyClass(true);
	      window.removeEventListener('resize', this.updateDimensions);
	      _events2.default.removeListener('ORDER_SOCKET', this.updateFromOrderSocket);
	      this.clearPrint();
	    }
	  }, {
	    key: 'updateFromOrderSocket',
	    value: function updateFromOrderSocket(json) {
	      if (!this.props.auth.user.DeviceToken) return;
	      if (json.Data === undefined || json.Data === null || json.Data.Id !== this.props.order.Id) return;
	      if (json.DeviceToken === this.props.auth.user.DeviceToken) return; // Don't update if socket message was initiated by current device.
	
	      if (json.Type === 'ORDER_UPDATE') {
	        setTimeout(this.props.onUpdateOrder(), 500);
	      }
	    }
	  }, {
	    key: 'onBookingTimesUpdated',
	    value: function onBookingTimesUpdated() {
	      var _this3 = this;
	
	      if (this.props.order && Array.isArray(this.props.order.CarRentalAssignments) && this.props.order.CarRentalAssignments.length > 0) {
	        this.props.GetAssignments(this.props.order.Id, false, false).then(function (res) {
	          console.log('onBookingTimesUpdated');
	          _this3.props.onUpdateOrder(_extends({}, _this3.props.order, { CarRentalAssignments: res.data.Assignments }));
	        });
	      }
	    }
	  }, {
	    key: 'setupPrint',
	    value: function setupPrint() {
	      var _this4 = this;
	
	      var beforePrint = function beforePrint() {
	        // Rearrange boxes
	        var row = document.getElementsByClassName('row clearfix');
	        if (row.length !== 0) {
	          var dataCols;
	          var oldInputs;
	          var newInputs;
	          var updatedSelects;
	          var oldSelects;
	          var newSelects;
	
	          (function () {
	            row[0].style.display = 'none';
	            // Make boxes HTML
	            var tempDomCols = ['<div class="col">', '<div class="col">'];
	            var columns = [[], []];
	            var dataColElements = document.querySelectorAll('[data-col]');
	            for (var i = 0; i < dataColElements.length; i++) {
	              console.log('Box[' + i + ']', dataColElements[i]);
	            }
	            var orderDepartment = _this4.state.order.OrderDepartment;
	            dataCols = [];
	
	            for (var _i = 0; _i < dataColElements.length; _i++) {
	              var colAttr = dataColElements[_i].getAttribute('data-col');
	              if (colAttr !== null && colAttr !== '') dataCols.push(colAttr);
	            }
	
	            var _loop = function _loop(_i2) {
	              var col = dataColElements[_i2].getAttribute('data-col');
	              if (col === null) return 'continue';
	              var outerHTML = dataColElements[_i2].outerHTML;
	
	              // Paint
	              var colConfigs = [// [col1], [col2]
	              ['order', 'customer'], ['notes', 'color'], ['files', 'transport'], [null, 'vehicle']];
	
	              // Body
	              if (orderDepartment !== 0) {
	                colConfigs = [['bodyshoporder2', null], ['bodyshoporder', 'order'], ['bodyshoptransport', 'transport'], ['vehicle', 'spareparts'], ['carownercustomer', 'color'], ['notes', 'customer'], [null, 'files']];
	              }
	              colConfigs.map(function (config, index) {
	                config.map(function (val, colIndex) {
	                  if (val && val === col) {
	                    columns[colIndex][index] = outerHTML;
	                  }
	                });
	              });
	            };
	
	            for (var _i2 = 0; _i2 < dataColElements.length; _i2++) {
	              var _ret2 = _loop(_i2);
	
	              if (_ret2 === 'continue') continue;
	            }
	            tempDomCols.map(function (value, i) {
	              columns[i].map(function (val) {
	                tempDomCols[i] += val;
	              });
	              tempDomCols[i] += '</div>';
	            });
	
	            // Combine all
	            var joined = tempDomCols[0] + tempDomCols[1]; // + '<div class="col"></div>'
	
	            var rowPrintElements = document.getElementsByClassName('rowPrint');
	            if (rowPrintElements !== null && rowPrintElements.length > 0) {
	              rowPrintElements[0].innerHTML = joined;
	            }
	
	            // Handle browsers with identity crisis:
	            var isIExplorer = navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1;
	            var isEdge = navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('Edge') !== -1;
	
	            oldInputs = row[0].getElementsByTagName('input');
	
	            if (rowPrintElements !== null && rowPrintElements.length > 0) {
	              newInputs = rowPrintElements[0].getElementsByTagName('input');
	
	              for (var _i3 = 0; _i3 < oldInputs.length; _i3++) {
	                if (oldInputs[_i3].type === 'checkbox' || oldInputs[_i3].type === 'radio') {
	                  for (var x = 0; x < newInputs.length; x++) {
	                    // Handle checkboxes
	                    if (newInputs[x].type === 'checkbox') {
	                      if (newInputs[x].name === oldInputs[_i3].name) {
	                        if (oldInputs[_i3].checked) {
	                          newInputs[x].checked = oldInputs[_i3].checked;
	                          if (newInputs[x].name.startsWith('BodyShopTransport')) {
	                            newInputs[x].parentNode.removeChild(newInputs[x]);
	                          }
	                        } else {
	                          if (newInputs[x].name.startsWith('BodyShopTransport')) {
	                            newInputs[x].parentElement.parentElement.parentElement.remove(); // Fails in IE (no longer supported)
	                          }
	                        }
	                      }
	
	                      // Handle radiobuttons
	                    } else if (newInputs[x].type === 'radio') {
	                      if (oldInputs[_i3].id === newInputs[x].id) {
	                        if (oldInputs[_i3].checked) {
	                          newInputs[x].checked = oldInputs[_i3].checked;
	                          newInputs[x].parentNode.removeChild(newInputs[x]);
	                        } else {
	                          newInputs[x].parentElement.parentElement.parentElement.remove(); // Fails in IE
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	
	            updatedSelects = [];
	            oldSelects = row[0].getElementsByTagName('select');
	
	            if (rowPrintElements !== null && rowPrintElements.length > 0) {
	              newSelects = rowPrintElements[0].getElementsByTagName('select');
	
	              for (var o = 0; o < oldSelects.length; o++) {
	                for (var n = 0; n < newSelects.length; n++) {
	                  if (newSelects[n].name === oldSelects[o].name && updatedSelects.indexOf(newSelects[n].name) === -1 && oldSelects[o].value !== '' && oldSelects[o].value !== null) {
	                    if (isIExplorer || isEdge) {
	                      setSelectIeEdge(newSelects[n], oldSelects[o].value);
	                    } else {
	                      newSelects[n].value = oldSelects[o].value;
	                    }
	                    updatedSelects.push(newSelects[n].name);
	                  }
	                }
	              }
	            }
	          })();
	        }
	      };
	
	      var setSelectIeEdge = function setSelectIeEdge(select, value) {
	        Array.prototype.forEach.call(select.children, function (option) {
	          if (option.value === value.toString()) {
	            option.selected = true;
	          }
	        });
	      };
	
	      var afterPrint = function afterPrint() {
	        // console.log('after print')
	        // return
	        // Set boxes back to normal
	        var row = document.getElementsByClassName('row clearfix');
	        if (row.length !== 0) {
	          row[0].style.display = 'block';
	          var elements = document.getElementsByClassName('rowPrint');
	          if (elements !== null && elements.length > 0) {
	            elements[0].innerHTML = '';
	          }
	        }
	      };
	
	      if (window.matchMedia) {
	        var mediaQueryList = window.matchMedia('print');
	        mediaQueryList.addListener(function (mql) {
	          if (mql.matches) {
	            beforePrint();
	          } else {
	            afterPrint();
	          }
	        });
	      }
	
	      window.onbeforeprint = beforePrint;
	      window.onafterprint = afterPrint;
	    }
	  }, {
	    key: 'clearPrint',
	    value: function clearPrint() {
	      window.onbeforeprint = undefined;
	      window.onafterprint = undefined;
	    }
	  }, {
	    key: 'setBodyClass',
	    value: function setBodyClass(out) {
	      setTimeout(function () {
	        if (out) {
	          document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('order__body', '');
	        } else {
	          document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className + ' order__body';
	        }
	      }, 0);
	    }
	  }, {
	    key: 'checkForPopups',
	    value: function checkForPopups() {
	      var item = document.getElementsByClassName('helperTextModal')[0];
	      if (item !== undefined) {
	        var bounding = item.getBoundingClientRect();
	        var windowWith = window.innerWidth;
	        if (bounding.left < 0) {
	          if (windowWith > bounding.width * 2 + bounding.left) {
	            item.style.cssText = 'right:' + bounding.left + 'px' + ' !important';
	            // item.style.right = bounding.left
	          } else {
	            var margin = (windowWith - bounding.width) / 2;
	            item.style.cssText = 'right:' + (bounding.left - margin) + 'px' + ' !important';
	            // item.style.right = bounding.left - margin
	          }
	        }
	
	        if (bounding.right < 0) {
	          if (windowWith > bounding.width * 2 + bounding.right) {
	            item.style.cssText = 'left:' + bounding.right + 'px' + ' !important';
	            // item.style.right = 0
	          } else {
	            var _margin = (windowWith - bounding.width) / 2;
	            item.style.cssText = 'left:' + (bounding.right - _margin) + 'px' + ' !important';
	            // item.style.left = bounding.right - margin
	          }
	        }
	      }
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this5 = this;
	
	      var contacts = [];
	      if (this.state.order && this.state.order.CustomerId && nextProps.order.CustomerId === this.state.order.CustomerId) {
	        contacts = this.state.contacts;
	      }
	
	      var order = nextProps.order;
	      if (order.carOwnerPhoneCount) {
	        var phoneCount = order.CarOwnerPhones.length;
	        if (phoneCount > this.state.carOwnerPhoneCount) this.state.carOwnerPhoneCount = phoneCount;
	        for (var i = phoneCount; i < this.state.carOwnerPhoneCount; i++) {
	          order.CarOwnerPhones.push('');
	        }
	      }
	
	      this.setState({
	        order: order,
	        altAddress: {
	          delivery: order.DeliveryAltLocationId !== 0,
	          pickup: order.PickupAltLocationId !== 0
	        },
	        contacts: contacts
	      }, function () {
	        if (order.CustomerId !== _this5.state.order.CustomerId) _this5.getContacts();
	        if (!_this5.state.priceInformation) _this5.getPriceInformations();
	      });
	
	      // }
	      //   }, this.getContacts) // merge made a mess
	    }
	  }, {
	    key: 'onNewOrderCreated',
	    value: function onNewOrderCreated() {
	      var _this6 = this;
	
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) return;
	      var DracarUsable = this.props.auth.permissions.DracarUsable;
	
	      if (!DracarUsable) return;
	
	      var data = {
	        OrderId: this.context.router.params.orderID
	      };
	      this.props.checkVehicleForCustomers(data).then(function (res) {
	        var dracarVehicleData = {
	          foundVehicle: res.data.VehicleFound,
	          customers: res.data.Customers
	        };
	        _this6.setState({
	          createdNew: false,
	          dracarVehicleCheck: dracarVehicleData
	        }, function () {
	          _this6.togglePopup('dracarInfoPopup', true);
	        });
	      });
	    }
	  }, {
	    key: 'checkOrder',
	    value: function checkOrder() {
	      var _this7 = this;
	
	      if (false) return; // Disable reloading attempts for DEV, for easier debugging
	      this.checkOrderTimeoutId = setTimeout(function () {
	        if (typeof _this7.props.order.Id === 'undefined' || typeof _this7.state.order === 'undefined') {
	          window.location.reload();
	        }
	      }, 10000);
	    }
	  }, {
	    key: 'onCreateEstimationSave',
	    value: function onCreateEstimationSave(order) {
	      var _this8 = this;
	
	      if (typeof order !== 'undefined') {
	        this.togglePopup('createEstimationPopup', false);
	        this.props.onUpdateOrder(order);
	      } else {
	        this.saveSingleValue('IsEvaluation', true, function () {
	          _this8.togglePopup('createEstimationPopup', false);
	          _this8.props.onUpdateOrder(_this8.state.order);
	        });
	      }
	    }
	  }, {
	    key: 'saveWorkcard',
	    value: function saveWorkcard(e, propName, skipCheck, order) {
	      var _this9 = this;
	
	      if (this.props.order && this.props.order[propName] !== undefined && this.state.order && this.state.order[propName] !== undefined) {
	        if (this.props.order[propName] === this.state.order[propName]) return Promise.resolve(); // No need to post if unchanged.
	      }
	
	      if (!order) return this.updateWorkcard(e, propName, skipCheck);
	      this.setState({
	        order: order
	      }, function () {
	        return _this9.updateWorkcard(e, propName, skipCheck);
	      });
	    }
	  }, {
	    key: 'updateWorkcard',
	    value: function updateWorkcard(e, propName, skipCheck) {
	      var _this10 = this;
	
	      if (typeof e !== 'undefined') e.preventDefault();
	      var order = this.state.order;
	      // Her overføre vi BodyShop RekvNumber til lakerings RekvNumber, hvis det er tomt.
	
	      var LakRekvNumber = order.RekvNumber;
	      if (order.BodyShopRekvNumber !== '' && propName === 'BodyShopRekvNumber' && (order.RekvNumber === '' || order.RekvNumber === null)) {
	        LakRekvNumber = order.BodyShopRekvNumber;
	      }
	      if (['LoosePartsType', 'BodyShopLoosePartsType'].includes(propName) && order.OrderDepartment === 2) {
	        if (propName === 'LoosePartsType') {
	          // Set the same loose part type on both
	          order.BodyShopLoosePartsType = order.LoosePartsType;
	        } else {
	          order.LoosePartsType = order.BodyShopLoosePartsType;
	        }
	      }
	      // BrandName
	      var BrandName = order.BrandName;
	      if (typeof BrandName === 'string' || typeof BrandName === 'number') {
	        BrandName = { Id: parseInt(BrandName) };
	      }
	      // BodyShopTransport
	      var BodyShopTransport = order.BodyShopTransport;
	
	      if ([order.BodyShopTransport_1_input, order.BodyShopTransport_2_input, order.BodyShopTransport_3_input].includes(false)) {
	        BodyShopTransport = 0;
	      }
	      if (order.BodyShopTransport_1_input === true) {
	        BodyShopTransport = 1;
	      } else if (order.BodyShopTransport_2_input === true) {
	        BodyShopTransport = 2;
	      } else if (order.BodyShopTransport_3_input === true) {
	        BodyShopTransport = 3;
	      }
	      // Her overføre vi BodyShop Transport over til Lakering i tilfælde af vi er integrationsværksted
	      var lakTransport = order.Transport;
	      // if (this.props.auth.departmentType === 2) {
	      if (order.OrderDepartment === 2) {
	        lakTransport = BodyShopTransport;
	      }
	
	      /**
	       * If current prop it returns the new value, else null
	       * @param {String} prop Actual prop
	       * @param {Any} value New value of prop
	       */
	      var valueOrNull = function valueOrNull(prop, value) {
	        if (typeof propName === 'string') {
	          return propName === prop ? value : null;
	        }
	        return value;
	      };
	
	      /**
	       * If dependent props has propName it returns the new value, else null
	       * @param {Array<String>} props Dependent props
	       * @param {Any} value New value of prop
	       */
	      var dependentValueOrNull = function dependentValueOrNull(props, value) {
	        if (typeof propName === 'string') {
	          return props.includes(propName) ? value : null;
	        }
	        return value;
	      };
	
	      var DELIVERY_PROPS = ['PickupTimes', 'ProductionTimes', 'DeliveryTimes', 'BodyShopPickupTime', 'BodyShopProductionTime', 'BodyShopDeliveryTime', 'updateDelivery', 'CommentShowToCustomer', 'CommentApplyToInvoice'];
	      var TRANSPORT_PROPS = ['Transport', 'BodyShopTransport_1_input', 'BodyShopTransport_2_input', 'BodyShopTransport_3_input', 'LoosePartsType', 'BodyShopLoosePartsType'];
	
	      var data = {
	        OrderID: order.Id,
	        Identification: {
	          IsDirty: false,
	          OrderType: valueOrNull('OrderType', order.OrderType),
	          RekvNumber: dependentValueOrNull(['RekvNumber', 'BodyShopRekvNumber'], LakRekvNumber),
	          BodyShopRekvNumber: valueOrNull('BodyShopRekvNumber', order.BodyShopRekvNumber),
	          IsBodyShopOrder: dependentValueOrNull(['IsBodyShopOrder', 'IsPaintOrder'], order.IsBodyShopOrder),
	          IsPaintOrder: dependentValueOrNull(['IsBodyShopOrder', 'IsPaintOrder'], order.IsPaintOrder),
	          Extent: valueOrNull('Extent', null),
	          BodyShopSelectedStatus: valueOrNull('BodyShopSelectedStatus', Number('' + order.BodyShopSelectedStatus))
	        },
	        Notes: {
	          IsDirty: false,
	          Notes: order.Notes
	        },
	        BodyShopDelivery: {
	          IsDirty: false,
	          Pickup: dependentValueOrNull(DELIVERY_PROPS, order.BodyShopPickupTime),
	          ProductionDate: dependentValueOrNull(DELIVERY_PROPS, order.BodyShopProductionTime),
	          Delivery: dependentValueOrNull(DELIVERY_PROPS, order.BodyShopDeliveryTime),
	          Transport: dependentValueOrNull(TRANSPORT_PROPS, BodyShopTransport),
	          LoosePartsType: dependentValueOrNull(TRANSPORT_PROPS, '' + order.BodyShopLoosePartsType === 'true'),
	          HasPickupAltLocation: dependentValueOrNull(['HasBodyShopPickupAltLocation', 'BodyShopPickupAltLocationId', 'BodyShopPickupAltLocationComment'], order.HasBodyShopPickupAltLocation),
	          PickupAltLocationId: dependentValueOrNull(['HasBodyShopPickupAltLocation', 'BodyShopPickupAltLocationId'], Number('' + order.BodyShopPickupAltLocationId)),
	          PickupAltLocationComment: valueOrNull('BodyShopPickupAltLocationComment', order.BodyShopPickupAltLocationComment),
	          HasDeliveryAltLocation: dependentValueOrNull(['HasBodyShopDeliveryAltLocation', 'BodyShopDeliveryAltLocationId', 'BodyShopDeliveryAltLocationComment'], order.HasBodyShopDeliveryAltLocation),
	          DeliveryAltLocationId: dependentValueOrNull(['HasBodyShopDeliveryAltLocation', 'BodyShopDeliveryAltLocationId'], Number('' + order.BodyShopDeliveryAltLocationId)),
	          DeliveryAltLocationComment: valueOrNull('BodyShopDeliveryAltLocationComment', order.BodyShopDeliveryAltLocationComment),
	          EstimatedProcessTimeInMin: valueOrNull('EstimatedProcessTimeShown', order.EstimatedProcessTime)
	        },
	        Delivery: {
	          IsDirty: false,
	          Delivery: dependentValueOrNull(DELIVERY_PROPS, order.Delivery),
	          ProductionDate: dependentValueOrNull(DELIVERY_PROPS, order.ProductionDate),
	          Pickup: dependentValueOrNull(DELIVERY_PROPS, order.Pickup),
	          Transport: dependentValueOrNull(TRANSPORT_PROPS, lakTransport),
	          LoosePartsType: dependentValueOrNull(TRANSPORT_PROPS, '' + order.LoosePartsType === 'true'),
	          DeliveryAltLocationId: dependentValueOrNull(['HasDeliveryAltLocation', 'DeliveryAltLocationId'], Number('' + order.DeliveryAltLocationId)),
	          PickupAltLocationId: dependentValueOrNull(['HasPickupAltLocation', 'PickupAltLocationId'], Number('' + order.PickupAltLocationId)),
	          SuppressSMS: valueOrNull('SuppressSMS', order.SuppressSMS),
	          LTW: valueOrNull('LTW', order.LTW),
	          LTWIdCode: dependentValueOrNull(['LTW', 'LTWIdCode'], order.LTWIdCode),
	          DeliveryChangeReason: dependentValueOrNull(DELIVERY_PROPS, order.DeliveryChangeReason),
	          DeliveryChangeComment: dependentValueOrNull(DELIVERY_PROPS, order.DeliveryChangeComment),
	          DateChangeReason: dependentValueOrNull(DELIVERY_PROPS, order.DateChangeReason),
	          HasPickupAltLocation: dependentValueOrNull(['HasPickupAltLocation', 'PickupAltLocationId', 'PickupAltLocationComment'], order.HasPickupAltLocation),
	          HasDeliveryAltLocation: dependentValueOrNull(['HasDeliveryAltLocation', 'DeliveryAltLocationId', 'DeliveryAltLocationComment'], order.HasDeliveryAltLocation),
	          PickupAltLocationComment: valueOrNull('PickupAltLocationComment', order.PickupAltLocationComment),
	          DeliveryAltLocationComment: valueOrNull('DeliveryAltLocationComment', order.DeliveryAltLocationComment),
	          DeliveryDatesHasValue: dependentValueOrNull(DELIVERY_PROPS, true),
	          CommentShowToCustomer: dependentValueOrNull(DELIVERY_PROPS, order.CommentShowToCustomer),
	          CommentApplyToInvoice: dependentValueOrNull(DELIVERY_PROPS, order.CommentApplyToInvoice)
	        },
	        Color: {
	          IsDirty: false,
	          ColorControlIncluded: valueOrNull('ColorControlIncluded', order.ColorControlIncluded),
	          Color: valueOrNull('Color', order.Color),
	          ColorCode: valueOrNull('ColorCode', order.ColorCode),
	          ColorVariant: valueOrNull('ColorVariant', order.ColorVariant),
	          ColorIsReady: valueOrNull('ColorIsReady', order.ColorIsReady),
	          ColorAmount: valueOrNull('ColorAmount', order.ColorAmount)
	        },
	        Vehicle: {
	          IsDirty: false,
	          RegNumber: dependentValueOrNull(['updateVehicle', 'RegNumber'], order.RegNumber),
	          BrandNameHasValue: dependentValueOrNull(['updateVehicle', 'BrandName'], true),
	          BrandName: dependentValueOrNull(['updateVehicle', 'BrandName'], BrandName),
	          Model: dependentValueOrNull(['updateVehicle', 'Model'], order.Model),
	          Doors: dependentValueOrNull(['updateVehicle', 'Doors'], order.Doors),
	          RegistrationDate: dependentValueOrNull(['updateVehicle', 'RegistrationDate'], order.RegistrationDate),
	          ChassisNumber: dependentValueOrNull(['updateVehicle', 'ChassisNumber'], order.ChassisNumber),
	          DistanceDriven: valueOrNull('DistanceDriven', order.DistanceDriven)
	        },
	        Customer: {
	          IsDirty: false,
	          CustomerName: valueOrNull('CustomerName', order.CustomerName),
	          Contact: valueOrNull('Contact', order.Contact),
	          ContactPhone: valueOrNull('ContactPhone', order.ContactPhone),
	          IsReferredIn: valueOrNull('IsReferredIn', order.IsReferredIn),
	          IsReferredOut: valueOrNull('IsReferredOut', order.IsReferredOut),
	          CreatedBy: valueOrNull('CreatedBy', order.CreatedBy),
	          CreationDate: valueOrNull('CreationDate', order.CreationDate),
	          HasRequestedCarRental: valueOrNull('HasRequestedCarRental', order.HasRequestedCarRental),
	          CarRentalId: dependentValueOrNull(['CarRentalId', 'HasCarRental'], order.CarRentalId),
	          CarOwnerName: valueOrNull('CarOwnerName', order.CarOwnerName),
	          CarOwnerLastName: valueOrNull('CarOwnerLastName', order.CarOwnerLastName),
	          CarOwnerAddress: valueOrNull('CarOwnerAddress', order.CarOwnerAddress),
	          CarOwnerZipCode: valueOrNull('CarOwnerZipCode', order.CarOwnerZipCode),
	          CarOwnerCity: valueOrNull('CarOwnerCity', order.CarOwnerCity),
	          CarOwnerPhones: valueOrNull('CarOwnerPhones', order.CarOwnerPhones),
	          CarOwnerMail: valueOrNull('CarOwnerMail', order.CarOwnerMail),
	          InsuranceCompanyId: valueOrNull('InsuranceCompanyId', order.InsuranceCompanyId),
	          InsuranceDamageNr: valueOrNull('InsuranceDamageNr', order.InsuranceDamageNr)
	        },
	        SpareParts: {
	          IsDirty: false,
	          HasSpareParts: valueOrNull('HasSpareParts', order.HasSpareParts)
	        }
	      };
	      var groups = {
	        Identification: ['BodyShopRekvNumber', 'OrderType', 'IsBodyShopOrder', 'IsPaintOrder', 'RekvNumber', 'BodyShopSelectedStatus'],
	        BodyShopDelivery: ['BodyShopTransport_1_input', 'BodyShopTransport_2_input', 'BodyShopTransport_3_input', 'Transport', 'HasBodyShopPickupAltLocation', 'BodyShopPickupAltLocationId', 'BodyShopPickupAltLocationComment', 'HasBodyShopDeliveryAltLocation', 'BodyShopDeliveryAltLocationId', 'BodyShopDeliveryAltLocationComment', 'BodyShopPickupTime', 'BodyShopProductionTime', 'BodyShopDeliveryTime', 'LoosePartsType', 'BodyShopLoosePartsType', 'EstimatedProcessTimeShown'],
	        Delivery: ['LTW', 'LTWIdCode', 'Transport', 'BodyShopTransport_1_input', 'BodyShopTransport_2_input', 'BodyShopTransport_3_input', 'HasPickupAltLocation', 'PickupAltLocationId', 'PickupAltLocationComment', 'HasDeliveryAltLocation', 'DeliveryAltLocationId', 'DeliveryAltLocationComment', 'PickupTimes', 'ProductionTimes', 'DeliveryTimes', 'LoosePartsType', 'BodyShopLoosePartsType', 'updateDelivery', 'SuppressSMS'],
	        Color: ['ColorControlIncluded', 'Color', 'ColorCode', 'ColorVariant', 'ColorIsReady', 'ColorAmount'],
	        Vehicle: ['RegNumber', 'BrandName', 'Model', 'Doors', 'RegistrationDate', 'ChassisNumber', 'updateVehicle', 'DistanceDriven'],
	        Customer: ['InsuranceCompanyId', 'Contact', 'ContactPhone', 'CarOwnerName', 'CarOwnerLastName', 'CarOwnerAddress', 'CarOwnerZipCode', 'CarOwnerCity', 'CarOwnerPhones', 'CarOwnerMail', 'HasRequestedCarRental', 'HasCarRental', 'CarRentalId', 'InsuranceDamageNr'],
	        SpareParts: ['HasSpareParts']
	      };
	      var foundDirty = false;
	      Object.keys(groups).map(function (key) {
	        // same key for groups and data makes this a short one
	        if (groups[key].includes(propName)) foundDirty = data[key].IsDirty = true;
	      });
	      // I tilfælde af vi ikke kan finde det korrekte segment at gemme, så gemmer vi det hele som før.
	      if (!foundDirty) Object.keys(groups).map(function (key) {
	        data[key].IsDirty = true;
	      });
	
	      // Set loading spinner
	      // this.props.triggerPopupActionBG(true)
	      // Save workcard order
	      return this.props.saveOrder(data).then(function (res) {
	        if (/\/orders\/\d{6,}/.test(_this10.props.router.location.pathname)) {
	          // Only change if still on workcard
	          _this10.props.setPageTitle((0, _order.makeOrderPageTitleObject)(res.data));
	        }
	
	        _this10.props.onUpdateOrder(res.data);
	        var priceChanged = res.data.PriceWasChanged;
	        // Remove spinner
	        if (!_this10.state.createEstimationPopup.show) _this10.props.triggerPopupActionBG(false);
	        // Toastr
	        // let message = translation('13403')
	        // if (res.data.IsDraft) message = translation('2261')
	        // window.toastr.success(message, translation('13424'))
	        if (priceChanged) {
	          window.toastr.info((0, _helpers.translation)('2244'));
	          _this10.setState({
	            loosepartChangeConfirmDialogOpen: true
	          }, function () {
	            // console.log('PriceChange', this.props)
	            if (!_this10.state.priceInformation) {
	              _this10.getPriceInformations();
	            }
	          });
	        }
	        if (data.BodyShopDelivery.IsDirty) _this10.renderCarRentalList();
	        return res;
	      }, function (err) {
	        // Remove spinner
	        // this.props.triggerPopupActionBG(false)
	
	        // console.log('err', err.response.data)
	        var data = err.response.data;
	        if (data.Errors !== undefined && data.Errors !== null && data.Errors.length > 0) {
	          for (var i = 0; i < data.Errors.length; i++) {
	            window.toastr.error((0, _helpers.translation)(data.Errors[i].DictionaryKey), (0, _helpers.translation)('216'));
	            _this10.props.onUpdateOrder(data);
	          }
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13404'), (0, _helpers.translation)('216'));
	          return null;
	        }
	      });
	    }
	  }, {
	    key: 'bookOrder',
	    value: function bookOrder(e) {
	      var BodyShop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var _this11 = this;
	
	      var BookAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var DoNotRoute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      var wait = function wait(until, doAfter) {
	        if (until() === true) return doAfter();
	        setTimeout(function () {
	          wait(until, doAfter);
	        }, 100);
	      };
	      wait(function () {
	        return _this11.state.isSaving === false || _this11.state.isSaving === undefined;
	      }, function () {
	        // Set loading spinner
	        _this11.props.triggerPopupActionBG(true);
	        var order = _this11.state.order;
	
	        var routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders', '/CarRentals/Overview']);
	
	        _this11.setState({ updating: true }, function () {
	          _this11.saveWorkcard(e).then(function (res) {
	            var bookingOptions = { bookingDestination: _this11.props.bookingDestination, assignments: _this11.props.assignments
	              // console.log('Book order -> booking options: ', bookingOptions)
	            };var data = {
	              OrderId: order.Id,
	              Transport: parseInt(order.Transport),
	              BrandName: order.BrandName,
	              Model: order.Model,
	              BookOnlyBodyShopOrder: BodyShop === true,
	              Assignments: bookingOptions.assignments
	            };
	            _this11.props.triggerPopupActionBG(true);
	            _this11.props.bookOrder(data).then(function (res) {
	              // Update order
	              // Toastr
	              // window.toastr.success(translation('13416'), translation('13424'))
	              // Remove spinner
	              _this11.props.triggerPopupActionBG(false);
	              _this11.setState({ updating: false });
	              // Go back
	              if (_this11.props.auth.departmentType !== 1 || !DoNotRoute) {
	                var routeParams = '?orderid=' + order.Id;
	                if (bookingOptions.bookingDestination) {
	                  routeParams += '&destination=' + bookingOptions.bookingDestination;
	                }
	                if (routeItem === null) {
	                  _this11.props.router.replace('/orders' + routeParams);
	                } else {
	                  _this11.props.router.replace(routeItem.pathname + routeParams);
	                }
	              }
	              _this11.props.onUpdateOrder(res.data.Order);
	            }, function (err) {
	              _this11.setState({ updating: false });
	              if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	                var errors = err.response.data.Errors;
	                var errorText = '';
	                errors.map(function (item) {
	                  if (item.DictionaryKey !== 0) errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey) + '<br />';
	                });
	                // Toastr
	                window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	              } else {
	                // Toastr
	                window.toastr.error((0, _helpers.translation)(13417), (0, _helpers.translation)('216'));
	              }
	              _this11.props.triggerPopupActionBG(false);
	            });
	          });
	        });
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this12 = this;
	
	      e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') value = e.target.checked;
	      // console.log('onCHange wokacrsd', { e, value })
	      this.saveSingleValue(e.target.name, value, function () {
	        // console.log(e.target.name, value, typeof value, e.target.type)
	        if (['checkbox', 'select-one', 'radio'].includes(e.target.type)) {
	          _this12.saveWorkcard(undefined, e.target.name, undefined).then(function () {
	            if (['Transport', 'BodyShopTransport_1_input', 'BodyShopTransport_2_input', 'BodyShopTransport_3_input'].includes(e.target.name)) {
	              if (typeof _this12.refs.price1 !== 'undefined') _this12.refs.price1.getWrappedInstance().getPrices();
	              if (typeof _this12.refs.price2 !== 'undefined') _this12.refs.price2.getWrappedInstance().getPrices();
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'saveSingleValue',
	    value: function saveSingleValue(name, value, callback) {
	      this.setState({
	        order: _extends({}, this.state.order, _defineProperty({}, name, value))
	      }, function () {
	        if (callback) callback();
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this13 = this;
	
	      e.persist();
	      this.setState({ isSaving: true });
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') value = e.target.checked;
	      this.saveSingleValue(e.target.name, value, function () {
	        _this13.saveWorkcard(undefined, e.target.name, undefined).then(function () {
	          _this13.setState({ isSaving: false });
	        });
	      });
	    }
	  }, {
	    key: 'onCarOwnerBlur',
	    value: function onCarOwnerBlur(e) {
	      var _this14 = this;
	
	      e.persist();
	      this.setState({ isSaving: true });
	      var value = e.target.value;
	      this.saveSingleValue(e.target.name, value, function () {
	        _this14.saveWorkcard(undefined, e.target.name, undefined).then(function () {
	          console.log('onCarOwnerBlur', e.target.name, e.target.value);
	          _events2.default.emit('UPDATE_CAROWNER');
	          _this14.setState({ isSaving: false });
	        });
	      });
	    }
	  }, {
	    key: 'onRegBlur',
	    value: function onRegBlur(e) {
	      var _this15 = this;
	
	      e.persist();
	      var value = e.target.value;
	      var name = e.target.name;
	      if (value !== null && value.trim() !== '' && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10))) {
	        this.props.getOrderVehicleData(value, name).then(function (res) {
	          var _extends3;
	
	          _this15.setState({
	            order: _extends({}, _this15.state.order, (_extends3 = {}, _defineProperty(_extends3, e.target.name, value), _defineProperty(_extends3, 'RegNumber', res.data.RegNr), _defineProperty(_extends3, 'Model', res.data.Model || ''), _defineProperty(_extends3, 'BrandName', res.data.BrandNameId.toString() || '0'), _defineProperty(_extends3, 'ChassisNumber', res.data.ChassisNumber || ''), _defineProperty(_extends3, 'RegistrationDate', res.data.RegistrationDate || ''), _extends3))
	          }, function () {
	            _this15.saveWorkcard(undefined, 'updateVehicle', undefined);
	            if (res.data.DictionaryKey !== 0) {
	              // Toastr
	              window.toastr.info((0, _helpers.translation)(res.data.DictionaryKey));
	            }
	          });
	        }, function (err) {
	          _this15.saveSingleValue(e.target.name, value, _this15.saveWorkcard);
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	        });
	      } else {
	        this.saveSingleValue(e.target.name, value, this.saveWorkcard);
	      }
	    }
	  }, {
	    key: 'onTimeSpanBlur',
	    value: function onTimeSpanBlur(e) {
	      var _this16 = this;
	
	      var name = e.target.name;
	      var value = e.target.value;
	      if (e.target.currentFormat === -1 && this.state.order.EstimatedProcessTime) {
	        // (-1 = invalid format)
	        window.toastr.error((0, _helpers.translation)(16837), (0, _helpers.translation)('216'));
	      } else {
	        // Estimated process time.
	        var estimatedProcessTime = value === null ? null : value.decimal;
	        if (estimatedProcessTime === null || Number.isNaN(estimatedProcessTime) || estimatedProcessTime === 0) {
	          estimatedProcessTime = null;
	        } else {
	          estimatedProcessTime *= 60;
	        }
	        this.setState({
	          order: _extends({}, this.state.order, {
	            EstimatedProcessTime: estimatedProcessTime
	          }),
	          isSaving: true
	        }, function () {
	          _this16.saveWorkcard(undefined, name, undefined).then(function () {
	            _this16.setState({ isSaving: false });
	          });
	        });
	      }
	    }
	
	    // showNotePopup(item) {
	    //   console.log('here')
	    //   let note = { Note: '', NoteTypeID: 0, OrderID: this.state.order.Id, ApplyToInvoice: false }
	    //   if (typeof item !== 'undefined') {
	    //     if (typeof item.OrderID !== 'undefined') {
	    //       note = item
	    //     }
	    //   }
	    //   console.log('note ', note)
	    //   this.props.triggerPopup(!this.state.notePopup.showNotePopup)
	    //   this.setState({
	    //     notePopup: {
	    //       showNotePopup: !this.state.notePopup.showNotePopup,
	    //       note: note
	    //     }
	    //   }, () => console.log('showNote', this.state.notePopup))
	    // }
	
	  }, {
	    key: 'renderDracar',
	    value: function renderDracar() {
	      var DracarUsable = this.props.auth.permissions.DracarUsable;
	      var order = this.state.order;
	
	
	      if (!DracarUsable || !_constants.DracarAllowOrderTypes.includes(order.OrderType)) return null;
	
	      return _react2.default.createElement(_Dracar2.default, { order: this.state.order });
	    }
	  }, {
	    key: 'renderNotes',
	    value: function renderNotes() {
	      var _this17 = this;
	
	      var $type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'box';
	      var $screen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      var notes = this.state.order.Notes;
	      // Update note
	      var onUpdateNote = function onUpdateNote(data) {
	        var newData = _extends({}, _this17.state.order);
	        var index = newData.Notes.findIndex(function (note) {
	          return note.NoteID === data.NoteID;
	        });
	        if (index === -1) newData.Notes.push(data);else newData.Notes[index] = data;
	        _this17.props.onUpdateOrder(newData);
	      };
	      // Delete note
	      var deleteNote = function deleteNote(item) {
	        _this17.setState({
	          confirmDelete: {
	            open: true,
	            NoteID: item.NoteID
	          }
	        });
	      };
	      // Render each note
	      var renderNote = function renderNote(item, index) {
	        if (!item.IsMine && !(0, _auth.hasSubscriptionPermission)(_this17.props.auth, 10)) return null;
	        var editIcon = void 0,
	            customerIcon = void 0,
	            deleteIcon = void 0,
	            invoiceIcon = void 0,
	            editedText = void 0;
	
	        if (_this17.props.auth.user.CustomerId === '-1') {
	          invoiceIcon = _react2.default.createElement(
	            'div',
	            { className: 'hint--top', 'aria-label': (0, _helpers.translation)('14835') },
	            _react2.default.createElement('img', { src: '/images/svgs/invoice/Total_price.svg', className: 'renderIcons' })
	          );
	          // Customer icon
	          if (!item.CreatedByCustommer && item.ShowToCustomer) {
	            customerIcon = _react2.default.createElement(
	              'div',
	              { className: 'hint--top', 'aria-label': (0, _helpers.translation)('2157') },
	              _react2.default.createElement('img', { src: '/images/icons/Customer_16.png' })
	            );
	          }
	        }
	        // Delete icon + edit icon
	        if (item.IsMine && (_this17.props.auth.user.CustomerId === '-1' || _this17.props.order.IsDraft) && item.SourceID !== 26) {
	          editIcon = _react2.default.createElement(
	            'div',
	            { className: 'hint--top', 'aria-label': (0, _helpers.translation)('13357') },
	            _react2.default.createElement('img', { src: '/images/icons/edit_16.png', onClick: function onClick() {
	                return showNotePopup(item);
	              } })
	          );
	          if (item.SourceID !== 26 && !_this17.props.order.IsReferredIn && !_this17.props.order.IsReferredOut) {
	            // Can't delete notes if order is referred
	            deleteIcon = _react2.default.createElement(
	              'div',
	              { className: 'hint--top', 'aria-label': (0, _helpers.translation)('2156') },
	              _react2.default.createElement('img', { src: '/images/icons/Delete_16.png', onClick: function onClick() {
	                  return deleteNote(item);
	                } })
	            );
	          }
	        }
	
	        if (item.IsEdited) {
	          editedText = _react2.default.createElement(
	            _label2.default,
	            null,
	            16853
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'workcard-note' },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 'max-content'], align: 'start' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_UserInfo2.default, { user: item.UserInfo }),
	              _react2.default.createElement(
	                _inline2.default,
	                { spacing: [0] },
	                (0, _time.renderFullDate)(item.NoteDate),
	                editedText
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: [0] },
	              _this17.props.disabled !== true && editIcon,
	              customerIcon,
	              item.ApplyToInvoice === true && invoiceIcon,
	              _this17.props.disabled !== true && deleteIcon
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(item.SourceDictionaryKey),
	            ': ',
	            item.Note
	          ),
	          item.ShareType > 0 && _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('17861'),
	            (0, _helpers.getOrderNoteShareString)(item.ShareType)
	          )
	        );
	      };
	      // Show note popup
	      var showNotePopup = function showNotePopup(item) {
	        var note = { Note: '', NoteTypeID: 0, OrderID: _this17.state.order.Id, ApplyToInvoice: false };
	        if (typeof item !== 'undefined') {
	          if (typeof item.OrderID !== 'undefined') {
	            note = item;
	          }
	        }
	        _this17.props.triggerPopup(!_this17.state.notePopup.showNotePopup);
	        _this17.setState({
	          notePopup: {
	            showNotePopup: !_this17.state.notePopup.showNotePopup,
	            note: note
	          }
	        }, function () {
	          return console.log('showNote', _this17.state.notePopup);
	        });
	      };
	      // console.log('type - data ', $type)
	      // console.log('state ', this.state.notePopup.showNotePopup)
	
	      var nrOfComments = notes.length; // + dateChangeComments.length
	      if ($type === 'data') {
	        return _react2.default.createElement(
	          _panel2.default,
	          { dataCol: 'notes' },
	          _react2.default.createElement(_NotesModal2.default, {
	            show: this.state.notePopup.showNotePopup,
	            onClose: showNotePopup,
	            note: this.state.notePopup.note,
	            onSuccess: onUpdateNote.bind(this),
	            order: this.state.order }),
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            (0, _helpers.translation)('14834'),
	            ' (',
	            nrOfComments,
	            ')'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'notes_inner' },
	            notes.map(renderNote)
	          ),
	          this.props.disabled !== true && _react2.default.createElement(
	            'button',
	            { onClick: showNotePopup, className: 'button full primary' },
	            _react2.default.createElement('img', { src: '/images/icons/circle_plus22-black.png' }),
	            (0, _helpers.translation)('75')
	          )
	        );
	      } else {
	        if ($screen !== '') {
	          return _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('14834') + ' (' + nrOfComments + ')', dataCol: 'notes' },
	            _react2.default.createElement(_NotesModal2.default, {
	              show: this.state.notePopup.showNotePopup,
	              onClose: showNotePopup,
	              note: this.state.notePopup.note,
	              onSuccess: onUpdateNote.bind(this),
	              order: this.state.order
	            }),
	            notes.map(renderNote),
	            this.props.disabled !== true && _react2.default.createElement(_button2.default, { style: 'link', onClick: showNotePopup, labelText: (0, _helpers.translation)('75') })
	          );
	        } else {
	          return _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('14834') + ' (' + nrOfComments + ')', dataCol: 'notes' },
	            _react2.default.createElement(_NotesModal2.default, {
	              show: this.state.notePopup.showNotePopup,
	              onClose: showNotePopup,
	              note: this.state.notePopup.note,
	              onSuccess: onUpdateNote.bind(this),
	              order: this.state.order
	            }),
	            notes.map(renderNote),
	            this.props.disabled !== true && _react2.default.createElement(_button2.default, { style: 'link', onClick: showNotePopup, labelText: (0, _helpers.translation)('75') })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'renderCarRentalList',
	    value: function renderCarRentalList() {
	      var _this18 = this;
	
	      var orderId = this.context.router.params.orderID; // Can't get orderId from state or props...
	      this.props.GetSimpleCarRentals(0, orderId).then(function (res) {
	        var data = [{ Id: 0, Name: (0, _helpers.translation)('14790') }].concat(_toConsumableArray(res.data.filter(function (car) {
	          return car.Active;
	        })));
	        _this18.setState({ carrental: data });
	      });
	    }
	  }, {
	    key: 'renderBodyShopTransport',
	    value: function renderBodyShopTransport() {
	      var _this19 = this;
	
	      var isLoosePart = this.state.order.BodyShopTransport === 2 || this.state.order.BodyShopTransport === '2';
	      var isPickup = this.state.order.HasBodyShopPickupAltLocation === true;
	      var isDelivery = this.state.order.HasBodyShopDeliveryAltLocation === true;
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var isReferredIn = this.state.order.IsReferredIn;
	      var currentShopCanAssignRentalCar = this.state.order.CurrentShopCanAssignRentalCar;
	      // Transport formatter to add icons?
	      var transportFormatter = function transportFormatter(val, listItemValName) {
	        var name = typeof val === 'number' ? '' : val.Name;
	        if (name === '') {
	          _this19.props.transport.map(function (v, index) {
	            if (v.Id === val) {
	              name = v.Name;
	            }
	          });
	        }
	        return _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)(name)
	        );
	      };
	      var renderList = function renderList(inputName, name, value) {
	        var list = [].concat(_toConsumableArray(_this19.state.order.CustomerClients));
	        var data = [{ CustomerClientId: 0, Name: (0, _helpers.translation)('227'), Address: '', ZipCode: '', City: '', CustomerId: 0, DisplayVal: (0, _helpers.translation)('227') }];
	
	        if (isReferredIn) {
	          var customerClient = _this19.state.order[value.replace('Id', '')];
	          if (customerClient !== null) data.push(customerClient);
	        } else {
	          list.map(function (customerClient) {
	            return data.push(customerClient);
	          });
	        }
	
	        data.map(function (val, key) {
	          val.DisplayVal = val.Name;
	          if (val.Address !== '') val.DisplayVal += ', ' + val.Address;
	        });
	        return _this19.getInputRender(inputName, value, undefined, 'list', data, ['CustomerClientId', 'DisplayVal']);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-col': 'bodyshoptransport' },
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13373') }),
	        _react2.default.createElement(
	          'div',
	          { className: 'information' },
	          this.getInputRender('14830', 'IsBodyShopOrder', undefined, 'checkbox'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(_BookingTimes2.default, { OrderId: this.state.order.Id, ShowLeadTime: true, FromBody: true, onUpdated: this.onBookingTimesUpdated }),
	          _react2.default.createElement(_timeSpan2.default, { name: 'EstimatedProcessTimeShown', value: this.state.order.EstimatedProcessTimeShown || '', labelText: 16835, onBlur: this.onTimeSpanBlur, onChange: this.onChange, disabled: !this.state.order.CanEditEstimatedProcessTime }),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.getInputRender('80', 'BodyShopRekvNumber'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.getInputRender('983', 'SuppressSMS', undefined, 'checkbox'),
	          this.getInputRender('26', 'BodyShopTransport', transportFormatter, 'list', this.props.transport, ['Id', 'Name']),
	          isLoosePart && this.getInputRender('13395', 'BodyShopLoosePartsType', undefined, 'list', this.props.loosePartType, ['Id', 'Name']),
	          this.renderTransportText(),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          this.getInputRender('14859', 'HasRequestedCarRental', undefined, 'checkbox'),
	          this.state.order.CarRentalAssignmentReset && _react2.default.createElement(
	            'div',
	            { className: 'carRentalWarning' },
	            (0, _helpers.translation)(16823)
	          ),
	          this.state.order.HasCarRental && this.state.order.IsUsingAdvancedCarRental && _react2.default.createElement(_CarRentalAssignmentList2.default, { items: this.state.order.CarRentalAssignments }),
	          !isCustomer && _react2.default.createElement(_button2.default, { id: 'carRentalAdvancedBtn', noSubmit: true, style: 'secondary', labelText: (0, _helpers.translation)('16769'), onClick: this.togglePopup.bind(this, 'handleCarRentalPopup'), disabled: !currentShopCanAssignRentalCar || !this.state.order.HasRequestedCarRental }),
	          !isCustomer && this.state.order.HasCarRentalNotAlternative && this.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.NONE && currentShopCanAssignRentalCar && _react2.default.createElement(_CarRentalContract2.default, { order: this.state.order, onUpdateOrder: this.props.onUpdateOrder }),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.getInputRender('14764', 'HasBodyShopPickupAltLocation', undefined, 'checkbox'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && isPickup && renderList((0, _helpers.translation)('713'), '25', 'BodyShopPickupAltLocationId'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && isPickup && this.getInputRender('14769', 'BodyShopPickupAltLocationComment'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.getInputRender('14765', 'HasBodyShopDeliveryAltLocation', undefined, 'checkbox'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && isDelivery && renderList((0, _helpers.translation)('714'), '25', 'BodyShopDeliveryAltLocationId'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && isDelivery && this.getInputRender('14770', 'BodyShopDeliveryAltLocationComment')
	        )
	      );
	    }
	  }, {
	    key: 'renderBookExternalLak',
	    value: function renderBookExternalLak() {
	      var _this20 = this;
	
	      var order = this.props.order;
	      // console.log('render booking external lak')
	
	      var bookingStopped = order.IsAgreementForsiCreated && !order.IsEvaluation;
	      var evaluationStopped = (!order.IsEvaluation || order.IsEvaluation && !order.IsEvaluated) && order.CustomerWPEvaluationRequired && order.IsAgreementOrder;
	      var evaluationRejected = order.IsEvaluation && !order.IsEvaluated && order.IsEvaluationRejected && order.CustomerWPEvaluationRequired && order.IsAgreementOrder;
	      var bookingButtonClass = 'BookPaintBTN button primary full';
	      var bookingButtonLabel = '';
	      var bookingStoppedLabel = '';
	      var disabled = this.state.updating || order.IsReferredOut;
	
	      if (bookingStopped) {
	        bookingButtonClass += ' disabled hint--left';
	        bookingButtonLabel += ' ' + (0, _helpers.translation)('13568');
	        bookingStoppedLabel = (0, _helpers.translation)('13568');
	      } else if (evaluationStopped) {
	        var evaluationRequiredTxt = order.IsEvaluation ? (0, _helpers.translation)('13038') : (0, _helpers.translation)('15177');
	        bookingButtonClass += ' disabled hint--left BookPaintBTN--small';
	        bookingButtonLabel += ' ' + evaluationRequiredTxt;
	        bookingStoppedLabel = evaluationRequiredTxt;
	      }
	      var bookingStoppedToast = function bookingStoppedToast() {
	        window.toastr.error(order.IsEvaluation ? (0, _helpers.translation)('13038') : (0, _helpers.translation)('15177'));
	        if (!order.IsEvaluation && !order.IsEvaluated) {
	          _this20.togglePopup.bind(_this20, 'createEstimationPopup')();
	        }
	      };
	      // if (this.props.auth.departmentType === 1) {
	      if (order.OrderDepartment === 1 && order.HasAvailablePaintPartner) {
	        if (order.PaintIsDraft) {
	          if (order.NeedReferredApprove) {
	            // Order has been referred in but not yet approved. Prevent booking.
	            return _react2.default.createElement(
	              'div',
	              { className: 'alert-h4-text' },
	              (0, _helpers.translation)('18096')
	            );
	          } else {
	            return _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [1], block: true },
	              (bookingStopped || evaluationStopped) && _react2.default.createElement(
	                'div',
	                { className: 'left hint--left stopBookingIcon', 'aria-label': bookingStoppedLabel },
	                _react2.default.createElement('img', { src: '/images/icons/Stop-31.png', onClick: bookingStopped || evaluationRejected ? this.togglePopup.bind(this, 'createEstimationPopup') : bookingStoppedToast })
	              ),
	              order.PaintIsDraft && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) && _react2.default.createElement(
	                _button2.default,
	                {
	                  style: 'link',
	                  spacing: 0,
	                  className: bookingButtonClass,
	                  'aria-label': bookingButtonLabel,
	                  disabled: disabled,
	                  onClick: bookingStopped || evaluationRejected ? this.togglePopup.bind(this, 'createEstimationPopup') : evaluationStopped ? bookingStoppedToast : this.bookOrder.bind(this, undefined, false, false, true)
	                },
	                (0, _helpers.translation)('13384')
	              )
	            );
	          }
	        } else {
	          return _react2.default.createElement(_labelWrapper2.default, {
	            labelText: (0, _helpers.translation)('13532'),
	            helpText: (0, _helpers.translation)('13011') + ': ' + this.props.order.PublishedBy + '\n' + (0, _helpers.translation)('65') + ': ' + this.props.order.PublishedByShopName + '\n' + (0, _helpers.translation)('388') + ': ' + (0, _time.renderFullDate)(this.props.order.PublishDate) + '\n' + (0, _helpers.translation)('1052') + ': ' + this.props.order.PublishedByMail + '\n' + (0, _helpers.translation)('38') + ': ' + this.props.order.PublishedByMobile
	          });
	        }
	      }
	    }
	  }, {
	    key: 'renderTransport',
	    value: function renderTransport() {
	      var _this21 = this;
	
	      var $type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'box';
	
	      var isLoosePart = false;
	      var isPickup = false;
	      var isDelivery = false;
	      if (this.state.order.HasPickupAltLocation === true) isPickup = true;
	      if (this.state.order.HasDeliveryAltLocation === true) isDelivery = true;
	      if ([2, '2'].includes(this.state.order.Transport)) isLoosePart = true;
	      // Transport formatter to add icons?
	      var transportFormatter = function transportFormatter(val, listItemValName) {
	        var name = typeof val === 'number' ? '' : val.Name;
	        if (name === '') {
	          _this21.props.transport.map(function (v, index) {
	            if (v.Id === val) {
	              name = v.Name;
	            }
	          });
	        }
	        return _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)(name)
	        );
	      };
	
	      var renderList = function renderList(inputName, name, value) {
	        var list = [].concat(_toConsumableArray(_this21.state.order.CustomerClients));
	        var data = [{ CustomerClientId: 0, Name: (0, _helpers.translation)('227'), Address: '', ZipCode: '', City: '', CustomerId: 0, DisplayVal: (0, _helpers.translation)('227') }];
	
	        if (_this21.props.auth.user.DepartmentType === 1 && _this21.state.order.IsReferredOut) {
	          var customerClient = _this21.state.order[value.replace('Id', '')];
	          if (customerClient !== null) data.push(customerClient);
	        } else {
	          list.map(function (customerClient) {
	            return data.push(customerClient);
	          });
	        }
	
	        data.map(function (val, key) {
	          val.DisplayVal = val.Name;
	          if (val.Address !== '') val.DisplayVal += ', ' + val.Address;
	        });
	        return _this21.getInputRender(inputName, value, undefined, 'list', data, ['CustomerClientId', 'DisplayVal']);
	      };
	
	      var canEditTimes = this.state.order.PaintIsDraft && this.props.auth.departmentType === 1 && !this.state.order.IsReferredOut || this.props.auth.departmentType !== 1;
	
	      var renderPanel = function renderPanel(content) {
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('13373'), dataCol: 'transport' },
	          content
	        );
	      };
	
	      var renderHeader = function renderHeader(content) {
	        return _react2.default.createElement(
	          'div',
	          { 'data-col': 'transport' },
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13373') }),
	          content
	        );
	      };
	
	      var renderContent = function renderContent() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _this21.props.auth.departmentType === 1 && !_this21.props.order.HasAvailablePaintPartner && _react2.default.createElement(
	            'div',
	            { className: 'information' },
	            $type === 'data' && _this21.props.auth.user.UserType !== 4 && _this21.getInputRender('14829', 'IsPaintOrder', undefined, 'checkbox')
	          ),
	          (_this21.props.auth.departmentType !== 1 || _this21.props.order.HasAvailablePaintPartner) && _react2.default.createElement(
	            'div',
	            { className: 'information' },
	            $type === 'data' && _this21.props.auth.user.UserType !== 4 && _this21.getInputRender('14829', 'IsPaintOrder', undefined, 'checkbox'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 10)) && _react2.default.createElement(_BookingTimes2.default, { OrderId: _this21.state.order.Id, FromPaint: true, onUpdated: _this21.onBookingTimesUpdated }),
	            canEditTimes && _this21.state.order.OrderDepartment === 1 && _this21.getInputRender('26', 'Transport', transportFormatter, 'list', _this21.props.transport, ['Id', 'Name']),
	            !canEditTimes && _react2.default.createElement(_RadioList2.default, { title: '26', name: 'Transport', formatter: transportFormatter,
	              value: '' + _this21.state.order.Transport, onChange: function onChange() {},
	              listItems: _this21.removeLoosePart('Transport', _this21.props.transport), listItemValName: ['Id', 'Name'], disabled: true, translate: true }),
	            (_this21.state.order.OrderDepartment === 0 || _this21.state.order.OrderDepartment === 2 && !_this21.state.order.IsBodyShopOrder) && _this21.getInputRender('26', 'Transport', transportFormatter, 'list', _this21.props.transport, ['Id', 'Name']),
	            $type !== 'data' && _this21.renderTransportText(),
	            isLoosePart && _this21.getInputRender('13395', 'LoosePartsType', undefined, 'list', _this21.props.loosePartType, ['Id', 'Name']),
	            isLoosePart && _this21.getInputRender('286', 'ColorControlIncluded', undefined, 'checkbox'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 10)) && _this21.getInputRender('80', 'RekvNumber'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 20)) && _this21.getInputRender('13386', 'LTW', undefined, 'checkbox'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 20)) && _this21.state.order.LTW && _this21.getInputRender('13396', 'LTWIdCode'),
	            _this21.props.order.IsReferredIn && _this21.props.order.OrderConnection !== null && _this21.renderReferredIn(),
	            _this21.props.order.IsReferredOut && _this21.props.order.OrderConnection !== null && _this21.renderReferredOut(),
	            _react2.default.createElement(_divider2.default, { noLine: true }),
	            (0, _auth.hasSubscriptionPermission)(_this21.props.auth, 20) && $type !== 'data' && _this21.getInputRender('983', 'SuppressSMS', undefined, 'checkbox'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 20)) && _this21.getInputRender('14764', 'HasPickupAltLocation', undefined, 'checkbox'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 20)) && isPickup && renderList((0, _helpers.translation)('713'), '25', 'PickupAltLocationId'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 20)) && isPickup && _this21.getInputRender('14769', 'PickupAltLocationComment'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 20)) && _this21.getInputRender('14765', 'HasDeliveryAltLocation', undefined, 'checkbox'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 20)) && isDelivery && renderList((0, _helpers.translation)('714'), '25', 'DeliveryAltLocationId'),
	            ((0, _auth.hasSubscriptionPermission)(_this21.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(_this21.props.auth, 20)) && isDelivery && _this21.getInputRender('14769', 'DeliveryAltLocationComment')
	          )
	        );
	      };
	
	      return this.props.auth.departmentType === 1 ? renderHeader(renderContent()) : renderPanel(renderContent());
	    }
	  }, {
	    key: 'renderTransportText',
	    value: function renderTransportText() {
	      var showTransport = this.state.order.CustomerShowTransport;
	      if (!showTransport) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pg-mb-2' },
	          (0, _helpers.translation)('600')
	        );
	      }
	    }
	  }, {
	    key: 'renderReferredOut',
	    value: function renderReferredOut() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_text2.default, { value: this.props.order.OrderConnection.TransportBefore, disabled: true, labelText: (0, _helpers.translation)('705') }),
	        _react2.default.createElement(_text2.default, { value: this.props.order.OrderConnection.TransportAfter, disabled: true, labelText: (0, _helpers.translation)('707') })
	      );
	    }
	  }, {
	    key: 'renderReferredIn',
	    value: function renderReferredIn() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_text2.default, { value: this.props.order.OrderConnection.TransportBefore, disabled: true, labelText: (0, _helpers.translation)('705') }),
	        _react2.default.createElement(_text2.default, { value: this.props.order.OrderConnection.TransportAfter, disabled: true, labelText: (0, _helpers.translation)('707') })
	      );
	    }
	  }, {
	    key: 'renderVehicle',
	    value: function renderVehicle(dimensions) {
	      var $type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'box';
	      var $screen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	      if (dimensions !== null && !this.dimensionShow(dimensions)) return null;
	      var information = _react2.default.createElement(
	        'div',
	        { className: 'information' },
	        this.getInputRender('78', 'RegNumber'),
	        this.getInputRender('145', 'BrandName', undefined, 'list', this.props.brands, ['Id', 'Name'], true),
	        this.getInputRender('146', 'Model'),
	        this.getInputRender('147', 'Doors', undefined, 'list', this.props.doors, ['Id', 'Name'], false),
	        this.getInputRender('347', 'RegistrationDate'),
	        this.getInputRender('81', 'ChassisNumber'),
	        this.props.auth.departmentType > 0 && this.getInputRender('16710', 'DistanceDriven')
	      );
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('77'), dataCol: 'vehicle' },
	        information
	      );
	    }
	  }, {
	    key: 'renderColor',
	    value: function renderColor() {
	      var _this22 = this;
	
	      var $type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'box';
	      var $limit = arguments[1];
	
	      if (this.props.auth.departmentType === 1 && !this.props.order.HasAvailablePaintPartner) return null;
	      var hasSubscriptionProLight = (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0);
	      // let extraClass = $type === 'data' ? 'clearBackground' : ''
	      var hasLimit = $limit === '2cols';
	      var inputRenderType = $type === 'data' ? 'inputicon' : 'input';
	      var checkboxRenderType = $type === 'data' ? 'checkboxicon' : 'checkbox';
	
	      var renderPanel = function renderPanel(content) {
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('179'), dataCol: 'color' },
	          content
	        );
	      };
	
	      var renderHeader = function renderHeader(content) {
	        return _react2.default.createElement(
	          'div',
	          { 'data-col': 'color' },
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('179') }),
	          content
	        );
	      };
	
	      var renderContent = function renderContent() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'information' },
	          _this22.getInputRender('179', 'Color', undefined, inputRenderType),
	          _this22.getInputRender('79', 'ColorCode', undefined, inputRenderType),
	          hasSubscriptionProLight && !hasLimit && _this22.getInputRender('13388', 'ColorVariant', undefined, inputRenderType),
	          hasSubscriptionProLight && !hasLimit && _this22.getInputRender('13392', 'ColorAmount', undefined, inputRenderType),
	          hasSubscriptionProLight && !hasLimit && _this22.getInputRender('13393', 'ColorIsReady', undefined, checkboxRenderType)
	        );
	      };
	
	      return $type === 'data' ? renderHeader(renderContent()) : renderPanel(renderContent());
	    }
	  }, {
	    key: 'getContacts',
	    value: function getContacts() {
	      var _this23 = this;
	
	      if (typeof this.state.order.CustomerId === 'undefined') return null;
	      this.props.getCustomer(this.state.order.CustomerId).then(function (res) {
	        var contacts = res.data.Contacts;
	        contacts = contacts.filter(function (contact) {
	          return contact.Active ? contact : false;
	        });
	        _this23.setState({
	          contacts: contacts
	        });
	      });
	    }
	  }, {
	    key: 'renderInsuranceDisplay',
	    value: function renderInsuranceDisplay() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      if (this.state.InsuranceCompanies === undefined || this.state.order.OrderType !== _constants.OrderTypes.Insurance || this.state.order.InsuranceCompanyId == null) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_text2.default, {
	          value: this.state.order.InsuranceCompanyName,
	          disabled: true,
	          labelText: (0, _helpers.translation)('418')
	        }),
	        _react2.default.createElement(_text2.default, {
	          value: this.state.order.InsuranceAssessorName,
	          disabled: true,
	          labelText: (0, _helpers.translation)('14800')
	        })
	      );
	    }
	  }, {
	    key: 'renderCarOwnerPortal',
	    value: function renderCarOwnerPortal() {
	      if (!this.props.auth.permissions.CarOwnerPortalEnabled) return null;
	      return _react2.default.createElement(_CarOwnerPortalInviteStatus2.default, { orderId: this.props.order.Id });
	    }
	  }, {
	    key: 'renderReferred',
	    value: function renderReferred() {
	      if (this.props.auth.user.CustomerId !== '-1') return null;
	      if (this.props.order.OrderConnection === undefined || this.props.order.OrderConnection === null) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.order.IsReferredIn && this.props.order.OriginalShopName && _react2.default.createElement(_text2.default, {
	          value: this.props.order.OriginalShopName,
	          disabled: true,
	          labelText: (0, _helpers.translation)('17865')
	        }),
	        this.props.order.IsReferredIn && _react2.default.createElement(_text2.default, {
	          value: this.props.order.ShopNameReferredFrom ? this.props.order.ShopNameReferredFrom : '',
	          disabled: true,
	          labelText: (0, _helpers.translation)('719')
	        }),
	        this.props.order.IsReferredOut && _react2.default.createElement(_text2.default, {
	          value: this.props.order.ShopNameReferredTo ? this.props.order.ShopNameReferredTo : '',
	          disabled: true,
	          labelText: (0, _helpers.translation)('729')
	        })
	      );
	    }
	  }, {
	    key: 'renderCarOwnerPhoneList',
	    value: function renderCarOwnerPhoneList() {
	      var _this24 = this;
	
	      var carOwnerPhones = this.state.order.CarOwnerPhones;
	
	      if (carOwnerPhones.length === 0) {
	        carOwnerPhones.push('');
	      }
	
	      var newNumber = function newNumber(e) {
	        e.preventDefault();
	        var carOwnerPhoneCount = _this24.state.carOwnerPhoneCount;
	        if (carOwnerPhoneCount < 4) {
	          carOwnerPhoneCount++;
	          carOwnerPhones.push('');
	          _this24.setState({
	            carOwnerPhoneCount: carOwnerPhoneCount
	          });
	        }
	      };
	
	      var onChangePhone = function onChangePhone(key, e) {
	        carOwnerPhones[key] = e.target.value;
	        _this24.setState({
	          carOwnerPhones: carOwnerPhones
	        });
	      };
	
	      var onBlurPhone = function onBlurPhone(key, e) {
	        var data = _this24.state.order;
	        var carOwnerPhones = data.CarOwnerPhones;
	        carOwnerPhones[key] = e.target.value;
	
	        _this24.setState({
	          data: data,
	          carOwnerPhones: carOwnerPhones
	        }, function () {
	          _this24.saveWorkcard(undefined, undefined, data).then(function () {
	            _events2.default.emit('UPDATE_CAROWNER');
	            _this24.setState({}, function () {});
	          });
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        carOwnerPhones.map(function (val, key) {
	          if (val === null) {
	            val = '';
	          }
	          return _react2.default.createElement(_text2.default, { name: 'Text', value: val, key: 'number_' + key, labelText: (0, _helpers.translation)('14762'), onBlur: onBlurPhone.bind(_this24, key), onChange: onChangePhone.bind(_this24, key) });
	        }),
	        _react2.default.createElement(_button2.default, { style: 'link', labelText: (0, _helpers.translation)('17899'), disabled: carOwnerPhones.length === 4, onClick: newNumber })
	      );
	    }
	  }, {
	    key: 'renderContact',
	    value: function renderContact() {
	      var _this25 = this;
	
	      var $type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'box';
	
	      var renderSelectList = function renderSelectList() {
	        if ((0, _auth.hasAccess)([6], _this25.props.auth.user.UserType) || _this25.state.contacts.length === 0 || !_this25.props.order.IsDraft && _this25.props.auth.user.CustomerId !== '-1') return null;
	        var onChange = function onChange(e) {
	          _this25.state.contacts.map(function (contact) {
	            if (contact.UserId === parseInt(e.target.value)) {
	              _this25.setState({
	                order: _extends({}, _this25.state.order, {
	                  Contact: contact.Name,
	                  ContactPhone: contact.Phone || ''
	                })
	              }, _this25.saveWorkcard);
	            }
	          });
	        };
	        return _react2.default.createElement(
	          _dropDown2.default,
	          { value: 0, onChange: onChange, labelText: (0, _helpers.translation)('2242') },
	          _react2.default.createElement(
	            'option',
	            { value: '0' },
	            (0, _helpers.translation)('2242')
	          ),
	          _this25.state.contacts.map(function (contact, k) {
	            return _react2.default.createElement(
	              'option',
	              { key: k, value: contact.UserId },
	              contact.Name
	            );
	          })
	        );
	        // return (
	        //   <div className='selectCustomer'>
	        //     <label>{translation('2242')}</label>
	        //     <select value={0} onChange={onChange} ref='contact__list'>
	        //       <option value='0'>{translation('2242')}</option>
	        //       {this.state.contacts.map((contact, k) => {
	        //         return <option key={k} value={contact.UserId}>{contact.Name}</option>
	        //       })}
	        //     </select>
	        //   </div>
	        // )
	      };
	      var renderInsuranceDropdown = function renderInsuranceDropdown() {
	        var shownCustomer = _this25.state.order.CustomerName;
	        if (_this25.props.auth.allowNoCustomer && _this25.props.order.CustomerSelect === 1) {
	          shownCustomer = (0, _helpers.translation)('15330');
	        }
	        if (_this25.state.InsuranceCompanies === undefined) return null;
	
	        var noInsuranceId = _this25.state.order.InsuranceCompanyId === null;
	        var notInsurance = _this25.state.order.OrderType !== 1;
	        var lackingInsurance = notInsurance || noInsuranceId;
	
	        if (_this25.state.order.Report && !lackingInsurance) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _this25.renderInsuranceDisplay(),
	            _react2.default.createElement(_text2.default, {
	              value: shownCustomer,
	              disabled: true,
	              labelText: (0, _helpers.translation)('58')
	            })
	          );
	        }
	        if (!_this25.state.order.Report) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            (0, _auth.hasSubscriptionPermission)(_this25.props.auth, 10) && _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'InsuranceCompanyId', value: _this25.state.order.InsuranceCompanyId, onChange: _this25.onChange, labelText: (0, _helpers.translation)('418') },
	              _react2.default.createElement(
	                'option',
	                { value: '0' },
	                (0, _helpers.translation)('418')
	              ),
	              _this25.state.InsuranceCompanies.map(function (val, index) {
	                if (val.Active) {
	                  if (val.InsuranceCompanyId === _this25.state.order.InsuranceCompanyId) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: val.InsuranceCompanyId, key: index, selected: true },
	                      val.Company
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: val.InsuranceCompanyId, key: index },
	                      val.Company
	                    );
	                  }
	                }
	              })
	            ),
	            (0, _auth.hasSubscriptionPermission)(_this25.props.auth, 10) && !lackingInsurance && _this25.state.order.InsuranceAssessorName !== null && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_text2.default, {
	                value: _this25.state.order.InsuranceAssessorName,
	                disabled: true,
	                labelText: (0, _helpers.translation)('14800')
	              })
	            ),
	            _react2.default.createElement(_text2.default, {
	              value: shownCustomer,
	              disabled: true,
	              labelText: (0, _helpers.translation)('58')
	            })
	          );
	        }
	      };
	
	      var publishedBy = this.state.order.PublishedByUserInfo;
	      var publishedDate = 'PublishDate';
	      var publishInfo = this.state.order.PublishedByShopName.length > 0 ? this.state.order.PublishedByShopName + '\n' : '';
	      var isBooked = !this.state.order.IsDraft && this.props.auth.user.DepartmentType !== 1 || this.props.auth.user.DepartmentType === 1 && !this.state.order.BodyShopIsDraft;
	      if (this.props.auth.user.DepartmentType === 1 && !this.state.order.BodyShopIsDraft) {
	        publishedBy = this.state.order.BodyShopPublishedByUserInfo;
	        publishedDate = 'BodyShopPublishDate';
	        if (this.state.order.BodyShopPublishedByShopName.length > 0) {
	          publishInfo = this.state.order.BodyShopPublishedByShopName + '\n';
	        }
	      }
	      if (this.state.order.PublishedByMail.length > 0 || this.state.order.PublishedByMobile.length > 0) {
	        publishInfo += this.state.order.PublishedByMail + '\n' + this.state.order.PublishedByMobile;
	      }
	      var createInfo = this.state.order.CreatedByShopName.length > 0 ? this.state.order.CreatedByShopName + '\n' : '';
	      if (this.state.order.CreatedByMail.length > 0 || this.state.order.CreatedByMobile.length > 0) {
	        createInfo += this.state.order.CreatedByMail + '\n' + this.state.order.CreatedByMobile;
	      }
	      // console.log('[Workcard] auth', this.props.auth.user)
	
	      // console.log('Workcard: this.props.auth', this.props.auth.permissions)
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('346'), dataCol: 'carownercustomer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'information' },
	          renderInsuranceDropdown(),
	          ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && renderSelectList(),
	          ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && this.getInputRender('346', 'Contact'),
	          ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && this.getInputRender('345', 'ContactPhone'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.getInputRender('16776', 'CarOwnerName'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.getInputRender('16777', 'CarOwnerLastName'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.getInputRender('18386', 'CarOwnerAddress'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.getInputRender('18387', 'CarOwnerZipCode'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.getInputRender('18388', 'CarOwnerCity'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.renderCarOwnerPhoneList(),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.getInputRender('14763', 'CarOwnerMail'),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.getInputRender('16718', 'InsuranceDamageNr'),
	          this.renderCarOwnerPortal(),
	          this.renderReferred(),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('263'), helpText: createInfo.length > 0 && createInfo },
	            _react2.default.createElement(_UserInfo2.default, { user: this.state.order.CreatedByUserInfo })
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13387') },
	            (0, _time.renderFullDate)(this.state.order.CreationDate)
	          ),
	          isBooked && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13011'), helpText: publishInfo.length > 0 && publishInfo },
	            _react2.default.createElement(_UserInfo2.default, { user: publishedBy })
	          ),
	          isBooked && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13012') },
	            (0, _time.renderFullDate)(this.state.order[publishedDate])
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderInvoice',
	    value: function renderInvoice() {
	      return _react2.default.createElement(_Invoice2.default, { invoiceOrder: this.state.order, updateOrder: this.props.onUpdateOrder });
	    }
	  }, {
	    key: 'renderForsiToken',
	    value: function renderForsiToken() {
	      var _this26 = this;
	
	      var auth = this.props.auth;
	      var _state = this.state,
	          order = _state.order,
	          InsuranceCompanies = _state.InsuranceCompanies;
	
	      var forsiEnable = auth.permissions.ChainAssessmentSystem === 1; // Forsi is available for the company
	
	      // console.log("API", auth.permissions)
	      if (!forsiEnable) return null;
	      if (!auth.permissions.UsesForsiTokenApi) return null;
	      if (order.OrderType !== _constants.OrderTypes.Insurance) return null;
	
	      var onSuccess = function onSuccess() {
	        var evaluationStopped = (!_this26.props.order.IsEvaluation || _this26.props.order.IsEvaluation && !_this26.props.order.IsEvaluated) && _this26.props.order.CustomerWPEvaluationRequired && _this26.props.order.IsAgreementOrder;
	        var evaluationRejected = _this26.props.order.IsEvaluation && !_this26.props.order.IsEvaluated && _this26.props.order.IsEvaluationRejected && _this26.props.order.CustomerWPEvaluationRequired && _this26.props.order.IsAgreementOrder;
	
	        if (evaluationStopped || evaluationRejected) {
	          _this26.togglePopup('createEstimationPopup');
	        }
	      };
	
	      return _react2.default.createElement(_ForsiCreateReport2.default, { order: order, forsi: InsuranceCompanies, onSuccess: onSuccess });
	    }
	  }, {
	    key: 'renderCustomer',
	    value: function renderCustomer(dimensions) {
	      var _this27 = this;
	
	      var $type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'box';
	      var $screen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	      if (!this.dimensionShow(dimensions)) return null;
	
	      // Select list of customer contacts
	      var renderSelectList = function renderSelectList() {
	        if ((0, _auth.hasAccess)([6], _this27.props.auth.user.UserType) || _this27.state.contacts.length === 0 || !_this27.props.order.IsDraft && _this27.props.auth.user.CustomerId !== '-1') return null;
	        // const onChange = (e) => {
	        //   e.preventDefault()
	        //   console.log('ONCHAGNE', e.target.value, this.refs.contact__list.value)
	        //   this.state.contacts.map((contact) => {
	        //     if (contact.UserId === parseInt(this.refs.contact__list.value)) {
	        //       this.setState({
	        //         order: {
	        //           ...this.state.order,
	        //           Contact: contact.Name,
	        //           ContactPhone: contact.Phone || ''
	        //         }
	        //       }, this.saveWorkcard)
	        //     }
	        //   })
	        //   this.refs.contact__list.value = 0
	        // }
	        var onChange = function onChange(e) {
	          _this27.state.contacts.map(function (contact) {
	            if (contact.UserId === parseInt(e.target.value)) {
	              _this27.setState({
	                order: _extends({}, _this27.state.order, {
	                  Contact: contact.Name,
	                  ContactPhone: contact.Phone || ''
	                })
	              }, _this27.saveWorkcard);
	            }
	          });
	        };
	        return _react2.default.createElement(
	          _dropDown2.default,
	          { value: 0, onChange: onChange },
	          _react2.default.createElement(
	            'option',
	            { value: '0' },
	            (0, _helpers.translation)('2242')
	          ),
	          _this27.state.contacts.map(function (contact, k) {
	            return _react2.default.createElement(
	              'option',
	              { key: k, value: contact.UserId },
	              contact.Name
	            );
	          })
	        );
	        // return (
	        //   <div className='selectCustomer'>
	        //     <label>{translation('2242')}</label>
	        //     <select onChange={onChange} ref='contact__list'>
	        //       <option value='0'>{translation('2242')}</option>
	        //       {this.state.contacts.map((contact, k) => {
	        //         return <option key={k} value={contact.UserId}>{contact.Name}</option>
	        //       })}
	        //     </select>
	        //   </div>
	        // )
	      };
	      var createInfo = this.state.order.CreatedByShopName.length > 0 ? this.state.order.CreatedByShopName + '\n' : '';
	      if (this.state.order.CreatedByMail.length > 0 || this.state.order.CreatedByMobile.length > 0) {
	        createInfo += this.state.order.CreatedByMail + '\n' + this.state.order.CreatedByMobile;
	      }
	      var publishInfo = this.state.order.PublishedByShopName.length > 0 ? this.state.order.PublishedByShopName + '\n' : '';
	      if (this.state.order.PublishedByMail.length > 0 || this.state.order.PublishedByMobile.length > 0) {
	        publishInfo += this.state.order.PublishedByMail + '\n' + this.state.order.PublishedByMobile;
	      }
	      // Render customer block
	      if ($type === 'data') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'white__box clearBackground', 'data-col': 'customer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon titleIcon' },
	              _react2.default.createElement('img', { src: '/images/svgs/workscreen/customer-contact-info.svg', alt: (0, _helpers.translation)('179'), className: 'subtitleIMG' })
	            ),
	            (0, _helpers.translation)('346')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'information' },
	            this.renderInsuranceDisplay(),
	            renderSelectList(),
	            this.getInputRender('363', 'CustomerName'),
	            ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && this.getInputRender('346', 'Contact'),
	            ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && this.getInputRender('345', 'ContactPhone'),
	            this.renderReferred(),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                (0, _helpers.translation)('263')
	              ),
	              _react2.default.createElement(_UserInfo2.default, { user: this.state.order.CreatedByUserInfo }),
	              createInfo.length > 0 && _react2.default.createElement(_HelpText2.default, { left: true, className: 'helpText', text: createInfo })
	            ),
	            this.getInputRender('13387', 'CreationDate', _time.renderFullDate),
	            !this.state.order.IsDraft && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                (0, _helpers.translation)('13011')
	              ),
	              _react2.default.createElement(_UserInfo2.default, { user: this.state.order.PublishedByUserInfo }),
	              publishInfo.length > 0 && _react2.default.createElement(_HelpText2.default, { left: true, className: 'helpText', text: publishInfo })
	            ),
	            this.getInputRender('13012', 'PublishDate', _time.renderFullDate)
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('346'), dataCol: 'customer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'information' },
	            this.renderInsuranceDisplay(),
	            renderSelectList(),
	            this.getInputRender('363', 'CustomerName'),
	            ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && this.getInputRender('346', 'Contact'),
	            ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && this.getInputRender('345', 'ContactPhone'),
	            this.renderReferred(),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('263'), helpText: createInfo.length > 0 && createInfo },
	              _react2.default.createElement(_UserInfo2.default, { user: this.state.order.CreatedByUserInfo })
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('13387') },
	              (0, _time.renderFullDate)(this.state.order.CreationDate)
	            ),
	            !this.state.order.IsDraft && _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('13011'), helpText: publishInfo.length > 0 && publishInfo },
	              _react2.default.createElement(_UserInfo2.default, { user: this.state.order.PublishedByUserInfo })
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('13012') },
	              (0, _time.renderFullDate)(this.state.order.PublishDate)
	            ),
	            (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(_text2.default, {
	              value: this.state.order.ShopName,
	              disabled: true,
	              labelText: (0, _helpers.translation)('14847')
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderFiles',
	    value: function renderFiles(dimensions) {
	      var $type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'box';
	      var $screen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	      if (dimensions && !this.dimensionShow(dimensions)) return null;
	      return _react2.default.createElement(_Files2.default, { type: $type, order: this.state.order, onUpdateOrder: this.props.onUpdateOrder, saveWorkcard: this.saveWorkcard, saveSingleValue: this.saveSingleValue });
	    }
	  }, {
	    key: 'getPriceInformations',
	    value: function getPriceInformations() {
	      var _this28 = this;
	
	      if (!this.state.order || !this.state.order.BrandName) return null;
	      var _state$order = this.state.order,
	          OrderType = _state$order.OrderType,
	          BrandName = _state$order.BrandName,
	          CustomerId = _state$order.CustomerId;
	
	      this.props.getPriceInformations(OrderType, BrandName.Name, CustomerId, null, false, false, this.state.order.Id).then(function (_ref) {
	        var _ref$data = _ref.data,
	            RefinishTypes = _ref$data.RefinishTypes,
	            StartTimes = _ref$data.StartTimes,
	            HourPrices = _ref$data.HourPrices,
	            MaterialsShares = _ref$data.MaterialsShares;
	
	        _this28.setState({
	          priceInformation: {
	            RefinishTypes: RefinishTypes,
	            StartTimes: StartTimes,
	            HourPrices: HourPrices,
	            MaterialsShares: MaterialsShares
	          }
	        });
	      });
	    }
	  }, {
	    key: 'onConfirmMissingBodywork',
	    value: function onConfirmMissingBodywork() {
	      this.onCloseConfirmMissingBodywork(true);
	    }
	  }, {
	    key: 'onCloseConfirmMissingBodywork',
	    value: function onCloseConfirmMissingBodywork(book) {
	      var _this29 = this;
	
	      this.setState({
	        confirmMissingBodywork: {
	          show: false
	        }
	      }, function () {
	        _this29.props.triggerPopup(false); // modal-closed, backdrop-closed
	        if (book === true) {
	          setTimeout(function () {
	            _this29.bookOrder(undefined, true); // backdrop-open
	          }, 100);
	        }
	      });
	    }
	  }, {
	    key: 'renderConfirmMissingBodywork',
	    value: function renderConfirmMissingBodywork() {
	      return _react2.default.createElement(
	        _Portal2.default,
	        { className: 'confirm_popup', onPortalClose: this.onCloseConfirmMissingBodywork.bind(this) },
	        _react2.default.createElement(_Confirm2.default, { renderText: function renderText() {
	            return (0, _helpers.translation)(16748);
	          }, confirm: this.onConfirmMissingBodywork.bind(this), notConfirm: this.onCloseConfirmMissingBodywork.bind(this) })
	      );
	    }
	  }, {
	    key: 'renderConfirmPaintNotBooked',
	    value: function renderConfirmPaintNotBooked() {
	      var _this30 = this;
	
	      var onClose = function onClose() {
	        _this30.setState({
	          confirmPaintNotBooked: { open: false }
	        });
	      };
	      return _react2.default.createElement(
	        _Portal2.default,
	        { className: 'confirm_popup', onPortalClose: onClose.bind(this) },
	        _react2.default.createElement(_ConfirmOk2.default, { renderText: function renderText() {
	            return (0, _helpers.translation)(15246);
	          }, confirm: onClose.bind(this) })
	      );
	    }
	  }, {
	    key: 'renderLoosepartPriceChangePopup',
	    value: function renderLoosepartPriceChangePopup() {
	      var _this31 = this;
	
	      var onClose = function onClose(isCancel) {
	        _this31.setState({
	          loosepartChangeConfirmDialogOpen: false
	        }, function () {
	          if (isCancel) {
	            postCancel();
	          } else {
	            _this31.props.onUpdateOrder();
	          }
	        });
	      };
	
	      var postCancel = function postCancel() {
	        var postData = _this31.props.price;
	        postData.CancelEditing = true;
	
	        _this31.props.updatePrices(postData).then(function (res) {
	          _this31.props.onUpdateOrder();
	          if (typeof _this31.refs.price1 !== 'undefined') _this31.refs.price1.getWrappedInstance().getPrices();
	          if (typeof _this31.refs.price2 !== 'undefined') _this31.refs.price2.getWrappedInstance().getPrices();
	        });
	      };
	      // console.log('IN')
	      if (this.props.price.RequireShopApproval) {
	        // console.log('INRequire')
	        var show = this.state.loosepartChangeConfirmDialogOpen && this.props.price.RequireShopApproval === true;
	        return _react2.default.createElement(_PriceApprovalModal2.default, {
	          orderId: this.props.order.Id,
	          show: show,
	          closeModal: onClose,
	          overflowHidden: false,
	          priceInformation: this.state.priceInformation,
	          showAE: this.state.order.showAE });
	      }
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this32 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this32.state.dimensions.width;
	          if (width > higherThan && width <= lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'togglePopup',
	    value: function togglePopup(prop, visible) {
	      var _this33 = this;
	
	      if (typeof visible !== 'boolean') {
	        visible = !this.state[prop].show;
	      }
	      if (!visible && prop === 'handleCarRentalPopup') {
	        // After editing advanced car rentals in popup, reload order.
	        this.props.onUpdateOrder();
	      }
	      this.setState(_defineProperty({}, prop, _extends({}, this.state[prop], {
	        show: visible
	      })), function () {
	        // console.log('state.confirmMissingBodywork ', this.state.confirmMissingBodywork)
	        _this33.props.triggerPopup(visible);
	      });
	    }
	  }, {
	    key: 'renderSetCustomerPopup',
	    value: function renderSetCustomerPopup() {
	      var _this34 = this;
	
	      if (!this.state.showSetCustomerPopup.show) return null;
	      // console.log('[WorkCard] renderSetCustomerPopup')
	      var updateOrder = function updateOrder(item) {
	        // console.log('[WorkCard] updateOrder trigger')
	        _this34.props.onUpdateOrder();
	      };
	      return _react2.default.createElement(_SetCustomer2.default, { id: this.state.order.Id, item: this.state.order, close: this.togglePopup.bind(this, 'showSetCustomerPopup'), inModal: true, updateOrder: updateOrder.bind(this) });
	      // return (
	      //   <Modal show onClose={this.togglePopup.bind(this, 'showSetCustomerPopup')} header={translation('2259')}>
	      //     <SetCustomer id={this.state.order.Id} item={this.state.order} close={this.togglePopup.bind(this, 'showSetCustomerPopup')} inModal updateOrder={updateOrder.bind(this)} />
	      //   </Modal>
	      // )
	    }
	  }, {
	    key: 'renderCreateEstimationPopup',
	    value: function renderCreateEstimationPopup() {
	      if (!this.state.createEstimationPopup.show) return null;
	      var topMessage = [(0, _helpers.translation)('13568')];
	      var returnOrder = true;
	      return _react2.default.createElement(_CreateEstimationModal2.default, {
	        show: this.state.createEstimationPopup.show,
	        topMessage: topMessage,
	        id: this.state.order.Id,
	        returnOrder: returnOrder,
	        onClose: this.togglePopup.bind(this, 'createEstimationPopup', false),
	        onSave: this.onCreateEstimationSave
	      });
	    }
	  }, {
	    key: 'renderHandleCarRentalPopup',
	    value: function renderHandleCarRentalPopup() {
	      // console.log('this.state.handleCarRentalPopup ', this.state.handleCarRentalPopup)
	      // console.log('this.state.order ', this.state.order)
	      if (!this.state.handleCarRentalPopup.show) return null;
	
	      var order = this.state.order;
	
	      return _react2.default.createElement(_HandleCarRentalModal2.default, {
	        show: this.state.handleCarRentalPopup.show,
	        orderId: order.Id,
	        customerId: order.CustomerId,
	        pickup: order.BodyShopPickupTime,
	        pickupTimes: order.BodyShopPickupTimes // temporary prop ?
	        , delivery: order.BodyShopDeliveryTime,
	        deliveryTimes: order.BodyShopDeliveryTimes // temporary prop ?
	        , onClose: this.togglePopup.bind(this, 'handleCarRentalPopup', false)
	      });
	    }
	  }, {
	    key: 'renderDracarInfoPopup',
	    value: function renderDracarInfoPopup() {
	      if (!this.state.dracarVehicleCheck || !this.state.dracarInfoPopup.show) return null;
	      var text = [];
	      if (this.state.dracarVehicleCheck.foundVehicle) {
	        if (this.state.dracarVehicleCheck.customers.length > 0) {
	          text.push((0, _helpers.translation)('17846'));
	          this.state.dracarVehicleCheck.customers.map(function (customer) {
	            text.push(_react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                customer.Relationship,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                customer.FirstName,
	                ', ',
	                customer.LastName
	              )
	            ));
	          });
	        } else {
	          text.push((0, _helpers.translation)('17847'));
	        }
	      } else {
	        text.push((0, _helpers.translation)('17848'));
	      }
	      return _react2.default.createElement(
	        _OkModal2.default,
	        _extends({}, this.state.dracarInfoPopup, { onClose: this.togglePopup.bind(this, 'dracarInfoPopup', false) }),
	        text
	      );
	    }
	  }, {
	    key: 'renderBodyShopStatus',
	    value: function renderBodyShopStatus() {
	      var _this35 = this;
	
	      // Do not show body shop status for customer
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) return null;
	      var renderList = function renderList(inputName, name, value) {
	        var data = [{ BodyShopStatusId: 0, Name: (0, _helpers.translation)('13054'), DisplayVal: (0, _helpers.translation)('13054') }, { BodyShopStatusId: 1, Name: (0, _helpers.translation)('13053'), DisplayVal: (0, _helpers.translation)('13053') }];
	        data.map(function (val, key) {
	          val.DisplayVal = val.Name;
	        });
	        return _this35.getInputRender(inputName, value, undefined, 'list', data, ['BodyShopStatusId', 'DisplayVal']);
	      };
	
	      return [_react2.default.createElement(
	        'div',
	        { 'data-col': 'bodyshopstatus', key: '0' },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	          renderList('13052', '25', 'BodyShopSelectedStatus')
	        )
	      ), _react2.default.createElement(_divider2.default, { key: '1' })];
	    }
	  }, {
	    key: 'renderPaintShopStatus',
	    value: function renderPaintShopStatus() {
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) return null;
	      return [_react2.default.createElement(
	        'div',
	        { 'data-col': 'paintshopstatus', key: '0' },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13052') },
	            this.renderBookExternalLak()
	          )
	        )
	      ), _react2.default.createElement(_divider2.default, { key: '1' })];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this36 = this;
	
	      if (typeof this.props.order.Id === 'undefined' || typeof this.state.order === 'undefined') {
	        var loadingSpinner = function loadingSpinner() {
	          return _react2.default.createElement(
	            _panel2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'workcard__screen' },
	          this.props.disabled !== true && _react2.default.createElement(
	            _Header2.default,
	            {
	              router: this.props.router
	              // title={title}
	              , showBack: true,
	              headerButtonsGoBack: this.props.renderButtonsGoBack,
	              renderButtons: function renderButtons() {
	                return [_react2.default.createElement(_OrderBookingButton2.default, { key: 'booking', order: _this36.props.order, togglePopup: _this36.togglePopup, bookOrder: _this36.bookOrder, regularBooking: true })];
	              }
	            },
	            this.props.renderTabs()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row clearfix' },
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              loadingSpinner()
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              loadingSpinner()
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                loadingSpinner(),
	                loadingSpinner()
	              ),
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                loadingSpinner(),
	                loadingSpinner()
	              )
	            )
	          )
	        );
	      }
	      var disablePaintShopManuelPriceSetting = false;
	      // if (this.state.order.ForsiOrderExtent !== null) disablePaintShopManuelPriceSetting = true
	      var order = this.state.order;
	
	      var hasForsiReport = order.Report !== null && order.Report.ReportType === 1;
	      if (hasForsiReport && order.Report.Paint) disablePaintShopManuelPriceSetting = true;
	      var disableMobileAccess = this.dimensionShow([Below650]);
	
	      var bodyshop = function bodyshop() {
	        var isIntegration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        // console.log('render bodyshop - isIntegration', isIntegration)
	        var leftTitle = _this36.state.order.Id;
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('788') + ' \xB7 ' + leftTitle },
	          !isIntegration && _this36.renderBodyShopStatus(),
	          _react2.default.createElement(
	            'div',
	            { 'data-col': 'bodyshoptransport' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: _this36.saveWorkcard, autoComplete: 'off' },
	              _this36.renderBodyShopTransport()
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(_OrderExtent2.default, { router: _this36.props.router, whitebox: false, type: '', department: 'body', hideContent: false, onUpdateOrder: _this36.props.onUpdateOrder })
	        );
	      };
	      var paint = function paint() {
	        var isIntegration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var isCustomer = _this36.props.auth.user.CustomerId !== '-1';
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('161') },
	          !isCustomer && !isIntegration && _this36.props.order.HasAvailablePaintPartner && _this36.renderPaintShopStatus(),
	          !(0, _auth.hasAccess)([4], _this36.props.auth.user.UserType) && _this36.props.order.HasAvailablePaintPartner && [_react2.default.createElement(
	            'div',
	            { 'data-col': 'painttransport', key: '0' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: _this36.saveWorkcard, autoComplete: 'off' },
	              _this36.renderTransport('data')
	            )
	          ), _react2.default.createElement(_divider2.default, { key: '1' })],
	          _react2.default.createElement(
	            'form',
	            { onSubmit: _this36.saveWorkcard, autoComplete: 'off' },
	            !isIntegration && _this36.renderColor('data', '2cols'),
	            isIntegration && _this36.renderColor('data')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(_OrderExtent2.default, { router: _this36.props.router, datacol: 'order', whitebox: false, type: 'data', department: '', hideContent: false, editAllowed: disablePaintShopManuelPriceSetting, onUpdateOrder: _this36.props.onUpdateOrder })
	        );
	      };
	
	      var col3 = function col3(isCol) {
	        var renderContent = function renderContent() {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _this36.dimensionShow([Between1055And1400]) && _react2.default.createElement(
	              'div',
	              { className: 'section__status' },
	              _this36.renderInvoice(),
	              _this36.renderForsiToken(),
	              _this36.renderDracar()
	            ),
	            _react2.default.createElement(_SpareParts2.default, { disableMobileAccess: disableMobileAccess, onUpdateOrder: _this36.props.onUpdateOrder, renderInput: _this36.getInputRender.bind(_this36), order: _this36.state.order, saveWorkcard: _this36.saveWorkcard, saveSingleValue: _this36.saveSingleValue }),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: _this36.saveWorkcard, autoComplete: 'off' },
	              !isCol && _this36.renderVehicle([Below1055], 'box', 'plade/integration')
	            ),
	            !isCol && _this36.dimensionShow([Below1055]) && _this36.renderNotes('box', 'plade'),
	            !isCol && _this36.renderFiles('', 'plade/integration')
	          );
	        };
	
	        return isCol ? _react2.default.createElement(
	          _col2.default,
	          null,
	          renderContent()
	        ) : renderContent();
	      };
	      var col4 = function col4(isCol) {
	        var renderContent = function renderContent() {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _this36.dimensionShow([Above1400]) && _react2.default.createElement(
	              'div',
	              { className: 'section__status' },
	              _this36.renderInvoice(),
	              _this36.renderForsiToken(),
	              _this36.renderDracar()
	            ),
	            _this36.dimensionShow([Above1400]) && _this36.renderNotes('box', 'plade'),
	            _this36.renderFiles([Above1400], '', 'plade/integration'),
	            (0, _auth.hasSubscriptionPermission)(_this36.props.auth, 10) && _react2.default.createElement(
	              'form',
	              { onSubmit: _this36.saveWorkcard, autoComplete: 'off' },
	              _this36.renderVehicle([Above1055, Below650], 'box', 'plade/integration'),
	              _this36.dimensionShow([Above1400, Below1055]) && _this36.renderContact()
	            )
	          );
	        };
	
	        return isCol ? _react2.default.createElement(
	          _col2.default,
	          null,
	          renderContent()
	        ) : renderContent();
	      };
	      // Free only column
	      var col5 = function col5(isCol) {
	        if ((0, _auth.hasSubscriptionPermission)(_this36.props.auth, 10)) return null;
	
	        var renderContent = function renderContent() {
	          return _react2.default.createElement(
	            'div',
	            { className: isCol ? 'col' : '' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: _this36.saveWorkcard, autoComplete: 'off' },
	              _this36.renderVehicle([Above1055, Below650], 'box', 'plade/integration'),
	              _this36.dimensionShow([Above1400, Below1055]) && _this36.renderContact()
	            )
	          );
	        };
	
	        return isCol ? _react2.default.createElement(
	          _col2.default,
	          null,
	          renderContent()
	        ) : renderContent();
	      };
	
	      var department = this.state.order.OrderDepartment;
	      var paintDepartment = department === 0;
	      var bodyDepartment = department === 1;
	      var combinedDepartment = department === 2;
	      var isMyPage = this.context.router.location.pathname.indexOf('mypage/orders/') > -1;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'workcard__screen' },
	        !this.props.disabled && _react2.default.createElement(
	          _Header2.default,
	          {
	            router: this.props.router,
	            showBack: true,
	            headerButtonsGoBack: this.props.renderButtonsGoBack,
	            renderButtons: function renderButtons() {
	              return [_react2.default.createElement(_OrderBookingButton2.default, { key: 'booking', order: _this36.props.order, togglePopup: _this36.togglePopup, bookOrder: _this36.bookOrder, regularBooking: true })];
	            }
	          },
	          this.props.renderTabs()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'printTitle' },
	          this.props.common.pageTitle.title + '  (' + this.props.order.Id + ')'
	        ),
	        _react2.default.createElement(
	          'fieldset',
	          { disabled: this.props.disabled },
	          _react2.default.createElement(
	            'div',
	            { className: 'row clearfix' },
	            bodyDepartment && isMyPage && _react2.default.createElement(
	              'div',
	              { className: 'col firstcol' },
	              this.dimensionShow([[0, 1055]]) && _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              this.dimensionShow([[0, 10000]]) && bodyshop(combinedDepartment),
	              this.dimensionShow([[0, 1055]]) && paint(combinedDepartment),
	              this.dimensionShow([[0, 1300]]) && _react2.default.createElement(_SpareParts2.default, { disableMobileAccess: false, onUpdateOrder: this.props.onUpdateOrder, renderInput: this.getInputRender.bind(this), order: this.state.order, saveWorkcard: this.saveWorkcard, saveSingleValue: this.saveSingleValue }),
	              this.dimensionShow([[0, 1055]]) && this.renderNotes(),
	              this.renderFiles([[0, 1055]], '', 'plade/integration'),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.renderVehicle([[0, 1300]])
	              ),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.dimensionShow([[0, 1055]]) && this.renderContact()
	              ),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.dimensionShow([[1300, 10000]]) && this.renderContact()
	              )
	            ),
	            bodyDepartment && isMyPage && this.dimensionShow([[1055, 10000]]) && _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              this.dimensionShow([[1055, 1300]]) && _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              this.dimensionShow([Above650]) && paint(combinedDepartment),
	              this.renderNotes([[1055, 10000]]),
	              this.renderFiles([[1055, 10000]], '', 'plade/integration'),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.dimensionShow([[1055, 1300]]) && this.renderContact()
	              )
	            ),
	            bodyDepartment && isMyPage && this.dimensionShow([[1300, 10000]]) && _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              _react2.default.createElement(_SpareParts2.default, { disableMobileAccess: false, onUpdateOrder: this.props.onUpdateOrder, renderInput: this.getInputRender.bind(this), order: this.state.order, saveWorkcard: this.saveWorkcard, saveSingleValue: this.saveSingleValue }),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.renderVehicle([[1300, 10000]])
	              )
	            ),
	            paintDepartment && isMyPage && _react2.default.createElement(
	              'div',
	              { className: 'col firstcol' },
	              this.dimensionShow([[0, 1055]]) && _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              _react2.default.createElement(
	                _WhiteBox2.default,
	                { titleId: 'paintTitle', titleIconAlt: (0, _helpers.translation)('179'), titleText: (0, _helpers.translation)('13360') },
	                _react2.default.createElement(_OrderExtent2.default, { router: this.props.router, datacol: 'order', whitebox: false, type: 'data', department: '', hideContent: false, editAllowed: disablePaintShopManuelPriceSetting, onUpdateOrder: this.props.onUpdateOrder })
	              ),
	              this.dimensionShow([[0, 1055]]) && _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.renderTransport()
	              ),
	              this.dimensionShow([[0, 1055]]) && this.renderNotes(),
	              this.renderFiles([[0, 1055]], '', 'plade/integration'),
	              this.dimensionShow([[0, 1055]]) && this.renderColor(),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.renderVehicle([[0, 10000]])
	              ),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.renderContact()
	              )
	            ),
	            paintDepartment && isMyPage && this.dimensionShow([[1055, 10000]]) && _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              this.dimensionShow([[1055, 1300]]) && _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.renderTransport()
	              ),
	              this.renderNotes(),
	              this.renderFiles([[1055, 10000]], '', 'plade/integration'),
	              this.dimensionShow([[1055, 1300]]) && this.renderColor()
	            ),
	            paintDepartment && isMyPage && this.dimensionShow([[1300, 10000]]) && _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              this.renderColor()
	            ),
	            paintDepartment && !isMyPage && _react2.default.createElement(
	              _col2.default,
	              null,
	              this.dimensionShow([Below650]) && _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              _react2.default.createElement(_OrderExtent2.default, { router: this.props.router, onUpdateOrder: this.props.onUpdateOrder }),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.renderVehicle([Between650And1401]),
	                this.renderCustomer([Between650And1401])
	              )
	            ),
	            !paintDepartment && !isMyPage && this.dimensionShow([Below650]) && _react2.default.createElement(
	              _col2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              bodyshop(combinedDepartment),
	              paint(combinedDepartment),
	              _react2.default.createElement(_SpareParts2.default, { disableMobileAccess: true, onUpdateOrder: this.props.onUpdateOrder, renderInput: this.getInputRender.bind(this), order: this.state.order, saveWorkcard: this.saveWorkcard, saveSingleValue: this.saveSingleValue }),
	              this.renderNotes('box', 'plade'),
	              this.renderFiles([Below650], '', 'plade/integration'),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.renderVehicle([Below650], 'box', 'plade/integration'),
	                this.renderContact()
	              )
	            ),
	            !paintDepartment && !isMyPage && this.dimensionShow([Above650]) && _react2.default.createElement(
	              _col2.default,
	              null,
	              bodyshop(combinedDepartment),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.dimensionShow([Between1055And1400]) && this.renderContact()
	              ),
	              this.dimensionShow([Below1055]) && col3(false)
	            ),
	            combinedDepartment && !isMyPage && this.dimensionShow([Above650]) && _react2.default.createElement(
	              _col2.default,
	              null,
	              this.dimensionShow([[650, 1055]]) && _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              paint(combinedDepartment),
	              this.renderFiles([Between1055And1400], '', 'plade/integration'),
	              this.dimensionShow([Below1055]) && col4(false)
	            ),
	            paintDepartment && !isMyPage && _react2.default.createElement(
	              _col2.default,
	              null,
	              this.dimensionShow([[650, 1055]]) && _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                this.renderTransport()
	              ),
	              this.renderNotes(),
	              this.renderFiles()
	            ),
	            paintDepartment && !isMyPage && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                this.dimensionShow([Between1055And1400]) && _react2.default.createElement(
	                  'div',
	                  { className: 'section__status' },
	                  this.renderInvoice(),
	                  this.renderForsiToken(),
	                  this.renderDracar()
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                  this.renderColor()
	                )
	              ),
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                this.dimensionShow([Above1400]) && _react2.default.createElement(
	                  'div',
	                  { className: 'section__status' },
	                  this.renderInvoice(),
	                  this.renderForsiToken(),
	                  this.renderDracar()
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: this.saveWorkcard, autoComplete: 'off' },
	                  this.renderVehicle([Above1400, Below650]),
	                  this.renderCustomer([Above1400, Below650])
	                )
	              )
	            ),
	            bodyDepartment && !isMyPage && this.dimensionShow([Above650]) && _react2.default.createElement(
	              _col2.default,
	              null,
	              this.dimensionShow([[650, 1055]]) && _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                this.renderInvoice(),
	                this.renderForsiToken(),
	                this.renderDracar()
	              ),
	              paint(combinedDepartment),
	              this.dimensionShow([Between1055And1400]) && this.renderNotes('box', 'plade'),
	              this.renderFiles([Between1055And1400], '', 'plade/integration'),
	              this.dimensionShow([Below1055]) && col4(false)
	            ),
	            !paintDepartment && !isMyPage && this.dimensionShow([Above1055]) && _react2.default.createElement(
	              'div',
	              null,
	              col3(true),
	              col4(true),
	              col5(true)
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'row clearfix rowPrint' }),
	        this.renderSetCustomerPopup(),
	        this.renderCreateEstimationPopup(),
	        this.renderHandleCarRentalPopup(),
	        this.renderDracarInfoPopup(),
	        this.state.loosepartChangeConfirmDialogOpen && this.renderLoosepartPriceChangePopup(),
	        this.state.confirmPaintNotBooked.open && this.renderConfirmPaintNotBooked(),
	        this.state.confirmMissingBodywork.show && this.renderConfirmMissingBodywork(),
	        this.state.confirmDelete.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDelete') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDelete') })
	        )
	      );
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm() {
	      var _this37 = this;
	
	      this.onPortalClose('confirmDelete');
	      this.props.deleteNote(this.state.confirmDelete.NoteID).then(function (res) {
	        var newData = _extends({}, _this37.state.order);
	        newData.Notes = res.data.Notes;
	        _this37.props.onUpdateOrder(newData);
	        // Toastr
	        // window.toastr.success(translation('1895'), translation('13424'))
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13441'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false,
	        NoteID: 0
	      })));
	    }
	  }]);
	
	  return WorkCard;
	}(_react.Component);
	
	WorkCard.propTypes = {
	  triggerPopup: _propTypes2.default.func.isRequired,
	  deleteNote: _propTypes2.default.func.isRequired
	};
	WorkCard.contextTypes = {
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired,
	  router: _propTypes2.default.object
	};
	WorkCard.childContextTypes = {
	  dimensions: _propTypes2.default.shape({
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  onBlur: _propTypes2.default.func,
	  onChange: _propTypes2.default.func.isRequired,
	  onUpdateOrder: _propTypes2.default.func.isRequired,
	  saveWorkcard: _propTypes2.default.func.isRequired,
	  disabledForWP: _propTypes2.default.bool
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    price: state.price.price,
	    order: state.orders.order,
	    brands: state.common.brands,
	    orderTypes: state.common.enums.orderTypes,
	    transport: state.common.transport,
	    doors: state.common.doors,
	    loosePartType: state.common.loosePartType,
	    common: state.common
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  deleteNote: _notes.deleteNote,
	  uploadFileToOrder: _orders.uploadFileToOrder,
	  deleteFileFromOrder: _orders.deleteFileFromOrder,
	  saveOrder: _orders.saveOrder,
	  setWorkcardOrder: _orders.setWorkcardOrder,
	  bookOrder: _orders.bookOrder,
	  isFileReady: _orders.isFileReady,
	  getOrderVehicleData: _orders.getOrderVehicleData,
	  getCustomer: _customers.getCustomer,
	  getPrices: _orderPrice.getPrices,
	  getOrderClean: _orders.getOrderClean,
	  triggerPopupActionBG: _backdrop.triggerPopupActionBG,
	  triggerPopup: _backdrop.triggerPopup,
	  GetSimpleCarRentals: _shops.GetSimpleCarRentals,
	  GetAssignments: _carrental.GetAssignments,
	  getInsuranceCompanies: _insurancecompanies.getInsuranceCompanies,
	  updatePrices: _orderPrice.updatePrices,
	  getPriceInformations: _priceModel.getPriceInformations,
	  setPageTitle: _common.setPageTitle,
	  checkVehicleForCustomers: _dracar.checkVehicleForCustomers,
	  openOverlay: _common.openOverlay
	})(WorkCard);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _actions = __webpack_require__(129);
	
	var _common = __webpack_require__(25);
	
	var _orders = __webpack_require__(21);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _constants = __webpack_require__(5);
	
	var _orderPrice = __webpack_require__(193);
	
	var _priceModel = __webpack_require__(75);
	
	var _notes = __webpack_require__(114);
	
	var _backdrop = __webpack_require__(29);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _HelpText = __webpack_require__(130);
	
	var _HelpText2 = _interopRequireDefault(_HelpText);
	
	var _EstimationsList = __webpack_require__(1030);
	
	var _EstimationsList2 = _interopRequireDefault(_EstimationsList);
	
	var _AssessmentForsi = __webpack_require__(436);
	
	var _AssessmentForsi2 = _interopRequireDefault(_AssessmentForsi);
	
	var _AssessmentDBS = __webpack_require__(435);
	
	var _AssessmentDBS2 = _interopRequireDefault(_AssessmentDBS);
	
	var _Estimation = __webpack_require__(292);
	
	var _Estimation2 = _interopRequireDefault(_Estimation);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	__webpack_require__(1442);
	
	var _currency = __webpack_require__(41);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _array = __webpack_require__(205);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _expand = __webpack_require__(175);
	
	var _expand2 = _interopRequireDefault(_expand);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { renderFullDate } from '../../utils/time'
	
	// import Dropzone from '../../shared/components/Dropzone'
	
	// Actions
	
	
	// Confirm
	
	
	// Components
	
	
	// import Forsi from '../../shared/components/Extent/Forsi'
	
	
	// import styles
	
	// import '../PriceCalculation/Price/price.scss'
	
	// import { hasAccess } from '../../utils/auth'
	
	
	// import utils
	
	
	// Elements
	
	
	var PriceApproval = function (_Component) {
	  _inherits(PriceApproval, _Component);
	
	  function PriceApproval(props) {
	    _classCallCheck(this, PriceApproval);
	
	    var _this = _possibleConstructorReturn(this, (PriceApproval.__proto__ || Object.getPrototypeOf(PriceApproval)).call(this, props));
	
	    _this.state = {
	      prices: {
	        Original: {},
	        Changed: {},
	        IsApproved: false,
	        ApprovalToken: '',
	        CustomerId: 0,
	        Customer: null,
	        Shop: null,
	        OrderType: 0
	      },
	      isShopApproval: false,
	      shopApproval: {
	        orderId: null,
	        orderPriceType: null
	      },
	      note: {
	        NoteID: 0,
	        Note: '',
	        NoteTypeID: 1,
	        OrderID: 0,
	        SourceID: 0,
	        ApplyToInvoice: false,
	        DeviationId: 0
	      },
	      CommentName: '',
	      Locked: false,
	      toggleGross: false,
	      ApprovedText: '',
	      confirmImage: false,
	      confirm: {
	        open: false
	      },
	      reject: {
	        open: false
	      },
	      approvalResult: null,
	      hideXButton: false,
	      isHandled: false,
	      custommerContacts: [],
	      priceInformation: props.priceInformation !== undefined ? props.priceInformation : null,
	      employees: [],
	      specificReciever: ''
	    };
	
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.getPricesForApproval = _this.getPricesForApproval.bind(_this);
	    _this.renderPrice = _this.renderPrice.bind(_this);
	    _this.renderPartTasks = _this.renderPartTasks.bind(_this);
	    _this.renderAddonPart = _this.renderAddonPart.bind(_this);
	    _this.renderAddonStartTime = _this.renderAddonStartTime.bind(_this);
	    _this.renderExtraOrService = _this.renderExtraOrService.bind(_this);
	    _this.setLanguage = _this.setLanguage.bind(_this);
	    _this.toggleGross = _this.toggleGross.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.onApproveClick = _this.onApproveClick.bind(_this);
	    _this.onRejectClick = _this.onRejectClick.bind(_this);
	    _this.validateFields = _this.validateFields.bind(_this);
	    _this.onPortalClose = _this.onPortalClose.bind(_this);
	    _this.renderComment = _this.renderComment.bind(_this);
	    _this.renderFiles = _this.renderFiles.bind(_this);
	    _this.renderHandledBy = _this.renderHandledBy.bind(_this);
	    _this.setHeader = _this.setHeader.bind(_this);
	    return _this;
	  }
	
	  _createClass(PriceApproval, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var isShopApproval = false;
	      var orderPriceType = 1; // base
	      var orderId = null;
	      var commentName = ''; // this.props.auth.isAuthenticated ? this.props.auth.user.ContactName : ''
	      if (this.props.orderId !== undefined && this.props.shopApproval === true) {
	        isShopApproval = true;
	        orderId = this.props.orderId;
	        orderPriceType = this.props.orderPriceType !== undefined ? this.props.orderPriceType : orderPriceType;
	        // console.log('orderPriceType', orderPriceType, this.props.orderPriceType)
	        if (this.context.router.params.addon === '4') orderPriceType = 4; // Afterevaluation
	        if (this.context.router.params.addon === '3') orderPriceType = 3; // Evaluation
	        if (this.context.router.params.addon === '2') orderPriceType = 2; // Addon
	        var isBodyShop = this.context.router.params.addon === 'bodyextent' || this.context.router.params.addon === 'bodyaddon';
	
	        this.getPricesForShopApproval(orderId, orderPriceType, isBodyShop ? 1 : 0).then(function () {
	          // console.log('PriceApproval get for shop ', this.props.priceInformation, this.state.prices.Changed.UseEstimation)
	          if (!_this2.props.priceInformation && (_this2.state.prices.Changed !== null && (_this2.state.prices.Changed.UseEstimation || _this2.state.prices.Changed.IsAfterEvaluation) || _this2.state.prices.Original !== null && (_this2.state.prices.Original.UseEstimation || _this2.state.prices.Original.IsAfterEvaluation))) {
	            // console.log('PriceApproval Will get partTasks')
	            var _state$prices = _this2.state.prices,
	                OrderBrand = _state$prices.OrderBrand,
	                CustomerId = _state$prices.CustomerId,
	                OrderId = _state$prices.Changed.OrderId;
	
	
	            _this2.props.getPriceInformations(null, OrderBrand, CustomerId, null, true, false, OrderId).then(function (res) {
	              _this2.setState({
	                priceInformation: res.data
	              });
	            });
	          }
	        });
	      } else {
	        var token = this.props.routeParams.approvalToken;
	
	        this.getPricesForApproval(token).then(function () {
	          if (!_this2.props.priceInformation && (_this2.state.prices.Changed.UseEstimation || _this2.state.prices.Original.UseEstimation)) {
	            var _state$prices2 = _this2.state.prices,
	                OrderBrand = _state$prices2.OrderBrand,
	                CustomerId = _state$prices2.CustomerId,
	                OrderId = _state$prices2.Changed.OrderId;
	
	
	            _this2.props.getPriceInformations(null, OrderBrand, CustomerId, null, true, false, OrderId).then(function (res) {
	              _this2.setState({
	                priceInformation: res.data
	              });
	            });
	          }
	        });
	      }
	
	      this.setState({
	        isShopApproval: isShopApproval,
	        shopApproval: {
	          orderId: orderId,
	          orderPriceType: orderPriceType
	        },
	        CommentName: commentName
	      }, function () {
	        if (_this2.props.renderModal && _this2.props.setBottomBarProps) {
	          _this2.props.setBottomBarProps(_this2.getActionButtons(true));
	        }
	      });
	    }
	  }, {
	    key: 'setHeader',
	    value: function setHeader() {
	      if (this.props.setModalHeader !== undefined && this.props.setModalHeader !== null) {
	        if (this.state.prices.Changed !== null) {
	          if (this.state.prices.Changed.IsAfterEvaluation) this.props.setModalHeader((0, _helpers.translation)(14921));else if (this.state.prices.Changed.IsEvaluation) this.props.setModalHeader((0, _helpers.translation)(13363));else if (this.state.prices.Changed.IsAddonPrice) this.props.setModalHeader((0, _helpers.translation)(1045));
	        } else {
	          this.props.setModalHeader((0, _helpers.translation)(2012));
	        }
	      }
	    }
	  }, {
	    key: 'getPricesForApproval',
	    value: function getPricesForApproval(token) {
	      var _this3 = this;
	
	      return this.props.getPricesForApproval(token).then(function (res) {
	        var commentName = '';
	        var hideXButton = false;
	        if (res.data === null) {
	          _this3.setState({
	            prices: null,
	            isHandled: true,
	            CommentName: '',
	            hideXButton: true
	          });
	        } else {
	          if (res.data.CurrentUserName !== undefined && res.data.CurrentUserName !== null) {
	            commentName = res.data.CurrentUserName;
	          } else {
	            hideXButton = true; // Hide X if not logged in
	          }
	          _this3.setState({
	            prices: res.data,
	            CommentName: commentName,
	            hideXButton: hideXButton
	          }, function (res) {
	            _this3.setLanguage(_this3.state.prices.CustomerId);
	            _this3.setHeader();
	          });
	        }
	      }, function () {
	        _this3.context.router.goBack();
	      });
	    }
	  }, {
	    key: 'getPricesForShopApproval',
	    value: function getPricesForShopApproval(orderId, type, department) {
	      var _this4 = this;
	
	      return this.props.getPricesForShopApproval(orderId, type, department).then(function (res) {
	        var commentName = '';
	        if (res.data.CurrentUserName !== undefined && res.data.CurrentUserName !== null) {
	          commentName = res.data.CurrentUserName;
	        }
	        var note = res.data.Changed.Notes[0] || _this4.state.note;
	        _this4.setState({
	          prices: res.data,
	          CommentName: commentName,
	          note: note,
	          employees: res.data.Employees,
	          custommerContacts: res.data.CustommerContacts
	        }, function (res) {
	          _this4.setLanguage(_this4.state.prices.CustomerId);
	          _this4.setHeader();
	        });
	      });
	    }
	  }, {
	    key: 'setLanguage',
	    value: function setLanguage(customerId) {
	      var _this5 = this;
	
	      this.props.getCustomerLanguage(customerId).then(function (res) {
	        var language = res.data.Language;
	        if (language !== undefined && language !== null) {
	          _this5.props.setLanguage(language);
	        }
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(el) {
	      if (el === 'accept') {
	        this.props.triggerPopup(!this.state.confirm.open);
	        this.setState({
	          confirm: {
	            open: !this.state.confirm.open
	          }
	        });
	      } else {
	        this.props.triggerPopup(!this.state.reject.open);
	        this.setState({
	          reject: {
	            open: !this.state.reject.open
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'onApproveClick',
	    value: function onApproveClick() {
	      var _this6 = this;
	
	      var approveShop = function approveShop() {
	        var data = _this6.state.prices.Changed;
	        data.SendToApproval = true;
	        if (!_this6.state.prices.Changed.IsAfterEvaluation) data.SendToCustomer = true;
	        data.SelectedContacts = _this6.state.custommerContacts.concat(_this6.state.employees);
	        if (_this6.state.specificReciever && _this6.state.specificReciever.trim().length > 0) {
	          data.SelectedContacts.push({ GetMail: true, SpecificReciever: _this6.state.specificReciever });
	        }
	
	        _this6.props.updatePrices(data).then(function (res) {
	          _this6.setState({
	            Locked: true,
	            ApprovedText: _this6.state.prices.Changed.IsAddonPrice ? (0, _helpers.translation)(16831) : (0, _helpers.translation)('2333')
	          });
	          if (_this6.state.prices.OrderType === 1 && !_this6.state.prices.Changed.IsAfterEvaluation) {
	            // window.toastr.success(translation('15215'), translation('13424'))
	          } else if (_this6.state.prices.Changed.RequireCustomerApproval) {
	            // window.toastr.success(translation('2720'), translation('13424'))  // Msg: 'Price change sent to customer...' // was 2016
	            // window.toastr.success(translation('2721'), translation('13424'))  // Msg: ''
	          } else if (_this6.state.prices.Changed.IsAfterEvaluation) {
	            // window.toastr.success(translation('15217'), translation('13424'))
	          } else {
	              // window.toastr.success(translation('15215'), translation('13424'))
	            }
	
	          var router = _this6.context.router;
	          var workcardLocation = '/orders/' + router.params.orderID;
	          var routeItem = window.LocalstorageStack.findFirst([workcardLocation, '/workscreen', '/orders']);
	          if (routeItem !== null) {
	            if (routeItem.pathname === '/orders/') {
	              router.replace(routeItem.pathname + '' + router.params.orderID);
	            } else if (routeItem.pathname === '/orders') {
	              router.replace(routeItem.pathname + '?orderid=' + router.params.orderID);
	            } else {
	              router.replace(routeItem.pathname);
	            }
	          } else {
	            if (!_this6.context.router.location.pathname.includes('/orders/')) {
	              _this6.context.router.push('/orders?orderid=' + _this6.state.prices.Changed.OrderId);
	            } else {
	              _this6.props.modalCloseCB(false);
	            }
	          }
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('2009'), (0, _helpers.translation)('216'));
	          _this6.setState({
	            Locked: false
	          });
	        });
	        // })
	      };
	
	      var approveCustomer = function approveCustomer() {
	        _this6.props.approvePrices(_this6.state.prices.ApprovalToken, _this6.state.CommentName, _this6.state.CommentText).then(function (res) {
	          _this6.setState({
	            Locked: true,
	            ApprovedText: _this6.state.prices.Changed.IsAddonPrice ? (0, _helpers.translation)(16831) : (0, _helpers.translation)('2333'),
	            approvalResult: res.data
	          });
	
	          // Toastr
	          // window.toastr.success(translation('2008'), translation('13424'))
	          // this.props.router.push('/orders?orderid=' + this.state.prices.Changed.OrderId)
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('2009'), (0, _helpers.translation)('216'));
	          _this6.setState({
	            Locked: false
	          });
	        });
	      };
	
	      if (this.validateFields(0)) {
	        this.setState({
	          Locked: true
	        });
	        if (this.state.isShopApproval) {
	          approveShop();
	        } else {
	          approveCustomer();
	        }
	      }
	    }
	  }, {
	    key: 'onRejectClick',
	    value: function onRejectClick() {
	      var _this7 = this;
	
	      var rejectShop = function rejectShop() {
	        if (_this7.props.modalCloseCB === undefined || _this7.props.modalCloseCB === null) {} else {
	          _this7.props.modalCloseCB(true);
	        }
	      };
	
	      var rejectCustomer = function rejectCustomer() {
	        _this7.props.rejectPrices(_this7.state.prices.ApprovalToken, _this7.state.CommentName, _this7.state.CommentText).then(function (res) {
	          _this7.setState({
	            Locked: true,
	            ApprovedText: (0, _helpers.translation)('2334'),
	            approvalResult: res.data
	          });
	
	          // Toastr
	          // window.toastr.success(translation('2010'), translation('13424'))
	          _this7.context.router.push('/orders?orderid=' + _this7.state.prices.Changed.OrderId);
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('2011'), (0, _helpers.translation)('216'));
	          _this7.setState({
	            Locked: false
	          });
	        });
	      };
	
	      if (this.state.isShopApproval) {
	        rejectShop();
	      } else {
	        if (this.validateFields(1)) {
	          rejectCustomer();
	        }
	      }
	    }
	  }, {
	    key: 'validateFields',
	    value: function validateFields(type) {
	      if (this.state.CommentName === undefined || this.state.CommentName.trim() === '') {
	        window.toastr.error((0, _helpers.translation)('2243'), (0, _helpers.translation)('216'));
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'getActionButtons',
	    value: function getActionButtons() {
	      var asProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var isAfterEvaluation = this.state.prices.Changed.IsAfterEvaluation;
	
	      var confirmBtnText = (0, _helpers.translation)('752');
	      if (this.state.isShopApproval === true && this.state.prices.Changed.RequireCustomerApproval || isAfterEvaluation) {
	        confirmBtnText = (0, _helpers.translation)('1022');
	      }
	      if (!isAfterEvaluation && this.state.prices.OrderType === 1) {
	        confirmBtnText = (0, _helpers.translation)('752');
	      }
	
	      if (asProps) {
	        return {
	          actionLabelText: confirmBtnText,
	          onActionClick: this.handleClick.bind(this, 'accept'),
	          cancelLabelText: this.state.isShopApproval === true ? (0, _helpers.translation)('1155') : (0, _helpers.translation)('753'),
	          onCancelClick: this.handleClick.bind(this, 'reject')
	        };
	      }
	
	      return _react2.default.createElement(
	        _inline2.default,
	        { fillChildNum: [0, 1], block: true },
	        _react2.default.createElement(_button2.default, {
	          disabled: this.state.Locked,
	          onClick: this.handleClick.bind(this, 'accept'),
	          labelText: confirmBtnText
	        }),
	        _react2.default.createElement(_button2.default, {
	          style: 'alert',
	          disabled: this.state.Locked,
	          onClick: this.handleClick.bind(this, 'reject'),
	          labelText: this.state.isShopApproval === true ? (0, _helpers.translation)('1155') : (0, _helpers.translation)('753')
	        })
	      );
	    }
	  }, {
	    key: 'renderFiles',
	    value: function renderFiles(onlyPhotos) {
	      var _this8 = this;
	
	      var Files = this.state.prices.Changed.Files;
	      // let { oldFiles } = this.state
	
	      var allFiles = Files.concat(this.state.prices.Changed.SelectedOldFiles);
	      if (allFiles === undefined || allFiles === null) {
	        allFiles = [];
	      }
	      var files = allFiles;
	
	      // Render image
	      var renderImage = function renderImage(image, index) {
	        // Image key
	        var imageKey = _this8.state.imageKey + '_' + index + '_' + image.OrderFileID;
	        // Url
	        var url = _constants.FILE_STORAGE + image.ThumbURL + '?' + imageKey;
	        var fullUrl = _constants.FILE_STORAGE + image.FileURL + '?' + imageKey;
	        // set grayout class
	        var oldImgClass = 'testImg';
	        if (image.oldFile && image.checked !== true) {
	          oldImgClass += ' grayout';
	        }
	
	        if (_this8.state.isShopApproval === true) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'a',
	                { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	                _react2.default.createElement('img', { className: oldImgClass, id: image.OrderFileID, name: 'oldImages', src: url, key: imageKey })
	              )
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'a',
	                { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	                _react2.default.createElement('img', { className: 'testImg', id: image.OrderFileID, name: 'oldImages', src: url, key: imageKey })
	              )
	            )
	          );
	        }
	      };
	
	      // Render other files
	      var renderOtherFile = function renderOtherFile(file, index) {
	        if (file.OrderFile !== undefined) {
	          file = file.OrderFile;
	        }
	        // let fileUrl = file.FileURL.replace('API/', '')
	        if (file.ActualFileName === null) return null;
	        var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(_this8.props.auth.user.Token);
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	        var deleteFile = function deleteFile() {
	          _this8.setState({
	            confirmImage: file
	          });
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-document clearfix' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          _react2.default.createElement(
	            'a',
	            { target: '_BLANK', href: newFileUrl },
	            file.FileName
	          ),
	          _react2.default.createElement('img', { className: 'file-delete', src: '/images/icons/Delete_16.png', onClick: deleteFile })
	        );
	      };
	      // Filter files
	      var imgFiles = files.filter(function (file) {
	        if (file.OrderFile !== undefined) file = file.OrderFile;
	        return (file.OrderFileID !== undefined || file.Id !== undefined) && file.IsImage ? file : false;
	      });
	      var otherFiles = files.filter(function (file) {
	        if (file.OrderFile !== undefined) file = file.OrderFile;
	        return file.IsImage || file.Id === undefined && file.OrderFileID === undefined ? false : file;
	      });
	
	      if (onlyPhotos) {
	        if (imgFiles.length === 0 && otherFiles.length === 0) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'price_photo' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('1011')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          otherFiles.map(renderOtherFile),
	          _react2.default.createElement(_Gallery2.default, { files: imgFiles, renderImage: renderImage })
	        );
	      }
	    }
	  }, {
	    key: 'renderComment',
	    value: function renderComment() {
	      var _this9 = this;
	
	      var note = this.state.note;
	      // Create / Save
	
	      var onChange = function onChange(e) {
	        e.persist();
	        var value = e.target.value;
	        if (e.target.type === 'checkbox') {
	          value = e.target.checked;
	          if (e.target.name === 'NoteTypeID') {
	            value = value ? 1 : 0;
	          }
	        }
	        _this9.setState({
	          note: _extends({}, _this9.state.note, _defineProperty({}, e.target.name, value))
	        }, function () {
	          if (e.target.type === 'checkbox') {
	            createSave(e);
	          }
	        });
	      };
	      var createSave = function createSave(e) {
	        var note = _extends({}, _this9.state.note);
	        note.OrderPrices = [_this9.state.prices.Changed.OrderPriceId];
	        note.OrderID = _this9.state.prices.Changed.OrderId;
	        note.SourceID = 11; // PriceChange
	        note.NoteUserName = _this9.state.CommentName;
	        note.ApprovalToken = _this9.props.routeParams.approvalToken;
	        _this9.props.createNote(note).then(function (res) {
	          var newNote = res.data;
	          _this9.setState({
	            note: newNote
	          });
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('1917'), (0, _helpers.translation)('216'));
	        });
	      };
	      if (this.state.isShopApproval && (note.Note === undefined || note.Note === null || note.Note === '')) return null;
	      // Render
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          (0, _helpers.translation)('149')
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        !this.state.isShopApproval && _react2.default.createElement(_textarea2.default, { name: 'Note', onBlur: createSave, value: note.Note, onChange: onChange }),
	        this.state.isShopApproval && _react2.default.createElement(
	          'div',
	          null,
	          (0, _array.formatArrayToString)(note.Note)
	        )
	      );
	    }
	  }, {
	    key: 'renderSendTo',
	    value: function renderSendTo() {
	      var _this10 = this;
	
	      if (this.state.isShopApproval === false) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	
	      var contact = function contact(listName, val, key) {
	        var onChange = function onChange(e) {
	          e.persist();
	          var list = _this10.state[listName];
	          list[key][e.target.name] = e.target.checked;
	
	          _this10.setState(_defineProperty({}, listName, list));
	        };
	        return _react2.default.createElement(
	          _inline2.default,
	          { key: key, fillChildNum: [0], block: true },
	          val.Name,
	          _react2.default.createElement(_check2.default, { simple: true, name: 'GetMail', onChange: onChange, checked: val.GetMail, disabled: val.HasMail === false, onClick: function onClick() {
	              return val.HasMail === false ? window.toastr.error((0, _helpers.translation)('2727'), (0, _helpers.translation)('216')) : '';
	            } }),
	          _react2.default.createElement(_check2.default, { simple: true, name: 'GetPhone', onChange: onChange, checked: val.GetPhone, disabled: val.HasPhone === false, onClick: function onClick() {
	              return val.HasPhone === false ? window.toastr.error((0, _helpers.translation)('2728'), (0, _helpers.translation)('216')) : '';
	            } })
	        );
	      };
	
	      // Render
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          (0, _helpers.translation)('2726')
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        _react2.default.createElement(
	          'ul',
	          { className: 'notifications__list' },
	          _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('13601'), defaultOpen: true },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement('span', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('1052')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('15')
	              )
	            ),
	            this.state.custommerContacts.map(contact.bind(this, 'custommerContacts'))
	          ),
	          _react2.default.createElement(_divider2.default, { noLine: true, size: 2 }),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('16664') },
	            this.state.employees.map(contact.bind(this, 'employees'))
	          ),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          _react2.default.createElement(_text2.default, { labelText: 1052, value: this.state.specificReciever, onChange: function onChange(e) {
	              _this10.setState({ specificReciever: e.target.value });
	            } })
	        )
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this11 = this;
	
	      var price = !this.state.prices.Original ? this.state.prices.Changed : this.state.prices.Original;
	      var orderId = price.OrderId;
	
	      var hasCommentAndFilePermission = true;
	
	      if (orderId === undefined || orderId === null) {
	        return null;
	      }
	      var pices = [this.state.prices.OrderRegNr, (0, _helpers.translation)('' + this.state.prices.OrderBrand === '2000' ? '' : this.state.prices.OrderBrand), this.state.prices.OrderModel];
	      pices = pices.filter(function (x) {
	        return x !== '' && x !== ' ' && x !== null;
	      });
	      if (pices.length === 0) {
	        pices = [this.props.orderId];
	      }
	      // Text below title. Texts for shop approval, customer approval of price change, and text for shop approval of after evaluation.
	      var text = this.props.RequireCustomerApproval ? (0, _helpers.translation)('2711') : (0, _helpers.translation)('2013');
	      if (this.state.prices.Changed.IsAfterEvaluation) {
	        text = (0, _helpers.translation)(15205);
	      } else if (this.state.prices.Changed.IsEvaluation) {
	        text = (0, _helpers.translation)(16665);
	      } else if (this.state.prices.Changed.IsAddonPrice) {
	        text = (0, _helpers.translation)(16826);
	      } else if (this.state.prices.OrderType === 1) {
	        // no matter what, insurance orders should not be send to the customer
	        text = (0, _helpers.translation)('15229');
	      }
	      text = text.replace('[OrderId]', orderId);
	
	      var title = (0, _helpers.translation)('2014') + ('\n' + pices.join(', '));
	      if (title.includes('[OrderId]')) {
	        price.OrderId !== undefined ? title = title.replace('[OrderId]', price.OrderId) : title = title.replace('[OrderId]', this.props.orderId);
	      }
	      if (text.includes('[OrderId]')) {
	        price.OrderId !== undefined ? text = text.replace('[OrderId]', price.OrderId) : text = text.replace('[OrderId]', this.props.orderId);
	      }
	
	      var deliveryText = '';
	      var approval = this.state.approvalResult;
	      if (approval !== undefined && approval !== null && approval.Success) {
	        if (approval.DeliveryTimeChanged) {
	          deliveryText = (0, _helpers.translation)('2722').replace('[DeliveryTime]', (0, _time.renderFullDate)(approval.DeliveryTime)); // Note: the delivery time is changed to [DeliveryTime]!
	        } else {
	          deliveryText = (0, _helpers.translation)('2725');
	        }
	      }
	
	      // console.log(this.state.approvalResult, deliveryText)
	      var original = !this.state.prices.Original ? this.state.prices.Changed : this.state.prices.Original;
	      var changed = this.state.prices.Changed;
	      var isTheSame = Number(original.OrderPriceId) === Number(changed.OrderPriceId);
	      var isAfterEvaluation = changed.IsAfterEvaluation;
	      var isEvaluation = changed.IsEvaluation;
	      var isAddonPrice = changed.IsAddonPrice;
	
	      var renderOrderInfo = function renderOrderInfo() {
	        var customer = _this11.state.prices.Customer;
	        var shop = _this11.state.prices.Shop;
	        if (customer === null || shop === null) return null;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('13420')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            _grid2.default,
	            { align: 'start' },
	            _react2.default.createElement(
	              'div',
	              null,
	              customer.Name
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              shop.Name
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { aling: 'start' },
	            _react2.default.createElement(
	              'div',
	              null,
	              customer.Address
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              shop.Address
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { align: 'start' },
	            _react2.default.createElement(
	              'div',
	              null,
	              customer.Zip,
	              ' ',
	              customer.City ? ',' : '',
	              ' ',
	              customer.City
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              shop.Zip,
	              shop.City ? ',' : '',
	              ' ',
	              shop.City
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { align: 'start' },
	            _react2.default.createElement(
	              'div',
	              null,
	              customer.PhoneCode,
	              ' ',
	              customer.Phone
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              shop.PhoneCode,
	              ' ',
	              shop.Phone
	            )
	          )
	        );
	      };
	
	      var carData = function carData() {
	        var customer = _this11.state.prices.Customer;
	        var shop = _this11.state.prices.Shop;
	        if (customer === null || shop === null) return null;
	
	        var orderBrand = _this11.state.prices.OrderBrand;
	        var orderChassisNr = _this11.state.prices.OrderChassisNr;
	        var orderModel = _this11.state.prices.OrderModel;
	        var orderRegNr = _this11.state.prices.OrderRegNr;
	        var orderRekvNr = _this11.state.prices.OrderRekvNr;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('77')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            (0, _helpers.translation)('145'),
	            (0, _helpers.translation)(orderBrand)
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            (0, _helpers.translation)('146'),
	            orderModel
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            (0, _helpers.translation)('2005'),
	            orderRegNr
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            (0, _helpers.translation)('81'),
	            orderChassisNr
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            (0, _helpers.translation)('1337'),
	            orderRekvNr
	          )
	        );
	      };
	
	      var changedBy = function changedBy() {
	        if (_this11.state.isShopApproval) return null;
	        // console.log(this.state)
	        var createdBy = _this11.state.prices.Changed.CreatedBy;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)(2713)
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            createdBy && _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              _react2.default.createElement(_UserInfo2.default, { user: createdBy.UserInfo }),
	              (createdBy.Email !== null && createdBy.Email.length > 0 || createdBy.Phone !== null && createdBy.Phone.length > 0) && _react2.default.createElement(_HelpText2.default, { className: 'helpText', text: createdBy.Email + '\n' + createdBy.Phone })
	            ),
	            _this11.state.prices.Changed.Notes && _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              _this11.state.prices.Changed.Notes !== undefined && _this11.state.prices.Changed.Notes.length > 0 && _this11.state.prices.Changed.Notes[0].Note || ''
	            )
	          )
	        );
	      };
	
	      var onChange = function onChange(e) {
	        _this11.setState(_defineProperty({}, e.target.name, e.target.value));
	      };
	
	      if (!this.state.Locked) {
	        // console.log('priceapproval state: ', this.state, 'props', this.props)
	        var confirmText = '';
	        var rejectText = '';
	
	        if (this.state.isShopApproval && this.state.prices.Changed.RequireCustomerApproval) {
	          confirmText = this.state.prices.Changed.IsAddonPrice ? (0, _helpers.translation)(16827) : (0, _helpers.translation)(2723);
	          rejectText = this.state.prices.Changed.IsAddonPrice ? (0, _helpers.translation)(16828) : (0, _helpers.translation)(2724);
	        } else {
	          confirmText = this.state.prices.Changed.IsAddonPrice ? (0, _helpers.translation)(16830) : (0, _helpers.translation)(15216);
	          rejectText = this.state.prices.Changed.IsAddonPrice ? (0, _helpers.translation)(16829) : (0, _helpers.translation)(2724);
	        }
	
	        var willSendToCustomers = Array.isArray(this.state.custommerContacts) && this.state.custommerContacts.some(function (c) {
	          return c.GetMail || c.GetPhone;
	        });
	        if (this.state.prices.Changed.IsAfterEvaluation) {
	          // if (this.state.prices.Changed.SendToCustomer) {
	          if (willSendToCustomers) {
	            confirmText = (0, _helpers.translation)(15218);
	            rejectText = (0, _helpers.translation)(15219);
	          } else {
	            confirmText = (0, _helpers.translation)(15220);
	            rejectText = (0, _helpers.translation)(15219);
	          }
	        } else if (this.state.prices.Changed.IsEvaluation) {
	          confirmText = (0, _helpers.translation)(16666);
	          rejectText = (0, _helpers.translation)(16667);
	        } // else if (this.state.prices.OrderType === 1) {
	        //   confirmText = translation(15216)
	        //   rejectText = translation(2724)
	        // }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'priceapprove__screen--inner' },
	          _react2.default.createElement(
	            _col2.default,
	            { span: '2' },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: title },
	              _react2.default.createElement(
	                'div',
	                null,
	                text,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null)
	              ),
	              renderOrderInfo(),
	              changedBy(),
	              carData(),
	              this.renderPrice('first', original, isAfterEvaluation || isEvaluation ? (0, _helpers.translation)(15206) : (0, _helpers.translation)(2006), isTheSame, isAfterEvaluation || isEvaluation),
	              this.renderPrice('second', changed, isAfterEvaluation || isEvaluation ? (0, _helpers.translation)(15172) : isAddonPrice ? (0, _helpers.translation)(1045) : (0, _helpers.translation)(2007), false, isAfterEvaluation || isEvaluation),
	              hasCommentAndFilePermission && this.renderComment(),
	              hasCommentAndFilePermission && this.renderFiles(true),
	              this.renderSendTo(),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  (0, _helpers.translation)('752')
	                ),
	                _react2.default.createElement(_divider2.default, null),
	                this.renderHandledBy()
	              ),
	              !this.props.renderModal && _react2.default.createElement(_divider2.default, { size: 3, noLine: true }),
	              !this.props.renderModal && this.getActionButtons(),
	              this.state.confirm.open && _react2.default.createElement(
	                _Portal2.default,
	                { className: 'deleteModal', onPortalClose: this.onPortalClose.bind(this, 'confirm') },
	                _react2.default.createElement(_Confirm2.default, {
	                  renderText: function renderText() {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'pg-pb-2' },
	                      confirmText
	                    );
	                  },
	                  confirm: this.onApproveClick,
	                  notConfirm: this.onPortalClose.bind(this, 'confirm')
	                })
	              ),
	              this.state.reject.open && _react2.default.createElement(
	                _Portal2.default,
	                { className: 'deleteModal', onPortalClose: this.onPortalClose.bind(this, 'reject') },
	                _react2.default.createElement(_Confirm2.default, {
	                  renderText: function renderText() {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'pg-pb-2' },
	                      rejectText
	                    );
	                  },
	                  confirm: this.onRejectClick,
	                  notConfirm: this.onPortalClose.bind(this, 'reject')
	                })
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'priceapprove__screen--inner' },
	          _react2.default.createElement(
	            _col2.default,
	            { span: '2' },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: title },
	              _react2.default.createElement(
	                'div',
	                null,
	                text,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'deliveryText' },
	                  deliveryText
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null)
	              ),
	              renderOrderInfo(),
	              hasCommentAndFilePermission && this.renderFiles(true),
	              this.renderPrice('first', original, isAfterEvaluation || isEvaluation ? (0, _helpers.translation)(15206) : (0, _helpers.translation)(2006)),
	              this.renderPrice('second', changed, isAddonPrice ? (0, _helpers.translation)(1045) : (0, _helpers.translation)('2007')),
	              _react2.default.createElement(
	                'h3',
	                null,
	                (0, _helpers.translation)('752')
	              ),
	              _react2.default.createElement(_divider2.default, null),
	              _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('30'), name: 'CommentName', id: 'CommmentName', disabled: this.state.Locked, defaultValue: this.state.CommentName, onChange: onChange }),
	              _react2.default.createElement(
	                'div',
	                { className: 'button_bar', style: { alignItems: 'center', textAlign: 'center' } },
	                this.state.ApprovedText
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderHandledBy',
	    value: function renderHandledBy() {
	      var _this12 = this;
	
	      if (this.state.prices.CurrentUserName !== null) {
	        if (this.state.isShopApproval) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('13564'),
	            ' ',
	            this.state.CommentName
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('2712'),
	            ' ',
	            this.state.CommentName
	          );
	        }
	      } else {
	        return _react2.default.createElement(
	          _inline2.default,
	          { block: true },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('2712')
	          ),
	          _react2.default.createElement(_text2.default, { value: this.state.CommentName, onChange: function onChange(e) {
	              _this12.setState({ CommentName: e.target.value });
	            } })
	        );
	      }
	    }
	  }, {
	    key: 'renderPartTasks',
	    value: function renderPartTasks(part, key) {
	      var _this13 = this;
	
	      var renderTask = function renderTask(task, key) {
	        var price = _this13.state.toggleGross ? task.Gross : task.Net;
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [1], block: true, key: 'task_' + key },
	          '\xA0\xA0\xA0-',
	          task.TaskName,
	          (0, _currency.formatCurrency)(price)
	        );
	      };
	      var renderEstimationTask = function renderEstimationTask(task, key) {
	        var extraTasks = '';
	        var extraText = '';
	        if (typeof task.EstimationTaskId !== 'undefined') {
	          extraText = task.Extent === null ? '' : task.Extent.Type;
	          var thousandClass = task.EstimationTaskId === 0 && extraText === '' ? 'alone' : '';
	          extraTasks = _react2.default.createElement(
	            'div',
	            { className: 'extraThousands ' + thousandClass },
	            task.Extras && task.Extras.map(function (val, key) {
	              var valMatText = '';
	              if (_this13.props.showAE) {
	                if (val.AE !== 0 || val.Material !== 0) {
	                  var commaSep = '';
	                  if (val.AE !== 0 && val.Material !== 0) commaSep = ', ';
	                  valMatText += '(';
	                  if (val.AE !== 0) valMatText += val.AE + ' ' + (0, _helpers.translation)('885');
	                  valMatText += commaSep;
	                  if (val.Material !== 0) valMatText += val.Material + ' ' + (0, _helpers.translation)('13338');
	                  valMatText += ')';
	                }
	              }
	              var content = val.Name + ' ' + valMatText;
	              return _react2.default.createElement(
	                'div',
	                { key: key },
	                content
	              );
	            })
	          );
	        }
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: 'task_' + key },
	          _react2.default.createElement(
	            'div',
	            null,
	            '\xA0\xA0\xA0- ',
	            task.TaskName,
	            ' ',
	            extraText
	          ),
	          extraTasks
	        );
	      };
	
	      var partName = part.Part.Name;
	      var side = '';
	      var frontBack = '';
	
	      if (part.Part.PartItemId === 0) {
	        partName = (0, _helpers.translation)('227');
	      }
	
	      if (part.Part.TaskSide !== 0) {
	        switch (part.Part.TaskSide) {
	          case 1:
	            side = (0, _helpers.translation)('213'); // Left
	            break;
	          case 2:
	            side = (0, _helpers.translation)('214'); // Right
	            break;
	          case 5:
	            side = (0, _helpers.translation)('213'); // Left
	            frontBack = (0, _helpers.translation)('287'); // Front
	            break;
	          case 6:
	            side = (0, _helpers.translation)('214'); // Right
	            frontBack = (0, _helpers.translation)('287'); // Front
	            break;
	          case 7:
	            side = (0, _helpers.translation)('213'); // Left
	            frontBack = (0, _helpers.translation)('288'); // Back
	            break;
	          case 8:
	            side = (0, _helpers.translation)('214'); // Right
	            frontBack = (0, _helpers.translation)('288'); // Back
	            break;
	        }
	      }
	
	      var hasTasks = part.Tasks !== null && part.Tasks.length > 0;
	      var tasks = part.Tasks;
	      var PNumber = part.Part.PNumber ? '(' + part.Part.PNumber + ')' : '';
	      var estimationTasks = part.EstimationTasks;
	      var hasEstimationTasks = estimationTasks !== null && estimationTasks.length > 0;
	      return _react2.default.createElement(
	        'li',
	        { key: 'part_' + key },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'price-approval_partname' },
	                side,
	                ' ',
	                partName,
	                ' ',
	                frontBack,
	                ' ',
	                PNumber
	              )
	            ),
	            _react2.default.createElement('div', { className: 'right' })
	          ),
	          hasTasks && tasks.map(renderTask),
	          hasEstimationTasks && estimationTasks.map(renderEstimationTask)
	        )
	      );
	    }
	  }, {
	    key: 'renderAddonPart',
	    value: function renderAddonPart(addon, key) {
	      var price = this.state.toggleGross ? addon.Price : addon.Net;
	      return _react2.default.createElement(
	        _inline2.default,
	        { fillChildNum: [0], block: true, key: 'addonpart_' + key },
	        addon.Name,
	        (0, _currency.formatCurrency)(price)
	      );
	    }
	  }, {
	    key: 'renderAddonStartTime',
	    value: function renderAddonStartTime(addon, key) {
	      var price = this.state.toggleGross ? addon.Price : addon.Net;
	      return _react2.default.createElement(
	        _inline2.default,
	        { fillChildNum: [0], block: true, key: 'addonstarttime_' + key },
	        addon.Name,
	        (0, _currency.formatCurrency)(price)
	      );
	    }
	  }, {
	    key: 'renderExtraOrService',
	    value: function renderExtraOrService(service, key) {
	      var price = this.state.toggleGross ? service.Total : service.Net;
	      var count = service.Count > 1 ? '(' + service.Count + ' ' + (0, _helpers.translation)('1443') + ')' : '';
	      return _react2.default.createElement(
	        _inline2.default,
	        { fillChildNum: [0], block: true, key: (service.IsExtra ? 'extra' : 'service') + '_' + key },
	        service.TaskName + ' ' + count,
	        (0, _currency.formatCurrency)(price)
	      );
	    }
	  }, {
	    key: 'toggleGross',
	    value: function toggleGross() {
	      this.setState({ toggleGross: !this.state.toggleGross });
	    }
	  }, {
	    key: 'renderPrice',
	    value: function renderPrice(location, price, title, isTheSame, isAfterEvaluation) {
	      var isReport = location === 'first' && isAfterEvaluation && price.Report !== null && price.Report.ReportId !== 0;
	      if (isReport) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'extent-content' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            title
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          price.Report.ReportType === 3 ? _react2.default.createElement(_AssessmentDBS2.default, { order: this.state.prices, showPrices: true, showAE: true }) : _react2.default.createElement(_AssessmentForsi2.default, { order: this.state.prices, showPrices: true, showAE: true })
	        );
	      }
	
	      if (isAfterEvaluation && !isReport) {
	        if (isTheSame) return null;
	        // Show estimation component.
	        return _react2.default.createElement(
	          'div',
	          { className: 'extent-content' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            title
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(_Estimation2.default, {
	            overrideInnerTitle: '',
	            orderPrice: price,
	            partTasks: this.props.priceInformation || this.state.priceInformation,
	            editable: false
	          })
	        );
	      }
	      var hasParts = price.Parts !== undefined && price.Parts !== null && price.Parts.length > 0;
	      var hasExtras = price.Extras !== undefined && price.Extras !== null && price.Extras.length > 0;
	      var hasServices = price.Services !== undefined && price.Services !== null && price.Services.length > 0;
	      var hasAddonParts = price.OrderAddonParts !== undefined && price.OrderAddonParts !== null && price.OrderAddonParts.length > 0;
	      var hasAddonStartTimes = price.OrderAddonStartTimes !== undefined && price.OrderAddonStartTimes !== null && price.OrderAddonStartTimes.length > 0;
	      var hasPriceInformation = !!(this.props.priceInformation || this.state.priceInformation);
	      var netp = price.Net;
	      var gross = price.Gross;
	      var env = price.Environment;
	      var startPrice = this.state.toggleGross ? price.StartPrice : price.StartPriceNet;
	      var hasTotalAndNoOtherPrice = netp === 0 && gross === 0 && (price.Total !== 0 || env !== 0);
	      var isInsuranceNoPrice = this.state.prices.OrderType === 1 && netp === 0 && gross === 0 && price.Total === 0 && env === 0;
	      var showGrossNet = !isAfterEvaluation && !price.UseEstimation && !(hasTotalAndNoOtherPrice || isInsuranceNoPrice);
	
	      var renderGross = function renderGross() {
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true, key: 'gross' },
	          (0, _helpers.translation)('13350'),
	          (0, _currency.formatCurrency)(gross)
	        );
	      };
	
	      var renderNet = function renderNet() {
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true, key: 'netp' },
	          (0, _helpers.translation)('1305'),
	          (0, _currency.formatCurrency)(netp)
	        );
	      };
	
	      var renderTotal = function renderTotal() {
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true, key: 'total' },
	          (0, _helpers.translation)('641'),
	          (0, _currency.formatCurrency)(price.Total)
	        );
	      };
	
	      var renderEnv = function renderEnv() {
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true, key: 'env' },
	          (0, _helpers.translation)('13339'),
	          (0, _currency.formatCurrency)(env)
	        );
	      };
	
	      var renderSpacing = function renderSpacing() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'clearfix totals-spacing' },
	          '\xA0'
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'priceview ' },
	        showGrossNet && _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true },
	          _react2.default.createElement(
	            'h3',
	            null,
	            title
	          ),
	          _react2.default.createElement(_button2.default, { style: 'link', size: 'm', onClick: this.toggleGross, labelText: (0, _helpers.translation)(this.state.toggleGross ? '13350' : '1305') })
	        ),
	        !showGrossNet && _react2.default.createElement(
	          'h3',
	          null,
	          title
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        _react2.default.createElement(
	          'ul',
	          null,
	          startPrice > 0 && _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            (0, _helpers.translation)('1285'),
	            (0, _currency.formatCurrency)(startPrice)
	          ),
	          hasParts && price.Parts.map(this.renderPartTasks),
	          hasExtras && price.Extras.map(this.renderExtraOrService),
	          hasServices && price.Services.map(this.renderExtraOrService),
	          hasAddonParts && price.OrderAddonParts.map(this.renderAddonPart),
	          hasAddonStartTimes && price.OrderAddonStartTimes.map(this.renderAddonStartTime),
	          hasPriceInformation && _react2.default.createElement(_EstimationsList2.default, { priceInformation: this.props.priceInformation || this.state.priceInformation, price: price }),
	          !isAfterEvaluation && showGrossNet && renderSpacing(),
	          !isAfterEvaluation && showGrossNet && renderEnv(),
	          !isAfterEvaluation && showGrossNet && renderNet(),
	          !isAfterEvaluation && showGrossNet && renderGross(),
	          !isAfterEvaluation && !showGrossNet && renderSpacing(),
	          !isAfterEvaluation && !showGrossNet && renderTotal(),
	          !isAfterEvaluation && !showGrossNet && renderEnv()
	        )
	      );
	    }
	  }, {
	    key: 'renderLeftBefore',
	    value: function renderLeftBefore() {
	      return _react2.default.createElement(_icon2.default, { icon: _icons.GeneralIcons.Apromas_Logo, size: 'l' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this14 = this;
	
	      if (!this.state.isHandled && (this.state.prices === undefined || this.state.prices === null)) return null;
	
	      var headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	        if (!_this14.props.auth.isAuthenticated || _this14.state.hideXButton === true) return null;
	        var goBack = function goBack() {
	          _this14.context.router.goBack();
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_closeButton2.default, { spacing: 0, ariaLabel: t('2060'), onClick: goBack })
	        );
	      };
	
	      if (this.state.isHandled) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'priceapprove__screen' },
	          _react2.default.createElement(_Header2.default, { router: this.context.router, renderLeftBefore: this.renderLeftBefore, title: (0, _helpers.translation)('2012'), icon: 'menu/Prices-White.png', showBack: true, headerButtonsGoBack: headerButtonsGoBack }),
	          _react2.default.createElement(
	            'div',
	            { className: 'middle' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('13039')
	            )
	          )
	        );
	      }
	
	      if (this.props.renderModal !== undefined && this.props.renderModal) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'priceapprove__screen' },
	          this.renderContent()
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'priceapprove__screen' },
	          _react2.default.createElement(_Header2.default, { router: this.context.router, renderLeftBefore: this.renderLeftBefore, title: (0, _helpers.translation)('2012'), icon: 'menu/Prices-White.png', showBack: true, headerButtonsGoBack: headerButtonsGoBack }),
	          this.renderContent()
	        );
	      }
	    }
	  }]);
	
	  return PriceApproval;
	}(_react.Component);
	
	PriceApproval.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	PriceApproval.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  getPricesForShopApproval: _orderPrice.getPricesForShopApproval,
	  getPricesForApproval: _orderPrice.getPricesForApproval,
	  approvePrices: _orderPrice.approvePrices,
	  rejectPrices: _orderPrice.rejectPrices,
	  getCustomerLanguage: _common.getCustomerLanguage,
	  setLanguage: _actions.setLanguage,
	  uploadMultipleFiles: _orders.uploadMultipleFiles,
	  updatePrices: _orderPrice.updatePrices,
	  getPriceInformations: _priceModel.getPriceInformations,
	  createNote: _notes.createNote,
	  getOrderFiles: _orders.getOrderFiles,
	  deleteFileFromOrder: _orders.deleteFileFromOrder,
	  UpdateOrderFileSelection: _orders.UpdateOrderFileSelection
	})(PriceApproval);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1464);
	
	var _constants = __webpack_require__(5);
	
	var _settings = __webpack_require__(51);
	
	var _auth = __webpack_require__(68);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _null = __webpack_require__(236);
	
	var _null2 = _interopRequireDefault(_null);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ProductNumbers = __webpack_require__(967);
	
	var _ProductNumbers2 = _interopRequireDefault(_ProductNumbers);
	
	var _auth2 = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Constants
	
	
	// Actions
	
	
	// Elements
	
	
	// Components
	
	
	// Utils
	
	
	var DICT_HANDLED_IN_APROMAS = 17868;
	var DICT_HANDLED_IN_DRACAR = 17869;
	var DICT_HANDLED_IN_AUTOLINE = 18142;
	
	var Invoicing = function (_Component) {
	  _inherits(Invoicing, _Component);
	
	  function Invoicing(props) {
	    _classCallCheck(this, Invoicing);
	
	    var _this = _possibleConstructorReturn(this, (Invoicing.__proto__ || Object.getPrototypeOf(Invoicing)).call(this, props));
	
	    _this.state = {
	      Invoicing: {
	        ShopId: 0,
	        IsPaintshop: false,
	        TransferWorkHoursAsUnitPrice: false,
	        AccountingSystem: 0,
	        EconomicDepartment: 0,
	        EconomicDepartmentType: 0,
	        VismaNetDepartment: 0,
	        VismaNetDepartmentType: 0,
	        HeliosTransferLWTIdCode: false,
	        HeliosNumber: '',
	        EconomicId: '',
	        EconomicUserName: '',
	        EconomicPassword: '',
	        EconomicWebHook: '',
	        EconomicToken: '',
	        EconomicAuthUrl: '',
	        // new Visma.net
	        VismaNetToken: '',
	        VismaNetAuthUrl: '',
	
	        C5Ftp: '',
	        TFSOUserName: '',
	        TFSOPassword: '',
	        TFSODepartmentNumber: null,
	        DracarInvoiceLaborTotal: false,
	        DracarInvoiceUnitsTotal: false,
	        DracarInvoiceLaborTotalCode: null,
	        UseDracarSparePartCreation: false,
	        InsuranceCompanyTypeInDracar: 0,
	        DracarJobFeeSettings: []
	      },
	      DracarStores: {
	        ShopId: 0,
	        DracarCompanyStores: []
	      },
	      DracarStoreNew: {
	        StoreName: '',
	        StoreId: '',
	        EnterpriseId: '',
	        IsDeleted: false
	      },
	      Confirm: {
	        deleteKey: 0,
	        Show: false
	      },
	      PNumberAccountingSystem: 0,
	      SelectedHeadlineField: -1,
	      SelectedText1Field: -1,
	      SelectedText2Field: -1,
	      SelectedOtherReferencesField: -1,
	      SelectedReferenceField: -1,
	      SelectedInvoiceTextField: -1,
	      SelectedCustomerOrderIdField: -1,
	      SelectedExternalReferenceField: -1,
	      SelectedExtraLinesField: -1,
	      SelectedCommentField: -1,
	      HeadlineFields: [],
	      Text1Fields: [],
	      Text2Fields: [],
	      OtherReferencesFields: [],
	      ReferenceFields: [],
	      InvoiceTextFields: [],
	      CustomerOrderIdFields: [],
	      ExternalReferenceFields: [],
	      ExtraLinesFields: [],
	      CommentFields: []
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onAccountingSystemChange = _this.onAccountingSystemChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.allFieldsFilledIn = _this.allFieldsFilledIn.bind(_this);
	    _this.confirmDelete = _this.confirmDelete.bind(_this);
	    _this.notConfirm = _this.notConfirm.bind(_this);
	    _this.getAccountingSystemName = _this.getAccountingSystemName.bind(_this);
	    _this.onFieldChange = _this.onFieldChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Invoicing, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getInvoicingInformation();
	      this.getDracarStores();
	      this.getAccountingSystemField();
	    }
	  }, {
	    key: 'getInvoicingInformation',
	    value: function getInvoicingInformation() {
	      var _this2 = this;
	
	      this.props.getInvoicingInformation(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          Invoicing: {
	            ShopId: res.data.ShopId,
	            IsPaintshop: res.data.IsPaintshop,
	            AccountingSystem: res.data.AccountingSystem,
	            EconomicDepartment: res.data.EconomicDepartment,
	            EconomicDepartmentType: res.data.EconomicDepartmentType,
	            TransferWorkHoursAsUnitPrice: res.data.TransferWorkHoursAsUnitPrice,
	            // Visma.net
	            VismaNetDepartment: res.data.VismaNetDepartment,
	            VismaNetDepartmentType: res.data.VismaNetDepartmentType,
	            HeliosNumber: res.data.HeliosNumber,
	            EconomicId: res.data.EconomicId,
	            EconomicUserName: res.data.EconomicUserName,
	            EconomicPassword: res.data.EconomicPassword,
	            EconomicWebHook: res.data.EconomicWebHook,
	            EconomicToken: res.data.EconomicToken,
	            EconomicAuthUrl: res.data.EconomicAuthUrl,
	            // Visma.net
	            VismaNetToken: res.data.VismaNetToken,
	            VismaNetAuthUrl: res.data.VismaNetAuthUrl,
	
	            C5Ftp: res.data.C5Ftp,
	            DracarJobFeeSettings: res.data.DracarJobFeeSettings,
	            DracarInvoiceLaborTotal: res.data.DracarInvoiceLaborTotal,
	            DracarInvoiceLaborTotalCode: res.data.DracarInvoiceLaborTotalCode,
	            DracarInvoiceUnitsTotal: res.data.DracarInvoiceUnitsTotal,
	            UseDracarSparePartCreation: res.data.UseDracarSparePartCreation,
	            InsuranceCompanyTypeInDracar: res.data.InsuranceCompanyTypeInDracar,
	            TFSOUserName: res.data.TFSOUserName,
	            TFSOPassword: res.data.TFSOPassword,
	            TFSODepartmentNumber: res.data.TFSODepartmentNumber
	          },
	          PNumberAccountingSystem: res.data.AccountingSystem
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getDracarStores',
	    value: function getDracarStores() {
	      var _this3 = this;
	
	      this.props.getDracarStores(this.props.auth.user.ShopId).then(function (res) {
	        _this3.setState({
	          DracarStores: {
	            ShopId: res.data.ShopId,
	            DracarCompanyStores: res.data.DracarCompanyStores
	          }
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getAccountingSystemField',
	    value: function getAccountingSystemField() {
	      var _this4 = this;
	
	      var positions = [{
	        'id': 0,
	        'key': 'HeadlineFields'
	      }, {
	        'id': 1,
	        'key': 'Text1Fields'
	      }, {
	        'id': 2,
	        'key': 'Text2Fields'
	      }, {
	        'id': 3,
	        'key': 'OtherReferencesFields'
	      }, {
	        'id': 4,
	        'key': 'ReferenceFields'
	      }, {
	        'id': 5,
	        'key': 'InvoiceTextFields'
	      }, {
	        'id': 6,
	        'key': 'CustomerOrderIdFields'
	      }, {
	        'id': 7,
	        'key': 'ExternalReferenceFields'
	      }, {
	        'id': 8,
	        'key': 'ExtraLinesFields'
	      }, {
	        'id': 9,
	        'key': 'CommentFields'
	      }];
	
	      positions.forEach(function (position) {
	        _this4.setState(_defineProperty({}, position.key, []));
	      });
	
	      this.props.getAccountingSystemField().then(function (res) {
	        res.data.forEach(function (element) {
	          var key = positions[element.Position].key;
	          _this4.setState(_defineProperty({}, key, [].concat(_toConsumableArray(_this4.state[key]), [element])));
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'allFieldsFilledIn',
	    value: function allFieldsFilledIn(fields) {
	      var Invoicing = this.state.Invoicing;
	
	      var filledIn = true;
	
	      if (Array.isArray(fields)) {
	        fields.forEach(function (field) {
	          var storeField = Invoicing[field];
	
	          if (storeField) {
	            switch ((typeof storeField === 'undefined' ? 'undefined' : _typeof(storeField)).toLocaleLowerCase()) {
	              case 'string':
	                if (storeField.replace(/\s/g, '').length === 0) {
	                  filledIn = false;
	                }
	                break;
	              default:
	                break;
	            }
	          } else {
	            filledIn = false;
	          }
	        });
	      } else {
	        filledIn = false;
	      }
	
	      return filledIn;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this5 = this;
	
	      e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'radio' || e.target.type === 'checkbox') {
	        var typesToConvert = ['AccountingSystem', 'EconomicDepartment', 'VismaNetDepartment', 'InsuranceCompanyTypeInDracar'];
	        if (e.target.type === 'checkbox') {
	          value = e.target.checked;
	        } else if (typesToConvert.includes(e.target.name)) {
	          value = parseInt(value);
	        } else {
	          value = e.target.value === 'yes';
	        }
	
	        if (e.target.name === 'EconomicUseCustomDepartment') {
	          value = e.target.checked ? -1 : 0;
	          this.setState({
	            Invoicing: _extends({}, this.state.Invoicing, {
	              EconomicDepartment: value
	            })
	          }, function () {
	            _this5.onBlur(e);
	          });
	        } else if (e.target.name === 'VismaNetUseCustomDepartment') {
	          value = e.target.checked ? -1 : 0;
	          this.setState({
	            Invoicing: _extends({}, this.state.Invoicing, {
	              VismaNetDepartment: value
	            })
	          }, function () {
	            _this5.onBlur(e);
	          });
	        } else {
	          this.setState({
	            Invoicing: _extends({}, this.state.Invoicing, _defineProperty({}, e.target.name, value))
	          }, function () {
	            _this5.onBlur(e);
	          });
	        }
	      } else {
	        if (e.target.name.startsWith('DType')) {
	          var name = e.target.name.substring(5);
	          var index = this.state.Invoicing.DracarJobFeeSettings.findIndex(function (x) {
	            return x.DType === parseInt(name);
	          });
	          var fees = this.state.Invoicing.DracarJobFeeSettings;
	          fees[index].DNumber = value;
	          this.setState({
	            Invoicing: _extends({}, this.state.Invoicing, {
	              DracarJobFeeSettings: fees
	            })
	          });
	        } else if (e.target.name.startsWith('DracarStore')) {
	          var _name = e.target.name.substring(11);
	          this.setState({
	            DracarStoreNew: _extends({}, this.state.DracarStoreNew, _defineProperty({}, _name, e.target.value))
	          });
	        } else {
	          if (e.target.name === 'TFSODepartmentNumber') {
	            value = value.trim();
	            value = value.length > 0 ? parseInt(value) : null;
	          }
	          this.setState({
	            Invoicing: _extends({}, this.state.Invoicing, _defineProperty({}, e.target.name, value))
	          });
	        }
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this6 = this;
	
	      var updateState = void 0;
	      if (e.target.name === 'AccountingSystem' || e.target.name === 'AccountingSystem_KeyLoop') updateState = true;
	      this.props.saveInvoicingInformation(this.state.Invoicing).then(function (res) {
	        if (updateState) {
	          _this6.setState({
	            PNumberAccountingSystem: res.data.AccountingSystem
	          });
	          // Fetch token resources again to get updated data on invoicing system.
	          _this6.props.getAuthResources();
	        }
	        // Toastr (replace dict. key)
	        // window.toastr.success(translation('1724'), translation('13424'))
	
	        _this6.getAccountingSystemField();
	      }, function () {
	        // Toastr (replace dict. key)
	        window.toastr.error((0, _helpers.translation)('1725'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'notConfirm',
	    value: function notConfirm() {
	      this.setState({
	        Confirm: _extends({}, this.state.Confirm, {
	          Show: false
	        })
	      });
	    }
	  }, {
	    key: 'confirmDelete',
	    value: function confirmDelete() {
	      var _this7 = this;
	
	      this.setState({
	        Confirm: _extends({}, this.state.Confirm, {
	          Show: false
	        })
	      });
	      var key = this.state.Confirm.deleteKey;
	      var DracarStores = this.state.DracarStores;
	
	      var DracarCompanyStores = [].concat(_toConsumableArray(DracarStores.DracarCompanyStores));
	      DracarCompanyStores[key].IsDeleted = true;
	      DracarStores.DracarCompanyStores = DracarCompanyStores;
	      this.props.saveDracarStores(DracarStores).then(function (res) {
	        _this7.setState({
	          DracarStores: res.data
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isWP = (0, _auth2.hasAccess)([6], this.props.auth.user.UserType);
	      if (isWP) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'settings__screen' },
	          _react2.default.createElement(
	            'div',
	            { className: 'settings__screen--inner clearfix' },
	            this.renderInvoicing()
	          )
	        );
	      }
	      return this.renderInvoicing();
	    }
	  }, {
	    key: 'onAccountingSystemChange',
	    value: function onAccountingSystemChange(e) {
	      var _this8 = this;
	
	      e.persist();
	      var system = this.state.Invoicing.AccountingSystem;
	      var val = parseInt(e.target.value);
	      if (val !== system) {
	        this.setState({ Invoicing: _extends({}, this.state.Invoicing, { AccountingSystem: val }) }, function () {
	          return _this8.onBlur(e);
	        });
	      }
	    }
	  }, {
	    key: 'getAccountingSystemName',
	    value: function getAccountingSystemName() {
	      switch (this.state.Invoicing.AccountingSystem) {
	        case 1:
	          return (0, _helpers.translation)('13489');
	        case 2:
	          return (0, _helpers.translation)('13488');
	        case 3:
	          return (0, _helpers.translation)('1382');
	        case 4:
	          return (0, _helpers.translation)('15352');
	        case 5:
	          return (0, _helpers.translation)('17942');
	        case 6:
	          return (0, _helpers.translation)('18138');
	        case 7:
	          return (0, _helpers.translation)('18235'); // Visma.net
	      }
	    }
	  }, {
	    key: 'renderAccountingRadios',
	    value: function renderAccountingRadios() {
	      var isWP = (0, _auth2.hasAccess)([6], this.props.auth.user.UserType);
	      var dracarAllowed = this.props.auth.permissions.DracarAllowed;
	      var system = this.state.Invoicing.AccountingSystem;
	      // 15352 = 'Dracar+'
	
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: 13487 },
	        _react2.default.createElement(_radio2.default, { id: 'AccountingSystem_none', name: 'AccountingSystem', value: '0', onChange: this.onAccountingSystemChange, checked: system === 0, labelText: (0, _helpers.translation)(433) }),
	        _react2.default.createElement(_radio2.default, { id: 'AccountingSystem_economic', name: 'AccountingSystem', value: '1', onChange: this.onAccountingSystemChange, checked: system === 1, labelText: (0, _helpers.translation)(13489) }),
	        !isWP && _react2.default.createElement(_radio2.default, { id: 'AccountingSystem_helios', name: 'AccountingSystem', value: '2', onChange: this.onAccountingSystemChange, checked: system === 2, labelText: (0, _helpers.translation)(13488) }),
	        !isWP && _react2.default.createElement(_radio2.default, { id: 'AccountingSystem_c5', name: 'AccountingSystem', value: '3', onChange: this.onAccountingSystemChange, checked: system === 3, labelText: (0, _helpers.translation)(1382) }),
	        !isWP && dracarAllowed && _react2.default.createElement(_radio2.default, { id: 'AccountingSystem_KeyLoop', name: 'AccountingSystem', value: '4', onChange: this.onAccountingSystemChange, checked: system === 4 || system === 6, labelText: 18137 }),
	        !isWP && _react2.default.createElement(_radio2.default, { id: 'AccountingSystem_24SO', name: 'AccountingSystem', value: '5', onChange: this.onAccountingSystemChange, checked: system === 5, labelText: (0, _helpers.translation)(17942) }),
	        !isWP && _react2.default.createElement(_radio2.default, { id: 'AccountingSystem_visma_net', name: 'AccountingSystem', value: '7', onChange: this.onAccountingSystemChange, checked: system === 7, labelText: (0, _helpers.translation)(18235) })
	      );
	    }
	  }, {
	    key: 'onFieldChange',
	    value: function onFieldChange(e) {
	      var name = e.target.name;
	      var value = e.target.value;
	
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'renderInvoicing',
	    value: function renderInvoicing() {
	      var _this9 = this;
	
	      var DracarAllowed = this.props.auth.permissions.DracarAllowed;
	      var user = this.props.auth.user;
	      var Invoicing = this.state.Invoicing;
	
	      var isWP = (0, _auth2.hasAccess)([6], user.UserType);
	      var accountingSystemName = this.getAccountingSystemName();
	      var displayOnBodyShop = user.DepartmentType === _constants.DepartmentType.Body;
	      var displayOnPaintShop = user.DepartmentType === _constants.DepartmentType.Paint;
	      var displayOnWP = isWP;
	      var display = displayOnWP || displayOnPaintShop || displayOnBodyShop; // display for all
	
	      var invoiceFields = [{
	        'id': 0,
	        'key': 'OrderType',
	        'translationKey': 525,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 1,
	        'key': 'PickupDate',
	        'translationKey': 18346,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 2,
	        'key': 'DeliveryDate',
	        'translationKey': 18347,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 3,
	        'key': 'Chassinumber',
	        'translationKey': 18348,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 4,
	        'key': 'WarrantyCode',
	        'translationKey': 13396,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 5,
	        'key': 'DamageNumber',
	        'translationKey': 18257,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 6,
	        'key': 'ReportNumber',
	        'translationKey': 18349,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 7,
	        'key': 'RegistrationNumber',
	        'translationKey': 2005,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 8,
	        'key': 'BrandAndModel',
	        'translationKey': 18350,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 9,
	        'key': 'ApromasID',
	        'translationKey': 18351,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 10,
	        'key': 'RequisitionNumber',
	        'translationKey': 80,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 11,
	        'key': 'ExternalDeviations',
	        'translationKey': 18352,
	        'displayOnHeader': false,
	        'display': displayOnPaintShop
	      }, {
	        'id': 12,
	        'key': 'AfterEvaluation',
	        'translationKey': 1037,
	        'displayOnHeader': false,
	        'display': false
	      }, {
	        'id': 13,
	        'key': 'TotalWagesAndMaterialsOnIndividualLine',
	        'translationKey': 18353,
	        'displayOnHeader': false,
	        'display': displayOnPaintShop
	      }, {
	        'id': 14,
	        'key': 'ColorCode',
	        'translationKey': 79,
	        'displayOnHeader': true,
	        'display': display
	      }, {
	        'id': 15,
	        'key': 'WPDealerName',
	        'translationKey': 18360,
	        'displayOnHeader': true,
	        'display': displayOnWP
	      }];
	
	      var positions = [{
	        'id': 0,
	        'key': 'HeadlineFields'
	      }, {
	        'id': 1,
	        'key': 'Text1Fields'
	      }, {
	        'id': 2,
	        'key': 'Text2Fields'
	      }, {
	        'id': 3,
	        'key': 'OtherReferencesFields'
	      }, {
	        'id': 4,
	        'key': 'ReferenceFields'
	      }, {
	        'id': 5,
	        'key': 'InvoiceTextFields'
	      }, {
	        'id': 6,
	        'key': 'CustomerOrderIdFields'
	      }, {
	        'id': 7,
	        'key': 'ExternalReferenceFields'
	      }, {
	        'id': 8,
	        'key': 'ExtraLinesFields'
	      }, {
	        'id': 9,
	        'key': 'CommentFields'
	      }];
	
	      var renderInvoiceHeaderField = function renderInvoiceHeaderField(field) {
	        if (field.displayOnHeader && field.display) {
	          return _react2.default.createElement(
	            'option',
	            { key: field.id, value: field.id },
	            (0, _helpers.translation)(field.translationKey)
	          );
	        }
	      };
	
	      var renderExtraInvoiceLineField = function renderExtraInvoiceLineField(field) {
	        if (field.display) {
	          return _react2.default.createElement(
	            'option',
	            { key: field.id, value: field.id },
	            (0, _helpers.translation)(field.translationKey)
	          );
	        }
	      };
	
	      var addInvoiceField = function addInvoiceField(position, dataItem) {
	        var key = positions[position].key;
	        if (dataItem === undefined || dataItem === -1) {
	          window.toastr.error('please choose an item from the drop-down');
	        } else if (_this9.state[key].some(function (item) {
	          return item.DataItem === dataItem;
	        })) {
	          window.toastr.error('unable to add a field twice');
	        } else {
	          var data = {
	            Position: position,
	            DataItem: dataItem
	          };
	          _this9.props.updateAccountingSystemField(data).then(function (res) {
	            var field = {
	              Id: res.data.Id,
	              Position: position,
	              DataItem: dataItem
	            };
	            _this9.setState(_defineProperty({}, key, [].concat(_toConsumableArray(_this9.state[key]), [field])));
	          }, function () {
	            window.toastr.error((0, _helpers.translation)('1725'), (0, _helpers.translation)('216'));
	          });
	        }
	      };
	
	      var renderSelectedField = function renderSelectedField(val, key) {
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true, key: key },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)(invoiceFields[val.DataItem].translationKey)
	          ),
	          _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	              return removeInvoiceField(val);
	            }, id: val.Id, size: 's' })
	        );
	      };
	
	      var removeInvoiceField = function removeInvoiceField(field) {
	        var key = positions[field.Position].key;
	        var fields = [].concat(_toConsumableArray(_this9.state[key]));
	        var index = fields.map(function (item) {
	          return item.Id;
	        }).indexOf(field.Id);
	        if (index !== -1) {
	          _this9.props.deleteAccountingSystemField(field.Id).then(function (res) {
	            fields.splice(index, 1);
	            _this9.setState(_defineProperty({}, key, fields));
	          }, function () {
	            window.toastr.error((0, _helpers.translation)('1725'), (0, _helpers.translation)('216'));
	          });
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoicing__page' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('13486') },
	              this.renderAccountingRadios(),
	              this.state.Invoicing.IsPaintshop && _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('16527') },
	                _react2.default.createElement(_radio2.default, { name: 'TransferWorkHoursAsUnitPrice', value: 'no', onChange: this.onChange, checked: !Invoicing.TransferWorkHoursAsUnitPrice, labelText: (0, _helpers.translation)('16528') }),
	                _react2.default.createElement(_radio2.default, { name: 'TransferWorkHoursAsUnitPrice', value: 'yes', onChange: this.onChange, checked: Invoicing.TransferWorkHoursAsUnitPrice, labelText: (0, _helpers.translation)('16529') })
	              )
	            ),
	            Invoicing.AccountingSystem === 1 && _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('16672') },
	              _react2.default.createElement(_switch2.default, { name: 'EconomicUseCustomDepartment', onChange: this.onChange, checked: Invoicing.EconomicDepartment === -1, labelText: (0, _helpers.translation)('15321') }),
	              Invoicing.EconomicDepartment !== -1 && [_react2.default.createElement(_radio2.default, { key: 'EconomicDepartment_0', id: 'EconomicDepartment_PersonCars', name: 'EconomicDepartment', value: '0', onChange: this.onChange, checked: Invoicing.EconomicDepartment === 0, labelText: '100' }), !isWP && _react2.default.createElement(_radio2.default, { key: 'EconomicDepartment_1', id: 'EconomicDepartment_BigCars', name: 'EconomicDepartment', value: '1', onChange: this.onChange, checked: Invoicing.EconomicDepartment === 1, labelText: '200' }), !isWP && _react2.default.createElement(_radio2.default, { key: 'EconomicDepartment_2', id: 'EconomicDepartment_Industry', name: 'EconomicDepartment', value: '2', onChange: this.onChange, checked: Invoicing.EconomicDepartment === 2, labelText: '300', disabled: isWP })],
	              Invoicing.EconomicDepartment === -1 && _react2.default.createElement(_text2.default, { name: 'EconomicDepartmentType', value: Invoicing.EconomicDepartmentType, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('15202') })
	            ),
	            Invoicing.AccountingSystem === 7 && _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('16672') },
	              _react2.default.createElement(_switch2.default, { name: 'VismaNetUseCustomDepartment', onChange: this.onChange, checked: Invoicing.VismaNetDepartment === -1, labelText: (0, _helpers.translation)('15321') }),
	              Invoicing.VismaNetDepartment !== -1 && [_react2.default.createElement(_radio2.default, { key: 'VismaNetDepartment_0', id: 'VismaNetDepartment_PersonCars', name: 'VismaNetDepartment', value: '0', onChange: this.onChange, checked: Invoicing.VismaNetDepartment === 0, labelText: '100' }), !isWP && _react2.default.createElement(_radio2.default, { key: 'VismaNetDepartment_1', id: 'VismaNetDepartment_BigCars', name: 'VismaNetDepartment', value: '1', onChange: this.onChange, checked: Invoicing.VismaNetDepartment === 1, labelText: '200' }), !isWP && _react2.default.createElement(_radio2.default, { key: 'VismaNetDepartment_2', id: 'VismaNetDepartment_Industry', name: 'VismaNetDepartment', value: '2', onChange: this.onChange, checked: Invoicing.VismaNetDepartment === 2, labelText: '300', disabled: isWP })],
	              Invoicing.VismaNetDepartment === -1 && _react2.default.createElement(_text2.default, { name: 'VismaNetDepartmentType', value: Invoicing.VismaNetDepartmentType, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('15202') })
	            )
	          ),
	          Invoicing.AccountingSystem !== 0 && _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: accountingSystemName },
	              Invoicing.AccountingSystem === 2 && _react2.default.createElement(_text2.default, { name: 'HeliosNumber', value: Invoicing.HeliosNumber || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('499') }),
	              Invoicing.AccountingSystem === 1 && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_text2.default, { name: 'EconomicId', value: Invoicing.EconomicId, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('1132') }),
	                _react2.default.createElement(_text2.default, { name: 'EconomicUserName', value: Invoicing.EconomicUserName || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('13490') }),
	                _react2.default.createElement(_text2.default, { name: 'EconomicPassword', value: Invoicing.EconomicPassword || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('13491') }),
	                _react2.default.createElement(
	                  _null2.default,
	                  { comment: 'Hint link for EconomicToken' },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'token_link', href: Invoicing.EconomicAuthUrl },
	                    _react2.default.createElement('img', { src: '/images/icons/Cirkle_info-grey25x25px.png' })
	                  )
	                ),
	                _react2.default.createElement(_text2.default, { name: 'EconomicToken', value: Invoicing.EconomicToken, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('13017'), helpText: _react2.default.createElement(
	                    'a',
	                    { className: 'token_link', href: Invoicing.EconomicAuthUrl },
	                    'Economic'
	                  ) }),
	                _react2.default.createElement(_text2.default, { name: 'EconomicWebHook', value: Invoicing.EconomicWebHook, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('13493') })
	              ),
	              Invoicing.AccountingSystem === 7 && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _null2.default,
	                  { comment: 'Hint link for VismaNetToken' },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'token_link', href: Invoicing.VismaNetAuthUrl },
	                    _react2.default.createElement('img', { src: '/images/icons/Cirkle_info-grey25x25px.png' })
	                  )
	                ),
	                _react2.default.createElement(_text2.default, { name: 'VismaNetToken', value: Invoicing.VismaNetToken, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('18239'), helpText: _react2.default.createElement(
	                    'a',
	                    { className: 'token_link', href: Invoicing.VismaNetAuthUrl },
	                    (0, _helpers.translation)(18235)
	                  ) })
	              ),
	              Invoicing.AccountingSystem === 3 && _react2.default.createElement(_text2.default, { name: 'C5Ftp', value: Invoicing.C5Ftp || '', onChange: this.onChange, onBlur: this.onBlur, disabled: true, labelText: (0, _helpers.translation)('556') }),
	              [4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { labelText: (0, _helpers.translation)('18137'), spacing: 4 },
	                  _react2.default.createElement(_radio2.default, { name: 'AccountingSystem_KeyLoop', value: '4', onChange: this.onAccountingSystemChange, checked: Invoicing.AccountingSystem === 4, labelText: (0, _helpers.translation)(15352) }),
	                  _react2.default.createElement(_radio2.default, { name: 'AccountingSystem_KeyLoop', value: '6', onChange: this.onAccountingSystemChange, checked: Invoicing.AccountingSystem === 6, labelText: (0, _helpers.translation)(18138) })
	                ),
	                _react2.default.createElement(_switch2.default, { name: 'DracarInvoiceLaborTotal', onChange: this.onChange, checked: Invoicing.DracarInvoiceLaborTotal, labelText: (0, _helpers.translation)('17838') }),
	                _react2.default.createElement(_switch2.default, { name: 'DracarInvoiceUnitsTotal', onChange: this.onChange, checked: Invoicing.DracarInvoiceUnitsTotal, labelText: (0, _helpers.translation)('17927') }),
	                Invoicing.DracarInvoiceLaborTotal && Invoicing.AccountingSystem === 4 && _react2.default.createElement(_text2.default, { name: 'DracarInvoiceLaborTotalCode', value: Invoicing.DracarInvoiceLaborTotalCode || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('17839') }),
	                _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { labelText: (0, _helpers.translation)('17867') },
	                  _react2.default.createElement(_radio2.default, { name: 'UseDracarSparePartCreation', value: 'no', onChange: this.onChange, checked: !Invoicing.UseDracarSparePartCreation, labelText: (0, _helpers.translation)(DICT_HANDLED_IN_APROMAS) }),
	                  Invoicing.AccountingSystem === 4 && _react2.default.createElement(_radio2.default, { name: 'UseDracarSparePartCreation', value: 'yes', onChange: this.onChange, checked: Invoicing.UseDracarSparePartCreation, labelText: (0, _helpers.translation)(DICT_HANDLED_IN_DRACAR) }),
	                  Invoicing.AccountingSystem === 6 && _react2.default.createElement(_radio2.default, { name: 'UseDracarSparePartCreation', value: 'yes', onChange: this.onChange, checked: Invoicing.UseDracarSparePartCreation, labelText: (0, _helpers.translation)(DICT_HANDLED_IN_AUTOLINE) })
	                ),
	                _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { labelText: (0, _helpers.translation)(17943).replace('[KeyLoopSystem]', accountingSystemName) },
	                  _react2.default.createElement(_radio2.default, { id: 'InsuranceCompanyTypeInDracar_Customer', name: 'InsuranceCompanyTypeInDracar', value: '1', onChange: this.onChange, checked: Invoicing.InsuranceCompanyTypeInDracar === 1, labelText: (0, _helpers.translation)('17944') }),
	                  _react2.default.createElement(_radio2.default, { id: 'InsuranceCompanyTypeInDracar_Company', name: 'InsuranceCompanyTypeInDracar', value: '0', onChange: this.onChange, checked: Invoicing.InsuranceCompanyTypeInDracar === 0, labelText: (0, _helpers.translation)('17945') })
	                )
	              ),
	              Invoicing.AccountingSystem === 5 && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_text2.default, { name: 'TFSOUserName', value: Invoicing.TFSOUserName || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('17940') }),
	                _react2.default.createElement(_text2.default, { name: 'TFSOPassword', value: Invoicing.TFSOPassword || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('17941') }),
	                _react2.default.createElement(_text2.default, { name: 'TFSODepartmentNumber', value: Invoicing.TFSODepartmentNumber || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('17946') })
	              )
	            )
	          ),
	          Invoicing.AccountingSystem === 1 && _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('18344') },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 1229, spacing: 4 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedHeadlineField', onChange: this.onFieldChange, value: this.state.SelectedHeadlineField },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(0, _this9.state.SelectedHeadlineField);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.HeadlineFields !== null && this.state.HeadlineFields.map(renderSelectedField)
	              ),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 18354, spacing: 4 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedText1Field', onChange: this.onFieldChange, value: this.state.SelectedText1Field },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(1, _this9.state.SelectedText1Field);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.Text1Fields !== null && this.state.Text1Fields.map(renderSelectedField)
	              ),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 18355, spacing: 4 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedText2Field', onChange: this.onFieldChange, value: this.state.SelectedText2Field },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(2, _this9.state.SelectedText2Field);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.Text2Fields !== null && this.state.Text2Fields.map(renderSelectedField)
	              ),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 18356 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedOtherReferencesField', onChange: this.onFieldChange, value: this.state.SelectedOtherReferencesField },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(3, _this9.state.SelectedOtherReferencesField);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.OtherReferencesFields !== null && this.state.OtherReferencesFields.map(renderSelectedField)
	              )
	            )
	          ),
	          Invoicing.AccountingSystem === 5 && _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('18344') },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 18357, spacing: 4 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedReferenceField', onChange: this.onFieldChange, value: this.state.SelectedReferenceField },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(4, _this9.state.SelectedReferenceField);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.ReferenceFields !== null && this.state.ReferenceFields.map(renderSelectedField)
	              ),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 1219, spacing: 4 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedInvoiceTextField', onChange: this.onFieldChange, value: this.state.SelectedInvoiceTextField },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(5, _this9.state.SelectedInvoiceTextField);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.InvoiceTextFields !== null && this.state.InvoiceTextFields.map(renderSelectedField)
	              ),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 149 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedCommentField', onChange: this.onFieldChange, value: this.state.SelectedCommentField },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(9, _this9.state.SelectedCommentField);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.CommentFields !== null && this.state.CommentFields.map(renderSelectedField)
	              )
	            )
	          ),
	          Invoicing.AccountingSystem === 7 && _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('18344') },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 18358, spacing: 4 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedCustomerOrderIdField', onChange: this.onFieldChange, value: this.state.SelectedCustomerOrderIdField },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(6, _this9.state.SelectedCustomerOrderIdField);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.CustomerOrderIdFields !== null && this.state.CustomerOrderIdFields.map(renderSelectedField)
	              ),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 18359, spacing: 4 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedExternalReferenceField', onChange: this.onFieldChange, value: this.state.SelectedExternalReferenceField },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(7, _this9.state.SelectedExternalReferenceField);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.ExternalReferenceFields !== null && this.state.ExternalReferenceFields.map(renderSelectedField)
	              ),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 1219 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'SelectedInvoiceTextField', onChange: this.onFieldChange, value: this.state.SelectedInvoiceTextField },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderInvoiceHeaderField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(5, _this9.state.SelectedInvoiceTextField);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.InvoiceTextFields !== null && this.state.InvoiceTextFields.map(renderSelectedField)
	              )
	            )
	          ),
	          Invoicing.AccountingSystem !== 0 && _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('18345') },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 18345, spacing: 0 },
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: ['200px', 'auto'] },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'selectedExtraLinesField', onChange: this.onFieldChange, value: this.state.selectedExtraLinesField },
	                    _react2.default.createElement(
	                      'option',
	                      { value: -1 },
	                      (0, _helpers.translation)('890')
	                    ),
	                    invoiceFields.map(renderExtraInvoiceLineField)
	                  ),
	                  _react2.default.createElement(_addButton2.default, { onClick: function onClick() {
	                      return addInvoiceField(8, _this9.state.selectedExtraLinesField);
	                    } })
	                ),
	                _react2.default.createElement('br', null),
	                this.state.ExtraLinesFields !== null && this.state.ExtraLinesFields.map(renderSelectedField)
	              )
	            )
	          )
	        ),
	        !isWP && Invoicing.AccountingSystem > 0 && !([4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed) && (0, _auth2.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(_ProductNumbers2.default, { section: 'report', accountingSystem: this.state.PNumberAccountingSystem }),
	        !isWP && Invoicing.AccountingSystem > 0 && !([4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed) && (0, _auth2.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(_ProductNumbers2.default, { section: 'other', accountingSystem: this.state.PNumberAccountingSystem }),
	        [4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed && this.renderDracarJobFeeSettings(),
	        [4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed && this.renderDracarStores(),
	        this.state.Confirm.Show === true && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.notConfirm },
	          _react2.default.createElement(_Confirm2.default, { t: _helpers.translation, renderText: function renderText() {
	              return (0, _helpers.translation)(16760);
	            }, confirm: this.confirmDelete, notConfirm: this.notConfirm })
	        )
	      );
	    }
	  }, {
	    key: 'renderDracarStores',
	    value: function renderDracarStores() {
	      var _this10 = this;
	
	      var DracarStores = this.state.DracarStores;
	
	
	      var renderNew = function renderNew() {
	        var DracarStoreNew = _this10.state.DracarStoreNew;
	
	        var addItem = function addItem() {
	          var DracarCompanyStores = [].concat(_toConsumableArray(DracarStores.DracarCompanyStores));
	          DracarCompanyStores.push(_this10.state.DracarStoreNew);
	          DracarStores.DracarCompanyStores = DracarCompanyStores;
	          _this10.props.saveDracarStores(DracarStores).then(function (res) {
	            _this10.setState({
	              DracarStores: res.data,
	              DracarStoreNew: {
	                StoreName: '',
	                StoreId: '',
	                EnterpriseId: '',
	                IsDeleted: false
	              }
	            });
	          });
	        };
	
	        // Store id = 18140
	        // enterprise id = 18141
	
	        var systemText = _this10.getAccountingSystemName();
	        // switch (this.state.Invoicing.AccountingSystem) {
	        //   case 4:
	        //     systemText = translation(DICT_DRACAR_PLUS)
	        //     break
	        //   case 6:
	        //     systemText = translation(DICT_AUTOLINE)
	        //     break
	        // }
	        var storeIdText = systemText + ' ' + (0, _helpers.translation)(18140);
	        var enterpriseIdText = systemText + ' ' + (0, _helpers.translation)(18141);
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 1, 1, 'min-content'], align: 'center' },
	          _react2.default.createElement(_text2.default, { labelText: 16759, name: 'DracarStoreStoreName', value: DracarStoreNew.StoreName, onChange: _this10.onChange }),
	          _react2.default.createElement(_text2.default, { labelText: storeIdText, name: 'DracarStoreStoreId', value: DracarStoreNew.StoreId, onChange: _this10.onChange }),
	          _react2.default.createElement(_text2.default, { labelText: enterpriseIdText, name: 'DracarStoreEnterpriseId', value: DracarStoreNew.EnterpriseId, onChange: _this10.onChange }),
	          _react2.default.createElement(_addButton2.default, { onClick: addItem })
	        );
	      };
	
	      var renderStores = function renderStores(val, key) {
	        var deleteItem = function deleteItem(key) {
	          _this10.setState({
	            Confirm: {
	              deleteKey: key,
	              Show: true
	            }
	          });
	        };
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 1, 1, 'min-content'], key: key, spacing: 1 },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            val.StoreName
	          ),
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            val.StoreId
	          ),
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            val.EnterpriseId
	          ),
	          _react2.default.createElement(_removeButton2.default, { size: 'm', onClick: deleteItem.bind(_this10, key) })
	        );
	      };
	
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 3 },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)(16758).replace('[KeyLoopSystem]', this.getAccountingSystemName()) },
	          renderNew(),
	          DracarStores.DracarCompanyStores.length > 0 && DracarStores.DracarCompanyStores.map(renderStores)
	        )
	      );
	    }
	  }, {
	    key: 'renderDracarJobFeeSettings',
	    value: function renderDracarJobFeeSettings() {
	      var _this11 = this;
	
	      var DracarJobFeeSettings = this.state.Invoicing.DracarJobFeeSettings;
	
	      var renderJobFeeSettings = function renderJobFeeSettings(val, key) {
	        var labelText = '';
	        switch (val.DType) {
	          case _constants.DracarJobFeeSettingType.LABOR_1:
	            labelText = (0, _helpers.translation)('416');
	            break;
	          case _constants.DracarJobFeeSettingType.BODYSHOP_ENVIRONMENT_2:
	            labelText = (0, _helpers.translation)('15156');
	            break;
	          case _constants.DracarJobFeeSettingType.SUNDRYPARTS_MATERIAL_3:
	            labelText = (0, _helpers.translation)('14785');
	            break;
	          case _constants.DracarJobFeeSettingType.SUNDRYPARTS_TOTAL_4:
	            labelText = (0, _helpers.translation)('16755');
	            break;
	          case _constants.DracarJobFeeSettingType.HOLLOW_CAVITY_SEALANT_5:
	            labelText = (0, _helpers.translation)('16756');
	            break;
	          case _constants.DracarJobFeeSettingType.PAINT_6:
	            labelText = (0, _helpers.translation)('161');
	            break;
	          case _constants.DracarJobFeeSettingType.PAINT_ENVIRONMENT_7:
	            labelText = (0, _helpers.translation)('15155');
	            break;
	          case _constants.DracarJobFeeSettingType.DIFFERENCE_INSURANCE_8:
	            labelText = (0, _helpers.translation)('15154');
	            break;
	          case _constants.DracarJobFeeSettingType.AUTOLINE_CONSUMABLES_9:
	            labelText = (0, _helpers.translation)('18139');
	            break;
	          default:
	            break;
	        }
	        return _react2.default.createElement(
	          _grid2.default,
	          { spacing: '1', align: 'center', cols: [2, 1], key: 'dnum_' + key },
	          _react2.default.createElement(
	            'span',
	            null,
	            labelText
	          ),
	          _react2.default.createElement(_text2.default, { size: 'm', name: 'DType' + val.DType, value: val.DNumber, onChange: _this11.onChange, onBlur: _this11.onBlur })
	        );
	      };
	
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { span: 2 },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('15295') },
	            DracarJobFeeSettings.map(renderJobFeeSettings)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Invoicing;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getInvoicingInformation: _settings.getInvoicingInformation,
	  saveInvoicingInformation: _settings.saveInvoicingInformation,
	  getDracarStores: _settings.getDracarStores,
	  saveDracarStores: _settings.saveDracarStores,
	  getAuthResources: _auth.getAuthResources,
	  getAccountingSystemField: _settings.getAccountingSystemField,
	  deleteAccountingSystemField: _settings.deleteAccountingSystemField,
	  updateAccountingSystemField: _settings.updateAccountingSystemField
	})(Invoicing);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layout = __webpack_require__(1050);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _icons = __webpack_require__(6);
	
	var _NoMatch = __webpack_require__(880);
	
	var _NoMatch2 = _interopRequireDefault(_NoMatch);
	
	var _Login = __webpack_require__(867);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _ChangePass = __webpack_require__(807);
	
	var _ChangePass2 = _interopRequireDefault(_ChangePass);
	
	var _ChangePin = __webpack_require__(808);
	
	var _ChangePin2 = _interopRequireDefault(_ChangePin);
	
	var _PasswordReset = __webpack_require__(930);
	
	var _PasswordReset2 = _interopRequireDefault(_PasswordReset);
	
	var _Activate = __webpack_require__(804);
	
	var _Activate2 = _interopRequireDefault(_Activate);
	
	var _Signup = __webpack_require__(981);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _NewWorkscreen = __webpack_require__(879);
	
	var _NewWorkscreen2 = _interopRequireDefault(_NewWorkscreen);
	
	var _PunchClock = __webpack_require__(950);
	
	var _PunchClock2 = _interopRequireDefault(_PunchClock);
	
	var _PunchReport = __webpack_require__(952);
	
	var _PunchReport2 = _interopRequireDefault(_PunchReport);
	
	var _PunchEdit = __webpack_require__(951);
	
	var _PunchEdit2 = _interopRequireDefault(_PunchEdit);
	
	var _AbsenceReport = __webpack_require__(803);
	
	var _AbsenceReport2 = _interopRequireDefault(_AbsenceReport);
	
	var _Dashboard = __webpack_require__(835);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _PriceCalculation = __webpack_require__(938);
	
	var _PriceCalculation2 = _interopRequireDefault(_PriceCalculation);
	
	var _Conflicts = __webpack_require__(826);
	
	var _Conflicts2 = _interopRequireDefault(_Conflicts);
	
	var _Order = __webpack_require__(923);
	
	var _Order2 = _interopRequireDefault(_Order);
	
	var _OrderList = __webpack_require__(910);
	
	var _OrderList2 = _interopRequireDefault(_OrderList);
	
	var _OrderInspection = __webpack_require__(896);
	
	var _OrderInspection2 = _interopRequireDefault(_OrderInspection);
	
	var _Addresses = __webpack_require__(806);
	
	var _Addresses2 = _interopRequireDefault(_Addresses);
	
	var _Prices = __webpack_require__(949);
	
	var _Prices2 = _interopRequireDefault(_Prices);
	
	var _PriceApproval = __webpack_require__(424);
	
	var _PriceApproval2 = _interopRequireDefault(_PriceApproval);
	
	var _QualityCheckSettings = __webpack_require__(954);
	
	var _QualityCheckSettings2 = _interopRequireDefault(_QualityCheckSettings);
	
	var _QualityCheckSettingsChild = __webpack_require__(287);
	
	var _QualityCheckSettingsChild2 = _interopRequireDefault(_QualityCheckSettingsChild);
	
	var _Settings = __webpack_require__(976);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _Invoicing = __webpack_require__(425);
	
	var _Invoicing2 = _interopRequireDefault(_Invoicing);
	
	var _Chains = __webpack_require__(822);
	
	var _Chains2 = _interopRequireDefault(_Chains);
	
	var _Performance = __webpack_require__(931);
	
	var _Performance2 = _interopRequireDefault(_Performance);
	
	var _ForsiList = __webpack_require__(860);
	
	var _ForsiList2 = _interopRequireDefault(_ForsiList);
	
	var _InsuranceCompanyList = __webpack_require__(862);
	
	var _InsuranceCompanyList2 = _interopRequireDefault(_InsuranceCompanyList);
	
	var _SelectShop = __webpack_require__(955);
	
	var _SelectShop2 = _interopRequireDefault(_SelectShop);
	
	var _MyPage = __webpack_require__(877);
	
	var _MyPage2 = _interopRequireDefault(_MyPage);
	
	var _MyOrders = __webpack_require__(874);
	
	var _MyOrders2 = _interopRequireDefault(_MyOrders);
	
	var _Order3 = __webpack_require__(873);
	
	var _Order4 = _interopRequireDefault(_Order3);
	
	var _MyTasks = __webpack_require__(415);
	
	var _MyTasks2 = _interopRequireDefault(_MyTasks);
	
	var _Task = __webpack_require__(284);
	
	var _Task2 = _interopRequireDefault(_Task);
	
	var _MyMessages = __webpack_require__(872);
	
	var _MyMessages2 = _interopRequireDefault(_MyMessages);
	
	var _Message = __webpack_require__(414);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _Customers = __webpack_require__(834);
	
	var _Customers2 = _interopRequireDefault(_Customers);
	
	var _Contacts = __webpack_require__(832);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	var _Single = __webpack_require__(833);
	
	var _Single2 = _interopRequireDefault(_Single);
	
	var _CollaboratingPartners = __webpack_require__(824);
	
	var _CollaboratingPartners2 = _interopRequireDefault(_CollaboratingPartners);
	
	var _Employees = __webpack_require__(854);
	
	var _Employees2 = _interopRequireDefault(_Employees);
	
	var _ShopOwners = __webpack_require__(978);
	
	var _ShopOwners2 = _interopRequireDefault(_ShopOwners);
	
	var _Shops = __webpack_require__(980);
	
	var _Shops2 = _interopRequireDefault(_Shops);
	
	var _SmallDashboard = __webpack_require__(982);
	
	var _SmallDashboard2 = _interopRequireDefault(_SmallDashboard);
	
	var _DataWarehouse = __webpack_require__(836);
	
	var _DataWarehouse2 = _interopRequireDefault(_DataWarehouse);
	
	var _Partners = __webpack_require__(929);
	
	var _Partners2 = _interopRequireDefault(_Partners);
	
	var _Contacts3 = __webpack_require__(927);
	
	var _Contacts4 = _interopRequireDefault(_Contacts3);
	
	var _Constraints = __webpack_require__(925);
	
	var _Constraints2 = _interopRequireDefault(_Constraints);
	
	var _EvaluationHistory = __webpack_require__(859);
	
	var _EvaluationHistory2 = _interopRequireDefault(_EvaluationHistory);
	
	var _Agreements = __webpack_require__(935);
	
	var _Agreements2 = _interopRequireDefault(_Agreements);
	
	var _CustomerGroups = __webpack_require__(830);
	
	var _CustomerGroups2 = _interopRequireDefault(_CustomerGroups);
	
	var _Contacts5 = __webpack_require__(828);
	
	var _Contacts6 = _interopRequireDefault(_Contacts5);
	
	var _CarRental = __webpack_require__(819);
	
	var _CarRental2 = _interopRequireDefault(_CarRental);
	
	var _CarRentals = __webpack_require__(820);
	
	var _CarRentals2 = _interopRequireDefault(_CarRentals);
	
	var _Managers = __webpack_require__(869);
	
	var _Managers2 = _interopRequireDefault(_Managers);
	
	var _Task3 = __webpack_require__(988);
	
	var _Task4 = _interopRequireDefault(_Task3);
	
	var _Tasks = __webpack_require__(989);
	
	var _Tasks2 = _interopRequireDefault(_Tasks);
	
	var _Messages = __webpack_require__(871);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _Message3 = __webpack_require__(870);
	
	var _Message4 = _interopRequireDefault(_Message3);
	
	var _Subcontractors = __webpack_require__(986);
	
	var _Subcontractors2 = _interopRequireDefault(_Subcontractors);
	
	var _SparePartsSuppliers = __webpack_require__(984);
	
	var _SparePartsSuppliers2 = _interopRequireDefault(_SparePartsSuppliers);
	
	var _ProductionStatusOverview = __webpack_require__(445);
	
	var _ProductionStatusOverview2 = _interopRequireDefault(_ProductionStatusOverview);
	
	var _DeliveryStatusOverview = __webpack_require__(433);
	
	var _DeliveryStatusOverview2 = _interopRequireDefault(_DeliveryStatusOverview);
	
	var _EmbeddedBooking = __webpack_require__(852);
	
	var _EmbeddedBooking2 = _interopRequireDefault(_EmbeddedBooking);
	
	var _CarOwnerPortal = __webpack_require__(812);
	
	var _CarOwnerPortal2 = _interopRequireDefault(_CarOwnerPortal);
	
	var _IntegrationErrorList = __webpack_require__(863);
	
	var _IntegrationErrorList2 = _interopRequireDefault(_IntegrationErrorList);
	
	var _SupportAccessUser = __webpack_require__(987);
	
	var _SupportAccessUser2 = _interopRequireDefault(_SupportAccessUser);
	
	var _Chain = __webpack_require__(842);
	
	var _Chain2 = _interopRequireDefault(_Chain);
	
	var _Company = __webpack_require__(845);
	
	var _Company2 = _interopRequireDefault(_Company);
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _requireAuth = __webpack_require__(1136);
	
	var _requireAuth2 = _interopRequireDefault(_requireAuth);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import layout
	
	
	// Menu icons
	
	
	// import pages
	
	
	// Auth
	
	
	// Activation
	
	
	// Signup
	
	
	// Workscreen
	
	
	// PunchClock
	
	
	// PunchReport
	
	
	// PunchEdit
	
	
	// AbsenceReport
	
	
	// Dashboard
	
	
	// Price calculation
	
	
	// Conflicts
	
	
	// Orders
	
	
	// Addresses
	
	
	// Prices
	
	
	// PriceApproval
	
	
	// Quality check Settings
	
	
	// Settings
	
	
	// Chains
	
	
	// Performance
	
	
	// Forsilist
	
	
	// InsuranceCompanyList
	
	
	// Shop owner
	
	
	// My page
	
	
	// Customers
	
	
	// CollaboratingPartners
	
	
	// Employees
	
	
	// Shop Owners
	
	
	// Shops
	
	
	// Small Dashboard
	
	
	// Partners
	
	
	// Evaluation history
	
	
	// Price agreements
	// import PriceAgreements from './pages/PriceAgreements'
	
	
	// Customer groups
	
	
	// CarRental
	
	
	// Manager
	
	
	// Tasks
	
	
	// Messages
	
	
	// Subcontractors
	
	
	// Spare parts supplier
	
	
	// Overview
	
	
	// Embedded booking
	
	
	// Car owner portal
	
	
	// Support
	
	
	// ESG
	
	
	// EmptyPage
	var EmptyPage = function (_React$Component) {
	  _inherits(EmptyPage, _React$Component);
	
	  function EmptyPage() {
	    _classCallCheck(this, EmptyPage);
	
	    return _possibleConstructorReturn(this, (EmptyPage.__proto__ || Object.getPrototypeOf(EmptyPage)).apply(this, arguments));
	  }
	
	  _createClass(EmptyPage, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return EmptyPage;
	}(_react2.default.Component);
	
	// Require auth to show layout
	
	
	exports.default = function (store) {
	  // On Enter
	  var onEnter = function onEnter(nextState, replace, callback) {
	    var state = store.getState();
	
	    var origin = window.location.origin;
	    var url = origin + '/version.json';
	    var serverVer = '';
	    var serverBuild = '';
	    var clientBuild = window.localStorage.getItem('clientBuild');
	    var clientVer = window.localStorage.getItem('clientVersion');
	
	    // Stop caching the version file!
	    var config = {
	      headers: {
	        Pragma: 'no-cache',
	        'Expires': '-1'
	      }
	    };
	
	    _axios2.default.get(url, config).then(function (res) {
	      var version = res.data;
	      serverVer = version.version;
	      serverBuild = version.build;
	      if (clientBuild === undefined || clientBuild === 'undefined' || clientBuild === 'null' || clientBuild === null) {
	        window.localStorage.setItem('clientBuild', serverBuild);
	        window.localStorage.setItem('clientVersion', serverVer);
	        clientBuild = serverBuild;
	        clientVer = serverVer;
	      }
	      if (clientBuild !== serverBuild || clientVer !== serverVer) {
	        window.localStorage.setItem('clientBuild', serverBuild);
	        window.localStorage.setItem('clientVersion', serverVer);
	        window.location.reload();
	      }
	    });
	
	    // console.log('usertype', state.auth.user.UserType)
	    // console.log('Console test')
	    // if (nextState.routes[nextState.routes.length - 1].allowExternalAccess) {
	    //   // replace({ nextPathname: nextState.location.pathname }, '/')
	    //   callback()
	    //   console.log('Console test 2')
	    //   return
	    // }
	    if (typeof state.auth.user.UserType === 'undefined') {
	      replace({ nextPathname: nextState.location.pathname }, '/login');
	    } else {
	      var access = nextState.routes[nextState.routes.length - 1].access;
	      var hasValidShops = nextState.routes[nextState.routes.length - 1].hasValidShop;
	      var ValidShopChecks = nextState.routes[nextState.routes.length - 1].ValidShopCheck;
	      var isValidShop = true;
	      var userType = state.auth.user.UserType;
	      if (nextState.location.pathname.indexOf('/orders/') === -1 && (0, _auth.isLoginFromShop)(state.auth.inactiveUsers)) {
	        // if you logged in as a shop, you shouldn't be able to get an employees rights
	        userType = 5;
	      }
	      if (hasValidShops !== undefined && hasValidShops.length > 0) {
	        isValidShop = (0, _auth.hasDepartmentType)(state.auth, hasValidShops, userType, ValidShopChecks);
	      }
	      // let permissionId = nextState.routes[nextState.routes.length - 1].permissionId
	      // if (permissionId === undefined || permissionId === null) permissionId = 0
	      // let availableFree = nextState.routes[nextState.routes.length - 1].isAvailableFree
	      if (!(0, _auth.hasAccess)(access, userType) || !isValidShop) {
	        // || !hasPermission(state.auth, permissionId, availableFree)
	        replace({ nextPathname: nextState.location.pathname }, '/');
	      }
	    }
	    callback();
	  };
	  // Return routes
	  return [{
	    path: '/login',
	    component: _Login2.default,
	    isAvailableFree: true
	  }, {
	    path: '/resetpassword',
	    component: _PasswordReset2.default,
	    isAvailableFree: true
	  }, {
	    path: '/resetpassword/:resetToken',
	    component: _PasswordReset2.default,
	    isAvailableFree: true
	  }, {
	    path: '/signup',
	    component: _Signup2.default,
	    isAvailableFree: true
	  }, {
	    path: '/activate/:activationCode',
	    component: _Activate2.default,
	    isAvailableFree: true
	  }, {
	    path: '/activate/',
	    component: _Activate2.default,
	    isAvailableFree: true
	  }, {
	    path: '/priceapproval/:approvalToken',
	    component: _PriceApproval2.default,
	    isAvailableFree: true
	  }, {
	    path: '/embeddedbooking/:embedToken/:language',
	    component: _EmbeddedBooking2.default
	  }, {
	    path: '/carownerportal/:token',
	    component: _CarOwnerPortal2.default
	  }, {
	    path: '/empty',
	    component: EmptyPage,
	    isAvailableFree: true
	  }, {
	    path: '/',
	    component: (0, _requireAuth2.default)(_Layout2.default),
	    isAvailableFree: true,
	    indexRoute: {
	      component: _Dashboard2.default
	    },
	    childRoutes: [{
	      path: '/selectshop',
	      component: _SelectShop2.default,
	      onEnter: onEnter,
	      access: [8],
	      isAvailableFree: false,
	      topBar: {
	        title: 1896,
	        icon: _icons.MainMenuIcons.WorkScreen_White
	      },
	      menu: {
	        order: 1,
	        title: '1896',
	        icon: _icons.MainMenuIcons.WorkScreen_Black
	      }
	    }, {
	      path: '/workscreen',
	      component: _NewWorkscreen2.default,
	      onEnter: onEnter,
	      access: [3, 5, 7],
	      isAvailableFree: true,
	      permissionId: 1,
	      topBar: {
	        title: 18,
	        icon: _icons.MainMenuIcons.WorkScreen_White
	      },
	      menu: {
	        order: 4,
	        title: '18',
	        icon: _icons.MainMenuIcons.WorkScreen_Black
	      }
	    }, {
	      path: '/orders',
	      component: _OrderList2.default,
	      onEnter: onEnter,
	      access: [3, 4, 6, 7],
	      isAvailableFree: true,
	      topBar: {
	        title: 14876,
	        icon: _icons.MainMenuIcons.OrderList_White
	      },
	      menu: {
	        order: 3,
	        title: '14876',
	        icon: _icons.MainMenuIcons.OrderList_Black
	      }
	    }, {
	      path: '/orders/:orderID',
	      component: _Order2.default,
	      onEnter: onEnter,
	      access: [3, 4, 6, 7],
	      isAvailableFree: true
	    }, {
	      path: '/orders/:orderID/orderinspection',
	      component: _OrderInspection2.default,
	      onEnter: onEnter,
	      access: [3, 4, 6, 7],
	      isAvailableFree: false
	    }, {
	      path: '/pricecalculation/:orderID/:addon',
	      component: _PriceCalculation2.default,
	      isAvailableFree: true
	    }, {
	      path: '/evaluationhistory/:orderId',
	      component: _EvaluationHistory2.default,
	      onEnter: onEnter,
	      access: [3, 5, 7, 6],
	      isAvailableFree: false
	      // menu: {
	      //   order: 200,
	      //   title: 'Eval hist. (dev)',
	      //   icon: '/images/icons/menu/Workscreen-Black.png'
	      // }
	    }, {
	      path: '/addresses',
	      component: _Addresses2.default,
	      onEnter: onEnter,
	      access: [3, 4, 7],
	      ValidShopCheck: [3],
	      hasValidShop: [1, 2],
	      isAvailableFree: false,
	      subscriptionValue: 20,
	      checkPartnerSubscription: true,
	      topBar: {
	        title: 13466,
	        icon: _icons.MainMenuIcons.Adresses_White
	      },
	      menu: {
	        order: 10,
	        title: '13466',
	        icon: _icons.MainMenuIcons.Adresses_Black
	      }
	    }, {
	      path: '/prices',
	      component: _Prices2.default,
	      onEnter: onEnter,
	      access: [2, 3, 4, 6, 7],
	      isAvailableFree: true,
	      permissionId: 11,
	      subscriptionValue: 20,
	      customer: false,
	      topBar: {
	        title: 1172,
	        icon: _icons.MainMenuIcons.PriceLists_White
	      },
	      menu: {
	        order: 5,
	        title: '1172',
	        icon: _icons.MainMenuIcons.PriceLists_Black
	      }
	    }, {
	      path: '/prices/:type',
	      component: _Prices2.default,
	      onEnter: onEnter,
	      access: [2, 3, 4, 6, 7],
	      permissionId: 11,
	      customer: false,
	      isAvailableFree: true
	    }, {
	      path: '/prices/:type/:value',
	      component: _Prices2.default,
	      onEnter: onEnter,
	      access: [2, 3, 4, 6, 7],
	      permissionId: 11,
	      customer: false,
	      isAvailableFree: true
	    }, {
	      path: '/qualitychecksettings',
	      component: _QualityCheckSettings2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: false,
	      subscriptionValue: 30,
	      permissionId: 22,
	      topBar: {
	        title: function title(department) {
	          return department === 1 ? 17893 : 13421;
	        },
	        icon: _icons.MainMenuIcons.QualityCheck_White
	      },
	      menu: {
	        order: 6,
	        title: function title(department) {
	          return department === 1 ? '17893' : '13421';
	        },
	        icon: _icons.MainMenuIcons.QualityCheck_Black
	      },
	      childRoutes: [{
	        path: ':type',
	        component: _QualityCheckSettingsChild2.default,
	        onEnter: onEnter,
	        access: [2, 3, 7],
	        isAvailableFree: false
	      }]
	    },
	    // Chain admin page (chain users does not have permissions, to handle without permissions)
	    // {
	    //   path: '/qualitychecksettings',
	    //   component: QualityCheckSettings,
	    //   onEnter: onEnter,
	    //   access: [2],
	    //   isAvailableFree: false,
	    //   menu: {
	    //     order: 6,
	    //     title: '13421',
	    //     icon: '/images/icons/menu/qualitycontrol-Black.png'
	    //   },
	    //   childRoutes: [
	    //     {
	    //       path: ':type',
	    //       component: QualityCheckSettingsChild,
	    //       onEnter: onEnter,
	    //       access: [2, 3, 7],
	    //       isAvailableFree: false
	    //     }
	    //   ]
	    // },
	    {
	      path: '/settings',
	      component: _Settings2.default,
	      onEnter: onEnter,
	      access: [2, 3, 7],
	      permissionId: [6, 11, [12, 19], 22],
	      isAvailableFree: true,
	      topBar: {
	        title: 6,
	        icon: _icons.MainMenuIcons.Settings_White
	      },
	      menu: {
	        order: 150,
	        title: '6',
	        icon: _icons.MainMenuIcons.Settings_Black
	      }
	    }, {
	      path: '/settings/:type',
	      component: _Settings2.default,
	      onEnter: onEnter,
	      access: [2, 3, 7],
	      isAvailableFree: true,
	      topBar: {
	        title: 6,
	        icon: _icons.MainMenuIcons.Settings_White
	      }
	    }, {
	      path: '/conflicts',
	      component: _Conflicts2.default,
	      onEnter: onEnter,
	      access: [6],
	      isAvailableFree: false,
	      topBar: {
	        title: 12304,
	        icon: _icons.MainMenuIcons.Settings_White
	      },
	      menu: {
	        order: 150,
	        title: '12304',
	        icon: _icons.MainMenuIcons.Settings_Black
	      }
	    }, {
	      path: '/conflicts/:customerId',
	      component: _Conflicts2.default,
	      onEnter: onEnter,
	      access: [6],
	      isAvailableFree: false
	    }, {
	      path: '/wpemployees',
	      component: _Contacts4.default,
	      onEnter: onEnter,
	      access: [6],
	      isAvailableFree: false,
	      topBar: {
	        title: 10,
	        icon: _icons.MainMenuIcons.Employees_White
	      },
	      menu: {
	        order: 160,
	        title: '10',
	        icon: _icons.MainMenuIcons.Employees_Black
	      }
	    }, {
	      path: '/forsilist',
	      component: _ForsiList2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false,
	      topBar: {
	        title: 2228,
	        icon: _icons.MainMenuIcons.Forsi_White
	      },
	      menu: {
	        order: 10,
	        title: '2228',
	        icon: _icons.MainMenuIcons.Forsi_Black
	      }
	    }, {
	      path: '/insurancecompanylist',
	      component: _InsuranceCompanyList2.default,
	      onEnter: onEnter,
	      access: [2, 3, 7, 8],
	      isAvailableFree: false,
	      permissionId: 11,
	      subscriptionValue: 10,
	      topBar: {
	        title: 13044,
	        icon: _icons.MainMenuIcons.Insurance_White
	      },
	      menu: {
	        order: 7,
	        title: '13044',
	        icon: _icons.MainMenuIcons.Insurance_Black
	      }
	    }, {
	      path: '/chains',
	      component: _Chains2.default,
	      onEnter: onEnter,
	      access: [1],
	      isAvailableFree: false,
	      topBar: {
	        title: 1700,
	        icon: _icons.MainMenuIcons.Chain_White
	      },
	      menu: {
	        order: 1,
	        title: '1700',
	        icon: _icons.MainMenuIcons.Chain_Black
	      }
	    }, {
	      path: '/chains/:type',
	      component: _Chains2.default,
	      onEnter: onEnter,
	      access: [1],
	      isAvailableFree: false
	    }, {
	      path: '/chains/:chainID/managers',
	      component: _Managers2.default,
	      onEnter: onEnter,
	      access: [1],
	      isAvailableFree: false
	    }, {
	      path: '/chains/:chainID/managers/:managerID',
	      component: _Managers2.default,
	      onEnter: onEnter,
	      access: [1],
	      isAvailableFree: false
	    }, {
	      path: '/performance',
	      component: _Performance2.default,
	      onEnter: onEnter,
	      access: [1],
	      isAvailableFree: false,
	      topBar: {
	        title: 18369,
	        icon: _icons.MainMenuIcons.Forsi_White
	      },
	      menu: {
	        order: 2,
	        title: 18369,
	        icon: _icons.MainMenuIcons.Forsi_Black
	      }
	    }, {
	      path: '/customers',
	      component: _Customers2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: true,
	      permissionId: 7,
	      topBar: {
	        title: 14,
	        icon: _icons.MainMenuIcons.Customers_White
	      },
	      menu: {
	        order: 8,
	        title: '14',
	        icon: _icons.MainMenuIcons.Customers_Black
	      }
	    }, {
	      path: '/customers/:customerID',
	      component: _Single2.default,
	      onEnter: onEnter,
	      access: [0], // 4 - HUSK: reinsert
	      isAvailableFree: true,
	      permissionId: 7,
	      topBar: {
	        title: 700,
	        icon: _icons.MainMenuIcons.Settings_White
	      },
	      menu: {
	        order: 100,
	        title: '700',
	        icon: _icons.MainMenuIcons.Settings_Black,
	        parser: function parser(user, link) {
	          return link.replace(':customerID', user.CustomerId);
	        }
	      }
	    }, {
	      path: '/customers/:customerID/contacts',
	      component: _Contacts2.default,
	      onEnter: onEnter,
	      access: [3, 4, 7],
	      isAvailableFree: true,
	      topBar: {
	        title: 13460,
	        icon: _icons.MainMenuIcons.Customers_White
	      },
	      menu: {
	        order: 4,
	        title: '13460',
	        icon: _icons.MainMenuIcons.Customers_Black,
	        access: [0], // 4 - HUSK: reinsert
	        parser: function parser(user, link) {
	          return link.replace(':customerID', user.CustomerId);
	        }
	      }
	    }, {
	      path: '/customers/:customerID/contacts/:contactID',
	      component: _Contacts2.default,
	      onEnter: onEnter,
	      access: [3, 4, 7],
	      isAvailableFree: true,
	      topBar: {
	        title: 13460,
	        icon: _icons.MainMenuIcons.Customers_White
	      }
	    }, {
	      path: '/customers/:customerID/prices',
	      component: _Prices2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      customer: true,
	      isAvailableFree: true,
	      topBar: {
	        title: 1172,
	        icon: _icons.MainMenuIcons.PriceLists_White
	      }
	    }, {
	      path: '/customers/:customerID/prices/:type',
	      component: _Prices2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      customer: true,
	      isAvailableFree: true,
	      topBar: {
	        title: 1172,
	        icon: _icons.MainMenuIcons.PriceLists_White
	      }
	    }, {
	      path: '/customers/:customerID/prices/:type/:value',
	      component: _Prices2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      customer: true,
	      isAvailableFree: true,
	      topBar: {
	        title: 1172,
	        icon: _icons.MainMenuIcons.PriceLists_White
	      }
	    }, {
	      path: '/customers/:customerID/prices/:type/:value/:separateType',
	      component: _Prices2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      customer: true,
	      isAvailableFree: true,
	      topBar: {
	        title: 1172,
	        icon: _icons.MainMenuIcons.PriceLists_White
	      }
	    }, {
	      path: '/employees',
	      component: _Employees2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: true,
	      permissionId: 9,
	      topBar: {
	        title: 10,
	        icon: _icons.MainMenuIcons.Employees_White
	      },
	      menu: {
	        order: 11,
	        title: '10',
	        icon: _icons.MainMenuIcons.Employees_Black
	      }
	    }, {
	      path: '/shops',
	      component: _Shops2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: true,
	      topBar: {
	        title: 1861,
	        icon: _icons.MainMenuIcons.Shops_White
	      },
	      menu: {
	        order: 13,
	        title: '1861',
	        icon: _icons.MainMenuIcons.Shops_Black
	      }
	    }, {
	      path: '/smalldashboard',
	      component: _SmallDashboard2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      ValidShopCheck: [3, 7],
	      isAvailableFree: false,
	      hasValidShop: [0, 1, 2],
	      subscriptionValue: 30,
	      permissionId: 10,
	      topBar: {
	        title: 389,
	        icon: _icons.MainMenuIcons.Statistics_White
	      },
	      menu: {
	        order: 14,
	        title: '389',
	        icon: _icons.MainMenuIcons.Statistics_Black
	      }
	    }, {
	      path: '/datawarehouse/:reportType',
	      component: _DataWarehouse2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      ValidShopCheck: [3, 7],
	      isAvailableFree: false,
	      hasValidShop: [0, 1, 2],
	      subscriptionValue: 30,
	      permissionId: 10,
	      topBar: {
	        title: 389,
	        icon: _icons.MainMenuIcons.Statistics_White
	      }
	    }, {
	      path: '/shopowners',
	      component: _ShopOwners2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false,
	      topBar: {
	        title: 1860,
	        icon: _icons.MainMenuIcons.Customers_White
	      },
	      menu: {
	        order: 12,
	        title: '1860',
	        icon: _icons.MainMenuIcons.Customers_Black
	      }
	    }, {
	      path: '/managers',
	      component: _Managers2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false,
	      topBar: {
	        title: 1862,
	        icon: _icons.MainMenuIcons.Customers_White
	      },
	      menu: {
	        order: 14,
	        title: '1862',
	        icon: _icons.MainMenuIcons.Customers_Black
	      }
	    }, {
	      path: '/partners/:partnerID',
	      component: _Partners2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false,
	      topBar: {
	        title: 1879,
	        icon: _icons.MainMenuIcons.Partners_White
	      }
	    }, {
	      path: '/partners',
	      component: _Partners2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false,
	      topBar: {
	        title: 1879,
	        icon: _icons.MainMenuIcons.Partners_White
	      },
	      menu: {
	        order: 2,
	        title: '1879',
	        icon: _icons.MainMenuIcons.Partners_Black
	      }
	    }, {
	      path: '/invoicing',
	      component: _Invoicing2.default,
	      onEnter: onEnter,
	      access: [6],
	      isAvailableFree: false,
	      topBar: {
	        title: 13486,
	        icon: _icons.MainMenuIcons.Partners_White
	      },
	      menu: {
	        order: 18,
	        title: '13486',
	        icon: _icons.MainMenuIcons.Partners_Black
	      }
	    }, {
	      path: '/partners/:partnerID/contacts',
	      component: _Contacts4.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false
	    }, {
	      path: '/partners/:partnerID/contacts/:contactID',
	      component: _Contacts4.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false
	    }, {
	      path: '/partners/:partnerID/constraints',
	      component: _Constraints2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false
	    }, {
	      path: '/partners/:partnerID/constraints/:ConstraintID',
	      component: _Constraints2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false
	    }, {
	      path: '/partners/:partnerID/prices',
	      component: _Prices2.default,
	      onEnter: onEnter,
	      access: [2],
	      partners: true,
	      isAvailableFree: false
	    }, {
	      path: '/partners/:partnerID/prices/:type',
	      component: _Prices2.default,
	      onEnter: onEnter,
	      access: [2],
	      partners: true,
	      isAvailableFree: false
	    },
	    /* {
	      path: '/priceagreements',
	      component: PriceAgreements,
	      onEnter: onEnter,
	      access: [6],
	      isAvailableFree: false,
	      menu: {
	        order: 4,
	        title: 'Constraints @',
	        icon: '/images/icons/menu/Partners-Black.png'
	      }
	    },
	    {
	      path: '/priceagreements/:ConstraintID',
	      component: PriceAgreements,
	      onEnter: onEnter,
	      access: [6],
	      isAvailableFree: false
	    }, */
	    {
	      path: '/agreements',
	      component: _Agreements2.default,
	      onEnter: onEnter,
	      access: [6],
	      isAvailableFree: false,
	      topBar: {
	        title: 12309,
	        icon: _icons.MainMenuIcons.Partners_White
	      },
	      menu: {
	        order: 2,
	        title: '12309',
	        icon: _icons.MainMenuIcons.Partners_Black
	      }
	    }, {
	      path: '/agreements/:type',
	      component: _Agreements2.default,
	      onEnter: onEnter,
	      access: [6],
	      permissionId: 11,
	      customer: false,
	      isAvailableFree: false,
	      topBar: {
	        title: 12309,
	        icon: _icons.MainMenuIcons.Partners_White
	      }
	    }, {
	      path: '/customergroups/:customerGroupId',
	      component: _CustomerGroups2.default,
	      onEnter: onEnter,
	      access: [2, 6],
	      isAvailableFree: false,
	      topBar: {
	        title: 12308,
	        icon: _icons.MainMenuIcons.Partners_White
	      }
	    }, {
	      path: '/customergroups',
	      component: _CustomerGroups2.default,
	      onEnter: onEnter,
	      access: [2, 6],
	      isAvailableFree: false,
	      topBar: {
	        title: 12308,
	        icon: _icons.MainMenuIcons.Partners_White
	      },
	      menu: {
	        order: 3,
	        title: '12308',
	        icon: _icons.MainMenuIcons.Partners_Black
	      }
	    }, {
	      path: '/customergroups/:customerGroupID/contacts',
	      component: _Contacts6.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false
	    }, {
	      path: '/customergroups/:customerGroupID/contacts/:contactID',
	      component: _Contacts6.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false
	    }, {
	      path: '/Subcontractors',
	      component: _Subcontractors2.default,
	      onEnter: onEnter,
	      access: [6],
	      isAvailableFree: false,
	      topBar: {
	        title: 1737,
	        icon: _icons.MainMenuIcons.Subcontractors_White
	      },
	      menu: {
	        order: 9,
	        title: '1737',
	        icon: _icons.MainMenuIcons.Subcontractors_Black
	      }
	    },
	    // {
	    //   path: '/manualupdate/:orderID',
	    //   component: ManualUpdate,
	    //   onEnter: onEnter,
	    //   access: [3, 7],
	    //   isAvailableFree: true,
	    //   topBar: {
	    //     title: 1789,
	    //     icon: HeaderIcons.Update_White
	    //   }
	    // },
	    {
	      path: '/supportaccess',
	      component: _SupportAccessUser2.default,
	      access: [3],
	      topBar: {
	        title: 17967,
	        icon: _icons.MainMenuIcons.Employees_White
	      }
	    }, {
	      path: '/changepassword',
	      component: _ChangePass2.default,
	      isAvailableFree: true
	    }, {
	      path: '/changepin',
	      component: _ChangePin2.default,
	      access: [3],
	      isAvailableFree: true,
	      topBar: {
	        title: 17961, // TODO: state.auth.user.UserHasPincode ? 17961 : 17977
	        icon: _icons.MainMenuIcons.PasswordChange_White
	      }
	    }, {
	      path: '/tasks',
	      component: _Tasks2.default,
	      onEnter: onEnter,
	      access: [2, 3, 7],
	      isAvailableFree: false,
	      subscriptionValue: 30,
	      permissionId: 14,
	      topBar: {
	        title: 1227,
	        icon: _icons.MainMenuIcons.Tasks_White
	      },
	      menu: {
	        order: 16,
	        title: '1227',
	        icon: _icons.MainMenuIcons.Tasks_Black
	      }
	    }, {
	      path: '/tasks/:tasksID',
	      component: _Task4.default,
	      onEnter: onEnter,
	      access: [2, 3, 7],
	      isAvailableFree: false,
	      topBar: {
	        title: 1227,
	        icon: _icons.MainMenuIcons.Tasks_White
	      }
	    }, {
	      path: '/messages',
	      component: _Messages2.default,
	      onEnter: onEnter,
	      access: [2, 3, 7],
	      isAvailableFree: false,
	      subscriptionValue: 30,
	      permissionId: 8,
	      topBar: {
	        title: 1243,
	        icon: _icons.MainMenuIcons.Messages_White
	      },
	      menu: {
	        order: 16,
	        title: '1243',
	        icon: _icons.MainMenuIcons.Messages_Black
	      }
	    }, {
	      path: '/messages/:messagesID',
	      component: _Message4.default,
	      onEnter: onEnter,
	      access: [2, 3, 7],
	      isAvailableFree: false,
	      topBar: {
	        title: 1243,
	        icon: _icons.MainMenuIcons.Messages_White
	      }
	    }, {
	      path: '/punchclock',
	      component: _PunchClock2.default,
	      onEnter: onEnter,
	      access: [3, 5, 7],
	      isAvailableFree: false,
	      subscriptionValue: 20,
	      permissionId: 12,
	      topBar: {
	        title: 437,
	        icon: _icons.MainMenuIcons.PunchClock_White
	      },
	      menu: {
	        order: 12,
	        title: '437',
	        icon: _icons.MainMenuIcons.PunchClock_Black
	      }
	    }, {
	      path: '/punchreport',
	      component: _PunchReport2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: false,
	      subscriptionValue: 20,
	      permissionId: 16,
	      onlyDev: false,
	      topBar: {
	        title: 2241,
	        icon: _icons.MainMenuIcons.HourReport_White
	      },
	      menu: {
	        order: 13,
	        title: '2241',
	        icon: _icons.MainMenuIcons.HourReport_Black
	      }
	    }, {
	      path: '/punchedit',
	      component: _PunchEdit2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: false,
	      permissionId: 12,
	      onlyDev: false
	      // menu: {
	      //   title: 'Punch edit @',
	      //   icon: '/images/icons/punch-black-30.png'
	      // }
	    }, {
	      path: '/absencereport',
	      component: _AbsenceReport2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: false
	    }, {
	      path: '/mypage',
	      component: _MyPage2.default,
	      indexRoute: {
	        component: _MyOrders2.default
	      },
	      access: [3],
	      isAvailableFree: true,
	      childRoutes: [{
	        path: 'orders',
	        component: _MyOrders2.default,
	        isAvailableFree: true,
	        topBar: {
	          title: 1887
	        },
	        childRoutes: [{
	          path: ':orderID',
	          component: _Order4.default,
	          isAvailableFree: true
	        }]
	      }, {
	        path: 'tasks',
	        component: _MyTasks2.default,
	        isAvailableFree: false,
	        topBar: {
	          title: 1887
	        },
	        childRoutes: [{
	          path: ':taskID',
	          component: _Task2.default,
	          isAvailableFree: false
	        }]
	      }, {
	        path: 'messages',
	        component: _MyMessages2.default,
	        isAvailableFree: false,
	        topBar: {
	          title: 1887
	        },
	        childRoutes: [{
	          path: ':msgID',
	          component: _Message2.default,
	          isAvailableFree: false
	        }]
	      }]
	    }, {
	      path: '/CarRental', // Should only be shown for companies that does not have access to the Overview
	      component: _CarRental2.default,
	      access: [3, 7],
	      isAvailableFree: false,
	      permissionId: 11, // 11: "Shop 1", 29: "Rental car overview"
	      subscriptionValue: 10,
	      // maxSubscriptionValue: 20,
	      exclPermissionId: 29, // Excl. when access to overview
	      topBar: {
	        title: 14778,
	        icon: _icons.MainMenuIcons.CarRental_White
	      },
	      menu: {
	        order: 11,
	        title: '14778',
	        icon: _icons.MainMenuIcons.CarRental_Black
	      }
	    }, {
	      path: '/CarRentals/Overview',
	      component: _CarRentals2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: false,
	      permissionId: 29,
	      subscriptionValue: 20,
	      topBar: {
	        title: 15105,
	        icon: _icons.MainMenuIcons.CarRental_White
	      },
	      menu: {
	        order: 4,
	        title: '15105',
	        icon: _icons.MainMenuIcons.CarRental_Black
	      }
	    }, {
	      path: '/collaboratingPartners',
	      component: _CollaboratingPartners2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: false,
	      permissionId: 29,
	      subscriptionValue: 20,
	      ValidShopCheck: [3, 7],
	      hasValidShop: [1, 2],
	      checkAuth: function checkAuth(auth) {
	        return auth.permissions.IsCollaboratingPartnersAvailable;
	      },
	      topBar: {
	        title: 17906,
	        icon: _icons.MainMenuIcons.CollaboratingPartners_White
	      },
	      menu: {
	        order: 8,
	        title: '17906',
	        icon: _icons.MainMenuIcons.CollaboratingPartners_Black
	      }
	    }, {
	      path: '/sparepartsuppliers',
	      component: _SparePartsSuppliers2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      permissionId: 31,
	      isAvailableFree: false,
	      subscriptionValue: 30,
	      ValidShopCheck: [3, 7],
	      hasValidShop: [1, 2],
	      topBar: {
	        title: 16424,
	        icon: _icons.MainMenuIcons.SpareParts_White
	      },
	      menu: {
	        order: 8,
	        title: '16506',
	        icon: _icons.MainMenuIcons.SpareParts_Black
	      },
	      childRoutes: [{
	        path: ':supplierID',
	        component: _SparePartsSuppliers2.default
	      }]
	    }, {
	      path: '/productionstatus',
	      component: _ProductionStatusOverview2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: false,
	      subscriptionValue: 30,
	      topBar: {
	        title: '16599'
	      }
	    }, {
	      path: '/deliverystatus',
	      component: _DeliveryStatusOverview2.default,
	      onEnter: onEnter,
	      access: [3, 7],
	      isAvailableFree: false,
	      subscriptionValue: 30,
	      topBar: {
	        title: 16599
	      }
	    }, {
	      path: '/integrationerrorlist',
	      component: _IntegrationErrorList2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false,
	      topBar: {
	        title: 18163,
	        icon: _icons.MainMenuIcons.Forsi_White
	      },
	      menu: {
	        order: 11,
	        title: 18163,
	        icon: _icons.MainMenuIcons.Forsi_Black
	      }
	    }, {
	      path: '/chainesg',
	      component: _Chain2.default,
	      onEnter: onEnter,
	      access: [2],
	      isAvailableFree: false,
	      topBar: {
	        title: 18401,
	        icon: _icons.MainMenuIcons.Statistics_White
	      },
	      menu: {
	        order: 17,
	        title: 18401,
	        icon: _icons.MainMenuIcons.Statistics_Black
	      },
	      childRoutes: [{
	        path: ':chemaId',
	        component: _Chain2.default
	      }]
	    }, {
	      path: '/esg',
	      component: _Company2.default,
	      onEnter: onEnter,
	      access: [7, 3], // owners and employees
	      permissionId: 11,
	      isAvailableFree: false,
	      checkAuth: function checkAuth(auth) {
	        return auth.companyHaveAssignedESG;
	      },
	      topBar: {
	        title: 18401,
	        icon: _icons.MainMenuIcons.Statistics_White
	      },
	      menu: {
	        order: 15,
	        title: 18401,
	        icon: _icons.MainMenuIcons.Statistics_Black
	      }
	    }]
	  }, {
	    path: '*',
	    component: _NoMatch2.default
	  }];
	};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	__webpack_require__(337);
	
	var _backdrop = __webpack_require__(29);
	
	var _orders = __webpack_require__(21);
	
	var _invoicing = __webpack_require__(150);
	
	var _ActionMenu = __webpack_require__(230);
	
	var _ActionMenu2 = _interopRequireDefault(_ActionMenu);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _ResendText = __webpack_require__(288);
	
	var _ResendText2 = _interopRequireDefault(_ResendText);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _PhotoDocModal = __webpack_require__(469);
	
	var _PhotoDocModal2 = _interopRequireDefault(_PhotoDocModal);
	
	var _MoveModal = __webpack_require__(458);
	
	var _MoveModal2 = _interopRequireDefault(_MoveModal);
	
	var _LinkOrdersModal = __webpack_require__(1093);
	
	var _LinkOrdersModal2 = _interopRequireDefault(_LinkOrdersModal);
	
	var _CreateEstimationModal = __webpack_require__(237);
	
	var _CreateEstimationModal2 = _interopRequireDefault(_CreateEstimationModal);
	
	var _ReferenceOrderModal = __webpack_require__(1113);
	
	var _ReferenceOrderModal2 = _interopRequireDefault(_ReferenceOrderModal);
	
	var _StopLockOrderModal = __webpack_require__(475);
	
	var _StopLockOrderModal2 = _interopRequireDefault(_StopLockOrderModal);
	
	var _QualityCheckModal = __webpack_require__(204);
	
	var _QualityCheckModal2 = _interopRequireDefault(_QualityCheckModal);
	
	var _OtherPriceModal = __webpack_require__(303);
	
	var _OtherPriceModal2 = _interopRequireDefault(_OtherPriceModal);
	
	var _MarkAsWreckedModal = __webpack_require__(1094);
	
	var _MarkAsWreckedModal2 = _interopRequireDefault(_MarkAsWreckedModal);
	
	var _ReferenceOrderActionModal = __webpack_require__(305);
	
	var _ReferenceOrderActionModal2 = _interopRequireDefault(_ReferenceOrderActionModal);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import components
	
	
	// Modals
	
	
	// Utils
	
	
	// Elements
	// import Check from '../../../elements/check'
	
	var OrderActions = function (_PureComponent) {
	  _inherits(OrderActions, _PureComponent);
	
	  function OrderActions(props) {
	    _classCallCheck(this, OrderActions);
	
	    var _this = _possibleConstructorReturn(this, (OrderActions.__proto__ || Object.getPrototypeOf(OrderActions)).call(this, props));
	
	    _this.state = {
	      confirm: {
	        open: false
	      },
	      cancelReferral: {
	        open: false
	      },
	      photodoc: {
	        open: false
	      },
	      moveItem: {
	        open: false,
	        type: 0
	      },
	      linkorders: {
	        open: false,
	        id: 0
	      },
	      estimation: {
	        open: false,
	        id: 0
	      },
	      referenceorder: {
	        open: false,
	        id: 0
	      },
	      stoplockorder: {
	        open: false,
	        id: 0
	      },
	      quality: {
	        open: false,
	        data: {},
	        index: 0,
	        pos: 0
	      },
	      assignEmployees: {
	        open: false
	      },
	      showAddonPopup: false,
	      confirmResendInvoice: {
	        open: false,
	        splitAddon: false,
	        hasAddon: false
	      },
	      item: {},
	      otherPopup: {
	        open: false,
	        other: {
	          Title: '',
	          Price: '',
	          Environment: '',
	          Description: ''
	        }
	      },
	      lastHistory: {
	        FoundHistory: false
	      },
	      isLoadingLastHistory: false,
	      confirmMarkAsWrecked: {
	        open: false
	      },
	      newDelivery: undefined,
	      isMoreThanHalfAnHour: false,
	      isStopped: false
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.renderActionMenu = _this.renderActionMenu.bind(_this);
	    _this.onConfirm = _this.onConfirm.bind(_this);
	    _this.onConfirmResend = _this.onConfirmResend.bind(_this);
	    _this.updateRow = _this.updateRow.bind(_this);
	    _this.renderConfirmResendInvoiceDialog = _this.renderConfirmResendInvoiceDialog.bind(_this);
	    _this.confirmAddon = _this.confirmAddon.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderActions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._mounted = true;
	      var item = _extends({}, this.props.item);
	      item.StepIndex = this.props.step;
	      item.ItemIndex = this.props.index;
	      this.setState({
	        confirmResendInvoice: {
	          open: false,
	          splitAddon: item.SeparateAddonInvoice,
	          hasAddon: false
	        },
	        item: item,
	        otherPopup: {
	          open: false,
	          other: {
	            Title: item.OtherTitle,
	            Price: item.Price,
	            Environment: item.Environment,
	            Description: item.Description
	          }
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(this.props.item, nextProps.item)) {
	        var item = _extends({}, nextProps.item);
	        item.StepIndex = this.props.step;
	        item.ItemIndex = this.props.index;
	        this.setState({
	          confirmResendInvoice: {
	            open: false,
	            splitAddon: item.SeparateAddonInvoice,
	            hasAddon: false
	          },
	          item: item,
	          otherPopup: {
	            open: false,
	            other: {
	              Title: item.OtherTitle,
	              Price: item.Price,
	              Environment: item.Environment,
	              Description: item.Description
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._mounted = false;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(el) {
	      var _this2 = this;
	
	      switch (el.dataset.action) {
	        case 'delete':
	          this.setState({
	            confirm: {
	              open: !this.state.confirm.open
	            }
	          });
	          break;
	        case 'cancelReferral':
	          this.props.triggerPopup(!this.state.cancelReferral.open);
	          this.setState({
	            cancelReferral: {
	              open: !this.state.cancelReferral.open
	            }
	          });
	          break;
	        case 'photo':
	          this.props.triggerPopup(!this.state.photodoc.open);
	          this.setState({
	            photodoc: {
	              open: !this.state.photodoc.open
	            }
	          });
	          break;
	        case 'estimation':
	          this.props.triggerPopup(!this.state.estimation.open);
	          this.setState({
	            estimation: {
	              open: !this.state.estimation.open,
	              id: this.state.item.Id
	            }
	          });
	          break;
	        case 'linkOrders':
	          this.props.triggerPopup(!this.state.linkorders.open);
	          this.setState({
	            linkorders: {
	              open: !this.state.linkorders.open,
	              id: this.state.item.Id
	            }
	          });
	          break;
	        case 'referenceOrder':
	          this.props.triggerPopup(!this.state.referenceorder.open);
	          this.setState({
	            referenceorder: {
	              open: !this.state.referenceorder.open,
	              id: this.state.item.Id
	            }
	          });
	          break;
	        case 'stopLockOrder':
	          if (this.state.item.IsStopped) {
	            this.props.GetNewDeliveryForResume(this.props.item.Id).then(function (res) {
	              if (res.data !== null) {
	                _this2.setState({
	                  newDelivery: res.data.NewDeliveryDateTime,
	                  isMoreThanHalfAnHour: res.data.IsMoreThanHalfAnHour,
	                  isStopped: res.data.IsStopped
	                }, function () {
	                  // isStopped = false from backend if not manual stop
	                  _this2.props.triggerPopup(!_this2.state.stoplockorder.open);
	                  _this2.setState({
	                    stoplockorder: {
	                      open: !_this2.state.stoplockorder.open,
	                      id: _this2.state.item.Id
	                    }
	                  });
	                });
	              }
	            });
	          } else {
	            this.props.triggerPopup(!this.state.stoplockorder.open);
	            this.setState({
	              stoplockorder: {
	                open: !this.state.stoplockorder.open,
	                id: this.state.item.Id
	              }
	            });
	          }
	
	          break;
	        case 'move':
	          this.props.triggerPopup(!this.state.moveItem.open);
	          var item = _extends({}, this.state.item);
	          // item.NewStepId = (parseInt(el.dataset.type) === 1) ? item.StepId - 1 : item.StepId + 1
	          this.setState({
	            moveItem: {
	              open: !this.state.moveItem.open,
	              type: parseInt(el.dataset.type)
	            },
	            item: item
	          });
	          break;
	        case 'finishOrder':
	          // this.props.triggerPopup(!this.state.moveItem.open) // disabled - would trigger modal state but never revert.
	          this.props.onOrderMove({ OrderIds: [this.props.item.Id], UserId: 0, StepFrom: this.props.item.StepId, StepTo: 8 /*  (item.StepId + 1) */, Comment: '', FilterSettings: {} });
	          break;
	        case 'afterevaluation':
	          this.props.router.push('/pricecalculation/' + this.props.item.Id + '/4');
	          break;
	        case 'newpricecalculation':
	          if (this.props.item.OrderType !== 4) {
	            this.props.router.push('/pricecalculation/' + this.props.item.Id + '/1');
	          } else {
	            this.setState({
	              otherPopup: _extends({}, this.state.otherPopup, {
	                open: true
	              })
	            });
	          }
	          break;
	        case 'internalDeviation':
	          this.props.router.push('/pricecalculation/' + this.props.item.Id + '/5');
	          // To prevent possibly changing an earlier orderPrice in Extent
	          window.location.reload();
	          break;
	        case 'externalDeviation':
	          this.props.router.push('/pricecalculation/' + this.props.item.Id + '/6');
	          // To prevent possibly changing an earlier orderPrice in Extent
	          window.location.reload();
	          break;
	        case 'resendInvoice':
	          this.setState({
	            isLoadingLastHistory: true
	          }, function () {
	            _this2.props.invoiceHistory(_this2.props.item.Id).then(function (res) {
	              _this2.setState({
	                lastHistory: res.data,
	                isLoadingLastHistory: false
	                // }, { () => console.log('[OrderActions][loadinglasthistory]', this.state)
	              });
	            });
	          });
	          this.setState({
	            confirmResendInvoice: _extends({}, this.state.confirmResendInvoice, {
	              open: !this.state.confirmResendInvoice.open
	            })
	          });
	          break;
	        case 'evaluationHistory':
	          this.props.router.push('/evaluationhistory/' + this.props.item.Id);
	          break;
	        case 'assignEmployees':
	          this.setState({
	            assignEmployees: {
	              open: true
	            }
	          }, function () {
	            // this.props.checkForPopups()
	            _this2.props.triggerClickAssign();
	          });
	          break;
	        case 'markAsWrecked':
	          this.props.triggerPopup(!this.state.confirmMarkAsWrecked.open);
	          this.setState({
	            confirmMarkAsWrecked: {
	              open: true
	            }
	          });
	          break;
	      }
	    }
	  }, {
	    key: 'renderActionMenu',
	    value: function renderActionMenu() {
	      var _this3 = this;
	
	      var item = this.state.item;
	      // Render move back
	
	      var shouldNotRender = !(0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType) || this.props.itemType === '1' || item.IsDraft || !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 1);
	      var renderMoveBack = function renderMoveBack() {
	        if (shouldNotRender) return null;
	        if (_this3.props.item.IsReferredOut) return null;
	        if (item.StepId !== 0 && item.StepId !== 1 && item.StepId !== 8 && ((0, _auth.hasAccess)([7], _this3.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 30) || (0, _auth.hasSubscriptionPermission)(_this3.props.auth, 30, 20))) {
	          return _react2.default.createElement(
	            'a',
	            { 'data-action': 'move', 'data-type': '1' },
	            _react2.default.createElement('img', { src: '/images/icons/Backward.png' }),
	            (0, _helpers.translation)('13481')
	          );
	        }
	        return null;
	      };
	      // Render move forward
	      var renderMoveForward = function renderMoveForward() {
	        if (shouldNotRender) return null;
	        if (_this3.props.item.IsReferredOut) return null;
	        if (item.StepId < 7 || item.StepId > 8) {
	          return _react2.default.createElement(
	            'a',
	            { 'data-action': 'move', 'data-type': '2' },
	            _react2.default.createElement('img', { src: '/images/icons/Forward.png' }),
	            (0, _helpers.translation)('13479')
	          );
	        }
	        return null;
	      };
	      // Render move forward
	      var renderFinishOrder = function renderFinishOrder() {
	        if (shouldNotRender) return null;
	        if (_this3.props.item.IsReferredOut) return null;
	        if (item.StepId === 7 && !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 20, 1)) {
	          return _react2.default.createElement(
	            'a',
	            { 'data-action': 'finishOrder' },
	            _react2.default.createElement('img', { src: '/images/icons/Forward.png' }),
	            (0, _helpers.translation)('15269')
	          );
	        }
	        return null;
	      };
	      // Render after evaluation
	      var renderAfterEvaluation = function renderAfterEvaluation() {
	        if (!(0, _auth.hasAccess)([3, 5, 6, 7], _this3.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 30, 26) && !(0, _auth.hasAccess)([6], _this3.props.auth.user.UserType)) return null;
	        if (item.IsDraft) return null;
	        if (item.OrderDepartment === 1) return null;
	        if (_this3.props.auth.user.DepartmentType === 1) return null;
	        if (item.OrderType === 1) {
	          return _react2.default.createElement(
	            'a',
	            { 'data-action': 'afterevaluation' },
	            _react2.default.createElement('img', { src: '/images/svgs/menuicons/after-charge.svg' }),
	            (0, _helpers.translation)('1037')
	          );
	        }
	        return null;
	      };
	      // render new pricecalculation
	      var renderNewPriceclaculations = function renderNewPriceclaculations() {
	        if (!(0, _auth.hasAccess)([3, 5, 6, 7], _this3.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 20, 2)) return null;
	        if (item.OrderDepartment === 1 || item.IsDraft) return null;
	        if (_this3.props.auth.user.DepartmentType === 1) return null;
	        if (item.IsAssessmentOk) return null;
	        if (item.OrderType !== 1) {
	          return _react2.default.createElement(
	            'a',
	            { 'data-action': 'newpricecalculation' },
	            _react2.default.createElement('img', { src: '/images/svgs/menuicons/New_price_calculation.svg' }),
	            (0, _helpers.translation)('13565')
	          );
	        }
	        return null;
	      };
	      // Render quality doc
	      var renderQualityDoc = function renderQualityDoc() {
	        if (!(0, _auth.hasAccess)([3, 5, 7], _this3.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 10, 21)) return null;
	        // if (item.OrderDepartment === 1) return null
	        // if (this.props.auth.user.DepartmentType === 1) return null
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'photo' },
	          _react2.default.createElement('img', { src: '/images/icons/Camera.png' }),
	          (0, _helpers.translation)('2065')
	        );
	      };
	      // Render delete
	      var renderDelete = function renderDelete() {
	        if (item.IsReferredIn || item.IsReferredOut) {
	          // Can only cancel referral on paint
	          if (_this3.props.auth.user.DepartmentType === 0 && item.StepId === 1 && item.IsReferredIn && (0, _auth.hasSubscriptionPermission)(_this3.props.auth, 0, 32)) {
	            return _react2.default.createElement(
	              'a',
	              { 'data-action': 'cancelReferral' },
	              _react2.default.createElement('img', { src: '/images/icons/Delete.png' }),
	              (0, _helpers.translation)('15225')
	            );
	          }
	          return null;
	        }
	        if (_this3.props.auth.departmentType === 0 && item.HasExternalCompany) return null;
	        if (item.StepId === 1 && _this3.props.itemType !== '1') {
	          // if (hasAccess([4], this.props.auth.user.UserType) || !item.IsDraft || !hasSubscriptionPermission(this.props.auth, 0, 2)) {
	          if ((0, _auth.hasAccess)([4], _this3.props.auth.user.UserType) && !item.IsDraft || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 0, 32)) {
	            return null;
	          }
	          return _react2.default.createElement(
	            'a',
	            { 'data-action': 'delete' },
	            _react2.default.createElement('img', { src: '/images/icons/Delete.png' }),
	            (0, _helpers.translation)('786')
	          );
	        }
	        return null;
	      };
	      // Render empty message
	      var renderEmptyMessage = function renderEmptyMessage() {
	        // if (hasAccess([4], this.props.auth.user.UserType) && item.StepId !== 1 && !item.IsDraft) {
	        if ((0, _auth.hasAccess)([4], _this3.props.auth.user.UserType) && !item.IsDraft && item.IsEvaluation && !item.IsEvaluationRejected) {
	          // No valid options for user
	          return _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('2023')
	          );
	        }
	        return null;
	      };
	      // Deviation links
	      var renderInternalDeviationLink = function renderInternalDeviationLink() {
	        if (!(0, _auth.hasAccess)([3, 5, 7], _this3.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 30, 20) || _this3.props.item.OrderType === 4) return null;
	        if (item.IsDraft) return null;
	        if (item.OrderDepartment === 1) return null;
	        if (_this3.props.auth.user.DepartmentType === 1) return null;
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'internalDeviation' },
	          _react2.default.createElement('img', { src: '/images/icons/External-Deviation.png' }),
	          (0, _helpers.translation)('310')
	        ) // It is the correct img
	        ;
	      };
	      var renderExternalDeviationLink = function renderExternalDeviationLink() {
	        if (!(0, _auth.hasAccess)([3, 5, 7], _this3.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 30, 20) || _this3.props.item.OrderType === 4) return null;
	        if (item.IsDraft) return null;
	        if (item.OrderDepartment === 1) return null;
	        if (_this3.props.auth.user.DepartmentType === 1) return null;
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'externalDeviation' },
	          _react2.default.createElement('img', { src: '/images/icons/Internal-Deviation.png' }),
	          (0, _helpers.translation)('311')
	        ) // It is the correct img
	        ;
	      };
	      // Link orders
	      var linkOrders = function linkOrders() {
	        if (item.IsDraft || _this3.props.auth.departmentType === 1) return null;
	        if (!(0, _auth.hasAccess)([3, 5, 7], _this3.props.auth.user.UserType) || _this3.props.itemType === '1' || _this3.props.step === 9 || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 30, 13)) return renderNewPriceclaculations;
	        // if (item.OrderDepartment === 1) return null
	        // if (this.props.auth.user.DepartmentType === 1) return null
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'linkOrders' },
	          _react2.default.createElement('img', { src: '/images/icons/Link-Black.png' }),
	          (0, _helpers.translation)('1848')
	        );
	      };
	      var createEstimation = function createEstimation() {
	        if (!(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 30)) return null;
	        if (item.IsEvaluation && !item.IsEvaluationRejected || item.OrderType === 4 || item.OrderType === 5) return null;
	        if (item.OrderDepartment === 1 && !item.IsPaintOrder) return null;
	        if (item.IsReferredIn) return null;
	        if (item.StepId === 8) return null;
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'estimation' },
	          _react2.default.createElement('img', { src: '/images/svgs/menuicons/additional-support_VS.svg' }),
	          (0, _helpers.translation)('13363')
	        );
	      };
	      // Reference order
	      var referenceOrder = function referenceOrder() {
	        // console.log('reference order', 'itemType', this.props.itemType, 'item', item, 'auth', this.props.auth, 'IsReferrable', item.IsReferrable)
	        if (!(0, _auth.hasAccess)([3, 5, 7], _this3.props.auth.user.UserType) || _this3.props.itemType === '1' || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 30, 5)) return null;
	        if (!item.IsReferrable) return null;
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'referenceOrder' },
	          _react2.default.createElement('img', { src: '/images/icons/Referred16.png' }),
	          (0, _helpers.translation)('2106')
	        );
	      };
	      // Stop Lock Order
	      var stopLockOrder = function stopLockOrder() {
	        if (!(0, _auth.hasAccess)([3, 5, 7], _this3.props.auth.user.UserType) || _this3.props.itemType === '1') return null;
	        if (!(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 10, 13)) return null;
	        if (_this3.props.item.IsReferredOut) return null;
	        if (item.StepId === 8 || item.IsDraft) return null;
	        // if (this.props.auth.departmentType === 1) { return null }
	        if (_this3.state.item.IsStopped) {
	          return _react2.default.createElement(
	            'a',
	            { 'data-action': 'stopLockOrder' },
	            _react2.default.createElement('img', { src: '/images/icons/stop-hand-32x32.png' }),
	            (0, _helpers.translation)('2220')
	          );
	        }
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'stopLockOrder' },
	          _react2.default.createElement('img', { src: '/images/icons/stop-hand-32x32.png' }),
	          (0, _helpers.translation)('2218')
	        );
	      };
	      // Resend for invoicing
	      var resendInvoice = function resendInvoice() {
	        if (_this3.props.type === 'workscreen') return null;
	        if (!(0, _auth.hasAccess)([3, 5, 6, 7], _this3.props.auth.user.UserType) || _this3.props.itemType === '1') return null;
	        if (_this3.props.item.IsDraft || !(0, _auth.hasAccess)([6], _this3.props.auth.user.UserType) && !(_this3.props.item.IsInvoiced || _this3.props.item.IsMarkInvoiced)) return null;
	        if ((0, _auth.hasAccess)([6], _this3.props.auth.user.UserType) && !(_this3.props.item.IsInvoicedByWP || _this3.props.item.IsMarkInvoicedByWP)) return null;
	        if (!(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 10, 6)) return null;
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'resendInvoice' },
	          _react2.default.createElement('img', { src: '/images/svgs/invoice/resend-for-invoice.svg' }),
	          (0, _helpers.translation)('13508')
	        );
	      };
	      // Evaluation history
	      var renderEvaluationHistoryLink = function renderEvaluationHistoryLink() {
	        if (!(0, _auth.hasAccess)([3, 5, 6, 7], _this3.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 20, 31) || _this3.props.auth.departmentType !== 0 || _this3.props.item.IsDraft || _this3.props.auth.permissions.ChainAssessmentSystem === _constants.AssessmentSystemType.DBS) return null;
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'evaluationHistory' },
	          _react2.default.createElement('img', { src: '/images/icons/Actions_Assessment_history.svg' }),
	          (0, _helpers.translation)('14920')
	        );
	      };
	      // Assign employees
	      var assignEmployees = function assignEmployees() {
	        if (!(0, _auth.hasAccess)([3, 5, 7], _this3.props.auth.user.UserType) || _this3.props.item.IsDraft) return null;
	        if (!(0, _auth.hasAccessToAssign)(_this3.props.auth)) return null;
	        if (!(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 10)) return null;
	        if (!(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 20) && _this3.props.auth.departmentType === 1 && _this3.props.type === 'workscreen') return null;
	        if (_this3.state.item.IsArchived) return null;
	        if (_this3.props.type === 'workscreen') return null;
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'assignEmployees' },
	          _react2.default.createElement('img', { src: '/images/icons/menu/Assign.png' }),
	          (0, _helpers.translation)('1856')
	        );
	      };
	
	      var renderMarkAsWrecked = function renderMarkAsWrecked() {
	        if (_this3.props.auth.departmentType === 0 || _this3.props.item.IsDraft || _this3.props.item.StepId === 8 || !(0, _auth.hasAccess)([3, 7], _this3.props.auth.user.UserType)) return null;
	        if (!(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 30)) return null;
	        return _react2.default.createElement(
	          'a',
	          { 'data-action': 'markAsWrecked' },
	          _react2.default.createElement('img', { src: '/images/svgs/actions/total-wreck.svg' }),
	          (0, _helpers.translation)('15239')
	        );
	      };
	
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'poppedup' },
	        renderEmptyMessage(),
	        renderDelete(),
	        renderQualityDoc(),
	        renderInternalDeviationLink(),
	        renderExternalDeviationLink(),
	        renderAfterEvaluation(),
	        renderNewPriceclaculations(),
	        renderMoveBack(),
	        renderMoveForward(),
	        renderFinishOrder(),
	        linkOrders(),
	        createEstimation(),
	        referenceOrder(),
	        stopLockOrder(),
	        resendInvoice(),
	        renderEvaluationHistoryLink(),
	        assignEmployees(),
	        renderMarkAsWrecked()
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      if (this._mounted) {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false
	        })));
	      }
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'stopLockResumeWithoutPopUp',
	    value: function stopLockResumeWithoutPopUp() {
	      var _this4 = this;
	
	      var data = {
	        ApplyToInvoice: this.state.item.OrderStop.StoppedMessageApplyToInvoice,
	        ShowCustomer: this.state.item.OrderStop.StoppedMessageShowCustomer,
	        Message: this.state.item.OrderStop.StoppedMessage,
	        OrderId: this.props.item.Id,
	        TimeAction: 2 // keep old time
	      };
	      this.props.StopLockOrder(data).then(function (res) {
	        // window.toastr.success(translation('13403'), translation('13424'))
	        _this4.onPortalClose('stoplockorder');
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('13404'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm() {
	      var _this5 = this;
	
	      if (this.props.type === 'workscreen') {
	        this.props.deleteOrderSimple(this.props.item.Id).then(function () {
	          // Close
	          if (_this5._mounted) {
	            _this5.onPortalClose('confirm');
	          }
	          // Emit event
	          _events2.default.emit('workcard_delete', {
	            id: _this5.props.item.Id,
	            step: _this5.props.step,
	            index: _this5.props.index
	          });
	          // Toastr
	          // window.toastr.success(translation('2021'), translation('13424'))
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('2022'), (0, _helpers.translation)('216'));
	          // Close
	          _this5.onPortalClose('confirm');
	        });
	      } else {
	        // Delete
	        this.props.deleteOrder(this.props.item.Id, this.props.step, this.props.index).then(function () {
	          // Toastr
	          // window.toastr.success(translation('2021'), translation('13424'))
	          // Close
	          if (_this5._mounted) {
	            _this5.onPortalClose('confirm');
	          }
	          // Update list
	          _this5.props.deleteOrderIndex(_this5.props.step, _this5.props.index);
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('2022'), (0, _helpers.translation)('216'));
	          // Close
	          if (_this5._mounted) {
	            _this5.onPortalClose('confirm');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'confirmAddon',
	    value: function confirmAddon(val) {
	      var _this6 = this;
	
	      this.setState({
	        showAddonPopup: false,
	        confirmResendInvoice: _extends({}, this.state.confirmResendInvoice, {
	          splitAddon: val
	        })
	      }, function () {
	        _this6.onConfirmResend(true);
	      });
	    }
	  }, {
	    key: 'renderConfirmResendInvoiceDialog',
	    value: function renderConfirmResendInvoiceDialog() {
	      // const showClickError = (e) => {
	      //   let disabled = !this.props.item.CanChangeAddonInvoice
	      //   if (!disabled) return null
	      //   let error = translation('14806')
	      //   error = error.replace('[WPName]', this.props.item.WPName)
	      //   window.toastr.error(error, translation('216'))
	      // }
	      // let checked = this.state.confirmResendInvoice.splitAddon
	      // let disabled = !this.props.item.CanChangeAddonInvoice
	      var t = _helpers.translation;
	      return _react2.default.createElement(_ResendText2.default, { isLoadingLastHistory: this.state.isLoadingLastHistory, lastHistory: this.state.lastHistory, store: _store2.default, t: t });
	    }
	  }, {
	    key: 'onConfirmResend',
	    value: function onConfirmResend() {
	      var addonChecked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.state.confirmResendInvoice.open === true || this.state.showAddonPopup === true) {
	        this.setState({
	          showAddonPopup: false,
	          confirmResendInvoice: _extends({}, this.state.confirmResendInvoice, {
	            open: false
	          })
	        });
	      }
	      if (this.props.item.HasAddonPrice && this.props.item.CanChangeAddonInvoice && !addonChecked) {
	        this.setState({
	          showAddonPopup: true
	        });
	        return null;
	      }
	      var splitAddon = this.props.item.HasAddonPrice && this.state.confirmResendInvoice.splitAddon;
	      var data = {
	        OrderId: this.props.item.Id,
	        SplitAddon: splitAddon
	      };
	      this.props.invoiceOrder(data).then(function (res) {
	        // Toastr
	        // window.toastr.success(translation('13506'), translation('13424'))
	        // Close
	      }, function (err) {
	        if (err.response) {
	          if (err.response.data !== undefined && err.response.data.Error !== undefined) {
	            var error = err.response.data.Error;
	            var errorText = (0, _helpers.translation)('960');
	            // OrderNotFound = 1,
	            // CompanyNotFound = 2,
	            // NotValidEconomicCredentials = 3,
	            // NotValidHeliosNumber = 4,
	            // NotValidC5UserPass = 5,
	            // OrderIsAlreadySent = 6,
	            switch (error) {
	              case 0:
	                errorText = (0, _helpers.translation)('13700');
	                break;
	              case 1:
	                errorText = (0, _helpers.translation)('13701');
	                break;
	              case 2:
	                errorText = (0, _helpers.translation)('13702');
	                break;
	              case 3:
	                errorText = (0, _helpers.translation)('13703');
	                break;
	              case 4:
	                errorText = (0, _helpers.translation)('13704');
	                break;
	              case 5:
	                errorText = (0, _helpers.translation)('13705');
	                break;
	              case 6:
	                errorText = (0, _helpers.translation)('13706');
	                break;
	              case 7:
	                errorText = (0, _helpers.translation)('13707');
	                break;
	              case 8:
	                errorText = (0, _helpers.translation)('2710');
	                break;
	              case 9:
	                errorText = (0, _helpers.translation)('14851');
	                break;
	              case 10:
	                errorText = (0, _helpers.translation)('16616');
	                break;
	              case 11:
	                errorText = (0, _helpers.translation)('16617');
	                break;
	              case 12:
	                errorText = (0, _helpers.translation)('16650');
	                break;
	              case 13:
	                errorText = (0, _helpers.translation)('16618');
	                break;
	              case 14:
	                errorText = (0, _helpers.translation)('16636');
	                break;
	              case 15:
	                errorText = (0, _helpers.translation)('16651');
	                break;
	              case 16:
	                errorText = (0, _helpers.translation)('16619');
	                break;
	              case 17:
	                errorText = (0, _helpers.translation)('17947');
	                break;
	              case 18:
	                errorText = (0, _helpers.translation)('18145');
	                break;
	              case 19:
	                errorText = (0, _helpers.translation)('18144');
	                break;
	              default:
	                break;
	            }
	            window.toastr.error(errorText, (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	          }
	        } else {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        }
	      });
	      if (this._mounted) {
	        this.onPortalClose('confirmResendInvoice');
	      }
	    }
	  }, {
	    key: 'updateRow',
	    value: function updateRow(data, pos, index) {
	      _events2.default.emit('update_row-' + this.props.type, {
	        data: data,
	        pos: pos,
	        index: index
	      });
	    }
	  }, {
	    key: 'onMoveFailed',
	    value: function onMoveFailed(data, pos, index) {
	      this.setState({
	        quality: {
	          open: true,
	          data: data,
	          pos: pos,
	          index: index
	        }
	      });
	    }
	  }, {
	    key: 'moveOrderSuccess',
	    value: function moveOrderSuccess(data) {
	      this.onPortalClose('quality');
	      this.updateRow(data.CurrentStepOrders, this.state.quality.pos, this.state.quality.index);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var disableResend = this.state.isLoadingLastHistory === true;
	      var isDuplicate = this.props.item.OrderKey !== undefined && this.props.item.OrderKey !== null && this.props.item.OrderKey.endsWith('_LoosePart');
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var onOpenFunction = this.props.router.location.pathname === '/orders' ? this.props.clearLastVisitedOrderId : undefined;
	
	      if (isCustomer && !this.props.item.IsDraft && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) {
	        return _react2.default.createElement('div', { className: 'order__action' });
	      }
	      if (isDuplicate || this.props.item.NeedReferredApprove && this.props.item.ReferredApproved !== true) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'order__action' },
	          _react2.default.createElement('div', { className: 'action_opener' })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'order__action' },
	        _react2.default.createElement(_ActionMenu2.default, { renderActionMenu: this.renderActionMenu, handleClick: this.handleClick, open: this.props.open, type: this.props.type, isStarted: this.props.isStarted, onOpen: onOpenFunction }),
	        this.state.cancelReferral.open && _react2.default.createElement(
	          _Portal2.default,
	          { portalId: 'cancelReferral', onPortalClose: this.onPortalClose.bind(this, 'cancelReferral'), dontSendT: true },
	          _react2.default.createElement(_ReferenceOrderActionModal2.default, {
	            show: this.state.cancelReferral.open,
	            item: this.props.item,
	            id: this.props.item.Id,
	            onClose: this.onPortalClose.bind(this, 'cancelReferral'),
	            department: this.props.auth.departmentType })
	        ),
	        this.state.quality.open && _react2.default.createElement(_QualityCheckModal2.default, {
	          show: this.state.quality.open,
	          data: this.state.quality.data,
	          onSuccess: this.moveOrderSuccess.bind(this),
	          onClose: this.onPortalClose.bind(this, 'quality'),
	          move: true,
	          router: this.props.router }),
	        this.state.photodoc.open && _react2.default.createElement(
	          _Portal2.default,
	          { portalId: 'photoDoc', onPortalClose: this.onPortalClose.bind(this, 'photodoc'), dontSendT: true },
	          _react2.default.createElement(_PhotoDocModal2.default, {
	            show: this.state.photodoc,
	            item: this.state.item,
	            onClose: this.onPortalClose.bind(this, 'photodoc'),
	            t: _helpers.translation,
	            enumfunc: _helpers.enumtranslate })
	        ),
	        this.state.moveItem.open && _react2.default.createElement(
	          _Portal2.default,
	          { portalId: 'moveItem', onPortalClose: this.onPortalClose.bind(this, 'moveItem'), dontSendT: true },
	          _react2.default.createElement(_MoveModal2.default, { router: this.props.router,
	            show: this.state.moveItem.open,
	            item: this.state.item,
	            type: this.state.moveItem.type,
	            onClose: this.onPortalClose.bind(this, 'moveItem'),
	            onMoveOrders: this.props.onOrderMove.bind(this) })
	        ),
	        this.state.estimation.open && _react2.default.createElement(
	          _Portal2.default,
	          { portalId: 'estimation', onPortalClose: this.onPortalClose.bind(this, 'estimation'), dontSendT: true },
	          _react2.default.createElement(_CreateEstimationModal2.default, { router: this.props.router,
	            show: this.state.estimation.open,
	            id: this.state.estimation.id,
	            orderId: this.state.item.Id,
	            onClose: this.onPortalClose.bind(this, 'estimation') })
	        ),
	        this.state.linkorders.open && _react2.default.createElement(
	          _Portal2.default,
	          { portalId: 'linkOrders', onPortalClose: this.onPortalClose.bind(this, 'linkorders'), dontSendT: true },
	          _react2.default.createElement(_LinkOrdersModal2.default, {
	            show: this.state.linkorders.open,
	            id: this.state.linkorders.id,
	            onClose: this.onPortalClose.bind(this, 'linkorders') })
	        ),
	        this.state.referenceorder.open && _react2.default.createElement(
	          _Portal2.default,
	          { portalId: 'referenceOrder', onPortalClose: this.onPortalClose.bind(this, 'referenceorder'), dontSendT: true },
	          _react2.default.createElement(_ReferenceOrderModal2.default, {
	            show: this.state.referenceorder.open,
	            item: this.state.item,
	            id: this.state.referenceorder.id,
	            onClose: this.onPortalClose.bind(this, 'referenceorder') })
	        ),
	        this.state.stoplockorder.open && _react2.default.createElement(
	          _Portal2.default,
	          { portalId: 'stopLockOrder', onPortalClose: this.onPortalClose.bind(this, 'stoplockorder'), dontSendT: true },
	          _react2.default.createElement(_StopLockOrderModal2.default, {
	            show: this.state.stoplockorder.open,
	            item: this.state.item,
	            id: this.state.stoplockorder.id,
	            newDelivery: this.state.newDelivery,
	            onClose: this.onPortalClose.bind(this, 'stoplockorder') })
	        ),
	        this.state.confirm.open && this.props.item.StepId === 1 && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: this.onPortalClose.bind(this, 'confirm') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm, notConfirm: this.onPortalClose.bind(this, 'confirm') })
	        ),
	        this.state.confirmResendInvoice.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'resendModal', onPortalClose: this.onPortalClose.bind(this, 'confirmResendInvoice') },
	          _react2.default.createElement(_Confirm2.default, { renderText: this.renderConfirmResendInvoiceDialog, confirm: function confirm() {
	              return _this7.onConfirmResend(false);
	            }, notConfirm: this.onPortalClose.bind(this, 'confirmResendInvoice'), disabled: disableResend })
	        ),
	        this.state.confirmMarkAsWrecked.open && _react2.default.createElement(
	          _Portal2.default,
	          { portalId: 'markAsWrecked', onPortalClose: this.onPortalClose.bind(this, 'confirmMarkAsWrecked'), dontSendT: true },
	          _react2.default.createElement(_MarkAsWreckedModal2.default, {
	            show: this.state.confirmMarkAsWrecked.open,
	            order: this.state.item,
	            onClose: this.onPortalClose.bind(this, 'confirmMarkAsWrecked'),
	            onMoveSuccess: this.props.onOrderMoveSuccess })
	        ),
	        this.state.item.OrderType === 4 && this.state.otherPopup.open && _react2.default.createElement(
	          _Portal2.default,
	          { portalId: 'otherPriceModal', onPortalClose: this.onPortalClose.bind(this, 'otherPopup'), dontSendT: true },
	          _react2.default.createElement(_OtherPriceModal2.default, {
	            type: 1,
	            show: this.state.otherPopup.open,
	            onClose: this.onPortalClose.bind(this, 'otherPopup'),
	            other: this.state.otherPopup.other,
	            order: this.state.item,
	            onSuccess: this.onPortalClose.bind(this, 'otherPopup'),
	            saveOrder: this.props.saveOrder })
	        ),
	        this.state.showAddonPopup && _react2.default.createElement(_Confirm2.default, {
	          t: _helpers.translation,
	          renderText: function renderText() {
	            return (0, _helpers.translation)('16485');
	          },
	          confirm: function confirm() {
	            return _this7.confirmAddon(true);
	          },
	          notConfirm: function notConfirm() {
	            return _this7.confirmAddon(false);
	          } })
	      );
	    }
	  }]);
	
	  return OrderActions;
	}(_react.PureComponent);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  deleteOrder: _orders.deleteOrder,
	  deleteOrderSimple: _orders.deleteOrderSimple,
	  moveOrder: _orders.moveOrder,
	  invoiceOrder: _invoicing.invoiceOrder,
	  invoiceHistory: _invoicing.invoiceHistory,
	  GetNewDeliveryForResume: _orders.GetNewDeliveryForResume,
	  StopLockOrder: _orders.StopLockOrder,
	  getOrderSimple: _orders.getOrderSimple,
	  saveOrder: _orders.saveOrder,
	  clearLastVisitedOrderId: _orders.clearLastVisitedOrderId
	}, null, { withRef: true })(OrderActions);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _bookingTime = __webpack_require__(278);
	
	var _backdrop = __webpack_require__(29);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ConfirmOk = __webpack_require__(429);
	
	var _ConfirmOk2 = _interopRequireDefault(_ConfirmOk);
	
	var _DeliveryDateChangeModal = __webpack_require__(302);
	
	var _DeliveryDateChangeModal2 = _interopRequireDefault(_DeliveryDateChangeModal);
	
	var _time = __webpack_require__(17);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	var BookingTimesWrapper = function (_Component) {
	  _inherits(BookingTimesWrapper, _Component);
	
	  function BookingTimesWrapper(props) {
	    _classCallCheck(this, BookingTimesWrapper);
	
	    var _this = _possibleConstructorReturn(this, (BookingTimesWrapper.__proto__ || Object.getPrototypeOf(BookingTimesWrapper)).call(this, props));
	
	    _this.state = {
	      Paint: undefined,
	      Body: undefined,
	
	      NeedChangeReason: false,
	      ChangeReasonInfo: {},
	
	      isLoading: false,
	      showPopup: false,
	      ModalInfoKey: null,
	      ErrorKey: null,
	
	      EditedBookingTime: {
	        Date: '',
	        Time: '',
	        Department: 0,
	        OrderId: 0,
	        BookingTimeType: null,
	        LeadTime: null
	      }
	    };
	    _this.handleSocket = _this.handleSocket.bind(_this);
	    _this.renderDateChangeModal = _this.renderDateChangeModal.bind(_this);
	    _this.handleBookinTimesEmitter = _this.handleBookinTimesEmitter.bind(_this);
	    return _this;
	  }
	
	  _createClass(BookingTimesWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getBookingTimes();
	
	      _events2.default.removeListener('ORDER_SOCKET', this.handleSocket);
	      _events2.default.addListener('ORDER_SOCKET', this.handleSocket, this);
	
	      _events2.default.removeListener('UPDATE_BOOKINGTIMES', this.handleBookinTimesEmitter);
	      _events2.default.addListener('UPDATE_BOOKINGTIMES', this.handleBookinTimesEmitter, this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _events2.default.removeListener('ORDER_SOCKET', this.handleSocket);
	      _events2.default.removeListener('UPDATE_BOOKINGTIMES', this.handleBookinTimesEmitter);
	    }
	  }, {
	    key: 'handleSocket',
	    value: function handleSocket(json) {
	      if (json.Type === 'ORDER_UPDATE' && json.Data.Id === this.props.OrderId) this.getBookingTimes();
	    }
	  }, {
	    key: 'handleBookinTimesEmitter',
	    value: function handleBookinTimesEmitter() {
	      this.getBookingTimes();
	    }
	  }, {
	    key: 'getBookingTimes',
	    value: function getBookingTimes() {
	      var _this2 = this;
	
	      this.props.getBookingTime(this.props.OrderId).then(function (res) {
	        _this2.setState({
	          Body: res.data.Body,
	          Paint: res.data.Paint
	        });
	      }, function (error) {
	        console.log(error);
	      });
	    }
	  }, {
	    key: 'saveBookingTime',
	    value: function saveBookingTime(onSuccess) {
	      var _this3 = this;
	
	      // this.renderModalMessage()
	      this.setState({
	        isLoading: false,
	        showPopup: false
	      });
	      this.props.saveBookingTime(this.state.EditedBookingTime).then(function (res) {
	        var _res$data = res.data,
	            ModalInfoKey = _res$data.ModalInfoKey,
	            ErrorKey = _res$data.ErrorKey,
	            NeedChangeReason = _res$data.NeedChangeReason;
	
	        var textKey = void 0,
	            showPopup = void 0;
	        if (!NeedChangeReason) {
	          if (ModalInfoKey) {
	            textKey = ModalInfoKey;
	            showPopup = true;
	          }
	          if (ErrorKey) {
	            textKey = ErrorKey;
	          }
	        }
	
	        if (NeedChangeReason) {
	          _this3.props.triggerPopup(true);
	        }
	
	        _this3.setState({
	          Body: res.data.Body,
	          Paint: res.data.Paint,
	          isLoading: false,
	          textKey: textKey,
	          showPopup: showPopup,
	          NeedChangeReason: NeedChangeReason,
	          ChangeReasonInfo: res.data.ChangeReasonInfo
	        }, function () {
	          if (NeedChangeReason) {
	            // window.toastr.info(translation('@Need more info'), translation('@Info'))
	          } else if (!ErrorKey) {
	            // window.toastr.success(translation(''), translation('13424'))
	            if (typeof onSuccess === 'function') onSuccess();
	            if (typeof _this3.props.onUpdated === 'function') _this3.props.onUpdated();
	          } else {
	            window.toastr.error((0, _helpers.translation)(ErrorKey), (0, _helpers.translation)('216'));
	          }
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm() {
	      this.onPortalClose();
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose() {
	      this.setState({
	        showPopup: false
	      });
	    }
	  }, {
	    key: 'renderPopupMessage',
	    value: function renderPopupMessage() {
	      var _state = this.state,
	          showPopup = _state.showPopup,
	          textKey = _state.textKey;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        showPopup && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this) },
	          _react2.default.createElement(_ConfirmOk2.default, {
	            headingText: function headingText() {
	              return (0, _helpers.translation)('534');
	            },
	            renderText: function renderText() {
	              return (0, _helpers.translation)(textKey);
	            },
	            confirm: this.onConfirm.bind(this) })
	        )
	      );
	    }
	  }, {
	    key: 'renderDateChangeModal',
	    value: function renderDateChangeModal() {
	      var _this4 = this;
	
	      if (!this.state.NeedChangeReason) return null;
	
	      var onClose = function onClose() {
	        _this4.props.triggerPopup(false);
	        _this4.setState({ NeedChangeReason: false });
	      };
	      var updateFromDeliveryTime = function updateFromDeliveryTime(data) {
	        _this4.setState({
	          NeedChangeReason: false,
	          EditedBookingTime: _extends({}, _this4.state.EditedBookingTime, {
	            Date: data.NewDate,
	            Time: (0, _time.renderTimeOnly)(data.NewDate),
	            ChangeReason: {
	              ChangeReasonComment: data.DeliveryChangeComment,
	              CommentApplyToInvoice: data.CommentApplyToInvoice,
	              CommentShowToCustomer: data.CommentShowToCustomer,
	              ChangeReason: data.DeliveryChangeReason
	            }
	          })
	        }, function () {
	          _this4.saveBookingTime();
	          _this4.props.triggerPopup(false);
	        });
	      };
	
	      var formatTime = function formatTime(time) {
	        return time.substring(0, 5);
	      };
	
	      var _state$ChangeReasonIn = this.state.ChangeReasonInfo,
	          OldBookingTime = _state$ChangeReasonIn.OldBookingTime,
	          NewBookingTime = _state$ChangeReasonIn.NewBookingTime,
	          CompanyName = _state$ChangeReasonIn.CompanyName,
	          CustomerName = _state$ChangeReasonIn.CustomerName;
	
	      return _react2.default.createElement(_DeliveryDateChangeModal2.default, {
	        show: true,
	        onClose: onClose,
	        onSave: updateFromDeliveryTime,
	        oldDate: OldBookingTime.Date,
	        newDate: NewBookingTime.Date,
	        clientName: CustomerName,
	        shopName: CompanyName,
	        times: NewBookingTime.ValidTimes.map(function (x) {
	          return formatTime(x);
	        })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.children(this.state, function (state, callBack) {
	          return _this5.setState(_extends({}, _this5.state, state), callBack);
	        }, function (callBack) {
	          return _this5.saveBookingTime(callBack);
	        }),
	        this.renderPopupMessage(),
	        this.renderDateChangeModal()
	      );
	    }
	  }]);
	
	  return BookingTimesWrapper;
	}(_react.Component);
	
	BookingTimesWrapper.propTypes = {
	  OrderId: _propTypes2.default.number.isRequired,
	  children: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getBookingTime: _bookingTime.getBookingTime,
	  saveBookingTime: _bookingTime.saveBookingTime,
	  triggerPopup: _backdrop.triggerPopup
	})(BookingTimesWrapper);

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modalHeader = __webpack_require__(176);
	
	var _modalHeader2 = _interopRequireDefault(_modalHeader);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	__webpack_require__(1497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// import styles
	
	
	var ConfirmOk = function (_Component) {
	  _inherits(ConfirmOk, _Component);
	
	  function ConfirmOk(props) {
	    _classCallCheck(this, ConfirmOk);
	
	    var _this = _possibleConstructorReturn(this, (ConfirmOk.__proto__ || Object.getPrototypeOf(ConfirmOk)).call(this, props));
	
	    _this.state = {
	      disabled: false
	    };
	    return _this;
	  }
	
	  _createClass(ConfirmOk, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        disabled: this.props.disabled === true
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.disabled !== nextProps.disabled) {
	        this.setState({
	          disabled: nextProps.disabled === true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var higher = this.props.higher ? 'higher' : '';
	      var disabled = this.state.disabled;
	      return _react2.default.createElement(
	        'div',
	        { className: 'confirmok__modal__wrapper' },
	        _react2.default.createElement('div', { className: 'backdrop__modal ' + higher }),
	        _react2.default.createElement(
	          'div',
	          { className: 'confirmok__modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'confirmok__content' },
	            _react2.default.createElement(_modalHeader2.default, { text: this.props.headingText(this.props) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'pg-mb-2' },
	              this.props.renderText(this.props)
	            )
	          ),
	          _react2.default.createElement(_bottomBar2.default, {
	            disabled: disabled,
	            actionLabelText: this.props.confirmText(this.props),
	            onActionClick: this.props.confirm,
	            cancelLabelText: false,
	            center: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return ConfirmOk;
	}(_react.Component);
	
	ConfirmOk.defaultProps = {
	  headingText: function headingText(props) {
	    return props.t(534);
	  },
	  renderText: function renderText(props) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      props.t('Tekst mangler!')
	    );
	  },
	  confirmText: function confirmText(props) {
	    return props.t('956');
	  }
	};
	exports.default = ConfirmOk;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1498);
	
	var _modalHeader = __webpack_require__(176);
	
	var _modalHeader2 = _interopRequireDefault(_modalHeader);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Elements
	
	
	var ConfirmPriceChanges = function (_Component) {
	  _inherits(ConfirmPriceChanges, _Component);
	
	  function ConfirmPriceChanges() {
	    _classCallCheck(this, ConfirmPriceChanges);
	
	    return _possibleConstructorReturn(this, (ConfirmPriceChanges.__proto__ || Object.getPrototypeOf(ConfirmPriceChanges)).apply(this, arguments));
	  }
	
	  _createClass(ConfirmPriceChanges, [{
	    key: 'render',
	    value: function render() {
	      var higher = this.props.higher ? 'higher' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'confirm_Price_modal__wrapper' },
	        _react2.default.createElement('div', { className: 'backdrop__modal ' + higher }),
	        _react2.default.createElement(
	          'div',
	          { className: 'confirm__modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'confirm__content' },
	            _react2.default.createElement(_modalHeader2.default, { text: this.props.t('534') }),
	            this.props.renderText(this.props)
	          ),
	          _react2.default.createElement(_bottomBar2.default, {
	            actionLabelText: this.props.t('956'),
	            onActionClick: this.props.confirm,
	            center: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return ConfirmPriceChanges;
	}(_react.Component);
	
	ConfirmPriceChanges.defaultProps = {
	  renderText: function renderText(props) {
	    var txt = props.t('13494');
	    if (props.changes) {
	      txt = props.t('13495');
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      txt
	    );
	  }
	};
	
	exports.default = ConfirmPriceChanges;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bookingTime = __webpack_require__(278);
	
	var _helpers = __webpack_require__(2);
	
	var _Wrapper = __webpack_require__(428);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var DateActions = function (_Component) {
	  _inherits(DateActions, _Component);
	
	  function DateActions(props) {
	    _classCallCheck(this, DateActions);
	
	    var _this = _possibleConstructorReturn(this, (DateActions.__proto__ || Object.getPrototypeOf(DateActions)).call(this, props));
	
	    _this.renderDateChange = _this.renderDateChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateActions, [{
	    key: 'renderDateChange',
	    value: function renderDateChange(state, setState, saveBookingTime) {
	      var _this2 = this;
	
	      var department = this.props.auth.departmentType === 0 ? 'Paint' : 'Body';
	      var orderId = this.props.orderId;
	
	      var section = (state[department] || {}).Delivery;
	      if (!section) return null;
	
	      var ValidTimes = section.ValidTimes,
	          CanEdit = section.CanEdit,
	          Date = section.Date,
	          Time = section.Time;
	
	      var disabled = state.isLoading || !CanEdit;
	
	      var formatTime = function formatTime(time) {
	        return time.substring(0, 5);
	      };
	
	      var onChange = function onChange(e) {
	        var value = void 0,
	            name = void 0,
	            date = void 0,
	            time = void 0;
	        if (e.target && e.target.name === 'Time') {
	          // for time change
	          name = e.target.name;
	          value = e.target.value;
	          time = value;
	          date = Date;
	        } else {
	          // for date change
	          value = e.format('YYYY-MM-DDTHH:mm:ss');
	          name = 'Date';
	          time = Time;
	          date = e.format('YYYY-MM-DDTHH:mm:ss');
	        }
	
	        var EditedBookingTime = {
	          Date: date,
	          Time: time,
	          Department: department === 'Body' ? 1 : 0,
	          OrderId: orderId,
	          BookingTimeType: 2 // Delivery
	
	
	          // If date is changeing we need to validate and get valid times
	        };if (name === 'Date') {
	          _this2.props.GetValidDelivery(EditedBookingTime).then(function (_ref) {
	            var _setState;
	
	            var data = _ref.data;
	
	            setState((_setState = {}, _defineProperty(_setState, department, _extends({}, state[department], {
	              Delivery: _extends({}, state[department].Delivery, {
	                Date: data.Date,
	                Time: data.Time,
	                ValidTimes: data.ValidTimes
	              })
	            })), _defineProperty(_setState, 'EditedBookingTime', _extends({}, EditedBookingTime, {
	              Date: data.Date,
	              Time: data.Time
	            })), _setState));
	          }, function () {
	            return window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	          });
	        } else {
	          var _setState2;
	
	          setState((_setState2 = {}, _defineProperty(_setState2, department, _extends({}, state[department], {
	            Delivery: _extends({}, state[department].Delivery, _defineProperty({}, name, value))
	          })), _defineProperty(_setState2, 'EditedBookingTime', EditedBookingTime), _setState2));
	        }
	      };
	
	      var renderDate = function renderDate() {
	        return _react2.default.createElement(
	          _grid2.default,
	          { spacing: 1, cols: [1, 'min-content'] },
	          _react2.default.createElement(_datetime2.default, {
	            size: 'm',
	            inputProps: { readOnly: true, disabled: disabled },
	            closeOnSelect: true,
	            dateFormat: 'DD-MM-YYYY',
	            timeFormat: false,
	            value: window.CustomDate(Date),
	            name: 'Date',
	            onChange: onChange,
	            disabled: disabled
	          }),
	          _react2.default.createElement(
	            _dropDown2.default,
	            { size: 'm', name: 'Time', value: formatTime(Time), onChange: onChange, disabled: disabled },
	            ValidTimes && ValidTimes.map(function (val, index) {
	              return _react2.default.createElement(
	                'option',
	                { key: index, value: formatTime(val) },
	                formatTime(val)
	              );
	            }),
	            !ValidTimes && _react2.default.createElement(
	              'option',
	              { value: formatTime(Time) },
	              formatTime(Time)
	            )
	          )
	        );
	      };
	
	      var warningText = null;
	      if (this.props.item && Array.isArray(this.props.item.CarRentalAssignments) && this.props.item.CarRentalAssignments.length > 0) {
	        warningText = (0, _helpers.translation)(16822);
	      }
	
	      var classString = 'poppedup';
	      if (this.props.location === 'orderlist') {
	        classString += ' orderlist';
	      } else if (this.props.location === 'assign') {
	        classString += ' assign';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classString },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('193') }),
	          renderDate(),
	          _react2.default.createElement(
	            'div',
	            { className: 'warning' },
	            warningText
	          ),
	          _react2.default.createElement(_button2.default, { size: 'm', onClick: function onClick(_) {
	              return saveBookingTime(_this2.props.onSuccess);
	            }, labelText: (0, _helpers.translation)('791') })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Wrapper2.default,
	        { OrderId: this.props.orderId },
	        this.renderDateChange
	      );
	    }
	  }]);
	
	  return DateActions;
	}(_react.Component);
	
	DateActions.PropTypes = {
	  orderId: _propTypes2.default.number.isRequired,
	  item: _propTypes2.default.object, // If defined, used to determine if rentalcar warning should be displayed
	  onSuccess: _propTypes2.default.func, // If defined, called on successful save
	  location: _propTypes2.default.oneOf(['orderlist', 'assign'])
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetValidDelivery: _bookingTime.GetValidDelivery
	})(DateActions);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1502);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	var DateChangePopup = function (_Component) {
	  _inherits(DateChangePopup, _Component);
	
	  function DateChangePopup(props) {
	    _classCallCheck(this, DateChangePopup);
	
	    var _this = _possibleConstructorReturn(this, (DateChangePopup.__proto__ || Object.getPrototypeOf(DateChangePopup)).call(this, props));
	
	    _this.state = {
	      isOpen: false
	    };
	    _this.triggerOpen = _this.triggerOpen.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateChangePopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._mounted = true;
	      if (typeof this.props.open !== 'undefined') {
	        if (this.props.open) {
	          this.triggerOpen();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (typeof nextProps.open !== 'undefined') {
	        if (this.props.open !== nextProps.open) {
	          if (nextProps.open) {
	            this.triggerOpen();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.handleClick, false);
	      this._mounted = false;
	    }
	  }, {
	    key: 'triggerOpen',
	    value: function triggerOpen(onlyClose) {
	      if (!this.state.isOpen) {
	        document.addEventListener('click', this.handleClick, false);
	      } else {
	        document.removeEventListener('click', this.handleClick, false);
	      }
	      if (onlyClose && typeof onlyClose === 'boolean') {
	        document.removeEventListener('click', this.handleClick, false);
	        this.setState({
	          isOpen: false
	        });
	      } else {
	        this.setState({
	          isOpen: !this.state.isOpen
	        });
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      document.removeEventListener('click', this.handleClick, false);
	      this.setState({
	        isOpen: false
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var allowExtraClasses = ['rdtSwitch', 'rdtMonth', 'rdtYear', 'rdtYear rdtOld'];
	      var component = _reactDom2.default.findDOMNode(this.refs.component);
	
	      // Target and parent classes
	      var targetClasses = [].concat(_toConsumableArray(e.target.className.split(' ')), _toConsumableArray(e.target.parentNode.className.split(' ')));
	      var isFromDropdown = !!['element-dropdown__option', 'drop__option'].find(function (c) {
	        return targetClasses.includes(c);
	      });
	
	      // console.log('handleClick', e.target === component, component.contains(e.target), allowExtraClasses.indexOf(e.target.className) !== -1, isFromDropdown, e.target, e.target.parentNode)
	      if (e.target === component || component.contains(e.target) || allowExtraClasses.indexOf(e.target.className) !== -1 || isFromDropdown) {
	        if (e.target.tagName.toLowerCase() === 'a') {
	          this.props.handleClick(e.target);
	          if (e.target.dataset.action !== 'delete') {
	            if (this._mounted) {
	              this.triggerOpen();
	            }
	          }
	        }
	      } else {
	        if (this._mounted) {
	          this.triggerOpen();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var actionMenu = '';
	      if (this.state.isOpen) {
	        actionMenu = this.props.renderActionMenu(this.triggerOpen);
	      }
	
	      var onClick = function onClick() {
	        if (_this2.props.selfClick && !_this2.state.isOpen) _this2.triggerOpen();
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className(), ref: 'component', onClick: onClick },
	        this.props.renderActionOpener(this.triggerOpen),
	        actionMenu
	      );
	    }
	  }]);
	
	  return DateChangePopup;
	}(_react.Component);
	
	DateChangePopup.propTypes = {
	  renderActionMenu: _propTypes2.default.func.isRequired,
	  renderActionOpener: _propTypes2.default.func.isRequired
	};
	
	DateChangePopup.defaultProps = {
	  className: function className() {
	    return 'datechangepopup';
	  },
	  renderActionOpener: function renderActionOpener(triggerOpen) {
	    return _react2.default.createElement(
	      'span',
	      { onClick: triggerOpen },
	      _react2.default.createElement('img', { src: '/images/icons/menu_dots16.png' })
	    );
	  },
	  renderActionMenu: function renderActionMenu() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'poppedup' },
	      'POPUP'
	    );
	  }
	};
	
	exports.default = DateChangePopup;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1505);
	
	var _auth = __webpack_require__(8);
	
	var _overview = __webpack_require__(225);
	
	var _Overview = __webpack_require__(297);
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	var DeliveryStatusOverview = function (_Component) {
	  _inherits(DeliveryStatusOverview, _Component);
	
	  function DeliveryStatusOverview(props) {
	    _classCallCheck(this, DeliveryStatusOverview);
	
	    var _this = _possibleConstructorReturn(this, (DeliveryStatusOverview.__proto__ || Object.getPrototypeOf(DeliveryStatusOverview)).call(this, props));
	
	    _this.pageRef = null;
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(DeliveryStatusOverview, [{
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	
	      return _react2.default.createElement(_Overview2.default, {
	        itemType: 'order',
	        getItems: this.props.getDeliveryStatus
	      });
	    }
	  }]);
	
	  return DeliveryStatusOverview;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getDeliveryStatus: _overview.getDeliveryStatus
	})(DeliveryStatusOverview);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentForsiLine = function (_Component) {
	  _inherits(AssesmentForsiLine, _Component);
	
	  function AssesmentForsiLine() {
	    _classCallCheck(this, AssesmentForsiLine);
	
	    return _possibleConstructorReturn(this, (AssesmentForsiLine.__proto__ || Object.getPrototypeOf(AssesmentForsiLine)).apply(this, arguments));
	  }
	
	  _createClass(AssesmentForsiLine, [{
	    key: 'renderLine',
	    value: function renderLine() {
	      var notation = '';
	      var line = this.props.line;
	      var reportType = this.props.reportType;
	      var currencyCode = this.props.currencyCode;
	      var useSubline = true; // reportType === 2 // ForsiManual // RPreport
	      var className = reportType === 2 ? 'forsi-RPreport__line' : 'forsi-body__line';
	      var amount = void 0;
	      if (line.ManualPrice && this.props.showPrices) {
	        amount = line.ManualPrice;notation = (0, _helpers.translation)(currencyCode);
	      }
	      if (line.CalculatedPrice && this.props.showPrices) {
	        amount = line.CalculatedPrice;notation = (0, _helpers.translation)(currencyCode);
	      }
	      if (line.UnitPrice && this.props.showAE) {
	        amount = line.UnitPrice;
	      }
	      if (line.WorkUnits && this.props.showAE) {
	        amount = line.WorkUnits;notation = (0, _helpers.translation)('885');
	      }
	      if (line.GenericValue) {
	        amount = line.GenericValue;
	      }
	      var lineText = line.LineText ? line.LineText.split('\r\n') : [];
	
	      if (lineText.length > 1) {
	        var first = lineText[0];
	        var last = lineText.slice(-1);
	        var rest = lineText.filter(function (n, i) {
	          return i !== 0 && i !== lineText.length - 1;
	        });
	        return _react2.default.createElement(
	          _Line2.default,
	          { boldText: true, text: first },
	          rest.map(function (n, key) {
	            return _react2.default.createElement(_Line2.default, { text: n, className: className, subLine: useSubline, key: key });
	          }),
	          _react2.default.createElement(_Line2.default, { text: last, amount: amount, noFormat: true, currencyType: notation, className: className, subLine: useSubline })
	        );
	      } else {
	        var format = 'noFormat';
	        // format the amount if it is a decimal number
	        if (amount % 1 !== 0 && amount !== 'undefined' && line.LineType === 1) {
	          format = '';
	        }
	
	        // method // LineType: 0 = Generic
	        if (line.LineType === 0 && !line.GenericValue && line.LineNumber) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'extent-line clearfix' },
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              line.LineNumber,
	              ' '
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              line.LineText
	            )
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          line.AdditionalText ? _react2.default.createElement(
	            _Line2.default,
	            { bold: true, text: line.LineText },
	            _react2.default.createElement(_Line2.default, { text: line.AdditionalText, amount: amount, noFormat: true, currencyType: notation, subLine: true })
	          ) : _react2.default.createElement(_Line2.default, { boldText: true, boldAmount: this.props.boldAmount, text: line.LineText, noFormat: format, amount: amount, currencyType: notation })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.line) return this.renderLine();
	      return null;
	    }
	  }]);
	
	  return AssesmentForsiLine;
	}(_react.Component);
	
	exports.default = AssesmentForsiLine;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _AssesmentDBSLine = __webpack_require__(1031);
	
	var _AssesmentDBSLine2 = _interopRequireDefault(_AssesmentDBSLine);
	
	var _RPReportFiles = __webpack_require__(199);
	
	var _RPReportFiles2 = _interopRequireDefault(_RPReportFiles);
	
	var _AssessmentReportSums = __webpack_require__(198);
	
	var _AssessmentReportSums2 = _interopRequireDefault(_AssessmentReportSums);
	
	var _constants = __webpack_require__(5);
	
	var _car = __webpack_require__(222);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1513);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Constants
	
	
	// Elements
	
	
	// Utils
	
	
	var LineType = {
	  Generic: 0,
	  Work: 1,
	  AdditionalWork: 2,
	  Material: 3,
	  StartTime: 4,
	  Addition: 5,
	  Deduction: 6,
	  Environment: 7
	};
	
	var REPORTYPE = {
	  Unknown: 0,
	  Forsi: 1,
	  ForsiManual: 2,
	  DBS: 3
	};
	
	var DEPARTMENTTYPE = {
	  Paint: 0,
	  Body: 1
	};
	
	var AssessmentDBS = function (_Component) {
	  _inherits(AssessmentDBS, _Component);
	
	  function AssessmentDBS(props) {
	    _classCallCheck(this, AssessmentDBS);
	
	    var _this = _possibleConstructorReturn(this, (AssessmentDBS.__proto__ || Object.getPrototypeOf(AssessmentDBS)).call(this, props));
	
	    _this.state = {
	      order: null,
	      department: {},
	      isPaint: false,
	      isBody: false,
	      attachment: null
	    };
	    return _this;
	  }
	
	  _createClass(AssessmentDBS, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onRef) this.props.onRef(this);
	      this.getDepartment();
	
	      var isEvaluation = this.props.orderPrice !== undefined && this.props.orderPrice.IsEvaluation && this.props.router !== undefined && this.props.router.params !== undefined && this.props.router.params.addon === '3';
	      var isAfterEvaluation = this.props.orderPrice !== undefined && this.props.orderPrice.IsAfterEvaluation;
	      var hasReport = this.props.order && this.props.order.Report && this.props.order.Report.ReportType === _constants.AssessmentReporType.DBS;
	      if (hasReport && !this.props.orderPrice.IsAddonPrice && !isEvaluation && !isAfterEvaluation) {
	        this.props.setCarActiveState(false);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onRef) this.props.onRef(undefined);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      if (_typeof(next.order) !== 'object') return;
	      this.setState({
	        order: next.order
	      });
	      this.getDepartment();
	    }
	  }, {
	    key: 'getTitleAria',
	    value: function getTitleAria() {
	      // if (this.props.orderPrice === null) return null
	      if (this.props.orderPrice !== null && this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(34) + ' ' + (0, _helpers.translation)(1396);
	      }
	      return (0, _helpers.translation)(2705);
	    }
	  }, {
	    key: 'getEditUrl',
	    value: function getEditUrl() {
	      if (this.props.order.Report.ReportType === REPORTYPE.DBS && !this.props.order.Report.IsApproved) {
	        if (this.props.department === DEPARTMENTTYPE.Paint && this.props.auth.departmentType === DEPARTMENTTYPE.Paint) {
	          if (this.props.order !== null && this.props.order.IsAssessmentOk === true) return null;
	
	          return '/pricecalculation/' + this.props.order.Id + '/1';
	        }
	        if (this.props.department === DEPARTMENTTYPE.Body) {
	          return '/pricecalculation/' + this.props.order.Id + '/manualbody';
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      return (0, _helpers.translation)(70);
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      return '/images/svgs/workscreen/Insurance-black.svg';
	    }
	  }, {
	    key: 'getDepartment',
	    value: function getDepartment() {
	      var _this2 = this;
	
	      var report = this.props.order.Report;
	      var attachment = this.props.order.Report.Attachments.find(function (item) {
	        return _this2.formatSectionType(item.SectionType) === _this2.props.department;
	      });
	      if (this.props.department === DEPARTMENTTYPE.Paint) {
	        var lines = [].concat(_toConsumableArray(report.Paint.Lines));
	        this.setState({
	          department: _extends({}, report.Paint, {
	            Lines: lines
	          }),
	          isPaint: true,
	          attachment: attachment
	        });
	      }
	      if (this.props.department === DEPARTMENTTYPE.Body) {
	        var Glass = report.Glass;
	        var Plastic = report.Plastic;
	        var _lines = [].concat(_toConsumableArray(report.Body.Lines));
	        this.setState({
	          department: _extends({}, report.Body, {
	            Lines: _lines,
	            Glass: Glass,
	            Plastic: Plastic
	          }),
	          isBody: true,
	          attachment: attachment
	        });
	      }
	    }
	  }, {
	    key: 'renderDownloadlink',
	    value: function renderDownloadlink() {
	      var attachment = this.state.attachment;
	      if (!attachment) return null;
	
	      if (attachment !== null && attachment.OrderFileId !== null) {
	        if (attachment.FileName === null) return null;
	        var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token);
	        var translateKey = this.state.isBody ? '936' : '14836';
	
	        var renderText = function renderText() {
	          return _react2.default.createElement(
	            'div',
	            { className: 'text downloadLink' },
	            (0, _helpers.translation)(translateKey),
	            _react2.default.createElement(
	              'a',
	              { href: newFileUrl, title: attachment.FileName, target: '_blank' },
	              _react2.default.createElement('img', { src: '/images/svgs/download.svg', alt: '', className: 'downloadIcon' })
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'dbsPDF' },
	          _react2.default.createElement(_Line2.default, { text: renderText, amount: (0, _time.renderFullDate)(this.props.order.Report.CreatedDate), noFormat: true })
	        );
	      }
	    }
	  }, {
	    key: 'renderTotals',
	    value: function renderTotals() {
	      var isPaint = this.state.isPaint;
	      var isBody = this.state.isBody;
	
	      var showPrices = (0, _auth.hasAccess)([6], this.props.auth.user.UserType) || this.props.showPrices || this.props.order.ShowPrices;
	      if (!showPrices) return null;
	
	      if (this.props.showOnlyWork) return null;
	      var department = this.state.department;
	      var currencyCode = this.props.currencyCode;
	      /*
	              <div>
	                <Line boldText text={translation('393') + ':'} amount={department.TotalPrice} currencyType={translation(currencyCode)} />
	              </div>
	      
	              <div><Line boldText text={translation('416') + ':'} amount={department.LaborTotalNoDeductionAndAddition} currencyType={translation(currencyCode)} /></div>
	              {isBody && <div><Line boldText text={translation('13051') + ':'} amount={department.AdditionalTotal} currencyType={translation(currencyCode)} /></div>}
	              {isPaint && <div><Line boldText text={translation('417') + ':'} amount={department.MaterialsTotal} currencyType={translation(currencyCode)} /></div>}
	              {isBody && <div><Line boldText text={translation('637') + ':'} amount={department.SparepartsTotal} currencyType={translation(currencyCode)} /></div>}
	              {isBody && department.Glass && <div><Line boldText text={translation('17981') + ':'} amount={department.Glass.TotalPrice} currencyType={translation(currencyCode)} /></div>}
	              {isBody && department.Plastic && <div><Line boldText text={translation('123') + ':'} amount={department.Plastic.TotalPrice} currencyType={translation(currencyCode)} /></div>}
	      
	      */
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        (isPaint && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || isBody) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Line2.default, { boldText: true, text: (0, _helpers.translation)('419') + ':', amount: department.HourPrice, currencyType: (0, _helpers.translation)(currencyCode) })
	        ),
	        _react2.default.createElement(_AssessmentReportSums2.default, { report: this.props.order.Report, department: this.props.department, currencyCode: this.props.currencyCode })
	      );
	    }
	  }, {
	    key: 'formatSectionType',
	    value: function formatSectionType(sectionType) {
	      switch (sectionType) {
	        case 1:
	          return DEPARTMENTTYPE.Paint;
	        case 2:
	          return DEPARTMENTTYPE.Body;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'renderForsiCompany',
	    value: function renderForsiCompany() {
	      if (!this.props.order.Report.InsuranceCompany) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Line2.default, { boldText: true, text: (0, _helpers.translation)('418') + ':', amount: this.props.order.Report.InsuranceCompany, noFormat: true })
	      );
	    }
	  }, {
	    key: 'renderClasses',
	    value: function renderClasses(from) {
	      var department = this.state.department;
	      var className = '';
	      var dbsBody = 'dbs-body';
	
	      if (from === 'render') {
	        className = department === DEPARTMENTTYPE.Body ? dbsBody : 'price__view dbs';
	        return className;
	      }
	      className = department === DEPARTMENTTYPE.Body ? dbsBody : '';
	      return className;
	    }
	  }, {
	    key: 'renderAE',
	    value: function renderAE(department) {
	      if (!(this.props.order.ShowAE || this.props.showAE)) return null;
	      var className = this.renderClasses() + '__sum';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Line2.default, { isTotal: true, amount: department.TotalWorkUnits, noFormat: true, currencyType: (0, _helpers.translation)('885'), className: className })
	      );
	    }
	  }, {
	    key: 'renderWarning',
	    value: function renderWarning(hasDifference) {
	      if (!hasDifference) return null;
	      var className = 'dbs_diff' + this.renderClasses('renderWarning');
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        (0, _helpers.translation)('749')
	      );
	    }
	  }, {
	    key: 'renderLines',
	    value: function renderLines(lines, lineType, boldText, boldAmount) {
	      var _this3 = this;
	
	      var showAE = this.props.order.ShowAE;
	      var showPrices = this.props.order.ShowPrices;
	      return _react2.default.createElement(
	        'div',
	        null,
	        lines.filter(function (line) {
	          return line.LineType === lineType;
	        }).map(function (line, key) {
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            _react2.default.createElement(_AssesmentDBSLine2.default, { line: line, boldText: boldText, boldAmount: boldAmount, reportType: _this3.props.order.Report.ReportType, key: key, currencyCode: _this3.props.currencyCode, showPrices: showPrices, showAE: showAE })
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderRpReports',
	    value: function renderRpReports() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) return null;
	      var renderPaint = this.props.editable || this.props.department === 0;
	      var renderBody = this.props.editable || this.props.department === 1;
	      var renderSparePart = this.props.editable;
	      return _react2.default.createElement(_RPReportFiles2.default, {
	        order: this.props.order,
	        editable: this.props.editable,
	        renderPaint: renderPaint,
	        renderBody: renderBody,
	        renderSparePart: renderSparePart,
	        onUploadSuccess: this.props.loadOrder.bind(this, true),
	        showDates: !this.props.editable
	      });
	    }
	  }, {
	    key: 'renderDBS',
	    value: function renderDBS(section) {
	      var _this4 = this;
	
	      var ispaint = this.state.isPaint;
	      var isBody = this.state.isBody;
	      var isPaintPermission = ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && ispaint;
	
	      var renderSection = function renderSection(section) {
	        if (section === null) return null;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _this4.renderWarning(_this4.props.order.Report.CheckReportCalculation || section.CheckReportCalculation),
	          _this4.renderLines(section.Lines, LineType.Generic),
	          _this4.renderLines(section.Lines, LineType.Work),
	          section.Lines.findIndex(function (x) {
	            return x.LineType === LineType.AdditionalWork;
	          }) !== -1 && _react2.default.createElement('hr', null),
	          _this4.renderLines(section.Lines, LineType.AdditionalWork),
	          _this4.renderLines(section.Lines, LineType.StartTime, true),
	          _this4.renderAE(section),
	          _react2.default.createElement('br', null)
	        );
	      };
	
	      var renderSimple = function renderSimple() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _this4.renderWarning(_this4.props.order.Report.CheckReportCalculation || section.CheckReportCalculation),
	          _this4.renderDownloadlink(),
	          (isBody || isPaintPermission) && _this4.renderLines(section.Lines, LineType.Work),
	          _this4.props.department === DEPARTMENTTYPE.Body && section.Lines.findIndex(function (x) {
	            return x.LineType === LineType.AdditionalWork;
	          }) !== -1 && _react2.default.createElement('hr', null),
	          (isBody || isPaintPermission) && _this4.renderLines(section.Lines, LineType.AdditionalWork),
	          (isBody || isPaintPermission) && _this4.renderLines(section.Lines, LineType.StartTime, true),
	          (isBody || isPaintPermission) && _this4.renderAE(section),
	          _react2.default.createElement('br', null),
	          isBody && renderSection(section.Glass),
	          isBody && renderSection(section.Plastic),
	          isPaintPermission && _this4.renderLines(section.Lines, LineType.Generic, true, false),
	          _this4.renderTotals(),
	          (isBody || isPaintPermission) && _this4.renderForsiCompany(),
	          _react2.default.createElement('br', null),
	          isBody && _this4.renderLines(section.Lines, LineType.Generic)
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.renderClasses('render') },
	        renderSimple(),
	        this.props.editable && this.renderRpReports(),
	        this.props.editable && _react2.default.createElement(_button2.default, { onClick: this.props.goBack, labelText: (0, _helpers.translation)('956') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var department = this.state.department;
	      if (_typeof(this.props.order.Report) !== 'object' || this.props.order.Report === null) return null;
	      if (Object.keys(department).length < 1) return null;
	
	      return this.renderDBS(department);
	    }
	  }]);
	
	  return AssessmentDBS;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  setCarActiveState: _car.setCarActiveState
	})(AssessmentDBS);

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _AssesmentForsiLine = __webpack_require__(434);
	
	var _AssesmentForsiLine2 = _interopRequireDefault(_AssesmentForsiLine);
	
	var _Estimation = __webpack_require__(292);
	
	var _Estimation2 = _interopRequireDefault(_Estimation);
	
	var _ManualBody = __webpack_require__(438);
	
	var _ManualBody2 = _interopRequireDefault(_ManualBody);
	
	var _AssessmentRPReportFiles = __webpack_require__(1032);
	
	var _AssessmentRPReportFiles2 = _interopRequireDefault(_AssessmentRPReportFiles);
	
	var _AssessmentReportSums = __webpack_require__(198);
	
	var _AssessmentReportSums2 = _interopRequireDefault(_AssessmentReportSums);
	
	var _constants = __webpack_require__(5);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _car = __webpack_require__(222);
	
	__webpack_require__(1514);
	
	var _RPReportFiles = __webpack_require__(199);
	
	var _RPReportFiles2 = _interopRequireDefault(_RPReportFiles);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Constants
	
	
	// Utils
	
	
	var LineType = {
	  Generic: 0,
	  Work: 1,
	  AdditionalWork: 2,
	  Material: 3,
	  StartTime: 4,
	  Addition: 5,
	  Deduction: 6,
	  Environment: 7
	};
	var REPORTYPE = {
	  Unknown: 0,
	  Forsi: 1,
	  ForsiManual: 2,
	  DBS: 3
	};
	
	var DEPARTMENTTYPE = {
	  Paint: 0,
	  Body: 1
	};
	
	var AssessmentForsi = function (_Component) {
	  _inherits(AssessmentForsi, _Component);
	
	  function AssessmentForsi(props) {
	    _classCallCheck(this, AssessmentForsi);
	
	    var _this = _possibleConstructorReturn(this, (AssessmentForsi.__proto__ || Object.getPrototypeOf(AssessmentForsi)).call(this, props));
	
	    _this.state = {
	      order: null,
	      department: {},
	      isPaint: false,
	      isBody: false,
	      attachment: null
	    };
	    return _this;
	  }
	
	  _createClass(AssessmentForsi, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onRef) this.props.onRef(this);
	      this.getDepartment();
	
	      var isEvaluation = this.props.orderPrice !== undefined && this.props.orderPrice.IsEvaluation && this.props.router !== undefined && this.props.router.params !== undefined && this.props.router.params.addon === '3';
	      var isAfterEvaluation = this.props.orderPrice !== undefined && this.props.orderPrice.IsAfterEvaluation;
	      var hasReport = this.props.order && this.props.order.Report && this.props.order.Report.ReportType === 2;
	      if (hasReport && !this.props.orderPrice.IsAddonPrice && !isEvaluation && !isAfterEvaluation) {
	        this.props.setCarActiveState(false);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onRef) this.props.onRef(undefined);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      if (_typeof(next.order) !== 'object') return;
	      this.setState({
	        order: next.order
	      });
	      this.getDepartment();
	    }
	  }, {
	    key: 'getTitleAria',
	    value: function getTitleAria() {
	      // if (this.props.orderPrice === null) return null
	      if (this.props.orderPrice !== null && this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(34) + ' ' + (0, _helpers.translation)(1396);
	      }
	      return (0, _helpers.translation)(2705);
	    }
	  }, {
	    key: 'getEditUrl',
	    value: function getEditUrl() {
	      if (!this.props.order.Report.IsApproved) {
	        if (this.props.department === DEPARTMENTTYPE.Paint && this.props.auth.departmentType === DEPARTMENTTYPE.Paint) {
	          if (this.props.order !== null && this.props.order.IsAssessmentOk === true) return null;
	
	          return '/pricecalculation/' + this.props.order.Id + '/1';
	        }
	        if (this.props.department === DEPARTMENTTYPE.Body) {
	          return '/pricecalculation/' + this.props.order.Id + '/manualbody';
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      var reportType = this.props.order.Report.ReportType;
	      if (reportType === REPORTYPE.Forsi) return (0, _helpers.translation)(70);
	      if (reportType === REPORTYPE.ForsiManual) {
	        if (this.props.orderPrice !== null && this.props.orderPrice.IsAddonPrice) {
	          return (0, _helpers.translation)(1396);
	        }
	        switch (this.props.order.OrderType) {
	          case 1:
	            return (0, _helpers.translation)(13360);
	          case 2:
	            return (0, _helpers.translation)(71);
	          case 3:
	            return (0, _helpers.translation)(13361);
	          case 4:
	            return (0, _helpers.translation)(73);
	          case 6:
	            return (0, _helpers.translation)(785);
	        }
	        return 'No title';
	      }
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      var reportType = this.props.order.Report.ReportType;
	      if (reportType === REPORTYPE.Forsi) return '/images/svgs/workscreen/Insurance-black.svg';
	      if (reportType === REPORTYPE.ForsiManual) {
	        // if (this.props.orderPrice === null) return null
	        if (this.props.orderPrice !== null && this.props.orderPrice.IsAddonPrice) {
	          return '/images/svgs/taksering/Additional-sales-new.svg';
	        }
	        switch (this.props.order.OrderType) {
	          case 1:
	            return '/images/svgs/ordrer/Insurance-black.svg';
	          case 2:
	            return '/images/svgs/ordrer/Salescar-black.svg';
	          case 3:
	            return '/images/svgs/ordrer/Garanteed-black.svg';
	          case 4:
	            return '/images/svgs/ordrer/Other-black.svg';
	          case 6:
	            return '/images/svgs/ordrer/Private_c-black.svg';
	        }
	        return null;
	      }
	    }
	  }, {
	    key: 'getDepartment',
	    value: function getDepartment() {
	      var _this2 = this;
	
	      if (_typeof(this.props.order.Report) !== 'object' || this.props.order.Report === null) return null;
	
	      var department = this.props.order.Report;
	      var attachment = this.props.order.Report.Attachments.find(function (item) {
	        return _this2.formatSectionType(item.SectionType) === _this2.props.department;
	      });
	      if (this.props.department === DEPARTMENTTYPE.Paint) {
	        var lines = [].concat(_toConsumableArray(department.Paint.Lines));
	        this.setState({
	          department: _extends({}, department.Paint, {
	            Lines: lines
	          }),
	          isPaint: true,
	          attachment: attachment
	        });
	      }
	      if (this.props.department === DEPARTMENTTYPE.Body) {
	        var _lines = [].concat(_toConsumableArray(department.Body.Lines));
	        this.setState({
	          department: _extends({}, department.Body, {
	            Lines: _lines
	          }),
	          isBody: true,
	          attachment: attachment
	        });
	      }
	    }
	  }, {
	    key: 'renderDownloadlink',
	    value: function renderDownloadlink() {
	      var attachment = this.state.attachment;
	
	      if (attachment && attachment.OrderFileId !== null) {
	        if (attachment.FileName === null) return null;
	        var Report = this.props.order.Report;
	
	        var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token);
	        var translateKey = void 0;
	        if (this.props.auth.departmentType === DEPARTMENTTYPE.Body) {
	          // Additional report = V-Nr > 0
	          if (Report && Report.IsApproved && Report.ReportVersionNr > 0) {
	            translateKey = this.state.isBody ? '937' : '14836';
	          } else {
	            // head report
	            translateKey = this.state.isBody ? '936' : '14836';
	          }
	        }
	
	        if (this.props.auth.departmentType === DEPARTMENTTYPE.Paint) {
	          if (Report && Report.IsApproved && Report.ReportVersionNr > 0) {
	            translateKey = '937';
	          } else {
	            // head report
	            translateKey = '936';
	          }
	        }
	
	        var renderText = function renderText() {
	          // <img src='/images/svgs/download.svg' alt='' className='downloadIcon' />
	          return _react2.default.createElement(
	            'div',
	            { className: 'text downloadLink' },
	            (0, _helpers.translation)(translateKey),
	            _react2.default.createElement(
	              'a',
	              { href: newFileUrl, title: attachment.FileName, target: '_blank' },
	              _react2.default.createElement(_icon2.default, { icon: _icons.FileIcons.Download_Black, size: 'xs' })
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'forsiPDF' },
	          _react2.default.createElement(_Line2.default, { text: renderText, amount: (0, _time.renderFullDate)(this.props.order.Report.CreatedDate), noFormat: true })
	        );
	      }
	    }
	  }, {
	    key: 'renderPrices',
	    value: function renderPrices() {
	      var isPaint = this.state.isPaint;
	      var isBody = this.state.isBody;
	
	      var showPrices = (0, _auth.hasAccess)([6], this.props.auth.user.UserType) || this.props.showPrices || this.props.order.ShowPrices;
	      if (!showPrices) return null;
	
	      if (this.props.showOnlyWork) return null;
	      var section = this.state.department;
	      var renderHourPrice = isPaint && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || isBody;
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderHourPrice && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Line2.default, { boldText: true, text: (0, _helpers.translation)('419') + ':', amount: section.HourPrice, currencyType: (0, _helpers.translation)(this.props.currencyCode) })
	        ),
	        _react2.default.createElement(_AssessmentReportSums2.default, { report: this.props.order.Report, department: this.props.department, currencyCode: this.props.currencyCode })
	      );
	    }
	  }, {
	    key: 'formatSectionType',
	    value: function formatSectionType(sectionType) {
	      switch (sectionType) {
	        case 1:
	          return DEPARTMENTTYPE.Paint;
	        case 2:
	          return DEPARTMENTTYPE.Body;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'renderForsiCompany',
	    value: function renderForsiCompany() {
	      if (!this.props.order.Report.InsuranceCompany) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Line2.default, { boldText: true, text: (0, _helpers.translation)('418') + ':', amount: this.props.order.Report.InsuranceCompany, noFormat: true })
	      );
	    }
	  }, {
	    key: 'renderClasses',
	    value: function renderClasses(from) {
	      var department = this.state.department;
	      var reportType = this.props.order.Report.ReportType;
	      var className = '';
	      switch (reportType) {
	        case REPORTYPE.Forsi:
	          if (from === 'render') {
	            className = department === DEPARTMENTTYPE.Body ? 'forsi-body' : 'forsi';
	            return className;
	          }
	          className = department === DEPARTMENTTYPE.Body ? 'forsi-body' : '';
	          return className;
	
	        case REPORTYPE.ForsiManual:
	          className = 'assessment-forsi';
	          if (from === 'renderWarning') {
	            className += '__red';
	            return className;
	          }
	          return className;
	
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'renderAE',
	    value: function renderAE(department) {
	      if (!(this.props.order.ShowAE || this.props.showAE)) return null;
	      var className = this.renderClasses() + '__sum';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Line2.default, { isTotal: true, amount: department.TotalWorkUnits, noFormat: true, currencyType: (0, _helpers.translation)('885'), className: className })
	      );
	    }
	  }, {
	    key: 'renderWarning',
	    value: function renderWarning(hasDifference) {
	      if (!hasDifference) return null;
	      var className = 'forsi_diff assessment-forsi__red ';
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        (0, _helpers.translation)('749')
	      );
	    }
	  }, {
	    key: 'renderLines',
	    value: function renderLines(lines, lineType, boldText, boldAmount) {
	      var _this3 = this;
	
	      var showAE = this.props.order.ShowAE;
	      var showPrices = this.props.order.ShowPrices;
	      return _react2.default.createElement(
	        'div',
	        null,
	        lines.filter(function (line) {
	          return line.LineType === lineType;
	        }).map(function (line, key) {
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            _react2.default.createElement(_AssesmentForsiLine2.default, { line: line, boldText: boldText, boldAmount: boldAmount, reportType: _this3.props.order.Report.ReportType, key: key, currencyCode: _this3.props.currencyCode, showPrices: showPrices, showAE: showAE })
	          );
	        })
	      );
	    }
	
	    // Forsi manual / RP report (same thing)
	
	  }, {
	    key: 'renderForsiManual',
	    value: function renderForsiManual(reportSection) {
	      var _this4 = this;
	
	      // console.log('renderForsiManual')
	      var attachment = this.state.attachment;
	      var renderHourPrice = function renderHourPrice() {
	        if (!_this4.props.order.ShowPrices) return null;
	        if (_this4.props.showOnlyWork) return null;
	        if (reportSection.HourPrice === 0) return null;
	        return _react2.default.createElement(_Line2.default, { boldText: true, text: (0, _helpers.translation)('419'), amount: reportSection.HourPrice, noFormat: true, currencyType: _this4.props.currencyCode });
	      };
	
	      var renderIsApproved = function renderIsApproved(isApproved) {
	        var label = isApproved ? (0, _helpers.translation)('16483') : (0, _helpers.translation)('16482');
	        return _react2.default.createElement(
	          'div',
	          { className: 'forsi_diff assessment-forsi__red' },
	          label
	        );
	      };
	
	      var renderReportSums = function renderReportSums() {
	        if (!_this4.props.order.ShowPrices || _this4.props.showOnlyWork) return null;
	
	        var sumDepartment = _this4.props.department;
	        if (_this4.props.department === 1) {
	          sumDepartment = 2; // If body department, render both body and paint
	        }
	
	        return _react2.default.createElement(_AssessmentReportSums2.default, { report: _this4.props.order.Report, department: sumDepartment, currencyCode: _this4.props.currencyCode, includeTotal: false });
	      };
	
	      // Paint
	      if (this.props.department === DEPARTMENTTYPE.Paint) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'manual-paint' },
	          !this.props.editable && renderIsApproved(this.props.order.Report.IsApproved),
	          !this.props.editable && this.renderWarning(this.props.order.Report.CheckReportCalculation || reportSection.CheckReportCalculation),
	          !this.props.editable && this.props.viewMode !== 'hover' && _react2.default.createElement(_AssessmentRPReportFiles2.default, { attachment: attachment, order: this.props.order, showDates: true }),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.Work),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.AdditionalWork),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.StartTime, true),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && this.renderAE(reportSection),
	          !this.props.editable && _react2.default.createElement('br', { key: 'br1' }),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.Generic, true, false),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && renderHourPrice(),
	          renderReportSums(),
	          this.props.editable && this.renderRpReports(),
	          this.props.editable && _react2.default.createElement(_button2.default, { onClick: this.props.goBack, labelText: (0, _helpers.translation)('956') })
	        );
	      }
	      // Body
	      if (this.props.department === DEPARTMENTTYPE.Body) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'manual-body' },
	          !this.props.editable && renderIsApproved(this.props.order.Report.IsApproved),
	          !this.props.editable && this.renderWarning(this.props.order.Report.CheckReportCalculation || reportSection.CheckReportCalculation),
	          !this.props.editable && this.props.viewMode !== 'hover' && _react2.default.createElement(_AssessmentRPReportFiles2.default, { attachment: attachment, order: this.props.order, showDates: true }),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.Work),
	          !this.props.editable && reportSection.Lines.findIndex(function (x) {
	            return x.LineType === LineType.AdditionalWork;
	          }) !== -1 && _react2.default.createElement('hr', null),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.AdditionalWork),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && this.renderAE(reportSection),
	          !this.props.editable && reportSection.Lines.findIndex(function (x) {
	            return x.LineType === LineType.Generic;
	          }) !== -1 && _react2.default.createElement('br', null),
	          !this.props.editable && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.Generic),
	          !this.props.editable && reportSection.Lines.findIndex(function (x) {
	            return x.LineType === LineType.Generic;
	          }) !== -1 && _react2.default.createElement('br', null),
	          !this.props.editable && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && renderHourPrice(),
	          !this.props.showOnlyWork && _react2.default.createElement(_ManualBody2.default, _extends({}, this.props, { hideTitle: true, hideFile: true, noRef: true }))
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderForsi',
	    value: function renderForsi(section) {
	      var _this5 = this;
	
	      var ispaint = this.state.isPaint;
	      var isBody = this.state.isBody;
	      var isPaintPermission = ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && ispaint;
	
	      var renderIsApproved = function renderIsApproved() {
	        if (_this5.props.order.Report.ReportType === 1) return null; // Don't render approved notice when report was not manually uploaded
	        return _react2.default.createElement(
	          'div',
	          { className: 'forsi_diff assessment-forsi__red' },
	          _this5.props.order.Report.IsApproved ? (0, _helpers.translation)('16483') : (0, _helpers.translation)('16482')
	        );
	      };
	
	      // Body and paint
	      var renderWithSelectedEvaluation = function renderWithSelectedEvaluation() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          renderIsApproved(),
	          _this5.renderWarning(_this5.props.order.Report.CheckReportCalculation || section.CheckReportCalculation),
	          _this5.renderDownloadlink(),
	          (isBody || isPaintPermission) && _this5.renderLines(section.Lines, LineType.Work),
	          isBody && section.Lines.findIndex(function (x) {
	            return x.LineType === LineType.AdditionalWork;
	          }) !== -1 && _react2.default.createElement('hr', null),
	          (isBody || isPaintPermission) && _this5.renderLines(section.Lines, LineType.AdditionalWork),
	          isPaintPermission && _this5.renderLines(section.Lines, LineType.StartTime, true),
	          (isBody || isPaintPermission) && _this5.renderAE(section),
	          _react2.default.createElement('br', null),
	          isPaintPermission && _this5.renderLines(section.Lines, LineType.Generic, true, false),
	          _this5.renderPrices(),
	          (isBody || isPaintPermission) && _this5.renderForsiCompany(),
	          _react2.default.createElement('br', null),
	          isBody && _this5.renderLines(section.Lines, LineType.Generic),
	          _react2.default.createElement('div', { className: 'clearfix spacing20' }),
	          _react2.default.createElement(_Estimation2.default, _extends({}, _this5.props, { renderAdditional: true, overrideInnerTitle: (0, _helpers.translation)(891) }))
	        );
	      };
	
	      // Body and paint
	      var renderSimple = function renderSimple() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          renderIsApproved(),
	          _this5.renderWarning(_this5.props.order.Report.CheckReportCalculation || section.CheckReportCalculation),
	          _this5.renderDownloadlink(),
	          (isBody || isPaintPermission) && _this5.renderLines(section.Lines, LineType.Work),
	          _this5.props.department === 1 && section.Lines.findIndex(function (x) {
	            return x.LineType === LineType.AdditionalWork;
	          }) !== -1 && _react2.default.createElement('hr', null),
	          (isBody || isPaintPermission) && _this5.renderLines(section.Lines, LineType.AdditionalWork),
	          isPaintPermission && _this5.renderLines(section.Lines, LineType.StartTime, true),
	          (isBody || isPaintPermission) && _this5.renderAE(section),
	          _react2.default.createElement('br', null),
	          isPaintPermission && _this5.renderLines(section.Lines, LineType.Generic, true, false),
	          _this5.renderPrices(),
	          (isBody || isPaintPermission) && _this5.renderForsiCompany(),
	          _react2.default.createElement('br', null),
	          isBody && _this5.renderLines(section.Lines, LineType.Generic)
	        );
	      };
	
	      var content = null;
	      if (this.props.useSelectedEvaluation && this.props.orderPrice !== null && this.props.orderPrice.AdditionalParts !== null && this.props.orderPrice.AdditionalParts.length > 0 && [4, 5, 6, 7].includes(this.props.order.SelectedEvaluationType)) {
	        content = renderWithSelectedEvaluation();
	      } else {
	        content = renderSimple();
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: this.renderClasses('render') },
	        content
	      );
	    }
	  }, {
	    key: 'renderRpReports',
	    value: function renderRpReports() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) return null;
	      var renderPaint = this.props.editable || this.props.department === 0;
	      var renderBody = this.props.editable || this.props.department === 1;
	      var renderSparePart = this.props.editable;
	      return _react2.default.createElement(_RPReportFiles2.default, {
	        order: this.props.order,
	        editable: this.props.editable,
	        renderPaint: renderPaint,
	        renderBody: renderBody,
	        renderSparePart: renderSparePart,
	        onUploadSuccess: this.props.loadOrder.bind(this, true),
	        showDates: !this.props.editable
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var section = this.state.department;
	
	      if (!this.props.order.Report) return null;
	      if (Object.keys(section).length < 1) return null;
	
	      var reportType = this.props.order.Report.ReportType;
	      if (reportType === REPORTYPE.Forsi) {
	        return this.renderForsi(section);
	      }
	      if (reportType === REPORTYPE.ForsiManual) {
	        return this.props.editable ? this.renderForsiManual(section) : this.renderForsi(section);
	      }
	    }
	  }]);
	
	  return AssessmentForsi;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  setCarActiveState: _car.setCarActiveState
	})(AssessmentForsi);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EstimationLine = function (_Component) {
	  _inherits(EstimationLine, _Component);
	
	  function EstimationLine() {
	    _classCallCheck(this, EstimationLine);
	
	    return _possibleConstructorReturn(this, (EstimationLine.__proto__ || Object.getPrototypeOf(EstimationLine)).apply(this, arguments));
	  }
	
	  _createClass(EstimationLine, [{
	    key: 'renderExtra',
	    value: function renderExtra(extra) {
	      var text = extra.Name;
	      if (extra.AE || extra.Material) {
	        text += ' (' + (0, _helpers.translation)('13345') + ': ' + extra.AE + ' ; ' + (0, _helpers.translation)('13443') + ': ' + (0, _currency.formatCurrency)(extra.Material) + ' ' + this.props.currencyCode + ')';
	      }
	
	      return _react2.default.createElement(_Line2.default
	      // renderKey={this.props.renderKey}
	      , { key: 'extra_' + extra.OrderEstimationExtraId, text: text, subLine: !this.props.editable });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Task = this.props.orderEstimationTask;
	      var text = '';
	      var ae = '';
	
	      if (Task !== undefined && Task !== null) {
	        text = Task.TaskName;
	        ae = Task.AE;
	      }
	
	      if (Task.Extent && Task.Extent.Type) {
	        if (text) text += ' ' + Task.Extent.Type;else text = Task.Extent.Type;
	      }
	
	      return _react2.default.createElement(
	        _Line2.default,
	        { text: text,
	          amount: ae,
	          onDelete: this.props.onDelete && this.props.onDelete.bind(this, Task.OrderEstimationTaskId),
	          subLine: !this.props.editable
	        },
	        Task.Extras && Task.Extras.map(this.renderExtra.bind(this))
	      );
	    }
	  }]);
	
	  return EstimationLine;
	}(_react.Component);
	
	exports.default = EstimationLine;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _RPReportFiles = __webpack_require__(199);
	
	var _RPReportFiles2 = _interopRequireDefault(_RPReportFiles);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1523);
	
	var _auth = __webpack_require__(8);
	
	var _constants = __webpack_require__(5);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _AssessmentReportSums = __webpack_require__(198);
	
	var _AssessmentReportSums2 = _interopRequireDefault(_AssessmentReportSums);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// constants
	
	
	// Elements
	
	
	var ManualBody = function (_Component) {
	  _inherits(ManualBody, _Component);
	
	  function ManualBody(props) {
	    _classCallCheck(this, ManualBody);
	
	    var _this = _possibleConstructorReturn(this, (ManualBody.__proto__ || Object.getPrototypeOf(ManualBody)).call(this, props));
	
	    _this.state = {};
	    _this.onPriceFieldBlur = _this.onPriceFieldBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(ManualBody, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.noRef) {
	        this.props.onRef(this);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.noRef) {
	        this.props.onRef(undefined);
	      }
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(1396);
	      }
	      switch (this.props.order.OrderType) {
	        case 1:
	          return (0, _helpers.translation)(13360);
	        case 2:
	          return (0, _helpers.translation)(71);
	        case 3:
	          return (0, _helpers.translation)(13361);
	        case 6:
	          return (0, _helpers.translation)(785);
	      }
	      return 'No title';
	    }
	  }, {
	    key: 'getTitleAria',
	    value: function getTitleAria() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(34) + ' ' + (0, _helpers.translation)(1396);
	      }
	      return (0, _helpers.translation)(2705);
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return '/images/svgs/taksering/Additional-sales-new.svg';
	      }
	      switch (this.props.order.OrderType) {
	        case 1:
	          return '/images/svgs/ordrer/Insurance-black.svg';
	        case 2:
	          return '/images/svgs/ordrer/Salescar-black.svg';
	        case 3:
	          return '/images/svgs/ordrer/Garanteed-black.svg';
	        case 6:
	          return '/images/svgs/ordrer/Private_c-black.svg';
	      }
	      return null;
	    }
	  }, {
	    key: 'getEditUrl',
	    value: function getEditUrl() {
	      if (this.props.department === 1) {
	        return '/pricecalculation/' + this.props.order.Id + '/manualbody';
	      }
	    }
	  }, {
	    key: 'onPriceFieldBlur',
	    value: function onPriceFieldBlur(args) {
	      if (this.props.order[args.name] !== undefined && this.props.order[args.name] !== args.value) {
	        var data = { OrderID: this.props.order.Id };
	        if (args.name.includes('ManualBody')) {
	          var _data$BodyShopPrice;
	
	          data.BodyShopPrice = (_data$BodyShopPrice = {}, _defineProperty(_data$BodyShopPrice, args.name, args.value), _defineProperty(_data$BodyShopPrice, 'IsDirty', true), _data$BodyShopPrice);
	        } else {
	          var _data$Other;
	
	          data.Other = (_data$Other = {}, _defineProperty(_data$Other, args.name, args.value), _defineProperty(_data$Other, 'IsDirty', true), _data$Other);
	        }
	        console.log('onPriceFieldBlur -> saveOrder');
	        this.props.saveOrder(data);
	      }
	    }
	  }, {
	    key: 'renderRpReports',
	    value: function renderRpReports() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) return null;
	      var renderPaint = this.props.editable || this.props.department === 0;
	      var renderBody = this.props.editable || this.props.department === 1;
	      var renderSparePart = this.props.editable;
	      return _react2.default.createElement(_RPReportFiles2.default, {
	        order: this.props.order,
	        editable: this.props.editable,
	        renderPaint: renderPaint,
	        renderBody: renderBody,
	        renderSparePart: renderSparePart,
	        onUploadSuccess: this.props.loadOrder.bind(this, true),
	        showDates: !this.props.editable
	      });
	    }
	  }, {
	    key: 'renderAmountField',
	    value: function renderAmountField(field, label, value) {
	      var _this2 = this;
	
	      var bold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var disabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      if (value === null) value = 0;
	      // console.log('value ', value)
	      var amount = value;
	      if (this.props.editable) {
	        if (this.props.order.ReportType === _constants.AssessmentReporType.DBS) return; // use to hide manual body price
	        amount = function amount() {
	          return _react2.default.createElement(
	            'div',
	            { className: 'amount' },
	            _react2.default.createElement(_DecimalInput2.default, { size: 's', name: field, value: value, onBlur: _this2.onPriceFieldBlur, disabled: disabled, rightAlign: true })
	          );
	        };
	      }
	      if (!this.props.order || !this.props.order.ShowPrices) return null;
	      return _react2.default.createElement(_Line2.default, { boldText: true, text: label, amount: amount, bold: bold, currencyType: this.props.currencyCode });
	    }
	  }, {
	    key: 'renderAmounts',
	    value: function renderAmounts() {
	      var _this3 = this;
	
	      var hasPaintPriceList = this.props.order.HasBasePaintPriceList;
	      var isCorrectViewMode = this.props.viewMode !== 'simple';
	      // let hasBodyPriceList = true
	
	      var renderDivider = function renderDivider(text) {
	        if (text !== undefined) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'title spacing' },
	            text
	          );
	        }
	        return _react2.default.createElement('div', { className: 'h-line bold' });
	      };
	
	      var renderTotals = function renderTotals() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'totals' },
	          isCorrectViewMode && _this3.renderAmountField('ManualBodyGross', (0, _helpers.translation)(13376), _this3.props.order.ManualBodyGross),
	          isCorrectViewMode && _this3.renderAmountField('ManualBodyVat', (0, _helpers.translation)(13390), _this3.props.order.ManualBodyVat),
	          isCorrectViewMode && renderDivider(),
	          _this3.renderAmountField('ManualBodyTotal', (0, _helpers.translation)(393), _this3.props.order.ManualBodyTotal, true)
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        isCorrectViewMode && this.renderAmountField('ManualBodyWorkPrice', (0, _helpers.translation)(416), this.props.order.ManualBodyWorkPrice),
	        isCorrectViewMode && this.renderAmountField('ManualBodySparePartPrice', (0, _helpers.translation)(637), this.props.order.ManualBodySparePartPrice),
	        isCorrectViewMode && this.renderAmountField('ManualBodyMiscPrice', (0, _helpers.translation)(15154), this.props.order.ManualBodyMiscPrice),
	        isCorrectViewMode && !hasPaintPriceList && this.props.editable && this.renderAmountField('Price', (0, _helpers.translation)(660), this.props.order.Price, false, !this.props.order.IsDraft),
	        isCorrectViewMode && !hasPaintPriceList && this.props.editable && this.renderAmountField('Environment', (0, _helpers.translation)(15155), this.props.order.Environment, false, !this.props.order.IsDraft),
	        isCorrectViewMode && this.renderAmountField('ManualBodyWorkEnvPrice', (0, _helpers.translation)(15156), this.props.order.ManualBodyWorkEnvPrice),
	        !this.props.editable && renderTotals()
	      );
	    }
	  }, {
	    key: 'renderInnerTitle',
	    value: function renderInnerTitle() {
	      var title = this.props.editable ? (0, _helpers.translation)(1913) : ''; // translation(889)
	      if (this.props.overrideInnerTitle !== null) {
	        title = this.props.overrideInnerTitle;
	      }
	
	      if (!title) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'h-line title' },
	        title
	      );
	    }
	  }, {
	    key: 'renderReportSums',
	    value: function renderReportSums() {
	      var sumDepartment = this.props.department;
	      if (this.props.department === 1 && [1, 3].includes(this.props.extentInfo.PaintBase)) {
	        // If body department and use paint report...
	        sumDepartment = 2; // ...render both body and paint
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AssessmentReportSums2.default, { report: this.props.order.Report, department: sumDepartment, currencyCode: this.props.currencyCode, includeTotal: false })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var css = 'manualbody' + (this.props.editable ? ' editable' : '');
	      return _react2.default.createElement(
	        'div',
	        { className: css },
	        this.props.viewMode === 'mobile' && this.props.renderInside(),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: function onSubmit(e) {
	              e.preventDefault();
	            } },
	          !this.props.hideTitle && this.renderInnerTitle(),
	          !this.props.hideFile && !this.props.editable && this.renderRpReports(),
	          !this.props.order.Report && this.renderAmounts() || this.renderReportSums(),
	          this.props.editable && this.renderRpReports()
	        ),
	        this.props.editable && _react2.default.createElement(_button2.default, { onClick: this.props.goBack, labelText: (0, _helpers.translation)('956') })
	      );
	    }
	  }]);
	
	  return ManualBody;
	}(_react.Component);
	
	ManualBody.contextTypes = {
	  // router: React.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(ManualBody);

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _helpers = __webpack_require__(2);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	__webpack_require__(1527);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var PriceLine = function (_Component) {
	  _inherits(PriceLine, _Component);
	
	  function PriceLine(props) {
	    _classCallCheck(this, PriceLine);
	
	    var _this = _possibleConstructorReturn(this, (PriceLine.__proto__ || Object.getPrototypeOf(PriceLine)).call(this, props));
	
	    _this.state = {
	      taskName: '',
	      type: null
	    };
	    _this.changeValue = _this.changeValue.bind(_this);
	    _this.saveOrderPrice = _this.saveOrderPrice.bind(_this);
	    return _this;
	  }
	
	  _createClass(PriceLine, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (this.props.orderTaskPrice !== undefined) {
	        this.setState({
	          taskName: this.props.orderTaskPrice.TaskName,
	          type: 'taskPrice'
	        });
	      } else if (this.state.type === null) {
	        var type = null;
	        if (this.props.orderServiceTask !== undefined) {
	          if (this.props.orderServiceTask.IsExtra) {
	            type = 'extra';
	          } else {
	            type = 'service';
	          }
	        } else if (this.props.orderAddonPart !== undefined) {
	          type = 'addonPart';
	        } else if (this.props.orderAddonStartTime !== undefined) {
	          type = 'addonStartTime';
	        }
	        this.setState({ type: type });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.orderTaskPrice !== undefined) return this.renderAsTaskPrice();
	      if (this.props.orderServiceTask !== undefined) return this.renderAsServiceTask();
	      if (this.props.orderAddonPart !== undefined) return this.renderAsAddonPart();
	      if (this.props.orderAddonStartTime !== undefined) return this.renderAsAddonStartTime();
	
	      return null;
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      if (this.props.orderTaskPrice !== undefined) return this.props.orderTaskPrice;
	      if (this.props.orderServiceTask !== undefined) return this.props.orderServiceTask;
	      if (this.props.orderAddonPart !== undefined) return this.props.orderAddonPart;
	      if (this.props.orderAddonStartTime !== undefined) return this.props.orderAddonStartTime;
	    }
	  }, {
	    key: 'changeValue',
	    value: function changeValue(args) {
	      var item = this.getItem();
	      if (item === null) return;
	      if (item[args.name] === args.value) return;
	
	      var orderPrice = this.props.orderPrice;
	      item[args.name] = args.value;
	
	      // Check if wanting to create new task
	      if (args.name === 'TaskName' && args.value !== '' && this.props.orderTaskPrice !== undefined && item.PartItemId === 0 && item.OrderTaskId === 0) {
	        orderPrice.Parts.push({
	          Part: { PartItemId: 0 },
	          Tasks: [item]
	        });
	        this.setState({ taskName: item.TaskName });
	      }
	      this.saveOrderPrice(orderPrice);
	    }
	  }, {
	    key: 'saveOrderPrice',
	    value: function saveOrderPrice(orderPrice) {
	      var stripTasks = this.state.type !== 'taskPrice';
	      var stripExtras = this.state.type !== 'extra';
	      var stripServices = this.state.type !== 'service';
	
	      this.props.saveOrderPrice(orderPrice, stripTasks, stripExtras, stripServices);
	    }
	  }, {
	    key: 'renderSubLine',
	    value: function renderSubLine(propName, editable) {
	      var _this2 = this;
	
	      var item = this.getItem();
	      var amount = item[propName];
	      var text = propName;
	      switch (propName) {
	        case 'AE':
	          text = (0, _helpers.translation)(885);
	          break;
	        case 'Mat':
	          text = (0, _helpers.translation)(417);
	          break;
	        case 'Discount':
	          text = (0, _helpers.translation)(15014);
	          break;
	      }
	
	      if (editable) {
	        amount = function amount() {
	          return _react2.default.createElement(
	            'div',
	            { className: 'amount' },
	            _react2.default.createElement(_DecimalInput2.default, { size: 's', className: propName.toLowerCase(), value: item[propName], name: propName, onBlur: _this2.changeValue })
	          );
	        };
	      }
	
	      return _react2.default.createElement(_Line2.default
	      // key={'line_' + this.props.key}
	
	      // key={this.props.key}
	
	      // key={this.props.key}
	
	      // key={this.props.key}
	      , { text: text, amount: amount });
	    }
	  }, {
	    key: 'renderAsTaskPrice',
	    value: function renderAsTaskPrice() {
	      var _this3 = this;
	
	      if (this.props.orderTaskPrice !== undefined && this.props.orderTaskPrice !== null && !this.props.orderTaskPrice.IsDeleted) {
	        var item = this.props.orderTaskPrice;
	        var text = item.TaskName;
	        var amount = this.props.showAgreementPrice ? item.GrossWP : item.Gross;
	        if (this.props.showNet) {
	          amount = this.props.showAgreementPrice ? item.NetWP : item.Net;
	        }
	
	        /* if (this.props.isCustomer && item.PartItemId === 0 && amount === 0.0) {
	          amount = ''
	        } */
	
	        var showPrices = (this.props.order && this.props.order.ShowPrices || this.props.editable) && !this.props.orderPrice.UseEstimation;
	        if (!showPrices) {
	          amount = '';
	        }
	
	        if (this.props.noPrice) {
	          amount = '';
	        }
	
	        var canEditTaskName = !this.props.orderPrice.HasAwaiting && item.TaskPriceId === 0 && this.props.department === 0 && this.props.editable && (!this.props.isCustomer || this.props.order.IsDraft);
	
	        var canEditAmounts = !this.props.orderPrice.HasAwaiting && item.OrderTaskId > 0 && item.TaskPriceId === 0 && this.props.department === 0 && this.props.editable && !this.props.isCustomer;
	
	        if (this.props.department === 0 && this.props.auth.departmentType === 1 && this.props.auth.hasPartner) {
	          canEditAmounts = false;
	        }
	
	        var subLines = void 0;
	
	        // Can edit text when no ordertaskid and part is 'other'
	        if (canEditTaskName) {
	          text = function text() {
	            return _react2.default.createElement(
	              'div',
	              { className: 'text' },
	              _react2.default.createElement(_text2.default, {
	                size: 's',
	                value: _this3.state.taskName,
	                onChange: function onChange(e) {
	                  return _this3.setState({ taskName: e.target.value });
	                },
	                onBlur: function onBlur(e) {
	                  return _this3.changeValue({ name: 'TaskName', value: e.target.value });
	                }
	              })
	            );
	          };
	        }
	
	        // Can edit ae, mat and discount when have ordertaskid and part is 'other'
	        if (canEditAmounts) {
	          subLines = [];
	          subLines.push(this.renderSubLine('AE', true));
	          subLines.push(this.renderSubLine('Mat', true));
	          subLines.push(this.renderSubLine('Discount', true));
	        }
	        var css = void 0;
	        if (canEditTaskName) {
	          css = 'editable';
	          if (item.OrderTaskId > 0) {
	            css += ' small';
	          }
	        }
	
	        return _react2.default.createElement(
	          _Line2.default,
	          { className: css,
	            text: text,
	            amount: amount,
	            canExpand: subLines !== undefined,
	            onDelete: this.props.editable && this.props.onDelete !== undefined ? this.props.onDelete.bind(this, item) : undefined,
	            subLine: !this.props.editable
	          },
	          subLines
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderAsServiceTask',
	    value: function renderAsServiceTask() {
	      if (this.props.orderServiceTask !== undefined && this.props.orderServiceTask !== null && !this.props.orderServiceTask.IsDeleted) {
	        var item = this.props.orderServiceTask;
	        var qty = '';
	        if (item.Count > 1) {
	          qty = ' (' + item.Count + ')';
	        }
	        var text = item.TaskName + qty;
	        var amount = item.Total;
	        if (this.props.showNet) {
	          amount = item.Net;
	        }
	        var showPrices = (this.props.order.ShowPrices || this.props.editable) && !this.props.orderPrice.UseEstimation;
	        // let showPrices = this.props.order.ShowPrices || this.props.editable
	        if (!showPrices) {
	          amount = '';
	        }
	        if (this.props.noPrice) {
	          amount = '';
	        }
	        return _react2.default.createElement(_Line2.default, { text: text,
	          amount: amount,
	          boldText: true,
	          onDelete: this.props.editable && this.props.onDelete !== undefined ? this.props.onDelete.bind(this, item) : undefined
	        });
	      }
	      return null;
	    }
	  }, {
	    key: 'renderAsAddonPart',
	    value: function renderAsAddonPart() {
	      if (this.props.orderAddonPart !== undefined && this.props.orderAddonPart !== null && !this.props.orderAddonPart.IsDeleted) {
	        var item = this.props.orderAddonPart;
	        var text = item.Name;
	        var amount = this.props.isWp && this.props.showAgreementPrice ? item.GrossWP : item.Price;
	        if (this.props.showNet) {
	          amount = this.props.isWp && this.props.showAgreementPrice ? item.NetWP : item.Net;
	        }
	        var showPrices = (this.props.order.ShowPrices || this.props.editable) && !this.props.orderPrice.UseEstimation;
	        // let showPrices = this.props.order.ShowPrices || this.props.editable
	        if (!showPrices) {
	          amount = '';
	        }
	        if (this.props.noPrice) {
	          amount = '';
	        }
	        return _react2.default.createElement(_Line2.default, { text: text,
	          amount: amount,
	          boldText: true,
	          onDelete: this.props.onDelete !== undefined ? this.props.onDelete.bind(this, item) : undefined
	        });
	      }
	      return null;
	    }
	  }, {
	    key: 'renderAsAddonStartTime',
	    value: function renderAsAddonStartTime() {
	      if (this.props.orderAddonStartTime !== undefined && this.props.orderAddonStartTime !== null && !this.props.orderAddonStartTime.IsDeleted) {
	        var item = this.props.orderAddonStartTime;
	        var text = item.Name;
	        var amount = this.props.isWp && this.props.showAgreementPrice ? item.GrossWP : item.Price;
	        if (this.props.showNet) {
	          amount = this.props.isWp && this.props.showAgreementPrice ? item.NetWP : item.Net;
	        }
	        var showPrices = (this.props.order.ShowPrices || this.props.editable) && !this.props.orderPrice.UseEstimation;
	        // let showPrices = this.props.order.ShowPrices || this.props.editable
	        if (!showPrices) {
	          amount = '';
	        }
	        if (this.props.noPrice) {
	          amount = '';
	        }
	        return _react2.default.createElement(_Line2.default, { text: text,
	          amount: amount,
	          boldText: true,
	          onDelete: this.props.onDelete !== undefined ? this.props.onDelete.bind(this, item) : undefined
	        });
	      }
	      return null;
	    }
	  }]);
	
	  return PriceLine;
	}(_react.Component);
	
	PriceLine.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = PriceLine;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _backdrop = __webpack_require__(29);
	
	var _common = __webpack_require__(25);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _NewForsiRPModal = __webpack_require__(1097);
	
	var _NewForsiRPModal2 = _interopRequireDefault(_NewForsiRPModal);
	
	var _StatusBox = __webpack_require__(298);
	
	var _StatusBox2 = _interopRequireDefault(_StatusBox);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var ForsiCreateReport = function (_Component) {
	  _inherits(ForsiCreateReport, _Component);
	
	  function ForsiCreateReport(props) {
	    _classCallCheck(this, ForsiCreateReport);
	
	    var _this = _possibleConstructorReturn(this, (ForsiCreateReport.__proto__ || Object.getPrototypeOf(ForsiCreateReport)).call(this, props));
	
	    _this.state = {
	      showForsiCreatePopup: false,
	      showSpinner: false,
	      isCreated: false,
	      draft: null
	    };
	    _this.updateSpinner = _this.updateSpinner.bind(_this);
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleTokenExpired = _this.handleTokenExpired.bind(_this);
	    _this.handleForsiPopup = _this.handleForsiPopup.bind(_this);
	    return _this;
	  }
	
	  _createClass(ForsiCreateReport, [{
	    key: 'handleForsiPopup',
	    value: function handleForsiPopup(e) {
	      var value = !this.state.showForsiCreatePopup;
	      this.props.triggerPopup(value);
	      this.setState({
	        showForsiCreatePopup: value,
	        showSpinner: !this.state.showSpinner
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess(draft) {
	      var _this2 = this;
	
	      var value = !this.state.showForsiCreatePopup;
	      this.props.triggerPopup(value);
	      this.setState({
	        showForsiCreatePopup: value,
	        showSpinner: !this.state.showSpinner,
	        isCreated: true,
	        draft: draft
	      }, function () {
	        // window.toastr.success(translation('16491'), translation('13424'))
	        if (_this2.props.onSuccess !== null) {
	          _this2.props.onSuccess();
	        }
	      });
	    }
	  }, {
	    key: 'handleTokenExpired',
	    value: function handleTokenExpired() {
	      var _this3 = this;
	
	      this.props.triggerPopup(false);
	      this.setState({
	        showForsiCreatePopup: false,
	        showSpinner: false,
	        forsiActive: false
	      }, function () {
	        _this3.props.setHeaderInfo(_constants.SET_HEADERINFO_FORSI, 'action', {
	          ForsiTokenActive: false
	        });
	      });
	    }
	  }, {
	    key: 'updateSpinner',
	    value: function updateSpinner() {
	      this.setState({ showSpinner: !this.state.showSpinner });
	    }
	  }, {
	    key: 'renderForsiTokenStatus',
	    value: function renderForsiTokenStatus() {
	      var _props = this.props,
	          order = _props.order,
	          forsiTokenActive = _props.forsiTokenActive;
	
	
	      if (this.state.showSpinner) {
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: ['min-content', 1, 'max-content'], align: 'center' },
	          _react2.default.createElement('div', { className: 'divider', key: '1' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice', key: '2' },
	            _react2.default.createElement(
	              'span',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	            )
	          )
	        );
	      }
	
	      var isSentToForsi = order.IsSentToForsi || this.state.isCreated;
	      var draftId = order.IsSentToForsi ? order.ForsiDraftId : this.state.isCreated ? this.state.draft ? this.state.draft.id : '' : '';
	      var forsiReportIcon = isSentToForsi ? _icons.SparePartModuleIcons.OK : _icons.SparePartModuleIcons.Attention;
	      var forsiText = isSentToForsi ? (0, _helpers.translation)('16477') + ': ' + draftId : forsiTokenActive ? '' + (0, _helpers.translation)('16474') : '' + (0, _helpers.translation)('16476');
	      var forsiColor = isSentToForsi ? 'green' : 'orange';
	
	      if (order.HasForsiReport || order.HasBodyShopForsiReport) {
	        isSentToForsi = true;
	        forsiText = (0, _helpers.translation)(16503);
	      }
	
	      var action = void 0;
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 2) && forsiTokenActive && !isSentToForsi) {
	        action = this.handleForsiPopup;
	      }
	
	      return _react2.default.createElement(_StatusBox2.default, {
	        onClick: action,
	        icon: forsiReportIcon,
	        color: forsiColor,
	        title: (0, _helpers.translation)(13438).toUpperCase(),
	        subTitle: forsiText,
	        chevron: this.state.showForsiCreatePopup
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasAccess)([3, 5, 6, 7], this.props.auth.user.UserType)) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.hasHeader && _react2.default.createElement(_panelHeader2.default, { text: '' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'white__box invoice_wrapper' },
	          this.renderForsiTokenStatus()
	        ),
	        this.state.showForsiCreatePopup && _react2.default.createElement(_NewForsiRPModal2.default, {
	          showSpinner: this.updateSpinner,
	          show: this.state.showForsiCreatePopup,
	          onClose: this.handleForsiPopup,
	          onSuccess: this.handleSuccess,
	          onTokenExpired: this.handleTokenExpired,
	          insuranceCompanies: this.props.forsi,
	          order: this.props.order
	        })
	      );
	    }
	  }]);
	
	  return ForsiCreateReport;
	}(_react.Component);
	
	ForsiCreateReport.defaultProps = {
	  onSuccess: null
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    forsiTokenActive: state.common.headerInfo.ForsiTokenActive
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  setHeaderInfo: _common.setHeaderInfo
	})(ForsiCreateReport);

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _reactHoverObserver = __webpack_require__(684);
	
	var _reactHoverObserver2 = _interopRequireDefault(_reactHoverObserver);
	
	var _orders = __webpack_require__(21);
	
	var _currency = __webpack_require__(41);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1535);
	
	var _Extent = __webpack_require__(153);
	
	var _Extent2 = _interopRequireDefault(_Extent);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	// Components
	// import Price from '../../../pages/PriceCalculation/Price'
	
	// Actions
	
	
	// Utils
	
	// Utils
	
	
	// Styles
	
	
	// Elements
	
	
	var HoverExtent = function (_Component) {
	  _inherits(HoverExtent, _Component);
	
	  function HoverExtent(props) {
	    _classCallCheck(this, HoverExtent);
	
	    var _this = _possibleConstructorReturn(this, (HoverExtent.__proto__ || Object.getPrototypeOf(HoverExtent)).call(this, props));
	
	    _this.onHoverChanged = _this.onHoverChanged.bind(_this);
	    _this.checkPos = _this.checkPos.bind(_this);
	    _this.state = {
	      active: false,
	      status: 'loading',
	      item: undefined,
	      // showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1',
	      adjustPopupBottom: false
	    };
	    return _this;
	  }
	
	  _createClass(HoverExtent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _events2.default.addListener('price updated', this.checkPos);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _events2.default.removeListener('price updated', this.checkPos);
	    }
	  }, {
	    key: 'checkPos',
	    value: function checkPos() {
	      if (this.state.active) {
	        this.app = _reactDom2.default.findDOMNode(document.getElementById('app'));
	        var orderListElement = document.getElementsByClassName('orderlist__list');
	        if (orderListElement.length > 0) {
	          this.listElement = _reactDom2.default.findDOMNode(orderListElement[0]);
	        }
	        if (this.listElement !== undefined) {
	          this.listContent = this.listElement.childNodes[0];
	        }
	        if (this.listElement !== undefined && this.listContent !== undefined) {
	          if (this.state.active === true) {
	            var hoverRect = _reactDom2.default.findDOMNode(this).getElementsByClassName('hover_extent-popup')[0].getBoundingClientRect();
	            // let listScroll = this.app.scrollTop
	            // let listHeight = this.listContent.offsetHeight
	            // let itemListPos = (hoverRect.bottom + listScroll + 151)
	            var windowHeight = window.innerHeight;
	            var bottomOffset = windowHeight - (hoverRect.top + hoverRect.height);
	            // if (itemListPos > listHeight && hoverRect.top > 0 || bottomOffset < 31) {
	            if (bottomOffset < 31) {
	              // let itemHeight = hoverRect.height
	              // console.log('--- HOVER POPUP BELOW LIST EDGE! (' + itemListPos + ' > ' + listHeight + ')', itemListPos - listHeight)
	              if (this.state.adjustPopupBottom !== true) {
	                this.setState({ adjustPopupBottom: true });
	              }
	            }
	          } else {
	            if (this.state.adjustPopupBottom !== false) {
	              this.setState({ adjustPopupBottom: false });
	            }
	          }
	        }
	      } else {
	        if (this.state.adjustPopupBottom !== false) {
	          this.setState({ adjustPopupBottom: false });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this.checkPos();
	    }
	    // componentWillReceiveProps (nextPost) {
	    //   this.listElement = undefined
	    //   this.listContent = undefined
	    //   this.checkPos()
	    // }
	
	  }, {
	    key: 'getOrder',
	    value: function getOrder(id) {
	      var _this2 = this;
	
	      this.props.getOrderClean(id).then(function (res) {
	        _this2.setState({
	          item: res.data,
	          status: 'loaded'
	          // showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1'
	        }, function () {
	          _this2.checkPos();
	        });
	      }, function () {
	        _this2.setState({
	          status: 'failed'
	        });
	      });
	    }
	  }, {
	    key: 'onHoverChanged',
	    value: function onHoverChanged(data) {
	      var _this3 = this;
	
	      if (data.isHovering !== this.state.active) {
	        this.setState({
	          active: data.isHovering,
	          status: data.isHovering ? this.state.status : 'loading',
	          item: data.isHovering ? this.state.item : undefined
	        }, function () {
	          if (data.isHovering) {
	            _this3.getOrder(_this3.props.id);
	          } else {
	            if (_this3.state.adjustPopupBottom !== false) {
	              _this3.setState({ adjustPopupBottom: false });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'renderOther',
	    value: function renderOther() {
	      if (this.state.item.OrderType === 4) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'extent_other' },
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('889') }),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 'min-content'] },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('1206')
	            ),
	            this.state.item.OtherTitle || ''
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 'min-content'] },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('1021')
	            ),
	            this.state.item.OtherDescription || ''
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 'min-content'] },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('641')
	            ),
	            this.state.item.Price || 0
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 'min-content'] },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('13339')
	            ),
	            this.state.item.Environment || 0
	          )
	        );
	      }
	      return undefined;
	    }
	  }, {
	    key: 'renderPrices',
	    value: function renderPrices() {
	      var hasAwaiting = this.state.item.HasAwaiting;
	      var hasAwaitingAddon = this.state.item.HasAwaitingAddon;
	      if (this.state.item.OrderType !== 4) {
	        var basePaint = _react2.default.createElement(_Extent2.default, {
	          order: this.props.id,
	          department: 0
	          // showAgreementPrice={this.state.showAgreementPrice}
	          , extents: [{
	            type: 'base',
	            editable: false,
	            showEditLink: false,
	            noTitle: true,
	            overrideInnerTitle: (0, _helpers.translation)('2093') + ' ' + (0, _helpers.translation)('161'),
	            viewMode: 'hover',
	            showOnlyWork: true,
	            useSelectedEvaluation: true
	          }]
	        });
	
	        var addonPaint = _react2.default.createElement(_Extent2.default, {
	          order: this.props.id,
	          department: 0
	          // showAgreementPrice={this.state.showAgreementPrice}
	          , extents: [{
	            type: 'addon',
	            editable: false,
	            showEditLink: false,
	            noTitle: true,
	            overrideInnerTitle: (0, _helpers.translation)('161') + ' ' + (0, _helpers.translation)('1045'),
	            viewMode: 'hover',
	            showOnlyWork: true
	          }]
	        });
	
	        var baseBody = _react2.default.createElement(_Extent2.default, {
	          order: this.props.id,
	          department: 1
	          // showAgreementPrice={this.state.showAgreementPrice}
	          , extents: [{
	            type: 'base',
	            editable: false,
	            showEditLink: false,
	            noTitle: true,
	            overrideInnerTitle: (0, _helpers.translation)('2093') + ' ' + (0, _helpers.translation)('14779'),
	            viewMode: 'hover',
	            showOnlyWork: true
	          }]
	        });
	
	        var addonBody = _react2.default.createElement(_Extent2.default, {
	          order: this.props.id,
	          department: 1
	          // showAgreementPrice={this.state.showAgreementPrice}
	          , extents: [{
	            type: 'addon',
	            editable: false,
	            showEditLink: false,
	            noTitle: true,
	            overrideInnerTitle: (0, _helpers.translation)('14779') + ' ' + (0, _helpers.translation)('1045'),
	            viewMode: 'hover',
	            showOnlyWork: true
	          }]
	        });
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.props.auth.departmentType !== 1 && _react2.default.createElement(
	            'span',
	            { className: 'showPriceItem' },
	            hasAwaiting && _react2.default.createElement(
	              'div',
	              { className: 'color_diff' },
	              (0, _helpers.translation)('2729')
	            ),
	            this.state.item.HasExtent && basePaint,
	            hasAwaitingAddon && _react2.default.createElement(
	              'div',
	              { className: 'color_diff' },
	              (0, _helpers.translation)('17840')
	            ),
	            this.state.item.HasExtentAddon && addonPaint
	          ),
	          this.props.auth.departmentType !== 0 && !(this.props.auth.departmentType === 2 && this.state.item.ExternalCompanyId !== null) && _react2.default.createElement(
	            'span',
	            { className: 'showPriceItem' },
	            !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) /* && this.state.item.HasExtentBodyShop */ && baseBody,
	            !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.state.item.HasExtentBodyShopAddon && addonBody
	          ),
	          !this.state.item.HasExtent && !this.state.item.HasExtentBodyShop && this.props.auth.departmentType !== 1 && this.state.item.OrderType !== 1 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'extent_other custom' },
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: [1, 'min-content'] },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('641')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(this.state.item.Price || 0)
	                )
	              ),
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: [1, 'min-content'] },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('13339')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(this.state.item.Environment || 0)
	                )
	              )
	            )
	          )
	        );
	      }
	      return undefined;
	    }
	  }, {
	    key: 'renderPopup',
	    value: function renderPopup() {
	      var positionAdjustStyle = null;
	      if (this.state.adjustPopupBottom === true) {
	        positionAdjustStyle = { bottom: 30, top: 'auto' };
	      }
	      if (this.state.status === 'loading') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'hover_extent-popup', style: positionAdjustStyle },
	          _react2.default.createElement(
	            'p',
	            { className: 'loading' },
	            _react2.default.createElement(
	              'span',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            )
	          )
	        );
	      }
	      if (this.state.status === 'failed') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'hover_extent-popup', style: positionAdjustStyle },
	          _react2.default.createElement(
	            'p',
	            { className: 'loading' },
	            (0, _helpers.translation)('2269')
	          )
	        );
	      }
	      // const onChange = (e) => {
	      //   if (e !== undefined) {
	      //     if (e.target.name === 'showAgreementPrice') {
	      //       let show = window.localStorage.getItem('showAgreementPrice') === '1'
	      //       window.localStorage.setItem('showAgreementPrice', show ? 0 : 1)
	      //       this.setState({
	      //         showAgreementPrice: !show
	      //       })
	      //     }
	      //   }
	      //   return window.localStorage.getItem('showAgreementPrice') === '1'
	      // }
	      // let checked = this.state.showAgreementPrice
	      // // console.log(this.state.item)
	      // const renderCheck = () => {
	      //   if (!hasAccess([6], this.props.auth.user.UserType)) return undefined
	      //   return (
	      //     <div className='checkbox__custom__wrapper'>
	      //       <div className='checkbox__custom'>
	      //         <input type='checkbox' name='showAgreementPrice' id='sshowAgreementPrice' checked={checked} onChange={onChange} />
	      //         <label htmlFor='sshowAgreementPrice'>{translation('12318')}
	      //         </label>
	      //       </div>
	      //     </div>
	      //   )
	      // }
	      return _react2.default.createElement(
	        'div',
	        { className: 'hover_extent-popup', style: positionAdjustStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'extent_box clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'white__box' },
	            this.renderPrices(),
	            this.renderOther(),
	            this.renderColors(),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.renderComments()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderColors',
	    value: function renderColors() {
	      var item = this.state.item;
	
	      if ((item.Color === null || item.Color === '') && (item.ColorCode === null || item.ColorCode === '') && (item.ColorVariant === null || item.ColorVariant === '') && (item.ColorAmount === null || item.ColorAmount === '')) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'colorDiv' },
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('179') }),
	        _react2.default.createElement(_divider2.default, null),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'min-content'] },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('179')
	          ),
	          item.Color || ''
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'min-content'] },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('79')
	          ),
	          item.ColorCode || ''
	        ),
	        this.props.auth.departmentType !== 1 && _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'min-content'] },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('13388')
	          ),
	          item.ColorVariant || ''
	        ),
	        this.props.auth.departmentType !== 1 && _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'min-content'] },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('13392')
	          ),
	          item.ColorAmount || ''
	        )
	      );
	    }
	  }, {
	    key: 'renderComments',
	    value: function renderComments() {
	      if (this.state.item.Notes.length === 0) return null;
	      var renderNote = function renderNote(note, key) {
	        // console.log('Note', note)
	        var labelText = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            note.NoteUserName
	          ),
	          ': ',
	          (0, _time.renderFullDate)(note.NoteDate)
	        );
	        return _react2.default.createElement(
	          'div',
	          { key: key, className: 'note' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: labelText },
	            (0, _helpers.translation)(note.SourceDictionaryKey),
	            ': ',
	            note.Note
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'notes' },
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('93') }),
	        _react2.default.createElement(_divider2.default, null),
	        this.state.item.Notes.map(renderNote)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactHoverObserver2.default,
	        {
	          className: 'hover_extent',
	          hoverDelayInMs: 1000,
	          hoverOffDelayInMs: 500,
	          onHoverChanged: this.onHoverChanged,
	          shouldDecorateChildren: false },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.children,
	          this.state.active && this.renderPopup()
	        )
	      );
	    }
	  }]);
	
	  return HoverExtent;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetExtends: _orders.GetExtends,
	  getOrderClean: _orders.getOrderClean
	})(HoverExtent);

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _invoicing = __webpack_require__(150);
	
	var _auth = __webpack_require__(8);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ResendText = __webpack_require__(288);
	
	var _ResendText2 = _interopRequireDefault(_ResendText);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	// import Check from '../../elements/check'
	
	
	// Styles
	
	
	var InvoicePopup = function (_Component) {
	  _inherits(InvoicePopup, _Component);
	
	  function InvoicePopup(props) {
	    _classCallCheck(this, InvoicePopup);
	
	    var _this = _possibleConstructorReturn(this, (InvoicePopup.__proto__ || Object.getPrototypeOf(InvoicePopup)).call(this, props));
	
	    _this.invoiceOrder = _this.invoiceOrder.bind(_this);
	    _this.approveInvoice = _this.approveInvoice.bind(_this);
	    _this.checkApproveInvoice = _this.checkApproveInvoice.bind(_this);
	    _this.markAsInvoiced = _this.markAsInvoiced.bind(_this);
	    _this.confirm = _this.confirm.bind(_this);
	    _this.confirmResend = _this.confirmResend.bind(_this);
	    _this.confirmAddon = _this.confirmAddon.bind(_this);
	    _this.notConfirm = _this.notConfirm.bind(_this);
	    _this.getLastHistory = _this.getLastHistory.bind(_this);
	    _this.onConfirmApprove = _this.onConfirmApprove.bind(_this);
	    _this.getKeyLoopSystemName = _this.getKeyLoopSystemName.bind(_this);
	    _this.getRepairOrderAlias = _this.getRepairOrderAlias.bind(_this);
	    _this.state = {
	      splitAddon: props.item.SeparateAddonInvoice,
	      isLoading: false,
	      showPopup: false,
	      showResendPopup: false,
	      showAddonPopup: false,
	      isInvoiced: false,
	      lastHistory: null,
	      FoundHistory: {
	        Date: '0001-01-01T00:00:00',
	        EconomicAddonInvoiceId: 0,
	        EconomicInvoiceId: 0,
	        EconomicKickbackInvoiceId: 0,
	        FoundHistory: false,
	        UserName: null
	      },
	      shouldMark: false,
	      confirmApproveAssesment: {
	        open: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(InvoicePopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var isReady = !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.props.item.ReadyForInvoice === 1 || (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.props.item.ReadyForInvoiceByWP;
	      var isInvoiced = !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.props.item.IsInvoiced || (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.props.item.IsInvoicedByWP;
	      var isDraft = this.props.item.IsDraft;
	
	      this.getLastHistory();
	    }
	  }, {
	    key: 'getLastHistory',
	    value: function getLastHistory(cb) {
	      var _this2 = this;
	
	      this.setState({
	        isLoading: true
	      }, function () {
	        _this2.props.invoiceHistory(_this2.props.item.Id).then(function (res) {
	          _this2.setState({
	            isLoading: false,
	            lastHistory: res.data
	          }, function () {
	            // console.log('this.state.lastHistory', this.state.lastHistory)
	            if (cb !== undefined) {
	              cb();
	            }
	          });
	        }, function () {
	          _this2.setState({
	            isLoading: false
	          });
	          if (cb !== undefined) {
	            cb();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'invoiceOrder',
	    value: function invoiceOrder(markInvoiced) {
	      var _this3 = this;
	
	      var confirmed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var addonChecked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      // console.log('[Invoice][invoiceOrder]')
	      if (this.state.isLoading) return;
	      if (this.state.showResendPopup === true || this.state.showAddonPopup === true) {
	        this.setState({
	          showResendPopup: false,
	          showAddonPopup: false
	        });
	      }
	      if (this.state.lastHistory && this.state.lastHistory.FoundHistory === true && confirmed !== true) {
	        this.setState({
	          showResendPopup: true,
	          shouldMark: markInvoiced === true
	          // }, {  () => console.log('[Invoice]', this.state)
	        });
	        return null;
	      }
	      if (this.props.item.HasAddonPrice && this.props.item.CanChangeAddonInvoice && !this.state.splitAddon && !addonChecked) {
	        this.setState({
	          showAddonPopup: true,
	          shouldMark: markInvoiced === true
	        });
	        return null;
	      }
	      var split = this.state.splitAddon;
	      var data = {
	        OrderId: this.props.item.Id,
	        SplitAddon: split,
	        MarkAsInvoiced: markInvoiced === true
	      };
	      this.setState({ isLoading: true }, function () {
	        // this.props.showSpinner('invoicing', true)
	        _this3.props.invoiceOrder(data).then(function (res) {
	          var item = _extends({}, _this3.props.item);
	          item.IsInvoiced = true;
	          if (markInvoiced === true) {
	            item.IsMarkInvoiced = true;
	          }
	          _this3.props.updateOrder(item);
	          // if (!confirmed) {
	          //   this.props.close()
	          // }
	          _this3.props.showSpinner('invoicing', false);
	          _this3.setState({ isLoading: false }, function () {
	            _this3.props.close();
	          });
	
	          // Toastr
	          // window.toastr.success(translation('13022'), translation('13424'))
	        }, function (err) {
	          _this3.props.close();
	          _this3.props.showSpinner('invoicing', false);
	          // Toastr
	          if (err.response) {
	            if (err.response.data !== undefined && err.response.data.Error !== undefined) {
	              var error = err.response.data.Error;
	              var errorText = (0, _helpers.translation)('960');
	              // OrderNotFound = 1,
	              // CompanyNotFound = 2,
	              // NotValidEconomicCredentials = 3,
	              // NotValidHeliosNumber = 4,
	              // NotValidC5UserPass = 5,
	              // OrderIsAlreadySent = 6,
	              // AwaitingPriceApproval = 8
	              switch (error) {
	                case 0:
	                  errorText = (0, _helpers.translation)('13700');
	                  break;
	                case 1:
	                  errorText = (0, _helpers.translation)('13701');
	                  break;
	                case 2:
	                  errorText = (0, _helpers.translation)('13702');
	                  break;
	                case 3:
	                  errorText = (0, _helpers.translation)('13703');
	                  break;
	                case 4:
	                  errorText = (0, _helpers.translation)('13704');
	                  break;
	                case 5:
	                  errorText = (0, _helpers.translation)('13705');
	                  break;
	                case 6:
	                  errorText = (0, _helpers.translation)('13706');
	                  break;
	                case 7:
	                  errorText = (0, _helpers.translation)('13707');
	                  break;
	                case 8:
	                  errorText = (0, _helpers.translation)('2710');
	                  break;
	                case 9:
	                  errorText = (0, _helpers.translation)('14851');
	                  break;
	                case 10:
	                  errorText = (0, _helpers.translation)('16616');
	                  break;
	                case 11:
	                  errorText = (0, _helpers.translation)('16617');
	                  break;
	                case 12:
	                  errorText = (0, _helpers.translation)('16650');
	                  break;
	                case 13:
	                  errorText = (0, _helpers.translation)('16618');
	                  break;
	                case 14:
	                  errorText = (0, _helpers.translation)('16636').replace('[KeyLoopSystem]', _this3.getKeyLoopSystemName()).replace('[RepairOrderAlias]', _this3.getRepairOrderAlias());
	                  break;
	                case 15:
	                  errorText = (0, _helpers.translation)('16651');
	                  break;
	                case 16:
	                  errorText = (0, _helpers.translation)('16619').replace('[KeyLoopSystem]', _this3.getKeyLoopSystemName());
	                  break;
	                case 17:
	                  errorText = (0, _helpers.translation)('17947');
	                  break;
	                case 18:
	                  errorText = (0, _helpers.translation)('18145');
	                  break;
	                case 19:
	                  errorText = (0, _helpers.translation)('18144');
	                  break;
	                default:
	                  break;
	              }
	              window.toastr.error(errorText, (0, _helpers.translation)('216'));
	            } else {
	              window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	            }
	          } else {
	            window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	          }
	        });
	      });
	    }
	  }, {
	    key: 'checkApproveInvoice',
	    value: function checkApproveInvoice(undo, checkForAfterEvaluation) {
	      if (!undo && checkForAfterEvaluation && this.props.item.OrderType === _constants.OrderTypes.Insurance && this.props.item.LastUpdatedType === 1) {
	        this.setState({
	          showPopup: true
	        });
	        return;
	      }
	
	      if (this.state.lastHistory && this.state.lastHistory.FoundHistory === true && this.props.item.IsAssessmentOk === false) {
	        this.setState({
	          confirmApproveAssesment: {
	            open: !this.state.confirmApproveAssesment.open
	          }
	        }, function () {});
	        return;
	      }
	      this.approveInvoice(undo);
	    }
	  }, {
	    key: 'approveInvoice',
	    value: function approveInvoice(undo) {
	      var _this4 = this;
	
	      if (this.state.confirmApproveAssesment.open === true) {
	        this.setState({
	          confirmApproveAssesment: {
	            open: false
	          }
	        });
	      }
	      this.props.showSpinner('invoicing', true);
	      this.props.approveOrderInvoice(this.props.item.Id, undo).then(function (res) {
	        var item = _extends({}, _this4.props.item);
	        item.ReadyForInvoice = res.data.ReadyForInvoice ? 1 : 0;
	        item.ReadyForInvoiceByWP = res.data.ReadyForInvoice;
	        item.IsAssessmentOk = res.data.ReadyForInvoice;
	        if (item.ReadyForInvoice) {
	          item.InspectionStepsCompleted += 1;
	        }
	        _this4.props.updateOrder(item);
	        _this4.props.close();
	        _this4.props.showSpinner('invoicing', false);
	        // Toastr
	        if (res.data.ReadyForInvoice) {
	          // window.toastr.success(translation('13708'), translation('13424'))
	        } else {
	            // window.toastr.success(translation(15213), translation('13424'))
	          }
	      }, function (err) {
	        _this4.props.close();
	        _this4.props.showSpinner('invoicing', false);
	        // Toastr
	        if (err.response) {
	          if (err.response.data !== undefined && err.response.data.Errors !== undefined && err.response.data.Errors.length === 1) {
	            var error = err.response.data.Errors[0];
	            var text = (0, _helpers.translation)(error.DictionaryKey);
	            if (error.Parameters.length === 1) {
	              text = text.replace('[WorkProvider]', error.Parameters[0]);
	            }
	            // console.log(err.response.data, error, text)
	            window.toastr.error(text, (0, _helpers.translation)('216'));
	          } else if (err.response.status === 403) {
	            window.toastr.error((0, _helpers.translation)('1794'), (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	          }
	        } else {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'markAsInvoiced',
	    value: function markAsInvoiced() {
	      var _this5 = this;
	
	      this.props.showSpinner('invoicing', true);
	      this.props.markAsInvoiced(this.props.item.Id).then(function (res) {
	        var result = res.data;
	        var item = _extends({}, _this5.props.item);
	        item.IsMarkInvoiced = result.MarkInvoiced;
	        _this5.props.updateOrder(item);
	        _this5.props.close();
	        _this5.props.showSpinner('invoicing', false);
	
	        // window.toastr.success(translation('13510'), translation('13424'))
	      }, function () {
	        _this5.props.close();
	        _this5.props.showSpinner('invoicing', false);
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13650'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm() {
	      var _this6 = this;
	
	      this.setState({
	        showPopup: false,
	        showResendPopup: false
	      }, function () {
	        _this6.checkApproveInvoice(false);
	      });
	    }
	  }, {
	    key: 'confirmResend',
	    value: function confirmResend(e) {
	      var _this7 = this;
	
	      e.stopPropagation();
	      e.preventDefault();
	      this.setState({
	        showResendPopup: false
	      }, function () {
	        _this7.invoiceOrder(_this7.state.shouldMark === true, true);
	      });
	    }
	  }, {
	    key: 'confirmAddon',
	    value: function confirmAddon(val) {
	      var _this8 = this;
	
	      this.setState({
	        splitAddon: val,
	        showAddonPopup: false
	      }, function () {
	        _this8.invoiceOrder(_this8.state.shouldMark === true, true, true);
	      });
	    }
	
	    // notConfirmAddon () {
	    //   this.setState({
	    //     splitAddon: false,
	    //     showAddonPopup: false
	    //   }, () => { this.invoiceOrder(this.state.shouldMark === true, true, true) })
	    // }
	
	  }, {
	    key: 'notConfirm',
	    value: function notConfirm() {
	      this.setState({
	        showPopup: false,
	        showResendPopup: false,
	        confirmApproveAssesment: {
	          open: false
	        }
	      });
	    }
	  }, {
	    key: 'onConfirmApprove',
	    value: function onConfirmApprove() {
	      this.approveInvoice(false);
	    }
	  }, {
	    key: 'getKeyLoopSystemName',
	    value: function getKeyLoopSystemName() {
	      switch (this.props.auth.accountingSystem) {
	        case 4:
	          return (0, _helpers.translation)(15352);
	        case 6:
	          return (0, _helpers.translation)(18138);
	      }
	      return '';
	    }
	  }, {
	    key: 'getRepairOrderAlias',
	    value: function getRepairOrderAlias() {
	      switch (this.props.auth.accountingSystem) {
	        case 4:
	          return (0, _helpers.translation)(18149);
	        case 6:
	          return (0, _helpers.translation)(18150);
	      }
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _props = this.props,
	          auth = _props.auth,
	          item = _props.item,
	          dracarSettings = _props.dracarSettings;
	
	      var isReady = (!(0, _auth.hasAccess)([6], auth.user.UserType) && item.ReadyForInvoice === 1 || (0, _auth.hasAccess)([6], auth.user.UserType) && item.ReadyForInvoiceByWP) && (!dracarSettings || dracarSettings.dracarActive);
	      var isMarked = !(0, _auth.hasAccess)([6], auth.user.UserType) && item.IsMarkInvoiced || (0, _auth.hasAccess)([6], auth.user.UserType) && item.IsMarkInvoicedByWP;
	      var isInvoiced = !(0, _auth.hasAccess)([6], auth.user.UserType) && item.IsInvoiced || (0, _auth.hasAccess)([6], auth.user.UserType) && item.IsInvoicedByWP;
	      var isDraft = auth.departmentType !== 1 ? item.IsDraft : item.BodyShopIsDraft;
	      var isInsurance = item.OrderType === 1;
	
	      if (isDraft || isInvoiced && isMarked) return null;
	
	      var allowInvoicing = true;
	      var lastHistoryMessageKey = this.state.lastHistory ? this.state.lastHistory.MessageKey : '';
	      if (this.state.lastHistory) {
	        allowInvoicing = this.state.lastHistory.AllowInvoicing; // if Body Paint partner has pricelist, AllowInvoicing is false
	      }
	
	      // let hasAddon = item.HasAddonPrice
	      var isReset = item.InvoiceStatusIsResat;
	
	      var renderText = function renderText() {
	        return _react2.default.createElement(_ResendText2.default, { isLoadingLastHistory: _this9.state.isLoading, lastHistory: _this9.state.lastHistory, t: _helpers.translation, store: _store2.default });
	      };
	
	      var renderConfirmApproveDialog = function renderConfirmApproveDialog() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ResendText2.default, { isLoadingLastHistory: _this9.state.isLoading, lastHistory: _this9.state.lastHistory, t: _helpers.translation, store: _store2.default, assessment: true })
	        );
	      };
	
	      var renderButtonText = function renderButtonText(text) {
	        if (_this9.state.isLoading) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	          );
	        }
	        return text;
	      };
	
	      var approveIcon = _icons.InvoiceIcons.Ready_Invoice;
	      if (!isDraft && isReset) {
	        approveIcon = _icons.InvoiceIcons.Invoice_Reset_Approved;
	      }
	      var dracarMessages = {
	        MISSING_B2B: (0, _helpers.translation)('17836').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()),
	        NO_INTEGRATION: (0, _helpers.translation)('16773').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()),
	        ORDER_NOT_IN_KEYLOOP: (0, _helpers.translation)('16609').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()),
	        LAST_HISTORY: (0, _helpers.translation)(this.state.lastHistory ? this.state.lastHistory.MessageKey : '').replace('[KeyLoopSystem]', this.getKeyLoopSystemName())
	      };
	
	      var isUsingKeyLoop = [4, 6].includes(this.props.auth.accountingSystem);
	      var isDracarApprovalPending = dracarSettings && !isReady && !isDraft && !isInvoiced;
	      var isDracarInvoicingPending = dracarSettings && !isDraft && !isInvoiced;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'poppedup padding invoiceInlinePopup form textLeft' },
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [1], alignChildren: 'bottom' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.InvoiceIcons.Total_Price }),
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('13486')
	          ),
	          _react2.default.createElement(_closeButton2.default, { size: 'm', onClick: this.props.close })
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        isDracarApprovalPending && !isReset && !dracarSettings.isRpReport && !allowInvoicing && _react2.default.createElement(
	          'div',
	          { className: 'dracar__approval dracar__red' },
	          dracarMessages.LAST_HISTORY
	        ),
	        isDracarApprovalPending && !isReset && !dracarSettings.isRpReport && !dracarSettings.isDracarOtherOrder && _react2.default.createElement(
	          'div',
	          { className: 'dracar__approval dracar__red' },
	          dracarMessages.MISSING_B2B
	        ),
	        isDracarApprovalPending && !isReset && dracarSettings.isRpReport && !allowInvoicing && _react2.default.createElement(
	          'div',
	          { className: 'dracar__approval dracar__red' },
	          dracarMessages.MISSING_B2B
	        ),
	        isDracarInvoicingPending && dracarSettings.isDracarOtherOrder && _react2.default.createElement(
	          'div',
	          { className: 'dracar__approval dracar__red' },
	          dracarMessages.NO_INTEGRATION
	        ),
	        isDracarInvoicingPending && !dracarSettings.isDracarOtherOrder && !dracarSettings.dracarOrderSet && _react2.default.createElement(
	          'div',
	          { className: 'dracar__approval dracar__red' },
	          dracarMessages.ORDER_NOT_IN_KEYLOOP
	        ),
	        !isReady && !isDraft && !isInvoiced && isReset && (0, _helpers.translation)('15068'),
	        !isReady && !isDraft && !isInvoiced && !isReset && _react2.default.createElement(
	          _label2.default,
	          null,
	          (0, _helpers.translation)('1140')
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0], alignChildren: 'center' },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('13502')
	          ),
	          _react2.default.createElement(_icon2.default, { icon: approveIcon }),
	          isUsingKeyLoop && isDracarApprovalPending && allowInvoicing && (dracarSettings.dracarOrderSet && (dracarSettings.isRpReport || isInsurance) || dracarSettings.isDracarOtherOrder) && _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', onClick: function onClick() {
	              return _this9.checkApproveInvoice(false, true);
	            }, disabled: this.state.isLoading || isReady && !isDraft && !isInvoiced, labelText: renderButtonText((0, _helpers.translation)('752')), style: 'link' }),
	          !isUsingKeyLoop && !isReady && !isDraft && !isInvoiced && allowInvoicing && _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', onClick: function onClick() {
	              return _this9.checkApproveInvoice(false, true);
	            }, disabled: this.state.isLoading || isReady && !isDraft && !isInvoiced, labelText: renderButtonText((0, _helpers.translation)('752')), style: 'link' })
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0], alignChildren: 'center' },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('13503')
	          ),
	          _react2.default.createElement(_icon2.default, { icon: _icons.InvoiceIcons.Sent_To_Invoice }),
	          _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', onClick: function onClick() {
	              return _this9.invoiceOrder(false);
	            }, disabled: this.state.isLoading || isInvoiced || !isReady || dracarSettings && dracarSettings.isDracarOtherOrder, labelText: renderButtonText((0, _helpers.translation)('1301')), style: 'link' })
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0], alignChildren: 'center' },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('13505')
	          ),
	          _react2.default.createElement(_icon2.default, { icon: _icons.InvoiceIcons.Invoiced }),
	          _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', onClick: function onClick() {
	              return _this9.invoiceOrder(true);
	            }, disabled: this.state.isLoading || isMarked || isInvoiced || !isReady || dracarSettings && dracarSettings.isDracarOtherOrder, labelText: renderButtonText((0, _helpers.translation)('1301')), style: 'link' })
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0], alignChildren: 'center' },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('13504')
	          ),
	          _react2.default.createElement(_icon2.default, { icon: _icons.InvoiceIcons.Marked_As_Invoice }),
	          _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', onClick: function onClick() {
	              return _this9.markAsInvoiced();
	            }, disabled: this.state.isLoading || isMarked || !isReady, labelText: renderButtonText((0, _helpers.translation)('15046')), style: 'link' })
	        ),
	        isReady && !isInvoiced && !isMarked && _react2.default.createElement(
	          'a',
	          { onClick: function onClick() {
	              return _this9.checkApproveInvoice(true);
	            } },
	          (0, _helpers.translation)('13515')
	        ),
	        this.state.showPopup === true && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Confirm2.default, {
	            t: _helpers.translation,
	            renderText: function renderText() {
	              return (0, _helpers.translation)('14747');
	            },
	            confirm: this.confirm,
	            notConfirm: this.notConfirm })
	        ),
	        this.state.showAddonPopup === true && _react2.default.createElement(_Confirm2.default, {
	          t: _helpers.translation,
	          renderText: function renderText() {
	            return (0, _helpers.translation)('16485');
	          },
	          confirm: function confirm() {
	            return _this9.confirmAddon(true);
	          },
	          notConfirm: function notConfirm() {
	            return _this9.confirmAddon(false);
	          } }),
	        this.state.showResendPopup === true && _react2.default.createElement(_Confirm2.default, {
	          t: _helpers.translation,
	          renderText: renderText,
	          confirm: function confirm(e) {
	            return _this9.confirmResend(e);
	          },
	          notConfirm: this.notConfirm }),
	        this.state.confirmApproveAssesment.open === true && _react2.default.createElement(_Confirm2.default, {
	          t: _helpers.translation,
	          renderText: renderConfirmApproveDialog,
	          confirm: this.approveInvoice.bind(this, false),
	          notConfirm: this.notConfirm })
	      );
	    }
	  }]);
	
	  return InvoicePopup;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  invoiceOrder: _invoicing.invoiceOrder,
	  approveOrderInvoice: _invoicing.approveOrderInvoice,
	  markAsInvoiced: _invoicing.markAsInvoiced,
	  invoiceHistory: _invoicing.invoiceHistory
	})(InvoicePopup);

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1555);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _backdrop = __webpack_require__(29);
	
	var _common = __webpack_require__(25);
	
	var _ProductionStatusOverlay = __webpack_require__(1126);
	
	var _ProductionStatusOverlay2 = _interopRequireDefault(_ProductionStatusOverlay);
	
	var _DeliveryStatusOverlay = __webpack_require__(1118);
	
	var _DeliveryStatusOverlay2 = _interopRequireDefault(_DeliveryStatusOverlay);
	
	var _PickupStatusOverlay = __webpack_require__(1125);
	
	var _PickupStatusOverlay2 = _interopRequireDefault(_PickupStatusOverlay);
	
	var _icons = __webpack_require__(6);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Utils
	
	
	// import components
	
	
	// Actions
	
	
	// Overlays
	
	
	// Elements
	
	
	var OverviewStatusSelection = function (_Component) {
	  _inherits(OverviewStatusSelection, _Component);
	
	  function OverviewStatusSelection(props) {
	    _classCallCheck(this, OverviewStatusSelection);
	
	    var _this = _possibleConstructorReturn(this, (OverviewStatusSelection.__proto__ || Object.getPrototypeOf(OverviewStatusSelection)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      isLoading: false
	    };
	    _this.openOverlay = _this.openOverlay.bind(_this);
	    return _this;
	  }
	
	  _createClass(OverviewStatusSelection, [{
	    key: 'openOverlay',
	    value: function openOverlay(overlay) {
	      this.props.openOverlay(overlay);
	      this.setState({ overviewstatusmodal: false });
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!((0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && !(0, _auth.hasAccess)([4], this.props.auth.user.UserType))) return null;
	      var openOverviewStatusModal = function openOverviewStatusModal() {
	        _this2.setState({ overviewstatusmodal: true });
	        _this2.props.triggerPopup(true);
	      };
	      var closeOverviewStatusModal = function closeOverviewStatusModal() {
	        _this2.props.triggerPopup(false);
	        _this2.setState({
	          overviewstatusmodal: false
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'overviewstatus-section' },
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', style: 'link', labelText: (0, _helpers.translation)('13052'), onClick: openOverviewStatusModal }),
	        this.state.overviewstatusmodal && _react2.default.createElement(
	          'div',
	          { className: 'overviewstatus_modal' },
	          _react2.default.createElement(
	            _Modal2.default,
	            { show: this.state.overviewstatusmodal, router: this.props.router, onClose: closeOverviewStatusModal, header: (0, _helpers.translation)('16720'), overflowHidden: this.state.overflowHidden,
	              icon: _icons.ModalIcons.Repport_Data },
	            _react2.default.createElement(
	              'div',
	              { className: 'overviews' },
	              _react2.default.createElement(_button2.default, { style: 'link', labelText: (0, _helpers.translation)('16839'), onClick: function onClick() {
	                  return _this2.openOverlay('PickupStatusOverlay');
	                } }),
	              _react2.default.createElement(_button2.default, { style: 'link', labelText: (0, _helpers.translation)('16719'), onClick: function onClick() {
	                  return _this2.openOverlay('ProductionStatusOverlay');
	                } }),
	              _react2.default.createElement(_button2.default, { style: 'link', labelText: (0, _helpers.translation)('16721'), onClick: function onClick() {
	                  return _this2.openOverlay('DeliveryStatusOverlay');
	                } })
	            )
	          )
	        ),
	        _react2.default.createElement(_ProductionStatusOverlay2.default, null),
	        _react2.default.createElement(_DeliveryStatusOverlay2.default, null),
	        _react2.default.createElement(_PickupStatusOverlay2.default, null)
	      );
	    }
	  }]);
	
	  return OverviewStatusSelection;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  openOverlay: _common.openOverlay
	})(OverviewStatusSelection);

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	__webpack_require__(1560);
	
	var _PrivacyPolicyModal = __webpack_require__(1105);
	
	var _PrivacyPolicyModal2 = _interopRequireDefault(_PrivacyPolicyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Modals
	
	
	var PrivacyPolicy = function (_Component) {
	  _inherits(PrivacyPolicy, _Component);
	
	  function PrivacyPolicy(props) {
	    _classCallCheck(this, PrivacyPolicy);
	
	    var _this = _possibleConstructorReturn(this, (PrivacyPolicy.__proto__ || Object.getPrototypeOf(PrivacyPolicy)).call(this, props));
	
	    _this.state = {
	      showModal: false
	    };
	
	    _this.toggleShow = _this.toggleShow.bind(_this);
	    return _this;
	  }
	
	  _createClass(PrivacyPolicy, [{
	    key: 'toggleShow',
	    value: function toggleShow(e) {
	      if (e !== undefined) {
	        e.preventDefault();
	      }
	      this.setState({
	        showModal: !this.state.showModal
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'privacy-policy__item' },
	        _react2.default.createElement(
	          'a',
	          { href: '', onClick: this.toggleShow.bind(this) },
	          this.props.text
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { onPortalClose: this.toggleShow.bind(this) },
	          _react2.default.createElement(_PrivacyPolicyModal2.default, { show: this.state.showModal, onClose: this.toggleShow.bind(this) })
	        )
	      );
	    }
	  }]);
	
	  return PrivacyPolicy;
	}(_react.Component);
	
	exports.default = PrivacyPolicy;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1561);
	
	var _auth = __webpack_require__(8);
	
	var _overview = __webpack_require__(225);
	
	var _Overview = __webpack_require__(297);
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	var ProductionStatusOverview = function (_Component) {
	  _inherits(ProductionStatusOverview, _Component);
	
	  function ProductionStatusOverview(props) {
	    _classCallCheck(this, ProductionStatusOverview);
	
	    var _this = _possibleConstructorReturn(this, (ProductionStatusOverview.__proto__ || Object.getPrototypeOf(ProductionStatusOverview)).call(this, props));
	
	    _this.pageRef = null;
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ProductionStatusOverview, [{
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	
	      return _react2.default.createElement(_Overview2.default, {
	        itemType: 'order',
	        getItems: this.props.getProductionStatus
	      });
	    }
	  }]);
	
	  return ProductionStatusOverview;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getProductionStatus: _overview.getProductionStatus
	})(ProductionStatusOverview);

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RenderFontURL = function (_Component) {
	  _inherits(RenderFontURL, _Component);
	
	  function RenderFontURL() {
	    _classCallCheck(this, RenderFontURL);
	
	    return _possibleConstructorReturn(this, (RenderFontURL.__proto__ || Object.getPrototypeOf(RenderFontURL)).apply(this, arguments));
	  }
	
	  _createClass(RenderFontURL, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: '<link rel=\'stylesheet\' type=\'text/css\' href=\'' + this.props.url + '\' />' } });
	    }
	  }]);
	
	  return RenderFontURL;
	}(_react.Component);
	
	exports.default = RenderFontURL;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _orders = __webpack_require__(21);
	
	var _agreementConstraint = __webpack_require__(171);
	
	var _customerGroup = __webpack_require__(107);
	
	__webpack_require__(1562);
	
	var _InputState = __webpack_require__(1047);
	
	var _InputState2 = _interopRequireDefault(_InputState);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _filter = __webpack_require__(307);
	
	var _icons = __webpack_require__(6);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Datetime from 'react-datetime'
	
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	
	// import utils
	
	
	// Elements
	
	// import PageHeader from '../../../elements/pageHeader'
	
	
	var SearchFilter = function (_Component) {
	  _inherits(SearchFilter, _Component);
	
	  function SearchFilter(props) {
	    _classCallCheck(this, SearchFilter);
	
	    var _this = _possibleConstructorReturn(this, (SearchFilter.__proto__ || Object.getPrototypeOf(SearchFilter)).call(this, props));
	
	    _this.state = {
	      isOpen: false,
	      filter: {},
	      simplesearch: {
	        save: true,
	        value: ''
	      },
	      customergroups: [],
	      pricemodels: []
	
	      // Bind to this
	    };_this.onChange = _this.onChange.bind(_this);
	    _this.renderProcessStep = _this.renderProcessStep.bind(_this);
	    _this.renderEvaluation = _this.renderEvaluation.bind(_this);
	    _this.renderUpdate = _this.renderUpdate.bind(_this);
	    _this.renderOrderType = _this.renderOrderType.bind(_this);
	    _this.renderDelivery = _this.renderDelivery.bind(_this);
	    _this.renderVehicleData = _this.renderVehicleData.bind(_this);
	    _this.renderColor = _this.renderColor.bind(_this);
	    _this.renderInvoice = _this.renderInvoice.bind(_this);
	    _this.renderSpareParts = _this.renderSpareParts.bind(_this);
	    _this.renderIdentification = _this.renderIdentification.bind(_this);
	
	    _this.advancedSearchForm = _this.advancedSearchForm.bind(_this);
	    _this.simpleSearchForm = _this.simpleSearchForm.bind(_this);
	    _this.handleInputState = _this.handleInputState.bind(_this);
	    _this.openFilterTab = _this.openFilterTab.bind(_this);
	    _this.triggerSearch = _this.triggerSearch.bind(_this);
	    _this.renderCustomerGroup = _this.renderCustomerGroup.bind(_this);
	    _this.resetFilter = _this.resetFilter.bind(_this);
	    _this.resetSimplesearch = _this.resetSimplesearch.bind(_this);
	    _this.getAgreementConstraints = _this.getAgreementConstraints.bind(_this);
	    _this.getCustomerGroups = _this.getCustomerGroups.bind(_this);
	    _this.renderEconomicFilter = _this.renderEconomicFilter.bind(_this);
	    _this.renderDepartmentType = _this.renderDepartmentType.bind(_this);
	    _this.renderAdditionalReport = _this.renderAdditionalReport.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchFilter, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAgreementConstraints();
	      this.getCustomerGroups();
	      // console.log('mount')
	      this.getOrSetFilter();
	    }
	  }, {
	    key: 'getOrSetFilter',
	    value: function getOrSetFilter() {
	      var _this2 = this;
	
	      // let filter = { ...this.props.filter }
	      // console.log('getfilter this.props.source', this.props.source)
	      var _getOrderFilterData = (0, _filter.getOrderFilterData)(this.props),
	          source = _getOrderFilterData.source,
	          filter = _getOrderFilterData.filter,
	          simpleSearch = _getOrderFilterData.simpleSearch;
	      // let source = 'orderlist'
	      // if (hasAccess([4], this.props.auth.user.UserType)) {
	      //   source = 'customer'
	      // } else if (hasAccess([6], this.props.auth.user.UserType)) {
	      //   source = 'wp'
	      // } else if (this.props.source === 'workscreen') {
	      //   source = 'workscreen'
	      // }
	
	      // // get filter from local storage if no filter active/ refresh page
	      // if (isEqual(this.props.filter, this.props.initialFilter)) {
	      //   let storedFilter = JSON.parse(window.localStorage.getItem('filterOrderlist'))
	      //   console.log('getfilter isEqual props.filter and this.props.initialFilter ')
	      //   if (hasAccess([4], this.props.auth.user.UserType)) {
	      //     storedFilter = JSON.parse(window.localStorage.getItem('filterCustomer'))
	      //   } else if (hasAccess([6], this.props.auth.user.UserType)) {
	      //     storedFilter = JSON.parse(window.localStorage.getItem('filterWP'))
	      //   } else if (this.props.source === 'workscreen') {
	      //     storedFilter = JSON.parse(window.localStorage.getItem('filterWorkscreen'))
	      //   }
	      //   if (storedFilter !== undefined && storedFilter !== null && storedFilter.delivery !== undefined) {
	      //     filter = storedFilter
	      //   }
	      // }
	
	      // // Final check to make sure we have a filter
	      // if (filter === undefined || filter === null || isEqual(filter, { NewOrdersFilter: 0 })) {
	      //   filter = this.props.initialFilter
	      // }
	      // // console.log('Workscreen filter', filter)
	
	      // // get simple search from local storage if none active/ page refresh
	      // let simpleSearch = this.props.simplesearch
	      // if (simpleSearch !== undefined && simpleSearch !== null && simpleSearch.value !== undefined && simpleSearch.value.length === 0) {
	      //   let storedSimpleSearch = ''
	      //   if (this.props.source === 'workscreen') {
	      //     storedSimpleSearch = JSON.parse(window.localStorage.getItem('simplesearchWorkscreen'))
	      //   } else {
	      //     storedSimpleSearch = JSON.parse(window.localStorage.getItem('simpleSearch'))
	      //     console.log('getfilter storedSimpleSearch', storedSimpleSearch)
	      //   }
	      //   if (storedSimpleSearch !== '') {
	      //     simpleSearch = storedSimpleSearch
	      //   }
	      // }
	
	      // if simplesearch save is set, reset filter and use search values
	
	
	      if (simpleSearch !== undefined && simpleSearch !== null && simpleSearch.value !== undefined && simpleSearch.value.length > 0) {
	        (0, _orders.resetFilter)(source);
	        setTimeout(function () {
	          var newFilter = JSON.parse(JSON.stringify(_this2.props.initialFilter));
	          if (!(0, _auth.hasAccess)([4], _this2.props.auth.user.UserType)) {
	            newFilter.process.Completed = false;
	            newFilter.process.CompletedThisWeek = true;
	          }
	          _this2.props.setOrdersFilter(newFilter, source);
	          setTimeout(function () {
	            _this2.props.onSubmit({
	              SimpleSearch: simpleSearch.value,
	              SkipCheck: true,
	              movedOrders: true
	            });
	            if (_this2.refs.simplesearch !== undefined && _this2.refs.simplesearch.refs.input !== undefined) {
	              // console.log('this.refs.simplesearch', this.refs.simplesearch.refs.input)
	              // this.refs.simplesearch.refs.input.value = simpleSearch.refs.input.value
	              _this2.refs.simplesearch.refs.input.value = simpleSearch.value;
	            }
	          }, 50);
	        }, 50);
	      } else {
	        if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	          // filter.process.Completed = false
	          // filter.process.CompletedThisWeek = false
	        }
	        if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) && window.localStorage.getItem('get-drafts-as-wp') !== 'true') {
	          filter.process.draft2 = false;
	          filter.process.draft1 = false;
	          filter.process.draft = false;
	        }
	
	        this.setState({
	          filter: filter,
	          simplesearch: simpleSearch
	        });
	      }
	
	      if (this.props.auth.user.UserId !== parseInt(window.localStorage.getItem('auth-user-UserId')) && this.props.router.location.pathname === '/orders') {
	        // console.log('reset filter - other user')
	        window.localStorage.setItem('auth-user-UserId', this.props.auth.user.UserId);
	        (0, _orders.resetFilter)(source);
	        setTimeout(function () {
	          var newFilter = JSON.parse(JSON.stringify(_this2.props.initialFilter));
	          if (!(0, _auth.hasAccess)([4], _this2.props.auth.user.UserType)) {
	            newFilter.process.Completed = false;
	            newFilter.process.CompletedThisWeek = true;
	          }
	          _this2.props.setOrdersFilter(newFilter, source);
	          setTimeout(function () {
	            _this2.props.onSubmit(newFilter);
	          }, 50);
	        }, 50);
	      }
	    }
	  }, {
	    key: 'getAgreementConstraints',
	    value: function getAgreementConstraints() {
	      var _this3 = this;
	
	      if (!(0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return;
	      this.props.getAgreementConstraints(this.props.auth.user.WorkProviderId).then(function (res) {
	        var pricemodels = res.data;
	        _this3.setState({
	          pricemodels: pricemodels
	        });
	      });
	    }
	  }, {
	    key: 'getCustomerGroups',
	    value: function getCustomerGroups() {
	      var _this4 = this;
	
	      if (!(0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return;
	      this.props.getCustomerGroups().then(function (res) {
	        var customergroups = res.data;
	        _this4.setState({
	          customergroups: customergroups
	        });
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // let filter = { ...nextProps.filter }
	      var _getOrderFilterData2 = (0, _filter.getOrderFilterData)(this.props),
	          filter = _getOrderFilterData2.filter,
	          simpleSearch = _getOrderFilterData2.simpleSearch;
	      // if (hasAccess([4], this.props.auth.user.UserType)) {
	      //   // filter.process.Completed = false
	      // }
	
	
	      this.setState({
	        filter: filter,
	        simplesearch: simpleSearch
	      });
	    }
	  }, {
	    key: 'openFilterTab',
	    value: function openFilterTab(e) {
	      // console.log('SearchFilter -> openFilterTab')
	      var parent = e.target.parentNode;
	      while (true) {
	        if (parent.tagName.toLowerCase() !== 'li') {
	          parent = parent.parentNode;
	          continue;
	        }
	        break;
	      }
	      if (parent.className !== 'open') {
	        parent.className = 'open';
	      } else {
	        parent.className = '';
	      }
	    }
	  }, {
	    key: 'handleInputState',
	    value: function handleInputState(option, name) {
	      name = name.split('_');
	      if (name.length > 1) {
	        this.setState({
	          filter: _extends({}, this.state.filter, _defineProperty({}, name[0], _extends({}, this.state.filter[name[0]], _defineProperty({}, name[1], _extends({}, this.state.filter[name[0]][name[1]], {
	            option: option
	          })))))
	        }, function () {
	          // console.log(this.state.filter.process)
	        });
	      } else {
	        this.setState({
	          filter: _extends({}, this.state.filter, _defineProperty({}, name[0], _extends({}, this.state.filter[name[0]], {
	            option: option
	          })))
	        }, function () {
	          // console.log(this.state.filter.process)
	        });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      // console.log(this.state.filter.process, e)
	      var name = '';
	      // console.log('e.target, name, value ', e.target, e.target.name, e.target.value)
	      switch (e.target.name) {
	        case 'simplesearch_save':
	          this.setState({
	            simplesearch: _extends({}, this.state.simplesearch, {
	              save: e.target.checked
	            })
	          });
	          break;
	        case 'order_process':
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              process: {
	                step: e.target.value,
	                draft: this.state.filter.process.draft
	              }
	            })
	          });
	          break;
	        case 'order_process_InProcess':
	        case 'order_process_Completed':
	        case 'order_process_CompletedThisWeek':
	        case 'order_process_draft':
	        case 'order_process_draft1':
	        case 'order_process_draft2':
	          name = e.target.name.split('_')[2];
	          if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) && e.target.name === 'order_process_draft') {
	            var _extends5;
	
	            window.localStorage.setItem('get-drafts-as-wp', e.target.checked ? 'true' : 'false');
	            this.setState({
	              filter: _extends({}, this.state.filter, {
	                process: _extends({}, this.state.filter.process, (_extends5 = {}, _defineProperty(_extends5, name, e.target.checked), _defineProperty(_extends5, 'draft1', e.target.checked), _defineProperty(_extends5, 'draft2', e.target.checked), _extends5))
	              })
	            }, function () {
	              // console.log('state', this.state.filter.process)
	            });
	          } else {
	            this.setState({
	              filter: _extends({}, this.state.filter, {
	                process: _extends({}, this.state.filter.process, _defineProperty({}, name, e.target.checked))
	              })
	            }, function () {
	              // console.log('state', this.state.filter.process)
	            });
	          }
	          break;
	        case 'order_evaluation[]':
	          var evaluation = Object.assign({}, this.state.filter.evaluation);
	          if (e.target.checked) {
	            evaluation[e.target.value] = true;
	          } else {
	            evaluation[e.target.value] = false;
	          }
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              evaluation: evaluation
	            })
	          });
	          break;
	        case 'order_update[]':
	          var update = Object.assign({}, this.state.filter.update);
	          if (e.target.checked) {
	            update[e.target.value] = true;
	          } else {
	            update[e.target.value] = false;
	          }
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              update: update
	            })
	          });
	          break;
	        case 'order_invoice[]':
	          var invoice = Object.assign({}, this.state.filter.invoice);
	          if (e.target.checked) {
	            invoice[e.target.value] = true;
	          } else {
	            invoice[e.target.value] = false;
	          }
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              invoice: invoice
	            })
	          });
	          break;
	
	        case 'parts':
	          var parts = Object.assign({}, this.state.filter.parts);
	          if (e.target.checked) {
	            parts[e.target.value] = true;
	          } else {
	            parts[e.target.value] = false;
	          }
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              parts: parts
	            })
	          });
	          break;
	        case 'ordertype':
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              orderType: e.target.value
	            })
	          });
	          break;
	        case 'delivery_transport':
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              delivery: _extends({}, this.state.filter.delivery, {
	                transport: e.target.value
	              })
	            })
	          });
	          break;
	        case 'pricemodel_pricemodelid':
	          var value = e.target.value;
	          if (e.target.value === '-1') {
	            this.setState({
	              filter: _extends({}, this.state.filter, {
	                pricemodel: undefined
	              }),
	              selectedpricemodel: -1
	            });
	          } else {
	            var constraint = this.state.pricemodels.find(function (val) {
	              return Number(val.AgreementConstraintId) === Number(value);
	            });
	            var id = constraint.Name;
	            this.setState({
	              filter: _extends({}, this.state.filter, {
	                pricemodel: _extends({}, this.state.filter.pricemodel, {
	                  PriceModelName: id,
	                  PriceModelId: value
	                })
	              }),
	              selectedpricemodel: value
	            }, function () {
	              // console.log(this.state, value)
	            });
	          }
	          break;
	        case 'customergroup_customergroupid':
	          var valu = e.target.value;
	          if (valu === '-1') {
	            this.setState({
	              filter: _extends({}, this.state.filter, {
	                customergroup: undefined
	              }),
	              selectedcustomergroup: -1
	            });
	          } else {
	            var _id = this.state.customergroups.find(function (val) {
	              return Number(val.CustomerGroupId) === Number(valu);
	            }).Name;
	            this.setState({
	              filter: _extends({}, this.state.filter, {
	                customergroup: _extends({}, this.state.filter.customergroup, {
	                  CustomerGroupName: _id,
	                  CustomerGroupId: valu
	                })
	              }),
	              selectedcustomergroup: valu
	            }, function () {
	              // console.log(valu, id, this.state)
	            });
	          }
	
	          break;
	        case 'delivery_delivery_start':
	        case 'delivery_delivery_end':
	        case 'delivery_pickup_start':
	        case 'delivery_pickup_end':
	        case 'delivery_production_start':
	        case 'delivery_production_end':
	          name = e.target.name.split('_');
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              delivery: _extends({}, this.state.filter.delivery, _defineProperty({}, name[1], _extends({}, this.state.filter.delivery[name[1]], _defineProperty({}, name[2], e.target.value))))
	            })
	          });
	          break;
	        case 'vehicle_regnumber':
	        case 'vehicle_brand':
	        case 'vehicle_model':
	        case 'vehicle_year':
	        case 'color_color':
	        case 'color_code':
	        case 'color_ctype':
	        case 'identification_ordernumber':
	        case 'identification_rekvnumber':
	          name = e.target.name.split('_');
	          this.setState({
	            filter: _extends({}, this.state.filter, _defineProperty({}, name[0], _extends({}, this.state.filter[name[0]], _defineProperty({}, name[1], _extends({}, this.state.filter[name[0]][name[1]], {
	              value: e.target.value
	            })))))
	          });
	          break;
	        case 'order_economicfilter[]':
	          var economicfilter = Object.assign({}, this.state.filter.economicfilter);
	          if (e.target.checked) {
	            economicfilter[e.target.value] = true;
	          } else {
	            economicfilter[e.target.value] = false;
	          }
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              economicfilter: economicfilter
	            })
	          });
	          break;
	        case 'order_additionalreport[]':
	          var additionalreport = Object.assign({}, this.state.filter.additionalreport);
	          if (e.target.checked) {
	            additionalreport[e.target.value] = true;
	          } else {
	            additionalreport[e.target.value] = false;
	          }
	          this.setState({
	            filter: _extends({}, this.state.filter, {
	              additionalreport: additionalreport
	            })
	          });
	          break;
	      }
	    }
	  }, {
	    key: 'itemLayout',
	    value: function itemLayout(title, content, active) {
	      var activeClass = '';
	      if (active) {
	        activeClass = 'active';
	      }
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'title ' + activeClass, onClick: this.openFilterTab },
	          title,
	          ' ',
	          _react2.default.createElement('i', { className: 'fa fa-plus' })
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          content
	        )
	      );
	    }
	  }, {
	    key: 'checkActiveState',
	    value: function checkActiveState(name) {
	      var initialFilter = _extends({}, this.props.initialFilter);
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        initialFilter.process.Completed = false;
	        initialFilter.process.CompletedThisWeek = false;
	      } else {
	        initialFilter.process.Completed = false;
	        // initialFilter.process.CompletedThisWeek = true // This should be handled by reducer
	      }
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        initialFilter.process.draft1 = false;
	        initialFilter.process.draft2 = false;
	        initialFilter.process.draft = false;
	      }
	      var checker = this.state.filter[name];
	      if ((typeof checker === 'undefined' ? 'undefined' : _typeof(checker)) === 'object') {
	        var checkState = JSON.parse(JSON.stringify(initialFilter[name]));
	        if (this.props.auth.user.CustomerId !== '-1') {
	          if (typeof checkState['external_control'] !== 'undefined' || typeof checker['external_control'] !== 'undefined') {
	            delete checkState['external_control'];
	            delete checker['external_control'];
	          }
	          if (typeof checkState['invoicing'] !== 'undefined' || typeof checker['invoicing'] !== 'undefined') {
	            delete checkState['invoicing'];
	            delete checker['invoicing'];
	          }
	          if (typeof checkState['customer'] !== 'undefined' || typeof checker['customer'] !== 'undefined') {
	            delete checkState['customer'];
	            delete checker['customer'];
	          }
	          if (name === 'update') {
	            delete checkState['missing'];
	            delete checker['missing'];
	          }
	          if (name === 'delivery') {
	            delete checkState['production'];
	            delete checker['production'];
	          }
	          if (name === 'color') {
	            delete checkState['amount'];
	            delete checker['amount'];
	          }
	        }
	        return !(0, _lodash.isEqual)(checkState, checker);
	      } else {
	        var _checkState = initialFilter[name];
	        if (name === 'customergroup_customergroupid') {
	          return this.state.filter.customergroup !== undefined && this.state.filter.customergroup.CustomerGroupId !== -1;
	        }
	        if (name === 'pricemodel_pricemodelid') {
	          return this.state.filter.pricemodel !== undefined && this.state.filter.pricemodel.PriceModelId !== -1;
	        }
	        if (name === 'orderType') {
	          return Number(this.state.filter.orderType) !== 0;
	        }
	        return !checker === _checkState;
	      }
	    }
	  }, {
	    key: 'renderCustomerGroup',
	    value: function renderCustomerGroup() {
	      var customergroups = this.state.customergroups;
	      var selectedcustomergroup = -1;
	      if (this.state.filter.customergroup !== undefined) {
	        selectedcustomergroup = this.state.filter.customergroup.CustomerGroupId;
	      }
	      var stepContent = _react2.default.createElement(
	        _dropDown2.default,
	        { value: selectedcustomergroup, name: 'customergroup_customergroupid', onChange: this.onChange },
	        _react2.default.createElement(
	          'option',
	          { value: '-1', key: '-1' },
	          (0, _helpers.translation)('12310')
	        ),
	        customergroups !== null && customergroups.length > 0 && customergroups.map(function (val, i) {
	          return _react2.default.createElement(
	            'option',
	            { value: val.CustomerGroupId, key: val.CustomerGroupId },
	            val.Name
	          );
	        })
	      );
	      // console.log(this.state, this.props)
	      return this.itemLayout((0, _helpers.translation)('12282'), stepContent, this.checkActiveState('customergroup_customergroupid'));
	    }
	  }, {
	    key: 'renderPriceModel',
	    value: function renderPriceModel() {
	      // let priceModels = this.state.pricemodels.map((val) => { return val.Name }).filter((value, index, self) => self.indexOf(value) === index)
	      var pricemodelsList = this.state.pricemodels;
	      var grouping = [];
	
	      var _loop = function _loop(i) {
	        var group = grouping.find(function (val, idx) {
	          return val.customerGroupName === pricemodelsList[i].CustomerGroupName;
	        });
	        if (group === undefined) {
	          group = {
	            customerGroupName: pricemodelsList[i].CustomerGroupName,
	            pricemodelsList: []
	          };
	          grouping.push(group);
	        }
	        group.pricemodelsList.push(pricemodelsList[i]);
	        group.pricemodelsList.sort(function (a, b) {
	          return a.Name.localeCompare(b.Name);
	        });
	      };
	
	      for (var i = 0; i < pricemodelsList.length; i++) {
	        _loop(i);
	      }
	      grouping.sort(function (a, b) {
	        return a.customerGroupName.localeCompare(b.customerGroupName);
	      });
	      var renderGroup = function renderGroup(group, key) {
	        var renderItem = function renderItem(val, key) {
	          if (val.PriceType === 8) return null;
	          return _react2.default.createElement(
	            'option',
	            { value: val.AgreementConstraintId, key: val.AgreementConstraintId },
	            val.Name
	          );
	        };
	        var customerGroupName = group.customerGroupName;
	        return _react2.default.createElement(
	          'optgroup',
	          { label: customerGroupName, key: customerGroupName },
	          group.pricemodelsList.map(renderItem)
	        );
	      };
	      var selectedPriceModel = -1;
	      if (this.state.filter.pricemodel !== undefined) {
	        selectedPriceModel = this.state.filter.pricemodel.PriceModelId;
	      }
	      var stepContent = _react2.default.createElement(
	        _dropDown2.default,
	        { name: 'pricemodel_pricemodelid', onChange: this.onChange, value: selectedPriceModel, isGrouping: true },
	        _react2.default.createElement(
	          'option',
	          { value: '-1', key: '-1' },
	          (0, _helpers.translation)('12311')
	        ),
	        grouping.map(renderGroup)
	      );
	      return this.itemLayout((0, _helpers.translation)('12270'), stepContent, this.checkActiveState('pricemodel_pricemodelid'));
	    }
	  }, {
	    key: 'renderProcessStep',
	    value: function renderProcessStep() {
	      if (this.props.disableProcessStep) return null;
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('13366'), id: 'order_process-draft', name: 'order_process_draft', onChange: this.onChange, checked: this.state.filter.process.draft }),
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('208'), id: 'order_process-inprocess', name: 'order_process_InProcess', onChange: this.onChange, checked: this.state.filter.process.InProcess }),
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('2702'), id: 'order_process-completed-this-week', name: 'order_process_CompletedThisWeek', onChange: this.onChange, checked: this.state.filter.process.CompletedThisWeek }),
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('2703'), id: 'order_process-completed', name: 'order_process_Completed', onChange: this.onChange, checked: this.state.filter.process.Completed })
	      );
	      if (!(0, _auth.hasAccess)([4, 6], this.props.auth.user.UserType)) {
	        stepContent = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('13496'), id: 'order_process-draft1', name: 'order_process_draft1', onChange: this.onChange, checked: this.state.filter.process.draft1 }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('13497'), id: 'order_process-draft2', name: 'order_process_draft2', onChange: this.onChange, checked: this.state.filter.process.draft2 }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('208'), id: 'order_process-inprocess', name: 'order_process_InProcess', onChange: this.onChange, checked: this.state.filter.process.InProcess }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('2702'), id: 'order_process-completed-this-week', name: 'order_process_CompletedThisWeek', onChange: this.onChange, checked: this.state.filter.process.CompletedThisWeek }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('2703'), id: 'order_process-completed', name: 'order_process_Completed', onChange: this.onChange, checked: this.state.filter.process.Completed })
	        );
	      }
	      return this.itemLayout((0, _helpers.translation)('946'), stepContent, this.checkActiveState('process'));
	    }
	  }, {
	    key: 'renderEvaluation',
	    value: function renderEvaluation() {
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('13367'), value: 'missing', id: 'order_evaluation-1', name: 'order_evaluation[]', onChange: this.onChange, checked: this.state.filter.evaluation.missing }),
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('13368'), value: 'evaluated', id: 'order_evaluation-2', name: 'order_evaluation[]', onChange: this.onChange, checked: this.state.filter.evaluation.evaluated })
	      );
	      return this.itemLayout((0, _helpers.translation)('13363'), stepContent, this.checkActiveState('evaluation'));
	    }
	  }, {
	    key: 'renderUpdate',
	    value: function renderUpdate() {
	      var missingUpdate = '';
	      if (this.props.auth.user.CustomerId === '-1') {
	        missingUpdate = _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('13369'), value: 'missing', id: 'order_update-1', name: 'order_update[]', onChange: this.onChange, checked: this.state.filter.update.missing });
	      }
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        missingUpdate,
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('950'), value: 'updated', id: 'order_update-2', name: 'order_update[]', onChange: this.onChange, checked: this.state.filter.update.updated })
	      );
	      return this.itemLayout((0, _helpers.translation)('998'), stepContent, this.checkActiveState('update'));
	    }
	  }, {
	    key: 'renderInvoice',
	    value: function renderInvoice() {
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) return null;
	      var invoiceName = (0, _auth.hasAccess)([6], this.props.auth.user.UserType) ? '13002' : '529';
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('1140'), value: 'notApprovedForInvoicing', id: 'order_invoice-3', name: 'order_invoice[]', onChange: this.onChange, checked: this.state.filter.invoice.notApprovedForInvoicing }),
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('1139'), value: 'approvedForInvoicing', id: 'order_invoice-1', name: 'order_invoice[]', onChange: this.onChange, checked: this.state.filter.invoice.approvedForInvoicing }),
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)(invoiceName), value: 'isInvoiced', id: 'order_invoice-2', name: 'order_invoice[]', onChange: this.onChange, checked: this.state.filter.invoice.isInvoiced }),
	        (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('13003'), value: 'isInvoicedByWP', id: 'order_invoice-4', name: 'order_invoice[]', onChange: this.onChange, checked: this.state.filter.invoice.isInvoicedByWP })
	      );
	      return this.itemLayout((0, _helpers.translation)('13486'), stepContent, this.checkActiveState('invoice'));
	    }
	  }, {
	    key: 'renderAdditionalReport',
	    value: function renderAdditionalReport() {
	      var isCustomer = this.props.auth.user.DepartmentType === 1 || (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var headingText = '937';
	      var awaitingText = '14915';
	      var additionalreportText = '14916';
	      if (isCustomer) {
	        headingText = '14921';
	        awaitingText = '14922';
	        additionalreportText = '14923';
	      }
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)(awaitingText), value: 'awaiting', id: 'order_additionalreport-1', name: 'order_additionalreport[]', onChange: this.onChange, checked: this.state.filter.additionalreport.awaiting }),
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)(additionalreportText), value: 'received', id: 'order_additionalreport-2', name: 'order_additionalreport[]', onChange: this.onChange, checked: this.state.filter.additionalreport.received })
	      );
	      return this.itemLayout((0, _helpers.translation)(headingText), stepContent, this.checkActiveState('additionalreport'));
	    }
	  }, {
	    key: 'renderEconomicFilter',
	    value: function renderEconomicFilter() {
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) return null;
	      var economicfilter = this.state.filter.economicfilter;
	
	      var filterNotMatched = economicfilter.economicFilterNotMatched !== undefined ? economicfilter.economicFilterNotMatched : false;
	      var filterMatched = economicfilter.economicFilterMatched !== undefined ? economicfilter.economicFilterMatched : false;
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('14809'), value: 'economicFilterNotMatched', id: 'order_economicfilter-1', name: 'order_economicfilter[]', onChange: this.onChange, checked: filterNotMatched }),
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('14808'), value: 'economicFilterMatched', id: 'order_economicfilter-2', name: 'order_economicfilter[]', onChange: this.onChange, checked: filterMatched })
	      );
	      return this.itemLayout((0, _helpers.translation)('14807'), stepContent, this.checkActiveState('economicfilter'));
	    }
	  }, {
	    key: 'renderSpareParts',
	    value: function renderSpareParts() {
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('161') },
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('14796'), value: 'paintNotOrdered', id: 'parts-1', name: 'parts', onChange: this.onChange, checked: this.state.filter.parts.paintNotOrdered }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('16535'), value: 'paintOrdered', id: 'parts-2', name: 'parts', onChange: this.onChange, checked: this.state.filter.parts.paintOrdered }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('16452'), value: 'paintArrived', id: 'parts-4', name: 'parts', onChange: this.onChange, checked: this.state.filter.parts.paintArrived })
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('14779') },
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('14796'), value: 'bodyNotOrdered', id: 'parts-5', name: 'parts', onChange: this.onChange, checked: this.state.filter.parts.bodyNotOrdered }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('16535'), value: 'bodyOrdered', id: 'parts-6', name: 'parts', onChange: this.onChange, checked: this.state.filter.parts.bodyOrdered }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('16452'), value: 'bodyArrived', id: 'parts-8', name: 'parts', onChange: this.onChange, checked: this.state.filter.parts.bodyArrived })
	        )
	      );
	      return this.itemLayout((0, _helpers.translation)('637'), stepContent, this.checkActiveState('parts'));
	    }
	  }, {
	    key: 'renderOrderType',
	    value: function renderOrderType() {
	      var _this5 = this;
	
	      var stepContent = _react2.default.createElement(
	        _dropDown2.default,
	        { value: this.state.filter.orderType, onChange: this.onChange, name: 'ordertype' },
	        _react2.default.createElement(
	          'option',
	          { value: '0' },
	          (0, _helpers.translation)('13401')
	        ),
	        Object.keys(this.props.orderTypes).map(function (val, index) {
	          return _react2.default.createElement(
	            'option',
	            { key: index, value: val },
	            (0, _helpers.translation)(_this5.props.orderTypes[val])
	          );
	        })
	      );
	      return this.itemLayout((0, _helpers.translation)('525'), stepContent, this.checkActiveState('orderType'));
	    }
	  }, {
	    key: 'renderDatepicker',
	    value: function renderDatepicker(name, stateName1, stateName2) {
	      var _this6 = this;
	
	      var alignDatePickerRight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      if (typeof this.state.filter.delivery[stateName1] === 'undefined') return null;
	
	      var date = '';
	      var val = this.state.filter.delivery[stateName1][stateName2];
	
	      var translationArr = {
	        start: '188',
	        end: '187'
	      };
	
	      var showTime = false;
	      var closeOnSelect = true;
	      var inputProps = {
	        name: name,
	        placeholder: (0, _helpers.translation)(translationArr[stateName2]),
	        readOnly: true
	      };
	      if (val !== null && val !== '') {
	        date = window.CustomDate(val);
	      }
	      // Input change
	      var onInputChange = function onInputChange(datetime) {
	        _this6.setState({
	          filter: _extends({}, _this6.state.filter, {
	            delivery: _extends({}, _this6.state.filter.delivery, _defineProperty({}, stateName1, _extends({}, _this6.state.filter.delivery[stateName1], _defineProperty({}, stateName2, datetime))))
	          })
	        });
	      };
	      var alignCalendar = function alignCalendar() {
	        var element = document.querySelector('.rdtOpen').querySelector('.rdtPicker');
	        var bounding = element.getBoundingClientRect();
	
	        // out of screen to right
	        var windowWidth = parseInt(window.innerWidth);
	        var outOfScreen = windowWidth - (bounding.left + bounding.width);
	        outOfScreen -= 5;
	
	        // scroll bar width
	        var appWidth = document.querySelector('#app').getBoundingClientRect().width;
	        var layoutWidth = document.querySelector('.layout__content').getBoundingClientRect().width;
	        var scrollBarWidth = appWidth - layoutWidth;
	
	        if (outOfScreen < 0) {
	          outOfScreen *= -1;
	          outOfScreen += scrollBarWidth;
	          element.style.marginLeft = element.style.marginLeft - outOfScreen;
	        }
	      };
	      // Render
	      return _react2.default.createElement(_datetime2.default, {
	        inputProps: inputProps,
	        dateFormat: 'DD-MM-YYYY',
	        timeFormat: showTime,
	        closeOnSelect: closeOnSelect,
	        value: date,
	        onFocus: alignCalendar,
	        onChange: onInputChange,
	        alignDatePickerRight: alignDatePickerRight });
	    }
	  }, {
	    key: 'renderDelivery',
	    value: function renderDelivery() {
	      var showProduction = '';
	      if (this.props.auth.user.CustomerId === '-1' && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 13)) {
	        showProduction = _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('13402') },
	          _react2.default.createElement(
	            _inline2.default,
	            null,
	            this.renderDatepicker('delivery_production_start', 'production', 'start', true),
	            this.renderDatepicker('delivery_production_end', 'production', 'end', true)
	          )
	        );
	      }
	      var stepContent = _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('193') },
	          _react2.default.createElement(
	            _inline2.default,
	            null,
	            this.renderDatepicker('delivery_delivery_start', 'delivery', 'start', true),
	            this.renderDatepicker('delivery_delivery_end', 'delivery', 'end', true)
	          )
	        ),
	        showProduction,
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('157') },
	          _react2.default.createElement(
	            _inline2.default,
	            null,
	            this.renderDatepicker('delivery_pickup_start', 'pickup', 'start', true),
	            this.renderDatepicker('delivery_pickup_end', 'pickup', 'end', true)
	          )
	        ),
	        _react2.default.createElement(
	          _dropDown2.default,
	          { labelText: (0, _helpers.translation)('13371'), value: this.state.filter.delivery.transport, onChange: this.onChange, name: 'delivery_transport' },
	          _react2.default.createElement(
	            'option',
	            { value: '0' },
	            (0, _helpers.translation)('13401')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: '1' },
	            (0, _helpers.translation)('154')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: '2' },
	            (0, _helpers.translation)('351')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: '3' },
	            (0, _helpers.translation)('26')
	          )
	        )
	      );
	      return this.itemLayout((0, _helpers.translation)('193'), stepContent, this.checkActiveState('delivery'));
	    }
	  }, {
	    key: 'renderIdentification',
	    value: function renderIdentification() {
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_InputState2.default, { placeholder: (0, _helpers.translation)('294'), triggerChange: this.onChange, triggerHandler: this.handleInputState, triggerName: 'identification_ordernumber', option: this.state.filter.identification.ordernumber.option, value: this.state.filter.identification.ordernumber.value }),
	        _react2.default.createElement(_InputState2.default, { placeholder: (0, _helpers.translation)('80'), triggerChange: this.onChange, triggerHandler: this.handleInputState, triggerName: 'identification_rekvnumber', option: this.state.filter.identification.rekvnumber.option, value: this.state.filter.identification.rekvnumber.value })
	      );
	      return this.itemLayout((0, _helpers.translation)('13370'), stepContent, this.checkActiveState('identification'));
	    }
	  }, {
	    key: 'renderVehicleData',
	    value: function renderVehicleData() {
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_InputState2.default, { placeholder: (0, _helpers.translation)('78'), triggerChange: this.onChange, triggerHandler: this.handleInputState, triggerName: 'vehicle_regnumber', option: this.state.filter.vehicle.regnumber.option, value: this.state.filter.vehicle.regnumber.value }),
	        _react2.default.createElement(_InputState2.default, { placeholder: (0, _helpers.translation)('145'), triggerChange: this.onChange, triggerHandler: this.handleInputState, triggerName: 'vehicle_brand', option: this.state.filter.vehicle.brand.option, value: this.state.filter.vehicle.brand.value }),
	        _react2.default.createElement(_InputState2.default, { placeholder: (0, _helpers.translation)('146'), triggerChange: this.onChange, triggerHandler: this.handleInputState, triggerName: 'vehicle_model', option: this.state.filter.vehicle.model.option, value: this.state.filter.vehicle.model.value }),
	        _react2.default.createElement(_InputState2.default, { placeholder: (0, _helpers.translation)('148'), triggerChange: this.onChange, triggerHandler: this.handleInputState, triggerName: 'vehicle_year', option: this.state.filter.vehicle.year.option, value: this.state.filter.vehicle.year.value })
	      );
	      return this.itemLayout((0, _helpers.translation)('77'), stepContent, this.checkActiveState('vehicle'));
	    }
	  }, {
	    key: 'renderColor',
	    value: function renderColor() {
	      var stepContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_InputState2.default, { placeholder: (0, _helpers.translation)('179'), triggerChange: this.onChange, triggerHandler: this.handleInputState, triggerName: 'color_color', option: this.state.filter.color.color.option, value: this.state.filter.color.color.value }),
	        _react2.default.createElement(_InputState2.default, { placeholder: (0, _helpers.translation)('13372'), triggerChange: this.onChange, triggerHandler: this.handleInputState, triggerName: 'color_code', option: this.state.filter.color.code.option, value: this.state.filter.color.code.value }),
	        _react2.default.createElement(_InputState2.default, { placeholder: (0, _helpers.translation)('332'), triggerChange: this.onChange, triggerHandler: this.handleInputState, triggerName: 'color_ctype', option: this.state.filter.color.ctype.option, value: this.state.filter.color.ctype.value })
	      );
	      return this.itemLayout((0, _helpers.translation)('179'), stepContent, this.checkActiveState('color'));
	    }
	  }, {
	    key: 'advancedSearchForm',
	    value: function advancedSearchForm(e) {
	      var _this7 = this;
	
	      e.preventDefault();
	
	      var filter = this.state.filter;
	      // console.log('advancedSearchForm', filter)
	      // IF user is a customer, remove some data
	
	      if (this.props.auth.user.CustomerId !== '-1') {
	        delete filter['external_control'];
	        delete filter['invoicing'];
	        delete filter['customer'];
	        delete filter['update']['missing'];
	        delete filter['delivery']['production'];
	        delete filter['color']['amount'];
	      }
	      if (this.props.disableProcessStep) {
	        filter.process.draft = false;
	        filter.process.InProcess = true;
	        filter.process.Completed = false;
	        filter.process.CompletedThisWeek = false;
	      }
	
	      var source = 'orderlist';
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        source = 'customer';
	      } else if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        source = 'wp';
	      } else if (this.props.source === 'workscreen') {
	        source = 'workscreen';
	      }
	
	      // console.log('setOrdersFilter', filter)
	      this.props.resetSimplesearch(source);
	      this.props.setOrdersFilter(filter, source);
	      setTimeout(function () {
	        _this7.props.onSubmit(filter);
	        _this7.refs.simplesearch.refs.input.value = '';
	      }, 50);
	    }
	  }, {
	    key: 'simpleSearchForm',
	    value: function simpleSearchForm(e) {
	      // console.log('simpleSearchForm', this.state.simplesearch)
	      e.preventDefault();
	      var value = this.refs.simplesearch.refs.input.value;
	      this.props.onSimple(value);
	
	      var source = 'orderlist';
	      if (this.props.source === 'workscreen') {
	        source = 'workscreen';
	      }
	
	      this.props.setSimplesearch({
	        save: this.state.simplesearch.save,
	        value: value
	      }, source);
	
	      if (!this.state.simplesearch.save) {
	        this.refs.simplesearch.refs.input.value = '';
	      }
	
	      this.props.resetFilter(source);
	      // console.log('this.state.simplesearch.save', this.state.simplesearch.save)
	    }
	  }, {
	    key: 'triggerSearch',
	    value: function triggerSearch() {
	      this.setState({
	        isOpen: !this.state.isOpen
	      });
	    }
	  }, {
	    key: 'resetFilter',
	    value: function resetFilter(e) {
	      var _this8 = this;
	
	      e.preventDefault();
	      var source = 'orderlist';
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        source = 'customer';
	      } else if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        source = 'wp';
	      } else if (this.props.source === 'workscreen') {
	        source = 'workscreen';
	      }
	      this.props.resetFilter(source);
	      setTimeout(function () {
	        var newFilter = JSON.parse(JSON.stringify(_this8.props.initialFilter));
	        if ((0, _auth.hasAccess)([6], _this8.props.auth.user.UserType)) {
	          newFilter.process.draft2 = false;
	          newFilter.process.draft1 = false;
	          newFilter.process.draft = false;
	          newFilter.process.Completed = false;
	          newFilter.process.CompletedThisWeek = true;
	          newFilter.customergroup = {};
	          newFilter.pricemodel = {};
	          window.localStorage.setItem('get-drafts-as-wp', 'false');
	        }
	        _this8.props.onSubmit(newFilter);
	      }, 50);
	      var filter = _extends({}, this.state.filter);
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        filter.process.draft2 = false;
	        filter.process.draft1 = false;
	        filter.process.draft = false;
	        filter.process.Completed = false;
	        filter.process.CompletedThisWeek = true;
	        filter.customergroup = {};
	        filter.pricemodel = {};
	        window.localStorage.setItem('get-drafts-as-wp', 'false');
	        this.setState({
	          filter: filter,
	          selectedpricemodel: -1,
	          selectedcustomergroup: -1
	        }, function () {
	          // console.log('reset filter', filter, this.state.filter)
	        });
	      }
	      if (!(0, _auth.hasAccess)([4, 6], this.props.auth.user.UserType)) {
	        this.setState({
	          filter: {
	            filter: filter,
	            process: _extends({}, filter.process, {
	              Completed: false,
	              CompletedThisWeek: true
	            })
	          }
	        });
	      }
	    }
	  }, {
	    key: 'resetSimplesearch',
	    value: function resetSimplesearch(e) {
	      var _this9 = this;
	
	      if (e !== undefined) e.preventDefault();
	      this.props.resetSimplesearch(this.props.source);
	      this.refs.simplesearch.refs.input.value = '';
	      setTimeout(function () {
	        var newFilter = JSON.parse(JSON.stringify(_this9.props.initialFilter));
	        _this9.props.onSubmit(newFilter);
	      }, 50);
	    }
	  }, {
	    key: 'renderDepartmentType',
	    value: function renderDepartmentType() {
	      var _this10 = this;
	
	      // let paintImage = 'blue'
	      // let bodyImage = 'blue'
	      var paintActive = '';
	      var bodyActive = '';
	
	      if (this.state.filter.HasPaintWork) {
	        // paintImage = 'white1'
	        paintActive = 'active';
	      }
	      if (this.state.filter.HasBodyWork) {
	        // bodyImage = 'white'
	        bodyActive = 'active';
	      }
	
	      var clicked = function clicked(val) {
	        _this10.setState({
	          filter: _extends({}, _this10.state.filter, _defineProperty({}, val, !_this10.state.filter[val]))
	        });
	      };
	      return _react2.default.createElement(
	        _inline2.default,
	        { block: true, fillChildNum: [0, 1], alignChildren: 'center' },
	        _react2.default.createElement(
	          'div',
	          { className: paintActive + ' paint' },
	          _react2.default.createElement(_check2.default, { onClick: clicked.bind(this, 'HasPaintWork'), checked: this.state.filter.HasPaintWork, labelText: _react2.default.createElement(_icon2.default, { icon: _icons.OrderDepartmentIcons.Paint }) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: bodyActive + ' body' },
	          _react2.default.createElement(_check2.default, { onClick: clicked.bind(this, 'HasBodyWork'), checked: this.state.filter.HasBodyWork, labelText: _react2.default.createElement(_icon2.default, { icon: _icons.OrderDepartmentIcons.Body }) })
	        )
	      );
	    }
	  }, {
	    key: 'renderFilterOrdersAssignedToMe',
	    value: function renderFilterOrdersAssignedToMe() {
	      var _this11 = this;
	
	      if (!(0, _auth.hasAccess)([3], this.props.auth.user.UserType)) return null; // Show only for employees.
	
	      var onSwitch = function onSwitch() {
	        _this11.setState({
	          filter: _extends({}, _this11.state.filter, {
	            AssignedToMe: !_this11.state.filter.AssignedToMe
	          })
	        });
	      };
	
	      // console.log('SearchFilter -> renderFilterOrdersAssignedToMe: this.state.filter', this.state.filter.AssignedToMe, 'this.props', this.props)
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'my-assigned-orders' },
	        _react2.default.createElement(_switch2.default, { name: 'AssignedToMe', labelText: 18259, checked: this.state.filter.AssignedToMe, onChange: onSwitch })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log('SearchFilter -> render()', this.state.filter)
	      if (this.state.filter === undefined || this.state.filter === null || typeof this.state.filter.delivery === 'undefined') {
	        return _react2.default.createElement('div', null);
	      }
	
	      var openClassname = '';
	      var filterBackdrop = '';
	      if (this.state.isOpen) {
	        openClassname += 'open';
	        filterBackdrop = _react2.default.createElement('div', { className: 'backdrop__search', onClick: this.triggerSearch });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        filterBackdrop,
	        _react2.default.createElement('i', { className: 'responsiveSearchTrigger fa fa-search', onClick: this.triggerSearch }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'filter__search ' + openClassname },
	          _react2.default.createElement(
	            'form',
	            { className: 'search--input' },
	            _react2.default.createElement(_text2.default, { ref: 'simplesearch', name: 'simplesearch' }),
	            _react2.default.createElement(_button2.default, { labelText: (0, _helpers.translation)('906'), onClick: this.simpleSearchForm, style: 'link' }),
	            _react2.default.createElement(
	              'a',
	              { onClick: this.resetSimplesearch.bind(this) },
	              (0, _helpers.translation)('13001')
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.advancedSearchForm },
	            _react2.default.createElement(
	              'div',
	              { className: 'head' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                (0, _helpers.translation)('13389')
	              )
	            ),
	            this.renderFilterOrdersAssignedToMe(),
	            !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.props.auth.departmentType !== 0 && this.renderDepartmentType(),
	            this.renderProcessStep(),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 25) && this.renderEvaluation(),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 4) && this.renderUpdate(),
	            (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.renderEconomicFilter(),
	            this.renderAdditionalReport(),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 6) && this.renderInvoice(),
	            this.props.auth.departmentType !== 0 && this.renderSpareParts(),
	            (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.renderPriceModel(),
	            (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.renderCustomerGroup(),
	            this.renderOrderType(),
	            this.renderIdentification(),
	            this.renderDelivery(),
	            this.renderVehicleData(),
	            this.renderColor(),
	            _react2.default.createElement(
	              'div',
	              { className: 'filter__search__bottom' },
	              _react2.default.createElement(_button2.default, { labelText: (0, _helpers.translation)('1228'), style: 'link' }),
	              _react2.default.createElement(
	                'a',
	                { onClick: this.resetFilter },
	                (0, _helpers.translation)('13498')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SearchFilter;
	}(_react.Component);
	
	SearchFilter.propTypes = {
	  setOrdersFilter: _propTypes2.default.func.isRequired,
	  resetFilter: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  var initialFilter = state.orders.initialFilterOrderlist;
	  var filter = state.orders.filterOrderlist;
	  var simplesearch = state.orders.simplesearch;
	  // console.log('Selected default initial filter', filter.AssignedToMe)
	  if ((0, _auth.hasAccess)([4], state.auth.user.UserType)) {
	    initialFilter = state.orders.initialFilterCustomer;
	    filter = state.orders.filterCustomer;
	    // console.log('Selected customer initial filter', filter.AssignedToMe)
	  } else if ((0, _auth.hasAccess)([6], state.auth.user.UserType)) {
	    initialFilter = state.orders.initialFilterWP;
	    filter = state.orders.filterWP;
	    // console.log('Selected wp initial filter', filter.AssignedToMe)
	  } else if (state.routing.locationBeforeTransitions.pathname === '/workscreen') {
	    initialFilter = state.orders.initialFilterWorkscreen;
	    filter = state.orders.filterWorkscreen;
	    simplesearch = state.orders.simplesearchWorkscreen;
	    // console.log('Selected workscreen initial filter', filter.AssignedToMe)
	  }
	  return {
	    filter: filter,
	    initialFilter: initialFilter,
	    auth: state.auth,
	    orderTypes: state.common.enums.orderTypes,
	    simplesearch: simplesearch
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  setOrdersFilter: _orders.setOrdersFilter,
	  resetFilter: _orders.resetFilter,
	  getAgreementConstraints: _agreementConstraint.getAgreementConstraints,
	  getCustomerGroups: _customerGroup.getCustomerGroups,
	  resetSimplesearch: _orders.resetSimplesearch,
	  setSimplesearch: _orders.setSimplesearch,
	  setOrdersSearch: _orders.setOrdersSearch
	}, null, { withRef: true })(SearchFilter);

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _employees = __webpack_require__(128);
	
	var _backdrop = __webpack_require__(29);
	
	__webpack_require__(1571);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _lodash = __webpack_require__(27);
	
	var _WorkhourModal = __webpack_require__(1116);
	
	var _WorkhourModal2 = _interopRequireDefault(_WorkhourModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// elements
	
	
	// Utils
	
	
	// Modals
	
	
	var WorkHours = function (_Component) {
	  _inherits(WorkHours, _Component);
	
	  function WorkHours(props) {
	    _classCallCheck(this, WorkHours);
	
	    var _this = _possibleConstructorReturn(this, (WorkHours.__proto__ || Object.getPrototypeOf(WorkHours)).call(this, props));
	
	    _this.state = {
	      Hours: {},
	      ShowHourWindow: false,
	      IsHourWindowHistory: false,
	      EditPauseType: 0
	    };
	
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onInputHourChange = _this.onInputHourChange.bind(_this);
	    _this.ToggelHourWindow = _this.ToggelHourWindow.bind(_this);
	    _this.onChangeDate = _this.onChangeDate.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(WorkHours, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        Hours: (0, _lodash.cloneDeep)(this.props.WorkHours)
	      }, function () {
	        var EditPauseType = _this2.state.Hours.PauseType;
	        if (!_this2.props.onlyShow) {
	          _this2.setState({
	            Hours: _extends({}, _this2.state.Hours, {
	              Date: new Date()
	            }),
	            EditPauseType: EditPauseType
	          });
	        }
	      });
	
	      if (!this.props.onlyShow && this.props.setBottomBarProps) {
	        this.props.setBottomBarProps({
	          actionLabelText: (0, _helpers.translation)('14732'),
	          onActionClick: this.onSave,
	          cancelLabelText: (0, _helpers.translation)('1155'),
	          onCancelClick: this.props.onClose
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        Hours: _extends({}, (0, _lodash.cloneDeep)(nextProps.WorkHours))
	      });
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      var value = parseInt(e.target.value);
	      var name = e.target.name;
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'onInputHourChange',
	    value: function onInputHourChange(e) {
	      var Hours = this.state.Hours;
	      var value = '';
	      var name = e.target.name;
	      var val = e.target.value;
	
	      var sub = val.substr(1, 1);
	      var sub2 = val.substr(2, 1);
	      if (isNaN(parseInt(sub))) {
	        if (sub !== ':' && sub !== '') {
	          val = val.replace(sub, ':');
	        }
	      }
	      if (isNaN(parseInt(sub2))) {
	        if (sub2 !== ':' && sub2 !== '') {
	          val = val.replace(sub2, ':');
	        }
	      }
	      val = val.replace('::', ':');
	      var datetimeFormat = Hours[name];
	      if (datetimeFormat === null) datetimeFormat = '2000-01-01T00:00:00';
	      value = (0, _time.setHourMin)(datetimeFormat, val);
	
	      this.setState({
	        Hours: _extends({}, this.state.Hours, _defineProperty({}, name, value))
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var name = e.target.name;
	
	      var day = name.substr(0, name.indexOf('day') + 3);
	      var start = this.state.Hours[day + 'StartTime'];
	      var end = this.state.Hours[day + 'EndTime'];
	
	      var time = start.endsWith('T') || end.endsWith('T') ? 0 : (0, _moment2.default)(end, 'YYYY-MM-DD HH:mm').diff((0, _moment2.default)(start, 'YYYY-MM-DD HH:mm'));
	      time = time > 0 ? time / 3600000 : 0.0;
	
	      this.setState({
	        Hours: _extends({}, this.state.Hours, _defineProperty({}, day, time))
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.state.Hours === undefined || this.state.Hours.Monday === undefined) return null;
	      var allWorkHours = Number(this.state.Hours.Monday * 60) + Number(this.state.Hours.Tuesday * 60) + Number(this.state.Hours.Wednesday * 60) + Number(this.state.Hours.Thursday * 60) + Number(this.state.Hours.Friday * 60) + Number(this.state.Hours.Saturday * 60) + Number(this.state.Hours.Sunday * 60);
	      var allPauseHours = (Number(this.state.Hours.MondayPause) + Number(this.state.Hours.TuesdayPause) + Number(this.state.Hours.WednesdayPause) + Number(this.state.Hours.ThursdayPause) + Number(this.state.Hours.FridayPause) + Number(this.state.Hours.SaturdayPause) + Number(this.state.Hours.SundayPause)) / 60;
	
	      var allWorkMinutes = allWorkHours;
	      var allPauseMinutes = allPauseHours * 60;
	      var wageMinutes = allWorkMinutes - allPauseMinutes;
	
	      var cols = [2];
	
	      var formatMinutes = function formatMinutes(minutes) {
	        minutes = Math.round(minutes);
	        var hours = Math.floor(minutes / 60);
	        var min = Math.round(minutes % 60);
	        return (0, _time.padNumber)(hours, 2) + ':' + (0, _time.padNumber)(min, 2);
	      };
	
	      var formatWorkHourTimes = function formatWorkHourTimes(datetime) {
	        if (datetime === null || datetime === undefined || datetime.length < 11) return '';
	        return datetime.substring(11, 16);
	      };
	
	      var renderWorkDay = function renderWorkDay(label, name) {
	        var startNameProp = name + 'StartTime';
	        var endNameProp = name + 'EndTime';
	        var pauseNameProp = name + 'Pause';
	
	        if (_this3.props.onlyShow) {
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: cols, rowSpan: '2', align: 'center' },
	            _react2.default.createElement(
	              'span',
	              null,
	              label
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              formatWorkHourTimes(_this3.state.Hours[startNameProp])
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              formatWorkHourTimes(_this3.state.Hours[endNameProp])
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              formatMinutes(_this3.state.Hours[name] * 60)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _this3.state.Hours[pauseNameProp] || ''
	            )
	          );
	        }
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, rowSpan: '2', align: 'center' },
	          _react2.default.createElement(
	            'span',
	            null,
	            label
	          ),
	          _react2.default.createElement(_text2.default, { name: startNameProp, value: formatWorkHourTimes(_this3.state.Hours[startNameProp]), onChange: _this3.onInputHourChange, onBlur: _this3.onBlur, disabled: _this3.props.onlyShow, maxLength: '5', size: 's', simple: true }),
	          _react2.default.createElement(_text2.default, { name: endNameProp, value: formatWorkHourTimes(_this3.state.Hours[endNameProp]), onChange: _this3.onInputHourChange, onBlur: _this3.onBlur, disabled: _this3.props.onlyShow, maxLength: '5', size: 's', simple: true }),
	          _react2.default.createElement(
	            'span',
	            null,
	            formatMinutes(_this3.state.Hours[name] * 60)
	          ),
	          _react2.default.createElement(_text2.default, { name: pauseNameProp, value: _this3.state.Hours[pauseNameProp] || '', onChange: _this3.onInputChange, disabled: _this3.props.onlyShow, maxLength: '3', size: 's', simple: true })
	        );
	      };
	
	      var renderContainer = function renderContainer(content) {
	        // if (this.props.IsLog) {
	        //   return (
	        //     <div>
	        //       <Header text={translation('453')} />
	        //       <Divider />
	        //       {content}
	        //     </div>
	        //   )
	        // }
	
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('453') },
	          _react2.default.createElement(
	            _actions2.default,
	            null,
	            _this3.props.onlyShow && _this3.props.IsLog !== true && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, onClick: _this3.ToggelHourWindow, size: 't' })
	          ),
	          content
	        );
	      };
	
	      var renderContent = function renderContent() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'WorkHours' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: cols },
	              _react2.default.createElement('span', null),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon hint--bottom', 'aria-label': (0, _helpers.translation)('2202') },
	                  _react2.default.createElement('img', { className: 'icon', src: '/images/icons/working-hour-16x16.png' })
	                ),
	                ' ',
	                _react2.default.createElement(_helpIcon2.default, { helpText: (0, _helpers.translation)('2204') })
	              ),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon hint--bottom', 'aria-label': (0, _helpers.translation)('2203') },
	                  _react2.default.createElement('img', { className: 'icon', src: '/images/icons/Fyraften-16x16.png' })
	                ),
	                ' ',
	                _react2.default.createElement(_helpIcon2.default, { helpText: (0, _helpers.translation)('2205') })
	              ),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon hint--bottom', 'aria-label': (0, _helpers.translation)('469') },
	                  _react2.default.createElement('img', { className: 'icon', src: '/images/icons/My-hours-Black-16x16.png' })
	                ),
	                ' ',
	                _react2.default.createElement(_helpIcon2.default, { helpText: (0, _helpers.translation)('1977') })
	              ),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon hint--bottom', 'aria-label': (0, _helpers.translation)('468') },
	                  _react2.default.createElement('img', { className: 'icon', src: '/images/icons/Pause-Black-16x16.png' })
	                ),
	                ' ',
	                _react2.default.createElement(_helpIcon2.default, { helpText: (0, _helpers.translation)('1978') })
	              )
	            ),
	            renderWorkDay((0, _helpers.translation)('169'), 'Monday'),
	            renderWorkDay((0, _helpers.translation)('170'), 'Tuesday'),
	            renderWorkDay((0, _helpers.translation)('171'), 'Wednesday'),
	            renderWorkDay((0, _helpers.translation)('172'), 'Thursday'),
	            renderWorkDay((0, _helpers.translation)('173'), 'Friday'),
	            renderWorkDay((0, _helpers.translation)('174'), 'Saturday'),
	            renderWorkDay((0, _helpers.translation)('175'), 'Sunday'),
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: cols, rowSpan: '2', align: 'center' },
	              _react2.default.createElement(
	                'label',
	                { className: 'weeklyHoursLabel' },
	                (0, _helpers.translation)('452')
	              ),
	              _react2.default.createElement('span', null),
	              _react2.default.createElement('span', null),
	              _react2.default.createElement(
	                'label',
	                { className: 'count_all' },
	                formatMinutes(allWorkMinutes)
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'count_all' },
	                formatMinutes(allPauseMinutes)
	              )
	            ),
	            _react2.default.createElement(_divider2.default, { noLine: true }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('1817'), helpText: (0, _helpers.translation)('1979') },
	              _this3.props.onlyShow && _react2.default.createElement(_radio2.default, { name: 'PauseType', value: 0, checked: _this3.state.Hours.PauseType === 0, disabled: _this3.props.onlyShow, labelText: (0, _helpers.translation)('463') }),
	              _this3.props.onlyShow && _react2.default.createElement(_radio2.default, { name: 'PauseType', value: 1, checked: _this3.state.Hours.PauseType === 1, disabled: _this3.props.onlyShow, labelText: (0, _helpers.translation)('464') }),
	              _this3.props.onlyShow && _react2.default.createElement(_radio2.default, { name: 'PauseType', value: 2, checked: _this3.state.Hours.PauseType === 2, disabled: _this3.props.onlyShow, labelText: (0, _helpers.translation)('460') }),
	              !_this3.props.onlyShow && _react2.default.createElement(_radio2.default, { name: 'EditPauseType', value: 0, checked: _this3.state.EditPauseType === 0, onChange: _this3.onRadioChange, disabled: _this3.props.onlyShow, labelText: (0, _helpers.translation)('463') }),
	              !_this3.props.onlyShow && _react2.default.createElement(_radio2.default, { name: 'EditPauseType', value: 1, checked: _this3.state.EditPauseType === 1, onChange: _this3.onRadioChange, disabled: _this3.props.onlyShow, labelText: (0, _helpers.translation)('464') }),
	              !_this3.props.onlyShow && _react2.default.createElement(_radio2.default, { name: 'EditPauseType', value: 2, checked: _this3.state.EditPauseType === 2, onChange: _this3.onRadioChange, disabled: _this3.props.onlyShow, labelText: (0, _helpers.translation)('460') })
	            ),
	            _this3.props.onlyShow ? _react2.default.createElement(
	              _grid2.default,
	              { spacing: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('14733')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _time.renderFullDate)(_this3.state.Hours.Date, false)
	              )
	            ) : _react2.default.createElement(_datetime2.default, {
	              labelText: (0, _helpers.translation)('14733'),
	              dateFormat: 'DD-MM-YYYY',
	              closeOnSelect: true,
	              timeFormat: false,
	              value: _this3.state.Hours.Date,
	              onChange: _this3.onChangeDate.bind(_this3, 'Date') }),
	            _this3.state.ShowToDate && _react2.default.createElement(
	              _grid2.default,
	              { spacing: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('187')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _time.renderFullDate)(_this3.state.ShowToDate, false)
	              )
	            ),
	            _this3.props.onlyShow && _this3.props.IsLog !== true && _this3.props.LogCount > 1 && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Log_Icon, onClick: _this3.ToggelHourWindow.bind(_this3, 'true') })
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('547') }),
	            _react2.default.createElement(
	              'span',
	              null,
	              formatMinutes(wageMinutes)
	            )
	          ),
	          _this3.state.ShowHourWindow && _react2.default.createElement(_WorkhourModal2.default, { SetWorkHours: _this3.props.setWorkHours.bind(_this3), UserId: _this3.state.Hours.UserId, onClose: _this3.ToggelHourWindow, IsHistory: _this3.state.IsHourWindowHistory })
	        );
	      };
	
	      return this.props.InModal !== true /* || this.props.IsLog */ ? renderContainer(renderContent()) : renderContent();
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(name, e) {
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (typeof e === 'undefined') {
	          e = name;
	        }
	        name = e.target.name;
	        value = e.target.value;
	      }
	      this.setState({
	        Hours: _extends({}, this.state.Hours, _defineProperty({}, name, value))
	      });
	    }
	  }, {
	    key: 'onChangeDate',
	    value: function onChangeDate(name, e) {
	      var value = e;
	      this.setState({
	        Hours: _extends({}, this.state.Hours, _defineProperty({}, name, value))
	      });
	
	      var date = '';
	      var val = new Date(value);
	      var dates = this.props.Dates;
	      for (var i = dates.length, j = 0; i > j; i--) {
	        if (new Date(dates[i]) > val) {
	          date = dates[i];
	        }
	      }
	      this.setState({
	        ShowToDate: date
	      });
	    }
	  }, {
	    key: 'ToggelHourWindow',
	    value: function ToggelHourWindow(IsHistory) {
	      this.props.triggerPopup(!this.state.ShowHourWindow);
	
	      this.setState({
	        ShowHourWindow: !this.state.ShowHourWindow,
	        IsHourWindowHistory: IsHistory === 'true'
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave() {
	      var _this4 = this;
	
	      var data = {
	        UserId: this.state.Hours.UserId,
	        WorkHour: _extends({}, this.state.Hours, {
	          PauseType: this.state.EditPauseType
	        })
	      };
	
	      this.props.UpdateWorkHours(data).then(function (res) {
	        _this4.props.updateLogs(res.data);
	
	        // window.toastr.success(translation('14766'), translation('13424'))
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('14767'), (0, _helpers.translation)('216'));
	      });
	    }
	  }]);
	
	  return WorkHours;
	}(_react.Component);
	
	WorkHours.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { UpdateWorkHours: _employees.UpdateWorkHours, triggerPopup: _backdrop.triggerPopup })(WorkHours);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1579);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	var CheckButton = function (_Component) {
	  _inherits(CheckButton, _Component);
	
	  function CheckButton(props) {
	    _classCallCheck(this, CheckButton);
	
	    var _this = _possibleConstructorReturn(this, (CheckButton.__proto__ || Object.getPrototypeOf(CheckButton)).call(this, props));
	
	    _this.state = {};
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(CheckButton, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      // console.log('CheckButton onClick triggered!', e)
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return ' size-large';
	        case 'm':
	          return ' size-medium';
	        case 's':
	          return ' size-small';
	      }
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var css = '' + this.getSizeClass();
	
	      if (this.props.checked) {
	        css += ' checked';
	      }
	
	      return css;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var labelText = this.props.labelText;
	      if (typeof labelText === 'number') labelText = (0, _helpers.translation)(labelText);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-check-button' },
	        _react2.default.createElement(
	          'button',
	          {
	            className: this.getStyle(),
	            name: this.props.name,
	            onClick: this.onClick
	          },
	          this.props.labelText && labelText,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return CheckButton;
	}(_react.Component);
	
	CheckButton.defaultProps = {
	  size: 'm',
	  labelText: null,
	  onClick: null,
	  name: null,
	  checked: false
	};
	
	exports.default = CheckButton;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1582);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CircleButton = function (_Component) {
	  _inherits(CircleButton, _Component);
	
	  function CircleButton(props) {
	    _classCallCheck(this, CircleButton);
	
	    var _this = _possibleConstructorReturn(this, (CircleButton.__proto__ || Object.getPrototypeOf(CircleButton)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CircleButton, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.icon === null || this.props.icon === undefined) return null;
	      var buttonProps = _extends({}, this.props, { round: true });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-circlebutton' },
	        _react2.default.createElement(
	          _button2.default,
	          buttonProps,
	          _react2.default.createElement(_icon2.default, { size: this.props.size, icon: this.props.icon, injectSvg: true })
	        )
	      );
	    }
	  }]);
	
	  return CircleButton;
	}(_react.Component);
	
	CircleButton.defaultProps = {
	  size: 'l',
	  style: 'link',
	  // round: true,
	  spacing: 0
	};
	
	exports.default = CircleButton;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1588);
	
	var _helpers = __webpack_require__(2);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var CountSpecifier = function (_Component) {
	  _inherits(CountSpecifier, _Component);
	
	  function CountSpecifier(props) {
	    _classCallCheck(this, CountSpecifier);
	
	    var _this = _possibleConstructorReturn(this, (CountSpecifier.__proto__ || Object.getPrototypeOf(CountSpecifier)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(CountSpecifier, [{
	    key: 'onClick',
	    value: function onClick(type) {
	      var newCount = this.props.value;
	
	      if (type === 'add') {
	        newCount += 1;
	      } else {
	        newCount -= 1;
	      }
	
	      if (this.props.onChange !== null) {
	        this.props.onChange({
	          target: {
	            name: this.props.name,
	            value: newCount
	          }
	        });
	      }
	    }
	  }, {
	    key: 'renderCount',
	    value: function renderCount() {
	      var _props = this.props,
	          value = _props.value,
	          total = _props.total,
	          disabled = _props.disabled;
	
	      var className = 'element-count-specifier__count';
	      if (disabled) className += ' disabled';
	
	      if (!total || total < 2) {
	        return _react2.default.createElement(
	          'div',
	          { className: className },
	          value
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        value + ' ' + (0, _helpers.translation)(16436) + ' ' + total
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          value = _props2.value,
	          total = _props2.total,
	          disabled = _props2.disabled;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-count-specifier' },
	        _react2.default.createElement(
	          _inline2.default,
	          null,
	          _react2.default.createElement(_removeButton2.default, {
	            onClick: function onClick() {
	              return _this2.onClick('remove');
	            },
	            disabled: value === 1 || disabled,
	            size: 'm',
	            style: 'link',
	            dimmed: false,
	            round: true,
	            minus: true
	          }),
	          this.renderCount(),
	          _react2.default.createElement(_addButton2.default, {
	            onClick: function onClick() {
	              return _this2.onClick('add');
	            },
	            disabled: value === total || disabled,
	            size: 'm',
	            round: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return CountSpecifier;
	}(_react.Component);
	
	CountSpecifier.defaultProps = {
	  onChange: null,
	  disabled: false
	};
	
	exports.default = CountSpecifier;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	__webpack_require__(1599);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Image = function (_Component) {
	  _inherits(Image, _Component);
	
	  function Image(props) {
	    _classCallCheck(this, Image);
	
	    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));
	
	    _this.onDelete = _this.onDelete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Image, [{
	    key: 'onDelete',
	    value: function onDelete(e) {
	      if (typeof this.props.onClickDelete === 'function') {
	        this.props.onClickDelete(this.props.imageFile);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.imageFile === null) return null;
	      var imageFile = this.props.imageFile;
	      if (!imageFile.IsImage) return null;
	      var canDelete = typeof this.props.onClickDelete === 'function' && (imageFile.IsDeletable === undefined || imageFile.IsDeletable);
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-image' },
	        _react2.default.createElement(
	          'a',
	          { href: imageFile.FileURL, 'data-lightbox': 'gallery', 'data-title': imageFile.FileName },
	          _react2.default.createElement('img', { className: 'thumb', src: imageFile.ThumbURL })
	        ),
	        canDelete && _react2.default.createElement(
	          'div',
	          { className: 'file-delete' },
	          _react2.default.createElement(_removeButton2.default, { onClick: this.onDelete, size: 's' })
	        )
	      );
	    }
	  }]);
	
	  return Image;
	}(_react.Component);
	
	Image.defaultProps = {
	  imageFile: null,
	  onClickDelete: null
	};
	
	exports.default = Image;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1606);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrangeDivider = function (_Component) {
	  _inherits(OrangeDivider, _Component);
	
	  function OrangeDivider() {
	    _classCallCheck(this, OrangeDivider);
	
	    return _possibleConstructorReturn(this, (OrangeDivider.__proto__ || Object.getPrototypeOf(OrangeDivider)).apply(this, arguments));
	  }
	
	  _createClass(OrangeDivider, [{
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      if (typeof this.props.size === 'number' && this.props.size > 0 && this.props.size < 7) {
	        return 'pg-my-' + this.props.size;
	      }
	
	      return 'pg-my-1';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = 'element-divider-orange ' + this.getSizeClass();
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)(this.props.labelText)
	        ),
	        _react2.default.createElement('hr', null)
	      );
	    }
	  }]);
	
	  return OrangeDivider;
	}(_react.Component);
	
	OrangeDivider.defaultProps = {
	  size: 1
	};
	
	exports.default = OrangeDivider;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressLine = function (_PureComponent) {
	  _inherits(ProgressLine, _PureComponent);
	
	  function ProgressLine() {
	    _classCallCheck(this, ProgressLine);
	
	    return _possibleConstructorReturn(this, (ProgressLine.__proto__ || Object.getPrototypeOf(ProgressLine)).apply(this, arguments));
	  }
	
	  _createClass(ProgressLine, [{
	    key: 'getFill',
	    value: function getFill() {
	      var fill = typeof this.props.fill === 'string' ? parseInt(this.props.fill) : this.props.fill;
	      if (fill < 1) return '';
	      return fill;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      switch (this.props.color) {
	        case 'green':
	          return ' green';
	        case 'red':
	          return ' red';
	        case 'yellow':
	          return ' yellow';
	        default:
	          return '';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: 'element-progress-line' + this.getColor(), style: this.props.style });
	    }
	  }]);
	
	  return ProgressLine;
	}(_react.PureComponent);
	
	ProgressLine.defaultProps = {
	  fill: 100,
	  color: 'green'
	};
	
	exports.default = ProgressLine;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1633);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LINE_TYPES = {
	  None: -1,
	  DoubleSolid: 0,
	  DoubleDashed: 1,
	  SingleSolid: 2,
	  SingleDashed: 3
	};
	
	var POINT_TYPES = {
	  None: -1,
	  Default: 0,
	  Dot_Gray: 1,
	  Intersection: 2,
	  Ok_Green: 3,
	  Exclamation_Red: 4
	
	  /**
	   * Renders a vertical time line segment for one "step" in a timeline. Multiple parallel lines are supported.
	   * Note: Any width assigned to this component must be a multiple of 20. (Each line takes exactly 20 pixels in width)
	   * Vertically, the component will fill up to the edges, to allow stacking them to produce continous time lines.
	   */
	};
	var TimeLineSegment = function (_Component) {
	  _inherits(TimeLineSegment, _Component);
	
	  function TimeLineSegment() {
	    _classCallCheck(this, TimeLineSegment);
	
	    return _possibleConstructorReturn(this, (TimeLineSegment.__proto__ || Object.getPrototypeOf(TimeLineSegment)).apply(this, arguments));
	  }
	
	  _createClass(TimeLineSegment, [{
	    key: 'getLineTypeClass',
	    value: function getLineTypeClass(lineType) {
	      switch (lineType) {
	        case LINE_TYPES.SingleSolid:
	          return 'linesegment single-solid';
	        case LINE_TYPES.DoubleSolid:
	          return 'linesegment double-solid';
	        case LINE_TYPES.SingleDashed:
	          return 'linesegment single-dashed';
	        case LINE_TYPES.DoubleDashed:
	          return 'linesegment double-dashed';
	      }
	      return 'linesegment none';
	    }
	  }, {
	    key: 'renderTopLines',
	    value: function renderTopLines(lines) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-timelinesegment__lines__top' },
	        lines.map(function (x, i) {
	          return _this2.renderLineSegment(x.LineTypeBefore, i);
	        })
	      );
	    }
	  }, {
	    key: 'renderBottomLines',
	    value: function renderBottomLines(lines) {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-timelinesegment__lines__bottom' },
	        lines.map(function (x, i) {
	          return _this3.renderLineSegment(x.LineTypeAfter, i);
	        })
	      );
	    }
	  }, {
	    key: 'renderLineSegment',
	    value: function renderLineSegment(lineType, index) {
	      return _react2.default.createElement(
	        'div',
	        { key: index, className: 'segment-center' },
	        _react2.default.createElement('div', { className: this.getLineTypeClass(lineType) })
	      );
	    }
	  }, {
	    key: 'renderLineDots',
	    value: function renderLineDots(lines) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-timelinesegment__lines__center' },
	        lines.map(function (x, i) {
	          return _this4.renderDotSegment(x.LineDotType, i);
	        })
	      );
	    }
	  }, {
	    key: 'renderDotSegment',
	    value: function renderDotSegment(dotType, index) {
	      // Html for different point types.
	      var blank = _react2.default.createElement('div', { key: index, className: 'segment-center' });
	
	      var dotGray = _react2.default.createElement(
	        'div',
	        { key: index, className: 'segment-center' },
	        _react2.default.createElement('div', { className: 'dotsegment dot_gray' })
	      );
	
	      var intersection = _react2.default.createElement(
	        'div',
	        { key: index, className: 'segment-center' },
	        _react2.default.createElement('div', { className: 'dotsegment intersection' })
	      );
	
	      var okGreen = _react2.default.createElement(
	        'div',
	        { key: index, className: 'segment-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dotsegment icon' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.TimeLineIcons.Ok_Green, size: 't' })
	        )
	      );
	
	      var exclamationRed = _react2.default.createElement(
	        'div',
	        { key: index, className: 'segment-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dotsegment icon' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.TimeLineIcons.Exclamation_Red, size: 't' })
	        )
	      );
	      switch (dotType) {
	        case POINT_TYPES.Dot_Gray:
	          return dotGray;
	        case POINT_TYPES.Intersection:
	          return intersection;
	        case POINT_TYPES.Ok_Green:
	          return okGreen;
	        case POINT_TYPES.Exclamation_Red:
	          return exclamationRed;
	      }
	      return blank;
	    }
	  }, {
	    key: 'renderActive',
	    value: function renderActive(lines) {
	      var renderActiveSegment = function renderActiveSegment(index) {
	        // First index is where we put the active dot and line. We don't support the active dot in other segments.
	        var activeDotWithLine = _react2.default.createElement(
	          'div',
	          { key: 'active_' + index, className: 'active-span' },
	          _react2.default.createElement('div', { className: 'active-dot' }),
	          _react2.default.createElement('div', { className: 'active-line' })
	        );
	        if (index === 0) {
	          return activeDotWithLine;
	        }
	        return null;
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-timelinesegment__lines__center' },
	        lines.map(function (x, i) {
	          return renderActiveSegment(i);
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var inlineStyle = { gridTemplateRows: this.props.topHeight + ' 0px ' + this.props.bottomHeight };
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-timelinesegment' },
	        _react2.default.createElement(
	          'div',
	          { className: 'element-timelinesegment__lines', style: inlineStyle },
	          this.renderTopLines(this.props.lines),
	          this.props.active ? this.renderActive(this.props.lines) : this.renderLineDots(this.props.lines),
	          this.renderBottomLines(this.props.lines)
	        )
	      );
	    }
	  }]);
	
	  return TimeLineSegment;
	}(_react.Component);
	
	TimeLineSegment.defaultProps = {
	  topHeight: '1fr', // Height of top in any unit   (Use these to align center to content rendered next to this component)
	  bottomHeight: '1fr', // Height of bottom in any unit
	  active: true, // True to render active line with dot, overrides any dot type
	  lines: [{
	    LineTypeAfter: LINE_TYPES.SingleSolid,
	    LineTypeBefore: LINE_TYPES.SingleSolid,
	    LineDotType: POINT_TYPES.Dot_Gray
	  }, {
	    LineTypeAfter: LINE_TYPES.DoubleSolid,
	    LineTypeBefore: LINE_TYPES.DoubleSolid,
	    LineDotType: POINT_TYPES.Intersection
	  }, {
	    LineTypeAfter: LINE_TYPES.SingleDashed,
	    LineTypeBefore: LINE_TYPES.SingleDashed,
	    LineDotType: POINT_TYPES.Ok_Green
	  }, {
	    LineTypeAfter: LINE_TYPES.DoubleDashed,
	    LineTypeBefore: LINE_TYPES.DoubleDashed,
	    LineDotType: POINT_TYPES.Exclamation_Red
	  }]
	};
	
	exports.default = TimeLineSegment;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _lodash = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TIMESPAN_FORMAT_INVALID = -1;
	var TIMESPAN_FORMAT_DECIMAL = 0;
	var TIMESPAN_FORMAT_TIME = 1;
	
	var TimeSpan = function (_Component) {
	  _inherits(TimeSpan, _Component);
	
	  function TimeSpan(props) {
	    _classCallCheck(this, TimeSpan);
	
	    var _this = _possibleConstructorReturn(this, (TimeSpan.__proto__ || Object.getPrototypeOf(TimeSpan)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.detectFormat = _this.detectFormat.bind(_this);
	    _this.getFromValue = _this.getFromValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(TimeSpan, [{
	    key: 'detectFormat',
	    value: function detectFormat(value) {
	      value += '';
	      if (/\b\d{1,3}[:]\d{0,2}\b/.test(value) && (0, _lodash.parseInt)(value.split(':')[1]) <= 59) return TIMESPAN_FORMAT_TIME;
	      if (/\b\d{1,3}[,]\d{0,2}\b/.test(value)) return TIMESPAN_FORMAT_DECIMAL;
	      return TIMESPAN_FORMAT_INVALID;
	    }
	  }, {
	    key: 'decimalToTimeFormat',
	    value: function decimalToTimeFormat(value) {
	      value += ''; // ensure string
	      value = value.replace(',', '.');
	      var parts = value.split('.');
	      var hour = (0, _lodash.parseInt)(parts[0]);
	      if (isNaN(hour)) hour = 0;
	      var min = parseFloat(value) - hour;
	      min /= 1.666666666666666667;
	      min = min.toFixed(2).replace('0.', '');
	      return hour + ':' + min;
	    }
	  }, {
	    key: 'timeToDecimalFormat',
	    value: function timeToDecimalFormat(value) {
	      value += '';
	      value = value.replace(':', '.');
	      var parts = value.split('.');
	      var hour = (0, _lodash.parseInt)(parts[0]);
	      if (isNaN(hour)) hour = 0;
	      var min = parseFloat(value) - hour;
	      min *= 1.666666666666666667;
	      min = min.toFixed(2).replace('0.', '');
	      return parseFloat(hour + '.' + min);
	    }
	  }, {
	    key: 'getFromValue',
	    value: function getFromValue(val) {
	      var value = { decimal: 0.0, time: '0:00' };
	      var currentFormat = this.detectFormat(val);
	      switch (currentFormat) {
	        case TIMESPAN_FORMAT_TIME:
	          value.time = val;
	          value.decimal = this.timeToDecimalFormat(value.time);
	          break;
	        case TIMESPAN_FORMAT_DECIMAL:
	          value.decimal = parseFloat(val.replace(',', '.'));
	          value.time = this.decimalToTimeFormat(value.decimal);
	          break;
	      }
	      return {
	        currentFormat: currentFormat,
	        value: value
	      };
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      if (this.props.onChange) {
	        this.props.onChange(e);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var valString = this.props.value + '';
	      if (!isNaN((0, _lodash.parseInt)(valString)) && !valString.includes(':') && !valString.includes(',') && !valString.includes('.')) {
	        valString += ':00';
	        e.target.value = valString;
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	      if (this.props.onBlur) {
	        this.props.onBlur({ target: _extends({ name: this.props.name }, this.getFromValue(valString)) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_text2.default, _extends({}, this.props, {
	        placeHolder: '0:00',
	        value: this.props.value,
	        onChange: this.onChange,
	        onBlur: this.onBlur
	      }));
	    }
	  }]);
	
	  return TimeSpan;
	}(_react.Component);
	
	TimeSpan.defaultProps = {
	  onChange: null
	};
	
	exports.default = TimeSpan;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1648);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PinCodeModal = __webpack_require__(1104);
	
	var _PinCodeModal2 = _interopRequireDefault(_PinCodeModal);
	
	var _auth = __webpack_require__(68);
	
	var _auth2 = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var LoginAsModal = function (_Component) {
	  _inherits(LoginAsModal, _Component);
	
	  function LoginAsModal(props) {
	    _classCallCheck(this, LoginAsModal);
	
	    var _this = _possibleConstructorReturn(this, (LoginAsModal.__proto__ || Object.getPrototypeOf(LoginAsModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      isLoading: false,
	      showPinModal: false,
	      selectedUser: null
	    };
	    _this.renderEmployee = _this.renderEmployee.bind(_this);
	    _this.loginAs = _this.loginAs.bind(_this);
	    _this.checkPinCode = _this.checkPinCode.bind(_this);
	    _this.closePinModal = _this.closePinModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(LoginAsModal, [{
	    key: 'loginAs',
	    value: function loginAs(id) {
	      var _this2 = this;
	
	      this.setState({ isLoading: true }, function () {
	        _this2.props.loginAs(id).then(function (res) {
	          _this2.props.getAuthResources().then(function (res) {
	            res.data.permissions = res.data.Permissions;
	            if (typeof _this2.props.data.type !== 'undefined') {
	              switch (_this2.props.data.type) {
	                case 'inspection':
	                  if ((0, _auth2.hasSubscriptionPermission)(res.data, 10, 30)) {
	                    _this2.props.router.push('/orders/' + _this2.props.data.id + '/orderinspection');
	                  } else {
	                    _this2.props.onClose(true, _this2.props.data);
	                  }
	                  break;
	                case 'workcard':
	                  _this2.props.router.push('/orders/' + _this2.props.data.id);
	                  break;
	              }
	            }
	          }).finally(function () {
	            _this2.props.onClose(true, _this2.props.data);
	            _this2.setState({ isLoading: false });
	          });
	        }, function (err) {
	          _this2.setState({ isLoading: false });
	          console.log(err);
	          console.log('Nooooo, could not login', err.response.data);
	        });
	      });
	    }
	  }, {
	    key: 'renderEmployee',
	    value: function renderEmployee(val, key) {
	      if (val.Active) {
	        return _react2.default.createElement(_button2.default, { key: key, disabled: this.state.isLoading, style: 'link' /* onClick={this.loginAs.bind(this, val.UserId)} */, onClick: this.checkPinCode.bind(this, val), labelText: val.Name, onLogin: this.loginAs });
	      }
	    }
	  }, {
	    key: 'checkPinCode',
	    value: function checkPinCode(user) {
	      this.setState({
	        showPinModal: true,
	        selectedUser: user,
	        isLoading: true
	      });
	    }
	  }, {
	    key: 'closePinModal',
	    value: function closePinModal(e) {
	      var _this3 = this;
	
	      this.setState({
	        showPinModal: false,
	        isLoading: false
	      }, function () {
	        if (e === undefined) {
	          _this3.props.onClose(true, _this3.props.data);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var employees = this.props.employees;
	
	      if (this.state.showPinModal) {
	        return _react2.default.createElement(_PinCodeModal2.default, { router: this.props.router,
	          show: this.state.showPinModal,
	          onClose: this.closePinModal,
	          user: this.state.selectedUser,
	          data: this.props.data
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'loginas_modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: (0, _helpers.translation)('57'), overflowHidden: this.state.overflowHidden,
	            icon: _icons.ModalIcons.Employees_White }),
	          _react2.default.createElement(
	            'div',
	            { className: 'employees' },
	            employees.map(this.renderEmployee)
	          )
	        )
	      );
	    }
	  }]);
	
	  return LoginAsModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    employees: state.common.employees
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  loginAs: _auth.loginAs,
	  getAuthResources: _auth.getAuthResources
	})(LoginAsModal);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1651);
	
	var _orders = __webpack_require__(21);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// import components
	
	
	// import utils
	
	
	// Elements
	
	
	var MoveModal = function (_Component) {
	  _inherits(MoveModal, _Component);
	
	  function MoveModal(props) {
	    _classCallCheck(this, MoveModal);
	
	    var _this = _possibleConstructorReturn(this, (MoveModal.__proto__ || Object.getPrototypeOf(MoveModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      clickOutsideClose: true,
	      Step: 0,
	      availableSteps: [],
	      actionType: 0,
	      comment: ''
	    };
	    _this.modalTitle = _this.modalTitle.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    _this.moveOrder = _this.moveOrder.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.renderAvailableSteps = _this.renderAvailableSteps.bind(_this);
	    _this.renderDeviation = _this.renderDeviation.bind(_this);
	    _this.renderPaintButtons = _this.renderPaintButtons.bind(_this);
	    _this.renderOther = _this.renderOther.bind(_this);
	    return _this;
	  }
	
	  _createClass(MoveModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var step = this.props.item.NewStepId ? this.props.item.NewStepId : this.props.item.StepId;
	      var actionType = this.props.auth.departmentType === 1 ? 2 : 0;
	      this.setState({
	        Step: step,
	        actionType: actionType
	      });
	      if (this.props.type !== undefined) {
	        if (this.props.type === 1) {
	          this.props.getStepsBehind(this.props.item.Id).then(function (res) {
	            var newStep = res.data.filter(function (x) {
	              return x.Step === step;
	            })[0];
	            if (newStep === undefined) newStep = res.data[res.data.length - 1];
	            _this2.setState({
	              Step: newStep.Step,
	              availableSteps: res.data
	            });
	          });
	        } else {
	          this.props.getStepsAhead(this.props.item.Id).then(function (res) {
	            var newStep = res.data.filter(function (x) {
	              return x.Step === step;
	            })[0];
	            if (newStep === undefined) newStep = res.data[0];
	            _this2.setState({
	              Step: newStep.Step,
	              availableSteps: res.data
	            });
	          });
	        }
	      } else {
	        // Get available steps for this order.
	        this.props.getSteps(this.props.item.Id).then(function (res) {
	          // Determine if new step is ahead or behind current step.
	          var newStepIndex = res.data.findIndex(function (s) {
	            return s.Step === step;
	          });
	          var currentStepIndex = res.data.findIndex(function (s) {
	            return s.Step === _this2.props.item.StepId;
	          });
	          if (res.data[newStepIndex].Order < res.data[currentStepIndex].Order) {
	            _this2.props.getStepsBehind(_this2.props.item.Id).then(function (res) {
	              _this2.setState({ availableSteps: res.data });
	            });
	          } else {
	            _this2.props.getStepsAhead(_this2.props.item.Id).then(function (res) {
	              _this2.setState({ availableSteps: res.data });
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.props.onClose();
	    }
	  }, {
	    key: 'moveOrder',
	    value: function moveOrder(e) {
	      e.preventDefault();
	      // console.log('modal', this.props.item.StepId, this.state.Step)
	      if (this.state.Step === 0) {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13430'), (0, _helpers.translation)('216'));
	      } else {
	        var moveData = {
	          OrderIds: [this.props.item.Id],
	          UserId: 0,
	          StepFrom: this.props.item.StepId,
	          StepTo: this.state.Step,
	          Comment: this.state.comment,
	          FilterSettings: {}
	
	          // console.log('Move data', moveData, this.props.item)
	        };this.props.onMoveOrders(moveData);
	        this.onClose();
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.setState(_defineProperty({}, e.target.name, parseInt(e.target.value)));
	    }
	  }, {
	    key: 'renderAvailableSteps',
	    value: function renderAvailableSteps() {
	      var _this3 = this;
	
	      var steps = [];
	      steps = this.state.availableSteps.map(function (x) {
	        return x.Step;
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'clearfix radio--inputs' },
	        steps.map(function (val, key) {
	          if (val === 0) return null; // draft
	          if (val === 8) return null; // completed
	          var name = (0, _helpers.enumtranslate)('PaintShopOrderSteps', val);
	          // console.log('step', val, name)
	          return _react2.default.createElement(_radio2.default, { key: key, id: 'step-' + val, name: 'Step', value: val, onChange: _this3.onInputChange, checked: _this3.state.Step === val, labelText: (0, _helpers.translation)(name) });
	        })
	      );
	    }
	  }, {
	    key: 'renderDeviation',
	    value: function renderDeviation() {
	      var _this4 = this;
	
	      if (this.props.type !== 1 || !(0, _auth.hasSubscriptionPermission)(this.props.auth, 30, 20) || this.props.item.OrderType === 4 || this.props.show !== true || this.props.auth.departmentType === 1) return null;
	      // console.log('rendered anyway')
	      var GoToDeviation = function GoToDeviation(id, e) {
	        e.preventDefault();
	        _this4.onClose();
	        // console.log('Move with deviation', this.state.Step)
	        _this4.props.router.push({
	          pathname: '/pricecalculation/' + _this4.props.item.Id + '/' + id,
	          state: {
	            stepId: _this4.state.Step
	          }
	        });
	        // this.props.router.push('/pricecalculation/' + this.props.item.Id + '/' + id)
	      };
	      return _react2.default.createElement(
	        _grid2.default,
	        null,
	        _react2.default.createElement(_button2.default, { style: 'link', onClick: GoToDeviation.bind(this, 5), labelText: (0, _helpers.translation)('310') }),
	        _react2.default.createElement(_button2.default, { style: 'link', onClick: GoToDeviation.bind(this, 6), labelText: (0, _helpers.translation)('311') })
	      );
	    }
	  }, {
	    key: 'renderOther',
	    value: function renderOther() {
	      var _this5 = this;
	
	      var onChange = function onChange(e) {
	        _this5.setState({
	          comment: e.target.value
	        });
	      };
	      return _react2.default.createElement(
	        _grid2.default,
	        { cols: '1fr' },
	        _react2.default.createElement(_textarea2.default, { labelText: 15197, onChange: onChange }),
	        _react2.default.createElement(_button2.default, { labelText: this.props.type === 1 ? (0, _helpers.translation)('13481') : (0, _helpers.translation)('13479'), onClick: this.moveOrder })
	      );
	    }
	  }, {
	    key: 'renderPaintButtons',
	    value: function renderPaintButtons() {
	      var _this6 = this;
	
	      var setActionType = function setActionType(type) {
	        _this6.setState({
	          actionType: type
	        });
	      };
	      return _react2.default.createElement(
	        _grid2.default,
	        null,
	        _react2.default.createElement(_button2.default, { labelText: 16661, onClick: setActionType.bind(this, 1) }),
	        _react2.default.createElement(_button2.default, { style: 'link', labelText: 227, onClick: setActionType.bind(this, 2) })
	      );
	    }
	  }, {
	    key: 'renderViewBackward',
	    value: function renderViewBackward() {
	      var actionType = this.state.actionType;
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderAvailableSteps(),
	        _react2.default.createElement(_divider2.default, { size: 3, noLine: true }),
	        actionType === 0 && this.renderPaintButtons(),
	        actionType === 1 && this.renderDeviation(),
	        actionType === 2 && this.renderOther()
	      );
	    }
	  }, {
	    key: 'renderViewForward',
	    value: function renderViewForward() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderAvailableSteps(),
	        _react2.default.createElement(_divider2.default, { size: 3, noLine: true }),
	        _react2.default.createElement(_button2.default, { labelText: this.props.type === 1 ? (0, _helpers.translation)('13481') : (0, _helpers.translation)('13479'), onClick: this.moveOrder })
	      );
	    }
	  }, {
	    key: 'modalTitle',
	    value: function modalTitle() {
	      var item = this.props.item;
	
	      var title = '';
	
	      // Model
	      if (item.Model) {
	        title += item.Model;
	      }
	
	      // RegNumber
	      if (item.RegNumber) {
	        if (item.Model) {
	          title += ', ';
	        }
	        title += item.RegNumber;
	      }
	
	      // Title empty
	      if (title === '') {
	        title += item.Id;
	      }
	
	      return title;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var icon = this.props.type === 2 ? _icons.ModalIcons.Forward : _icons.ModalIcons.Backward;
	      return _react2.default.createElement(
	        'div',
	        { className: 'move__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: this.modalTitle(),
	            overflowHidden: this.state.overflowHidden,
	            clickOutsideClose: this.state.clickOutsideClose,
	            onClose: this.onClose,
	            icon: icon }),
	          this.props.type === 1 ? this.renderViewBackward() : this.renderViewForward()
	        )
	      );
	    }
	  }]);
	
	  return MoveModal;
	}(_react.Component);
	
	MoveModal.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  moveOrder: _orders.moveOrder,
	  getStepsBehind: _orders.getStepsBehind,
	  getStepsAhead: _orders.getStepsAhead,
	  getSteps: _orders.getSteps
	})(MoveModal);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _common = __webpack_require__(25);
	
	var _helpers = __webpack_require__(2);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Components
	
	
	var Brand = function (_Component) {
	  _inherits(Brand, _Component);
	
	  function Brand(props) {
	    _classCallCheck(this, Brand);
	
	    var _this = _possibleConstructorReturn(this, (Brand.__proto__ || Object.getPrototypeOf(Brand)).call(this, props));
	
	    _this.state = {
	      isGettingBrands: false
	    };
	    return _this;
	  }
	
	  _createClass(Brand, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.brands && this.props.brands.length > 0) {
	        this.props.updateState({
	          BrandOriginal: this.props.brands[0].Name
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.isGettingBrands) return;
	
	      if (this.props.brands === undefined || this.props.brands === null || this.props.brands.length === 0) {
	        this.setState({
	          isGettingBrands: true
	        }, function () {
	          _this2.props.getBrands().then(function (res) {
	            _this2.setState({
	              isGettingBrands: false
	            });
	          });
	        });
	      }
	    }
	  }, {
	    key: 'renderOptions',
	    value: function renderOptions() {
	      return this.props.brands.map(function (brand, key) {
	        return _react2.default.createElement(
	          'option',
	          { value: brand.Name, key: key },
	          (0, _helpers.translation)(brand.Name)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _dropDown2.default,
	        {
	          labelText: (0, _helpers.translation)('145'),
	          name: 'BrandOriginal',
	          value: this.props.selected,
	          onChange: this.props.onInputChange },
	        this.renderOptions()
	      );
	    }
	  }]);
	
	  return Brand;
	}(_react.Component);
	
	Brand.propTypes = {
	  selected: _propTypes2.default.string.isRequired,
	  onInputChange: _propTypes2.default.func.isRequired,
	  updateState: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    brands: state.common.brands
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getBrands: _common.getBrands
	})(Brand);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Components
	
	
	var ChassisNumber = function (_Component) {
	  _inherits(ChassisNumber, _Component);
	
	  function ChassisNumber(props) {
	    _classCallCheck(this, ChassisNumber);
	
	    var _this = _possibleConstructorReturn(this, (ChassisNumber.__proto__ || Object.getPrototypeOf(ChassisNumber)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ChassisNumber, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('81'), name: 'ChassisNumber', value: this.props.chassisNumber, onChange: this.props.onInputChange, autoComplete: 'off' });
	    }
	  }]);
	
	  return ChassisNumber;
	}(_react.Component);
	
	ChassisNumber.propTypes = {
	  chassisNumber: _propTypes2.default.string.isRequired,
	  onInputChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = ChassisNumber;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Extent = __webpack_require__(153);
	
	var _Extent2 = _interopRequireDefault(_Extent);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	// import Price from '../../../../pages/PriceCalculation/Price'
	
	
	// Actions
	
	
	// Utils
	
	
	var Complaint = function (_Component) {
	  _inherits(Complaint, _Component);
	
	  function Complaint(props) {
	    _classCallCheck(this, Complaint);
	
	    var _this = _possibleConstructorReturn(this, (Complaint.__proto__ || Object.getPrototypeOf(Complaint)).call(this, props));
	
	    _this.state = {};
	
	    _this.onCloseDelete = _this.onCloseDelete.bind(_this);
	    _this.chooseComplaint = _this.chooseComplaint.bind(_this);
	    _this.renderOrder = _this.renderOrder.bind(_this);
	    return _this;
	  }
	
	  _createClass(Complaint, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.updateModal({
	        headerTitle: '301',
	        onModalClose: this.onCloseDelete,
	        bottomBarProps: {
	          actionLabelText: (0, _helpers.translation)('1406'),
	          onActionClick: this.chooseComplaint
	        }
	      });
	    }
	  }, {
	    key: 'onCloseDelete',
	    value: function onCloseDelete() {
	      this.props.onModalClose();
	      if (this.props.orderdata !== undefined && this.props.orderdata.OrderId !== undefined) {
	        this.props.deleteOrder(this.props.orderdata.OrderId, 0);
	      }
	    }
	  }, {
	    key: 'chooseComplaint',
	    value: function chooseComplaint(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      var data = {
	        OldOrderId: parseInt(this.props.listingID),
	        NewOrderId: this.props.orderdata.OrderId
	      };
	
	      this.props.ConnectOrder(data).then(function (res) {
	        // Toastr
	        // window.toastr.success(translation('13439'), translation('13424'))
	        _this2.props.redirectToOrder(data.NewOrderId);
	      }, function () {
	        _this2.props.setErrors({
	          isLoading: false
	        });
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderOrder',
	    value: function renderOrder(order, index) {
	      var orderType = this.props.orderTypes[order.OrderType];
	      var orderExtent = order.OldOrderExtent;
	      var extentLines = [];
	      if (orderExtent !== null && orderExtent !== '') {
	        extentLines = orderExtent.split('\n');
	      }
	
	      var renderLine = function renderLine(val, key) {
	        return _react2.default.createElement(
	          'p',
	          { key: 'extentLine_' + key },
	          val
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { key: index },
	        _react2.default.createElement(_radio2.default, {
	          name: 'listingID',
	          value: order.OrderID,
	          checked: this.props.listingID === order.OrderID.toString(),
	          onChange: this.props.onInputChange,
	          labelText: (0, _helpers.translation)(orderType) + ', ' + (0, _time.renderFullDate)(order.Delivery)
	        }),
	        _react2.default.createElement(_Extent2.default, {
	          order: order.OrderID,
	          department: this.props.bodyShop ? 1 : 0,
	          extents: [{ type: 'base', editable: false, showEditeLink: false, noTitle: true, viewMode: 'simple' }]
	        }),
	        extentLines !== null && extentLines.length > 0 && _react2.default.createElement(
	          'div',
	          { className: 'OldOrderExtent white__box price__view' },
	          extentLines.map(renderLine)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'neworder__modal__complaint' },
	        _react2.default.createElement(
	          'label',
	          null,
	          (0, _helpers.translation)('2028')
	        ),
	        _react2.default.createElement(
	          'div',
	          { ref: 'addorderpopup' },
	          this.props.orderdata.PreviousOrders.map(this.renderOrder),
	          _react2.default.createElement(_radio2.default, { name: 'listingID', value: '0', checked: this.props.listingID === '0', onChange: this.props.onInputChange, labelText: (0, _helpers.translation)('13408') })
	        )
	      );
	    }
	  }]);
	
	  return Complaint;
	}(_react.Component);
	
	Complaint.propTypes = {
	  listingID: _propTypes2.default.string.isRequired,
	  orderdata: _propTypes2.default.object.isRequired,
	  onInputChange: _propTypes2.default.func.isRequired,
	  setErrors: _propTypes2.default.func.isRequired,
	  redirectToOrder: _propTypes2.default.func.isRequired,
	  onModalClose: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    orderTypes: state.common.enums.orderTypes
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  ConnectOrder: _orders.ConnectOrder,
	  deleteOrder: _orders.deleteOrder
	})(Complaint);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Elements
	
	
	var Customer = function (_Component) {
	  _inherits(Customer, _Component);
	
	  function Customer() {
	    _classCallCheck(this, Customer);
	
	    return _possibleConstructorReturn(this, (Customer.__proto__ || Object.getPrototypeOf(Customer)).apply(this, arguments));
	  }
	
	  _createClass(Customer, [{
	    key: 'renderOptions',
	    value: function renderOptions() {
	      return this.props.customers.filter(function (c) {
	        return c.Active && c.RelationType !== 1;
	      }).map(function (c, i) {
	        if (c.IsApromasWorkshop) {
	          return _react2.default.createElement(
	            'option',
	            { value: c.CustomerId, style: { color: 'grey' }, key: i },
	            c.Name
	          );
	        } else {
	          return _react2.default.createElement(
	            'option',
	            { value: c.CustomerId, key: i },
	            c.Name
	          );
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          allowNoCustomer = _props.allowNoCustomer,
	          bodyShop = _props.bodyShop,
	          onInputChange = _props.onInputChange,
	          selected = _props.selected;
	
	      var label = bodyShop ? '14780' : '35';
	      var customerNotSelected = null;
	      if (allowNoCustomer) {
	        customerNotSelected = _react2.default.createElement(
	          'option',
	          { value: '-1' },
	          (0, _helpers.translation)('15330')
	        );
	      }
	      return _react2.default.createElement(
	        _dropDown2.default,
	        { labelText: (0, _helpers.translation)(label), name: 'CustomerId', value: selected, onChange: onInputChange },
	        _react2.default.createElement(
	          'option',
	          { value: '0' },
	          (0, _helpers.translation)('2259')
	        ),
	        customerNotSelected,
	        this.renderOptions()
	      );
	    }
	  }]);
	
	  return Customer;
	}(_react.Component);
	
	Customer.propTypes = {
	  selected: _propTypes2.default.number.isRequired,
	  onInputChange: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    allowNoCustomer: state.auth.allowNoCustomer,
	    customers: state.common.customers
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Customer);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Elements
	
	
	var Estimation = function (_Component) {
	  _inherits(Estimation, _Component);
	
	  function Estimation(props) {
	    _classCallCheck(this, Estimation);
	
	    var _this = _possibleConstructorReturn(this, (Estimation.__proto__ || Object.getPrototypeOf(Estimation)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Estimation, [{
	    key: 'render',
	    value: function render() {
	      var canEstimate = this.props.evaluationAllowed;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('13363'), helpText: (0, _helpers.translation)('1934'), disabled: !canEstimate, id: 'estimation', name: 'Estimation', value: '1', onChange: this.props.onInputChange, checked: this.props.showComment }),
	        this.props.showComment && _react2.default.createElement(_textarea2.default, { labelText: (0, _helpers.translation)('13364'), name: 'Estimation_comment', onChange: this.props.onInputChange, value: this.props.comment })
	      );
	    }
	  }]);
	
	  return Estimation;
	}(_react.Component);
	
	Estimation.propTypes = {
	  evaluationAllowed: _propTypes2.default.bool.isRequired,
	  showComment: _propTypes2.default.bool.isRequired,
	  comment: _propTypes2.default.string.isRequired,
	  onInputChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = Estimation;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Actions
	
	
	// Utils
	
	
	var FileArea = function (_Component) {
	  _inherits(FileArea, _Component);
	
	  function FileArea(props) {
	    _classCallCheck(this, FileArea);
	
	    var _this = _possibleConstructorReturn(this, (FileArea.__proto__ || Object.getPrototypeOf(FileArea)).call(this, props));
	
	    _this.state = {
	      upload: {
	        errors: []
	      },
	      confirm: false
	    };
	
	    _this.ensureFileContainer = _this.ensureFileContainer.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onDropAccepted = _this.onDropAccepted.bind(_this);
	    _this.onDropRejected = _this.onDropRejected.bind(_this);
	    return _this;
	  }
	
	  _createClass(FileArea, [{
	    key: 'ensureFileContainer',
	    value: function ensureFileContainer() {
	      var _this2 = this;
	
	      if (this.props.fileContainerId === null) {
	        return this.props.createFileContainer().then(function (res) {
	          _this2.props.updateState({
	            fileContainerId: res.data.FileContainerId
	          });
	        });
	      } else {
	        return Promise.resolve();
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop() {
	      this.setState({ upload: _extends({}, this.state.upload, { errors: [] }) });
	    }
	  }, {
	    key: 'onDropAccepted',
	    value: function onDropAccepted(files) {
	      var _this3 = this;
	
	      var documents = [].concat(_toConsumableArray(this.props.files));
	      var images = [].concat(_toConsumableArray(this.props.images));
	
	      this.ensureFileContainer().then(function () {
	        _this3.props.uploadMultipleFiles(files, 0, undefined, undefined, _this3.props.fileContainerId).then(function (fileResponse) {
	          var uploadedFiles = fileResponse.data;
	          uploadedFiles.forEach(function (file, index) {
	            if (file.IsImage) {
	              images.push({
	                imageUrl: _constants.FILE_STORAGE + '/OrderFiles/' + file.RealFileURL,
	                ImageSize: {
	                  Width: 0,
	                  Height: 0
	                },
	                OrderFileID: file.OrderFileID,
	                circles: [],
	                ImageType: 2,
	                base64: files[index].imageUrl,
	                rotation: 0
	              });
	            } else {
	              documents.push({
	                OrderFileID: file.OrderFileID,
	                FileName: file.FileURL,
	                name: file.FileName,
	                ImageType: -1
	              });
	            }
	          });
	          _this3.props.updateState({
	            images: images,
	            files: documents
	          });
	          // createOrder(finishedFiles, IsEvaluation, evaluationComment)
	        }, function () {
	          _this3.props.setErrors({
	            isLoading: false
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13440'), (0, _helpers.translation)('216'));
	        });
	      });
	    }
	  }, {
	    key: 'onDropRejected',
	    value: function onDropRejected(files) {
	      var newErrors = files.map(function (file) {
	        return 'File: ' + file.name + ' is not allowed.';
	      });
	      this.setState({ upload: _extends({}, this.state.upload, { errors: newErrors }) });
	    }
	  }, {
	    key: 'renderFiles',
	    value: function renderFiles() {
	      var _this4 = this;
	
	      var files = this.props.files;
	
	      var removeFile = function removeFile(index) {
	        var oldFiles = _this4.props.files;
	        var newFiles = [].concat(_toConsumableArray(oldFiles)).filter(function (item, i) {
	          return i !== index;
	        });
	
	        _this4.props.updateState({
	          files: newFiles
	        });
	      };
	
	      var renderFile = function renderFile(file, index) {
	        if (file.file === null) return null;
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.name;
	
	        // let newFileUrl = API_URL + '/FileService/DownloadNoHeader?fileName=' + file.ActualFileName + '&token=' + this.props.auth.user.Token
	        // let thumbUrl = API_URL + '/FileService/DownloadNoHeader?fileName=' + file.ThumbURL + '&token=' + this.props.auth.user.Token
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-document clearfix' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          _react2.default.createElement(
	            'span',
	            null,
	            file.name
	          ),
	          _this4.props.auth.user.CustomerId === '-1' && _react2.default.createElement('img', { className: 'file-delete', src: '/images/icons/Delete_16.png', onClick: function onClick() {
	              return removeFile(index);
	            } })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'estimation_documents' },
	        files.map(renderFile)
	      );
	    }
	  }, {
	    key: 'deleteImage',
	    value: function deleteImage(image, index) {
	      this.setState({
	        confirm: index
	      });
	    }
	  }, {
	    key: 'renderImages',
	    value: function renderImages() {
	      var _this5 = this;
	
	      var images = this.props.images;
	      // Render image
	
	      var renderImage = function renderImage(image, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          _react2.default.createElement(
	            'div',
	            { className: 'delete' },
	            _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	                return _this5.deleteImage(image, index);
	              }, size: 's' })
	          ),
	          _react2.default.createElement('img', { src: image.base64, onClick: function onClick() {
	              return _this5.goToImage(image, index);
	            } })
	        );
	      };
	      // Confirm
	      var onPortalClose = function onPortalClose() {
	        _this5.setState({
	          confirm: false
	        });
	      };
	      var onConfirm = function onConfirm() {
	        var images = [].concat(_toConsumableArray(_this5.props.images));
	        images.splice(_this5.state.confirm, 1);
	
	        _this5.props.updateState({ images: images });
	        _this5.setState({ confirm: false });
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'estimation_images' },
	        _react2.default.createElement(_Gallery2.default, { files: images, renderImage: renderImage }),
	        this.state.confirm !== false && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onPortalClose })
	        )
	      );
	    }
	  }, {
	    key: 'goToImage',
	    value: function goToImage(image, index) {
	      var _this6 = this;
	
	      this.props.updateState({
	        activeImage: {
	          image: image,
	          index: index
	        }
	      }, function () {
	        _this6.props.updateModal({
	          tabView: 'image'
	        });
	      });
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError(error, key) {
	      return _react2.default.createElement(
	        'p',
	        { key: key },
	        error
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var errors = this.state.upload.errors;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'clearfix' },
	        errors.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          errors.map(this.renderError)
	        ),
	        _react2.default.createElement(
	          _Dropzone2.default,
	          {
	            onDrop: this.onDrop,
	            onDropAccepted: this.onDropAccepted,
	            onDropRejected: this.onDropRejected,
	            includeCircles: true },
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)('13397')
	          )
	        ),
	        this.renderFiles(),
	        this.renderImages()
	      );
	    }
	  }]);
	
	  return FileArea;
	}(_react.Component);
	
	FileArea.propTypes = {
	  files: _propTypes2.default.array.isRequired,
	  images: _propTypes2.default.array.isRequired,
	  updateState: _propTypes2.default.func.isRequired,
	  updateModal: _propTypes2.default.func.isRequired,
	  setErrors: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createFileContainer: _orders.createFileContainer,
	  uploadMultipleFiles: _orders.uploadMultipleFiles,
	  uploadImageMarkings: _orders.uploadImageMarkings
	})(FileArea);

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	// import HelpText from '../../../components/HelpText'
	
	// Actions
	
	
	// Utils
	
	
	// Components
	
	// import LabelWrapper from '../../../elements/labelWrapper'
	
	
	var Forsi = function (_Component) {
	  _inherits(Forsi, _Component);
	
	  function Forsi(props) {
	    _classCallCheck(this, Forsi);
	
	    var _this = _possibleConstructorReturn(this, (Forsi.__proto__ || Object.getPrototypeOf(Forsi)).call(this, props));
	
	    _this.state = {
	      ForsiID: '',
	      forsiIsLoading: false
	    };
	
	    _this.renderButtonText = _this.renderButtonText.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onButtonClick = _this.onButtonClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Forsi, [{
	    key: 'renderButtonText',
	    value: function renderButtonText(text) {
	      if (this.state.forsiIsLoading) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'animated-background' },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-x fa-fw', style: { lineHeight: '13px' } })
	        );
	      }
	      return (0, _helpers.translation)(text);
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.setState({
	        ForsiID: e.target.value
	      });
	    }
	  }, {
	    key: 'onButtonClick',
	    value: function onButtonClick(e) {
	      var _this2 = this;
	
	      if (typeof e.key === 'undefined' || e.key === 'Enter') {
	        e.preventDefault();
	        if (this.state.ForsiID === '') {
	          window.toastr.error((0, _helpers.translation)('13428'), (0, _helpers.translation)('216'));
	          return false;
	        }
	        this.state.ForsiID = this.state.ForsiID.replace(' ', '');
	        this.setState(_extends({}, this.state, {
	          forsiIsLoading: true
	        }));
	        this.props.getForsiData(this.state.ForsiID).then(function (res) {
	          _this2.setState(_extends({}, _this2.state, {
	            forsiIsLoading: false
	          }));
	          if (res.data.AddedOrderId !== 0) {
	            _this2.props.redirectToOrder(res.data.AddedOrderId);
	          } else {
	            if (res.data.Error !== undefined && res.data.Error !== null) {
	              var errorString = (0, _helpers.translation)(res.data.Error.DictionaryKey);
	              if (errorString.indexOf('[orderstep]') !== -1) {
	                errorString = errorString.replace('[orderstep]', res.data.Error.Parameters[0]);
	              }
	              if (errorString.indexOf('[chainName]') !== -1) {
	                errorString = errorString.replace('[chainName]', res.data.Error.Parameters[0]);
	              }
	              window.toastr.error(errorString, (0, _helpers.translation)('216'));
	            } else {
	              window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	            }
	          }
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	          _this2.setState(_extends({}, _this2.state, {
	            forsiIsLoading: false
	          }));
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var helpText = '1933'; // FORSI
	      if (this.props.auth.permissions.ChainAssessmentSystem === 2) helpText = '18041'; // DBS
	
	      return _react2.default.createElement(
	        'form',
	        { autoComplete: 'off' },
	        _react2.default.createElement(_text2.default, {
	          labelText: (0, _helpers.translation)('13427'),
	          helpText: (0, _helpers.translation)(helpText),
	          name: 'ForsiID',
	          value: this.state.ForsiID,
	          onChange: this.onInputChange
	          // autoComplete='off'
	          , onKeyPress: this.onButtonClick }),
	        _react2.default.createElement(_button2.default, {
	          labelText: this.renderButtonText('2038'),
	          onClick: this.onButtonClick,
	          style: 'link'
	        }),
	        _react2.default.createElement(_divider2.default, null)
	      );
	    }
	  }]);
	
	  return Forsi;
	}(_react.Component);
	
	Forsi.propTypes = {
	  getForsiData: _propTypes2.default.func.isRequired,
	  redirectToOrder: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getForsiData: _orders.getForsiData
	})(Forsi);

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CircleImage = __webpack_require__(231);
	
	var _CircleImage2 = _interopRequireDefault(_CircleImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var MarkImage = function (_Component) {
	  _inherits(MarkImage, _Component);
	
	  function MarkImage(props) {
	    _classCallCheck(this, MarkImage);
	
	    var _this = _possibleConstructorReturn(this, (MarkImage.__proto__ || Object.getPrototypeOf(MarkImage)).call(this, props));
	
	    _this.state = {
	      imageSubmitted: false
	    };
	
	    _this.submitImage = _this.submitImage.bind(_this);
	    _this.onCircleImageClose = _this.onCircleImageClose.bind(_this);
	    _this.circleDrag = _this.circleDrag.bind(_this);
	    return _this;
	  }
	
	  _createClass(MarkImage, [{
	    key: 'submitImage',
	    value: function submitImage(image) {
	      var _this2 = this;
	
	      var images = [].concat(_toConsumableArray(this.props.images));
	      images[image.index] = image.image;
	
	      this.setState({ imageSubmitted: true }, function () {
	        _this2.props.updateState({ images: images });
	        _this2.props.updateModal({
	          tabView: 'draft'
	        });
	      });
	    }
	  }, {
	    key: 'onCircleImageClose',
	    value: function onCircleImageClose(image) {
	      if (!this.state.imageSubmitted) {
	        var images = [].concat(_toConsumableArray(this.props.images));
	        images[image.index] = image.image;
	
	        this.props.updateState({ images: images });
	        this.props.updateModal({
	          tabView: 'draft'
	        });
	      } else {
	        this.setState({
	          imageSubmitted: false
	        });
	      }
	    }
	  }, {
	    key: 'circleDrag',
	    value: function circleDrag(active) {
	      this.props.updateModal({ overflowHidden: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_CircleImage2.default, {
	        submitImage: this.submitImage,
	        image: this.props.currentImg,
	        onDrag: this.circleDrag,
	        onCircleImageClose: this.onCircleImageClose });
	    }
	  }]);
	
	  return MarkImage;
	}(_react.Component);
	
	MarkImage.propTypes = {
	  currentImg: _propTypes2.default.object.isRequired,
	  images: _propTypes2.default.array.isRequired,
	  updateState: _propTypes2.default.func.isRequired,
	  updateModal: _propTypes2.default.func.isRequired
	};
	
	exports.default = MarkImage;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Elements
	
	
	var OrderTypes = function (_Component) {
	  _inherits(OrderTypes, _Component);
	
	  function OrderTypes(props) {
	    _classCallCheck(this, OrderTypes);
	
	    var _this = _possibleConstructorReturn(this, (OrderTypes.__proto__ || Object.getPrototypeOf(OrderTypes)).call(this, props));
	
	    _this.state = {};
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderTypes, [{
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var value = e.target.value;
	
	
	      if (value === '5' || value === '4') {
	        this.props.updateState({
	          evaluationAllowed: false,
	          Estimation: '0'
	        });
	      } else {
	        this.props.updateState({
	          evaluationAllowed: true
	        });
	      }
	
	      this.props.onInputChange(e);
	    }
	  }, {
	    key: 'renderOrderType',
	    value: function renderOrderType(type, dictionaryKey, img, inline) {
	      var display = this.props.bodyShop ? 'display_img' : '';
	      var id = 'order_type-' + type;
	      var label = _react2.default.createElement(
	        _grid2.default,
	        { cols: ['min-content', 1] },
	        _react2.default.createElement(
	          'span',
	          { className: display },
	          _react2.default.createElement(_icon2.default, { icon: img })
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)(dictionaryKey)
	        )
	      );
	
	      return _react2.default.createElement(_radio2.default, { labelText: label, id: id, size: 'm', name: 'OrderType', value: type, onChange: this.onInputChange, checked: this.props.selected === type });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: 525 },
	        this.renderOrderType('1', '13360', _icons.OrderTypeIcons.Insurance_black, true),
	        this.renderOrderType('2', '71', _icons.OrderTypeIcons.Salescar_black, true),
	        this.renderOrderType('3', '13361', _icons.OrderTypeIcons.Garanteed_black, true),
	        this.renderOrderType('6', '785', _icons.OrderTypeIcons.Private_black, true),
	        this.renderOrderType('4', '14980', _icons.OrderTypeIcons.Other_black, true),
	        this.renderOrderType('5', '301', _icons.OrderTypeIcons.Complaint_black, true)
	      );
	    }
	  }]);
	
	  return OrderTypes;
	}(_react.Component);
	
	OrderTypes.propTypes = {
	  selected: _propTypes2.default.string.isRequired,
	  onInputChange: _propTypes2.default.func.isRequired,
	  updateState: _propTypes2.default.func.isRequired
	};
	
	exports.default = OrderTypes;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Components
	
	
	var RegistrationNumber = function (_Component) {
	  _inherits(RegistrationNumber, _Component);
	
	  function RegistrationNumber(props) {
	    _classCallCheck(this, RegistrationNumber);
	
	    var _this = _possibleConstructorReturn(this, (RegistrationNumber.__proto__ || Object.getPrototypeOf(RegistrationNumber)).call(this, props));
	
	    _this.state = {
	      searchInputChanged: false,
	      regNumberText: 0
	    };
	
	    _this.searchBrandVin = _this.searchBrandVin.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(RegistrationNumber, [{
	    key: 'searchBrandVin',
	    value: function searchBrandVin(e) {
	      var _this2 = this;
	
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	      console.log('here');
	
	      if (!value) return;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) return;
	      if (!this.state.searchInputChanged) return;
	
	      this.setState({ ExtraData: {} });
	      this.props.getOrderVehicleData(value, name).then(function (res) {
	        if (res.data.BrandOriginal !== null) {
	          _this2.props.updateState({
	            RegNumber: res.data.RegNr,
	            ChassisNumber: res.data.ChassisNumber,
	            BrandOriginal: res.data.BrandName,
	            ExtraData: res.data
	          });
	
	          _this2.setState({
	            searchInputChanged: false,
	            regNumberText: res.data.DictionaryKey
	          });
	
	          if (![0, 1153].includes(res.data.DictionaryKey)) {
	            // display if not empty or "Order with that reg. nr. already exists"
	            // Toastr
	            window.toastr.info((0, _helpers.translation)(res.data.DictionaryKey));
	          }
	        }
	      }, function (err) {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      if (e.target.value !== this.props.regNr) {
	        this.setState({
	          searchInputChanged: true
	        });
	      }
	
	      this.props.onInputChange(e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var displayError = this.state.regNumberText === 1153; // "Order with that reg. nr. already exists"
	
	      return _react2.default.createElement(_text2.default, {
	        redBorder: displayError,
	        labelText: (0, _helpers.translation)('78'),
	        name: 'RegNumber',
	        value: this.props.regNr,
	        onBlur: this.searchBrandVin,
	        onChange: this.onInputChange,
	        autoComplete: 'off',
	        errorText: displayError ? (0, _helpers.translation)(this.state.regNumberText) : null
	      });
	    }
	  }]);
	
	  return RegistrationNumber;
	}(_react.Component);
	
	RegistrationNumber.propTypes = {
	  regNr: _propTypes2.default.string.isRequired,
	  updateState: _propTypes2.default.func.isRequired,
	  onInputChange: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrderVehicleData: _orders.getOrderVehicleData
	})(RegistrationNumber);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1660);
	
	var _orders = __webpack_require__(21);
	
	var _constants = __webpack_require__(5);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _CircleImage = __webpack_require__(231);
	
	var _CircleImage2 = _interopRequireDefault(_CircleImage);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _icons = __webpack_require__(6);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Constants
	
	
	// import components
	
	
	// Elements
	
	
	// Utils
	
	
	var PhotoDocModal = function (_Component) {
	  _inherits(PhotoDocModal, _Component);
	
	  function PhotoDocModal(props) {
	    _classCallCheck(this, PhotoDocModal);
	
	    var _this = _possibleConstructorReturn(this, (PhotoDocModal.__proto__ || Object.getPrototypeOf(PhotoDocModal)).call(this, props));
	
	    _this.state = {
	      tabView: 'step1',
	      confirm: false,
	      overflowHidden: false,
	      images: [],
	      upload: {
	        shouldCapture: true,
	        errors: []
	      },
	      activeImage: {},
	      Comment: '',
	      fileContainerId: null,
	      Step: 0,
	      isCircleimageOpen: false,
	      newOrderModalWidth: 0,
	      firstRender: true,
	      imageSubmitted: false,
	      imageUploadsStarted: 0,
	      imageUploadsCompleted: 0,
	      selectedImages: {}
	    };
	    _this.onClose = _this.onClose.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    // Image
	    _this.submitImage = _this.submitImage.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onDropAccepted = _this.onDropAccepted.bind(_this);
	    _this.onDropRejected = _this.onDropRejected.bind(_this);
	    _this.uploadImages = _this.uploadImages.bind(_this);
	    _this.onCircleImageClose = _this.onCircleImageClose.bind(_this);
	    _this.checkboxChange = _this.checkboxChange.bind(_this);
	    _this.t = _this.t.bind(_this);
	    return _this;
	  }
	
	  _createClass(PhotoDocModal, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.firstRender) {
	        var newOrderModalWidth = void 0;
	        if (document.getElementsByClassName('modal__container')[0] !== undefined) {
	          newOrderModalWidth = document.getElementsByClassName('modal__container')[0].getBoundingClientRect().width;
	        }
	        this.setState({
	          newOrderModalWidth: newOrderModalWidth,
	          firstRender: false
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var images = [];
	      this.props.getOrderFiles(this.props.item.Id, 1).then(function (res) {
	        res.data.forEach(function (element) {
	          images.push({
	            imagePath: _constants.FILE_STORAGE + element.FileURL,
	            thumbPath: _constants.FILE_STORAGE + element.ThumbURL,
	            OrderFileID: element.OrderFileID
	          });
	        }, _this2);
	        _this2.setState({
	          images: images
	        });
	      });
	
	      this.setState({
	        Step: this.props.stepId || this.props.item.StepId
	      });
	
	      this.props.createFileContainer().then(function (res) {
	        _this2.setState({
	          fileContainerId: res.data.FileContainerId
	        });
	      });
	    }
	  }, {
	    key: 't',
	    value: function t(val) {
	      if (typeof _helpers.translation !== 'undefined') {
	        return (0, _helpers.translation)(val);
	      }
	      return this.props.t(val);
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var value = e.target.value;
	      if (e.target.name === 'Step') {
	        value = parseInt(value);
	      }
	      this.setState(_defineProperty({}, e.target.name, value));
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      if (this.state.tabView === 'step2') {
	        this.setState({
	          tabView: 'step1'
	        });
	      } else {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'checkboxChange',
	    value: function checkboxChange(e) {
	      // let input
	      // if (e.target.tagName === 'DIV') {
	      //   // if div click
	      //   input = e.target.children[0]
	      //   input.checked = !input.checked
	      //   console.log('checkboxChange DIV')
	      // } else if (e.target.tagName === 'B') {
	      //   // if b click
	      //   input = e.target.parentElement.children[0]
	      //   input.checked = !input.checked
	      //   console.log('checkboxChange B')
	      // } else if (e.target.tagName === 'INPUT') {
	      //   // if input click
	      //   input = e.target
	      //   input.checked = !input.checked
	      //   console.log('checkboxChange INPUT')
	      // }
	      this.setState({ selectedImages: _extends({}, this.state.selectedImages, _defineProperty({}, e.target.id, e.target.checked)) });
	    }
	  }, {
	    key: 'renderImages',
	    value: function renderImages() {
	      var _this3 = this;
	
	      var images = this.state.images;
	      // Render image
	
	      var renderImage = function renderImage(image, index) {
	        if (image.imageUrl !== undefined) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'div',
	                { className: 'delete' },
	                _react2.default.createElement(_removeButton2.default, _extends({}, _this3.props, { onClick: function onClick() {
	                    return _this3.deleteImage(image, index);
	                  }, size: 's' }))
	              ),
	              _react2.default.createElement('img', { className: 'img2', id: image.OrderFileID, src: image.base64, onClick: function onClick() {
	                  return _this3.goToImage(image, index);
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'divCheckbox' },
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: _this3.t('1218'), id: image.OrderFileID, name: 'checkbox_image', checked: true, disabled: true })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'a',
	                { href: image.imagePath, 'data-lightbox': 'gallery' },
	                _react2.default.createElement('img', { className: 'img3', id: image.OrderFileID, name: 'oldImages', src: image.thumbPath })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'divCheckbox' },
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: _this3.t('1218'), id: image.OrderFileID, name: 'checkbox_image', checked: _this3.state.selectedImages[image.OrderFileID] === true, onChange: _this3.checkboxChange })
	            )
	          );
	        }
	      };
	      // Confirm
	      var onPortalClose = function onPortalClose() {
	        _this3.setState({
	          confirm: false
	        });
	      };
	      var onConfirm = function onConfirm() {
	        var images = [].concat(_toConsumableArray(_this3.state.images));
	        images.splice(_this3.state.confirm, 1);
	        _this3.setState({
	          confirm: false,
	          images: images
	        });
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Gallery2.default, { files: images, renderImage: renderImage }),
	        this.state.confirm !== false && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', t: this.props.t, onPortalClose: onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onPortalClose })
	        )
	      );
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop() {
	      this.setState({ upload: _extends({}, this.state.upload, { errors: [] }) });
	    }
	  }, {
	    key: 'onDropAccepted',
	    value: function onDropAccepted(files) {
	      var _this4 = this;
	
	      this.setState({ imageUploadsStarted: this.state.imageUploadsStarted + files.length });
	      this.props.uploadMultipleFiles(files, 0, undefined, undefined, this.state.fileContainerId).then(function (fileResponse) {
	        var newImages = [].concat(_toConsumableArray(_this4.state.images));
	        var uploadedFiles = fileResponse.data;
	        uploadedFiles.map(function (val, index) {
	          if (val.IsImage) {
	            newImages.push({
	              imageUrl: _constants.FILE_STORAGE + val.FileURL,
	              ImageSize: {
	                Width: 0,
	                Height: 0
	              },
	              OrderFileID: val.OrderFileID,
	              circles: [],
	              ImageType: 2,
	              base64: files[index].imageUrl,
	              rotation: 0
	            });
	          }
	        });
	        newImages.map(function (val) {
	          if (typeof val.ImageSize === 'undefined') {
	            val.ImageSize = {
	              Width: 0,
	              Height: 0
	            };
	          }
	        });
	        _this4.setState({ images: newImages, imageUploadsCompleted: _this4.state.imageUploadsCompleted + files.length });
	      }).catch(function () {
	        _this4.setState({ imageUploadsCompleted: _this4.state.imageUploadsCompleted + files.length });
	      });
	    }
	  }, {
	    key: 'onDropRejected',
	    value: function onDropRejected(files) {
	      var _this5 = this;
	
	      var newErrors = [];
	      files.map(function (val, index) {
	        newErrors.push(_this5.t('1207') + ': ' + val.name + ' ' + _this5.t('13405') + '.');
	      });
	      this.setState({ upload: _extends({}, this.state.upload, { errors: newErrors }) });
	    }
	  }, {
	    key: 'goToImage',
	    value: function goToImage(image, index) {
	      this.setState({
	        tabView: 'step2',
	        isCircleimageOpen: true,
	        activeImage: {
	          image: image,
	          index: index
	        }
	      });
	    }
	  }, {
	    key: 'submitImage',
	    value: function submitImage(image) {
	      var images = [].concat(_toConsumableArray(this.state.images));
	      images[image.index] = image.image;
	      this.setState({
	        tabView: 'step1',
	        images: images,
	        isCircleimageOpen: false,
	        imageSubmitted: true
	      });
	    }
	  }, {
	    key: 'onCircleImageClose',
	    value: function onCircleImageClose(image) {
	      if (!this.state.imageSubmitted) {
	        var images = [].concat(_toConsumableArray(this.state.images));
	        images[image.index] = image.image;
	        this.setState({
	          tabView: 'step1',
	          images: images,
	          isCircleimageOpen: false
	        });
	      } else {
	        this.setState({
	          imageSubmitted: false
	        });
	      }
	    }
	  }, {
	    key: 'deleteImage',
	    value: function deleteImage(image, index) {
	      this.setState({
	        confirm: index
	      });
	    }
	  }, {
	    key: 'uploadImages',
	    value: function uploadImages(e) {
	      var _this6 = this;
	
	      e.preventDefault();
	      if (this.state.imageUploadsStarted !== this.state.imageUploadsCompleted) {
	        return window.toastr.error(this.t('15335'), this.t('216'));
	      }
	      var checkErrors = function checkErrors() {
	        var inp = document.getElementsByTagName('input');
	        for (var i = 0; i < inp.length; i++) {
	          if (inp[i].name === 'checkbox_image' && inp[i].checked === true) {
	            return false;
	          }
	        }
	        return true;
	      };
	
	      var error = checkErrors();
	      if (error) return window.toastr.error(this.t('2031'), this.t('216'));
	
	      var finishedFiles = [];
	      var orderFileIds = [];
	      var imageMarkings = [];
	      var uploadedFiles = this.state.images;
	
	      uploadedFiles.map(function (val, index) {
	        var markings = [];
	        if (_this6.state.images[index].circles !== undefined) {
	          _this6.state.images[index].circles.map(function (circle, circleIdx) {
	            markings.push({
	              PositionX: circle.left,
	              PositionY: circle.top,
	              Scale: parseFloat(circle.scale.toFixed(2)),
	              Size: 50
	            });
	          });
	        }
	        if (markings.length !== 0 || val.rotation !== 0 && val.rotation !== undefined) {
	          imageMarkings.push({
	            ImageSize: _this6.state.images[index].ImageSize,
	            OrderFileID: val.OrderFileID,
	            Markings: markings,
	            Rotation: val.rotation
	          });
	        }
	      });
	      var inputs = document.getElementsByClassName('gallery')[0].getElementsByTagName('input');
	      for (var i = 0; i < inputs.length; i++) {
	        if (inputs[i].name === 'checkbox_image' && inputs[i].checked === true) {
	          finishedFiles.push({
	            OrderFileId: inputs[i].id
	          });
	          orderFileIds.push(inputs[i].id);
	        }
	      }
	      // imageMarkings[0].ImageSize.Width = 1000
	      // imageMarkings[0].ImageSize.Height = 500
	
	      this.props.createPhotoDoc({
	        FileContainerId: this.state.fileContainerId,
	        OrderId: this.props.item.Id,
	        Images: finishedFiles,
	        Step: this.state.Step,
	        OrderNote: {
	          OrderNoteId: 0,
	          Note: this.state.Comment
	        }
	      }).then(function (res) {
	        if (imageMarkings.length !== 0) {
	          _this6.props.uploadImageMarkings(imageMarkings);
	        }
	        _this6.props.UpdateOrderFileSelection({
	          OrderFileIds: orderFileIds,
	          Type: 1,
	          Step: _this6.state.Step,
	          TypeId: res.data.OrderNote.OrderNoteId,
	          QualityCheckPhotoStart: _this6.props.QualityCheckPhotoStart === true,
	          QualityCheckPhotoEnd: _this6.props.QualityCheckPhotoEnd === true
	        }).then(function (res) {
	          if (_this6.props.setImages !== undefined) {
	            _this6.props.setImages();
	          }
	        }, function () {
	          return window.toastr.error(_this6.t('960'), _this6.t('216'));
	        });
	        _this6.props.onClose();
	        // window.toastr.success(this.t('2032'), this.t('13424'))
	      }, function () {
	        return window.toastr.error(_this6.t('960'), _this6.t('216'));
	      });
	    }
	  }, {
	    key: 'renderStep1',
	    value: function renderStep1() {
	      var _this7 = this;
	
	      var errors = this.state.upload.errors;
	
	      var disabledSteps = this.props.QualityCheckPhotoStart === true || this.props.QualityCheckPhotoEnd === true;
	      var renderError = function renderError(error, index) {
	        return _react2.default.createElement(
	          'p',
	          { key: index },
	          error
	        );
	      };
	      var createStep = function createStep(key, name) {
	        return {
	          key: key,
	          name: name
	        };
	      };
	      // Render order steps
	      var orderStepIds = [1, 101, 102, 105, 2, 3, 4, 5, 6, 103, 104, 7];
	      var shopOrderSteps = [];
	      orderStepIds.map(function (stepId) {
	        switch (stepId) {
	          case 1:
	            shopOrderSteps.push(createStep(stepId, 164));
	            break;
	          case 101:
	            if (_this7.props.auth.departmentType === 1 || _this7.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 617));
	            break;
	          case 102:
	            if (_this7.props.auth.departmentType === 1 || _this7.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 618));
	            break;
	          case 105:
	            if (_this7.props.auth.departmentType === 1) shopOrderSteps.push(createStep(stepId, 161));
	            break;
	          case 2:
	            if (_this7.props.auth.departmentType === 0 || _this7.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 96));
	            break;
	          case 3:
	            if (_this7.props.auth.departmentType === 0 || _this7.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 160));
	            break;
	          case 4:
	            if (_this7.props.auth.departmentType === 0 || _this7.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 158));
	            break;
	          case 5:
	            if (_this7.props.auth.departmentType === 0 || _this7.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 161));
	            break;
	          case 6:
	            if (_this7.props.auth.departmentType === 0 || _this7.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 162));
	            break;
	          case 103:
	            if (_this7.props.auth.departmentType === 1 || _this7.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 619));
	            break;
	          case 104:
	            if (_this7.props.auth.departmentType === 1 || _this7.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 162));
	            break;
	          case 7:
	            shopOrderSteps.push(createStep(stepId, 163));
	            break;
	        }
	      });
	      var renderStep = function renderStep(stepId, name) {
	        var inputId = 'step-' + stepId;
	        var value = '' + stepId;
	        var labelText = name;
	        return _react2.default.createElement(_radio2.default, { id: inputId, name: 'Step', value: value, onChange: _this7.onInputChange, checked: _this7.state.Step === stepId, disabled: disabledSteps, labelText: labelText, key: stepId });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        shopOrderSteps.map(function (step) {
	          return renderStep(step.key, _this7.t(step.name));
	        }),
	        errors.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          errors.map(renderError)
	        ),
	        _react2.default.createElement(
	          _Dropzone2.default,
	          {
	            onDrop: this.onDrop,
	            onDropAccepted: this.onDropAccepted,
	            onDropRejected: this.onDropRejected,
	            includeCircles: true },
	          _react2.default.createElement(
	            'p',
	            null,
	            this.t('13397')
	          )
	        ),
	        this.renderImages(),
	        _react2.default.createElement(_textarea2.default, { name: 'Comment', onChange: this.onInputChange, value: this.state.Comment, labelText: this.t('149') })
	      );
	    }
	  }, {
	    key: 'renderStep2',
	    value: function renderStep2() {
	      var _this8 = this;
	
	      var circleDrag = function circleDrag(active) {
	        _this8.setState({ overflowHidden: active });
	      };
	
	      return _react2.default.createElement(_CircleImage2.default, {
	        submitImage: this.submitImage,
	        image: this.state.activeImage,
	        onDrag: circleDrag,
	        onCircleImageClose: this.onCircleImageClose,
	        newOrderModalWidth: this.state.newOrderModalWidth,
	        t: this.t });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalClass = 'photodoc__modal';
	      var tabView = _react2.default.createElement('div', null);
	      var bottomBarProps = null;
	      if (this.state.tabView === 'step1') {
	        tabView = this.renderStep1();
	        bottomBarProps = {
	          actionLabelText: this.t('791'),
	          onActionClick: this.uploadImages,
	          disabled: this.props.uploads.inProgress
	        };
	      } else if (this.state.tabView === 'step2') {
	        tabView = this.renderStep2();
	      }
	
	      var titleText = this.t('2065');
	      if (this.state.isCircleimageOpen) {
	        modalClass = 'circleimage_modal';
	        titleText = this.t('15051');
	      }
	
	      var clickOutsideClose = false;
	      return _react2.default.createElement(
	        'div',
	        { className: modalClass },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            isLoading: this.props.uploads.inProgress,
	            icon: _icons.ModalIcons.Camera,
	            header: titleText,
	            overflowHidden: this.state.overflowHidden,
	            clickOutsideClose: clickOutsideClose,
	            onClose: this.onClose,
	            bottomBarProps: bottomBarProps
	          }),
	          tabView,
	          _react2.default.createElement('div', { style: { clear: 'both' } })
	        )
	      );
	    }
	  }]);
	
	  return PhotoDocModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    paintShopOrderSteps: state.common.enums_new.PaintShopOrderSteps,
	    auth: state.auth,
	    uploads: state.uploads
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  uploadMultipleFiles: _orders.uploadMultipleFiles,
	  createPhotoDoc: _orders.createPhotoDoc,
	  uploadImageMarkings: _orders.uploadImageMarkings,
	  getOrderFiles: _orders.getOrderFiles,
	  UpdateOrderFileSelection: _orders.UpdateOrderFileSelection,
	  DeleteExifData: _orders.DeleteExifData,
	  createFileContainer: _orders.createFileContainer,
	  rotateImages: _orders.rotateImages
	})(PhotoDocModal);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1663);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _time = __webpack_require__(17);
	
	var _priceModel = __webpack_require__(75);
	
	var _helpers = __webpack_require__(2);
	
	var _tableHeader = __webpack_require__(132);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	// import { hasAccess } from '../../../utils/auth'
	
	// import utils
	
	
	// Actions
	
	
	// Utils
	
	
	var PriceModelLogModal = function (_Component) {
	  _inherits(PriceModelLogModal, _Component);
	
	  function PriceModelLogModal(props) {
	    _classCallCheck(this, PriceModelLogModal);
	
	    var _this = _possibleConstructorReturn(this, (PriceModelLogModal.__proto__ || Object.getPrototypeOf(PriceModelLogModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      price: {},
	      log: [{
	        ChangeTable: 0,
	        ChangeTableId: 0,
	        ChangeField: 0,
	        PartItemId: 0,
	        ChangeType: 0,
	        ChangedById: 0,
	        ChangedByName: null,
	        ChangedAt: '',
	        From: 0,
	        To: 0,
	        FromText: null,
	        ToText: null
	      }]
	      // this.renderForm = this.renderForm.bind(this)
	    };_this.getPriceModelLog = _this.getPriceModelLog.bind(_this);
	    return _this;
	  }
	
	  _createClass(PriceModelLogModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPriceModelLog(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.getPriceModelLog(nextProps);
	    }
	  }, {
	    key: 'getPriceModelLog',
	    value: function getPriceModelLog(props) {
	      var _this2 = this;
	
	      var id = props.priceModelId;
	      var userId = null;
	      var fromTime = null;
	      var toTime = null;
	
	      props.getPriceModelLog(id, userId, fromTime, toTime).then(function (res) {
	        _this2.setState({
	          log: res.data
	        });
	      }, function () {
	        // Toastr
	        // window.toastr.error(translation('13445'), translation('216'))
	        // this.props.onShouldUpdate()
	      });
	    }
	  }, {
	    key: 'renderPriceModelLog',
	    value: function renderPriceModelLog() {
	      // Do not render if estimation type model
	      // if (this.state.price.PriceType === 5) return null
	      // if (this.props.partners) {
	      //   if (hasAccess([2], this.props.auth.user.UserType)) {
	      //     return null
	      //   }
	      // }
	
	      var log = this.state.log;
	      var hasData = log !== undefined;
	
	      var renderLogLine = function renderLogLine(val, key) {
	        var changeText = (0, _helpers.translation)('1868');
	        var addedText = (0, _helpers.translation)('1869');
	        var removedText = (0, _helpers.translation)('1870');
	
	        var text = '';
	        var fieldName = '';
	        var tableName = '';
	        var fromVal = '';
	        var toVal = '';
	        if (val.FromText !== null && val.FromText !== '') {
	          fromVal = val.FromText;
	          if (val.ChangeField === 18 || val.ChangeField === 23) {
	            fromVal = fromVal === 'True' ? (0, _helpers.translation)('13553') : (0, _helpers.translation)('13554');
	          }
	        } else {
	          fromVal = val.From;
	        }
	        if (val.ToText !== null && val.ToText !== '') {
	          toVal = val.ToText;
	          if (val.ChangeField === 18 || val.ChangeField === 23) {
	            toVal = toVal === 'True' ? (0, _helpers.translation)('13553') : (0, _helpers.translation)('13554');
	          }
	        } else {
	          toVal = val.To;
	        }
	
	        var changedBy = val.ChangedByName;
	        var changedTime = val.ChangedAt;
	
	        switch (val.ChangeTable) {
	          case 0:
	            tableName = '';
	            break;
	          case 1:
	            tableName = (0, _helpers.translation)('1867');
	            break;
	          case 2:
	            tableName = (0, _helpers.translation)('1227');
	            break;
	          case 3:
	            tableName = (0, _helpers.translation)('13344');
	            break;
	          case 4:
	            tableName = (0, _helpers.translation)('13374');
	            break;
	          case 12:
	            tableName = (0, _helpers.translation)('1871');
	            break;
	          case 13:
	            tableName = (0, _helpers.translation)('1872');
	            break;
	        }
	
	        switch (val.ChangeField) {
	          case 1:
	            fieldName = (0, _helpers.translation)('30');
	            break;
	          case 2:
	            fieldName = (0, _helpers.translation)('295');
	            break;
	          case 9:
	            fieldName = (0, _helpers.translation)('419');
	            break;
	          case 10:
	            fieldName = (0, _helpers.translation)('13443');
	            break;
	          case 11:
	            fieldName = (0, _helpers.translation)('1044');
	            break;
	          case 12:
	            fieldName = (0, _helpers.translation)('1199');
	            break;
	          case 13:
	            fieldName = (0, _helpers.translation)('885');
	            break;
	          case 14:
	            fieldName = (0, _helpers.translation)('13350');
	            break;
	          case 15:
	            fieldName = (0, _helpers.translation)('13431');
	            break;
	          case 16:
	            fieldName = (0, _helpers.translation)('1305');
	            break;
	          case 17:
	            fieldName = (0, _helpers.translation)('393');
	            break;
	          case 18:
	            fieldName = (0, _helpers.translation)('13477');
	            break;
	          case 19:
	            fieldName = (0, _helpers.translation)('13477');
	            break;
	          case 22:
	            fieldName = (0, _helpers.translation)('13476');
	            break;
	          case 23:
	            fieldName = (0, _helpers.translation)('13476');
	            break;
	          case 24:
	            fieldName = (0, _helpers.translation)('16673');
	            break;
	        }
	
	        switch (val.ChangeType) {
	          case 1:
	            text = changeText;
	            break;
	          case 2:
	            text = removedText;
	            break;
	          case 0:
	            text = addedText;
	            break;
	        }
	        // console.log('Text', text)
	
	        text = text.replace('[table]', tableName);
	        text = text.replace('[field]', fieldName);
	        text = text.replace('[fromvalue]', fromVal);
	        text = text.replace('[tovalue]', toVal);
	        text = text.replace('[user]', changedBy);
	        text = text.replace('[time]', changedTime);
	
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { cols: cols, key: key },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _time.renderFullDate)(changedTime)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            changedBy
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            text
	          )
	        );
	      };
	
	      var cols = [1, 1, 2];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _tableHeader2.default,
	          { expand: true },
	          (0, _helpers.translation)('1866')
	        ),
	        _react2.default.createElement(
	          _tableRow2.default,
	          { header: true, cols: cols, align: 'center' },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('388')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('30')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('1489')
	          )
	        ),
	        hasData && log.map(renderLogLine)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'pricelog_modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: (0, _helpers.translation)('1864'), overflowHidden: this.state.overflowHidden,
	            icon: _icons.ModalIcons.Plus }),
	          this.renderPriceModelLog()
	        )
	      );
	    }
	  }]);
	
	  return PriceModelLogModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceModelLog: _priceModel.getPriceModelLog,
	  renderFullDate: _time.renderFullDate
	})(PriceModelLogModal);

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icons = __webpack_require__(6);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var ReferenceActions = function (_Component) {
	  _inherits(ReferenceActions, _Component);
	
	  function ReferenceActions(props) {
	    _classCallCheck(this, ReferenceActions);
	
	    var _this = _possibleConstructorReturn(this, (ReferenceActions.__proto__ || Object.getPrototypeOf(ReferenceActions)).call(this, props));
	
	    _this.state = {
	      comment: ''
	    };
	
	    _this.referenceEdit = _this.referenceEdit.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReferenceActions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.setBottomBarProps) {
	        if (this.props.isApproval) {
	          this.props.setBottomBarProps(this.renderApprovalButtons(true));
	        } else if (this.props.isCancellation) {
	          this.props.setBottomBarProps(this.renderCancellationButton(true));
	        }
	      }
	    }
	  }, {
	    key: 'referenceEdit',
	    value: function referenceEdit(state) {
	      var data = {
	        orderReferralId: this.props.referenceInfo.OrderReferralId,
	        state: state,
	        comment: this.state.comment
	      };
	
	      return this.props.ReferenceEdit(data);
	    }
	  }, {
	    key: 'handleReferenceError',
	    value: function handleReferenceError(err) {
	      // Toastr
	      if (err.response !== undefined && err.response.data !== undefined) {
	        window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	      } else {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'renderApprovalButtons',
	    value: function renderApprovalButtons() {
	      var _this2 = this;
	
	      var asProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var onclickApprove = function onclickApprove(e) {
	        e.preventDefault();
	
	        _this2.referenceEdit(1).then(function (res) {
	          // window.toastr.success(translation('2257'), translation('13424'))
	          _this2.props.onClose(true);
	        }).catch(_this2.handleReferenceError);
	      };
	
	      var onclickReject = function onclickReject(e) {
	        e.preventDefault();
	
	        _this2.referenceEdit(2).then(function (res) {
	          window.toastr.info((0, _helpers.translation)('735'), (0, _helpers.translation)('13424'));
	          _this2.props.onClose();
	        }).catch(_this2.handleReferenceError);
	      };
	
	      if (asProps) {
	        return {
	          actionLabelText: (0, _helpers.translation)('15223'),
	          onActionClick: onclickApprove,
	          cancelStyle: 'alert',
	          cancelLabelText: (0, _helpers.translation)('15224'),
	          onCancelClick: onclickReject,
	          center: true
	        };
	      }
	
	      return [_react2.default.createElement(_button2.default, { onClick: onclickApprove, labelText: (0, _helpers.translation)('15223'), key: 'approve' }), _react2.default.createElement(_button2.default, { onClick: onclickReject, labelText: (0, _helpers.translation)('15224'), style: 'alert', key: 'reject' })];
	    }
	  }, {
	    key: 'renderCancellationButton',
	    value: function renderCancellationButton() {
	      var _this3 = this;
	
	      var asProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var onclickCancel = function onclickCancel(e) {
	        e.preventDefault();
	
	        _this3.referenceEdit(4).then(function (res) {
	          // window.toastr.success(translation('2021'), translation('13424'))
	          _this3.props.onClose();
	        }).catch(_this3.handleReferenceError);
	      };
	
	      if (asProps) {
	        return {
	          actionStyle: 'alert',
	          actionLabelText: (0, _helpers.translation)('15225'),
	          onActionClick: onclickCancel,
	          cancelLabelText: false
	        };
	      }
	
	      return _react2.default.createElement(_button2.default, { onClick: onclickCancel, labelText: (0, _helpers.translation)('15225'), style: 'alert' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var department = this.props.department;
	
	
	      var title = void 0;
	      var icon = void 0;
	      switch (department) {
	        default:
	        case 0:
	          title = (0, _helpers.translation)('149');
	          icon = _icons.ReferenceIcons.Comment;
	          break;
	        case 1:
	          title = (0, _helpers.translation)('17881');
	          break;
	      }
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: title, icon: icon },
	        _react2.default.createElement(_textarea2.default, {
	          name: 'comment',
	          value: this.state.comment || '',
	          onChange: this.onInputChange
	        }),
	        !this.props.setBottomBarProps && _react2.default.createElement(
	          'div',
	          { className: 'refOrderApproval__buttons' },
	          this.props.isApproval && this.renderApprovalButtons(),
	          this.props.isCancellation && this.renderCancellationButton()
	        )
	      );
	    }
	  }]);
	
	  return ReferenceActions;
	}(_react.Component);
	
	ReferenceActions.propTypes = {
	  referenceInfo: _propTypes2.default.object.isRequired,
	  onClose: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  ReferenceEdit: _orders.ReferenceEdit
	})(ReferenceActions);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { translation } from '../../../../utils/helpers'
	
	var ReferenceContactInfo = function (_Component) {
	  _inherits(ReferenceContactInfo, _Component);
	
	  function ReferenceContactInfo() {
	    _classCallCheck(this, ReferenceContactInfo);
	
	    return _possibleConstructorReturn(this, (ReferenceContactInfo.__proto__ || Object.getPrototypeOf(ReferenceContactInfo)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceContactInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          icon = _props.icon,
	          name = _props.name,
	          address = _props.address,
	          phone = _props.phone,
	          onlyName = _props.onlyName;
	
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: title, icon: icon },
	        _react2.default.createElement(
	          'label',
	          { className: 'full' },
	          name
	        ),
	        !onlyName && _react2.default.createElement(
	          'label',
	          null,
	          address
	        ),
	        !onlyName && _react2.default.createElement(
	          'label',
	          null,
	          phone
	        )
	      );
	    }
	  }]);
	
	  return ReferenceContactInfo;
	}(_react.Component);
	
	ReferenceContactInfo.propTypes = {
	  title: _propTypes2.default.string,
	  name: _propTypes2.default.string.isRequired,
	  address: _propTypes2.default.string.isRequired,
	  phone: _propTypes2.default.string.isRequired
	};
	
	ReferenceContactInfo.defaultProps = {
	  title: null,
	  icon: null
	};
	
	exports.default = ReferenceContactInfo;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _icons = __webpack_require__(6);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import SimpleHeader from '../SimpleHeader'
	
	// Utils
	
	
	// Elements
	
	
	var ReferenceOrderData = function (_Component) {
	  _inherits(ReferenceOrderData, _Component);
	
	  function ReferenceOrderData() {
	    _classCallCheck(this, ReferenceOrderData);
	
	    return _possibleConstructorReturn(this, (ReferenceOrderData.__proto__ || Object.getPrototypeOf(ReferenceOrderData)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceOrderData, [{
	    key: 'renderLabel',
	    value: function renderLabel(dictionaryKey, label) {
	      return _react2.default.createElement(
	        _inline2.default,
	        { fillChildNum: [0, 1], block: true },
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)(dictionaryKey),
	          ':'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          label
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          referenceInfo = _props.referenceInfo,
	          department = _props.department,
	          isApproval = _props.isApproval;
	
	
	      var isPaint = department === 0;
	
	      var icon = isPaint ? _icons.ReferenceIcons.Info : null;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('14918'), icon: icon },
	        this.renderLabel('294', referenceInfo.OrderInfo.Orderid),
	        this.renderLabel('78', referenceInfo.OrderInfo.RegNumber),
	        this.renderLabel('145', (0, _helpers.translation)(referenceInfo.OrderInfo.Brand)),
	        this.renderLabel('146', referenceInfo.OrderInfo.Model),
	        isPaint && this.renderLabel('179', referenceInfo.OrderInfo.Color),
	        isPaint && this.renderLabel('289', (0, _time.renderFullDate)(referenceInfo.OrderInfo.Pickup)),
	        isPaint && this.renderLabel('290', (0, _time.renderFullDate)(referenceInfo.OrderInfo.Delivery)),
	        isPaint && isApproval && this.renderLabel('721', referenceInfo.TransportBefore, 'wrap'),
	        isPaint && isApproval && this.renderLabel('722', referenceInfo.TransportAfter, 'wrap'),
	        !isPaint && _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('14827') },
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0, 1], block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              referenceInfo.OriginalCompany.Name,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(referenceInfo.OrderInfo.Pickup)
	            )
	          ),
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('17880') }),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0, 1], block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              referenceInfo.OriginalCompany.Name,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(referenceInfo.OrderInfo.Delivery)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReferenceOrderData;
	}(_react.Component);
	
	ReferenceOrderData.propTypes = {
	  referenceInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = ReferenceOrderData;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import SimpleHeader from '../SimpleHeader'
	
	// Utils
	
	
	// Elements
	
	
	var ReferencedFrom = function (_Component) {
	  _inherits(ReferencedFrom, _Component);
	
	  function ReferencedFrom() {
	    _classCallCheck(this, ReferencedFrom);
	
	    return _possibleConstructorReturn(this, (ReferencedFrom.__proto__ || Object.getPrototypeOf(ReferencedFrom)).apply(this, arguments));
	  }
	
	  _createClass(ReferencedFrom, [{
	    key: 'render',
	    value: function render() {
	      var department = this.props.department;
	
	
	      var moveType = '';
	      switch (this.props.referenceInfo.MoveType) {
	        case 1:
	          moveType = '703';
	          break;
	        case 0:
	          moveType = '778';
	          break;
	      }
	
	      var icon = department === 0 ? _icons.ReferenceIcons.Referred_From : null;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('719'), icon: icon },
	        _react2.default.createElement(
	          'div',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'label',
	            { className: 'full' },
	            this.props.referenceInfo.TransferedFromCompanyName
	          ),
	          this.props.department === 0 && _react2.default.createElement(
	            'label',
	            { className: 'full' },
	            (0, _helpers.translation)(moveType)
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0, 1], block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('30'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              this.props.referenceInfo.CreatedBy
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0, 1], block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('388'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(this.props.referenceInfo.CreationDate)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReferencedFrom;
	}(_react.Component);
	
	ReferencedFrom.propTypes = {
	  referenceInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = ReferencedFrom;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1672);
	
	var _orders = __webpack_require__(21);
	
	var _notes = __webpack_require__(114);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _icons = __webpack_require__(6);
	
	var _order = __webpack_require__(92);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	// import components
	
	// import RadioList from './InputComponents/RadioList/RadioList'
	
	// Elements
	
	
	// Utils
	
	
	var StopLockOrderModal = function (_Component) {
	  _inherits(StopLockOrderModal, _Component);
	
	  function StopLockOrderModal(props) {
	    _classCallCheck(this, StopLockOrderModal);
	
	    var _this = _possibleConstructorReturn(this, (StopLockOrderModal.__proto__ || Object.getPrototypeOf(StopLockOrderModal)).call(this, props));
	
	    _this.state = {
	      itemIsStopped: props.item.IsStopped,
	      standardNotes: [],
	      show: false,
	      message: '',
	      selectedRadioButtonValue: '-1',
	      isRadioSelected: false,
	      newDelivery: _this.props.newDelivery,
	      ApplyToInvoice: false,
	      ShowCustomer: false,
	      ShowPaintShop: false
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.stopLockOrder = _this.stopLockOrder.bind(_this);
	    _this.radioChange = _this.onRadioChange.bind(_this);
	    _this.addStandardNote = _this.addStandardNote.bind(_this);
	    _this.deleteNoteText = _this.deleteNoteText.bind(_this);
	    _this.addNoteText = _this.addNoteText.bind(_this);
	    _this.translate = _this.translate.bind(_this);
	    return _this;
	  }
	
	  _createClass(StopLockOrderModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.item.OrderStop) {
	        this.setState({
	          itemIsStopped: this.props.item.IsStopped,
	          message: this.props.item.OrderStop.StoppedMessage,
	          selectedRadioButtonValue: this.props.item.OrderStop.TimeAction.toString(),
	          ApplyToInvoice: this.props.item.OrderStop.StoppedMessageApplyToInvoice,
	          ShowCustomer: this.props.item.OrderStop.StoppedMessageShowCustomer,
	          ShowPaintShop: this.props.item.OrderStop.StoppedMessageShowCustomer
	        });
	      }
	      this.props.getStandardNotes().then(function (res) {
	        _this2.setState({
	          standardNotes: res.data
	        });
	      });
	    }
	  }, {
	    key: 'addNoteText',
	    value: function addNoteText(text) {
	      var noteText = this.state.message;
	      if (noteText === '') {
	        noteText = text;
	      } else {
	        noteText += '\n';
	        noteText = noteText.concat(text);
	      }
	      this.setState({
	        message: noteText
	      });
	    }
	  }, {
	    key: 'addStandardNote',
	    value: function addStandardNote(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      var inputText = document.getElementsByName('standardNote')[0];
	      var noteText = document.getElementsByName('standardNote')[0].value;
	      if (noteText !== '') {
	        var newStandardNote = {
	          Id: 0,
	          Note: noteText,
	          IsDeleted: false
	        };
	        this.props.createOrDeleteStandardNote(newStandardNote).then(function (res) {
	          _this3.setState({
	            standardNotes: res.data
	          }, function () {
	            inputText.value = '';
	          });
	        });
	      }
	    }
	  }, {
	    key: 'deleteNoteText',
	    value: function deleteNoteText(note) {
	      var _this4 = this;
	
	      note.IsDeleted = true;
	      this.props.createOrDeleteStandardNote(note).then(function (res) {
	        _this4.setState({
	          standardNotes: res.data
	        }, function () {});
	      });
	    }
	  }, {
	    key: 'stopLockOrder',
	    value: function stopLockOrder(e) {
	      var _this5 = this;
	
	      e.preventDefault();
	      var data = {
	        OrderId: this.props.id,
	        Message: this.state.message,
	        TimeAction: parseInt(this.state.selectedRadioButtonValue),
	        NewDelivery: this.state.newDelivery,
	        ShowCustomer: this.state.ShowCustomer,
	        ShowPaintShop: this.state.ShowPaintShop,
	        ApplyToInvoice: this.state.ApplyToInvoice
	      };
	      if (this.state.itemIsStopped || this.state.isRadioSelected || parseInt(this.state.selectedRadioButtonValue) > 0) {
	        this.props.StopLockOrder(data).then(function (res) {
	          // window.toastr.success(translation('13403'), translation('13424'))
	          _this5.props.onClose();
	        }, function (err) {
	          var key = err.response.data.DictionaryKey === undefined ? '13404' : err.response.data.DictionaryKey;
	          window.toastr.error((0, _helpers.translation)(key), (0, _helpers.translation)('216'));
	        });
	      } else {
	        window.toastr.error((0, _helpers.translation)('15265'), (0, _helpers.translation)('216'));
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      if (e.target.type === 'checkbox') {
	        this.setState(_defineProperty({}, e.target.name, e.target.checked));
	      } else {
	        var value = e.target.value;
	        this.setState(_defineProperty({}, e.target.name, value));
	      }
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      var value = e.target.value;
	      this.setState({
	        selectedRadioButtonValue: value,
	        isRadioSelected: true // makes sure that when new stop is made any of the radio buttons is clicked
	      });
	    }
	    // kept this in comment in case someone changes their mind.. good UX here
	    // checkboxActive () {
	    //   if (this.state.message !== '') return false
	    //   else return true
	    // }
	
	  }, {
	    key: 'renderCheckBoxes',
	    value: function renderCheckBoxes() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_check2.default, { id: 'ApplyToInvoice', name: 'ApplyToInvoice', value: 'yes', onChange: this.onInputChange, checked: this.state.ApplyToInvoice, labelText: (0, _helpers.translation)('1785') }),
	        _react2.default.createElement(_check2.default, { id: 'ShowCustomer', name: 'ShowCustomer', value: '1', onChange: this.onInputChange, checked: this.state.ShowCustomer, labelText: (0, _helpers.translation)('13429') }),
	        (this.props.auth.departmentType === 1 || (0, _auth.hasAccess)([6], this.props.auth.user.UserType)) && _react2.default.createElement(_check2.default, { id: 'ShowPaintShop', name: 'ShowPaintShop', value: '1', onChange: this.onInputChange, checked: this.state.ShowPaintShop, labelText: (0, _helpers.translation)('17858') })
	      );
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this6 = this;
	
	      var renderStopMessage = function renderStopMessage() {
	        var renderTitle = function renderTitle() {
	          if (!_this6.state.itemIsStopped) {
	            return _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('149'),
	              ':'
	            );
	          } else {
	            if (_this6.props.item.OrderStop) {
	              var date = _this6.props.item.OrderStop.StoppedDate.replace('T', ' - ');
	              var transformedDate = date.substr(0, date.length - 3);
	              return _react2.default.createElement(
	                _label2.default,
	                null,
	                _react2.default.createElement(_UserInfo2.default, { user: _this6.props.item.OrderStop.StoppedByUserInfo }),
	                transformedDate
	              );
	            }
	          }
	        };
	        var renderStandardNotes = function renderStandardNotes() {
	          if (_this6.state.standardNotes.length <= 0) return null;
	          var sNotes = [].concat(_toConsumableArray(_this6.state.standardNotes));
	          var renderedNotes = sNotes.map(function (note, i) {
	            return _react2.default.createElement(
	              _inline2.default,
	              { key: i, fillChildNum: [0], block: true, alignChildren: 'center' },
	              _react2.default.createElement(
	                'span',
	                null,
	                note.Note
	              ),
	              _this6.state.showEdit === true && _react2.default.createElement(_removeButton2.default, { size: 's', onClick: function onClick() {
	                  return _this6.deleteNoteText(note);
	                } }),
	              _react2.default.createElement(_addButton2.default, { size: 's', onClick: function onClick() {
	                  return _this6.addNoteText(note.Note);
	                } })
	            );
	          });
	          return renderedNotes;
	        };
	        var toggleEdit = function toggleEdit() {
	          _this6.setState({
	            showEdit: !_this6.state.showEdit
	          });
	        };
	        var renderOldComment = function renderOldComment() {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_textarea2.default, { name: 'message', onChange: _this6.onInputChange, value: _this6.state.message || '' }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: _react2.default.createElement(
	                  'span',
	                  null,
	                  defaultNoteTitle,
	                  ' ',
	                  _react2.default.createElement('img', { src: '/images/icons/edit_16.png', onClick: toggleEdit.bind(_this6) })
	                ) },
	              renderStandardNotes()
	            ),
	            _this6.state.showEdit === true && _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('15201') },
	              _react2.default.createElement(
	                _inline2.default,
	                { fillChildNum: [0], block: true },
	                _react2.default.createElement(_text2.default, { name: 'standardNote', defaultValue: '' }),
	                _react2.default.createElement(_addButton2.default, { onClick: _this6.addStandardNote })
	              )
	            ),
	            _this6.renderCheckBoxes()
	          );
	        };
	        var renderNewComment = function renderNewComment() {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_textarea2.default, { name: 'message', onChange: _this6.onInputChange, value: _this6.state.message || '' }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: _react2.default.createElement(
	                  'span',
	                  null,
	                  defaultNoteTitle,
	                  ' ',
	                  _react2.default.createElement('img', { src: '/images/icons/edit_16.png', onClick: toggleEdit.bind(_this6) })
	                ) },
	              renderStandardNotes()
	            ),
	            _this6.state.showEdit === true && _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('15201') },
	              _react2.default.createElement(
	                _inline2.default,
	                { fillChildNum: [0], block: true },
	                _react2.default.createElement(_text2.default, { name: 'standardNote', defaultValue: '' }),
	                _react2.default.createElement(_addButton2.default, { onClick: _this6.addStandardNote })
	              )
	            ),
	            _this6.renderCheckBoxes()
	          );
	        };
	        var defaultNoteTitle = (0, _helpers.translation)('15095');
	        if (_this6.state.standardNotes.length <= 0) {
	          defaultNoteTitle = (0, _helpers.translation)('15207');
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          renderTitle(),
	          _this6.state.itemIsStopped && renderOldComment(),
	          !_this6.state.itemIsStopped && renderNewComment()
	        );
	      };
	      var renderStopTimeAction = function renderStopTimeAction() {
	        if (_this6.state.itemIsStopped && _this6.state.newDelivery === null) return null;
	        var department = _this6.props.item.OrderDepartment;
	        var time = void 0;
	        if (department === 1) {
	          time = _this6.props.item.BodyShopDeliveryTime;
	        } else {
	          time = _this6.props.item.Delivery;
	        }
	        var formatDateTimeString = function formatDateTimeString(dateTime) {
	          var dateTimeReplaceT = dateTime.replace('T', '-');
	          var dateTimeTimeSplit = dateTimeReplaceT.split('-');
	          var transformedDate = ' ' + dateTimeTimeSplit[2] + '.' + dateTimeTimeSplit[1] + '.' + dateTimeTimeSplit[0] + ' ' + (0, _helpers.translation)('15263') + ' ' + dateTimeTimeSplit[3].substr(0, 5);
	          return transformedDate;
	        };
	        var renderOldSelection = function renderOldSelection() {
	          if (_this6.state.newDelivery !== undefined && _this6.state.newDelivery !== null) {
	            var radioButtons = [{ Id: 1, Name: (0, _helpers.translation)('15262') + formatDateTimeString(_this6.state.newDelivery) }, { Id: 2, Name: (0, _helpers.translation)('15260') + formatDateTimeString(time) }];
	            var mapItems = function mapItems(val, index) {
	              var id = val.Id;
	              var name = 'selectedRadioButtonValue';
	              var idName = name + '_' + id + '_input';
	              return _react2.default.createElement(_radio2.default, { key: index, id: idName, name: idName, value: id, onChange: _this6.radioChange, checked: _this6.state.selectedRadioButtonValue === id.toString() ? 'checked' : false, disabled: false, labelText: _this6.translate(val['Name']) });
	            };
	            return (
	              // <RadioList title={translation('15264')} subTitle={translation('15259')}
	              //   name={'selectedRadioButtonValue'} value={this.state.selectedRadioButtonValue} onChange={this.radioChange}
	              //   listItems={radioButtons} checked={false} listItemValName={['Id', 'Name']} translate showTitle showSubTitle />
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('15264') },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  (0, _helpers.translation)('15259')
	                ),
	                radioButtons.map(mapItems)
	              )
	            );
	          }
	        };
	        var renderNewSelection = function renderNewSelection() {
	          var getValue = function getValue() {
	            if (!_this6.state.isRadioSelected) return '-1';else return _this6.state.selectedRadioButtonValue;
	          };
	          var radioButtons = [{ Id: 1, Name: (0, _helpers.translation)('47') }, { Id: 2, Name: (0, _helpers.translation)('15260') + formatDateTimeString(time) }, { Id: 0, Name: (0, _helpers.translation)('15261') }];
	
	          var mapItems = function mapItems(val, index) {
	            var id = val.Id;
	            var name = 'selectedRadioButtonValue';
	            var idName = name + '_' + id + '_input';
	            return _react2.default.createElement(_radio2.default, { key: index, id: idName, name: idName, value: id, onChange: _this6.radioChange, checked: getValue() === id.toString() ? 'checked' : false, disabled: false, labelText: _this6.translate(val['Name']) });
	          };
	          return (
	            // <RadioList title={translation('15264')} subTitle={translation('15259')}
	            //   name={'selectedRadioButtonValue'} value={getValue()} onChange={this.radioChange}
	            //   listItems={radioButtons} checked={false} listItemValName={['Id', 'Name']} translate showTitle showSubTitle />
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('15264') },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)('15259')
	              ),
	              radioButtons.map(mapItems)
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          _this6.state.itemIsStopped && renderOldSelection(),
	          !_this6.state.itemIsStopped && renderNewSelection()
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderStopMessage(),
	        renderStopTimeAction()
	      );
	    }
	  }, {
	    key: 'translate',
	    value: function translate(text) {
	      if (isNaN(Number(text))) return text;
	      return (0, _helpers.translation)(text);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // let icon = 'Stop-White.png'
	      var icon = _icons.ModalIcons.Stop_Order;
	      var headerName = (0, _order.makeOrderTitle)(this.props.item, null, null, true);
	      return _react2.default.createElement(
	        'div',
	        { className: 'stoplockorder__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('2218') + ' - ' + headerName,
	            overflowHidden: this.state.overflowHidden,
	            onClose: this.props.onClose,
	            icon: icon,
	            bottomBarProps: {
	              actionStyle: 'alert',
	              actionLabelText: this.state.itemIsStopped ? (0, _helpers.translation)('2220') : (0, _helpers.translation)('2218'),
	              onActionClick: this.stopLockOrder
	            }
	          }),
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return StopLockOrderModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  StopLockOrder: _orders.StopLockOrder,
	  getStandardNotes: _notes.getStandardNotes,
	  createNote: _notes.createNote,
	  createOrDeleteStandardNote: _notes.createOrDeleteStandardNote,
	  getOrder: _orders.getOrder
	})(StopLockOrderModal);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _overlay = __webpack_require__(131);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _OverlayHeader = __webpack_require__(174);
	
	var _OverlayHeader2 = _interopRequireDefault(_OverlayHeader);
	
	var _Task = __webpack_require__(284);
	
	var _Task2 = _interopRequireDefault(_Task);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	__webpack_require__(1687);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Components
	
	
	var TaskOverlay = function (_Component) {
	  _inherits(TaskOverlay, _Component);
	
	  function TaskOverlay() {
	    _classCallCheck(this, TaskOverlay);
	
	    return _possibleConstructorReturn(this, (TaskOverlay.__proto__ || Object.getPrototypeOf(TaskOverlay)).apply(this, arguments));
	  }
	
	  _createClass(TaskOverlay, [{
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var task = this.props.task;
	
	      return _react2.default.createElement(
	        _OverlayHeader2.default,
	        { overlayId: 'TaskOverlay', onClose: this.props.onClose },
	        _react2.default.createElement(
	          'div',
	          { className: 'top topHeaderInfo' },
	          _react2.default.createElement(
	            'div',
	            { className: 'heading' },
	            _react2.default.createElement(
	              'div',
	              { className: 'heading-title' },
	              task.Title
	            ),
	            window.innerWidth > 760 && _react2.default.createElement(
	              'div',
	              { className: 'heading-category' },
	              (0, _helpers.translation)(task.Category)
	            )
	          ),
	          window.innerWidth > 760 && _react2.default.createElement(
	            'div',
	            { className: 'deadline' },
	            _react2.default.createElement(
	              'div',
	              { className: 'deadline-title' },
	              (0, _helpers.translation)(1232)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'deadline-date' },
	              (0, _time.renderFullDate)(task.Deadline, false)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var task = this.props.task;
	      if ((typeof task === 'undefined' ? 'undefined' : _typeof(task)) !== 'object') return null;
	      return _react2.default.createElement(
	        _overlay2.default,
	        { overlayId: 'TaskOverlay', extraClassName: 'task-overlay' },
	        this.renderHeader(),
	        _react2.default.createElement(
	          'div',
	          { className: 'task-overlay__content' },
	          _react2.default.createElement(_Task2.default, { item: this.props.task, modal: true })
	        )
	      );
	    }
	  }]);
	
	  return TaskOverlay;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(TaskOverlay);

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	__webpack_require__(1690);
	
	var _common = __webpack_require__(25);
	
	var _spareparts = __webpack_require__(108);
	
	var _helpers = __webpack_require__(2);
	
	var _slidePanel = __webpack_require__(202);
	
	var _slidePanel2 = _interopRequireDefault(_slidePanel);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Helpers
	
	
	// Elements
	
	
	var FilterSlidePanel = function (_Component) {
	  _inherits(FilterSlidePanel, _Component);
	
	  function FilterSlidePanel(props) {
	    _classCallCheck(this, FilterSlidePanel);
	
	    var _this = _possibleConstructorReturn(this, (FilterSlidePanel.__proto__ || Object.getPrototypeOf(FilterSlidePanel)).call(this, props));
	
	    _this.state = {
	      filterDetails: [],
	      isLoading: false,
	
	      selectedSuppliers: [],
	      selectedStatuses: []
	    };
	
	    _this.clearFilters = _this.clearFilters.bind(_this);
	    return _this;
	  }
	
	  _createClass(FilterSlidePanel, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          view = _props.view,
	          filter = _props.filter;
	
	
	      if (view !== prevProps.view) {
	        this.getFilterDetails();
	      }
	
	      // Update filter selected values
	      if (!(0, _lodash.isEqual)(filter, prevProps.filter)) {
	        this.setState({
	          selectedSuppliers: filter.SupplierIds,
	          selectedStatuses: filter.Statuses
	        });
	      }
	    }
	  }, {
	    key: 'getFilterDetails',
	    value: function getFilterDetails() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          type = _props2.type;
	
	
	      var filterType = 1; // Status
	      if (view === 'supplier') {
	        filterType = 2; // Supplier
	      }
	
	      var data = {
	        OrderId: this.props.orderId,
	        FilterType: filterType
	      };
	
	      this.setState({ isLoading: true }, function () {
	        switch (type) {
	          case 'ordering':
	          default:
	            _this2.props.getFilterOrderingSparePartsDetails(data).then(function (res) {
	              _this2.setState({
	                filterDetails: res.data,
	                isLoading: false
	              });
	            });
	            break;
	          case 'reception':
	            _this2.props.getFilterReceptionSparePartsDetails(data).then(function (res) {
	              _this2.setState({
	                filterDetails: res.data,
	                isLoading: false
	              });
	            });
	            break;
	        }
	      });
	    }
	  }, {
	    key: 'submitFilter',
	    value: function submitFilter(filterType) {
	      var _this3 = this;
	
	      var filterObj = {
	        OrderId: this.props.orderId
	      };
	
	      if (filterType === 'supplier') {
	        filterObj.SupplierIds = this.state.selectedSuppliers;
	        filterObj.SelectedFilters = 2;
	      } else if (filterType === 'status') {
	        filterObj.Statuses = this.state.selectedStatuses;
	        filterObj.SelectedFilters = 1;
	      }
	
	      this.setState({ isLoading: true }, function () {
	        if (_this3.props.type === 'ordering') {
	          _this3.props.getSparePartsOrdering(filterObj).then(function (res) {
	            _this3.closeSlidePanel();
	          });
	        } else {
	          _this3.props.getSparePartsReception(filterObj).then(function (res) {
	            _this3.closeSlidePanel();
	          });
	        }
	      });
	    }
	  }, {
	    key: 'closeSlidePanel',
	    value: function closeSlidePanel() {
	      if (this.props.onClose) this.props.onClose();
	      this.props.closeSlidePanel('sparePartsFilter');
	      this.setState({ isLoading: false });
	    }
	  }, {
	    key: 'clearFilters',
	    value: function clearFilters() {
	      var _this4 = this;
	
	      var hasFilters = this.props.filter.SelectedFilters !== 0;
	      if (hasFilters) {
	        this.setState({ isLoading: true }, function () {
	          if (_this4.props.type === 'ordering') {
	            _this4.props.getSparePartsOrdering({ OrderId: _this4.props.orderId }).then(function (res) {
	              _this4.closeSlidePanel();
	            });
	          } else {
	            _this4.props.getSparePartsReception({ OrderId: _this4.props.orderId }).then(function (res) {
	              _this4.closeSlidePanel();
	            });
	          }
	        });
	      } else {
	        this.closeSlidePanel();
	      }
	    }
	  }, {
	    key: 'getCancelText',
	    value: function getCancelText() {
	      if (this.props.filter.SelectedFilters === 0) {
	        return (0, _helpers.translation)('1155');
	      } else {
	        return (0, _helpers.translation)('16658');
	      }
	    }
	  }, {
	    key: 'renderSpinner',
	    value: function renderSpinner() {
	      var small = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (small) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'animated-background' },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated-background' },
	        _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	      );
	    }
	  }, {
	    key: 'renderSupplierView',
	    value: function renderSupplierView() {
	      var _this5 = this;
	
	      var renderSupplierGroup = function renderSupplierGroup(supplierGroup, key) {
	        var onChange = function onChange(e) {
	          var _e$target = e.target,
	              value = _e$target.value,
	              checked = _e$target.checked;
	
	          var val = parseInt(value, 10);
	
	          if (checked) {
	            _this5.setState({
	              selectedSuppliers: [].concat(_toConsumableArray(_this5.state.selectedSuppliers), [val])
	            });
	          } else {
	            _this5.setState({
	              selectedSuppliers: [].concat(_toConsumableArray(_this5.state.selectedSuppliers.filter(function (ss) {
	                return ss !== val;
	              })))
	            });
	          }
	        };
	
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true, key: key },
	          _react2.default.createElement(_check2.default, {
	            name: 'supplier',
	            value: supplierGroup.SupplierId,
	            onChange: onChange,
	            checked: _this5.state.selectedSuppliers.includes(supplierGroup.SupplierId),
	            labelText: supplierGroup.SupplierName || (0, _helpers.translation)('15392'),
	            disabled: supplierGroup.Count === 0
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'filter-count' },
	            supplierGroup.Count
	          )
	        );
	      };
	
	      var selectedCount = this.state.filterDetails.reduce(function (sum, detail) {
	        if (_this5.state.selectedSuppliers.includes(detail.SupplierId)) {
	          return sum + detail.Count;
	        }
	        return sum;
	      }, 0);
	      var actionText = (0, _helpers.translation)('16656').replace('[count]', selectedCount);
	
	      return [_react2.default.createElement(
	        'div',
	        { className: 'top', key: 0 },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          (0, _helpers.translation)(16657)
	        )
	      ), _react2.default.createElement(
	        'div',
	        { className: 'content filter', key: 1 },
	        this.state.isLoading && this.renderSpinner(),
	        !this.state.isLoading && this.state.filterDetails.map(renderSupplierGroup)
	      ), _react2.default.createElement(_bottomBar2.default, {
	        disabled: this.state.isLoading || this.state.selectedSuppliers.length === 0,
	        actionLabelText: this.state.isLoading ? this.renderSpinner(true) : actionText,
	        onActionClick: function onActionClick() {
	          return _this5.submitFilter('supplier');
	        },
	        cancelLabelText: this.getCancelText(),
	        onCancelClick: this.clearFilters,
	        key: 2
	      })];
	    }
	  }, {
	    key: 'renderStatusView',
	    value: function renderStatusView() {
	      var _this6 = this;
	
	      var renderStatusGroup = function renderStatusGroup(statusGroup, key) {
	        var onChange = function onChange(e) {
	          var _e$target2 = e.target,
	              name = _e$target2.name,
	              value = _e$target2.value,
	              checked = _e$target2.checked;
	
	          var val = parseInt(value, 10);
	
	          console.log('status change', { name: name, val: val, checked: checked });
	          if (checked) {
	            _this6.setState({
	              selectedStatuses: [].concat(_toConsumableArray(_this6.state.selectedStatuses), [val])
	            });
	          } else {
	            _this6.setState({
	              selectedStatuses: [].concat(_toConsumableArray(_this6.state.selectedStatuses.filter(function (ss) {
	                return ss !== val;
	              })))
	            });
	          }
	        };
	
	        var labelText = void 0;
	        switch (statusGroup.Status) {
	          case 1:
	            labelText = (0, _helpers.translation)('15392');
	            break;
	          case 2:
	            labelText = (0, _helpers.translation)('16449');
	            break;
	          case 4:
	            labelText = (0, _helpers.translation)('14799');
	            break;
	          case 8:
	            labelText = _this6.props.type === 'ordering' ? (0, _helpers.translation)('16457') : (0, _helpers.translation)('16535');
	            break;
	          case 16:
	            labelText = (0, _helpers.translation)('16452');
	            break;
	          case 32:
	            labelText = (0, _helpers.translation)('16453');
	            break;
	          case 64:
	            labelText = (0, _helpers.translation)('16454');
	            break;
	          case 128:
	            labelText = (0, _helpers.translation)('18108');
	            break;
	          case 0:
	            return null;
	        }
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true, key: key },
	          _react2.default.createElement(_check2.default, {
	            name: 'status',
	            value: statusGroup.Status,
	            onChange: onChange,
	            checked: _this6.state.selectedStatuses.includes(statusGroup.Status),
	            labelText: labelText,
	            disabled: statusGroup.Count === 0
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'filter-count' },
	            statusGroup.Count
	          )
	        );
	      };
	
	      var selectedCount = this.state.filterDetails.reduce(function (sum, detail) {
	        if (_this6.state.selectedStatuses.includes(detail.Status)) {
	          return sum + detail.Count;
	        }
	        return sum;
	      }, 0);
	      var actionText = (0, _helpers.translation)('16656').replace('[count]', selectedCount);
	
	      return [_react2.default.createElement(
	        'div',
	        { className: 'top', key: 0 },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          'Status'
	        )
	      ), _react2.default.createElement(
	        'div',
	        { className: 'content filter', key: 1 },
	        this.state.isLoading && this.renderSpinner(),
	        !this.state.isLoading && this.state.filterDetails.map(renderStatusGroup)
	      ), _react2.default.createElement(_bottomBar2.default, {
	        disabled: this.state.isLoading || this.state.selectedStatuses.length === 0,
	        actionLabelText: this.state.isLoading ? this.renderSpinner(true) : actionText,
	        onActionClick: function onActionClick() {
	          return _this6.submitFilter('status');
	        },
	        cancelLabelText: this.getCancelText(),
	        onCancelClick: this.clearFilters,
	        key: 2
	      })];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = null;
	      switch (this.props.view) {
	        case 'supplier':
	        default:
	          content = this.renderSupplierView();
	          break;
	        case 'status':
	          content = this.renderStatusView();
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'filterSlidePanel' },
	        _react2.default.createElement(
	          _slidePanel2.default,
	          { slidePanelId: 'sparePartsFilter' },
	          content
	        )
	      );
	    }
	  }]);
	
	  return FilterSlidePanel;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  closeSlidePanel: _common.closeSlidePanel,
	  getFilterOrderingSparePartsDetails: _spareparts.getFilterOrderingSparePartsDetails,
	  getFilterReceptionSparePartsDetails: _spareparts.getFilterReceptionSparePartsDetails,
	  getSparePartsOrdering: _spareparts.getSparePartsOrdering,
	  getSparePartsReception: _spareparts.getSparePartsReception
	})(FilterSlidePanel);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(109);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(80);
	var toAbsoluteIndex = __webpack_require__(163);
	var toLength = __webpack_require__(72);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(155);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(88);
	var toObject = __webpack_require__(80);
	var IObject = __webpack_require__(208);
	var toLength = __webpack_require__(72);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(88);
	var isObject = __webpack_require__(49);
	var invoke = __webpack_require__(488);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(71).f;
	var create = __webpack_require__(157);
	var redefineAll = __webpack_require__(161);
	var ctx = __webpack_require__(110);
	var anInstance = __webpack_require__(154);
	var forOf = __webpack_require__(155);
	var $iterDefine = __webpack_require__(320);
	var step = __webpack_require__(491);
	var setSpecies = __webpack_require__(162);
	var DESCRIPTORS = __webpack_require__(70);
	var fastKey = __webpack_require__(142).fastKey;
	var validate = __webpack_require__(182);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(207);
	var from = __webpack_require__(480);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(161);
	var getWeak = __webpack_require__(142).getWeak;
	var anObject = __webpack_require__(39);
	var isObject = __webpack_require__(49);
	var anInstance = __webpack_require__(154);
	var forOf = __webpack_require__(155);
	var createArrayMethod = __webpack_require__(117);
	var $has = __webpack_require__(96);
	var validate = __webpack_require__(182);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(243);
	var isObject = __webpack_require__(49);
	var toLength = __webpack_require__(72);
	var ctx = __webpack_require__(110);
	var IS_CONCAT_SPREADABLE = __webpack_require__(56)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(70) && !__webpack_require__(47)(function () {
	  return Object.defineProperty(__webpack_require__(313)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 488 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(49);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(39);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 491 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(322);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 493 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 494 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(159);
	var gOPS = __webpack_require__(247);
	var pIE = __webpack_require__(209);
	var toObject = __webpack_require__(80);
	var IObject = __webpack_require__(208);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(47)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(71);
	var anObject = __webpack_require__(39);
	var getKeys = __webpack_require__(159);
	
	module.exports = __webpack_require__(70) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(105);
	var gOPN = __webpack_require__(158).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(96);
	var toIObject = __webpack_require__(105);
	var arrayIndexOf = __webpack_require__(239)(false);
	var IE_PROTO = __webpack_require__(326)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(159);
	var toIObject = __webpack_require__(105);
	var isEnum = __webpack_require__(209).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(158);
	var gOPS = __webpack_require__(247);
	var anObject = __webpack_require__(39);
	var Reflect = __webpack_require__(44).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(44).parseFloat;
	var $trim = __webpack_require__(181).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(330) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(44).parseInt;
	var $trim = __webpack_require__(181).trim;
	var ws = __webpack_require__(330);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 503 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(39);
	var isObject = __webpack_require__(49);
	var newPromiseCapability = __webpack_require__(324);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(72);
	var repeat = __webpack_require__(329);
	var defined = __webpack_require__(119);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(121);
	var toLength = __webpack_require__(72);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(56);


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(483);
	var validate = __webpack_require__(182);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(240)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(70) && /./g.flags != 'g') __webpack_require__(71).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(242)
	});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(483);
	var validate = __webpack_require__(182);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(240)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(117)(0);
	var redefine = __webpack_require__(98);
	var meta = __webpack_require__(142);
	var assign = __webpack_require__(495);
	var weak = __webpack_require__(485);
	var isObject = __webpack_require__(49);
	var fails = __webpack_require__(47);
	var validate = __webpack_require__(182);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(240)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 512 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1720),
	    isArguments = __webpack_require__(1764),
	    isArray = __webpack_require__(348),
	    isBuffer = __webpack_require__(534),
	    isIndex = __webpack_require__(1743),
	    isTypedArray = __webpack_require__(1767);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(525),
	    eq = __webpack_require__(532);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(1730);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(523),
	    isArray = __webpack_require__(348);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(523),
	    getPrototype = __webpack_require__(343),
	    getSymbols = __webpack_require__(344),
	    stubArray = __webpack_require__(537);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(1711);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(535),
	    isLength = __webpack_require__(536);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(123),
	    stubFalse = __webpack_require__(1768);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(211),
	    isObject = __webpack_require__(212);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 538 */
/***/ (function(module, exports) {

	'use strict';
	
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (newInputs[i] !== lastInputs[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	// Language contact person : Abdoufata Kane : https://github.com/abdoufata
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY H:mm',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    };
	var numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 653 */
/***/ (function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ }),
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1810);


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1872);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objectAssign = __webpack_require__(1866);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _object = __webpack_require__(1867);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _noop = __webpack_require__(1865);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props) {
	        _classCallCheck(this, _class);
	
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	        _this.state = {
	            isHovering: false
	        };
	
	        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	        _this.onMouseOver = _this.onMouseOver.bind(_this);
	        _this.onMouseOut = _this.onMouseOut.bind(_this);
	        _this.setIsHovering = _this.setIsHovering.bind(_this);
	        _this.unsetIsHovering = _this.unsetIsHovering.bind(_this);
	        _this.componentWillUnmount = _this.componentWillUnmount.bind(_this);
	
	        _this.timerIds = [];
	        return _this;
	    }
	
	    _createClass(_class, [{
	        key: 'onMouseEnter',
	        value: function onMouseEnter(e) {
	            this.props.onMouseEnter({
	                e: e,
	                setIsHovering: this.setIsHovering,
	                unsetIsHovering: this.unsetIsHovering
	            });
	        }
	    }, {
	        key: 'onMouseLeave',
	        value: function onMouseLeave(e) {
	            this.props.onMouseLeave({
	                e: e,
	                setIsHovering: this.setIsHovering,
	                unsetIsHovering: this.unsetIsHovering
	            });
	        }
	    }, {
	        key: 'onMouseOver',
	        value: function onMouseOver(e) {
	            this.props.onMouseOver({
	                e: e,
	                setIsHovering: this.setIsHovering,
	                unsetIsHovering: this.unsetIsHovering
	            });
	        }
	    }, {
	        key: 'onMouseOut',
	        value: function onMouseOut(e) {
	            this.props.onMouseOut({
	                e: e,
	                setIsHovering: this.setIsHovering,
	                unsetIsHovering: this.unsetIsHovering
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearTimers();
	        }
	    }, {
	        key: 'setIsHovering',
	        value: function setIsHovering() {
	            var _this2 = this;
	
	            this.clearTimers();
	
	            var hoverScheduleId = setTimeout(function () {
	                var newState = { isHovering: true };
	                _this2.setState(newState, function () {
	                    _this2.props.onHoverChanged(newState);
	                });
	            }, this.props.hoverDelayInMs);
	
	            this.timerIds.push(hoverScheduleId);
	        }
	    }, {
	        key: 'unsetIsHovering',
	        value: function unsetIsHovering() {
	            var _this3 = this;
	
	            this.clearTimers();
	
	            var hoverOffScheduleId = setTimeout(function () {
	                var newState = { isHovering: false };
	                _this3.setState(newState, function () {
	                    _this3.props.onHoverChanged(newState);
	                });
	            }, this.props.hoverOffDelayInMs);
	
	            this.timerIds.push(hoverOffScheduleId);
	        }
	    }, {
	        key: 'clearTimers',
	        value: function clearTimers() {
	            var ids = this.timerIds;
	            while (ids.length) {
	                clearTimeout(ids.pop());
	            }
	        }
	    }, {
	        key: 'isReactComponent',
	        value: function isReactComponent(reactElement) {
	            return typeof reactElement.type === 'function';
	        }
	    }, {
	        key: 'shouldDecorateChild',
	        value: function shouldDecorateChild(child) {
	            return !!child && this.isReactComponent(child) && this.props.shouldDecorateChildren;
	        }
	    }, {
	        key: 'decorateChild',
	        value: function decorateChild(child, props) {
	            return (0, _react.cloneElement)(child, props);
	        }
	    }, {
	        key: 'renderChildrenWithProps',
	        value: function renderChildrenWithProps(children, props) {
	            var _this4 = this;
	
	            return _react.Children.map(children, function (child) {
	                return _this4.shouldDecorateChild(child) ? _this4.decorateChild(child, props) : child;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                className = _props.className;
	
	            var childProps = (0, _objectAssign2.default)({}, { isHovering: this.state.isHovering }, (0, _object2.default)(this.props, ['children', 'className', 'hoverDelayInMs', 'hoverOffDelayInMs', 'onHoverChanged', 'onMouseEnter', 'onMouseLeave', 'onMouseOver', 'onMouseOut', 'shouldDecorateChildren']));
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: className,
	                    onMouseEnter: this.onMouseEnter,
	                    onMouseLeave: this.onMouseLeave,
	                    onMouseOver: this.onMouseOver,
	                    onMouseOut: this.onMouseOut
	                },
	                this.renderChildrenWithProps(children, childProps)
	            );
	        }
	    }]);
	
	    return _class;
	}(_react2.default.Component);
	
	_class.displayName = 'ReactHoverObserver';
	_class.defaultProps = {
	    hoverDelayInMs: 0,
	    hoverOffDelayInMs: 0,
	    onHoverChanged: _noop2.default,
	    onMouseEnter: function onMouseEnter(_ref) {
	        var setIsHovering = _ref.setIsHovering;
	        return setIsHovering();
	    },
	    onMouseLeave: function onMouseLeave(_ref2) {
	        var unsetIsHovering = _ref2.unsetIsHovering;
	        return unsetIsHovering();
	    },
	    onMouseOver: _noop2.default,
	    onMouseOut: _noop2.default,
	    shouldDecorateChildren: true
	};
	_class.propTypes = {
	    className: _propTypes2.default.string,
	    hoverDelayInMs: _propTypes2.default.number,
	    hoverOffDelayInMs: _propTypes2.default.number,
	    onHoverChanged: _propTypes2.default.func,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseOver: _propTypes2.default.func,
	    onMouseOut: _propTypes2.default.func,
	    shouldDecorateChildren: _propTypes2.default.bool
	};
	exports.default = _class;
	;

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(688);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1892)();
	}


/***/ }),
/* 689 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(691);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(689);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1897);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1896);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(136);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(125);
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(377);
	
	var _ContextUtils = __webpack_require__(376);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(136);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(125);
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(143);
	
	var _PatternUtils = __webpack_require__(187);
	
	var _InternalPropTypes = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 695 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(702);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(701);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1923);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(699);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(188);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1906);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1903);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1910);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1907);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1912);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(702);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(701);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(382);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1924);
	
	var _runTransitionHook = __webpack_require__(382);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(189);
	
	var _PathUtils = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeAsyncSelect = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Select = _interopRequireDefault(__webpack_require__(269));
	
	var _utils = __webpack_require__(271);
	
	var _stateManager = _interopRequireDefault(__webpack_require__(270));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultProps = {
	  cacheOptions: false,
	  defaultOptions: false,
	  filterOption: null
	};
	exports.defaultProps = defaultProps;
	
	var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Async, _Component);
	
	    function Async(props) {
	      var _this;
	
	      _classCallCheck(this, Async);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Async).call(this));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastRequest", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionsCache", {});
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (newValue, actionMeta) {
	        var _this$props = _this.props,
	            cacheOptions = _this$props.cacheOptions,
	            onInputChange = _this$props.onInputChange; // TODO
	
	        var inputValue = (0, _utils.handleInputChange)(newValue, actionMeta, onInputChange);
	
	        if (!inputValue) {
	          delete _this.lastRequest;
	
	          _this.setState({
	            inputValue: '',
	            loadedInputValue: '',
	            loadedOptions: [],
	            isLoading: false,
	            passEmptyOptions: false
	          });
	
	          return;
	        }
	
	        if (cacheOptions && _this.optionsCache[inputValue]) {
	          _this.setState({
	            inputValue: inputValue,
	            loadedInputValue: inputValue,
	            loadedOptions: _this.optionsCache[inputValue],
	            isLoading: false,
	            passEmptyOptions: false
	          });
	        } else {
	          var request = _this.lastRequest = {};
	
	          _this.setState({
	            inputValue: inputValue,
	            isLoading: true,
	            passEmptyOptions: !_this.state.loadedInputValue
	          }, function () {
	            _this.loadOptions(inputValue, function (options) {
	              if (!_this.mounted) return;
	
	              if (options) {
	                _this.optionsCache[inputValue] = options;
	              }
	
	              if (request !== _this.lastRequest) return;
	              delete _this.lastRequest;
	
	              _this.setState({
	                isLoading: false,
	                loadedInputValue: inputValue,
	                loadedOptions: options || [],
	                passEmptyOptions: false
	              });
	            });
	          });
	        }
	
	        return inputValue;
	      });
	
	      _this.state = {
	        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
	        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
	        isLoading: props.defaultOptions === true ? true : false,
	        loadedOptions: [],
	        passEmptyOptions: false
	      };
	      return _this;
	    }
	
	    _createClass(Async, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        this.mounted = true;
	        var defaultOptions = this.props.defaultOptions;
	        var inputValue = this.state.inputValue;
	
	        if (defaultOptions === true) {
	          this.loadOptions(inputValue, function (options) {
	            if (!_this2.mounted) return;
	            var isLoading = !!_this2.lastRequest;
	
	            _this2.setState({
	              defaultOptions: options || [],
	              isLoading: isLoading
	            });
	          });
	        }
	      }
	    }, {
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        // if the cacheOptions prop changes, clear the cache
	        if (nextProps.cacheOptions !== this.props.cacheOptions) {
	          this.optionsCache = {};
	        }
	
	        if (nextProps.defaultOptions !== this.props.defaultOptions) {
	          this.setState({
	            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
	          });
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.mounted = false;
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      }
	    }, {
	      key: "loadOptions",
	      value: function loadOptions(inputValue, callback) {
	        var loadOptions = this.props.loadOptions;
	        if (!loadOptions) return callback();
	        var loader = loadOptions(inputValue, callback);
	
	        if (loader && typeof loader.then === 'function') {
	          loader.then(callback, function () {
	            return callback();
	          });
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this3 = this;
	
	        var _this$props2 = this.props,
	            loadOptions = _this$props2.loadOptions,
	            props = _objectWithoutProperties(_this$props2, ["loadOptions"]);
	
	        var _this$state = this.state,
	            defaultOptions = _this$state.defaultOptions,
	            inputValue = _this$state.inputValue,
	            isLoading = _this$state.isLoading,
	            loadedInputValue = _this$state.loadedInputValue,
	            loadedOptions = _this$state.loadedOptions,
	            passEmptyOptions = _this$state.passEmptyOptions;
	        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
	        return _react.default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this3.select = _ref;
	          },
	          options: options,
	          isLoading: isLoading,
	          onInputChange: this.handleInputChange
	        }));
	      }
	    }]);
	
	    return Async;
	  }(_react.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	};
	
	exports.makeAsyncSelect = makeAsyncSelect;
	var SelectState = (0, _stateManager.default)(_Select.default);
	
	var _default = makeAsyncSelect(SelectState);
	
	exports.default = _default;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeCreatableSelect = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Select = _interopRequireDefault(__webpack_require__(269));
	
	var _utils = __webpack_require__(271);
	
	var _stateManager = _interopRequireDefault(__webpack_require__(270));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var compareOption = function compareOption() {
	  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var option = arguments.length > 1 ? arguments[1] : undefined;
	  var candidate = String(inputValue).toLowerCase();
	  var optionValue = String(option.value).toLowerCase();
	  var optionLabel = String(option.label).toLowerCase();
	  return optionValue === candidate || optionLabel === candidate;
	};
	
	var builtins = {
	  formatCreateLabel: function formatCreateLabel(inputValue) {
	    return "Create \"".concat(inputValue, "\"");
	  },
	  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
	    return !(!inputValue || selectValue.some(function (option) {
	      return compareOption(inputValue, option);
	    }) || selectOptions.some(function (option) {
	      return compareOption(inputValue, option);
	    }));
	  },
	  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
	    return {
	      label: optionLabel,
	      value: inputValue,
	      __isNew__: true
	    };
	  }
	};
	
	var defaultProps = _objectSpread({
	  allowCreateWhileLoading: false,
	  createOptionPosition: 'last'
	}, builtins);
	
	exports.defaultProps = defaultProps;
	
	var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Creatable, _Component);
	
	    function Creatable(props) {
	      var _this;
	
	      _classCallCheck(this, Creatable);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Creatable).call(this, props));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
	        var _this$props = _this.props,
	            getNewOptionData = _this$props.getNewOptionData,
	            inputValue = _this$props.inputValue,
	            isMulti = _this$props.isMulti,
	            onChange = _this$props.onChange,
	            onCreateOption = _this$props.onCreateOption,
	            value = _this$props.value;
	
	        if (actionMeta.action !== 'select-option') {
	          return onChange(newValue, actionMeta);
	        }
	
	        var newOption = _this.state.newOption;
	        var valueArray = Array.isArray(newValue) ? newValue : [newValue];
	
	        if (valueArray[valueArray.length - 1] === newOption) {
	          if (onCreateOption) onCreateOption(inputValue);else {
	            var newOptionData = getNewOptionData(inputValue, inputValue);
	            var newActionMeta = {
	              action: 'create-option'
	            };
	
	            if (isMulti) {
	              onChange([].concat(_toConsumableArray((0, _utils.cleanValue)(value)), [newOptionData]), newActionMeta);
	            } else {
	              onChange(newOptionData, newActionMeta);
	            }
	          }
	          return;
	        }
	
	        onChange(newValue, actionMeta);
	      });
	
	      var options = props.options || [];
	      _this.state = {
	        newOption: undefined,
	        options: options
	      };
	      return _this;
	    }
	
	    _createClass(Creatable, [{
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
	            createOptionPosition = nextProps.createOptionPosition,
	            formatCreateLabel = nextProps.formatCreateLabel,
	            getNewOptionData = nextProps.getNewOptionData,
	            inputValue = nextProps.inputValue,
	            isLoading = nextProps.isLoading,
	            isValidNewOption = nextProps.isValidNewOption,
	            value = nextProps.value;
	        var options = nextProps.options || [];
	        var newOption = this.state.newOption;
	
	        if (isValidNewOption(inputValue, (0, _utils.cleanValue)(value), options)) {
	          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
	        } else {
	          newOption = undefined;
	        }
	
	        this.setState({
	          newOption: newOption,
	          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(options)) : [].concat(_toConsumableArray(options), [newOption]) : options
	        });
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var props = _extends({}, this.props);
	
	        var options = this.state.options;
	        return _react.default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          options: options,
	          onChange: this.onChange
	        }));
	      }
	    }]);
	
	    return Creatable;
	  }(_react.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	}; // TODO: do this in package entrypoint
	
	
	exports.makeCreatableSelect = makeCreatableSelect;
	var SelectCreatable = makeCreatableSelect(_Select.default);
	
	var _default = (0, _stateManager.default)(SelectCreatable);
	
	exports.default = _default;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.css = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      _ref$theme = _ref.theme,
	      colors = _ref$theme.colors,
	      borderRadius = _ref$theme.borderRadius,
	      spacing = _ref$theme.spacing;
	  return {
	    label: 'control',
	    alignItems: 'center',
	    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
	    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
	    borderRadius: borderRadius,
	    borderStyle: 'solid',
	    borderWidth: 1,
	    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
	    cursor: 'default',
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'space-between',
	    minHeight: spacing.controlHeight,
	    outline: '0 !important',
	    position: 'relative',
	    transition: 'all 100ms',
	    '&:hover': {
	      borderColor: isFocused ? colors.primary : colors.neutral30
	    }
	  };
	};
	
	exports.css = css;
	
	var Control = function Control(props) {
	  var children = props.children,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      className = props.className,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps,
	      menuIsOpen = props.menuIsOpen;
	  return _react.default.createElement("div", _extends({
	    ref: innerRef,
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('control', props)), {
	      'control': true,
	      'control--is-disabled': isDisabled,
	      'control--is-focused': isFocused,
	      'control--menu-is-open': menuIsOpen
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = Control;
	exports.default = _default;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GroupHeading = exports.groupHeadingCSS = exports.groupCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var groupCSS = function groupCSS(_ref) {
	  var spacing = _ref.theme.spacing;
	  return {
	    paddingBottom: spacing.baseUnit * 2,
	    paddingTop: spacing.baseUnit * 2
	  };
	};
	
	exports.groupCSS = groupCSS;
	
	var Group = function Group(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      Heading = props.Heading,
	      headingProps = props.headingProps,
	      label = props.label,
	      theme = props.theme,
	      selectProps = props.selectProps;
	  return _react.default.createElement("div", {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('group', props)), {
	      'group': true
	    }, className)
	  }, _react.default.createElement(Heading, _extends({}, headingProps, {
	    selectProps: selectProps,
	    theme: theme,
	    getStyles: getStyles,
	    cx: cx
	  }), label), _react.default.createElement("div", null, children));
	};
	
	var groupHeadingCSS = function groupHeadingCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    label: 'group',
	    color: '#999',
	    cursor: 'default',
	    display: 'block',
	    fontSize: '75%',
	    fontWeight: '500',
	    marginBottom: '0.25em',
	    paddingLeft: spacing.baseUnit * 3,
	    paddingRight: spacing.baseUnit * 3,
	    textTransform: 'uppercase'
	  };
	};
	
	exports.groupHeadingCSS = groupHeadingCSS;
	
	var GroupHeading = function GroupHeading(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      theme = props.theme,
	      selectProps = props.selectProps,
	      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);
	
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('groupHeading', _objectSpread({
	      theme: theme
	    }, cleanProps))), {
	      'group-heading': true
	    }, className)
	  }, cleanProps));
	};
	
	exports.GroupHeading = GroupHeading;
	var _default = Group;
	exports.default = _default;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.inputCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	var _reactInputAutosize = _interopRequireDefault(__webpack_require__(1876));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var inputCSS = function inputCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    margin: spacing.baseUnit / 2,
	    paddingBottom: spacing.baseUnit / 2,
	    paddingTop: spacing.baseUnit / 2,
	    visibility: isDisabled ? 'hidden' : 'visible',
	    color: colors.neutral80
	  };
	};
	
	exports.inputCSS = inputCSS;
	
	var inputStyle = function inputStyle(isHidden) {
	  return {
	    label: 'input',
	    background: 0,
	    border: 0,
	    fontSize: 'inherit',
	    opacity: isHidden ? 0 : 1,
	    outline: 0,
	    padding: 0,
	    color: 'inherit'
	  };
	};
	
	var Input = function Input(_ref2) {
	  var className = _ref2.className,
	      cx = _ref2.cx,
	      getStyles = _ref2.getStyles,
	      innerRef = _ref2.innerRef,
	      isHidden = _ref2.isHidden,
	      isDisabled = _ref2.isDisabled,
	      theme = _ref2.theme,
	      selectProps = _ref2.selectProps,
	      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);
	
	  return _react.default.createElement("div", {
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('input', _objectSpread({
	      theme: theme
	    }, props)))
	  }, _react.default.createElement(_reactInputAutosize.default, _extends({
	    className: cx(null, {
	      'input': true
	    }, className),
	    inputRef: innerRef,
	    inputStyle: inputStyle(isHidden),
	    disabled: isDisabled
	  }, props)));
	};
	
	var _default = Input;
	exports.default = _default;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MultiValueRemove = exports.MultiValueLabel = exports.MultiValueContainer = exports.MultiValueGeneric = exports.multiValueRemoveCSS = exports.multiValueLabelCSS = exports.multiValueCSS = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	var _indicators = __webpack_require__(386);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var multiValueCSS = function multiValueCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      borderRadius = _ref$theme.borderRadius,
	      colors = _ref$theme.colors;
	  return {
	    label: 'multiValue',
	    backgroundColor: colors.neutral10,
	    borderRadius: borderRadius / 2,
	    display: 'flex',
	    margin: spacing.baseUnit / 2,
	    minWidth: 0 // resolves flex/text-overflow bug
	
	  };
	};
	
	exports.multiValueCSS = multiValueCSS;
	
	var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
	  var _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      colors = _ref2$theme.colors,
	      cropWithEllipsis = _ref2.cropWithEllipsis;
	  return {
	    borderRadius: borderRadius / 2,
	    color: colors.neutral80,
	    fontSize: '85%',
	    overflow: 'hidden',
	    padding: 3,
	    paddingLeft: 6,
	    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
	    whiteSpace: 'nowrap'
	  };
	};
	
	exports.multiValueLabelCSS = multiValueLabelCSS;
	
	var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
	  var _ref3$theme = _ref3.theme,
	      spacing = _ref3$theme.spacing,
	      borderRadius = _ref3$theme.borderRadius,
	      colors = _ref3$theme.colors,
	      isFocused = _ref3.isFocused;
	  return {
	    alignItems: 'center',
	    borderRadius: borderRadius / 2,
	    backgroundColor: isFocused && colors.dangerLight,
	    display: 'flex',
	    paddingLeft: spacing.baseUnit,
	    paddingRight: spacing.baseUnit,
	    ':hover': {
	      backgroundColor: colors.dangerLight,
	      color: colors.danger
	    }
	  };
	};
	
	exports.multiValueRemoveCSS = multiValueRemoveCSS;
	
	var MultiValueGeneric = function MultiValueGeneric(_ref4) {
	  var children = _ref4.children,
	      innerProps = _ref4.innerProps;
	  return _react.default.createElement("div", innerProps, children);
	};
	
	exports.MultiValueGeneric = MultiValueGeneric;
	var MultiValueContainer = MultiValueGeneric;
	exports.MultiValueContainer = MultiValueContainer;
	var MultiValueLabel = MultiValueGeneric;
	exports.MultiValueLabel = MultiValueLabel;
	
	var MultiValueRemove =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MultiValueRemove, _Component);
	
	  function MultiValueRemove() {
	    _classCallCheck(this, MultiValueRemove);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValueRemove).apply(this, arguments));
	  }
	
	  _createClass(MultiValueRemove, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          innerProps = _this$props.innerProps;
	      return _react.default.createElement("div", innerProps, children || _react.default.createElement(_indicators.CrossIcon, {
	        size: 14
	      }));
	    }
	  }]);
	
	  return MultiValueRemove;
	}(_react.Component);
	
	exports.MultiValueRemove = MultiValueRemove;
	
	var MultiValue =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MultiValue, _Component2);
	
	  function MultiValue() {
	    _classCallCheck(this, MultiValue);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValue).apply(this, arguments));
	  }
	
	  _createClass(MultiValue, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          components = _this$props2.components,
	          cx = _this$props2.cx,
	          data = _this$props2.data,
	          getStyles = _this$props2.getStyles,
	          innerProps = _this$props2.innerProps,
	          isDisabled = _this$props2.isDisabled,
	          removeProps = _this$props2.removeProps,
	          selectProps = _this$props2.selectProps;
	      var Container = components.Container,
	          Label = components.Label,
	          Remove = components.Remove;
	
	      var containerInnerProps = _objectSpread({
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('multiValue', this.props)), {
	          'multi-value': true,
	          'multi-value--is-disabled': isDisabled
	        }, className)
	      }, innerProps);
	
	      var labelInnerProps = {
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('multiValueLabel', this.props)), {
	          'multi-value__label': true
	        }, className)
	      };
	
	      var removeInnerProps = _objectSpread({
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('multiValueRemove', this.props)), {
	          'multi-value__remove': true
	        }, className)
	      }, removeProps);
	
	      return _react.default.createElement(Container, {
	        data: data,
	        innerProps: containerInnerProps,
	        selectProps: selectProps
	      }, _react.default.createElement(Label, {
	        data: data,
	        innerProps: labelInnerProps,
	        selectProps: selectProps
	      }, children), _react.default.createElement(Remove, {
	        data: data,
	        innerProps: removeInnerProps,
	        selectProps: selectProps
	      }));
	    }
	  }]);
	
	  return MultiValue;
	}(_react.Component);
	
	_defineProperty(MultiValue, "defaultProps", {
	  cropWithEllipsis: true
	});
	
	var _default = MultiValue;
	exports.default = _default;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.optionCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var optionCSS = function optionCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      isSelected = _ref.isSelected,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'option',
	    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
	    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
	    cursor: 'default',
	    display: 'block',
	    fontSize: 'inherit',
	    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
	    width: '100%',
	    userSelect: 'none',
	    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	    // provide some affordance on touch devices
	    ':active': {
	      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
	    }
	  };
	};
	
	exports.optionCSS = optionCSS;
	
	var Option = function Option(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      isSelected = props.isSelected,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    ref: innerRef,
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('option', props)), {
	      'option': true,
	      'option--is-disabled': isDisabled,
	      'option--is-focused': isFocused,
	      'option--is-selected': isSelected
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = Option;
	exports.default = _default;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.placeholderCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var placeholderCSS = function placeholderCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'placeholder',
	    color: colors.neutral50,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    position: 'absolute',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	exports.placeholderCSS = placeholderCSS;
	
	var Placeholder = function Placeholder(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('placeholder', props)), {
	      'placeholder': true
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = Placeholder;
	exports.default = _default;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.css = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'singleValue',
	    color: isDisabled ? colors.neutral40 : colors.neutral80,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
	    overflow: 'hidden',
	    position: 'absolute',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	exports.css = css;
	
	var SingleValue = function SingleValue(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('singleValue', props)), {
	      'single-value': true,
	      'single-value--is-disabled': isDisabled
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = SingleValue;
	exports.default = _default;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndicatorsContainer = exports.indicatorsContainerCSS = exports.ValueContainer = exports.valueContainerCSS = exports.SelectContainer = exports.containerCSS = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var containerCSS = function containerCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isRtl = _ref.isRtl;
	  return {
	    label: 'container',
	    direction: isRtl ? 'rtl' : null,
	    pointerEvents: isDisabled ? 'none' : null,
	    // cancel mouse events when disabled
	    position: 'relative'
	  };
	};
	
	exports.containerCSS = containerCSS;
	
	var SelectContainer = function SelectContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isDisabled = props.isDisabled,
	      isRtl = props.isRtl;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('container', props)), {
	      '--is-disabled': isDisabled,
	      '--is-rtl': isRtl
	    }, className)
	  }, innerProps), children);
	}; // ==============================
	// Value Container
	// ==============================
	
	
	exports.SelectContainer = SelectContainer;
	
	var valueContainerCSS = function valueContainerCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    alignItems: 'center',
	    display: 'flex',
	    flex: 1,
	    flexWrap: 'wrap',
	    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
	    WebkitOverflowScrolling: 'touch',
	    position: 'relative',
	    overflow: 'hidden'
	  };
	};
	
	exports.valueContainerCSS = valueContainerCSS;
	
	var ValueContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ValueContainer, _Component);
	
	  function ValueContainer() {
	    _classCallCheck(this, ValueContainer);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ValueContainer).apply(this, arguments));
	  }
	
	  _createClass(ValueContainer, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          cx = _this$props.cx,
	          isMulti = _this$props.isMulti,
	          getStyles = _this$props.getStyles,
	          hasValue = _this$props.hasValue;
	      return _react.default.createElement("div", {
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('valueContainer', this.props)), {
	          'value-container': true,
	          'value-container--is-multi': isMulti,
	          'value-container--has-value': hasValue
	        }, className)
	      }, children);
	    }
	  }]);
	
	  return ValueContainer;
	}(_react.Component); // ==============================
	// Indicator Container
	// ==============================
	
	
	exports.ValueContainer = ValueContainer;
	
	var indicatorsContainerCSS = function indicatorsContainerCSS() {
	  return {
	    alignItems: 'center',
	    alignSelf: 'stretch',
	    display: 'flex',
	    flexShrink: 0
	  };
	};
	
	exports.indicatorsContainerCSS = indicatorsContainerCSS;
	
	var IndicatorsContainer = function IndicatorsContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles;
	  return _react.default.createElement("div", {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('indicatorsContainer', props)), {
	      'indicators': true
	    }, className)
	  }, children);
	};
	
	exports.IndicatorsContainer = IndicatorsContainer;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFilter = void 0;
	
	var _diacritics = __webpack_require__(1941);
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var trimString = function trimString(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	var defaultStringify = function defaultStringify(option) {
	  return "".concat(option.label, " ").concat(option.value);
	};
	
	var createFilter = function createFilter(config) {
	  return function (option, rawInput) {
	    var _ignoreCase$ignoreAcc = _objectSpread({
	      ignoreCase: true,
	      ignoreAccents: true,
	      stringify: defaultStringify,
	      trim: true,
	      matchFrom: 'any'
	    }, config),
	        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
	        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
	        stringify = _ignoreCase$ignoreAcc.stringify,
	        trim = _ignoreCase$ignoreAcc.trim,
	        matchFrom = _ignoreCase$ignoreAcc.matchFrom;
	
	    var input = trim ? trimString(rawInput) : rawInput;
	    var candidate = trim ? trimString(stringify(option)) : stringify(option);
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	      candidate = candidate.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = (0, _diacritics.stripDiacritics)(input);
	      candidate = (0, _diacritics.stripDiacritics)(candidate);
	    }
	
	    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
	  };
	};
	
	exports.createFilter = createFilter;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "SelectBase", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "Async", {
	  enumerable: true,
	  get: function get() {
	    return _Async.default;
	  }
	});
	Object.defineProperty(exports, "makeAsyncSelect", {
	  enumerable: true,
	  get: function get() {
	    return _Async.makeAsyncSelect;
	  }
	});
	Object.defineProperty(exports, "AsyncCreatable", {
	  enumerable: true,
	  get: function get() {
	    return _AsyncCreatable.default;
	  }
	});
	Object.defineProperty(exports, "Creatable", {
	  enumerable: true,
	  get: function get() {
	    return _Creatable.default;
	  }
	});
	Object.defineProperty(exports, "makeCreatableSelect", {
	  enumerable: true,
	  get: function get() {
	    return _Creatable.makeCreatableSelect;
	  }
	});
	Object.defineProperty(exports, "createFilter", {
	  enumerable: true,
	  get: function get() {
	    return _filters.createFilter;
	  }
	});
	Object.defineProperty(exports, "makeAnimated", {
	  enumerable: true,
	  get: function get() {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "components", {
	  enumerable: true,
	  get: function get() {
	    return _index2.components;
	  }
	});
	Object.defineProperty(exports, "mergeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _styles.mergeStyles;
	  }
	});
	Object.defineProperty(exports, "defaultTheme", {
	  enumerable: true,
	  get: function get() {
	    return _theme.defaultTheme;
	  }
	});
	exports.default = void 0;
	
	var _Select = _interopRequireDefault(__webpack_require__(269));
	
	var _stateManager = _interopRequireDefault(__webpack_require__(270));
	
	var _Async = _interopRequireWildcard(__webpack_require__(703));
	
	var _AsyncCreatable = _interopRequireDefault(__webpack_require__(1932));
	
	var _Creatable = _interopRequireWildcard(__webpack_require__(704));
	
	var _filters = __webpack_require__(713);
	
	var _index = _interopRequireDefault(__webpack_require__(1939));
	
	var _index2 = __webpack_require__(385);
	
	var _styles = __webpack_require__(716);
	
	var _theme = __webpack_require__(717);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _stateManager.default)(_Select.default);
	
	exports.default = _default;

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exportedEqual;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
	    var arrA = isArray(a),
	        arrB = isArray(b),
	        i,
	        length,
	        key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	
	      for (i = length; i-- !== 0;) {
	        if (!equal(a[i], b[i])) return false;
	      }
	
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	    var dateA = a instanceof Date,
	        dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	    var regexpA = a instanceof RegExp,
	        regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length) {
	      return false;
	    }
	
	    for (i = length; i-- !== 0;) {
	      if (!hasProp.call(b, keys[i])) return false;
	    } // end fast-deep-equal
	    // Custom handling for React
	
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    } // fast-deep-equal index.js 2.0.1
	
	
	    return true;
	  }
	
	  return a !== a && b !== b;
	} // end fast-deep-equal
	
	
	function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (error.message && error.message.match(/stack|recursion/i)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    } // some other error. we should definitely know about these
	
	
	    throw error;
	  }
	}
	
	;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeStyles = mergeStyles;
	exports.defaultStyles = void 0;
	
	var _containers = __webpack_require__(712);
	
	var _Control = __webpack_require__(705);
	
	var _Group = __webpack_require__(706);
	
	var _indicators = __webpack_require__(386);
	
	var _Input = __webpack_require__(707);
	
	var _Placeholder = __webpack_require__(710);
	
	var _Option = __webpack_require__(709);
	
	var _Menu = __webpack_require__(384);
	
	var _SingleValue = __webpack_require__(711);
	
	var _MultiValue = __webpack_require__(708);
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultStyles = {
	  clearIndicator: _indicators.clearIndicatorCSS,
	  container: _containers.containerCSS,
	  control: _Control.css,
	  dropdownIndicator: _indicators.dropdownIndicatorCSS,
	  group: _Group.groupCSS,
	  groupHeading: _Group.groupHeadingCSS,
	  indicatorsContainer: _containers.indicatorsContainerCSS,
	  indicatorSeparator: _indicators.indicatorSeparatorCSS,
	  input: _Input.inputCSS,
	  loadingIndicator: _indicators.loadingIndicatorCSS,
	  loadingMessage: _Menu.loadingMessageCSS,
	  menu: _Menu.menuCSS,
	  menuList: _Menu.menuListCSS,
	  menuPortal: _Menu.menuPortalCSS,
	  multiValue: _MultiValue.multiValueCSS,
	  multiValueLabel: _MultiValue.multiValueLabelCSS,
	  multiValueRemove: _MultiValue.multiValueRemoveCSS,
	  noOptionsMessage: _Menu.noOptionsMessageCSS,
	  option: _Option.optionCSS,
	  placeholder: _Placeholder.placeholderCSS,
	  singleValue: _SingleValue.css,
	  valueContainer: _containers.valueContainerCSS
	}; // Merge Utility
	// Allows consumers to extend a base Select with additional styles
	
	exports.defaultStyles = defaultStyles;
	
	function mergeStyles(source) {
	  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  // initialize with source styles
	  var styles = _objectSpread({}, source); // massage in target styles
	
	
	  Object.keys(target).forEach(function (key) {
	    if (source[key]) {
	      styles[key] = function (rsCss, props) {
	        return target[key](source[key](rsCss, props), props);
	      };
	    } else {
	      styles[key] = target[key];
	    }
	  });
	  return styles;
	}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultTheme = exports.spacing = exports.colors = void 0;
	var colors = {
	  primary: '#2684FF',
	  primary75: '#4C9AFF',
	  primary50: '#B2D4FF',
	  primary25: '#DEEBFF',
	  danger: '#DE350B',
	  dangerLight: '#FFBDAD',
	  neutral0: 'hsl(0, 0%, 100%)',
	  neutral5: 'hsl(0, 0%, 95%)',
	  neutral10: 'hsl(0, 0%, 90%)',
	  neutral20: 'hsl(0, 0%, 80%)',
	  neutral30: 'hsl(0, 0%, 70%)',
	  neutral40: 'hsl(0, 0%, 60%)',
	  neutral50: 'hsl(0, 0%, 50%)',
	  neutral60: 'hsl(0, 0%, 40%)',
	  neutral70: 'hsl(0, 0%, 30%)',
	  neutral80: 'hsl(0, 0%, 20%)',
	  neutral90: 'hsl(0, 0%, 10%)'
	};
	exports.colors = colors;
	var borderRadius = 4;
	var baseUnit = 4;
	/* Used to calculate consistent margin/padding on elements */
	
	var controlHeight = 38;
	/* The minimum height of the control */
	
	var menuGutter = baseUnit * 2;
	/* The amount of space between the control and menu */
	
	var spacing = {
	  baseUnit: baseUnit,
	  controlHeight: controlHeight,
	  menuGutter: menuGutter
	};
	exports.spacing = spacing;
	var defaultTheme = {
	  borderRadius: borderRadius,
	  colors: colors,
	  spacing: spacing
	};
	exports.defaultTheme = defaultTheme;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(77));
	
	var _reactLifecyclesCompat = __webpack_require__(685);
	
	var _PropTypes = __webpack_require__(721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(685);
	
	var _ChildMapping = __webpack_require__(1962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(1960));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1961));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(719));
	
	var _Transition = _interopRequireDefault(__webpack_require__(718));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ }),
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(349);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1984);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 733 */
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  manager: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var Bezel =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Bezel, _Component);
	
	  function Bezel(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Bezel);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bezel).call(this, props, context));
	    _this.timer = null;
	    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
	    _this.state = {
	      hidden: true,
	      operation: {}
	    };
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Bezel, [{
	    key: "handleStateChange",
	    value: function handleStateChange(state, prevState) {
	      var _this2 = this;
	
	      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
	        if (this.timer) {
	          // previous animation is not finished
	          clearTimeout(this.timer); // cancel it
	
	          this.timer = null;
	        } // show it
	        // update operation
	
	
	        this.setState({
	          hidden: false,
	          count: state.count,
	          operation: state.operation
	        }); // hide it after 0.5s
	
	        this.timer = setTimeout(function () {
	          _this2.setState({
	            hidden: true
	          });
	
	          _this2.timer = null;
	        }, 500);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      // only displays for shortcut so far
	      if (this.state.operation.source !== 'shortcut') {
	        return null;
	      }
	
	      var style = this.state.hidden ? {
	        display: 'none'
	      } : null;
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])({
	          'video-react-bezel': true,
	          'video-react-bezel-animation': this.state.count % 2 === 0,
	          'video-react-bezel-animation-alt': this.state.count % 2 === 1
	        }, this.props.className),
	        style: style,
	        role: "status",
	        "aria-label": this.state.operation.action
	      }, _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('video-react-bezel-icon', "video-react-bezel-icon-".concat(this.state.operation.action))
	      }));
	    }
	  }]);
	  return Bezel;
	}(_react.Component);
	
	exports["default"] = Bezel;
	Bezel.propTypes = propTypes;
	Bezel.displayName = 'Bezel';

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  position: _propTypes["default"].string,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  position: 'left'
	};
	
	var BigPlayButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(BigPlayButton, _Component);
	
	  function BigPlayButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, BigPlayButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BigPlayButton).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(BigPlayButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "handleClick",
	    value: function handleClick() {
	      var actions = this.props.actions;
	      actions.play();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          position = _this$props.position;
	      return _react["default"].createElement("button", {
	        className: (0, _classnames["default"])('video-react-button', 'video-react-big-play-button', "video-react-big-play-button-".concat(position), this.props.className, {
	          'big-play-button-hide': player.hasStarted || !player.currentSrc
	        }),
	        type: "button",
	        "aria-live": "polite",
	        tabIndex: "0",
	        onClick: this.handleClick
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Play Video"));
	    }
	  }]);
	  return BigPlayButton;
	}(_react.Component);
	
	exports["default"] = BigPlayButton;
	BigPlayButton.propTypes = propTypes;
	BigPlayButton.defaultProps = defaultProps;
	BigPlayButton.displayName = 'BigPlayButton';

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(191));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(138));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  tagName: _propTypes["default"].string,
	  onClick: _propTypes["default"].func.isRequired,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  tagName: 'div'
	};
	
	var ClickableComponent =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ClickableComponent, _Component);
	
	  function ClickableComponent(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ClickableComponent);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClickableComponent).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ClickableComponent, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount(e) {
	      this.handleBlur(e);
	    }
	  }, {
	    key: "handleKeypress",
	    value: function handleKeypress(event) {
	      // Support Space (32) or Enter (13) key operation to fire a click event
	      if (event.which === 32 || event.which === 13) {
	        event.preventDefault();
	        this.handleClick(event);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      var onClick = this.props.onClick;
	      onClick(event);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(e) {
	      document.addEventListener('keydown', this.handleKeypress);
	
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(e) {
	      document.removeEventListener('keydown', this.handleKeypress);
	
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var Tag = this.props.tagName;
	      var props = (0, _objectSpread2["default"])({}, this.props);
	      delete props.tagName;
	      delete props.className;
	      return _react["default"].createElement(Tag, (0, _extends2["default"])({
	        className: (0, _classnames["default"])(this.props.className),
	        role: "button",
	        tabIndex: "0",
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, props));
	    }
	  }]);
	  return ClickableComponent;
	}(_react.Component);
	
	exports["default"] = ClickableComponent;
	ClickableComponent.propTypes = propTypes;
	ClickableComponent.defaultProps = defaultProps;
	ClickableComponent.displayName = 'ClickableComponent';

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = LoadingSpinner;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function LoadingSpinner(_ref) {
	  var player = _ref.player,
	      className = _ref.className;
	
	  if (player.error) {
	    return null;
	  }
	
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-loading-spinner', className)
	  });
	}
	
	LoadingSpinner.propTypes = propTypes;
	LoadingSpinner.displayName = 'LoadingSpinner';

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  poster: _propTypes["default"].string,
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function PosterImage(_ref) {
	  var poster = _ref.poster,
	      player = _ref.player,
	      actions = _ref.actions,
	      className = _ref.className;
	
	  if (!poster || player.hasStarted) {
	    return null;
	  }
	
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-poster', className),
	    style: {
	      backgroundImage: "url(\"".concat(poster, "\")")
	    },
	    onClick: function onClick() {
	      if (player.paused) {
	        actions.play();
	      }
	    }
	  });
	}
	
	PosterImage.propTypes = propTypes;
	PosterImage.displayName = 'PosterImage';
	var _default = PosterImage;
	exports["default"] = _default;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(274));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(395));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _dom = __webpack_require__(273);
	
	var propTypes = {
	  clickable: _propTypes["default"].bool,
	  dblclickable: _propTypes["default"].bool,
	  manager: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  shortcuts: _propTypes["default"].array
	};
	var defaultProps = {
	  clickable: true,
	  dblclickable: true
	};
	
	var Shortcut =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Shortcut, _Component);
	
	  function Shortcut(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Shortcut);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Shortcut).call(this, props, context));
	    _this.defaultShortcuts = [{
	      keyCode: 32,
	      // spacebar
	      handle: _this.togglePlay
	    }, {
	      keyCode: 75,
	      // k
	      handle: _this.togglePlay
	    }, {
	      keyCode: 70,
	      // f
	      handle: _this.toggleFullscreen
	    }, {
	      keyCode: 37,
	      // Left arrow
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.replay(5, {
	          action: 'replay-5',
	          source: 'shortcut'
	        }); // Go back 5 seconds
	      }
	    }, {
	      keyCode: 74,
	      // j
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.replay(10, {
	          action: 'replay-10',
	          source: 'shortcut'
	        }); // Go back 10 seconds
	      }
	    }, {
	      keyCode: 39,
	      // Right arrow
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.forward(5, {
	          action: 'forward-5',
	          source: 'shortcut'
	        }); // Go forward 5 seconds
	      }
	    }, {
	      keyCode: 76,
	      // l
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.forward(10, {
	          action: 'forward-10',
	          source: 'shortcut'
	        }); // Go forward 10 seconds
	      }
	    }, {
	      keyCode: 36,
	      // Home
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.seek(0); // Go to beginning of video
	      }
	    }, {
	      keyCode: 35,
	      // End
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        } // Go to end of video
	
	
	        actions.seek(player.duration);
	      }
	    }, {
	      keyCode: 38,
	      // Up arrow
	      handle: function handle(player, actions) {
	        // Increase volume 5%
	        var v = player.volume + 0.05;
	
	        if (v > 1) {
	          v = 1;
	        }
	
	        actions.changeVolume(v, {
	          action: 'volume-up',
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 40,
	      // Down arrow
	      handle: function handle(player, actions) {
	        // Decrease volume 5%
	        var v = player.volume - 0.05;
	
	        if (v < 0) {
	          v = 0;
	        }
	
	        var action = v > 0 ? 'volume-down' : 'volume-off';
	        actions.changeVolume(v, {
	          action: action,
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 190,
	      // Shift + >
	      shift: true,
	      handle: function handle(player, actions) {
	        // Increase speed
	        var playbackRate = player.playbackRate;
	
	        if (playbackRate >= 1.5) {
	          playbackRate = 2;
	        } else if (playbackRate >= 1.25) {
	          playbackRate = 1.5;
	        } else if (playbackRate >= 1.0) {
	          playbackRate = 1.25;
	        } else if (playbackRate >= 0.5) {
	          playbackRate = 1.0;
	        } else if (playbackRate >= 0.25) {
	          playbackRate = 0.5;
	        } else if (playbackRate >= 0) {
	          playbackRate = 0.25;
	        }
	
	        actions.changeRate(playbackRate, {
	          action: 'fast-forward',
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 188,
	      // Shift + <
	      shift: true,
	      handle: function handle(player, actions) {
	        // Decrease speed
	        var playbackRate = player.playbackRate;
	
	        if (playbackRate <= 0.5) {
	          playbackRate = 0.25;
	        } else if (playbackRate <= 1.0) {
	          playbackRate = 0.5;
	        } else if (playbackRate <= 1.25) {
	          playbackRate = 1.0;
	        } else if (playbackRate <= 1.5) {
	          playbackRate = 1.25;
	        } else if (playbackRate <= 2) {
	          playbackRate = 1.5;
	        }
	
	        actions.changeRate(playbackRate, {
	          action: 'fast-rewind',
	          source: 'shortcut'
	        });
	      }
	    }];
	    _this.shortcuts = (0, _toConsumableArray2["default"])(_this.defaultShortcuts);
	    _this.mergeShortcuts = _this.mergeShortcuts.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleDoubleClick = _this.handleDoubleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Shortcut, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mergeShortcuts();
	      document.addEventListener('keydown', this.handleKeyPress);
	      document.addEventListener('click', this.handleClick);
	      document.addEventListener('dblclick', this.handleDoubleClick);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.shortcuts !== this.props.shortcuts) {
	        this.mergeShortcuts();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.handleKeyPress);
	      document.removeEventListener('click', this.handleClick);
	      document.removeEventListener('dblclick', this.handleDoubleClick);
	    } // merge the shortcuts from props
	
	  }, {
	    key: "mergeShortcuts",
	    value: function mergeShortcuts() {
	      var getShortcutKey = function getShortcutKey(_ref) {
	        var _ref$keyCode = _ref.keyCode,
	            keyCode = _ref$keyCode === void 0 ? 0 : _ref$keyCode,
	            _ref$ctrl = _ref.ctrl,
	            ctrl = _ref$ctrl === void 0 ? false : _ref$ctrl,
	            _ref$shift = _ref.shift,
	            shift = _ref$shift === void 0 ? false : _ref$shift,
	            _ref$alt = _ref.alt,
	            alt = _ref$alt === void 0 ? false : _ref$alt;
	        return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
	      };
	
	      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
	        return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
	      }, {});
	      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
	        var keyCode = shortcut.keyCode,
	            handle = shortcut.handle;
	
	        if (keyCode && typeof handle === 'function') {
	          return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
	        }
	
	        return shortcuts;
	      }, defaultShortcuts);
	
	      var gradeShortcut = function gradeShortcut(s) {
	        var score = 0;
	        var ps = ['ctrl', 'shift', 'alt'];
	        ps.forEach(function (key) {
	          if (s[key]) {
	            score++;
	          }
	        });
	        return score;
	      };
	
	      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
	        return mergedShortcuts[key];
	      }).sort(function (a, b) {
	        return gradeShortcut(b) - gradeShortcut(a);
	      });
	    }
	  }, {
	    key: "togglePlay",
	    value: function togglePlay(player, actions) {
	      if (player.paused) {
	        actions.play({
	          action: 'play',
	          source: 'shortcut'
	        });
	      } else {
	        actions.pause({
	          action: 'pause',
	          source: 'shortcut'
	        });
	      }
	    }
	  }, {
	    key: "toggleFullscreen",
	    value: function toggleFullscreen(player, actions) {
	      actions.toggleFullscreen(player);
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(e) {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	
	      if (!player.isActive) {
	        return;
	      }
	
	      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active') // || hasClass(document.activeElement, 'video-react-slider')
	      || (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
	        return;
	      }
	
	      var keyCode = e.keyCode || e.which;
	      var ctrl = e.ctrlKey || e.metaKey;
	      var shift = e.shiftKey;
	      var alt = e.altKey;
	      var shortcut = this.shortcuts.filter(function (s) {
	        if (!s.keyCode || s.keyCode - keyCode !== 0) {
	          return false;
	        }
	
	        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
	          return false;
	        }
	
	        return true;
	      })[0];
	
	      if (shortcut) {
	        shortcut.handle(player, actions);
	        e.preventDefault();
	      }
	    } // only if player is active and player is ready
	
	  }, {
	    key: "canBeClicked",
	    value: function canBeClicked(player, e) {
	      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(e) {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions,
	          clickable = _this$props2.clickable;
	
	      if (!this.canBeClicked(player, e) || !clickable) {
	        return;
	      }
	
	      this.togglePlay(player, actions); // e.preventDefault();
	    }
	  }, {
	    key: "handleDoubleClick",
	    value: function handleDoubleClick(e) {
	      var _this$props3 = this.props,
	          player = _this$props3.player,
	          actions = _this$props3.actions,
	          dblclickable = _this$props3.dblclickable;
	
	      if (!this.canBeClicked(player, e) || !dblclickable) {
	        return;
	      }
	
	      this.toggleFullscreen(player, actions); // e.preventDefault();
	    } // this component dose not render anything
	    // it's just for the key down event
	
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	  return Shortcut;
	}(_react.Component);
	
	exports["default"] = Shortcut;
	Shortcut.propTypes = propTypes;
	Shortcut.defaultProps = defaultProps;
	Shortcut.displayName = 'Shortcut';

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(138));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _utils = __webpack_require__(126);
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  children: _propTypes["default"].any,
	  startTime: _propTypes["default"].number,
	  loop: _propTypes["default"].bool,
	  muted: _propTypes["default"].bool,
	  autoPlay: _propTypes["default"].bool,
	  playsInline: _propTypes["default"].bool,
	  src: _propTypes["default"].string,
	  poster: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
	  crossOrigin: _propTypes["default"].string,
	  onLoadStart: _propTypes["default"].func,
	  onWaiting: _propTypes["default"].func,
	  onCanPlay: _propTypes["default"].func,
	  onCanPlayThrough: _propTypes["default"].func,
	  onPlaying: _propTypes["default"].func,
	  onEnded: _propTypes["default"].func,
	  onSeeking: _propTypes["default"].func,
	  onSeeked: _propTypes["default"].func,
	  onPlay: _propTypes["default"].func,
	  onPause: _propTypes["default"].func,
	  onProgress: _propTypes["default"].func,
	  onDurationChange: _propTypes["default"].func,
	  onError: _propTypes["default"].func,
	  onSuspend: _propTypes["default"].func,
	  onAbort: _propTypes["default"].func,
	  onEmptied: _propTypes["default"].func,
	  onStalled: _propTypes["default"].func,
	  onLoadedMetadata: _propTypes["default"].func,
	  onLoadedData: _propTypes["default"].func,
	  onTimeUpdate: _propTypes["default"].func,
	  onRateChange: _propTypes["default"].func,
	  onVolumeChange: _propTypes["default"].func,
	  onResize: _propTypes["default"].func
	};
	
	var Video =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Video, _Component);
	
	  function Video(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Video);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Video).call(this, props));
	    _this.video = null; // the html5 video
	
	    _this.play = _this.play.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.pause = _this.pause.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.seek = _this.seek.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.forward = _this.forward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.replay = _this.replay.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.toggleFullscreen = _this.toggleFullscreen.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getProperties = _this.getProperties.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleLoadStart = _this.handleLoadStart.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleCanPlay = _this.handleCanPlay.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePlaying = _this.handlePlaying.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleEnded = _this.handleEnded.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleWaiting = _this.handleWaiting.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSeeking = _this.handleSeeking.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSeeked = _this.handleSeeked.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFullscreenChange = _this.handleFullscreenChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSuspend = _this.handleSuspend.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleAbort = _this.handleAbort.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleEmptied = _this.handleEmptied.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleStalled = _this.handleStalled.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleLoadedData = _this.handleLoadedData.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleTimeUpdate = _this.handleTimeUpdate.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleRateChange = _this.handleRateChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleVolumeChange = _this.handleVolumeChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleDurationChange = _this.handleDurationChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind((0, _assertThisInitialized2["default"])(_this)), 250);
	    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleTextTrackChange = _this.handleTextTrackChange.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Video, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.forceUpdate(); // make sure the children can get the video property
	
	      if (this.video && this.video.textTracks) {
	        this.video.textTracks.onaddtrack = this.handleTextTrackChange;
	        this.video.textTracks.onremovetrack = this.handleTextTrackChange;
	      }
	    } // get all video properties
	
	  }, {
	    key: "getProperties",
	    value: function getProperties() {
	      var _this2 = this;
	
	      if (!this.video) {
	        return null;
	      }
	
	      return _utils.mediaProperties.reduce(function (properties, key) {
	        properties[key] = _this2.video[key];
	        return properties;
	      }, {});
	    } // get playback rate
	
	  }, {
	    key: "handleTextTrackChange",
	    value: function handleTextTrackChange() {
	      var _this$props = this.props,
	          actions = _this$props.actions,
	          player = _this$props.player;
	
	      if (this.video && this.video.textTracks) {
	        var activeTextTrack = Array.from(this.video.textTracks).find(function (textTrack) {
	          return textTrack.mode === 'showing';
	        });
	
	        if (activeTextTrack !== player.activeTextTrack) {
	          actions.activateTextTrack(activeTextTrack);
	        }
	      }
	    } // play the video
	
	  }, {
	    key: "play",
	    value: function play() {
	      var promise = this.video.play();
	
	      if (promise !== undefined) {
	        promise["catch"](function () {}).then(function () {});
	      }
	    } // pause the video
	
	  }, {
	    key: "pause",
	    value: function pause() {
	      var promise = this.video.pause();
	
	      if (promise !== undefined) {
	        promise["catch"](function () {}).then(function () {});
	      }
	    } // Change the video source and re-load the video:
	
	  }, {
	    key: "load",
	    value: function load() {
	      this.video.load();
	    } // Add a new text track to the video
	
	  }, {
	    key: "addTextTrack",
	    value: function addTextTrack() {
	      var _this$video;
	
	      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
	    } // Check if your browser can play different types of video:
	
	  }, {
	    key: "canPlayType",
	    value: function canPlayType() {
	      var _this$video2;
	
	      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
	    } // toggle play
	
	  }, {
	    key: "togglePlay",
	    value: function togglePlay() {
	      if (this.video.paused) {
	        this.play();
	      } else {
	        this.pause();
	      }
	    } // seek video by time
	
	  }, {
	    key: "seek",
	    value: function seek(time) {
	      try {
	        this.video.currentTime = time;
	      } catch (e) {// console.log(e, 'Video is not ready.')
	      }
	    } // jump forward x seconds
	
	  }, {
	    key: "forward",
	    value: function forward(seconds) {
	      this.seek(this.video.currentTime + seconds);
	    } // jump back x seconds
	
	  }, {
	    key: "replay",
	    value: function replay(seconds) {
	      this.forward(-seconds);
	    } // enter or exist full screen
	
	  }, {
	    key: "toggleFullscreen",
	    value: function toggleFullscreen() {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions;
	      actions.toggleFullscreen(player);
	    } // Fired when the user agent
	    // begins looking for media data
	
	  }, {
	    key: "handleLoadStart",
	    value: function handleLoadStart() {
	      var _this$props3 = this.props,
	          actions = _this$props3.actions,
	          onLoadStart = _this$props3.onLoadStart;
	      actions.handleLoadStart(this.getProperties());
	
	      if (onLoadStart) {
	        onLoadStart.apply(void 0, arguments);
	      }
	    } // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: "handleCanPlay",
	    value: function handleCanPlay() {
	      var _this$props4 = this.props,
	          actions = _this$props4.actions,
	          onCanPlay = _this$props4.onCanPlay;
	      actions.handleCanPlay(this.getProperties());
	
	      if (onCanPlay) {
	        onCanPlay.apply(void 0, arguments);
	      }
	    } // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: "handleCanPlayThrough",
	    value: function handleCanPlayThrough() {
	      var _this$props5 = this.props,
	          actions = _this$props5.actions,
	          onCanPlayThrough = _this$props5.onCanPlayThrough;
	      actions.handleCanPlayThrough(this.getProperties());
	
	      if (onCanPlayThrough) {
	        onCanPlayThrough.apply(void 0, arguments);
	      }
	    } // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: "handlePlaying",
	    value: function handlePlaying() {
	      var _this$props6 = this.props,
	          actions = _this$props6.actions,
	          onPlaying = _this$props6.onPlaying;
	      actions.handlePlaying(this.getProperties());
	
	      if (onPlaying) {
	        onPlaying.apply(void 0, arguments);
	      }
	    } // Fired whenever the media has been started
	
	  }, {
	    key: "handlePlay",
	    value: function handlePlay() {
	      var _this$props7 = this.props,
	          actions = _this$props7.actions,
	          onPlay = _this$props7.onPlay;
	      actions.handlePlay(this.getProperties());
	
	      if (onPlay) {
	        onPlay.apply(void 0, arguments);
	      }
	    } // Fired whenever the media has been paused
	
	  }, {
	    key: "handlePause",
	    value: function handlePause() {
	      var _this$props8 = this.props,
	          actions = _this$props8.actions,
	          onPause = _this$props8.onPause;
	      actions.handlePause(this.getProperties());
	
	      if (onPause) {
	        onPause.apply(void 0, arguments);
	      }
	    } // Fired when the duration of
	    // the media resource is first known or changed
	
	  }, {
	    key: "handleDurationChange",
	    value: function handleDurationChange() {
	      var _this$props9 = this.props,
	          actions = _this$props9.actions,
	          onDurationChange = _this$props9.onDurationChange;
	      actions.handleDurationChange(this.getProperties());
	
	      if (onDurationChange) {
	        onDurationChange.apply(void 0, arguments);
	      }
	    } // Fired while the user agent
	    // is downloading media data
	
	  }, {
	    key: "handleProgress",
	    value: function handleProgress() {
	      var _this$props10 = this.props,
	          actions = _this$props10.actions,
	          onProgress = _this$props10.onProgress;
	
	      if (this.video) {
	        actions.handleProgressChange(this.getProperties());
	      }
	
	      if (onProgress) {
	        onProgress.apply(void 0, arguments);
	      }
	    } // Fired when the end of the media resource
	    // is reached (currentTime == duration)
	
	  }, {
	    key: "handleEnded",
	    value: function handleEnded() {
	      var _this$props11 = this.props,
	          loop = _this$props11.loop,
	          player = _this$props11.player,
	          actions = _this$props11.actions,
	          onEnded = _this$props11.onEnded;
	
	      if (loop) {
	        this.seek(0);
	        this.play();
	      } else if (!player.paused) {
	        this.pause();
	      }
	
	      actions.handleEnd(this.getProperties());
	
	      if (onEnded) {
	        onEnded.apply(void 0, arguments);
	      }
	    } // Fired whenever the media begins waiting
	
	  }, {
	    key: "handleWaiting",
	    value: function handleWaiting() {
	      var _this$props12 = this.props,
	          actions = _this$props12.actions,
	          onWaiting = _this$props12.onWaiting;
	      actions.handleWaiting(this.getProperties());
	
	      if (onWaiting) {
	        onWaiting.apply(void 0, arguments);
	      }
	    } // Fired whenever the player
	    // is jumping to a new time
	
	  }, {
	    key: "handleSeeking",
	    value: function handleSeeking() {
	      var _this$props13 = this.props,
	          actions = _this$props13.actions,
	          onSeeking = _this$props13.onSeeking;
	      actions.handleSeeking(this.getProperties());
	
	      if (onSeeking) {
	        onSeeking.apply(void 0, arguments);
	      }
	    } // Fired when the player has
	    // finished jumping to a new time
	
	  }, {
	    key: "handleSeeked",
	    value: function handleSeeked() {
	      var _this$props14 = this.props,
	          actions = _this$props14.actions,
	          onSeeked = _this$props14.onSeeked;
	      actions.handleSeeked(this.getProperties());
	
	      if (onSeeked) {
	        onSeeked.apply(void 0, arguments);
	      }
	    } // Handle Fullscreen Change
	
	  }, {
	    key: "handleFullscreenChange",
	    value: function handleFullscreenChange() {} // Fires when the browser is
	    // intentionally not getting media data
	
	  }, {
	    key: "handleSuspend",
	    value: function handleSuspend() {
	      var _this$props15 = this.props,
	          actions = _this$props15.actions,
	          onSuspend = _this$props15.onSuspend;
	      actions.handleSuspend(this.getProperties());
	
	      if (onSuspend) {
	        onSuspend.apply(void 0, arguments);
	      }
	    } // Fires when the loading of an audio/video is aborted
	
	  }, {
	    key: "handleAbort",
	    value: function handleAbort() {
	      var _this$props16 = this.props,
	          actions = _this$props16.actions,
	          onAbort = _this$props16.onAbort;
	      actions.handleAbort(this.getProperties());
	
	      if (onAbort) {
	        onAbort.apply(void 0, arguments);
	      }
	    } // Fires when the current playlist is empty
	
	  }, {
	    key: "handleEmptied",
	    value: function handleEmptied() {
	      var _this$props17 = this.props,
	          actions = _this$props17.actions,
	          onEmptied = _this$props17.onEmptied;
	      actions.handleEmptied(this.getProperties());
	
	      if (onEmptied) {
	        onEmptied.apply(void 0, arguments);
	      }
	    } // Fires when the browser is trying to
	    // get media data, but data is not available
	
	  }, {
	    key: "handleStalled",
	    value: function handleStalled() {
	      var _this$props18 = this.props,
	          actions = _this$props18.actions,
	          onStalled = _this$props18.onStalled;
	      actions.handleStalled(this.getProperties());
	
	      if (onStalled) {
	        onStalled.apply(void 0, arguments);
	      }
	    } // Fires when the browser has loaded
	    // meta data for the audio/video
	
	  }, {
	    key: "handleLoadedMetaData",
	    value: function handleLoadedMetaData() {
	      var _this$props19 = this.props,
	          actions = _this$props19.actions,
	          onLoadedMetadata = _this$props19.onLoadedMetadata,
	          startTime = _this$props19.startTime;
	
	      if (startTime && startTime > 0) {
	        this.video.currentTime = startTime;
	      }
	
	      actions.handleLoadedMetaData(this.getProperties());
	
	      if (onLoadedMetadata) {
	        onLoadedMetadata.apply(void 0, arguments);
	      }
	    } // Fires when the browser has loaded
	    // the current frame of the audio/video
	
	  }, {
	    key: "handleLoadedData",
	    value: function handleLoadedData() {
	      var _this$props20 = this.props,
	          actions = _this$props20.actions,
	          onLoadedData = _this$props20.onLoadedData;
	      actions.handleLoadedData(this.getProperties());
	
	      if (onLoadedData) {
	        onLoadedData.apply(void 0, arguments);
	      }
	    } // Fires when the current
	    // playback position has changed
	
	  }, {
	    key: "handleTimeUpdate",
	    value: function handleTimeUpdate() {
	      var _this$props21 = this.props,
	          actions = _this$props21.actions,
	          onTimeUpdate = _this$props21.onTimeUpdate;
	      actions.handleTimeUpdate(this.getProperties());
	
	      if (onTimeUpdate) {
	        onTimeUpdate.apply(void 0, arguments);
	      }
	    }
	    /**
	     * Fires when the playing speed of the audio/video is changed
	     */
	
	  }, {
	    key: "handleRateChange",
	    value: function handleRateChange() {
	      var _this$props22 = this.props,
	          actions = _this$props22.actions,
	          onRateChange = _this$props22.onRateChange;
	      actions.handleRateChange(this.getProperties());
	
	      if (onRateChange) {
	        onRateChange.apply(void 0, arguments);
	      }
	    } // Fires when the volume has been changed
	
	  }, {
	    key: "handleVolumeChange",
	    value: function handleVolumeChange() {
	      var _this$props23 = this.props,
	          actions = _this$props23.actions,
	          onVolumeChange = _this$props23.onVolumeChange;
	      actions.handleVolumeChange(this.getProperties());
	
	      if (onVolumeChange) {
	        onVolumeChange.apply(void 0, arguments);
	      }
	    } // Fires when an error occurred
	    // during the loading of an audio/video
	
	  }, {
	    key: "handleError",
	    value: function handleError() {
	      var _this$props24 = this.props,
	          actions = _this$props24.actions,
	          onError = _this$props24.onError;
	      actions.handleError(this.getProperties());
	
	      if (onError) {
	        onError.apply(void 0, arguments);
	      }
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize() {
	      var _this$props25 = this.props,
	          actions = _this$props25.actions,
	          onResize = _this$props25.onResize;
	      actions.handleResize(this.getProperties());
	
	      if (onResize) {
	        onResize.apply(void 0, arguments);
	      }
	    }
	  }, {
	    key: "handleKeypress",
	    value: function handleKeypress() {}
	  }, {
	    key: "renderChildren",
	    value: function renderChildren() {
	      var _this3 = this;
	
	      var props = (0, _objectSpread2["default"])({}, this.props, {
	        video: this.video
	      }); // to make sure the children can get video property
	
	      if (!this.video) {
	        return null;
	      } // only keep <source />, <track />, <MyComponent isVideoChild /> elements
	
	
	      return _react["default"].Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
	        var cprops;
	
	        if (typeof c.type === 'string') {
	          // add onError to <source />
	          if (c.type === 'source') {
	            cprops = (0, _objectSpread2["default"])({}, c.props);
	            var preOnError = cprops.onError;
	
	            cprops.onError = function () {
	              if (preOnError) {
	                preOnError.apply(void 0, arguments);
	              }
	
	              _this3.handleError.apply(_this3, arguments);
	            };
	          }
	        } else {
	          cprops = props;
	        }
	
	        return _react["default"].cloneElement(c, cprops);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _this$props26 = this.props,
	          loop = _this$props26.loop,
	          poster = _this$props26.poster,
	          preload = _this$props26.preload,
	          src = _this$props26.src,
	          autoPlay = _this$props26.autoPlay,
	          playsInline = _this$props26.playsInline,
	          muted = _this$props26.muted,
	          crossOrigin = _this$props26.crossOrigin,
	          videoId = _this$props26.videoId;
	      return _react["default"].createElement("video", {
	        className: (0, _classnames["default"])('video-react-video', this.props.className),
	        id: videoId,
	        crossOrigin: crossOrigin,
	        ref: function ref(c) {
	          _this4.video = c;
	        },
	        muted: muted,
	        preload: preload,
	        loop: loop,
	        playsInline: playsInline,
	        autoPlay: autoPlay,
	        poster: poster,
	        src: src,
	        onLoadStart: this.handleLoadStart,
	        onWaiting: this.handleWaiting,
	        onCanPlay: this.handleCanPlay,
	        onCanPlayThrough: this.handleCanPlayThrough,
	        onPlaying: this.handlePlaying,
	        onEnded: this.handleEnded,
	        onSeeking: this.handleSeeking,
	        onSeeked: this.handleSeeked,
	        onPlay: this.handlePlay,
	        onPause: this.handlePause,
	        onProgress: this.handleProgress,
	        onDurationChange: this.handleDurationChange,
	        onError: this.handleError,
	        onSuspend: this.handleSuspend,
	        onAbort: this.handleAbort,
	        onEmptied: this.handleEmptied,
	        onStalled: this.handleStalled,
	        onLoadedMetadata: this.handleLoadedMetaData,
	        onLoadedData: this.handleLoadedData,
	        onTimeUpdate: this.handleTimeUpdate,
	        onRateChange: this.handleRateChange,
	        onVolumeChange: this.handleVolumeChange,
	        tabIndex: "-1"
	      }, this.renderChildren());
	    }
	  }, {
	    key: "playbackRate",
	    get: function get() {
	      return this.video.playbackRate;
	    } // set playback rate
	    // speed of video
	    ,
	    set: function set(rate) {
	      this.video.playbackRate = rate;
	    }
	  }, {
	    key: "muted",
	    get: function get() {
	      return this.video.muted;
	    },
	    set: function set(val) {
	      this.video.muted = val;
	    }
	  }, {
	    key: "volume",
	    get: function get() {
	      return this.video.volume;
	    },
	    set: function set(val) {
	      if (val > 1) {
	        val = 1;
	      }
	
	      if (val < 0) {
	        val = 0;
	      }
	
	      this.video.volume = val;
	    } // video width
	
	  }, {
	    key: "videoWidth",
	    get: function get() {
	      return this.video.videoWidth;
	    } // video height
	
	  }, {
	    key: "videoHeight",
	    get: function get() {
	      return this.video.videoHeight;
	    }
	  }]);
	  return Video;
	}(_react.Component);
	
	exports["default"] = Video;
	Video.propTypes = propTypes;
	Video.displayName = 'Video';

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(275));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _ProgressControl = _interopRequireDefault(__webpack_require__(749));
	
	var _PlayToggle = _interopRequireDefault(__webpack_require__(748));
	
	var _ForwardControl = _interopRequireDefault(__webpack_require__(742));
	
	var _ReplayControl = _interopRequireDefault(__webpack_require__(750));
	
	var _FullscreenToggle = _interopRequireDefault(__webpack_require__(744));
	
	var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(755));
	
	var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(753));
	
	var _DurationDisplay = _interopRequireDefault(__webpack_require__(754));
	
	var _TimeDivider = _interopRequireDefault(__webpack_require__(756));
	
	var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(752));
	
	var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(392));
	
	var _utils = __webpack_require__(126);
	
	var propTypes = {
	  children: _propTypes["default"].any,
	  autoHide: _propTypes["default"].bool,
	  autoHideTime: _propTypes["default"].number,
	  // used in Player
	  disableDefaultControls: _propTypes["default"].bool,
	  disableCompletely: _propTypes["default"].bool,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  autoHide: true,
	  disableCompletely: false
	};
	
	var ControlBar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ControlBar, _Component);
	
	  function ControlBar(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ControlBar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ControlBar).call(this, props));
	    _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getFullChildren = _this.getFullChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ControlBar, [{
	    key: "getDefaultChildren",
	    value: function getDefaultChildren() {
	      return [_react["default"].createElement(_PlayToggle["default"], {
	        key: "play-toggle",
	        order: 1
	      }), _react["default"].createElement(_VolumeMenuButton["default"], {
	        key: "volume-menu-button",
	        order: 4
	      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
	        key: "current-time-display",
	        order: 5.1
	      }), _react["default"].createElement(_TimeDivider["default"], {
	        key: "time-divider",
	        order: 5.2
	      }), _react["default"].createElement(_DurationDisplay["default"], {
	        key: "duration-display",
	        order: 5.3
	      }), _react["default"].createElement(_ProgressControl["default"], {
	        key: "progress-control",
	        order: 6
	      }), _react["default"].createElement(_FullscreenToggle["default"], {
	        key: "fullscreen-toggle",
	        order: 8
	      })];
	    }
	  }, {
	    key: "getFullChildren",
	    value: function getFullChildren() {
	      return [_react["default"].createElement(_PlayToggle["default"], {
	        key: "play-toggle",
	        order: 1
	      }), _react["default"].createElement(_ReplayControl["default"], {
	        key: "replay-control",
	        order: 2
	      }), _react["default"].createElement(_ForwardControl["default"], {
	        key: "forward-control",
	        order: 3
	      }), _react["default"].createElement(_VolumeMenuButton["default"], {
	        key: "volume-menu-button",
	        order: 4
	      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
	        key: "current-time-display",
	        order: 5
	      }), _react["default"].createElement(_TimeDivider["default"], {
	        key: "time-divider",
	        order: 6
	      }), _react["default"].createElement(_DurationDisplay["default"], {
	        key: "duration-display",
	        order: 7
	      }), _react["default"].createElement(_ProgressControl["default"], {
	        key: "progress-control",
	        order: 8
	      }), _react["default"].createElement(_RemainingTimeDisplay["default"], {
	        key: "remaining-time-display",
	        order: 9
	      }), _react["default"].createElement(_PlaybackRateMenuButton["default"], {
	        rates: [1, 1.25, 1.5, 2],
	        key: "playback-rate",
	        order: 10
	      }), _react["default"].createElement(_FullscreenToggle["default"], {
	        key: "fullscreen-toggle",
	        order: 11
	      })];
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren() {
	      var children = _react["default"].Children.toArray(this.props.children);
	
	      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
	      var _this$props = this.props,
	          className = _this$props.className,
	          parentProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className"]); // remove className
	
	      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          autoHide = _this$props2.autoHide,
	          className = _this$props2.className,
	          disableCompletely = _this$props2.disableCompletely;
	      var children = this.getChildren();
	      return disableCompletely ? null : _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('video-react-control-bar', {
	          'video-react-control-bar-auto-hide': autoHide
	        }, className)
	      }, children);
	    }
	  }]);
	  return ControlBar;
	}(_react.Component);
	
	exports["default"] = ControlBar;
	ControlBar.propTypes = propTypes;
	ControlBar.defaultProps = defaultProps;
	ControlBar.displayName = 'ControlBar';

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(743));
	
	// Pass mode into parent function
	var ForwardControl = (0, _ForwardReplayControl["default"])('forward');
	ForwardControl.displayName = 'ForwardControl';
	var _default = ForwardControl;
	exports["default"] = _default;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  seconds: _propTypes["default"].oneOf([5, 10, 30])
	};
	var defaultProps = {
	  seconds: 10
	};
	
	var _default = function _default(mode) {
	  var ForwardReplayControl =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inherits2["default"])(ForwardReplayControl, _Component);
	
	    function ForwardReplayControl(props, context) {
	      var _this;
	
	      (0, _classCallCheck2["default"])(this, ForwardReplayControl);
	      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ForwardReplayControl).call(this, props, context));
	      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	      return _this;
	    }
	
	    (0, _createClass2["default"])(ForwardReplayControl, [{
	      key: "handleClick",
	      value: function handleClick() {
	        var _this$props = this.props,
	            actions = _this$props.actions,
	            seconds = _this$props.seconds; // Depends mode to implement different actions
	
	        if (mode === 'forward') {
	          actions.forward(seconds);
	        } else {
	          actions.replay(seconds);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            seconds = _this$props2.seconds,
	            className = _this$props2.className;
	        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
	        classNames.push("video-react-icon-".concat(mode, "-").concat(seconds), "video-react-".concat(mode, "-control"));
	
	        if (className) {
	          classNames.push(className);
	        }
	
	        return _react["default"].createElement("button", {
	          ref: function ref(c) {
	            _this2.button = c;
	          },
	          className: classNames.join(' '),
	          type: "button",
	          onClick: this.handleClick
	        }, _react["default"].createElement("span", {
	          className: "video-react-control-text"
	        }, "".concat(mode, " ").concat(seconds, " seconds")));
	      }
	    }]);
	    return ForwardReplayControl;
	  }(_react.Component);
	
	  ForwardReplayControl.propTypes = propTypes;
	  ForwardReplayControl.defaultProps = defaultProps;
	  return ForwardReplayControl;
	};
	
	exports["default"] = _default;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var FullscreenToggle =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(FullscreenToggle, _Component);
	
	  function FullscreenToggle(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, FullscreenToggle);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FullscreenToggle).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(FullscreenToggle, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	      actions.toggleFullscreen(player);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          className = _this$props2.className;
	      return _react["default"].createElement("button", {
	        className: (0, _classnames["default"])(className, {
	          'video-react-icon-fullscreen-exit': player.isFullscreen,
	          'video-react-icon-fullscreen': !player.isFullscreen
	        }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
	        ref: function ref(c) {
	          _this2.button = c;
	        },
	        type: "button",
	        tabIndex: "0",
	        onClick: this.handleClick
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Non-Fullscreen"));
	    }
	  }]);
	  return FullscreenToggle;
	}(_react.Component);
	
	exports["default"] = FullscreenToggle;
	FullscreenToggle.propTypes = propTypes;
	FullscreenToggle.displayName = 'FullscreenToggle';

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = LoadProgressBar;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  duration: _propTypes["default"].number,
	  buffered: _propTypes["default"].object,
	  className: _propTypes["default"].string
	}; // Shows load progress
	
	function LoadProgressBar(_ref) {
	  var buffered = _ref.buffered,
	      duration = _ref.duration,
	      className = _ref.className;
	
	  if (!buffered || !buffered.length) {
	    return null;
	  }
	
	  var bufferedEnd = buffered.end(buffered.length - 1);
	  var style = {};
	
	  if (bufferedEnd > duration) {
	    bufferedEnd = duration;
	  } // get the percent width of a time compared to the total end
	
	
	  function percentify(time, end) {
	    var percent = time / end || 0; // no NaN
	
	    return "".concat((percent >= 1 ? 1 : percent) * 100, "%");
	  } // the width of the progress bar
	
	
	  style.width = percentify(bufferedEnd, duration);
	  var parts = []; // add child elements to represent the individual buffered time ranges
	
	  for (var i = 0; i < buffered.length; i++) {
	    var start = buffered.start(i);
	    var end = buffered.end(i); // set the percent based on the width of the progress bar (bufferedEnd)
	
	    var part = _react["default"].createElement("div", {
	      style: {
	        left: percentify(start, bufferedEnd),
	        width: percentify(end - start, bufferedEnd)
	      },
	      key: "part-".concat(i)
	    });
	
	    parts.push(part);
	  }
	
	  if (parts.length === 0) {
	    parts = null;
	  }
	
	  return _react["default"].createElement("div", {
	    style: style,
	    className: (0, _classnames["default"])('video-react-load-progress', className)
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Loaded: 0%"), parts);
	}
	
	LoadProgressBar.propTypes = propTypes;
	LoadProgressBar.displayName = 'LoadProgressBar';

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _utils = __webpack_require__(126);
	
	function MouseTimeDisplay(_ref) {
	  var duration = _ref.duration,
	      mouseTime = _ref.mouseTime,
	      className = _ref.className,
	      text = _ref.text;
	
	  if (!mouseTime.time) {
	    return null;
	  }
	
	  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-mouse-display', className),
	    style: {
	      left: "".concat(mouseTime.position, "px")
	    },
	    "data-current-time": time
	  });
	}
	
	MouseTimeDisplay.propTypes = {
	  duration: _propTypes["default"].number,
	  mouseTime: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	MouseTimeDisplay.displayName = 'MouseTimeDisplay';
	var _default = MouseTimeDisplay;
	exports["default"] = _default;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = PlayProgressBar;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _utils = __webpack_require__(126);
	
	var propTypes = {
	  currentTime: _propTypes["default"].number,
	  duration: _propTypes["default"].number,
	  percentage: _propTypes["default"].string,
	  className: _propTypes["default"].string
	}; // Shows play progress
	
	function PlayProgressBar(_ref) {
	  var currentTime = _ref.currentTime,
	      duration = _ref.duration,
	      percentage = _ref.percentage,
	      className = _ref.className;
	  return _react["default"].createElement("div", {
	    "data-current-time": (0, _utils.formatTime)(currentTime, duration),
	    className: (0, _classnames["default"])('video-react-play-progress video-react-slider-bar', className),
	    style: {
	      width: percentage
	    }
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Progress: ".concat(percentage)));
	}
	
	PlayProgressBar.propTypes = propTypes;
	PlayProgressBar.displayName = 'PlayProgressBar';

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var PlayToggle =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PlayToggle, _Component);
	
	  function PlayToggle(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PlayToggle);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlayToggle).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PlayToggle, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          actions = _this$props.actions,
	          player = _this$props.player;
	
	      if (player.paused) {
	        actions.play();
	      } else {
	        actions.pause();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          className = _this$props2.className;
	      var controlText = player.paused ? 'Play' : 'Pause';
	      return _react["default"].createElement("button", {
	        ref: function ref(c) {
	          _this2.button = c;
	        },
	        className: (0, _classnames["default"])(className, {
	          'video-react-play-control': true,
	          'video-react-control': true,
	          'video-react-button': true,
	          'video-react-paused': player.paused,
	          'video-react-playing': !player.paused
	        }),
	        type: "button",
	        tabIndex: "0",
	        onClick: this.handleClick
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, controlText));
	    }
	  }]);
	  return PlayToggle;
	}(_react.Component);
	
	exports["default"] = PlayToggle;
	PlayToggle.propTypes = propTypes;
	PlayToggle.displayName = 'PlayToggle';

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(191));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var Dom = _interopRequireWildcard(__webpack_require__(273));
	
	var _SeekBar = _interopRequireDefault(__webpack_require__(751));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var ProgressControl =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ProgressControl, _Component);
	
	  function ProgressControl(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ProgressControl);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProgressControl).call(this, props, context));
	    _this.state = {
	      mouseTime: {
	        time: null,
	        position: 0
	      }
	    };
	    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ProgressControl, [{
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      if (!event.pageX) {
	        return;
	      }
	
	      var duration = this.props.player.duration;
	      var node = this.seekBar;
	      var newTime = Dom.getPointerPosition(node, event).x * duration;
	      var position = event.pageX - Dom.findElPosition(node).left;
	      this.setState({
	        mouseTime: {
	          time: newTime,
	          position: position
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var className = this.props.className;
	      return _react["default"].createElement("div", {
	        onMouseMove: this.handleMouseMoveThrottle,
	        className: (0, _classnames["default"])('video-react-progress-control video-react-control', className)
	      }, _react["default"].createElement(_SeekBar["default"], (0, _extends2["default"])({
	        mouseTime: this.state.mouseTime,
	        ref: function ref(c) {
	          _this2.seekBar = c;
	        }
	      }, this.props)));
	    }
	  }]);
	  return ProgressControl;
	}(_react.Component);
	
	exports["default"] = ProgressControl;
	ProgressControl.propTypes = propTypes;
	ProgressControl.displayName = 'ProgressControl';

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(743));
	
	// Pass mode into parent function
	var ReplayControl = (0, _ForwardReplayControl["default"])('replay');
	ReplayControl.displayName = 'ReplayControl';
	var _default = ReplayControl;
	exports["default"] = _default;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _Slider = _interopRequireDefault(__webpack_require__(391));
	
	var _PlayProgressBar = _interopRequireDefault(__webpack_require__(747));
	
	var _LoadProgressBar = _interopRequireDefault(__webpack_require__(745));
	
	var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(746));
	
	var _utils = __webpack_require__(126);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  mouseTime: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var SeekBar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(SeekBar, _Component);
	
	  function SeekBar(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, SeekBar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SeekBar).call(this, props, context));
	    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getNewTime = _this.getNewTime.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(SeekBar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {}
	    /**
	     * Get percentage of video played
	     *
	     * @return {Number} Percentage played
	     * @method getPercent
	     */
	
	  }, {
	    key: "getPercent",
	    value: function getPercent() {
	      var _this$props$player = this.props.player,
	          currentTime = _this$props$player.currentTime,
	          seekingTime = _this$props$player.seekingTime,
	          duration = _this$props$player.duration;
	      var time = seekingTime || currentTime;
	      var percent = time / duration;
	      return percent >= 1 ? 1 : percent;
	    }
	  }, {
	    key: "getNewTime",
	    value: function getNewTime(event) {
	      var duration = this.props.player.duration;
	      var distance = this.slider.calculateDistance(event);
	      var newTime = distance * duration; // Don't let video end while scrubbing.
	
	      return newTime === duration ? newTime - 0.1 : newTime;
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown() {}
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(event) {
	      var actions = this.props.actions;
	      var newTime = this.getNewTime(event); // Set new time (tell video to seek to new time)
	
	      actions.seek(newTime);
	      actions.handleEndSeeking(newTime);
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      var actions = this.props.actions;
	      var newTime = this.getNewTime(event);
	      actions.handleSeekingTime(newTime);
	    }
	  }, {
	    key: "stepForward",
	    value: function stepForward() {
	      var actions = this.props.actions;
	      actions.forward(5);
	    }
	  }, {
	    key: "stepBack",
	    value: function stepBack() {
	      var actions = this.props.actions;
	      actions.replay(5);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          _this$props$player2 = _this$props.player,
	          currentTime = _this$props$player2.currentTime,
	          seekingTime = _this$props$player2.seekingTime,
	          duration = _this$props$player2.duration,
	          buffered = _this$props$player2.buffered,
	          mouseTime = _this$props.mouseTime;
	      var time = seekingTime || currentTime;
	      return _react["default"].createElement(_Slider["default"], {
	        ref: function ref(input) {
	          _this2.slider = input;
	        },
	        label: "video progress bar",
	        className: (0, _classnames["default"])('video-react-progress-holder', this.props.className),
	        valuenow: (this.getPercent() * 100).toFixed(2),
	        valuetext: (0, _utils.formatTime)(time, duration),
	        onMouseDown: this.handleMouseDown,
	        onMouseMove: this.handleMouseMove,
	        onMouseUp: this.handleMouseUp,
	        getPercent: this.getPercent,
	        stepForward: this.stepForward,
	        stepBack: this.stepBack
	      }, _react["default"].createElement(_LoadProgressBar["default"], {
	        buffered: buffered,
	        currentTime: time,
	        duration: duration
	      }), _react["default"].createElement(_MouseTimeDisplay["default"], {
	        duration: duration,
	        mouseTime: mouseTime
	      }), _react["default"].createElement(_PlayProgressBar["default"], {
	        currentTime: time,
	        duration: duration
	      }));
	    }
	  }]);
	  return SeekBar;
	}(_react.Component);
	
	exports["default"] = SeekBar;
	SeekBar.propTypes = propTypes;
	SeekBar.displayName = 'SeekBar';

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(191));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _PopupButton = _interopRequireDefault(__webpack_require__(1999));
	
	var _VolumeBar = _interopRequireDefault(__webpack_require__(2000));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  vertical: _propTypes["default"].bool,
	  className: _propTypes["default"].string,
	  alwaysShowVolume: _propTypes["default"].bool
	};
	var defaultProps = {
	  vertical: false
	};
	
	var VolumeMenuButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(VolumeMenuButton, _Component);
	
	  function VolumeMenuButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, VolumeMenuButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeMenuButton).call(this, props, context));
	    _this.state = {
	      active: false
	    };
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(VolumeMenuButton, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	      actions.mute(!player.muted);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      this.setState({
	        active: true
	      });
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.setState({
	        active: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          vertical = _this$props2.vertical,
	          player = _this$props2.player,
	          className = _this$props2.className;
	      var inline = !vertical;
	      var level = this.volumeLevel;
	      return _react["default"].createElement(_PopupButton["default"], {
	        className: (0, _classnames["default"])(className, {
	          'video-react-volume-menu-button-vertical': vertical,
	          'video-react-volume-menu-button-horizontal': !vertical,
	          'video-react-vol-muted': player.muted,
	          'video-react-vol-0': level === 0 && !player.muted,
	          'video-react-vol-1': level === 1,
	          'video-react-vol-2': level === 2,
	          'video-react-vol-3': level === 3,
	          'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
	          'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
	        }, 'video-react-volume-menu-button'),
	        onClick: this.handleClick,
	        inline: inline
	      }, _react["default"].createElement(_VolumeBar["default"], (0, _extends2["default"])({
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, this.props)));
	    }
	  }, {
	    key: "volumeLevel",
	    get: function get() {
	      var _this$props$player = this.props.player,
	          volume = _this$props$player.volume,
	          muted = _this$props$player.muted;
	      var level = 3;
	
	      if (volume === 0 || muted) {
	        level = 0;
	      } else if (volume < 0.33) {
	        level = 1;
	      } else if (volume < 0.67) {
	        level = 2;
	      }
	
	      return level;
	    }
	  }]);
	  return VolumeMenuButton;
	}(_react.Component);
	
	VolumeMenuButton.propTypes = propTypes;
	VolumeMenuButton.defaultProps = defaultProps;
	VolumeMenuButton.displayName = 'VolumeMenuButton';
	var _default = VolumeMenuButton;
	exports["default"] = _default;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _utils = __webpack_require__(126);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function CurrentTimeDisplay(_ref) {
	  var _ref$player = _ref.player,
	      currentTime = _ref$player.currentTime,
	      duration = _ref$player.duration,
	      className = _ref.className;
	  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-current-time video-react-time-control video-react-control', className)
	  }, _react["default"].createElement("div", {
	    className: "video-react-current-time-display",
	    "aria-live": "off"
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Current Time "), formattedTime));
	}
	
	CurrentTimeDisplay.propTypes = propTypes;
	CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
	var _default = CurrentTimeDisplay;
	exports["default"] = _default;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _utils = __webpack_require__(126);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function DurationDisplay(_ref) {
	  var duration = _ref.player.duration,
	      className = _ref.className;
	  var formattedTime = (0, _utils.formatTime)(duration);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])(className, 'video-react-duration video-react-time-control video-react-control')
	  }, _react["default"].createElement("div", {
	    className: "video-react-duration-display",
	    "aria-live": "off"
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Duration Time "), formattedTime));
	}
	
	DurationDisplay.propTypes = propTypes;
	DurationDisplay.displayName = 'DurationDisplay';
	var _default = DurationDisplay;
	exports["default"] = _default;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _utils = __webpack_require__(126);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function RemainingTimeDisplay(_ref) {
	  var _ref$player = _ref.player,
	      currentTime = _ref$player.currentTime,
	      duration = _ref$player.duration,
	      className = _ref.className;
	  var remainingTime = duration - currentTime;
	  var formattedTime = (0, _utils.formatTime)(remainingTime);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-remaining-time video-react-time-control video-react-control', className)
	  }, _react["default"].createElement("div", {
	    className: "video-react-remaining-time-display",
	    "aria-live": "off"
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Remaining Time "), "-".concat(formattedTime)));
	}
	
	RemainingTimeDisplay.propTypes = propTypes;
	RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
	var _default = RemainingTimeDisplay;
	exports["default"] = _default;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = TimeDivider;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  separator: _propTypes["default"].string,
	  className: _propTypes["default"].string
	};
	
	function TimeDivider(_ref) {
	  var separator = _ref.separator,
	      className = _ref.className;
	  var separatorText = separator || '/';
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-time-control video-react-time-divider', className),
	    dir: "ltr"
	  }, _react["default"].createElement("div", null, _react["default"].createElement("span", null, separatorText)));
	}
	
	TimeDivider.propTypes = propTypes;
	TimeDivider.displayName = 'TimeDivider';

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	exports.operationReducer = exports.playerReducer = void 0;
	
	var _player = _interopRequireDefault(__webpack_require__(2004));
	
	var _operation = _interopRequireDefault(__webpack_require__(2003));
	
	function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	  return {
	    player: (0, _player["default"])(state.player, action),
	    operation: (0, _operation["default"])(state.operation, action)
	  };
	}
	
	var playerReducer = _player["default"];
	exports.playerReducer = playerReducer;
	var operationReducer = _operation["default"];
	exports.operationReducer = operationReducer;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var Fullscreen =
	/*#__PURE__*/
	function () {
	  function Fullscreen() {
	    (0, _classCallCheck2["default"])(this, Fullscreen);
	  }
	
	  (0, _createClass2["default"])(Fullscreen, [{
	    key: "request",
	    value: function request(elm) {
	      if (elm.requestFullscreen) {
	        elm.requestFullscreen();
	      } else if (elm.webkitRequestFullscreen) {
	        elm.webkitRequestFullscreen();
	      } else if (elm.mozRequestFullScreen) {
	        elm.mozRequestFullScreen();
	      } else if (elm.msRequestFullscreen) {
	        elm.msRequestFullscreen();
	      }
	    }
	  }, {
	    key: "exit",
	    value: function exit() {
	      if (document.exitFullscreen) {
	        document.exitFullscreen();
	      } else if (document.webkitExitFullscreen) {
	        document.webkitExitFullscreen();
	      } else if (document.mozCancelFullScreen) {
	        document.mozCancelFullScreen();
	      } else if (document.msExitFullscreen) {
	        document.msExitFullscreen();
	      }
	    }
	  }, {
	    key: "addEventListener",
	    value: function addEventListener(handler) {
	      document.addEventListener('fullscreenchange', handler);
	      document.addEventListener('webkitfullscreenchange', handler);
	      document.addEventListener('mozfullscreenchange', handler);
	      document.addEventListener('MSFullscreenChange', handler);
	    }
	  }, {
	    key: "removeEventListener",
	    value: function removeEventListener(handler) {
	      document.removeEventListener('fullscreenchange', handler);
	      document.removeEventListener('webkitfullscreenchange', handler);
	      document.removeEventListener('mozfullscreenchange', handler);
	      document.removeEventListener('MSFullscreenChange', handler);
	    }
	  }, {
	    key: "isFullscreen",
	    get: function get() {
	      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
	    }
	  }, {
	    key: "enabled",
	    get: function get() {
	      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
	    }
	  }]);
	  return Fullscreen;
	}();
	
	var _default = new Fullscreen();
	
	exports["default"] = _default;

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(2018);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 761 */
/***/ (function(module, exports) {

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  }
	}
	
	module.exports = _arrayWithoutHoles;

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	module.exports = _iterableToArray;

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	module.exports = _nonIterableSpread;

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	module.exports = murmurhash2_32_gc;


/***/ }),
/* 768 */
/***/ (function(module, exports) {

	'use strict';
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	module.exports = memoize;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

	'use strict';
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e, m).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        switch (d.constructor) {
	          case Array:
	            for (var c = 0, e = d.length; c < e; ++c) {
	              T(d[c]);
	            }
	
	            break;
	
	          case Function:
	            S[A++] = d;
	            break;
	
	          case Boolean:
	            Y = !!d | 0;
	        }
	
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	module.exports = stylis_min;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

	'use strict';
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	module.exports = unitlessKeys;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(772)
	} else {
	  module.exports = require('./svg-injector.cjs.development.js')
	}


/***/ }),
/* 772 */
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var cloneSvg=function(e){return e.cloneNode(!0)},isLocal=function(){return"file:"===window.location.protocol},svgCache=new Map,requestQueue={},queueRequest=function(e,t){requestQueue[e]=requestQueue[e]||[],requestQueue[e].push(t)},processRequestQueue=function(e){for(var t=function(t,r){setTimeout(function(){if(Array.isArray(requestQueue[e])){var r=svgCache.get(e),n=requestQueue[e][t];(r instanceof SVGSVGElement||r instanceof HTMLElement)&&n(null,cloneSvg(r)),r instanceof Error&&n(r),t===requestQueue[e].length-1&&delete requestQueue[e]}},0)},r=0,n=requestQueue[e].length;r<n;r++)t(r)},loadSvg=function(e,t){if(svgCache.has(e)){var r=svgCache.get(e);return r instanceof SVGSVGElement||r instanceof HTMLElement?void t(null,cloneSvg(r)):r instanceof Error?void t(r):void queueRequest(e,t)}svgCache.set(e,void 0),queueRequest(e,t);var n=new XMLHttpRequest;n.onreadystatechange=function(){try{if(4===n.readyState){if(404===n.status||null===n.responseXML)throw new Error(isLocal()?"Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver.":"Unable to load SVG file: "+e);if(!(200===n.status||isLocal()&&0===n.status))throw new Error("There was a problem injecting the SVG: "+n.status+" "+n.statusText);n.responseXML instanceof Document&&n.responseXML.documentElement&&svgCache.set(e,n.responseXML.documentElement),processRequestQueue(e)}}catch(t){svgCache.set(e,t),processRequestQueue(e)}},n.open("GET",e),n.overrideMimeType&&n.overrideMimeType("text/xml"),n.send()},idCounter=0,uniqueId=function(){return++idCounter},injectedElements=[],ranScripts={},svgNamespace="http://www.w3.org/2000/svg",xlinkNamespace="http://www.w3.org/1999/xlink",injectElement=function(e,t,r,n,i){var s=e.getAttribute("data-src")||e.getAttribute("src");if(s&&/\.svg/i.test(s)){if(-1!==injectedElements.indexOf(e))return injectedElements.splice(injectedElements.indexOf(e),1),void(e=null);injectedElements.push(e),e.setAttribute("src",""),loadSvg(s,function(a,o){if(!o)return injectedElements.splice(injectedElements.indexOf(e),1),e=null,void i(a);var l=e.getAttribute("id");l&&o.setAttribute("id",l);var u=e.getAttribute("title");u&&o.setAttribute("title",u);var c=e.getAttribute("width");c&&o.setAttribute("width",c);var f=e.getAttribute("height");f&&o.setAttribute("height",f);var v=Array.from(new Set((o.getAttribute("class")||"").split(" ").concat(["injected-svg"],(e.getAttribute("class")||"").split(" ")))).join(" ").trim();o.setAttribute("class",v);var p=e.getAttribute("style");p&&o.setAttribute("style",p),o.setAttribute("data-src",s);var d=[].filter.call(e.attributes,function(e){return/^data-\w[\w-]*$/.test(e.name)});if(Array.prototype.forEach.call(d,function(e){e.name&&e.value&&o.setAttribute(e.name,e.value)}),r){var g,h,m,A,w={clipPath:["clip-path"],"color-profile":["color-profile"],cursor:["cursor"],filter:["filter"],linearGradient:["fill","stroke"],marker:["marker","marker-start","marker-mid","marker-end"],mask:["mask"],path:[],pattern:["fill","stroke"],radialGradient:["fill","stroke"]};Object.keys(w).forEach(function(e){h=w[e];for(var t=function(e,t){var r;A=(m=g[e].id)+"-"+uniqueId(),Array.prototype.forEach.call(h,function(e){for(var t=0,n=(r=o.querySelectorAll("["+e+'*="'+m+'"]')).length;t<n;t++){var i=r[t].getAttribute(e);i&&!i.match(new RegExp("url\\(#"+m+"\\)"))||r[t].setAttribute(e,"url(#"+A+")")}});for(var n=o.querySelectorAll("[*|href]"),i=[],s=0,a=n.length;s<a;s++){var l=n[s].getAttributeNS(xlinkNamespace,"href");l&&l.toString()==="#"+g[e].id&&i.push(n[s])}for(var u=0,c=i.length;u<c;u++)i[u].setAttributeNS(xlinkNamespace,"href","#"+A);g[e].id=A},r=0,n=(g=o.querySelectorAll(e+"[id]")).length;r<n;r++)t(r)})}o.removeAttribute("xmlns:a");for(var E,b,S=o.querySelectorAll("script"),y=[],x=0,j=S.length;x<j;x++)(b=S[x].getAttribute("type"))&&"application/ecmascript"!==b&&"application/javascript"!==b&&"text/javascript"!==b||((E=S[x].innerText||S[x].textContent)&&y.push(E),o.removeChild(S[x]));if(y.length>0&&("always"===t||"once"===t&&!ranScripts[s])){for(var q=0,k=y.length;q<k;q++)new Function(y[q])(window);ranScripts[s]=!0}var N=o.querySelectorAll("style");Array.prototype.forEach.call(N,function(e){e.textContent+=""}),o.setAttribute("xmlns",svgNamespace),o.setAttribute("xmlns:xlink",xlinkNamespace),n(o),e.parentNode&&e.parentNode.replaceChild(o,e),injectedElements.splice(injectedElements.indexOf(e),1),e=null,i(null,o)})}else i(new Error("Attempted to inject a file with a non-svg extension: "+s))};!function(e){e.Always="always",e.Once="once",e.Never="never"}(exports.EvalScripts||(exports.EvalScripts={}));var SVGInjector=function(e,t){var r=void 0===t?{}:t,n=r.afterAll,i=void 0===n?function(){}:n,s=r.afterEach,a=void 0===s?function(){}:s,o=r.beforeEach,l=void 0===o?function(){}:o,u=r.evalScripts,c=void 0===u?exports.EvalScripts.Never:u,f=r.renumerateIRIElements,v=void 0===f||f;if(e&&"length"in e)for(var p=0,d=0,g=e.length;d<g;d++)injectElement(e[d],c,v,l,function(t,r){a(t,r),e&&"length"in e&&e.length===++p&&i(p)});else e?injectElement(e,c,v,l,function(t,r){a(t,r),i(1),e=null}):i(0)};exports.SVGInjector=SVGInjector;
	//# sourceMappingURL=svg-injector.cjs.production.js.map


/***/ }),
/* 773 */
/***/ (function(module, exports) {

	module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	var bind = __webpack_require__(400);
	var Axios = __webpack_require__(776);
	var defaults = __webpack_require__(276);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(397);
	axios.CancelToken = __webpack_require__(775);
	axios.isCancel = __webpack_require__(398);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(790);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(397);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(276);
	var utils = __webpack_require__(101);
	var InterceptorManager = __webpack_require__(777);
	var dispatchRequest = __webpack_require__(778);
	var isAbsoluteURL = __webpack_require__(786);
	var combineURLs = __webpack_require__(784);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	var transformData = __webpack_require__(781);
	var isCancel = __webpack_require__(398);
	var defaults = __webpack_require__(276);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 779 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(399);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 782 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 784 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 786 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(101);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 790 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAbsenceReport = getAbsenceReport;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Getting absence from api
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/absence
	 */
	function getAbsenceReport(data) {
	  var url = _constants.API_URL + '/Shop/Reports/Absence';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCarRentalContract = getCarRentalContract;
	exports.updateCarRentalContract = updateCarRentalContract;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Gets CarRentalContract data for an order/carRental combination
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/carrentalcontracts
	 */
	function getCarRentalContract(orderId, carRentalId, forceNew) {
	  var url = _constants.API_URL + '/CarRentalContract/Get/';
	  var data = { OrderId: orderId, CarRentalId: carRentalId, ForceNew: forceNew };
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Updates CarRentalContract data for an order/carRental combination
	 * @return {Promise} Axios promise
	 */
	function updateCarRentalContract(contractData) {
	  var url = _constants.API_URL + '/CarRentalContract/Update/';
	  return function (dispatch) {
	    return _axios2.default.post(url, contractData);
	  };
	}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAssessmentCustomerRates = getAssessmentCustomerRates;
	exports.updateAssessmentCustomerRates = updateAssessmentCustomerRates;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get assessment discounts/kickbacks
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/discountsAndKickback
	 */
	function getAssessmentCustomerRates() {
	  var customerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var usage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var url = _constants.API_URL + '/DiscountsAndKickback/Assessment/Customer/Get/' + customerId + '?usage=' + usage;
	  // if (customerId !== undefined && customerId > 0) url += '?CustomerId=' + customerId + '&usage=' + usage
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Update assessment discounts/kickbacks
	 * @return {Promise} Axios promise
	 */
	function updateAssessmentCustomerRates(data) {
	  var url = _constants.API_URL + '/DiscountsAndKickback/Assessment/Customer/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEvaluationHistory = getEvaluationHistory;
	exports.updateEvaluationHistory = updateEvaluationHistory;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get evaluation history from api
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/evaluationhistory
	 */
	function getEvaluationHistory(orderId) {
	  var url = _constants.API_URL + '/EvaluationHistory/Get/' + orderId;
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Update evaluation history changes to api
	 * @return {Promise} Axios promise
	 */
	function updateEvaluationHistory(data) {
	  var url = _constants.API_URL + '/EvaluationHistory/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetForsiDraftEnums = GetForsiDraftEnums;
	exports.GetForsiDamageTypes = GetForsiDamageTypes;
	exports.GetForsiDraft = GetForsiDraft;
	exports.CreateForsiDraft = CreateForsiDraft;
	exports.UpdateForsiDraft = UpdateForsiDraft;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get Forsi draft enums
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/forsitoken
	 */
	function GetForsiDraftEnums() {
	  var url = _constants.API_URL + '/ForsiToken/Enums/';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get Forsi damage types
	 * @return {Promise} Axios promise
	 */
	function GetForsiDamageTypes(id) {
	  var url = _constants.API_URL + ('/ForsiToken/DamageTypes/' + id);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Get Forsi draft
	 * @return {Promise} Axios promise
	 */
	function GetForsiDraft(id) {
	  var url = _constants.API_URL + ('/ForsiToken/Draft/' + id);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Post Forsi draft
	 * @return {Promise} Axios promise
	 */
	function CreateForsiDraft(data) {
	  var url = _constants.FILE_STORAGE_API + '/ForsiToken/Draft/';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Update Forsi draft
	 * @return {Promise} Axios promise
	 */
	function UpdateForsiDraft(id, data) {
	  var url = _constants.API_URL + ('/ForsiToken/Draft/' + id);
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forgotPassword = forgotPassword;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Sending email with token for password reset
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/password
	 */
	function forgotPassword(email) {
	  var url = _constants.API_URL + '/Users/ForgottenPassword';
	  return function (dispatch) {
	    return _axios2.default.post(url, { Email: email });
	  };
	}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getReleases = getReleases;
	exports.postRelease = postRelease;
	exports.getResponseTimeStatistics = getResponseTimeStatistics;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get releases
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/users
	 */
	function getReleases() {
	  var url = _constants.API_URL + '/Performance/Releases/Get';
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Create or update release
	 * @return {Promise} Axios promise
	 */
	function postRelease(data) {
	  var url = _constants.API_URL + '/Performance/Releases/Post';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Get response time statistics
	 * @return {Promise} Axios promise
	 */
	function getResponseTimeStatistics(type) {
	  var url = _constants.API_URL + ('/Performance/ResponseTime/Get/' + type);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPendingMerges = getPendingMerges;
	exports.reportOrderMatch = reportOrderMatch;
	exports.cancelReportOrder = cancelReportOrder;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Get pending report merges for specified orderId
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/tasks
	 */
	function getPendingMerges(orderId) {
	  var url = _constants.API_URL + ('/Report/ManualMerge/' + orderId);
	  return function (dispatch) {
	    return _axios2.default.get(url);
	  };
	}
	
	/**
	 * @description Match a report and order
	 * @return {Promise} Axios promise
	 */
	function reportOrderMatch(data) {
	  var url = _constants.API_URL + '/Report/ManualMerge';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}
	
	/**
	 * @description Cancel a report merge request i.e. create the report as a new order
	 * @return {Promise} Axios promise
	 */
	function cancelReportOrder(data) {
	  var url = _constants.API_URL + '/Report/CancelMergeRequest';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setUploads = undefined;
	exports.setUploadsAction = setUploadsAction;
	exports.finishUploadsIfAllDone = finishUploadsIfAllDone;
	
	var _constants = __webpack_require__(5);
	
	function setUploadsAction(uploads) {
	  return {
	    type: _constants.SET_UPLOADS,
	    payload: uploads
	  };
	} /**
	   * @module actions/uploads
	   */
	var setUploads = exports.setUploads = function setUploads(uploads) {
	  return function (dispatch) {
	    dispatch(setUploadsAction(uploads));
	  };
	};
	
	function finishUploadsIfAllDone() {
	  return {
	    type: _constants.FINISH_UPLOADS
	  };
	}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createBaseUser = createBaseUser;
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description Create base user
	 * @return {Promise} Axios promise
	 */
	/**
	 * @module actions/users
	 */
	function createBaseUser(data) {
	  var url = _constants.API_URL + '/Users/Create';
	  return function (dispatch) {
	    return _axios2.default.post(url, data);
	  };
	}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(77);
	
	var _lodash = __webpack_require__(27);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _setAuthorizationToken = __webpack_require__(206);
	
	var _auth = __webpack_require__(8);
	
	var _auth2 = __webpack_require__(68);
	
	var _detect = __webpack_require__(102);
	
	var _reactRouter = __webpack_require__(43);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouterRedux = __webpack_require__(690);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _UploadOverlay = __webpack_require__(1061);
	
	var _UploadOverlay2 = _interopRequireDefault(_UploadOverlay);
	
	var _axios = __webpack_require__(22);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _routes = __webpack_require__(426);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	__webpack_require__(1695);
	
	var _language = __webpack_require__(139);
	
	var _common = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Redux
	
	
	// import I18n from './language'
	
	// Toastr
	window.toastr.options.progressBar = true;
	window.toastr.options.positionClass = 'toast-bottom-right';
	window.toastr.options.newestOnTop = false;
	
	// Lightbox
	window.lightbox.option({
	  albumLabel: '%1 / %2'
	});
	
	// Moment
	_moment2.default.locale('en', {
	  week: {
	    dow: 1
	  }
	});
	
	// Sockets
	var sockUrl = ("wss://socket.apromas.com:443");
	var sock = new window.ReconnectingWebSocket(sockUrl, null, {
	  debug: false,
	  reconnectInterval: 3000
	});
	
	sock.OPEN = 1;
	window.sock = sock;
	sock.onopen = function (e) {
	  console.log('[app][sock.onopen]', sock);
	  if (window.localStorage.user_data || window.localStorage.loginAsUser) {
	    // Connect to socket
	    setTimeout(function () {
	      if (window.sock.readyState === window.sock.OPEN) {
	        var shopId = JSON.parse(window.localStorage.user_data).ShopId;
	        if (parseInt(shopId) === 0 && window.localStorage.loginAsUser) {
	          shopId = JSON.parse(window.localStorage.loginAsUser).ShopId;
	        }
	        window.sock.send(JSON.stringify({
	          Type: 'RECONNECT',
	          ShopId: parseInt(shopId)
	        }));
	      }
	    }, 3000);
	  }
	};
	
	sock.onmessage = function (e) {
	  var json = JSON.parse(e.data);
	  // console.log('[app][sock.onmessage]', json)
	  switch (json.Type) {
	    case 'HEADER_INFO_MESSAGES':
	    case 'HEADER_INFO_EVALUATION':
	    case 'HEADER_INFO_UPDATES':
	    case 'HEADER_INFO_FORSI':
	    case 'HEADER_INFO_CHAINNOTIFICATION':
	      _events2.default.emit('HEADER_INFO', json);
	      break;
	    case 'ORDER_UPDATE':
	    case 'ORDER_LINKED':
	    case 'ORDER_CREATED':
	    case 'ORDER_MOVED':
	    case 'ORDER_STARTED':
	    case 'ORDER_STOPPED':
	      _events2.default.emit('ORDER_SOCKET', json);
	      break;
	    default:
	      _events2.default.emit(json.Type, json);
	      break;
	  }
	};
	
	if (true) {
	  var FIVE_MINUTES = 60 * 5 * 1000;
	  var lastLeave = new Date();
	  var shouldRefresh = false;
	  document.addEventListener('visibilitychange', function () {
	    if (document.visibilityState === 'hidden') {
	      lastLeave = new Date();
	    }
	    if (document.visibilityState === 'visible' && window.jQuery('.dropzone').length === 0) {
	      shouldRefresh = new Date() - lastLeave > FIVE_MINUTES;
	      if (shouldRefresh) {
	        window.location.reload(true);
	      }
	    }
	  });
	}
	
	// Send ping every 10 sec
	setInterval(function () {
	  if (window.sock.readyState === window.sock.OPEN) {
	    window.sock.send(JSON.stringify({
	      Type: 'HEARTBEAT'
	    }));
	  }
	}, 10000);
	
	// Listen on store
	var currentValue = void 0;
	function handleChange() {
	  var previousValue = currentValue;
	  currentValue = _store2.default.getState().auth.user;
	  if (!(0, _lodash.isEqual)(previousValue, currentValue)) {
	    if (window.sock.readyState === window.sock.OPEN) {
	      window.sock.send(JSON.stringify({
	        Type: 'RECONNECT',
	        ShopId: parseInt(currentValue.ShopId)
	      }));
	    }
	  }
	}
	_store2.default.subscribe(handleChange);
	
	// Axios
	
	_axios2.default.defaults.headers.post['Content-Type'] = 'application/json';
	
	// import routes
	
	
	// import global scss
	
	
	// Language
	
	(0, _language.InitLanguage)().then(function (res) {
	  // Set translations
	  _store2.default.dispatch((0, _language.setTranslations)(res.translations));
	  _store2.default.dispatch((0, _language.setLanguages)(res.langs));
	
	  // Set rest
	  _store2.default.dispatch((0, _common.setPhoneCodes)(res.data.PhoneCodes));
	  _store2.default.dispatch((0, _common.setBrands)(res.data.Brands));
	  _store2.default.dispatch((0, _common.setEnums)(res.data.Enums));
	  _store2.default.dispatch((0, _common.setCountries)(res.data.Countries));
	  _store2.default.dispatch((0, _common.setVehicleLookupServices)(res.data.VehicleLookupServices));
	
	  // Set user language
	  if (typeof window.localStorage.user_language !== 'undefined') {
	    _store2.default.dispatch((0, _language.setLanguage)(window.localStorage.user_language));
	  }
	});
	
	// History
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, _store2.default);
	
	// Is user logged in, if accessing embedded booking don't set data from localstorage see AP-3454
	if (window.localStorage.user_token && window.localStorage.user_data && !window.location.pathname.startsWith('/embeddedbooking')) {
	  if (window.localStorage.loginAsUser && window.localStorage.inactiveUsers) {
	    if (JSON.parse(window.localStorage.inactiveUsers).length === 0) {
	      window.localStorage.removeItem('inactiveUsers');
	      window.localStorage.removeItem('loginAsUser');
	      // Normal login
	      (0, _setAuthorizationToken.setAuthorizationToken)(window.localStorage.user_token);
	      (0, _setAuthorizationToken.setDeviceToken)(JSON.parse(window.localStorage.user_data).DeviceToken);
	      _store2.default.dispatch((0, _auth2.setCurrentUser)(JSON.parse(window.localStorage.user_data)));
	      if (window.localStorage.department_type === undefined) {
	        window.localStorage.setItem('department_type', 0);
	      }
	      _store2.default.dispatch((0, _auth2.setDepartmentType)(JSON.parse(window.localStorage.department_type)));
	    } else {
	      // Login as
	      (0, _setAuthorizationToken.setAuthorizationToken)(JSON.parse(window.localStorage.loginAsUser).Token);
	      (0, _setAuthorizationToken.setDeviceToken)(JSON.parse(window.localStorage.loginAsUser).DeviceToken);
	      _store2.default.dispatch((0, _auth2.setCurrentUser)(JSON.parse(window.localStorage.loginAsUser)));
	      if (window.localStorage.department_type === undefined) {
	        window.localStorage.setItem('department_type', 0);
	      }
	
	      _store2.default.dispatch((0, _auth2.setDepartmentType)(JSON.parse(window.localStorage.department_type)));
	      _store2.default.dispatch({
	        type: 'SET_LOGIN_AS',
	        inactiveUsers: JSON.parse(window.localStorage.inactiveUsers),
	        user: JSON.parse(window.localStorage.loginAsUser)
	      });
	    }
	  } else {
	    // Normal login
	    (0, _setAuthorizationToken.setAuthorizationToken)(window.localStorage.user_token);
	    (0, _setAuthorizationToken.setDeviceToken)(JSON.parse(window.localStorage.user_data).DeviceToken);
	    _store2.default.dispatch((0, _auth2.setCurrentUser)(JSON.parse(window.localStorage.user_data)));
	    if (window.localStorage.department_type === undefined) {
	      window.localStorage.setItem('department_type', 0);
	    }
	    _store2.default.dispatch((0, _auth2.setDepartmentType)(JSON.parse(window.localStorage.department_type)));
	  }
	  // Connect to socket
	  setTimeout(function () {
	    if (window.sock.readyState === window.sock.OPEN) {
	      var shopId = JSON.parse(window.localStorage.user_data).ShopId;
	      if (parseInt(shopId) === 0 && window.localStorage.loginAsUser) {
	        shopId = JSON.parse(window.localStorage.loginAsUser).ShopId;
	      }
	      window.sock.send(JSON.stringify({
	        Type: 'CONNECTION',
	        ShopId: parseInt(shopId)
	      }));
	    }
	  }, 3000);
	}
	
	// SET_LOGINTIMER
	var setLoginTimer = function setLoginTimer(store) {
	  var newDate = window.CustomDate();
	  if (false) {
	    newDate.setSeconds(newDate.getSeconds() + 60 * 10);
	  } else {
	    var isLoginFromOwner = (0, _auth.isLoginFromShopOwner)(store.getState().auth.inactiveUsers);
	    if (isLoginFromOwner) {
	      newDate.setSeconds(newDate.getSeconds() + 120);
	    } else {
	      newDate.setSeconds(newDate.getSeconds() + 60);
	    }
	  }
	  store.dispatch({
	    type: 'SET_LOGINTIMER',
	    loginTimer: newDate
	  });
	};
	
	// COUNTDOWN LOGIN - on mouse click
	document.addEventListener('click', function () {
	  setLoginTimer(_store2.default);
	}, true);
	
	// LocalstorageStack
	window.LocalstorageStack = {
	  all: function all() {
	    var locations = JSON.parse(window.localStorage.getItem('stack_locations')) || [];
	    return locations;
	  },
	  top: function top() {
	    var locations = JSON.parse(window.localStorage.getItem('stack_locations')) || [];
	    if (locations.length === 0 || locations[locations.length - 2] === undefined) return false;
	    return locations[locations.length - 2];
	  },
	  get: function get(index) {
	    var locations = JSON.parse(window.localStorage.getItem('stack_locations')) || [];
	    if (locations.length === 0 || locations[locations.length + index] === undefined) return false;
	    return locations[locations.length + index];
	  },
	  push: function push(location) {
	    var locations = JSON.parse(window.localStorage.getItem('stack_locations')) || [];
	    if (locations.length > 15) locations.shift();
	    locations.push(location);
	    window.localStorage.setItem('stack_locations', JSON.stringify(locations));
	  },
	  findFirst: function findFirst(paths) {
	    var foundItem = null;
	    var all = window.LocalstorageStack.all();
	    if (!all) {
	      return foundItem;
	    }
	    all = all.reverse();
	    all.map(function (item) {
	      var indexOfPaths = paths.indexOf(item.pathname);
	      if (indexOfPaths !== -1 && foundItem === null) {
	        foundItem = item;
	      }
	    });
	    return foundItem;
	  }
	};
	
	window.LocalstorageStack.push(window.location);
	
	// history listener
	history.listen(function (location) {
	  // console.log('location', location)
	  window.LocalstorageStack.push(location);
	
	  // COUNTDOWN LOGIN
	  setLoginTimer(_store2.default);
	});
	
	// Check loginTimer
	setInterval(function () {
	  var loginTimer = _store2.default.getState().common.loginTimer;
	  var now = window.CustomDate();
	  var diff = (loginTimer.getTime() - now.getTime()) / 1000;
	  if (diff <= 0) {
	    if (typeof _store2.default.getState().auth.user.UserType !== 'undefined') {
	      if (_store2.default.getState().auth.user.UserType === 3 && _store2.default.getState().auth.inactiveUsers.length !== 0 && !(0, _auth.isLoginFromChainOrSuper)(_store2.default.getState().auth.inactiveUsers)) {
	        // window.localStorage.setItem('workscreen_view', null)
	        _store2.default.dispatch((0, _auth2.logOutAs)());
	        history.replace('/empty');
	        history.replace('/workscreen');
	      }
	    }
	  }
	}, 1000);
	
	// Response interceptor - Logout on 401
	_axios2.default.interceptors.response.use(function (response) {
	  return response;
	}, function (error) {
	  if (error.response && error.response.status === 401) {
	    if (_store2.default.getState().auth.inactiveUsers.length === 0) {
	      var bookingPortalUser = _store2.default.getState().auth.user.Usage === 1;
	      _store2.default.dispatch((0, _auth2.logout)());
	      if (history.getCurrentLocation().pathname !== '/login') {
	        if (!bookingPortalUser) {
	          history.replace('/login');
	        }
	        window.location.reload(true);
	      }
	    } else {
	      _store2.default.dispatch((0, _auth2.logOutAs)(true));
	      history.replace('/');
	      window.location.reload(true);
	    }
	  }
	  return Promise.reject(error);
	});
	
	// DEBOUNCE
	window.debounce = function (func, wait, immediate) {
	  var timeout;
	  return function () {
	    var context = this;
	    var args = arguments;
	    var later = function later() {
	      timeout = null;
	      if (!immediate) func.apply(context, args);
	    };
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    if (callNow) func.apply(context, args);
	  };
	};
	
	// copy text eventListener
	// info: https://developer.mozilla.org/en-US/docs/Web/API/Element/copy_event
	document.addEventListener('copy', function (event) {
	  // let selection = checkCopyText(document.getSelection())
	  var selection = checkCopyTextIsRegNumber(getSelectionText());
	  event.clipboardData.setData('text/plain', selection.toString());
	  event.preventDefault();
	  // console.log('Copied the text: ' + selection)
	});
	
	var checkCopyTextIsRegNumber = function checkCopyTextIsRegNumber(copyText) {
	  // Regex to find registration number //DC97811
	  var regNrRegex = new RegExp(/(^\s*[a-zA-Z]{2})(\s*)(\d{2})(\s*)(\d{3}\s*$)/);
	  // remove space if the copy text is a registration number
	  if (regNrRegex.test(copyText.toString()) && copyText.toString().replace(/ /g, '').length === 7) {
	    // console.log('Reg Match: ' + copyText)
	    copyText = copyText.toString().replace(/ /g, '');
	  } else {
	    // console.log('Reg not Match: ' + copyText)
	  }
	
	  return copyText;
	};
	
	// Since getSelection() doesn't work in firefox input elemnets, we need to get activeElement before we can find the selected text
	// info: https://developer.mozilla.org/en-US/docs/Web/API/Document/activeElement
	function getSelectionText() {
	  var text = '';
	  var activeEl = document.activeElement;
	  var activeElTagName = activeEl ? activeEl.tagName.toLowerCase() : null;
	  if (activeElTagName === 'textarea' || activeElTagName === 'input' && /^(?:text|search|tel|url)$/i.test(activeEl.type) || typeof activeEl.selectionStart === 'number') {
	    text = activeEl.value.slice(activeEl.selectionStart, activeEl.selectionEnd);
	  } else if (window.getSelection) {
	    text = window.getSelection().toString();
	  }
	
	  return text;
	}
	
	// Use to get browser name and add it as class name to the element app.
	function addClassName() {
	  var element = document.getElementById('app');
	  var className = (0, _detect.getBrowserName)();
	  element.classList.add(className);
	}
	
	var routesConfig = (0, _routes2.default)(_store2.default);
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this.state = {
	      key: 0
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _events2.default.addListener('USER_CHANGED_LANG', function () {
	        setTimeout(function () {
	          _this2.forceUpdate();
	        }, 50);
	      });
	      _events2.default.addListener('FORCE_UPDATE', function () {
	        _this2.forceReRender();
	      });
	      addClassName();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      _events2.default.removeListener('USER_CHANGED_LANG', function () {
	        setTimeout(function () {
	          _this3.forceUpdate();
	        }, 50);
	      });
	      _events2.default.removeListener('FORCE_UPDATE', function () {
	        _this3.forceReRender();
	      });
	    }
	
	    // Used to render the entire app again, only when the language resources has updated (some pages was blank until state changed)
	
	  }, {
	    key: 'forceReRender',
	    value: function forceReRender() {
	      var _this4 = this;
	
	      // Timeout is for components to recieve props before rerendering (Workcard recieved undefined in Order and called ReloadPage)
	      setTimeout(function () {
	        _this4.setState({ key: Math.random() });
	        setLoginTimer(_store2.default);
	      }, 750);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _store2.default },
	        _react2.default.createElement(
	          'div',
	          { key: this.state.key },
	          _react2.default.createElement(_reactRouter.Router, { history: history, routes: routesConfig }),
	          _react2.default.createElement(_UploadOverlay2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	// Render app
	
	
	(0, _reactDom.render)(_react2.default.createElement(App, null), document.getElementById('app'));

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.i18nState = i18nState;
	var reduxI18nState = {
	  languages: [],
	  lang: 'Danish',
	  translations: {}
	};
	
	function i18nState() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reduxI18nState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'REDUX_I18N_SET_LANGUAGE':
	      return _extends({}, state, { lang: action.lang });
	    case 'REDUX_I18N_SET_TRANSLATIONS':
	      return _extends({}, state, { translations: action.translations });
	    case 'REDUX_I18N_SET_LANGUAGES':
	      return _extends({}, state, { languages: action.languages });
	    default:
	      return state;
	  }
	}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _absence = __webpack_require__(791);
	
	var _helpers = __webpack_require__(2);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(1355);
	
	var _auth = __webpack_require__(8);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	// import Col from '../../shared/elements/col'
	
	// import Label from '../../shared/elements/label'
	// import Grid from '../../shared/elements/grid'
	
	var AbsenceReport = function (_Component) {
	  _inherits(AbsenceReport, _Component);
	
	  function AbsenceReport(props) {
	    _classCallCheck(this, AbsenceReport);
	
	    var _this = _possibleConstructorReturn(this, (AbsenceReport.__proto__ || Object.getPrototypeOf(AbsenceReport)).call(this, props));
	
	    _this.state = {
	      list: [],
	      From: '',
	      To: ''
	    };
	    _this.renderGroup = _this.renderGroup.bind(_this);
	    _this.renderDay = _this.renderDay.bind(_this);
	    _this.searchNew = _this.searchNew.bind(_this);
	    return _this;
	  }
	
	  _createClass(AbsenceReport, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAbsenceReport();
	    }
	  }, {
	    key: 'genPeriod',
	    value: function genPeriod(day) {
	      var period1 = (0, _moment2.default)(day.Date).format('DD.MM');
	      var period2 = (0, _moment2.default)(day.Date).add(4, 'days').format('DD.MM');
	      return period1 + ' - ' + period2;
	    }
	  }, {
	    key: 'searchNew',
	    value: function searchNew(e) {
	      e.preventDefault();
	      this.setState({
	        list: []
	      });
	      this.getAbsenceReport(this.state.From, this.state.To);
	    }
	  }, {
	    key: 'getDateFromInput',
	    value: function getDateFromInput(input, type) {
	      var newDate = (0, _moment2.default)(input);
	      if (typeof input === 'undefined' || !newDate.isValid()) {
	        var date = new Date();
	        var year = date.getFullYear();
	        var month = date.getMonth();
	
	        var startDate = (0, _moment2.default)([year, month]);
	        var endDate = (0, _moment2.default)(startDate).endOf('month');
	
	        newDate = type === 0 ? startDate : endDate;
	      }
	      return newDate.format('YYYY-MM-DD');
	    }
	  }, {
	    key: 'getAbsenceReport',
	    value: function getAbsenceReport(fromDate, toDate) {
	      var _this2 = this;
	
	      var data = {
	        ShopId: 0,
	        From: this.getDateFromInput(fromDate, 0),
	        To: this.getDateFromInput(toDate, 1)
	      };
	      this.props.getAbsenceReport(data).then(function (res) {
	        var grouped = [];
	        var days = res.data.Days;
	
	        // Filter away days -  0 & 6 is weekend
	        days = days.filter(function (day, index) {
	          if (day.WeekDay === 0 || day.WeekDay === 6) return false;
	          return day;
	        });
	
	        // Loop through the days and group them together
	        var i = 1;
	        var x = 0;
	        days.map(function (day) {
	          if (typeof grouped[x] === 'undefined') {
	            grouped[x] = {
	              Period: _this2.genPeriod(day),
	              Days: [day]
	            };
	          } else {
	            grouped[x].Days.push(day);
	          }
	
	          if (i % 5 === 0) {
	            i = 0;
	            x++;
	          }
	          i++;
	        });
	
	        _this2.setState({
	          list: grouped
	        });
	      }, function () {
	        console.log('Error getting absence repport');
	      });
	    }
	  }, {
	    key: 'getLetterFromType',
	    value: function getLetterFromType(type) {
	      switch (type) {
	        case 0:
	          return _react2.default.createElement(
	            'span',
	            { className: 'type blue1' },
	            'A'
	          );
	        case 1:
	          return _react2.default.createElement(
	            'span',
	            { className: 'type green1' },
	            'D'
	          );
	        case 2:
	          return _react2.default.createElement(
	            'span',
	            { className: 'type green2' },
	            'E'
	          );
	        case 3:
	          return _react2.default.createElement(
	            'span',
	            { className: 'type blue2' },
	            'B'
	          );
	        case 4:
	          return _react2.default.createElement(
	            'span',
	            { className: 'type blue3' },
	            'C'
	          );
	        default:
	          return '';
	      }
	    }
	  }, {
	    key: 'renderDay',
	    value: function renderDay(day, key) {
	      var _this3 = this;
	
	      var momentDate = (0, _moment2.default)(day.Date);
	      var isToday = momentDate.isSame((0, _moment2.default)(), 'day');
	      var extraClass = '';
	      if (isToday) {
	        extraClass = 'isToday';
	      }
	      return _react2.default.createElement(
	        'td',
	        { className: extraClass, key: key },
	        day.Absence.map(function (employee, k) {
	          return _react2.default.createElement(
	            _inline2.default,
	            { spacing: 1, block: true, key: k },
	            _this3.getLetterFromType(employee.AwayType),
	            employee.EmployeeName
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'date' },
	          _react2.default.createElement(
	            'span',
	            null,
	            momentDate.format('DD')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            momentDate.format('DD-MM-YYYY')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderGroup',
	    value: function renderGroup(group, key) {
	      return _react2.default.createElement(
	        'tr',
	        { key: key },
	        _react2.default.createElement(
	          'td',
	          null,
	          group.Period
	        ),
	        group.Days.map(this.renderDay)
	      );
	    }
	  }, {
	    key: 'onDateChange',
	    value: function onDateChange(name, e) {
	      this.setState(_defineProperty({}, name, e));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	
	      var renderInputs = function renderInputs() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'inputs' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(188) },
	            _react2.default.createElement(_datetime2.default, {
	              inputProps: {
	                name: 'from',
	                readOnly: true,
	                placeholder: (0, _helpers.translation)('1728')
	              },
	              dateFormat: 'DD-MM-YYYY',
	              timeFormat: false,
	              closeOnSelect: true,
	              value: _this4.state.From,
	              onChange: _this4.onDateChange.bind(_this4, 'From') })
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(187) },
	            _react2.default.createElement(_datetime2.default, {
	              inputProps: {
	                name: 'to',
	                readOnly: true,
	                placeholder: (0, _helpers.translation)('1728')
	              },
	              dateFormat: 'DD-MM-YYYY',
	              timeFormat: false,
	              closeOnSelect: true,
	              value: _this4.state.To,
	              onChange: _this4.onDateChange.bind(_this4, 'To'),
	              className: 'second' })
	          ),
	          _react2.default.createElement(_button2.default, { spacing: 0, labelText: (0, _helpers.translation)('380'), onClick: _this4.searchNew })
	        );
	      };
	
	      var renderLegend = function renderLegend() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'legend' },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, spacing: 0, alignChildren: 'top' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _inline2.default,
	                { spacing: 1, fillChildNum: [2], block: true },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'type blue1' },
	                  'A'
	                ),
	                '=',
	                (0, _helpers.translation)('500')
	              ),
	              _react2.default.createElement(
	                _inline2.default,
	                { spacing: 0, fillChildNum: [2], block: true },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'type blue2' },
	                  'B'
	                ),
	                '=',
	                (0, _helpers.translation)('1436')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _inline2.default,
	                { spacing: 1, fillChildNum: [2], block: true },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'type blue3' },
	                  'C'
	                ),
	                '=',
	                (0, _helpers.translation)('1435')
	              ),
	              _react2.default.createElement(
	                _inline2.default,
	                { spacing: 0, fillChildNum: [2], block: true },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'type green1' },
	                  'D'
	                ),
	                '=',
	                (0, _helpers.translation)('508')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0, fillChildNum: [2], block: true },
	              _react2.default.createElement(
	                'span',
	                { className: 'type green2' },
	                'E'
	              ),
	              '=',
	              (0, _helpers.translation)('502')
	            )
	          )
	        );
	      };
	
	      var renderTop = function renderTop() {
	        return _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'top' },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: '', clearfix: true },
	              _react2.default.createElement(
	                'div',
	                { className: 'topflex' },
	                renderInputs(),
	                _react2.default.createElement('div', { className: 'filler' }),
	                renderLegend()
	              )
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'absence__screen' },
	        _react2.default.createElement(
	          _Header2.default,
	          { router: this.props.router },
	          _react2.default.createElement(
	            _tabBar2.default,
	            null,
	            _react2.default.createElement(
	              _tabItem2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/punchreport' },
	                (0, _helpers.translation)('2159')
	              )
	            ),
	            _react2.default.createElement(
	              _tabItem2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/punchedit' },
	                (0, _helpers.translation)('2206')
	              )
	            ),
	            _react2.default.createElement(
	              _tabItem2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/absencereport', className: 'active' },
	                (0, _helpers.translation)('1128')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          renderTop()
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _tableContainer2.default,
	            null,
	            _react2.default.createElement(
	              'table',
	              { className: 'calendar' },
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  { className: 'table__header' },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _helpers.translation)('434')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _helpers.translation)('169')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _helpers.translation)('170')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _helpers.translation)('171')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _helpers.translation)('172')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _helpers.translation)('173')
	                  )
	                ),
	                this.state.list.map(this.renderGroup)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AbsenceReport;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getAbsenceReport: _absence.getAbsenceReport
	})(AbsenceReport);

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _actions = __webpack_require__(129);
	
	var _common = __webpack_require__(25);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _PrivacyPolicy = __webpack_require__(444);
	
	var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);
	
	var _helpers = __webpack_require__(2);
	
	var _Auth = __webpack_require__(226);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _auth = __webpack_require__(68);
	
	__webpack_require__(1356);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Components
	
	
	// Utils
	
	
	// Auth wrapper
	
	
	// import styles
	
	
	var Activate = function (_Component) {
	  _inherits(Activate, _Component);
	
	  function Activate(props) {
	    _classCallCheck(this, Activate);
	
	    var _this = _possibleConstructorReturn(this, (Activate.__proto__ || Object.getPrototypeOf(Activate)).call(this, props));
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.validateToken = _this.validateToken.bind(_this);
	
	    _this.state = {
	      ActivationCode: '',
	      Name: '',
	      Initials: '',
	      UserName: '',
	      Password: '',
	      ConfirmPassword: '',
	      Phone: '',
	      Email: '',
	      lockedActivationCode: false,
	      Accept: false,
	      DefaultLanguage: '',
	      AsDefaultLanguage: false
	    };
	    return _this;
	  }
	
	  _createClass(Activate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.routeParams.activationCode !== undefined && this.props.routeParams.activationCode !== '') {
	        this.setState(_extends({}, this.state, {
	          lockedActivationCode: true,
	          ActivationCode: this.props.routeParams.activationCode
	        }), function () {
	          _this2.validateToken();
	        });
	      }
	    }
	  }, {
	    key: 'getDefautlLange',
	    value: function getDefautlLange() {
	      var _state = this.state,
	          AsDefaultLanguage = _state.AsDefaultLanguage,
	          DefaultLanguage = _state.DefaultLanguage;
	
	      if (!AsDefaultLanguage) {
	        // get user language from lacalstorage and if this is undefined get the language from the result
	        if (typeof window.localStorage.user_language !== 'undefined') {
	          _store2.default.dispatch((0, _actions.setLanguage)(window.localStorage.user_language));
	          this.setState({ AsDefaultLanguage: true });
	        } else {
	          if (!AsDefaultLanguage && DefaultLanguage) {
	            _store2.default.dispatch((0, _actions.setLanguage)(DefaultLanguage));
	            this.setState({ AsDefaultLanguage: true });
	          } else {
	            _store2.default.dispatch((0, _actions.setLanguage)('English'));
	          }
	        }
	      }
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      e.preventDefault();
	
	      var data = {
	        ActivationCode: this.state.ActivationCode,
	        Name: this.state.Name,
	        Initials: this.state.Initials,
	        UserName: this.state.UserName,
	        Password: this.state.Password,
	        ConfirmPassword: this.state.ConfirmPassword,
	        Phone: this.state.Phone,
	        Email: this.state.Email
	      };
	      this.props.submitActionToken(data).then(function (res) {
	        window.location.href = window.location.origin + '/login';
	      }, function (err) {
	        if (err.response.data !== undefined && err.response.data.length > 0) {
	          err.response.data.map(function (error) {
	            window.toastr.error((0, _helpers.translation)(error.DictionaryKey));
	          });
	        }
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') value = e.target.checked;
	      this.setState(_defineProperty({}, e.target.name, value));
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      e.preventDefault();
	      this.validateToken();
	    }
	  }, {
	    key: 'validateToken',
	    value: function validateToken() {
	      var _this3 = this;
	
	      var data = {
	        ActivationCode: this.state.ActivationCode
	      };
	      this.props.checkActionToken(data).then(function (res) {
	        _this3.setState(_extends({}, _this3.state, {
	          ActivationCode: res.data.ActivationCode,
	          Name: res.data.Name,
	          Email: res.data.Email,
	          DefaultLanguage: res.data.DefaultLanguage
	        }), function () {
	          _this3.getDefautlLange();
	        });
	      }, function (err) {
	        if (err.response.data.Errors !== undefined && err.response.data.Errors.length > 0) {
	          err.response.data.Errors.map(function (error) {
	            window.toastr.error((0, _helpers.translation)(error.DictionaryKey));
	          });
	        }
	      });
	    }
	  }, {
	    key: 'renderHelpTexts',
	    value: function renderHelpTexts() {
	      return _react2.default.createElement(
	        'ol',
	        { className: 'helpTexts' },
	        _react2.default.createElement(
	          'li',
	          null,
	          (0, _helpers.translation)('16400')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          (0, _helpers.translation)('16401')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          (0, _helpers.translation)('16402')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          (0, _helpers.translation)('16403')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          (0, _helpers.translation)('16404')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          (0, _helpers.translation)('16405')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          (0, _helpers.translation)('16406')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          (0, _helpers.translation)('16407')
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          Name = _state2.Name,
	          Email = _state2.Email,
	          ActivationCode = _state2.ActivationCode,
	          Accept = _state2.Accept;
	
	
	      var goBack = function goBack(router, t) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_closeButton2.default, { spacing: 0, ariaLabel: t('394'), onClick: function onClick() {
	              return router.goBack();
	            } })
	        );
	      };
	
	      // Auth props before: showBack headerButtonsGoBack={goBack}
	      return _react2.default.createElement(
	        'div',
	        { className: 'activation__screen' },
	        _react2.default.createElement(
	          _Auth2.default,
	          { router: this.props.router },
	          _react2.default.createElement(_Header2.default, { showBack: true, headerButtonsGoBack: goBack.bind(this, this.props.router, _helpers.translation) }),
	          _react2.default.createElement(
	            'div',
	            { className: 'activation__layout' },
	            _react2.default.createElement(
	              _panel2.default,
	              null,
	              _react2.default.createElement(
	                'h3',
	                { className: 'title' },
	                (0, _helpers.translation)('16370')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'activation__content' },
	                _react2.default.createElement(
	                  _col2.default,
	                  { id: 'left-col' },
	                  _react2.default.createElement(_panelHeader2.default, { text: 16357 }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'activation__content--left' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: this.onSubmit },
	                      _react2.default.createElement(_text2.default, { labelText: '1. ' + (0, _helpers.translation)(16354), helpText: 16400, name: 'ActivationCode', required: true, value: ActivationCode || '', disabled: this.state.lockedActivationCode, onBlur: this.onBlur, onChange: this.onChange }),
	                      _react2.default.createElement(_text2.default, { labelText: '2. ' + (0, _helpers.translation)(30), helpText: 16401, name: 'Name', required: true, value: Name || '', onChange: this.onChange }),
	                      _react2.default.createElement(_text2.default, { labelText: '3. ' + (0, _helpers.translation)(1815), helpText: 16402, name: 'Initials', onChange: this.onChange }),
	                      _react2.default.createElement(_text2.default, { labelText: '4. ' + (0, _helpers.translation)(1), helpText: 16403, name: 'UserName', required: true, onChange: this.onChange }),
	                      _react2.default.createElement(_text2.default, { labelText: '5. ' + (0, _helpers.translation)(2), helpText: 16404, name: 'Password', isPassword: true, onChange: this.onChange }),
	                      _react2.default.createElement(_text2.default, { labelText: '6. ' + (0, _helpers.translation)(14883), helpText: 16405, name: 'ConfirmPassword', isPassword: true, onChange: this.onChange }),
	                      _react2.default.createElement(_text2.default, { labelText: '7. ' + (0, _helpers.translation)(38), helpText: 16406, name: 'Phone', onChange: this.onChange }),
	                      _react2.default.createElement(_text2.default, { labelText: '8. ' + (0, _helpers.translation)(1052), helpText: 16407, name: 'Email', required: true, value: Email || '', onChange: this.onChange }),
	                      _react2.default.createElement(_divider2.default, null),
	                      _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)(16385), name: 'Accept', id: 'accept', onChange: this.onChange, checked: Accept, required: true }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'accept-text' },
	                        (0, _helpers.translation)(16386)
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'accept-text' },
	                        (0, _helpers.translation)(16387)
	                      ),
	                      _react2.default.createElement(_divider2.default, { noLine: true }),
	                      _react2.default.createElement(_PrivacyPolicy2.default, { text: (0, _helpers.translation)(16655) }),
	                      _react2.default.createElement(_button2.default, { labelText: 16356 })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _col2.default,
	                  { id: 'right-col' },
	                  _react2.default.createElement(_panelHeader2.default, { text: 16358 }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'activation__content--right' },
	                    this.renderHelpTexts()
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Activate;
	}(_react.Component);
	
	Activate.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	Activate.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getCustomerLanguage: _common.getCustomerLanguage,
	  setLanguage: _actions.setLanguage,
	  checkActionToken: _auth.checkActionToken,
	  submitActionToken: _auth.submitActionToken
	})(Activate);

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _address = __webpack_require__(277);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	
	// Utils
	
	
	var AddressesCreate = function (_Component) {
	  _inherits(AddressesCreate, _Component);
	
	  function AddressesCreate(props) {
	    _classCallCheck(this, AddressesCreate);
	
	    var _this = _possibleConstructorReturn(this, (AddressesCreate.__proto__ || Object.getPrototypeOf(AddressesCreate)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      address: {
	        CustomerClientId: 0,
	        Name: '',
	        Address: '',
	        City: '',
	        ZipCode: '',
	        PhoneNumber: '',
	        PhoneCode: _this.props.phonecode
	      },
	      confirm: {
	        open: false,
	        type: 0
	      },
	      confirmDelete: {
	        open: false
	      }
	    };
	    _this.inputChange = _this.inputChange.bind(_this);
	    _this.saveAddress = _this.saveAddress.bind(_this);
	    _this.deleteAddress = _this.deleteAddress.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(AddressesCreate, [{
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        address: {
	          CustomerClientId: 0,
	          Name: '',
	          Address: '',
	          City: '',
	          ZipCode: '',
	          PhoneNumber: '',
	          PhoneCode: this.props.phonecode,
	          CompanyDepartment: this.props.auth.departmentType
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof this.props.item.CustomerClientId === 'undefined') {
	        this.resetCreate();
	      } else {
	        this.setState({
	          type: 'edit',
	          address: this.props.item
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (typeof nextProps.item.CustomerClientId === 'undefined') {
	        this.resetCreate();
	      } else {
	        this.setState({
	          type: 'edit',
	          address: nextProps.item
	        });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      var value = e.target.value;
	
	      if (e.target.type === 'radio') {
	        value = e.target.value === 'yes';
	      }
	      this.setState({
	        // type: 'edit',
	        address: _extends({}, this.state.address, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'radio') {
	          _this2.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      if (this.state.address.CustomerClientId !== undefined && this.state.address.CustomerClientId !== 0) {
	        this.saveAddress();
	      }
	    }
	  }, {
	    key: 'inputChange',
	    value: function inputChange(e) {
	      var value = e.target.value;
	      if (e.target.name === 'PhoneCode') {
	        value = {
	          Id: e.target.value
	        };
	      }
	      this.setState({
	        address: _extends({}, this.state.address, _defineProperty({}, e.target.name, value))
	      });
	    }
	  }, {
	    key: 'saveAddress',
	    value: function saveAddress() {
	      var _this3 = this;
	
	      this.props.createSaveAddress(this.state.address).then(function (res) {
	        _this3.props.onSave(res.data, _this3.state.type);
	      }, function (err) {
	        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	          var errors = err.response.data.Errors;
	          var errorText = '';
	          errors.map(function (item) {
	            if (item.DictionaryKey !== 0) {
	              errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	            }
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13468'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'deleteAddress',
	    value: function deleteAddress() {
	      this.setState({
	        confirmDelete: {
	          open: true
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('13420'), helpText: (0, _helpers.translation)('1941') },
	            _react2.default.createElement(_text2.default, { name: 'Name', value: this.state.address.Name, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('30') }),
	            _react2.default.createElement(_text2.default, { name: 'Address', value: this.state.address.Address, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('25') }),
	            _react2.default.createElement(_text2.default, { name: 'ZipCode', value: this.state.address.ZipCode, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('40') }),
	            _react2.default.createElement(_text2.default, { name: 'City', value: this.state.address.City, onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('37') }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('345') },
	              _react2.default.createElement(_Phone2.default, {
	                onChange: this.inputChange,
	                code: this.state.address.PhoneCode,
	                number: this.state.address.PhoneNumber })
	            ),
	            this.state.type === 'edit' && _react2.default.createElement(_button2.default, { style: 'alert', onClick: this.deleteAddress, labelText: (0, _helpers.translation)('786') })
	          )
	        ),
	        this.state.confirmDelete.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDelete') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDelete') })
	        )
	      );
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm() {
	      var _this4 = this;
	
	      this.onPortalClose('confirmDelete');
	
	      this.props.deleteAddress({
	        ItemID: this.state.address.CustomerClientId
	      }).then(function (res) {
	        _this4.props.onDelete(res.data);
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13469'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	    }
	  }]);
	
	  return AddressesCreate;
	}(_react.Component);
	
	AddressesCreate.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { createSaveAddress: _address.createSaveAddress, deleteAddress: _address.deleteAddress }, null, { withRef: true })(AddressesCreate);

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _address = __webpack_require__(277);
	
	__webpack_require__(1357);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _Create = __webpack_require__(805);
	
	var _Create2 = _interopRequireDefault(_Create);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Addresses = function (_Component) {
	  _inherits(Addresses, _Component);
	
	  function Addresses(props) {
	    _classCallCheck(this, Addresses);
	
	    var _this = _possibleConstructorReturn(this, (Addresses.__proto__ || Object.getPrototypeOf(Addresses)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      addresses: [],
	      search: '',
	      activeItem: {}
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onDelete = _this.onDelete.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Addresses, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAddresses();
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, ariaText: (0, _helpers.translation)('2039'), labelText: (0, _helpers.translation)(1797), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'getAddresses',
	    value: function getAddresses() {
	      var _this2 = this;
	
	      this.props.getAddressses().then(function (res) {
	        var addresses = res.data;
	        addresses.map(function (address, index) {
	          address.CompanyDepartment = _this2.props.auth.departmentType;
	        });
	
	        _this2.setState({
	          addresses: res.data
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(data) {
	      this.setState({
	        view: 'list',
	        activeItem: {},
	        addresses: data
	      });
	      // Toastr
	      // window.toastr.success(translation('13470'), translation('13424'))
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var addresses = [].concat(_toConsumableArray(this.state.addresses));
	      var viewType = '';
	      if (type === 'edit') {
	        for (var i = 0; i < addresses.length; i++) {
	          if (addresses[i].CustomerClientId === data.CustomerClientId) {
	            addresses[i] = data;
	          }
	        }
	        viewType = 'item';
	      } else {
	        addresses.push(data);
	        viewType = 'list';
	      }
	      var activeItem = viewType === 'item' ? this.state.activeItem : {};
	      this.setState({
	        view: viewType,
	        activeItem: activeItem,
	        addresses: addresses
	      });
	      // Toastr
	      // window.toastr.success(translation('13467'), translation('13424'))
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      if (key.Address.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      this.setState({
	        search: e.target.value
	      });
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.create.getWrappedInstance().saveAddress();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.addresses.map(function (a) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: a.Name,
	          onClick: function onClick() {
	            return _this3.onSelectItem(a);
	          },
	          selected: a.CustomerClientId === _this3.state.activeItem.CustomerClientId,
	          key: a.CustomerClientId
	        });
	      });
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_Create2.default, { ref: 'create', item: this.state.activeItem, onSave: this.onSave, onDelete: this.onDelete, departmentType: this.props.departmentType });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      // using "defaultShowInactive" temporarily, due to "Active" field missing from left menu items
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'addresses__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: function renderRight() {
	            return _this4.headerButtonsRight();
	          } }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: true },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'addresses__screen--inner clearfix' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Addresses;
	}(_react.Component);
	
	Addresses.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getAddressses: _address.getAddressses })(Addresses);

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1358);
	
	var _auth = __webpack_require__(68);
	
	var _helpers = __webpack_require__(2);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var ChangePass = function (_Component) {
	  _inherits(ChangePass, _Component);
	
	  function ChangePass(props) {
	    _classCallCheck(this, ChangePass);
	
	    var _this = _possibleConstructorReturn(this, (ChangePass.__proto__ || Object.getPrototypeOf(ChangePass)).call(this, props));
	
	    _this.state = {
	      OldPassword: '',
	      NewPassword: '',
	      ConfirmPassword: ''
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.changePassword = _this.changePassword.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChangePass, [{
	    key: 'changePassword',
	    value: function changePassword() {
	      var _this2 = this;
	
	      var _state = this.state,
	          OldPassword = _state.OldPassword,
	          NewPassword = _state.NewPassword,
	          ConfirmPassword = _state.ConfirmPassword;
	
	      if (NewPassword !== ConfirmPassword) {
	        window.toastr.error((0, _helpers.translation)('14882'), (0, _helpers.translation)('216'));
	        return;
	      }
	
	      var data = {
	        UserId: 0,
	        OldPassword: OldPassword,
	        newPassWord: NewPassword
	      };
	      console.log('Change password', data);
	      this.props.changePassword(data).then(function (res) {
	        console.log('Password changed', res.data);
	        _this2.setState({
	          OldPassword: '',
	          NewPassword: '',
	          ConfirmPassword: ''
	        });
	        // Toastr
	        // window.toastr.success(translation('1083'), translation('13424'))
	      }, function (err) {
	        var data = err.response.data;
	
	        data.map(function (e) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(e.DictionaryKey), (0, _helpers.translation)('216'));
	        });
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(_ref) {
	      var _ref$target = _ref.target,
	          name = _ref$target.name,
	          value = _ref$target.value;
	
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          OldPassword = _state2.OldPassword,
	          NewPassword = _state2.NewPassword,
	          ConfirmPassword = _state2.ConfirmPassword;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'password__screen' },
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('1777') },
	            _react2.default.createElement(_text2.default, { isPassword: true, labelText: (0, _helpers.translation)('1778'), name: 'OldPassword', value: OldPassword, onChange: this.onChange }),
	            _react2.default.createElement(_text2.default, { isPassword: true, labelText: (0, _helpers.translation)('1077'), name: 'NewPassword', value: NewPassword, onChange: this.onChange }),
	            _react2.default.createElement(_text2.default, { isPassword: true, labelText: (0, _helpers.translation)('14883'), name: 'ConfirmPassword', value: ConfirmPassword, onChange: this.onChange }),
	            _react2.default.createElement(_button2.default, { onClick: this.changePassword, labelText: (0, _helpers.translation)('1079') })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChangePass;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  console.debug('Hello, I\'m here!');
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  changePassword: _auth.changePassword
	})(ChangePass);

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1359);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(68);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Utils
	
	
	// actions'
	
	
	// Elements
	
	
	var ChangePin = function (_Component) {
	  _inherits(ChangePin, _Component);
	
	  function ChangePin(props) {
	    _classCallCheck(this, ChangePin);
	
	    var _this = _possibleConstructorReturn(this, (ChangePin.__proto__ || Object.getPrototypeOf(ChangePin)).call(this, props));
	
	    _this.state = {
	      NewPin: '',
	      ConfirmPin: ''
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.changePin = _this.changePin.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChangePin, [{
	    key: 'onChange',
	    value: function onChange(_ref) {
	      var _ref$target = _ref.target,
	          name = _ref$target.name,
	          value = _ref$target.value;
	
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'changePin',
	    value: function changePin() {
	      var _state = this.state,
	          NewPin = _state.NewPin,
	          ConfirmPin = _state.ConfirmPin;
	
	      var regex = /^[0-9\b]+$/;
	
	      if (NewPin !== ConfirmPin) {
	        window.toastr.error((0, _helpers.translation)('17966'), (0, _helpers.translation)('216'));
	        return;
	      }
	
	      if (!regex.test(NewPin)) {
	        window.toastr.error((0, _helpers.translation)('18035'), (0, _helpers.translation)('216'));
	        return;
	      }
	
	      if (NewPin.length < 4 || NewPin.length > 4) {
	        window.toastr.error((0, _helpers.translation)('18036'), (0, _helpers.translation)('216'));
	        return;
	      }
	
	      var data = {
	        UserId: this.props.auth.user.UserId,
	        NewPin: NewPin
	      };
	
	      this.props.changePincode(data).then(function (res) {
	        // window.toastr.success(translation('18037'), translation('13424'))
	      }, function (err) {
	        window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          NewPin = _state2.NewPin,
	          ConfirmPin = _state2.ConfirmPin;
	
	      var hasPin = this.props.auth.user.UserHasPincode;
	      var title = hasPin ? (0, _helpers.translation)('17961') : (0, _helpers.translation)('17977');
	      return _react2.default.createElement(
	        'div',
	        { className: 'pin__screen' },
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: title },
	            _react2.default.createElement(
	              _label2.default,
	              { size: 'l' },
	              (0, _helpers.translation)('18064')
	            ),
	            _react2.default.createElement(_text2.default, { isPassword: true, labelText: (0, _helpers.translation)('17963'), name: 'NewPin', value: NewPin, onChange: this.onChange }),
	            _react2.default.createElement(_text2.default, { isPassword: true, labelText: (0, _helpers.translation)('17964'), name: 'ConfirmPin', value: ConfirmPin, onChange: this.onChange }),
	            _react2.default.createElement(_button2.default, { onClick: this.changePin, labelText: (0, _helpers.translation)('17965') })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChangePin;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { changePincode: _auth.changePincode })(ChangePin);

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	__webpack_require__(1362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotificationItem = function (_Component) {
	  _inherits(NotificationItem, _Component);
	
	  function NotificationItem() {
	    _classCallCheck(this, NotificationItem);
	
	    return _possibleConstructorReturn(this, (NotificationItem.__proto__ || Object.getPrototypeOf(NotificationItem)).apply(this, arguments));
	  }
	
	  _createClass(NotificationItem, [{
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'notification-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'notification-item__content read' },
	          _react2.default.createElement(
	            'div',
	            { className: 'h2-fz h2-color' },
	            (0, _helpers.translation)(data.TitleDictionaryKey)
	          ),
	          _react2.default.createElement(
	            'time',
	            { className: 'color-wrap fz-wrap' },
	            (0, _time.getWeekDay)(data.CreatedDate),
	            ', ',
	            (0, _time.renderFullDate)(data.CreatedDate)
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'color-wrap fz-wrap' },
	            data.Contents
	          )
	        )
	      );
	    }
	  }]);
	
	  return NotificationItem;
	}(_react.Component);
	
	exports.default = NotificationItem;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _expand = __webpack_require__(175);
	
	var _expand2 = _interopRequireDefault(_expand);
	
	var _notificationItem = __webpack_require__(809);
	
	var _notificationItem2 = _interopRequireDefault(_notificationItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotificationsArea = function (_Component) {
	  _inherits(NotificationsArea, _Component);
	
	  function NotificationsArea(props) {
	    _classCallCheck(this, NotificationsArea);
	
	    var _this = _possibleConstructorReturn(this, (NotificationsArea.__proto__ || Object.getPrototypeOf(NotificationsArea)).call(this, props));
	
	    _this.state = {
	      open: true
	    };
	    return _this;
	  }
	
	  _createClass(NotificationsArea, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var allNotification = this.props.notifications;
	
	      var toggleValue = function toggleValue(value) {
	        _this2.setState({
	          open: value
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'status-report status-report-wrap' },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)(1243) },
	          _react2.default.createElement(
	            'div',
	            { className: 'status-report__content' },
	            _react2.default.createElement(
	              _expand2.default,
	              { defaultOpen: this.state.open, title: this.state.open ? (0, _helpers.translation)(18287) : (0, _helpers.translation)(18286), alignRight: true, onClick: toggleValue },
	              allNotification.length > 0 && allNotification.map(function (i) {
	                return _react2.default.createElement(_notificationItem2.default, { key: i.Id, data: i });
	              })
	            ),
	            !this.state.open && allNotification.length > 0 && _react2.default.createElement(_notificationItem2.default, { key: allNotification[0].Id, data: allNotification[0] }),
	            _react2.default.createElement(_divider2.default, { size: 4 }),
	            _react2.default.createElement(_check2.default, { name: 'AllowedSMS', labelText: 18245, labelAlignment: 'r', onChange: this.props.onChangeCbx, checked: this.props.notificationSettings.AllowedSMS || false }),
	            _react2.default.createElement(_check2.default, { name: 'AllowedEmail', labelText: 18246, labelAlignment: 'r', onChange: this.props.onChangeCbx, checked: this.props.notificationSettings.AllowedEmail || false })
	          )
	        )
	      );
	    }
	  }]);
	
	  return NotificationsArea;
	}(_react.Component);
	
	exports.default = NotificationsArea;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _icons = __webpack_require__(6);
	
	var _timeLineSegment = __webpack_require__(455);
	
	var _timeLineSegment2 = _interopRequireDefault(_timeLineSegment);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _chevron = __webpack_require__(1065);
	
	var _chevron2 = _interopRequireDefault(_chevron);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import moment from 'moment'
	
	
	var LINE_TYPES = {
	  None: -1,
	  DoubleSolid: 0,
	  DoubleDashed: 1,
	  SingleSolid: 2,
	  SingleDashed: 3
	};
	
	var POINT_TYPES = {
	  None: -1,
	  Default: 0,
	  Dot_Gray: 1,
	  Intersection: 2,
	  Ok_Green: 3,
	  Exclamation_Red: 4
	
	  // const formatDate = (date) => {
	  //   return moment(date).format('DD-MM-YYYY hh:mm')
	  // }
	
	};
	var StepsArea = function (_Component) {
	  _inherits(StepsArea, _Component);
	
	  function StepsArea(props) {
	    _classCallCheck(this, StepsArea);
	
	    var _this = _possibleConstructorReturn(this, (StepsArea.__proto__ || Object.getPrototypeOf(StepsArea)).call(this, props));
	
	    _this.state = {
	      stepsExpanded: false
	    };
	    _this.renderStep = _this.renderStep.bind(_this);
	    _this.renderUnfinishedProcessStep = _this.renderUnfinishedProcessStep.bind(_this);
	    return _this;
	  }
	
	  _createClass(StepsArea, [{
	    key: 'renderUnfinishedProcessStep',
	    value: function renderUnfinishedProcessStep(step, index) {
	      var _this2 = this;
	
	      var contentClass = 'content';
	      if (!step.IsActive) contentClass += ' dimmed';
	
	      var lines = [{
	        LineTypeBefore: LINE_TYPES.DoubleDashed,
	        LineDotType: step.IsCompleted ? POINT_TYPES.Ok_Green : POINT_TYPES.Dot_Gray,
	        LineTypeAfter: LINE_TYPES.DoubleDashed
	      }];
	
	      if (!this.state.stepsExpanded && step.IsCompleted && !step.IsActive) return null;
	      var isBodyShopFinishing = step.OrderBy !== 9;
	      return _react2.default.createElement(
	        'div',
	        { key: 'un-item-' + index + '-container', className: isBodyShopFinishing ? 'wrap-unfinished-process-step' : null },
	        _react2.default.createElement(
	          'div',
	          { key: 'un-item-' + index, className: 'timeline-step' },
	          _react2.default.createElement(
	            'div',
	            { className: 'lines' },
	            _react2.default.createElement(_timeLineSegment2.default, { lines: lines, active: step.IsActive === true, topHeight: '4px', bottomHeight: '1fr' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: contentClass },
	            _react2.default.createElement(
	              'div',
	              { className: 'top h2-fz h2-color' },
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: ['auto', '24px'] },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)(step.DictionaryKey)
	                ),
	                step.IsActive && _react2.default.createElement(_chevron2.default, { open: this.state.stepsExpanded, onClick: function onClick() {
	                    _this2.setState({ stepsExpanded: !_this2.state.stepsExpanded });
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'bottom' },
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: ['24px', 'auto'] },
	                !isBodyShopFinishing ? _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Indent }) : null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  !isBodyShopFinishing ? _react2.default.createElement(
	                    'time',
	                    null,
	                    (0, _time.getWeekDay)(step.Date),
	                    ', ',
	                    (0, _time.renderFullDate)(step.Date)
	                  ) : null,
	                  step.AdditionalText && _react2.default.createElement(
	                    'span',
	                    null,
	                    step.AdditionalText
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	    // step active
	
	  }, {
	    key: 'renderStep',
	    value: function renderStep(step, index) {
	      var _this3 = this;
	
	      var contentClass = 'content';
	      if (!step.IsActive) contentClass += ' dimmed';
	
	      var lines = [{
	        LineTypeBefore: LINE_TYPES.DoubleDashed,
	        LineDotType: step.IsCompleted ? POINT_TYPES.Ok_Green : POINT_TYPES.Dot_Gray,
	        LineTypeAfter: LINE_TYPES.DoubleDashed
	      }];
	
	      if (!this.state.stepsExpanded && step.IsCompleted && !step.IsActive) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'item-' + index, className: 'timeline-step' },
	        _react2.default.createElement(
	          'div',
	          { className: 'lines' },
	          _react2.default.createElement(_timeLineSegment2.default, { lines: lines, active: step.IsActive === true, topHeight: '4px', bottomHeight: '1fr' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: contentClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'top h2-fz h2-color' },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: ['auto', '24px'] },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)(step.DictionaryKey)
	              ),
	              step.IsActive && _react2.default.createElement(_chevron2.default, { isOpenUp: this.state.stepsExpanded, open: this.state.stepsExpanded, onClick: function onClick() {
	                  _this3.setState({ stepsExpanded: !_this3.state.stepsExpanded });
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bottom' },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: ['24px', 'auto'] },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Indent }),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'time',
	                  null,
	                  (0, _time.getWeekDay)(step.Date),
	                  ', ',
	                  (0, _time.renderFullDate)(step.Date)
	                ),
	                step.AdditionalText && _react2.default.createElement(
	                  'span',
	                  null,
	                  step.AdditionalText
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.timeLine === null) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'steps steps-wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: this.state.stepsExpanded ? 'steps--show' : '' },
	          this.props.timeLine.UnfinishedProcessSteps.map(this.renderUnfinishedProcessStep),
	          this.props.timeLine.Steps.map(this.renderStep)
	        )
	      );
	    }
	  }]);
	
	  return StepsArea;
	}(_react.Component);
	
	exports.default = StepsArea;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1361);
	
	var _overview = __webpack_require__(225);
	
	var _settings = __webpack_require__(51);
	
	var _carownerportal = __webpack_require__(192);
	
	var _helpers = __webpack_require__(2);
	
	var _stepsArea = __webpack_require__(811);
	
	var _stepsArea2 = _interopRequireDefault(_stepsArea);
	
	var _notificationsArea = __webpack_require__(810);
	
	var _notificationsArea2 = _interopRequireDefault(_notificationsArea);
	
	var _RenderFontURL = __webpack_require__(446);
	
	var _RenderFontURL2 = _interopRequireDefault(_RenderFontURL);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	// Actions
	
	// import { CarOwnerPortalIcons } from '../../shared/elements/icons'
	
	// Components
	
	
	// Elements
	
	
	// import Icon from '../../shared/elements/icon'
	
	var REFRESH_INTERVAL = 60000;
	
	var CarOwnerPortal = function (_Component) {
	  _inherits(CarOwnerPortal, _Component);
	
	  function CarOwnerPortal(props) {
	    _classCallCheck(this, CarOwnerPortal);
	
	    var _this = _possibleConstructorReturn(this, (CarOwnerPortal.__proto__ || Object.getPrototypeOf(CarOwnerPortal)).call(this, props));
	
	    _this.getDataInterval = null;
	    _this.state = {
	      isLoading: true,
	      styles: {
	        FontType: 1,
	        WebSafeFont: 'Verdana',
	        FontURL: '',
	        FontFamily: 'unset',
	        BrandColor: '#000000',
	        BrandColorSecondary: '#000000',
	        PrimaryBackgroundColor: '#000000',
	        ColoredBackground: '#000000',
	        H1Size: 20,
	        H1Color: '#000000',
	        H2Size: 18,
	        H2Color: '#000000',
	        BodySize: 14,
	        BodyColor: '#000000',
	        NavigationSize: 0,
	        NavigationColor: '#000000',
	        LinkSize: 14,
	        LinkColor: '#000000',
	        ButtonTextSize: 14,
	        ButtonTextColor: '#000000',
	        ButtonStrokeColor: '#000000',
	        ButtonFillColor: '#000000',
	        HoverStrokeColor: '#000000',
	        HoverFillColor: '#000000',
	        CheckboxColor: '#000000',
	        CheckboxActiveColor: '#000000'
	      },
	      orderId: null,
	      timeLine: null,
	      notifications: [],
	      notificationSettings: {
	        AllowedEmail: null,
	        AllowedSMS: null
	      },
	      logo: '',
	      tokenInfo: {
	        CarOwnerName: '',
	        CarOwnerLastName: '',
	        OrderId: '',
	        AcceptedTheTerm: false,
	        PrivacyPolicyUrl: null,
	        WelcomeText: null
	      },
	      showPopup: false,
	      modalMode: 1,
	      acceptTerm: false
	    };
	    _this.handleSubmitFrm = _this.handleSubmitFrm.bind(_this);
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.renderFooter = _this.renderFooter.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	    _this.onClickNotificationTypeAllowed = _this.onClickNotificationTypeAllowed.bind(_this);
	    _this.getTimeLineStatus = _this.getTimeLineStatus.bind(_this);
	    _this.getNotifications = _this.getNotifications.bind(_this);
	    _this.onMarkNotificationsRead = _this.onMarkNotificationsRead.bind(_this);
	    _this.getData = _this.getData.bind(_this);
	
	    if (!props.params.token) {
	      console.log(!props.params.token);
	      props.router.push('/');
	    }
	    return _this;
	  }
	
	  _createClass(CarOwnerPortal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.tokenLogin(this.props.params.token).then(function (res) {
	        _this2.setState({
	          tokenInfo: res.data,
	          orderId: res.data.OrderId,
	          showPopup: !res.data.AcceptedTheTerm,
	          notificationSettings: {
	            AllowedEmail: res.data.AllowedEmail, // Allowed... = if car owner has allowed the notification type
	            AllowedSMS: res.data.AllowedSMS
	          } }, function () {
	          _this2.getData();
	          if (_this2.getDataInterval) clearInterval(_this2.getDataInterval);
	          _this2.getDataInterval = setInterval(_this2.getData, REFRESH_INTERVAL);
	        });
	        _this2.getStyle();
	        _this2.props.getLogoPortalStyling().then(function (res) {
	          _this2.setState({ logo: res.data.FileURL });
	        });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.getDataInterval) clearInterval(this.getDataInterval);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      this.getTimeLineStatus();
	      this.getNotifications();
	    }
	  }, {
	    key: 'getTimeLineStatus',
	    value: function getTimeLineStatus() {
	      var _this3 = this;
	
	      var orderId = this.state.orderId;
	      if (orderId) {
	        this.props.getTimeLineStatus(orderId).then(function (res) {
	          _this3.setState({ timeLine: res.data });
	        });
	      }
	    }
	  }, {
	    key: 'getNotifications',
	    value: function getNotifications() {
	      var _this4 = this;
	
	      var orderId = this.state.orderId;
	      this.props.getDataByOrderId(orderId).then(function (res) {
	        // Store separately the ids of the unread messages
	        _this4.setState({
	          notifications: res.data
	        });
	      });
	    }
	  }, {
	    key: 'onClickNotificationTypeAllowed',
	    value: function onClickNotificationTypeAllowed(e) {
	      var _this5 = this;
	
	      e.persist();
	      this.props.updateAllowNotifications(_defineProperty({}, e.target.name, e.target.checked)).then(function (res) {
	        _this5.setState({ notificationSettings: _extends({}, _this5.state.notificationSettings, res.data) });
	      });
	    }
	  }, {
	    key: 'onMarkNotificationsRead',
	    value: function onMarkNotificationsRead(ids) {
	      var _this6 = this;
	
	      if (!ids || ids.length === 0) return;
	      ids.map(function (x) {
	        var request = {
	          NotificationId: x,
	          IsRead: true
	        };
	        _this6.props.updateNotificationRead(request);
	      });
	    }
	  }, {
	    key: 'handleSubmitFrm',
	    value: function handleSubmitFrm(val) {
	      var _this7 = this;
	
	      this.props.acceptTOS({
	        IsAccept: val
	      }).then(function (res) {
	        if (val) {
	          _this7.handleClose();
	        } else {
	          _this7.setState({ modalMode: 0 });
	        }
	      });
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      this.setState({ showPopup: false });
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var _this8 = this;
	
	      this.props.getStylePortalWeb().then(function (res) {
	        _this8.setState({ styles: res.data, isLoading: false });
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this9 = this;
	
	      if (this.state.modalMode) {
	        var paragraphs = this.state.tokenInfo.WelcomeText ? this.state.tokenInfo.WelcomeText.split('\n') : [];
	        return _react2.default.createElement(
	          'div',
	          { className: 'modal-main__content__main' },
	          paragraphs.map(function (x, i) {
	            return _react2.default.createElement(
	              'p',
	              { key: i },
	              x
	            );
	          }),
	          this.state.tokenInfo.PrivacyPolicyUrl && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: this.state.tokenInfo.PrivacyPolicyUrl },
	              (0, _helpers.translation)(18247)
	            )
	          ),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)(18248), labelAlignment: 'r', onChange: function onChange() {
	              return _this9.setState(function (prevProps) {
	                return _extends({}, prevProps, { acceptTerm: !prevProps.acceptTerm });
	              });
	            }, checked: this.state.acceptTerm })
	        );
	      } else {
	        // Declined
	        return _react2.default.createElement(
	          'div',
	          { className: 'modal-main__content__main' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            (0, _helpers.translation)(18249)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      var _this10 = this;
	
	      if (this.state.modalMode) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'modal-main__content__footer' },
	          _react2.default.createElement(_button2.default, { labelText: (0, _helpers.translation)(18250), disabled: !this.state.acceptTerm, onClick: function onClick() {
	              return _this10.handleSubmitFrm(true);
	            } }),
	          _react2.default.createElement(
	            'a',
	            { href: '#', onClick: function onClick() {
	                return _this10.handleSubmitFrm(false);
	              } },
	            (0, _helpers.translation)(18251)
	          )
	        );
	      } else {
	        return _react2.default.createElement('div', { className: 'modal-main__content__footer' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      // Don't show page before the styling settings are loaded.
	      if (this.state.isLoading) return null; // Show spinner maybe?
	
	      var bottomBarProps = {
	        disabled: true,
	        actionLabelText: 'buttonText',
	        onActionClick: this.handleClick
	      };
	
	      var fontFamily = 'unset';
	      if (this.state.styles.FontType === 1 && this.state.styles.WebSafeFont) {
	        // Font selected from list
	        fontFamily = '"' + this.state.styles.WebSafeFont + '"';
	      } else if (this.state.styles.FontType === 2 && this.state.styles.FontURL && this.state.styles.FontFamily) {
	        fontFamily = '"' + this.state.styles.FontFamily + '"';
	      }
	
	      var renderStyle = function renderStyle() {
	        return _react2.default.createElement(
	          'style',
	          null,
	          '\n            :root{\n              --webSafeFont: ' + _this11.state.styles.WebSafeFont + ';\n              --fontURL: ' + _this11.state.styles.FontURL + ';\n              --fontFamily: ' + fontFamily + ';\n              --brandColor: ' + _this11.state.styles.BrandColor + ';\n              --brandColorSecondary: ' + _this11.state.styles.BrandColorSecondary + ';\n              --primaryBackgroundColor: ' + _this11.state.styles.PrimaryBackgroundColor + ';\n              --coloredBackground: ' + _this11.state.styles.ColoredBackground + ';\n              --h1Size: ' + _this11.state.styles.H1Size + ';\n              --h1Color: ' + _this11.state.styles.H1Color + ';\n              --h2Size: ' + _this11.state.styles.H2Size + ';\n              --h2Color: ' + _this11.state.styles.H2Color + ';\n              --bodySize: ' + _this11.state.styles.BodySize + ';\n              --bodyColor: ' + _this11.state.styles.BodyColor + ';\n              --navigationSize: ' + _this11.state.styles.NavigationSize + ';\n              --navigationColor: ' + _this11.state.styles.NavigationColor + ';\n              --linkSize: ' + _this11.state.styles.LinkSize + ';\n              --linkColor: ' + _this11.state.styles.LinkColor + ';\n              --buttonTextSize: ' + _this11.state.styles.ButtonTextSize + ';\n              --buttonTextColor: ' + _this11.state.styles.ButtonTextColor + ';\n              --buttonStrokeColor: ' + _this11.state.styles.ButtonStrokeColor + ';\n              --buttonFillColor: ' + _this11.state.styles.ButtonFillColor + ';\n              --hoverStrokeColor: ' + _this11.state.styles.HoverStrokeColor + ';\n              --hoverFillColor: ' + _this11.state.styles.HoverFillColor + ';\n              --checkboxColor: ' + _this11.state.styles.CheckboxColor + ';\n              --checkboxActiveColor: ' + _this11.state.styles.CheckboxActiveColor + ';\n            }\n          .ff-wrap{\n            font-family: ' + fontFamily + ';\n          }\n          .color-wrap{\n            color: ' + _this11.state.styles.BodyColor + ';\n          }\n          .branch-color{\n            color: ' + _this11.state.styles.BrandColor + ';\n          }\n          .branch-bg{\n            background: ' + _this11.state.styles.BrandColor + ';\n          }\n          .branch-border{\n            border-color: ' + _this11.state.styles.BrandColor + ';\n          }\n          .fz-wrap{\n            font-size: ' + _this11.state.styles.BodySize + ';\n          }\n          .h1-color{\n            color: ' + _this11.state.styles.H1Color + ';\n          }\n          .h1-fz{\n            font-size: ' + _this11.state.styles.H1Size + ';\n          }\n          .h2-color{\n            color: ' + _this11.state.styles.H2Color + ';\n            font-weight: 700;\n          }\n          .h2-fz{\n            font-size: ' + _this11.state.styles.H2Size + ';\n          }\n          .nav-color{\n            color: ' + _this11.state.styles.NavigationColor + ';\n          }\n          .nav-fz{\n            font-size: ' + _this11.state.styles.NavigationSize + ';\n          }\n          .link-color{\n            color: ' + _this11.state.styles.LinkColor + ';\n          }\n          .link-fz{\n            font-size: ' + _this11.state.styles.LinkSize + ';\n          }\n        '
	        );
	      };
	
	      var renderUserInfoBox = function renderUserInfoBox() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'carownerportal__userinfo' },
	          _react2.default.createElement('div', { className: 'carownerportal__notification' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'carownerportal__username' },
	            _react2.default.createElement(
	              'div',
	              { className: 'carownerportal__username__avatar branch-bg branch-border' },
	              _react2.default.createElement('i', { className: 'fa fa-user' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'carownerportal__username__information color-wrap' },
	              _react2.default.createElement(
	                'div',
	                { className: 'carownerportal__username__information--top' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _this11.state.tokenInfo.CarOwnerName,
	                  ' ',
	                  _this11.state.tokenInfo.CarOwnerLastName
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'carownerportal__username__information--bottom color-wrap' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _this11.state.tokenInfo.RegNumber
	                ),
	                '\xA0\xA0|\xA0\xA0',
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)(15102),
	                  ': ',
	                  _this11.state.tokenInfo.OrderId
	                )
	              )
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'carownerportal carownerportal-wrap ff-wrap' },
	        this.state.styles.FontType === 2 && this.state.styles.FontURL !== '' && _react2.default.createElement(_RenderFontURL2.default, { url: this.state.styles.FontURL }),
	        renderStyle(),
	        _react2.default.createElement(
	          'header',
	          { className: 'carownerportal__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'carownerportal__logo' },
	            _react2.default.createElement('img', { src: this.state.logo, alt: 'Logo' })
	          ),
	          renderUserInfoBox()
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'carownerportal__content' },
	          _react2.default.createElement(_stepsArea2.default, { timeLine: this.state.timeLine }),
	          _react2.default.createElement(_notificationsArea2.default, { notifications: this.state.notifications, onChangeCbx: this.onClickNotificationTypeAllowed, notificationSettings: this.state.notificationSettings }),
	          _react2.default.createElement(
	            _Modal2.default,
	            { clickOutsideClose: false, onClose: this.handleClose, hideX: true, show: this.state.showPopup, header: false, bottomBarProps: bottomBarProps, isLoading: false },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-main modal-main-wrap' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-main__header' },
	                _react2.default.createElement('img', { src: this.state.logo, alt: 'Logo', style: { height: 40 } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-main__content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'modal-main__content__title' },
	                  this.state.modalMode ? (0, _helpers.translation)(18252) : (0, _helpers.translation)(18253)
	                ),
	                this.renderContent(),
	                this.renderFooter()
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CarOwnerPortal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getDeliveryStatus: _overview.getDeliveryStatus,
	  getDataByOrderId: _settings.getDataByOrderId,
	  getStylePortalWeb: _settings.getStylePortalWeb,
	  getLogoPortalStyling: _settings.getLogoPortalStyling,
	  tokenLogin: _carownerportal.tokenLogin,
	  acceptTOS: _carownerportal.acceptTOS,
	  getTimeLineStatus: _carownerportal.getTimeLineStatus,
	  updateNotificationRead: _settings.updateNotificationRead,
	  updateAllowNotifications: _settings.updateAllowNotifications
	})(CarOwnerPortal);

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _time = __webpack_require__(17);
	
	var _HoverPopup = __webpack_require__(293);
	
	var _HoverPopup2 = _interopRequireDefault(_HoverPopup);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CarOrder = function (_Component) {
	  _inherits(CarOrder, _Component);
	
	  function CarOrder(props) {
	    _classCallCheck(this, CarOrder);
	
	    var _this = _possibleConstructorReturn(this, (CarOrder.__proto__ || Object.getPrototypeOf(CarOrder)).call(this, props));
	
	    _this.state = {};
	    _this.getVerticalScrollOffset = _this.getVerticalScrollOffset.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarOrder, [{
	    key: 'getVerticalScrollOffset',
	    value: function getVerticalScrollOffset() {
	      var result = 0;
	      var scrollContainer = document.getElementById('app');
	      if (scrollContainer !== undefined) {
	        result = scrollContainer.scrollTop;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var carrentalClass = 'carrental-order drag-handle-class';
	      if (!this.props.order.IsClickable) carrentalClass += ' non-clickable-order';
	      if (this.props.order.OrderId === -1 || !this.props.order.IsClickable) {
	        carrentalClass += ' gu-nonselectable notavailable';
	      } else if (this.props.order.IsCompleted) {
	        carrentalClass += ' completed';
	      }
	      var style = { left: '0%', right: '90%' };
	      if (this.props.order.FromPercent !== undefined && this.props.order.ToPercent !== undefined) {
	        style = { left: this.props.order.FromPercent + '%', right: 100 - this.props.order.ToPercent + '%' };
	      }
	      var contentStyle = {};
	      if (this.props.order.Index !== null && this.props.order.Index > 0) {
	        var top = 48 * this.props.order.Index;
	        top += this.props.order.Index;
	        carrentalClass += ' indexmoved';
	        style.top = top + 'px';
	        style.zIndex = this.props.order.Index;
	      }
	      var contentWidth = 100;
	      if (this.props.order.BufferBefore !== null) {
	        contentWidth -= this.props.order.BufferBefore.Percent;
	      }
	      if (this.props.order.BufferAfter !== null) {
	        contentWidth -= this.props.order.BufferAfter.Percent;
	      }
	      contentStyle.width = contentWidth + '%';
	      var renderContentMarkings = function renderContentMarkings(item, index) {
	        var style = { left: '0%', right: '90%' };
	        style = { left: item.FromPercent + '%', right: 100 - item.ToPercent + '%' };
	        var contentMarkingClass = 'contentMarking';
	        switch (item.Type) {
	          case 1:
	            contentMarkingClass += ' yellow';
	            break;
	          case 2:
	            contentMarkingClass += ' red';
	            break;
	        }
	        return _react2.default.createElement('div', { key: index, className: contentMarkingClass, style: style });
	      };
	      var renderBufferBefore = function renderBufferBefore() {
	        if (_this2.props.order.BufferBefore === null) return null;
	        var bufferStyle = { width: _this2.props.order.BufferBefore.Percent + '%' };
	        return _react2.default.createElement(
	          'div',
	          { className: 'bufferMargin left', style: bufferStyle },
	          _this2.props.order.BufferBefore.ContentMarkings !== undefined && _this2.props.order.BufferBefore.ContentMarkings.map(renderContentMarkings)
	        );
	      };
	      var renderBufferAfter = function renderBufferAfter() {
	        if (_this2.props.order.BufferAfter === null) return null;
	        var bufferStyle = { width: _this2.props.order.BufferAfter.Percent + '%' };
	        return _react2.default.createElement(
	          'div',
	          { className: 'bufferMargin right', style: bufferStyle },
	          _this2.props.order.BufferAfter.ContentMarkings !== undefined && _this2.props.order.BufferAfter.ContentMarkings.map(renderContentMarkings)
	        );
	      };
	      var renderTime = function renderTime(time, hasExtraTime) {
	        if (hasExtraTime === true) {
	          return (0, _time.renderFullDate)(time);
	        } else {
	          return (0, _time.renderTimeOnly)(time);
	        }
	      };
	      var orderOnClick = function orderOnClick() {
	        if (!_this2.props.order.IsClickable) return;
	        if (_this2.props.order.OrderId !== -1) {
	          _this2.props.router.push('/orders/' + _this2.props.order.OrderId);
	        }
	      };
	
	      var hoverLines = [];
	      if (this.props.order.RegNr !== null && this.props.order.RegNr !== '') {
	        hoverLines.push(_react2.default.createElement(
	          'p',
	          { key: this.props.order.OrderId + '_' + Math.random() + '_' + Math.random() },
	          this.props.order.RegNr
	        ));
	      }
	      if (this.props.order.BrandName != null && this.props.order.BrandName !== '') {
	        hoverLines.push(_react2.default.createElement(
	          'p',
	          { key: this.props.order.OrderId + '_' + Math.random() + '_' + Math.random() },
	          (0, _helpers.translation)(this.props.order.BrandName)
	        ));
	      }
	      if (this.props.order.Model !== null && this.props.order.Model !== '') {
	        hoverLines.push(_react2.default.createElement(
	          'p',
	          { key: this.props.order.OrderId + '_' + Math.random() + '_' + Math.random() },
	          this.props.order.Model
	        ));
	      }
	      hoverLines.push(_react2.default.createElement(
	        'p',
	        { key: this.props.order.OrderId + '_' + Math.random() + '_' + Math.random() },
	        renderTime(this.props.order.FromDate, true)
	      ));
	      hoverLines.push(_react2.default.createElement(
	        'p',
	        { key: this.props.order.OrderId + '_' + Math.random() + '_' + Math.random() },
	        renderTime(this.props.order.ToDate, true)
	      ));
	      var useClick = false;
	      var useHover = true;
	      var customHoverStyle = {};
	
	      return _react2.default.createElement(
	        'div',
	        { className: carrentalClass, style: style, onClick: orderOnClick.bind(this), 'data-id': this.props.order.OrderId, 'data-fromdate': this.props.order.FromDate, 'data-periodid': this.props.order.CarRentalPeriodId },
	        renderBufferBefore(),
	        _react2.default.createElement(
	          'div',
	          { className: 'mainOrder' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content', style: contentStyle },
	            _react2.default.createElement(
	              _HoverPopup2.default,
	              { UseClick: useClick, customStyle: customHoverStyle, UseHover: useHover, orderId: this.props.order.OrderId, PopupContent: hoverLines, getVerticalScrollOffset: this.getVerticalScrollOffset },
	              _react2.default.createElement(
	                'div',
	                { className: 'top' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.order.Text
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'bottom' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'left' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    renderTime(this.props.order.FromDate, this.props.order.HasTimeBefore)
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'right' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    renderTime(this.props.order.ToDate, this.props.order.HasTimeAfter)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'markings' },
	                this.props.order.ContentMarkings !== undefined && this.props.order.ContentMarkings.map(renderContentMarkings)
	              )
	            )
	          )
	        ),
	        renderBufferAfter()
	      );
	    }
	  }]);
	
	  return CarOrder;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(CarOrder);

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _auth = __webpack_require__(8);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1364);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var CarRow = function (_Component) {
	  _inherits(CarRow, _Component);
	
	  function CarRow(props) {
	    _classCallCheck(this, CarRow);
	
	    var _this = _possibleConstructorReturn(this, (CarRow.__proto__ || Object.getPrototypeOf(CarRow)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CarRow, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var carRowStyle = {
	        height: '48px'
	      };
	      if (this.props.maxConflicts !== undefined && this.props.maxConflicts > 0) {
	        var height = (this.props.maxConflicts + 1) * 48;
	        height += this.props.maxConflicts;
	        carRowStyle.height = height + 'px';
	      }
	      var dayStyle = {};
	      if (this.props.days !== undefined && this.props.days.length > 0) {
	        dayStyle = {
	          // Somehow Edge is broken when using 100%... broken as always.
	          width: 'calc(99.97% / ' + this.props.days.length + ')'
	        };
	      }
	      var renderDays = function renderDays(item, dayIndex) {
	        var dayOnClick = function dayOnClick(clickedDate) {
	          if ((0, _auth.hasSubscriptionPermission)(_this2.props.auth, 10, 2)) {
	            _this2.props.setCreateOrderValues(true, _this2.props.car.Id, clickedDate);
	          }
	        };
	
	        return _react2.default.createElement('div', { key: _this2.props.Id + '_' + dayIndex, className: 'dailydiv gu-nonselectable', style: dayStyle, onClick: dayOnClick.bind(_this2, item.Date), 'data-date': item.Date });
	      };
	      var renderTimeIndexes = function renderTimeIndexes(item) {
	        var top = item.Index * 48;
	        top += item.Index;
	        var indexStyle = {
	          top: top + 'px'
	          // let sideText = 'left'
	          // let markingColorText = 'gray'
	        };var imageString = '';
	        switch (item.SideType) {
	          case 0:
	            // sideText = 'left'
	            imageString = item.Type === 0 ? _icons.ElementIcons.Arrow_Left_Gray : _icons.ElementIcons.Arrow_Left_Lightgray;
	            break;
	          case 1:
	            // sideText = 'right'
	            imageString = item.Type === 0 ? _icons.ElementIcons.Arrow_Right_Gray : _icons.ElementIcons.Arrow_Right_Lightgray;
	            break;
	        }
	        // switch (item.Type) {
	        //   case 0:
	        //     markingColorText = 'gray'
	        //     break
	        //   case 1:
	        //     markingColorText = 'lightgray'
	        //     break
	        // }
	        // let imageString = '/images/svgs/ordrer/arrow-' + sideText + '-' + markingColorText + '.svg'
	        return _react2.default.createElement(
	          'div',
	          { key: Math.random(), className: 'timearrow' },
	          _react2.default.createElement(_icon2.default, { icon: imageString, style: indexStyle, className: 'arrow' })
	        );
	      };
	
	      var departmentName = this.props.car.DepartmentName;
	      var departmentNameText = '';
	      if (departmentName) {
	        departmentNameText = this.props.car.CarNumber ? ', ' + departmentName : departmentName;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'car-row', style: carRowStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin left' },
	          _react2.default.createElement(
	            'div',
	            { className: 'details' },
	            _react2.default.createElement(
	              'div',
	              { className: 'number' },
	              _react2.default.createElement(
	                'span',
	                { className: 'text-ellipsis' },
	                this.props.car.CarNumber + departmentNameText
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'identification' },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.props.car.Identity
	              )
	            )
	          ),
	          this.props.car.TimeBeforeIndexes.map(renderTimeIndexes)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'car-row-content', 'data-id': this.props.car.Id },
	          this.props.days.map(renderDays),
	          this.props.children
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'margin right' },
	          this.props.car.TimeAfterIndexes.map(renderTimeIndexes)
	        )
	      );
	    }
	  }]);
	
	  return CarRow;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(CarRow);

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Dragula = __webpack_require__(290);
	
	var _Dragula2 = _interopRequireDefault(_Dragula);
	
	var _CarRow = __webpack_require__(814);
	
	var _CarRow2 = _interopRequireDefault(_CarRow);
	
	var _CarOrder = __webpack_require__(813);
	
	var _CarOrder2 = _interopRequireDefault(_CarOrder);
	
	var _backdrop = __webpack_require__(29);
	
	var _NewOrdersModal = __webpack_require__(238);
	
	var _NewOrdersModal2 = _interopRequireDefault(_NewOrdersModal);
	
	var _StickyContainer = __webpack_require__(1060);
	
	var _StickyContainer2 = _interopRequireDefault(_StickyContainer);
	
	__webpack_require__(1365);
	
	var _helpers = __webpack_require__(2);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _carrental = __webpack_require__(223);
	
	var _auth = __webpack_require__(8);
	
	var _common = __webpack_require__(25);
	
	var _constants = __webpack_require__(5);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _nextButton = __webpack_require__(1072);
	
	var _nextButton2 = _interopRequireDefault(_nextButton);
	
	var _previousButton = __webpack_require__(1076);
	
	var _previousButton2 = _interopRequireDefault(_previousButton);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// contants
	
	
	// Elements
	// import Null from '../../shared/elements/null'
	// import TabBar from '../../shared/elements/tabBar'
	
	
	var CarRentalOverview = function (_Component) {
	  _inherits(CarRentalOverview, _Component);
	
	  function CarRentalOverview(props) {
	    _classCallCheck(this, CarRentalOverview);
	
	    var _this = _possibleConstructorReturn(this, (CarRentalOverview.__proto__ || Object.getPrototypeOf(CarRentalOverview)).call(this, props));
	
	    _this.state = {
	      dimensions: {
	        width: 0,
	        height: 0
	      },
	      createOrderPopup: {
	        show: false,
	        defaultCreateOrderInfo: undefined
	      },
	      requestData: {
	        CalendarView: 0,
	        CalendarDirection: null,
	        WeekType: 0,
	        CurrentViewRange: null,
	        OverviewSorting: 1,
	        AvailableDaysNr: 0,
	        CarRentalType: null,
	        CarRentalCategory: null
	      },
	      CalendarData: {
	        CalendarText: '',
	        CalendarTextDictionaryKey: null
	      },
	      Days: [{
	        Text: '',
	        Active: false,
	        IsClosed: false
	      }, {
	        Text: '',
	        Active: false,
	        IsClosed: false
	      }, {
	        Text: '',
	        Active: false,
	        IsClosed: false
	      }, {
	        Text: '',
	        Active: false,
	        IsClosed: false
	      }, {
	        Text: '',
	        Active: false,
	        IsClosed: false
	      }, {
	        Text: '',
	        Active: false,
	        IsClosed: true
	      }, {
	        Text: '',
	        Active: false,
	        IsClosed: true
	      }],
	      Cars: [],
	      carTypes: [],
	      carCategories: []
	    };
	    _this.getCarRentalOverview = _this.getCarRentalOverview.bind(_this);
	    _this.setupDragula = _this.setupDragula.bind(_this);
	    _this.renderHeaderItems = _this.renderHeaderItems.bind(_this);
	    _this.dimensionShow = _this.dimensionShow.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.initiateMove = _this.initiateMove.bind(_this);
	    _this.setNewOverview = _this.setNewOverview.bind(_this);
	    _this.SetCreateNewOrderValues = _this.SetCreateNewOrderValues.bind(_this);
	    _this.renderAvailableDaysNr = _this.renderAvailableDaysNr.bind(_this);
	    _this.setLocalStorage = _this.setLocalStorage.bind(_this);
	    _this.getCarClasses = _this.getCarClasses.bind(_this);
	    _this.getCarTypes = _this.getCarTypes.bind(_this);
	
	    _this.dragula = null;
	    _this.appElement = document.getElementById('app');
	    // this.dragXStart = null
	    // this.dragXDelta = null
	    _this.currentMirrorElement = null;
	    _this.currentContainer = null;
	    // this.observer = null
	
	    // socket
	    _this.updateFromOrderSocket = _this.updateFromOrderSocket.bind(_this);
	    return _this;
	  }
	  // all the commented code is for later use, if we should use the horizontal drag
	
	
	  _createClass(CarRentalOverview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.addEventListener('resize', this.updateDimensions);
	      _events2.default.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this);
	      this.updateDimensions();
	      this.getCarTypes();
	      this.getCarClasses();
	      var data = {
	        CalendarView: 0,
	        WeekType: 0,
	        OverviewSorting: 1,
	        AvailableDaysNr: 0,
	        CarRentalType: null,
	        CarRentalCategory: null
	      };
	      try {
	        var storageData = JSON.parse(window.localStorage.getItem('carRentalOverviewSettings'));
	        if (storageData !== undefined && storageData !== null) {
	          data.CalendarView = parseInt(storageData.CalendarView);
	          data.WeekType = parseInt(storageData.WeekType);
	          data.OverviewSorting = parseInt(storageData.OverviewSorting);
	          data.AvailableDaysNr = parseInt(storageData.AvailableDaysNr);
	          data.CarRentalType = storageData.CarRentalType ? parseInt(storageData.CarRentalType) : null;
	          data.CarRentalCategory = storageData.CarRentalCategory ? parseInt(storageData.CarRentalCategory) : null;
	        }
	      } catch (err) {
	        console.error('Could not get CarRentalOverview information from local storage');
	      }
	
	      this.setState({
	        requestData: _extends({}, this.state.requestData, {
	          OverviewSorting: data.OverviewSorting,
	          CalendarView: data.CalendarView,
	          AvailableDaysNr: data.AvailableDaysNr,
	          WeekType: data.WeekType,
	          CarRentalType: data.CarRentalType,
	          CarRentalCategory: data.CarRentalCategory
	        })
	      }, function () {
	        return _this2.getCarRentalOverview();
	      });
	
	      // Check if need to open capacity overview
	      var location = this.props.router.location;
	      if (location.query.destination && location.query.destination === 'capacityoverview') {
	        this.props.openOverlay('OrderCapacityOverview');
	        this.props.router.replace(_extends({}, location, { query: {} })); // Reset query to only trigger once.
	      }
	
	      // this.observer = new MutationObserver((mutations) => {
	      //   mutations.forEach((mutation) => {
	      //     if (this.currentMirrorElement !== null) {
	      //       let left = this.currentMirrorElement.style.left
	      //       console.log('currentMirrorElement left', left)
	      //     } else {
	      //       console.log('style changed observed but no currentMirrorElement!!!')
	      //     }
	
	      //   })
	      // })
	
	      // document.addEventListener('mousedown', (e) => {
	      //   console.log('mouse down', e, e.screenX)
	      //   this.dragXStart = e.screenX
	      // })
	      // document.addEventListener('mouseup', (e) => {
	      //   this.dragXDelta = e.screenX - this.dragXStart
	      //   console.log('mouse up', e, e.screenX, 'delta', this.dragXDelta)
	
	      // })
	
	      // console.log('dragula', this.dragula)
	      // document.addEventListener('mou')
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	      _events2.default.removeListener('ORDER_SOCKET', this.updateFromOrderSocket);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'setupDragula',
	    value: function setupDragula() {
	      var _this3 = this;
	
	      var containerClass = 'car-row-content';
	      var containerDomCollection = _reactDom2.default.findDOMNode(this).getElementsByClassName(containerClass);
	      var containers = [];
	      for (var i = 0; i < containerDomCollection.length; i++) {
	        containers.push(containerDomCollection[i]);
	      }
	
	      var options = {
	        direction: 'vertical',
	        revertOnSpill: true,
	        accepts: function accepts(el, target, source, sibling) {
	          if (target.className.includes(containerClass)) {
	            return true;
	          }
	          return true;
	        }
	        // to handle mobile scrolling when dragging elements
	      };var moveList = document.querySelectorAll('div.drag-handle-class');
	      if (moveList) {
	        moveList.forEach(function (move) {
	          move.addEventListener('touchmove', function (event) {
	            return event.preventDefault();
	          });
	        });
	      }
	      if (this.dragula !== null) {
	        this.dragula.destroy();
	      }
	      this.dragula = new _Dragula2.default(containers, options).on('over', function (el, container) {
	        var mirrors = document.getElementsByClassName('gu-mirror');
	        if (mirrors.length > 0) {
	          var mirror = mirrors[0];
	          _this3.currentMirrorElement = mirror;
	          _this3.currentContainer = container;
	        }
	      }).on('drop', function (el, target, source, sibling) {
	        if (el.style.display !== 'block') el.style.display = 'block';
	        _this3.initiateMove(el, target, source, sibling);
	        _this3.dragula.cancel();
	      });
	    }
	  }, {
	    key: 'initiateMove',
	    value: function initiateMove(el, target, source, sibling) {
	      var _this4 = this;
	
	      var sourceId = parseInt(source.dataset.id);
	      var targetId = parseInt(target.dataset.id);
	      if (sourceId === targetId) return;
	      var request = {
	        OverviewRequest: this.state.requestData,
	        CarId: targetId,
	        FromCarId: el.dataset.periodid && el.dataset.periodid !== '0' ? undefined : sourceId,
	        OrderId: el.dataset.id,
	        FromDate: el.dataset.fromdate,
	        CarRentalPeriodId: el.dataset.periodid
	      };
	
	      this.props.MoveOrderCarRental(request).then(function (res) {
	        _this4.setNewOverview(res.data);
	        // window.toastr.success(translation('1909'), translation('13424'))
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('12339'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'setNewOverview',
	    value: function setNewOverview(data) {
	      var _this5 = this;
	
	      this.setState({
	        requestData: _extends({}, this.state.requestData, {
	          CalendarDirection: 0,
	          CurrentViewRange: data.CurrentViewRange
	        }),
	        CalendarData: {
	          CalendarText: data.CalendarText,
	          CalendarTextDictionaryKey: data.CalendarTextDictionaryKey
	        },
	        Days: data.Days,
	        Cars: data.Cars
	      }, function () {
	        _this5.setupDragula(); // has to be run after the order elements has been rendered
	      });
	    }
	  }, {
	    key: 'getCarTypes',
	    value: function getCarTypes() {
	      var _this6 = this;
	
	      this.props.GetCarTypes().then(function (res) {
	        _this6.setState({
	          carTypes: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getCarClasses',
	    value: function getCarClasses() {
	      var _this7 = this;
	
	      this.props.GetCarClasses().then(function (res) {
	        _this7.setState({
	          carCategories: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getCarRentalOverview',
	    value: function getCarRentalOverview() {
	      var _this8 = this;
	
	      this.props.GetCarRentalOverview(this.state.requestData).then(function (res) {
	        _this8.setNewOverview(res.data);
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('15160'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'setLocalStorage',
	    value: function setLocalStorage() {
	      var carRentalOverviewSettings = {
	        OverviewSorting: this.state.requestData.OverviewSorting,
	        AvailableDaysNr: this.state.requestData.AvailableDaysNr,
	        CalendarView: this.state.requestData.CalendarView,
	        WeekType: this.state.requestData.WeekType,
	        CarRentalType: this.state.requestData.CarRentalType,
	        CarRentalCategory: this.state.requestData.CarRentalCategory
	      };
	      window.localStorage.setItem('carRentalOverviewSettings', JSON.stringify(carRentalOverviewSettings));
	      this.getCarRentalOverview();
	    }
	  }, {
	    key: 'renderAvailableDaysNr',
	    value: function renderAvailableDaysNr() {
	      var options = [];
	      for (var nr = 0; nr < 16; nr++) {
	        var label = (0, _helpers.translation)(381);
	        if (nr > 0) label = nr + ' ' + (0, _helpers.translation)(nr > 1 ? 503 : 483).toLowerCase();
	        if (nr > 14) label = '> ' + (nr - 1) + ' ' + (0, _helpers.translation)(503).toLowerCase();
	        options.push(_react2.default.createElement(
	          'option',
	          { value: nr },
	          label
	        ));
	      }
	      return options;
	    }
	  }, {
	    key: 'renderHeaderItems',
	    value: function renderHeaderItems() {
	      var _this9 = this;
	
	      // const { carTypes, carCategories } = this.props
	      var _state = this.state,
	          requestData = _state.requestData,
	          carTypes = _state.carTypes,
	          carCategories = _state.carCategories;
	
	
	      var renderMiddleCalendarText = function renderMiddleCalendarText() {
	        var text = '';
	        if (_this9.state.CalendarData.CalendarTextDictionaryKey !== null) {
	          text = (0, _helpers.translation)(_this9.state.CalendarData.CalendarTextDictionaryKey) + ' ';
	        }
	        if (_this9.state.CalendarData.CalendarText !== null) {
	          text += _this9.state.CalendarData.CalendarText;
	        }
	        return _react2.default.createElement(
	          'span',
	          null,
	          text
	        );
	      };
	      var rangeSwitchOnClick = function rangeSwitchOnClick(direction) {
	        _this9.setState({
	          requestData: _extends({}, _this9.state.requestData, {
	            CalendarDirection: direction
	          })
	        }, function () {
	          _this9.getCarRentalOverview();
	        });
	      };
	      var onChange = function onChange(e) {
	        var value = parseInt(e.target.value);
	        if (e.target.name === 'CalendarView') {
	          _this9.setState({
	            requestData: _extends({}, _this9.state.requestData, {
	              CalendarDirection: null,
	              CurrentViewRange: null,
	              CalendarView: value,
	              WeekType: 0
	            })
	          }, _this9.setLocalStorage);
	        } else if (e.target.name === 'OverviewSorting' && value === 0) {
	          _this9.setState({
	            requestData: _extends({}, _this9.state.requestData, _defineProperty({
	              AvailableDaysNr: 0
	            }, e.target.name, value))
	          }, _this9.setLocalStorage);
	        } else {
	          if (e.target.name === 'CarRentalType' || e.target.name === 'CarRentalCategory') {
	            value = value === 0 ? null : value;
	          }
	          var resetCategory = e.target.name === 'CarRentalType' && _this9.state.requestData.CarRentalCategory !== null;
	          _this9.setState({
	            requestData: _extends({}, _this9.state.requestData, _defineProperty({
	              CarRentalCategory: resetCategory ? null : _this9.state.requestData.CarRentalCategory
	            }, e.target.name, value))
	          }, _this9.setLocalStorage);
	        }
	      };
	
	      var renderTypes = function renderTypes(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.Id },
	          val.Name
	        );
	      };
	
	      var renderCategories = function renderCategories(category, key) {
	        var cat = parseInt(category.Id);
	        if (requestData.CarRentalType === null || requestData.CarRentalType === 1 && vanCategories.includes(cat) || requestData.CarRentalType === 2 && passengerCategories.includes(cat)) {
	          return _react2.default.createElement(
	            'option',
	            { key: key, value: cat },
	            category.Name
	          );
	        }
	      };
	      var usedRentLog = this.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.RENTLOG;
	      var vanCategories = [3, 4, 5];
	      var passengerCategories = [1, 2, 4, 5];
	      return _react2.default.createElement(
	        'div',
	        { className: 'carrental__tabs noselect' },
	        _react2.default.createElement(
	          _inline2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'middleActions' },
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _inline2.default,
	                  { spacing: 0 },
	                  _react2.default.createElement(_previousButton2.default, { size: 'm', onClick: rangeSwitchOnClick.bind(this, 1) }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'middle' },
	                    renderMiddleCalendarText()
	                  ),
	                  _react2.default.createElement(_nextButton2.default, { size: 'm', onClick: rangeSwitchOnClick.bind(this, 2) })
	                )
	              ),
	              _react2.default.createElement(
	                _dropDown2.default,
	                { size: 'm', name: 'CalendarView', onChange: onChange, value: requestData.CalendarView },
	                _react2.default.createElement(
	                  'option',
	                  { value: 0 },
	                  (0, _helpers.translation)('250')
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 1 },
	                  (0, _helpers.translation)('15140')
	                )
	              ),
	              requestData.CalendarView === 0 && _react2.default.createElement(
	                _dropDown2.default,
	                { size: 'm', name: 'WeekType', onChange: onChange, value: requestData.WeekType },
	                _react2.default.createElement(
	                  'option',
	                  { value: 0 },
	                  (0, _helpers.translation)('15208')
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 1 },
	                  (0, _helpers.translation)('15141')
	                )
	              ),
	              _react2.default.createElement(
	                _dropDown2.default,
	                { size: 'm', name: 'OverviewSorting', onChange: onChange, value: requestData.OverviewSorting },
	                _react2.default.createElement(
	                  'option',
	                  { value: 0 },
	                  (0, _helpers.translation)(16792)
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 1 },
	                  (0, _helpers.translation)(16809)
	                )
	              ),
	              requestData.OverviewSorting === 1 && _react2.default.createElement(
	                _dropDown2.default,
	                { size: 'm', minWidth: '120px', name: 'AvailableDaysNr', onChange: onChange, value: requestData.AvailableDaysNr },
	                this.renderAvailableDaysNr()
	              ),
	              _react2.default.createElement(
	                _dropDown2.default,
	                { size: 'm', name: 'CarRentalType', onChange: onChange, value: requestData.CarRentalType || 0 },
	                _react2.default.createElement(
	                  'option',
	                  { value: 0 },
	                  (0, _helpers.translation)(332)
	                ),
	                carTypes.map(renderTypes)
	              ),
	              _react2.default.createElement(
	                _dropDown2.default,
	                { size: 'm', name: 'CarRentalCategory', onChange: onChange, value: requestData.CarRentalCategory || 0, disabled: !usedRentLog && requestData.CarRentalType === null },
	                _react2.default.createElement(
	                  'option',
	                  { value: 0 },
	                  (0, _helpers.translation)(1230)
	                ),
	                carCategories.map(renderCategories)
	              )
	            )
	          )
	        ),
	        false && _react2.default.createElement(
	          'div',
	          { className: 'actions' },
	          _react2.default.createElement(
	            'button',
	            { className: 'button primary' },
	            _react2.default.createElement('img', { src: '/images/icons/circle_plus22.png' }),
	            (0, _helpers.translation)('15107')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this10 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this10.state.dimensions.width;
	          if (width > higherThan && width <= lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'SetCreateNewOrderValues',
	    value: function SetCreateNewOrderValues(show, carRentalId, pickupDate) {
	      var defaultInfo = void 0;
	      if (show) {
	        defaultInfo = {
	          date: pickupDate,
	          carRentalId: carRentalId
	        };
	      }
	      this.props.triggerPopup(show);
	      this.setState({
	        createOrderPopup: {
	          show: show,
	          defaultCreateOrderInfo: defaultInfo
	        }
	      });
	    }
	  }, {
	    key: 'updateFromOrderSocket',
	    value: function updateFromOrderSocket(json) {
	      if (json.Type === 'ORDER_CREATED') this.getCarRentalOverview();
	      if (json.Type === 'ORDER_UPDATE' && json.Data.CarRentalId !== undefined && json.Data.CarRentalId !== null) this.getCarRentalOverview();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      var renderCarRow = function renderCarRow(car, carRowIndex) {
	        var renderCarOrder = function renderCarOrder(order, carOrderIndex) {
	          return _react2.default.createElement(_CarOrder2.default, { order: order, router: _this11.props.router, key: 'carorder_' + carRowIndex + '_' + carOrderIndex });
	        };
	        // do not show orders that end before first day of calendar
	        var carOrders = car.Orders;
	        var calendarStart = _this11.state.Days[0].Date;
	        carOrders = carOrders.filter(function (x) {
	          return x.FromDate >= calendarStart || x.ToDate > calendarStart;
	        });
	        return _react2.default.createElement(
	          _CarRow2.default,
	          { key: 'carrow_' + car.Id + '_' + carRowIndex, setCreateOrderValues: _this11.SetCreateNewOrderValues, car: car, maxConflicts: car.MaxIndex, days: _this11.state.Days },
	          carOrders.map(renderCarOrder),
	          ' '
	        );
	      };
	      var renderHeaderDay = function renderHeaderDay(day, dayIndex) {
	        var dayCount = _this11.state.Days.length;
	        if (dayCount <= 0) dayCount = 1;
	        var style = {
	          // Somehow Edge is broken when using 100%... broken as always.
	          width: 'calc(99.97% / ' + dayCount + ')'
	        };
	        var dayClass = 'day';
	        if (day.Active) {
	          dayClass += ' active';
	        } else if (day.IsClosed) {
	          dayClass += ' closed';
	        }
	        var dayText = '';
	        if (_this11.dimensionShow([[0, 740]])) {
	          dayText = (0, _helpers.translation)(day.ShortTextDictionaryKey);
	        } else {
	          if (day.TextDictionaryKey !== undefined && day.TextDictionaryKey !== null) {
	            dayText = (0, _helpers.translation)(day.TextDictionaryKey) + ' ';
	          }
	          if (day.Text !== undefined && day.Text !== null) {
	            dayText += day.Text;
	          }
	        }
	        if (!day.IsClosed && day.NrCarsArrived !== null && !_this11.dimensionShow([[0, 515]])) {
	          dayText += ' (' + day.NrCarsArrived + ')';
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { key: 'header_' + dayIndex, className: dayClass, style: style },
	          _react2.default.createElement(
	            'span',
	            null,
	            dayText
	          )
	        );
	      };
	      var renderHeaderDays = function renderHeaderDays() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'headerDays' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin icon' },
	            _react2.default.createElement('img', { src: '/images/svgs/menuicons/lend-White.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'days' },
	            _this11.state.Days.map(renderHeaderDay)
	          ),
	          _react2.default.createElement('div', { className: 'margin right' }),
	          _react2.default.createElement('div', { className: 'clearfix' })
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'carrentaloverview-screen' },
	        _react2.default.createElement(_StickyContainer2.default, { renderContent: this.renderHeaderItems, order: 0, specificIndex: 25 }),
	        _react2.default.createElement('div', { className: 'row clearfix' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'rentalCarsBoard noselect' },
	          _react2.default.createElement(_StickyContainer2.default, { renderContent: renderHeaderDays, order: 1 }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row-container' },
	            this.state.Cars.map(renderCarRow)
	          )
	        ),
	        _react2.default.createElement(_NewOrdersModal2.default, { router: this.props.router,
	          show: this.state.createOrderPopup.show,
	          carRentalDefaultInfo: this.state.createOrderPopup.defaultCreateOrderInfo,
	          onClose: this.SetCreateNewOrderValues.bind(this, false),
	          bodyShop: true })
	      );
	    }
	  }]);
	
	  return CarRentalOverview;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    carTypes: state.common.enums_new.CarRentalTypes,
	    carCategories: state.common.enums_new.CarRentalCategories
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetCarRentalOverview: _carrental.GetCarRentalOverview,
	  MoveOrderCarRental: _carrental.MoveOrderCarRental,
	  NewOrdersModal: _NewOrdersModal2.default,
	  triggerPopup: _backdrop.triggerPopup,
	  GetCarTypes: _carrental.GetCarTypes,
	  GetCarClasses: _carrental.GetCarClasses,
	  openOverlay: _common.openOverlay
	})(CarRentalOverview);

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _shops = __webpack_require__(79);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	__webpack_require__(1366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	// import TableRow from '../../../shared/elements/tableRow'
	// import TableContainer from '../../../shared/elements/tableContainer'
	// import PanelHeader from '../../../shared/elements/panelHeader'
	
	
	// Styles
	
	
	var CarRentalLog = function (_Component) {
	  _inherits(CarRentalLog, _Component);
	
	  function CarRentalLog(props) {
	    _classCallCheck(this, CarRentalLog);
	
	    var _this = _possibleConstructorReturn(this, (CarRentalLog.__proto__ || Object.getPrototypeOf(CarRentalLog)).call(this, props));
	
	    _this.state = {
	      carId: 0,
	      logs: []
	    };
	
	    _this.renderLog = _this.renderLog.bind(_this);
	    _this.getCarRentalLog = _this.getCarRentalLog.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarRentalLog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCarRentalLog(this.props.rentalCarId);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rentalCarId !== this.props.rentalCarId) {
	        this.getCarRentalLog(nextProps.rentalCarId);
	      }
	    }
	
	    // shouldComponentUpdate (nextProps) {
	    //   //if (nextProps.rentalCarId !== this.state.carId) {
	    //   if (nextProps.rentalCarId !== this.props.rentalCarId) {
	    //     this.getCarRentalLog(nextProps.rentalCarId)
	    //     return true
	    //   } else {
	    //     return false
	    //   }
	    // }
	
	  }, {
	    key: 'getCarRentalLog',
	    value: function getCarRentalLog(rentalCarId) {
	      var _this2 = this;
	
	      this.props.GetCarRentalLog(rentalCarId).then(function (res) {
	        _this2.setState({
	          logs: res.data,
	          carId: rentalCarId
	        });
	      });
	    }
	  }, {
	    key: 'renderLog',
	    value: function renderLog(logLine, key) {
	      var _this3 = this;
	
	      var info = logLine.OrderID > 0 ? logLine.OrderID : logLine.Note;
	      var goTo = function goTo(info, e) {
	        e.preventDefault();
	        if (!isNaN(info)) {
	          _this3.props.router.replace({
	            pathname: '/orders/' + info
	          });
	        }
	      };
	      // onClick={goTo.bind(this, logLine.OrderID)}
	      return _react2.default.createElement(
	        _grid2.default,
	        { key: key, cols: ['max-content', 1], spacing: 1 },
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _time.renderFullDate)(logLine.StartDate, false) + ' - ' + (0, _time.renderFullDate)(logLine.EndDate, false)
	        ),
	        logLine.OrderID > 0 ? _react2.default.createElement(
	          'a',
	          { onClick: goTo.bind(this, logLine.OrderID), href: '' },
	          info
	        ) : _react2.default.createElement(
	          'span',
	          null,
	          info
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('2211') },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [1.75, 1.25] },
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('434') }),
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('13420') })
	        ),
	        this.state.logs.length > 0 && this.state.logs.map(this.renderLog)
	      );
	    }
	  }]);
	
	  return CarRentalLog;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetCarRentalLog: _shops.GetCarRentalLog
	})(CarRentalLog);

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _shops = __webpack_require__(79);
	
	var _time = __webpack_require__(17);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	__webpack_require__(1367);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	
	// Elements
	
	
	// Utils
	
	
	// Styles
	
	
	// Is a flaggable enum
	var CarRentalServicePeriodTypes = {
	  TempUnavailable: 1
	};
	
	var TempInoperative = function (_Component) {
	  _inherits(TempInoperative, _Component);
	
	  function TempInoperative(props) {
	    _classCallCheck(this, TempInoperative);
	
	    var _this = _possibleConstructorReturn(this, (TempInoperative.__proto__ || Object.getPrototypeOf(TempInoperative)).call(this, props));
	
	    _this.state = {
	      carId: 0,
	      logs: [],
	      dateStart: (0, _moment2.default)(),
	      dateEnd: (0, _moment2.default)().add(1, 'd'),
	      comment: '',
	      confirm: {
	        open: false
	      }
	    };
	
	    _this.onDateStartChange = _this.onDateStartChange.bind(_this);
	    _this.onDateEndChange = _this.onDateEndChange.bind(_this);
	    _this.onCommentChange = _this.onCommentChange.bind(_this);
	    _this.renderLog = _this.renderLog.bind(_this);
	    _this.makeTempInoperative = _this.makeTempInoperative.bind(_this);
	    _this.getTempInoperative = _this.getTempInoperative.bind(_this);
	    _this.deleteService = _this.deleteService.bind(_this);
	    _this.closePopup = _this.closePopup.bind(_this);
	    return _this;
	  }
	
	  _createClass(TempInoperative, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getTempInoperative(this.props.rentalCarId);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rentalCarId !== this.state.carId) {
	        this.getTempInoperative(nextProps.rentalCarId);
	      }
	    }
	  }, {
	    key: 'getTempInoperative',
	    value: function getTempInoperative(rentalCarId) {
	      var _this2 = this;
	
	      this.props.GetTempInoperative(rentalCarId).then(function (res) {
	        _this2.setState({
	          logs: res.data,
	          carId: rentalCarId,
	          comment: ''
	        });
	      });
	    }
	  }, {
	    key: 'onDateStartChange',
	    value: function onDateStartChange(date) {
	      this.setState({
	        dateStart: date
	      });
	    }
	  }, {
	    key: 'onDateEndChange',
	    value: function onDateEndChange(date) {
	      this.setState({
	        dateEnd: date
	      });
	    }
	  }, {
	    key: 'onCommentChange',
	    value: function onCommentChange(e) {
	      var _this3 = this;
	
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	      this.setState(_defineProperty({}, name, value), function () {
	        return console.log('state', _this3.state);
	      });
	    }
	  }, {
	    key: 'makeTempInoperative',
	    value: function makeTempInoperative() {
	      var _this4 = this;
	
	      var _state = this.state,
	          dateStart = _state.dateStart,
	          dateEnd = _state.dateEnd;
	
	
	      if (dateStart.isAfter(dateEnd) || dateStart.isSameOrBefore((0, _moment2.default)().add(-1, 'd')) || dateEnd.isSameOrBefore((0, _moment2.default)().add(-1, 'd'))) {
	        window.toastr.error((0, _helpers.translation)('391'), (0, _helpers.translation)('216'));
	        return;
	      }
	
	      var inoperativeCar = {
	        StartDate: this.state.dateStart,
	        EndDate: this.state.dateEnd,
	        Comment: this.state.comment,
	        Type: CarRentalServicePeriodTypes.TempUnavailable,
	        IsDeleted: false,
	        CarRentalId: this.state.carId
	      };
	      this.props.MakeTempInoperative(inoperativeCar).then(function (res) {
	        _this4.setState({
	          logs: res.data
	        });
	        if (typeof _this4.props.OnUpdateCallback === 'function') _this4.props.OnUpdateCallback();
	      }, function (err) {
	        if (err.response.data !== undefined) {
	          var error = err.response.data;
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(error), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'deleteService',
	    value: function deleteService() {
	      var _this5 = this;
	
	      var inoperativeCar = {
	        Id: this.state.deleteId,
	        IsDeleted: true,
	        CarRentalId: this.state.carId
	      };
	      this.props.MakeTempInoperative(inoperativeCar).then(function (res) {
	        _this5.setState({
	          logs: res.data,
	          confirm: {
	            open: false
	          }
	        });
	        if (typeof _this5.props.OnUpdateCallback === 'function') _this5.props.OnUpdateCallback();
	      });
	    }
	  }, {
	    key: 'closePopup',
	    value: function closePopup() {
	      this.setState({
	        confirm: {
	          open: false
	        }
	      });
	    }
	  }, {
	    key: 'renderLog',
	    value: function renderLog(log, key) {
	      var _this6 = this;
	
	      var openConfirm = function openConfirm(id) {
	        _this6.setState({
	          deleteId: id,
	          confirm: {
	            open: true
	          }
	        });
	      };
	      return _react2.default.createElement(
	        _inline2.default,
	        { fillChildNum: [0], key: key, block: true, spacing: 2 },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _inline2.default,
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('434'),
	              ':'
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _time.renderFullDate)(log.StartDate, false) + ' - ' + (0, _time.renderFullDate)(log.EndDate, false)
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0 },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('333'),
	              ':'
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              log.Comment
	            )
	          )
	        ),
	        (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 11) && _react2.default.createElement(_removeButton2.default, { round: true, size: 'm', onClick: openConfirm.bind(this, log.Id), disabled: !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 11) })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          dateStart = _state2.dateStart,
	          dateEnd = _state2.dateEnd,
	          comment = _state2.comment;
	
	      var hasPerm = (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 11);
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('15103') },
	        this.state.logs.map(this.renderLog),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('434') },
	          _react2.default.createElement(
	            _inline2.default,
	            null,
	            _react2.default.createElement(_datetime2.default, {
	              className: 'inop__date',
	              inputProps: { name: 'dateStart', className: 'inop__date-input', disabled: !hasPerm },
	              closeOnSelect: true,
	              dateFormat: 'DD-MM-YYYY',
	              timeFormat: false,
	              value: dateStart,
	              onChange: this.onDateStartChange }),
	            _react2.default.createElement(_datetime2.default, {
	              className: 'inop__date',
	              inputProps: { name: 'dateEnd', className: 'inop__date-input', disabled: !hasPerm },
	              closeOnSelect: true,
	              dateFormat: 'DD-MM-YYYY',
	              timeFormat: false,
	              value: dateEnd,
	              onChange: this.onDateEndChange })
	          )
	        ),
	        _react2.default.createElement(_text2.default, { name: 'comment', value: comment, onChange: this.onCommentChange, disabled: !hasPerm, labelText: (0, _helpers.translation)('333') }),
	        _react2.default.createElement(_button2.default, { onClick: this.makeTempInoperative, disabled: !hasPerm, labelText: (0, _helpers.translation)('27') }),
	        this.state.confirm.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: this.closePopup },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.deleteService, notConfirm: this.closePopup, renderText: function renderText() {
	              return (0, _helpers.translation)('15122');
	            } })
	        )
	      );
	    }
	  }]);
	
	  return TempInoperative;
	}(_react.Component);
	
	TempInoperative.defaultProps = {
	  rentalCarId: undefined,
	  OnUpdateCallback: function OnUpdateCallback() {}
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetTempInoperative: _shops.GetTempInoperative,
	  MakeTempInoperative: _shops.MakeTempInoperative
	})(TempInoperative);

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _shops = __webpack_require__(79);
	
	var _carrental = __webpack_require__(223);
	
	var _orders = __webpack_require__(21);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1368);
	
	var _CarRentalLog = __webpack_require__(816);
	
	var _CarRentalLog2 = _interopRequireDefault(_CarRentalLog);
	
	var _TempInoperative = __webpack_require__(817);
	
	var _TempInoperative2 = _interopRequireDefault(_TempInoperative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Elements
	
	
	// Utils
	
	
	// contants
	
	
	// import styles
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      carRental: {
	        Id: 0,
	        RegNumber: '',
	        BrandName: '2000',
	        Number: 0,
	        Model: '',
	        Name: '',
	        Type: 0,
	        Category: 0,
	        Color: '',
	        Comment: '',
	        Active: true
	      },
	      openNumbers: [],
	      carTypes: [],
	      carCategories: []
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.getCarRental = _this.getCarRental.bind(_this);
	    _this.updateCarRental = _this.updateCarRental.bind(_this);
	    _this.getOpenCarRentalNumbers = _this.getOpenCarRentalNumbers.bind(_this);
	    _this.getOrderVehicleData = _this.getOrderVehicleData.bind(_this);
	    _this.getCarClasses = _this.getCarClasses.bind(_this);
	    _this.getCarTypes = _this.getCarTypes.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCarRental(this.props.itemId);
	      this.getOpenCarRentalNumbers();
	      this.getCarTypes();
	      this.getCarClasses();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.getCarRental(nextProps.itemId);
	      this.getOpenCarRentalNumbers();
	      this.getCarTypes();
	      this.getCarClasses();
	    }
	  }, {
	    key: 'getCarRental',
	    value: function getCarRental(itemId) {
	      var _this2 = this;
	
	      if (typeof itemId !== 'undefined' && itemId > 0) {
	        this.props.GetCarRental(itemId).then(function (res) {
	          _this2.setState({
	            type: 'edit',
	            carRental: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'getOpenCarRentalNumbers',
	    value: function getOpenCarRentalNumbers() {
	      var _this3 = this;
	
	      this.props.GetOpenCarRentalNumbers().then(function (res) {
	        _this3.setState({
	          openNumbers: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getCarTypes',
	    value: function getCarTypes() {
	      var _this4 = this;
	
	      this.props.GetCarTypes().then(function (res) {
	        _this4.setState({
	          carTypes: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getCarClasses',
	    value: function getCarClasses() {
	      var _this5 = this;
	
	      this.props.GetCarClasses().then(function (res) {
	        _this5.setState({
	          carCategories: res.data
	        });
	      });
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        carRental: {
	          Id: 0,
	          RegNumber: '',
	          BrandName: '2000',
	          Number: 0,
	          Model: '',
	          Color: '',
	          Comment: '',
	          Active: true
	        }
	      });
	    }
	  }, {
	    key: 'updateCarRental',
	    value: function updateCarRental() {
	      var _this6 = this;
	
	      var carRental = this.state.carRental;
	
	      var errText = '';
	      if (carRental.RegNumber === '') {
	        errText = (0, _helpers.translation)('14774');
	      }
	      // if (carRental.Number === 0 && carRental.Active) {
	      //   errText += '<br>' + translation('14786')
	      // }
	      if (errText !== '') {
	        window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	      } else {
	        this.props.UpdateCarRental(carRental).then(function (res) {
	          _this6.setState({
	            carRental: _extends({}, _this6.state.carRental, {
	              Number: res.data.Number
	            })
	          });
	          _this6.props.onSave(res.data, _this6.state.type);
	          setTimeout(function () {
	            _this6.props.GetSimpleCarRentals();
	            _this6.getOpenCarRentalNumbers();
	          }, 0);
	        }, function (err) {
	          if (err.response.data !== undefined) {
	            var error = err.response.data;
	            if (error.Message) {
	              error = error.Message;
	            }
	            _this6.getCarRental(carRental.Id);
	
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(error), (0, _helpers.translation)('216'));
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this7 = this;
	
	      if (typeof e.persist === 'function') e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      if (e.target.type === 'radio') {
	        value = e.target.value === 'yes';
	      }
	
	      if (e.target.name === 'Type' || e.target.name === 'Category') {
	        value = value === '0' || value === 0 ? null : parseInt(value);
	      }
	
	      this.setState({
	        type: this.state.type,
	        carRental: _extends({}, this.state.carRental, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type !== 'text') {
	          _this7.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      if (e.target.name === 'RegNumber') {
	        this.getOrderVehicleData(e.target.value);
	      }
	      if (this.state.carRental.Id !== undefined && this.state.carRental.Id > 0) {
	        this.updateCarRental();
	      }
	    }
	  }, {
	    key: 'renderCarRental',
	    value: function renderCarRental() {
	      var _this8 = this;
	
	      var carRental = this.state.carRental;
	      var _state = this.state,
	          carTypes = _state.carTypes,
	          carCategories = _state.carCategories;
	      // const { carTypes, carCategories } = this.props
	
	      var hasPerm = (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 11);
	      var readOnlyIsActive = this.state.carRental.IsAssigned || !hasPerm || this.state.carRental.HasServicePeriodNowOrFuture;
	      var isActiveHelpText = void 0;
	      if (this.state.carRental.IsAssigned) isActiveHelpText = 15109;else if (this.state.carRental.HasServicePeriodNowOrFuture) isActiveHelpText = 17923;
	
	      if (carRental === undefined) return null;
	      var brandsList = function brandsList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.Name },
	          (0, _helpers.translation)(val.Name)
	        );
	      };
	
	      var renderOpenNumbers = function renderOpenNumbers() {
	        return _this8.state.openNumbers.reduce(function (numbers, num, key) {
	          if (num !== '' && num !== carRental.Number) {
	            var opt = _react2.default.createElement(
	              'option',
	              { key: key, value: num },
	              num
	            );
	            return [].concat(_toConsumableArray(numbers), [opt]);
	          }
	          return numbers;
	        }, []);
	      };
	
	      var vanCategories = [3, 4, 5];
	      var passengerCategories = [1, 2, 4, 5];
	      var panelTitle = '';
	      var disabledForRentLog = this.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.RENTLOG;
	
	      var renderTypes = function renderTypes(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.Id },
	          val.Name
	        );
	      };
	
	      var renderCategories = function renderCategories(category, key) {
	        var cat = parseInt(category.Id);
	
	        if (_this8.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.RENTLOG) {
	          return _react2.default.createElement(
	            'option',
	            { key: key, value: cat },
	            category.Name
	          );
	        }
	
	        if (carRental.Type === null || carRental.Type === 1 && vanCategories.includes(cat) || carRental.Type === 2 && passengerCategories.includes(cat)) {
	          return _react2.default.createElement(
	            'option',
	            { key: key, value: cat },
	            category.Name
	          );
	        }
	      };
	
	      if (this.state.type === 'create') panelTitle = (0, _helpers.translation)('629');else if (this.state.type === 'edit') panelTitle = carRental.RegNumber + ', ' + carRental.BrandName + ', ' + carRental.Model;
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: panelTitle },
	        _react2.default.createElement(_text2.default, { name: 'RegNumber', value: carRental.RegNumber || '', onChange: this.onChange, onBlur: this.onBlur, disabled: this.state.type === 'edit' || disabledForRentLog, labelText: (0, _helpers.translation)('2005') }),
	        _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'BrandName', onChange: this.onChange, value: carRental.BrandName, disabled: this.state.type === 'edit' || disabledForRentLog, labelText: (0, _helpers.translation)('145') },
	          this.props.brands.map(brandsList)
	        ),
	        _react2.default.createElement(_text2.default, { name: 'Model', value: carRental.Model || '', onChange: this.onChange, onBlur: this.onBlur, disabled: this.state.type === 'edit' || disabledForRentLog, labelText: (0, _helpers.translation)('146') }),
	        _react2.default.createElement(_text2.default, { name: 'Name', value: carRental.Name || '', onChange: this.onChange, onBlur: this.onBlur, disabled: !hasPerm || disabledForRentLog, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'Type', onChange: this.onChange, value: carRental.Type || 0, disabled: !hasPerm || disabledForRentLog, labelText: (0, _helpers.translation)('332') },
	          _react2.default.createElement('option', { value: 0 }),
	          carTypes.map(renderTypes)
	        ),
	        _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'Category', onChange: this.onChange, value: carRental.Category || 0, disabled: !hasPerm || disabledForRentLog, labelText: (0, _helpers.translation)('1230') },
	          _react2.default.createElement('option', { value: 0 }),
	          carCategories.map(renderCategories)
	        ),
	        _react2.default.createElement(_text2.default, { name: 'Color', value: carRental.Color || '', onChange: this.onChange, onBlur: this.onBlur, disabled: !hasPerm || disabledForRentLog, labelText: (0, _helpers.translation)('179') }),
	        this.state.openNumbers !== undefined && _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'Number', onChange: this.onChange, value: carRental.Number, disabled: !carRental.Active || !hasPerm || disabledForRentLog, labelText: (0, _helpers.translation)('1309') },
	          _react2.default.createElement(
	            'option',
	            { value: carRental.Number },
	            carRental.Number || (0, _helpers.translation)('1309')
	          ),
	          renderOpenNumbers()
	        ),
	        _react2.default.createElement(_textarea2.default, { name: 'Comment', onChange: this.onChange, onBlur: this.onBlur, value: carRental.Comment || '', disabled: !hasPerm || disabledForRentLog, labelText: (0, _helpers.translation)('93') }),
	        _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onChange, checked: carRental.Active, labelText: (0, _helpers.translation)('295'), disabled: readOnlyIsActive || disabledForRentLog, helpText: (0, _helpers.translation)(isActiveHelpText) })
	      );
	    }
	  }, {
	    key: 'getOrderVehicleData',
	    value: function getOrderVehicleData(regNumber) {
	      var _this9 = this;
	
	      this.props.getOrderVehicleData(regNumber, 'RegNumber').then(function (res) {
	        _this9.setState({
	          carRental: _extends({}, _this9.state.carRental, {
	            RegNumber: res.data.RegNr,
	            BrandName: res.data.BrandName,
	            Model: res.data.Model
	          })
	        });
	        var dictionaryKeyResult = res.data.DictionaryKey;
	        if (dictionaryKeyResult === 1153) {
	          dictionaryKeyResult = 14862;
	        }
	        if (dictionaryKeyResult) {
	          // Toastr
	          window.toastr.info((0, _helpers.translation)(dictionaryKeyResult));
	        }
	      }, function (err) {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      var classNameList = this.state.type === 'edit' ? 'view_edit' : 'view_create';
	      return _react2.default.createElement(
	        'div',
	        { className: classNameList },
	        _react2.default.createElement(
	          'div',
	          { className: 'row clearfix' },
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderCarRental()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.state.type === 'edit' && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && _react2.default.createElement(_CarRentalLog2.default, { router: this.props.router, rentalCarId: this.props.itemId })
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.state.type === 'edit' && this.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.NONE && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && _react2.default.createElement(_TempInoperative2.default, { rentalCarId: this.props.itemId, OnUpdateCallback: function OnUpdateCallback() {
	                return _this10.getCarRental(_this10.props.itemId);
	              } })
	          )
	        )
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    // carTypes: state.common.enums_new.CarRentalTypes,
	    // carCategories: state.common.enums_new.CarRentalCategories,
	    brands: state.common.brands
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetCarRental: _shops.GetCarRental,
	  UpdateCarRental: _shops.UpdateCarRental,
	  GetOpenCarRentalNumbers: _shops.GetOpenCarRentalNumbers,
	  getOrderVehicleData: _orders.getOrderVehicleData,
	  GetCarTypes: _carrental.GetCarTypes,
	  GetCarClasses: _carrental.GetCarClasses
	}, null, { withRef: true })(View);

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _shops = __webpack_require__(79);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _constants = __webpack_require__(5);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _View = __webpack_require__(818);
	
	var _View2 = _interopRequireDefault(_View);
	
	__webpack_require__(1369);
	
	var _backButton = __webpack_require__(235);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// contants
	
	
	// Elements
	
	
	// Utils
	
	
	// Views
	
	
	// import styles
	
	
	var CarRental = function (_Component) {
	  _inherits(CarRental, _Component);
	
	  function CarRental(props) {
	    _classCallCheck(this, CarRental);
	
	    var _this = _possibleConstructorReturn(this, (CarRental.__proto__ || Object.getPrototypeOf(CarRental)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      search: '',
	      includeInactive: false,
	      carRentals: [],
	      activeItem: {},
	      brands: []
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.headerButtonsGoBack = _this.headerButtonsGoBack.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    _this.GetSimpleCarRentals = _this.GetSimpleCarRentals.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarRental, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.GetSimpleCarRentals();
	    }
	  }, {
	    key: 'GetSimpleCarRentals',
	    value: function GetSimpleCarRentals() {
	      var _this2 = this;
	
	      this.props.GetSimpleCarRentals().then(function (res) {
	        _this2.setState({
	          carRentals: res.data,
	          activeItem: _this2.state.activeItem
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsGoBack',
	    value: function headerButtonsGoBack() {
	      var _this3 = this;
	
	      if (this.state.view === 'create') return null;
	
	      var goBack = function goBack(type) {
	        _this3.context.router.goBack();
	      };
	      return _react2.default.createElement(_backButton2.default, { ariaText: (0, _helpers.translation)('394'), onClick: goBack.bind(this, 'back') });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 11)) return null;
	      if (this.state.view === 'create') return null;
	      if (this.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.RENTLOG) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', labelText: (0, _helpers.translation)('14773'), ariaText: (0, _helpers.translation)('14773'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var carRentals = [].concat(_toConsumableArray(this.state.carRentals));
	      var activeItem = void 0;
	      if (type === 'create') {
	        var createdName = '';
	        if (data.Number !== 0) {
	          createdName += data.Number + ' - ';
	        }
	        createdName += data.RegNumber;
	        if (data.BrandName !== '2000') {
	          createdName += ', ' + data.BrandName;
	        }
	        carRentals.push({
	          Id: data.Id,
	          RegNumber: data.RegNumber,
	          BrandName: data.BrandName,
	          Number: data.Number,
	          Active: data.Active,
	          Name: createdName
	        });
	        type = 'item';
	        activeItem = {
	          Id: data.Id
	        };
	      } else {
	        carRentals.map(function (val, key) {
	          if (val.Id === data.Id) {
	            val.RegNumber = data.RegNumber;
	            val.BrandName = data.BrandName;
	            val.Number = data.Number;
	            val.Active = data.Active;
	            // val.Name = data.Name
	          }
	        });
	        type = 'item';
	        activeItem = {
	          Id: data.Id
	        };
	      }
	      this.setState({
	        carRentals: carRentals,
	        view: type,
	        activeItem: activeItem
	      });
	      // Toastr
	      // window.toastr.success(translation('14772'), translation('13424'))
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, {
	            router: this.props.router,
	            ref: 'view',
	            onSave: this.onSave,
	            itemId: this.state.activeItem.Id,
	            GetSimpleCarRentals: this.GetSimpleCarRentals });
	      }
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this4 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this4.refs.view.getWrappedInstance().updateCarRental();
	        };
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.carRentals.map(function (cr) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: cr.Name,
	          onClick: function onClick() {
	            return _this4.onSelectItem(cr);
	          },
	          selected: cr.Id === _this4.state.activeItem.Id,
	          inactive: !cr.Active,
	          key: cr.Id
	        });
	      });
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // title={translation('14778')}
	      // svg={'/images/svgs/menuicons/lend-White.svg'}
	      console.log('props.renderTitles', this.props.renderTitles);
	      return _react2.default.createElement(
	        'div',
	        { className: 'carrental__screen' },
	        _react2.default.createElement(
	          _Header2.default,
	          { router: this.props.router, showBack: true, headerButtonsGoBack: this.headerButtonsGoBack, renderRight: this.headerButtonsRight },
	          _react2.default.createElement(
	            _tabBar2.default,
	            null,
	            this.props.renderTitles
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'carrental__screen--inner' },
	          _react2.default.createElement('div', { className: 'row clearfix' }),
	          _react2.default.createElement(
	            _sideMenu2.default,
	            { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create' },
	            this.createView()
	          ),
	          _react2.default.createElement(
	            _Content2.default,
	            { className: 'customers__screen--inner' },
	            this.renderView()
	          )
	        )
	      );
	    }
	  }]);
	
	  return CarRental;
	}(_react.Component);
	
	CarRental.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetSimpleCarRentals: _shops.GetSimpleCarRentals,
	  hasSubscriptionPermission: _auth.hasSubscriptionPermission
	})(CarRental);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _CarRentalOverview = __webpack_require__(815);
	
	var _CarRentalOverview2 = _interopRequireDefault(_CarRentalOverview);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	__webpack_require__(1370);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _common = __webpack_require__(25);
	
	var _OrderCapacityOverview = __webpack_require__(306);
	
	var _OrderCapacityOverview2 = _interopRequireDefault(_OrderCapacityOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	// import CarRental from '../CarRental'
	
	
	// Elements
	
	
	// Import styles
	
	
	var CarRentals = function (_Component) {
	  _inherits(CarRentals, _Component);
	
	  function CarRentals(props) {
	    _classCallCheck(this, CarRentals);
	
	    var _this = _possibleConstructorReturn(this, (CarRentals.__proto__ || Object.getPrototypeOf(CarRentals)).call(this, props));
	
	    _this.state = {
	      tabActive: 'overview'
	    };
	
	    _this.renderTabContent = _this.renderTabContent.bind(_this);
	    _this.renderTitle = _this.renderTitle.bind(_this);
	    _this.renderTitles = _this.renderTitles.bind(_this);
	    _this.renderCapacityOverview = _this.renderCapacityOverview.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarRentals, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkOpenCapacityOverview();
	    }
	  }, {
	    key: 'checkOpenCapacityOverview',
	    value: function checkOpenCapacityOverview() {
	      var routeItems = window.LocalstorageStack.all();
	      var index = routeItems.length - 3;
	      if (routeItems && routeItems.length > 3 && routeItems[index].pathname === 'OrderCapacityOverview') {
	        this.props.openOverlay('OrderCapacityOverview');
	      }
	    }
	  }, {
	    key: 'changeTab',
	    value: function changeTab(title, e) {
	      e.preventDefault();
	      this.setState({
	        tabActive: title.val
	      });
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(title, index) {
	      var activeClass = this.state.tabActive === title.val ? 'active' : '';
	      var onClick = this.changeTab.bind(this, title);
	      var link = '#';
	      if (title.link) {
	        link = title.link;
	        onClick = function onClick() {};
	      }
	      return _react2.default.createElement(
	        _tabItem2.default,
	        { key: 'tab_' + index },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            className: activeClass,
	            to: link,
	            onClick: onClick,
	            key: index },
	          title.name
	        )
	      );
	    }
	  }, {
	    key: 'renderTitles',
	    value: function renderTitles() {
	      var titles = [{ name: (0, _helpers.translation)('15106'), val: 'overview' // , link: '/CarRentalOverview' }
	      }];
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10, [11])) {
	        titles.push({ name: (0, _helpers.translation)('14778'), val: 'carRental', link: '/CarRental' });
	      }
	      return titles.map(this.renderTitle);
	    }
	  }, {
	    key: 'renderTabContent',
	    value: function renderTabContent() {
	      // let titles = [
	      //   { name: translation('15106'), val: 'overview' } // , link: '/CarRentalOverview' }
	      // ]
	      // if (hasSubscriptionPermission(this.props.auth, 10, [11])) {
	      //   titles.push(
	      //     { name: translation('14778'), val: 'carRental', link: '/CarRental' }
	      //   )
	      // }
	      // const renderTitles = () => {
	      //   return titles.map(this.renderTitle)
	      // }
	      switch (this.state.tabActive) {
	        case 'carRental':
	          // return <CarRental renderTitles={renderTitles()} />
	          break;
	        case 'overview':
	        default:
	          return _react2.default.createElement(_CarRentalOverview2.default, { router: this.props.router /* renderTitles={this.renderTitles()} */ });
	      }
	    }
	  }, {
	    key: 'renderCapacityOverview',
	    value: function renderCapacityOverview() {
	      var _this2 = this;
	
	      if (!(0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(this.props.auth, 30) || this.props.auth.departmentType !== 1) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'capacity-overview hide-from-resposive' },
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', style: 'link', labelText: (0, _helpers.translation)('17912'), onClick: function onClick() {
	            return _this2.props.openOverlay('OrderCapacityOverview');
	          } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // let title = this.state.tabActive === 'carRental' ? translation('14778') : translation('15105')
	      return _react2.default.createElement(
	        'div',
	        { className: 'carrentals__screen' },
	        _react2.default.createElement(
	          _Header2.default,
	          { router: this.props.router, renderRight: this.renderCapacityOverview },
	          _react2.default.createElement(
	            _tabBar2.default,
	            null,
	            this.renderTitles()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'carrentals__screen--inner' },
	          this.renderTabContent()
	        ),
	        _react2.default.createElement(_OrderCapacityOverview2.default, null)
	      );
	    }
	  }]);
	
	  return CarRentals;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  openOverlay: _common.openOverlay
	})(CarRentals);

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _chains = __webpack_require__(127);
	
	var _auth = __webpack_require__(68);
	
	var _constants = __webpack_require__(5);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	__webpack_require__(1371);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _icons = __webpack_require__(6);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// Components
	
	
	// Elements
	
	
	// Utils
	
	
	var Create = function (_PureComponent) {
	  _inherits(Create, _PureComponent);
	
	  function Create(props) {
	    _classCallCheck(this, Create);
	
	    var _this = _possibleConstructorReturn(this, (Create.__proto__ || Object.getPrototypeOf(Create)).call(this, props));
	
	    _this.state = {
	      chain: {
	        Id: 0,
	        IsActive: '',
	        Name: '',
	        PhoneNumber: '',
	        PhoneCode: {
	          Id: 0,
	          Code: '',
	          MinNrLength: 0,
	          MaxNrLength: 0
	        },
	        DefaultPhoneCode: {
	          Id: 0,
	          Code: '',
	          MinNrLength: 0,
	          MaxNrLength: 0
	        },
	        Contact: '',
	        Email: '',
	        Address: '',
	        Country: '',
	        Logo: '',
	        UseForsi: 0,
	        VehicleLookupServiceId: 0,
	        PaintTool: 0,
	        SmsDk: '',
	        SmsEu: '',
	        UseBenchmark: '',
	        AccessShops: '',
	        DefaultCulture: 0,
	        DefaultLanguage: '',
	        Currency: {
	          Id: 0,
	          Code: ''
	        },
	        Administrators: [],
	        // PermissionModules: [],
	        AutomaticWarrantyCode: false,
	        AssessmentSystem: 0
	      },
	      Stats: {
	        StartDate: (0, _moment2.default)().subtract(1, 'month'),
	        EndDate: (0, _moment2.default)()
	      },
	      Confirm: {
	        Show: false,
	        IsPermission: false,
	        target: {
	          value: '',
	          name: '',
	          checked: false
	        }
	      },
	      dimensions: {
	        width: 0,
	        height: 0
	      },
	      currencies: []
	    };
	
	    _this.updateChain = _this.updateChain.bind(_this);
	    _this.addChain = _this.addChain.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onCheckBoxChange = _this.onCheckBoxChange.bind(_this);
	    // this.onModuleCheck = this.onModuleCheck.bind(this)
	    _this.onChangeSelect = _this.onChangeSelect.bind(_this);
	    _this.getStats = _this.getStats.bind(_this);
	    _this.confirm = _this.confirm.bind(_this);
	    _this.notConfirm = _this.notConfirm.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.getCurrencies = _this.getCurrencies.bind(_this);
	    return _this;
	  }
	
	  _createClass(Create, [{
	    key: 'resetCreateChain',
	    value: function resetCreateChain() {
	      this.setState({
	        chain: {
	          Id: 0,
	          IsActive: '',
	          Name: '',
	          PhoneNumber: '',
	          PhoneCode: {
	            Id: 12,
	            Code: '+45',
	            MinNrLength: 8,
	            MaxNrLength: 8
	          },
	          DefaultPhoneCode: {
	            Id: 12,
	            Code: '+45',
	            MinNrLength: 8,
	            MaxNrLength: 8
	          },
	          Contact: '',
	          Email: '',
	          Address: '',
	          Country: '1750',
	          Logo: '',
	          UseForsi: 0,
	          VehicleLookupServiceId: 0,
	          PaintTool: 0,
	          UseSmsDk: '',
	          UseSmsEu: '',
	          UseBenchmark: '',
	          AccessShops: '',
	          DefaultCulture: 0,
	          DefaultLanguage: 'Danish',
	          Currency: {
	            Id: 10,
	            Code: 'DKK'
	          },
	          Administrators: [],
	          // PermissionModules: [],
	          AutomaticWarrantyCode: false,
	          AssessmentSystem: 0
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.updateDimensions);
	      this.updateDimensions();
	      this.getCurrencies();
	      if (typeof this.props.item.ChainId === 'undefined') {
	        this.resetCreateChain();
	      } else {
	        this.setState({
	          type: 'edit'
	        });
	        this.getChainById(this.props.item.ChainId);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (typeof nextProps.item.ChainId === 'undefined') {
	        this.resetCreateChain();
	      } else {
	        if (this.props.item.ChainId !== nextProps.item.ChainId) {
	          this.setState({
	            type: 'edit'
	          });
	          this.getChainById(nextProps.item.ChainId);
	        }
	      }
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'getCurrencies',
	    value: function getCurrencies() {
	      var _this2 = this;
	
	      this.props.getCurrencies().then(function (res) {
	        _this2.setState({
	          currencies: res.data
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getChainById',
	    value: function getChainById(id) {
	      var _this3 = this;
	
	      this.props.getChain(id).then(function (res) {
	        _this3.setState({
	          chain: res.data
	        }, function () {
	          return console.log('get chain by id: ', _this3.state.chain);
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this4 = this;
	
	      var names = ['Country', 'Dateformat', 'DefaultLanguage', 'VehicleLookupServiceId', 'PhoneCode'];
	      this.setState({
	        chain: _extends({}, this.state.chain, _defineProperty({}, e.target.name, e.target.value))
	      }, function () {
	        if (names.includes(e.target.name)) _this4.updateChain();
	      });
	    }
	  }, {
	    key: 'onCheckBoxChange',
	    value: function onCheckBoxChange(e, dontCheck) {
	      var _this5 = this;
	
	      if (!dontCheck) {
	        this.setState({
	          Confirm: {
	            Show: true,
	            IsPermission: false,
	            text: e.target.name,
	            target: {
	              value: e.target.value,
	              name: e.target.name
	            }
	          }
	        });
	        return;
	      }
	
	      var checkboxValue = e.target.name === 'PaintTool' || e.target.name === 'AssessmentSystem' ? parseInt(e.target.value, 10) : !(e.target.value === 'true');
	      this.setState({
	        chain: _extends({}, this.state.chain, _defineProperty({}, e.target.name, checkboxValue))
	      }, function () {
	        _this5.updateChain(e);
	      });
	    }
	  }, {
	    key: 'onChangeSelect',
	    value: function onChangeSelect(e) {
	      var _this6 = this;
	
	      if (e.target.name === 'Currency') {
	        this.setState({
	          chain: _extends({}, this.state.chain, {
	            Currency: _extends({}, this.state.Currency, {
	              Id: e.target.value
	            })
	          })
	        }, function () {
	          _this6.updateChain();
	        });
	      } else {
	        this.setState({
	          chain: _extends({}, this.state.chain, {
	            DefaultPhoneCode: _extends({}, this.state.chain.DefaultPhoneCode, {
	              Id: e.target.value
	            })
	          })
	        }, function () {
	          if (e.target.name === 'Countrycode') _this6.updateChain();
	        });
	      }
	    }
	
	    // onModuleCheck (e, dontCheck) {
	    //   if (!dontCheck) {
	    //     this.setState({
	    //       Confirm: {
	    //         Show: true,
	    //         IsPermission: true,
	    //         target: {
	    //           value: e.target.value,
	    //           name: e.target.name,
	    //           checked: e.target.checked
	    //         }
	    //       }
	    //     })
	    //     return
	    //   }
	
	    //   let modules = [...this.state.chain.PermissionModules]
	    //   var value = e.target.value
	    //   console.log(modules, value)
	    //   if (e.target.checked === false) {
	    //     modules = modules.filter(function (el) {
	    //       return Number(el.PermissionModuleId) !== Number(value)
	    //     })
	    //   } else {
	    //     modules.push({
	    //       PermissionModuleId: value
	    //     })
	    //   }
	    //   this.setState({
	    //     chain: {
	    //       ...this.state.chain,
	    //       PermissionModules: modules
	    //     }
	    //   }, this.updateChain)
	    // }
	
	  }, {
	    key: 'loginAs',
	    value: function loginAs(id) {
	      var _this7 = this;
	
	      this.props.loginAs(id).then(function (res) {
	        setTimeout(function () {
	          _this7.props.router.push('/shopowners');
	        }, 200);
	      });
	    }
	  }, {
	    key: 'updateChain',
	    value: function updateChain() {
	      if (this.state.chain.Id !== 0) {
	        this.props.createSaveChain(this.state.chain).then(function (res) {
	          // Toastr
	          // window.toastr.success(translation('13462'), translation('13424'))
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13463'), (0, _helpers.translation)('216'));
	        });
	      }
	    }
	  }, {
	    key: 'addChain',
	    value: function addChain() {
	      var _this8 = this;
	
	      if (this.state.chain.Id === 0 && this.state.chain.Name.length > 0) {
	        this.props.createSaveChain(this.state.chain).then(function (res) {
	          _this8.props.onSave(res.data, _this8.props.type);
	          setTimeout(function () {
	            _this8.props.getChains();
	          }, 0);
	          // Toastr
	          // window.toastr.success(translation('1830'), translation('13424'))
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('1831'), (0, _helpers.translation)('216'));
	        });
	      }
	    }
	  }, {
	    key: 'renderAdmins',
	    value: function renderAdmins() {
	      var _this9 = this;
	
	      if (this.props.type === 'create') return null;
	      var chain = this.state.chain;
	      var adminList = function adminList(val, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/chains/' + chain.Id + '/managers/' + val.UserId },
	              val.Name
	            )
	          ),
	          val.UserId > 0 && _react2.default.createElement(_button2.default, { onClick: _this9.loginAs.bind(_this9, val.UserId), style: 'link', labelText: (0, _helpers.translation)('57') })
	        );
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('61') },
	        _react2.default.createElement(
	          _actions2.default,
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/chains/' + chain.Id + '/managers' },
	            _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't' })
	          )
	        ),
	        chain.Administrators.map(adminList)
	      );
	    }
	  }, {
	    key: 'changeDate',
	    value: function changeDate(name, moment) {
	      this.setState({
	        Stats: _extends({}, this.state.Stats, _defineProperty({}, name, moment))
	      });
	    }
	  }, {
	    key: 'getStats',
	    value: function getStats() {
	      var newFileUrl = _constants.API_URL + '/Permissions/PermissionsHistory?startDate=' + this.state.Stats.StartDate.format('DD-MM-YYYY HH:mm:ss') + '&endDate=' + this.state.Stats.EndDate.format('DD-MM-YYYY HH:mm:ss') + '&chainId=' + this.props.item.ChainId + '&token=' + encodeURIComponent(this.props.auth.user.Token);
	      window.open(newFileUrl);
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this10 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this10.state.dimensions.width;
	          if (width > higherThan && width <= lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chain = this.state.chain;
	
	      var renderCodes = function renderCodes(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.Id },
	          val.Code
	        );
	      };
	      var renderLanguage = function renderLanguage(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val },
	          val
	        );
	      };
	
	      var confirmText = this.state.Confirm.text === 'AssessmentSystem' ? '17933' : '14748';
	
	      var vehicleLookupServiceOptions = [{ Id: 0, Name: 'Ingen' }];
	      this.props.vehicleLookupServices.map(function (val) {
	        vehicleLookupServiceOptions.push({ Id: val.Id, Name: (0, _helpers.translation)(val.NameDictionaryKey) });
	      });
	      var renderVehicleLookupService = function renderVehicleLookupService(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.Id },
	          val.Name
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'chainCreate__screen' },
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.dimensionShow([[0, 850]]) && this.renderAdmins(),
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('346') },
	            _react2.default.createElement(_text2.default, { name: 'Name', value: chain.Name || '', onChange: this.onChange, onBlur: this.updateChain, labelText: (0, _helpers.translation)('30') }),
	            _react2.default.createElement(_text2.default, { name: 'Contact', value: chain.Contact || '', onChange: this.onChange, onBlur: this.updateChain, labelText: (0, _helpers.translation)('346') }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('345') },
	              _react2.default.createElement(_Phone2.default, {
	                onChange: this.onChange,
	                code: chain.PhoneCode,
	                number: chain.PhoneNumber,
	                name: 'PhoneCode',
	                onBlur: this.updateChain })
	            ),
	            _react2.default.createElement(_text2.default, { name: 'Email', value: chain.Email || '', onChange: this.onChange, onBlur: this.updateChain, labelText: (0, _helpers.translation)('1052') }),
	            _react2.default.createElement(_text2.default, { name: 'Address', value: chain.Address || '', onChange: this.onChange, onBlur: this.updateChain, labelText: (0, _helpers.translation)('25') }),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'Country', value: parseInt(chain.Country, 10), onChange: this.onChange, labelText: (0, _helpers.translation)('1701') },
	              this.props.countries.map(function (val, index) {
	                var showVal = (0, _helpers.translation)(val['CountryName']);
	                return _react2.default.createElement(
	                  'option',
	                  { value: val['CountryName'], key: index },
	                  showVal
	                );
	              })
	            ),
	            _react2.default.createElement(_text2.default, { name: 'Logo', value: chain.Logo || '', onChange: this.onChange, onBlur: this.updateChain, labelText: (0, _helpers.translation)('1702') })
	          )
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('6') },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('17932') },
	              _react2.default.createElement(_radio2.default, { id: 'NoAssessmentSystem', name: 'AssessmentSystem', value: 0, onChange: this.onCheckBoxChange, checked: chain.AssessmentSystem === 0, labelText: (0, _helpers.translation)('433') }),
	              _react2.default.createElement(_radio2.default, { id: 'Forsi', name: 'AssessmentSystem', value: 1, onChange: this.onCheckBoxChange, checked: chain.AssessmentSystem === 1, labelText: (0, _helpers.translation)('13438') }),
	              _react2.default.createElement(_radio2.default, { id: 'DBS', name: 'AssessmentSystem', value: 2, onChange: this.onCheckBoxChange, checked: chain.AssessmentSystem === 2, labelText: (0, _helpers.translation)('17930') })
	            ),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'VehicleLookupServiceId', onChange: this.onChange, value: chain.VehicleLookupServiceId, labelText: (0, _helpers.translation)('1704') },
	              vehicleLookupServiceOptions.map(renderVehicleLookupService)
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('14964') },
	              _react2.default.createElement(_radio2.default, { id: 'NoPaintTool', name: 'PaintTool', value: 0, onChange: this.onCheckBoxChange, checked: chain.PaintTool === 0, labelText: (0, _helpers.translation)('433') }),
	              _react2.default.createElement(_radio2.default, { id: 'ChromaWeb', name: 'PaintTool', value: 1, onChange: this.onCheckBoxChange, checked: chain.PaintTool === 1, labelText: 'ChromaWeb' })
	            ),
	            _react2.default.createElement(_divider2.default, { noLine: true }),
	            _react2.default.createElement(_check2.default, { id: 'UseSmsDk', name: 'UseSmsDk', value: chain.UseSmsDk, onChange: this.onCheckBoxChange, checked: chain.UseSmsDk, labelText: (0, _helpers.translation)('1705') }),
	            _react2.default.createElement(_check2.default, { id: 'UseSmsEu', name: 'UseSmsEu', value: chain.UseSmsEu, onChange: this.onCheckBoxChange, checked: chain.UseSmsEu, labelText: (0, _helpers.translation)('1706') }),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'Countrycode', onChange: this.onChangeSelect, value: chain.DefaultPhoneCode.Id, labelText: (0, _helpers.translation)('1707') },
	              this.props.phonecodes.map(renderCodes)
	            ),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'Dateformat', onChange: this.onChange, labelText: (0, _helpers.translation)('1708') },
	              _react2.default.createElement(
	                'option',
	                { key: '1', value: '1' },
	                '1'
	              ),
	              _react2.default.createElement(
	                'option',
	                { key: '2', value: '2' },
	                '2'
	              )
	            ),
	            _react2.default.createElement(_text2.default, { name: 'Vat', value: chain.Vat || '', onChange: this.onChange, onBlur: this.updateChain, labelText: (0, _helpers.translation)('14804') }),
	            _react2.default.createElement(_check2.default, { id: 'UseBenchmark', name: 'UseBenchmark', value: chain.UseBenchmark, onChange: this.onCheckBoxChange, checked: chain.UseBenchmark, labelText: (0, _helpers.translation)('1419') }),
	            _react2.default.createElement(_check2.default, { id: 'AccessShops', name: 'AccessShops', value: chain.AccessShops, onChange: this.onCheckBoxChange, checked: chain.AccessShops, labelText: (0, _helpers.translation)('1710') }),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'DefaultLanguage', onChange: this.onChange, value: chain.DefaultLanguage, labelText: (0, _helpers.translation)('1711') },
	              this.props.languages.map(renderLanguage)
	            ),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'Currency', onChange: this.onChangeSelect, value: chain.Currency.Id, labelText: (0, _helpers.translation)('17994') },
	              this.state.currencies.map(renderCodes)
	            ),
	            _react2.default.createElement(_check2.default, { id: 'AutomaticWarrantyCode', name: 'AutomaticWarrantyCode', value: chain.AutomaticWarrantyCode, onChange: this.onCheckBoxChange, checked: chain.AutomaticWarrantyCode, labelText: (0, _helpers.translation)('15145') })
	          )
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          !this.dimensionShow([[0, 850]]) && this.renderAdmins(),
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('389') },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('1490') },
	              _react2.default.createElement(_datetime2.default, {
	                dateFormat: 'DD-MM-YYYY',
	                closeOnSelect: true,
	                timeFormat: false,
	                value: this.state.Stats.StartDate,
	                onChange: this.changeDate.bind(this, 'StartDate') })
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('13516') },
	              _react2.default.createElement(_datetime2.default, {
	                dateFormat: 'DD-MM-YYYY',
	                closeOnSelect: true,
	                timeFormat: false,
	                value: this.state.Stats.EndDate,
	                onChange: this.changeDate.bind(this, 'EndDate') })
	            ),
	            _react2.default.createElement(_button2.default, { onClick: this.getStats, labelText: (0, _helpers.translation)('13517'), style: 'link' })
	          )
	        ),
	        this.state.Confirm.Show === true && _react2.default.createElement(_Confirm2.default, { t: _helpers.translation, renderText: function renderText() {
	            return (0, _helpers.translation)(confirmText);
	          }, confirm: this.confirm, notConfirm: this.notConfirm })
	      );
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm() {
	      this.setState({
	        Confirm: _extends({}, this.state.Confirm, {
	          Show: false
	        })
	      });
	
	      if (this.state.Confirm.IsPermission) {} else {
	        this.onCheckBoxChange(this.state.Confirm, true);
	      }
	    }
	  }, {
	    key: 'notConfirm',
	    value: function notConfirm() {
	      this.setState({
	        Confirm: _extends({}, this.state.confirm, {
	          Show: false
	        })
	      });
	    }
	  }]);
	
	  return Create;
	}(_react.PureComponent);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecodes: state.common.phonecodes,
	    vehicleLookupServices: state.common.vehicleLookupServices,
	    languages: state.i18nState.languages,
	    countries: state.common.countries,
	    currencies: state.common.currencies
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getChain: _chains.getChain,
	  getChainStats: _chains.getChainStats,
	  createSaveChain: _chains.createSaveChain,
	  getCurrencies: _chains.getCurrencies,
	  loginAs: _auth.loginAs
	}, null, { withRef: true })(Create);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _chains = __webpack_require__(127);
	
	__webpack_require__(1372);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _Create = __webpack_require__(821);
	
	var _Create2 = _interopRequireDefault(_Create);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Chains = function (_Component) {
	  _inherits(Chains, _Component);
	
	  function Chains(props) {
	    _classCallCheck(this, Chains);
	
	    var _this = _possibleConstructorReturn(this, (Chains.__proto__ || Object.getPrototypeOf(Chains)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      chains: [],
	      search: '',
	      activeItem: {}
	    };
	    _this.getChains = _this.getChains.bind(_this);
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Chains, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getChains();
	      var valid = ['create'];
	      if (typeof this.props.params.type !== 'undefined') {
	        if (valid.indexOf(this.props.params.type) === -1) {
	          this.props.router.push('/chains');
	        }
	      }
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', ariaText: (0, _helpers.translation)('2040'), labelText: (0, _helpers.translation)(1797), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'getChains',
	    value: function getChains() {
	      var _this2 = this;
	
	      this.props.getChains().then(function (res) {
	        _this2.setState({
	          chains: res.data
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var chains = [].concat(_toConsumableArray(this.state.chains));
	      if (type === 'create') {
	        chains.push({
	          ChainId: data.Id,
	          ChainName: data.Name
	        });
	        type = 'list';
	      } else {
	        chains.map(function (val, key) {
	          if (val.ChainId === data.Id) {
	            val.Name = data.Name;
	          }
	        });
	        type = 'item';
	      }
	      this.setState({
	        chains: chains,
	        view: type
	      });
	      // Toastr
	      // window.toastr.success(translation('1830'), translation('13424'))
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      if (key.ChainName.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'renderHeaderTitle',
	    value: function renderHeaderTitle() {
	      return (0, _helpers.translation)('1700');
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.create.getWrappedInstance().addChain();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.chains.map(function (c) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: c.ChainName,
	          onClick: function onClick() {
	            return _this3.onSelectItem(c);
	          },
	          selected: c.ChainId === _this3.state.activeItem.ChainId,
	          key: c.ChainId
	        });
	      });
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'item':
	        case 'create':
	          return _react2.default.createElement(_Create2.default, { router: this.props.router, ref: 'create', item: this.state.activeItem, onSave: this.onSave, getChains: this.getChains, type: this.state.view });
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // API doesn't return an Active field for chain item, to be checked by filter
	      // using "defaultShowInactive" temporarily to show all chains
	      return _react2.default.createElement(
	        'div',
	        { className: 'settings__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: this.headerButtonsRight }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: true },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'settings__screen--inner clearfix' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Chains;
	}(_react.Component);
	
	Chains.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getChains: _chains.getChains
	})(Chains);

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	__webpack_require__(1373);
	
	var _helpers = __webpack_require__(2);
	
	var _currency = __webpack_require__(41);
	
	var _collaboratingPartners = __webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	// Utils
	
	
	// Actions
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      PartnerInvoiceSetting: {
	        PartnerInvoiceSettingId: 0,
	        CompanyId: 0,
	        DebtorNumber: '',
	        Deduction: 0,
	        IsDeleted: false,
	        Misc: 0,
	        Paint: 0,
	        PaintMaterialsEnv: 0,
	        ParentPartnerId: 0,
	        PartnerId: 0,
	        Salary: 0,
	        SalaryEnv: 0,
	        SpareParts: 0,
	        SummationKickbacks: []
	      },
	      disabledDebtorNumber: false
	    };
	
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(props) {
	      this.getCollaboratingPartnerInvoiceSetting(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.Id !== nextProps.item.Id) {
	        this.getCollaboratingPartnerInvoiceSetting(nextProps);
	      }
	    }
	  }, {
	    key: 'getCollaboratingPartnerInvoiceSetting',
	    value: function getCollaboratingPartnerInvoiceSetting(props) {
	      var _this2 = this;
	
	      var isMainPartner = props.item.Partners !== undefined;
	      var parentPartnerShopId = isMainPartner ? props.item.ShopId : props.item.ParentPartnerShopId;
	      var partnerShopId = isMainPartner ? null : props.item.PartnerShopId;
	
	      var disabledDebtorNumber = props.item.ParentPartnerShopId !== undefined;
	      var partnerInvoiceSetting = this.state.PartnerInvoiceSetting;
	      if (typeof props.item === 'undefined') return;
	      props.getCollaboratingPartnerInvoiceSetting(parentPartnerShopId, partnerShopId).then(function (res) {
	        var data = res.data;
	        partnerInvoiceSetting = _extends({}, data, {
	          Deduction: (0, _currency.formatCurrency)(data.Deduction),
	          Misc: (0, _currency.formatCurrency)(data.Misc),
	          Paint: (0, _currency.formatCurrency)(data.Paint),
	          PaintMaterialsEnv: (0, _currency.formatCurrency)(data.PaintMaterialsEnv),
	          Salary: (0, _currency.formatCurrency)(data.Salary),
	          SalaryEnv: (0, _currency.formatCurrency)(data.SalaryEnv),
	          SpareParts: (0, _currency.formatCurrency)(data.SpareParts),
	          PartnerInvoiceSettingId: data.PartnerInvoiceSettingId,
	          SummationKickbacks: data.SummationKickbacks
	        });
	        _this2.setState({
	          PartnerInvoiceSetting: partnerInvoiceSetting,
	          disabledDebtorNumber: disabledDebtorNumber
	        });
	      });
	    }
	  }, {
	    key: 'savePartnerSetting',
	    value: function savePartnerSetting() {
	      var _this3 = this;
	
	      var data = this.state.PartnerInvoiceSetting;
	      data = _extends({}, data, {
	        Salary: parseFloat((0, _currency.reverseFormatCurrency)((0, _currency.formatCurrency2)(data.Salary))),
	        SpareParts: parseFloat((0, _currency.reverseFormatCurrency)((0, _currency.formatCurrency2)(data.SpareParts))),
	        Misc: parseFloat((0, _currency.reverseFormatCurrency)((0, _currency.formatCurrency2)(data.Misc))),
	        Paint: parseFloat((0, _currency.reverseFormatCurrency)((0, _currency.formatCurrency2)(data.Paint))),
	        PaintMaterialsEnv: parseFloat((0, _currency.reverseFormatCurrency)((0, _currency.formatCurrency2)(data.PaintMaterialsEnv))),
	        SalaryEnv: parseFloat((0, _currency.reverseFormatCurrency)((0, _currency.formatCurrency2)(data.SalaryEnv))),
	        Deduction: parseFloat((0, _currency.reverseFormatCurrency)((0, _currency.formatCurrency2)(data.Deduction)))
	      });
	      this.props.createSavePartnerInvoiceSetting(data).then(function (res) {
	        var data = res.data;
	        var partnerInvoiceSetting = _this3.state.PartnerInvoiceSetting;
	        partnerInvoiceSetting = _extends({}, partnerInvoiceSetting, {
	          Deduction: (0, _currency.formatCurrency)(data.Deduction),
	          Misc: (0, _currency.formatCurrency)(data.Misc),
	          Paint: (0, _currency.formatCurrency)(data.Paint),
	          PaintMaterialsEnv: (0, _currency.formatCurrency)(data.PaintMaterialsEnv),
	          Salary: (0, _currency.formatCurrency)(data.Salary),
	          SalaryEnv: (0, _currency.formatCurrency)(data.SalaryEnv),
	          SpareParts: (0, _currency.formatCurrency)(data.SpareParts),
	          PartnerInvoiceSettingId: data.PartnerInvoiceSettingId,
	          SummationKickbacks: data.SummationKickbacks
	        });
	        _this3.setState({
	          PartnerInvoiceSetting: partnerInvoiceSetting
	        });
	        // Toastr
	        // window.toastr.success(translation('15157'), translation('13424'))
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      this.savePartnerSetting();
	    }
	  }, {
	    key: 'renderDebtorNumber',
	    value: function renderDebtorNumber() {
	      var _this4 = this;
	
	      var PartnerInvoiceSetting = this.state.PartnerInvoiceSetting;
	      var onChange = function onChange(e) {
	        PartnerInvoiceSetting[e.target.name] = e.target.value;
	        _this4.setState({
	          PartnerInvoiceSetting: PartnerInvoiceSetting
	        });
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('17907') },
	        _react2.default.createElement(_text2.default, {
	          labelText: PartnerInvoiceSetting.ParentPartnerName,
	          name: 'DebtorNumber',
	          value: PartnerInvoiceSetting.DebtorNumber || '',
	          onChange: onChange,
	          onBlur: this.onBlur,
	          disabled: this.state.disabledDebtorNumber
	        })
	      );
	    }
	  }, {
	    key: 'renderReturnCommissionWithReport',
	    value: function renderReturnCommissionWithReport(e) {
	      var _this5 = this;
	
	      var PartnerInvoiceSetting = this.state.PartnerInvoiceSetting;
	
	      var onChangeCommissionInput = function onChangeCommissionInput(e) {
	        var value = e.target.value;
	        var currentIndex = PartnerInvoiceSetting.SummationKickbacks.findIndex(function (x) {
	          return x.SummationGroupConfigId === parseInt(e.target.name);
	        });
	        var updateItem = _extends({}, PartnerInvoiceSetting.SummationKickbacks[currentIndex], {
	          Kickback: value
	        });
	        PartnerInvoiceSetting.SummationKickbacks[currentIndex] = updateItem;
	        _this5.setState({
	          PartnerInvoiceSetting: PartnerInvoiceSetting
	        });
	      };
	
	      var onAmountBlur = function onAmountBlur(e) {
	        var value = parseFloat((0, _currency.reverseFormatCurrency)((0, _currency.formatCurrency2)(e.target.value)));
	        if (isNaN(value)) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('15159'), (0, _helpers.translation)('216'));
	        } else if (value < 0 || value > 99.99) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('15158'), (0, _helpers.translation)('216'));
	        } else {
	          _this5.savePartnerSetting();
	        }
	      };
	
	      var renderField = function renderField(item) {
	        return _react2.default.createElement(
	          _grid2.default,
	          { align: 'center', spacing: 1, key: item.SummationGroupConfigId },
	          _react2.default.createElement(
	            'span',
	            null,
	            item.Text
	          ),
	          _react2.default.createElement(_text2.default, {
	            name: item.SummationGroupConfigId,
	            value: PartnerInvoiceSetting.SummationKickbacks.find(function (x) {
	              return x.SummationGroupConfigId === parseInt(item.SummationGroupConfigId);
	            }).Kickback,
	            onChange: onChangeCommissionInput,
	            onBlur: onAmountBlur,
	            size: 'm'
	          })
	        );
	      };
	
	      return PartnerInvoiceSetting.SummationKickbacks ? PartnerInvoiceSetting.SummationKickbacks.map(renderField) : null;
	    }
	  }, {
	    key: 'renderReturnCommission',
	    value: function renderReturnCommission(e) {
	      var _this6 = this;
	
	      var PartnerInvoiceSetting = this.state.PartnerInvoiceSetting;
	
	      var onChangeCommissionInput = function onChangeCommissionInput(e) {
	        var value = e.target.value;
	        PartnerInvoiceSetting[e.target.name] = value;
	        _this6.setState({
	          PartnerInvoiceSetting: PartnerInvoiceSetting
	        });
	      };
	
	      var onAmountBlur = function onAmountBlur(e) {
	        var value = parseFloat((0, _currency.reverseFormatCurrency)((0, _currency.formatCurrency2)(e.target.value)));
	        if (isNaN(value)) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('15159'), (0, _helpers.translation)('216'));
	        } else if (value < 0 || value > 99.99) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('15158'), (0, _helpers.translation)('216'));
	        } else {
	          _this6.savePartnerSetting();
	        }
	      };
	
	      var renderField = function renderField(name, label) {
	        return _react2.default.createElement(
	          _grid2.default,
	          { align: 'center', spacing: 1, key: name },
	          _react2.default.createElement(
	            'span',
	            null,
	            label
	          ),
	          _react2.default.createElement(_text2.default, {
	            name: name,
	            value: PartnerInvoiceSetting[name],
	            onChange: onChangeCommissionInput,
	            onBlur: onAmountBlur,
	            size: 'm'
	          })
	        );
	      };
	
	      return [renderField('Salary', (0, _helpers.translation)('416')), renderField('SpareParts', (0, _helpers.translation)('637')), renderField('Misc', (0, _helpers.translation)('15154')), renderField('Paint', (0, _helpers.translation)('660')), renderField('PaintMaterialsEnv', (0, _helpers.translation)('15155')), renderField('SalaryEnv', (0, _helpers.translation)('15156')), renderField('Deduction', (0, _helpers.translation)('15214'))];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      /*  Old hardcoded kickback rates:
	            <Col span='3'>
	              <Panel title={translation('17914').replace('[CompanyName]', this.state.PartnerInvoiceSetting.ParentPartnerName)} helpText={translation('15036')}>
	                <Grid align='center' spacing={1}>
	                  <span>{translation('70')}</span>
	                  <span>{translation('14904')}</span>
	                </Grid>
	                {this.renderReturnCommission()}
	              </Panel>
	            </Col>
	        */
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderDebtorNumber()
	          )
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            { span: '3' },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('18384').replace('[CompanyName]', this.state.PartnerInvoiceSetting.ParentPartnerName), helpText: (0, _helpers.translation)('15036') },
	              _react2.default.createElement(
	                _grid2.default,
	                { align: 'center', spacing: 1 },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)('70')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)('14904')
	                )
	              ),
	              this.renderReturnCommissionWithReport()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getCollaboratingPartnerInvoiceSetting: _collaboratingPartners.getCollaboratingPartnerInvoiceSetting,
	  createSavePartnerInvoiceSetting: _collaboratingPartners.createSavePartnerInvoiceSetting
	}, null, { withRef: true })(View);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _collaboratingPartners = __webpack_require__(404);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _View = __webpack_require__(823);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	// import components
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var CollaboratintPartners = function (_Component) {
	  _inherits(CollaboratintPartners, _Component);
	
	  function CollaboratintPartners(props) {
	    _classCallCheck(this, CollaboratintPartners);
	
	    var _this = _possibleConstructorReturn(this, (CollaboratintPartners.__proto__ || Object.getPrototypeOf(CollaboratintPartners)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      activeItem: {},
	      partnerList: []
	    };
	
	    _this.renderList = _this.renderList.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    return _this;
	  }
	
	  _createClass(CollaboratintPartners, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCollaboratingPartners();
	    }
	  }, {
	    key: 'getCollaboratingPartners',
	    value: function getCollaboratingPartners() {
	      var _this2 = this;
	
	      this.props.getCollaboratingPartners().then(function (res) {
	        _this2.setState({
	          partnerList: res.data
	        });
	      });
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item, key) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList() {
	      var _this3 = this;
	
	      var renderPartnerListPartners = function renderPartnerListPartners(partner, key) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: partner.PartnerShopName,
	          onClick: function onClick() {
	            return _this3.onSelectItem(partner);
	          },
	          selected: partner.Id === _this3.state.activeItem.Id,
	          key: partner.Id
	        });
	      };
	
	      return [].concat(_toConsumableArray(this.state.partnerList.map(function (partner) {
	        return _react2.default.createElement(
	          'div',
	          { key: partner.Id },
	          _react2.default.createElement(_sideMenuItem2.default, {
	            label: partner.ShopName,
	            onClick: function onClick() {
	              return _this3.onSelectItem(partner);
	            },
	            selected: partner.Id === _this3.state.activeItem.Id,
	            key: partner.Id,
	            isTitle: true
	          }),
	          partner.Partners.map(renderPartnerListPartners)
	        );
	      })));
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'item':
	          {
	            return _react2.default.createElement(_View2.default, { ref: 'view', item: this.state.activeItem, parentName: this.state.parentPartnerShopName });
	          }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'collaboratingPartner__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: false, hideInactiveCheck: true },
	          this.renderList()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'collaboratingPartner__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return CollaboratintPartners;
	}(_react.Component);
	
	CollaboratintPartners.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { hasSubscriptionPermission: _auth.hasSubscriptionPermission, getCollaboratingPartners: _collaboratingPartners.getCollaboratingPartners })(CollaboratintPartners);

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _backdrop = __webpack_require__(29);
	
	var _priceModelConflict = __webpack_require__(410);
	
	var _agreement = __webpack_require__(401);
	
	var _customerWP = __webpack_require__(406);
	
	var _auth = __webpack_require__(68);
	
	var _helpers = __webpack_require__(2);
	
	var _DealerSettings = __webpack_require__(1024);
	
	var _DealerSettings2 = _interopRequireDefault(_DealerSettings);
	
	__webpack_require__(1374);
	
	__webpack_require__(513);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	// Styles
	
	
	// Elements
	
	// import LabelWrapper from '../../../shared/elements/labelWrapper'
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'view',
	      customersList: [],
	      companyAgreements: [{
	        agreementsList: [],
	        addonList: [],
	        complaintList: [],
	        insuranceList: [],
	        otherList: [],
	        privateList: [],
	        salescarList: [],
	        warrantyList: [],
	        companyName: ''
	      }],
	      customerContactsList: [],
	      selectedDealer: {},
	      customerGroups: []
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.renderItem = _this.renderItem.bind(_this);
	    _this.getConflictsCustomer = _this.getConflictsCustomer.bind(_this);
	    _this.saveConflict = _this.saveConflict.bind(_this);
	    _this.renderAgreements = _this.renderAgreements.bind(_this);
	    _this.getCustomerAgreements = _this.getCustomerAgreements.bind(_this);
	    _this.getCustomerContactsInfo = _this.getCustomerContactsInfo.bind(_this);
	    _this.renderCompanyAgreements = _this.renderCompanyAgreements.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getConflictsCustomer();
	    }
	  }, {
	    key: 'getConflictsCustomer',
	    value: function getConflictsCustomer(customerId) {
	      var _this2 = this;
	
	      if (customerId === undefined) {
	        customerId = this.props.item.CustomerId;
	      }
	      if (Number(customerId) !== Number(-1)) {
	        this.props.getPriceModelConflictsCustomer(customerId).then(function (res) {
	          _this2.setState({
	            customersList: res.data
	          });
	        });
	        this.getCustomerAgreements(customerId);
	        this.getCustomerContactsInfo(customerId);
	      }
	    }
	  }, {
	    key: 'loginAs',
	    value: function loginAs(id) {
	      var _this3 = this;
	
	      this.props.loginAs(id).then(function (res) {
	        _this3.props.router.push(res.data.StartScreen !== null ? res.data.StartScreen : '/orders/');
	      });
	    }
	  }, {
	    key: 'getCustomerAgreements',
	    value: function getCustomerAgreements(customerId) {
	      var _this4 = this;
	
	      this.props.getCustomerAgrements(customerId).then(function (res) {
	        var details = res.data;
	        var companyAgreements = [];
	        for (var i = 0; i < details.CompanyAgreements.length; i++) {
	          var detail = details.CompanyAgreements[i];
	          var addon = [];
	          var complaint = [];
	          var insurance = [];
	          var other = [];
	          var privates = [];
	          var salescar = [];
	          var warranty = [];
	          for (var a = 0; a < detail.AgreementsList.length; a++) {
	            var item = detail.AgreementsList[a];
	            switch (item.PriceType) {
	              case 0:
	                // Other
	                other.push(item);
	                break;
	              case 1:
	                // Salescar
	                salescar.push(item);
	                break;
	              case 2:
	                // Private
	                privates.push(item);
	                break;
	              case 3:
	                // Warranty
	                warranty.push(item);
	                break;
	              case 5:
	                // Estimation
	                insurance.push(item);
	                break;
	              case 6:
	                // Complaint
	                complaint.push(item);
	                break;
	              case 8:
	                addon.push(item);
	                break;
	            }
	          }
	          companyAgreements.push({
	            agreementsList: detail.AgreementsList,
	            companyName: detail.CompanyName,
	            addonList: addon,
	            complaintList: complaint,
	            insuranceList: insurance,
	            otherList: other,
	            privateList: privates,
	            salescarList: salescar,
	            warrantyList: warranty
	          });
	        }
	        _this4.setState({
	          companyAgreements: companyAgreements,
	          customerGroups: details.CustomerGroups
	        });
	      });
	    }
	  }, {
	    key: 'getCustomerContactsInfo',
	    value: function getCustomerContactsInfo(customerId) {
	      var _this5 = this;
	
	      this.props.getCustomerContactsInfo(customerId).then(function (res) {
	        var customer = res.data.Customer;
	        if (customer.CustomerId === 0) customer.CustomerId = customerId;
	        _this5.setState({
	          customerContactsList: res.data.Contacts,
	          selectedDealer: customer
	        });
	      });
	    }
	  }, {
	    key: 'saveConflict',
	    value: function saveConflict(data) {
	      var _this6 = this;
	
	      this.props.updatePriceModelConflicts(data).then(function (res) {
	        _this6.setState({
	          customersList: res.data
	        }, function () {
	          _this6.props.getConflictList();
	          // window.toastr.success(translation('13027'), translation('13424'))
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('13028'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this7 = this;
	
	      if (this.props.item.CustomerId !== nextProps.item.CustomerId) {
	        this.setState({
	          customersList: [],
	          companyAgreements: [],
	          customerContactsList: [],
	          selectedDealer: {},
	          customerGroups: []
	        }, function () {
	          _this7.getConflictsCustomer(nextProps.item.CustomerId);
	        });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this8 = this;
	
	      e.persist();
	      var value = parseInt(e.target.value);
	      var conflictName = parseInt(e.target.name);
	      var customersList = [].concat(_toConsumableArray(this.state.customersList));
	
	      var _loop = function _loop() {
	        var item = customersList[i];
	        if (item.PriceModelConflictId === conflictName) {
	          item.ResolvedToPriceModelId = value;
	          customersList[i] = item;
	          _this8.setState({
	            customersList: customersList
	          }, function () {
	            _this8.saveConflict(item);
	          });
	        }
	      };
	
	      for (var i = 0; i < customersList.length; i++) {
	        _loop();
	      }
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(val, key) {
	      var _this9 = this;
	
	      var conflictId = val.PriceModelConflictId;
	      var resolvedId = val.ResolvedToPriceModelId;
	      var renderConflictModel = function renderConflictModel(val, key) {
	        var inputId = 'ResolvedToPriceModelId_' + conflictId + '_' + val.PriceModelId;
	        var labelText = val.CustomerGroupName + ', ' + val.Name;
	        var radioClassName = '';
	        if (val.PriceModelId === 0) {
	          labelText = (0, _helpers.translation)('433') + ' ' + val.Name;
	        }
	        if (val.Active === false) {
	          radioClassName += ' inactive'; // background: #eaeaea;
	        }
	        var hasBrand = val.Brand !== null && val.Brand !== '';
	        var brandName = '(' + val.Brand + ')';
	        return _react2.default.createElement(
	          'div',
	          { key: key, className: radioClassName },
	          _react2.default.createElement(_radio2.default, { labelText: labelText, id: inputId, name: conflictId, value: val.PriceModelId, onChange: _this9.onChange, checked: val.PriceModelId === resolvedId }),
	          hasBrand && _react2.default.createElement(
	            'span',
	            null,
	            brandName
	          )
	        );
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { key: key, title: (0, _helpers.translation)(val.PriceTypeName) + ', ' + val.CompanyName },
	        val.PriceModels.map(renderConflictModel)
	      );
	    }
	  }, {
	    key: 'renderAgreements',
	    value: function renderAgreements(agreement, key) {
	      var renderType = function renderType(list, name) {
	        if (list === undefined || list.length === 0) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'agreements' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)(name)
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          list.map(renderAgreement)
	        );
	      };
	      var renderAgreement = function renderAgreement(val, key) {
	        var labelText = val.CustomerGroupName + ', ' + val.Name;
	        var className = 'spacing ';
	        if (val.Active === false) {
	          className += 'inactive'; // background: #eaeaea;
	        }
	        if (val.PriceModelId === 0) {
	          labelText = (0, _helpers.translation)('433') + ' ' + val.Name;
	        }
	        var hasBrand = val.Brand !== null && val.Brand !== '';
	        var brandName = '(' + val.Brand + ')';
	        return _react2.default.createElement(
	          'div',
	          { className: className, key: key },
	          _react2.default.createElement(
	            'span',
	            null,
	            labelText
	          ),
	          hasBrand && _react2.default.createElement(
	            'div',
	            null,
	            brandName
	          )
	        );
	      };
	
	      var title = (0, _helpers.translation)('1738') + ', ' + agreement.companyName;
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: title },
	        renderType(agreement.addonList, '1396'),
	        renderType(agreement.complaintList, '301'),
	        renderType(agreement.insuranceList, '13360'),
	        renderType(agreement.otherList, '73'),
	        renderType(agreement.privateList, '785'),
	        renderType(agreement.salescarList, '71'),
	        renderType(agreement.warrantyList, '13361')
	      );
	    }
	  }, {
	    key: 'renderCompanyAgreements',
	    value: function renderCompanyAgreements() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.companyAgreements.map(this.renderAgreements)
	      );
	    }
	  }, {
	    key: 'renderDealerInfos',
	    value: function renderDealerInfos() {
	      var _this10 = this;
	
	      var renderDealerContacts = function renderDealerContacts(val, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              val.UserName
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1052'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              val.Email
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('345'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              val.Phone
	            )
	          ),
	          _react2.default.createElement(_button2.default, { size: 'm', style: 'link', onClick: _this10.loginAs.bind(_this10, val.UserId), labelText: (0, _helpers.translation)('57') }),
	          _react2.default.createElement(_divider2.default, null)
	        );
	      };
	      var renderDealerCustomerGroupInfo = function renderDealerCustomerGroupInfo(val, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          val.Name
	        );
	      };
	      var renderDealerInfo = function renderDealerInfo(data) {
	        if (data === null || data === undefined || data.CustomerId === 0) return;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('30'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.CompanyName
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('25'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.CompanyAddress + ', ' + data.CompanyZipCode + ' ' + data.CompanyCity
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('41'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.CompanyCVR
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('38'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.CompanyPhoneNumber
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('93'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.Notes
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('13660'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.ShopName
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: this.state.selectedDealer.CompanyName },
	        _react2.default.createElement(
	          'h3',
	          null,
	          (0, _helpers.translation)('13600')
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        renderDealerInfo(this.state.selectedDealer),
	        _react2.default.createElement(
	          'h3',
	          null,
	          (0, _helpers.translation)('12308')
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        this.state.customerGroups.map(renderDealerCustomerGroupInfo),
	        _react2.default.createElement(
	          'h3',
	          null,
	          (0, _helpers.translation)('13601')
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        this.state.customerContactsList !== undefined ? this.state.customerContactsList.map(renderDealerContacts) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // let classNameList = '' // (this.state.type === 'edit') ? 'view_edit' : 'view_create'
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.state.customersList.map(this.renderItem),
	          this.renderCompanyAgreements()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(_DealerSettings2.default, { CustomerId: this.state.selectedDealer.CustomerId }),
	          this.renderDealerInfos()
	        )
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceModelConflictsCustomer: _priceModelConflict.getPriceModelConflictsCustomer,
	  updatePriceModelConflicts: _priceModelConflict.updatePriceModelConflicts,
	  getCustomerAgrements: _agreement.getCustomerAgrements,
	  getCustomerContactsInfo: _customerWP.getCustomerContactsInfo,
	  triggerPopup: _backdrop.triggerPopup,
	  loginAs: _auth.loginAs
	}, null, { withRef: true })(View);

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _priceModelConflict = __webpack_require__(410);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(513);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _customerGroup = __webpack_require__(107);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _View = __webpack_require__(825);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _auth = __webpack_require__(8);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	// Utils
	
	
	var Conflicts = function (_Component) {
	  _inherits(Conflicts, _Component);
	
	  function Conflicts(props) {
	    _classCallCheck(this, Conflicts);
	
	    var _this = _possibleConstructorReturn(this, (Conflicts.__proto__ || Object.getPrototypeOf(Conflicts)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      search: '',
	      activeItem: {},
	      conflictsList: [],
	      isUpdating: false,
	      onlyUnsolved: true,
	      customergroups: [],
	      selectedcustomergroup: -1
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.leftMenu = _this.leftMenu.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.getConflictList = _this.getConflictList.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.getCustomerGroups = _this.getCustomerGroups.bind(_this);
	    return _this;
	  }
	
	  _createClass(Conflicts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getConflictList();
	      this.getCustomerGroups();
	      // this.getCustomerGroups()
	      // this.getShops()
	      if (typeof this.props.router.params.customerId !== 'undefined') {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            CustomerId: parseInt(this.props.router.params.customerId)
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getConflictList',
	    value: function getConflictList() {
	      var _this2 = this;
	
	      var workProviderId = this.props.auth.user.WorkProviderId;
	      this.props.getPriceModelConflicts(workProviderId).then(function (res) {
	        _this2.setState({
	          conflictsList: res.data,
	          activeItem: _this2.state.activeItem
	        });
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      this.props.router.replace('/conflicts/' + activeItem.CustomerId);
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({
	          search: e.target.value
	        });
	      }
	      if (e.target.name === 'Unsolved') {
	        this.setState({
	          onlyUnsolved: e.target.checked
	        });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      var customerGroupIds = key.CustomerGroupIds;
	      var selectedGroupId = Number(this.state.selectedcustomergroup);
	      if (selectedGroupId !== -1 && customerGroupIds.findIndex(function (val) {
	        return val === selectedGroupId;
	      }) === -1) return false;
	      if (key.CustomerName.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (this.state.onlyUnsolved ? key.HasUnsolved : true)) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'getCustomerGroups',
	    value: function getCustomerGroups() {
	      var _this3 = this;
	
	      if (!(0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return;
	      this.props.getCustomerGroups().then(function (res) {
	        var customergroups = res.data;
	        _this3.setState({
	          customergroups: customergroups
	        });
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var name = e.target.name;
	      if (name === 'customergroup_customergroupid') {
	        var valu = e.target.value;
	        if (valu === '-1') {
	          this.setState({
	            selectedcustomergroup: -1
	          }, function () {
	            // console.log(valu, this.state)
	          });
	        } else {
	          // let id = this.state.customergroups.find((val) => Number(val.CustomerGroupId) === Number(valu)).Name
	          this.setState({
	            selectedcustomergroup: valu
	          }, function () {
	            // console.log(valu, id, this.state)
	          });
	        }
	      }
	    }
	  }, {
	    key: 'leftMenu',
	    value: function leftMenu() {
	      var _this4 = this;
	
	      // Render item
	      var renderItem = function renderItem(val, key) {
	        if (val === null || val.CustomerId === undefined) return;
	        // Classname
	        var isSelected = false;
	        if ((0, _lodash.isEqual)(val.CustomerId, _this4.state.activeItem.CustomerId)) {
	          isSelected = true;
	        }
	
	        // On select
	        var selectItem = function selectItem() {
	          _this4.setState({
	            view: 'item',
	            activeItem: val
	          }, function () {
	            _this4.changeView('edit');
	          });
	          _events2.default.emit('sidebar_trigger', false);
	        };
	
	        // Return
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: val.CustomerName,
	          onClick: selectItem,
	          selected: isSelected,
	          key: key
	        });
	      };
	
	      var renderCustomerGroups = function renderCustomerGroups() {
	        var customergroups = _this4.state.customergroups;
	
	        var renderGroup = function renderGroup(group, key) {
	          return _react2.default.createElement(
	            'option',
	            { value: group.CustomerGroupId, key: key },
	            group.Name
	          );
	        };
	
	        return customergroups !== null && customergroups.length > 0 && customergroups.map(renderGroup);
	      };
	
	      // Return
	      return [_react2.default.createElement(
	        'div',
	        { key: 'filter' },
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          null,
	          _react2.default.createElement(_text2.default, {
	            name: 'SearchText',
	            value: this.state.search,
	            onChange: this.searchList
	          })
	        ),
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          null,
	          _react2.default.createElement(
	            _dropDown2.default,
	            {
	              name: 'customergroup_customergroupid',
	              value: this.state.selectedcustomergroup,
	              onChange: this.onChange
	            },
	            _react2.default.createElement(
	              'option',
	              { value: '-1' },
	              (0, _helpers.translation)('12310')
	            ),
	            renderCustomerGroups()
	          )
	        ),
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          null,
	          _react2.default.createElement(_check2.default, {
	            name: 'Unsolved',
	            checked: this.state.onlyUnsolved === true,
	            onChange: this.searchList,
	            labelText: (0, _helpers.translation)('13029'),
	            spacing: 0
	          })
	        )
	      )].concat(_toConsumableArray(this.state.conflictsList.filter(this.filterList).map(renderItem)));
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var conflictsList = [].concat(_toConsumableArray(this.state.conflictsList));
	      var activeItem = this.state.activeItem;
	      conflictsList.map(function (val, key) {
	        if (val.CustomerId === data.CustomerId) {
	          val.CustomerName = data.CustomerName;
	        }
	      });
	      type = 'item';
	
	      this.setState({
	        conflictsList: conflictsList,
	        view: type,
	        activeItem: activeItem
	      });
	      // Toastr
	      // window.toastr.success(translation('13464'), translation('13424'))
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'item':
	          return _react2.default.createElement(_View2.default, { router: this.props.router, ref: 'view', item: this.state.activeItem, getConflictList: this.getConflictList, onSave: this.onSave });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'priceconflicts__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, title: (0, _helpers.translation)('12304'), icon: 'menu/Partners-White.png' }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { disableFilter: true },
	          this.leftMenu()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'priceconflicts__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Conflicts;
	}(_react.Component);
	
	Conflicts.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceModelConflicts: _priceModelConflict.getPriceModelConflicts,
	  updatePriceModelConflicts: _priceModelConflict.updatePriceModelConflicts,
	  getCustomerGroups: _customerGroup.getCustomerGroups,
	  hasAccess: _auth.hasAccess
	})(Conflicts);

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _customerGroupContact = __webpack_require__(405);
	
	__webpack_require__(1375);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	// import { loginAs } from '../../../../actions/auth'
	
	// import styles
	
	
	// Components
	
	// import HelpText from '../../../../shared/components/HelpText'
	
	// Elements
	
	
	// Utils
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      contact: {
	        UserId: null,
	        UserName: '',
	        Name: '',
	        Email: '',
	        EmailIsValid: false,
	        Phone: '',
	        PhoneCode: _this.props.phonecode,
	        PhoneIsValid: false,
	        CustomerGroupId: props.customerGroupId,
	        ChainId: props.chainId,
	        Active: false
	      }
	      // console.log('constructor props', props)
	    };_this.onInputChange = _this.onInputChange.bind(_this);
	    _this.saveAddContact = _this.saveAddContact.bind(_this);
	    _this.addContact = _this.addContact.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomerGroupContact(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.UserId !== nextProps.item.UserId) {
	        this.getCustomerGroupContact(nextProps);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      var value = e.target.value;
	
	      if (e.target.type === 'radio') {
	        value = e.target.value === 'yes';
	      }
	      if (e.target.name === 'Active') {
	        value = e.target.checked;
	      }
	      this.setState({
	        type: 'edit',
	        contact: _extends({}, this.state.contact, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'radio' || e.target.name === 'Active') {
	          _this2.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this3 = this;
	
	      if (this.state.contact.UserId !== undefined && this.state.contact.UserId !== null && this.state.contact.UserId !== 0) {
	        this.setState({ type: 'edit' }, function () {
	          _this3.saveAddContact();
	        });
	      }
	    }
	  }, {
	    key: 'getCustomerGroupContact',
	    value: function getCustomerGroupContact(props) {
	      var _this4 = this;
	
	      if (props.item.UserId !== undefined && props.item.UserId !== null && props.item.UserId !== 0) {
	        props.getCustomerGroupContact(props.item.UserId).then(function (res) {
	          var contact = res.data;
	          _this4.setState({
	            type: 'edit',
	            contact: contact
	          });
	        }, function () {
	          _this4.props.onError();
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        contact: {
	          UserId: null,
	          Phone: '',
	          PhoneCode: this.props.phonecode,
	          PhoneIsValid: false,
	          Active: false,
	          UserName: '',
	          Name: '',
	          Email: '',
	          CustomerGroupId: this.props.customerGroupId,
	          ChainId: this.props.chainId,
	          EmailIsValid: false
	        }
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this5 = this;
	
	      var value = e.target.value;
	      var name = e.target.name;
	      if (name === 'PhoneNumber') {
	        name = 'Phone';
	        this.setState({
	          contact: _extends({}, this.state.contact, _defineProperty({}, name, value))
	        });
	      } else {
	        this.setState({
	          contact: _extends({}, this.state.contact, {
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        }, function () {
	          _this5.onBlur();
	        });
	      }
	    }
	
	    // sendNewPassword (e) {
	    //   e.preventDefault()
	    //   if (!this.state.contact.EmailIsValid) {
	    //     window.toastr.error(translation('Email is required to send password @'), translation('216'))
	    //   } else {
	    //     let data = {
	    //       UserId: this.state.contact.UserId
	    //     }
	    //     this.props.sendPassword(data).then((res) => {
	    //       // window.toastr.success(translation('Contact password has been sent @'), translation('13424'))
	    //     }, () => {
	    //       window.toastr.error(translation('Failed to send contact password @'), translation('216'))
	    //     })
	    //   }
	    // }
	
	    /*  User name
	              <div className='control__group'>
	                <label>{translation('1')}</label>
	                <input type='text' name='UserName' value={contact.UserName || ''} onChange={this.onChange} />
	              </div>
	    */
	
	    /*  Send password
	              <div>
	                {this.state.contact.UserId !== 0 && typeof this.state.contact.UserId !== 'undefined' && (
	                  <div className='control__group'>
	                    <label>{translation('2')} <HelpText text={translation('Help text @')} /></label>
	                    <button className='button full primary half' style={{ marginTop: 0 }} onClick={this.sendNewPassword} disabled='true'>{translation('Send password @')}</button>
	                  </div>
	                )}
	              </div>
	    */
	
	  }, {
	    key: 'renderContact',
	    value: function renderContact() {
	      var contact = this.state.contact;
	
	      if (contact === null) return null;
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('346') },
	        _react2.default.createElement(_text2.default, { name: 'Name', value: contact.Name || '', onChange: this.onChange, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_text2.default, { name: 'UserName', value: contact.UserName || '', onChange: this.onChange, labelText: (0, _helpers.translation)('1') }),
	        _react2.default.createElement(_text2.default, { name: 'Email', value: contact.Email || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('1052') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('345') },
	          _react2.default.createElement(_Phone2.default, {
	            onChange: this.onInputChange,
	            onBlur: this.onBlur,
	            code: contact.PhoneCode,
	            number: contact.Phone })
	        ),
	        _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onChange, checked: contact.Active, disabled: true, labelText: (0, _helpers.translation)('295') })
	      );
	    }
	  }, {
	    key: 'addContact',
	    value: function addContact() {
	      var _this6 = this;
	
	      this.setState({ type: 'create' }, function () {
	        _this6.props.createSaveCustomerGroupContact(_this6.state.contact).then(function (res) {
	          _this6.props.onSave(res.data, _this6.state.type);
	        }, function (err) {
	          // Toastr
	          // console.log('err', err.response.data.Errors)
	          if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	            var errors = err.response.data.Errors;
	            var errText = '';
	            for (var i = 0; i < errors.length; i++) {
	              var dictKey = errors[i].DictionaryKey;
	              errText += '<br/>' + (0, _helpers.translation)(dictKey);
	            }
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('13463'), (0, _helpers.translation)('216'));
	          }
	          // Toastr
	          // window.toastr.error(translation('13463'), translation('216'))
	        });
	      });
	    }
	  }, {
	    key: 'saveAddContact',
	    value: function saveAddContact() {
	      var _this7 = this;
	
	      this.props.createSaveCustomerGroupContact(this.state.contact).then(function (res) {
	        _this7.props.onSave(res.data, _this7.state.type);
	        _this7.setState({
	          contact: res.data
	        });
	      }, function (err) {
	        // Toastr
	        // console.log('err', err.response.data.Errors)
	        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	          var errors = err.response.data.Errors;
	          var errText = '';
	          for (var i = 0; i < errors.length; i++) {
	            var dictKey = errors[i].DictionaryKey;
	            errText += '<br/>' + (0, _helpers.translation)(dictKey);
	          }
	          window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('13463'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasAccess)([2], this.props.auth.user.UserType)) return null;
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        this.renderContact()
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createSaveCustomerGroupContact: _customerGroupContact.createSaveCustomerGroupContact,
	  getCustomerGroupContact: _customerGroupContact.getCustomerGroupContact
	}, null, { withRef: true })(View);

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _customerGroup = __webpack_require__(107);
	
	var _customerGroupContact = __webpack_require__(405);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _View = __webpack_require__(827);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import components
	
	// import LeftMenu from '../../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var CustomerGroupContacts = function (_Component) {
	  _inherits(CustomerGroupContacts, _Component);
	
	  function CustomerGroupContacts(props) {
	    _classCallCheck(this, CustomerGroupContacts);
	
	    var _this = _possibleConstructorReturn(this, (CustomerGroupContacts.__proto__ || Object.getPrototypeOf(CustomerGroupContacts)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      activeItem: {},
	      contacts: [],
	      customerGroupName: '',
	      customerGroupId: 0,
	      chainId: 0
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onViewFail = _this.onViewFail.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomerGroupContacts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomerGroup(this.props);
	      this.getCustomerGroupContacts();
	      if (typeof this.props.params.contactID !== 'undefined') {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            UserId: this.props.params.contactID
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getCustomerGroup',
	    value: function getCustomerGroup(props) {
	      var _this2 = this;
	
	      if (typeof props.params.customerGroupID !== 'undefined') {
	        props.getCustomerGroup(props.params.customerGroupID).then(function (res) {
	          _this2.setState({
	            customerGroupName: res.data.Name,
	            customerGroupId: res.data.CustomerGroupId,
	            chainId: props.auth.user.ChainId
	          });
	        }, function (err) {
	          if (err.response.status === 401) {
	            _this2.props.router.replace('/orders');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getCustomerGroupContacts',
	    value: function getCustomerGroupContacts() {
	      var _this3 = this;
	
	      return this.props.getCustomerGroupContacts(this.props.params.customerGroupID).then(function (res) {
	        _this3.setState({
	          contacts: res.data
	        });
	        if (res.data.length === 0) {
	          _this3.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	      this.props.router.replace('/customergroups/' + this.props.params.customerGroupID + '/contacts');
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) && this.state.contacts.length < 2) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('2079'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this4 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this4.refs.view.getWrappedInstance().addContact();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.contacts.map(function (c) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: c.Name,
	          onClick: function onClick() {
	            return _this4.onSelectItem(c);
	          },
	          selected: c.UserId === _this4.state.activeItem.UserId,
	          inactive: !c.Active,
	          key: c.UserId
	        });
	      });
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      this.props.router.replace('/customergroups/' + this.props.params.customerGroupID + '/contacts');
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      // console.log('Contacts onSave ', this.state, this.props, data, type)
	      var contacts = [].concat(_toConsumableArray(this.state.contacts));
	      if (type === 'create') {
	        contacts.push({
	          Name: data.Name,
	          UserId: data.UserId,
	          ChainId: this.props.chainId,
	          CustomerGroupId: this.props.customerGroupId
	        });
	        type = 'list';
	      } else {
	        contacts.map(function (val, key) {
	          if (val.UserId === data.UserId) {
	            val.Name = data.Name;
	          }
	        });
	        type = 'item';
	      }
	      this.setState({
	        contacts: contacts,
	        view: type,
	        chainId: this.props.chainId,
	        customerGroupId: this.props.customerGroupId
	      });
	      // Toastr
	      // window.toastr.success(translation('13462'), translation('13424'))
	    }
	  }, {
	    key: 'onViewFail',
	    value: function onViewFail() {
	      this.setState({
	        view: 'list',
	        activeItem: {}
	      });
	      this.props.router.replace('/customergroups/' + this.props.params.customerGroupID + '/contacts');
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var chainId = this.props.auth.user.ChainId;
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { ref: 'view', item: this.state.activeItem, onSave: this.onSave, chainId: chainId, customerGroupId: this.props.params.customerGroupID, onError: this.onViewFail });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var headerButtonsGoBack = void 0;
	      headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	        var goBack = function goBack() {
	          _this5.props.router.replace({
	            pathname: '/customergroups/' + _this5.props.params.customerGroupID
	          });
	        };
	        return _react2.default.createElement(_closeButton2.default, { ariaText: t('2060'), onClick: goBack });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'customergroup_contacts__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, title: (0, _helpers.translation)('13460') + ' - ' + this.state.customerGroupName, renderRight: this.headerButtonsRight, icon: 'menu/Customers-White.png', showBack: true, headerButtonsGoBack: headerButtonsGoBack }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create' },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'customergroup_contacts__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return CustomerGroupContacts;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getCustomerGroupContacts: _customerGroupContact.getCustomerGroupContacts, getCustomerGroup: _customerGroup.getCustomerGroup })(CustomerGroupContacts);

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _customerGroup = __webpack_require__(107);
	
	var _customers = __webpack_require__(74);
	
	var _backdrop = __webpack_require__(29);
	
	var _customerWP = __webpack_require__(406);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _icons = __webpack_require__(6);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text2 = __webpack_require__(12);
	
	var _text3 = _interopRequireDefault(_text2);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	__webpack_require__(1376);
	
	__webpack_require__(514);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	// import HelpText from '../../../shared/components/HelpText'
	
	
	// Elements
	
	
	// Styles
	
	
	// Utils
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      customergroup: {
	        CustomerGroupId: 0,
	        Active: true,
	        Name: '',
	        Comment: '',
	        CustomerGroupContacts: {},
	        CustomerGroupCustomers: {}
	      },
	      customersList: [],
	      selectedCustomers: [],
	      selectedShopId: -1,
	      selectedCustomerId: -1,
	      confirmSelect: {
	        open: false,
	        customerId: -1,
	        customerGroup: ''
	      },
	      dealerExpand: false,
	      selectedDealer: {
	        CustomerId: 0,
	        Name: ''
	      },
	      orderBy: {
	        nameDesc: false,
	        zipDesc: true,
	        zipImg: _react2.default.createElement('img', null),
	        nameImg: _react2.default.createElement('img', { style: { width: '15px', transform: 'rotate(180deg)', marginLeft: '7px' }, src: '/images/svgs/Arrow_up-down.svg' })
	      }
	    };
	    _this.saveAddCustomerGroup = _this.saveAddCustomerGroup.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.renderBasic = _this.renderBasic.bind(_this);
	    _this.renderContacts = _this.renderContacts.bind(_this);
	    _this.renderCustomerSelection = _this.renderCustomerSelection.bind(_this);
	    _this.renderCustomersList = _this.renderCustomersList.bind(_this);
	    _this.onSelectCustomer = _this.onSelectCustomer.bind(_this);
	    _this.addCustomerGroupCustomers = _this.addCustomerGroupCustomers.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomerGroup(this.props);
	      this.getShopCustomers();
	    }
	  }, {
	    key: 'getShopCustomers',
	    value: function getShopCustomers() {
	      var _this2 = this;
	
	      var shopId = this.state.selectedShopId;
	      if (Number(shopId) !== Number(-1)) {
	        this.props.getShopCustomers(shopId).then(function (res) {
	          _this2.setState({
	            customersList: res.data
	          });
	        });
	      } else {
	        this.setState({
	          customersList: []
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.CustomerGroupId !== nextProps.item.CustomerGroupId) {
	        this.getCustomerGroup(nextProps);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this3 = this;
	
	      e.persist();
	      var value = e.target.value;
	
	      if (e.target.type === 'radio') {
	        value = e.target.value === 'yes';
	      }
	      if (e.target.name === 'DimentionNumber') {
	        if (isNaN(value)) {
	          value = parseInt(this.state.customergroup.DimentionNumber);
	        } else {
	          value = parseInt(value);
	        }
	      }
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      this.setState({
	        type: this.state.type,
	        customergroup: _extends({}, this.state.customergroup, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'radio' || e.target.type === 'checkbox') {
	          _this3.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(name, e) {
	      var _this4 = this;
	
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (typeof e === 'undefined') {
	          e = name;
	        }
	        name = e.target.name;
	        value = e.target.value;
	        if (e.target.type === 'radio') {
	          value = e.target.value === 'yes';
	        }
	      }
	      // console.log('e.target.value ', e.target.value, value, e.target.name)
	      if (e.target.name === 'selectedShopId') {
	        this.setState({
	          selectedShopId: value,
	          selectedCustomers: []
	        }, function () {
	          // console.log('this.state.selectedShopId after onChange ', this.state.selectedShopId)
	          _this4.getShopCustomers();
	        });
	      } else {
	        this.setState({
	          customergroup: _extends({}, this.state.customergroup, _defineProperty({}, name, value))
	        });
	      }
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect(customer) {
	      this.setState({
	        confirmSelect: {
	          open: true,
	          customerId: customer.CustomerId,
	          customerGroup: customer.CustomerGroupName
	        }
	      });
	    }
	  }, {
	    key: 'onSelectCustomer',
	    value: function onSelectCustomer(e) {
	      var value = Number(e.target.value);
	      var selectedCustomers = [].concat(_toConsumableArray(this.state.selectedCustomers));
	      if (selectedCustomers.includes(value)) {
	        selectedCustomers = selectedCustomers.filter(function (el) {
	          return Number(el) !== value;
	        });
	      } else {
	        var cust = this.state.customersList.filter(function (eg) {
	          return Number(eg.CustomerId) === value;
	        })[0];
	        if (cust.CustomerGroupId > 0) {
	          this.onSelect(cust);
	        } else {
	          selectedCustomers.push(value);
	        }
	      }
	      this.setState({
	        selectedCustomers: selectedCustomers
	      });
	    }
	  }, {
	    key: 'onRemoveCustomer',
	    value: function onRemoveCustomer(key, companyId) {
	      var _this5 = this;
	
	      var data = {
	        CustomerId: key,
	        CompanyId: companyId,
	        CustomerGroupId: this.props.item.CustomerGroupId
	      };
	      this.props.removeCustomerGroupCustomer(data).then(function (res) {
	        _this5.getCustomerGroup(_this5.props);
	        // window.toastr.success(translation('13031'), translation('13424'))
	      }, function (err) {
	        // Toastr
	        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	          var errors = err.response.data.Errors;
	          var errText = '';
	          for (var i = 0; i < errors.length; i++) {
	            var dictKey = errors[i].DictionaryKey;
	            errText += '<br/>' + (0, _helpers.translation)(dictKey);
	          }
	          window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('12307'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      if (this.state.customergroup.CustomerGroupId !== undefined && this.state.customergroup.CustomerGroupId > 0) {
	        this.saveAddCustomerGroup(this.state.customergroup);
	        if (e.target.name === 'Name') {
	          this.props.getCustomerGroups();
	        }
	      }
	    }
	  }, {
	    key: 'getCustomerGroup',
	    value: function getCustomerGroup(props) {
	      var _this6 = this;
	
	      if (typeof props.item.CustomerGroupId !== 'undefined' && props.item.CustomerGroupId > 0) {
	        props.getCustomerGroup(props.item.CustomerGroupId).then(function (res) {
	          _this6.setState({
	            type: 'edit',
	            customergroup: res.data,
	            selectedShopId: -1,
	            customersList: [],
	            selectedCustomers: [],
	            dealerExpand: false
	          }, function () {
	            _this6.getShopCustomers();
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        customergroup: {
	          Name: '',
	          Active: true,
	          DebitorNumber: '',
	          DimentionNumber: '',
	          Comment: '',
	          CustomerGroupContacts: {},
	          CustomerGroupCustomers: {}
	        },
	        customersList: [],
	        selectedCustomers: [],
	        selectedShopId: -1,
	        selectedCustomerId: -1,
	        confirmSelect: {
	          open: false,
	          customerId: -1,
	          customerGroup: ''
	        }
	      });
	    }
	  }, {
	    key: 'addCustomerGroupCustomers',
	    value: function addCustomerGroupCustomers() {
	      var _this7 = this;
	
	      var selectedCustomers = this.state.selectedCustomers;
	
	      if (selectedCustomers === undefined || selectedCustomers == null || selectedCustomers.length === 0) return;
	      var data = {
	        SelectedShopId: this.state.selectedShopId,
	        CustomerGroupId: this.props.item.CustomerGroupId,
	        CustomersList: this.state.selectedCustomers.map(function (key, val) {
	          var CustomerGroupCustomerDto = {
	            CustomerId: key
	          };
	          return CustomerGroupCustomerDto;
	        })
	      };
	      this.props.changeLoading(true);
	      this.props.addCustomerGroupCustomers(data).then(function (res) {
	        _this7.getCustomerGroup(_this7.props);
	        _this7.props.changeLoading(false);
	        // window.toastr.success(translation('13030'), translation('13424'))
	      }, function (err) {
	        _this7.props.changeLoading(false);
	        // Toastr
	        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	          var errors = err.response.data.Errors;
	          var errText = '';
	          for (var i = 0; i < errors.length; i++) {
	            var dictKey = errors[i].DictionaryKey;
	            errText += '<br/>' + (0, _helpers.translation)(dictKey);
	          }
	          window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('12306'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'saveAddCustomerGroup',
	    value: function saveAddCustomerGroup() {
	      var _this8 = this;
	
	      return this.props.CreateSaveCustomerGroup(this.state.customergroup).then(function (res) {
	        _this8.props.onSave(res.data, _this8.state.type);
	        // console.log('Saved.. ', res.data)
	        setTimeout(function () {
	          _this8.props.getCustomerGroups();
	        }, 0);
	      }, function (err) {
	        // Toastr
	        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	          var errors = err.response.data.Errors;
	          var errText = '';
	          for (var i = 0; i < errors.length; i++) {
	            var dictKey = errors[i].DictionaryKey;
	            errText += '<br/>' + (0, _helpers.translation)(dictKey);
	          }
	          window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('13465'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'renderBasic',
	    value: function renderBasic() {
	      var customergroup = this.state.customergroup;
	
	      var isChain = (0, _auth.hasAccess)([2], this.props.auth.user.UserType);
	      var isWp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      // if (hasAccess([2], this.props.auth.user.UserType)) {
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('12282') },
	        _react2.default.createElement(_text3.default, { name: 'Name', value: customergroup.Name || '', onChange: this.onChange, onBlur: this.onBlur, disabled: !isChain, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('149') },
	          _react2.default.createElement(_textarea2.default, { name: 'Comment', value: customergroup.Comment || '', onChange: this.onChange, onBlur: this.onBlur, disabled: !isChain })
	        ),
	        isChain && _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onChange, checked: customergroup.Active, labelText: (0, _helpers.translation)('295') }),
	        isWp && _react2.default.createElement(_text3.default, { name: 'DebitNr', value: customergroup.DebitNr || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('13452'), helpText: (0, _helpers.translation)('1945') }),
	        isWp && _react2.default.createElement(_text3.default, { name: 'DimentionNumber', value: customergroup.DimentionNumber || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('15202'), helpText: (0, _helpers.translation)('15203') }),
	        isWp && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('18143'), helpText: (0, _helpers.translation)('') },
	          _react2.default.createElement(_check2.default, { name: 'UseWPDealerNrInYourRef', checked: customergroup.UseWPDealerNrInYourRef, onChange: this.onChange })
	        )
	      );
	    }
	  }, {
	    key: 'renderContacts',
	    value: function renderContacts() {
	      if (this.state.type === 'create') return null;
	      if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	        var customergroup = this.state.customergroup;
	
	
	        var renderContact = function renderContact(val, key) {
	          return _react2.default.createElement(
	            _label2.default,
	            { key: key },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/customergroups/' + customergroup.CustomerGroupId + '/contacts/' + val.ContactId },
	              val.Name
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('13460') },
	          _react2.default.createElement(
	            _actions2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/customergroups/' + customergroup.CustomerGroupId + '/contacts' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint--left', 'aria-label': (0, _helpers.translation)('12305') },
	                _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't' })
	              )
	            )
	          ),
	          customergroup.CustomerGroupContacts !== undefined && customergroup.CustomerGroupContacts !== null ? customergroup.CustomerGroupContacts.map(renderContact) : undefined
	        );
	      }
	    }
	  }, {
	    key: 'renderCustomersList',
	    value: function renderCustomersList() {
	      var _this9 = this;
	
	      if (this.state.type === 'create') return null;
	      if (!(0, _auth.hasAccess)([2, 6], this.props.auth.user.UserType)) return null;
	      var customergroup = this.state.customergroup;
	
	      var formExtraClass = 'extra';
	      if (!this.state.dealerExpand) {
	        formExtraClass += ' hide';
	      }
	
	      var deleteItem = function deleteItem(key) {
	        _this9.onRemoveCustomer(customergroup.CustomerGroupCustomers[key].CustomerId, customergroup.CustomerGroupCustomers[key].CustomerCompanyId);
	      };
	
	      var renderDealerContacts = function renderDealerContacts(val, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('30'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              val.Name
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('1'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              val.UserName
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('1052'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              val.Email
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('345'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              val.Phone
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        );
	      };
	
	      var renderDealerInfo = function renderDealerInfo(data) {
	        // console.log('renderDealerInfo: ', data)
	        if (data === null || data === undefined || data.CustomerId === 0) return;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('30'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.CompanyName
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('25'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.CompanyAddress + ', ' + data.CompanyZipCode + ' ' + data.CompanyCity
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('41'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.CompanyCVR
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('38'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.CompanyPhoneNumber
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('93'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              data.Notes
	            )
	          )
	        );
	      };
	
	      var renderDealerShopInfo = function renderDealerShopInfo(data) {
	        // console.log('renderDealerInfo: ', data)
	        if (data === null || data === undefined || data.ShopName === undefined) return;
	        return _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('30'),
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            data.ShopName
	          )
	        );
	      };
	
	      var onCollapseClick = function onCollapseClick() {
	        _this9.setState({
	          dealerExpand: !_this9.state.dealerExpand,
	          selectedDealer: {
	            CustomerId: 0,
	            Name: ''
	          }
	        });
	      };
	
	      var renderDealer = function renderDealer(val, key) {
	        var helptext = '';
	        var getDiv = function getDiv(val, key) {
	          return _react2.default.createElement(
	            'ul',
	            { key: key + '0' },
	            _react2.default.createElement(
	              'li',
	              { key: key },
	              (0, _helpers.translation)('12308'),
	              ':'
	            ),
	            val.map(renderConstraints)
	          );
	        };
	        var renderDName = function renderDName(val, key) {
	          return _react2.default.createElement(
	            'li',
	            { key: key },
	            '-- ',
	            val.Name
	          );
	        };
	        var renderConstraints = function renderConstraints(val, key) {
	          if ((0, _auth.hasAccess)([2], _this9.props.auth.user.UserType)) {
	            return _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                { key: key },
	                val.Name
	              ),
	              val.Constraints.map(renderDName)
	            );
	          } else {
	            return _react2.default.createElement(
	              'li',
	              { key: key },
	              val.Name
	            );
	          }
	        };
	
	        var onItemChange = function onItemChange(e) {
	          e.persist();
	          var isCheckBox = e.target.type === 'checkbox';
	          var value = isCheckBox ? e.target.checked : e.target.value;
	          var field = e.target.name;
	          var customerGroupCustomers = _this9.state.customergroup.CustomerGroupCustomers;
	          var customer = customerGroupCustomers[key];
	
	          if (field === 'DimentionNumber') {
	            if (isNaN(value)) {
	              value = parseInt(customer[field]);
	            } else {
	              value = parseInt(value);
	            }
	          }
	
	          customer[field] = value;
	          customerGroupCustomers[key] = customer;
	
	          _this9.setState({
	            customergroup: _extends({}, _this9.state.customergroup, {
	              CustomerGroupCustomers: [].concat(_toConsumableArray(customerGroupCustomers))
	            })
	          }, function () {
	            if (isCheckBox) onItemBlur();
	          });
	        };
	
	        var onItemBlur = function onItemBlur() {
	          var customergroup = _this9.state.customergroup;
	          var customerGroupCustomers = _this9.state.customergroup.CustomerGroupCustomers;
	          var customer = customerGroupCustomers[key];
	
	          var data = {
	            CustomerId: customer.CustomerId,
	            CustomerCompanyId: customer.CustomerCompanyId,
	            DebitorNrForWP: customer.DebitorNrForWP,
	            DimentionNumber: customer.DimentionNumber,
	            UseWPDealerNrInYourRef: customer.UseWPDealerNrInYourRef,
	            UseDebitorNrForWP: customer.UseDebitorNrForWP,
	            WPDealerNr: customer.WPDealerNr,
	            CustomerGroupId: customergroup.CustomerGroupId
	          };
	
	          _this9.props.updateCustomerWPInfo(data).then(function (res) {
	            _this9.setState({
	              customergroup: res.data
	            });
	
	            // window.toastr.success(translation('12316'), translation('13424'))
	          }, function () {
	            window.toastr.error((0, _helpers.translation)('12317'), (0, _helpers.translation)('216'));
	          });
	        };
	
	        // same "if" condition 2 times, but different HelpText
	        if (val.CustomerGroups !== undefined && val.CustomerGroups !== null && val.CustomerGroups.length > 1) {
	          var text = getDiv(val.CustomerGroups, key);
	          helptext = _react2.default.createElement(_helpIcon2.default, { helpText: text });
	        }
	
	        var onDealerClick = function onDealerClick() {
	          _this9.props.getCustomerContactsInfo(val.CustomerId).then(function (res) {
	            var customer = res.data.Customer;
	            if (customer.CustomerId === 0) customer.CustomerId = val.CustomerId;
	            // let customerId = res.data.CustomerId
	            // if (customerId === null || customerId === 0) customerId = val.CustomerId
	            _this9.setState({
	              customerContactsList: res.data.Contacts,
	              dealerExpand: true,
	              selectedDealer: customer
	              // selectedDealer: {
	              //   CustomerId: val.CustomerId,
	              //   Name: val.Name
	              // }
	            });
	          });
	        };
	        var dealerNameClass = 'dealer';
	        if (_this9.state.selectedDealer.CustomerId === val.CustomerId) {
	          dealerNameClass += ' selected';
	        }
	        if ((0, _auth.hasAccess)([2], _this9.props.auth.user.UserType)) {
	          // To show shop of customer in the name
	          var shownName = val.Name + ' (' + val.CustomerCompanyName + ')';
	          return _react2.default.createElement(
	            _grid2.default,
	            { spacing: 1, key: key, cols: [0.5, 2, 'min-content'], align: 'center' },
	            _react2.default.createElement(
	              'div',
	              null,
	              val.ZipCode
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              shownName,
	              helptext
	            ),
	            _react2.default.createElement(_removeButton2.default, { size: 'm', name: key, onClick: deleteItem.bind(_this9, key) })
	          );
	        }
	
	        // same "if" condition 2 times, but different HelpText
	        if (val.CustomerGroups !== undefined && val.CustomerGroups !== null && val.CustomerGroups.length > 1) {
	          var _text = getDiv(val.CustomerGroups);
	          helptext = _react2.default.createElement(_helpIcon2.default, { helpText: _text, red: val.ConflictStatus === 1, green: val.ConflictStatus === 2 });
	        }
	
	        var isChecked = val.UseDebitorNrForWP;
	        var debitorInput = _react2.default.createElement(_text3.default, { labelText: (0, _helpers.translation)('13452'), helpText: (0, _helpers.translation)('1945'), size: 's', name: 'DebitorNrForWP', value: val.DebitorNrForWP, onBlur: onItemBlur, onChange: onItemChange, disabled: !isChecked });
	
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            _grid2.default,
	            { align: 'center' },
	            _react2.default.createElement(
	              'div',
	              { onClick: onDealerClick, className: dealerNameClass },
	              val.Name,
	              ' ',
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                val.CustomerCompanyName
	              )
	            ),
	            _react2.default.createElement(_text3.default, { labelText: (0, _helpers.translation)('13559'), helpText: (0, _helpers.translation)('13560'), size: 's', name: 'WPDealerNr', value: val.WPDealerNr || '', onBlur: onItemBlur, onChange: onItemChange, disabled: !val.IsPrimaryCustomer }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('12314'), helpText: (0, _helpers.translation)('12315') },
	              _react2.default.createElement(_check2.default, { simple: true, name: 'UseDebitorNrForWP', checked: isChecked, onChange: onItemChange, disabled: !val.IsPrimaryCustomer })
	            )
	          ),
	          isChecked && _react2.default.createElement(
	            _grid2.default,
	            { align: 'center' },
	            _react2.default.createElement('div', null),
	            debitorInput,
	            _react2.default.createElement(_text3.default, { labelText: (0, _helpers.translation)('15202'), helpText: (0, _helpers.translation)('15203'), size: 's', name: 'DimentionNumber', value: val.DimentionNumber || '', onBlur: onItemBlur, onChange: onItemChange, disabled: !val.IsPrimaryCustomer })
	          )
	        );
	      };
	
	      var orderBy = function orderBy(type) {
	        if (type === 1) {
	          _this9.setState({
	            customergroup: _extends({}, _this9.state.customergroup, {
	              CustomerGroupCustomers: _this9.state.orderBy.zipDesc ? _this9.state.customergroup.CustomerGroupCustomers.sort(function (a, b) {
	                return a.ZipCode.localeCompare(b.ZipCode);
	              }) : _this9.state.customergroup.CustomerGroupCustomers.sort(function (a, b) {
	                return b.ZipCode.localeCompare(a.ZipCode);
	              })
	            }),
	            orderBy: _extends({}, _this9.state.orderBy, {
	              zipDesc: !_this9.state.orderBy.zipDesc,
	              zipImg: _this9.state.orderBy.zipDesc ? _react2.default.createElement('img', { style: { width: '15px', marginLeft: '7px' }, src: '/images/svgs/Arrow_up-down.svg' }) : _react2.default.createElement('img', { style: { width: '15px', transform: 'rotate(180deg)', marginLeft: '7px' }, src: '/images/svgs/Arrow_up-down.svg' }),
	              nameImg: _react2.default.createElement('img', null)
	            })
	          });
	        } else if (type === 2) {
	          _this9.setState({
	            customergroup: _extends({}, _this9.state.customergroup, {
	              CustomerGroupCustomers: _this9.state.orderBy.nameDesc ? _this9.state.customergroup.CustomerGroupCustomers.sort(function (a, b) {
	                return a.Name.localeCompare(b.Name);
	              }) : _this9.state.customergroup.CustomerGroupCustomers.sort(function (a, b) {
	                return b.Name.localeCompare(a.Name);
	              })
	            }),
	            orderBy: _extends({}, _this9.state.orderBy, {
	              nameDesc: !_this9.state.orderBy.nameDesc,
	              nameImg: _this9.state.orderBy.nameDesc ? _react2.default.createElement('img', { style: { width: '15px', transform: 'rotate(180deg)', marginLeft: '7px' }, src: '/images/svgs/Arrow_up-down.svg' }) : _react2.default.createElement('img', { style: { width: '15px', marginLeft: '7px' }, src: '/images/svgs/Arrow_up-down.svg' }),
	              zipImg: _react2.default.createElement('img', null)
	            })
	          });
	        }
	      };
	
	      var zip = _react2.default.createElement(
	        'div',
	        { style: { width: '20%', float: 'left' } },
	        _react2.default.createElement(
	          'div',
	          { style: { width: 'fit-content', cursor: 'pointer' }, onClick: function onClick() {
	              return orderBy(1);
	            } },
	          (0, _helpers.translation)('40'),
	          this.state.orderBy.zipImg
	        )
	      );
	      var name = _react2.default.createElement(
	        'div',
	        { style: { marginLeft: '20%' } },
	        _react2.default.createElement(
	          'div',
	          { style: { width: 'fit-content', cursor: 'pointer' }, onClick: function onClick() {
	              return orderBy(2);
	            } },
	          (0, _helpers.translation)('12304'),
	          this.state.orderBy.nameImg
	        )
	      );
	
	      var colClassName = '';
	      if (this.state.dealerExpand) {
	        colClassName += ' expandable';
	      }
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('12304') },
	        (0, _auth.hasAccess)([2], this.props.auth.user.UserType) && _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          zip,
	          ' ',
	          name
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { alignChildren: 'top' },
	          _react2.default.createElement(
	            'div',
	            { className: 'real' + colClassName },
	            customergroup.CustomerGroupCustomers !== undefined && customergroup.CustomerGroupCustomers !== null ? customergroup.CustomerGroupCustomers.map(renderDealer) : undefined
	          ),
	          this.state.dealerExpand && _react2.default.createElement(
	            'div',
	            { className: formExtraClass + colClassName },
	            _react2.default.createElement(
	              'div',
	              { className: 'title-spacing' },
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: [1, 'min-content'], align: 'center' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  this.state.selectedDealer.CompanyName
	                ),
	                _react2.default.createElement(_closeButton2.default, { onClick: onCollapseClick })
	              )
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('13600') },
	              renderDealerInfo(this.state.selectedDealer)
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('1737') },
	              renderDealerShopInfo(this.state.selectedDealer)
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('13601') },
	              this.state.customerContactsList !== undefined ? this.state.customerContactsList.map(renderDealerContacts) : null
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderShopSelection',
	    value: function renderShopSelection() {
	      var _this10 = this;
	
	      var renderShopsList = function renderShopsList() {
	        if (_this10.props.shopsList === undefined || _this10.props.shopsList === null) return null;
	        return _this10.props.shopsList.reduce(function (shops, val, i) {
	          if (val.Active) {
	            var opt = _react2.default.createElement(
	              'option',
	              { value: val.ShopId, key: val.ShopId },
	              val.ShopName
	            );
	            return [].concat(_toConsumableArray(shops), [opt]);
	          }
	          return shops;
	        }, []);
	      };
	      if (this.state.type === 'create') return null;
	      if (!(0, _auth.hasAccess)([2], this.props.auth.user.UserType)) return null;
	      // console.log('this.state.selectedShopId ', this.state.selectedShopId)
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('12303') },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'selectedShopId', onChange: this.onInputChange, value: this.state.selectedShopId },
	          _react2.default.createElement(
	            'option',
	            { value: -1, key: '-1' },
	            (0, _helpers.translation)('890')
	          ),
	          renderShopsList()
	        )
	      );
	    }
	  }, {
	    key: 'renderAddCustomerButton',
	    value: function renderAddCustomerButton() {
	      var customersList = this.state.customersList;
	
	      if (customersList === undefined || customersList == null || customersList.length === 0) return undefined;
	      return _react2.default.createElement(_button2.default, { onClick: this.addCustomerGroupCustomers, labelText: (0, _helpers.translation)('1208') });
	    }
	  }, {
	    key: 'renderCustomerSelection',
	    value: function renderCustomerSelection() {
	      var _this11 = this;
	
	      if (this.state.type === 'create') return null;
	      if (!(0, _auth.hasAccess)([2], this.props.auth.user.UserType)) return null;
	      var customersList = this.state.customersList;
	
	      var hasCustomers = customersList !== undefined && customersList !== null && customersList.length > 0;
	      if (!hasCustomers) return undefined;
	
	      // const getDiv = (val, key) => {
	      //   return (<div>
	      //     <div key={key} >{translation('12308')}:</div>
	      //     {val.map(renderDName)}
	      //   </div>)
	      // }
	      // const renderDName = (val, key) => {
	      //   let name = val.Name + ' (' + val.WorkProviderName + ')'
	      //   return (<div key={key}>{name}</div>)
	      // }
	      var renderDNameNew = function renderDNameNew(val) {
	        return '\n' + val.Name + ' (' + val.WorkProviderName + ')';
	      };
	      var checked = function checked(key) {
	        var selectedCustomers = [].concat(_toConsumableArray(_this11.state.selectedCustomers));
	        return selectedCustomers.includes(Number(key));
	      };
	
	      var renderCustomerCheckBox = function renderCustomerCheckBox(val, key) {
	        var _state = _extends({}, _this11.state),
	            customergroup = _state.customergroup;
	
	        var cust = _this11.state.customersList.filter(function (eg) {
	          return Number(eg.CustomerId) === Number(val.CustomerId) && Number(val.CustomerGroupId) === customergroup.CustomerGroupId;
	        })[0];
	        if (cust !== undefined) return undefined;
	        var name = 'customerCheck_' + val.CustomerId;
	        var helptext = '';
	        var customerWorkProviderId = -1;
	        if (val.CustomerGroups !== undefined && val.CustomerGroups !== null && val.CustomerGroups.length > 0) {
	          var text = (0, _helpers.translation)('12302') + ' ';
	          var count = val.CustomerGroups.length;
	          var i = 0;
	          val.CustomerGroups.forEach(function (element) {
	            i++;
	            var textName = ' ' + element.Name;
	            if (i < count) {
	              textName += ',';
	            }
	            text += textName;
	            customerWorkProviderId = element.WorkProviderId;
	          });
	          // text = getDiv(val.CustomerGroups, key)
	          text = (0, _helpers.translation)('12308') + ':';
	          var dNames = val.CustomerGroups.map(renderDNameNew);
	          text += dNames;
	          if (text !== '') {
	            helptext = text;
	          }
	        }
	
	        var partnerName = '';
	        if (val.RelationType === 2) {
	          // 2 = FromPartner
	          partnerName = '\n(' + val.PartnerName + ')';
	        }
	
	        var isChecked = checked(val.CustomerId) || false;
	        var currentWorkProviderId = _this11.state.customergroup.WorkProviderId;
	        var isActive = customerWorkProviderId === -1 || currentWorkProviderId === customerWorkProviderId;
	        var ZipCode = val.ZipCode !== '' && val.ZipCode !== null ? ' (' + val.ZipCode + ')' : '';
	        return _react2.default.createElement(_check2.default, { key: key, disabled: !isActive, id: name, value: val.CustomerId, onChange: _this11.onSelectCustomer, checked: isChecked, name: name, labelText: val.Name + ZipCode + partnerName, helpText: helptext });
	      };
	
	      var activeCustomers = customersList.filter(function (c) {
	        return c.Active;
	      });
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('12301') },
	        hasCustomers ? activeCustomers.map(renderCustomerCheckBox) : _react2.default.createElement(
	          _label2.default,
	          null,
	          (0, _helpers.translation)('433')
	        ),
	        this.renderAddCustomerButton()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      // let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
	      var confirmSelect = function confirmSelect(props) {
	        var ctext = props.t('12300');
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            ctext
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _this12.state.confirmSelect.customerGroup
	          )
	        );
	      };
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderBasic(),
	          this.renderContacts()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { span: (0, _auth.hasAccess)([2], this.props.auth.user.UserType) ? '2' : '5' },
	          this.renderShopSelection(),
	          this.renderCustomerSelection(),
	          this.renderCustomersList()
	        ),
	        this.state.confirmSelect.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmSelect') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirmSelect.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmSelect'), higher: true, renderText: confirmSelect })
	        )
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false,
	        customerId: -1,
	        customerGroup: ''
	      })));
	    }
	  }, {
	    key: 'onConfirmSelect',
	    value: function onConfirmSelect() {
	      var value = Number(this.state.confirmSelect.customerId);
	      var selectedCustomers = [].concat(_toConsumableArray(this.state.selectedCustomers));
	      selectedCustomers.push(value);
	      this.setState({
	        selectedCustomers: selectedCustomers
	      });
	      this.onPortalClose('confirmSelect');
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes,
	    selectedShopId: state.selectedShopId
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  CreateSaveCustomerGroup: _customerGroup.CreateSaveCustomerGroup,
	  getCustomerGroups: _customerGroup.getCustomerGroups,
	  getCustomerContactsInfo: _customerWP.getCustomerContactsInfo,
	  getCustomerGroup: _customerGroup.getCustomerGroup,
	  getShopCustomers: _customers.getShopCustomers,
	  addCustomerGroupCustomers: _customerGroup.addCustomerGroupCustomers,
	  triggerPopup: _backdrop.triggerPopup,
	  removeCustomerGroupCustomer: _customerGroup.removeCustomerGroupCustomer,
	  updateCustomerWPInfo: _customerWP.updateCustomerWPInfo
	}, null, { withRef: true })(View);

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _customerGroup = __webpack_require__(107);
	
	var _shops = __webpack_require__(79);
	
	__webpack_require__(514);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _View = __webpack_require__(829);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	// Utils
	
	
	var CustomerGroups = function (_Component) {
	  _inherits(CustomerGroups, _Component);
	
	  function CustomerGroups(props) {
	    _classCallCheck(this, CustomerGroups);
	
	    var _this = _possibleConstructorReturn(this, (CustomerGroups.__proto__ || Object.getPrototypeOf(CustomerGroups)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      search: '',
	      includeInactive: true,
	      customergroups: [],
	      activeItem: {},
	      shopsList: [],
	      isUpdating: false,
	      isLoading: false
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.changeLoading = _this.changeLoading.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomerGroups, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomerGroups();
	      this.getShops();
	      if (typeof this.props.router.params.customerGroupId !== 'undefined') {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            CustomerGroupId: parseInt(this.props.router.params.customerGroupId)
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getShops',
	    value: function getShops() {
	      var _this2 = this;
	
	      var chainId = this.props.auth.user.ChainId;
	      this.props.getShopsWithCustomers(chainId).then(function (res) {
	        _this2.setState({
	          shopsList: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getCustomerGroups',
	    value: function getCustomerGroups() {
	      var _this3 = this;
	
	      this.props.getCustomerGroups().then(function (res) {
	        _this3.setState({
	          customergroups: res.data,
	          activeItem: _this3.state.activeItem
	        });
	
	        if (res.data.length === 0) {
	          _this3.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'changeLoading',
	    value: function changeLoading(load) {
	      this.setState({
	        isLoading: load
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (!(0, _auth.hasAccess)([2], this.props.auth.user.UserType)) return null;
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('16652'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({
	          search: e.target.value
	        });
	      }
	      if (e.target.name === 'Inactive') {
	        this.setState({
	          includeInactive: e.target.checked
	        });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      if (key.Name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.Active : true)) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this4 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this4.setState({ isUpdating: true });
	          _this4.refs.view.getWrappedInstance().saveAddCustomerGroup().then(function () {
	            _this4.setState({ isUpdating: false });
	          });
	        };
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { disabled: this.state.isUpdating, onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', disabled: this.state.isUpdating, onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.customergroups.map(function (cg) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: cg.Name,
	          onClick: function onClick() {
	            return _this4.onSelectItem(cg);
	          },
	          selected: cg.CustomerGroupId === _this4.state.activeItem.CustomerGroupId,
	          inactive: !cg.Active,
	          key: cg.CustomerGroupId
	        });
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var customerGroups = [].concat(_toConsumableArray(this.state.customergroups));
	      var activeItem = _extends({}, this.state.activeItem);
	      if (type === 'create') {
	        customerGroups.push({
	          CustomerGroupId: data.CustomerGroupId,
	          Name: data.Name,
	          Active: data.Active
	        });
	        type = 'item';
	        activeItem = {
	          CustomerGroupId: data.CustomerGroupId
	        };
	      } else {
	        customerGroups.map(function (val, key) {
	          if (val.CustomerGroupId === data.CustomerGroupId) {
	            val.Name = data.Name;
	            val.Active = data.Active;
	          }
	        });
	        type = 'item';
	      }
	      this.setState({
	        customergroups: customerGroups,
	        view: type,
	        activeItem: activeItem
	      });
	      // Toastr
	      // window.toastr.success(translation('13464'), translation('13424'))
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { ref: 'view', isCustomer: false, item: this.state.activeItem, changeLoading: this.changeLoading, shopsList: this.state.shopsList, onSave: this.onSave, getCustomerGroups: this.getCustomerGroups });
	      }
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      var _this5 = this;
	
	      this.setState({
	        view: 'item',
	        activeItem: item
	      }, function () {
	        _this5.props.router.replace('/customergroups/' + item.CustomerGroupId);
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'customergroups__screen' },
	        this.state.isLoading && _react2.default.createElement(
	          'div',
	          { className: 'loading-background' },
	          _react2.default.createElement(
	            'div',
	            { className: 'loading-middle' },
	            _react2.default.createElement(
	              'div',
	              { className: 'loading-text' },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('13032')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('13033')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('13034')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	            )
	          )
	        ),
	        _react2.default.createElement(_Header2.default, { router: this.props.router, icon: 'menu/Partners-White.png', renderRight: function renderRight() {
	            return _this6.headerButtonsRight();
	          } }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          {
	            showFilter: this.state.view !== 'create',
	            hideInactiveCheck: this.state.view === 'create',
	            defaultShowInactive: true
	          },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'customergroups__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return CustomerGroups;
	}(_react.Component);
	
	CustomerGroups.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    shopsList: state.shopsList
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getCustomerGroups: _customerGroup.getCustomerGroups, getShopsWithCustomers: _shops.getShopsWithCustomers, hasAccess: _auth.hasAccess })(CustomerGroups);

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _customers = __webpack_require__(74);
	
	var _auth = __webpack_require__(68);
	
	__webpack_require__(1377);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _HelpText = __webpack_require__(130);
	
	var _HelpText2 = _interopRequireDefault(_HelpText);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _auth2 = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// Components
	
	
	// Utils
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'edit',
	      contact: {
	        UserId: 0,
	        CustomerId: 0,
	        UserName: '',
	        Email: '',
	        EmailIsValid: false,
	        Phone: '',
	        PhoneCode: _this.props.phonecode,
	        PhoneIsValid: false,
	        Active: true,
	        NotificationSettings: []
	      }
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.saveAddContact = _this.saveAddContact.bind(_this);
	    _this.loginAs = _this.loginAs.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomerContact(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.UserId !== nextProps.item.UserId) {
	        this.getCustomerContact(nextProps);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      var value = e.target.value;
	
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      this.setState({
	        contact: _extends({}, this.state.contact, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this2.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this3 = this;
	
	      if (this.state.contact.UserId !== undefined) {
	        this.setState({ type: 'edit' }, function () {
	          _this3.saveAddContact();
	        });
	      }
	    }
	  }, {
	    key: 'loginAs',
	    value: function loginAs(id) {
	      var _this4 = this;
	
	      this.props.loginAs(id).then(function (res) {
	        _this4.props.router.push('/');
	      }, function (err) {
	        if (err.response.data.DictionaryKey !== undefined) {
	          window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	        }
	        console.log('Nooooo, could not login', err.response.data);
	      });
	    }
	  }, {
	    key: 'getCustomerContact',
	    value: function getCustomerContact(props) {
	      var _this5 = this;
	
	      if (typeof props.item.UserId !== 'undefined') {
	        props.getCustomerContact(props.item.UserId).then(function (res) {
	          var contact = res.data;
	          if (contact.NotificationSettings.length === 0) {
	            contact.NotificationSettings = _this5.getNotificationSettings();
	          }
	          _this5.setState({
	            type: 'edit',
	            contact: contact
	          });
	        }, function () {
	          _this5.props.onError();
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'getNotificationSettings',
	    value: function getNotificationSettings() {
	      var NotificationSettings = [].concat(_toConsumableArray(this.state.contact.NotificationSettings));
	      NotificationSettings.map(function (val, key) {
	        NotificationSettings[key] = {
	          NotificationEvent: val.NotificationEvent,
	          Sms: false,
	          Email: false,
	          Push: false
	        };
	      });
	      return NotificationSettings;
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        contact: {
	          UserId: 0,
	          CustomerId: this.props.customerID,
	          Phone: '',
	          PhoneCode: this.props.phonecode,
	          PhoneIsValid: false,
	          Active: true,
	          NotificationSettings: this.getNotificationSettings(),
	          UserName: '',
	          Email: '',
	          EmailIsValid: false
	        }
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var value = e.target.value;
	      var name = e.target.name;
	      if (name === 'PhoneNumber') {
	        name = 'Phone';
	        this.setState({
	          contact: _extends({}, this.state.contact, _defineProperty({}, name, value))
	        });
	      } else {
	        this.setState({
	          contact: _extends({}, this.state.contact, {
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        });
	      }
	    }
	  }, {
	    key: 'renderContact',
	    value: function renderContact() {
	      var contact = this.state.contact;
	
	      var disableInputs = false;
	      // Check if LoginAs is allowed
	      // let isLoginAsAllowed = !contact.HidePassword // && this.props.auth.departmentType !== 1// !this.props.hidePassword // (contact.UserId > 0) && hasAccess([3, 5, 7], this.props.auth.user.UserType) && !this.props.hidePassword
	      // Allow LoginAs if the first logged in user is chain
	      var isLoginAsAllowed = true; // GDPR - TO BE CHANGED
	      if ((0, _auth2.isTopOfStackChain)(this.props.auth.inactiveUsers)) {
	        isLoginAsAllowed = true;
	      }
	      isLoginAsAllowed = contact.AllowLoginAs;
	
	      if (contact.IsPartnerUser) {
	        disableInputs = true;
	      }
	
	      // let a = 1
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('346') },
	        _react2.default.createElement(_text2.default, { name: 'Name', value: contact.Name || '', onChange: this.onChange, onBlur: this.onBlur, disabled: disableInputs, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_text2.default, { name: 'UserName', value: contact.UserName || '', onChange: this.onChange, onBlur: this.onBlur, disabled: disableInputs, labelText: (0, _helpers.translation)('1') }),
	        ((0, _auth2.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth2.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && _react2.default.createElement(_text2.default, { name: 'Email', value: contact.Email || '', onChange: this.onChange, onBlur: this.onBlur, disabled: disableInputs, labelText: (0, _helpers.translation)('1052') }),
	        ((0, _auth2.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth2.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('345') },
	          _react2.default.createElement(_Phone2.default, {
	            onChange: this.onInputChange,
	            onBlur: this.onBlur,
	            code: contact.PhoneCode,
	            number: contact.Phone,
	            disabled: disableInputs })
	        ),
	        !contact.IsPartnerUser && _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onChange, checked: contact.Active, labelText: (0, _helpers.translation)('295') }),
	        isLoginAsAllowed && this.state.type !== 'create' && _react2.default.createElement(_button2.default, { style: 'link', onClick: this.loginAs.bind(this, contact.UserId), labelText: (0, _helpers.translation)('57') })
	      );
	    }
	  }, {
	    key: 'renderNotifications',
	    value: function renderNotifications() {
	      var _this6 = this;
	
	      if (!(0, _auth2.hasSubscriptionPermission)(this.props.auth, 10, 0)) return null;
	      var contact = this.state.contact;
	
	      var disableCheckboxEmail = false;
	      var disableCheckboxSMS = false;
	      if (contact.NotificationSettings.length === 0) return null;
	
	      var renderNotification = function renderNotification(val, key) {
	        if (!_this6.props.isOwnedByShop && (val.NotificationEvent === 1 || val.NotificationEvent === 2)) return null;
	        var name = 'notification_' + val.NotificationEvent + '_';
	        var keyName = (0, _helpers.enumtranslate)('NotificationEventType', val.NotificationEvent);
	        var helpText = '';
	        switch (val.NotificationEvent) {
	          case 1:
	            helpText = '2169';
	            break;
	          case 2:
	            helpText = '2170';
	            break;
	          case 3:
	            helpText = '2171';
	            break;
	          case 4:
	            helpText = '2198';
	            break;
	          case 5:
	            helpText = '2172';
	            break;
	          case 6:
	            helpText = '2173';
	            break;
	          case 7:
	            helpText = '1969';
	            break;
	          case 8:
	            helpText = '1970';
	            break;
	          case 9:
	            helpText = '1971';
	            break;
	          case 10:
	            helpText = '1972';
	            break;
	          case 11:
	            helpText = '1973';
	            break;
	          case 12:
	            helpText = '2197';
	            break;
	          case 13:
	            helpText = '2174';
	            break;
	          case 14:
	            helpText = '13709';
	            break;
	          case 18:
	            helpText = '15150';
	        }
	        // On change
	        var onChange = function onChange(e) {
	          var NotificationSettings = [].concat(_toConsumableArray(_this6.state.contact.NotificationSettings));
	          if (e.target.name === 'sms') {
	            NotificationSettings[key].Sms = e.target.checked;
	          } else if (e.target.name === 'email') {
	            NotificationSettings[key].Email = e.target.checked;
	          }
	          _this6.setState({
	            contact: _extends({}, _this6.state.contact, {
	              NotificationSettings: NotificationSettings
	            })
	          });
	          _this6.onBlur();
	        };
	
	        if (!contact.EmailIsValid || contact.IsPartnerUser) {
	          disableCheckboxEmail = true;
	        }
	
	        if (!contact.PhoneIsValid || contact.IsPartnerUser) {
	          disableCheckboxSMS = true;
	        }
	
	        // Return
	        return _react2.default.createElement(
	          _grid2.default,
	          { spacing: 1, cols: [3], align: 'center', key: key },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(keyName),
	            ' ',
	            _react2.default.createElement(_HelpText2.default, { text: (0, _helpers.translation)(helpText) })
	          ),
	          _react2.default.createElement(_check2.default, { simple: true, id: name + 'email', name: 'email', value: '1', checked: val.Email, onChange: onChange, disabled: disableCheckboxEmail }),
	          _react2.default.createElement(_check2.default, { simple: true, id: name + 'sms', name: 'sms', value: '1', checked: val.Sms, onChange: onChange, disabled: disableCheckboxSMS })
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13461'), helpText: (0, _helpers.translation)('14739') },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [3], align: 'center', spacing: 1 },
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('1052')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('15')
	          )
	        ),
	        contact.NotificationSettings.map(renderNotification)
	      );
	    }
	  }, {
	    key: 'saveAddContact',
	    value: function saveAddContact() {
	      var _this7 = this;
	
	      this.props.CreateSaveCustomerContact(this.state.contact).then(function (res) {
	        _this7.props.onSave(res.data, _this7.state.type);
	        _this7.setState({
	          contact: res.data
	        });
	      }, function (err) {
	        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	          if (_this7.state.contact.Email !== '' && _this7.state.contact.UserName !== '') {
	            var errors = err.response.data.Errors;
	            var errText = '';
	            for (var i = 0; i < errors.length; i++) {
	              var dictKey = errors[i].DictionaryKey;
	              errText += '<br/>' + (0, _helpers.translation)(dictKey);
	            }
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          }
	        } else {
	          var errorMessage = function errorMessage(error) {
	            var messageText = '';
	            if (error < 5) {
	              messageText += (0, _helpers.translation)('16340');
	            }
	            if (messageText !== '') messageText += ' ';
	            switch (error) {
	              case 1:
	                messageText += (0, _helpers.translation)('16329');
	                break;
	              case 2:
	                messageText += (0, _helpers.translation)('16336');
	                break;
	              case 3:
	                messageText += (0, _helpers.translation)('16335');
	                break;
	              case 4:
	                messageText += (0, _helpers.translation)('16338');
	                break;
	              case 5:
	                messageText += (0, _helpers.translation)('16337');
	                break;
	              default:
	                break;
	            }
	            messageText += '<br>';
	            return messageText;
	          };
	          var _errors = err.response.data;
	          if (Array.isArray(_errors)) {
	            var message = _errors.map(function (error) {
	              return errorMessage(error);
	            });
	            window.toastr.error(message, (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('13463'), (0, _helpers.translation)('216'));
	          }
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderContact()
	        ),
	        (0, _auth2.hasSubscriptionPermission)(this.props.auth, 20) && this.props.auth.departmentType !== 1 && _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderNotifications()
	        )
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  CreateSaveCustomerContact: _customers.CreateSaveCustomerContact,
	  getCustomerContact: _customers.getCustomerContact,
	  loginAs: _auth.loginAs
	}, null, { withRef: true })(View);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _customers = __webpack_require__(74);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _CreateUser = __webpack_require__(197);
	
	var _CreateUser2 = _interopRequireDefault(_CreateUser);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _View = __webpack_require__(831);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import components
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Contacts = function (_Component) {
	  _inherits(Contacts, _Component);
	
	  function Contacts(props) {
	    _classCallCheck(this, Contacts);
	
	    var _this = _possibleConstructorReturn(this, (Contacts.__proto__ || Object.getPrototypeOf(Contacts)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      includeNonVerified: false,
	      activeItem: {},
	      contacts: [],
	      customerName: '',
	      isPartnerShopCustomer: false,
	      isOwnedByShop: false,
	      canAddContacts: false
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onViewFail = _this.onViewFail.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    return _this;
	  }
	
	  _createClass(Contacts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomer(this.props);
	      this.getContacts();
	      if (typeof this.props.params.contactID !== 'undefined') {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            UserId: Number(this.props.params.contactID),
	            CustomerId: this.props.params.customerID !== 'undefined' ? this.props.params.customerID : 0
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getCustomer',
	    value: function getCustomer(props) {
	      var _this2 = this;
	
	      if (typeof props.params.customerID !== 'undefined') {
	        props.getCustomer(props.params.customerID).then(function (res) {
	          _this2.setState({
	            customerName: res.data.CompanyName,
	            isPartnerShopCustomer: res.data.IsPartnerShopCustomer,
	            isOwnedByShop: res.data.IsOwnedByShop,
	            canAddContacts: res.data.CanAddContacts
	          });
	        }, function (err) {
	          if (err.response.status === 401) {
	            _this2.props.router.replace('/orders');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getContacts',
	    value: function getContacts() {
	      var _this3 = this;
	
	      return this.props.getCustomerContacts(this.props.params.customerID).then(function (res) {
	        _this3.setState({
	          contacts: res.data
	        });
	        if (res.data.length === 0) {
	          _this3.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	      this.props.router.replace('/customers/' + this.props.params.customerID + '/contacts');
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) && this.state.contacts.length < 2) return null;
	      if (this.state.isPartnerShopCustomer) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.canAddContacts && _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('2079'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this4 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this4.refs.create.getWrappedInstance().createUser();
	        };
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return [_react2.default.createElement(
	        'div',
	        { key: 'confirmedfilter', className: 'filter' },
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { isFixed: true },
	          _react2.default.createElement(_check2.default, {
	            name: 'NonVerified',
	            checked: this.state.includeNonVerified,
	            onChange: function onChange() {
	              _this4.setState({ includeNonVerified: !_this4.state.includeNonVerified });
	            },
	            labelText: (0, _helpers.translation)('16320'),
	            spacing: 0
	          })
	        )
	      )].concat(_toConsumableArray(this.state.contacts.map(function (e) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: e.Name,
	          onClick: function onClick() {
	            return _this4.onSelectItem(e);
	          },
	          selected: e.UserId === _this4.state.activeItem.UserId,
	          inactive: !e.Active,
	          confirmed: e.Confirmed,
	          key: e.UserId
	        });
	      })));
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var contacts = [].concat(_toConsumableArray(this.state.contacts));
	      var activeItem = void 0;
	      if (type === 'create') {
	        contacts.push({
	          Name: data.Name,
	          UserId: data.UserId,
	          Active: data.Active,
	          Email: data.Email,
	          Confirmed: false
	        });
	        type = 'item';
	        activeItem = {
	          UserId: data.UserId,
	          Confirmed: false
	        };
	      } else {
	        contacts.map(function (val, key) {
	          if (val.UserId === data.UserId) {
	            val.Name = data.Name;
	            val.Active = data.Active;
	          }
	        });
	        type = 'item';
	        if (data.Confirmed) {
	          activeItem = {
	            UserId: data.UserId,
	            Confirmed: true
	          };
	        } else {
	          activeItem = {
	            UserId: data.UserId,
	            Email: data.Email,
	            Name: data.Name,
	            Confirmed: data.Confirmed,
	            CustomerId: data.CustomerId
	          };
	        }
	      }
	      this.setState({
	        contacts: contacts,
	        view: type,
	        activeItem: activeItem
	      });
	      // Toastr
	      // window.toastr.success(translation('13462'), translation('13424'))
	    }
	  }, {
	    key: 'onViewFail',
	    value: function onViewFail() {
	      this.setState({
	        view: 'list',
	        activeItem: {}
	      });
	      this.props.router.replace('/customers/' + this.props.params.customerID + '/contacts');
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this5 = this;
	
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	          return _react2.default.createElement(_CreateUser2.default, { isContact: true, ref: 'create', title: (0, _helpers.translation)('16339'), customerID: this.props.params.customerID, user: undefined, onSuccess: function onSuccess(res) {
	              return _this5.onSave(res, 'create');
	            } });
	        case 'item':
	          if (this.state.activeItem.Confirmed === false) return _react2.default.createElement(_CreateUser2.default, { isContact: true, user: this.state.activeItem, title: (0, _helpers.translation)('16339'), onSuccess: function onSuccess(res) {
	              return _this5.onSave(res, 'item');
	            } });
	          return _react2.default.createElement(_View2.default, { router: this.props.router, ref: 'view', item: this.state.activeItem, onSave: this.onSave, getContacts: this.getContacts, customerID: this.props.params.customerID, isOwnedByShop: this.state.isOwnedByShop, onError: this.onViewFail });
	      }
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      this.props.router.replace('/customers/' + this.props.params.customerID + '/contacts');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var headerButtonsGoBack = void 0;
	      headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	        var goBack = function goBack() {
	          var isCustomer = _this6.props.auth.user.UserType === 4;
	          if (isCustomer) {
	            _this6.props.router.goBack();
	          }
	          _this6.props.router.replace({
	            pathname: '/customers',
	            query: {
	              customerId: _this6.props.params.customerID
	            }
	          });
	        };
	        return _react2.default.createElement(_closeButton2.default, { ariaText: t('2060'), onClick: goBack });
	      };
	
	      var isCustomer = this.props.auth.user.UserType === 4;
	      var customFilter = function customFilter(item, showInactive) {
	        // Include any items not confirmed if using this filter
	        if (_this6.state.includeNonVerified && !item.confirmed) {
	          return true;
	        }
	        if (showInactive) {
	          // Exclude unconfirmed
	          return item.confirmed;
	        }
	        return !item.inactive;
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'customers__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, pageTitleExtra: !isCustomer ? this.state.customerName : null, renderRight: this.headerButtonsRight, showBack: true, headerButtonsGoBack: headerButtonsGoBack }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create', customFilter: customFilter },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'customers__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Contacts;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getCustomerContacts: _customers.getCustomerContacts, getCustomer: _customers.getCustomer })(Contacts);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _View = __webpack_require__(412);
	
	var _View2 = _interopRequireDefault(_View);
	
	__webpack_require__(1378);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Styles
	
	
	// Utils
	
	
	var SingleCustomer = function (_Component) {
	  _inherits(SingleCustomer, _Component);
	
	  function SingleCustomer(props) {
	    _classCallCheck(this, SingleCustomer);
	
	    var _this = _possibleConstructorReturn(this, (SingleCustomer.__proto__ || Object.getPrototypeOf(SingleCustomer)).call(this, props));
	
	    _this.state = {
	      customer: {
	        CustomerId: null
	      }
	    };
	    _this.onSave = _this.onSave.bind(_this);
	    return _this;
	  }
	
	  _createClass(SingleCustomer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        customer: {
	          CustomerId: this.props.params.customerID
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.customerID !== this.props.params.customerID) {
	        this.setState({
	          customer: {
	            CustomerId: nextProps.params.customerID
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave() {
	      // Toastr
	      // window.toastr.success(translation('13464'), translation('13424'))
	    }
	  }, {
	    key: 'getCustomers',
	    value: function getCustomers() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var isCustomer = this.props.auth.user.UserType === 4;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'single_customer__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, title: isCustomer ? (0, _helpers.translation)('700') : (0, _helpers.translation)('6'), icon: 'menu/Settings-White.png' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'single_customer__screen--inner' },
	          this.state.customer.CustomerId !== null && _react2.default.createElement(_View2.default, { ref: 'view', isCustomer: true, item: this.state.customer, onSave: this.onSave, getCustomers: this.getCustomers })
	        )
	      );
	    }
	  }]);
	
	  return SingleCustomer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(SingleCustomer);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _customers = __webpack_require__(74);
	
	__webpack_require__(1380);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _helpers = __webpack_require__(2);
	
	var _View = __webpack_require__(412);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Utils
	
	
	// Views
	
	
	var Customers = function (_Component) {
	  _inherits(Customers, _Component);
	
	  function Customers(props) {
	    _classCallCheck(this, Customers);
	
	    var _this = _possibleConstructorReturn(this, (Customers.__proto__ || Object.getPrototypeOf(Customers)).call(this, props));
	
	    _this.state = {
	      view: 'list'
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    return _this;
	  }
	
	  _createClass(Customers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.getCustomers().then(function () {
	        if (_this2.props.customers.length === 0) {
	          return _this2.changeView('create');
	        }
	      });
	
	      if (typeof this.props.router.location.query.customerId !== 'undefined') {
	        this.setState({ view: 'item' });
	      }
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      if (view === 'create') this.props.setActiveCustomer(null);
	      this.setState({ view: view });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('2050'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.view.getWrappedInstance().addCustomer();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	      return this.props.customers.map(function (c) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: c.Name,
	          onClick: function onClick() {
	            return _this3.onSelectItem(c);
	          },
	          selected: c.CustomerId === _this3.props.activeCustomer.CustomerId,
	          inactive: !c.Active,
	          key: c.CustomerId
	        });
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var _this4 = this;
	
	      this.props.getCustomers().then(function () {
	        _this4.setState({
	          view: 'item'
	          // activeItem: { CustomerId: data.CustomerId }
	        });
	        _this4.props.setActiveCustomer(data.CustomerId);
	        // window.toastr.success(translation('13464'), translation('13424'))
	      });
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { ref: 'view', isCustomer: false, item: this.props.activeCustomer, getCustomers: this.props.getCustomers, onSave: this.onSave });
	      }
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.props.setActiveCustomer(item.CustomerId);
	      this.setState({ view: 'item' });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'customers__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: function renderRight() {
	            return _this5.headerButtonsRight();
	          } }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create' },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'customers__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Customers;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers,
	    activeCustomer: state.common.activeCustomer
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getCustomers: _customers.getCustomers, setActiveCustomer: _customers.setActiveCustomer })(Customers);

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _signup = __webpack_require__(411);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1381);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	// import { hasSubscriptionPermission } from '../../utils/auth'
	
	// import styles
	
	
	// import components
	
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this.state = {
	      Name: '',
	      Phone: '',
	      IsValid: false,
	      RequestSent: false
	    };
	    _this.onClickContactMe = _this.onClickContactMe.bind(_this);
	    _this.updateState = _this.updateState.bind(_this);
	    _this.upgradeRequest = _this.upgradeRequest.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      if (this.props.auth.permissions.ShopSubscriptionType === undefined || this.props.auth.permissions.ShopSubscriptionType !== 1) {
	        if (this.props.auth.user.ShopSubscriptionType === undefined || this.props.auth.user.ShopSubscriptionType !== 1) {
	          setTimeout(function () {
	            // console.log(this.props.auth.user)
	            if (_this2.props.auth.user.CustomerId !== undefined && _this2.props.auth.user.CustomerId !== '-1') {
	              _this2.props.router.push('/orders');
	              return;
	            } else {
	              if (_this2.props.auth.user.UserType === 8) {
	                _this2.props.router.push('/selectshop');
	                return;
	              } else if (_this2.props.auth.user.UserType === 1) {
	                _this2.props.router.push('/chains');
	                return;
	              } else if (_this2.props.auth.user.UserType === 6) {
	                _this2.props.router.push('/orders');
	                return;
	              } else if (_this2.props.auth.user.UserType !== undefined) {
	                console.log('go to workscreen', _this2.props.auth.user.UserType);
	                _this2.props.router.push('/workscreen');
	                return;
	              }
	            }
	          }, 200);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // console.log('Props ', this.props)
	      this.updateState(this.props.auth.user.ContactName, this.props.auth.user.ContactPhone);
	      // console.log('is new user', this.props.auth.user.IsNewUser)
	    }
	  }, {
	    key: 'upgradeRequest',
	    value: function upgradeRequest(name, phone, userId) {
	      var _this3 = this;
	
	      this.props.upgradeRequest(name, phone, userId).then(function (res) {
	        _this3.setState({
	          RequestSent: true
	        });
	      });
	    }
	  }, {
	    key: 'onClickContactMe',
	    value: function onClickContactMe(e) {
	      e.preventDefault();
	      if (this.state.Name !== '' && this.state.Phone !== '') {
	        this.upgradeRequest(this.state.Name, this.state.Phone, this.props.auth.user.UserId);
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(name, phone) {
	      var valid = name !== '' && name !== null && phone !== '' && phone !== null;
	      this.setState({
	        Name: name,
	        Phone: phone,
	        IsValid: valid
	      }, function () {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      if (this.props.auth.permissions.ShopSubscriptionType === undefined || this.props.auth.permissions.ShopSubscriptionType !== 1) return null;
	
	      var onChange = function onChange(e) {
	        var name = _this4.state.Name;
	        var phone = _this4.state.Phone;
	        switch (e.target.name) {
	          case 'name':
	            name = e.target.value;
	            break;
	          case 'phone':
	            phone = e.target.value;
	            break;
	        }
	        _this4.updateState(name, phone);
	      };
	
	      var isNewUser = this.props.auth.user.IsNewUser === true;
	      var showRequestBlock = !this.state.RequestSent;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dashboard__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, title: 'Dashboard' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          isNewUser && _react2.default.createElement(
	            'div',
	            { className: 'header_text' },
	            (0, _helpers.translation)('2134')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'block_container' },
	            !showRequestBlock && _react2.default.createElement(
	              'div',
	              { className: 'info_block' },
	              _react2.default.createElement('img', { className: 'image', src: '/images/icons/Apromas-free200x200px.png' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'info' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'block_header' },
	                  (0, _helpers.translation)('2141')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  (0, _helpers.translation)('2133')
	                )
	              )
	            ) || _react2.default.createElement(
	              'div',
	              { className: 'info_block' },
	              _react2.default.createElement('img', { className: 'image', src: '/images/icons/Apromas-free200x200px.png' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'info' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'block_header' },
	                  (0, _helpers.translation)('2138')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  (0, _helpers.translation)('2139')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  (0, _helpers.translation)('2122'),
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'http://apromas.com/da/produkt' },
	                    (0, _helpers.translation)('2123')
	                  )
	                ),
	                _react2.default.createElement(
	                  'form',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    (0, _helpers.translation)('2137')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('input', { type: 'text', name: 'name', onChange: onChange, value: this.state.Name }),
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'name' },
	                      (0, _helpers.translation)('30')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('input', { type: 'text', name: 'phone', onChange: onChange, value: this.state.Phone }),
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'phone' },
	                      (0, _helpers.translation)('38')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: this.onClickContactMe, disabled: !this.state.IsValid },
	                    (0, _helpers.translation)('2140')
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info_block' },
	              _react2.default.createElement('img', { className: 'image', src: '/images/icons/Apromas-support200x200px.png' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'info' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'block_header' },
	                  (0, _helpers.translation)('2135')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  (0, _helpers.translation)('2136'),
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'http://apromas.com/da/support' },
	                    (0, _helpers.translation)('2123')
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	Dashboard.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  upgradeRequest: _signup.upgradeRequest
	})(Dashboard);

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _DWHouse = __webpack_require__(1022);
	
	var _DWHouse2 = _interopRequireDefault(_DWHouse);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _auth = __webpack_require__(8);
	
	__webpack_require__(1382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import components
	
	// import { translation } from '../../utils/helpers'
	
	var DataWarehouse = function (_Component) {
	  _inherits(DataWarehouse, _Component);
	
	  function DataWarehouse() {
	    _classCallCheck(this, DataWarehouse);
	
	    return _possibleConstructorReturn(this, (DataWarehouse.__proto__ || Object.getPrototypeOf(DataWarehouse)).apply(this, arguments));
	  }
	
	  _createClass(DataWarehouse, [{
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30, 10)) return null;
	
	      // Get report type from url parameter or passed in reportType prop. (valid values: 0 = shop or 1 = chain)
	      var reportType = this.props.params.reportType !== undefined ? this.props.params.reportType : this.props.reportType;
	
	      if (reportType === undefined || reportType === null) {
	        console.error('ReportType ' + reportType + ' is invalid!');
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'datawarehouse__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router }),
	        _react2.default.createElement(_DWHouse2.default, { reportType: reportType })
	      );
	    }
	  }]);
	
	  return DataWarehouse;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(DataWarehouse);

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _esg = __webpack_require__(113);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _lines = __webpack_require__(839);
	
	var _lines2 = _interopRequireDefault(_lines);
	
	var _iconCycle = __webpack_require__(1071);
	
	var _iconCycle2 = _interopRequireDefault(_iconCycle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	// import Label from '../../../../../shared/elements/label'
	
	// import Inline from '../../../../../shared/elements/inline'
	
	
	var EntryRestriction = { Hide: 0, CanSee: 1, CanEnterData: 2 };
	
	var Categories = function (_Component) {
	  _inherits(Categories, _Component);
	
	  function Categories(props) {
	    _classCallCheck(this, Categories);
	
	    var _this = _possibleConstructorReturn(this, (Categories.__proto__ || Object.getPrototypeOf(Categories)).call(this, props));
	
	    _this.resetNewCategory = {
	      Name: '',
	      EntryName: '',
	      UnitName: '',
	      UnitConversionName: '',
	      CompanyEntryRestriction: 2,
	      CompanyUnitRestriction: 1,
	      CompanyConversionRestriction: 1
	    };
	
	    _this.restrictionIconSize = '16px';
	    _this.defaultCols = ['2fr', '1fr', _this.restrictionIconSize, '1fr', _this.restrictionIconSize, '2fr', _this.restrictionIconSize, 'min-content'];
	    _this.manualReportingCols = ['auto', 'min-content'];
	    _this.iconCycleList = [{ icon: _icons.ElementIcons.Edit, value: EntryRestriction.CanEnterData }, { icon: _icons.ElementIcons.Show, value: EntryRestriction.CanSee }, { icon: _icons.ElementIcons.Hide, value: EntryRestriction.Hide }];
	    _this.state = {
	      newCategory: _extends({}, _this.resetNewCategory)
	    };
	    return _this;
	  }
	
	  _createClass(Categories, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var scopeType = this.props.scopeType;
	
	      var renderCategory = function renderCategory(category, index) {
	        var changeCategoryData = function changeCategoryData(data, shouldSave) {
	          var categories = [].concat(_toConsumableArray(_this2.props.categories));
	          categories[index] = _extends({}, category, data);
	          if (categories[index].IsDeleted === true) categories.splice(index, 1);
	          _this2.props.bubbleUpChange({ Categories: categories });
	          if (shouldSave === true) saveCategory(categories[index]); // save immediatly if it was a checkbox
	        };
	
	        var saveCategory = function saveCategory() {
	          var overWriteObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	          var data = overWriteObj || category;
	          _this2.props.postCategory(data).then(function (res) {
	            changeCategoryData(res.data);
	            // window.toastr.success(translation(893), translation('13424'))
	          }, function () {
	            window.toastr.error((0, _helpers.translation)(960), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var deleteCategory = function deleteCategory() {
	          return _this2.props.onDelete(_esg.ESGLevelTypes.Category, category.Id, function () {
	            return saveCategory(_extends({}, category, { IsDeleted: true }));
	          });
	        };
	        var onCategoryChange = function onCategoryChange(_ref) {
	          var _ref$target = _ref.target,
	              value = _ref$target.value,
	              name = _ref$target.name,
	              type = _ref$target.type;
	          return changeCategoryData(_defineProperty({}, name, value), type === 'cycle');
	        };
	        var hideEntry = category.CompanyEntryRestriction === EntryRestriction.Hide;
	        var hideUnit = category.CompanyUnitRestriction === EntryRestriction.Hide;
	        var hideAmount = category.CompanyConversionRestriction === EntryRestriction.Hide;
	
	        switch (scopeType) {
	          case _esg.ESGScopeTypes.ManualReporting:
	            return _react2.default.createElement(
	              'div',
	              { key: index, className: 'pg-my-3' },
	              _react2.default.createElement(_lines2.default, { categoryId: category.Id, lines: category.Lines, scopeType: scopeType, bubbleUpChange: changeCategoryData, onDelete: _this2.props.onDelete, cols: _this2.manualReportingCols })
	            );
	          case _esg.ESGScopeTypes.Default:
	            return _react2.default.createElement(
	              'div',
	              { key: index, className: 'pg-my-3' },
	              _react2.default.createElement(
	                _tableRow2.default,
	                { header: true, cols: _this2.defaultCols, className: 'category-header' },
	                _react2.default.createElement(_text2.default, { size: 's', name: 'Name', value: category.Name, onChange: onCategoryChange, onBlur: function onBlur() {
	                    return saveCategory();
	                  } }),
	                _react2.default.createElement(_text2.default, { size: 's', name: 'EntryName', value: category.EntryName, onChange: onCategoryChange, onBlur: function onBlur() {
	                    return saveCategory();
	                  }, disabled: hideEntry }),
	                _react2.default.createElement(_iconCycle2.default, { size: 't', icons: _this2.iconCycleList, name: 'CompanyEntryRestriction', value: category.CompanyEntryRestriction, onChange: onCategoryChange }),
	                _react2.default.createElement(_text2.default, { size: 's', name: 'UnitName', value: category.UnitName, onChange: onCategoryChange, onBlur: function onBlur() {
	                    return saveCategory();
	                  }, disabled: hideUnit }),
	                _react2.default.createElement(_iconCycle2.default, { size: 't', icons: _this2.iconCycleList, name: 'CompanyUnitRestriction', value: category.CompanyUnitRestriction, onChange: onCategoryChange }),
	                _react2.default.createElement(_text2.default, { size: 's', name: 'UnitConversionName', value: category.UnitConversionName, onChange: onCategoryChange, onBlur: function onBlur() {
	                    return saveCategory();
	                  }, disabled: hideAmount }),
	                _react2.default.createElement(_iconCycle2.default, { size: 't', icons: _this2.iconCycleList.slice(1), name: 'CompanyConversionRestriction', value: category.CompanyConversionRestriction, onChange: onCategoryChange }),
	                _react2.default.createElement(_removeButton2.default, { size: 's', onClick: deleteCategory })
	              ),
	              _react2.default.createElement(_lines2.default, { categoryId: category.Id, lines: category.Lines, scopeType: scopeType, bubbleUpChange: changeCategoryData, onDelete: _this2.props.onDelete, cols: _this2.defaultCols, hideEntry: hideEntry, hideUnit: hideUnit, hideAmount: hideAmount })
	            );
	          default:
	            throw new Error('Scope type: ' + scopeType + ' is not implemented!');
	        }
	      };
	
	      var renderAddCategory = function renderAddCategory(category) {
	        if (scopeType === _esg.ESGScopeTypes.ManualReporting) return null;
	
	        var addCategory = function addCategory() {
	          var data = _extends({}, category, { scopeId: _this2.props.scopeId });
	          _this2.props.postCategory(data).then(function (res) {
	            _this2.props.bubbleUpChange({ Categories: [].concat(_toConsumableArray(_this2.props.categories), [res.data]) });
	            _this2.setState({ newCategory: _extends({}, _this2.resetNewCategory) });
	            // window.toastr.success(translation(18410), translation('13424'))
	          }, function () {
	            window.toastr.error((0, _helpers.translation)(18411), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var onCategoryChange = function onCategoryChange(_ref2) {
	          var _ref2$target = _ref2.target,
	              value = _ref2$target.value,
	              name = _ref2$target.name;
	          return _this2.setState({ newCategory: _extends({}, category, _defineProperty({}, name, value)) });
	        };
	        var hideEntry = category.CompanyEntryRestriction === 0;
	        var hideUnit = category.CompanyUnitRestriction === 0;
	        var hideAmount = category.CompanyConversionRestriction === 0;
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { header: true, cols: _this2.defaultCols, className: 'category-header' },
	          _react2.default.createElement(_text2.default, { size: 's', name: 'Name', value: category.Name, onChange: onCategoryChange }),
	          _react2.default.createElement(_text2.default, { size: 's', name: 'EntryName', value: category.EntryName, onChange: onCategoryChange, disabled: hideEntry }),
	          _react2.default.createElement(_iconCycle2.default, { size: 't', icons: _this2.iconCycleList, name: 'CompanyEntryRestriction', value: category.CompanyEntryRestriction, onChange: onCategoryChange }),
	          _react2.default.createElement(_text2.default, { size: 's', name: 'UnitName', value: category.UnitName, onChange: onCategoryChange, disabled: hideUnit }),
	          _react2.default.createElement(_iconCycle2.default, { size: 't', icons: _this2.iconCycleList, name: 'CompanyUnitRestriction', value: category.CompanyUnitRestriction, onChange: onCategoryChange }),
	          _react2.default.createElement(_text2.default, { size: 's', name: 'UnitConversionName', value: category.UnitConversionName, onChange: onCategoryChange, disabled: hideAmount }),
	          _react2.default.createElement(_iconCycle2.default, { size: 't', icons: _this2.iconCycleList.slice(1), name: 'CompanyConversionRestriction', value: category.CompanyConversionRestriction, onChange: onCategoryChange }),
	          _react2.default.createElement(_addButton2.default, { size: 's', onClick: addCategory })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'category-container' },
	        this.props.categories.map(renderCategory),
	        renderAddCategory(this.state.newCategory)
	      );
	    }
	  }]);
	
	  return Categories;
	}(_react.Component);
	
	Categories.propTypes = {
	  scopeId: _propTypes2.default.number.isRequired,
	  bubbleUpChange: _propTypes2.default.func.isRequired,
	  categories: _propTypes2.default.arrayOf(_propTypes.object).isRequired,
	  onDelete: _propTypes2.default.func.isRequired,
	  scopeType: _propTypes2.default.oneOf(Object.values(_esg.ESGScopeTypes)).isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { postCategory: _esg.postCategory })(Categories);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _esg = __webpack_require__(113);
	
	var _helpers = __webpack_require__(2);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	// components
	
	
	// sub-components
	
	
	var CompanySelection = function (_Component) {
	  _inherits(CompanySelection, _Component);
	
	  function CompanySelection(props) {
	    _classCallCheck(this, CompanySelection);
	
	    var _this = _possibleConstructorReturn(this, (CompanySelection.__proto__ || Object.getPrototypeOf(CompanySelection)).call(this, props));
	
	    _this.state = {
	      companies: [],
	      confirm: { show: false, onConfirm: function onConfirm() {} }
	    };
	    return _this;
	  }
	
	  _createClass(CompanySelection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAssociatedCompanies(this.props.schemaId, this.props.year);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.schemaId !== nextProps.schemaId || this.props.year !== nextProps.year) {
	        this.getAssociatedCompanies(nextProps.schemaId, nextProps.year);
	      }
	    }
	  }, {
	    key: 'getAssociatedCompanies',
	    value: function getAssociatedCompanies(schemaId, year) {
	      var _this2 = this;
	
	      this.props.getAssociatedCompanies(schemaId, year).then(function (res) {
	        _this2.setState({ companies: res.data });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var renderCompanyType = function renderCompanyType(department, title) {
	        var selecableCompanies = _this3.state.companies.filter(function (x) {
	          return x.Department === department && !x.IsSelected;
	        });
	        var selectedCompanies = _this3.state.companies.filter(function (x) {
	          return x.Department === department && x.IsSelected;
	        });
	
	        var removeCompany = function removeCompany(companyId) {
	          _this3.props.postRemoveCompanyFromSchema(_this3.props.schemaId, _this3.props.year, companyId).then(function (res) {
	            _this3.setState({ companies: res.data });
	            // window.toastr.success(translation(893), translation('13424'))
	          }, function () {
	            window.toastr.error((0, _helpers.translation)(960), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var onRemoveCompany = function onRemoveCompany(companyId) {
	          _this3.props.getHaveCompnyEnteredData(_this3.props.schemaId, _this3.props.year, companyId).then(function (res) {
	            if (res.data === false) removeCompany(companyId);else _this3.setState({ confirm: { show: true, onConfirm: function onConfirm() {
	                  return removeCompany(companyId);
	                } } });
	          }, function () {
	            window.toastr.error((0, _helpers.translation)(960), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var addCompany = function addCompany() {
	          if (isNaN(_this3.state[department])) {
	            window.toastr.error((0, _helpers.translation)(960), (0, _helpers.translation)('216'));
	            return;
	          }
	          _this3.props.postAddCompanyToSchema(_this3.props.schemaId, _this3.props.year, _this3.state[department]).then(function (res) {
	            _this3.setState(_defineProperty({ companies: res.data }, department, undefined));
	            // window.toastr.success(translation(893), translation('13424'))
	          }, function () {
	            window.toastr.error((0, _helpers.translation)(960), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var renderCompany = function renderCompany(company, index) {
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: ['auto', 'min-content'], key: index, spacing: 1 },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              company.CompanyName
	            ),
	            _react2.default.createElement(_removeButton2.default, { size: 's', onClick: function onClick() {
	                return onRemoveCompany(company.CompanyId);
	              } })
	          );
	        };
	
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: title },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: ['auto', 'min-content'], gap: 2, spacing: 2 },
	            _react2.default.createElement(
	              _dropDown2.default,
	              { value: _this3.state[department], onChange: function onChange(_ref) {
	                  var value = _ref.target.value;
	                  return _this3.setState(_defineProperty({}, department, value));
	                } },
	              _react2.default.createElement(
	                'option',
	                { value: '0' },
	                (0, _helpers.translation)('1896')
	              ),
	              selecableCompanies.map(function (company, k) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: k, value: company.CompanyId },
	                  company.CompanyName
	                );
	              })
	            ),
	            _react2.default.createElement(_addButton2.default, { onClick: addCompany })
	          ),
	          selectedCompanies.map(renderCompany)
	        );
	      };
	
	      var onConfirmClose = function onConfirmClose() {
	        return _this3.setState({ confirm: { show: false, onConfirm: function onConfirm() {} } });
	      };
	      var onConfirm = function onConfirm() {
	        _this3.state.confirm.onConfirm();onConfirmClose();
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderCompanyType(1, 15364),
	        renderCompanyType(0, 18409),
	        this.state.confirm.show !== false && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirmModal', onPortalClose: onConfirmClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onConfirmClose, higher: true, renderText: function renderText() {
	              return (0, _helpers.translation)(18419);
	            }, confirmText: function confirmText() {
	              return (0, _helpers.translation)(786);
	            }, notConfirmText: function notConfirmText() {
	              return (0, _helpers.translation)(570);
	            } })
	        )
	      );
	    }
	  }]);
	
	  return CompanySelection;
	}(_react.Component);
	
	CompanySelection.propTypes = {
	  schemaId: _propTypes2.default.number.isRequired,
	  year: _propTypes2.default.number.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getAssociatedCompanies: _esg.getAssociatedCompanies,
	  postAddCompanyToSchema: _esg.postAddCompanyToSchema,
	  postRemoveCompanyFromSchema: _esg.postRemoveCompanyFromSchema,
	  getHaveCompnyEnteredData: _esg.getHaveCompnyEnteredData
	})(CompanySelection);

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _esg = __webpack_require__(113);
	
	var _helpers = __webpack_require__(2);
	
	var _currency = __webpack_require__(41);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	// formatCurrency, reverseFormatCurrency
	
	
	// Elements
	
	
	var Lines = function (_Component) {
	  _inherits(Lines, _Component);
	
	  function Lines(props) {
	    _classCallCheck(this, Lines);
	
	    var _this = _possibleConstructorReturn(this, (Lines.__proto__ || Object.getPrototypeOf(Lines)).call(this, props));
	
	    _this.resetNewLine = {
	      Name: '',
	      EntryValue: '',
	      UnitValue: '',
	      AmountPrUnit: 0
	    };
	    _this.maxDecimals = 3; // maybe a precice conversion is needed
	
	    _this.state = {
	      newLine: _extends({}, _this.resetNewLine)
	    };
	    return _this;
	  }
	
	  _createClass(Lines, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var scopeType = this.props.scopeType;
	
	      var renderLine = function renderLine(line, index) {
	        var changeLineData = function changeLineData(data, shouldSave) {
	          var lines = [].concat(_toConsumableArray(_this2.props.lines));
	          lines[index] = _extends({}, line, data);
	          if (lines[index].IsDeleted === true) lines.splice(index, 1);
	          _this2.props.bubbleUpChange({ Lines: lines });
	          if (shouldSave === true) saveLine(lines[index]); // save immediatly if it was a checkbox
	        };
	
	        var saveLine = function saveLine() {
	          var overWriteObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	          var data = overWriteObj || line;
	          data.AmountPrUnit = (0, _currency.reverseFormatCurrency2)(data.AmountPrUnit);
	          _this2.props.postLine(data).then(function (res) {
	            changeLineData(res.data);
	            // window.toastr.success(translation(893), translation('13424'))
	          }, function () {
	            window.toastr.error((0, _helpers.translation)(960), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var deleteLine = function deleteLine() {
	          return _this2.props.onDelete(_esg.ESGLevelTypes.Line, line.Id, function () {
	            return saveLine(_extends({}, line, { IsDeleted: true }));
	          });
	        };
	
	        var onLineChange = function onLineChange(_ref) {
	          var _ref$target = _ref.target,
	              value = _ref$target.value,
	              name = _ref$target.name,
	              checked = _ref$target.checked,
	              type = _ref$target.type;
	
	          var isCheck = type === 'checkbox';
	          changeLineData(_defineProperty({}, name, isCheck ? checked : value), isCheck);
	        };
	
	        switch (scopeType) {
	          case _esg.ESGScopeTypes.ManualReporting:
	            return _react2.default.createElement(
	              _tableRow2.default,
	              { key: index, cols: _this2.props.cols, className: 'line' },
	              _react2.default.createElement(_text2.default, { size: 's', name: 'Name', value: line.Name, onChange: onLineChange, onBlur: function onBlur() {
	                  return saveLine();
	                } }),
	              _react2.default.createElement(_removeButton2.default, { size: 's', onClick: deleteLine })
	            );
	          case _esg.ESGScopeTypes.Default:
	            return _react2.default.createElement(
	              _tableRow2.default,
	              { key: index, cols: _this2.props.cols, className: 'line' },
	              _react2.default.createElement(_text2.default, { size: 's', name: 'Name', value: line.Name, onChange: onLineChange, onBlur: function onBlur() {
	                  return saveLine();
	                } }),
	              _react2.default.createElement(_text2.default, { size: 's', name: 'EntryValue', value: line.EntryValue, onChange: onLineChange, onBlur: function onBlur() {
	                  return saveLine();
	                }, disabled: _this2.props.hideEntry }),
	              _react2.default.createElement('div', null),
	              _react2.default.createElement(_text2.default, { size: 's', name: 'UnitValue', value: line.UnitValue, onChange: onLineChange, onBlur: function onBlur() {
	                  return saveLine();
	                }, disabled: _this2.props.hideUnit }),
	              _react2.default.createElement('div', null),
	              _react2.default.createElement(_DecimalInput2.default, { size: 's', name: 'AmountPrUnit', value: line.AmountPrUnit, onChange: onLineChange, onBlur: function onBlur() {
	                  return saveLine();
	                }, decimals: _this2.maxDecimals, disabled: _this2.props.hideAmount }),
	              _react2.default.createElement('div', null),
	              _react2.default.createElement(_removeButton2.default, { size: 's', onClick: deleteLine })
	            );
	          default:
	            throw new Error('Scope type: ' + scopeType + ' is not implemented!');
	        }
	      };
	
	      var renderAddLine = function renderAddLine(line) {
	        var addLine = function addLine() {
	          var data = _extends({}, line, { CategoryId: _this2.props.categoryId });
	          _this2.props.postLine(data).then(function (res) {
	            _this2.props.bubbleUpChange({ Lines: [].concat(_toConsumableArray(_this2.props.lines), [res.data]) });
	            _this2.setState({ newLine: _extends({}, _this2.resetNewLine) });
	            // window.toastr.success(translation(18412), translation('13424'))
	          }, function () {
	            window.toastr.error((0, _helpers.translation)(18413), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var onLineChange = function onLineChange(_ref2) {
	          var _ref2$target = _ref2.target,
	              value = _ref2$target.value,
	              name = _ref2$target.name,
	              checked = _ref2$target.checked,
	              type = _ref2$target.type;
	
	          _this2.setState({ newLine: _extends({}, line, _defineProperty({}, name, type === 'checkbox' ? checked : value)) });
	        };
	        switch (scopeType) {
	          case _esg.ESGScopeTypes.ManualReporting:
	            return _react2.default.createElement(
	              _tableRow2.default,
	              { cols: _this2.props.cols, className: 'line' },
	              _react2.default.createElement(_text2.default, { size: 's', name: 'Name', value: line.Name, onChange: onLineChange }),
	              _react2.default.createElement(_addButton2.default, { size: 's', onClick: addLine })
	            );
	          case _esg.ESGScopeTypes.Default:
	            return _react2.default.createElement(
	              _tableRow2.default,
	              { cols: _this2.props.cols, className: 'line' },
	              _react2.default.createElement(_text2.default, { size: 's', name: 'Name', value: line.Name, onChange: onLineChange }),
	              _react2.default.createElement(_text2.default, { size: 's', name: 'EntryValue', value: line.EntryValue, onChange: onLineChange, disabled: _this2.props.hideEntry }),
	              _react2.default.createElement('div', null),
	              _react2.default.createElement(_text2.default, { size: 's', name: 'UnitValue', value: line.UnitValue, onChange: onLineChange, disabled: _this2.props.hideUnit }),
	              _react2.default.createElement('div', null),
	              _react2.default.createElement(_DecimalInput2.default, { size: 's', name: 'AmountPrUnit', value: line.AmountPrUnit, onChange: onLineChange, decimals: _this2.maxDecimals, disabled: _this2.props.hideAmount }),
	              _react2.default.createElement('div', null),
	              _react2.default.createElement(_addButton2.default, { size: 's', onClick: addLine })
	            );
	          default:
	            throw new Error('Scope type: ' + scopeType + ' is not implemented!');
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'line-container' },
	        this.props.lines.map(renderLine),
	        renderAddLine(this.state.newLine)
	      );
	    }
	  }]);
	
	  return Lines;
	}(_react.Component);
	
	Lines.propTypes = {
	  categoryId: _propTypes2.default.number.isRequired,
	  bubbleUpChange: _propTypes2.default.func.isRequired,
	  lines: _propTypes2.default.arrayOf(_propTypes.object).isRequired,
	  cols: _propTypes2.default.arrayOf(_propTypes.string).isRequired,
	  onDelete: _propTypes2.default.func.isRequired,
	  hideEntry: _propTypes2.default.bool,
	  hideUnit: _propTypes2.default.bool,
	  hideAmount: _propTypes2.default.bool,
	  scopeType: _propTypes2.default.oneOf(Object.values(_esg.ESGScopeTypes)).isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { postLine: _esg.postLine })(Lines);

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _esg = __webpack_require__(113);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _categories = __webpack_require__(837);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	// components
	
	
	// sub-components
	
	
	var Scopes = function (_Component) {
	  _inherits(Scopes, _Component);
	
	  function Scopes(props) {
	    _classCallCheck(this, Scopes);
	
	    var _this = _possibleConstructorReturn(this, (Scopes.__proto__ || Object.getPrototypeOf(Scopes)).call(this, props));
	
	    _this.state = {
	      scopes: [],
	      confirm: { show: false, onConfirm: function onConfirm() {} }
	    };
	
	    _this.addScope = _this.addScope.bind(_this);
	    _this.onDelete = _this.onDelete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Scopes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getScopes(this.props.schemaId, this.props.year, this.props.scopeType);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          schemaId = _props.schemaId,
	          year = _props.year,
	          scopeType = _props.scopeType;
	
	      if (schemaId !== nextProps.schemaId || year !== nextProps.year || scopeType !== nextProps.scopeType) {
	        this.getScopes(nextProps.schemaId, nextProps.year, nextProps.scopeType);
	      }
	    }
	  }, {
	    key: 'getScopes',
	    value: function getScopes(schemaId, year, scopeType) {
	      var _this2 = this;
	
	      this.props.getScopesForYear(schemaId, year, scopeType).then(function (res) {
	        _this2.setState({ scopes: res.data });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'addScope',
	    value: function addScope() {
	      var _this3 = this;
	
	      var data = { schemaId: this.props.schemaId, year: this.props.year };
	      this.props.postScope(data).then(function (res) {
	        _this3.setState({ scopes: [].concat(_toConsumableArray(_this3.state.scopes), [res.data]) });
	        // window.toastr.success(translation(18416), translation('13424'))
	      }, function () {
	        window.toastr.error((0, _helpers.translation)(18417), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(level, id, callback) {
	      var _this4 = this;
	
	      this.props.getIsDataEntered(level, id).then(function (res) {
	        if (res.data === false) callback(); // no data is entered, delete
	        else if (res.data === true) {
	            _this4.setState({ confirm: { show: true, onConfirm: callback } });
	          }
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var scopeType = this.props.scopeType;
	
	      var renderScope = function renderScope(scope, index) {
	        var scopeNumber = index + 1;
	
	        var changeScopeData = function changeScopeData(data) {
	          var scopes = [].concat(_toConsumableArray(_this5.state.scopes));
	          scopes[index] = _extends({}, scope, data);
	          if (scopes[index].IsDeleted === true) scopes.splice(index, 1);
	          _this5.setState({ scopes: scopes });
	        };
	
	        var saveScope = function saveScope() {
	          var overWriteObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	          var data = overWriteObj || scope;
	          _this5.props.postScope(data).then(function (res) {
	            changeScopeData(res.data);
	            // window.toastr.success(translation(893), translation('13424'))
	          }, function () {
	            window.toastr.error((0, _helpers.translation)(960), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var onScopeChange = function onScopeChange(_ref) {
	          var _ref$target = _ref.target,
	              value = _ref$target.value,
	              name = _ref$target.name;
	          return changeScopeData(_defineProperty({}, name, value));
	        };
	        var deleteScope = function deleteScope() {
	          return _this5.onDelete(_esg.ESGLevelTypes.Scope, scope.Id, function () {
	            return saveScope(_extends({}, scope, { IsDeleted: true }));
	          });
	        };
	
	        switch (scopeType) {
	          case _esg.ESGScopeTypes.ManualReporting:
	            return _react2.default.createElement(
	              _col2.default,
	              { key: index, span: 3 },
	              _react2.default.createElement(
	                _panel2.default,
	                { title: 19006 },
	                _react2.default.createElement(_text2.default, { size: 's', labelText: 19007, name: 'Title', value: scope.Title, onChange: onScopeChange, onBlur: function onBlur() {
	                    return saveScope();
	                  } }),
	                _react2.default.createElement(_categories2.default, { scopeId: scope.Id, scopeType: scopeType, categories: scope.Categories, bubbleUpChange: changeScopeData, onDelete: _this5.onDelete })
	              )
	            );
	          case _esg.ESGScopeTypes.Default:
	            return _react2.default.createElement(
	              _col2.default,
	              { key: index, span: 3 },
	              _react2.default.createElement(
	                _panel2.default,
	                { title: (0, _helpers.translation)(18406) + '\xA0' + scopeNumber },
	                index > 0 && _react2.default.createElement(_removeButton2.default, { spacing: 1, onClick: deleteScope }),
	                _react2.default.createElement(_text2.default, { size: 's', labelText: (0, _helpers.translation)(18414) + '\xA0' + scopeNumber, name: 'Title', value: scope.Title, onChange: onScopeChange, onBlur: function onBlur() {
	                    return saveScope();
	                  } }),
	                _react2.default.createElement(_textarea2.default, { labelText: (0, _helpers.translation)(18415) + '\xA0' + scopeNumber, name: 'Description', value: scope.Description, onChange: onScopeChange, onBlur: function onBlur() {
	                    return saveScope();
	                  } }),
	                _react2.default.createElement(_categories2.default, { scopeId: scope.Id, scopeType: scopeType, categories: scope.Categories, bubbleUpChange: changeScopeData, onDelete: _this5.onDelete })
	              )
	            );
	          default:
	            throw new Error('Scope type: ' + scopeType + ' is not implemented!');
	        }
	      };
	
	      var onConfirmClose = function onConfirmClose() {
	        return _this5.setState({ confirm: { show: false, onConfirm: function onConfirm() {} } });
	      };
	      var onConfirm = function onConfirm() {
	        _this5.state.confirm.onConfirm();onConfirmClose();
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.scopes.map(renderScope),
	        this.state.confirm.show !== false && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirmModal', onPortalClose: onConfirmClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onConfirmClose, higher: true, renderText: function renderText() {
	              return (0, _helpers.translation)(18418);
	            }, confirmText: function confirmText() {
	              return (0, _helpers.translation)(786);
	            }, notConfirmText: function notConfirmText() {
	              return (0, _helpers.translation)(570);
	            } })
	        )
	      );
	    }
	  }]);
	
	  return Scopes;
	}(_react.Component);
	
	Scopes.propTypes = {
	  schemaId: _propTypes2.default.number.isRequired,
	  year: _propTypes2.default.number.isRequired,
	  scopeType: _propTypes2.default.oneOf(Object.values(_esg.ESGScopeTypes)).isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getScopesForYear: _esg.getScopesForYear,
	  postScope: _esg.postScope,
	  getIsDataEntered: _esg.getIsDataEntered
	}, null, { withRef: true })(Scopes);

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _esg = __webpack_require__(113);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _helpers = __webpack_require__(2);
	
	var _scopes = __webpack_require__(840);
	
	var _scopes2 = _interopRequireDefault(_scopes);
	
	var _companySelection = __webpack_require__(838);
	
	var _companySelection2 = _interopRequireDefault(_companySelection);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _modalHeader = __webpack_require__(176);
	
	var _modalHeader2 = _interopRequireDefault(_modalHeader);
	
	__webpack_require__(253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Elements
	
	
	// Utils
	
	
	// Subcomponents
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.resetSchema = {
	      Id: 0,
	      Name: '',
	      IsActive: true,
	      StartYear: new Date().getFullYear()
	    };
	    _this.state = {
	      type: 'edit',
	      schema: _this.resetSchema,
	      selectableYears: [],
	      selectedYear: 0,
	      showPortal: false
	
	      // add years 10 years back and in future
	    };_this.selectableStartYears = [];
	    for (var i = -10; i <= 10; i++) {
	      _this.selectableStartYears.push(new Date().getFullYear() + i);
	    }
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onInputChangeSave = _this.onInputChangeSave.bind(_this);
	    _this.updateSchema = _this.updateSchema.bind(_this);
	    _this.saveAddSchema = _this.saveAddSchema.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSelectableSchemaYears(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.Id !== nextProps.item.Id) {
	        this.getSelectableSchemaYears(nextProps);
	      }
	    }
	  }, {
	    key: 'getSelectableSchemaYears',
	    value: function getSelectableSchemaYears(props) {
	      var _this2 = this;
	
	      if (typeof props.item.Id !== 'undefined' && props.item.Id > 0) {
	        this.setState({ schema: props.item });
	        this.props.getSelectableSchemaYears(props.item.Id).then(function (res) {
	          _this2.setState({
	            selectableYears: res.data,
	            selectedYear: res.data.at(-1)
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'updateSchema',
	    value: function updateSchema() {
	      var _this3 = this;
	
	      this.props.postSchema(this.state.schema).then(function (res) {
	        _this3.props.onSave(res.data, _this3.state.type);
	        var newState = { schema: res.data };
	        if (_this3.state.type === 'create') {
	          newState.type = 'edit';
	        }
	        _this3.setState(_extends({}, newState));
	        _this3.props.updateListItem(newState.schema);
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('18408'), (0, _helpers.translation)('216'));
	        // if (Array.isArray(err.response.data.Errors) && err.response.data.Errors.length > 0) {
	        //   let errors = err.response.data.Errors
	        //   let errText = ''
	        //   for (let i = 0; i < errors.length; i++) {
	        //     let dictKey = errors[i].DictionaryKey
	        //     if (errText !== '') errText += '<br/>'
	        //     errText += translation(dictKey)
	        //   }
	        //   window.toastr.error(translation(errText), translation('216'))
	        // } else {
	        //   window.toastr.error(translation('18408'), translation('216'))
	        // }
	      });
	    }
	  }, {
	    key: 'saveAddSchema',
	    value: function saveAddSchema() {
	      if (this.state.type !== 'create') this.updateSchema();
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(name, e) {
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (e === undefined) {
	          e = name;
	        }
	        name = e.target.name;
	        value = e.target.value;
	      }
	
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	
	      this.setState({
	        schema: _extends({}, this.state.schema, _defineProperty({}, name, value))
	      });
	    }
	  }, {
	    key: 'onInputChangeSave',
	    value: function onInputChangeSave(name, e) {
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (e === undefined) {
	          e = name;
	        }
	        name = e.target.name;
	        value = e.target.value;
	      }
	
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	
	      this.setState({
	        schema: _extends({}, this.state.schema, _defineProperty({}, name, value))
	      }, this.saveAddSchema);
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        schema: this.resetSchema
	      });
	    }
	  }, {
	    key: 'renderSchema',
	    value: function renderSchema() {
	      var schema = this.state.schema;
	      var isCreate = this.state.type === 'create';
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('18404') },
	        _react2.default.createElement(_text2.default, { name: 'Name', value: schema.Name || '', onChange: this.onInputChange, onBlur: this.saveAddSchema, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_switch2.default, { name: 'IsActive', checked: schema.IsActive || false, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)('295') }),
	        isCreate && _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'StartYear', value: schema.StartYear, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)(18428) },
	          this.selectableStartYears.map(function (year, k) {
	            return _react2.default.createElement(
	              'option',
	              { key: k, value: year },
	              year
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'rederAddScope',
	    value: function rederAddScope() {
	      var _this4 = this;
	
	      if (!(this.state.selectedYear > 0) || this.state.type === 'create') return null;
	
	      var addScope = function addScope() {
	        _this4.refs.scopes.getWrappedInstance().addScope();
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(18405) },
	        _react2.default.createElement(_button2.default, { style: 'secondary', onClick: addScope, labelText: (0, _helpers.translation)('1208') })
	      );
	    }
	  }, {
	    key: 'renderYear',
	    value: function renderYear() {
	      var _this5 = this;
	
	      if (!(this.state.schema.Id > 0) || this.state.type === 'create') return null;
	
	      var createYear = function createYear(isCopy) {
	        closePortal();
	        _this5.props.postCreateNewChemaYear(_this5.state.schema.Id, isCopy ? _this5.state.selectedYear : undefined).then(function (res) {
	          _this5.setState({
	            selectableYears: res.data,
	            selectedYear: res.data.at(-1)
	          });
	          // window.toastr.success(translation(18424), translation('13424'))
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        });
	      };
	
	      var onChange = function onChange(item) {
	        _this5.setState({ selectedYear: parseInt(item.target.value) });
	      };
	
	      var openPortal = function openPortal() {
	        return _this5.setState({ showPortal: true });
	      };
	      var closePortal = function closePortal() {
	        return _this5.setState({ showPortal: false });
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(18407) },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { value: this.state.selectedYear, onChange: onChange, labelText: (0, _helpers.translation)(18407) },
	          this.state.selectableYears.map(function (year, k) {
	            return _react2.default.createElement(
	              'option',
	              { key: k, value: year },
	              year
	            );
	          })
	        ),
	        _react2.default.createElement(_button2.default, { style: 'secondary', onClick: openPortal, labelText: (0, _helpers.translation)(18420) }),
	        this.state.showPortal === true && _react2.default.createElement(
	          _Portal2.default,
	          { onPortalClose: closePortal },
	          _react2.default.createElement(
	            'div',
	            { className: 'confirm__modal__wrapper' },
	            _react2.default.createElement('div', { className: 'backdrop__modal' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'confirm__modal schema_newYear_modal' },
	              _react2.default.createElement(
	                'div',
	                { className: 'confirm__content' },
	                _react2.default.createElement(_modalHeader2.default, { text: (0, _helpers.translation)(18420) }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pg-pb-2' },
	                  (0, _helpers.translation)(18423, { nextYear: this.state.selectableYears.at(-1) + 1, selectedYear: this.state.selectedYear })
	                )
	              ),
	              _react2.default.createElement(
	                _bottomBar2.default,
	                {
	                  actionStyle: 'secondary',
	                  actionLabelText: (0, _helpers.translation)(18421),
	                  onActionClick: function onActionClick() {
	                    return createYear(true);
	                  },
	                  cancelLabelText: (0, _helpers.translation)(570),
	                  onCancelClick: closePortal },
	                _react2.default.createElement(_button2.default, { spacing: 0, style: 'secondary', onClick: function onClick() {
	                    return createYear(false);
	                  }, labelText: (0, _helpers.translation)(18422) })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCompanySelection',
	    value: function renderCompanySelection() {
	      if (!(this.state.selectedYear > 0) || this.state.type === 'create') return null;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(1861) },
	        _react2.default.createElement(_companySelection2.default, { schemaId: this.state.schema.Id, year: this.state.selectedYear })
	      );
	    }
	  }, {
	    key: 'renderScopes',
	    value: function renderScopes() {
	      if (!(this.state.selectedYear > 0) || this.state.type === 'create') return null;
	
	      return [_react2.default.createElement(_scopes2.default, { key: 0, schemaId: this.state.schema.Id, year: this.state.selectedYear, scopeType: _esg.ESGScopeTypes.ManualReporting }), _react2.default.createElement(_scopes2.default, { key: 1, ref: 'scopes', schemaId: this.state.schema.Id, year: this.state.selectedYear, scopeType: _esg.ESGScopeTypes.Default })];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderSchema(),
	          this.renderYear(),
	          this.renderCompanySelection(),
	          this.rederAddScope()
	        ),
	        this.renderScopes()
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  postSchema: _esg.postSchema,
	  getSelectableSchemaYears: _esg.getSelectableSchemaYears,
	  getAssociatedCompanies: _esg.getAssociatedCompanies,
	  postCreateNewChemaYear: _esg.postCreateNewChemaYear
	}, null, { withRef: true })(View);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _esg = __webpack_require__(113);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _View = __webpack_require__(841);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import components
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var ESGChain = function (_Component) {
	  _inherits(ESGChain, _Component);
	
	  function ESGChain(props) {
	    _classCallCheck(this, ESGChain);
	
	    var _this = _possibleConstructorReturn(this, (ESGChain.__proto__ || Object.getPrototypeOf(ESGChain)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      search: '',
	      includeInactive: false,
	      schemas: [],
	      activeItem: {}
	    };
	
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    _this.updateListItem = _this.updateListItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(ESGChain, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSchemas();
	
	      var schemaId = this.props.router.location.query.schemaId;
	      if (!isNaN(schemaId)) {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            Id: parseInt(schemaId)
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getSchemas',
	    value: function getSchemas() {
	      var _this2 = this;
	
	      this.props.getChainSchemas().then(function (res) {
	        _this2.setState({
	          schemas: res.data
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var schemas = [].concat(_toConsumableArray(this.state.schemas));
	      var activeItem = { Id: data.Id };
	
	      if (type === 'create') {
	        schemas.push(_extends({}, data));
	        // Toastr
	        // window.toastr.success(translation('18403'), translation('13424'))
	      } else {
	        schemas.map(function (val, key) {
	          if (val.Id === data.Id) {
	            val = _extends({}, data);
	          }
	        });
	        // Toastr
	        // window.toastr.success(translation('18402'), translation('13424'))
	      }
	
	      this.setState({
	        schemas: schemas,
	        view: 'item',
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var _this3 = this;
	
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        this.setState({
	          view: view,
	          activeItem: {}
	        }, function () {
	          return _this3.refs.view.getWrappedInstance().resetCreate();
	        });
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('16432'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({ search: e.target.value });
	      }
	      if (e.target.name === 'Inactive') {
	        this.setState({ includeInactive: e.target.checked });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      if (key.Name === null || key.Name === undefined) {
	        return false;
	      }
	      if (this.state.search === undefined || this.state.search === null) {
	        return true;
	      }
	      if (key.Name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.IsActive : true)) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this4 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this4.refs.view.getWrappedInstance().updateSchema();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.schemas.map(function (s) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: s.Name,
	          onClick: function onClick() {
	            return _this4.onSelectItem(s);
	          },
	          selected: s.Id === _this4.state.activeItem.Id,
	          inactive: !s.IsActive,
	          key: s.Id
	        });
	      });
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'updateListItem',
	    value: function updateListItem(item) {
	      var itemIndex = this.state.schemas.findIndex(function (x) {
	        return x.Id === item.Id;
	      });
	      var newArray = [].concat(_toConsumableArray(this.state.schemas));
	      newArray[itemIndex] = item;
	      this.setState({ schemas: newArray });
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { updateListItem: this.updateListItem, ref: 'view', item: this.state.activeItem, onSave: this.onSave });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'schemas__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, icon: 'menu/Customers-White.png', renderRight: function renderRight() {
	            return _this5.headerButtonsRight();
	          } }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create' },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'schemas__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return ESGChain;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getChainSchemas: _esg.getChainSchemas,
	  postSchema: _esg.postSchema
	})(ESGChain);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _esg = __webpack_require__(113);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	__webpack_require__(253);
	
	var _categories = __webpack_require__(413);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	// import LabelWrapper from '../../../../shared/elements/labelWrapper'
	// import Label from '../../../../shared/elements/label'
	
	
	var ManualReporting = function (_Component) {
	  _inherits(ManualReporting, _Component);
	
	  function ManualReporting(props) {
	    _classCallCheck(this, ManualReporting);
	
	    var _this = _possibleConstructorReturn(this, (ManualReporting.__proto__ || Object.getPrototypeOf(ManualReporting)).call(this, props));
	
	    _this.state = {
	      isUsingManualReporting: false,
	      scopes: []
	    };
	    _this.cols = ['3fr', [2, 2], [6, 1]];
	    _this.maxDecimals = 3;
	    return _this;
	  }
	
	  _createClass(ManualReporting, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData(this.props.schemaId, this.props.year);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.schemaId !== nextProps.schemaId || this.props.year !== nextProps.year) {
	        this.getData(nextProps.schemaId, nextProps.year);
	      }
	    }
	  }, {
	    key: 'getData',
	    value: function getData(schemaId, year) {
	      var _this2 = this;
	
	      this.props.getIsCompanyUsingManualReportingForSchemaYear(schemaId, year).then(function (res) {
	        _this2.setState({ isUsingManualReporting: res.data });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	
	      this.props.getCompanyScopesForSchemaYear(schemaId, year, _esg.ESGScopeTypes.ManualReporting).then(function (res) {
	        _this2.setState({ scopes: res.data });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // Hide this section if there doest not exist any scopes of type "ManualReporting" or there are no lines
	      if (this.state.scopes.length === 0 || !this.state.scopes.some(function (scope) {
	        return scope.Categories.some(function (cat) {
	          return cat.Lines.length > 0;
	        });
	      })) return null;
	
	      var renderScope = function renderScope(scope, index) {
	        var applyScopeChange = function applyScopeChange(change) {
	          var scopes = [].concat(_toConsumableArray(_this3.state.scopes));
	          scopes[index] = _extends({}, scope, change);
	          _this3.setState({ scopes: scopes });
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'category-container' },
	          _react2.default.createElement(_categories2.default, { categories: scope.Categories, bubbleUpChange: applyScopeChange, disableAllInput: !_this3.state.isUsingManualReporting })
	        );
	      };
	
	      var updateIsUsingManualReporting = function updateIsUsingManualReporting(_ref) {
	        var checked = _ref.target.checked;
	
	        _this3.props.postIsCompanyUsingManualReportingForSchemaYear(_this3.props.schemaId, _this3.props.year, checked).then(function (res) {
	          _this3.setState({ isUsingManualReporting: res.data });
	          window.toastr.success((0, _helpers.translation)(893), (0, _helpers.translation)('13424'));
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        });
	      };
	
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { id: 'scope-col' },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: this.state.scopes[0].Title },
	            _react2.default.createElement(_switch2.default, { checked: this.state.isUsingManualReporting, onChange: updateIsUsingManualReporting, labelText: 19008, spacing: 0 })
	          ),
	          this.state.scopes.map(renderScope)
	        )
	      );
	    }
	  }]);
	
	  return ManualReporting;
	}(_react.Component);
	
	ManualReporting.propTypes = {
	  schemaId: _propTypes2.default.number.isRequired,
	  year: _propTypes2.default.number.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getCompanyScopesForSchemaYear: _esg.getCompanyScopesForSchemaYear,
	  getIsCompanyUsingManualReportingForSchemaYear: _esg.getIsCompanyUsingManualReportingForSchemaYear,
	  postIsCompanyUsingManualReportingForSchemaYear: _esg.postIsCompanyUsingManualReportingForSchemaYear
	})(ManualReporting);

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _esg = __webpack_require__(113);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	__webpack_require__(253);
	
	var _categories = __webpack_require__(413);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var Scopes = function (_Component) {
	  _inherits(Scopes, _Component);
	
	  function Scopes(props) {
	    _classCallCheck(this, Scopes);
	
	    var _this = _possibleConstructorReturn(this, (Scopes.__proto__ || Object.getPrototypeOf(Scopes)).call(this, props));
	
	    _this.state = {
	      scopes: []
	    };
	    _this.cols = ['3fr', [2, 2], [6, 1]];
	    _this.maxDecimals = 3;
	    return _this;
	  }
	
	  _createClass(Scopes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getScopes(this.props.schemaId, this.props.year);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.schemaId !== nextProps.schemaId || this.props.year !== nextProps.year) {
	        this.getScopes(nextProps.schemaId, nextProps.year);
	      }
	    }
	  }, {
	    key: 'getScopes',
	    value: function getScopes(schemaId, year) {
	      var _this2 = this;
	
	      this.props.getCompanyScopesForSchemaYear(schemaId, year, _esg.ESGScopeTypes.Default).then(function (res) {
	        _this2.setState({ scopes: res.data });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var renderScope = function renderScope(scope, index) {
	        var applyScopeChange = function applyScopeChange(change) {
	          var scopes = [].concat(_toConsumableArray(_this3.state.scopes));
	          scopes[index] = _extends({}, scope, change);
	          _this3.setState({ scopes: scopes });
	        };
	
	        return _react2.default.createElement(
	          _row2.default,
	          { key: index },
	          _react2.default.createElement(
	            _col2.default,
	            { id: 'scope-col', key: index },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: ' ' },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { className: 'scope-title', labelText: scope.Title },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  scope.Description
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'category-container' },
	              _react2.default.createElement(
	                _panel2.default,
	                { title: function title() {} },
	                _react2.default.createElement(_categories2.default, { categories: scope.Categories, bubbleUpChange: applyScopeChange })
	              )
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.scopes.map(renderScope)
	      );
	    }
	  }]);
	
	  return Scopes;
	}(_react.Component);
	
	Scopes.propTypes = {
	  schemaId: _propTypes2.default.number.isRequired,
	  year: _propTypes2.default.number.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getCompanyScopesForSchemaYear: _esg.getCompanyScopesForSchemaYear
	})(Scopes);

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _esg = __webpack_require__(113);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _helpers = __webpack_require__(2);
	
	var _scopes = __webpack_require__(844);
	
	var _scopes2 = _interopRequireDefault(_scopes);
	
	__webpack_require__(1383);
	
	var _manualReporting = __webpack_require__(843);
	
	var _manualReporting2 = _interopRequireDefault(_manualReporting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import components
	
	
	// Elements
	
	
	// Utils
	
	
	var ESGCompany = function (_Component) {
	  _inherits(ESGCompany, _Component);
	
	  function ESGCompany(props) {
	    _classCallCheck(this, ESGCompany);
	
	    var _this = _possibleConstructorReturn(this, (ESGCompany.__proto__ || Object.getPrototypeOf(ESGCompany)).call(this, props));
	
	    _this.defaultAssociation = { Name: '', SchemaId: 0, Years: [], SelectedYear: 0 };
	    _this.state = {
	      associations: [],
	      slecectedAssociation: _this.defaultAssociation
	    };
	    return _this;
	  }
	
	  _createClass(ESGCompany, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.getCompanySchemaAssociations().then(function (res) {
	        _this2.setState({
	          associations: res.data,
	          slecectedAssociation: _this2.defaultAssociation // res.data.at(-1)
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)(960), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderSchemaSelector',
	    value: function renderSchemaSelector() {
	      var _this3 = this;
	
	      var _state$slecectedAssoc = this.state.slecectedAssociation,
	          SelectedYear = _state$slecectedAssoc.SelectedYear,
	          Years = _state$slecectedAssoc.Years,
	          Name = _state$slecectedAssoc.Name;
	
	
	      var onChange = function onChange(_ref) {
	        var value = _ref.target.value;
	        return _this3.setState({ slecectedAssociation: _extends({}, _this3.state.slecectedAssociation, { SelectedYear: value }) });
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: Name },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { value: SelectedYear, onChange: onChange, labelText: (0, _helpers.translation)(18407) },
	          _react2.default.createElement(
	            'option',
	            { key: 'default', value: 0 },
	            (0, _helpers.translation)(18427)
	          ),
	          Years.map(function (obj, k) {
	            return _react2.default.createElement(
	              'option',
	              { key: k, value: obj },
	              obj
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state$slecectedAssoc2 = this.state.slecectedAssociation,
	          SchemaId = _state$slecectedAssoc2.SchemaId,
	          SelectedYear = _state$slecectedAssoc2.SelectedYear;
	
	
	      var renderList = function renderList() {
	        return _this4.state.associations.map(function (s) {
	          return _react2.default.createElement(_sideMenuItem2.default, {
	            label: s.Name,
	            onClick: function onClick() {
	              return _this4.setState({ slecectedAssociation: s });
	            },
	            selected: s.SchemaId === SchemaId,
	            key: s.SchemaId
	          });
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'schema_screen' },
	        _react2.default.createElement(_Header2.default, null),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: true, hideInactiveCheck: true },
	          renderList()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'schemas__screen--inner' },
	          SchemaId > 0 && _react2.default.createElement(
	            _row2.default,
	            null,
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              this.renderSchemaSelector()
	            )
	          ),
	          SchemaId > 0 && SelectedYear > 0 && _react2.default.createElement(_manualReporting2.default, { schemaId: SchemaId, year: SelectedYear }),
	          SchemaId > 0 && SelectedYear > 0 && _react2.default.createElement(_scopes2.default, { schemaId: SchemaId, year: SelectedYear })
	        )
	      );
	    }
	  }]);
	
	  return ESGCompany;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getCompanySchemaAssociations: _esg.getCompanySchemaAssociations
	})(ESGCompany);

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _embeddedbooking = __webpack_require__(149);
	
	var _orders = __webpack_require__(21);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1384);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// Elements
	
	
	// utils
	
	
	// Icons
	
	
	// styles
	
	
	var CarDataView = function (_Component) {
	  _inherits(CarDataView, _Component);
	
	  function CarDataView(props) {
	    _classCallCheck(this, CarDataView);
	
	    var _this = _possibleConstructorReturn(this, (CarDataView.__proto__ || Object.getPrototypeOf(CarDataView)).call(this, props));
	
	    _this.state = {
	      CarData: {
	        IsDirty: _this.props.CarData.IsDirty,
	        RegNumber: _this.props.CarData.RegNumber,
	        BrandNameId: _this.props.CarData.BrandNameId,
	        Model: _this.props.CarData.Model,
	        ChassisNumber: _this.props.CarData.ChassisNumber,
	        Km: _this.props.CarData.Km,
	        DamageComment: _this.props.CarData.DamageComment
	      },
	      BrandNameError: false,
	      ModelError: false,
	      KmError: false
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onRegBlur = _this.onRegBlur.bind(_this);
	    _this.onRegNrChange = _this.onRegNrChange.bind(_this);
	    _this.checkAndNav = _this.checkAndNav.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarDataView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        CarData: this.props.CarData
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      var value = e.target.value;
	      var names = e.target.name.split('.');
	      if (names[1] === 'Km') value = parseInt(e.target.value);
	      this.setState({
	        CarData: _extends({}, this.state.CarData, _defineProperty({}, names[1], value)),
	        BrandNameError: false,
	        ModelError: false,
	        KmError: false
	      }, function () {
	        if (names[1] === 'BrandNameId') {
	          _this2.props.setEmbeddedBookingCardata(_this2.state.CarData);
	          _this2.props.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'checkAndNav',
	    value: function checkAndNav(e, opt) {
	      e.persist();
	      var CarData = this.state.CarData;
	
	      var brandNameError = CarData.BrandNameId === 1; // Unknown brand
	      var modelError = CarData.Model === null || CarData.Model.length === 0;
	      var kmError = CarData.Km < 1;
	      if (brandNameError || modelError || kmError) {
	        this.setState({
	          BrandNameError: brandNameError,
	          ModelError: modelError,
	          KmError: kmError
	        });
	      } else {
	        this.props.onNavClick(e, opt);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.props.onBlur(e);
	    }
	  }, {
	    key: 'onRegBlur',
	    value: function onRegBlur() {
	      var _this3 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (!_this3.state.CarData.RegNumber || _this3.state.CarData.RegNumber.length === 0) {
	          var updateData = {
	            CarData: {
	              IsDirty: true,
	              RegNumber: '',
	              BrandNameId: null,
	              Model: null,
	              ChassisNumber: null,
	              Km: null
	            }
	          };
	          _this3.props.saveEmbeddedBooking(updateData).then(function (res) {
	            return resolve && resolve();
	          });
	          return;
	        }
	        _this3.props.getOrderVehicleData(_this3.state.CarData.RegNumber, 'RegNumber').then(function (res) {
	          _this3.setState({
	            CarData: _extends({}, _this3.state.CarData, {
	              RegNumber: res.data.RegNr,
	              BrandNameId: res.data.BrandNameId,
	              Model: res.data.Model,
	              ChassisNumber: res.data.ChassisNumber
	            }),
	            regNumberChecked: true
	          }, function () {
	            var updateData = {
	              CarData: {
	                IsDirty: true,
	                RegNumber: _this3.state.CarData.RegNumber,
	                BrandNameId: _this3.state.CarData.BrandNameId,
	                Model: _this3.state.CarData.Model,
	                ChassisNumber: _this3.state.CarData.ChassisNumber,
	                Km: null
	              }
	            };
	            _this3.props.saveEmbeddedBooking(updateData).then(function (res) {
	              return resolve && resolve();
	            });
	          });
	        }).catch(function () {
	          resolve && resolve();
	        });
	      });
	    }
	  }, {
	    key: 'onRegNrChange',
	    value: function onRegNrChange(e) {
	      var value = e.target.value;
	
	      this.setState({
	        CarData: _extends({}, this.state.CarData, {
	          RegNumber: value
	        }),
	        regNumberChecked: false,
	        regNumberError: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var CarData = this.state.CarData;
	
	      var requiredBrandNameClass = this.state.BrandNameError ? 'required' : '';
	      var requiredModelClass = this.state.ModelError ? 'required' : '';
	      var requiredKmClass = this.state.KmError ? 'required' : '';
	      // <option value='0'>{translation(145)}</option>
	
	      var renderWithRegFlow = function renderWithRegFlow() {
	        var leftChildren = true;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'reg' },
	          _react2.default.createElement(
	            'article',
	            { className: 'main' },
	            _this4.props.children,
	            _react2.default.createElement(
	              'h1',
	              null,
	              (0, _helpers.translation)(77)
	            ),
	            _react2.default.createElement(_text2.default, { className: requiredKmClass, name: 'CarData.Km', value: CarData.Km || '', onChange: _this4.onChange, onBlur: _this4.onBlur, helpText: (0, _helpers.translation)(16846), placeholder: (0, _helpers.translation)(860) }),
	            _react2.default.createElement(_textarea2.default, { name: 'CarData.DamageComment', placeholder: (0, _helpers.translation)(1021), value: CarData.DamageComment || '', onChange: _this4.onChange, onBlur: _this4.onBlur }),
	            _react2.default.createElement(_text2.default, { className: _this4.state.regNumberError ? 'required' : '', name: 'CarData.RegNumber', value: CarData.RegNumber || '', onChange: _this4.onRegNrChange, onBlur: _this4.onRegBlur, placeholder: (0, _helpers.translation)(2005) }),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { className: requiredBrandNameClass, name: 'CarData.BrandNameId', value: CarData.BrandNameId, onChange: _this4.onChange },
	              _this4.props.Brands.map(function (val, index) {
	                var brandName = val.Id === 1 ? (0, _helpers.translation)(val.Name) : val.Name;
	                return val.Id === _this4.state.CarData.BrandNameId ? _react2.default.createElement(
	                  'option',
	                  { value: val.Id, key: index, selected: true },
	                  brandName
	                ) : _react2.default.createElement(
	                  'option',
	                  { value: val.Id, key: index },
	                  brandName
	                );
	              })
	            ),
	            _react2.default.createElement(_text2.default, { className: requiredModelClass, name: 'CarData.Model', value: CarData.Model || '', onChange: _this4.onChange, onBlur: _this4.onBlur, placeholder: (0, _helpers.translation)(146) }),
	            _react2.default.createElement(_text2.default, { name: 'CarData.ChassisNumber', value: CarData.ChassisNumber || '', onChange: _this4.onChange, onBlur: _this4.onBlur, helpText: (0, _helpers.translation)(16845), placeholder: (0, _helpers.translation)(81) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'ctaWrapper' },
	              _react2.default.createElement(
	                _button2.default,
	                { style: 'secondary', labelText: (0, _helpers.translation)('394'), onClick: function onClick(e) {
	                    return _this4.props.onNavClick(e, 'previous');
	                  }, leftChildren: leftChildren },
	                _react2.default.createElement(_icon2.default, {
	                  size: 's',
	                  icon: _icons.EmbeddedBookingIcons.Left_Arrow,
	                  injectSvg: true
	                })
	              ),
	              _react2.default.createElement(
	                _button2.default,
	                { labelText: (0, _helpers.translation)(237), onClick: function onClick(e) {
	                    return _this4.checkAndNav(e, 'next');
	                  } },
	                _react2.default.createElement(_icon2.default, {
	                  size: 's',
	                  icon: _icons.EmbeddedBookingIcons.Right_Arrow,
	                  injectSvg: true
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            { className: 'side' },
	            _react2.default.createElement(
	              'section',
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                (0, _helpers.translation)(18432)
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                (0, _helpers.translation)(18433)
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  (0, _helpers.translation)(18434)
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  (0, _helpers.translation)(18435)
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  (0, _helpers.translation)(18436)
	                )
	              )
	            )
	          )
	        );
	      };
	
	      var renderNoRegFlow = function renderNoRegFlow() {
	        // <option value='0'>{translation(145)}</option>
	        var leftChildren = true;
	        return _react2.default.createElement(
	          'div',
	          { className: 'noReg' },
	          _react2.default.createElement(
	            'article',
	            { className: 'main' },
	            _this4.props.children,
	            _react2.default.createElement(
	              'h1',
	              null,
	              (0, _helpers.translation)(77)
	            ),
	            _react2.default.createElement(_text2.default, { className: requiredKmClass, name: 'CarData.Km', value: CarData.Km || '', onChange: _this4.onChange, onBlur: _this4.onBlur, helpText: (0, _helpers.translation)(16846), placeholder: (0, _helpers.translation)(860) }),
	            _react2.default.createElement(_textarea2.default, { name: 'CarData.DamageComment', placeholder: (0, _helpers.translation)(1021), value: CarData.DamageComment || '', onChange: _this4.onChange, onBlur: _this4.onBlur }),
	            _react2.default.createElement(_text2.default, { className: _this4.state.regNumberError ? 'required' : '', name: 'CarData.RegNumber', value: CarData.RegNumber || '', onChange: _this4.onRegNrChange, onBlur: _this4.onRegBlur, placeholder: (0, _helpers.translation)(2005) }),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { className: requiredBrandNameClass, name: 'CarData.BrandNameId', value: CarData.BrandNameId, onChange: _this4.onChange },
	              _this4.props.Brands.map(function (val, index) {
	                var brandName = val.Id === 1 ? (0, _helpers.translation)(val.Name) : val.Name;
	                return val.Id === _this4.state.CarData.BrandNameId ? _react2.default.createElement(
	                  'option',
	                  { value: val.Id, key: index, selected: true },
	                  brandName
	                ) : _react2.default.createElement(
	                  'option',
	                  { value: val.Id, key: index },
	                  brandName
	                );
	              })
	            ),
	            _react2.default.createElement(_text2.default, { className: requiredModelClass, name: 'CarData.Model', value: CarData.Model || '', onChange: _this4.onChange, onBlur: _this4.onBlur, placeholder: (0, _helpers.translation)(146) }),
	            _react2.default.createElement(_text2.default, { name: 'CarData.ChassisNumber', value: CarData.ChassisNumber || '', onChange: _this4.onChange, onBlur: _this4.onBlur, helpText: (0, _helpers.translation)(16845), placeholder: (0, _helpers.translation)(81) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'ctaWrapper' },
	              _react2.default.createElement(
	                _button2.default,
	                { style: 'secondary', labelText: (0, _helpers.translation)('394'), onClick: function onClick(e) {
	                    return _this4.props.onNavClick(e, 'previous');
	                  }, leftChildren: leftChildren },
	                _react2.default.createElement(_icon2.default, {
	                  size: 's',
	                  icon: _icons.EmbeddedBookingIcons.Left_Arrow,
	                  injectSvg: true
	                })
	              ),
	              _react2.default.createElement(
	                _button2.default,
	                { labelText: (0, _helpers.translation)(237), onClick: function onClick(e) {
	                    return _this4.checkAndNav(e, 'next');
	                  } },
	                _react2.default.createElement(_icon2.default, {
	                  size: 's',
	                  icon: _icons.EmbeddedBookingIcons.Right_Arrow,
	                  injectSvg: true
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            { className: 'side' },
	            _react2.default.createElement(
	              'section',
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                (0, _helpers.translation)(18432)
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                (0, _helpers.translation)(18433)
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  (0, _helpers.translation)(18434)
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  (0, _helpers.translation)(18435)
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  (0, _helpers.translation)(18436)
	                )
	              )
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'car-data__view' },
	        this.props.flowType === 'with_regnr' ? renderWithRegFlow() : renderNoRegFlow()
	      );
	    }
	  }]);
	
	  return CarDataView;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    Brands: state.common.brands,
	    CarData: state.embeddedbooking.CarData,
	    EmbeddedBooking: state.embeddedbooking
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { setEmbeddedBookingCardata: _embeddedbooking.setEmbeddedBookingCardata, saveEmbeddedBooking: _embeddedbooking.saveEmbeddedBooking, getOrderVehicleData: _orders.getOrderVehicleData })(CarDataView);

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _embeddedbooking = __webpack_require__(149);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// Components
	
	
	// Elements
	
	
	// utils
	
	
	// Icons
	
	
	// Styles
	
	
	var ContactInfoView = function (_Component) {
	  _inherits(ContactInfoView, _Component);
	
	  function ContactInfoView(props) {
	    _classCallCheck(this, ContactInfoView);
	
	    var _this = _possibleConstructorReturn(this, (ContactInfoView.__proto__ || Object.getPrototypeOf(ContactInfoView)).call(this, props));
	
	    _this.state = {
	      ContactInfo: {
	        ContactName: null,
	        ContactLastName: null,
	        ContactEmail: null,
	        PhoneCode: _this.props.phonecode,
	        ContactPhone: null,
	        Address: null,
	        ZipCode: null,
	        City: null
	      },
	      NameError: false,
	      LastNameError: false,
	      EmailError: false,
	      PhoneError: false
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.onPhoneBlur = _this.onPhoneBlur.bind(_this);
	    _this.checkAndNav = _this.checkAndNav.bind(_this);
	    return _this;
	  }
	
	  _createClass(ContactInfoView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        CurrentStep: this.props.EmbeddedBooking.CurrentStep,
	        ContactInfo: this.props.ContactInfo
	      });
	    }
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(e) {
	      var _this2 = this;
	
	      var name = e.target.name;
	      var value = e.target.value;
	      if (name === 'PhoneCode') {
	        this.setState({
	          ContactInfo: _extends({}, this.state.ContactInfo, {
	            IsDirty: true,
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        }, function () {
	          _this2.props.saveEmbeddedBooking(_this2.state);
	        });
	      } else if (name === 'PhoneNumber') {
	        this.setState({
	          ContactInfo: _extends({}, this.state.ContactInfo, {
	            IsDirty: true,
	            ContactPhone: value
	          }),
	          NameError: false,
	          LastNameError: false,
	          EmailError: false,
	          PhoneError: false
	        });
	      }
	    }
	  }, {
	    key: 'onPhoneBlur',
	    value: function onPhoneBlur() {
	      this.props.saveEmbeddedBooking(this.state);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var name = e.target.name;
	      switch (name) {// In order to get correct autofill data for chrome
	        case 'fname':
	          name = 'ContactInfo.ContactName';
	          break;
	        case 'lname':
	          name = 'ContactInfo.ContactLastName';
	          break;
	        case 'email':
	          name = 'ContactInfo.ContactEmail';
	          break;
	        case 'address':
	          name = 'ContactInfo.Address';
	          break;
	        case 'zipcode':
	          name = 'ContactInfo.ZipCode';
	          break;
	        case 'city':
	          name = 'ContactInfo.City';
	          break;
	      }
	
	      var value = e.target.value;
	      var names = name.split('.');
	      this.setState({
	        ContactInfo: _extends({}, this.state.ContactInfo, _defineProperty({}, names[1], value)),
	        NameError: false,
	        LastNameError: false,
	        EmailError: false,
	        PhoneError: false
	      });
	    }
	  }, {
	    key: 'checkAndNav',
	    value: function checkAndNav(e, opt) {
	      var _this3 = this;
	
	      e.persist();
	      var ContactInfo = this.state.ContactInfo;
	
	      // get the value of each input in case of autofill
	
	      var contactName = document.getElementById('fname').value;
	      var contactLastName = document.getElementById('lname').value;
	      var contactEmail = document.getElementById('email').value;
	      var contactPhone = document.getElementById('ContactPhone').value;
	      var address = document.getElementById('address').value;
	      var zipCode = document.getElementById('zipcode').value;
	      var city = document.getElementById('city').value;
	
	      var nameError = !ContactInfo.ContactName || ContactInfo.ContactName.length === 0;
	      var lastNameError = !ContactInfo.ContactLastName || ContactInfo.ContactLastName.length === 0;
	      var emailError = !ContactInfo.ContactEmail || ContactInfo.ContactEmail.length === 0;
	      var phoneError = !ContactInfo.ContactPhone || ContactInfo.ContactPhone.length === 0;
	
	      if (contactName) nameError = false;
	      if (contactLastName) lastNameError = false;
	      if (contactEmail) emailError = false;
	      if (contactPhone) phoneError = false;
	
	      if (nameError || lastNameError || emailError || phoneError) {
	        this.setState({
	          NameError: nameError,
	          LastNameError: lastNameError,
	          EmailError: emailError,
	          PhoneError: phoneError
	        });
	      } else {
	        this.setState({
	          ContactInfo: _extends({}, this.state.ContactInfo, {
	            ContactName: contactName,
	            ContactLastName: contactLastName,
	            ContactPhone: contactPhone,
	            ContactEmail: contactEmail,
	            Address: address,
	            ZipCode: zipCode,
	            City: city,
	            IsDirty: true
	          })
	        }, function () {
	          _this3.props.saveEmbeddedBooking(_this3.state).then(function () {
	            _this3.props.onNavClick(e, opt);
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var ContactInfo = this.state.ContactInfo;
	
	      var requiredNameClass = this.state.NameError ? 'required' : '';
	      var requiredLastNameClass = this.state.LastNameError ? 'required' : '';
	      var requiredPhoneClass = this.state.PhoneError ? 'required' : '';
	      var requiredEmailClass = this.state.EmailError ? 'required' : '';
	      var leftChildren = true;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'contact-info__view' },
	        _react2.default.createElement(
	          'article',
	          { className: 'main' },
	          this.props.children,
	          _react2.default.createElement(
	            'h1',
	            null,
	            (0, _helpers.translation)(16691)
	          ),
	          _react2.default.createElement(_text2.default, { id: 'fname', className: requiredNameClass, name: 'fname', placeholder: (0, _helpers.translation)(18336) + ' *', value: ContactInfo.ContactName || '', onChange: this.onChange, onBlur: this.props.onBlur, autoComplete: 'given-name' }),
	          _react2.default.createElement(_text2.default, { id: 'lname', className: requiredLastNameClass, name: 'lname', placeholder: (0, _helpers.translation)(18337) + ' *', value: ContactInfo.ContactLastName || '', onChange: this.onChange, onBlur: this.props.onBlur, autoComplete: 'family-name' }),
	          _react2.default.createElement(_text2.default, { id: 'address', name: 'address', placeholder: (0, _helpers.translation)(19009), value: ContactInfo.Address || '', onChange: this.onChange, onBlur: this.props.onBlur, autoComplete: 'street-address' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'zipCityWrapper' },
	            _react2.default.createElement(_text2.default, { id: 'zipcode', name: 'zipcode', placeholder: (0, _helpers.translation)(19010), value: ContactInfo.ZipCode || '', onChange: this.onChange, onBlur: this.props.onBlur, autoComplete: 'postal-code' }),
	            _react2.default.createElement(_text2.default, { id: 'city', name: 'city', placeholder: (0, _helpers.translation)(19011), value: ContactInfo.City || '', onChange: this.onChange, onBlur: this.props.onBlur, autoComplete: 'address-level2' })
	          ),
	          _react2.default.createElement(_Phone2.default, {
	            PhoneNumberClassName: requiredPhoneClass,
	            onChange: this.onPhoneChange,
	            onBlur: this.onPhoneBlur,
	            code: ContactInfo.PhoneCode || { Id: 0 },
	            number: ContactInfo.ContactPhone || '',
	            placeholder: (0, _helpers.translation)('38') + ' *',
	            Id: 'ContactPhone' }),
	          _react2.default.createElement(_text2.default, { id: 'email', className: requiredEmailClass, name: 'email', placeholder: (0, _helpers.translation)(1052) + ' *', value: ContactInfo.ContactEmail || '', onChange: this.onChange, onBlur: this.props.onBlur, autoComplete: 'email' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ctaWrapper' },
	            _react2.default.createElement(
	              _button2.default,
	              { style: 'secondary', labelText: (0, _helpers.translation)('394'), onClick: function onClick(e) {
	                  return _this4.props.onNavClick(e, 'previous');
	                }, leftChildren: leftChildren },
	              _react2.default.createElement(_icon2.default, {
	                size: 's',
	                icon: _icons.EmbeddedBookingIcons.Left_Arrow,
	                injectSvg: true
	              })
	            ),
	            _react2.default.createElement(
	              _button2.default,
	              { labelText: (0, _helpers.translation)(237), onClick: function onClick(e) {
	                  return _this4.checkAndNav(e, 'next');
	                } },
	              _react2.default.createElement(_icon2.default, {
	                size: 's',
	                icon: _icons.EmbeddedBookingIcons.Right_Arrow,
	                injectSvg: true
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'aside',
	          { className: 'side' },
	          _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              (0, _helpers.translation)(18432)
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)(16746)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ContactInfoView;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    ContactInfo: state.embeddedbooking.ContactInfo,
	    EmbeddedBooking: state.embeddedbooking
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { setEmbeddedBookingContactInfo: _embeddedbooking.setEmbeddedBookingContactInfo, saveEmbeddedBooking: _embeddedbooking.saveEmbeddedBooking })(ContactInfoView);

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoPlayer = __webpack_require__(1063);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	var _orders = __webpack_require__(21);
	
	var _embeddedbooking = __webpack_require__(149);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1386);
	
	var _reactRedux = __webpack_require__(3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// utils
	
	
	// Icons
	
	
	// constants
	
	
	// styles
	
	
	var INSTRUCTION_VIDEO = {
	  DK: _constants.API_BASE + '/Content/Videos/booking_photoguide_dk.mp4',
	  EN: _constants.API_BASE + '/Content/Videos/booking_photoguide_en.mp4',
	  SE: _constants.API_BASE + '/Content/Videos/booking_photoguide_se.mp4',
	  NO: _constants.API_BASE + '/Content/Videos/booking_photoguide_no.mp4'
	};
	
	var IntroView = function (_Component) {
	  _inherits(IntroView, _Component);
	
	  function IntroView(props) {
	    _classCallCheck(this, IntroView);
	
	    var _this = _possibleConstructorReturn(this, (IntroView.__proto__ || Object.getPrototypeOf(IntroView)).call(this, props));
	
	    _this.state = {
	      WelcomeMessage: null,
	      CarData: {
	        RegNumber: _this.props.EmbeddedBooking.CarData.RegNumber,
	        BrandNameId: '',
	        Model: '',
	        ChassisNumber: '',
	        Km: 0
	      },
	      shops: null,
	      regNumberError: false,
	      regNumberChecked: false
	    };
	
	    _this.onNextClick = _this.onNextClick.bind(_this);
	    _this.onRegBlur = _this.onRegBlur.bind(_this);
	    _this.onRegNrChange = _this.onRegNrChange.bind(_this);
	    _this.onNextToStep = _this.onNextToStep.bind(_this);
	    _this.onNextValidateReg = _this.onNextValidateReg.bind(_this);
	    _this.getBookingPortalWelcomeMessage = _this.getBookingPortalWelcomeMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(IntroView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(props) {
	      this.getBookingPortalWelcomeMessage();
	    }
	  }, {
	    key: 'getBookingPortalWelcomeMessage',
	    value: function getBookingPortalWelcomeMessage() {
	      var _this2 = this;
	
	      this.props.getBookingPortalWelcomeMessageFromToken(this.props.embedToken).then(function (res) {
	        _this2.setState({ WelcomeMessage: res.data });
	      }, function () {
	        console.error('error');
	      });
	    }
	  }, {
	    key: 'onNextClick',
	    value: function onNextClick(e) {
	      if (this.props.onNavClick !== null) {
	        this.props.onNavClick(e, 'next');
	      }
	    }
	  }, {
	    key: 'onRegBlur',
	    value: function onRegBlur() {
	      var _this3 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (!_this3.state.CarData.RegNumber || _this3.state.CarData.RegNumber.length === 0) {
	          resolve && resolve();
	          return;
	        }
	        _this3.props.getOrderVehicleData(_this3.state.CarData.RegNumber, 'RegNumber').then(function (res) {
	          _this3.setState({
	            CarData: _extends({}, _this3.state.CarData, {
	              RegNumber: res.data.RegNr,
	              BrandNameId: res.data.BrandNameId,
	              Model: res.data.Model,
	              ChassisNumber: res.data.ChassisNumber
	            }),
	            regNumberChecked: true
	          }, function () {
	            var updateData = {
	              CarData: {
	                IsDirty: true,
	                RegNumber: _this3.state.CarData.RegNumber,
	                BrandNameId: _this3.state.CarData.BrandNameId,
	                Model: _this3.state.CarData.Model,
	                ChassisNumber: _this3.state.CarData.ChassisNumber,
	                Km: null
	              }
	            };
	            _this3.props.saveEmbeddedBooking(updateData).then(function (res) {
	              return resolve && resolve();
	            });
	          });
	        }).catch(function () {
	          resolve && resolve();
	        });
	      });
	    }
	  }, {
	    key: 'onRegNrChange',
	    value: function onRegNrChange(e) {
	      var value = e.target.value;
	
	      this.setState({
	        CarData: _extends({}, this.state.CarData, {
	          RegNumber: value
	        }),
	        regNumberChecked: false,
	        regNumberError: false
	      });
	    }
	  }, {
	    key: 'onNextValidateReg',
	    value: function onNextValidateReg() {
	      var _this4 = this;
	
	      var detectRegNrError = function detectRegNrError() {
	        if (_this4.state.regNumberError || _this4.state.CarData.RegNumber === null || _this4.state.CarData.RegNumber.length === 0) {
	          _this4.setState({
	            regNumberError: true
	          });
	          return true;
	        }
	        return false;
	      };
	      if (!this.state.regNumberChecked) {
	        this.onRegBlur().then(function () {
	          if (detectRegNrError()) return;
	          _this4.onNextToStep('with_regnr');
	        });
	        return;
	      }
	      detectRegNrError();
	      this.onNextToStep('with_regnr');
	    }
	  }, {
	    key: 'onNextToStep',
	    value: function onNextToStep(flowType) {
	      this.setState({
	        regNumberError: false
	      });
	      if (flowType) {
	        this.props.setFlowType(flowType);
	      }
	      this.onNextClick();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var CarData = this.state.CarData;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'intro__view' },
	        _react2.default.createElement(
	          'article',
	          { className: 'main' },
	          this.props.children,
	          _react2.default.createElement(
	            'h1',
	            null,
	            (0, _helpers.translation)(18429)
	          ),
	          _react2.default.createElement(_text2.default, { className: this.state.regNumberError ? 'required' : '', name: 'CarData.RegNumber', value: CarData.RegNumber || '', onChange: this.onRegNrChange, onBlur: this.onRegBlur, placeholder: (0, _helpers.translation)(18430) }),
	          _react2.default.createElement(
	            'a',
	            { className: 'link', onClick: this.onNextToStep.bind(this, 'no_regnr') },
	            (0, _helpers.translation)(18319)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ctaWrapper' },
	            _react2.default.createElement(
	              _button2.default,
	              { style: 'primary', labelText: (0, _helpers.translation)(1223), onClick: this.onNextValidateReg },
	              _react2.default.createElement(_icon2.default, {
	                size: 's',
	                icon: _icons.EmbeddedBookingIcons.Right_Arrow,
	                injectSvg: true
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'aside',
	          { className: 'side' },
	          _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              (0, _helpers.translation)(16705)
	            ),
	            this.state.WelcomeMessage && _react2.default.createElement(
	              'p',
	              null,
	              this.state.WelcomeMessage.BookingPortalWelcomeMessageText
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              (0, _helpers.translation)(18317)
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)(18318)
	            ),
	            _react2.default.createElement(_VideoPlayer2.default, {
	              position: 'center',
	              poster: '',
	              src: INSTRUCTION_VIDEO[this.props.countryCode],
	              hideVolume: true,
	              autoHide: true,
	              autoHideTime: 1000
	            })
	          ),
	          _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              (0, _helpers.translation)(18431)
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                (0, _helpers.translation)(16577)
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                (0, _helpers.translation)(16710)
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                (0, _helpers.translation)(16711)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IntroView;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common,
	    CarData: state.embeddedbooking.CarData,
	    EmbeddedBooking: state.embeddedbooking
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrderVehicleData: _orders.getOrderVehicleData,
	  saveEmbeddedBooking: _embeddedbooking.saveEmbeddedBooking,
	  getBookingPortalWelcomeMessageFromToken: _embeddedbooking.getBookingPortalWelcomeMessageFromToken
	})(IntroView);

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _embeddedbooking = __webpack_require__(149);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _helpers = __webpack_require__(2);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _icons = __webpack_require__(6);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1387);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// Elements
	
	
	// utils
	
	
	// Icons
	
	
	// Styles
	
	
	var OtherInfoView = function (_Component) {
	  _inherits(OtherInfoView, _Component);
	
	  function OtherInfoView(props) {
	    _classCallCheck(this, OtherInfoView);
	
	    var _this = _possibleConstructorReturn(this, (OtherInfoView.__proto__ || Object.getPrototypeOf(OtherInfoView)).call(this, props));
	
	    _this.state = {
	      OtherInfo: {
	        DamageNr: '',
	        InsuranceCompanyId: 0,
	        NeedRental: false,
	        CarRentalId: 0,
	        DamageDate: null
	      }
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onDateChange = _this.onDateChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onBlurDamageDate = _this.onBlurDamageDate.bind(_this);
	    _this.checkAndNav = _this.checkAndNav.bind(_this);
	    _this.renderRentals = _this.renderRentals.bind(_this);
	    return _this;
	  }
	
	  _createClass(OtherInfoView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        OtherInfo: this.props.OtherInfo
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	
	      var value = e.target.value;
	      var names = e.target.name.split('.');
	      if (names[1] === 'InsuranceCompanyId' || names[1] === 'CarRentalAlternativeId') value = parseInt(e.target.value);
	      if (e.target.type === 'checkbox') value = e.target.checked;
	      this.setState({
	        OtherInfo: _extends({}, this.state.OtherInfo, _defineProperty({}, names[1], value))
	      }, function () {
	        if (e.target.type === 'checkbox' || e.target.type === 'radio' || e.target.type === 'select-one') {
	          _this2.props.setEmbeddedBookingOtherInfo(_this2.state.OtherInfo);
	          _this2.props.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onDateChange',
	    value: function onDateChange(date) {
	      var _this3 = this;
	
	      this.setState({
	        OtherInfo: _extends({}, this.state.OtherInfo, {
	          DamageDate: date
	        })
	      }, function () {
	        _this3.props.setEmbeddedBookingOtherInfo(_this3.state.OtherInfo);
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      e.persist();
	      this.props.setEmbeddedBookingOtherInfo(this.state.OtherInfo);
	      this.props.onBlur(e);
	    }
	  }, {
	    key: 'onBlurDamageDate',
	    value: function onBlurDamageDate(e) {
	      this.props.onBlur(e, true);
	    }
	  }, {
	    key: 'checkAndNav',
	    value: function checkAndNav(e, opt) {
	      e.persist();
	      this.props.onNavClick(e, opt);
	    }
	  }, {
	    key: 'renderRentals',
	    value: function renderRentals() {
	      var _this4 = this;
	
	      var OtherInfo = this.state.OtherInfo;
	
	      var CarRentalAlternatives = this.props.CarRentalAlternatives;
	      var showAlts = this.props.OfferCarRentalAlts && CarRentalAlternatives.length !== 0;
	
	      var renderCarRentalAlts = function renderCarRentalAlts(val, key) {
	        return _react2.default.createElement(_radio2.default, { key: key, name: 'OtherInfo.CarRentalAlternativeId.' + key, value: val.Id, checked: OtherInfo.CarRentalAlternativeId === val.Id, onChange: _this4.onChange, labelText: val.Name });
	      };
	      return showAlts && _react2.default.createElement(
	        'div',
	        { className: 'carrental--inner' },
	        _react2.default.createElement(_radio2.default, { name: 'OtherInfo.CarRentalAlternativeId', value: 0, checked: !OtherInfo.CarRentalAlternativeId, onChange: this.onChange, labelText: (0, _helpers.translation)(629) }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: 18363 },
	          CarRentalAlternatives.map(renderCarRentalAlts)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var OtherInfo = this.state.OtherInfo;
	
	      var damageDate = OtherInfo.DamageDate;
	      var inputProps = {
	        placeholder: (0, _helpers.translation)(18322)
	      };
	      var leftChildren = true;
	
	      if (typeof damageDate === 'string') {
	        damageDate = (0, _moment2.default)(damageDate.substring(0, 10));
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'other-info__view' },
	        _react2.default.createElement(
	          'article',
	          { className: 'main' },
	          this.props.children,
	          _react2.default.createElement(
	            'h1',
	            null,
	            (0, _helpers.translation)(16687)
	          ),
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'OtherInfo.InsuranceCompanyId', value: OtherInfo.InsuranceCompanyId, onChange: this.onChange, helpText: (0, _helpers.translation)(16850) },
	            _react2.default.createElement(
	              'option',
	              { value: '0' },
	              (0, _helpers.translation)(14863)
	            ),
	            this.props.InsuranceCompanies.map(function (val, index) {
	              if (val.Active) {
	                if (val.InsuranceCompanyId === OtherInfo.InsuranceCompanyId) {
	                  return _react2.default.createElement(
	                    'option',
	                    { value: val.InsuranceCompanyId, key: index, selected: true },
	                    val.Company
	                  );
	                } else {
	                  return _react2.default.createElement(
	                    'option',
	                    { value: val.InsuranceCompanyId, key: index },
	                    val.Company
	                  );
	                }
	              }
	            })
	          ),
	          _react2.default.createElement(_text2.default, { name: 'OtherInfo.DamageNr', value: OtherInfo.DamageNr || '', onChange: this.onChange, placeholder: (0, _helpers.translation)(16701), helpText: (0, _helpers.translation)(16851), onBlur: this.onBlur }),
	          _react2.default.createElement(_datetime2.default, { name: 'OtherInfo.DamageDate', timeFormat: false, value: damageDate, onChange: this.onDateChange, onBlur: this.onBlurDamageDate, inputProps: inputProps, closeOnSelect: true }),
	          _react2.default.createElement(_check2.default, { name: 'OtherInfo.NeedRental', checked: OtherInfo.NeedRental, onChange: this.onChange, labelText: (0, _helpers.translation)(18437) }),
	          OtherInfo.NeedRental && this.renderRentals(),
	          _react2.default.createElement(
	            'div',
	            { className: 'ctaWrapper' },
	            _react2.default.createElement(
	              _button2.default,
	              { style: 'secondary', labelText: (0, _helpers.translation)('394'), onClick: function onClick(e) {
	                  return _this5.props.onNavClick(e, 'previous');
	                }, leftChildren: leftChildren },
	              _react2.default.createElement(_icon2.default, {
	                size: 's',
	                icon: _icons.EmbeddedBookingIcons.Left_Arrow,
	                injectSvg: true
	              })
	            ),
	            _react2.default.createElement(
	              _button2.default,
	              { labelText: (0, _helpers.translation)(237), onClick: function onClick(e) {
	                  return _this5.checkAndNav(e, 'next');
	                } },
	              _react2.default.createElement(_icon2.default, {
	                size: 's',
	                icon: _icons.EmbeddedBookingIcons.Right_Arrow,
	                injectSvg: true
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'aside',
	          { className: 'side' },
	          _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              (0, _helpers.translation)(18432)
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)(16692)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OtherInfoView;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    brands: state.common.brands,
	    InsuranceCompanies: state.embeddedbooking.InsuranceCompanies,
	    CarRentalAlternatives: state.embeddedbooking.CarRentalAlternatives,
	    OfferCarRentalAlts: state.embeddedbooking.OfferCarRentalAlts,
	    OtherInfo: state.embeddedbooking.OtherInfo
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { setEmbeddedBookingOtherInfo: _embeddedbooking.setEmbeddedBookingOtherInfo })(OtherInfoView);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(43);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _embeddedbooking = __webpack_require__(149);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _icons = __webpack_require__(6);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	__webpack_require__(1388);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// utils
	
	
	// Icons
	
	
	// Components
	
	
	// Elements
	
	
	var SendView = function (_Component) {
	  _inherits(SendView, _Component);
	
	  function SendView(props) {
	    _classCallCheck(this, SendView);
	
	    var _this = _possibleConstructorReturn(this, (SendView.__proto__ || Object.getPrototypeOf(SendView)).call(this, props));
	
	    _this.state = {
	      isSent: false,
	      consent: false
	    };
	    return _this;
	  }
	
	  _createClass(SendView, [{
	    key: 'renderStepHeader',
	    value: function renderStepHeader(stepId, title) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'step-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'step-title' },
	          _react2.default.createElement(
	            'div',
	            null,
	            title
	          ),
	          !this.props.EmbeddedBooking.IsComplete && _react2.default.createElement(
	            'div',
	            { onClick: function onClick(e) {
	                return _this2.props.onNavClick(e, stepId);
	              } },
	            _react2.default.createElement(_icon2.default, {
	              size: 's',
	              icon: _icons.EmbeddedBookingIcons.Edit_Pencil,
	              injectSvg: true
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderStep1',
	    value: function renderStep1() {
	      // Photos
	      var images = this.props.EmbeddedBooking.FilesInfo.Files.filter(function (x) {
	        return x.IsImage;
	      });
	
	      var stepId = 1;
	      return _react2.default.createElement(
	        'div',
	        { className: '__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'step-circle-large active' },
	          _react2.default.createElement(
	            'span',
	            null,
	            stepId
	          )
	        ),
	        this.renderStepHeader(stepId, (0, _helpers.translation)(16685)),
	        _react2.default.createElement(
	          'div',
	          { className: 'section section__photos' },
	          _react2.default.createElement(_Gallery2.default, { files: images, renderImage: this.renderImage })
	        )
	      );
	    }
	  }, {
	    key: 'renderStep2',
	    value: function renderStep2() {
	      // CarData
	      var carData = this.props.EmbeddedBooking.CarData;
	      var brand = this.props.Brands.filter(function (x) {
	        return x.Id === carData.BrandNameId;
	      })[0];
	      if (brand.Name === '2000') brand = { Id: 2000, Name: (0, _helpers.translation)(2000) };
	
	      var stepId = 2;
	      return _react2.default.createElement(
	        'div',
	        { className: '__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'step-circle-large active' },
	          _react2.default.createElement(
	            'span',
	            null,
	            stepId
	          )
	        ),
	        this.renderStepHeader(stepId, (0, _helpers.translation)(77)),
	        _react2.default.createElement(
	          'div',
	          { className: 'section section__cardata' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(16693)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              carData.Km
	            )
	          ),
	          this.props.flowType === 'with_regnr' && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(78)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              carData.RegNumber
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(145)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              brand.Name
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(146)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              carData.Model
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(81)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              carData.ChassisNumber
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'descriptionBox' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(16686)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              carData.DamageComment
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderStep3',
	    value: function renderStep3() {
	      // OtherInfo
	      var otherInfo = this.props.EmbeddedBooking.OtherInfo;
	      var insuranceCompany = { Company: '' };
	      if (otherInfo.InsuranceCompanyId !== null && this.props.EmbeddedBooking.InsuranceCompanies !== undefined && this.props.EmbeddedBooking.InsuranceCompanies !== null) {
	        insuranceCompany = this.props.EmbeddedBooking.InsuranceCompanies.filter(function (x) {
	          return x.InsuranceCompanyId === otherInfo.InsuranceCompanyId;
	        })[0];
	      }
	
	      var renderInsuranceOrderCompany = function renderInsuranceOrderCompany() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(418)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            insuranceCompany.Company
	          )
	        );
	      };
	      var renderInsuranceOrderDamageNr = function renderInsuranceOrderDamageNr() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(16688)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            otherInfo.DamageNr
	          )
	        );
	      };
	      var renderInsuranceOrderDamageDate = function renderInsuranceOrderDamageDate() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(18322)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _time.renderDate)(otherInfo.DamageDate)
	          )
	        );
	      };
	      var renderRentalCar = function renderRentalCar() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(16689)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            otherInfo.NeedRental === true ? (0, _helpers.translation)(47).toUpperCase() : (0, _helpers.translation)(48).toUpperCase()
	          )
	        );
	      };
	
	      var stepId = 3;
	      return _react2.default.createElement(
	        'div',
	        { className: '__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'step-circle-large active' },
	          _react2.default.createElement(
	            'span',
	            null,
	            stepId
	          )
	        ),
	        this.renderStepHeader(stepId, (0, _helpers.translation)(16687)),
	        _react2.default.createElement(
	          'div',
	          { className: 'section section__otherinfo' },
	          renderInsuranceOrderCompany(),
	          renderInsuranceOrderDamageNr(),
	          renderInsuranceOrderDamageDate(),
	          renderRentalCar()
	        )
	      );
	    }
	  }, {
	    key: 'renderStep4',
	    value: function renderStep4() {
	      // ContactInfo
	      var contact = this.props.EmbeddedBooking.ContactInfo;
	      var stepId = 4;
	      return _react2.default.createElement(
	        'div',
	        { className: '__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'step-circle-large active' },
	          _react2.default.createElement(
	            'span',
	            null,
	            stepId
	          )
	        ),
	        this.renderStepHeader(stepId, (0, _helpers.translation)(16691)),
	        _react2.default.createElement(
	          'div',
	          { className: 'section section__contactinfo' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(16606)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              contact.ContactName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(16607)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              contact.ContactLastName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(25)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              contact.Address
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(16791)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              contact.ZipCode
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(37)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              contact.City
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(38)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              contact.ContactPhone
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(1052)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              contact.ContactEmail
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCompleted',
	    value: function renderCompleted() {
	      var _this3 = this;
	
	      var text = this.props.EmbeddedBooking.CompletionText;
	      if (typeof text !== 'string') {
	        text = '';
	      }
	      var lines = text.split('\n');
	      return _react2.default.createElement(
	        'div',
	        { className: 'send__view completed' },
	        _react2.default.createElement(
	          'div',
	          { className: 'top completed' },
	          this.props.children
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            (0, _helpers.translation)(16706)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            lines.map(function (l, i) {
	              return _react2.default.createElement(
	                'p',
	                { key: 'l_' + i },
	                l
	              );
	            })
	          ),
	          _react2.default.createElement(_button2.default, { style: 'primary', labelText: 956, onClick: function onClick(e) {
	              return _this3.props.onNavClick(e, 'restart');
	            } })
	        )
	      );
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(image, index) {
	      var url = _constants.FILE_STORAGE + image.ThumbURL;
	      var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	      return _react2.default.createElement(
	        'div',
	        { className: 'image-div', key: index },
	        _react2.default.createElement(
	          'a',
	          { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	          _react2.default.createElement('img', { src: url })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      if (this.props.EmbeddedBooking.IsComplete === true) {
	        var link = document.getElementById('booking-portal-link');
	        if (link.href) {
	          link.click();
	          return null;
	        } else {
	          return this.renderCompleted();
	        }
	      }
	      // } else {
	      //   return (
	      //     <div className='send__view full-width'>
	      //       <Panel title={16690}>
	      //         <div className='send__content'>
	      //           {this.renderStep1()}
	      //           {this.renderStep2()}
	      //           {this.renderStep3()}
	      //           {this.renderStep4()}
	      //           {!this.props.EmbeddedBooking.IsComplete && (
	      //             <div className='actions'>
	      //               <div className='consent-box'>
	      //                 <Check simple name='Consent' onChange={() => this.setState({ consent: !this.state.consent })} checked={this.state.consent} />
	      //                 <div className='consent-text'>
	      //                   <div className='consent-text__text'>{translation(16727)}
	      //                     {this.props.EmbeddedBooking.PrivacyPolicyUrl &&
	      //                       <Link to={{ pathname: this.props.EmbeddedBooking.PrivacyPolicyUrl }} className='link' target='_blank'>{' ' + translation(16728)}</Link>}
	      //                   </div>
	      //                 </div>
	      //               </div>
	      //               <div className='buttons'>
	      //                 <div className='back-button'>
	      //                   <Button style='secondary' labelText={translation('394')} onClick={(e) => this.props.onNavClick(e, 'previous')} />
	      //                 </div>
	      //                 <Button spacing={0} labelText={16703} disabled={!this.state.consent} onClick={(e) => this.props.onNavClick(e, 'complete')} />
	      //               </div>
	      //             </div>
	      //           )}
	      //         </div>
	      //       </Panel>
	      //     </div>
	      //   )
	      // }
	      // if (this.props.EmbeddedBooking.IsComplete === true) return this.renderCompleted()
	
	      var renderConsent = function renderConsent() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'consent-box' },
	          _react2.default.createElement(_check2.default, { simple: true, name: 'Consent', onChange: function onChange() {
	              return _this4.setState({ consent: !_this4.state.consent });
	            }, checked: _this4.state.consent }),
	          _react2.default.createElement(
	            'div',
	            { className: 'consent-text' },
	            _react2.default.createElement(
	              'div',
	              { className: 'consent-text__text' },
	              (0, _helpers.translation)(16727),
	              _this4.props.EmbeddedBooking.PrivacyPolicyUrl && _react2.default.createElement(
	                _reactRouter.Link,
	                { to: { pathname: _this4.props.EmbeddedBooking.PrivacyPolicyUrl }, className: 'link', target: '_blank' },
	                ' ' + (0, _helpers.translation)(16728)
	              )
	            )
	          )
	        );
	      };
	
	      var renderActions = function renderActions() {
	        var leftChildren = true;
	
	        return _react2.default.createElement(
	          'section',
	          { className: 'bottom' },
	          renderConsent(),
	          _react2.default.createElement(
	            'div',
	            { className: 'ctaWrapper' },
	            _react2.default.createElement(
	              _button2.default,
	              { style: 'secondary', labelText: (0, _helpers.translation)(394), onClick: function onClick(e) {
	                  return _this4.props.onNavClick(e, 'previous');
	                }, leftChildren: leftChildren },
	              _react2.default.createElement(_icon2.default, { size: 's', icon: _icons.EmbeddedBookingIcons.Left_Arrow, injectSvg: true })
	            ),
	            _react2.default.createElement(
	              _button2.default,
	              { style: 'primary', spacing: 0, labelText: (0, _helpers.translation)(752), disabled: !_this4.state.consent, onClick: function onClick(e) {
	                  return _this4.props.onNavClick(e, 'complete');
	                } },
	              _react2.default.createElement(_icon2.default, { size: 's', icon: _icons.EmbeddedBookingIcons.Right_Arrow, injectSvg: true })
	            )
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'send__view' },
	        _react2.default.createElement(
	          'section',
	          { className: 'top' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            (0, _helpers.translation)(16703)
	          ),
	          this.props.children
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'middle' },
	          this.renderStep1(),
	          this.renderStep2(),
	          this.renderStep3(),
	          this.renderStep4()
	        ),
	        !this.props.EmbeddedBooking.IsComplete && renderActions()
	      );
	    }
	  }]);
	
	  return SendView;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    Brands: state.common.brands,
	    EmbeddedBooking: state.embeddedbooking
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { setEmbeddedBookingContactInfo: _embeddedbooking.setEmbeddedBookingContactInfo })(SendView);

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _embeddedbooking = __webpack_require__(149);
	
	var _orders = __webpack_require__(21);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1389);
	
	var _LicensePlate = __webpack_require__(295);
	
	var _LicensePlate2 = _interopRequireDefault(_LicensePlate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// Components
	
	
	// Elements
	
	
	// utils
	
	
	// Icons
	
	
	// styles
	
	
	var UploadPhotoView = function (_Component) {
	  _inherits(UploadPhotoView, _Component);
	
	  function UploadPhotoView(props) {
	    _classCallCheck(this, UploadPhotoView);
	
	    var _this = _possibleConstructorReturn(this, (UploadPhotoView.__proto__ || Object.getPrototypeOf(UploadPhotoView)).call(this, props));
	
	    _this.state = {
	      upload: {
	        loading: false,
	        errors: []
	      },
	      errors: [],
	      confirm: {
	        open: false
	      }
	    };
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onDropAccepted = _this.onDropAccepted.bind(_this);
	    _this.renderImage = _this.renderImage.bind(_this);
	    _this.renderPhotoGuide = _this.renderPhotoGuide.bind(_this);
	    _this.ensureFileContainer = _this.ensureFileContainer.bind(_this);
	    _this.deleteFile = _this.deleteFile.bind(_this);
	    _this.onPortalClose = _this.onPortalClose.bind(_this);
	    _this.onConfirm = _this.onConfirm.bind(_this);
	    return _this;
	  }
	
	  // componentDidMount () {
	  //   this.setState({
	  //     files: this.props.embeddedbooking.
	  //   })
	  // }
	
	  _createClass(UploadPhotoView, [{
	    key: 'ensureFileContainer',
	    value: function ensureFileContainer() {
	      var _this2 = this;
	
	      if (this.props.embeddedbooking.FilesInfo.FileContainerId === null) {
	        return this.props.createFileContainer().then(function (res) {
	          return _this2.props.saveEmbeddedBooking({ FilesInfo: { FileContainerId: res.data.FileContainerId } });
	          // this.setState({
	          //   fileContainerId: res.data.FileContainerId
	          // })
	        });
	      } else {
	        return Promise.resolve();
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop() {
	      this.setState({ upload: _extends({}, this.state.upload, { errors: [] }) });
	    }
	  }, {
	    key: 'onDropAccepted',
	    value: function onDropAccepted(files) {
	      var _this3 = this;
	
	      this.ensureFileContainer().then(function () {
	        _this3.setState({
	          upload: _extends({}, _this3.state.upload, {
	            files: files,
	            loading: true
	          })
	        }, function () {
	          var type = 0;
	          _this3.props.uploadMultipleFiles(_this3.state.upload.files, 0, type, null, _this3.props.embeddedbooking.FilesInfo.FileContainerId).then(function (res) {
	            // Get updated booking details.
	            _this3.props.saveEmbeddedBooking({ CurrentStep: 2 });
	            _this3.setState({ upload: _extends({}, _this3.state.upload, { files: [], loading: false }) });
	          });
	        });
	      });
	    }
	  }, {
	    key: 'onDropRejected',
	    value: function onDropRejected(files) {
	      var newErrors = [];
	      files.map(function (file) {
	        newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13405') + '.');
	      });
	      this.setState({ upload: _extends({}, this.state.upload, { errors: newErrors, files: [] }) });
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile(fileId) {
	      this.props.saveEmbeddedBooking({
	        CurrentStep: 2,
	        FilesInfo: { DeleteFileId: fileId }
	      });
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(image, index) {
	      var _this4 = this;
	
	      var url = _constants.FILE_STORAGE + image.ThumbURL;
	      var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	      return _react2.default.createElement(
	        'div',
	        { className: 'image-div', key: index },
	        _react2.default.createElement(
	          'a',
	          { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	          _react2.default.createElement('img', { src: url })
	        ),
	        _react2.default.createElement(_removeButton2.default, { size: 's', onClick: function onClick() {
	            return _this4.deleteFile(image.OrderFileID);
	          } })
	      );
	    }
	  }, {
	    key: 'renderPhotoGuide',
	    value: function renderPhotoGuide(flowType) {
	      var reg = flowType === 'with_regnr';
	
	      if (!reg) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'photo_guide' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'guideImageWrapper' },
	              _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_2.fileName }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(16693)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'guideImageWrapper' },
	              _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_3.fileName }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(16714)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'guideImageWrapper' },
	              _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_4.fileName }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(18320)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'guideImageWrapper' },
	              _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_5.fileName }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(16716)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'guideImageWrapper' },
	              _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_6.fileName }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(16717)
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'photo_guide' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'guideImageWrapper' },
	            this.props.embeddedbooking.CarData.RegNumber !== null && _react2.default.createElement(
	              'div',
	              { className: 'ghost' },
	              _react2.default.createElement(_LicensePlate2.default, { regNr: this.props.embeddedbooking.CarData.RegNumber, countryCode: this.props.countryCode })
	            ),
	            this.props.embeddedbooking.CarData.RegNumber !== null && _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_1.fileName }),
	            this.props.embeddedbooking.CarData.RegNumber !== null && _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16577)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'guideImageWrapper' },
	            _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_2.fileName }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16693)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'guideImageWrapper' },
	            _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_3.fileName }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16714)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'guideImageWrapper' },
	            _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_4.fileName }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(18320)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'guideImageWrapper' },
	            _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_5.fileName }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16716)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'guideImageWrapper' },
	            _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Photo_Guide_6.fileName }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16717)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose() {
	      this.setState({
	        confirm: _extends({}, this.state.confirm, {
	          open: false
	        })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var errors = this.state.upload.errors;
	
	      var images = this.props.embeddedbooking.FilesInfo.Files.filter(function (x) {
	        return x.IsImage;
	      });
	      var leftChildren = true;
	
	      var renderError = function renderError(error, index) {
	        return _react2.default.createElement(
	          'p',
	          { key: index },
	          error
	        );
	      };
	
	      var openPortal = function openPortal() {
	        _this5.setState({
	          confirm: {
	            open: true
	          }
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'upload-photo__view' },
	        _react2.default.createElement(
	          'article',
	          { className: 'main' },
	          this.props.children,
	          _react2.default.createElement(
	            'h1',
	            null,
	            (0, _helpers.translation)(16697)
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: '' },
	            errors.length !== 0 && _react2.default.createElement(
	              'div',
	              { className: 'alert alert-danger' },
	              errors.map(renderError)
	            ),
	            _react2.default.createElement(
	              _Dropzone2.default,
	              {
	                onDrop: this.onDrop,
	                onDropAccepted: this.onDropAccepted,
	                onDropRejected: this.onDropRejected,
	                includeCircles: false },
	              this.state.upload.loading && _react2.default.createElement(
	                'p',
	                { className: 'loading' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'animated-background' },
	                  _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'sr-only' },
	                    (0, _helpers.translation)('13382'),
	                    '...'
	                  )
	                )
	              ),
	              !this.state.upload.loading && _react2.default.createElement(
	                'div',
	                { className: 'imageWrapper' },
	                _react2.default.createElement('img', { src: _icons.EmbeddedBookingIcons.Upload_Image.fileName }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)(18439)
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'upload-photo__view--inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(_Gallery2.default, { files: images, renderImage: this.renderImage })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ctaWrapper' },
	            _react2.default.createElement(
	              _button2.default,
	              { style: 'secondary', labelText: (0, _helpers.translation)('394'), onClick: function onClick(e) {
	                  return _this5.props.onNavClick(e, 'previous');
	                }, leftChildren: leftChildren },
	              _react2.default.createElement(_icon2.default, {
	                size: 's',
	                icon: _icons.EmbeddedBookingIcons.Left_Arrow,
	                injectSvg: true
	              })
	            ),
	            _react2.default.createElement(
	              _button2.default,
	              { style: 'primary', labelText: (0, _helpers.translation)(237), onClick: openPortal },
	              _react2.default.createElement(_icon2.default, {
	                size: 's',
	                icon: _icons.EmbeddedBookingIcons.Right_Arrow,
	                injectSvg: true
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'aside',
	          { className: 'side' },
	          _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              (0, _helpers.translation)(18432)
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)(16722)
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            null,
	            this.renderPhotoGuide(this.props.flowType)
	          )
	        ),
	        this.state.confirm.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup embeddedBooking', onPortalClose: this.onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm, notConfirm: this.onPortalClose, renderText: this.renderText, cancelStyle: 'link', actionStyle: 'cta' })
	        )
	      );
	    }
	  }, {
	    key: 'renderText',
	    value: function renderText() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        (0, _helpers.translation)('16844')
	      );
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm(e) {
	      this.onPortalClose();
	      this.props.onNavClick(e, 'next');
	    }
	  }]);
	
	  return UploadPhotoView;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    embeddedbooking: state.embeddedbooking
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  saveEmbeddedBooking: _embeddedbooking.saveEmbeddedBooking,
	  createFileContainer: _orders.createFileContainer,
	  uploadMultipleFiles: _orders.uploadMultipleFiles
	})(UploadPhotoView);

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _EmbedView = __webpack_require__(1029);
	
	var _EmbedView2 = _interopRequireDefault(_EmbedView);
	
	var _IntroView = __webpack_require__(848);
	
	var _IntroView2 = _interopRequireDefault(_IntroView);
	
	var _CarDataView = __webpack_require__(846);
	
	var _CarDataView2 = _interopRequireDefault(_CarDataView);
	
	var _UploadPhotoView = __webpack_require__(851);
	
	var _UploadPhotoView2 = _interopRequireDefault(_UploadPhotoView);
	
	var _OtherInfoView = __webpack_require__(849);
	
	var _OtherInfoView2 = _interopRequireDefault(_OtherInfoView);
	
	var _ContactInfoView = __webpack_require__(847);
	
	var _ContactInfoView2 = _interopRequireDefault(_ContactInfoView);
	
	var _SendView = __webpack_require__(850);
	
	var _SendView2 = _interopRequireDefault(_SendView);
	
	var _RenderFontURL = __webpack_require__(446);
	
	var _RenderFontURL2 = _interopRequireDefault(_RenderFontURL);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _embeddedbooking = __webpack_require__(149);
	
	var _insurancecompanies = __webpack_require__(172);
	
	var _embedded = __webpack_require__(408);
	
	var _carrentalalternatives = __webpack_require__(403);
	
	__webpack_require__(1390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import $ from 'jquery'
	
	// Components
	
	
	// // Elements
	// import Icon from '../../shared/elements/icon'
	// import { EmbeddedBookingIcons } from '../../shared/elements/icons'
	
	// actions
	
	// import { getStylePortalWeb } from '../../actions/settings'
	
	// Styles
	
	
	var EmbeddedBooking = function (_Component) {
	  _inherits(EmbeddedBooking, _Component);
	
	  function EmbeddedBooking(props) {
	    _classCallCheck(this, EmbeddedBooking);
	
	    var _this = _possibleConstructorReturn(this, (EmbeddedBooking.__proto__ || Object.getPrototypeOf(EmbeddedBooking)).call(this, props));
	
	    _this.state = {
	      stepId: 0,
	      embedViewState: null,
	      companyData: null,
	      countryCode: '',
	      flowType: 'with_regnr',
	      isLoading: false,
	      styles: {
	        FontType: 1,
	        WebSafeFont: 'Verdana',
	        FontURL: '',
	        FontFamily: 'unset',
	        BrandColor: '#000000',
	        BrandColorSecondary: '#000000',
	        PrimaryBackgroundColor: '#000000',
	        ColoredBackground: '#000000',
	        H1Size: 20,
	        H1Color: '#000000',
	        H2Size: 18,
	        H2Color: '#000000',
	        BodySize: 14,
	        BodyColor: '#000000',
	        NavigationSize: 0,
	        NavigationColor: '#000000',
	        LinkSize: 14,
	        LinkColor: '#000000',
	        ButtonTextSize: 14,
	        ButtonTextColor: '#000000',
	        ButtonStrokeColor: '#000000',
	        ButtonFillColor: '#000000',
	        HoverStrokeColor: '#000000',
	        HoverFillColor: '#000000',
	        CheckboxColor: '#000000',
	        CheckboxActiveColor: '#000000',
	        BackButtonTextSize: 20,
	        BackButtonTextColor: '#000000',
	        BackButtonStrokeColor: '#000000',
	        BackButtonFillColor: '#000000',
	        BackButtonHoverStrokeColor: '#000000',
	        BackButtonHoverFillColor: '#000000',
	        InputFieldColor: '#000000',
	        EmptyFieldTextColor: '#000000',
	        EmptyFieldTextSize: 16
	      }
	    };
	
	    _this.steps = [{ stepId: 0, stepName: 'Intro' }, { stepId: 1, stepName: 'UploadPhotoView' }, { stepId: 2, stepName: 'CarDataView' }, { stepId: 3, stepName: 'OtherInfoView' }, { stepId: 4, stepName: 'ContactInfoView' }, { stepId: 5, stepName: 'SendView' }];
	
	    _this.getView = _this.getView.bind(_this);
	    _this.onNavClick = _this.onNavClick.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.getResetData = _this.getResetData.bind(_this);
	    _this.onLoginComplete = _this.onLoginComplete.bind(_this);
	    _this.getStyle = _this.getStyle.bind(_this);
	    _this.setFlowType = _this.setFlowType.bind(_this);
	    return _this;
	  }
	
	  _createClass(EmbeddedBooking, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCountryCode();
	    }
	  }, {
	    key: 'setFlowType',
	    value: function setFlowType(flowType) {
	      this.setState({ flowType: flowType });
	    }
	  }, {
	    key: 'getResetData',
	    value: function getResetData() {
	      return {
	        CurrentStep: this.state.stepId,
	        IsComplete: false,
	        CarData: {
	          IsDirty: false,
	          RegNumber: null,
	          BrandNameId: null,
	          Model: null,
	          ChassisNumber: null,
	          Km: null,
	          DamageComment: null
	        },
	        OtherInfo: {
	          IsDirty: false,
	          InsuranceCompanyId: null,
	          NeedRental: null,
	          DamageNr: null,
	          CarRentalId: null,
	          DamageDate: null
	        },
	        ContactInfo: {
	          IsDirty: false,
	          ContactName: null,
	          ContactLastName: null,
	          ContactEmail: null,
	          ContactPhone: null,
	          PhoneCode: null,
	          Address: null,
	          ZipCode: null,
	          City: null
	        }
	      };
	    }
	  }, {
	    key: 'getView',
	    value: function getView() {
	      switch (this.state.stepId) {
	        case 0:
	          return _react2.default.createElement(_IntroView2.default, { onNavClick: this.onNavClick, countryCode: this.state.countryCode, flowType: this.state.flowType, setFlowType: this.setFlowType });
	        case 1:
	          return _react2.default.createElement(
	            _UploadPhotoView2.default,
	            { onNavClick: this.onNavClick, onBlur: this.onBlur, countryCode: this.state.countryCode, flowType: this.state.flowType },
	            this.renderSteps()
	          );
	        case 2:
	          return _react2.default.createElement(
	            _CarDataView2.default,
	            { onNavClick: this.onNavClick, onBlur: this.onBlur, flowType: this.state.flowType },
	            this.renderSteps()
	          );
	        case 3:
	          return _react2.default.createElement(
	            _OtherInfoView2.default,
	            { onNavClick: this.onNavClick, onBlur: this.onBlur, flowType: this.state.flowType },
	            this.renderSteps()
	          );
	        case 4:
	          return _react2.default.createElement(
	            _ContactInfoView2.default,
	            { renderSteps: this.renderSteps, onNavClick: this.onNavClick, onBlur: this.onBlur, flowType: this.state.flowType },
	            this.renderSteps()
	          );
	        case 5:
	          var link = document.getElementById('booking-portal-link');
	          if (link && !link.href) {
	            this.props.getBookingPortalRedirectUrlFromToken(this.state.companyData.Token, 'bookingportal').then(function (res) {
	              if (res.data.BookingPortalRedirectUrl) {
	                if (!res.data.BookingPortalRedirectUrl.startsWith('https://')) {
	                  res.data.BookingPortalRedirectUrl = 'https://' + res.data.BookingPortalRedirectUrl;
	                }
	
	                link.href = res.data.BookingPortalRedirectUrl;
	              }
	            });
	          }
	
	          return _react2.default.createElement(
	            _SendView2.default,
	            { onNavClick: this.onNavClick, processing: this.state.processing, flowType: this.state.flowType },
	            this.renderSteps()
	          );
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'renderSteps',
	    value: function renderSteps() {
	      var _this2 = this;
	
	      if (this.state.stepId <= 0) return null;
	
	      var renderStep = function renderStep(step, key) {
	        if (step.stepId === 0) return;
	        var activeClass = _this2.state.stepId >= step.stepId ? ' active' : '';
	        var focused = _this2.state.stepId === step.stepId ? ' focused' : '';
	        var isEarlierStep = _this2.state.stepId > step.stepId;
	        var clickable = isEarlierStep ? ' hasCursor' : '';
	
	        var onClick = function onClick(e) {
	          if (isEarlierStep) _this2.onNavClick(e, step.stepId);
	          return null;
	        };
	
	        return [_react2.default.createElement(
	          'div',
	          { key: key, className: 'step-circle-large' + activeClass + clickable + focused, onClick: onClick },
	          _react2.default.createElement(
	            'span',
	            null,
	            step.stepId
	          )
	        )];
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'steps' },
	        _react2.default.createElement(
	          'div',
	          { className: 'stepWrapper' },
	          this.steps.map(renderStep)
	        )
	      );
	    }
	  }, {
	    key: 'onNavClick',
	    value: function onNavClick(e, nav) {
	      var _this3 = this;
	
	      if (e) e.preventDefault();
	      var newStepId = this.state.stepId;
	      switch (nav) {
	        case 'next':
	          newStepId++;
	          break;
	        case 'previous':
	          newStepId--;
	          break;
	        case 1:
	          newStepId = 1;
	          break;
	        case 2:
	          newStepId = 2;
	          break;
	        case 3:
	          newStepId = 3;
	          break;
	        case 4:
	          newStepId = 4;
	          break;
	        case 5:
	          newStepId = 5;
	          break;
	        case 'complete':
	          this.setState({ processing: true });
	          var updateData = this.getResetData();
	          updateData = _extends({}, updateData, {
	            IsComplete: true,
	            Consent: true
	          });
	          this.props.saveEmbeddedBooking(updateData).then(function (res) {
	            var newStep = res.data.IsComplete === false ? res.data.CurrentStep : _this3.state.stepId;
	            _this3.setState({
	              stepId: newStep
	            });
	          }).catch(function (e) {
	            window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	          });
	
	          break;
	        case 'restart':
	          this.props.logout();
	          setTimeout(function () {
	            _this3.setState({
	              // flowType: 'with_regnr',
	              stepId: 0,
	              embedViewState: null
	            });
	          }, 200);
	          return;
	      }
	
	      this.setState({
	        stepId: Math.min(5, newStepId, Math.max(0, newStepId))
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var isDateTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var value = void 0;
	      var names = void 0;
	      var embeddedbooking = this.props.embeddedbooking;
	      var update = this.getResetData();
	      if (isDateTime) {
	        value = (0, _time.formatDate)(e, true);
	        names = 'OtherInfo.DamageDate'.split('.');
	
	        update = _extends({}, update, _defineProperty({
	          CurrentStep: this.state.stepId
	        }, names[0], _extends({}, embeddedbooking[names[0]], _defineProperty({
	          IsDirty: true
	        }, names[1], value))));
	      } else {
	        var name = e.target.name;
	        switch (name) {// In order to get correct autofill data for chrome
	          case 'fname':
	            name = 'ContactInfo.ContactName';
	            break;
	          case 'lname':
	            name = 'ContactInfo.ContactLastName';
	            break;
	          case 'email':
	            name = 'ContactInfo.ContactEmail';
	            break;
	        }
	        value = e.target.value;
	        names = name.split('.');
	        if (names[1] === 'Km') value = parseInt(e.target.value);
	        if (e.target.type === 'checkbox') value = e.target.checked;
	
	        update = _extends({}, update, _defineProperty({
	          CurrentStep: this.state.stepId
	        }, names[0], _extends({}, embeddedbooking[names[0]], _defineProperty({
	          IsDirty: true
	        }, names[1], value))));
	      }
	
	      this.props.saveEmbeddedBooking(update);
	    }
	  }, {
	    key: 'loginWithToken',
	    value: function loginWithToken(token, isCreateNew) {
	      var _this4 = this;
	
	      this.props.loginWithToken(token, 'bookingportal').then(function (res) {
	        // this.setView('logincomplete')
	        _this4.onLoginComplete(isCreateNew);
	      }, function () {
	        _this4.setState({ view: 'error' });
	      });
	    }
	  }, {
	    key: 'onLoginComplete',
	    value: function onLoginComplete(isCreateNew) {
	      var _this5 = this;
	
	      console.log('Authorized... createNew ? ', isCreateNew);
	      this.getStyle();
	      this.props.GetCarRentalAlts().then(function (result) {
	        _this5.props.setEmbeddedCarRentalAlts(result.data);
	      });
	      this.props.getInsuranceCompanies().then(function (result) {
	        _this5.props.setEmbeddedInsuranceCompanies(result.data.Item2);
	      });
	
	      if (isCreateNew) {
	        this.props.saveEmbeddedBooking(_extends({}, this.getResetData(), { CurrentStep: null })).then(function (res) {
	          console.log('Started new booking: ', res.data);
	        });
	      } else if (typeof isCreateNew === 'undefined') {
	        this.setState({ stepId: 0 });
	      }
	    }
	  }, {
	    key: 'getCountryCode',
	    value: function getCountryCode() {
	      var countryCode = '';
	      switch (this.props.params.language.toLowerCase()) {
	        case 'danish':
	          countryCode = 'DK';
	          break;
	        case 'english':
	          countryCode = 'EN';
	          break;
	        case 'swedish':
	          countryCode = 'SE';
	          break;
	        case 'norwegian':
	          countryCode = 'NO';
	          break;
	      }
	      this.setState({ countryCode: countryCode });
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var _this6 = this;
	
	      if (this.state.companyData && this.state.companyData.Token) {
	        this.setState({ isLoading: true }, function () {
	          _this6.props.getStyle(_this6.state.companyData.Token, 'bookingportal').then(function (res) {
	            _this6.setState({ styles: res.data, isLoading: false });
	            document.querySelector('#app').style.backgroundColor = res.data.ColoredBackground;
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      // Don't show page before the styling settings are loaded.
	      // if (this.state.isLoading) return null // Show spinner maybe?
	
	      var fontFamily = 'unset';
	      if (this.state.styles.FontType === 1 && this.state.styles.WebSafeFont) {
	        // Font selected from list
	        fontFamily = '"' + this.state.styles.WebSafeFont + '"';
	      } else if (this.state.styles.FontType === 2 && this.state.styles.FontURL && this.state.styles.FontFamily) {
	        fontFamily = '"' + this.state.styles.FontFamily + '"';
	      }
	
	      var renderStyle = function renderStyle() {
	        if (!_this7.state.styles) return null;
	        return _react2.default.createElement(
	          'style',
	          null,
	          '\n            :root{\n              --webSafeFont: ' + _this7.state.styles.WebSafeFont + ';\n              --fontURL: ' + _this7.state.styles.FontURL + ';\n              --fontFamily: ' + fontFamily + ';\n              --brandColor: ' + _this7.state.styles.BrandColor + ';\n              --brandColorSecondary: ' + _this7.state.styles.BrandColorSecondary + ';\n              --primaryBackgroundColor: ' + _this7.state.styles.PrimaryBackgroundColor + ';\n              --coloredBackground: ' + _this7.state.styles.ColoredBackground + ';\n              --h1Size: ' + _this7.state.styles.H1Size + ';\n              --h1Color: ' + _this7.state.styles.H1Color + ';\n              --h2Size: ' + _this7.state.styles.H2Size + ';\n              --h2Color: ' + _this7.state.styles.H2Color + ';\n              --bodySize: ' + _this7.state.styles.BodySize + ';\n              --bodyColor: ' + _this7.state.styles.BodyColor + ';\n              --navigationSize: ' + _this7.state.styles.NavigationSize + ';\n              --navigationColor: ' + _this7.state.styles.NavigationColor + ';\n              --linkSize: ' + _this7.state.styles.LinkSize + ';\n              --linkColor: ' + _this7.state.styles.LinkColor + ';\n              --buttonTextSize: ' + _this7.state.styles.ButtonTextSize + ';\n              --buttonTextColor: ' + _this7.state.styles.ButtonTextColor + ';\n              --buttonStrokeColor: ' + _this7.state.styles.ButtonStrokeColor + ';\n              --buttonFillColor: ' + _this7.state.styles.ButtonFillColor + ';\n              --hoverStrokeColor: ' + _this7.state.styles.HoverStrokeColor + ';\n              --hoverFillColor: ' + _this7.state.styles.HoverFillColor + ';\n              --checkboxColor: ' + _this7.state.styles.CheckboxColor + ';\n              --checkboxActiveColor: ' + _this7.state.styles.CheckboxActiveColor + ';\n              --backButtonTextSize: ' + _this7.state.styles.BackButtonTextSize + ';\n              --backButtonTextColor: ' + _this7.state.styles.BackButtonTextColor + ';\n              --backButtonStrokeColor: ' + _this7.state.styles.BackButtonStrokeColor + ';\n              --backButtonFillColor: ' + _this7.state.styles.BackButtonFillColor + ';\n              --backButtonHoverStrokeColor: ' + _this7.state.styles.BackButtonHoverStrokeColor + ';\n              --backButtonHoverFillColor: ' + _this7.state.styles.BackButtonHoverFillColor + ';\n              --inputFieldColor: ' + _this7.state.styles.InputFieldColor + ';\n              --emptyFieldTextColor: ' + _this7.state.styles.EmptyFieldTextColor + ';\n              --emptyFieldTextSize: ' + _this7.state.styles.EmptyFieldTextSize + ';             \n            }\n          .ff-wrap{\n            font-family: ' + fontFamily + ';\n          }\n          .color-wrap{\n            color: ' + _this7.state.styles.BodyColor + ';\n          }\n          .branch-color{\n            color: ' + _this7.state.styles.BrandColor + ';\n          }\n          .branch-bg{\n            background: ' + _this7.state.styles.BrandColor + ';\n          }\n          .branch-border{\n            border-color: ' + _this7.state.styles.BrandColor + ';\n          }\n          .fz-wrap{\n            font-size: ' + _this7.state.styles.BodySize + ';\n          }\n          .h1-color{\n            color: ' + _this7.state.styles.H1Color + ';\n          }\n          .h1-fz{\n            font-size: ' + _this7.state.styles.H1Size + ';\n          }\n          .h2-color{\n            color: ' + _this7.state.styles.H2Color + ';\n            font-weight: 700;\n          }\n          .h2-fz{\n            font-size: ' + _this7.state.styles.H2Size + ';\n          }\n          .nav-color{\n            color: ' + _this7.state.styles.NavigationColor + ';\n          }\n          .nav-fz{\n            font-size: ' + _this7.state.styles.NavigationSize + ';\n          }\n          .link-color{\n            color: ' + _this7.state.styles.LinkColor + ';\n          }\n          .link-fz{\n            font-size: ' + _this7.state.styles.LinkSize + ';\n          }\n        '
	        );
	      };
	
	      var onCompanyDataReceived = function onCompanyDataReceived(companyData) {
	        _this7.setState({ companyData: companyData[0] }, function () {
	          _this7.getStyle();
	          _this7.loginWithToken(companyData[0].Token, true);
	        });
	      };
	
	      if (this.state.stepId === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'embeddedbooking' },
	          this.state.styles.FontType === 2 && this.state.styles.FontURL !== '' && _react2.default.createElement(_RenderFontURL2.default, { url: this.state.styles.FontURL }),
	          renderStyle(),
	          _react2.default.createElement(
	            _IntroView2.default,
	            { companyData: this.state.companyData, onNavClick: this.onNavClick,
	              embedToken: this.props.params.embedToken,
	              countryCode: this.state.countryCode,
	              flowType: this.state.flowType,
	              setFlowType: this.setFlowType
	            },
	            _react2.default.createElement(_EmbedView2.default, {
	              notAvailableMsg: (0, _helpers.translation)(16684),
	              configErrorMsg: (0, _helpers.translation)('There seems to be a configuration error with the booking portal!'),
	              embedToken: this.props.params.embedToken,
	              language: this.props.params.language,
	              embedType: 'bookingportal',
	              view: this.state.embedViewState,
	              onViewChange: function onViewChange(newView) {
	                return _this7.setState({ embedViewState: newView });
	              },
	              onLoginComplete: this.onLoginComplete,
	              onCompanyTokensReceived: onCompanyDataReceived
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'embeddedbooking' },
	        this.state.styles.FontType === 2 && this.state.styles.FontURL !== '' && _react2.default.createElement(_RenderFontURL2.default, { url: this.state.styles.FontURL }),
	        renderStyle(),
	        _react2.default.createElement(_reactRouter.Link, { id: 'booking-portal-link', to: '' }),
	        _react2.default.createElement(
	          _EmbedView2.default,
	          {
	            embedToken: this.props.params.embedToken,
	            embedType: 'bookingportal',
	            view: this.state.embedViewState,
	            onViewChange: function onViewChange(newView) {
	              return _this7.setState({ embedViewState: newView });
	            }
	          },
	          this.getView()
	        )
	      );
	    }
	  }]);
	
	  return EmbeddedBooking;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common,
	    carData: state.embeddedbooking.CarData,
	    images: state.embeddedbooking.Images,
	    otherInfo: state.embeddedbooking.OtherInfo,
	    contactInfo: state.embeddedbooking.ContactInfo,
	    embeddedbooking: state.embeddedbooking
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { saveEmbeddedBooking: _embeddedbooking.saveEmbeddedBooking, setEmbeddedInsuranceCompanies: _embeddedbooking.setEmbeddedInsuranceCompanies, setEmbeddedCarRentalAlts: _embeddedbooking.setEmbeddedCarRentalAlts, getBookingPortalRedirectUrlFromToken: _embeddedbooking.getBookingPortalRedirectUrlFromToken, getInsuranceCompanies: _insurancecompanies.getInsuranceCompanies, loginWithToken: _embedded.loginWithToken, logout: _embedded.logout, GetCarRentalAlts: _carrentalalternatives.GetCarRentalAlts, getStyle: _embedded.getStyle })(EmbeddedBooking);

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _employees = __webpack_require__(128);
	
	var _actions = __webpack_require__(129);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _HelpText = __webpack_require__(130);
	
	var _HelpText2 = _interopRequireDefault(_HelpText);
	
	var _Workhours = __webpack_require__(448);
	
	var _Workhours2 = _interopRequireDefault(_Workhours);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	__webpack_require__(1391);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	// import NotificationCopy from '../../../shared/components/NotificationCopy'
	
	// Styles
	
	
	// Utils
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'edit',
	      validate: {
	        UsersInitials: true,
	        UserName: true,
	        Phone: true,
	        Email: true
	      },
	      employee: {
	        Id: 0,
	        CompanyId: 0,
	        Name: '',
	        UsersInitials: '',
	        UserName: '',
	        Phone: '',
	        PhoneCode: _this.props.phonecode,
	        Email: '',
	        Note: '',
	        Active: true,
	        Department: 0,
	        ProductionPart: '',
	        EmployeeRole: 0,
	        StartScreen: '/workscreen',
	        ProcessTimeGainFactor: 0,
	        IsWageReported: true,
	        EmploymentDate: (0, _moment2.default)(),
	        TerminationDate: (0, _moment2.default)(),
	        IgnoreIPRestriction: false,
	        CompanyPunchClockActive: false,
	        CompanyIPRestriction: false,
	        WorkHour: {
	          Monday: 0,
	          MondayStartTime: null,
	          MondayEndTime: null,
	          Tuesday: 0,
	          TuesdayStartTime: null,
	          TuesdayEndTime: null,
	          Wednesday: 0,
	          WednesdayStartTime: null,
	          WednesdayEndTime: null,
	          Thursday: 0,
	          ThursdayStartTime: null,
	          ThursdayEndTime: null,
	          Friday: 0,
	          FridayStartTime: null,
	          FridayEndTime: null,
	          Saturday: 0,
	          SaturdayStartTime: null,
	          SaturdayEndTime: null,
	          Sunday: 0,
	          SundayStartTime: null,
	          SundayEndTime: null
	        },
	        PauseType: 0,
	        MondayPause: 0,
	        TuesdayPause: 0,
	        WednesdayPause: 0,
	        ThursdayPause: 0,
	        FridayPause: 0,
	        SaturdayPause: 0,
	        SundayPause: 0,
	        NotificationSettings: [],
	        MyWorkscreen: {
	          Active: false,
	          Step1: false,
	          Step2: false,
	          Step3: false,
	          Step4: false,
	          Step5: false,
	          Step6: false,
	          Step7: false
	        }
	      },
	      dimensions: {
	        width: 0,
	        height: 0
	      }
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onInputLanguageChange = _this.onInputLanguageChange.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.onChangeDate = _this.onChangeDate.bind(_this);
	    _this.onCheck = _this.onCheck.bind(_this);
	    _this.saveAddEmployee = _this.saveAddEmployee.bind(_this);
	    _this.addEmployee = _this.addEmployee.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getEmployee(this.props);
	      window.addEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.getEmployee(nextProps);
	    }
	  }, {
	    key: 'getEmployee',
	    value: function getEmployee(props) {
	      var _this2 = this;
	
	      if (typeof props.item === 'undefined') return;
	      if (typeof props.item.UserId !== 'undefined') {
	        props.getEmployee(props.item.UserId).then(function (res) {
	          _this2.setState({
	            type: 'edit',
	            employee: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        employee: {
	          UserId: 0,
	          CompanyId: parseInt(this.props.auth.user.ShopId),
	          Name: '',
	          UsersInitials: '',
	          UserName: '',
	          Phone: '',
	          PhoneCode: this.props.phonecode,
	          Email: '',
	          Note: '',
	          Active: true,
	          Department: 0,
	          ProductionPart: 100,
	          EmployeeRole: 3,
	          StartScreen: '/workscreen',
	          ProcessTimeGainFactor: 100,
	          IsWageReported: true,
	          EmploymentDate: Date.now(),
	          TerminationDate: (0, _moment2.default)(),
	          IgnoreIPRestriction: false,
	          CompanyPunchClockActive: false,
	          CompanyIPRestriction: false,
	          WorkHour: {
	            Monday: 0,
	            MondayStartTime: null,
	            MondayEndTime: null,
	            Tuesday: 0,
	            TuesdayStartTime: null,
	            TuesdayEndTime: null,
	            Wednesday: 0,
	            WednesdayStartTime: null,
	            WednesdayEndTime: null,
	            Thursday: 0,
	            ThursdayStartTime: null,
	            ThursdayEndTime: null,
	            Friday: 0,
	            FridayStartTime: null,
	            FridayEndTime: null,
	            Saturday: 0,
	            SaturdayStartTime: null,
	            SaturdayEndTime: null,
	            Sunday: 0,
	            SundayStartTime: null,
	            SundayEndTime: null
	          },
	          PauseType: 0,
	          MondayPause: 0,
	          TuesdayPause: 0,
	          WednesdayPause: 0,
	          ThursdayPause: 0,
	          FridayPause: 0,
	          SaturdayPause: 0,
	          SundayPause: 0,
	          NotificationSettings: [],
	          MyWorkscreen: {
	            Active: false,
	            Step1: false,
	            Step2: false,
	            Step3: false,
	            Step4: false,
	            Step5: false,
	            Step6: false,
	            Step7: false,
	            Step101: false,
	            Step102: false,
	            Step103: false,
	            Step104: false
	          },
	          dimensions: {
	            width: 0,
	            height: 0
	          }
	        }
	      });
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'saveAddEmployee',
	    value: function saveAddEmployee(e) {
	      var _this3 = this;
	
	      if (this.state.employee.UserId > 0) {
	        var _ref;
	
	        var propName = typeof e === 'string' ? e : e.target.name;
	        /**
	         * If current prop it returns the new value, else null
	         * @param {String} prop Actual prop
	         * @param {Any} value New value of prop
	         */
	        var valueOrNull = function valueOrNull(prop, value) {
	          if (typeof propName === 'string') {
	            return propName === prop ? value : null;
	          }
	          return value;
	        };
	
	        /**
	         * If dependent props has propName it returns the new value, else null
	         * @param {Array<String>} props Dependent props
	         * @param {Any} value New value of prop
	         */
	        var dependentValueOrNull = function dependentValueOrNull(props, value) {
	          if (typeof propName === 'string') {
	            return props.includes(propName) ? value : null;
	          }
	          return value;
	        };
	
	        // convert date
	        var formatDate = function formatDate(date) {
	          if (date === null || date === '' || date === undefined) return null;
	          if (Number.isInteger(date)) date = (0, _moment2.default)(window.CustomDate(date));
	          // console.log('format date:', date.format('YYYY-MM-DDTHH:mm:ss'))
	          if (typeof date.format === 'function') {
	            return date.format('YYYY-MM-DDTHH:mm:ss');
	          }
	          return date;
	        };
	
	        var employee = _extends({}, this.state.employee);
	        if (employee.ProductionPart === '' || employee.ProductionPart === null) employee.ProductionPart = 0;
	        employee.EmploymentDate = formatDate(employee.EmploymentDate);
	        employee.TerminationDate = formatDate(employee.TerminationDate);
	
	        var data = {
	          Id: employee.Id,
	          UserId: employee.UserId,
	          CompanyId: employee.CompanyId,
	          Name: valueOrNull('Name', employee.Name),
	          UsersInitials: valueOrNull('UsersInitials', employee.UsersInitials),
	          UserName: valueOrNull('UserName', employee.UserName),
	          Phone: valueOrNull('Phone', employee.Phone),
	          PhoneCode: valueOrNull('PhoneCode', employee.PhoneCode),
	          Email: valueOrNull('Email', employee.Email),
	          Note: valueOrNull('Note', employee.Note),
	          Active: valueOrNull('Active', employee.Active),
	          Department: valueOrNull('Department', employee.Department),
	          IsAssignableToOrders: valueOrNull('IsAssignableToOrders', employee.IsAssignableToOrders),
	          ProductionPartHasValue: dependentValueOrNull(['IsWageReported', 'ProductionPart'], true),
	          ProductionPart: dependentValueOrNull(['IsWageReported', 'ProductionPart'], employee.ProductionPart),
	          EmployeeRole: valueOrNull('EmployeeRole', employee.EmployeeRole),
	          StartScreen: valueOrNull('StartScreen', employee.StartScreen),
	          ProcessTimeGainFactor: valueOrNull('ProcessTimeGainFactor', employee.ProcessTimeGainFactor),
	          IsWageReported: dependentValueOrNull(['IsWageReported', 'ProductionPart'], employee.IsWageReported),
	          EmploymentDateHasValue: valueOrNull('EmploymentDate', true),
	          EmploymentDate: valueOrNull('EmploymentDate', employee.EmploymentDate),
	          TerminationDateHasValue: valueOrNull('TerminationDate', true),
	          TerminationDate: valueOrNull('TerminationDate', employee.TerminationDate),
	          Language: valueOrNull('Language', employee.Language),
	          IgnoreIPRestriction: valueOrNull('IgnoreIPRestriction', employee.IgnoreIPRestriction),
	          NotificationSettingsHasValue: dependentValueOrNull(['Noti_Email', 'Noti_Sms'], true),
	          NotificationSettings: dependentValueOrNull(['Noti_Email', 'Noti_Sms'], employee.NotificationSettings),
	          MyWorkscreenHasValue: /(^WorkScreen).*|(^Step).*/.test(propName),
	          MyWorkscreen: /(^WorkScreen).*|(^Step).*/.test(propName) ? (_ref = {
	            UserId: employee.MyWorkscreen.UserId
	          }, _defineProperty(_ref, propName, employee.MyWorkscreen[propName]), _defineProperty(_ref, 'Active', valueOrNull('WorkScreen_Active', employee.MyWorkscreen.Active)), _ref) : null,
	          PermissionsHasValue: valueOrNull('Permissions', true),
	          Permissions: valueOrNull('Permissions', employee.Permissions)
	
	          // update
	        };this.props.CreateSaveEmployee(data).then(function (res) {
	          _this3.props.onSave(res.data, _this3.state.type);
	          _this3.setState({
	            employee: res.data
	          });
	        }, function (err) {
	          if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	            var errors = err.response.data.Errors;
	            var errorText = '';
	            errors.map(function (item) {
	              if (item.DictionaryKey !== 0) {
	                errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	              }
	            });
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	          } else {
	            var errorMessage = function errorMessage(error) {
	              var messageText = '';
	              if (error < 5) {
	                messageText += (0, _helpers.translation)('16334');
	              }
	              switch (error) {
	                case 1:
	                  messageText += (0, _helpers.translation)('16329');
	                  break;
	                case 2:
	                  messageText += (0, _helpers.translation)('16336');
	                  break;
	                case 3:
	                  messageText += (0, _helpers.translation)('16335');
	                  break;
	                case 4:
	                  messageText += (0, _helpers.translation)('16338');
	                  break;
	                case 5:
	                  messageText += (0, _helpers.translation)('16337');
	                  break;
	                default:
	                  break;
	              }
	              messageText += '<br>';
	              return messageText;
	            };
	            var _errors = err.response.data;
	            if (Array.isArray(_errors)) {
	              var message = _errors.map(function (error) {
	                return errorMessage(error);
	              });
	              window.toastr.error(message, (0, _helpers.translation)('216'));
	            } else {
	              // Toastr
	              window.toastr.error((0, _helpers.translation)('1883'), (0, _helpers.translation)('216'));
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'addEmployee',
	    value: function addEmployee() {
	      var _this4 = this;
	
	      if (this.state.employee.UserId === 0) {
	        // convert date
	        var formatDate = function formatDate(date) {
	          if (date === null || date === '' || date === 0 || date === undefined) return null;
	          if (Number.isInteger(date)) date = (0, _moment2.default)(window.CustomDate(date));
	          // console.log(date.format('YYYY-MM-DDTHH:mm:ss'))
	          if (typeof date.format === 'function') {
	            return date.format('YYYY-MM-DDTHH:mm:ss');
	          }
	          return date;
	        };
	        var employee = _extends({}, this.state.employee);
	        employee.EmploymentDate = formatDate(employee.EmploymentDate);
	        employee.TerminationDate = formatDate(employee.TerminationDate);
	
	        // update
	        this.props.CreateSaveEmployee(employee).then(function (res) {
	          _this4.props.onSave(res.data, _this4.state.type);
	          _this4.setState({
	            employee: res.data
	          });
	        }, function (err) {
	          if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	            var errors = err.response.data.Errors;
	            var errorText = '';
	            errors.map(function (item) {
	              if (item.DictionaryKey !== 0) {
	                errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	              }
	            });
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	          } else {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)('1883'), (0, _helpers.translation)('216'));
	          }
	        });
	        // } else {
	        //   console.log('validation error')
	        // }
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(name, e) {
	      var _this5 = this;
	
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (typeof e === 'undefined') {
	          e = name;
	        }
	        name = e.target.name;
	        value = e.target.value;
	      }
	
	      this.setState({
	        employee: _extends({}, this.state.employee, _defineProperty({}, name, value))
	      }, function () {
	        if (name === 'StartScreen' || name === 'EmployeeRole' || name === 'Department') {
	          _this5.saveAddEmployee(name);
	        }
	      });
	    }
	  }, {
	    key: 'onInputLanguageChange',
	    value: function onInputLanguageChange(name, e) {
	      var _this6 = this;
	
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (typeof e === 'undefined') {
	          e = name;
	        }
	        name = e.target.name;
	      }
	
	      var langInfos = this.props.getLanguageInfos();
	      langInfos.map(function (l) {
	        if (l.SelfLangName === e.target.value) {
	          value = l.LanguageName;
	        }
	      });
	
	      if (this.state.employee.UserId === this.props.auth.user.UserId) {
	        this.props.setLanguage(value);
	      }
	
	      this.setState({
	        employee: _extends({}, this.state.employee, _defineProperty({}, name, value))
	      }, function () {
	        if (name === 'Language') {
	          _this6.saveAddEmployee(name);
	        }
	      });
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      var _this7 = this;
	
	      e.persist();
	      var value = e.target.checked;
	      var name = e.target.name;
	      if (name === 'WorkScreen_Active') {
	        var workscreen = this.state.employee.MyWorkscreen;
	        workscreen.Active = value;
	        this.setState({
	          employee: _extends({}, this.state.employee, {
	            MyWorkscreen: workscreen
	          })
	        }, function () {
	          _this7.saveAddEmployee(e);
	        });
	      } else {
	        this.setState({
	          employee: _extends({}, this.state.employee, _defineProperty({}, name, value))
	        }, function () {
	          _this7.saveAddEmployee(e);
	        });
	      }
	    }
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(name, e) {
	      var _this8 = this;
	
	      var value = '';
	      value = name.target.value;
	      if (name.target.name === 'PhoneNumber') {
	        name = 'Phone';
	        this.setState({
	          employee: _extends({}, this.state.employee, _defineProperty({}, name, value))
	        });
	      } else {
	        this.setState({
	          employee: _extends({}, this.state.employee, {
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        }, function () {
	          _this8.saveAddEmployee(name);
	        });
	      }
	    }
	  }, {
	    key: 'onChangeDate',
	    value: function onChangeDate(name, e) {
	      var _this9 = this;
	
	      var value = e;
	      this.setState({
	        employee: _extends({}, this.state.employee, _defineProperty({}, name, value))
	      }, function () {
	        _this9.saveAddEmployee(name);
	      });
	    }
	  }, {
	    key: 'onCheck',
	    value: function onCheck(e) {
	      var _this10 = this;
	
	      e.persist();
	      var employee = _extends({}, this.state.employee);
	      if (e.target.name.substring(0, 4) === 'Step') {
	        var field = e.target.name;
	        var value = e.target.checked;
	        var workscreen = this.state.employee.MyWorkscreen;
	        workscreen[field] = value;
	        this.setState({
	          employee: _extends({}, employee, {
	            MyWorkscreen: workscreen
	          })
	        }, function () {
	          _this10.saveAddEmployee(e);
	        }
	        //, console.log(this.state.employee)
	        );
	      } else {
	        // check if set
	        var set = false;
	        var array = [].concat(_toConsumableArray(this.state.employee.NotificationSettings));
	        array.map(function (val, key) {
	          // console.log('Checked: ', key, val)
	          if (val.NotificationEvent === Number(e.target.value)) {
	            set = true;
	            if (e.target.name === 'Noti_Sms') {
	              array[key].Sms = e.target.checked;
	            } else if (e.target.name === 'Noti_Email') {
	              array[key].Email = e.target.checked;
	            }
	          }
	        });
	        // if not set - add object
	        if (set === false) {
	          var newItem = {};
	          if (e.target.name === 'Noti_Sms') {
	            newItem = {
	              NotificationEvent: Number(e.target.value),
	              Sms: e.target.checked,
	              Email: false
	            };
	          } else if (e.target.name === 'Noti_Email') {
	            newItem = {
	              NotificationEvent: Number(e.target.value),
	              Sms: false,
	              Email: e.target.checked
	            };
	          }
	          array.push(newItem);
	          // if set change
	        }
	        this.setState({
	          employee: _extends({}, employee, {
	            NotificationSettings: array
	          })
	        }, function () {
	          return _this10.saveAddEmployee(e);
	        });
	      }
	    }
	  }, {
	    key: 'renderUser',
	    value: function renderUser() {
	      var _this11 = this;
	
	      var employee = _extends({}, this.state.employee);
	      /* const ActiveChecked = (type, active) => {
	        if (active === type) {
	          return (
	            true
	          )
	        }
	      } */
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('64') },
	        _react2.default.createElement(_text2.default, { name: 'Name', value: employee.Name || '', onChange: this.onInputChange, onBlur: this.saveAddEmployee, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_text2.default, { name: 'UsersInitials', value: employee.UsersInitials || '', maxLength: 2, onChange: this.onInputChange, onBlur: this.saveAddEmployee, labelText: (0, _helpers.translation)('1815'), helpText: (0, _helpers.translation)('1964') }),
	        _react2.default.createElement(_text2.default, { name: 'UserName', value: employee.UserName || '', onChange: this.onInputChange, onBlur: this.saveAddEmployee, labelText: (0, _helpers.translation)('1'), helpText: (0, _helpers.translation)('1965') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('38') },
	          _react2.default.createElement(_Phone2.default, {
	            onChange: this.onPhoneChange,
	            onBlur: function onBlur() {
	              return _this11.saveAddEmployee('Phone');
	            },
	            code: employee.PhoneCode,
	            number: employee.Phone })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'Email', value: employee.Email || '', onChange: this.onInputChange, onBlur: this.saveAddEmployee, labelText: (0, _helpers.translation)('1052') }),
	        _react2.default.createElement(_textarea2.default, { name: 'Note', onChange: this.onInputChange, onBlur: this.saveAddEmployee, value: employee.Note || '', placeholder: (0, _helpers.translation)('2260'), labelText: (0, _helpers.translation)('93') }),
	        _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onRadioChange, checked: this.state.employee.Active, labelText: (0, _helpers.translation)('295'), helpText: (0, _helpers.translation)('1967') })
	      );
	    }
	  }, {
	    key: 'renderSettings',
	    value: function renderSettings() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) || typeof this.props.employeeTypes === 'undefined') return null;
	      if (Object.keys(this.props.employeeTypes).length === 0) return null;
	      var employee = this.state.employee;
	      var EmploymentDate = this.state.employee.EmploymentDate;
	      var TerminationDate = this.state.employee.TerminationDate;
	
	      var langInfos = this.props.getLanguageInfos();
	
	      // Date
	      var renderEmploymentDate = '';
	      if (typeof EmploymentDate !== 'undefined' && EmploymentDate !== null && EmploymentDate !== '') {
	        renderEmploymentDate = window.CustomDate(EmploymentDate);
	      }
	
	      var renderTerminationDate = '';
	      if (typeof TerminationDate !== 'undefined' && TerminationDate !== null && TerminationDate !== '') {
	        renderTerminationDate = window.CustomDate(TerminationDate);
	      }
	
	      var ActiveChecked = function ActiveChecked(type, active) {
	        if (active === type) {
	          return true;
	        }
	      };
	
	      var EmployeeTypesList = function EmployeeTypesList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: key + 1 },
	          (0, _helpers.translation)(val)
	        );
	      };
	
	      var CompanyDepartmentList = function CompanyDepartmentList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: key },
	          (0, _helpers.translation)(val)
	        );
	      };
	
	      var langInfosList = function langInfosList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.SelfLangName },
	          (0, _helpers.translation)(val.SelfLangName)
	        );
	      };
	
	      var GetSelfLanguage = function GetSelfLanguage(allLanguages, currentLanguage) {
	        var defaultLanguage = void 0;
	        allLanguages.map(function (l) {
	          if (l.LanguageName === currentLanguage) {
	            defaultLanguage = l.SelfLangName;
	          }
	        });
	        return defaultLanguage;
	      };
	
	      var employeeTypes = [];
	      for (var i = 1; i < Object.keys(this.props.employeeTypes).length + 1; i++) {
	        employeeTypes.push(this.props.employeeTypes[i]);
	      }
	
	      var companyDepartments = [];
	      for (i = 0; i < Object.keys(this.props.companyDepartments).length; i++) {
	        companyDepartments.push(this.props.companyDepartments[i]);
	      }
	
	      var disableCompanyDepartment = true;
	      if (this.props.auth.user.UserType === 3 && this.state.employee.Permissions !== undefined) {
	        for (i = 0; i < this.state.employee.Permissions.length; i++) {
	          if (this.state.employee.Permissions[i].Id === 9 && this.state.employee.Permissions[i].Checked) {
	            disableCompanyDepartment = false;
	          }
	        }
	      } else if (this.props.auth.user.UserType === 7) {
	        disableCompanyDepartment = false;
	      }
	
	      var inputProps = {
	        readOnly: true
	
	        // console.log('auth', this.props.auth)
	      };var showDepartment = this.props.auth.departmentType === 2; // both
	
	      var gainFactor = '';
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20, 17)) {
	        gainFactor = _react2.default.createElement(_text2.default, {
	          name: 'ProcessTimeGainFactor',
	          value: employee.ProcessTimeGainFactor || '',
	          onChange: this.onInputChange,
	          onBlur: this.saveAddEmployee,
	          labelText: (0, _helpers.translation)('13484'),
	          helpText: (0, _helpers.translation)('1976')
	        });
	      }
	
	      // startScreens
	      var startScreens = [{ DictionaryKey: '18', value: '/workscreen' }, { DictionaryKey: '683', value: '/orders' }, { DictionaryKey: '1887', value: '/mypage' }, { DictionaryKey: '6', value: '/settings' }, { DictionaryKey: '10', value: '/employees' }, { DictionaryKey: '14', value: '/customers' }, { DictionaryKey: '1172', value: '/prices' }, { DictionaryKey: '437', value: '/punchclock' }, { DictionaryKey: '448', value: '/punchreport' }];
	
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('6') },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('60') },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'EmployeeRole', onChange: this.onInputChange, value: employee.EmployeeRole },
	            employeeTypes.map(EmployeeTypesList)
	          )
	        ),
	        showDepartment && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('626') },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'Department', onChange: this.onInputChange, value: employee.Department, disabled: disableCompanyDepartment },
	            companyDepartments.map(CompanyDepartmentList)
	          )
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('56') },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'StartScreen', onChange: this.onInputChange, value: employee.StartScreen },
	            startScreens.map(function (v, k) {
	              return _react2.default.createElement(
	                'option',
	                { key: k, value: v.value },
	                (0, _helpers.translation)(v.DictionaryKey)
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_switch2.default, { name: 'IsAssignableToOrders', onChange: this.onRadioChange, checked: employee.IsAssignableToOrders, labelText: (0, _helpers.translation)('18325') }),
	        (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && _react2.default.createElement(_text2.default, {
	          name: 'ProductionPart',
	          value: employee.ProductionPart,
	          onChange: this.onInputChange,
	          onBlur: this.saveAddEmployee,
	          disabled: ActiveChecked(false, employee.IsWageReported),
	          labelText: (0, _helpers.translation)('967'),
	          helpText: ActiveChecked(false, employee.IsWageReported) ? (0, _helpers.translation)('14878') : (0, _helpers.translation)('1975')
	        }),
	        gainFactor,
	        (0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && _react2.default.createElement(_switch2.default, { name: 'IsWageReported', onChange: this.onRadioChange, checked: employee.IsWageReported, labelText: (0, _helpers.translation)('1816') }),
	        _react2.default.createElement(_datetime2.default, {
	          inputProps: inputProps,
	          dateFormat: 'DD-MM-YYYY',
	          closeOnSelect: true,
	          timeFormat: false,
	          value: renderEmploymentDate,
	          onChange: this.onChangeDate.bind(this, 'EmploymentDate'),
	          labelText: (0, _helpers.translation)('1504') }),
	        _react2.default.createElement(_datetime2.default, {
	          dateFormat: 'DD-MM-YYYY',
	          closeOnSelect: true,
	          timeFormat: false,
	          value: renderTerminationDate,
	          onChange: this.onChangeDate.bind(this, 'TerminationDate'),
	          labelText: (0, _helpers.translation)('1505') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1711') },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'Language', onChange: this.onInputLanguageChange, value: GetSelfLanguage(langInfos, employee.Language) },
	            langInfos.map(langInfosList)
	          )
	        ),
	        employee.CompanyPunchClockActive && _react2.default.createElement(_switch2.default, { name: 'IgnoreIPRestriction', checked: employee.IgnoreIPRestriction,
	          onChange: this.onRadioChange, disabled: !employee.CompanyIPRestriction,
	          labelText: (0, _helpers.translation)('16680') })
	      );
	    }
	  }, {
	    key: 'renderHours',
	    value: function renderHours() {
	      var _this12 = this;
	
	      // if (this.state.type === 'create') return null
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0)) return null;
	
	      var setWorkHours = function setWorkHours(data) {
	        _this12.setState({
	          employee: _extends({}, _this12.state.employee, {
	            WorkHour: data
	          })
	        });
	      };
	
	      return _react2.default.createElement(_Workhours2.default, { LogCount: this.state.employee.LogCount, setWorkHours: setWorkHours, WorkHours: this.state.employee.WorkHour, onlyShow: true, displayId: 1 });
	    }
	  }, {
	    key: 'renderNotifications',
	    value: function renderNotifications() {
	      var _this13 = this;
	
	      // if (this.state.type === 'create') return null
	      if (this.props.notificationEventType === undefined || this.props.notificationEventType === null || this.props.notificationEventType.length === 0) {
	        return;
	      }
	      var employee = this.state.employee;
	      if (employee.NotificationSettings.length === 0) return null;
	      var checkedSms = [];
	      var checkedEmail = [];
	      employee.NotificationSettings.map(function (val, k) {
	        checkedSms[val.NotificationEvent] = val.Sms;
	        checkedEmail[val.NotificationEvent] = val.Email;
	      });
	      var NotificationEventTypeList = function NotificationEventTypeList(val, key) {
	        // if (val.NotificationEvent >= 100) {
	        //   return
	        // }
	        // If inherited from premium partner, hide notification
	        var forsiEnable = _this13.props.auth.permissions.ChainAssessmentSystem === 1; // Forsi is available for the company
	        if (val.NotificationEvent === 9 && (!(0, _auth.hasSubscriptionPermission)(_this13.props.auth, 20) || !forsiEnable)) {
	          return;
	        }
	        // hide DeliveryTimeChange for body shop in the section Referred orders. (*** temporary ***)
	        if (val.NotificationEvent === 23 && _this13.props.auth.departmentType === 1) {
	          return;
	        }
	        var key2 = val.NotificationEvent;
	        // console.log('Notif. key: ', translation(val).substring(0, 8), key, 'sms:' + checkedSms[key], 'mail:' + checkedEmail[key])
	        var helptext = '';
	        var labelText = '';
	        switch (key2) {
	          case 1:
	            if (_this13.props.auth.departmentType === 0) {
	              helptext = '2169';
	            } else {
	              helptext = '15349';
	              labelText = '15348';
	            }
	            break;
	          case 2:
	            helptext = '2170';
	            break;
	          case 3:
	          case 22:
	            helptext = '2171';
	            break;
	          case 4:
	          case 24:
	            helptext = '2198';
	            break;
	          case 5:
	          case 25:
	            helptext = '2172';
	            break;
	          case 6:
	          case 26:
	            helptext = '2173';
	            break;
	          case 7:
	            helptext = '1969';
	            break;
	          case 8:
	            helptext = '1970';
	            break;
	          case 9:
	            helptext = '1971';
	            break;
	          case 10:
	            helptext = '1972';
	            break;
	          case 11:
	            helptext = '1973';
	            break;
	          case 12:
	            helptext = '2197';
	            break;
	          case 13:
	            if (_this13.props.auth.departmentType === 1) helptext = '15346';else helptext = '2196';
	            break;
	          case 27:
	            helptext = '2196';
	            break;
	          case 29:
	            helptext = '17978';
	            break;
	          case 14:
	            helptext = '13709';
	            break;
	          case 16:
	            helptext = '15075';
	            break;
	          case 17:
	            helptext = '15174';
	            break;
	          case 18:
	          case 23:
	            if (_this13.props.auth.departmentType === 1) helptext = '15173';else helptext = '15150';
	            break;
	          case 19:
	            helptext = '15236';
	            break;
	          case 20:
	            helptext = '15349';
	            break;
	          case 21:
	            helptext = '15073';
	            break;
	          case 100:
	            helptext = '2169';
	            break;
	          case 102:
	            helptext = '15023'; // '2170'
	            break;
	          case 103:
	            helptext = '2171';
	            break;
	          case 104:
	            helptext = '15024'; // '2198'
	            break;
	          case 105:
	            helptext = '2172';
	            break;
	          case 106:
	            helptext = '2173';
	            break;
	          case 108:
	            helptext = '15022';
	            break;
	          case 150:
	            helptext = '17958';
	        }
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: [4], align: 'center', key: key, spacing: 1 },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(labelText || (0, _helpers.enumtranslate)('NotificationEventType', val.NotificationEvent)),
	            ' ',
	            _react2.default.createElement(_HelpText2.default, { text: (0, _helpers.translation)(helptext) })
	          ),
	          _react2.default.createElement(_check2.default, { name: 'Noti_Email', value: key2, checked: checkedEmail[key2], onChange: _this13.onCheck, disabled: employee.Email === null || employee.Email.length === 0, simple: true }),
	          val.NotificationEvent !== 16 && (val.NotificationEvent < 100 || val.NotificationEvent >= 150) && _react2.default.createElement(_check2.default, { name: 'Noti_Sms', value: key2, checked: checkedSms[key2], onChange: _this13.onCheck, disabled: employee.Phone === null || employee.Phone.length === 0, simple: true, width: '1' }) || _react2.default.createElement('span', null)
	        );
	      };
	
	      var sortPaintNotifications = function sortPaintNotifications(a, b) {
	        var nEventA = a.NotificationEvent;
	        var nEventB = b.NotificationEvent;
	
	        // Sort to top
	        var topSpecialValues = [7, 17, 1, 19];
	        var isTopSpecialA = topSpecialValues.includes(nEventA);
	        var isTopSpecialB = topSpecialValues.includes(nEventB);
	        if (isTopSpecialA) {
	          if (!isTopSpecialB) {
	            return -1;
	          } else {
	            return topSpecialValues.indexOf(nEventA) - topSpecialValues.indexOf(nEventB);
	          }
	        } else if (isTopSpecialB) {
	          return 1;
	        }
	
	        // Sort to just above 21
	        var bottomSpecialValues = [10, 11];
	        var isBottomSpecialA = bottomSpecialValues.includes(nEventA);
	        var isBottomSpecialB = bottomSpecialValues.includes(nEventB);
	        if (isBottomSpecialA) {
	          if (nEventB === 21) {
	            return -1;
	          } else if (!isBottomSpecialB) {
	            return 1;
	          }
	        } else if (isBottomSpecialB) {
	          if (nEventA === 21) {
	            return 1;
	          } else {
	            return -1;
	          }
	        }
	
	        return nEventA - nEventB;
	      };
	
	      var sortBodyNotifications = function sortBodyNotifications(a, b) {
	        var nEventA = a.NotificationEvent;
	        var nEventB = b.NotificationEvent;
	
	        // Move event 17, 19 and 20 just after 1
	        var specialValues = [17, 19, 20];
	        var isSpecialA = specialValues.includes(nEventA);
	        var isSpecialB = specialValues.includes(nEventB);
	        if (isSpecialA) {
	          if (nEventB === 1) {
	            return 1;
	          } else if (!isSpecialB) {
	            return -1;
	          }
	        } else if (isSpecialB) {
	          if (nEventA === 1) {
	            return -1;
	          } else {
	            return 1;
	          }
	        }
	
	        return nEventA - nEventB;
	      };
	
	      var notificationEventType = [];
	      for (var i = 1; i < Object.keys(this.props.notificationEventType).length + 1; i++) {
	        notificationEventType.push(this.props.notificationEventType[i]);
	      }
	
	      if (employee.Department === 1) {
	        // Sort for BodyShop
	        employee.NotificationSettings.sort(sortBodyNotifications);
	      } else {
	        employee.NotificationSettings.sort(sortPaintNotifications);
	      }
	
	      // separate body shop employee notifications into 2 sections
	      var isBodyShopEmployee = employee.Department === 1;
	
	      var notificationGroups = employee.NotificationSettings.reduce(function (list, notif) {
	        if (notif.Group === 1) {
	          if (isBodyShopEmployee) {
	            if ([1, 2, 3, 4, 5, 6, 13, 18].includes(notif.NotificationEvent)) {
	              return _extends({}, list, { orderBodyPaint: [].concat(_toConsumableArray(list.orderBodyPaint), [notif]) // Notifications between paint and boydy
	              });
	            } else if ([9, 10, 11, 16, 17, 19, 20].includes(notif.NotificationEvent)) {
	              return _extends({}, list, { order: [].concat(_toConsumableArray(list.order), [notif]) // Internal body notifications
	              });
	            } else {
	              return list;
	            }
	          } else {
	            return _extends({}, list, { order: [].concat(_toConsumableArray(list.order), [notif]) });
	          }
	        } else if (notif.Group === 2) {
	          return _extends({}, list, { refOrder: [].concat(_toConsumableArray(list.refOrder), [notif]) });
	        } else if (notif.Group === 4) {
	          return _extends({}, list, { bookingPortal: [].concat(_toConsumableArray(list.bookingPortal), [notif]) });
	        } else {
	          return _extends({}, list, { copy: [].concat(_toConsumableArray(list.copy), [notif]) });
	        }
	      }, { order: [], orderBodyPaint: [], refOrder: [], copy: [], bookingPortal: [] });
	
	      var orderNotif = notificationGroups.order;
	      var orderBodyPaintNotif = notificationGroups.orderBodyPaint;
	      var refNotif = notificationGroups.refOrder;
	      var copyNotif = notificationGroups.copy;
	      var bookingPortalNotif = notificationGroups.bookingPortal;
	
	      var title = this.state.employee.Department !== 0 ? '13461' : '14947';
	
	      var renderNotificationsCopy = function renderNotificationsCopy() {
	        if (!(0, _auth.hasSubscriptionPermission)(_this13.props.auth, 30)) return null;
	        if (_this13.state.type === 'create') return null;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(title) }),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [4], align: 'center', spacing: 1 },
	            _react2.default.createElement('span', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1052')
	            ),
	            _react2.default.createElement('span', null)
	          ),
	          copyNotif.map(NotificationEventTypeList)
	        );
	      };
	
	      var renderReferredNotifications = function renderReferredNotifications() {
	        if (!(0, _auth.hasSubscriptionPermission)(_this13.props.auth, 30)) return null;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('15356') }),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [4], align: 'center', spacing: 1 },
	            _react2.default.createElement('span', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1052')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('15')
	            )
	          ),
	          refNotif.map(NotificationEventTypeList)
	        );
	      };
	
	      var renderBookingPortalNotifications = function renderBookingPortalNotifications() {
	        if (!(0, _auth.hasSubscriptionPermission)(_this13.props.auth, 30)) return null;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('17957') }),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [4], align: 'center', spacing: 1 },
	            _react2.default.createElement('span', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1052')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('15')
	            )
	          ),
	          bookingPortalNotif.map(NotificationEventTypeList)
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13461'), helpText: (0, _helpers.translation)('1968') },
	        isBodyShopEmployee && _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('15247') }),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [4], align: 'center', spacing: 1 },
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('1052')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('15')
	          )
	        ),
	        orderNotif.map(NotificationEventTypeList),
	        !isBodyShopEmployee && renderReferredNotifications(),
	        !isBodyShopEmployee && renderNotificationsCopy(),
	        isBodyShopEmployee && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('15248') }),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [4], align: 'center', spacing: 1 },
	            _react2.default.createElement('span', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1052')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('15')
	            )
	          ),
	          orderBodyPaintNotif.map(NotificationEventTypeList)
	        ),
	        isBodyShopEmployee && renderReferredNotifications(),
	        isBodyShopEmployee && renderBookingPortalNotifications()
	      );
	    }
	  }, {
	    key: 'renderPermissions',
	    value: function renderPermissions() {
	      var _this14 = this;
	
	      // if (this.state.type === 'create') return null
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0)) return null;
	      var Permissions = this.state.employee.Permissions;
	
	      if (typeof Permissions === 'undefined') {
	        Permissions = [].concat(_toConsumableArray(this.props.auth.permissions.DefaultPermissions));
	      }
	      var newPermission = [];
	      Permissions.map(function (val) {
	        if (typeof newPermission[val.PermissionGroup] === 'undefined') {
	          // console.log(val)
	          newPermission[val.PermissionGroup] = {
	            name: (0, _helpers.translation)((0, _helpers.enumtranslate)('PermissionGroup', val.PermissionGroup)),
	            items: []
	          };
	        }
	        newPermission[val.PermissionGroup].items.push(val);
	      });
	
	      var renderGroup = function renderGroup(group, key) {
	        var onCheckBoxChange = function onCheckBoxChange(e) {
	          var employee = _extends({}, _this14.state.employee);
	          if (typeof employee.Permissions === 'undefined') {
	            employee.Permissions = [].concat(_toConsumableArray(_this14.props.auth.permissions.DefaultPermissions));
	          }
	
	          group.items.map(function (val) {
	            for (var i = 0; i < employee.Permissions.length; i++) {
	              if (employee.Permissions[i].Id === val.Id) {
	                employee.Permissions[i].Checked = e.target.checked;
	              }
	            }
	          });
	          if (employee.UserId === _this14.props.auth.user.UserId) {
	            _this14.props.auth.permissions.EmployeePermissions = employee.Permissions.filter(function (x) {
	              return x.Checked;
	            });
	          }
	          _this14.setState({
	            employee: employee
	          }, function () {
	            if (_this14.state.type === 'edit') {
	              _this14.saveAddEmployee('Permissions');
	            }
	          });
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(_check2.default, { checked: group.items.every(function (x) {
	              return x.Checked;
	            }), onChange: onCheckBoxChange, labelText: group.name }),
	          group.items.map(renderItem),
	          key !== 3 && _react2.default.createElement(_divider2.default, null)
	        );
	      };
	
	      var renderItem = function renderItem(item, key) {
	        // No CarRentalOverview, SparePartsModule on PaintShops
	        if (_this14.props.auth.departmentType !== 1 && [29, 31].includes(item.Id)) return null;
	
	        var onChange = function onChange(e) {
	          var employee = _extends({}, _this14.state.employee);
	          var permissions = [].concat(_toConsumableArray(employee.Permissions));
	          permissions.map(function (val, k) {
	            if (val.Id === item.Id) {
	              permissions[k] = _extends({}, item, {
	                Checked: e.target.checked
	              });
	            }
	          });
	          if (employee.UserId === _this14.props.auth.user.UserId) {
	            _this14.props.auth.permissions.EmployeePermissions = permissions.filter(function (x) {
	              return x.Checked;
	            });
	          }
	          employee.Permissions = permissions;
	          _this14.setState({
	            employee: employee
	          }, function () {
	            if (_this14.state.type === 'edit') {
	              _this14.saveAddEmployee('Permissions');
	            }
	          });
	        };
	        var helpText = '';
	        switch (item.Id) {
	          case 1:
	            helpText = '2175';
	            break;
	          case 2:
	            helpText = '2177';
	            break;
	          case 3:
	            helpText = '2176';
	            break;
	          case 4:
	            helpText = '2181';
	            break;
	          case 5:
	            helpText = '14717';
	            break;
	          case 6:
	            helpText = '2195';
	            break;
	          case 7:
	            helpText = (0, _auth.hasSubscriptionPermission)(_this14.props.auth, 20) ? '2191' : '15272';
	            break;
	          case 8:
	            helpText = '2194';
	            break;
	          case 9:
	            helpText = '2192';
	            break;
	          case 10:
	            helpText = '';
	            break;
	          case 11:
	            helpText = _this14.props.auth.departmentType !== 0 ? '2188' : '15233';
	            if (!(0, _auth.hasSubscriptionPermission)(_this14.props.auth, 20)) helpText = '15270';
	            break;
	          case 12:
	            helpText = '2178';
	            break;
	          case 13:
	            helpText = '2187';
	            break;
	          case 14:
	            helpText = '2186';
	            break;
	          case 15:
	            helpText = '2185';
	            break;
	          case 16:
	            helpText = '';
	            break;
	          case 17:
	            helpText = (0, _auth.hasSubscriptionPermission)(_this14.props.auth, 20) ? '2193' : '15271';
	            break;
	          case 18:
	            helpText = '';
	            break;
	          case 19:
	            helpText = '2189';
	            break;
	          case 20:
	            helpText = '2180';
	            break;
	          case 21:
	            helpText = '2179';
	            break;
	          case 22:
	            helpText = '2184';
	            break;
	          case 23:
	            helpText = '';
	            break;
	          case 24:
	            helpText = '2190';
	            break;
	          case 25:
	            helpText = '2182';
	            break;
	          case 26:
	            helpText = '2183';
	            break;
	          case 27:
	            helpText = '';
	            break;
	          case 28:
	            helpText = '';
	            break;
	          case 29:
	            helpText = '15230';
	            break;
	          case 31:
	            helpText = '16479';
	            break;
	          case 32:
	            helpText = '16843';
	            break;
	          case 33:
	            helpText = '17983';
	            break;
	
	        }
	        return _react2.default.createElement(_check2.default, { checked: item.Checked, onChange: onChange, labelText: (0, _helpers.translation)(item.Name), helpText: (0, _helpers.translation)(helpText), key: key });
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('2149') },
	        newPermission.map(renderGroup)
	      );
	    }
	  }, {
	    key: 'renderMyWorkScreen',
	    value: function renderMyWorkScreen() {
	      var _this15 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      // if (this.state.type === 'create') return null
	      if (this.props.paintShopOrderSteps === undefined || this.props.paintShopOrderSteps === null || this.props.paintShopOrderSteps.length === 0) {
	        return;
	      }
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0)) return null;
	      var employee = this.state.employee;
	      // const paintShopOrderStepsList = (val, key) => {
	      //   let id = 'PaintShopStep' + key
	      //   let name = 'Step' + (key + 1)
	      //   let workscreen = this.state.employee.MyWorkscreen
	      //   if (workscreen === undefined) return
	      //   if (this.props.auth.departmentType === 1 && val !== 164) return null
	      //   return (
	      //     <div className='checkbox__custom' key={key}>
	      //       <input type='checkbox' id={id} value={key} checked={workscreen[name]} name={name} onChange={this.onCheck} />
	      //       <label htmlFor={id} className='inputCheck' />
	      //       <label>{translation(val)}</label>
	      //     </div>
	      //   )
	      // }
	      // const bodyShopOrderStepsList = (val, key) => {
	      //   let keyIndex = (key + 1) + 100
	      //   let name = 'Step' + keyIndex
	      //   let workscreen = this.state.employee.MyWorkscreen
	      //   if (workscreen === undefined) return
	      //   console.log('bodystep', val, key)
	      //   return (
	      //     <div className='checkbox__custom' key={keyIndex}>
	      //       <input type='checkbox' id={keyIndex} value={keyIndex} checked={workscreen[name]} name={name} onChange={this.onCheck} />
	      //       <label htmlFor={keyIndex} className='inputCheck' />
	      //       <label>{translation(val)}</label>
	      //     </div>
	      //   )
	      // }
	      var paintShopOrderSteps = [];
	      // var bodyShopOrderSteps = []
	      // console.log('paintshop order steps', this.props.paintShopOrderSteps)
	      for (var step in this.props.paintShopOrderSteps) {
	        if (parseInt(step) === 0 || parseInt(step) === 8) {
	          continue;
	        }
	        var stepItem = this.props.paintShopOrderSteps[step];
	        paintShopOrderSteps.push(stepItem);
	        // if (step < 100) {
	        //   paintShopOrderSteps.push(this.props.paintShopOrderSteps[step])
	        // } else {
	        //   bodyShopOrderSteps.push(this.props.paintShopOrderSteps[step])
	        // }
	      }
	      var renderOrderSteps = function renderOrderSteps() {
	        // Checkboxes der er synlige i forhold til integrationsskærmen.
	        if (_this15.props.auth.departmentType === 2) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            renderOrderStep((0, _helpers.translation)(164), 1),
	            renderOrderStep((0, _helpers.translation)(617), 101),
	            renderOrderStep((0, _helpers.translation)(618), 102),
	            renderOrderStep((0, _helpers.translation)(619), 103),
	            renderOrderStep((0, _helpers.translation)(162) + ' (' + (0, _helpers.translation)(14779) + ')', 104),
	            renderOrderStep((0, _helpers.translation)(163), 7),
	            _react2.default.createElement('hr', null),
	            renderOrderStep((0, _helpers.translation)(96), 2),
	            renderOrderStep((0, _helpers.translation)(160), 3),
	            renderOrderStep((0, _helpers.translation)(158), 4),
	            renderOrderStep((0, _helpers.translation)(161), 5),
	            renderOrderStep((0, _helpers.translation)(162) + ' (' + (0, _helpers.translation)(161) + ')', 6)
	          );
	
	          /*
	          Old Return
	             return (
	            <div className='checklist'>
	              {renderOrderStep(translation(164), 0)}
	              {renderOrderStep(translation(617), 7)}
	              {renderOrderStep(translation(618), 8)}
	              {renderOrderStep(translation(619), 9)}
	              {renderOrderStep(translation(162) + ' (' + translation(14779) + ')', 10)}
	              {renderOrderStep(translation(163), 6)}
	              <hr />
	              {renderOrderStep(translation(96), 1)}
	              {renderOrderStep(translation(160), 2)}
	              {renderOrderStep(translation(158), 3)}
	              {renderOrderStep(translation(161), 4)}
	              {renderOrderStep(translation(162) + ' (' + translation(161) + ')', 5)}
	            </div>
	          )
	          */
	        }
	        // Checkboxes der er synlige i forhold til karosseriskærmen.
	        if (_this15.props.auth.departmentType === 1) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            renderOrderStep((0, _helpers.translation)(164), 1),
	            renderOrderStep((0, _helpers.translation)(617), 101),
	            renderOrderStep((0, _helpers.translation)(618), 102),
	            renderOrderStep((0, _helpers.translation)(619), 103),
	            renderOrderStep((0, _helpers.translation)(162), 104),
	            renderOrderStep((0, _helpers.translation)(163), 7)
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          renderOrderStep((0, _helpers.translation)(164), 1),
	          renderOrderStep((0, _helpers.translation)(96), 2),
	          renderOrderStep((0, _helpers.translation)(160), 3),
	          renderOrderStep((0, _helpers.translation)(158), 4),
	          renderOrderStep((0, _helpers.translation)(161), 5),
	          renderOrderStep((0, _helpers.translation)(162), 6),
	          renderOrderStep((0, _helpers.translation)(163), 7)
	        );
	      };
	      var renderOrderStep = function renderOrderStep(text, key) {
	        // let keyIndex = (key + 1) + 100
	        var keyIndex = key;
	        var name = 'Step' + keyIndex;
	        var workscreen = _this15.state.employee.MyWorkscreen;
	        if (workscreen === undefined) return;
	        return _react2.default.createElement(_check2.default, { id: name, value: keyIndex, checked: workscreen[name], name: name, onChange: _this15.onCheck, labelText: text, key: keyIndex });
	      };
	      // {paintShopOrderSteps.map(paintShopOrderStepsList)}
	      // <hr />
	      // {bodyShopOrderSteps.map(bodyShopOrderStepsList)}
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1857'), helpText: (0, _helpers.translation)('1974') },
	        renderOrderSteps(),
	        _react2.default.createElement(_switch2.default, { name: 'WorkScreen_Active', checked: employee.MyWorkscreen.Active, onChange: this.onRadioChange, labelText: (0, _helpers.translation)('295') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
	      var showNotifications = (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20);
	
	      var oneCol = 1008; // px
	      var twoCols = 1328; // px
	      var threeCols = 1648; // px
	      var width = this.state.dimensions.width;
	
	      if (width > oneCol && width <= twoCols) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderUser(),
	            this.renderSettings(),
	            showNotifications && this.renderNotifications()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderHours(),
	            this.renderPermissions(),
	            this.renderMyWorkScreen()
	          )
	        );
	      } else if (width > twoCols && width <= threeCols) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderUser(),
	            this.renderSettings()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderHours(),
	            showNotifications && this.renderNotifications()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderPermissions(),
	            this.renderMyWorkScreen()
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderUser(),
	            this.renderSettings()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderHours()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderPermissions()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            showNotifications && this.renderNotifications(),
	            this.renderMyWorkScreen()
	          )
	        );
	      }
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes,
	    employeeTypes: state.common.enums_new.EmployeeTypes,
	    notificationEventType: state.common.enums_new.NotificationEventType,
	    paintShopOrderSteps: state.common.enums_new.PaintShopOrderSteps,
	    companyDepartments: state.common.enums_new.CompanyDepartments
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getEmployee: _employees.getEmployee,
	  CreateSaveEmployee: _employees.CreateSaveEmployee,
	  setLanguage: _actions.setLanguage,
	  getLanguageInfos: _actions.getLanguageInfos
	}, null, { withRef: true })(View);

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _employees = __webpack_require__(128);
	
	__webpack_require__(1392);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _CreateUser = __webpack_require__(197);
	
	var _CreateUser2 = _interopRequireDefault(_CreateUser);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _View = __webpack_require__(853);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Employees = function (_Component) {
	  _inherits(Employees, _Component);
	
	  function Employees(props) {
	    _classCallCheck(this, Employees);
	
	    var _this = _possibleConstructorReturn(this, (Employees.__proto__ || Object.getPrototypeOf(Employees)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      includeNonVerified: false,
	      employees: [],
	      activeItem: {}
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Employees, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getEmployees();
	    }
	  }, {
	    key: 'getEmployees',
	    value: function getEmployees() {
	      var _this2 = this;
	
	      this.props.getEmployees(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          employees: res.data
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create' || !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0)) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('2045'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.create.getWrappedInstance().createUser();
	        };
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return [_react2.default.createElement(
	        'div',
	        { key: 'confirmedfilter', className: 'filter' },
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { isFixed: true },
	          _react2.default.createElement(_check2.default, {
	            name: 'NonVerified',
	            checked: this.state.includeNonVerified,
	            onChange: function onChange() {
	              _this3.setState({ includeNonVerified: !_this3.state.includeNonVerified });
	            },
	            labelText: (0, _helpers.translation)('16320'),
	            spacing: 0
	          })
	        )
	      )].concat(_toConsumableArray(this.state.employees.map(function (e) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: e.Name,
	          onClick: function onClick() {
	            return _this3.onSelectItem(e);
	          },
	          selected: e.UserId === _this3.state.activeItem.UserId,
	          inactive: !e.Active,
	          confirmed: e.Confirmed,
	          key: e.UserId
	        });
	      })));
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var _this4 = this;
	
	      var employees = [].concat(_toConsumableArray(this.state.employees));
	      var activeItem = void 0;
	      if (type === 'create') {
	        employees.push({
	          UserId: data.UserId,
	          Name: data.Name,
	          Active: data.Active,
	          Email: data.Email
	        });
	        type = 'item';
	        activeItem = {
	          UserId: data.UserId
	        };
	      } else {
	        employees.map(function (val, key) {
	          if (val.UserId === data.UserId) {
	            val.Name = data.Name;
	            val.Active = data.Active;
	            val.Email = data.Email;
	            val.Confirmed = data.Confirmed;
	          }
	        });
	        type = 'item';
	        if (data.Confirmed) {
	          activeItem = {
	            UserId: data.UserId,
	            Confirmed: true
	          };
	        } else {
	          activeItem = {
	            UserId: data.UserId,
	            Email: data.Email,
	            Name: data.Name,
	            Confirmed: data.Confirmed
	          };
	        }
	      }
	      this.setState({
	        employees: employees,
	        view: type,
	        activeItem: activeItem
	      });
	
	      // Update employees in application state
	      this.props.getEmployees(this.props.auth.user.ShopId).then(function (res) {
	        _this4.setState({
	          employees: res.data
	        });
	      });
	
	      // Toastr
	      // window.toastr.success(translation('1882'), translation('13424'))
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this5 = this;
	
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	          return _react2.default.createElement(_CreateUser2.default, { isEmployee: true, ref: 'create', title: (0, _helpers.translation)('16318'), user: undefined, onSuccess: function onSuccess(res) {
	              return _this5.onSave(res, 'create');
	            } });
	        case 'item':
	          {
	            if (this.state.activeItem.Confirmed !== true) return _react2.default.createElement(_CreateUser2.default, { isEmployee: true, user: this.state.activeItem, title: (0, _helpers.translation)('16318'), onSuccess: function onSuccess(res) {
	                return _this5.onSave(res, 'item');
	              } });
	
	            return _react2.default.createElement(_View2.default, { ref: 'view', item: this.state.activeItem, onSave: this.onSave });
	          }
	      }
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var customFilter = function customFilter(item, showInactive) {
	        // Include any items not confirmed if using this filter
	        if (_this6.state.includeNonVerified && !item.confirmed) {
	          return true;
	        }
	        if (showInactive) {
	          // Exclude unconfirmed
	          return item.confirmed;
	        }
	        return !item.inactive;
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'employees__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: function renderRight() {
	            return _this6.headerButtonsRight();
	          } }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create', customFilter: customFilter },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'employees__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Employees;
	}(_react.Component);
	
	Employees.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getEmployees: _employees.getEmployees, CreateSaveEmployee: _employees.CreateSaveEmployee, hasSubscriptionPermission: _auth.hasSubscriptionPermission })(Employees);

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	__webpack_require__(1393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	var Column = function (_Component) {
	  _inherits(Column, _Component);
	
	  function Column(props) {
	    _classCallCheck(this, Column);
	
	    var _this = _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).call(this, props));
	
	    _this.renderTitle = _this.renderTitle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Column, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'column' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column_content scrollbar' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column_content_inner' },
	            !this.props.noTitle && this.renderTitle(),
	            this.props.children
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true },
	          this.props.icon !== undefined && _react2.default.createElement(_icon2.default, { icon: this.props.icon }),
	          this.props.title !== undefined && _react2.default.createElement(
	            'h3',
	            null,
	            this.props.title
	          ),
	          this.props.renderRight !== null ? this.props.renderRight : null
	        ),
	        _react2.default.createElement(_divider2.default, null)
	      );
	    }
	  }]);
	
	  return Column;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Column);

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _currency = __webpack_require__(41);
	
	var _icons = __webpack_require__(6);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(1394);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	// import { Link } from 'react-router'
	
	// Elements
	
	
	// Styles
	
	
	// Utils
	
	
	var ExtentLine = function (_Component) {
	  _inherits(ExtentLine, _Component);
	
	  function ExtentLine(props) {
	    _classCallCheck(this, ExtentLine);
	
	    var _this = _possibleConstructorReturn(this, (ExtentLine.__proto__ || Object.getPrototypeOf(ExtentLine)).call(this, props));
	
	    _this.renderEstimationTaskLine = _this.renderEstimationTaskLine.bind(_this);
	    _this.renderTaskPriceLine = _this.renderTaskPriceLine.bind(_this);
	    _this.renderSubItems = _this.renderSubItems.bind(_this);
	    _this.renderForsiItem = _this.renderForsiItem.bind(_this);
	    _this.renderForsiSubItems = _this.renderForsiSubItems.bind(_this);
	    _this.renderEstimationExtraLine = _this.renderEstimationExtraLine.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExtentLine, [{
	    key: 'renderEstimationTaskLine',
	    value: function renderEstimationTaskLine(item) {
	      var extraCSS = '';
	      if (item.WasRemoved === true) {
	        extraCSS = 'removed';
	      }
	
	      if (item.WasAdded === true) {
	        extraCSS = 'added';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        _react2.default.createElement(
	          'div',
	          { className: extraCSS },
	          item.TaskName,
	          ' ',
	          item.Extent !== null ? item.Extent : ''
	        )
	      );
	    }
	  }, {
	    key: 'renderEstimationExtraLine',
	    value: function renderEstimationExtraLine(item, parent) {
	      var extraCSS = '';
	      var workcardExtraCss = '';
	      var invoiceExtraCss = '';
	
	      if (this.props.invoiceDisabled) invoiceExtraCss = ' fadeOut';
	      if (this.props.workcardDisabled) workcardExtraCss = ' fadeOut';
	
	      var checks = _react2.default.createElement(
	        'div',
	        { className: 'checks' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hint--top-right' + invoiceExtraCss, 'aria-label': (0, _helpers.translation)('14998') },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true },
	            _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Total_Price }),
	            _react2.default.createElement(_check2.default, { simple: true, checked: item.SelectedInvoice || this.props.invoiceDisabled, onChange: this.props.onInvoiceClick.bind(this, item), disabled: this.props.invoiceDisabled })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hint--bottom-right' + workcardExtraCss, 'aria-label': (0, _helpers.translation)('14997') },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true },
	            _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Workcard }),
	            _react2.default.createElement(_check2.default, { simple: true, checked: item.SelectedWorkCard || this.props.workcardDisabled, onChange: this.props.onWorkCardClick.bind(this, item), disabled: this.props.workcardDisabled })
	          )
	        )
	      );
	
	      var added = parent.OrderEstimationTaskId !== null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'estimationExtra', key: 'estimationExtra_' + item.OrderEstimationExtraId },
	        item.Selectable && checks,
	        _react2.default.createElement(
	          'div',
	          { key: 'subItem_' + item.OrderEstimationExtraId, className: 'estimationExtra-child' },
	          _react2.default.createElement(
	            'div',
	            { className: 'extraContent' + (added ? ' added' : '') },
	            _react2.default.createElement(
	              'div',
	              { className: extraCSS },
	              item.Name,
	              ' '
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: extraCSS },
	              '(',
	              (0, _helpers.translation)('13345'),
	              ': ',
	              item.AE,
	              ' ; ',
	              (0, _helpers.translation)('13443'),
	              ': ',
	              (0, _currency.formatCurrency)(item.Material),
	              ' ',
	              this.props.currencyCode,
	              ')'
	            )
	          ),
	          item.Gross !== null && _react2.default.createElement(
	            'div',
	            { className: 'smallRight' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _currency.formatCurrency)(item.Gross),
	              ' ',
	              this.props.currencyCode
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTaskPriceLine',
	    value: function renderTaskPriceLine(item) {
	      var showNet = this.props.showNet === true;
	      var price = showNet ? item.Net : item.Gross;
	      price = (0, _currency.formatCurrency)(price);
	
	      var extraCSS = '';
	      if (item.WasRemoved === true) {
	        extraCSS = 'removed';
	      }
	
	      if (item.WasAdded === true) {
	        extraCSS = 'added';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: extraCSS },
	          item.TaskName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'priceRight ' + extraCSS },
	          price,
	          ' ',
	          this.props.currencyCode
	        )
	      );
	    }
	  }, {
	    key: 'renderSubItems',
	    value: function renderSubItems(item) {
	      var _this2 = this;
	
	      var isEstimation = item.EstimationTaskId !== null;
	      var isTaskPrice = item.TaskPriceId !== null;
	
	      var extraCSS = '';
	      if (item.WasRemoved === true) {
	        extraCSS = 'removed';
	      }
	
	      if (item.WasAdded === true) {
	        extraCSS = 'added';
	      }
	
	      var renderSubItem = function renderSubItem(subItem, index) {
	        if (isEstimation) {
	          if (_this2.props.showPrice === true) {
	            return _react2.default.createElement(
	              'div',
	              { key: 'subItem_' + index },
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                  'div',
	                  { className: extraCSS },
	                  subItem.Name,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: extraCSS },
	                  '(',
	                  (0, _helpers.translation)('13345'),
	                  ': ',
	                  subItem.AE,
	                  ' ; ',
	                  (0, _helpers.translation)('13443'),
	                  ': ',
	                  (0, _currency.formatCurrency)(subItem.Material),
	                  ' ',
	                  _this2.props.currencyCode,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'smallRight' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _currency.formatCurrency)(subItem.Gross),
	                  ' ',
	                  _this2.props.currencyCode
	                )
	              )
	            );
	          } else {
	            return _react2.default.createElement(
	              'div',
	              { key: 'subItem_' + index },
	              _react2.default.createElement(
	                'div',
	                { className: extraCSS },
	                subItem.Name,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: extraCSS },
	                '(',
	                (0, _helpers.translation)('13345'),
	                ': ',
	                subItem.AE,
	                ' ; ',
	                (0, _helpers.translation)('13443'),
	                ': ',
	                (0, _currency.formatCurrency)(subItem.Material),
	                ' ',
	                _this2.props.currencyCode,
	                ')'
	              )
	            );
	          }
	        }
	        if (isTaskPrice) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            '\xA0'
	          );
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'subItem-parent' },
	        item.SubItems.map(renderSubItem)
	      );
	    }
	  }, {
	    key: 'renderForsiItem',
	    value: function renderForsiItem(item) {
	      var icon = null;
	      if (item.Selectable === false) {
	        icon = _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Indent, size: 't' });
	      }
	      if (item.OrderEstimationTaskId !== null) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'forsiItemLeft removed' },
	            icon,
	            item.ReportLineAdditionalText
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'forsiWorkUnitRight removed' },
	            item.WorkUnits,
	            ' ',
	            (0, _helpers.translation)('13345')
	          ),
	          _react2.default.createElement('div', { className: 'clearFix' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'forsiItemLeft added' },
	            icon,
	            item.TaskName,
	            ' ',
	            item.Extent ? item.Extent : ''
	          ),
	          _react2.default.createElement('span', { className: 'forsiWorkUnitRight added' }),
	          _react2.default.createElement('div', { className: 'clearFix' })
	        );
	      } else {
	        var extraCss = '';
	        if (this.props.entry && this.props.entry.Type === 4) {
	          extraCss = ' afterevalitem';
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'forsiItemLeft' + extraCss },
	            icon,
	            item.ReportLineAdditionalText,
	            ' ',
	            item.Extent ? item.Extent : ''
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'forsiWorkUnitRight' },
	            item.WorkUnits,
	            ' ',
	            (0, _helpers.translation)('13345')
	          ),
	          _react2.default.createElement('div', { className: 'clearFix' }),
	          item.SubItems && this.renderForsiSubItems(item)
	        );
	      }
	    }
	  }, {
	    key: 'renderForsiSubItems',
	    value: function renderForsiSubItems(item) {
	      var _this3 = this;
	
	      var isEstimation = item.EstimationTaskId !== null;
	      var isTaskPrice = item.TaskPriceId !== null;
	      var renderSubItems = function renderSubItems(subItem, index) {
	        if (isEstimation) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'subItem', key: 'subItem_' + index },
	            _react2.default.createElement(
	              'div',
	              null,
	              subItem.Name
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              '(',
	              (0, _helpers.translation)('13345'),
	              ': ',
	              subItem.AE,
	              ' ; ',
	              (0, _helpers.translation)('13443'),
	              ': ',
	              (0, _currency.formatCurrency)(subItem.Material),
	              ' ',
	              _this3.props.currencyCode,
	              ')'
	            )
	          );
	        }
	        if (isTaskPrice) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            '\xA0'
	          );
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        item.SubItems.map(renderSubItems)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var item = this.props.item;
	      var isEstimation = item.EstimationTaskId !== undefined && item.EstimationTaskId !== null;
	      var isTaskPrice = item.TaskPriceId !== undefined && item.TaskPriceId !== null;
	      var isReport = item.PaintLineId !== undefined && item.PaintLineId !== null;
	      // let isEstimationExtra = item.EstimationExtraId !== undefined && item.EstimationExtraId !== null
	
	      var extraCSS = '';
	      var icon = null;
	
	      var content = _react2.default.createElement('div', null);
	
	      if (isEstimation) content = this.renderEstimationTaskLine(item);
	      if (isTaskPrice) content = this.renderTaskPriceLine(item);
	      if (isReport) content = this.renderForsiItem(item);
	      // if (isEstimationExtra) content = this.renderEstimationExtraLine(item)
	
	      if (item.Selectable === false) {
	        extraCSS = ' fullWidth';
	      }
	
	      var workcardExtraCss = '';
	      var invoiceExtraCss = '';
	
	      if (this.props.invoiceDisabled) invoiceExtraCss = ' fadeOut';
	      if (this.props.workcardDisabled) workcardExtraCss = ' fadeOut';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'extentLine' },
	        item.Selectable && item.TaskName !== null && _react2.default.createElement(
	          'div',
	          { className: 'checks' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--top-right' + invoiceExtraCss, 'aria-label': (0, _helpers.translation)('14998') },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true },
	              _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Total_Price }),
	              _react2.default.createElement(_check2.default, { simple: true, checked: item.SelectedInvoice || isEstimation && this.props.invoiceDisabled, onChange: this.props.onInvoiceClick.bind(this, item), disabled: this.props.invoiceDisabled })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--bottom-right' + workcardExtraCss, 'aria-label': (0, _helpers.translation)('14997') },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true },
	              _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Workcard }),
	              _react2.default.createElement(_check2.default, { simple: true, checked: item.SelectedWorkCard || isEstimation && this.props.workcardDisabled, onChange: this.props.onWorkCardClick.bind(this, item), disabled: this.props.workcardDisabled })
	            )
	          )
	        ),
	        (item.TaskName !== null || item.ReportLineAdditionalText !== null) && _react2.default.createElement(
	          'div',
	          { className: 'content' + extraCSS },
	          icon,
	          content
	        ),
	        item.SubItems !== null && item.SubItems.map(function (subItem) {
	          return _this4.renderEstimationExtraLine(subItem, item);
	        })
	      );
	    }
	  }]);
	
	  return ExtentLine;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(ExtentLine);

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(1395);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	// import { Link } from 'react-router'
	
	// Elements
	
	
	// Styles
	
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section(props) {
	    _classCallCheck(this, Section);
	
	    var _this = _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).call(this, props));
	
	    _this.renderTitle = _this.renderTitle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Section, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var sectionCss = '';
	      if (this.props.sectionCss !== undefined) {
	        sectionCss = this.props.sectionCss;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section ' + sectionCss },
	        this.props.title !== undefined && this.props.title !== null && this.renderTitle(),
	        this.props.children
	      );
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _inline2.default,
	          { alignChildren: 'center' },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.icon !== undefined ? _react2.default.createElement(_icon2.default, { icon: this.props.icon }) : _react2.default.createElement(
	              'span',
	              { className: 'noIcon' },
	              '\xA0'
	            )
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'title-text' + (this.props.icon !== undefined ? '' : ' noImg') },
	            this.props.title
	          )
	        ),
	        _react2.default.createElement(_divider2.default, null)
	      );
	    }
	  }]);
	
	  return Section;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Section);

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1396);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	// import { Link } from 'react-router'
	
	// Elements
	
	
	// Styles
	
	
	// Utils
	
	
	var SelectableLine = function (_Component) {
	  _inherits(SelectableLine, _Component);
	
	  function SelectableLine(props) {
	    _classCallCheck(this, SelectableLine);
	
	    var _this = _possibleConstructorReturn(this, (SelectableLine.__proto__ || Object.getPrototypeOf(SelectableLine)).call(this, props));
	
	    _this.state = {
	      showEuro: _this.props.showEuro === undefined || _this.props.showEuro
	    };
	    return _this;
	  }
	
	  _createClass(SelectableLine, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      this.props.onChange(event);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showEuro = this.props.showEuro === undefined || this.props.showEuro;
	
	      // let extraCSS = 'SelectableLineStaticHeight'
	      // if (this.props.extraCSS !== undefined) {
	      //   extraCSS = this.props.extraCSS
	      // }
	
	      return _react2.default.createElement(
	        _inline2.default,
	        { fillChildNum: [2], block: true, alignChildren: 'center' },
	        showEuro && _react2.default.createElement(
	          'span',
	          { className: 'hint--bottom-right', 'aria-label': (0, _helpers.translation)('14998') },
	          _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Total_Price })
	        ),
	        _react2.default.createElement(_check2.default, { simple: true, name: this.props.name, onChange: this.onChange.bind(this), checked: this.props.checked }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return SelectableLine;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(SelectableLine);

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _detect = __webpack_require__(102);
	
	var _currency = __webpack_require__(41);
	
	var _order = __webpack_require__(92);
	
	var _common = __webpack_require__(25);
	
	var _time = __webpack_require__(17);
	
	var _icons = __webpack_require__(6);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Column = __webpack_require__(855);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _Section = __webpack_require__(857);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _SelectableLine = __webpack_require__(858);
	
	var _SelectableLine2 = _interopRequireDefault(_SelectableLine);
	
	var _ExtentLine = __webpack_require__(856);
	
	var _ExtentLine2 = _interopRequireDefault(_ExtentLine);
	
	var _HelpText = __webpack_require__(130);
	
	var _HelpText2 = _interopRequireDefault(_HelpText);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Invoice = __webpack_require__(294);
	
	var _Invoice2 = _interopRequireDefault(_Invoice);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _constants = __webpack_require__(5);
	
	var _evaluationhistory = __webpack_require__(794);
	
	var _orders = __webpack_require__(21);
	
	var _backdrop = __webpack_require__(29);
	
	__webpack_require__(1397);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import EventEmitter from '../../utils/events'
	// import moment from 'moment'
	
	// Utils
	
	// import { hasAccess, hasSubscriptionPermission } from '../../utils/auth'
	
	
	// import components
	
	// import GreenCheck from '../../shared/components/GreenCheck'
	
	
	// Elements
	
	
	// Constants
	
	
	// Actions
	
	
	var EvaluationHistory = function (_Component) {
	  _inherits(EvaluationHistory, _Component);
	
	  function EvaluationHistory(props) {
	    _classCallCheck(this, EvaluationHistory);
	
	    var _this = _possibleConstructorReturn(this, (EvaluationHistory.__proto__ || Object.getPrototypeOf(EvaluationHistory)).call(this, props));
	
	    _this.md = new window.MobileDetect(window.navigator.userAgent);
	    _this.loadHistory = _this.loadHistory.bind(_this);
	    _this.loadOrder = _this.loadOrder.bind(_this);
	    _this.updateHistory = _this.updateHistory.bind(_this);
	    _this.renderColumns = _this.renderColumns.bind(_this);
	    _this.renderInvoiceExtra = _this.renderInvoiceExtra.bind(_this);
	    _this.renderAddonSaleColumn = _this.renderAddonEntry.bind(_this);
	    _this.renderEvaluationEntry = _this.renderEvaluationEntry.bind(_this);
	    _this.renderCreationInfoSection = _this.renderCreationInfoSection.bind(_this);
	    _this.renderItemSection = _this.renderItemSection.bind(_this);
	    _this.renderAddonSection = _this.renderAddonSection.bind(_this);
	    _this.prepareForRender = _this.prepareForRender.bind(_this);
	    _this.getOrCreatePart = _this.getOrCreatePart.bind(_this);
	    _this.getEvaluationTitle = _this.getEvaluationTitle.bind(_this);
	    _this.getEvaluationIcon = _this.getEvaluationIcon.bind(_this);
	    _this.getTaskSideName = _this.getTaskSideName.bind(_this);
	    _this.SortMe = _this.SortMe.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.renderReportCalc = _this.renderReportCalc.bind(_this);
	    _this.renderReportTotals = _this.renderReportTotals.bind(_this);
	    _this.renderExternalItems = _this.renderExternalItems.bind(_this);
	    _this.renderExternalSubCustomItems = _this.renderExternalSubCustomItems.bind(_this);
	    _this.renderExternalSubItems = _this.renderExternalSubItems.bind(_this);
	    _this.renderFileContainer = _this.renderFileContainer.bind(_this);
	    _this.scroller = null;
	
	    _this.state = {
	      sorting: 0,
	      history: null,
	      swap: false
	    };
	    return _this;
	  }
	
	  _createClass(EvaluationHistory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadHistory();
	      this.loadOrder();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.scroller !== null) {
	        this.scroller.destroy();
	      }
	    }
	  }, {
	    key: 'loadOrder',
	    value: function loadOrder() {
	      var _this2 = this;
	
	      var orderId = this.props.params.orderId;
	      this.props.getOrder(orderId).then(function (res) {
	        _this2.props.setPageTitle((0, _order.makeOrderPageTitleObject)(res.data));
	      });
	    }
	  }, {
	    key: 'loadHistory',
	    value: function loadHistory() {
	      var _this3 = this;
	
	      this.props.triggerPopupActionBG(true);
	      var orderId = this.props.params.orderId;
	
	      if (orderId !== ':orderId') {
	        // Get from api
	        this.props.getEvaluationHistory(orderId).then(function (res) {
	          _this3.setState({
	            history: res.data
	          });
	          _this3.props.triggerPopupActionBG(false);
	          /* this.initHammer() */
	        }, function (e) {
	          console.log('Error: ', e);
	          _this3.props.triggerPopupActionBG(false);
	          // this.props.router.goBack()
	        });
	      }
	    }
	  }, {
	    key: 'updateHistory',
	    value: function updateHistory(changes) {
	      var _this4 = this;
	
	      // Post to api
	      this.props.updateEvaluationHistory(changes).then(function (res) {
	        var history = _this4.state.history;
	
	        // Order data
	        if (res.data.OrderTypeSelected !== null) history.OrderTypeSelected = res.data.OrderTypeSelected;
	        if (res.data.PickupDateSelected !== null) history.PickupDateSelected = res.data.PickupDateSelected;
	        if (res.data.DeliveredDateSelected !== null) history.DeliveredDateSelected = res.data.DeliveredDateSelected;
	        if (res.data.LtwIdCodeSelected !== null) history.LtwIdCodeSelected = res.data.LtwIdCodeSelected;
	        if (res.data.ChassisNumberSelected !== null) history.ChassisNumberSelected = res.data.ChassisNumberSelected;
	
	        // Notes
	        if (history.Notes !== null && res.data.Notes !== null) {
	          var _loop = function _loop(i) {
	            var noteIndex = history.Notes.findIndex(function (item) {
	              return item.NoteId === res.data.Notes[i].NoteId;
	            });
	            if (noteIndex >= 0) {
	              history.Notes[noteIndex] = res.data.Notes[i];
	            }
	          };
	
	          for (var i = 0; i < res.data.Notes.length; i++) {
	            _loop(i);
	          }
	        }
	
	        if (history.History !== null && res.data.History !== null) {
	          var _loop2 = function _loop2(i) {
	            var historyIndex = history.History.findIndex(function (entry) {
	              return entry.OrderPriceId === res.data.History[i].OrderPriceId && entry.ReportId === res.data.History[i].ReportId && entry.State === res.data.History[i].State;
	            });
	            if (historyIndex >= 0) {
	              history.History[historyIndex] = res.data.History[i];
	            }
	          };
	
	          for (var i = 0; i < res.data.History.length; i++) {
	            _loop2(i);
	          }
	        }
	
	        _this4.setState({
	          history: history
	        });
	      });
	    }
	  }, {
	    key: 'debindAll',
	    value: function debindAll() {
	      if (this.scroller !== null) {
	        this.scroller.destroy();
	      }
	      var hammerTime = new window.Hammer(window.board, {
	        inputClass: window.Hammer.TouchInput
	      });
	      hammerTime.off('swipeleft');
	      hammerTime.off('swiperight');
	    }
	  }, {
	    key: 'allowHammer',
	    value: function allowHammer() {
	      var allowSize = window.innerWidth < 1360;
	      var androidTablet = this.md.os() === 'AndroidOS' && this.md.tablet();
	      if ((0, _detect.isTouchDevice)() && !androidTablet && allowSize) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'panHandler',
	    value: function panHandler(event) {
	      if (event.type === 'panend' || event.type === 'pancancel') {
	        // iOS bug fix
	        this.lock = false;
	        this.delta = 0;
	        this.lastDirection = null;
	        this.lastDelta = 0;
	        this.deltaX = 0;
	      } else if ((event.type === 'swipe' || event.type === 'panmove') && event.direction & window.Hammer.DIRECTION_VERTICAL) {
	        this.lock = true;
	      } else if (event.type === 'swipe' && event.direction & window.Hammer.DIRECTION_HORIZONTAL) {
	        // iOS bug fix
	        this.lock = true;
	      } else if (event.type === 'panmove' && event.direction & window.Hammer.DIRECTION_HORIZONTAL) {
	        if (this.lastDirection === null) {
	          this.lastDirection = event.direction;
	        }
	        this.deltaX = event.deltaX;
	        if (window.board.scrollLeft >= window.board.width) window.board.scrollLeft = window.board.width;
	        if (window.board.scrollLeft < 0) window.board.scrollLeft = 0;
	        if (this.lock === true || !this.canScroll || window.board.scrollLeft > window.board.width || window.board.scrollLeft < 0 || this.deltaX === this.lastDelta && window.board.scrollLeft > 0) return;
	        if (this.lastDirection !== event.direction) {
	          this.delta = this.deltaX - this.lastDelta;
	          window.board.scrollLeft -= this.delta;
	        } else {
	          this.delta = this.lastDelta - this.deltaX;
	          window.board.scrollLeft += this.delta;
	        }
	        this.lastDirection = event.direction;
	        this.lastDelta = this.deltaX;
	      }
	    }
	  }, {
	    key: 'initHammer',
	    value: function initHammer() {
	      var _this5 = this;
	
	      // if (this.md.userAgent() === 'Safari' || this.md.phone()) {
	      if (this.allowHammer()) {
	        var getPos = function getPos() {
	          if (typeof window.board.dataset.pos === 'undefined') {
	            return 1;
	          }
	          return parseInt(window.board.dataset.pos);
	        };
	
	        var hammerTime = new window.Hammer(window.board, {
	          inputClass: window.Hammer.TouchInput
	        });
	        if (window.innerHeight < 600 || window.innerWidth < 600) {
	          var ColumnAmount = this.state.history.History.length + 1;
	
	          hammerTime.on('swipeleft', function (ev) {
	            var newPos = getPos() !== ColumnAmount ? getPos() + 1 : getPos();
	            _this5.changePage(newPos);
	          });
	          hammerTime.on('swiperight', function (ev) {
	            var newPos = getPos() > 1 ? getPos() - 1 : getPos();
	            _this5.changePage(newPos);
	          });
	        } else {
	          hammerTime.add(new window.Hammer.Pan({ direction: window.Hammer.DIRECTION_HORIZONTAL, threshold: 10 }));
	          hammerTime.on('panstart panmove panend pancancel swipe', this.panHandler);
	        }
	      }
	    }
	  }, {
	    key: 'changePage',
	    value: function changePage(pos) {
	      window.board.dataset.pos = pos;
	      pos = parseInt(pos) - 1;
	      var parent = this.refs['dragparent' + pos];
	
	      window.board.scrollLeft = parent.offsetLeft - 5;
	    }
	  }, {
	    key: 'getOrCreatePart',
	    value: function getOrCreatePart(targetArray, partId, partName, taskSide) {
	      if (targetArray === null) targetArray = [];
	      var i = targetArray.findIndex(function (item) {
	        return item.PartId === partId && item.PartName === partName && item.TaskSide === taskSide;
	      });
	      if (i === -1) {
	        var part = {
	          PartId: partId,
	          PartName: partName,
	          TaskSide: taskSide,
	          Items: []
	        };
	        targetArray.push(part);
	        return part;
	      }
	      return targetArray[i];
	    }
	  }, {
	    key: 'prepareForRender',
	    value: function prepareForRender(entries) {
	      if (entries === null) return null;
	      var sortedEntries = entries.sort(function (a, b) {
	        if (a === null && b !== null) return -1;
	        if (a !== null && b === null) return 1;
	        if (a === null && b === null) return 0;
	        return a.CreatedDate.localeCompare(b.CreatedDate);
	      });
	      return sortedEntries;
	    }
	  }, {
	    key: 'getEvaluationTitle',
	    value: function getEvaluationTitle(entry) {
	      var title = 'None';
	      switch (entry.Type) {
	        case 1:
	          if (this.state.history.OrderType !== 1) {
	            // title = translation('889')   // Omfang
	            title = (0, _helpers.translation)('14983'); // Omfang oprettet
	            switch (entry.State) {
	              case 1:
	                // awaiting
	                title = (0, _helpers.translation)('2716'); // Prisændring afsendt
	                break;
	              case 2:
	                // approved/ok
	                title = (0, _helpers.translation)('2714'); // Prisændring godkendt
	                break;
	              case 3:
	                // rejected
	                title = (0, _helpers.translation)('2715'); // Prisændring afvist
	                break;
	            }
	          } else {
	            title = (0, _helpers.translation)('14716'); // Manuelt
	          }
	          break;
	        case 2:
	          title = (0, _helpers.translation)('1396'); // Mersalg
	          break;
	        case 3:
	          title = (0, _helpers.translation)('13363'); // Takseringssupport
	          break;
	        case 4:
	          title = (0, _helpers.translation)('1037'); // Eftertaksering
	          break;
	        case 5:
	          title = (0, _helpers.translation)('936'); // Hovedrapport
	          break;
	        case 6:
	          title = (0, _helpers.translation)('937'); // Tillægsrapport
	          break;
	        case 7:
	          title = (0, _helpers.translation)('15376'); // RPrapport
	          break;
	      }
	      return title;
	    }
	  }, {
	    key: 'getEvaluationIcon',
	    value: function getEvaluationIcon(entry) {
	      var icon = '';
	
	      switch (entry.Type) {
	        case 1:
	          // icon = '/images/svgs/taksering/manually.svg'
	          icon = _icons.OrderAssessmentIcons.Extent;
	          if (entry.State !== undefined) {
	            switch (entry.State) {
	              case 1:
	                // awaiting
	                icon = _icons.OrderAssessmentIcons.Invoice_Awaiting;
	                break;
	              case 2: // approved/ok
	              case 3:
	                // rejected
	                icon = _icons.OrderAssessmentIcons.Invoice_Approved_Rejected;
	                break;
	            }
	          }
	          break;
	        case 2:
	          icon = _icons.OrderAssessmentIcons.Addon_Price;
	          break;
	        case 3:
	          icon = _icons.OrderAssessmentIcons.Estimation_Request;
	          if (entry.State !== undefined) {
	            switch (entry.State) {
	              case 1:
	                icon = _icons.OrderAssessmentIcons.Estimation;
	                break;
	              case 2:
	                icon = _icons.OrderAssessmentIcons.Estimation_Complete;
	                break;
	            }
	          }
	          break;
	        case 4:
	          icon = _icons.OrderAssessmentIcons.After_Evaluation;
	          break;
	        case 5:
	          icon = _icons.OrderAssessmentIcons.Main_Report;
	          break;
	        case 6:
	          icon = _icons.OrderAssessmentIcons.Additional_Report;
	          break;
	      }
	      return icon;
	    }
	  }, {
	    key: 'getTaskSideName',
	    value: function getTaskSideName(taskSide) {
	      switch (taskSide) {
	        case 0:
	          return '';
	        case 1:
	          return (0, _helpers.translation)('213'); // venstre
	        case 2:
	          return (0, _helpers.translation)('214'); // højre
	        case 3:
	          return (0, _helpers.translation)('287'); // for
	        case 4:
	          return (0, _helpers.translation)('288'); // bag
	        case 5:
	          return (0, _helpers.translation)('213') + ' ' + (0, _helpers.translation)('287'); // venstre for
	        case 6:
	          return (0, _helpers.translation)('214') + ' ' + (0, _helpers.translation)('287'); // højre for
	        case 7:
	          return (0, _helpers.translation)('213') + ' ' + (0, _helpers.translation)('288'); // venstre bag
	        case 8:
	          return (0, _helpers.translation)('214') + ' ' + (0, _helpers.translation)('288'); // højre bag
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	
	      if (this.state.swap === true) {
	        this.setState({
	          swap: false
	        });
	      } else {
	        this.setState({
	          swap: true
	        });
	      }
	    }
	  }, {
	    key: 'SortMe',
	    value: function SortMe() {
	      return _react2.default.createElement(
	        'div',
	        { onClick: this.handleClick, className: 'hint--left', 'aria-label': this.state.swap ? (0, _helpers.translation)('14996') : (0, _helpers.translation)('14995') },
	        _react2.default.createElement('img', { src: '/images/svgs/sort_chronologically.svg', className: 'sortOrder' + (this.state.swap ? ' rotate' : '') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      if (this.props.auth.departmentType === 1) return null; // Deny bodyshop access
	      var renderHeaderGoBack = function renderHeaderGoBack(router, t) {
	        var goBack = function goBack() {
	          _this6.props.router.goBack();
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('div', { className: 'alignHelper' }),
	          _react2.default.createElement(_closeButton2.default, { onClick: goBack, ariaText: (0, _helpers.translation)('2060') })
	        );
	      };
	      // <Header icon={'assesment-history-white.svg'} title={title} renderRight={this.SortMe.bind(this)} showBack headerButtonsGoBack={renderHeaderGoBack} />
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'evaluationhistory__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: this.SortMe.bind(this), showBack: true, headerButtonsGoBack: renderHeaderGoBack }),
	        this.state.history !== null && this.state.history.IsOldOrder === true && _react2.default.createElement(
	          'div',
	          { className: 'oldOrderHeader' },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('15092')
	          )
	        ),
	        this.renderColumns()
	      );
	    }
	  }, {
	    key: 'renderColumns',
	    value: function renderColumns() {
	      var _this7 = this;
	
	      if (this.state.history === null) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'board' },
	          '\xA0'
	        );
	      }
	      var boardClass = 'scrollbar';
	      if (this.state.history !== null && this.state.history.IsOldOrder === true) {
	        boardClass += ' extendedHeader ';
	      }
	      var history = this.state.history;
	      var entries = this.prepareForRender(history.History);
	
	      // Find index of addon orderprice
	      var addonIndex = -1;
	      if (history.History !== null) {
	        addonIndex = history.History.findIndex(function (entry) {
	          return entry.Type === 2;
	        });
	      }
	      var evaluationSteps = null;
	      if (entries !== null) {
	        evaluationSteps = entries.filter(function (entry, index) {
	          return index !== addonIndex;
	        }).sort(function (a, b) {
	          if (_this7.state.swap) {
	            return -a.CreatedDate.localeCompare(b.CreatedDate);
	          } else {
	            return a.CreatedDate.localeCompare(b.CreatedDate);
	          }
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { id: 'board', className: boardClass, ref: 'board' },
	        this.renderInvoiceExtra(),
	        entries !== null && addonIndex > -1 && this.renderAddonEntry(entries[addonIndex]),
	        entries !== null && evaluationSteps !== null && evaluationSteps.map(this.renderEvaluationEntry)
	      );
	    }
	  }, {
	    key: 'renderExternalSubItems',
	    value: function renderExternalSubItems(part) {
	      if (part !== null && part !== undefined) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          part.map(function (item, index) {
	            return _react2.default.createElement(
	              'div',
	              { key: index + Math.floor(Math.random() * Math.floor(5000)) },
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('ExternalDeviationTypes', item.DeviationType.Type))
	            );
	          })
	        );
	      }
	    }
	  }, {
	    key: 'renderExternalSubCustomItems',
	    value: function renderExternalSubCustomItems(part) {
	      if (part !== null && part !== undefined) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          part.map(function (item, index) {
	            return _react2.default.createElement(
	              'div',
	              { key: index + Math.floor(Math.random() * Math.floor(5000)) },
	              item.CustomReason
	            );
	          })
	        );
	      }
	    }
	  }, {
	    key: 'renderExternalItems',
	    value: function renderExternalItems(item) {
	      var _this8 = this;
	
	      var history = this.state.history;
	      var renderDeviation = function renderDeviation(partitem) {
	        if (partitem.parts !== null) {
	          var onChange = function onChange(e) {
	            // e.persist()
	            if (e.target.name === undefined || e.target.name === null) return;
	            partitem[e.target.name] = !partitem[e.target.name];
	            // partitem.SelectedInvoice = !partitem.SelectedInvoice
	            var changes = {
	              OrderId: history.OrderId,
	              ExternalDeviations: [partitem]
	            };
	            _this8.updateHistory(changes);
	          };
	
	          return _react2.default.createElement(
	            'div',
	            { key: Math.floor(Math.random() * Math.floor(5000)) },
	            _react2.default.createElement(
	              _SelectableLine2.default,
	              { name: 'SelectedInvoice', checked: partitem.SelectedInvoice, extraCSS: 'SelectableLineExpandend', onChange: onChange },
	              partitem.Parts.map(function (part, index) {
	                return _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { key: index + Math.floor(Math.random() * Math.floor(5000)), labelText: part.PartDetails.Name },
	                  _this8.renderExternalSubItems(part.DeviationReasons),
	                  _this8.renderExternalSubCustomItems(part.CustomDeviationReasonDetails)
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _SelectableLine2.default,
	              { name: 'SelectedInvoiceCost', checked: partitem.SelectedInvoiceCost, onChange: onChange },
	              _react2.default.createElement(
	                _inline2.default,
	                { fillChildNum: [0], block: true },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)('337') + ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  partitem.Cost,
	                  ' ',
	                  _this8.props.currencyCode
	                )
	              )
	            )
	          );
	        }
	      };
	
	      if (item.ExternalDeviations !== null) {
	        return _react2.default.createElement(
	          'div',
	          { key: Math.floor(Math.random() * Math.floor(5000)) },
	          item.ExternalDeviations.map(renderDeviation)
	        );
	      }
	    }
	  }, {
	    key: 'renderInvoiceExtra',
	    value: function renderInvoiceExtra() {
	      var _this9 = this;
	
	      var history = this.state.history;
	
	      var onOrderDataChange = function onOrderDataChange(e) {
	        var name = e.target.name; // getAttribute('name')
	        var changes = { OrderId: history.OrderId };
	        changes[name] = !_this9.state.history[name];
	        _this9.updateHistory(changes);
	      };
	
	      var renderNote = function renderNote(note) {
	        var onChange = function onChange(e) {
	          // e.persist()
	          note.SelectedInvoice = !note.SelectedInvoice;
	          var changes = {
	            OrderId: history.OrderId,
	            Notes: [note]
	          };
	          _this9.updateHistory(changes);
	        };
	
	        var label = _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'max-content'], align: 'start' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_UserInfo2.default, { user: note.CreatedByUserInfo }),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _time.renderFullDate)(note.CreatedDate)
	            )
	          ),
	          note.IsExternal ? _react2.default.createElement(
	            'span',
	            { className: 'hint--top', 'aria-label': (0, _helpers.translation)('2157') },
	            _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Customer })
	          ) : ''
	        );
	
	        return _react2.default.createElement(
	          _SelectableLine2.default,
	          { extraCSS: 'noteContent', key: 'Notes_' + note.NoteId + Math.floor(Math.random() * Math.floor(5000)), name: 'Notes_' + note.NoteId, checked: note.SelectedInvoice, onChange: onChange },
	          _react2.default.createElement(
	            'div',
	            { className: 'evaluationHistory-note' },
	            label,
	            _react2.default.createElement(
	              'div',
	              { className: 'text' },
	              (0, _helpers.translation)(note.SourceDictionaryKey),
	              ': ',
	              note.Text
	            )
	          )
	        );
	      };
	      // console.log('Evaluation history - state, props ', this.state, this.props)
	
	      return _react2.default.createElement(
	        _Column2.default,
	        { ref: 'dragparent' + 1, 'data-pos': 1, noTitle: true },
	        _react2.default.createElement(_Invoice2.default, { invoiceOrderId: this.props.params.orderId }),
	        _react2.default.createElement(_Section2.default, { icon: _icons.EvaluationHistoryIcons.Invoice_Add, title: (0, _helpers.translation)('14917') }),
	        _react2.default.createElement(
	          _Section2.default,
	          { extraCSS: 'extraSpace', icon: _icons.EvaluationHistoryIcons.Deviation, title: (0, _helpers.translation)('383') },
	          this.renderExternalItems(history)
	        ),
	        history.Notes !== null && _react2.default.createElement(
	          _Section2.default,
	          { icon: _icons.EvaluationHistoryIcons.Comment, title: (0, _helpers.translation)('14834') },
	          history.Notes.map(renderNote)
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { title: (0, _helpers.translation)('14918'), icon: _icons.EvaluationHistoryIcons.Order_Data },
	          _react2.default.createElement(
	            _SelectableLine2.default,
	            { name: 'OrderTypeSelected', checked: history.OrderTypeSelected, onChange: onOrderDataChange },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true, spacing: 0 },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('525'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)((0, _helpers.enumtranslate)('OrderTypes', history.OrderType))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _SelectableLine2.default,
	            { name: 'PickupDateSelected', checked: history.PickupDateSelected, onChange: onOrderDataChange },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true, spacing: 0 },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                (0, _helpers.translation)('156'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                (0, _time.renderFullDate)(history.PickupDate)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _SelectableLine2.default,
	            { name: 'DeliveredDateSelected', checked: history.DeliveredDateSelected, onChange: onOrderDataChange },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true, spacing: 0 },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                (0, _helpers.translation)('14919'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                history.DeliveredDate ? (0, _time.renderFullDate)(history.DeliveredDate) : (0, _helpers.translation)('14999')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _SelectableLine2.default,
	            { name: 'LtwIdCodeSelected', checked: history.LtwIdCodeSelected, onChange: onOrderDataChange },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true, spacing: 0 },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                (0, _helpers.translation)('13396'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                history.LtwIdCode
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _SelectableLine2.default,
	            { name: 'ChassisNumberSelected', checked: history.ChassisNumberSelected, onChange: onOrderDataChange },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true, spacing: 0 },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                (0, _helpers.translation)('1032'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                history.ChassisNumber
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCreationInfoSection',
	    value: function renderCreationInfoSection(entry) {
	      var createdBy = _react2.default.createElement(
	        'span',
	        null,
	        '\xA0'
	      );
	      if (entry.CreatedBy !== null) {
	        var helpText = '';
	        if (entry.CreatedByUserId === 4) {
	          helpText = _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(17929)
	          );
	        } else {
	          helpText = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              entry.CreatedByCompany
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              entry.CreatedByPhone
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              entry.CreatedByMail
	            )
	          );
	        }
	        createdBy = _react2.default.createElement(
	          'div',
	          { className: 'creation-info' },
	          _react2.default.createElement(_UserInfo2.default, { user: entry.CreatedByUserInfo }),
	          _react2.default.createElement(_HelpText2.default, { bottom: true, text: helpText })
	        );
	      }
	      return _react2.default.createElement(
	        _Section2.default,
	        null,
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _time.renderFullDate)(entry.CreatedDate) },
	          _react2.default.createElement(
	            'div',
	            null,
	            createdBy
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        )
	      );
	    }
	  }, {
	    key: 'renderAddonEntry',
	    value: function renderAddonEntry(entry) {
	      if (entry === null) return null;
	      var title = this.getEvaluationTitle(entry);
	      var icon = this.getEvaluationIcon(entry);
	
	      return _react2.default.createElement(
	        _Column2.default,
	        { key: 'entry_addon' + Math.floor(Math.random() * Math.floor(5000)), title: title, icon: icon },
	        this.renderCreationInfoSection(entry),
	        this.renderItemSection(entry),
	        entry.ManualPrice !== null && this.renderManualPrice(entry)
	      );
	    }
	  }, {
	    key: 'renderFileContainer',
	    value: function renderFileContainer(item) {
	      if (item.Files !== null && item.Files !== undefined && item.Files.length > 0) {
	        var imgFiles = [].concat(_toConsumableArray(item.Files));
	
	        var renderFile = function renderFile(image, index) {
	          var url = _constants.FILE_STORAGE + image.ThumbURL;
	          var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	          return _react2.default.createElement(
	            'div',
	            { key: index + Math.floor(Math.random() * Math.floor(5000)), className: 'file-image fileContainer' },
	            _react2.default.createElement(
	              'a',
	              { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	              _react2.default.createElement('img', { src: url })
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          _Section2.default,
	          { title: (0, _helpers.translation)('1043'), icon: _icons.ElementIcons.Files },
	          _react2.default.createElement(_Gallery2.default, { files: imgFiles, renderImage: renderFile })
	        );
	      }
	    }
	  }, {
	    key: 'renderEvaluationEntry',
	    value: function renderEvaluationEntry(entry, key, val) {
	      var _this10 = this;
	
	      if (entry === null) return;
	      var title = this.getEvaluationTitle(entry);
	      var icon = this.getEvaluationIcon(entry);
	
	      var onInvoiceClick = function onInvoiceClick() {
	        entry.SelectedInvoice = !entry.SelectedInvoice;
	        var changes = {
	          OrderId: _this10.state.history.OrderId,
	          History: [entry]
	        };
	        _this10.updateHistory(changes);
	      };
	
	      var onWorkCardClick = function onWorkCardClick() {
	        entry.SelectedWorkCard = !entry.SelectedWorkCard;
	        var changes = {
	          OrderId: _this10.state.history.OrderId,
	          History: [entry]
	        };
	        _this10.updateHistory(changes);
	      };
	
	      var ItemKey = 0;
	
	      if (typeof val !== 'undefined') {
	        val.map(function (item, key) {
	          if (item.Type === 1) {
	            if (item.OrderPriceId > ItemKey) {
	              ItemKey = item.OrderPriceId;
	            }
	          }
	        });
	      }
	
	      var renderSelectionChecks = function renderSelectionChecks() {
	        var workCardChange = onWorkCardClick;
	        var invoiceChange = onInvoiceClick;
	        var fade = false;
	
	        if (_this10.state.history.OrderType !== 1) {
	          if (entry.Type === 1) {
	            // && entry.OrderPriceId === ItemKey
	            fade = true;
	            workCardChange = null;
	            invoiceChange = null;
	          }
	        }
	
	        return _react2.default.createElement(
	          _Section2.default,
	          { sectionCss: 'columnchecks' },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--bottom-right', 'aria-label': (0, _helpers.translation)('14997') },
	              _react2.default.createElement(_check2.default, { checked: entry.SelectedWorkCard, onChange: workCardChange, disabled: fade, labelText: _react2.default.createElement(
	                  'span',
	                  { className: fade ? 'fadeOut' : '' },
	                  _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Workcard })
	                ) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--bottom-right', 'aria-label': (0, _helpers.translation)('14998') },
	              _react2.default.createElement(_check2.default, { checked: entry.SelectedInvoice, onChange: invoiceChange, disabled: fade, labelText: _react2.default.createElement(
	                  'span',
	                  { className: fade ? 'fadeOut' : '' },
	                  _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Total_Price })
	                ) })
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        );
	      };
	
	      if (entry.Parts.length > 0 || entry.Type === 1 || entry.Type === 3 || entry.Type === 4 || entry.Type === 5 || entry.Type === 6) {
	        var NewContainerKey = key + 2;
	
	        return _react2.default.createElement(
	          _Column2.default,
	          { key: 'entry_' + key + Math.floor(Math.random() * Math.floor(5000)), title: title, ref: 'dragparent' + NewContainerKey, 'data-pos': NewContainerKey, icon: icon },
	          renderSelectionChecks(),
	          this.renderCreationInfoSection(entry),
	          this.renderItemSection(entry),
	          entry.Report !== null && this.renderReportCalc(entry),
	          entry.Report !== null && this.renderReportTotals(entry),
	          entry.ManualPrice !== null && this.renderManualPrice(entry),
	          this.renderAddonSection(entry),
	          this.renderFileContainer(entry)
	        );
	      }
	    }
	  }, {
	    key: 'renderManualPrice',
	    value: function renderManualPrice(entry) {
	      return _react2.default.createElement(
	        _Section2.default,
	        null,
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0] },
	          _react2.default.createElement(
	            'span',
	            { className: 'sumText' },
	            (0, _helpers.translation)('13347'),
	            ':'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'amount' },
	            (0, _currency.formatCurrency)(entry.ManualPrice)
	          )
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0] },
	          _react2.default.createElement(
	            'span',
	            { className: 'sumText' },
	            (0, _helpers.translation)('13352'),
	            ':'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'amount' },
	            (0, _currency.formatCurrency)(entry.ManualEnvironment)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderReportTotals',
	    value: function renderReportTotals(entry) {
	      var currency = this.props.currencyCode;
	      var added = ' addedprice';
	      var removed = ' removedprice';
	      var totalPriceClass = '';
	      var totalPrice = 0;
	      var totalPriceWithEnv = 0;
	      if (entry.Report.Paint) {
	        if (entry.Report.Paint.TotalPriceStatus === 1) totalPriceClass += added;
	        if (entry.Report.Paint.TotalPriceStatus === 2) totalPriceClass += removed;
	
	        totalPrice = entry.Report.Paint.TotalPrice;
	        totalPriceWithEnv = entry.Report.Paint.TotalPriceWithEnv;
	      }
	      var summationWithStatus = entry.Report.Summation.map(function (x) {
	        return _extends({}, x, entry.Report.SummationStatus.find(function (s) {
	          return s.Text === x.Text;
	        }));
	      });
	
	      var renderSummation = function renderSummation(sum, index) {
	        var summationClass = '';
	        if (sum.Status === 1) summationClass += added;
	        if (sum.Status === 2) summationClass += removed;
	
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: summationClass },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              sum.Text,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'amount' },
	              (0, _currency.formatCurrency)(sum.TotalPrice),
	              ' ',
	              currency
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _Section2.default,
	        null,
	        summationWithStatus.filter(function (x) {
	          return x.SumType !== 4;
	        }).map(renderSummation),
	        _react2.default.createElement(
	          'div',
	          { className: totalPriceClass },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              (0, _helpers.translation)('18392'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'amount' },
	              ' ',
	              (0, _currency.formatCurrency)(totalPrice),
	              ' ',
	              currency
	            )
	          )
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        summationWithStatus.filter(function (x) {
	          return x.SumType === 4;
	        }).map(renderSummation),
	        _react2.default.createElement(
	          'div',
	          { className: totalPriceClass },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              (0, _helpers.translation)('393'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'amount' },
	              ' ',
	              (0, _currency.formatCurrency)(totalPriceWithEnv),
	              ' ',
	              currency
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderReportCalc',
	    value: function renderReportCalc(entry) {
	      var _this11 = this;
	
	      var renderMetallicMethod = function renderMetallicMethod(item, key) {
	        var renderAddedRefinishTypes = function renderAddedRefinishTypes(item, key) {
	          return _react2.default.createElement(
	            'div',
	            { key: Math.floor(Math.random() * Math.floor(5000)), className: 'added' },
	            item.Type
	          );
	        };
	        var strike = false;
	        var addedRefinishTypes = [];
	        entry.RefinishTypes.map(function (refinishType) {
	          if (refinishType.PaintLineId !== null && refinishType.PaintLineId === item.PaintLineId) {
	            strike = true;
	            addedRefinishTypes.push(refinishType);
	          }
	        });
	        return _react2.default.createElement(
	          'div',
	          { key: Math.floor(Math.random() * Math.floor(5000)), className: 'pg-mb-1' },
	          strike === true && _react2.default.createElement('div', { className: 'strike_through' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'bold' },
	            item.ReportLineNumber || ''
	          ),
	          ' ',
	          item.ReportLineText,
	          addedRefinishTypes.map(renderAddedRefinishTypes)
	        );
	      };
	      var renderStartTimes = function renderStartTimes(item, key) {
	        return _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0] },
	          _react2.default.createElement(
	            'span',
	            { className: 'added' },
	            item.Type
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'added amount' },
	            item.Ae,
	            ' ',
	            lu
	          )
	        );
	      };
	      var renderHourPrices = function renderHourPrices(item, key) {
	        return _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0] },
	          _react2.default.createElement(
	            'span',
	            { className: 'added' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'added amount' },
	            item.Price,
	            ' ',
	            _this11.props.currencyCode
	          )
	        );
	      };
	      var renderMaterialsShares = function renderMaterialsShares(item, key) {
	        return _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0] },
	          _react2.default.createElement(
	            'span',
	            { className: 'added' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'added amount' },
	            item.Share,
	            ' %'
	          )
	        );
	      };
	
	      var lu = (0, _helpers.translation)('13345');
	      var baseClass = 'reportprice';
	      var addedClass = ' addedprice';
	      var removedClass = ' removedprice';
	      var hourClass = baseClass;
	      var matIndexClass = baseClass;
	
	      // - Line types
	      var GENERIC_TYPE = 0;
	      var STARTTIME_TYPE = 4;
	
	      // - Line sub types
	      var MATERIALINDEX_SUBTYPE = 1;
	      var REFINISH_SUBTYPE = 6;
	
	      var lines = [];
	      var hourPrice = 0;
	
	      if (entry.Report.Paint) {
	        var _entry$Report$Paint = entry.Report.Paint,
	            HourPriceStatus = _entry$Report$Paint.HourPriceStatus,
	            Lines = _entry$Report$Paint.Lines,
	            HourPrice = _entry$Report$Paint.HourPrice;
	
	
	        if (HourPriceStatus === 1) hourClass += addedClass;
	        if (HourPriceStatus === 2) hourClass += removedClass;
	
	        lines = Lines;
	        hourPrice = HourPrice;
	
	        if (lines.some(function (l) {
	          return l.LineSubType === MATERIALINDEX_SUBTYPE && l.Status === 1;
	        })) matIndexClass += addedClass;
	        if (lines.some(function (l) {
	          return l.LineSubType === MATERIALINDEX_SUBTYPE && l.Status === 2;
	        })) matIndexClass += removedClass;
	      }
	
	      // Renders start time data for a group of start times (grouped by LineSubType from Report/ReportLineSubType on OrderPriceDetail)
	      var renderStartTimeGroup = function renderStartTimeGroup(startTimeType) {
	        var reportStartTimes = lines.filter(function (l) {
	          return l.LineType === STARTTIME_TYPE && l.LineSubType === startTimeType;
	        });
	        var orderPriceStartTimes = entry.StartTimes.filter(function (l) {
	          return l.ReportLineSubType === startTimeType;
	        });
	
	        if (reportStartTimes.length === 0 && orderPriceStartTimes.length === 0) return null;
	
	        var startTimeClass = baseClass;
	        if (reportStartTimes.some(function (l) {
	          return l.Status === 1;
	        })) {
	          startTimeClass += addedClass;
	        } else if (reportStartTimes.some(function (l) {
	          return l.Status === 2;
	        })) {
	          startTimeClass += removedClass;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          reportStartTimes.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'report_item' },
	            orderPriceStartTimes.length > 0 && _react2.default.createElement('div', { className: 'strike_through' }),
	            _react2.default.createElement(
	              'div',
	              { className: startTimeClass },
	              _react2.default.createElement(
	                _inline2.default,
	                { block: true, fillChildNum: [0] },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'bold' },
	                  reportStartTimes[0].LineText
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'amount' },
	                  reportStartTimes[0].WorkUnits + ' ' + lu
	                )
	              )
	            )
	          ),
	          orderPriceStartTimes.filter(function (l) {
	            return l.PaintLineId;
	          }).map(renderStartTimes)
	        );
	      };
	
	      var renderMaterialShares = function renderMaterialShares() {
	        // Get material index line if present.
	        var materialIndexLines = lines.filter(function (l) {
	          return l.LineSubType === MATERIALINDEX_SUBTYPE;
	        });
	        var materialIndexLine = materialIndexLines.length > 0 ? materialIndexLines[0] : null;
	        var renderReportMaterialIndex = function renderReportMaterialIndex() {
	          return _react2.default.createElement(
	            'div',
	            { className: 'report_item' },
	            entry.MaterialsShares.length > 0 && _react2.default.createElement('div', { className: 'strike_through' }),
	            _react2.default.createElement(
	              'div',
	              { className: matIndexClass },
	              _react2.default.createElement(
	                _inline2.default,
	                { block: true, fillChildNum: [0] },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'bold' },
	                  materialIndexLine.LineText
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'amount' },
	                  materialIndexLine.GenericValue
	                )
	              )
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          materialIndexLine !== null && renderReportMaterialIndex(),
	          entry.MaterialsShares.map(renderMaterialsShares)
	        );
	      };
	
	      // Gather distinct types of starttimes from both report and orderprice.
	      var startTimeTypes = [];
	      // - report
	      lines.filter(function (l) {
	        return l.LineType === STARTTIME_TYPE;
	      }).map(function (l) {
	        if (!startTimeTypes.some(function (type) {
	          return type === l.LineSubType;
	        })) {
	          startTimeTypes.push(l.LineSubType);
	        }
	      });
	
	      // - orderprice
	      entry.StartTimes.map(function (st) {
	        if (!startTimeTypes.some(function (type) {
	          return type === st.ReportLineSubType;
	        })) {
	          startTimeTypes.push(st.ReportLineSubType);
	        }
	      });
	
	      return _react2.default.createElement(
	        _Section2.default,
	        null,
	        lines.filter(function (l) {
	          return l.LineType === GENERIC_TYPE && l.LineSubType === REFINISH_SUBTYPE;
	        }).map(renderMetallicMethod),
	        startTimeTypes.map(renderStartTimeGroup),
	        entry.HourPrices.length > 0 && _react2.default.createElement('div', { className: 'strike_through' }),
	        _react2.default.createElement(
	          'div',
	          { className: hourClass },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              (0, _helpers.translation)('419')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'amount' },
	              (0, _currency.formatCurrency)(hourPrice),
	              ' ',
	              this.props.currencyCode
	            )
	          )
	        ),
	        entry.HourPrices.map(renderHourPrices),
	        renderMaterialShares()
	      );
	    }
	  }, {
	    key: 'renderAddonSection',
	    value: function renderAddonSection(entry) {
	      var _this12 = this;
	
	      var parts = entry.Parts;
	
	      // Get start times and refinish types, not associated with forsi item.
	      var startTimes = [];
	      var refinishTypes = [];
	      if (entry.StartTimes !== null) startTimes = entry.StartTimes.filter(function (x) {
	        return x.PaintLineId === null;
	      });
	      if (entry.RefinishTypes !== null) refinishTypes = entry.RefinishTypes.filter(function (x) {
	        return x.PaintLineId === null;
	      });
	      var hasOtherItems = startTimes.length > 0 || refinishTypes.length > 0;
	
	      var allDummy = true;
	      for (var partIndex in parts) {
	        for (var itemIndex in parts[partIndex].Items) {
	          var item = parts[partIndex].Items[itemIndex];
	          if (!item.IsDummy) {
	            allDummy = false;
	          }
	        }
	      }
	
	      var renderOtherItems = function renderOtherItems(items, heading) {
	        if (items.length === 0) return null;
	        var renderOtherItem = function renderOtherItem(item, key) {
	          if (item.PaintLineId !== undefined && item.PaintLineId !== null) return;
	          var text = item.Type || item.Share || item.Price;
	          var amount = item.Ae || false;
	          var className = 'other_item';
	          if (entry.Type === 4) className += ' added'; // "other items" for after-evaluation are always "added".
	          return _react2.default.createElement(
	            'div',
	            { key: 'other_' + key, className: className },
	            _react2.default.createElement(
	              'span',
	              { className: 'sumText' },
	              text
	            ),
	            amount && _react2.default.createElement(
	              'span',
	              { className: 'amount' },
	              amount,
	              ' ',
	              (0, _helpers.translation)(885)
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          heading && _react2.default.createElement(
	            'div',
	            { className: 'sumText bold top-spacing' },
	            heading
	          ),
	          items.map(renderOtherItem)
	        );
	      };
	
	      if ((parts.length > 0 || hasOtherItems) && entry.Type === 4 && allDummy === false) {
	        var renderPart = function renderPart(part) {
	          var addonParts = false;
	          var renderItem = function renderItem(item) {
	            if (item === null) return null;
	
	            var onInvoiceClick = function onInvoiceClick(clickedItem) {
	              if (clickedItem !== undefined && clickedItem !== null) {
	                clickedItem.SelectedInvoice = !clickedItem.SelectedInvoice;
	                var changes = {
	                  OrderId: _this12.state.history.OrderId,
	                  Modifier: clickedItem
	                };
	                _this12.updateHistory(changes);
	              } else {
	                item.SelectedInvoice = !item.SelectedInvoice;
	                var _changes = {
	                  OrderId: _this12.state.history.OrderId,
	                  Modifier: item
	                };
	                _this12.updateHistory(_changes);
	              }
	            };
	
	            var onWorkCardClick = function onWorkCardClick(clickedItem) {
	              if (clickedItem !== undefined && clickedItem !== null) {
	                clickedItem.SelectedWorkCard = !clickedItem.SelectedWorkCard;
	                var changes = {
	                  OrderId: _this12.state.history.OrderId,
	                  Modifier: clickedItem
	                };
	                _this12.updateHistory(changes);
	              } else {
	                item.SelectedWorkCard = !item.SelectedWorkCard;
	                var _changes2 = {
	                  OrderId: _this12.state.history.OrderId,
	                  Modifier: item
	                };
	                _this12.updateHistory(_changes2);
	              }
	            };
	
	            var workcardDisabled = false;
	            var invoiceDisabled = false;
	            if (entry.Type === 4) {
	              workcardDisabled = entry.SelectedWorkCard;
	              invoiceDisabled = entry.SelectedInvoice;
	            }
	
	            var key = 'item_' + item.VisualLineNr;
	
	            if (item.IsAddon === true && item.IsDummy === false) {
	              return _react2.default.createElement(
	                'div',
	                { key: key + Math.floor(Math.random() * Math.floor(5000)) },
	                _react2.default.createElement(_ExtentLine2.default, { item: item, onInvoiceClick: onInvoiceClick, onWorkCardClick: onWorkCardClick, showPrice: true, workcardDisabled: workcardDisabled, invoiceDisabled: invoiceDisabled })
	              );
	            }
	          };
	
	          part.Items.map(function (myitem, key) {
	            if (myitem.IsAddon === true) {
	              addonParts = true;
	            }
	          });
	
	          if (addonParts === true) {
	            var partName = part.PartName;
	            if (partName === 'None') partName = (0, _helpers.translation)(227);
	            return _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: _this12.getTaskSideName(part.TaskSide) + ' ' + partName, key: 'part_' + part.PartId + '_taskside_' + part.TaskSide + '_partname_' + part.PartName.split(' ').join('') + Math.floor(Math.random() * Math.floor(5000)) },
	              part.Items.map(renderItem)
	            );
	          }
	        };
	
	        return _react2.default.createElement(
	          _Section2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              (0, _helpers.translation)('13536')
	            ),
	            _react2.default.createElement(_divider2.default, null)
	          ),
	          parts !== null && parts.map(renderPart),
	          startTimes !== null && renderOtherItems(startTimes, (0, _helpers.translation)(1195)),
	          refinishTypes !== null && renderOtherItems(refinishTypes, (0, _helpers.translation)(161))
	        );
	      }
	    }
	  }, {
	    key: 'renderItemSection',
	    value: function renderItemSection(entry) {
	      var _this13 = this;
	
	      var parts = entry.Parts;
	      var priceEntries = entry.PriceEntries;
	      var renderPart = function renderPart(part) {
	        var originalParts = false;
	        var renderItem = function renderItem(item) {
	          if (item === null) return null;
	
	          var onInvoiceClick = function onInvoiceClick(clickedItem) {
	            clickedItem.SelectedInvoice = !clickedItem.SelectedInvoice;
	            var changes = {
	              OrderId: _this13.state.history.OrderId,
	              Modifier: clickedItem
	            };
	            _this13.updateHistory(changes);
	          };
	
	          var onWorkCardClick = function onWorkCardClick(clickedItem) {
	            clickedItem.SelectedWorkCard = !clickedItem.SelectedWorkCard;
	            var changes = {
	              OrderId: _this13.state.history.OrderId,
	              Modifier: clickedItem
	            };
	            _this13.updateHistory(changes);
	          };
	
	          var key = 'item_' + item.VisualLineNr;
	          var workcardDisabled = false;
	          var invoiceDisabled = false;
	          if (entry.Type === 4) {
	            workcardDisabled = entry.SelectedWorkCard;
	            invoiceDisabled = entry.SelectedInvoice;
	          }
	          if (item.IsAddon === false) {
	            return _react2.default.createElement(_ExtentLine2.default, { item: item, entry: entry, onInvoiceClick: onInvoiceClick, onWorkCardClick: onWorkCardClick, workcardDisabled: workcardDisabled, invoiceDisabled: invoiceDisabled, key: key + Math.floor(Math.random() * Math.floor(5000)) });
	          }
	        };
	
	        part.Items.map(function (myitem, key) {
	          if (myitem.IsAddon === false) {
	            originalParts = true;
	          }
	        });
	        var partCss = 'part';
	        if (part.ReportLineAdded) {
	          partCss += ' added';
	        } else if (part.ReportLineRemoved) {
	          partCss += ' removed';
	        }
	        if (originalParts === true) {
	          var partName = part.PartName;
	          if (partName === 'None') partName = (0, _helpers.translation)(227);
	          return _react2.default.createElement(
	            'div',
	            { key: 'part_' + part.PartId + '_taskside_' + part.TaskSide + '_partname_' + part.PartName.split(' ').join('') + Math.floor(Math.random() * Math.floor(5000)), className: partCss },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: partName },
	              part.Items.map(renderItem)
	            )
	          );
	        }
	      };
	      var renderOtherPriceEntries = function renderOtherPriceEntries(item, key) {
	        if (item.EntryType === null || item.EntryType < 9) return null;
	        return renderPriceEntry(item);
	      };
	      var renderPriceEntry = function renderPriceEntry(item) {
	        var partCss = 'part';
	        if (item.PriceStatus === 1) {
	          partCss += ' added';
	        } else if (item.PriceStatus === 2) {
	          partCss += ' removed';
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: partCss },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(
	              'span',
	              null,
	              item.Name
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              (0, _currency.formatCurrency)(Number(item.Amount)),
	              ' ',
	              _this13.props.currencyCode
	            )
	          )
	        );
	      };
	      var renderStartPrice = function renderStartPrice() {
	        if (entry.StartPriceGross === null || entry.Type !== 1 && entry.Type !== 2) return null;
	        return _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0] },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(13378)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _currency.formatCurrency)(Number(entry.StartPriceGross)),
	            ' ',
	            _this13.props.currencyCode
	          )
	        );
	      };
	      var environment = priceEntries.filter(function (item) {
	        return item.EntryType === 2;
	      })[0];
	      var gross = priceEntries.filter(function (item) {
	        return item.EntryType === 0;
	      })[0];
	      if (environment) {
	        environment.Name = (0, _helpers.translation)('13379');
	      }
	      if (gross) {
	        gross.Name = (0, _helpers.translation)('13350');
	      }
	      return _react2.default.createElement(
	        _Section2.default,
	        null,
	        renderStartPrice(),
	        parts !== null && parts.map(renderPart),
	        priceEntries !== null && priceEntries.map(renderOtherPriceEntries),
	        environment && renderPriceEntry(environment),
	        gross && renderPriceEntry(gross)
	      );
	    }
	  }]);
	
	  return EvaluationHistory;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getEvaluationHistory: _evaluationhistory.getEvaluationHistory,
	  updateEvaluationHistory: _evaluationhistory.updateEvaluationHistory,
	  getOrder: _orders.getOrder,
	  setPageTitle: _common.setPageTitle,
	  triggerPopup: _backdrop.triggerPopup,
	  triggerPopupActionBG: _backdrop.triggerPopupActionBG
	})(EvaluationHistory);

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _chains = __webpack_require__(127);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(1398);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForsiList = function (_Component) {
	  _inherits(ForsiList, _Component);
	
	  function ForsiList(props) {
	    _classCallCheck(this, ForsiList);
	
	    var _this = _possibleConstructorReturn(this, (ForsiList.__proto__ || Object.getPrototypeOf(ForsiList)).call(this, props));
	
	    _this.state = {
	      list: []
	    };
	    _this.renderItem = _this.renderItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(ForsiList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getForsiList();
	    }
	  }, {
	    key: 'getForsiList',
	    value: function getForsiList() {
	      var _this2 = this;
	
	      this.props.getForsiList().then(function (res) {
	        _this2.setState({
	          list: res.data
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('2225'), (0, _helpers.translation)('216'));
	        _this2.props.router.push('/');
	      });
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(item, key) {
	      return _react2.default.createElement(
	        _tableRow2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          item.ShopName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.Mail
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.Phone
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _time.renderFullDate)(item.LastUpdated)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.ForsiBodyShopId
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderActive(item)
	        )
	      );
	    }
	  }, {
	    key: 'renderActive',
	    value: function renderActive(item) {
	      var _this3 = this;
	
	      var changeActive = function changeActive() {
	        _this3.props.updateForsiList(item.ShopId, !item.Active).then(function (res) {
	          _this3.setState({
	            list: res.data
	          });
	          // window.toastr.success(translation('2226'), translation('13424'))
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('2227'), (0, _helpers.translation)('216'));
	        });
	      };
	      return _react2.default.createElement(
	        'span',
	        { onClick: changeActive },
	        _react2.default.createElement(
	          _inline2.default,
	          null,
	          item.Active ? _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Inspection_Check }) : _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Inspection_Cancel }),
	          ' ',
	          item.Active ? (0, _helpers.translation)('295') : (0, _helpers.translation)('296')
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Header2.default, { router: this.props.router, title: (0, _helpers.translation)('2228'), icon: 'menu/Forsi-white30x30px.png' }),
	        _react2.default.createElement(
	          _tableContainer2.default,
	          null,
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('30')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('151')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('38')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('560')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('14803')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('13438')
	            )
	          ),
	          this.state.list.map(this.renderItem)
	        )
	      );
	    }
	  }]);
	
	  return ForsiList;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getForsiList: _chains.getForsiList,
	  updateForsiList: _chains.updateForsiList
	})(ForsiList);

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _insurancecompanies = __webpack_require__(172);
	
	var _actions = __webpack_require__(129);
	
	var _constants = __webpack_require__(5);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	// import HelpText from '../../../shared/components/HelpText'
	
	// contants
	
	
	// Elements
	
	
	// Utils
	
	
	// Styles
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      insuranceCompany: {
	        InsuranceCompanyId: 0,
	        Code: '',
	        Name: '',
	        Company: '',
	        Active: '',
	        Comment: '',
	        Debtor: '',
	        contractTypeSelected: 0,
	        RentLogContractTypeInfo: null,
	        ContractTypeListFromRentLog: []
	      }
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onInputLanguageChange = _this.onInputLanguageChange.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.saveAddInsuranceCompany = _this.saveAddInsuranceCompany.bind(_this);
	    _this.addInsuranceCompany = _this.addInsuranceCompany.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getInsuranceCompany(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.InsuranceCompanyId !== nextProps.item.InsuranceCompanyId) {
	        this.getInsuranceCompany(nextProps);
	      }
	    }
	  }, {
	    key: 'getInsuranceCompany',
	    value: function getInsuranceCompany(props) {
	      var _this2 = this;
	
	      // console.log('getInsuranceCompany props', props)
	      if (typeof props.item === 'undefined') return;
	      if (typeof props.item.InsuranceCompanyId !== 'undefined') {
	        props.getInsuranceCompany(props.item.InsuranceCompanyId).then(function (res) {
	          _this2.setState({
	            type: 'edit',
	            insuranceCompany: res.data
	          });
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        insuranceCompany: {
	          InsuranceCompanyId: 0,
	          Code: '',
	          Name: '',
	          Company: '',
	          Active: true,
	          Comment: '',
	          Debtor: '',
	          contractTypeSelected: 0,
	          RentLogContractTypeInfo: null,
	          ContractTypeListFromRentLog: []
	        }
	      });
	    }
	  }, {
	    key: 'saveAddInsuranceCompany',
	    value: function saveAddInsuranceCompany(e) {
	      var _this3 = this;
	
	      if (this.state.insuranceCompany.InsuranceCompanyId > 0) {
	        var insuranceCompany = _extends({}, this.state.insuranceCompany);
	        // update
	        this.props.CreateSaveInsuranceCompany(insuranceCompany).then(function (res) {
	          _this3.props.onSave(res.data, _this3.state.type);
	          _this3.setState({
	            insuranceCompany: res.data
	          });
	        }, function (err) {
	          if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	            var errors = err.response.data.Errors;
	            var errorText = '';
	            errors.map(function (item) {
	              if (item.DictionaryKey !== 0) {
	                errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	              }
	            });
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	          } else {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	          }
	        });
	        // } else {
	        //   console.log('validation error')
	        // }
	      }
	    }
	  }, {
	    key: 'addInsuranceCompany',
	    value: function addInsuranceCompany() {
	      var _this4 = this;
	
	      if (this.state.insuranceCompany.InsuranceCompanyId === 0) {
	        var insuranceCompany = _extends({}, this.state.insuranceCompany);
	        // update
	        this.props.CreateSaveInsuranceCompany(insuranceCompany).then(function (res) {
	          _this4.props.onSave(res.data, _this4.state.type);
	          _this4.setState({
	            insuranceCompany: res.data
	          });
	        }, function (err) {
	          if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	            var errors = err.response.data.Errors;
	            var errorText = '';
	            errors.map(function (item) {
	              if (item.DictionaryKey !== 0) {
	                errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	              }
	            });
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	          } else {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)('1883'), (0, _helpers.translation)('216'));
	          }
	        });
	        // } else {
	        //   console.log('validation error')
	        // }
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(name, e) {
	      var _this5 = this;
	
	      // console.log('this.state', this.state)
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (typeof e === 'undefined') {
	          e = name;
	        }
	        name = e.target.name;
	        value = e.target.value;
	      }
	
	      if (name === 'contractTypeSelected') {
	        if (value === 0) return;
	        name = 'RentLogContractTypeInfo';
	        var newRentLogContractInfo = {
	          InsuranceCompanyId: this.state.insuranceCompany.InsuranceCompanyId,
	          RentLogContractTypeOid: value,
	          CompanyId: this.props.auth.user.ShopId
	        };
	        value = newRentLogContractInfo;
	      }
	
	      this.setState({
	        insuranceCompany: _extends({}, this.state.insuranceCompany, _defineProperty({}, name, value))
	      }, function () {
	        if (name === 'StartScreen' || name === 'RentLogContractTypeInfo') {
	          _this5.saveAddInsuranceCompany();
	        }
	      });
	    }
	  }, {
	    key: 'onInputLanguageChange',
	    value: function onInputLanguageChange(name, e) {
	      var _this6 = this;
	
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (typeof e === 'undefined') {
	          e = name;
	        }
	        name = e.target.name;
	      }
	
	      var langInfos = this.props.getLanguageInfos();
	      langInfos.map(function (l) {
	        if (l.SelfLangName === e.target.value) {
	          value = l.LanguageName;
	        }
	      });
	
	      if (this.state.insuranceCompany.InsuranceCompanyId === this.props.auth.InsuranceCompanyId) {
	        this.props.setLanguage(value);
	      }
	
	      this.setState({
	        insuranceCompany: _extends({}, this.state.insuranceCompany, _defineProperty({}, name, value))
	      }, function () {
	        if (name === 'Language') {
	          _this6.saveAddInsuranceCompany();
	        }
	      });
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      var _this7 = this;
	
	      e.persist();
	      var value = e.target.value;
	      var name = e.target.name;
	      // console.log(name + '' + value)
	      // console.log(e.target.name)
	      if (name === 'Active') {
	        value = e.target.checked;
	        this.setState({
	          insuranceCompany: _extends({}, this.state.insuranceCompany, {
	            Active: value
	          })
	        }, function () {
	          _this7.saveAddInsuranceCompany();
	        });
	      } else {
	        this.setState({
	          insuranceCompany: _extends({}, this.state.insuranceCompany, _defineProperty({}, name, value))
	        }, function () {
	          _this7.saveAddInsuranceCompany();
	        });
	      }
	    }
	  }, {
	    key: 'renderInsuranceCompany',
	    value: function renderInsuranceCompany() {
	      var insuranceCompany = _extends({}, this.state.insuranceCompany);
	      /* const ActiveChecked = (type, active) => {
	        if (active === type) {
	          return (
	            true
	          )
	        }
	      } */
	      var usedRentLog = this.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.RENTLOG;
	      var contractTypeListFromRentLog = [];
	      if (!insuranceCompany.RentLogContractTypeInfo) contractTypeListFromRentLog.push({ Oid: 0, Name: (0, _helpers.translation)('890') });
	
	      insuranceCompany.ContractTypeListFromRentLog && insuranceCompany.ContractTypeListFromRentLog.map(function (val) {
	        contractTypeListFromRentLog.push({ Oid: val.Oid, Name: val.Name });
	      });
	
	      if (insuranceCompany.RentLogContractTypeInfo && contractTypeListFromRentLog.length > 1) {
	        contractTypeListFromRentLog.filter(function (x) {
	          return x.Oid !== 0;
	        });
	      }
	
	      var contractTypeSelected = void 0;
	      insuranceCompany.ContractTypeListFromRentLog && insuranceCompany.ContractTypeListFromRentLog.map(function (val) {
	        if (insuranceCompany.RentLogContractTypeInfo && insuranceCompany.RentLogContractTypeInfo.RentLogContractTypeOid === val.Oid) contractTypeSelected = val.Oid;
	      });
	      var contractTypeOptions = contractTypeListFromRentLog.map(function (b, index) {
	        return _react2.default.createElement(
	          'option',
	          { key: index, value: b.Oid },
	          b.Name
	        );
	      });
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('418') },
	        _react2.default.createElement(_text2.default, { name: 'Code', value: insuranceCompany.Code || '', disabled: !(0, _auth.hasAccess)([2], this.props.auth.user.UserType), onChange: this.onInputChange, onBlur: this.saveAddInsuranceCompany, labelText: (0, _helpers.translation)('13372') }),
	        _react2.default.createElement(_text2.default, { name: 'Company', value: insuranceCompany.Company || '', disabled: !(0, _auth.hasAccess)([2], this.props.auth.user.UserType), onChange: this.onInputChange, onBlur: this.saveAddInsuranceCompany, labelText: (0, _helpers.translation)('418') }),
	        _react2.default.createElement(_text2.default, { name: 'Name', value: insuranceCompany.Name || '', disabled: !(0, _auth.hasAccess)([2], this.props.auth.user.UserType), onChange: this.onInputChange, onBlur: this.saveAddInsuranceCompany, labelText: (0, _helpers.translation)('14800') }),
	        !(0, _auth.hasAccess)([2], this.props.auth.user.UserType) && _react2.default.createElement(_text2.default, { name: 'Debtor', value: insuranceCompany.Debtor || '', onChange: this.onInputChange, onBlur: this.saveAddInsuranceCompany, labelText: (0, _helpers.translation)('13452') }),
	        _react2.default.createElement(_textarea2.default, { name: 'Comment', onChange: this.onInputChange, onBlur: this.saveAddInsuranceCompany, value: insuranceCompany.Comment || '', placeholder: (0, _helpers.translation)('14801'), labelText: (0, _helpers.translation)('149') }),
	        usedRentLog && _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'contractTypeSelected', value: contractTypeSelected, onChange: this.onInputChange, labelText: (0, _helpers.translation)('18130') },
	          contractTypeOptions
	        ),
	        (0, _auth.hasAccess)([2], this.props.auth.user.UserType) && _react2.default.createElement(_switch2.default, { name: 'Active', value: 'true', disabled: !(0, _auth.hasAccess)([2], this.props.auth.user.UserType), checked: this.state.insuranceCompany.Active === true, onChange: this.onRadioChange, labelText: (0, _helpers.translation)('295') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        this.renderInsuranceCompany()
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  setLanguage: _actions.setLanguage,
	  getLanguageInfos: _actions.getLanguageInfos,
	  getInsuranceCompany: _insurancecompanies.getInsuranceCompany,
	  CreateSaveInsuranceCompany: _insurancecompanies.CreateSaveInsuranceCompany
	}, null, { withRef: true })(View);

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _insurancecompanies = __webpack_require__(172);
	
	__webpack_require__(1400);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _View = __webpack_require__(861);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var InsuranceCompanyList = function (_Component) {
	  _inherits(InsuranceCompanyList, _Component);
	
	  function InsuranceCompanyList(props) {
	    _classCallCheck(this, InsuranceCompanyList);
	
	    var _this = _possibleConstructorReturn(this, (InsuranceCompanyList.__proto__ || Object.getPrototypeOf(InsuranceCompanyList)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      insuranceCompanies: [],
	      activeItem: {}
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(InsuranceCompanyList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getInsuranceCompanies();
	    }
	  }, {
	    key: 'getInsuranceCompanies',
	    value: function getInsuranceCompanies() {
	      var _this2 = this;
	
	      this.props.getInsuranceCompanies().then(function (res) {
	        _this2.setState({
	          insuranceCompanies: res.data.Item2
	        });
	        if (res.data.Item2.length === 0) {
	          _this2.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create' || !(0, _auth.hasAccess)([2], this.props.auth.user.UserType)) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: '0', size: 'm', ariaText: (0, _helpers.translation)('1797'), labelText: (0, _helpers.translation)(1797), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.view.getWrappedInstance().addInsuranceCompany();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.insuranceCompanies.map(function (ic) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: ic.Company,
	          onClick: function onClick() {
	            return _this3.onSelectItem(ic);
	          },
	          selected: ic.InsuranceCompanyId === _this3.state.activeItem.InsuranceCompanyId,
	          inactive: !ic.Active,
	          key: ic.InsuranceCompanyId
	        });
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var insuranceCompanies = [].concat(_toConsumableArray(this.state.insuranceCompanies));
	      var activeItem = void 0;
	      if (type === 'create') {
	        insuranceCompanies.push({
	          InsuranceCompanyId: data.InsuranceCompanyId,
	          Code: data.Code,
	          Name: data.Name,
	          Company: data.Company,
	          Active: data.Active,
	          Comment: data.Comment,
	          Debtor: data.Debtor
	        });
	        type = 'item';
	        activeItem = {
	          InsuranceCompanyId: data.InsuranceCompanyId
	        };
	      } else {
	        insuranceCompanies.map(function (val, key) {
	          if (val.InsuranceCompanyId === data.InsuranceCompanyId) {
	            val.Name = data.Name;
	            val.Active = data.Active;
	          }
	        });
	        type = 'item';
	      }
	      this.setState({
	        insuranceCompanies: insuranceCompanies,
	        view: type,
	        activeItem: activeItem
	      });
	      // Toastr
	      // window.toastr.success(translation('512'), translation('13424'))
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { ref: 'view', item: this.state.activeItem, onSave: this.onSave });
	      }
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'customers__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: this.headerButtonsRight }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create' },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'customers__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return InsuranceCompanyList;
	}(_react.Component);
	
	InsuranceCompanyList.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getInsuranceCompanies: _insurancecompanies.getInsuranceCompanies })(InsuranceCompanyList);

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _helpers = __webpack_require__(2);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _httpIntegrationLog = __webpack_require__(866);
	
	var _httpIntegrationLog2 = _interopRequireDefault(_httpIntegrationLog);
	
	var _dbsLog = __webpack_require__(864);
	
	var _dbsLog2 = _interopRequireDefault(_dbsLog);
	
	var _forsiTokenLog = __webpack_require__(865);
	
	var _forsiTokenLog2 = _interopRequireDefault(_forsiTokenLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntegrationErrorList = function (_Component) {
	  _inherits(IntegrationErrorList, _Component);
	
	  function IntegrationErrorList(props) {
	    _classCallCheck(this, IntegrationErrorList);
	
	    var _this = _possibleConstructorReturn(this, (IntegrationErrorList.__proto__ || Object.getPrototypeOf(IntegrationErrorList)).call(this, props));
	
	    _this.state = {
	      selectedTabIndex: 0,
	      tabs: [{
	        title: 18138,
	        component: _httpIntegrationLog2.default,
	        props: {
	          integrationType: 0
	        }
	      }, {
	        title: 15352,
	        component: _httpIntegrationLog2.default,
	        props: {
	          integrationType: 1
	        }
	      }, {
	        title: 17930,
	        component: _dbsLog2.default
	      }, {
	        title: 18331,
	        component: _forsiTokenLog2.default
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(IntegrationErrorList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderTitle = function renderTitle(title, index) {
	        return _react2.default.createElement(_tabItem2.default, {
	          key: index,
	          onClick: function onClick() {
	            return _this2.setState({ selectedTabIndex: index });
	          },
	          labelText: (0, _helpers.translation)(title.title),
	          active: _this2.state.selectedTabIndex === index
	        });
	      };
	
	      var _state$tabs$state$sel = this.state.tabs[this.state.selectedTabIndex],
	          Component = _state$tabs$state$sel.component,
	          props = _state$tabs$state$sel.props;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Header2.default,
	          { router: this.props.router },
	          _react2.default.createElement(
	            _tabBar2.default,
	            null,
	            this.state.tabs.map(renderTitle)
	          )
	        ),
	        _react2.default.createElement(Component, props)
	      );
	    }
	  }]);
	
	  return IntegrationErrorList;
	}(_react.Component);
	
	exports.default = IntegrationErrorList;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _chains = __webpack_require__(127);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DBSLog = function (_Component) {
	  _inherits(DBSLog, _Component);
	
	  function DBSLog(props) {
	    _classCallCheck(this, DBSLog);
	
	    var _this = _possibleConstructorReturn(this, (DBSLog.__proto__ || Object.getPrototypeOf(DBSLog)).call(this, props));
	
	    _this.state = {
	      list: []
	    };
	    _this.renderItem = _this.renderItem.bind(_this);
	    _this.cols = ['1fr', '1fr', '1fr', '1fr'];
	    return _this;
	  }
	
	  _createClass(DBSLog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getDBSLogs();
	    }
	  }, {
	    key: 'getDBSLogs',
	    value: function getDBSLogs() {
	      var _this2 = this;
	
	      this.props.getDBSLogs(this.props.integrationType).then(function (res) {
	        _this2.setState({
	          list: res.data
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	        _this2.props.router.push('/');
	      });
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(item, key) {
	      return _react2.default.createElement(
	        _tableRow2.default,
	        { cols: this.cols },
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _time.renderFullDate)(item.DateTime)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.CompanyName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)(item.ResponseType)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.EstimateNumber
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _tableContainer2.default,
	        null,
	        _react2.default.createElement(
	          _tableRow2.default,
	          { header: true, cols: this.cols },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(388)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(700)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(18166)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(13427)
	          )
	        ),
	        this.state.list.map(this.renderItem)
	      );
	    }
	  }]);
	
	  return DBSLog;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getDBSLogs: _chains.getDBSLogs
	})(DBSLog);

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _chains = __webpack_require__(127);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FORSITokenLog = function (_Component) {
	  _inherits(FORSITokenLog, _Component);
	
	  function FORSITokenLog(props) {
	    _classCallCheck(this, FORSITokenLog);
	
	    var _this = _possibleConstructorReturn(this, (FORSITokenLog.__proto__ || Object.getPrototypeOf(FORSITokenLog)).call(this, props));
	
	    _this.state = {
	      list: []
	    };
	    _this.renderItem = _this.renderItem.bind(_this);
	    _this.cols = ['1fr', '1fr', '1fr', '1fr', '5fr'];
	    return _this;
	  }
	
	  _createClass(FORSITokenLog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getLogs();
	    }
	  }, {
	    key: 'getLogs',
	    value: function getLogs() {
	      var _this2 = this;
	
	      this.props.getForsiTokenLogs().then(function (res) {
	        return _this2.setState({ list: res.data });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	        _this2.props.router.push('/');
	      });
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(item, key) {
	      return _react2.default.createElement(
	        _tableRow2.default,
	        { cols: this.cols },
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _time.renderFullDate)(item.DateTime)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.CompanyName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.OrderId
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.HttpStatusCode || ''
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.ErrorMessage
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _tableContainer2.default,
	        null,
	        _react2.default.createElement(
	          _tableRow2.default,
	          { header: true, cols: this.cols },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(388)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(700)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(15102)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(18164)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(18166)
	          )
	        ),
	        this.state.list.map(this.renderItem)
	      );
	    }
	  }]);
	
	  return FORSITokenLog;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getForsiTokenLogs: _chains.getForsiTokenLogs
	})(FORSITokenLog);

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _chains = __webpack_require__(127);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	__webpack_require__(1401);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HttpIntegrationLog = function (_Component) {
	  _inherits(HttpIntegrationLog, _Component);
	
	  function HttpIntegrationLog(props) {
	    _classCallCheck(this, HttpIntegrationLog);
	
	    var _this = _possibleConstructorReturn(this, (HttpIntegrationLog.__proto__ || Object.getPrototypeOf(HttpIntegrationLog)).call(this, props));
	
	    _this.state = {
	      list: []
	    };
	    _this.renderItem = _this.renderItem.bind(_this);
	    _this.cols = ['136px', '180px', '120px', '116px', '1fr', '1fr'];
	    return _this;
	  }
	
	  _createClass(HttpIntegrationLog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getHttpIntegrationLogs();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.integrationType !== prevProps.integrationType) {
	        this.getHttpIntegrationLogs();
	      }
	    }
	  }, {
	    key: 'getHttpIntegrationLogs',
	    value: function getHttpIntegrationLogs() {
	      var _this2 = this;
	
	      this.props.getHttpIntegrationLogs(this.props.integrationType).then(function (res) {
	        _this2.setState({
	          list: res.data
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	        _this2.props.router.push('/');
	      });
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(item, key) {
	      return _react2.default.createElement(
	        _tableRow2.default,
	        { cols: this.cols },
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _time.renderFullDate)(item.DateTime)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.CompanyName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.UserName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.StatusCode
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.EndPoint
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          item.ErrorMessage
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'integrationlog__screen' },
	        _react2.default.createElement(
	          _tableContainer2.default,
	          null,
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true, cols: this.cols },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(388)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(700)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(450)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(18164)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(18165)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(18166)
	            )
	          ),
	          this.state.list.map(this.renderItem)
	        )
	      );
	    }
	  }]);
	
	  return HttpIntegrationLog;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getHttpIntegrationLogs: _chains.getHttpIntegrationLogs
	})(HttpIntegrationLog);

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(43);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Auth = __webpack_require__(226);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _auth = __webpack_require__(68);
	
	var _language = __webpack_require__(139);
	
	var _common = __webpack_require__(25);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _helpers = __webpack_require__(2);
	
	var _ForgotPasswordModal = __webpack_require__(1086);
	
	var _ForgotPasswordModal2 = _interopRequireDefault(_ForgotPasswordModal);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(1402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Auth wrapper
	
	
	// Actions
	
	
	// Elements
	
	
	// Utils
	
	
	// Components
	
	
	// Redux
	
	
	// import styles
	
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = {
	      UserName: '',
	      Password: '',
	      errors: false,
	      isLoading: false,
	      modal: false,
	      spinnerShow: false
	    };
	
	    _this.toggleForgotPassword = _this.toggleForgotPassword.bind(_this);
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.auth.isAuthenticated) {
	        if (this.props.router !== undefined) {
	          this.props.router.push('/');
	        } else {
	          this.props.this.props.router.push('/'); // this.props.this.props ? copy/paste mistake or hacks? hmm..
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // get resources if missing
	      var common = this.props.common;
	      if (common.phonecodes.length === 0 || common.brands.length === 0 || common.countries.length === 0) {
	        (0, _language.InitLanguage)().then(function (res) {
	          // Set translations
	          _store2.default.dispatch((0, _language.setTranslations)(res.translations));
	          _store2.default.dispatch((0, _language.setLanguages)(res.langs));
	
	          // Set rest
	          _store2.default.dispatch((0, _common.setPhoneCodes)(res.data.PhoneCodes));
	          _store2.default.dispatch((0, _common.setBrands)(res.data.Brands));
	          _store2.default.dispatch((0, _common.setEnums)(res.data.Enums));
	          _store2.default.dispatch((0, _common.setCountries)(res.data.Countries));
	          _store2.default.dispatch((0, _common.setVehicleLookupServices)(res.data.VehicleLookupServices));
	
	          // Set user language
	          if (typeof window.localStorage.user_language !== 'undefined') {
	            _store2.default.dispatch((0, _language.setLanguage)(window.localStorage.user_language));
	          }
	        });
	      }
	    }
	  }, {
	    key: 'loadingSpinner',
	    value: function loadingSpinner() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated-background' },
	        _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'sr-only' },
	          (0, _helpers.translation)('13382'),
	          '...'
	        )
	      );
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      this.setState({ errors: false, isLoading: true });
	      var UserName = this.refs.UserName.value || this.state.UserName;
	      var Password = this.refs.password.value || this.state.Password;
	
	      // Validate input
	      if (UserName === '' || Password === '') {
	        this.setState({ errors: '17', isLoading: false });
	        return;
	      }
	
	      this.props.login({
	        UserName: UserName,
	        Password: Password
	      }).then(function (loginRes) {
	        setTimeout(function () {
	          if (window.sock.readyState === window.sock.OPEN) {
	            window.sock.send(JSON.stringify({
	              Type: 'CONNECTION',
	              ShopId: parseInt(JSON.parse(window.localStorage.user_data).ShopId)
	            }));
	          }
	        }, 3000);
	        // console.log('Login res', res.data)
	
	        // if (res.data.ShopSubscriptionType !== undefined && res.data.ShopSubscriptionType === 1) {
	        //   this.props.router.push('/')
	        // }
	        _this2.props.getAuthResources().then(function (res) {
	          if (res.data.Permissions.ShopSubscriptionValue === 0) {
	            _this2.props.router.push('/');
	          } else {
	            console.log(loginRes.data.UserType);
	            if (loginRes.data.UserType === 8) {
	              _this2.props.router.push('/selectshop');
	            } else if (loginRes.data.UserType === 5) {
	              _this2.props.router.push('/workscreen');
	            } else if (loginRes.data.UserType === 3) {
	              if (loginRes.data.StartScreen !== null) {
	                _this2.props.router.push(loginRes.data.StartScreen);
	              } else {
	                _this2.props.router.push('/workscreen');
	              }
	            } else {
	              _this2.props.router.push('/orders');
	            }
	          }
	        });
	      }, function (err) {
	        if (err.response.status === 401) {
	          _this2.setState({ spinnerShow: true });
	          var delay = err.response.data.Parameters[0];
	          setTimeout(function () {
	            _this2.setState({ errors: '3', isLoading: false, spinnerShow: false, Password: '' });
	          }, delay * 1000);
	
	          _this2.refs.password.value = '';
	        } else {
	          _this2.setState({ errors: 'Network error. Try again later.', isLoading: false });
	        }
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'renderGetStarted',
	    value: function renderGetStarted() {
	      if (window.location.host !== 'web.apromas.com') return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'main__right' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          (0, _helpers.translation)('2143')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Lorem ipsum ...'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          (0, _helpers.translation)('2122'),
	          ' ',
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/signup', className: 'green' },
	            (0, _helpers.translation)('2123')
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/signup', className: 'button' },
	          (0, _helpers.translation)('2120')
	        )
	      );
	    }
	  }, {
	    key: 'toggleForgotPassword',
	    value: function toggleForgotPassword(e) {
	      if (e !== undefined) {
	        e.preventDefault();
	      }
	      this.setState({
	        modal: !this.state.modal
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          errors = _state.errors,
	          isLoading = _state.isLoading,
	          spinnerShow = _state.spinnerShow;
	
	
	      var className = 'spinner-bg ';
	      if (spinnerShow) {
	        className += 'show';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: className },
	          spinnerShow && this.loadingSpinner()
	        ),
	        _react2.default.createElement(
	          _Auth2.default,
	          { router: this.props.router },
	          _react2.default.createElement(
	            'div',
	            { className: 'login__screen' },
	            _react2.default.createElement(
	              'div',
	              { className: 'login__layout' },
	              _react2.default.createElement(
	                _panel2.default,
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'title' },
	                  (0, _helpers.translation)('2124')
	                ),
	                errors && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-danger' },
	                  (0, _helpers.translation)(errors)
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: this.onSubmit },
	                  _react2.default.createElement(_text2.default, { ref: 'UserName', name: 'UserName', onChange: this.onChange, labelText: (0, _helpers.translation)('1'), autoComplete: 'off' }),
	                  _react2.default.createElement(_text2.default, { ref: 'password', isPassword: true, name: 'Password', onChange: this.onChange, labelText: (0, _helpers.translation)('2'), autoComplete: 'off' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'links clearfix' },
	                    _react2.default.createElement(_button2.default, { disabled: isLoading, labelText: (0, _helpers.translation)('13355'), onClick: this.onSubmit }),
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/activate/' },
	                      (0, _helpers.translation)('16388')
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { href: '', onClick: this.toggleForgotPassword },
	                      (0, _helpers.translation)('2144')
	                    )
	                  )
	                ),
	                this.renderGetStarted()
	              )
	            ),
	            _react2.default.createElement(_ForgotPasswordModal2.default, { show: this.state.modal, onClose: this.toggleForgotPassword.bind(this) })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	Login.propTypes = {
	  auth: _propTypes2.default.object.isRequired,
	  login: _propTypes2.default.func.isRequired,
	  setLanguage: _propTypes2.default.func.isRequired,
	  setNextLanguage: _propTypes2.default.func.isRequired,
	  getAuthResources: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { login: _auth.login, setLanguage: _language.setLanguage, setNextLanguage: _language.setNextLanguage, getAuthResources: _auth.getAuthResources })(Login);

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _chains = __webpack_require__(127);
	
	var _helpers = __webpack_require__(2);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	__webpack_require__(1403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	
	// Styles
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'edit',
	      manager: {
	        UserId: 0,
	        ChainId: _this.props.chainID,
	        Name: '',
	        Phone: '',
	        UserName: '',
	        PhoneCode: {
	          Id: Number(12)
	        },
	        Active: true
	      }
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.saveManager = _this.saveManager.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAdminChain(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.getAdminChain(nextProps);
	    }
	  }, {
	    key: 'getAdminChain',
	    value: function getAdminChain(props) {
	      var _this2 = this;
	
	      if (typeof props.item.UserId !== 'undefined') {
	        props.getAdminChain(props.item.UserId).then(function (res) {
	          _this2.setState({
	            type: 'edit',
	            manager: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        manager: {
	          UserId: 0,
	          ChainId: this.props.chainID,
	          Name: '',
	          Phone: '',
	          UserName: '',
	          PhoneCode: {
	            Id: Number(12)
	          },
	          Active: true
	        }
	      });
	    }
	  }, {
	    key: 'saveManager',
	    value: function saveManager(e) {
	      var _this3 = this;
	
	      if (this.state.manager.UserId > 0) {
	        var manager = _extends({}, this.state.manager);
	        // update
	        this.props.createSaveAdminChain(manager).then(function (res) {
	          _this3.props.onSave(res.data, _this3.state.type);
	          _this3.setState({
	            manager: res.data
	          });
	        }, function (err) {
	          if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	            var errors = err.response.data.Errors;
	            var errText = '';
	            errors.map(function (item) {
	              if (item.DictionaryKey !== 0) {
	                errText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	              }
	            });
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          } else {
	            var errorMessage = function errorMessage(error) {
	              var messageText = '';
	              if (error < 5) {
	                messageText += (0, _helpers.translation)('2001');
	              }
	              if (messageText !== '') messageText += ' ';
	              switch (error) {
	                case 1:
	                  messageText += (0, _helpers.translation)('16329');
	                  break;
	                case 2:
	                  messageText += (0, _helpers.translation)('16336');
	                  break;
	                case 3:
	                  messageText += (0, _helpers.translation)('16335');
	                  break;
	                case 4:
	                  messageText += (0, _helpers.translation)('16338');
	                  break;
	                case 5:
	                  messageText += (0, _helpers.translation)('16337');
	                  break;
	                default:
	                  break;
	              }
	              messageText += '<br>';
	              return messageText;
	            };
	            var _errors = err.response.data;
	            if (Array.isArray(_errors)) {
	              var message = _errors.map(function (error) {
	                return errorMessage(error);
	              });
	              window.toastr.error(message, (0, _helpers.translation)('216'));
	            } else {
	              window.toastr.error((0, _helpers.translation)('17949'), (0, _helpers.translation)('216'));
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(name, e) {
	      var _this4 = this;
	
	      var value = '';
	      if (typeof e === 'undefined') {
	        e = name;
	      }
	      e.persist();
	      name = e.target.name;
	      value = e.target.value;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      this.setState({
	        manager: _extends({}, this.state.manager, _defineProperty({}, name, value))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this4.saveManager(e);
	        }
	      });
	    }
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(name, e) {
	      var _this5 = this;
	
	      var value = '';
	      value = name.target.value;
	      if (name.target.name === 'PhoneNumber') {
	        name = 'Phone';
	        this.setState({
	          manager: _extends({}, this.state.manager, _defineProperty({}, name, value))
	        });
	      } else {
	        this.setState({
	          manager: _extends({}, this.state.manager, {
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        }, function () {
	          _this5.saveManager();
	        });
	      }
	    }
	  }, {
	    key: 'renderUser',
	    value: function renderUser() {
	      var manager = this.state.manager;
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1881') },
	        _react2.default.createElement(_text2.default, { name: 'Name', value: manager.Name || '', onChange: this.onInputChange, onBlur: this.saveManager, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_text2.default, { name: 'UserName', value: manager.UserName || '', onChange: this.onInputChange, onBlur: this.saveManager, labelText: (0, _helpers.translation)('1') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('38') },
	          _react2.default.createElement(_Phone2.default, {
	            onChange: this.onPhoneChange,
	            onBlur: this.saveManager,
	            code: manager.PhoneCode,
	            number: manager.Phone })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'Email', value: manager.Email || '', onChange: this.onInputChange, onBlur: this.saveManager, labelText: (0, _helpers.translation)('1052') }),
	        _react2.default.createElement(_switch2.default, { name: 'Active', value: 'yes', onChange: this.onInputChange, checked: manager.Active, labelText: (0, _helpers.translation)('295') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        this.renderUser()
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getAdminChain: _chains.getAdminChain,
	  createSaveAdminChain: _chains.createSaveAdminChain
	}, null, { withRef: true })(View);

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _chains = __webpack_require__(127);
	
	__webpack_require__(1404);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _CreateUser = __webpack_require__(197);
	
	var _CreateUser2 = _interopRequireDefault(_CreateUser);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _View = __webpack_require__(868);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	
	// Elements
	
	
	// Utils
	
	
	// Views
	
	
	var Managers = function (_Component) {
	  _inherits(Managers, _Component);
	
	  function Managers(props) {
	    _classCallCheck(this, Managers);
	
	    var _this = _possibleConstructorReturn(this, (Managers.__proto__ || Object.getPrototypeOf(Managers)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      managers: [],
	      activeItem: {},
	      includeNonVerified: false
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Managers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getManagers();
	      if (typeof this.props.params.managerID !== 'undefined') {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            UserId: this.props.params.managerID
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getManagers',
	    value: function getManagers() {
	      var _this2 = this;
	
	      var chainId = (0, _auth.hasAccess)([1], this.props.auth.user.UserType) ? this.props.params.chainID : this.props.auth.user.ChainId;
	      this.props.getAdminChains(Number(chainId)).then(function (res) {
	        _this2.setState({
	          managers: res.data
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('2046'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.create.getWrappedInstance().createUser();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return [_react2.default.createElement(
	        'div',
	        { key: 'confirmedfilter', className: 'filter' },
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { isFixed: true },
	          _react2.default.createElement(_check2.default, {
	            name: 'NonVerified',
	            checked: this.state.includeNonVerified,
	            onChange: function onChange() {
	              _this3.setState({ includeNonVerified: !_this3.state.includeNonVerified });
	            },
	            labelText: (0, _helpers.translation)('16320'),
	            spacing: 0
	          })
	        )
	      )].concat(_toConsumableArray(this.state.managers.map(function (m) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: m.Name,
	          onClick: function onClick() {
	            return _this3.onSelectItem(m);
	          },
	          selected: m.UserId === _this3.state.activeItem.UserId,
	          inactive: !m.Active,
	          confirmed: m.Confirmed,
	          key: m.UserId
	        });
	      })));
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var managers = [].concat(_toConsumableArray(this.state.managers));
	      var activeItem = void 0;
	      if (type === 'create') {
	        managers.push({
	          UserId: data.UserId,
	          Name: data.Name,
	          Active: data.Active,
	          Email: data.Email,
	          Confirmed: false
	        });
	        type = 'item';
	        activeItem = {
	          UserId: data.UserId,
	          Confirmed: false
	        };
	      } else {
	        managers.map(function (val, key) {
	          if (val.UserId === data.UserId) {
	            val.Name = data.Name;
	            val.Active = data.Active;
	          }
	        });
	        type = 'item';
	        if (data.Confirmed) {
	          activeItem = {
	            UserId: data.UserId,
	            Confirmed: true
	          };
	        } else {
	          activeItem = {
	            UserId: data.UserId,
	            Name: data.Name,
	            Email: data.Email,
	            Confirmed: data.Confirmed,
	            ChainId: data.ChainId
	          };
	        }
	      }
	      this.setState({
	        managers: managers,
	        view: type,
	        activeItem: activeItem
	      });
	      // Toastr
	      // window.toastr.success(translation('13464'), translation('1884'))
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this4 = this;
	
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	          return _react2.default.createElement(_CreateUser2.default, { isChainAdmin: true, ref: 'create', title: (0, _helpers.translation)('2046'), chainID: (0, _auth.hasAccess)([1], this.props.auth.user.UserType) ? Number(this.props.params.chainID) : Number(this.props.auth.user.ChainId), user: undefined, onSuccess: function onSuccess(res) {
	              return _this4.onSave(res, 'create');
	            } });
	        case 'item':
	          if (this.state.activeItem.Confirmed !== true) return _react2.default.createElement(_CreateUser2.default, { isChainAdmin: true, user: this.state.activeItem, title: (0, _helpers.translation)('2046'), onSuccess: function onSuccess(res) {
	              return _this4.onSave(res, 'item');
	            } });
	          return _react2.default.createElement(_View2.default, { ref: 'view', item: this.state.activeItem, onSave: this.onSave, chainID: (0, _auth.hasAccess)([1], this.props.auth.user.UserType) ? Number(this.props.params.chainID) : Number(this.props.auth.user.ChainId) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var customFilter = function customFilter(item, showInactive) {
	        // Include any items not confirmed if using this filter
	        if (_this5.state.includeNonVerified && !item.confirmed) {
	          return true;
	        }
	        if (showInactive) {
	          // Exclude unconfirmed
	          return item.confirmed;
	        }
	        return !item.inactive;
	      };
	
	      var header = (0, _auth.hasAccess)([1], this.props.auth.user.UserType) && this.state.view !== 'create' ? _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: function renderRight() {
	          return _this5.headerButtonsRight();
	        }, showBack: true }) : _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: function renderRight() {
	          return _this5.headerButtonsRight();
	        } });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'customers__screen' },
	        header,
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create', customFilter: customFilter },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'customers__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Managers;
	}(_react.Component);
	
	Managers.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getAdminChains: _chains.getAdminChains })(Managers);

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _async = __webpack_require__(147);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(5);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _messages = __webpack_require__(280);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _backButton = __webpack_require__(235);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	__webpack_require__(515);
	
	__webpack_require__(1405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import components
	
	
	// import components
	
	
	// Actions
	
	
	// Utils
	
	// import { renderFullDate } from '../../../utils/time'
	
	
	// Elements
	
	// import Row from '../../../shared/elements/row'
	
	
	// import styles
	
	
	var Single = function (_Component) {
	  _inherits(Single, _Component);
	
	  function Single(props) {
	    _classCallCheck(this, Single);
	
	    var _this = _possibleConstructorReturn(this, (Single.__proto__ || Object.getPrototypeOf(Single)).call(this, props));
	
	    _this.state = {
	      View: 'List',
	      CheckAll: false,
	      message: {
	        Id: Number(_this.props.params.messagesID),
	        Type: 0,
	        Title: '',
	        Subtitle: '',
	        Body: '',
	        CreationDate: '',
	        StartDate: (0, _moment2.default)(),
	        DeletedDate: null,
	        ExpireDate: (0, _moment2.default)().add(1, 'd'),
	        CompanyId: Number(_this.props.auth.user.ShopId),
	        SenderId: 0,
	        IsSent: false,
	        MessageUsers: [],
	        MessageCompanies: [],
	        MessageTargets: [],
	        MessageFiles: [],
	        MessageIllustration: null,
	        MessageDocument: null
	      },
	      upload: {
	        loading: false,
	        errors: []
	      },
	      illustrationUpload: {
	        loading: false,
	        errors: []
	      },
	      documentUpload: {
	        loading: false,
	        errors: []
	      },
	      employees: [],
	      companies: [],
	      targets: {},
	      MessageFiles: [],
	      confirmFileDelete: {
	        confirm: false,
	        file: null
	      }
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onCheckAll = _this.onCheckAll.bind(_this);
	    _this.onCheck = _this.onCheck.bind(_this);
	    _this.onCheckTarget = _this.onCheckTarget.bind(_this);
	    _this.updateMessage = _this.updateMessage.bind(_this);
	    _this.onChangeStartDate = _this.onChangeStartDate.bind(_this);
	    _this.onChangeExpireDate = _this.onChangeExpireDate.bind(_this);
	    _this.deleteConfirmation = _this.deleteConfirmation.bind(_this);
	    _this.deleteFile = _this.deleteFile.bind(_this);
	    _this.renderFile = _this.renderFile.bind(_this);
	    _this.renderImage = _this.renderImage.bind(_this);
	    _this.renderSaveButton = _this.renderSaveButton.bind(_this);
	    return _this;
	  }
	
	  _createClass(Single, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // get message
	      if (this.props.params.messagesID > 0) {
	        this.getMessageById(this.props.params.messagesID);
	      }
	    }
	  }, {
	    key: 'updateMessage',
	    value: function updateMessage(e, goThrough) {
	      var _this2 = this;
	
	      if (this.state.message.Id === 0 && typeof goThrough === 'undefined') return null;
	      // check input
	      // console.log('UpdateMessage', this.state.message)
	      if (this.state.message.Title.length > 0 // &&
	      // this.state.message.StartDate !== '' &&
	      // this.state.message.ExpireDate !== '' &&
	      // (this.state.message.MessageCompanies.length > 0 || this.state.message.MessageUsers)
	      ) {
	          // convert dates
	          var formatDate = function formatDate(date) {
	            if (!date) return '1990-01-01T00:00:00';
	            if (typeof date.format === 'function') {
	              return date.format('YYYY-MM-DDTHH:mm:ss');
	            }
	            return date;
	          };
	
	          var message = _extends({}, this.state.message);
	          message.StartDate = formatDate(message.StartDate);
	          message.ExpireDate = formatDate(message.ExpireDate);
	
	          // add company
	          if (this.props.auth.user.UserType === 3 && message.MessageCompanies.length === 0) {
	            message.MessageCompanies = [{ CompanyId: Number(this.props.auth.user.ShopId) }];
	          }
	          // Images
	          if (this.state.MessageFiles.length !== 0) {
	            message.MessageFiles = message.MessageFiles.concat(this.state.MessageFiles);
	          }
	          // update / add message
	          this.props.createUpdateMessage(message).then(function (res) {
	            // Toastr
	            // window.toastr.success(translation('1826'), translation('13424'))
	            _this2.setState({
	              message: res.data,
	              MessageFiles: []
	            }, function () {
	              if (message.Id === 0) {
	                _this2.props.router.replace('/messages/' + res.data.Id);
	              }
	            });
	          }, function (err) {
	            // Toastr
	            if (err.response !== undefined && err.response.data !== undefined) {
	              console.log('err', err);
	              window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	            } else {
	              window.toastr.error((0, _helpers.translation)('1827'), (0, _helpers.translation)('216'));
	            }
	          });
	        } else {
	        if (this.state.message.Title.length < 1) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13009'), (0, _helpers.translation)('216'));
	        }
	        // if (this.state.message.MessageUsers.length < 1) {
	        //   window.toastr.error(translation('1026'), translation('216'))
	        // }
	      }
	    }
	  }, {
	    key: 'getMessageById',
	    value: function getMessageById(id) {
	      var _this3 = this;
	
	      this.props.getMessage(id).then(function (res) {
	        // Target
	        var lengthTarget = res.data.MessageTargets.length;
	        var rowStateTarget = {};
	        for (var i = 0; i < lengthTarget; i++) {
	          rowStateTarget[res.data.MessageTargets[i].Target] = true;
	        }
	        // Companies
	        var lengthCom = res.data.MessageCompanies.length;
	        var rowStateCom = [];
	        for (var x = 0; x < lengthCom; x++) {
	          rowStateCom[res.data.MessageCompanies[x].CompanyId] = true;
	        }
	        // Employees
	        var lengthEm = res.data.MessageUsers.length;
	        var rowStateEm = [];
	        for (var y = 0; y < lengthEm; y++) {
	          rowStateEm[res.data.MessageUsers[y].UserId] = true;
	        }
	        _this3.setState({
	          message: res.data,
	          targets: rowStateTarget,
	          companies: rowStateCom,
	          employees: rowStateEm
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(_ref) {
	      var _ref$target = _ref.target,
	          name = _ref$target.name,
	          value = _ref$target.value;
	
	      var val = value;
	
	      if (name === 'Type') {
	        var _extends2;
	
	        val = parseInt(value, 10);
	
	        this.setState({
	          message: _extends({}, this.state.message, (_extends2 = {}, _defineProperty(_extends2, name, val), _defineProperty(_extends2, 'MessageTargets', []), _extends2)),
	          targets: {}
	        }, this.updateMessage);
	      }
	
	      this.setState({
	        message: _extends({}, this.state.message, _defineProperty({}, name, val))
	      });
	    }
	  }, {
	    key: 'onCheckTarget',
	    value: function onCheckTarget(_ref2) {
	      var _ref2$target = _ref2.target,
	          value = _ref2$target.value,
	          checked = _ref2$target.checked;
	
	      this.setState({
	        targets: _extends({}, this.state.targets, _defineProperty({}, value, checked))
	      });
	
	      if (checked) {
	        var msgTarget = {
	          Target: Number(value),
	          MessageId: Number(this.state.message.Id)
	        };
	        this.state.message.MessageTargets.push(msgTarget);
	        this.setState({
	          message: _extends({}, this.state.message, {
	            MessageTargets: [].concat(_toConsumableArray(this.state.message.MessageTargets))
	          })
	        }, this.updateMessage);
	      } else {
	        var msgTargets = this.state.message.MessageTargets;
	        this.state.message.MessageTargets = msgTargets.filter(function (mt) {
	          return mt.Target !== Number(value);
	        });
	        this.setState({
	          message: _extends({}, this.state.message, {
	            MessageTargets: [].concat(_toConsumableArray(this.state.message.MessageTargets)) })
	        }, this.updateMessage);
	      }
	    }
	  }, {
	    key: 'onCheckAll',
	    value: function onCheckAll(_ref3) {
	      var checked = _ref3.target.checked;
	
	      this.setState({ CheckAll: checked });
	
	      if (this.props.auth.user.UserType === 2) {
	        // map companies
	        var CheckAllCompanies = [];
	        var CheckAllMessageCompanies = [];
	        this.props.companies.map(function (comp) {
	          CheckAllCompanies[comp.ShopId] = checked;
	          if (checked) {
	            var CheckAllMessageCompaniesValue = {
	              MessageId: 0,
	              CompanyID: comp.ShopId
	            };
	            CheckAllMessageCompanies.push(CheckAllMessageCompaniesValue);
	          } else {
	            CheckAllMessageCompanies = [];
	          }
	        });
	        this.setState({
	          companies: CheckAllCompanies,
	          message: _extends({}, this.state.message, {
	            MessageCompanies: CheckAllMessageCompanies
	          })
	        }, this.updateMessage);
	      } else if (this.props.auth.user.UserType === 3) {
	        // map employees
	        var CheckAllEmployees = [];
	        var CheckAllMessageEmployees = [];
	        this.props.employees.map(function (emp) {
	          CheckAllEmployees[emp.UserId] = checked;
	          if (checked) {
	            var CheckAllMessageEmployeesValue = {
	              IsRead: false,
	              MessageId: 0,
	              UserId: emp.UserId
	            };
	            CheckAllMessageEmployees.push(CheckAllMessageEmployeesValue);
	          } else {
	            CheckAllMessageEmployees = [];
	          }
	        });
	        this.setState({
	          employees: CheckAllEmployees,
	          message: _extends({}, this.state.message, {
	            MessageUsers: CheckAllMessageEmployees
	          })
	        }, this.updateMessage);
	      }
	    }
	  }, {
	    key: 'onCheck',
	    value: function onCheck(_ref4) {
	      var _this4 = this;
	
	      var _ref4$target = _ref4.target,
	          value = _ref4$target.value,
	          checked = _ref4$target.checked,
	          id = _ref4$target.id;
	
	      // Chain
	      if (this.props.auth.user.UserType === 2) {
	        this.setState({
	          companies: _extends({}, this.state.companies, _defineProperty({}, value, checked))
	        });
	        if (checked) {
	          var msgComp = {
	            CompanyId: Number(id),
	            IsRead: false,
	            MessageId: Number(this.state.message.Id)
	          };
	          this.state.message.MessageCompanies.push(msgComp);
	          this.setState({
	            message: _extends({}, this.state.message, {
	              MessageCompanies: [].concat(_toConsumableArray(this.state.message.MessageCompanies))
	            })
	          }, function () {
	            _this4.updateMessage();
	            _this4.setState({ CheckAll: checkAll() });
	          });
	        } else {
	          var msgComps = this.state.message.MessageCompanies;
	          this.state.message.MessageCompanies = msgComps.filter(function (mc) {
	            return mc.CompanyId !== Number(id);
	          });
	          this.setState({
	            message: _extends({}, this.state.message, {
	              MessageCompanies: [].concat(_toConsumableArray(this.state.message.MessageCompanies))
	            })
	          }, function () {
	            _this4.updateMessage();
	            _this4.setState({ CheckAll: checkAll() });
	          });
	        }
	      } else {
	        // Company
	        this.setState({
	          employees: _extends({}, this.state.employees, _defineProperty({}, value, checked))
	        });
	        if (checked) {
	          var msgUser = {
	            UserId: Number(id),
	            IsRead: false,
	            MessageId: Number(this.state.message.Id)
	          };
	          this.state.message.MessageUsers.push(msgUser);
	          this.setState({
	            message: _extends({}, this.state.message, {
	              MessageUsers: [].concat(_toConsumableArray(this.state.message.MessageUsers))
	            })
	          }, function () {
	            _this4.updateMessage();
	            _this4.setState({ CheckAll: checkAll() });
	          });
	        } else {
	          var msgUsers = this.state.message.MessageUsers;
	          this.state.message.MessageUsers = msgUsers.filter(function (mu) {
	            return mu.UserId !== Number(id);
	          });
	          this.setState({
	            message: _extends({}, this.state.message, {
	              MessageUsers: [].concat(_toConsumableArray(this.state.message.MessageUsers))
	            })
	          }, function () {
	            _this4.updateMessage();
	            _this4.setState({ CheckAll: checkAll() });
	          });
	        }
	      }
	      var checkAll = function checkAll() {
	        // Is all checked?
	        var allChecked = true;
	        if (_this4.props.auth.user.UserType === 2) {
	          var companies = _this4.state.companies;
	          for (var i = 0; i < _this4.props.companies.length; i++) {
	            var comp = _this4.props.companies[i];
	            if (companies[comp.CompanyId] !== true) {
	              allChecked = false;
	              break;
	            }
	          }
	        } else {
	          var employees = _this4.state.employees;
	          for (var _i = 0; _i < _this4.props.employees.length; _i++) {
	            var emp = _this4.props.employees[_i];
	            if (employees[emp.UserId] !== true) {
	              allChecked = false;
	              break;
	            }
	          }
	        }
	        return allChecked;
	      };
	    }
	  }, {
	    key: 'messageCheckboxExtra',
	    value: function messageCheckboxExtra() {
	      var _this5 = this;
	
	      var isNews = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.props.auth.user.UserType === 2) {
	        var renderRole = function renderRole(name, value, label, disabled) {
	          return _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)(label), id: name, value: value, name: name, checked: _this5.state.targets[value], onChange: _this5.onCheckTarget, disabled: disabled });
	        };
	
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('2707') },
	          renderRole('admin', 1, '61', isNews),
	          renderRole('leader', 2, '646', isNews),
	          renderRole('employee', 3, '64', isNews),
	          renderRole('driver', 4, '647', isNews),
	          isNews && _react2.default.createElement(_divider2.default, null),
	          isNews && renderRole('customerContacts', 5, '15288')
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderRecipientList',
	    value: function renderRecipientList() {
	      var _this6 = this;
	
	      var employeesList = function employeesList(emp, key) {
	        if (!emp.Active) return null;
	        var checked = typeof _this6.state.employees[emp.UserId] !== 'undefined' && _this6.state.employees[emp.UserId];
	        return _react2.default.createElement(_check2.default, { key: key, labelText: emp.Name, id: emp.UserId, value: emp.UserId, name: key, checked: checked, onChange: _this6.onCheck });
	      };
	      var companiesList = function companiesList(comp, key) {
	        var checked = typeof _this6.state.companies[comp.ShopId] !== 'undefined' && _this6.state.companies[comp.ShopId];
	        return _react2.default.createElement(_check2.default, { key: key, labelText: comp.ShopName, id: comp.ShopId, value: comp.ShopId, name: key, checked: checked, onChange: _this6.onCheck });
	      };
	      var headline = function headline() {
	        if (_this6.props.auth.user.UserType === 2) {
	          return (0, _helpers.translation)('4');
	        } else {
	          return (0, _helpers.translation)('10');
	        }
	      };
	      var checkList = function checkList() {
	        if (_this6.props.auth.user.UserType === 2) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _this6.props.companies.map(companiesList)
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _this6.props.employees.map(employeesList)
	          );
	        }
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: headline() },
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('531'), id: 'all', onChange: this.onCheckAll, checked: this.state.CheckAll }),
	        checkList()
	      );
	    }
	  }, {
	    key: 'deleteConfirmation',
	    value: function deleteConfirmation(file) {
	      this.setState({
	        confirmFileDelete: {
	          confirm: true,
	          file: file
	        }
	      });
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile(_ref5) {
	      var _this7 = this;
	
	      var OrderFileID = _ref5.OrderFileID,
	          FileName = _ref5.FileName;
	
	      var newErrors = [];
	
	      this.props.fileDelete({ ItemId: OrderFileID }).then(function () {
	        // Delete from database
	        var MessageFiles = [].concat(_toConsumableArray(_this7.state.message.MessageFiles));
	        MessageFiles = MessageFiles.filter(function (mf) {
	          return mf.OrderFileID !== Number(OrderFileID);
	        });
	
	        _this7.setState({
	          message: _extends({}, _this7.state.message, {
	            MessageFiles: MessageFiles
	          })
	        }, _this7.updateMessage);
	      }, function () {
	        newErrors.push((0, _helpers.translation)('1207') + ': ' + FileName);
	        _this7.setState({
	          upload: _extends({}, _this7.state.upload, { errors: newErrors })
	        });
	      });
	    }
	  }, {
	    key: 'renderFile',
	    value: function renderFile(file, index) {
	      var _this8 = this;
	
	      var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token);
	      var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileNameWithFolders;
	      return _react2.default.createElement(
	        _inline2.default,
	        { key: index, block: true },
	        _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	        _react2.default.createElement(
	          'a',
	          { target: '_BLANK', href: newFileUrl },
	          file.FileName
	        ),
	        this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(_removeButton2.default, { size: 's', bin: true, onClick: function onClick() {
	            return _this8.deleteConfirmation(file);
	          } })
	      );
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(image, index) {
	      var _this9 = this;
	
	      var url = _constants.FILE_STORAGE + image.ThumbURL;
	      var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	      return _react2.default.createElement(
	        'div',
	        { className: 'image-div', key: index },
	        _react2.default.createElement(
	          'a',
	          { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	          _react2.default.createElement('img', { src: url })
	        ),
	        this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(_removeButton2.default, { size: 's', onClick: function onClick() {
	            return _this9.deleteConfirmation(image);
	          } })
	      );
	    }
	  }, {
	    key: 'renderFiles',
	    value: function renderFiles() {
	      var _this10 = this;
	
	      var errors = this.state.upload.errors;
	
	      // On drop
	
	      var onDrop = function onDrop() {
	        _this10.setState({ upload: _extends({}, _this10.state.upload, {
	            errors: []
	          }) });
	      };
	      // On drop accepted
	      var onDropAccepted = function onDropAccepted(files) {
	        var newErrors = [];
	        var MessageFiles = [];
	        _this10.setState({
	          upload: _extends({}, _this10.state.upload, {
	            loading: true
	          })
	        });
	        _async2.default.each(files, function (file, cb) {
	          // Upload each file
	          _this10.props.fileUpload(file).then(function (_ref6) {
	            var data = _ref6.data;
	
	            MessageFiles.push({
	              FileName: data[0].FileName,
	              FileURL: data[0].RealFileURL,
	              ThumbURL: data[0].RealThumbURL,
	              Description: '',
	              CreationDate: file.lastModifiedDate,
	              OrderFileID: data[0].OrderFileID,
	              IsImage: data[0].IsImage
	            });
	            cb();
	          }, function () {
	            newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13406') + '.');
	            cb();
	          });
	        }, function () {
	          if (newErrors.length !== 0) {
	            _this10.setState({
	              upload: _extends({}, _this10.state.upload, {
	                errors: _this10.state.upload.errors.concat(newErrors)
	              }),
	              MessageFiles: []
	            }, _this10.updateMessage);
	          } else {
	            var message = _extends({}, _this10.state.message);
	            message.MessageFiles = message.MessageFiles.concat(MessageFiles);
	            _this10.setState({
	              message: message,
	              upload: _extends({}, _this10.state.upload, {
	                loading: false
	              }),
	              MessageFiles: [] // MessageFiles
	            }, _this10.updateMessage);
	          }
	        });
	      };
	      // On drop rejected
	      var onDropRejected = function onDropRejected(files) {
	        var newErrors = [];
	        files.map(function (file) {
	          newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13405') + '.');
	        });
	        _this10.setState({ upload: _extends({}, _this10.state.upload, { errors: newErrors }) });
	      };
	      // Render error
	      var renderError = function renderError(error, index) {
	        return _react2.default.createElement(
	          'p',
	          { key: index },
	          error
	        );
	      };
	
	      // // imgFiles
	      // let imgFiles = [...this.state.message.MessageFiles].filter(file => file.IsImage)
	      // // Doc files
	      // let docFiles = [...this.state.message.MessageFiles].filter(file => !file.IsImage)
	      var imgFiles = [];
	      var docFiles = [];
	      this.state.message.MessageFiles.forEach(function (file) {
	        return file.IsImage ? imgFiles.push(file) : docFiles.push(file);
	      });
	
	      var multiple = true;
	      // Render
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('1043') },
	        errors.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          errors.map(renderError)
	        ),
	        _react2.default.createElement(
	          _Dropzone2.default,
	          {
	            onDrop: onDrop,
	            onDropAccepted: onDropAccepted,
	            onDropRejected: onDropRejected,
	            multiple: multiple,
	            includeCircles: false },
	          this.state.upload.loading && _react2.default.createElement(
	            'p',
	            { className: 'loading' },
	            _react2.default.createElement(
	              'span',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            )
	          ),
	          !this.state.upload.loading && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)('13397')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'gallery' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'files_inner' },
	              docFiles.map(this.renderFile)
	            )
	          ),
	          _react2.default.createElement(_Gallery2.default, { files: imgFiles, renderImage: this.renderImage })
	        )
	      );
	    }
	  }, {
	    key: 'renderIllustration',
	    value: function renderIllustration() {
	      var _this11 = this;
	
	      var renderDropzone = function renderDropzone() {
	        var isIllustration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var uploadName = void 0;
	        var upload = void 0;
	        var type = void 0;
	        if (isIllustration) {
	          uploadName = 'illustrationUpload';
	          upload = _this11.state.illustrationUpload;
	          type = 17;
	        } else {
	          uploadName = 'documentUpload';
	          upload = _this11.state.documentUpload;
	          type = 18;
	        }
	
	        var onDrop = function onDrop() {
	          return _this11.setState(_defineProperty({}, uploadName, { errors: [] }));
	        };
	        var onDropAccepted = function onDropAccepted(files) {
	          var newErrors = [];
	          var newFiles = [];
	          _this11.setState(_defineProperty({}, uploadName, _extends({}, _this11.state[uploadName], {
	            loading: true
	          })));
	          _async2.default.each(files, function (file, cb) {
	            // Upload each file
	            _this11.props.fileUpload(file, type).then(function (_ref7) {
	              var data = _ref7.data;
	
	              newFiles.push({
	                FileName: data[0].FileName,
	                FileURL: data[0].RealFileURL,
	                ThumbURL: data[0].RealThumbURL,
	                Description: '',
	                CreationDate: file.lastModifiedDate,
	                OrderFileID: data[0].OrderFileID,
	                IsImage: data[0].IsImage
	              });
	              cb();
	            }, function (err) {
	              window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	              newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13406') + '.');
	              cb();
	            });
	          }, function () {
	            if (newErrors.length !== 0) {
	              var _this11$setState3;
	
	              _this11.setState((_this11$setState3 = {}, _defineProperty(_this11$setState3, uploadName, _extends({}, _this11.state[uploadName], {
	                errors: _this11.state[uploadName].errors.concat(newErrors),
	                loading: false
	              })), _defineProperty(_this11$setState3, 'MessageFiles', []), _this11$setState3), _this11.updateMessage);
	            } else {
	              var _this11$setState4;
	
	              var message = _extends({}, _this11.state.message);
	              // message.MessageFiles = message.MessageFiles.concat(newFiles)
	
	              if (isIllustration) {
	                message.MessageIllustration = newFiles[0];
	              } else {
	                message.MessageDocument = newFiles[0];
	              }
	
	              _this11.setState((_this11$setState4 = {
	                message: message
	              }, _defineProperty(_this11$setState4, uploadName, _extends({}, _this11.state[uploadName], {
	                loading: false
	              })), _defineProperty(_this11$setState4, 'MessageFiles', []), _this11$setState4), _this11.updateMessage);
	            }
	          });
	        };
	        var onDropRejected = function onDropRejected(files) {
	          var errors = files.map(function (file) {
	            return (0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13405') + '.';
	          });
	
	          _this11.setState({
	            illustrationUpload: {
	              errors: errors
	            }
	          });
	        };
	
	        var renderDropzoneContent = function renderDropzoneContent() {
	          var isLoading = upload.loading;
	
	          if (isLoading) {
	            return _react2.default.createElement(
	              'p',
	              { className: 'loading' },
	              _react2.default.createElement(
	                'span',
	                { className: 'animated-background' },
	                _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'sr-only' },
	                  (0, _helpers.translation)('13382'),
	                  '...'
	                )
	              )
	            );
	          }
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)('13397')
	            )
	          );
	        };
	
	        var title = isIllustration ? '15285' : '15286';
	        var msgDocument = _this11.state.message.MessageDocument ? [_this11.state.message.MessageDocument] : [];
	        var msgIllustration = _this11.state.message.MessageIllustration ? [_this11.state.message.MessageIllustration] : [];
	
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)(title) },
	          _react2.default.createElement(
	            _Dropzone2.default,
	            {
	              onDrop: onDrop,
	              onDropAccepted: onDropAccepted,
	              onDropRejected: onDropRejected,
	              multiple: false,
	              includeCircles: false
	            },
	            renderDropzoneContent()
	          ),
	          !isIllustration && _react2.default.createElement(
	            'div',
	            { className: 'gallery' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'files_inner' },
	              msgDocument.map(_this11.renderFile)
	            )
	          ),
	          isIllustration && _react2.default.createElement(_Gallery2.default, { files: msgIllustration, renderImage: _this11.renderImage })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderDropzone(true),
	        renderDropzone(false)
	      );
	    }
	  }, {
	    key: 'renderStartDate',
	    value: function renderStartDate() {
	      var _this12 = this;
	
	      var StartDate = this.state.message.StartDate;
	
	      var times = [];
	      for (var h = 0; h < 24; h++) {
	        var hour = h < 10 ? '0' + h : h.toString();
	        times.push(hour + ':00');
	        times.push(hour + ':30');
	      }
	      // Time string
	      var timeString = times ? times[0] : '';
	      // Date
	      var date = StartDate ? window.CustomDate(StartDate) : '';
	
	      if (date !== '') {
	        // Hours + pad zero
	        var hours = date.getHours();
	        // Minutes + pad zero
	        var minutes = date.getMinutes();
	        if (minutes === 0) {
	          minutes = '00';
	        } else if (minutes <= 30) {
	          minutes = '30';
	        } else {
	          minutes = '00';
	          hours = '00'.substring(0, 2 - hours.length) + (hours + 1);
	        }
	
	        if (typeof hours !== 'string') {
	          var end = hours > 9 ? 2 : 1;
	          hours = '00'.substring(0, 2 - end) + hours;
	        }
	
	        // Set time
	        timeString = hours + ':' + minutes;
	      }
	      // Actions
	      var onChangeTime = function onChangeTime(_ref8) {
	        var value = _ref8.target.value;
	
	        var splitted = value.split(':');
	        var dateVal = StartDate !== null ? window.CustomDate(StartDate) : window.CustomDate();
	        var momentDate = (0, _moment2.default)(dateVal);
	        momentDate.set({ hour: splitted[0], minute: splitted[1], second: 0, millisecond: 0 });
	        _this12.setState({
	          message: _extends({}, _this12.state.message, {
	            StartDate: momentDate
	          })
	        }, _this12.updateMessage);
	      };
	
	      var inputProps = {
	        name: 'startDate',
	        readOnly: true
	      };
	      var closeOnSelect = true;
	      // Return
	      var timeKey = 'Pickup_' + (0, _moment2.default)(date).format('DD-MM-YYYY_HH:mm');
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('1490') },
	        _react2.default.createElement(
	          _inline2.default,
	          null,
	          _react2.default.createElement(_datetime2.default, {
	            inputProps: inputProps,
	            dateFormat: 'DD-MM-YYYY',
	            closeOnSelect: closeOnSelect,
	            value: date,
	            timeFormat: false
	            // onChange={onChangeStartDate.bind(this.state)} />
	            , onChange: this.onChangeStartDate }),
	          _react2.default.createElement(
	            _dropDown2.default,
	            { value: timeString, onChange: onChangeTime, key: timeKey },
	            times.map(function (val, index) {
	              return _react2.default.createElement(
	                'option',
	                { key: index, value: val },
	                val
	              );
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'onChangeStartDate',
	    value: function onChangeStartDate(StartDate) {
	      var ExpireDate = this.state.ExpireDate;
	
	      var shouldExpireDateUpdate = false;
	      var newExpireDate = null;
	      if (StartDate.isSameOrAfter(ExpireDate)) {
	        shouldExpireDateUpdate = true;
	        newExpireDate = StartDate.clone().add(1, 'd');
	      }
	      this.setState({
	        message: _extends({}, this.state.message, {
	          StartDate: StartDate
	        }, shouldExpireDateUpdate && { ExpireDate: newExpireDate })
	      }, this.updateMessage);
	    }
	  }, {
	    key: 'onChangeExpireDate',
	    value: function onChangeExpireDate(ExpireDate) {
	      this.setState({
	        message: _extends({}, this.state.message, {
	          ExpireDate: ExpireDate
	        })
	      }, this.updateMessage);
	    }
	  }, {
	    key: 'renderTypes',
	    value: function renderTypes() {
	      if (!(0, _auth.hasAccess)([2], this.props.auth.user.UserType)) return null;
	
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('332') },
	        _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('930'), id: 'message', name: 'Type', value: 0, onChange: this.onChange, checked: this.state.message.Type === 0 }),
	        _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('15283'), id: 'news', name: 'Type', value: 1, onChange: this.onChange, checked: this.state.message.Type === 1 })
	      );
	    }
	  }, {
	    key: 'renderExpireDate',
	    value: function renderExpireDate() {
	      var ExpireDate = this.state.message.ExpireDate;
	
	      // Date
	
	      var renderExpireDate = '';
	      if (ExpireDate) {
	        renderExpireDate = window.CustomDate(ExpireDate);
	      }
	      var inputProps = {
	        placeholder: (0, _helpers.translation)('1728'),
	        readOnly: true
	      };
	
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('1245') },
	        _react2.default.createElement(_datetime2.default, {
	          inputProps: inputProps,
	          dateFormat: 'DD-MM-YYYY',
	          timeFormat: false,
	          closeOnSelect: true,
	          value: renderExpireDate,
	          onChange: this.onChangeExpireDate })
	      );
	    }
	  }, {
	    key: 'renderSaveButton',
	    value: function renderSaveButton() {
	      var isNews = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.state.message.Id !== 0) return null;
	      return _react2.default.createElement(_button2.default, { onClick: this.updateMessage.bind(this, 'yes'), labelText: (0, _helpers.translation)(isNews ? '15287' : '2047') });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this13 = this;
	
	      var onConfirm = function onConfirm() {
	        var file = _this13.state.confirmFileDelete.file;
	        _this13.setState({
	          confirmFileDelete: {
	            confirm: false,
	            file: null
	          }
	        }, function () {
	          _this13.deleteFile(file);
	        });
	      };
	
	      var notConfirm = function notConfirm() {
	        _this13.setState({
	          confirmFileDelete: {
	            confirm: false,
	            file: null
	          }
	        });
	      };
	
	      var isNews = this.state.message.Type === 1;
	
	      var renderGoBack = function renderGoBack() {
	        var goBack = function goBack() {
	          _this13.props.router.replace({
	            pathname: '/messages'
	          });
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_backButton2.default, { onClick: goBack, ariaText: (0, _helpers.translation)('394') })
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Header2.default, { router: this.props.router, showBack: true, headerButtonsGoBack: renderGoBack }),
	        _react2.default.createElement(
	          'div',
	          { className: 'messages__screen--inner' },
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('930') },
	              this.renderTypes(),
	              _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('1229'), name: 'Title', value: this.state.message.Title, onChange: this.onChange, onBlur: this.updateMessage }),
	              isNews && _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('15284'), name: 'Subtitle', value: this.state.message.Subtitle, onChange: this.onChange, onBlur: this.updateMessage }),
	              this.renderStartDate(),
	              this.renderExpireDate(),
	              _react2.default.createElement(_textarea2.default, { labelText: (0, _helpers.translation)('1021'), name: 'Body', value: this.state.message.Body, onChange: this.onChange, onBlur: this.updateMessage }),
	              isNews && this.renderIllustration(),
	              !isNews && this.renderFiles(),
	              this.renderSaveButton(isNews)
	            ),
	            this.messageCheckboxExtra(isNews)
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderRecipientList()
	          ),
	          this.state.confirmFileDelete.confirm && _react2.default.createElement(
	            _Portal2.default,
	            { className: 'deleteModal', onPortalClose: notConfirm },
	            _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: notConfirm })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Single;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    employees: state.common.employees,
	    companies: state.common.companies
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getMessage: _messages.getMessage,
	  createUpdateMessage: _messages.createUpdateMessage,
	  fileUpload: _messages.fileUpload,
	  fileDelete: _messages.fileDelete
	})(Single);

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	__webpack_require__(515);
	
	var _time = __webpack_require__(17);
	
	var _messages = __webpack_require__(280);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import components
	
	
	// import styles
	
	
	// Utils
	
	
	// Actions
	
	
	// Utils
	
	
	var Messages = function (_Component) {
	  _inherits(Messages, _Component);
	
	  function Messages(props) {
	    _classCallCheck(this, Messages);
	
	    var _this = _possibleConstructorReturn(this, (Messages.__proto__ || Object.getPrototypeOf(Messages)).call(this, props));
	
	    _this.state = {
	      Messages: [],
	      delete: {
	        type: false,
	        id: 0
	      },
	      IsMobile: false
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.deleteMessage = _this.deleteMessage.bind(_this);
	    _this.deleteMshowDeletePortalessage = _this.showDeletePortal.bind(_this);
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.getMessagesChain = _this.getMessagesChain.bind(_this);
	    _this.getMessagesCompany = _this.getMessagesCompany.bind(_this);
	    _this.onConfirm = _this.onConfirm.bind(_this);
	    return _this;
	  }
	
	  _createClass(Messages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (Number(this.props.auth.user.ShopId) === 0) {
	        this.getMessagesChain(this.props.auth.user.ChainId);
	      } else {
	        this.getMessagesCompany(this.props.auth.user.ShopId);
	      }
	      this.setState({
	        IsMobile: window.outerWidth < 535
	      });
	
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var IsMobile = window.outerWidth < 535;
	      if (IsMobile !== this.state.IsMobile) {
	        this.setState({
	          IsMobile: IsMobile
	        });
	      }
	    }
	  }, {
	    key: 'deleteMessage',
	    value: function deleteMessage(Id) {
	      this.setState({
	        delete: {
	          type: true,
	          id: Id
	        }
	      });
	    }
	  }, {
	    key: 'showDeletePortal',
	    value: function showDeletePortal() {
	      // console.log(this.state.delete)
	      if (this.state.delete.type === true) {
	        return _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: this.onPortalClose.bind(this, 'confirm') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm, notConfirm: this.onPortalClose.bind(this, 'confirm') })
	        );
	      }
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm() {
	      var _this2 = this;
	
	      var DeleteId = Number(this.state.delete.id);
	      if (DeleteId > 0) {
	        this.props.deleteMessage(DeleteId).then(function (res) {
	          // Toastr
	          // window.toastr.success(translation('1886'), translation('13424'))
	          if (Number(_this2.props.auth.user.ShopId) === 0) {
	            _this2.getMessagesChain(_this2.props.auth.user.ChainId);
	          } else {
	            _this2.getMessagesCompany(_this2.props.auth.user.ShopId);
	          }
	        }, function () {
	          console.log('err');
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('1885'), (0, _helpers.translation)('216'));
	        });
	        this.onPortalClose('confirm');
	      }
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState({
	        delete: {
	          type: false,
	          id: 0
	        }
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', ariaLabel: (0, _helpers.translation)('2047'), labelText: (0, _helpers.translation)(1797), onClick: function onClick() {
	            _this3.props.router.push('/messages/0');
	          } })
	      );
	    }
	  }, {
	    key: 'getMessagesChain',
	    value: function getMessagesChain(id) {
	      var _this4 = this;
	
	      this.props.getMessageChain(id).then(function (res) {
	        _this4.setState({
	          Messages: res.data
	        });
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'getMessagesCompany',
	    value: function getMessagesCompany(id) {
	      var _this5 = this;
	
	      this.props.getMessageCompany(id).then(function (res) {
	        _this5.setState({
	          Messages: res.data
	        });
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	      var isChain = (0, _auth.hasAccess)([2], this.props.auth.user.UserType);
	      var messageList = function messageList(val, key) {
	        var messagesLink = '/messages/' + val.Id;
	
	        var fromChain = val.CompanyId === 0 && !isChain;
	        if (_this6.state.IsMobile === false) {
	          return _react2.default.createElement(
	            _tableRow2.default,
	            { key: key },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: messagesLink },
	              (0, _time.renderFullDate)(val.CreationDate)
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: messagesLink },
	              (0, _time.renderFullDate)(val.StartDate)
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: messagesLink },
	              (0, _time.renderFullDate)(val.ExpireDate)
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: messagesLink },
	              val.Title
	            ),
	            !fromChain ? _react2.default.createElement(_removeButton2.default, { bin: true, size: 'm', onClick: _this6.deleteMessage.bind(_this6, val.Id) }) : _react2.default.createElement('div', null)
	          );
	        }
	
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: messagesLink, key: key },
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                val.Title
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('1490') + ': ',
	                (0, _time.renderFullDate)(val.StartDate)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('1245') + ': ',
	                (0, _time.renderFullDate)(val.ExpireDate)
	              )
	            ),
	            !fromChain ? _react2.default.createElement(_removeButton2.default, { bin: true, size: 'm', onClick: _this6.deleteMessage.bind(_this6, val.Id) }) : _react2.default.createElement('div', null)
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'messages__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: this.headerButtonsRight }),
	        this.showDeletePortal(),
	        _react2.default.createElement(
	          _tableContainer2.default,
	          null,
	          !this.state.IsMobile && _react2.default.createElement(
	            _tableRow2.default,
	            { header: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('13387')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1490')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1245')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1229')
	            ),
	            _react2.default.createElement('span', null)
	          ),
	          this.state.Messages.map(messageList)
	        )
	      );
	    }
	  }]);
	
	  return Messages;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    employees: state.common.employees
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getMessageChain: _messages.getMessageChain,
	  getMessageCompany: _messages.getMessageCompany,
	  deleteMessage: _messages.deleteMessage
	})(Messages);

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	__webpack_require__(1406);
	
	var _mypage = __webpack_require__(151);
	
	var _backdrop = __webpack_require__(29);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _CleanModal = __webpack_require__(1083);
	
	var _CleanModal2 = _interopRequireDefault(_CleanModal);
	
	var _Message = __webpack_require__(414);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _auth = __webpack_require__(8);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// Actions
	
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	// import Panel from '../../../shared/elements/panel'
	// import Divider from '../../../shared/elements/divider'
	// import LabelWrapper from '../../../shared/elements/labelWrapper'
	
	
	var MyMessages = function (_Component) {
	  _inherits(MyMessages, _Component);
	
	  function MyMessages(props) {
	    _classCallCheck(this, MyMessages);
	
	    var _this = _possibleConstructorReturn(this, (MyMessages.__proto__ || Object.getPrototypeOf(MyMessages)).call(this, props));
	
	    _this.state = {
	      messages: [],
	      openMessage: false
	    };
	    _this.getMessages = _this.getMessages.bind(_this);
	    _this.renderMessage = _this.renderMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(MyMessages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getMessages();
	    }
	  }, {
	    key: 'getMessages',
	    value: function getMessages() {
	      var _this2 = this;
	
	      this.props.getMyMessages(0).then(function (res) {
	        _this2.setState({
	          messages: res.data
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('2002'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderChild',
	    value: function renderChild() {
	      var child = '';
	      if (this.props.children !== null) {
	        child = _react2.default.cloneElement(this.props.children, {
	          getMessages: this.getMessages
	        });
	      }
	      return child;
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage(item, key) {
	      var _this3 = this;
	
	      // console.log('msg', item)
	      var makeTime = function makeTime() {
	        return (0, _time.renderFullDate)(item.CreationDate, true);
	      };
	      var goToMessage = function goToMessage(e) {
	        if (window.innerWidth <= 760) {
	          e.preventDefault();
	          _this3.props.triggerPopup(true);
	          _this3.setState({
	            openMessage: item
	          });
	        }
	      };
	      return _react2.default.createElement(
	        _tableRow2.default,
	        { key: key },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/mypage/messages/' + item.Id, className: 'clearfix', onClick: goToMessage },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: ['min-content', 1] },
	            _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              !item.IsUserRead && _react2.default.createElement('span', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'right' },
	              _react2.default.createElement(
	                _grid2.default,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'bold' },
	                  item.SenderName
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'bold' },
	                  makeTime()
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'messageBody' },
	                item.Title
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMessagePopup',
	    value: function renderMessagePopup() {
	      var _this4 = this;
	
	      var onClose = function onClose() {
	        _this4.props.triggerPopup(false);
	        _this4.setState({
	          openMessage: false
	        });
	      };
	      return _react2.default.createElement(
	        _CleanModal2.default,
	        { show: this.state.openMessage !== false, header: (0, _helpers.translation)('930'), onClose: onClose },
	        _react2.default.createElement(_Message2.default, { item: this.state.openMessage })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'row mymessages__screen' },
	        _react2.default.createElement(
	          _col2.default,
	          { id: 'items' },
	          this.props.renderMenu(),
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('1243') }),
	          _react2.default.createElement(
	            _tableContainer2.default,
	            null,
	            this.state.messages.map(this.renderMessage),
	            this.state.messages.length === 0 && _react2.default.createElement(
	              'div',
	              { style: { marginTop: 10 } },
	              (0, _helpers.translation)('1244')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { id: 'message' },
	          this.renderChild()
	        ),
	        this.state.openMessage !== false && this.renderMessagePopup()
	      );
	    }
	  }]);
	
	  return MyMessages;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getMyMessages: _mypage.getMyMessages,
	  triggerPopup: _backdrop.triggerPopup
	})(MyMessages);

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _NewWorkCard = __webpack_require__(423);
	
	var _NewWorkCard2 = _interopRequireDefault(_NewWorkCard);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	// import WorkCard from '../../../Orders/Order/WorkCard'
	
	
	// Utils
	
	
	var MyOrdersOrder = function (_Component) {
	  _inherits(MyOrdersOrder, _Component);
	
	  function MyOrdersOrder(props) {
	    _classCallCheck(this, MyOrdersOrder);
	
	    var _this = _possibleConstructorReturn(this, (MyOrdersOrder.__proto__ || Object.getPrototypeOf(MyOrdersOrder)).call(this, props));
	
	    _this.state = {};
	    _this.onUpdateOrder = _this.onUpdateOrder.bind(_this);
	    return _this;
	  }
	
	  _createClass(MyOrdersOrder, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getOrder(this.props.params.orderID);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.orderID !== this.props.params.orderID) {
	        this.props.resetOrder();
	        this.props.getOrder(nextProps.params.orderID);
	      }
	    }
	  }, {
	    key: 'onUpdateOrder',
	    value: function onUpdateOrder() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'order__screen' },
	        _react2.default.createElement(
	          'div',
	          { className: 'order__screen--inner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'myOrders__workcard' },
	            _react2.default.createElement(_NewWorkCard2.default, { disabled: true, onUpdateOrder: this.onUpdateOrder, router: this.props.router, renderTitles: [(0, _helpers.translation)('159')] })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MyOrdersOrder;
	}(_react.Component);
	// <WorkCard disabled onUpdateOrder={this.onUpdateOrder} renderTitles={translation('159')} />
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrder: _orders.getOrder,
	  resetOrder: _orders.resetOrder
	})(MyOrdersOrder);

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _mypage = __webpack_require__(151);
	
	var _orders = __webpack_require__(21);
	
	var _backdrop = __webpack_require__(29);
	
	var _helpers = __webpack_require__(2);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _Item = __webpack_require__(416);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _QualityCheckModal = __webpack_require__(204);
	
	var _QualityCheckModal2 = _interopRequireDefault(_QualityCheckModal);
	
	var _auth = __webpack_require__(8);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	// import Panel from '../../../shared/elements/panel'
	
	
	var MyOrders = function (_Component) {
	  _inherits(MyOrders, _Component);
	
	  function MyOrders(props) {
	    _classCallCheck(this, MyOrders);
	
	    var _this = _possibleConstructorReturn(this, (MyOrders.__proto__ || Object.getPrototypeOf(MyOrders)).call(this, props));
	
	    _this.state = {
	      CurrentOrders: [],
	      FutureOrders: [],
	      quality: {
	        open: false,
	        data: {},
	        index: 0,
	        pos: 0,
	        move: true
	      }
	    };
	    _this.getOrders = _this.getOrders.bind(_this);
	    _this.renderOrder = _this.renderOrder.bind(_this);
	    _this.completeOrder = _this.completeOrder.bind(_this);
	    _this.startOrderSuccess = _this.startOrderSuccess.bind(_this);
	    _this.closeQualityModal = _this.closeQualityModal.bind(_this);
	    _this.updateFromOrderSocket = _this.updateFromOrderSocket.bind(_this);
	    return _this;
	  }
	
	  _createClass(MyOrders, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOrders();
	      _events2.default.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _events2.default.removeListener('ORDER_SOCKET', this.updateFromOrderSocket);
	    }
	  }, {
	    key: 'updateFromOrderSocket',
	    value: function updateFromOrderSocket(json) {
	      if (json.Type === 'ORDER_MOVED' || json.Type === 'ORDER_STOPPED') this.getOrders();
	    }
	  }, {
	    key: 'getOrders',
	    value: function getOrders() {
	      var _this2 = this;
	
	      this.props.getMyOrders(0).then(function (res) {
	        _this2.setState({
	          CurrentOrders: res.data.CurrentOrders,
	          FutureOrders: res.data.FutureOrders
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1910'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'completeOrder',
	    value: function completeOrder(id, fromStep, toStep, step, index, item) {
	      var _this3 = this;
	
	      var moveData = {
	        OrderId: id,
	        UserId: 0,
	        StepFrom: item.StepId,
	        StepTo: item.StepId + 1,
	        Comment: '',
	        FilterSettings: {},
	        DontReturnOrders: true
	      };
	      this.props.moveOrder(moveData).then(function (res) {
	        _this3.setState({
	          CurrentOrders: [],
	          FutureOrders: []
	        }, function () {
	          _this3.getOrders();
	        });
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('1731'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'startOrderSuccess',
	    value: function startOrderSuccess() {
	      this.closeQualityModal();
	      this.props.getPunchClockStats();
	    }
	  }, {
	    key: 'renderOrder',
	    value: function renderOrder(val, key) {
	      var isFutureOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var className = '';
	      // Visited
	      if (typeof this.props.params.orderID !== 'undefined') {
	        if (val.Id === parseInt(this.props.params.orderID)) {
	          className += ' visited';
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, className: 'order__item__myorders ' + className },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: ['minmax(0, 1fr)', 'min-content'], align: 'center' },
	          _react2.default.createElement(_Item2.default, { router: this.props.router, noCircle: isFutureOrder, type: '1', item: val, key: key, index: key, step: 0, MoveOrders: this.moveOrders.bind(this), completeOrder: this.completeOrder, startOrderSuccess: this.startOrderSuccess }),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/mypage/orders/' + val.Id },
	            _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Chevron_Right })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'stepHasComments',
	    value: function stepHasComments(data) {
	      var ProcessComments = data.ProcessComments;
	      var anyComments = false;
	      if (ProcessComments) {
	        ProcessComments.map(function (val) {
	          if (val.StepComments.length !== 0) anyComments = true;
	        });
	      } else if (data.Checks) {
	        data.Checks.map(function (check) {
	          check.ProcessComments.map(function (val) {
	            if (val.StepComments.length !== 0) anyComments = true;
	          });
	        });
	      }
	
	      return anyComments;
	    }
	  }, {
	    key: 'moveOrders',
	    value: function moveOrders(data) {
	      var _this4 = this;
	
	      if (data === undefined) {
	        data = {
	          OrderIds: this.state.MoveOrders.MoveAll === true ? this.state.MoveOrders.OrderIds : [this.state.MoveOrders.Id],
	          UserId: 0,
	          StepFrom: this.state.MoveOrders.FromStep,
	          StepTo: this.state.MoveOrders.ToStep,
	          Comment: '',
	          FilterSettings: {}
	        };
	      }
	
	      var orders = [];
	      for (var i = 0; i < data.OrderIds.length; i++) {
	        var order = {
	          OrderId: data.OrderIds[i]
	        };
	        orders.push(order);
	      }
	
	      var moveData = {
	        Orders: orders,
	        UserId: data.UserId,
	        StepFrom: data.StepFrom,
	        StepTo: data.StepTo,
	        Comment: data.Comment,
	        FilterSettings: data.FilterSettings,
	        MoveAll: data.MoveAll,
	        CheckOnly: false
	      };
	
	      this.props.moveOrder(moveData).then(function (res) {
	        if (res.data.MoveAll) {
	          _this4.setState({
	            MoveOrders: _extends({}, _this4.state.MoveOrders, {
	              open: true,
	              MoveAll: null,
	              OrderIds: res.data.OrderIds,
	              FromStep: data.StepFrom,
	              ToStep: data.StepTo,
	              Id: data.OrderIds[0]
	            })
	          }, function () {
	            return null;
	          });
	        } else if (res.data.Checks.length > 0) {
	          _this4.props.triggerPopup(true);
	          res.data.OrderIds = data.OrderIds;
	          _this4.setState({
	            quality: {
	              open: true,
	              data: [res.data],
	              pos: data.Pos,
	              index: data.Index,
	              move: true
	            },
	            MoveOrders: _extends({}, _this4.state.MoveOrders, {
	              FromStep: moveData.StepFrom
	            })
	          });
	        } else {
	          if (_this4.stepHasComments(res.data)) {
	            _this4.props.triggerPopup(true);
	            _this4.setState({
	              quality: {
	                open: true,
	                data: [res.data],
	                pos: data.Pos,
	                index: data.Index,
	                move: true
	              }
	            });
	          }
	          //  else {
	          // }
	          // this.updateRow(res.data.CurrentStepOrders, data.Pos, data.Index)
	          // let message = orders.length > 1 ? translation('12338') : translation('1909')
	          // window.toastr.success(message, translation('13424'))
	        }
	      }, function (res) {
	        // Toastr
	        var message = void 0;
	        if (res.response.data.IsStopped === true) message = (0, _helpers.translation)('12347');else if (res.response.data.IsReffered === true) message = (0, _helpers.translation)('2704');else message = orders.length > 1 ? (0, _helpers.translation)('12339') : (0, _helpers.translation)('1731');
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderCurrentOrders',
	    value: function renderCurrentOrders() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'clearfix' },
	        this.state.CurrentOrders.length === 0 && _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)('1890')
	        ),
	        this.state.CurrentOrders.map(this.renderOrder)
	      );
	    }
	  }, {
	    key: 'renderFutureOrders',
	    value: function renderFutureOrders() {
	      var _this5 = this;
	
	      var comingOrders = this.state.FutureOrders.filter(function (item) {
	        return !_this5.state.CurrentOrders.some(function (x) {
	          return x.Id === item.Id;
	        });
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'clearfix' },
	        comingOrders.length === 0 && _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)('1890')
	        ),
	        comingOrders.map(function (val, key) {
	          return _this5.renderOrder(val, key, true);
	        })
	      );
	    }
	  }, {
	    key: 'renderChild',
	    value: function renderChild() {
	      var child = '';
	      if (this.props.children !== null) {
	        child = _react2.default.cloneElement(this.props.children, {});
	      }
	      return child;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { id: 'items' },
	          this.props.renderMenu(),
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('1888') }),
	          this.renderCurrentOrders(),
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('586') }),
	          this.renderFutureOrders()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { id: 'order' },
	          this.renderChild()
	        ),
	        this.state.quality.open && _react2.default.createElement(_QualityCheckModal2.default, {
	          router: this.props.router,
	          show: this.state.quality.open,
	          data: this.state.quality.data,
	          onMoveSuccess: this.moveOrderSuccess.bind(this),
	          onClose: this.closeQualityModal.bind(this),
	          move: this.state.quality.move })
	      );
	    }
	  }, {
	    key: 'moveOrderSuccess',
	    value: function moveOrderSuccess(data) {
	      this.closeQualityModal();
	    }
	  }, {
	    key: 'closeQualityModal',
	    value: function closeQualityModal() {
	      var _this6 = this;
	
	      this.props.triggerPopup(false);
	      this.setState({
	        quality: {
	          open: false,
	          data: {},
	          index: 0,
	          pos: 0
	        }
	      }, function () {
	        _this6.getOrders();
	      });
	    }
	  }]);
	
	  return MyOrders;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getMyOrders: _mypage.getMyOrders,
	  moveOrder: _orders.moveOrder,
	  triggerPopup: _backdrop.triggerPopup
	})(MyOrders);

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _GeneralNotesModal = __webpack_require__(1087);
	
	var _GeneralNotesModal2 = _interopRequireDefault(_GeneralNotesModal);
	
	var _backdrop = __webpack_require__(29);
	
	var _generalnotes = __webpack_require__(279);
	
	var _tasks = __webpack_require__(194);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	__webpack_require__(1407);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Comments = function (_Component) {
	  _inherits(Comments, _Component);
	
	  function Comments(props) {
	    _classCallCheck(this, Comments);
	
	    var _this = _possibleConstructorReturn(this, (Comments.__proto__ || Object.getPrototypeOf(Comments)).call(this, props));
	
	    _this.state = {
	      notes: [],
	      note: {
	        modal: false,
	        data: {}
	      },
	      confirmDelete: {
	        open: false,
	        NoteId: 0
	      }
	    };
	
	    _this.getOccurrenceNotes = _this.getOccurrenceNotes.bind(_this);
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.showNoteModal = _this.showNoteModal.bind(_this);
	    _this.onNoteSuccess = _this.onNoteSuccess.bind(_this);
	    _this.onPortalClose = _this.onPortalClose.bind(_this);
	    _this.onConfirm = _this.onConfirm.bind(_this);
	    return _this;
	  }
	
	  _createClass(Comments, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOccurrenceNotes(this.props.OccurrenceId);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.OccurrenceId !== this.props.OccurrenceId) {
	        this.getOccurrenceNotes(nextProps.OccurrenceId);
	      }
	    }
	  }, {
	    key: 'getOccurrenceNotes',
	    value: function getOccurrenceNotes(occurrenceId) {
	      var _this2 = this;
	
	      this.props.getOccurrenceNotes(occurrenceId).then(function (res) {
	        _this2.setState({
	          notes: res.data
	        });
	      });
	    }
	  }, {
	    key: 'showNoteModal',
	    value: function showNoteModal(note) {
	      this.props.triggerPopup(!this.state.note.modal);
	      this.setState({
	        note: {
	          data: note,
	          modal: !this.state.note.modal
	        }
	      });
	    }
	  }, {
	    key: 'onNoteSuccess',
	    value: function onNoteSuccess(res) {
	      this.setState({
	        notes: res
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this3 = this;
	
	      var newComment = function newComment() {
	        _this3.props.triggerPopup(true);
	        _this3.setState({
	          note: {
	            data: {
	              Note: '',
	              OtherTaskOccurrenceId: _this3.props.OccurrenceId
	            },
	            modal: true
	          }
	        });
	      };
	
	      var deleteNote = function deleteNote(item) {
	        _this3.setState({
	          confirmDelete: {
	            open: true,
	            NoteId: item.Id
	          }
	        });
	      };
	
	      // Comments
	      var renderComment = function renderComment(item, key) {
	        var editIcon = _react2.default.createElement(
	          'div',
	          { className: 'hint--top', 'aria-label': (0, _helpers.translation)('13357') },
	          _react2.default.createElement('img', { src: '/images/icons/edit_16.png', onClick: function onClick() {
	              return _this3.showNoteModal(item);
	            } })
	        );
	        var deleteIcon = _react2.default.createElement(
	          'div',
	          { className: 'hint--top', 'aria-label': (0, _helpers.translation)('2156') },
	          _react2.default.createElement('img', { src: '/images/icons/Delete_16.png', onClick: function onClick() {
	              return deleteNote(item);
	            } })
	        );
	
	        return _react2.default.createElement(
	          'div',
	          { key: key, className: 'note' },
	          _react2.default.createElement(
	            'div',
	            { className: 'heading' },
	            _react2.default.createElement(
	              'span',
	              null,
	              item.CreatedByName,
	              ': ',
	              (0, _time.renderFullDate)(item.CreatedDate)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'actions' },
	              item.IsMine === true && editIcon,
	              item.IsMine === true && deleteIcon
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            item.Note
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'notes' },
	          this.state.notes.map(renderComment)
	        ),
	        _react2.default.createElement(_button2.default, { size: 'l', style: 'link', onClick: newComment, labelText: (0, _helpers.translation)('15359') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('14834') + ' (' + this.state.notes.length + ')' },
	        this.renderContent(),
	        _react2.default.createElement(_GeneralNotesModal2.default, {
	          show: this.state.note.modal,
	          onClose: this.showNoteModal,
	          note: this.state.note.data,
	          onSuccess: this.onNoteSuccess }),
	        this.state.confirmDelete.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm, notConfirm: this.onPortalClose })
	        )
	      );
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm() {
	      var _this4 = this;
	
	      this.onPortalClose();
	      this.props.deleteNote(this.state.confirmDelete.NoteId).then(function (res) {
	        _this4.setState({
	          notes: res.data
	        });
	        // Toastr
	        // window.toastr.success(translation('1895'), translation('13424'))
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13441'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose() {
	      this.setState({
	        confirmDelete: _extends({}, this.state.confirmDelete, {
	          open: false,
	          NoteId: 0
	        })
	      });
	    }
	  }]);
	
	  return Comments;
	}(_react.Component);
	
	Comments.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  getOccurrenceNotes: _tasks.getOccurrenceNotes,
	  deleteNote: _generalnotes.deleteNote
	})(Comments);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _async = __webpack_require__(147);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _constants = __webpack_require__(5);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _tasks = __webpack_require__(194);
	
	var _helpers = __webpack_require__(2);
	
	var _generalnotes = __webpack_require__(279);
	
	var _time = __webpack_require__(17);
	
	__webpack_require__(1408);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _image = __webpack_require__(452);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Constants
	
	
	// Components
	
	
	var Files = function (_PureComponent) {
	  _inherits(Files, _PureComponent);
	
	  function Files(props) {
	    _classCallCheck(this, Files);
	
	    var _this = _possibleConstructorReturn(this, (Files.__proto__ || Object.getPrototypeOf(Files)).call(this, props));
	
	    _this.state = {
	      upload: {
	        loading: false,
	        errors: []
	      },
	      files: [],
	      confirmFileDelete: {
	        confirm: false,
	        file: null
	      },
	      mounted: false
	    };
	    _this.renderFiles = _this.renderFiles.bind(_this);
	    return _this;
	  }
	
	  _createClass(Files, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        files: this.props.files,
	        confirmFileDelete: {
	          confirm: false,
	          file: null
	        },
	        mounted: true
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        files: nextProps.files,
	        confirmFileDelete: {
	          confirm: false,
	          file: null
	        },
	        mounted: true
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setState({
	        mounted: false
	      });
	    }
	  }, {
	    key: 'renderFiles',
	    value: function renderFiles() {
	      var _this2 = this;
	
	      var errors = this.state.upload.errors;
	
	      // Delete file
	
	      var deleteFile = function deleteFile(file) {
	        var newErrors = [];
	        var deleteFileId = { ItemId: file.OrderFileId };
	        _this2.props.fileDelete(deleteFileId).then(function (res) {
	          // delete from database
	          _this2.setState({
	            files: _this2.state.files.filter(function (el) {
	              return el.OrderFileId !== Number(file.OrderFileId);
	            })
	          });
	        }, function () {
	          newErrors.push((0, _helpers.translation)('1207') + ': ' + file.FileName);
	          _this2.setState({
	            upload: _extends({}, _this2.state.upload, { errors: newErrors })
	          });
	        });
	      };
	
	      var deleteConfirmation = function deleteConfirmation(file) {
	        _this2.setState({
	          confirmFileDelete: {
	            confirm: true,
	            file: file
	          }
	        });
	      };
	
	      // Render file
	      var renderFile = function renderFile(file, index) {
	        var info = function info() {
	          return _react2.default.createElement(
	            'div',
	            { className: 'info' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('15357'),
	              ': ',
	              file.CreatedBy
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('15358'),
	              ': ',
	              (0, _time.renderFullDate)(file.CreatedDate)
	            )
	          );
	        };
	
	        var postNote = function postNote() {
	          var data = _this2.state.files[index].Notes[0];
	          if (isNaN(data.OrderFileId)) data.OrderFileId = file.OrderFileId;
	          _this2.props.postNote(data).then(function (res) {
	            var files = _this2.state.files;
	            files[index].Notes = res.data;
	            _this2.setState({
	              files: files
	            }, function () {
	              // window.toastr.success(translation('1931'), translation('13424'))
	            });
	          }, function () {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var noteChange = function noteChange(e) {
	          var files = _this2.state.files;
	          files[index].Notes[0] = _extends({}, files[index].Notes[0], {
	            Note: e.target.value
	          });
	          _this2.setState({
	            files: files
	          }, _this2.forceUpdate);
	        };
	
	        var note = file.Notes.length > 0 ? file.Notes[0].Note : '';
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          file.IsImage ? _react2.default.createElement(
	            'div',
	            { className: 'top clearfix' },
	            renderImage(file),
	            info()
	          ) : renderNonImage(file),
	          file.IsImage === false && info(),
	          _react2.default.createElement(
	            'div',
	            { className: 'note' },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('15359') },
	              _react2.default.createElement(_textarea2.default, { value: note, onChange: noteChange, onBlur: postNote })
	            )
	          )
	        );
	      };
	
	      // Render non image
	      var renderNonImage = function renderNonImage(file) {
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	        return _react2.default.createElement(
	          'div',
	          { className: 'nonimage' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          _react2.default.createElement(
	            'a',
	            { target: '_BLANK', href: file.FileURL },
	            file.FileName
	          ),
	          _react2.default.createElement('img', { className: 'file-delete', src: '/images/icons/Delete_16.png', onClick: function onClick() {
	              return deleteConfirmation(file);
	            } })
	        );
	      };
	      // Render image
	      var renderImage = function renderImage(image) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'gallery' },
	          _react2.default.createElement(_image2.default, { imageFile: image, onClickDelete: function onClickDelete() {
	              return deleteConfirmation(image);
	            } })
	        );
	      };
	
	      var onConfirm = function onConfirm() {
	        var file = _this2.state.confirmFileDelete.file;
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	
	        _this2.setState({
	          confirmFileDelete: confirm
	        }, function () {
	          deleteFile(file);
	        });
	      };
	
	      var notConfirm = function notConfirm() {
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	        _this2.setState({
	          confirmFileDelete: confirm
	        });
	      };
	      // On drop
	      var onDrop = function onDrop() {
	        _this2.setState({ upload: _extends({}, _this2.state.upload, {
	            errors: []
	          }) });
	      };
	      // On drop accepted
	      var onDropAccepted = function onDropAccepted(files) {
	        var newErrors = [];
	        _this2.setState({
	          upload: _extends({}, _this2.state.upload, {
	            loading: true
	          })
	        });
	        _async2.default.each(files, function (file, cb) {
	          // Upload each file
	          _this2.props.fileUpload(file, 0).then(function (res) {
	            _this2.props.postOccurrenceFile({ OccurrenceId: _this2.props.OccurrenceId, OrderFileId: res.data[0].OrderFileID }).then(function (files) {
	              _this2.setState({
	                files: files.data
	              });
	            });
	            cb();
	          }, function () {
	            newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13406') + '.');
	            cb();
	          });
	        }, function () {
	          if (newErrors.length !== 0) {
	            _this2.setState({
	              upload: _extends({}, _this2.state.upload, {
	                errors: _this2.state.upload.errors.concat(newErrors)
	              })
	            });
	          }
	          _this2.setState({
	            upload: _extends({}, _this2.state.upload, {
	              loading: false
	            })
	          });
	        });
	      };
	      // On drop rejected
	      var onDropRejected = function onDropRejected(files) {
	        var newErrors = [];
	        files.map(function (val, index) {
	          newErrors.push((0, _helpers.translation)('1207') + ': ' + val.name + ' ' + (0, _helpers.translation)('13405') + '.');
	        });
	        _this2.setState({ upload: _extends({}, _this2.state.upload, { errors: newErrors }) });
	      };
	      // Render error
	      var renderError = function renderError(error, index) {
	        return _react2.default.createElement(
	          'p',
	          { key: index },
	          error
	        );
	      };
	      // Render
	      var isMultipleUpload = true;
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1043') },
	        _react2.default.createElement(
	          'div',
	          { className: 'files' },
	          _react2.default.createElement(
	            'div',
	            { className: 'files_inner clearfix' },
	            this.state.files && this.state.files.map(renderFile)
	          ),
	          errors.length !== 0 && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            errors.map(renderError)
	          ),
	          _react2.default.createElement(
	            _Dropzone2.default,
	            {
	              onDrop: onDrop,
	              onDropAccepted: onDropAccepted,
	              onDropRejected: onDropRejected,
	              multiple: isMultipleUpload,
	              includeCircles: false },
	            this.state.upload.loading && _react2.default.createElement(
	              'div',
	              { className: 'loading' },
	              _react2.default.createElement(
	                'div',
	                { className: 'animated-background' },
	                _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'sr-only' },
	                  (0, _helpers.translation)('13382'),
	                  '...'
	                )
	              )
	            ),
	            !this.state.upload.loading && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                (0, _helpers.translation)('13397')
	              )
	            )
	          ),
	          this.state.confirmFileDelete.confirm && _react2.default.createElement(
	            _Portal2.default,
	            { className: 'deleteModal', onPortalClose: notConfirm },
	            _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: notConfirm })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'white__box' },
	        this.renderFiles()
	      );
	    }
	  }]);
	
	  return Files;
	}(_react.PureComponent);
	
	Files.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  fileUpload: _tasks.fileUpload,
	  fileDelete: _tasks.fileDelete,
	  postOccurrenceFile: _tasks.postOccurrenceFile,
	  postNote: _generalnotes.postNote
	})(Files);

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	__webpack_require__(1411);
	
	var _punchclock = __webpack_require__(173);
	
	var _settings = __webpack_require__(51);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// import actions
	
	
	// Utils
	
	
	// Elements
	
	
	// import Header from '../../shared/components/Header'
	
	var MyPage = function (_Component) {
	  _inherits(MyPage, _Component);
	
	  function MyPage(props) {
	    _classCallCheck(this, MyPage);
	
	    var _this = _possibleConstructorReturn(this, (MyPage.__proto__ || Object.getPrototypeOf(MyPage)).call(this, props));
	
	    _this.state = {
	      punch: {},
	      punchStatsCurrentUser: { UserPunchStats: { PunchType: 2 } },
	      settings: { PunchInVia: null }
	    };
	    _this._renderMenu = _this._renderMenu.bind(_this);
	    _this.getPunchClockStats = _this.getPunchClockStats.bind(_this);
	    _this.getPunchStatsCurrentUser = _this.getPunchStatsCurrentUser.bind(_this);
	    _this.startStopPunchClock = _this.startStopPunchClock.bind(_this);
	    return _this;
	  }
	
	  _createClass(MyPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.getPunchClockStats();
	      this.getPunchStatsCurrentUser();
	      this.props.getPunchClockInformation(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({ settings: res.data });
	      });
	    }
	
	    /**
	     * 0: Pause
	     * 1: Working
	     * 2: Not punched in
	     */
	
	  }, {
	    key: 'getPunchClockStats',
	    value: function getPunchClockStats() {
	      var _this3 = this;
	
	      this.props.getPunchClockStats(0).then(function (res) {
	        _this3.setState({
	          punch: res.data
	        });
	      }, function () {
	        console.log('Punch err');
	      });
	    }
	  }, {
	    key: 'getPunchStatsCurrentUser',
	    value: function getPunchStatsCurrentUser() {
	      var _this4 = this;
	
	      this.props.getPunchStatsCurrentUser().then(function (res) {
	        _this4.setState({
	          punchStatsCurrentUser: res.data
	        });
	      }, function () {
	        console.log('Punch err');
	      });
	    }
	  }, {
	    key: 'startStopPunchClock',
	    value: function startStopPunchClock(punch) {
	      var _this5 = this;
	
	      var punchData = {
	        UserId: punch.UserId ? punch.UserId : 0,
	        PunchType: 0,
	        IsManual: true
	        // if (punch.Status === 0 || punch.Status === 2) {
	      };if (this.state.punchStatsCurrentUser.UserPunchStats.PunchType === 0 || this.state.punchStatsCurrentUser.UserPunchStats.PunchType === 2) {
	        punchData.PunchType = 1;
	      } else {
	        punchData.PunchType = 2;
	      }
	      this.props.editPunchStats(punchData).then(function (res) {
	        // this.getPunchStatsCurrentUser()
	        _this5.props.getPunchStatsCurrentUser().then(function (getStatsRes) {
	          _this5.setState({
	            punchStatsCurrentUser: getStatsRes.data
	          });
	          if (getStatsRes.data.UserPunchStats.PunchType === 1) {
	            // window.toastr.success(translation('1902'), translation('13424'))
	          } else {
	              // window.toastr.success(translation('1903'), translation('13424'))
	            }
	        });
	        _this5.setState({
	          punch: res.data
	        }, function () {
	          if (_this5.props.router.location.pathname === '/mypage/tasks') {
	            _events2.default.emit('UPDATE_TASKS_MYPAGE');
	          }
	        });
	      }).catch(function () {
	        window.toastr.error((0, _helpers.translation)('1904'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderPunchClock',
	    value: function renderPunchClock() {
	      var _this6 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20, 12) || !this.props.auth.shopPunchClockActive) return null;
	      var _state = this.state,
	          punch = _state.punch,
	          settings = _state.settings,
	          punchStatsCurrentUser = _state.punchStatsCurrentUser;
	
	      if (Object.keys(punch).length === 0) return null;
	      // Variables
	      var punchInAllowed = settings.PunchInVia === 0 || settings.PunchInVia === 2;
	      var extraClass = 'active';
	      // using state.punchStatsCurrentUser to show clock times, because api to update state.punch is not being called after an order is started
	      var punchTime = punchStatsCurrentUser.UserPunchStats.LastPunch;
	      // let punchTime = punch.LastPunchIn
	      var punchText = '1900';
	      var checkText = '443';
	      var image = '/images/icons/Punch-clock-white.png';
	      var actionText = '2131';
	      var ipRestricted = punch.IsIpRestricted;
	      var disabled = false;
	      // if (punch.Status === 0 || punch.Status === 2) {
	      if (punchStatsCurrentUser.UserPunchStats.PunchType === 0 || punchStatsCurrentUser.UserPunchStats.PunchType === 2) {
	        // punchTime = punch.LastPunchOut
	        if (punchInAllowed) {
	          actionText = '2130';
	        } else {
	          disabled = true;
	        }
	        punchText = '1901';
	        checkText = '1899';
	
	        extraClass = '';
	        image = '/images/icons/Punch-clock-black.png';
	      }
	      var extraPanelText = ': ' + (0, _helpers.translation)(actionText);
	      if (ipRestricted === true || disabled) {
	        extraPanelText = '';
	        extraClass += ' disabled';
	        disabled = true;
	      }
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'punchClock ' + extraClass, onClick: !disabled ? function () {
	              return _this6.startStopPunchClock(punch);
	            } : null },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: ['min-content', 1], align: 'center', className: 'pg-px-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'punchIcon' },
	              _react2.default.createElement('img', { src: image })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pg-pb-2' },
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(checkText) + extraPanelText }),
	              _react2.default.createElement(_divider2.default, null),
	              _react2.default.createElement(
	                _inline2.default,
	                { spacing: 0 },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)(punchText)
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _time.renderFullDate)(punchTime)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: '_renderMenu',
	    value: function _renderMenu() {
	      var renderMyOrders = function renderMyOrders() {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/mypage/orders', activeClassName: 'active' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.MyPageIcons.My_Orders })
	        );
	      };
	      var renderMyTasks = function renderMyTasks() {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/mypage/tasks', activeClassName: 'active' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.MyPageIcons.My_Tasks })
	        );
	      };
	      var renderMyMessages = function renderMyMessages() {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/mypage/messages', activeClassName: 'active' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.MyPageIcons.My_Messages })
	        );
	      };
	      return _react2.default.createElement(
	        _tabBar2.default,
	        null,
	        _react2.default.createElement(
	          _tabItem2.default,
	          null,
	          renderMyOrders()
	        ),
	        _react2.default.createElement(
	          _tabItem2.default,
	          null,
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) && renderMyTasks()
	        ),
	        _react2.default.createElement(
	          _tabItem2.default,
	          null,
	          renderMyMessages()
	        )
	      );
	    }
	  }, {
	    key: 'renderChild',
	    value: function renderChild() {
	      var child = '';
	      if (this.props.children !== null) {
	        child = _react2.default.cloneElement(this.props.children, {
	          renderMenu: this._renderMenu,
	          getPunchClockStats: this.getPunchStatsCurrentUser
	        });
	      }
	      return child;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'mypage__screen' },
	        _react2.default.createElement(
	          'div',
	          { className: 'mypage__screen--inner' },
	          _react2.default.createElement(
	            _row2.default,
	            null,
	            this.renderPunchClock()
	          ),
	          _react2.default.createElement(
	            _row2.default,
	            null,
	            this.renderChild()
	          )
	        )
	      );
	    }
	  }]);
	
	  return MyPage;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPunchClockStats: _punchclock.getPunchClockStats,
	  getPunchStatsCurrentUser: _punchclock.getPunchStatsCurrentUser,
	  editPunchStats: _punchclock.editPunchStats,
	  getPunchClockInformation: _settings.getPunchClockInformation
	})(MyPage);

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownBox = function (_PureComponent) {
	  _inherits(DropdownBox, _PureComponent);
	
	  function DropdownBox(props) {
	    _classCallCheck(this, DropdownBox);
	
	    var _this = _possibleConstructorReturn(this, (DropdownBox.__proto__ || Object.getPrototypeOf(DropdownBox)).call(this, props));
	
	    _this.state = {};
	    _this.handle = _this.handle.bind(_this);
	    return _this;
	  }
	
	  _createClass(DropdownBox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('click', this.handle, true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.handle, true);
	    }
	  }, {
	    key: 'handle',
	    value: function handle(e) {
	      var el = this.refs.dropdown_container;
	      if (!el.contains(e.target) && this.props.openDropdownLeft) {
	        this.props.closeDropdown();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var toggleDropdownLeft = function toggleDropdownLeft() {
	        console.log('toggle dropdown', !_this2.props.openDropdownLeft);
	        _this2.props.toggleDropdown(!_this2.props.openDropdownLeft);
	      };
	      var isActive = function isActive(view) {
	        if (view === _this2.props.screenview) return 'active';
	        return '';
	      };
	      var hasPaintShopValue = (0, _auth.hasPaintShop)(this.props.auth);
	      var hasBodyShopValue = (0, _auth.hasBodyShop)(this.props.auth);
	      var hasCombinedBodyPaintShopValue = (0, _auth.hasCombinedBodyPaintShop)(this.props.auth);
	      var fullPaintScreenText = '1157';
	      var fullBodyScreenText = '18'; // '1157'
	      var shopScreenText = '18';
	      var prepScreenText = '19';
	      var bodyWorkScreenText = '14826'; // '18'
	      if (hasCombinedBodyPaintShopValue === true) {
	        fullPaintScreenText = '14822';
	        fullBodyScreenText = '14821';
	        shopScreenText = '14824';
	        prepScreenText = '14825';
	        bodyWorkScreenText = '14823';
	      }
	      var renderActiveName = function renderActiveName() {
	        // console.log(this.props.screenview)
	        switch (_this2.props.screenview) {
	          case '0':
	            return fullPaintScreenText;
	          case '1':
	            return '1157';
	          case '2':
	            return fullBodyScreenText;
	          case '3':
	            return shopScreenText;
	          case '4':
	            return prepScreenText;
	          case '5':
	            return '254';
	          case '6':
	            return bodyWorkScreenText;
	          case '7':
	            return '1857';
	          default:
	            return '1157';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'dropdown__changeScreen', ref: 'dropdown_container' },
	        _react2.default.createElement(
	          'div',
	          { onClick: toggleDropdownLeft, className: 'trigger' },
	          _react2.default.createElement(
	            'label',
	            null,
	            (0, _helpers.translation)(renderActiveName())
	          ),
	          ' ',
	          _react2.default.createElement('i', { className: 'fa fa-chevron-down' })
	        ),
	        this.props.openDropdownLeft && _react2.default.createElement(
	          'div',
	          { className: 'dropdown__box' },
	          _react2.default.createElement(
	            'div',
	            null,
	            hasCombinedBodyPaintShopValue === true && _react2.default.createElement(
	              'a',
	              { onClick: this.props.changeScreen.bind(this, '1'), className: isActive('1') },
	              (0, _helpers.translation)('1157')
	            ),
	            hasBodyShopValue === true && _react2.default.createElement(
	              'a',
	              { onClick: this.props.changeScreen.bind(this, '2'), className: isActive('2') },
	              (0, _helpers.translation)(fullBodyScreenText)
	            ),
	            hasBodyShopValue === true && _react2.default.createElement(
	              'a',
	              { onClick: this.props.changeScreen.bind(this, '6'), className: isActive('6') },
	              (0, _helpers.translation)(bodyWorkScreenText)
	            ),
	            hasPaintShopValue === true && _react2.default.createElement(
	              'a',
	              { onClick: this.props.changeScreen.bind(this, '0'), className: isActive('0') },
	              (0, _helpers.translation)(fullPaintScreenText)
	            ),
	            hasPaintShopValue === true && _react2.default.createElement(
	              'a',
	              { onClick: this.props.changeScreen.bind(this, '3'), className: isActive('3') },
	              (0, _helpers.translation)(shopScreenText)
	            ),
	            hasPaintShopValue === true && _react2.default.createElement(
	              'a',
	              { onClick: this.props.changeScreen.bind(this, '4'), className: isActive('4') },
	              (0, _helpers.translation)(prepScreenText)
	            ),
	            _react2.default.createElement(
	              'a',
	              { onClick: this.props.changeScreen.bind(this, '5'), className: isActive('5') },
	              (0, _helpers.translation)('254')
	            ),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.props.auth.myscreen.Active && _react2.default.createElement(
	              'a',
	              { onClick: this.props.changeScreen.bind(this, '7'), className: isActive('7') },
	              (0, _helpers.translation)('1857')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DropdownBox;
	}(_react.PureComponent);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(DropdownBox);

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _lodash = __webpack_require__(27);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Dragula = __webpack_require__(290);
	
	var _Dragula2 = _interopRequireDefault(_Dragula);
	
	__webpack_require__(1415);
	
	var _backdrop = __webpack_require__(29);
	
	var _orders = __webpack_require__(21);
	
	var _auth = __webpack_require__(68);
	
	var _assign = __webpack_require__(148);
	
	var _common = __webpack_require__(25);
	
	var _auth2 = __webpack_require__(8);
	
	var _filter = __webpack_require__(307);
	
	var _detect = __webpack_require__(102);
	
	var _helpers = __webpack_require__(2);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _MyTasks = __webpack_require__(415);
	
	var _MyTasks2 = _interopRequireDefault(_MyTasks);
	
	var _OverviewStatusSelection = __webpack_require__(443);
	
	var _OverviewStatusSelection2 = _interopRequireDefault(_OverviewStatusSelection);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _MoveModal = __webpack_require__(458);
	
	var _MoveModal2 = _interopRequireDefault(_MoveModal);
	
	var _LoginAsModal = __webpack_require__(457);
	
	var _LoginAsModal2 = _interopRequireDefault(_LoginAsModal);
	
	var _QualityCheckModal = __webpack_require__(204);
	
	var _QualityCheckModal2 = _interopRequireDefault(_QualityCheckModal);
	
	var _NewOrdersModal = __webpack_require__(238);
	
	var _NewOrdersModal2 = _interopRequireDefault(_NewOrdersModal);
	
	var _MultiStart = __webpack_require__(1096);
	
	var _MultiStart2 = _interopRequireDefault(_MultiStart);
	
	var _Item = __webpack_require__(416);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _AssignItem = __webpack_require__(227);
	
	var _AssignItem2 = _interopRequireDefault(_AssignItem);
	
	var _AssignBox = __webpack_require__(196);
	
	var _AssignBox2 = _interopRequireDefault(_AssignBox);
	
	var _DropdownBox = __webpack_require__(878);
	
	var _DropdownBox2 = _interopRequireDefault(_DropdownBox);
	
	var _SearchFilter = __webpack_require__(447);
	
	var _SearchFilter2 = _interopRequireDefault(_SearchFilter);
	
	var _StopOtherOrders = __webpack_require__(299);
	
	var _StopOtherOrders2 = _interopRequireDefault(_StopOtherOrders);
	
	var _OrderCapacityOverview = __webpack_require__(306);
	
	var _OrderCapacityOverview2 = _interopRequireDefault(_OrderCapacityOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Dragula from 'react-dragula'
	
	
	// import styles
	
	
	// Constants
	
	// Actions
	
	
	// Utils
	
	
	// import components
	
	
	// Elements
	
	
	// Modals
	
	
	// Item component
	
	
	var Workscreen = function (_Component) {
	  _inherits(Workscreen, _Component);
	
	  function Workscreen(props) {
	    _classCallCheck(this, Workscreen);
	
	    var _this = _possibleConstructorReturn(this, (Workscreen.__proto__ || Object.getPrototypeOf(Workscreen)).call(this, props));
	
	    _this.state = {
	      view: 'workscreen',
	      steps: [],
	      StepAssignments: [],
	      moveItem: {
	        open: false,
	        type: 0,
	        item: {}
	      },
	      loginasmodal: false,
	      loginasmodalData: {},
	      quality: {
	        open: false,
	        data: {},
	        index: 0,
	        pos: 0,
	        move: true,
	        onlyProcessComments: false
	      },
	      overviewstatusmodal: false,
	      openDropdownLeft: false,
	      screenview: '1',
	      addPopupShow: false,
	      addPopupClickedAsShop: false,
	      openAction: false,
	      openStartStop: false,
	      filterOpen: false,
	      searchFilter: {
	        Screen: 'workscreen',
	        SelectedWorkScreenType: 1,
	        SimpleSearch: '',
	        Steps: [],
	        Process: {
	          draft: false,
	          draft1: false,
	          draft2: false,
	          InProcess: true,
	          Completed: false
	        }
	      },
	      initialSearchFilter: {
	        Screen: 'workscreen',
	        SelectedWorkScreenType: 1,
	        Steps: [],
	        Process: {
	          draft: false,
	          draft1: false,
	          draft2: false,
	          InProcess: true,
	          Completed: false
	        }
	      },
	      OpenstartModal: {
	        open: false,
	        step: 0
	      },
	      OrderStarts: {
	        selectedOrderIds: [],
	        selectedUserIds: [],
	        Id: 0,
	        first: true,
	        start: false,
	        larst: false
	      },
	      MoveOrders: {
	        open: false,
	        MoveAll: null,
	        OrderIds: [],
	        FromStep: 0,
	        ToStep: 0,
	        step: 0,
	        index: 0,
	        Id: 0
	      },
	      isIExplorer: false,
	      isEdge: false,
	      isFireFox: false,
	      renderSteps: [],
	      isLoadingFromInit: false,
	      showTasks: false,
	      pinTasks: false
	    };
	    _this.md = new window.MobileDetect(window.navigator.userAgent);
	    _this.drake = null;
	    _this.scroller = null;
	    _this.events = null;
	    _this.renderBoard = _this.renderBoard.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.initiateMove = _this.initiateMove.bind(_this);
	    _this.closeMove = _this.closeMove.bind(_this);
	    _this.updateRow = _this.updateRow.bind(_this);
	    _this.handleRowUpdate = _this.handleRowUpdate.bind(_this);
	    _this.completeOrder = _this.completeOrder.bind(_this);
	    _this.onStartAsShopLogin = _this.onStartAsShopLogin.bind(_this);
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.closeLoginAs = _this.closeLoginAs.bind(_this);
	    _this.closeAssign = _this.closeAssign.bind(_this);
	    _this.getAssignOrderData = _this.getAssignOrderData.bind(_this);
	    _this.onAssignUsers = _this.onAssignUsers.bind(_this);
	    _this.initOrder = _this.initOrder.bind(_this);
	    _this.updateFromOrderSocket = _this.updateFromOrderSocket.bind(_this);
	    _this.renderDropdownLeft = _this.renderDropdownLeft.bind(_this);
	    _this.showAddPopup = _this.showAddPopup.bind(_this);
	    _this.openFilter = _this.openFilter.bind(_this);
	    _this.quickSearch = _this.quickSearch.bind(_this);
	    _this.onSearchSubmit = _this.onSearchSubmit.bind(_this);
	    _this.updateSteps = _this.updateSteps.bind(_this);
	    _this.updateRemainingTime = _this.updateRemainingTime.bind(_this);
	    _this.pressed = _this.pressed.bind(_this);
	    _this.closeOrderStart = _this.closeOrderStart.bind(_this);
	    _this.start = _this.start.bind(_this);
	    _this.setWorkscreenView = _this.setWorkscreenView.bind(_this);
	    _this.getVerticalScrollOffset = _this.getVerticalScrollOffset.bind(_this);
	    _this.getHorizontalScrollOffset = _this.getHorizontalScrollOffset.bind(_this);
	    _this.getScreenView = _this.getScreenView.bind(_this);
	    _this.orderMovedUpdateOrderSteps = _this.orderMovedUpdateOrderSteps.bind(_this);
	    _this.moveOrderSuccess = _this.moveOrderSuccess.bind(_this);
	    _this.app = null;
	    _this.lock = false;
	    _this.delta = 0;
	    _this.lastDirection = null;
	    _this.lastDelta = 0;
	    _this.deltaX = 0;
	    _this.canScroll = true;
	    _this.moveOrders = _this.moveOrders.bind(_this);
	    _this.panHandler = _this.panHandler.bind(_this);
	    _this.toggleTasks = _this.toggleTasks.bind(_this);
	    _this.toggleTaskPin = _this.toggleTaskPin.bind(_this);
	    return _this;
	  }
	
	  _createClass(Workscreen, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkOpenCapacityOverview();
	      this.lastDateUsed = false;
	      this._mounted = true;
	      // EventEmitter.addListener('WORKSCREEN_VIEW_CHANGED', this.setWorkscreenView, this)
	      _events2.default.removeListener('workcard_delete', this.handleDelete);
	      _events2.default.removeListener('update_row-workscreen', this.handleRowUpdate);
	      _events2.default.removeListener('updateorderlist', this.initOrder);
	      _events2.default.removeListener('ORDER_SOCKET', this.updateFromOrderSocket);
	      _events2.default.removeListener('ORDER_TIMES', this.updateRemainingTime);
	
	      _events2.default.addListener('workcard_delete', this.handleDelete, this);
	      _events2.default.addListener('update_row-workscreen', this.handleRowUpdate, this);
	      _events2.default.addListener('updateorderlist', this.initOrder, this);
	      _events2.default.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this);
	      _events2.default.addListener('ORDER_TIMES', this.updateRemainingTime, this);
	
	      this.reconnectSocket();
	      this.setBodyClass(false);
	
	      var isTouch = (0, _detect.isTouchDevice)();
	      if (this.props.workscreenOrders.length === 0) {
	        this.setWorkscreenView(true);
	      }
	      var filterData = (0, _filter.getOrderFilterData)(_extends({}, this.props, { source: 'workscreen' }));
	      // let filter = this.props.filter
	      var filter = filterData.filter;
	
	      // if (isEqual(this.props.filter, this.props.initialFilter)) {
	      //   let storedFilter = JSON.parse(window.localStorage.getItem('filterWorkscreen'))
	      //   if (storedFilter !== undefined) {
	      //     filter = storedFilter
	      //   }
	      // }
	      // let simpleSearch = JSON.parse(window.localStorage.getItem('simplesearchWorkscreen'))
	      // // let simpleSearch = filterData.simpleSearch
	      // if (simpleSearch !== undefined && simpleSearch !== null && simpleSearch.value !== undefined && simpleSearch.value !== null && simpleSearch.value.length > 0) {
	      //   filter.SimpleSearch = simpleSearch.value
	      // }
	
	      if (filterData.hasSimpleSearch) {
	        filter.SimpleSearch = filterData.simpleSearch.value;
	      }
	
	      this.setState({
	        isIExplorer: navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1,
	        isEdge: navigator.userAgent.indexOf('Edge') > -1,
	        isFireFox: navigator.userAgent.indexOf('Firefox') > -1,
	        isTouch: isTouch === true || Number(isTouch) > 0,
	
	        showTasks: window.localStorage.getItem('workscreen_pin_tasks') === 'true',
	        pinTasks: window.localStorage.getItem('workscreen_pin_tasks') === 'true',
	
	        searchFilter: _extends({}, this.state.searchFilter, filter)
	      });
	
	      if (filter === undefined || filter === null || (0, _lodash.isEqual)(filter, { NewOrdersFilter: 0 })) {
	        filter = _extends({}, this.props.initialFilter);
	      }
	      this.props.setOrdersFilter(_extends({}, filter, { NewOrdersFilter: 0 }), 'workscreen');
	
	      // Check if need to open capacity overview
	      var location = this.props.router.location;
	      if (location.query.destination && location.query.destination === 'capacityoverview') {
	        this.props.openOverlay('OrderCapacityOverview');
	        this.props.router.replace(_extends({}, location, { query: {} })); // Reset query to only trigger once.
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.lastDateUsed = false;
	      this._mounted = false;
	      if (this.drake !== null) {
	        this.drake.destroy();
	      }
	      if (this.scroller !== null) {
	        this.scroller.destroy();
	      }
	      var steps = [];
	      this.props.updateWorkscreenList(steps);
	      this.props.triggerPopupActionBG(false);
	      _events2.default.removeListener('WORKSCREEN_VIEW_CHANGED', this.setWorkscreenView);
	      _events2.default.removeListener('workcard_delete', this.handleDelete);
	      _events2.default.removeListener('update_row-workscreen', this.handleRowUpdate);
	      _events2.default.removeListener('updateorderlist', this.initOrder);
	      _events2.default.removeListener('ORDER_SOCKET', this.updateFromOrderSocket);
	      _events2.default.removeListener('ORDER_TIMES', this.updateRemainingTime);
	      this.setBodyClass(true);
	    }
	  }, {
	    key: 'checkOpenCapacityOverview',
	    value: function checkOpenCapacityOverview() {
	      var routeItems = window.LocalstorageStack.all();
	      var index = routeItems.length - 3;
	      if (routeItems && routeItems.length > 3 && routeItems[index].pathname === 'OrderCapacityOverview') {
	        this.props.openOverlay('OrderCapacityOverview');
	      }
	    }
	  }, {
	    key: 'checkForPopups',
	    value: function checkForPopups() {
	      var item = document.getElementsByClassName('poppedup')[0];
	      if (item !== undefined) {
	        var itembounding = item.getBoundingClientRect();
	        var app = item.parentElement;
	        var itemparrent = item.parentElement;
	        var itemparrentBounding = itemparrent.getBoundingClientRect();
	        while (app.className !== 'drag-content scrollbar') {
	          app = app.parentElement;
	        }
	        var windowWith = window.innerWidth;
	        var windowHeight = window.innerHeight;
	        if (itembounding.left < 0) {
	          if (windowWith > itembounding.width * 2 + itembounding.left) {
	            item.style.left = 0;
	          } else {
	            var margin = (windowWith - itembounding.width) / 2;
	            item.style.right = itembounding.left - margin;
	          }
	        }
	
	        if (itembounding.right < 0) {
	          if (windowWith > itembounding.width * 2 + itembounding.right) {
	            item.style.right = 0;
	          } else {
	            var _margin = (windowWith - itembounding.width) / 2;
	            item.style.left = itembounding.right - _margin;
	          }
	        }
	
	        if (itembounding.top < 0) {
	          app.scrollTop = app.scrollTop + itembounding.top;
	        }
	        var bottomOffset = windowHeight - (itembounding.top + itembounding.height);
	        var topOffset = itemparrentBounding.top - itembounding.height;
	        if (bottomOffset < 0 && topOffset > 160) {
	          item.style.bottom = '100%';
	          item.style.top = 'auto';
	        }
	      }
	    }
	  }, {
	    key: 'setWorkscreenView',
	    value: function setWorkscreenView(doInitOrder, props, fromNewUser) {
	      var _this2 = this;
	
	      if (props === undefined) props = this.props;
	      var screenView = this.getScreenView(props, fromNewUser);
	      this.setState({
	        screenview: '' + screenView,
	        renderSteps: this.getStepsFromView(screenView),
	        searchFilter: _extends({}, this.state.searchFilter, {
	          SelectedWorkScreenType: parseInt(screenView)
	        })
	      }, function () {
	        if (doInitOrder && _this2._mounted) {
	          if (fromNewUser) {
	            var filter = _extends({}, props.initialFilter, { SelectedWorkScreenType: parseInt(screenView) });
	            setTimeout(function () {
	              _this2.initOrder(screenView, filter);
	            }, 100); // Fix to wait for reset filter dispatch to complete
	          } else {
	            _this2.initOrder(screenView);
	          }
	        }
	        if (doInitOrder === false && _this2._mounted) {
	          var addPopupShow = _this2.state.addPopupShow;
	          var addPopupClickedAsShop = _this2.state.addPopupClickedAsShop;
	          if (addPopupShow === false && addPopupClickedAsShop === true) {
	            addPopupShow = addPopupClickedAsShop;
	            _this2.setState({
	              addPopupShow: addPopupShow,
	              addPopupClickedAsShop: !addPopupShow
	            }, function () {
	              // console.log('[NewWorkscreen][setWorkscreenView] addpopupshow', addPopupShow)
	              if (_this2.state.addPopupShow) {
	                _this2.props.triggerPopup(_this2.state.addPopupShow);
	              }
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getScreenView',
	    value: function getScreenView(props, fromNewUser) {
	      var screenView = '0';
	      var prevscreen = void 0;
	      if (props.auth.inactiveUsers[props.auth.inactiveUsers.length - 1] !== undefined) {
	        prevscreen = props.auth.inactiveUsers[props.auth.inactiveUsers.length - 1].PrevWorkscreenView;
	        if (prevscreen !== undefined && prevscreen !== null && prevscreen !== 'null') {
	          screenView = prevscreen;
	          // console.log('[NewWorkscreen] set prevscreen', screenView, props.auth)
	        }
	      }
	      var storedView = window.localStorage.getItem('workscreen_view');
	      if (typeof storedView !== 'undefined' && storedView !== null && storedView !== 'null') {
	        screenView = storedView;
	        if (fromNewUser && parseInt(props.auth.user.WorkscreenView) === 7) {
	          // console.log('[NewWorkscreen] fromNewUser', screenView, props.auth)
	          screenView = props.auth.user.WorkscreenView;
	        }
	        var storedDepartment = parseInt(window.localStorage.getItem('department_type'));
	        if (storedDepartment !== parseInt(props.auth.user.DepartmentType)) {
	          var view = '1';
	          var department = parseInt(props.auth.user.DepartmentType);
	          switch (department) {
	            case 0:
	              view = '0';
	              break;
	            case 1:
	              view = '2';
	              break;
	            case 2:
	              view = '1';
	              break;
	          }
	          screenView = view;
	        }
	
	        // console.log('[NewWorkscreen] from stored view', screenView, prevscreen)
	        // } else if (props.auth.user.hasLoggedInBefore && !this.state.gotViewFromUser) {
	        //   screenView = props.auth.user.WorkscreenView
	        //   this.setState({
	        //     gotViewFromUser: true
	        //   })
	      } else {
	        screenView = props.auth.user.WorkscreenView;
	        // console.log('[NewWorkscreen] from from user view', screenView, prevscreen, props.auth)
	      }
	
	      // Validate screen allowed
	      var paintScreens = ['0', '3', '4'];
	      var bodyScreens = ['2', '6'];
	      var combinedScreens = ['1'];
	      // let anyScreens = ['5', '7']
	
	      var hasPaintShopValue = (0, _auth2.hasPaintShop)(props.auth);
	      var hasBodyShopValue = (0, _auth2.hasBodyShop)(props.auth);
	      var hasCombinedBodyPaintShopValue = (0, _auth2.hasCombinedBodyPaintShop)(props.auth);
	      // console.log('hasPaintShopValue', hasPaintShopValue, ' hasBodyShopValue', hasBodyShopValue, ' hasCombinedBodyPaintShopValue', hasCombinedBodyPaintShopValue)
	
	      var invalidScreen = false;
	      if (!hasPaintShopValue && paintScreens.indexOf(screenView) !== -1) {
	        invalidScreen = true;
	      }
	      if (!hasBodyShopValue && bodyScreens.indexOf(screenView) !== -1) {
	        invalidScreen = true;
	      }
	      if (!hasCombinedBodyPaintShopValue && combinedScreens.indexOf(screenView) !== -1) {
	        invalidScreen = true;
	      }
	
	      if (invalidScreen) {
	        // console.log('invalid screen', screenView)
	        if (hasCombinedBodyPaintShopValue) {
	          screenView = 1;
	        } else if (hasPaintShopValue) {
	          screenView = 0;
	        } else if (hasBodyShopValue) {
	          screenView = 2;
	        }
	      }
	
	      window.localStorage.setItem('workscreen_view', screenView);
	      // console.log('[NewWorkscreen] getScreenView end', screenView)
	      return screenView;
	    }
	  }, {
	    key: 'setBodyClass',
	    value: function setBodyClass(out) {
	      setTimeout(function () {
	        if (out) {
	          document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('workscreen__body', '');
	        } else {
	          document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className + ' workscreen__body';
	        }
	      }, 0);
	    }
	  }, {
	    key: 'reconnectSocket',
	    value: function reconnectSocket() {
	      if (window.sock.readyState === window.sock.OPEN) {
	        var shopId = JSON.parse(window.localStorage.user_data).ShopId;
	        if (parseInt(shopId) === 0 && window.localStorage.loginAsUser) {
	          shopId = JSON.parse(window.localStorage.loginAsUser).ShopId;
	        }
	        window.sock.send(JSON.stringify({
	          Type: 'RECONNECT',
	          ShopId: parseInt(shopId)
	        }));
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // if (prevState.addPopupShow !== this.state.addPopupShow) {
	      //   console.log('[NewWorkscreen][componentDidUpdate] addPopupShow', prevState.addPopupShow, this.state.addPopupShow)
	      // }
	      // if (prevState.addPopupClickedAsShop !== this.state.addPopupClickedAsShop) {
	      //   console.log('[NewWorkscreen][componentDidUpdate] addPopupClickedAsShop', prevState.addPopupClickedAsShop, this.state.addPopupClickedAsShop)
	      // }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextState) {
	      var _this3 = this;
	
	      // console.log('recieved props', this._mounted, this.props.router.location.pathname)
	      if (this._mounted === false || this.props.router.location.pathname !== '/workscreen') return;
	      this.lastDateUsed = false;
	      // let savedScreen = window.localStorage.getItem('workscreen_view')
	      if (!(0, _lodash.isEqual)(this.state.steps, nextProps.workscreenOrders) && (0, _lodash.isEqual)(this.props.auth, nextProps.auth) && !nextProps.auth.prevWorkscreen && !this.props.auth.prevWorkscreen) {
	        // console.log('[NewWorkscreen] revieced new workscreenOrders', nextProps.auth)
	        this.setState({
	          steps: nextProps.workscreenOrders
	        }, function () {
	          return _this3.setWorkscreenView(false, nextProps);
	        });
	      } else if (!(0, _lodash.isEqual)(this.props.auth.user, nextProps.auth.user) && !nextProps.auth.user.hasLoggedInBefore) {
	        // console.log('[NewWorkscreen] revieced new user', nextProps.auth.user.WorkscreenView)
	        this.setWorkscreenView(true, nextProps, true);
	      } else if (nextProps.auth.prevWorkscreen !== undefined && nextProps.auth.prevWorkscreen !== null) {
	        var screenView = nextProps.auth.prevWorkscreen;
	        window.localStorage.setItem('workscreen_view', screenView);
	        _store2.default.dispatch(this.props.setPrevWorkscreen(null));
	        this.setState({
	          steps: nextProps.workscreenOrders
	        }, function () {
	          // console.log('[NewWorkscreen] set prevworkscreen', this.state)
	        });
	        // console.log('prevscreenview has value', screenView)
	        // this.setState({
	        //   screenview: '' + screenView,
	        //   renderSteps: this.getStepsFromView(screenView),
	        //   searchFilter: {
	        //     ...this.state.searchFilter,
	        //     SelectedWorkScreenType: parseInt(screenView)
	        //   }
	        // }, () => {
	        //   this.props.setPrevWorkscreen(null)
	        // })
	      }
	    }
	  }, {
	    key: 'openFilter',
	    value: function openFilter() {
	      var _this4 = this;
	
	      this.setState({
	        filterOpen: !this.state.filterOpen
	      }, function () {
	        if (_this4.state.filterOpen) {
	          if (_this4.refs.SearchFilter.getWrappedInstance().refs.simpleSearch !== undefined) {
	            _this4.refs.SearchFilter.getWrappedInstance().refs.simplesearch.focus();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'quickSearch',
	    value: function quickSearch(val) {
	      var _this5 = this;
	
	      // console.log('workscreen quickSearch', val)
	      this.setState({
	        isLoading: true,
	        filterOpen: false,
	        searchFilter: {
	          Screen: 'workscreen',
	          SelectedWorkScreenType: parseInt(this.state.screenview),
	          SimpleSearch: val,
	          SkipCheck: true
	        }
	      }, function () {
	        _this5.initOrder();
	      });
	    }
	  }, {
	    key: 'onSearchSubmit',
	    value: function onSearchSubmit(filter) {
	      var _this6 = this;
	
	      // console.log('workscreen onSearchSubmit', filter)
	      this.setState({
	        isLoading: true,
	        filterOpen: false,
	        searchFilter: _extends({}, filter, {
	          Screen: 'workscreen',
	          SelectedWorkScreenType: parseInt(this.state.screenview),
	          movedOrders: false,
	          process: {
	            InProcess: true
	          }
	        })
	      }, function () {
	        _this6.initOrder();
	      });
	    }
	  }, {
	    key: 'updateRemainingTime',
	    value: function updateRemainingTime(json) {
	      var steps = [].concat(_toConsumableArray(this.state.steps));
	      steps.map(function (step, key) {
	        if (['1', '2', '3', '4', '5', '6', '7', '101', '102', '103', '104'].includes(step.Title)) {
	          // if (step.Title === '1' || step.Title === '2' || step.Title === '3' || step.Title === '4' ||
	          //   step.Title === '5' || step.Title === '6' || step.Title === '7') {
	          step.Orders.map(function (order, orderKey) {
	            if (order.IsStarted) {
	              json.Data.map(function (remainingTime, timeKey) {
	                if (order.Id === remainingTime.OrderId) {
	                  order.RemainingTimeDelay = remainingTime.Delay;
	                  order.ColoredParts = remainingTime.ColoredParts;
	                }
	              });
	            }
	          });
	        }
	      });
	      // this.setState({
	      //   steps: steps
	      // })
	      this.setState(function (prevState) {
	        return {
	          steps: steps
	        };
	      });
	    }
	  }, {
	    key: 'updateFromOrderSocket',
	    value: function updateFromOrderSocket(json) {
	      // console.log('workscreen updateFromOrderSocket', json)
	      switch (json.Type) {
	        case 'ORDER_UPDATE':
	          this.updateSingleOrder(json.Data);
	          break;
	        case 'ORDER_STARTED':
	        case 'ORDER_STOPPED':
	          this.updateMultipleOrders(json.Data);
	          break;
	        case 'ORDER_MOVED':
	          if (json.Data.MovedOrderIds !== undefined || json.Data.MovedOrderId !== undefined) {
	            // if (this.props.auth.user.DeviceToken === json.DeviceToken) console.log('Request came from my client!')
	            if (this.props.auth.user === undefined || this.props.auth.user.DeviceToken === undefined || this.props.auth.user.DeviceToken === null || this.props.auth.user.DeviceToken !== json.DeviceToken) {
	              this.orderMovedUpdateOrderSteps(json.Data);
	            }
	          } else {
	            this.updateOrderSteps(json.Data.data);
	          }
	          break;
	
	        default:
	          // console.log(json.Data)
	          // console.log('DEFAULT SOCKET HANDLING: (updateOrderSteps)')
	          if (json.Data.data !== undefined) {
	            this.updateOrderSteps(json.Data.data);
	          } else {
	            this.updateOrderSteps(json.Data);
	          }
	          break;
	      }
	    }
	  }, {
	    key: 'updateMultipleOrders',
	    value: function updateMultipleOrders(data) {
	      var _this7 = this;
	
	      // console.log('workscreen updateMultipleOrders', data)
	      if (data.OrderIds === undefined || data.OrderIds === null || data.OrderIds.length === 0) return;
	      var filter = _extends({}, this.state.searchFilter, {
	        identification: {
	          ordernumbers: data.OrderIds
	        }
	      });
	      this.props.getOrdersNew(filter).then(function (res) {
	        var resultSteps = res.data[0].Steps;
	        var stepsOriginal = [].concat(_toConsumableArray(_this7.state.steps));
	        resultSteps.map(function (resultStep, key) {
	          resultSteps[key].Orders.map(function (v, k) {
	            // Find step in stepsOriginal
	            var stepsOriginalIndex = stepsOriginal.findIndex(function (s) {
	              return s.StepId === resultStep.StepId;
	            });
	            if (stepsOriginalIndex !== -1) {
	              // Find order in step
	              var orderIndexOriginal = stepsOriginal[stepsOriginalIndex].Orders.findIndex(function (o) {
	                return o.Id === v.Id;
	              });
	              if (orderIndexOriginal !== -1) {
	                stepsOriginal[stepsOriginalIndex].Orders[orderIndexOriginal] = _extends({}, v, {
	                  mathRandom: Math.random()
	                });
	              }
	            }
	          });
	        });
	        _this7.setState(function (prevState) {
	          return {
	            steps: stepsOriginal
	          };
	        });
	      });
	    }
	  }, {
	    key: 'updateSingleOrder',
	    value: function updateSingleOrder(data) {
	      var _this8 = this;
	
	      var steps = [].concat(_toConsumableArray(this.state.steps));
	      // check if the order must be update
	      if (!(0, _orders.mustOrderUpdateDueToSocket)([data.Id], steps)) return;
	
	      var selectedStep = void 0;
	      steps.map(function (step) {
	        if (step.StepId === data.StepId) {
	          selectedStep = step;
	        }
	      });
	
	      if (typeof selectedStep !== 'undefined') {
	        var getFromServer = data.IsUpdateRequired !== undefined && data.IsUpdateRequired === true;
	        if (getFromServer) {
	          var filter = _extends({}, this.state.searchFilter, {
	            identification: {
	              ordernumber: {
	                value: data.Id,
	                option: 1
	              }
	            }
	            // console.log('Call getOrdersNew from updateSingleOrder')
	          });this.props.getOrdersNew(filter).then(function (res) {
	            // console.log('UPDATE SINGLE ORDER', res.data)
	            var searchSteps = res.data[0].Steps;
	            var foundOrder = null;
	            for (var s = 0; s < searchSteps.length; s++) {
	              if (searchSteps[s].Orders !== undefined && searchSteps[s].Orders.length > 0) {
	                for (var o = 0; o < searchSteps[s].Orders.length; o++) {
	                  if (searchSteps[s].Orders[o].Id === data.Id) {
	                    foundOrder = searchSteps[s].Orders[o];
	                    break;
	                  }
	                }
	              }
	              if (foundOrder !== null) break;
	            }
	
	            // Insert new order data...
	            selectedStep.Orders = selectedStep.Orders.map(function (order) {
	              if (foundOrder !== null && order.Id === foundOrder.Id) {
	                var orderCopy = _extends({}, order);
	                orderCopy.Id = foundOrder.Id;
	                orderCopy.IsStarted = foundOrder.IsStarted;
	                orderCopy.StepId = foundOrder.StepId;
	                orderCopy.Employees = foundOrder.Employees;
	                orderCopy.Model = foundOrder.Model;
	                orderCopy.RegNumber = foundOrder.RegNumber;
	                orderCopy.Transport = foundOrder.Transport;
	                orderCopy.IsLinkMain = foundOrder.IsLinkMain;
	                orderCopy.PreviouslyStarted = foundOrder.PreviouslyStarted;
	                orderCopy.InspectionStepsCompleted = foundOrder.InspectionStepsCompleted;
	                orderCopy.InspectionStepsTotal = foundOrder.InspectionStepsTotal;
	                orderCopy.DisplayedTimePrt1 = foundOrder.DisplayedTimePrt1;
	                orderCopy.DisplayedTimePrt2 = foundOrder.DisplayedTimePrt2;
	                orderCopy.CustomerName = foundOrder.CustomerName;
	                orderCopy.HasNotes = foundOrder.HasNotes;
	                orderCopy.UnreadNotes = foundOrder.UnreadNotes;
	                orderCopy.ColorIsReady = foundOrder.ColorIsReady;
	                orderCopy.MissingParts = foundOrder.MissingParts;
	                orderCopy.ColorVariant = foundOrder.ColorVariant;
	                orderCopy.IsStopped = foundOrder.IsStopped;
	                orderCopy.StoppedMessage = foundOrder.StoppedMessage;
	                orderCopy.OrderStop = foundOrder.OrderStop;
	                orderCopy.BodySparePartStatusSum = foundOrder.BodySparePartStatusSum;
	                orderCopy.PaintSparePartStatusSum = foundOrder.PaintSparePartStatusSum;
	                orderCopy.mathRandom = Math.random();
	                order = orderCopy;
	              }
	              return order;
	            });
	            _this8.setState(function (prevState) {
	              return {
	                steps: steps
	              };
	            });
	          });
	        } else {
	          // console.log('Update order', data.Id, 'with', data)
	          selectedStep.Orders = selectedStep.Orders.map(function (order) {
	            if (order.Id === data.Id) {
	              var orderCopy = _extends({}, order);
	              orderCopy.Id = data.Id;
	              orderCopy.IsStarted = data.IsStarted;
	              orderCopy.StepId = data.StepId;
	              orderCopy.Employees = data.Employees;
	              orderCopy.Model = data.Model;
	              orderCopy.RegNumber = data.RegNumber;
	              orderCopy.Transport = data.Transport;
	              orderCopy.IsLinkMain = data.IsLinkMain;
	              orderCopy.PreviouslyStarted = data.PreviouslyStarted;
	              orderCopy.InspectionStepsCompleted = data.InspectionStepsCompleted;
	              orderCopy.InspectionStepsTotal = data.InspectionStepsTotal;
	              orderCopy.DisplayedTimePrt1 = data.DisplayedTimePrt1;
	              orderCopy.DisplayedTimePrt2 = data.DisplayedTimePrt2;
	              orderCopy.CustomerName = data.CustomerName;
	              orderCopy.HasNotes = data.HasNotes;
	              orderCopy.ColorIsReady = data.ColorIsReady;
	              orderCopy.ColorVariant = data.ColorVariant;
	              orderCopy.IsStopped = data.IsStopped;
	              orderCopy.StoppedMessage = data.StoppedMessage;
	              orderCopy.mathRandom = Math.random();
	              order = orderCopy;
	            }
	            return order;
	          });
	          this.setState(function (prevState) {
	            return {
	              steps: steps
	            };
	          });
	        }
	      }
	    }
	  }, {
	    key: 'stepHasComments',
	    value: function stepHasComments(data) {
	      var ProcessComments = data.ProcessComments;
	      var anyComments = false;
	      if (ProcessComments) {
	        ProcessComments.map(function (val) {
	          if (val.StepComments.length !== 0) anyComments = true;
	        });
	      } else if (data.Checks) {
	        data.Checks.map(function (check) {
	          check.ProcessComments.map(function (val) {
	            if (val.StepComments.length !== 0) anyComments = true;
	          });
	        });
	      }
	
	      return anyComments;
	    }
	  }, {
	    key: 'getStepsFromView',
	    value: function getStepsFromView(view) {
	      var _this9 = this;
	
	      if (view === undefined) view = this.state.screenview;
	      switch (view) {
	        case '0':
	          return [1, 5, 6, 7, 8, 10, 14];
	        case '1':
	          return [];
	        case '2':
	          return [1, 2, 3, 4, 11, 12, 13, 14];
	        case '3':
	          return [1, 5, 6, 7, 8];
	        case '4':
	          return [1, 7, 8, 10, 14];
	        case '5':
	          return [1, 10, 14];
	        case '6':
	          return [2, 3, 4, 11, 13];
	        case '7':
	          if (!this.props.auth.myscreen.Active) {
	            return [];
	          } else {
	            var activeSteps = [];
	            var screenValues = [{ val: 1, step: 1 }, { val: 2, step: 5 }, { val: 3, step: 6 }, { val: 4, step: 7 }, { val: 5, step: 8 }, { val: 6, step: 10 }, { val: 7, step: 14 }, { val: 101, step: 2 }, { val: 102, step: 3 }, { val: 103, step: 11 }, { val: 104, step: 13 }];
	            screenValues.map(function (screen) {
	              if (_this9.props.auth.myscreen['Step' + screen.val]) {
	                activeSteps.push(screen.step);
	              }
	            });
	            return activeSteps;
	          }
	        default:
	          return [];
	      }
	    }
	  }, {
	    key: 'orderMovedUpdateOrderSteps',
	    value: function orderMovedUpdateOrderSteps(data) {
	      var _this10 = this;
	
	      // console.log('ORDER-MOVED-UPDATE-ORDER-STEPS', data)
	      var steps = [].concat(_toConsumableArray(this.state.steps));
	      var selectedMovedFromStep = void 0;
	      var selectedMovedToStep = void 0;
	      steps.map(function (step) {
	        if (step.StepId === data.MovedTo) {
	          selectedMovedToStep = step;
	        } else if (step.StepId === data.MovedFrom) {
	          selectedMovedFromStep = step;
	        }
	      });
	
	      var orderIds = data.MovedOrderIds !== undefined ? data.MovedOrderIds : [data.MovedOrderId];
	      // check if the order must be update
	      if (!(0, _orders.mustOrderUpdateDueToSocket)(orderIds, steps)) return;
	
	      var filter = _extends({}, this.state.searchFilter, {
	        identification: {
	          OrderNumbers: orderIds
	        }
	      });
	
	      this.props.getOrdersNew(filter).then(function (res) {
	        var searchSteps = res.data[0].Steps;
	
	        var _loop = function _loop(i) {
	          var orderId = orderIds[i] + '';
	          var foundOrder = null;
	          for (var s = 0; s < searchSteps.length; s++) {
	            if (searchSteps[s].Orders !== undefined && searchSteps[s].Orders.length > 0) {
	              for (var o = 0; o < searchSteps[s].Orders.length; o++) {
	                if (searchSteps[s].Orders[o].OrderKey === orderId && searchSteps[s].Orders[o]) {
	                  foundOrder = searchSteps[s].Orders[o];
	                  break;
	                }
	              }
	            }
	            if (foundOrder !== null) break;
	          }
	
	          // Remove order in 'moved from' step
	          if (selectedMovedFromStep !== undefined) {
	            var indexInFrom = selectedMovedFromStep.Orders.findIndex(function (order) {
	              return order.OrderKey === orderId;
	            });
	            if (indexInFrom >= 0) {
	              selectedMovedFromStep.Orders.splice(indexInFrom, 1);
	            }
	          }
	
	          if (foundOrder !== null) {
	            // Insert order in 'moved to' step (remove first if already inserted)
	            if (selectedMovedToStep !== undefined) {
	              var indexInTo = selectedMovedToStep.Orders.findIndex(function (order) {
	                return order.Id === foundOrder.Id;
	              });
	              var doInsert = true;
	              if (indexInTo >= 0) {
	                doInsert = false;
	                var orderInTo = selectedMovedToStep.Orders[indexInTo];
	                if (!foundOrder.IsDisplayOnly || orderInTo.IsDisplayOnly) {
	                  // If exists in step, only replace if old is displayOnly or new is not displayOnly
	                  selectedMovedToStep.Orders.splice(indexInTo, 1);
	                  doInsert = true;
	                }
	              }
	              if (doInsert) {
	                selectedMovedToStep.Orders.push(foundOrder);
	                foundOrder.mathRandom = Math.random();
	              }
	            }
	          }
	        };
	
	        for (var i = 0; i < orderIds.length; i++) {
	          _loop(i);
	        }
	
	        if (selectedMovedToStep !== undefined) {
	          var toStepOrderKeys = selectedMovedToStep.Orders.map(function (o) {
	            return o.OrderKey;
	          });
	          var step = selectedMovedToStep.StepId;
	
	          _this10.props.getOrderSorting(step, toStepOrderKeys).then(function (res) {
	            selectedMovedToStep.Orders.sort(function (orderA, orderB) {
	              return res.data.findIndex(function (orderKey) {
	                return orderKey === orderA.OrderKey;
	              }) - res.data.findIndex(function (orderKey) {
	                return orderKey === orderB.OrderKey;
	              });
	            });
	            _this10.setState(function (prevState) {
	              return {
	                steps: steps
	              };
	            });
	          });
	        } else {
	          _this10.setState(function (prevState) {
	            return {
	              steps: steps
	            };
	          });
	        }
	      });
	    }
	  }, {
	    key: 'updateOrderSteps',
	    value: function updateOrderSteps(data) {
	      var _this11 = this;
	
	      var searchData = {
	        Steps: data,
	        Process: {
	          draft: false,
	          draft1: false,
	          draft2: false,
	          InProcess: true,
	          Completed: false
	        }
	        /*
	        this.setState({
	          searchFilter: {
	            ...this.state.searchFilter,
	            Steps: data
	          }
	        })
	        */
	      };searchData = this.state.searchFilter;
	      searchData = _extends({}, searchData, {
	        Steps: data
	        // console.log('Call getOrdersNew from updateOrderSteps')
	      });this.props.getOrdersNew(searchData).then(function (res) {
	        var steps = res.data[0].Steps;
	        var stepsOriginal = [].concat(_toConsumableArray(_this11.state.steps));
	        stepsOriginal.map(function (step, key) {
	          // if (data.indexOf(parseInt(step.Title)) !== -1) {
	          if (data.indexOf(step.StepId) !== -1) {
	            stepsOriginal[key].Orders = steps[key].Orders;
	            stepsOriginal[key].Orders.map(function (v, k) {
	              stepsOriginal[key].Orders[k] = _extends({}, v, {
	                mathRandom: Math.random()
	              });
	            });
	          }
	          return step;
	        });
	        _this11.setState(function (prevState) {
	          return {
	            steps: stepsOriginal
	          };
	        });
	      });
	    }
	  }, {
	    key: 'debindAll',
	    value: function debindAll() {
	      if (this.drake !== null) {
	        this.drake.destroy();
	      }
	      if (this.scroller !== null) {
	        this.scroller.destroy();
	      }
	      var hammerTime = new window.Hammer(window.board, {
	        inputClass: window.Hammer.TouchInput
	      });
	      hammerTime.off('swipeleft');
	      hammerTime.off('swiperight');
	    }
	  }, {
	    key: 'initOrder',
	    value: function initOrder() {
	      var _this12 = this;
	
	      var overrideScreenView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var filterOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (this.state.isLoadingFromInit || !this._mounted || this.props.router.location.pathname !== '/workscreen') return this;
	      this.debindAll();
	      this.setState({
	        steps: [],
	        isLoadingFromInit: true
	      });
	      // let steps = this.getStepsFromView()
	      // let data = {
	      //   Steps: [],
	      //   SelectedWorkScreenType: overrideScreenView !== null ? parseInt(overrideScreenView) : parseInt(this.getScreenView(this.props)),
	      //   Process: {
	      //     draft: false,
	      //     draft1: false,
	      //     draft2: false,
	      //     InProcess: true,
	      //     Completed: false
	      //   }
	      // }
	
	      var data = _extends({}, this.state.searchFilter); // don't know why 'data' was assigned twice (?)
	      if (overrideScreenView !== null) {
	        data.SelectedWorkScreenType = parseInt(overrideScreenView);
	      }
	
	      if (filterOverride !== undefined && filterOverride !== null) {
	        data = filterOverride;
	      }
	
	      // Trigger popup action BG - START
	      this.props.triggerPopupActionBG(true);
	      // Trigger popup action BG - END
	      // console.log('Call getOrdersNew from initOrder')
	      return this.props.getOrdersNew(data).then(function (res) {
	        // Trigger popup action BG - START
	        _this12.props.triggerPopupActionBG(false);
	        // Fix for when moving an order after loginas popup
	        if (_this12.state.moveItem.open) {
	          _this12.props.triggerPopup(true);
	        }
	
	        if (!_this12._mounted) return null;
	        // Trigger popup action BG - END
	        var steps = res.data[0].Steps;
	        _this12.props.updateWorkscreenList(steps);
	        _this12.setState({
	          // steps: steps,
	          view: typeof _this12.props.location.query.view !== 'undefined' ? _this12.props.location.query.view : 'workscreen',
	          isLoadingFromInit: false,
	          isLoading: false
	        }, function () {
	          if (typeof _this12.props.location.query.view !== 'undefined') {
	            _this12.getAssignOrderData();
	            _this12.props.router.replace('/workscreen');
	          } else {
	            // setTimeout(() => {
	            _this12.initDragula(steps);
	            _this12.initHammer();
	            // }, 0)
	          }
	        });
	        return res;
	      }).catch(function (_) {
	        _this12.props.triggerPopupActionBG(false);
	        window.toastr.error((0, _helpers.translation)('18079'), (0, _helpers.translation)('216'));
	      });
	    }
	
	    // Updates order data from the API for the given steps
	
	  }, {
	    key: 'updateSteps',
	    value: function updateSteps(steps) {
	      var _this13 = this;
	
	      var filter = _extends({}, this.state.searchFilter);
	      filter.Steps = steps;
	      // console.log('Call getOrdersNew from updateSteps')
	      return this.props.getOrdersNew(filter).then(function (res) {
	        var stepsUpdate = res.data[0].Steps;
	
	        // TODO: færdiggør den her..
	        var stepsData = [].concat(_toConsumableArray(_this13.state.steps));
	        for (var i = 0; i < stepsData.length; i++) {
	          for (var j = 0; j < stepsUpdate.length; j++) {
	            if (steps.filter(function (s) {
	              // console.log('s', s, 'stepsUpdate[' + j + '].Title', stepsUpdate[j].Title)
	              return s === parseInt(stepsUpdate[j].Title);
	            }) && stepsUpdate[j].Title === stepsData[i].Title) {
	              stepsData[i] = stepsUpdate[j];
	            }
	          }
	        }
	        _this13.setState({
	          steps: stepsData
	        });
	      });
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete(event) {
	      var steps = [].concat(_toConsumableArray(this.state.steps));
	      delete steps[event.step].Orders[event.index];
	      this.setState({
	        steps: steps
	      });
	    }
	  }, {
	    key: 'allowHammer',
	    value: function allowHammer() {
	      var allowSize = window.innerWidth < 1367;
	      var androidTablet = this.md.is('AndroidOS') && this.md.tablet() !== null;
	      if (this.state.isTouch && !androidTablet && allowSize) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'panHandler',
	    value: function panHandler(event) {
	      if (event.type === 'panend' || event.type === 'pancancel') {
	        // iOS bug fix
	        this.lock = false;
	        this.delta = 0;
	        this.lastDirection = null;
	        this.lastDelta = 0;
	        this.deltaX = 0;
	      } else if ((event.type === 'swipe' || event.type === 'panmove') && event.direction & window.Hammer.DIRECTION_VERTICAL) {
	        this.lock = true;
	      } else if (event.type === 'swipe' && event.direction & window.Hammer.DIRECTION_HORIZONTAL) {
	        // iOS bug fix
	        this.lock = true;
	      } else if (event.type === 'panmove' && event.direction & window.Hammer.DIRECTION_HORIZONTAL) {
	        if (this.lastDirection === null) {
	          this.lastDirection = event.direction;
	        }
	        this.deltaX = event.deltaX;
	        if (window.board.scrollLeft >= window.board.width) window.board.scrollLeft = window.board.width;
	        if (window.board.scrollLeft < 0) window.board.scrollLeft = 0;
	        if (this.lock === true || !this.canScroll || window.board.scrollLeft > window.board.width || window.board.scrollLeft < 0 || this.deltaX === this.lastDelta && window.board.scrollLeft > 0) return;
	        if (this.lastDirection !== event.direction) {
	          this.delta = this.deltaX - this.lastDelta;
	          window.board.scrollLeft -= this.delta;
	        } else {
	          this.delta = this.lastDelta - this.deltaX;
	          window.board.scrollLeft += this.delta;
	        }
	        this.lastDirection = event.direction;
	        this.lastDelta = this.deltaX;
	      }
	    }
	  }, {
	    key: 'initHammer',
	    value: function initHammer() {
	      // if (this.md.userAgent() === 'Safari' || this.md.phone()) {
	      if (!this.allowHammer()) return null;
	
	      // const getPos = () => {
	      //   if (typeof window.board.dataset.pos === 'undefined') {
	      //     return 1
	      //   }
	      //   return parseInt(window.board.dataset.pos)
	      // }
	      // let hammerTime = new window.Hammer(window.board, {
	      //   inputClass: window.Hammer.TouchInput
	      // })
	      // if (window.innerHeight < 600 || window.innerWidth < 600) {
	      //   hammerTime.on('swipeleft', (ev) => {
	      //     let newPos = (getPos() !== this.state.steps.length) ? (getPos() + 1) : getPos()
	      //     this.changePage(newPos)
	      //   })
	      //   hammerTime.on('swiperight', (ev) => {
	      //     let newPos = (getPos() > 1) ? (getPos() - 1) : getPos()
	      //     this.changePage(newPos)
	      //   })
	      // } else {
	      // hammerTime.add(new window.Hammer.Pan({ direction: window.Hammer.DIRECTION_HORIZONTAL, threshold: 10 }))
	      // hammerTime.on('panstart panmove panend pancancel swipe', this.panHandler)
	      // }
	    }
	  }, {
	    key: 'changePage',
	    value: function changePage(pos) {
	      window.board.dataset.pos = pos;
	      pos = parseInt(pos) - 1;
	      var parent = this.refs['dragparent' + pos];
	      window.board.scrollLeft = parent.offsetLeft - 5;
	    }
	  }, {
	    key: 'updateRow',
	    value: function updateRow(data, pos, index) {
	      var stepsCopy = [].concat(_toConsumableArray(this.state.steps));
	      // let nKey = 0
	      stepsCopy.map(function (val, key) {
	        if (val.Title === data.Title) {
	          // nKey = key
	          stepsCopy[key] = data;
	        }
	      });
	
	      /*     if (pos !== undefined && index !== undefined) { // Added for some cases where pos and index are undefined to avoid errors preventing setState to be called
	        stepsCopy[pos].Orders.splice(index, 1)
	      } */
	      this.setState({
	        steps: stepsCopy
	      });
	      // Toastr
	      // window.toastr.success(translation('1909'), translation('13424'))
	      // Change page if phone
	      // if (this.md.userAgent() === 'Safari' || this.md.phone()) {
	      // if (this.allowHammer()) {
	      //   this.changePage(nKey + 1)
	      // }
	    }
	  }, {
	    key: 'handleRowUpdate',
	    value: function handleRowUpdate(event) {
	      if (event.data !== undefined) this.updateRow(event.data, event.pos, event.index);
	    }
	  }, {
	    key: 'moveOrders',
	    value: function moveOrders(data) {
	      var _this14 = this;
	
	      // console.log('state data', this.state.MoveOrders)
	      if (data === undefined) {
	        data = {
	          OrderIds: this.state.MoveOrders.MoveAll === true ? this.state.MoveOrders.OrderIds : [this.state.MoveOrders.Id],
	          UserId: 0,
	          StepFrom: this.state.MoveOrders.FromStep,
	          StepTo: this.state.MoveOrders.ToStep,
	          Comment: '',
	          FilterSettings: {}
	        };
	        this.setState({
	          MoveOrders: _extends({}, this.state.MoveOrders, {
	            MoveAll: null
	          })
	        });
	        // console.log('data', data)
	      }
	
	      // console.log('moveOrders (data): ', data)
	      var orders = [];
	      for (var i = 0; i < data.OrderIds.length; i++) {
	        var order = {
	          OrderId: data.OrderIds[i]
	        };
	        orders.push(order);
	      }
	
	      var moveData = {
	        Orders: orders,
	        UserId: data.UserId,
	        StepFrom: data.StepFrom,
	        StepTo: data.StepTo,
	        Comment: data.Comment,
	        FilterSettings: data.FilterSettings,
	        MoveAll: data.MoveAll === undefined ? this.state.MoveOrders.MoveAll : data.MoveAll,
	        CheckOnly: false
	      };
	
	      this.props.moveOrder(moveData).then(function (res) {
	        if (res.data.MoveAll) {
	          // console.log('moveALL')
	          _this14.setState({
	            MoveOrders: _extends({}, _this14.state.MoveOrders, {
	              open: true,
	              MoveAll: null,
	              OrderIds: res.data.OrderIds,
	              FromStep: moveData.StepFrom, // res.data.StepFrom,
	              ToStep: moveData.StepTo, // res.data.StepTo,
	              Id: data.OrderIds[0]
	            })
	          }, function () {
	            return null;
	          });
	        } else if (res.data.Checks.length > 0 && res.data.Checks.some(function (x) {
	          return x.MoveFailed;
	        })) {
	          _this14.props.triggerPopup(true);
	          res.data.OrderIds = data.OrderIds;
	          _this14.setState({
	            quality: {
	              open: true,
	              data: [res.data],
	              pos: data.Pos,
	              index: data.Index,
	              move: true
	            },
	            MoveOrders: _extends({}, _this14.state.MoveOrders, {
	              FromStep: moveData.StepFrom
	            })
	          });
	        } else {
	          if (_this14.stepHasComments(res.data)) {
	            _this14.props.triggerPopup(true);
	            _this14.setState({
	              quality: {
	                open: true,
	                data: [res.data],
	                pos: data.Pos,
	                index: data.Index,
	                move: true,
	                onlyProcessComments: true
	              }
	            });
	          } // else {
	          // let message = orders.length > 1 ? translation('12338') : translation('1909')
	          // window.toastr.success(message, translation('13424'))
	          if (res.data.MoveFailed === false) {
	            _this14.moveOrderSuccess(res.data, moveData.Orders);
	          }
	          // }
	          // this.updateRow(res.data.CurrentStepOrders, data.Pos, data.Index)
	        }
	      }, function (res) {
	        // Toastr
	        var message = void 0;
	        if (res.response.data.IsStopped === true) message = (0, _helpers.translation)('12347');else if (res.response.data.IsReffered === true) message = (0, _helpers.translation)('2704');else message = orders.length > 1 ? (0, _helpers.translation)('12339') : (0, _helpers.translation)('1731');
	
	        // Get error message from response.
	        if (res.response.data !== undefined && res.response.data.DictionaryKey !== undefined) {
	          message = (0, _helpers.translation)(res.response.data.DictionaryKey);
	        }
	
	        // If have StatusCode = 1 (Order can not be moved to this step)
	        if (res.response.data !== undefined && res.response.data.StatusCode !== undefined) {
	          var statusCode = res.response.data.StatusCode;
	          if (statusCode === 1) {
	            // this.moveOrders(this.state.MoveOrders) // Made mass error message spam...
	          }
	        }
	
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'initDragula',
	    value: function initDragula(steps) {
	      var _this15 = this;
	
	      // Containers
	      var containers = [];
	      for (var i = 0; i < steps.length; i++) {
	        containers.push(this.refs['drag-container' + i]);
	      }
	      // Options
	      var options = {
	        threshold: {
	          y: 68,
	          x: 50
	        },
	        ignoreInputTextSelection: false,
	        direction: 'horizontal',
	        revertOnSpill: true,
	        copy: true,
	        accepts: function accepts(el, target, source, sibling) {
	          return target.dataset.pos !== source.dataset.pos;
	        },
	        moves: function moves(el, source, handle, sibling) {
	          if (handle.classList.contains('upcomingOrders')) return false;
	          if (_this15.state.isTouch) {
	            // let triggerOpen = ['action__menu', 'action_opener', 'action_image', 'buttons', 'workers', 'worker__image', 'workers_name']
	            var triggerOpen = ['action__menu', 'action_opener', 'action_opener actionSwipe', 'action_image', 'action_image actionSwipe'];
	
	            return triggerOpen.indexOf(handle.className) !== -1 && !_this15.props.modalOpen;
	          }
	          return !_this15.props.modalOpen;
	        },
	        invalid: function invalid(el, handle) {
	          if (el.classList.contains('locked')) {
	            return true;
	          }
	
	          var excludeClasses = ['hint--bottom', 'workers', 'buttons'];
	          return excludeClasses.indexOf(handle.className) !== -1 || typeof handle.dataset.action !== 'undefined';
	          // if (excludeClasses.indexOf(handle.className) !== -1) return true
	          // if (typeof handle.dataset.action !== 'undefined') return true
	          // return false
	        }
	      };
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	        e.passive = true;
	      };
	      var preventDefaultForScrollKeys = function preventDefaultForScrollKeys(e) {
	        var keys = {
	          37: 1,
	          38: 1,
	          39: 1,
	          40: 1
	        };
	        if (keys[e.keyCode]) {
	          preventDefault(e);
	          return false;
	        }
	      };
	      var disableScroll = function disableScroll() {
	        _this15.canScroll = false;
	        if (window.addEventListener) {
	          window.removeEventListener('DOMMouseScroll', preventDefault, false);
	          window.addEventListener('DOMMouseScroll', preventDefault, false);
	        }
	        window.onwheel = preventDefault; // modern standard
	        window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
	        window.ontouchmove = preventDefault; // mobile
	        document.onkeydown = preventDefaultForScrollKeys;
	      };
	      var enableScroll = function enableScroll() {
	        if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', preventDefault, false);
	        window.onmousewheel = document.onmousewheel = null;
	        window.onwheel = null;
	        window.ontouchmove = null;
	        document.onkeydown = null;
	        _this15.canScroll = true;
	      };
	      // Dragula
	      var drake = null;
	      if (this.drake !== null) {
	        this.drake.destroy();
	      }
	      this.drake = drake = new _Dragula2.default(containers, options)
	      // .on('threshold_drag', () => {
	      //   disableScroll()
	      //   setTimeout(() => {
	      //     enableScroll()
	      //   }, 100)
	      // })
	      .on('drag', function (el, source) {
	        if (_this15.canScroll) disableScroll();
	      }).on('over', function (el, container) {
	        var parent = _this15.refs['dragparent' + container.dataset.pos];
	        if (parent.className.indexOf(' ex-over') === -1) parent.className += ' ex-over';
	      }).on('out', function (el, container) {
	        var parent = _this15.refs['dragparent' + container.dataset.pos];
	        if (parent.className.indexOf(' ex-over') > -1) parent.className = parent.className.replace(' ex-over', '');
	      }).on('shadow', function (el, target) {
	        if (el.style.display !== 'none') el.style.display = 'none';
	      }).on('drop', function (el, target, source, sibling) {
	        if (!_this15.canScroll) enableScroll();
	        if (el.style.display !== 'block') el.style.display = 'block';
	        _this15.initiateMove(el, target, source, sibling);
	        drake.cancel();
	      }).on('cancel', function (el, container) {
	        enableScroll();
	        el.style.display = 'block';
	        // setTimeout(() => {
	        //   if (this.allowHammer()) {
	        //     this.changePage(parseInt(container.dataset.pos) + 1)
	        //   }
	        // }, 0)
	      });
	      // Auto scroll
	      this.scroller = window.autoScroll([window, this.refs.board], {
	        margin: 150,
	        maxSpeed: 10,
	        scrollWhenOutside: true,
	        autoScroll: function autoScroll() {
	          // return this.down && drake.dragging
	          return drake.dragging;
	        }
	      });
	    }
	  }, {
	    key: 'closeMove',
	    value: function closeMove() {
	      this.setState({
	        moveItem: {
	          open: false,
	          type: 0,
	          item: {}
	        }
	      });
	      this.props.triggerPopup(false);
	    }
	
	    // initiateMove (el, pos1, pos2, sourceStepId, targetStepId)
	
	  }, {
	    key: 'initiateMove',
	    value: function initiateMove(el, target, source, sibling) {
	      var _this16 = this;
	
	      var oneStepMoveItem = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	      // Difference
	      var difference = function difference(a, b) {
	        return Math.abs(a - b);
	      };
	
	      // console.log('source.dataset', source.dataset, 'target.dataset', target.dataset)
	      var drake = this.drake;
	      var pos1 = parseInt(source.dataset.pos);
	      var pos2 = parseInt(target.dataset.pos);
	      var sourceStepId = parseInt(source.dataset.stepid);
	      var targetStepId = parseInt(target.dataset.stepid);
	      var index = parseInt(el.dataset.index);
	      var item = oneStepMoveItem || _extends({}, this.state.steps[pos1].Orders[index]);
	
	      if (this.props.auth.departmentType !== 1 && pos1 > pos2 && !((0, _auth2.hasAccess)([7], this.props.auth.user.UserType) || !(0, _auth2.hasSubscriptionPermission)(this.props.auth, 30) || (0, _auth2.hasSubscriptionPermission)(this.props.auth, 30, 20))) {
	        window.toastr.error((0, _helpers.translation)('17864'), (0, _helpers.translation)('216'));
	        return null;
	      }
	
	      if (difference(pos1, pos2) === 1 && pos2 > pos1) {
	        if ((0, _auth2.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	          this.onStartAsShopLogin({
	            type: 'move',
	            isOneStepMove: true,
	            item: item,
	            move: {
	              el: el,
	              target: target,
	              source: source,
	              sibling: sibling
	            },
	            quality: {
	              open: true,
	              pos: pos1,
	              index: index
	            }
	          });
	          drake.cancel();
	          return false;
	        }
	
	        var data = {
	          OrderIds: [item.Id],
	          UserId: 0,
	          StepFrom: sourceStepId,
	          StepTo: targetStepId,
	          Comment: '',
	          FilterSettings: {}
	        };
	
	        this.setState({
	          MoveOrders: _extends({}, this.state.MoveOrders, {
	            MoveAll: null
	          })
	        }, function () {
	          _this16.moveOrders(data);
	        });
	      } else {
	        var moveData = {
	          Orders: [{
	            OrderId: item.Id
	          }],
	          UserId: 0,
	          StepFrom: sourceStepId,
	          StepTo: targetStepId,
	          Comment: '',
	          FilterSettings: {},
	          CheckOnly: true
	        };
	
	        if ((0, _auth2.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	          this.onStartAsShopLogin({
	            type: 'move',
	            move: moveData,
	            quality: {
	              open: true,
	              pos: pos1,
	              index: index
	            },
	            stepid: targetStepId,
	            pos1: pos1,
	            pos2: pos2,
	            index: index,
	            item: item
	          });
	          drake.cancel();
	          return false;
	        }
	
	        this.props.moveOrder(moveData).then(function (res) {
	          item.NewStepId = targetStepId;
	          item.StepIndex = pos1;
	          item.ItemIndex = index;
	          var type = pos1 > pos2 ? 1 : 2;
	          if (difference(pos1, pos2) === 1) {
	            type = 1;
	          }
	
	          _this16.setState({
	            moveItem: {
	              open: true,
	              type: type,
	              item: item
	            }
	          });
	          _this16.props.triggerPopup(true);
	          // }
	        }, function (res) {
	          // Toastr
	          var message = void 0;
	          if (res.response.data.IsStopped === true) message = (0, _helpers.translation)('12347');else if (res.response.data.IsReffered === true) message = (0, _helpers.translation)('2704');else message = (0, _helpers.translation)('1731');
	          window.toastr.error(message, (0, _helpers.translation)('216'));
	        });
	      }
	    }
	  }, {
	    key: 'getHeaderIcon',
	    value: function getHeaderIcon(info) {
	      var imagePath = '/images/svgs/workscreen/';
	      switch (info.DictionaryKey) {
	        case 395:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20 }, src: imagePath + 'Draft-order-Black.svg' });
	        case 164:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'neworder.svg' });
	        case 208:
	          return _react2.default.createElement('img', { style: { width: 16, height: 16 }, src: imagePath + 'coating.svg' });
	        case 163:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'delivered.svg' });
	        case 23:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20 }, src: imagePath + 'Completed-Black.svg' });
	        case 158:
	          return _react2.default.createElement('img', { style: { width: 25, height: 25, marginTop: -5 }, src: imagePath + 'sanding.svg' });
	        case 161:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'coating.svg' });
	        case 96:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'pretreatment.svg' });
	        case 160:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'filler.svg' });
	        case 162:
	          if (info.StepId === 6) {
	            return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'preparing.svg' });
	          } else if (info.StepId === 104) {
	            return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'clean.svg' });
	          }
	          break;
	        case 617:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'demount.svg' });
	        case 618:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'reparation.svg' });
	        case 619:
	          return _react2.default.createElement('img', { style: { width: 20, height: 20, marginTop: -5 }, src: imagePath + 'mount.svg' });
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'toggleTasks',
	    value: function toggleTasks() {
	      var newState = !this.state.showTasks;
	
	      this.setState({
	        showTasks: newState,
	        pinTasks: newState
	      });
	    }
	  }, {
	    key: 'toggleTaskPin',
	    value: function toggleTaskPin() {
	      var newState = !(window.localStorage.getItem('workscreen_pin_tasks') === 'true' || this.state.pinTasks);
	      window.localStorage.setItem('workscreen_pin_tasks', newState ? 'true' : 'false');
	      this.setState({
	        pinTasks: newState
	      });
	    }
	  }, {
	    key: 'renderBoard',
	    value: function renderBoard(val, key) {
	      var _this17 = this;
	
	      var steps = this.getStepsFromView();
	      if (steps.length !== 0) {
	        if (steps.indexOf(parseInt(val.Title)) === -1) {
	          return null;
	        }
	      }
	
	      this.lastDateUsed = false;
	      var showOpenTaskIcon = !this.state.showTasks && !this.state.pinTasks;
	      // const getButton = () => {
	      //   let btn = ''
	      //   if (val.Orders !== undefined && val.Orders.length > 1) {
	      //     // btn = <div className='hint--bottom' aria-label={translation('2317')}><img src='/images/icons/shared-screen.svg' className='Can-Click' onClick={this.pressed.bind(this, key)} /></div>
	      //   }
	      //   return btn
	      // }
	      var classnames = 'drag-container';
	      if (this.state.isIExplorer || this.state.isFireFox) {
	        classnames += ' drag-container-ie';
	      } else if (this.state.isEdge) {
	        classnames += ' drag-container-edge';
	      }
	      var headerIcon = this.getHeaderIcon(val);
	      var headerText = (0, _helpers.translation)(val.DictionaryKey);
	      // var headerButton = getButton()
	      var renderOrdersForThis = function renderOrdersForThis(val, key1) {
	        return _this17.renderOrder(key, val, key1);
	      };
	      var renderAssignOrdersForThis = function renderAssignOrdersForThis(val, key1) {
	        return _this17.renderAssignOrder(key, val, key1);
	      };
	      var toRender = null;
	      if (this.state.view === 'workscreen') {
	        if (val.Orders === undefined) return null;
	        if (val.StepId === 1) {
	          toRender = val.Orders.sort(function (a, b) {
	            return a.IsAfterNewOrdersGroupingSplit - b.IsAfterNewOrdersGroupingSplit;
	          }).map(renderOrdersForThis);
	        } else {
	          toRender = val.Orders.map(renderOrdersForThis);
	        }
	      }
	      if (this.state.view === 'assign') {
	        toRender = val.OrderAssignments.map(renderAssignOrdersForThis);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: classnames, key: key, ref: 'dragparent' + key, 'data-pos': key },
	        (0, _auth2.hasSubscriptionPermission)(this.props.auth, 30) && val.Title === '1' && showOpenTaskIcon && _react2.default.createElement('img', { onClick: this.toggleTasks, className: 'otherTasks', src: '/images/svgs/othertasks/Task-arrow.svg' }),
	        _react2.default.createElement(
	          'h4',
	          null,
	          headerIcon,
	          ' ',
	          headerText
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'drag-content scrollbar', ref: 'drag-container' + key, 'data-pos': key, 'data-stepid': val.StepId },
	          toRender
	        )
	      );
	    }
	  }, {
	    key: 'renderOrder',
	    value: function renderOrder(step, val, key) {
	      var _this18 = this;
	
	      var openStartStop = false;
	      var openAction = false;
	      if (this.state.openAction === val.Id) {
	        openAction = true;
	      }
	      if (this.state.openStartStop === val.Id) {
	        openStartStop = true;
	      }
	      var hasOpendStatrStop = function hasOpendStatrStop() {
	        _this18.setState({
	          openStartStop: false
	        });
	      };
	      if (step === 0) {
	        // Checks if we logged in as BodyShop
	
	        // let today = moment()
	        // let daysDiff = itemDate.diff(today, 'days')
	        // let daysDiff = getDateDiff(itemDate)
	        if (!this.lastDateUsed && val.IsAfterNewOrdersGroupingSplit) {
	          this.lastDateUsed = true;
	
	          var label = void 0;
	          switch (this.props.auth.newOrdersGrouping) {
	            case 0:
	            default:
	              label = (0, _helpers.translation)('586');
	              break;
	            case 1:
	              label = (0, _helpers.translation)('16583');
	              break;
	          }
	
	          return [_react2.default.createElement(
	            'div',
	            { className: 'upcomingOrders' },
	            label
	          ), _react2.default.createElement(_Item2.default, { router: this.props.router, MoveOrders: this.moveOrders, openAction: openAction, openStartStop: openStartStop, hasOpendStatrStop: hasOpendStatrStop, type: '0', item: val, key: key, index: key, step: step, completeOrder: this.completeOrder, onStartAsShopLogin: this.onStartAsShopLogin, isEdge: this.state.isEdge, isFireFox: this.state.isFireFox, isIExplorer: this.state.isIExplorer, isTouch: this.state.isTouch, getVerticalScrollOffset: this.getVerticalScrollOffset, getHorizontalScrollOffset: this.getHorizontalScrollOffset })];
	        }
	      }
	      return _react2.default.createElement(_Item2.default, {
	        router: this.props.router,
	        MoveOrders: this.moveOrders,
	        onMoveSuccess: this.moveOrderSuccess,
	        openAction: openAction,
	        openStartStop: openStartStop,
	        type: '0',
	        renderTrigger: val.ColoredParts // Force item to trigger prop change when ColoredParts change.
	        , item: val, key: key, index: key, step: step, completeOrder: this.completeOrder,
	        onStartAsShopLogin: this.onStartAsShopLogin,
	        isEdge: this.state.isEdge, isFireFox: this.state.isFireFox, isIExplorer: this.state.isIExplorer, isTouch: this.state.isTouch, getVerticalScrollOffset: this.getVerticalScrollOffset, getHorizontalScrollOffset: this.getHorizontalScrollOffset,
	        hasOpendStatrStop: hasOpendStatrStop });
	    }
	  }, {
	    key: 'getVerticalScrollOffset',
	    value: function getVerticalScrollOffset(column) {
	      var result = 0;
	      if (column !== undefined && typeof column === 'number') {
	        var scrollContainer = this.refs['drag-container' + column];
	        if (scrollContainer !== undefined) {
	          result = scrollContainer.scrollTop;
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'getHorizontalScrollOffset',
	    value: function getHorizontalScrollOffset() {
	      var result = 0;
	      var scrollContainer = this.refs['board'];
	      if (scrollContainer !== undefined) {
	        result = scrollContainer.scrollLeft;
	      }
	      return result;
	    }
	  }, {
	    key: 'onStartAsShopLogin',
	    value: function onStartAsShopLogin(data) {
	      this.props.triggerPopup(true);
	      this.setState({
	        loginasmodal: true,
	        loginasmodalData: data,
	        addPopupShow: false
	        // }, () => {
	      });
	    }
	  }, {
	    key: 'renderAssignOrder',
	    value: function renderAssignOrder(step, val, key) {
	      return _react2.default.createElement(_AssignItem2.default, { router: this.props.router, key: key, item: val, step: step, index: key, onAssignUsers: this.onAssignUsers, getAssignOrderData: this.getAssignOrderData, assignAriaPos: 'bottom-right', useHtmlTitleTag: true });
	    }
	  }, {
	    key: 'completeOrder',
	    value: function completeOrder(id, fromStep, toStep, step, index) {
	      var _this19 = this;
	
	      var moveData = {
	        Orders: [{
	          OrderId: id
	        }],
	        UserId: 0,
	        StepFrom: fromStep,
	        StepTo: toStep,
	        Comment: '',
	        FilterSettings: {},
	        DontReturnOrders: toStep === 10
	        // console.log('id, fromStep, toStep, step, index', id, fromStep, toStep, step, index)
	      };this.props.moveOrder(moveData).then(function (res) {
	        if (res.data.MoveAll === true) {
	          _this19.setState({
	            MoveOrders: _extends({}, _this19.state.MoveOrders, {
	              open: true,
	              OrderIds: res.data.OrderIds,
	              FromStep: fromStep,
	              ToStep: toStep,
	              step: step,
	              index: index,
	              Id: id
	            })
	          }, function () {
	            // console.log(this.state.MoveOrders)
	          });
	        } else {
	          if (res.data.MoveFailed) {
	            _this19.props.triggerPopup(true);
	            _this19.setState({
	              quality: {
	                open: true,
	                data: [res.data],
	                pos: step,
	                index: index,
	                move: true
	              }
	            });
	          } else {
	            if (_this19.stepHasComments(res.data)) {
	              _this19.props.triggerPopup(true);
	              _this19.setState({
	                quality: {
	                  open: true,
	                  data: [res.data],
	                  pos: step,
	                  index: index,
	                  move: true
	                }
	              });
	            }
	            _this19.updateRow(res.data.CurrentStepOrders, step, index);
	          }
	        }
	      }, function (res) {
	        // Toastr
	        var message = void 0;
	        if (res.response.data.IsStopped === true) message = (0, _helpers.translation)('12347');else if (res.response.data.IsReffered === true) message = (0, _helpers.translation)('2704');else message = (0, _helpers.translation)('1731');
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      var _this20 = this;
	
	      var renderEmployeePicker = function renderEmployeePicker() {
	        if (!(0, _auth2.hasAccess)([5, 7], _this20.props.auth.user.UserType) || _this20.state.view !== 'workscreen') return null;
	        var openLoginAsModal = function openLoginAsModal() {
	          _this20.setState({ loginasmodal: true });
	          _this20.props.triggerPopup(true);
	        };
	        var ariaLabel = '';
	        if (!_this20.state.isTouch) ariaLabel = (0, _helpers.translation)('2057');
	        return _react2.default.createElement(_icon2.default, { icon: _icons.MainMenuIcons.Customers_Black, onClick: openLoginAsModal, ariaText: ariaLabel });
	      };
	      var renderOverviewStatusPicker = function renderOverviewStatusPicker() {
	        if (!((0, _auth2.hasSubscriptionPermission)(_this20.props.auth, 30) && !(0, _auth2.hasAccess)([4], _this20.props.auth.user.UserType) && _this20.state.view === 'workscreen')) return null;
	        return _react2.default.createElement(_OverviewStatusSelection2.default, null);
	      };
	
	      var renderAssignUsers = function renderAssignUsers() {
	        if (!(0, _auth2.hasAccess)([3, 7], _this20.props.auth.user.UserType)) return null;
	        var assignUsers = function assignUsers() {
	          if (_this20.state.view === 'workscreen') {
	            _this20.getAssignOrderData();
	          } else {
	            _this20.initOrder();
	            setTimeout(function () {
	              _this20.getAssignOrderData([]);
	            }, 0);
	          }
	          _this20.setState({
	            view: _this20.state.view === 'workscreen' ? 'assign' : 'workscreen',
	            showTasks: false
	          });
	        };
	        var ariaLabel = '';
	        if (!_this20.state.isTouch) ariaLabel = (0, _helpers.translation)('2058');
	        // <div className='hint--left' aria-label={ariaLabel}><img src='/images/icons/Assign-Black.png' onClick={assignUsers} className='icon' /></div>
	        return _react2.default.createElement(_icon2.default, { icon: _icons.AssignmentIcons.Assign_Employee_Black, onClick: assignUsers, ariaText: ariaLabel });
	      };
	      var renderSearchFilter = function renderSearchFilter() {
	        if (_this20.state.view !== 'workscreen') return null;
	
	        var filterData = (0, _filter.getOrderFilterData)(_extends({}, _this20.props, { source: 'workscreen' }));
	        var filterActive = false;
	        // let simplesearch = this.refs.SearchFilter !== undefined ? this.refs.SearchFilter.getWrappedInstance().state.simplesearch : ''
	
	        // let simplesearch = this.refs.SearchFilter !== undefined ? this.refs.SearchFilter.getWrappedInstance().state.simplesearch.value : ''
	        var simplesearch = '';
	        if (_this20.refs.SearchFilter !== undefined) {
	          var instance = _this20.refs.SearchFilter.getWrappedInstance();
	          if (instance.state !== undefined && instance.state.simplesearch !== undefined && instance.state.simplesearch !== null) {
	            simplesearch = instance.state.simplesearch.value;
	          }
	        }
	        if (simplesearch === '' || simplesearch === undefined) {
	          // let storedSimpleSearch = JSON.parse(window.localStorage.getItem('simplesearchWorkscreen'))
	          // if (storedSimpleSearch !== null && storedSimpleSearch.value !== undefined && storedSimpleSearch.value.length > 0) {
	          //   simplesearch = storedSimpleSearch.value
	          // }
	          if (filterData.hasSimpleSearch) {
	            simplesearch = filterData.simpleSearch.value;
	          }
	        }
	        if (_this20.refs.SearchFilter !== undefined && (0, _filter.isFilterChanged)(_this20.props.auth, simplesearch, _this20.refs.SearchFilter.getWrappedInstance().props.filter, _this20.refs.SearchFilter.getWrappedInstance().props.initialFilter)) {
	          filterActive = true;
	        } else {
	          // let storedFilter = JSON.parse(window.localStorage.getItem('filterOrderlist'))
	          // if (hasAccess([4], this.props.auth.user.UserType)) {
	          //   storedFilter = JSON.parse(window.localStorage.getItem('filterCustomer'))
	          // } else if (hasAccess([6], this.props.auth.user.UserType)) {
	          //   storedFilter = JSON.parse(window.localStorage.getItem('filterWP'))
	          // }
	          var storedFilter = _extends({}, _this20.props.initialFilter, filterData.filter);
	          if ((0, _filter.isFilterChanged)(_this20.props.auth, simplesearch, storedFilter, _this20.props.initialFilter)) {
	            // if page refresh
	            filterActive = true;
	          }
	        }
	
	        var ariaLabel = '';
	        if (!_this20.state.isTouch) ariaLabel = (0, _helpers.translation)('2048');
	
	        return _react2.default.createElement(
	          'div',
	          { className: filterActive ? 'searchicon filter-active' : 'searchicon' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.FilterIcons.Magnifier_Black, onClick: _this20.openFilter, injectSvg: true, ariaText: ariaLabel })
	        );
	      };
	      // let searchClass = (isFilterChanged(this.props.auth.user.CustomerId, this.state.searchFilter, this.state.initialSearchFilter)) ? 'active' : ''
	      var renderCreateButton = function renderCreateButton() {
	        if ((0, _auth2.hasSubscriptionPermission)(_this20.props.auth, 0, 2) && _this20.state.view === 'workscreen') {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_button2.default, { id: 'btn-createorder', spacing: 0, size: 'm', style: 'cta', labelText: (0, _helpers.translation)(21), onClick: _this20.showAddPopup }),
	            _react2.default.createElement(_addButton2.default, { id: 'btn-createorder-phone', spacing: 0, size: 'm', style: 'cta', onClick: _this20.showAddPopup })
	          );
	        }
	        return null;
	      };
	
	      var renderCapacityOverview = function renderCapacityOverview() {
	        if (_this20.state.view !== 'workscreen') return null;
	        if (!(0, _auth2.hasAccess)([3, 5, 7], _this20.props.auth.user.UserType) || !(0, _auth2.hasSubscriptionPermission)(_this20.props.auth, 30) || _this20.props.auth.departmentType !== 1) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'capacity-overview hide-from-resposive' },
	          _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', style: 'link', labelText: (0, _helpers.translation)('17912'), onClick: function onClick() {
	              return _this20.props.openOverlay('OrderCapacityOverview');
	            } })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { className: 'alignHelper' }),
	        renderCapacityOverview(),
	        renderOverviewStatusPicker(),
	        renderSearchFilter(),
	        renderEmployeePicker(),
	        (0, _auth2.hasSubscriptionPermission)(this.props.auth, 20, 15) && (0, _auth2.hasAccessToAssign)(this.props.auth) && renderAssignUsers(),
	        renderCreateButton(),
	        _react2.default.createElement(_NewOrdersModal2.default, { router: this.props.router,
	          show: this.state.addPopupShow,
	          onClose: this.showAddPopup,
	          bodyShop: this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2 }),
	        _react2.default.createElement(_OrderCapacityOverview2.default, null)
	      );
	    }
	  }, {
	    key: 'showAddPopup',
	    value: function showAddPopup() {
	      var _this21 = this;
	
	      if ((0, _auth2.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	        this.setState({
	          addPopupClickedAsShop: true,
	          addPopupShow: false
	        }, function () {
	          _this21.onStartAsShopLogin({
	            type: 'neworder'
	          });
	          return false;
	        });
	      }
	      var showPopup = this.state.addPopupShow;
	      this.setState({
	        addPopupShow: !showPopup,
	        addPopupClickedAsShop: !(this.state.addPopupClickedAsShop && showPopup)
	      }, function () {
	        // console.log('[NewWorkscreen][showAddPopup]', this.state.addPopupShow, this.state.addPopupClickedAsShop)
	        _this21.props.triggerPopup(_this21.state.addPopupShow);
	      });
	    }
	  }, {
	    key: 'closeAssign',
	    value: function closeAssign() {
	      this.setState({
	        view: 'workscreen'
	      });
	    }
	  }, {
	    key: 'getAssignOrderData',
	    value: function getAssignOrderData(activeEmployees) {
	      var _this22 = this;
	
	      // Find order ids
	      var orderIds = [];
	      this.state.steps.map(function (val) {
	        val.Orders.map(function (v) {
	          orderIds.push(v.Id);
	        });
	      });
	      // Get assign order data
	      this.props.getOrderData({
	        OrderIds: orderIds,
	        UserIds: activeEmployees || this.props.activeEmployees
	      }).then(function (res) {
	        _this22.setState({
	          StepAssignments: res.data.StepAssignments
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1922'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onAssignUsers',
	    value: function onAssignUsers() {
	      this.refs.AssignBox.getWrappedInstance().getAssignEmployees();
	    }
	  }, {
	    key: 'closeLoginAs',
	    value: function closeLoginAs(update, data) {
	      var _this23 = this;
	
	      if (this._mounted) {
	        this.setState({
	          loginasmodal: false,
	          loginasmodalData: {},
	          addPopupClickedAsShop: false
	        }, function () {
	          if (data === undefined) {
	            return;
	          }
	          if (typeof update === 'boolean' && update) {
	            var screenView = _this23.getScreenView(_this23.props);
	            _this23.setState({
	              screenview: screenView,
	              steps: [],
	              searchFilter: _extends({}, _this23.state.searchFilter, {
	                SelectedWorkScreenType: parseInt(screenView)
	              })
	            }, function () {
	              // this.initOrder().then(() => {
	              if (typeof data !== 'undefined') {
	                if (typeof data.type !== 'undefined') {
	                  // Stop/start - START
	                  if (data.type === 'stop' || data.type === 'start') {
	                    var steps = document.getElementsByClassName('drag-content scrollbar');
	                    for (var i = 0; i < steps.length; i++) {
	                      if (steps[i].dataset.pos === '' + data.id) {
	                        steps[i].scrollTop = data.scrollOffset;
	                      }
	                    }
	                    _this23.setState({
	                      openStartStop: data.id
	                    });
	                    // , () => {
	                    //   setTimeout(() => {
	                    //     if (this._mounted) {
	                    //       this.setState({
	                    //         openStartStop: false
	                    //       })
	                    //     }
	                    //   }, 5000)
	                    // })
	                  }
	                  // Stop/start - END
	                  // Action - START
	                  if (data.type === 'action') {
	                    _this23.setState({
	                      openAction: data.id
	                    }, function () {
	                      setTimeout(function () {
	                        if (_this23._mounted) {
	                          _this23.setState({
	                            openAction: false
	                          });
	                        }
	                      }, 5000);
	                    });
	                  }
	                  // Action - END
	                  // Move - START
	                  if (data.type === 'move') {
	                    if (data.isOneStepMove) {
	                      _this23.initiateMove(data.move.el, data.move.target, data.move.source, data.move.sibling, data.item);
	                      return null;
	                    }
	                    _this23.props.moveOrder(data.move).then(function (res) {
	                      if (res.data.MoveFailed) {
	                        _this23.props.triggerPopup(true);
	                        var quality = data.quality;
	                        quality.data = res.data;
	                        _this23.setState({
	                          quality: quality
	                        });
	                      } else {
	                        if (_this23.stepHasComments(res.data)) {
	                          _this23.props.triggerPopup(true);
	                          var _quality = data.quality;
	                          _quality.data = res.data;
	                          _this23.setState({
	                            quality: _quality
	                          });
	                        }
	                        if (data.move.CheckOnly) {
	                          var item = data.item;
	                          item.NewStepId = parseInt(data.stepid);
	                          item.StepIndex = data.pos1;
	                          item.ItemIndex = data.index;
	                          // Difference
	                          var difference = function difference(a, b) {
	                            return Math.abs(a - b);
	                          };
	                          var type = data.pos1 > data.pos2 ? 1 : 2;
	                          if (difference(data.pos1, data.pos2) === 1) {
	                            type = 1;
	                          }
	                          _this23.setState({
	                            moveItem: {
	                              open: true,
	                              type: type,
	                              item: item
	                            }
	                          });
	                          _this23.props.triggerPopup(true);
	                        } else {
	                          // Sometimes data.pos1 and index is undefined?
	                          // if (data.pos1 === undefined) {
	                          //   data.pos1 = data.move.StepFrom
	                          // }
	                          // console.log('move order update row data: ', res.data, data)
	                          _this23.updateRow(res.data.CurrentStepOrders, data.pos1, data.index);
	                          // let steps = [ data.move.StepFrom, data.move.StepTo ]
	                          // this.updateSteps(steps)  // TODO: Færdiggør den her..
	                        }
	                      }
	                    }, function (res) {
	                      // Toastr
	                      var message = void 0;
	                      if (res.response.data.IsStopped === true) message = (0, _helpers.translation)('12347');else if (res.response.data.IsReffered === true) message = (0, _helpers.translation)('2704');else message = (0, _helpers.translation)('1731');
	                      window.toastr.error(message, (0, _helpers.translation)('216'));
	                    });
	                  } // Move - END
	                  // NEW ORDER - START
	                  if (data.type === 'neworder') {
	                    _this23.showAddPopup();
	                  }
	
	                  if (data.type === 'task') {
	                    _this23.setState({
	                      otherTaskOccurrenceAction: {
	                        Id: data.Id,
	                        action: data.action
	                      },
	                      showTasks: true
	                    });
	                  }
	                } // Typeof data.type - END
	              } // Typeof data - END
	              // })
	            });
	          }
	        });
	      }
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'closeQualityModal',
	    value: function closeQualityModal() {
	      this.props.triggerPopup(false);
	      this.setState({
	        quality: {
	          open: false,
	          data: {},
	          index: 0,
	          pos: 0
	        }
	      });
	    }
	  }, {
	    key: 'moveOrderSuccess',
	    value: function moveOrderSuccess(data, movedOrders) {
	      var _this24 = this;
	
	      if (data === undefined || movedOrders === undefined) return null;
	      if (data.MoveFailed === false) {
	        var steps = [].concat(_toConsumableArray(this.state.steps));
	        var selectedMovedFromStep = void 0;
	        var selectedMovedToStep = void 0;
	        steps.map(function (step) {
	          if (step.StepId === data.StepTo) {
	            selectedMovedToStep = step;
	          } else if (step.StepId === data.StepFrom) {
	            selectedMovedFromStep = step;
	          }
	        });
	        var orderIds = movedOrders.map(function (o) {
	          return o.OrderId;
	        });
	        var filter = _extends({}, this.state.searchFilter, {
	          identification: {
	            OrderNumbers: orderIds
	          }
	        });
	        var stepsUpdated = false;
	        // console.log('moveOrderSuccess', filter)
	        this.props.getOrdersNew(filter).then(function (res) {
	          // console.log('MOVE ORDER SUCCESS -> SEARCH SINGLE RESPONSE:', movedOrders, res.data)
	          var searchSteps = res.data[0].Steps;
	
	          var _loop2 = function _loop2(i) {
	            var orderId = orderIds[i];
	            var foundOrder = null;
	            for (var s = 0; s < searchSteps.length; s++) {
	              if (searchSteps[s].Orders !== undefined && searchSteps[s].Orders.length > 0) {
	                for (var o = 0; o < searchSteps[s].Orders.length; o++) {
	                  if (searchSteps[s].Orders[o].OrderKey === orderId + '') {
	                    foundOrder = searchSteps[s].Orders[o];
	                    break;
	                  }
	                }
	              }
	              if (foundOrder !== null) break;
	            }
	
	            if (selectedMovedFromStep !== undefined) {
	              // Remove order in 'moved from' step
	              var indexInFrom = selectedMovedFromStep.Orders.findIndex(function (order) {
	                return order.OrderKey === orderId + '';
	              });
	              if (indexInFrom >= 0) {
	                selectedMovedFromStep.Orders.splice(indexInFrom, 1);
	                stepsUpdated = true;
	              }
	            }
	            if (foundOrder !== null && selectedMovedToStep !== undefined) {
	              // Insert order in 'moved to' step
	              selectedMovedToStep.Orders.push(foundOrder);
	              foundOrder.mathRandom = Math.random();
	              stepsUpdated = true;
	
	              var toStepOrderIds = selectedMovedToStep.Orders.map(function (o) {
	                return o.Id;
	              });
	              var step = selectedMovedToStep.StepId;
	
	              _this24.props.getOrderSorting(step, toStepOrderIds).then(function (res) {
	                selectedMovedToStep.Orders.sort(function (orderA, orderB) {
	                  return res.data.findIndex(function (id) {
	                    return id === orderA.Id;
	                  }) - res.data.findIndex(function (id) {
	                    return id === orderB.Id;
	                  });
	                });
	                _this24.setState({
	                  steps: steps
	                });
	              });
	            } else if (stepsUpdated) {
	              _this24.setState({
	                steps: steps
	              });
	            }
	          };
	
	          for (var i = 0; i < orderIds.length; i++) {
	            _loop2(i);
	          }
	        });
	
	        // Handle additional actions directed by backend.
	        // const NONE = 0
	        // const CONFIRM_START = 1 // Not used here
	        var GOTO_WORKCARD = 2;
	
	        var gotoWorkCard = function gotoWorkCard(orderId) {
	          _this24.props.router.push('/orders/' + orderId + '?notifyPaintNotBooked=1');
	        };
	        if (data.FrontendActions !== undefined && data.FrontendActions !== null && data.FrontendActions.length > 0) {
	          data.FrontendActions.forEach(function (item) {
	            if (item.Action === GOTO_WORKCARD) {
	              gotoWorkCard(item.OrderId);
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'changeScreen',
	    value: function changeScreen(view, e) {
	      var _this25 = this;
	
	      e.preventDefault();
	      window.localStorage.setItem('workscreen_view', view);
	      this.setState({
	        screenview: view,
	        openDropdownLeft: false
	      }, function () {
	        _this25.onSearchSubmit(_this25.state.filter);
	      });
	    }
	  }, {
	    key: 'renderDropdownLeft',
	    value: function renderDropdownLeft() {
	      var _this26 = this;
	
	      var toggleDropdown = function toggleDropdown(val) {
	        _this26.setState({
	          openDropdownLeft: val
	        });
	      };
	      var closeDropdown = function closeDropdown() {
	        _this26.setState({
	          openDropdownLeft: false
	        });
	      };
	      var screenview = this.state.screenview;
	      return _react2.default.createElement(_DropdownBox2.default, {
	        closeDropdown: closeDropdown,
	        changeScreen: this.changeScreen.bind(this),
	        toggleDropdown: toggleDropdown,
	        screenview: screenview,
	        openDropdownLeft: this.state.openDropdownLeft });
	    }
	  }, {
	    key: 'renderTasks',
	    value: function renderTasks() {
	      var _this27 = this;
	
	      if (!(0, _auth2.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	
	      var isTasksPined = window.localStorage.getItem('workscreen_pin_tasks') === 'true';
	      var handledAction = function handledAction() {
	        _this27.setState({
	          otherTaskOccurrenceAction: null
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'mytasks__screen drag-container' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h4',
	            { onClick: this.toggleTasks },
	            _react2.default.createElement('img', { className: 'otherTasks otherTasks--open', src: '/images/svgs/menuicons/Task-Black.svg' }),
	            (0, _helpers.translation)('1227')
	          ),
	          _react2.default.createElement('img', { onClick: this.toggleTaskPin, src: '/images/svgs/othertasks/pen' + (isTasksPined ? '' : '-not') + '-placed.svg' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'drag-content scrollbar' },
	          _react2.default.createElement(_MyTasks2.default, { IsWorkscreen: true, onStartAsShopLogin: this.onStartAsShopLogin.bind(this), occurrenceAction: this.state.otherTaskOccurrenceAction, handledAction: handledAction })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth2.hasSubscriptionPermission)(this.props.auth, 20) && window.localStorage.getItem('workscreen_view') === '7') {
	        window.localStorage.setItem('workscreen_view', null);
	      }
	      // let isTasksPined = (window.localStorage.getItem('workscreen_pin_tasks') === 'true' || this.state.pinTasks)
	      var isTasksPined = this.state.pinTasks;
	      var extraClass = this.state.view === 'workscreen' ? '' : 'assigningUsers';
	      var filterExtraClass = '';
	      if (this.state.filterOpen) {
	        filterExtraClass += 'open';
	      }
	      var disableProcessStep = true;
	      var toRender = null;
	      if (this.state.view === 'workscreen' && this.state.steps !== undefined) {
	        toRender = this.state.steps.map(this.renderBoard);
	      }
	      if (this.state.view === 'assign') {
	        toRender = this.state.StepAssignments.map(this.renderBoard);
	      }
	      var boardBottom = '0';
	      if (this.props.auth.departmentType === 1 && this.state.view === 'assign') {
	        boardBottom = '115';
	      } else if (this.props.auth.departmentType !== 1 && this.state.view === 'assign') {
	        boardBottom = '170';
	      }
	      // console.log('NewWorkScreen -> render,', this.state)
	      return _react2.default.createElement(
	        'div',
	        { className: 'work__screen ' + extraClass },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, changeTrigger: Math.random(), renderLeft: this.renderDropdownLeft, renderRight: this.headerButtonsRight }),
	        _react2.default.createElement(
	          'div',
	          { className: 'filter__wrap ' + filterExtraClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'right__filter__wrap' },
	            _react2.default.createElement(_SearchFilter2.default, { router: this.props.router, ref: 'SearchFilter', disableProcessStep: disableProcessStep, onSubmit: this.onSearchSubmit, onSimple: this.quickSearch, source: 'workscreen' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'board', className: 'scrollbar right__wrap', style: { bottom: boardBottom + 'px' }, ref: 'board' },
	            _react2.default.createElement('div', { className: 'filler' }),
	            (this.state.showTasks || this.state.view !== 'assign' && isTasksPined) && this.renderTasks(),
	            toRender
	          )
	        ),
	        this.state.view === 'assign' && _react2.default.createElement(_AssignBox2.default, { router: this.props.router, ref: 'AssignBox', closeAssign: this.closeAssign, onEmployeeChange: this.getAssignOrderData }),
	        this.state.moveItem.open && _react2.default.createElement(_MoveModal2.default, { router: this.props.router,
	          show: this.state.moveItem.open,
	          item: this.state.moveItem.item,
	          type: this.state.moveItem.type,
	          onClose: this.closeMove,
	          onMoveOrders: this.moveOrders.bind(this)
	          /* onMoveSuccess={this.MoveMennyOrders.bind(this)}
	          onMoveWorkscreen={this.MoveMennyOrders.bind(this)} */ }),
	        (0, _auth2.hasAccess)([5, 7], this.props.auth.user.UserType) && this.state.loginasmodal && _react2.default.createElement(_LoginAsModal2.default, { router: this.props.router,
	          data: this.state.loginasmodalData,
	          show: this.state.loginasmodal,
	          onClose: this.closeLoginAs }),
	        this.state.quality.open && _react2.default.createElement(_QualityCheckModal2.default, { router: this.props.router,
	          show: this.state.quality.open,
	          data: this.state.quality.data,
	          onMoveSuccess: this.moveOrderSuccess.bind(this),
	          onClose: this.closeQualityModal.bind(this),
	          move: this.state.quality.move,
	          onlyProcessComments: this.state.quality.onlyProcessComments }),
	        this.state.OpenstartModal.open && _react2.default.createElement(_MultiStart2.default, {
	          show: this.state.OpenstartModal.open,
	          onClose: this.closeOrderStart,
	          orders: this.state.steps[this.state.OpenstartModal.step].Orders.filter(function (x) {
	            return !x.IsStopped;
	          }),
	          start: this.start.bind(this),
	          move: this.moveOrders.bind(this),
	          step: this.state.OpenstartModal.step + 1 }),
	        this.state.MoveOrders.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'MoveOrders') },
	          _react2.default.createElement(_StopOtherOrders2.default, { Move: true, AllOrders: this.AllOrders.bind(this, 'MoveOrders'), NotAllOrders: this.NotAllOrders.bind(this, 'MoveOrders') })
	        )
	      );
	    }
	  }, {
	    key: 'modalTitle',
	    value: function modalTitle(item) {
	      var title = '';
	      if (typeof item !== 'undefined') {
	        // Model
	        if (item.Model) {
	          title += item.Model;
	        }
	        // RegNumber
	        if (item.RegNumber) {
	          if (item.Model) {
	            title += ', ';
	          }
	          title += item.RegNumber;
	        }
	        // Title empty
	        if (title === '') {
	          title += item.Id || item.OrderId;
	        }
	      }
	
	      return title;
	    }
	  }, {
	    key: 'AllOrders',
	    value: function AllOrders(type) {
	      var _this28 = this;
	
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false,
	        MoveAll: true
	      })), function () {
	        _this28.moveOrders();
	      });
	    }
	  }, {
	    key: 'NotAllOrders',
	    value: function NotAllOrders(type) {
	      var _this29 = this;
	
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false,
	        MoveAll: false
	      })), function () {
	        _this29.moveOrders();
	      });
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.props.triggerPopup(false);
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	    }
	  }, {
	    key: 'start',
	    value: function start(OrderIds, UserIds) {
	      var _this30 = this;
	
	      this.closeOrderStart();
	      var Orders = [];
	      for (var i = 0; i < OrderIds.length; i++) {
	        Orders.push({
	          OrderId: OrderIds[i],
	          WarrantyCode: null,
	          PaintThickness: null
	        });
	      }
	
	      var data = {
	        Orders: Orders,
	        UserIds: UserIds,
	        WorkOnAll: false,
	        CheckOnly: false,
	        FromMenny: true
	      };
	
	      this.props.startOrder(data).then(function (res) {
	        if (res.data.length > 0 || _this30.stepHasComments(res.data)) {
	          _this30.props.triggerPopup(true);
	          _this30.setState({
	            quality: {
	              open: true,
	              data: {
	                res: res.data,
	                WorkOnAll: false,
	                UserIds: UserIds
	              },
	              move: false
	            }
	          });
	        } else {
	          // let message = Orders.length > 1 ? translation('13519') : translation('13518')
	          // window.toastr.success(message, translation('13424'))
	        }
	      }, function () {
	        var message = Orders.length > 1 ? (0, _helpers.translation)('12337') : (0, _helpers.translation)('1923');
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'pressed',
	    value: function pressed(key) {
	      this.props.triggerPopup(true);
	      this.setState({
	        OpenstartModal: _extends({}, this.state.OpenstartModal, {
	          open: true,
	          step: key
	        })
	      });
	    }
	  }, {
	    key: 'closeOrderStart',
	    value: function closeOrderStart() {
	      this.props.triggerPopup(false);
	      this.setState({
	        OpenstartModal: _extends({}, this.state.OpenstartModal, {
	          open: false,
	          step: 0
	        })
	      });
	    }
	  }]);
	
	  return Workscreen;
	}(_react.Component);
	
	Workscreen.propTypes = {
	  auth: _propTypes2.default.object.isRequired,
	  getOrdersAdvanced: _propTypes2.default.func.isRequired,
	  setPrevWorkscreen: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    modalOpen: state.backdrop.modalOpen,
	    workscreenOrders: state.orders.workscreenOrders,
	    activeEmployees: state.assign.activeEmployees,
	    filter: state.orders.filterWorkscreen,
	    initialFilter: state.orders.initialFilterWorkscreen
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  getOrdersNew: _orders.getOrdersNew,
	  moveOrder: _orders.moveOrder,
	  logOutAs: _auth.logOutAs,
	  getOrderData: _assign.getOrderData,
	  getOrdersAdvanced: _orders.getOrdersAdvanced,
	  triggerPopupActionBG: _backdrop.triggerPopupActionBG,
	  startOrder: _orders.startOrder,
	  isFilterChanged: _filter.isFilterChanged,
	  updateWorkscreenList: _orders.updateWorkscreenList,
	  setPrevWorkscreen: _auth.setPrevWorkscreen,
	  setOrdersFilter: _orders.setOrdersFilter,
	  getOrderSorting: _orders.getOrderSorting,
	  openOverlay: _common.openOverlay
	})(Workscreen);

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(43);
	
	__webpack_require__(1416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	var NoMatch = function (_Component) {
	  _inherits(NoMatch, _Component);
	
	  function NoMatch() {
	    _classCallCheck(this, NoMatch);
	
	    return _possibleConstructorReturn(this, (NoMatch.__proto__ || Object.getPrototypeOf(NoMatch)).apply(this, arguments));
	  }
	
	  _createClass(NoMatch, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'nomatch__screen' },
	        _react2.default.createElement(
	          'div',
	          { className: 'nomatch__wrapper' },
	          _react2.default.createElement(
	            'span',
	            null,
	            '404'
	          ),
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Page not found'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/' },
	            'Home'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NoMatch;
	}(_react.Component);
	
	exports.default = NoMatch;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _time = __webpack_require__(17);
	
	var _Extent = __webpack_require__(153);
	
	var _Extent2 = _interopRequireDefault(_Extent);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _currency = __webpack_require__(41);
	
	var _order = __webpack_require__(92);
	
	var _constants = __webpack_require__(5);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _expand = __webpack_require__(175);
	
	var _expand2 = _interopRequireDefault(_expand);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Price from '../../../PriceCalculation/Price'
	
	
	// Elements
	
	
	var DEPARTMENTTYPE = {
	  Paint: 0,
	  Body: 1
	};
	var REPORTTYPE = {
	  Unknown: 0,
	  Forsi: 1,
	  ForsiManual: 2, // RP
	  DBS: 3
	};
	
	var Assessment = function (_PureComponent) {
	  _inherits(Assessment, _PureComponent);
	
	  function Assessment(props) {
	    _classCallCheck(this, Assessment);
	
	    var _this = _possibleConstructorReturn(this, (Assessment.__proto__ || Object.getPrototypeOf(Assessment)).call(this, props));
	
	    _this.state = {
	      showExtent: false
	    };
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.renderAdditionalSales = _this.renderAdditionalSales.bind(_this);
	    _this.renderPriceCalculation = _this.renderPriceCalculation.bind(_this);
	    // this.renderForsiReport = this.renderForsiReport.bind(this)
	    // this.renderBodyShopForsiReport = this.renderBodyShopForsiReport.bind(this)
	    // this.renderBodyShopPriceDiff = this.renderBodyShopPriceDiff.bind(this)
	    _this.GetIcon = _this.GetIcon.bind(_this);
	    _this.ToAfterEvaluation = _this.ToAfterEvaluation.bind(_this);
	    return _this;
	  }
	
	  _createClass(Assessment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'formatSectionType',
	    value: function formatSectionType(sectionType) {
	      switch (sectionType) {
	        case 1:
	          return DEPARTMENTTYPE.Paint;
	        case 2:
	          return DEPARTMENTTYPE.Body;
	        default:
	          break;
	      }
	    }
	
	    // renderBodyShopPriceDiff () {
	    //   let hasForsiReport = this.props.order.Report !== null && this.props.order.Report.ReportType === REPORTTYPE.Forsi
	    //   // if (this.props.order.BodyShopForsiOrderExtent === null) return null
	    //   if (this.props.order.OrderDepartment === DEPARTMENTTYPE.Body && !hasForsiReport) return null
	    //   // ???
	    //   if (this.props.order.BodyShopForsiOrderExtent.CheckReportDiff !== true) return null
	    //   return (
	    //     <div className='forsi_diff'>{translation('749')}</div>
	    //   )
	    // }
	
	  }, {
	    key: 'renderPriceCalculation',
	    value: function renderPriceCalculation() {
	      var isBodyShop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var editDenied = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var OrderType = this.props.order.OrderType;
	      // console.log('Order', this.props.order)
	
	      var orderExtent = this.props.order.OrderExtent;
	      // if (orderExtent === null) return null
	      var extentLines = [];
	      if (orderExtent !== null && orderExtent !== '') {
	        extentLines = this.props.order.OrderExtent.split('<br />');
	      }
	
	      var renderLine = function renderLine(val, key) {
	        return _react2.default.createElement(
	          'p',
	          { key: 'extentLine_' + key },
	          val
	        );
	      };
	
	      // Other
	      // console.log('OrderType', OrderType)
	      if (OrderType === 4) {
	        // let extentImage = <div><img src='/images/svgs/ordrer/Other-black.svg' className='subtitleIMG' /></div>
	
	        return _react2.default.createElement(
	          _expand2.default,
	          { title: (0, _helpers.translation)('73') },
	          _react2.default.createElement(
	            _actions2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'icon hint--top', 'aria-label': (0, _helpers.translation)('2706') },
	              _react2.default.createElement('img', { src: '/images/icons/edit_16.png' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'extent_other', onClick: (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) && this.openOtherPopup },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)('1206')
	              ),
	              this.props.order.OtherTitle || ''
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)('1021')
	              ),
	              this.props.order.OtherDescription || ''
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)('641')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _currency.formatCurrency)(this.props.order.Price || 0)
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)('13339')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _currency.formatCurrency)(this.props.order.Environment || 0)
	              )
	            )
	          )
	        );
	      }
	      // let noPrices = false
	      // if (OrderType === 1) {
	      //   noPrices = true
	      // }
	
	      // Price calculation
	      // TODO: Ikke vis other price på insurance og other
	      var isReferredIn = this.props.order.IsReferredIn;
	      if (isReferredIn) {
	        if (this.props.order.OrderConnection !== undefined && this.props.order.OrderConnection !== null && this.props.order.OrderConnection.IsApproved) {
	          isReferredIn = false;
	        }
	      }
	
	      var extentLink = isBodyShop ? '/bodyextent' : '/1';
	
	      // console.log(this.props.order)
	      // let hasExtent = this.props.order.HasExtent
	      var isAssessmentOk = true; // isBodyShop ? this.props.order.IsBodyShopAssessmentOk : this.props.order.IsAssessmentOk
	      // if (isBodyShop) hasExtent = true || this.props.order.HasExtentBodyShop
	      var pric = _react2.default.createElement(_Extent2.default, {
	        order: this.props.order,
	        department: isBodyShop ? 1 : 0,
	        showAgreementPrice: false,
	        extents: [{
	          type: 'base',
	          editable: false
	        }]
	      });
	      var hasForsiPaint = this.props.order.Report && this.props.order.Report.Paint && this.props.order.Report.ReportType === REPORTTYPE.Forsi;
	      var hasForsiBody = this.props.order.Report && this.props.order.Report.Body && this.props.order.Report.ReportType === REPORTTYPE.Forsi;
	      return _react2.default.createElement(
	        'div',
	        { className: 'extent_box clearfix' },
	        !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && isBodyShop === true && _react2.default.createElement(
	          _reactRouter.Link,
	          { to: !hasForsiBody && this.props.order.OrderType !== 1 && !isAssessmentOk && !isReferredIn && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) ? '/pricecalculation/' + this.props.order.Id + extentLink : '' },
	          pric,
	          extentLines !== null && extentLines.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'OldOrderExtent' },
	            extentLines.map(renderLine),
	            _react2.default.createElement('br', null)
	          )
	        ),
	        !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && isBodyShop === false && _react2.default.createElement(
	          _reactRouter.Link,
	          { to: !hasForsiPaint && !isAssessmentOk && !isReferredIn && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) ? '/pricecalculation/' + this.props.order.Id + extentLink : '' },
	          this.props.order.HasAwaiting && _react2.default.createElement(
	            'div',
	            { className: 'forsi_diff' },
	            (0, _helpers.translation)('2729')
	          ),
	          pric,
	          extentLines !== null && extentLines.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'OldOrderExtent' },
	            extentLines.map(renderLine),
	            _react2.default.createElement('br', null)
	          )
	        ),
	        (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(
	          'div',
	          null,
	          this.props.order.HasAwaiting && _react2.default.createElement(
	            'div',
	            { className: 'forsi_diff' },
	            (0, _helpers.translation)('2729')
	          ),
	          pric
	        )
	      );
	    }
	  }, {
	    key: 'renderAdditionalSales',
	    value: function renderAdditionalSales() {
	      var isBodyShop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.props.order.OrderType === 4) return null;
	      var isReferredIn = this.props.order.IsReferredIn;
	      var isAssessmentOk = true;
	      if (isReferredIn) {
	        if (this.props.order.OrderConnection !== undefined && this.props.order.OrderConnection !== null && this.props.order.OrderConnection.IsApproved) {
	          isReferredIn = false;
	        }
	      }
	      var addonPriceComment = this.props.order.AddonPriceComment !== null ? this.props.order.AddonPriceComment : '';
	      if (this.props.order.IsDummy) {
	        addonPriceComment = 'Pris';
	      }
	      // let showPrices = hasAccess([6], this.props.auth.user.UserType) || this.props.order.ShowPrices
	      var addedPrice = _react2.default.createElement(_Extent2.default, {
	        order: this.props.order,
	        department: isBodyShop ? 1 : 0,
	        showAgreementPrice: false,
	        extents: [{
	          type: 'addon',
	          editable: false,
	          noTitle: true
	        }]
	      });
	
	      var extentLink = isBodyShop ? '/bodyaddon' : '/2';
	      var hasExtentAddon = this.props.order.HasExtentAddon; // HasExtentBodyShopAddon
	      if (isBodyShop) hasExtentAddon = this.props.order.HasExtentBodyShopAddon;
	      return _react2.default.createElement(
	        'div',
	        { className: 'additional_sales_box' },
	        !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: !isAssessmentOk && !isReferredIn && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) ? '/pricecalculation/' + this.props.order.Id + extentLink : '' },
	            hasExtentAddon && _react2.default.createElement(
	              _expand2.default,
	              { title: (0, _helpers.translation)('1396') },
	              this.props.order.HasAwaitingAddon && _react2.default.createElement(
	                'div',
	                { className: 'forsi_diff' },
	                (0, _helpers.translation)('17840')
	              ),
	              addedPrice,
	              this.props.order.OrderExtent !== null && this.props.order.AddonPrice > 0 && _react2.default.createElement(
	                'span',
	                null,
	                addonPriceComment,
	                ': ',
	                (0, _currency.formatCurrency)(isBodyShop ? this.props.order.BodyShopAddonPrice : this.props.order.AddonPrice || 0)
	              )
	            )
	          )
	        ),
	        (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(
	          'div',
	          null,
	          this.props.order.HasExtentAddon && _react2.default.createElement(
	            _expand2.default,
	            { title: (0, _helpers.translation)('1396') },
	            this.props.order.HasAwaitingAddon && _react2.default.createElement(
	              'div',
	              { className: 'forsi_diff' },
	              (0, _helpers.translation)('17840')
	            ),
	            addedPrice,
	            this.props.order.OrderExtent !== null && this.props.order.AddonPrice > 0 && _react2.default.createElement(
	              'span',
	              null,
	              addonPriceComment,
	              ': ',
	              (0, _currency.formatCurrency)(isBodyShop ? this.props.order.BodyShopAddonPrice : this.props.order.AddonPrice || 0)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'GetIcon',
	    value: function GetIcon(assessmentItem, complete) {
	      var icon = (0, _order.makeOrderAssessmentIcon)(assessmentItem.Name, complete);
	      return _react2.default.createElement(
	        'div',
	        { className: 'imgDiv hint--right', 'aria-label': (0, _helpers.translation)(assessmentItem.Name) },
	        _react2.default.createElement(_icon2.default, { icon: icon })
	      );
	    }
	  }, {
	    key: 'ToAfterEvaluation',
	    value: function ToAfterEvaluation() {
	      var _this2 = this;
	
	      var isWP = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var isAfterEval = this.props.order.OrderType === 1;
	      var isDisabled = this.props.AfterEvaluation.Checked || isWP && !isAfterEval;
	      var disabledNoPermission = false;
	      if (isAfterEval && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) {
	        isDisabled = true;
	        disabledNoPermission = true;
	      }
	
	      var ConditionalLink = function ConditionalLink(props) {
	        var onClick = function onClick() {
	          if (disabledNoPermission === true) return null;
	          var msg = '15025';
	          if (isWP && !isAfterEval) {
	            msg = '15038';
	          }
	          window.toastr.error((0, _helpers.translation)(msg), (0, _helpers.translation)('216'));
	        };
	
	        if (!isDisabled) {
	          if (isAfterEval) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/pricecalculation/' + _this2.props.order.Id + '/4', className: 'left', disabled: isDisabled },
	              props.children
	            );
	          } else {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/pricecalculation/' + _this2.props.order.Id + (!_this2.props.isBodyshop ? '/1' : '/bodyextent'), className: 'left', disabled: isDisabled },
	              props.children
	            );
	          }
	        } else {
	          return _react2.default.createElement(
	            'a',
	            { className: 'left', onClick: onClick },
	            props.children
	          );
	        }
	      };
	
	      var title = '13565';
	      if (isAfterEval) {
	        title = '14714';
	      }
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	      return _react2.default.createElement(
	        ConditionalLink,
	        null,
	        _react2.default.createElement(_button2.default, { style: 'secondary', labelText: (0, _helpers.translation)(title), disabled: isDisabled })
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this3 = this;
	
	      // Do not show button for Complaints
	      if (this.props.order.OrderType === 5) return null;
	      var hasForsiReport = this.props.order.Report !== null && this.props.order.Report.ReportType === REPORTTYPE.Forsi;
	      var assessmentItems = this.props.assessmentItems;
	      var renderAssessmentItem = function renderAssessmentItem(assessmentItem, index) {
	        var className = 'assessmentItem';
	
	        if (index < assessmentItems.AssessmentItemDetails.length - 1) className += ' assessment_item_bottomborder';
	        // {
	        var assessmentItemLabel = _react2.default.createElement(
	          _inline2.default,
	          null,
	          (0, _helpers.translation)(assessmentItem.Name),
	          _this3.props.isBodyshop && renderDownloadLink()
	        );
	        return _react2.default.createElement(
	          _inline2.default,
	          { key: 'assesmentItem_' + index, fillChildNum: [1], block: true },
	          _this3.GetIcon(assessmentItem, assessmentItem.Completed),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: assessmentItemLabel, className: className },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: ['max-content', 'max-content', 1, '24px'] },
	              _react2.default.createElement(
	                'div',
	                { className: 'assessment-date' },
	                (0, _time.renderFullDate)(assessmentItem.Date, false, undefined)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assessment-time' },
	                (0, _time.renderFullDate)(assessmentItem.Date, true, true)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assessment-creator' },
	                _react2.default.createElement(_UserInfo2.default, { user: assessmentItem.CreatedByUserInfo })
	              ),
	              assessmentItem.OnWorkcard && !_this3.props.isBodyshop && _react2.default.createElement(_icon2.default, { icon: (0, _order.makeOrderAssessmentIcon)(159) })
	            )
	          )
	        );
	      };
	      var renderDownloadLink = function renderDownloadLink() {
	        if (!hasForsiReport || _this3.props.auth.departmentType === DEPARTMENTTYPE.Paint) return null;
	        var report = _this3.props.order.Report;
	        var attachment = report.Attachments.find(function (file) {
	          return _this3.formatSectionType(file.SectionType) === _this3.props.auth.departmentType;
	        });
	        if (_this3.props.auth.departmentType === DEPARTMENTTYPE.Body && hasForsiReport && attachment && attachment.OrderFileId) {
	          if (attachment.FileName === null) return null;
	          var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(_this3.props.auth.user.Token);
	
	          return _react2.default.createElement(
	            'a',
	            { href: newFileUrl, title: attachment.FileName, target: '_blank' },
	            _react2.default.createElement('img', { src: '/images/svgs/download.svg', alt: '', className: 'downloadIcon' })
	          );
	        }
	      };
	      var selectChange = function selectChange(e) {
	        _this3.props.onChange(e);
	      };
	      var renderSelect = function renderSelect() {
	        return _react2.default.createElement(
	          _dropDown2.default,
	          { labelText: (0, _helpers.translation)('13052') + ':', onChange: selectChange, value: _this3.props.AfterEvaluation.AssessmentSelection },
	          _react2.default.createElement(
	            'option',
	            { value: 0 },
	            (0, _helpers.translation)('15000')
	          ),
	          _this3.props.order.OrderType === 1 && _react2.default.createElement(
	            'option',
	            { value: 1 },
	            (0, _helpers.translation)('15001')
	          ),
	          _this3.props.order.OrderType === 2 && _this3.props.auth.departmentType !== 1 && _react2.default.createElement(
	            'option',
	            { value: 3 },
	            (0, _helpers.translation)('15281')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 2 },
	            (0, _helpers.translation)('15002')
	          )
	        );
	      };
	
	      var renderExtent = function renderExtent(type) {
	        var renderPriceCalculation = _this3.renderPriceCalculation(_this3.props.isBodyshop);
	        var renderAdditionalSales = _this3.renderAdditionalSales(_this3.props.isBodyshop);
	
	        var extentClass = 'extent';
	        if (_this3.state.showExtent) {
	          extentClass += ' open';
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: extentClass },
	          _react2.default.createElement(
	            'div',
	            null,
	            type === 'normal' && renderPriceCalculation
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            renderAdditionalSales
	          )
	        );
	      };
	      var assessmentClassName = 'assessmentItems';
	      if (!(assessmentItems && assessmentItems.AnyOnWorkcard && assessmentItems.AssessmentItemDetails.length > 0)) assessmentClassName += '2';
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderSelect(),
	        _react2.default.createElement(
	          'div',
	          { className: assessmentClassName },
	          assessmentItems && assessmentItems.AssessmentItemDetails.map(renderAssessmentItem)
	        ),
	        renderExtent('normal'),
	        !this.props.isBodyshop && this.ToAfterEvaluation(),
	        (0, _auth.hasAccess)([3, 5, 6, 7], this.props.auth.user.UserType) && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && !this.props.isBodyshop && this.props.auth.permissions.ChainAssessmentSystem !== _constants.AssessmentSystemType.DBS && _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/EvaluationHistory/' + this.props.order.Id },
	          _react2.default.createElement(_button2.default, { style: 'secondary', labelText: (0, _helpers.translation)('15094') })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var onHeaderClick = function onHeaderClick() {
	        var prop = 'AfterEvaluation';
	        if (_this4.props.isBodyshop) prop = 'BodyshopAfterEvaluation';
	        _this4.props.onHeaderClick(prop);
	      };
	      var title = { icon: '/images/svgs/inspection/assessment.svg', text: '901' };
	      return _react2.default.createElement(_InspectionItem2.default, { onHeaderClick: onHeaderClick, title: title, renderContent: this.renderContent, checked: this.props.AfterEvaluation.Checked });
	    }
	  }]);
	
	  return Assessment;
	}(_react.PureComponent);
	
	Assessment.defaultProps = {
	  isBodyshop: false
	};
	
	Assessment.propTypes = {
	  isBodyshop: _propTypes2.default.bool,
	  AfterEvaluation: _propTypes2.default.object.isRequired,
	  order: _propTypes2.default.object.isRequired
	};
	
	Assessment.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Assessment);

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _AssignBox = __webpack_require__(196);
	
	var _AssignBox2 = _interopRequireDefault(_AssignBox);
	
	var _AssignItem = __webpack_require__(227);
	
	var _AssignItem2 = _interopRequireDefault(_AssignItem);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Constants
	
	
	// Elements
	
	
	var AssignWorker = function (_Component) {
	  _inherits(AssignWorker, _Component);
	
	  function AssignWorker(props) {
	    _classCallCheck(this, AssignWorker);
	
	    var _this = _possibleConstructorReturn(this, (AssignWorker.__proto__ || Object.getPrototypeOf(AssignWorker)).call(this, props));
	
	    _this.state = {
	      showAssign: false
	    };
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.onAssignUsers = _this.onAssignUsers.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssignWorker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'onAssignUsers',
	    value: function onAssignUsers() {
	      this.refs.AssignBox.getWrappedInstance().getAssignEmployees();
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      if (this.props.order.StepId === undefined) return null; // Order not loaded yet.
	      if (this.props.isBodyshop) return null; // TODO: Make processtime work for bodyshop first
	      var disabled = this.props.order.IsReferredOut;
	      var stepId = this.props.order.StepId;
	      // Find entry in step assignments
	      var entry = null;
	      for (var i = 0; i < this.props.StepAssignments.length; i++) {
	        if (this.props.StepAssignments[i].StepId === stepId) {
	          entry = _extends({}, this.props.StepAssignments[i].OrderAssignments[0]);
	          break;
	        }
	      }
	
	      var toggleShowAssign = function toggleShowAssign() {
	        var showAssign = !_this2.state.showAssign;
	        console.log(_this2.props, stepId, entry);
	        _this2.setState({
	          showAssign: showAssign
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AssignItem2.default, { disabled: disabled, item: entry, step: stepId, onAssignUsers: this.onAssignUsers, assignAriaPos: 'bottom-right', DontShowDeadline: true }),
	        _react2.default.createElement(_button2.default, { style: 'secondary', onClick: toggleShowAssign, labelText: (0, _helpers.translation)('270') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var title = { icon: '/images/svgs/inspection/assign.svg', text: '1856' };
	      return _react2.default.createElement(
	        'div',
	        { key: 'box_1' },
	        _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, showCheckmark: false }),
	        this.state.showAssign && _react2.default.createElement(_AssignBox2.default, { router: this.props.router, ref: 'AssignBox', onEmployeeChange: this.props.getAssignOrderData, closeAssign: function closeAssign() {
	            _this3.setState({ showAssign: false });
	          } })
	      );
	    }
	  }]);
	
	  return AssignWorker;
	}(_react.Component);
	
	AssignWorker.defaultProps = {
	  isBodyshop: false
	};
	
	AssignWorker.propTypes = {
	  isBodyshop: _propTypes2.default.bool,
	  getAssignOrderData: _propTypes2.default.func.isRequired,
	  StepAssignments: _propTypes2.default.array.isRequired,
	  order: _propTypes2.default.object.isRequired
	};
	
	AssignWorker.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(AssignWorker);

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _helpers = __webpack_require__(2);
	
	var _OrderBookingButton = __webpack_require__(417);
	
	var _OrderBookingButton2 = _interopRequireDefault(_OrderBookingButton);
	
	var _orders = __webpack_require__(21);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _BookingTimes = __webpack_require__(289);
	
	var _BookingTimes2 = _interopRequireDefault(_BookingTimes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Datetime from 'react-datetime'
	
	// import moment from 'moment'
	
	// import { renderFullDate } from '../../../../utils/time'
	// Constants
	
	// import DateTime from '../../../../shared/elements/datetime'
	// import DropDown from '../../../../shared/elements/dropDown'
	// import Inline from '../../../../shared/elements/inline'
	
	
	var BodyshopBooking = function (_PureComponent) {
	  _inherits(BodyshopBooking, _PureComponent);
	
	  function BodyshopBooking(props) {
	    _classCallCheck(this, BodyshopBooking);
	
	    var _this = _possibleConstructorReturn(this, (BodyshopBooking.__proto__ || Object.getPrototypeOf(BodyshopBooking)).call(this, props));
	
	    _this.state = {};
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.bookOrder = _this.bookOrder.bind(_this);
	    return _this;
	  }
	
	  // renderDeadlineDate (name, DictionaryKey, times) {
	  //   if (this.props.deadline[name] === '') return null
	  //   // Variables
	  //   // let date = window.CustomDate(this.state.inspection.Deadline[name])
	  //   let date = window.CustomDate(this.props.deadline[name])
	  //   let timeString = renderFullDate(date, true, true)
	  //   let disabled = this.props.bodyshopBooking.IsBooked || this.props.order.IsReferredOut
	
	  //   // Functions
	  //   const onChangeTime = (e) => {
	  //     this.props.onChangeTime(e.target.value, name, this.props.isBodyshop)
	  //   }
	  //   // Return
	  //   let timeKey = name + '_' + moment(date).format('DD-MM-YYYY_HH:mm') + '_' + times.length
	  //   let inputProps = {
	  //     readOnly: true,
	  //     disabled: disabled
	  //   }
	  //   const onDeadlineChange = (e) => {
	  //     this.props.onDeadlineChange(e, name, this.props.isBodyshop)
	  //   }
	  //   return (
	  //     <LabelWrapper labelText={translation(DictionaryKey)}>
	  //       <Inline>
	  //         <DateTime
	  //           inputProps={inputProps}
	  //           closeOnSelect
	  //           dateFormat='DD-MM-YYYY'
	  //           timeFormat={false}
	  //           value={date}
	  //           onChange={onDeadlineChange}
	  //         />
	  //         <DropDown value={timeString} onChange={onChangeTime} ref={name} key={timeKey}
	  //           disabled={disabled}>
	  //           {times.map((val, index) => {
	  //             return <option key={index} value={val}>{val}</option>
	  //           })}
	  //         </DropDown>
	  //       </Inline>
	  //     </LabelWrapper>
	  //   )
	  // }
	
	  _createClass(BodyshopBooking, [{
	    key: 'bookOrder',
	    value: function bookOrder(e) {
	      var BodyShop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var _this2 = this;
	
	      var BookAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var DoNotRoute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var order = this.props.order;
	
	      var routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders']);
	      this.setState({ updating: true });
	      // this.saveWorkcard(e).then((res) => {
	      this.props.bookOrder({
	        OrderId: order.Id,
	        Transport: parseInt(order.Transport),
	        BrandName: order.BrandName,
	        Model: order.Model,
	        BookOnlyBodyShopOrder: BodyShop === true,
	        BookAll: BookAll === true
	      }).then(function (res) {
	        // Update order
	        _this2.props.onUpdateOrder(res.data.Order);
	        // Toastr
	        // window.toastr.success(translation('13416'), translation('13424'))
	        _this2.setState({ updating: false });
	        // Go back
	        if (_this2.props.auth.departmentType === 1) {
	          if (BodyShop !== false) {
	            if (routeItem === null) {
	              _this2.props.router.replace('/orders?orderid=' + order.Id);
	            } else if (DoNotRoute !== true) {
	              _this2.props.router.replace(routeItem.pathname + '?orderid=' + order.Id);
	            }
	          }
	        } else {
	          if (routeItem === null) {
	            _this2.props.router.replace('/orders?orderid=' + order.Id);
	          } else {
	            _this2.props.router.replace(routeItem.pathname + '?orderid=' + order.Id);
	          }
	        }
	        _this2.props.getInspection();
	      }, function (err) {
	        _this2.setState({ updating: false });
	        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	          var errors = err.response.data.Errors;
	          var errorText = '';
	          errors.map(function (item) {
	            if (item.DictionaryKey !== 0) {
	              errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey) + '<br />';
	            }
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(13417), (0, _helpers.translation)('216'));
	        }
	        // console.log(res.response.data)
	        // Toastr
	        // window.toastr.error(translation('13417'), translation('216'))
	      });
	    }
	  }, {
	    key: 'renderPaintShopStatus',
	    value: function renderPaintShopStatus() {
	      var _this3 = this;
	
	      var onUpdateOrder = function onUpdateOrder(e) {
	        _this3.props.onUpdateOrder(e);
	        _this3.props.getInspection();
	      };
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('13052') },
	        _react2.default.createElement(_OrderBookingButton2.default, { disabled: this.props.order.IsReferredOut, order: this.props.order, bookOrder: this.bookOrder, onUpdateOrder: onUpdateOrder, togglePopup: this.props.togglePopup })
	      );
	    }
	
	    // renderBookingTimes () {
	    //   return(
	    //     <BookingTimes OrderId={this.state.order.Id} FromBody />
	    //   )
	    // }
	
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this4 = this;
	
	      if (!this.props.order.HasAvailablePaintPartner) return null;
	      var disabled = this.props.bodyshopBooking.IsBooked || this.props.order.IsReferredOut;
	      var listItems = [{ id: 1, name: 154 }, { id: 3, name: 26 }, { id: 2, name: 351 }];
	      var value = 'Transport';
	      var displayValue = this.props.bodyshopBooking[value];
	      var onChangeTransport = function onChangeTransport(e) {
	        _this4.props.onInputChange(e);
	      };
	      var renderItem = function renderItem(val, index) {
	        var id = val.id;
	        var checked = displayValue !== null && displayValue.toString() === id.toString();
	        return _react2.default.createElement(_radio2.default, { key: index, labelText: (0, _helpers.translation)(val.name), id: value + '_' + id + '_input', name: value, value: id, onChange: onChangeTransport, checked: checked, disabled: disabled });
	      };
	      var onChangeLoosePart = function onChangeLoosePart(e) {
	        _this4.props.onInputChange(e);
	      };
	      var renderLoosePart = function renderLoosePart(val, index) {
	        var id = val.id;
	        var value = 'LoosePartsType';
	        var displayValue = _this4.props.bodyshopBooking[value];
	        var checked = id === 1 && displayValue || id === 2 && !displayValue;
	        return _react2.default.createElement(_radio2.default, { key: index, labelText: (0, _helpers.translation)(val.name), id: value + '_' + id + '_input', name: value, value: id, onChange: onChangeLoosePart, checked: checked, disabled: disabled });
	      };
	      var loosePartTypes = [{ id: 1, name: 75 }, { id: 2, name: 76 }];
	      var renderLoosePartType = function renderLoosePartType() {
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('13395') },
	          loosePartTypes.map(renderLoosePart)
	        );
	      };
	      var renderTransport = function renderTransport() {
	        if (!_this4.props.order.Id) return null;
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('26') },
	          listItems.map(renderItem)
	        );
	      };
	      // let deadlineTimes = this.props.deadlineTimes
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderPaintShopStatus(),
	        _react2.default.createElement(_BookingTimes2.default, { OrderId: this.props.order.Id, FromPaint: true, Component: 'OrderInspection' }),
	        renderTransport(),
	        this.props.bodyshopBooking.Transport === 2 && renderLoosePartType()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      if (!this.props.deadline) return null;
	      var title = {
	        icon: '/images/svgs/inspection/booking.svg',
	        text: '13373'
	      };
	      var headerClick = function headerClick() {
	        _this5.props.onHeaderClick('BodyshopBooking');
	      };
	      return _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, checked: this.props.checked, onHeaderClick: headerClick });
	    }
	  }]);
	
	  return BodyshopBooking;
	}(_react.PureComponent);
	
	BodyshopBooking.defaultProps = {
	  isBodyshop: false
	};
	
	BodyshopBooking.propTypes = {
	  getInspection: _propTypes2.default.func.isRequired,
	  // bodyshopBooking: React.PropTypes.object.isRequired,
	  onInputChange: _propTypes2.default.func.isRequired,
	  onDeadlineChange: _propTypes2.default.func.isRequired,
	  onChangeTime: _propTypes2.default.func.isRequired,
	  // deadline: React.PropTypes.object.isRequired,
	  // deadlineTimes: React.PropTypes.object.isRequired,
	  onHeaderClick: _propTypes2.default.func.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired
	};
	
	BodyshopBooking.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  bookOrder: _orders.bookOrder
	})(BodyshopBooking);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var Claim = function (_PureComponent) {
	  _inherits(Claim, _PureComponent);
	
	  function Claim(props) {
	    _classCallCheck(this, Claim);
	
	    var _this = _possibleConstructorReturn(this, (Claim.__proto__ || Object.getPrototypeOf(Claim)).call(this, props));
	
	    _this.state = {};
	    _this.renderContent = _this.renderContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(Claim, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var Claim = this.props.claim;
	      if (Claim === null) return null;
	      var ourName = (0, _helpers.translation)('733');
	      var shopName = this.props.shopName;
	      var custName = this.props.customerName;
	      if (shopName) {
	        ourName = shopName;
	      }
	      var customerName = (0, _helpers.translation)('363');
	      if (custName) {
	        customerName = custName;
	      }
	      var onBlur = function onBlur(e) {
	        _this2.props.onBlur(e);
	      };
	      var onChange = function onChange(e) {
	        _this2.props.onChange(e);
	      };
	      var renderReason = function renderReason(item, key) {
	        var renderComplaint = function renderComplaint(complaint, k) {
	          var complaintName = (0, _helpers.enumtranslate)('ComplaintTypes', complaint);
	          if (_this2.props.isBodyshop) {
	            switch (complaint) {
	              case 14:
	                complaintName = 317;
	                break;
	              case 15:
	                complaintName = 318;
	                break;
	              case 16:
	                complaintName = 320;
	                break;
	              case 17:
	                complaintName = 319;
	                break;
	              case 18:
	                complaintName = 321;
	                break;
	              case 19:
	                complaintName = 322;
	                break;
	              case 20:
	                complaintName = 227;
	                break;
	              case 26:
	                complaintName = 766;
	                break;
	              case 27:
	                complaintName = 767;
	                break;
	              case 28:
	                complaintName = 770;
	                break;
	              case 1026:
	                complaintName = 1034;
	                break;
	              case 1027:
	                complaintName = 1307;
	                break;
	            }
	          }
	          return _react2.default.createElement(
	            'div',
	            { key: k, className: 'reason' },
	            (0, _helpers.translation)(complaintName)
	          );
	        };
	        var side = '';
	        if (item.Part.TaskSide !== 0) {
	          side = item.Part.TaskSide === 1 ? (0, _helpers.translation)('213') : (0, _helpers.translation)('214');
	        }
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: side + (0, _helpers.translation)(item.Part.DictionaryKey), key: key },
	          item.Complaints.map(renderComplaint)
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('13410'), name: 'ComplaintOurRefNr', value: Claim.ComplaintOurRefNr || '', onChange: onChange, onBlur: onBlur }),
	        _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('185'), defaultValue: Claim.ComplaintCustomerRef || '', disabled: true }),
	        _react2.default.createElement(
	          'div',
	          { className: 'category' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('333')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          Claim.ComplaintReasons.map(renderReason)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'category' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('994')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          Claim.ComplaintComment
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'category' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('13409')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          Claim.PreviousOrder !== null ? _react2.default.createElement(
	            'div',
	            null,
	            (0, _time.renderFullDate)(Claim.PreviousOrder.Delivery, false),
	            ', ',
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: '/orders/' + Claim.PreviousOrder.OrderId },
	              Claim.PreviousOrder.OrderId
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('2004')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'category' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('1427') },
	            _react2.default.createElement(_radio2.default, { labelText: ourName, id: 'payment_us', name: 'Payment', value: 'us', checked: Claim.ComplaintPayer === 1, onChange: onChange }),
	            _react2.default.createElement(_radio2.default, { labelText: customerName, id: 'payment_customer', name: 'Payment', value: 'customer', checked: Claim.ComplaintPayer === 0, onChange: onChange })
	          )
	        ),
	        Claim.ComplaintPayer === 0 && _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('641'), name: 'ComplaintPrice', value: Claim.ComplaintPrice || 0, onChange: onChange, onBlur: onBlur })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (!this.props.claim) return null;
	      var title = {
	        icon: '/images/svgs/inspection/complaint-black.svg',
	        text: '301'
	      };
	      var headerClick = function headerClick() {
	        var prop = 'Claim';
	        if (_this3.props.isBodyshop) prop = 'BodyshopClaim';
	        _this3.props.onHeaderClick(prop);
	      };
	      return _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, onHeaderClick: headerClick, checked: this.props.claim.Checked });
	    }
	  }]);
	
	  return Claim;
	}(_react.PureComponent);
	
	Claim.defaultProps = {
	  isBodyshop: false
	};
	
	Claim.propTypes = {
	  onBlur: _propTypes2.default.func.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  claim: _propTypes2.default.object.isRequired,
	  onHeaderClick: _propTypes2.default.func.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired
	};
	
	Claim.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Claim);

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _backdrop = __webpack_require__(29);
	
	var _helpers = __webpack_require__(2);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Constants
	
	
	// Elements
	
	
	var Color = function (_PureComponent) {
	  _inherits(Color, _PureComponent);
	
	  function Color(props) {
	    _classCallCheck(this, Color);
	
	    var _this = _possibleConstructorReturn(this, (Color.__proto__ || Object.getPrototypeOf(Color)).call(this, props));
	
	    _this.state = {};
	    _this.renderContent = _this.renderContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(Color, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var onChange = function onChange(e) {
	        var propName = 'Color';
	        if (_this2.props.isBodyshop) propName = 'BodyshopColor';
	        _this2.props.onChange(propName, e);
	      };
	      var onBlur = function onBlur(e) {
	        _this2.props.onBlur(e);
	      };
	      var renderItem = function renderItem(key, name) {
	        // let colorIcon = null
	        var value = _this2.props.color ? _this2.props.color[name] || '' : '';
	        // if (name === 'Color') {
	        //   colorIcon = <span className='right'><img src='/images/svgs/color/Color.svg' title={translation('179')} style={{ width: 20, height: 20 }} /></span>
	        // }
	        // if (name === 'Code') {
	        //   colorIcon = <span className='right'><img src='/images/svgs/color/Color_code.svg' title={translation('79')} style={{ width: 20, height: 20 }} /></span>
	        // }
	        // if (name === 'Variant') {
	        //   colorIcon = <span className='right'><img src='/images/svgs/color/color-variation.svg' title={translation('13388')} style={{ width: 20, height: 20 }} /></span>
	        // }
	        // if (name === 'Amount') {
	        //   colorIcon = <span className='right'><img src='/images/svgs/color/Color_amount-VS.svg' title={translation('13392')} style={{ width: 20, height: 20 }} /></span>
	        // }
	
	        var disabled = name === 'Amount' && _this2.props.order.IsReferredOut;
	
	        return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)(key), value: value, name: name, onChange: onChange, onBlur: onBlur, disabled: disabled });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderItem('179', 'Color'),
	        renderItem('79', 'Code'),
	        !this.props.isBodyshop && renderItem('13388', 'Variant'),
	        !this.props.isBodyshop && renderItem('13392', 'Amount'),
	        !this.props.isBodyshop && _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('13393'), id: 'IsReady', name: 'IsReady', value: '1', checked: this.props.color.IsReady, onChange: onChange, disabled: this.props.order.IsReferredOut })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // if (!this.props.color) return null
	      var title = {
	        icon: '/images/svgs/inspection/color.svg',
	        text: '179'
	      };
	      var headerClick = function headerClick() {
	        var color = 'Color';
	        if (_this3.props.isBodyshop) color = 'BodyshopColor';
	        _this3.props.onHeaderClick(color);
	      };
	      return _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, checked: this.props.color ? this.props.color.Checked : false, onHeaderClick: headerClick });
	    }
	  }]);
	
	  return Color;
	}(_react.PureComponent);
	
	Color.defaultProps = {
	  isBodyshop: false
	};
	
	Color.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  onBlur: _propTypes2.default.func.isRequired,
	  // color: React.PropTypes.object.isRequired,
	  onHeaderClick: _propTypes2.default.func.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired
	};
	
	Color.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    order: state.orders.order
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup
	})(Color);

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _NotesModal = __webpack_require__(203);
	
	var _NotesModal2 = _interopRequireDefault(_NotesModal);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _backdrop = __webpack_require__(29);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Constants
	
	
	// Elements
	
	
	var CustomInspection = function (_Component) {
	  _inherits(CustomInspection, _Component);
	
	  function CustomInspection(props) {
	    _classCallCheck(this, CustomInspection);
	
	    var _this = _possibleConstructorReturn(this, (CustomInspection.__proto__ || Object.getPrototypeOf(CustomInspection)).call(this, props));
	
	    _this.state = {
	      note: {
	        modal: false,
	        data: {}
	      }
	    };
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.showNoteModal = _this.showNoteModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomInspection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'showNoteModal',
	    value: function showNoteModal() {
	      this.props.triggerPopup(!this.state.note.modal);
	      this.setState({
	        note: _extends({}, this.state.note, {
	          data: {},
	          modal: !this.state.note.modal
	        })
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var openComment = function openComment() {
	        _this2.props.triggerPopup(true);
	        _this2.setState({
	          note: {
	            data: {
	              Note: '',
	              NoteTypeID: 0,
	              SourceID: 5,
	              OrderID: _this2.props.order.Id,
	              ApplyToInvoice: false,
	              CustomInspectionId: _this2.props.item.CustomInspectionId
	            },
	            modal: true
	          }
	        });
	      };
	      var renderNote = function renderNote(note, k) {
	        var customerIcon = null;
	        if (!note.CreatedByCustommer && note.NoteTypeID === 1) {
	          customerIcon = _react2.default.createElement(
	            'div',
	            { className: 'hint--top', 'aria-label': (0, _helpers.translation)('2157') },
	            _react2.default.createElement('img', { src: '/images/icons/Customer_16.png' })
	          );
	        }
	        var invoiceIcon = _react2.default.createElement(
	          'div',
	          { className: 'hint--top', 'aria-label': (0, _helpers.translation)('14835') },
	          _react2.default.createElement('img', { src: '/images/svgs/invoice/Total_price.svg' })
	        );
	
	        var commentLabel = _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'max-content'], align: 'start' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_UserInfo2.default, { user: note.UserInfo }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(note.NoteDate)
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { spacing: [0] },
	            customerIcon,
	            note.ApplyToInvoice === true && invoiceIcon
	          )
	        );
	        return _react2.default.createElement(
	          'div',
	          { className: 'orderInspection-note' },
	          commentLabel,
	          _react2.default.createElement(
	            'div',
	            null,
	            note.Note
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.item.InspectionNotes.map(renderNote),
	        _react2.default.createElement(_button2.default, { style: 'secondary', onClick: openComment, labelText: (0, _helpers.translation)('149') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var title = {
	        icon: '/images/svgs/inspection/further-control.svg',
	        text: this.props.item.Text,
	        className: 'icon custom'
	      };
	      var headerClick = function headerClick() {
	        _this3.props.changeStatus(_this3.props.keyIndex);
	      };
	      return _react2.default.createElement(
	        'div',
	        { key: this.props.keyIndex },
	        _react2.default.createElement(_InspectionItem2.default, { noTranslation: true, title: title, renderContent: this.renderContent, checked: this.props.item.Checked, onHeaderClick: headerClick }),
	        _react2.default.createElement(_NotesModal2.default, {
	          show: this.state.note.modal,
	          onClose: this.showNoteModal,
	          note: this.state.note.data,
	          onSuccess: this.props.onNoteSuccess,
	          standardNotes: this.props.standardNotes,
	          onStandardNoteUpdate: this.props.onStandardNoteUpdate,
	          order: this.props.order })
	      );
	    }
	  }]);
	
	  return CustomInspection;
	}(_react.Component);
	
	CustomInspection.defaultProps = {
	  isBodyshop: false
	};
	
	CustomInspection.propTypes = {
	  keyIndex: _propTypes2.default.number.isRequired,
	  changeStatus: _propTypes2.default.func.isRequired,
	  onNoteSuccess: _propTypes2.default.func.isRequired,
	  item: _propTypes2.default.object.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired
	};
	
	CustomInspection.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup
	})(CustomInspection);

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _BookingTimes = __webpack_require__(289);
	
	var _BookingTimes2 = _interopRequireDefault(_BookingTimes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Deadline = function (_PureComponent) {
	  _inherits(Deadline, _PureComponent);
	
	  function Deadline(props) {
	    _classCallCheck(this, Deadline);
	
	    var _this = _possibleConstructorReturn(this, (Deadline.__proto__ || Object.getPrototypeOf(Deadline)).call(this, props));
	
	    _this.state = {};
	    _this.renderContent = _this.renderContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(Deadline, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_BookingTimes2.default, { OrderId: this.props.order.Id, FromBody: true, Component: 'OrderInspection' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.deadline) return null;
	      var title = {
	        icon: '/images/svgs/inspection/deadline.svg',
	        text: '1232'
	      };
	      var headerClick = function headerClick() {
	        var deadline = 'Deadline';
	        if (_this2.props.isBodyshop) deadline = 'BodyshopDeadline';
	        _this2.props.onHeaderClick(deadline);
	      };
	      return _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, checked: this.props.deadline.Checked, onHeaderClick: headerClick });
	    }
	  }]);
	
	  return Deadline;
	}(_react.PureComponent);
	
	Deadline.defaultProps = {
	  isBodyshop: false
	};
	
	Deadline.propTypes = {
	  onDeadlineChange: _propTypes2.default.func.isRequired,
	  onChangeTime: _propTypes2.default.func.isRequired,
	  onHeaderClick: _propTypes2.default.func.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired
	};
	
	Deadline.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Deadline);

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _constants = __webpack_require__(5);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Constants
	
	
	// Elements
	
	
	var ExternalDeviation = function (_Component) {
	  _inherits(ExternalDeviation, _Component);
	
	  function ExternalDeviation(props) {
	    _classCallCheck(this, ExternalDeviation);
	
	    var _this = _possibleConstructorReturn(this, (ExternalDeviation.__proto__ || Object.getPrototypeOf(ExternalDeviation)).call(this, props));
	
	    _this.state = {};
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.renderDeviation = _this.renderDeviation.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExternalDeviation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'renderDeviation',
	    value: function renderDeviation(deviation, key) {
	      // Render reasons
	      var renderReasons = function renderReasons(reasons, k) {
	        var renderReason = function renderReason(reason, keyReason) {
	          var enumName = reason.DeviationType.ClassId - 1 === 0 ? 'InternalDeviationTypes' : 'ExternalDeviationTypes';
	          var deviationName = (0, _helpers.enumtranslate)(enumName, reason.DeviationType.Type);
	          return _react2.default.createElement(
	            'div',
	            { key: keyReason },
	            (0, _helpers.translation)(deviationName)
	          );
	        };
	        var renderCustomReason = function renderCustomReason(reason, keyReason) {
	          var deviationName = reason.CustomReason;
	          return _react2.default.createElement(
	            'div',
	            { key: keyReason },
	            deviationName
	          );
	        };
	        var side = '';
	        if (reasons.Part.TaskSide !== 0) {
	          side = reasons.Part.TaskSide === 1 ? (0, _helpers.translation)('213') : (0, _helpers.translation)('214');
	        }
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { key: 'part_' + k, labelText: side + (0, _helpers.translation)(reasons.Part.DictionaryKey) },
	          reasons.DeviationReasons.map(renderReason),
	          reasons.CustomDeviationReasons.map(renderCustomReason)
	        );
	      };
	      // Render image
	      var renderImage = function renderImage(image, index) {
	        // console.log('image', image)
	        var url = _constants.FILE_STORAGE + (image.OrderFile !== undefined ? image.OrderFile.ThumbURL : image.FileName);
	        var fullUrl = _constants.FILE_STORAGE + (image.OrderFile !== undefined ? image.OrderFile.FileURL : image.FileName);
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          _react2.default.createElement(
	            'a',
	            { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	            _react2.default.createElement('img', { src: url })
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        deviation.Parts.length !== 0 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('333')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          deviation.Parts.map(renderReasons)
	        ),
	        deviation.DeviationFiles.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'category' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('1043')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(_Gallery2.default, { files: deviation.DeviationFiles, renderImage: renderImage })
	        ),
	        deviation.DeviationComment !== null && _react2.default.createElement(
	          'div',
	          { className: 'category' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('149')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_UserInfo2.default, { user: deviation.DeviationComment.UserInfo }),
	                (0, _time.renderFullDate)(deviation.DeviationComment.NoteDate)
	              ) },
	            deviation.DeviationComment.Note
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var Deviations = this.props.ExternalWork.Deviations;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        Deviations.map(this.renderDeviation),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/pricecalculation/' + this.props.order.Id + '/6' },
	          _react2.default.createElement(_button2.default, { style: 'secondary', labelText: (0, _helpers.translation)('311') })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.ExternalWork === null || this.props.ExternalWork === undefined) return null;
	      var onHeaderClick = function onHeaderClick() {
	        _this2.props.onHeaderClick('ExternalWork');
	      };
	      var title = { icon: '/images/svgs/inspection/external-deviation.svg', text: '583' };
	      return _react2.default.createElement(_InspectionItem2.default, { onHeaderClick: onHeaderClick, title: title, renderContent: this.renderContent, checked: this.props.ExternalWork.Checked });
	    }
	  }]);
	
	  return ExternalDeviation;
	}(_react.Component);
	
	ExternalDeviation.defaultProps = {
	  isBodyshop: false
	};
	
	ExternalDeviation.propTypes = {
	  isBodyshop: _propTypes2.default.bool,
	  ExternalWork: _propTypes2.default.object.isRequired,
	  order: _propTypes2.default.object.isRequired
	};
	
	ExternalDeviation.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(ExternalDeviation);

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _async = __webpack_require__(147);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _constants = __webpack_require__(5);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Constants
	
	
	var Files = function (_PureComponent) {
	  _inherits(Files, _PureComponent);
	
	  function Files(props) {
	    _classCallCheck(this, Files);
	
	    var _this = _possibleConstructorReturn(this, (Files.__proto__ || Object.getPrototypeOf(Files)).call(this, props));
	
	    _this.state = {
	      upload: {
	        errors: []
	      },
	      order: {},
	      loading: false,
	      confirmFileDelete: {
	        confirm: false,
	        file: null
	      },
	      mounted: false
	    };
	    _this.renderContent = _this.renderContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(Files, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        upload: this.props.upload,
	        order: this.props.order,
	        loading: false,
	        confirmFileDelete: {
	          confirm: false,
	          file: null
	        },
	        mounted: true
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        upload: nextProps.upload,
	        order: nextProps.order,
	        loading: false,
	        confirmFileDelete: {
	          confirm: false,
	          file: null
	        },
	        mounted: true
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setState({
	        mounted: false
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      if (typeof this.props.order.Id === 'undefined' || this.props.order.length === 0 || !this.state.mounted) return null;
	      var errors = this.state.upload.errors;
	      // Delete file
	
	      var deleteFile = function deleteFile(file) {
	        var confirm = {
	          confirm: true,
	          file: file
	        };
	        _this2.setState({
	          confirmFileDelete: confirm
	        });
	      };
	
	      // Render image
	      var renderImage = function renderImage(image, index) {
	        // console.log('RenderImage ', image)
	        var url = _constants.FILE_STORAGE + image.ThumbURL;
	        var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-image' },
	          _react2.default.createElement(
	            'a',
	            { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	            _react2.default.createElement('img', { src: url })
	          ),
	          image.IsDeletable && _react2.default.createElement(
	            'div',
	            { className: 'file-delete' },
	            _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	                return deleteFile(image);
	              }, size: 's' })
	          )
	        );
	      };
	      // Render file
	      var renderFile = function renderFile(file, index) {
	        // let fileUrl = file.FileURL.replace('API/', '')
	        if (file.ActualFileName === null) return null;
	        var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(_this2.props.auth.user.Token);
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	        var fileError = function fileError() {
	          window.toastr.error((0, _helpers.translation)('15191'), (0, _helpers.translation)('216'));
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-document clearfix' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          file.FileExists ? _react2.default.createElement(
	            'a',
	            { target: '_BLANK', href: newFileUrl },
	            file.FileName
	          ) : _react2.default.createElement(
	            'a',
	            { onClick: fileError },
	            file.FileName
	          ),
	          _this2.props.auth.user.CustomerId === '-1' && file.IsDeletable && _react2.default.createElement(
	            'div',
	            { className: 'file-delete' },
	            _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	                return deleteFile(file);
	              }, size: 's' })
	          )
	        );
	      };
	      // On drop
	      var onDrop = function onDrop() {
	        _this2.setState({ upload: _extends({}, _this2.state.upload, { errors: [] }) });
	      };
	
	      // On drop accepted
	      var onDropAccepted = function onDropAccepted(files) {
	        var newErrors = [];
	        _this2.setState({
	          upload: _extends({}, _this2.state.upload, {
	            loading: true,
	            errors: []
	          })
	        });
	        _async2.default.each(files, function (file, cb) {
	          // Upload each file
	          _this2.props.uploadFileToOrder(file, _this2.props.order.Id).then(function (res) {
	            cb();
	          }, function () {
	            newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13406') + '.');
	            cb();
	          });
	        }, function () {
	          if (newErrors.length !== 0) {
	            _this2.setState({
	              upload: _extends({}, _this2.state.upload, {
	                errors: _this2.state.upload.errors.concat(newErrors)
	              })
	            });
	          }
	          _this2.setState({
	            upload: _extends({}, _this2.state.upload, {
	              loading: false
	            })
	          });
	          // Save order first
	          _this2.props.loadOrder();
	        });
	      };
	      // On drop rejected
	      var onDropRejected = function onDropRejected(files) {
	        var newErrors = [];
	        files.map(function (val, index) {
	          newErrors.push((0, _helpers.translation)('1207') + ': ' + val.name + ' ' + (0, _helpers.translation)('13405') + '.');
	        });
	        _this2.setState({ upload: _extends({}, _this2.state.upload, { errors: newErrors }) });
	      };
	      // Render error
	      var renderError = function renderError(error, index) {
	        return _react2.default.createElement(
	          'p',
	          { key: index },
	          error
	        );
	      };
	      // Other files
	      var otherFiles = [];
	      var imgFiles = [];
	      if (this.state.order.OrderFiles !== undefined) {
	        otherFiles = [].concat(_toConsumableArray(this.state.order.OrderFiles));
	        otherFiles = otherFiles.filter(function (val, index) {
	          return !val.IsImage;
	        });
	        // imgFiles
	        imgFiles = [].concat(_toConsumableArray(this.state.order.OrderFiles));
	        imgFiles = imgFiles.filter(function (val, index) {
	          return val.IsImage;
	        });
	      }
	
	      // Confirm delete
	      var onPortalClose = function onPortalClose() {
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	        _this2.setState({
	          confirmFileDelete: confirm
	        });
	      };
	      var onConfirm = function onConfirm() {
	        var file = _this2.state.confirmFileDelete.file;
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	        _this2.setState({
	          confirmFileDelete: confirm
	        }, function () {
	          var newErrors = [];
	          _this2.props.deleteFileFromOrder(file).then(function (res) {
	            _this2.props.loadOrder();
	          }, function () {
	            newErrors.push((0, _helpers.translation)('1207') + ': ' + file.FileName + '' + (0, _helpers.translation)('13406') + '.');
	            _this2.setState({
	              upload: _extends({}, _this2.state.upload, { errors: newErrors })
	            });
	          });
	        });
	      };
	
	      // Render
	      var isMultipleUpload = true;
	      return _react2.default.createElement(
	        'div',
	        { className: '' },
	        errors.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          errors.map(renderError)
	        ),
	        _react2.default.createElement(
	          _Dropzone2.default,
	          {
	            onDrop: onDrop,
	            onDropAccepted: onDropAccepted,
	            onDropRejected: onDropRejected,
	            multiple: isMultipleUpload,
	            includeCircles: false },
	          this.state.upload.loading && _react2.default.createElement(
	            'p',
	            { className: 'loading' },
	            _react2.default.createElement(
	              'span',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            )
	          ),
	          !this.state.upload.loading && _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)('13397')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'files_inner' },
	          _react2.default.createElement(
	            'div',
	            null,
	            otherFiles.map(renderFile)
	          ),
	          _react2.default.createElement(_Gallery2.default, { files: imgFiles, renderImage: renderImage })
	        ),
	        this.state.confirmFileDelete.confirm && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onPortalClose })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.order.OrderFiles) return null;
	      var title = {
	        icon: '/images/svgs/inspection/files.svg',
	        text: '1043'
	      };
	      var headerClick = function headerClick() {};
	      return _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, onHeaderClick: headerClick, showCheckmark: false });
	    }
	  }]);
	
	  return Files;
	}(_react.PureComponent);
	
	Files.defaultProps = {
	  isBodyshop: false,
	  upload: {
	    errors: []
	  }
	};
	
	Files.propTypes = {
	  loadOrder: _propTypes2.default.func.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  upload: _propTypes2.default.object,
	  order: _propTypes2.default.object.isRequired
	};
	
	Files.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  uploadFileToOrder: _orders.uploadFileToOrder,
	  deleteFileFromOrder: _orders.deleteFileFromOrder
	})(Files);

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var InspectionHeader = function (_PureComponent) {
	  _inherits(InspectionHeader, _PureComponent);
	
	  function InspectionHeader(props) {
	    _classCallCheck(this, InspectionHeader);
	
	    var _this = _possibleConstructorReturn(this, (InspectionHeader.__proto__ || Object.getPrototypeOf(InspectionHeader)).call(this, props));
	
	    _this.state = {};
	    _this.renderDepartmentType = _this.renderDepartmentType.bind(_this);
	    return _this;
	  }
	
	  _createClass(InspectionHeader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'renderDepartmentType',
	    value: function renderDepartmentType() {
	      var _this2 = this;
	
	      var paintActive = '';
	      var bodyActive = '';
	      // let paintImage = 'blue'
	      // let bodyImage = 'blue'
	      // let paintActive = ''
	      // let bodyActive = ''
	
	      if (this.props.hasPaintWork) {
	        // paintImage = 'white1'
	        paintActive = 'active';
	      }
	      if (this.props.hasBodyWork) {
	        // bodyImage = 'white'
	        bodyActive = 'active';
	      }
	      var togglePaint = function togglePaint() {
	        _this2.props.togglePaint();
	      };
	      var toggleBody = function toggleBody() {
	        _this2.props.toggleBody();
	      };
	      // let paintIcon = (
	      //   <Icon icon={OrderDepartmentIcons.Paint} />
	      // )
	      // let bodyIcon = (
	      //   <Icon icon={OrderDepartmentIcons.Body} />
	      // )
	      return _react2.default.createElement(
	        _grid2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: paintActive + ' paint' },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, alignChildren: 'center' },
	            _react2.default.createElement(_check2.default, { simple: true, checked: this.props.hasPaintWork, onClick: togglePaint, onChange: function onChange() {} }),
	            _react2.default.createElement(_icon2.default, { icon: _icons.OrderDepartmentIcons.Paint })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: bodyActive + ' body' },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, alignChildren: 'center' },
	            _react2.default.createElement(_check2.default, { simple: true, checked: this.props.hasBodyWork, onClick: toggleBody, onChange: function onChange() {} }),
	            _react2.default.createElement(_icon2.default, { icon: _icons.OrderDepartmentIcons.Body })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.auth.departmentType === 0) return null;
	      // let commonClass = 'common'
	      // let extraClass = ' body'
	      // let rightClass = 'rightheader'
	      // if (this.props.auth.departmentType === 1) {
	      // commonClass += extraClass
	      // rightClass += extraClass
	      // }
	      return _react2.default.createElement(
	        'div',
	        { className: 'orderinspection_header' },
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'common' },
	            this.props.auth.departmentType === 2 && this.renderDepartmentType()
	          )
	        ),
	        this.props.hasBodyWork && _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _inline2.default,
	            { alignChildren: 'center' },
	            _react2.default.createElement(_icon2.default, { icon: _icons.OrderDepartmentIcons.Body, alt: (0, _helpers.translation)('14779') }),
	            _react2.default.createElement(
	              'h2',
	              null,
	              (0, _helpers.translation)('14779')
	            )
	          )
	        ),
	        this.props.hasPaintWork && _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _inline2.default,
	            { alignChildren: 'center' },
	            _react2.default.createElement(_icon2.default, { icon: _icons.OrderDepartmentIcons.Paint, alt: (0, _helpers.translation)('161') }),
	            _react2.default.createElement(
	              'h2',
	              null,
	              (0, _helpers.translation)('161')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InspectionHeader;
	}(_react.PureComponent);
	
	InspectionHeader.defaultProps = {
	  hasBodyWork: true,
	  hasPaintWork: true,
	  toggleBody: function toggleBody(e) {
	    console.log('clicked body');
	  },
	  togglePaint: function togglePaint(e) {
	    console.log('clicked paint');
	  }
	};
	InspectionHeader.propTypes = {
	  toggleBody: _propTypes2.default.func,
	  togglePaint: _propTypes2.default.func,
	  hasBodyWork: _propTypes2.default.bool,
	  hasPaintWork: _propTypes2.default.bool
	};
	InspectionHeader.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(InspectionHeader);

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _NotesModal = __webpack_require__(203);
	
	var _NotesModal2 = _interopRequireDefault(_NotesModal);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _backdrop = __webpack_require__(29);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Constants
	
	
	// Elements
	
	
	var MssingParts = function (_Component) {
	  _inherits(MssingParts, _Component);
	
	  function MssingParts(props) {
	    _classCallCheck(this, MssingParts);
	
	    var _this = _possibleConstructorReturn(this, (MssingParts.__proto__ || Object.getPrototypeOf(MssingParts)).call(this, props));
	
	    _this.state = {
	      note: {
	        modal: false,
	        data: {}
	      }
	    };
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.showNoteModal = _this.showNoteModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(MssingParts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'showNoteModal',
	    value: function showNoteModal() {
	      this.props.triggerPopup(!this.state.note.modal);
	      this.setState({
	        note: _extends({}, this.state.note, {
	          data: {},
	          modal: !this.state.note.modal
	        })
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var MissingParts = this.props.MissingParts;
	      var openComment = function openComment() {
	        _this2.props.triggerPopup(true);
	        _this2.setState({
	          note: {
	            data: {
	              Note: '',
	              NoteTypeID: 0,
	              SourceID: 4,
	              OrderID: _this2.props.order.Id,
	              ApplyToInvoice: false
	            },
	            modal: true
	          }
	        });
	      };
	      var showNotePopup = function showNotePopup(item) {
	        _this2.props.triggerPopup(true);
	        _this2.setState({
	          note: {
	            data: item,
	            modal: true
	          }
	        });
	      };
	      var onChange = function onChange(e) {
	        _this2.props.changeMissingPartStatus(e.target.checked);
	      };
	      var editIcon = void 0;
	      var customerIcon = null;
	      if (MissingParts.Note !== null) {
	        if (MissingParts.Note.IsMine) {
	          editIcon = _react2.default.createElement(
	            'div',
	            { className: 'hint--top', 'aria-label': (0, _helpers.translation)('13357') },
	            _react2.default.createElement('img', { src: '/images/icons/edit_16.png', onClick: function onClick() {
	                return showNotePopup(MissingParts.Note);
	              } })
	          );
	        }
	        if (!MissingParts.Note.CreatedByCustommer && MissingParts.Note.NoteTypeID === 1) {
	          customerIcon = _react2.default.createElement(
	            'div',
	            { className: 'hint--top', 'aria-label': (0, _helpers.translation)('2157') },
	            _react2.default.createElement('img', { src: '/images/icons/Customer_16.png' })
	          );
	        }
	      }
	      var invoiceIcon = _react2.default.createElement(
	        'div',
	        { className: 'hint--top', 'aria-label': (0, _helpers.translation)('14835') },
	        _react2.default.createElement('img', { src: '/images/svgs/invoice/Total_price.svg' })
	      );
	
	      var note = MissingParts.Note !== null ? _react2.default.createElement(
	        _grid2.default,
	        { cols: [1, 'max-content'], align: 'start' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_UserInfo2.default, { user: MissingParts.Note.UserInfo }),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _time.renderFullDate)(MissingParts.Note.NoteDate)
	          )
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { spacing: [0] },
	          editIcon,
	          customerIcon,
	          MissingParts.Note.ApplyToInvoice === true && invoiceIcon
	        )
	      ) : null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('2322'), id: 'MissingParts', name: 'MissingParts', value: '1', checked: MissingParts.MissingParts, onChange: onChange }),
	        MissingParts.Note === null && _react2.default.createElement(_button2.default, { style: 'secondary', onClick: openComment, labelText: (0, _helpers.translation)('149') }),
	        MissingParts.Note !== null && _react2.default.createElement(
	          'div',
	          { className: 'orderInspection-note' },
	          note,
	          _react2.default.createElement(
	            'div',
	            null,
	            MissingParts.Note.Note
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var title = {
	        icon: '/images/svgs/inspection/loose_missing-parts.svg',
	        text: '13456'
	      };
	      var headerClick = function headerClick() {
	        _this3.props.onHeaderClick('MissingParts');
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, checked: this.props.MissingParts.Checked, onHeaderClick: headerClick }),
	        _react2.default.createElement(_NotesModal2.default, {
	          show: this.state.note.modal,
	          onClose: this.showNoteModal,
	          note: this.state.note.data,
	          onSuccess: this.props.onNoteSuccess,
	          standardNotes: this.props.standardNotes,
	          onStandardNoteUpdate: this.props.onStandardNoteUpdate,
	          order: this.props.order })
	      );
	    }
	  }]);
	
	  return MssingParts;
	}(_react.Component);
	
	MssingParts.defaultProps = {
	  isBodyshop: false
	};
	
	MssingParts.propTypes = {
	  changeMissingPartStatus: _propTypes2.default.func.isRequired,
	  onHeaderClick: _propTypes2.default.func.isRequired,
	  onNoteSuccess: _propTypes2.default.func.isRequired,
	  MissingParts: _propTypes2.default.object.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired
	};
	
	MssingParts.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup
	})(MssingParts);

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _StopLockOrderModal = __webpack_require__(475);
	
	var _StopLockOrderModal2 = _interopRequireDefault(_StopLockOrderModal);
	
	var _backdrop = __webpack_require__(29);
	
	var _orders = __webpack_require__(21);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Constants
	
	// Modals
	
	// Actions
	
	
	// Elements
	
	
	var OrderStop = function (_Component) {
	  _inherits(OrderStop, _Component);
	
	  function OrderStop(props) {
	    _classCallCheck(this, OrderStop);
	
	    var _this = _possibleConstructorReturn(this, (OrderStop.__proto__ || Object.getPrototypeOf(OrderStop)).call(this, props));
	
	    _this.state = {
	      id: 0,
	      stopMessage: '',
	      stoplockorder: {
	        open: false,
	        id: 0
	      },
	      order: _this.props.order
	    };
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderStop, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var renderOldComment = function renderOldComment() {
	        var commentHeader = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_UserInfo2.default, { user: _this2.state.order.OrderStop.StoppedByUserInfo }),
	          (0, _time.renderFullDate)(_this2.state.order.OrderStop.StoppedDate)
	        );
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: commentHeader },
	          _this2.state.order.OrderStop.StoppedMessage
	        );
	      };
	      var btnText = (0, _helpers.translation)('2218');
	      if (this.state.order.IsStopped) {
	        btnText = (0, _helpers.translation)('2220');
	      }
	      // console.log('ITEM ---------->', this.state.order)
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.order.IsStopped && renderOldComment(),
	        _react2.default.createElement(_button2.default, { onClick: this.handleClick, labelText: btnText, style: 'link' })
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var _this3 = this;
	
	      if (this.state.order.IsStopped) {
	        this.props.GetNewDeliveryForResume(this.props.order.Id).then(function (res) {
	          if (res.data !== null) {
	            _this3.setState({
	              newDelivery: res.data.NewDeliveryDateTime,
	              isMoreThanHalfAnHour: res.data.IsMoreThanHalfAnHour,
	              isStopped: res.data.IsStopped
	            }, function () {
	              // if (this.state.isStopped && !this.state.isMoreThanHalfAnHour) {
	              //   this.stopLockResumeWithoutPopUp()
	              // } else {
	              _this3.props.triggerPopup(!_this3.state.stoplockorder.open);
	              _this3.setState({
	                stoplockorder: {
	                  open: !_this3.state.stoplockorder.open,
	                  id: _this3.state.order.Id
	                }
	              });
	              // }
	            });
	          }
	        });
	      } else {
	        this.props.triggerPopup(!this.state.stoplockorder.open);
	        this.setState({
	          stoplockorder: {
	            open: !this.state.stoplockorder.open,
	            id: this.state.order.Id
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      var _this4 = this;
	
	      this.props.getOrder(this.props.order.Id).then(function (res) {
	        _this4.setState({
	          order: res.data
	        });
	      });
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'stopLockResumeWithoutPopUp',
	    value: function stopLockResumeWithoutPopUp() {
	      var _this5 = this;
	
	      var data = {
	        ApplyToInvoice: this.state.order.OrderStop.StoppedMessageApplyToInvoice,
	        ShowCustomer: this.state.order.OrderStop.StoppedMessageShowCustomer,
	        Message: this.state.order.OrderStop.StoppedMessage,
	        OrderId: this.props.order.Id,
	        TimeAction: 2 // keep old time
	      };
	      this.props.StopLockOrder(data).then(function (res) {
	        // window.toastr.success(translation('13403'), translation('13424'))
	        _this5.onPortalClose('stoplockorder');
	        // this.getNewOrder()    // This doesn't exist (??)
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('13404'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderPopup',
	    value: function renderPopup() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'order__action' },
	        this.state.stoplockorder.open && _react2.default.createElement(_StopLockOrderModal2.default, {
	          show: this.state.stoplockorder.open,
	          item: this.state.order,
	          id: this.state.stoplockorder.id,
	          newDelivery: this.state.newDelivery,
	          onClose: this.onPortalClose.bind(this, 'stoplockorder') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var title = { icon: '/images/svgs/inspection/stop-hand.svg', text: '2218' };
	      return _react2.default.createElement(
	        'div',
	        { key: 'box_2' },
	        _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, showCheckmark: false }),
	        this.renderPopup()
	      );
	    }
	  }]);
	
	  return OrderStop;
	}(_react.Component);
	
	OrderStop.defaultProps = {
	  isBodyshop: false
	};
	
	OrderStop.propTypes = {
	  stopLockOrder: _propTypes2.default.func.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired
	};
	
	OrderStop.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  StopLockOrder: _orders.StopLockOrder,
	  StopLockOrderModal: _StopLockOrderModal2.default,
	  triggerPopup: _backdrop.triggerPopup,
	  GetNewDeliveryForResume: _orders.GetNewDeliveryForResume,
	  getOrder: _orders.getOrder
	})(OrderStop);

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _NotesModal = __webpack_require__(203);
	
	var _NotesModal2 = _interopRequireDefault(_NotesModal);
	
	var _backdrop = __webpack_require__(29);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var OtherComments = function (_Component) {
	  _inherits(OtherComments, _Component);
	
	  function OtherComments(props) {
	    _classCallCheck(this, OtherComments);
	
	    var _this = _possibleConstructorReturn(this, (OtherComments.__proto__ || Object.getPrototypeOf(OtherComments)).call(this, props));
	
	    _this.state = {
	      note: {
	        modal: false,
	        data: {}
	      }
	    };
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.showNoteModal = _this.showNoteModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(OtherComments, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'showNoteModal',
	    value: function showNoteModal() {
	      this.props.triggerPopup(!this.state.note.modal);
	      this.setState({
	        note: _extends({}, this.state.note, {
	          data: {},
	          modal: !this.state.note.modal
	        })
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var openComment = function openComment() {
	        _this2.props.triggerPopup(true);
	        _this2.setState({
	          note: {
	            data: {
	              Note: '',
	              NoteTypeID: 0,
	              SourceID: 5,
	              OrderID: _this2.props.order.Id,
	              ApplyToInvoice: false
	            },
	            modal: true
	          }
	        });
	      };
	      // Comments
	      var comments = !this.props.OrderNotes ? [] : this.props.OrderNotes.filter(function (v) {
	        return v.SourceID === 5;
	      });
	      var renderComment = function renderComment(item, key) {
	        var customerIcon = null;
	        if (!item.CreatedByCustommer && item.NoteTypeID === 1) {
	          customerIcon = _react2.default.createElement(
	            'div',
	            { className: 'hint--top', 'aria-label': (0, _helpers.translation)('2157') },
	            _react2.default.createElement('img', { src: '/images/icons/Customer_16.png' })
	          );
	        }
	        var invoiceIcon = _react2.default.createElement(
	          'div',
	          { className: 'hint--top', 'aria-label': (0, _helpers.translation)('14835') },
	          _react2.default.createElement('img', { src: '/images/svgs/invoice/Total_price.svg' })
	        );
	        // console.log(item)
	        var note = _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'max-content'], align: 'start' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_UserInfo2.default, { user: item.UserInfo }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(item.NoteDate)
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { spacing: [0] },
	            customerIcon,
	            item.ApplyToInvoice === true && invoiceIcon
	          )
	        );
	        return _react2.default.createElement(
	          'div',
	          { className: 'orderInspection-note' },
	          note,
	          _react2.default.createElement(
	            'div',
	            null,
	            item.Note
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        'div',
	        null,
	        comments.map(renderComment),
	        _react2.default.createElement(_button2.default, { style: 'secondary', onClick: openComment, labelText: (0, _helpers.translation)('149') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var title = { icon: '/images/svgs/inspection/comment.svg', text: '1894' };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, showCheckmark: false }),
	        _react2.default.createElement(_NotesModal2.default, {
	          show: this.state.note.modal,
	          onClose: this.showNoteModal,
	          note: this.state.note.data,
	          onSuccess: this.props.onNoteSuccess,
	          standardNotes: this.props.standardNotes,
	          onStandardNoteUpdate: this.props.onStandardNoteUpdate,
	          order: this.props.order })
	      );
	    }
	  }]);
	
	  return OtherComments;
	}(_react.Component);
	
	OtherComments.defaultProps = {
	  isBodyshop: false
	};
	
	OtherComments.propTypes = {
	  onNoteSuccess: _propTypes2.default.func.isRequired,
	  OrderNotes: _propTypes2.default.array.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired
	};
	
	OtherComments.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup
	})(OtherComments);

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _constants = __webpack_require__(5);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _array = __webpack_require__(205);
	
	__webpack_require__(1418);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var OtherDamage = function (_Component) {
	  _inherits(OtherDamage, _Component);
	
	  function OtherDamage(props) {
	    _classCallCheck(this, OtherDamage);
	
	    var _this = _possibleConstructorReturn(this, (OtherDamage.__proto__ || Object.getPrototypeOf(OtherDamage)).call(this, props));
	
	    _this.renderOtherDamage = _this.renderOtherDamage.bind(_this);
	    _this.renderDamages = _this.renderDamages.bind(_this);
	    _this.renderImage = _this.renderImage.bind(_this);
	    _this.renderContent = _this.renderContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(OtherDamage, [{
	    key: 'renderOtherDamage',
	    value: function renderOtherDamage(damage, key) {
	      if (!damage.Active) return null;
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        damage.Parts.length !== 0 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('15188')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          damage.Parts.map(this.renderDamages)
	        ),
	        damage.Files.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'category' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('1043')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(_Gallery2.default, { files: damage.Files, renderImage: this.renderImage })
	        ),
	        damage.Comment !== null && _react2.default.createElement(
	          'div',
	          { className: 'category' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('149')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_UserInfo2.default, { user: damage.Comment.UserInfo }),
	                (0, _time.renderFullDate)(damage.Comment.NoteDate)
	              ) },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _array.formatArrayToString)(damage.Comment.Note)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDamages',
	    value: function renderDamages(part, key) {
	      var renderDamage = function renderDamage(dmg, k) {
	        var dmgName = dmg.Type === 10 ? dmg.CustomName : (0, _helpers.enumtranslate)('OtherDamageTypes', dmg.Type);
	
	        return _react2.default.createElement(
	          'div',
	          { key: k },
	          (0, _helpers.translation)(dmgName)
	        );
	      };
	
	      var side = '';
	      if (part.Part.TaskSide !== 0) {
	        side = part.Part.TaskSide === 1 ? (0, _helpers.translation)('213') : (0, _helpers.translation)('214');
	        side += ' ';
	      }
	
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { key: 'part_' + key, labelText: side + (0, _helpers.translation)(part.Part.DictionaryKey) },
	        part.OtherDamages.map(renderDamage)
	      );
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(image, key) {
	      var url = _constants.FILE_STORAGE + image.ThumbURL;
	      var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        _react2.default.createElement(
	          'a',
	          { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	          _react2.default.createElement('img', { src: url })
	        )
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var OtherDamages = this.props.otherDamage.OtherDamages;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        OtherDamages && OtherDamages.map(this.renderOtherDamage),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/pricecalculation/' + this.props.order.Id + '/7' },
	          _react2.default.createElement(_button2.default, { style: 'secondary', labelText: (0, _helpers.translation)('1208') })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var title = { icon: '/images/svgs/inspection/damage-other.svg', text: '15187' };
	
	      var onHeaderClick = function onHeaderClick() {
	        _this2.props.onHeaderClick('OtherDamage');
	      };
	
	      return _react2.default.createElement(_InspectionItem2.default, { onHeaderClick: onHeaderClick, title: title, renderContent: this.renderContent, checked: this.props.otherDamage.Checked });
	    }
	  }]);
	
	  return OtherDamage;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(OtherDamage);

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _InspectionItem = __webpack_require__(89);
	
	var _InspectionItem2 = _interopRequireDefault(_InspectionItem);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var ProcessComments = function (_Component) {
	  _inherits(ProcessComments, _Component);
	
	  function ProcessComments(props) {
	    _classCallCheck(this, ProcessComments);
	
	    var _this = _possibleConstructorReturn(this, (ProcessComments.__proto__ || Object.getPrototypeOf(ProcessComments)).call(this, props));
	
	    _this.state = {};
	    _this.renderContent = _this.renderContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProcessComments, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      // Add comment
	      var addComment = function addComment() {
	        var obj = {
	          OrderId: _this2.props.order.Id,
	          Text: '',
	          Step1Start: false,
	          Step1End: false,
	          Step2Start: false,
	          Step2End: false,
	          Step3Start: false,
	          Step3End: false,
	          Step4Start: false,
	          Step4End: false,
	          Step5Start: false,
	          Step5End: false,
	          Step6Start: false,
	          Step6End: false,
	          Step7Start: false,
	          Step7End: false,
	          Step8: false,
	          Step101Start: false,
	          Step101End: false,
	          Step102Start: false,
	          Step102End: false,
	          Step103Start: false,
	          Step103End: false,
	          Step104Start: false,
	          Step104End: false,
	          Step105Start: false,
	          Step105End: false
	        };
	        var processComment = _extends({}, _this2.props.processComment);
	        var propName = 'ProcessComments';
	        // if (this.props.isBodyshop) propName = 'BodyshopProcessComments'
	        processComment[propName].push(obj);
	        _this2.props.saveProcessComment(processComment);
	      };
	      var renderProcessComment = function renderProcessComment(item, key) {
	        var onBlur = function onBlur() {
	          _this2.props.onBlur();
	        };
	        var onChange = function onChange(e) {
	          _this2.props.onChange(e, key, _this2.props.isBodyshop);
	        };
	        var deleteItem = function deleteItem(e) {
	          _this2.props.deleteItem(e, key, _this2.props.isBodyshop);
	        };
	        var renderIcon = function renderIcon(icon, title) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'hint--top', 'aria-label': (0, _helpers.translation)(title), key: title },
	            _react2.default.createElement(_icon2.default, { icon: icon, title: (0, _helpers.translation)(title) })
	          );
	        };
	        var renderStepCheckbox = function renderStepCheckbox(item, name, checked, disabled) {
	          var id = name + item.Id;
	          if (disabled === undefined) disabled = false;
	          return _react2.default.createElement(_check2.default, { labelText: id, id: id, name: id, onChange: onChange, checked: checked, disabled: disabled, simple: true });
	        };
	        var renderIcons = function renderIcons() {
	          if (_this2.props.isBodyshop) {
	            return _react2.default.createElement(
	              _grid2.default,
	              { justify: 'center', align: 'center' },
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_New, '164'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Disassembly, '617'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Repair, '618'),
	              _this2.props.auth.departmentType === 1 && renderIcon(_icons.QualityCheckIcons.Quality_Check_Coating, '161'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Assembly, '619'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Preparing_Body, '162'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Handover, '163')
	            );
	          }
	          if (_this2.props.auth.departmentType === 0) {
	            return _react2.default.createElement(
	              _grid2.default,
	              { justify: 'center', align: 'center' },
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_New, '164'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Pretreatment, '96'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Filler, '160'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Sanding, '158'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Coating, '161'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Preparing, '162'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Handover, '163'),
	              renderIcon(_icons.QualityCheckIcons.Quality_Check_Finished, '1231')
	            );
	          }
	          return _react2.default.createElement(
	            _grid2.default,
	            { justify: 'center', align: 'center' },
	            renderIcon(_icons.QualityCheckIcons.Quality_Check_Pretreatment, '96'),
	            renderIcon(_icons.QualityCheckIcons.Quality_Check_Filler, '160'),
	            renderIcon(_icons.QualityCheckIcons.Quality_Check_Sanding, '158'),
	            renderIcon(_icons.QualityCheckIcons.Quality_Check_Coating, '161'),
	            renderIcon(_icons.QualityCheckIcons.Quality_Check_Preparing, '162'),
	            renderIcon(_icons.QualityCheckIcons.Quality_Check_Finished, '1231')
	          );
	        };
	        var renderSteps = function renderSteps(isStop) {
	          var stepType = 'Start';
	          if (isStop) stepType = 'End';
	          if (_this2.props.isBodyshop) {
	            return _react2.default.createElement(
	              _grid2.default,
	              { justify: 'center', align: 'center' },
	              renderStepCheckbox(item, 'Step1' + stepType + '_', item['Step1' + stepType]),
	              renderStepCheckbox(item, 'Step101' + stepType + '_', item['Step101' + stepType], _this2.props.order.OrderDepartment === 0),
	              renderStepCheckbox(item, 'Step102' + stepType + '_', item['Step102' + stepType], _this2.props.order.OrderDepartment === 0),
	              _this2.props.auth.departmentType === 1 && renderStepCheckbox(item, 'Step105' + stepType + '_', item['Step105' + stepType]),
	              renderStepCheckbox(item, 'Step103' + stepType + '_', item['Step103' + stepType], _this2.props.order.OrderDepartment === 0),
	              renderStepCheckbox(item, 'Step104' + stepType + '_', item['Step104' + stepType], _this2.props.order.OrderDepartment === 0),
	              renderStepCheckbox(item, 'Step7' + stepType + '_', item['Step7' + stepType])
	            );
	          }
	          if (_this2.props.auth.departmentType === 0) {
	            return _react2.default.createElement(
	              _grid2.default,
	              { justify: 'center', align: 'center' },
	              renderStepCheckbox(item, 'Step1' + stepType + '_', item['Step1' + stepType]),
	              renderStepCheckbox(item, 'Step2' + stepType + '_', item['Step2' + stepType]),
	              renderStepCheckbox(item, 'Step3' + stepType + '_', item['Step3' + stepType]),
	              renderStepCheckbox(item, 'Step4' + stepType + '_', item['Step4' + stepType]),
	              renderStepCheckbox(item, 'Step5' + stepType + '_', item['Step5' + stepType]),
	              renderStepCheckbox(item, 'Step6' + stepType + '_', item['Step6' + stepType]),
	              renderStepCheckbox(item, 'Step7' + stepType + '_', item['Step7' + stepType]),
	              !isStop && renderStepCheckbox(item, 'Step8_', item.Step8),
	              isStop && _react2.default.createElement('div', null)
	            );
	          }
	          return _react2.default.createElement(
	            _grid2.default,
	            { justify: 'center', align: 'center' },
	            renderStepCheckbox(item, 'Step2' + stepType + '_', item['Step2' + stepType]),
	            renderStepCheckbox(item, 'Step3' + stepType + '_', item['Step3' + stepType]),
	            renderStepCheckbox(item, 'Step4' + stepType + '_', item['Step4' + stepType]),
	            renderStepCheckbox(item, 'Step5' + stepType + '_', item['Step5' + stepType]),
	            renderStepCheckbox(item, 'Step6' + stepType + '_', item['Step6' + stepType]),
	            !isStop && renderStepCheckbox(item, 'Step8_', item.Step8)
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(_text2.default, { onChange: onChange, onBlur: onBlur, value: item.Text }),
	            _react2.default.createElement(_removeButton2.default, { onClick: deleteItem, round: true })
	          ),
	          renderIcons(),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('271') },
	            renderSteps(false)
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('2062') },
	            renderSteps(true)
	          ),
	          _react2.default.createElement(_divider2.default, null)
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.processComment && this.props.processComment.ProcessComments.map(renderProcessComment),
	        _react2.default.createElement(_button2.default, { style: 'secondary', onClick: addComment, labelText: (0, _helpers.translation)('1208') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (!this.props.processComment) return null;
	      var title = {
	        icon: '/images/svgs/inspection/comment.svg',
	        text: '15091'
	      };
	      var headerClick = function headerClick() {
	        var processComment = 'ProcessComment';
	        if (_this3.props.isBodyshop) processComment = 'BodyshopProcessComment';
	        _this3.props.onHeaderClick(processComment);
	      };
	      return _react2.default.createElement(_InspectionItem2.default, { title: title, renderContent: this.renderContent, checked: this.props.processComment.Checked, onHeaderClick: headerClick });
	    }
	  }]);
	
	  return ProcessComments;
	}(_react.Component);
	
	ProcessComments.defaultProps = {
	  isBodyshop: false
	};
	
	ProcessComments.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  onBlur: _propTypes2.default.func.isRequired,
	  deleteItem: _propTypes2.default.func.isRequired,
	  saveProcessComment: _propTypes2.default.func.isRequired,
	  // processComment: React.PropTypes.object.isRequired,
	  onHeaderClick: _propTypes2.default.func.isRequired,
	  isBodyshop: _propTypes2.default.bool,
	  order: _propTypes2.default.object.isRequired
	};
	
	ProcessComments.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(ProcessComments);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(27);
	
	__webpack_require__(1419);
	
	var _orders = __webpack_require__(21);
	
	var _backdrop = __webpack_require__(29);
	
	var _assign = __webpack_require__(148);
	
	var _invoicing = __webpack_require__(150);
	
	var _common = __webpack_require__(25);
	
	var _notes = __webpack_require__(114);
	
	var _insurancecompanies = __webpack_require__(172);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _NotesModal = __webpack_require__(203);
	
	var _NotesModal2 = _interopRequireDefault(_NotesModal);
	
	var _AssignBox = __webpack_require__(196);
	
	var _AssignBox2 = _interopRequireDefault(_AssignBox);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _ResendText = __webpack_require__(288);
	
	var _ResendText2 = _interopRequireDefault(_ResendText);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Invoice = __webpack_require__(294);
	
	var _Invoice2 = _interopRequireDefault(_Invoice);
	
	var _DeliveryDateChangeModal = __webpack_require__(302);
	
	var _DeliveryDateChangeModal2 = _interopRequireDefault(_DeliveryDateChangeModal);
	
	var _OtherPriceModal = __webpack_require__(303);
	
	var _OtherPriceModal2 = _interopRequireDefault(_OtherPriceModal);
	
	var _CreateEstimationModal = __webpack_require__(237);
	
	var _CreateEstimationModal2 = _interopRequireDefault(_CreateEstimationModal);
	
	var _time = __webpack_require__(17);
	
	var _currency = __webpack_require__(41);
	
	var _order = __webpack_require__(92);
	
	var _router = __webpack_require__(308);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _ExternalDeviation = __webpack_require__(888);
	
	var _ExternalDeviation2 = _interopRequireDefault(_ExternalDeviation);
	
	var _Assessment = __webpack_require__(881);
	
	var _Assessment2 = _interopRequireDefault(_Assessment);
	
	var _AssignWorker = __webpack_require__(882);
	
	var _AssignWorker2 = _interopRequireDefault(_AssignWorker);
	
	var _OrderStop = __webpack_require__(892);
	
	var _OrderStop2 = _interopRequireDefault(_OrderStop);
	
	var _OtherComments = __webpack_require__(893);
	
	var _OtherComments2 = _interopRequireDefault(_OtherComments);
	
	var _CustomInspection = __webpack_require__(886);
	
	var _CustomInspection2 = _interopRequireDefault(_CustomInspection);
	
	var _MissingParts = __webpack_require__(891);
	
	var _MissingParts2 = _interopRequireDefault(_MissingParts);
	
	var _Color = __webpack_require__(885);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Deadline = __webpack_require__(887);
	
	var _Deadline2 = _interopRequireDefault(_Deadline);
	
	var _ProcessComments = __webpack_require__(895);
	
	var _ProcessComments2 = _interopRequireDefault(_ProcessComments);
	
	var _Files = __webpack_require__(889);
	
	var _Files2 = _interopRequireDefault(_Files);
	
	var _Claim = __webpack_require__(884);
	
	var _Claim2 = _interopRequireDefault(_Claim);
	
	var _InspectionHeader = __webpack_require__(890);
	
	var _InspectionHeader2 = _interopRequireDefault(_InspectionHeader);
	
	var _BodyshopBooking = __webpack_require__(883);
	
	var _BodyshopBooking2 = _interopRequireDefault(_BodyshopBooking);
	
	var _OtherDamage = __webpack_require__(894);
	
	var _OtherDamage2 = _interopRequireDefault(_OtherDamage);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _backButton = __webpack_require__(235);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _icons = __webpack_require__(6);
	
	var _ForsiCreateReport = __webpack_require__(440);
	
	var _ForsiCreateReport2 = _interopRequireDefault(_ForsiCreateReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// Actions
	
	
	// Components
	
	
	// Modals
	
	
	// Utils
	
	
	// New Components
	
	
	// Elements
	
	
	var OrderInspection = function (_Component) {
	  _inherits(OrderInspection, _Component);
	
	  function OrderInspection(props) {
	    _classCallCheck(this, OrderInspection);
	
	    var _this = _possibleConstructorReturn(this, (OrderInspection.__proto__ || Object.getPrototypeOf(OrderInspection)).call(this, props));
	
	    _this.state = {
	      assessmentItems: null,
	      assessmentItemsBodyshop: null,
	      inspection: {},
	      note: {
	        modal: false,
	        data: {}
	      },
	      DeadlineTimes: null,
	      BodyshopDeadlineTimes: null,
	      Deadline: null,
	      BodyshopDeadline: null,
	      dimensions: {
	        width: 0,
	        height: 0
	      },
	      order: {},
	      steps: [],
	      StepAssignments: [],
	      stopMessage: '',
	      showAssign: false,
	      confirmFileDelete: {
	        confirm: false,
	        file: null
	      },
	      upload: {
	        loading: false,
	        errors: []
	      },
	      createEstimationPopup: {
	        show: false
	      },
	      deliveryChangePopup: {
	        show: false,
	        showOnSave: false,
	        oldDate: '',
	        oldProductionDate: '',
	        newDate: '',
	        reason: 1,
	        comment: '',
	        confirmed: false
	      },
	      ShowDeliveryChangePopup: false,
	      otherPopup: {
	        open: false,
	        other: {
	          Title: '',
	          Price: '',
	          Environment: '',
	          Description: ''
	        }
	      },
	      showPopup: false,
	      lastHistory: {
	        FoundHistory: false
	      },
	      isLoadingLastHistory: false,
	      confirmApproveAssesment: {
	        open: false
	      },
	      hasPaintWork: true,
	      hasBodyWork: true,
	      isLoading: false,
	      standardNotes: [],
	      InsuranceCompanies: []
	    };
	
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.showNoteModal = _this.showNoteModal.bind(_this);
	    _this.onNoteSuccess = _this.onNoteSuccess.bind(_this);
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.onAssignUsers = _this.onAssignUsers.bind(_this);
	    _this.getAssignOrderData = _this.getAssignOrderData.bind(_this);
	    _this.renderFileArea = _this.renderFileArea.bind(_this);
	    _this.updateImages = _this.updateImages.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.renderDeliveryDatePopup = _this.renderDeliveryDatePopup.bind(_this);
	    _this.showDeliveryDatePopup = _this.showDeliveryDatePopup.bind(_this);
	    _this.updateFromDeliveryTime = _this.updateFromDeliveryTime.bind(_this);
	    _this.fnListener = window.debounce(_this.updateDimensions, 250);
	    _this.PriceChange = _this.PriceChange.bind(_this);
	    _this.onConfirmApprove = _this.onConfirmApprove.bind(_this);
	    _this.toggleInspection = _this.toggleInspection.bind(_this);
	    _this.stopLockOrder = _this.stopLockOrder.bind(_this);
	    _this.onChangeTime = _this.onChangeTime.bind(_this);
	    _this.onDeadlineChange = _this.onDeadlineChange.bind(_this);
	    _this.renderAssesment = _this.renderAssesment.bind(_this);
	    _this.renderOtherDamage = _this.renderOtherDamage.bind(_this);
	    _this.renderExternalDeviation = _this.renderExternalDeviation.bind(_this);
	    _this.renderAssignWorker = _this.renderAssignWorker.bind(_this);
	    _this.renderOrderStop = _this.renderOrderStop.bind(_this);
	    _this.renderInvoice = _this.renderInvoice.bind(_this);
	    _this.onUpdateOrder = _this.onUpdateOrder.bind(_this);
	    _this.getAssessmentItems = _this.getAssessmentItems.bind(_this);
	    _this.onStandardNoteUpdate = _this.onStandardNoteUpdate.bind(_this);
	    _this.togglePopup = _this.togglePopup.bind(_this);
	    _this.onCreateEstimationSave = _this.onCreateEstimationSave.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderInspection, [{
	    key: 'stopLockOrder',
	    value: function stopLockOrder(data) {
	      var _this2 = this;
	
	      this.props.StopLockOrder(data).then(function (res) {
	        // window.toastr.success(translation('13403'), translation('13424'))
	        _this2.loadOrder();
	        // this.props.onClose()
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('13404'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'toggleInspection',
	    value: function toggleInspection(name) {
	      var _this3 = this;
	
	      // Get type
	      var type = this.state.inspection[name] === null || typeof this.state.inspection[name] === 'undefined' ? 0 : typeof this.state.inspection[name] === 'boolean' ? 1 : 2;
	
	      var canToggle = function canToggle() {
	        if (_this3.state.order.OrderType !== 1) return true;
	        if (_this3.state.order.LastUpdatedType !== 1) return true;
	        var inspection = _extends({}, _this3.state.inspection);
	        return name !== 'AfterEvaluation' && name !== 'BodyshopAfterEvaluation' || type === 1 && inspection[name] || type === 2 && inspection[name].Checked;
	      };
	      var save = function save() {
	        switch (type) {
	          case 1:
	            inspection[name] = !inspection[name];
	            break;
	          case 2:
	            inspection[name].Checked = !inspection[name].Checked;
	            inspection[name].AssessmentSelection = inspection[name].Checked ? 2 : 0;
	            break;
	        }
	        _this3.saveOrderInspection(inspection).then(function () {
	          if (name === 'AfterEvaluation' || name === 'BodyshopAfterEvaluation') {
	            if (inspection[name].Checked) {
	              _this3.props.approveOrderInvoice(_this3.state.order.Id, false).then(function (res) {
	                console.log('order approved for invoice');
	              }).catch(function () {});
	            } else {
	              _this3.props.approveOrderInvoice(_this3.state.order.Id, true).then(function (res) {
	                console.log('order disapproved for invoice');
	              }).catch(function () {});
	            }
	          }
	        });
	      };
	      var inspection = _extends({}, this.state.inspection);
	      if (canToggle()) {
	        if (name !== 'AfterEvaluation' && name !== 'BodyshopAfterEvaluation' || this.state.inspection[name].Checked === true) {
	          // if ((this.state.order.OrderType !== 1) || (this.state.order.OrderType === 1 && this.state.inspection.AfterEvaluation.Checked === true)) {
	          save();
	        } else {
	          this.setState({
	            isLoadingLastHistory: true
	          }, function () {
	            _this3.props.invoiceHistory(_this3.state.order.Id).then(function (res) {
	              _this3.setState({
	                lastHistory: res.data,
	                isLoadingLastHistory: false
	              }, function () {
	                if (_this3.state.lastHistory.FoundHistory && _this3.state.inspection[name].Checked === false) {
	                  _this3.setState({
	                    confirmApproveAssesment: {
	                      open: !_this3.state.confirmApproveAssesment.open
	                    }
	                  });
	                } else if (!_this3.state.lastHistory.FoundHistory) {
	                  save();
	                }
	              });
	            });
	          });
	        }
	      } else {
	        this.setState({
	          showPopup: true
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      this._mounted = true;
	      // setTimeout(() => {
	      //   console.log('orderInspection didMount', hasSubscriptionPermission(this.props.auth, 20), isLAKexperten(this.props.auth), this.props.auth)
	      //   if (hasSubscriptionPermission(this.props.auth, 20) && isLAKexperten(this.props.auth)) {
	      //     this.props.GetAssessmentItemsInOrderInspection(this.props.params.orderID, 0).then((res) => {
	      //       this.setState({
	      //         assessmentItems: res.data
	      //       }, () => console.log('assessmentItems after set state ', this.state.assessmentItems))
	      //     }, () => {
	      //     })
	      //     this.props.GetAssessmentItemsInOrderInspection(this.props.params.orderID, 1).then((res) => {
	      //       this.setState({
	      //         assessmentItemsBodyshop: res.data
	      //       })
	      //     }, () => {
	      //     })
	      //   }
	      // }, 500)
	      this.getAssessmentItems();
	
	      this.getOrderInspection();
	      window.addEventListener('resize', this.fnListener);
	      this.updateDimensions();
	      this.loadOrder();
	      this.getAssignOrderData();
	      this.checkFileTimer = setInterval(this.updateImages, 3000);
	      this.setState({
	        confirmApproveAssesment: {
	          open: false
	        },
	        hasPaintWork: this.props.auth.departmentType !== 2 || this.props.auth.user.Department !== 1,
	        hasBodyWork: this.props.auth.departmentType !== 2 || this.props.auth.user.Department !== 0
	      });
	
	      this.props.getStandardNotes().then(function (res) {
	        _this4.onStandardNoteUpdate(res.data);
	      });
	
	      this.props.getInsuranceCompanies().then(function (res) {
	        _this4.setState({ InsuranceCompanies: res.data.Item2 });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._mounted = false;
	      window.removeEventListener('resize', this.fnListener);
	      clearInterval(this.checkFileTimer);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(this.props.auth, nextProps.auth) && this.state.assessmentItems === null && this.state.assessmentItemsBodyshop === null && !this.state.isLoading) {
	        this.getAssessmentItems();
	      }
	    }
	  }, {
	    key: 'onStandardNoteUpdate',
	    value: function onStandardNoteUpdate(notes) {
	      this.setState({
	        standardNotes: notes
	      });
	    }
	  }, {
	    key: 'getAssessmentItems',
	    value: function getAssessmentItems() {
	      var _this5 = this;
	
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && (0, _auth.hasAccessToAssign)(this.props.auth)) {
	        this.setState({
	          isLoading: true
	        }, function () {
	          var getAssesments = function getAssesments() {
	            return _this5.props.GetAssessmentItemsInOrderInspection(_this5.props.params.orderID, 0).then(function (res) {
	              _this5.setState({
	                assessmentItems: res.data
	              });
	            }, function () {});
	          };
	          var getBodyAssesments = function getBodyAssesments() {
	            return _this5.props.GetAssessmentItemsInOrderInspection(_this5.props.params.orderID, 1).then(function (res) {
	              _this5.setState({
	                assessmentItemsBodyshop: res.data
	              });
	            }, function () {});
	          };
	          Promise.all([getAssesments(), getBodyAssesments()]).then(function () {
	            _this5.setState({
	              isLoading: false
	            });
	          });
	        });
	      }
	    }
	  }, {
	    key: 'loadOrder',
	    value: function loadOrder() {
	      var _this6 = this;
	
	      var orderId = this.props.params.orderID;
	      this.props.getOrder(orderId).then(function (res) {
	        if (/\/orders\/\d{6,}\/orderinspection/.test(_this6.props.router.location.pathname)) {
	          // Only change if still on '/orders/xxxxxx/orderinspection'
	          _this6.props.setPageTitle((0, _order.makeOrderPageTitleObject)(res.data));
	        }
	
	        _this6.setState({
	          order: res.data,
	          otherPopup: {
	            open: false,
	            other: {
	              Title: res.data.OtherTitle,
	              Price: res.data.Price,
	              Environment: res.data.Environment,
	              Description: res.data.Description
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'saveOrder',
	    value: function saveOrder() {
	      if (this.state.order === undefined || this.state.order === null || this.state.order.Id === 0) return null;
	
	      var data = this.state.order;
	      return this.props.saveOrder(data).then(function (res) {
	        // window.toastr.success(translation('13403'), translation('13424'))
	        return res;
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('13404'), (0, _helpers.translation)('216'));
	        return null;
	      });
	    }
	  }, {
	    key: 'updateImages',
	    value: function updateImages() {
	      var _this7 = this;
	
	      if (Object.keys(this.state.order).length === 0) return null;
	      if (window.location.hostname === 'localhost') return null;
	      var files = [].concat(_toConsumableArray(this.state.order.OrderFiles));
	      var order = _extends({}, this.state.order);
	
	      var _loop = function _loop(i) {
	        if (files[i].IsImage) {
	          var img = files[i];
	          if (img.IsFinishedLoading === false) {
	            // Check with api if file is ready.
	            _this7.props.isFileReady(img.OrderFileID).then(function (res) {
	              if (res.data.FileReady === true) {
	                var append = '?preventCache=' + Math.random() * 10;
	                img.IsFinishedLoading = true;
	                img.ThumbURL = res.data.ThumbURL + append;
	                img.FileURL = res.data.FileURL + append;
	                // files[i] = img
	                order.OrderFiles[i] = img;
	                _this7.setState({
	                  order: _extends({}, _this7.state.order, {
	                    OrderFiles: order.OrderFiles
	                  })
	                });
	              }
	            });
	          }
	        }
	      };
	
	      for (var i = 0; i < files.length; i++) {
	        _loop(i);
	      }
	    }
	  }, {
	    key: 'getAssignOrderData',
	    value: function getAssignOrderData(activeEmployees) {
	      var _this8 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || !(0, _auth.hasAccessToAssign)(this.props.auth)) return;
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        // wp don't need assign data
	        return;
	      }
	
	      // Find order ids
	      var orderId = this.props.params.orderID;
	      var orderIds = [];
	      orderIds.push(orderId);
	      // Get assign order data
	      this.props.getOrderData({
	        OrderIds: orderIds,
	        UserIds: activeEmployees || this.props.activeEmployees
	      }).then(function (res) {
	        _this8.setState({
	          StepAssignments: res.data.StepAssignments
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1922'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onAssignUsers',
	    value: function onAssignUsers() {
	      this.refs.AssignBox.getWrappedInstance().getAssignEmployees();
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this9 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this9.state.dimensions.width;
	          if (width > higherThan && width < lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'getOrderInspection',
	    value: function getOrderInspection() {
	      var _this10 = this;
	
	      this.props.getOrderInspection(this.props.params.orderID).then(function (res) {
	        if (typeof res.data.Claim !== 'undefined' && res.data.Claim !== null) {
	          res.data.Claim.ComplaintPrice = (0, _currency.formatCurrency)(res.data.Claim.ComplaintPrice);
	        }
	        var deadline = null;
	        var bodyDeadline = null;
	        var deadlineTimes = null;
	        var bodyDeadlineTimes = null;
	
	        var showDeliveryChangePopup = false;
	        if (res.data.Deadline !== null) {
	          deadline = {
	            Pickup: res.data.Deadline.Pickup,
	            Delivery: res.data.Deadline.Delivery,
	            ProductionDate: res.data.Deadline.ProductionDate,
	            Checked: res.data.Deadline.Checked
	          };
	          deadlineTimes = {
	            PickupTimes: res.data.Deadline.PickupTimes,
	            DeliveryTimes: res.data.Deadline.DeliveryTimes,
	            ProductionTimes: res.data.Deadline.ProductionTimes
	          };
	          showDeliveryChangePopup = res.data.Deadline.ShowDeliveryChangePopup;
	        }
	        if (res.data.BodyshopDeadline !== null) {
	          bodyDeadline = {
	            Pickup: res.data.BodyshopDeadline.Pickup,
	            Delivery: res.data.BodyshopDeadline.Delivery,
	            ProductionDate: res.data.BodyshopDeadline.ProductionDate,
	            Checked: res.data.BodyshopDeadline.Checked
	          };
	          bodyDeadlineTimes = {
	            PickupTimes: res.data.BodyshopDeadline.PickupTimes,
	            DeliveryTimes: res.data.BodyshopDeadline.DeliveryTimes,
	            ProductionTimes: res.data.BodyshopDeadline.ProductionTimes
	          };
	          showDeliveryChangePopup = res.data.Deadline.ShowDeliveryChangePopup;
	        }
	        _this10.setState({
	          inspection: res.data,
	          Deadline: deadline,
	          DeadlineTimes: deadlineTimes,
	          BodyshopDeadline: bodyDeadline,
	          BodyshopDeadlineTimes: bodyDeadlineTimes,
	          ShowDeliveryChangePopup: showDeliveryChangePopup
	        }, function () {
	          if (res.data.MissingParts !== null && res.data.MissingParts.Note && _this10.state.inspection.MissingParts.Note === null) {
	            var _inspection = res.data;
	            _inspection.MissingParts.MissingParts = true;
	            _this10.saveOrderInspection(_inspection);
	          }
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('15004'), (0, _helpers.translation)('960'));
	        console.log('Error getting order inspection');
	      });
	    }
	  }, {
	    key: 'saveOrderInspection',
	    value: function saveOrderInspection(inspection, skipCheck) {
	      var _this11 = this;
	
	      var inspec = _extends({}, inspection);
	      if (typeof skipCheck === 'undefined') {
	        if (typeof inspec.Claim !== 'undefined' && inspec.Claim !== null) {
	          inspec.Claim.ComplaintPrice = parseFloat((0, _currency.reverseFormatCurrency)(inspec.Claim.ComplaintPrice));
	        }
	      }
	      if (this.state.ShowDeliveryChangePopup && this.state.deliveryChangePopup.showOnSave === true && this.state.deliveryChangePopup.confirmed !== true && !this.state.deliveryChangePopup.show) {
	        this.showDeliveryDatePopup();
	        return false;
	      }
	
	      return this.props.saveOrderInspection(inspection).then(function (res) {
	        // Toastr
	        if (typeof res.data.Claim !== 'undefined' && res.data.Claim !== null) {
	          res.data.Claim.ComplaintPrice = (0, _currency.formatCurrency)(res.data.Claim.ComplaintPrice);
	        }
	        var deadline = null;
	        var bodyDeadline = null;
	        var deadlineTimes = null;
	        var bodyDeadlineTimes = null;
	        if (res.data.Deadline !== null) {
	          deadline = {
	            Pickup: res.data.Deadline.Pickup,
	            Delivery: res.data.Deadline.Delivery,
	            ProductionDate: res.data.Deadline.ProductionDate,
	            Checked: res.data.Deadline.Checked
	          };
	          deadlineTimes = {
	            PickupTimes: res.data.Deadline.PickupTimes,
	            DeliveryTimes: res.data.Deadline.DeliveryTimes,
	            ProductionTimes: res.data.Deadline.ProductionTimes
	          };
	        }
	        if (res.data.BodyshopDeadline !== null) {
	          bodyDeadline = {
	            Pickup: res.data.BodyshopDeadline.Pickup,
	            Delivery: res.data.BodyshopDeadline.Delivery,
	            ProductionDate: res.data.BodyshopDeadline.ProductionDate,
	            Checked: res.data.BodyshopDeadline.Checked
	          };
	          bodyDeadlineTimes = {
	            PickupTimes: res.data.BodyshopDeadline.PickupTimes,
	            DeliveryTimes: res.data.BodyshopDeadline.DeliveryTimes,
	            ProductionTimes: res.data.BodyshopDeadline.ProductionTimes
	          };
	        }
	        _this11.setState({
	          inspection: res.data,
	          Deadline: deadline,
	          DeadlineTimes: deadlineTimes,
	          BodyshopDeadline: bodyDeadline,
	          BodyshopDeadlineTimes: bodyDeadlineTimes
	        });
	        // Update Invoice component
	        _this11.props.getInvoiceStatus(_this11.state.order.Id).then(function (result) {
	          var order = _extends({}, _this11.state.order);
	          order.ReadyForInvoice = result.data.ReadyForInvoice;
	          order.ReadyForInvoiceByWP = result.data.ReadyForInvoiceByWP;
	          order.IsMarkInvoiced = result.data.IsMarkInvoiced;
	          order.IsMarkInvoicedByWP = result.data.IsMarkInvoicedByWP;
	          order.IsInvoiced = result.data.IsInvoiced;
	          order.IsInvoicedByWP = result.data.IsInvoicedByWP;
	          order.InvoiceStatusIsResat = result.data.InvoiceStatusIsResat;
	
	          _this11.setState({
	            order: order,
	            inspection: res.data,
	            Deadline: deadline,
	            DeadlineTimes: deadlineTimes
	          }, function () {
	            // window.toastr.success(translation('1911'), translation('13424'))
	          });
	          return res;
	        });
	      }, function (err) {
	        if (err.response) {
	          if (err.response.data !== undefined && err.response.data.Errors !== undefined && err.response.data.Errors.length === 1) {
	            var error = err.response.data.Errors[0];
	            var text = (0, _helpers.translation)(error.DictionaryKey);
	            if (error.Parameters.length === 1) {
	              text = text.replace('[WorkProvider]', error.Parameters[0]);
	            }
	            window.toastr.error(text, (0, _helpers.translation)('216'));
	          } else if (err.response.status === 403) {
	            window.toastr.error((0, _helpers.translation)('1794'), (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	          }
	        }
	        _this11.getOrderInspection();
	        return err;
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(obj, e) {
	      var _this12 = this;
	
	      e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') value = e.target.checked;
	      this.setState({
	        inspection: _extends({}, this.state.inspection, _defineProperty({}, obj, _extends({}, this.state.inspection[obj], _defineProperty({}, e.target.name, value))))
	      }, function () {
	        if (['Color', 'BodyshopColor'].includes(obj)) {
	          // Set same color for both
	          var propName = 'Color';
	          if (obj === 'Color') propName = 'BodyshopColor';
	          _this12.setState({
	            inspection: _extends({}, _this12.state.inspection, _defineProperty({}, propName, _extends({}, _this12.state.inspection[propName], _defineProperty({}, e.target.name, value))))
	          });
	        }
	        if (e.target.type === 'checkbox') {
	          _this12.onBlur();
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      var _this13 = this;
	
	      setTimeout(function () {
	        _this13.saveOrderInspection(_this13.state.inspection);
	      }, 0);
	    }
	  }, {
	    key: 'renderConfirmApproveDialog',
	    value: function renderConfirmApproveDialog() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ResendText2.default, { isLoadingLastHistory: this.state.isLoadingLastHistory, lastHistory: this.state.lastHistory, t: _helpers.translation, store: _store2.default, assessment: true })
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	    }
	  }, {
	    key: 'onConfirmApprove',
	    value: function onConfirmApprove() {
	      var _this14 = this;
	
	      var inspection = _extends({}, this.state.inspection);
	      var name = this.props.auth.departmentType === 1 ? 'BodyshopAfterEvaluation' : 'AfterEvaluation';
	      inspection[name].Checked = true;
	      this.saveOrderInspection(inspection).then(function () {
	        _this14.onPortalClose('confirmApproveAssesment');
	      }, function () {});
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(name, context) {
	      var _this15 = this;
	
	      // Get type
	      var type = this.state.inspection[name] === null || typeof this.state.inspection[name] === 'undefined' ? 0 : typeof this.state.inspection[name] === 'boolean' ? 1 : 2;
	      // Image
	      var image = 'Red_marking';
	      switch (type) {
	        case 1:
	          if (this.state.inspection[name]) image = 'Green_chekmark';
	          break;
	        case 2:
	          if (this.state.inspection[name].Checked) image = 'Green_chekmark';
	          break;
	      }
	      var canToggle = function canToggle() {
	        if (_this15.state.order.OrderType !== 1) return true;
	        if (_this15.state.order.LastUpdatedType !== 1) return true;
	        var inspection = _extends({}, _this15.state.inspection);
	        return name !== 'AfterEvaluation' || type === 1 && inspection[name] || type === 2 && inspection[name].Checked;
	      };
	      // On Click
	      var onChangeMarking = function onChangeMarking() {
	        var save = function save() {
	          switch (type) {
	            case 1:
	              inspection[name] = !inspection[name];
	              break;
	            case 2:
	              inspection[name].Checked = !inspection[name].Checked;
	              break;
	          }
	          _this15.saveOrderInspection(inspection).then(function () {});
	        };
	        var inspection = _extends({}, _this15.state.inspection);
	        if (canToggle()) {
	          if (name !== 'AfterEvaluation' || _this15.state.inspection.AfterEvaluation.Checked === true) {
	            // if ((this.state.order.OrderType !== 1) || (this.state.order.OrderType === 1 && this.state.inspection.AfterEvaluation.Checked === true)) {
	            save();
	          } else {
	            _this15.setState({
	              isLoadingLastHistory: true
	            }, function () {
	              _this15.props.invoiceHistory(_this15.state.order.Id).then(function (res) {
	                _this15.setState({
	                  lastHistory: res.data,
	                  isLoadingLastHistory: false
	                }, function () {
	                  if (_this15.state.lastHistory.FoundHistory && _this15.state.inspection.AfterEvaluation.Checked === false) {
	                    _this15.setState({
	                      confirmApproveAssesment: {
	                        open: !_this15.state.confirmApproveAssesment.open
	                      }
	                    });
	                  } else if (!_this15.state.lastHistory.FoundHistory) {
	                    save();
	                  }
	                });
	              });
	            });
	          }
	        } else {
	          _this15.setState({
	            showPopup: true
	          });
	        }
	      };
	      // Return
	      if (context !== '901') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'title', onClick: onChangeMarking },
	          (0, _helpers.translation)(context),
	          _react2.default.createElement('img', { className: 'right', src: '/images/icons/' + image + '.png' })
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'title', onClick: onChangeMarking },
	          _react2.default.createElement('img', { className: 'left large', src: '/images/svgs/taksering/damage assessment.svg' }),
	          (0, _helpers.translation)(context),
	          _react2.default.createElement('img', { className: 'right', src: '/images/icons/' + image + '.png' })
	        );
	      }
	    }
	  }, {
	    key: 'renderMissingParts',
	    value: function renderMissingParts(isBodyshop) {
	      var _this16 = this;
	
	      if (this.state.inspection.MissingParts === null) return null;
	      var changeMissingPartStatus = function changeMissingPartStatus(e) {
	        _this16.setState({
	          inspection: _extends({}, _this16.state.inspection, {
	            MissingParts: _extends({}, _this16.state.inspection.MissingParts, {
	              MissingParts: e
	            })
	          })
	        }, _this16.onBlur);
	      };
	
	      return _react2.default.createElement(_MissingParts2.default, { standardNotes: this.state.standardNotes, onStandardNoteUpdate: this.onStandardNoteUpdate, onHeaderClick: this.toggleInspection, MissingParts: this.state.inspection.MissingParts, changeMissingPartStatus: changeMissingPartStatus.bind(this), order: this.state.order, onNoteSuccess: this.onNoteSuccess, isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'renderColor',
	    value: function renderColor(isBodyshop) {
	      if (isBodyshop && !this.state.order.HasAvailablePaintPartner) return null;
	      var propName = 'Color';
	      if (isBodyshop) propName = 'BodyshopColor';
	      var prop = this.state.inspection[propName];
	      if (prop === null) return null;
	      return _react2.default.createElement(_Color2.default, { order: this.state.order, onBlur: this.onBlur.bind(this), onChange: this.onChange.bind(this), color: prop, onHeaderClick: this.toggleInspection, isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'onDeadlineChange',
	    value: function onDeadlineChange(dateTime, name, isBodyshop) {
	      var _this17 = this;
	
	      var newDate = '';
	      var newTime = '';
	      var momentDate = (0, _moment2.default)(dateTime);
	      var propName = 'Deadline';
	      if (isBodyshop) propName = 'BodyshopDeadline';
	      // momentDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
	      var inspection = _extends({}, this.state.inspection);
	      var oldDelivery = inspection[propName].Delivery;
	      var oldProduction = inspection[propName].ProductionDate;
	      switch (name) {
	        case 'Pickup':
	          newDate = momentDate.format('YYYY-MM-DD');
	          newTime = momentDate.format('HH:mm');
	          this.props.getPickupTimes(newDate, newTime, this.state.inspection.CustomerId).then(function (res) {
	            var _this17$setState;
	
	            var AvailableTimes = res.data.AvailableTimes;
	            _this17.setState((_this17$setState = {}, _defineProperty(_this17$setState, propName, _extends({}, _this17.state[propName], _defineProperty({}, name, (0, _time.formatDate)(momentDate)))), _defineProperty(_this17$setState, 'DeadlineTimes', _extends({}, _this17.state.DeadlineTimes, {
	              PickupTimes: AvailableTimes
	            })), _this17$setState));
	          }, function (err) {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	          });
	          break;
	        case 'Delivery':
	          newDate = momentDate.format('YYYY-MM-DD') + ' ' + momentDate.format('HH:mm:ss');
	          this.props.getDeliveryTimes(newDate, undefined, this.props.order.Id).then(function (res) {
	            var _this17$setState2;
	
	            var AvailableTimes = res.data.AvailableDeliveryTimes;
	            var deliveryChanged = (0, _moment2.default)(inspection[propName].Delivery) !== (0, _moment2.default)(newDate);
	            _this17.setState((_this17$setState2 = {}, _defineProperty(_this17$setState2, propName, _extends({}, _this17.state[propName], _defineProperty({}, name, (0, _time.formatDate)(momentDate)))), _defineProperty(_this17$setState2, 'DeadlineTimes', _extends({}, _this17.state.DeadlineTimes, {
	              DeliveryTimes: AvailableTimes
	            })), _defineProperty(_this17$setState2, 'deliveryChangePopup', _extends({}, _this17.state.deliveryChangePopup, {
	              confirmed: false,
	              showOnSave: deliveryChanged,
	              newDate: newDate,
	              oldDate: oldDelivery,
	              show: !isBodyshop // Always show for paint
	            })), _this17$setState2));
	          }, function (err) {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	          });
	          break;
	        case 'ProductionDate':
	          newDate = momentDate.format('YYYY-MM-DD') + ' ' + momentDate.format('HH:mm:ss');
	          this.props.getDeliveryTimes(newDate, undefined, this.props.order.Id).then(function (res) {
	            var _this17$setState3;
	
	            var AvailableTimes = res.data.AvailableDeliveryTimes;
	            var firstProductionTime = AvailableTimes[0];
	            newDate = momentDate.format('YYYY-MM-DD') + ' ' + firstProductionTime + ':00';
	            momentDate = (0, _moment2.default)(newDate);
	            var deliveryChanged = (0, _moment2.default)(inspection[propName].Delivery) <= (0, _moment2.default)(newDate);
	            _this17.setState((_this17$setState3 = {}, _defineProperty(_this17$setState3, propName, _extends({}, _this17.state[propName], {
	              ProductionDate: newDate,
	              ProductionTimes: AvailableTimes
	            })), _defineProperty(_this17$setState3, 'DeadlineTimes', _extends({}, _this17.state.DeadlineTimes, {
	              ProductionTimes: AvailableTimes
	            })), _defineProperty(_this17$setState3, 'deliveryChangePopup', _extends({}, _this17.state.deliveryChangePopup, {
	              confirmed: false,
	              showOnSave: deliveryChanged,
	              newDate: newDate,
	              oldDate: oldDelivery,
	              oldProductionDate: oldProduction
	            })), _this17$setState3), function () {
	              inspection[propName].ProductionDate = newDate;
	            });
	          }, function (err) {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	          });
	          break;
	      }
	      setTimeout(function () {
	        if (_this17.state.deliveryChangePopup.show) return;
	
	        inspection[propName].PickupTimes = _this17.state.DeadlineTimes.PickupTimes;
	        inspection[propName].DeliveryTimes = _this17.state.DeadlineTimes.DeliveryTimes;
	        inspection[propName].ProductionTimes = _this17.state.DeadlineTimes.ProductionTimes;
	        if (name === 'ProductionDate') {
	          inspection[propName].DateChangeReason = 1;
	        } else if (name === 'Delivery') {
	          inspection[propName].DateChangeReason = 2;
	          inspection[propName][name] = (0, _time.formatDate)(momentDate);
	        } else {
	          inspection[propName].DateChangeReason = null;
	          inspection[propName][name] = (0, _time.formatDate)(momentDate);
	        }
	        _this17.setState({
	          DateChangeReason: inspection[propName].DateChangeReason,
	          inspection: inspection
	        });
	        _this17.saveOrderInspection(inspection);
	      }, 100);
	    }
	  }, {
	    key: 'onChangeTime',
	    value: function onChangeTime(value, name, isBodyshop) {
	      var _this18 = this;
	
	      var splitted = value.split(':');
	      var propName = 'Deadline';
	      if (isBodyshop) propName = 'BodyshopDeadline';
	      var dateVal = window.CustomDate(this.state[propName][name]);
	      var momentDate = (0, _moment2.default)(dateVal);
	      momentDate.set({ hour: splitted[0], minute: splitted[1], second: 0, millisecond: 0 });
	      // Save date
	      var inspection = _extends({}, this.state.inspection);
	      inspection[propName][name] = (0, _time.formatDate)(momentDate);
	      inspection[propName].PickupTimes = this.state.DeadlineTimes.PickupTimes;
	      inspection[propName].DeliveryTimes = this.state.DeadlineTimes.DeliveryTimes;
	      inspection[propName].ProductionTimes = this.state.DeadlineTimes.ProductionTimes;
	      var deliveryChanged = false;
	      var oldDate = this.state[propName].Delivery;
	      var oldProduction = this.state[propName].ProductionDate;
	      var newDate = oldDate;
	      if (name === 'ProductionDate') {
	        inspection[propName].DateChangeReason = 1;
	        deliveryChanged = (0, _moment2.default)(oldDate) <= momentDate;
	      } else if (name === 'Delivery') {
	        inspection[propName].DateChangeReason = 2;
	        deliveryChanged = (0, _moment2.default)(oldDate) !== momentDate;
	      } else {
	        inspection[propName].DateChangeReason = null;
	      }
	      newDate = momentDate.format('YYYY-MM-DD') + ' ' + momentDate.format('HH:mm:ss');
	      this.setState({
	        deliveryChangePopup: _extends({}, this.state.deliveryChangePopup, {
	          confirmed: false,
	          showOnSave: deliveryChanged,
	          newDate: newDate,
	          oldDate: oldDate,
	          oldProductionDate: oldProduction
	        })
	      }, function () {
	        _this18.saveOrderInspection(inspection);
	      });
	    }
	  }, {
	    key: 'renderDeadline',
	    value: function renderDeadline(isBodyshop) {
	      return _react2.default.createElement(_Deadline2.default, { deadline: isBodyshop ? this.state.BodyshopDeadline : this.state.Deadline, deadlineTimes: isBodyshop ? this.state.BodyshopDeadlineTimes : this.state.DeadlineTimes, order: this.state.order, onHeaderClick: this.toggleInspection, onChangeTime: this.onChangeTime, onDeadlineChange: this.onDeadlineChange, isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'renderBodyshopBooking',
	    value: function renderBodyshopBooking() {
	      var _this19 = this;
	
	      var checked = false;
	      if (this.state.inspection.BodyshopBooking) {
	        checked = this.state.inspection.BodyshopBooking.Checked;
	      }
	      var onUpdateOrder = function onUpdateOrder() {
	        _this19.loadOrder();
	      };
	      var onChange = function onChange(e) {
	        var name = e.target.name;
	        var value = e.target.value;
	        var inspection = _extends({}, _this19.state.inspection);
	        if (name === 'Transport') {
	          inspection.BodyshopBooking[name] = value;
	        }
	        if (name === 'LoosePartsType') {
	          inspection.BodyshopBooking[name] = value === '1';
	        }
	        _this19.saveOrderInspection(inspection);
	      };
	      return _react2.default.createElement(_BodyshopBooking2.default, { togglePopup: this.togglePopup.bind(this), getInspection: this.getOrderInspection.bind(this), checked: checked, bodyshopBooking: this.state.inspection.BodyshopBooking, onInputChange: onChange, deadline: this.state.Deadline, deadlineTimes: this.state.DeadlineTimes, order: this.state.order, onHeaderClick: this.toggleInspection, onChangeTime: this.onChangeTime, onDeadlineChange: this.onDeadlineChange, onUpdateOrder: onUpdateOrder.bind(this) });
	    }
	  }, {
	    key: 'renderCustomInspections',
	    value: function renderCustomInspections(isBodyshop) {
	      var _this20 = this;
	
	      if (!this.state.inspection.CustomInspections || this.state.inspection.CustomInspections.length === 0) return null;
	      var changeStatus1 = function changeStatus1(key) {
	        var inspection = _extends({}, _this20.state.inspection);
	        inspection.CustomInspections[key].Checked = !inspection.CustomInspections[key].Checked;
	        _this20.saveOrderInspection(inspection);
	      };
	      var renderCustomInspection = function renderCustomInspection(item, key) {
	        return _react2.default.createElement(_CustomInspection2.default, { key: key, standardNotes: _this20.state.standardNotes, onStandardNoteUpdate: _this20.onStandardNoteUpdate, onNoteSuccess: _this20.onNoteSuccess, item: item, keyIndex: key, order: _this20.state.order, changeStatus: changeStatus1, isBodyshop: isBodyshop });
	      };
	      // return (
	      //   <div key={k} className='note bottom'>
	      //     <strong>{note.UsersInitials}: {renderFullDate(note.NoteDate)}</strong>
	      //     {note.Note}
	      //   </div>
	      // )
	      // }
	      // return (
	      //   <div className='white__box' key={key}>
	      //     <div className='title' onClick={changeStatus}><img className='right' src={'/images/icons/' + image + '.png'} />{item.Text}</div>
	      //     <div className='notes'>
	      //       {item.InspectionNotes.map(renderNote)}
	      //     </div>
	      //     <div className='form'>
	      //       <button className='button full primary' onClick={openComment}><img src='/images/icons/circle_plus22.png' />{translation('149')}</button>
	      //     </div>
	      //   </div>
	      // )
	      // }
	      return this.state.inspection.CustomInspections.map(renderCustomInspection);
	    }
	  }, {
	    key: 'renderCreateEstimationPopup',
	    value: function renderCreateEstimationPopup() {
	      if (!this.state.createEstimationPopup.show) return null;
	      var topMessage = [(0, _helpers.translation)('13568')];
	      var returnOrder = true;
	      return _react2.default.createElement(_CreateEstimationModal2.default, {
	        show: this.state.createEstimationPopup.show,
	        topMessage: topMessage,
	        id: this.state.order.Id,
	        returnOrder: returnOrder,
	        onClose: this.togglePopup.bind(this, 'createEstimationPopup', false),
	        onSave: this.onCreateEstimationSave
	      });
	    }
	  }, {
	    key: 'onCreateEstimationSave',
	    value: function onCreateEstimationSave(order) {
	      var _this21 = this;
	
	      if (typeof order !== 'undefined') {
	        this.togglePopup('createEstimationPopup', false);
	        this.onUpdateOrder(order);
	      } else {
	        this.saveSingleValue('IsEvaluation', true, function () {
	          _this21.togglePopup('createEstimationPopup', false);
	          _this21.onUpdateOrder(_this21.state.order);
	        });
	      }
	    }
	  }, {
	    key: 'togglePopup',
	    value: function togglePopup(prop, visible) {
	      var _this22 = this;
	
	      if (typeof visible !== 'boolean') {
	        visible = !this.state[prop].show;
	      }
	      if (!visible && prop === 'handleCarRentalPopup') {
	        // After editing advanced car rentals in popup, reload order.
	        this.onUpdateOrder();
	      }
	      this.setState(_defineProperty({}, prop, _extends({}, this.state[prop], {
	        show: visible
	      })), function () {
	        _this22.props.triggerPopup(visible);
	      });
	    }
	  }, {
	    key: 'onNoteSuccess',
	    value: function onNoteSuccess() {
	      this.getOrderInspection();
	    }
	  }, {
	    key: 'showNoteModal',
	    value: function showNoteModal() {
	      this.props.triggerPopup(!this.state.note.modal);
	      this.setState({
	        note: _extends({}, this.state.note, {
	          data: {},
	          modal: !this.state.note.modal
	        })
	      });
	    }
	  }, {
	    key: 'renderOtherComment',
	    value: function renderOtherComment(isBodyshop) {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      return _react2.default.createElement(_OtherComments2.default, { standardNotes: this.state.standardNotes, onStandardNoteUpdate: this.onStandardNoteUpdate, onNoteSuccess: this.onNoteSuccess, OrderNotes: this.state.inspection.OrderNotes, order: this.state.order, isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'renderProcessComment',
	    value: function renderProcessComment(isBodyshop) {
	      var _this23 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      var propName = 'ProcessComment';
	      if (isBodyshop) propName = 'BodyshopProcessComment';
	      var saveProcessComment = function saveProcessComment(processComment) {
	        var inspection = _extends({}, _this23.state.inspection);
	        inspection[propName] = processComment;
	        _this23.saveOrderInspection(inspection);
	      };
	      var onBlur = function onBlur() {
	        setTimeout(function () {
	          _this23.saveOrderInspection(_this23.state.inspection);
	        }, 0);
	      };
	      var onChange = function onChange(e, key) {
	        e.persist();
	        var inspection = _extends({}, _this23.state.inspection);
	        if (e.target.type === 'checkbox') {
	          var name = e.target.name.split('_')[0];
	          inspection[propName].ProcessComments[key][name] = e.target.checked;
	        } else {
	          inspection[propName].ProcessComments[key].Text = e.target.value;
	        }
	        _this23.setState({
	          inspection: inspection
	        }, function () {
	          if (e.target.type === 'checkbox') {
	            onBlur();
	          }
	        });
	      };
	      var deleteItem = function deleteItem(e, key) {
	        e.preventDefault();
	        var inspection = _extends({}, _this23.state.inspection);
	        inspection[propName].ProcessComments[key].DeletedBy = _this23.props.auth.user.UserId || 0;
	        _this23.setState({
	          inspection: inspection
	        }, onBlur);
	      };
	      return _react2.default.createElement(_ProcessComments2.default, { saveProcessComment: saveProcessComment, onBlur: onBlur, onChange: onChange, deleteItem: deleteItem, order: this.state.order, processComment: this.state.inspection[propName], onHeaderClick: this.toggleInspection, isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'renderAssesment',
	    value: function renderAssesment(isBodyshop) {
	      var _this24 = this;
	
	      var propName = 'AfterEvaluation';
	      if (isBodyshop) propName = 'BodyshopAfterEvaluation';
	      var onChange = function onChange(e) {
	        var inspection = _extends({}, _this24.state.inspection);
	        inspection[propName].AssessmentSelection = Number(e.target.value);
	        inspection[propName].Checked = Number(e.target.value) === 2;
	        _this24.setState({
	          inspection: inspection
	        }, function () {
	          _this24.saveOrderInspection(_this24.state.inspection).then(function () {
	            if (propName === 'AfterEvaluation' || propName === 'BodyshopAfterEvaluation') {
	              if (inspection[propName].Checked) {
	                _this24.props.approveOrderInvoice(_this24.state.order.Id, false).then(function (res) {
	                  console.log('order approved for invoice');
	                }).catch(function () {});
	              } else {
	                _this24.props.approveOrderInvoice(_this24.state.order.Id, true).then(function (res) {
	                  console.log('order disapproved for invoice');
	                }).catch(function () {});
	              }
	            }
	          });
	          // this.toggleInspection(propName)
	        });
	      };
	      if (this.state.inspection[propName] === null) return null;
	      return _react2.default.createElement(_Assessment2.default, { router: this.props.router, AfterEvaluation: this.state.inspection[propName], onChange: onChange, order: this.state.order, onHeaderClick: this.toggleInspection, isBodyshop: isBodyshop, PriceChange: this.PriceChange, assessmentItems: isBodyshop ? this.state.assessmentItemsBodyshop : this.state.assessmentItems });
	    }
	  }, {
	    key: 'renderOtherDamage',
	    value: function renderOtherDamage() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      if (this.state.inspection.OtherDamage === null) return null;
	      return _react2.default.createElement(_OtherDamage2.default, { otherDamage: this.state.inspection.OtherDamage, order: this.state.order, onHeaderClick: this.toggleInspection });
	    }
	  }, {
	    key: 'renderExternalDeviation',
	    value: function renderExternalDeviation(isBodyshop) {
	      if (this.state.inspection.ExternalWork === null || this.state.order.OrderType === 4) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	      return _react2.default.createElement(_ExternalDeviation2.default, { ExternalWork: this.state.inspection.ExternalWork, order: this.state.order, onHeaderClick: this.toggleInspection, isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'renderAssignWorker',
	    value: function renderAssignWorker(isBodyshop) {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || !(0, _auth.hasAccessToAssign)(this.props.auth)) return null;
	      if (isBodyshop) return null;
	      return _react2.default.createElement(_AssignWorker2.default, { router: this.props.router, order: this.state.order, getAssignOrderData: this.getAssignOrderData, StepAssignments: this.state.StepAssignments, isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'renderOrderStop',
	    value: function renderOrderStop(isBodyshop) {
	      if (this.state.order.IsReferredOut) return null;
	      return _react2.default.createElement(_OrderStop2.default, { order: this.state.order, stopLockOrder: this.stopLockOrder, isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'renderClaim',
	    value: function renderClaim(isBodyshop) {
	      var _this25 = this;
	
	      var propName = 'Claim';
	      if (isBodyshop) propName = 'BodyshopClaim';
	      var onBlur = function onBlur(e) {
	        setTimeout(function () {
	          _this25.saveOrderInspection(_this25.state.inspection);
	        }, 0);
	      };
	      var onChange = function onChange(e) {
	        e.persist();
	        var inspection = _extends({}, _this25.state.inspection);
	
	        if (isBodyshop) {
	          inspection.Claim = null;
	        } else {
	          inspection.BodyshopClaim = null;
	        }
	
	        if (e.target.name === 'ComplaintPrice') {
	          inspection[propName].ComplaintPrice = e.target.value;
	        } else {
	          if (e.target.name === 'Payment') {
	            inspection[propName].ComplaintPayer = e.target.value === 'us' ? 1 : 0;
	          } else {
	            inspection[propName].ComplaintOurRefNr = e.target.value;
	          }
	        }
	        _this25.setState({
	          inspection: inspection
	        }, function () {
	          if (e.target.type === 'checkbox' || e.target.type === 'radio') {
	            onBlur(e);
	          }
	        });
	      };
	      if (!this.state.inspection.Claim && !this.state.inspection.BodyshopClaim) return null;
	      return _react2.default.createElement(_Claim2.default, { order: this.state.order, onChange: onChange, onBlur: onBlur, claim: this.state.inspection[propName], shopName: this.state.inspection.ShopName, customerName: this.state.inspection.CustomerName, onHeaderClick: this.toggleInspection, isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'updateFromDeliveryTime',
	    value: function updateFromDeliveryTime(data) {
	      var _this26 = this;
	
	      this.setState({
	        inspection: _extends({}, this.state.inspection, {
	          Deadline: _extends({}, this.state.inspection.Deadline, {
	            DeliveryChangeReason: data.DeliveryChangeReason,
	            DeliveryChangeComment: data.DeliveryChangeComment,
	            Delivery: data.NewDate,
	            CommentApplyToInvoice: data.CommentApplyToInvoice,
	            CommentShowToCustomer: data.CommentShowToCustomer
	          })
	        }),
	        deliveryChangePopup: _extends({}, this.state.deliveryChangePopup, {
	          confirmed: data.Confirmed
	        })
	      }, function () {
	        if (data.Confirmed) {
	          _this26.showDeliveryDatePopup(false);
	        }
	        var inspection = _this26.state.inspection;
	        _this26.saveOrderInspection(inspection, true);
	      });
	    }
	  }, {
	    key: 'showDeliveryDatePopup',
	    value: function showDeliveryDatePopup(visible) {
	      if (visible === undefined) {
	        visible = !this.state.deliveryChangePopup.show;
	      }
	      this.props.triggerPopup(visible);
	      this.setState({
	        deliveryChangePopup: _extends({}, this.state.deliveryChangePopup, {
	          show: visible
	        })
	      });
	    }
	  }, {
	    key: 'renderDeliveryDatePopup',
	    value: function renderDeliveryDatePopup() {
	      var _this27 = this;
	
	      if (!this.state.deliveryChangePopup.show) return null;
	      var onClose = function onClose() {
	        var visible = false;
	        _this27.props.triggerPopup(visible);
	        _this27.setState({
	          deliveryChangePopup: _extends({}, _this27.state.deliveryChangePopup, {
	            show: visible
	          }),
	          inspection: _extends({}, _this27.state.inspection, {
	            Deadline: _extends({}, _this27.state.inspection.Deadline, {
	              Delivery: _this27.state.deliveryChangePopup.oldDate,
	              ProductionDate: _this27.state.deliveryChangePopup.oldProductionDate
	            })
	          }),
	          Deadline: _extends({}, _this27.state.Deadline, {
	            Delivery: _this27.state.deliveryChangePopup.oldDate,
	            ProductionDate: _this27.state.deliveryChangePopup.oldProductionDate
	          })
	        });
	      };
	      return _react2.default.createElement(_DeliveryDateChangeModal2.default, {
	        show: this.state.deliveryChangePopup.show,
	        onClose: onClose.bind(this),
	        onSave: this.updateFromDeliveryTime,
	        oldDate: this.state.deliveryChangePopup.oldDate,
	        newDate: this.state.deliveryChangePopup.newDate,
	        clientName: this.state.order.CustomerName,
	        shopName: this.state.order.ShopName,
	        times: this.state.inspection.Deadline.DeliveryTimes });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      var _this28 = this;
	
	      var goBack = function goBack(type) {
	        if ( /* shouldHaveArrow() && */type === 'close') {
	          var routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders']);
	          if (routeItem !== null) {
	            if (routeItem.pathname === '/orders') {
	              var orderId = _this28.props.routeParams.orderID;
	              _this28.props.setLastVisitedOrderId(orderId);
	              _this28.props.router.replace({
	                pathname: '/orders',
	                query: {
	                  orderid: orderId
	                }
	              });
	            } else {
	              _this28.props.router.replace(routeItem.pathname);
	            }
	          } else {
	            _this28.props.router.goBack();
	          }
	        } else {
	          _this28.props.router.goBack();
	        }
	      };
	      var renderArrowBack = function renderArrowBack() {
	        var topOfStack = window.LocalstorageStack.top();
	        if (topOfStack && !(0, _router.shouldHaveArrow)()) {
	          return null;
	        }
	        return _react2.default.createElement(_backButton2.default, { onClick: goBack.bind(_this28, 'back'), ariaText: (0, _helpers.translation)('394') });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderArrowBack(),
	        _react2.default.createElement(_closeButton2.default, { onClick: goBack.bind(this, 'close'), ariaText: (0, _helpers.translation)('2060') })
	      );
	    }
	  }, {
	    key: 'renderFileArea',
	    value: function renderFileArea(isBodyshop) {
	      return _react2.default.createElement(_Files2.default, { order: this.state.order, upload: this.state.upload, loadOrder: this.loadOrder.bind(this), isBodyshop: isBodyshop });
	    }
	  }, {
	    key: 'PriceChange',
	    value: function PriceChange(isBodyshop) {
	      var pat = '/1';
	      if (isBodyshop) pat = '/bodyextent';
	      if (this.state.order.OrderType === 4) {
	        this.setState({
	          otherPopup: _extends({}, this.state.otherPopup, {
	            open: true
	          })
	        });
	      } else {
	        this.props.router.push('pricecalculation/' + this.state.order.Id + pat);
	      }
	    }
	  }, {
	    key: 'onUpdateOrder',
	    value: function onUpdateOrder(res) {
	      if (typeof res === 'undefined' || (typeof res === 'undefined' ? 'undefined' : _typeof(res)) === undefined) {
	        // console.log('here???')
	        this.props.getOrder(this.props.params.orderID);
	      } else {
	        this.props.setOrder(res);
	        this.setState({ order: res });
	        this.getOrderInspection();
	      }
	    }
	  }, {
	    key: 'renderInvoice',
	    value: function renderInvoice() {
	      if (this.state.order === undefined) {
	        console.log('OrderInspection: ORDER UNDEFINED!');
	      }
	      return _react2.default.createElement(_Invoice2.default, { invoiceOrder: this.state.order, updateOrder: this.onUpdateOrder });
	    }
	  }, {
	    key: 'renderForsiToken',
	    value: function renderForsiToken() {
	      var _state = this.state,
	          order = _state.order,
	          InsuranceCompanies = _state.InsuranceCompanies;
	
	      var forsiEnable = this.props.auth.permissions.ChainAssessmentSystem === 1; // Forsi is available for the company
	
	      if (!forsiEnable) return null;
	      if (order.OrderType !== 1) return null;
	
	      return _react2.default.createElement(_ForsiCreateReport2.default, { order: order, forsi: InsuranceCompanies });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this29 = this;
	
	      if (this.state.inspection == null || !this.state.order.Id) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      if (Object.keys(this.state.inspection).length === 0) return null;
	      // let title = translation('13423')
	      // if (typeof this.state.order.Id !== 'undefined') {
	      //   title = makeOrderTitle(this.state.order, translation, enumtranslate, false, true)
	      // }
	      var onPortalClose = function onPortalClose(type) {
	        _this29.setState(_defineProperty({}, type, _extends({}, _this29.state[type], {
	          open: false
	        })));
	      };
	
	      var notConfirm = function notConfirm() {
	        _this29.setState({
	          showPopup: false
	        });
	      };
	      var confirm = function confirm() {
	        var inspection = _extends({}, _this29.state.inspection);
	        var name = _this29.props.auth.departmentType === 1 ? 'BodyshopAfterEvaluation' : 'AfterEvaluation';
	        var type = _this29.state.inspection[name] === null || typeof _this29.state.inspection[name] === 'undefined' ? 0 : typeof _this29.state.inspection[name] === 'boolean' ? 1 : 2;
	
	        switch (type) {
	          case 1:
	            inspection[name] = !inspection[name];
	            break;
	          case 2:
	            inspection[name].Checked = !inspection[name].Checked;
	            break;
	        }
	        _this29.saveOrderInspection(inspection);
	        _this29.setState({
	          showPopup: false
	        });
	      };
	      var renderCommonItems = function renderCommonItems() {
	        if (_this29.props.auth.departmentType === 1) {
	          if (_this29.dimensionShow([[0, 1056]])) {
	            return _react2.default.createElement(
	              _col2.default,
	              { key: '1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                _this29.renderInvoice(),
	                _this29.renderForsiToken()
	              ),
	              _this29.renderOrderStop(false),
	              _this29.renderCustomInspections(false),
	              _this29.renderOtherComment(false),
	              _this29.renderFileArea(false),
	              _this29.state.hasPaintWork && renderPaintItems()
	            );
	          }
	          if (_this29.state.hasPaintWork && _this29.dimensionShow([[0, 1401]])) {
	            return _react2.default.createElement(
	              _col2.default,
	              { key: '1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section__status' },
	                _this29.renderInvoice(),
	                _this29.renderForsiToken()
	              ),
	              _this29.renderOrderStop(false),
	              _this29.renderCustomInspections(false),
	              _this29.renderOtherComment(false),
	              _this29.renderFileArea(false)
	            );
	          }
	          return [_react2.default.createElement(
	            _col2.default,
	            { key: '1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'section__status' },
	              _this29.renderInvoice(),
	              _this29.renderForsiToken()
	            ),
	            _this29.renderOrderStop(false),
	            _this29.renderCustomInspections(false),
	            _this29.renderOtherComment(false)
	          ), _react2.default.createElement(
	            _col2.default,
	            { key: '2' },
	            _this29.renderFileArea(false)
	          )];
	        }
	        if (_this29.props.auth.departmentType === 2) {
	          // let classNames = 'col common'
	          // if (columnsWhenShowBoth) {
	          //   classNames = 'common'
	          // }
	          return _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'section__status' },
	              _this29.renderInvoice()
	            ),
	            _this29.renderOrderStop(false),
	            _this29.renderCustomInspections(false),
	            _this29.renderOtherComment(false),
	            _this29.renderFileArea(false)
	          );
	        }
	        if (_this29.dimensionShow([[0, 1056]])) {
	          return [_react2.default.createElement(
	            _col2.default,
	            { key: '1' },
	            _this29.renderClaim(false),
	            _react2.default.createElement(
	              'div',
	              { className: 'section__status' },
	              _this29.renderInvoice()
	            ),
	            _this29.renderAssesment(false),
	            _this29.renderExternalDeviation(false),
	            _this29.renderAssignWorker(false),
	            _this29.renderOrderStop(false),
	            _this29.renderMissingParts(false),
	            _this29.renderColor(false)
	          ), _react2.default.createElement(
	            _col2.default,
	            { key: '2' },
	            _this29.renderDeadline(false)
	          )];
	        }
	
	        return [_react2.default.createElement(
	          _col2.default,
	          { key: '1' },
	          _this29.renderClaim(false),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__status' },
	            _this29.renderInvoice()
	          ),
	          _this29.renderAssesment(false),
	          _this29.renderExternalDeviation(false),
	          _this29.renderAssignWorker(false),
	          _this29.renderOrderStop(false)
	        ), _react2.default.createElement(
	          _col2.default,
	          { key: '2' },
	          _this29.renderMissingParts(false),
	          _this29.renderColor(false),
	          _this29.renderDeadline(false)
	        )];
	      };
	      var getTitle = function getTitle(type) {
	        if (!_this29.dimensionShow([[0, 1073]])) {
	          return null;
	        }
	        var title = (0, _helpers.translation)('14779');
	        var icon = _icons.OrderDepartmentIcons.Body;
	        if (type === 'paint') {
	          title = (0, _helpers.translation)('161');
	          icon = _icons.OrderDepartmentIcons.Paint;
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'orderDepartment' },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, alignChildren: 'center' },
	            _react2.default.createElement(_icon2.default, { icon: icon }),
	            _react2.default.createElement(
	              'h2',
	              null,
	              title
	            )
	          )
	        );
	      };
	      var renderBodyItems = function renderBodyItems() {
	        if (_this29.props.auth.departmentType === 0) return null;
	        if (_this29.props.auth.departmentType === 1) {
	          return _react2.default.createElement(
	            _col2.default,
	            null,
	            getTitle('body'),
	            _this29.renderAssesment(true),
	            _this29.renderOtherDamage(),
	            _this29.renderClaim(true),
	            _this29.renderDeadline(true),
	            _this29.renderAssignWorker(true),
	            _this29.renderProcessComment(true)
	          );
	        }
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          getTitle('body'),
	          _this29.renderAssesment(false),
	          _this29.renderDeadline(true),
	          _this29.renderAssignWorker(true),
	          _this29.renderProcessComment(true)
	        );
	      };
	      var renderPaintItems = function renderPaintItems() {
	        if (_this29.props.auth.departmentType === 1) {
	          if (_this29.props.hasPartner === false) return null;
	
	          if (_this29.dimensionShow([[0, 1056]])) {
	            return [getTitle('paint'), _this29.renderBodyshopBooking(), _this29.renderColor(true)];
	          }
	          return _react2.default.createElement(
	            _col2.default,
	            null,
	            getTitle('paint'),
	            _this29.renderBodyshopBooking(),
	            _this29.renderColor(true)
	          );
	        }
	        if (_this29.props.auth.departmentType === 2) {
	          if (_this29.dimensionShow([[0, 1073]])) {
	            // let classNames = 'col'
	            // if (columnsWhenShowBoth) {
	            //   classNames = ''
	            // }
	            return _react2.default.createElement(
	              _col2.default,
	              { key: '3' },
	              getTitle('paint'),
	              _this29.renderClaim(false),
	              _this29.renderAssesment(false),
	              _this29.renderOtherDamage(),
	              _this29.renderDeadline(false),
	              _this29.renderAssignWorker(false),
	              _this29.renderProcessComment(false),
	              _this29.renderExternalDeviation(false),
	              _this29.renderColor(false),
	              _this29.renderMissingParts(false)
	            );
	          }
	          return [_react2.default.createElement(
	            _col2.default,
	            { key: '3' },
	            _this29.renderClaim(false),
	            _this29.renderAssesment(false),
	            _this29.renderOtherDamage(),
	            _this29.renderDeadline(false),
	            _this29.renderAssignWorker(false),
	            _this29.renderProcessComment(false)
	          ), _react2.default.createElement(
	            _col2.default,
	            { key: '4' },
	            _this29.renderExternalDeviation(false),
	            _this29.renderColor(false),
	            _this29.renderMissingParts(false)
	          )];
	        }
	        if (_this29.dimensionShow([[1376, 1377]])) {
	          return [_react2.default.createElement(
	            _col2.default,
	            { key: '1' },
	            _this29.renderProcessComment(false),
	            _this29.renderOtherComment(false),
	            _this29.renderFileArea(false)
	          ), _react2.default.createElement(
	            _col2.default,
	            { key: '2' },
	            _this29.renderCustomInspections(false)
	          )];
	        }
	
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          _this29.renderProcessComment(false),
	          _this29.renderOtherComment(false),
	          _this29.renderFileArea(false),
	          _this29.renderCustomInspections(false)
	        );
	      };
	      /* const renderFirstColumn = () => {
	        // let assessmentClass = 'assessmentItems2'
	        // if (assessmentItems.AnyOnWorkcard && assessmentItems.AssessmentItemDetails.length) {
	        //   assessmentClass = 'assessmentItems'
	        // }
	        return (
	          <div>
	            {renderCommonItems()}
	            {this.state.hasPaintWork && renderPaintItems()}
	          </div>
	        )
	      } */
	      if (this.state.inspection == null) return null;
	      if (Object.keys(this.state.inspection).length === 0) return null;
	      // let Deviations
	      // if (this.state.inspection.ExternalWork !== null) {
	      //   Deviations = this.state.inspection.ExternalWork.Deviations
	      // }
	
	      var toggleBody = function toggleBody() {
	        _this29.setState({
	          hasBodyWork: !_this29.state.hasBodyWork
	        });
	      };
	      var togglePaint = function togglePaint() {
	        _this29.setState({
	          hasPaintWork: !_this29.state.hasPaintWork
	        });
	      };
	
	      var isOver1072 = !this.dimensionShow([[0, 1056]]);
	      var hasPaintWork = this.state.hasPaintWork && !(this.props.auth.departmentType === 1 && this.props.hasPartner === false);
	
	      // Change 2nd link to pricecalc/4 to be controlled by ordertype
	      return _react2.default.createElement(
	        'div',
	        { className: 'orderinspection__screen' },
	        _react2.default.createElement(
	          _Header2.default,
	          { router: this.props.router, renderRight: this.headerButtonsRight },
	          _react2.default.createElement(_InspectionHeader2.default, { hasBodyWork: this.state.hasBodyWork, hasPaintWork: hasPaintWork, toggleBody: toggleBody, togglePaint: togglePaint, key: '131' })
	        ),
	        this.state.showPopup === true && _react2.default.createElement(_Confirm2.default, {
	          t: _helpers.translation,
	          renderText: function renderText() {
	            return (0, _helpers.translation)('14781');
	          },
	          confirm: confirm.bind(this),
	          notConfirm: notConfirm.bind(this) }),
	        _react2.default.createElement(_NotesModal2.default, {
	          show: this.state.note.modal,
	          onClose: this.showNoteModal,
	          note: this.state.note.data,
	          onSuccess: this.onNoteSuccess,
	          standardNotes: this.state.standardNotes,
	          onStandardNoteUpdate: this.onStandardNoteUpdate,
	          order: this.state.order }),
	        this.state.confirmApproveAssesment.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'resendModal', onPortalClose: onPortalClose.bind(this, 'confirmApproveAssesment') },
	          _react2.default.createElement(_Confirm2.default, { renderText: this.renderConfirmApproveDialog.bind(this), confirm: this.onConfirmApprove, notConfirm: onPortalClose.bind(this, 'confirmApproveAssesment'), disabled: this.state.isLoadingLastHistory === true })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'orderinspection__screen--inner', key: '13' },
	          _react2.default.createElement(
	            _row2.default,
	            null,
	            renderCommonItems(),
	            this.state.hasBodyWork && renderBodyItems(),
	            (isOver1072 || this.props.auth.departmentType !== 1) && this.state.hasPaintWork && renderPaintItems()
	          )
	        ),
	        this.renderDeliveryDatePopup(),
	        this.renderCreateEstimationPopup(),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.showAssign && _react2.default.createElement(_AssignBox2.default, { ref: 'AssignBox', onEmployeeChange: this.getAssignOrderData, closeAssign: function closeAssign() {
	              _this29.setState({ showAssign: false });
	            } })
	        ),
	        this.state.order.OrderType === 4 && _react2.default.createElement(_OtherPriceModal2.default, {
	          type: 1,
	          show: this.state.otherPopup.open,
	          onClose: onPortalClose.bind(this, 'otherPopup'),
	          other: this.state.otherPopup.other,
	          order: this.state.order,
	          onSuccess: onPortalClose.bind(this, 'otherPopup'),
	          saveOrder: this.props.saveOrder })
	      );
	    }
	  }]);
	
	  return OrderInspection;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    activeEmployees: state.assign.activeEmployees,
	    order: state.orders.order,
	    hasPartner: state.auth.hasPartner
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrderInspection: _orders.getOrderInspection,
	  saveOrderInspection: _orders.saveOrderInspection,
	  triggerPopup: _backdrop.triggerPopup,
	  getNextDeliveryTimes: _orders.getNextDeliveryTimes,
	  GetDeliveryChange: _orders.GetDeliveryChange,
	  getDeliveryTimes: _orders.getDeliveryTimes,
	  getPickupTimes: _orders.getPickupTimes,
	  getOrder: _orders.getOrder,
	  setOrder: _orders.setOrder,
	  saveOrder: _orders.saveOrder,
	  getOrderData: _assign.getOrderData,
	  isFileReady: _orders.isFileReady,
	  uploadFileToOrder: _orders.uploadFileToOrder,
	  deleteFileFromOrder: _orders.deleteFileFromOrder,
	  StopLockOrder: _orders.StopLockOrder,
	  GetAssessmentItemsInOrderInspection: _orders.GetAssessmentItemsInOrderInspection,
	  invoiceHistory: _invoicing.invoiceHistory,
	  getInvoiceStatus: _invoicing.getInvoiceStatus,
	  approveOrderInvoice: _invoicing.approveOrderInvoice,
	  setPageTitle: _common.setPageTitle,
	  getStandardNotes: _notes.getStandardNotes,
	  getInsuranceCompanies: _insurancecompanies.getInsuranceCompanies,
	  setLastVisitedOrderId: _orders.setLastVisitedOrderId
	})(OrderInspection);

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactList = __webpack_require__(1882);
	
	var _reactList2 = _interopRequireDefault(_reactList);
	
	var _constants = __webpack_require__(5);
	
	var _NewItem = __webpack_require__(909);
	
	var _NewItem2 = _interopRequireDefault(_NewItem);
	
	var _MassInvoice = __webpack_require__(1095);
	
	var _MassInvoice2 = _interopRequireDefault(_MassInvoice);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _orders = __webpack_require__(21);
	
	var _invoicing = __webpack_require__(150);
	
	var _backdrop = __webpack_require__(29);
	
	__webpack_require__(1420);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var List = function (_PureComponent) {
	  _inherits(List, _PureComponent);
	
	  function List(props) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));
	
	    _this.state = {
	      items: [],
	      pagination: {
	        hasMore: true,
	        isFetching: true,
	        page: 1
	      },
	      assignBoxOut: false,
	      GoToTop: false,
	      newOrdersFilter: 0,
	      massInvoice: {
	        open: false,
	        isLoading: false,
	        orderGroup: {},
	        orderGroupKey: null,
	        response: null,
	        itemsIsInvoicing: []
	        // dimensions: {
	        //   width: 0,
	        //   height: 0
	        // }
	      } };
	    _this.renderItem = _this.renderItem.bind(_this);
	    _this.getItems = window.debounce(_this.getItems, 500);
	    _this.app = null;
	    _this.number = 85;
	    _this.queryOrderId = 'undefined';
	    _this.scrollListener = window.debounce(_this.scrollListener.bind(_this), 500);
	    _this.toggleAssign = _this.toggleAssign.bind(_this);
	    _this.setSimpleSearch = _this.setSimpleSearch.bind(_this);
	    _this.setNewOrdersFilter = _this.setNewOrdersFilter.bind(_this);
	    _this.getNewOrdersFilter = _this.getNewOrdersFilter.bind(_this);
	    // this.dimensionShow = this.dimensionShow.bind(this)
	    // this.updateDimensions = this.updateDimensions.bind(this)
	
	    // Mass Invoice
	    _this.onMassInvoiceClose = _this.onMassInvoiceClose.bind(_this);
	    _this.executeMassInvoice = _this.executeMassInvoice.bind(_this);
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.orders !== nextProps.orders || this.props.openStartStopId !== nextProps.openStartStopId) {
	        this.getItems(nextProps);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._mounted = true;
	      this.getItems(this.props);
	      this.attachListeners();
	      this.queryOrderId = '' + this.props.router.location.query.orderid;
	      if (this.queryOrderId !== 'undefined') {
	        this.number = 20000;
	      }
	      var newOrdersFilter = this.getNewOrdersFilter();
	      // window.addEventListener('resize', this.updateDimensions)
	      // this.updateDimensions()
	      this.setState({
	        newOrdersFilter: newOrdersFilter
	      });
	    }
	  }, {
	    key: 'checkForPopups',
	    value: function checkForPopups() {
	      var item = document.getElementsByClassName('poppedup padding')[0];
	      if (item !== undefined) {
	        var bounding = item.getBoundingClientRect();
	        var app = document.getElementById('app');
	        var windowWith = window.innerWidth;
	        var windowHeight = window.innerHeight;
	
	        if (bounding.left < 0) {
	          if (windowWith > bounding.width * 2 + bounding.left) {
	            item.style.left = 0;
	          } else {
	            var margin = (windowWith - bounding.width) / 2;
	            item.style.right = bounding.left - margin;
	          }
	        }
	
	        if (bounding.right < 0) {
	          if (windowWith > bounding.width * 2 + bounding.right) {
	            item.style.right = 0;
	          } else {
	            var _margin = (windowWith - bounding.width) / 2;
	            item.style.left = bounding.right - _margin;
	          }
	        }
	
	        if (bounding.top < 0) {
	          app.scrollTop = app.scrollTop + bounding.top;
	        }
	        var bottomOffset = windowHeight - (bounding.top + bounding.height);
	        if (bottomOffset < 0) {
	          var distance = bottomOffset * -1;
	          distance += app.scrollTop;
	          app.scrollTop = distance;
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._mounted = false;
	      this.detachScrollListener();
	    }
	  }, {
	    key: 'attachListeners',
	    value: function attachListeners() {
	      if (_constants.isiOS) {
	        this.app = document.body;
	        document.addEventListener('scroll', this.scrollListener);
	        document.addEventListener('resize', this.scrollListener);
	      } else {
	        this.app = _reactDom2.default.findDOMNode(document.getElementById('app'));
	        this.app.addEventListener('scroll', this.scrollListener);
	        this.app.addEventListener('resize', this.scrollListener);
	      }
	    }
	  }, {
	    key: 'detachScrollListener',
	    value: function detachScrollListener() {
	      if (_constants.isiOS) {
	        document.removeEventListener('scroll', this.scrollListener);
	        document.removeEventListener('resize', this.scrollListener);
	      } else {
	        this.app.removeEventListener('scroll', this.scrollListener);
	        this.app.removeEventListener('resize', this.scrollListener);
	      }
	
	      this.app = null;
	    }
	  }, {
	    key: 'resetPagination',
	    value: function resetPagination() {
	      this.setState({
	        pagination: {
	          hasMore: true,
	          isFetching: true,
	          page: 1
	        }
	      });
	    }
	  }, {
	    key: 'setSimpleSearch',
	    value: function setSimpleSearch(simpleSearch) {
	      this.setState({
	        simpleSearch: simpleSearch
	      });
	    }
	  }, {
	    key: 'scrollListener',
	    value: function scrollListener() {
	      if (this.app === null || typeof this.app === 'undefined') return null;
	
	      var distance = this.app.scrollHeight - this.app.scrollTop;
	
	      if (this.app.scrollTop > 500) {
	        if (this.state.GoToTop !== true) {
	          this.setState({
	            GoToTop: true
	          });
	        }
	      } else {
	        if (this.state.GoToTop) {
	          this.setState({
	            GoToTop: false
	          });
	        }
	      }
	
	      if (distance < 2000 && this.state.pagination.hasMore) {
	        this.loadMore(this.state.pagination.page + 1);
	      }
	    }
	
	    // dimensionShow (dimensions) {
	    //   let show = false
	    //   dimensions.map((val, key) => {
	    //     if (!show) {
	    //       let higherThan = val[0]
	    //       let lessThan = val[1]
	    //       let width = this.state.dimensions.width
	    //       if (width > higherThan && width <= lessThan) show = true
	    //     }
	    //   })
	    //   return show
	    // }
	
	  }, {
	    key: 'loadMore',
	    value: function loadMore(page) {
	      var _this2 = this;
	
	      if (this.state.pagination.isFetching || !this.props.filter.process.Completed && this.state.simpleSearch == null) return null;
	      this.setState({
	        pagination: _extends({}, this.state.pagination, {
	          isFetching: true
	        })
	      });
	
	      // Data
	      var filter = _extends({}, this.props.filter);
	      filter.process = _extends({}, this.props.filter.process); // To not modify the same object ref. (caused the filter to "stick")
	      filter.process.Completed = true;
	      filter = _extends({}, filter, {
	        simpleSearch: this.state.simpleSearch
	      });
	      var data = {
	        Count: 50,
	        PageIdx: page,
	        Filter: filter
	        // Call API
	      };this.props.getArchivedOrders(data).then(function (res) {
	        if (!_this2._mounted) return null;
	        if (res.data.length !== 0) {
	          // Reset order query when showing additional archived orders to prevent browser jumping to top of list.
	          var routeItem = window.LocalstorageStack.findFirst(['/orders']);
	          if (routeItem !== null) {
	            _this2.props.router.replace({
	              pathname: '/orders',
	              query: null
	            });
	          }
	
	          // Orders
	          var orders = JSON.parse(JSON.stringify(_this2.props.orders));
	          res.data.map(function (item, k) {
	            orders[orders.length - 1].Orders.push(item);
	          });
	          _this2.props.updateOrderList(orders);
	        }
	        // Done getting items, set new items and page
	        _this2.setState({
	          pagination: {
	            isFetching: false,
	            page: page,
	            hasMore: res.data.length !== 0
	          }
	        }, function () {
	          if (_this2.state.pagination.hasMore) {
	            setTimeout(function () {
	              // window.toastr.success(translation('2250'), translation('13424'))
	            }, 1000);
	          }
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('2249'), (0, _helpers.translation)('216'));
	        // Done with errors, set page back and is still loading
	        _this2.setState({
	          pagination: {
	            hasMore: true,
	            isFetching: false,
	            page: page--
	          }
	        });
	      });
	    }
	  }, {
	    key: 'toggleAssign',
	    value: function toggleAssign(type) {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      if (!(0, _auth.hasAccessToAssign)(this.props.auth)) return null;
	      if (type !== this.state.assignBoxOut) {
	        this.setState({
	          assignBoxOut: type
	        });
	      }
	    }
	  }, {
	    key: 'getItems',
	    value: function getItems(props) {
	      var _this3 = this;
	
	      var wait = function wait(until, doWhile, doAfter) {
	        if (until() === true) return doAfter();
	        if (doWhile !== null) doWhile();
	        setTimeout(function () {
	          wait(until, doWhile, doAfter);
	        }, 500);
	      };
	
	      var items = [];
	      var indexCount = -1;
	      var skipToIndex = false;
	      var ArciveHeaderSplit = false;
	      var date = new Date();
	      date.setDate(date.getDate() - (date.getDay() || 7) + 1);
	      date.setHours(0);
	      date.setMinutes(0);
	      date.setMilliseconds(0);
	
	      props.orders.map(function (orderGroup, key) {
	        var skipInsert = false;
	        if (!orderGroup.SkipCheck) {
	          if (!props.filter.process.draft && orderGroup.DictionaryKey === 395) {
	            skipInsert = true;
	          }
	          if (!props.filter.process.Completed && !props.filter.process.CompletedThisWeek && orderGroup.DictionaryKey === 2703) {
	            skipInsert = true;
	          }
	          // if (!props.filter.process.InProcess) {
	          if (!props.filter.process.InProcess && orderGroup.DictionaryKey !== 2703 && orderGroup.DictionaryKey !== 395) {
	            var inprocess = [1, 2, 3, 4, 5, 6, 7];
	            // if (inprocess.indexOf(parseInt(orderGroup.Title)) !== -1) {
	            //   skipInsert = true
	            // }
	            if (inprocess.indexOf(parseInt(orderGroup.StepId)) !== -1) {
	              skipInsert = true;
	            }
	          }
	        }
	        if (!skipInsert) {
	          if (orderGroup.Orders.length === 0) {
	            // indexCount++
	            if (!props.filter.process.Completed && orderGroup.DictionaryKey === 2703) {
	              // orders = ''
	              // indexCount--
	            }
	            if (orderGroup.DictionaryKey === 164) {
	              if (props.filter !== undefined && props.filter.NewOrdersFilter !== undefined || props.filter.NewOrdersFilter !== null || props.filter.NewOrdersFilter !== 0) {
	                items.push(_this3.renderHeader(orderGroup, key));
	              }
	            }
	          } else {
	            if (orderGroup.DictionaryKey === 2703) {
	              if (new Date(orderGroup.Orders[0].ArchiveDate) < date) {
	                items.push(_this3.renderHeader(orderGroup, key));
	                ArciveHeaderSplit = true;
	              } else {
	                orderGroup.DictionaryKey = 2702;
	                items.push(_this3.renderHeader(orderGroup, key));
	                orderGroup.DictionaryKey = 2703;
	              }
	            } else {
	              items.push(_this3.renderHeader(orderGroup, key));
	            }
	
	            indexCount++;
	            orderGroup.Orders.map(function (item, k) {
	              if (orderGroup.DictionaryKey === 2703 && !ArciveHeaderSplit && new Date(item.ArchiveDate) < date) {
	                items.push(_this3.renderHeader(orderGroup, key + 1));
	                ArciveHeaderSplit = true;
	                indexCount++;
	              }
	              if (typeof _this3.queryOrderId !== 'undefined') {
	                indexCount++;
	                if (item !== null && ('' + item.Id === _this3.queryOrderId || item.LinkedOrders !== undefined && item.LinkedOrders.filter(function (e) {
	                  return '' + e.Id === _this3.queryOrderId;
	                }).length > 0)) {
	                  skipToIndex = indexCount;
	                }
	              }
	              // Is invoice loading?
	              var isInvoicing = _this3.state.massInvoice.itemsIsInvoicing.includes(item.Id);
	
	              items.push(_react2.default.createElement(_NewItem2.default, {
	                router: _this3.props.router,
	                toggleAssign: _this3.toggleAssign,
	                key: item.OrderKey,
	                item: item,
	                index: k,
	                step: key,
	                checkForPopups: _this3.checkForPopups,
	                isInvoicing: isInvoicing,
	                onStartAsShopLogin: _this3.props.onStartAsShopLogin,
	                openStartStopId: _this3.props.openStartStopId,
	                hasOpendStatrStop: _this3.props.hasOpendStatrStop
	                // setSelectedItem={this.props.setSelectedItem}
	                , openAction: _this3.props.openAction
	                // forceRender={Math.random()}
	              }));
	            });
	          }
	        }
	      });
	      if (this._mounted) {
	        this.setState({
	          items: items,
	          pagination: _extends({}, this.state.pagination, {
	            isFetching: false
	          })
	        }, function () {
	          if (_this3.state.pagination.hasMore && _this3.state.items.length < 25) {
	            _this3.loadMore(_this3.state.pagination.page + 1);
	          }
	          // Note:  If an order was just booked, for some reason that would be the only order in the list for a short moment,
	          //        which means skipToIndex would be set to 1, and queryOrderId would be cleared. Shortly after the full list of orders would be iterated,
	          //        but scrolling would then not occur as the id was cleared. Quickfix: scroll and reset query only if skipToIndex > 1
	          if (skipToIndex !== false && skipToIndex > 1) {
	            if (_this3.refs.reactlist === undefined) {
	              wait(function () {
	                return _this3.refs.reactlist !== undefined;
	              }, null, function () {
	                _this3.refs.reactlist.scrollTo(skipToIndex);
	                _this3.queryOrderId = 'undefined';
	              });
	            } else if (_this3.refs.reactlist !== undefined) {
	              _this3.refs.reactlist.scrollTo(skipToIndex);
	              _this3.queryOrderId = 'undefined';
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getHeaderIcon',
	    value: function getHeaderIcon(info) {
	      var imagePath = '/images/svgs/workscreen/';
	      switch (info.DictionaryKey) {
	        case 395:
	          return _react2.default.createElement('img', { src: imagePath + 'Draft-order-Black.svg' });
	        case 164:
	          return _react2.default.createElement('img', { src: imagePath + 'neworder.svg' });
	        case 208:
	          var img = 'coating.svg';
	          if (this.props.auth.departmentType === 1 && (0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	            img = 'bodywork.svg';
	          }
	          return _react2.default.createElement('img', { src: imagePath + img });
	        case 163:
	          return _react2.default.createElement('img', { src: imagePath + 'delivered.svg' });
	        case 2702:
	        case 2703:
	          return _react2.default.createElement('img', { src: imagePath + 'Completed-Black.svg' });
	        case 158:
	          return _react2.default.createElement('img', { src: imagePath + 'sanding.svg' });
	        case 161:
	          return _react2.default.createElement('img', { src: imagePath + 'coating.svg' });
	        case 96:
	          return _react2.default.createElement('img', { src: imagePath + 'pretreatment.svg' });
	        case 160:
	          return _react2.default.createElement('img', { src: imagePath + 'filler.svg' });
	        case 162:
	          if (info.StepId === 6) {
	            return _react2.default.createElement('img', { src: imagePath + 'preparing.svg' });
	          } else if (info.StepId === 104) {
	            return _react2.default.createElement('img', { src: imagePath + 'clean.svg' });
	          }
	          break;
	        case 702:
	          return _react2.default.createElement('img', { src: imagePath + 'moved-order.svg' });
	        case 617:
	          return _react2.default.createElement('img', { src: imagePath + 'demount.svg' });
	        case 618:
	          return _react2.default.createElement('img', { src: imagePath + 'reparation.svg' });
	        case 619:
	          return _react2.default.createElement('img', { src: imagePath + 'mount.svg' });
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'getNewOrdersFilter',
	    value: function getNewOrdersFilter(e) {
	      var _this4 = this;
	
	      var found = false;
	      var items = JSON.parse(window.localStorage.getItem('newOrdersFilter'));
	      var newOrdersFilter = e ? Number(e.target.value) : 0;
	
	      if (items && typeof items.push === 'function') {
	        items.map(function (x) {
	          if (x.userId === _this4.props.auth.user.UserId) {
	            if (e) x.filter = newOrdersFilter;else newOrdersFilter = x.filter;
	            found = true;
	          }
	        });
	      } else items = [];
	
	      if (!found) {
	        items.push({ userId: this.props.auth.user.UserId, filter: newOrdersFilter });
	      }
	      window.localStorage.setItem('newOrdersFilter', JSON.stringify(items));
	      return newOrdersFilter;
	    }
	  }, {
	    key: 'setNewOrdersFilter',
	    value: function setNewOrdersFilter(e) {
	      var _this5 = this;
	
	      var newOrdersFilter = this.getNewOrdersFilter(e);
	      var searchData = _extends({}, this.props.filter, {
	        NewOrdersFilter: newOrdersFilter
	      });
	      this.props.setOrdersFilter(searchData, 'orderlist');
	      this.setState({
	        newOrdersFilter: newOrdersFilter
	      });
	      if (e) {
	        searchData = _extends({}, searchData, {
	          Steps: [1]
	        });
	
	        var spinner = document.createElement('i');
	        spinner.className = 'fa fa-spinner fa-spin fa-2x fa-fw';
	        spinner.style = 'margin-left: 82px; position: absolute;';
	        var formElement = document.getElementById('newOrdersFilterId');
	        formElement.firstChild.disabled = true;
	        formElement.insertBefore(spinner, formElement.firstChild);
	
	        this.props.getOrdersNew(searchData).then(function (res) {
	          var steps = res.data[0].Steps;
	          var orders = JSON.parse(JSON.stringify(_this5.props.orders));
	          orders[1].Orders = steps[1].Orders;
	          _this5.props.updateOrderList(orders);
	
	          formElement.firstElementChild.remove();
	          formElement.firstChild.disabled = false;
	        });
	      }
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(header, key) {
	      var _this6 = this;
	
	      var orderGroupKey = key;
	      key += ' 234';
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var isBodyShop = this.props.auth.user.DepartmentType > 0;
	      var isNewOrder = header.DictionaryKey === 164;
	      if (header.Orders.length === 0) {
	        if (header.DictionaryKey === 164) {
	          if (this.props.filter === undefined) return;
	          if (this.props.filter.NewOrdersFilter === undefined || this.props.filter.NewOrdersFilter === null || this.props.filter.NewOrdersFilter === 0) {
	            return;
	          }
	        } else {
	          return;
	        }
	      }
	      var renderNewOrderOrInspection = function renderNewOrderOrInspection() {
	        if (!(0, _auth.hasSubscriptionPermission)(_this6.props.auth, 10) && !isBodyShop) return null;
	        if ((0, _auth.hasAccess)([3, 7], _this6.props.auth.user.UserType)) {
	          if (header.Title !== '0' && header.Title !== '1') {
	            return _react2.default.createElement(
	              'div',
	              { className: 'times' },
	              _this6.props.auth.departmentType !== 1 && _react2.default.createElement(
	                'div',
	                { className: 'hint--bottom', 'aria-label': (0, _helpers.translation)('13423') },
	                _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/Inspectionsteps-black.svg', className: 'icon' })
	              ),
	              _this6.props.auth.departmentType === 1 && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { style: { width: 25, height: 25 }, className: 'icon' })
	              )
	            );
	          }
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'times' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--bottom', 'aria-label': isBodyShop ? (0, _helpers.translation)('14827') : (0, _helpers.translation)('157') },
	            _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/pick-up-time.svg', className: 'icon' })
	          )
	        );
	      };
	
	      var renderRekvNr = function renderRekvNr() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'rekv_top_icon hint--top', 'aria-label': (0, _helpers.translation)('1337') },
	          _react2.default.createElement('img', { src: '/images/svgs/ordrer/Requisition_No.svg', style: { width: 25, height: 25 } })
	        );
	      };
	
	      var renderRekvNrCol = function renderRekvNrCol() {
	        if (isBodyShop || (0, _auth.hasSubscriptionPermission)(_this6.props.auth, 10)) {
	          return [_react2.default.createElement(
	            'div',
	            { className: 'rekv_nr' },
	            renderRekvNr()
	          ), _react2.default.createElement('div', { className: 'divider' })];
	        } else {
	          return null;
	        }
	      };
	
	      var renderDraftorNot = function renderDraftorNot(isDraft) {
	        var tooltip = isDraft === true ? (0, _helpers.translation)('13522') : (0, _helpers.translation)('1799');
	        return _react2.default.createElement(
	          'div',
	          { className: 'times' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--bottom', 'aria-label': tooltip },
	            _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/order-date.svg', className: 'icon' })
	          )
	        );
	      };
	      var renderNewOrderFilter = function renderNewOrderFilter() {
	        return _react2.default.createElement(
	          'form',
	          { id: 'newOrdersFilterId' },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { size: 'm', disabled: _this6.state.NewOrdersFilterIsLoading, onChange: _this6.setNewOrdersFilter.bind(_this6), value: _this6.state.newOrdersFilter },
	            _react2.default.createElement(
	              'option',
	              { value: 1 },
	              (0, _helpers.translation)('238')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 2 },
	              (0, _helpers.translation)('796')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 3 },
	              (0, _helpers.translation)('797')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 4 },
	              (0, _helpers.translation)('798')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 0 },
	              (0, _helpers.translation)('381')
	            )
	          )
	        );
	      };
	
	      var showMassInvoiceModal = function showMassInvoiceModal() {
	        _this6.props.triggerPopup(!_this6.state.massInvoice.open);
	        _this6.setState({
	          massInvoice: _extends({}, _this6.state.massInvoice, {
	            open: true,
	            orderGroup: header,
	            orderGroupKey: orderGroupKey
	          })
	        });
	      };
	
	      var bodyClass = ' body';
	      var nameClass = 'name';
	      var rightClass = 'rightorder';
	      if (isNewOrder) {
	        rightClass += ' text-adjust';
	        if (isCustomer) {
	          rightClass += ' customer';
	        }
	      }
	      var newOrdersHeaderClass = 'newOrderHeaderFilter';
	      if (isBodyShop) {
	        nameClass += bodyClass;
	        rightClass += bodyClass;
	      }
	      if (!isBodyShop) {
	        bodyClass = '';
	      }
	      if (iswp) {
	        bodyClass = ' wp';
	        nameClass += bodyClass;
	        rightClass += bodyClass;
	      }
	      if (this.props.auth.departmentType !== 0) {
	        if (isCustomer) {
	          newOrdersHeaderClass += ' bodyCustomer';
	        } else {
	          newOrdersHeaderClass += ' extra';
	        }
	      } else if (isCustomer) {
	        newOrdersHeaderClass += ' customer';
	      } else if (iswp) {
	        newOrdersHeaderClass += ' wp';
	      }
	      var isDraft = header.DictionaryKey === 395;
	      if (header.DictionaryKey === 395) {
	        // 395 ordrekladder
	        return _react2.default.createElement(
	          'div',
	          { className: 'neworder_item-outer list__header', key: key },
	          _react2.default.createElement(
	            'div',
	            { className: 'neworder_item clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: nameClass },
	              this.getHeaderIcon(header),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(header.DictionaryKey)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: rightClass },
	              _react2.default.createElement('div', { className: 'divider' }),
	              renderRekvNrCol(),
	              _react2.default.createElement('div', { className: 'message_missing_color' }),
	              _react2.default.createElement('div', { className: 'divider' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'times_wrap' },
	                isCustomer || iswp ? renderDraftorNot(isDraft) : _react2.default.createElement(
	                  _grid2.default,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'times' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hint--bottom', 'aria-label': isBodyShop ? (0, _helpers.translation)('14827') : (0, _helpers.translation)('157') },
	                      _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/pick-up-time.svg', className: 'icon' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'times' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hint--bottom', 'aria-label': (0, _helpers.translation)('193') },
	                      _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/Handsover-New.svg', className: 'icon' })
	                    )
	                  )
	                )
	              ),
	              (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && _react2.default.createElement('div', { className: 'divider', key: 'circle_1' }),
	              (!isBodyShop || isBodyShop && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) && _react2.default.createElement('div', { className: 'circle', key: 'circle_2' }),
	              this.props.auth.departmentType !== 0 && _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('div', { className: 'divider' }),
	                _react2.default.createElement('div', { className: 'body_paint_status' })
	              ),
	              _react2.default.createElement('div', { className: 'divider' }),
	              _react2.default.createElement('div', { className: 'transport' }),
	              _react2.default.createElement('div', { className: 'divider' }),
	              !isCustomer && _react2.default.createElement('div', { className: 'invoice' }),
	              !isCustomer && _react2.default.createElement('div', { className: 'divider' }),
	              _react2.default.createElement('div', { className: 'price_and_action' + bodyClass })
	            )
	          )
	        );
	      } else if (header.DictionaryKey === 2703 || header.DictionaryKey === 2702) {
	        // 2702 afsluttede (denne uge) // 2703 afsluttede (resterende)
	        return _react2.default.createElement(
	          'div',
	          { className: 'neworder_item-outer list__header', key: key },
	          _react2.default.createElement(
	            'div',
	            { className: 'neworder_item clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: nameClass },
	              this.getHeaderIcon(header),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(header.DictionaryKey)
	              ),
	              !isCustomer && _react2.default.createElement(
	                'div',
	                { className: 'invoice invoice__show', onClick: showMassInvoiceModal },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hint--top', 'aria-label': 'Mass invoice' },
	                  _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/mass-invoicing2.svg', className: 'icon' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: rightClass },
	              _react2.default.createElement('div', { className: 'divider' }),
	              renderRekvNrCol(),
	              _react2.default.createElement('div', { className: 'message_missing_color' }),
	              _react2.default.createElement('div', { className: 'divider' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'times_wrap' },
	                renderNewOrderOrInspection(),
	                (0, _auth.hasAccess)([3, 7], this.props.auth.user.UserType) && _react2.default.createElement(
	                  'div',
	                  { className: 'times' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hint--bottom', 'aria-label': (0, _helpers.translation)('1231') },
	                    _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/workscreen/Completed-Black.svg', className: 'icon' })
	                  )
	                ),
	                !(!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && !(this.props.auth.departmentType === 1)) && _react2.default.createElement(
	                  'div',
	                  { className: 'times' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hint--bottom', 'aria-label': (0, _helpers.translation)('193') },
	                    _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/Handsover-New.svg', className: 'icon' })
	                  )
	                )
	              ),
	              (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && _react2.default.createElement('div', { className: 'divider', key: 'circle_1' }),
	              (!isBodyShop || isBodyShop && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) && _react2.default.createElement('div', { className: 'circle', key: 'circle_2' }),
	              this.props.auth.departmentType !== 0 && _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('div', { className: 'divider' }),
	                _react2.default.createElement('div', { className: 'body_paint_status' })
	              ),
	              _react2.default.createElement('div', { className: 'divider' }),
	              _react2.default.createElement('div', { className: 'transport' }),
	              _react2.default.createElement('div', { className: 'divider' }),
	              !isCustomer && _react2.default.createElement(
	                'div',
	                { className: 'invoice' },
	                (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(
	                  'div',
	                  { className: 'hint--top', 'aria-label': 'Mass invoice', onClick: showMassInvoiceModal },
	                  _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/mass-invoicing2.svg', className: 'icon' })
	                )
	              ),
	              !isCustomer && _react2.default.createElement('div', { className: 'divider' }),
	              _react2.default.createElement('div', { className: 'price_and_action' + bodyClass })
	            )
	          )
	        );
	      } else {
	        var newOrdersSpacerBefore = 'space-adjust-before';
	        var newOrdersSpacerAfter = 'space-adjust-after';
	        if (this.props.auth.departmentType !== 0) {
	          newOrdersSpacerBefore += ' bodyshop-spacer';
	          newOrdersSpacerAfter += ' bodyshop-spacer';
	        } else if (iswp) {
	          newOrdersSpacerBefore += ' wp-spacer';
	        }
	        if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) {
	          newOrdersSpacerBefore += ' minimal';
	        }
	        var newOrderHeader = isNewOrder ? 'neworder_header-title' : '';
	        var cols = iswp ? [0.7, 0.7, 0.7] : [0.7, 1];
	        return _react2.default.createElement(
	          'div',
	          { className: 'neworder_item-outer list__header', key: key },
	          _react2.default.createElement(
	            'div',
	            { className: 'neworder_item clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: nameClass },
	              this.getHeaderIcon(header),
	              _react2.default.createElement(
	                'span',
	                { className: newOrderHeader },
	                (0, _helpers.translation)(header.DictionaryKey)
	              ),
	              isNewOrder && renderNewOrderFilter(),
	              !isCustomer && _react2.default.createElement(
	                'div',
	                { className: 'invoice invoice__show', onClick: showMassInvoiceModal },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hint--top', 'aria-label': 'Mass invoice' },
	                  _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/mass-invoicing2.svg', className: 'icon' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: rightClass },
	              _react2.default.createElement('div', { className: 'divider' }),
	              renderRekvNrCol(),
	              _react2.default.createElement('div', { className: 'message_missing_color' }),
	              _react2.default.createElement('div', { className: 'divider' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'times_wrap' },
	                !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && !isBodyShop && renderDraftorNot(isDraft),
	                _react2.default.createElement(
	                  _grid2.default,
	                  { cols: cols },
	                  !(this.props.auth.departmentType === 1 && header.DictionaryKey === 161) && renderNewOrderOrInspection(),
	                  this.props.auth.departmentType === 1 && header.DictionaryKey === 161 && _react2.default.createElement(
	                    'div',
	                    { className: 'times' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hint--bottom', 'aria-label': (0, _helpers.translation)('14982') },
	                      _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/coating-done-5.svg', className: 'icon' })
	                    )
	                  ),
	                  iswp && header.DictionaryKey !== 161 && _react2.default.createElement(
	                    'div',
	                    { className: 'times' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hint--bottom', 'aria-label': (0, _helpers.translation)('13423') },
	                      _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/Inspectionsteps-black.svg', className: 'icon' })
	                    )
	                  ),
	                  ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && !isBodyShop || isBodyShop) && _react2.default.createElement(
	                    'div',
	                    { className: 'times' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hint--bottom', 'aria-label': (0, _helpers.translation)('193') },
	                      _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/Handsover-New.svg', className: 'icon' })
	                    )
	                  )
	                )
	              ),
	              !isNewOrder && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && _react2.default.createElement('div', { className: 'divider', key: 'circle_1' }),
	              !isNewOrder && (!isBodyShop || isBodyShop && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) && _react2.default.createElement('div', { className: 'circle', key: 'circle_2' }),
	              !isNewOrder && this.props.auth.departmentType !== 0 && _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('div', { className: 'divider' }),
	                _react2.default.createElement('div', { className: 'body_paint_status' })
	              ),
	              !isNewOrder && _react2.default.createElement('div', { className: 'divider' }),
	              !isNewOrder && _react2.default.createElement('div', { className: 'transport' }),
	              !isNewOrder && _react2.default.createElement('div', { className: 'divider' }),
	              isNewOrder && _react2.default.createElement(
	                'div',
	                { className: newOrdersHeaderClass },
	                renderNewOrderFilter()
	              ),
	              isNewOrder && _react2.default.createElement('div', { className: newOrdersSpacerBefore }),
	              !isCustomer && _react2.default.createElement(
	                'div',
	                { className: 'invoice' },
	                (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(
	                  'div',
	                  { className: 'hint--top', 'aria-label': 'Mass invoice', onClick: showMassInvoiceModal },
	                  _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: '/images/svgs/listheader/mass-invoicing2.svg', className: 'icon' })
	                )
	              ),
	              isNewOrder && _react2.default.createElement('div', { className: newOrdersSpacerAfter }),
	              !isNewOrder && !isCustomer && _react2.default.createElement('div', { className: 'divider' }),
	              !isNewOrder && _react2.default.createElement('div', { className: 'price_and_action' + bodyClass })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderMassInvoiceModal',
	    value: function renderMassInvoiceModal() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      var _state$massInvoice = this.state.massInvoice,
	          open = _state$massInvoice.open,
	          isLoading = _state$massInvoice.isLoading,
	          response = _state$massInvoice.response,
	          itemsIsInvoicing = _state$massInvoice.itemsIsInvoicing;
	
	      var iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	
	      var orderKeys = {};
	      var addToOrderKeys = function addToOrderKeys(valid, o, groupKey, orderKey) {
	        if (valid) {
	          orderKeys[groupKey] = [].concat(_toConsumableArray(orderKeys[groupKey] || []), [{ Id: o.Id, orderKey: orderKey }]);
	        }
	      };
	
	      var readyOrders = this.props.orders.reduce(function (filtered, orderGroup, groupKey) {
	        var readyForInvoice = orderGroup.Orders.filter(function (o, orderKey) {
	          var mayInvoice = false;
	          if (iswp) {
	            mayInvoice = !o.IsInvoicedByWP && !o.IsMarkInvoicedByWP;
	          } else {
	            mayInvoice = !o.IsInvoiced && !o.IsMarkInvoiced;
	          }
	
	          var valid = o.ReadyForInvoice === 1 && mayInvoice;
	          addToOrderKeys(valid, o, groupKey, orderKey);
	          return valid;
	        });
	
	        var readyForMark = orderGroup.Orders.filter(function (o, orderKey) {
	          var mayMarkInvoiced = false;
	          if (iswp) {
	            mayMarkInvoiced = /* o.IsInvoicedByWP && */!o.IsMarkInvoicedByWP;
	          } else {
	            mayMarkInvoiced = /* o.IsInvoiced && */!o.IsMarkInvoiced;
	          }
	
	          var valid = o.ReadyForInvoice === 1 && mayMarkInvoiced;
	          addToOrderKeys(valid, o, groupKey, orderKey);
	          return valid;
	        });
	
	        if (readyForInvoice.length !== 0) {
	          filtered.readyForInvoice.push({
	            StepId: orderGroup.StepId,
	            DictionaryKey: orderGroup.DictionaryKey,
	            orders: readyForInvoice
	          });
	        }
	        if (readyForMark.length !== 0) {
	          filtered.readyForMark.push({
	            StepId: orderGroup.StepId,
	            DictionaryKey: orderGroup.DictionaryKey,
	            orders: readyForMark
	          });
	        }
	
	        return filtered;
	      }, { readyForInvoice: [], readyForMark: [] });
	
	      return _react2.default.createElement(_MassInvoice2.default, {
	        onClose: this.onMassInvoiceClose,
	        show: open,
	        isLoading: isLoading,
	        orders: readyOrders.readyForInvoice,
	        invoicedOrders: readyOrders.readyForMark,
	        executeMassInvoice: this.executeMassInvoice,
	        response: response,
	        getHeaderIcon: this.getHeaderIcon,
	        meta: { orderKeys: orderKeys },
	        itemsIsInvoicing: itemsIsInvoicing,
	        getErrDictionaryKey: this.getMassInvoiceErrorKey
	      });
	    }
	  }, {
	    key: 'getMassInvoiceErrorKey',
	    value: function getMassInvoiceErrorKey(errorType) {
	      switch (errorType) {
	        case 0:
	          return '13700';
	        case 1:
	          // OrderNotFound = 1,
	          return '13701';
	        case 2:
	          // CompanyNotFound = 2,
	          return '13702';
	        case 3:
	          // NotValidEconomicCredentials = 3,
	          return '13703';
	        case 4:
	          // NotValidHeliosNumber = 4,
	          return '13704';
	        case 5:
	          // NotValidC5UserPass = 5,
	          return '13705';
	        case 6:
	          // OrderIsAlreadySent = 6,
	          return '13706';
	        case 7:
	          return '13707';
	        case 8:
	          // AwaitingPriceApproval = 8
	          return '2710';
	        case 9:
	          return '14851';
	        case 10:
	          // NoDepartmentNumber = 10
	          return '16616';
	        case 11:
	          // NoDepartmentNumberEconomic = 11
	          return '16617';
	        default:
	          return '960';
	      }
	    }
	  }, {
	    key: 'executeMassInvoice',
	    value: function executeMassInvoice(selectedOrders, action, splitAddon, _ref) {
	      var _this7 = this;
	
	      var orderKeys = _ref.orderKeys;
	
	      var ids = selectedOrders.map(function (o) {
	        return o.Id;
	      });
	
	      var updateOrders = function updateOrders(orders) {
	        // update orders in the orderlist
	        orders.forEach(function (order) {
	          var keys = Object.entries(orderKeys).reduce(function (keys, ok) {
	            var _ok = _slicedToArray(ok, 2),
	                groupKey = _ok[0],
	                orderKeys = _ok[1];
	
	            var orderKey = orderKeys.find(function (k) {
	              return k.Id === order.Id;
	            });
	
	            if (orderKey) {
	              return [parseInt(groupKey), orderKey.orderKey];
	            }
	            return keys;
	          }, []);
	
	          if (keys.length === 2) {
	            _this7.props.updateOrderListSingle(order, keys[0], keys[1]);
	          }
	        });
	      };
	
	      this.setState({
	        massInvoice: _extends({}, this.state.massInvoice, {
	          isLoading: true,
	          itemsIsInvoicing: ids
	        })
	      }, function () {
	        // Is Invoicing
	        var key = 'ItemsIsInvoicing_' + _this7.props.auth.user.UserId;
	        // const isLoadings = JSON.parse(window.localStorage.getItem(key)) || []
	        // const isInvoicing = JSON.stringify([...isLoadings, ...ids])
	        // window.localStorage.setItem(key, isInvoicing) // Gives problems when invoicing and leaving page, orders are never removed from as invoicing
	
	        updateOrders(selectedOrders);
	
	        if (action !== 1) {
	          _this7.props.massInvoiceOrders({
	            OrderIds: ids,
	            SplitAddon: splitAddon,
	            MarkAsInvoiced: action === 2
	          }).then(function (res) {
	            var _res$data = res.data,
	                Success = _res$data.Success,
	                Errors = _res$data.Errors;
	
	            var errors = false;
	
	            if (Errors.length > 0) {
	              errors = Errors.map(function (e) {
	                var errDictionaryKey = _this7.getMassInvoiceErrorKey(e.Error);
	
	                return { order: e.order, error: (0, _helpers.translation)(errDictionaryKey) };
	              });
	
	              var errorText = errors.map(function (e) {
	                var identification = e.order.RegNumber || e.order.Id;
	                return identification + ': ' + e.error + '<br />';
	              });
	
	              window.toastr.error(errorText, (0, _helpers.translation)('216'));
	            }
	
	            window.localStorage.removeItem(key);
	
	            _this7.setState({
	              massInvoice: _extends({}, _this7.state.massInvoice, {
	                isLoading: false,
	                itemsIsInvoicing: [],
	                response: { action: action, success: Success, errors: errors }
	              })
	            });
	
	            // update icons in the orderlist
	            // updateOrders([ ...Success, ...Errors.map(e => e.order)])
	
	            if (Errors.length === 0) {
	              if (action === 2) {
	                // window.toastr.success(translation('14992'), translation('13424'))
	              } else {
	                  // window.toastr.success(translation('14990'), translation('13424'))
	                }
	            }
	          }).catch(function () {
	            window.localStorage.removeItem(key);
	            // updateOrders(selectedOrders)
	            window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	
	            _this7.setState({
	              massInvoice: _extends({}, _this7.state.massInvoice, {
	                isLoading: false,
	                itemsIsInvoicing: [],
	                response: { action: action, errors: true }
	              })
	            });
	          });
	        } else {
	          _this7.props.massMarkInvoiced({
	            OrderIds: ids
	          }).then(function (res) {
	            _this7.setState({
	              massInvoice: _extends({}, _this7.state.massInvoice, {
	                isLoading: false,
	                itemsIsInvoicing: [],
	                response: { action: action, success: res.data }
	              })
	            });
	
	            window.localStorage.removeItem(key);
	            // window.toastr.success(translation('14991'), translation('13424'))
	
	            // update icons in the orderlist
	            // updateOrders(res.data)
	          }).catch(function () {
	            _this7.setState({
	              massInvoice: _extends({}, _this7.state.massInvoice, {
	                isLoading: false,
	                itemsIsInvoicing: [],
	                response: { action: action, errors: true }
	              })
	            });
	
	            window.localStorage.removeItem(key);
	            window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	          });
	        }
	      });
	    }
	  }, {
	    key: 'onMassInvoiceClose',
	    value: function onMassInvoiceClose() {
	      this.props.triggerPopup(false);
	      this.setState({
	        massInvoice: _extends({}, this.state.massInvoice, {
	          open: false,
	          isLoading: false,
	          response: null
	        })
	      });
	    }
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this8 = this;
	
	      if (this.props.errors && !this.props.isLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'loading' },
	          _react2.default.createElement('div', null),
	          (0, _helpers.translation)('960')
	        );
	      }
	
	      if (this.props.orders.length === 0 || this.props.isLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'loading' },
	          _react2.default.createElement('div', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'sr-only' },
	              (0, _helpers.translation)('13382'),
	              '...'
	            )
	          )
	        );
	      }
	
	      var listContent = this.props.orders.map(function (orderGroup, key) {
	        if (!orderGroup.SkipCheck) {
	          if (!_this8.props.filter.process.draft && orderGroup.DictionaryKey === 395) {
	            return null;
	          }
	          if (!_this8.props.filter.process.Completed && orderGroup.DictionaryKey === 23) {
	            return null;
	          }
	          if (!_this8.props.filter.process.InProcess) {
	            var inprocess = [1, 2, 3, 4, 5, 6, 7];
	            if (inprocess.indexOf(parseInt(orderGroup.Title)) !== -1) {
	              return null;
	            }
	          }
	        }
	
	        var orders = '';
	        if (orderGroup.Orders.length === 0) {} else {
	          orders = orderGroup.Orders.map(_this8.renderItem.bind(_this8, key));
	        }
	        return [_this8.renderHeader(orderGroup, key), orders];
	      });
	
	      return listContent;
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(index, key) {
	      return this.state.items[index];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var listClass = '';
	      if (this.props.auth.user.CustomerId !== '-1') {
	        listClass = 'client__list';
	      } else {
	        listClass = 'work__list';
	      }
	
	      if (this.state.assignBoxOut) {
	        listClass += ' assignBoxOut';
	      }
	
	      if (this.props.errors && !this.props.isLoading) {
	        var text = (0, _helpers.translation)('960');
	        if (this.props.errors.NoOrders === true) {
	          text = (0, _helpers.translation)('957');
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'orderlist__list ' + listClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'loading' },
	            _react2.default.createElement('div', null),
	            text
	          )
	        );
	      }
	
	      if (this.state.items.length === 0 || this.props.isLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'orderlist__list ' + listClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'loading' },
	            _react2.default.createElement('div', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            )
	          )
	        );
	      }
	      var threshold = 200;
	      var goToTop = function goToTop() {
	        _this9.app.scrollTop = 0;
	        _this9.setState({
	          GoToTop: false
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'orderlist__list ' + listClass },
	        _react2.default.createElement(_reactList2.default, {
	          ref: 'reactlist',
	          itemRenderer: this.renderItem,
	          length: this.state.items.length,
	          pageSize: this.number,
	          threshold: threshold,
	          type: 'simple' }),
	        this.state.GoToTop && _react2.default.createElement(
	          'div',
	          { className: 'orderScrollToTop', onClick: goToTop.bind(this) },
	          _react2.default.createElement('img', { src: '/images/svgs/go-to-top.svg', alt: 'Scroll til toppen', title: (0, _helpers.translation)('13025') })
	        ),
	        this.state.massInvoice.open && this.renderMassInvoiceModal()
	      );
	    }
	  }]);
	
	  return List;
	}(_react.PureComponent);
	
	function mapStateToProps(state) {
	  var filter = state.orders.filterOrderlist;
	  if ((0, _auth.hasAccess)([4], state.auth.user.UserType)) {
	    filter = state.orders.filterCustomer;
	  } else if ((0, _auth.hasAccess)([6], state.auth.user.UserType)) {
	    filter = state.orders.filterWP;
	  }
	  return {
	    auth: state.auth,
	    filter: filter,
	    orders: state.orders.orders
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getArchivedOrders: _orders.getArchivedOrders,
	  updateOrderList: _orders.updateOrderList,
	  getOrdersNew: _orders.getOrdersNew,
	  setOrdersFilter: _orders.setOrdersFilter,
	  updateOrderListSingle: _orders.updateOrderListSingle,
	  massInvoiceOrders: _invoicing.massInvoiceOrders,
	  massMarkInvoiced: _invoicing.massMarkInvoiced,
	  triggerPopup: _backdrop.triggerPopup
	}, null, { withRef: true })(List);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1421);
	
	var _orders = __webpack_require__(21);
	
	var _ActionMenu = __webpack_require__(230);
	
	var _ActionMenu2 = _interopRequireDefault(_ActionMenu);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactDOM from 'react-dom'
	
	// Styles
	
	
	// Actions
	
	
	// import Overlay from '../../../../../shared/components/Overlay'
	
	
	var Circle = function (_Component) {
	  _inherits(Circle, _Component);
	
	  function Circle(props) {
	    _classCallCheck(this, Circle);
	
	    var _this = _possibleConstructorReturn(this, (Circle.__proto__ || Object.getPrototypeOf(Circle)).call(this, props));
	
	    _this.state = {
	      showTxt: false
	    };
	    _this.updateTime = null;
	    _this.checkStartStop = _this.checkStartStop.bind(_this);
	    // this.triggerClick = this.triggerClick.bind(this)
	    return _this;
	  }
	
	  _createClass(Circle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // this.setState({
	      //   item: this.props.item
	      // }, () => this.checkStartStop(this.props))
	      this.checkStartStop(this.props);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.checkStartStop(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.openStartStopId !== this.props.openStartStopId) {
	        this.checkStartStop(nextProps);
	      }
	      // this.setState({
	      //   item: nextProps.item
	      // }, () => {
	
	      //   this.checkStartStop(nextProps)
	      // })
	
	      // if (this.props.assign_open !== nextProps.assign_open) {
	      //   if (!nextProps.assign_open) {
	      //     this.refs.overlay.triggerOpen()
	      //   }
	      //   if (this.nextProps !== undefined && this.nextProps.checkForPopups !== undefined) this.nextProps.checkForPopups()
	      // }
	    }
	  }, {
	    key: 'checkStartStop',
	    value: function checkStartStop(props) {
	      if (props.item !== undefined && props.openStartStopId === props.item.Id) {
	        // if (this.startStop !== undefined) {
	
	        // }
	        if (typeof this.startStop.click === 'function') {
	          this.startStop.click();
	          this.props.hasOpendStatrStop();
	        }
	      }
	    }
	  }, {
	    key: 'getCircleImages',
	    value: function getCircleImages() {
	      var item = this.props.item;
	
	      var image = 'Timespent-';
	      var colored = item.ColoredParts < 0 ? 0 : item.ColoredParts;
	      var delayType = item.RemainingTimeDelay;
	      if (item.CompletedGain !== undefined && item.CompletedGain !== null) {
	        colored = item.CompletedGain.ColoredParts;
	        delayType = item.CompletedGain.Delay;
	      }
	      switch (delayType) {
	        case 0:
	          if (colored === 0) {
	            image += 'Black-0';
	          } else {
	            image += 'Green-' + colored;
	          }
	          break;
	        case 1:
	          image += 'Yellow-8';
	          break;
	        case 2:
	          var coloredX = colored < 8 ? colored : 8;
	          coloredX = coloredX === 0 ? 8 : coloredX;
	          image += 'Red-' + coloredX;
	          break;
	      }
	      var color = item.IsStarted && image.indexOf('Black-0') === -1 ? '-White' : '';
	      return image + color;
	    }
	  }, {
	    key: 'getEmployeeName',
	    value: function getEmployeeName() {
	      var item = this.props.item;
	      // Employee
	
	      var employee = '';
	      if (item.Employees && item.Employees.length !== 0) {
	        employee = item.Employees[0].Initials;
	        if (item.Employees.length !== 1 && employee !== '') {
	          employee += '+';
	        }
	      }
	      // Names popup
	      var namesPopup = '';
	      if (item.Employees && item.Employees.length !== 0) {
	        var names = [];
	        item.Employees.map(function (val) {
	          names.push(val.Name);
	        });
	        namesPopup = "<span class='hint--bottom' aria-label='" + names.join('&#xa;') + "'>" + employee + '</span>';
	      }
	      if (namesPopup !== '') {
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: namesPopup } })
	        );
	      }
	      // Return normal
	      return _react2.default.createElement(
	        'span',
	        { className: 'workers_name' },
	        employee
	      );
	    }
	  }, {
	    key: 'renderCircle',
	    value: function renderCircle(opener) {
	      var _this2 = this;
	
	      var item = this.props.item;
	
	      if (typeof item.ColoredParts === 'undefined') {
	        return _react2.default.createElement('div', { className: 'workers' });
	      }
	      var image = this.getCircleImages(item);
	      var EmployeeName = this.getEmployeeName();
	      var onClick = function onClick(e) {
	        if (typeof _this2.props.onPopupOpen === 'function') _this2.props.onPopupOpen();
	        var onClick = item.IsCurrentUserWorking ? _this2.props.stopOrder : _this2.props.startOrder;
	        if (opener !== false) {
	          onClick = opener;
	        }
	        onClick(e);
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'time_circle hasCursor', onClick: onClick, ref: function ref(c) {
	            return _this2.startStop = c;
	          } },
	        _react2.default.createElement('img', { src: '/images/icons/circle/' + image + '.png', className: 'worker__image' }),
	        EmployeeName
	      );
	    }
	
	    // triggerClick () {
	    //   if (this.props.auth.departmentType === 1) return null // BodyShop should not have this yet...
	
	    //   let type = !this.props.assign_open
	    //   this.props.openAssign(type)
	    //   let { item } = this.props
	    //   let element = document.getElementById('' + item.Id)
	
	    //   if (type) {
	    //     let bounding = element.getBoundingClientRect()
	    //     let distance = (window.innerHeight - 190) - (bounding.top + bounding.height)
	    //     if (distance < 0) {
	    //       let app = document.getElementById('app')
	    //       distance = distance * -1
	    //       element.style.marginBottom = distance + 'px'
	    //       distance += app.scrollTop
	    //       app.scrollTop = distance
	    //     }
	    //   } else {
	    //     element.style.marginBottom = '0px'
	    //   }
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var item = this.props.item;
	
	      // Stop icon
	
	      var renderStopIcon = function renderStopIcon() {
	        var renderActionOpener = function renderActionOpener(opener) {
	          return _this3.renderCircle(opener);
	        };
	        var renderActionMenu = function renderActionMenu() {
	          return _react2.default.createElement(
	            'div',
	            { className: 'poppedup' },
	            _react2.default.createElement(
	              'a',
	              { 'data-action': 'stop' },
	              _react2.default.createElement('img', { src: '/images/icons/pause-sign-32x32.png' }),
	              (0, _helpers.translation)('440')
	            ),
	            _react2.default.createElement(
	              'a',
	              { 'data-action': 'complete' },
	              _react2.default.createElement('img', { src: '/images/icons/Chekmark-Black-32.png' }),
	              (0, _helpers.translation)('1732')
	            )
	          );
	        };
	        var handleClick = function handleClick(el) {
	          // if (this.props.item.Id === 1060364) {
	          // } else if (this.props.item === undefined || this.props.item === null) console.log('MISSING ITEM')
	
	          switch (el.dataset.action) {
	            case 'stop':
	              _this3.props.stopOrder();
	              break;
	            case 'complete':
	              _this3.props.moveOrders({ OrderIds: [_this3.props.item.Id], UserId: 0, StepFrom: item.StepId, StepTo: null /*  (item.StepId + 1) */, Comment: '', FilterSettings: {} });
	              break;
	          }
	        };
	        var className = function className() {
	          return 'action__menu close__menu';
	        };
	
	        return _react2.default.createElement(_ActionMenu2.default, { className: className, item: _this3.props.item, handleClick: handleClick, renderActionOpener: renderActionOpener, renderActionMenu: renderActionMenu, noAriaLabel: true });
	      };
	
	      // Icon with names in
	      var renderIconWithNames = function renderIconWithNames() {
	        var onClick = function onClick(e) {
	          if (_this3.props.item.NeedReferredApprove) return null;
	          if (typeof _this3.props.onPopupOpen === 'function') _this3.props.onPopupOpen();
	          _this3.props.startOrder(e);
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'time_circle hasCursor', onClick: onClick, ref: function ref(c) {
	              return _this3.startStop = c;
	            } },
	          _react2.default.createElement('img', { src: '/images/icons/Ring-Black.png' }),
	          _this3.getEmployeeName()
	        );
	      };
	
	      if (item.IsStopped) {
	        var text = item.StoppedMessage;
	        if (item.StoppedMessage.length > 50) {
	          var breakTextNicely = function breakTextNicely(text, limit) {
	            var parts = text.split(' ');
	            var lines = [];
	            text = parts[0];
	            parts.shift();
	            while (parts.length > 0) {
	              var newText = text + ' ' + parts[0];
	              if (newText.length > limit) {
	                lines.push(text + '\n');
	                text = parts[0];
	              } else {
	                text = newText;
	              }
	              parts.shift();
	            }
	            lines.push(text);
	            return lines.join('');
	          };
	          text = breakTextNicely(item.StoppedMessage, 50);
	        }
	
	        var message = (0, _helpers.translation)(13501) + text;
	        if (item.StoppedMessage.length === 0) {
	          message = message.replace(':', '');
	        }
	
	        var call = function call() {
	          if (_this3.props.IsCustomer === true) {
	            if (typeof _this3.props.onPopupOpen === 'function') _this3.props.onPopupOpen();
	            _this3.setState({
	              showTxt: !_this3.state.showTxt
	            });
	          } else {
	            _this3.props.unlockOrder();
	          }
	        };
	
	        var popup = function popup() {
	          if (_this3.props.IsCustomer !== true || _this3.state.showTxt === false || item.StoppedMessage.length === 0) return null;
	
	          if (item.PriceApprovalToken !== null) {
	            _this3.props.router.push('/priceapproval/' + item.PriceApprovalToken);
	            return null;
	          }
	          return _react2.default.createElement(
	            'div',
	            { className: 'poppedup padding InfoPopup' },
	            _react2.default.createElement(
	              'label',
	              null,
	              item.StoppedMessage
	            )
	          );
	        };
	
	        if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'overlay time_circle hint--top', 'aria-label': message },
	            _react2.default.createElement('img', { src: '/images/icons/Stop-31.png', className: 'icon' })
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'overlay time_circle hint--top', 'aria-label': message, onClick: call, ref: function ref(c) {
	              return _this3.startStop = c;
	            } },
	          _react2.default.createElement('img', { src: '/images/icons/Stop-31.png', className: 'icon hasCursor' }),
	          popup()
	        );
	      }
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'time_circle' },
	          _react2.default.createElement('img', { src: '/images/icons/Ring-Black.png' }),
	          this.getEmployeeName()
	        );
	      }
	
	      // New type
	      if (this.props.type !== '111') {
	        if (item.IsCurrentUserWorking) {
	          return renderStopIcon();
	        }
	      }
	
	      var onClickOrderStart = function onClickOrderStart(e) {
	        if (_this3.props.item.NeedReferredApprove) return null;
	        if (typeof _this3.props.onPopupOpen === 'function') _this3.props.onPopupOpen();
	        _this3.props.startOrder(e);
	      };
	
	      // Step 1 & 7
	      if (item.StepId === 1 || item.StepId === 7) {
	        if (item.IsCurrentUserWorking) {
	          return renderStopIcon();
	        }
	        if (item.IsCurrentUserAssigned) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'time_circle hasCursor', onClick: onClickOrderStart, ref: function ref(c) {
	                return _this3.startStop = c;
	              } },
	            _react2.default.createElement('img', { src: '/images/icons/Start-Black.png' })
	          );
	        } else {
	          return renderIconWithNames();
	        }
	      }
	
	      // Order has been started
	      if (item.PreviouslyStarted) {
	        return this.renderCircle(false);
	      }
	
	      // User is assigned
	      if (item.IsCurrentUserAssigned) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'time_circle hasCursor', onClick: onClickOrderStart, ref: function ref(c) {
	              return _this3.startStop = c;
	            } },
	          _react2.default.createElement('img', { src: '/images/icons/Start-Black.png' })
	        );
	      }
	
	      if (item.CompletedGain !== undefined && item.CompletedGain !== null) {
	        var circleClass = 'time_circle ';
	        var hoverText = null;
	        if (item.CompletedGain.Text != null) {
	          circleClass += 'hint--top';
	          hoverText = (0, _helpers.translation)(2070) + ': ' + item.CompletedGain.Text;
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: circleClass, 'aria-label': hoverText },
	          _react2.default.createElement('img', { src: '/images/icons/circle/' + this.getCircleImages() + '.png' })
	        );
	      }
	
	      // Order has not been started
	      return renderIconWithNames();
	      // return <Overlay ref='overlay' dontHandleClick renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener}
	      //   openClick={openClick}
	      //   checkForPopups={this.props.checkForPopups} />
	    }
	  }]);
	
	  return Circle;
	}(_react.Component);
	
	Circle.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  StopLockOrder: _orders.StopLockOrder
	})(Circle);

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _AssignItem = __webpack_require__(227);
	
	var _AssignItem2 = _interopRequireDefault(_AssignItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Popup = function (_Component) {
	  _inherits(Popup, _Component);
	
	  function Popup() {
	    _classCallCheck(this, Popup);
	
	    return _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).apply(this, arguments));
	  }
	
	  _createClass(Popup, [{
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	
	      if (this.props.StepAssignments.length === 0) return null;
	      var stepId = item.StepId;
	      // Find entry in step assignments
	      var entry = null;
	      for (var i = 0; i < this.props.StepAssignments.length; i++) {
	        if (this.props.StepAssignments[i].StepId === stepId) {
	          this.props.StepAssignments[i].OrderAssignments.map(function (v) {
	            if (v.OrderId === item.Id) {
	              entry = _extends({}, v);
	            }
	          });
	          break;
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'poppedup padding circleInlinePopup' },
	        _react2.default.createElement(_AssignItem2.default, { item: entry, step: stepId, onAssignUsers: this.props.onAssignUsers, assignAriaPos: 'bottom-left', DontShowDeadline: true })
	      );
	    }
	  }]);
	
	  return Popup;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    StepAssignments: state.assign.StepAssignments
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Popup);

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _orders = __webpack_require__(21);
	
	__webpack_require__(1422);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// Utils
	
	
	// Elements
	
	
	var Color = function (_Component) {
	  _inherits(Color, _Component);
	
	  function Color(props) {
	    _classCallCheck(this, Color);
	
	    var _this = _possibleConstructorReturn(this, (Color.__proto__ || Object.getPrototypeOf(Color)).call(this, props));
	
	    _this.state = {
	      color: undefined
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Color, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        color: {
	          Color: this.props.item.Color,
	          ColorCode: this.props.item.ColorCode,
	          ColorVariant: this.props.item.ColorVariant,
	          ColorAmount: this.props.item.ColorAmount,
	          ColorIsReady: this.props.item.ColorIsReady
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = {
	        Color: nextProps.item.Color,
	        ColorCode: nextProps.item.ColorCode,
	        ColorVariant: nextProps.item.ColorVariant,
	        ColorAmount: nextProps.item.ColorAmount,
	        ColorIsReady: nextProps.item.ColorIsReady
	      };
	      if (!(0, _lodash.isEqual)(data, this.state.color)) {
	        this.setState({
	          color: data
	        });
	      }
	      if (this.nextProps !== undefined && this.nextProps.checkForPopups !== undefined) this.nextProps.checkForPopups();
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      this.setState({
	        color: _extends({}, this.state.color, _defineProperty({}, e.target.name, e.target.type === 'checkbox' ? e.target.checked : e.target.value))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this2.onBlur();
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      var _this3 = this;
	
	      var data = _extends({}, this.state.color);
	      data.OrderId = this.props.id;
	      this.props.updatePaint(data).then(function (res) {
	        _this3.props.updateOrder(res.data);
	        // Toastr
	        // window.toastr.success(translation('13521'), translation('13424'))
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.color === undefined) return null;
	      var isNotCustomer = !(0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      if (this.props.auth.departmentType === 1) {
	        // Dette er hvad vi viser, hvis vi er logget ind som pladeværksted/Karosseri
	        return _react2.default.createElement(
	          'div',
	          { className: 'poppedup padding colorInlinePopup form' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('179') },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [1], spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ColorIcons.Color_Name }),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'Color', value: this.state.color.Color || '', onChange: this.onInputChange, onBlur: this.onBlur })
	            )
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('79') },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [1], spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ColorIcons.Color_Code }),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'ColorCode', value: this.state.color.ColorCode || '', onChange: this.onInputChange, onBlur: this.onBlur })
	            ),
	            _react2.default.createElement('div', { style: { clear: 'both' } })
	          )
	        );
	      } else {
	        // Dette er hvad vi viser, hvis vi er logget ind som lak-/integrationsværksted
	        return _react2.default.createElement(
	          'div',
	          { className: 'poppedup padding colorInlinePopup form' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('179') },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [1], spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ColorIcons.Color_Name }),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'Color', value: this.state.color.Color || '', onChange: this.onInputChange, onBlur: this.onBlur })
	            )
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('79') },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [1], spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ColorIcons.Color_Code }),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'ColorCode', value: this.state.color.ColorCode || '', onChange: this.onInputChange, onBlur: this.onBlur })
	            )
	          ),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && isNotCustomer && [_react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13388'), key: 'color_1' },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [1], spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ColorIcons.Color_Variant }),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'ColorVariant', value: this.state.color.ColorVariant || '', onChange: this.onInputChange, onBlur: this.onBlur })
	            )
	          ), _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13392'), key: 'color_2' },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [1], spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ColorIcons.Color_Amount }),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'ColorAmount', value: this.state.color.ColorAmount || '', onChange: this.onInputChange, onBlur: this.onBlur })
	            )
	          ), _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13393'), key: 'color_3' },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [1], spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ColorIcons.Color_Ready }),
	              _react2.default.createElement(_check2.default, { size: 'm', simple: true, id: 'ColorIsReady_input', name: 'ColorIsReady', value: this.state.color.ColorIsReady, onChange: this.onInputChange, checked: this.state.color.ColorIsReady })
	            )
	          )]
	        );
	      }
	    }
	  }]);
	
	  return Color;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updatePaint: _orders.updatePaint
	})(Color);

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	__webpack_require__(210);
	
	__webpack_require__(254);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	var Baseline = function (_PureComponent) {
	  _inherits(Baseline, _PureComponent);
	
	  function Baseline(props) {
	    _classCallCheck(this, Baseline);
	
	    var _this = _possibleConstructorReturn(this, (Baseline.__proto__ || Object.getPrototypeOf(Baseline)).call(this, props));
	
	    _this.state = {
	      item: {
	        Handled: false,
	        HandledUserName: '',
	        HandledDate: null,
	        EconomicMatchPrice: 0,
	        EconomicMatchPriceWithVat: 0,
	        DiffPrice: null,
	        DiffPerc: null,
	        ShopBaseline: {
	          TotalPrice: 0,
	          TotalPriceWithVat: 0,
	          Price: 0,
	          EnvironmentPrice: 0,
	          AddonPrice: 0,
	          AddonEnvironmentPrice: 0,
	          PriceCorrection: 0,
	          AfterEvaluation: 0
	        },
	        WpBaseline: {
	          TotalPrice: 0,
	          TotalPriceWithVat: 0,
	          Price: 0,
	          EnvironmentPrice: 0,
	          AddonPrice: 0,
	          AddonEnvironmentPrice: 0,
	          PriceCorrection: 0,
	          AfterEvaluation: 0
	        }
	      }
	    };
	    _this.getTextFromType = _this.getTextFromType.bind(_this);
	    return _this;
	  }
	
	  _createClass(Baseline, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        item: nextProps.item
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        item: this.props.item
	      });
	    }
	  }, {
	    key: 'getTextFromType',
	    value: function getTextFromType(type) {
	      return (0, _helpers.translation)(type);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderDetailItem = function renderDetailItem(text, value, extraTitle, allInclusive, isPercent) {
	        if (value === -1) return null;
	        var val = (0, _currency.formatCurrency)(value);
	        var currency = _this2.props.currencyCode;
	        if (isPercent) currency = '';
	        var className = '';
	        if (extraTitle === true) {
	          className += ' logtitle';
	        }
	        if (allInclusive === true) {
	          return _react2.default.createElement(
	            'div',
	            { className: className },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [0] },
	              _react2.default.createElement('div', null),
	              _react2.default.createElement(
	                'div',
	                { className: 'amount' },
	                '(',
	                val,
	                ' ',
	                currency,
	                ')*'
	              )
	            )
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: className },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(text)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'amount' },
	              val,
	              isPercent ? '%' : ' ' + currency
	            )
	          )
	        );
	      };
	      var renderTotal = function renderTotal(price, priceWithVat) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          renderDetailItem('14846', price, true),
	          renderDetailItem('14846', priceWithVat, true, true)
	        );
	      };
	      var renderBaseDetails = function renderBaseDetails(item, type) {
	        var subcontractorTitle = (0, _helpers.translation)('14975') + ' (' + (0, _helpers.translation)('14974') + ')';
	        subcontractorTitle = subcontractorTitle.replace('%1', 'Qars');
	        var iswp = type === 'baseline';
	        var isshop = type === 'shop';
	        var baseClass = 'color-box';
	        if (iswp || isshop) {
	          subcontractorTitle = (0, _helpers.translation)('14848') + ' (' + (0, _helpers.translation)('14973') + ')';
	          if (isshop) {
	            subcontractorTitle = '(' + (0, _helpers.translation)('14974') + ')';
	          }
	          if (iswp && _this2.props.matchGreen) {
	            if (item.TotalPrice !== null && item.TotalPrice > 0 || item.TotalPriceWithVat !== null && item.TotalPriceWithVat > 0) {
	              baseClass += ' green-box';
	            }
	          }
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: baseClass },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: subcontractorTitle },
	              _react2.default.createElement(
	                'div',
	                null,
	                renderTotal(item.TotalPrice, item.TotalPriceWithVat)
	              )
	            )
	          ),
	          renderDetailItem('889', item.Price),
	          renderDetailItem('13339', item.EnvironmentPrice),
	          renderDetailItem('2325', item.AddonPrice),
	          renderDetailItem('2326', item.AddonEnvironmentPrice),
	          renderDetailItem('13535', item.PriceCorrection),
	          renderDetailItem('1019', item.AfterEvaluation)
	        );
	      };
	      var renderBaseLine = function renderBaseLine(item, baseItem, type) {
	        var title = (0, _helpers.translation)('14838');
	        var invoiceBaseClass = '';
	        var iswp = type === 'baseline';
	        if (iswp) {
	          title = (0, _helpers.translation)('14972');
	          if (_this2.props.matchBlue) {
	            if (baseItem.EconomicMatchPrice && baseItem.EconomicMatchPrice !== 0 || baseItem.EconomicMatchPriceWithVat && baseItem.EconomicMatchPriceWithVat !== 0) {
	              invoiceBaseClass += ' blue-box';
	            }
	          }
	        }
	        // let baseClass = 'baseline'
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _inline2.default,
	            { alignChildren: 'center' },
	            !iswp && _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Total_Price }),
	            iswp && _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Payment_Notif }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              title
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          iswp && _react2.default.createElement(
	            'div',
	            { className: 'invoicebase' },
	            _react2.default.createElement(
	              'div',
	              { className: invoiceBaseClass },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('14841') },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  renderTotal(baseItem.EconomicMatchPrice, baseItem.EconomicMatchPriceWithVat)
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'spacing' }),
	            renderDetailItem('14842', baseItem.DiffPrice ? baseItem.DiffPrice : 0),
	            renderDetailItem('14843', baseItem.DiffPerc ? baseItem.DiffPerc : 0, undefined, undefined, true)
	          ),
	          renderBaseDetails(item, type)
	        );
	      };
	      var item = this.state.item;
	
	      var isWP = this.props.isWP === true;
	      return _react2.default.createElement(
	        'div',
	        { className: 'popupPriceMatch' },
	        isWP && _react2.default.createElement(
	          'div',
	          null,
	          renderBaseLine(item.ShopBaseline, item, 'baseline'),
	          _react2.default.createElement('div', { className: 'spacing' }),
	          renderBaseLine(item.WpBaseline, item)
	        ),
	        !isWP && renderBaseLine(item.ShopBaseline, item, 'shop'),
	        _react2.default.createElement(_divider2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'spacing' },
	          '* ',
	          (0, _helpers.translation)('14978')
	        )
	      );
	    }
	  }]);
	
	  return Baseline;
	}(_react.PureComponent);
	
	Baseline.propTypes = {
	  item: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Baseline);

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _order = __webpack_require__(92);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	__webpack_require__(210);
	
	__webpack_require__(254);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	var InvoiceLogItem = function (_PureComponent) {
	  _inherits(InvoiceLogItem, _PureComponent);
	
	  function InvoiceLogItem(props) {
	    _classCallCheck(this, InvoiceLogItem);
	
	    var _this = _possibleConstructorReturn(this, (InvoiceLogItem.__proto__ || Object.getPrototypeOf(InvoiceLogItem)).call(this, props));
	
	    _this.state = {
	      item: {
	        Type: 0,
	        Date: undefined,
	        InvoiceNo: null,
	        VoucherNo: null,
	        VoucherFilePath: '',
	        Price: '',
	        CompanyName: '',
	        UserName: '',
	        UserPhone: '',
	        UserMail: ''
	      }
	    };
	    _this.findLogLineIcon = _this.findLogLineIcon.bind(_this);
	    _this.getTextFromType = _this.getTextFromType.bind(_this);
	    return _this;
	  }
	
	  _createClass(InvoiceLogItem, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.item !== this.props.item) {
	        this.setState({
	          item: nextProps.item
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        item: this.props.item
	      });
	    }
	  }, {
	    key: 'findLogLineIcon',
	    value: function findLogLineIcon(key) {
	      var icon = '';
	      key = '' + key;
	      switch (key) {
	        case '1139':
	          return 'images/svgs/invoicelog/ready-for-invoice.svg'; // '1139' Godkendt til fakturering
	        case '13042':
	          return 'images/svgs/invoice/posted-not-billed.svg'; // '13042' Sendt til fakturering
	        case '1136':
	          return 'images/svgs/invoice/Payment-ok.svg'; // '1136' Bogført
	        case '14958':
	          return 'images/svgs/invoicelog/crediting.svg'; // '14958' Kreditering
	        case '15322':
	        case '15267':
	        case '14959':
	          return 'images/svgs/invoice/posted-not-billed.svg'; // '14959' Gensendt til fakturering
	        case '14960':
	          return 'images/svgs/invoicelog/credit-note.svg'; // '14960' Kreditnota
	        case '14961':
	          return 'images/svgs/invoicelog/invoice.svg'; // '14961' Faktura
	        case '14962':
	          return 'images/svgs/invoicelog/afterevaluation-sent.svg'; // '14962' Eftertaksering sendt
	        case '14963':
	          return 'images/svgs/invoicelog/main-report-received.svg'; // '14963' Hovedrapport modtaget
	        case '14916':
	          return 'images/svgs/invoicelog/additional-report-received.svg'; // '14916' Tillægsrapport modtaget
	        case '2716':
	          return 'images/svgs/invoicelog/price-change-sent_black.svg'; // '2716'  Prisændring afsendt
	        case '14983':
	          return 'images/svgs/taksering/Charging-Black.svg'; // '14983' Omfang oprettet
	        case '2714': // '2714' Prisændring godkendt
	        case '2715':
	          return 'images/svgs/invoicelog/price-change-approved_black.svg'; // '2715' Prisændring afvist
	        case '14984': // '14984' Mersalg oprettet
	        case '1275':
	          return 'images/svgs/invoicelog/additional-sales-new.svg'; // '1275' Mersalg ændret
	      }
	      icon = '/images/svgs/Cirkle_info-black.svg';
	      return icon;
	    }
	  }, {
	    key: 'getTextFromType',
	    value: function getTextFromType(type) {
	      return (0, _helpers.translation)(type);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var item = this.state.item;
	
	      if (item.MarkType === 2) {
	        console.log('item invoice log ', item);
	      }
	      var type = this.getTextFromType(item.DictionaryKey);
	      if (item.TextExtension !== undefined && item.TextExtension !== null) type += ' ' + item.TextExtension;
	      var date = '';
	      if (item.Date && item.Date.length > 0) date = (0, _moment2.default)(window.CustomDate(item.Date)).format('DD-MM-YYYY - HH:mm');
	      var name = '';
	      if (item.UserName == null && item.CompanyName != null) {
	        name = item.CompanyName;
	      }
	      if (item.UserName != null) {
	        name = item.UserName;
	      }
	      var companyName = item.CompanyName;
	      var phone = item.UserPhone;
	      var mail = item.UserMail;
	      var showInfo = companyName !== undefined && companyName != null && companyName.length > 0 || phone !== undefined && phone != null && phone.length > 0 || mail !== undefined && mail != null && mail.length > 0;
	
	      var price = _react2.default.createElement('span', null);
	      var hasVoucher = item.VoucherNo !== null;
	      var hasInvoice = item.InvoiceNo !== null;
	      var hasReportName = item.ReportName !== null;
	      var hasVoucherPath = item.VoucherFilePath !== null;
	      if (item.Price !== 0) {
	        price = _react2.default.createElement(
	          'span',
	          { className: 'amount' },
	          (0, _currency.formatCurrency)(item.Price),
	          ' ',
	          this.props.currencyCode
	        );
	      }
	      // let imgsrc = this.findLogLineIcon(item.DictionaryKey)
	      var imgsrc = (0, _order.makeOrderAssessmentIcon)(item.DictionaryKey);
	      var info = '';
	      if (companyName != null) info += companyName;
	      if (phone != null) info += '\n' + phone;
	      if (mail != null) info += '\n' + mail;
	      var logClass = '';
	      if (this.props.showColor === true) {
	        if (item.MarkType === 1) logClass += ' green-box';
	        if (item.MarkType === 2) logClass += ' blue-box';
	      }
	      var isWarning = item.IsWarning;
	      if (isWarning) logClass += ' red-box';
	
	      var renderExtra = function renderExtra(type, extraNo) {
	        if (type === 'invoice' && !hasInvoice) return null;
	        if (type === 'voucher' && !hasVoucher) return null;
	        var title = (0, _helpers.translation)('14970');
	        if (type === 'voucher') title = (0, _helpers.translation)('14971');
	        if (type === 'voucher' && hasVoucher && hasVoucherPath) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'logtitle' },
	              title,
	              ' '
	            ),
	            _react2.default.createElement(
	              'a',
	              { target: '_BLANK', href: item.VoucherFilePath },
	              _react2.default.createElement(
	                'div',
	                { className: 'logname' },
	                extraNo
	              )
	            )
	          );
	        }
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: title },
	          _react2.default.createElement(
	            'div',
	            null,
	            extraNo
	          )
	        );
	      };
	      if (isWarning) {
	        type = (0, _helpers.translation)('534');
	        name = (0, _helpers.translation)('14986');
	        showInfo = (0, _helpers.translation)('14987');
	        return _react2.default.createElement(
	          _inline2.default,
	          { block: true, alignChildren: 'center', fillChildNum: [1] },
	          _react2.default.createElement(_icon2.default, { icon: imgsrc }),
	          _react2.default.createElement(
	            'div',
	            { className: logClass },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: type },
	              _react2.default.createElement(
	                'div',
	                null,
	                name
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                showInfo
	              )
	            )
	          )
	        );
	      }
	      // let logname = 'logname'
	      // if (!showInfo) logname += ' wide'
	      return _react2.default.createElement(
	        _inline2.default,
	        { block: true, alignChildren: 'center', fillChildNum: [1] },
	        _react2.default.createElement(_icon2.default, { icon: imgsrc }),
	        _react2.default.createElement(
	          'div',
	          { className: logClass },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, alignChildren: 'bottom', fillChildNum: [0, 1] },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: type },
	              _react2.default.createElement(
	                _inline2.default,
	                { block: true },
	                _react2.default.createElement(_UserInfo2.default, { user: item.UserInfo }),
	                showInfo && _react2.default.createElement(_helpIcon2.default, { helpText: info, white: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                date
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              renderExtra('invoice', item.InvoiceNo),
	              renderExtra('voucher', item.VoucherNo),
	              hasReportName && _react2.default.createElement(
	                'span',
	                null,
	                item.ReportName
	              )
	            ),
	            price
	          )
	        )
	      );
	    }
	  }]);
	
	  return InvoiceLogItem;
	}(_react.PureComponent);
	
	InvoiceLogItem.propTypes = {
	  item: _propTypes2.default.object.isRequired
	};
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(InvoiceLogItem);

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _time = __webpack_require__(17);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(210);
	
	__webpack_require__(254);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	var MatchPrice = function (_PureComponent) {
	  _inherits(MatchPrice, _PureComponent);
	
	  function MatchPrice(props) {
	    _classCallCheck(this, MatchPrice);
	
	    var _this = _possibleConstructorReturn(this, (MatchPrice.__proto__ || Object.getPrototypeOf(MatchPrice)).call(this, props));
	
	    _this.state = {
	      item: {
	        Handled: false,
	        HandledUserName: 'Apromas',
	        HandledDate: null
	      },
	      wpEconomicMatchType: undefined,
	      isLoading: false
	    };
	    _this.getTextFromType = _this.getTextFromType.bind(_this);
	    return _this;
	  }
	
	  _createClass(MatchPrice, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.item !== this.props.item) {
	        this.setState({
	          item: nextProps.item,
	          wpEconomicMatchType: nextProps.wpEconomicMatchType
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        item: this.props.item,
	        wpEconomicMatchType: this.props.wpEconomicMatchType
	      });
	    }
	  }, {
	    key: 'getTextFromType',
	    value: function getTextFromType(type) {
	      return (0, _helpers.translation)(type);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var item = this.state.item;
	
	      var handled = item.Handled === true;
	      var baseClass = 'matchprice_outer';
	      baseClass += handled ? ' handled' : ' unhandled';
	      // if (item.WpEconomicMatchType === null) return null
	      var handlePriceMatch = function handlePriceMatch() {
	        var data = {
	          OrderId: item.OrderId,
	          Checked: handled ? 0 : 1
	        };
	        _this2.setState({
	          isLoading: true
	        }, function () {
	          _this2.props.UpdateEconomicMatch(data).then(function (res) {
	            _this2.setState({
	              item: _extends({}, _this2.state.item, {
	                Handled: res.data.Checked === true
	              }),
	              wpEconomicMatchType: res.data.Checked === true ? 1 : 0,
	              isLoading: false
	            }, function () {
	              // console.log(this.state.item)
	              // window.toastr.success(translation('13041'), translation('13424'))
	            });
	          }, function (res) {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)('216'));
	            _this2.setState({
	              isLoading: false
	            });
	          });
	        });
	      };
	      var checkboxId = 'economicMatch_';
	      var handledName = (0, _helpers.translation)('14979').replace('%1', item.HandledUserName);
	      var canNotHandle = this.state.wpEconomicMatchType === undefined || this.state.wpEconomicMatchType === null || this.state.isLoading;
	      if (canNotHandle) {
	        baseClass = 'matchprice_outer handled';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: baseClass },
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0], alignChildren: 'center' },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('14976'),
	            ' - ',
	            !handled && (0, _helpers.translation)('14809'),
	            handled && handledName,
	            handled && ' - ',
	            handled && (0, _time.renderFullDate)(item.HandledDate, false)
	          ),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('14977'), className: 'rightmatch', id: checkboxId, value: handled, checked: handled, onClick: handlePriceMatch.bind(this), disabled: canNotHandle })
	        )
	      );
	    }
	  }]);
	
	  return MatchPrice;
	}(_react.PureComponent);
	
	MatchPrice.propTypes = {
	  item: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  UpdateEconomicMatch: _orders.UpdateEconomicMatch
	})(MatchPrice);

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _orders = __webpack_require__(21);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _InvoiceLogItem = __webpack_require__(902);
	
	var _InvoiceLogItem2 = _interopRequireDefault(_InvoiceLogItem);
	
	var _backdrop = __webpack_require__(29);
	
	var _Baseline = __webpack_require__(901);
	
	var _Baseline2 = _interopRequireDefault(_Baseline);
	
	var _MatchPrice = __webpack_require__(903);
	
	var _MatchPrice2 = _interopRequireDefault(_MatchPrice);
	
	var _icons = __webpack_require__(6);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(210);
	
	__webpack_require__(254);
	
	var _time = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	var InvoiceLog = function (_Component) {
	  _inherits(InvoiceLog, _Component);
	
	  function InvoiceLog(props) {
	    _classCallCheck(this, InvoiceLog);
	
	    var _this = _possibleConstructorReturn(this, (InvoiceLog.__proto__ || Object.getPrototypeOf(InvoiceLog)).call(this, props));
	
	    _this.state = {
	      isLoading: false,
	      show: true,
	      invoiceLog: {
	        OrderId: -1,
	        PriceDetails: {},
	        Items: []
	      },
	      isWP: false,
	      matchGreen: false,
	      matchBlue: false,
	      view: 'main'
	    };
	    _this.getInvoiceLog = _this.getInvoiceLog.bind(_this);
	    _this.renderDetails = _this.renderDetails.bind(_this);
	    _this.renderItem = _this.renderItem.bind(_this);
	    _this.renderOrderLog = _this.renderOrderLog.bind(_this);
	    _this.hide = _this.hide.bind(_this);
	    _this.getEmptyItem = _this.getEmptyItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(InvoiceLog, [{
	    key: 'hide',
	    value: function hide() {
	      this.props.triggerPopup(false);
	      this.setState({
	        show: false
	      });
	    }
	  }, {
	    key: 'getEmptyItem',
	    value: function getEmptyItem() {
	      return {
	        TotalPrice: 0,
	        TotalPriceWithVat: 0,
	        Price: 0,
	        EnvironmentPrice: 0,
	        AddonPrice: 0,
	        AddonEnvironmentPrice: 0,
	        PriceCorrection: 0,
	        AfterEvaluation: 0
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.getInvoiceLog(nextProps.item.Id);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getInvoiceLog(this.props.item.Id);
	      this.props.triggerPopup(true);
	    }
	  }, {
	    key: 'getInvoiceLog',
	    value: function getInvoiceLog(orderId) {
	      var _this2 = this;
	
	      this.setState({
	        isLoading: true,
	        show: true,
	        isWP: (0, _auth.hasAccess)([6], this.props.auth.user.UserType)
	      }, function () {
	        _this2.props.GetOrderInvoiceLog(orderId).then(function (res) {
	          if (res.data.ShopBaseline === null) {
	            res.data.ShopBaseline = _this2.getEmptyItem();
	          }
	          if (res.data.WpBaseline === null) {
	            res.data.WpBaseline = _this2.getEmptyItem();
	          }
	          var matchGreen = false;
	          var matchBlue = false;
	          if (_this2.state.isWP) {
	            // Find match in items
	            for (var i = 0; i < res.data.Items.length; i++) {
	              var item = res.data.Items[i];
	              if (item.MarkType === 1) {
	                matchGreen = true;
	              } else if (item.MarkType === 2) {
	                matchBlue = true;
	              }
	            }
	
	            // Find match in referredFromItems
	            for (var _i = 0; _i < res.data.ReferredFromItems.length; _i++) {
	              var _item = res.data.ReferredFromItems[_i];
	              if (_item.MarkType === 1) {
	                matchGreen = true;
	              } else if (_item.MarkType === 2) {
	                matchBlue = true;
	              }
	            }
	          }
	          // if (orderId < 1000000) {
	          //   let warningItem = {
	          //     CompanyName: '',
	          //     Date: null,
	          //     DictionaryKey: '',
	          //     GetBaselinePrice: false,
	          //     InvoiceNo: null,
	          //     MarkType: 0,
	          //     Price: 0,
	          //     ReportName: null,
	          //     TextExtension: '',
	          //     UserMail: '',
	          //     UserName: '',
	          //     UserPhone: '',
	          //     VoucherFilePath: null,
	          //     VoucherNo: null,
	          //     IsWarning: true
	          //   }
	          //   res.data.Items.splice(0, 0, warningItem)
	          // }
	          // console.log('res.data ', res.data)
	          _this2.setState({
	            matchBlue: matchBlue,
	            matchGreen: matchGreen,
	            invoiceLog: res.data,
	            isLoading: false
	          });
	        }, function (err) {
	          window.toastr.err((0, _helpers.translation)('2269'));
	          console.log(err);
	          _this2.hide();
	        });
	      });
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(val, key) {
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        _react2.default.createElement(_InvoiceLogItem2.default, { item: val, showColor: this.state.isWP }),
	        _react2.default.createElement(_divider2.default, null)
	      );
	    }
	  }, {
	    key: 'renderDetails',
	    value: function renderDetails() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: '2' },
	        _react2.default.createElement(_Baseline2.default, { item: this.state.invoiceLog, isWP: this.state.isWP, matchGreen: this.state.matchGreen, matchBlue: this.state.matchBlue })
	      );
	    }
	  }, {
	    key: 'renderLogHeader',
	    value: function renderLogHeader() {
	      var _this3 = this;
	
	      var _state$invoiceLog = this.state.invoiceLog,
	          ReferredFromCompany = _state$invoiceLog.ReferredFromCompany,
	          ReferredFromUser = _state$invoiceLog.ReferredFromUser,
	          ReferredFromDate = _state$invoiceLog.ReferredFromDate;
	
	
	      var onChange = function onChange(e) {
	        var value = e.target.value;
	
	        // console.log('onChange', { name, value })
	
	        _this3.setState({
	          view: value
	        });
	      };
	
	      // console.log('logheader', { view: this.state.view, checked: this.state.view === 'main' })
	      return _react2.default.createElement(
	        'div',
	        { className: 'logheader' },
	        _react2.default.createElement(
	          'div',
	          { className: 'logheader__btn-group' },
	          _react2.default.createElement(
	            'div',
	            { className: 'logheader__tab' },
	            _react2.default.createElement('input', { id: 'main', name: 'logView', type: 'checkbox', className: 'logheader__check', value: 'main', onChange: onChange, checked: this.state.view === 'main' }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'main', className: 'logheader__label' },
	              'Udf\xF8rende'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'logheader__tab' },
	            _react2.default.createElement('input', { id: 'refFrom', name: 'logView', type: 'checkbox', className: 'logheader__check', value: 'refFrom', onChange: onChange, checked: this.state.view === 'refFrom' }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'refFrom', className: 'logheader__label' },
	              'Henvist fra'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'logheader__info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'logheader__info-line' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Henvist fra:'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ReferredFromCompany
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'logheader__info-line' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Navn:'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ReferredFromUser
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'logheader__info-line' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Dato:'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(ReferredFromDate, true)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderOrderLog',
	    value: function renderOrderLog() {
	      var _state$invoiceLog2 = this.state.invoiceLog,
	          Items = _state$invoiceLog2.Items,
	          ReferredFromItems = _state$invoiceLog2.ReferredFromItems;
	
	
	      var logTitle = (0, _helpers.translation)('14839');
	      var noItems = (0, _helpers.translation)('14840');
	
	      var hasItems = false;
	      var items = [];
	      switch (this.state.view) {
	        case 'refFrom':
	          hasItems = ReferredFromItems.length > 0;
	          items = ReferredFromItems;
	          break;
	        case 'main':
	        default:
	          hasItems = Items.length > 0;
	          items = Items;
	          break;
	      }
	
	      return _react2.default.createElement(
	        _col2.default,
	        { span: '2' },
	        _react2.default.createElement(
	          _inline2.default,
	          null,
	          _react2.default.createElement(_icon2.default, { icon: _icons.OrderAssessmentIcons.Assesment_History }),
	          _react2.default.createElement(
	            'h3',
	            null,
	            logTitle
	          )
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        items.map(this.renderItem),
	        !hasItems && _react2.default.createElement(
	          'li',
	          null,
	          noItems
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	      var orderId = item.RegNumber !== null ? item.RegNumber : '';
	      if (orderId !== '' && item.Model !== '') orderId += ', ';
	      if (item.Model !== '') orderId += item.Model;
	      if (orderId === '') orderId = item.Id;
	      // console.log('this.state.invoiceLog.IsReferred ', this.state.invoiceLog.IsReferred)
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoiceLogPopup' },
	        _react2.default.createElement(
	          'div',
	          { className: 'poppeduplog' },
	          _react2.default.createElement(
	            _Modal2.default,
	            _extends({}, this.props, { show: this.state.show, onClose: this.hide, header: orderId, icon: _icons.ModalIcons.Payment_Notif }),
	            this.state.isLoading === true && _react2.default.createElement(
	              'div',
	              { className: 'loading-background' },
	              _react2.default.createElement(
	                'div',
	                { className: 'loading-middle' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'animated-background' },
	                  _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	                )
	              )
	            ),
	            this.state.isLoading === false && this.state.isWP && _react2.default.createElement(_MatchPrice2.default, { item: this.state.invoiceLog, wpEconomicMatchType: item.WpEconomicMatchType }),
	            this.state.isLoading === false && this.state.isWP && this.state.invoiceLog.IsReferred && this.renderLogHeader(),
	            _react2.default.createElement(
	              'div',
	              { className: 'poppeduplog-large' },
	              this.state.isLoading === false && this.renderOrderLog(),
	              this.state.isLoading === false && this.renderDetails()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InvoiceLog;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  UpdateEconomicMatch: _orders.UpdateEconomicMatch,
	  GetOrderInvoiceLog: _orders.GetOrderInvoiceLog,
	  triggerPopup: _backdrop.triggerPopup
	})(InvoiceLog);

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _notes = __webpack_require__(114);
	
	__webpack_require__(1423);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// Utils
	
	
	// Elements
	
	
	var Notes = function (_Component) {
	  _inherits(Notes, _Component);
	
	  function Notes(props) {
	    _classCallCheck(this, Notes);
	
	    var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));
	
	    _this.state = {
	      notes: [],
	      unread: false
	    };
	    _this.renderNote = _this.renderNote.bind(_this);
	    return _this;
	  }
	
	  _createClass(Notes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.getOrderNotes(this.props.id).then(function (res) {
	        if (res.data.length !== 0) {
	          _this2.setState({
	            notes: res.data
	          });
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'renderNote',
	    value: function renderNote(item, key) {
	      var _this3 = this;
	
	      // console.log(item)
	      var isRead = item.IsRead;
	      var onInputChange = function onInputChange(e) {
	        var checked = e.target.checked;
	        // Call API and set it to unread
	        var data = {
	          OrderId: _this3.props.id,
	          OrderNotes: [{
	            Id: item.NoteID,
	            IsRead: checked
	          }]
	        };
	
	        _this3.props.SetRead(data).then(function (res) {
	          // Set notes IsRead to !e.target.checked
	          var notes = [].concat(_toConsumableArray(_this3.state.notes));
	          notes[key].IsRead = checked;
	          _this3.setState({
	            notes: notes,
	            unread: true
	          });
	          _this3.props.updateOrder(res.data);
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        });
	      };
	
	      var customerIcon = void 0,
	          invoiceIcon = void 0;
	      if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && item.NoteTypeID === 1) {
	        customerIcon = _react2.default.createElement(
	          'div',
	          { className: 'hint--top', 'aria-label': (0, _helpers.translation)('2321') },
	          _react2.default.createElement('img', { src: '/images/icons/Customer_16.png' })
	        );
	      }
	
	      if (item.ApplyToInvoice === true) {
	        invoiceIcon = _react2.default.createElement(
	          'div',
	          { className: 'hint--top renderIcons', 'aria-label': (0, _helpers.translation)('@ Note tilføjet på fakturaen') },
	          _react2.default.createElement('img', { src: '/images/svgs/invoice/Total_price.svg', className: 'renderIcons' })
	        );
	      }
	
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        {
	          key: key,
	          labelText: _react2.default.createElement(
	            _grid2.default,
	            { spacing: 0, cols: ['max-content', 1, 'min-content'], align: 'center', fullWidth: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(item.NoteDate) + ':',
	              customerIcon,
	              invoiceIcon
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'user-name' },
	              item.NoteUserName
	            ),
	            item.CanEdditRead && !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(_check2.default, { simple: true, size: 's', id: item.NoteID + '_input', key: 'check_' + key, value: '1', onChange: onInputChange, checked: isRead })
	          ) },
	        (0, _helpers.translation)(item.SourceDictionaryKey),
	        ': ',
	        item.Note,
	        item.ShareType > 0 && _react2.default.createElement(
	          _label2.default,
	          null,
	          (0, _helpers.translation)('17861'),
	          (0, _helpers.getOrderNoteShareString)(item.ShareType)
	        ),
	        _react2.default.createElement(_divider2.default, null)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.notes.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'poppedup padding notesInlinePopup' },
	          (0, _helpers.translation)('2318')
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'poppedup padding notesInlinePopup' },
	          (0, _auth.hasAccess)([6], this.props.auth.user.UserType) ? _react2.default.createElement('span', null) : _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('13566')
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          this.state.notes.map(this.renderNote)
	        );
	      }
	
	      /* if (this.state.unread) {
	            return (
	              <div className='poppedup padding notesInlinePopup'>
	                <span>{translation('2319')}</span>
	                {this.state.notes.map(this.renderNote)}
	              </div>
	            )
	          } else {
	            return (
	              <div className='poppedup padding notesInlinePopup'>
	                <span>{translation('2320')}</span>
	                {this.state.notes.map(this.renderNote)}
	              </div>
	            )
	          } */
	    }
	  }]);
	
	  return Notes;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrderNotes: _notes.getOrderNotes,
	  SetRead: _notes.SetRead,
	  hasAccess: _auth.hasAccess
	})(Notes);

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _orders = __webpack_require__(21);
	
	__webpack_require__(1424);
	
	var _auth = __webpack_require__(8);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// Utils
	
	
	// Elements
	
	
	var PriceChange = function (_Component) {
	  _inherits(PriceChange, _Component);
	
	  function PriceChange(props) {
	    _classCallCheck(this, PriceChange);
	
	    var _this = _possibleConstructorReturn(this, (PriceChange.__proto__ || Object.getPrototypeOf(PriceChange)).call(this, props));
	
	    _this.state = {
	      pricelist: undefined
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(PriceChange, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        pricelist: {
	          Price: this.props.item.Price,
	          Environment: this.props.item.Environment,
	          AddonPrice: this.props.item.AddonPrice,
	          AddonEnvironment: this.props.item.AddonEnvironment,
	          PriceWP: this.props.item.PriceWP,
	          EnvWP: this.props.item.EnvWP,
	          AddonPriceWP: this.props.item.AddonPriceWP,
	          AddonEnvWP: this.props.item.AddonEnvWP
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = {
	        Price: nextProps.item.Price,
	        Environment: nextProps.item.Environment,
	        AddonPrice: nextProps.item.AddonPrice,
	        AddonEnvironment: nextProps.item.AddonEnvironment,
	        PriceWP: nextProps.item.PriceWP,
	        EnvWP: nextProps.item.EnvWP,
	        AddonPriceWP: this.props.item.AddonPriceWP,
	        AddonEnvWP: this.props.item.AddonEnvWP
	      };
	
	      if (!(0, _lodash.isEqual)(data, this.state.pricelist)) {
	        this.setState({
	          pricelist: data
	        });
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this2 = this;
	
	      var FixInput = e.target.value.replace(',', '.');
	
	      e.persist();
	      this.setState({
	        pricelist: _extends({}, this.state.pricelist, _defineProperty({}, e.target.name, e.target.type === 'checkbox' ? e.target.checked : FixInput))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this2.onBlur();
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      var _this3 = this;
	
	      var data = _extends({}, this.state.pricelist);
	      data.OrderId = this.props.id;
	
	      this.props.updatePrice(data).then(function (res) {
	        _this3.props.updateOrder(res.data);
	        // Toastr
	        // window.toastr.success(translation('2337'), translation('13424'))
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	
	      this.props.close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.pricelist === undefined) return null;
	      console.log('this.props.auth.user.UserType ', this.props.auth.user.UserType);
	      var iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var renderPriceLine = function renderPriceLine(key, value) {
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'min-content'], align: 'center' },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(key)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _currency.formatCurrency)(value)
	          )
	        );
	      };
	      var three = 3;
	      if ( /* this.props.item.HasOrderPrice !== true || this.props.item.MainReportDate !== null */2 + 2 !== three) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'poppedup padding colorInlinePopup form' },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 'min-content'], align: 'center' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('641')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _currency.formatCurrency)(this.state.pricelist.Price || 0)
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 'min-content'], align: 'center' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('1044')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _currency.formatCurrency)(this.state.pricelist.Environment || 0)
	            )
	          ),
	          ((0, _auth.hasSubscriptionPermission)(this.props.auth, 30) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30)) && _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 'min-content'], align: 'center' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('2325')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _currency.formatCurrency)(this.state.pricelist.AddonPrice || 0)
	            )
	          ),
	          ((0, _auth.hasSubscriptionPermission)(this.props.auth, 30) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30)) && _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 'min-content'], align: 'center' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('2326')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _currency.formatCurrency)(this.state.pricelist.AddonEnvironment || 0)
	            )
	          ),
	          iswp && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('12270') },
	            renderPriceLine('641', this.state.pricelist.PriceWP),
	            renderPriceLine('1044', this.state.pricelist.EnvWP),
	            renderPriceLine('2325', this.state.pricelist.AddonPriceWP),
	            renderPriceLine('2326', this.state.pricelist.AddonEnvWP)
	          )
	        );
	      }
	      // not shown anymore
	
	      //  else if (!hasAccess([4], this.props.auth.user.UserType)) {
	      // return (
	      //   <div className='poppedup padding colorInlinePopup form'>
	      //     <div>
	      //       <label>{translation('641')}</label>
	      //       <input type='text' name='Price' value={this.state.pricelist.Price || ''} onChange={this.onInputChange} />
	      //     </div>
	      //     <div>
	      //       <label>{translation('1044')}</label>
	      //       <input type='text' name='Environment' value={this.state.pricelist.Environment || ''} onChange={this.onInputChange} />
	      //     </div>
	      //     {(hasSubscriptionPermission(this.props.auth, 30) || hasPartnerSubscriptionPermission(this.props.auth, 30)) && (<div>
	      //       <label>{translation('2325')}</label>
	      //       <input type='text' name='AddonPrice' value={this.state.pricelist.AddonPrice || ''} onChange={this.onInputChange} />
	      //     </div>)}
	      //     {(hasSubscriptionPermission(this.props.auth, 30) || hasPartnerSubscriptionPermission(this.props.auth, 30)) && (<div>
	      //       <label>{translation('2326')}</label>
	      //       <input type='text' name='AddonEnvironment' value={this.state.pricelist.AddonEnvironment || ''} onChange={this.onInputChange} />
	      //     </div>)}
	      //     <div>
	      //       <button className='button primary' onClick={this.onBlur} style={{width: 250}}>{translation('Gem')}</button>
	      //     </div>
	      //   </div>
	      // )
	      // }
	    }
	  }]);
	
	  return PriceChange;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updatePrice: _orders.updatePrice
	})(PriceChange);

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1425);
	
	var _auth = __webpack_require__(8);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Styles
	
	
	// Elements
	
	
	var ChangeRekvNumber = function (_Component) {
	  _inherits(ChangeRekvNumber, _Component);
	
	  function ChangeRekvNumber(props) {
	    _classCallCheck(this, ChangeRekvNumber);
	
	    var _this = _possibleConstructorReturn(this, (ChangeRekvNumber.__proto__ || Object.getPrototypeOf(ChangeRekvNumber)).call(this, props));
	
	    _this.state = {
	      rekvnumber: undefined
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChangeRekvNumber, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.item !== undefined) {
	        if (this.props.auth.departmentType === 1) {
	          this.setState({
	            rekvnumber: {
	              RekvNumber: this.props.item.BodyShopRekvNumber
	            }
	          });
	        } else {
	          this.setState({
	            rekvnumber: {
	              RekvNumber: this.props.item.RekvNumber
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = {};
	      if (this.props.auth.departmentType === 1) {
	        data = {
	          RekvNumber: nextProps.item.BodyShopRekvNumber
	        };
	      } else {
	        data = {
	          RekvNumber: nextProps.item.RekvNumber
	        };
	      }
	
	      if (!(0, _lodash.isEqual)(data, this.state.rekvnumber)) {
	        this.setState({
	          rekvnumber: data
	        });
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this2 = this;
	
	      var FixInput = e.target.value.replace(',', '.');
	      e.persist();
	      this.setState({
	        rekvnumber: _extends({}, this.state.rekvnumber, _defineProperty({}, e.target.name, e.target.type === 'checkbox' ? e.target.checked : FixInput))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this2.onBlur();
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      var _this3 = this;
	
	      var data = _extends({}, this.state.rekvnumber);
	
	      data.OrderId = this.props.id;
	      if (this.props.auth.departmentType === 1) {
	        data.isBodyShop = true;
	      } else {
	        data.isBodyShop = false;
	      }
	
	      // console.log(data)
	
	      this.props.updateRekvNumber(data).then(function (res) {
	        _this3.props.updateOrder(res.data);
	        // Toastr
	        // window.toastr.success(translation('2330'), translation('13424'))
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var onClick = function onClick() {
	        _this4.props.clearLastVisitedOrderId();
	      };
	      // console.log(this.state.rekvnumber)
	      // console.log(this.props.item)
	      if (this.state.rekvnumber === undefined) {
	        return null;
	      } else {
	        // popup isn't shown anywhere!
	        if (this.props.showLabel === true || this.props.showLabel === undefined) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'poppedup padding colorInlinePopup form' },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('80') },
	              (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(_text2.default, { size: 'm', name: 'RekvNumber', value: this.state.rekvnumber.RekvNumber || '', onChange: this.onInputChange, onBlur: this.onBlur, onClick: onClick })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(_text2.default, { size: 's', name: 'RekvNumber', value: this.state.rekvnumber.RekvNumber || '', onChange: this.onInputChange, onBlur: this.onBlur, onClick: onClick })
	            )
	          );
	        }
	      }
	    }
	  }]);
	
	  return ChangeRekvNumber;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateRekvNumber: _orders.updateRekvNumber,
	  clearLastVisitedOrderId: _orders.clearLastVisitedOrderId
	})(ChangeRekvNumber);

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1427);
	
	var _helpers = __webpack_require__(2);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// Utils
	
	
	// Elements
	
	
	var Transport = function (_Component) {
	  _inherits(Transport, _Component);
	
	  function Transport() {
	    _classCallCheck(this, Transport);
	
	    return _possibleConstructorReturn(this, (Transport.__proto__ || Object.getPrototypeOf(Transport)).apply(this, arguments));
	  }
	
	  _createClass(Transport, [{
	    key: 'renderReferredOut',
	    value: function renderReferredOut() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('751') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('705') + ':' },
	          this.props.item.OrderConnection.TransportBefore
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('707') + ':' },
	          this.props.item.OrderConnection.TransportAfter
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('729'),
	            ': '
	          ),
	          this.props.item.OrderConnection.TransferedToCompanyName
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('359'),
	            ': '
	          ),
	          (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', this.props.item.OrderConnection.StepId))
	        ),
	        !this.props.item.OrderConnection.IsApproved && _react2.default.createElement(
	          _label2.default,
	          null,
	          (0, _helpers.translation)('734')
	        )
	      );
	    }
	  }, {
	    key: 'renderReferredIn',
	    value: function renderReferredIn() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('751') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('705') + ':' },
	          this.props.item.OrderConnection.TransportBefore
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('707') + ':' },
	          this.props.item.OrderConnection.TransportAfter
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('719'),
	            ': '
	          ),
	          this.props.item.OrderConnection.TransferedFromCompanyName
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('359'),
	            ': '
	          ),
	          (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', this.props.item.OrderConnection.StepId))
	        ),
	        !this.props.item.OrderConnection.IsApproved && _react2.default.createElement(
	          _label2.default,
	          { className: 'left bold' },
	          (0, _helpers.translation)('734')
	        )
	      );
	    }
	  }, {
	    key: 'RenderBodyShopPickUp',
	    value: function RenderBodyShopPickUp() {
	      var BodyShopPickupAltLocation = this.props.item.BodyShopPickupAltLocation;
	
	
	      if (this.props.item.HasBodyShopPickupAltLocation !== false) {
	        if (this.props.item.BodyShopPickupAltLocationId === 0 && BodyShopPickupAltLocation === null) {
	          return _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('157') },
	            (0, _helpers.translation)('227'),
	            _react2.default.createElement('br', null),
	            this.props.item.BodyShopPickupAltLocationComment
	          );
	        } else {
	          if (BodyShopPickupAltLocation !== null) {
	            return _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('157') },
	              BodyShopPickupAltLocation.Name,
	              _react2.default.createElement('br', null),
	              BodyShopPickupAltLocation.Address,
	              ', ',
	              BodyShopPickupAltLocation.ZipCode,
	              ' ',
	              BodyShopPickupAltLocation.City
	            );
	          }
	        }
	      }
	    }
	  }, {
	    key: 'RenderBodyShopDelivery',
	    value: function RenderBodyShopDelivery() {
	      var BodyShopDeliveryAltLocation = this.props.item.BodyShopDeliveryAltLocation;
	
	      if (this.props.item.HasBodyShopDeliveryAltLocation !== false) {
	        if (this.props.item.BodyShopDeliveryAltLocationId === 0 && BodyShopDeliveryAltLocation === null) {
	          return _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('193') },
	            (0, _helpers.translation)('227'),
	            _react2.default.createElement('br', null),
	            this.props.item.BodyShopDeliveryAltLocationComment
	          );
	        } else {
	          if (BodyShopDeliveryAltLocation !== null) {
	            return _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('193') },
	              BodyShopDeliveryAltLocation.Name,
	              _react2.default.createElement('br', null),
	              BodyShopDeliveryAltLocation.Address,
	              ', ',
	              BodyShopDeliveryAltLocation.ZipCode,
	              ' ',
	              BodyShopDeliveryAltLocation.City
	            );
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.auth.departmentType === 1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'poppedup padding TransportInlinePopup' },
	          this.RenderBodyShopPickUp(),
	          this.RenderBodyShopDelivery()
	        );
	      } else {
	        var _props$item = this.props.item,
	            PickupAltLocation = _props$item.PickupAltLocation,
	            DeliveryAltLocation = _props$item.DeliveryAltLocation;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'poppedup padding TransportInlinePopup' },
	          PickupAltLocation !== null && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('157') },
	            PickupAltLocation.Name,
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true },
	              PickupAltLocation.Address + ',',
	              PickupAltLocation.ZipCode,
	              PickupAltLocation.City
	            )
	          ),
	          DeliveryAltLocation !== null && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('193') },
	            DeliveryAltLocation.Name,
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true },
	              DeliveryAltLocation.Address + ',',
	              DeliveryAltLocation.ZipCode,
	              DeliveryAltLocation.City
	            )
	          ),
	          this.props.item.IsReferredIn && this.props.item.OrderConnection !== null && this.renderReferredIn(),
	          this.props.item.IsReferredOut && this.props.item.OrderConnection !== null && this.renderReferredOut()
	        );
	      }
	    }
	  }]);
	
	  return Transport;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Transport);

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(43);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _orders = __webpack_require__(21);
	
	var _assign = __webpack_require__(148);
	
	var _backdrop = __webpack_require__(29);
	
	var _shops = __webpack_require__(79);
	
	var _helpers = __webpack_require__(2);
	
	var _DateChangePopup = __webpack_require__(432);
	
	var _DateChangePopup2 = _interopRequireDefault(_DateChangePopup);
	
	var _DateActions = __webpack_require__(431);
	
	var _DateActions2 = _interopRequireDefault(_DateActions);
	
	var _OrderActions = __webpack_require__(427);
	
	var _OrderActions2 = _interopRequireDefault(_OrderActions);
	
	var _Overlay = __webpack_require__(1057);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _HoverExtent = __webpack_require__(441);
	
	var _HoverExtent2 = _interopRequireDefault(_HoverExtent);
	
	var _QualityCheckModal = __webpack_require__(204);
	
	var _QualityCheckModal2 = _interopRequireDefault(_QualityCheckModal);
	
	var _HoverPopup = __webpack_require__(293);
	
	var _HoverPopup2 = _interopRequireDefault(_HoverPopup);
	
	var _AssignBox = __webpack_require__(196);
	
	var _AssignBox2 = _interopRequireDefault(_AssignBox);
	
	var _InvoicePopup = __webpack_require__(442);
	
	var _InvoicePopup2 = _interopRequireDefault(_InvoicePopup);
	
	var _popup = __webpack_require__(899);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _StopOtherOrders = __webpack_require__(299);
	
	var _StopOtherOrders2 = _interopRequireDefault(_StopOtherOrders);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Notes = __webpack_require__(905);
	
	var _Notes2 = _interopRequireDefault(_Notes);
	
	var _Color = __webpack_require__(900);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _InvoiceLog = __webpack_require__(904);
	
	var _InvoiceLog2 = _interopRequireDefault(_InvoiceLog);
	
	var _Transport = __webpack_require__(908);
	
	var _Transport2 = _interopRequireDefault(_Transport);
	
	var _PriceChange = __webpack_require__(906);
	
	var _PriceChange2 = _interopRequireDefault(_PriceChange);
	
	var _RekvNumber = __webpack_require__(907);
	
	var _RekvNumber2 = _interopRequireDefault(_RekvNumber);
	
	var _SetCustomer = __webpack_require__(418);
	
	var _SetCustomer2 = _interopRequireDefault(_SetCustomer);
	
	var _Taksering = __webpack_require__(419);
	
	var _Taksering2 = _interopRequireDefault(_Taksering);
	
	var _Circle = __webpack_require__(898);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _ReferenceOrderActionModal = __webpack_require__(305);
	
	var _ReferenceOrderActionModal2 = _interopRequireDefault(_ReferenceOrderActionModal);
	
	var _time = __webpack_require__(17);
	
	var _currency = __webpack_require__(41);
	
	var _order = __webpack_require__(92);
	
	var _auth = __webpack_require__(8);
	
	var _constants = __webpack_require__(5);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	__webpack_require__(210);
	
	var _icons = __webpack_require__(6);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Action
	
	// import { approveOrderInvoice } from '../../../../actions/invoicing'
	
	
	// Utils
	
	
	// import components
	
	
	// Overlays
	
	// import Invoice from './Invoice'
	
	
	// Taksering
	
	
	// Circle
	
	
	// import modals
	
	
	// import utils
	
	
	// Elements
	
	
	// Styles
	
	
	var NewItem = function (_Component) {
	  _inherits(NewItem, _Component);
	
	  function NewItem(props) {
	    _classCallCheck(this, NewItem);
	
	    var _this = _possibleConstructorReturn(this, (NewItem.__proto__ || Object.getPrototypeOf(NewItem)).call(this, props));
	
	    _this.state = {
	      item: null,
	      assign_open: false,
	      OrderIds: [],
	      UserIds: [],
	      orderReferenceApprove: {
	        open: false,
	        id: 0
	      },
	      MoveOrders: {
	        open: false,
	        MoveAll: null,
	        OrderIds: [],
	        FromStep: 0,
	        ToStep: 0,
	        step: 0,
	        index: 0,
	        Id: 0
	      },
	      stopped: {
	        open: false,
	        comment: ''
	      },
	      stopOtherOrders: {
	        open: false,
	        WorkOnAll: null
	      },
	      stopOrders: {
	        open: false,
	        StopAll: null
	      },
	      showTxt: false,
	      quality: {
	        open: false,
	        data: [{}],
	        pos: 0,
	        index: 0,
	        move: true
	      },
	      showSpinner: {
	        invoicing: false
	      },
	      isIExplorer: false,
	      isEdge: false,
	      isFireFox: false
	    };
	    _this.updateOrder = _this.updateOrder.bind(_this);
	    _this.openAssign = _this.openAssign.bind(_this);
	    _this.getAssignOrderData = _this.getAssignOrderData.bind(_this);
	    _this.onAssignUsers = _this.onAssignUsers.bind(_this);
	    _this.closeAssignBox = _this.closeAssignBox.bind(_this);
	    _this.unlockOrder = _this.unlockOrder.bind(_this);
	    _this.renderNewOrder = _this.renderNewOrder.bind(_this);
	    // this.approveForInvoice = this.approveForInvoice.bind(this)
	    _this.closeQualityModal = _this.closeQualityModal.bind(_this);
	    _this.moveOrder = _this.moveOrder.bind(_this);
	    _this.showSpinner = _this.showSpinner.bind(_this);
	    _this.renderWorkproviderPriceMatch = _this.renderWorkproviderPriceMatch.bind(_this);
	    _this.renderPaintBodyStatus = _this.renderPaintBodyStatus.bind(_this);
	    _this.renderSetNewCustomer = _this.renderSetNewCustomer.bind(_this);
	    _this.getVerticalScrollOffset = _this.getVerticalScrollOffset.bind(_this);
	    _this.getHorizontalScrollOffset = _this.getHorizontalScrollOffset.bind(_this);
	    _this.renderReferred = _this.renderReferred.bind(_this);
	    _this.renderItem = _this.renderItem.bind(_this);
	    _this.renderLinkedItem = _this.renderLinkedItem.bind(_this);
	    _this.triggerClickAssign = _this.triggerClickAssign.bind(_this);
	    _this.startOrder = _this.startOrder.bind(_this);
	    _this.stopOrder = _this.stopOrder.bind(_this);
	    _this.startOrderSuccess = _this.startOrderSuccess.bind(_this);
	    _this.moveOrders = _this.moveOrders.bind(_this);
	    _this.setStopped = _this.setStopped.bind(_this);
	    _this.togglePortal = _this.togglePortal.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        item: this.props.item
	      });
	      if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        _events2.default.addListener('OPEN_ASSIGNBOX', this.closeAssignBox, this);
	      }
	      this.showSpinner('invoicing', this.props.isInvoicing);
	
	      this.setState({
	        isIExplorer: navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1,
	        isEdge: navigator.userAgent.indexOf('Edge') > -1,
	        isFireFox: navigator.userAgent.indexOf('Firefox') > -1
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!(0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        _events2.default.removeListener('OPEN_ASSIGNBOX', this.closeAssignBox);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(nextProps.item, this.props.item) || this.props.openStartStopId !== nextProps.openStartStopId) {
	        this.setState({
	          item: nextProps.item
	        });
	      }
	
	      this.showSpinner('invoicing', nextProps.isInvoicing);
	    }
	  }, {
	    key: 'togglePortal',
	    value: function togglePortal(e) {
	      e.preventDefault();
	      this.setState({
	        stopped: _extends({}, this.state.stopped, {
	          open: false
	        })
	      });
	      document.removeEventListener('click', this.togglePortal, false);
	    }
	  }, {
	    key: 'showSpinner',
	    value: function showSpinner(element, enabled) {
	      var spinner = this.state.showSpinner;
	      spinner[element] = enabled;
	      this.setState({
	        showSpinner: spinner
	      });
	    }
	  }, {
	    key: 'closeAssignBox',
	    value: function closeAssignBox() {
	      if (this.state.assign_open !== false) {
	        this.setState({
	          assign_open: false
	        });
	      }
	    }
	  }, {
	    key: 'triggerClickAssign',
	    value: function triggerClickAssign() {
	      // if (this.props.auth.departmentType === 1) return null // BodyShop should not have this yet...
	
	      var type = !this.state.assign_open;
	      this.openAssign(type);
	      var item = this.state.item;
	
	      var element = document.getElementById('' + item.Id);
	
	      if (type) {
	        var bounding = element.getBoundingClientRect();
	        var distance = window.innerHeight - 190 - (bounding.top + bounding.height);
	        if (distance < 0) {
	          var app = document.getElementById('app');
	          distance = distance * -1;
	          element.style.marginBottom = distance + 'px';
	          distance += app.scrollTop;
	          app.scrollTop = distance;
	        }
	      } else {
	        element.style.marginBottom = '0px';
	      }
	
	      // if (this.props.checkForPopups !== undefined) {
	      //   this.props.checkForPopups()
	      // }
	    }
	  }, {
	    key: 'renderTime',
	    value: function renderTime(time, isPickup) {
	      if (this.props.auth.user.WorkProviderId + '' === '-1' && this.props.auth.user.CustomerId + '' === '-1' && isPickup && this.props.auth.shopUseTimeForPickupOnOrderList === false) {
	        return (0, _time.renderFullDate)(time, false);
	      } else if (this.props.auth.user.CustomerId === '-1') {
	        return (0, _time.renderTime)(time);
	      } else {
	        return (0, _time.renderFullDate)(time);
	      }
	    }
	
	    // Check permissions for this function?
	
	  }, {
	    key: 'renderNewOrder',
	    value: function renderNewOrder() {
	      var _this2 = this;
	
	      var convertDateOutput = function convertDateOutput(item, className, translationText) {
	        var newDate = (0, _time.renderFullDate)(item);
	        var dasDate = newDate.substring(0, 5);
	        var dasTime = newDate.substring(12, 18);
	        return _react2.default.createElement(
	          'span',
	          { className: className, 'aria-label': translationText },
	          dasDate,
	          '\xA0\xA0\xA0',
	          dasTime
	        );
	      };
	
	      // Order inspection
	      if (this.state.item.StepId !== 1 && !(0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        var backgroundClass = '';
	        if (this.props.auth.departmentType === 1 && this.state.item.Step === 105) {
	          var className = '';
	          var translationText = '';
	          if (this.state.item.IsDeliveryDateChanged) {
	            translationText = (0, _helpers.translation)('1273');
	            className = 'deliveryChanged';
	          }
	          return _react2.default.createElement(
	            'div',
	            { className: 'times' },
	            convertDateOutput(this.state.item.Delivery, className, translationText)
	          );
	          // } else {
	          //   return (
	          //     <div className={'times'} />
	          //   )
	          // }
	        } else if (!this.state.item.IsReferredOut || [7, 8].includes(this.state.item.Step)) {
	          if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.state.item.InspectionStepsCompleted === 0) {
	            backgroundClass = 'hasRedBorder';
	          }
	          if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.state.item.InspectionStepsCompleted !== 0 && this.state.item.InspectionStepsCompleted !== this.state.item.InspectionStepsTotal) {
	            backgroundClass = 'hasYellowBorder';
	          }
	          var timesData = (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) ? this.state.item.InspectionStepsCompleted + '/' + this.state.item.InspectionStepsTotal : '\xA0';
	          var onClick = function onClick() {
	            if ((0, _auth.hasSubscriptionPermission)(_this2.props.auth, 10, 30) || (0, _auth.hasAccess)([6], _this2.props.auth.user.UserType)) {
	              _this2.props.router.push('/orders/' + _this2.state.item.Id + '/orderinspection');
	            }
	          };
	          if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20, 0)) backgroundClass = '';
	          return _react2.default.createElement(
	            'div',
	            { className: 'times hasCursor ' + backgroundClass, onClick: onClick },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              null,
	              _react2.default.createElement('img', { src: '/images/svgs/listheader/Inspectionsteps-black.svg' }),
	              timesData
	            )
	          );
	        }
	      }
	
	      var classList = '';
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType) && !this.state.item.IsDraft) {
	        classList = ' hint--top';
	      }
	
	      // New order pickup date
	
	      if (this.props.auth.departmentType === 1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'times mobileTimes' },
	          _react2.default.createElement('img', { src: '/images/svgs/listheader/pick-up-time.svg' }),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(
	            'span',
	            { className: 'mobileTime hint--top' + classList, 'aria-label': (0, _helpers.translation)('157') + ' ' + (0, _time.renderFullDate)(this.state.item.BodyShopPickupTime) },
	            this.renderTime(this.state.item.BodyShopPickupTime, true)
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'times mobileTimes' },
	          _react2.default.createElement('img', { src: '/images/svgs/listheader/pick-up-time.svg' }),
	          ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && _react2.default.createElement(
	            'span',
	            { className: 'mobileTime hint--top' + classList, 'aria-label': (0, _helpers.translation)('157') + ' ' + (0, _time.renderFullDate)(this.state.item.Pickup) },
	            this.renderTime(this.state.item.Pickup, true)
	          )
	        );
	      }
	    }
	
	    // should be able to edit Delivery time
	
	  }, {
	    key: 'renderHandover',
	    value: function renderHandover(item) {
	      var _this3 = this;
	
	      if (!item) item = this.state.item;
	      var classList = 'hint--top';
	      var hasCursor = ' hasCursor';
	      var translationText = (0, _helpers.translation)('193');
	      var showBodyTime = this.props.auth.departmentType === 1 || this.props.auth.departmentType !== 0 && item.IsBodyShopOrder;
	      if (showBodyTime && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0) || !showBodyTime && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 0)) {
	        hasCursor = ' hasDefaultCursor';
	      }
	      if (!showBodyTime && item.IsDeliveryDateChanged) {
	        classList += ' deliveryChanged';
	        translationText = (0, _helpers.translation)('1273');
	      }
	      if (item.StepId === 8 || (0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        hasCursor = ' hasDefaultCursor';
	      }
	      if ( /* this.state.item.StepId >= 7 && */!item.IsDeliveryDateChanged && !(0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        translationText = (0, _helpers.translation)('193');
	        if (item.StepId >= 7) {
	          translationText = (0, _helpers.translation)('12');
	        }
	        translationText += ' ' + (0, _time.renderFullDate)(showBodyTime ? item.BodyShopDeliveryTime : item.Delivery);
	      }
	      var renderTime = function renderTime() {
	        var iswp = (0, _auth.hasAccess)([6], _this3.props.auth.user.UserType);
	        var showDateAndTime = !iswp;
	        if ( /* this.state.item.StepId >= 7 && */!(0, _auth.hasAccess)([4], _this3.props.auth.user.UserType)) return (0, _time.renderFullDate)(showBodyTime ? item.BodyShopDeliveryTime : item.Delivery, showDateAndTime);
	        return _this3.renderTime(showBodyTime ? item.BodyShopDeliveryTime : item.Delivery);
	      };
	      if (!item.IsDraft && (0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        classList += ' mobileTime';
	        return _react2.default.createElement(
	          'div',
	          { className: 'times' },
	          item.Delivery && _react2.default.createElement('img', { src: '/images/svgs/listheader/Handsover-New.svg' }),
	          ((0, _auth.hasSubscriptionPermission)(this.props.auth, 0) || !showBodyTime && (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 0)) && _react2.default.createElement(
	            'span',
	            { className: classList + hasCursor, 'aria-label': translationText },
	            renderTime()
	          )
	        );
	      }
	
	      var canChange = (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 13) || item.StepId === 8;
	      var renderActionOpener = function renderActionOpener(opener) {
	        var onClick = function onClick(e) {
	          e.preventDefault();
	          _this3.props.clearLastVisitedOrderId();
	          opener(e);
	        };
	
	        classList += ' mobileTime';
	        return _react2.default.createElement(
	          'div',
	          { className: canChange ? 'hasCursor' : '', onClick: onClick },
	          _react2.default.createElement('img', { src: '/images/svgs/listheader/Handsover-New.svg' }),
	          ((0, _auth.hasSubscriptionPermission)(_this3.props.auth, 10) || !showBodyTime && (0, _auth.hasPartnerSubscriptionPermission)(_this3.props.auth, 10)) && _react2.default.createElement(
	            'span',
	            { className: classList + hasCursor, 'aria-label': translationText },
	            renderTime()
	          )
	        );
	      };
	      var renderActionMenu = function renderActionMenu(triggerOpen) {
	        if (!canChange) return null;
	        return _react2.default.createElement(_DateActions2.default, { item: item, orderId: item.Id, location: 'orderlist', onSuccess: triggerOpen });
	      };
	      return _react2.default.createElement(_DateChangePopup2.default, { selfClick: true, className: function className() {
	          return 'datechangepopup times' + hasCursor;
	        }, renderActionOpener: renderActionOpener, renderActionMenu: renderActionMenu });
	    }
	  }, {
	    key: 'deleteOrderIndex',
	    value: function deleteOrderIndex(step, index) {
	      // For some reason the IsDeleted flag is not always set, this should fix that.
	      if (this.state.item !== undefined && this.state.item !== null && !this.state.item.IsDeleted) {
	        this.setState({
	          item: _extends({}, this.state.item, {
	            IsDeleted: true
	          })
	        });
	      }
	    }
	
	    // approveForInvoice (undo) {
	    //   this.props.approveOrderInvoice(this.state.item.Id, undo).then((res) => {
	    //     let item = { ...this.state.item }
	    //     item.ReadyForInvoice = res.data.ReadyForInvoice
	    //     this.updateOrder(item)
	    //   })
	    // }
	    // <div className='divider' key='1' />,
	
	  }, {
	    key: 'renderInvoice',
	    value: function renderInvoice(invoiceItem) {
	      var _this4 = this;
	
	      var isDuplicate = invoiceItem.OrderKey !== undefined && invoiceItem.OrderKey !== null && invoiceItem.OrderKey.endsWith('_LoosePart');
	      if (isDuplicate) {
	        return _react2.default.createElement('div', { className: 'invoice', key: '2' });
	      }
	      // console.log('invoice item ', invoiceItem)
	      // Default not ready for invoice
	      if (invoiceItem.IsDraft || invoiceItem.IsWrecked) {
	        var setCustomer = this.renderSetNewCustomer(invoiceItem);
	        return [!invoiceItem.IsWrecked && _react2.default.createElement('div', { className: 'divider', key: '1' }), _react2.default.createElement(
	          'div',
	          { className: 'invoice', key: '2' },
	          setCustomer !== null ? setCustomer : _react2.default.createElement('span', { className: 'icon' })
	        )];
	      }
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	        return [_react2.default.createElement('div', { className: 'divider', key: '1' }), _react2.default.createElement('div', { className: 'invoice noclick', key: '2' })];
	      }
	      if (this.state.showSpinner.invoicing === true) {
	        return [_react2.default.createElement('div', { className: 'divider', key: '1' }), _react2.default.createElement(
	          'div',
	          { className: 'invoice', key: '2' },
	          _react2.default.createElement(
	            'span',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	          )
	        )];
	      }
	
	      // Do not allow invoicing referred out orders
	      if (invoiceItem.IsReferredOut && invoiceItem.OrderConnection !== undefined && invoiceItem.OrderConnection !== null) {
	        if (invoiceItem.OrderConnection.MoveType !== undefined && invoiceItem.OrderConnection.MoveType !== null && invoiceItem.OrderConnection.MoveType === 1) {
	          var referredName = invoiceItem.OrderConnection.TransferedToCompanyName;
	          if (invoiceItem.OrderConnection.TransferedToCompanyName === undefined || invoiceItem.OrderConnection.TransferedToCompanyName === null) {
	            referredName = '';
	          }
	          var referText = (0, _helpers.translation)('729') + ' ' + referredName;
	          return _react2.default.createElement(
	            'div',
	            { className: 'invoice', key: '2' },
	            _react2.default.createElement(_helpIcon2.default, { altIcon: _icons.GeneralIcons.Info_Circle_Grey, helpText: referText, size: 's' })
	          );
	        }
	      }
	      var iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var image = 'Total_price.svg';
	      var showBubbleText = (0, _helpers.translation)('13509');
	
	      // Ready for invoice
	      if (!iswp && invoiceItem.ReadyForInvoice + '' === '1' || iswp && invoiceItem.ReadyForInvoiceByWP) {
	        image = 'ready-for-invoice.svg';
	        showBubbleText = (0, _helpers.translation)('1139');
	
	        // Invoice status reset
	        if (invoiceItem.InvoiceStatusIsResat) {
	          // if it is resat and approved
	          image = 'approved-for-invoicing_reset.svg';
	          showBubbleText = (0, _helpers.translation)('15003');
	        }
	      } else {
	        // Invoice status reset
	        if (invoiceItem.InvoiceStatusIsResat) {
	          // if it is resat and not approved
	          image = 'reset-invoising.svg';
	          showBubbleText = (0, _helpers.translation)('15006');
	        }
	      }
	      if (invoiceItem.IsMarkInvoiced) {
	        // (!iswp && invoiceItem.IsMarkInvoiced) || (iswp && invoiceItem.IsMarkInvoicedByWP)) {
	        image = 'billed-not-posted.svg';
	        showBubbleText = (0, _helpers.translation)('13510');
	      }
	      if (invoiceItem.IsInvoiced && !invoiceItem.IsMarkInvoiced) {
	        // (!iswp && invoiceItem.IsInvoiced && !invoiceItem.IsMarkInvoiced) || (iswp && invoiceItem.IsInvoicedByWP && !invoiceItem.IsMarkInvoicedByWP)) {
	        image = 'posted-not-billed.svg';
	        showBubbleText = (0, _helpers.translation)('13511');
	      }
	      if (invoiceItem.HasInvoiceError) {
	        image = 'ready-for-invoice_notication.svg';
	
	        switch (invoiceItem.InvoiceError) {
	          case 0:
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('13700');
	            break;
	          case 1:
	            // OrderNotFound = 1,
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('13701');
	            break;
	          case 2:
	            // CompanyNotFound = 2,
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('13702');
	            break;
	          case 3:
	            // NotValidEconomicCredentials = 3,
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('13703');
	            break;
	          case 4:
	            // NotValidHeliosNumber = 4,
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('13704');
	            break;
	          case 5:
	            // NotValidC5UserPass = 5,
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('13705');
	            break;
	          case 6:
	            // OrderIsAlreadySent = 6,
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('13706');
	            break;
	          case 7:
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('13707');
	            break;
	          case 8:
	            // AwaitingPriceApproval = 8
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('2710');
	            break;
	          case 9:
	            showBubbleText = (0, _helpers.translation)('1139') + ' \u2013 ' + (0, _helpers.translation)('14851');
	            break;
	          default:
	            showBubbleText = (0, _helpers.translation)('1139');
	        }
	      }
	
	      // Is invoiced and marked
	      if (invoiceItem.IsInvoiced && invoiceItem.IsMarkInvoiced && !invoiceItem.InvoiceStatusIsResat) {
	        // (!iswp && invoiceItem.IsInvoiced && invoiceItem.IsMarkInvoiced) || (iswp && invoiceItem.IsInvoicedByWP && invoiceItem.IsMarkInvoicedByWP)) {
	        image = 'Payment-ok.svg';
	        showBubbleText = (0, _helpers.translation)('13512');
	        // Return
	        return [_react2.default.createElement(
	          'div',
	          { className: 'invoice', key: '2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--left', 'aria-label': showBubbleText },
	            _react2.default.createElement('img', { src: '/images/svgs/invoice/' + image, className: 'icon' })
	          )
	        )];
	      }
	
	      var stoppedOnClick = function stoppedOnClick(message) {
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      };
	
	      var dracarSettings = void 0;
	
	      // Should be moved to backend, when invoice component gets reworked
	      if (this.props.auth.permissions.DracarUsable) {
	        dracarSettings = {
	          dracarNonMatchesFound: invoiceItem.DracarNonMatchingPartsExists,
	          dracarOrderSet: invoiceItem.DracarRepairOrderSet,
	          dracarActive: this.props.auth.permissions.DracarAllowed,
	          isDracarOtherOrder: !_constants.DracarAllowOrderTypes.includes(invoiceItem.OrderType), // other orderType order when using Dracar
	          isRpReport: invoiceItem.ReportType === 2
	        };
	      }
	
	      // Overlay
	      var renderActionMenu = function renderActionMenu(close) {
	        return _react2.default.createElement(_InvoicePopup2.default, {
	          item: invoiceItem,
	          updateOrder: _this4.updateOrder,
	          close: close,
	          showSpinner: _this4.showSpinner,
	          dracarSettings: dracarSettings });
	      };
	      var renderActionOpener = function renderActionOpener(opener) {
	        var openerAction = opener;
	        if (!(0, _auth.hasSubscriptionPermission)(_this4.props.auth, 10, [6, 30]) || !(0, _auth.hasSubscriptionPermission)(_this4.props.auth, 10, 30) && !(!iswp && invoiceItem.ReadyForInvoice + '' === '1' || iswp && invoiceItem.ReadyForInvoiceByWP)) {
	          openerAction = function openerAction() {};
	        }
	        if (invoiceItem.IsStopped) {
	          var errorMsg = (0, _helpers.translation)('15041') + ': ' + invoiceItem.StoppedMessage;
	          openerAction = stoppedOnClick.bind(_this4, errorMsg);
	        }
	
	        var onClick = function onClick(e) {
	          _this4.props.clearLastVisitedOrderId();
	          openerAction(e);
	        };
	
	        return [_react2.default.createElement(
	          'div',
	          { className: 'invoice', key: '2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--left', 'aria-label': showBubbleText },
	            _react2.default.createElement('img', { src: '/images/svgs/invoice/' + image, className: 'icon hasCursor', onClick: onClick })
	          )
	        )];
	      };
	      return _react2.default.createElement(_Overlay2.default, { renderActionMenu: renderActionMenu, renderActionOpener: renderActionOpener, checkForPopups: this.props.checkForPopups });
	    }
	  }, {
	    key: 'renderShowInvoice',
	    value: function renderShowInvoice(invoiceitem) {
	      var _this5 = this;
	
	      var shownData = '';
	      // let shownData2 = ''
	      var MyClassNames = '';
	      // let dasLink = '/orders/' + invoiceitem.Id
	      if (invoiceitem.RekvNumber) {
	        shownData = invoiceitem.RekvNumber;
	        MyClassNames = 'iconNumber';
	        if (shownData.length > 7) {
	          // shownData2 = shownData.substring(0, 7) + '...'
	        }
	      } else {
	        shownData = (0, _helpers.translation)('13024');
	        // MyClassNames = 'iconNumber fadeIconNumber'
	      }
	
	      // Overlay
	      var renderActionMenu = function renderActionMenu() {
	        return _react2.default.createElement(_RekvNumber2.default, { id: invoiceitem.Id, item: invoiceitem, updateOrder: _this5.updateOrder });
	      };
	      var renderActionOpener = function renderActionOpener(opener) {
	        var onClick = function onClick(e) {
	          _this5.props.clearLastVisitedOrderId();
	          opener(e);
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'reknumber hint--right', key: '2', 'aria-label': shownData },
	          _react2.default.createElement(
	            'span',
	            { className: MyClassNames, onClick: onClick },
	            _react2.default.createElement('img', { src: '/images/svgs/ordrer/Requisition_No.svg' })
	          )
	        );
	      };
	      return _react2.default.createElement(_Overlay2.default, { renderActionMenu: renderActionMenu, renderActionOpener: renderActionOpener, key: Math.random(), checkForPopups: this.props.checkForPopups });
	    }
	  }, {
	    key: 'renderSetNewCustomer',
	    value: function renderSetNewCustomer(item) {
	      var _this6 = this;
	
	      var allowNoCustomer = this.props.auth.allowNoCustomer;
	
	
	      if (item.CustomerSelect !== 1 || item.OrderDepartment === 0 || item.ForsiReportId === null && !allowNoCustomer || item.ForsiReportId === '' && !allowNoCustomer) {
	        return null;
	      }
	      if (this.props.auth.departmentType !== 1) return null;
	
	      // Overlay
	      var renderActionMenu = function renderActionMenu(close) {
	        return _react2.default.createElement(_SetCustomer2.default, { id: item.Id, item: item, updateOrder: _this6.updateOrder, close: close });
	      };
	      var renderActionOpener = function renderActionOpener(opener) {
	        var onClick = function onClick(e) {
	          _this6.props.clearLastVisitedOrderId();
	          opener(e);
	        };
	        var image = '/images/svgs/stop-customer.svg';
	        return _react2.default.createElement(
	          'div',
	          { className: 'hint--left', 'aria-label': (0, _helpers.translation)('2259') },
	          _react2.default.createElement(
	            'span',
	            { className: '', onClick: onClick },
	            _react2.default.createElement('img', { src: image, className: 'icon hasCursor' })
	          )
	        );
	      };
	      return _react2.default.createElement(_Overlay2.default, { renderActionMenu: renderActionMenu, renderActionOpener: renderActionOpener, key: Math.random(), checkForPopups: this.props.checkForPopups });
	    }
	  }, {
	    key: 'renderNotes',
	    value: function renderNotes(noteItem) {
	      var _this7 = this;
	
	      var icon = void 0;
	      // if order does not have notes from customer or shop
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 0) || !noteItem.HasNotes) return _react2.default.createElement('div', { className: 'icon' });
	      // if order has unread notes
	      if (noteItem.UnreadNotes !== 0) {
	        var browserClass = '';
	        if (this.state.isFireFox) {
	          browserClass = ' FireFox';
	        } else if (this.state.isEdge) {
	          browserClass = ' Edge';
	        } else if (this.state.isIExplorer) {
	          browserClass = ' IExplorer';
	        }
	
	        // Should trigger popup when clicked on
	        icon = _react2.default.createElement(
	          'span',
	          { className: 'hasTextInBubble hasTextInBubbleNotes' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--left', 'aria-label': (0, _helpers.translation)('2339') },
	            _react2.default.createElement('img', { src: '/images/svgs/comment/comment-red-circle.svg', className: 'icon hasCursor' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: browserClass },
	            noteItem.UnreadNotes
	          )
	        );
	      } else {
	        // Default
	        icon = _react2.default.createElement(
	          'div',
	          { className: 'hint--left', 'aria-label': (0, _helpers.translation)('149') },
	          _react2.default.createElement('img', { src: '/images/svgs/comment/comment-new.svg', className: 'icon hasCursor' })
	        );
	      }
	
	      // Overlay
	      var renderActionMenu = function renderActionMenu() {
	        return _react2.default.createElement(_Notes2.default, { id: noteItem.Id, updateOrder: _this7.updateOrder, checkForPopups: _this7.props.checkForPopups });
	      };
	      var renderActionOpener = function renderActionOpener(opener) {
	        var onClick = function onClick(e) {
	          _this7.props.clearLastVisitedOrderId();
	          opener(e);
	        };
	        return _react2.default.createElement(
	          'span',
	          { onClick: onClick },
	          icon
	        );
	      };
	      var openClick = function openClick(open) {
	        /*       if (open) {
	                if (!noteItem.isLinkMain && noteItem.LinkedOrders.length === 0 && this.state.item.LinkedOrders.length > 0) {
	                  this.state.item.LinkedOrders.filter(e => noteItem.Id === e.Id)[0].UnreadNotes = 0
	                } else {
	                  this.setState({
	                    item: {
	                      ...this.state.item,
	                      UnreadNotes: 0
	                    }
	                  })
	                }
	                this.updateOrder(this.state.item)
	              } */
	      };
	      return _react2.default.createElement(_Overlay2.default, { renderActionMenu: renderActionMenu, renderActionOpener: renderActionOpener, openClick: openClick, checkForPopups: this.props.checkForPopups });
	    }
	  }, {
	    key: 'renderMissingPart',
	    value: function renderMissingPart(partItem) {
	      var _this8 = this;
	
	      var icon = void 0;
	      if (!partItem.MissingParts) return _react2.default.createElement('div', { className: 'icon' });
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var message = (0, _helpers.translation)('13520');
	      if (partItem.MissingPartsMessage) {
	        message += ':\n' + partItem.MissingPartsMessage;
	      }
	      var onClick = function onClick() {
	        if (isCustomer) {
	          _this8.setState({
	            showTxt: !_this8.state.showTxt
	          });
	          return null;
	        }
	        _this8.props.router.push('/orders/' + partItem.Id + '/orderinspection');
	      };
	
	      var popup = function popup() {
	        if (isCustomer !== true || _this8.state.showTxt === false || !partItem.MissingPartsMessage) return null;
	        console.log('partItem.MissingPartsMessage: ', partItem.MissingPartsMessage);
	        return _react2.default.createElement(
	          'div',
	          { className: 'poppedup padding InfoPopup' },
	          _react2.default.createElement(
	            'label',
	            null,
	            partItem.MissingPartsMessage
	          )
	        );
	      };
	
	      var cName = 'icon missingparticon ' + (isCustomer && !partItem.MissingPartsMessage ? '' : 'hasCursor');
	      icon = _react2.default.createElement(
	        'div',
	        { className: 'hint--left', 'aria-label': message },
	        _react2.default.createElement('img', { src: '/images/svgs/missing-parts/missing-parts.svg', className: cName, onClick: onClick }),
	        popup()
	      );
	      // Overlay
	      var renderActionMenu = function renderActionMenu() {
	        return _react2.default.createElement(_Notes2.default, { id: partItem.Id, updateOrder: _this8.updateOrder });
	      };
	      var renderActionOpener = function renderActionOpener(opener) {
	        var onClick = function onClick(e) {
	          _this8.props.clearLastVisitedOrderId();
	          opener(e);
	        };
	        return _react2.default.createElement(
	          'span',
	          { onClick: onClick },
	          icon
	        );
	      };
	      var openClick = function openClick(open) {};
	      return _react2.default.createElement(_Overlay2.default, { renderActionMenu: renderActionMenu, renderActionOpener: renderActionOpener, openClick: openClick, checkForPopups: this.props.checkForPopups });
	    }
	  }, {
	    key: 'renderColor',
	    value: function renderColor(colorItem) {
	      var _this9 = this;
	
	      var image = 'Color-no-info-grey-VS.svg';
	      var openImg = null;
	      var showBubbleText = (0, _helpers.translation)('13603');
	
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        if (colorItem.ColorCode !== null && colorItem.ColorCode !== '') {
	          image = 'Color_code.svg';
	          showBubbleText = (0, _helpers.translation)('79');
	        } else if (colorItem.Color !== null && colorItem.Color !== '') {
	          image = 'Color.svg';
	          showBubbleText = (0, _helpers.translation)('179');
	        }
	      } else {
	        if (colorItem.ColorIsReady) {
	          image = 'Color-ok.svg';
	          showBubbleText = (0, _helpers.translation)('13393');
	        } else if (colorItem.ColorVariant !== null && colorItem.ColorVariant !== '') {
	          image = 'color-variation.svg';
	          showBubbleText = (0, _helpers.translation)('13388');
	        } else if (colorItem.ColorCode !== null && colorItem.ColorCode !== '') {
	          image = 'Color_code.svg';
	          showBubbleText = (0, _helpers.translation)('79');
	        } else if (colorItem.Color !== null && colorItem.Color !== '') {
	          image = 'Color.svg';
	          showBubbleText = (0, _helpers.translation)('179');
	        }
	      }
	
	      openImg = _react2.default.createElement(
	        'div',
	        { className: 'hint--left', 'aria-label': showBubbleText },
	        _react2.default.createElement('img', { src: '/images/svgs/color/' + image, className: 'icon hasCursor' })
	      );
	      if (image === null) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { className: 'icon' })
	        );
	      } else {
	        // Overlay
	        var renderActionMenu = function renderActionMenu() {
	          return _react2.default.createElement(_Color2.default, { id: colorItem.Id, item: colorItem, updateOrder: _this9.updateOrder, checkForPopups: _this9.props.checkForPopups });
	        };
	        var renderActionOpener = function renderActionOpener(opener) {
	          var onClick = function onClick(e) {
	            _this9.props.clearLastVisitedOrderId();
	            opener(e);
	          };
	          return _react2.default.createElement(
	            'span',
	            { onClick: onClick },
	            openImg
	          );
	        };
	        return _react2.default.createElement(_Overlay2.default, { renderActionMenu: renderActionMenu, renderActionOpener: renderActionOpener, checkForPopups: this.props.checkForPopups });
	      }
	    }
	  }, {
	    key: 'openAssign',
	    value: function openAssign(type) {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      if (!(0, _auth.hasAccessToAssign)(this.props.auth)) return null;
	      if (type) {
	        _events2.default.emit('OPEN_ASSIGNBOX');
	        this.getAssignOrderData();
	      }
	      this.setState({
	        assign_open: type
	      });
	      this.props.toggleAssign(type);
	    }
	  }, {
	    key: 'getAssignOrderData',
	    value: function getAssignOrderData(activeEmployees) {
	      // Get assign order data
	      this.props.getOrderDataNew({
	        OrderIds: [this.state.item.Id],
	        UserIds: activeEmployees || this.props.activeEmployees
	      });
	    }
	  }, {
	    key: 'onAssignUsers',
	    value: function onAssignUsers() {
	      var _this10 = this;
	
	      this.refs.AssignBox.getWrappedInstance().getAssignEmployees();
	      var searchData = {
	        SimpleSearch: this.state.item.Id + '',
	        SkipCheck: true
	      };
	      this.props.getOrdersNew(searchData).then(function (res) {
	        var order = res.data[0].Steps[_this10.props.step].Orders[0];
	        _this10.updateOrder(order);
	      });
	    }
	  }, {
	    key: 'unlockOrder',
	    value: function unlockOrder() {
	      var data = {
	        dataset: {
	          action: 'stopLockOrder'
	        }
	      };
	      this.refs.OrderActions.getWrappedInstance().handleClick(data);
	    }
	  }, {
	    key: 'startOrderSuccess',
	    value: function startOrderSuccess(data) {
	      this.props.triggerPopup(false);
	      this.setState({
	        stopOtherOrders: _extends({}, this.state.stopOtherOrders, {
	          WorkOnAll: null
	        })
	      });
	
	      var item = _extends({}, this.state.item);
	      item.IsStarted = true;
	      item.IsCurrentUserWorking = true;
	      item.PreviouslyStarted = true;
	      this.setState({
	        item: item
	      });
	      if (typeof this.props.startOrderSuccess !== 'undefined') {
	        this.props.startOrderSuccess(item);
	      }
	    }
	  }, {
	    key: 'startOrder',
	    value: function startOrder() {
	      var _this11 = this;
	
	      if ((0, _auth.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	        if (typeof this.props.onStartAsShopLogin !== 'undefined') {
	          var top = 500;
	          // let steps = document.getElementsByClassName('drag-content scrollbar')
	          // for (let i = 0; i < steps.length; i++) {
	          //   if (steps[i].dataset.pos === '' + this.props.step) {
	          //     top = steps[i].scrollTop
	          //   }
	          // }
	
	          this.props.onStartAsShopLogin({
	            type: 'start',
	            id: this.state.item.Id,
	            scrollOffset: top,
	            step: this.props.step
	          });
	          // this.props.setSelectedItem(this.state.item)
	          return false;
	        }
	      }
	
	      var item = this.state.item;
	
	      var data = {
	        Orders: [{
	          OrderId: item.Id,
	          WarrantyCode: null,
	          PaintThickness: null
	        }],
	        UserIds: [],
	        WorkOnAll: this.state.stopOtherOrders.WorkOnAll,
	        CheckOnly: false,
	        ConfirmStart: true
	      };
	
	      this.props.startOrder(data).then(function (res) {
	        if (res.data.StopOtherOrders === true) {
	          _this11.props.triggerPopup(true);
	          _this11.setState({
	            stopOtherOrders: _extends({}, _this11.state.stopOtherOrders, {
	              open: true,
	              WorkOnAll: null
	            })
	          });
	        } else if (res.data.length > 0 && _this11.stepHasFailedStartChecks(res.data) || _this11.stepHasComments(res.data)) {
	          // if (res.data.length > 0 || this.stepHasComments(res.data)) {
	          _this11.props.triggerPopup(true);
	          _this11.setState({
	            quality: {
	              open: true,
	              data: {
	                res: res.data,
	                WorkOnAll: _this11.state.stopOtherOrders.WorkOnAll,
	                UserIds: []
	              },
	              move: false
	            }
	          });
	        }
	        // else {
	        // window.toastr.success(translation('13518'), translation('13424'))
	        _this11.startOrderSuccess(res.data[0]);
	        // }
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1923'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'stopOrder',
	    value: function stopOrder() {
	      var _this12 = this;
	
	      if ((0, _auth.hasAccess)([5, 7], this.props.auth.user.UserType)) {
	        if (typeof this.props.onStartAsShopLogin !== 'undefined') {
	          this.props.onStartAsShopLogin({
	            type: 'stop',
	            id: this.state.item.Id
	          });
	          return false;
	        }
	      }
	
	      var item = this.state.item;
	
	      var data = {
	        OrderId: item.Id,
	        UserId: 0,
	        StopAll: this.state.stopOrders.StopAll
	      };
	
	      this.props.stopOrder(data).then(function (res) {
	        if (res.data.StopAll === true) {
	          _this12.props.triggerPopup(true);
	          _this12.setState({
	            stopOrders: _extends({}, _this12.state.stopOrders, {
	              open: true,
	              StopAll: null
	            })
	          });
	        } else {
	          var _item = res.data;
	          _this12.setState({
	            item: _item
	          });
	          clearTimeout(_this12.updateTime);
	
	          // let message = this.state.stopOrders.StopAll === true ? translation('12340') : translation('15042')
	          // window.toastr.success(message, translation('13424'))
	
	          _this12.setState({
	            stopOrders: _extends({}, _this12.state.stopOrders, {
	              StopAll: null
	            })
	          });
	        }
	      }, function () {
	        var message = _this12.state.stopOrders.StopAll === true ? (0, _helpers.translation)('12342') : (0, _helpers.translation)('12343');
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'AllOrders',
	    value: function AllOrders(type) {
	      var _this13 = this;
	
	      this.props.triggerPopup(false);
	      if (type === 'stopOtherOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          WorkOnAll: true
	        })), function () {
	          _this13.startOrder();
	        });
	      } else if (type === 'stopOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          StopAll: true
	        })), function () {
	          _this13.stopOrder();
	        });
	      } else if (type === 'MoveOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          MoveAll: true
	        })), function () {
	          _this13.moveOrders();
	        });
	      }
	    }
	  }, {
	    key: 'NotAllOrders',
	    value: function NotAllOrders(type) {
	      var _this14 = this;
	
	      this.props.triggerPopup(false);
	      if (type === 'stopOtherOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          WorkOnAll: false
	        })), function () {
	          _this14.startOrder();
	        });
	      } else if (type === 'stopOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          StopAll: false
	        })), function () {
	          _this14.stopOrder();
	        });
	      } else if (type === 'MoveOrders') {
	        this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	          open: false,
	          MoveAll: false
	        })), function () {
	          _this14.moveOrders();
	        });
	      }
	    }
	  }, {
	    key: 'setStopped',
	    value: function setStopped() {
	      this.setState({
	        stopped: _extends({}, this.state.stopped, { open: true
	        })
	      });
	      document.addEventListener('click', this.togglePortal, false);
	    }
	  }, {
	    key: 'renderCircle',
	    value: function renderCircle(circleItem) {
	      // return this.renderWorkproviderPriceMatch()
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      if (iswp || isCustomer || this.state.item.IsDraft) {
	        if (!iswp && circleItem.IsStopped) {
	          return _react2.default.createElement(_Circle2.default, { onPopupOpen: this.props.clearLastVisitedOrderId, router: this.props.router, IsCustomer: isCustomer, item: circleItem, checkForPopups: this.props.checkForPopups, onStartAsShopLogin: this.props.onStartAsShopLogin });
	        }
	      } else {
	        return _react2.default.createElement(_Circle2.default, { router: this.props.router,
	          unlockOrder: this.unlockOrder,
	          setStopped: this.setStopped,
	          startOrder: this.startOrder,
	          stopOrder: this.stopOrder,
	          item: circleItem,
	          updateOrder: this.updateOrder,
	          onStartAsShopLogin: this.props.onStartAsShopLogin,
	          moveOrders: this.moveOrders,
	          openStartStopId: this.props.openStartStopId,
	          hasOpendStatrStop: this.props.hasOpendStatrStop,
	          onPopupOpen: this.props.clearLastVisitedOrderId });
	      }
	      if (iswp) {
	        return this.renderWorkproviderPriceMatch();
	      }
	    }
	  }, {
	    key: 'renderWorkproviderPriceMatch',
	    value: function renderWorkproviderPriceMatch() {
	      var _this15 = this;
	
	      var item = this.state.item;
	      // if (item.WpEconomicMatchType === null) return null
	      var showCheckMark = true;
	      var handleClass = 'economic_pricematch';
	      var perc = '';
	      switch (item.WpEconomicMatchType) {
	        case 0:
	          if (item.WpEconomicMatchPerc !== null && item.WpEconomicMatchPerc !== 0) {
	            // show percentage with Red color
	            showCheckMark = false;
	            handleClass += ' unhandled';
	            perc = item.WpEconomicMatchPerc + '%';
	          } else {
	            // show checked mark
	            showCheckMark = true;
	            handleClass += ' unhandled';
	          }
	          break;
	        case 1:
	          if (item.WpEconomicMatchPerc !== null && item.WpEconomicMatchPerc !== 0) {
	            // show percentage with Green color
	            showCheckMark = false;
	            handleClass += ' handled';
	            perc = item.WpEconomicMatchPerc + '%';
	          } else {
	            // show checked mark
	            showCheckMark = true;
	            handleClass += ' handled';
	          }
	          break;
	        case 2:
	          showCheckMark = false;
	          handleClass += ' unhandled';
	          perc = '-%';
	          break;
	      }
	      var renderInvoiceLog = function renderInvoiceLog() {
	        return _react2.default.createElement(_InvoiceLog2.default, { item: item });
	      };
	      if (item.WpEconomicMatchType === null) showCheckMark = false;
	      var renderActionOpener = function renderActionOpener(opener) {
	        var onClick = function onClick(e) {
	          _this15.props.clearLastVisitedOrderId();
	          opener(e);
	        };
	        return _react2.default.createElement(
	          'div',
	          { onClick: onClick, className: handleClass },
	          showCheckMark && _react2.default.createElement('img', { src: '/images/icons/Green_chekmark.png' }),
	          !showCheckMark && perc,
	          item.WpEconomicMatchType === null && _react2.default.createElement('img', { src: '/images/svgs/invoicelog/payment-notification.svg' })
	        );
	      };
	      return _react2.default.createElement(_Overlay2.default, { renderActionMenu: renderInvoiceLog, renderActionOpener: renderActionOpener, checkForPopups: this.props.checkForPopups });
	    }
	  }, {
	    key: 'renderPaintBodyStatus',
	    value: function renderPaintBodyStatus(item) {
	      var paintLit = false;
	      var bodyLit = false;
	
	      var paintBooked = false;
	      var bodyBooked = false;
	
	      var paintOrdered = false;
	      var bodyOrdered = false;
	
	      var paintNotOrdered = false;
	      var bodyNotOrdered = false;
	
	      var paintTextItems = [];
	      var bodyTextItems = [];
	      var overallTextItems = [];
	
	      // Order shown as PaintShop, BodyShop or CombinedShop
	      if (item.OrderDepartment === 0 || item.OrderDepartment === 1 || item.OrderDepartment === 2) {
	        paintLit = item.IsPaintOrder;
	        paintBooked = !item.PaintIsDraft;
	        if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	          paintOrdered = item.HasSpareParts && item.PaintSparePartStatusSum === 8;
	          paintNotOrdered = item.HasSpareParts && item.PaintSparePartStatusSum === 1;
	        }
	      }
	
	      // Order shown as BodyShop or CombinedShop
	      if (item.OrderDepartment === 1 || item.OrderDepartment === 2) {
	        bodyLit = item.IsBodyShopOrder;
	        bodyBooked = !item.BodyShopIsDraft;
	        if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	          bodyOrdered = item.HasSpareParts && item.BodySparePartStatusSum === 8;
	          bodyNotOrdered = item.HasSpareParts && item.BodySparePartStatusSum === 1;
	        }
	      }
	
	      var image = 'show-work';
	      var imageVert = 'show-work';
	      var imgPath = '/images/svgs/orderlist/';
	
	      // Check for paint/body work
	      if (paintLit) {
	        image += '_paint-lit';
	        paintTextItems.push((0, _helpers.translation)('14829'));
	      }
	      if (bodyLit) {
	        image += '_body-lit';
	        bodyTextItems.push((0, _helpers.translation)('14830'));
	      }
	
	      if (paintLit && bodyLit) {
	        overallTextItems.push((0, _helpers.translation)('14867'));
	      }
	
	      // Check for paint/body booked
	      if (paintLit && !paintBooked) {
	        image += '_paint-red';
	        paintTextItems.push((0, _helpers.translation)('13045'));
	      } else if (paintNotOrdered && !paintOrdered) {
	        image += '_paint-red';
	      } else if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && paintNotOrdered) {
	        image += '_paint-red';
	        // Check for paint/body spare parts ordered
	      } else if (paintOrdered && !paintNotOrdered) {
	        image += '_paint-yellow';
	      }
	
	      if (bodyLit && !bodyBooked) {
	        image += '_body-red';
	        bodyTextItems.push((0, _helpers.translation)('13046'));
	      } else if (bodyLit && bodyBooked && bodyNotOrdered && !bodyOrdered) {
	        image += '_body-red';
	      } else if (bodyLit && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && bodyNotOrdered) {
	        image += '_body-red';
	      }
	
	      if (bodyLit && bodyBooked && bodyOrdered && !bodyNotOrdered) {
	        image += '_body-yellow';
	      }
	
	      var imgClass = 'PaintBodyStatus flat';
	      // if (!image.includes('red') && !image.includes('yellow')) {
	      //   imgClass = ' PaintBodyStatus__padding'
	      // }
	
	      if (item.HasSpareParts === true && item.BodySparePartStatusSum !== 0 && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	        // Body spare parts not ordered
	        if (item.BodySparePartStatusSum === 1) {
	          bodyTextItems.push((0, _helpers.translation)('13048'));
	        }
	
	        // Body spare parts not received
	        if (item.BodySparePartStatusSum === 8) {
	          bodyTextItems.push((0, _helpers.translation)('13050'));
	        }
	
	        // Body spare parts received
	        if (item.BodySparePartStatusSum === 16) {
	          bodyTextItems.push((0, _helpers.translation)('14870'));
	        }
	      }
	
	      if (item.HasSpareParts === true && item.PaintSparePartStatusSum !== 0 && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	        // Paint spare parts not ordered
	        if (item.PaintSparePartStatusSum === 1) {
	          if (bodyLit) {
	            paintTextItems.push((0, _helpers.translation)('13047'));
	          } else {
	            paintTextItems.push((0, _helpers.translation)('638'));
	          }
	        }
	
	        // Paint spare parts not received
	        if (item.PaintSparePartStatusSum === 8) {
	          if (bodyLit) {
	            paintTextItems.push((0, _helpers.translation)('13049'));
	          } else {
	            paintTextItems.push((0, _helpers.translation)('639'));
	          }
	        }
	
	        // Paint spare parts received
	        if (item.PaintSparePartStatusSum === 16) {
	          if (bodyLit) {
	            paintTextItems.push((0, _helpers.translation)('14872'));
	          } else {
	            paintTextItems.push((0, _helpers.translation)('640'));
	          }
	        }
	      }
	
	      /*
	        if (paintNotOrdered && !paintOrdered) {
	        paintTextItems.push(translation('13047'))
	      }
	      if (bodyNotOrdered && !bodyOrdered) {
	        bodyTextItems.push(translation('13048'))
	      }
	      if (paintOrdered && !paintNotOrdered) {
	        paintTextItems.push(translation('13049'))
	      }
	      if (bodyOrdered && !bodyNotOrdered) {
	        bodyTextItems.push(translation('13050'))
	      }
	        */
	      imageVert = image + '-vertical';
	      imageVert += '.svg';
	      image += '.svg';
	
	      var lines = [];
	      var hoverHoverTextLines = function hoverHoverTextLines(val, key) {
	        if (key === 0) {
	          if (lines.length > 0) {
	            lines.push(_react2.default.createElement('p', { key: item.Id + '_' + Math.random() + '_' + Math.random() }));
	          }
	        }
	        lines.push(_react2.default.createElement(
	          'p',
	          { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	          val
	        ));
	      };
	
	      var addOverallText = function addOverallText(val, key) {
	        if (key !== 0) {
	          overallTextItems.push(val);
	        }
	      };
	
	      if (paintLit && bodyLit) {
	        paintTextItems.map(addOverallText);
	        bodyTextItems.map(addOverallText);
	
	        overallTextItems.map(hoverHoverTextLines);
	      } else {
	        paintTextItems.map(hoverHoverTextLines);
	        bodyTextItems.map(hoverHoverTextLines);
	      }
	      var useClick = true;
	      var useHover = true;
	
	      if (lines.length === 0) {
	        lines = (0, _helpers.translation)('14856');
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'fullSize orderStatus' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _HoverPopup2.default,
	            { UseClick: useClick, UseHover: useHover, orderId: item.Id, getVerticalScrollOffset: this.getVerticalScrollOffset, getHorizontalScrollOffset: this.getHorizontalScrollOffset, scrollColumn: this.props.step, PopupContent: lines },
	            _react2.default.createElement('img', { src: imgPath + image, className: imgClass }),
	            _react2.default.createElement('img', { src: imgPath + imageVert, className: 'PaintBodyStatus tall' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getVerticalScrollOffset',
	    value: function getVerticalScrollOffset() {
	      var result = 0;
	      var scrollContainer = document.getElementById('app');
	      if (scrollContainer !== undefined) {
	        result = scrollContainer.scrollTop;
	      }
	      return result;
	    }
	  }, {
	    key: 'getHorizontalScrollOffset',
	    value: function getHorizontalScrollOffset() {
	      var result = 0;
	      var scrollContainer = document.getElementById('app');
	      if (scrollContainer !== undefined) {
	        result = scrollContainer.scrollLeft;
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderReferred',
	    value: function renderReferred(item) {
	      var _this16 = this;
	
	      if (!(item.IsReferredIn || item.IsReferredOut)) return null;
	      if (item.ReferredShopName === null || item.ReferredShopName === '') return null;
	      var transportImage = 'referred-order.svg';
	      var renderActionMenu = function renderActionMenu() {
	        var renderTextOverlay = function renderTextOverlay(text) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'poppedup padding transportpopup' },
	            _react2.default.createElement(
	              'label',
	              null,
	              text
	            )
	          );
	        };
	        var referredText = (0, _helpers.translation)('14757');
	        referredText = referredText.replace('[Source]', item.ReferredShopName);
	        referredText = referredText.replace('[Target]', item.ShopName);
	        return renderTextOverlay(referredText);
	      };
	      var renderActionOpener = function renderActionOpener(opener) {
	        var onClick = function onClick(e) {
	          _this16.props.clearLastVisitedOrderId();
	          opener(e);
	        };
	        var classname = '';
	        return _react2.default.createElement(
	          'span',
	          { onClick: onClick, className: 'icon hasTextInBubble' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--top' },
	            _react2.default.createElement('img', { src: '/images/svgs/transport/' + transportImage, className: classname })
	          )
	        );
	      };
	      return _react2.default.createElement(_Overlay2.default, { className: 'referred', renderActionMenu: renderActionMenu, renderActionOpener: renderActionOpener, checkForPopups: this.props.checkForPopups });
	    }
	  }, {
	    key: 'renderTransport',
	    value: function renderTransport(transportItem) {
	      var _this17 = this;
	
	      if (this.props.auth.departmentType === 1) {
	        if ((transportItem.BodyShopTransport === null || transportItem.BodyShopTransport === 0) && !transportItem.IsReferredOut) return _react2.default.createElement('div', { className: 'icon' });
	      } else {
	        if (transportItem.Transport === null || transportItem.Transport === 0) return _react2.default.createElement('div', { className: 'icon' });
	      }
	      // if pickup or delivery address is not normal address - Show bubble
	      // if delivery address is not normal address - show bubble, but only in draft and new orders (step: 1)
	
	      var isshop = (0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType);
	      var showDifferentImageVar = false;
	      var transportImage = 'Can-drive-black.svg';
	      var showDifferentImage = 'Can-drive-different-delivery-black.svg';
	      var showBubbleText = (0, _helpers.translation)('154');
	
	      if (this.props.auth.departmentType === 1) {
	        // Bodyshop
	        if (transportItem.IsReferredOut) {
	          // transport not set and is referred out
	          transportImage = 'referred-order.svg';
	          showDifferentImage = 'referred-order.svg';
	        }
	
	        if (transportItem.BodyShopTransport === 3) {
	          transportImage = 'Transport-black.svg';
	          showDifferentImage = 'Transport-different-delivery-black.svg';
	          showBubbleText = (0, _helpers.translation)('26');
	        }
	
	        if (transportItem.BodyShopTransport === 2) {
	          transportImage = 'loosepart_black.svg';
	          showDifferentImage = 'loosepart_black_redcircle.svg';
	          showBubbleText = (0, _helpers.translation)('351');
	        }
	
	        // Check pickup location
	        if ((transportItem.BodyShopPickupAltLocationId !== 0 || transportItem.BodyShopDeliveryAltLocationId !== 0) && (transportItem.StepId === 1 || transportItem.StepId === 8)) {
	          showBubbleText = (0, _helpers.translation)('13418');
	        }
	
	        if (transportItem.BodyShopPickupAltLocationId === 0 && transportItem.HasBodyShopPickupAltLocation && (transportItem.StepId === 1 || transportItem.StepId === 8)) {
	          showBubbleText = (0, _helpers.translation)('13418');
	        }
	
	        if (transportItem.BodyShopDeliveryAltLocationId !== 0 && transportItem.StepId >= 1) {
	          showBubbleText = (0, _helpers.translation)('13419');
	        }
	
	        if (transportItem.BodyShopDeliveryAltLocationId === 0 && transportItem.HasBodyShopDeliveryAltLocation && transportItem.StepId >= 1) {
	          showBubbleText = (0, _helpers.translation)('13419');
	        }
	
	        if (isshop && (transportItem.IsReferredIn || transportItem.IsReferredOut) && transportItem.BodyShopTransport !== null && transportItem.BodyShopTransport !== 0 && (transportItem.BodyShopPickupAltLocationId !== 0 || transportItem.BodyShopDeliveryAltLocationId !== 0)) {
	          showDifferentImageVar = true;
	        }
	      } else {
	        // Not bodyshop
	        if (transportItem.Transport === 3) {
	          transportImage = 'Transport-black.svg';
	          showDifferentImage = 'Transport-different-delivery-black.svg';
	          showBubbleText = (0, _helpers.translation)('26');
	        }
	
	        if (transportItem.Transport === 2) {
	          transportImage = 'loosepart_black.svg';
	          showDifferentImage = 'loosepart_black_redcircle.svg';
	          showBubbleText = (0, _helpers.translation)('351');
	        }
	
	        // Check pickup location
	        if ((transportItem.PickupAltLocationId !== 0 || transportItem.DeliveryAltLocationId !== 0) && (transportItem.StepId === 1 || transportItem.StepId === 8)) {
	          showDifferentImageVar = true;
	        }
	
	        if (transportItem.DeliveryAltLocationId !== 0 && transportItem.StepId > 1) {
	          showDifferentImageVar = true;
	        }
	      }
	      var classname = '';
	      var iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      if (iswp) {
	        if (transportItem.IsReferredIn) {
	          showDifferentImageVar = true;
	          showDifferentImage = 'referred-order.svg';
	          showBubbleText = '';
	        } else {
	          return null;
	        }
	      }
	      // if (!hasAccess([4], this.props.auth.user.UserType)) {
	      //   classname = 'hasCursor'
	      // }
	      // Returns
	      if (showDifferentImageVar) {
	        var renderTextOverlay = function renderTextOverlay(text) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'poppedup padding TransportInlinePopup' },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              text
	            )
	          );
	        };
	
	        // Overlay
	        var renderActionMenu = function renderActionMenu() {
	          if (iswp && transportItem.HasBodyShopPickupAltLocation && transportItem.BodyShopPickupAltLocationId === 0 || transportItem.HasBodyShopDeliveryAltLocation && transportItem.BodyShopDeliveryAltLocationId === 0) {
	            if (transportItem.HasBodyShopPickupAltLocation && transportItem.BodyShopPickupAltLocationId === 0 && (transportItem.StepId === 1 || transportItem.StepId === 8)) {
	              return _react2.default.createElement(_Transport2.default, { id: transportItem.Id, item: transportItem, updateOrder: _this17.updateOrder });
	            }
	          } else {
	            if (iswp && transportItem.IsReferredIn) {
	              var referredText = (0, _helpers.translation)('14757');
	              referredText = referredText.replace('[Source]', transportItem.ReferredShopName);
	              referredText = referredText.replace('[Target]', transportItem.ShopName);
	              return renderTextOverlay(referredText);
	            }
	          }
	
	          return _react2.default.createElement(_Transport2.default, { id: transportItem.Id, item: transportItem, updateOrder: _this17.updateOrder });
	        };
	        var renderActionOpener = function renderActionOpener(opener) {
	          var onClick = function onClick(e) {
	            _this17.props.clearLastVisitedOrderId();
	            opener(e);
	          };
	          return _react2.default.createElement(
	            'span',
	            { onClick: onClick, className: 'icon hasTextInBubble' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--top', 'aria-label': showBubbleText },
	              _react2.default.createElement('img', { src: '/images/svgs/transport/' + showDifferentImage, className: classname })
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              '!'
	            )
	          );
	        };
	        return _react2.default.createElement(_Overlay2.default, { renderActionMenu: renderActionMenu, renderActionOpener: renderActionOpener, checkForPopups: this.props.checkForPopups });
	      }
	      var imageSrc = transportImage ? '/images/svgs/transport/' + transportImage : null;
	      return _react2.default.createElement(
	        'span',
	        { className: 'icon hasTextInBubble' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hint--left', 'aria-label': showBubbleText },
	          _react2.default.createElement('img', { src: imageSrc, className: classname })
	        )
	      );
	    }
	  }, {
	    key: 'renderPartWithoutPrice',
	    value: function renderPartWithoutPrice(partnopriceitem) {
	      var _this18 = this;
	
	      if (!partnopriceitem.HasTasksWithoutPrice) return _react2.default.createElement('div', { className: 'icon' });
	      var icon = _react2.default.createElement(
	        'span',
	        { className: 'hasTextInBubble' },
	        _react2.default.createElement('img', { src: '/images/svgs/invoice/Payment-notification-icon.svg', className: '' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          '?'
	        )
	      );
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'icon hint--left' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--left', 'aria-label': (0, _helpers.translation)('12348') },
	            icon
	          )
	        );
	      }
	      if (this.props.auth.departmentType === 1) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'icon hint--left' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--left', 'aria-label': (0, _helpers.translation)('12348') },
	            icon
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'span',
	        { className: 'icon hasCursor' },
	        _react2.default.createElement(
	          _HoverExtent2.default,
	          { router: this.props.router, id: this.state.item.Id, item: this.state.item, checkForPopups: this.props.checkForPopups },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--left', 'aria-label': (0, _helpers.translation)('14719'), onClick: function onClick() {
	                return _this18.props.router.push('/pricecalculation/' + partnopriceitem.Id + '/1');
	              } },
	            icon
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPrice',
	    value: function renderPrice(priceitem) {
	      var _this19 = this;
	
	      // let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
	      // if (isCustomer) {
	      //   return (
	      //     <span>{formatCurrency(priceitem.TotalPrice)}</span>
	      //   )
	      // } else {
	      // Overlay
	      var isshop = (0, _auth.hasAccess)([3, 5, 6, 7], this.props.auth.user.UserType);
	
	      var renderActionMenu = function renderActionMenu(close) {
	        if (isshop && _this19.props.auth.departmentType !== 1 && (0, _auth.hasSubscriptionPermission)(_this19.props.auth, 20)) return _react2.default.createElement(_InvoiceLog2.default, { item: priceitem });
	        return _react2.default.createElement(_PriceChange2.default, { id: priceitem.Id, item: priceitem, updateOrder: _this19.updateOrder, close: close });
	      };
	      var renderActionOpener = function renderActionOpener(opener) {
	        var onClick = function onClick(e) {
	          _this19.props.clearLastVisitedOrderId();
	          opener(e);
	        };
	        return _react2.default.createElement(
	          'span',
	          { onClick: onClick },
	          (0, _currency.formatCurrency)(priceitem.TotalPrice)
	        );
	      };
	      return _react2.default.createElement(_Overlay2.default, { renderActionMenu: renderActionMenu, renderActionOpener: renderActionOpener, checkForPopups: this.props.checkForPopups });
	      // }
	    }
	  }, {
	    key: 'openReferenceApprove',
	    value: function openReferenceApprove() {
	      this.props.triggerPopup(true);
	      this.setState({
	        orderReferenceApprove: {
	          open: true,
	          id: this.state.item.id
	        }
	      });
	    }
	  }, {
	    key: 'renderTaksering',
	    value: function renderTaksering(taksitem) {
	      var _this20 = this;
	
	      var update = function update() {
	        _this20.updateOrder(taksitem);
	      };
	      return _react2.default.createElement(_Taksering2.default, { onPopupOpen: this.props.clearLastVisitedOrderId, router: this.props.router, item: taksitem, updateOrder: update.bind(this), openReferenceApprove: this.openReferenceApprove.bind(this), checkForPopups: this.props.checkForPopups });
	    }
	  }, {
	    key: 'updateOrder',
	    value: function updateOrder(data) {
	      // let orders = JSON.parse(JSON.stringify(this.props.orders))
	      // orders[this.props.step].Orders[this.props.index] = data
	      // this.props.updateOrderList(orders)
	      this.props.updateOrderListSingle(data, this.props.step, this.props.index);
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'renderLinkedOrders',
	    value: function renderLinkedOrders(item) {
	      if (item === undefined) item = this.state.item;
	
	      if (item.LinkedOrders === undefined || item.LinkedOrders.length === 0) return null;
	      if (item.LinkedOrders.length !== 0) {
	        return item.LinkedOrders.map(this.renderLinkedItem);
	      }
	    }
	  }, {
	    key: 'renderRekvNr',
	    value: function renderRekvNr(partItem) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'text form' },
	          _react2.default.createElement(_RekvNumber2.default, { id: partItem.Id, item: partItem, updateOrder: this.updateOrder, showLabel: 'false', checkForPopups: this.props.checkForPopups })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'icon' },
	          this.renderShowInvoice(partItem)
	        )
	      );
	    }
	  }, {
	    key: 'getOrderTitle',
	    value: function getOrderTitle(item) {
	      if (!(0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        var titleClass = 'mobiletitle';
	        if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	          titleClass += ' customer';
	        }
	        if (this.props.auth.departmentType === 1) {
	          if (item.HasCarRental) {
	            titleClass += ' small';
	          }
	          var brandAndModel = '';
	          if (item.BrandName) {
	            if (item.BrandName.Name !== '2000') {
	              brandAndModel += (0, _helpers.translation)(item.BrandName.Name.toUpperCase());
	            }
	          }
	          if (item.Model) brandAndModel += ' ' + item.Model.toUpperCase();
	          return _react2.default.createElement(
	            'span',
	            { className: titleClass },
	            _react2.default.createElement(
	              'ul',
	              null,
	              item.RegNumber && _react2.default.createElement(
	                'li',
	                null,
	                item.RegNumber.toUpperCase()
	              ),
	              brandAndModel !== '' && _react2.default.createElement(
	                'li',
	                null,
	                brandAndModel
	              ),
	              !item.RegNumber && !item.Model && _react2.default.createElement(
	                'li',
	                null,
	                item.Id
	              )
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            { className: titleClass },
	            _react2.default.createElement(
	              'ul',
	              null,
	              item.RegNumber && _react2.default.createElement(
	                'li',
	                null,
	                item.RegNumber.toUpperCase()
	              ),
	              item.Model && _react2.default.createElement(
	                'li',
	                null,
	                item.Model.toUpperCase()
	              ),
	              !item.RegNumber && !item.Model && _react2.default.createElement(
	                'li',
	                null,
	                item.Id
	              )
	            )
	          );
	          // return (
	          //   <div className='mobiletitle'>
	          //     {item.RegNumber && (<span>{item.RegNumber.toUpperCase()}</span>)}
	          //     {item.Model && (<span>{item.Model.toUpperCase()}</span>)}
	          //     {!item.RegNumber && !item.Model && (<span>{item.Id}</span>)}
	          //   </div>
	          // )
	        }
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'mobiletitle wp' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              { className: 'wp' },
	              (0, _order.makeOrderTitle)(item, _helpers.translation, _helpers.enumtranslate, true)
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'orderid' },
	              '(' + item.Id + ')'
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getOrderHasRentalCar',
	    value: function getOrderHasRentalCar(item) {
	      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var isCustomer = arguments[2];
	
	      if (item.HasCarRental === true || item.HasRequestedCarRental === true) {
	        // return if CarRentalAssignments only contains alternative.
	        if (item.CarRentalAssignments.length > 0 && !item.HasCarRentalNotAlternative) return;
	
	        var image = '';
	        var whatClasses = '';
	        var hasNoCarSelected = item.HasRequestedCarRental && item.CarRentalAssignments.length === 0;
	
	        if (isCustomer) {
	          image = '/images/svgs/ordrer/lend.svg';
	          return _react2.default.createElement(
	            'div',
	            { className: 'hoverinfoclass' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rentalCarImage' },
	              _react2.default.createElement('img', { src: image, style: { width: 25, height: 25 } })
	            )
	          );
	        }
	        if (active === true) {
	          image = '/images/svgs/ordrer/lend-cirkel-white.svg';
	          switch (item.CarRentalColliderType) {
	            case 0:
	              image = '/images/svgs/ordrer/lend-cirkel-white.svg';
	              break;
	            case 1:
	              // image = '/images/svgs/ordrer/lend-yellowcircle-white.svg'
	              break;
	            case 2:
	              // image = '/images/svgs/ordrer/lend-redcircle-white.svg'
	              break;
	          }
	          whatClasses = 'rentCarActive';
	        } else {
	          image = '/images/svgs/ordrer/lend-cirkel.svg';
	          switch (item.CarRentalColliderType) {
	            case 0:
	              image = '/images/svgs/ordrer/lend-cirkel.svg';
	              break;
	            case 1:
	              image = '/images/svgs/ordrer/lend-yellowcircle.svg';
	              break;
	            case 2:
	              image = '/images/svgs/ordrer/lend-redcircle.svg';
	              break;
	          }
	          whatClasses = 'rentCarKladde';
	
	          if (hasNoCarSelected) {
	            image = '/images/svgs/ordrer/lend-redcircle.svg';
	          }
	        }
	
	        var hoverLines = [];
	        var useClick = true;
	        var useHover = true;
	
	        var carRentalAssignments = item.CarRentalAssignments;
	        if (carRentalAssignments.length > 0) {
	          carRentalAssignments.forEach(function (elem, i) {
	            hoverLines.push(_react2.default.createElement(
	              'p',
	              { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	              elem.Identity
	            ));
	            hoverLines.push(_react2.default.createElement(
	              'p',
	              { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	              (0, _time.renderFullDate)(elem.Start, true)
	            ));
	            hoverLines.push(_react2.default.createElement(
	              'p',
	              { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	              (0, _time.renderFullDate)(elem.End, true)
	            ));
	            if (i < carRentalAssignments.length - 1) {
	              hoverLines.push(_react2.default.createElement('p', { key: item.Id + '_' + Math.random() + '_' + Math.random() }));
	            }
	          });
	        } else {
	          hoverLines.push(_react2.default.createElement(
	            'p',
	            { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	            (0, _time.renderFullDate)(item.BodyShopPickupTime, true)
	          ));
	          hoverLines.push(_react2.default.createElement(
	            'p',
	            { key: item.Id + '_' + Math.random() + '_' + Math.random() },
	            (0, _time.renderFullDate)(item.BodyShopDeliveryTime, true)
	          ));
	        }
	
	        var number = 0;
	
	        if (carRentalAssignments.length > 0) {
	          number = carRentalAssignments[0].CarNumber;
	        }
	        if (item.HasCarRental && !item.CurrentShopCanAssignRentalCar) {
	          // Hide rental car number for car from other company.
	          number = '';
	          image = '/images/svgs/ordrer/lend.svg';
	        }
	
	        return _react2.default.createElement(
	          _HoverPopup2.default,
	          { UseClick: useClick, UseHover: useHover, orderId: item.Id, getVerticalScrollOffset: this.getVerticalScrollOffset, getHorizontalScrollOffset: this.getHorizontalScrollOffset, scrollColumn: this.props.step, PopupContent: hoverLines },
	          _react2.default.createElement(
	            'div',
	            { className: 'rentalCarImage' },
	            _react2.default.createElement('img', { src: image, style: { width: 25, height: 25 } }),
	            !hasNoCarSelected && _react2.default.createElement(
	              'font',
	              { className: whatClasses },
	              number
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderLinkedItem',
	    value: function renderLinkedItem(item) {
	      return this.renderItem(item, true);
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(item, isLinked) {
	      var _this21 = this;
	
	      if (item === null || item.IsDeleted) return null;
	      // Generate title
	      // let title = makeOrderTitle(this.state.item, translation, enumtranslate, true)
	      var isBodyShop = this.props.auth.user.DepartmentType > 0;
	      var moreInfo = item.ShopName;
	      if (item.PriceModelName !== null && item.PriceModelName !== '') {
	        moreInfo += ' (' + item.PriceModelName + ')';
	      }
	      // Generate link
	      var link = (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) || (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 3) ? '/orders/' + item.Id : '';
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var iswp = (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	      var cols = iswp ? [0.7, 0.7, 0.7] : [0.7, 1];
	
	      var shownCustomer = item.CustomerName;
	      if (this.props.auth.allowNoCustomer && item.CustomerSelect === 1) {
	        shownCustomer = (0, _helpers.translation)('15330');
	      }
	
	      var shownInsurance = '';
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && item.InsuranceCompanyId !== null && item.InsuranceCompanyId > 0) {
	        shownInsurance = item.InsuranceCompanyName;
	      }
	      var hasInsurance = shownInsurance !== '';
	      var amActive = false;
	
	      if (item.IsStarted) {
	        amActive = true;
	      }
	      var isDuplicate = item.OrderKey !== undefined && item.OrderKey !== null && item.OrderKey.endsWith('_LoosePart');
	
	      var wide = iswp ? ' wide' : '';
	      var shownName = item.ReferredShopName;
	      var baseClass = '';
	      var nameClass = 'ins';
	      var hasReferred = shownName != null && shownName.length > 0;
	      var hasReferredOut = item.IsReferredOut;
	      var hasReferredIn = item.IsReferredIn;
	      if (hasReferred) {
	        nameClass = 'refshop';
	        baseClass += 'refshop';
	      }
	      var refshopclass = 'refshopclass';
	      if (hasReferred && !hasInsurance && !hasReferredOut || !hasReferredIn) refshopclass = 'refshop';
	      var bodyclass = '';
	      if (!hasReferred && hasInsurance) baseClass = 'ins';
	      if (this.props.auth.departmentType !== 0) bodyclass = ' body';
	      if (hasReferred && hasReferredIn && (hasInsurance || hasReferredOut)) baseClass = 'fifteen';
	      if (iswp) {
	        baseClass = 'fifteen';
	        bodyclass = ' wp';
	      }
	      if (baseClass !== '' && baseClass !== 'ins' && baseClass !== 'refshop') {
	        refshopclass += ' ' + baseClass;
	        nameClass += ' ' + baseClass;
	      }
	      var customerClass = 'mobilecustomer';
	      if (iswp) customerClass += ' wp';
	      if (item.HasCarRental) customerClass += ' rent';
	      var outerclass = 'neworder_item-outer';
	      if (isLinked) outerclass += ' linkedOrder';
	
	      var innerClass = 'neworder_item clearfix';
	      if (item.IsStarted && !isCustomer) innerClass += ' active';
	      if (this.props.lastVisitedOrderId === item.Id) innerClass += ' lastVisitedOrder';
	
	      if (item.IsDraft === true) {
	        return _react2.default.createElement(
	          'div',
	          { key: this.props.key + '' + item.Id },
	          _react2.default.createElement(
	            'div',
	            { id: '' + item.Id, className: outerclass },
	            _react2.default.createElement(
	              'div',
	              { className: innerClass },
	              _react2.default.createElement(
	                'div',
	                { className: 'name mobilename' + bodyclass },
	                _react2.default.createElement(
	                  _HoverExtent2.default,
	                  { router: this.props.router, id: item.Id, item: item, checkForPopups: this.props.checkForPopups },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: link },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'hint--right', 'aria-label': (0, _helpers.translation)((0, _helpers.enumtranslate)('OrderTypes', item.OrderType)) },
	                      _react2.default.createElement('img', { src: (0, _order.makeOrderTypeImage)(item.OrderType, item.IsStarted && !isCustomer) })
	                    ),
	                    this.getOrderTitle(item),
	                    !iswp && this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(
	                      'div',
	                      { className: customerClass },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { className: baseClass },
	                          shownCustomer
	                        ),
	                        hasInsurance && _react2.default.createElement(
	                          'li',
	                          { className: nameClass },
	                          shownInsurance
	                        ),
	                        hasReferred && _react2.default.createElement(
	                          'li',
	                          { className: refshopclass },
	                          shownName
	                        )
	                      )
	                    ),
	                    iswp && _react2.default.createElement(
	                      'div',
	                      { className: customerClass },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { className: baseClass },
	                          shownCustomer
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: nameClass },
	                          moreInfo
	                        ),
	                        hasReferred && _react2.default.createElement(
	                          'li',
	                          { className: refshopclass },
	                          shownName
	                        )
	                      )
	                    ),
	                    this.getOrderHasRentalCar(item, amActive, isCustomer)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'rightorder mobileright' + bodyclass },
	                (isBodyShop || (0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) && _react2.default.createElement('div', { className: 'divider hide_small' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'rekv_nr' },
	                  this.renderReferred(item),
	                  (isBodyShop || (0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) && this.renderRekvNr(item)
	                ),
	                _react2.default.createElement('div', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'message_missing_color' },
	                  this.renderNotes(item),
	                  !iswp && this.renderMissingPart(item),
	                  !iswp && this.renderColor(item)
	                ),
	                _react2.default.createElement('div', { className: 'divider' }),
	                isCustomer || iswp ? _react2.default.createElement(
	                  'div',
	                  { className: 'times_wrap clearfix', style: { textAlign: 'left', alignItems: 'left' } },
	                  _react2.default.createElement(
	                    'span',
	                    { 'aria-label': (0, _helpers.translation)('13387'), className: 'timeCreated hint--top' },
	                    (0, _time.renderFullDate)(item.CreationDate, true)
	                  )
	                ) : [_react2.default.createElement(
	                  'div',
	                  { className: 'times_wrap clearfix', style: { textAlign: 'left', alignItems: 'left' } },
	                  _react2.default.createElement(
	                    _grid2.default,
	                    { cols: '.7fr 1fr' },
	                    _react2.default.createElement(
	                      'span',
	                      { 'aria-label': (0, _helpers.translation)('16458') + ' ' + (0, _time.renderFullDate)(isBodyShop ? item.BodyShopPickupTime : item.Pickup, true), className: 'timeCreated hint--top' },
	                      (0, _time.renderFullDate)(isBodyShop ? item.BodyShopPickupTime : item.Pickup, false)
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { 'aria-label': (0, _helpers.translation)('193') + ' ' + (0, _time.renderFullDate)(isBodyShop ? item.BodyShopDeliveryTime : item.Delivery, true), className: 'timeCreated hint--top' },
	                      (0, _time.renderFullDate)(isBodyShop ? item.BodyShopDeliveryTime : item.Delivery, true)
	                    )
	                  )
	                )],
	                (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement('div', { className: 'divider hide_small', key: 'circle_1' }),
	                (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30) || !isLinked) && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(
	                  'div',
	                  { className: 'circle', key: 'circle_2' },
	                  this.renderCircle(item)
	                ),
	                (0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && isLinked && _react2.default.createElement(
	                  'div',
	                  { className: 'circle hint--left', 'aria-label': (0, _helpers.translation)('13525'), key: 'circle_2' },
	                  _react2.default.createElement('img', { src: '/images/svgs/workscreen/link-order.svg', style: { width: 25, height: 25 } })
	                ),
	                !(0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && !isBodyShop && _react2.default.createElement('div', { className: 'circle', key: 'circle_2' }),
	                this.props.auth.departmentType !== 0 && _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('div', { className: 'divider' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'body_paint_status' },
	                    this.renderPaintBodyStatus(item)
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'divider' }),
	                !iswp && _react2.default.createElement(
	                  'div',
	                  { className: 'transport' },
	                  this.renderTransport(item),
	                  !iswp && this.renderPartWithoutPrice(item),
	                  !iswp && this.renderTaksering(item)
	                ),
	                iswp && _react2.default.createElement(
	                  'div',
	                  { className: 'transport' },
	                  this.renderTransport(item),
	                  this.renderTaksering(item)
	                ),
	                !isCustomer && this.renderInvoice(item),
	                _react2.default.createElement('div', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'price_and_action' + bodyclass },
	                  this.renderPrice(item),
	                  _react2.default.createElement(_OrderActions2.default, { router: this.props.router, ref: 'OrderActions', itemType: '0', item: item, type: 'orderlist', index: this.props.index, step: this.props.step, onOrderMove: this.moveOrder.bind(this), deleteOrderIndex: this.deleteOrderIndex.bind(this) })
	                )
	              )
	            ),
	            this.state.assign_open && _react2.default.createElement(_AssignBox2.default, { router: this.props.router, ref: 'AssignBox', closeAssign: function closeAssign() {
	                _this21.openAssign(false);
	              }, onEmployeeChange: this.getAssignOrderData }),
	            /* item.NeedReferredApprove && */this.state.orderReferenceApprove.open && _react2.default.createElement(_ReferenceOrderActionModal2.default, {
	              show: this.state.orderReferenceApprove.open,
	              item: item,
	              id: item.Id,
	              onClose: this.onPortalClose.bind(this, 'orderReferenceApprove'),
	              checkForPopups: this.props.checkForPopups,
	              department: this.props.auth.departmentType })
	          ),
	          !isLinked && this.renderLinkedOrders()
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { key: this.props.key + '' + item.Id },
	          _react2.default.createElement(
	            'div',
	            { id: '' + item.Id, className: outerclass },
	            _react2.default.createElement(
	              'div',
	              { className: innerClass },
	              _react2.default.createElement(
	                'div',
	                { className: 'name mobilename' + wide + bodyclass },
	                _react2.default.createElement(
	                  _HoverExtent2.default,
	                  { router: this.props.router, id: item.Id, item: item, checkForPopups: this.props.checkForPopups },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: link },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'hint--right', 'aria-label': (0, _helpers.translation)((0, _helpers.enumtranslate)('OrderTypes', item.OrderType)) },
	                      _react2.default.createElement('img', { src: (0, _order.makeOrderTypeImage)(item.OrderType, item.IsStarted && !isCustomer) })
	                    ),
	                    this.getOrderTitle(item),
	                    isCustomer && hasReferred && _react2.default.createElement(
	                      'div',
	                      { className: customerClass },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { className: refshopclass },
	                          shownName
	                        )
	                      )
	                    ),
	                    !iswp && this.props.auth.user.CustomerId === '-1' && !hasReferredOut && _react2.default.createElement(
	                      'div',
	                      { className: customerClass },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { className: baseClass },
	                          shownCustomer
	                        ),
	                        hasInsurance && _react2.default.createElement(
	                          'li',
	                          { className: nameClass },
	                          shownInsurance
	                        ),
	                        hasReferred && _react2.default.createElement(
	                          'li',
	                          { className: refshopclass },
	                          item.ShopNameReferredFrom
	                        )
	                      )
	                    ),
	                    iswp && _react2.default.createElement(
	                      'div',
	                      { className: customerClass },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { className: baseClass },
	                          shownCustomer
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: nameClass },
	                          moreInfo
	                        ),
	                        hasReferred && _react2.default.createElement(
	                          'li',
	                          { className: refshopclass },
	                          shownName
	                        )
	                      )
	                    ),
	                    hasReferred && hasReferredOut && !iswp && this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(
	                      'div',
	                      { className: customerClass },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { className: baseClass },
	                          shownCustomer
	                        ),
	                        item.IsReferredIn && _react2.default.createElement(
	                          'li',
	                          { className: nameClass },
	                          item.ShopNameReferredFrom
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: refshopclass },
	                          item.ShopNameReferredTo
	                        )
	                      )
	                    ),
	                    this.getOrderHasRentalCar(item, amActive, isCustomer)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'rightorder mobileright' + wide + bodyclass },
	                (isBodyShop || (0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) && _react2.default.createElement('div', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'rekv_nr' },
	                  this.renderReferred(item),
	                  (isBodyShop || (0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) && this.renderRekvNr(item)
	                ),
	                _react2.default.createElement('div', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'message_missing_color' },
	                  this.renderNotes(item),
	                  !iswp && this.renderMissingPart(item),
	                  !iswp && this.renderColor(item)
	                ),
	                _react2.default.createElement('div', { className: 'divider' }),
	                !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.props.auth.departmentType === 0 && item.Step !== 8 && _react2.default.createElement(
	                  'div',
	                  { className: 'times_wrap clearfix', style: { textAlign: 'left', alignItems: 'left' } },
	                  _react2.default.createElement(
	                    'span',
	                    { 'aria-label': (0, _helpers.translation)('13012'), className: 'timeCreated hint--top' },
	                    (0, _time.renderFullDate)(item.PublishDate, true)
	                  )
	                ),
	                !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.props.auth.departmentType === 0 && item.Step === 8 && _react2.default.createElement(
	                  'div',
	                  { className: 'times_wrap clearfix', style: { textAlign: 'left', alignItems: 'left' } },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'hint--top hasDefaultCursor timeCreated', 'aria-label': (0, _helpers.translation)('1231') + ' ' + (0, _time.renderFullDate)(item.ArchiveDate) || '\xA0' },
	                    (0, _time.renderFullDate)(item.ArchiveDate, false) || '\xA0'
	                  )
	                ),
	                !(!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && this.props.auth.departmentType === 0) && _react2.default.createElement(
	                  'div',
	                  { className: 'times_wrap clearfix' },
	                  _react2.default.createElement(
	                    _grid2.default,
	                    { cols: cols },
	                    iswp && _react2.default.createElement(
	                      'span',
	                      { className: 'times' },
	                      (0, _time.renderFullDate)(item.CreationDate, false) || '\xA0'
	                    ),
	                    this.renderNewOrder(item),
	                    this.renderHandover(item)
	                  )
	                ),
	                (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement('div', { className: 'divider hide_small', key: 'circle_1' }),
	                (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30) || !isLinked) && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(
	                  'div',
	                  { className: 'circle', key: 'circle_2' },
	                  !isDuplicate && this.renderCircle(item)
	                ),
	                (0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && isLinked && _react2.default.createElement(
	                  'div',
	                  { className: 'circle hint--left', 'aria-label': (0, _helpers.translation)('13525'), key: 'circle_2' },
	                  _react2.default.createElement('img', { src: '/images/svgs/workscreen/link-order.svg', style: { width: 25, height: 25 } })
	                ),
	                !(0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && !isBodyShop && _react2.default.createElement('div', { className: 'circle', key: 'circle_2' }),
	                this.props.auth.departmentType !== 0 && _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('div', { className: 'divider' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'body_paint_status' },
	                    this.renderPaintBodyStatus(item)
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'divider' }),
	                !iswp && _react2.default.createElement(
	                  'div',
	                  { className: 'transport' },
	                  this.renderTransport(item),
	                  !iswp && this.renderPartWithoutPrice(item),
	                  !iswp && this.renderTaksering(item)
	                ),
	                iswp && _react2.default.createElement(
	                  'div',
	                  { className: 'transport' },
	                  this.renderTransport(item),
	                  this.renderTaksering(item)
	                ),
	                _react2.default.createElement('div', { className: 'divider' }),
	                !isCustomer && this.renderInvoice(item),
	                _react2.default.createElement('div', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'price_and_action' + bodyclass },
	                  this.state.assign_open && _react2.default.createElement(_popup2.default, { item: item, onAssignUsers: this.onAssignUsers }),
	                  this.renderPrice(item),
	                  _react2.default.createElement(_OrderActions2.default, { router: this.props.router, ref: 'OrderActions', itemType: '0', item: item, type: 'orderlist', index: this.props.index, step: this.props.step, onOrderMove: this.moveOrder.bind(this), deleteOrderIndex: this.deleteOrderIndex.bind(this), checkForPopups: this.props.checkForPopups, triggerClickAssign: this.triggerClickAssign })
	                )
	              ),
	              this.state.assign_open && _react2.default.createElement(_AssignBox2.default, { router: this.props.router, ref: 'AssignBox', closeAssign: function closeAssign() {
	                  _this21.openAssign(false);
	                }, onEmployeeChange: this.getAssignOrderData }),
	              /* item.NeedReferredApprove && */this.state.orderReferenceApprove.open && _react2.default.createElement(_ReferenceOrderActionModal2.default, {
	                show: this.state.orderReferenceApprove.open,
	                item: item,
	                id: item.Id,
	                onClose: this.onPortalClose.bind(this, 'orderReferenceApprove'),
	                checkForPopups: this.props.checkForPopups,
	                department: this.props.auth.departmentType }),
	              this.state.quality.open && _react2.default.createElement(_QualityCheckModal2.default, { router: this.props.router,
	                show: this.state.quality.open,
	                data: this.state.quality.data,
	                onSuccess: this.startOrderSuccess,
	                onMoveSuccess: this.closeQualityModal,
	                onClose: this.closeQualityModal,
	                move: this.state.quality.move,
	                checkForPopups: this.props.checkForPopups }),
	              this.state.stopOtherOrders.open && _react2.default.createElement(
	                _Portal2.default,
	                { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'stopOtherOrders') },
	                _react2.default.createElement(_StopOtherOrders2.default, { Stop: false, AllOrders: this.AllOrders.bind(this, 'stopOtherOrders'), NotAllOrders: this.NotAllOrders.bind(this, 'stopOtherOrders') })
	              ),
	              this.state.stopOrders.open && _react2.default.createElement(
	                _Portal2.default,
	                { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'stopOrders') },
	                _react2.default.createElement(_StopOtherOrders2.default, { Stop: this.state.stopOrders.open, AllOrders: this.AllOrders.bind(this, 'stopOrders'), NotAllOrders: this.NotAllOrders.bind(this, 'stopOrders') })
	              ),
	              this.state.MoveOrders.open && _react2.default.createElement(
	                _Portal2.default,
	                { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'MoveOrders') },
	                _react2.default.createElement(_StopOtherOrders2.default, { Move: true, AllOrders: this.AllOrders.bind(this, 'MoveOrders'), NotAllOrders: this.NotAllOrders.bind(this, 'MoveOrders') })
	              )
	            ),
	            !isLinked && this.renderLinkedOrders()
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.renderItem(this.state.item);
	    }
	  }, {
	    key: 'closeQualityModal',
	    value: function closeQualityModal() {
	      this.setState({
	        quality: {
	          open: false,
	          data: {},
	          index: 0,
	          pos: 0
	        }
	      });
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'moveOrders',
	    value: function moveOrders(data) {
	      var _this22 = this;
	
	      if (data === undefined) {
	        data = {
	          OrderIds: this.state.MoveOrders.MoveAll === true ? this.state.MoveOrders.OrderIds : [this.state.MoveOrders.Id],
	          UserId: 0,
	          StepFrom: this.state.MoveOrders.FromStep,
	          StepTo: this.state.MoveOrders.ToStep,
	          Comment: '',
	          FilterSettings: {}
	        };
	        this.setState({
	          MoveOrders: _extends({}, this.state.MoveOrders, {
	            MoveAll: null
	          })
	        });
	      }
	
	      var orders = [];
	      for (var i = 0; i < data.OrderIds.length; i++) {
	        var order = {
	          OrderId: data.OrderIds[i]
	        };
	        orders.push(order);
	      }
	
	      var moveData = {
	        Orders: orders,
	        UserId: data.UserId,
	        StepFrom: data.StepFrom,
	        StepTo: data.StepTo,
	        Comment: data.Comment,
	        FilterSettings: data.FilterSettings,
	        MoveAll: data.MoveAll === undefined ? this.state.MoveOrders.MoveAll : data.MoveAll,
	        CheckOnly: false
	      };
	
	      this.props.moveOrder(moveData).then(function (res) {
	        if (res.data.MoveAll) {
	          _this22.setState({
	            MoveOrders: _extends({}, _this22.state.MoveOrders, {
	              open: true,
	              MoveAll: null,
	              OrderIds: res.data.OrderIds,
	              FromStep: moveData.StepFrom, // res.data.StepFrom,
	              ToStep: moveData.StepTo, // res.data.StepTo,
	              Id: data.OrderIds[0]
	            })
	          }, function () {
	            return null;
	          });
	        } else if (res.data.Checks.length > 0) {
	          _this22.props.triggerPopup(true);
	          res.data.OrderIds = data.OrderIds;
	          _this22.setState({
	            quality: {
	              open: true,
	              data: [res.data],
	              pos: data.Pos,
	              index: data.Index,
	              move: true
	            },
	            MoveOrders: _extends({}, _this22.state.MoveOrders, {
	              FromStep: moveData.StepFrom
	            })
	          });
	        } else {
	          if (_this22.stepHasComments(res.data)) {
	            _this22.props.triggerPopup(true);
	            _this22.setState({
	              quality: {
	                open: true,
	                data: [res.data],
	                pos: data.Pos,
	                index: data.Index,
	                move: true
	              }
	            });
	          } else {}
	          // let message = orders.length > 1 ? translation('12338') : translation('1909')
	          // window.toastr.success(message, translation('13424'))
	          // if (res.data.MoveFailed === false) {
	          //   this.moveOrderSuccess(res.data, moveData.Orders)
	          // }
	
	          // this.updateRow(res.data.CurrentStepOrders, data.Pos, data.Index)
	        }
	      }, function (res) {
	        // Toastr
	        var message = void 0;
	        if (res.response.data.IsStopped === true) message = (0, _helpers.translation)('12347');else if (res.response.data.IsReffered === true) message = (0, _helpers.translation)('2704');else message = orders.length > 1 ? (0, _helpers.translation)('12339') : (0, _helpers.translation)('1731');
	
	        // Get error message from response.
	        if (res.response.data !== undefined && res.response.data.DictionaryKey !== undefined) {
	          message = (0, _helpers.translation)(res.response.data.DictionaryKey);
	        }
	
	        // If have StatusCode = 1 (Order can not be moved to this step)
	        if (res.response.data !== undefined && res.response.data.StatusCode !== undefined) {
	          var statusCode = res.response.data.StatusCode;
	          if (statusCode === 1) {
	            // this.moveOrders(this.state.MoveOrders) // Made mass error message spam...
	          }
	        }
	
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'moveOrder',
	    value: function moveOrder(data) {
	      var _this23 = this;
	
	      var orders = [];
	      for (var i = 0; i < data.OrderIds.length; i++) {
	        var order = {
	          OrderId: data.OrderIds[i]
	        };
	        orders.push(order);
	      }
	
	      var moveData = {
	        Orders: orders,
	        UserId: data.UserId,
	        StepFrom: data.StepFrom,
	        StepTo: data.StepTo,
	        Comment: data.Comment,
	        FilterSettings: data.FilterSettings,
	        MoveAll: false,
	        CheckOnly: false
	      };
	
	      this.props.moveOrder(moveData).then(function (res) {
	        if (res.data.Checks.length > 0) {
	          _this23.props.triggerPopup(true);
	          res.data.OrderIds = data.OrderIds;
	          _this23.setState({
	            quality: {
	              open: true,
	              data: [res.data],
	              pos: data.Pos,
	              index: data.Index,
	              move: true
	            }
	          });
	        } else {
	          if (_this23.stepHasComments(res.data)) {
	            _this23.props.triggerPopup(true);
	            _this23.setState({
	              quality: {
	                open: true,
	                data: [res.data],
	                pos: data.Pos,
	                index: data.Index,
	                move: true
	              }
	            });
	          } else if (res.data.FrontendActions !== undefined && res.data.FrontendActions !== null && res.data.FrontendActions.length > 0) {
	            // Handle additional actions directed by backend.
	            // const NONE = 0
	            // const CONFIRM_START = 1 // Not used here
	            var GOTO_WORKCARD = 2;
	
	            var gotoWorkCard = function gotoWorkCard(orderId) {
	              _this23.props.router.push('/orders/' + orderId + '?notifyPaintNotBooked=1');
	            };
	            if (res.data.FrontendActions !== undefined && res.data.FrontendActions !== null && res.data.FrontendActions.length > 0) {
	              res.data.FrontendActions.forEach(function (item) {
	                if (item.Action === GOTO_WORKCARD) {
	                  gotoWorkCard(item.OrderId);
	                }
	              });
	            }
	          } else if (!res.data.MoveFailed) {
	            // window.toastr.success(translation('1909'), translation('13424'))
	          }
	        }
	      }, function (res) {
	        // Toastr
	        var message = void 0;
	        if (res.response.data.IsStopped === true) message = (0, _helpers.translation)('12347');else if (res.response.data.IsReffered === true) message = (0, _helpers.translation)('2704');else message = (0, _helpers.translation)('1731');
	        window.toastr.error(message, (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'stepHasComments',
	    value: function stepHasComments(data) {
	      var ProcessComments = data.ProcessComments;
	      var anyComments = false;
	      if (ProcessComments) {
	        ProcessComments.map(function (val) {
	          if (val.StepComments.length !== 0) anyComments = true;
	        });
	      } else if (data.Checks) {
	        data.Checks.map(function (check) {
	          check.ProcessComments.map(function (val) {
	            if (val.StepComments.length !== 0) anyComments = true;
	          });
	        });
	      }
	
	      return anyComments;
	    }
	  }, {
	    key: 'stepHasFailedStartChecks',
	    value: function stepHasFailedStartChecks(data) {
	      // Because of old and messy "NewItem" code, that seriously needs refactoring (!) - the structure of the object that gets passed to this function is not reliable,
	      // so need to check the structure for where 'QualityCheck' lives.
	      // - 1. data might be array of orders that each hold the QualityCheck object.
	      // - 2. data might be single order object that holds the QualityCheck object.
	      // - 3. data might be object that holds a Checks array (refer to function 'stepHasComments' above) that holds QualityCheck object.
	      var hasFailed = false;
	      if (Array.isArray(data) && data.some(function (x) {
	        return x.QualityCheck && x.QualityCheck.StartFailed;
	      })) {
	        hasFailed = true;
	      } else if (data.QualityCheck && data.QualityCheck.StartFailed) {
	        hasFailed = true;
	      } else if (Array.isArray(data.Checks)) {
	        data.Checks.map(function (x) {
	          if (x.QualityCheck && x.QualityCheck.StartFailed) hasFailed = true;
	        });
	      }
	      return hasFailed;
	    }
	  }]);
	
	  return NewItem;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    orders: state.orders.orders,
	    activeEmployees: state.assign.activeEmployees,
	    lastVisitedOrderId: state.orders.lastVisitedOrderId
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateOrderList: _orders.updateOrderList,
	  updateOrderListSingle: _orders.updateOrderListSingle,
	  getOrderDataNew: _assign.getOrderDataNew,
	  getOrderSimple: _orders.getOrderSimple,
	  getOrdersNew: _orders.getOrdersNew,
	  moveOrder: _orders.moveOrder,
	  startOrder: _orders.startOrder,
	  stopOrder: _orders.stopOrder,
	  triggerPopup: _backdrop.triggerPopup,
	  // approveOrderInvoice,
	  UpdateEconomicMatch: _orders.UpdateEconomicMatch,
	  updateRekvNumber: _orders.updateRekvNumber,
	  GetSimpleCarRentals: _shops.GetSimpleCarRentals,
	  clearLastVisitedOrderId: _orders.clearLastVisitedOrderId
	})(NewItem);

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _assign = __webpack_require__(148);
	
	var _backdrop = __webpack_require__(29);
	
	var _filter = __webpack_require__(307);
	
	var _lodash = __webpack_require__(27);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	__webpack_require__(1428);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SearchFilter = __webpack_require__(447);
	
	var _SearchFilter2 = _interopRequireDefault(_SearchFilter);
	
	var _NewOrdersModal = __webpack_require__(238);
	
	var _NewOrdersModal2 = _interopRequireDefault(_NewOrdersModal);
	
	var _InfoModal = __webpack_require__(1090);
	
	var _InfoModal2 = _interopRequireDefault(_InfoModal);
	
	var _LoginAsModal = __webpack_require__(457);
	
	var _LoginAsModal2 = _interopRequireDefault(_LoginAsModal);
	
	var _OverviewStatusSelection = __webpack_require__(443);
	
	var _OverviewStatusSelection2 = _interopRequireDefault(_OverviewStatusSelection);
	
	var _OrderCapacityOverview = __webpack_require__(306);
	
	var _OrderCapacityOverview2 = _interopRequireDefault(_OrderCapacityOverview);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _common = __webpack_require__(25);
	
	var _List = __webpack_require__(897);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import VisibilitySensor from 'react-visibility-sensor'
	
	
	// import styles
	
	
	// import components
	
	
	// import modals
	
	
	// Utils
	// import { isFilterChanged } from '../../../utils/filter'
	
	
	// List
	
	
	var OrderList = function (_Component) {
	  _inherits(OrderList, _Component);
	
	  function OrderList(props) {
	    _classCallCheck(this, OrderList);
	
	    var _this = _possibleConstructorReturn(this, (OrderList.__proto__ || Object.getPrototypeOf(OrderList)).call(this, props));
	
	    _this.state = {
	      isLoading: true,
	      orders: [],
	      addPopupShow: false,
	      infoModal: false,
	      filterOpen: false,
	      simplesearch: null,
	      loginasmodal: false,
	      loginasmodalData: {},
	      openStartStopId: false,
	      openAction: false,
	      selectedItem: null,
	      reloadAfterModalClose: false
	    };
	    _this.quickSearch = _this.quickSearch.bind(_this);
	    _this.onSearchSubmit = _this.onSearchSubmit.bind(_this);
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.showAddPopup = _this.showAddPopup.bind(_this);
	    _this.handleRowUpdate = _this.handleRowUpdate.bind(_this);
	    _this.openFilter = _this.openFilter.bind(_this);
	    _this.handleLinkedOrders = _this.handleLinkedOrders.bind(_this);
	    _this.onStartAsShopLogin = _this.onStartAsShopLogin.bind(_this);
	    _this.closeLoginAs = _this.closeLoginAs.bind(_this);
	
	    // Sockets
	    _this.updateFromOrderSocket = _this.updateFromOrderSocket.bind(_this);
	    _this.updateSingleOrder = _this.updateSingleOrder.bind(_this);
	    _this.updateOrderSteps = _this.updateOrderSteps.bind(_this);
	    _this.orderMovedUpdateOrderSteps = _this.orderMovedUpdateOrderSteps.bind(_this);
	    _this.updateOrderCreated = _this.updateOrderCreated.bind(_this);
	    _this.updateRemainingTime = _this.updateRemainingTime.bind(_this);
	
	    _this.filterstyle = _this.filterstyle.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.checkOpenCapacityOverview();
	      this.setBodyClass(false);
	      _events2.default.addListener('update_row-orderlist', this.handleRowUpdate, this);
	      _events2.default.addListener('updateorderlist', this.handleLinkedOrders, this);
	      _events2.default.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this);
	      _events2.default.addListener('ORDER_TIMES', this.updateRemainingTime, this);
	      this.setState({
	        orders: [],
	        isLoading: false,
	        UserId: 0
	      });
	
	      var items = JSON.parse(window.localStorage.getItem('newOrdersFilter'));
	      var newOrdersFilter = 0;
	
	      if (items && typeof items.push === 'function') {
	        items.map(function (x) {
	          if (x.userId === _this2.props.auth.user.UserId) {
	            newOrdersFilter = x.filter;
	          }
	        });
	      }
	      var filterData = (0, _filter.getOrderFilterData)(this.props);
	      var refreshFilter = filterData.filter;
	      // let refreshFilter = this.props.filter
	
	      // if page refresh (current filter reset not manually), take from local storage
	      // movedOrders = true is default on orderlist
	      // let source = null
	      // if (isEqual(this.props.filter, this.props.initialFilter)) {
	      //   source = 'filterOrderlist'
	      //   if (hasAccess([4], this.props.auth.user.UserType)) {
	      //     source = 'filterCustomer'
	      //   } else if (hasAccess([6], this.props.auth.user.UserType)) {
	      //     source = 'filterWP'
	      //   }
	      //   let storedFilter = JSON.parse(window.localStorage.getItem(source))
	      //   if (storedFilter !== undefined) {
	      //     refreshFilter = storedFilter
	      //   }
	      // }
	
	      var filter = _extends({}, refreshFilter, {
	        NewOrdersFilter: newOrdersFilter
	        // let simpleSearch = JSON.parse(window.localStorage.getItem('simpleSearch'))
	        // let simpleSearch = filterData.simpleSearch
	        // if (!simpleSearch || simpleSearch.value.length === 0) {
	      });if (!filterData.hasSimpleSearch) {
	        setTimeout(function () {
	          _this2.getOrders(filter);
	        });
	      }
	
	      // Check if need to open capacity overview
	      var location = this.props.router.location;
	      if (location.query.destination && location.query.destination === 'capacityoverview') {
	        this.props.openOverlay('OrderCapacityOverview');
	        this.props.router.replace(_extends({}, location, { query: {} })); // Reset query to only trigger once.
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setBodyClass(true);
	      _events2.default.removeListener('update_row-orderlist', this.handleRowUpdate);
	      _events2.default.removeListener('updateorderlist', this.handleLinkedOrders);
	      _events2.default.removeListener('ORDER_SOCKET', this.updateFromOrderSocket);
	      _events2.default.removeListener('ORDER_TIMES', this.updateRemainingTime);
	    }
	  }, {
	    key: 'checkOpenCapacityOverview',
	    value: function checkOpenCapacityOverview() {
	      var routeItems = window.LocalstorageStack.all();
	      var index = routeItems.length - 3;
	      if (routeItems && routeItems.length > 3 && routeItems[index].pathname === 'OrderCapacityOverview') {
	        this.props.openOverlay('OrderCapacityOverview');
	      }
	    }
	  }, {
	    key: 'onStartAsShopLogin',
	    value: function onStartAsShopLogin(data) {
	      this.props.triggerPopup(true);
	      this.setState({
	        loginasmodal: true,
	        loginasmodalData: data
	      });
	    }
	  }, {
	    key: 'filterstyle',
	    value: function filterstyle(visible) {
	      var hasFilterOpen = document.getElementsByClassName('filter__wrap clearfix open')[0];
	      if (hasFilterOpen && window.innerWidth > 1000) {
	        var filter = document.getElementsByClassName('left__wrap')[0];
	        if (visible === false) {
	          filter.style.position = 'fixed';
	        } else if (visible === true) {
	          filter.style.position = 'absolute';
	        }
	      }
	    }
	  }, {
	    key: 'setBodyClass',
	    value: function setBodyClass(out) {
	      setTimeout(function () {
	        if (out) {
	          document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('orderlist_body', '');
	        } else {
	          document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className + ' orderlist_body';
	        }
	      }, 0);
	    }
	  }, {
	    key: 'getAssignOrders',
	    value: function getAssignOrders(data) {
	      // Find order ids
	      var orderIds = [];
	      data[0].Steps.map(function (val) {
	        val.Orders.map(function (v) {
	          orderIds.push(v.Id);
	        });
	      });
	      this.props.getOrderDataNew({
	        OrderIds: orderIds,
	        UserIds: this.props.activeEmployees
	      });
	    }
	  }, {
	    key: 'updateFromOrderSocket',
	    value: function updateFromOrderSocket(json) {
	      switch (json.Type) {
	        case 'ORDER_UPDATE':
	          this.updateSingleOrder(json.Data);
	          break;
	        case 'ORDER_CREATED':
	          this.updateOrderCreated(json.Data, 500);
	          break;
	        default:
	          if (json.Type === 'ORDER_MOVED' && json.Data.MovedOrderIds !== undefined || json.Data.MovedOrderId !== undefined) {
	            this.orderMovedUpdateOrderSteps(json.Data);
	          } else {
	            this.updateOrderSteps(json.Data);
	          }
	          break;
	      }
	    }
	  }, {
	    key: 'updateRemainingTime',
	    value: function updateRemainingTime(json) {
	      var steps = JSON.parse(JSON.stringify(this.props.orders));
	      steps.map(function (step, key) {
	        if (step.Title === '1' || step.Title === '2' || step.Title === '3' || step.Title === '4' || step.Title === '5' || step.Title === '6' || step.Title === '7') {
	          step.Orders.map(function (order, orderKey) {
	            if (order.IsStarted) {
	              json.Data.map(function (remainingTime, timeKey) {
	                if (order.Id === remainingTime.OrderId) {
	                  order.RemainingTimeDelay = remainingTime.Delay;
	                  order.ColoredParts = remainingTime.ColoredParts;
	                }
	              });
	            }
	          });
	        }
	      });
	      this.props.updateOrderList(steps);
	    }
	  }, {
	    key: 'updateOrderCreated',
	    value: function updateOrderCreated(data, delay) {
	      var _this3 = this;
	
	      var arrayObjectIndexOf = function arrayObjectIndexOf(myArray, searchTerm, property) {
	        for (var i = 0, len = myArray.length; i < len; i++) {
	          if (myArray[i][property] === searchTerm) return i;
	        }
	        return -1;
	      };
	      setTimeout(function () {
	        var filterSteps = [0, 1];
	        var isUpdate = false;
	        if (data.data !== undefined && data.data.length !== undefined && data.data.length > 0) {
	          if (data.data.some(function (x) {
	            return x > 1;
	          })) {
	            isUpdate = true;
	            filterSteps = data.data;
	          }
	        }
	
	        var filterData = (0, _filter.getOrderFilterData)(_this3.props);
	        // let proces = {
	        //   ...this.props.filter.process,
	        //   Completed: false
	        // }
	        // let filter = {
	        //   ...this.props.filter,
	        //   steps: filterSteps,
	        //   process: proces
	        // }
	        // filter.SimpleSearch = this.state.simplesearch === '' ? null : this.state.simplesearch
	
	        var proces = _extends({}, filterData.filter.process, {
	          Completed: false
	        });
	        var filter = _extends({}, filterData.filter, {
	          steps: filterSteps,
	          process: proces
	        });
	        filter.SimpleSearch = filterData.simpleSearch.value === '' ? null : filterData.simpleSearch.value;
	
	        // console.log('getOrdersNew in updateOrderCreated', filter, 'initial', this.props.initialFilter)
	        _this3.props.getOrdersNew(filter).then(function (res) {
	          var orders = JSON.parse(JSON.stringify(_this3.props.orders));
	          var steps = res.data[0].Steps;
	          if (data.IsReferredOut === true) {
	            orders[6] = steps[6];
	          } else if (!isUpdate) {
	            var stepArray = [0, 1];
	            for (var i = 0; i < stepArray.length; i++) {
	              var x = arrayObjectIndexOf(orders, stepArray[i] + '', 'Title');
	              var z = arrayObjectIndexOf(steps, stepArray[i] + '', 'Title');
	              orders[x] = steps[z];
	            }
	          } else {
	            for (var _i = 0; _i < filterSteps.length; _i++) {
	              var _x = arrayObjectIndexOf(orders, filterSteps[_i], 'StepId');
	              var _z = arrayObjectIndexOf(steps, filterSteps[_i], 'StepId');
	              orders[_x] = steps[_z];
	            }
	          }
	          _this3.props.updateOrderList(orders);
	        });
	      }, delay);
	    }
	  }, {
	    key: 'updateSingleOrder',
	    value: function updateSingleOrder(data) {
	      var _this4 = this;
	
	      // console.log('orderList ORDER_UPDATE updateSingleOrder', data)
	      var getFromServer = data.IsUpdateRequired !== undefined && data.IsUpdateRequired === true;
	      var orders = JSON.parse(JSON.stringify(this.props.orders));
	      // check if the order must be update
	      if (!(0, _orders.mustOrderUpdateDueToSocket)([data.Id], this.props.orders)) return;
	
	      // Some data can't be transferred using sockets, as it can be specific to current user (customer/shop/...), in these cases, client must request data from api.
	      if (getFromServer) {
	        var filter = {
	          // ...this.props.filter, // uncommented because when using a filter with "Approved for invoicing" and then invoicing the order and marking as invoiced, it would not update
	          identification: {
	            ordernumber: {
	              value: data.Id,
	              option: 1
	            }
	          }
	        };
	        filter.SimpleSearch = this.state.simplesearch === '' ? null : this.state.simplesearch;
	        // console.log('getOrdersNew in updateSingleOrder', filter, 'initial', this.props.initialFilter)
	        this.props.getOrdersNew(filter).then(function (res) {
	          var steps = res.data[0].Steps;
	          var foundOrder = null;
	          var groupIndex = void 0;
	          var itemIndex = void 0;
	          for (var s = 0; s < steps.length; s++) {
	            if (steps[s].Orders !== undefined && steps[s].Orders.length > 0) {
	              for (var o = 0; o < steps[s].Orders.length; o++) {
	                if (steps[s].Orders[o].Id === data.Id) {
	                  foundOrder = steps[s].Orders[o];
	                  break;
	                }
	              }
	            }
	            if (foundOrder !== null) break;
	          }
	          // Set new orders
	          for (var i = 0; i < orders.length; i++) {
	            var group = orders[i];
	            for (var idx = 0; idx < group.Orders.length; idx++) {
	              var order = group.Orders[idx];
	              if (foundOrder !== null && order.Id === foundOrder.Id) {
	                groupIndex = i;
	                itemIndex = idx;
	                break;
	              }
	            }
	            if (groupIndex !== undefined && itemIndex !== undefined) break;
	          }
	          if (groupIndex !== undefined && itemIndex !== undefined) {
	            _this4.props.updateOrderListSingle(foundOrder, groupIndex, itemIndex);
	          }
	        });
	      } else {
	        // Set new orders
	        var groupIndex = 0;
	        var itemIndex = 0;
	        for (var i = 0; i < orders.length; i++) {
	          var group = orders[i];
	          for (var idx = 0; idx < group.Orders.length; idx++) {
	            var order = group.Orders[idx];
	            if (order.Id === data.Id) {
	              groupIndex = i;
	              itemIndex = idx;
	              break;
	            }
	          }
	          if (groupIndex > 0 && itemIndex > 0) break;
	        }
	        this.props.updateOrderListSingle(data, groupIndex, itemIndex);
	      }
	    }
	  }, {
	    key: 'updateOrderSteps',
	    value: function updateOrderSteps(data) {
	      var _this5 = this;
	
	      // console.log('updateOrderSteps', data)
	      var filterData = (0, _filter.getOrderFilterData)(this.props);
	      var searchData = _extends({}, filterData.filter); // Ensures orders are updated according to current filter.
	      if (data.IsReferredOut === true) {
	        searchData.MovedOrders = true;
	      }
	      // searchData.SimpleSearch = this.state.simplesearch === '' ? null : this.state.simplesearch
	      searchData.SimpleSearch = filterData.hasSimpleSearch ? filterData.simpleSearch.value : null;
	      // console.log('updateOrderSteps searchData', searchData)
	      this.props.getOrdersNew(searchData).then(function (res) {
	        var orders = res.data[0].Steps;
	        _this5.props.updateOrderList(orders);
	      });
	    }
	  }, {
	    key: 'orderMovedUpdateOrderSteps',
	    value: function orderMovedUpdateOrderSteps(data) {
	      var _this6 = this;
	
	      // console.log('orderList orderMovedUpdateOrderSteps', data)
	      var steps = [].concat(_toConsumableArray(this.state.orders));
	      var selectedMovedFromStep = void 0;
	      var selectedMovedToStep = void 0;
	
	      var getMappedStep = function getMappedStep(step) {
	        var result = step;
	        var stepToCustomerTitleMapping = {
	          1: 1,
	          2: 2,
	          3: 2,
	          4: 2,
	          5: 2,
	          6: 2,
	          7: 2,
	          101: 2,
	          102: 2,
	          103: 2,
	          104: 2,
	          105: 2,
	          8: 3
	        };
	        if ((0, _auth.hasAccess)([4], _this6.props.auth.user.UserType)) {
	          result = stepToCustomerTitleMapping[parseInt(step)];
	        }
	        return result;
	      };
	
	      var getStepIdentifier = function getStepIdentifier(step) {
	        // When showing list in customer view, StepId in state.orders are 0, so need to detect correct step from title.
	        if ((0, _auth.hasAccess)([4], _this6.props.auth.user.UserType)) {
	          return parseInt(step.Title);
	        } else {
	          return step.StepId;
	        }
	      };
	
	      steps.map(function (step) {
	        var mappedFrom = getMappedStep(data.MovedFrom);
	        var mappedTo = getMappedStep(data.MovedTo);
	        var s = getStepIdentifier(step);
	        if (s === mappedTo) {
	          selectedMovedToStep = step;
	        }
	        if (s === mappedFrom) {
	          selectedMovedFromStep = step;
	        }
	      });
	
	      var orderIds = data.MovedOrderIds !== undefined ? data.MovedOrderIds : [data.MovedOrderId];
	      // check if the order must be update
	      if (!(0, _orders.mustOrderUpdateDueToSocket)(orderIds, this.props.orders)) return;
	
	      var filter = _extends({}, this.props.searchFilter, {
	        SimpleSearch: this.state.simplesearch === '' ? null : this.state.simplesearch,
	        identification: {
	          OrderNumbers: orderIds
	        }
	      });
	      if (data.IsReferredOut === true) {
	        filter.MovedOrders = true;
	      }
	      // console.log('orderList orderMovedUpdateOrderSteps', filter)
	      var stepsUpdated = false;
	      this.props.getOrdersNew(filter).then(function (res) {
	        var searchSteps = res.data[0].Steps;
	
	        var _loop = function _loop(i) {
	          var orderId = orderIds[i];
	          var foundOrder = null;
	          for (var s = 0; s < searchSteps.length; s++) {
	            if (searchSteps[s].Orders !== undefined && searchSteps[s].Orders.length > 0) {
	              for (var o = 0; o < searchSteps[s].Orders.length; o++) {
	                if (searchSteps[s].Orders[o].Id === orderId) {
	                  foundOrder = searchSteps[s].Orders[o];
	                  break;
	                }
	              }
	            }
	            if (foundOrder !== null) break;
	          }
	
	          if (selectedMovedFromStep !== undefined) {
	            // Remove order in 'moved from' step
	            var indexInFrom = selectedMovedFromStep.Orders.findIndex(function (order) {
	              return order.OrderKey === orderId + '';
	            });
	            if (indexInFrom >= 0) {
	              selectedMovedFromStep.Orders.splice(indexInFrom, 1);
	              stepsUpdated = true;
	            } else {
	              // Didn't find order in suggested moved-from step.
	              // Look in other special steps with stepId 0 (draft is included here, but doesn't matter - this is to cover moved orders)
	              fromSteps = steps.filter(function (x) {
	                return x.StepId === 0;
	              });
	
	              for (var _s = 0; _s < fromSteps.length; _s++) {
	                indexInFrom = fromSteps[_s].Orders.findIndex(function (order) {
	                  return order.OrderKey === orderId + '';
	                });
	                if (indexInFrom >= 0) {
	                  fromSteps[_s].Orders.splice(indexInFrom, 1);
	                  stepsUpdated = true;
	                  break;
	                }
	              }
	            }
	          }
	          if (foundOrder !== null) {
	            // Insert order in 'moved to' step (remove first if already inserted)
	            if (selectedMovedToStep !== undefined) {
	              var indexInTo = selectedMovedToStep.Orders.findIndex(function (order) {
	                return order.Id === foundOrder.Id;
	              });
	              var doInsert = true;
	              if (indexInTo >= 0) {
	                doInsert = false;
	                var orderInTo = selectedMovedToStep.Orders[indexInTo];
	                if (!foundOrder.IsDisplayOnly || orderInTo.IsDisplayOnly) {
	                  // If exists in step, only replace if old is displayOnly or new is not displayOnly
	                  selectedMovedToStep.Orders.splice(indexInTo, 1);
	                  doInsert = true;
	                }
	              }
	              if (doInsert) {
	                selectedMovedToStep.Orders.push(foundOrder);
	                foundOrder.mathRandom = Math.random();
	                stepsUpdated = true;
	              }
	            }
	          }
	
	          // if (foundOrder !== null && selectedMovedToStep !== undefined) {
	          //   // Insert order in 'moved to' step (remove first if already inserted)
	          //   selectedMovedToStep.Orders.push(foundOrder)
	          //   foundOrder.mathRandom = Math.random()
	          //   stepsUpdated = true
	          // }
	        };
	
	        for (var i = 0; i < orderIds.length; i++) {
	          var fromSteps;
	
	          _loop(i);
	        }
	
	        if (stepsUpdated) {
	          if (selectedMovedToStep !== undefined) {
	            var toStepOrderIds = selectedMovedToStep.Orders.map(function (o) {
	              return o.Id;
	            });
	            var step = getStepIdentifier(selectedMovedToStep);
	            _this6.props.getOrderSorting(step, toStepOrderIds).then(function (res) {
	              selectedMovedToStep.Orders.sort(function (orderA, orderB) {
	                return res.data.findIndex(function (id) {
	                  return id === orderA.Id;
	                }) - res.data.findIndex(function (id) {
	                  return id === orderB.Id;
	                });
	              });
	              _this6.props.updateOrderList(steps);
	            });
	          } else {
	            _this6.props.updateOrderList(steps);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'handleRowUpdate',
	    value: function handleRowUpdate(event) {
	      var data = event.data;
	      var orders = [].concat(_toConsumableArray(this.props.orders));
	      orders.map(function (val, key) {
	        if (val.Title === data.Title) {
	          orders[key] = data;
	        }
	      });
	      // console.log('orderList handleRowUpdate', orders, event)
	      orders[event.pos].Orders.splice(event.index, 1);
	      this.props.updateOrderList(orders);
	    }
	  }, {
	    key: 'handleLinkedOrders',
	    value: function handleLinkedOrders() {
	      // console.log('orderList handleLinkedOrders', this.props.filter, this.props.auth.user.UserType)
	      var filterData = (0, _filter.getOrderFilterData)(this.props);
	      var thisFilter = filterData.hasSimpleSearch ? filterData.simpleSearch : filterData.filter;
	      // this.props.getOrdersAdvanced(this.props.filter, this.props.auth.user.UserType)
	      this.props.getOrdersAdvanced(thisFilter, this.props.auth.user.UserType);
	    }
	  }, {
	    key: 'getOrders',
	    value: function getOrders(filter) {
	      var _this7 = this;
	
	      if (!(0, _lodash.isEqual)(this.props.orders, this.state.orders) || this.state.orders.length === 0) {
	        if (!this.state.isLoading) {
	          this.setState({
	            isLoading: true,
	            filterOpen: false
	          }, function () {
	            // console.log('Call getOrdersAdvanced', filter)
	            _this7.props.getOrdersAdvanced(filter, _this7.props.auth.user.UserType);
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState({
	        isLoading: false,
	        orders: props.orders
	      });
	    }
	  }, {
	    key: 'showAddPopup',
	    value: function showAddPopup() {
	      this.props.triggerPopup(!this.state.addPopupShow);
	      this.setState({
	        addPopupShow: !this.state.addPopupShow
	      });
	    }
	  }, {
	    key: 'openFilter',
	    value: function openFilter() {
	      var _this8 = this;
	
	      this.setState({
	        filterOpen: !this.state.filterOpen
	      }, function () {
	        if (_this8.state.filterOpen) {
	          _this8.refs.SearchFilter.getWrappedInstance().refs.simplesearch.refs.input.focus();
	        }
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      var _this9 = this;
	
	      var renderSearchButton = function renderSearchButton() {
	        // Check if search is active
	        var filterActive = false;
	        var simplesearch = '';
	        if (_this9.refs.SearchFilter !== undefined) {
	          var instance = _this9.refs.SearchFilter.getWrappedInstance();
	          if (instance.state !== undefined && instance.state.simplesearch !== undefined && instance.state.simplesearch !== null) {
	            simplesearch = instance.state.simplesearch.value;
	          }
	        }
	        // let simplesearch = this.refs.SearchFilter !== undefined ? this.refs.SearchFilter.getWrappedInstance().state.simplesearch.value : ''
	        if (simplesearch === '') {
	          var storedSimpleSearch = JSON.parse(window.localStorage.getItem('simpleSearch'));
	          if (storedSimpleSearch !== null && storedSimpleSearch.value !== undefined && storedSimpleSearch.value.length > 0) {
	            simplesearch = storedSimpleSearch.value;
	          }
	        }
	        if (_this9.refs.SearchFilter !== undefined && (0, _filter.isFilterChanged)(_this9.props.auth, simplesearch, _this9.refs.SearchFilter.getWrappedInstance().props.filter, _this9.refs.SearchFilter.getWrappedInstance().props.initialFilter)) {
	          filterActive = true;
	        } else {
	          var storedFilter = JSON.parse(window.localStorage.getItem('filterOrderlist'));
	          if ((0, _auth.hasAccess)([4], _this9.props.auth.user.UserType)) {
	            storedFilter = JSON.parse(window.localStorage.getItem('filterCustomer'));
	          } else if ((0, _auth.hasAccess)([6], _this9.props.auth.user.UserType)) {
	            storedFilter = JSON.parse(window.localStorage.getItem('filterWP'));
	          }
	          if ((0, _filter.isFilterChanged)(_this9.props.auth, simplesearch, storedFilter, _this9.props.initialFilter)) {
	            // if page refresh
	            filterActive = true;
	          }
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: filterActive ? 'searchicon filter-active' : 'searchicon' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.FilterIcons.Magnifier_Black, injectSvg: true, onClick: _this9.openFilter, ariaText: (0, _helpers.translation)('2048') })
	        );
	      };
	
	      var renderCreateButton = function renderCreateButton() {
	        if (!(0, _auth.hasAccess)([6], _this9.props.auth.user.UserType) && (0, _auth.hasSubscriptionPermission)(_this9.props.auth, 0, 2)) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_button2.default, { id: 'btn-createorder', spacing: 0, size: 'm', style: 'cta', labelText: (0, _helpers.translation)(21), onClick: _this9.showAddPopup })
	          );
	        }
	        return null;
	      };
	
	      var renderOverviewStatusSelection = function renderOverviewStatusSelection() {
	        if ((0, _auth.hasSubscriptionPermission)(_this9.props.auth, 30) && !(0, _auth.hasAccess)([4, 6], _this9.props.auth.user.UserType)) {
	          return _react2.default.createElement(_OverviewStatusSelection2.default, null);
	        }
	      };
	
	      var renderCapacityOverview = function renderCapacityOverview() {
	        if (!(0, _auth.hasAccess)([5, 7, 3], _this9.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(_this9.props.auth, 30) || _this9.props.auth.departmentType !== 1) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'capacity-overview hide-from-resposive' },
	          _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', style: 'link', labelText: (0, _helpers.translation)('17912'), onClick: function onClick() {
	              return _this9.props.openOverlay('OrderCapacityOverview');
	            } })
	        );
	      };
	
	      // let createButton = !hasAccess([6], this.props.auth.user.UserType) && hasSubscriptionPermission(this.props.auth, 0, 2) ? <div className='hint--left' aria-label={translation('21')}><img src='/images/icons/circle_plus22-black.png' onClick={this.showAddPopup} className='icon' /></div> : ''
	      var isBodyShop = this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { className: 'alignHelper' }),
	        renderCapacityOverview(),
	        renderOverviewStatusSelection(),
	        renderSearchButton(),
	        renderCreateButton(),
	        _react2.default.createElement(_NewOrdersModal2.default, { router: this.props.router,
	          show: this.state.addPopupShow,
	          onClose: this.showAddPopup,
	          bodyShop: isBodyShop }),
	        _react2.default.createElement(_OrderCapacityOverview2.default, null)
	      );
	    }
	  }, {
	    key: 'quickSearch',
	    value: function quickSearch(val) {
	      this.setState({
	        isLoading: true,
	        filterOpen: false,
	        simplesearch: val
	      });
	      this.props.setOrdersSearch(true);
	      this.props.getOrdersAdvanced({
	        SimpleSearch: val,
	        SkipCheck: true,
	        MovedOrders: true
	      }, this.props.auth.user.UserType);
	      this.refs.list.getWrappedInstance().setSimpleSearch(val);
	      this.refs.list.getWrappedInstance().resetPagination();
	    }
	  }, {
	    key: 'onSearchSubmit',
	    value: function onSearchSubmit(filter) {
	      var _this10 = this;
	
	      // console.log('onSearchSubmit', filter)
	      if (!this.state.isLoading) {
	        // fix double search when logging out and in
	        this.setState({
	          isLoading: true,
	          filterOpen: false,
	          simplesearch: null
	        }, function () {
	          _this10.props.setOrdersSearch(true);
	          _this10.props.getOrdersAdvanced(filter, _this10.props.auth.user.UserType);
	        });
	      }
	      if (this.refs.list !== undefined) {
	        this.refs.list.getWrappedInstance().setSimpleSearch(null);
	        this.refs.list.getWrappedInstance().resetPagination();
	      }
	    }
	  }, {
	    key: 'infoModal',
	    value: function infoModal() {
	      var _this11 = this;
	
	      var closeInfoModal = function closeInfoModal() {
	        _this11.props.triggerPopup(false);
	        _this11.props.setInfoModal(false);
	      };
	      return _react2.default.createElement(
	        _InfoModal2.default,
	        { show: this.props.infoPopup, onClose: closeInfoModal },
	        this.props.infoPopup
	      );
	    }
	  }, {
	    key: 'closeLoginAs',
	    value: function closeLoginAs(update, data) {
	      var _this12 = this;
	
	      this.setState({
	        loginasmodal: false,
	        loginasmodalData: {}
	      }, function () {
	        // if (this.state.reloadAfterModalClose) {
	        //   this.setState({ reloadAfterModalClose: false }, () => {
	        //     console.log('Calling getOrders with initialFilter', this.props.initialFilter)
	        //     this.props.getOrdersAdvanced(this.props.initialFilter, this.props.auth.user.UserType)
	        //   })
	        // }
	
	        if (data === undefined) {
	          return;
	        }
	
	        _this12.setState({
	          isLoading: true,
	          simplesearch: null
	        });
	
	        var filterData = (0, _filter.getOrderFilterData)(_this12.props);
	        var thisFilter = filterData.hasSimpleSearch ? filterData.simpleSearch : filterData.filter;
	
	        _this12.props.getOrdersAdvanced(thisFilter, _this12.props.auth.user.UserType).then(function () {
	          _this12.setState({ isLoading: false });
	          if (typeof update === 'boolean' && update) {
	            if (typeof data !== 'undefined') {
	              if (typeof data.type !== 'undefined') {
	                // Stop/start - START
	                if (data.type === 'stop' || data.type === 'start') {
	                  _this12.setState({
	                    openStartStopId: data.id
	                  }, function () {
	                    var updateData = {
	                      Id: data.id,
	                      IsUpdateRequired: true
	                    };
	                    _this12.updateSingleOrder(updateData);
	                  });
	                }
	                // Stop/start - END
	                // Action - START
	                if (data.type === 'action') {
	                  _this12.setState({
	                    openAction: data.id
	                  }, function () {
	                    setTimeout(function () {}, 5000);
	                  });
	                }
	                // Action - END
	                // Move - START
	                if (data.type === 'move') {
	                  if (data.isOneStepMove) {
	                    _this12.initiateMove(data.move.el, data.move.target, data.move.source, data.move.sibling, data.item);
	                    return null;
	                  }
	                  _this12.props.moveOrder(data.move).then(function (res) {
	                    if (res.data.MoveFailed) {
	                      _this12.props.triggerPopup(true);
	                      var quality = data.quality;
	                      quality.data = res.data;
	                      _this12.setState({
	                        quality: quality
	                      });
	                    } else {
	                      if (_this12.stepHasComments(res.data)) {
	                        _this12.props.triggerPopup(true);
	                        var _quality = data.quality;
	                        _quality.data = res.data;
	                        _this12.setState({
	                          quality: _quality
	                        });
	                      }
	                      if (data.move.CheckOnly) {
	                        var item = data.item;
	                        item.NewStepId = parseInt(data.stepid);
	                        item.StepIndex = data.pos1;
	                        item.ItemIndex = data.index;
	                        // Difference
	                        var difference = function difference(a, b) {
	                          return Math.abs(a - b);
	                        };
	                        var type = data.pos1 > data.pos2 ? 1 : 2;
	                        if (difference(data.pos1, data.pos2) === 1) {
	                          type = 1;
	                        }
	                        _this12.setState({
	                          moveItem: {
	                            open: true,
	                            type: type,
	                            item: item
	                          }
	                        });
	                        _this12.props.triggerPopup(true);
	                      } else {
	                        _this12.updateRow(res.data.CurrentStepOrders, data.pos1, data.index);
	                      }
	                    }
	                  }, function (res) {
	                    // Toastr
	                    var message = void 0;
	                    if (res.response.data.IsStopped === true) message = (0, _helpers.translation)('12347');else if (res.response.data.IsReffered === true) message = (0, _helpers.translation)('2704');else message = (0, _helpers.translation)('1731');
	                    window.toastr.error(message, (0, _helpers.translation)('216'));
	                  });
	                } // Move - END
	                // NEW ORDER - START
	                if (data.type === 'neworder') {
	                  _this12.showAddPopup();
	                }
	              } // Typeof data.type - END
	            } // Typeof data - END
	          }
	        });
	      });
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this13 = this;
	
	      // let VisibilitySensor = require('react-visibility-sensor')
	      var extraClass = '';
	      if (this.state.filterOpen) {
	        extraClass += 'open';
	      }
	
	      var openAction = false;
	
	      var hasOpendStatrStop = function hasOpendStatrStop() {
	        _this13.setState({
	          openStartStopId: false
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'orderlist__screen clearfix' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: this.headerButtonsRight, changeTrigger: Math.random() }),
	        this.infoModal(),
	        _react2.default.createElement(
	          'div',
	          { className: 'filter__wrap clearfix ' + extraClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'right__filter__wrap' },
	            _react2.default.createElement(_SearchFilter2.default, { router: this.props.router, ref: 'SearchFilter', onSubmit: this.onSearchSubmit, onSimple: this.quickSearch, source: 'orderlist' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right__wrap' },
	            _react2.default.createElement(_List2.default, {
	              router: this.props.router,
	              ref: 'list',
	              orders: this.state.orders,
	              isLoading: this.props.isSearching,
	              errors: this.props.orderErrors,
	              onStartAsShopLogin: this.onStartAsShopLogin,
	              moveOrders: this.moveOrders // Den findes ikke (??)
	              // openStartStop={openStartStop}
	              , hasOpendStatrStop: hasOpendStatrStop
	              // setSelectedItem={setSelectedItem.bind(this)}
	              , openAction: openAction,
	              openStartStopId: this.state.openStartStopId
	            })
	          )
	        ),
	        (0, _auth.hasAccess)([5, 7], this.props.auth.user.UserType) && this.state.loginasmodal && _react2.default.createElement(_LoginAsModal2.default, { router: this.props.router,
	          data: this.state.loginasmodalData,
	          show: this.state.loginasmodal,
	          onClose: this.closeLoginAs })
	      );
	    }
	  }]);
	
	  return OrderList;
	}(_react.Component);
	
	OrderList.propTypes = {
	  auth: _propTypes2.default.object.isRequired,
	  getOrdersAdvanced: _propTypes2.default.func.isRequired,
	  triggerPopup: _propTypes2.default.func.isRequired,
	  setInfoModal: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  // state.orders.filter.movedOrders = true
	  // state.orders.initialFilter.movedOrders = true
	  var initialFilter = state.orders.initialFilterOrderlist;
	  var filter = state.orders.filterOrderlist;
	  if ((0, _auth.hasAccess)([4], state.auth.user.UserType)) {
	    initialFilter = state.orders.initialFilterCustomer;
	    filter = state.orders.filterCustomer;
	  } else if ((0, _auth.hasAccess)([6], state.auth.user.UserType)) {
	    initialFilter = state.orders.initialFilterWP;
	    filter = state.orders.filterWP;
	  }
	  return {
	    auth: state.auth,
	    orders: state.orders.orders,
	    filter: filter,
	    initialFilter: initialFilter,
	    orderErrors: state.orders.errors,
	    infoPopup: state.backdrop.infoPopup,
	    activeEmployees: state.assign.activeEmployees,
	    isSearching: state.orders.isSearching
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrdersNew: _orders.getOrdersNew,
	  getOrdersAdvanced: _orders.getOrdersAdvanced,
	  getOrderSimple: _orders.getOrderSimple,
	  triggerPopup: _backdrop.triggerPopup,
	  setInfoModal: _backdrop.setInfoModal,
	  updateOrderList: _orders.updateOrderList,
	  updateOrderListSingle: _orders.updateOrderListSingle,
	  getOrderDataNew: _assign.getOrderDataNew,
	  isFilterChanged: _filter.isFilterChanged,
	  setOrdersSearch: _orders.setOrdersSearch,
	  setOrdersFilter: _orders.setOrdersFilter,
	  getOrderSorting: _orders.getOrderSorting,
	  resetFilter: _orders.resetFilter,
	  resetSimplesearch: _orders.resetSimplesearch,
	  openPopup: _common.openPopup,
	  closePopup: _common.closePopup,
	  openOverlay: _common.openOverlay
	})(OrderList);

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Evaluation = __webpack_require__(291);
	
	var _Evaluation2 = _interopRequireDefault(_Evaluation);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1429);
	
	var _backdrop = __webpack_require__(29);
	
	var _carownerportal = __webpack_require__(192);
	
	var _documentation = __webpack_require__(407);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _array = __webpack_require__(205);
	
	var _Part = __webpack_require__(152);
	
	var _Part2 = _interopRequireDefault(_Part);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import HelpText from '../../../../shared/components/HelpText'
	
	// import axios from 'axios'
	// import { isEqual } from 'lodash'
	// import async from 'async'
	// import Datetime from 'react-datetime'
	// import moment from 'moment'
	
	// import { Link } from 'react-router'
	
	// Constants
	
	
	// Styles
	
	
	// Actions
	
	// import { openOverlay } from '../../../../actions/common'
	
	
	// Utils
	
	// Elements
	
	
	// import Label from '../../../../shared/elements/label'
	// import Text from '../../../../shared/elements/text'
	// import HelpIcon from '../../../../shared/elements/helpIcon'
	// import { ModalIcons } from '../../../../shared/elements/icons'
	
	// import Modal from '../../../../shared/components/Modal'
	
	var Documentation = function (_Component) {
	  _inherits(Documentation, _Component);
	
	  function Documentation(props) {
	    _classCallCheck(this, Documentation);
	
	    var _this = _possibleConstructorReturn(this, (Documentation.__proto__ || Object.getPrototypeOf(Documentation)).call(this, props));
	
	    _this.state = {
	      isLoading: true,
	      quality: null,
	      process: null,
	      photo: null,
	      // intDeviations: null,
	      // extDeviations: null,
	      evaluation: null,
	      afterEvaluations: null,
	      dimensions: {
	        width: 0,
	        height: 0
	        // carOwnerPortalStatus: {
	        //   Logs: [],
	        //   Mail: null,
	        //   Phone: null,
	        //   Status: null
	        // }
	      } };
	    _this.getDocAll = _this.getDocAll.bind(_this);
	    _this.getDocQuality = _this.getDocQuality.bind(_this);
	    _this.getDocProcess = _this.getDocProcess.bind(_this);
	    _this.getDocPhoto = _this.getDocPhoto.bind(_this);
	    _this.getDeviations = _this.getDeviations.bind(_this);
	    _this.getDocEvaluations = _this.getDocEvaluations.bind(_this);
	    _this.getOtherDamages = _this.getOtherDamages.bind(_this);
	    // this.getCarOwnerStatus = this.getCarOwnerStatus.bind(this)
	
	    _this.renderQuality = _this.renderQuality.bind(_this);
	    _this.renderProcess = _this.renderProcess.bind(_this);
	    _this.renderPhotoDoc = _this.renderPhotoDoc.bind(_this);
	    _this.renderInternalDeviation = _this.renderInternalDeviations.bind(_this);
	    _this.renderExternalDeviation = _this.renderExternalDeviations.bind(_this);
	    _this.renderDeviations = _this.renderDeviations.bind(_this);
	    _this.renderOtherDamage = _this.renderOtherDamage.bind(_this);
	    _this.renderEvaluation = _this.renderEvaluation.bind(_this);
	    _this.renderAfterEvaluation = _this.renderAfterEvaluation.bind(_this);
	    _this.renderAfterEvaluations = _this.renderAfterEvaluations.bind(_this);
	    // this.renderCarOwnerPortalStatus = this.renderCarOwnerPortalStatus.bind(this)// add new
	    // this.updateCarOwner = this.updateCarOwner.bind(this)
	    // this.openOverlay = this.openOverlay.bind(this)
	    // this.openCarOwnerResendPopup = this.openCarOwnerResendPopup.bind(this)
	    // this.sendInvitation = this.sendInvitation.bind(this)
	
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.fnListener = window.debounce(_this.updateDimensions, 250);
	    _this.onChange = _this.onChange.bind(_this);
	    // this.onBlur = this.onBlur.bind(this)
	    return _this;
	  }
	
	  _createClass(Documentation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Load data
	      if (this.props.order.Id !== undefined) {
	        this.getDocAll(this.props.order.Id);
	      }
	      window.addEventListener('resize', this.fnListener);
	      this.updateDimensions();
	      // if (this.props.headerButtonsCbProvider !== null) {
	      //   this.props.headerButtonsCbProvider(() => { return [] })
	      // }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.fnListener);
	      // if (this.props.headerButtonsCbProvider !== null) {
	      //   this.props.headerButtonsCbProvider(() => { return [] })
	      // }
	    }
	  }, {
	    key: 'componentDidReceiveProps',
	    value: function componentDidReceiveProps(props) {
	      // Load data
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Load data
	      if (nextProps.order !== undefined && nextProps.order.Id !== undefined) {
	        this.getDocAll(nextProps.order.Id);
	      }
	    }
	    // openOverlay (e) {
	    //   e.persist()
	    //   this.setState({
	    //     carrentalselectionmodal: false
	    //   })
	    //   this.props.triggerPopup(false)
	    // }
	    // openCarOwnerResendPopup (modal, isSMS, isEmail, date) {
	    //   console.log('openCarOwnerResendPopup, modal', modal, 'isSMS', isSMS, 'isEmail', isEmail, 'date', date)
	    //   this.setState({
	    //     [modal]: true,
	    //     carOwnerPortalResend: {
	    //       isSMS: isSMS,
	    //       isEmail: isEmail,
	    //       date: renderFullDate(date)
	    //     }
	    //   })
	    //   this.props.triggerPopup(true)
	    // }
	    // // get car owner status
	    // getCarOwnerStatus (orderId) {
	    //   return this.props.getCarOwnerStatus(orderId).then((res) => {
	    //     // console.log(res.data)
	    //     this.setState({
	    //       carOwnerPortalStatus: res.data
	    //     })
	    //     return res
	    //   })
	    // }
	    // sendInvitation () {
	    //   const param = {
	    //     orderId: this.props.order.Id,
	    //     isSendSMS: this.state.carOwnerPortalResend.isSMS,
	    //     IsSendEmail: this.state.carOwnerPortalResend.isEmail
	    //   }
	
	    //   this.props.sendInvitation(param).then((res) => {
	    //     this.props.triggerPopup(false)
	    //     this.setState({
	    //       carrentalselectionmodal: false
	    //     })
	    //     this.getCarOwnerStatus(this.props.order.Id)
	
	    //     // window.toastr.success(translation('18189'), translation('13424'))
	    //   }, () => {
	    //     // Err saving
	    //     window.toastr.error(translation('18190'), translation('216'))
	    //   })
	    // }
	    // updateCarOwner () {
	    //   const params = {
	    //     orderId: this.props.order.Id,
	    //     mail: this.state.carOwnerPortalStatus.Mail,
	    //     phone: this.state.carOwnerPortalStatus.Phone
	
	    //   }
	    //   this.props.updateCarOwner(params).then((res) => {
	    //     // window.toastr.success(translation('18156'), translation('13424'))
	    //   }, () => {
	    //     // Err saving
	    //     window.toastr.error(translation('18157'), translation('216'))
	    //   })
	    // }
	
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this2 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this2.state.dimensions.width;
	          if (width > higherThan && width < lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'getDocQuality',
	    value: function getDocQuality(orderId) {
	      var _this3 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30)) return null;
	      return this.props.getDocQuality(orderId).then(function (res) {
	        _this3.setState({
	          quality: res.data
	        });
	        return res;
	      });
	    }
	  }, {
	    key: 'getDocProcess',
	    value: function getDocProcess(orderId) {
	      var _this4 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      return this.props.getDocProcess(orderId).then(function (res) {
	        _this4.setState({
	          process: res.data
	        });
	        return res;
	      });
	    }
	  }, {
	    key: 'getDocPhoto',
	    value: function getDocPhoto(orderId) {
	      var _this5 = this;
	
	      return this.props.getDocPhoto(orderId).then(function (res) {
	        _this5.setState({
	          photo: res.data
	        });
	        return res;
	      });
	    }
	  }, {
	    key: 'getDeviations',
	    value: function getDeviations(orderId) {
	      var _this6 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30)) return null;
	      return this.props.getDocDeviations(orderId).then(function (res) {
	        var intDeviations = res.data.InternalDeviations;
	        var extDeviations = res.data.ExternalDeviations;
	        _this6.setState({
	          intDeviations: intDeviations,
	          extDeviations: extDeviations
	        }, function () {
	          _this6.setState({
	            internalDeviationsTotalCost: res.data.InternalDeviationsTotalCost,
	            externalDeviationsTotalCost: res.data.ExternalDeviationsTotalCost
	          });
	        });
	        return res;
	      });
	    }
	  }, {
	    key: 'getOtherDamages',
	    value: function getOtherDamages(orderId) {
	      var _this7 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      return this.props.getDocOtherDamages(orderId).then(function (res) {
	        _this7.setState({
	          otherDamages: res.data.OtherDamages
	        });
	        return res;
	      });
	    }
	  }, {
	    key: 'getDocEvaluations',
	    value: function getDocEvaluations(orderId) {
	      var _this8 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30)) return null;
	      return this.props.getDocEvaluations(orderId).then(function (res) {
	        _this8.setState({
	          evaluation: res.data.Estimation,
	          afterEvaluations: res.data.AfterEvaluations
	        });
	        return res;
	      });
	    }
	  }, {
	    key: 'getDocAll',
	    value: function getDocAll(orderId) {
	      var _this9 = this;
	
	      // Trigger popup action BG - START
	      this.props.triggerPopupActionBG(true);
	      // Trigger popup action BG - END
	
	      // Load doc. data
	      var promise1 = this.getDocQuality(orderId);
	      var promise2 = this.getDocProcess(orderId);
	      var promise3 = this.getDocPhoto(orderId);
	      var promise4 = this.getDeviations(orderId);
	      var promise5 = this.getDocEvaluations(orderId);
	      var promise6 = this.getOtherDamages(orderId);
	      // let promise7 = this.getCarOwnerStatus(orderId)
	
	      // Wait for all to resolve
	      Promise.all([promise1, promise2, promise3, promise4, promise5, promise6]).then(function (values) {
	        _this9.setState({
	          isLoading: false
	        });
	        // Trigger popup action BG - START
	        _this9.props.triggerPopupActionBG(false);
	        // Trigger popup action BG - END
	      }, function () {
	        _this9.setState({
	          isLoading: false
	        });
	        // Trigger popup action BG - START
	        _this9.props.triggerPopupActionBG(false);
	        // Trigger popup action BG - END
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      e.persist();
	      var value = e.target.value;
	
	      this.setState({
	        carOwnerPortalStatus: _extends({}, this.state.carOwnerPortalStatus, _defineProperty({}, e.target.name, value))
	      });
	    }
	
	    // onBlur (e) {
	    //   this.updateCarOwner()
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.order.Id === 'undefined' || this.state.isLoading) {
	        var loadingSpinner = function loadingSpinner() {
	          return _react2.default.createElement(
	            _panel2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'documentation__screen' },
	          !this.props.disabled && _react2.default.createElement(
	            _Header2.default,
	            {
	              router: this.props.router,
	              showBack: true,
	              headerButtonsGoBack: this.props.renderButtonsGoBack,
	              renderButtons: function renderButtons() {
	                return [];
	              }
	            },
	            this.props.renderTabs()
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.auth.user.DepartmentType !== 1 && _react2.default.createElement(
	              _col2.default,
	              null,
	              loadingSpinner(),
	              loadingSpinner()
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              loadingSpinner()
	            ),
	            this.props.auth.user.DepartmentType !== 1 && _react2.default.createElement(
	              _col2.default,
	              null,
	              loadingSpinner(),
	              loadingSpinner()
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              loadingSpinner(),
	              loadingSpinner()
	            )
	          )
	        );
	      }
	
	      var showQuality = this.props.auth.user.DepartmentType !== 1; // || (hasSubscriptionPermission(this.props.auth, 0) && hasPartnerSubscriptionPermission(this.props.auth, 30))
	      return _react2.default.createElement(
	        'div',
	        { className: 'documentation__screen' },
	        !this.props.disabled && _react2.default.createElement(
	          _Header2.default,
	          {
	            router: this.props.router,
	            showBack: true,
	            headerButtonsGoBack: this.props.renderButtonsGoBack,
	            renderButtons: function renderButtons() {
	              return [];
	            }
	          },
	          this.props.renderTabs()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row clearfix' },
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderWreckedOrder(),
	            showQuality && this.renderQuality(),
	            this.renderCustomChecks(),
	            this.renderPhotoDoc(),
	            this.dimensionShow([[0, 1401]]) && _react2.default.createElement(
	              'div',
	              null,
	              this.props.auth.user.DepartmentType !== 1 && this.renderInternalDeviations(),
	              this.renderExternalDeviations(),
	              this.renderOtherDamage()
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderProcess()
	          ),
	          this.dimensionShow([[1400, 10000]]) && _react2.default.createElement(
	            _col2.default,
	            null,
	            this.props.auth.user.DepartmentType !== 1 && this.renderInternalDeviations(),
	            this.renderExternalDeviations(),
	            this.renderOtherDamage()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderEvaluation(),
	            this.renderAfterEvaluations()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderQuality',
	    value: function renderQuality() {
	      var quality = this.state.quality;
	      if (quality === null) return null;
	      var renderOrderChecks = function renderOrderChecks(quality) {
	        var qualityChecks = quality.OrderChecks.filter(function (x) {
	          return x.QualityCheckTaskName === '';
	        });
	        if (qualityChecks.length === 0) return null;
	        var renderEntry = function renderEntry(val, key) {
	          if (val === null || val === undefined) return null;
	          var step = (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', val.Step));
	          var isStart = val.StartOrEnd === 1;
	          var user = val.PerformedByUserInfo;
	          var date = val.PerformedAt;
	          return _react2.default.createElement(
	            'li',
	            { key: key },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [5, 6, 1], spacing: [1] },
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _time.renderFullDate)(date)
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                step,
	                ' - ',
	                isStart ? (0, _helpers.translation)('1223') : (0, _helpers.translation)('2062'),
	                ', ',
	                _react2.default.createElement(_UserInfo2.default, { user: user })
	              )
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('1929') }),
	          _react2.default.createElement(
	            'ul',
	            null,
	            qualityChecks.map(renderEntry)
	          )
	        );
	      };
	
	      var renderLayerThickness = function renderLayerThickness(quality) {
	        if (quality.PaintThicknessChecks.length === 0) return null;
	        var renderEntry = function renderEntry(val, key) {
	          if (val === null || val === undefined) return null;
	          var step = (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', val.Step));
	          var isStart = val.StartOrEnd === 1;
	          var user = val.PerformedByUserInfo;
	          var date = val.PerformedAt;
	          var value = val.ThicknessValue;
	          return _react2.default.createElement(
	            'li',
	            { key: key },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [5, 6, 1], spacing: [1] },
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _time.renderFullDate)(date)
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                step,
	                ' - ',
	                isStart ? (0, _helpers.translation)('1223') : (0, _helpers.translation)('2062'),
	                ', ',
	                _react2.default.createElement(_UserInfo2.default, { user: user })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                value
	              )
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('370') }),
	          _react2.default.createElement(
	            'ul',
	            null,
	            quality.PaintThicknessChecks.map(renderEntry)
	          )
	        );
	      };
	
	      var renderWarrantyCode = function renderWarrantyCode(quality) {
	        var code = quality.WarrantyCode;
	        if (code.trim() === '') return null;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13396') }),
	          _react2.default.createElement(
	            'div',
	            null,
	            code
	          )
	        );
	      };
	
	      var renderNoChecks = function renderNoChecks(quality) {
	        if (quality.OrderChecks.length !== 0 || quality.PaintThicknessChecks.length !== 0 || quality.WarrantyCode.trim() !== '') return null;
	        return _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)('1919')
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1929') },
	        renderNoChecks(quality),
	        renderOrderChecks(quality),
	        renderLayerThickness(quality),
	        renderWarrantyCode(quality)
	      );
	    }
	  }, {
	    key: 'renderCustomChecks',
	    value: function renderCustomChecks() {
	      var quality = this.state.quality;
	      if (quality === null) return null;
	      var customChecks = quality.OrderChecks.filter(function (x) {
	        return x.QualityCheckTaskName !== '';
	      });
	      if (customChecks.length === 0) return null;
	
	      // Group checks
	      var groupedChecks = customChecks.reduce(function (result, check) {
	        if (result[check.QualityCheckTaskName]) {
	          result[check.QualityCheckTaskName].push(check);
	        } else {
	          result[check.QualityCheckTaskName] = [check];
	        }
	
	        return result;
	      }, {}); // { [name]: [ ...checks ], ... }
	
	      var renderGroup = function renderGroup(groupKey, key) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: groupKey }),
	          _react2.default.createElement(
	            'ul',
	            null,
	            groupedChecks[groupKey].map(renderEntry)
	          )
	        );
	      };
	
	      var renderEntry = function renderEntry(val, key) {
	        if (val === null || val === undefined) return null;
	        var step = (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', val.Step));
	        var isStart = val.StartOrEnd === 1;
	        var user = val.PerformedByUserInfo;
	        var date = val.PerformedAt;
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [5, 6, 1], spacing: [1] },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(date)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)(val.Status)
	              ),
	              step,
	              ' - ',
	              isStart ? (0, _helpers.translation)('1223') : (0, _helpers.translation)('2062'),
	              ', ',
	              _react2.default.createElement(_UserInfo2.default, { user: user }),
	              _react2.default.createElement(
	                'div',
	                null,
	                val.Comment
	              )
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('17893') },
	        _react2.default.createElement(
	          'ul',
	          null,
	          Object.keys(groupedChecks).map(renderGroup)
	        )
	      );
	    }
	  }, {
	    key: 'renderProcess',
	    value: function renderProcess() {
	      var _this10 = this;
	
	      // Access
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) return null;
	      // Process
	      var process = this.state.process;
	      if (process === null) return null;
	      var renderStep = function renderStep(val, key) {
	        if (val === undefined || val === null) return null;
	        if (val.StepRecords.length === 0) return null;
	        var renderStepRecord = function renderStepRecord(val, key) {
	          if (val === undefined || val === null) return null;
	          var user = val.UserInfo;
	          var stopTime = val.StopTime;
	          var startTime = val.StartTime;
	          var usedTime = val.UsedTime;
	          var weight = val.SharedTime;
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: [7, 0.5], key: key, spacing: [1] },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _time.renderFullDate)(startTime, false),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  ' ',
	                  (0, _time.renderFullDate)(startTime, true, true),
	                  ' - ',
	                  (0, _time.renderFullDate)(stopTime, true, true),
	                  ' (',
	                  weight,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_UserInfo2.default, { user: user })
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              usedTime
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: 'step_' + key },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: _react2.default.createElement(
	                _inline2.default,
	                { fillChildNum: [0], block: true },
	                (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', val.StepId)),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  val.TotalUsedTime
	                )
	              ) },
	            _react2.default.createElement(
	              'div',
	              { className: 'stepUserData' },
	              val.StepRecords.map(renderStepRecord)
	            )
	          )
	        );
	      };
	
	      var usedTime = process.UsedTime;
	      var usedTimeWithTransport = process.UsedTimeWithTransport;
	      var assignedTimeForsi = process.AssignedTimeForsi;
	      var assignedTime = process.AssignedTime;
	      var estimatedTime = process.EstimatedTime;
	      var gainHour = process.GainHour;
	      var gainHourWithoutTransport = process.GainHourWithoutTransport;
	      var gainIndex = process.GainIndex;
	      var gainIndexWithoutTransport = process.GainIndexWithoutTransport;
	      var renderReferredOut = function renderReferredOut() {
	        if (!_this10.props.order.IsReferredOut || _this10.props.order.OrderConnection === undefined) return null;
	        var referredName = _this10.props.order.OrderConnection.TransferedToCompanyName;
	        if (_this10.props.order.OrderConnection.TransferedToCompanyName === undefined || _this10.props.order.OrderConnection.TransferedToCompanyName === null) {
	          referredName = '';
	        }
	        var referText = (0, _helpers.translation)('13558') + ' ' + referredName;
	        return _react2.default.createElement(
	          'div',
	          null,
	          referText
	        );
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('359') },
	        renderReferredOut(),
	        _react2.default.createElement(
	          'ul',
	          null,
	          usedTimeWithTransport !== '00:00' && _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('2066')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                usedTimeWithTransport
	              )
	            )
	          ),
	          usedTime !== '00:00' && _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('2067')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                usedTime
	              )
	            )
	          ),
	          assignedTimeForsi !== '00:00' && _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('2063')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                assignedTimeForsi
	              )
	            )
	          ),
	          estimatedTime !== '00:00' && _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('16836')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                estimatedTime
	              )
	            )
	          ),
	          assignedTime !== '00:00' && _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('2064')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                assignedTime
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'assignSteps' },
	          process.AssignedStepTimes.map(renderStep)
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          gainHour !== null && _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('2068')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                gainHour
	              )
	            )
	          ),
	          gainHourWithoutTransport !== null && _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('2069')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                gainHourWithoutTransport
	              )
	            )
	          ),
	          gainIndex !== null && _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('2070')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                gainIndex
	              )
	            )
	          ),
	          gainIndexWithoutTransport !== null && _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('2071')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                gainIndexWithoutTransport
	              )
	            )
	          )
	        )
	      );
	    }
	
	    // // Add new component 1515 status, 1021 des 31 m 18183 E-m 18219 re-s
	    // renderCarOwnerPortalStatus () {
	    //   const cols = [3, 2, 4]
	    //   let carOwnerPortalStatus = this.state.carOwnerPortalStatus
	    //   // console.log('carOwnerPortalStatus:', carOwnerPortalStatus)
	    //   const closeCarRentalSelectionModal = () => {
	    //     this.props.triggerPopup(false)
	    //     this.setState({
	    //       carrentalselectionmodal: false
	    //     })
	    //   }
	
	    //   const renderStatusElement = (status) => {
	    //     let text = ''
	    //     let helpText = ''
	    //     switch (status) {
	    //       case 1:
	    //         text = translation('295')
	    //         helpText = translation(`18221`)
	    //         break
	    //       case 2:
	    //         text = translation('18225')
	    //         helpText = translation(`18222`)
	    //         break
	    //       case 3:
	    //         text = translation('18226')
	    //         helpText = translation(`18223`)
	    //         break
	    //       case 4:
	    //         text = translation('18227')
	    //         helpText = translation(`18224`)
	    //         break
	    //     }
	    //     return (
	    //       <div>
	    //         <span>{text}</span>
	    //         <HelpIcon helpText={helpText} size='t' />
	    //       </div>
	    //     )
	    //   }
	    //   const renderLogElement = (val, key) => {
	    //     return (
	    //       <li key={key}>
	    //         <Grid cols={cols} spacing={2}>
	    //           <div className='date'>{renderFullDate(val.Date)}</div>
	    //           <div className='user'>{val.Name}</div>
	    //           <div className='eventtype'>{translation(val.Description)}</div>
	    //         </Grid>
	    //       </li>
	    //     )
	    //   }
	
	    //   // console.log('state (car owner)', this.state)
	    //   let noticeText = ''
	    //   let dateOfStatusText = ''
	    //   let date = ''
	    //   /*
	    //       Active = 1,
	    //       NotInvited = 2,
	    //       Invited = 3,
	    //       RejectedByCarOwner = 4
	    //   */
	    //   switch (carOwnerPortalStatus.Status) {
	    //     case 1:
	    //       noticeText = translation(18221)         // The car owner portal is active and can be used by car owner
	    //       dateOfStatusText = translation(18254)   // Accepted by the car owner
	    //       date = this.state.carOwnerPortalStatus.Logs.filter(x => x.Status === 1).slice(0, 1)[0].Date   // Latest date of car owner accept (active)
	    //       break
	    //     case 2:
	    //       noticeText = translation(18222)         // no invitation has been sent to the car owner
	    //       dateOfStatusText = null
	    //       break
	    //     case 3:
	    //       noticeText = translation(18223)         // An invitation has been sent by SMS or e-mail to the car owner, pending for approval of terms and conditions
	    //       dateOfStatusText = translation(18255)   // The car owner was invited
	    //       date = carOwnerPortalStatus.Logs.filter(x => x.Status === 3).slice(0, 1)[0].Date   // Latest date of invite
	    //       break
	    //     case 4:
	    //       noticeText = translation(18233)         // The invitation has previously been rejected by the car owner. Please ensure a verbal consent before re-sending the invitation.
	    //       dateOfStatusText = translation(18227)   // Rejected by car owner
	    //       date = carOwnerPortalStatus.Logs.filter(x => x.Status === 4).slice(0, 1)[0].Date   // Latest date of car owner decline
	    //       break
	    //   }
	    //   // console.log('carOwnerPortalStatus.Logs', carOwnerPortalStatus.Logs)
	
	    //   let carOwnerPortalLatestLogDate = null
	    //   if (carOwnerPortalStatus.Logs && carOwnerPortalStatus.Logs.length > 0) carOwnerPortalLatestLogDate = carOwnerPortalStatus.Logs[0].Date
	
	    //   return (
	    //     <Panel title={18217}>
	    //       {this.state.carrentalselectionmodal && <div className='carrentalselection_modal'>
	    //         <Modal
	    //           show={this.state.carrentalselectionmodal}
	    //           onClose={closeCarRentalSelectionModal}
	    //           header={translation(18219)}
	    //           icon={ModalIcons.Note}
	    //           bottomBarProps={{
	    //             actionLabelText: translation(18234),
	    //             onActionClick: this.sendInvitation
	    //           }}>
	    //           <div>
	    //             <div className='text-bold'>{noticeText}</div>
	    //             {dateOfStatusText} {renderFullDate(date)}
	    //           </div>
	    //         </Modal>
	    //       </div>}
	    //       <div className='car-owner'>
	    //         <LabelWrapper labelText={translation(18218)}>
	    //           <div>{renderStatusElement(carOwnerPortalStatus.Status)}</div>
	    //         </LabelWrapper>
	    //       </div>
	    //       <div className='car-owner'>
	    //         <Text
	    //           // className='size-large form-control'
	    //           labelText={31}
	    //           name='Phone'
	    //           value={carOwnerPortalStatus.Phone}
	    //           placeholder={translation(31)}
	    //           onChange={this.onChange}
	    //           onBlur={this.onBlur}
	    //         />
	    //         <a className={carOwnerPortalStatus.Phone ? 'element-re-send' : 'disabled-send'} href='#' onClick={() => this.openCarOwnerResendPopup('carrentalselectionmodal', true, false, carOwnerPortalLatestLogDate)} >{translation(18219)}</a>
	    //       </div>
	    //       <div className='car-owner'>
	    //         <Text
	    //           labelText={18183}
	    //           // className='size-large form-control'
	    //           name='Mail'
	    //           value={carOwnerPortalStatus.Mail}
	    //           placeholder={translation(18183)}
	    //           onChange={this.onChange}
	    //           onBlur={this.onBlur}
	    //         />
	    //         <a className={carOwnerPortalStatus.Mail ? 'element-re-send' : 'disabled-send'} href='#' onClick={() => this.openCarOwnerResendPopup('carrentalselectionmodal', false, true, carOwnerPortalLatestLogDate)} >{translation(18219)}</a>
	    //       </div>
	    //       <Divider />
	    //       <div className='car-owner'>
	    //         <PanelHeader text={translation(2211)} />
	    //         <ul>
	    //           <li>
	    //             <Grid cols={cols}>
	    //               <LabelWrapper labelText={translation(388)} />
	    //               <LabelWrapper labelText={translation(30)} />
	    //               <LabelWrapper labelText={translation(1021)} />
	    //             </Grid>
	    //           </li>
	    //           {carOwnerPortalStatus.Logs.map(renderLogElement)}
	    //         </ul>
	    //       </div>
	    //     </Panel>
	    //   )
	    // }
	
	  }, {
	    key: 'renderWreckedOrder',
	    value: function renderWreckedOrder() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	      var _props$order = this.props.order,
	          IsWrecked = _props$order.IsWrecked,
	          WreckedDate = _props$order.WreckedDate,
	          WreckedByName = _props$order.WreckedByName,
	          WreckedFromStep = _props$order.WreckedFromStep,
	          Notes = _props$order.Notes;
	
	      if (!IsWrecked) return null;
	
	      var step = (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', WreckedFromStep));
	      // If the wrecking has previously failed, use the newest wreck comment
	      var comment = [].concat(_toConsumableArray(Notes)).reverse().find(function (n) {
	        return n.SourceID === 20;
	      });
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('15244') },
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _time.renderFullDate)(WreckedDate),
	          '\xA0\xA0\xA0\xA0\xA0\xA0',
	          step,
	          ' - ',
	          WreckedByName,
	          comment !== undefined && _react2.default.createElement(
	            'div',
	            { className: 'qualityGroup' },
	            comment.Note
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPhotoDoc',
	    value: function renderPhotoDoc() {
	      var photo = this.state.photo;
	      if (photo === undefined || photo === null || photo.PhotoDocumentations === null) return null;
	
	      var renderEntry = function renderEntry(val, key) {
	        if (val[0] === undefined || val[0] === null) return null;
	        if (val[0].Images.length === 0) return null;
	        var renderEntry2 = function renderEntry2(val, key) {
	          var renderImage = function renderImage(v, key) {
	            if (v === undefined || v === null) return null;
	            return _react2.default.createElement(
	              'a',
	              { key: 'img_' + key, href: _constants.FILE_STORAGE + v.FileURL, 'data-lightbox': 'gallery_photodoc', 'data-title': v.FileName },
	              _react2.default.createElement('img', { style: /* Remove this */{ width: '100%' }, src: _constants.FILE_STORAGE + v.ThumbURL })
	            );
	          };
	
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', val.Step)) }),
	            _react2.default.createElement(
	              _grid2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                val.Images.map(renderImage)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _array.formatArrayToString)(val.Comment.Note),
	                _react2.default.createElement(_divider2.default, { noLine: true }),
	                _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { labelText: (0, _helpers.translation)('263') },
	                  _react2.default.createElement(_UserInfo2.default, { user: val.Comment.UserInfo })
	                ),
	                _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { labelText: (0, _helpers.translation)('176') },
	                  (0, _time.renderFullDate)(val.Comment.NoteDate)
	                ),
	                val.Comment.ShareType > 0 && _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { labelText: (0, _helpers.translation)('17861') },
	                  (0, _helpers.getOrderNoteShareString)(val.Comment.ShareType)
	                )
	              )
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          val.map(renderEntry2)
	        );
	      };
	
	      var renderEmptyPhotodocs = function renderEmptyPhotodocs() {
	        var itemFound = false;
	        photo.PhotoDocumentations.map(function (val) {
	          if (val[0] !== undefined) {
	            itemFound = true;
	          }
	        });
	        if (itemFound) return null;
	        return _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)('1920')
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('2065') },
	        _react2.default.createElement(
	          'div',
	          null,
	          renderEmptyPhotodocs(),
	          photo.PhotoDocumentations.map(renderEntry)
	        )
	      );
	    }
	  }, {
	    key: 'renderInternalDeviations',
	    value: function renderInternalDeviations() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	      // Access
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) return null;
	      // Internal deviation
	      var deviations = this.state.intDeviations;
	      if (deviations === undefined || deviations === null || deviations.length === 0) {
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('382') },
	          (0, _helpers.translation)('2094')
	        );
	      }
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('382') },
	        this.renderDeviations(deviations, 1)
	      );
	    }
	  }, {
	    key: 'renderExternalDeviations',
	    value: function renderExternalDeviations() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30)) return null;
	      // Access
	      if (this.props.auth.user.DepartmentType === 1 && (0, _auth.hasAccess)([4], this.props.auth.user.UserType)) return null;
	
	      var deviations = this.state.extDeviations;
	      var title = this.props.auth.user.DepartmentType !== 1 ? '383' : '32';
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) title = '32';
	
	      if (deviations === undefined || deviations === null || deviations.length === 0) {
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)(title) },
	          this.props.auth.user.DepartmentType === 1 || (0, _auth.hasAccess)([4], this.props.auth.user.UserType) ? (0, _helpers.translation)('16660') : (0, _helpers.translation)('2095')
	        );
	      }
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(title) },
	        this.renderDeviations(deviations, 2)
	      );
	    }
	  }, {
	    key: 'renderDeviations',
	    value: function renderDeviations(deviationArray, deviationType) {
	      var _this11 = this;
	
	      if (deviationArray === undefined || deviationArray == null || deviationArray.length === 0) return null;
	      var renderDeviation = function renderDeviation(deviation, key) {
	        if (deviation === undefined || deviation === null) return null;
	        var parts = deviation.Parts;
	        var files = deviation.DeviationFiles;
	        var renderPartsEntry = function renderPartsEntry(val, key) {
	          // let partName = val.Part.Name
	          // let partDict = val.Part.DictionaryKey
	          // // let partDictKey = val.Part.DictionaryKey
	          // let reasons = val.DeviationReasons
	          // let customReasons = val.CustomDeviationReasons
	          // // console.log('renderDeviations', val)
	          // const renderReasonEntry = (v, key) => {
	          //   // console.log('render reason entry')
	          //   // let reasonId = val.DeviationReasonId
	          //   // let deviationId = val.DeviationReasonId
	          //   let text = ''
	          //   if (!v.CustomDeviationReasonId) {
	          //     let classId = v.DeviationType.ClassId
	          //     let type = v.DeviationType.Type
	          //     switch (classId) {
	          //       case 1:
	          //         text = translation(enumtranslate('InternalDeviationTypes', type))
	          //         break
	          //       case 2:
	          //         text = translation(enumtranslate('ExternalDeviationTypes', type))
	          //         break
	          //     }
	          //   }
	          //   if (text === '') text = v.CustomReason
	          //   return (
	          //     <div key={'reason_' + key}>
	          //       <div>- {text}</div>
	          //     </div>
	          //   )
	          // }
	
	          return _react2.default.createElement(
	            'li',
	            { key: 'part_' + key, className: 'extent-content' },
	            _react2.default.createElement(_Part2.default, { part: val })
	          );
	        };
	
	        var renderFileEntry = function renderFileEntry(v, key) {
	          var file = v.OrderFile;
	          return _react2.default.createElement(
	            'a',
	            { href: _constants.FILE_STORAGE + file.FileURL, 'data-lightbox': 'gallery_deviations_' + deviationType, 'data-title': file.FileName, key: key },
	            _react2.default.createElement('img', { style: /* Remove this */{ width: '100%' }, src: _constants.FILE_STORAGE + file.ThumbURL })
	          );
	        };
	
	        // renderDeviation return
	        var hideCostFromBodyCustomer = _this11.props.auth.departmentType === 1 && !deviation.ShowCostCustomer;
	
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', deviation.StepId)) }),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              files !== undefined && files.map(renderFileEntry)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'ul',
	                null,
	                parts !== undefined && parts.map(renderPartsEntry)
	              ),
	              _react2.default.createElement(_divider2.default, null),
	              ((0, _auth.hasAccess)([3, 5, 7], _this11.props.auth.user.UserType) && !hideCostFromBodyCustomer || (0, _auth.hasAccess)([4], _this11.props.auth.user.UserType) && deviation.ShowCostCustomer) && _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('337') },
	                (0, _currency.formatCurrency)(deviation.Cost)
	              ),
	              (0, _auth.hasAccess)([3, 5, 7], _this11.props.auth.user.UserType) && deviation.ShowCostCustomer && _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('14940')
	              ),
	              (0, _auth.hasAccess)([3, 5, 7], _this11.props.auth.user.UserType) && deviation.TransferCostToInvoice && _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('14941')
	              ),
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              deviation.DeviationComment.Note !== null && (0, _array.formatArrayToString)(deviation.DeviationComment.Note),
	              _react2.default.createElement(_divider2.default, null),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('263') },
	                _react2.default.createElement(_UserInfo2.default, { user: deviation.DeviationComment.UserInfo })
	              ),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('176') },
	                (0, _time.renderFullDate)(deviation.DeviationComment.NoteDate)
	              ),
	              deviation.DeviationComment.ShareType > 0 && _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('17861') },
	                (0, _helpers.getOrderNoteShareString)(deviation.DeviationComment.ShareType)
	              )
	            )
	          )
	        );
	      };
	
	      // renderDeviatons return
	      return _react2.default.createElement(
	        'div',
	        null,
	        deviationArray.map(renderDeviation)
	      );
	    }
	  }, {
	    key: 'renderOtherDamage',
	    value: function renderOtherDamage() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      if (this.props.auth.departmentType !== 1) return null;
	
	      var otherDamages = this.state.otherDamages;
	
	      var renderDamage = function renderDamage(dmg, key) {
	        var renderFile = function renderFile(file, k) {
	          return _react2.default.createElement(
	            'a',
	            { href: _constants.FILE_STORAGE + file.FileURL, 'data-lightbox': 'gallery_otherDamage', 'data-title': file.FileName, key: k },
	            _react2.default.createElement('img', { src: _constants.FILE_STORAGE + file.ThumbURL })
	          );
	        };
	        var renderPart = function renderPart(part, k) {
	          var renderDmgItem = function renderDmgItem(item, j) {
	            var name = '';
	            if (item.Type === 10) {
	              name = item.CustomName;
	            } else {
	              name = (0, _helpers.translation)((0, _helpers.enumtranslate)('OtherDamageTypes', item.Type));
	            }
	
	            return _react2.default.createElement(
	              'div',
	              { key: 'damage_' + j },
	              _react2.default.createElement(
	                'div',
	                null,
	                '- ',
	                name
	              )
	            );
	          };
	
	          return _react2.default.createElement(
	            'div',
	            { key: 'part_' + k },
	            _react2.default.createElement(
	              'h3',
	              { className: 'h3' },
	              (0, _helpers.translation)(part.Part.DictionaryKey)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              part.OtherDamages && part.OtherDamages.map(renderDmgItem)
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            'div',
	            { className: 'stepName' },
	            (0, _helpers.translation)((0, _helpers.enumtranslate)('PaintShopOrderSteps', dmg.StepId))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'stepImageGallery clearfix divImages' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              dmg.Files.map(renderFile),
	              ' ',
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'ul',
	                null,
	                dmg.Parts.map(renderPart),
	                ' ',
	                _react2.default.createElement('br', null)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                dmg.Comment && (0, _array.formatArrayToString)(dmg.Comment.Note)
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { labelText: (0, _helpers.translation)('263') + ':' },
	                  _react2.default.createElement(_UserInfo2.default, { user: dmg.UserInfo })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('176'),
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    ': '
	                  ),
	                  (0, _time.renderFullDate)(dmg.Date)
	                )
	              )
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('15187') },
	        otherDamages === null || otherDamages.length === 0 ? (0, _helpers.translation)('16470') : _react2.default.createElement(
	          'ul',
	          null,
	          otherDamages.map(renderDamage)
	        )
	      );
	    }
	  }, {
	    key: 'renderEvaluation',
	    value: function renderEvaluation() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30) && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30)) return null;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13363') },
	        this.state.evaluation !== null ? _react2.default.createElement(_Evaluation2.default, { orderId: this.props.order.Id, evaluation: this.state.evaluation }) : (0, _helpers.translation)('13534')
	      );
	    }
	  }, {
	    key: 'renderAfterEvaluations',
	    value: function renderAfterEvaluations() {
	      var afterEvals = this.state.afterEvaluations;
	      if (afterEvals === null) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        afterEvals.map(this.renderAfterEvaluation)
	      );
	    }
	  }, {
	    key: 'renderAfterEvaluation',
	    value: function renderAfterEvaluation(afterEval, afterKey) {
	      var _this12 = this;
	
	      // renderImage
	      var renderImage = function renderImage(item, key) {
	        var url = _constants.FILE_STORAGE + item.ThumbURL;
	        var fullUrl = _constants.FILE_STORAGE + item.FileURL;
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            'a',
	            { href: fullUrl, 'data-lightbox': 'gallery_aftereval', 'data-title': item.FileName },
	            _react2.default.createElement('img', { src: url })
	          )
	        );
	      };
	      // renderRefinishType
	      var renderRefinishType = function renderRefinishType(type, key) {
	        if (type.ReportTask !== null && type.ApromasTasks.length === 0) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clearfix', key: 'refinish_' + key },
	            _react2.default.createElement(
	              'div',
	              null,
	              type.ReportTask !== null && _react2.default.createElement(
	                'strong',
	                null,
	                type.ReportTask.ReportItemLineNumber
	              ),
	              type.ReportTask !== null && type.ReportTask.ReportItemLineText
	            )
	          );
	        }
	        var renderTask = function renderTask(item, k) {
	          return _react2.default.createElement(
	            'div',
	            { key: 'refinish_' + key + '_task_' + k },
	            item.Type
	          );
	        };
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: 'refinish_' + key },
	          type.ReportTask !== null && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { className: 'strike_through' }),
	            type.ReportTask !== null && _react2.default.createElement(
	              'strong',
	              null,
	              type.ReportTask.ReportItemLineNumber
	            ),
	            type.ReportTask !== null && type.ReportTask.ReportItemLineText
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            type.ApromasTasks.map(renderTask)
	          )
	        );
	      };
	      // renderStartTime
	      var renderStartTime = function renderStartTime(time, key) {
	        /* // let type = 1
	        let startTime = time.ReportTask !== null ? time.ReportTask.StartTimePlastic : null
	        let text = translation('413')
	        if (time.ReportTask !== null && time.ReportTask.StartTimePlastic !== null) {
	          // type = 1
	          startTime = time.ReportTask.StartTimePlastic
	          text = translation('413')
	        } else if (time.ReportTask !== null && time.ReportTask.StartTimeMetal !== null) {
	          // type = 2
	          startTime = time.ReportTask.StartTimeMetal
	          text = translation('414')
	        } else if (time.ReportTask !== null && time.ReportTask.StartTimeSpot !== null) {
	          // type = 3
	          startTime = time.ReportTask.StartTimeSpot
	          text = translation('13250')
	        } else if (time.ReportTask !== null && time.ReportTask.StartTimeTwoColor !== null) {
	          // type = 4
	          startTime = time.ReportTask.StartTimeTwoColor
	          text = translation('13251')
	        } */
	        if (time.ReportTask !== null && time.ApromasTasks.length === 0) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clearfix', key: 'refinish_' + key },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                time.ReportTask.ReportItemLineText
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                time.ReportTask.ReportItemWorkUnits,
	                ' ',
	                (0, _helpers.translation)('885')
	              )
	            )
	          );
	        }
	        var renderTask = function renderTask(item, k) {
	          return _react2.default.createElement(
	            'div',
	            { key: 'refinish_task_' + k },
	            item.Type,
	            ' (',
	            item.Ae,
	            ' ',
	            (0, _helpers.translation)('885'),
	            ')'
	          );
	        };
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: 'refinish_' + key },
	          time.ReportTask !== null && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { className: 'strike_through' }),
	            _react2.default.createElement(
	              'strong',
	              null,
	              time.ReportTask.ReportItemLineText
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              time.ReportTask.ReportItemWorkUnits,
	              ' ',
	              (0, _helpers.translation)('885')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            time.ApromasTasks.map(renderTask)
	          )
	        );
	      };
	      // renderHourPrice
	      var renderHourPrice = function renderHourPrice(hour, key) {
	        if (hour.ReportTask !== null && hour.ApromasTasks.length === 0) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clearfix', key: 'hourly_' + key },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                (0, _helpers.translation)('419')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                hour.ReportTask.HourPrice,
	                ' ',
	                _this12.props.currencyCode
	              )
	            )
	          );
	        }
	        var renderTask = function renderTask(item, k) {
	          return _react2.default.createElement(
	            'div',
	            { key: 'hourly_task_' + k },
	            item.Price
	          );
	        };
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: 'hourly_' + key },
	          hour.ReportTask !== null && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { className: 'strike_through' }),
	            _react2.default.createElement(
	              'strong',
	              null,
	              (0, _helpers.translation)('419')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              hour.ReportTask.HourPrice,
	              ' ',
	              _this12.props.currencyCode
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            hour.ApromasTasks.map(renderTask)
	          )
	        );
	      };
	      // renderMaterialShare
	      var renderMaterialShare = function renderMaterialShare(share, key) {
	        if (share.ReportTask !== null && share.ApromasTasks.length === 0) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clearfix', key: 'share_' + key },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                (0, _helpers.translation)('415')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                share.ReportTask.ReportItemGenericValue
	              )
	            )
	          );
	        }
	        var renderTask = function renderTask(item, k) {
	          return _react2.default.createElement(
	            'div',
	            { key: 'share_task_' + k },
	            item.Share,
	            '%'
	          );
	        };
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: 'share_' + key },
	          share.ReportTask !== null && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { className: 'strike_through' }),
	            _react2.default.createElement(
	              'strong',
	              null,
	              (0, _helpers.translation)('415')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              share.ReportTask.ReportItemGenericValue
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            share.ApromasTasks.map(renderTask)
	          )
	        );
	      };
	      // renderTask
	      var renderTask = function renderTask(task, key) {
	        if (task.ReportTask === null) return null;
	        if (task.ApromasTasks.length === 0) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clearfix', key: 'tasks_' + key },
	            _react2.default.createElement(
	              'strong',
	              null,
	              task.ReportTask.ReportItemLineText
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'span',
	                null,
	                task.ReportTask.ReportItemAdditionalText
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                task.ReportTask.ReportItemWorkUnits,
	                ' ',
	                (0, _helpers.translation)('885')
	              )
	            )
	          );
	        }
	        var renderTask = function renderTask(item, k) {
	          var renderExtra = function renderExtra(extra, k) {
	            return _react2.default.createElement(
	              'div',
	              { key: 'tasks_task_extra_' + k },
	              extra.Name
	            );
	          };
	          return _react2.default.createElement(
	            'li',
	            { className: 'clearfix childitem', key: 'tasks_task_' + k },
	            _react2.default.createElement(
	              'span',
	              null,
	              item.TaskName,
	              ' ',
	              item.ExtentType
	            ),
	            _react2.default.createElement('span', null),
	            item.TaskExtras.length !== 0 && _react2.default.createElement(
	              'div',
	              { className: 'extraThousands' },
	              item.TaskExtras.map(renderExtra)
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: 'tasks_' + key },
	          _react2.default.createElement(
	            'strong',
	            null,
	            task.ReportTask.ReportItemLineText
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              'span',
	              null,
	              task.ReportTask.ReportItemAdditionalText
	            ),
	            _react2.default.createElement('div', { className: 'strike_through' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              task.ReportTask.ReportItemWorkUnits,
	              ' ',
	              (0, _helpers.translation)('885')
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            task.ApromasTasks.map(renderTask)
	          )
	        );
	      };
	      // renderAddon
	      var renderAddon = function renderAddon(addon, key) {
	        var renderTask = function renderTask(task, k) {
	          var renderExtra = function renderExtra(val, k) {
	            var valMatText = '';
	            if (val.AE !== 0 || val.Material !== 0) {
	              var commaSep = '';
	              if (val.AE !== 0 && val.Material !== 0) commaSep = ', ';
	              valMatText += '(';
	              if (val.AE !== 0) valMatText += val.AE + ' ' + (0, _helpers.translation)('885');
	              valMatText += commaSep;
	              if (val.Material !== 0) valMatText += val.Material + ' ' + (0, _helpers.translation)('13338');
	              valMatText += ')';
	            }
	            return _react2.default.createElement(_Line2.default, { text: val.Name + ' ' + valMatText, subLine: true, key: k });
	          };
	          return _react2.default.createElement(
	            _Line2.default,
	            { text: task.TaskName + ' ' + task.ExtentType, subLine: true, key: k },
	            task.TaskExtras.map(renderExtra)
	          );
	        };
	
	        return _react2.default.createElement(
	          'li',
	          { className: 'extent-content', key: key },
	          _react2.default.createElement(
	            'div',
	            { className: 'partname' },
	            (0, _helpers.translation)(addon.Part.DictionaryKey)
	          ),
	          addon.ApromasTasks.map(renderTask)
	        );
	      };
	
	      var hasAddons = afterEval.Items.Addons.length > 0 || afterEval.Items.AddonStartTimes.length > 0 || afterEval.Items.Addons.AddonHourPrices > 0 || afterEval.Items.Addons.AddonMaterialsShares > 0 || afterEval.Items.Addons.AddonRefinishTypes > 0;
	
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1037') },
	        _react2.default.createElement(
	          'ul',
	          null,
	          afterEval.Items.RefinishTypes.map(renderRefinishType),
	          afterEval.Items.StartTimes.map(renderStartTime),
	          afterEval.Items.HourPrices.map(renderHourPrice),
	          afterEval.Items.MaterialsShares.map(renderMaterialShare),
	          afterEval.Items.Tasks.map(renderTask)
	        ),
	        hasAddons && [_react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('2256'), key: 'header' }), _react2.default.createElement(
	          'ul',
	          { key: 'list' },
	          afterEval.Items.Addons.map(renderAddon),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          afterEval.Items.AddonRefinishTypes.length > 0 && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('1999') },
	            afterEval.Items.AddonRefinishTypes.map(renderRefinishType)
	          ),
	          afterEval.Items.AddonStartTimes.length > 0 && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('1195') },
	            afterEval.Items.AddonStartTimes.map(renderStartTime)
	          ),
	          afterEval.Items.AddonHourPrices.length > 0 && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('419') },
	            afterEval.Items.AddonHourPrices.map(renderHourPrice)
	          ),
	          afterEval.Items.AddonMaterialsShares.length > 0 && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('415') },
	            afterEval.Items.AddonMaterialsShares.map(renderMaterialShare)
	          )
	        )],
	        afterEval.Photos.length !== 0 && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1011') },
	          _react2.default.createElement(_Gallery2.default, { files: afterEval.Photos, renderImage: renderImage })
	        ),
	        afterEval.Comment !== null && [(!(0, _auth.hasAccess)([4], this.props.auth.user.UserType) || (0, _auth.hasAccess)([4], this.props.auth.user.UserType) && afterEval.Comment.NoteTypeID === 1) && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('149'), key: 'comment' },
	          _react2.default.createElement(
	            'div',
	            null,
	            afterEval.Comment.Note
	          )
	        ), !(0, _auth.hasAccess)([4], this.props.auth.user.UserType) && _react2.default.createElement(
	          'div',
	          { key: 'noteinfo' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13429') },
	            afterEval.Comment.NoteTypeID === 1 ? (0, _helpers.translation)('47') : (0, _helpers.translation)('48')
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('1785') },
	            afterEval.Comment.ApplyToInvoice ? (0, _helpers.translation)('47') : (0, _helpers.translation)('48')
	          ),
	          afterEval.Comment.ShareType > 0 && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('17861') },
	            (0, _helpers.getOrderNoteShareString)(afterEval.Comment.ShareType)
	          )
	        )],
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('263') },
	          _react2.default.createElement(_UserInfo2.default, { user: afterEval.UserInfo })
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('176') },
	          (0, _time.renderFullDate)(afterEval.CreatedDate)
	        )
	      );
	    }
	  }]);
	
	  return Documentation;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    order: state.orders.order,
	    brands: state.common.brands,
	    orderTypes: state.common.enums.orderTypes,
	    transport: state.common.transport,
	    doors: state.common.doors,
	    loosePartType: state.common.loosePartType,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getDocQuality: _documentation.getDocQuality,
	  getDocProcess: _documentation.getDocProcess,
	  getDocPhoto: _documentation.getDocPhoto,
	  getDocDeviations: _documentation.getDocDeviations,
	  getDocEvaluations: _documentation.getDocEvaluations,
	  getDocOtherDamages: _documentation.getDocOtherDamages,
	  getCarOwnerStatus: _carownerportal.getCarOwnerStatus,
	  triggerPopupActionBG: _backdrop.triggerPopupActionBG,
	  // openOverlay,
	  triggerPopup: _backdrop.triggerPopup,
	  updateCarOwner: _carownerportal.updateCarOwner,
	  sendInvitation: _carownerportal.sendInvitation
	})(Documentation);

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1430);
	
	var _orders = __webpack_require__(21);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Components
	// import HelpText from '../../../../shared/components/HelpText'
	
	
	// Utils
	
	
	// Elements
	// import TabBar from '../../../../shared/elements/tabBar'
	
	
	var Log = function (_Component) {
	  _inherits(Log, _Component);
	
	  function Log(props) {
	    _classCallCheck(this, Log);
	
	    var _this = _possibleConstructorReturn(this, (Log.__proto__ || Object.getPrototypeOf(Log)).call(this, props));
	
	    _this.state = {
	      log: [{
	        ChangedByShopName: '',
	        ChangedBy: '',
	        ChangedByRole: 0,
	        ChangedByMail: '',
	        ChangedByMobile: '',
	        Date: undefined,
	        TypeDictionaryKey: 0,
	        ValueDictionaryKey: 0,
	        ValueParameters: []
	      }],
	      notifications: [{
	        UserName: '',
	        SendTime: undefined,
	        MessageType: 0,
	        EventType: 0
	      }]
	    };
	    _this.getOrderLog = _this.getOrderLog.bind(_this);
	    _this.getOrderNotifications = _this.getOrderNotifications.bind(_this);
	    return _this;
	  }
	
	  _createClass(Log, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOrderLog();
	      this.getOrderNotifications();
	    }
	  }, {
	    key: 'getOrderLog',
	    value: function getOrderLog() {
	      var _this2 = this;
	
	      this.props.GetLog(this.props.router.params.orderID).then(function (res) {
	        _this2.setState({
	          log: res.data
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('2212'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'getOrderNotifications',
	    value: function getOrderNotifications() {
	      var _this3 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) return null;
	      this.props.GetOrderNotifications(this.props.router.params.orderID).then(function (res) {
	        _this3.setState({
	          notifications: res.data
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('2213'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderOrderLog',
	    value: function renderOrderLog() {
	      var _this4 = this;
	
	      var cols = [1.2, 1, 2.5];
	      var log = this.state.log;
	      var hasData = log !== undefined;
	
	      var getLogLineText = function getLogLineText(item, key) {
	        if (item === '<br />') return _react2.default.createElement('br', null);
	        return _react2.default.createElement('div', { key: key, dangerouslySetInnerHTML: { __html: item } });
	      };
	
	      var getTranslatedLogLineText = function getTranslatedLogLineText(item, key) {
	        if (item === '<br />') return _react2.default.createElement('br', { key: key });
	        return (0, _helpers.translation)(item);
	        // return (
	        //   <div key={key} dangerouslySetInnerHTML={{__html: translation(item)}} />
	        // )
	      };
	      var getDescriptionText = function getDescriptionText(item) {
	        var value = '';
	        var returnValueParam = false;
	        var translateValueParam = false;
	        if (item.ValueDictionaryKey > 0) {
	          value = (0, _helpers.translation)(item.ValueDictionaryKey);
	        } else {
	          translateValueParam = true;
	        }
	
	        if (item.ValueParameters && item.ValueParameters.length > 0) {
	          for (var i = 0; i < item.ValueParameters.length; i++) {
	            if (item.ValueParameters[i].includes('{stop}')) {
	              item.ValueParameters[i] = item.ValueParameters[i].replace('{stop}', '');
	              value = '';
	            }
	          }
	        }
	        if (item.ValueParameters && value.includes('{0}')) {
	          for (var _i = 0; _i < item.ValueParameters.length; _i++) {
	            if (value.includes('{' + _i + '}')) {
	              value = value.replace('{' + _i + '}', item.ValueParameters[_i]);
	            }
	          }
	        } else {
	          returnValueParam = true;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'description' },
	          value,
	          returnValueParam ? translateValueParam ? '' : _react2.default.createElement('br', null) : '',
	          item.ValueParameters && (returnValueParam ? translateValueParam ? item.ValueParameters.map(getTranslatedLogLineText) : item.ValueParameters.map(getLogLineText) : '')
	        );
	      };
	
	      var renderLogLine = function renderLogLine(val, key) {
	        var shopName = '';
	        var roleName = '';
	        if (val.ChangedByShopName) {
	          shopName = val.ChangedByShopName;
	          roleName = '\n';
	        }
	        if (val.ChangedByRole !== 0 && val.ChangedByRole !== 100) roleName += (0, _helpers.translation)(_this4.props.roleType[val.ChangedByRole]);
	        var mailAndPhone = '';
	        if (val.ChangedByMail) mailAndPhone = '\n' + val.ChangedByMail;
	        if (val.ChangedByMobile) mailAndPhone += '\n' + val.ChangedByMobile;
	
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: cols },
	            _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              (0, _time.renderFullDate)(val.Date)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'user' },
	              _react2.default.createElement(_labelWrapper2.default, { labelText: val.ChangedBy, helpText: roleName && shopName + roleName + mailAndPhone })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text' },
	              _react2.default.createElement(
	                'div',
	                { className: 'full' },
	                val.TypeDictionaryKey && (0, _helpers.translation)(val.TypeDictionaryKey)
	              ),
	              getDescriptionText(val)
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('2211') },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: cols },
	              _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('388') }),
	              _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('30') }),
	              _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('1021') })
	            )
	          ),
	          hasData && log.map(renderLogLine)
	        )
	      );
	    }
	  }, {
	    key: 'renderNotificationsLog',
	    value: function renderNotificationsLog() {
	      var _this5 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) return null;
	      var log = this.state.notifications;
	      var hasData = log !== undefined;
	      var cols = [2, 2, 1, 4];
	
	      var renderLogLine = function renderLogLine(val, key) {
	        var messageTypeText = '';
	
	        var eventText = (0, _helpers.translation)(_this5.props.notificationEventType[val.EventType]);
	
	        switch (val.MessageType) {
	          case 0:
	            messageTypeText = (0, _helpers.translation)('15');
	            break;
	          case 1:
	            messageTypeText = (0, _helpers.translation)('151');
	            break;
	        }
	
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: cols, spacing: 2 },
	            _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              (0, _time.renderFullDate)(val.SendTime)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'user' },
	              val.UserName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'messagetype' },
	              messageTypeText
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'eventtype' },
	              eventText
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13461') },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: cols },
	              _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('388') }),
	              _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)(30) + '/' + (0, _helpers.translation)(1052) }),
	              _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('332') }),
	              _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('1021') })
	            )
	          ),
	          hasData && log.map(renderLogLine)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'log__screen clearfix' },
	        !this.props.disabled && _react2.default.createElement(
	          _Header2.default,
	          {
	            router: this.props.router,
	            showBack: true,
	            headerButtonsGoBack: this.props.renderButtonsGoBack,
	            renderButtons: function renderButtons() {
	              return [];
	            }
	          },
	          this.props.renderTabs()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { span: '3' },
	          this.renderOrderLog()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { span: '3' },
	          this.renderNotificationsLog()
	        )
	      );
	    }
	  }]);
	
	  return Log;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    order: state.orders.order,
	    roleType: state.common.enums_new.AccessLevels,
	    notificationEventType: state.common.enums_new.NotificationEventType
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetLog: _orders.GetLog,
	  GetOrderNotifications: _orders.GetOrderNotifications
	})(Log);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _common = __webpack_require__(25);
	
	var _backdrop = __webpack_require__(29);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _CarRentalContractOverlay = __webpack_require__(1117);
	
	var _CarRentalContractOverlay2 = _interopRequireDefault(_CarRentalContractOverlay);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icons = __webpack_require__(6);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// components
	
	
	// elements
	
	
	// utils
	
	
	var CarRentalContract = function (_Component) {
	  _inherits(CarRentalContract, _Component);
	
	  function CarRentalContract(props) {
	    _classCallCheck(this, CarRentalContract);
	
	    var _this = _possibleConstructorReturn(this, (CarRentalContract.__proto__ || Object.getPrototypeOf(CarRentalContract)).call(this, props));
	
	    _this.state = {
	      selectedCarRentalId: null
	    };
	
	    _this.openOverlay = _this.openOverlay.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.openPopup = _this.openPopup.bind(_this);
	    _this.getCars = _this.getCars.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarRentalContract, [{
	    key: 'openOverlay',
	    value: function openOverlay(e) {
	      var _this2 = this;
	
	      e.persist();
	      if (e.target !== null && e.target.id.indexOf('_') !== -1) {
	        var carRentalId = parseInt(e.target.id.split('_')[1]);
	        this.setState({ selectedCarRentalId: carRentalId }, function () {
	          // console.log('Open (multi) with orderId', this.props.order.Id, ' selectedCarRentalId', this.state.selectedCarRentalId)
	          _this2.props.openOverlay('CarRentalContractOverlay');
	        });
	      } else {
	        // console.log('Open with orderId', this.props.order.Id, ' selectedCarRentalId', this.state.selectedCarRentalId)
	        this.props.openOverlay('CarRentalContractOverlay');
	      }
	      // e.preventDefault()
	      this.setState({
	        carrentalselectionmodal: false
	      });
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'openPopup',
	    value: function openPopup(modal) {
	      this.setState(_defineProperty({}, modal, true));
	      this.props.triggerPopup(true);
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.setState({
	        selectedCarRentalId: null
	      });
	      this.props.onUpdateOrder;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var _this3 = this;
	
	      var cars = this.getCars();
	      if (cars.length > 1) {
	        this.openPopup('carrentalselectionmodal');
	      } else {
	        this.setState({ selectedCarRentalId: cars[0].CarRentalId }, function () {
	          _this3.openOverlay(e);
	        });
	      }
	    }
	  }, {
	    key: 'getCars',
	    value: function getCars() {
	      var cars = {};
	      if (this.props.order !== undefined) {
	        if (Array.isArray(this.props.order.CarRentalAssignments)) {
	          var assignments = this.props.order.CarRentalAssignments;
	          for (var i = 0; i < assignments.length; i++) {
	            if (assignments[i].CarRentalId === null) continue;
	            if (cars[assignments[i].CarRentalId] === undefined) {
	              cars[assignments[i].CarRentalId] = {
	                CarRentalId: assignments[i].CarRentalId,
	                CarNumber: assignments[i].CarNumber,
	                Identity: assignments[i].Identity
	              };
	            }
	          }
	        }
	      }
	      var carsArray = Object.keys(cars).map(function (x) {
	        return cars[x];
	      });
	      // if (this.props.order.CarRentalId > 0 && carsArray.findIndex(x => x.CarRentalId !== this.props.order.CarRentalId) === -1) {
	      //   carsArray.push({ CarRentalId: this.props.order.CarRentalId, CarNumber: this.props.order.CarRentalNumber, Identity: this.props.order.CarRentalRegNumber })
	      // }
	      return carsArray;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var disabled = !this.props.order.CurrentShopCanAssignRentalCar;
	      var carsArray = this.getCars();
	      var renderCar = function renderCar(car, i) {
	        var carText = car.CarNumber + '. ' + car.Identity;
	        return _react2.default.createElement(_button2.default, { key: 'car_' + i, style: 'secondary', id: 'car_' + car.CarRentalId, labelText: carText, onClick: _this4.openOverlay });
	      };
	
	      var closeCarRentalSelectionModal = function closeCarRentalSelectionModal() {
	        _this4.props.triggerPopup(false);
	        _this4.setState({
	          carrentalselectionmodal: false
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { noSubmit: true, name: 'CarRentalContract', style: 'secondary', labelText: (0, _helpers.translation)(16781), onClick: this.handleClick, disabled: disabled }),
	        this.state.carrentalselectionmodal && _react2.default.createElement(
	          'div',
	          { className: 'carrentalselection_modal' },
	          _react2.default.createElement(
	            _Modal2.default,
	            {
	              show: this.state.carrentalselectionmodal,
	              onClose: closeCarRentalSelectionModal,
	              header: (0, _helpers.translation)(16781),
	              icon: _icons.ModalIcons.CarRental },
	            _react2.default.createElement(
	              'div',
	              null,
	              carsArray.map(renderCar)
	            )
	          )
	        ),
	        this.state.selectedCarRentalId && this.props.order && _react2.default.createElement(_CarRentalContractOverlay2.default, { order: this.props.order, carRentalId: this.state.selectedCarRentalId, onClose: this.onClose })
	      );
	    }
	  }]);
	
	  return CarRentalContract;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { openOverlay: _common.openOverlay, triggerPopup: _backdrop.triggerPopup })(CarRentalContract);

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _backdrop = __webpack_require__(29);
	
	var _orders = __webpack_require__(21);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _HandleFilesModal = __webpack_require__(1089);
	
	var _HandleFilesModal2 = _interopRequireDefault(_HandleFilesModal);
	
	var _async = __webpack_require__(147);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Files = function (_PureComponent) {
	  _inherits(Files, _PureComponent);
	
	  function Files(props) {
	    _classCallCheck(this, Files);
	
	    var _this = _possibleConstructorReturn(this, (Files.__proto__ || Object.getPrototypeOf(Files)).call(this, props));
	
	    _this.state = {
	      confirmFileDelete: {
	        confirm: false,
	        file: null
	      },
	      handleFilesPopupOpen: false,
	      upload: {
	        loading: false,
	        errors: []
	      }
	    };
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.updateImages = _this.updateImages.bind(_this);
	    _this.togglePopup = _this.togglePopup.bind(_this);
	    return _this;
	  }
	
	  _createClass(Files, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkFileTimer = setInterval(this.updateImages, 3000);
	    }
	  }, {
	    key: 'updateImages',
	    value: function updateImages() {
	      var _this2 = this;
	
	      if (Object.keys(this.props.order).length === 0) return null;
	      if (window.location.hostname === 'localhost') return null;
	      var files = [].concat(_toConsumableArray(this.props.order.OrderFiles));
	      var order = _extends({}, this.props.order);
	      var readyChecks = 0;
	
	      var _loop = function _loop(i) {
	        if (files[i].IsImage) {
	          var img = files[i];
	          if (img.IsFinishedLoading === false) {
	            // Check with api if file is ready.
	            readyChecks++;
	            _this2.props.isFileReady(img.OrderFileID).then(function (res) {
	              if (res.data.FileReady === true) {
	                var append = '?preventCache=' + Math.random() * 10;
	                img.IsFinishedLoading = true;
	                img.ThumbURL = res.data.ThumbURL + append;
	                img.FileURL = res.data.FileURL + append;
	                order.OrderFiles[i] = img;
	                _this2.props.saveSingleValue('OrderFiles', order.OrderFiles);
	              }
	            });
	          }
	        }
	      };
	
	      for (var i = 0; i < files.length && readyChecks < 3; i++) {
	        _loop(i);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.checkFileTimer);
	    }
	  }, {
	    key: 'togglePopup',
	    value: function togglePopup() {
	      this.props.triggerPopup(!this.state.handleFilesPopupOpen);
	      this.setState({
	        handleFilesPopupOpen: !this.state.handleFilesPopupOpen
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this3 = this;
	
	      var errors = this.state.upload.errors;
	
	      var isCustomer = this.props.auth.user.CustomerId !== '-1';
	      // Delete file
	      var deleteFile = function deleteFile(file) {
	        var confirm = {
	          confirm: true,
	          file: file
	        };
	        _this3.setState({
	          confirmFileDelete: confirm
	        });
	      };
	
	      // Show delete
	      var showDelete = true;
	      if (isCustomer) {
	        if (!this.props.order.IsDraft) {
	          showDelete = false;
	        }
	      }
	
	      // Render image
	      var renderImage = function renderImage(image, index) {
	        if (image.SharingType === 0 && !image.IsCurrentShopFile) return null;
	        var url = _constants.FILE_STORAGE + image.ThumbURL;
	        var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-image' },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, alignChildren: 'top', spacing: 0 },
	            !isCustomer && image.SharingType === 1 && _react2.default.createElement(_icon2.default, { icon: _icons.MainMenuIcons.Customers_Black, size: 's', injectSvg: true }),
	            showDelete && image.IsDeletable && _react2.default.createElement(
	              'div',
	              { className: 'file-delete' },
	              _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	                  return deleteFile(image);
	                }, size: 's' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'divImg' },
	            _react2.default.createElement(
	              'a',
	              { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	              _react2.default.createElement('img', { src: url })
	            )
	          )
	        );
	      };
	      // Render file
	      var renderFile = function renderFile(file, index) {
	        // let fileUrl = file.FileURL.replace('API/', '')
	        if (file.ActualFileName === null || file.SharingType === 0 && !file.IsCurrentShopFile) return null;
	        var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(_this3.props.auth.user.Token);
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	        var fileError = function fileError() {
	          window.toastr.error((0, _helpers.translation)('15191'), (0, _helpers.translation)('216'));
	        };
	        // Return
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-document clearfix' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          file.FileExists ? _react2.default.createElement(
	            'a',
	            { target: '_BLANK', href: newFileUrl },
	            file.FileName
	          ) : _react2.default.createElement(
	            'a',
	            { onClick: fileError },
	            file.FileName
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { alignChildren: 'top', spacing: 0 },
	            !isCustomer && file.SharingType === 1 && _react2.default.createElement(_icon2.default, { icon: _icons.MainMenuIcons.Customers_Black, size: 's', injectSvg: true }),
	            showDelete && file.IsDeletable && _react2.default.createElement(
	              'div',
	              { className: 'file-delete' },
	              _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	                  return deleteFile(file);
	                }, size: 's' })
	            )
	          )
	        );
	      };
	      // On drop
	      var onDrop = function onDrop() {
	        _this3.setState({ upload: _extends({}, _this3.state.upload, { errors: [] }) });
	      };
	      // On drop accepted
	      var onDropAccepted = function onDropAccepted(files) {
	        var newErrors = [];
	        _this3.setState({
	          upload: _extends({}, _this3.state.upload, {
	            loading: true,
	            errors: []
	          })
	        });
	        _async2.default.each(files, function (file, cb) {
	          // Upload each file
	          _this3.props.uploadFileToOrder(file, _this3.props.order.Id).then(function (res) {
	            cb();
	          }, function () {
	            newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13406') + '.');
	            cb();
	          });
	        }, function () {
	          if (newErrors.length !== 0) {
	            _this3.setState({
	              upload: _extends({}, _this3.state.upload, {
	                errors: _this3.state.upload.errors.concat(newErrors)
	              })
	            });
	          }
	          _this3.setState({
	            upload: _extends({}, _this3.state.upload, {
	              loading: false
	            })
	          });
	          // Save order first
	          var mock = {
	            preventDefault: function preventDefault() {}
	          };
	          _this3.props.saveWorkcard(mock).then(function () {
	            _this3.props.onUpdateOrder();
	          }, function () {
	            _this3.props.onUpdateOrder();
	          });
	        });
	      };
	      // On drop rejected
	      var onDropRejected = function onDropRejected(files) {
	        var newErrors = [];
	        files.map(function (val, index) {
	          newErrors.push((0, _helpers.translation)('1207') + ': ' + val.name + ' ' + (0, _helpers.translation)('13405') + '.');
	        });
	        _this3.setState({ upload: _extends({}, _this3.state.upload, { errors: newErrors }) });
	      };
	      // Render error
	      var renderError = function renderError(error, index) {
	        return _react2.default.createElement(
	          'p',
	          { key: index },
	          error
	        );
	      };
	      // Other files
	      var otherFiles = [].concat(_toConsumableArray(this.props.order.OrderFiles));
	      otherFiles = otherFiles.filter(function (val, index) {
	        return !val.IsImage;
	      });
	      // imgFiles
	      var imgFiles = [].concat(_toConsumableArray(this.props.order.OrderFiles));
	      imgFiles = imgFiles.filter(function (val, index) {
	        return val.IsImage;
	      });
	
	      // Confirm delete
	      var onPortalClose = function onPortalClose() {
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	        _this3.setState({
	          confirmFileDelete: confirm
	        });
	      };
	      var onConfirm = function onConfirm() {
	        var file = _this3.state.confirmFileDelete.file;
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	        _this3.setState({ confirmFileDelete: confirm }, function () {
	          _this3.props.deleteFileFromOrder(file).then(function (_) {
	            return _this3.props.onUpdateOrder();
	          }).catch(function (err) {
	            if (err.response && err.response.status === 400) {
	              var _err$response$data = err.response.data,
	                  dictionaryKey = _err$response$data.dictionaryKey,
	                  translationParams = _err$response$data.translationParams;
	
	              window.toastr.error((0, _helpers.translation)(dictionaryKey, translationParams), (0, _helpers.translation)('216'));
	            }
	          });
	        });
	      };
	
	      // Render
	      var isMultipleUpload = true;
	      return _react2.default.createElement(
	        'div',
	        null,
	        errors.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          errors.map(renderError)
	        ),
	        this.props.disabled !== true && _react2.default.createElement(
	          _Dropzone2.default,
	          {
	            onDrop: onDrop,
	            onDropAccepted: onDropAccepted,
	            onDropRejected: onDropRejected,
	            multiple: isMultipleUpload,
	            includeCircles: false },
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)('13397')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'files_inner' },
	          _react2.default.createElement(
	            'div',
	            null,
	            otherFiles.map(renderFile)
	          ),
	          _react2.default.createElement(_Gallery2.default, { files: imgFiles, renderImage: renderImage })
	        ),
	        !isCustomer && _react2.default.createElement(_button2.default, { style: 'secondary', labelText: (0, _helpers.translation)(16812), onClick: this.togglePopup }),
	        this.state.confirmFileDelete.confirm && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onPortalClose })
	        ),
	        this.state.handleFilesPopupOpen && _react2.default.createElement(_HandleFilesModal2.default, {
	          onClose: this.togglePopup,
	          show: this.state.handleFilesPopupOpen,
	          orderId: this.props.order.Id })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.whitebox) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.renderContent()
	        );
	      }
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1043'), dataCol: 'files' },
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return Files;
	}(_react.PureComponent);
	
	Files.defaultProps = {
	  datacol: '',
	  hideContent: false,
	  editAllowed: true,
	  whitebox: true
	};
	
	Files.propTypes = {
	  onUpdateOrder: _propTypes2.default.func.isRequired,
	  order: _propTypes2.default.object.isRequired,
	  auth: _propTypes2.default.object.isRequired
	};
	
	Files.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    orderTypes: state.common.enums.orderTypes,
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  triggerPopupActionBG: _backdrop.triggerPopupActionBG,
	  isFileReady: _orders.isFileReady,
	  uploadFileToOrder: _orders.uploadFileToOrder,
	  deleteFileFromOrder: _orders.deleteFileFromOrder
	})(Files);

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	__webpack_require__(255);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var InputCheckbox = function (_PureComponent) {
	  _inherits(InputCheckbox, _PureComponent);
	
	  function InputCheckbox(props) {
	    _classCallCheck(this, InputCheckbox);
	
	    var _this = _possibleConstructorReturn(this, (InputCheckbox.__proto__ || Object.getPrototypeOf(InputCheckbox)).call(this, props));
	
	    _this.state = {};
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onDisabledClick = _this.onDisabledClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(InputCheckbox, [{
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      // console.log('[InputCheckbox] change', e.target.name, e.target.value, e.target.checked)
	      this.props.onChange(e);
	    }
	  }, {
	    key: 'onDisabledClick',
	    value: function onDisabledClick(e) {
	      if (this.props.disabled) {
	        this.props.onDisabledClick(e);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      // const renderTitle = () => {
	      //   let title = this.props.title
	      //   if (!isNaN(Number(title))) title = translation(this.props.title)
	      //   return (
	      //     <label>{title}{this.props.icon}</label>
	      //   )
	      // }
	      var value = this.props.name;
	      var checked = this.props.checked;
	      // let className = 'checkbox__custom ' + this.props.extraClassName
	
	      var label = this.props.title;
	      if (!isNaN(Number(label))) label = (0, _helpers.translation)(this.props.title);
	
	      return _react2.default.createElement(_check2.default, {
	        id: value + '_input',
	        name: value,
	        value: '1',
	        onChange: this.onInputChange,
	        checked: checked === true,
	        disabled: this.props.disabled,
	        labelText: label
	      });
	      // return (
	      //   <div className='inputcomponents__inner'>
	      //     {renderTitle()}
	      //     <div className={className}>
	      //       <span onClick={this.onDisabledClick}>
	      //         <input type='checkbox' id={value + '_input'} name={value} value='1' onChange={this.onInputChange} checked={checked === true} disabled={this.props.disabled} />
	      //         <label htmlFor={value + '_input'} />
	      //       </span>
	      //     </div>
	      //   </div>
	      // )
	    }
	  }]);
	
	  return InputCheckbox;
	}(_react.PureComponent);
	
	InputCheckbox.defaultProps = {
	  icon: null,
	  disabled: false,
	  extraClassName: '',
	  onChange: function onChange(e) {
	    console.log('todo');
	  },
	  onDisabledClick: function onDisabledClick() {
	    console.log('todo');
	  },
	  name: 'None',
	  checked: false,
	  title: 'nope'
	};
	
	InputCheckbox.propTypes = {
	  icon: _propTypes2.default.element,
	  auth: _propTypes2.default.object.isRequired
	};
	
	InputCheckbox.contextTypes = {
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(InputCheckbox);

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	__webpack_require__(255);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // import React, { PureComponent } from 'react'
	
	
	// Styles
	
	
	var InputField = function (_Component) {
	  _inherits(InputField, _Component);
	
	  function InputField(props) {
	    _classCallCheck(this, InputField);
	
	    var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, props));
	
	    _this.state = {
	      hasFocus: false
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onFocus = _this.onFocus.bind(_this);
	    return _this;
	  }
	
	  _createClass(InputField, [{
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      // console.log('[InputField] change', e.target.name, e.target.value)
	      this.props.onChange(e);
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      // console.log('[InputField] blur', e.target.name, e.target.value)
	      this.setState({ hasFocus: false });
	      this.props.onBlur(e);
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(e) {
	      this.setState({ hasFocus: true });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      // const renderTitle = () => {
	      //   let title = this.props.title
	      //   if (!isNaN(Number(title))) title = translation(this.props.title)
	      //   return (
	      //     <label>{title}{this.props.icon}</label>
	      //   )
	      // }
	      // let name = this.props.name
	      // let value = this.props.value
	
	      var label = this.props.title;
	      if (!isNaN(Number(label))) label = (0, _helpers.translation)(this.props.title);
	
	      var value = this.props.value;
	      var refName = 'ref_' + this.props.name;
	      // Maybe in use, but gives problems with RegNr fetch, when focusing on Model input
	      // if (this.refs[refName] !== undefined && this.state.hasFocus) {
	      //   value = this.refs[refName].value
	      // }
	      // <Text name={this.props.name} ref={refName} labelText={label} value={this.props.value} onChange={this.onInputChange} onBlur={this.onBlur} onFocus={this.onFocus} disabled={this.props.disabled} />
	      return _react2.default.createElement(_text2.default, { name: this.props.name, ref: refName, labelText: label, value: value, onChange: this.onInputChange, onBlur: this.onBlur, onFocus: this.onFocus, disabled: this.props.disabled });
	      // return (
	      //   <div className='inputcomponents__inner'>
	      //     {renderTitle()}
	      //     <input type='text' name={name} value={value} onChange={this.onInputChange} onBlur={this.onBlur} disabled={this.props.disabled} />
	      //   </div>
	      // )
	    }
	  }]);
	
	  return InputField;
	}(_react.Component);
	
	InputField.defaultProps = {
	  icon: null,
	  disabled: false,
	  onChange: function onChange(e) {
	    console.log('todo');
	  },
	  onBlur: function onBlur() {
	    console.log('todo');
	  },
	  name: 'None',
	  value: '',
	  title: 'nope'
	};
	
	InputField.propTypes = {
	  icon: _propTypes2.default.element,
	  auth: _propTypes2.default.object.isRequired
	};
	
	InputField.contextTypes = {
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(InputField);

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	__webpack_require__(255);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var InputSelectList = function (_PureComponent) {
	  _inherits(InputSelectList, _PureComponent);
	
	  function InputSelectList(props) {
	    _classCallCheck(this, InputSelectList);
	
	    var _this = _possibleConstructorReturn(this, (InputSelectList.__proto__ || Object.getPrototypeOf(InputSelectList)).call(this, props));
	
	    _this.state = {};
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.translate = _this.translate.bind(_this);
	    _this.mapItems = _this.mapItems.bind(_this);
	    return _this;
	  }
	
	  _createClass(InputSelectList, [{
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      // console.log('[InputSelectList] change', e.target.name, e.target.value)
	      this.props.onChange(e);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'translate',
	    value: function translate(text) {
	      if (!this.props.translate || isNaN(Number(text))) return text;
	      return (0, _helpers.translation)(text);
	    }
	  }, {
	    key: 'mapItems',
	    value: function mapItems(val, index) {
	      var value = val[this.props.listItemValName[0]];
	      var showVal = this.translate(val[this.props.listItemValName[1]]);
	      return _react2.default.createElement(
	        'option',
	        { value: value, key: index },
	        showVal
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var mapItems = this.props.mapItems ? this.props.mapItems : this.mapItems;
	
	      return _react2.default.createElement(
	        _dropDown2.default,
	        {
	          name: this.props.name,
	          value: this.props.value,
	          onChange: this.onInputChange,
	          disabled: this.props.disabled,
	          labelText: this.props.showTitle && (0, _helpers.translation)(this.props.title)
	        },
	        this.props.listItems.map(mapItems)
	      );
	    }
	  }]);
	
	  return InputSelectList;
	}(_react.PureComponent);
	
	InputSelectList.defaultProps = {
	  disabled: false,
	  onChange: function onChange(e) {
	    console.log('todo');
	  },
	  name: 'None',
	  value: '',
	  title: '*title*',
	  listItems: [],
	  showTitle: true,
	  listItemValName: ['', ''],
	  translate: false
	};
	
	InputSelectList.propTypes = {
	  mapItems: _propTypes2.default.func,
	  translate: _propTypes2.default.bool,
	  showTitle: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func.isRequired,
	  value: _propTypes2.default.any.isRequired,
	  listItems: _propTypes2.default.array.isRequired,
	  auth: _propTypes2.default.object.isRequired
	};
	
	InputSelectList.contextTypes = {
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(InputSelectList);

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _constants = __webpack_require__(5);
	
	var _configuration = __webpack_require__(922);
	
	var _InputCheckbox = __webpack_require__(915);
	
	var _InputCheckbox2 = _interopRequireDefault(_InputCheckbox);
	
	var _InputField = __webpack_require__(916);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _InputSelectList = __webpack_require__(917);
	
	var _InputSelectList2 = _interopRequireDefault(_InputSelectList);
	
	var _RadioList = __webpack_require__(420);
	
	var _RadioList2 = _interopRequireDefault(_RadioList);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Styles
	
	// import OrderDate from '../OrderDate'
	
	var InputRender = function (_PureComponent) {
	  _inherits(InputRender, _PureComponent);
	
	  function InputRender(props) {
	    _classCallCheck(this, InputRender);
	
	    var _this = _possibleConstructorReturn(this, (InputRender.__proto__ || Object.getPrototypeOf(InputRender)).call(this, props));
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(InputRender, [{
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.context.onChange(e);
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var onBlur = typeof this.props.onBlur === 'function' ? this.props.onBlur : this.context.onBlur;
	      onBlur(e);
	    }
	  }, {
	    key: 'formatFormatter',
	    value: function formatFormatter(displayValue, formatter) {
	      if (typeof this.props.formatter === 'function') displayValue = formatter(displayValue);
	      return displayValue;
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var forceUpdate = nextProps.propName === 'IsBodyShopOrder' || nextProps.propName === 'IsPaintOrder' || nextProps.propName === 'HasRequestedCarRental'; // (nextProps.translateName === '14830')
	      return !(0, _lodash.isEqual)(this.props.order[this.props.propName], nextProps.order[this.props.propName]) || !(0, _lodash.isEqual)(this.props.listItems, nextProps.listItems) || forceUpdate;
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this2 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this2.context.dimensions.width;
	          if (width > higherThan && width <= lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'renderDisplayFormatter',
	    value: function renderDisplayFormatter(renderType, displayValue) {
	      if (renderType !== _constants.RenderTypes.FORMATTER) return null;
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var isDraft = this.props.auth.user.DepartmentType === 0 && this.props.order.IsDraft || this.props.auth.user.DepartmentType === 1 && this.props.order.BodyShopIsDraft;
	      if (isCustomer && !isDraft) {
	        if (displayValue !== null && displayValue.Id !== undefined) {
	          displayValue = displayValue.Name;
	          if (this.props.propName === 'BrandName') displayValue = (0, _helpers.translation)(displayValue);
	        }
	        if (['BodyShopLoosePartsType', 'LoosePartsType'].includes(this.props.propName) && displayValue !== null) {
	          displayValue = displayValue ? (0, _helpers.translation)('75') : (0, _helpers.translation)('76');
	        }
	        if (['PickupAltLocationId', 'DeliveryAltLocationId', 'BodyShopPickupAltLocationId', 'BodyShopDeliveryAltLocationId'].includes(this.props.propName)) {
	          var items = this.props.listItems.filter(function (x) {
	            return x.CustomerClientId === displayValue;
	          });
	          if (Array.isArray(items) && items.length > 0) displayValue = items[0].DisplayVal;
	        }
	      }
	      return _react2.default.createElement(_text2.default, {
	        value: this.formatFormatter(displayValue, this.props.formatter),
	        disabled: true,
	        labelText: (0, _helpers.translation)(this.props.translateName)
	      });
	      // return <div><label>{translation(this.props.translateName)}</label>{this.formatFormatter(displayValue, this.props.formatter)}</div>
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon(src, title) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'GoRight' },
	        _react2.default.createElement('img', { src: src, title: (0, _helpers.translation)(title), style: { width: 20, height: 20 } })
	      );
	    }
	  }, {
	    key: 'renderInputfield',
	    value: function renderInputfield(renderType, displayValue) {
	      if (![_constants.RenderTypes.INPUT, _constants.RenderTypes.INPUTICON].includes(renderType)) return null;
	      var colorIcon = null;
	      var disabledInput = this.props.propName === 'LTWIdCode' && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) || this.context.disabledForWP || this.props.propName === 'ColorAmount' && this.props.order.IsReferredOut;
	      if (renderType === _constants.RenderTypes.INPUTICON) {
	        if (this.props.propName === 'Color') colorIcon = this.getIcon('/images/svgs/color/Color.svg', '179');
	        if (this.props.propName === 'ColorCode') colorIcon = this.getIcon('/images/svgs/color/Color_code.svg', '79');
	        if (this.props.propName === 'ColorVariant') colorIcon = this.getIcon('/images/svgs/color/color-variation.svg', '13388');
	        if (this.props.propName === 'ColorAmount') colorIcon = this.getIcon('/images/svgs/color/Color_amount-VS.svg', '13392');
	      }
	      return _react2.default.createElement(_InputField2.default, { title: this.props.translateName, icon: colorIcon, name: this.props.propName, value: this.props.order[this.props.propName] !== null ? this.props.propName === 'ChassisNumber' ? this.props.order[this.props.propName].toUpperCase() : this.props.order[this.props.propName] : '', disabled: disabledInput, onChange: this.onInputChange, onBlur: this.onBlur });
	    }
	  }, {
	    key: 'renderCheckbox',
	    value: function renderCheckbox(renderType, displayValue) {
	      var _props = this.props,
	          order = _props.order,
	          propName = _props.propName;
	
	      if (![_constants.RenderTypes.CHECKBOXICON, _constants.RenderTypes.CHECKBOX].includes(renderType)) return null;
	      if (renderType === _constants.RenderTypes.CHECKBOXICON) {
	        var colorIcon = this.getIcon('/images/svgs/color/Color-ok.svg', '13393');
	        return _react2.default.createElement(_InputCheckbox2.default, { title: this.props.translateName, name: propName, icon: colorIcon, disabled: (propName === 'ColorControlIncluded' || propName === 'LTW' || propName === 'SuppressSMS') && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) || this.context.disabledForWP, onChange: this.onInputChange, checked: order[propName] === true ? 'checked' : false });
	      }
	      var disableCheckbox = false;
	      var checked = false;
	      if (order[propName] === true) checked = true;
	      if ((order.DisabledBodyShopChange || !order.BodyShopIsDraft || !order.PaintIsDraft) && propName === 'IsBodyShopOrder') {
	        if (this.props.auth.departmentType === 2) {
	          disableCheckbox = !order.IsDraft;
	        } else {
	          disableCheckbox = true;
	        }
	      }
	      if (propName === 'HasSpareParts' && (order.IsReferredOut || !(0, _auth.hasSubscriptionPermission)(this.props.auth, 30, 31))) disableCheckbox = true;
	      if (propName === 'HasRequestedCarRental' && (order.HasCarRental /* || hasAccess([4], this.props.auth.user.UserType) */ || !order.CurrentShopCanAssignRentalCar)) disableCheckbox = true;
	      if ((order.DisabledPaintChange || !order.IsDraft) && this.props.propName === 'IsPaintOrder' || this.context.disabledForWP) disableCheckbox = true;
	      if (propName === 'ColorIsReady' && order.IsReferredOut) disableCheckbox = true;
	      if (propName === 'ColorControlIncluded' && order.IsReferredOut && this.props.auth.user.DepartmentType === 1) disableCheckbox = true;
	      if (['HasBodyShopPickupAltLocation', 'HasBodyShopDeliveryAltLocation'].includes(propName) && order.IsReferredIn) disableCheckbox = true;
	      if (this.props.auth.user.DepartmentType === 1 && ['HasPickupAltLocation', 'HasDeliveryAltLocation'].includes(propName) && order.IsReferredOut) disableCheckbox = true;
	
	      var onDisabledClick = function onDisabledClick() {
	        if (order.IsDraft) {
	          window.toastr.error((0, _helpers.translation)('15043'), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('14865'), (0, _helpers.translation)('216'));
	        }
	      };
	
	      var bodyShopClassName = propName === 'IsBodyShopOrder' && this.dimensionShow([[0, 1100]]) ? 'checkbox__bodyshop' : '';
	      return _react2.default.createElement(_InputCheckbox2.default, { title: this.props.translateName, name: propName, onDisabledClick: onDisabledClick, disabled: disableCheckbox, extraClassName: bodyShopClassName, onChange: this.onInputChange, checked: checked === true });
	    }
	    // renderDatetime (renderType, displayValue) {
	    //   if (renderType !== RenderTypes.DATETIME) return null
	    //   const { propName, order } = this.props
	    //   let disabled = false
	
	    //   if (propName === 'BodyShopProductionTime' && order.IsReferredOut) {
	    //     disabled = true
	    //   }
	
	    //   return <OrderDate onUpdateOrder={this.context.onUpdateOrder} saveWorkcard={this.context.saveWorkcard} name={this.props.propName} translateKey={this.props.translateName} formatter={this.props.formatter} disabled={this.context.disabledForWP || !hasSubscriptionPermission(this.props.auth, 0, 2) || disabled} />
	    // }
	
	  }, {
	    key: 'renderSelectList',
	    value: function renderSelectList(renderType, displayValue) {
	      if (renderType !== _constants.RenderTypes.SELECTLIST) return null;
	      if (displayValue === null) displayValue = '';
	      if ((typeof displayValue === 'undefined' ? 'undefined' : _typeof(displayValue)) === 'object') displayValue = displayValue[this.props.listItemValName[0]];
	
	      var disabled = false;
	      if (this.context.disabledForWP || ['PickupAltLocationId', 'DeliveryAltLocationId'].includes(this.props.propName) && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2)) disabled = true;
	      if (this.props.auth.user.DepartmentType === 1 && ['PickupAltLocationId', 'DeliveryAltLocationId'].includes(this.props.propName) && this.props.order.IsReferredOut) disabled = true;
	
	      return _react2.default.createElement(_InputSelectList2.default, { title: this.props.translateName, translate: this.props.translate, name: this.props.propName, value: displayValue, onChange: this.onInputChange, listItems: this.props.listItems, listItemValName: this.props.listItemValName, disabled: disabled });
	    }
	  }, {
	    key: 'renderRadioList',
	    value: function renderRadioList(renderType, displayValue) {
	      var propName = this.props.propName;
	
	      if (renderType !== _constants.RenderTypes.RADIOLIST) return null;
	      if (displayValue === null) displayValue = '';
	      if ((typeof displayValue === 'undefined' ? 'undefined' : _typeof(displayValue)) === 'object') displayValue = displayValue[this.props.listItemValName[0]];
	
	      var disabled = (propName === 'Transport' || propName === 'LoosePartsType') && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) || this.context.disabledForWP;
	      var listItems = this.props.listItems;
	      // isCustomer
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType) && (this.props.auth.user.DepartmentType === 0 && !this.props.order.IsDraft || this.props.auth.user.DepartmentType === 1 && !this.props.order.BodyShopIsDraft)) disabled = true;
	      if (disabled === false && propName === 'LoosePartsType' && (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10) || this.props.auth.user.DepartmentType === 1 && this.props.order.IsReferredOut)) disabled = true;
	
	      if (propName === 'Transport' && listItems !== undefined && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && !(0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) {
	        listItems.map(function (item) {
	          if (item.Name === '351') listItems.splice(listItems.indexOf(item), 1);
	        });
	      }
	      // if ((propName === 'Transport' || propName === 'LoosePartsType') && this.props.order.IsAssessmentOk) {
	      //   if (propName !== 'LoosePartsType' && this.props.order.Transport === 2) disabled = true
	      //   if (propName === 'Transport' && this.props.order.Transport !== 2 && index === 2) disabled = true
	      // }
	      return _react2.default.createElement(_RadioList2.default, { title: this.props.translateName, translate: true, name: this.props.propName, value: '' + displayValue, formatter: this.props.formatter, onChange: this.onInputChange, listItems: listItems, listItemValName: this.props.listItemValName, disabled: disabled });
	    }
	  }, {
	    key: 'renderCheckboxList',
	    value: function renderCheckboxList(renderType, displayValue) {
	      if (renderType !== _constants.RenderTypes.CHECKBOXLIST) return null;
	      if (displayValue === null) displayValue = '';
	      return _react2.default.createElement(_RadioList2.default, { title: this.props.translateName, translate: true, name: this.props.propName, value: '' + displayValue, formatter: this.props.formatter, onChange: this.onInputChange, listItems: this.props.listItems, listItemValName: this.props.listItemValName, disabled: ['Transport'].includes(this.props.propName) && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) || this.context.disabledForWP });
	    }
	  }, {
	    key: 'renderInputfield2',
	    value: function renderInputfield2(renderType, displayValue) {
	      if (renderType !== _constants.RenderTypes.INPUTFIELD2) return null;
	      var blur = this.onBlur;
	      var disabled = false;
	      if (['LTWIdCode', 'PickupAltLocationComment', 'DeliveryAltLocationComment'].includes(this.props.propName) && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2) || this.context.disabledForWP) disabled = true;
	
	      return _react2.default.createElement(_text2.default, {
	        name: this.props.propName,
	        value: this.props.order[this.props.propName] !== null ? this.props.propName === 'ChassisNumber' ? this.props.order[this.props.propName].toUpperCase() : this.props.order[this.props.propName] : '',
	        onChange: this.onInputChange,
	        placeholder: this.props.translateName,
	        onBlur: blur,
	        disabled: disabled
	      });
	      // return (
	      //   <div>
	      //     <label className='labelOverwrite'>&nbsp;</label>
	      //     <input type='text' name={this.props.propName} value={this.props.order[this.props.propName] !== null ? (this.props.propName === 'ChassisNumber' ? this.props.order[this.props.propName].toUpperCase() : this.props.order[this.props.propName]) : ''} onChange={this.onInputChange} placeholder={this.props.translateName} onBlur={blur} disabled={['LTWIdCode', 'PickupAltLocationComment', 'DeliveryAltLocationComment'].includes(this.props.propName) && !hasSubscriptionPermission(this.props.auth, 0, 2) || this.context.disabledForWP} />
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'renderSelectList2',
	    value: function renderSelectList2(renderType, displayValue) {
	      var _this3 = this;
	
	      if (renderType !== _constants.RenderTypes.SELECTLIST2) return null;
	      var listItemValName = this.props.listItemValName;
	      if (displayValue === null) displayValue = '';
	      if ((typeof displayValue === 'undefined' ? 'undefined' : _typeof(displayValue)) === 'object') displayValue = displayValue[listItemValName[0]];
	
	      var disabled = false;
	      var spacing = 0;
	      if (['PickupAltLocationId', 'DeliveryAltLocationId', 'BodyShopPickupAltLocationId', 'BodyShopDeliveryAltLocationId'].includes(this.props.propName)) {
	        spacing = -1;
	      }
	
	      if (this.context.disabledForWP || ['PickupAltLocationId', 'DeliveryAltLocationId'].includes(this.props.propName) && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2)) disabled = true;
	      if (['BodyShopPickupAltLocationId', 'BodyShopDeliveryAltLocationId'].includes(this.props.propName) && this.props.order.IsReferredIn) disabled = true;
	
	      return _react2.default.createElement(
	        _dropDown2.default,
	        {
	          name: this.props.propName,
	          value: displayValue.toString(),
	          onChange: this.onInputChange,
	          spacing: spacing,
	          disabled: disabled
	        },
	        this.props.listItems && this.props.listItems.map(function (val, index) {
	          var className = _this3.props.propName === 'CarRentalId' && val.isFree === false ? 'warning' : '';
	          var showVal = _this3.props.translate ? (0, _helpers.translation)(val[listItemValName[1]]) : val[listItemValName[1]];
	          return _react2.default.createElement(
	            'option',
	            { value: val[listItemValName[0]].toString(), className: className, key: index },
	            showVal
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderTextarea',
	    value: function renderTextarea(renderType, displayValue) {
	      var _props2 = this.props,
	          propName = _props2.propName,
	          order = _props2.order;
	
	      if (renderType !== _constants.RenderTypes.TEXTAREA) return null;
	
	      var disabled = false;
	      if (['BodyShopPickupAltLocationComment', 'BodyShopDeliveryAltLocationComment'].includes(propName) && order.IsReferredIn) disabled = true;
	      if (this.props.auth.user.DepartmentType === 1 && ['PickupAltLocationComment', 'DeliveryAltLocationComment'].includes(propName) && order.IsReferredOut) disabled = true;
	
	      return _react2.default.createElement(_textarea2.default, {
	        name: propName,
	        value: order[propName],
	        placeholder: order[propName],
	        onChange: this.onInputChange,
	        onBlur: this.onBlur,
	        disabled: disabled
	      });
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput(translateName, propName, formatter, type, listItems, listItemValName, translate) {
	      // Get rendertypes from configuration for propName
	      var config = (0, _configuration.GetConfig)(propName);
	      if (typeof config === 'undefined') return null;
	      var displayValue = this.props.order[propName];
	      translateName = (0, _helpers.translation)(translateName);
	      if (type === 'checkbox' || type === 'checkboxicon') displayValue = displayValue ? (0, _helpers.translation)('47') : (0, _helpers.translation)('48');
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var isDraft = this.props.auth.user.DepartmentType === 0 && this.props.order.IsDraft || this.props.auth.user.DepartmentType === 1 && this.props.order.BodyShopIsDraft;
	      var renderType = _constants.RenderTypes.NONE;
	      if (isCustomer) {
	        renderType = isDraft ? config.draftCustomerRenderType : config.bookedCustomerRenderType;
	      } else {
	        renderType = isDraft ? config.draftShopRenderType : config.bookedShopRenderType;
	      }
	      if (renderType === _constants.RenderTypes.NONE) return null;
	
	      if (renderType === _constants.RenderTypes.CHECKBOX && type === 'checkboxicon') renderType = _constants.RenderTypes.CHECKBOXICON;
	      if (renderType === _constants.RenderTypes.INPUT && type === 'inputicon') renderType = _constants.RenderTypes.INPUTICON;
	      if (typeof renderType === 'undefined') renderType = _constants.RenderTypes.FORMATTER;
	      return _react2.default.createElement(
	        'div',
	        { className: 'workcard-input--' + propName },
	        this.renderDisplayFormatter(renderType, displayValue),
	        this.renderInputfield(renderType, displayValue),
	        this.renderCheckbox(renderType, displayValue),
	        this.renderSelectList(renderType, displayValue),
	        this.renderRadioList(renderType, displayValue),
	        this.renderCheckboxList(renderType, displayValue),
	        this.renderInputfield2(renderType, displayValue),
	        this.renderSelectList2(renderType, displayValue),
	        this.renderTextarea(renderType, displayValue)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (typeof this.props.order.Id === 'undefined') return null;
	      return this.renderInput(this.props.translateName, this.props.propName, this.props.formatter, this.props.type, this.props.listItems, this.props.listItemValName, this.props.translate);
	    }
	  }]);
	
	  return InputRender;
	}(_react.PureComponent);
	
	InputRender.defaultProps = {
	  translate: false
	};
	
	InputRender.propTypes = {
	  order: _propTypes2.default.object.isRequired,
	  translateName: _propTypes2.default.string.isRequired,
	  propName: _propTypes2.default.string.isRequired,
	  formatter: _propTypes2.default.func,
	  type: _propTypes2.default.string,
	  listItems: _propTypes2.default.array,
	  listItemValName: _propTypes2.default.array,
	  translate: _propTypes2.default.bool,
	  auth: _propTypes2.default.object.isRequired
	};
	InputRender.contextTypes = {
	  // t: React.PropTypes.func.isRequired,
	  dimensions: _propTypes2.default.shape({
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  onBlur: _propTypes2.default.func,
	  onChange: _propTypes2.default.func.isRequired,
	  onUpdateOrder: _propTypes2.default.func.isRequired,
	  saveWorkcard: _propTypes2.default.func.isRequired,
	  disabledForWP: _propTypes2.default.bool
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(InputRender);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _DummyExtent = __webpack_require__(1027);
	
	var _DummyExtent2 = _interopRequireDefault(_DummyExtent);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _currency = __webpack_require__(41);
	
	var _backdrop = __webpack_require__(29);
	
	var _Extent = __webpack_require__(153);
	
	var _Extent2 = _interopRequireDefault(_Extent);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _expand = __webpack_require__(175);
	
	var _expand2 = _interopRequireDefault(_expand);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _null = __webpack_require__(236);
	
	var _null2 = _interopRequireDefault(_null);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import WhiteBox from '../WhiteBox'
	
	// import OtherPriceModal from '../../../../../shared/modals/OtherPriceModal'
	
	// import { FILE_STORAGE_API } from '../../../../../constants'
	// import { renderFullDate } from '../../../../../utils/time'
	
	
	// Elements
	
	// import Check from '../../../../../shared/elements/check'
	
	
	var OrderExtent = function (_PureComponent) {
	  _inherits(OrderExtent, _PureComponent);
	
	  function OrderExtent(props) {
	    _classCallCheck(this, OrderExtent);
	
	    var _this = _possibleConstructorReturn(this, (OrderExtent.__proto__ || Object.getPrototypeOf(OrderExtent)).call(this, props));
	
	    _this.state = {
	      // showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1',
	      otherPopup: {
	        show: false,
	        other: {
	          Title: '',
	          Price: '',
	          Environment: '',
	          Description: ''
	        }
	      },
	      otherPopup2: {
	        show: false,
	        other: {
	          Price: '',
	          Environment: ''
	        }
	      }
	      // this.renderCheck = this.renderCheck.bind(this)
	    };_this.renderOrderColumn = _this.renderOrderColumn.bind(_this);
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.openOtherPopup = _this.openOtherPopup.bind(_this);
	    _this.openOtherPopup2 = _this.openOtherPopup2.bind(_this);
	    return _this;
	  }
	  // componentDidMount () {
	  //   this.setState({
	  //     showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1'
	  //   })
	  // }
	
	
	  _createClass(OrderExtent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'openOtherPopup2',
	    value: function openOtherPopup2(e) {
	      if (e !== false) {
	        e.preventDefault();
	      }
	      this.props.triggerPopup(!this.state.otherPopup2.show);
	      this.setState({
	        otherPopup2: {
	          show: !this.state.otherPopup2.show,
	          other: {
	            Price: this.props.order.Price,
	            Environment: this.props.order.Environment
	          }
	        }
	      });
	    }
	  }, {
	    key: 'renderAdditionalSales',
	    value: function renderAdditionalSales() {
	      var isBodyShop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.props.order.OrderType === 4) return null;
	
	      if (this.props.auth.departmentType === 1 && !isBodyShop && !this.props.auth.hasPartner) return null;
	      var isReferredIn = this.props.order.IsReferredIn;
	      var isAssessmentOk = this.props.order.IsAssessmentOk;
	      if (isReferredIn) {
	        if (this.props.order.OrderConnection !== undefined && this.props.order.OrderConnection !== null && this.props.order.OrderConnection.IsApproved) {
	          isReferredIn = false;
	        }
	      }
	      var addonPriceComment = this.props.order.AddonPriceComment !== null ? this.props.order.AddonPriceComment : '';
	      if (this.props.order.IsDummy) {
	        addonPriceComment = 'Pris';
	      }
	
	      var showEditLink = (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2);
	
	      var addedPrice = _react2.default.createElement(_Extent2.default, {
	        order: this.props.order,
	        department: isBodyShop ? 1 : 0
	        // showAgreementPrice={this.state.showAgreementPrice}
	        , extents: [{ type: 'addon', editable: false, showEditLink: showEditLink, noTitle: true }]
	      });
	
	      var extentLink = isBodyShop ? '/bodyaddon' : '/2';
	      var subTitleImage = '/images/svgs/taksering/Additional-sales-new.svg';
	      var hasExtentAddon = this.props.order.HasExtentAddon; // HasExtentBodyShopAddon
	      var hasExtentBodyShopAddon = this.props.order.HasExtentBodyShopAddon;
	      var hasPaintAddon = hasExtentAddon || this.props.order.AddonPrice !== 0 && this.props.order.AddonPrice !== null || this.props.order.AddonEnvironment !== 0 && this.props.order.AddonEnvironment !== null;
	      var hasBodyAddon = hasExtentBodyShopAddon || this.props.order.BodyShopAddonPrice !== 0 && this.props.order.BodyShopAddonPrice !== null || this.props.order.BodyShopAddonEnvironment !== 0 && this.props.order.BodyShopAddonEnvironment !== null;
	      var expandAddon = !isBodyShop ? hasPaintAddon : hasBodyAddon;
	
	      /* if (isBodyShop) {
	        hasExtentAddon = this.props.order.HasExtentBodyShopAddon
	        isAssessmentOk = this.props.order.IsBodyShopAssessmentOk
	      } */
	      var hasPermission = true;
	      // console.log('partner', this.props.auth.hasPartner, 'departmentType', this.props.auth.departmentType === 1, 'paint extent', !isBodyShop)
	      if (this.props.auth.hasPartner && this.props.auth.departmentType === 1 && !isBodyShop) {
	        // bodyshop with paint partner, viewing paint extent.
	        hasPermission = (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30);
	      } else {
	        hasPermission = (0, _auth.hasSubscriptionPermission)(this.props.auth, 30);
	      }
	
	      if (hasExtentAddon === false && !hasPermission) return null;
	      var deniedCustomerEdit = ((0, _auth.hasAccess)([4], this.props.auth.user.UserType) || (0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType) && this.props.auth.user.DepartmentType === 1) && this.props.order.IsDraft !== true && !isBodyShop;
	      var canEdit = !isAssessmentOk && !isReferredIn && !deniedCustomerEdit && hasPermission && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 2);
	      return _react2.default.createElement(
	        'div',
	        { className: 'additional_sales_box' },
	        !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(
	          _expand2.default,
	          { title: (0, _helpers.translation)('1396'), defaultOpen: expandAddon },
	          _react2.default.createElement(
	            _actions2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: canEdit ? '/pricecalculation/' + this.props.order.Id + extentLink : '', key: '1' },
	              canEdit && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't', ariaText: (0, _helpers.translation)('34') + ' ' + (0, _helpers.translation)('1396') })
	            )
	          ),
	          this.props.order.HasAwaitingAddon && _react2.default.createElement(
	            'div',
	            { className: 'forsi_diff' },
	            (0, _helpers.translation)('17840')
	          ),
	          addedPrice,
	          _react2.default.createElement(
	            _null2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: canEdit ? '/pricecalculation/' + this.props.order.Id + extentLink : '' },
	                subTitleImage.length > 0 && _react2.default.createElement('img', { className: 'subtitle_image', src: subTitleImage }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'subtitle' },
	                  (0, _helpers.translation)('1396'),
	                  ' ',
	                  !isAssessmentOk && !isReferredIn && !deniedCustomerEdit && hasPermission && showEditLink && _react2.default.createElement(
	                    'div',
	                    { className: 'icon hint--top', 'aria-label': (0, _helpers.translation)('34') + ' ' + (0, _helpers.translation)('1396') },
	                    _react2.default.createElement('img', { src: '/images/icons/edit_16.png' })
	                  )
	                )
	              ),
	              hasExtentAddon && addedPrice,
	              this.props.order.OrderExtent !== null && this.props.order.AddonPrice > 0 && _react2.default.createElement(
	                'span',
	                null,
	                addonPriceComment,
	                ': ',
	                (0, _currency.formatCurrency)(isBodyShop ? this.props.order.BodyShopAddonPrice : this.props.order.AddonPrice || 0)
	              )
	            )
	          )
	        ),
	        (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(
	          _expand2.default,
	          { title: (0, _helpers.translation)('1396'), defaultOpen: true },
	          this.props.order.HasAwaitingAddon && _react2.default.createElement(
	            'div',
	            { className: 'forsi_diff' },
	            (0, _helpers.translation)('17840')
	          ),
	          this.props.order.HasExtentAddon && addedPrice,
	          this.props.order.OrderExtent !== null && this.props.order.AddonPrice > 0 && _react2.default.createElement(
	            'span',
	            null,
	            addonPriceComment,
	            ': ',
	            (0, _currency.formatCurrency)(isBodyShop ? this.props.order.BodyShopAddonPrice : this.props.order.AddonPrice || 0)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'openOtherPopup',
	    value: function openOtherPopup() {
	      if (this.props.auth.user.CustomerId === '-1' || this.props.auth.user.CustomerId !== '-1' && this.props.order.IsDraft) {
	        this.props.triggerPopup(!this.state.otherPopup.show);
	        this.setState({
	          otherPopup: {
	            show: !this.state.otherPopup.show,
	            other: {
	              Title: this.props.order.OtherTitle,
	              Description: this.props.order.OtherDescription,
	              Price: this.props.order.Price,
	              Environment: this.props.order.Environment
	            }
	          }
	        }, console.log(this.state, this.props.order));
	      }
	    }
	  }, {
	    key: 'renderPriceCalculation',
	    value: function renderPriceCalculation() {
	      var isBodyShop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var editDenied = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var OrderType = this.props.order.OrderType;
	
	      var orderExtent = this.props.order.OrderExtent;
	      var extentLines = [];
	      if (orderExtent !== null && orderExtent !== '') {
	        extentLines = this.props.order.OrderExtent.split('<br />');
	      }
	
	      var renderLine = function renderLine(val, key) {
	        return _react2.default.createElement(
	          'p',
	          { key: 'extentLine_' + key },
	          val
	        );
	      };
	
	      // Other
	      // console.log('OrderType', OrderType)
	      if (OrderType === 4) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Extent2.default, {
	            order: this.props.order,
	            department: isBodyShop ? 1 : 0,
	            extents: [{ type: 'base', editable: false, showEditLink: true }]
	          })
	        );
	      }
	
	      var isReferredIn = this.props.order.IsReferredIn;
	      if (isReferredIn) {
	        if (this.props.order.OrderConnection !== undefined && this.props.order.OrderConnection !== null && this.props.order.OrderConnection.IsApproved) {
	          isReferredIn = false;
	        }
	      }
	      var afterEvaluation = this.props.order.SelectedEvaluationType === 4;
	      var selectedAfterEvaluation = afterEvaluation;
	
	      var pric = _react2.default.createElement(_Extent2.default, {
	        order: this.props.order,
	        department: isBodyShop ? 1 : 0
	        // showAgreementPrice={this.state.showAgreementPrice}
	        , extents: [{ type: 'base', editable: false, showEditLink: true, noTitle: false, useSelectedEvaluation: !isBodyShop, getOnly: false }]
	      });
	
	      var hasExtent = this.props.order.HasExtent;
	      if (isBodyShop) {
	        hasExtent = this.props.order.HasExtentBodyShop;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'extent_box clearfix' },
	        !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && isBodyShop === true && _react2.default.createElement(
	          'div',
	          null,
	          (hasExtent || selectedAfterEvaluation && this.props.order.OrderType === 1) && pric,
	          extentLines !== null && extentLines.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'OldOrderExtent' },
	            extentLines.map(renderLine),
	            _react2.default.createElement('br', null)
	          )
	        ),
	        !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) && isBodyShop === false && _react2.default.createElement(
	          'div',
	          null,
	          this.props.order.HasAwaiting && _react2.default.createElement(
	            'div',
	            { className: 'forsi_diff' },
	            (0, _helpers.translation)('2729')
	          ),
	          pric,
	          extentLines !== null && extentLines.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'OldOrderExtent' },
	            extentLines.map(renderLine),
	            _react2.default.createElement('br', null)
	          )
	        ),
	        (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(
	          'div',
	          null,
	          this.props.order.HasAwaiting && _react2.default.createElement(
	            'div',
	            { className: 'forsi_diff' },
	            (0, _helpers.translation)('2729')
	          ),
	          pric
	        )
	      );
	    }
	  }, {
	    key: 'renderPreviousOrder',
	    value: function renderPreviousOrder() {
	      var isBodyShop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      // Prices of previous order should not be shown, only extent/tasks.
	      if (this.props.order.OrderType !== 5) return null;
	      if (this.props.order.PreviousOrder === null || this.props.order.PreviousOrder === 0) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'additional_sales_box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'subtitle' },
	          (0, _helpers.translation)('13409'),
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: '/orders/' + this.props.order.PreviousOrder },
	            '(',
	            this.props.order.PreviousOrder,
	            ')'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'previous_order_msg' },
	          (0, _helpers.translation)('15334')
	        )
	      );
	    }
	  }, {
	    key: 'renderOrderColumn',
	    value: function renderOrderColumn() {
	      var $type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'box';
	      var $department = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var hideContent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var editAllowed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	      var orderType = (0, _helpers.enumtranslate)('OrderTypes', this.props.order.OrderType);
	      var orderExtent = this.props.order.OrderExtent;
	      var extentLines = [];
	      if (orderExtent !== null && orderExtent !== '') extentLines = this.props.order.OrderExtent.split('\n');
	      var department = $department === 'body' ? 1 : 0;
	      var showEditLink = (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 2) && !this.props.order.IsAssessmentOk;
	      var extent = _react2.default.createElement(_Extent2.default, {
	        order: this.props.order,
	        department: department,
	        extents: [{ type: 'base', editable: false, showEditLink: showEditLink, noTitle: false, useSelectedEvaluation: !department === 1, getOnly: false }]
	      });
	
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.props.order.IsDummy) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'hover_extent-popup' },
	          _react2.default.createElement(
	            'div',
	            { className: 'extent_box clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: '', 'data-col': 'order' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                (0, _helpers.translation)(orderType),
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '(',
	                  this.props.order.Id,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(_DummyExtent2.default, { item: this.props.order })
	            )
	          )
	        );
	      }
	      var evaluationTypes = [1, 2, 3, 4, 5, 6, 7];
	      if ($type === 'data') {
	        return _react2.default.createElement(
	          'div',
	          { 'data-col': 'order' },
	          this.renderPreviousOrder(department === 1),
	          hideContent === false && evaluationTypes.indexOf(this.props.order.SelectedEvaluationType) > -1 && this.renderPriceCalculation(false, editAllowed),
	          (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && extentLines !== null && extentLines.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'OldOrderExtent' },
	            extent,
	            _react2.default.createElement('br', null)
	          ),
	          this.renderAdditionalSales()
	        );
	      } else {
	        if ($department === '') {
	          return _react2.default.createElement(
	            'div',
	            { 'data-col': 'order' },
	            this.renderPreviousOrder(department === 1),
	            hideContent === false && evaluationTypes.indexOf(this.props.order.SelectedEvaluationType) > -1 && this.renderPriceCalculation(false, editAllowed),
	            (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && extentLines !== null && extentLines.length > 0 && _react2.default.createElement(
	              'div',
	              { className: 'OldOrderExtent' },
	              extent,
	              _react2.default.createElement('br', null)
	            ),
	            this.renderAdditionalSales()
	          );
	        } else {
	          // body shop extent
	          return _react2.default.createElement(
	            'div',
	            { 'data-col': 'bodyshoporder', className: 'extent_box' },
	            this.renderPreviousOrder(true),
	            hideContent === false && evaluationTypes.indexOf(this.props.order.SelectedEvaluationType) > -1 && extent,
	            this.renderAdditionalSales(true)
	          );
	        }
	      }
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.props.order.length === 0) return null;
	      return this.renderOrderColumn(this.props.type, this.props.department, this.props.hideContent, this.props.editAllowed);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var orderType = (0, _helpers.enumtranslate)('OrderTypes', this.props.order.OrderType);
	      if (!this.props.whitebox) {
	        return this.renderContent();
	      }
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(orderType) + ' · ' + this.props.order.Id, dataCol: this.props.datacol },
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return OrderExtent;
	}(_react.PureComponent);
	
	OrderExtent.defaultProps = {
	  datacol: '',
	  type: 'box',
	  department: '',
	  hideContent: false,
	  editAllowed: true,
	  whitebox: true
	};
	
	OrderExtent.propTypes = {
	  whitebox: _propTypes2.default.bool.isRequired,
	  onUpdateOrder: _propTypes2.default.func.isRequired,
	  type: _propTypes2.default.string.isRequired,
	  department: _propTypes2.default.string.isRequired,
	  hideContent: _propTypes2.default.bool.isRequired,
	  editAllowed: _propTypes2.default.bool.isRequired,
	  order: _propTypes2.default.object.isRequired,
	  auth: _propTypes2.default.object.isRequired
	};
	
	OrderExtent.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // enum: React.PropTypes.func.isRequired,
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    orderTypes: state.common.enums.orderTypes,
	    order: state.orders.order,
	    auth: state.auth,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup, triggerPopupActionBG: _backdrop.triggerPopupActionBG
	})(OrderExtent);

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _orders = __webpack_require__(21);
	
	var _spareParts = __webpack_require__(1132);
	
	var _spareParts2 = _interopRequireDefault(_spareParts);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _common = __webpack_require__(25);
	
	var _List = __webpack_require__(421);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _PremiumList = __webpack_require__(422);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Datetime from 'react-datetime'
	// import moment from 'moment'
	
	// Styles
	// import { FILE_STORAGE_API } from '../../../../../constants'
	
	// Elements
	
	// import DateTime from '../../../../../shared/elements/datetime'
	// import DropDown from '../../../../../shared/elements/dropDown'
	
	
	// Actions
	
	
	// Component updaters
	
	
	var SpareParts = function (_Component) {
	  _inherits(SpareParts, _Component);
	
	  function SpareParts(props) {
	    _classCallCheck(this, SpareParts);
	
	    var _this = _possibleConstructorReturn(this, (SpareParts.__proto__ || Object.getPrototypeOf(SpareParts)).call(this, props));
	
	    _this.state = {
	      order: {}
	    };
	    return _this;
	  }
	
	  _createClass(SpareParts, [{
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.props.onChange(e);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        order: nextProps.order
	      });
	    }
	  }, {
	    key: 'getTimeString',
	    value: function getTimeString(timeString, date) {
	      var toReturn = timeString;
	      if (date !== '') {
	        // Hours + pad zero
	        var hours = '' + date.getHours();
	        hours = '00'.substring(0, 2 - hours.length) + hours;
	        // Minutes + pad zero
	        var minutes = '' + date.getMinutes();
	        minutes = '00'.substring(0, 2 - minutes.length) + minutes;
	        // Set time
	        toReturn = hours + ':' + minutes;
	      }
	      return toReturn;
	    }
	    /* renderBodyShopSparePartDate () {
	      // let pickupDate = this.state.order.BodyShopSparePartDate
	      let pickupDate = this.state.order.SparePartDateDefault
	        if (this.state.order.BodyShopSparePartDate !== null && this.state.order.BodyShopSparePartDate !== '1990-01-01T00:00:00') {
	        pickupDate = this.state.order.BodyShopSparePartDate
	      }
	        let times = this.state.order.SparePartAvailableTimes
	      let closeOnSelect = true
	      let timeFormat = false
	      let inputProps = {
	        name: 'BodyShopSparePartDate',
	        readOnly: true,
	        disabled: !hasSubscriptionPermission(this.props.auth, 0, 2) || hasAccess([6], this.props.auth.user.UserType)
	      }
	        // Time string
	      let timeString = ''
	      if (times != null) timeString = times[0]
	      // Date
	      let date = ''
	      if (typeof pickupDate !== 'undefined' && pickupDate !== null && pickupDate !== '') {
	        date = window.CustomDate(pickupDate)
	      }
	        // Time string
	      timeString = this.getTimeString(timeString, date)
	        // Actions
	      const onChange = (dateTime) => {
	        this.setState({
	          order: {
	            ...this.state.order,
	            BodyShopSparePartDate: dateTime,
	            BodyShopSparePartDateTimes: []
	          }
	        }, () => {
	          let newDate = moment(dateTime).format('YYYY-MM-DD')
	          // let newTime = moment(dateTime).format('HH:mm')
	            this.props.getPickupTimes(newDate, '08:00', this.state.order.CustomerId).then((res) => {
	            let AvailableTimes = [''].concat(res.data.AvailableTimes)
	            this.setState({
	              order: {
	                ...this.state.order,
	                BodyShopSparePartDate: (res.data.IsSelectedDayValid) ? newDate + ' 08:00' : res.data.NextValidPickupDate,
	                BodyShopSparePartDateTimes: AvailableTimes
	              }
	            }, () => {
	              this.props.saveWorkcard(undefined, 'BodyShopSparePartDateTimes', undefined, this.state.order)
	            })
	          }, (err) => {
	            // Toastr
	            this.props.onUpdateOrder()
	            window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
	          })
	        })
	      }
	      const onChangeTime = (e) => {
	        let splitted = e.target.value.split(':')
	        let dateVal = (pickupDate !== null) ? window.CustomDate(pickupDate) : window.CustomDate()
	        let momentDate = moment(dateVal)
	        momentDate.set({ hour: splitted[0], minute: splitted[1], second: 0, millisecond: 0 })
	        this.props.saveSingleValue('BodyShopSparePartDate', momentDate.format('YYYY-MM-DDTHH:mm'), () => {
	          this.props.saveWorkcard(undefined, 'BodyShopSparePartDateTimes', undefined)
	        })
	      }
	      // Return
	      return (
	        <div className='spacing'>
	          <DateTime inputProps={inputProps} closeOnSelect={closeOnSelect} dateFormat='DD-MM-YYYY' timeFormat={timeFormat} value={date} onChange={onChange} />
	          <DropDown
	            name='BodyShopSparePartDate_time'
	            value={timeString}
	            onChange={onChangeTime}
	            ref='BodyShopSparePartDate'
	            // key={timeKey} // Breaks the dropdown for some reason
	            disabled={hasAccess([6], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 0, 2)}
	          >
	            {times.map((val, index) => {
	              return (<option key={index} value={val}>{val}</option>)
	            })}
	          </DropDown>
	        </div>
	      )
	    } */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (typeof this.state.order.Id === 'undefined') return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	
	      var renderDownloadLink = function renderDownloadLink(item) {
	        // Find reports
	        var files = _this2.props.order.Report ? _this2.props.order.Report.Attachments : [];
	        if (!(files.length > 0)) {
	          return null;
	        }
	
	        // Look after sparepart reports
	        var sparePartFile = files.find(function (f) {
	          return f.SectionType === 4;
	        });
	        if (sparePartFile !== undefined) {
	          // TODO: Implement backend security check via token/session?
	          var downloadURL = sparePartFile.FileUrl;
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'inside' },
	              (0, _helpers.translation)('14837'),
	              _react2.default.createElement(
	                'a',
	                { href: downloadURL, title: sparePartFile.FileName, target: '_blank' },
	                _react2.default.createElement('img', { src: '/images/svgs/download.svg', alt: '', className: 'downloadIcon' })
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'simpleFloatRight' },
	                (0, _time.renderFullDate)(_this2.props.order.Report.CreatedDate)
	              ),
	              _react2.default.createElement('div', { className: 'clearFix' })
	            )
	          );
	        }
	
	        // We didn't find any?
	        return null;
	      };
	      var renderInputContent = function renderInputContent() {
	        if (!_this2.state.order.HasSpareParts) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'information' },
	          _this2.props.auth.user.UserType !== 4 && _react2.default.createElement(_divider2.default, { size: 2 })
	        );
	      };
	      var renderContent = function renderContent() {
	        var onOpenSparePartsOverlay = function onOpenSparePartsOverlay(e) {
	          e.preventDefault();
	          _this2.props.openOverlay('SparePartsOverlay');
	        };
	        var hasPermissionToSparePartsOverlay = (0, _auth.hasSubscriptionPermission)(_this2.props.auth, 30, 31);
	        var disableSparePartsOverlayButton = _this2.props.disableMobileAccess || _this2.state.order.IsReferredOut || !hasPermissionToSparePartsOverlay;
	        var isCustomer = (0, _auth.hasAccess)([4], _this2.props.auth.user.UserType);
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          !isCustomer && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _button2.default,
	              { style: 'link', onClick: onOpenSparePartsOverlay, disabled: disableSparePartsOverlayButton },
	              (0, _helpers.translation)(16433)
	            ),
	            _react2.default.createElement(_divider2.default, { size: 2 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'information' },
	            _this2.props.auth.user.UserType !== 4 && _this2.props.renderInput((0, _helpers.translation)('637'), 'HasSpareParts', undefined, 'checkbox'),
	            renderInputContent()
	          ),
	          renderDownloadLink(),
	          _react2.default.createElement(_List2.default, {
	            order: _this2.props.order,
	            showRpFiles: true
	          })
	        );
	      };
	
	      var onClose = function onClose() {
	        _this2.props.onUpdateOrder();
	        _events2.default.emit('UPDATE_BOOKINGTIMES');
	        (0, _PremiumList.UpdateSparePartPremiumList)(_this2.state.order.Id);
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('637'), dataCol: 'spareparts' },
	        renderContent(),
	        _react2.default.createElement(_spareParts2.default, { order: this.state.order, onClose: onClose })
	      );
	    }
	  }]);
	
	  return SpareParts;
	}(_react.Component);
	
	SpareParts.defaultProps = {};
	
	SpareParts.propTypes = {
	  saveSingleValue: _propTypes2.default.func.isRequired,
	  saveWorkcard: _propTypes2.default.func.isRequired,
	  order: _propTypes2.default.object.isRequired,
	  renderInput: _propTypes2.default.func.isRequired,
	  auth: _propTypes2.default.object.isRequired
	};
	
	SpareParts.contextTypes = {
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPickupTimes: _orders.getPickupTimes,
	  openOverlay: _common.openOverlay
	})(SpareParts);

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var WhiteBox = function (_Component) {
	  _inherits(WhiteBox, _Component);
	
	  function WhiteBox(props) {
	    _classCallCheck(this, WhiteBox);
	
	    var _this = _possibleConstructorReturn(this, (WhiteBox.__proto__ || Object.getPrototypeOf(WhiteBox)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(WhiteBox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = '';
	      if (this.props.extraClass !== '') className += ' ' + this.props.extraClass;
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: this.props.renderTitle ? this.props.titleText : '', 'data-col': this.props.datacol },
	        _react2.default.createElement(
	          'div',
	          { className: className },
	          this.props.renderContent(),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return WhiteBox;
	}(_react.Component);
	
	WhiteBox.defaultProps = {
	  renderTitle: true,
	  extraClass: '',
	  datacol: '',
	  titleIcon: '',
	  titleIconAlt: '',
	  titleText: '',
	  titleTextLeft: '',
	  renderContent: function renderContent() {
	    return null;
	  }
	};
	
	WhiteBox.propTypes = {
	  renderTitle: _propTypes2.default.bool,
	  extraClass: _propTypes2.default.string,
	  datacol: _propTypes2.default.string,
	  titleIcon: _propTypes2.default.string,
	  titleIconAlt: _propTypes2.default.string,
	  titleText: _propTypes2.default.string,
	  titleTextLeft: _propTypes2.default.string,
	  renderContent: _propTypes2.default.func.isRequired,
	  auth: _propTypes2.default.object.isRequired
	};
	
	WhiteBox.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(WhiteBox);

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetBlank = GetBlank;
	exports.GetAllTyped = GetAllTyped;
	exports.GetShopTyped = GetShopTyped;
	exports.GetConfig = GetConfig;
	exports.SetRenderType = SetRenderType;
	exports.SetRenderTypeBooked = SetRenderTypeBooked;
	exports.SetRenderTypeAll = SetRenderTypeAll;
	exports.SetRenderTypeCustomer = SetRenderTypeCustomer;
	exports.SetRenderTypeShop = SetRenderTypeShop;
	var RenderTypes = __webpack_require__(5).RenderTypes;
	var RenderConfig = exports.RenderConfig = {
	  // Visible to all:
	  'BodyShopDeliveryAltLocationId': SetRenderType(GetAllTyped(RenderTypes.SELECTLIST2), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'BodyShopDeliveryTime': SetRenderType(GetAllTyped(RenderTypes.DATETIME), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'BodyShopLoosePartsType': SetRenderType(GetAllTyped(RenderTypes.RADIOLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'BodyShopPickupAltLocationId': SetRenderType(GetAllTyped(RenderTypes.SELECTLIST2), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'BodyShopPickupTime': SetRenderType(GetAllTyped(RenderTypes.DATETIME), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'BodyShopPublishDate': SetRenderTypeBooked(GetBlank(), RenderTypes.FORMATTER),
	  'BodyShopTransport': GetAllTyped(RenderTypes.RADIOLIST), // SetRenderType(GetAllTyped(RenderTypes.CHECKBOXLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'BrandName': SetRenderType(GetAllTyped(RenderTypes.SELECTLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'CarOwnerMail': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'CarOwnerName': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'CarOwnerLastName': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'CarOwnerAddress': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'CarOwnerZipCode': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'CarOwnerCity': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'CarOwnerPhone': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'InsuranceDamageNr': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'DistanceDriven': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'ChassisNumber': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'Color': GetAllTyped(RenderTypes.INPUT),
	  'ColorCode': GetAllTyped(RenderTypes.INPUT),
	  'ColorControlIncluded': SetRenderType(GetAllTyped(RenderTypes.CHECKBOX), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'Contact': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'ContactPhone': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'CreationDate': GetAllTyped(RenderTypes.FORMATTER),
	  'Delivery': SetRenderType(GetAllTyped(RenderTypes.DATETIME), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'Doors': SetRenderType(GetAllTyped(RenderTypes.SELECTLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'HasRequestedCarRental': GetAllTyped(RenderTypes.CHECKBOX),
	  'HasSpareParts': SetRenderType(GetAllTyped(RenderTypes.CHECKBOX), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'IsPaintOrder': SetRenderType(GetAllTyped(RenderTypes.CHECKBOX), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'LoosePartsType': SetRenderType(GetAllTyped(RenderTypes.RADIOLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'Model': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'Pickup': SetRenderType(GetAllTyped(RenderTypes.DATETIME), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'PublishDate': SetRenderTypeBooked(GetBlank(), RenderTypes.FORMATTER),
	  'RegistrationDate': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'RegNumber': SetRenderType(GetAllTyped(RenderTypes.INPUT), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	  'RekvNumber': GetAllTyped(RenderTypes.INPUT),
	  'Transport': GetAllTyped(RenderTypes.RADIOLIST), // SetRenderType(GetAllTyped(RenderTypes.RADIOLIST), ['bookedCustomerRenderType'], RenderTypes.FORMATTER),
	
	  // Invisible to customer:
	  'BodyShopDeliveryAltLocationComment': GetShopTyped(RenderTypes.TEXTAREA),
	  'BodyShopPickupAltLocationComment': GetShopTyped(RenderTypes.TEXTAREA),
	  'BodyShopProductionTime': GetShopTyped(RenderTypes.DATETIME),
	  'BodyShopRekvNumber': GetShopTyped(RenderTypes.INPUT),
	  'BodyShopSelectedStatus': GetShopTyped(RenderTypes.SELECTLIST),
	  'CarRentalId': GetShopTyped(RenderTypes.SELECTLIST2),
	  'ColorAmount': GetShopTyped(RenderTypes.INPUT),
	  'ColorIsReady': GetShopTyped(RenderTypes.CHECKBOX),
	  'ColorVariant': GetShopTyped(RenderTypes.INPUT),
	  'CustomerName': GetShopTyped(RenderTypes.FORMATTER),
	  'DeliveryAltLocationComment': GetShopTyped(RenderTypes.TEXTAREA),
	  'DeliveryAltLocationId': GetShopTyped(RenderTypes.SELECTLIST),
	  'HasBodyShopDeliveryAltLocation': GetShopTyped(RenderTypes.CHECKBOX),
	  'HasBodyShopPickupAltLocation': GetShopTyped(RenderTypes.CHECKBOX),
	  'HasDeliveryAltLocation': GetShopTyped(RenderTypes.CHECKBOX),
	  'HasPickupAltLocation': GetShopTyped(RenderTypes.CHECKBOX),
	  'IsBodyShopOrder': GetShopTyped(RenderTypes.CHECKBOX),
	  'LTW': GetShopTyped(RenderTypes.CHECKBOX),
	  'LTWIdCode': GetShopTyped(RenderTypes.INPUT),
	  'PickupAltLocationComment': GetShopTyped(RenderTypes.TEXTAREA),
	  'PickupAltLocationId': GetShopTyped(RenderTypes.SELECTLIST),
	  'ProductionDate': GetShopTyped(RenderTypes.DATETIME),
	  'SuppressSMS': GetShopTyped(RenderTypes.CHECKBOX)
	};
	function GetBlank() {
	  return {
	    draftCustomerRenderType: RenderTypes.NONE,
	    draftShopRenderType: RenderTypes.NONE,
	    bookedCustomerRenderType: RenderTypes.NONE,
	    bookedShopRenderType: RenderTypes.NONE
	  };
	}
	function GetAllTyped(renderType) {
	  return SetRenderTypeAll(GetBlank(), renderType);
	}
	function GetShopTyped(renderType) {
	  return SetRenderTypeShop(GetBlank(), renderType);
	}
	function GetConfig(name) {
	  // console.log('[GetConfig]', name)
	  var config = RenderConfig[name];
	  if (typeof config === 'undefined') {
	    config = GetBlank();
	    console.error('[GetConfig] Missing config for name, inserting Blank config - ', name);
	  }
	  return config;
	}
	
	function SetRenderType(types, propNames, renderType) {
	  var newTypes = Object.assign({}, types);
	  propNames.map(function (value) {
	    newTypes[value] = renderType;
	  });
	  return newTypes;
	}
	function SetRenderTypeBooked(types, renderType) {
	  return SetRenderType(types, ['bookedShopRenderType', 'bookedCustomerRenderType'], renderType);
	}
	function SetRenderTypeAll(types, renderType) {
	  return SetRenderType(types, ['draftCustomerRenderType', 'bookedCustomerRenderType', 'draftShopRenderType', 'bookedShopRenderType'], renderType);
	}
	function SetRenderTypeCustomer(types, renderType) {
	  return SetRenderType(types, ['draftCustomerRenderType', 'bookedCustomerRenderType'], renderType);
	}
	function SetRenderTypeShop(types, renderType) {
	  return SetRenderType(types, ['draftShopRenderType', 'bookedShopRenderType'], renderType);
	}

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(43);
	
	var _lodash = __webpack_require__(27);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _price = __webpack_require__(115);
	
	var _common = __webpack_require__(25);
	
	var _dracar = __webpack_require__(224);
	
	__webpack_require__(1432);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _order = __webpack_require__(92);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _router = __webpack_require__(308);
	
	var _NewWorkCard = __webpack_require__(423);
	
	var _NewWorkCard2 = _interopRequireDefault(_NewWorkCard);
	
	var _Documentation = __webpack_require__(911);
	
	var _Documentation2 = _interopRequireDefault(_Documentation);
	
	var _Log = __webpack_require__(912);
	
	var _Log2 = _interopRequireDefault(_Log);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	// import Header from '../../../shared/components/Header'
	
	// Elements
	
	// import Null from '../../../shared/elements/null'
	
	
	// Utils
	
	
	// Tabs
	
	
	var Order = function (_Component) {
	  _inherits(Order, _Component);
	
	  function Order(props) {
	    _classCallCheck(this, Order);
	
	    var _this = _possibleConstructorReturn(this, (Order.__proto__ || Object.getPrototypeOf(Order)).call(this, props));
	
	    _this.state = {
	      tabActive: 'workcard',
	      createdNew: false
	    };
	    _this.renderTitle = _this.renderTitle.bind(_this);
	    _this.onUpdateOrder = _this.onUpdateOrder.bind(_this);
	    // this.renderButtonsGoBack = this.renderButtonsGoBack.bind(this)
	    _this.renderTabs = _this.renderTabs.bind(_this);
	    _this.fetchOrder = _this.fetchOrder.bind(_this);
	    return _this;
	  }
	
	  _createClass(Order, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _lodash.isEqual)(this.props, nextProps) || !(0, _lodash.isEqual)(this.state, nextState);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Handle load of new order when order Id in props changes.
	      if (typeof nextProps.params.orderID === 'string' && this.props.params.orderID !== nextProps.params.orderID) {
	        this.props.resetOrder();
	        this.props.resetPrice();
	        this.fetchOrder(nextProps.params);
	        this.setState({
	          tabActive: 'workcard'
	        });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.location.state !== undefined) {
	        if (this.props.location.state) {
	          var _props$location$state = this.props.location.state,
	              createdNew = _props$location$state.createdNew,
	              bookingDestination = _props$location$state.bookingDestination,
	              assignments = _props$location$state.assignments;
	
	          this.setState({
	            createdNew: createdNew,
	            bookingDestination: bookingDestination,
	            assignments: assignments
	          });
	        }
	        // if (this.props.location.state.createdNew) {
	        //   this.setState({
	        //     createdNew: true
	        //   })
	        // }
	        var location = _extends({}, this.props.location, {
	          state: undefined
	        });
	        this.props.router.replace(location);
	      }
	
	      this.props.resetOrder();
	      this.props.resetPrice();
	
	      this.fetchOrder(this.props.params);
	
	      // this.props.getMatchingSpareParts({ OrderId: this.props.params.orderID, CheckInvoiceActive: true })
	      // .then(() => {
	      //   this.fetchOrder(this.props.params)
	      // })
	      // .catch(() => {
	      //   // Incase the fetching of spareparts fails, we still want to try and retrieve the Order
	      //   this.fetchOrder(this.props.params)
	      // })
	
	      var tab = this.props.router.location.query.page;
	      if (tab) {
	        switch (tab) {
	          case '1':
	            tab = 'workcard';
	            break;
	          case '2':
	            tab = 'documentation';
	            break;
	          case '3':
	            tab = 'log';
	            break;
	        }
	        var _location = this.props.router.location;
	        delete _location.query.page;
	        this.props.router.replace(_location);
	
	        this.setState({
	          tabActive: tab
	        });
	      }
	    }
	  }, {
	    key: 'fetchOrder',
	    value: function fetchOrder(params) {
	      var _this2 = this;
	
	      this.props.getOrder(params.orderID).then(function (res) {
	        _this2.props.setPageTitle((0, _order.makeOrderPageTitleObject)(res.data));
	      });
	    }
	  }, {
	    key: 'changeTab',
	    value: function changeTab(title, e) {
	      e.preventDefault();
	      this.setState({
	        tabActive: title.val
	      });
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(title, index) {
	      var activeClass = this.state.tabActive === title.val ? 'active' : '';
	      var onClick = this.changeTab.bind(this, title);
	      var link = '#';
	      if (title.link) {
	        link = title.link;
	        onClick = function onClick() {};
	      }
	      return _react2.default.createElement(
	        _tabItem2.default,
	        { key: 'tab_' + index },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            className: activeClass,
	            to: link,
	            onClick: onClick },
	          title.name
	        )
	      );
	    }
	  }, {
	    key: 'renderTabs',
	    value: function renderTabs() {
	      var _this3 = this;
	
	      var isCustomer = this.props.auth.user.CustomerId !== '-1';
	      var isBodyShop = this.props.auth.user.ShopId !== '-1' && this.props.auth.user.DepartmentType === 1;
	      // Tab titles
	      var titles = [{ name: (0, _helpers.translation)('159'), val: 'workcard'
	        // { name: 'Log', val: 'log' }
	      }];
	
	      // Show documentation page only to Apromas PRO
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) || (0, _auth.hasSubscriptionPermission)(this.props.auth, 0) && (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) {
	        titles.push({ name: (0, _helpers.translation)('1042'), val: 'documentation' });
	      }
	      // order log
	      titles.push({ name: (0, _helpers.translation)('2211'), val: 'log' });
	      // console.log('isdraft, isbodyshopdraft', this.props.order)
	      // Show order inspection only if not customer, not draft and "Quality Control" permission is checked
	      if (typeof this.props.order.IsDraft !== 'undefined' && typeof this.props.order.BodyShopIsDraft !== 'undefined' && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 30) && (!isCustomer && !this.props.order.IsDraft || (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && !this.props.order.IsDraft || !isCustomer && isBodyShop && !this.props.order.BodyShopIsDraft)) {
	        titles.push({ name: (0, _helpers.translation)('13423'), val: null, link: '/orders/' + this.props.params.orderID + '/orderinspection' });
	      }
	      var renderTitles = function renderTitles() {
	        return titles.map(_this3.renderTitle);
	      };
	      return _react2.default.createElement(
	        _tabBar2.default,
	        null,
	        renderTitles()
	      );
	    }
	  }, {
	    key: 'renderActivePage',
	    value: function renderActivePage() {
	      var _this4 = this;
	
	      var headerButtonsGoBack = void 0;
	      if (typeof this.props.location.state !== 'undefined') {
	        if (typeof this.props.location.state.lastview !== 'undefined') {
	          headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	            var goBack = function goBack() {
	              _this4.props.router.replace({
	                pathname: '/workscreen',
	                query: {
	                  view: _this4.props.location.state.lastview
	                }
	              });
	            };
	            // <div className='alignHelper' />
	            return _react2.default.createElement(
	              'div',
	              { key: 'close' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint--left', 'aria-label': t('2060') },
	                _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Close, onClick: goBack })
	              )
	            );
	          };
	        }
	      } else {
	        var routeItem = window.LocalstorageStack.findFirst(['/mypage/orders', '/workscreen', '/orders', '/CarRentals/Overview', 'OrderCapacityOverview']);
	        if (routeItem !== null) {
	          headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	            var goBack = function goBack() {
	              var query = {};
	              if (_this4.state.bookingDestination) {
	                query.destination = _this4.state.bookingDestination;
	              }
	              if (routeItem.pathname === '/orders') {
	                var orderId = _this4.props.params.orderID;
	                _this4.props.setLastVisitedOrderId(orderId);
	                query.orderid = orderId;
	              }
	
	              if (routeItem.pathname === 'OrderCapacityOverview') {
	                var _orderId = _this4.props.params.orderID;
	                if (_orderId) {
	                  var viewState = window.localStorage.getItem('capacity_viewstate');
	                  try {
	                    viewState = JSON.parse(viewState) || {};
	                  } catch (error) {
	                    viewState = {};
	                  }
	                  viewState.orderId = parseInt(_orderId);
	                  viewState.openDetails = true;
	                  window.localStorage.setItem('capacity_viewstate', JSON.stringify(viewState));
	                  console.log('viewState = ', viewState);
	                }
	                // console.log('OrderCapacityOverview - goBack -> path: ', routeItem.pathname, 'query: ', query, ' orderId: ', orderId)
	                _this4.props.router.replace({
	                  pathname: routeItem.search,
	                  query: query
	                });
	
	                return;
	              }
	              _this4.props.router.replace({
	                pathname: routeItem.pathname,
	                query: query
	              });
	            };
	            var renderArrowBack = function renderArrowBack() {
	              var topOfStack = window.LocalstorageStack.top();
	              if (topOfStack.pathname !== '/CarRental/' && topOfStack.pathname !== '/CarRental') return null;
	              if (topOfStack && !(0, _router.shouldHaveArrow)()) {
	                return null;
	              }
	              var goBack = function goBack() {
	                _this4.props.router.replace({
	                  pathname: '/CarRental'
	                });
	              };
	              return _react2.default.createElement(
	                'div',
	                { className: 'hint--left', 'aria-label': (0, _helpers.translation)('394') },
	                _react2.default.createElement('img', { src: '/images/icons/back-white-30x30.png', onClick: goBack.bind(_this4), className: 'icon' })
	              );
	            };
	            return _react2.default.createElement(
	              'div',
	              { key: 'back_close' },
	              renderArrowBack(),
	              _react2.default.createElement(_closeButton2.default, { onClick: goBack, ariaText: t('2060') })
	            );
	          };
	        }
	      }
	
	      switch (this.state.tabActive) {
	        case 'documentation':
	          return _react2.default.createElement(_Documentation2.default, {
	            renderTabs: this.renderTabs,
	            renderButtonsGoBack: headerButtonsGoBack,
	            router: this.props.router,
	            order: this.props.order,
	            onUpdateOrder: this.onUpdateOrder
	          });
	        case 'log':
	          return _react2.default.createElement(_Log2.default, {
	            renderTabs: this.renderTabs,
	            renderButtonsGoBack: headerButtonsGoBack,
	            router: this.props.router,
	            onUpdateOrder: this.onUpdateOrder
	          });
	        case 'workcard':
	        default:
	          return _react2.default.createElement(_NewWorkCard2.default, {
	            renderTabs: this.renderTabs,
	            renderButtonsGoBack: headerButtonsGoBack,
	            router: this.props.router,
	            onUpdateOrder: this.onUpdateOrder,
	            createdNew: this.state.createdNew,
	            bookingDestination: this.state.bookingDestination,
	            assignments: this.state.assignments
	          });
	      }
	    }
	  }, {
	    key: 'onUpdateOrder',
	    value: function onUpdateOrder(res) {
	      var _this5 = this;
	
	      if (typeof res === 'undefined' || (typeof res === 'undefined' ? 'undefined' : _typeof(res)) === undefined) {
	        this.props.getOrder(this.props.params.orderID).then(function (res) {
	          if (/\/orders\/\d{6,}/.test(_this5.props.router.location.pathname)) {
	            // Only change if still on '/orders/xxxxxx'
	            _this5.props.setPageTitle((0, _order.makeOrderPageTitleObject)(res.data));
	          }
	        });
	      } else {
	        this.props.setOrder(res);
	      }
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'order__screen' },
	        _react2.default.createElement(
	          'div',
	          { className: 'white__box notfound' },
	          (0, _helpers.translation)('2229'),
	          ': ',
	          this.props.params.orderID
	        )
	      );
	    }
	
	    // renderButtonsGoBack () {
	    //   return headerButtonsGoBack
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      if (typeof this.props.order === 'undefined' || this.props.order === null) {
	        return this.renderError();
	      }
	
	      // Generate title
	      // let title = makeOrderTitle(this.props.order, translation, enumtranslate, false, true)
	      /*
	      let title = ''
	      if (this.props.order.Model) {
	        title += this.props.order.Model
	      }
	      if (this.props.order.RegNumber) {
	        if (this.props.order.Model) {
	          title += ', '
	        }
	        title += this.props.order.RegNumber
	      }
	      if (title === '') {
	        title = this.props.order.Id
	      }
	      */
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'order__screen' },
	        _react2.default.createElement(
	          'div',
	          { className: 'order__screen--inner' },
	          this.renderActivePage()
	        )
	      );
	    }
	  }]);
	
	  return Order;
	}(_react.Component);
	
	Order.propTypes = {
	  getOrder: _propTypes2.default.func.isRequired,
	  setOrder: _propTypes2.default.func.isRequired,
	  resetOrder: _propTypes2.default.func.isRequired,
	  resetPrice: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    order: state.orders.order
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrder: _orders.getOrder,
	  setOrder: _orders.setOrder,
	  resetOrder: _orders.resetOrder,
	  resetPrice: _price.resetPrice,
	  setPageTitle: _common.setPageTitle,
	  getMatchingSpareParts: _dracar.getMatchingSpareParts,
	  setLastVisitedOrderId: _orders.setLastVisitedOrderId
	}, null, { withRef: true })(Order);

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	__webpack_require__(516);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text2 = __webpack_require__(12);
	
	var _text3 = _interopRequireDefault(_text2);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _agreementConstraint = __webpack_require__(171);
	
	var _customerGroup = __webpack_require__(107);
	
	var _common = __webpack_require__(25);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	// import './salescar.scss'
	
	
	// import components
	// import HelpText from '../../../../shared/components/HelpText'
	
	
	// Elements
	
	
	// Actions
	
	
	// Utils
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      confirmDelete: {
	        open: false
	      },
	      confirmDeactivate: {
	        open: false
	      },
	      constraint: {
	        AgreementConstraintId: 0,
	        CustomerGroupId: -1,
	        CustomerGroupName: '',
	        WorkProvider: {
	          WorkProviderId: _this.props.partnerID
	        },
	        Name: 'New',
	        Active: false,
	        Comment: '',
	        PriceType: 1,
	        ConstraintBrands: [],
	        BrandSelectionType: 0,
	        HasAgreement: false,
	        SelectedBrandNameId: 0
	      }
	    };
	    _this.onInputChange = _this.onChange.bind(_this);
	    _this.changeType = _this.changeType.bind(_this);
	    _this.saveAddConstraint = _this.saveAddConstraint.bind(_this);
	    _this.addConstraint = _this.addConstraint.bind(_this);
	    _this.getCustomerGroups = _this.getCustomerGroups.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.addItem = _this.addItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAgreementConstraint(this.props);
	      this.getCustomerGroups();
	      this.props.getBrands();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (nextProps.brands === null || nextProps.brands.length === 0) {
	        this.props.getBrands();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.AgreementConstraintId !== nextProps.item.AgreementConstraintId) {
	        this.getAgreementConstraint(nextProps);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      var value = e.target.value;
	      var name = e.target.name;
	
	      if (e.target.name === 'Active') {
	        value = e.target.checked;
	      }
	
	      if (value === false && name === 'Active' && this.state.constraint.HasAgreement) return;
	      if (e.target.name === 'BrandSelectionType' || e.target.name === 'SelectedBrandNameId') {
	        value = parseInt(e.target.value);
	      }
	      this.setState({
	        // type: 'edit',
	        constraint: _extends({}, this.state.constraint, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.name !== 'SelectedBrandNameId' && (e.target.type === 'radio' || e.target.type === 'checkbox' || e.target.type === 'select-one')) {
	          _this2.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType(e) {
	      var value = parseInt(e.target.value);
	      this.setState({
	        constraint: _extends({}, this.state.constraint, _defineProperty({}, e.target.name, value))
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this3 = this;
	
	      console.log('onBlur');
	      if (this.state.constraint.AgreementConstraintId !== 0) {
	        this.setState({ type: 'edit' }, function () {
	          _this3.saveAddConstraint();
	        });
	      }
	    }
	  }, {
	    key: 'getCustomerGroups',
	    value: function getCustomerGroups() {
	      this.props.getCustomerGroups();
	    }
	  }, {
	    key: 'getAgreementConstraint',
	    value: function getAgreementConstraint(props) {
	      var _this4 = this;
	
	      if (typeof props.item.AgreementConstraintId !== 'undefined') {
	        props.getAgreementConstraint(props.item.AgreementConstraintId).then(function (res) {
	          var constraint = res.data;
	          _this4.setState({
	            type: 'edit',
	            constraint: constraint
	          });
	        }, function () {
	          _this4.props.onError();
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'saveAddConstraint',
	    value: function saveAddConstraint() {
	      var _this5 = this;
	
	      console.log('saveAddConstraint');
	      if (Number(this.state.constraint.CustomerGroupId) === -1 || (0, _lodash.isEqual)(this.state.constraint.name, '')) return undefined;
	      this.props.createSaveAgreementConstraint(this.state.constraint).then(function (res) {
	        _this5.props.onSave(res.data, _this5.state.type);
	        _this5.setState({
	          constraint: res.data
	        }, function () {
	          _this5.props.getAgreementConstraints();
	        });
	      }, function (err) {
	        // Toastr
	        // console.log('err', err.response.data.Errors)
	        _this5.setState({
	          constraint: err.response.data
	        });
	        if (err.response.data.Error !== undefined && err.response.data.Error !== null) {
	          var error = err.response.data.Error;
	          if (error === '1' || error === 1) {
	            error = '13555';
	            var collidedWPName = err.response.data.CollidedWPName;
	            var collidedConstraintName = err.response.data.CollidedConstraintName;
	            var text = (0, _helpers.translation)('13557');
	            text = text.replace('{0}', collidedWPName).replace('{1}', collidedConstraintName);
	            window.toastr.error(text, (0, _helpers.translation)('216'));
	          } else if (error === '2' || error === 2) {
	            var _collidedConstraintName = err.response.data.CollidedConstraintName;
	            var _text = (0, _helpers.translation)('@ Kan ikke aktivere adgang, Koncern {1} er inaktiv');
	            _text = _text.replace('{1}', _collidedConstraintName);
	            window.toastr.error(_text, (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)(error), (0, _helpers.translation)('216'));
	          }
	        } else {
	          window.toastr.error((0, _helpers.translation)('12285'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        constraint: {
	          AgreementConstraintId: 0,
	          CustomerGroupId: -1,
	          CustomerGroupName: '',
	          WorkProvider: {
	            WorkProviderId: this.props.partnerID
	          },
	          Name: 'New',
	          Active: false,
	          Comment: '',
	          PriceType: 1,
	          ConstraintBrands: [],
	          BrandSelectionType: 0,
	          SelectedBrandNameId: 0
	          // }, () => {
	          //   console.log('reset state', this.state)
	        } });
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	    }
	  }, {
	    key: 'renderName',
	    value: function renderName() {
	      var constraint = this.state.constraint;
	
	      if (constraint === null) return null;
	      return _react2.default.createElement(_text3.default, { name: 'Name', value: constraint.Name || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('30') });
	    }
	  }, {
	    key: 'renderComment',
	    value: function renderComment() {
	      var constraint = this.state.constraint;
	
	      if (constraint === null) return null;
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('149') },
	        _react2.default.createElement(_textarea2.default, { name: 'Comment', value: constraint.Comment || '', onChange: this.onChange, onBlur: this.onBlur })
	      );
	    }
	  }, {
	    key: 'renderOrderType',
	    value: function renderOrderType() {
	      var constraint = this.state.constraint;
	
	      if (constraint === null) return null;
	
	      return _react2.default.createElement(
	        _dropDown2.default,
	        { name: 'PriceType', disabled: this.state.type === 'edit', onChange: this.onChange, value: constraint.PriceType, labelText: (0, _helpers.translation)('69') },
	        _react2.default.createElement(
	          'option',
	          { value: 1 },
	          (0, _helpers.translation)('71')
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: 2 },
	          (0, _helpers.translation)('785')
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: 3 },
	          (0, _helpers.translation)('13361')
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: 5 },
	          (0, _helpers.translation)('13360')
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: 6 },
	          (0, _helpers.translation)('301')
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: 8 },
	          (0, _helpers.translation)('1396')
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: 0 },
	          (0, _helpers.translation)('73')
	        )
	      );
	    }
	  }, {
	    key: 'renderActive',
	    value: function renderActive() {
	      var _this6 = this;
	
	      var constraint = this.state.constraint;
	
	      if (constraint === null || this.state.type === 'create') return null;
	      var onDeactivate = function onDeactivate(e) {
	        if (!e.target.checked && _this6.state.constraint.HasAgreement) {
	          _this6.setState({
	            confirmDeactivate: {
	              open: true
	            }
	          });
	        }
	      };
	      return _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onChange, onClick: onDeactivate, checked: constraint.Active, labelText: (0, _helpers.translation)('295') });
	    }
	  }, {
	    key: 'renderCustomerGroup',
	    value: function renderCustomerGroup() {
	      var _this7 = this;
	
	      var constraint = this.state.constraint;
	
	      var customerGroups = this.props.customergroups;
	      var renderCustomerGroupsMapped = function renderCustomerGroupsMapped() {
	        if (customerGroups === null || customerGroups.length <= 0) return [];
	        return customerGroups.reduce(function (groups, cust, i) {
	          var isEnabled = cust.WorkProviderId === -1 || cust.WorkProviderId === Number(_this7.props.partnerID);
	          var opt = _react2.default.createElement(
	            'option',
	            { value: cust.CustomerGroupId, disabled: !isEnabled, key: cust.CustomerGroupId },
	            cust.Name
	          );
	          if (isEnabled && cust.Active) {
	            return [].concat(_toConsumableArray(groups), [opt]);
	          }
	          return [].concat(_toConsumableArray(groups));
	        }, []);
	        // customerGroups.map((val, i) => {
	        //   let isEnabled = val.WorkProviderId === -1 || val.WorkProviderId === Number(this.props.partnerID)
	        //   return (<option value={val.CustomerGroupId} disabled={!isEnabled} key={val.CustomerGroupId}>{val.Name}</option>)
	        // })
	      };
	      return _react2.default.createElement(
	        _dropDown2.default,
	        { name: 'CustomerGroupId', onChange: this.onChange, disabled: this.state.type === 'edit', value: constraint.CustomerGroupId, labelText: (0, _helpers.translation)('12282') },
	        _react2.default.createElement(
	          'option',
	          { value: '-1' },
	          (0, _helpers.translation)('12283')
	        ),
	        renderCustomerGroupsMapped()
	      );
	    }
	  }, {
	    key: 'addItem',
	    value: function addItem(e) {
	      if (this.state.constraint.SelectedBrandNameId !== 0) {
	        this.state.constraint.ConstraintBrands.push({
	          BrandNameId: this.state.constraint.SelectedBrandNameId,
	          AgreementConstraintId: this.state.constraint.AgreementConstraintId
	        });
	      }
	      this.onBlur();
	    }
	  }, {
	    key: 'renderBrands',
	    value: function renderBrands() {
	      var _this8 = this;
	
	      var isCustomer = !(0, _auth.hasAccess)([2], this.props.auth.user.UserType);
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) || this.state.constraint.AgreementConstraintId === 0) return null;
	      var constraint = this.state.constraint;
	
	      var isDisabled = this.state.constraint.HasAgreement;
	      // Render brand
	      var renderBrand = function renderBrand(val, key) {
	        // Delete item
	        var deleteItem = function deleteItem(e) {
	          var constraint = _extends({}, _this8.state.constraint);
	          constraint.ConstraintBrands[key].IsDeleted = true;
	          _this8.onBlur();
	        };
	        return _react2.default.createElement(
	          _grid2.default,
	          { key: key, cols: [1, 'min-content'], spacing: 1 },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            val.BrandName
	          ),
	          !isDisabled && _react2.default.createElement(_removeButton2.default, { name: key, onClick: deleteItem, size: 'm' })
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('13473'), helpText: (0, _helpers.translation)('1953') },
	          _react2.default.createElement(_radio2.default, { id: 'brands_all', name: 'BrandSelectionType', value: '0', onChange: this.onChange, checked: constraint.BrandSelectionType === 0, disabled: isCustomer || isDisabled, labelText: (0, _helpers.translation)('381') }),
	          _react2.default.createElement(_radio2.default, { id: 'brands_selected', name: 'BrandSelectionType', value: '1', onChange: this.onChange, checked: constraint.BrandSelectionType === 1, disabled: isCustomer || isDisabled, labelText: (0, _helpers.translation)('13475') })
	        ),
	        constraint.BrandSelectionType === 1 && _react2.default.createElement(
	          'div',
	          { className: 'brands' },
	          constraint.ConstraintBrands.map(renderBrand),
	          !isDisabled && _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(
	              _dropDown2.default,
	              { value: this.state.constraint.SelectedBrandNameId, onChange: this.onChange, name: 'SelectedBrandNameId' },
	              _react2.default.createElement('option', { value: 0 }),
	              this.props.brands.length > 0 && this.props.brands.map(function (val, key) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: val.Id, key: key },
	                  (0, _helpers.translation)(val.Name)
	                );
	              })
	            ),
	            _react2.default.createElement(_addButton2.default, { onClick: this.addItem })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomAgreement',
	    value: function renderCustomAgreement() {
	      var _this9 = this;
	
	      var constraint = this.state.constraint;
	
	      if (constraint === null) return null;
	
	      var onDelete = function onDelete() {
	        _this9.setState({
	          confirmDelete: {
	            open: true
	          }
	        });
	      };
	      var canDelete = (0, _auth.hasAccess)([2], this.props.auth.user.UserType) && this.state.type === 'edit' && !this.state.constraint.HasAgreement;
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('12284') },
	          this.renderName(),
	          this.renderOrderType(),
	          this.renderCustomerGroup(),
	          this.renderBrands(),
	          this.renderActive(),
	          this.renderComment(),
	          canDelete && _react2.default.createElement(_button2.default, { style: 'alert', onClick: onDelete, labelText: (0, _helpers.translation)('786') })
	        )
	      );
	    }
	  }, {
	    key: 'addConstraint',
	    value: function addConstraint() {
	      var _this10 = this;
	
	      if (Number(this.state.constraint.CustomerGroupId) === -1) return Promise.reject('no customergroup selected');
	      this.setState({ type: 'create' }, function () {});
	      return this.props.createSaveAgreementConstraint(this.state.constraint).then(function (res) {
	        _this10.props.onSave(res.data, _this10.state.type);
	      }, function (err) {
	        // Toastr
	        // console.log('err', err.response.data.Errors)
	        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	          var errors = err.response.data.Errors;
	          var errText = '';
	          for (var i = 0; i < errors.length; i++) {
	            var dictKey = errors[i].DictionaryKey;
	            errText += '<br/>' + (0, _helpers.translation)(dictKey);
	          }
	          window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('12285'), (0, _helpers.translation)('216'));
	        }
	        // Toastr
	        // window.toastr.error(translation('13463'), translation('216'))
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var confirmDeactivate = function confirmDeactivate(props) {
	        var ctext = props.t('13556');
	        return _react2.default.createElement(
	          'div',
	          null,
	          ctext
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'constraints__screen' },
	        _react2.default.createElement(
	          'fieldset',
	          { disabled: this.props.creating },
	          this.renderCustomAgreement()
	        ),
	        this.state.confirmDelete.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDelete') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirmDelete.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDelete') })
	        ),
	        this.state.confirmDeactivate.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDeactivate') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirmDeactivate.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDeactivate'), higher: true, renderText: confirmDeactivate })
	        )
	      );
	    }
	  }, {
	    key: 'onConfirmDelete',
	    value: function onConfirmDelete() {
	      var _this11 = this;
	
	      this.onPortalClose('confirmDelete');
	      this.setState({
	        constraint: _extends({}, this.state.constraint, {
	          IsDeleted: true
	        })
	      }, function () {
	        _this11.props.createSaveAgreementConstraint(_this11.state.constraint).then(function () {
	          _this11.props.onShouldUpdate();
	        });
	      });
	    }
	  }, {
	    key: 'onConfirmDeactivate',
	    value: function onConfirmDeactivate() {
	      var _this12 = this;
	
	      this.onPortalClose('confirmDeactivate');
	      this.setState({
	        constraint: _extends({}, this.state.constraint, {
	          Active: false
	        })
	      }, function () {
	        _this12.onBlur();
	      });
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    brands: state.common.brands,
	    customergroups: state.common.customergroups
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createSaveAgreementConstraint: _agreementConstraint.createSaveAgreementConstraint,
	  getAgreementConstraint: _agreementConstraint.getAgreementConstraint,
	  getBrands: _common.getBrands,
	  getCustomerGroups: _customerGroup.getCustomerGroups
	}, null, { withRef: true })(View);

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _workProvider = __webpack_require__(195);
	
	var _agreementConstraint = __webpack_require__(171);
	
	var _common = __webpack_require__(25);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _View = __webpack_require__(924);
	
	var _View2 = _interopRequireDefault(_View);
	
	__webpack_require__(516);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import components
	
	// import LeftMenu from '../../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	// import Text from '../../../shared/elements/text'
	// import Check from '../../../shared/elements/check'
	
	
	// Views
	
	
	// import styles
	
	
	// Utils
	
	
	var Constraints = function (_Component) {
	  _inherits(Constraints, _Component);
	
	  function Constraints(props) {
	    _classCallCheck(this, Constraints);
	
	    var _this = _possibleConstructorReturn(this, (Constraints.__proto__ || Object.getPrototypeOf(Constraints)).call(this, props));
	
	    _this.state = {
	      price: {},
	      view: 'list',
	      activeItem: {},
	      constraints: [],
	      partnerName: '',
	      isUpdating: false,
	      search: '',
	      includeInactive: false
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onViewFail = _this.onViewFail.bind(_this);
	    _this.setState = _this.setState.bind(_this);
	    _this.onShouldUpdate = _this.onShouldUpdate.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    return _this;
	  }
	
	  _createClass(Constraints, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPartner(this.props);
	      this.getAgreementConstraints();
	      this.props.getBrands();
	      if (typeof this.props.params.ConstraintID !== 'undefined') {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            AgreementConstraintId: this.props.params.ConstraintID
	          }
	        }, function () {
	          // console.log('didmount', this.state)
	        });
	      }
	    }
	  }, {
	    key: 'getPartner',
	    value: function getPartner(props) {
	      var _this2 = this;
	
	      if (typeof props.params.partnerID !== 'undefined') {
	        props.getPartner(props.params.partnerID).then(function (res) {
	          _this2.setState({
	            partnerName: res.data.Name
	          }, function () {});
	        }, function (err) {
	          if (err.response.status === 401) {
	            _this2.props.router.replace('/orders');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onShouldUpdate',
	    value: function onShouldUpdate() {
	      var _this3 = this;
	
	      this.setState({
	        view: 'list',
	        activeItem: {}
	      }, function () {
	        _this3.props.params.ConstraintID = undefined;
	        _this3.props.router.push('/partners/' + _this3.props.params.partnerID + '/constraints');
	        _this3.getAgreementConstraints().then(function () {
	          // Toastr
	          // window.toastr.success(translation('13444'), translation('13424'))
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('2018'), (0, _helpers.translation)('216'));
	        });
	      });
	    }
	  }, {
	    key: 'getAgreementConstraints',
	    value: function getAgreementConstraints() {
	      var _this4 = this;
	
	      return this.props.getAgreementConstraints(this.props.params.partnerID).then(function (res) {
	        _this4.setState({
	          constraints: res.data
	        });
	        if (res.data.length === 0) {
	          _this4.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var _this5 = this;
	
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      }, function () {
	        _this5.props.router.replace('/partners/' + _this5.props.params.partnerID + '/constraints');
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) && this.state.constraints.length < 2) return null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('12291'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({
	          search: e.target.value
	        });
	      }
	      if (e.target.name === 'Inactive') {
	        this.setState({
	          includeInactive: e.target.checked
	        });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      if (key.Name === undefined || key.Name === null) return true;
	      if (key.Name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.Active : true)) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'leftMenu',
	    value: function leftMenu() {
	      var _this6 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this6.setState({ isUpdating: true });
	          _this6.refs.view.getWrappedInstance().addConstraint().then(function () {
	            _this6.setState({ isUpdating: false });
	          }, function () {
	            window.toastr.error((0, _helpers.translation)('12285'), (0, _helpers.translation)('216'));
	            _this6.setState({ isUpdating: false });
	          });
	        };
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { disabled: this.state.isUpdating, onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', disabled: this.state.isUpdating, onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      var constraints = this.state.constraints;
	      var grouping = [];
	
	      var _loop = function _loop(i) {
	        var group = grouping.find(function (val, idx) {
	          return val.customerGroupName === constraints[i].CustomerGroupName;
	        });
	        if (group === undefined) {
	          group = {
	            customerGroupName: constraints[i].CustomerGroupName,
	            constraints: []
	          };
	          grouping.push(group);
	        }
	        group.constraints.push(constraints[i]);
	      };
	
	      for (var i = 0; i < constraints.length; i++) {
	        _loop(i);
	      }
	
	      var renderGroup = function renderGroup(group, key) {
	        var renderItem = function renderItem(val, key) {
	          // Classname
	          // let classNameList = ''
	          var isSelected = false;
	          if ((0, _lodash.isEqual)(val, _this6.state.activeItem) || parseInt(val.AgreementConstraintId) === parseInt(_this6.state.activeItem.AgreementConstraintId)) {
	            // classNameList = 'active'
	            isSelected = true;
	          }
	          // On select
	          var selectItem = function selectItem() {
	            _this6.setState({
	              view: 'item',
	              activeItem: val
	            }, function () {
	              _this6.props.router.replace('/partners/' + _this6.props.params.partnerID + '/constraints/' + _this6.state.activeItem.AgreementConstraintId);
	            });
	          };
	          var name = val.Name;
	          if (val.Brand !== undefined && val.Brand !== null) {
	            name += ' (' + val.Brand + ')';
	          }
	          // Return
	          // let classname = 'item'
	          // if (!val.Active) classNameList += ' inactive'
	
	          return _react2.default.createElement(_sideMenuItem2.default, {
	            label: name,
	            onClick: selectItem,
	            selected: isSelected,
	            inactive: !val.Active,
	            key: key
	          });
	          // return (
	          //   <LeftMenuItem key={val.AgreementConstraintId} className={classname}>
	          //     <span onClick={selectItem} className={classNameList}>{name}</span>
	          //   </LeftMenuItem>
	          // )
	        };
	
	        var groupName = group.customerGroupName;
	        if (groupName === null) groupName = '(' + (0, _helpers.translation)('12268') + ')';
	
	        return _react2.default.createElement(
	          _sideMenuItem2.default,
	          {
	            label: groupName,
	            isTitle: true,
	            key: key
	          },
	          group.constraints.map(renderItem)
	        );
	        // return (
	        //   <li key={'group_' + key}>
	        //     <div className='headeritem'>{groupName}</div>
	        //     {group.constraints.filter(this.filterList).map(renderItem)}
	        //   </li>
	        // )
	      };
	
	      // Return
	      return grouping.map(renderGroup);
	      // return (
	      //   <div>
	      //     <div className='list__search'>
	      //       <Text name='SearchText' onChange={this.searchList} value={this.state.search} />
	      //       <Check id='Inactive' name='Inactive' value='0' onChange={this.searchList} checked={this.state.includeInactive === true} labelText={translation('1859')} />
	      //     </div>
	      //     <ul>
	      //       {grouping.map(renderGroup)}
	      //     </ul>
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var _this7 = this;
	
	      // console.log('Contacts onSave ', data, type)
	      var constraints = [].concat(_toConsumableArray(this.state.constraints));
	      if (type === 'create') {
	        constraints.push({
	          Name: data.Name,
	          AgreementConstraintId: data.AgreementConstraintId
	        });
	        type = 'list';
	      } else {
	        constraints.map(function (val, key) {
	          if (val.AgreementConstraintId === data.AgreementConstraintId) {
	            val.Name = data.Name;
	          }
	        });
	        type = 'item';
	      }
	      this.setState({
	        activeItem: data,
	        constraints: constraints,
	        view: data.AgreementConstraintId > 0 ? 'item' : 'list'
	      }, function () {
	        if (data.AgreementConstraintId > 0 && type === 'list') {
	          _this7.getAgreementConstraints();
	          _this7.props.router.params['ConstraintID'] = data.AgreementConstraintId;
	          _this7.props.router.replace('/partners/' + _this7.props.params.partnerID + '/constraints/' + data.AgreementConstraintId);
	        }
	      });
	      // Toastr
	      // window.toastr.success(translation('12286'), translation('13424'))
	    }
	  }, {
	    key: 'onViewFail',
	    value: function onViewFail() {
	      this.setState({
	        view: 'list',
	        activeItem: {}
	      });
	      this.props.router.replace('/partners/' + this.props.params.partnerID + '/constraints');
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { ref: 'view', item: this.state.activeItem, getAgreementConstraints: this.getAgreementConstraints.bind(this), onSave: this.onSave, partnerID: this.props.params.partnerID, onShouldUpdate: this.onShouldUpdate.bind(this), onError: this.onViewFail });
	      }
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType(e) {
	      var value = parseInt(e.target.value);
	      this.setState({
	        price: _defineProperty({}, e.target.name, value)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var headerButtonsGoBack = void 0;
	      headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	        var goBack = function goBack() {
	          _this8.props.router.push({
	            pathname: '/partners/' + _this8.props.router.params.partnerID
	          });
	        };
	        return _react2.default.createElement(_closeButton2.default, { key: 'back_close', ariaText: t('2060'), onClick: goBack });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'constraints__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, title: (0, _helpers.translation)('12292') + ' - ' + this.state.partnerName, renderRight: this.headerButtonsRight, icon: 'menu/Customers-White.png', showBack: true, headerButtonsGoBack: headerButtonsGoBack }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create' },
	          this.leftMenu()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'constraints__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Constraints;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    activeItem: state.activeItem
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getAgreementConstraints: _agreementConstraint.getAgreementConstraints, getPartner: _workProvider.getPartner, getBrands: _common.getBrands })(Constraints);

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _workProviderContact = __webpack_require__(283);
	
	__webpack_require__(1433);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _NotificationCopy = __webpack_require__(1054);
	
	var _NotificationCopy2 = _interopRequireDefault(_NotificationCopy);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	// import { loginAs } from '../../../../actions/auth'
	
	// import styles
	
	
	// Components
	
	
	// Elements
	
	
	// Utils
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      contact: {
	        UserId: null,
	        UserName: '',
	        Email: '',
	        Phone: '',
	        PhoneCode: _this.props.phonecode,
	        WorkProviderId: props.workproviderId,
	        ChainId: props.chainId,
	        Active: true,
	        NotificationSettings: []
	      }
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.saveAddContact = _this.saveAddContact.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPartnerContact(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.UserId !== nextProps.item.UserId) {
	        this.getPartnerContact(nextProps);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      var value = e.target.value;
	
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      this.setState({
	        type: 'edit',
	        contact: _extends({}, this.state.contact, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this2.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this3 = this;
	
	      if (this.state.contact.UserId !== null && this.state.contact.UserId !== 0) {
	        this.setState({ type: 'edit' }, function () {
	          _this3.saveAddContact();
	        });
	      }
	    }
	  }, {
	    key: 'getPartnerContact',
	    value: function getPartnerContact(props) {
	      var _this4 = this;
	
	      if (props.item.UserId !== undefined && props.item.UserId !== null && props.item.UserId !== 0) {
	        props.getPartnerContact(props.item.UserId).then(function (res) {
	          _this4.setState({
	            type: 'edit',
	            contact: res.data
	          });
	        }, function () {
	          _this4.props.onError();
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        contact: {
	          UserId: null,
	          Phone: '',
	          PhoneCode: this.props.phonecode,
	          Active: true,
	          UserName: '',
	          Email: '',
	          WorkProviderId: this.props.workproviderId,
	          ChainId: this.props.chainId
	        }
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this5 = this;
	
	      var value = e.target.value;
	      var name = e.target.name;
	      if (name === 'PhoneNumber') {
	        name = 'Phone';
	        this.setState({
	          contact: _extends({}, this.state.contact, _defineProperty({}, name, value))
	        });
	      } else {
	        this.setState({
	          contact: _extends({}, this.state.contact, {
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        }, function () {
	          _this5.onBlur();
	        });
	      }
	    }
	  }, {
	    key: 'renderNotificationCopy',
	    value: function renderNotificationCopy() {
	      var _this6 = this;
	
	      if (this.state.contact.UserId === null) return null;
	      var saveNotifications = function saveNotifications(notifications) {
	        _this6.setState({
	          contact: _extends({}, _this6.state.contact, {
	            NotificationSettings: notifications
	          })
	        }, function () {
	          return _this6.saveAddContact();
	        });
	      };
	
	      return _react2.default.createElement(_NotificationCopy2.default, { user: this.state.contact, SaveNotifications: saveNotifications.bind(this), SMS: true });
	    }
	  }, {
	    key: 'renderContact',
	    value: function renderContact() {
	      var contact = this.state.contact;
	
	      if (contact === null) return null;
	      var title = !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) ? '346' : '64';
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(title) },
	        _react2.default.createElement(_text2.default, { name: 'Name', value: contact.Name || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_text2.default, { name: 'UserName', value: contact.UserName || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('1') }),
	        _react2.default.createElement(_text2.default, { name: 'Email', value: contact.Email || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('1052') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('345') },
	          _react2.default.createElement(_Phone2.default, {
	            onChange: this.onInputChange,
	            onBlur: this.onBlur,
	            code: contact.PhoneCode,
	            number: contact.Phone })
	        ),
	        _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onChange, checked: contact.Active, labelText: (0, _helpers.translation)('295') })
	      );
	    }
	  }, {
	    key: 'saveAddContact',
	    value: function saveAddContact() {
	      var _this7 = this;
	
	      this.props.CreateSavePartnerContact(this.state.contact).then(function (res) {
	        _this7.props.onSave(res.data, _this7.state.type);
	        _this7.setState({
	          contact: res.data
	        });
	      }, function (err) {
	        // Toastr
	        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	          if (_this7.state.contact.Email !== '' && _this7.state.contact.UserName !== '') {
	            var errors = err.response.data.Errors;
	            var errText = '';
	            for (var i = 0; i < errors.length; i++) {
	              var dictKey = errors[i].DictionaryKey;
	              errText += '<br/>' + (0, _helpers.translation)(dictKey);
	            }
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          }
	        } else {
	          var errorMessage = function errorMessage(error) {
	            var messageText = '';
	            if (error < 5) {
	              messageText += (0, _helpers.translation)('17950');
	            }
	            if (messageText !== '') messageText += ' ';
	            switch (error) {
	              case 1:
	                messageText += (0, _helpers.translation)('16329');
	                break;
	              case 2:
	                messageText += (0, _helpers.translation)('16336');
	                break;
	              case 3:
	                messageText += (0, _helpers.translation)('16335');
	                break;
	              case 4:
	                messageText += (0, _helpers.translation)('16338');
	                break;
	              case 5:
	                messageText += (0, _helpers.translation)('16337');
	                break;
	              default:
	                break;
	            }
	            messageText += '<br>';
	            return messageText;
	          };
	          var _errors = err.response.data;
	          if (Array.isArray(_errors)) {
	            var message = _errors.map(function (error) {
	              return errorMessage(error);
	            });
	            window.toastr.error(message, (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('13463'), (0, _helpers.translation)('216'));
	          }
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasAccess)([2, 6], this.props.auth.user.UserType)) return null;
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderContact()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderNotificationCopy()
	        )
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  CreateSavePartnerContact: _workProviderContact.CreateSavePartnerContact,
	  getPartnerContact: _workProviderContact.getPartnerContact
	}, null, { withRef: true })(View);

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _workProvider = __webpack_require__(195);
	
	var _workProviderContact = __webpack_require__(283);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _CreateUser = __webpack_require__(197);
	
	var _CreateUser2 = _interopRequireDefault(_CreateUser);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _View = __webpack_require__(926);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import components
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Contacts = function (_Component) {
	  _inherits(Contacts, _Component);
	
	  function Contacts(props) {
	    _classCallCheck(this, Contacts);
	
	    var _this = _possibleConstructorReturn(this, (Contacts.__proto__ || Object.getPrototypeOf(Contacts)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      activeItem: {},
	      contacts: [],
	      partnerName: '',
	      includeNonVerified: false
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onViewFail = _this.onViewFail.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Contacts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        this.props.params.partnerID = this.props.auth.user.WorkProviderId;
	      }
	
	      this.getPartner(this.props);
	      this.getPartnerContacts();
	      if (typeof this.props.params.contactID !== 'undefined') {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            UserId: this.props.params.contactID
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getPartner',
	    value: function getPartner(props) {
	      var _this2 = this;
	
	      if (typeof props.params.partnerID !== 'undefined') {
	        props.getPartner(props.params.partnerID).then(function (res) {
	          _this2.setState({
	            partnerName: res.data.Name
	          });
	        }, function (err) {
	          if (err.response.status === 401) {
	            _this2.props.router.replace('/orders');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getPartnerContacts',
	    value: function getPartnerContacts() {
	      var _this3 = this;
	
	      return this.props.getPartnerContacts(this.props.params.partnerID).then(function (res) {
	        _this3.setState({
	          contacts: res.data
	        });
	        if (res.data.length === 0) {
	          _this3.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'getPath',
	    value: function getPath() {
	      var path = '/partners/' + this.props.params.partnerID + '/contacts';
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        path = '/wpemployees';
	      }
	
	      return path;
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	      this.props.router.replace(this.getPath());
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) && this.state.contacts.length < 2) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('2079'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this4 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this4.refs.create.getWrappedInstance().createUser();
	        };
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return [_react2.default.createElement(
	        'div',
	        { key: 'confirmedfilter', className: 'filter' },
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { isFixed: true },
	          _react2.default.createElement(_check2.default, {
	            name: 'NonVerified',
	            checked: this.state.includeNonVerified,
	            onChange: function onChange() {
	              _this4.setState({ includeNonVerified: !_this4.state.includeNonVerified });
	            },
	            labelText: (0, _helpers.translation)('16320'),
	            spacing: 0
	          })
	        )
	      )].concat(_toConsumableArray(this.state.contacts.map(function (c) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: c.Name,
	          onClick: function onClick() {
	            return _this4.onSelectItem(c);
	          },
	          selected: c.UserId === _this4.state.activeItem.UserId,
	          inactive: !c.Active,
	          confirmed: c.Confirmed,
	          key: c.UserId
	        });
	      })));
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      this.props.router.replace(this.getPath());
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var contacts = [].concat(_toConsumableArray(this.state.contacts));
	      var activeItem = void 0;
	      if (type === 'create') {
	        contacts.push({
	          Name: data.Name,
	          UserId: data.UserId,
	          Active: data.Active,
	          Email: data.Email,
	          Confirmed: false
	        });
	        type = 'item';
	        activeItem = {
	          UserId: data.UserId,
	          Confirmed: false
	        };
	      } else {
	        contacts.map(function (val, key) {
	          if (val.UserId === data.UserId) {
	            val.Name = data.Name;
	            val.Active = data.Active;
	          }
	        });
	        type = 'item';
	        if (data.Confirmed) {
	          activeItem = {
	            UserId: data.UserId,
	            Confirmed: true
	          };
	        } else {
	          activeItem = {
	            UserId: data.UserId,
	            Name: data.Name,
	            Email: data.Email,
	            Confirmed: data.Confirmed,
	            WorkProviderId: data.WorkProviderId
	          };
	        }
	      }
	      this.setState({
	        contacts: contacts,
	        view: type,
	        activeItem: activeItem
	      });
	      // Toastr
	      // window.toastr.success(translation('13462'), translation('13424'))
	    }
	  }, {
	    key: 'onViewFail',
	    value: function onViewFail() {
	      this.setState({
	        view: 'list',
	        activeItem: {}
	      });
	      this.props.router.replace(this.getPath());
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this5 = this;
	
	      var wpId = Number(this.props.params.partnerID);
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        wpId = Number(this.props.auth.user.WorkProviderId);
	      }
	
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	          return _react2.default.createElement(_CreateUser2.default, { isWPContact: true, ref: 'create', title: (0, _helpers.translation)('346'), wpID: wpId, user: undefined, onSuccess: function onSuccess(res) {
	              return _this5.onSave(res, 'create');
	            } });
	        case 'item':
	          if (this.state.activeItem.Confirmed !== true) return _react2.default.createElement(_CreateUser2.default, { isWPContact: true, user: this.state.activeItem, title: (0, _helpers.translation)('346'), onSuccess: function onSuccess(res) {
	              return _this5.onSave(res, 'item');
	            } });
	          return _react2.default.createElement(_View2.default, { ref: 'view', item: this.state.activeItem, onSave: this.onSave, chainId: this.props.auth.user.ChainId, workproviderId: wpId, onError: this.onViewFail });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var headerButtonsGoBack = void 0;
	      headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	        var goBack = function goBack() {
	          _this6.props.router.replace({
	            pathname: '/partners',
	            query: {
	              partnerId: _this6.props.params.partnerID
	            }
	          });
	        };
	        return _react2.default.createElement(_closeButton2.default, { ariaText: t('2060'), onClick: goBack });
	      };
	
	      // let title = translation('13460')
	
	      // if (hasAccess([6], this.props.auth.user.UserType)) {
	      //   title = translation('10')
	      // }
	
	      var customFilter = function customFilter(item, showInactive) {
	        // Include any items not confirmed if using this filter
	        if (_this6.state.includeNonVerified && !item.confirmed) {
	          return true;
	        }
	        if (showInactive) {
	          // Exclude unconfirmed
	          return item.confirmed;
	        }
	        return !item.inactive;
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'partners_contacts__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: this.headerButtonsRight, showBack: true, headerButtonsGoBack: headerButtonsGoBack }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create', customFilter: customFilter },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'partners_contacts__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Contacts;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getPartnerContacts: _workProviderContact.getPartnerContacts, getPartner: _workProvider.getPartner })(Contacts);

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _icons = __webpack_require__(6);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	__webpack_require__(1434);
	
	var _workProvider = __webpack_require__(195);
	
	var _agreementConstraint = __webpack_require__(171);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	// import Phone from '../../../shared/components/Phone'
	
	
	// Elements
	
	
	// import styles
	
	
	// Actions
	
	
	// Utils
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      partner: {},
	      constraints: [],
	      confirmDelete: {
	        open: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPartner(this.props);
	      this.getAgreementConstraints(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.getPartner(nextProps);
	      this.getAgreementConstraints(nextProps);
	    }
	  }, {
	    key: 'getPartner',
	    value: function getPartner(props) {
	      var _this2 = this;
	
	      if (typeof props.item.WorkProviderId !== 'undefined') {
	        props.getPartner(props.item.WorkProviderId).then(function (res) {
	          _this2.setState({
	            type: 'edit',
	            partner: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'getAgreementConstraints',
	    value: function getAgreementConstraints(props) {
	      var _this3 = this;
	
	      if (typeof props.item.WorkProviderId !== 'undefined') {
	        props.getAgreementConstraints(props.item.WorkProviderId).then(function (res) {
	          _this3.setState({
	            type: 'edit',
	            constraints: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        partner: {
	          Active: false,
	          Comment: '',
	          DebitNr: '',
	          IsDeleted: false,
	          Name: ''
	        },
	        constraints: [],
	        confirmDelete: {
	          open: false
	        }
	      });
	    }
	  }, {
	    key: 'saveAddPartners',
	    value: function saveAddPartners() {
	      var _this4 = this;
	
	      return this.props.CreateSavePartner(this.state.partner).then(function (res) {
	        _this4.props.onSave(res.data, _this4.state.type);
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('1733'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      // console.log(e.target)
	      var value = e.target.value;
	      var name = e.target.name;
	      this.setState({
	        shop: _extends({}, this.state.shop, _defineProperty({}, name, value))
	      }, this.saveAddShop);
	    }
	  }, {
	    key: 'renderPartner',
	    value: function renderPartner() {
	      var _this5 = this;
	
	      var partner = this.state.partner;
	
	      if (Object.keys(partner).length === 0) return null;
	
	      var ActiveChecked = function ActiveChecked(type, active) {
	        if (active === type) {
	          return true;
	        }
	      };
	
	      // On change
	      var onChange = function onChange(e) {
	        var value = e.target.value;
	        var name = e.target.name;
	        if (name === 'PhoneNumber') name = 'Phone';
	        if (name === 'PhoneCode') {
	          value = {
	            Id: value
	          };
	        }
	        if (name === 'Active') {
	          value = value === 'true';
	        }
	        _this5.setState({
	          partner: _extends({}, _this5.state.partner, _defineProperty({}, name, value))
	        }, function () {
	          if (name === 'PhoneCode' && _this5.state.type === 'edit') {
	            _this5.saveAddPartners();
	          }
	          if (name === 'Active') {
	            onBlur();
	          }
	        });
	      };
	      // On blur
	      var onBlur = function onBlur(e) {
	        if (_this5.state.type === 'edit') {
	          _this5.saveAddPartners();
	        }
	      };
	
	      var onDelete = function onDelete() {
	        _this5.setState({
	          confirmDelete: {
	            open: true
	          }
	        });
	      };
	      var isCreate = true; // disable delete for now. // this.state.type === 'create'
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1878') },
	        _react2.default.createElement(_text2.default, { name: 'Name', value: partner.Name, onChange: onChange, onBlur: onBlur, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('149') },
	          _react2.default.createElement(_textarea2.default, { name: 'Comment', value: partner.Comment, onChange: onChange, onBlur: onBlur })
	        ),
	        _react2.default.createElement(_switch2.default, { name: 'Active', value: 'true', checked: ActiveChecked(true, partner.Active) || false, onChange: onChange, labelText: (0, _helpers.translation)('295') }),
	        !isCreate && _react2.default.createElement(_button2.default, { onClick: onDelete, labelText: (0, _helpers.translation)('786') })
	      );
	    }
	  }, {
	    key: 'renderContacts',
	    value: function renderContacts() {
	      if (this.state.type === 'create') return null;
	      var partner = this.state.partner;
	
	
	      var renderContact = function renderContact(val, key) {
	        return _react2.default.createElement(
	          _label2.default,
	          { key: key },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/partners/' + partner.WorkProviderId + '/contacts/' + val.UserId },
	            val.Name
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13460') },
	        _react2.default.createElement(
	          _actions2.default,
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/partners/' + partner.WorkProviderId + '/contacts' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': (0, _helpers.translation)('12295') },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't' })
	            )
	          )
	        ),
	        partner.WorkProviderContacts !== undefined && partner.WorkProviderContacts !== null ? partner.WorkProviderContacts.map(renderContact) : undefined
	      );
	    }
	  }, {
	    key: 'renderAgreements',
	    value: function renderAgreements() {
	      if (this.state.type === 'create') return null;
	      var partner = this.state.partner;
	
	      var constraints = this.state.constraints;
	      var grouping = [];
	
	      var _loop = function _loop(i) {
	        var group = grouping.find(function (val, idx) {
	          return val.customerGroupName === constraints[i].CustomerGroupName;
	        });
	        if (group === undefined) {
	          group = {
	            customerGroupName: constraints[i].CustomerGroupName,
	            constraints: []
	          };
	          grouping.push(group);
	        }
	        group.constraints.push(constraints[i]);
	      };
	
	      for (var i = 0; i < constraints.length; i++) {
	        _loop(i);
	      }
	
	      var renderGroup = function renderGroup(group, key) {
	        var renderConstraint = function renderConstraint(val, key) {
	          var name = val.Name;
	          if (val.Brand !== undefined && val.Brand !== null) {
	            name += ' (' + val.Brand + ')';
	          }
	          return _react2.default.createElement(
	            _label2.default,
	            { key: val.AgreementConstraintId },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/partners/' + partner.WorkProviderId + '/constraints/' + val.AgreementConstraintId },
	              name
	            )
	          );
	        };
	
	        var groupName = group.customerGroupName;
	        if (groupName === null) groupName = '(' + (0, _helpers.translation)('12268') + ')';
	        return _react2.default.createElement(
	          'div',
	          { key: 'group_' + key },
	          _react2.default.createElement(
	            'h3',
	            null,
	            groupName
	          ),
	          group.constraints.map(renderConstraint)
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('12284') },
	        _react2.default.createElement(
	          _actions2.default,
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/partners/' + partner.WorkProviderId + '/constraints' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint--left', 'aria-label': (0, _helpers.translation)('12294') },
	              _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't' })
	            )
	          )
	        ),
	        grouping.map(renderGroup)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderPartner(),
	          this.renderContacts()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderAgreements()
	        ),
	        this.state.confirmDelete.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDelete') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirmDelete.bind(this), notConfirm: this.onPortalClose.bind(this, 'confirmDelete') })
	        )
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })));
	    }
	  }, {
	    key: 'onConfirmDelete',
	    value: function onConfirmDelete() {
	      this.onPortalClose('confirmDelete');
	      //  let price = { ...this.state.price }
	      //  price.IsDeleted = true
	      //  this.updatePrices(price).then(() => {
	      //    this.props.onShouldUpdate()
	      //  })
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  CreateSavePartner: _workProvider.CreateSavePartner,
	  getPartner: _workProvider.getPartner,
	  getAgreementConstraints: _agreementConstraint.getAgreementConstraints
	}, null, { withRef: true })(View);

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _workProvider = __webpack_require__(195);
	
	__webpack_require__(1435);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _View = __webpack_require__(928);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Partners = function (_Component) {
	  _inherits(Partners, _Component);
	
	  function Partners(props) {
	    _classCallCheck(this, Partners);
	
	    var _this = _possibleConstructorReturn(this, (Partners.__proto__ || Object.getPrototypeOf(Partners)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      activeItem: {},
	      partners: [],
	      isUpdating: false
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    return _this;
	  }
	
	  _createClass(Partners, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPartners();
	    }
	  }, {
	    key: 'getPartners',
	    value: function getPartners() {
	      var _this2 = this;
	
	      this.props.getPartners().then(function (res) {
	        _this2.setState({
	          partners: res.data
	        }, function () {
	          if (res.data.length === 0) {
	            _this2.changeView('create');
	          } else {
	            if (_this2.props.router.params.partnerID !== undefined) {
	              _this2.setState({
	                view: 'item',
	                activeItem: _this2.state.partners.find(function (value, index) {
	                  return (0, _lodash.isEqual)(value.WorkProviderId, Number(_this2.props.router.params.partnerID));
	                })
	              });
	            }
	          }
	        });
	      }, function () {
	        console.log('Error getting partners');
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var partners = [].concat(_toConsumableArray(this.state.partners));
	      var activeItem = void 0;
	      if (type === 'create') {
	        partners.push({
	          WorkProviderId: data.WorkProviderId,
	          Name: data.Name
	        });
	        type = 'list';
	        activeItem = {
	          WorkProviderId: data.WorkProviderId
	        };
	      } else {
	        partners.map(function (val, key) {
	          if (val.WorkProviderId === data.WorkProviderId) {
	            val.Name = data.Name;
	            val.Active = data.Active;
	          }
	        });
	        type = 'item';
	        activeItem = {
	          WorkProviderId: data.WorkProviderId
	        };
	      }
	      this.setState({
	        partners: partners,
	        view: type,
	        activeItem: activeItem
	      });
	
	      // console.log(partners)
	      // Toastr
	      // window.toastr.success(translation('1734'), translation('13424'))
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('2049'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.setState({ isUpdating: true });
	          _this3.refs.view.getWrappedInstance().saveAddPartners().then(function () {
	            _this3.setState({ isUpdating: false });
	          });
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { disabled: this.state.isUpdating, onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', disabled: this.state.isUpdating, onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.partners.map(function (p) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: p.Name,
	          onClick: function onClick() {
	            return _this3.onSelectItem(p);
	          },
	          selected: p.WorkProviderId === _this3.state.activeItem.WorkProviderId,
	          inactive: !p.Active,
	          key: p.WorkProviderId
	        });
	      });
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { ref: 'view', item: this.state.activeItem, onSave: this.onSave });
	      }
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      var _this4 = this;
	
	      this.setState({
	        view: 'item',
	        activeItem: item
	      }, function () {
	        _this4.props.router.replace('/partners/' + item.WorkProviderId);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'partners__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: function renderRight() {
	            return _this5.headerButtonsRight();
	          } }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create' },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'partners__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Partners;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPartners: _workProvider.getPartners
	})(Partners);

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _auth = __webpack_require__(68);
	
	var _language = __webpack_require__(139);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Auth = __webpack_require__(226);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	__webpack_require__(1436);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Auth wrapper
	
	
	// Utils
	
	
	// Elements
	
	
	var PasswordReset = function (_Component) {
	  _inherits(PasswordReset, _Component);
	
	  function PasswordReset(props) {
	    _classCallCheck(this, PasswordReset);
	
	    var _this = _possibleConstructorReturn(this, (PasswordReset.__proto__ || Object.getPrototypeOf(PasswordReset)).call(this, props));
	
	    _this.state = {
	      password: '',
	      confirmPassword: '',
	      validToken: false,
	      passWasChanged: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onKeyPress = _this.onKeyPress.bind(_this);
	    _this.changePassword = _this.changePassword.bind(_this);
	    return _this;
	  }
	
	  _createClass(PasswordReset, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(props) {
	      var _this2 = this;
	
	      if (!this.props.params.resetToken) {
	        this.props.router.push('/');
	      } else {
	        // Set language if undefined
	        if (typeof window.localStorage.user_language !== 'undefined') {
	          _store2.default.dispatch((0, _language.setLanguage)(window.localStorage.user_language));
	        } else {
	          _store2.default.dispatch((0, _language.setLanguage)('Danish'));
	        }
	
	        this.props.validatePasswordResetToken(this.props.params.resetToken).then(function (response) {
	          if (response.status === 200) {
	            _this2.setState({ validToken: true });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      if (this.state[e.target.name] !== undefined && this.state[e.target.name] !== e.target.value) {
	        this.setState(_defineProperty({}, e.target.name, e.target.value));
	      }
	    }
	  }, {
	    key: 'onKeyPress',
	    value: function onKeyPress(e) {
	      if (e.key === 'Enter') {
	        if (this.state.password !== '' && this.state.confirmPassword !== '') {
	          this.changePassword();
	        }
	      }
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword() {
	      var _this3 = this;
	
	      if (this.state.password === '') {
	        window.toastr.error((0, _helpers.translation)(16374), (0, _helpers.translation)('216'));
	        return;
	      }
	
	      if (this.state.password !== this.state.confirmPassword) {
	        window.toastr.error((0, _helpers.translation)(16352), (0, _helpers.translation)('216'));
	        return;
	      }
	
	      this.props.changePasswordByToken(this.props.params.resetToken, this.state.password).then(function (response) {
	        if (response.status === 200) {
	          _this3.setState({ passWasChanged: true });
	        }
	      }, function (err) {
	        err.response.data.map(function (e) {
	          // Check for 'Reset password link no longer valid' error.
	          if (e.DictionaryKey === 16353) {
	            _this3.setState({ validToken: false });
	            return;
	          }
	
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(e.DictionaryKey), (0, _helpers.translation)('216'));
	        });
	      });
	    }
	  }, {
	    key: 'renderInvalidToken',
	    value: function renderInvalidToken() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        _react2.default.createElement(
	          _panel2.default,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            (0, _helpers.translation)(1077)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)(16353)
	          ),
	          _react2.default.createElement(_button2.default, { onClick: function onClick() {
	              _this4.props.router.push('/');
	            }, labelText: 16376 })
	        )
	      );
	    }
	  }, {
	    key: 'renderValidToken',
	    value: function renderValidToken() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 3 },
	        _react2.default.createElement(
	          _panel2.default,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            (0, _helpers.translation)(1077)
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: '' /* ['1fr', 'min-content', '1fr'] */ },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_panelHeader2.default, { text: 16377 }),
	              _react2.default.createElement(_text2.default, { isPassword: true, name: 'password', labelText: 2, value: this.state.password, onChange: this.onChange, onKeyPress: this.onKeyPress }),
	              _react2.default.createElement(_text2.default, { isPassword: true, name: 'confirmPassword', labelText: 14883, value: this.state.confirmPassword, onChange: this.onChange, onKeyPress: this.onKeyPress }),
	              _react2.default.createElement(_button2.default, { onClick: this.changePassword, labelText: 1777 })
	            ),
	            _react2.default.createElement(_divider2.default, { vertical: true }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_panelHeader2.default, { text: 16378 }),
	              _react2.default.createElement(
	                'p',
	                null,
	                (0, _helpers.translation)(16379)
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                (0, _helpers.translation)(16380)
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPassChanged',
	    value: function renderPassChanged() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        _react2.default.createElement(
	          _panel2.default,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            (0, _helpers.translation)(1077)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)(16375)
	          ),
	          _react2.default.createElement(_button2.default, { onClick: function onClick() {
	              _this5.props.router.push('/');
	            }, labelText: 16376 })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.state.passWasChanged ? this.renderPassChanged() : this.state.validToken ? this.renderValidToken() : this.renderInvalidToken();
	      return _react2.default.createElement(
	        _Auth2.default,
	        { router: this.props.router },
	        _react2.default.createElement(
	          'div',
	          { className: 'password-reset' },
	          content
	        )
	      );
	    }
	  }]);
	
	  return PasswordReset;
	}(_react.Component);
	
	PasswordReset.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  changePasswordByToken: _auth.changePasswordByToken,
	  validatePasswordResetToken: _auth.validatePasswordResetToken,
	  setLanguage: _language.setLanguage
	})(PasswordReset);

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _helpers = __webpack_require__(2);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _responseTime = __webpack_require__(932);
	
	var _responseTime2 = _interopRequireDefault(_responseTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Performance = function (_Component) {
	  _inherits(Performance, _Component);
	
	  function Performance(props) {
	    _classCallCheck(this, Performance);
	
	    var _this = _possibleConstructorReturn(this, (Performance.__proto__ || Object.getPrototypeOf(Performance)).call(this, props));
	
	    _this.state = {
	      selectedTabIndex: 0,
	      tabs: [{
	        title: 18370,
	        component: _responseTime2.default
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Performance, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderTitle = function renderTitle(title, index) {
	        return _react2.default.createElement(_tabItem2.default, {
	          key: index,
	          onClick: function onClick() {
	            return _this2.setState({ selectedTabIndex: index });
	          },
	          labelText: (0, _helpers.translation)(title.title),
	          active: _this2.state.selectedTabIndex === index
	        });
	      };
	
	      var _state$tabs$state$sel = this.state.tabs[this.state.selectedTabIndex],
	          Component = _state$tabs$state$sel.component,
	          props = _state$tabs$state$sel.props;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Header2.default,
	          { router: this.props.router },
	          _react2.default.createElement(
	            _tabBar2.default,
	            null,
	            this.state.tabs.map(renderTitle)
	          )
	        ),
	        _react2.default.createElement(Component, props)
	      );
	    }
	  }]);
	
	  return Performance;
	}(_react.Component);
	
	exports.default = Performance;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _performance = __webpack_require__(797);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _EChart = __webpack_require__(1028);
	
	var _EChart2 = _interopRequireDefault(_EChart);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(1437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// utils
	
	
	// actions
	
	
	// elements
	
	
	// style
	
	
	var statisticsType = {
	  Day: 0,
	  Week: 1
	};
	
	var ResponseTime = function (_Component) {
	  _inherits(ResponseTime, _Component);
	
	  function ResponseTime(props) {
	    _classCallCheck(this, ResponseTime);
	
	    var _this = _possibleConstructorReturn(this, (ResponseTime.__proto__ || Object.getPrototypeOf(ResponseTime)).call(this, props));
	
	    _this.state = {
	      statisticsType: statisticsType.Day,
	      releases: [],
	      newRelease: {
	        Date: new Date(),
	        VersionText: ''
	      },
	      isLoading: false,
	      statistics: {
	        XAxis: [],
	        TotalRequests: [],
	        AveregeRequestTimeMs: [],
	        Over5s: [],
	        Over10s: [],
	        Over30s: [],
	        Over60s: [],
	        Over120s: [],
	        Over300s: [],
	        Over600s: []
	      }
	    };
	
	    _this.getStatistics = _this.getStatistics.bind(_this);
	    _this.getReleases = _this.getReleases.bind(_this);
	    _this.postRelease = _this.postRelease.bind(_this);
	
	    _this.renderReleases = _this.renderReleases.bind(_this);
	    _this.renderStatistics = _this.renderStatistics.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResponseTime, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getStatistics();
	      this.getReleases();
	    }
	  }, {
	    key: 'getStatistics',
	    value: function getStatistics() {
	      var _this2 = this;
	
	      this.props.getResponseTimeStatistics(this.state.statisticsType).then(function (res) {
	        _this2.setState({
	          statistics: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getReleases',
	    value: function getReleases() {
	      var _this3 = this;
	
	      this.props.getReleases().then(function (res) {
	        _this3.setState({
	          releases: res.data
	        });
	      });
	    }
	  }, {
	    key: 'postRelease',
	    value: function postRelease(release) {
	      var _this4 = this;
	
	      return this.props.postRelease(release).then(function (res) {
	        _this4.setState({ releases: res.data });
	        // window.toastr.success(translation('893'), translation('13424'))
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderReleases',
	    value: function renderReleases() {
	      var _this5 = this;
	
	      var renderAdd = function renderAdd() {
	        var onChange = function onChange(e) {
	          var value = '';
	          var name = '';
	          if (typeof e.target !== 'undefined') {
	            value = e.target.value;
	            name = e.target.name;
	          } else {
	            value = e;
	            name = 'Date';
	          }
	          _this5.setState({
	            newRelease: _extends({}, _this5.state.newRelease, _defineProperty({}, name, value))
	          });
	        };
	
	        var addRelease = function addRelease() {
	          _this5.setState({ isLoading: true }, function () {
	            return _this5.postRelease(_this5.state.newRelease).then(function () {
	              _this5.setState({ isLoading: false, newRelease: { Date: new Date(), VersionText: '' } });
	            });
	          });
	        };
	
	        return _react2.default.createElement(
	          _tableRow2.default,
	          null,
	          _react2.default.createElement(_datetime2.default, {
	            inputProps: {
	              name: 'Date',
	              placeholder: (0, _helpers.translation)('1728'),
	              readOnly: true
	            },
	            dateFormat: 'DD-MM-YYYY',
	            timeFormat: false,
	            closeOnSelect: true,
	            value: _this5.state.newRelease.Date,
	            onChange: onChange,
	            size: 'm' }),
	          _react2.default.createElement(_text2.default, { name: 'VersionText', value: _this5.state.newRelease.VersionText, onChange: onChange, size: 'm' }),
	          _react2.default.createElement(_addButton2.default, { spacing: 0, onClick: addRelease, disabled: _this5.state.isLoading, size: 'm' })
	        );
	      };
	
	      var renderRelease = function renderRelease(item, key) {
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { key: key },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _time.renderDate)(item.Date)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            item.VersionText
	          ),
	          _react2.default.createElement(_removeButton2.default, { spacing: 0, onClick: function onClick() {
	              return _this5.postRelease(_extends({}, item, { IsDeleted: true }));
	            }, size: 'm' })
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(18371), id: 'releases' },
	        _react2.default.createElement(
	          _tableRow2.default,
	          { header: true },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(388)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(1229)
	          )
	        ),
	        renderAdd(),
	        this.state.releases.map(renderRelease)
	      );
	    }
	  }, {
	    key: 'renderStatistics',
	    value: function renderStatistics() {
	      var zoomStart = (0, _moment2.default)().add({ months: -3 });
	      var marks = this.state.releases.map(function (x) {
	        return [{ name: x.VersionText, xAxis: (0, _time.renderDate)(x.Date) }, { xAxis: (0, _time.renderDate)((0, _moment2.default)(x.Date).add({ days: 1 })) }];
	      });
	      var dataZoom = [{ startValue: (0, _time.renderDate)(zoomStart) }, { type: 'inside' }];
	      if (this.state.statisticsType === statisticsType.Week) {
	        // formatted for ISO week of year i.e 01,02...52,53
	        marks = this.state.releases.map(function (x) {
	          return [{ name: x.VersionText, xAxis: (0, _moment2.default)(x.Date).year() + ', ' + (0, _moment2.default)(x.Date).format('WW') }, { xAxis: (0, _moment2.default)(x.Date).add({ days: 7 }).year() + ', ' + (0, _moment2.default)(x.Date).add({ days: 7 }).format('WW') }];
	        });
	        dataZoom[0].startValue = zoomStart.year() + ', ' + zoomStart.format('WW');
	      }
	      var releaseMarks = { type: 'line', markArea: { itemStyle: { color: 'rgba(128, 128, 128, 0.3)' }, data: marks } };
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'graphs' },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)(18372) },
	          _react2.default.createElement(_EChart2.default, { options: {
	              tooltip: {
	                trigger: 'axis',
	                position: function position(pt) {
	                  return [pt[0], '10%'];
	                }
	              },
	              toolbox: {
	                feature: {
	                  dataZoom: {
	                    yAxisIndex: 'none'
	                  },
	                  saveAsImage: {}
	                }
	              },
	              xAxis: {
	                type: 'category',
	                data: this.state.statistics.XAxis
	              },
	              yAxis: {
	                type: 'value'
	              },
	              dataZoom: dataZoom,
	              series: [{
	                name: (0, _helpers.translation)(18373),
	                type: 'line',
	                data: this.state.statistics.TotalRequests
	              }, releaseMarks]
	            } })
	        ),
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)(18374) },
	          _react2.default.createElement(_EChart2.default, { options: {
	              tooltip: {
	                trigger: 'axis',
	                position: function position(pt) {
	                  return [pt[0], '10%'];
	                }
	              },
	              toolbox: {
	                feature: {
	                  dataZoom: {
	                    yAxisIndex: 'none'
	                  },
	                  saveAsImage: {}
	                }
	              },
	              xAxis: {
	                type: 'category',
	                data: this.state.statistics.XAxis
	              },
	              yAxis: {
	                type: 'value',
	                axisLabel: {
	                  formatter: '{value} ms'
	                }
	              },
	              dataZoom: dataZoom,
	              series: [{
	                name: (0, _helpers.translation)(18375),
	                type: 'line',
	                data: this.state.statistics.AveregeRequestTimeMs
	              }, releaseMarks]
	            } })
	        ),
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)(18370) },
	          _react2.default.createElement(_EChart2.default, { options: {
	              tooltip: {
	                trigger: 'axis',
	                position: function position(pt) {
	                  return [pt[0], '10%'];
	                }
	              },
	              toolbox: {
	                feature: {
	                  dataZoom: {
	                    yAxisIndex: 'none'
	                  },
	                  saveAsImage: {}
	                }
	              },
	              xAxis: {
	                type: 'category',
	                data: this.state.statistics.XAxis
	              },
	              yAxis: {
	                type: 'value'
	              },
	              dataZoom: dataZoom,
	              series: [{
	                name: (0, _helpers.translation)(18376),
	                type: 'line',
	                data: this.state.statistics.Over5s
	              }, {
	                name: (0, _helpers.translation)(18377),
	                type: 'line',
	                data: this.state.statistics.Over10s
	              }, {
	                name: (0, _helpers.translation)(18378),
	                type: 'line',
	                data: this.state.statistics.Over30s
	              }, {
	                name: (0, _helpers.translation)(18379),
	                type: 'line',
	                data: this.state.statistics.Over60s
	              }, {
	                name: (0, _helpers.translation)(18380),
	                type: 'line',
	                data: this.state.statistics.Over120s
	              }, {
	                name: (0, _helpers.translation)(18381),
	                type: 'line',
	                data: this.state.statistics.Over300s
	              }, {
	                name: (0, _helpers.translation)(18382),
	                type: 'line',
	                data: this.state.statistics.Over600s
	              }, releaseMarks]
	            } })
	        )
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var _this6 = this;
	
	      var onChange = function onChange(_ref) {
	        var target = _ref.target;
	        return _this6.setState(_defineProperty({}, target.name, target.value), _this6.getStatistics);
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'top-bar' },
	        _react2.default.createElement(
	          _inline2.default,
	          null,
	          _react2.default.createElement(
	            _dropDown2.default,
	            { size: 'm', name: 'statisticsType', onChange: onChange, value: this.state.statisticsType },
	            _react2.default.createElement(
	              'option',
	              { value: statisticsType.Day },
	              (0, _helpers.translation)('483')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: statisticsType.Week },
	              (0, _helpers.translation)('250')
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'responsetime' },
	        this.renderHeader(),
	        this.renderStatistics(),
	        this.renderReleases()
	      );
	    }
	  }]);
	
	  return ResponseTime;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getReleases: _performance.getReleases,
	  postRelease: _performance.postRelease,
	  getResponseTimeStatistics: _performance.getResponseTimeStatistics
	})(ResponseTime);

/***/ }),
/* 933 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createConfigContext = createConfigContext;
	exports.getTaskPriceConfig = getTaskPriceConfig;
	exports.getServiceTaskConfig = getServiceTaskConfig;
	exports.getAddonStartTimeConfig = getAddonStartTimeConfig;
	exports.getAddonPartConfig = getAddonPartConfig;
	function createConfigContext(auth, price) {
	  return {
	    isCustomerList: price.CustomerId > 0,
	    isShopList: price.CustomerId === 0 && price.ShopId > 0,
	    isChainList: price.CustomerId === 0 && price.ShopId === 0 && price.ChainId > 0,
	    isCustomerUser: auth.user.UserType === 4,
	    isShopUser: auth.user.UserType === 5,
	    isChainUser: auth.user.UserType === 2,
	    isWorkProviderUser: auth.user.UserType === 6,
	    isWorkProviderPM: price.WorkProviderId > 0,
	    isSuperUser: auth.user.UserType === 1,
	    department: price.Department,
	    onlyShow: (auth.user.UserType === 1 || auth.user.UserType === 6) && price.UseRecommended
	  };
	}
	
	function getTaskPriceConfig(context) {
	  return {
	    itemIdField: 'TaskPriceId',
	    itemOrderField: 'SortIndex',
	    itemOrderLocked: 'SortIndexLocked',
	    editable: !context.isCustomerUser && (!context.isWorkProviderPM && !context.isWorkProviderUser || context.isWorkProviderPM && context.isWorkProviderUser),
	    whitebox: true,
	    draggable: !context.isWorkProviderPM && !context.isWorkProviderUser || context.isWorkProviderPM && context.isWorkProviderUser,
	    title: 'No title',
	    groupCss: 'partitem__list',
	    itemCss: 'taskpriceItem',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'TaskName',
	      header: 1203,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'name',
	      col: 3
	    }, {
	      name: 'AE',
	      header: 885,
	      type: 'ae',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Gross',
	      header: 13350,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Discount',
	      header: 15014,
	      type: 'percent',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Net',
	      header: 1392,
	      type: 'currency',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Environment',
	      header: 1044,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Total',
	      header: 393,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }],
	    newItemInputs: ['TaskName', 'AE', 'Discount'],
	    groupField: 'PartItemId'
	  };
	}
	
	function getServiceTaskConfig(context) {
	  return {
	    itemIdField: 'ServiceTaskId',
	    itemOrderField: 'SortIndex',
	    editable: !context.isCustomerUser && (!context.isWorkProviderPM && !context.isWorkProviderUser || context.isWorkProviderPM && context.isWorkProviderUser),
	    whitebox: true,
	    draggable: !context.isWorkProviderPM && !context.isWorkProviderUser || context.isWorkProviderPM && context.isWorkProviderUser,
	    title: 2224,
	    allowAdd: true,
	    allowDelete: true,
	    // groupField: 'IsExtra',
	    fields: [{
	      name: 'Name',
	      header: 1203,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'name'
	    }, {
	      name: 'Price',
	      header: 641,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Discount',
	      header: 15014,
	      type: 'percent',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Net',
	      header: 1305,
	      type: 'currency',
	      editable: true,
	      hide: false,
	      css: ''
	    }],
	    newItemInputs: ['Name', 'Price', 'Discount', 'Net']
	  };
	}
	
	function getAddonStartTimeConfig(context) {
	  return {
	    itemIdField: 'AddonStartTimeId',
	    itemOrderField: 'SortIndex',
	    itemOrderLocked: 'SortIndexLocked',
	    editable: !context.isCustomerUser && (!context.isWorkProviderPM && !context.isWorkProviderUser || context.isWorkProviderPM && context.isWorkProviderUser),
	    whitebox: false,
	    draggable: !context.isWorkProviderPM && !context.isWorkProviderUser || context.isWorkProviderPM && context.isWorkProviderUser,
	    title: null,
	    headerHelp: 1962,
	    groupCss: 'starttimes',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Name',
	      header: 1195,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'name',
	      col: 3
	    }, {
	      name: 'AE',
	      header: 885,
	      type: 'ae',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Mat',
	      header: context.department !== 0 ? 14788 : 13443,
	      type: 'currency',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Price',
	      header: 13350,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Discount',
	      header: 15014,
	      type: 'percent',
	      editable: true,
	      hide: false,
	      css: 'discount'
	    }, {
	      name: 'Net',
	      header: 1305,
	      type: 'currency',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Env',
	      header: 1044,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Total',
	      header: 393,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }],
	    newItemInputs: ['Name', 'AE', 'Mat']
	  };
	}
	
	function getAddonPartConfig(context) {
	  return {
	    itemIdField: 'AddonPartId',
	    itemOrderField: 'SortIndex',
	    itemOrderLocked: 'SortIndexLocked',
	    editable: !context.isCustomerUser && (!context.isWorkProviderPM && !context.isWorkProviderUser || context.isWorkProviderPM && context.isWorkProviderUser),
	    whitebox: false,
	    draggable: !context.isWorkProviderPM && !context.isWorkProviderUser || context.isWorkProviderPM && context.isWorkProviderUser,
	    title: null,
	    groupCss: 'addonparts',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Name',
	      header: 888,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'addonpart_name',
	      col: 2
	    }, {
	      name: 'AE',
	      header: 15015,
	      type: 'percent',
	      editable: true,
	      hide: false,
	      css: 'addon_workUnits'
	    }, {
	      name: 'Mat',
	      header: 15016,
	      type: 'percent',
	      editable: true,
	      hide: false,
	      css: 'mat'
	    }, {
	      name: 'StartTime',
	      header: 1195,
	      headerAppend: ' (%)',
	      type: 'percent',
	      editable: true,
	      hide: context.department !== 0,
	      css: 'starttime'
	    }],
	    newItemInputs: ['Name', 'AE', 'Mat', 'StartTime']
	  };
	}

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _priceModel = __webpack_require__(75);
	
	var _customerGroup = __webpack_require__(107);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _Insurance = __webpack_require__(286);
	
	var _Insurance2 = _interopRequireDefault(_Insurance);
	
	var _Delivery = __webpack_require__(229);
	
	var _Delivery2 = _interopRequireDefault(_Delivery);
	
	var _Details = __webpack_require__(285);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _QualityCheckSettingsChild = __webpack_require__(287);
	
	var _QualityCheckSettingsChild2 = _interopRequireDefault(_QualityCheckSettingsChild);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	// import './discounts.scss'
	
	// Utils
	
	
	// import { formatCurrency, reverseFormatCurrency } from '../../../utils/currency'
	
	
	// Elements
	
	
	var SelectCustomer = function (_Component) {
	  _inherits(SelectCustomer, _Component);
	
	  function SelectCustomer(props) {
	    _classCallCheck(this, SelectCustomer);
	
	    var _this = _possibleConstructorReturn(this, (SelectCustomer.__proto__ || Object.getPrototypeOf(SelectCustomer)).call(this, props));
	
	    _this.state = {
	      customersList: [],
	      selectedCustomerId: props.selectedCustomerId,
	      selectedShopId: props.selectedShopId,
	      selectedCustomerTab: -1,
	      activeItem: {},
	      priceModelId: props.agreementId,
	      agreementPrice: {}
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelectCustomer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomersList(this.props);
	      this.setState({
	        activeItem: this.props.item
	      });
	      this.state.isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      this.state.isShop = (0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(nextProps.selectedCustomerId, this.props.selectedCustomerId) || !(0, _lodash.isEqual)(nextProps.selectedShopId, this.props.selectedShopId)) {
	        console.log(this.props);
	        this.setState({
	          selectedCustomerId: nextProps.selectedCustomerId,
	          selectedShopId: nextProps.selectedShopId,
	          priceModelId: nextProps.agreementId
	        }, function () {
	          if (nextProps.item !== null && nextProps.item !== undefined) {
	            // this.props.getPriceList(nextProps)
	          }
	        });
	      }
	      if (!(0, _lodash.isEqual)(nextProps.item, this.props.item)) {
	        this.setState({
	          activeItem: nextProps.item,
	          priceModelId: nextProps.item !== null ? nextProps.item.PriceModelId : -1
	        });
	      }
	      // Get agreement again when clicking away from shops tab
	      if (!(0, _lodash.isEqual)(nextProps.selectedTabIndex, this.props.selectedTabIndex) && nextProps.selectedTabIndex !== 1) {
	        this.props.getPriceModel(nextProps, this.props.agreementId);
	      }
	    }
	  }, {
	    key: 'getCustomerAgreement',
	    value: function getCustomerAgreement(agreementId, customerId, companyId) {
	      var _this2 = this;
	
	      this.props.getShopCustomerAgreement(agreementId, customerId, companyId).then(function (res) {
	        _this2.setState({
	          agreementPrice: res.data
	        }, function () {});
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this2.props.onShouldUpdate();
	      });
	    }
	  }, {
	    key: 'getCustomersList',
	    value: function getCustomersList(props) {
	      var _this3 = this;
	
	      return props.getShopCustomers(props.item.CustomerGroupId).then(function (res) {
	        _this3.setState({
	          customersList: res.data
	        });
	        return res;
	      }, function () {
	        console.log('Err fetching price lists data');
	        return null;
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this4 = this;
	
	      e.persist();
	      var value = e.target.value;
	      // if (typeof value === 'string') {
	      //   value = parseInt(value.split('_')[0])
	      // }
	      var name = e.target.name;
	      if (name === 'selectedCustomerId') {
	        // let el = document.querySelector('select[name="selectedCustomerId"] option:checked')
	        // let shopId = parseInt(el.getAttribute('data-shopId'))
	
	        // value = <customerId>_<shopId>
	        var values = value.split('_');
	        this.props.selectCustomer(values[0], values[1]);
	
	        this.setState({
	          selectedCustomerTab: -1
	        }, function () {
	          _this4.getCustomerAgreement(_this4.state.priceModelId, _this4.props.selectedCustomerId, _this4.props.selectedShopId);
	        });
	      }
	      // if (name === 'btnMenuTab') {
	      //   this.setState({
	      //     selectedCustomerTab: Number(value)
	      //   }, () => {
	      //     if (this.state.selectedCustomerTab === 0) {
	      //       this.getCustomerAgreement(this.state.priceModelId, this.props.selectedCustomerId, this.props.selectedShopId)
	      //     }
	      //   })
	      // }
	    }
	  }, {
	    key: 'renderCustomerSelect',
	    value: function renderCustomerSelect() {
	      var _this5 = this;
	
	      // if (this.state.price.Name === null) return null
	      // let { price } = this.state
	      // let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
	      var customersList = this.state.customersList;
	      var grouping = [];
	
	      var _loop = function _loop(i) {
	        var group = grouping.find(function (val, idx) {
	          return val.shopName === customersList[i].ShopName;
	        });
	        if (group === undefined) {
	          group = {
	            shopName: customersList[i].ShopName,
	            shopId: customersList[i].ShopId,
	            customersList: []
	          };
	          grouping.push(group);
	        }
	        group.customersList.push(customersList[i]);
	        group.customersList.sort(function (a, b) {
	          return a.Name.localeCompare(b.Name);
	        }); // a.Name > b.Name)
	      };
	
	      for (var i = 0; i < customersList.length; i++) {
	        _loop(i);
	      }
	      grouping.sort(function (a, b) {
	        return a.shopName.localeCompare(b.shopName);
	      }); // a.shopName > b.shopName)
	      // let selectedCustomerId = parseInt(this.props.selectedCustomerId)
	      // let selectedShopId = parseInt(this.props.selectedShopId)
	
	      var renderGroup = function renderGroup(group, key) {
	        var renderItem = function renderItem(shopId, val, key) {
	          // console.log('shopId', shopId, 'customerId', val.CustomerId, 'props', this.props.selectedShopId, this.props.selectedCustomerId)
	          // let selected = parseInt(val.CustomerId) === selectedCustomerId && parseInt(shopId) === selectedShopId
	          // if (selected) {
	          //   console.log('SELECTED ', selectedShopId, selectedCustomerId)
	          // }
	          var value = val.CustomerId + '_' + shopId;
	          return _react2.default.createElement(
	            'option',
	            { value: value, key: val.CustomerId },
	            val.Name
	          );
	        };
	        var shopName = group.shopName;
	        var shopId = group.shopId;
	        // console.log('shopId ', shopId, 'group', group)
	        return _react2.default.createElement(
	          'optgroup',
	          { label: shopName, key: shopName },
	          group.customersList.map(function (val, key) {
	            return renderItem(shopId, val, key);
	          })
	        );
	      };
	      // let isCustomer = this.props.customer
	      var renderCustomersList = function renderCustomersList() {
	        // console.log('select value = ', this.state.selectedCustomerId + '_' + this.state.selectedShopId)
	        var value = _this5.state.selectedCustomerId + '_' + _this5.state.selectedShopId;
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: _this5.props.item.Name },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'selectedCustomerId', value: value, onChange: _this5.onInputChange, isGrouping: true },
	            _react2.default.createElement(
	              'option',
	              { value: '-1', key: '-1' },
	              (0, _helpers.translation)('890')
	            ),
	            grouping.map(renderGroup)
	          )
	        );
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('12281') },
	        renderCustomersList(),
	        this.renderCustomerMenuButtons()
	      );
	    }
	  }, {
	    key: 'renderCustomerMenuButtons',
	    value: function renderCustomerMenuButtons() {
	      var _this6 = this;
	
	      // if (this.props.route.customer) return null
	      if (!(0, _auth.hasAccess)([6], this.props.auth.user.UserType) || this.state.selectedCustomerId < 0) return null;
	      var isAddon = this.state.activeItem.PriceType === 8;
	      // const buttonClass = (val) => {
	      //   let btn = 'button'
	      //   if (val === this.state.selectedCustomerTab) return 'button active'
	      //   return btn
	      // }
	      // Aftale 13472
	      // Kvalitetstjek 13421
	      // Leveringstider 196
	      var onTabClick = function onTabClick(value) {
	        _this6.setState({
	          selectedCustomerTab: Number(value)
	        }, function () {
	          if (_this6.state.selectedCustomerTab === 0) {
	            _this6.getCustomerAgreement(_this6.state.priceModelId, _this6.props.selectedCustomerId, _this6.state.selectedShopId);
	          }
	        });
	      };
	
	      var priceModelButtons = function priceModelButtons() {
	        return _react2.default.createElement(
	          _tabBar2.default,
	          null,
	          _react2.default.createElement(_tabItem2.default, { name: 'btnMenuTab', onClick: function onClick() {
	              return onTabClick(0);
	            }, value: '0', active: _this6.state.selectedCustomerTab === 0, labelText: (0, _helpers.translation)('13472') }),
	          !isAddon && _react2.default.createElement(_tabItem2.default, { name: 'btnMenuTab', onClick: function onClick() {
	              return onTabClick(1);
	            }, value: '1', active: _this6.state.selectedCustomerTab === 1, labelText: (0, _helpers.translation)('13421') }),
	          !isAddon && _react2.default.createElement(_tabItem2.default, { name: 'btnMenuTab', onClick: function onClick() {
	              return onTabClick(2);
	            }, value: '2', active: _this6.state.selectedCustomerTab === 2, labelText: (0, _helpers.translation)('196') })
	        );
	      };
	      return priceModelButtons();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var view = null;
	      // let classname = ''
	      if (this.state.activeItem === null || this.props.item === null || this.state.PriceModelId <= 0) return null;
	      // let isAgeement = this.props.item.PriceModelId > 0 && this.state.selectedCustomerTab === 0
	      // let isQuality = this.state.selectedCustomerTab === 1
	      // let isDelivery = this.state.selectedCustomerTab === 2
	      var hasSelectedCustomer = this.state.selectedCustomerId > 0;
	      var pricetype = Number(this.props.item.PriceType);
	      switch (this.state.selectedCustomerTab) {
	        case 0:
	          if (pricetype !== 5 && pricetype !== 6 && pricetype !== 0 && !this.state.activeItem.UseEstimationList) {
	            view = _react2.default.createElement(_Details2.default, {
	              onShouldUpdate: this.props.onShouldUpdate,
	              selectedTabIndex: this.state.selectedCustomerTab,
	              item: this.state.activeItem,
	              selectedCustomerId: this.state.selectedCustomerId,
	              selectedShopId: this.state.selectedShopId,
	              customer: this.props.customer,
	              partners: this.props.partners,
	              agreementId: this.props.item.PriceModelId,
	              agreementPrice: this.state.agreementPrice,
	              getPriceLists: this.props.getPriceLists.bind(this) });
	          } else {
	            view = _react2.default.createElement(_Insurance2.default, { ref: 'view',
	              selectedTabIndex: this.state.selectedCustomerTab,
	              onShouldUpdate: this.props.onShouldUpdate,
	              isMain: false,
	              item: this.state.activeItem,
	              selectedCustomerId: this.state.selectedCustomerId,
	              selectedShopId: this.state.selectedShopId,
	              pricemodels: this.props.pricemodels,
	              agreementId: this.props.item.PriceModelId,
	              agreementPrice: this.state.agreementPrice,
	              getPriceLists: this.props.getPriceLists.bind(this) });
	          }
	          break;
	        case 1:
	          view = _react2.default.createElement(_QualityCheckSettingsChild2.default, { ref: 'view',
	            selectedTabIndex: this.state.selectedCustomerTab,
	            onShouldUpdate: this.props.onShouldUpdate,
	            isAgreement: true,
	            item: this.state.activeItem,
	            selectedCustomerId: this.state.selectedCustomerId,
	            selectedShopId: this.state.selectedShopId,
	            pricemodels: this.props.pricemodels,
	            agreementId: this.props.item.PriceModelId,
	            agreementPrice: this.state.agreementPrice,
	            getPriceLists: this.props.getPriceLists.bind(this) });
	          break;
	        case 2:
	          view = _react2.default.createElement(_Delivery2.default, { ref: 'view',
	            selectedTabIndex: this.state.selectedCustomerTab,
	            onShouldUpdate: this.props.onShouldUpdate,
	            isAgreement: true,
	            isShop: false,
	            selectedCustomerId: this.state.selectedCustomerId,
	            selectedShopId: this.state.selectedShopId,
	            pricemodels: this.props.pricemodels,
	            agreementId: this.state.activeItem.PriceModelId,
	            agreementPrice: this.state.agreementPrice,
	            getPriceLists: this.props.getPriceLists.bind(this) });
	          break;
	        default:
	          break;
	      }
	      if (!hasSelectedCustomer) view = null;
	      // let customerSelectClass = 'customer__select '
	      // if (!hasSelectedCustomer) customerSelectClass += 'none_selected'
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: hasSelectedCustomer ? 'select-customer' : '' },
	          _react2.default.createElement(
	            _row2.default,
	            null,
	            _react2.default.createElement(
	              _col2.default,
	              { span: 2 },
	              this.renderCustomerSelect()
	            )
	          )
	        ),
	        view
	      );
	    }
	  }]);
	
	  return SelectCustomer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    agreementPrice: state.agreementPrice,
	    selectedCustomerTab: state.selectedCustomerTab
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceList: _priceModel.getPriceList,
	  updatePriceList: _priceModel.updatePriceList,
	  getShopCustomers: _customerGroup.getShopCustomers,
	  getShopCustomerAgreement: _priceModel.getShopCustomerAgreement
	})(SelectCustomer);

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _backdrop = __webpack_require__(29);
	
	var _customers = __webpack_require__(74);
	
	var _shops = __webpack_require__(79);
	
	var _workProvider = __webpack_require__(195);
	
	var _agreement = __webpack_require__(401);
	
	var _priceModel = __webpack_require__(75);
	
	__webpack_require__(1440);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _Details = __webpack_require__(285);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _View = __webpack_require__(936);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _Insurance = __webpack_require__(286);
	
	var _Insurance2 = _interopRequireDefault(_Insurance);
	
	var _SelectCustomer = __webpack_require__(934);
	
	var _SelectCustomer2 = _interopRequireDefault(_SelectCustomer);
	
	var _QualityCheckSettingsChild = __webpack_require__(287);
	
	var _QualityCheckSettingsChild2 = _interopRequireDefault(_QualityCheckSettingsChild);
	
	var _Delivery = __webpack_require__(229);
	
	var _Delivery2 = _interopRequireDefault(_Delivery);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Agreements = function (_Component) {
	  _inherits(Agreements, _Component);
	
	  function Agreements(props) {
	    _classCallCheck(this, Agreements);
	
	    var _this = _possibleConstructorReturn(this, (Agreements.__proto__ || Object.getPrototypeOf(Agreements)).call(this, props));
	
	    _this.state = {
	      list: [],
	      search: '',
	      includeInactive: true,
	      includeConstraints: true,
	      activeItem: {},
	      constraints: [],
	      partnerName: '',
	      fetched: false,
	      customerName: null,
	      valid: [{
	        name: 'salescar',
	        access: [6]
	      }],
	      selectedTabIndex: 0,
	      agreementId: -1,
	      selectedCustomerId: -1,
	      selectedShopId: -1
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.onShouldUpdate = _this.onShouldUpdate.bind(_this);
	    _this.onClickCreate = _this.onClickCreate.bind(_this);
	    _this.onClickHeaderButton = _this.onClickHeaderButton.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.setActiveItem = _this.setActiveItem.bind(_this);
	    _this.selectCustomer = _this.selectCustomer.bind(_this);
	    _this.priceRoute = '/agreements';
	    return _this;
	  }
	
	  _createClass(Agreements, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPartner(this.props);
	      this.getPriceLists();
	      if (typeof this.props.params.constraintID !== 'undefined') {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            AgreementConstraintId: this.props.params.constraintID
	          }
	        });
	      }
	      if (this.props.route.customer) {
	        this.getCustomer(this.props);
	      }
	      if (!this.hasAccessToPage()) {
	        this.props.router.push(this.priceRoute);
	      } else {
	        /*
	        this.getPriceLists()
	        if (!isNaN(this.props.params.type)) {
	          this.setState({
	            agreementId: parseInt(this.props.params.type)
	          })
	        } */
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!isNaN(nextProps.params.type)) {
	        this.setState({
	          agreementId: parseInt(nextProps.params.type)
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      if (!this.hasAccessToPage()) {
	        this.props.router.push(this.priceRoute);
	      } else {
	        if (!this.state.fetched) {
	          setTimeout(function () {
	            if (_this2.state.list.length === 0) {
	              _this2.getPriceLists();
	            }
	          }, 1000);
	        }
	      }
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      // if (view === 'create') {
	      //   activeItem = {}
	      // }
	      activeItem = {};
	      this.setState({
	        view: view,
	        activeItem: activeItem,
	        constraints: this.state.constraints
	      });
	
	      this.props.router.replace(this.priceRoute + '/' + this.props.params.constraintID);
	    }
	  }, {
	    key: 'getPartner',
	    value: function getPartner(props) {
	      var _this3 = this;
	
	      if (typeof props.params.WorkProviderId !== 'undefined') {
	        props.getPartner(props.params.WorkProviderId).then(function (res) {
	          _this3.setState({
	            partnerName: res.data.Name
	          });
	        }, function (err) {
	          if (err.response.status === 401) {
	            _this3.props.router.replace('/orders');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'hasAccessToPage',
	    value: function hasAccessToPage() {
	      var _this4 = this;
	
	      var valid = true;
	      var found = false;
	      if (typeof this.props.params.type !== 'undefined') {
	        this.state.valid.map(function (val, key) {
	          if (val.name === _this4.props.params.type) {
	            found = true;
	            if (!(0, _auth.hasAccess)(val.access, _this4.props.auth.user.UserType)) {
	              valid = false;
	            }
	          }
	        });
	        if (!found) {
	          if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	            valid = true;
	          }
	        }
	      }
	      return valid;
	    }
	  }, {
	    key: 'selectCustomer',
	    value: function selectCustomer(customerId, shopId) {
	      if (typeof customerId === 'string') customerId = parseInt(customerId);
	      if (typeof shopId === 'string') shopId = parseInt(shopId);
	      // console.log('selected customer and shop', customerId, shopId)
	      this.setState({
	        selectedCustomerId: customerId,
	        selectedShopId: shopId
	      }, function () {
	        // console.log('selectCustomer after setstate', this.state.selectedCustomerId, this.state.selectedShopId)
	      });
	    }
	  }, {
	    key: 'getCustomer',
	    value: function getCustomer(props) {
	      var _this5 = this;
	
	      if (typeof props.params.customerID !== 'undefined') {
	        props.getCustomer(props.params.customerID).then(function (res) {
	          _this5.setState({
	            customerName: res.data.CompanyName
	          });
	        });
	      }
	    }
	  }, {
	    key: 'getPriceLists',
	    value: function getPriceLists() {
	      var _this6 = this;
	
	      this.props.getConstraints().then(function (res) {
	        _this6.setState({
	          constraints: res.data
	        }, function () {
	          if (_this6.state.activeItem !== null) {
	            _this6.setActiveItem(_this6.findPriceModelId(_this6.state.activeItem.AgreementConstraintId));
	          }
	        });
	      });
	      return this.props.getPriceLists().then(function (res) {
	        _this6.setState({
	          list: res.data,
	          fetched: true
	          // customerName: customerName
	        });
	        return res;
	      }, function () {
	        console.log('Err fetching price lists data');
	        return null;
	      });
	    }
	  }, {
	    key: 'setActiveItem',
	    value: function setActiveItem(val) {
	      this.setState({
	        view: 'item',
	        activeItem: val
	      });
	    }
	  }, {
	    key: 'onShouldUpdate',
	    value: function onShouldUpdate() {
	      var _this7 = this;
	
	      this.setState({
	        selectedTabIndex: 0
	      }, function () {
	        _this7.props.router.push(_this7.priceRoute + '/' + _this7.state.activeItem.AgreementConstraintId);
	        _this7.getPriceLists().then(function () {
	          // Toastr
	          // window.toastr.success(translation('13444'), translation('13424'))
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('2018'), (0, _helpers.translation)('216'));
	        });
	      });
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({
	          search: e.target.value
	        });
	      }
	      if (e.target.name === 'Inactive') {
	        this.setState({
	          includeInactive: e.target.checked
	        });
	      }
	      if (e.target.name === 'chkConstraint') {
	        this.setState({
	          includeConstraints: e.target.checked
	        });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      if (key.AgreementConstraintName.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.Active : true) && (!this.state.includeConstraints ? key.PriceModelId > -1 : true)) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'leftMenu',
	    value: function leftMenu() {
	      var _this8 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this8.refs.view.getWrappedInstance().addConstraint();
	        };
	
	        return _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          null,
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        );
	      }
	
	      var constraints = this.state.constraints;
	      var grouping = [];
	
	      var _loop = function _loop(i) {
	        var group = grouping.find(function (val, idx) {
	          return val.customerGroupName === constraints[i].CustomerGroupName;
	        });
	        if (group === undefined) {
	          group = {
	            customerGroupName: constraints[i].CustomerGroupName,
	            constraints: []
	          };
	          grouping.push(group);
	        }
	        group.constraints.push(constraints[i]);
	      };
	
	      for (var i = 0; i < constraints.length; i++) {
	        _loop(i);
	      }
	
	      var renderGroup = function renderGroup(group, key) {
	        var renderItem = function renderItem(val, key) {
	          // Classname
	          var isSelected = false;
	          if (_this8.state.activeItem) {
	            if ((0, _lodash.isEqual)(val, _this8.state.activeItem) || parseInt(val.AgreementConstraintId) === parseInt(_this8.state.activeItem.AgreementConstraintId)) {
	              isSelected = true;
	            }
	          }
	
	          // On select
	          var selectItem = function selectItem() {
	            _this8.setState({
	              view: 'item',
	              activeItem: val,
	              selectedTabIndex: 0,
	              constraints: _this8.state.constraints,
	              selectedCustomerId: -1
	            });
	            _this8.props.router.replace(_this8.priceRoute + '/' + val.AgreementConstraintId);
	          };
	
	          var name = val.AgreementConstraintName;
	          if (val.Brand !== undefined && val.Brand !== null) {
	            name += ' (' + val.Brand + ')';
	          }
	
	          return _react2.default.createElement(_sideMenuItem2.default, {
	            label: name,
	            onClick: selectItem,
	            selected: isSelected,
	            inactive: !val.Active || val.PriceModelId === -1,
	            key: key
	          });
	        };
	
	        var groupName = group.customerGroupName;
	        if (groupName === null) groupName = '(' + (0, _helpers.translation)('12268') + ')';
	        var filteredItems = group.constraints.filter(_this8.filterList);
	        if (filteredItems === undefined || filteredItems === null || filteredItems.length === 0) return undefined;
	
	        return _react2.default.createElement(
	          _sideMenuItem2.default,
	          {
	            label: groupName,
	            isTitle: true,
	            key: key
	          },
	          filteredItems.map(renderItem)
	        );
	      };
	
	      // Return
	      return [_react2.default.createElement(
	        'div',
	        { key: 'filter' },
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          null,
	          _react2.default.createElement(_text2.default, {
	            name: 'SearchText',
	            value: this.state.search,
	            onChange: this.searchList
	          })
	        ),
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          null,
	          _react2.default.createElement(_check2.default, {
	            name: 'Inactive',
	            checked: this.state.includeInactive === true,
	            onChange: this.searchList,
	            labelText: (0, _helpers.translation)('1859'),
	            spacing: 0
	          })
	        ),
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          null,
	          _react2.default.createElement(_check2.default, {
	            name: 'chkConstraint',
	            checked: this.state.includeConstraints === true,
	            onChange: this.searchList,
	            labelText: (0, _helpers.translation)('12269'),
	            spacing: 0
	          })
	        )
	      )].concat(_toConsumableArray(grouping.map(renderGroup)));
	    }
	  }, {
	    key: 'renderHeaderTitle',
	    value: function renderHeaderTitle() {
	      var customerName = this.state.customerName;
	      return customerName !== null ? (0, _helpers.translation)('12270') + ' - ' + customerName : (0, _helpers.translation)('12270');
	    }
	  }, {
	    key: 'findPriceModelId',
	    value: function findPriceModelId(constraintId) {
	      var item = null;
	      this.state.constraints.map(function (val, key) {
	        if (val.AgreementConstraintId === constraintId) {
	          item = val;
	        }
	      });
	      return item;
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      if (this.state.list.length === 0) return null;
	      var item = null;
	      var view = null;
	      var classname = 'agreements__screen--inner';
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          if (this.state.activeItem === null) return undefined;
	          item = this.state.activeItem.PriceModelId > 0 ? this.findPriceModelId(parseInt(this.props.params.type)) : this.state.activeItem;
	          var pricetype = Number(this.state.activeItem.PriceType);
	          switch (this.state.selectedTabIndex) {
	            case 0:
	              // Main agreement
	              if (this.state.activeItem.PriceModelId <= 0) {
	                view = _react2.default.createElement(_View2.default, { router: this.props.router, ref: 'view', item: this.state.activeItem, pricemodels: this.state.list, getPriceLists: this.getPriceLists.bind(this) });
	                classname = 'constraints__screen--inner';
	                break;
	              }
	              if (pricetype !== 5 && pricetype !== 6 && pricetype !== 0 && !this.state.activeItem.UseEstimationList) {
	                if (item !== null) {
	                  view = _react2.default.createElement(_Details2.default, {
	                    router: this.props.router,
	                    onShouldUpdate: this.onShouldUpdate,
	                    selectedTabIndex: this.state.selectedTabIndex,
	                    item: item,
	                    isMain: true,
	                    selectedCustomerId: -1,
	                    customer: this.props.route.customer,
	                    partners: this.props.route.partners,
	                    agreementId: this.state.activeItem.PriceModelId,
	                    getPriceLists: this.getPriceLists.bind(this) });
	                }
	              } else {
	                if (this.state.activeItem.PriceModelId > 0) item = this.findPriceModelId(parseInt(this.props.params.type));
	                view = _react2.default.createElement(_Insurance2.default, { ref: 'view',
	                  router: this.props.router,
	                  selectedTabIndex: this.state.selectedTabIndex,
	                  onShouldUpdate: this.onShouldUpdate,
	                  item: item,
	                  isMain: true,
	                  selectedCustomerId: -1,
	                  pricemodels: this.state.list,
	                  agreementId: this.state.activeItem.PriceModelId,
	                  getPriceLists: this.getPriceLists.bind(this) });
	              }
	              break;
	            case 1:
	              // SubAgreement
	              view = _react2.default.createElement(_SelectCustomer2.default, {
	                onShouldUpdate: this.onShouldUpdate,
	                selectedTabIndex: this.state.selectedTabIndex,
	                item: item,
	                setActiveItem: this.setActiveItem.bind(this),
	                customer: this.props.route.customer,
	                partners: this.props.route.partners,
	                agreementId: this.state.activeItem.PriceModelId,
	                getPriceLists: this.getPriceLists.bind(this),
	                selectCustomer: this.selectCustomer.bind(this),
	                selectedCustomerId: this.state.selectedCustomerId,
	                selectedShopId: this.state.selectedShopId });
	              break;
	            case 2:
	              // Quality Check
	              view = _react2.default.createElement(_QualityCheckSettingsChild2.default, { ref: 'view',
	                selectedTabIndex: this.state.selectedCustomerTab,
	                onShouldUpdate: this.props.onShouldUpdate,
	                isMainAgreement: true,
	                item: this.state.activeItem,
	                selectedCustomerId: 0,
	                pricemodels: this.props.pricemodels,
	                agreementId: this.state.activeItem.PriceModelId,
	                getPriceLists: this.props.getPriceLists.bind(this) });
	              break;
	            case 3:
	              // Delivery
	              view = _react2.default.createElement(_Delivery2.default, { ref: 'view',
	                selectedTabIndex: this.state.selectedCustomerTab,
	                onShouldUpdate: this.props.onShouldUpdate,
	                isMainAgreement: true,
	                isShop: false,
	                selectedCustomerId: 0,
	                pricemodels: this.props.pricemodels,
	                agreementId: this.state.activeItem.PriceModelId,
	                getPriceLists: this.props.getPriceLists.bind(this) });
	              break;
	            default:
	              view = _react2.default.createElement(_View2.default, { router: this.props.router, ref: 'view', item: this.state.activeItem, pricemodels: this.state.list, getPriceLists: this.getPriceLists.bind(this) });
	              classname = 'constraints__screen--inner';
	              break;
	          }
	
	          return _react2.default.createElement(
	            _Content2.default,
	            { className: classname },
	            view
	          );
	      }
	    }
	  }, {
	    key: 'onClickCreate',
	    value: function onClickCreate() {
	      this.props.router.push('/agreements/');
	    }
	  }, {
	    key: 'onClickHeaderButton',
	    value: function onClickHeaderButton(e) {
	      var _this9 = this;
	
	      var val = e.target.value;
	      var btn = e.target.name;
	      if (btn === 'btnTab') {
	        e.preventDefault();
	        this.setState({
	          selectedTabIndex: Number(val)
	        }, function () {
	          if (_this9.state.selectedTabIndex === 0) {}
	        });
	      }
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      var _this10 = this;
	
	      // if (this.props.route.customer) return null
	      if (!(0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return null;
	      var buttonClass = function buttonClass(val) {
	        var btn = '';
	        if (val === _this10.state.selectedTabIndex) return 'active';
	        return btn;
	      };
	      var priceModelButtons = function priceModelButtons() {
	        if (!_this10.state.activeItem) return false;
	        if (_this10.state.activeItem.PriceModelId <= 0) {
	          return undefined;
	        }
	        var isAddon = _this10.state.activeItem.PriceType === 8;
	        var onTabClick = function onTabClick(e) {
	          _this10.setState({
	            selectedTabIndex: e
	          });
	        };
	        return _react2.default.createElement(
	          _tabBar2.default,
	          null,
	          _react2.default.createElement(
	            _tabItem2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { name: 'btnTab', onClick: function onClick() {
	                  return onTabClick(0);
	                }, className: buttonClass(0) },
	              (0, _helpers.translation)('13472')
	            )
	          ),
	          _react2.default.createElement(
	            _tabItem2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { name: 'btnTab', onClick: function onClick() {
	                  return onTabClick(1);
	                }, className: buttonClass(1) },
	              (0, _helpers.translation)('1737')
	            )
	          ),
	          !isAddon && _react2.default.createElement(
	            _tabItem2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { name: 'btnTab', onClick: function onClick() {
	                  return onTabClick(2);
	                }, className: buttonClass(2) },
	              (0, _helpers.translation)('13421')
	            )
	          ),
	          !isAddon && _react2.default.createElement(
	            _tabItem2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { name: 'btnTab', onClick: function onClick() {
	                  return onTabClick(3);
	                }, className: buttonClass(3) },
	              (0, _helpers.translation)('196')
	            )
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        priceModelButtons()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      var headerButtonsGoBack = void 0;
	      headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	        var goBack = function goBack() {
	          _this11.props.router.replace({
	            pathname: '/customers',
	            query: {
	              customerId: _this11.props.params.customerID
	            }
	          });
	        };
	        if (!_this11.props.route.customer) return null;
	        return _react2.default.createElement(
	          'div',
	          { key: 'back_close' },
	          _react2.default.createElement('div', { className: 'alignHelper' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'hint--left', 'aria-label': t('2060') },
	            _react2.default.createElement('img', { src: '/images/icons/close_24.png', onClick: goBack, className: 'icon' })
	          )
	        );
	      };
	      var classname = 'constraints__screen';
	      if (this.state.activeItem !== null && this.state.activeItem.PriceModelId > 0) classname = 'prices__screen';
	      return _react2.default.createElement(
	        'div',
	        { className: classname },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: this.headerButtonsRight, showBack: this.props.route.customer, headerButtonsGoBack: headerButtonsGoBack }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { disableFilter: true },
	          this.leftMenu()
	        ),
	        this.renderView()
	      );
	    }
	  }]);
	
	  return Agreements;
	}(_react.Component);
	
	Agreements.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    selectedTabIndex: state.selectedTabIndex,
	    agreementId: state.agreementId,
	    pricemodels: state.pricemodels,
	    selectedCustomerId: state.selectedCustomerId
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  getCustomer: _customers.getCustomer,
	  getShops: _shops.getShops,
	  getConstraints: _agreement.getConstraints,
	  getPartner: _workProvider.getPartner,
	  getPriceLists: _priceModel.getPriceLists
	})(Agreements);

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _agreementConstraint = __webpack_require__(171);
	
	var _customerGroup = __webpack_require__(107);
	
	var _common = __webpack_require__(25);
	
	__webpack_require__(1441);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	
	
	// Elements
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      constraint: {
	        AgreementConstraintId: 0,
	        CustomerGroupId: 0,
	        CustomerGroupName: '',
	        WorkProvider: {},
	        Name: 'New',
	        Active: false,
	        Comment: '',
	        PriceType: 0,
	        ConstraintBrands: []
	      },
	      usePriceList: true,
	      pricemodels: [],
	      selectedpricemodel: -1,
	      createButtonActive: true
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.saveAddConstraint = _this.saveAddConstraint.bind(_this);
	    _this.addConstraint = _this.addConstraint.bind(_this);
	    _this.getCustomerGroups = _this.getCustomerGroups.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onCreateAgreement = _this.onCreateAgreement.bind(_this);
	    _this.createPriceAgreement = _this.createPriceAgreement.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAgreementConstraint(this.props);
	      this.getCustomerGroups();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (nextProps.brands === null || nextProps.brands.length === 0) {
	        this.props.getBrands();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.AgreementConstraintId !== nextProps.item.AgreementConstraintId) {
	        this.getAgreementConstraint(nextProps);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      e.persist();
	      var value = e.target.value;
	
	      if (e.target.type === 'radio') {
	        value = e.target.value === 'yes';
	      }
	      this.setState({
	        type: 'edit',
	        constraint: _extends({}, this.state.constraint, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'radio') {
	          _this2.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this3 = this;
	
	      if (this.state.constraint.AgreementConstraintId !== undefined) {
	        this.setState({ type: 'edit' }, function () {
	          _this3.saveAddConstraint();
	        });
	      }
	    }
	  }, {
	    key: 'getCustomerGroups',
	    value: function getCustomerGroups() {
	      this.props.getCustomerGroups();
	    }
	  }, {
	    key: 'getAgreementConstraint',
	    value: function getAgreementConstraint(props) {
	      var _this4 = this;
	
	      if (typeof props.item.AgreementConstraintId !== 'undefined') {
	        props.getAgreementConstraint(props.item.AgreementConstraintId).then(function (res) {
	          var constraint = res.data;
	          _this4.setState({
	            type: 'edit',
	            constraint: constraint
	          });
	        }, function () {
	          _this4.props.onError();
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        constraint: {
	          AgreementConstraintId: 0,
	          CustomerGroupId: 0,
	          CustomerGroupName: '',
	          WorkProvider: {},
	          Name: 'New',
	          Active: false,
	          Comment: '',
	          PriceType: 0,
	          ConstraintBrands: []
	        },
	        pricemodels: [],
	        selectedpricemodel: -1,
	        createButtonActive: true
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var value = e.target.value;
	      var name = e.target.name;
	      if (e === undefined) {
	        e = name;
	      }
	      if (name === 'PriceModelId') {
	        this.setState({
	          selectedpricemodel: Number(value)
	        });
	      } else {
	        this.setState({
	          constraint: _extends({}, this.state.constraint, _defineProperty({}, name, value))
	        });
	      }
	    }
	  }, {
	    key: 'createPriceAgreement',
	    value: function createPriceAgreement(data) {
	      this.props.createPriceAgreement(data);
	    }
	  }, {
	    key: 'onCreateAgreement',
	    value: function onCreateAgreement() {
	      var _this5 = this;
	
	      var type = this.props.item.PriceType;
	      if (parseInt(this.state.selectedpricemodel, 10) === -1 && type !== 5 && type !== 6 && type !== 0 && this.state.usePriceList) {
	        return false;
	      }
	      var data = {
	        ParentPriceModelId: this.state.selectedpricemodel,
	        CustomerGroupId: this.state.constraint.CustomerGroupId,
	        AgreementConstraintId: this.state.constraint.AgreementConstraintId,
	        UseEstimationList: !this.state.usePriceList
	      };
	      this.setState({
	        createButtonActive: false
	      }, function () {
	        _this5.props.createPriceAgreement(data).then(function (res) {
	          // window.toastr.success(translation('12271'), translation('13424'))
	          _this5.props.getPriceLists();
	          _this5.setState({
	            createButtonActive: true
	          });
	          _this5.props.router.push('/agreements/' + _this5.state.constraint.AgreementConstraintId);
	        }, function (err) {
	          console.log(err);
	          window.toastr.error((0, _helpers.translation)('12272'), (0, _helpers.translation)('216'));
	        });
	      });
	    }
	  }, {
	    key: 'renderConstraint',
	    value: function renderConstraint() {
	      var _this6 = this;
	
	      var constraint = this.state.constraint;
	
	      if (constraint === null) return null;
	      var renderOrderType = function renderOrderType() {
	        var pricetype = '12288';
	        switch (constraint.PriceType) {
	          case 1:
	            pricetype = '71';
	            break;
	          case 2:
	            pricetype = '785';
	            break;
	          case 3:
	            pricetype = '13361';
	            break;
	          case 5:
	            pricetype = '13360';
	            break;
	          case 8:
	            pricetype = '1396';
	            break;
	          case 6:
	            pricetype = '301';
	            break;
	          case 0:
	            pricetype = '73';
	            break;
	          default:
	            break;
	        }
	
	        return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('69'), value: (0, _helpers.translation)(pricetype), disabled: true });
	      };
	
	      var renderCustomerGroup = function renderCustomerGroup() {
	        var customergroupname = '';
	        if (_this6.props.item.CustomerGroupName !== null) {
	          customergroupname = _this6.props.item.CustomerGroupName;
	        }
	        return _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('12282'), value: customergroupname, disabled: true });
	      };
	
	      var renderPriceModel = function renderPriceModel() {
	        var priceModels = _this6.props.pricemodels;
	        var type = _this6.props.item.PriceType;
	        var active = _this6.state.createButtonActive;
	
	        var onChange = function onChange(_ref) {
	          var value = _ref.target.value;
	
	          _this6.setState({
	            usePriceList: value === 'yes'
	          });
	        };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: 15013 },
	            _react2.default.createElement(_radio2.default, { onChange: onChange, value: 'yes', checked: _this6.state.usePriceList, labelText: 47 }),
	            _react2.default.createElement(_radio2.default, { onChange: onChange, value: 'no', checked: !_this6.state.usePriceList, labelText: 48 })
	          ),
	          type !== 5 && type !== 6 && type !== 0 && _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'PriceModelId',
	              labelText: 1867,
	              onChange: _this6.onInputChange,
	              disabled: !_this6.state.usePriceList,
	              value: _this6.state.selectedpricemodel },
	            _react2.default.createElement(
	              'option',
	              { value: '-1', key: '-1' },
	              (0, _helpers.translation)('890')
	            ),
	            priceModels !== null && priceModels.length > 0 && priceModels.map(function (val, i) {
	              if (val.Active) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: val.PriceModelId, key: val.PriceModelId },
	                  val.Name
	                );
	              }
	            })
	          ),
	          _react2.default.createElement(_button2.default, { disabled: !active, onClick: _this6.onCreateAgreement, labelText: 12289 })
	        );
	      };
	
	      var renderbrands = function renderbrands() {
	        var renderBrand = function renderBrand(val, key) {
	          return _react2.default.createElement(
	            _label2.default,
	            { key: key },
	            val.BrandName
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          constraint.BrandSelectionType === 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('13473')
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('381')
	            )
	          ),
	          constraint.BrandSelectionType > 0 && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('13473') },
	            constraint.ConstraintBrands.map(renderBrand)
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('12284') },
	          _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('30'), value: constraint.Name || '', disabled: true }),
	          _react2.default.createElement(_textarea2.default, { labelText: (0, _helpers.translation)('149'), value: constraint.Comment || '', disabled: true }),
	          renderOrderType(),
	          renderCustomerGroup(),
	          renderbrands()
	        ),
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('1867') },
	          renderPriceModel()
	        )
	      );
	    }
	  }, {
	    key: 'addConstraint',
	    value: function addConstraint() {
	      var _this7 = this;
	
	      this.setState({ type: 'create' }, function () {
	        _this7.props.createSaveAgreementConstraint(_this7.state.constraint).then(function (res) {
	          _this7.props.onSave(res.data, _this7.state.type);
	          // window.toastr.success(translation('12290'), translation('13424'))
	        }, function (err) {
	          // Toastr
	          // console.log('err', err.response.data.Errors)
	          if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	            var errors = err.response.data.Errors;
	            var errText = '';
	            for (var i = 0; i < errors.length; i++) {
	              var dictKey = errors[i].DictionaryKey;
	              errText += '<br/>' + (0, _helpers.translation)(dictKey);
	            }
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('12272'), (0, _helpers.translation)('216'));
	          }
	          // Toastr
	          // window.toastr.error(translation('13463'), translation('216'))
	        });
	      });
	    }
	  }, {
	    key: 'saveAddConstraint',
	    value: function saveAddConstraint() {
	      var _this8 = this;
	
	      this.props.createSaveAgreementConstraint(this.state.constraint).then(function (res) {
	        _this8.props.onSave(res.data, _this8.state.type);
	        _this8.setState({
	          constraint: res.data
	        });
	      }, function (err) {
	        // Toastr
	        // console.log('err', err.response.data.Errors)
	        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	          var errors = err.response.data.Errors;
	          var errText = '';
	          for (var i = 0; i < errors.length; i++) {
	            var dictKey = errors[i].DictionaryKey;
	            errText += '<br/>' + (0, _helpers.translation)(dictKey);
	          }
	          window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('12285'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          this.renderConstraint()
	        )
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    brands: state.common.brands,
	    customergroups: state.common.customergroups
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createSaveAgreementConstraint: _agreementConstraint.createSaveAgreementConstraint,
	  getAgreementConstraint: _agreementConstraint.getAgreementConstraint,
	  getBrands: _common.getBrands,
	  getCustomerGroups: _customerGroup.getCustomerGroups,
	  createPriceAgreement: _agreementConstraint.createPriceAgreement
	}, null, { withRef: true })(View);

/***/ }),
/* 937 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// For use with later refactoring of PriceCalculation page.
	
	// import Extent from '../../shared/components/Extent'
	
	var parts = {
	  tag: 1,
	  fordor: 2,
	  bagdor: 3,
	  forskaerm: 4,
	  forkofanger: 5,
	  forklap: 6,
	  bagskaerm: 7,
	  bagkofanger: 8,
	  bagklap: 9,
	  panel: 10,
	  faelg: 11
	};
	
	var ExtentAdapter = function () {
	  function ExtentAdapter() {
	    _classCallCheck(this, ExtentAdapter);
	
	    this.extent = null;
	  }
	
	  /**
	   * Sets the Extent component used in the adapter.
	   * @param {Extent} extent
	   */
	
	
	  _createClass(ExtentAdapter, [{
	    key: 'setExtent',
	    value: function setExtent(extent) {
	      if (extent !== undefined) {
	        this.extent = extent;
	        // console.log('Extent set in adapter')
	      }
	    }
	
	    /**
	     *
	     * @param {String} type Event type
	     * @param {*} detail Event detail
	     */
	
	  }, {
	    key: 'onCarItem',
	    value: function onCarItem(type, detail) {
	      // console.log('onCarItem', type, detail)
	
	      if (detail.length !== undefined) {
	        for (var i = 0; i < detail.length; i++) {}
	      }
	    }
	
	    /**
	     * Get PartId from a string
	     * @param {String} val
	     */
	
	  }, {
	    key: 'getPartId',
	    value: function getPartId(val) {
	      var keys = Object.keys(parts);
	      for (var i = 0; i < keys.length; i++) {
	        if (val.includes(keys[i])) return parts[keys[i]];
	      }
	      return -1;
	    }
	
	    /**
	     * Get TaskId from a string
	     * @param {String} val
	     */
	
	  }, {
	    key: 'getTaskId',
	    value: function getTaskId(val) {
	      var parts = val.split('_');
	      var part = parts[parts.length - 1];
	      var id = parseInt(part);
	      if (isNaN(id)) return -1;
	      return id;
	    }
	
	    /**
	     * Get TaskSide from a string
	     * @param {String} val
	     */
	
	  }, {
	    key: 'getTaskSide',
	    value: function getTaskSide(val) {
	      var left = false;
	      var right = false;
	      var front = false;
	      var back = false;
	
	      var parts = val.split('-');
	      if (parts.includes('venstre')) left = true;
	      if (parts.includes('hojre')) right = true;
	      if (parts.includes('for')) front = true;
	      if (parts.includes('bag')) back = true;
	
	      if (front && left) return 5;
	      if (front && right) return 6;
	      if (back && left) return 7;
	      if (back && right) return 8;
	
	      if (front) return 3;
	      if (back) return 4;
	
	      if (left) return 1;
	      if (right) return 2;
	
	      return 0;
	    }
	  }]);
	
	  return ExtentAdapter;
	}();
	
	exports.default = ExtentAdapter;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ExtentAdapter = __webpack_require__(937);
	
	var _ExtentAdapter2 = _interopRequireDefault(_ExtentAdapter);
	
	var _price = __webpack_require__(115);
	
	var _priceModel = __webpack_require__(75);
	
	var _orderPrice = __webpack_require__(193);
	
	var _orders = __webpack_require__(21);
	
	var _bookingTime = __webpack_require__(278);
	
	var _backdrop = __webpack_require__(29);
	
	var _customers = __webpack_require__(74);
	
	__webpack_require__(1443);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Car = __webpack_require__(1021);
	
	var _Car2 = _interopRequireDefault(_Car);
	
	var _Extent = __webpack_require__(153);
	
	var _Extent2 = _interopRequireDefault(_Extent);
	
	var _Evaluation = __webpack_require__(291);
	
	var _Evaluation2 = _interopRequireDefault(_Evaluation);
	
	var _CarsizeModal = __webpack_require__(1082);
	
	var _CarsizeModal2 = _interopRequireDefault(_CarsizeModal);
	
	var _DeliveryDateChangeModal = __webpack_require__(302);
	
	var _DeliveryDateChangeModal2 = _interopRequireDefault(_DeliveryDateChangeModal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _auth = __webpack_require__(8);
	
	var _order = __webpack_require__(92);
	
	var _common = __webpack_require__(25);
	
	var _time = __webpack_require__(17);
	
	var _currency = __webpack_require__(41);
	
	var _router = __webpack_require__(308);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _constants = __webpack_require__(5);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _backButton = __webpack_require__(235);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import PropTypes from 'prop-types'
	
	// import {
	//   FILE_STORAGE
	// } from '../../constants'
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import Price from './Price'
	
	// import Gallery from '../../shared/components/Gallery'
	// import HelpText from '../../shared/components/HelpText'
	
	
	// import modals
	
	
	// Utils
	
	// import { renderFullDate } from '../../utils/time'
	
	
	// Elements
	
	
	// import Divider from '../../shared/elements/divider'
	
	var PriceCalculation = function (_Component) {
	  _inherits(PriceCalculation, _Component);
	
	  function PriceCalculation(props) {
	    _classCallCheck(this, PriceCalculation);
	
	    var _this = _possibleConstructorReturn(this, (PriceCalculation.__proto__ || Object.getPrototypeOf(PriceCalculation)).call(this, props));
	
	    _this.state = {
	      manualPriceChanged: false,
	      isUpdating: false,
	      price: {},
	      helperPopup: false,
	      view: 'euro',
	      carswitcher: false,
	      car: {
	        bodyParts: [],
	        parts: [],
	        extents: [],
	        services: [],
	        extra: [],
	        mapping: {},
	        complaints: [],
	        reasons: {},
	        otherDamages: [],
	        final: {
	          bodyParts: [],
	          parts: [],
	          extra: [],
	          services: [],
	          addon: [],
	          addonStartTimes: []
	        }
	      },
	      eventListener: undefined,
	      customer_price: {
	        gross_reduced: 'discount',
	        discount: 0,
	        netprice: 0
	      },
	      activeTaskId: 0,
	      manual: {
	        Price: 0,
	        Environment: 0,
	        OtherDescription: '',
	        OtherTitle: ''
	      },
	      contacts: [],
	      rejections: [],
	      showEmail: false,
	      draftDeliveryChangePopup: {
	        show: false,
	        originalDate: '',
	        oldDate: '',
	        newDate: '',
	        changedFromPopup: false
	      },
	      deliveryTime: '',
	      ShowExitConfirm: false,
	      ShowExitConfirmClose: false,
	      dimensions: {
	        width: 0,
	        height: 0
	      },
	      SelectedContact: '0',
	      SelectedContactMail: ''
	    };
	    _this.openEmail = _this.openEmail.bind(_this);
	    _this.getNewPriceCalc = _this.getNewPriceCalc.bind(_this);
	    _this.extentAdapterEventHandler = _this.extentAdapterEventHandler.bind(_this);
	    _this.bindCarEvent = _this.bindCarEvent.bind(_this);
	    _this.bindCarEventBooked = _this.bindCarEventBooked.bind(_this);
	    _this.bindCarEventNoItems = _this.bindCarEventNoItems.bind(_this);
	    _this.bindCarBodyEvent = _this.bindCarBodyEvent.bind(_this);
	    _this.setactiveitem = _this.setactiveitem.bind(_this);
	    _this.initData = _this.initData.bind(_this);
	    _this.clearEvents = _this.clearEvents.bind(_this);
	    _this.setManualPrice = _this.setManualPrice.bind(_this);
	    _this.renderDraftDeliveryDatePopup = _this.renderDraftDeliveryDatePopup.bind(_this);
	    _this.saveDelivery = _this.saveDelivery.bind(_this);
	    _this.goBack = _this.goBack.bind(_this);
	    _this.confirm = _this.confirm.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	
	    _this.extentAdapter = new _ExtentAdapter2.default();
	    _this._isMounted = false;
	    return _this;
	  }
	
	  _createClass(PriceCalculation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._isMounted = true;
	      var addon = this.props.params.addon;
	      var validParams = ['1', '2', '3', '4', '5', '6', '7', 'bodyextent', 'bodyaddon', 'manualbody'];
	      if (validParams.indexOf(addon) === -1) {
	        // this.props.router.replace('/orders/' + this.props.params.orderID)
	        this.props.router.goBack();
	      } else {
	        this.clearData();
	        this.initData();
	        this.setManualPrice(this.props);
	        this.getRejections();
	        window.addEventListener('resize', this.updateDimensions);
	        this.updateDimensions();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearEvents();
	      this.clearData();
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.params.orderID !== nextProps.params.orderID || this.props.params.addon !== nextProps.params.addon) {
	        this.clearData();
	        setTimeout(function () {
	          _this2.initData(nextProps);
	          _this2.getRejections();
	        }, 100);
	      }
	      if (this.props.price.Total !== nextProps.price.Total || this.props.price.Environment !== nextProps.price.Environment) {
	        this.setManualPrice(nextProps);
	      }
	
	      if (!(0, _lodash.isEqual)(this.props.carSelectedParts, nextProps.carSelectedParts)) {
	        if (nextProps.carSelectedParts.length > 0) {
	          this.bindCarBodyEvent(nextProps.carSelectedParts);
	        }
	      }
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this3 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this3.state.dimensions.width;
	          if (width > higherThan && width <= lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'getRejections',
	    value: function getRejections() {
	      var _this4 = this;
	
	      if (this.props.params.orderID !== undefined && this.props.params.orderID > 0) {
	        this.props.getRejectedEvaluations(this.props.params.orderID).then(function (res) {
	          var data = res.data;
	          _this4.setState({
	            rejections: data
	          }, function () {
	            // console.log('success', this.state)
	          });
	        }, function () {
	          console.log('failed');
	        });
	      }
	    }
	  }, {
	    key: 'clearData',
	    value: function clearData() {
	      this.setState({
	        price: {},
	        helperPopup: false,
	        view: 'euro',
	        carswitcher: false,
	        car: {
	          bodyParts: [],
	          parts: [],
	          extents: [],
	          services: [],
	          extra: [],
	          mapping: {},
	          complaints: [],
	          reasons: {},
	          otherDamages: [],
	          final: {
	            bodyParts: [],
	            parts: [],
	            extra: [],
	            services: [],
	            addon: [],
	            addonStartTimes: []
	          }
	        },
	        eventListener: undefined,
	        customer_price: {
	          gross_reduced: 'discount',
	          discount: 0,
	          netprice: 0
	        },
	        activeTaskId: 0,
	        manual: {
	          Price: 0,
	          Environment: 0,
	          OtherDescription: '',
	          OtherTitle: ''
	        },
	        contacts: [],
	        draftDeliveryChangePopup: {
	          show: false,
	          originalDate: '',
	          oldDate: '',
	          newDate: '',
	          changedFromPopup: false
	        },
	        deliveryTime: ''
	      });
	    }
	  }, {
	    key: 'getContacts',
	    value: function getContacts(data) {
	      var _this5 = this;
	
	      this.props.getCustomer(data.CustomerId).then(function (res) {
	        _this5.setState({
	          contacts: res.data.Contacts
	        });
	      });
	    }
	  }, {
	    key: 'setManualPrice',
	    value: function setManualPrice(props) {
	      if (Object.keys(props.price).length === 0 || this.props.order.OrderType === 4) return null;
	      this.setState({
	        manual: {
	          Price: (0, _currency.formatCurrency)(props.price.Total) === '0,00' || (0, _currency.formatCurrency)(props.price.Total) === '0.0' ? '' : (0, _currency.formatCurrency)(props.price.Total),
	          Environment: (0, _currency.formatCurrency)(props.price.Environment) === '0,00' || (0, _currency.formatCurrency)(props.price.Environment) === '0.0' ? '' : (0, _currency.formatCurrency)(props.price.Environment)
	        }
	      });
	    }
	  }, {
	    key: 'initData',
	    value: function initData(props) {
	      var _this6 = this;
	
	      props = typeof props === 'undefined' ? this.props : props;
	      if (props.auth.user.DepartmentType === 1 && this.props.order.IsPaintOrder === true && this.props.order.PaintIsDraft !== true && (this.props.params.addon === '1' || this.props.params.addon === '2')) {
	        window.toastr.error((0, _helpers.translation)('14930'), (0, _helpers.translation)('216'));
	        this.props.router.goBack();
	      }
	      this.clearEvents();
	      _events2.default.addListener('Price_Email_Click', this.openEmail);
	      var getPricesAndBind = function getPricesAndBind(res) {
	        // this.getPriceInformations(res.data.OrderType, res.data.BrandOriginal, res.data.CustomerId)
	        var brandName = null;
	        if (res.data.BrandName !== undefined && res.data.BrandName !== null) brandName = res.data.BrandName.Name;
	
	        _this6.getPriceInformations(res.data.OrderType, brandName, res.data.CustomerId);
	        // document.addEventListener('carhandler-select-body-ok', this.bindCarBodyEvent)
	        document.addEventListener('carhandler-ok', _this6.bindCarEvent);
	        // document.addEventListener('carhandler-ok', this.extentAdapterEventHandler)   // For further refactoring, for clearing up pricecalculation component.
	        document.addEventListener('carhandler-booked', _this6.bindCarEventBooked);
	        document.addEventListener('carhandler-noitems', _this6.bindCarEventNoItems);
	      };
	      var getPriceBind = true;
	      return this.props.getOrder(props.params.orderID).then(function (res) {
	        if (/\/pricecalculation\/\d{6,}/.test(_this6.props.router.location.pathname)) {
	          // Only change if still on '/pricecalculation/xxxxxx'
	          _this6.props.setPageTitle((0, _order.makeOrderPageTitleObject)(res.data));
	        }
	        if (res.data.Delivery !== null) {
	          _this6.setState({
	            deliveryTime: res.data.Delivery,
	            draftDeliveryChangePopup: _extends({}, _this6.state.draftDeliveryChangePopup, {
	              originalDate: res.data.Delivery,
	              oldDate: res.data.Delivery,
	              newDate: res.data.Delivery
	            })
	          });
	        }
	        if (res.data.OrderType === 4) {
	          _this6.setState({
	            manual: {
	              Price: (0, _currency.formatCurrency)(res.data.Price) === '0,00' || (0, _currency.formatCurrency)(res.data.Price) === '0.0' ? '' : (0, _currency.formatCurrency)(res.data.Price),
	              Environment: (0, _currency.formatCurrency)(res.data.Environment) === '0,00' || (0, _currency.formatCurrency)(res.data.Environment) === '0.0' ? '' : (0, _currency.formatCurrency)(res.data.Environment),
	              OtherDescription: res.data.OtherDescription === null ? '' : res.data.OtherDescription,
	              OtherTitle: res.data.OtherTitle === null ? '' : res.data.OtherTitle
	            }
	          });
	        }
	        _this6.getContacts(res.data);
	        if (props.params.addon === '4') {
	          _events2.default.addListener('pricecalc_activeitem', _this6.setactiveitem, _this6);
	          if (res.data.OrderType === 4) {
	            getPriceBind = false;
	            // this.props.router.replace('/orders/' + props.params.orderID)
	            _this6.props.router.goBack();
	          }
	        }
	        if (props.params.addon === '3') {
	          if (!res.data.IsEvaluation) {
	            // this.props.router.replace('/orders/' + props.params.orderID)
	            _this6.props.router.goBack();
	          } else {
	            // Check if it's already evaluated?
	            if (getPriceBind) {
	              getPricesAndBind(res);
	            }
	          }
	        } else {
	          if (getPriceBind) {
	            getPricesAndBind(res);
	          }
	        }
	        return res;
	      }, function (err) {
	        // this.context.router.replace('/orders/' + props.params.orderID)
	        _this6.props.router.goBack();
	        return err;
	      });
	    }
	  }, {
	    key: 'extentAdapterEventHandler',
	    value: function extentAdapterEventHandler(e) {
	      this.extentAdapter.onCarItem(e.type, e.detail);
	    }
	  }, {
	    key: 'clearEvents',
	    value: function clearEvents() {
	      // document.removeEventListener('carhandler-select-body-ok', this.bindCarBodyEvent)
	      document.removeEventListener('carhandler-ok', this.bindCarEvent);
	      // document.removeEventListener('carhandler-ok', this.extentAdapterEventHandler)
	      document.removeEventListener('carhandler-booked', this.bindCarEventBooked);
	      document.removeEventListener('carhandler-noitems', this.bindCarEventNoItems);
	      _events2.default.removeListener('pricecalc_activeitem', this.setactiveitem);
	      _events2.default.removeListener('Price_Email_Click', this.openEmail);
	    }
	  }, {
	    key: 'setactiveitem',
	    value: function setactiveitem(data) {
	      console.log('setting activeTaskId: ', data);
	      this.setState({
	        activeTaskId: data
	      });
	    }
	  }, {
	    key: 'mapPartsData',
	    value: function mapPartsData(part) {
	      var splitted = part.split('_');
	      return splitted;
	    }
	  }, {
	    key: 'bindCarEventBooked',
	    value: function bindCarEventBooked(e) {
	      if (e.detail.evaluation) {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('1782'), (0, _helpers.translation)('216'));
	      } else {
	        // Toastr
	        if (this.props.price.HasAwaiting) {
	          window.toastr.error((0, _helpers.translation)('1320'), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('13407'), (0, _helpers.translation)('216'));
	        }
	      }
	    }
	  }, {
	    key: 'bindCarEventNoItems',
	    value: function bindCarEventNoItems(e) {
	      // Toastr
	      window.toastr.error((0, _helpers.translation)('13426'), (0, _helpers.translation)('216'));
	    }
	  }, {
	    key: 'bindCarBodyEvent',
	    value: function bindCarBodyEvent(e) {
	      var _this7 = this;
	
	      var parts = e; // e.detail
	      if (e.length === 0) return null;
	      // let parts = this.props.carSelectedParts
	      // this.props.setCarSelectedParts([])
	      // const findItem = (items, val) => {
	      //   for (var key in items) {
	      //     let item = items[key]
	      //     if (item.IsSelected && (item.name === val.name || item.OrderTaskId === val.OrderTaskId)) return item
	      //   }
	      //   return null
	      // }
	      var finalData = [];
	      if (this.props.order.OrderType === 1 && this.props.params.addon === '1' || ['3', '4'].includes(this.props.params.addon) || this.props.price.UseEstimation && this.props.params.addon !== '7') {
	        // (this.props.params.addon === '3') || (this.props.params.addon === '4') || (this.props.price.UseEstimation)) {
	        // Insurnace order
	        parts.map(function (val, index) {
	          var map = _this7.mapPartsData(val.name);
	          if (typeof finalData[map[0]] !== 'undefined') {
	            finalData[map[0]].push(val);
	          } else {
	            finalData[map[0]] = [val];
	          }
	        });
	      } else if (this.props.params.addon === '6' || this.props.params.addon === '5' || this.props.params.addon === '7') {
	        // parts = parts[0]
	        parts.map(function (val, index) {
	          var map = _this7.mapPartsData(val.id);
	          if (typeof finalData[map[0]] !== 'undefined') {
	            finalData[map[0]].push(val);
	          } else {
	            finalData[map[0]] = [val];
	          }
	        });
	      } else {
	        // parts = parts[0]
	        parts.map(function (val, index) {
	          var map = _this7.mapPartsData(val.name);
	          if (typeof finalData[map[0]] !== 'undefined') {
	            finalData[map[0]].push(val);
	            // let foundItem = findItem(finalData[map[0]], val)
	            // if (foundItem === null) {
	            //   if (val.IsSelected === true) {
	            //   }
	            // } else {
	            //   foundItem.IsDeleted = val.IsDeleted
	            //   foundItem.Price = val.Price
	            //   foundItem.AE = val.AE
	            // }
	            // if (map[1] === '900000000000000000000' || Number(map[1]) >= '9000000000000000') {
	            //   finalData[map[0]].push(val)
	            // } else {
	            //   finalData[map[0]].push(map[1])
	            // }
	          } else {
	            finalData[map[0]] = [val];
	            // if (map[1] === '900000000000000000000' || Number(map[1]) >= '9000000000000000') {
	            //   finalData[map[0]] = [val]
	            // } else {
	            //   finalData[map[0]] = [map[1]]
	            // }
	          }
	        });
	      }
	      this.setState({
	        car: _extends({}, this.state.car, {
	          final: _extends({}, this.state.car.final, {
	            parts: finalData // JSON.parse(JSON.stringify(finalData))
	          })
	        })
	      }, function () {
	        // console.log('finalData:', this.state.car.final.parts)
	      });
	      setTimeout(function () {
	        _this7.getNewPriceCalc('del');
	        _this7.props.setCarSelectedParts([]);
	      }, 50);
	    }
	  }, {
	    key: 'bindCarEvent',
	    value: function bindCarEvent(e) {
	      var _this8 = this;
	
	      var parts = e.detail;
	      var finalData = [];
	      if (this.props.order.OrderType === 1 && this.props.params.addon === '1' || this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.price.UseEstimation) {
	        // Insurnace order
	        parts.map(function (val, index) {
	          var map = _this8.mapPartsData(val.name);
	          if (typeof finalData[map[0]] !== 'undefined') {
	            finalData[map[0]].push(val);
	          } else {
	            finalData[map[0]] = [val];
	          }
	        });
	      } else {
	        parts.map(function (val, index) {
	          var map = _this8.mapPartsData(val.name);
	          if (typeof finalData[map[0]] !== 'undefined') {
	            if (map[1] === '900000000000000000000' || Number(map[1]) >= '9000000000000000') {
	              finalData[map[0]].push(val);
	            } else {
	              finalData[map[0]].push(map[1]);
	            }
	          } else {
	            if (map[1] === '900000000000000000000' || Number(map[1]) >= '9000000000000000') {
	              finalData[map[0]] = [val];
	            } else {
	              finalData[map[0]] = [map[1]];
	            }
	          }
	        });
	      }
	      this.setState({
	        car: _extends({}, this.state.car, {
	          final: _extends({}, this.state.car.final, {
	            parts: finalData
	          })
	        })
	      });
	      setTimeout(function () {
	        _this8.getNewPriceCalc('del');
	      }, 50);
	    }
	  }, {
	    key: 'addExtraService',
	    value: function addExtraService(item, type) {
	      var _this9 = this;
	
	      if (this.props.auth.user.CustomerId !== '-1' && !this.props.order.IsDraft) {
	        // if (!this.props.order.IsDraft) {
	        this.bindCarEventBooked();
	      } else {
	        var name = type === 'extra' ? 'extra' : 'services';
	        if (type === 'addon') name = 'addon';
	        if (type === 'addonStartTimes') name = 'addonStartTimes';
	        var finalData = this.state.car.final[name];
	        finalData.push(item);
	        this.setState({
	          car: _extends({}, this.state.car, {
	            final: _extends({}, this.state.car.final, _defineProperty({}, name, finalData))
	          })
	        });
	        setTimeout(function () {
	          _this9.getNewPriceCalc('nodel');
	        }, 50);
	      }
	    }
	  }, {
	    key: 'findPartArrayFromId',
	    value: function findPartArrayFromId(parts, id, taskSide, sideType) {
	      for (var i = 0; i < parts.length; i++) {
	        var part = parts[i].Part;
	        if (taskSide !== 0) {
	          if (part.PartItemId === id && part.TaskSide === taskSide) {
	            return i;
	          }
	        } else {
	          if (part.PartItemId === id) {
	            return i;
	          }
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getTaskSide',
	    value: function getTaskSide(key) {
	      if (key.indexOf('tag') !== -1) {
	        return 0;
	      }
	
	      if (key.endsWith('-for')) {
	        if (key.indexOf('venstre-') !== -1) return 5;
	        if (key.indexOf('hojre-') !== -1) return 6;
	      } else if (key.endsWith('-bag')) {
	        if (key.indexOf('venstre-') !== -1) return 7;
	        if (key.indexOf('hojre-') !== -1) return 8;
	      }
	
	      if (key.indexOf('venstre-') !== -1) {
	        return 1;
	      } else if (key.indexOf('hojre-') !== -1) {
	        return 2;
	      } else if (key.indexOf('for-') !== -1) {
	        return 3;
	      } else if (key.indexOf('bag-') !== -1) {
	        return 4;
	      }
	      return 0;
	    }
	  }, {
	    key: 'findEstimationTask',
	    value: function findEstimationTask(tasks, id) {
	      for (var i = 0; i < tasks.length; i++) {
	        if (tasks[i].EstimationTaskId.toString() === id.toString()) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getNewPriceCalc',
	    value: function getNewPriceCalc(del, servicesData, extra, addonParts, addonTimes, partID, item) {
	      var _this10 = this;
	
	      var tmpState = Object.assign({}, this.state);
	
	      // Data
	      var postData = Object.assign({}, this.props.price);
	      var deviationExists = function deviationExists(val, deviationReasons) {
	        var foundItem = false;
	        if (typeof deviationReasons === 'undefined') return false;
	        // deviationReasons.map((item) => { // Set all reasons to deleted first
	        //   if (!item.CustomDeviationReasonId) item.IsDeleted = true
	        //   // if (!item.CustomReason) {
	        //   //   item.IsDeleted = true
	        //   // }
	        //   return item
	        // })
	        deviationReasons.map(function (item1) {
	          if (!foundItem) {
	            if (val.IsCustomDeviation) {
	              if (val.IsNew) {
	                foundItem = false;
	              } else if (val.CustomDeviationReasonId === item1.CustomDeviationReasonId) {
	                item1.IsDeleted = !val.IsSelected;
	                foundItem = item1;
	              } else {
	                // console.log('deviationReasonsMap equals not', val, item)
	              }
	            } else if (!val.IsCustomDeviation && '' + item1.DeviationType.Id === '' + val.EnumValue) {
	              item1.IsDeleted = false;
	              foundItem = item1;
	            }
	          }
	          return item;
	        });
	        return foundItem;
	      };
	      // Make parts
	      if (typeof partID !== 'undefined') {
	        var isUsingOrderEstimationTaskId = false;
	        // Check if its a OrderEstimationTaskId
	        if (typeof partID === 'string') {
	          if (partID.indexOf('OrderEstimationTaskId') !== -1) {
	            partID = parseInt(partID.split('_')[1]);
	            isUsingOrderEstimationTaskId = true;
	          }
	        }
	        // Set part IsDeleted to true
	        postData.Parts.map(function (val, index) {
	          if (_this10.props.params.addon === '5' || _this10.props.params.addon === '6') {
	            // DEVIATIONS
	            val.DeviationReasons.filter(function (v, i) {
	              if (item.TaskSide !== 0) {
	                if (v.DeviationReasonId === partID && v.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              } else {
	                if (v.DeviationReasonId === partID && val.Part.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              }
	              return v;
	            });
	            // Custom deviation reasons
	            val.CustomDeviationReasons.filter(function (v, i) {
	              if (item.TaskSide !== 0) {
	                if (v.CustomDeviationReasonId === partID && v.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              } else {
	                if (v.CustomDeviationReasonId === partID && val.Part.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              }
	              return v;
	            });
	          } else if (_this10.props.params.addon === '7') {
	            val.OtherDamages.filter(function (v) {
	              if (item.TaskSide !== 0) {
	                if (v.Id === partID && v.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              } else {
	                if (v.Id === partID && val.Part.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              }
	              return v;
	            });
	          } else if (_this10.props.order.OrderType === 1 && _this10.props.params.addon === '1' || _this10.props.params.addon === '3' || _this10.props.params.addon === '4' || _this10.props.price.UseEstimation) {
	            val.EstimationTasks.filter(function (v, i) {
	              var checkID = isUsingOrderEstimationTaskId ? v.OrderEstimationTaskId : v.EstimationTaskId;
	              if (item.TaskSide !== 0) {
	                if (checkID === partID && v.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              } else {
	                if (checkID === partID && val.Part.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              }
	              return v;
	            });
	          } else if (_this10.props.order.OrderType === 5 && _this10.props.params.addon !== '2' && _this10.props.params.addon !== 'bodyaddon') {
	            // COMPLAINTS
	            val.Complaints.filter(function (v, i) {
	              if (item.TaskSide !== 0) {
	                if (v.ComplaintType === partID && v.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              } else {
	                if (v.ComplaintType === partID && val.Part.TaskSide === item.TaskSide) {
	                  v.IsDeleted = true;
	                }
	              }
	              return v;
	            });
	          } else {
	            val.Tasks.filter(function (v, i) {
	              // if (item.TaskSide !== 0) {
	              //   if (v.OrderTaskId === partID && v.TaskSide === item.TaskSide) {
	              //     v.IsDeleted = true
	              //   }
	              // } else {
	              //   if (v.OrderTaskId === partID && val.Part.TaskSide === item.TaskSide) {
	              //     v.IsDeleted = true
	              //   }
	              // }
	              return v;
	            });
	          }
	        });
	        window.carHandler.fillParts(true, postData.Parts);
	      } else {
	        // Set part IsDeleted to true
	        if (del !== 'nodel') {
	          postData.Parts.map(function (val, index) {
	            if (_this10.props.params.addon === '5' || _this10.props.params.addon === '6') {
	              // val.DeviationReasons.map((v, i) => {
	              //   v.IsDeleted = true
	              //   return v
	              // })
	              // val.CustomDeviationReasons.map((v, i) => {
	              //   v.IsDeleted = true
	              //   return v
	              // })
	            } else if (_this10.props.order.OrderType === 1 && _this10.props.params.addon === '1' || _this10.props.params.addon === '3' || _this10.props.params.addon === '4' || _this10.props.price.UseEstimation) {
	              /*
	              val.EstimationTasks.map((v, i) => {
	                v.IsDeleted = true
	                return v
	              })
	              */
	            } else if (_this10.props.order.OrderType === 5 && _this10.props.params.addon !== '2' && _this10.props.params.addon !== 'bodyaddon' && _this10.props.params.addon !== 'manualbody') {
	              val.Complaints.map(function (v, i) {
	                var parts = tmpState.car.final.parts;
	                for (var key in parts) {
	                  // Delete parts that are not selected
	                  var part = parts[key];
	                  var _partID = _this10.state.car.mapping[key];
	                  var taskSide = _this10.getTaskSide(key);
	                  var partDataID = _this10.findPartArrayFromId(postData.Parts, _partID, taskSide);
	                  if (partDataID !== false) {
	                    var checkPart = postData.Parts[partDataID].Part;
	                    if (checkPart.PartItemId === val.Part.PartItemId) {
	                      (function () {
	                        var foundPart = false;
	                        part.map(function (p) {
	                          if (!foundPart && p.ComplaintType === v.ComplaintType) foundPart = true;
	                        });
	                        if (!foundPart) v.IsDeleted = true;
	                      })();
	                    }
	                  }
	                }
	                return v;
	              });
	            } else if (_this10.props.params.addon !== 'bodyextent' && _this10.props.params.addon !== 'bodyaddon') {
	              // val.Tasks.filter((v, i) => {
	              //   if (v.PartItemId !== 0) {
	              //     v.IsDeleted = true
	              //   }
	              //   return v
	              // })
	            }
	          });
	        }
	        if (this.props.params.addon === '5' || this.props.params.addon === '6') {
	          // DEVIATION REASONS
	          var parts = tmpState.car.final.parts;
	
	          var _loop = function _loop(key) {
	            var partID = _this10.state.car.mapping[key];
	            var partDataID = _this10.findPartArrayFromId(postData.Parts, partID, _this10.getTaskSide(key));
	            // console.log('added parts', 'key', key, 'partID', partID, 'partDataID', partDataID, 'parts[key]', parts[key])
	            if (partDataID === false) {
	              var partData = {};
	              partData.Part = {
	                PartItemId: partID,
	                TaskSide: _this10.getTaskSide(key)
	              };
	              partData.DeviationReasons = [];
	              parts[key].map(function (val, index) {
	                var deviationID = 0;
	                if (postData.Deviations.length === 0) {
	                  deviationID = 0;
	                } else {
	                  deviationID = postData.Deviations[postData.Deviations.length - 1].DeviationId;
	                }
	                if (typeof partData.DeviationReasons === 'undefined') partData.DeviationReasons = [];
	                if (typeof partData.CustomDeviationReasons === 'undefined') partData.CustomDeviationReasons = [];
	                var reasons = partData.DeviationReasons;
	                if (val.IsCustomDeviation) reasons = partData.CustomDeviationReasons;
	                var foundItem = deviationExists(val, reasons);
	                if (!foundItem) {
	                  var reason = {
	                    DeviationId: deviationID,
	                    TaskSide: _this10.getTaskSide(key)
	                  };
	                  if (!val.IsCustomDeviation) {
	                    reason.DeviationType = {
	                      Id: val.EnumValue
	                    };
	                  } else {
	                    reason.CustomDeviationReasonId = val.CustomDeviationReasonId;
	                    if (typeof reason.CustomDeviationReasonId === 'undefined') reason.CustomDeviationReasonId = 0;
	                    reason.CustomReason = val.CustomReason;
	                    reason.IsSelected = val.IsSelected;
	                    reason.IsDeleted = !val.IsSelected;
	                  }
	                  reasons.push(reason);
	                }
	              });
	              postData.Parts.push(partData);
	            } else {
	              postData.Parts[partDataID].DeviationReasons.map(function (v, i) {
	                v.IsDeleted = true;
	                return v;
	              });
	              postData.Parts[partDataID].CustomDeviationReasons.map(function (v, i) {
	                v.IsDeleted = true;
	                return v;
	              });
	              parts[key].map(function (val, index) {
	                var reasons = postData.Parts[partDataID].DeviationReasons;
	                if (val.IsCustomDeviation) reasons = postData.Parts[partDataID].CustomDeviationReasons;
	                var foundItem = deviationExists(val, reasons);
	                if (!foundItem) {
	                  var reason = {
	                    TaskSide: _this10.getTaskSide(key)
	                  };
	                  if (!val.IsCustomDeviation) {
	                    reason.DeviationType = {
	                      Id: val.EnumValue
	                    };
	                  } else {
	                    reason.CustomDeviationReasonId = val.CustomDeviationReasonId;
	                    if (typeof reason.CustomDeviationReasonId === 'undefined') reason.CustomDeviationReasonId = 0;
	                    reason.CustomReason = val.CustomReason;
	                    reason.IsSelected = val.IsSelected;
	                    reason.IsDeleted = !val.IsSelected;
	                  }
	                  reasons.push(reason);
	                } else {
	                  // console.log('found item, ', 'val', val, 'item', foundItem)
	                }
	                if (val.IsCustomDeviation) {
	                  postData.Parts[partDataID].CustomDeviationReasons = reasons;
	                } else {
	                  postData.Parts[partDataID].DeviationReasons = reasons;
	                }
	              });
	            }
	          };
	
	          for (var key in parts) {
	            _loop(key);
	          }
	        } else if (this.props.params.addon === '7') {
	          (function () {
	            // OTHER DAMAGE
	            var otherDamageExists = function otherDamageExists(part, otherDamages) {
	              var foundItem = false;
	
	              var _iteratorNormalCompletion = true;
	              var _didIteratorError = false;
	              var _iteratorError = undefined;
	
	              try {
	                for (var _iterator = otherDamages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                  var od = _step.value;
	
	                  if (od.Type === part.EnumValue) {
	                    // Type match
	                    if (part.EnumValue === 10) {
	                      // Is custom
	                      if (od.CustomName === part.name) {
	                        // Is same custom
	                        foundItem = true;
	                      }
	                    } else {
	                      foundItem = true;
	                    }
	                  }
	                }
	              } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                  }
	                } finally {
	                  if (_didIteratorError) {
	                    throw _iteratorError;
	                  }
	                }
	              }
	
	              return foundItem;
	            };
	
	            var parts = tmpState.car.final.parts;
	
	            var _loop2 = function _loop2(key) {
	              var partID = _this10.state.car.mapping[key];
	              var partDataID = _this10.findPartArrayFromId(postData.Parts, partID, _this10.getTaskSide(key));
	
	              if (partDataID === false) {
	                var partData = {
	                  Part: {
	                    PartItemId: partID,
	                    TaskSide: _this10.getTaskSide(key)
	                  },
	                  OtherDamages: []
	                };
	
	                parts[key].forEach(function (part) {
	                  var otherDamageID = 0;
	                  if (postData.OtherDamages.length !== 0) {
	                    otherDamageID = postData.OtherDamages.find(function (od) {
	                      return !od.Active;
	                    }).Id;
	                  }
	
	                  var foundItem = otherDamageExists(part, partData.OtherDamages);
	                  if (!foundItem) {
	                    var otherDamage = {
	                      OtherDamageId: otherDamageID,
	                      TaskSide: _this10.getTaskSide(key),
	                      Type: part.EnumValue,
	                      CustomName: part.EnumValue === 10 ? part.CustomName : null,
	                      IsDeleted: !part.IsSelected
	                    };
	                    partData.OtherDamages = [].concat(_toConsumableArray(partData.OtherDamages), [otherDamage]);
	                  }
	                });
	                postData.Parts = [].concat(_toConsumableArray(postData.Parts), [partData]);
	              } else {
	                var otherDamages = postData.Parts[partDataID].OtherDamages;
	                otherDamages.forEach(function (od) {
	                  od.IsDeleted = true;
	                });
	
	                parts[key].forEach(function (part) {
	                  // const foundItem = otherDamageExists(part, otherDamages)
	
	                  // if (!foundItem) {
	                  var otherDamage = {
	                    TaskSide: _this10.getTaskSide(key),
	                    Type: part.EnumValue,
	                    CustomName: part.EnumValue === 10 ? part.CustomName : null,
	                    IsDeleted: !part.IsSelected
	                  };
	                  otherDamages = [].concat(_toConsumableArray(otherDamages), [otherDamage]);
	                  // }
	                });
	                postData.Parts[partDataID].OtherDamages = otherDamages;
	              }
	            };
	
	            for (var key in parts) {
	              _loop2(key);
	            }
	          })();
	        } else if (this.props.order.OrderType === 1 && this.props.params.addon === '1' || this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.price.UseEstimation) {
	          // Order is INSURANCE, add special
	          var _parts = tmpState.car.final.parts;
	
	          var _loop3 = function _loop3(key) {
	            var partID = _this10.state.car.mapping[key];
	            var partDataID = _this10.findPartArrayFromId(postData.Parts, partID, _this10.getTaskSide(key));
	            if (partDataID === false) {
	              var partData = {};
	              partData.Part = {
	                PartItemId: partID,
	                TaskSide: _this10.getTaskSide(key)
	              };
	              partData.Tasks = [];
	              partData.EstimationTasks = [];
	
	              _parts[key].map(function (val, index) {
	                var splitted = val.name.split('_');
	                var id = splitted[1];
	                var extras = [];
	                if (typeof val.value !== 'undefined') {
	                  var isThere = _this10.findEstimationTask(partData.EstimationTasks, id);
	                  if (!isThere) {
	                    val.value.extra.map(function (v, k) {
	                      extras.push({
	                        EstimationExtraId: v.id.split('_')[2],
	                        AE: v.ae,
	                        Material: v.mat,
	                        Name: v.name
	                      });
	                    });
	                    partData.EstimationTasks.push({
	                      EstimationTaskId: id,
	                      TaskName: val.taskname,
	                      Extent: {
	                        PriceModelExtentId: typeof val.value.extent !== 'undefined' ? val.value.extent.split('_')[2] : 0,
	                        Type: val.value.type
	                      },
	                      Extras: extras,
	                      TaskSide: _this10.getTaskSide(key),
	                      PaintLineId: _this10.state.activeTaskId
	                    });
	                  } else {}
	                }
	              });
	
	              postData.Parts.push(partData);
	            } else {
	              _parts[key].map(function (val, index) {
	                var splitted = val.name.split('_');
	                var id = splitted[1];
	                var extras = [];
	                if (typeof val.value !== 'undefined') {
	                  var isThere = _this10.findEstimationTask(postData.Parts[partDataID].EstimationTasks, id);
	                  if (!isThere || id === '0') {
	                    val.value.extra.map(function (v, k) {
	                      extras.push({
	                        EstimationExtraId: v.id.split('_')[2],
	                        AE: v.ae,
	                        Material: v.mat,
	                        Name: v.name
	                      });
	                    });
	                    postData.Parts[partDataID].EstimationTasks.push({
	                      TaskName: val.taskname,
	                      PartName: key,
	                      EstimationTaskId: id,
	                      Extent: {
	                        PriceModelExtentId: typeof val.value.extent !== 'undefined' ? val.value.extent.split('_')[2] : 0,
	                        Type: val.value.type
	                      },
	                      Extras: extras,
	                      TaskSide: _this10.getTaskSide(key),
	                      PaintLine: _this10.state.activeTaskId,
	                      OrderEstimationTaskId: 0
	                    });
	                  } else {
	                    // Find estimationTaskIdx
	                    var estimationTask = null;
	                    var estimationTaskIdx = null;
	                    for (var i = 0; i < postData.Parts[partDataID].EstimationTasks.length; i++) {
	                      if (postData.Parts[partDataID].EstimationTasks[i].EstimationTaskId === parseInt(id)) {
	                        estimationTask = postData.Parts[partDataID].EstimationTasks[i];
	                        estimationTaskIdx = i;
	                        break;
	                      }
	                    }
	                    // Extent
	                    if (estimationTask !== null) {
	                      if (val.value.extent !== undefined && val.value.extent.split('_')[2] !== undefined) {
	                        estimationTask.Extent = {
	                          PriceModelExtentId: val.value.extent.split('_')[2]
	                        };
	                        postData.Parts[partDataID].EstimationTasks[estimationTaskIdx.toString()] = estimationTask;
	                      }
	                    }
	                    // EstimationTask is present, update its extras.
	                    val.value.extra.map(function (v, k) {
	                      if (estimationTask !== null) {
	                        var extraFound = false;
	                        for (var _i = 0; _i < estimationTask.Extras.length; _i++) {
	                          if (estimationTask.Extras[_i].EstimationExtraId === parseInt(v.id.split('_')[2])) extraFound = true;
	                        }
	                        if (!extraFound) {
	                          estimationTask.Extras.push({
	                            EstimationExtraId: parseInt(v.id.split('_')[2]),
	                            AE: v.ae,
	                            Material: v.mat
	                          });
	                        }
	                      }
	                      postData.Parts[partDataID].EstimationTasks[estimationTaskIdx.toString()] = estimationTask;
	                    });
	                  }
	                }
	              });
	            }
	          };
	
	          for (var key in _parts) {
	            _loop3(key);
	          }
	        } else if (this.props.order.OrderType === 5 && this.props.params.addon !== '2' && this.props.params.addon !== 'bodyaddon') {
	          // COMPLAINTS
	          var _parts2 = tmpState.car.final.parts;
	
	          var _loop4 = function _loop4(key) {
	            var partID = _this10.state.car.mapping[key];
	            var taskSide = _this10.getTaskSide(key);
	            var partDataID = _this10.findPartArrayFromId(postData.Parts, partID, taskSide);
	            // console.log('partDataID', partDataID, 'postData.Parts', postData.Parts, 'partID', partID, 'taskSide', taskSide)
	            if (partDataID === false) {
	              var partData = {};
	              partData.Part = {
	                PartItemId: partID,
	                TaskSide: taskSide
	              };
	              partData.Complaints = [];
	              _parts2[key].map(function (val, index) {
	                partData.Complaints.push({
	                  ComplaintType: val.ComplaintType !== undefined ? val.ComplaintType : val.EnumValue,
	                  TaskSide: taskSide
	                });
	              });
	              postData.Parts.push(partData);
	            } else {
	              _parts2[key].map(function (val, index) {
	                postData.Parts[partDataID].Complaints.push({
	                  ComplaintType: val.ComplaintType !== undefined ? val.ComplaintType : val.EnumValue,
	                  TaskSide: taskSide
	                });
	              });
	            }
	          };
	
	          for (var key in _parts2) {
	            _loop4(key);
	          }
	        } else {
	          // Check if we should add some tasks
	          var _parts3 = tmpState.car.final.parts;
	
	          var _loop5 = function _loop5(key) {
	            var partID = _this10.state.car.mapping[key];
	            var partDataID = _this10.findPartArrayFromId(postData.Parts, partID, _this10.getTaskSide(key));
	            if (partDataID === false) {
	              var partData = {};
	              partData.Part = {
	                PartItemId: partID,
	                TaskSide: _this10.getTaskSide(key)
	              };
	              partData.Tasks = [];
	              _parts3[key].map(function (val, index) {
	                if (val.IsNew === true) val.OrderTaskId = 0;
	                partData.Tasks.push(val);
	              });
	              postData.Parts.push(partData);
	            } else {
	              _parts3[key].map(function (val, index) {
	                if (val.IsNew === true) val.OrderTaskId = 0;
	                postData.Parts[partDataID].Tasks.push(val);
	              });
	            }
	          };
	
	          for (var key in _parts3) {
	            _loop5(key);
	          }
	        }
	      }
	
	      // Make addon parts
	      postData.OrderAddonParts = typeof addonParts !== 'undefined' ? addonParts : postData.OrderAddonParts;
	      // postData.OrderAddonParts = postData.OrderAddonParts
	      var addons = tmpState.car.final.addon;
	      addons.map(function (val, index) {
	        postData.OrderAddonParts.push({
	          AddonPartId: val.AddonPartId
	        });
	      });
	
	      // Make addon start times
	      postData.OrderAddonStartTimes = typeof addonTimes !== 'undefined' ? addonTimes : postData.OrderAddonStartTimes;
	      // postData.OrderAddonStartTimes = postData.OrderAddonStartTimes
	      var addonStartTimes = tmpState.car.final.addonStartTimes;
	      addonStartTimes.map(function (val, index) {
	        postData.OrderAddonStartTimes.push({
	          AddonStartTimeId: val.AddonStartTimeId
	        });
	      });
	
	      // Make extra
	      postData.Extras = typeof extra !== 'undefined' ? extra : postData.Extras;
	      var extras = tmpState.car.final.extra;
	      extras.map(function (val, index) {
	        postData.Extras.push({
	          ServiceTaskId: val.ServiceId
	        });
	      });
	
	      // Make services
	      postData.Services = typeof servicesData !== 'undefined' ? servicesData : postData.Services;
	      var services = tmpState.car.final.services;
	      services.map(function (val, index) {
	        postData.Services.push({
	          ServiceTaskId: val.ServiceId
	        });
	      });
	
	      // Set new state
	      this.setState({
	        car: _extends({}, this.state.car, {
	          final: _extends({}, this.state.car.final, {
	            parts: [],
	            services: [],
	            extra: [],
	            addon: [],
	            addonStartTimes: []
	          })
	        })
	      });
	
	      // Evaluation
	      if (this.props.params.addon === '3') {
	        postData.IsEvaluation = true;
	      }
	      // AfterEvaluation
	      if (this.props.params.addon === '4') {
	        postData.IsAfterEvaluation = true;
	      }
	
	      // Update prices
	      this.setState({ isUpdating: true }, function () {
	        _this10.props.updatePrices(postData).then(function (res) {
	          _this10.setState({
	            draftDeliveryChangePopup: _extends({}, _this10.state.draftDeliveryChangePopup, {
	              newDate: res.data.DeliveryAfter
	            })
	          });
	          _this10.setState({
	            isUpdating: false,
	            customer_price: _extends({}, _this10.state.customer_price, {
	              discount: res.data.DiscountCustomer,
	              netprice: res.data.NetCustomer
	            }),
	            activeTaskId: 0
	          });
	          _events2.default.emit('pricecalc_activeitem_done', 0);
	        }, function () {
	          _this10.setState({
	            isUpdating: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'getPriceInformations',
	    value: function getPriceInformations(type, brand, customerId) {
	      var _this11 = this;
	
	      if (this.state.gettingPriceInformation === true) return; // Added state to check and cancel if request already running
	      this.setState({ gettingPriceInformation: true }, function () {
	        var deviation = null;
	        var otherDamage = false;
	        var IsEstimation = false;
	        var isAddonSale = false;
	        if (_this11.props.params.addon === '5' || _this11.props.params.addon === '6') {
	          deviation = _this11.props.params.addon === '5' ? 0 : 1;
	        }
	        if (_this11.props.params.addon === '3' || _this11.props.params.addon === '4') {
	          IsEstimation = true;
	        }
	        if (_this11.props.params.addon === '2' || _this11.props.params.addon === 'bodyaddon') {
	          isAddonSale = true;
	        }
	        if (_this11.props.params.addon === '7') {
	          otherDamage = true;
	        }
	        var orderId = -1;
	        if (_this11.props.order !== undefined && _this11.props.order !== null && _this11.props.order.Id !== undefined && _this11.props.order.Id !== null) {
	          orderId = _this11.props.order.Id;
	        }
	        var request = {
	          type: type,
	          brand: brand,
	          customerId: customerId,
	          deviation: deviation,
	          IsOtherDamage: otherDamage,
	          IsEstimation: IsEstimation,
	          isAddon: isAddonSale,
	          orderId: orderId,
	          isBodyShop: ['bodyextent', 'bodyaddon', 'manualbody', '7'].indexOf(_this11.props.params.addon) !== -1 // this.props.params.addon === 'bodyextent' || this.props.params.addon === 'bodyaddon'
	        };
	        _this11.props.getPriceInformation(request).then(function (res) {
	          // Create a mapping here aswell
	          var mapping = [];
	          res.data.Parts.map(function (val, index) {
	            mapping[val.Mapping] = val.PartId;
	          });
	          // Set car state
	          _this11.setState({
	            price: res.data,
	            car: _extends({}, _this11.state.car, {
	              extents: res.data.Extents,
	              parts: res.data.Parts,
	              services: res.data.Services,
	              extra: res.data.Extra,
	              AddonParts: res.data.AddonParts,
	              AddonStartTimes: res.data.AddonStartTimes,
	              complaints: res.data.ComplaintTypes,
	              mapping: mapping,
	              reasons: res.data.DeviationReasons,
	              otherDamages: res.data.OtherDamages,
	              final: {
	                parts: [],
	                extra: [],
	                services: [],
	                addon: [],
	                addonStartTimes: []
	              }
	            })
	          }, function () {
	            _this11.props.setCarParts(_this11.state.car.parts);
	          });
	        }, function () {
	          // Toastr
	          if (isAddonSale) {
	            window.toastr.error((0, _helpers.translation)('2262'), (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('2087'), (0, _helpers.translation)('216'));
	          }
	          // this.props.router.replace('/orders/' + this.props.params.orderID)
	          _this11.props.router.goBack();
	        });
	        _this11.setState({ gettingPriceInformation: false });
	      });
	    }
	  }, {
	    key: 'isPriceCalc',
	    value: function isPriceCalc() {
	      // console.log('isPriceCalc -> this.state.price', this.state.price)
	      if (!this.state.price || this.state.price.UsingEstimationFallback === undefined || this.state.price.UsingEstimationFallback) return false;
	
	      if ( /* this.props.params.addon === '2' ||  */this.props.params.addon === 'bodyaddon') {
	        return true;
	      }
	
	      if (['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1) {
	        // this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6') {
	        return false;
	      }
	      return !(this.props.order.OrderType === 1 || this.props.order.OrderType === 4 || this.props.order.OrderType === 5 /* || this.props.order.OrderType === 2 */);
	    }
	  }, {
	    key: 'renderAddons',
	    value: function renderAddons() {
	      var _this12 = this;
	
	      if (this.props.params.addon === 'manualbody') return null;
	      if (this.props.price.HasAwaiting) return null;
	      if (this.props.price.CarSize === 0) return null;
	      if (this.state.price.UsingEstimationFallback) return null;
	      if (this.state.car.AddonParts === undefined) return null;
	      if (this.props.order.OrderType === 1 && this.props.params.addon === '1' || ['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1) return null; // this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6') return null
	      var AddonParts = this.state.car.AddonParts;
	      var AddonStartTimes = this.state.car.AddonStartTimes;
	
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1792') },
	        AddonParts.map(function (val, index) {
	          var labelText = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-plus' }),
	            ' ',
	            val.Name
	          );
	          return _react2.default.createElement(_button2.default, { style: 'link', size: 'm', key: index, onClick: _this12.addExtraService.bind(_this12, val, 'addon'), labelText: labelText });
	        }),
	        AddonStartTimes.map(function (val, index) {
	          var labelText = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-plus' }),
	            ' ',
	            val.Name
	          );
	          return _react2.default.createElement(_button2.default, { style: 'link', size: 'm', key: index, onClick: _this12.addExtraService.bind(_this12, val, 'addonStartTimes'), labelText: labelText });
	        })
	      );
	    }
	  }, {
	    key: 'renderExtraServices',
	    value: function renderExtraServices() {
	      var _this13 = this;
	
	      if (this.props.params.addon === 'manualbody') return null;
	      if (this.props.price.HasAwaiting) return null;
	      if (this.props.price.CarSize === 0) return null;
	      if (this.props.order.OrderType === 1 && this.props.params.addon === '1' || ['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1) return null; // this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6') return null
	      var items = this.state.car.extra;
	      var translateKey = this.props.params.addon === 'bodyextent' || this.props.params.addon === 'bodyaddon' ? '14820' : '2224';
	      // No services
	      if (items.length === 0) {
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)(translateKey) },
	          (0, _helpers.translation)('13380')
	        );
	      }
	      // Render services
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(translateKey) },
	        items.map(function (val, index) {
	          var labelText = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-plus' }),
	            ' ',
	            val.Name
	          );
	          return _react2.default.createElement(_button2.default, { style: 'link', size: 'm', key: index, onClick: _this13.addExtraService.bind(_this13, val, 'extra'), labelText: labelText });
	        })
	      );
	    }
	  }, {
	    key: 'renderServices',
	    value: function renderServices() {
	      var _this14 = this;
	
	      if (this.props.price.CarSize === 0) return null;
	      if (this.props.order.OrderType === 1 && this.props.params.addon === '1' || ['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1) return null; // this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6') return null
	      if (this.props.auth.user.CustomerId === '-1') return null;
	      var items = this.state.car.services;
	      var translateKey = '13375';
	      // No extra services
	      if (items.length === 0) {
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)(translateKey) },
	          (0, _helpers.translation)('13381')
	        );
	      }
	      // Render extra services
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(translateKey) },
	        items.map(function (val, index) {
	          var labelText = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-plus' }),
	            ' ',
	            val.Name
	          );
	          return _react2.default.createElement(_button2.default, { style: 'link', size: 'm', key: index, onClick: _this14.addExtraService.bind(_this14, val, 'services'), labelText: labelText });
	        })
	      );
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      var _this15 = this;
	
	      // Todo, ACTIVE TAB
	      var changeTab = function changeTab(view, e) {
	        e.preventDefault();
	        _this15.setState({
	          view: view === 'euro' ? 'euro' : 'car car' + view
	        });
	      };
	      var activeTab = function activeTab(id) {
	        if (_this15.state.view === 'euro' && id === 'euro') {
	          return 'active';
	        } else if (_this15.state.view === 'car car' + id) {
	          return 'active';
	        }
	        return '';
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'car__actions clearfix' },
	          _react2.default.createElement(
	            'a',
	            { className: 'change_car_view ' + activeTab('1'), 'data-type': 'front', onClick: changeTab.bind(this, '1') },
	            activeTab('1') !== 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-front-Black.png)' } }),
	            activeTab('1') === 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-front-White.png)' } })
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'change_car_view ' + activeTab('2'), 'data-type': 'right', onClick: changeTab.bind(this, '2') },
	            activeTab('2') !== 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-Right-Black.png)' } }),
	            activeTab('2') === 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-Right-White.png)' } })
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'change_car_view ' + activeTab('3'), 'data-type': 'back', onClick: changeTab.bind(this, '3') },
	            activeTab('3') !== 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-Back-Black.png)' } }),
	            activeTab('3') === 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-Back-White.png)' } })
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'change_car_view ' + activeTab('4'), 'data-type': 'left', onClick: changeTab.bind(this, '4') },
	            activeTab('4') !== 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-Left-Black.png)' } }),
	            activeTab('4') === 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-Left-White.png)' } })
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'change_car_view ' + activeTab('5'), 'data-type': 'roof', onClick: changeTab.bind(this, '5') },
	            activeTab('5') !== 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-Roof-Black.png)' } }),
	            activeTab('5') === 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/car/Car-Roof-White.png)' } })
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: '' + activeTab('euro'), onClick: changeTab.bind(this, 'euro') },
	            activeTab('euro') !== 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/payment16.png)' } }),
	            activeTab('euro') === 'active' && _react2.default.createElement('span', { style: { backgroundImage: 'url(/images/icons/payment16_white.png)' } })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCarSize',
	    value: function renderCarSize() {
	      var _this16 = this;
	
	      if (['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1 || this.state.price.UsingEstimationFallback) return null; // this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6' || this.state.price.UsingEstimationFallback) return null
	      if (this.props.params.addon === '1') {
	        if (this.props.order.OrderType === 1 || this.props.order.OrderType === 5) {
	          return null;
	        }
	      }
	      var carSizeNum = this.props.price.CarSize;
	      if (carSizeNum === 0) {
	        // carSizeNum = 2
	      }
	      var carsize = this.props.carSizes[carSizeNum];
	      var changeCarSize = function changeCarSize(size) {
	        var postData = Object.assign({}, _this16.props.price);
	        postData.CarSize = size;
	        // Evaluation
	        if (_this16.props.params.addon === '3') {
	          postData.IsEvaluation = true;
	        }
	        // AfterEvaluation
	        if (_this16.props.params.addon === '4') {
	          postData.IsAfterEvaluation = true;
	        }
	        _this16.props.updatePrices(postData);
	        _this16.setState({
	          car: _extends({}, _this16.state.car, {
	            size: size
	          }),
	          carswitcher: false
	        });
	      };
	      var triggerSwitcher = function triggerSwitcher() {
	        _this16.setState({
	          carswitcher: true
	        });
	      };
	      var openHelperModal = function openHelperModal() {
	        _this16.props.triggerPopup(!_this16.state.helperPopup);
	        _this16.setState({
	          helperPopup: !_this16.state.helperPopup
	        });
	      };
	      var carIconLabel = function carIconLabel(size) {
	        var noLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var icon = '';
	        var label = '';
	        switch (size) {
	          case 'S':
	            icon = _icons.CarIcons.Small;
	            label = (0, _helpers.translation)('1264');
	            break;
	          case 'M':
	            icon = _icons.CarIcons.Medium;
	            label = (0, _helpers.translation)('13342');
	            break;
	          case 'L':
	            icon = _icons.CarIcons.Large;
	            label = (0, _helpers.translation)('1266');
	            break;
	        }
	        return noLabel ? _react2.default.createElement(_icon2.default, { icon: icon }) : [_react2.default.createElement(_icon2.default, { icon: icon }), _react2.default.createElement(
	          'div',
	          null,
	          label
	        )];
	      };
	      var sizeLetter = 'L';
	      if (carsize === 'medium') sizeLetter = 'M';
	      if (carsize === 'small') sizeLetter = 'S';
	      var display = _react2.default.createElement(
	        'div',
	        { className: 'carsize__box' },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: ['min-content'] },
	          _react2.default.createElement(_button2.default, { style: 'link', onClick: triggerSwitcher.bind(this), labelText: carIconLabel(sizeLetter, true) })
	        )
	      );
	
	      if (this.props.params.addon === 'bodyextent' || this.props.params.addon === 'bodyaddon' || this.props.params.addon === 'manualbody') display = null;
	      if (this.props.auth.user.CustomerId === '-1' || this.props.order.IsDraft) {
	        if (this.state.carswitcher || carSizeNum === 0) {
	          display = _react2.default.createElement(
	            'div',
	            { className: 'carsize__box' },
	            _react2.default.createElement(_CarsizeModal2.default, {
	              show: this.state.helperPopup,
	              onClose: openHelperModal }),
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: ['min-content', 'min-content', 'min-content', 'min-content'] },
	              _react2.default.createElement(
	                _button2.default,
	                { style: 'link', onClick: openHelperModal.bind(this), className: 'helper__icon' },
	                _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Info_Circle })
	              ),
	              _react2.default.createElement(_button2.default, { style: 'link', onClick: changeCarSize.bind(this, 1), labelText: carIconLabel('S') }),
	              _react2.default.createElement(_button2.default, { style: 'link', onClick: changeCarSize.bind(this, 2), labelText: carIconLabel('M') }),
	              _react2.default.createElement(_button2.default, { style: 'link', onClick: changeCarSize.bind(this, 3), labelText: carIconLabel('L') })
	            )
	          );
	        }
	      }
	
	      return display;
	    }
	  }, {
	    key: 'renderEvaluation',
	    value: function renderEvaluation() {
	      if (this.props.params.addon !== '3') return null; // && !this.state.price.UsingEstimationFallback
	      if (this.state.price.UsingEstimationFallback === undefined) return null; // to handle double Estimation OrderPrices
	      // Filter away normal files
	      return _react2.default.createElement(
	        'div',
	        { className: 'evaluationBox' },
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13363') }),
	        _react2.default.createElement(_Evaluation2.default, { orderId: this.props.order.Id, isEdit: true })
	      );
	    }
	  }, {
	    key: 'renderInsuranceManual',
	    value: function renderInsuranceManual() {
	      var _this17 = this;
	
	      if ((this.props.params.addon === '1' && this.props.order.OrderType === 1 || this.state.price.UsingEstimationFallback) && this.props.params.addon !== '5' && this.props.params.addon !== '6' && this.props.params.addon !== '7') {
	        if (this.props.order.OrderType === 4) return null;
	        // Environment
	        var onInputChange = function onInputChange(e) {
	          _this17.setState({
	            manual: _extends({}, _this17.state.manual, _defineProperty({}, e.target.name, e.target.value))
	          });
	        };
	        var onBlur = function onBlur(e) {
	          // Data
	          var postData = Object.assign({}, _this17.props.price);
	          if (e.target.name === 'Price') {
	            postData.Total = parseFloat((0, _currency.reverseFormatCurrency)(e.target.value));
	          } else {
	            postData.Environment = parseFloat((0, _currency.reverseFormatCurrency)(e.target.value));
	          }
	          postData.HoldTotal = true;
	          _this17.setState({
	            isUpdating: true,
	            manualPriceChanged: true
	          });
	          _this17.props.updatePrices(postData).then(function (res) {
	            _this17.setState({
	              isUpdating: false,
	              manual: {
	                Price: (0, _currency.formatCurrency)(res.data.Total) === '0,00' || (0, _currency.formatCurrency)(res.data.Total) === '0.0' ? '' : (0, _currency.formatCurrency)(res.data.Total),
	                Environment: (0, _currency.formatCurrency)(res.data.Environment) === '0,00' || (0, _currency.formatCurrency)(res.data.Environment) === '0.0' ? '' : (0, _currency.formatCurrency)(res.data.Environment)
	              }
	            });
	          });
	        };
	
	        var beforeDiscountLabel = '';
	        if (this.props.order.HasDiscount || this.props.order.AddonHasDiscount) {
	          beforeDiscountLabel = ' ' + (0, _helpers.translation)('15012');
	        }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)('1913')
	          ),
	          _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('641') + beforeDiscountLabel, name: 'Price', onBlur: onBlur, onChange: onInputChange, value: this.state.manual.Price, placeholder: '0,00' }),
	          _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('13339') + beforeDiscountLabel, name: 'Environment', onBlur: onBlur, onChange: onInputChange, value: this.state.manual.Environment, placeholder: '0,00' })
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'openEmail',
	    value: function openEmail() {
	      this.setState({
	        showEmail: !this.state.showEmail
	      });
	    }
	  }, {
	    key: 'renderSendEmail',
	    value: function renderSendEmail() {
	      var _this18 = this;
	
	      if (!this.isPriceCalc()) return null;
	      if (Object.keys(this.props.price).length === 0) return null;
	      if (this.props.price.CarSize === 0) return null;
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	
	      var submitForm = function submitForm(e) {
	        // e.preventDefault()
	        var data = _extends({}, _this18.props.price);
	        data.SendMail = {
	          UserId: isCustomer ? 0 : parseInt(_this18.state.SelectedContact),
	          Email: isCustomer ? _this18.state.SelectedContactMail : null
	        };
	        if (!isCustomer && data.SendMail.UserId === 0 && _this18.state.contacts.length !== 0) {
	          data.SendMail.UserId = _this18.state.contacts[0].UserId;
	        }
	        _this18.props.updatePrices(data).then(function (res) {
	          // window.toastr.success(translation('13004'), translation('13424')) // Offer was sent
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('2250'), (0, _helpers.translation)('216'));
	        });
	      };
	      var onChange = function onChange(e) {
	        if (e.target.name === 'sendtoemail') {
	          _this18.setState({
	            SelectedContact: e.target.value
	          });
	        } else {
	          _this18.setState(_defineProperty({}, e.target.name, e.target.value));
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'sendEmailBox' },
	        isCustomer ? _react2.default.createElement(_text2.default, { name: 'SelectedContactMail', value: this.state.SelectedContactMail, onChange: onChange, labelText: (0, _helpers.translation)('1052') }) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('346') }),
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'sendtoemail', value: this.state.SelectedContact, onChange: onChange },
	            this.state.contacts.map(function (contact, key) {
	              if (contact.Active !== true || typeof contact.Mail !== 'string' || contact.Mail.indexOf('@') === -1) return null;
	              return _react2.default.createElement(
	                'option',
	                { value: contact.UserId, key: key },
	                contact.Name + ' (' + contact.Mail + ')'
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_button2.default, { labelText: (0, _helpers.translation)('1301'), onClick: submitForm })
	      );
	    }
	  }, {
	    key: 'postCancel',
	    value: function postCancel() {
	      // if (true /* this.props.price.ApprovalShop === 1 || this.props.price.ApprovalCustomer === 1 */) {
	      var postData = this.props.price;
	      postData.CancelEditing = true;
	      return this.props.updatePrices(postData);
	      // }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this19 = this;
	
	      var EXTENT_TYPE = {
	        BASE: '1',
	        BODY_EXTENT: 'bodyextent',
	        BODY_MANUAL: 'manualbody',
	        ADDON: '2',
	        BODY_ADDON: 'bodyaddon',
	        EVALUATION: '3',
	        AFTER_EVALUATION: '4',
	        INT_DEVIATION: '5',
	        EXT_DEVIATION: '6',
	        OTHER_DAMAGE: '7'
	      };
	
	      if (typeof this.props.order.Id === 'undefined') return null;
	      var isCreatingDeviation = this.props.params.addon === '5' || this.props.params.addon === '6';
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 20) && isCreatingDeviation) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 2) && !((0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 20) && isCreatingDeviation)) return null;
	
	      // Control variables
	      // let addon = false
	      var evaluation = false;
	      var afterEvaluation = false;
	      var deviation = false;
	      // let otherDamage = false
	
	      var extentType = 'base';
	
	      // if (this.props.params.addon === EXTENT_TYPE.BASE || this.props.params.addon === EXTENT_TYPE.BODY_EXTENT || this.props.params.addon === EXTENT_TYPE.BODY_MANUAL) {
	      //   addon = false
	      // }
	
	      switch (this.props.params.addon) {
	        case EXTENT_TYPE.BASE:
	          extentType = 'base';
	          if (this.state.price.UsingEstimationFallback) {
	            evaluation = true; // Estimation fallback for addon sales
	            // extentType = 'eval'
	          }
	          break;
	        case EXTENT_TYPE.BODY_EXTENT:
	          extentType = 'base';
	          break;
	        case EXTENT_TYPE.BODY_MANUAL:
	          extentType = 'base';
	          break;
	        case EXTENT_TYPE.ADDON:
	          // addon = true
	          extentType = 'addon';
	          if (this.state.price.UsingEstimationFallback) {
	            evaluation = true; // Estimation fallback for addon sale
	            extentType = 'eval';
	          }
	          break;
	        case EXTENT_TYPE.BODY_ADDON:
	          // addon = true
	          extentType = 'addon';
	          break;
	        case EXTENT_TYPE.EVALUATION:
	          evaluation = true;
	          extentType = 'eval';
	          break;
	        case EXTENT_TYPE.AFTER_EVALUATION:
	          afterEvaluation = true;
	          extentType = 'aftereval';
	          break;
	        case EXTENT_TYPE.INT_DEVIATION:
	          deviation = 0;
	          // evaluation = false
	          extentType = 'intdeviation';
	          break;
	        case EXTENT_TYPE.EXT_DEVIATION:
	          deviation = 1;
	          // evaluation = false
	          extentType = 'extdeviation';
	          break;
	        case EXTENT_TYPE.OTHER_DAMAGE:
	          // otherDamage = true
	          extentType = 'otherdamage';
	          break;
	      }
	
	      // // Evaluation
	      // let evaluation = false
	      // if (this.props.params.addon === EXTENT_TYPE.EVALUATION || this.state.price.UsingEstimationFallback) {
	      //   evaluation = true
	      //   addon = false
	      // }
	      // // After evaluation
	      // let afterEvaluation = false
	      // if (this.props.params.addon === EXTENT_TYPE.AFTER_EVALUATION) {
	      //   afterEvaluation = true
	      //   addon = false
	      // }
	
	      // // Estimation fallback for addon sale
	      // if ((this.props.params.addon === EXTENT_TYPE.ADDON || this.props.params.addon === EXTENT_TYPE.BODY_ADDON) && this.state.price.UsingEstimationFallback) {
	      //   evaluation = true
	      //   addon = true
	      // }
	
	      // // Deviation
	      // let deviation = false
	      // if (this.props.params.addon === EXTENT_TYPE.INT_DEVIATION || this.props.params.addon === EXTENT_TYPE.EXT_DEVIATION) {
	      //   deviation = (this.props.params.addon === EXTENT_TYPE.INT_DEVIATION) ? 0 : 1
	      //   addon = false
	      //   evaluation = false
	      // }
	
	      // let otherDamage = false
	      // if (this.props.params.addon === EXTENT_TYPE.OTHER_DAMAGE) {
	      //   otherDamage = true
	      //   addon = false
	      // }
	
	      // let extentType = 'base'
	      // if (evaluation) {
	      //   extentType = 'eval'
	      // }
	      // if (addon) {
	      //   extentType = 'addon'
	      // }
	      // if (afterEvaluation) {
	      //   extentType = 'aftereval'
	      // }
	      // if (deviation === 0) {
	      //   extentType = 'intdeviation'
	      // }
	      // if (deviation === 1) {
	      //   extentType = 'extdeviation'
	      // }
	      // if (otherDamage) {
	      //   extentType = 'otherdamage'
	      // }
	
	      var isBodyShop = [EXTENT_TYPE.BODY_EXTENT, EXTENT_TYPE.BODY_ADDON, EXTENT_TYPE.BODY_MANUAL, EXTENT_TYPE.OTHER_DAMAGE].includes(this.props.params.addon);
	      var headerButtonsGoBack = void 0;
	      if (window.LocalstorageStack.top() !== false && typeof headerButtonsGoBack !== 'undefined' && (window.LocalstorageStack.top().pathname === '/orders/' || window.LocalstorageStack.top().pathname === '/orders')) {
	        headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	          var goBack = function goBack() {
	            _this19.clearData();
	            _this19.props.router.replace({
	              pathname: '/orders',
	              query: {
	                orderid: _this19.props.order.Id
	              }
	            });
	          };
	          return _react2.default.createElement(_closeButton2.default, { onClick: goBack, ariaText: t('2060') });
	        };
	      }
	
	      if (typeof headerButtonsGoBack === 'undefined') {
	        headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	          var goBack = function goBack(type) {
	            if (type === 'back') {
	              _this19.checkPopupGoBack();
	            } else if ((0, _router.shouldHaveArrow)() && type === 'close') {
	              _this19.checkPopupGoBack(true);
	            } else {
	              // Check if orderprice has edits.
	              if (_this19.props.price.ApprovalShop === 1 || _this19.props.price.ApprovalCustomer === 1) {
	                var postData = _this19.props.price;
	                postData.CancelEditing = true;
	                _this19.checkPopupGoBack(true);
	              } else {
	                _this19.checkPopupGoBack();
	              }
	            }
	          };
	          var renderArrowBack = function renderArrowBack() {
	            var topOfStack = window.LocalstorageStack.top();
	            if (topOfStack && !(0, _router.shouldHaveArrow)()) {
	              return null;
	            }
	            return _react2.default.createElement(_backButton2.default, { ariaText: (0, _helpers.translation)('394'), onClick: goBack.bind(_this19, 'back') });
	          };
	          return _react2.default.createElement(
	            'div',
	            { key: 'back_close' },
	            renderArrowBack(),
	            _react2.default.createElement(_closeButton2.default, { onClick: goBack.bind(_this19, 'close'), ariaText: t('2060') })
	          );
	        };
	      }
	      // Render
	      var extent = this.refs['extent'];
	      if (extent !== undefined) {
	        this.extentAdapter.setExtent(extent);
	      }
	      var confirmExitText = '';
	      if (this.props.price.IsAfterEvaluation) {
	        confirmExitText = (0, _helpers.translation)(15209);
	      } else if (this.props.price.IsAddonPrice) {
	        confirmExitText = (0, _helpers.translation)(16833);
	      } else {
	        confirmExitText = (0, _helpers.translation)(13252);
	      }
	
	      var viewMode = void 0;
	      var renderInside = void 0;
	      var isMobile = this.dimensionShow([[0, 751]]);
	      if (isMobile) {
	        viewMode = 'mobile';
	        renderInside = function renderInside() {
	          return _this19.renderActions();
	        };
	      }
	
	      var doRenderCarArea = !isBodyShop && ((0, _auth.hasSubscriptionPermission)(this.props.auth, 20) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 20)) || isBodyShop && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20);
	      var doRenderExtrasArea = doRenderCarArea && this.isPriceCalc();
	      var doRenderExtentArea = true;
	
	      // console.log('PriceCalculation -> extentType', extentType, 'deRenderCarArea', doRenderCarArea, 'this.props', this.props, 'car', this.state.car)
	
	      var renderCarArea = function renderCarArea() {
	        return _react2.default.createElement(
	          'div',
	          { id: 'carArea', className: 'view_' + _this19.state.view },
	          _react2.default.createElement(
	            _panel2.default,
	            { clearfix: true },
	            _this19.props.order.OrderType !== 4 && _react2.default.createElement(
	              'div',
	              { className: 'car__outer_wrapper' },
	              _this19.renderActions(),
	              _this19.renderCarSize(),
	              _react2.default.createElement(
	                'div',
	                { className: 'car__wrapper' },
	                _react2.default.createElement(_Car2.default, { data: _this19.state.car, addon: _this19.props.params.addon, afterEvaluation: afterEvaluation, evaluation: evaluation, deviation: deviation })
	              )
	            )
	          )
	        );
	      };
	
	      var renderExtrasArea = function renderExtrasArea() {
	        return _react2.default.createElement(
	          'div',
	          { id: 'extrasArea', className: 'view_' + _this19.state.view },
	          _react2.default.createElement(
	            'div',
	            { className: 'extra_wrapper' },
	            _this19.renderAddons(),
	            _this19.renderExtraServices(),
	            !isBodyShop && _this19.renderServices()
	          )
	        );
	      };
	
	      var renderExtentArea = function renderExtentArea() {
	        return _react2.default.createElement(
	          'div',
	          { id: 'extentArea', className: 'view_' + _this19.state.view },
	          _react2.default.createElement(
	            _panel2.default,
	            { clearfix: true },
	            _this19.renderEvaluation(),
	            _this19.props.order.OrderType !== 4 && _react2.default.createElement(
	              'div',
	              { className: 'car__outer_wrapper' },
	              !isMobile && _this19.renderActions(),
	              _react2.default.createElement(_Extent2.default, {
	                ref: 'extent',
	                order: _this19.props.order,
	                department: isBodyShop ? 1 : 0,
	                extents: [{ type: extentType, editable: true, viewMode: viewMode, renderInside: renderInside }],
	                goBack: _this19.checkPopupGoBack.bind(_this19),
	                router: _this19.props.router
	              })
	            ),
	            _this19.state.showEmail && _this19.renderSendEmail()
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pricecalculation__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, showBack: true, headerButtonsGoBack: headerButtonsGoBack }),
	        _react2.default.createElement(
	          'div',
	          { className: 'pricecalculation__inner clearfix' },
	          doRenderCarArea && renderCarArea(),
	          doRenderExtrasArea && renderExtrasArea(),
	          doRenderExtentArea && renderExtentArea(),
	          this.props.order.OrderType === 4 && this.renderOtherOrder(),
	          this.renderDraftDeliveryDatePopup(),
	          this.state.ShowExitConfirm === true && _react2.default.createElement(_Confirm2.default, {
	            t: _helpers.translation,
	            renderText: function renderText() {
	              return confirmExitText;
	            },
	            confirm: this.confirm,
	            notConfirm: this.confirm.bind(this, true),
	            confirmText: function confirmText() {
	              return (0, _helpers.translation)('394');
	            },
	            notConfirmText: function notConfirmText() {
	              return (0, _helpers.translation)('13253');
	            }
	          })
	        )
	      );
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm(not) {
	      var _this20 = this;
	
	      this.setState({
	        ShowExitConfirm: false
	      }, function () {
	        if (not === true) {
	          _this20.postCancel().then(function () {
	            _this20.goBack(_this20.state.ShowExitConfirmClose === true);
	          });
	        }
	        // as a simple fix for price calculation, it should just close the popup, and the user should click on the OK button
	      });
	    }
	  }, {
	    key: 'checkPopupGoBack',
	    value: function checkPopupGoBack(close) {
	      var showPopup = this.state.draftDeliveryChangePopup.originalDate !== this.state.draftDeliveryChangePopup.newDate;
	      if (showPopup) {
	        this.setState({
	          draftDeliveryChangePopup: _extends({}, this.state.draftDeliveryChangePopup, {
	            show: this.state.draftDeliveryChangePopup.originalDate !== this.state.draftDeliveryChangePopup.newDate
	          })
	        });
	      } else if ((this.props.order.IsDraft === true || this.props.order.OrderType + '' === '1') && !this.props.price.IsAfterEvaluation) {
	        this.goBack(close);
	      } else if (this.props.price.RequireShopApproval === true) {
	        this.setState({
	          ShowExitConfirm: true,
	          ShowExitConfirmAction: close === true
	        });
	      } else {
	        this.goBack(close);
	      }
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack(close) {
	      if (close === true) {
	        var routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders']);
	        if (routeItem !== null) {
	          if (routeItem.pathname === '/orders') {
	            this.clearData();
	            this.clearEvents();
	            this.props.router.replace(routeItem.pathname + '?orderid=' + this.props.price.OrderId);
	          } else {
	            this.clearData();
	            this.clearEvents();
	            this.props.router.replace(routeItem.pathname);
	          }
	        } else {
	          this.clearData();
	          this.clearEvents();
	          this.props.router.goBack();
	        }
	      } else {
	        this.clearData();
	        this.clearEvents();
	        var _routeItem = window.LocalstorageStack.top();
	        // Fix for Edge, did cache some price calculations on workcard, and has to navigate insted of goBack
	        if (_routeItem !== null && _routeItem.pathname === '/orders/' + this.props.price.OrderId) {
	          this.props.router.push({
	            pathname: '/orders/' + this.props.price.OrderId
	          });
	        } else {
	          this.props.router.goBack();
	        }
	      }
	    }
	  }, {
	    key: 'renderOtherOrder',
	    value: function renderOtherOrder() {
	      var _this21 = this;
	
	      var onInputChangeOtherOrder = function onInputChangeOtherOrder(e) {
	        _this21.setState({
	          manual: _extends({}, _this21.state.manual, _defineProperty({}, e.target.name, e.target.value))
	        });
	      };
	      var saveOrder = function saveOrder() {
	        var data = {
	          OrderId: _this21.props.order.Id,
	          Price: parseFloat((0, _currency.reverseFormatCurrency)(_this21.state.manual.Price)),
	          Environment: parseFloat((0, _currency.reverseFormatCurrency)(_this21.state.manual.Environment)),
	          OtherTitle: _this21.state.manual.OtherTitle,
	          OtherDescription: _this21.state.manual.OtherDescription
	        };
	        _this21.props.updateOtherOrderPrice(data).then(function (res) {
	          _this21.setState({
	            manual: {
	              Price: (0, _currency.formatCurrency)(res.data.Price) === '0,00' || (0, _currency.formatCurrency)(res.data.Price) === '0.0' ? '' : (0, _currency.formatCurrency)(res.data.Price),
	              Environment: (0, _currency.formatCurrency)(res.data.Environment) === '0,00' || (0, _currency.formatCurrency)(res.data.Environment) === '0.0' ? '' : (0, _currency.formatCurrency)(res.data.Environment),
	              OtherTitle: res.data.OtherTitle === null ? '' : res.data.OtherTitle,
	              OtherDescription: res.data.OtherDescription === null ? '' : res.data.OtherDescription
	            }
	          });
	          var routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders']);
	          if (routeItem !== null) {
	            if (routeItem.pathname === '/orders') {
	              _this21.props.router.replace(routeItem.pathname + '?orderid=' + _this21.props.price.OrderId);
	            } else {
	              _this21.props.router.replace(routeItem.pathname);
	            }
	          } else {
	            _this21.props.router.goBack();
	          }
	        });
	      };
	
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('73') },
	            _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('1206'), name: 'OtherTitle', value: this.state.manual.OtherTitle, onChange: onInputChangeOtherOrder }),
	            _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('641'), name: 'Price', value: this.state.manual.Price, placeholder: '0,00', onChange: onInputChangeOtherOrder }),
	            _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('13339'), name: 'Environment', value: this.state.manual.Environment, placeholder: '0,00', onChange: onInputChangeOtherOrder }),
	            _react2.default.createElement(_textarea2.default, { labelText: (0, _helpers.translation)('1021'), name: 'OtherDescription', value: this.state.manual.OtherDescription, onChange: onInputChangeOtherOrder }),
	            _react2.default.createElement(_button2.default, { onClick: saveOrder, labelText: (0, _helpers.translation)('791') })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDraftDeliveryDatePopup',
	    value: function renderDraftDeliveryDatePopup() {
	      var _this22 = this;
	
	      if (!this.state.draftDeliveryChangePopup.show) return null;
	      if (this.props.auth.user.CustomerId === '-1' && this.state.draftDeliveryChangePopup.show) {
	        this.goBack();
	      } else {
	        var onSave = function onSave(date) {
	          _this22.setState({
	            draftDeliveryChangePopup: _extends({}, _this22.state.draftDeliveryChangePopup, {
	              newDate: date,
	              oldDate: date,
	              show: false
	            })
	          }, function () {
	            _this22.saveDelivery();
	          });
	        };
	        return _react2.default.createElement(_DeliveryDateChangeModal2.default, {
	          isCustomerDraft: true,
	          show: this.state.draftDeliveryChangePopup.show,
	          onClose: onSave.bind(this),
	          onSave: onSave.bind(this),
	          oldDate: this.state.draftDeliveryChangePopup.originalDate,
	          newDate: this.state.draftDeliveryChangePopup.newDate });
	      }
	    }
	  }, {
	    key: 'saveDelivery',
	    value: function saveDelivery() {
	      var _this23 = this;
	
	      var editedBookingTime = {
	        Department: this.props.auth.departmentType,
	        BookingTimeType: _constants.BookingTimesSectionType.Delivery,
	        OrderId: this.props.order.Id,
	        Date: this.state.draftDeliveryChangePopup.newDate,
	        Time: (0, _time.renderTimeOnly)(this.state.draftDeliveryChangePopup.newDate)
	      };
	
	      this.props.saveBookingTime(editedBookingTime).then(function (res) {
	        _this23.goBack();
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('13404'), (0, _helpers.translation)('216'));
	        _this23.goBack();
	      });
	    }
	  }]);
	
	  return PriceCalculation;
	}(_react.Component);
	
	PriceCalculation.propTypes = {
	  getPriceInformations: _react2.default.PropTypes.func.isRequired,
	  getPriceInformation: _react2.default.PropTypes.func.isRequired,
	  // getPrices: React.PropTypes.func.isRequired,
	  updatePrices: _react2.default.PropTypes.func.isRequired,
	  getOrder: _react2.default.PropTypes.func.isRequired,
	  triggerPopup: _react2.default.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    price: state.price.price,
	    order: state.orders.order,
	    carSizes: state.common.enums.carSizes,
	    carSelectedParts: state.price.carSelectedParts
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceInformations: _priceModel.getPriceInformations,
	  getPriceInformation: _priceModel.getPriceInformation,
	  // getPrices,
	  updatePrices: _orderPrice.updatePrices,
	  getOrder: _orders.getOrder,
	  triggerPopup: _backdrop.triggerPopup,
	  getCustomer: _customers.getCustomer,
	  updateOtherOrderPrice: _price.updateOtherOrderPrice,
	  getRejectedEvaluations: _orders.getRejectedEvaluations,
	  setCarParts: _price.setCarParts,
	  setCarSelectedParts: _price.setCarSelectedParts,
	  setPageTitle: _common.setPageTitle,
	  saveBookingTime: _bookingTime.saveBookingTime
	})(PriceCalculation);

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Elements
	
	
	var PriceCalculationType = function (_Component) {
	  _inherits(PriceCalculationType, _Component);
	
	  function PriceCalculationType() {
	    _classCallCheck(this, PriceCalculationType);
	
	    return _possibleConstructorReturn(this, (PriceCalculationType.__proto__ || Object.getPrototypeOf(PriceCalculationType)).apply(this, arguments));
	  }
	
	  _createClass(PriceCalculationType, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var item = this.props.item;
	      if (!item) return null;
	
	      // const onBlur = () => {
	      //   let { price } = this.state
	      //   price.PriceHourly = reverseFormatCurrency2(price.PriceHourly)
	
	      //   this.props.updatePriceList(price).then(res => {
	      //     this.setState({ price: res.data })
	      //     // Toastr
	      //     // window.toastr.success(translation('15157'), translation('13424'))
	      //   }, () => {
	      //     // Toastr
	      //     window.toastr.error(translation('13445'), translation('216'))
	      //   })
	      // }
	
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('18314') },
	        _react2.default.createElement(_text2.default, {
	          name: 'PriceHourly',
	          value: (0, _currency.formatCurrency2)(item.PriceHourly),
	          onChange: this.props.onChange,
	          onBlur: this.props.onBlur,
	          disabled: item.IsDisabled,
	          labelText: (0, _helpers.translation)('419')
	        }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1256') },
	          _react2.default.createElement(_radio2.default, { name: 'PriceCalculationType', value: '0', onChange: function onChange(e) {
	              return _this2.props.onChange(e, true);
	            }, disabled: item.IsDisabled, checked: item.PriceCalculationType === 0, labelText: (0, _helpers.translation)('12273'), helpText: (0, _helpers.translation)('12274') }),
	          _react2.default.createElement(_radio2.default, { name: 'PriceCalculationType', value: '1', onChange: function onChange(e) {
	              return _this2.props.onChange(e, true);
	            }, disabled: item.IsDisabled, checked: item.PriceCalculationType === 1, labelText: (0, _helpers.translation)('12275'), helpText: (0, _helpers.translation)('12276') }),
	          _react2.default.createElement(_radio2.default, { name: 'PriceCalculationType', value: '2', onChange: function onChange(e) {
	              return _this2.props.onChange(e, true);
	            }, disabled: item.IsDisabled, checked: item.PriceCalculationType === 2, labelText: (0, _helpers.translation)('12277'), helpText: (0, _helpers.translation)('12278') })
	        )
	      );
	    }
	  }]);
	
	  return PriceCalculationType;
	}(_react.Component);
	
	exports.default = PriceCalculationType;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _discountsAndKickback = __webpack_require__(793);
	
	__webpack_require__(517);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	
	// import HelpText from '../../../shared/components/HelpText'
	
	
	// Elements
	
	
	var ReportDiscounts = function (_Component) {
	  _inherits(ReportDiscounts, _Component);
	
	  function ReportDiscounts(props) {
	    _classCallCheck(this, ReportDiscounts);
	
	    var _this = _possibleConstructorReturn(this, (ReportDiscounts.__proto__ || Object.getPrototypeOf(ReportDiscounts)).call(this, props));
	
	    _this.state = {
	      customerId: 0,
	      assessmentRates_NoRental: {
	        CustomerId: 0,
	        Usage: _this.props.type,
	        Discounts: []
	      },
	      assessmentRates_Rental: null
	    };
	    return _this;
	  }
	
	  _createClass(ReportDiscounts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getRates(this.props);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.props.item.PriceModelId !== nextProps.item.PriceModelId || this.props.type !== nextProps.type) {
	        this.getRates(nextProps);
	      }
	    }
	  }, {
	    key: 'getRates',
	    value: function getRates(props) {
	      var _this2 = this;
	
	      var customerId = props.customerId;
	      var isKickback = this.props.hasKickback && parseInt(this.props.type) === 1;
	      this.props.getAssessmentCustomerRates(customerId, this.props.type).then(function (res) {
	        _this2.setState({
	          customerId: customerId,
	          assessmentRates_NoRental: res.data
	        });
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this2.props.router.push('/prices');
	      });
	      if (isKickback) {
	        this.props.getAssessmentCustomerRates(customerId, this.props.type * 10).then(function (res) {
	          // Type multiplied by 10 corresponds to same type but with rental car.
	          _this2.setState({
	            customerId: customerId,
	            assessmentRates_Rental: res.data
	          });
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	          _this2.props.router.push('/prices');
	        });
	      }
	    }
	  }, {
	    key: 'updateRates',
	    value: function updateRates(group) {
	      var _this3 = this;
	
	      this.props.updateAssessmentCustomerRates(this.state[group]).then(function (res) {
	        _this3.setState(_defineProperty({}, group, res.data));
	        // Toastr
	        // window.toastr.success(translation('15157'), translation('13424'))
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this3.props.router.push('/prices');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      var isKickback = this.props.hasKickback && parseInt(this.props.type) === 1;
	
	      var renderDiscounts = function renderDiscounts() {
	        if (_this4.state.assessmentRates_NoRental === null || _this4.state.assessmentRates_NoRental === undefined) return null;
	
	        // For bodyshop/kickback we want to render to colums of discount rows, for paintshops only one column applies,
	        // so we splice the discounts from each column together in pairs if we have them.
	        var hasRental = _this4.state.assessmentRates_Rental !== null;
	        var itemsNoRental = [].concat(_toConsumableArray(_this4.state.assessmentRates_NoRental.Discounts));
	        var itemsRental = hasRental ? [].concat(_toConsumableArray(_this4.state.assessmentRates_Rental.Discounts)) : null;
	        var splicedItems = itemsNoRental.map(function (x) {
	          return {
	            NoRental: x,
	            Rental: hasRental ? itemsRental.find(function (y) {
	              return y.SummationGroupConfigId === x.SummationGroupConfigId;
	            }) : null
	          };
	        });
	
	        var renderDiscountFields = function renderDiscountFields() {
	          var onChangeAmount = function onChangeAmount(e) {
	            var nameSegments = e.target.name.split('-');
	            var id = parseInt(nameSegments[1]);
	            var group = nameSegments[2];
	            var currentGroup = _this4.state[group];
	            var currentIndex = currentGroup.Discounts.findIndex(function (x) {
	              return x.SummationGroupConfigId === parseInt(id);
	            });
	            currentGroup.Discounts[currentIndex].DiscountAmount = e.target.value;
	            _this4.setState(_defineProperty({}, group, currentGroup));
	          };
	
	          var onAmountBlur = function onAmountBlur(target) {
	            var value = target.value;
	            var name = target.name;
	            if (isNaN(value)) {
	              // Toastr
	              window.toastr.error((0, _helpers.translation)('15159'), (0, _helpers.translation)('216'));
	            } else if (value < 0 || value > 99.99) {
	              // Toastr
	              window.toastr.error((0, _helpers.translation)('15158'), (0, _helpers.translation)('216'));
	            } else {
	              var nameSegments = name.split('-');
	              var id = parseInt(nameSegments[1]);
	              var group = nameSegments[2];
	
	              var currentGroup = _this4.state[group];
	              var currentIndex = currentGroup.Discounts.findIndex(function (x) {
	                return x.SummationGroupConfigId === parseInt(id);
	              });
	              currentGroup.Discounts[currentIndex].DiscountAmount = target.value;
	
	              _this4.setState(_defineProperty({}, group, currentGroup), function () {
	                _this4.updateRates(group);
	              });
	            }
	          };
	
	          var renderField = function renderField(item) {
	            var noRentalDiscount = item.NoRental;
	            var rentalDiscount = item.Rental;
	
	            var renderNoRental = function renderNoRental() {
	              return _react2.default.createElement(_DecimalInput2.default, {
	                name: 'SumGroupId-' + noRentalDiscount.SummationGroupConfigId + '-assessmentRates_NoRental',
	                value: noRentalDiscount.DiscountAmount,
	                onChange: onChangeAmount,
	                onBlur: onAmountBlur,
	                size: 'm'
	              });
	            };
	
	            var renderRental = function renderRental() {
	              return _react2.default.createElement(_DecimalInput2.default, {
	                name: 'SumGroupId-' + rentalDiscount.SummationGroupConfigId + '-assessmentRates_Rental',
	                value: rentalDiscount.DiscountAmount,
	                onChange: onChangeAmount,
	                onBlur: onAmountBlur,
	                size: 'm'
	              });
	            };
	
	            if (isKickback) {
	              return _react2.default.createElement(
	                _grid2.default,
	                { cols: ['40%', '1fr', '1fr'], align: 'center', spacing: 1, key: noRentalDiscount.SummationGroupConfigId },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  noRentalDiscount.DiscountType
	                ),
	                renderNoRental(),
	                rentalDiscount && renderRental()
	              );
	            } else {
	              return _react2.default.createElement(
	                _grid2.default,
	                { cols: ['1fr', '1fr'], align: 'center', spacing: 1, key: noRentalDiscount.SummationGroupConfigId },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  noRentalDiscount.DiscountType
	                ),
	                renderNoRental()
	              );
	            }
	          };
	
	          return splicedItems.map(renderField);
	        };
	
	        var renderHeadings = function renderHeadings(isKickback) {
	          var amountText = '1295';
	          var amountText2 = null;
	          var headingText = '';
	
	          if (_this4.props.type === 'Addon') {
	            // Addon
	            headingText = (0, _helpers.translation)('1396');
	          } else {
	            if (parseInt(_this4.props.type) === 1) {
	              // Insurance claim
	              headingText = (0, _helpers.translation)('70');
	              if (isKickback === true) {
	                amountText = '18391'; // without rental car
	                amountText2 = '18390'; // with rental car
	              }
	            } else {
	              headingText = (0, _helpers.translation)((0, _helpers.enumtranslate)('OrderTypes', parseInt(_this4.props.type)));
	            }
	          }
	
	          if (isKickback === true && _this4.props.isBodyShop === false) {
	            amountText = '14904';
	          }
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: amountText2 ? ['40%', '1fr', '1fr'] : ['1fr', '1fr'], align: 'center', spacing: 1 },
	            _react2.default.createElement(
	              'span',
	              null,
	              headingText
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(amountText)
	            ),
	            amountText2 && _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(amountText2)
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _this4.props.hasKickback ? renderHeadings(true) : renderHeadings(false),
	          renderDiscountFields()
	        );
	      };
	
	      var titleText = (0, _helpers.translation)('18368');
	      if (isKickback) {
	        titleText = (0, _helpers.translation)('18367');
	      }
	
	      var helpText = '';
	      switch (this.props.auth.departmentType) {
	        case 0:
	          helpText = (0, _helpers.translation)('15026') + ' ' + (0, _helpers.translation)('15037');
	          break;
	        case 1:
	          helpText = isKickback ? (0, _helpers.translation)('15212') : (0, _helpers.translation)('15036');
	          break;
	        case 2:
	          helpText = (0, _helpers.translation)('15026') + ' ' + (0, _helpers.translation)('15037');
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { span: '3' },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: titleText, helpText: helpText },
	            renderDiscounts()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReportDiscounts;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getAssessmentCustomerRates: _discountsAndKickback.getAssessmentCustomerRates,
	  updateAssessmentCustomerRates: _discountsAndKickback.updateAssessmentCustomerRates
	})(ReportDiscounts);

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _priceModel = __webpack_require__(75);
	
	__webpack_require__(517);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _PriceCalculationType = __webpack_require__(939);
	
	var _PriceCalculationType2 = _interopRequireDefault(_PriceCalculationType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	
	
	// Elements
	
	
	// import HelpText from '../../../shared/components/HelpText'
	
	var Discounts = function (_Component) {
	  _inherits(Discounts, _Component);
	
	  function Discounts(props) {
	    _classCallCheck(this, Discounts);
	
	    var _this = _possibleConstructorReturn(this, (Discounts.__proto__ || Object.getPrototypeOf(Discounts)).call(this, props));
	
	    _this.state = {
	      customerId: 0,
	      price: null,
	      currentItem: {
	        index: -1,
	        discount: null
	      }
	    };
	    _this.sortItems = _this.sortItems.bind(_this);
	    return _this;
	  }
	
	  _createClass(Discounts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadPriceModel(this.props);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.props.item.PriceModelId !== nextProps.item.PriceModelId || this.props.type !== nextProps.type) {
	        this.loadPriceModel(nextProps);
	      }
	    }
	  }, {
	    key: 'sortItems',
	    value: function sortItems(items) {
	      var _this2 = this;
	
	      var kickbackOrderTypes = [1, 10]; // easy expansion if more is added later
	      items.forEach(function (item) {
	        if (_this2.props.hasKickback && kickbackOrderTypes.indexOf(item.OrderType) > -1 && !item.IsAddonPrice) {
	          item.isKickBack = true;
	        } else {
	          item.isKickBack = false;
	        }
	      });
	      // sort OrderType 1,2,3,6,4,5,Mersalg
	      var index = items.findIndex(function (item) {
	        return item.OrderType === 1 && item.IsAddonPrice === true;
	      });
	      var addon = void 0;
	      if (index !== -1) addon = items.splice(index, 1);
	      var order = [1, 2, 3, 6, 4, 5];
	      // items = order.map(id => {
	      //   items.find(ob => ob.OrderType === id)
	      // })
	      items = items.map(function (_ref, i) {
	        var OrderType = _ref.OrderType;
	        return { item: order.indexOf(OrderType), index: i };
	      }).sort(function (a, b) {
	        return a.item - b.item || a.index - b.index;
	      }).map(function (_ref2) {
	        var index = _ref2.index;
	        return items[index];
	      });
	      items.push(addon[0]);
	      return items;
	    }
	  }, {
	    key: 'loadPriceModel',
	    value: function loadPriceModel(props) {
	      var _this3 = this;
	
	      var customerId = props.customerId;
	      this.props.getPriceList(props.item.PriceModelId, customerId).then(function (res) {
	        res.data.CustomerDiscounts.Discounts = _this3.sortItems(res.data.CustomerDiscounts.Discounts);
	        _this3.setState({
	          customerId: customerId,
	          price: res.data
	        });
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this3.props.router.push('/prices');
	      });
	    }
	  }, {
	    key: 'getDiscountSetIndex',
	    value: function getDiscountSetIndex(price, withRental) {
	      var _this4 = this;
	
	      var items = price.CustomerDiscounts.Discounts;
	      var index = items.findIndex(function (i) {
	        if (_this4.props.type === 'Addon') {
	          return i.OrderType === 1 && i.IsAddonPrice;
	        } else {
	          var type = parseInt(_this4.props.type);
	          if (withRental) {
	            // Rates for use with rental cars: Insurance (1) becomes Insurance_Rental (10)
	            type *= 10;
	          }
	          return i.OrderType === type && !i.IsAddonPrice;
	        }
	      });
	      return index;
	    }
	  }, {
	    key: 'updateDiscounts',
	    value: function updateDiscounts(withRental) {
	      var _this5 = this;
	
	      this.props.updatePriceList(this.state.price).then(function (res) {
	        res.data.CustomerDiscounts.Discounts = _this5.sortItems(res.data.CustomerDiscounts.Discounts);
	        _this5.setState({
	          price: res.data
	        });
	        // Toastr
	        // window.toastr.success(translation('15157'), translation('13424'))
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this5.props.router.push('/prices');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      if (!this.state.price) return null;
	
	      var renderDiscounts = function renderDiscounts() {
	        if (_this6.state.price === null || _this6.state.price === undefined) return null;
	
	        var renderBodyDiscountFields = function renderBodyDiscountFields() {
	          if (!_this6.state.price) return null;
	          var discountIndex = _this6.getDiscountSetIndex(_this6.state.price);
	          var currentDiscount = _this6.state.price.CustomerDiscounts.Discounts[discountIndex];
	          var discountIndexRental = null;
	          var currentDiscountRental = null;
	          if (_this6.props.hasKickback && _this6.props.isBodyShop) {
	            discountIndexRental = _this6.getDiscountSetIndex(_this6.state.price, true);
	            currentDiscountRental = _this6.state.price.CustomerDiscounts.Discounts[discountIndexRental];
	          }
	
	          // splice data for rendering
	          var itemsToRender = _extends({}, currentDiscount);
	          if (currentDiscountRental) {
	            Object.keys(currentDiscountRental).map(function (k) {
	              itemsToRender[k + '-Rental'] = currentDiscountRental[k];
	            });
	          }
	
	          var onChangeAmount = function onChangeAmount(e) {
	            var amount = e.target.value;
	            var name = e.target.name;
	            if (name.endsWith('-Rental')) {
	              currentDiscountRental[name.substring(0, name.length - 7)] = amount;
	            } else {
	              currentDiscount[name] = amount;
	            }
	            var update = _extends({}, _this6.state.price);
	            update.CustomerDiscounts.Discounts[discountIndex] = currentDiscount;
	            if (currentDiscountRental) {
	              update.CustomerDiscounts.Discounts[discountIndexRental] = currentDiscountRental;
	            }
	            _this6.setState({
	              price: update
	            });
	          };
	
	          var onAmountBlur = function onAmountBlur(e) {
	            var amount = e.value;
	            var name = e.name;
	            if (isNaN(amount)) {
	              // Toastr
	              window.toastr.error((0, _helpers.translation)('15159'), (0, _helpers.translation)('216'));
	            } else if (amount < 0 || amount > 99.99) {
	              // Toastr
	              window.toastr.error((0, _helpers.translation)('15158'), (0, _helpers.translation)('216'));
	            } else {
	              if (name.endsWith('-Rental')) {
	                currentDiscountRental[name.substring(0, name.length - 7)] = amount;
	              } else {
	                currentDiscount[name] = amount;
	              }
	              var update = _extends({}, _this6.state.price);
	              update.CustomerDiscounts.Discounts[discountIndex] = currentDiscount;
	              if (currentDiscountRental) {
	                update.CustomerDiscounts.Discounts[discountIndexRental] = currentDiscountRental;
	              }
	              _this6.setState({
	                price: update
	              }, function () {
	                _this6.updateDiscounts();
	              });
	            }
	          };
	
	          var renderFields = function renderFields(label, name1, name2) {
	            var renderField = function renderField(name) {
	              return _react2.default.createElement(_DecimalInput2.default, {
	                name: name,
	                value: itemsToRender[name],
	                onChange: onChangeAmount,
	                onBlur: onAmountBlur,
	                size: 'm'
	              });
	            };
	            var cols = name2 ? ['40%', '1fr', '1fr'] : ['1fr', '1fr'];
	            return _react2.default.createElement(
	              _grid2.default,
	              { align: 'center', spacing: 1, key: name1, cols: cols },
	              _react2.default.createElement(
	                'span',
	                null,
	                label
	              ),
	              name1 && renderField(name1),
	              name2 && renderField(name2)
	            );
	          };
	
	          if (_this6.props.isBodyShop) {
	            if (_this6.props.hasKickback && currentDiscount.OrderType === 1 && currentDiscount.IsAddonPrice !== true) {
	              return [renderFields((0, _helpers.translation)('416'), 'Salary', 'Salary-Rental'), renderFields((0, _helpers.translation)('637'), 'SpareParts', 'SpareParts-Rental'), renderFields((0, _helpers.translation)('15154'), 'Misc', 'Misc-Rental'), renderFields((0, _helpers.translation)('660'), 'Paint', 'Paint-Rental'), renderFields((0, _helpers.translation)('15155'), 'PaintMaterialsEnv', 'PaintMaterialsEnv-Rental'), renderFields((0, _helpers.translation)('15156'), 'SalaryEnv', 'SalaryEnv-Rental'), renderFields((0, _helpers.translation)('15214'), 'Deduction', 'Deduction-Rental')];
	            } else {
	              return [renderFields((0, _helpers.translation)('416'), 'Salary'), renderFields((0, _helpers.translation)('637'), 'SpareParts'), renderFields((0, _helpers.translation)('15154'), 'Misc'), renderFields((0, _helpers.translation)('660'), 'Paint'), renderFields((0, _helpers.translation)('15155'), 'PaintMaterialsEnv'), renderFields((0, _helpers.translation)('15156'), 'SalaryEnv'), currentDiscount.OrderType === 1 && currentDiscount.IsAddonPrice !== true && renderFields((0, _helpers.translation)('15214'), 'Deduction')];
	            }
	          } else {
	            return [renderFields((0, _helpers.translation)('548'), 'Amount'), renderFields((0, _helpers.translation)('13379'), 'Environment')];
	          }
	        };
	
	        var renderHeadings = function renderHeadings(isKickback) {
	          var amountText = '1295';
	          var amountText2 = null;
	
	          // Bodyshop discounts
	          var headingText = '';
	
	          if (_this6.props.type === 'Addon') {
	            // Addon
	            headingText = (0, _helpers.translation)('1396');
	          } else {
	            if (parseInt(_this6.props.type) === 1) {
	              // Insurance claim
	              headingText = (0, _helpers.translation)('70');
	              if (isKickback === true) {
	                amountText = '18391'; // without rental car
	                amountText2 = '18390'; // with rental car
	                // amountText = '14904'
	                // amountText2 = '18390'
	              }
	            } else {
	              headingText = (0, _helpers.translation)((0, _helpers.enumtranslate)('OrderTypes', parseInt(_this6.props.type)));
	            }
	          }
	
	          if (isKickback === true && _this6.props.isBodyShop === false) {
	            amountText = '14904';
	          }
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: amountText2 ? ['40%', '1fr', '1fr'] : ['1fr', '1fr'], align: 'center', spacing: 1 },
	            _react2.default.createElement(
	              'span',
	              null,
	              headingText
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(amountText)
	            ),
	            amountText2 && _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(amountText2)
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _this6.props.hasKickback ? renderHeadings(true) : renderHeadings(false),
	          renderBodyDiscountFields()
	        );
	      };
	
	      var isReturnCommission = this.props.hasKickback && parseInt(this.props.type) === 1;
	      var titleText = (0, _helpers.translation)('1197');
	      if (isReturnCommission) {
	        titleText = (0, _helpers.translation)('14898');
	      }
	
	      var helpText = '';
	      switch (this.props.auth.departmentType) {
	        case 0:
	          helpText = (0, _helpers.translation)('15026') + ' ' + (0, _helpers.translation)('15037');
	          break;
	        case 1:
	          helpText = isReturnCommission ? (0, _helpers.translation)('15212') : (0, _helpers.translation)('15036');
	          break;
	        case 2:
	          helpText = (0, _helpers.translation)('15026') + ' ' + (0, _helpers.translation)('15037');
	          break;
	      }
	
	      var priceCalculationType = function priceCalculationType() {
	        if (_this6.props.auth.departmentType !== 0 || _this6.state.customerId <= 0) return null;
	        var index = _this6.state.price.CustomerDiscounts.Discounts.findIndex(function (x) {
	          return x.OrderType === 1;
	        });
	        if (index === -1) return null;
	
	        var onChange = function onChange(_ref3, save) {
	          var _ref3$target = _ref3.target,
	              name = _ref3$target.name,
	              value = _ref3$target.value,
	              checked = _ref3$target.checked;
	
	          if (name === 'PriceCalculationType') value = parseInt(value);
	
	          var price = _extends({}, _this6.state.price);
	          price.CustomerDiscounts.Discounts[index][name] = value;
	          _this6.setState({ price: price }, function () {
	            return save && onBlur();
	          }); // If check mark / radio button, save
	        };
	
	        var onBlur = function onBlur() {
	          var price = _extends({}, _this6.state.price);
	          price.CustomerDiscounts.Discounts[index].PriceHourly = (0, _currency.reverseFormatCurrency2)(price.CustomerDiscounts.Discounts[index].PriceHourly);
	          _this6.setState({ price: price }, function () {
	            return _this6.updateDiscounts();
	          });
	        };
	
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(_PriceCalculationType2.default, { item: _this6.state.price.CustomerDiscounts.Discounts[index], onChange: onChange, onBlur: onBlur })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { span: '3' },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: titleText, helpText: helpText },
	            renderDiscounts()
	          )
	        ),
	        parseInt(this.props.type) === 1 ? priceCalculationType() : null
	      );
	    }
	  }]);
	
	  return Discounts;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceList: _priceModel.getPriceList,
	  updatePriceList: _priceModel.updatePriceList
	})(Discounts);

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createConfigContext = createConfigContext;
	exports.getEstimationTaskConfig = getEstimationTaskConfig;
	exports.getEstimationExtraConfig = getEstimationExtraConfig;
	exports.getStartTimeConfig = getStartTimeConfig;
	exports.getRefinishTypeConfig = getRefinishTypeConfig;
	exports.getHourPriceConfig = getHourPriceConfig;
	exports.getMaterialsShareConfig = getMaterialsShareConfig;
	exports.getExtentConfig = getExtentConfig;
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createConfigContext(auth, price) {
	  return {
	    isCustomerList: price.CustomerId > 0,
	    isShopList: price.CustomerId === 0 && price.ShopId > 0,
	    isChainList: price.CustomerId === 0 && price.ShopId === 0 && price.ChainId > 0,
	    isCustomerUser: auth.user.UserType === 4,
	    isShopUser: auth.user.UserType === 5 || auth.user.UserType === 3 || auth.user.UserType === 7,
	    isChainUser: auth.user.UserType === 2,
	    isWorkProviderUser: auth.user.UserType === 6,
	    isSuperUser: auth.user.UserType === 1,
	    department: price.Department,
	    useRecommended: price.UseRecommended,
	    onlyShow: (auth.user.UserType === 1 || auth.user.UserType === 6) && price.UseRecommended
	  };
	}
	
	function getEstimationTaskConfig(context) {
	  var state = _store2.default.getState();
	  var editable = !context.isCustomerUser && !context.useRecommended && state.common.activeCustomer.IsPerformingCustomer !== true;
	  return {
	    itemIdField: 'EstimationTaskId',
	    itemOrderField: 'SortIndex',
	    editable: editable,
	    whitebox: false,
	    draggable: true,
	    title: null,
	    groupCss: 'parts__list1',
	    itemCss: '',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'TaskName',
	      header: 13348,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'name'
	    }],
	    newItemInputs: ['TaskName'],
	    groupField: 'PartItemId'
	  };
	}
	
	function getEstimationExtraConfig(context) {
	  var state = _store2.default.getState();
	  var editable = !context.isCustomerUser && !context.useRecommended && state.common.activeCustomer.IsPerformingCustomer !== true;
	  return {
	    itemIdField: 'EstimationExtraId',
	    itemOrderField: 'SortIndex',
	    editable: editable,
	    whitebox: false,
	    draggable: true,
	    title: null,
	    groupCss: 'parts__list2',
	    itemCss: '',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Name',
	      header: 13374,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'name',
	      col: 3
	    }, {
	      name: 'AE',
	      header: 885,
	      type: 'ae',
	      editable: true,
	      hide: false,
	      css: 'ae'
	    }, {
	      name: 'Material',
	      header: 13443,
	      type: 'currency',
	      editable: true,
	      hide: false,
	      css: 'mat'
	    }],
	    newItemInputs: ['Name', 'AE', 'Material'],
	    groupField: 'PartItemId'
	  };
	}
	
	function getStartTimeConfig(context) {
	  var state = _store2.default.getState();
	  var editable = !context.isCustomerUser && !context.useRecommended && state.common.activeCustomer.IsPerformingCustomer !== true;
	  return {
	    itemIdField: 'EstimationStartTimeId',
	    itemOrderField: 'SortIndex',
	    editable: editable,
	    whitebox: true,
	    draggable: true,
	    title: 1195,
	    groupCss: 'starttime__list',
	    itemCss: '',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Type',
	      header: 332,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'type',
	      col: 2
	    }, {
	      name: 'Ae',
	      header: 885,
	      type: 'ae',
	      editable: false,
	      hide: false,
	      css: 'ae'
	    }],
	    newItemInputs: ['Type', 'AE']
	  };
	}
	
	function getRefinishTypeConfig(context) {
	  var state = _store2.default.getState();
	  var editable = !context.isCustomerUser && !context.useRecommended && state.common.activeCustomer.IsPerformingCustomer !== true;
	  return {
	    itemIdField: 'EstimationRefinishTypeId',
	    itemOrderField: 'SortIndex',
	    editable: editable,
	    whitebox: true,
	    draggable: context.isChainList,
	    title: 1999,
	    groupCss: 'refinishtype__list',
	    itemCss: '',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Type',
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'type'
	    }],
	    newItemInputs: ['Type']
	  };
	}
	
	function getHourPriceConfig(context) {
	  var state = _store2.default.getState();
	  var editable = !context.isCustomerUser && !context.useRecommended && state.common.activeCustomer.IsPerformingCustomer !== true;
	  return {
	    itemIdField: 'EstimationHourPriceId',
	    itemOrderField: 'SortIndex',
	    editable: editable,
	    whitebox: true,
	    draggable: context.isChainList,
	    title: 1847,
	    groupCss: 'hourprices__list',
	    itemCss: '',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Price',
	      type: 'int',
	      editable: false,
	      hide: false,
	      css: 'price'
	    }],
	    newItemInputs: ['Price']
	  };
	}
	
	function getMaterialsShareConfig(context) {
	  var state = _store2.default.getState();
	  var editable = !context.isCustomerUser && !context.useRecommended && state.common.activeCustomer.IsPerformingCustomer !== true;
	  return {
	    itemIdField: 'EstimationMaterialsShareId',
	    itemOrderField: 'SortIndex',
	    editable: editable,
	    whitebox: true,
	    draggable: true,
	    title: 13483,
	    groupCss: 'materialsshare__list',
	    itemCss: '',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Share',
	      type: 'int',
	      editable: false,
	      hide: false,
	      css: 'share'
	    }],
	    newItemInputs: ['Share']
	  };
	}
	
	function getExtentConfig(context) {
	  var state = _store2.default.getState();
	  var editable = !context.isCustomerUser && !context.useRecommended && state.common.activeCustomer.IsPerformingCustomer !== true;
	  return {
	    itemIdField: 'PriceModelExtentId',
	    itemOrderField: 'SortIndex',
	    editable: editable,
	    whitebox: true,
	    draggable: true,
	    title: 2093,
	    groupCss: 'extent__list',
	    itemCss: '',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Type',
	      header: 332,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'type',
	      col: 2
	    }, {
	      name: 'Group',
	      header: 13446,
	      type: 'select',
	      options: [{ 1: '1' }, { 2: '2' }, { 3: '3' }, { 4: '4' }, { 5: '5' }],
	      editable: false,
	      hide: false,
	      css: 'group'
	    }],
	    newItemInputs: ['Type', 'Group']
	  };
	}

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _priceModel = __webpack_require__(75);
	
	var _config = __webpack_require__(942);
	
	__webpack_require__(1444);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _PriceItemGroup = __webpack_require__(228);
	
	var _PriceItemGroup2 = _interopRequireDefault(_PriceItemGroup);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableHeader = __webpack_require__(132);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableExpand = __webpack_require__(140);
	
	var _tableExpand2 = _interopRequireDefault(_tableExpand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Config
	
	
	// import styles
	
	
	// Utils
	// import { formatCurrency2, reverseFormatCurrency2 } from '../../../utils/currency'
	
	
	// import components
	
	
	var Estimation = function (_Component) {
	  _inherits(Estimation, _Component);
	
	  function Estimation(props) {
	    _classCallCheck(this, Estimation);
	
	    var _this = _possibleConstructorReturn(this, (Estimation.__proto__ || Object.getPrototypeOf(Estimation)).call(this, props));
	
	    _this.state = {
	      priceOriginal: {},
	      price: {},
	      parts: [],
	      IsWorking: false,
	      ConfirmShow: {
	        UseRecommended: false
	      }
	    };
	    _this.AERounding = 5;
	    _this.switchRecommended = _this.switchRecommended.bind(_this);
	    _this.renderPartItem = _this.renderPartItem.bind(_this);
	    _this.deleteItem = _this.deleteItem.bind(_this);
	    _this.moveItem = _this.moveItem.bind(_this);
	    _this.updateOrAddItem = _this.updateOrAddItem.bind(_this);
	    _this.getItemIdField = _this.getItemIdField.bind(_this);
	    _this.getItemListName = _this.getItemListName.bind(_this);
	    return _this;
	  }
	
	  _createClass(Estimation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPriceList();
	    }
	  }, {
	    key: 'getPriceList',
	    value: function getPriceList() {
	      var _this2 = this;
	
	      this.props.getPriceList(this.props.item.PriceModelId).then(function (res) {
	        _this2.setState({
	          price: res.data,
	          priceOriginal: res.data
	        });
	        _this2.mapParts(res.data);
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this2.props.router.push('/prices');
	      });
	    }
	  }, {
	    key: 'shouldUpdatePrices',
	    value: function shouldUpdatePrices(val1, val2) {
	      return val1 !== val2;
	    }
	  }, {
	    key: 'updatePrices',
	    value: function updatePrices(price) {
	      var _this3 = this;
	
	      this.setState({ IsWorking: true });
	      return this.props.updatePriceList(price).then(function (res) {
	        _this3.setState({
	          price: res.data,
	          priceOriginal: res.data
	        });
	        _this3.mapParts(res.data);
	        _this3.setState({ IsWorking: false });
	        // Toastr
	        // window.toastr.success(translation('13444'), translation('13424'))
	        // Return
	        return res;
	      }, function (err) {
	        // Toastr
	        _this3.setState({ IsWorking: false });
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this3.props.router.push('/prices');
	        // Return
	        return err;
	      });
	    }
	  }, {
	    key: 'isInputValid',
	    value: function isInputValid(str) {
	      return !(!str || /^\s*$/.test(str));
	    }
	  }, {
	    key: 'onlyShow',
	    value: function onlyShow() {
	      if (this.state.price.UseRecommended) {
	        if ((0, _auth.hasAccess)([1], this.props.auth.user.UserType)) {
	          return false;
	        }
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'mapParts',
	    value: function mapParts(data) {
	      var newData = [];
	      // Parts
	      data.Parts.map(function (val, index) {
	        newData[val.PartItemId] = {
	          part: val,
	          tasks: [],
	          extras: []
	        };
	      });
	      // Tasks
	      data.EstimationTasks.map(function (val, index) {
	        newData[val.PartItemId].tasks.push(val);
	      });
	      // Extras
	      data.EstimationExtras.map(function (val, index) {
	        newData[val.PartItemId].extras.push(val);
	      });
	      this.setState({
	        parts: newData
	      });
	    }
	  }, {
	    key: 'deleteItem',
	    value: function deleteItem(item) {
	      item.IsDeleted = true;
	      this.updateOrAddItem(item);
	    }
	  }, {
	    key: 'moveItem',
	    value: function moveItem(item, newPosition) {
	      var _this4 = this;
	
	      if (item.SortIndex === undefined) return; // Need sort index to make reordering work.
	      var oldSortIndex = item.SortIndex;
	
	      var listName = this.getItemListName(item);
	      var idField = this.getItemIdField(item);
	      var price = _extends({}, this.state.price);
	      var hasPartId = item.PartItemId !== undefined;
	      var hasPartItem = item.PartItem !== undefined && item.PartItem.PartItemId !== undefined;
	      var list = price[listName];
	      item.SortIndex = newPosition;
	      this.props.reorderPriceListItem(item).then(function (res) {
	        var _loop = function _loop(i) {
	          var listItem = list.find(function (li) {
	            return li[idField] === res.data[i][idField];
	          });
	          if (listItem !== undefined) {
	            listItem.SortIndex = res.data[i].SortIndex;
	          }
	        };
	
	        // Assign sortindex from result to all items
	        for (var i = 0; i < res.data.length; i++) {
	          _loop(i);
	        }
	      }, function () {
	        // show error toast
	
	        // If reorder failed on server, revert to old position.
	        item.SortIndex = oldSortIndex;
	      }).finally(function () {
	        // Sort list containing item, to make sure the list and visual dom matches.
	        var sorter = function sorter(a, b) {
	          if (hasPartId) {
	            if (a.PartItemId !== b.PartItemId) return a.PartItemId - b.PartItemId;
	          } else if (hasPartItem) {
	            if (a.PartItem.PartItemId !== b.PartItem.PartItemId) return a.PartItem.PartItemId - b.PartItem.PartItemId;
	          }
	          return a.SortIndex - b.SortIndex;
	        };
	
	        if (list !== null) {
	          list = list.sort(function (a, b) {
	            return sorter(a, b);
	          });
	          price[listName] = list;
	          _this4.setState({
	            price: price
	          }, function () {
	            _this4.forceUpdate();
	          });
	        }
	      });
	    }
	  }, {
	    key: 'updateOrAddItem',
	    value: function updateOrAddItem(item) {
	      var doPost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var idField = this.getItemIdField(item);
	      var listName = this.getItemListName(item);
	      if (listName === null || idField === null) {
	        console.error('Could not update or add item!', item);
	        return;
	      }
	
	      // console.log('Updating item', item, 'adding to ', listName, '(id ' + item[idField] + ')')
	      var price = _extends({}, this.state.price);
	      var list = price[listName];
	      if (item[idField] > 0) {
	        for (var i; i < list.length; i++) {
	          var oldItem = list[i];
	          if (oldItem[idField] === item[idField]) {
	            list[i] = item;
	            break;
	          }
	        }
	      } else {
	        item[idField] = 0;
	        list.push(item);
	      }
	      price[listName] = list;
	
	      // Finally send to api.
	      if (doPost) {
	        this.updatePrices(price);
	      }
	    }
	  }, {
	    key: 'getItemIdField',
	    value: function getItemIdField(item) {
	      // Find id field
	      var idFields = [];
	      var fields = Object.keys(item);
	      for (var f in fields) {
	        var field = fields[f];
	        if (field.toLowerCase().endsWith('id')) {
	          idFields.push(field);
	        }
	      }
	
	      // Determine correct id field.
	      for (var _f in idFields) {
	        if (item[idFields[_f]] === undefined || item[idFields[_f]] === null || !(typeof item[idFields[_f]] === 'number')) continue;
	        switch (idFields[_f].toLowerCase()) {
	          case 'taskpriceid':
	          case 'bodytaskpriceid':
	          case 'estimationtaskid':
	          case 'estimationextraid':
	          case 'addonstarttimeid':
	          case 'addonpartid':
	          case 'estimationstarttimeid':
	          case 'estimationrefinishtypeid':
	          case 'estimationhourpriceid':
	          case 'estimationmaterialsshareid':
	          case 'pricemodelextentid':
	            return idFields[_f];
	        }
	      }
	      console.error('Could not determine Id field of item!', item);
	      return null;
	    }
	  }, {
	    key: 'getItemListName',
	    value: function getItemListName(item) {
	      // Find id field
	      var idFields = [];
	      var fields = Object.keys(item);
	      for (var f in fields) {
	        var field = fields[f];
	        if (field.toLowerCase().endsWith('id')) {
	          idFields.push(field);
	        }
	      }
	      // Determine correct id field.
	      for (var _f2 in idFields) {
	        if (item[idFields[_f2]] === undefined || item[idFields[_f2]] === null || !(typeof item[idFields[_f2]] === 'number')) continue;
	        switch (idFields[_f2].toLowerCase()) {
	          case 'taskpriceid':
	            return 'TaskPrices';
	          case 'bodytaskpriceid':
	            return 'BodyTaskPrices';
	          case 'estimationtaskid':
	            return 'EstimationTasks';
	          case 'addonstarttimeid':
	            return 'AddonStartTimes';
	          case 'addonpartid':
	            return 'AddonParts';
	          case 'estimationstarttimeid':
	            return 'EstimationStartTimes';
	          case 'estimationextraid':
	            return 'EstimationExtras';
	          case 'estimationrefinishtypeid':
	            return 'EstimationRefinishTypes';
	          case 'estimationhourpriceid':
	            return 'EstimationHourPrices';
	          case 'estimationmaterialsshareid':
	            return 'EstimationMaterialsShares';
	          case 'pricemodelextentid':
	            return 'PriceModelExtents';
	        }
	      }
	
	      console.error('Could not determine List name of item!', item);
	      return null;
	    }
	  }, {
	    key: 'renderExtents',
	    value: function renderExtents() {
	      var price = this.state.price;
	
	      var config = (0, _config.getExtentConfig)((0, _config.createConfigContext)(this.props.auth, price));
	
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        config: config,
	        items: price.PriceModelExtents,
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking });
	    }
	  }, {
	    key: 'switchRecommended',
	    value: function switchRecommended(e) {
	      var value = e.target.checked;
	      var price = _extends({}, this.state.price);
	      price.UseRecommended = value;
	      this.setState({ price: price });
	      if (value === true) {
	        this.ToggleConfirmShow('UseRecommended', true);
	      } else {
	        this.updatePrices(price);
	      }
	    }
	  }, {
	    key: 'renderRecommendedSelector',
	    value: function renderRecommendedSelector() {
	      var _this5 = this;
	
	      if (!(0, _auth.hasAccess)([3, 4, 7], this.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) && !this.props.customer) return null;
	      if (parseInt(this.props.auth.user.ShopId, 10) !== this.state.price.ShopId) return null;
	      // Recommended text
	      var recommendedText = function recommendedText() {
	        var translationText = (0, _helpers.translation)('13474');
	        if (_this5.props.customer) {
	          return translationText.replace('[NAME]', _this5.props.auth.user.ShopName);
	        }
	        return translationText.replace('[NAME]', _this5.props.auth.user.ChainName);
	      };
	      var disabled = this.props.activeCustomer.IsPerformingCustomer === true;
	      // Return
	      return _react2.default.createElement(
	        _inline2.default,
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          recommendedText()
	        ),
	        _react2.default.createElement(_switch2.default, { name: 'UseRecommended', onChange: this.switchRecommended, checked: this.state.price.UseRecommended, disabled: disabled })
	      );
	    }
	  }, {
	    key: 'renderPartItem',
	    value: function renderPartItem(val, key) {
	      var context = (0, _config.createConfigContext)(this.props.auth, this.state.price);
	      var taskConfig = (0, _config.getEstimationTaskConfig)(context);
	      var extraConfig = (0, _config.getEstimationExtraConfig)(context);
	
	      // Return
	      return _react2.default.createElement(
	        _tableContainer2.default,
	        { fullWidth: true, key: key },
	        _react2.default.createElement(
	          _tableExpand2.default,
	          null,
	          _react2.default.createElement(
	            _tableHeader2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(val.part.DictionaryKey)
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(_PriceItemGroup2.default, {
	              config: taskConfig,
	              items: val.tasks,
	              groupId: val.part.PartItemId,
	              onAdd: this.updateOrAddItem,
	              onDelete: this.deleteItem,
	              onUpdate: this.updateOrAddItem,
	              onDragged: this.moveItem,
	              disabled: this.state.IsWorking
	            })
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(_PriceItemGroup2.default, {
	              config: extraConfig,
	              items: val.extras,
	              itemClass: 'partItem',
	              groupId: val.part.PartItemId,
	              onAdd: this.updateOrAddItem,
	              onDelete: this.deleteItem,
	              onUpdate: this.updateOrAddItem,
	              onDragged: this.moveItem,
	              disabled: this.state.IsWorking
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderStartTime',
	    value: function renderStartTime() {
	      var price = this.state.price;
	
	      var config = (0, _config.getStartTimeConfig)((0, _config.createConfigContext)(this.props.auth, price));
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        config: config,
	        items: price.EstimationStartTimes,
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking });
	    }
	  }, {
	    key: 'renderRefinishType',
	    value: function renderRefinishType() {
	      var price = this.state.price;
	
	      var config = (0, _config.getRefinishTypeConfig)((0, _config.createConfigContext)(this.props.auth, price));
	
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        config: config,
	        items: price.EstimationRefinishTypes,
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking });
	    }
	  }, {
	    key: 'renderHourlyPrices',
	    value: function renderHourlyPrices() {
	      var price = this.state.price;
	
	      var config = (0, _config.getHourPriceConfig)((0, _config.createConfigContext)(this.props.auth, price));
	
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        config: config,
	        items: price.EstimationHourPrices,
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking });
	    }
	  }, {
	    key: 'renderMaterialsShare',
	    value: function renderMaterialsShare() {
	      var price = this.state.price;
	
	      var config = (0, _config.getMaterialsShareConfig)((0, _config.createConfigContext)(this.props.auth, price));
	
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        config: config,
	        items: price.EstimationMaterialsShares,
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking });
	    }
	  }, {
	    key: 'ToggleConfirmShow',
	    value: function ToggleConfirmShow(id, value) {
	      var currentVal = this.state.ConfirmShow[id];
	      if (currentVal === undefined) currentVal = false;
	      var confirmState = this.state.ConfirmShow;
	      confirmState[id] = value !== undefined && value !== null ? value : !currentVal;
	      this.setState({ ConfirmShow: confirmState });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var renderConfirmRecommendedSetting = function renderConfirmRecommendedSetting() {
	        var confirm = function confirm() {
	          _this6.ToggleConfirmShow('UseRecommended', false);
	          // update
	          _this6.updatePrices(_this6.state.price);
	        };
	
	        var notConfirm = function notConfirm() {
	          _this6.ToggleConfirmShow('UseRecommended', false);
	          // set radio back
	          var price = _this6.state.price;
	          price.UseRecommended = false;
	          _this6.setState({ price: price });
	        };
	
	        var confirmText = _this6.props.customer ? (0, _helpers.translation)('13010').replace('{0}', '') : (0, _helpers.translation)('13010').replace('{0}', _this6.props.auth.user.ChainName);
	        return _this6.state.ConfirmShow.UseRecommended && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: _this6.ToggleConfirmShow.bind(_this6, 'UseRecommended', false) },
	          _react2.default.createElement(_Confirm2.default, { renderText: function renderText() {
	              return confirmText;
	            }, confirm: confirm.bind(_this6), notConfirm: notConfirm.bind(_this6) })
	        );
	      };
	
	      if (Object.keys(this.state.price).length === 0) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'estimation__screen' },
	        this.renderRecommendedSelector(),
	        _react2.default.createElement(
	          'div',
	          { className: 'row clearfix' },
	          _react2.default.createElement(
	            _col2.default,
	            { span: '2' },
	            this.renderStartTime(),
	            this.renderRefinishType(),
	            this.renderHourlyPrices(),
	            this.renderMaterialsShare(),
	            this.renderExtents()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            { span: '4' },
	            this.state.parts.map(this.renderPartItem)
	          )
	        ),
	        renderConfirmRecommendedSetting()
	      );
	    }
	  }]);
	
	  return Estimation;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers,
	    activeCustomer: state.common.activeCustomer
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceList: _priceModel.getPriceList,
	  updatePriceList: _priceModel.updatePriceList,
	  reorderPriceListItem: _priceModel.reorderPriceListItem
	})(Estimation);

/***/ }),
/* 944 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createConfigContext = createConfigContext;
	exports.getServicesConfig = getServicesConfig;
	exports.getExtrasConfig = getExtrasConfig;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function createConfigContext(auth, price) {
	  return {
	    isCustomerList: price.CustomerId > 0,
	    isShopList: price.CustomerId === 0 && price.ShopId > 0,
	    isChainList: price.CustomerId === 0 && price.ShopId === 0 && price.ChainId > 0,
	    isCustomerUser: auth.user.UserType === 4,
	    isShopUser: auth.user.UserType === 5 || auth.user.UserType === 3 || auth.user.UserType === 7,
	    isChainUser: auth.user.UserType === 2,
	    isWorkProviderUser: auth.user.UserType === 6,
	    isSuperUser: auth.user.UserType === 1,
	    department: price.Department,
	    useRecommended: price.UseRecommended,
	    onlyShow: (auth.user.UserType === 1 || auth.user.UserType === 6) && price.UseRecommended
	  };
	}
	
	function getServicesConfig(context) {
	  return {
	    itemIdField: 'ServiceTaskId',
	    itemOrderField: 'SortIndex',
	    editable: true, // context.isCustomerUser && !context.useRecommended,
	    whitebox: true,
	    draggable: true,
	    title: 13375,
	    titleHelp: context.isCustomerUser ? 1942 : undefined,
	    groupCss: null,
	    allowAdd: true,
	    allowDelete: true,
	    groupField: 'IsExtra',
	    fields: [{
	      name: 'Name',
	      header: 1203,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'taskName',
	      col: 3
	    }, {
	      name: 'Price',
	      header: 641,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: 'price'
	    }, {
	      name: 'Discount',
	      type: 'percent',
	      editable: false,
	      hide: true,
	      css: 'discount'
	    }, {
	      name: 'Net',
	      type: 'currency',
	      editable: false,
	      hide: true,
	      css: 'net'
	    }],
	    newItemInputs: ['Name', 'Price']
	  };
	}
	
	function getExtrasConfig(context) {
	  return {
	    itemIdField: 'ServiceTaskId',
	    itemOrderField: 'SortIndex',
	    editable: !context.isCustomerUser && !context.useRecommended,
	    whitebox: true,
	    draggable: true,
	    title: 2224,
	    titleHelp: context.isCustomerUser ? 1942 : undefined,
	    groupCss: null,
	    allowAdd: true,
	    allowDelete: true,
	    groupField: 'IsExtra',
	    fields: [{
	      name: 'Name',
	      header: context.isCustomerList ? 1203 : undefined,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'taskName' + (context.isCustomerList && context.department !== 1 ? 'Customer' : ''),
	      col: 3
	    }, {
	      name: 'Price',
	      header: context.isCustomerList ? 641 : undefined,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: 'price' + (context.isCustomerList && context.department !== 1 ? 'Customer' : '')
	    }].concat(_toConsumableArray(context.department === 0 && [{
	      name: 'Discount',
	      header: context.isCustomerList ? 1199 : undefined,
	      type: 'percent',
	      editable: true,
	      hide: !context.isCustomerList,
	      css: 'discount' + (context.isCustomerList ? 'Customer' : '')
	    }, {
	      name: 'Net',
	      header: context.isCustomerList ? 1305 : undefined,
	      type: 'currency',
	      editable: true,
	      hide: !context.isCustomerList,
	      css: 'net' + (context.isCustomerList ? 'Customer' : '')
	    }])),
	    newItemInputs: context.isCustomerList ? ['Name', 'Price', 'Discount', 'Net'] : ['Name', 'Price']
	  };
	}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _priceModel = __webpack_require__(75);
	
	__webpack_require__(1445);
	
	var _auth = __webpack_require__(8);
	
	var _config = __webpack_require__(944);
	
	var _helpers = __webpack_require__(2);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _PriceItemGroup = __webpack_require__(228);
	
	var _PriceItemGroup2 = _interopRequireDefault(_PriceItemGroup);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	
	var Extras = function (_Component) {
	  _inherits(Extras, _Component);
	
	  function Extras(props) {
	    _classCallCheck(this, Extras);
	
	    var _this = _possibleConstructorReturn(this, (Extras.__proto__ || Object.getPrototypeOf(Extras)).call(this, props));
	
	    _this.state = {
	      price: {},
	      ConfirmShow: {
	        UseRecommended: false
	      },
	      isBodyShop: false
	    };
	    _this.switchRecommended = _this.switchRecommended.bind(_this);
	    _this.loadPriceModel = _this.loadPriceModel.bind(_this);
	    _this.moveItem = _this.moveItem.bind(_this);
	    _this.getItemListName = _this.getItemListName.bind(_this);
	    _this.getItemIdField = _this.getItemIdField.bind(_this);
	    _this.updateOrAddItem = _this.updateOrAddItem.bind(_this);
	    _this.deleteItem = _this.deleteItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Extras, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadPriceModel(this.props);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.props.item.PriceModelId !== nextProps.item.PriceModelId) {
	        this.loadPriceModel(nextProps);
	      }
	    }
	  }, {
	    key: 'loadPriceModel',
	    value: function loadPriceModel(props) {
	      var _this2 = this;
	
	      this.setState({
	        price: {},
	        ConfirmShow: {
	          UseRecommended: false
	        }
	      }, function () {
	        _this2.props.getPriceList(props.item.PriceModelId).then(function (res) {
	          _this2.setState({
	            price: res.data,
	            isBodyShop: res.data.Department === 1
	          });
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	          _this2.props.router.push('/prices');
	        });
	      });
	    }
	  }, {
	    key: 'deleteItem',
	    value: function deleteItem(item) {
	      item.IsDeleted = true;
	      this.updateOrAddItem(item);
	    }
	  }, {
	    key: 'moveItem',
	    value: function moveItem(item, newPosition) {
	      var _this3 = this;
	
	      if (item.SortIndex === undefined) return; // Need sort index to make reordering work.
	      var oldSortIndex = item.SortIndex;
	
	      var listName = this.getItemListName(item);
	      var idField = this.getItemIdField(item);
	      var price = _extends({}, this.state.price);
	      var hasPartId = item.PartItemId !== undefined;
	      var hasPartItem = item.PartItem !== undefined && item.PartItem.PartItemId !== undefined;
	      var list = price[listName];
	      item.SortIndex = newPosition;
	      this.setState({ IsWorking: true });
	      this.props.reorderPriceListItem(item).then(function (res) {
	        var _loop = function _loop(i) {
	          var listItem = list.find(function (li) {
	            return li[idField] === res.data[i][idField];
	          });
	          if (listItem !== undefined) {
	            listItem.SortIndex = res.data[i].SortIndex;
	          }
	        };
	
	        // Assign sortindex from result to all items
	        for (var i = 0; i < res.data.length; i++) {
	          _loop(i);
	        }
	      }, function () {
	        // If reorder failed on server, revert to old position.
	        item.SortIndex = oldSortIndex;
	
	        // show error toast
	      }).finally(function () {
	        // Sort list containing item, to make sure the list and visual dom matches.
	        var sorter = function sorter(a, b) {
	          if (hasPartId) {
	            if (a.PartItemId !== b.PartItemId) return a.PartItemId - b.PartItemId;
	          } else if (hasPartItem) {
	            if (a.PartItem.PartItemId !== b.PartItem.PartItemId) return a.PartItem.PartItemId - b.PartItem.PartItemId;
	          }
	          return a.SortIndex - b.SortIndex;
	        };
	
	        if (list !== null) {
	          list = list.sort(function (a, b) {
	            return sorter(a, b);
	          });
	          price[listName] = list;
	          _this3.setState({
	            price: price,
	            IsWorking: false
	          });
	          // console.log('updated list', list.filter((a) => a.SortIndex !== null).map(i => { return { Id: i[this.getItemIdField(i)], TaskName: i.TaskName, SortIndex: i.SortIndex, PartItemId: (hasPartId ? i.PartItemId : i.PartItem.PartItemId) } }))
	        }
	      });
	    }
	  }, {
	    key: 'updateOrAddItem',
	    value: function updateOrAddItem(item) {
	      var doPost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var idField = this.getItemIdField(item);
	      var listName = this.getItemListName(item);
	      if (listName === null || idField === null) {
	        console.error('Could not update or add item!', item);
	        return;
	      }
	
	      // console.log('Updating item', item, 'adding to ', listName, '(id ' + item[idField] + ')')
	      var price = _extends({}, this.state.price);
	      var list = price[listName];
	      if (item[idField] > 0) {
	        for (var i; i < list.length; i++) {
	          var oldItem = list[i];
	          if (oldItem[idField] === item[idField]) {
	            list[i] = item;
	            // updated = true
	            break;
	          }
	        }
	      } else {
	        item[idField] = 0;
	        list.push(item);
	      }
	      price[listName] = list;
	
	      // Finally send to api.
	      if (doPost) {
	        this.updatePrices(price);
	      }
	    }
	  }, {
	    key: 'getItemIdField',
	    value: function getItemIdField(item) {
	      // Find id field
	      var idFields = [];
	      var fields = Object.keys(item);
	      for (var f in fields) {
	        var field = fields[f];
	        if (field.toLowerCase().endsWith('id')) {
	          idFields.push(field);
	        }
	      }
	
	      // Determine correct id field.
	      for (var _f in idFields) {
	        if (item[idFields[_f]] === undefined || item[idFields[_f]] === null || !(typeof item[idFields[_f]] === 'number')) continue;
	        switch (idFields[_f].toLowerCase()) {
	          case 'servicetaskid':
	            return idFields[_f];
	        }
	      }
	      console.error('Could not determine Id field of item!', item);
	      return null;
	    }
	  }, {
	    key: 'getItemListName',
	    value: function getItemListName(item) {
	      // Find id field
	      var idFields = [];
	      var fields = Object.keys(item);
	      for (var f in fields) {
	        var field = fields[f];
	        if (field.toLowerCase().endsWith('id')) {
	          idFields.push(field);
	        }
	      }
	      // console.log('getItemListName id fields', idFields)
	      // Determine correct id field.
	      for (var _f2 in idFields) {
	        if (item[idFields[_f2]] === undefined || item[idFields[_f2]] === null || !(typeof item[idFields[_f2]] === 'number')) continue;
	        switch (idFields[_f2].toLowerCase()) {
	          case 'servicetaskid':
	            return 'ServiceTasks';
	        }
	      }
	
	      console.error('Could not determine List name of item!', item);
	      return null;
	    }
	  }, {
	    key: 'updatePrices',
	    value: function updatePrices(price) {
	      var _this4 = this;
	
	      this.setState({ IsWorking: true });
	      this.props.updatePriceList(price).then(function (res) {
	        _this4.setState({
	          price: res.data,
	          IsWorking: false
	        });
	        // Toastr
	        // window.toastr.success(translation('13444'), translation('13424'))
	      }, function () {
	        // Toastr
	        _this4.setState({ IsWorking: false });
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this4.props.router.push('/prices');
	      });
	    }
	  }, {
	    key: 'onlyShow',
	    value: function onlyShow() {
	      if (this.state.price.UseRecommended) {
	        if ((0, _auth.hasAccess)([1, 4], this.props.auth.user.UserType)) {
	          return false;
	        }
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'switchRecommended',
	    value: function switchRecommended(e) {
	      var value = e.target.checked;
	      var price = _extends({}, this.state.price);
	      price.UseRecommended = value;
	      this.setState({ price: price });
	      if (value === true) {
	        this.ToggleConfirmShow('UseRecommended', true);
	      } else {
	        this.updatePrices(price);
	      }
	    }
	  }, {
	    key: 'renderRecommendedSelector',
	    value: function renderRecommendedSelector() {
	      var _this5 = this;
	
	      if (!(0, _auth.hasAccess)([3, 7], this.props.auth.user.UserType) || !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0) && !this.props.customer) return null;
	      if (parseInt(this.props.auth.user.ShopId, 10) !== this.state.price.ShopId) return null;
	      // Recommended text
	      var recommendedText = function recommendedText() {
	        var translationText = (0, _helpers.translation)('13474');
	        console.log('[Extras] recommendedText', _this5.props);
	        if (_this5.props.customer) {
	          return translationText.replace('[NAME]', _this5.props.auth.user.ShopName);
	        }
	        return translationText.replace('[NAME]', _this5.props.auth.user.ChainName);
	      };
	
	      // Return
	      return _react2.default.createElement(
	        _inline2.default,
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          recommendedText()
	        ),
	        _react2.default.createElement(_switch2.default, { name: 'UseRecommended', onChange: this.switchRecommended, checked: this.state.price.UseRecommended })
	      );
	    }
	  }, {
	    key: 'ToggleConfirmShow',
	    value: function ToggleConfirmShow(id, value) {
	      var currentVal = this.state.ConfirmShow[id];
	      if (currentVal === undefined) currentVal = false;
	      var confirmState = this.state.ConfirmShow;
	      confirmState[id] = value !== undefined && value !== null ? value : !currentVal;
	      this.setState({ ConfirmShow: confirmState });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      // Test comment
	      var renderConfirmRecommendedSetting = function renderConfirmRecommendedSetting() {
	        var confirm = function confirm() {
	          _this6.ToggleConfirmShow('UseRecommended', false);
	          // update
	          _this6.updatePrices(_this6.state.price);
	        };
	
	        var notConfirm = function notConfirm() {
	          _this6.ToggleConfirmShow('UseRecommended', false);
	          // set radio back
	          var price = _this6.state.price;
	          price.UseRecommended = false;
	          _this6.setState({ price: price });
	        };
	
	        var confirmText = _this6.props.customer ? (0, _helpers.translation)('13010').replace('{0}', '') : (0, _helpers.translation)('13010').replace('{0}', _this6.props.auth.user.ChainName);
	        return _this6.state.ConfirmShow.UseRecommended && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: _this6.ToggleConfirmShow.bind(_this6, 'UseRecommended', false) },
	          _react2.default.createElement(_Confirm2.default, { renderText: function renderText() {
	              return confirmText;
	            }, confirm: confirm.bind(_this6), notConfirm: notConfirm.bind(_this6) })
	        );
	      };
	
	      if (Object.keys(this.state.price).length === 0) return null;
	      var price = this.state.price;
	
	      var currentUserIsCustomer = this.props.auth.user.UserType === 4;
	      var showExtras = this.props.showExtras !== undefined ? this.props.showExtras : true;
	      var showServices = this.props.showServices !== undefined ? this.props.showServices : true;
	      var isOnlyPaint = this.props.auth.departmentType === 0;
	
	      var renderServices = function renderServices() {
	        var items = price.ServiceTasks.filter(function (x) {
	          return !x.IsExtra;
	        });
	        return _react2.default.createElement(_PriceItemGroup2.default, {
	          items: items,
	          itemClass: 'extras',
	          config: (0, _config.getServicesConfig)((0, _config.createConfigContext)(_this6.props.auth, _this6.state.price)),
	          onAdd: _this6.updateOrAddItem,
	          onDelete: _this6.deleteItem,
	          onUpdate: _this6.updateOrAddItem,
	          onDragged: _this6.moveItem,
	          disabled: _this6.state.IsWorking,
	          groupId: false });
	      };
	
	      var renderExtras = function renderExtras() {
	        var items = price.ServiceTasks.filter(function (x) {
	          return x.IsExtra;
	        });
	        return _react2.default.createElement(_PriceItemGroup2.default, {
	          items: items,
	          itemClass: 'extras',
	          config: (0, _config.getExtrasConfig)((0, _config.createConfigContext)(_this6.props.auth, _this6.state.price)),
	          onAdd: _this6.updateOrAddItem,
	          onDelete: _this6.deleteItem,
	          onUpdate: _this6.updateOrAddItem,
	          onDragged: _this6.moveItem,
	          disabled: _this6.state.IsWorking,
	          groupId: true });
	      };
	
	      var renderExtrasShow = function renderExtrasShow() {
	        var items = price.ServiceTasks.filter(function (x) {
	          return x.IsExtra;
	        });
	        return _react2.default.createElement(_PriceItemGroup2.default, {
	          items: items,
	          itemClass: 'extras',
	          config: (0, _config.getExtrasConfig)((0, _config.createConfigContext)(_this6.props.auth, _this6.state.price)),
	          onAdd: _this6.updateOrAddItem,
	          onDelete: _this6.deleteItem,
	          onUpdate: _this6.updateOrAddItem,
	          onDragged: _this6.moveItem,
	          disabled: _this6.state.IsWorking,
	          groupId: true });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'extras__screen' },
	        _react2.default.createElement(
	          _col2.default,
	          { span: '3' },
	          this.renderRecommendedSelector(),
	          isOnlyPaint && currentUserIsCustomer && showServices && renderServices(),
	          !currentUserIsCustomer && showExtras && renderExtras(),
	          currentUserIsCustomer && showExtras && renderExtrasShow(),
	          renderConfirmRecommendedSetting()
	        )
	      );
	    }
	  }]);
	
	  return Extras;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceList: _priceModel.getPriceList,
	  updatePriceList: _priceModel.updatePriceList,
	  reorderPriceListItem: _priceModel.reorderPriceListItem
	})(Extras);

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _currency = __webpack_require__(41);
	
	var _percent = __webpack_require__(178);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	__webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { hasAccess } from '../../../utils/auth'
	
	
	// Elements
	// import Grid from '../../../shared/elements/grid'
	
	// import Button from '../../../shared/elements/button'
	
	
	// import styles
	
	
	var PriceItem = function (_Component) {
	  _inherits(PriceItem, _Component);
	
	  function PriceItem(props) {
	    _classCallCheck(this, PriceItem);
	
	    var _this = _possibleConstructorReturn(this, (PriceItem.__proto__ || Object.getPrototypeOf(PriceItem)).call(this, props));
	
	    _this.state = {
	      config: { // Example data - will be overwritten by config used in containing PriceItemGroup
	        itemIdField: null,
	        draggable: true,
	        editable: true,
	        itemCss: 'item',
	        allowDelete: true,
	        fields: [],
	        newItemInputs: []
	      },
	      item: null
	    };
	    _this.renderField = _this.renderField.bind(_this);
	    _this.renderAdd = _this.renderAdd.bind(_this);
	    _this.stateFromProps = _this.stateFromProps.bind(_this);
	    _this.createNewItem = _this.createNewItem.bind(_this);
	    _this.getOptionValues = _this.getOptionValues.bind(_this);
	    _this.onAdd = _this.onAdd.bind(_this);
	    return _this;
	  }
	
	  _createClass(PriceItem, [{
	    key: 'stateFromProps',
	    value: function stateFromProps(props) {
	      var _this2 = this;
	
	      var state = this.state;
	      if (props.config !== undefined && props.config !== null) {
	        state.config = props.config;
	      }
	      if (state.config.itemIdField !== null) {
	        var f;
	
	        (function () {
	          if (props.item === undefined || props.item === null) {
	            // Create blank item
	            state.item = _this2.createNewItem(state.config);
	          } else {
	            state.item = props.item;
	          }
	
	          var cols = [];
	          var fields = state.config.fields;
	          var itemFields = Object.keys(state.item);
	          // console.log('Object fields', itemFields, 'fields', fields)
	          for (f = 0; f < fields.length; f++) {
	            if (itemFields.findIndex(function (itemField) {
	              return itemField === fields[f].name;
	            }) !== -1) {
	              cols.push(fields[f]);
	            } else {
	              console.error('Field in config not found on item!', fields[f], state.item);
	              cols.push({
	                name: 'Invalid ' + Math.random(),
	                header: 'Invalid',
	                type: 'invalid'
	              });
	            }
	          }
	
	          state.cols = cols;
	          state.itemId = state.item[state.config.itemIdField];
	        })();
	      }
	      return state;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var state = this.stateFromProps(this.props);
	      this.setState(_extends({}, state));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var state = this.stateFromProps(newProps);
	      this.setState(_extends({}, state));
	    }
	  }, {
	    key: 'createNewItem',
	    value: function createNewItem(config) {
	      var newItem = {};
	      newItem[config.itemIdField] = 0; // Initialize the item's ID to 0
	      if (config.groupField !== undefined && config.groupField !== null && this.props.groupId !== undefined && this.props.groupId !== null) {
	        newItem[config.groupField] = this.props.groupId;
	      }
	
	      for (var f = 0; f < config.fields.length; f++) {
	        var field = config.fields[f];
	        if (field.name === config.itemIdField) continue;
	        switch (field.type) {
	          case 'currency':
	          case 'percent':
	          case 'ae':
	            newItem[field.name] = 0.0;
	            break;
	          case 'int':
	            newItem[field.name] = 0;
	            break;
	          case 'text':
	            newItem[field.name] = '';
	            break;
	          case 'select':
	            var option = this.getOptionValues(field)[0];
	            var value = Object.keys(option)[0];
	            newItem[field.name] = value;
	            break;
	        }
	      }
	      return newItem;
	    }
	  }, {
	    key: 'getOptionValues',
	    value: function getOptionValues(field) {
	      // options can be either an array or a function; if 'options' is a function,
	      // it is expected to take field-name as argument and return an array of option values
	      var result = [{ 0: '' }];
	      if (field.options === undefined || field.options === null) {
	        console.error('Select options not defined for ' + field);
	      }
	      if (typeof field.options === 'function') {
	        result = field.options(field.name);
	      } else {
	        result = field.options;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.config.itemIdField === null) return null;
	      var hasValidId = this.state.item[this.state.config.itemIdField] !== 0;
	      var orderLockedField = this.state.config.itemOrderLocked;
	      var orderLocked = false;
	      if (orderLockedField !== undefined && orderLockedField !== null && this.state.item[orderLockedField] !== undefined) {
	        orderLocked = this.state.item[orderLockedField];
	      }
	      var dragColumn = null;
	      if (this.state.config.draggable && this.state.config.editable) {
	        dragColumn = _react2.default.createElement('div', { className: 'dragcolumn' });
	        if (hasValidId && !orderLocked) {
	          dragColumn = _react2.default.createElement(
	            'div',
	            { className: 'dragcolumn' },
	            _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Drag_Icon, imgClassName: 'dragIcon handle' })
	          );
	        }
	      }
	
	      var shouldRenderDelete = hasValidId && this.state.config.editable && this.state.config.allowDelete && this.props.onDelete !== undefined && this.props.onDelete !== null;
	      var shouldRenderAddage = !hasValidId && this.state.config.editable && this.state.config.allowAdd && this.props.onAdd !== undefined && this.props.onAdd !== null;
	
	      var cols = this.props.generateColWidths(this.state.config.fields, dragColumn, shouldRenderDelete || shouldRenderAddage);
	
	      var itemCss = 'priceitem'; // 'clearfix form priceitem'
	      if (!hasValidId) itemCss += ' priceitem_static priceitem_noid';
	      if (orderLocked) itemCss += ' priceitem_nomove';
	      // if (this.state.config.itemCss !== undefined && this.state.config.itemCss !== null) itemCss += (' ' + this.state.config.itemCss)
	      itemCss += this.props.itemClass ? ' ' + this.props.itemClass : '';
	
	      return _react2.default.createElement(
	        'li',
	        { className: itemCss, 'data-index': this.props.index },
	        _react2.default.createElement(
	          _tableRow2.default,
	          { cols: cols },
	          dragColumn,
	          this.state.cols !== undefined && this.state.cols.map(this.renderField),
	          shouldRenderDelete && this.renderDelete(),
	          shouldRenderAddage && this.renderAdd()
	        )
	      );
	      // return (
	      //   <li className={itemCss} data-index={this.props.index}>
	      //     <Grid cols={cols} align='center'>
	      //       {dragColumn}
	      //       {this.state.cols !== undefined && this.state.cols.map(this.renderField)}
	      //       {shouldRenderDelete && this.renderDelete()}
	      //       {shouldRenderAddage && this.renderAdd()}
	      //     </Grid>
	      //   </li>
	      // )
	    }
	  }, {
	    key: 'renderField',
	    value: function renderField(val, key) {
	      var _this3 = this;
	
	      if (val.hide) return null;
	      var value = this.state.item[val.name];
	      var name = val.name;
	      var type = val.type;
	      var css = val.css;
	      var isNewItem = (this.state.itemId === null || this.state.itemId === 0) && this.state.config.newItemInputs.findIndex(function (s) {
	        return s.toLowerCase() === val.name.toLowerCase();
	      }) !== -1;
	      var editable = (isNewItem || this.state.itemId > 0 && val.editable) && this.state.config.editable;
	      var renderKey = this.state.config.itemIdField + '_' + this.state.itemId + '_' + name;
	      var size = 's';
	
	      var decimalOnBlur = function decimalOnBlur(data) {
	        if (data.value !== value) {
	          updateItem(data.value, data.shouldAdd);
	        }
	      };
	
	      var textOnBlur = function textOnBlur(e) {
	        if (value !== e.target.value) {
	          updateItem(e.target.value);
	        }
	      };
	
	      var textOnKeyPress = function textOnKeyPress(e) {
	        if ((e.key === 'Enter' || e.key === 'Tab') && e.target.value) {
	          updateItem(e.target.value, true);
	        }
	      };
	
	      var onChange = function onChange(e) {
	        if (value !== e.target.value) {
	          var item = _this3.state.item;
	          item[name] = e.target.value;
	          _this3.setState({
	            item: item
	          });
	        }
	      };
	
	      var updateItem = function updateItem(value) {
	        var shouldAdd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var item = _this3.state.item;
	        item[name] = value;
	        _this3.setState({
	          item: item
	        }, function () {
	          if (!isNewItem) {
	            _this3.props.onUpdate(_this3.state.item);
	          }
	          var newItemInputs = _this3.state.config.newItemInputs;
	
	          var isLast = newItemInputs[newItemInputs.length - 1].toLowerCase() === val.name.toLowerCase();
	          if (shouldAdd && isNewItem && isLast) {
	            _this3.onAdd();
	          }
	        });
	      };
	
	      var renderText = function renderText() {
	        if (editable) {
	          return _react2.default.createElement(_text2.default, {
	            value: value,
	            onChange: onChange,
	            onBlur: textOnBlur,
	            onKeyDown: textOnKeyPress,
	            disabled: _this3.props.disabled,
	            size: size,
	            key: renderKey,
	            maxLength: 50
	          });
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { key: renderKey, className: css },
	          value
	        );
	      };
	
	      var renderCurrency = function renderCurrency() {
	        var transformValue = function transformValue(value, toClean) {
	          if (type === 'percent') {
	            return (0, _percent.transformPercent)(value, toClean);
	          }
	          return value;
	        };
	
	        if (editable) {
	          return _react2.default.createElement(_DecimalInput2.default, {
	            value: value,
	            decimals: 2,
	            name: name,
	            onBlur: decimalOnBlur,
	            disabled: _this3.props.disabled,
	            transformValue: transformValue,
	            size: size,
	            key: renderKey
	          });
	        }
	
	        if (_this3.state.itemId > 0) {
	          return _react2.default.createElement(
	            'div',
	            { key: renderKey, className: css },
	            transformValue((0, _currency.formatCurrency2)(value, 2))
	          );
	        }
	
	        return _react2.default.createElement('div', { key: renderKey, className: css });
	      };
	
	      var renderAE = function renderAE() {
	        if (editable) {
	          return _react2.default.createElement(_DecimalInput2.default, {
	            value: value,
	            decimals: 5,
	            name: name,
	            onBlur: decimalOnBlur,
	            disabled: _this3.props.disabled,
	            size: size,
	            key: renderKey
	          });
	        }
	
	        if (_this3.state.itemId > 0) {
	          return _react2.default.createElement(
	            'div',
	            { key: renderKey, className: css },
	            (0, _currency.formatCurrency2)(value, 5)
	          );
	        }
	
	        return _react2.default.createElement('div', { key: renderKey, className: css });
	      };
	
	      var renderInt = function renderInt() {
	        if (editable) {
	          return _react2.default.createElement(_DecimalInput2.default, {
	            value: value,
	            decimals: 0,
	            name: name,
	            onBlur: decimalOnBlur,
	            disabled: _this3.props.disabled,
	            size: size,
	            key: renderKey
	          });
	        }
	
	        if (_this3.state.itemId > 0) {
	          return _react2.default.createElement(
	            'div',
	            { key: renderKey, className: css },
	            (0, _currency.formatCurrency2)(value, 0)
	          );
	        }
	
	        return _react2.default.createElement('div', { key: renderKey, className: css });
	      };
	
	      var renderSelect = function renderSelect() {
	        var options = _this3.getOptionValues(val);
	
	        if (editable) {
	          return _react2.default.createElement(
	            _dropDown2.default,
	            { onChange: onChange, size: size, key: renderKey },
	            options.map(function (v, k) {
	              var value = Object.keys(v)[0];
	              var display = v[value];
	              return _react2.default.createElement(
	                'option',
	                { key: renderKey + '_' + k, value: value },
	                display
	              );
	            })
	          );
	        }
	
	        if (_this3.state.itemId > 0) {
	          return _react2.default.createElement(
	            'div',
	            { key: renderKey, className: css },
	            value
	          );
	        }
	
	        return _react2.default.createElement('div', { key: renderKey, className: css });
	      };
	
	      var renderInvalid = function renderInvalid() {
	        return _react2.default.createElement(
	          'div',
	          { key: renderKey, className: 'invalid' },
	          'INVALID'
	        );
	      };
	
	      switch (type) {
	        case 'text':
	          return renderText();
	        case 'percent':
	        case 'currency':
	          return renderCurrency();
	        case 'ae':
	          return renderAE();
	        case 'int':
	          return renderInt();
	        case 'select':
	          return renderSelect();
	        case 'invalid':
	          return renderInvalid();
	      }
	      return _react2.default.createElement(
	        'div',
	        { key: renderKey, className: css },
	        '\xA0'
	      );
	    }
	  }, {
	    key: 'renderDelete',
	    value: function renderDelete() {
	      var _this4 = this;
	
	      var renderKey = this.state.config.itemIdField + '_' + this.state.itemId + '_delete';
	
	      return _react2.default.createElement(_removeButton2.default, {
	        onClick: function onClick() {
	          return _this4.props.onDelete(_this4.state.item);
	        },
	        disabled: this.props.disabled,
	        size: 's',
	        key: renderKey
	      });
	    }
	  }, {
	    key: 'renderAdd',
	    value: function renderAdd() {
	      // const onAdd = () => {
	      //   this.props.onAdd(this.state.item)
	      //   this.setState({
	      //     item: this.createNewItem(this.state.config)
	      //   })
	      // }
	      var renderKey = this.state.config.itemIdField + '_' + this.state.itemId + '_add';
	
	      return _react2.default.createElement(_addButton2.default, {
	        onClick: this.onAdd,
	        disabled: this.props.disabled,
	        size: 's',
	        key: renderKey
	      });
	    }
	  }, {
	    key: 'onAdd',
	    value: function onAdd() {
	      this.props.onAdd(this.state.item);
	      this.setState({
	        item: this.createNewItem(this.state.config)
	      });
	    }
	  }]);
	
	  return PriceItem;
	}(_react.Component);
	
	PriceItem.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	  // item: PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(PriceItem);

/***/ }),
/* 947 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createConfigContext = createConfigContext;
	exports.getTaskPriceConfig = getTaskPriceConfig;
	exports.getBodyTaskPriceConfig = getBodyTaskPriceConfig;
	exports.getAddonStartTimeConfig = getAddonStartTimeConfig;
	exports.getAddonPartConfig = getAddonPartConfig;
	function createConfigContext(auth, price) {
	  return {
	    isCustomerList: price.CustomerId > 0,
	    isShopList: price.CustomerId === 0 && price.ShopId > 0,
	    isChainList: price.CustomerId === 0 && price.ShopId === 0 && price.ChainId > 0,
	    isCustomerUser: auth.user.UserType === 4,
	    isShopUser: auth.user.UserType === 5 || auth.user.UserType === 3 || auth.user.UserType === 7,
	    isChainUser: auth.user.UserType === 2,
	    isWorkProviderUser: auth.user.UserType === 6,
	    isSuperUser: auth.user.UserType === 1,
	    department: price.Department,
	    useRecommended: price.UseRecommended,
	    onlyShow: (auth.user.UserType === 1 || auth.user.UserType === 6) && price.UseRecommended,
	    isOwnPriceList: parseInt(auth.user.ShopId, 10) === parseInt(price.ShopId, 10)
	  };
	}
	
	function getTaskPriceConfig(context) {
	  return {
	    itemIdField: 'TaskPriceId',
	    itemOrderField: 'SortIndex',
	    editable: !context.isCustomerUser && !context.useRecommended && context.isOwnPriceList,
	    whitebox: true,
	    draggable: true,
	    title: 'No title',
	    groupCss: 'partitem__list',
	    itemCss: 'taskpriceItem',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'TaskName',
	      header: 1203,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'name',
	      col: 3
	    }, {
	      name: 'Labor',
	      header: 13431,
	      type: 'currency',
	      editable: false,
	      hide: context.isCustomerList,
	      css: ''
	    }, {
	      name: 'AE',
	      header: 885,
	      type: 'ae',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Material',
	      header: context.department !== 0 ? 14788 : 13443,
	      type: 'currency',
	      editable: false,
	      hide: context.isCustomerList,
	      css: ''
	    }, {
	      name: 'Gross',
	      header: 13376,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Discount',
	      header: 15014,
	      type: 'percent',
	      editable: context.isCustomerList,
	      hide: !context.isCustomerList || context.department !== 0,
	      css: ''
	    }, {
	      name: 'Net',
	      header: 1392,
	      type: 'currency',
	      editable: context.isCustomerList,
	      hide: !context.isCustomerList || context.department !== 0,
	      css: ''
	    }, {
	      name: 'Environment',
	      header: 1044,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Total',
	      header: 393,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }],
	    newItemInputs: !context.isCustomerList || context.department !== 0 ? ['TaskName', 'AE'] : ['TaskName', 'AE', 'Discount'],
	    groupField: 'PartItemId'
	  };
	}
	
	function getBodyTaskPriceConfig(context) {
	  return {
	    itemIdField: 'BodyTaskPriceId',
	    itemOrderField: 'SortIndex',
	    editable: !context.isCustomerUser && !context.useRecommended && context.isOwnPriceList,
	    whitebox: true,
	    draggable: true,
	    title: 'No title',
	    groupCss: 'partitem__list',
	    itemCss: 'taskpriceItem',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'TaskName',
	      header: 1203,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'name',
	      col: 3
	    }, {
	      name: 'Labor',
	      header: 13431,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'AE',
	      header: 885,
	      type: 'ae',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Material',
	      header: 14788,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Gross',
	      header: 13376,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Environment',
	      header: 1044,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Total',
	      header: 393,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }],
	    newItemInputs: ['TaskName', 'AE'],
	    groupField: 'PartItemId'
	  };
	}
	
	function getAddonStartTimeConfig(context) {
	  return {
	    itemIdField: 'AddonStartTimeId',
	    itemOrderField: 'SortIndex',
	    editable: !context.isCustomerUser && !context.useRecommended && context.isOwnPriceList,
	    whitebox: false,
	    draggable: true,
	    title: null,
	    headerHelp: 1962,
	    groupCss: 'starttimes',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Name',
	      header: 1195,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'name',
	      col: 3
	    }, {
	      name: 'AE',
	      header: 885,
	      type: 'ae',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Mat',
	      header: context.department !== 0 ? 14788 : 13443,
	      type: 'currency',
	      editable: true,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Price',
	      header: 13350,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Discount',
	      header: 15014,
	      type: 'percent',
	      editable: context.isCustomerList,
	      hide: false,
	      css: 'discount'
	    }, {
	      name: 'Net',
	      header: 1305,
	      type: 'currency',
	      editable: context.isCustomerList,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Env',
	      header: 1044,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }, {
	      name: 'Total',
	      header: 393,
	      type: 'currency',
	      editable: false,
	      hide: false,
	      css: ''
	    }],
	    newItemInputs: context.isCustomerList ? ['Name', 'AE', 'Mat', 'Discount', 'Net'] : ['Name', 'AE', 'Mat']
	  };
	}
	
	function getAddonPartConfig(context) {
	  return {
	    itemIdField: 'AddonPartId',
	    itemOrderField: 'SortIndex',
	    editable: !context.isCustomerUser && !context.useRecommended && context.isOwnPriceList,
	    whitebox: false,
	    draggable: true,
	    title: null,
	    headerHelp: 1963,
	    groupCss: 'addonparts',
	    allowAdd: true,
	    allowDelete: true,
	    fields: [{
	      name: 'Name',
	      header: 888,
	      type: 'text',
	      editable: false,
	      hide: false,
	      css: 'addonpart_name',
	      col: 2
	    }, {
	      name: 'AE',
	      header: 885,
	      headerAppend: ' (%)',
	      type: 'percent',
	      editable: true,
	      hide: false,
	      css: 'addon_workUnits'
	    }, {
	      name: 'Mat',
	      header: context.department !== 0 ? 14788 : 13443,
	      headerAppend: ' (%)',
	      ariaLabel: 14785,
	      ariaHintClass: context.department !== 0 ? 'mat hint--top' : 'mat',
	      type: 'percent',
	      editable: true,
	      hide: false,
	      css: 'mat'
	    }, {
	      name: 'StartTime',
	      header: 1195,
	      headerAppend: ' (%)',
	      type: 'percent',
	      editable: true,
	      hide: context.department !== 0,
	      css: 'starttime'
	    }],
	    newItemInputs: ['Name', 'AE', 'Mat', 'StartTime']
	  };
	}

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _PriceModelLogModal = __webpack_require__(470);
	
	var _PriceModelLogModal2 = _interopRequireDefault(_PriceModelLogModal);
	
	var _priceModel = __webpack_require__(75);
	
	var _customers = __webpack_require__(74);
	
	var _backdrop = __webpack_require__(29);
	
	var _common = __webpack_require__(25);
	
	var _config = __webpack_require__(947);
	
	__webpack_require__(1447);
	
	var _currency = __webpack_require__(41);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _percent = __webpack_require__(178);
	
	var _helpers = __webpack_require__(2);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _PriceItemGroup = __webpack_require__(228);
	
	var _PriceItemGroup2 = _interopRequireDefault(_PriceItemGroup);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableHeader = __webpack_require__(132);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _helpIcon = __webpack_require__(90);
	
	var _helpIcon2 = _interopRequireDefault(_helpIcon);
	
	var _tableExpand = __webpack_require__(140);
	
	var _tableExpand2 = _interopRequireDefault(_tableExpand);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Modals
	
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	// formatCurrency, reverseFormatCurrency
	
	
	// import components
	
	// import HelpText from '../../../shared/components/HelpText'
	
	
	// Elements
	
	
	var Salescar = function (_Component) {
	  _inherits(Salescar, _Component);
	
	  function Salescar(props) {
	    _classCallCheck(this, Salescar);
	
	    var _this = _possibleConstructorReturn(this, (Salescar.__proto__ || Object.getPrototypeOf(Salescar)).call(this, props));
	
	    _this.state = {
	      showPriceModelLog: false,
	      log: [{
	        ChangeTable: 0,
	        ChangeTableId: 0,
	        ChangeField: 0,
	        PartItemId: 0,
	        ChangeType: 0,
	        ChangedById: 0,
	        ChangedByName: null,
	        ChangedAt: '',
	        From: 0,
	        To: 0,
	        FromText: null,
	        ToText: null
	      }],
	      priceOriginal: {},
	      price: {},
	      parts: [],
	      bodyParts: [],
	      new_startprice: {
	        Price: '',
	        AE: '',
	        Mat: '',
	        Env: '',
	        Net: '',
	        Discount: '',
	        Total: '',
	        Type: 0
	      },
	      new_startprice1: {
	        Price: '',
	        AE: '',
	        Mat: '',
	        Env: '',
	        Net: '',
	        Discount: '',
	        Total: '',
	        Type: 1
	      },
	      new_indexAdjust: {
	        IndexAdjustmentId: 0,
	        Date: '',
	        Amount: 0,
	        IsApplied: false,
	        IsDeleted: false
	      },
	      confirm: {
	        open: false,
	        type: 0
	      },
	      confirmActive: {
	        open: false,
	        type: 0
	      },
	      confirmDelete: {
	        open: false
	      },
	      IsWorking: false,
	      ShopId: 0,
	      customers: [],
	      dimensions: {
	        width: 0,
	        height: 0
	      },
	      department: 0,
	      config: null,
	      currentBrand: 0,
	      currentCustomer: 0
	    };
	    _this.AERounding = 5;
	    _this.switchRecommended = _this.switchRecommended.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onInputBlur = _this.onInputBlur.bind(_this);
	    // this.renderPartItem = this.renderPartItem.bind(this)
	    // this.renderPartItemTask = this.renderPartItemTask.bind(this)
	    _this.changeType = _this.changeType.bind(_this);
	    _this.renderAddonParts = _this.renderAddonParts.bind(_this);
	    _this.renderPriceModelLog = _this.renderPriceModelLog.bind(_this);
	    _this.renderIndexAdjustments = _this.renderIndexAdjustments.bind(_this);
	    _this.showPriceModelLog = _this.showPriceModelLog.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	
	    _this.moveItem = _this.moveItem.bind(_this);
	    _this.getItemListName = _this.getItemListName.bind(_this);
	    _this.getItemIdField = _this.getItemIdField.bind(_this);
	    _this.updateOrAddItem = _this.updateOrAddItem.bind(_this);
	    _this.deleteItem = _this.deleteItem.bind(_this);
	
	    _this.getConfirmActiveText = _this.getConfirmActiveText.bind(_this);
	
	    // this.renderTaskPriceParts = this.renderTaskPriceParts.bind(this)
	    // this.getTaskPriceConfig = getTaskPriceConfig.bind(this)
	    return _this;
	  }
	
	  _createClass(Salescar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPriceList(this.props);
	      window.addEventListener('resize', this.updateDimensions);
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'dimensionShow',
	    value: function dimensionShow(dimensions) {
	      var _this2 = this;
	
	      var show = false;
	      dimensions.map(function (val, key) {
	        if (!show) {
	          var higherThan = val[0];
	          var lessThan = val[1];
	          var width = _this2.state.dimensions.width;
	          if (width > higherThan && width < lessThan) show = true;
	        }
	      });
	      return show;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(nextProps.item, this.props.item)) {
	        this.setState({
	          price: {},
	          priceOriginal: {},
	          parts: [],
	          bodyParts: [],
	          new_startprice: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 0
	          },
	          new_startprice1: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 1
	          },
	          new_indexAdjust: {
	            IndexAdjustmentId: 0,
	            Date: '',
	            Amount: 0,
	            IsApplied: false,
	            IsDeleted: false
	          },
	          Log: [{
	            ChangeTable: 0,
	            ChangeTableId: 0,
	            ChangeField: 0,
	            PartItemId: 0,
	            ChangeType: 0,
	            ChangedById: 0,
	            ChangedByName: null,
	            ChangedAt: '',
	            From: 0,
	            To: 0,
	            FromText: null,
	            ToText: null
	          }],
	          department: 0
	        });
	        this.getPriceList(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      // Fix to missing brands
	      if (nextProps.brands === null || nextProps.brands.length === 0) {
	        this.props.getBrands();
	      }
	    }
	  }, {
	    key: 'getPriceList',
	    value: function getPriceList(props) {
	      var _this3 = this;
	
	      props.getPriceList(props.item.PriceModelId).then(function (res) {
	        _this3.setState({
	          price: res.data,
	          priceOriginal: (0, _lodash.cloneDeep)(res.data),
	          department: res.data.Department
	        });
	        _this3.mapParts(res.data);
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        _this3.props.onShouldUpdate();
	      });
	    }
	  }, {
	    key: 'shouldUpdatePrices',
	    value: function shouldUpdatePrices(val1, val2) {
	      return val1 !== val2;
	    }
	  }, {
	    key: 'updatePrices',
	    value: function updatePrices(price) {
	      var _this4 = this;
	
	      var setPriceState = function setPriceState(data) {
	        _this4.setState({
	          price: data,
	          priceOriginal: (0, _lodash.cloneDeep)(data),
	          new_startprice: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 0
	          },
	          new_startprice1: {
	            Price: '',
	            AE: '',
	            Mat: '',
	            Env: '',
	            Net: '',
	            Discount: '',
	            Total: '',
	            Type: 1
	          },
	          new_indexAdjust: {
	            IndexAdjustmentId: 0,
	            Date: '',
	            Amount: 0,
	            IsApplied: '',
	            IsDeleted: false
	          },
	          ShopId: 0,
	          customers: [],
	          Log: [{
	            ChangeTable: 0,
	            ChangeTableId: 0,
	            ChangeField: 0,
	            PartItemId: 0,
	            ChangeType: 0,
	            ChangedById: 0,
	            ChangedByName: null,
	            ChangedAt: '',
	            From: 0,
	            To: 0,
	            FromText: null,
	            ToText: null
	          }],
	          department: data.Department
	        });
	        _this4.mapParts(data);
	      };
	      this.setState({ IsWorking: true });
	      return this.props.updatePriceList(price).then(function (res) {
	        setPriceState(res.data);
	        _this4.setState({ IsWorking: false });
	        // Toastr
	        // window.toastr.success(translation('13444'), translation('13424'))
	        // Return
	        return res;
	      }, function (err) {
	        _this4.setState({ IsWorking: false });
	        // console.log('Error response ', err.response.data.Error)
	        var errorDescription = null;
	        switch (err.response.data.Error) {
	          case 1:
	            // Conflict with existing
	            errorDescription = '1793';
	            break;
	          case 2:
	            // Not allowed
	            errorDescription = '1794';
	            break;
	          case 1000:
	            // Unspecified error
	            errorDescription = '1795';
	            break;
	        }
	        if (errorDescription !== null) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445') + ':</br>' + (0, _helpers.translation)(errorDescription), (0, _helpers.translation)('216'));
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13445'), (0, _helpers.translation)('216'));
	        }
	
	        // console.log('error ', err.response)
	        setPriceState(err.response.data);
	        // this.props.router.push('/prices')
	        // Return
	        return err;
	      });
	    }
	  }, {
	    key: 'onlyShow',
	    value: function onlyShow() {
	      if ((0, _auth.hasAccess)([1, 6], this.props.auth.user.UserType) && this.state.price.UseRecommended || parseInt(this.props.auth.user.ShopId, 10) !== this.state.price.ShopId) {
	        return true;
	      }
	      return false;
	
	      // Old
	      // if (this.state.price.UseRecommended) {
	      //   if (hasAccess([1], this.props.auth.user.UserType)) {
	      //     return false
	      //   }
	      //   return true
	      // }
	      // return false
	    }
	  }, {
	    key: 'mapParts',
	    value: function mapParts(data) {
	      var newData = [];
	      // Parts
	      data.Parts.map(function (val, index) {
	        newData[val.PartItemId] = {
	          part: val,
	          tasks: []
	        };
	      });
	      // Tasks
	      if (data.Department === 0) {
	        data.TaskPrices.map(function (val, index) {
	          newData[val.PartItem.PartItemId].tasks.push(val);
	        });
	        this.setState({
	          parts: newData,
	          bodyParts: []
	        });
	      } else {
	        data.BodyTaskPrices.map(function (val, index) {
	          // console.log('bodytaskrpicemap', val, index)
	          newData[val.PartItem.PartItemId].tasks.push(val);
	        });
	        this.setState({
	          parts: [],
	          bodyParts: newData
	        });
	      }
	      console.log('data to map:', data);
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this5 = this;
	
	      e.persist();
	      var value = (0, _percent.transformPercent)(e.target.value, true);
	      var name = e.target.name;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      if (e.target.name === 'Name') {
	        value = e.target.value;
	      }
	      this.setState({
	        price: _extends({}, this.state.price, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this5.updatePrices(_this5.state.price).then(function (res) {
	            if (name === 'Active') {
	              _this5.props.getPriceLists(_this5.props);
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'onInputBlur',
	    value: function onInputBlur(e) {
	      var _this6 = this;
	
	      var name = e.target.name;
	      if (name === 'PriceHourly') {
	        var value = e.target.value === '' ? '0' : e.target.value;
	        this.state.price.PriceHourly = (0, _currency.reverseFormatCurrency2)(value);
	      }
	      if (name === 'PriceMaterial') {
	        var _value = e.target.value === '' ? '0' : (0, _percent.transformPercent)(e.target.value, true);
	        this.state.price.PriceMaterial = (0, _currency.reverseFormatCurrency2)(_value);
	      }
	      if (name === 'PriceEnvironment') {
	        var _value2 = e.target.value === '' ? '0' : (0, _percent.transformPercent)(e.target.value, true);
	        this.state.price.PriceEnvironment = (0, _currency.reverseFormatCurrency2)(_value2);
	      }
	      if (this.shouldUpdatePrices(this.state.price[e.target.name], this.state.priceOriginal[e.target.name])) {
	        this.updatePrices(this.state.price).then(function (res) {
	          if (name === 'Name') {
	            _this6.props.getPriceLists(_this6.props);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType(e) {
	      var _this7 = this;
	
	      var value = parseInt(e.target.value);
	      this.setState({
	        price: _extends({}, this.state.price, _defineProperty({}, e.target.name, value))
	      }, function () {
	        _this7.updatePrices(_this7.state.price).then(function (res) {
	          _this7.props.getPriceLists(_this7.props);
	        });
	      });
	    }
	  }, {
	    key: 'renderPrices',
	    value: function renderPrices() {
	      var _this8 = this;
	
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      if (isCustomer) return null;
	      // let isCustomer = this.props.customer
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	      var price = this.state.price;
	
	      var isDisabled = false;
	      // Render environment discount
	      var renderEnviDiscount = function renderEnviDiscount() {
	        if (_this8.shouldRender(1) || (0, _auth.hasAccess)([6], _this8.props.auth.user.UserType)) {
	          return _react2.default.createElement(_switch2.default, {
	            name: 'IsEnvironmentDiscount',
	            onChange: _this8.onInputChange,
	            checked: price.IsEnvironmentDiscount,
	            disabled: false,
	            labelText: (0, _helpers.translation)('1236')
	          });
	        }
	        return null;
	      };
	
	      // IF Customer
	      if (this.props.customer && price.UseRecommended || parseInt(this.props.auth.user.ShopId, 10) !== price.ShopId) {
	        isDisabled = true;
	      }
	      var priceHourly = (0, _currency.formatCurrency2)(price.PriceHourly === undefined || price.PriceHourly === '' ? '0' : price.PriceHourly);
	      var priceMaterial = (0, _percent.transformPercent)((0, _currency.formatCurrency2)(price.PriceMaterial === undefined || price.PriceMaterial === '' ? '0' : price.PriceMaterial));
	      var priceEnvironment = (0, _percent.transformPercent)((0, _currency.formatCurrency2)(price.PriceEnvironment === undefined || price.PriceEnvironment === '' ? '0' : price.PriceEnvironment));
	      var mat = '417';
	      var ht = '1955';
	      if (this.state.department !== 0) {
	        mat = '14785';
	        ht = '14789';
	      }
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13354') },
	        _react2.default.createElement(_text2.default, {
	          name: 'PriceHourly',
	          value: priceHourly,
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('419'),
	          helpText: (0, _helpers.translation)('1954')
	        }),
	        _react2.default.createElement(_text2.default, {
	          name: 'PriceMaterial',
	          value: priceMaterial,
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          onFocus: _percent.onPercentFocus,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)(mat) + ' (%)',
	          helpText: (0, _helpers.translation)(ht)
	        }),
	        _react2.default.createElement(_text2.default, {
	          name: 'PriceEnvironment',
	          value: priceEnvironment,
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          onFocus: _percent.onPercentFocus,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('13339') + ' (%)',
	          helpText: (0, _helpers.translation)('1956')
	        }),
	        (0, _auth.hasAccess)([6], this.props.auth.user.UserType) && _react2.default.createElement(_text2.default, {
	          name: 'PriceDiscount',
	          value: price.PriceDiscount,
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('1199') + ' (%)'
	        }),
	        renderEnviDiscount()
	      );
	      // return (
	      //   <div className='white__box'>
	      //     <div className='title'>{translation('13354')}</div>
	      //     <div className='form fifty'>
	      //       <div className='control__group'>
	      //         <label>{translation('419')} <HelpText text={translation('1954')} /></label>
	      //         {!isCustomer && (<input type='text' name='PriceHourly' value={priceHourly} onChange={this.onInputChange} onBlur={this.onInputBlur} disabled={isDisabled} />)}
	      //         {isCustomer && (<label >{price.PriceHourly}</label>)}
	      //       </div>
	      //       <div className='control__group'>
	      //         <label>{translation(mat)} (%) <HelpText text={translation(ht)} /></label>
	      //         {!isCustomer && (<input type='text' name='PriceMaterial' value={priceMaterial} onChange={this.onInputChange} onBlur={this.onInputBlur} onFocus={onPercentFocus} disabled={isDisabled} />)}
	      //         {isCustomer && (<label >{transformPercent(price.PriceMaterial)}</label>)}
	      //       </div>
	      //       <div className='control__group'>
	      //         <label>{translation('13339')} (%) <HelpText text={translation('1956')} /></label>
	      //         {!isCustomer && (<input type='text' name='PriceEnvironment' value={priceEnvironment} onChange={this.onInputChange} onBlur={this.onInputBlur} onFocus={onPercentFocus} disabled={isDisabled} />)}
	      //         {isCustomer && (<label >{transformPercent(price.PriceEnvironment)}</label>)}
	      //       </div>
	      //       {hasAccess([6], this.props.auth.user.UserType) && (
	      //         <div className='control__group'>
	      //           <label>{translation('1199')} (%)</label>
	      //           {isCustomer && (<input type='text' name='PriceDiscount' value={price.PriceDiscount} onChange={this.onInputChange} onBlur={this.onInputBlur} disabled={isDisabled} />)}
	      //           {isCustomer && (<label >{price.PriceDiscount}</label>)}
	      //         </div>
	      //       )}
	      //       {renderEnviDiscount()}
	      //     </div>
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'renderSize',
	    value: function renderSize() {
	      if (this.state.department !== 0) return null;
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      // let isCustomer = this.props.customer
	      // if (hasAccess([6], this.props.auth.user.UserType) || this.props.partners) return null
	      var price = this.state.price;
	
	      var isDisabled = this.onlyShow() || isCustomer;
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13340') },
	        _react2.default.createElement(_text2.default, {
	          name: 'SizeSmall',
	          value: (0, _percent.transformPercent)(price.SizeSmall),
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          onFocus: _percent.onPercentFocus,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('1264') + ' (%)',
	          helpText: (0, _helpers.translation)('1957')
	        }),
	        _react2.default.createElement(_text2.default, { value: '0', disabled: true, labelText: (0, _helpers.translation)('1265'), helpText: (0, _helpers.translation)('1958') }),
	        _react2.default.createElement(_text2.default, {
	          name: 'SizeLarge',
	          value: (0, _percent.transformPercent)(price.SizeLarge),
	          onChange: this.onInputChange,
	          onBlur: this.onInputBlur,
	          onFocus: _percent.onPercentFocus,
	          disabled: isDisabled,
	          labelText: (0, _helpers.translation)('1266') + ' (%)',
	          helpText: (0, _helpers.translation)('1959')
	        })
	      );
	    }
	  }, {
	    key: 'renderAddons',
	    value: function renderAddons(dimensions) {
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      if (isCustomer && this.state.price.AddonStartTimes.length === 0 && this.state.price.AddonParts.length === 0) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	
	      if (!this.dimensionShow(dimensions)) return null;
	      // Do not render if estimation type model
	      if (this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	
	      return _react2.default.createElement(
	        _tableContainer2.default,
	        { fullWidth: true },
	        _react2.default.createElement(
	          _tableExpand2.default,
	          null,
	          _react2.default.createElement(
	            _tableHeader2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1792'),
	              _react2.default.createElement(_helpIcon2.default, { helpText: (0, _helpers.translation)('1961') })
	            )
	          ),
	          this.state.department === 0 && this.renderAddonStartTimes(),
	          this.renderAddonParts()
	        )
	      );
	    }
	  }, {
	    key: 'renderAddonParts',
	    value: function renderAddonParts() {
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      // let isCustomer = this.props.customer
	      // Do not render if estimation type model
	      if (isCustomer && this.state.price.AddonParts.length === 0) return null;
	      if (this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	      var price = this.state.price;
	
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        items: price.AddonParts,
	        itemClass: 'addonPart',
	        config: (0, _config.getAddonPartConfig)((0, _config.createConfigContext)(this.props.auth, this.state.price)),
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking });
	    }
	
	    //     if (typeof newItem.AE !== 'number' || isNaN(newItem.AE)) {
	    //       // Toastr
	    //       window.toastr.error(translation('13430'), translation('216'))
	    //       // Toastr
	    //       window.toastr.error(translation('13430'), translation('216'))
	
	  }, {
	    key: 'renderAddonStartTimes',
	    value: function renderAddonStartTimes() {
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      if (isCustomer && this.state.price.AddonStartTimes.length === 0) return null;
	      // let isCustomer = this.props.customer
	      // Do not render if estimation type model
	      if (this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	
	      var price = this.state.price;
	
	
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        items: price.AddonStartTimes,
	        itemClass: 'addonStartTime',
	        config: (0, _config.getAddonStartTimeConfig)((0, _config.createConfigContext)(this.props.auth, this.state.price)),
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking });
	    }
	  }, {
	    key: 'renderStartPrice',
	    value: function renderStartPrice(dimensions, type) {
	      var _this9 = this;
	
	      if (this.state.department !== 0) return null;
	      if (!this.dimensionShow(dimensions)) return null;
	      // Old config.
	      // let canEditPrice = !hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
	      // let canEditAE = hasAccess([2], this.props.auth.user.UserType)
	      // let canEditMat = hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
	      // let canEditDiscount = hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
	      // let canEditNet = hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
	
	      // New config.
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      var isOwnPriceList = parseInt(this.props.auth.user.ShopId, 10) === this.state.price.ShopId;
	
	      if (isCustomer && this.state.price.StartPrices.length === 0) return null;
	      // let isCustomer = this.props.customer
	      var canEditPrice = false;
	      var canEditAE = (0, _auth.hasAccess)([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer;
	      var canEditMat = (0, _auth.hasAccess)([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer; // && !this.onlyShow()
	      var canEditDiscount = (0, _auth.hasAccess)([2, 3, 5, 7], this.props.auth.user.UserType) && this.props.customer && isOwnPriceList; // && !this.onlyShow()
	      var canEditNet = (0, _auth.hasAccess)([2, 3, 5, 7], this.props.auth.user.UserType) && this.props.customer && isOwnPriceList; // && !this.onlyShow()
	
	      var canEditNewAE = (0, _auth.hasAccess)([2, 3, 5, 6, 7], this.props.auth.user.UserType) && this.props.customer;
	      var canEditNewMat = (0, _auth.hasAccess)([2, 3, 5, 6, 7], this.props.auth.user.UserType) && this.props.customer;
	
	      var showDiscount = (0, _auth.hasAccess)([2, 3, 5, 7], this.props.auth.user.UserType) && this.props.customer || isCustomer; // && !this.onlyShow()
	      var showNet = (0, _auth.hasAccess)([2, 3, 5, 7], this.props.auth.user.UserType) && this.props.customer || isCustomer; // && !this.onlyShow()
	
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	
	      var cols = [1, [7, 2], 1]; // [ 1, 2, 2, 2, 2, 2, 2, 2, 1 ]
	
	      var price = this.state.price;
	
	      var deleteItem = function deleteItem(key) {
	        var price = _extends({}, _this9.state.price);
	        price.StartPrices[key].IsDeleted = true;
	        _this9.updatePrices(price);
	      };
	      var renderStartprice = function renderStartprice(val, key) {
	        if (val.Type !== type) return null;
	        var size = 's';
	
	        // let ref1 = 'startPRICE' + type + '_' + val.StartPriceId
	        // let ref2 = 'startAE' + type + '_' + val.StartPriceId
	        // let ref3 = 'startMAT' + type + '_' + val.StartPriceId
	        // let ref4 = 'startNET' + type + '_' + val.StartPriceId
	        // let ref5 = 'startDISCOUNT' + type + '_' + val.StartPriceId
	        // Edit item
	        // const onEditStartprice = (e) => {
	        //   // let price = {...this.state.price}
	        //   console.log('onEditStartPrice', e.target.name, e.target.value, this.refs[ref5], ref5, this.refs[ref5].value)
	        //   let price = JSON.parse(JSON.stringify(this.state.price))
	        //   if (e.target.name === 'AE') {
	        //     price.StartPrices[key].AE = reverseFormatCurrency2(this.refs[ref2].value, this.AERounding)
	        //     if (this.shouldUpdatePrices(price.StartPrices[key].AE, this.state.price.StartPrices[key].AE)) {
	        //       this.updatePrices(price).then(() => {
	        //         this.refs[ref2].value = formatCurrency2(price.StartPrices[key].AE, this.AERounding)
	        //       })
	        //     }
	        //   } else if (e.target.name === 'Price') {
	        //     price.StartPrices[key].Price = reverseFormatCurrency2(this.refs[ref1].value)
	        //     if (this.shouldUpdatePrices(price.StartPrices[key].Price, this.state.price.StartPrices[key].Price)) {
	        //       this.updatePrices(price).then(() => {
	        //         this.refs[ref1].value = formatCurrency2(price.StartPrices[key].Price)
	        //       })
	        //     }
	        //   } else if (e.target.name === 'Mat') {
	        //     price.StartPrices[key].Mat = reverseFormatCurrency2(this.refs[ref3].value)
	        //     if (this.shouldUpdatePrices(price.StartPrices[key].Mat, this.state.price.StartPrices[key].Mat)) {
	        //       this.updatePrices(price).then(() => {
	        //         this.refs[ref3].value = formatCurrency2(price.StartPrices[key].Mat)
	        //       })
	        //     }
	        //   } else if (e.target.name === 'Net') {
	        //     price.StartPrices[key].Net = reverseFormatCurrency2(this.refs[ref4].value)
	        //     if (this.shouldUpdatePrices(price.StartPrices[key].Net, this.state.price.StartPrices[key].Net)) {
	        //       this.updatePrices(price).then(() => {
	        //         this.refs[ref4].value = formatCurrency2(price.StartPrices[key].Net)
	        //       })
	        //     }
	        //   } else if (e.target.name === 'Discount') {
	        //     price.StartPrices[key].Discount = reverseFormatCurrency2(transformPercent(this.refs[ref5].value, true))
	        //     if (this.shouldUpdatePrices(price.StartPrices[key].Discount, this.state.price.StartPrices[key].Discount)) {
	        //       this.updatePrices(price).then(() => {
	        //         this.refs[ref5].value = transformPercent(formatCurrency2(price.StartPrices[key].Discount))
	        //       })
	        //     }
	        //   }
	        // }
	
	        var onBlur = function onBlur(e) {
	          var name = e.name,
	              value = e.value;
	          var _state = _this9.state,
	              price = _state.price,
	              priceOriginal = _state.priceOriginal;
	
	
	          price.StartPrices[key][name] = value;
	
	          _this9.setState({
	            price: _extends({}, _this9.state.price, {
	              StartPrices: price.StartPrices
	            })
	          }, function () {
	            if (_this9.shouldUpdatePrices(price.StartPrices[key][name], priceOriginal.StartPrices[key][name])) {
	              _this9.updatePrices(price);
	            }
	          });
	        };
	
	        // Functions
	        var renderPrice = function renderPrice() {
	          if (canEditPrice) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'Price',
	              value: val.Price,
	              onBlur: onBlur,
	              size: size
	            });
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'price' },
	            (0, _currency.formatCurrency2)(val.Price)
	          );
	        };
	
	        var renderWorkunits = function renderWorkunits() {
	          if (canEditAE) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'AE',
	              value: val.AE,
	              onBlur: onBlur,
	              size: size
	            });
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'workUnits_small' },
	            (0, _currency.formatCurrency2)(val.AE, _this9.AERounding)
	          );
	        };
	
	        var renderMat = function renderMat() {
	          if (canEditMat) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'Mat',
	              value: val.Mat,
	              onBlur: onBlur,
	              size: size
	            });
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'mat' },
	            (0, _currency.formatCurrency2)(val.Mat)
	          );
	        };
	
	        var renderNet = function renderNet() {
	          if (!showNet) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'net' },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\xA0'
	              )
	            );
	          }
	
	          if (canEditNet) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'Net',
	              value: val.Net,
	              onBlur: onBlur,
	              size: size
	            });
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'Net' },
	            (0, _currency.formatCurrency2)(val.Net)
	          );
	        };
	
	        var renderDiscount = function renderDiscount() {
	          if (!showDiscount) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'discount' },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\xA0'
	              )
	            );
	          }
	
	          if (canEditDiscount) {
	            return _react2.default.createElement(_DecimalInput2.default, {
	              name: 'Discount',
	              value: val.Discount,
	              onBlur: onBlur,
	              onFocus: _percent.onPercentFocus,
	              transformValue: _percent.transformPercent,
	              size: size
	            });
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'discount' },
	            (0, _percent.transformPercent)((0, _currency.formatCurrency2)(val.Discount))
	          );
	        };
	
	        // Return
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { cols: cols, key: key },
	          _react2.default.createElement(
	            'span',
	            null,
	            val.Order,
	            '.'
	          ),
	          renderWorkunits(),
	          renderMat(),
	          renderPrice(),
	          renderDiscount(),
	          renderNet(),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _currency.formatCurrency2)(val.Env)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _currency.formatCurrency2)(val.Total)
	          ),
	          !_this9.onlyShow() && !isCustomer && _react2.default.createElement(_removeButton2.default, { onClick: deleteItem.bind(_this9, key), disabled: _this9.state.IsWorking, size: 's' })
	        );
	      };
	      var addMoreStartprices = function addMoreStartprices() {
	        var price = _this9.state.price;
	
	        var startPriceKey = 'new_startprice';
	        if (type > 0) startPriceKey += type;
	
	        var lastEditable = '';
	        if (canEditAE) lastEditable = 'AE';
	        if (canEditMat) lastEditable = 'Mat';
	        if (canEditPrice) lastEditable = 'Price';
	        if (canEditDiscount) lastEditable = 'Discount';
	        if (canEditNet) lastEditable = 'Net';
	
	        // Functions
	        var onChange = function onChange(e) {
	          var value = e.target.value;
	          _this9.setState(_defineProperty({}, startPriceKey, _extends({}, _this9.state[startPriceKey], _defineProperty({}, e.target.name, value))));
	        };
	        var formatPrice = function formatPrice(e) {
	          var value = e.target.value === '' ? '0' : e.target.value;
	          _this9.setState(_defineProperty({}, startPriceKey, _extends({}, _this9.state[startPriceKey], _defineProperty({}, e.target.name, (0, _currency.formatCurrency2)((0, _currency.reverseFormatCurrency2)(value))))));
	        };
	        var onKeyDown = function onKeyDown(e) {
	          if (e.key === 'Enter' || e.key === 'Tab') {
	            if (e.target.name === lastEditable) {
	              addItem();
	            }
	          }
	        };
	        var addItem = function addItem() {
	          var price = _extends({}, _this9.state.price);
	          var newItem = _extends({}, _this9.state[startPriceKey]);
	          newItem.Price = (0, _currency.reverseFormatCurrency2)(newItem.Price);
	          if ((0, _auth.hasAccess)([2], _this9.props.auth.user.UserType)) {
	            newItem.Price = 0;
	          }
	
	          newItem.AE = (0, _currency.reverseFormatCurrency2)(newItem.AE);
	          newItem.Mat = (0, _currency.reverseFormatCurrency2)(newItem.Mat);
	          newItem.Env = (0, _currency.reverseFormatCurrency2)(newItem.Env);
	          newItem.Net = (0, _currency.reverseFormatCurrency2)(newItem.Net);
	          newItem.Discount = (0, _currency.reverseFormatCurrency2)(newItem.Discount);
	          newItem.Type = type;
	
	          newItem.Price = typeof newItem.Price !== 'number' || isNaN(newItem.Price) ? 0 : newItem.Price;
	          newItem.AE = typeof newItem.AE !== 'number' || isNaN(newItem.AE) ? 0 : newItem.AE;
	          newItem.Mat = typeof newItem.Mat !== 'number' || isNaN(newItem.Mat) ? 0 : newItem.Mat;
	          newItem.Net = typeof newItem.Net !== 'number' || isNaN(newItem.Net) ? 0 : newItem.Net;
	          newItem.Env = typeof newItem.Env !== 'number' || isNaN(newItem.Env) ? 0 : newItem.Env;
	          newItem.Discount = typeof newItem.Discount !== 'number' || isNaN(newItem.Discount) ? 0 : newItem.Discount;
	
	          // if (typeof newItem.Price !== 'number' || isNaN(newItem.Price)) {
	          //   // Toastr
	          //   window.toastr.error(translation('13430'), translation('216'))
	          // } else {
	          price.StartPrices.push(newItem);
	          _this9.updatePrices(price);
	          // }
	        };
	        // Return
	        if (isCustomer) return null;
	
	        var count = price.StartPrices.filter(function (val) {
	          return val.Type === type;
	        }).length;
	
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { cols: cols },
	          _react2.default.createElement(
	            'span',
	            null,
	            count + 1,
	            '.'
	          ),
	          !(canEditAE || canEditNewAE) && _react2.default.createElement('span', null),
	          (canEditAE || canEditNewAE) && _react2.default.createElement(_text2.default, { name: 'AE', value: (0, _currency.formatCurrency2)(_this9.state[startPriceKey].AE, _this9.AERounding), onChange: onChange, onKeyDown: onKeyDown, size: 's' }),
	          !(canEditMat || canEditNewMat) && _react2.default.createElement('span', null),
	          (canEditMat || canEditNewMat) && _react2.default.createElement(_text2.default, { name: 'Mat', value: _this9.state[startPriceKey].Mat, onChange: onChange, onKeyDown: onKeyDown, size: 's' }),
	          !canEditPrice && _react2.default.createElement('span', null),
	          canEditPrice && _react2.default.createElement(_text2.default, { name: 'Price', value: _this9.state[startPriceKey].Price, onChange: onChange, onBlur: formatPrice, onKeyDown: onKeyDown, size: 's' }),
	          showDiscount && canEditDiscount && _react2.default.createElement(_text2.default, { name: 'Discount', value: _this9.state[startPriceKey].Discount, onChange: onChange, onKeyDown: onKeyDown, size: 's' }) || _react2.default.createElement('span', null),
	          !canEditNet && _react2.default.createElement('span', null),
	          canEditNet && _react2.default.createElement(_text2.default, { name: 'Net', value: _this9.state[startPriceKey].Net, onChange: onChange, onKeyDown: onKeyDown, size: 's' }),
	          _react2.default.createElement('span', null),
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(_addButton2.default, { onClick: addItem, disabled: _this9.state.IsWorking, size: 's' })
	        );
	      };
	
	      // Set title depending on startprice type being rendered.
	      var title = '';
	      var helpText = '';
	      switch (type) {
	        case 0:
	          title = (0, _helpers.translation)('2247'); // car
	          helpText = (0, _helpers.translation)('1960');
	          break;
	        case 1:
	          title = (0, _helpers.translation)('2246'); // no car
	          helpText = (0, _helpers.translation)('1960');
	          break;
	      }
	
	      var mat = '13443';
	      if (this.state.department !== 0) {
	        mat = '14788';
	      }
	
	      return _react2.default.createElement(
	        _tableContainer2.default,
	        { fullWidth: true },
	        _react2.default.createElement(
	          _tableExpand2.default,
	          null,
	          _react2.default.createElement(
	            _tableHeader2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              title,
	              _react2.default.createElement(_helpIcon2.default, { helpText: helpText })
	            )
	          ),
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true, cols: cols },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('13346')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('885')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(mat)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('641')
	            ),
	            showDiscount && _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('15014')
	            ) || _react2.default.createElement(
	              'span',
	              null,
	              '\xA0'
	            ),
	            showNet && _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1305')
	            ) || _react2.default.createElement(
	              'span',
	              null,
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1044')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('393')
	            ),
	            _react2.default.createElement('span', null)
	          ),
	          price.StartPrices.map(renderStartprice),
	          !this.onlyShow() && addMoreStartprices()
	        )
	      );
	    }
	  }, {
	    key: 'renderPriceParts',
	    value: function renderPriceParts(classnameList) {
	      var _this10 = this;
	
	      if (this.state.parts.length === 0 && this.state.bodyParts.length === 0) return null;
	      var parts = this.state.parts.length > 0 ? this.state.parts : this.state.bodyParts;
	      var config = this.state.parts.length > 0 ? (0, _config.getTaskPriceConfig)((0, _config.createConfigContext)(this.props.auth, this.state.price)) : (0, _config.getBodyTaskPriceConfig)((0, _config.createConfigContext)(this.props.auth, this.state.price));
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) && this.state.price.PriceType === 5) return _react2.default.createElement('div', { className: 'col' });
	      // console.log('Sales car - this.props.partners && hasAccess([2], this.props.auth.user.UserType) ', this.props.partners, hasAccess([2], this.props.auth.user.UserType))
	      // console.log('renderPriceParts config' , config)
	      var showCustomerPartners = this.props.partners && (0, _auth.hasAccess)([2], this.props.auth.user.UserType);
	      // if (this.props.partners) {
	      //   if (hasAccess([2], this.props.auth.user.UserType)) {
	      //     return (
	      //       <div className={classnameList}>
	      //         {this.renderStartPrice([[0, 1500]], 0)}
	      //         {this.renderStartPrice([[0, 1500]], 1)}
	      //         {this.renderAddons([[0, 1500]])}
	      //         {this.renderCustomersPartners()}
	      //       </div>
	      //     )
	      //   }
	      // }
	
	      var renderContent = function renderContent() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _this10.renderDiscountPrice(),
	          _this10.renderStartPrice([[0, 10000]], 0),
	          _this10.renderStartPrice([[0, 10000]], 1),
	          _this10.renderAddons([[0, 10000]]),
	          !showCustomerPartners && parts.map(_this10.renderTaskPriceParts.bind(_this10, config)),
	          showCustomerPartners && _this10.renderCustomersPartners()
	        );
	      };
	
	      if (classnameList) {
	        return _react2.default.createElement(
	          _col2.default,
	          { span: '4' },
	          renderContent()
	        );
	      }
	
	      return renderContent();
	      // return (
	      //   <div className={classnameList}>
	      //     {this.renderDiscountPrice()}
	      //     {this.renderStartPrice([[0, 1500]], 0)}
	      //     {this.renderStartPrice([[0, 1500]], 1)}
	      //     {this.renderAddons([[0, 1500]])}
	      //     {parts.map(this.renderTaskPriceParts.bind(this, config))}
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'renderTaskPriceParts',
	    value: function renderTaskPriceParts(config, val, key) {
	      return _react2.default.createElement(_PriceItemGroup2.default, {
	        config: config,
	        items: val.tasks,
	        groupId: val.part.PartItemId,
	        title: (0, _helpers.translation)(val.part.DictionaryKey),
	        onAdd: this.updateOrAddItem,
	        onDelete: this.deleteItem,
	        onUpdate: this.updateOrAddItem,
	        onDragged: this.moveItem,
	        disabled: this.state.IsWorking,
	        key: key });
	    }
	  }, {
	    key: 'deleteItem',
	    value: function deleteItem(item) {
	      item.IsDeleted = true;
	      this.updateOrAddItem(item);
	    }
	  }, {
	    key: 'moveItem',
	    value: function moveItem(item, newPosition) {
	      var _this11 = this;
	
	      if (item.SortIndex === undefined) return; // Need sort index to make reordering work.
	      var oldSortIndex = item.SortIndex;
	
	      var listName = this.getItemListName(item);
	      var idField = this.getItemIdField(item);
	      var price = _extends({}, this.state.price);
	      // if (price.Department === 1) {
	      //   if (idField === 'TaskPriceId') {
	      //     idField = 'BodyTaskPriceId'
	      //     item.BodyTaskPriceId = item.TaskPriceId
	      //     item.TaskPriceId = null
	      //   }
	      //   if (listName === 'TaskPrices') listName = 'BodyTaskPrices'
	      //   console.log('item to move ', item)
	      // }
	      var hasPartId = item.PartItemId !== undefined;
	      var hasPartItem = item.PartItem !== undefined && item.PartItem.PartItemId !== undefined;
	      var list = price[listName];
	      item.SortIndex = newPosition;
	      this.setState({ IsWorking: true });
	      this.props.reorderPriceListItem(item).then(function (res) {
	        var _loop = function _loop(i) {
	          var listItem = list.find(function (li) {
	            return li[idField] === res.data[i][idField];
	          });
	          if (listItem !== undefined) {
	            listItem.SortIndex = res.data[i].SortIndex;
	          }
	        };
	
	        // Assign sortindex from result to all items
	        for (var i = 0; i < res.data.length; i++) {
	          _loop(i);
	        }
	      }, function () {
	        // If reorder failed on server, revert to old position.
	        item.SortIndex = oldSortIndex;
	
	        // show error toast
	      }).finally(function () {
	        // Sort list containing item, to make sure the list and visual dom matches.
	        var sorter = function sorter(a, b) {
	          if (hasPartId) {
	            if (a.PartItemId !== b.PartItemId) return a.PartItemId - b.PartItemId;
	          } else if (hasPartItem) {
	            if (a.PartItem.PartItemId !== b.PartItem.PartItemId) return a.PartItem.PartItemId - b.PartItem.PartItemId;
	          }
	          return a.SortIndex - b.SortIndex;
	        };
	
	        if (list !== null) {
	          list = list.sort(function (a, b) {
	            return sorter(a, b);
	          });
	          price[listName] = list;
	          _this11.setState({
	            price: price,
	            IsWorking: false
	          });
	          // console.log('updated list', list.filter((a) => a.SortIndex !== null).map(i => { return { Id: i[this.getItemIdField(i)], TaskName: i.TaskName, SortIndex: i.SortIndex, PartItemId: (hasPartId ? i.PartItemId : i.PartItem.PartItemId) } }))
	        }
	      });
	    }
	  }, {
	    key: 'updateOrAddItem',
	    value: function updateOrAddItem(item) {
	      var doPost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var idField = this.getItemIdField(item);
	      var listName = this.getItemListName(item);
	      if (listName === null || idField === null) {
	        console.error('Could not update or add item!', item);
	        return;
	      }
	
	      // console.log('Updating item', item, 'adding to ', listName, '(id ' + item[idField] + ')')
	      var price = _extends({}, this.state.price);
	      var list = price[listName];
	      if (item[idField] > 0) {
	        for (var i; i < list.length; i++) {
	          var oldItem = list[i];
	          if (oldItem[idField] === item[idField]) {
	            list[i] = item;
	            // updated = true
	            break;
	          }
	        }
	      } else {
	        item[idField] = 0;
	        list.push(item);
	      }
	      price[listName] = list;
	
	      // Finally send to api.
	      if (doPost) {
	        this.updatePrices(price);
	      }
	    }
	  }, {
	    key: 'getItemIdField',
	    value: function getItemIdField(item) {
	      // Find id field
	      var idFields = [];
	      var fields = Object.keys(item);
	      for (var f in fields) {
	        var field = fields[f];
	        if (field.toLowerCase().endsWith('id')) {
	          idFields.push(field);
	        }
	      }
	
	      // Determine correct id field.
	      for (var _f in idFields) {
	        if (item[idFields[_f]] === undefined || item[idFields[_f]] === null || !(typeof item[idFields[_f]] === 'number')) continue;
	        switch (idFields[_f].toLowerCase()) {
	          case 'bodytaskpriceid':
	          case 'taskpriceid':
	          case 'estimationtaskid':
	          case 'addonstarttimeid':
	          case 'addonpartid':
	            return idFields[_f];
	        }
	      }
	      console.error('Could not determine Id field of item!', item);
	      return null;
	    }
	  }, {
	    key: 'getItemListName',
	    value: function getItemListName(item) {
	      // Find id field
	      var idFields = [];
	      var fields = Object.keys(item);
	      for (var f in fields) {
	        var field = fields[f];
	        if (field.toLowerCase().endsWith('id')) {
	          idFields.push(field);
	        }
	      }
	      // console.log('getItemListName id fields', idFields)
	      // Determine correct id field.
	      for (var _f2 in idFields) {
	        if (item[idFields[_f2]] === undefined || item[idFields[_f2]] === null || !(typeof item[idFields[_f2]] === 'number') || item[idFields[_f2]] < 0) continue;
	        switch (idFields[_f2].toLowerCase()) {
	          case 'bodytaskpriceid':
	            return 'BodyTaskPrices';
	          case 'taskpriceid':
	            return 'TaskPrices';
	          case 'estimationtaskid':
	            return 'EstimationTasks';
	          case 'addonstarttimeid':
	            return 'AddonStartTimes';
	          case 'addonpartid':
	            return 'AddonParts';
	        }
	      }
	
	      console.error('Could not determine List name of item!', item);
	      return null;
	    }
	
	    // Should render
	    // Customer: 1 - Shop: 2
	
	  }, {
	    key: 'shouldRender',
	    value: function shouldRender(type) {
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        return type === 2;
	      }
	      // if (this.state.price.Name === null && this.state.price.CustomerId === 0 && type === 2) {
	      if (this.state.price.CustomerId === 0 && type === 2) {
	        return true;
	      }
	      // if ((this.state.price.Name !== null || this.state.price.CustomerId !== 0) && type === 1) {
	      if (this.state.price.CustomerId !== 0 && type === 1) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'switchRecommended',
	    value: function switchRecommended(e) {
	      var value = e.target.checked;
	      var price = _extends({}, this.state.price);
	      price.UseRecommended = value;
	      this.updatePrices(price);
	    }
	  }, {
	    key: 'renderRecommendedSelector',
	    value: function renderRecommendedSelector() {
	      var _this12 = this;
	
	      var DISABLE_RECOMMENDED_TYPES = [-1, 0, 1, 2, 3, 8];
	      if (DISABLE_RECOMMENDED_TYPES.find(function (val) {
	        val === _this12.state.price.PriceType;
	      }) === undefined) return null;
	      // if (this.state.price.PriceType <= 3) return null  // Can no longer choose to use recommended rates for undefined, sales, private and warranty.
	      // if (!this.state.price.HasParent && (this.state.price.PriceType <= 3)) return null
	      if (!(0, _auth.hasAccess)([3, 4, 7], this.props.auth.user.UserType)) return null;
	      // if (this.state.price.Name !== null) return null
	      // Recommended text
	      var recommendedText = function recommendedText() {
	        var translationText = (0, _helpers.translation)('13474');
	        if (_this12.props.customer) {
	          return translationText.replace('[NAME]', '');
	        }
	        return translationText.replace('[NAME]', _this12.props.auth.user.ChainName);
	      };
	
	      // Return
	      return _react2.default.createElement(
	        _inline2.default,
	        null,
	        _react2.default.createElement(_panelHeader2.default, { text: recommendedText() }),
	        _react2.default.createElement(_switch2.default, { name: 'UseRecommended', onChange: this.switchRecommended, checked: this.state.price.UseRecommended })
	      );
	    }
	  }, {
	    key: 'renderCustomAgreement',
	    value: function renderCustomAgreement() {
	      var _this13 = this;
	
	      // if (this.state.price.Name === null) return null
	      var price = this.state.price;
	
	      var isCustomer = (0, _auth.hasAccess)([4], this.props.auth.user.UserType);
	      // const isDisabled = parseInt(this.props.auth.user.ShopId, 10) !== price.ShopId
	      // let isCustomer = this.props.customer
	      var renderAgreement = function renderAgreement() {
	        var onDelete = function onDelete() {
	          _this13.setState({
	            confirmDelete: {
	              open: true
	            }
	          });
	        };
	
	        var onActive = function onActive(e) {
	          _this13.setState({
	            confirmActive: {
	              open: true,
	              type: e.target.checked ? 1 : 0
	            }
	          });
	        };
	
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('13472') },
	          _react2.default.createElement(_text2.default, { name: 'Name', value: price.Name, onChange: _this13.onInputChange, onBlur: _this13.onInputBlur, disabled: isCustomer, labelText: (0, _helpers.translation)('30') }),
	          _react2.default.createElement(_switch2.default, { name: 'Active', onChange: onActive, checked: price.Active, disabled: isCustomer, labelText: (0, _helpers.translation)('295') }),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true },
	            !isCustomer && _react2.default.createElement(_button2.default, { style: 'alert', onClick: onDelete, labelText: (0, _helpers.translation)('1822') }),
	            _react2.default.createElement(_button2.default, { style: 'link', onClick: _this13.showPriceModelLog, labelText: (0, _helpers.translation)('1865') })
	          ),
	          _react2.default.createElement(_PriceModelLogModal2.default, { priceModelId: price.PriceModelId, show: _this13.state.showPriceModelLog, onClose: _this13.showPriceModelLog })
	        );
	        // return (
	        //   <div className='white__box'>
	        //     <div className='title'>{translation('13472')}</div>
	        //     <div className='form fifty'>
	        //       <div className='control__group'>
	        //         <label>{translation('30')}</label>
	        //         {!isCustomer && (<input type='text' name='Name' value={price.Name} onChange={this.onInputChange} onBlur={this.onInputBlur} />)}
	        //         {isCustomer && (<label>{price.Name}</label>)}
	        //       </div>
	        //       <div className='control__group radio__custom__outer'>
	        //         <label>{translation('295')}</label>
	        //         <div className='radio__custom__wrapper'>
	        //           <div className='radio__custom'>
	        //             <input type='radio' id='active_yes' name='Active' value='yes' onChange={this.onInputChange} checked={price.Active} disabled={isCustomer} />
	        //             <label htmlFor='active_yes'>{translation('47')}</label>
	        //           </div>
	        //           <div className='radio__custom'>
	        //             <input type='radio' id='active_no' name='Active' value='no' onChange={this.onInputChange} checked={!price.Active} disabled={isCustomer} />
	        //             <label htmlFor='active_no'>{translation('48')}</label>
	        //           </div>
	        //         </div>
	        //         <div>
	        //           {!isCustomer && (<button className='button primary button_half' onClick={onDelete}>{translation('1822')}</button>)}
	        //           <button className='button primary button_half' onClick={this.showPriceModelLog} >{translation('1865')}</button>
	        //           <PriceModelLogModal priceModelId={price.PriceModelId} show={this.state.showPriceModelLog} onClose={this.showPriceModelLog} />
	        //         </div>
	        //       </div>
	        //     </div>
	        //   </div>
	        // )
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderAgreement(),
	        this.renderOrderTypes(),
	        this.renderCustomers(),
	        this.renderBrands()
	      );
	    }
	  }, {
	    key: 'showPriceModelLog',
	    value: function showPriceModelLog() {
	      this.props.triggerPopup(!this.state.showPriceModelLog);
	      this.setState({
	        showPriceModelLog: !this.state.showPriceModelLog
	      });
	    }
	  }, {
	    key: 'renderSubContractors',
	    value: function renderSubContractors() {
	      var _this14 = this;
	
	      if (!(0, _auth.hasAccess)([600], this.props.auth.user.UserType)) return null;
	      var price = this.state.price;
	      // Render sub contractor
	
	      var renderContractor = function renderContractor(item, key) {
	        var onInputBlur = function onInputBlur(e) {
	          var price = _extends({}, _this14.state.price);
	          price.PriceModelSubContractors[key][e.target.name] = e.target.value;
	          _this14.updatePrices(price);
	        };
	        var onInputChange = function onInputChange(e) {
	          var price = _extends({}, _this14.state.price);
	          var name = e.target.name.split('_')[0];
	          price.PriceModelSubContractors[key][name] = e.target.value === 'yes';
	          _this14.updatePrices(price);
	        };
	        // Keys
	        var key1 = 'PriceHourly_' + item.SubContractorId + '_' + item.PriceHourly;
	        var key2 = 'PriceMaterial_' + item.SubContractorId + '_' + item.PriceMaterial;
	        var key3 = 'PriceEnvironment_' + item.SubContractorId + '_' + item.PriceEnvironment;
	        var key4 = 'PriceDiscount_' + item.SubContractorId + '_' + item.PriceDiscount;
	        // Render customers
	        var customers = [];
	        price.PriceModelCustomers.map(function (val) {
	          if (val.ShopId === item.CompanyId) {
	            customers.push(val.CustomerName);
	          }
	        });
	        var customersHtml = "<span class='hint--bottom-left' aria-label='" + customers.join('&#xa;') + "'><img src='/images/icons/menu/Customers-Black.png' /></span>";
	
	        // Return
	        return _react2.default.createElement(
	          'div',
	          { className: 'form fifty', key: key },
	          _react2.default.createElement(
	            'strong',
	            { className: 'clearfix' },
	            item.CompanyName,
	            ' ',
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: customersHtml } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('419')
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'PriceHourly', defaultValue: item.PriceHourly, onBlur: onInputBlur, key: key1 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('13338'),
	              ' (%)'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'PriceMaterial', defaultValue: item.PriceMaterial, onBlur: onInputBlur, key: key2 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('13339'),
	              ' (%)'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'PriceEnvironment', defaultValue: item.PriceEnvironment, onBlur: onInputBlur, key: key3 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('1199'),
	              ' (%)'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'PriceDiscount', defaultValue: item.PriceDiscount, onBlur: onInputBlur, key: key4 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'control__group radio__custom__outer' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('1236')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'radio__custom__wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'radio__custom' },
	                _react2.default.createElement('input', { type: 'radio', id: 'discount_yes_' + item.SubContractorId, name: 'IsEnvironmentDiscount_' + item.SubContractorId, value: 'yes', onChange: onInputChange, checked: item.IsEnvironmentDiscount }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'discount_yes_' + item.SubContractorId },
	                  (0, _helpers.translation)('47')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'radio__custom' },
	                _react2.default.createElement('input', { type: 'radio', id: 'discount_no_' + item.SubContractorId, name: 'IsEnvironmentDiscount_' + item.SubContractorId, value: 'no', onChange: onInputChange, checked: !item.IsEnvironmentDiscount }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'discount_no_' + item.SubContractorId },
	                  (0, _helpers.translation)('48')
	                )
	              )
	            )
	          )
	        );
	      };
	
	      // Return
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('1737') },
	          price.PriceModelSubContractors.map(renderContractor)
	        )
	      );
	    }
	  }, {
	    key: 'renderOrderTypes',
	    value: function renderOrderTypes() {
	      // let isCustomer = this.props.customer
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return null;
	      if ((0, _auth.hasAccess)([3, 7], this.props.auth.user.UserType) && !this.props.customer) return null;
	      if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType) && !this.props.partners) return null; // If chain creating work provider..
	      // console.log('ordertype', this.props.auth.user.UserType)
	      var price = this.state.price;
	
	      var isDisabled = (0, _auth.hasAccess)([4], this.props.auth.user.UserType) || parseInt(this.props.auth.user.ShopId, 10) !== price.ShopId;
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('525') },
	        _react2.default.createElement(_radio2.default, { name: 'PriceType', value: '1', onChange: this.changeType, checked: price.PriceType === 1, disabled: isDisabled, labelText: (0, _helpers.translation)('71') }),
	        _react2.default.createElement(_radio2.default, { name: 'PriceType', value: '3', onChange: this.changeType, checked: price.PriceType === 3, disabled: isDisabled, labelText: (0, _helpers.translation)('13361') }),
	        _react2.default.createElement(_radio2.default, { name: 'PriceType', value: '2', onChange: this.changeType, checked: price.PriceType === 2, disabled: isDisabled, labelText: (0, _helpers.translation)('785') }),
	        _react2.default.createElement(_radio2.default, { name: 'PriceType', value: '8', onChange: this.changeType, checked: price.PriceType === 8, disabled: isDisabled, labelText: (0, _helpers.translation)('1396') }),
	        this.props.partners && _react2.default.createElement(_radio2.default, { name: 'PriceType', value: '5', onChange: this.changeType, checked: price.PriceType === 5, labelText: (0, _helpers.translation)('13363') })
	      );
	      // return (
	      //   <div className='white__box'>
	      //     <div className='title'>{translation('525')}</div>
	      //     <div className='radio__custom__wrapper'>
	      //       <div className='radio__custom'>
	      //         <input type='radio' id='ordertype_1' name='PriceType' value='1' onChange={this.changeType} checked={price.PriceType === 1} disabled={isCustomer} />
	      //         <label htmlFor='ordertype_1'>{translation('71')}</label>
	      //       </div>
	      //       <div className='radio__custom'>
	      //         <input type='radio' id='ordertype_3' name='PriceType' value='3' onChange={this.changeType} checked={price.PriceType === 3} disabled={isCustomer} />
	      //         <label htmlFor='ordertype_3'>{translation('13361')}</label>
	      //       </div>
	      //       <div className='radio__custom'>
	      //         <input type='radio' id='ordertype_2' name='PriceType' value='2' onChange={this.changeType} checked={price.PriceType === 2} disabled={isCustomer} />
	      //         <label htmlFor='ordertype_2'>{translation('785')}</label>
	      //       </div>
	      //       <div className='radio__custom'>
	      //         <input type='radio' id='ordertype_8' name='PriceType' value='8' onChange={this.changeType} checked={price.PriceType === 8} disabled={isCustomer} />
	      //         <label htmlFor='ordertype_8'>{translation('1396')}</label>
	      //       </div>
	      //       {this.props.partners && (
	      //         <div className='radio__custom'>
	      //           <input type='radio' id='ordertype_5' name='PriceType' value='5' onChange={this.changeType} checked={price.PriceType === 5} />
	      //           <label htmlFor='ordertype_5'>{translation('13363')}</label>
	      //         </div>
	      //       )}
	      //     </div>
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'renderCustomersPartners',
	    value: function renderCustomersPartners() {
	      var _this15 = this;
	
	      var price = _extends({}, this.state.price);
	      // Render shop
	      var renderShop = function renderShop(val, key) {
	        var onChange = function onChange(e) {
	          e.persist();
	          _this15.setState({
	            ShopId: parseInt(e.target.value),
	            customers: []
	          }, function () {
	            _this15.props.getCustomers(e.target.value).then(function (res) {
	              _this15.setState({
	                customers: res.data
	              });
	            }, function () {
	              console.log('Err getting customers');
	            });
	          });
	        };
	        return _react2.default.createElement(_radio2.default, { key: key, labelText: val.ShopName, id: 'ShopId_' + val.ShopId, name: 'ShopId', value: val.ShopId, onChange: onChange, checked: _this15.state.ShopId === val.ShopId });
	      };
	      // Render customer
	      var renderCustomer = function renderCustomer(val, key) {
	        return _react2.default.createElement(_check2.default, { key: key, labelText: val.Name, id: 'CustomerId_' + val.CustomerId, name: 'CustomerId', value: val.CustomerId, ref: 'CustomerId_' + val.CustomerId });
	      };
	      // Add
	      var addItems = function addItems() {
	        var selectedCustomers = [];
	        var price = _extends({}, _this15.state.price);
	        Object.keys(_this15.refs).map(function (val, key) {
	          if (val.indexOf('CustomerId') !== -1) {
	            if (_this15.refs[val].checked) {
	              selectedCustomers.push(val.split('_')[1]);
	              // Add customer
	              price.PriceModelCustomers.push({
	                CustomerId: val.split('_')[1]
	              });
	            }
	          }
	        });
	        if (selectedCustomers.length === 0) {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('1736'), (0, _helpers.translation)('216'));
	        } else {
	          // Add shop
	          price.PriceModelSubContractors.push({
	            CompanyId: _this15.state.ShopId
	          });
	          // Update prices
	          _this15.updatePrices(price);
	        }
	      };
	      // Render SubContractor
	      var renderSubcontractor = function renderSubcontractor(item, key) {
	        var customers = price.PriceModelCustomers.filter(function (val) {
	          return val.ShopId === item.CompanyId;
	        });
	        if (customers.length === 0) return null;
	        var renderCustomer = function renderCustomer(val, k) {
	          var deleteItem = function deleteItem() {
	            var price = _extends({}, _this15.state.price);
	            price.PriceModelCustomers.map(function (item) {
	              if (item.CustomerId === val.CustomerId) {
	                item.IsDeleted = true;
	              }
	            });
	            _this15.updatePrices(price);
	          };
	          return _react2.default.createElement(
	            'li',
	            { key: k, className: 'clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'customer' },
	              val.CustomerName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'buttonWrap' },
	              _react2.default.createElement(_removeButton2.default, { onClick: deleteItem, disabled: _this15.state.IsWorking, size: 's' })
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            'strong',
	            null,
	            item.CompanyName
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement('li', null),
	            customers.map(renderCustomer)
	          )
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('14') },
	        _react2.default.createElement(
	          'div',
	          { className: 'partnerCustomers' },
	          _react2.default.createElement(
	            'div',
	            { className: 'scrollable_list' },
	            this.props.companies.map(renderShop)
	          ),
	          this.state.customers.length !== 0 && _react2.default.createElement(
	            'div',
	            { className: 'scrollable_list' },
	            this.state.customers.map(renderCustomer)
	          ),
	          this.state.ShopId !== 0 && _react2.default.createElement(_button2.default, { onClick: addItems, labelText: (0, _helpers.translation)('1208') }),
	          price.PriceModelSubContractors.length !== 0 && _react2.default.createElement(
	            'div',
	            { className: 'subcontractors' },
	            price.PriceModelSubContractors.map(renderSubcontractor)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      var _this16 = this;
	
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType) || this.props.partners) return null;
	      if ((0, _auth.hasAccess)([2, 3, 4, 7], this.props.auth.user.UserType)) return null;
	      var price = this.state.price;
	      var customers = this.props.customers;
	      // let ref = 'customersid'
	
	      var onChange = function onChange(e) {
	        if (e.target.name === 'customers') {
	          _this16.setState({
	            currentCustomer: e.target.value
	          });
	        }
	      };
	
	      // Add customers
	      var addItem = function addItem() {
	        // let id = parseInt(this.refs[ref].value)
	        var id = parseInt(_this16.state.currentCustomer);
	
	        if (id !== 0) {
	          var _price = _extends({}, _this16.state.price);
	          _price.PriceModelCustomers.push({
	            CustomerId: id
	          });
	
	          _this16.updatePrices(_price).then(function () {
	            // this.refs[ref].value = 0
	            _this16.setState({
	              currentCustomer: '0'
	            });
	          });
	        }
	      };
	
	      // Render customer
	      var renderCustomer = function renderCustomer(val, key) {
	        // Delete item
	        var deleteItem = function deleteItem(e) {
	          var price = _extends({}, _this16.state.price);
	          price.PriceModelCustomers[key].IsDeleted = true;
	          _this16.updatePrices(price);
	        };
	
	        // Return
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              val.CustomerName
	            ),
	            _react2.default.createElement(_removeButton2.default, { onClick: deleteItem, disabled: _this16.state.IsWorking, size: 's' })
	          )
	        );
	      };
	
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('14') },
	        _react2.default.createElement(_radio2.default, { name: 'CustomerSelectionType', value: '0', onChange: this.changeType, checked: price.CustomerSelectionType === 0, labelText: (0, _helpers.translation)('381') }),
	        _react2.default.createElement(_radio2.default, { name: 'CustomerSelectionType', value: '1', onChange: this.changeType, checked: price.CustomerSelectionType === 1, labelText: (0, _helpers.translation)('13475') }),
	        price.CustomerSelectionType === 1 && _react2.default.createElement(
	          'ul',
	          null,
	          price.PriceModelCustomers.map(renderCustomer),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _inline2.default,
	              { fillChildNum: [0], block: true },
	              _react2.default.createElement(
	                _dropDown2.default,
	                { name: 'customers', value: this.state.currentCustomer, onChange: onChange },
	                _react2.default.createElement(
	                  'option',
	                  { value: '0' },
	                  '\xA0'
	                ),
	                customers.map(function (val, key) {
	                  return _react2.default.createElement(
	                    'option',
	                    { value: val.CustomerId, key: key },
	                    val.Name
	                  );
	                })
	              ),
	              _react2.default.createElement(_addButton2.default, { onClick: addItem, disabled: this.state.IsWorking, size: 's' })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderBrands',
	    value: function renderBrands() {
	      var _this17 = this;
	
	      // let isCustomer = this.props.customer
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return null;
	      var price = this.state.price;
	      var brands = this.props.brands;
	
	      var isDisabled = (0, _auth.hasAccess)([4], this.props.auth.user.UserType) || parseInt(this.props.auth.user.ShopId, 10) !== price.ShopId;
	      // console.log('Brands: ', brands.length)
	      // let ref = 'brandsid'
	
	      var onChange = function onChange(e) {
	        if (e.target.name === 'brands') {
	          _this17.setState({
	            currentBrand: e.target.value
	          });
	        }
	      };
	
	      // Add customers
	      var addItem = function addItem() {
	        // let id = parseInt(this.refs[ref].value)
	        var id = parseInt(_this17.state.currentBrand);
	
	        if (id !== 0) {
	          var _price2 = _extends({}, _this17.state.price);
	          _price2.PriceModelBrands.push({
	            BrandId: id
	          });
	
	          _this17.updatePrices(_price2).then(function () {
	            // this.refs[ref].value = 0
	            _this17.setState({
	              currentBrand: '0'
	            });
	            _this17.props.getPriceLists(_this17.props);
	          });
	        }
	      };
	
	      // Render brand
	      var renderBrand = function renderBrand(val, key) {
	        // Delete item
	        var deleteItem = function deleteItem(e) {
	          var price = _extends({}, _this17.state.price);
	          price.PriceModelBrands[key].IsDeleted = true;
	          _this17.updatePrices(price).then(function (res) {
	            _this17.props.getPriceLists(_this17.props);
	          });
	        };
	
	        // Return
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true, key: key },
	          _react2.default.createElement(
	            'span',
	            null,
	            val.BrandName
	          ),
	          _react2.default.createElement(_removeButton2.default, { onClick: deleteItem, disabled: _this17.state.IsWorking, size: 'm' })
	        );
	      };
	
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('13473'), helpText: (0, _helpers.translation)('1953') },
	        _react2.default.createElement(_radio2.default, { name: 'BrandSelectionType', value: '0', onChange: this.changeType, checked: price.BrandSelectionType === 0, disabled: isDisabled, labelText: (0, _helpers.translation)('381') }),
	        _react2.default.createElement(_radio2.default, { name: 'BrandSelectionType', value: '1', onChange: this.changeType, checked: price.BrandSelectionType === 1, disabled: isDisabled, labelText: (0, _helpers.translation)('13475') }),
	        price.BrandSelectionType === 1 && _react2.default.createElement(
	          'div',
	          { className: 'brands' },
	          price.PriceModelBrands.map(renderBrand),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'brands', value: this.state.currentBrand, onChange: onChange },
	              _react2.default.createElement(
	                'option',
	                { value: '0' },
	                '\xA0'
	              ),
	              brands.map(function (val, key) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: val.Id, key: key },
	                  (0, _helpers.translation)(val.Name)
	                );
	              })
	            ),
	            _react2.default.createElement(_addButton2.default, { onClick: addItem, disabled: this.state.IsWorking })
	          )
	        )
	      );
	    }
	
	    // Renders the fixed unit/discount box
	
	  }, {
	    key: 'renderDiscountPrice',
	    value: function renderDiscountPrice() {
	      var _this18 = this;
	
	      if ((0, _auth.hasAccess)([4, 6], this.props.auth.user.UserType)) return null;
	      if (parseInt(this.props.auth.user.ShopId, 10) !== this.state.price.ShopId) return null;
	      if (this.state.price.Department !== 0) return null;
	      // Only show on custom views
	      // if (this.state.price.Name === null && this.state.price.CustomerId === 0) return null
	      if (this.state.price.CustomerId === 0) return null;
	
	      var size = 'm';
	
	      var ref1 = 'discount_unit';
	      var ref2 = 'discount_discount';
	      // Apply
	      var apply = function apply(type, e) {
	        var price = _extends({}, _this18.state.price);
	        if (type === 'unit') {
	          price.FixedUnitPrice = (0, _currency.reverseFormatCurrency2)(_this18.refs[ref1].value);
	          price.FixedDiscount = 0;
	          price.FixedPriceType = 1;
	        } else if (type === 'discount') {
	          price.FixedUnitPrice = 0;
	          price.FixedDiscount = (0, _currency.reverseFormatCurrency2)(_this18.refs[ref2].value);
	          price.FixedPriceType = 2;
	        }
	        _this18.updatePrices(price).then(function () {
	          _this18.refs[ref1].value = '';
	          _this18.refs[ref2].value = '';
	          _this18.setState({
	            confirm: {
	              open: false,
	              type: 0
	            }
	          });
	        });
	      };
	      // Format price
	      var formatPrice = function formatPrice(e) {
	        var value = e.target.value === '' ? '0' : e.target.value;
	        var currencyValue = (0, _currency.formatCurrency2)((0, _currency.reverseFormatCurrency2)(value));
	        if (e.target.name === 'unit') {
	          _this18.refs[ref1].value = currencyValue;
	        } else {
	          _this18.refs[ref2].value = currencyValue;
	        }
	      };
	      // Open portal
	      var openPortal = function openPortal(type) {
	        _this18.setState({
	          confirm: {
	            open: true,
	            type: type
	          }
	        });
	      };
	      var renderText = function renderText() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)('2017')
	        );
	      };
	      // Return
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('2258') },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [3, 2, 1] },
	              _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('13476'), helpText: (0, _helpers.translation)('2080') }),
	              _react2.default.createElement(_text2.default, { name: 'unit', ref: ref1, onBlur: formatPrice, size: size }),
	              _react2.default.createElement(_button2.default, { style: 'link', onClick: openPortal.bind(this, 'unit'), labelText: (0, _helpers.translation)('1218'), size: size })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [3, 2, 1] },
	              _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('13477') + ' (%)', helpText: (0, _helpers.translation)('2081') }),
	              _react2.default.createElement(_text2.default, { name: 'discount', ref: ref2, onBlur: formatPrice, size: size }),
	              _react2.default.createElement(_button2.default, { style: 'link', onClick: openPortal.bind(this, 'discount'), labelText: (0, _helpers.translation)('1218'), size: size })
	            )
	          )
	        ),
	        this.state.confirm.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: this.onPortalClose.bind(this, 'confirm') },
	          _react2.default.createElement(_Confirm2.default, { renderText: renderText, confirm: apply.bind(this, this.state.confirm.type), notConfirm: this.onPortalClose.bind(this, 'confirm') })
	        )
	      );
	    }
	  }, {
	    key: 'renderIndexAdjustments',
	    value: function renderIndexAdjustments() {
	      var _this19 = this;
	
	      // Do not render if estimation type model
	      if (this.state.price.PriceType === 5) return null;
	
	      // console.log('UserType = ', this.props.auth.user.UserType, (this.props.partners ? 'Partner = true' : 'partner = fale'))
	      // Render for wp, and shop type users editing a customer
	      var access = false;
	      if ((0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType) && this.props.customer) access = true;
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) access = true;
	      if (parseInt(this.props.auth.user.ShopId, 10) !== this.state.price.ShopId) access = false;
	      if (access === false) return; // Det er sent..
	
	      if (this.props.partners) {
	        // Do not render for wp/chain
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	      var price = _extends({}, this.state.price);
	      // let indexAdjustments = [...price.IndexAdjustments]
	      var cols = [4, 4, 1];
	
	      var renderNew = function renderNew() {
	        var newItem = _this19.state.new_indexAdjust;
	
	        var addItem = function addItem() {
	          if (newItem.Date === null || newItem.Date === '') return;
	          newItem.Date = (0, _time.formatDate)(newItem.Date);
	          price.IndexAdjustments.push(newItem);
	          _this19.updatePrices(price);
	        };
	
	        var onChange = function onChange(e) {
	          var value = '';
	          var name = '';
	          if (typeof e.target !== 'undefined') {
	            value = parseFloat((0, _percent.transformPercent)(e.target.value, true) || '0');
	            name = e.target.name;
	          } else {
	            value = e;
	            name = 'Date';
	          }
	          _this19.setState({
	            new_indexAdjust: _extends({}, _this19.state.new_indexAdjust, _defineProperty({}, name, value))
	          }, function () {
	            // console.log('New index adjust ', this.state.new_indexAdjust)
	          });
	        };
	
	        var inputProps = {
	          name: 'Date',
	          placeholder: (0, _helpers.translation)('1728'),
	          readOnly: true
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: cols },
	          _react2.default.createElement(_datetime2.default, {
	            inputProps: inputProps,
	            dateFormat: 'DD-MM-YYYY',
	            timeFormat: false,
	            closeOnSelect: true,
	            value: newItem.Date,
	            onChange: onChange,
	            size: 's'
	          }),
	          _react2.default.createElement(_text2.default, { size: 's', name: 'Amount', value: (0, _percent.transformPercent)(newItem.Amount), onChange: onChange, onFocus: _percent.onPercentFocus }),
	          _react2.default.createElement(_addButton2.default, { onClick: addItem, disabled: _this19.state.IsWorking, size: 's' })
	        );
	      };
	
	      var renderIndexAdjustLine = function renderIndexAdjustLine(val, key) {
	        var deleteItem = function deleteItem(e) {
	          var price = _extends({}, _this19.state.price);
	          price.IndexAdjustments[key].IsDeleted = true;
	          _this19.updatePrices(price);
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, spacing: 1, key: key },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _time.renderFullDate)(val.Date, false)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _percent.transformPercent)(parseFloat(val.Amount))
	          ),
	          !val.IsApplied && _react2.default.createElement(_removeButton2.default, { onClick: deleteItem, size: 's' }) || _react2.default.createElement('span', null)
	        );
	      };
	
	      var hasIndexAdjustments = price.IndexAdjustments !== undefined;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1876'), helpText: (0, _helpers.translation)('2085') },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: cols },
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('388') }),
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('1877') + ' (%)' })
	        ),
	        hasIndexAdjustments && price.IndexAdjustments.map(renderIndexAdjustLine),
	        renderNew()
	      );
	    }
	  }, {
	    key: 'renderPriceModelLog',
	    value: function renderPriceModelLog() {
	      var _this20 = this;
	
	      // Do not render if estimation type model
	      if (this.state.price.PriceType === 5) return null;
	      if (this.props.partners) {
	        if ((0, _auth.hasAccess)([2], this.props.auth.user.UserType)) {
	          return null;
	        }
	      }
	
	      var log = this.state.log;
	
	      var renderLogLine = function renderLogLine(val, key) {
	        var changeText = (0, _helpers.translation)('1873');
	        var addedText = (0, _helpers.translation)('1874');
	        var removedText = (0, _helpers.translation)('1875');
	
	        var text = '';
	        var fieldName = '';
	        var tableName = '';
	        var fromVal = val.FromText !== null && val.FromText !== '' ? val.FromText : val.From;
	        var toVal = val.ToText !== null && val.ToText !== '' ? val.ToText : val.To;
	        var changedBy = val.ChangedByName;
	        var changedTime = val.ChangedAt;
	
	        switch (val.ChangeTable) {
	          case 0:
	            tableName = '';
	            break;
	          case 1:
	            tableName = (0, _helpers.translation)('1867');
	            break;
	          case 2:
	            tableName = (0, _helpers.translation)('1227');
	            break;
	          case 3:
	            tableName = (0, _helpers.translation)('13344');
	            break;
	          case 4:
	            tableName = (0, _helpers.translation)('13374');
	            break;
	          case 12:
	            tableName = (0, _helpers.translation)('1871');
	            break;
	          case 13:
	            tableName = (0, _helpers.translation)('1872');
	            break;
	        }
	        var mat = '13443';
	        if (_this20.state.department !== 0) {
	          mat = '14788';
	        }
	
	        switch (val.ChangeField) {
	          case 1:
	            fieldName = (0, _helpers.translation)('30');
	            break;
	          case 2:
	            fieldName = (0, _helpers.translation)('295');
	            break;
	          case 9:
	            fieldName = (0, _helpers.translation)('419');
	            break;
	          case 10:
	            fieldName = (0, _helpers.translation)(mat);
	            break;
	          case 11:
	            fieldName = (0, _helpers.translation)('1044');
	            break;
	          case 12:
	            fieldName = (0, _helpers.translation)('1199');
	            break;
	          case 13:
	            fieldName = (0, _helpers.translation)('885');
	            break;
	          case 14:
	            fieldName = (0, _helpers.translation)('13350');
	            break;
	          case 15:
	            fieldName = (0, _helpers.translation)('13431');
	            break;
	          case 16:
	            fieldName = (0, _helpers.translation)('1305');
	            break;
	          case 17:
	            fieldName = (0, _helpers.translation)('393');
	            break;
	        }
	
	        switch (val.changeType) {
	          case 0:
	            text = changeText;
	            break;
	          case 1:
	            text = addedText;
	            break;
	          case 2:
	            text = removedText;
	            break;
	        }
	        text = text.replace('[table]', tableName);
	        text = text.replace('[field]', fieldName);
	        text = text.replace('[fromvalue]', fromVal);
	        text = text.replace('[tovalue]', toVal);
	        text = text.replace('[user]', changedBy);
	        text = text.replace('[time]', changedTime);
	
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: key },
	          _react2.default.createElement(
	            'div',
	            null,
	            changedTime
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            text
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'white__box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          (0, _helpers.translation)('1866')
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'changelog' },
	          _react2.default.createElement(
	            'li',
	            { className: 'clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              (0, _helpers.translation)('388')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text' },
	              (0, _helpers.translation)('1489')
	            )
	          ),
	          log.map(renderLogLine)
	        )
	      );
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose(type) {
	      var _this21 = this;
	
	      this.setState(_defineProperty({}, type, _extends({}, this.state[type], {
	        open: false
	      })), function () {
	        return console.log(_this21.state[type]);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (Object.keys(this.state.price).length === 0) return null;
	      var extraClass = '';
	      var renderPricePartsClass = false;
	      if (this.props.partners) {
	        extraClass += 'partnersPrices';
	      }
	      if ((0, _auth.hasAccess)([600], this.props.auth.user.UserType)) {
	        renderPricePartsClass = true;
	        extraClass += ' partnerLoggedIn';
	      }
	      var renderIndexAdjustmentsRight = (0, _auth.hasAccess)([600], this.props.auth.user.UserType);
	      return _react2.default.createElement(
	        'div',
	        { className: 'salescar__screen ' + extraClass },
	        _react2.default.createElement(
	          'fieldset',
	          { disabled: this.props.creating },
	          this.renderRecommendedSelector(),
	          _react2.default.createElement(
	            'div',
	            { className: 'row clearfix' },
	            _react2.default.createElement(
	              _col2.default,
	              { span: '2' },
	              this.renderCustomAgreement(),
	              this.renderPrices(),
	              this.renderSize(),
	              !renderIndexAdjustmentsRight && this.renderIndexAdjustments(),
	              renderPricePartsClass && this.renderPriceParts('')
	            ),
	            !renderPricePartsClass && this.renderPriceParts('col'),
	            this.renderSubContractors(),
	            renderIndexAdjustmentsRight && _react2.default.createElement(
	              _col2.default,
	              null,
	              this.renderIndexAdjustments()
	            )
	          )
	        ),
	        this.state.confirmDelete.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmDelete') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm.bind(this, 'confirmDelete'), notConfirm: this.onPortalClose.bind(this, 'confirmDelete') })
	        ),
	        this.state.confirmActive.open && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.onPortalClose.bind(this, 'confirmActive') },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.onConfirm.bind(this, 'confirmActive'), notConfirm: this.onPortalClose.bind(this, 'confirmActive'), renderText: this.getConfirmActiveText })
	        )
	      );
	    }
	  }, {
	    key: 'getConfirmActiveText',
	    value: function getConfirmActiveText() {
	      var ctext = this.state.confirmActive.type ? 17834 : 17835;
	
	      // For WP it's price agreements
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) ctext = this.state.confirmActive.type ? 16841 : 16840;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        (0, _helpers.translation)(ctext)
	      );
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm(type) {
	      var _this22 = this;
	
	      this.onPortalClose(type);
	      var price = _extends({}, this.state.price);
	
	      if (type === 'confirmDelete') price.IsDeleted = true;
	      if (type === 'confirmActive') price.Active = this.state.confirmActive.type === 1;
	
	      this.updatePrices(price).then(function () {
	        _this22.props.onShouldUpdate();
	      });
	    }
	  }]);
	
	  return Salescar;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers,
	    companies: state.common.companies,
	    brands: state.common.brands
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceList: _priceModel.getPriceList,
	  updatePriceList: _priceModel.updatePriceList,
	  reorderPriceListItem: _priceModel.reorderPriceListItem,
	  getCustomers: _customers.getCustomers,
	  // getPriceModelLog,
	  triggerPopup: _backdrop.triggerPopup,
	  getBrands: _common.getBrands
	})(Salescar);

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _NewPriceModal = __webpack_require__(1100);
	
	var _NewPriceModal2 = _interopRequireDefault(_NewPriceModal);
	
	var _priceModel = __webpack_require__(75);
	
	var _backdrop = __webpack_require__(29);
	
	var _customers = __webpack_require__(74);
	
	__webpack_require__(1448);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuHeader = __webpack_require__(1079);
	
	var _sideMenuHeader2 = _interopRequireDefault(_sideMenuHeader);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _icons = __webpack_require__(6);
	
	var _common = __webpack_require__(25);
	
	var _Salescar = __webpack_require__(948);
	
	var _Salescar2 = _interopRequireDefault(_Salescar);
	
	var _Extras = __webpack_require__(945);
	
	var _Extras2 = _interopRequireDefault(_Extras);
	
	var _Estimation = __webpack_require__(943);
	
	var _Estimation2 = _interopRequireDefault(_Estimation);
	
	var _ReportDiscounts = __webpack_require__(940);
	
	var _ReportDiscounts2 = _interopRequireDefault(_ReportDiscounts);
	
	var _Discounts = __webpack_require__(941);
	
	var _Discounts2 = _interopRequireDefault(_Discounts);
	
	var _Details = __webpack_require__(285);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _Insurance = __webpack_require__(286);
	
	var _Insurance2 = _interopRequireDefault(_Insurance);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Modals
	
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Prices = function (_Component) {
	  _inherits(Prices, _Component);
	
	  function Prices(props) {
	    _classCallCheck(this, Prices);
	
	    var _this = _possibleConstructorReturn(this, (Prices.__proto__ || Object.getPrototypeOf(Prices)).call(this, props));
	
	    _this.state = {
	      customer: null,
	      showNewPriceModal: false,
	      valid: [{
	        name: 'salescar',
	        access: [2, 3]
	      }, {
	        name: 'private',
	        access: [2, 3]
	      }, {
	        name: 'warranty',
	        access: [2, 3]
	      }, {
	        name: 'addon',
	        access: [2, 3],
	        subscriptionValue: 30
	      }, {
	        name: 'discounts',
	        access: [3, 7],
	        subscriptionValue: 10
	      }, {
	        name: 'extras',
	        access: [2, 3, 4, 7],
	        subscriptionValue: 30
	      }, {
	        name: 'services',
	        access: [4],
	        subscriptionValue: 30
	      }, {
	        name: 'estimation',
	        access: [2, 3, 7]
	      }],
	      list: [],
	      activeItem: {},
	      fetched: false,
	      customerName: null,
	      hasForsiCustomerNr: false,
	      search: '',
	      includeInactive: false
	      // discounts: []
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.createNewPricemodel = _this.createNewPricemodel.bind(_this);
	    _this.showNewPriceModal = _this.showNewPriceModal.bind(_this);
	    _this.createNew = _this.createNew.bind(_this);
	    _this.onShouldUpdate = _this.onShouldUpdate.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    return _this;
	  }
	
	  _createClass(Prices, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.route.customer && typeof this.props.params.customerID !== 'undefined') {
	        this.props.getCustomers(0, parseInt(this.props.params.customerID));
	      }
	      if (this.props.route.customer) {
	        this.getCustomer();
	      }
	      if (!this.hasAccessToPage()) {
	        this.props.router.push('/prices');
	      } else {
	        this.getPriceLists();
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var _this2 = this;
	
	      if (this.props.route.customer !== nextProps.route.customer || this.props.route.partners !== nextProps.route.partners) {
	        this.setState({
	          list: [],
	          activeItem: {},
	          fetched: false
	          // customerName: 'Test'
	        }, function () {
	          _this2.getPriceLists();
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.hasAccessToPage()) {
	        this.props.router.push('/prices');
	      }
	    }
	  }, {
	    key: 'hasAccessToPage',
	    value: function hasAccessToPage() {
	      var _this3 = this;
	
	      var valid = true;
	      var found = false;
	      if (typeof this.props.params.type !== 'undefined') {
	        this.state.valid.map(function (val, key) {
	          if (val.name === _this3.props.params.type) {
	            found = true;
	            if (!(0, _auth.hasAccess)(val.access, _this3.props.auth.user.UserType)) {
	              valid = false;
	            }
	            if (valid === true && val.subscriptionValue !== undefined) {
	              if (!(0, _auth.hasSubscriptionPermission)(_this3.props.auth, val.subscriptionValue)) valid = false;
	            }
	          }
	        });
	        if ((!found || !valid) && (0, _auth.hasAccess)([3, 7], this.props.auth.user.UserType)) valid = true;
	      }
	      return valid;
	    }
	  }, {
	    key: 'getCustomer',
	    value: function getCustomer() {
	      var _this4 = this;
	
	      if (typeof this.props.params.customerID !== 'undefined') {
	        this.props.getCustomer(this.props.params.customerID).then(function (res) {
	          _this4.setState({
	            customer: res.data,
	            hasForsiCustomerNr: parseInt(res.data.ForsiCustomerNumber) > 0
	          });
	        });
	      }
	    }
	  }, {
	    key: 'getPriceLists',
	    value: function getPriceLists() {
	      var _this5 = this;
	
	      var props = this.props;
	      var id = props.route.customer ? props.params.customerID : 0;
	      var workProviderId = props.route.partners ? props.params.partnerID : 0;
	      if ((0, _auth.hasAccess)([4], props.auth.user.UserType)) id = props.auth.user.CustomerId;
	      return props.getPriceLists(id, workProviderId).then(function (res) {
	        _this5.setState({
	          list: res.data,
	          fetched: true
	        });
	        return res;
	      }, function () {
	        console.log('Err fetching price lists data');
	        return null;
	      });
	    }
	  }, {
	    key: 'createPriceListFrom',
	    value: function createPriceListFrom(parentId) {
	      var data = {
	        ParentPriceModelId: parentId,
	        CustomerId: this.props.params.customerID
	      };
	      return this.props.createPriceListFrom(data).then(function (res) {
	        return res;
	      });
	    }
	  }, {
	    key: 'onShouldUpdate',
	    value: function onShouldUpdate() {
	      // Redirect
	      if (this.props.route.partners) {
	        this.props.router.push('/partners/' + this.props.params.partnerID + '/prices');
	      } else if (this.props.route.customer) {
	        this.props.router.push('/customers/' + this.props.params.customerID + '/prices');
	      } else {
	        this.props.router.push('/prices');
	      }
	      this.getPriceLists().then(function () {
	        // Toastr
	        // window.toastr.success(translation('13444'), translation('13424'))
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('2018'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({
	          search: e.target.value
	        });
	      }
	      if (e.target.name === 'Inactive') {
	        this.setState({
	          includeInactive: e.target.checked
	        });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      if (key.Name === undefined || key.Name === null) return true;
	      if (!this.state.includeInactive ? key.Active : true) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'leftMenu',
	    value: function leftMenu() {
	      var _this6 = this;
	
	      // if (this.state.list.length === 0) return null
	      // Create
	      if (this.props.params.type === 'create') {
	        var onAdd = function onAdd() {
	          // console.log('Create pricelist from: ', this.state.activeItem)
	
	          _this6.createPriceListFrom(_this6.state.activeItem.PriceModelId).then(function (res) {
	            setTimeout(function () {
	              _this6.getPriceLists().then(function () {
	                // Toastr
	                // window.toastr.success(translation('13444'), translation('13424'))
	                // Redirect
	                if (_this6.props.route.partners) {
	                  _this6.props.router.push('/partners/' + _this6.props.params.partnerID + '/prices/' + res.data.PriceModelId);
	                } else if (_this6.props.route.customer) {
	                  _this6.props.router.push('/customers/' + _this6.props.params.customerID + '/prices/' + res.data.PriceModelId);
	                } else {
	                  _this6.props.router.push('/prices/' + res.data.PriceModelId);
	                }
	              }, function () {
	                // Toastr
	                window.toastr.error((0, _helpers.translation)('2018'), (0, _helpers.translation)('216'));
	                // Redirect
	                if (_this6.props.route.partners) {
	                  _this6.props.router.push('/partners/' + _this6.props.params.partnerID + '/prices');
	                } else if (_this6.props.route.customer) {
	                  _this6.props.router.push('/customers/' + _this6.props.params.customerID + '/prices');
	                } else {
	                  _this6.props.router.push('/prices');
	                }
	              });
	            }, 0);
	          });
	        };
	        var cancelAdd = function cancelAdd() {
	          if (_this6.props.route.partners) {
	            _this6.props.router.push('/partners/' + _this6.props.params.partnerID + '/prices');
	          } else if (_this6.props.route.customer) {
	            _this6.props.router.push('/customers/' + _this6.props.params.customerID + '/prices');
	          } else {
	            _this6.props.router.push('/prices');
	          }
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: cancelAdd, labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	      // Render item
	      var renderItem = function renderItem(val, key) {
	        // console.log('renderItem val/key', val, key)
	        var isTitle = false;
	        // Name + Link
	        var name = val.Name;
	        var brand = val.Brand;
	
	        // if (val.Active === false && !this.state.includeInactive) return
	
	        var link = '/prices/' + val.PriceModelId;
	        if (name === null) {
	          if (val.PriceType !== 4) {
	            if (!(0, _auth.hasAccess)([2, 3, 7], _this6.props.auth.user.UserType)) return null;
	          }
	          if ([4, 6, 8].indexOf(val.PriceType) !== -1 && !(0, _auth.hasSubscriptionPermission)(_this6.props.auth, 30)) return null;
	          if ([-10].indexOf(val.PriceType) !== -1 && !(0, _auth.hasSubscriptionPermission)(_this6.props.auth, 10)) return null;
	          if (val.Department === 1 && val.PriceType === 5) return null;
	          switch (val.PriceType) {
	            case 4:
	              name = (0, _helpers.translation)('2224');
	              // if (hasAccess([4], this.props.auth.user.UserType)) name = translation('13375')
	              link = '/prices/extras/' + val.Department;
	              if (val.IsServices !== undefined && val.IsServices === true) {
	                if (_this6.props.auth.user.DepartmentType !== 0) return null;
	                name = (0, _helpers.translation)('13375');
	                link = '/prices/services/' + val.Department;
	              }
	              isTitle = true;
	              break;
	            case 5:
	              name = (0, _helpers.translation)('13363');
	              link = '/prices/estimation/' + val.Department;
	              isTitle = true;
	              break;
	            case -10:
	              if (val.Department !== 1) {
	                name = (0, _helpers.translation)('18316');
	                isTitle = true;
	                link = '/prices/discounts/' + val.Department;
	              }
	              break;
	            // case 4:
	            //   name = translation('2224')
	            //   // if (hasAccess([4], this.props.auth.user.UserType)) name = translation('13375')
	            //   link = '/prices/extras'
	            //   if (val.IsServices !== undefined && val.IsServices === true) {
	            //     name = translation('13375')
	            //     link = '/prices/services'
	            //   }
	            //   classNameList = 'headerItem'
	            //   break
	            // case 5:
	            //   name = translation('13363')
	            //   link = '/prices/estimation'
	            //   classNameList = 'headerItem'
	            //   break
	            // case -10:
	            //   name = translation('1197')
	            //   link = '/prices/discounts'
	            //   classNameList = 'headerItem'
	            //   break
	          }
	        } else {
	          if (!(0, _auth.hasAccess)([2, 6], _this6.props.auth.user.UserType)) {
	            if (!(0, _auth.hasAccess)([3, 4, 7], _this6.props.auth.user.UserType)) return null;
	            // classNameList = 'subChild'
	          }
	        }
	
	        // Customer links
	        if (_this6.props.route.customer) {
	          link = '/customers/' + _this6.props.params.customerID + link;
	        }
	        // Partners links
	        if (_this6.props.route.partners) {
	          link = '/partners/' + _this6.props.params.partnerID + link;
	        }
	
	        var text = name;
	        if (!(0, _auth.hasAccess)([6], _this6.props.auth.user.UserType)) {
	          if (val.IsWorkprovider === true && brand !== null) {
	            text += ' (' + brand + '/' + val.WorkProviderName + ')';
	          } else if (brand !== null) {
	            text += ' (' + brand + ')';
	          } else if (val.IsWorkprovider) {
	            text += ' (' + val.WorkProviderName + ')';
	          }
	        }
	
	        // Return
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: text,
	          renderLabel: function renderLabel(label, className, activeClassName) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: link, className: className, activeClassName: activeClassName },
	              label
	            );
	          },
	          inactive: !val.Active,
	          isTitle: isTitle,
	          key: key
	        });
	      };
	
	      var groups = {
	        Undefined: [],
	        Insurance: [],
	        Sales: [],
	        Warranty: [],
	        Private: [],
	        Other: [],
	        Complaint: [],
	        Addon: [],
	        Discounts: [],
	        Extra: [],
	        Estimation: [],
	        UnGrouped: []
	      };
	      var groupsBody = {
	        Undefined: [],
	        Insurance: [],
	        Sales: [],
	        Warranty: [],
	        Private: [],
	        Other: [],
	        Complaint: [],
	        Addon: [],
	        Discounts: [],
	        Extra: [],
	        Estimation: [],
	        UnGrouped: []
	      };
	      var getGroup = function getGroup(item) {
	        var group = groups;
	        if (item.Department === 1) group = groupsBody;
	        return group;
	      };
	      var paintCount = 0;
	      var bodyCount = 0;
	      for (var i = 0; i < this.state.list.length; i++) {
	        var item = this.state.list[i];
	        if ([-10].indexOf(item.PriceType) !== -1 && !(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) continue;
	        var foundGroup = getGroup(item);
	        // console.log('leftMenu foundGroup', foundGroup)
	        if (foundGroup === groups) paintCount++;
	        if (foundGroup === groupsBody) bodyCount++;
	        switch (item.PriceType) {
	          case -1:
	            // Undefined
	            foundGroup.Undefined.push(item);
	            break;
	          case 0:
	            // Other
	            foundGroup.Other.push(item);
	            break;
	          case 1:
	            // Salescar
	            foundGroup.Sales.push(item);
	            break;
	          case 2:
	            // Private
	            foundGroup.Private.push(item);
	            break;
	          case 3:
	            // Warranty
	            foundGroup.Warranty.push(item);
	            break;
	          case 4:
	            // Extra
	            foundGroup.UnGrouped.push(item); // only bodyshop
	            if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	              var servicesItem = _extends({}, item);
	              servicesItem.IsServices = true;
	              foundGroup.UnGrouped.push(servicesItem);
	            }
	
	            break;
	          case 5:
	            // Estimation
	            if (item.Name !== null) {
	              foundGroup.Insurance.push(item);
	            } else {
	              foundGroup.UnGrouped.push(item); // only bodyshop
	            }
	            break;
	          case 6:
	            // Complaint
	            foundGroup.Complaint.push(item);
	            break;
	          case 8:
	            foundGroup.Addon.push(item);
	            break;
	          case -10:
	            // Discounts
	            // console.log('menu discount case item', item)
	            // if (item.Department === 1) {
	            foundGroup.Discounts.push(item);
	            // } else {
	            //   foundGroup.UnGrouped.push(item)
	            // }
	            break;
	        }
	      }
	      var renderGroup = function renderGroup(val, key) {
	        if (val.length === 0) return null;
	        var groupTitle = (0, _helpers.translation)(key);
	
	        if (key === 'UnGrouped') {
	          return val.map(renderItem);
	        } else if (key === 'Discounts') {
	          var discountPaintLabel = 18316;
	          var discountBodyLabel = 1197;
	          return _react2.default.createElement(
	            _sideMenuItem2.default,
	            { label: (0, _helpers.translation)(_this6.props.auth.departmentType === 0 ? discountPaintLabel : discountBodyLabel), isTitle: true, key: key },
	            _this6.props.route.customer && _this6.state.customer && _this6.state.customer.Discounts && _this6.state.customer.Discounts.map(renderDiscountList)
	          );
	        } else {
	          return _react2.default.createElement(
	            _sideMenuItem2.default,
	            { label: groupTitle, isTitle: true, key: key },
	            val.map(renderItem)
	          );
	        }
	      };
	
	      var renderDiscountList = function renderDiscountList(val) {
	        if (val.IsAddonPrice && val.OrderType === 1) {
	          var renderLink = function renderLink(label, className, activeClassName) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/customers/' + _this6.props.params.customerID + '/prices/discounts/' + val.Department + '/Addon', className: className, activeClassName: activeClassName },
	              label
	            );
	          };
	
	          return _react2.default.createElement(_sideMenuItem2.default, { label: (0, _helpers.translation)('1396'), renderLabel: renderLink, key: 'addon' });
	        } else {
	          var text = (0, _helpers.translation)((0, _helpers.enumtranslate)('OrderTypes', val.OrderType));
	          if (val.OrderType === 1) text = (0, _helpers.translation)('70');
	          if (val.OrderType === 4) text = (0, _helpers.translation)('2263');
	
	          var _renderLink = function _renderLink(label, className, activeClassName) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/customers/' + _this6.props.params.customerID + '/prices/discounts/' + val.Department + '/' + val.OrderType, className: className, activeClassName: activeClassName },
	              label
	            );
	          };
	
	          return _react2.default.createElement(_sideMenuItem2.default, { label: text, renderLabel: _renderLink, key: val.OrderType });
	        }
	      };
	
	      var renderGroups = function renderGroups(count, header, groups, src, bodyDiscounts) {
	        if (count === 0) return null;
	
	        return _react2.default.createElement(
	          _sideMenuHeader2.default,
	          { label: header, icon: src, key: header },
	          renderGroup(groups['Undefined'], '2036'),
	          renderGroup(groups['Insurance'], '13360'),
	          renderGroup(groups['Sales'], '71'),
	          renderGroup(groups['Warranty'], '13361'),
	          renderGroup(groups['Private'], '785'),
	          renderGroup(groups['Other'], '73'),
	          renderGroup(groups['Complaint'], '301'),
	          renderGroup(groups['Addon'], '1396'),
	          _this6.props.route.customer && renderGroup(groups['Discounts'], 'Discounts'),
	          renderGroup(groups['UnGrouped'], 'UnGrouped')
	        );
	      };
	
	      return [renderGroups(paintCount, (0, _helpers.translation)('161'), groups, _icons.OrderDepartmentIcons.Paint, false), renderGroups(bodyCount, (0, _helpers.translation)('788'), groupsBody, _icons.OrderDepartmentIcons.Body, true)];
	    }
	  }, {
	    key: 'renderHeaderTitle',
	    value: function renderHeaderTitle() {
	      var customer = this.state.customer;
	      // if (customer === null || customer.CompanyName === null || !this.props.route.customer) return translation('1172')
	      // return translation('1172') + ' - ' + customer.CompanyName
	
	      if (customer === null || customer.CompanyName === null || !this.props.route.customer) return null;
	      return customer.CompanyName;
	    }
	  }, {
	    key: 'findPriceModelId',
	    value: function findPriceModelId(type, id) {
	      var item = null;
	      this.state.list.map(function (val, key) {
	        if (typeof id === 'undefined') {
	          if (val.PriceType === type && val.Name === null) {
	            item = val;
	          }
	        } else {
	          if (val.PriceModelId === id) {
	            item = val;
	          }
	        }
	      });
	      return item;
	    }
	  }, {
	    key: 'findDepartmentPriceModelId',
	    value: function findDepartmentPriceModelId(type, department) {
	      var item = null;
	      this.state.list.map(function (val, key) {
	        if (typeof department === 'undefined') {
	          if (val.PriceType === type && val.Name === null) {
	            item = val;
	          }
	        } else {
	          if (val.PriceType === type && val.Name === null && val.Department === department) {
	            item = val;
	          }
	        }
	      });
	      return item;
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var item = null;
	      switch (this.props.params.type) {
	        case 'salescar':
	          item = this.findPriceModelId(1);
	          return _react2.default.createElement(_Salescar2.default, { router: this.props.router, onShouldUpdate: this.onShouldUpdate, item: item, customer: this.props.route.customer, partners: this.props.route.partners, getPriceLists: this.getPriceLists.bind(this) });
	        case 'warranty':
	          item = this.findPriceModelId(3);
	          return _react2.default.createElement(_Salescar2.default, { router: this.props.router, onShouldUpdate: this.onShouldUpdate, item: item, customer: this.props.route.customer, partners: this.props.route.partners, getPriceLists: this.getPriceLists.bind(this) });
	        case 'private':
	          item = this.findPriceModelId(2);
	          return _react2.default.createElement(_Salescar2.default, { router: this.props.router, onShouldUpdate: this.onShouldUpdate, item: item, customer: this.props.route.customer, partners: this.props.route.partners, getPriceLists: this.getPriceLists.bind(this) });
	        case 'addon':
	          item = this.findPriceModelId(8);
	          return _react2.default.createElement(_Salescar2.default, { router: this.props.router, onShouldUpdate: this.onShouldUpdate, item: item, customer: this.props.route.customer, partners: this.props.route.partners, getPriceLists: this.getPriceLists.bind(this) });
	        case 'extras':
	          item = this.findDepartmentPriceModelId(4, parseInt(this.props.params.value));
	          if (item !== null) {
	            return _react2.default.createElement(_Extras2.default, { router: this.props.router, item: item, customer: this.props.route.customer, showExtras: true, showServices: false });
	          }
	          return null;
	        case 'services':
	          item = this.findPriceModelId(4);
	          return _react2.default.createElement(_Extras2.default, { router: this.props.router, item: item, customer: this.props.route.customer, showExtras: false, showServices: true });
	        case 'estimation':
	          item = this.findPriceModelId(5);
	          return item && _react2.default.createElement(_Estimation2.default, { router: this.props.router, item: item, customer: this.props.route.customer }) || null;
	        case 'discounts':
	          var dep = parseInt(this.props.params.value);
	          item = this.findDepartmentPriceModelId(-10, dep);
	          // console.log('renderView discounts item', item)
	          if (item) {
	            var renderKickback = this.props.auth.user.DepartmentType === 1 && !this.state.hasForsiCustomerNr;
	            var renderReportDiscounts = [1, 2, 3, 6].indexOf(parseInt(this.props.params.separateType)) > -1;
	            return _react2.default.createElement(
	              'div',
	              null,
	              renderReportDiscounts && _react2.default.createElement(_ReportDiscounts2.default, { router: this.props.router, item: item, customer: this.props.route.customer, customerId: parseInt(this.props.params.customerID), hasKickback: renderKickback, type: this.props.params.separateType, isBodyShop: dep === 1, department: dep }),
	              _react2.default.createElement(_Discounts2.default, { router: this.props.router, item: item, customer: this.props.route.customer, customerId: parseInt(this.props.params.customerID), hasKickback: renderKickback, type: this.props.params.separateType, isBodyShop: dep === 1 })
	            );
	          }
	          return null;
	        case 'create':
	          return _react2.default.createElement(_Salescar2.default, { router: this.props.router, onShouldUpdate: this.onShouldUpdate, creating: true, item: this.state.activeItem, customer: this.props.route.customer, partners: this.props.route.partners, getPriceLists: this.getPriceLists.bind(this) });
	        default:
	          if (!isNaN(this.props.params.type)) {
	            item = this.findPriceModelId(0, parseInt(this.props.params.type));
	            if (item !== null) {
	              var pricetype = item.PriceType;
	              var isPriceModelType = pricetype !== 5 && pricetype !== 6 && pricetype !== 0;
	              var isInsuranceType = pricetype === 5 || pricetype === 6 || pricetype === 0;
	              if (item.CustomerGroupId === 0) {
	                return _react2.default.createElement(_Salescar2.default, { router: this.props.router, onShouldUpdate: this.onShouldUpdate, item: item, customer: this.props.route.customer, partners: this.props.route.partners, getPriceLists: this.getPriceLists.bind(this) });
	              }
	              if (item.CustomerGroupId > 0 && isPriceModelType && !item.UseEstimationList) {
	                return _react2.default.createElement(_Details2.default, { router: this.props.router, onShouldUpdate: this.onShouldUpdate, item: item, isMain: true, customer: this.props.route.customer, partners: this.props.route.partners, getPriceLists: this.getPriceLists.bind(this) });
	              }
	              if (item.CustomerGroupId > 0 && (isInsuranceType || item.UseEstimationList)) {
	                return _react2.default.createElement(_Insurance2.default, { ref: 'view',
	                  router: this.props.router,
	                  selectedTabIndex: this.state.selectedTabIndex,
	                  onShouldUpdate: this.onShouldUpdate,
	                  selectedCustomerId: -1,
	                  isMain: true,
	                  item: item,
	                  pricemodels: this.state.list,
	                  agreementId: this.state.activeItem.PriceModelId,
	                  getPriceLists: this.getPriceLists.bind(this) });
	                // return <AgreementDetails onShouldUpdate={this.onShouldUpdate} item={item} customer={this.props.route.customer} partners={this.props.route.partners} getPriceLists={this.getPriceLists.bind(this)} />
	              }
	            }
	          }
	          return null;
	      }
	    }
	  }, {
	    key: 'createNewPricemodel',
	    value: function createNewPricemodel() {
	      var _this7 = this;
	
	      var data = {
	        PriceModelId: 0,
	        PriceType: 1,
	        Name: 'New'
	      };
	      if (this.props.route.partners) {
	        data.WorkProviderId = this.props.params.partnerID;
	        data.CustomerSelectionType = 1;
	      }
	      this.props.updatePriceList(data).then(function (res) {
	        _this7.setState({
	          activeItem: res.data
	        });
	        if (_this7.props.route.partners) {
	          _this7.props.router.push('/partners/' + _this7.props.params.partnerID + '/prices/create');
	        } else {
	          _this7.props.router.push('/prices/create');
	        }
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13482'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'showNewPriceModal',
	    value: function showNewPriceModal() {
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        // Show new price model popup for chain, shop and shop/customer
	        if (this.props.route.partners) {
	          this.createNew({
	            PriceModelId: 0,
	            PriceType: 1
	          });
	        } else {
	          this.createNew({
	            PriceModelId: 0,
	            PriceType: -1
	          });
	        }
	      } else {
	        this.props.triggerPopup(!this.state.showNewPriceModal);
	        this.setState({
	          showNewPriceModal: !this.state.showNewPriceModal
	        });
	      }
	    }
	  }, {
	    key: 'createNew',
	    value: function createNew(data) {
	      var _this8 = this;
	
	      if (data.PriceModelId === 0) {
	        var create = {
	          PriceModelId: 0,
	          PriceType: typeof data.PriceType !== 'undefined' ? data.PriceType : -1,
	          Name: 'New',
	          Department: typeof data.Department !== 'undefined' ? data.Department : 0
	        };
	        if (this.props.route.partners) {
	          create.WorkProviderId = this.props.params.partnerID;
	          create.CustomerSelectionType = 1;
	        }
	        this.props.updatePriceList(create).then(function (res) {
	          _this8.setState({
	            activeItem: {
	              Name: res.data.Name,
	              PriceModelId: res.data.PriceModelId,
	              PriceType: res.data.PriceType,
	              Department: res.data.Department
	            }
	          }, function () {
	            setTimeout(function () {
	              _this8.getPriceLists().then(function () {
	                // Toastr
	                // window.toastr.success(translation('13444'), translation('13424'))
	                // Redirect
	                if (_this8.props.route.partners) {
	                  _this8.props.router.push('/partners/' + _this8.props.params.partnerID + '/prices/' + _this8.state.activeItem.PriceModelId);
	                } else if (_this8.props.route.customer) {
	                  _this8.props.router.push('/customers/' + _this8.props.params.customerID + '/prices/' + _this8.state.activeItem.PriceModelId);
	                } else {
	                  _this8.props.router.push('/prices/' + _this8.state.activeItem.PriceModelId);
	                }
	              }, function () {
	                // Toastr
	                window.toastr.error((0, _helpers.translation)('2018'), (0, _helpers.translation)('216'));
	                // Redirect
	                if (_this8.props.route.partners) {
	                  _this8.props.router.push('/partners/' + _this8.props.params.partnerID + '/prices');
	                } else if (_this8.props.route.customer) {
	                  _this8.props.router.push('/customers/' + _this8.props.params.customerID + '/prices');
	                } else {
	                  _this8.props.router.push('/prices');
	                }
	              });
	            }, 0);
	          });
	          // this.props.router.push('/prices/' + res.data.PriceModelId)
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('13482'), (0, _helpers.translation)('216'));
	        });
	      } else {
	        this.setState({
	          activeItem: data
	        });
	        if (this.props.route.partners) {
	          this.props.router.push('/partners/' + this.props.params.partnerID + '/prices/create');
	        } else if (this.props.route.customer) {
	          this.props.router.push('/customers/' + this.props.params.customerID + '/prices/create');
	        } else {
	          this.props.router.push('/prices/create');
	        }
	      }
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      // if (this.props.route.customer) return null
	      if (!(0, _auth.hasAccess)([2, 3, 6, 7], this.props.auth.user.UserType)) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      if (this.state.customer && !this.state.customer.IsOwnedByShop) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('2052'), onClick: this.showNewPriceModal }),
	        _react2.default.createElement(_NewPriceModal2.default, {
	          onCreate: this.createNew,
	          customer: this.props.route.customer,
	          partners: this.props.route.partners,
	          activeCustomerId: this.props.params.customerID,
	          show: this.state.showNewPriceModal,
	          onClose: this.showNewPriceModal })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      var headerButtonsGoBack = void 0;
	      headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	        var goBack = function goBack() {
	          _this9.props.router.replace({
	            pathname: '/customers',
	            query: {
	              customerId: _this9.props.params.customerID
	            }
	          });
	        };
	        if (!_this9.props.route.customer) return null;
	        return _react2.default.createElement(_closeButton2.default, { key: 'back_close', ariaText: t('2060'), onClick: goBack });
	      };
	
	      var isCreateView = this.props.params.type === 'create';
	      return _react2.default.createElement(
	        'div',
	        { className: 'prices__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, pageTitleExtra: this.renderHeaderTitle(), renderRight: this.headerButtonsRight, showBack: this.props.route.customer, headerButtonsGoBack: headerButtonsGoBack }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { disableFilter: isCreateView },
	          this.leftMenu()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'prices__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Prices;
	}(_react.Component);
	
	Prices.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers,
	    pageTitle: state.common.pageTitle,
	    activeCustomer: state.common.activeCustomer
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceLists: _priceModel.getPriceLists,
	  updatePriceList: _priceModel.updatePriceList,
	  createPriceListFrom: _priceModel.createPriceListFrom,
	  triggerPopup: _backdrop.triggerPopup,
	  getCustomer: _customers.getCustomer,
	  getCustomers: _customers.getCustomers,
	  setPageTitle: _common.setPageTitle,
	  setPageTitleExtra: _common.setPageTitleExtra
	})(Prices);

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _PunchStatsModal = __webpack_require__(1107);
	
	var _PunchStatsModal2 = _interopRequireDefault(_PunchStatsModal);
	
	var _punchclock = __webpack_require__(173);
	
	var _backdrop = __webpack_require__(29);
	
	__webpack_require__(1449);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router'
	
	// import components
	
	// import Portal from './../../shared/components/Portal'
	// import Confirm from './../../shared/components/Confirm'
	
	
	// import actions
	
	
	// import styles
	
	
	// Utils
	
	
	// Elements
	
	
	var PunchClock = function (_Component) {
	  _inherits(PunchClock, _Component);
	
	  function PunchClock(props) {
	    _classCallCheck(this, PunchClock);
	
	    var _this = _possibleConstructorReturn(this, (PunchClock.__proto__ || Object.getPrototypeOf(PunchClock)).call(this, props));
	
	    _this.state = {
	      punch: {
	        IsRestrictedIp: false,
	        ShowManualPunchIn: false,
	        UserPunchStats: []
	      },
	      punchmodal: {
	        open: false,
	        id: 0,
	        name: ''
	      },
	      isRequestPending: false
	    };
	
	    _this.renderHeaderTitle = _this.renderHeaderTitle.bind(_this);
	    _this.renderEmployees = _this.renderEmployees.bind(_this);
	    _this.getPunchStats = _this.getPunchStats.bind(_this);
	    _this.editPunch = _this.editPunch.bind(_this);
	    return _this;
	  }
	
	  _createClass(PunchClock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPunchStats();
	    }
	  }, {
	    key: 'getPunchStats',
	    value: function getPunchStats() {
	      var _this2 = this;
	
	      this.props.getPunchStats().then(function (res) {
	        _this2.setState({
	          punch: res.data
	        });
	      });
	    }
	  }, {
	    key: 'editPunch',
	    value: function editPunch(userId, punchType) {
	      var _this3 = this;
	
	      var restLock = function restLock() {
	        _this3.setState({
	          isRequestPending: false
	        });
	      };
	      var data = {
	        UserId: userId,
	        PunchType: punchType
	      };
	
	      this.props.editPunchStats(data).then(function (res) {
	        restLock();
	        if (res.data !== null) {
	          _this3.getPunchStats();
	        }
	      }, restLock);
	    }
	  }, {
	    key: 'renderHeaderTitle',
	    value: function renderHeaderTitle() {
	      return (0, _helpers.translation)('437');
	    }
	  }, {
	    key: 'renderEmployees',
	    value: function renderEmployees() {
	      var _this4 = this;
	
	      if (this.state.punch === undefined || this.state.punch === null) return null;
	      var employees = this.state.punch.UserPunchStats;
	
	      var renderEmployee = function renderEmployee(val, key) {
	        var PUNCH_BREAK = 0;
	        var PUNCH_IN = 1;
	        var PUNCH_OUT = 2;
	        var userId = val.UserId;
	        var name = val.UserName;
	        var state = val.PunchType;
	        var lastPunchTxt = val.LastPunch;
	        var isPunchAllowed = val.PunchAllowed;
	
	        if (val.LastPunch === null) {
	          lastPunchTxt = (0, _helpers.translation)('1901') + ': ' + (0, _helpers.translation)('2103');
	        } else {
	          if (state === PUNCH_IN) {
	            lastPunchTxt = (0, _helpers.translation)('1900') + ': ' + (0, _time.renderFullDate)(val.LastPunch, true);
	          } else {
	            lastPunchTxt = (0, _helpers.translation)('1901') + ': ' + (0, _time.renderFullDate)(val.LastPunch, true);
	          }
	        }
	
	        // const doPunchBreak = () => {
	        //   this.editPunch(userId, PUNCH_BREAK)
	        // }
	        var doPunchIn = function doPunchIn() {
	          _this4.setState({
	            isRequestPending: true
	          }, function () {
	            return _this4.editPunch(userId, PUNCH_IN);
	          });
	        };
	
	        var doPunchOut = function doPunchOut() {
	          _this4.editPunch(userId, PUNCH_OUT);
	        };
	
	        var stateTxt = '';
	        switch (state) {
	          case PUNCH_BREAK:
	            stateTxt = (0, _helpers.translation)('13561');
	            break;
	          case PUNCH_IN:
	            stateTxt = (0, _helpers.translation)('441');
	            break;
	          case PUNCH_OUT:
	            stateTxt = (0, _helpers.translation)('1899');
	            break;
	        }
	        var bgClass = state === PUNCH_IN ? 'selected' : '';
	
	        // ShowIn / ShowOut
	        var showIn = true;
	        var showOut = true;
	
	        if (!_this4.state.punch.ShowManualPunchIn) {
	          showIn = false;
	        }
	
	        if (_this4.state.punch.IsRestrictedIp) {
	          showIn = false;
	          showOut = false;
	        }
	
	        var openPunchStats = function openPunchStats(e) {
	          e.preventDefault();
	          _this4.props.triggerPopup(true);
	          _this4.setState({
	            punchmodal: {
	              open: true,
	              id: userId,
	              name: name
	            }
	          });
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { className: bgClass, key: 'empl_' + key },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: '', align: 'center', className: 'list__item' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '', onClick: openPunchStats },
	                name,
	                ' (',
	                val.UserInitials,
	                ')'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                lastPunchTxt
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              null,
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)(2230),
	                ':'
	              ),
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                stateTxt
	              )
	            ),
	            state === PUNCH_IN && showOut && _react2.default.createElement(_button2.default, { style: 'alert', spacing: 0, labelText: _react2.default.createElement(_icon2.default, { icon: _icons.ClockIcons.Punch_Out_Red }), onClick: doPunchOut, disabled: !isPunchAllowed }),
	            state === PUNCH_OUT && showIn && _react2.default.createElement(_button2.default, { style: 'link', spacing: 0, labelText: _react2.default.createElement(_icon2.default, { icon: _icons.ClockIcons.Punch_In }), onClick: doPunchIn, disabled: _this4.state.isRequestPending || !isPunchAllowed })
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'employee__list' },
	        _react2.default.createElement(
	          _tableContainer2.default,
	          null,
	          _react2.default.createElement(
	            _tableRow2.default,
	            { cols: ['auto', '236px'], header: true },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)(450)
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)(2230)
	            )
	          ),
	          employees.map(renderEmployee)
	        )
	      );
	    }
	  }, {
	    key: 'closePunchModal',
	    value: function closePunchModal() {
	      this.props.triggerPopup(false);
	      this.setState({
	        punchmodal: {
	          open: false,
	          id: 0,
	          name: ''
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'punchclock__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router }),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderEmployees()
	        ),
	        this.state.punchmodal.open && _react2.default.createElement(_PunchStatsModal2.default, {
	          show: this.state.punchmodal.open,
	          id: this.state.punchmodal.id,
	          name: this.state.punchmodal.name,
	          onClose: this.closePunchModal.bind(this) })
	      );
	    }
	  }]);
	
	  return PunchClock;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    employees: state.common.employees
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPunchStats: _punchclock.getPunchStats,
	  editPunchStats: _punchclock.editPunchStats,
	  renderFullDate: _time.renderFullDate,
	  triggerPopup: _backdrop.triggerPopup
	})(PunchClock);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _NewPunchModal = __webpack_require__(1101);
	
	var _NewPunchModal2 = _interopRequireDefault(_NewPunchModal);
	
	var _backdrop = __webpack_require__(29);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _punchclock = __webpack_require__(173);
	
	__webpack_require__(1450);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Datetime from 'react-datetime'
	
	
	// Modals
	
	
	// import components
	
	
	// Elements
	
	// import Inline from '../../shared/elements/inline'
	
	// import actions
	
	
	// import styles
	
	
	// Utils
	
	
	// import { Icons } from '../../shared/elements/icons'
	
	var PunchEdit = function (_Component) {
	  _inherits(PunchEdit, _Component);
	
	  function PunchEdit(props) {
	    _classCallCheck(this, PunchEdit);
	
	    var _this = _possibleConstructorReturn(this, (PunchEdit.__proto__ || Object.getPrototypeOf(PunchEdit)).call(this, props));
	
	    _this.state = {
	      Times: [{
	        PunchClockStatId: 0,
	        PunchIn: null,
	        PunchOut: null,
	        AwayDate: null,
	        Date: null,
	        Day: null,
	        ModifiedByAdmin: false,
	        CheckVacation: false,
	        CheckSick: false,
	        CheckSickChild: false,
	        CheckPaidAbsence: false,
	        CheckUnPaidAbsence: false
	      }],
	      From: null,
	      To: null,
	      UserId: null,
	      ShowNewPunchModal: false,
	      ChangeAllPopup: {
	        Show: false,
	        Confirmed: false
	      }
	    };
	    _this.renderHeaderTitle = _this.renderHeaderTitle.bind(_this);
	    _this.renderInputArea = _this.renderInputArea.bind(_this);
	    _this.renderReportArea = _this.renderReportArea.bind(_this);
	    _this.renderReportHeader = _this.renderReportHeader.bind(_this);
	    _this.getPunchTimes = _this.getPunchTimes.bind(_this);
	    _this.getReportFromState = _this.getPunchTimesFromState.bind(_this);
	    _this.editPunchTimes = _this.editPunchTimes.bind(_this);
	    _this.setHourMin = _this.setHourMin.bind(_this);
	    _this.toggleNewPunchModal = _this.toggleNewPunchModal.bind(_this);
	    _this.setPunchTimes = _this.setPunchTimes.bind(_this);
	    _this.showChangeAll = _this.showChangeAll.bind(_this);
	    _this.closeChangeAll = _this.closeChangeAll.bind(_this);
	    _this.setUserIdFromProps = _this.setUserIdFromProps.bind(_this);
	    return _this;
	  }
	
	  _createClass(PunchEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.location.query !== undefined) {
	        var query = this.props.location.query;
	        var userId = query.UserId;
	        var fromDate = query.From;
	        var toDate = query.To;
	
	        if (userId === undefined || userId === null || userId === 'undefined') userId = 0;
	        if (fromDate === undefined || fromDate === 'undefined') fromDate = null;
	        if (toDate === undefined || toDate === 'undefined') toDate = null;
	
	        // console.log('did mount: from', fromDate, 'to', toDate)
	        // if (this.props.employees !== undefined && this.props.employees !== null && this.props.employees.length > 0) {
	        //   userId = this.props.employees[0].UserId
	        // }
	
	        if (userId !== 0) {
	          this.setState({
	            UserId: userId
	          }, function () {
	            _this2.getPunchTimesFromState();
	          });
	        } else {
	          this.setUserIdFromProps(this.props);
	        }
	        this.setState({
	          From: fromDate !== null ? (0, _moment2.default)(fromDate) : null,
	          To: toDate !== null ? (0, _moment2.default)(toDate) : null
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.UserId === undefined || this.state.UserId === 0 || this.state.UserId === null) {
	        this.setUserIdFromProps(nextProps);
	      }
	    }
	  }, {
	    key: 'setUserIdFromProps',
	    value: function setUserIdFromProps(props) {
	      var _this3 = this;
	
	      console.log('props.employees', props.employees);
	      if (props.employees !== undefined && props.employees !== null && props.employees.length > 0) {
	        var userId = props.employees[0].UserId;
	        console.log('got props. UserId = ', userId);
	        this.setState({
	          UserId: userId
	        }, function () {
	          _this3.getPunchTimesFromState();
	        });
	      }
	    }
	  }, {
	    key: 'getPunchTimes',
	    value: function getPunchTimes(userId, fromDateTime, toDateTime) {
	      var _this4 = this;
	
	      if (typeof userId === 'undefined') {
	        userId = this.refs.employeeSelect.value;
	      }
	
	      this.props.getEmployeePunchTimes(userId, fromDateTime, toDateTime).then(function (res) {
	        _this4.setPunchTimes(res.data);
	      });
	    }
	  }, {
	    key: 'setPunchTimes',
	    value: function setPunchTimes(data) {
	      // console.log('times', data)
	      var times = [];
	      for (var i = 0; i < data.PunchTimeStats.length; i++) {
	        var item = data.PunchTimeStats[i];
	        var entry = {
	          PunchClockStatId: item.PunchClockStatId,
	          PunchIn: item.PunchIn,
	          PunchOut: item.PunchOut,
	          AwayDate: item.Away,
	          Date: item.Date,
	          Day: item.Day,
	          ModifiedByAdmin: item.ModifiedByAdmin,
	          CheckVacation: item.AwayType === 0,
	          CheckSick: item.AwayType === 1,
	          CheckSickChild: item.AwayType === 2,
	          CheckPaidAbsence: item.AwayType === 3,
	          CheckUnPaidAbsence: item.AwayType === 4
	        };
	        times.push(entry);
	      }
	
	      this.setState({
	        Times: times
	      });
	    }
	  }, {
	    key: 'saveNewEntry',
	    value: function saveNewEntry(entry) {
	      var _this5 = this;
	
	      // console.log('New entry', entry)
	      entry.PunchClockStatId = 0;
	      var times = [].concat(_toConsumableArray(this.state.Times));
	      times.push(entry);
	      // console.log('New entry', entry, 'all entries', times)
	      if (this.state.ShowNewPunchModal === true) {
	        this.toggleNewPunchModal();
	      }
	      this.setState({
	        Times: times
	        // ShowNewPunchModal: false
	      }, function () {
	        _this5.editPunchTimes();
	        // this.props.triggerPopup(!this.state.ShowNewPunchModal)
	      });
	    }
	  }, {
	    key: 'editPunchTimes',
	    value: function editPunchTimes() {
	      var _this6 = this;
	
	      var formatDate = function formatDate(moment) {
	        return moment.year() + '-' + (moment.month() + 1) + '-' + moment.date();
	      };
	
	      var editedTimes = [];
	      for (var i = 0; i < this.state.Times.length; i++) {
	        var entry = this.state.Times[i];
	        var awayType = null;
	        var awayDate = null;
	        if (entry.CheckVacation) awayType = 0;
	        if (entry.CheckSick) awayType = 1;
	        if (entry.CheckSickChild) awayType = 2;
	        if (entry.CheckPaidAbsence) awayType = 3;
	        if (entry.CheckUnPaidAbsence) awayType = 4;
	
	        if (awayType !== null) {
	          awayDate = entry.AwayDate !== null && entry.AwayDate !== undefined ? entry.AwayDate : entry.Date;
	          if (awayDate === null) {
	            continue; // Invalid entry
	          }
	        }
	
	        var item = {
	          PunchClockStatId: entry.PunchClockStatId,
	          PunchIn: entry.PunchIn,
	          PunchOut: entry.PunchOut,
	          ModifiedByAdmin: entry.ModifiedByAdmin,
	          AwayType: awayType,
	          Away: awayDate
	        };
	        editedTimes.push(item);
	      }
	      var data = {
	        UserId: this.state.UserId,
	        PunchTimeStats: editedTimes,
	        From: formatDate(this.state.From),
	        To: formatDate(this.state.To)
	        // console.log('Data', data)
	      };this.props.editEmployeePunchTimes(data).then(function (res) {
	        _this6.setPunchTimes(res.data);
	        if (res.data.Error === null) {
	          // window.toastr.success(translation('2208'), translation('13424'))
	        } else {
	          window.toastr.error((0, _helpers.translation)('2209'), (0, _helpers.translation)(res.data.Error.DictionaryKey));
	        }
	      }, function () {
	        // console.log(err.response.data)
	        window.toastr.error((0, _helpers.translation)('2209'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'getPunchTimesFromState',
	    value: function getPunchTimesFromState() {
	      var userId = this.state.UserId;
	      if (userId === 0) return;
	      if (this.state.From === null) return null;
	      if (this.state.To === null) return null;
	      var formatDate = function formatDate(moment) {
	        return moment.year() + '-' + (moment.month() + 1) + '-' + moment.date();
	      };
	      this.getPunchTimes(userId, formatDate(this.state.From), formatDate(this.state.To));
	    }
	  }, {
	    key: 'toggleNewPunchModal',
	    value: function toggleNewPunchModal() {
	      // console.log('Toggle new punch modal')
	      this.props.triggerPopup(!this.state.ShowNewPunchModal);
	      this.setState({
	        ShowNewPunchModal: !this.state.ShowNewPunchModal
	      });
	    }
	  }, {
	    key: 'renderHeaderTitle',
	    value: function renderHeaderTitle() {
	      return (0, _helpers.translation)('2206');
	    }
	  }, {
	    key: 'renderReportHeader',
	    value: function renderReportHeader(title) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'report_header' },
	        (0, _helpers.translation)(title)
	      );
	    }
	  }, {
	    key: 'renderInputArea',
	    value: function renderInputArea() {
	      var _this7 = this;
	
	      var onDateChange = function onDateChange(name, e) {
	        _this7.setState(_defineProperty({}, name, e));
	      };
	
	      var onEmployeeChange = function onEmployeeChange(e) {
	        var userId = e.target.value;
	        if (_this7.state.UserId !== userId) {
	          _this7.setState({ UserId: userId });
	        }
	      };
	
	      var onShowReportClick = function onShowReportClick(e) {
	        e.preventDefault();
	        _this7.getPunchTimesFromState();
	      };
	
	      var canClickButtons = false;
	      if (this.state.From !== '' && this.state.To !== '' && this.state.From !== null && this.state.To !== null && this.state.UserId > 0) {
	        canClickButtons = true;
	      }
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: '' },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { labelText: (0, _helpers.translation)('449'), name: 'employee', onChange: onEmployeeChange, value: this.state.UserId },
	          _react2.default.createElement(
	            'option',
	            { key: 0, value: null },
	            (0, _helpers.translation)(1440)
	          ),
	          this.props.employees.map(function (emp) {
	            if (emp.Active) {
	              return _react2.default.createElement(
	                'option',
	                { key: emp.UserId, value: emp.UserId },
	                emp.Name
	              );
	            }
	          })
	        ),
	        _react2.default.createElement(_datetime2.default, {
	          labelText: (0, _helpers.translation)('434'),
	          inputProps: {
	            name: 'from',
	            readOnly: true,
	            placeholder: (0, _helpers.translation)('1728')
	          },
	          dateFormat: 'DD-MM-YYYY',
	          timeFormat: false,
	          closeOnSelect: true,
	          value: this.state.From,
	          onChange: onDateChange.bind(this, 'From') }),
	        _react2.default.createElement(_datetime2.default, {
	          labelText: (0, _helpers.translation)('187'),
	          inputProps: {
	            name: 'to',
	            readOnly: true,
	            placeholder: (0, _helpers.translation)('1728')
	          },
	          dateFormat: 'DD-MM-YYYY',
	          timeFormat: false,
	          closeOnSelect: true,
	          value: this.state.To,
	          onChange: onDateChange.bind(this, 'To') }),
	        _react2.default.createElement(_button2.default, { spacing: 0, disabled: !canClickButtons, onClick: onShowReportClick, labelText: (0, _helpers.translation)('380') })
	      );
	    }
	  }, {
	    key: 'setHourMin',
	    value: function setHourMin(dateTime, hhmm) {
	      // Format is 2017-04-02T10:41:16
	      if (hhmm !== null && hhmm.length === 4) {
	        if (hhmm.indexOf(':') === -1) {
	          hhmm = hhmm.substring(0, 2) + ':' + hhmm.substring(2, 4);
	        } else if (hhmm.indexOf(':') === 1) {
	          hhmm = '0' + hhmm;
	        }
	      }
	      console.log('hhmm', hhmm);
	      var result = dateTime.substring(0, 11) + hhmm;
	      return result;
	    }
	  }, {
	    key: 'renderReportArea',
	    value: function renderReportArea() {
	      var _this8 = this;
	
	      if (this.state.Times === undefined || this.state.Times === null) return null;
	      var entries = this.state.Times;
	      var renderEntries = function renderEntries() {
	        var BLANK = _react2.default.createElement(
	          'span',
	          null,
	          '\xA0'
	        );
	        var prevDate = null;
	        var renderEntry = function renderEntry(entry, key) {
	          // console.log(entry)
	          if (entry.PunchIn === null && entry.PunchOut === null && (entry.Date === null || entry.AwayDate === null)) return null;
	          var renderAwayCheck = function renderAwayCheck(entry, type, key) {
	            var name = '';
	            var label = '';
	            switch (type) {
	              case 0:
	                name = 'CheckVacation';
	                label = '500';
	                break;
	              case 1:
	                name = 'CheckSick';
	                label = '508';
	                break;
	              case 2:
	                name = 'CheckSickChild';
	                label = '502';
	                break;
	              case 3:
	                name = 'CheckPaidAbsence';
	                label = '1436';
	                break;
	              case 4:
	                name = 'CheckUnPaidAbsence';
	                label = '1435';
	                break;
	            }
	            var value = entry[name];
	
	            var onChangeAwayType = function onChangeAwayType(e) {
	              entry.CheckVacation = false;
	              entry.CheckSick = false;
	              entry.CheckSickChild = false;
	              entry.CheckPaidAbsence = false;
	              entry.CheckUnPaidAbsence = false;
	              entry[name] = e.target.checked;
	
	              if (entry.CheckVacation || entry.CheckSick || entry.CheckSickChild || entry.CheckPaidAbsence || entry.CheckUnPaidAbsence) {
	                if (entry.AwayDate === null) entry.AwayDate = entry.Date;
	              } else {
	                // console.log('setting punch in to', entry.Date, entry)
	                // if (entry.PunchIn === null) entry.PunchIn = entry.Date
	              }
	              if (entry.PunchClockStatId < 0) {
	                entry.PunchClockStatId = 0; // Instruct api to create this entry
	              }
	              var times = [].concat(_toConsumableArray(_this8.state.Times));
	              times[key] = entry;
	              _this8.setState({
	                Times: times
	              }, function () {
	                _this8.editPunchTimes();
	              });
	            };
	
	            return _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)(label), id: name + '_' + key, name: name, value: '0', onChange: onChangeAwayType.bind(_this8), checked: value === true });
	          };
	
	          var onChangeTime = function onChangeTime(e) {
	            e.persist();
	            entry = _this8.state.Times[key];
	            var value = e.target.value;
	            // if (value === '') value = null
	            if (e.target.name === 'punchIn') {
	              // if (entry.CheckVacation || entry.CheckSick || entry.CheckSickChild || entry.CheckPaidAbsence || entry.CheckUnPaidAbsence) {
	              //   entry.AwayDate = this.setHourMin(entry.AwayDate, value)
	              // } else {
	              if (entry.PunchIn === null) entry.PunchIn = entry.Date;
	              entry.PunchIn = _this8.setHourMin(entry.PunchIn, value);
	              // }
	            } else if (e.target.name === 'punchOut') {
	              if (entry.PunchOut === null) entry.PunchOut = entry.Date;
	              entry.PunchOut = _this8.setHourMin(entry.PunchOut, value);
	            }
	
	            if (entry.PunchClockStatId < 0) {
	              entry.PunchClockStatId = 0; // Instruct api to create this entry
	            }
	
	            // let times = [...this.state.Times]
	            var times = _this8.state.Times;
	            times[key] = entry;
	            _this8.setState({
	              Times: times
	            }, function () {
	              e.target.focus();
	            });
	          };
	
	          var onDelete = function onDelete(e) {
	            entry = _this8.state.Times[key];
	            entry.PunchIn = null;
	            entry.PunchOut = null;
	            entry.CheckVacation = false;
	            entry.CheckSick = false;
	            entry.CheckSickChild = false;
	            entry.CheckPaidAbsence = false;
	            entry.CheckUnPaidAbsence = false;
	            entry.AwayDate = null;
	            var times = [].concat(_toConsumableArray(_this8.state.Times));
	            times[key] = entry;
	            _this8.setState({
	              Times: times
	            }, function () {
	              _this8.editPunchTimes();
	            });
	          };
	
	          var date = entry.Date;
	          if (date === undefined || date === null) return null;
	          var punchIn = entry.PunchIn !== null ? entry.PunchIn.substring(11, 16) : '';
	          var punchOut = entry.PunchOut !== null ? entry.PunchOut.substring(11, 16) : '';
	          var isAbsence = entry.AwayDate !== null && (entry.CheckVacation || entry.CheckSick || entry.CheckSickChild || entry.CheckPaidAbsence || entry.CheckUnPaidAbsence);
	          console.log('Entry', entry);
	          var dayClass = '';
	          var day = '';
	          switch (entry.Day) {
	            case 0:
	              // sunday
	              day = (0, _helpers.translation)('175').substring(0, 3);
	              dayClass = 'weekend';
	              break;
	            case 1:
	              // monday
	              day = (0, _helpers.translation)('169').substring(0, 3);
	              break;
	            case 2:
	              // ..
	              day = (0, _helpers.translation)('170').substring(0, 3);
	              break;
	            case 3:
	              // ..
	              day = (0, _helpers.translation)('171').substring(0, 3);
	              break;
	            case 4:
	              // ..
	              day = (0, _helpers.translation)('172').substring(0, 3);
	              break;
	            case 5:
	              // friday
	              day = (0, _helpers.translation)('173').substring(0, 3);
	              break;
	            case 6:
	              // saturday
	              day = (0, _helpers.translation)('174').substring(0, 3);
	              dayClass = 'weekend';
	              break;
	
	          }
	
	          day = day.substring(0, 3);
	
	          var dateShown = (0, _time.renderFullDate)(date, false);
	          var newDay = true;
	          // If current entry date is same as previous entry date, don't write out date again.
	          if (prevDate !== null && prevDate !== undefined) {
	            if (prevDate.substring(0, 10) === date.substring(0, 10)) {
	              dateShown = BLANK;
	              day = BLANK;
	              newDay = false;
	            }
	          }
	          prevDate = date;
	          if (!newDay) {
	            return _react2.default.createElement(
	              _tableRow2.default,
	              { key: 'entry_' + key, cols: [1, 1, 1, 1, 1, 1, 1, 1, 'min-content'] },
	              _react2.default.createElement(
	                'div',
	                { className: 'date' },
	                _react2.default.createElement(
	                  'span',
	                  { className: dayClass },
	                  day
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: dayClass },
	                  dateShown
	                )
	              ),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'punchIn', maxLength: '5', value: punchIn || '', onChange: onChangeTime, onBlur: _this8.editPunchTimes, disabled: isAbsence }),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'punchOut', maxLength: '5', value: punchOut || '', onChange: onChangeTime, onBlur: _this8.editPunchTimes, disabled: isAbsence }),
	              _react2.default.createElement(
	                'div',
	                null,
	                BLANK
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                BLANK
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                BLANK
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                BLANK
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                BLANK
	              ),
	              _react2.default.createElement(_removeButton2.default, { round: true, size: 's', onClick: onDelete })
	            );
	          } else {
	            return _react2.default.createElement(
	              _tableRow2.default,
	              { key: 'entry_' + key, cols: [1, 1, 1, 1, 1, 1, 1, 1, 'min-content'] },
	              _react2.default.createElement(
	                'div',
	                { className: 'date' },
	                _react2.default.createElement(
	                  'span',
	                  { className: dayClass },
	                  day
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: dayClass },
	                  dateShown
	                )
	              ),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'punchIn', maxLength: '5', value: punchIn === null ? '' : punchIn, onChange: onChangeTime, onBlur: _this8.editPunchTimes, disabled: isAbsence }),
	              _react2.default.createElement(_text2.default, { size: 'm', name: 'punchOut', maxLength: '5', value: punchOut === null ? '' : punchOut, onChange: onChangeTime, onBlur: _this8.editPunchTimes, disabled: isAbsence }),
	              _react2.default.createElement(
	                'div',
	                null,
	                renderAwayCheck(entry, 0, key)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                renderAwayCheck(entry, 1, key)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                renderAwayCheck(entry, 2, key)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                renderAwayCheck(entry, 3, key)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                renderAwayCheck(entry, 4, key)
	              ),
	              _react2.default.createElement(_removeButton2.default, { round: true, size: 's', onClick: onDelete })
	            );
	          }
	        };
	
	        var isAllChecked = function isAllChecked(type) {
	          for (var i = 0; i < _this8.state.Times.length; i++) {
	            var entry = _this8.state.Times[i];
	            switch (type) {
	              case 0:
	                if (!entry.CheckVacation) return false;
	                break;
	              case 1:
	                if (!entry.CheckSick) return false;
	                break;
	              case 2:
	                if (!entry.CheckSickChild) return false;
	                break;
	              case 3:
	                if (!entry.CheckPaidAbsence) return false;
	                break;
	              case 4:
	                if (!entry.CheckUnPaidAbsence) return false;
	                break;
	            }
	          }
	          return true;
	        };
	
	        var onChangeAll = function onChangeAll(e) {
	          _this8.showChangeAll(e.target.name);
	        };
	
	        return _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _tableContainer2.default,
	            null,
	            _react2.default.createElement(
	              _tableRow2.default,
	              { header: true, cols: [1, 1, 1, 1, 1, 1, 1, 1, 'min-content'] },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('388')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('443')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('1899')
	              ),
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('381'), id: 'all_vacation', name: 'all_vacation', value: '0', onChange: onChangeAll, checked: isAllChecked(0) }),
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('381'), id: 'all_sick', name: 'all_sick', value: '0', onChange: onChangeAll, checked: isAllChecked(1) }),
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('381'), id: 'all_sickchild', name: 'all_sickchild', value: '0', onChange: onChangeAll, checked: isAllChecked(2) }),
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('381'), id: 'all_paidabsence', name: 'all_paidabsence', value: '0', onChange: onChangeAll, checked: isAllChecked(3) }),
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('381'), id: 'all_unpaidabsence', name: 'all_unpaidabsence', value: '0', onChange: onChangeAll, checked: isAllChecked(4) }),
	              _react2.default.createElement(_addButton2.default, { size: 's', onClick: _this8.toggleNewPunchModal })
	            ),
	            entries.map(renderEntry)
	          )
	        );
	      };
	
	      return this.state.Times.length > 0 && renderEntries();
	    }
	  }, {
	    key: 'showChangeAll',
	    value: function showChangeAll(arg) {
	      var popup = _extends({}, this.state.ChangeAllPopup);
	      popup.Confirmed = false;
	      popup.Show = true;
	      popup.Arg = arg;
	
	      this.setState({
	        ChangeAllPopup: popup
	      });
	    }
	  }, {
	    key: 'closeChangeAll',
	    value: function closeChangeAll() {
	      var _this9 = this;
	
	      var confirm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var popup = _extends({}, this.state.ChangeAllPopup);
	      var arg = popup.Arg;
	      popup.Confirmed = confirm;
	      popup.Show = false;
	      popup.Arg = null;
	      this.setState({
	        ChangeAllPopup: popup
	      }, function () {
	        if (confirm && arg !== null && arg !== undefined) {
	          var times = [].concat(_toConsumableArray(_this9.state.Times));
	          for (var i = 0; i < times.length; i++) {
	            times[i].CheckVacation = true;
	            times[i].CheckSick = false;
	            times[i].CheckSickChild = false;
	            times[i].CheckPaidAbsence = false;
	            times[i].CheckUnPaidAbsence = false;
	            switch (arg) {
	              case 'all_vacation':
	                times[i].CheckVacation = true;
	                break;
	              case 'all_sick':
	                times[i].CheckSick = true;
	                break;
	              case 'all_sickchild':
	                times[i].CheckSickChild = true;
	                break;
	              case 'all_paidabsence':
	                times[i].CheckPaidAbsence = true;
	                break;
	              case 'all_unpaidabsence':
	                times[i].CheckUnPaidAbsence = true;
	                break;
	            }
	            if (times[i].PunchClockStatId === -1) {
	              times[i].PunchClockStatId = 0;
	            }
	            // times[i].PunchIn = null
	            // times[i].PunchOut = null
	            times[i].AwayDate = times[i].Date;
	          }
	          _this9.setState({
	            Times: times
	          }, function () {
	            _this9.editPunchTimes();
	            // console.log('State after set all', this.state)
	          });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      var formatDate = function formatDate(moment) {
	        var year = moment.year();
	        var month = moment.month() + 1;
	        var day = moment.date();
	
	        month = month < 10 ? '0' + month.toString() : month.toString();
	        day = day < 10 ? '0' + day.toString() : day.toString();
	        return year + '-' + month + '-' + day;
	      };
	      var fromDate = this.state.From !== null && this.state.From !== '' ? formatDate(this.state.From) : null;
	      var toDate = this.state.To !== null && this.state.To !== '' ? formatDate(this.state.To) : null;
	
	      var editLinkParams = '';
	      if (this.state.UserId !== 0) {
	        editLinkParams += editLinkParams === '' ? '?' : '&';
	        editLinkParams += 'UserId=' + this.state.UserId;
	      }
	      if (this.state.From !== null && this.state.From !== '') {
	        editLinkParams += editLinkParams === '' ? '?' : '&';
	        editLinkParams += 'From=' + fromDate;
	      }
	
	      if (this.state.To !== null) {
	        editLinkParams += editLinkParams === '' ? '?' : '&';
	        editLinkParams += 'To=' + toDate;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'punchedit__screen' },
	        _react2.default.createElement(
	          _Header2.default,
	          { router: this.props.router },
	          _react2.default.createElement(
	            _tabBar2.default,
	            null,
	            _react2.default.createElement(
	              _tabItem2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/punchreport' + editLinkParams },
	                (0, _helpers.translation)('2159')
	              )
	            ),
	            _react2.default.createElement(
	              _tabItem2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/punchedit' + editLinkParams, className: 'active' },
	                (0, _helpers.translation)('2206')
	              )
	            ),
	            _react2.default.createElement(
	              _tabItem2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/absencereport' },
	                (0, _helpers.translation)('1128')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderInputArea()
	          )
	        ),
	        this.renderReportArea(),
	        _react2.default.createElement(_NewPunchModal2.default, {
	          saveNewEntry: this.saveNewEntry.bind(this),
	          show: this.state.ShowNewPunchModal,
	          onClose: this.toggleNewPunchModal }),
	        this.state.ChangeAllPopup.Show && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: this.closeChangeAll.bind(this, false) },
	          _react2.default.createElement(_Confirm2.default, { confirm: this.closeChangeAll.bind(this, true), notConfirm: this.closeChangeAll.bind(this, false), renderText: function renderText() {
	              return _react2.default.createElement(
	                'p',
	                null,
	                (0, _helpers.translation)('2207')
	              );
	            } })
	        )
	      );
	    }
	  }]);
	
	  return PunchEdit;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    employees: state.common.employees
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  renderFullDate: _time.renderFullDate,
	  getEmployeePunchTimes: _punchclock.getEmployeePunchTimes,
	  editEmployeePunchTimes: _punchclock.editEmployeePunchTimes,
	  triggerPopup: _backdrop.triggerPopup
	})(PunchEdit);

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(43);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _punchclock = __webpack_require__(173);
	
	var _backdrop = __webpack_require__(29);
	
	var _common = __webpack_require__(25);
	
	__webpack_require__(1451);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _PunchReportModal = __webpack_require__(1106);
	
	var _PunchReportModal2 = _interopRequireDefault(_PunchReportModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import components
	
	
	// Elements
	
	
	// import actions
	
	// import styles
	
	
	// Utils
	
	
	// Modals
	
	
	var PunchReport = function (_Component) {
	  _inherits(PunchReport, _Component);
	
	  function PunchReport(props) {
	    _classCallCheck(this, PunchReport);
	
	    var _this = _possibleConstructorReturn(this, (PunchReport.__proto__ || Object.getPrototypeOf(PunchReport)).call(this, props));
	
	    _this.state = {
	      punchReport: [{
	        Id: 0,
	        DateRec: '',
	        PunchIn: '',
	        PunchOut: '',
	        Away: false,
	        AwayType: 0,
	        StandardWorkHours: '',
	        UnderOverTime: '',
	        Pauses: 0,
	        OverallPauseTime: '',
	        Hours: 0,
	        OverallHours: '',
	        IsAdminRecord: false,
	        ClosingDayId: 0,
	        ClosingDayName: null
	      }],
	      From: null,
	      To: null,
	      UserId: null,
	      punchmodal: {
	        open: false
	      }
	    };
	    _this.renderHeaderTitle = _this.renderHeaderTitle.bind(_this);
	    _this.getReport = _this.getReport.bind(_this);
	    _this.renderInputArea = _this.renderInputArea.bind(_this);
	    _this.renderReportArea = _this.renderReportArea.bind(_this);
	    _this.renderReportHeader = _this.renderReportHeader.bind(_this);
	    _this.getReportFromState = _this.getReportFromState.bind(_this);
	    _this.calcTotals = _this.calcTotals.bind(_this);
	
	    _this.openMultipleEmployeesPopup = _this.openMultipleEmployeesPopup.bind(_this);
	    _this.closePunchModal = _this.closePunchModal.bind(_this);
	    _this.minutesToTimeFormat = _this.minutesToTimeFormat.bind(_this);
	    _this.parseTimeToMinutes = _this.parseTimeToMinutes.bind(_this);
	    return _this;
	  }
	
	  _createClass(PunchReport, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.location.query !== undefined) {
	        var query = this.props.location.query;
	        var userId = query.UserId;
	        var fromDate = query.From;
	        var toDate = query.To;
	
	        if (userId === undefined || userId === null) userId !== 0;
	        if (fromDate === undefined) fromDate = null;
	        if (toDate === undefined) toDate = null;
	
	        this.setState({
	          UserId: userId,
	          From: fromDate !== null ? (0, _moment2.default)(fromDate) : null,
	          To: toDate !== null ? (0, _moment2.default)(toDate) : null
	        }, function () {
	          _this2.getReportFromState();
	        });
	      }
	      this.setBodyClass(false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setBodyClass(true);
	    }
	  }, {
	    key: 'setBodyClass',
	    value: function setBodyClass(out) {
	      setTimeout(function () {
	        if (out) {
	          document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('puncreport__body', '');
	        } else {
	          document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className + ' puncreport__body';
	        }
	      }, 0);
	    }
	  }, {
	    key: 'getReport',
	    value: function getReport(userId, fromDateTime, toDateTime) {
	      var _this3 = this;
	
	      if (typeof userId === 'undefined') {
	        userId = this.refs.employeeSelect.value;
	      }
	      this.props.getShopPunchTimeReport(userId, fromDateTime, toDateTime).then(function (res) {
	        _this3.setState({
	          punchReport: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getReportFromState',
	    value: function getReportFromState() {
	      var userId = this.state.UserId;
	      if (userId === 0) return;
	      if (this.state.From === null) return null;
	      if (this.state.To === null) return null;
	      var formatDate = function formatDate(moment) {
	        return moment.format('YYYY-MM-DD');
	      };
	      this.getReport(userId, formatDate(this.state.From), formatDate(this.state.To));
	    }
	  }, {
	    key: 'minutesToTimeFormat',
	    value: function minutesToTimeFormat(minutes) {
	      var minutesAsDecimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var negative = minutes < 0;
	      minutes = Math.abs(minutes);
	      var h = Math.floor(minutes / 60).toFixed(0);
	      var m = (minutes % 60).toFixed(0);
	      if (minutesAsDecimal) {
	        m = (parseInt(m) * (100 / 60)).toFixed(0);
	        if (m.length === 1) m = '0' + m;
	        return h + ',' + m; // need to add , or . depending on language.
	      }
	      if (m.length === 1) m = '0' + m;
	      return (negative ? '-' : '') + h + ':' + m;
	    }
	  }, {
	    key: 'parseTimeToMinutes',
	    value: function parseTimeToMinutes(time) {
	      if (time === null || time === '') return 0;
	      var parts = time.split(':');
	      var negative = parts[0].startsWith('-');
	      var hours = Math.abs(parseInt(parts[0]));
	      var minutes = parseInt(parts[1]);
	      var result = (hours * 60 + minutes) * (negative ? -1 : 1);
	      return result;
	    }
	  }, {
	    key: 'calcTotals',
	    value: function calcTotals() {
	      var breakTotal = 0;
	      var standardTimeTotal = 0;
	      var totalTimeTotal = 0;
	      // let totalTimeHourTotal = 0
	      var underTimeTotal = 0;
	      // let underTimeHourTotal = 0
	      var overTimeTotal = 0;
	      // let overTimeHourTotal = 0
	      var VacationTotal = 0;
	      var SickTotal = 0;
	      var SickChildTotal = 0;
	      var AwayWithPayTotal = 0;
	      var AwayWithoutPayTotal = 0;
	      var VacationTotalDays = 0;
	      var SickTotalDays = 0;
	      var SickChildTotalDays = 0;
	      var AwayWithPayTotalDays = 0;
	      var AwayWithoutPayTotalDays = 0;
	
	      var report = this.state.punchReport;
	      var prevEntry = null;
	      if (report !== null && report.length > 0) {
	        for (var i = 0; i < report.length; i++) {
	          var entry = report[i];
	          if (prevEntry === null || prevEntry.DateRec !== entry.DateRec) {
	            var overUnder = this.parseTimeToMinutes(entry.UnderOverTime);
	            if (overUnder > 0) {
	              overTimeTotal += overUnder;
	            } else {
	              underTimeTotal += overUnder;
	            }
	
	            // overTimeTotal += entry.UnderOverTime > 0 ? entry.UnderOverTime : 0
	            // underTimeTotal += entry.UnderOverTime < 0 ? entry.UnderOverTime : 0
	
	            if (entry.OverallPauseTime !== '') {
	              breakTotal += this.parseTimeToMinutes(entry.OverallPauseTime);
	              // breakTotal += (parseInt(entry.OverallPauseTime.split(':', 2)[0]) * 60) + parseInt(entry.OverallPauseTime.split(':', 2)[1])
	            }
	            if (entry.StandardWorkHours !== '' && (!entry.Away || entry.AwayType === 4)) {
	              standardTimeTotal += this.parseTimeToMinutes(entry.StandardWorkHours);
	              // standardTimeTotal += (parseInt(entry.StandardWorkHours.split(':', 2)[0]) * 60) + parseInt(entry.StandardWorkHours.split(':', 2)[1])
	            }
	            if (entry.OverallHours !== '') {
	              totalTimeTotal += this.parseTimeToMinutes(entry.OverallHours);
	              // totalTimeTotal += (parseInt(entry.OverallHours.split(':', 2)[0]) * 60) + parseInt(entry.OverallHours.split(':', 2)[1])
	            }
	
	            if (entry.Away) {
	              switch (entry.AwayType) {
	                case 0:
	                  if (entry.StandardWorkHours !== '') {
	                    VacationTotal += this.parseTimeToMinutes(entry.StandardWorkHours); // Vacation
	                    VacationTotalDays += 1;
	                  }
	                  break;
	                case 1:
	                  if (entry.StandardWorkHours !== '') {
	                    SickTotal += this.parseTimeToMinutes(entry.StandardWorkHours); // Sick
	                    SickTotalDays += 1;
	                  }
	                  break;
	                case 2:
	                  if (entry.StandardWorkHours !== '') {
	                    SickChildTotal += this.parseTimeToMinutes(entry.StandardWorkHours); // Sick child
	                    SickChildTotalDays += 1;
	                  }
	                  break;
	                case 3:
	                  if (entry.StandardWorkHours !== '') {
	                    AwayWithPayTotal += this.parseTimeToMinutes(entry.StandardWorkHours); // Away with pay
	                    AwayWithPayTotalDays += 1;
	                  }
	                  break;
	                case 4:
	                  if (entry.StandardWorkHours !== '') {
	                    AwayWithoutPayTotal += this.parseTimeToMinutes(entry.StandardWorkHours); // Away without pay
	                    AwayWithoutPayTotalDays += 1;
	                  }
	                  break;
	              }
	            }
	          }
	          prevEntry = entry;
	        }
	      }
	
	      return {
	        BreakTotal: this.minutesToTimeFormat(breakTotal),
	        StandardTimeTotal: this.minutesToTimeFormat(standardTimeTotal),
	        TotalTimeTotal: this.minutesToTimeFormat(totalTimeTotal),
	        TotalTimeHourTotal: this.minutesToTimeFormat(totalTimeTotal, true),
	        UnderTimeTotal: this.minutesToTimeFormat(underTimeTotal),
	        UnderTimeHourTotal: this.minutesToTimeFormat(underTimeTotal, true),
	        OverTimeTotal: this.minutesToTimeFormat(overTimeTotal),
	        OverTimeHourTotal: this.minutesToTimeFormat(overTimeTotal, true),
	
	        VacationTotal: this.minutesToTimeFormat(VacationTotal),
	        SickTotal: this.minutesToTimeFormat(SickTotal),
	        SickChildTotal: this.minutesToTimeFormat(SickChildTotal),
	        AwayWithPayTotal: this.minutesToTimeFormat(AwayWithPayTotal),
	        AwayWithoutPayTotal: this.minutesToTimeFormat(AwayWithoutPayTotal),
	        VacationTotalDays: VacationTotalDays,
	        SickTotalDays: SickTotalDays,
	        SickChildTotalDays: SickChildTotalDays,
	        AwayWithPayTotalDays: AwayWithPayTotalDays,
	        AwayWithoutPayTotalDays: AwayWithoutPayTotalDays
	      };
	    }
	  }, {
	    key: 'renderHeaderTitle',
	    value: function renderHeaderTitle() {
	      return (0, _helpers.translation)('2159');
	    }
	  }, {
	    key: 'renderReportHeader',
	    value: function renderReportHeader(title) {
	      return _react2.default.createElement(
	        'h2',
	        null,
	        (0, _helpers.translation)(title)
	      );
	    }
	  }, {
	    key: 'openMultipleEmployeesPopup',
	    value: function openMultipleEmployeesPopup(e) {
	      e.preventDefault();
	      this.props.triggerPopup(true);
	      this.setState({
	        punchmodal: {
	          open: true
	        }
	      });
	    }
	  }, {
	    key: 'closePunchModal',
	    value: function closePunchModal() {
	      this.props.triggerPopup(false);
	      this.setState({
	        punchmodal: {
	          open: false
	        }
	      });
	    }
	  }, {
	    key: 'renderInputArea',
	    value: function renderInputArea() {
	      var _this4 = this;
	
	      var onDateChange = function onDateChange(name, e) {
	        _this4.setState(_defineProperty({}, name, e));
	      };
	
	      var onEmployeeChange = function onEmployeeChange(e) {
	        var userId = e.target.value;
	        if (_this4.state.UserId !== userId) {
	          _this4.setState({ UserId: userId });
	        }
	      };
	
	      var onShowReportClick = function onShowReportClick(e) {
	        e.preventDefault();
	        _this4.getReportFromState();
	      };
	
	      var canClickButtons = false;
	      if (this.state.From !== '' && this.state.To !== '' && this.state.From !== null && this.state.To !== null && this.state.UserId > 0) {
	        canClickButtons = true;
	      }
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: '' },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'employee', onChange: onEmployeeChange, value: this.state.UserId, ref: 'employeeSelect', labelText: (0, _helpers.translation)('449') },
	          _react2.default.createElement(
	            'option',
	            { key: 0, value: null },
	            (0, _helpers.translation)(1440)
	          ),
	          this.props.employees.map(function (emp) {
	            if (emp.Active) {
	              return _react2.default.createElement(
	                'option',
	                { key: emp.UserId, value: emp.UserId },
	                emp.Name
	              );
	            }
	          })
	        ),
	        _react2.default.createElement(_datetime2.default, {
	          labelText: (0, _helpers.translation)('434'),
	          inputProps: {
	            name: 'from',
	            readOnly: true,
	            placeholder: (0, _helpers.translation)('1728')
	          },
	          dateFormat: 'DD-MM-YYYY',
	          timeFormat: false,
	          closeOnSelect: true,
	          value: this.state.From,
	          onChange: onDateChange.bind(this, 'From') }),
	        _react2.default.createElement(_datetime2.default, {
	          labelText: (0, _helpers.translation)('187'),
	          inputProps: {
	            name: 'to',
	            readOnly: true,
	            placeholder: (0, _helpers.translation)('1728')
	          },
	          dateFormat: 'DD-MM-YYYY',
	          timeFormat: false,
	          closeOnSelect: true,
	          value: this.state.To,
	          onChange: onDateChange.bind(this, 'To') }),
	        _react2.default.createElement(_button2.default, { disabled: !canClickButtons, onClick: onShowReportClick, labelText: (0, _helpers.translation)('380') }),
	        _react2.default.createElement(_button2.default, { style: 'link', disabled: !canClickButtons, onClick: this.openMultipleEmployeesPopup, labelText: (0, _helpers.translation)('2240') })
	      );
	    }
	  }, {
	    key: 'renderReportArea',
	    value: function renderReportArea() {
	      var _this5 = this;
	
	      var entries = this.state.punchReport;
	      var renderEntries = function renderEntries() {
	        var BLANK = _react2.default.createElement(
	          'span',
	          null,
	          '\xA0'
	        );
	        var prevEntry = null;
	        var renderTotals = function renderTotals() {
	          var totals = _this5.calcTotals();
	          return _react2.default.createElement(
	            'div',
	            { className: 'totals' },
	            _react2.default.createElement(
	              _tableRow2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)(472)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                BLANK
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                BLANK
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                BLANK
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                totals.StandardTimeTotal
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  totals.TotalTimeTotal
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  '(',
	                  totals.TotalTimeHourTotal,
	                  ' ',
	                  (0, _helpers.translation)('989'),
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  totals.UnderTimeTotal
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  '(',
	                  totals.UnderTimeHourTotal,
	                  ' ',
	                  (0, _helpers.translation)('989'),
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  totals.OverTimeTotal
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  '(',
	                  totals.OverTimeHourTotal,
	                  ' ',
	                  (0, _helpers.translation)('989'),
	                  ')'
	                )
	              )
	            ),
	            totals.VacationTotal !== '0:00' && _react2.default.createElement(
	              _tableRow2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('500')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                totals.VacationTotal + ' (' + totals.VacationTotalDays + ' ' + (0, _helpers.translation)('503') + ')'
	              )
	            ),
	            totals.SickTotal !== '0:00' && _react2.default.createElement(
	              _tableRow2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('508')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                totals.SickTotal + ' (' + totals.SickTotalDays + ' ' + (0, _helpers.translation)('503') + ')'
	              )
	            ),
	            totals.SickChildTotal !== '0:00' && _react2.default.createElement(
	              _tableRow2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('502')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                totals.SickChildTotal + ' (' + totals.SickChildTotalDays + ' ' + (0, _helpers.translation)('503') + ')'
	              )
	            ),
	            totals.AwayWithPayTotal !== '0:00' && _react2.default.createElement(
	              _tableRow2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('1436')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                totals.AwayWithPayTotal + ' (' + totals.AwayWithPayTotalDays + ' ' + (0, _helpers.translation)('503') + ')'
	              )
	            ),
	            totals.AwayWithoutPayTotal !== '0:00' && _react2.default.createElement(
	              _tableRow2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('1435')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                totals.AwayWithoutPayTotal + ' (' + totals.AwayWithoutPayTotalDays + ' ' + (0, _helpers.translation)('503') + ')'
	              )
	            )
	          );
	        };
	        var renderEntry = function renderEntry(entry, key) {
	          console.log('entry.IsAdminRecord ', entry.IsAdminRecord, entry);
	          // console.log('entry', entry)
	          var date = entry.DateRec;
	          var punchIn = entry.PunchIn;
	          var punchOut = entry.PunchOut;
	          // let pauses = entry.Pauses
	          var pausesText = entry.PausesText;
	          var totalPause = entry.OverallPauseTime;
	          var standardHours = entry.StandardWorkHours;
	          var totalHours = entry.OverallHours;
	          var overUnderMinutes = _this5.parseTimeToMinutes(entry.UnderOverTime);
	          var overTime = overUnderMinutes > 0 ? overUnderMinutes : 0;
	          var underTime = overUnderMinutes < 0 ? overUnderMinutes : 0;
	          var closingDayId = entry.ClosingDayId;
	          var closingDayName = entry.ClosingDayName !== null ? entry.ClosingDayName : (0, _helpers.translation)('500'); // Holiday
	          var awayType = entry.AwayType;
	          var awayTypeName = null;
	          var isAdminRec = entry.IsAdminRecord;
	
	          if (entry.Away) {
	            switch (awayType) {
	              case 0:
	                awayTypeName = (0, _helpers.translation)('500'); // Vacation
	                break;
	              case 1:
	                awayTypeName = (0, _helpers.translation)('508'); // Sick
	                break;
	              case 2:
	                awayTypeName = (0, _helpers.translation)('502'); // Sick child
	                break;
	              case 3:
	                awayTypeName = (0, _helpers.translation)('1436'); // Away with pay
	                break;
	              case 4:
	                awayTypeName = (0, _helpers.translation)('1435'); // Away without pay
	                break;
	            }
	          }
	
	          // If current entry date is same as previous entry date, don't write out date again.
	          if (prevEntry !== null && prevEntry.DateRec === entry.DateRec) date = BLANK;
	
	          // Replace blank fields.
	          if (punchIn === '') punchIn = '-';
	          if (punchOut === '') punchOut = '-';
	          if (standardHours === '' || standardHours === '00:00') standardHours = BLANK;
	          if (totalHours === '' || totalHours === '00:00') totalHours = BLANK;
	
	          if (punchIn === '-' && punchOut === '-' && entry.Away && awayType !== 4) standardHours = BLANK;
	
	          overTime = overTime === 0 ? BLANK : _this5.minutesToTimeFormat(overTime);
	          underTime = underTime === 0 ? BLANK : _this5.minutesToTimeFormat(underTime);
	          // if (overTime === 0) overTime = BLANK
	          // if (underTime === 0) underTime = BLANK
	
	          if (totalPause === '00:00') totalPause = '';
	
	          // Break minutes
	          if (pausesText === null || pausesText === '') {
	            pausesText = '-';
	          }
	
	          if (totalPause === '') totalPause = BLANK;
	
	          if (prevEntry !== null && prevEntry.DateRec === entry.DateRec) {
	            // pauses = BLANK
	            pausesText = BLANK;
	            totalPause = BLANK;
	            standardHours = BLANK;
	            totalHours = BLANK;
	            overTime = BLANK;
	            underTime = BLANK;
	          }
	
	          var specialDay = null;
	          if (awayType !== null) specialDay = awayTypeName;
	          if (closingDayId !== 0) specialDay = closingDayName;
	          var extraClass = specialDay === null ? '' : 'specialday';
	
	          prevEntry = entry;
	          // console.log('key', key, 'entry', entry)
	          var punchClass = isAdminRec ? 'isModified' : '';
	          return _react2.default.createElement(
	            _tableRow2.default,
	            { key: key + '_' + entry.id, className: punchClass },
	            specialDay !== null && _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              _react2.default.createElement(
	                'div',
	                null,
	                date
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: extraClass },
	                '(',
	                specialDay,
	                ')'
	              )
	            ) || _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              _react2.default.createElement(
	                'div',
	                null,
	                date
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time_small ' },
	              punchIn
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time_small ' },
	              punchOut
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time' },
	              totalPause
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time' },
	              standardHours
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time' },
	              totalHours
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time_small' },
	              underTime
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time_small' },
	              overTime
	            )
	          );
	        };
	        return _react2.default.createElement(
	          _tableContainer2.default,
	          null,
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              (0, _helpers.translation)('388')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time_small' },
	              (0, _helpers.translation)('443')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time_small' },
	              (0, _helpers.translation)('1899')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time' },
	              (0, _helpers.translation)('595')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time' },
	              (0, _helpers.translation)('469')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time' },
	              (0, _helpers.translation)('470')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time_small' },
	              (0, _helpers.translation)('2158')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'time_small' },
	              (0, _helpers.translation)('455')
	            )
	          ),
	          entries.map(renderEntry),
	          renderTotals()
	        );
	      };
	
	      return this.state.punchReport.length > 0 && renderEntries();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      var formatDate = function formatDate(moment) {
	        return moment.format('YYYY-MM-DD');
	      };
	      var fromDate = this.state.From !== null && this.state.From !== '' ? formatDate(this.state.From) : null;
	      var toDate = this.state.To !== null && this.state.To !== '' ? formatDate(this.state.To) : null;
	
	      var editLinkParams = '';
	      if (this.state.UserId !== 0) {
	        editLinkParams += editLinkParams === '' ? '?' : '&';
	        editLinkParams += 'UserId=' + this.state.UserId;
	      }
	      if (this.state.From !== null && this.state.From !== '') {
	        editLinkParams += editLinkParams === '' ? '?' : '&';
	        editLinkParams += 'From=' + fromDate;
	      }
	
	      if (this.state.To !== null) {
	        editLinkParams += editLinkParams === '' ? '?' : '&';
	        editLinkParams += 'To=' + toDate;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'punchreport__screen' },
	        _react2.default.createElement(
	          _Header2.default,
	          { router: this.props.router },
	          _react2.default.createElement(
	            _tabBar2.default,
	            null,
	            _react2.default.createElement(
	              _tabItem2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/punchreport' + editLinkParams, className: 'active' },
	                (0, _helpers.translation)('2159')
	              )
	            ),
	            _react2.default.createElement(
	              _tabItem2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/punchedit' + editLinkParams },
	                (0, _helpers.translation)('2206')
	              )
	            ),
	            _react2.default.createElement(
	              _tabItem2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/absencereport' },
	                (0, _helpers.translation)('1128')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'title__header' },
	          (0, _helpers.translation)('2231')
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderInputArea()
	          )
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          this.renderReportHeader('459'),
	          this.renderReportArea(),
	          this.state.punchmodal.open && _react2.default.createElement(_PunchReportModal2.default, {
	            show: this.state.punchmodal.open,
	            From: this.state.From,
	            To: this.state.To,
	            onClose: this.closePunchModal })
	        )
	      );
	    }
	  }]);
	
	  return PunchReport;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    employees: state.common.employees
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  renderFullDate: _time.renderFullDate,
	  getShopPunchTimeReport: _punchclock.getShopPunchTimeReport,
	  triggerPopup: _backdrop.triggerPopup,
	  setPageTitle: _common.setPageTitle
	})(PunchReport);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	var QualityCheckSettingsBox = function (_Component) {
	  _inherits(QualityCheckSettingsBox, _Component);
	
	  function QualityCheckSettingsBox(props) {
	    _classCallCheck(this, QualityCheckSettingsBox);
	
	    var _this = _possibleConstructorReturn(this, (QualityCheckSettingsBox.__proto__ || Object.getPrototypeOf(QualityCheckSettingsBox)).call(this, props));
	
	    _this.state = {
	      customName: props.group !== null ? props.group.CustomName : ''
	    };
	    _this.renderTask = _this.renderTask.bind(_this);
	    return _this;
	  }
	
	  _createClass(QualityCheckSettingsBox, [{
	    key: 'renderTask',
	    value: function renderTask(task, key) {
	      var _this2 = this;
	
	      var quality = this.props.quality;
	
	
	      var onChange = function onChange(e) {
	        console.log('QualityCheckSettingsBox\' onChange event triggered!', e);
	        e.persist();
	        var tasks = [].concat(_toConsumableArray(quality.QualityCheckTasks));
	        tasks = tasks.map(function (v) {
	          if (v.QualityCheckTaskId === task.QualityCheckTaskId) {
	            if (e.target.value === 'start') {
	              v.PerformAtStart = e.target.checked;
	            } else {
	              v.PerformAtEnd = e.target.checked;
	            }
	          }
	          return v;
	        });
	
	        if (_this2.props.onChange !== null) {
	          _this2.props.onChange(tasks);
	        }
	      };
	
	      var icon = '';
	      switch (task.StepNr) {
	        case 1:
	          icon = _icons.QualityCheckIcons.Quality_Check_New;
	          break;
	        case 2:
	          icon = _icons.QualityCheckIcons.Quality_Check_Pretreatment;
	          break;
	        case 3:
	          icon = _icons.QualityCheckIcons.Quality_Check_Filler;
	          break;
	        case 4:
	          icon = _icons.QualityCheckIcons.Quality_Check_Sanding;
	          break;
	        case 5:
	          icon = _icons.QualityCheckIcons.Quality_Check_Coating;
	          break;
	        case 6:
	          icon = _icons.QualityCheckIcons.Quality_Check_Preparing;
	          break;
	        case 7:
	          icon = _icons.QualityCheckIcons.Quality_Check_Handover;
	          break;
	        case 101:
	          icon = _icons.QualityCheckIcons.Quality_Check_Disassembly;
	          break;
	        case 102:
	          icon = _icons.QualityCheckIcons.Quality_Check_Repair;
	          break;
	        case 103:
	          icon = _icons.QualityCheckIcons.Quality_Check_Assembly;
	          break;
	        case 104:
	          icon = _icons.QualityCheckIcons.Quality_Check_Preparing_Body;
	          break;
	        case 105:
	          icon = _icons.QualityCheckIcons.Quality_Check_Coating;
	          break;
	      }
	      var ariaLabel = (0, _helpers.enumtranslate)('PaintShopOrderSteps', task.StepNr);
	      var disabledStart = task.ModifiedStart || !this.props.isLoaded;
	      var disabledEnd = task.ModifiedEnd || !this.props.isLoaded;
	
	      var headerItem = _react2.default.createElement(
	        'div',
	        {
	          className: 'hint--top',
	          'aria-label': (0, _helpers.translation)(ariaLabel),
	          key: task.StepNr
	        },
	        _react2.default.createElement(_icon2.default, { icon: icon, size: 't' })
	      );
	      var startItem = _react2.default.createElement(_check2.default, {
	        id: 'Task_start_' + task.QualityCheckTaskId,
	        name: 'Task_start_' + task.QualityCheckTaskId,
	        onChange: onChange,
	        checked: task.PerformAtStart,
	        disabled: disabledStart,
	        value: 'start',
	        key: task.StepNr,
	        simple: true
	      });
	      var endItem = _react2.default.createElement(_check2.default, {
	        id: 'Task_end_' + task.QualityCheckTaskId,
	        name: 'Task_end_' + task.QualityCheckTaskId,
	        onChange: onChange,
	        checked: task.PerformAtEnd,
	        disabled: disabledEnd,
	        value: 'end',
	        key: task.StepNr,
	        simple: true
	      });
	
	      return [headerItem, startItem, endItem];
	    }
	  }, {
	    key: 'renderGroup',
	    value: function renderGroup(tasks, taskType) {
	      var _this3 = this;
	
	      var elementLists = tasks.reduce(function (lists, task) {
	        var taskLists = _this3.renderTask(task);
	
	        lists.headerItems.push(taskLists[0]);
	        lists.startItems.push(taskLists[1]);
	        lists.endItems.push(taskLists[2]);
	
	        return lists;
	      }, {
	        headerItems: [],
	        startItems: [],
	        endItems: []
	      });
	
	      var helpTextStart = '';
	      var helpTextEnd = '';
	      switch (taskType) {
	        case 1:
	          helpTextStart = '1935';
	          helpTextEnd = '15167';
	          break;
	        case 2:
	          helpTextStart = '15161';
	          helpTextEnd = '15162';
	          break;
	        case 3:
	          helpTextStart = '15163';
	          helpTextEnd = '15164';
	          break;
	        case 4:
	          helpTextStart = '15165';
	          helpTextEnd = '15166';
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { justify: 'center', align: 'center' },
	          elementLists.headerItems
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('271'), helpText: (0, _helpers.translation)(helpTextStart), simple: true },
	          _react2.default.createElement(
	            _grid2.default,
	            { justify: 'center' },
	            elementLists.startItems
	          )
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('2062'), helpText: (0, _helpers.translation)(helpTextEnd), simple: true },
	          _react2.default.createElement(
	            _grid2.default,
	            { justify: 'center' },
	            elementLists.endItems
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          taskType = _props.taskType,
	          group = _props.group,
	          quality = _props.quality;
	
	      if (quality === null) return null;
	      var qualityCheckTasks = quality.QualityCheckTasks;
	
	      var tasks = [];
	      for (var i = 0; i < qualityCheckTasks.length; i++) {
	        var item = qualityCheckTasks[i];
	        if (item.QualityCheckTaskType === taskType && (group === null || item.QualityCheckTaskGroupId === group.QualityCheckTaskGroupId)) {
	          tasks.push(item);
	        }
	      }
	
	      if (tasks.length === 0) return null;
	
	      var title = '';
	      var helptext = '';
	      switch (taskType) {
	        case 1:
	          title = '370'; // layer thickness
	          helptext = '15168';
	          break;
	        case 2:
	          title = '342'; // qual. check
	          helptext = '15169';
	          break;
	        case 3:
	          title = '2065'; // photo
	          helptext = '1937';
	          break;
	        case 4:
	          title = '13396'; // warranty code
	          helptext = '1938';
	          break;
	      }
	
	      if (taskType === 5) {
	        var onNameChange = function onNameChange(e) {
	          _this4.setState({ customName: e.target.value });
	        };
	
	        var onNameBlur = function onNameBlur(e) {
	          group.CustomName = _this4.state.customName;
	          _this4.props.updateGroups(quality.QualityCheckTaskGroups);
	        };
	
	        var onDelete = function onDelete() {
	          group.IsDeleted = true;
	          _this4.props.updateGroups(quality.QualityCheckTaskGroups);
	        };
	
	        return (
	          // Custom task group
	          _react2.default.createElement(
	            _panel2.default,
	            { title: group.CustomName, helpText: group.CustomName },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: 'auto 50px' },
	              _react2.default.createElement(_text2.default, { value: this.state.customName, onChange: onNameChange, onBlur: onNameBlur }),
	              _react2.default.createElement(_removeButton2.default, { onClick: onDelete })
	            ),
	            _react2.default.createElement(_divider2.default, { noline: true }),
	            this.renderGroup(tasks, taskType)
	          )
	        );
	      } else {
	        // Regular tasks
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)(title), helpText: (0, _helpers.translation)(helptext) },
	          this.renderGroup(tasks, taskType)
	        );
	      }
	    }
	  }]);
	
	  return QualityCheckSettingsBox;
	}(_react.Component);
	
	QualityCheckSettingsBox.defaultProps = {
	  taskType: 1,
	  group: null,
	  // qualityCheckTasks: [],
	  quality: null,
	  onChange: null,
	  isLoaded: false
	};
	
	exports.default = QualityCheckSettingsBox;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _qualitychecksettings = __webpack_require__(281);
	
	__webpack_require__(518);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Utils
	
	
	var QualityCheckSettings = function (_Component) {
	  _inherits(QualityCheckSettings, _Component);
	
	  function QualityCheckSettings(props) {
	    _classCallCheck(this, QualityCheckSettings);
	
	    var _this = _possibleConstructorReturn(this, (QualityCheckSettings.__proto__ || Object.getPrototypeOf(QualityCheckSettings)).call(this, props));
	
	    _this.state = {
	      list: [{
	        QualityCheckModelId: 0,
	        Name: '',
	        QualityCheckOrderType: 0,
	        Active: true
	      }],
	      activeItem: {
	        QualityCheckModelId: 0,
	        ChainId: 0,
	        ShopId: 0,
	        Name: '',
	        QualityCheckTasks: [],
	        QualityCheckBrands: [],
	        QualityCheckCustomers: []
	      },
	      includeInactive: true,
	      search: ''
	    };
	    _this.renderChildren = _this.renderChildren.bind(_this);
	    _this.renderHeaderTitle = _this.renderHeaderTitle.bind(_this);
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.updateList = _this.updateList.bind(_this);
	    _this.createNew = _this.createNew.bind(_this);
	    // this.filterList = this.filterList.bind(this)
	    // this.searchList = this.searchList.bind(this)
	    _this.updateQualityCheckSettings = _this.updateQualityCheckSettings.bind(_this);
	    return _this;
	  }
	
	  _createClass(QualityCheckSettings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // if (!this.hasAccessToPage()) {
	      //   this.props.router.push('/qualitychecksettings')
	      // } else {
	      this.updateList();
	      // }
	    }
	  }, {
	    key: 'updateList',
	    value: function updateList() {
	      var _this2 = this;
	
	      // console.log('updateList')
	      var chainId = this.props.auth.user.ChainId;
	      var shopId = this.props.auth.user.ShopId;
	      return this.props.getQualityCheckSettingsList(chainId, shopId).then(function (res) {
	        // console.log('res', res.data)
	        _this2.setState({
	          list: res.data,
	          fetched: true
	        });
	        // console.log('Received: ', res.data)
	        return res;
	      }, function () {
	        console.log('Err fetching quality check settings lists data');
	        return null;
	      });
	    }
	  }, {
	    key: 'renderHeaderTitle',
	    value: function renderHeaderTitle() {
	      return (0, _helpers.translation)('1810');
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (!(0, _auth.hasAccess)([3, 7], this.props.auth.user.UserType)) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', ariaText: (0, _helpers.translation)('2053'), labelText: (0, _helpers.translation)(1797), onClick: this.createNew })
	      );
	    }
	  }, {
	    key: 'createNew',
	    value: function createNew() {
	      var _this3 = this;
	
	      var create = {
	        QualityCheckModelId: 0,
	        QualityCheckOrderType: 1,
	        BrandSelectionType: 0,
	        Name: 'New'
	      };
	      this.updateQualityCheckSettings(create).then(function (res) {
	        var newId = res.data.QualityCheckModelId;
	        _this3.updateList().then(function (res) {
	          _this3.props.router.push('/qualitychecksettings/' + newId);
	        });
	      });
	    }
	  }, {
	    key: 'updateQualityCheckSettings',
	    value: function updateQualityCheckSettings(data) {
	      return this.props.updateQualityCheckSettings(data);
	    }
	
	    // searchList (e) {
	    //   if (e.target.name === 'SearchText') {
	    //     this.setState({
	    //       search: e.target.value
	    //     })
	    //   }
	    //   if (e.target.name === 'Inactive') {
	    //     this.setState({
	    //       includeInactive: e.target.checked
	    //     })
	    //   }
	    // }
	
	    // filterList (item) {
	    //   // console.log('item', item)
	    //   if (item.Name === null) return true
	    //   if (item === null || item.Active === undefined) return false
	    //   if (item.Name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? item.Active : true)) {
	    //     return true
	    //   }
	    //   return false
	    // }
	
	  }, {
	    key: 'leftMenu',
	    value: function leftMenu() {
	      if (this.state.list.length === 0) return null;
	
	      var renderItem = function renderItem(val, key) {
	        var name = val.Name;
	        var link = '/qualitychecksettings/' + val.QualityCheckModelId;
	        var orderType = val.QualityCheckOrderType;
	        var isTitle = false;
	
	        if (name === null) {
	          name = (0, _helpers.translation)((0, _helpers.enumtranslate)('QualityCheckModelTypes', orderType, true));
	          isTitle = true;
	        }
	
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: name,
	          renderLabel: function renderLabel(label, className, activeClassName) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: link, className: className, activeClassName: activeClassName },
	              label
	            );
	          },
	          inactive: !val.Active,
	          isTitle: isTitle,
	          key: key
	        });
	      };
	
	      return this.state.list.map(renderItem);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var child = '';
	      if (this.props.children !== null) {
	        child = _react2.default.cloneElement(this.props.children, {
	          updateList: this.updateList,
	          updateQualityCheckSettings: this.updateQualityCheckSettings
	        });
	      }
	      return child;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'qualitycheck__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: this.headerButtonsRight }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { defaultShowInactive: true },
	          this.leftMenu()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'qualitycheck__screen--inner' },
	          this.renderChildren()
	        )
	      );
	    }
	  }]);
	
	  return QualityCheckSettings;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getQualityCheckSettingsList: _qualitychecksettings.getQualityCheckSettingsList,
	  getQualityCheckSettings: _qualitychecksettings.getQualityCheckSettings,
	  updateQualityCheckSettings: _qualitychecksettings.updateQualityCheckSettings
	})(QualityCheckSettings);

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1453);
	
	var _auth = __webpack_require__(68);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Elements
	
	
	// Utils
	
	
	var SelectShop = function (_PureComponent) {
	  _inherits(SelectShop, _PureComponent);
	
	  function SelectShop(props) {
	    _classCallCheck(this, SelectShop);
	
	    var _this = _possibleConstructorReturn(this, (SelectShop.__proto__ || Object.getPrototypeOf(SelectShop)).call(this, props));
	
	    _this.state = {};
	    _this.renderShop = _this.renderShop.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelectShop, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      // console.log('componentWillReceiveProps', nextProps.auth)
	      // if (!isEqual(this.props.auth.user, nextProps.auth.user)) {
	      setTimeout(function () {
	        if (nextProps.auth.user.UserType === 7) {
	          // shopowners
	          _this2.props.router.replace('/orders');
	        } else {
	          _this2.props.router.replace('/workscreen');
	        }
	      }, 150);
	      // }
	    }
	  }, {
	    key: 'renderShop',
	    value: function renderShop(shop, key) {
	      var _this3 = this;
	
	      var selectShop = function selectShop(e) {
	        e.preventDefault();
	        _this3.props.loginAs(0, shop.ShopId).then(function (res) {
	          // window.localStorage.setItem('workscreen_view', null)
	          // setTimeout(() => {
	          //   this.props.router.replace('/workscreen')
	          // }, 250)
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('1892'), (0, _helpers.translation)('216'));
	        });
	      };
	      return _react2.default.createElement(_button2.default, { key: key, onClick: selectShop, labelText: shop.ShopName, style: 'link' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'selectshop__screen' },
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('1896') },
	            this.props.companies.map(this.renderShop)
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelectShop;
	}(_react.PureComponent);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    companies: state.common.companies
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  loginAs: _auth.loginAs
	})(SelectShop);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _settings = __webpack_require__(51);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	__webpack_require__(1454);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	// import { hasSubscriptionPermission } from '../../../utils/auth'
	
	// Actions
	
	
	// Elements
	
	
	// import LabelWrapper from '../../../shared/elements/labelWrapper'
	
	var BookingPortal = function (_Component) {
	  _inherits(BookingPortal, _Component);
	
	  function BookingPortal(props) {
	    _classCallCheck(this, BookingPortal);
	
	    var _this = _possibleConstructorReturn(this, (BookingPortal.__proto__ || Object.getPrototypeOf(BookingPortal)).call(this, props));
	
	    _this.state = {
	      bookingPortal: {
	        Enabled: false,
	        EmbedSnippet: '',
	        BookingPortalCustomerName: '',
	        PrivacyPolicyUrl: '',
	        BookingPortalRedirectUrl: '',
	        BookingPortalLastStepSubmitText: '',
	        OfferCarRentalAlts: false,
	        BookingPortalWelcomeMessageText: ''
	      }
	    };
	
	    _this.getBookingPortalInformation = _this.getBookingPortalInformation.bind(_this);
	    _this.saveBookingPortalInformation = _this.saveBookingPortalInformation.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(BookingPortal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getBookingPortalInformation();
	    }
	  }, {
	    key: 'getBookingPortalInformation',
	    value: function getBookingPortalInformation() {
	      var _this2 = this;
	
	      this.props.getBookingPortalInformation().then(function (res) {
	        _this2.setState({
	          bookingPortal: res.data
	        });
	      }, function () {
	        // Err loading
	      });
	    }
	  }, {
	    key: 'saveBookingPortalInformation',
	    value: function saveBookingPortalInformation() {
	      var _this3 = this;
	
	      this.props.saveBookingPortalInformation(this.state.bookingPortal).then(function (res) {
	        _this3.setState({
	          bookingPortal: res.data
	        });
	        // window.toastr.success(translation('16725'), translation('13424'))
	      }, function () {
	        // Err saving
	        window.toastr.error((0, _helpers.translation)('16726'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this4 = this;
	
	      e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      this.setState({
	        bookingPortal: _extends({}, this.state.bookingPortal, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this4.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.saveBookingPortalInformation();
	    }
	  }, {
	    key: 'renderEmbedInfo',
	    value: function renderEmbedInfo() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 3 },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: 16744 },
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)(16735)
	          ),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)(16736)
	          ),
	          _react2.default.createElement(_divider2.default, { noLine: true }),
	          _react2.default.createElement(
	            'div',
	            { className: 'snippet' },
	            _react2.default.createElement(_textarea2.default, { labelText: 16737, disabled: true, value: this.state.bookingPortal.EmbedSnippet })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderLastStepSubmitText',
	    value: function renderLastStepSubmitText() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 5 },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: 16739 },
	          _react2.default.createElement(
	            'div',
	            { className: 'submit-text' },
	            _react2.default.createElement(_textarea2.default, { name: 'BookingPortalLastStepSubmitText', labelText: (0, _helpers.translation)(16738), value: this.state.bookingPortal.BookingPortalLastStepSubmitText || '', onChange: this.onChange, onBlur: this.onBlur })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderWelcomeMessageText',
	    value: function renderWelcomeMessageText() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 5 },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: 18153 },
	          _react2.default.createElement(
	            'div',
	            { className: 'submit-text' },
	            _react2.default.createElement(_textarea2.default, { name: 'BookingPortalWelcomeMessageText', labelText: (0, _helpers.translation)(18315), value: this.state.bookingPortal.BookingPortalWelcomeMessageText || '', onChange: this.onChange, onBlur: this.onBlur })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPrivacyPolicyInfo',
	    value: function renderPrivacyPolicyInfo() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 5 },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: 16653 },
	          _react2.default.createElement(_text2.default, { name: 'PrivacyPolicyUrl', labelText: (0, _helpers.translation)(16740), value: this.state.bookingPortal.PrivacyPolicyUrl || '', placeholder: 'http://', onChange: this.onChange, onBlur: this.onBlur })
	        )
	      );
	    }
	  }, {
	    key: 'renderBookingRequestRedirectUrl',
	    value: function renderBookingRequestRedirectUrl() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 5 },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: 18457 },
	          _react2.default.createElement(_text2.default, { name: 'BookingPortalRedirectUrl', labelText: (0, _helpers.translation)(18458), value: this.state.bookingPortal.BookingPortalRedirectUrl || '', placeholder: 'http://', onChange: this.onChange, onBlur: this.onBlur })
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomerInfo',
	    value: function renderCustomerInfo() {
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: 16741 },
	        _react2.default.createElement(_text2.default, { labelText: 16742, value: this.state.bookingPortal.BookingPortalCustomerName || '', disabled: true }),
	        _react2.default.createElement(_text2.default, { labelText: 16743, value: this.state.bookingPortal.BookingPortalContactName || '', disabled: true })
	      );
	    }
	  }, {
	    key: 'renderCarRentalAltsInfo',
	    value: function renderCarRentalAltsInfo() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 5 },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: 16751, helpText: 16757 },
	          _react2.default.createElement(_switch2.default, { name: 'OfferCarRentalAlts', checked: this.state.bookingPortal.OfferCarRentalAlts, onChange: this.onChange, labelText: 16752 })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'bookingportal__settings' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'clearfix colwrapper' },
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              _react2.default.createElement(
	                _panel2.default,
	                { title: 16681 },
	                _react2.default.createElement(_switch2.default, { name: 'Enabled', onChange: this.onChange, checked: this.state.bookingPortal.Enabled, labelText: 16682 })
	              ),
	              this.state.bookingPortal.Enabled && this.renderCustomerInfo()
	            ),
	            this.state.bookingPortal.Enabled && this.renderEmbedInfo()
	          ),
	          this.state.bookingPortal.Enabled && this.renderLastStepSubmitText(),
	          this.state.bookingPortal.Enabled && this.renderWelcomeMessageText(),
	          this.state.bookingPortal.Enabled && this.renderPrivacyPolicyInfo(),
	          this.state.bookingPortal.Enabled && this.renderBookingRequestRedirectUrl(),
	          this.state.bookingPortal.Enabled && this.renderCarRentalAltsInfo()
	        )
	      );
	    }
	  }]);
	
	  return BookingPortal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getBookingPortalInformation: _settings.getBookingPortalInformation,
	  saveBookingPortalInformation: _settings.saveBookingPortalInformation
	})(BookingPortal);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1455);
	
	var _settings = __webpack_require__(51);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Elements
	
	
	// Utils
	
	
	var Booking = function (_Component) {
	  _inherits(Booking, _Component);
	
	  function Booking(props) {
	    _classCallCheck(this, Booking);
	
	    var _this = _possibleConstructorReturn(this, (Booking.__proto__ || Object.getPrototypeOf(Booking)).call(this, props));
	
	    _this.state = {
	      Booking: {
	        ShopId: 0,
	        OpeningHours: [],
	        BookingStart: [],
	        BookingEnd: [],
	        DefaultHours: 0,
	        DeliveryPlusDriving: false,
	        DeliveryHourPrices: []
	      }
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Booking, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getBookingInformation();
	    }
	  }, {
	    key: 'getBookingInformation',
	    value: function getBookingInformation() {
	      var _this2 = this;
	
	      this.props.getBookingInformation(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          Booking: {
	            ShopId: res.data.ShopId,
	            OpeningHours: res.data.OpeningHours,
	            BookingStart: res.data.BookingStart,
	            BookingEnd: res.data.BookingEnd,
	            DefaultHours: res.data.DefaultHours,
	            DeliveryPlusDriving: res.data.DeliveryPlusDriving,
	            DeliveryHourPrices: res.data.DeliveryHourPrices
	
	          } });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      e.persist();
	      this.setState({
	        Booking: _extends({}, this.state.Booking, _defineProperty({}, e.target.name, e.target.value))
	      }, function () {});
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.props.saveBookingInformation(this.state.Booking).then(function () {
	        // Toastr (replace dict. key)
	        // window.toastr.success(translation('1823'), translation('13424'))
	      }, function () {
	        // Toastr (replace dict. key)
	        window.toastr.error((0, _helpers.translation)('1824'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var booking = this.state.Booking;
	
	      var renderDays = function renderDays(days, array) {
	        var renderDay = function renderDay(daySetting, key) {
	          var dayString = '';
	          switch (daySetting.Day) {
	            case 0:
	              dayString = (0, _helpers.translation)('175');
	              break;
	            case 1:
	              dayString = (0, _helpers.translation)('169');
	              break;
	            case 2:
	              dayString = (0, _helpers.translation)('170');
	              break;
	            case 3:
	              dayString = (0, _helpers.translation)('171');
	              break;
	            case 4:
	              dayString = (0, _helpers.translation)('172');
	              break;
	            case 5:
	              dayString = (0, _helpers.translation)('173');
	              break;
	            case 6:
	              dayString = (0, _helpers.translation)('174');
	              break;
	          }
	
	          var onChange = function onChange(e) {
	            e.persist();
	            var value = e.target.value;
	            if (e.target.type === 'checkbox') {
	              value = e.target.checked;
	            }
	            var newDays = [].concat(_toConsumableArray(_this3.state.Booking[array]));
	            newDays[key][e.target.name] = value;
	            _this3.setState({
	              Booking: _extends({}, _this3.state.Booking, _defineProperty({}, array, newDays))
	            }, function () {
	              if (e.target.type === 'checkbox' || e.target.type === 'radio') {
	                _this3.onBlur(e);
	              }
	            });
	          };
	
	          var renderFromToTime = function renderFromToTime(array, key) {
	            var onChange = function onChange(e) {
	              var field = e.target.name;
	              var value = e.target.value;
	              var newDays = [].concat(_toConsumableArray(_this3.state.Booking[array]));
	              newDays[key][field] = value;
	              _this3.setState({
	                Booking: _extends({}, _this3.state.Booking, _defineProperty({}, array, newDays))
	              }, function () {
	                _this3.onBlur(e);
	              });
	            };
	
	            var displayFrom = daySetting.From;
	            var displayTo = daySetting.To;
	
	            var timeOptions = [];
	            for (var h = 0; h < 24; h++) {
	              var hour = h < 10 ? '0' + h : h.toString();
	              timeOptions.push(hour + ':00');
	              timeOptions.push(hour + ':30');
	            }
	
	            return _react2.default.createElement(
	              'span',
	              { className: 'fromtotimepicker' },
	              _react2.default.createElement(
	                _inline2.default,
	                null,
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  { value: displayFrom, onChange: onChange, name: 'From', ref: displayFrom, size: 'm' },
	                  timeOptions.map(function (val, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: val, key: 'From_' + index },
	                      val
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  { value: displayTo, onChange: onChange, name: 'To', ref: displayTo, size: 'm' },
	                  timeOptions.map(function (val, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: val, key: 'To_' + index },
	                      val
	                    );
	                  })
	                )
	              )
	            );
	          };
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: [2, 1, 3], align: 'center', key: key },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              dayString
	            ),
	            _react2.default.createElement(_check2.default, { name: 'Available', value: '1', checked: daySetting.Available, onChange: onChange, simple: true }),
	            renderFromToTime(array, key)
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [2, 1, 3], align: 'center' },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('483')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1780')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1781')
	            )
	          ),
	          days.map(renderDay)
	        );
	      };
	
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { span: '2' },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('195'), helpText: (0, _helpers.translation)('1982') },
	            renderDays(booking.BookingStart, 'BookingStart')
	          )
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { span: '2' },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('196'), helpText: (0, _helpers.translation)('1983') },
	            renderDays(booking.BookingEnd, 'BookingEnd')
	          )
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { span: '2' },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('186'), helpText: (0, _helpers.translation)('1984') },
	            renderDays(booking.OpeningHours, 'OpeningHours')
	          )
	        )
	      );
	    }
	  }]);
	
	  return Booking;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getBookingInformation: _settings.getBookingInformation,
	  saveBookingInformation: _settings.saveBookingInformation
	})(Booking);

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var CarOwnerNotificationSettings = function (_Component) {
	  _inherits(CarOwnerNotificationSettings, _Component);
	
	  function CarOwnerNotificationSettings(props) {
	    _classCallCheck(this, CarOwnerNotificationSettings);
	
	    var _this = _possibleConstructorReturn(this, (CarOwnerNotificationSettings.__proto__ || Object.getPrototypeOf(CarOwnerNotificationSettings)).call(this, props));
	
	    _this.state = {
	      // This should probably be in the backend
	      notificationEventType: {
	        159: { translationKey: 18167, icon: _icons.ProductionStatus.Step_New },
	        160: { translationKey: 18168, icon: _icons.ProductionStatus.Step_New },
	        161: { translationKey: 18169, icon: _icons.ProductionStatus.Step_BodyShopDisassemply },
	        162: { translationKey: 18170, icon: _icons.ProductionStatus.Step_BodyShopDisassemply },
	        163: { translationKey: 18171, icon: _icons.ProductionStatus.Step_BodyShopRepair },
	        164: { translationKey: 18172, icon: _icons.ProductionStatus.Step_BodyShopRepair },
	        165: { translationKey: 18173, icon: _icons.ProductionStatus.Step_Painting },
	        166: { translationKey: 18174, icon: _icons.ProductionStatus.Step_BodyShopAssembly },
	        167: { translationKey: 18175, icon: _icons.ProductionStatus.Step_BodyShopAssembly },
	        168: { translationKey: 18176, icon: _icons.ProductionStatus.Step_Preparing },
	        169: { translationKey: 18177, icon: _icons.ProductionStatus.Step_Preparing },
	        170: { translationKey: 18178, icon: _icons.ProductionStatus.Step_Handover },
	        171: { translationKey: 18179, icon: _icons.ProductionStatus.Step_Handover },
	        172: { translationKey: 18187, icon: _icons.ProductionStatus.Step_Archived }, // Not implemented yet
	        173: { translationKey: 18180, icon: _icons.ProductionStatus.Step_Finished },
	        174: { translationKey: 18181, icon: _icons.ProductionStatus.Step_Finished },
	        176: { translationKey: 14827, icon: _icons.ProductionStatus.Step_Expected }
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CarOwnerNotificationSettings, [{
	    key: 'eventTypesList',
	    value: function eventTypesList(val, text) {
	      return _react2.default.createElement(
	        'option',
	        { key: val, value: val },
	        text
	      );
	    }
	  }, {
	    key: 'deriveVariables',
	    value: function deriveVariables(setting) {
	      var type = Number(setting.Type);
	      var offsetDaysArray = Array.from(Array(61).keys());
	      var canOffsetBefore = type === 171 || type === 176;
	      var canOffsetAfter = type === 176 || type === 172;
	      var offsettableType = canOffsetBefore || canOffsetAfter;
	
	      var beforeAfter = setting.Offset < 0 ? 'before' : 'after';
	      var days = Math.abs(setting.Offset / 24);
	      return { type: type, offsettableType: offsettableType, days: days, offsetDaysArray: offsetDaysArray, beforeAfter: beforeAfter, canOffsetBefore: canOffsetBefore, canOffsetAfter: canOffsetAfter };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var selectableTypes = Object.entries(this.state.notificationEventType).filter(function (x) {
	        return x[0] !== '172';
	      }); // TODO: implement this option fully in backend before reactivation
	      console.log('types', selectableTypes);
	
	      function renderOption(number) {
	        var translationKey = 503;
	
	        if (number === 1) translationKey = 483;
	        return _react2.default.createElement(
	          'option',
	          { key: number, value: number },
	          number + ' ' + (0, _helpers.translation)(translationKey)
	        );
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.data.map(function (setting, index) {
	          var _deriveVariables = _this2.deriveVariables(setting),
	              type = _deriveVariables.type,
	              offsettableType = _deriveVariables.offsettableType,
	              days = _deriveVariables.days,
	              offsetDaysArray = _deriveVariables.offsetDaysArray,
	              beforeAfter = _deriveVariables.beforeAfter,
	              canOffsetBefore = _deriveVariables.canOffsetBefore,
	              canOffsetAfter = _deriveVariables.canOffsetAfter;
	
	          var onChange = function onChange(e) {
	            return _this2.props.onChange(e, setting.Id);
	          };
	          var onBlur = function onBlur(e) {
	            return _this2.props.onBlur(e, setting.Id);
	          };
	
	          return _react2.default.createElement(
	            'div',
	            { key: index, className: 'submit-text' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex' },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                _react2.default.createElement(_icon2.default, { size: 's', icon: _this2.state.notificationEventType[setting.Type].icon }),
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  { name: 'NotificationType', onChange: onChange, disabled: false, size: 'm', value: type },
	                  selectableTypes.map(function (val) {
	                    return _this2.eventTypesList(Number(val[0]), (0, _helpers.translation)(val[1].translationKey));
	                  })
	                ),
	                offsettableType && _react2.default.createElement(
	                  _dropDown2.default,
	                  { name: 'Days', onChange: onChange, disabled: false, size: 'm', value: days },
	                  offsetDaysArray.map(renderOption)
	                ),
	                offsettableType && _react2.default.createElement(
	                  _dropDown2.default,
	                  { name: 'BeforeAfter', onChange: onChange, disabled: false, size: 'm', value: beforeAfter },
	                  canOffsetBefore && _react2.default.createElement(
	                    'option',
	                    { key: 1, value: 'before' },
	                    (0, _helpers.translation)(19000)
	                  ),
	                  canOffsetAfter && _react2.default.createElement(
	                    'option',
	                    { key: 2, value: 'after' },
	                    (0, _helpers.translation)(19001)
	                  )
	                ),
	                _react2.default.createElement(_removeButton2.default, { spacing: 0, onClick: function onClick(e) {
	                    return _this2.props.deleteNotification(e, setting);
	                  }, size: 'm' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                _react2.default.createElement(_switch2.default, { name: 'SMSAllowed', onChange: onChange, checked: setting.SMSAllowed, labelText: 15, labelAlignment: 'l' }),
	                _react2.default.createElement(_switch2.default, { name: 'EmailAllowed', onChange: onChange, checked: setting.EmailAllowed, labelText: 1052, labelAlignment: 'l' })
	              )
	            ),
	            _react2.default.createElement(_textarea2.default, { placeholder: (0, _helpers.translation)(18153), name: 'text',
	              value: setting.Text,
	              onChange: onChange, onBlur: onBlur }),
	            setting.SMSAllowed && _react2.default.createElement(
	              'div',
	              { className: 'txt-count' },
	              _this2.props.countText(setting.Text)
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return CarOwnerNotificationSettings;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null)(CarOwnerNotificationSettings);

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _settings = __webpack_require__(51);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	__webpack_require__(1456);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _index = __webpack_require__(958);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	// import { hasSubscriptionPermission } from '../../../utils/auth'
	
	// Actions
	
	
	// Elements
	
	// import Text from '../../../shared/elements/text'
	
	// import { ProductionStatus } from './../../../elements/icons'
	
	
	var CarOwnerNotification = function (_Component) {
	  _inherits(CarOwnerNotification, _Component);
	
	  function CarOwnerNotification(props) {
	    _classCallCheck(this, CarOwnerNotification);
	
	    var _this = _possibleConstructorReturn(this, (CarOwnerNotification.__proto__ || Object.getPrototypeOf(CarOwnerNotification)).call(this, props));
	
	    _this.state = {
	      data: [],
	      signature: {}
	    };
	    _this.getStatusNotificationInformation = _this.getStatusNotificationInformation.bind(_this);
	    _this.saveStatusNotificationInformation = _this.saveStatusNotificationInformation.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.setStateFromRequest = _this.setStateFromRequest.bind(_this);
	    _this.success = _this.success.bind(_this);
	    _this.error = _this.error.bind(_this);
	    _this.countText = _this.countText.bind(_this);
	    _this.deleteNotification = _this.deleteNotification.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarOwnerNotification, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getStatusNotificationInformation();
	    }
	  }, {
	    key: 'getStatusNotificationInformation',
	    value: function getStatusNotificationInformation() {
	      var _this2 = this;
	
	      this.props.getStatusNotificationInformation().then(function (res) {
	        _this2.setStateFromRequest(res);
	      });
	    }
	  }, {
	    key: 'saveStatusNotificationInformation',
	    value: function saveStatusNotificationInformation(id) {
	      var setting = this.state.data.find(function (x) {
	        return x.Id === id;
	      });
	
	      this.props.saveStatusNotificationInformation(setting).then(this.success, this.error);
	    }
	  }, {
	    key: 'setStateFromRequest',
	    value: function setStateFromRequest(res) {
	      // could be a splice?
	      var signature = res.data.find(function (x) {
	        return x.Type === 175;
	      });
	      var cast = res.data.map(function (x) {
	        return _extends({}, x, { Type: Number(x.Type) });
	      });
	
	      var newState = {
	        data: cast,
	        signature: signature
	      };
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'constructSMS',
	    value: function constructSMS(length, count) {
	      var SMS = (0, _helpers.translation)('15');
	      return length + ' (' + count + ' ' + SMS + ')';
	    }
	  }, {
	    key: 'countText',
	    value: function countText(value, isSignature) {
	      var signatureLength = this.state.signature && this.state.signature.Text ? this.state.signature.Text.length : 0;
	      var SMSCountSignature = Math.ceil(signatureLength / 160);
	      if (isSignature) return this.constructSMS(signatureLength, SMSCountSignature);
	
	      if (value === null || value === undefined) {
	        return this.constructSMS(0, 0);
	      }
	
	      var textLength = value.length;
	      var textWithSignatureLength = textLength + signatureLength;
	      var SMSCount = Math.ceil(textLength / 160);
	      var SMSCountWithSignature = Math.ceil(textWithSignatureLength / 160);
	
	      var Message = (0, _helpers.translation)('930');
	      var exclusive = this.constructSMS(textLength, SMSCount);
	
	      var InclusiveSignature = (0, _helpers.translation)('18283');
	      var inclusive = this.constructSMS(textWithSignatureLength, SMSCountWithSignature);
	      return Message + ': ' + exclusive + ' / ' + InclusiveSignature + ': ' + inclusive;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e, selectedId) {
	      var _this3 = this;
	
	      e.persist();
	
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value,
	          checked = _e$target.checked,
	          type = _e$target.type;
	
	
	      this.setState(function (prevState) {
	        var signatureModified = void 0;
	
	        var newDataState = prevState.data.map(function (setting) {
	          if (setting.Id === Number(name) || setting.Id === selectedId) {
	            switch (type) {
	              case 'checkbox':
	                if (name === 'SMSAllowed') setting.SMSAllowed = checked;
	                if (name === 'EmailAllowed') setting.EmailAllowed = checked;
	                break;
	
	              case 'select-one':
	                if (name === 'NotificationType') setting.Type = value;
	                if (name === 'Days') {
	                  if (setting.Offset < 0) {
	                    setting.Offset = -Math.abs(value * 24);
	                  } else {
	                    setting.Offset = value * 24;
	                  }
	                }
	                if (name === 'BeforeAfter') {
	                  if (value === 'before') {
	                    if (setting.Offset === 0) setting.Offset = -24;
	                    setting.Offset = -Math.abs(setting.Offset);
	                  } else {
	                    setting.Offset = Math.abs(setting.Offset);
	                  }
	                }
	                break;
	
	              default:
	                setting.Text = value;
	                break;
	            }
	
	            if (_this3.state.signature && setting.Id === _this3.state.signature.Id) signatureModified = setting;
	          }
	          return setting;
	        });
	
	        return {
	          data: newDataState,
	          signature: signatureModified !== undefined ? signatureModified : prevState.signature // Incredibly heavy performance burden
	        };
	      }, function () {
	        if (e.target.type === 'checkbox' || e.target.type === 'select-one') {
	          _this3.onBlur(e, selectedId);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e, id) {
	      this.saveStatusNotificationInformation(id);
	    }
	  }, {
	    key: 'addNotification',
	    value: function addNotification() {
	      this.props.addStatusNotification().then(this.success, this.error);
	    }
	  }, {
	    key: 'deleteNotification',
	    value: function deleteNotification(e, setting) {
	      this.props.deleteStatusNotification(setting.Id).then(this.success, this.error);
	    }
	  }, {
	    key: 'error',
	    value: function error() {
	      // Err saving
	      window.toastr.error((0, _helpers.translation)('18190'), (0, _helpers.translation)('216'));
	    }
	  }, {
	    key: 'success',
	    value: function success(res) {
	      this.setStateFromRequest(res);
	      // window.toastr.success(translation('18189'), translation('13424'))
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var headerGridColsSignature = ['auto'];
	      var isSignature = true;
	
	      /* Omit Signature */
	      var filteredData = this.state.data.filter(function (x) {
	        return x.Type !== 175;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'carownerportal__settings' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            { span: 5 },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: 18185 },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item-field-group' },
	                  _react2.default.createElement(
	                    _col2.default,
	                    { span: 12 },
	                    _react2.default.createElement(
	                      _label2.default,
	                      null,
	                      (0, _helpers.translation)(18184)
	                    )
	                  )
	                ),
	                this.state && _react2.default.createElement(_index2.default, {
	                  data: filteredData,
	                  countText: this.countText,
	                  deleteNotification: this.deleteNotification,
	                  onChange: this.onChange,
	                  onBlur: this.onBlur })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            { span: 1 },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: 18308 },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)(18309)
	              ),
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              _react2.default.createElement(_button2.default, { size: 'm', style: 'link', labelText: (0, _helpers.translation)('18310'), onClick: function onClick() {
	                  return (0, _helpers.copyTextToClipboard)((0, _helpers.translation)('18311'));
	                } }),
	              _react2.default.createElement(_button2.default, { size: 'm', style: 'link', labelText: (0, _helpers.translation)('14827'), onClick: function onClick() {
	                  return (0, _helpers.copyTextToClipboard)((0, _helpers.translation)('19005'));
	                } }),
	              _react2.default.createElement(_button2.default, { size: 'm', style: 'link', labelText: (0, _helpers.translation)('17880'), onClick: function onClick() {
	                  return (0, _helpers.copyTextToClipboard)((0, _helpers.translation)('19012'));
	                } })
	            ),
	            _react2.default.createElement(
	              _panel2.default,
	              { title: 19004 },
	              _react2.default.createElement(_button2.default, { size: 'm', style: 'link', labelText: (0, _helpers.translation)(1208), onClick: function onClick() {
	                  return _this4.addNotification();
	                } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            { span: 5 },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: 18284 },
	              this.state && this.state.signature && _react2.default.createElement(
	                'div',
	                { className: 'wrap-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'submit-text' },
	                  _react2.default.createElement(
	                    _grid2.default,
	                    { cols: headerGridColsSignature, spacing: 1 },
	                    _react2.default.createElement(
	                      _label2.default,
	                      null,
	                      (0, _helpers.translation)(18285)
	                    )
	                  ),
	                  _react2.default.createElement(_textarea2.default, { placeholder: (0, _helpers.translation)(18181), name: 'SignatureText',
	                    value: this.state.signature.Text === null ? (0, _helpers.translation)(18282) : this.state.signature.Text,
	                    onChange: function onChange(e) {
	                      return _this4.onChange(e, _this4.state.signature.Id);
	                    }, onBlur: function onBlur(e) {
	                      return _this4.onBlur(e, _this4.state.signature.Id);
	                    } }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'txt-count' },
	                    this.countText(this.state.signature.Text, isSignature)
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CarOwnerNotification;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  saveStatusNotificationInformation: _settings.saveStatusNotificationInformation,
	  getStatusNotificationInformation: _settings.getStatusNotificationInformation,
	  deleteStatusNotification: _settings.deleteStatusNotification,
	  addStatusNotification: _settings.addStatusNotification
	})(CarOwnerNotification);

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _settings = __webpack_require__(51);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	__webpack_require__(1457);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Actions
	
	
	// Elements
	
	// import Divider from '../../../shared/elements/divider'
	
	var CarOwnerPortal = function (_Component) {
	  _inherits(CarOwnerPortal, _Component);
	
	  function CarOwnerPortal(props) {
	    _classCallCheck(this, CarOwnerPortal);
	
	    var _this = _possibleConstructorReturn(this, (CarOwnerPortal.__proto__ || Object.getPrototypeOf(CarOwnerPortal)).call(this, props));
	
	    _this.state = {
	      carOwnerPortalPortal: {
	        CarOwnerPortalEnabled: false,
	        CarOwnerPortalPrivacyPolicyUrl: '',
	        CarOwnerPortalWelcomeMessageText: ''
	      }
	    };
	    _this.getCarOwnerPortalInformation = _this.getCarOwnerPortalInformation.bind(_this);
	    _this.saveCarOwnerPortalInformation = _this.saveCarOwnerPortalInformation.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarOwnerPortal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCarOwnerPortalInformation();
	    }
	  }, {
	    key: 'getCarOwnerPortalInformation',
	    value: function getCarOwnerPortalInformation() {
	      var _this2 = this;
	
	      this.props.getCarOwnerPortalInformation().then(function (res) {
	        console.log(res.data);
	        _this2.setState({
	          carOwnerPortalPortal: res.data
	        });
	      }, function () {
	        // Err loading
	      });
	    }
	  }, {
	    key: 'saveCarOwnerPortalInformation',
	    value: function saveCarOwnerPortalInformation() {
	      var _this3 = this;
	
	      this.props.saveCarOwnerPortalInformation(this.state.carOwnerPortalPortal).then(function (res) {
	        _this3.setState({
	          carOwnerPortalPortal: res.data
	        });
	        // window.toastr.success(translation('18156'), translation('13424'))
	      }, function () {
	        // Err saving
	        window.toastr.error((0, _helpers.translation)('18157'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this4 = this;
	
	      e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	        if (value) {
	          // recheck permissions Allow show or hide menu client notification
	          $(this.props.auth.permissions.CarOwnerPortalEnabled ? '.show-menu-notification' : '.hide-menu-notification').css('display', 'block');
	        } else {
	          $(this.props.auth.permissions.CarOwnerPortalEnabled ? '.show-menu-notification' : '.hide-menu-notification').css('display', 'none');
	        }
	      }
	      this.setState({
	        carOwnerPortalPortal: _extends({}, this.state.carOwnerPortalPortal, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'checkbox') {
	          _this4.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.saveCarOwnerPortalInformation();
	    }
	  }, {
	    key: 'renderWelcomeMessageText',
	    value: function renderWelcomeMessageText() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 5 },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: 18153 },
	          _react2.default.createElement(
	            'div',
	            { className: 'submit-text' },
	            _react2.default.createElement(_textarea2.default, { placeholder: (0, _helpers.translation)(18153), name: 'CarOwnerPortalWelcomeMessageText', labelText: (0, _helpers.translation)(18154), value: this.state.carOwnerPortalPortal.CarOwnerPortalWelcomeMessageText || '', onChange: this.onChange, onBlur: this.onBlur })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPrivacyPolicyInfo',
	    value: function renderPrivacyPolicyInfo() {
	      return _react2.default.createElement(
	        _col2.default,
	        { span: 5 },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: 16653 },
	          _react2.default.createElement(_text2.default, { name: 'CarOwnerPortalPrivacyPolicyUrl', labelText: (0, _helpers.translation)(16740), value: this.state.carOwnerPortalPortal.CarOwnerPortalPrivacyPolicyUrl || '', placeholder: 'http://', onChange: this.onChange, onBlur: this.onBlur })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'bookingportal__settings' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'clearfix colwrapper' },
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              _react2.default.createElement(
	                _panel2.default,
	                { title: 18152 },
	                _react2.default.createElement(_switch2.default, { name: 'CarOwnerPortalEnabled', onChange: this.onChange, checked: this.state.carOwnerPortalPortal.CarOwnerPortalEnabled, labelText: 18155 })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          this.state.carOwnerPortalPortal.CarOwnerPortalEnabled && this.renderWelcomeMessageText(),
	          this.state.carOwnerPortalPortal.CarOwnerPortalEnabled && this.renderPrivacyPolicyInfo()
	        )
	      );
	    }
	  }]);
	
	  return CarOwnerPortal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  saveCarOwnerPortalInformation: _settings.saveCarOwnerPortalInformation,
	  getCarOwnerPortalInformation: _settings.getCarOwnerPortalInformation
	})(CarOwnerPortal);

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1458);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _helpers = __webpack_require__(2);
	
	var _constants = __webpack_require__(5);
	
	var _settings = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	// import HelpText from '../../../shared/components/HelpText'
	
	// contants
	
	
	// Actions
	
	
	var CarRental = function (_Component) {
	  _inherits(CarRental, _Component);
	
	  function CarRental(props) {
	    _classCallCheck(this, CarRental);
	
	    var _this = _possibleConstructorReturn(this, (CarRental.__proto__ || Object.getPrototypeOf(CarRental)).call(this, props));
	
	    _this.state = {
	      Identification: 0,
	      BufferBefore: 0,
	      BufferAfter: 0,
	      ShowClosedDays: false,
	      Show24Hours: false,
	      StandardConditions: '',
	      StandardPrice: 0,
	      CarRentalAlts: [],
	      NewItem: {
	        Id: 0,
	        Name: '',
	        Active: false,
	        IsDeleted: false
	      },
	      CarRentalSystem: _constants.CarRentalSystemTypes.NONE,
	      RentLogUserName: '',
	      RentLogPassword: '',
	      CarRentalCredentialsError: false,
	      SelectedBranchOffice: '',
	      BranchOfficeListFromRentLog: [],
	      RentLogBranchOfficeInfos: [],
	      RentLogDepartmentInfos: [],
	      DepartmentListFromRentLog: [],
	      textKey: 0,
	      showPopup: false,
	      selectedRentLog: _constants.CarRentalSystemTypes.NONE
	    };
	
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.renderIdentification = _this.renderIdentification.bind(_this);
	    _this.renderBuffer = _this.renderBuffer.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.renderContract = _this.renderContract.bind(_this);
	    _this.renderAlternatives = _this.renderAlternatives.bind(_this);
	    _this.updateStateFromResponse = _this.updateStateFromResponse.bind(_this);
	    _this.renderIntegration = _this.renderRentLogIntegration.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarRental, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getCarRentalInformation(this.props.auth.user.ShopId).then(this.updateStateFromResponse).catch(function (err) {
	        console.error('CarRental settings', err);
	      });
	    }
	  }, {
	    key: 'updateStateFromResponse',
	    value: function updateStateFromResponse(res) {
	      var _res$data = res.data,
	          Identification = _res$data.Identification,
	          BufferBefore = _res$data.BufferBefore,
	          BufferAfter = _res$data.BufferAfter,
	          ShowClosedDays = _res$data.ShowClosedDays,
	          Show24Hours = _res$data.Show24Hours,
	          StandardConditions = _res$data.StandardConditions,
	          StandardPrice = _res$data.StandardPrice,
	          CarRentalAlts = _res$data.CarRentalAlts,
	          CarRentalSystem = _res$data.CarRentalSystem,
	          RentLogUserName = _res$data.RentLogUserName,
	          RentLogPassword = _res$data.RentLogPassword,
	          CarRentalCredentialsError = _res$data.CarRentalCredentialsError,
	          BranchOfficeListFromRentLog = _res$data.BranchOfficeListFromRentLog,
	          RentLogBranchOfficeInfos = _res$data.RentLogBranchOfficeInfos,
	          RentLogDepartmentInfos = _res$data.RentLogDepartmentInfos,
	          DepartmentListFromRentLog = _res$data.DepartmentListFromRentLog;
	
	      this.setState({
	        Identification: Identification,
	        BufferBefore: BufferBefore,
	        BufferAfter: BufferAfter,
	        ShowClosedDays: ShowClosedDays,
	        Show24Hours: Show24Hours,
	        StandardConditions: StandardConditions,
	        StandardPrice: StandardPrice,
	        CarRentalAlts: CarRentalAlts,
	        NewItem: {
	          Id: 0,
	          Name: '',
	          Active: false,
	          IsDeleted: false
	        },
	        CarRentalSystem: CarRentalSystem,
	        RentLogUserName: RentLogUserName,
	        RentLogPassword: RentLogPassword,
	        CarRentalCredentialsError: CarRentalCredentialsError,
	        RentLogBranchOfficeInfos: RentLogBranchOfficeInfos,
	        BranchOfficeListFromRentLog: BranchOfficeListFromRentLog,
	        RentLogDepartmentInfos: RentLogDepartmentInfos,
	        DepartmentListFromRentLog: DepartmentListFromRentLog,
	        showPopup: false
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      var _this2 = this;
	
	      this.props.saveCarRentalInformation(this.state).then(function (res) {
	        _this2.updateStateFromResponse(res);
	        // window.toastr.success(translation('15125'), translation('13424'))
	      }).catch(function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderBrancheOfficeListFromRentLog',
	    value: function renderBrancheOfficeListFromRentLog() {
	      var _this3 = this;
	
	      var _state = this.state,
	          BranchOfficeListFromRentLog = _state.BranchOfficeListFromRentLog,
	          RentLogBranchOfficeInfos = _state.RentLogBranchOfficeInfos,
	          SelectedBranchOffice = _state.SelectedBranchOffice,
	          DepartmentListFromRentLog = _state.DepartmentListFromRentLog;
	
	      var cols = ['auto', '48px'];
	      var depGridCols = '1fr 1fr 1fr';
	
	      var onClick = function onClick() {
	        var newBranchOffice = {
	          RentLogBranchOffice: 0,
	          CompanyId: _this3.props.auth.user.ShopId,
	          BranchOfficeOId: _this3.state.SelectedBranchOffice,
	          IsDeleted: false
	        };
	
	        if (newBranchOffice.BranchOfficeOId) {
	          _this3.setState({
	            RentLogBranchOfficeInfos: [newBranchOffice]
	          }, function () {
	            _this3.onBlur();
	          });
	        }
	        SelectedBranchOffice = '';
	      };
	
	      var onChange = function onChange(e) {
	        _this3.setState(_defineProperty({}, e.target.name, e.target.value));
	      };
	
	      var renderSelectedBranOffice = function renderSelectedBranOffice(branchOffice, key) {
	        var onDelete = function onDelete(_) {
	          branchOffice.IsDeleted = true;
	          _this3.setState({
	            RentLogBranchOfficeInfos: [].concat(_toConsumableArray(RentLogBranchOfficeInfos))
	          }, function () {
	            return _this3.onBlur();
	          });
	        };
	
	        var name = '';
	        BranchOfficeListFromRentLog.map(function (val) {
	          if (val.Oid === branchOffice.BranchOfficeOId) {
	            name = val.Name;
	          }
	        });
	
	        // Department section
	        // if the branch has been selected, it will be part of the selected branch office
	        var renderDepartments = function renderDepartments(department, Dkey) {
	          var thisDepartment = branchOffice.RentLogDepartmentInfos && branchOffice.RentLogDepartmentInfos.find(function (d) {
	            return d.DepartmentOId === department.Oid;
	          });
	          var departmentInfo = {
	            CompanyId: _this3.props.auth.user.ShopId,
	            Active: thisDepartment !== undefined ? thisDepartment.Active : false,
	            RentLogBranchOfficeId: branchOffice.RentLogBranchOffice,
	            DepartmentOId: department.Oid,
	            RentLogDepartmentId: thisDepartment !== undefined ? thisDepartment.RentLogDepartmentId : 0,
	            Name: thisDepartment !== undefined && thisDepartment.Name ? thisDepartment.Name : department.Name
	          };
	
	          var onDeparmentChange = function onDeparmentChange(e) {
	            departmentInfo = _extends({}, departmentInfo, {
	              Active: e.target.checked
	            });
	            _this3.setState({
	              RentLogDepartmentInfos: [departmentInfo]
	            }, function () {
	              _this3.onBlur();
	            });
	          };
	
	          var onDepartmentNameChange = function onDepartmentNameChange(e) {
	            departmentInfo = _extends({}, departmentInfo, {
	              Name: e.target.value
	            });
	
	            _this3.setState({
	              RentLogDepartmentInfos: [departmentInfo]
	            });
	          };
	
	          // get the section name and active state if the user has selected department
	          var departmentName = department.Name;
	          var selectedDeparment = false;
	          branchOffice.RentLogDepartmentInfos && branchOffice.RentLogDepartmentInfos.map(function (val) {
	            if (val.DepartmentOId === department.Oid) {
	              departmentName = department.Name;
	              selectedDeparment = val.Active;
	            }
	          });
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { key: Dkey, cols: _this3.gridCols, spacing: 1 },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              departmentName
	            ),
	            _react2.default.createElement(_switch2.default, { name: 'department_' + Dkey, id: Dkey, onChange: onDeparmentChange, checked: selectedDeparment, spacing: 0 }),
	            _react2.default.createElement(_text2.default, { name: 'Text_' + Dkey, defaultValue: departmentInfo.Name, onChange: onDepartmentNameChange, onBlur: _this3.onBlur, disabled: !selectedDeparment, size: 'm' })
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { key: key, className: 'branchOffice-department' },
	          _react2.default.createElement(
	            _grid2.default,
	            { key: key, cols: cols, spacing: 1 },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              name
	            ),
	            _react2.default.createElement(_removeButton2.default, { onClick: onDelete, size: 'm' })
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: depGridCols, align: 'center' },
	            _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('626') }),
	            _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('1780') }),
	            _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('18396') })
	          ),
	          DepartmentListFromRentLog.map(renderDepartments)
	        );
	      };
	
	      var branchOfficeListFromRentLog = [];
	      if (RentLogBranchOfficeInfos.length < 1) branchOfficeListFromRentLog.push({ Oid: 0, Name: (0, _helpers.translation)('890') });
	
	      BranchOfficeListFromRentLog.map(function (val) {
	        branchOfficeListFromRentLog.push({ Oid: val.Oid, Name: val.Name });
	      });
	      var branchOfficeOptions = branchOfficeListFromRentLog.map(function (b, index) {
	        return _react2.default.createElement(
	          'option',
	          { key: index, value: b.Oid },
	          b.Name
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        RentLogBranchOfficeInfos.map(renderSelectedBranOffice),
	        (0, _helpers.translation)('18131'),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, spacing: 1 },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'SelectedBranchOffice', value: SelectedBranchOffice, onChange: onChange },
	            branchOfficeOptions
	          ),
	          _react2.default.createElement(_addButton2.default, { onClick: onClick })
	        )
	      );
	    }
	  }, {
	    key: 'renderPopupMessage',
	    value: function renderPopupMessage() {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          showPopup = _state2.showPopup,
	          textKey = _state2.textKey,
	          selectedRentLog = _state2.selectedRentLog;
	
	
	      var onConfirm = function onConfirm() {
	        _this4.setState({
	          showPopup: false,
	          CarRentalSystem: selectedRentLog
	        }, function () {
	          return _this4.onBlur();
	        });
	      };
	      var onPortalClose = function onPortalClose() {
	        _this4.setState({
	          showPopup: false
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        showPopup && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'confirm_popup', onPortalClose: onPortalClose.bind(this) },
	          _react2.default.createElement(_Confirm2.default, {
	            renderText: function renderText() {
	              return (0, _helpers.translation)(textKey);
	            },
	            confirm: onConfirm.bind(this),
	            notConfirm: onPortalClose.bind(this) })
	        )
	      );
	    }
	  }, {
	    key: 'renderRentLogIntegration',
	    value: function renderRentLogIntegration() {
	      var _this5 = this;
	
	      var _state3 = this.state,
	          CarRentalSystem = _state3.CarRentalSystem,
	          RentLogUserName = _state3.RentLogUserName,
	          RentLogPassword = _state3.RentLogPassword;
	
	      var onChange = function onChange(e) {
	        var _this5$setState;
	
	        var _e$target = e.target,
	            value = _e$target.value,
	            name = _e$target.name,
	            type = _e$target.type,
	            checked = _e$target.checked;
	
	        var val = value;
	        var popup = false;
	        var text = void 0;
	        if (type === 'checkbox') {
	          if (checked) {
	            val = _constants.CarRentalSystemTypes.RENTLOG;
	            popup = true;
	            text = 18133;
	          } else {
	            val = _constants.CarRentalSystemTypes.NONE;
	            text = 18134;
	            popup = true;
	          }
	        }
	
	        _this5.setState((_this5$setState = {}, _defineProperty(_this5$setState, name, val), _defineProperty(_this5$setState, 'showPopup', popup), _defineProperty(_this5$setState, 'textKey', text), _this5$setState));
	      };
	
	      var onBlur = function onBlur(e) {
	        var _e$target2 = e.target,
	            value = _e$target2.value,
	            name = _e$target2.name;
	
	        _this5.setState(_defineProperty({}, name, value), function () {
	          return _this5.onBlur();
	        });
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('18135') },
	        _react2.default.createElement(_switch2.default, { name: 'selectedRentLog', onChange: onChange, checked: CarRentalSystem === _constants.CarRentalSystemTypes.RENTLOG, labelText: (0, _helpers.translation)('18132') }),
	        CarRentalSystem === _constants.CarRentalSystemTypes.RENTLOG && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_text2.default, { name: 'RentLogUserName', value: RentLogUserName, onChange: onChange, onBlur: onBlur, labelText: (0, _helpers.translation)('1'), showValidationIcon: !this.state.CarRentalCredentialsError }),
	          _react2.default.createElement(_text2.default, { name: 'RentLogPassword', isPassword: true, value: RentLogPassword, onChange: onChange, onBlur: onBlur, labelText: (0, _helpers.translation)('2'), showValidationIcon: !this.state.CarRentalCredentialsError }),
	          this.renderBrancheOfficeListFromRentLog()
	        )
	      );
	    }
	  }, {
	    key: 'renderIdentification',
	    value: function renderIdentification() {
	      var _this6 = this;
	
	      var onChange = function onChange(e) {
	        _this6.setState({
	          Identification: parseInt(e.target.value)
	        }, function () {
	          return _this6.onBlur();
	        });
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('15111'), helpText: (0, _helpers.translation)('15121') },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('15112') },
	          _react2.default.createElement(_radio2.default, { id: 'RegNr', name: 'RegNr', value: 0, checked: this.state.Identification === 0, onChange: onChange, labelText: (0, _helpers.translation)('2005') }),
	          _react2.default.createElement(_radio2.default, { id: 'Brand', name: 'Brand', value: 1, checked: this.state.Identification === 1, onChange: onChange, labelText: (0, _helpers.translation)('145') }),
	          _react2.default.createElement(_radio2.default, { id: 'Model', name: 'Model', value: 2, checked: this.state.Identification === 2, onChange: onChange, labelText: (0, _helpers.translation)('146') }),
	          _react2.default.createElement(_radio2.default, { id: 'CarName', name: 'CarName', value: 3, checked: this.state.Identification === 3, onChange: onChange, labelText: (0, _helpers.translation)('15113') })
	        )
	      );
	    }
	  }, {
	    key: 'renderBuffer',
	    value: function renderBuffer() {
	      var _this7 = this;
	
	      var onChange = function onChange(e) {
	        var _e$target3 = e.target,
	            name = _e$target3.name,
	            value = _e$target3.value;
	
	        _this7.setState(_defineProperty({}, name, value));
	      };
	
	      var onBlur = function onBlur(e) {
	        var _e$target4 = e.target,
	            name = _e$target4.name,
	            value = _e$target4.value;
	
	        _this7.setState(_defineProperty({}, name, isNaN(parseInt(value)) ? 0 : parseInt(value)), function () {
	          return _this7.onBlur();
	        });
	      };
	
	      var _state4 = this.state,
	          BufferBefore = _state4.BufferBefore,
	          BufferAfter = _state4.BufferAfter;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('15114'), helpText: (0, _helpers.translation)('15120') },
	        _react2.default.createElement(_text2.default, { name: 'BufferBefore', value: BufferBefore, onChange: onChange, onBlur: onBlur, labelText: (0, _helpers.translation)('15115') }),
	        _react2.default.createElement(_text2.default, { name: 'BufferAfter', value: BufferAfter, onChange: onChange, onBlur: onBlur, labelText: (0, _helpers.translation)('15116') })
	      );
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this8 = this;
	
	      var onChange = function onChange(e) {
	        _this8.setState(_defineProperty({}, e.target.name, e.target.checked), function () {
	          return _this8.onBlur();
	        });
	      };
	
	      var _state5 = this.state,
	          ShowClosedDays = _state5.ShowClosedDays,
	          Show24Hours = _state5.Show24Hours;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('15117') },
	        _react2.default.createElement(_switch2.default, { name: 'ShowClosedDays', onChange: onChange, checked: ShowClosedDays, labelText: (0, _helpers.translation)('15118'), helpText: (0, _helpers.translation)('15124') }),
	        _react2.default.createElement(_switch2.default, { name: 'Show24Hours', onChange: onChange, checked: Show24Hours, labelText: (0, _helpers.translation)('15119'), helpText: (0, _helpers.translation)('15123') })
	      );
	    }
	  }, {
	    key: 'renderContract',
	    value: function renderContract() {
	      var _this9 = this;
	
	      var onChange = function onChange(e) {
	        var _e$target5 = e.target,
	            name = _e$target5.name,
	            value = _e$target5.value;
	
	        _this9.setState(_defineProperty({}, name, value));
	      };
	
	      var onBlur = function onBlur(e) {
	        var name = e.name,
	            value = e.value;
	
	        _this9.setState(_defineProperty({}, name, isNaN(value) ? 0 : value), function () {
	          return _this9.onBlur();
	        });
	      };
	
	      var _state6 = this.state,
	          StandardConditions = _state6.StandardConditions,
	          StandardPrice = _state6.StandardPrice;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('16779') },
	        _react2.default.createElement(_textarea2.default, { name: 'StandardConditions', value: StandardConditions, onChange: onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('16778') }),
	        _react2.default.createElement(_DecimalInput2.default, { name: 'StandardPrice', decimals: 2, value: StandardPrice, onChange: onChange, onBlur: onBlur, labelText: (0, _helpers.translation)('16780') })
	      );
	    }
	  }, {
	    key: 'renderAlternatives',
	    value: function renderAlternatives() {
	      var _this10 = this;
	
	      var renderNew = function renderNew() {
	        var addItem = function addItem() {
	          _this10.setState({
	            CarRentalAlts: [].concat(_toConsumableArray(_this10.state.CarRentalAlts), [_this10.state.NewItem])
	          }, function () {
	            return _this10.onBlur();
	          });
	        };
	        var onChange = function onChange(e) {
	          _this10.setState({
	            NewItem: _extends({}, _this10.state.NewItem, {
	              Active: e.target.value.length > 0,
	              Name: e.target.value
	            })
	          });
	        };
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: ['min-content', 1, 'min-content'], align: 'center' },
	          _react2.default.createElement(_check2.default, { name: 'Active', checked: _this10.state.NewItem.Active, simple: true }),
	          _react2.default.createElement(_text2.default, { name: 'Name', value: _this10.state.NewItem.Name, onChange: onChange }),
	          _react2.default.createElement(_addButton2.default, { onClick: addItem })
	        );
	      };
	      var renderAltRentalCars = function renderAltRentalCars(val, key) {
	        var onChange = function onChange(e) {
	          var CarRentalAltsNew = [].concat(_toConsumableArray(_this10.state.CarRentalAlts));
	          CarRentalAltsNew[key].Active = e.target.checked;
	          _this10.setState({
	            CarRentalAlts: CarRentalAltsNew
	          }, function () {
	            return _this10.onBlur();
	          });
	        };
	        var deleteItem = function deleteItem(key) {
	          var CarRentalAlts = [].concat(_toConsumableArray(_this10.state.CarRentalAlts));
	          CarRentalAlts[key].IsDeleted = true;
	          _this10.setState({
	            CarRentalAlts: CarRentalAlts
	          }, function () {
	            return _this10.onBlur();
	          });
	        };
	        return _react2.default.createElement(
	          _grid2.default,
	          { key: key, cols: [1, 'min-content'], align: 'center' },
	          _react2.default.createElement(_check2.default, { labelText: val.Name, checked: val.Active, onChange: onChange }),
	          _react2.default.createElement(_removeButton2.default, { onClick: deleteItem.bind(_this10, key), size: 'm' })
	        );
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('16751') },
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          (0, _helpers.translation)('295')
	        ),
	        this.state.CarRentalAlts.length > 0 && this.state.CarRentalAlts.map(renderAltRentalCars),
	        renderNew()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var noneIntegration = this.state.CarRentalSystem === _constants.CarRentalSystemTypes.NONE;
	      return _react2.default.createElement(
	        'div',
	        { className: 'carrental' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderIdentification(),
	            this.renderBuffer(),
	            this.renderView()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            { span: 3 },
	            noneIntegration && this.renderAlternatives(),
	            this.renderPopupMessage(),
	            this.renderRentLogIntegration()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            { span: 5 },
	            noneIntegration && this.renderContract()
	          )
	        )
	      );
	    }
	  }]);
	
	  return CarRental;
	}(_react.Component);
	
	CarRental.contextTypes = {};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getCarRentalInformation: _settings.getCarRentalInformation,
	  saveCarRentalInformation: _settings.saveCarRentalInformation
	})(CarRental);

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _settings = __webpack_require__(51);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	
	// Utils
	
	
	var ChainNotification = function (_Component) {
	  _inherits(ChainNotification, _Component);
	
	  function ChainNotification(props) {
	    _classCallCheck(this, ChainNotification);
	
	    var _this = _possibleConstructorReturn(this, (ChainNotification.__proto__ || Object.getPrototypeOf(ChainNotification)).call(this, props));
	
	    _this.state = {
	      Notification: {
	        ChainNotification: ''
	      }
	    };
	
	    _this.getSettings = _this.getSettings.bind(_this);
	    _this.updateSettings = _this.updateSettings.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChainNotification, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSettings();
	    }
	  }, {
	    key: 'getSettings',
	    value: function getSettings() {
	      var _this2 = this;
	
	      this.props.getNotificationInformation().then(function (res) {
	        _this2.setState({
	          Notification: res.data
	        });
	      }, function (err) {
	        console.log('err', err.response.data);
	      });
	    }
	  }, {
	    key: 'updateSettings',
	    value: function updateSettings() {
	      var _this3 = this;
	
	      this.props.saveNotificationInformation(this.state.Notification).then(function (res) {
	        _this3.setState({
	          Notification: res.data
	        }, function () {
	          // window.toastr.success(translation('2215'), translation('13424'))
	        });
	      }, function (err) {
	        console.log('err', err.response.data);
	        window.toastr.error((0, _helpers.translation)('2216'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      e.preventDefault();
	      var settings = _extends({}, this.state.Notification);
	      if (e.target.name === 'ChainNotification') {
	        settings.ChainNotification = e.target.value;
	        this.setState({
	          Notification: settings
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var settings = _extends({}, this.state.Notification);
	
	      var onBlur = function onBlur(e) {
	        e.preventDefault();
	        _this4.updateSettings();
	      };
	
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { span: 2 },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('2214') },
	            _react2.default.createElement(_textarea2.default, { size: 'l', name: 'ChainNotification', onChange: this.onChange, value: settings.ChainNotification, onBlur: onBlur, labelText: (0, _helpers.translation)('2214'), helpText: (0, _helpers.translation)('2217') })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChainNotification;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getNotificationInformation: _settings.getNotificationInformation,
	  saveNotificationInformation: _settings.saveNotificationInformation
	})(ChainNotification);

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1460);
	
	var _settings = __webpack_require__(51);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Datetime from 'react-datetime'
	
	// import styles
	
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var ClosingDays = function (_Component) {
	  _inherits(ClosingDays, _Component);
	
	  function ClosingDays(props) {
	    _classCallCheck(this, ClosingDays);
	
	    var _this = _possibleConstructorReturn(this, (ClosingDays.__proto__ || Object.getPrototypeOf(ClosingDays)).call(this, props));
	
	    _this.state = {
	      NewItem: {
	        Date: '',
	        Text: '',
	        IsChangeable: true,
	        IsDeleted: false
	      },
	      ClosingDays: {
	        ShopId: 0,
	        Days: [{
	          Id: 0,
	          Date: '',
	          Text: '',
	          IsChangeable: true,
	          IsDeleted: false
	        }]
	      },
	      isLoading: false
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(ClosingDays, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getClosingDaysInformation();
	    }
	  }, {
	    key: 'getClosingDaysInformation',
	    value: function getClosingDaysInformation() {
	      var _this2 = this;
	
	      this.props.getClosingDaysInformation(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          ClosingDays: {
	            ShopId: res.data.ShopId,
	            Days: res.data.Days
	          } });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'updateClosingDays',
	    value: function updateClosingDays(closingDays) {
	      var _this3 = this;
	
	      this.setState({ isLoading: true });
	      return this.props.saveClosingDaysInformation(closingDays).then(function (res) {
	        _this3.setState({
	          ClosingDays: {
	            ShopId: res.data.ShopId,
	            Days: res.data.Days
	          }
	        });
	        return res;
	      }, function (err) {
	        console.log(err);
	        return err;
	      }).finally(function () {
	        return _this3.setState({ isLoading: false });
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var value = e.target.value;
	      this.setState({
	        ClosingDays: _extends({}, this.state.ClosingDays, _defineProperty({}, e.target.name, value))
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.props.saveClosingDaysInformation(this.state.ClosingDays).then(function () {
	        // Toastr (replace dict. key)
	        // window.toastr.success(translation('1718'), translation('13424'))
	      }, function () {
	        // Toastr (replace dict. key)
	        window.toastr.error((0, _helpers.translation)('1719'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderClosingDays',
	    value: function renderClosingDays() {
	      var _this4 = this;
	
	      var ClosingDays = this.state.ClosingDays;
	
	      var deleteItem = function deleteItem(key) {
	        var closingDays = _extends({}, _this4.state.ClosingDays);
	        closingDays.Days[key].IsDeleted = true;
	        _this4.updateClosingDays(ClosingDays);
	      };
	
	      var renderNew = function renderNew() {
	        var addItem = function addItem() {
	          var formatDate = function formatDate(date) {
	            if (date === null || date === '') return '1990-01-01';
	            if (typeof date.format === 'function') {
	              return date.format('YYYY-MM-DD');
	            }
	            return date;
	          };
	
	          var ClosingDays = _extends({}, _this4.state.ClosingDays);
	          var newItem = _extends({}, _this4.state.NewItem);
	          newItem.Date = formatDate(newItem.Date);
	          ClosingDays.Days.push(newItem);
	          _this4.updateClosingDays(ClosingDays).then(function (res) {
	            _this4.setState({
	              NewItem: {
	                Date: '',
	                Text: '',
	                IsDeleted: false,
	                IsChangeable: true
	              }
	            });
	            // Toastr (replace dict. key)
	            // window.toastr.success(translation('1718'), translation('13424'))
	          }, function () {
	            // Toastr (replace dict. key)
	            window.toastr.error((0, _helpers.translation)('1719'), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var onChange = function onChange(e) {
	          var value = '';
	          var name = '';
	          if (typeof e.target !== 'undefined') {
	            value = e.target.value;
	            name = e.target.name;
	          } else {
	            value = e;
	            name = 'Date';
	          }
	          _this4.setState({
	            NewItem: _extends({}, _this4.state.NewItem, _defineProperty({}, name, value))
	          });
	        };
	
	        var inputProps = {
	          name: 'Date',
	          placeholder: (0, _helpers.translation)('1728'),
	          readOnly: true
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 1.75, 0.25], spacing: 1 },
	          _react2.default.createElement(_datetime2.default
	          // labelText={translation('388')}
	          , { inputProps: inputProps,
	            dateFormat: 'DD-MM-YYYY',
	            timeFormat: false,
	            closeOnSelect: true,
	            value: _this4.state.NewItem.Date,
	            onChange: onChange }),
	          _react2.default.createElement(_text2.default, { name: 'Text', value: _this4.state.NewItem.Text, onChange: onChange }),
	          _react2.default.createElement(_addButton2.default, { spacing: 0, onClick: addItem, disabled: _this4.state.isLoading })
	        );
	      };
	
	      var renderClosingDay = function renderClosingDay(val, key) {
	        var renderChangable = function renderChangable(val, key) {
	          var onChange = function onChange(e) {
	            var closingDayNew = _extends({}, _this4.state.ClosingDays);
	            closingDayNew.Days[key][e.target.name] = e.target.value;
	            _this4.setState({
	              ClosingDays: closingDayNew
	            });
	          };
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { key: key, cols: [1, 1.75, 0.25], spacing: 1 },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _time.renderFullDate)(val.Date, false)
	            ),
	            _react2.default.createElement(_text2.default, { name: 'Text', key: 'closingDayText_' + val.Id, defaultValue: val.Text, onChange: onChange, onBlur: _this4.onBlur, size: 'm' }),
	            _react2.default.createElement(_removeButton2.default, { spacing: 0, onClick: deleteItem.bind(_this4, key), size: 'm' })
	          );
	        };
	
	        var renderUnchangable = function renderUnchangable(val, key) {
	          return _react2.default.createElement(
	            _inline2.default,
	            { key: key },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _time.renderFullDate)(val.Date, false)
	            ),
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              val.Text
	            )
	          );
	        };
	
	        return val.IsChangeable ? renderChangable(val, key) : renderUnchangable(val, key);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 1.75, 0.25], spacing: 1 },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('388')
	          ),
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('333')
	          ),
	          _react2.default.createElement('div', null)
	        ),
	        renderNew(),
	        ClosingDays.Days.map(renderClosingDay)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'closing-days' },
	        _react2.default.createElement(
	          _col2.default,
	          { span: '2' },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('504'), helpText: (0, _helpers.translation)('1985') },
	            this.renderClosingDays()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClosingDays;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getClosingDaysInformation: _settings.getClosingDaysInformation,
	  saveClosingDaysInformation: _settings.saveClosingDaysInformation
	})(ClosingDays);

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1461);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _helpers = __webpack_require__(2);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _color = __webpack_require__(1066);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _constants = __webpack_require__(5);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _carownerportal = __webpack_require__(192);
	
	var _settings = __webpack_require__(51);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import async from 'async'
	
	// import styles
	
	
	// Elements
	
	// import Label from '../../../shared/elements/label'
	
	// Utils
	
	
	// Actions
	
	
	var fonts = ['Arial', 'Verdana', 'Helvetica', 'Tahoma', 'Trebuchet MS', 'Times New Roman', 'Georgia', 'Garamond', 'Courier New', 'Brush Script MT'];
	
	var fontSizes = Array.from({ length: 45 }, function (v, k) {
	  return k + 4;
	});
	
	var CompanyStyling = function (_Component) {
	  _inherits(CompanyStyling, _Component);
	
	  function CompanyStyling(props) {
	    _classCallCheck(this, CompanyStyling);
	
	    var _this = _possibleConstructorReturn(this, (CompanyStyling.__proto__ || Object.getPrototypeOf(CompanyStyling)).call(this, props));
	
	    _this.state = {
	      FontType: 1,
	      WebSafeFont: 'Arial',
	      FontURL: '',
	      FontFamily: '',
	      BrandColor: '#000000',
	      BrandColorSecondary: '#000000',
	      PrimaryBackgroundColor: '#000000',
	      ColoredBackground: '#000000',
	      H1Size: 40,
	      H1Color: '#000000',
	      H2Size: 40,
	      H2Color: '#000000',
	      BodySize: 40,
	      BodyColor: '#000000',
	      NavigationSize: 40,
	      NavigationColor: '#000000',
	      LinkSize: 40,
	      LinkColor: '#000000',
	      ButtonTextSize: 40,
	      ButtonTextColor: '#000000',
	      ButtonStrokeColor: '#000000',
	      ButtonFillColor: '#000000',
	      HoverStrokeColor: '#000000',
	      HoverFillColor: '#000000',
	      CheckboxColor: '#000000',
	      CheckboxActiveColor: '#000000',
	      BackButtonTextSize: 40,
	      BackButtonTextColor: '#000000',
	      BackButtonStrokeColor: '#000000',
	      BackButtonFillColor: '#000000',
	      BackButtonHoverStrokeColor: '#000000',
	      BackButtonHoverFillColor: '#000000',
	      InputFieldColor: '#000000',
	      EmptyFieldTextColor: '#000000',
	      EmptyFieldTextSize: 40,
	      Logo: null,
	      upload: {
	        loading: false,
	        errors: []
	      },
	      confirmFileDelete: {
	        confirm: false,
	        file: null
	      },
	      errors: []
	    };
	
	    _this.handleClickSave = _this.updateStyling.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onTextChange = _this.onTextChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onDropAccepted = _this.onDropAccepted.bind(_this);
	    _this.onDropRejected = _this.onDropRejected.bind(_this);
	    _this.renderImage = _this.renderImage.bind(_this);
	    return _this;
	  }
	
	  _createClass(CompanyStyling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	      this.getLogo();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._mounted = false;
	      window.removeEventListener('resize', this.fnListener);
	      clearInterval(this.checkFileTimer);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      this.props.getPortalStyling().then(function (res) {
	        _this2.setState(res.data);
	      });
	    }
	  }, {
	    key: 'getLogo',
	    value: function getLogo() {
	      var _this3 = this;
	
	      this.props.getLogo().then(function (res) {
	        _this3.setState({ Logo: res.data });
	      });
	    }
	  }, {
	    key: 'updateStyling',
	    value: function updateStyling(e) {
	      var _this4 = this;
	
	      this.props.postPortalStyling(JSON.parse(JSON.stringify(this.state))).then(function (res) {
	        _this4.setState(_extends({}, res.data));
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(name, value) {
	      var _this5 = this;
	
	      if (Number.isInteger(parseInt(value))) value = parseInt(value);
	      this.setState(_defineProperty({}, name, value), function () {
	        _this5.updateStyling();
	      });
	    }
	  }, {
	    key: 'onTextChange',
	    value: function onTextChange(e) {
	      console.log('onTextChange', e.target.name, 'value', e.target.value);
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.updateStyling();
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop() {
	      this.setState({ upload: _extends({}, this.state.upload, { errors: [] }) });
	    }
	  }, {
	    key: 'onDropAccepted',
	    value: function onDropAccepted(files) {
	      var _this6 = this;
	
	      this.setState({
	        upload: _extends({}, this.state.upload, {
	          files: files,
	          loading: true
	        })
	      }, function () {
	        _this6.props.uploadLogo(_this6.state.upload.files[0]).then(function (res) {
	          _this6.setState({ upload: _extends({}, _this6.state.upload, { files: [], loading: false }) });
	          _this6.setState({ Logo: res.data });
	        });
	      });
	    }
	  }, {
	    key: 'onDropRejected',
	    value: function onDropRejected(files) {
	      var newErrors = [];
	      files.map(function (file) {
	        newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13405') + '.');
	      });
	      this.setState({ upload: _extends({}, this.state.upload, { errors: newErrors, files: [] }) });
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile(file) {
	      var confirm = {
	        confirm: true,
	        file: file
	      };
	      this.setState({
	        confirmFileDelete: confirm
	      });
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(image, index) {
	      var _this7 = this;
	
	      if (image != null) {
	        var url = _constants.FILE_STORAGE + image.FileURL;
	        return _react2.default.createElement(
	          'div',
	          { className: 'image-div', key: index },
	          _react2.default.createElement(
	            'a',
	            { href: url, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	            _react2.default.createElement('img', { src: url })
	          ),
	          _react2.default.createElement(_removeButton2.default, { size: 's', onClick: function onClick() {
	              return _this7.deleteFile(image);
	            } })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      // let { errors } = this.state.upload
	      var images = [this.state.Logo];
	
	      var onPortalClose = function onPortalClose() {
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	        _this8.setState({
	          confirmFileDelete: confirm
	        });
	      };
	
	      var onConfirm = function onConfirm() {
	        var file = _this8.state.confirmFileDelete.file;
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	        _this8.setState({
	          confirmFileDelete: confirm
	        }, function () {
	          var newErrors = [];
	          _this8.props.deleteLogo().then(function (res) {
	            _this8.setState({ Logo: null });
	          }, function () {
	            newErrors.push((0, _helpers.translation)('1207') + ': ' + file.FileName + '' + (0, _helpers.translation)('13406') + '.');
	            _this8.setState({
	              upload: _extends({}, _this8.state.upload, { errors: newErrors })
	            });
	          });
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'company-styling' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            { span: 2 },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)(18188) },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 'Font type' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row-container row-1col' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-container' },
	                    _react2.default.createElement(_radio2.default, { name: 'FontType', value: 1, checked: this.state.FontType === 1, onChange: function onChange(e) {
	                        return _this8.onInputChange(e.target.name, e.target.value);
	                      }, labelText: (0, _helpers.translation)(18194) }),
	                    _react2.default.createElement(
	                      _dropDown2.default,
	                      { name: 'WebSafeFont', onChange: function onChange(e) {
	                          return _this8.onInputChange('WebSafeFont', e.target.value);
	                        }, value: this.state.WebSafeFont, spacing: 1 },
	                      fonts.map(function (f) {
	                        return _react2.default.createElement(
	                          'option',
	                          { value: f, key: f },
	                          f
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row-container row-1col' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-container' },
	                    _react2.default.createElement(_radio2.default, { name: 'FontType', value: 2, checked: this.state.FontType === 2, onChange: function onChange(e) {
	                        return _this8.onInputChange(e.target.name, e.target.value);
	                      }, labelText: (0, _helpers.translation)(18195) })
	                  )
	                )
	              ),
	              _react2.default.createElement(_text2.default, { name: 'FontURL', value: this.state.FontURL, labelText: 18195, onChange: this.onTextChange, onBlur: this.onBlur, helpText: 18260 }),
	              _react2.default.createElement(_text2.default, { name: 'FontFamily', value: this.state.FontFamily, labelText: 18258, onChange: this.onTextChange, onBlur: this.onBlur, helpText: 18261 }),
	              _react2.default.createElement(_divider2.default, { noLine: true, size: 3 }),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18196) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'BrandColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('BrandColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18288), value: this.state.BrandColor })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'BrandColorSecondary', onChange: function onChange(e) {
	                      return _this8.onInputChange('BrandColorSecondary', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18289), value: this.state.BrandColorSecondary })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'PrimaryBackgroundColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('PrimaryBackgroundColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18290), value: this.state.PrimaryBackgroundColor })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'ColoredBackground', onChange: function onChange(e) {
	                      return _this8.onInputChange('ColoredBackground', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18291), value: this.state.ColoredBackground })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18197) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'H1Size', onChange: function onChange(e) {
	                        return _this8.onInputChange('H1Size', e.target.value);
	                      }, value: this.state.H1Size, labelText: (0, _helpers.translation)(13340) },
	                    fontSizes.map(function (f) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: f, key: f },
	                        f,
	                        'px'
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'H1Color', onChange: function onChange(e) {
	                      return _this8.onInputChange('H1Color', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18213), value: this.state.H1Color })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18198) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'h2size', onChange: function onChange(e) {
	                        return _this8.onInputChange('H2Size', e.target.value);
	                      }, value: this.state.H2Size, labelText: (0, _helpers.translation)(13340) },
	                    fontSizes.map(function (f) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: f, key: f },
	                        f,
	                        'px'
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'H2Color', onChange: function onChange(e) {
	                      return _this8.onInputChange('H2Color', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18213), value: this.state.H2Color })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18208) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'BodySize', onChange: function onChange(e) {
	                        return _this8.onInputChange('BodySize', e.target.value);
	                      }, value: this.state.BodySize, labelText: (0, _helpers.translation)(13340) },
	                    fontSizes.map(function (f) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: f, key: f },
	                        f,
	                        'px'
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'BodyColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('BodyColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18213), value: this.state.BodyColor })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18199) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'NavigationSize', onChange: function onChange(e) {
	                        return _this8.onInputChange('NavigationSize', e.target.value);
	                      }, value: this.state.NavigationSize, labelText: (0, _helpers.translation)(13340) },
	                    fontSizes.map(function (f) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: f, key: f },
	                        f,
	                        'px'
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'NavigationColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('NavigationColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18213), value: this.state.NavigationColor })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18200) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'LinkSize', onChange: function onChange(e) {
	                        return _this8.onInputChange('LinkSize', e.target.value);
	                      }, value: this.state.LinkSize, labelText: (0, _helpers.translation)(13340) },
	                    fontSizes.map(function (f) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: f, key: f },
	                        f,
	                        'px'
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'LinkColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('LinkColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18213), value: this.state.LinkColor })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18201) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'ButtonTextSize', onChange: function onChange(e) {
	                        return _this8.onInputChange('ButtonTextSize', e.target.value);
	                      }, value: this.state.ButtonTextSize, labelText: (0, _helpers.translation)(13340) },
	                    fontSizes.map(function (f) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: f, key: f },
	                        f,
	                        'px'
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'ButtonTextColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('ButtonTextColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18203), value: this.state.ButtonTextColor })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'ButtonStrokeColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('ButtonStrokeColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18204), value: this.state.ButtonStrokeColor })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'ButtonFillColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('ButtonFillColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18205), value: this.state.ButtonFillColor })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'HoverStrokeColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('HoverStrokeColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18298), value: this.state.HoverStrokeColor })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'HoverFillColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('HoverFillColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18292), value: this.state.HoverFillColor })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18328) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'BackButtonTextSize', onChange: function onChange(e) {
	                        return _this8.onInputChange('BackButtonTextSize', e.target.value);
	                      }, value: this.state.BackButtonTextSize, labelText: (0, _helpers.translation)(13340) },
	                    fontSizes.map(function (f) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: f, key: f },
	                        f,
	                        'px'
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'BackButtonTextColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('BackButtonTextColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18203), value: this.state.BackButtonTextColor })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'BackButtonStrokeColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('BackButtonStrokeColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18204), value: this.state.BackButtonStrokeColor })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'BackButtonFillColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('BackButtonFillColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18205), value: this.state.BackButtonFillColor })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'BackButtonHoverStrokeColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('BackButtonHoverStrokeColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18298), value: this.state.BackButtonHoverStrokeColor })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'BackButtonHoverFillColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('BackButtonHoverFillColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18292), value: this.state.BackButtonHoverFillColor })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18330) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(
	                    _dropDown2.default,
	                    { name: 'EmptyFieldTextSize', onChange: function onChange(e) {
	                        return _this8.onInputChange('EmptyFieldTextSize', e.target.value);
	                      }, value: this.state.EmptyFieldTextSize, labelText: (0, _helpers.translation)(13340) },
	                    fontSizes.map(function (f) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: f, key: f },
	                        f,
	                        'px'
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'EmptyFieldTextColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('EmptyFieldTextColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18295), value: this.state.EmptyFieldTextColor })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18329) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'InputFieldColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('InputFieldColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18294), value: this.state.InputFieldColor })
	                )
	              ),
	              _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(18293) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'row-container row-2col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'CheckboxColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('CheckboxColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18294), value: this.state.CheckboxColor })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-container' },
	                  _react2.default.createElement(_color2.default, { name: 'CheckboxActiveColor', onChange: function onChange(e) {
	                      return _this8.onInputChange('CheckboxActiveColor', e.target.value);
	                    }, labelText: (0, _helpers.translation)(18295), value: this.state.CheckboxActiveColor })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            { span: 2 },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)(1702) },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)(18214) },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row-container row-1col' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-container' },
	                    _react2.default.createElement(
	                      _Dropzone2.default,
	                      {
	                        onDrop: this.onDrop,
	                        onDropAccepted: this.onDropAccepted,
	                        onDropRejected: this.onDropRejected,
	                        multiple: false,
	                        includeCircles: false },
	                      this.state.upload.loading && _react2.default.createElement(
	                        'p',
	                        { className: 'loading' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'animated-background' },
	                          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'sr-only' },
	                            (0, _helpers.translation)(13382),
	                            '...'
	                          )
	                        )
	                      ),
	                      !this.state.upload.loading && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          (0, _helpers.translation)(16847)
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row-container row-1col' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-container' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'files_inner' },
	                      _react2.default.createElement(_Gallery2.default, { files: images, renderImage: this.renderImage })
	                    )
	                  ),
	                  this.state.confirmFileDelete.confirm && _react2.default.createElement(
	                    _Portal2.default,
	                    { className: 'deleteModal', onPortalClose: onPortalClose },
	                    _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onPortalClose })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CompanyStyling;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  uploadLogo: _carownerportal.uploadLogo,
	  getLogo: _carownerportal.getLogo,
	  deleteLogo: _carownerportal.deleteLogo,
	  getPortalStyling: _settings.getPortalStyling,
	  postPortalStyling: _settings.postPortalStyling
	})(CompanyStyling);

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _settings = __webpack_require__(51);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	
	// Utils
	
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).call(this, props));
	
	    _this.state = {
	      // ShopId: 0,
	      Mobile: '',
	      PhoneCode: _this.props.phonecode,
	      Name: '',
	      Mail: '',
	      UserName: '',
	      Password: '',
	      Address: '',
	      ZipCode: '',
	      City: ''
	    };
	    _this.updateContactInformation = _this.updateContactInformation.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Contact, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getContactInformation();
	    }
	  }, {
	    key: 'getContactInformation',
	    value: function getContactInformation() {
	      var _this2 = this;
	
	      // this.props.auth.user.ShopId
	      this.props.getContactInformation().then(function (res) {
	        _this2.setState({
	          // ShopId: res.data.ShopId,
	          Mobile: res.data.Mobile,
	          PhoneCode: res.data.PhoneCode,
	          Name: res.data.Name,
	          Mail: res.data.Mail,
	          UserName: res.data.UserName,
	          Password: res.data.Password,
	          Address: res.data.Address,
	          ZipCode: res.data.ZipCode,
	          City: res.data.City
	        });
	      }, function () {
	        // console.log('get contact err', err)
	      });
	    }
	  }, {
	    key: 'updateContactInformation',
	    value: function updateContactInformation() {
	      this.props.saveContactInformation(this.state).then(function (res) {
	        // Toastr
	        // window.toastr.success(translation('13462'), translation('13424'))
	      }, function (err) {
	        // Toastr
	        if (err.response.data.DictionaryKey) {
	          window.toastr.error((0, _helpers.translation)('13463') + '. ' + (0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('13463'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(name, e) {
	      var value = '';
	      value = name.target.value;
	      if (name.target.name === 'PhoneNumber') {
	        name = 'Mobile';
	        this.setState(_defineProperty({}, name, value));
	      } else {
	        this.setState({
	          PhoneCode: {
	            Id: Number(value.Id)
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var canEditName = (0, _auth.hasAccess)([1, 2], this.props.auth.user.UserType);
	
	      var renderLogin = function renderLogin() {
	        if (!(0, _auth.hasSubscriptionPermission)(_this3.props.auth, 10, 0)) return null;
	        return _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('2223'), helpText: (0, _helpers.translation)('2084') + ' ' + (0, _helpers.translation)('1965') + ' ' + (0, _helpers.translation)('1966') },
	          _react2.default.createElement(_text2.default, { name: 'UserName', value: _this3.state.UserName, onChange: _this3.onChange, onBlur: _this3.updateContactInformation, labelText: (0, _helpers.translation)('1') }),
	          _react2.default.createElement(_text2.default, { name: 'Password', value: _this3.state.Password, onChange: _this3.onChange, onBlur: _this3.updateContactInformation, labelText: (0, _helpers.translation)('2') })
	        );
	      };
	
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('2222'), helpText: (0, _helpers.translation)('2083') },
	            _react2.default.createElement(_text2.default, { name: 'Name', value: this.state.Name, onChange: this.onChange, onBlur: this.updateContactInformation, disabled: !canEditName, labelText: (0, _helpers.translation)('30') }),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('345') },
	              _react2.default.createElement(_Phone2.default, {
	                onChange: this.onPhoneChange,
	                onBlur: this.updateContactInformation,
	                code: this.state.PhoneCode,
	                number: this.state.Mobile })
	            ),
	            _react2.default.createElement(_text2.default, { name: 'Mail', value: this.state.Mail, onChange: this.onChange, onBlur: this.updateContactInformation, labelText: (0, _helpers.translation)('151') }),
	            _react2.default.createElement(_text2.default, { name: 'Address', value: this.state.Address, onChange: this.onChange, onBlur: this.updateContactInformation, labelText: (0, _helpers.translation)('25') }),
	            _react2.default.createElement(_text2.default, { name: 'ZipCode', value: this.state.ZipCode, onChange: this.onChange, onBlur: this.updateContactInformation, labelText: (0, _helpers.translation)('40') }),
	            _react2.default.createElement(_text2.default, { name: 'City', value: this.state.City, onChange: this.onChange, onBlur: this.updateContactInformation, labelText: (0, _helpers.translation)('37') })
	          )
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          renderLogin()
	        )
	      );
	    }
	  }]);
	
	  return Contact;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getContactInformation: _settings.getContactInformation,
	  saveContactInformation: _settings.saveContactInformation
	})(Contact);

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1463);
	
	var _settings = __webpack_require__(51);
	
	var _customers = __webpack_require__(74);
	
	var _auth = __webpack_require__(68);
	
	var _common = __webpack_require__(25);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Elements
	
	
	// Utils
	
	
	var Forsi = function (_Component) {
	  _inherits(Forsi, _Component);
	
	  function Forsi(props) {
	    _classCallCheck(this, Forsi);
	
	    var _this = _possibleConstructorReturn(this, (Forsi.__proto__ || Object.getPrototypeOf(Forsi)).call(this, props));
	
	    _this.state = {
	      Forsi: {
	        ShopId: 0,
	        Active: false,
	        UserName: '',
	        Password: '',
	        ForsiBodyShopId: '',
	        AutoUpdate: false,
	        UpdateCompleted: false,
	        UpdateCompletedManuel: false,
	        UpdateInvoiced: false,
	        ShowPrices: false,
	        ShowAe: false,
	        ShopCustomerId: null,
	        UsesToken: false,
	        TokenActive: '',
	        Token: ''
	      },
	      Customers: [],
	      randradio: 0,
	      randcheck: [],
	      dropper: '3',
	      switcher: []
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Forsi, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.getForsiInformation();
	      this.props.getCustomers(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          Customers: res.data
	          // }, () => {
	          //   console.log('[Forsi] got customers', this.state)
	        });
	      });
	    }
	  }, {
	    key: 'getForsiInformation',
	    value: function getForsiInformation() {
	      var _this3 = this;
	
	      this.props.getForsiInformation(this.props.auth.user.ShopId).then(function (res) {
	        _this3.setState({
	          Forsi: {
	            ShopId: res.data.ShopId,
	            Active: res.data.Active,
	            UserName: res.data.UserName,
	            Password: res.data.Password,
	            ForsiBodyShopId: res.data.ForsiBodyShopId,
	            AutoUpdate: res.data.AutoUpdate,
	            UpdateCompleted: res.data.UpdateCompleted,
	            UpdateCompletedManuel: res.data.UpdateCompletedManuel,
	            UpdateInvoiced: res.data.UpdateInvoiced,
	            ShowPrices: res.data.ShowPrices,
	            ShowAe: res.data.ShowAe,
	            ShopCustomerId: res.data.ShopCustomerId,
	            UsesToken: res.data.UsesToken,
	            TokenActive: res.data.TokenActive,
	            Token: res.data.Token
	          }
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this4 = this;
	
	      e.persist();
	      var value = e.target.value;
	
	      if (e.target.name === 'UpdateCompleted') {
	        var updateCompleted = e.target.value === 'yes';
	        var updateCompletedManual = e.target.value === 'manual';
	        this.setState({
	          Forsi: _extends({}, this.state.Forsi, {
	            UpdateCompleted: updateCompleted,
	            UpdateCompletedManuel: updateCompletedManual
	          })
	        }, function () {
	          if (e.target.type === 'radio') {
	            _this4.onBlur(e);
	          }
	        });
	      } else {
	        if (e.target.type === 'radio') {
	          value = e.target.value === 'yes';
	        }
	        if (e.target.type === 'checkbox') {
	          console.log('checkbox', e.target.name, e.target.checked);
	          value = e.target.checked;
	        }
	        if (e.target.type === 'select-one') {
	          value = Number(value);
	        }
	        this.setState({
	          Forsi: _extends({}, this.state.Forsi, _defineProperty({}, e.target.name, value))
	        }, function () {
	          if (e.target.type === 'radio' || e.target.type === 'select-one' || e.target.type === 'checkbox') {
	            _this4.onBlur(e);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this5 = this;
	
	      this.props.saveForsiInformation(this.state.Forsi).then(function () {
	        // Toastr (replace dict. key)
	        // window.toastr.success(translation('1722'), translation('13424'))
	        _this5.props.getAuthResources();
	      }, function () {
	        if (_this5.state.Forsi.UserName === null || _this5.state.Forsi.Password) {
	          window.toastr.error((0, _helpers.translation)('2077'));
	        }
	        // Toastr (replace dict. key)
	        window.toastr.error((0, _helpers.translation)('1723'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderForsiToken',
	    value: function renderForsiToken() {
	      var Forsi = this.state.Forsi;
	      // console.log(Forsi)
	
	      if (!Forsi.UsesToken) return null;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(16421) },
	        _react2.default.createElement(_switch2.default, { name: 'TokenActive', onChange: this.onChange, checked: Forsi.TokenActive, labelText: (0, _helpers.translation)('295') }),
	        Forsi.TokenActive ? _react2.default.createElement(_text2.default, { name: 'Token', value: Forsi.Token, onChange: this.onChange, onBlur: this.onBlur, labelText: 'Token' }) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var Forsi = this.state.Forsi;
	      // console.log('[Forsi] render', this.props, this.state)
	
	      var customersList = function customersList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: val.CustomerId, value: val.CustomerId },
	          val.Name
	        );
	      };
	
	      var renderForsiColumn = function renderForsiColumn() {
	        if (_this6.props.auth.permissions.ChainAssessmentSystem !== 1) return null;
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('13438') },
	            _react2.default.createElement(_switch2.default, { id: 'Active', name: 'Active', checked: Forsi.Active, value: '1', onChange: _this6.onChange, labelText: (0, _helpers.translation)('295') }),
	            _react2.default.createElement(_text2.default, { name: 'UserName', value: Forsi.UserName, onChange: _this6.onChange, onBlur: _this6.onBlur, labelText: (0, _helpers.translation)(1) }),
	            _react2.default.createElement(_text2.default, { name: 'Password', value: Forsi.Password, onChange: _this6.onChange, onBlur: _this6.onBlur, labelText: (0, _helpers.translation)(2) }),
	            _react2.default.createElement(_text2.default, { name: 'ForsiBodyShopId', value: Forsi.ForsiBodyShopId, onChange: _this6.onChange, onBlur: _this6.onBlur, labelText: (0, _helpers.translation)(14803) }),
	            _this6.props.auth.user.DepartmentType === 1 && _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('14905'), helpText: (0, _helpers.translation)('14907') },
	              _react2.default.createElement(
	                _dropDown2.default,
	                { onChange: _this6.onChange, name: 'ShopCustomerId', value: Forsi.ShopCustomerId },
	                _react2.default.createElement(
	                  'option',
	                  { key: null, value: null },
	                  (0, _helpers.translation)('14906')
	                ),
	                _this6.state.Customers.map(customersList)
	              )
	            )
	          )
	        );
	      };
	
	      var autoUpdateText = null;
	      var autoUpdateHelpText = null;
	      switch (this.props.auth.permissions.ChainAssessmentSystem) {
	        case 1:
	          autoUpdateText = (0, _helpers.translation)('942');
	          autoUpdateHelpText = (0, _helpers.translation)('1996');
	          break;
	        case 2:
	          autoUpdateText = (0, _helpers.translation)('18066');
	          autoUpdateHelpText = (0, _helpers.translation)('18067');
	          break;
	        default:
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'forsi__page' },
	        _react2.default.createElement(
	          'form',
	          null,
	          _react2.default.createElement(
	            _row2.default,
	            null,
	            renderForsiColumn(),
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              _react2.default.createElement(
	                _panel2.default,
	                { title: (0, _helpers.translation)('998') },
	                _react2.default.createElement(_switch2.default, { id: 'AutoUpdate', name: 'AutoUpdate', checked: Forsi.AutoUpdate, value: '1', onChange: this.onChange, labelText: autoUpdateText, helpText: autoUpdateHelpText }),
	                _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { labelText: (0, _helpers.translation)('1250'), helpText: (0, _helpers.translation)('1997') },
	                  _react2.default.createElement(_radio2.default, { id: 'UpdateCompleted_yes', name: 'UpdateCompleted', labelText: (0, _helpers.translation)('47'), onChange: this.onChange, value: 'yes', checked: Forsi.UpdateCompleted }),
	                  _react2.default.createElement(_radio2.default, { id: 'UpdateCompleted_no', name: 'UpdateCompleted', labelText: (0, _helpers.translation)('48'), onChange: this.onChange, value: 'no', checked: !Forsi.UpdateCompleted && !Forsi.UpdateCompletedManuel }),
	                  _react2.default.createElement(_radio2.default, { id: 'UpdateCompleted_manual', name: 'UpdateCompleted', labelText: (0, _helpers.translation)('1619'), onChange: this.onChange, value: 'manual', checked: !Forsi.UpdateCompletedManuel })
	                ),
	                _react2.default.createElement(_switch2.default, { id: 'UpdateInvoiced', name: 'UpdateInvoiced', checked: Forsi.UpdateInvoiced, value: '1', onChange: this.onChange, labelText: (0, _helpers.translation)('1251'), helpText: (0, _helpers.translation)('1998') })
	              )
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              _react2.default.createElement(
	                _panel2.default,
	                { title: (0, _helpers.translation)('420') },
	                _react2.default.createElement(_switch2.default, { id: 'ShowAe', name: 'ShowAe', checked: Forsi.ShowAe, value: '1', onChange: this.onChange, labelText: (0, _helpers.translation)('422') }),
	                _react2.default.createElement(_switch2.default, { id: 'ShowPrices', name: 'ShowPrices', checked: Forsi.ShowPrices, value: '1', onChange: this.onChange, labelText: (0, _helpers.translation)('423') })
	              )
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              { span: 2 },
	              this.renderForsiToken()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Forsi;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getForsiInformation: _settings.getForsiInformation,
	  saveForsiInformation: _settings.saveForsiInformation,
	  getCustomers: _customers.getCustomers,
	  getAuthResources: _auth.getAuthResources,
	
	  openPopup: _common.openPopup,
	  closePopup: _common.closePopup
	})(Forsi);

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _helpers = __webpack_require__(2);
	
	var _settings = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// elemnents
	
	
	var ProductNumbers = function (_Component) {
	  _inherits(ProductNumbers, _Component);
	
	  function ProductNumbers(props) {
	    _classCallCheck(this, ProductNumbers);
	
	    var _this = _possibleConstructorReturn(this, (ProductNumbers.__proto__ || Object.getPrototypeOf(ProductNumbers)).call(this, props));
	
	    _this.state = {
	      ShopId: 0,
	      UseOwnProductNumbers: false,
	      WorkHourAEProduct: null,
	      TotalPriceProduct: null,
	      ChainUseStandardProductNumbers: true,
	      ProductNumber: []
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProductNumbers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getProductNumbers();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(oldProps) {
	      if (oldProps.accountingSystem !== this.props.accountingSystem) {
	        this.getProductNumbers();
	      }
	    }
	  }, {
	    key: 'getProductNumbers',
	    value: function getProductNumbers() {
	      var _this2 = this;
	
	      if (this.props.section === 'report') {
	        this.props.getProductNumbersReport().then(function (res) {
	          _this2.setState({
	            ShopId: res.data.ShopId,
	            UseOwnProductNumbers: res.data.UseOwnProductNumbers,
	            WorkHourAEProduct: res.data.WorkHourAEProduct,
	            TotalPriceProduct: res.data.TotalPriceProduct,
	            ChainUseStandardProductNumbers: res.data.ChainUseStandardProductNumbers,
	            ProductNumber: res.data.ProductNumber
	          });
	        }, function (err) {
	          console.log(err);
	        });
	      } else {
	        this.props.getProductNumbers(this.props.auth.user.ShopId).then(function (res) {
	          _this2.setState({
	            ShopId: res.data.ShopId,
	            UseOwnProductNumbers: res.data.UseOwnProductNumbers,
	            ChainUseStandardProductNumbers: res.data.ChainUseStandardProductNumbers,
	            ProductNumber: res.data.ProductNumber
	          });
	        }, function (err) {
	          console.log(err);
	        });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this3 = this;
	
	      e.persist();
	      if (e.target.name === 'UseOwnProductNumbers') {
	        this.setState(_extends({}, this.state, _defineProperty({}, e.target.name, e.target.checked)), function () {
	          _this3.onBlur(e);
	        });
	      } else {
	        if (e.target.name.startsWith('PType')) {
	          var id = e.target.name.substring(5);
	          var index = 0;
	          if (this.props.section === 'report') {
	            index = this.state.ProductNumber.findIndex(function (x) {
	              return x.ProductNumberId === parseInt(id);
	            });
	          } else {
	            index = this.state.ProductNumber.findIndex(function (x) {
	              return x.PType === parseInt(id);
	            });
	          }
	          var numbers = this.state.ProductNumber;
	          numbers[index].PNumber = e.target.value;
	          numbers[index].PExternalName = '';
	          this.setState(_extends({}, this.state, {
	            ProductNumber: numbers
	          }));
	        } else if (e.target.name === 'WorkHourAEProduct' || e.target.name === 'TotalPriceProduct') {
	          this.setState(_extends({}, this.state, _defineProperty({}, e.target.name, e.target.value || '')));
	        }
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this4 = this;
	
	      if (this.props.section === 'report') {
	        this.props.saveProductNumbersReport(this.state).then(function (res) {
	          _this4.setState(_extends({}, _this4.state, {
	            WorkHourAEProduct: res.data.WorkHourAEProduct,
	            TotalPriceProduct: res.data.TotalPriceProduct,
	            ProductNumber: res.data.ProductNumber
	          }));
	          // Toastr (replace dict. key)
	          // window.toastr.success(translation('1724'), translation('13424'))
	        }, function () {
	          // Toastr (replace dict. key)
	          window.toastr.error((0, _helpers.translation)('1725'), (0, _helpers.translation)('216'));
	        });
	      } else {
	        this.props.saveProductNumbers(this.state).then(function (res) {
	          _this4.setState(_extends({}, _this4.state, {
	            ProductNumber: res.data.ProductNumber
	          }));
	          // Toastr (replace dict. key)
	          // window.toastr.success(translation('1724'), translation('13424'))
	        }, function () {
	          // Toastr (replace dict. key)
	          window.toastr.error((0, _helpers.translation)('1725'), (0, _helpers.translation)('216'));
	        });
	      }
	    }
	  }, {
	    key: 'getLabelText',
	    value: function getLabelText(val) {
	      if (this.props.section === 'report') {
	        return val.PType;
	      }
	
	      var isBodyShop = this.props.auth.departmentType === 1;
	      var labelText = '';
	      switch (val.PType) {
	        case 1:
	          labelText = (0, _helpers.translation)('416');
	          break;
	        case 2:
	          labelText = isBodyShop ? (0, _helpers.translation)('15155') : (0, _helpers.translation)('13339');
	          break;
	        case 3:
	          labelText = (0, _helpers.translation)('417');
	          break;
	        case 4:
	          labelText = (0, _helpers.translation)('1396');
	          break;
	        case 5:
	          labelText = (0, _helpers.translation)('15297');
	          break;
	        case 6:
	          labelText = isBodyShop ? (0, _helpers.translation)('660') : (0, _helpers.translation)('15298');
	          break;
	        case 7:
	          labelText = (0, _helpers.translation)('416');
	          break;
	        case 8:
	          labelText = (0, _helpers.translation)('13339');
	          break;
	        case 9:
	          labelText = (0, _helpers.translation)('637');
	          break;
	        case 10:
	          labelText = (0, _helpers.translation)('15154');
	          break;
	        case 11:
	          labelText = (0, _helpers.translation)('1396');
	          break;
	        case 12:
	          labelText = (0, _helpers.translation)('15297');
	          break;
	        case 13:
	          labelText = (0, _helpers.translation)('15298');
	          break;
	        default:
	          break;
	      }
	      return labelText;
	    }
	  }, {
	    key: 'renderProductNumberOther',
	    value: function renderProductNumberOther(val, key) {
	      var labelText = this.getLabelText(val);
	
	      return _react2.default.createElement(
	        _grid2.default,
	        { spacing: '1', align: 'center', cols: [2, 1], key: 'pnum_' + key },
	        _react2.default.createElement(
	          'span',
	          null,
	          labelText
	        ),
	        _react2.default.createElement(_text2.default, { size: 'm', name: 'PType' + (this.props.section === 'report' ? val.ProductNumberId : val.PType), value: val.PNumber, onChange: this.onChange, onBlur: this.onBlur })
	      );
	    }
	  }, {
	    key: 'renderProductNumberTFSO',
	    value: function renderProductNumberTFSO(val, key) {
	      var labelText = this.getLabelText(val);
	      var showIcon = val.PExternalName !== null && val.PExternalName !== '' ? true : null;
	
	      return _react2.default.createElement(
	        _grid2.default,
	        { spacing: '1', align: 'center', cols: [2, 1, 2], key: 'pnum_' + key },
	        _react2.default.createElement(
	          'span',
	          null,
	          labelText
	        ),
	        _react2.default.createElement(_text2.default, { size: 'm', name: 'PType' + (this.props.section === 'report' ? val.ProductNumberId : val.PType), value: val.PNumber, onChange: this.onChange, onBlur: this.onBlur, showValidationIcon: showIcon }),
	        _react2.default.createElement(
	          'span',
	          null,
	          val.PExternalName
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.ChainUseStandardProductNumbers === true) return null;
	      if (this.props.section === 'report') {
	        return this.renderProductNumbersReports();
	      }
	      return this.renderProductNumbersOther();
	    }
	  }, {
	    key: 'renderProductNumbersOther',
	    value: function renderProductNumbersOther() {
	      var _this5 = this;
	
	      var isTFSO = this.props.accountingSystem === 5;
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { span: this.state.UseOwnProductNumbers ? isTFSO ? 3 : 2 : 1 },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('18366'), helpText: (0, _helpers.translation)('15307') + ' ' + (0, _helpers.translation)('15308') },
	            _react2.default.createElement(_switch2.default, { labelText: (0, _helpers.translation)('15296'), name: 'UseOwnProductNumbers', checked: this.state.UseOwnProductNumbers, onChange: this.onChange }),
	            this.state.UseOwnProductNumbers && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              this.state.ProductNumber.map(function (val, key) {
	                return isTFSO ? _this5.renderProductNumberTFSO(val, key) : _this5.renderProductNumberOther(val, key);
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderProductNumbersReports',
	    value: function renderProductNumbersReports() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { span: this.state.UseOwnProductNumbers ? 2 : 1 },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('18365'), helpText: (0, _helpers.translation)('15307') + ' ' + (0, _helpers.translation)('15308') },
	            _react2.default.createElement(_switch2.default, { labelText: (0, _helpers.translation)('15296'), name: 'UseOwnProductNumbers', checked: this.state.UseOwnProductNumbers, onChange: this.onChange }),
	            this.state.UseOwnProductNumbers && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              _react2.default.createElement(
	                _grid2.default,
	                { spacing: '1', align: 'center', cols: [2, 1], key: 'pnum_ae' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)(18385)
	                ),
	                _react2.default.createElement(_text2.default, { size: 'm', name: 'WorkHourAEProduct', value: this.state.WorkHourAEProduct, onChange: this.onChange, onBlur: this.onBlur })
	              ),
	              this.state.ProductNumber.map(function (val, key) {
	                return _this6.renderProductNumberOther(val, key);
	              }),
	              _react2.default.createElement(
	                _grid2.default,
	                { spacing: '1', align: 'center', cols: [2, 1], key: 'pnum_tp' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)(15298)
	                ),
	                _react2.default.createElement(_text2.default, { size: 'm', name: 'TotalPriceProduct', value: this.state.TotalPriceProduct, onChange: this.onChange, onBlur: this.onBlur })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductNumbers;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getProductNumbersReport: _settings.getProductNumbersReport, getProductNumbers: _settings.getProductNumbers, saveProductNumbersReport: _settings.saveProductNumbersReport, saveProductNumbers: _settings.saveProductNumbers })(ProductNumbers);

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1465);
	
	var _settings = __webpack_require__(51);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Components
	// import HelpText from '../../../shared/components/HelpText'
	
	// Utils
	
	
	var OrderInspection = function (_Component) {
	  _inherits(OrderInspection, _Component);
	
	  function OrderInspection(props) {
	    _classCallCheck(this, OrderInspection);
	
	    var _this = _possibleConstructorReturn(this, (OrderInspection.__proto__ || Object.getPrototypeOf(OrderInspection)).call(this, props));
	
	    _this.state = {
	      NewItem: {
	        Text: '',
	        Deleted: false
	      },
	      OrderInspection: {
	        ShopId: 0,
	        Active: false,
	        Claim: false,
	        ExternalWork: false,
	        Assessment: false,
	        MissingParts: false,
	        Color: false,
	        ProcessComment: false,
	        Deadline: false,
	        OtherDamage: false,
	        AdditionalInspections: []
	      }
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderInspection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOrderInspectionInformation();
	    }
	  }, {
	    key: 'getOrderInspectionInformation',
	    value: function getOrderInspectionInformation() {
	      var _this2 = this;
	
	      this.props.getOrderInspectionInformation(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          OrderInspection: {
	            ShopId: res.data.ShopId,
	            Active: res.data.Active,
	            Claim: res.data.Claim,
	            ExternalWork: res.data.ExternalWork,
	            Assessment: res.data.Assessment,
	            MissingParts: res.data.MissingParts,
	            Color: res.data.Color,
	            ProcessComment: res.data.ProcessComment,
	            Deadline: res.data.Deadline,
	            OtherDamage: res.data.OtherDamage,
	            AdditionalInspections: res.data.AdditionalInspections
	          } });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'updateOrderInspection',
	    value: function updateOrderInspection(orderInspection) {
	      var _this3 = this;
	
	      return this.props.saveOrderInspectionInformation(orderInspection).then(function (res) {
	        _this3.setState({
	          OrderInspection: {
	            ShopId: res.data.ShopId,
	            Active: res.data.Active,
	            Claim: res.data.Claim,
	            ExternalWork: res.data.ExternalWork,
	            Assessment: res.data.Assessment,
	            MissingParts: res.data.MissingParts,
	            Color: res.data.Color,
	            ProcessComment: res.data.ProcessComment,
	            Deadline: res.data.Deadline,
	            OtherDamage: res.data.OtherDamage,
	            AdditionalInspections: res.data.AdditionalInspections
	          }
	        });
	        return res;
	      }, function (err) {
	        console.log(err);
	        return err;
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.props.saveOrderInspectionInformation(this.state.OrderInspection).then(function () {
	        // Toastr (replace dict. key)
	        // window.toastr.success(translation('1726'), translation('13424'))
	      }, function () {
	        // Toastr (replace dict. key)
	        window.toastr.error((0, _helpers.translation)('1727'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this4 = this;
	
	      e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'radio') {
	        value = e.target.value === 'yes';
	      } else if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      this.setState({
	        OrderInspection: _extends({}, this.state.OrderInspection, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'radio' || e.target.type === 'checkbox') {
	          _this4.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var inspection = this.state.OrderInspection;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'orderinspection__page' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('13423'), helpText: (0, _helpers.translation)('1988') },
	              _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onChange, checked: inspection.Active, labelText: (0, _helpers.translation)('295') }),
	              _react2.default.createElement(_check2.default, { id: 'Claim', name: 'Claim', value: '1', checked: inspection.Claim, onChange: this.onChange, labelText: (0, _helpers.translation)('301') }),
	              this.props.auth.departmentType === 0 && _react2.default.createElement(_check2.default, { id: 'ExternalWork', name: 'ExternalWork', value: '1', checked: inspection.ExternalWork, onChange: this.onChange, labelText: (0, _helpers.translation)('1012') }),
	              _react2.default.createElement(_check2.default, { id: 'Assessment', name: 'Assessment', value: '1', checked: inspection.Assessment, onChange: this.onChange, labelText: (0, _helpers.translation)('801') }),
	              this.props.auth.departmentType === 0 && _react2.default.createElement(_check2.default, { id: 'MissingParts', name: 'MissingParts', value: '1', checked: inspection.MissingParts, onChange: this.onChange, labelText: (0, _helpers.translation)('13456') }),
	              _react2.default.createElement(_check2.default, { id: 'Color', name: 'Color', value: '1', checked: inspection.Color, onChange: this.onChange, labelText: (0, _helpers.translation)('179') }),
	              _react2.default.createElement(_check2.default, { id: 'ProcessComment', name: 'ProcessComment', value: '1', checked: inspection.ProcessComment, onChange: this.onChange, labelText: (0, _helpers.translation)('1729') }),
	              (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && _react2.default.createElement(_check2.default, { id: 'Deadline', name: 'Deadline', value: '1', checked: inspection.Deadline, onChange: this.onChange, labelText: (0, _helpers.translation)('1232') }),
	              this.props.auth.departmentType !== 0 && _react2.default.createElement(_check2.default, { id: 'OtherDamage', name: 'OtherDamage', value: '1', checked: inspection.OtherDamage, onChange: this.onChange, labelText: (0, _helpers.translation)('15188') })
	            )
	          ),
	          (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 24) && this.renderCustomInspections()
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomInspections',
	    value: function renderCustomInspections() {
	      var _this5 = this;
	
	      var cols = ['auto', '48px'];
	      var OrderInspection = this.state.OrderInspection;
	
	      var deleteItem = function deleteItem(key) {
	        var customInspection = _extends({}, _this5.state.OrderInspection);
	        customInspection.AdditionalInspections[key].Deleted = true;
	        _this5.updateOrderInspection(OrderInspection);
	      };
	
	      var renderNew = function renderNew() {
	        var addItem = function addItem() {
	          var OrderInspection = _extends({}, _this5.state.OrderInspection);
	          var newItem = _extends({}, _this5.state.NewItem);
	          OrderInspection.AdditionalInspections.push(newItem);
	          _this5.updateOrderInspection(OrderInspection).then(function (res) {
	            _this5.setState({
	              NewItem: {
	                CustomInspectionId: 0,
	                Text: '',
	                Deleted: false
	              }
	            });
	            // Toastr (replace dict. key)
	            // window.toastr.success(translation('1726'), translation('13424'))
	          }, function () {
	            // Toastr (replace dict. key)
	            window.toastr.error((0, _helpers.translation)('1727'), (0, _helpers.translation)('216'));
	          });
	        };
	
	        var onChange = function onChange(e) {
	          _this5.setState({
	            NewItem: _extends({}, _this5.state.NewItem, _defineProperty({}, e.target.name, e.target.value))
	          });
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, spacing: 1 },
	          _react2.default.createElement(_text2.default, { name: 'Text', value: _this5.state.NewItem.Text, onChange: onChange }),
	          _react2.default.createElement(_addButton2.default, { spacing: 0, onClick: addItem })
	        );
	      };
	
	      var renderCustomInspection = function renderCustomInspection(val, key) {
	        var onChange = function onChange(e) {
	          var inspectionNew = _extends({}, _this5.state.OrderInspection);
	          inspectionNew.AdditionalInspections[key][e.target.name] = e.target.value;
	          _this5.setState({
	            OrderInspection: inspectionNew
	          });
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, key: key, spacing: 1 },
	          _react2.default.createElement(_text2.default, { name: 'Text', defaultValue: val.Text, onChange: onChange, onBlur: _this5.onBlur, key: 'customInspection_' + val.Id, size: 'm' }),
	          _react2.default.createElement(_removeButton2.default, { spacing: 0, onClick: deleteItem.bind(_this5, key), size: 'm' })
	        );
	      };
	
	      return _react2.default.createElement(
	        _col2.default,
	        null,
	        _react2.default.createElement(
	          _panel2.default,
	          { title: (0, _helpers.translation)('1730'), helpText: (0, _helpers.translation)('1989') },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: cols, spacing: 1 },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)('1021')
	              ),
	              _react2.default.createElement('div', null)
	            ),
	            renderNew(),
	            OrderInspection.AdditionalInspections.map(renderCustomInspection)
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderInspection;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrderInspectionInformation: _settings.getOrderInspectionInformation,
	  saveOrderInspectionInformation: _settings.saveOrderInspectionInformation
	})(OrderInspection);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1466);
	
	var _settings = __webpack_require__(51);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	// Actions
	
	
	// Utils
	
	
	var PaintTool = function (_Component) {
	  _inherits(PaintTool, _Component);
	
	  function PaintTool(props) {
	    _classCallCheck(this, PaintTool);
	
	    var _this = _possibleConstructorReturn(this, (PaintTool.__proto__ || Object.getPrototypeOf(PaintTool)).call(this, props));
	
	    _this.state = {
	      PaintTool: 0,
	      Active: false,
	      BodyshopReference: ''
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(PaintTool, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.getPaintToolInformation(this.props.auth.user.ShopId).then(function (_ref) {
	        var _ref$data = _ref.data,
	            PaintTool = _ref$data.PaintTool,
	            Active = _ref$data.Active,
	            BodyshopReference = _ref$data.BodyshopReference;
	
	        _this2.setState({
	          PaintTool: PaintTool,
	          Active: Active,
	          BodyshopReference: BodyshopReference || ''
	        });
	      }).catch(function (err) {
	        console.error('PaintTool settings', err);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this3 = this;
	
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	      var shouldBlur = false;
	
	      if (name === 'PaintTool') {
	        value = parseInt(value);
	
	        if (value === 0 && this.state.Active) {
	          this.setState({
	            Active: false
	          });
	        }
	        shouldBlur = true;
	      } else if (name === 'Active') {
	        if (this.state.PaintTool > 0) {
	          value = value === 'true';
	          shouldBlur = true;
	        } else {
	          value = this.state.Active;
	          window.toastr.error((0, _helpers.translation)('14968'), (0, _helpers.translation)('216'));
	        }
	      }
	
	      this.setState(_defineProperty({}, name, value), function () {
	        if (shouldBlur) {
	          _this3.onBlur();
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      this.props.savePaintToolInformation(this.state).then(function () {
	        // window.toastr.success(translation('14967'), translation('13424'))
	      }).catch(function () {
	        window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          PaintTool = _state.PaintTool,
	          Active = _state.Active,
	          BodyshopReference = _state.BodyshopReference;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'painttool' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(
	              'div',
	              { className: 'white__box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                (0, _helpers.translation)('14965')
	              ),
	              _react2.default.createElement(
	                'form',
	                { className: 'fifty' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control__group radio__custom__outer painttool__system' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    (0, _helpers.translation)('14966')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radio__custom__wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'radio__custom' },
	                      _react2.default.createElement('input', {
	                        type: 'radio',
	                        id: 'NoPaintTool',
	                        name: 'PaintTool',
	                        value: 0,
	                        onChange: this.onChange,
	                        checked: PaintTool === 0 }),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'NoPaintTool' },
	                        (0, _helpers.translation)('433')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'radio__custom' },
	                      _react2.default.createElement('input', {
	                        type: 'radio',
	                        id: 'ChromaWeb',
	                        name: 'PaintTool',
	                        value: 1,
	                        onChange: this.onChange,
	                        checked: PaintTool === 1 }),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'ChromaWeb' },
	                        'ChromaWeb'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control__group radio__custom__outer' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    (0, _helpers.translation)('295')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radio__custom__wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'radio__custom' },
	                      _react2.default.createElement('input', {
	                        type: 'radio',
	                        id: 'Active_yes',
	                        name: 'Active',
	                        value: 'true',
	                        onChange: this.onChange,
	                        checked: Active }),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'Active_yes' },
	                        (0, _helpers.translation)('47')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'radio__custom' },
	                      _react2.default.createElement('input', {
	                        type: 'radio',
	                        id: 'Active_no',
	                        name: 'Active',
	                        value: 'false',
	                        onChange: this.onChange,
	                        checked: !Active }),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'Active_no' },
	                        (0, _helpers.translation)('48')
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control__group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    (0, _helpers.translation)('14969')
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    name: 'BodyshopReference',
	                    value: BodyshopReference,
	                    onChange: this.onChange,
	                    onBlur: this.onBlur })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaintTool;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPaintToolInformation: _settings.getPaintToolInformation,
	  savePaintToolInformation: _settings.savePaintToolInformation
	})(PaintTool);

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _settings = __webpack_require__(51);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	// import Text from '../../../shared/elements/text'
	
	
	// Actions
	
	
	// Utils
	
	
	var ProcessManagement = function (_Component) {
	  _inherits(ProcessManagement, _Component);
	
	  function ProcessManagement(props) {
	    _classCallCheck(this, ProcessManagement);
	
	    var _this = _possibleConstructorReturn(this, (ProcessManagement.__proto__ || Object.getPrototypeOf(ProcessManagement)).call(this, props));
	
	    _this.state = {
	      UseAutoOrderMove: false,
	      UseLoosePartOrderSplit: false,
	      BufferTimeBeforeProduction: 0,
	      BufferTimeDelivery: 0
	    };
	
	    _this.saveSettings = _this.saveSettings.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProcessManagement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.getProcessManagementInformation(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          UseAutoOrderMove: res.data.UseAutoOrderMove,
	          UseLoosePartOrderSplit: res.data.UseLoosePartOrderSplit,
	          BufferTimeBeforeProduction: res.data.BufferTimeBeforeProduction,
	          BufferTimeDelivery: res.data.BufferTimeDelivery
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'saveSettings',
	    value: function saveSettings() {
	      var _this3 = this;
	
	      var _state = this.state,
	          UseAutoOrderMove = _state.UseAutoOrderMove,
	          UseLoosePartOrderSplit = _state.UseLoosePartOrderSplit,
	          BufferTimeBeforeProduction = _state.BufferTimeBeforeProduction,
	          BufferTimeDelivery = _state.BufferTimeDelivery;
	
	
	      var data = {
	        ShopId: this.props.auth.user.ShopId,
	        UseAutoOrderMove: UseAutoOrderMove,
	        UseLoosePartOrderSplit: UseLoosePartOrderSplit,
	        BufferTimeBeforeProduction: BufferTimeBeforeProduction,
	        BufferTimeDelivery: BufferTimeDelivery
	      };
	
	      this.props.saveProcessManagementInformation(data).then(function (res) {
	        _this3.setState({
	          UseAutoOrderMove: res.data.UseAutoOrderMove,
	          UseLoosePartOrderSplit: res.data.UseLoosePartOrderSplit,
	          BufferTimeBeforeProduction: res.data.BufferTimeBeforeProduction,
	          BufferTimeDelivery: res.data.BufferTimeDelivery
	        });
	
	        // Toastr
	        if (res.data.MessageKey === 0) {
	          // window.toastr.success(translation('15258'), translation('13424'))
	        } else {
	          window.toastr.error((0, _helpers.translation)(res.data.MessageKey), (0, _helpers.translation)('216'));
	        }
	      }).catch(function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this4 = this;
	
	      var value = e.target.value;
	      var type = e.target.type;
	      if (type === 'checkbox') {
	        value = e.target.checked;
	      }
	
	      this.setState(_defineProperty({}, e.target.name, value), function () {
	        if (type !== 'text') {
	          _this4.saveSettings();
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.saveSettings();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var bufferTimeOptions = this.getBufferTimeOptions();
	      return _react2.default.createElement(
	        'div',
	        { className: 'forsi__page' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('15252'), helpText: (0, _helpers.translation)('15253') },
	              _react2.default.createElement(_switch2.default, { name: 'UseLoosePartOrderSplit', onChange: this.onChange, checked: this.state.UseLoosePartOrderSplit, labelText: (0, _helpers.translation)('15256'), helpText: (0, _helpers.translation)('15257') }),
	              _react2.default.createElement(_switch2.default, { name: 'UseAutoOrderMove', onChange: this.onChange, checked: this.state.UseAutoOrderMove, labelText: (0, _helpers.translation)('15254'), helpText: (0, _helpers.translation)('15255') })
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('17894'), helpText: (0, _helpers.translation)('17896') },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 17895 },
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  { name: 'BufferTimeBeforeProduction', onChange: this.onChange, value: this.state.BufferTimeBeforeProduction },
	                  Object.keys(bufferTimeOptions).map(function (key) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: Number(key), key: 'BufferTimeBeforeProduction_' + key },
	                      bufferTimeOptions[key]
	                    );
	                  })
	                )
	              ),
	              (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: 18091 },
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  { name: 'BufferTimeDelivery', onChange: this.onChange, value: this.state.BufferTimeDelivery },
	                  Object.keys(bufferTimeOptions).map(function (key) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: Number(key), key: 'BufferTimeDelivery_' + key },
	                      bufferTimeOptions[key]
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getBufferTimeOptions',
	    value: function getBufferTimeOptions() {
	      return {
	        0: '00:00 ' + (0, _helpers.translation)(18296),
	        15: '00:15 ' + (0, _helpers.translation)(18296),
	        30: '00:30 ' + (0, _helpers.translation)(18296),
	        45: '00:45 ' + (0, _helpers.translation)(18296),
	        60: '01:00 ' + (0, _helpers.translation)(18296),
	        75: '01:15 ' + (0, _helpers.translation)(18296),
	        90: '01:30 ' + (0, _helpers.translation)(18296),
	        105: '01:45 ' + (0, _helpers.translation)(18296),
	        120: '02:00 ' + (0, _helpers.translation)(18296),
	        135: '02:15 ' + (0, _helpers.translation)(18296),
	        150: '02:30 ' + (0, _helpers.translation)(18296),
	        165: '02:45 ' + (0, _helpers.translation)(18296),
	        180: '03:00 ' + (0, _helpers.translation)(18296),
	        195: '03:15 ' + (0, _helpers.translation)(18296),
	        210: '03:30 ' + (0, _helpers.translation)(18296),
	        225: '03:45 ' + (0, _helpers.translation)(18296),
	        240: '04:00 ' + (0, _helpers.translation)(18296),
	        255: '04:15 ' + (0, _helpers.translation)(18296),
	        270: '04:30 ' + (0, _helpers.translation)(18296),
	        285: '04:45 ' + (0, _helpers.translation)(18296),
	        300: '05:00 ' + (0, _helpers.translation)(18296),
	        315: '05:15 ' + (0, _helpers.translation)(18296),
	        330: '05:30 ' + (0, _helpers.translation)(18296),
	        345: '05:45 ' + (0, _helpers.translation)(18296),
	        360: '06:00 ' + (0, _helpers.translation)(18296),
	        375: '06:15 ' + (0, _helpers.translation)(18296),
	        390: '06:30 ' + (0, _helpers.translation)(18296),
	        405: '06:45 ' + (0, _helpers.translation)(18296),
	        420: '07:00 ' + (0, _helpers.translation)(18296),
	        435: '07:15 ' + (0, _helpers.translation)(18296),
	        450: '07:30 ' + (0, _helpers.translation)(18296),
	        465: '07:45 ' + (0, _helpers.translation)(18296),
	        480: '08:00 ' + (0, _helpers.translation)(18296),
	        1440: '24 ' + (0, _helpers.translation)('542') + ' (1 ' + (0, _helpers.translation)('18105') + ')',
	        2880: '48 ' + (0, _helpers.translation)('542') + ' (2 ' + (0, _helpers.translation)('503') + ')',
	        4320: '72 ' + (0, _helpers.translation)('542') + ' (3 ' + (0, _helpers.translation)('503') + ')',
	        5760: '96 ' + (0, _helpers.translation)('542') + ' (4 ' + (0, _helpers.translation)('503') + ')',
	        7200: '120 ' + (0, _helpers.translation)('542') + ' (5 ' + (0, _helpers.translation)('503') + ')',
	        8640: '144 ' + (0, _helpers.translation)('542') + ' (6 ' + (0, _helpers.translation)('503') + ')',
	        10080: '168 ' + (0, _helpers.translation)('542') + ' (7 ' + (0, _helpers.translation)('503') + ')',
	        11520: '192 ' + (0, _helpers.translation)('542') + ' (8 ' + (0, _helpers.translation)('503') + ')',
	        12960: '216 ' + (0, _helpers.translation)('542') + ' (9 ' + (0, _helpers.translation)('503') + ')',
	        14400: '240 ' + (0, _helpers.translation)('542') + ' (10 ' + (0, _helpers.translation)('503') + ')'
	      };
	    }
	  }]);
	
	  return ProcessManagement;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getProcessManagementInformation: _settings.getProcessManagementInformation,
	  saveProcessManagementInformation: _settings.saveProcessManagementInformation
	})(ProcessManagement);

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _settings = __webpack_require__(51);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _percent = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Actions
	
	
	// Components
	
	
	var ProcessTimeDamagetype = {
	  RepairDamage: 0,
	  InstallationDamage: 1
	};
	
	var BufferTimeDistribution = function (_Component) {
	  _inherits(BufferTimeDistribution, _Component);
	
	  function BufferTimeDistribution(props) {
	    _classCallCheck(this, BufferTimeDistribution);
	
	    var _this = _possibleConstructorReturn(this, (BufferTimeDistribution.__proto__ || Object.getPrototypeOf(BufferTimeDistribution)).call(this, props));
	
	    _this.gridCols = '1fr 96px 96px'; // [ 1, 1, 1 ]
	    _this.state = {
	      BufferTimeDistributionResponse: {
	        BufferTimeDistributions: [],
	        MessagesKey: 0
	      },
	
	      BufferTimeDistributionInfo: {
	        BufferTimeDistributionId: 0,
	        CompanyId: 0,
	        BeforePaint: null,
	        AfterPaint: null,
	        Damagetype: 0
	      }
	    };
	
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(BufferTimeDistribution, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderBufferTimeDistribution();
	    }
	  }, {
	    key: 'renderBufferTimeDistribution',
	    value: function renderBufferTimeDistribution() {
	      var _this2 = this;
	
	      this.props.getBufferTimeDistribution().then(function (res) {
	        console.log('res', res);
	        _this2.setState({
	          BufferTimeDistributionResponse: res.data
	        });
	      }, function (error) {
	        console.log(error);
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      var _this3 = this;
	
	      var BufferTimeDistributionInfo = this.state.BufferTimeDistributionInfo;
	      if (BufferTimeDistributionInfo) {
	        this.props.saveBufferTimeDistribution(BufferTimeDistributionInfo).then(function (res) {
	          console.log('res', res);
	          if (res.data.MessagesKey === 0) {
	            // window.toastr.success(translation('18088'), translation('13424'))
	          } else {
	            window.toastr.error((0, _helpers.translation)('18085'), (0, _helpers.translation)('216'));
	          }
	          _this3.setState({
	            BufferTimeDistributionResponse: res.data
	          });
	        }, function (error) {
	          console.log(error);
	        });
	      }
	    }
	  }, {
	    key: 'getDamageTypeName',
	    value: function getDamageTypeName(typeNme) {
	      switch (typeNme) {
	        case ProcessTimeDamagetype.RepairDamage:
	          return (0, _helpers.translation)('14828'); // Repair damage
	        case ProcessTimeDamagetype.InstallationDamage:
	          return (0, _helpers.translation)('14784'); // Installation damage
	      }
	    }
	  }, {
	    key: 'transformValue',
	    value: function transformValue(value, toClean) {
	      return (0, _percent.transformPercent)(value, toClean);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var BufferTimeDistributions = this.state.BufferTimeDistributionResponse.BufferTimeDistributions;
	
	      var renderBufferTime = function renderBufferTime(val, key) {
	        var onChange = function onChange(e) {
	          var _extends2;
	
	          var editedBuffer = _this4.state.BufferTimeDistributionResponse.BufferTimeDistributions;
	          if (e.target.value !== '') {
	            var value = parseInt(e.target.value);
	            if (value > 99999999) value = 99999999;
	            editedBuffer[key][e.target.name] = value;
	          } else {
	            editedBuffer[key][e.target.name] = '';
	          }
	          _this4.setState({
	            BufferTimeDistributionInfo: _extends({}, _this4.state.BufferTimeDistributionInfo, (_extends2 = {
	              BufferTimeDistributionId: editedBuffer[key].BufferTimeDistributionId,
	              CompanyId: editedBuffer[key].CompanyId
	            }, _defineProperty(_extends2, e.target.name, e.target.value), _defineProperty(_extends2, 'Damagetype', editedBuffer[key].Damagetype), _extends2))
	          });
	        };
	
	        var size = 'm';
	        var damageType = _this4.getDamageTypeName(val.Damagetype);
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: _this4.gridCols, rowSpan: '3', align: 'center', key: key },
	          _react2.default.createElement(
	            'div',
	            null,
	            damageType
	          ),
	          _react2.default.createElement(_DecimalInput2.default, { name: 'BeforePaint', value: val.BeforePaint, onChange: onChange, onBlur: _this4.onBlur, decimals: 0, transformValue: _this4.transformValue, size: size }),
	          _react2.default.createElement(_DecimalInput2.default, { name: 'AfterPaint', value: val.AfterPaint, onChange: onChange, onBlur: _this4.onBlur, decimals: 0, transformValue: _this4.transformValue, size: size })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: this.gridCols, align: 'center' },
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('16478') }),
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('18087'), helpText: (0, _helpers.translation)('18092') }),
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('18089'), helpText: (0, _helpers.translation)('18093') })
	        ),
	        BufferTimeDistributions && BufferTimeDistributions.map(renderBufferTime)
	      );
	    }
	  }]);
	
	  return BufferTimeDistribution;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getBufferTimeDistribution: _settings.getBufferTimeDistribution,
	  saveBufferTimeDistribution: _settings.saveBufferTimeDistribution
	})(BufferTimeDistribution);

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1467);
	
	var _settings = __webpack_require__(51);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _null = __webpack_require__(236);
	
	var _null2 = _interopRequireDefault(_null);
	
	var _BufferTimeDistribution = __webpack_require__(971);
	
	var _BufferTimeDistribution2 = _interopRequireDefault(_BufferTimeDistribution);
	
	var _auth = __webpack_require__(8);
	
	var _percent = __webpack_require__(178);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Components
	// import HelpText from '../../../shared/components/HelpText'
	
	
	// Utils
	
	
	var Process = function (_Component) {
	  _inherits(Process, _Component);
	
	  function Process(props) {
	    _classCallCheck(this, Process);
	
	    var _this = _possibleConstructorReturn(this, (Process.__proto__ || Object.getPrototypeOf(Process)).call(this, props));
	
	    _this.gridCols = '1fr 96px 96px'; // [ 1, 1, 1 ]
	    _this.state = {
	      ShopId: 0,
	      PaintShopProcess: undefined,
	      BodyShopProcess: {
	        SmallDamage: undefined,
	        BigDamage: undefined,
	        HourlyPrice: 0,
	        DefaultMinutes: 0,
	        MaterialPart: 0,
	        BodyShopGainFactor: 0,
	        SparePartShare: 0,
	        BodyShopDefaultLeadTime: null
	      },
	      ProcessTimeOnOrderBrick: false
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBodyShopChange = _this.onBodyShopChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onBodyShopBlur = _this.onBodyShopBlur.bind(_this);
	    _this.onDefaultLeadTimeChange = _this.onDefaultLeadTimeChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Process, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createTemplates();
	      this.getProcessTimeInformation();
	    }
	  }, {
	    key: 'createTemplates',
	    value: function createTemplates() {
	      var processTemplate = {
	        ProcessTimes: [{
	          CompanyId: 0,
	          Fixed: 0,
	          Variable: 0,
	          share: 0,
	          Step: 101,
	          CompanyDepartment: 0,
	          Id: 0
	        }, {
	          CompanyId: 0,
	          Fixed: 0,
	          Variable: 0,
	          share: 0,
	          Step: 102,
	          CompanyDepartment: 0,
	          Id: 0
	        }, {
	          CompanyId: 0,
	          Fixed: 0,
	          Variable: 0,
	          share: 0,
	          Step: 103,
	          CompanyDepartment: 0,
	          Id: 0
	        }, {
	          CompanyId: 0,
	          Fixed: 0,
	          Variable: 0,
	          share: 0,
	          Step: 104,
	          CompanyDepartment: 0,
	          Id: 0
	        }]
	      };
	      this.setState({
	        ShopId: 0,
	        BodyShopProcess: {
	          SmallDamageProcess: processTemplate,
	          BigDamageProcess: processTemplate,
	          HourlyPrice: 0,
	          MaterialPart: 0,
	          DefaultMinutes: 0,
	          BigDamage: 0,
	          BodyShopGainFactor: 0,
	          SparePartShare: 0,
	          BodyShopDefaultLeadTime: null
	        },
	        PaintShopProcess: {
	          ProcessTimes: [{
	            CompanyId: 0,
	            Fixed: 0,
	            Variable: 0,
	            share: 0,
	            Step: 2,
	            CompanyDepartment: 0,
	            Id: 0
	          }, {
	            CompanyId: 0,
	            Fixed: 0,
	            Variable: 0,
	            share: 0,
	            Step: 3,
	            CompanyDepartment: 0,
	            Id: 0
	          }, {
	            CompanyId: 0,
	            Fixed: 0,
	            Variable: 0,
	            share: 0,
	            Step: 4,
	            CompanyDepartment: 0,
	            Id: 0
	          }, {
	            CompanyId: 0,
	            Fixed: 0,
	            Variable: 0,
	            share: 0,
	            Step: 5,
	            CompanyDepartment: 0,
	            Id: 0
	          }, {
	            CompanyId: 0,
	            Fixed: 0,
	            Variable: 0,
	            share: 0,
	            Step: 6,
	            CompanyDepartment: 0,
	            Id: 0
	          }],
	          ShareSum: 100,
	          HourlyPrice: 0,
	          MaterialPart: 0,
	          GainFactor: 0,
	          DefaultMinutes: 0,
	          TimeOnWorkcard: false,
	          PriceOnWorkcard: false
	        }
	      });
	    }
	  }, {
	    key: 'getProcessTimeInformation',
	    value: function getProcessTimeInformation() {
	      var _this2 = this;
	
	      this.props.getProcessTimeInformation(this.props.auth.user.ShopId).then(function (res) {
	        var paintProcess = res.data.PaintShopProcess;
	        var bodyProcess = res.data.BodyShopProcess;
	        if (paintProcess !== null) {
	          _this2.setState({
	            ShopId: res.data.ShopId,
	            PaintShopProcess: _extends({}, _this2.state.PaintShopProcess, {
	              HourlyPrice: res.data.PaintShopProcess.HourlyPrice,
	              MaterialPart: res.data.PaintShopProcess.MaterialPart,
	              GainFactor: res.data.PaintShopProcess.GainFactor,
	              DefaultMinutes: res.data.PaintShopProcess.DefaultMinutes,
	              TimeOnWorkcard: res.data.PaintShopProcess.TimeOnWorkcard,
	              PriceOnWorkcard: res.data.PaintShopProcess.PriceOnWorkcard,
	              ProcessTimes: res.data.PaintShopProcess.ProcessTimes,
	              ShareSum: res.data.PaintShopProcess.ShareSum
	            })
	          });
	        }
	        if (bodyProcess !== null) {
	          _this2.setState({
	            ShopId: res.data.ShopId,
	            BodyShopProcess: _extends({}, _this2.state.BodyShopProcess, {
	              SmallDamageProcess: {
	                ProcessTimes: res.data.BodyShopProcess.SmallDamageProcess.ProcessTimes,
	                ShareSum: res.data.BodyShopProcess.SmallDamageProcess.ShareSum
	              },
	              BigDamageProcess: {
	                ProcessTimes: res.data.BodyShopProcess.BigDamageProcess.ProcessTimes,
	                ShareSum: res.data.BodyShopProcess.BigDamageProcess.ShareSum
	              },
	              HourlyPrice: res.data.BodyShopProcess.HourlyPrice,
	              MaterialPart: res.data.BodyShopProcess.MaterialPart,
	              DefaultMinutes: res.data.BodyShopProcess.DefaultMinutes,
	              BigDamage: res.data.BodyShopProcess.BigDamage,
	              BodyShopGainFactor: res.data.BodyShopProcess.BodyShopGainFactor,
	              SparePartShare: res.data.BodyShopProcess.SparePartShare,
	              BodyShopDefaultLeadTime: res.data.BodyShopProcess.BodyShopDefaultLeadTime
	            })
	          });
	        }
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      if (e.persist) e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'radio') {
	        value = e.target.value === 'yes';
	      }
	      this.setState({
	        PaintShopProcess: _extends({}, this.state.PaintShopProcess, _defineProperty({}, e.target.name, parseInt(value)))
	      });
	    }
	  }, {
	    key: 'onBodyShopChange',
	    value: function onBodyShopChange(e) {
	      if (e.persist) e.persist();
	      var value = e.target.value;
	
	      if (e.target.name === 'SparePartShare') {
	        value = parseInt(value);
	        if (isNaN(value)) {
	          value = this.state.BodyShopProcess[e.target.name];
	        }
	        if (value < 0 || value > 100) {
	          window.toastr.error((0, _helpers.translation)('15175'), (0, _helpers.translation)('216'));
	          if (value < 0) value = 0;
	          if (value > 100) value = 100;
	        }
	      }
	      this.setState({
	        BodyShopProcess: _extends({}, this.state.BodyShopProcess, _defineProperty({}, e.target.name, value))
	      });
	    }
	  }, {
	    key: 'onDefaultLeadTimeChange',
	    value: function onDefaultLeadTimeChange(e) {
	      var value = e.target.value;
	      value = parseInt(value);
	
	      if (isNaN(value)) {
	        value = '';
	      }
	      if (value === '' || value < 1 || value > 99) {
	        window.toastr.error((0, _helpers.translation)('18340'), (0, _helpers.translation)('216'));
	      }
	      this.setState({
	        BodyShopProcess: _extends({}, this.state.BodyShopProcess, _defineProperty({}, e.target.name, value))
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this3 = this;
	
	      var allProcesses = {
	        ShopId: this.state.ShopId,
	        PaintShopProcess: this.state.PaintShopProcess
	        // BodyShopProcess: this.state.BodyShopProcess
	      };
	
	      this.props.saveProcessTimeInformation(allProcesses).then(function (res) {
	        // Toastr (replace dict. key)
	        if (res.data.PaintShopProcess.ShareSum === 100) {
	          // window.toastr.success(translation('1713'), translation('13424'))
	        } else {
	          window.toastr.error((0, _helpers.translation)('1715'), (0, _helpers.translation)('216'));
	        }
	        _this3.setState({
	          PaintShopProcess: _extends({}, _this3.state.PaintShopProcess, {
	            ShareSum: res.data.PaintShopProcess.ShareSum
	          })
	        });
	      }, function () {
	        // Toastr (replace dict. key)
	        window.toastr.error((0, _helpers.translation)('1714'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onBodyShopBlur',
	    value: function onBodyShopBlur(e) {
	      var _this4 = this;
	
	      var processTime = {
	        ShopId: this.state.ShopId,
	        BodyShopProcess: this.state.BodyShopProcess
	      };
	
	      this.props.saveProcessTimeInformation(processTime).then(function (res) {
	        // Toastr (replace dict. key)
	        if (res.data.Errors.length > 0) {
	          var errors = res.data.Errors;
	          var errorText = '';
	          errors.map(function (item) {
	            if (item.DictionaryKey !== 0) {
	              errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	            }
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	        } else {
	          if (res.data.BodyShopProcess.SmallDamageProcess.ShareSum === 100 && res.data.BodyShopProcess.BigDamageProcess.ShareSum === 100) {
	            // window.toastr.success(translation('1713'), translation('13424'))
	          } else {
	            window.toastr.error((0, _helpers.translation)('1715'), (0, _helpers.translation)('216'));
	          }
	        }
	        _this4.setState({
	          BodyShopProcess: _extends({}, _this4.state.BodyShopProcess, {
	            SmallDamageProcess: _extends({}, _this4.state.BodyShopProcess.SmallDamageProcess, {
	              ShareSum: res.data.BodyShopProcess.SmallDamageProcess.ShareSum
	            }),
	            BigDamageProcess: _extends({}, _this4.state.BodyShopProcess.BigDamageProcess, {
	              ShareSum: res.data.BodyShopProcess.BigDamageProcess.ShareSum
	            }),
	            BodyShopDefaultLeadTime: res.data.BodyShopProcess.BodyShopDefaultLeadTime
	          })
	        });
	      }, function (err) {
	        console.log('err', err);
	        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	          var errors = err.response.data.Errors;
	          var errorText = '';
	          errors.map(function (item) {
	            if (item.DictionaryKey !== 0) {
	              errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	            }
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('1714'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      if (this.state.BodyShopProcess === undefined && this.state.PaintShopProcess === undefined) return null;
	      if (this.state.BodyShopProcess.SmallDamageProcess === undefined) return null;
	      if (this.state.BodyShopProcess.BigDamageProcess === undefined) return null;
	
	      var PaintShopProcess = this.state.PaintShopProcess;
	      var BodyShopProcess = this.state.BodyShopProcess;
	
	
	      var gainFactor = '';
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 19) || PaintShopProcess === null) {
	        gainFactor = _react2.default.createElement(_text2.default, {
	          name: 'GainFactor',
	          value: PaintShopProcess.GainFactor,
	          onChange: this.onChange,
	          onBlur: this.onBlur,
	          labelText: (0, _helpers.translation)('13484'),
	          helpText: (0, _helpers.translation)('1994')
	        });
	      }
	
	      var bodyshopGainFactor = '';
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 19) || BodyShopProcess === null) {
	        bodyshopGainFactor = _react2.default.createElement(_text2.default, {
	          name: 'BodyShopGainFactor',
	          value: BodyShopProcess.BodyShopGainFactor,
	          onChange: this.onBodyShopChange,
	          onBlur: this.onBodyShopBlur,
	          labelText: (0, _helpers.translation)('13484'),
	          helpText: (0, _helpers.translation)('1994')
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        BodyShopProcess !== null && (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            { span: '2' },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('788') },
	              _react2.default.createElement(
	                _null2.default,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'title' },
	                  _react2.default.createElement('img', { src: '/images/svgs/bodyshop-steps/bodywork-2.svg' }),
	                  (0, _helpers.translation)('788')
	                )
	              ),
	              _react2.default.createElement(_DecimalInput2.default, {
	                name: 'SparePartShare',
	                value: BodyShopProcess.SparePartShare,
	                onChange: this.onBodyShopChange,
	                onBlur: this.onBodyShopBlur,
	                decimals: 0,
	                transformValue: this.transformValue,
	                labelText: (0, _helpers.translation)('15044') + ' (%)',
	                helpText: (0, _helpers.translation)('15110')
	              }),
	              _react2.default.createElement(_divider2.default, null),
	              this.renderSmallDamageProcessTimes(),
	              BodyShopProcess.SmallDamageProcess.ShareSum !== 100 && _react2.default.createElement(
	                _grid2.default,
	                { cols: '1fr 96px', align: 'center' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)('1717')
	                ),
	                _react2.default.createElement(_text2.default, { value: BodyShopProcess.SmallDamageProcess.ShareSum + '%', disabled: true })
	              ),
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              this.renderBigDamageProcessTimes(),
	              BodyShopProcess.BigDamageProcess.ShareSum !== 100 && _react2.default.createElement(
	                _grid2.default,
	                { cols: '1fr 96px', align: 'center' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)('1717')
	                ),
	                _react2.default.createElement(_text2.default, { value: BodyShopProcess.BigDamageProcess.ShareSum + '%', disabled: true })
	              )
	            ),
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('18086') },
	              _react2.default.createElement(_BufferTimeDistribution2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('14782') },
	              _react2.default.createElement(_text2.default, {
	                name: 'HourlyPrice',
	                value: BodyShopProcess.HourlyPrice,
	                onChange: this.onBodyShopChange,
	                onBlur: this.onBodyShopBlur,
	                labelText: (0, _helpers.translation)('419'),
	                helpText: (0, _helpers.translation)('1992')
	              }),
	              _react2.default.createElement(_DecimalInput2.default, {
	                name: 'MaterialPart',
	                value: BodyShopProcess.MaterialPart,
	                onChange: this.onBodyShopChange,
	                onBlur: this.onBodyShopBlur,
	                decimals: 0,
	                transformValue: this.transformValue,
	                labelText: (0, _helpers.translation)('15045'),
	                helpText: (0, _helpers.translation)('1993')
	              }),
	              _react2.default.createElement(_text2.default, {
	                name: 'DefaultMinutes',
	                value: BodyShopProcess.DefaultMinutes,
	                onChange: this.onBodyShopChange,
	                onBlur: this.onBodyShopBlur,
	                labelText: (0, _helpers.translation)('13485'),
	                helpText: (0, _helpers.translation)('1995')
	              }),
	              _react2.default.createElement(_divider2.default, null),
	              bodyshopGainFactor
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('18342') },
	              _react2.default.createElement(_text2.default, {
	                name: 'BodyShopDefaultLeadTime',
	                value: BodyShopProcess.BodyShopDefaultLeadTime,
	                onChange: this.onDefaultLeadTimeChange,
	                onBlur: this.onBodyShopBlur,
	                labelText: (0, _helpers.translation)('503')
	              })
	            )
	          )
	        ),
	        PaintShopProcess !== null && (this.props.auth.departmentType === 0 || this.props.auth.departmentType === 2) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            { span: '2' },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('161') },
	              _react2.default.createElement(
	                _null2.default,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'title' },
	                  _react2.default.createElement('img', { src: '/images/svgs/workscreen/coating.svg' }),
	                  (0, _helpers.translation)('161')
	                )
	              ),
	              this.renderPaintShopProcessTimes(),
	              PaintShopProcess.ShareSum !== 100 && _react2.default.createElement(
	                _grid2.default,
	                { cols: '1fr 96px', align: 'center' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)('1717')
	                ),
	                _react2.default.createElement(_text2.default, { value: PaintShopProcess.ShareSum + '%', disabled: true })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('14782') },
	              _react2.default.createElement(_text2.default, {
	                name: 'HourlyPrice',
	                value: PaintShopProcess.HourlyPrice,
	                onChange: this.onChange,
	                onBlur: this.onBlur,
	                labelText: (0, _helpers.translation)('419'),
	                helpText: (0, _helpers.translation)('1992')
	              }),
	              _react2.default.createElement(_DecimalInput2.default, {
	                name: 'MaterialPart',
	                value: PaintShopProcess.MaterialPart,
	                onChange: this.onChange,
	                onBlur: this.onBlur,
	                decimals: 0,
	                transformValue: this.transformValue,
	                labelText: (0, _helpers.translation)('13483'),
	                helpText: (0, _helpers.translation)('1993')
	              }),
	              _react2.default.createElement(_text2.default, {
	                name: 'DefaultMinutes',
	                value: PaintShopProcess.DefaultMinutes,
	                onChange: this.onChange,
	                onBlur: this.onBlur,
	                labelText: (0, _helpers.translation)('13485'),
	                helpText: (0, _helpers.translation)('1995')
	              }),
	              _react2.default.createElement(_divider2.default, null),
	              gainFactor
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'calcStepNameAndImage',
	    value: function calcStepNameAndImage(step) {
	      if (!step) return { stepName: step };
	
	      switch (step) {
	        case 101:
	          return {
	            stepName: (0, _helpers.translation)('617'),
	            image: '/images/svgs/workscreen/demount.svg'
	          };
	        case 102:
	          return {
	            stepName: (0, _helpers.translation)('618'),
	            image: '/images/svgs/workscreen/reparation.svg'
	          };
	        case 103:
	          return {
	            stepName: (0, _helpers.translation)('619'),
	            image: '/images/svgs/workscreen/mount.svg'
	          };
	        case 104:
	          return {
	            stepName: (0, _helpers.translation)('162'),
	            image: '/images/svgs/workscreen/clean.svg'
	          };
	      }
	    }
	  }, {
	    key: 'renderSmallDamageProcessTimes',
	    value: function renderSmallDamageProcessTimes() {
	      var _this5 = this;
	
	      var renderProcessTime = function renderProcessTime(val, key) {
	        var onChange = function onChange(e) {
	          var processNew = _extends({}, _this5.state.BodyShopProcess.SmallDamageProcess);
	          if (e.target.value !== '') {
	            var value = parseInt(e.target.value);
	            if (value > 99999999) value = 99999999;
	            processNew.ProcessTimes[key][e.target.name] = value;
	          } else {
	            processNew.ProcessTimes[key][e.target.name] = '';
	          }
	          _this5.setState({
	            BodyShopProcess: _extends({}, _this5.state.BodyShopProcess, {
	              SmallDamageProcess: processNew
	            })
	          });
	        };
	
	        var size = 'm';
	        // console.log(this.calcStepNameAndImage(val.Step))
	
	        var _calcStepNameAndImage = _this5.calcStepNameAndImage(val.Step),
	            stepName = _calcStepNameAndImage.stepName;
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: _this5.gridCols, rowSpan: '3', align: 'center', key: key },
	          _react2.default.createElement(
	            'div',
	            null,
	            stepName
	          ),
	          _react2.default.createElement(_text2.default, { name: 'Fixed', value: val.Fixed, onChange: onChange, onBlur: _this5.onBodyShopBlur, size: size }),
	          _react2.default.createElement(_DecimalInput2.default, { name: 'share', value: val.share, onChange: onChange, onBlur: _this5.onBodyShopBlur, decimals: 0, transformValue: _this5.transformValue, size: size })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: this.gridCols, align: 'center' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('14828') },
	            _react2.default.createElement(
	              'div',
	              { className: 'undertext' },
	              '(' + (0, _helpers.translation)('15044') + ' <' + this.state.BodyShopProcess.SparePartShare + '%)'
	            )
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('1195'), helpText: (0, _helpers.translation)('1990') },
	            '\u200B'
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('1716') + ' (%)', helpText: (0, _helpers.translation)('1991') },
	            '\u200B'
	          )
	        ),
	        this.state.BodyShopProcess.SmallDamageProcess.ProcessTimes.map(renderProcessTime)
	      );
	    }
	  }, {
	    key: 'renderBigDamageProcessTimes',
	    value: function renderBigDamageProcessTimes() {
	      var _this6 = this;
	
	      var renderProcessTime = function renderProcessTime(val, key) {
	        var onChange = function onChange(e) {
	          var processNew = _extends({}, _this6.state.BodyShopProcess.BigDamageProcess);
	          if (e.target.value !== '') {
	            var value = parseInt(e.target.value);
	            if (value > 99999999) value = 99999999;
	            processNew.ProcessTimes[key][e.target.name] = value;
	          } else {
	            processNew.ProcessTimes[key][e.target.name] = '';
	          }
	          _this6.setState({
	            BodyShopProcess: _extends({}, _this6.state.BodyShopProcess, {
	              BigDamageProcess: processNew
	            })
	          });
	        };
	
	        var size = 'm';
	
	        var _calcStepNameAndImage2 = _this6.calcStepNameAndImage(val.Step),
	            stepName = _calcStepNameAndImage2.stepName;
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: _this6.gridCols, rowSpan: '3', align: 'center', key: key },
	          _react2.default.createElement(
	            'div',
	            null,
	            stepName
	          ),
	          _react2.default.createElement(_text2.default, { name: 'Fixed', value: val.Fixed, onChange: onChange, onBlur: _this6.onBodyShopBlur, size: size }),
	          _react2.default.createElement(_DecimalInput2.default, { name: 'share', value: val.share, onChange: onChange, onBlur: _this6.onBodyShopBlur, decimals: 0, transformValue: _this6.transformValue, size: size })
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: this.gridCols, align: 'center' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('14784') },
	            _react2.default.createElement(
	              'div',
	              { className: 'undertext' },
	              '(' + (0, _helpers.translation)('15044') + ' >' + this.state.BodyShopProcess.SparePartShare + '%)'
	            )
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('1195'), helpText: (0, _helpers.translation)('1990') },
	            '\u200B'
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('1716') + ' (%)', helpText: (0, _helpers.translation)('1991') },
	            '\u200B'
	          )
	        ),
	        this.state.BodyShopProcess.BigDamageProcess.ProcessTimes.map(renderProcessTime)
	      );
	    }
	  }, {
	    key: 'renderPaintShopProcessTimes',
	    value: function renderPaintShopProcessTimes() {
	      var _this7 = this;
	
	      if (this.state.PaintShopProcess === null) return null;
	      var renderProcessTime = function renderProcessTime(val, key) {
	        var onChange = function onChange(e) {
	          var processNew = _extends({}, _this7.state.PaintShopProcess);
	          if (e.target.value !== '') {
	            processNew.ProcessTimes[key][e.target.name] = parseInt(e.target.value);
	          } else {
	            processNew.ProcessTimes[key][e.target.name] = '';
	          }
	          _this7.setState({
	            PaintShopProcess: processNew
	          });
	        };
	
	        var size = 'm';
	
	        var stepName = val.step;
	        // let image
	        switch (val.Step) {
	          case 2:
	            stepName = (0, _helpers.translation)('96');
	            // image = '/images/svgs/workscreen/pretreatment.svg'
	            break;
	          case 3:
	            stepName = (0, _helpers.translation)('160');
	            // image = '/images/svgs/workscreen/filler.svg'
	            break;
	          case 4:
	            stepName = (0, _helpers.translation)('158');
	            // image = '/images/svgs/workscreen/sanding.svg'
	            break;
	          case 5:
	            stepName = (0, _helpers.translation)('161');
	            // image = '/images/svgs/workscreen/coating.svg'
	            break;
	          case 6:
	            stepName = (0, _helpers.translation)('162');
	            // image = '/images/svgs/workscreen/preparing.svg'
	            break;
	        }
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: _this7.gridCols, rowSpan: '3', key: key, align: 'center' },
	          _react2.default.createElement(
	            'div',
	            null,
	            stepName
	          ),
	          _react2.default.createElement(_text2.default, { name: 'Fixed', value: val.Fixed, onChange: onChange, onBlur: _this7.onBlur, size: size }),
	          _react2.default.createElement(_DecimalInput2.default, { name: 'share', value: val.share, onChange: onChange, onBlur: _this7.onBlur, decimals: 0, transformValue: _this7.transformValue, size: size })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: this.gridCols, align: 'center' },
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('946') }),
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('1195'), helpText: (0, _helpers.translation)('1990') }),
	          _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('1716') + ' (%)', helpText: (0, _helpers.translation)('1991') })
	        ),
	        this.state.PaintShopProcess.ProcessTimes.map(renderProcessTime)
	      );
	    }
	  }, {
	    key: 'transformValue',
	    value: function transformValue(value, toClean) {
	      return (0, _percent.transformPercent)(value, toClean);
	    }
	  }]);
	
	  return Process;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getProcessTimeInformation: _settings.getProcessTimeInformation,
	  saveProcessTimeInformation: _settings.saveProcessTimeInformation
	})(Process);

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _settings = __webpack_require__(51);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	
	// Utils
	
	
	var PunchClock = function (_Component) {
	  _inherits(PunchClock, _Component);
	
	  function PunchClock(props) {
	    _classCallCheck(this, PunchClock);
	
	    var _this = _possibleConstructorReturn(this, (PunchClock.__proto__ || Object.getPrototypeOf(PunchClock)).call(this, props));
	
	    _this.state = {
	      PunchClock: {
	        ShopId: 0,
	        Active: false,
	        // ManuelPunchIn: false,
	        PunchInVia: 0,
	        IpRestriction: ''
	      }
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(PunchClock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPunchClockInformation();
	    }
	  }, {
	    key: 'getPunchClockInformation',
	    value: function getPunchClockInformation() {
	      var _this2 = this;
	
	      this.props.getPunchClockInformation(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          PunchClock: {
	            ShopId: res.data.ShopId,
	            Active: res.data.Active,
	            // ManuelPunchIn: res.data.ManuelPunchIn,
	            PunchInVia: res.data.PunchInVia,
	            IpRestriction: res.data.IpRestriction
	          } });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this3 = this;
	
	      e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      if (e.target.name === 'PunchInVia') {
	        value = parseInt(e.target.value);
	      }
	      this.setState({
	        PunchClock: _extends({}, this.state.PunchClock, _defineProperty({}, e.target.name, value))
	      }, function () {
	        if (e.target.type === 'checkbox' || e.target.name === 'PunchInVia') {
	          _this3.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      this.props.savePunchClockInformation(this.state.PunchClock).then(function () {
	        // Toastr (replace dict. key)
	        // window.toastr.success(translation('1720'), translation('13424'))
	      }, function () {
	        // Toastr (replace dict. key)
	        window.toastr.error((0, _helpers.translation)('1721'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      var PunchClock = this.state.PunchClock;
	
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('437') },
	            _react2.default.createElement(_switch2.default, { name: 'Active', onChange: this.onChange, checked: PunchClock.Active, labelText: (0, _helpers.translation)('295') }),
	            PunchClock.Active && [_react2.default.createElement(
	              _labelWrapper2.default,
	              { key: 'PunchInVia', labelText: (0, _helpers.translation)('16676'), helpText: (0, _helpers.translation)('1986') },
	              _react2.default.createElement(_radio2.default, { name: 'PunchInVia', value: '0', onChange: this.onChange, checked: PunchClock.PunchInVia === 0, labelText: (0, _helpers.translation)('16677') }),
	              _react2.default.createElement(_radio2.default, { name: 'PunchInVia', value: '1', onChange: this.onChange, checked: PunchClock.PunchInVia === 1, labelText: (0, _helpers.translation)('16678') }),
	              _react2.default.createElement(_radio2.default, { name: 'PunchInVia', value: '2', onChange: this.onChange, checked: PunchClock.PunchInVia === 2, labelText: (0, _helpers.translation)('16679') })
	            ), _react2.default.createElement(_text2.default, { key: 'IpRestriction', name: 'IpRestriction', value: PunchClock.IpRestriction || '', onChange: this.onChange, onBlur: this.onBlur, labelText: (0, _helpers.translation)('553'), helpText: (0, _helpers.translation)('1987') })]
	          )
	        )
	      );
	    }
	  }]);
	
	  return PunchClock;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPunchClockInformation: _settings.getPunchClockInformation,
	  savePunchClockInformation: _settings.savePunchClockInformation
	})(PunchClock);

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _settings = __webpack_require__(51);
	
	var _helpers = __webpack_require__(2);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Actions
	
	
	// Utils
	
	
	var SupportAccess = function (_Component) {
	  _inherits(SupportAccess, _Component);
	
	  function SupportAccess(props) {
	    _classCallCheck(this, SupportAccess);
	
	    var _this = _possibleConstructorReturn(this, (SupportAccess.__proto__ || Object.getPrototypeOf(SupportAccess)).call(this, props));
	
	    _this.state = {
	      SupportAccessInfo: {
	        SupportTeams: [],
	        AllowSupportAccess: false
	      }
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SupportAccess, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSupportAccess();
	    }
	  }, {
	    key: 'getSupportAccess',
	    value: function getSupportAccess() {
	      var _this2 = this;
	
	      this.props.getSupportAccess(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          SupportAccessInfo: res.data
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'saveSupportAccess',
	    value: function saveSupportAccess() {
	      var _this3 = this;
	
	      var supportaccessInfo = _extends({}, this.state.SupportAccessInfo);
	      this.props.saveSupportAccess(supportaccessInfo).then(function (res) {
	        _this3.setState({
	          SupportAccessInfo: res.data
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _setState,
	          _this4 = this;
	
	      var value = e.target.checked;
	      this.setState((_setState = {}, _defineProperty(_setState, e.target.name, value), _defineProperty(_setState, 'SupportAccessInfo', _extends({}, this.state.SupportAccessInfo, {
	        AllowSupportAccess: value
	      })), _setState), function () {
	        _this4.saveSupportAccess();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var supportTeams = this.state.SupportAccessInfo.SupportTeams;
	      var allowSupportAccess = this.state.SupportAccessInfo.AllowSupportAccess;
	      var renderSupportTeam = function renderSupportTeam(val, key) {
	        return _react2.default.createElement(
	          _label2.default,
	          { size: 'm', key: key },
	          val.ChainName
	        );
	      };
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('17967') },
	            _react2.default.createElement(_switch2.default, { labelText: (0, _helpers.translation)('17968'), helpText: (0, _helpers.translation)('17969'), checked: allowSupportAccess, name: 'SupportAccess', onChange: this.onChange }),
	            _react2.default.createElement(
	              _label2.default,
	              { size: 'm' },
	              (0, _helpers.translation)('18039')
	            ),
	            _react2.default.createElement('br', null),
	            supportTeams.map(renderSupportTeam)
	          )
	        )
	      );
	    }
	  }]);
	
	  return SupportAccess;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getSupportAccess: _settings.getSupportAccess,
	  saveSupportAccess: _settings.saveSupportAccess
	})(SupportAccess);

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1468);
	
	var _settings = __webpack_require__(51);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Components
	
	
	// Utils
	
	
	var ViewSettings = function (_Component) {
	  _inherits(ViewSettings, _Component);
	
	  function ViewSettings(props) {
	    _classCallCheck(this, ViewSettings);
	
	    var _this = _possibleConstructorReturn(this, (ViewSettings.__proto__ || Object.getPrototypeOf(ViewSettings)).call(this, props));
	
	    _this.state = {
	      ViewSetting: {
	        ShopId: 0,
	        DateOnOrder: false,
	        TimeOnOrderList: true,
	        NewOrdersGrouping: 0
	      }
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(ViewSettings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getViewSettings(this.props);
	    }
	  }, {
	    key: 'getViewSettings',
	    value: function getViewSettings(props) {
	      var _this2 = this;
	
	      this.props.getViewSettings(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          ViewSetting: res.data
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'saveViewSetting',
	    value: function saveViewSetting(e) {
	      var _this3 = this;
	
	      var viewSetting = _extends({}, this.state.ViewSetting);
	      // update
	      this.props.saveViewSettings(viewSetting).then(function (res) {
	        _this3.setState({
	          ViewSetting: res.data
	        });
	        // Toastr
	        // window.toastr.success(translation('15040'), translation('13424'))
	        // console.log('dateOnOrder', this.state.ViewSetting.DateOnOrder)
	      }, function (err) {
	        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	          var errors = err.response.data.Errors;
	          var errorText = '';
	          errors.map(function (item) {
	            if (item.DictionaryKey !== 0) {
	              errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	            }
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this4 = this;
	
	      e.persist();
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value,
	          checked = _e$target.checked,
	          type = _e$target.type;
	
	
	      if (type === 'checkbox') {
	        value = name === 'DateOnOrder' ? !checked : checked;
	      }
	
	      this.setState({
	        ViewSetting: _extends({}, this.state.ViewSetting, _defineProperty({}, name, value))
	      }, function () {
	        _this4.saveViewSetting();
	      });
	    }
	  }, {
	    key: 'renderDateSetting',
	    value: function renderDateSetting() {
	      var ViewSetting = this.state.ViewSetting;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('14792') },
	        _react2.default.createElement(_switch2.default, {
	          name: 'DateOnOrder',
	          onChange: this.onChange,
	          checked: !ViewSetting.DateOnOrder,
	          labelText: (0, _helpers.translation)('2221'),
	          helpText: (0, _helpers.translation)('15076')
	        })
	      );
	    }
	  }, {
	    key: 'renderTimeSetting',
	    value: function renderTimeSetting() {
	      var ViewSetting = this.state.ViewSetting;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('14876') },
	        _react2.default.createElement(_switch2.default, {
	          name: 'TimeOnOrderList',
	          onChange: this.onChange,
	          checked: ViewSetting.TimeOnOrderList,
	          labelText: (0, _helpers.translation)('15039'),
	          helpText: (0, _helpers.translation)('15077')
	        })
	      );
	    }
	  }, {
	    key: 'renderWorkscreen',
	    value: function renderWorkscreen() {
	      if (this.props.auth.departmentType !== 1) return null;
	
	      var ViewSetting = this.state.ViewSetting;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('18') },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('16584') },
	          _react2.default.createElement(_radio2.default, { name: 'NewOrdersGrouping', value: 0, checked: ViewSetting.NewOrdersGrouping === 0, onChange: this.onChange, labelText: (0, _helpers.translation)('16585') }),
	          _react2.default.createElement(_radio2.default, { name: 'NewOrdersGrouping', value: 1, checked: ViewSetting.NewOrdersGrouping === 1, onChange: this.onChange, labelText: (0, _helpers.translation)('16586') })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 20)) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'forsi__page' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderDateSetting(),
	            this.renderTimeSetting(),
	            this.renderWorkscreen()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ViewSettings;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getViewSettings: _settings.getViewSettings,
	  saveViewSettings: _settings.saveViewSettings
	})(ViewSettings);

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	__webpack_require__(1469);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _Contact = __webpack_require__(965);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _PunchClock = __webpack_require__(973);
	
	var _PunchClock2 = _interopRequireDefault(_PunchClock);
	
	var _Forsi = __webpack_require__(966);
	
	var _Forsi2 = _interopRequireDefault(_Forsi);
	
	var _Invoicing = __webpack_require__(425);
	
	var _Invoicing2 = _interopRequireDefault(_Invoicing);
	
	var _ClosingDays = __webpack_require__(963);
	
	var _ClosingDays2 = _interopRequireDefault(_ClosingDays);
	
	var _Process = __webpack_require__(972);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _OrderInspection = __webpack_require__(968);
	
	var _OrderInspection2 = _interopRequireDefault(_OrderInspection);
	
	var _Booking = __webpack_require__(957);
	
	var _Booking2 = _interopRequireDefault(_Booking);
	
	var _Delivery = __webpack_require__(229);
	
	var _Delivery2 = _interopRequireDefault(_Delivery);
	
	var _ChainNotification = __webpack_require__(962);
	
	var _ChainNotification2 = _interopRequireDefault(_ChainNotification);
	
	var _ViewSettings = __webpack_require__(975);
	
	var _ViewSettings2 = _interopRequireDefault(_ViewSettings);
	
	var _PaintTool = __webpack_require__(969);
	
	var _PaintTool2 = _interopRequireDefault(_PaintTool);
	
	var _CarRental = __webpack_require__(961);
	
	var _CarRental2 = _interopRequireDefault(_CarRental);
	
	var _ProcessManagement = __webpack_require__(970);
	
	var _ProcessManagement2 = _interopRequireDefault(_ProcessManagement);
	
	var _BookingPortal = __webpack_require__(956);
	
	var _BookingPortal2 = _interopRequireDefault(_BookingPortal);
	
	var _CarOwnerPortal = __webpack_require__(960);
	
	var _CarOwnerPortal2 = _interopRequireDefault(_CarOwnerPortal);
	
	var _SupportAccess = __webpack_require__(974);
	
	var _SupportAccess2 = _interopRequireDefault(_SupportAccess);
	
	var _CompanyStyling = __webpack_require__(964);
	
	var _CompanyStyling2 = _interopRequireDefault(_CompanyStyling);
	
	var _CarOwnerNotification = __webpack_require__(959);
	
	var _CarOwnerNotification2 = _interopRequireDefault(_CarOwnerNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	// import { getContactInformation } from '../../actions/settings'
	
	// import styles
	
	
	// Utils
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Views
	
	
	var Settings = function (_Component) {
	  _inherits(Settings, _Component);
	
	  function Settings(props) {
	    _classCallCheck(this, Settings);
	
	    var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));
	
	    _this.state = {
	      valid: [{
	        name: 'contact'
	      }, {
	        name: 'punchclock'
	      }, {
	        name: 'forsi'
	      }, {
	        name: 'invoicing'
	      }, {
	        name: 'closingdays'
	      }, {
	        name: 'process'
	      }, {
	        name: 'orderinspection'
	      }, {
	        name: 'booking'
	      }, {
	        name: 'delivery'
	      }, {
	        name: 'chainnotification'
	      }, {
	        name: 'viewsetting'
	      }, {
	        name: 'painttool'
	      }, {
	        name: 'carrental'
	      }, {
	        name: 'processmanagement'
	      }, {
	        name: 'bookingportal'
	      }, {
	        name: 'carownerportal'
	      }, {
	        name: 'companystyling'
	      }, {
	        name: 'carownernotification'
	      }, {
	        name: 'supportaccess'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Settings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.isValidPage()) {
	        this.props.router.push('/settings');
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.isValidPage()) {
	        this.props.router.push('/settings');
	      }
	    }
	  }, {
	    key: 'isValidPage',
	    value: function isValidPage() {
	      var _this2 = this;
	
	      var valid = true;
	      var found = false;
	      if (typeof this.props.params.type !== 'undefined') {
	        this.state.valid.map(function (val, key) {
	          if (val.name === _this2.props.params.type) {
	            found = true;
	          }
	        });
	        if (!found) {
	          valid = false;
	        }
	      }
	      return valid;
	    }
	  }, {
	    key: 'leftMenu',
	    value: function leftMenu() {
	      var renderMenuItem = function renderMenuItem(to, label, classDefault) {
	        var renderLink = function renderLink(linkLabel, className, activeClass) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: to,
	              className: className + (classDefault ? ' ' + classDefault : ''),
	              activeClassName: activeClass
	            },
	            linkLabel
	          );
	        };
	
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: label,
	          renderLabel: renderLink,
	          key: to
	        });
	      };
	
	      var isEmployeeOrShopOwner = (0, _auth.hasAccess)([3, 7], this.props.auth.user.UserType);
	      var assessmentSystemText = null;
	      switch (this.props.auth.permissions.ChainAssessmentSystem) {
	        case 1:
	          assessmentSystemText = (0, _helpers.translation)('13438');
	          break;
	        case 2:
	          assessmentSystemText = (0, _helpers.translation)('17930');
	          break;
	        default:
	          break;
	      }
	
	      return [
	      // <div>
	      //   <ul>
	      isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 11) && renderMenuItem('/settings/contact', (0, _helpers.translation)('346')), isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 11) && renderMenuItem('/settings/booking', (0, _helpers.translation)('13373')), (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 11) && renderMenuItem('/settings/closingdays', (0, _helpers.translation)('504')), this.props.auth.hasPartner && this.props.auth.departmentType === 1 && isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && renderMenuItem('/settings/processmanagement', (0, _helpers.translation)('15251')), isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20, [19, 12]) && renderMenuItem('/settings/punchclock', (0, _helpers.translation)('437')), isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && renderMenuItem('/settings/orderinspection', (0, _helpers.translation)('13423')),
	      /* this.props.auth.departmentType !== 1 && */isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20, 11) && renderMenuItem('/settings/process', (0, _helpers.translation)('165')), isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 11) && this.props.auth.permissions.ChainAssessmentSystem > 0 && renderMenuItem('/settings/forsi', assessmentSystemText), isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 6) && renderMenuItem('/settings/invoicing', (0, _helpers.translation)('13486')),
	      /* <li><Link to='/settings/partners' activeClassName='active'>{translation('649')}</Link></li> */
	      this.props.auth.departmentType !== 1 && isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20, 11) && renderMenuItem('/settings/delivery', (0, _helpers.translation)('196')), (0, _auth.hasAccess)([2], this.props.auth.user.UserType) && renderMenuItem('/settings/chainnotification', (0, _helpers.translation)('2214')), isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20, 11) && renderMenuItem('/settings/viewsetting', (0, _helpers.translation)('14791')), this.props.auth.departmentType !== 1 && this.props.auth.permissions.ChainAllowPaintTool > 0 && isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 11) && renderMenuItem('/settings/painttool', (0, _helpers.translation)('14965')), isEmployeeOrShopOwner && this.props.auth.departmentType !== 0 && (0, _auth.hasSubscriptionPermission)(this.props.auth, 20, 11) && renderMenuItem('/settings/carrental', (0, _helpers.translation)('14778')), isEmployeeOrShopOwner && this.props.auth.permissions.AllowBookingPortal === true && renderMenuItem('/settings/bookingportal', (0, _helpers.translation)('16681')), isEmployeeOrShopOwner && this.props.auth.permissions.AllowCarOwnerPortal === true && renderMenuItem('/settings/carownerportal', (0, _helpers.translation)('18152')), isEmployeeOrShopOwner && this.props.auth.permissions.AllowCarOwnerPortal === true && this.props.auth.permissions.CarOwnerPortalEnabled === true && renderMenuItem('/settings/carownernotification', (0, _helpers.translation)('18186')), isEmployeeOrShopOwner && (this.props.auth.permissions.AllowCarOwnerPortal === true || this.props.auth.permissions.AllowBookingPortal === true) && renderMenuItem('/settings/companystyling', (0, _helpers.translation)('18188')), isEmployeeOrShopOwner && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 33) && renderMenuItem('/settings/supportaccess', (0, _helpers.translation)('17967'))
	      //   </ul>
	      // </div>
	      ];
	    }
	  }, {
	    key: 'renderHeaderTitle',
	    value: function renderHeaderTitle() {
	      return (0, _helpers.translation)('6');
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      // console.log('this.props.params.type', this.props.params.type)
	      switch (this.props.params.type) {
	        case 'contact':
	          return _react2.default.createElement(_Contact2.default, null);
	        case 'punchclock':
	          return _react2.default.createElement(_PunchClock2.default, null);
	        case 'forsi':
	          return _react2.default.createElement(_Forsi2.default, null);
	        case 'invoicing':
	          return _react2.default.createElement(_Invoicing2.default, null);
	        case 'closingdays':
	          return _react2.default.createElement(_ClosingDays2.default, null);
	        case 'process':
	          return _react2.default.createElement(_Process2.default, null);
	        case 'orderinspection':
	          return _react2.default.createElement(_OrderInspection2.default, null);
	        case 'booking':
	          return _react2.default.createElement(_Booking2.default, null);
	        case 'delivery':
	          return _react2.default.createElement(_Delivery2.default, { type: 'shop' });
	        case 'chainnotification':
	          return _react2.default.createElement(_ChainNotification2.default, null);
	        case 'viewsetting':
	          return _react2.default.createElement(_ViewSettings2.default, null);
	        case 'painttool':
	          return _react2.default.createElement(_PaintTool2.default, null);
	        case 'carrental':
	          return _react2.default.createElement(_CarRental2.default, null);
	        case 'processmanagement':
	          return _react2.default.createElement(_ProcessManagement2.default, null);
	        case 'bookingportal':
	          return _react2.default.createElement(_BookingPortal2.default, null);
	        case 'carownerportal':
	          return _react2.default.createElement(_CarOwnerPortal2.default, null);
	        case 'carownernotification':
	          return _react2.default.createElement(_CarOwnerNotification2.default, null);
	        case 'supportaccess':
	          return _react2.default.createElement(_SupportAccess2.default, null);
	        case 'companystyling':
	          return _react2.default.createElement(_CompanyStyling2.default, null);
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'settings__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: false, hideInactiveCheck: true },
	          this.leftMenu()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'settings__screen--inner clearfix' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Settings;
	}(_react.Component);
	
	Settings.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Settings);

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _shopowners = __webpack_require__(282);
	
	var _auth = __webpack_require__(68);
	
	var _helpers = __webpack_require__(2);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(1470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	
	// Styles
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'edit',
	      shopowner: {
	        UserId: 0,
	        ChainId: _this.props.auth.user.ChainId,
	        Active: true,
	        Name: '',
	        UserName: '',
	        Phone: '',
	        PhoneCode: _this.props.phonecode,
	        IsInvoicingUser: false,
	        IsUnlimitedSupportActive: false,
	        Shops: []
	      },
	      shoplist: [],
	      shoplistsearch: ''
	    };
	    _this.searchList = _this.searchList.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.saveAddShopOwner = _this.saveAddShopOwner.bind(_this);
	    _this.adminShop = _this.adminShop.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getShopOwner(this.props);
	      this.getShopList(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.item.UserId !== this.props.item.UserId || nextProps.auth.user.ChainId !== this.props.auth.user.ChainId) {
	        this.getShopOwner(nextProps); // item.UserId
	        this.getShopList(nextProps); // auth.user.ChainId
	      }
	    }
	  }, {
	    key: 'getShopOwner',
	    value: function getShopOwner(props) {
	      var _this2 = this;
	
	      if (typeof props.item.UserId !== 'undefined') {
	        props.getShopOwner(props.item.UserId).then(function (res) {
	          _this2.setState({
	            type: 'edit',
	            shopowner: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'getShopList',
	    value: function getShopList(props) {
	      var _this3 = this;
	
	      if (typeof props.auth.user.ChainId !== 'undefined') {
	        props.getShopList(props.auth.user.ChainId).then(function (res) {
	          _this3.setState({
	            shoplist: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        shopowner: {
	          UserId: 0,
	          ChainId: this.props.auth.user.ChainId,
	          Active: true,
	          Name: '',
	          UserName: '',
	          Phone: '',
	          PhoneCode: this.props.phonecode,
	          IsInvoicingUser: false,
	          IsUnlimitedSupportActive: false,
	          Shops: []
	        }
	      });
	    }
	  }, {
	    key: 'loginAs',
	    value: function loginAs(id, shopId, support, impersonate) {
	      var _this4 = this;
	
	      this.props.loginAs(id, shopId, support, impersonate).then(function (res) {
	        _this4.props.router.push('/');
	      }, function (err) {
	        console.log('Nooooo, could not login', err.response.data);
	      });
	    }
	  }, {
	    key: 'saveAddShopOwner',
	    value: function saveAddShopOwner(e) {
	      var _this5 = this;
	
	      var shopowner = this.state.shopowner;
	      // update
	      if (shopowner.UserId > 0) {
	        this.props.CreateSaveShopOwner(shopowner).then(function (res) {
	          _this5.props.onSave(res.data, _this5.state.type);
	          _this5.setState({
	            shopowner: res.data
	          });
	        }, function (err) {
	          if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	            var errors = err.response.data.Errors;
	            var errText = '';
	            errors.map(function (item) {
	              if (item.DictionaryKey !== 0) {
	                errText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	              }
	            });
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          } else {
	            var errorMessage = function errorMessage(error) {
	              var messageText = '';
	              if (error < 5) {
	                messageText += (0, _helpers.translation)('2145');
	              }
	              if (messageText !== '') messageText += ' ';
	              switch (error) {
	                case 1:
	                  messageText += (0, _helpers.translation)('16329');
	                  break;
	                case 2:
	                  messageText += (0, _helpers.translation)('16336');
	                  break;
	                case 3:
	                  messageText += (0, _helpers.translation)('16335');
	                  break;
	                case 4:
	                  messageText += (0, _helpers.translation)('16338');
	                  break;
	                case 5:
	                  messageText += (0, _helpers.translation)('16337');
	                  break;
	                default:
	                  break;
	              }
	              messageText += '<br>';
	              return messageText;
	            };
	            var _errors = err.response.data;
	            if (Array.isArray(_errors)) {
	              var message = _errors.map(function (error) {
	                return errorMessage(error);
	              });
	              window.toastr.error(message, (0, _helpers.translation)('216'));
	            } else {
	              window.toastr.error((0, _helpers.translation)('17954'), (0, _helpers.translation)('216'));
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'removeShop',
	    value: function removeShop(id) {
	      this.adminShop(undefined, id);
	    }
	  }, {
	    key: 'adminShop',
	    value: function adminShop(e, id) {
	      var _this6 = this;
	
	      var value = 0;
	      if (e === undefined) {
	        value = id;
	      } else {
	        value = e.target.value;
	      }
	      var shopowner = this.state.shopowner;
	      var shop = {
	        UserId: shopowner.UserId,
	        ShopId: value
	      };
	      this.props.updateShop(shop).then(function (res) {
	        _this6.getShopOwner(_this6.props);
	      }, function () {
	        // Toastr
	        window.toastr.error((0, _helpers.translation)('13465'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this7 = this;
	
	      e.persist();
	      var name = '';
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        // if (typeof e === 'undefined') {
	        //   e = name
	        // }
	        name = e.target.name;
	        value = e.target.value;
	      }
	      this.setState({
	        shopowner: _extends({}, this.state.shopowner, _defineProperty({}, name, value))
	      }, function () {
	        if (e.target.name === 'shops') _this7.adminShop();
	      });
	    }
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(name, e) {
	      var _this8 = this;
	
	      var value = '';
	      value = name.target.value;
	      if (name.target.name === 'PhoneNumber') {
	        this.setState({
	          shopowner: _extends({}, this.state.shopowner, {
	            Phone: name.target.value
	          })
	        });
	      } else {
	        this.setState({
	          shopowner: _extends({}, this.state.shopowner, {
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        }, function () {
	          _this8.saveAddShopOwner();
	        });
	      }
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      var _this9 = this;
	
	      var value = e.target.value;
	      var name = e.target.name;
	      if (e.target.type === 'radio') value = e.target.value === 'yes';
	      if (e.target.type === 'checkbox') value = e.target.checked;
	      this.setState({
	        shopowner: _extends({}, this.state.shopowner, _defineProperty({}, name, value))
	      }, function () {
	        _this9.saveAddShopOwner();
	      });
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      this.setState({
	        shoplistsearch: e.target.value
	      });
	    }
	  }, {
	    key: 'renderOwner',
	    value: function renderOwner() {
	      var shopowner = this.state.shopowner;
	      var impersonate = true;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: 1880 },
	        _react2.default.createElement(_text2.default, { name: 'Name', value: shopowner.Name || '', onChange: this.onInputChange, onBlur: this.saveAddShopOwner, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('38') },
	          _react2.default.createElement(_Phone2.default, {
	            onChange: this.onPhoneChange,
	            code: shopowner.PhoneCode,
	            number: shopowner.Phone,
	            onBlur: this.saveAddShopOwner })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'Email', value: shopowner.Email || '', onChange: this.onInputChange, onBlur: this.saveAddShopOwner, labelText: (0, _helpers.translation)('1052') }),
	        _react2.default.createElement(_text2.default, { name: 'UserName', value: shopowner.UserName || '', onChange: this.onInputChange, onBlur: this.saveAddShopOwner, labelText: (0, _helpers.translation)('1') }),
	        _react2.default.createElement(_switch2.default, { name: 'Active', checked: shopowner.Active, onChange: this.onRadioChange, labelText: (0, _helpers.translation)('295') }),
	        shopowner.UserId > 0 && shopowner.CanImpersonate && _react2.default.createElement(_button2.default, { onClick: this.loginAs.bind(this, shopowner.UserId, 0, false, impersonate), style: 'link', labelText: (0, _helpers.translation)('57') })
	      );
	    }
	  }, {
	    key: 'renderOwnerInvoiceSettings',
	    value: function renderOwnerInvoiceSettings() {
	      // 18394 = invoicing user
	      // 18395 = unlimited support
	      var shopowner = this.state.shopowner;
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: 18393 },
	        _react2.default.createElement(_switch2.default, { name: 'IsInvoicingUser', checked: shopowner.IsInvoicingUser, onChange: this.onRadioChange, labelText: 18394 }),
	        _react2.default.createElement(_switch2.default, { name: 'IsUnlimitedSupportActive', checked: shopowner.IsUnlimitedSupportActive, onChange: this.onRadioChange, labelText: 18395 })
	      );
	    }
	  }, {
	    key: 'renderShops',
	    value: function renderShops() {
	      var _this10 = this;
	
	      var shopowner = this.state.shopowner;
	      var renderShops = function renderShops(val, key) {
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true, key: key },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            val.Name
	          ),
	          _react2.default.createElement(_removeButton2.default, { minus: true, onClick: _this10.removeShop.bind(_this10, val.Id), size: 'm' })
	        );
	      };
	      var renderShopList = function renderShopList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.ShopId },
	          val.ShopName
	        );
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1861') },
	        shopowner.Shops.map(renderShops),
	        _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], block: true },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: 'shops', onChange: this.adminShop, value: 0 },
	            _react2.default.createElement(
	              'option',
	              { value: 0 },
	              (0, _helpers.translation)('890'),
	              ' ',
	              (0, _helpers.translation)('700')
	            ),
	            this.state.shoplist.filter(function (x) {
	              return x.Active;
	            }).map(renderShopList)
	          ),
	          _react2.default.createElement(_addButton2.default, null)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classNameList = this.state.type === 'edit' ? 'view_edit' : 'view_create';
	      return _react2.default.createElement(
	        'div',
	        { className: classNameList },
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderOwner(),
	          this.renderOwnerInvoiceSettings()
	        ),
	        this.state.shopowner.UserId > 0 && _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderShops()
	        )
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getShopOwner: _shopowners.getShopOwner,
	  CreateSaveShopOwner: _shopowners.CreateSaveShopOwner,
	  getShopList: _shopowners.getShopList,
	  updateShop: _shopowners.updateShop,
	  loginAs: _auth.loginAs
	}, null, { withRef: true })(View);

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _shopowners = __webpack_require__(282);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1471);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _CreateUser = __webpack_require__(197);
	
	var _CreateUser2 = _interopRequireDefault(_CreateUser);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _View = __webpack_require__(977);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	
	// Actions
	
	
	// Utils
	
	
	// import styles
	
	
	// import components
	
	
	// Elements
	
	
	// Views
	
	
	var ShopOwners = function (_Component) {
	  _inherits(ShopOwners, _Component);
	
	  function ShopOwners(props) {
	    _classCallCheck(this, ShopOwners);
	
	    var _this = _possibleConstructorReturn(this, (ShopOwners.__proto__ || Object.getPrototypeOf(ShopOwners)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      search: '',
	      includeInactive: false,
	      shopowners: [],
	      activeItem: {},
	      includeNonVerified: false
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(ShopOwners, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getShopOwners();
	    }
	  }, {
	    key: 'getShopOwners',
	    value: function getShopOwners() {
	      var _this2 = this;
	
	      this.props.getShopOwners(this.props.auth.user.ChainId).then(function (res) {
	        _this2.setState({
	          shopowners: res.data
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', ariaText: (0, _helpers.translation)('2054'), labelText: (0, _helpers.translation)(1797), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({
	          search: e.target.value
	        });
	      }
	      if (e.target.name === 'Inactive') {
	        this.setState({
	          includeInactive: e.target.checked
	        });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      // if (key.Name !== null) {
	      if (key.Name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.Active : true)) {
	        return true;
	      }
	      return false;
	      // }
	      // return false
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var shopowners = [].concat(_toConsumableArray(this.state.shopowners));
	      var activeItem = void 0;
	      if (type === 'create') {
	        shopowners.push({
	          UserId: data.UserId,
	          Name: data.Name,
	          Active: data.Active,
	          Email: data.Email,
	          Confirmed: false
	        });
	        type = 'item';
	        activeItem = {
	          UserId: data.UserId,
	          Confirmed: false
	        };
	      } else {
	        shopowners.map(function (val, key) {
	          if (val.UserId === data.UserId) {
	            val.Name = data.Name;
	            val.Active = data.Active;
	            val.Email = data.Email;
	            val.Confirmed = data.Confirmed;
	          }
	        });
	        type = 'item';
	        if (data.Confirmed) {
	          activeItem = {
	            UserId: data.UserId,
	            Confirmed: true
	          };
	        } else {
	          activeItem = {
	            UserId: data.UserId,
	            Name: data.Name,
	            Email: data.Email,
	            Confirmed: data.Confirmed
	          };
	        }
	      }
	      this.setState({
	        shopowners: shopowners,
	        view: type,
	        activeItem: activeItem
	      });
	      // Toastr
	      // window.toastr.success(translation('13464'), translation('13424'))
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.create.getWrappedInstance().createUser();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return [_react2.default.createElement(
	        'div',
	        { key: 'confirmedfilter', className: 'filter' },
	        _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { isFixed: true },
	          _react2.default.createElement(_check2.default, {
	            name: 'NonVerified',
	            checked: this.state.includeNonVerified,
	            onChange: function onChange() {
	              _this3.setState({ includeNonVerified: !_this3.state.includeNonVerified });
	            },
	            labelText: (0, _helpers.translation)('16320'),
	            spacing: 0
	          })
	        )
	      )].concat(_toConsumableArray(this.state.shopowners.map(function (so) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: so.Name,
	          onClick: function onClick() {
	            return _this3.onSelectItem(so);
	          },
	          selected: so.UserId === _this3.state.activeItem.UserId,
	          inactive: !so.Active,
	          confirmed: so.Confirmed,
	          key: so.UserId
	        });
	      })));
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this4 = this;
	
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	          return _react2.default.createElement(_CreateUser2.default, { isShopOwner: true, ref: 'create', title: (0, _helpers.translation)('2054'), user: undefined, onSuccess: function onSuccess(res) {
	              return _this4.onSave(res, 'create');
	            } });
	        case 'item':
	          if (this.state.activeItem.Confirmed !== true) return _react2.default.createElement(_CreateUser2.default, { isShopOwner: true, user: this.state.activeItem, title: (0, _helpers.translation)('2054'), onSuccess: function onSuccess(res) {
	              return _this4.onSave(res, 'item');
	            } });
	          return _react2.default.createElement(_View2.default, { router: this.props.router, ref: 'view', item: this.state.activeItem, onSave: this.onSave });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var customFilter = function customFilter(item, showInactive) {
	        // Include any items not confirmed if using this filter
	        if (_this5.state.includeNonVerified && !item.confirmed) {
	          return true;
	        }
	        if (showInactive) {
	          // Exclude unconfirmed
	          return item.confirmed;
	        }
	        return !item.inactive;
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'shop-owners__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: function renderRight() {
	            return _this5.headerButtonsRight();
	          } }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create', customFilter: customFilter },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'customers__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return ShopOwners;
	}(_react.Component);
	
	ShopOwners.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getShopOwners: _shopowners.getShopOwners })(ShopOwners);

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _shops = __webpack_require__(79);
	
	var _auth = __webpack_require__(68);
	
	var _customers = __webpack_require__(74);
	
	var _common = __webpack_require__(25);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	__webpack_require__(1472);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	// import HelpText from '../../../shared/components/HelpText'
	
	// Elements
	
	
	// Styles
	
	
	// Utils
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'create',
	      previousSelectedShopId: 0,
	      premiumShoplist: [],
	      paintShoplist: [],
	      allSubscriptions: [],
	      companyCustomers: [],
	      shop: {
	        Active: true,
	        Address: '',
	        Alias: '',
	        CountryId: 0,
	        CVR: '',
	        VendorId: '',
	        VendorCode: '',
	        ChainId: _this.props.auth.user.ChainId,
	        City: '',
	        CompanyName: '',
	        Email: '',
	        Partners: [],
	        // PermissionModules: [],
	        PhoneCode: _this.props.phonecode,
	        SubscriptionId: null,
	        PhoneNumber: '',
	        ShopId: 0,
	        ShopType: 0,
	        TakseringType: 0,
	        UserId: 0,
	        UserName: '',
	        ZipCode: '',
	        Region: '',
	        SubscriptionType: 0,
	        PNumber: '',
	        ChainUseStandardProductNumbers: true,
	        IsTestAccount: false,
	        IncludeInStatistics: true,
	        MemberType: 0,
	        ProductionType: 0,
	        DbsActive: false,
	        DBSWorkshopNumber: null,
	        ShopCustomerId: null,
	        DracarCompanyID: null
	      },
	      statistics: {
	        active: true
	      },
	      ShopOwners: [],
	      Employees: [],
	      SupportUsers: [],
	      Confirm: {
	        Show: false,
	        IsPermission: false,
	        target: {
	          value: '',
	          name: '',
	          checked: false
	        }
	      },
	      selectedPartner: 0,
	      paintPartner: 0,
	      paintPartnerCustomer: 0
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    // this.onModuleCheck = this.onModuleCheck.bind(this)
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.onPhoneBlur = _this.onPhoneBlur.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.onMemberTypeChange = _this.onMemberTypeChange.bind(_this);
	    _this.saveAddShop = _this.saveAddShop.bind(_this);
	    _this.addShop = _this.addShop.bind(_this);
	    _this.confirm = _this.confirm.bind(_this);
	    _this.notConfirm = _this.notConfirm.bind(_this);
	    _this.changePaintPartner = _this.changePaintPartner.bind(_this);
	    _this.getPaintPartnerCustomers = _this.getPaintPartnerCustomers.bind(_this);
	    _this.getSubscriptions = _this.getSubscriptions.bind(_this);
	    _this.getShopCustomersIfChainUseDBS = _this.getShopCustomersIfChainUseDBS.bind(_this);
	    // this.adminPartners = this.adminPartners.bind(this)
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getShopCustomersIfChainUseDBS(this.props);
	      this.getShopInfoes(this.props);
	      this.getPremiumShops(this.props);
	      this.getPaintShops(this.props);
	      this.getSubscriptions();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.getShopCustomersIfChainUseDBS(nextProps);
	      this.getShopInfoes(nextProps);
	      this.getPremiumShops(nextProps);
	      this.getPaintShops(nextProps);
	      this.getPaintPartnerCustomers(nextProps);
	    }
	  }, {
	    key: 'getSubscriptions',
	    value: function getSubscriptions() {
	      var _this2 = this;
	
	      this.props.getSubscriptions().then(function (res) {
	        _this2.setState({
	          allSubscriptions: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getShopInfoes',
	    value: function getShopInfoes(props) {
	      var _this3 = this;
	
	      if (typeof props.item.ShopId !== 'undefined') {
	        props.getShop(props.item.ShopId).then(function (res) {
	          var shop = res.data;
	          var paintPartner = 0;
	
	          for (var i = 0; shop.Partners.length > i; i++) {
	            if (shop.Partners[i].PartnerType === 1) {
	              paintPartner = shop.Partners[i];
	              i = shop.length;
	            }
	          }
	          _this3.setState({
	            type: 'edit',
	            shop: shop,
	            paintPartner: paintPartner !== 0 ? paintPartner.ShopId : 0,
	            paintPartnerCustomer: paintPartner.CustomerId !== undefined ? paintPartner.CustomerId : 0
	          }, function () {
	            _this3.getPaintPartnerCustomers(paintPartner.ShopId);
	          });
	        });
	        props.getShopUsers(props.item.ShopId).then(function (res) {
	          _this3.setState({
	            ShopOwners: res.data.ShopOwners,
	            Employees: res.data.Employees,
	            SupportUsers: res.data.SupportUsers
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'getPremiumShops',
	    value: function getPremiumShops(props) {
	      var _this4 = this;
	
	      if (typeof props.auth.user.ChainId !== 'undefined') {
	        props.getPremiumShops(props.auth.user.ChainId, props.item.ShopType).then(function (res) {
	          _this4.setState({
	            premiumShoplist: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'getPaintShops',
	    value: function getPaintShops(props) {
	      var _this5 = this;
	
	      if (typeof props.auth.user.ChainId !== 'undefined') {
	        props.getPaintShops(props.auth.user.ChainId).then(function (res) {
	          _this5.setState({
	            paintShoplist: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      var _this6 = this;
	
	      var chainCountryId = this.props.countries.filter(function (c) {
	        return c.CountryName === parseInt(_this6.props.auth.user.ChainCountry);
	      })[0].Id;
	      this.setState({
	        type: 'create',
	        shop: {
	          Active: true,
	          Address: '',
	          Alias: '',
	          CountryId: chainCountryId, // this.props.auth.user.ChainCountry,
	          CVR: '',
	          VendorId: '',
	          VendorCode: '',
	          ChainId: this.props.auth.user.ChainId,
	          City: '',
	          CompanyName: '',
	          Email: '',
	          Partners: [],
	          // PermissionModules: [],
	          PhoneCode: this.props.phonecode,
	          PhoneNumber: '',
	          ShopId: 0,
	          ShopType: 0,
	          TakseringType: 0,
	          UserId: 0,
	          UserName: '',
	          ZipCode: '',
	          Region: '',
	          SubscriptionType: 0,
	          SubscriptionId: null,
	          PNumber: '',
	          ChainUseStandardProductNumbers: true,
	          IsTestAccount: false,
	          IncludeInStatistics: true,
	          MemberType: 0,
	          DbsActive: false,
	          DBSWorkshopNumber: null,
	          ShopCustomerId: null
	        },
	        paintPartner: 0,
	        paintPartnerCustomer: 0,
	        Employees: [],
	        ShopOwners: [],
	        companyCustomers: [],
	        SupportUsers: []
	      });
	    }
	  }, {
	    key: 'loginAs',
	    value: function loginAs(id, shopId, support, impersonate) {
	      var _this7 = this;
	
	      this.props.loginAs(id, shopId, support, impersonate).then(function (res) {
	        var startScreen = res.data.StartScreen;
	        if (startScreen === undefined || startScreen === null) startScreen = '/workscreen';
	        _this7.props.router.push(startScreen);
	      });
	    }
	  }, {
	    key: 'saveAddShop',
	    value: function saveAddShop(e) {
	      var _this8 = this;
	
	      var shop = this.state.shop;
	      // update
	      if (shop.ShopId > 0) {
	        this.props.CreateSaveShop(shop).then(function (res) {
	          _this8.props.onSave(res.data, 'list');
	          _this8.setState({
	            shop: res.data
	          });
	        }, function (err) {
	          if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	            var errors = err.response.data.Errors;
	            var errorText = '';
	            errors.map(function (item) {
	              if (item.DictionaryKey !== 0) {
	                errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	              }
	            });
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	          } else {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)('2019'), (0, _helpers.translation)('216'));
	          }
	        });
	      }
	      if (shop.ShopId === undefined || shop.ShopId === 0) {
	        this.validateCvrAndPNumberNewShop();
	      }
	    }
	  }, {
	    key: 'validateCvrAndPNumberNewShop',
	    value: function validateCvrAndPNumberNewShop() {
	      var cvrAndPNumberDetails = {
	        cvr: this.state.shop.CVR,
	        countryId: this.state.shop.CountryId,
	        pnumber: this.state.shop.PNumber
	      };
	      this.props.ValidateCVRAndPNumber(cvrAndPNumberDetails).then(function (err) {
	        if (err.data !== undefined && err.data.Error !== null) {
	          var error = err.data.Error;
	          var errorText = '';
	          if (error.DictionaryKey !== 0) {
	            errorText += '<br />' + (0, _helpers.translation)(error.DictionaryKey);
	          }
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'addShop',
	    value: function addShop() {
	      var _this9 = this;
	
	      var shop = this.state.shop;
	      // add
	      this.props.CreateSaveShop(shop).then(function (res) {
	        _this9.props.onSave(res.data, 'create');
	        _this9.setState({
	          type: 'edit',
	          shop: res.data
	        });
	      }, function (err) {
	        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
	          var errors = err.response.data.Errors;
	          var errorText = '';
	          errors.map(function (item) {
	            if (item.DictionaryKey !== 0) {
	              errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	            }
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('2019'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(name, e) {
	      var _this10 = this;
	
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (e === undefined) {
	          e = name;
	        }
	        name = e.target.name;
	        value = e.target.value;
	      }
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      if (name === 'ProductionType') {
	        value = parseInt(value);
	      }
	      if (name === 'selectedPartner') {
	        this.setState(_defineProperty({}, name, value));
	      } else if (name === 'paintPartner') {
	        var _value = e.target.value;
	        this.changePaintPartner(_value);
	      } else if (name === 'paintPartnerCustomer') {
	        var _value2 = e.target.value;
	        this.editPaintPartner(_value2);
	      } else {
	        this.setState({
	          shop: _extends({}, this.state.shop, _defineProperty({}, name, value))
	        }, function () {
	          if (['ShopType', 'DracarAllowed', 'UseForsiTokenApi', 'BookingPortalAllowed', 'CarOwnerPortalAllowed', 'ProductionType', 'DbsActive', 'ShopCustomerId', 'IncludeInStatistics'].includes(name)) {
	            _this10.saveAddShop();
	          }
	        });
	      }
	    }
	    // getCountryIdByName(countryName){
	    //   for(let value in this.state.countries){
	    //     if(value.CountryName === countryName){
	    //       return value.Id
	    //     }
	    //   }
	    // }
	
	  }, {
	    key: 'changePaintPartner',
	    value: function changePaintPartner(value) {
	      var partners = [].concat(_toConsumableArray(this.state.shop.Partners));
	
	      var alreadyAdded = false;
	      for (var i = 0; i < partners.length; i++) {
	        if (partners[i].PartnerType === 1) {
	          // edit partners
	          partners[i].ShopId = value;
	          alreadyAdded = true;
	        }
	      }
	      if (!alreadyAdded) {
	        // add new partners
	        partners.push({
	          ShopId: value,
	          PartnerType: 1
	        });
	      }
	      this.setState({
	        shop: _extends({}, this.state.shop, {
	          Partners: partners
	        }),
	        paintPartner: value,
	        paintPartnerCustomer: 0
	      }, this.saveAddShop, this.getPaintPartnerCustomers(value));
	    }
	  }, {
	    key: 'editPaintPartner',
	    value: function editPaintPartner(value) {
	      var partners = [].concat(_toConsumableArray(this.state.shop.Partners));
	
	      for (var i = 0; i < partners.length; i++) {
	        if (parseInt(partners[i].ShopId) === parseInt(this.state.paintPartner) && partners[i].PartnerType === 1) {
	          partners[i].CustomerId = parseInt(value);
	        }
	      }
	
	      this.setState({
	        shop: _extends({}, this.state.shop, {
	          Partners: partners
	        }),
	        paintPartnerCustomer: value
	      }, this.saveAddShop);
	    }
	  }, {
	    key: 'getPaintPartnerCustomers',
	    value: function getPaintPartnerCustomers(shop) {
	      var _this11 = this;
	
	      if ((typeof shop === 'undefined' ? 'undefined' : _typeof(shop)) === 'object' && shop.item !== undefined && shop.item.ShopId !== undefined) {
	        shop = shop.item.ShopId;
	      }
	      this.props.getCustomers(shop).then(function (res) {
	        _this11.setState({
	          PaintPartnerCustomers: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getShopCustomersIfChainUseDBS',
	    value: function getShopCustomersIfChainUseDBS(props, from) {
	      var _this12 = this;
	
	      var shopId = props.item.ShopId;
	      var usesDBS = props.auth.permissions.ChainAssessmentSystem === 2;
	      var isSameShopAsState = shopId === this.state.ShopId;
	      if (typeof shopId === 'undefined' || shopId === 0 || !usesDBS || isSameShopAsState) return null;
	
	      this.props.getCustomers(shopId).then(function (res) {
	        _this12.setState({
	          companyCustomers: res.data
	        });
	      });
	    }
	
	    // onModuleCheck (e, dontCheck) {
	    //   if (!dontCheck) {
	    //     this.setState({
	    //       Confirm: {
	    //         Show: true,
	    //         IsPermission: true,
	    //         target: {
	    //           value: e.target.value,
	    //           name: e.target.name,
	    //           checked: e.target.checked
	    //         }
	    //       }
	    //     })
	    //     return
	    //   }
	
	    //   let modules = [...this.state.shop.PermissionModules]
	    //   var value = e.target.value
	    //   if (e.target.checked === false) {
	    //     modules = modules.filter(function (el) {
	    //       return Number(el.PermissionModuleId) !== Number(value)
	    //     })
	    //   } else {
	    //     modules.push({
	    //       PermissionModuleId: value
	    //     })
	    //   }
	    //   this.setState({
	    //     shop: {
	    //       ...this.state.shop,
	    //       PermissionModules: modules
	    //     }
	    //   }, this.saveAddShop)
	    // }
	
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(name, e) {
	      var value = '';
	      value = name.target.value;
	      if (name.target.name === 'PhoneNumber') {
	        name = 'PhoneNumber';
	        this.setState({
	          shop: _extends({}, this.state.shop, _defineProperty({}, name, value))
	        });
	      } else {
	        this.setState({
	          shop: _extends({}, this.state.shop, {
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        }, this.saveAddShop);
	      }
	    }
	  }, {
	    key: 'onPhoneBlur',
	    value: function onPhoneBlur(name, e) {
	      var value = '';
	      value = name.target.value;
	      if (name.target.name === 'PhoneNumber') {
	        name = 'PhoneNumber';
	        this.setState({
	          shop: _extends({}, this.state.shop, _defineProperty({}, name, value))
	        }, this.saveAddShop);
	      }
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e, dontCheck) {
	      // if (typeof e.preventDefault === 'function') e.preventDefault()
	      var value = e.target.value;
	      var name = e.target.name;
	
	      if (e.target.name === 'ChainUseStandardProductNumbers' || e.target.name === 'Active') {
	        value = e.target.value === 'true' || e.target.value === true;
	        if (e.target.type === 'checkbox') value = e.target.checked;
	      }
	      if (this.state.shop[name] + '' === '' + value) return;
	      if (dontCheck !== true) {
	        this.setState({
	          Confirm: {
	            Show: true,
	            IsPermission: false,
	            target: {
	              value: value,
	              name: name,
	              checked: e.target.checked
	            }
	          }
	        });
	        return;
	      }
	      this.setState({
	        shop: _extends({}, this.state.shop, _defineProperty({}, name, value))
	      }, this.saveAddShop);
	    }
	  }, {
	    key: 'onMemberTypeChange',
	    value: function onMemberTypeChange(e, dontCheck) {
	      var value = e.target.value;
	      var name = e.target.name;
	      var checked = e.target.checked;
	      // Open up confirmation
	      if (dontCheck !== true) {
	        this.setState({
	          Confirm: {
	            Show: true,
	            IsPermission: false,
	            target: {
	              value: value,
	              name: name,
	              checked: checked
	            }
	          }
	        });
	        return;
	      }
	      if (name === 'MemberType') {
	        // These checkboxes work the same way as the radio buttons, but with an option to have none of them checked
	        if (e.target.value === this.state.shop.MemberType.toString()) value = 0;
	      }
	      this.setState({
	        shop: _extends({}, this.state.shop, _defineProperty({}, name, value))
	      }, this.saveAddShop);
	    }
	  }, {
	    key: 'renderShop',
	    value: function renderShop() {
	      if (this.state.previousSelectedShopId !== this.state.shop.ShopId) {
	        this.setState({
	          previousSelectedShopId: this.state.shop.ShopId
	        });
	      }
	
	      var shop = this.state.shop;
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('700') },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'CountryId', value: shop.CountryId, onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('1701') },
	          this.props.countries.map(function (val, index) {
	            var showVal = (0, _helpers.translation)(val['CountryName']);
	            return _react2.default.createElement(
	              'option',
	              { value: val['Id'], key: index },
	              showVal
	            );
	          })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'CVR', value: shop.CVR || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('41') }),
	        _react2.default.createElement(_text2.default, { name: 'PNumber', value: shop.PNumber || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('15222') }),
	        _react2.default.createElement(_text2.default, { name: 'CompanyName', value: shop.CompanyName || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_text2.default, { name: 'Alias', value: shop.Alias || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('1863') }),
	        _react2.default.createElement(_text2.default, { name: 'Address', value: shop.Address || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('25') }),
	        _react2.default.createElement(_text2.default, { name: 'ZipCode', value: shop.ZipCode || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('40') }),
	        _react2.default.createElement(_text2.default, { name: 'Region', value: shop.Region || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('14753') }),
	        _react2.default.createElement(_text2.default, { name: 'City', value: shop.City || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('37') }),
	        _react2.default.createElement(_text2.default, { name: 'VendorId', value: shop.VendorId || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('14754') }),
	        _react2.default.createElement(_text2.default, { name: 'VendorCode', value: shop.VendorCode || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('15250') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('38') },
	          _react2.default.createElement(_Phone2.default, { onChange: this.onPhoneChange, onBlur: this.onPhoneBlur, code: shop.PhoneCode || '', number: shop.PhoneNumber || '' })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'Email', value: shop.Email || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('1052') }),
	        _react2.default.createElement(_text2.default, { name: 'UserName', value: shop.UserName || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('1') }),
	        _react2.default.createElement(_switch2.default, { name: 'Active', checked: shop.Active, onChange: this.onRadioChange, labelText: (0, _helpers.translation)('295') }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _auth.loginAs
	        )
	      );
	    }
	  }, {
	    key: 'renderSettings',
	    value: function renderSettings() {
	      var _this13 = this;
	
	      var shop = this.state.shop;
	      var chainUsesDBS = this.props.auth.permissions.ChainAssessmentSystem === 2;
	
	      var prodNrChecked = function prodNrChecked(type, standard) {
	        if (standard === type) {
	          return true;
	        }
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('6') },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'ShopType', onChange: this.onInputChange, value: shop.ShopType !== null ? shop.ShopType : 0, labelText: (0, _helpers.translation)('1167'), onBlur: this.saveAddShop, disabled: shop.ShopId > 0 },
	          _react2.default.createElement(
	            'option',
	            { value: 0 },
	            (0, _helpers.translation)('660')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 1 },
	            (0, _helpers.translation)('635')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 2 },
	            (0, _helpers.translation)('736')
	          )
	        ),
	        _react2.default.createElement(_switch2.default, { id: 'TestAccount', name: 'IsTestAccount', labelText: 16381, checked: shop.IsTestAccount, onChange: this.onInputChange }),
	        shop.ShopType >= 1 ? _react2.default.createElement(_switch2.default, { id: 'AllowBookingPortal', name: 'BookingPortalAllowed', labelText: 16852, checked: shop.BookingPortalAllowed, onChange: this.onInputChange }) : null,
	        shop.ShopType >= 1 ? _react2.default.createElement(_switch2.default, { id: 'AllowCarOwnerPortal', name: 'CarOwnerPortalAllowed', labelText: 18151, checked: shop.CarOwnerPortalAllowed, onChange: this.onInputChange }) : null,
	        shop.ShopType >= 1 && !chainUsesDBS ? _react2.default.createElement(_switch2.default, { id: 'UseForsiToken', name: 'UseForsiTokenApi', onChange: this.onInputChange, checked: shop.UseForsiTokenApi, labelText: (0, _helpers.translation)('16420') }) : null,
	        shop.ShopType >= 1 ? _react2.default.createElement(_switch2.default, { id: 'Dracar', name: 'DracarAllowed', onChange: this.onInputChange, checked: shop.DracarAllowed, labelText: (0, _helpers.translation)('18364') }) : null,
	        shop.DracarAllowed ? _react2.default.createElement(_text2.default, { name: 'DracarCompanyId', value: shop.DracarCompanyId || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('18456') }) : null,
	        (shop.SubscriptionId !== null && shop.SubscriptionId > 0 || this.state.type !== 'edit') && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('15295'), helpText: (0, _helpers.translation)('15312') + ' ' + (0, _helpers.translation)('15313') },
	          _react2.default.createElement(_radio2.default, { id: 'StandardProductNumbers_yes', name: 'ChainUseStandardProductNumbers', value: 'true', onChange: function onChange(e) {
	              return _this13.onRadioChange(e, true);
	            }, checked: prodNrChecked(true, shop.ChainUseStandardProductNumbers) || false, labelText: (0, _helpers.translation)('15309') }),
	          _react2.default.createElement(_radio2.default, { id: 'StandardProductNumbers_no', name: 'ChainUseStandardProductNumbers', value: 'false', onChange: function onChange(e) {
	              return _this13.onRadioChange(e, true);
	            }, checked: prodNrChecked(false, shop.ChainUseStandardProductNumbers) || false, labelText: (0, _helpers.translation)('15310') })
	        )
	      );
	    }
	  }, {
	    key: 'renderProductionTypes',
	    value: function renderProductionTypes() {
	      var shop = this.state.shop;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1167') },
	        _react2.default.createElement(_radio2.default, { id: 'ProductionType_PersonCars', name: 'ProductionType', value: '0', onChange: this.onInputChange, checked: shop.ProductionType === 0, labelText: (0, _helpers.translation)('1168') }),
	        _react2.default.createElement(_radio2.default, { id: 'ProductionType_BigCars', name: 'ProductionType', value: '1', onChange: this.onInputChange, checked: shop.ProductionType === 1, labelText: (0, _helpers.translation)('1169') }),
	        _react2.default.createElement(_radio2.default, { id: 'ProductionType_Industry', name: 'ProductionType', value: '2', onChange: this.onInputChange, checked: shop.ProductionType === 2, labelText: (0, _helpers.translation)('1170') })
	      );
	    }
	  }, {
	    key: 'isPartnerInList',
	    value: function isPartnerInList(partners, shop) {
	      if (partners !== undefined && shop !== undefined) {
	        for (var i = 0; i < partners.length; i++) {
	          if (partners[i].ShopId === shop.ShopId && [0, 2].includes(partners[i].PartnerType)) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'renderPartners',
	    value: function renderPartners() {
	      var _this14 = this;
	
	      if (this.state.shop.SubscriptionId < 4) return null;
	      var shop = this.state.shop;
	      // Filters out added partners and itself
	      var filteredPremiumShoplist = this.state.premiumShoplist.filter(function (shop) {
	        return _this14.isPartnerInList(_this14.state.shop.Partners, shop) === false && shop.ShopId !== _this14.state.shop.ShopId && shop.ShopType === _this14.state.shop.ShopType;
	      });
	
	      var adminPartners = function adminPartners(e) {
	        var partners = [].concat(_toConsumableArray(_this14.state.shop.Partners));
	        var value = 0;
	
	        if (e.target.value === undefined) {
	          console.log('delete???', e.target);
	          value = e.target.id;
	          partners = partners.filter(function (el) {
	            return Number(el.ShopId) !== Number(value);
	          });
	        } else {
	          value = e.target.value;
	          partners.push({
	            ShopId: value
	          });
	        }
	        _this14.setState({
	          shop: _extends({}, _this14.state.shop, {
	            Partners: partners
	          })
	        }, _this14.saveAddShop);
	      };
	      var addPartner = function addPartner() {
	        var partners = _this14.state.shop.Partners;
	        var value = _this14.state.selectedPartner;
	
	        if (value !== 0 && value !== undefined) {
	          var newPartner = {
	            ShopId: value,
	            PartnerType: filteredPremiumShoplist.find(function (x) {
	              return x.ShopId === value;
	            }).ShopType === 0 ? 0 : 2
	          };
	          _this14.setState({
	            shop: _extends({}, _this14.state.shop, {
	              Partners: [].concat(_toConsumableArray(partners), [newPartner])
	            }),
	            selectedPartner: 0
	          }, _this14.saveAddShop);
	        }
	      };
	      var renderShops = function renderShops(val, key) {
	        if ([0, 2].includes(val.PartnerType)) {
	          return _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true, key: key },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              val.ShopName
	            ),
	            _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	                return adminPartners({ target: { id: val.ShopId } });
	              }, id: val.ShopId, size: 's' })
	          );
	        }
	      };
	      var renderShopList = function renderShopList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.ShopId },
	          val.ShopName
	        );
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('649') },
	        shop.Partners !== null && shop.Partners.map(renderShops),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: ['200px', 'auto'] },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { ref: 'partnerShops', name: 'selectedPartner', onChange: this.onInputChange, value: this.state.selectedPartner },
	            _react2.default.createElement(
	              'option',
	              { value: 0 },
	              (0, _helpers.translation)('890'),
	              ' ',
	              (0, _helpers.translation)('700')
	            ),
	            filteredPremiumShoplist.map(renderShopList)
	          ),
	          _react2.default.createElement(_addButton2.default, { onClick: addPartner })
	        )
	      );
	    }
	  }, {
	    key: 'renderPaintPartner',
	    value: function renderPaintPartner() {
	      var _this15 = this;
	
	      var filteredPaintShoplist = this.state.paintShoplist.filter(function (shop) {
	        return shop.ShopId !== _this15.state.shop.ShopId;
	      });
	      var renderShopList = function renderShopList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.ShopId },
	          val.ShopName
	        );
	      };
	      var renderPaintPartnerCustomers = function renderPaintPartnerCustomers() {
	        return _this15.state.PaintPartnerCustomers.filter(function (x) {
	          return x.RelationType === 0;
	        }).reduce(function (mapped, elem, key) {
	          if (elem.Active) {
	            var element = _react2.default.createElement(
	              'option',
	              { key: key, value: elem.CustomerId },
	              elem.Name
	            );
	            return [].concat(_toConsumableArray(mapped), [element]);
	          }
	          return mapped;
	        }, []);
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('161') },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'paintPartner', value: this.state.paintPartner, onChange: this.onInputChange, labelText: (0, _helpers.translation)('867') },
	          _react2.default.createElement(
	            'option',
	            { value: 0 },
	            (0, _helpers.translation)('890'),
	            ' ',
	            (0, _helpers.translation)('700')
	          ),
	          filteredPaintShoplist.map(renderShopList)
	        ),
	        this.state.PaintPartnerCustomers !== undefined && _react2.default.createElement(
	          _dropDown2.default,
	          { name: 'paintPartnerCustomer', value: this.state.paintPartnerCustomer, onChange: this.onInputChange, labelText: (0, _helpers.translation)('14805') },
	          _react2.default.createElement(
	            'option',
	            { value: 0 },
	            (0, _helpers.translation)('890'),
	            ' ',
	            (0, _helpers.translation)('58')
	          ),
	          renderPaintPartnerCustomers()
	        )
	      );
	    }
	  }, {
	    key: 'renderSubscriptions',
	    value: function renderSubscriptions() {
	      var _this16 = this;
	
	      var shop = this.state.shop;
	
	      var renderSubscription = function renderSubscription(item, key) {
	        var inputId = 'shop_subscription_' + item.Name;
	        var checked = shop.SubscriptionId + '' === item.SubscriptionId + '';
	        var name = item.Name;
	        if (item.SubscriptionId <= 0) name = (0, _helpers.translation)('433');
	        return _react2.default.createElement(_radio2.default, { key: key, id: inputId, name: 'SubscriptionId', value: item.SubscriptionId, checked: checked, labelText: name, onChange: _this16.onRadioChange });
	        // return (
	        //   <div key={key} className='radio__custom__wrapper'>
	        //     <div className='radio__custom'>
	        //       <input type='radio' id={inputId} name='SubscriptionId' value={item.SubscriptionId} checked={checked} onClick={this.onRadioChange} onChange={() => { return }} />
	        //       <label htmlFor={inputId}>{name}</label>
	        //     </div>
	        //   </div>
	        // )
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('2149') },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('2151') },
	          this.state.allSubscriptions.map(renderSubscription)
	        )
	      );
	    }
	  }, {
	    key: 'renderStatistics',
	    value: function renderStatistics() {
	      // // The labelText represents the name before checkbox and memberType is the type of member which checkbox represents
	      // const renderCheckbox = (labelText, memberType) => {
	      //   let checked = this.state.shop.MemberType === memberType
	      //   var inputId = 'shop_memberType_' + labelText
	      //   return (
	      //     <div className='control__group checkbox__custom__outer'>
	      //       <label>{labelText}</label>
	      //       <div className='checkbox__custom__wrapper'>
	      //         <div className='checkbox__custom'>
	      //           <input type='checkbox' id={inputId} name='MemberType' value={memberType} checked={checked} onChange={this.onMemberTypeChange} />
	      //           <label htmlFor={inputId} />
	      //         </div>
	      //       </div>
	      //     </div>
	      //   )
	      // }
	
	      // const ActiveChecked = (type, active) => {
	      //   if (active === type) {
	      //     return (
	      //       true
	      //     )
	      //   }
	      // }
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: 389, helpText: 15328 },
	        _react2.default.createElement(_switch2.default, { name: 'IncludeInStatistics', labelText: 15323, checked: this.state.shop.IncludeInStatistics, onChange: this.onInputChange }),
	        this.state.shop.IncludeInStatistics && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: 15324 },
	          _react2.default.createElement(_radio2.default, { labelText: 15332, name: 'MemberType', value: 0, checked: this.state.shop.MemberType === 0, onChange: this.onMemberTypeChange }),
	          _react2.default.createElement(_radio2.default, { labelText: 15325, name: 'MemberType', value: 1, checked: this.state.shop.MemberType === 1, onChange: this.onMemberTypeChange }),
	          _react2.default.createElement(_radio2.default, { labelText: 15326, name: 'MemberType', value: 2, checked: this.state.shop.MemberType === 2, onChange: this.onMemberTypeChange }),
	          _react2.default.createElement(_radio2.default, { labelText: 15327, name: 'MemberType', value: 3, checked: this.state.shop.MemberType === 3, onChange: this.onMemberTypeChange })
	        )
	      );
	
	      // return (
	      //   <div className='white__box'>
	      //     <div className='title'>{translation('389')}<HelpText className='helpText' text={translation('15328')} left /></div>
	      //     <div className='form fifty'>
	      //       <div className='control__group radio__custom__outer'>
	      //         <label>{translation('15323')}</label>
	      //         <div className='radio__custom__wrapper'>
	      //           <div className='radio__custom'>
	      //             <input type='radio' id='statistics_active_yes' name='IncludeInStatistics' value='true' checked={ActiveChecked(true, this.state.shop.IncludeInStatistics) || false} onChange={this.onRadioChange} />
	      //             <label htmlFor='statistics_active_yes'>{translation('47')}</label>
	      //           </div>
	      //           <div className='radio__custom'>
	      //             <input type='radio' id='statistics_active_no' name='IncludeInStatistics' value='false' checked={ActiveChecked(false, this.state.shop.IncludeInStatistics) || false} onChange={this.onRadioChange} />
	      //             <label htmlFor='statistics_active_no'>{translation('48')}</label>
	      //           </div>
	      //         </div>
	      //       </div>
	      //       {this.state.shop.IncludeInStatistics && (
	      //         <div className='checkbox_group_wrapper'>
	      //           <label className='boldLabel'>{translation('15324')}</label>
	      //           {renderCheckbox(translation('15325'), 1)}
	      //           {renderCheckbox(translation('15326'), 2)}
	      //           {renderCheckbox(translation('15327'), 3)}
	      //         </div>
	      //       )}
	
	      //     </div>
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers(Titele, Users, request) {
	      var _this17 = this;
	
	      var User = function User(val, key) {
	        if (!(val.Id > 0)) {
	          return;
	        }
	        var textKey = support ? '18033' : '57';
	        var support = request === 'Support';
	        var impersonate = request === 'Impersonate';
	        var shopId = support ? _this17.state.shop.ShopId : 0;
	
	        if (support && !val.CanLogin || impersonate && !val.CanImpersonate) {
	          return _react2.default.createElement(_labelWrapper2.default, { labelText: val.Name, key: key });
	        }
	
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: val.Name, key: key },
	          _react2.default.createElement(_button2.default, { style: 'link', onClick: _this17.loginAs.bind(_this17, val.Id, shopId, support, impersonate), labelText: (0, _helpers.translation)(textKey) })
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: Titele },
	        Users.map(User)
	      );
	    }
	  }, {
	    key: 'renderDBS',
	    value: function renderDBS() {
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('17930') },
	        _react2.default.createElement(_switch2.default, { id: 'DbsActive', name: 'DbsActive', labelText: 295, checked: this.state.shop.DbsActive, onChange: this.onInputChange }),
	        _react2.default.createElement(_text2.default, { name: 'DBSWorkshopNumber', value: this.state.shop.DBSWorkshopNumber || '', onChange: this.onInputChange, onBlur: this.saveAddShop, labelText: (0, _helpers.translation)('17931') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('14905'), helpText: (0, _helpers.translation)('14907') },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { onChange: this.onInputChange, name: 'ShopCustomerId', value: this.state.shop.ShopCustomerId },
	            _react2.default.createElement(
	              'option',
	              { key: null, value: null },
	              (0, _helpers.translation)('14906')
	            ),
	            this.state.companyCustomers.filter(function (x) {
	              return x.Active === true;
	            }).map(function (val, key) {
	              return _react2.default.createElement(
	                'option',
	                { key: val.CustomerId, value: val.CustomerId },
	                val.Name
	              );
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderShop()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderSettings(),
	          this.renderProductionTypes(),
	          this.renderUsers((0, _helpers.translation)('10'), this.state.Employees, 'Impersonate')
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.state.shop.ShopType !== 2 && this.state.shop.ShopId !== 0 && this.renderPartners(),
	          this.state.shop !== undefined && this.state.shop.ShopType === 1 && this.state.shop.ShopId !== 0 && this.renderPaintPartner(),
	          this.renderUsers((0, _helpers.translation)('1860'), this.state.ShopOwners, 'Impersonate'),
	          this.renderSubscriptions()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.auth.user.ChainId === '2' && (this.props.auth.user.UserType === 2 || this.props.auth.user.UserType === 1) && this.renderStatistics()
	          ),
	          this.props.auth.permissions.ChainAssessmentSystem === 2 && this.renderDBS(),
	          this.renderUsers((0, _helpers.translation)('659'), this.state.SupportUsers, 'Support')
	        ),
	        this.state.Confirm.Show === true && _react2.default.createElement(_Confirm2.default, { t: _helpers.translation, renderText: function renderText() {
	            return (0, _helpers.translation)('14748');
	          }, confirm: this.confirm, notConfirm: this.notConfirm })
	      );
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm() {
	      this.setState({
	        Confirm: _extends({}, this.state.Confirm, {
	          Show: false
	        })
	      });
	
	      if (this.state.Confirm.IsPermission) {} else {
	        if (this.state.Confirm.target.name === 'MemberType') {
	          this.onMemberTypeChange(this.state.Confirm, true);
	        } else {
	          this.onRadioChange(this.state.Confirm, true);
	        }
	      }
	    }
	  }, {
	    key: 'notConfirm',
	    value: function notConfirm() {
	      this.setState({
	        Confirm: _extends({}, this.state.confirm, {
	          Show: false
	        })
	      });
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes,
	    countries: state.common.countries
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getShop: _shops.getShop,
	  CreateSaveShop: _shops.CreateSaveShop,
	  ValidateCVRAndPNumber: _shops.ValidateCVRAndPNumber,
	  getPremiumShops: _shops.getPremiumShops,
	  getPaintShops: _shops.getPaintShops,
	  updateShop: _shops.updateShop,
	  loginAs: _auth.loginAs,
	  getShopUsers: _shops.getShopUsers,
	  getCustomers: _customers.getCustomers,
	  getSubscriptions: _common.getSubscriptions
	}, null, { withRef: true })(View);

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _shops = __webpack_require__(79);
	
	__webpack_require__(1473);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _View = __webpack_require__(979);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Shops = function (_Component) {
	  _inherits(Shops, _Component);
	
	  function Shops(props) {
	    _classCallCheck(this, Shops);
	
	    var _this = _possibleConstructorReturn(this, (Shops.__proto__ || Object.getPrototypeOf(Shops)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      search: '',
	      includeInactive: false,
	      shops: [],
	      activeItem: {}
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Shops, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getShops();
	    }
	  }, {
	    key: 'getShops',
	    value: function getShops() {
	      var _this2 = this;
	
	      this.props.getShops(this.props.auth.user.ChainId).then(function (res) {
	        _this2.setState({
	          shops: res.data
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', ariaText: (0, _helpers.translation)('2055'), labelText: (0, _helpers.translation)(1797), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({
	          search: e.target.value
	        });
	      }
	      if (e.target.name === 'Inactive') {
	        this.setState({
	          includeInactive: e.target.checked
	        });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      // if (key.ShopId === 16) {
	      //   console.log('filter')
	      //   console.log(key)
	      // }
	      // if (key.ShopName !== null) {
	      if (key.ShopName === null || key.ShopName === undefined) {
	        return false;
	      }
	      if (this.state.search === undefined || this.state.search === null) {
	        return true;
	      }
	      if (key.ShopName.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.Active : true)) {
	        return true;
	      }
	      return false;
	      // }
	      // return false
	      // }
	      // return false
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.view.getWrappedInstance().addShop();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.shops.map(function (s) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: s.ShopName,
	          onClick: function onClick() {
	            return _this3.onSelectItem(s);
	          },
	          selected: s.ShopId === _this3.state.activeItem.ShopId,
	          inactive: !s.Active,
	          key: s.ShopId
	        });
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var shops = [].concat(_toConsumableArray(this.state.shops));
	      if (type === 'create') {
	        shops.push({
	          ShopId: data.ShopId,
	          ShopName: data.CompanyName,
	          Active: data.Active
	        }, this.getShops);
	        type = 'list';
	      } else {
	        shops.map(function (val, key) {
	          if (val.ShopId === data.ShopId) {
	            val.ShopName = data.CompanyName;
	          }
	        });
	        type = 'item';
	      }
	      this.setState({
	        shops: shops,
	        view: type
	      });
	      // Toastr
	      // window.toastr.success(translation('2072'), translation('13424'))
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { router: this.props.router, ref: 'view', item: this.state.activeItem, onSave: this.onSave });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'shops__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, renderRight: function renderRight() {
	            return _this4.headerButtonsRight();
	          } }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create' },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'shops__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Shops;
	}(_react.Component);
	
	Shops.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getShops: _shops.getShops })(Shops);

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Auth = __webpack_require__(226);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _signup = __webpack_require__(411);
	
	var _language = __webpack_require__(139);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	__webpack_require__(1474);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Auth wrapper
	
	
	// Actions
	
	
	// Components
	
	
	// import styles
	
	
	// Utils
	
	
	var Signup = function (_Component) {
	  _inherits(Signup, _Component);
	
	  function Signup(props) {
	    _classCallCheck(this, Signup);
	
	    var _this = _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).call(this, props));
	
	    _this.state = {
	      Name: '',
	      Email: '',
	      PhoneNumber: '',
	      PhoneCode: { Id: 12 },
	      ShopName: '',
	      ShopAddress: '',
	      ShopZipCode: '',
	      ShopCity: '',
	      CountryId: 12,
	      AgreeToTerms: false
	    };
	
	    var browserLanguage = window.navigator.language || window.navigator.userLanguage;
	
	    if (browserLanguage === 'da') {
	      _this.props.setLanguage('Danish');
	    } else {
	      _this.props.setLanguage('English');
	    }
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Signup, [{
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      this.setState({ isLoading: true });
	
	      this.props.sendSignup({
	        Name: this.state.Name,
	        Email: this.state.Email,
	        PhoneNumber: this.state.PhoneNumber,
	        PhoneCode: this.state.PhoneCode,
	        ShopName: this.state.ShopName,
	        ShopAddress: this.state.ShopAddress,
	        ShopZipCode: this.state.ShopZipCode,
	        ShopCity: this.state.ShopCity,
	        CountryId: this.state.CountryId,
	        AgreeToTerms: this.state.AgreeToTerms
	      }).then(function (res) {
	        _this2.props.router.push('/');
	      }, function (err) {
	        _this2.setState({ isLoading: false });
	        if (err.response.data !== undefined) {
	          var errors = err.response.data;
	          var errorText = '';
	          errors.map(function (item) {
	            if (item.DictionaryKey !== 0) {
	              errorText += '<br />' + (0, _helpers.translation)(item.DictionaryKey);
	            }
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(errorText), (0, _helpers.translation)('216'));
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('1883'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	      this.setState(_defineProperty({}, e.target.name, value));
	    }
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(name, e) {
	      var value = '';
	      value = name.target.value;
	      if (name.target.name === 'PhoneNumber') {
	        name = 'PhoneNumber';
	        this.setState(_defineProperty({}, name, value));
	      } else {
	        this.setState({
	          PhoneCode: {
	            Id: Number(value)
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isLoading = this.state.isLoading;
	
	
	      return _react2.default.createElement(
	        _Auth2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'signup__screen clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'main__left' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              (0, _helpers.translation)('2120')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)('2121')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)('2122'),
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { className: 'green', href: 'https://apromas.com' },
	                (0, _helpers.translation)('2123')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main__right' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.onSubmit },
	              _react2.default.createElement(
	                'h2',
	                null,
	                (0, _helpers.translation)('2119')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control__group' },
	                _react2.default.createElement('input', { type: 'text', name: 'Name', onChange: this.onChange, placeholder: (0, _helpers.translation)('30'), autoComplete: 'off' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control__group' },
	                _react2.default.createElement('input', { type: 'text', name: 'Email', onChange: this.onChange, placeholder: (0, _helpers.translation)('1052'), autoComplete: 'off' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control__group' },
	                _react2.default.createElement(_Phone2.default, {
	                  onChange: this.onPhoneChange,
	                  code: this.state.PhoneCode,
	                  number: this.state.PhoneNumber })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control__group' },
	                _react2.default.createElement('input', { type: 'text', name: 'ShopName', onChange: this.onChange, placeholder: (0, _helpers.translation)('2116'), autoComplete: 'off' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control__group' },
	                _react2.default.createElement('input', { type: 'text', name: 'ShopAddress', onChange: this.onChange, placeholder: (0, _helpers.translation)('25'), autoComplete: 'off' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control__group' },
	                _react2.default.createElement('input', { type: 'text', name: 'ShopZipCode', onChange: this.onChange, placeholder: (0, _helpers.translation)('40'), autoComplete: 'off' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control__group' },
	                _react2.default.createElement('input', { type: 'text', name: 'ShopCity', onChange: this.onChange, placeholder: (0, _helpers.translation)('37'), autoComplete: 'off' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control__group' },
	                _react2.default.createElement(
	                  'select',
	                  { value: this.state.CountryId, onChange: this.onChange, name: 'CountryId' },
	                  this.props.countries.map(function (val, index) {
	                    var showVal = (0, _helpers.translation)(val['CountryName']);
	                    return _react2.default.createElement(
	                      'option',
	                      { value: val['Id'].toString(), key: index },
	                      showVal
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'checkbox__custom__wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkbox__custom' },
	                  _react2.default.createElement('input', { type: 'checkbox', id: 'terms', name: 'AgreeToTerms', value: '1', checked: this.state.AgreeToTerms, onChange: this.onChange }),
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'terms' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      (0, _helpers.translation)('2127'),
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        null,
	                        (0, _helpers.translation)('2128')
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { disabled: isLoading, className: 'button' },
	                (0, _helpers.translation)('2115')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Signup;
	}(_react.Component);
	
	Signup.propTypes = {
	  setLanguage: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes,
	    countries: state.common.countries
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { sendSignup: _signup.sendSignup, setLanguage: _language.setLanguage })(Signup);

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1475);
	
	var _shops = __webpack_require__(79);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _time = __webpack_require__(17);
	
	var _currency = __webpack_require__(41);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// import components
	
	
	// Utils
	
	
	// Elements
	
	// import PanelHeader from '../../shared/elements/panelHeader'
	
	
	var SmallDashboard = function (_Component) {
	  _inherits(SmallDashboard, _Component);
	
	  function SmallDashboard(props) {
	    _classCallCheck(this, SmallDashboard);
	
	    var _this = _possibleConstructorReturn(this, (SmallDashboard.__proto__ || Object.getPrototypeOf(SmallDashboard)).call(this, props));
	
	    _this.state = {
	      smallDashboard: {
	        PeriodStart: undefined,
	        PeriodStop: undefined,
	        Turnover: 0,
	        OrderCount: 0,
	        ForsiOrderCount: 0,
	        EvaluationCount: 0,
	        AfterEvaluationCount: 0,
	        DocumentationCount: 0,
	        PhotoOrderCount: 0,
	        PhotoRegistrationCount: 0,
	        FullDashboardUrl: '',
	        FullReportUrl: ''
	      }
	    };
	    _this.getSmallDashboard = _this.getSmallDashboard.bind(_this);
	    return _this;
	  }
	
	  _createClass(SmallDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSmallDashboard();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.orderID !== this.props.params.orderID) {
	        this.setState({
	          smallDashboard: {
	            PeriodStart: undefined,
	            PeriodStop: undefined,
	            Turnover: 0,
	            OrderCount: 0,
	            ForsiOrderCount: 0,
	            EvaluationCount: 0,
	            AfterEvaluationCount: 0,
	            DocumentationCount: 0,
	            PhotoOrderCount: 0,
	            PhotoRegistrationCount: 0,
	            FullDashboardUrl: '',
	            FullReportUrl: ''
	          }
	        });
	        this.getSmallDashboard(nextProps);
	      }
	    }
	  }, {
	    key: 'getSmallDashboard',
	    value: function getSmallDashboard(props) {
	      var _this2 = this;
	
	      props = typeof props === 'undefined' ? this.props : props;
	      this.props.GetSmallDashboard(props.params.orderID).then(function (res) {
	        _this2.setState({
	          smallDashboard: res.data
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1790'), (0, _helpers.translation)('216'));
	        _this2.props.router.goBack();
	      });
	    }
	  }, {
	    key: 'renderAssessment',
	    value: function renderAssessment() {
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('901'), key: 'assessment' },
	        _react2.default.createElement(
	          _inline2.default,
	          { spacing: '0', block: true, fillChildNum: [0] },
	          (0, _helpers.translation)('13363'),
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            this.state.smallDashboard.EvaluationCount
	          )
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { spacing: '0', block: true, fillChildNum: [0] },
	          (0, _helpers.translation)('1037'),
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            this.state.smallDashboard.AfterEvaluationCount
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPhotoDocumentation',
	    value: function renderPhotoDocumentation() {
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('2065'), key: 'photodoc' },
	        _react2.default.createElement(
	          _inline2.default,
	          { spacing: '0', block: true, fillChildNum: [0] },
	          (0, _helpers.translation)('14812'),
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            this.state.smallDashboard.DocumentationCount
	          )
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { spacing: '0', block: true, fillChildNum: [0] },
	          (0, _helpers.translation)('14813'),
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            this.state.smallDashboard.PhotoRegistrationCount
	          )
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { spacing: '0', block: true, fillChildNum: [0] },
	          (0, _helpers.translation)('1096'),
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            this.state.smallDashboard.PhotoOrderCount
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderReportButtons',
	    value: function renderReportButtons() {
	      // let isBodyShop = this.props.auth.departmentType === 1
	      var showDashboardReport = this.props.auth.user.ChainId !== '2' && this.props.auth.user.ChainId !== '8'; // Disable for QARS for now (while paint and body reports are not being maintained)
	      var showQarsReport = this.props.auth.user.ChainId === '2' || this.props.auth.user.ChainId === '8';
	
	      // Renders report link button for chain or shop report.
	      var renderDWLink = function renderDWLink() {
	        var reportType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        var url = '/DataWarehouse/' + reportType;
	        var to = (0, _helpers.translation)(187);
	        var reports = (0, _helpers.translation)(436);
	        var title = to + ' ' + reports;
	
	        return _react2.default.createElement(
	          'a',
	          { href: url },
	          _react2.default.createElement(_button2.default, { style: 'link', labelText: _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              title,
	              _react2.default.createElement(_icon2.default, { className: 'topright', icon: _icons.DashboardIcons.Arrow_Black })
	            ) })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        showDashboardReport && renderDWLink(0),
	        showQarsReport && renderDWLink(1)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30, 10)) return null;
	
	      var isBodyShop = this.props.auth.departmentType === 1;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'smalldashboard__page' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router }),
	        _react2.default.createElement(
	          'div',
	          { className: 'smalldashboard__page--inner' },
	          _react2.default.createElement(
	            _col2.default,
	            { span: 1 },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('1102') },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                (0, _helpers.translation)('1103') + ' ' + (0, _time.renderFullDate)(this.state.smallDashboard.PeriodStart, false) + ' - ' + (0, _time.renderFullDate)(this.state.smallDashboard.PeriodStop, false)
	              ),
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('1090') },
	                _react2.default.createElement(
	                  _inline2.default,
	                  { spacing: '0', block: true, fillChildNum: [0] },
	                  (0, _helpers.translation)('1095'),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'amount' },
	                    (0, _currency.formatCurrency)(this.state.smallDashboard.Turnover, 0)
	                  )
	                ),
	                _react2.default.createElement(
	                  _inline2.default,
	                  { spacing: '0', block: true, fillChildNum: [0] },
	                  (0, _helpers.translation)('1096'),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'value' },
	                    this.state.smallDashboard.OrderCount
	                  )
	                ),
	                _react2.default.createElement(
	                  _inline2.default,
	                  { spacing: '0', block: true, fillChildNum: [0] },
	                  (0, _helpers.translation)('1097'),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'value' },
	                    this.state.smallDashboard.ForsiOrderCount
	                  )
	                )
	              ),
	              !isBodyShop && [_react2.default.createElement(_divider2.default, { noLine: true, key: '1' }), this.renderAssessment(), _react2.default.createElement(_divider2.default, { noLine: true, key: '3' }), this.renderPhotoDocumentation()],
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              this.renderReportButtons()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SmallDashboard;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetSmallDashboard: _shops.GetSmallDashboard
	})(SmallDashboard);

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _spareparts = __webpack_require__(108);
	
	var _settings = __webpack_require__(51);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _time = __webpack_require__(301);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	__webpack_require__(1476);
	
	var _helpers = __webpack_require__(2);
	
	var _SparePartDeliverySettingEditModal = __webpack_require__(1115);
	
	var _SparePartDeliverySettingEditModal2 = _interopRequireDefault(_SparePartDeliverySettingEditModal);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	
	// Elements
	
	
	// Styles
	
	
	// Utils
	
	
	var SendPricesSettingType = {
	  None: 0,
	  AllBrand: 1,
	  SelectedBrand: 2
	};
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      type: 'edit',
	      orderEmail: '',
	      supplier: {
	        Id: 0,
	        CompanyName: '',
	        Address: '',
	        ZipCode: '',
	        City: '',
	        PhoneNumber: '',
	        PhoneCode: _this.props.phonecode,
	        Note: '',
	        Active: true,
	        PickupSelf: false,
	        AutoOrder: false,
	        Contacts: [],
	        CustomerNumber: '',
	        IncludeRequisitionNumberInMail: false,
	        DeliverySettings: [],
	        DeliverySettingsUrgent: [],
	        DracarCompanyStoreId: '',
	        SendPricesSettingType: SendPricesSettingType.None,
	        SparePartBrandEmailRules: [],
	        OrderingReplyEmail: '',
	        ReplyToCompanyMail: false,
	        CompanyContactPhoneNumber: '',
	        CompanyContactPhoneCode: _this.props.phonecode
	      },
	
	      SelectedSparePartBrandEmailRule: '',
	      brands: [],
	      dracarStores: [],
	      newDeliveryRule: {},
	      OrderBefore: '10:00',
	      ExpectedDeliveryDays: 0,
	      ExpectedDeliveryTime: '15:00',
	
	      showDeliverySettingModal: {}
	    };
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onInputChangeSave = _this.onInputChangeSave.bind(_this);
	    _this.updateSupplier = _this.updateSupplier.bind(_this);
	    _this.saveAddSupplier = _this.saveAddSupplier.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.onPhoneBlur = _this.onPhoneBlur.bind(_this);
	    _this.renderContacts = _this.renderContacts.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSupplier(this.props);
	      this.getDracarStores();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.item.Id !== nextProps.item.Id) {
	        this.getSupplier(nextProps);
	      }
	    }
	  }, {
	    key: 'getSupplier',
	    value: function getSupplier(props) {
	      var _this2 = this;
	
	      if (typeof props.item.Id !== 'undefined' && props.item.Id > 0) {
	        this.props.getSupplier(props.item.Id).then(function (res) {
	          _this2.setState({
	            supplier: res.data
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'getDracarStores',
	    value: function getDracarStores() {
	      var _this3 = this;
	
	      this.props.getDracarStores(this.props.auth.user.ShopId).then(function (res) {
	        _this3.setState({
	          dracarStores: res.data.DracarCompanyStores
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'updateSupplier',
	    value: function updateSupplier() {
	      var _this4 = this;
	
	      this.props.createSaveSupplier(this.state.supplier).then(function (res) {
	        _this4.props.onSave(res.data, _this4.state.type);
	        var newState = { supplier: res.data };
	        if (_this4.state.type === 'create') {
	          newState.type = 'edit';
	        }
	        _this4.setState(_extends({}, newState));
	      }, function (err) {
	        // Toastr
	        if (Array.isArray(err.response.data.Errors) && err.response.data.Errors.length > 0) {
	          var errors = err.response.data.Errors;
	          var errText = '';
	          for (var i = 0; i < errors.length; i++) {
	            var dictKey = errors[i].DictionaryKey;
	            if (errText !== '') errText += '<br/>';
	            errText += (0, _helpers.translation)(dictKey);
	          }
	          window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('16431'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'saveAddSupplier',
	    value: function saveAddSupplier() {
	      console.log('save suplier');
	      if (this.state.type !== 'create') this.updateSupplier();
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(name, e) {
	      console.log('onInputChange', name, e);
	
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (e === undefined) {
	          e = name;
	        }
	        name = e.target.name;
	        value = e.target.value;
	      }
	
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	
	      this.setState({
	        supplier: _extends({}, this.state.supplier, _defineProperty({}, name, value))
	      });
	    }
	  }, {
	    key: 'onInputChangeSave',
	    value: function onInputChangeSave(name, e) {
	      var value = '';
	      if (_moment2.default.isMoment(e)) {
	        value = e;
	      } else {
	        if (e === undefined) {
	          e = name;
	        }
	        name = e.target.name;
	        value = e.target.value;
	      }
	
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	
	      if (e.target.type === 'radio') {
	        value = e.target.value;
	        name = 'SendPricesSettingType';
	      }
	
	      this.setState({
	        supplier: _extends({}, this.state.supplier, _defineProperty({}, name, value))
	      }, this.saveAddSupplier);
	    }
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(name, e) {
	      var value = '';
	      value = name.target.value;
	      if (name.target.name === 'PhoneNumber') {
	        name = 'PhoneNumber';
	        this.setState({
	          supplier: _extends({}, this.state.supplier, _defineProperty({}, name, value))
	        });
	      } else {
	        this.setState({
	          supplier: _extends({}, this.state.supplier, {
	            PhoneCode: {
	              Id: Number(value.Id)
	            }
	          })
	        }, this.saveAddSupplier);
	      }
	    }
	  }, {
	    key: 'onPhoneBlur',
	    value: function onPhoneBlur(name, e) {
	      var value = '';
	      value = name.target.value;
	      if (name.target.name === 'PhoneNumber') {
	        name = 'PhoneNumber';
	        this.setState({
	          supplier: _extends({}, this.state.supplier, _defineProperty({}, name, value))
	        }, this.saveAddSupplier);
	      }
	    }
	  }, {
	    key: 'resetCreate',
	    value: function resetCreate() {
	      this.setState({
	        type: 'create',
	        orderEmail: '',
	        supplier: {
	          Id: 0,
	          CompanyName: '',
	          Address: '',
	          ZipCode: '',
	          City: '',
	          PhoneNumber: '',
	          PhoneCode: this.props.phonecode,
	          Note: '',
	          Active: true,
	          PickupSelf: false,
	          AutoOrder: false,
	          Contacts: [],
	          CustomerNumber: '',
	          OrderingReplyEmail: '',
	          ReplyToCompanyMail: false,
	          CompanyContactPhoneNumber: '',
	          CompanyContactPhoneCode: this.props.phonecode,
	          SparePartBrandEmailRules: []
	        }
	      });
	    }
	  }, {
	    key: 'renderSupplier',
	    value: function renderSupplier() {
	      var supplier = this.state.supplier;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('16424') },
	        _react2.default.createElement(_text2.default, { name: 'CompanyName', value: supplier.CompanyName || '', onChange: this.onInputChange, onBlur: this.saveAddSupplier, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_text2.default, { name: 'Address', value: supplier.Address || '', onChange: this.onInputChange, onBlur: this.saveAddSupplier, labelText: (0, _helpers.translation)('25') }),
	        _react2.default.createElement(_text2.default, { name: 'ZipCode', value: supplier.ZipCode || '', onChange: this.onInputChange, onBlur: this.saveAddSupplier, labelText: (0, _helpers.translation)('40') }),
	        _react2.default.createElement(_text2.default, { name: 'City', value: supplier.City || '', onChange: this.onInputChange, onBlur: this.saveAddSupplier, labelText: (0, _helpers.translation)('37') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('38') },
	          _react2.default.createElement(_Phone2.default, { onChange: this.onPhoneChange, onBlur: this.onPhoneBlur, code: supplier.PhoneCode || '', number: supplier.PhoneNumber || '' })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'CustomerNumber', value: supplier.CustomerNumber || '', onChange: this.onInputChange, onBlur: this.saveAddSupplier, labelText: (0, _helpers.translation)('16515') }),
	        _react2.default.createElement(_textarea2.default, { name: 'Note', onChange: this.onInputChange, value: supplier.Note || '', onBlur: this.saveAddSupplier, labelText: (0, _helpers.translation)('93') }),
	        _react2.default.createElement(_switch2.default, { name: 'Active', checked: supplier.Active || false, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)('295') })
	      );
	    }
	  }, {
	    key: 'renderSparePartBrandEmail',
	    value: function renderSparePartBrandEmail() {
	      var _this5 = this;
	
	      var supplier = this.state.supplier;
	
	      var cols = ['auto', '48px'];
	      var newBrand = {
	        id: 0,
	        BrandName: this.state.SelectedSparePartBrandEmailRule,
	        IsDeleted: false
	      };
	
	      var onClick = function onClick() {
	        _this5.setState({
	          supplier: _extends({}, supplier, {
	            SparePartBrandEmailRules: [newBrand]
	          })
	        }, _this5.saveAddSupplier);
	        _this5.state.SelectedSparePartBrandEmailRule = '';
	      };
	
	      var onChange = function onChange(e) {
	        _this5.setState(_defineProperty({}, e.target.name, e.target.value));
	      };
	
	      var renderSelectedBrand = function renderSelectedBrand(brand, key) {
	        var onDelete = function onDelete(_) {
	          brand.IsDeleted = true;
	          _this5.setState({
	            supplier: _extends({}, supplier, {
	              SparePartBrandEmailRules: [].concat(_toConsumableArray(supplier.SparePartBrandEmailRules))
	            })
	          }, _this5.saveAddSupplier);
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { key: key, cols: cols, spacing: 1 },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            brand.BrandName
	          ),
	          _react2.default.createElement(_removeButton2.default, { onClick: onDelete, size: 'm' })
	        );
	      };
	
	      var brandOptions = this.props.brands.map(function (b, index) {
	        if (index === 0) {
	          return { value: b.Name, label: (0, _helpers.translation)(b.Name), disabled: true };
	        }
	
	        return { value: b.Name, label: b.Name };
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        supplier.SparePartBrandEmailRules.map(renderSelectedBrand),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, spacing: 1 },
	          _react2.default.createElement(_dropDown2.default, { name: 'SelectedSparePartBrandEmailRule', value: this.state.SelectedSparePartBrandEmailRule, onChange: onChange, options: brandOptions }),
	          _react2.default.createElement(_addButton2.default, { onClick: onClick })
	        )
	      );
	    }
	  }, {
	    key: 'renderContacts',
	    value: function renderContacts() {
	      var _this6 = this;
	
	      var _state = this.state,
	          supplier = _state.supplier,
	          orderEmail = _state.orderEmail;
	
	      var cols = ['auto', '48px'];
	
	      var onClick = function onClick(_) {
	        _this6.setState({
	          orderEmail: '',
	          supplier: _extends({}, supplier, {
	            Contacts: [].concat(_toConsumableArray(supplier.Contacts), [{ Email: orderEmail }])
	          })
	        }, _this6.saveAddSupplier);
	      };
	
	      var onChange = function onChange(e) {
	        _this6.setState(_defineProperty({}, e.target.name, e.target.value));
	      };
	
	      var renderContact = function renderContact(contact, key) {
	        var onDelete = function onDelete(_) {
	          contact.IsDeleted = true;
	          _this6.setState({
	            supplier: _extends({}, supplier, {
	              Contacts: [].concat(_toConsumableArray(supplier.Contacts))
	            })
	          }, _this6.saveAddSupplier);
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { key: key, cols: cols, spacing: 1 },
	          _react2.default.createElement(_text2.default, { readOnly: true, value: contact.Email, size: 'm' }),
	          _react2.default.createElement(_removeButton2.default, { onClick: onDelete, size: 'm' })
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, spacing: 1 },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            (0, _helpers.translation)('17862')
	          ),
	          _react2.default.createElement('div', null)
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: cols, spacing: 1 },
	          _react2.default.createElement(_text2.default, { name: 'orderEmail', value: orderEmail, onChange: onChange }),
	          _react2.default.createElement(_addButton2.default, { onClick: onClick })
	        ),
	        supplier.Contacts.map(renderContact)
	      );
	    }
	  }, {
	    key: 'renderBooking',
	    value: function renderBooking() {
	      var _this7 = this;
	
	      var supplier = this.state.supplier;
	      var usesDracar = function usesDracar() {
	        return _this7.props.dracarUsable;
	      };
	      var dracarStoreList = function dracarStoreList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.StoreId },
	          val.StoreName
	        );
	      };
	
	      var autoOrderSwitchEnabled = supplier && supplier.Contacts && supplier.Contacts.some(function (x) {
	        return x.Email && x.Email.trim() !== '';
	      });
	      var keyLoopStoreText = '';
	      switch (this.props.auth.accountingSystem) {
	        case 4:
	          keyLoopStoreText = 16761;
	          break;
	        case 6:
	          keyLoopStoreText = 18148;
	          break;
	      }
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('16426') },
	        this.renderContacts(),
	        _react2.default.createElement(_switch2.default, { name: 'AutoOrder', disabled: !autoOrderSwitchEnabled, checked: supplier.AutoOrder || false, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)('16428') }),
	        _react2.default.createElement(_switch2.default, { name: 'IncludeRequisitionNumberInMail', checked: supplier.IncludeRequisitionNumberInMail, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)('16582') }),
	        usesDracar() && _react2.default.createElement(
	          _dropDown2.default,
	          { labelText: keyLoopStoreText, name: 'DracarCompanyStoreId', value: supplier.DracarCompanyStoreId, onChange: this.onInputChangeSave },
	          _react2.default.createElement(
	            'option',
	            { value: '0' },
	            (0, _helpers.translation)('16762')
	          ),
	          this.state.dracarStores.map(dracarStoreList)
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          (0, _helpers.translation)('18069')
	        ),
	        _react2.default.createElement(_radio2.default, { name: 'AllBrand', value: SendPricesSettingType.AllBrand, checked: supplier.SendPricesSettingType === SendPricesSettingType.AllBrand, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)('18070') }),
	        _react2.default.createElement(_radio2.default, { name: 'None', value: SendPricesSettingType.None, checked: supplier.SendPricesSettingType === SendPricesSettingType.None, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)('433') }),
	        _react2.default.createElement(_radio2.default, { name: 'SelectedBrand', value: SendPricesSettingType.SelectedBrand, checked: supplier.SendPricesSettingType === SendPricesSettingType.SelectedBrand, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)('18071') }),
	        this.renderSparePartBrandEmail()
	      );
	    }
	  }, {
	    key: 'renderOrderingReply',
	    value: function renderOrderingReply() {
	      var _this8 = this;
	
	      var supplier = this.state.supplier;
	
	      var onCompanyContactPhoneChange = function onCompanyContactPhoneChange(name) {
	        var value = '';
	        value = name.target.value;
	        if (name.target.name === 'PhoneNumber') {
	          name = 'CompanyContactPhoneNumber';
	          _this8.setState({
	            supplier: _extends({}, _this8.state.supplier, _defineProperty({}, name, value))
	          });
	        } else {
	          _this8.setState({
	            supplier: _extends({}, _this8.state.supplier, {
	              CompanyContactPhoneCode: {
	                Id: Number(value.Id)
	              }
	            })
	          }, _this8.saveAddSupplier);
	        }
	      };
	
	      var onCompanyPhoneBlur = function onCompanyPhoneBlur(name) {
	        var value = '';
	        value = name.target.value;
	        if (name.target.name === 'PhoneNumber') {
	          name = 'CompanyContactPhoneNumber';
	          _this8.setState({
	            supplier: _extends({}, _this8.state.supplier, _defineProperty({}, name, value))
	          }, _this8.saveAddSupplier);
	        }
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('18077') },
	        _react2.default.createElement(_text2.default, { name: 'OrderingReplyEmail', value: supplier.OrderingReplyEmail || '', onChange: this.onInputChange, onBlur: this.saveAddSupplier, labelText: (0, _helpers.translation)('151') }),
	        _react2.default.createElement(_switch2.default, { name: 'ReplyToCompanyMail', checked: supplier.ReplyToCompanyMail || false, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)('18074') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('38') },
	          _react2.default.createElement(_Phone2.default, { onChange: onCompanyContactPhoneChange, onBlur: onCompanyPhoneBlur, code: supplier.CompanyContactPhoneCode || '', number: supplier.CompanyContactPhoneNumber || '' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPickup',
	    value: function renderPickup() {
	      var supplier = this.state.supplier;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('579') },
	        _react2.default.createElement(_switch2.default, { name: 'PickupSelf', checked: supplier.PickupSelf || false, onChange: this.onInputChangeSave, labelText: (0, _helpers.translation)('16427') })
	      );
	    }
	
	    // RENDER NORMAL DELIVERY
	
	  }, {
	    key: 'renderDeliverySettings',
	    value: function renderDeliverySettings() {
	      var _this9 = this;
	
	      var supplier = this.state.supplier;
	      var deliveryCols = [1, 1, 1, '32px'];
	
	      var onChange = function onChange(e) {
	        var _e$target = e.target,
	            name = _e$target.name,
	            value = _e$target.value;
	
	
	        _this9.setState(_defineProperty({}, name, value));
	      };
	
	      var updateDeliverySetting = function updateDeliverySetting(setting) {
	        return _this9.props.updateSparePartDeliverySetting(setting).then(function () {
	          _this9.getSupplier(_this9.props);
	          // window.toastr.success(translation('16429'), translation('13424'))
	        }).catch(function () {
	          window.toastr.error('', (0, _helpers.translation)('216'));
	        });
	      };
	
	      var addSetting = function addSetting() {
	        var _state2 = _this9.state,
	            supplier = _state2.supplier,
	            brands = _state2.brands;
	
	
	        if (brands.length === 0) {
	          window.toastr.error((0, _helpers.translation)('16525'), (0, _helpers.translation)('216'));
	          return;
	        }
	
	        var newSetting = {
	          SparePartSupplierId: supplier.Id,
	          DeliveryType: 1,
	          BrandRules: [].concat(_toConsumableArray(brands.map(function (b) {
	            return { BrandName: b };
	          })))
	        };
	
	        updateDeliverySetting(newSetting).then(function () {
	          _this9.setState({
	            brands: []
	          });
	        });
	      };
	
	      // DELIVERY SETTING
	      var renderDeliverySetting = function renderDeliverySetting(setting, key) {
	        var onEditBrandSave = function onEditBrandSave(updatedBrands) {
	          for (var i = 0; i < setting.BrandRules.length; i++) {
	            var brandRule = setting.BrandRules[i];
	
	            if (!updatedBrands.includes(brandRule.BrandName)) {
	              brandRule.IsDeleted = true;
	            }
	          }
	
	          var newBrands = updatedBrands.filter(function (ub) {
	            return !setting.BrandRules.some(function (br) {
	              return br.BrandName === ub;
	            });
	          });
	          setting.BrandRules = [].concat(_toConsumableArray(setting.BrandRules), _toConsumableArray(newBrands.map(function (nb) {
	            return { BrandName: nb };
	          })));
	
	          return updateDeliverySetting(setting);
	        };
	
	        var toggleBrandModal = function toggleBrandModal() {
	          _this9.setState({
	            showDeliverySettingModal: _defineProperty({}, setting.Id, !_this9.state.showDeliverySettingModal[setting.Id])
	          });
	        };
	
	        // DELIVERY RULE
	        var renderDeliveryRule = function renderDeliveryRule(deliveryRule, key) {
	          var removeDeliveryRule = function removeDeliveryRule() {
	            var settingObj = _extends({}, setting);
	
	            var rule = settingObj.DeliveryRules.find(function (dr) {
	              return dr.Id === deliveryRule.Id;
	            });
	            rule.IsDeleted = true;
	
	            updateDeliverySetting(settingObj);
	          };
	
	          var formatTime = function formatTime(time) {
	            return time.substring(0, 5);
	          };
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: deliveryCols, align: 'center', spacing: 1, key: key },
	            _react2.default.createElement(
	              'div',
	              null,
	              formatTime(deliveryRule.OrderBefore)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              deliveryRule.ExpectedDeliveryDays
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              formatTime(deliveryRule.ExpectedDeliveryTime)
	            ),
	            _react2.default.createElement(_removeButton2.default, { onClick: removeDeliveryRule, size: 's' })
	          );
	        };
	
	        // NEW DELIVERY RULE
	        var renderNewDeliveryRule = function renderNewDeliveryRule() {
	          var _ref = _this9.state.newDeliveryRule[setting.Id] || { OrderBefore: '', ExpectedDeliveryDays: 0, ExpectedDeliveryTime: '' },
	              OrderBefore = _ref.OrderBefore,
	              ExpectedDeliveryDays = _ref.ExpectedDeliveryDays,
	              ExpectedDeliveryTime = _ref.ExpectedDeliveryTime;
	
	          var onNewDeliveryChange = function onNewDeliveryChange(e) {
	            var _e$target2 = e.target,
	                name = _e$target2.name,
	                value = _e$target2.value;
	
	
	            if (name === 'ExpectedDeliveryDays') {
	              if (!/^[0-9]*$/.test(value)) {
	                return;
	              }
	
	              // Only 0-50 values
	              value = parseInt(value);
	              if (!isNaN(value)) {
	                if (value > 50) value = 50;else if (value < 0) value = 0;
	              }
	              value = value || '';
	            }
	
	            _this9.setState({
	              newDeliveryRule: _extends({}, _this9.state.newDeliveryRule, _defineProperty({}, setting.Id, _extends({}, _this9.state.newDeliveryRule[setting.Id], _defineProperty({}, name, value))))
	            });
	          };
	
	          var validateInput = function validateInput() {
	            if (!OrderBefore || typeof parseInt(ExpectedDeliveryDays) !== 'number' || !ExpectedDeliveryTime) {
	              window.toastr.error((0, _helpers.translation)('16531'), (0, _helpers.translation)('216'));
	              return false;
	            }
	
	            if (!ExpectedDeliveryDays || ExpectedDeliveryDays === 0) {
	              var beforeTime = parseInt(OrderBefore.replace(':', ''));
	              var afterTime = parseInt(ExpectedDeliveryTime.replace(':', ''));
	
	              if (afterTime < beforeTime) {
	                window.toastr.error((0, _helpers.translation)('16521'), (0, _helpers.translation)('216'));
	                return false;
	              }
	            }
	
	            return true;
	          };
	
	          var addNewDeliveryRule = function addNewDeliveryRule() {
	            if (!validateInput()) {
	              return;
	            }
	
	            var settingObj = _extends({}, setting);
	
	            var newDeliveryRule = {
	              OrderBefore: OrderBefore,
	              ExpectedDeliveryDays: ExpectedDeliveryDays,
	              ExpectedDeliveryTime: ExpectedDeliveryTime
	            };
	
	            settingObj.DeliveryRules.push(newDeliveryRule);
	
	            updateDeliverySetting(settingObj).then(function () {
	              _this9.setState({
	                newDeliveryRule: _extends({}, _this9.state.newDeliveryRule, _defineProperty({}, setting.Id, null))
	              });
	            });
	          };
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: deliveryCols, align: 'center' },
	            _react2.default.createElement(_time2.default, { name: 'OrderBefore', value: OrderBefore || '', onChange: onNewDeliveryChange, size: 'm', simple: true }),
	            _react2.default.createElement(_text2.default, { name: 'ExpectedDeliveryDays', value: ExpectedDeliveryDays || 0, onChange: onNewDeliveryChange, size: 'm', simple: true }),
	            _react2.default.createElement(_time2.default, { name: 'ExpectedDeliveryTime', value: ExpectedDeliveryTime || '', onChange: onNewDeliveryChange, onBlur: function onBlur() {
	                return validateInput();
	              }, size: 'm', simple: true }),
	            _react2.default.createElement(_addButton2.default, { onClick: addNewDeliveryRule, size: 'm' })
	          );
	        };
	
	        // BRAND RULE
	        var renderBrandRule = function renderBrandRule(brandRule, key) {
	          var onBrandChange = function onBrandChange(e) {
	            var _e$target3 = e.target,
	                name = _e$target3.name,
	                value = _e$target3.value,
	                checked = _e$target3.checked,
	                type = _e$target3.type;
	
	
	            var rule = setting.BrandRules.find(function (br) {
	              return br.Id === brandRule.Id;
	            });
	            if (name === 'Discount') {
	              rule[name] = value;
	            } else if (name === 'StockItemsOnly') {
	              rule[name] = checked;
	            }
	
	            var settingIndex = supplier.DeliverySettings.findIndex(function (dr) {
	              return dr.Id === setting.Id;
	            });
	            supplier.DeliverySettings[settingIndex] = setting;
	
	            _this9.setState({
	              supplier: supplier
	            }, function () {
	              if (type === 'checkbox') {
	                var updatedSetting = _this9.state.supplier.DeliverySettings.find(function (dr) {
	                  return dr.Id === setting.Id;
	                });
	                updateDeliverySetting(updatedSetting);
	              }
	            });
	          };
	
	          var onBlur = function onBlur(e) {
	            var settingObj = _extends({}, setting);
	
	            updateDeliverySetting(settingObj);
	          };
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { align: 'center', key: key },
	            _react2.default.createElement(
	              'div',
	              null,
	              brandRule.BrandName
	            ),
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [1, 'max-content'], align: 'center' },
	              _react2.default.createElement(_text2.default, { name: 'Discount', value: brandRule.Discount, onChange: onBrandChange, onBlur: onBlur, size: 'm', simple: true }),
	              (0, _helpers.translation)('16523')
	            ),
	            _react2.default.createElement(_check2.default, { name: 'StockItemsOnly', checked: brandRule.StockItemsOnly, onChange: onBrandChange, onBlur: onBlur, labelText: 16524 })
	          );
	        };
	
	        var label = setting.BrandRules.reduce(function (prev, rule, index) {
	          if (index === 0) {
	            return rule.BrandName;
	          }
	
	          return prev + ', ' + rule.BrandName;
	        }, '');
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            _inline2.default,
	            null,
	            _react2.default.createElement(_panelHeader2.default, { text: label }),
	            _react2.default.createElement(_addButton2.default, { onClick: toggleBrandModal, size: 's' })
	          ),
	          setting.DeliveryRules.length === 0 && _react2.default.createElement(
	            'div',
	            { className: 'sparePartSupplier__danger' },
	            (0, _helpers.translation)('16522')
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: deliveryCols, spacing: 1 },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('16518')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('16519') + ' (0-50)'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('16520')
	            ),
	            _react2.default.createElement('div', null)
	          ),
	          setting.DeliveryRules.map(renderDeliveryRule),
	          renderNewDeliveryRule(),
	          _react2.default.createElement(_divider2.default, { size: 2, noLine: true }),
	          setting.BrandRules.map(renderBrandRule),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(_SparePartDeliverySettingEditModal2.default, {
	            show: _this9.state.showDeliverySettingModal[setting.Id],
	            selected: setting.BrandRules.map(function (br) {
	              return br.BrandName;
	            }),
	            onSave: onEditBrandSave,
	            onClose: toggleBrandModal
	          })
	        );
	      };
	
	      var brandOptions = this.props.brands.map(function (b, index) {
	        if (index === 0) {
	          return { value: b.Name, label: (0, _helpers.translation)(b.Name), disabled: true };
	        }
	
	        return { value: b.Name, label: b.Name };
	      });
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('193') },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('16517') },
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(_dropDown2.default, { name: 'brands', value: this.state.brands, onChange: onChange, options: brandOptions, isMulti: true }),
	            _react2.default.createElement(_addButton2.default, { onClick: addSetting })
	          )
	        ),
	        supplier.DeliverySettings.map(renderDeliverySetting)
	      );
	    }
	
	    // RENDER URGENT DELIVERY
	
	  }, {
	    key: 'renderUrgentDeliverySettings',
	    value: function renderUrgentDeliverySettings() {
	      var _this10 = this;
	
	      var supplier = this.state.supplier;
	      var deliveryCols = [1, 1, 1, '32px'];
	
	      var onChange = function onChange(e) {
	        var _e$target4 = e.target,
	            name = _e$target4.name,
	            value = _e$target4.value;
	
	
	        _this10.setState(_defineProperty({}, name, value));
	      };
	
	      var updateDeliverySetting = function updateDeliverySetting(setting) {
	        return _this10.props.updateSparePartDeliverySetting(setting).then(function () {
	          _this10.getSupplier(_this10.props);
	          // window.toastr.success(translation('16429'), translation('13424'))
	        }).catch(function () {
	          window.toastr.error('', (0, _helpers.translation)('216'));
	        });
	      };
	
	      var addSetting = function addSetting() {
	        var _state3 = _this10.state,
	            supplier = _state3.supplier,
	            brands = _state3.brands;
	
	
	        if (brands.length === 0) {
	          window.toastr.error((0, _helpers.translation)('16525'), (0, _helpers.translation)('216'));
	          return;
	        }
	
	        var newSetting = {
	          SparePartSupplierId: supplier.Id,
	          DeliveryType: 2,
	          BrandRules: [].concat(_toConsumableArray(brands.map(function (b) {
	            return { BrandName: b };
	          })))
	        };
	
	        updateDeliverySetting(newSetting).then(function () {
	          _this10.setState({
	            brands: []
	          });
	        });
	      };
	
	      // DELIVERY SETTING
	      var renderDeliverySetting = function renderDeliverySetting(setting, key) {
	        var onEditBrandSave = function onEditBrandSave(updatedBrands) {
	          for (var i = 0; i < setting.BrandRules.length; i++) {
	            var brandRule = setting.BrandRules[i];
	
	            if (!updatedBrands.includes(brandRule.BrandName)) {
	              brandRule.IsDeleted = true;
	            }
	          }
	
	          var newBrands = updatedBrands.filter(function (ub) {
	            return !setting.BrandRules.some(function (br) {
	              return br.BrandName === ub;
	            });
	          });
	          setting.BrandRules = [].concat(_toConsumableArray(setting.BrandRules), _toConsumableArray(newBrands.map(function (nb) {
	            return { BrandName: nb };
	          })));
	
	          return updateDeliverySetting(setting);
	        };
	
	        var toggleBrandModal = function toggleBrandModal() {
	          _this10.setState({
	            showDeliverySettingModal: _defineProperty({}, setting.Id, !_this10.state.showDeliverySettingModal[setting.Id])
	          });
	        };
	
	        // DELIVERY RULE
	        var renderDeliveryRule = function renderDeliveryRule(deliveryRule, key) {
	          var removeDeliveryRule = function removeDeliveryRule() {
	            var settingObj = _extends({}, setting);
	
	            var rule = settingObj.DeliveryRules.find(function (dr) {
	              return dr.Id === deliveryRule.Id;
	            });
	            rule.IsDeleted = true;
	
	            updateDeliverySetting(settingObj);
	          };
	
	          var formatTime = function formatTime(time) {
	            return time.substring(0, 5);
	          };
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: deliveryCols, align: 'center', spacing: 1, key: key },
	            _react2.default.createElement(
	              'div',
	              null,
	              formatTime(deliveryRule.OrderBefore)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              deliveryRule.ExpectedDeliveryDays
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              formatTime(deliveryRule.ExpectedDeliveryTime)
	            ),
	            _react2.default.createElement(_removeButton2.default, { onClick: removeDeliveryRule, size: 's' })
	          );
	        };
	
	        // NEW DELIVERY RULE
	        var renderNewDeliveryRule = function renderNewDeliveryRule() {
	          var _ref2 = _this10.state.newDeliveryRule[setting.Id] || { OrderBefore: '', ExpectedDeliveryDays: 0, ExpectedDeliveryTime: '' },
	              OrderBefore = _ref2.OrderBefore,
	              ExpectedDeliveryDays = _ref2.ExpectedDeliveryDays,
	              ExpectedDeliveryTime = _ref2.ExpectedDeliveryTime;
	
	          var onNewDeliveryChange = function onNewDeliveryChange(e) {
	            var _e$target5 = e.target,
	                name = _e$target5.name,
	                value = _e$target5.value;
	
	
	            if (name === 'ExpectedDeliveryDays') {
	              if (!/^[0-9]*$/.test(value)) {
	                return;
	              }
	
	              // Only 0-50 values
	              value = parseInt(value);
	              if (!isNaN(value)) {
	                if (value > 50) value = 50;else if (value < 0) value = 0;
	              }
	              value = value || '';
	            }
	
	            _this10.setState({
	              newDeliveryRule: _extends({}, _this10.state.newDeliveryRule, _defineProperty({}, setting.Id, _extends({}, _this10.state.newDeliveryRule[setting.Id], _defineProperty({}, name, value))))
	            });
	          };
	
	          var validateInput = function validateInput() {
	            if (!OrderBefore || typeof parseInt(ExpectedDeliveryDays) !== 'number' || !ExpectedDeliveryTime) {
	              window.toastr.error((0, _helpers.translation)('16531'), (0, _helpers.translation)('216'));
	              return false;
	            }
	
	            if (!ExpectedDeliveryDays || ExpectedDeliveryDays === 0) {
	              var beforeTime = parseInt(OrderBefore.replace(':', ''));
	              var afterTime = parseInt(ExpectedDeliveryTime.replace(':', ''));
	
	              if (afterTime < beforeTime) {
	                window.toastr.error((0, _helpers.translation)('16521'), (0, _helpers.translation)('216'));
	                return false;
	              }
	            }
	
	            return true;
	          };
	
	          var addNewDeliveryRule = function addNewDeliveryRule() {
	            if (!validateInput()) {
	              return;
	            }
	
	            var settingObj = _extends({}, setting);
	
	            var newDeliveryRule = {
	              OrderBefore: OrderBefore,
	              ExpectedDeliveryDays: ExpectedDeliveryDays,
	              ExpectedDeliveryTime: ExpectedDeliveryTime
	            };
	
	            settingObj.DeliveryRules.push(newDeliveryRule);
	
	            updateDeliverySetting(settingObj).then(function () {
	              _this10.setState({
	                newDeliveryRule: _extends({}, _this10.state.newDeliveryRule, _defineProperty({}, setting.Id, null))
	              });
	            });
	          };
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: deliveryCols, align: 'center' },
	            _react2.default.createElement(_time2.default, { name: 'OrderBefore', value: OrderBefore || '', onChange: onNewDeliveryChange, size: 'm', simple: true }),
	            _react2.default.createElement(_text2.default, { name: 'ExpectedDeliveryDays', value: ExpectedDeliveryDays || 0, onChange: onNewDeliveryChange, size: 'm', simple: true }),
	            _react2.default.createElement(_time2.default, { name: 'ExpectedDeliveryTime', value: ExpectedDeliveryTime || '', onChange: onNewDeliveryChange, onBlur: function onBlur() {
	                return validateInput();
	              }, size: 'm', simple: true }),
	            _react2.default.createElement(_addButton2.default, { onClick: addNewDeliveryRule, size: 'm' })
	          );
	        };
	
	        // BRAND RULE
	        var renderBrandRule = function renderBrandRule(brandRule, key) {
	          var onBrandChange = function onBrandChange(e) {
	            var _e$target6 = e.target,
	                name = _e$target6.name,
	                value = _e$target6.value,
	                checked = _e$target6.checked,
	                type = _e$target6.type;
	
	
	            var rule = setting.BrandRules.find(function (br) {
	              return br.Id === brandRule.Id;
	            });
	            if (name === 'Discount') {
	              rule[name] = value;
	            } else if (name === 'StockItemsOnly') {
	              rule[name] = checked;
	            }
	
	            var settingIndex = supplier.DeliverySettingsUrgent.findIndex(function (dr) {
	              return dr.Id === setting.Id;
	            });
	            supplier.DeliverySettingsUrgent[settingIndex] = setting;
	
	            _this10.setState({
	              supplier: supplier
	            }, function () {
	              if (type === 'checkbox') {
	                var updatedSetting = _this10.state.supplier.DeliverySettingsUrgent.find(function (dr) {
	                  return dr.Id === setting.Id;
	                });
	                updateDeliverySetting(updatedSetting);
	              }
	            });
	          };
	
	          var onBlur = function onBlur(e) {
	            var settingObj = _extends({}, setting);
	
	            updateDeliverySetting(settingObj);
	          };
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { align: 'center', key: key },
	            _react2.default.createElement(
	              'div',
	              null,
	              brandRule.BrandName
	            ),
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [1, 'max-content'], align: 'center' },
	              _react2.default.createElement(_text2.default, { name: 'Discount', value: brandRule.Discount, onChange: onBrandChange, onBlur: onBlur, size: 'm', simple: true }),
	              (0, _helpers.translation)('16523')
	            ),
	            _react2.default.createElement(_check2.default, { name: 'StockItemsOnly', checked: brandRule.StockItemsOnly, onChange: onBrandChange, onBlur: onBlur, labelText: 16524 })
	          );
	        };
	
	        var label = setting.BrandRules.reduce(function (prev, rule, index) {
	          if (index === 0) {
	            return rule.BrandName;
	          }
	
	          return prev + ', ' + rule.BrandName;
	        }, '');
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            _inline2.default,
	            null,
	            _react2.default.createElement(_panelHeader2.default, { text: label }),
	            _react2.default.createElement(_addButton2.default, { onClick: toggleBrandModal, size: 's' })
	          ),
	          setting.DeliveryRules.length === 0 && _react2.default.createElement(
	            'div',
	            { className: 'sparePartSupplier__danger' },
	            (0, _helpers.translation)('16522')
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: deliveryCols, spacing: 1 },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('16518')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('16519') + ' (0-50)'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('16520')
	            ),
	            _react2.default.createElement('div', null)
	          ),
	          setting.DeliveryRules.map(renderDeliveryRule),
	          renderNewDeliveryRule(),
	          _react2.default.createElement(_divider2.default, { size: 2, noLine: true }),
	          setting.BrandRules.map(renderBrandRule),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(_SparePartDeliverySettingEditModal2.default, {
	            show: _this10.state.showDeliverySettingModal[setting.Id],
	            selected: setting.BrandRules.map(function (br) {
	              return br.BrandName;
	            }),
	            onSave: onEditBrandSave,
	            onClose: toggleBrandModal
	          })
	        );
	      };
	
	      var brandOptions = this.props.brands.map(function (b, index) {
	        if (index === 0) {
	          return { value: b.Name, label: (0, _helpers.translation)(b.Name), disabled: true };
	        }
	
	        return { value: b.Name, label: b.Name };
	      });
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('17904') },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('16517') },
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(_dropDown2.default, { name: 'brands', value: this.state.brands, onChange: onChange, options: brandOptions, isMulti: true }),
	            _react2.default.createElement(_addButton2.default, { onClick: addSetting })
	          )
	        ),
	        supplier.DeliverySettingsUrgent.map(renderDeliverySetting)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderSupplier()
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          this.renderBooking(),
	          this.renderOrderingReply(),
	          this.renderPickup()
	        ),
	        this.state.supplier.Id > 0 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            { span: 3 },
	            this.renderDeliverySettings()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            { span: 3 },
	            this.renderUrgentDeliverySettings()
	          )
	        )
	      );
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes,
	    brands: state.common.brands,
	    dracarUsable: state.auth.permissions.DracarUsable
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getSupplier: _spareparts.getSupplier,
	  createSaveSupplier: _spareparts.createSaveSupplier,
	  updateSparePartDeliverySetting: _spareparts.updateSparePartDeliverySetting,
	  getDracarStores: _settings.getDracarStores
	}, null, { withRef: true })(View);

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _spareparts = __webpack_require__(108);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	var _View = __webpack_require__(983);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	
	// Actions
	
	
	// import components
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var SparePartSuppliers = function (_Component) {
	  _inherits(SparePartSuppliers, _Component);
	
	  function SparePartSuppliers(props) {
	    _classCallCheck(this, SparePartSuppliers);
	
	    var _this = _possibleConstructorReturn(this, (SparePartSuppliers.__proto__ || Object.getPrototypeOf(SparePartSuppliers)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      search: '',
	      includeInactive: false,
	      suppliers: [],
	      activeItem: {}
	    };
	
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(SparePartSuppliers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSuppliers();
	
	      var supplierId = this.props.router.location.query.supplierId;
	      if (!isNaN(supplierId)) {
	        this.setState({
	          view: 'item',
	          activeItem: {
	            Id: parseInt(supplierId)
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getSuppliers',
	    value: function getSuppliers() {
	      var _this2 = this;
	
	      this.props.getListSimple(false).then(function (res) {
	        _this2.setState({
	          suppliers: res.data
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var suppliers = [].concat(_toConsumableArray(this.state.suppliers));
	      var activeItem = void 0;
	      if (type === 'create') {
	        suppliers.push({
	          Id: data.Id,
	          Name: data.CompanyName,
	          Active: data.Active
	        });
	        type = 'item';
	        activeItem = {
	          Id: data.Id
	          // Toastr
	          // window.toastr.success(translation('19425'), translation('13424'))
	        };
	      } else {
	        suppliers.map(function (val, key) {
	          if (val.Id === data.Id) {
	            val.Name = data.CompanyName;
	            val.Active = data.Active;
	          }
	        });
	        type = 'item';
	        activeItem = {
	          Id: data.Id
	          // Toastr
	          // window.toastr.success(translation('16429'), translation('13424'))
	        };
	      }
	      this.setState({
	        suppliers: suppliers,
	        view: type,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { size: 'm', spacing: 0, labelText: (0, _helpers.translation)(1797), ariaText: (0, _helpers.translation)('16432'), onClick: this.changeView.bind(this, 'create') })
	      );
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({
	          search: e.target.value
	        });
	      }
	      if (e.target.name === 'Inactive') {
	        this.setState({
	          includeInactive: e.target.checked
	        });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      if (key.Name === null || key.Name === undefined) {
	        return false;
	      }
	      if (this.state.search === undefined || this.state.search === null) {
	        return true;
	      }
	      if (key.Name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.Active : true)) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.view.getWrappedInstance().updateSupplier();
	        };
	
	        return [_react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '0', isFixed: true },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') })
	        ), _react2.default.createElement(
	          _sideMenuCustomItem2.default,
	          { key: '1', isFixed: true },
	          _react2.default.createElement(_button2.default, { style: 'secondary', onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        )];
	      }
	
	      return this.state.suppliers.map(function (s) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: s.Name,
	          onClick: function onClick() {
	            return _this3.onSelectItem(s);
	          },
	          selected: s.Id === _this3.state.activeItem.Id,
	          inactive: !s.Active,
	          key: s.Id
	        });
	      });
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { router: this.props.router, ref: 'view', item: this.state.activeItem, onSave: this.onSave });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'suppliers__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, icon: 'menu/Customers-White.png', renderRight: function renderRight() {
	            return _this4.headerButtonsRight();
	          } }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { showFilter: this.state.view !== 'create', hideInactiveCheck: this.state.view === 'create' },
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'suppliers__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return SparePartSuppliers;
	}(_react.Component);
	
	SparePartSuppliers.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getListSimple: _spareparts.getListSimple,
	  createSaveSupplier: _spareparts.createSaveSupplier
	})(SparePartSuppliers);

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _shops = __webpack_require__(79);
	
	var _customerGroup = __webpack_require__(107);
	
	var _auth = __webpack_require__(68);
	
	var _Phone = __webpack_require__(86);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	__webpack_require__(1478);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	
	// Elements
	
	
	// Styles
	
	
	// Utils
	
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View(props) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));
	
	    _this.state = {
	      shop: {
	        Active: true,
	        Address: '',
	        Alias: '',
	        CVR: '',
	        ChainId: _this.props.auth.user.ChainId,
	        City: '',
	        CompanyName: '',
	        Email: '',
	        Partners: [],
	        // PermissionModules: [],
	        PhoneCode: _this.props.phonecode,
	        PhoneNumber: '',
	        ShopId: 0,
	        ShopType: 0,
	        TakseringType: 0,
	        UserId: 0,
	        UserName: '',
	        ZipCode: '',
	        SubscriptionType: 0,
	        EstimationAnswer: 0
	      },
	      CustomerGroupAgreements: [],
	      ShopOwners: [],
	      Employees: []
	    };
	    _this.renderCustomerGroups = _this.renderCustomerGroups.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.UpdateEstimationAnswer = _this.UpdateEstimationAnswer.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getShopInfoes(this.props);
	      window.addEventListener('resize', this.updateDimensions);
	      this.updateDimensions();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.getShopInfoes(nextProps);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var w = window;
	      var d = document;
	      var documentElement = d.documentElement;
	      var body = d.getElementsByTagName('body')[0];
	
	      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
	      var height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
	
	      this.setState({
	        dimensions: {
	          width: width,
	          height: height
	        }
	      });
	    }
	  }, {
	    key: 'getShopInfoes',
	    value: function getShopInfoes(props) {
	      var _this2 = this;
	
	      if (typeof props.item.ShopId !== 'undefined') {
	        props.getShop(props.item.ShopId).then(function (res) {
	          _this2.setState({
	            shop: res.data
	          });
	        });
	        props.getCustomerGroupAgreements(props.item.ShopId).then(function (res) {
	          _this2.setState({
	            CustomerGroupAgreements: res.data
	          });
	        });
	        props.getShopUsers(props.item.ShopId).then(function (res) {
	          _this2.setState({
	            ShopOwners: res.data.ShopOwners,
	            Employees: res.data.Employees
	          });
	        });
	      } else {
	        this.resetCreate();
	      }
	    }
	  }, {
	    key: 'loginAs',
	    value: function loginAs(id) {
	      var _this3 = this;
	
	      this.props.loginAs(id).then(function (res) {
	        _this3.props.router.push(res.data.StartScreen);
	      });
	    }
	  }, {
	    key: 'UpdateEstimationAnswer',
	    value: function UpdateEstimationAnswer(e) {
	      var _this4 = this;
	
	      var data = {
	        ShopId: this.props.item.ShopId,
	        EstimationAnswer: this.state.shop.EstimationAnswer
	      };
	      this.props.UpdateEstimationAnswer(data).then(function (res) {
	        _this4.setState({
	          shop: res.data
	        });
	      });
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      var value = e.target.value;
	      this.setState({
	        shop: _extends({}, this.state.shop, {
	          EstimationAnswer: value
	        })
	      }, this.UpdateEstimationAnswer);
	    }
	  }, {
	    key: 'renderShop',
	    value: function renderShop() {
	      var shop = this.state.shop;
	      var ActiveChecked = function ActiveChecked(type, active) {
	        if (active === type) {
	          return true;
	        }
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('14709') },
	        _react2.default.createElement(_text2.default, { name: 'CompanyName', value: shop.CompanyName || '', disabled: true, labelText: (0, _helpers.translation)('30') }),
	        _react2.default.createElement(_text2.default, { name: 'Alias', value: shop.Alias || '', disabled: true, labelText: (0, _helpers.translation)('1863') }),
	        _react2.default.createElement(_text2.default, { name: 'Address', value: shop.Address || '', disabled: true, labelText: (0, _helpers.translation)('25') }),
	        _react2.default.createElement(_text2.default, { name: 'ZipCode', value: shop.ZipCode || '', disabled: true, labelText: (0, _helpers.translation)('40') }),
	        _react2.default.createElement(_text2.default, { name: 'City', value: shop.City || '', disabled: true, labelText: (0, _helpers.translation)('37') }),
	        _react2.default.createElement(_text2.default, { name: 'CVR', value: shop.CVR || '', disabled: true, labelText: (0, _helpers.translation)('41') }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('38') },
	          _react2.default.createElement(_Phone2.default, {
	            onChange: this.onPhoneChange,
	            onBlur: this.onPhoneBlur,
	            code: shop.PhoneCode || '',
	            number: shop.PhoneNumber || '',
	            disabled: true })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'Email', value: shop.Email || '', disabled: true, labelText: (0, _helpers.translation)('1052') }),
	        _react2.default.createElement(_text2.default, { name: 'UserName', value: shop.UserName || '', disabled: true, labelText: (0, _helpers.translation)('1') }),
	        _react2.default.createElement(_switch2.default, { name: 'Active', value: 'true', checked: ActiveChecked(true, shop.Active) || false, disabled: true, labelText: (0, _helpers.translation)('295') })
	      );
	    }
	  }, {
	    key: 'renderSettings',
	    value: function renderSettings() {
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('6') },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('14711') },
	          _react2.default.createElement(_radio2.default, { id: 'WP_Estimation', name: 'SubscriptionType', value: '0', checked: this.state.shop.EstimationAnswer + '' === '0', onChange: this.onRadioChange, labelText: (0, _helpers.translation)('14712') }),
	          _react2.default.createElement(_radio2.default, { id: 'Both_Estimation', name: 'SubscriptionType', value: '1', checked: this.state.shop.EstimationAnswer + '' === '1', onChange: this.onRadioChange, labelText: (0, _helpers.translation)('736') }),
	          _react2.default.createElement(_radio2.default, { id: 'UL_Estimation', name: 'SubscriptionType', value: '2', checked: this.state.shop.EstimationAnswer + '' === '2', onChange: this.onRadioChange, labelText: (0, _helpers.translation)('14713') })
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomerGroups',
	    value: function renderCustomerGroups() {
	      var CustomerGroup = function CustomerGroup(val) {
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: val.CustomerGroupName },
	          val.AgreementNames.map(function (val) {
	            return _react2.default.createElement(
	              _label2.default,
	              { className: 'name' },
	              val
	            );
	          })
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('14710') },
	        this.state.CustomerGroupAgreements.map(CustomerGroup)
	      );
	    }
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers(Title, Users) {
	      var _this5 = this;
	
	      var User = function User(val, key) {
	        if (!(val.Id > 0)) {
	          return;
	        }
	        console.log('user', val);
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: val.Name, key: key },
	          _react2.default.createElement(_button2.default, { style: 'link', onClick: _this5.loginAs.bind(_this5, val.Id), labelText: (0, _helpers.translation)('57') })
	        );
	      };
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: Title },
	        Users.map(User)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.dimensions !== undefined && this.state.dimensions.width > 950 && this.state.dimensions.width < 1500) {
	        return _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderShop(),
	            this.renderSettings(),
	            this.renderCustomerGroups()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderUsers((0, _helpers.translation)('1860'), this.state.ShopOwners),
	            this.renderUsers((0, _helpers.translation)('10'), this.state.Employees)
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderShop()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderSettings()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderCustomerGroups()
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            this.renderUsers((0, _helpers.translation)('1860'), this.state.ShopOwners),
	            this.renderUsers((0, _helpers.translation)('10'), this.state.Employees)
	          )
	        );
	      }
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    phonecode: state.common.phonecode,
	    phonecodes: state.common.phonecodes
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getShop: _shops.getShop,
	  getCustomerGroupAgreements: _customerGroup.getCustomerGroupAgreements,
	  UpdateEstimationAnswer: _shops.UpdateEstimationAnswer,
	  getShopUsers: _shops.getShopUsers,
	  loginAs: _auth.loginAs
	}, null, { withRef: true })(View);

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _shops = __webpack_require__(79);
	
	__webpack_require__(1477);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _View = __webpack_require__(985);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isEqual } from 'lodash'
	
	
	// Actions
	
	
	// import styles
	
	
	// import components
	
	// import LeftMenu from '../../shared/components/Menus/LeftMenu'
	
	
	// Elements
	
	
	// Views
	
	
	// Utils
	
	
	var Subcontractors = function (_Component) {
	  _inherits(Subcontractors, _Component);
	
	  function Subcontractors(props) {
	    _classCallCheck(this, Subcontractors);
	
	    var _this = _possibleConstructorReturn(this, (Subcontractors.__proto__ || Object.getPrototypeOf(Subcontractors)).call(this, props));
	
	    _this.state = {
	      view: 'list',
	      search: '',
	      includeInactive: false,
	      shops: [],
	      activeItem: {}
	    };
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.searchList = _this.searchList.bind(_this);
	    _this.filterList = _this.filterList.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.createView = _this.createView.bind(_this);
	    _this.onSelectItem = _this.onSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Subcontractors, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getShops();
	    }
	  }, {
	    key: 'getShops',
	    value: function getShops() {
	      var _this2 = this;
	
	      this.props.getShops(this.props.auth.user.ChainId).then(function (res) {
	        _this2.setState({
	          shops: res.data
	        });
	        if (res.data.length === 0) {
	          _this2.changeView('create');
	        }
	      }, function () {
	        console.log('err');
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view) {
	      var activeItem = this.state.activeItem;
	      if (view === 'create') {
	        activeItem = {};
	      }
	      this.setState({
	        view: view,
	        activeItem: activeItem
	      });
	    }
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      if (this.state.view === 'create') return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'hint--left', 'aria-label': (0, _helpers.translation)('2055') },
	          _react2.default.createElement('img', { src: '/images/icons/circle_plus22-black.png', onClick: this.changeView.bind(this, 'create'), className: 'icon' })
	        )
	      );
	    }
	  }, {
	    key: 'searchList',
	    value: function searchList(e) {
	      if (e.target.name === 'SearchText') {
	        this.setState({
	          search: e.target.value
	        });
	      }
	      if (e.target.name === 'Inactive') {
	        this.setState({
	          includeInactive: e.target.checked
	        });
	      }
	    }
	  }, {
	    key: 'filterList',
	    value: function filterList(key) {
	      // if (key.ShopId === 16) {
	      //   console.log('filter')
	      //   console.log(key)
	      // }
	      // if (key.ShopName !== null) {
	      if (key.ShopName === null || key.ShopName === undefined) {
	        return false;
	      }
	      if (this.state.search === undefined || this.state.search === null) {
	        return true;
	      }
	      if (key.ShopName.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.Active : true)) {
	        return true;
	      }
	      return false;
	      // }
	      // return false
	      // }
	      // return false
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(data, type) {
	      var shops = [].concat(_toConsumableArray(this.state.shops));
	      if (type === 'create') {
	        shops.push({
	          ShopId: data.ShopId,
	          ShopName: data.CompanyName,
	          Active: data.Active
	        }, this.getShops);
	        type = 'list';
	      } else {
	        shops.map(function (val, key) {
	          if (val.ShopId === data.ShopId) {
	            val.ShopName = data.CompanyName;
	          }
	        });
	        type = 'item';
	      }
	      this.setState({
	        shops: shops,
	        view: type
	      });
	      // Toastr
	      // window.toastr.success(translation('2072'), translation('13424'))
	    }
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem(item) {
	      this.setState({
	        view: 'item',
	        activeItem: item
	      });
	      _events2.default.emit('sidebar_trigger', false);
	    }
	  }, {
	    key: 'createView',
	    value: function createView() {
	      var _this3 = this;
	
	      // If view is create
	      if (this.state.view === 'create') {
	        var onAdd = function onAdd() {
	          _this3.refs.view.getWrappedInstance().addShop();
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'list__buttons' },
	          _react2.default.createElement(_button2.default, { onClick: onAdd, labelText: (0, _helpers.translation)('1208') }),
	          _react2.default.createElement(_button2.default, { onClick: this.changeView.bind(this, 'list'), labelText: (0, _helpers.translation)('570') })
	        );
	      }
	
	      return this.state.shops.map(function (s) {
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: s.ShopName,
	          onClick: function onClick() {
	            return _this3.onSelectItem(s);
	          },
	          selected: s.ShopId === _this3.state.activeItem.ShopId,
	          inactive: !s.Active,
	          key: s.ShopId
	        });
	      });
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      switch (this.state.view) {
	        case 'list':
	          return _react2.default.createElement('div', null);
	        case 'create':
	        case 'item':
	          return _react2.default.createElement(_View2.default, { router: this.props.router, ref: 'view', item: this.state.activeItem, onSave: this.onSave });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'customers__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, title: (0, _helpers.translation)('14709'), icon: 'menu/Customers-White.png' }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          null,
	          this.createView()
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'customers__screen--inner' },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return Subcontractors;
	}(_react.Component);
	
	Subcontractors.propTypes = {
	  auth: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getShops: _shops.getShops })(Subcontractors);

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1479);
	
	var _employees = __webpack_require__(128);
	
	var _helpers = __webpack_require__(2);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// action
	
	
	// Utils
	
	
	// Elements
	
	
	var SupportAccessUser = function (_Component) {
	  _inherits(SupportAccessUser, _Component);
	
	  function SupportAccessUser(props) {
	    _classCallCheck(this, SupportAccessUser);
	
	    // create hours list
	    var _this = _possibleConstructorReturn(this, (SupportAccessUser.__proto__ || Object.getPrototypeOf(SupportAccessUser)).call(this, props));
	
	    var timeLabels = [];
	    for (var i = 0; i < 24; i++) {
	      var hh = i.toString();
	      var hour = '00'.substring(0, 2 - hh.length) + hh;
	      timeLabels.push(hour + ':' + '00');
	      timeLabels.push(hour + ':' + '30');
	    }
	
	    _this.state = {
	      ImpersonateAccessInfo: {
	        ImpersonationAccessEnabled: false,
	        ImpersonationExpiryDate: (0, _moment2.default)().format('DD-MM-YYYY HH:mm:ss'),
	        SupportTeams: []
	      },
	      SupportAccessTimes: timeLabels,
	      previewDateTime: null
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onChangeTime = _this.onChangeTime.bind(_this);
	    _this.onChangeDate = _this.onChangeDate.bind(_this);
	    return _this;
	  }
	
	  _createClass(SupportAccessUser, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getImpersonationAccess();
	    }
	  }, {
	    key: 'getImpersonationAccess',
	    value: function getImpersonationAccess() {
	      var _this2 = this;
	
	      this.props.getImpersonationAccess().then(function (res) {
	        _this2.setState({
	          ImpersonateAccessInfo: res.data
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'saveImpersonationAccess',
	    value: function saveImpersonationAccess(info) {
	      var _this3 = this;
	
	      this.props.saveImpersonationAccess(info).then(function (res) {
	        _this3.setState({
	          ImpersonateAccessInfo: res.data
	        });
	        // window.toastr.success(translation('512'))
	      }, function (err) {
	        _this3.updateSelected();
	        window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('293'));
	      });
	    }
	  }, {
	    key: 'updateSelected',
	    value: function updateSelected() {
	      this.setState({
	        ImpersonateAccessInfo: _extends({}, this.state.ImpersonateAccessInfo, {
	          ImpersonationExpiryDate: this.state.previewDateTime
	        })
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this4 = this;
	
	      this.setState({
	        ImpersonateAccessInfo: _extends({}, this.state.ImpersonateAccessInfo, _defineProperty({}, e.target.name, e.target.checked))
	      }, function () {
	        _this4.saveImpersonationAccess(_this4.state.ImpersonateAccessInfo);
	      });
	    }
	  }, {
	    key: 'onChangeDate',
	    value: function onChangeDate(date) {
	      var _this5 = this;
	
	      var ImpersonationExpiryDate = this.state.ImpersonateAccessInfo.ImpersonationExpiryDate;
	
	      var previewDateTime = ImpersonationExpiryDate;
	      this.setState({
	        ImpersonateAccessInfo: _extends({}, this.state.ImpersonateAccessInfo, {
	          ImpersonationExpiryDate: date
	        }),
	        previewDateTime: previewDateTime
	      }, function () {
	        var info = _extends({}, _this5.state.ImpersonateAccessInfo, {
	          ImpersonationExpiryDate: _this5.state.ImpersonateAccessInfo.ImpersonationExpiryDate.format()
	        });
	        _this5.saveImpersonationAccess(info);
	      });
	    }
	  }, {
	    key: 'onChangeTime',
	    value: function onChangeTime(e) {
	      var _this6 = this;
	
	      var ImpersonationExpiryDate = this.state.ImpersonateAccessInfo.ImpersonationExpiryDate;
	
	      var splitted = e.target.value.split(':');
	      var dateVal = ImpersonationExpiryDate !== null ? window.CustomDate(ImpersonationExpiryDate) : window.CustomDate();
	      var hours = splitted[0];
	      var minutes = splitted[1];
	      var combined = (0, _moment2.default)(dateVal).hours(parseInt(hours)).minutes(parseInt(minutes));
	      var previewDateTime = ImpersonationExpiryDate;
	      this.setState({
	        ImpersonateAccessInfo: _extends({}, this.state.ImpersonateAccessInfo, {
	          ImpersonationExpiryDate: combined
	        }),
	        previewDateTime: previewDateTime
	      }, function () {
	        var info = _extends({}, _this6.state.ImpersonateAccessInfo, {
	          ImpersonationExpiryDate: _this6.state.ImpersonateAccessInfo.ImpersonationExpiryDate.format()
	        });
	        _this6.saveImpersonationAccess(info);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$ImpersonateAcc = this.state.ImpersonateAccessInfo,
	          ImpersonationAccessEnabled = _state$ImpersonateAcc.ImpersonationAccessEnabled,
	          ImpersonationExpiryDate = _state$ImpersonateAcc.ImpersonationExpiryDate,
	          SupportTeams = _state$ImpersonateAcc.SupportTeams;
	
	      var times = this.state.SupportAccessTimes;
	
	      // Date
	      var date = '';
	      if (typeof ImpersonationExpiryDate !== 'undefined' && ImpersonationExpiryDate !== null && ImpersonationExpiryDate !== '') {
	        date = window.CustomDate(ImpersonationExpiryDate);
	      }
	
	      var ToNearest30Minutes = function ToNearest30Minutes(datetime) {
	        var remainder = datetime.minute() % 30;
	        if (remainder < 15) {
	          remainder = 0 - remainder;
	        } else {
	          remainder = 30 - remainder;
	        }
	        return (0, _moment2.default)(datetime).add(remainder, 'minutes').format('HH:mm');
	      };
	
	      // Time string
	      var timeString = '';
	      if (date !== '') {
	        timeString = ToNearest30Minutes((0, _moment2.default)(ImpersonationExpiryDate));
	      }
	
	      var hide = function hide() {
	        var className = void 0;
	        if (!ImpersonationAccessEnabled) {
	          className = 'hide';
	        } else {
	          className = 'show';
	        }
	        return className;
	      };
	
	      var renderSupportTeam = function renderSupportTeam(val, key) {
	        return _react2.default.createElement(
	          _label2.default,
	          { size: 'm', key: key },
	          val.ChainName
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'supportAccess__screen' },
	        _react2.default.createElement(
	          _col2.default,
	          { span: '2' },
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('17967') },
	            _react2.default.createElement(_switch2.default, { labelText: (0, _helpers.translation)('17970'), helpText: (0, _helpers.translation)('17972'), name: 'ImpersonationAccessEnabled', checked: ImpersonationAccessEnabled, onChange: this.onChange }),
	            _react2.default.createElement(
	              _label2.default,
	              { size: 'm' },
	              (0, _helpers.translation)('18038')
	            ),
	            _react2.default.createElement('br', null),
	            SupportTeams.map(renderSupportTeam),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { className: hide(), labelText: (0, _helpers.translation)('17971'), helpText: (0, _helpers.translation)('17973') },
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: [3, 1] },
	                _react2.default.createElement(_datetime2.default, {
	                  inputProps: { name: 'ImpersonationExpiryDate', disabled: !ImpersonationAccessEnabled },
	                  closeOnSelect: true,
	                  dateFormat: 'DD-MM-YYYY',
	                  timeFormat: false,
	                  value: date,
	                  onChange: this.onChangeDate,
	                  helpText: (0, _helpers.translation)('17973') }),
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  { name: 'SupportAccessTimes', value: timeString, onChange: this.onChangeTime, disabled: !ImpersonationAccessEnabled },
	                  times.map(function (val, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: index, value: val },
	                      val
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SupportAccessUser;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getImpersonationAccess: _employees.getImpersonationAccess,
	  saveImpersonationAccess: _employees.saveImpersonationAccess
	})(SupportAccessUser);

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _async = __webpack_require__(147);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _constants = __webpack_require__(5);
	
	var _common = __webpack_require__(25);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _TaskOverlay = __webpack_require__(476);
	
	var _TaskOverlay2 = _interopRequireDefault(_TaskOverlay);
	
	var _tasks = __webpack_require__(194);
	
	var _shops = __webpack_require__(79);
	
	__webpack_require__(1480);
	
	__webpack_require__(519);
	
	__webpack_require__(521);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _tableHeader = __webpack_require__(132);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableExpand = __webpack_require__(140);
	
	var _tableExpand2 = _interopRequireDefault(_tableExpand);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuCustomItem = __webpack_require__(69);
	
	var _sideMenuCustomItem2 = _interopRequireDefault(_sideMenuCustomItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Datetime from 'react-datetime'
	
	
	// Utils
	
	
	// import components
	
	
	// import components
	
	// import HelpText from '../../../shared/components/HelpText'
	
	/* import LeftMenu from '../../../shared/components/Menus/LeftMenu' */
	
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	
	
	// Elements
	
	// import HelpIcon from '../../../shared/elements/helpIcon'
	// import PanelHeader from '../../../shared/elements/panelHeader'
	
	
	var Tasks = function (_Component) {
	  _inherits(Tasks, _Component);
	
	  function Tasks(props) {
	    _classCallCheck(this, Tasks);
	
	    var _this = _possibleConstructorReturn(this, (Tasks.__proto__ || Object.getPrototypeOf(Tasks)).call(this, props));
	
	    _this.state = {
	      task: {
	        OtherTaskId: 0,
	        StartDate: window.CustomDate(),
	        EndDate: window.CustomDate(),
	        NoEndDate: true,
	        Description: '',
	        Deadline: {
	          Id: 0,
	          CreatedBy: 0,
	          CreatedDate: window.CustomDate(),
	          PuplishDayCount: 7, // Default value
	          OccurrenceType: 1,
	          DeadlineType: 0,
	          SpecificDay: 1,
	          Month: 1,
	          WeekDay: 1,
	          StartEnd: 0,
	          OnlyOneDeadline: false,
	          IsChain: false
	        },
	        CategoryId: 1,
	        IsActive: false,
	        IsUnsecified: false,
	        Name: '',
	        OtherTaskLog: [],
	        Assigns: [],
	        OtherTaskFiles: [],
	        AssignsOnlyFirst: false,
	        HasNextOccurrence: false
	      },
	      upload: {
	        loading: false,
	        errors: []
	      },
	      categories: [],
	      confirmFileDelete: {
	        confirm: false,
	        file: null
	      },
	      shops: [],
	      DedlineChanged: false,
	      ConfirmDedlineChange: false,
	      isUserChain: false,
	      taskOccurrence: {
	        task: {}
	      }
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onChangeDate = _this.onChangeDate.bind(_this);
	    _this.onChangeList = _this.onChangeList.bind(_this);
	    _this.onChangeNumber = _this.onChangeNumber.bind(_this);
	    _this.onClickCheckbox = _this.onClickCheckbox.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.updateTask = _this.updateTask.bind(_this);
	    _this.renderButton = _this.renderButton.bind(_this);
	    _this.occurrenceInterval = _this.occurrenceInterval.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tasks, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // get task
	      if (this.props.params.tasksID > 0) {
	        this.getTaskById(this.props.params.tasksID);
	      }
	      // get categories
	      this.getCategories();
	      this.getShops();
	      this.updateDeadline();
	
	      this.setState({
	        isUserChain: this.props.auth.user.AccessLevel === 2
	      });
	    }
	  }, {
	    key: 'getShops',
	    value: function getShops() {
	      var _this2 = this;
	
	      if (this.props.auth.user.AccessLevel === 2) {
	        this.props.getShops(this.props.auth.user.ChainId).then(function (res) {
	          _this2.setState({
	            shops: res.data.filter(function (x) {
	              return x.Active === true;
	            })
	          });
	        });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(type, e) {
	      var _this3 = this;
	
	      // console.log('this.state.task.Deadline.SpecificDay ', this.state.task.Deadline.SpecificDay)
	      if (type === 'deadline') {
	        this.setState({
	          task: _extends({}, this.state.task, {
	            Deadline: _extends({}, this.state.task.Deadline, _defineProperty({}, e.target.name, Number(e.target.value)))
	          }),
	          DedlineChanged: true
	        }, this.updateTask);
	      } else {
	        if (typeof type !== 'string') e = type;
	        this.setState({
	          task: _extends({}, this.state.task, _defineProperty({}, e.target.name, e.target.value))
	        }, function () {
	          if (type !== 'Description') _this3.updateTask;
	        });
	      }
	    }
	  }, {
	    key: 'onChangeNumber',
	    value: function onChangeNumber(e) {
	      this.setState({
	        task: _extends({}, this.state.task, _defineProperty({}, e.target.name, Number(e.target.value)))
	      }, this.updateTask);
	    }
	  }, {
	    key: 'onChangeDate',
	    value: function onChangeDate(name, value) {
	      var deadlineChanged = name === 'StartDate' && this.state.task.Deadline.OnlyOneDeadline;
	      this.setState({
	        task: _extends({}, this.state.task, _defineProperty({}, name, value)),
	        DedlineChanged: deadlineChanged
	      });
	    }
	  }, {
	    key: 'onChangeList',
	    value: function onChangeList(e) {
	      var _this4 = this;
	
	      var assigns = this.state.task.Assigns;
	      if (e.target.checked) {
	        if (this.state.isUserChain) {
	          if (e.target.name === 'all') {
	            // Filter out all shops
	            assigns = assigns.filter(function (a) {
	              return a.CompanyId === null;
	            });
	            // Add all shops
	            this.state.shops.map(function (x) {
	              return x.Active === true && assigns.push({ CompanyId: x.ShopId });
	            });
	          } else {
	            assigns.push({ CompanyId: e.target.id });
	          }
	        } else {
	          if (e.target.name === 'all') {
	            // Filter out all employees, who do not exist in list (Keep employees from other shops!)
	            assigns = assigns.filter(function (a) {
	              return a.UserId === null || !_this4.props.employees.find(function (e) {
	                return e.UserId === a.UserId;
	              });
	            });
	            // Add all employees
	            this.props.employees.map(function (x) {
	              return assigns.push({ UserId: x.UserId });
	            });
	          } else {
	            assigns.push({ UserId: e.target.id });
	          }
	        }
	      } else {
	        if (e.target.name === 'all') {
	          if (this.state.isUserChain) {
	            // Filter out all shops
	            assigns = assigns.filter(function (a) {
	              return a.CompanyId === null;
	            });
	          } else {
	            // Filter out all employees
	            assigns = assigns.filter(function (a) {
	              return a.UserId === null;
	            });
	          }
	        } else {
	          assigns = assigns.filter(function (otu) {
	            return Number(otu.UserId ? otu.UserId : otu.CompanyId) !== Number(e.target.id);
	          });
	        }
	      }
	
	      this.setState({
	        task: _extends({}, this.state.task, {
	          Assigns: assigns
	        })
	      }, this.updateTask);
	    }
	  }, {
	    key: 'onClickCheckbox',
	    value: function onClickCheckbox(type, e) {
	      if (type === 'deadline') {
	        this.setState({
	          task: _extends({}, this.state.task, {
	            Deadline: _extends({}, this.state.task.Deadline, {
	              WeekDay: Number(e.target.name)
	            })
	          }),
	          DedlineChanged: true
	        }, this.updateTask);
	      } else {
	        if (typeof type !== 'string') e = type;
	        if (e.target.id === 'allOrc') e.target.checked = false;
	
	        var deadline = _extends({}, this.state.task.Deadline);
	        if (e.target.name === 'IsUnsecified' && !e.target.checked) {
	          deadline.OccurrenceType = 1;
	          deadline.WeekDay = 1;
	        }
	
	        this.setState({
	          task: _extends({}, this.state.task, _defineProperty({
	            Deadline: deadline
	          }, e.target.name, e.target.checked))
	        }, this.updateTask);
	      }
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(type, e) {
	      if (type === 'deadline') {
	        this.setState({
	          task: _extends({}, this.state.task, {
	            Deadline: _extends({}, this.state.task.Deadline, _defineProperty({}, e.target.name, isNaN(e.target.value) === false ? Number(e.target.value) : e.target.value === 'true'))
	          }),
	          DedlineChanged: true
	        }, this.updateTask);
	      } else {
	        if (typeof type !== 'string') e = type;
	        var value = e.target.value;
	        if (e.target.name === 'IsActive') value = e.target.checked;
	        this.setState({
	          task: _extends({}, this.state.task, _defineProperty({}, e.target.name, String(value) === 'true'))
	        }, this.updateTask);
	      }
	    }
	  }, {
	    key: 'updateDeadline',
	    value: function updateDeadline() {
	      var _this5 = this;
	
	      if (this.props.params.tasksID === '0' || this.props.params.taskID === 0) {
	        var formatDate = function formatDate(date, fromDate) {
	          if (date === null || date === '' || date === undefined) {
	            date = new Date(fromDate);
	          }
	          if (typeof date.format === 'function') {
	            return date.format('YYYY-MM-DDTHH:mm:ss');
	          }
	          return date;
	        };
	        var task = _extends({}, this.state.task, { OtherTaskId: this.props.params.tasksID });
	        if (this.state.task.NoEndDate === false && this.state.task.EndDate === null) {
	          task.StartDate = formatDate(task.StartDate);
	          task.EndDate = formatDate(task.EndDate, task.StartDate);
	        }
	        this.props.getDeadline(task).then(function (res) {
	          _this5.setState({
	            task: _extends({}, res.data)
	          });
	        });
	      }
	    }
	  }, {
	    key: 'updateTask',
	    value: function updateTask(goThrough, e) {
	      var _this6 = this;
	
	      if (typeof goThrough !== 'string') e = goThrough;
	      if (this.state.task.OtherTaskId === 0 && goThrough !== 'yes') {
	        this.updateDeadline();
	        return null;
	      }
	      if (this.state.task.Name.length > 0) {
	        var formatDate = function formatDate(date, fromDate) {
	          if (date === null || date === '' || date === undefined) {
	            date = new Date(fromDate);
	          }
	          if (typeof date.format === 'function') {
	            return date.format('YYYY-MM-DDTHH:mm:ss');
	          }
	          return date;
	        };
	
	        var task = _extends({}, this.state.task);
	        task.StartDate = formatDate(task.StartDate);
	        task.EndDate = formatDate(task.EndDate, task.StartDate);
	        this.updateDeadline();
	        return this.props.createUpdateTask(task).then(function (res) {
	          // Toastr
	          // window.toastr.success(translation('1828'), translation('13424'))
	          if (task.OtherTaskId === 0 || task.isDeleted) {
	            // if create or delete
	            if (task.isDeleted) _this6.context.router.goBack();else {
	              _this6.setState({
	                task: res.data
	              }, function () {
	                _this6.state.task.IsActive ? _this6.context.router.replace('/tasks/' + _this6.state.task.OtherTaskId) : _this6.context.router.replace('/tasks/');
	              });
	            }
	          } else {
	            // if edit
	            _this6.setState({
	              task: res.data
	            });
	          }
	
	          // if (task.OtherTaskId !== 0 && !task.isDeleted) { // if not create nor delete
	          //   this.setState({
	          //     task: res.data
	          //   })
	          // } else {
	          //   this.context.router.replace('/tasks/')
	          // }
	
	          // this.setState({
	          //   task: res.data
	          // }, () => {
	          //   if (task.OtherTaskId === 0) {
	          //     this.context.router.replace('/tasks/') // + res.data.OtherTaskId)
	          //   }
	          // })
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('1829'), (0, _helpers.translation)('216'));
	        });
	      } else {
	        this.updateDeadline();
	        // Toastr
	        if (this.state.task.Name.length > 1) {
	          window.toastr.error((0, _helpers.translation)('2243'), (0, _helpers.translation)('216'));
	        } else {
	          window.toastr.error((0, _helpers.translation)('13430'), (0, _helpers.translation)('216'));
	        }
	      }
	    }
	  }, {
	    key: 'getTaskById',
	    value: function getTaskById(id) {
	      var _this7 = this;
	
	      this.props.getTask(id).then(function (res) {
	        _this7.setState({
	          task: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      var _this8 = this;
	
	      this.props.getCategories().then(function (res) {
	        _this8.setState({
	          categories: res.data,
	          task: _extends({}, _this8.state.task, {
	            CategoryId: res.data[0].Id
	          })
	        });
	      });
	    }
	  }, {
	    key: 'occurrenceInterval',
	    value: function occurrenceInterval() {
	      var _this9 = this;
	
	      var type = this.state.task.Deadline.OccurrenceType;
	      var isDisabled = this.state.task.IsUnsecified || this.state.task.IsChain && !this.state.isUserChain;
	
	      var monthSelector = function monthSelector(e) {
	        return _react2.default.createElement(
	          _dropDown2.default,
	          { size: 's', disabled: _this9.state.task.Deadline.DeadlineType !== e || isDisabled, key: 'monthSelector', name: 'Month', onChange: _this9.onChange.bind(_this9, 'deadline'), value: _this9.state.task.Deadline.Month },
	          _react2.default.createElement(
	            'option',
	            { value: 1 },
	            (0, _helpers.translation)('239')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 2 },
	            (0, _helpers.translation)('240')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 3 },
	            (0, _helpers.translation)('241')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 4 },
	            (0, _helpers.translation)('242')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 5 },
	            (0, _helpers.translation)('243')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 6 },
	            (0, _helpers.translation)('244')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 7 },
	            (0, _helpers.translation)('245')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 8 },
	            (0, _helpers.translation)('246')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 9 },
	            (0, _helpers.translation)('247')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 10 },
	            (0, _helpers.translation)('276')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 11 },
	            (0, _helpers.translation)('248')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 12 },
	            (0, _helpers.translation)('249')
	          )
	        );
	      };
	
	      var getMaxDay = function getMaxDay() {
	        if (_this9.state.task.Deadline.OccurrenceType === 3) {
	          return 92;
	        } else if (_this9.state.task.Deadline.OccurrenceType === 2) {
	          return 31;
	        } else {
	          return new Date(new Date().getFullYear(), _this9.state.task.Deadline.Month, 0).getDate();
	        }
	      };
	      var deadline = '';
	      if (this.state.task.OtherTaskLog.filter(function (otl) {
	        return !otl.IsChange;
	      }).length > 0) {
	        deadline = (0, _time.renderFullDate)(this.state.task.OtherTaskLog.filter(function (otl) {
	          return !otl.IsChange;
	        })[0].Deadline, false);
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1825') },
	          _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('1818'), disabled: isDisabled, id: 'weekly', value: '1', name: 'OccurrenceType', checked: this.state.task.Deadline.OccurrenceType === 1, onChange: this.onRadioChange.bind(this, 'deadline') }),
	          _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('1819'), disabled: isDisabled, id: 'monthly', value: '2', name: 'OccurrenceType', checked: this.state.task.Deadline.OccurrenceType === 2, onChange: this.onRadioChange.bind(this, 'deadline') }),
	          _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('1820'), disabled: isDisabled, id: 'quaterly', value: '3', name: 'OccurrenceType', checked: this.state.task.Deadline.OccurrenceType === 3, onChange: this.onRadioChange.bind(this, 'deadline') }),
	          _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('15053'), disabled: isDisabled, id: 'yearly', value: '4', name: 'OccurrenceType', checked: this.state.task.Deadline.OccurrenceType === 4, onChange: this.onRadioChange.bind(this, 'deadline') })
	        ),
	        _react2.default.createElement(_divider2.default, null),
	        type === 0 && _react2.default.createElement('div', null),
	        type === 1 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'selectForWeek' },
	            _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('169'), disabled: isDisabled, id: 'mon', name: 1, onChange: this.onClickCheckbox.bind(this, 'deadline'), checked: this.state.task.Deadline.WeekDay === 1 }),
	            _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('170'), disabled: isDisabled, id: 'tue', name: 2, onChange: this.onClickCheckbox.bind(this, 'deadline'), checked: this.state.task.Deadline.WeekDay === 2 }),
	            _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('171'), disabled: isDisabled, id: 'wed', name: 3, onChange: this.onClickCheckbox.bind(this, 'deadline'), checked: this.state.task.Deadline.WeekDay === 3 }),
	            _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('172'), disabled: isDisabled, id: 'thu', name: 4, onChange: this.onClickCheckbox.bind(this, 'deadline'), checked: this.state.task.Deadline.WeekDay === 4 }),
	            _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('173'), disabled: isDisabled, id: 'fri', name: 5, onChange: this.onClickCheckbox.bind(this, 'deadline'), checked: this.state.task.Deadline.WeekDay === 5 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'nextOccurrence' },
	            !this.state.task.HasNextOccurrence && _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('15331') + (0, _helpers.translation)('15332')
	            ),
	            this.state.task.HasNextOccurrence && _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('15331') + deadline
	            )
	          )
	        ),
	        [2, 3, 4].indexOf(type) > -1 && _react2.default.createElement(
	          'div',
	          { className: 'pg-mt-2' },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: 'auto auto ' + (type === 4 ? 'min-content' : '') + ' auto', align: 'center', spacing: 2 },
	            _react2.default.createElement(_radio2.default, { spacing: 0, labelText: (0, _helpers.translation)('15054'), disabled: isDisabled, id: 'month_Specific', name: 'DeadlineType', value: 0, checked: this.state.task.Deadline.DeadlineType === 0, onChange: this.onRadioChange.bind(this, 'deadline') }),
	            _react2.default.createElement(_text2.default, { size: 's', type: 'number', min: '1', max: getMaxDay(), id: 'numberDay', name: 'SpecificDay', disabled: this.state.task.Deadline.DeadlineType !== 0 || isDisabled, onChange: this.onChange.bind(this, 'deadline'), value: isNaN(this.state.task.Deadline.SpecificDay) ? 0 : this.state.task.Deadline.SpecificDay }),
	            type === 2 && _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('15055')
	            ),
	            type === 3 && _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('15056')
	            ),
	            type === 4 && [_react2.default.createElement(
	              _label2.default,
	              { key: 'label' },
	              '-'
	            ), monthSelector(0)]
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: 'max-content auto ' + (type !== 4 ? 'auto' : ''), align: 'center', spacing: 2 },
	            _react2.default.createElement(_radio2.default, { spacing: 0, labelText: (0, _helpers.translation)('15057'), disabled: isDisabled, id: 'StartEnd_Month', name: 'DeadlineType', value: 1, checked: this.state.task.Deadline.DeadlineType === 1, onChange: this.onRadioChange.bind(this, 'deadline') }),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { size: 's', name: 'StartEnd', disabled: this.state.task.Deadline.DeadlineType !== 1 || isDisabled, onChange: this.onChange.bind(this, 'deadline'), value: this.state.task.Deadline.StartEnd },
	              _react2.default.createElement(
	                'option',
	                { value: 0 },
	                (0, _helpers.translation)('15058')
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 1 },
	                (0, _helpers.translation)('15059')
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 2 },
	                (0, _helpers.translation)('15060')
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 3 },
	                (0, _helpers.translation)('15061')
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 4 },
	                (0, _helpers.translation)('15062')
	              )
	            ),
	            type === 2 && _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('15063')
	            ),
	            type === 3 && _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('15064')
	            ),
	            type === 4 && [_react2.default.createElement(
	              _label2.default,
	              { key: 'label' },
	              (0, _helpers.translation)('15065')
	            ), monthSelector(1)]
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'nextOccurrence' },
	            !this.state.task.HasNextOccurrence && _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('15331') + (0, _helpers.translation)('15332')
	            ),
	            this.state.task.HasNextOccurrence && _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)('15331') + deadline
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDeadline',
	    value: function renderDeadline() {
	      var isDisabled = this.state.task.IsUnsecified || this.state.task.IsChain && !this.state.isUserChain;
	      var inputProps = {
	        placeholder: (0, _helpers.translation)('1728'),
	        readOnly: true,
	        disabled: isDisabled
	      };
	      var StartDate = this.state.task.StartDate;
	      var EndDate = this.state.task.EndDate;
	
	      // Date
	      var renderStartDate = '';
	      if (typeof StartDate !== 'undefined' && StartDate !== null && StartDate !== '') {
	        renderStartDate = window.CustomDate(StartDate);
	      }
	
	      var renderEndDate = this.state.task.EndDate;
	      if (typeof EndDate !== 'undefined' && EndDate !== null && EndDate !== '') {
	        renderEndDate = window.CustomDate(EndDate);
	      }
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('1232'), helpText: (0, _helpers.translation)('1981') },
	        _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('15079'), disabled: isDisabled, id: 'onlyOne', value: 'true', name: 'OnlyOneDeadline', checked: this.state.task.Deadline.OnlyOneDeadline, onChange: this.onRadioChange.bind(this, 'deadline') }),
	        _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('15080'), disabled: isDisabled, id: 'menny', value: 'false', name: 'OnlyOneDeadline', checked: !this.state.task.Deadline.OnlyOneDeadline, onChange: this.onRadioChange.bind(this, 'deadline') }),
	        this.state.task.Deadline.OnlyOneDeadline && _react2.default.createElement(
	          'div',
	          { className: 'datepicker-fullwidth control__field' },
	          _react2.default.createElement(_datetime2.default, {
	            labelText: (0, _helpers.translation)('1232'),
	            inputProps: inputProps,
	            dateFormat: 'DD-MM-YYYY',
	            timeFormat: false,
	            closeOnSelect: true,
	            value: renderStartDate,
	            onChange: this.onChangeDate.bind(this, 'StartDate'),
	            onBlur: this.updateTask })
	        ),
	        this.state.task.Deadline.OnlyOneDeadline === false && [_react2.default.createElement(
	          'div',
	          { key: 'DeadlineDate' },
	          _react2.default.createElement(_datetime2.default, {
	            labelText: (0, _helpers.translation)('573'),
	            inputProps: inputProps,
	            dateFormat: 'DD-MM-YYYY',
	            timeFormat: false,
	            closeOnSelect: true,
	            value: renderStartDate,
	            onChange: this.onChangeDate.bind(this, 'StartDate'),
	            onBlur: this.updateTask
	          }),
	          _react2.default.createElement(_datetime2.default, {
	            labelText: (0, _helpers.translation)('574'),
	            inputProps: _extends({}, inputProps, { disabled: isDisabled || this.state.task.NoEndDate }),
	            dateFormat: 'DD-MM-YYYY',
	            timeFormat: false,
	            closeOnSelect: true,
	            isValidDate: function isValidDate(x) {
	              return new Date(x) > new Date(renderStartDate);
	            },
	            readOnly: this.state.task.NoEndDate,
	            value: renderEndDate,
	            onChange: this.onChangeDate.bind(this, 'EndDate'),
	            onBlur: this.updateTask
	          }),
	          _react2.default.createElement(_check2.default, { disabled: isDisabled, id: 'noEndDate', name: 'NoEndDate', onChange: this.onClickCheckbox, checked: this.state.task.NoEndDate, labelText: (0, _helpers.translation)('15066') })
	        ), _react2.default.createElement(
	          'div',
	          { key: 'DeadlineOccurrences' },
	          this.occurrenceInterval()
	        )],
	        _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('2020'), type: 'number', disabled: isDisabled, min: '0', name: 'PuplishDayCount', onChange: this.onChange.bind(this, 'deadline'), value: this.state.task.Deadline.PuplishDayCount })
	      );
	    }
	  }, {
	    key: 'renderFiles',
	    value: function renderFiles() {
	      var _this10 = this;
	
	      var errors = this.state.upload.errors;
	
	      var notDisabled = !(this.state.task.IsChain && !this.state.isUserChain);
	
	      // Delete file
	      var deleteFile = function deleteFile(file) {
	        var newErrors = [];
	        var deleteFileId = { ItemId: file.OrderFileId };
	        _this10.props.fileDelete(deleteFileId).then(function (res) {
	          // delete from database
	          var array = _this10.state.task.OtherTaskFiles;
	          _this10.setState({
	            task: _extends({}, _this10.state.task, {
	              OtherTaskFiles: array.filter(function (el) {
	                return el.OrderFileId !== Number(file.OrderFileId);
	              })
	            })
	          }, _this10.updateTask);
	        }, function () {
	          newErrors.push((0, _helpers.translation)('1207') + ': ' + file.FileName);
	          _this10.setState({
	            upload: _extends({}, _this10.state.upload, { errors: newErrors })
	          });
	        });
	      };
	
	      var deleteConfirmation = function deleteConfirmation(file) {
	        _this10.setState({
	          confirmFileDelete: {
	            confirm: true,
	            file: file
	          }
	        });
	      };
	
	      // Render file
	      var renderFile = function renderFile(file, index) {
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	        return _react2.default.createElement(
	          'li',
	          { key: index, className: 'file-document' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          _react2.default.createElement(
	            'a',
	            { target: '_BLANK', href: file.FileURL },
	            file.FileName
	          ),
	          _this10.props.auth.user.CustomerId === '-1' && notDisabled && _react2.default.createElement(
	            'div',
	            { className: 'file-delete' },
	            _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	                return deleteConfirmation(file);
	              }, size: 's' })
	          )
	        );
	      };
	      // Render image
	      var renderImage = function renderImage(image, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            'a',
	            { href: image.FileURL, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	            _react2.default.createElement('img', { src: image.ThumbURL })
	          ),
	          _this10.props.auth.user.CustomerId === '-1' && notDisabled && _react2.default.createElement(
	            'div',
	            { className: 'file-delete' },
	            _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	                return deleteConfirmation(image);
	              }, size: 's' })
	          )
	        );
	      };
	
	      var onConfirm = function onConfirm() {
	        var file = _this10.state.confirmFileDelete.file;
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	
	        _this10.setState({
	          confirmFileDelete: confirm
	        }, function () {
	          deleteFile(file);
	        });
	      };
	
	      var notConfirm = function notConfirm() {
	        var confirm = {
	          confirm: false,
	          file: null
	        };
	        _this10.setState({
	          confirmFileDelete: confirm
	        });
	      };
	      // On drop
	      var onDrop = function onDrop() {
	        _this10.setState({ upload: _extends({}, _this10.state.upload, {
	            errors: []
	          }) });
	      };
	      // On drop accepted
	      var onDropAccepted = function onDropAccepted(files) {
	        var newErrors = [];
	        _this10.setState({
	          upload: _extends({}, _this10.state.upload, {
	            loading: true
	          })
	        });
	        _async2.default.each(files, function (file, cb) {
	          // Upload each file
	          _this10.props.fileUpload(file, 0).then(function (res) {
	            _this10.setState({
	              task: _extends({}, _this10.state.task, {
	                OtherTaskFiles: [].concat(_toConsumableArray(_this10.state.task.OtherTaskFiles), [{
	                  OtherTaskId: _this10.state.task.OtherTaskId,
	                  OrderFileId: res.data[0].OrderFileID,
	                  IsImage: res.data[0].IsImage,
	                  FileURL: res.data[0].RealFileURL,
	                  FileName: res.data[0].FileName,
	                  ThumbURL: res.data[0].RealThumbURL
	                }])
	              })
	            });
	            cb();
	          }, function () {
	            newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13406') + '.');
	            cb();
	          });
	        }, function () {
	          if (newErrors.length !== 0) {
	            _this10.setState({
	              upload: _extends({}, _this10.state.upload, {
	                errors: _this10.state.upload.errors.concat(newErrors)
	              })
	            });
	          }
	          _this10.setState({
	            upload: _extends({}, _this10.state.upload, {
	              loading: false
	            })
	          });
	          _this10.updateTask();
	        });
	      };
	      // On drop rejected
	      var onDropRejected = function onDropRejected(files) {
	        var newErrors = [];
	        files.map(function (val, index) {
	          newErrors.push((0, _helpers.translation)('1207') + ': ' + val.name + ' ' + (0, _helpers.translation)('13405') + '.');
	        });
	        _this10.setState({ upload: _extends({}, _this10.state.upload, { errors: newErrors }) });
	      };
	      // Render error
	      var renderError = function renderError(error, index) {
	        return _react2.default.createElement(
	          'p',
	          { key: index },
	          error
	        );
	      };
	      var imgFiles = [];
	      var docFiles = [];
	      this.state.task.OtherTaskFiles.forEach(function (file) {
	        return file.IsImage ? imgFiles.push(file) : docFiles.push(file);
	      });
	
	      // Render
	      var isMultipleUpload = true;
	      return _react2.default.createElement(
	        'div',
	        { className: 'files' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          (0, _helpers.translation)('1043')
	        ),
	        errors.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          errors.map(renderError)
	        ),
	        notDisabled && _react2.default.createElement(
	          _Dropzone2.default,
	          {
	            onDrop: onDrop,
	            onDropAccepted: onDropAccepted,
	            onDropRejected: onDropRejected,
	            multiple: isMultipleUpload,
	            includeCircles: false },
	          this.state.upload.loading && _react2.default.createElement(
	            'div',
	            { className: 'loading' },
	            _react2.default.createElement(
	              'div',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            )
	          ),
	          !this.state.upload.loading && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.translation)('13397')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'files_inner clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'gallery' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              docFiles.map(renderFile)
	            )
	          ),
	          _react2.default.createElement(_Gallery2.default, { files: imgFiles, renderImage: renderImage })
	        ),
	        this.state.confirmFileDelete.confirm && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', onPortalClose: notConfirm },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: notConfirm })
	        )
	      );
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton() {
	      var _this11 = this;
	
	      var deleteTask = function deleteTask() {
	        _this11.setState({
	          task: _extends({}, _this11.state.task, {
	            confirmDelete: true
	          })
	        });
	      };
	
	      var onConfirm = function onConfirm() {
	        _this11.setState({
	          task: _extends({}, _this11.state.task, {
	            isDeleted: true,
	            confirmDelete: false
	          })
	        }, function () {
	          return _this11.updateTask();
	        }); // .then(this.context.router.goBack()))
	      };
	
	      var closeConfirm = function closeConfirm() {
	        _this11.setState({
	          task: _extends({}, _this11.state.task, {
	            confirmDelete: false
	          })
	        });
	      };
	
	      if (this.state.task.OtherTaskId === 0) {
	        return _react2.default.createElement(_button2.default, { onClick: this.updateTask.bind(this, 'yes'), className: 'saveButton', labelText: (0, _helpers.translation)('2056') });
	      } else {
	        return _react2.default.createElement(
	          _button2.default,
	          { onClick: deleteTask, className: 'saveButton', style: 'alert', labelText: (0, _helpers.translation)('15081') },
	          this.state.task.confirmDelete && _react2.default.createElement(
	            _Portal2.default,
	            { className: 'deleteModal', onPortalClose: closeConfirm },
	            _react2.default.createElement(_Confirm2.default, {
	              confirm: onConfirm,
	              notConfirm: closeConfirm,
	              renderText: function renderText() {
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('15082')
	                );
	              }
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderAssignList',
	    value: function renderAssignList() {
	      var _this12 = this;
	
	      var isDisabled = this.state.task.IsUnsecified || this.state.task.IsChain && !this.state.isUserChain;
	      var list = this.state.isUserChain ? this.state.shops : this.props.employees;
	      var assignsList = function assignsList(val, key) {
	        if (!val.Active) return null;
	
	        var name = val.Name ? val.Name : val.ShopName;
	        var Id = val.UserId ? val.UserId : val.ShopId;
	        var checkedId = _this12.state.task.Assigns.find(function (x) {
	          return x.UserId ? Id === Number(x.UserId) : Id === Number(x.CompanyId);
	        });
	        var checked = checkedId !== undefined;
	
	        var disabled = _this12.state.task.IsUnsecified || _this12.state.isUserChain && val.SubscriptionType !== 30;
	
	        return _react2.default.createElement(_check2.default, { key: key, labelText: name, disabled: disabled, id: Id, value: Id, checked: checked, onChange: _this12.onChangeList });
	      };
	
	      var assignOne = this.state.isUserChain ? (0, _helpers.translation)('15143') : (0, _helpers.translation)('15083');
	      var assignAll = this.state.isUserChain ? (0, _helpers.translation)('15144') : (0, _helpers.translation)('15084');
	
	      var actualAssigns = this.state.task.Assigns.filter(function (a) {
	        return _this12.state.isUserChain ? a.CompanyId !== null : a.UserId !== null;
	      });
	      var isAllChecked = false;
	      if (actualAssigns.length > 0 && this.state.isUserChain) {
	        isAllChecked = list.every(function (s) {
	          return !!actualAssigns.find(function (a) {
	            return a.CompanyId === s.ShopId;
	          });
	        });
	      } else {
	        isAllChecked = list.every(function (e) {
	          return !!actualAssigns.find(function (a) {
	            return a.UserId === e.UserId;
	          });
	        });
	      }
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(this.state.isUserChain ? '1861' : '10'), helpText: (0, _helpers.translation)('1980') },
	        !this.state.task.Deadline.OnlyOneDeadline && !isDisabled && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_radio2.default, { key: 'firstInstance', labelText: assignOne, disabled: this.state.task.IsUnsecified, id: 'onlyFirst', name: 'AssignsOnlyFirst', checked: this.state.task.AssignsOnlyFirst, onChange: this.onClickCheckbox }),
	          _react2.default.createElement(_radio2.default, { key: 'allInstances', labelText: assignAll, disabled: this.state.task.IsUnsecified, id: 'allOrc', name: 'AssignsOnlyFirst', checked: this.state.task.AssignsOnlyFirst === false, onChange: this.onClickCheckbox })
	        ),
	        _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('531'), disabled: this.state.task.IsUnsecified, id: 'selectAll', name: 'all', checked: isAllChecked, onChange: this.onChangeList }),
	        list.map(assignsList)
	      );
	    }
	  }, {
	    key: 'renderLog',
	    value: function renderLog() {
	      var _this13 = this;
	
	      var className = this.state.isUserChain ? '' : 'shop';
	      var renderStat = function renderStat(stat, key) {
	        var renderEmpStat = function renderEmpStat(emp, empKey) {
	          return _react2.default.createElement(
	            _grid2.default,
	            { key: empKey },
	            _react2.default.createElement(
	              'span',
	              null,
	              emp.Name
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              emp.UsedTime
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { cols: [1.25, 0.75], key: key },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'company' },
	              stat.CompanyName
	            ),
	            stat.Employees.length > 0 && stat.Employees.map(renderEmpStat),
	            _react2.default.createElement(
	              _grid2.default,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('15085')
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'total-time' },
	                stat.TotaltimeUsed
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'center' },
	            stat.Finished ? (0, _time.renderFullDate)(stat.Finished) : (0, _helpers.translation)('1233')
	          )
	        );
	      };
	
	      // const showStats = (key) => {
	      //   let Log = this.state.task.OtherTaskLog
	      //   let changes = []
	      //   let deadlines = []
	      //   Log.map(x => { x.IsChange ? changes.push(x) : deadlines.push(x) })
	      //   Log = changes
	      //   deadlines[key].showStats = deadlines[key].showStats !== true
	      //   Log = Log.concat(deadlines)
	
	      //   this.setState({
	      //     task: {
	      //       ...this.state.task,
	      //       OtherTaskLog: Log
	      //     }
	      //   })
	      // }
	
	      var openTask = function openTask(occurrenceId, deadline) {
	        var _state$task = _this13.state.task,
	            CategoryId = _state$task.CategoryId,
	            Description = _state$task.Description,
	            Name = _state$task.Name;
	
	        var category = _this13.state.categories.filter(function (x) {
	          return x.Id === CategoryId;
	        })[0].Name;
	        _this13.setState({
	          taskOccurrence: {
	            task: {
	              OccurrenceId: occurrenceId,
	              Deadline: deadline,
	              Category: category,
	              Description: Description,
	              Title: Name
	            }
	          }
	        }, function () {
	          _this13.props.openOverlay('TaskOverlay');
	        });
	      };
	
	      var renderChainItem = function renderChainItem(val, key) {
	        if (val.IsChange) {
	          return _react2.default.createElement(
	            _tableRow2.default,
	            { key: key, className: 'chain' },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(val.Deadline, false)
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'assigned' },
	              val.ChangedBy
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('OtherTaskSections', val.Section))
	            )
	          );
	        }
	
	        return _react2.default.createElement(
	          _tableExpand2.default,
	          { key: key },
	          _react2.default.createElement(
	            _tableHeader2.default,
	            { className: 'chain', cols: [1, 1, 1, '32px', '24px'] },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(val.Deadline, false)
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'assigned' },
	              val.TotalAssignt,
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ' + (0, _helpers.translation)('1861')
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              val.TotalFinished,
	              '/',
	              val.TotalAssignt,
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ' + (0, _helpers.translation)('1861')
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              val.Entries[0] && _react2.default.createElement(_icon2.default, { icon: _icons.MainMenuIcons.Tasks_Black, onClick: openTask.bind(_this13, val.Entries[0].OccurrenceId, val.Deadline) })
	            )
	          ),
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true, cols: [1.25, 0.75] },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('64')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('15087')
	            )
	          ),
	          val.Entries.map(renderStat)
	        );
	      };
	
	      var renderShopItem = function renderShopItem(val, key) {
	        if (val.IsChange) {
	          return _react2.default.createElement(
	            _tableRow2.default,
	            { key: key },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(val.Deadline, false)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              val.ChangedBy
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)((0, _helpers.enumtranslate)('OtherTaskSections', val.Section))
	            )
	          );
	        }
	
	        var renderStat = function renderStat(emp, key) {
	          return _react2.default.createElement(
	            _tableRow2.default,
	            { key: 'stat_' + key },
	            _react2.default.createElement(
	              'span',
	              null,
	              emp.Name
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(emp.StopTime)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              emp.UsedTime
	            )
	          );
	        };
	        var hasData = val.Entries.length > 0;
	        return _react2.default.createElement(
	          _tableExpand2.default,
	          { key: key },
	          _react2.default.createElement(
	            _tableHeader2.default,
	            { cols: [1, 1, 1, '32px', '24px'] },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(val.Deadline, false)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              hasData && val.Entries[0].Finished ? (0, _time.renderFullDate)(val.Entries[0].Finished) : (0, _helpers.translation)('1233')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              hasData ? val.Entries[0].TotaltimeUsed : '00:00:00'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              hasData && _react2.default.createElement(_icon2.default, { icon: _icons.MainMenuIcons.Tasks_Black, onClick: openTask.bind(_this13, val.Entries[0].OccurrenceId, val.Deadline) })
	            )
	          ),
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('30')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('15096')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('575')
	            )
	          ),
	          val.Entries[0].Employees.map(renderStat)
	        );
	      };
	
	      var occurrences = this.state.task.OtherTaskLog.filter(function (otl) {
	        return !otl.IsChange;
	      });
	      var changes = this.state.task.OtherTaskLog.filter(function (otl) {
	        return otl.IsChange;
	      });
	
	      // <span className='expand-align' />
	      return _react2.default.createElement(
	        _tableContainer2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'log ' + className },
	          _react2.default.createElement(
	            'div',
	            { className: 'log-header' },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [1, 'min-content'], align: 'center' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                (0, _helpers.translation)('1269')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true, cols: [1, 1, 1, '32px', '32px'] },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1232')
	            ),
	            this.state.isUserChain && _react2.default.createElement(
	              'span',
	              { className: 'assigned' },
	              (0, _helpers.translation)('15086')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('15087')
	            ),
	            !this.state.isUserChain && _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('575')
	            ),
	            _react2.default.createElement('span', null),
	            _react2.default.createElement('span', null)
	          ),
	          this.state.isUserChain ? occurrences.map(renderChainItem) : occurrences.map(renderShopItem),
	          _react2.default.createElement(
	            'div',
	            { className: 'log-header' },
	            _react2.default.createElement(
	              _grid2.default,
	              null,
	              _react2.default.createElement(
	                'h3',
	                null,
	                (0, _helpers.translation)('1489')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('388')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('15231')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('15232')
	            )
	          ),
	          this.state.isUserChain ? changes.map(renderChainItem) : changes.map(renderShopItem)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this14 = this;
	
	      var categoriesList = function categoriesList(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.Id },
	          (0, _helpers.translation)(val.Name)
	        );
	      };
	
	      var headerButtonsGoBack = function headerButtonsGoBack(router, t) {
	        var goBack = function goBack() {
	          if (_this14.state.DedlineChanged) {
	            _this14.setState({
	              ConfirmDedlineChange: true
	            });
	          } else {
	            router.goBack();
	          }
	        };
	        return _react2.default.createElement(_closeButton2.default, { key: 'back_close', ariaText: t('2060'), onClick: goBack });
	      };
	
	      var isDisabled = this.state.task.IsChain && !this.state.isUserChain;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'task__screen' },
	        _react2.default.createElement(_Header2.default, { router: this.props.router, showBack: true, headerButtonsGoBack: headerButtonsGoBack }),
	        _react2.default.createElement(
	          _sideMenu2.default,
	          { disableFilter: true },
	          _react2.default.createElement(
	            _sideMenuCustomItem2.default,
	            { isFixed: true },
	            !isDisabled && this.renderButton()
	          )
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          { className: 'tasks task__screen--inner' },
	          _react2.default.createElement(
	            _row2.default,
	            null,
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              _react2.default.createElement(
	                _panel2.default,
	                { title: (0, _helpers.translation)('1227') },
	                _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('30'), value: this.state.task.Name, name: 'Name', onChange: this.onChange, onBlur: this.updateTask, disabled: isDisabled }),
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  { labelText: (0, _helpers.translation)('1230'), onChange: this.onChangeNumber, name: 'CategoryId', value: this.state.task.CategoryId, disabled: isDisabled },
	                  this.state.categories.map(categoriesList)
	                ),
	                _react2.default.createElement(_switch2.default, { labelText: (0, _helpers.translation)('295'), name: 'IsActive', checked: this.state.task.IsActive === true, onChange: this.onRadioChange, disabled: isDisabled }),
	                _react2.default.createElement(_textarea2.default, { labelText: (0, _helpers.translation)('1021'), value: this.state.task.Description ? this.state.task.Description : '', name: 'Description', onChange: this.onChange.bind(this, 'Description'), onBlur: this.updateTask, disabled: isDisabled }),
	                _react2.default.createElement(_check2.default, { id: 'unspecifiedTask', name: 'IsUnsecified', onChange: this.onClickCheckbox, checked: this.state.task.IsUnsecified, disabled: isDisabled, labelText: (0, _helpers.translation)('15067') }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  this.renderFiles()
	                )
	              ),
	              this.renderDeadline()
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              null,
	              this.renderAssignList()
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              { span: 2 },
	              this.renderLog()
	            )
	          ),
	          this.state.ConfirmDedlineChange && this.state.task.OtherTaskId !== 0 && _react2.default.createElement(
	            _Portal2.default,
	            { onPortalClose: function onPortalClose() {
	                _this14.setState({ ConfirmDedlineChanged: false }, function () {
	                  _this14.props.router.goBack();
	                });
	              } },
	            _react2.default.createElement(_Confirm2.default, {
	              confirm: function confirm() {
	                _this14.setState({
	                  task: _extends({}, _this14.state.task, {
	                    UseOldDeadline: false
	                  }),
	                  ConfirmDedlineChange: false
	                }, function () {
	                  // this.props.router.goBack()
	                });
	              },
	              notConfirm: function notConfirm() {
	                _this14.setState({
	                  task: _extends({}, _this14.state.task, {
	                    UseOldDeadline: true
	                  }),
	                  ConfirmDedlineChanged: false
	                }, function () {
	                  _this14.updateTask().then(_this14.props.router.goBack());
	                });
	              },
	              renderText: function renderText() {
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _helpers.translation)('15142')
	                );
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(_TaskOverlay2.default, { task: this.state.taskOccurrence.task })
	      );
	    }
	  }]);
	
	  return Tasks;
	}(_react.Component);
	
	Tasks.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    employees: state.common.employees
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getTask: _tasks.getTask,
	  createUpdateTask: _tasks.createUpdateTask,
	  fileUpload: _tasks.fileUpload,
	  fileDelete: _tasks.fileDelete,
	  getCategories: _tasks.getCategories,
	  getShops: _shops.getShops,
	  getDeadline: _tasks.getDeadline,
	  openOverlay: _common.openOverlay
	})(Tasks);

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _Header = __webpack_require__(26);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	__webpack_require__(519);
	
	var _tasks = __webpack_require__(194);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _icons = __webpack_require__(6);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _pageHeader = __webpack_require__(1074);
	
	var _pageHeader2 = _interopRequireDefault(_pageHeader);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import components
	
	
	// import styles
	
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	// import Inline from '../../shared/elements/inline'
	
	
	var Tasks = function (_Component) {
	  _inherits(Tasks, _Component);
	
	  function Tasks(props) {
	    _classCallCheck(this, Tasks);
	
	    var _this = _possibleConstructorReturn(this, (Tasks.__proto__ || Object.getPrototypeOf(Tasks)).call(this, props));
	
	    _this.state = {
	      Tasks: [],
	      searchTask: {
	        CompanyId: null,
	        ChainId: null,
	        Name: '',
	        IsFinished: false,
	        Active: true,
	        Inactive: false
	      },
	      IsMobile: false
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.headerButtonsRight = _this.headerButtonsRight.bind(_this);
	    _this.listMenu = _this.listMenu.bind(_this);
	    _this.getTasks = _this.getTasks.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tasks, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        IsMobile: window.outerWidth < 650,
	        searchTask: _extends({}, this.state.searchTask, {
	          CompanyId: Number(this.props.auth.user.ShopId)
	        })
	      });
	      this.getTasks();
	
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var IsMobile = window.outerWidth < 650;
	      if (IsMobile !== this.state.IsMobile) {
	        this.setState({
	          IsMobile: IsMobile
	        });
	      }
	    }
	  }, {
	    key: 'renderHeaderTitle',
	    value: function renderHeaderTitle() {
	      return (0, _helpers.translation)('1227');
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this2 = this;
	
	      var value = e.target.value;
	      if (value === undefined || value === 'on' || e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	
	      this.setState({
	        searchTask: _extends({}, this.state.searchTask, _defineProperty({}, e.target.name, value))
	      }, function () {
	        return _this2.getTasks();
	      });
	    }
	  }, {
	    key: 'getTasks',
	    value: function getTasks() {
	      var _this3 = this;
	
	      this.props.getTasks(this.state.searchTask).then(function (res) {
	        _this3.setState({
	          Tasks: res.data
	        });
	      });
	    }
	
	    // <Link to='/tasks/0'></Link>
	
	  }, {
	    key: 'headerButtonsRight',
	    value: function headerButtonsRight() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { spacing: 0, size: 'm', ariaText: (0, _helpers.translation)('2056'), labelText: (0, _helpers.translation)(1797), onClick: function onClick() {
	            _this4.props.router.push('/tasks/0');
	          } })
	      );
	    }
	  }, {
	    key: 'listMenu',
	    value: function listMenu() {
	      return _react2.default.createElement(
	        _pageHeader2.default,
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(_text2.default, { size: 's', className: 'searchInput', name: 'Name', onChange: this.onChange, value: this.state.searchTask.Name }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('295'), id: 'Active', name: 'Active', onChange: this.onChange, checked: this.state.searchTask.Active }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('296'), id: 'Inactive', name: 'Inactive', onChange: this.onChange, checked: this.state.searchTask.Inactive }),
	          _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('23'), id: 'IsFinished', name: 'IsFinished', onChange: this.onChange, checked: this.state.searchTask.IsFinished })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	      var renderHeader = function renderHeader() {
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { header: true },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('30')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('1232')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('13516')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('15071')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('1230')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('13052')
	          )
	        );
	      };
	      var tasksList = function tasksList(val, key) {
	        var tasksLink = '/tasks/' + val.OtherTaskId;
	        var status = val.IsActive ? val.IsFinished ? '1231' : '295' : '296';
	
	        var renderInner = function renderInner() {
	          return [_react2.default.createElement(
	            'div',
	            { key: 'Name' },
	            val.Name
	          ), _react2.default.createElement(
	            'div',
	            { key: 'Deadline' },
	            (0, _time.renderFullDate)(val.NextDeadline, false)
	          ), _react2.default.createElement(
	            'div',
	            { key: 'endDate' },
	            val.EndDate ? (0, _time.renderFullDate)(val.EndDate, false) : _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Infinity })
	          ), _react2.default.createElement(
	            'div',
	            { key: 'Occurrences' },
	            val.TotalOccurrences === null ? _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Infinity }) : val.TotalOccurrences
	          ), _react2.default.createElement(
	            'div',
	            { key: 'Category' },
	            (0, _helpers.translation)(val.CategoryName)
	          ), _react2.default.createElement(
	            'div',
	            { key: 'Status' },
	            (0, _helpers.translation)(status)
	          )];
	        };
	
	        if (_this5.state.IsMobile) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: tasksLink, className: 'task__link', key: key },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('30') + ': ',
	              val.Name
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('1232') + ': ',
	              (0, _time.renderFullDate)(val.NextDeadline, false)
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0, block: true },
	              (0, _helpers.translation)('13516') + ': ',
	              val.EndDate ? (0, _time.renderFullDate)(val.EndDate, false) : _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Infinity })
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0, block: true },
	              (0, _helpers.translation)('15071') + ': ',
	              val.TotalOccurrences === null ? _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Infinity }) : val.TotalOccurrences
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('1230') + ': ',
	              (0, _helpers.translation)(val.CategoryName)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)('13052') + ': ',
	              (0, _helpers.translation)(status)
	            )
	          );
	        }
	
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: tasksLink, className: 'task__link', key: key },
	          _react2.default.createElement(
	            _tableRow2.default,
	            null,
	            renderInner()
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'tasks__screen' },
	        _react2.default.createElement(
	          _Header2.default,
	          { router: this.props.router, renderRight: this.headerButtonsRight },
	          _react2.default.createElement(
	            _grid2.default,
	            { align: 'center' },
	            _react2.default.createElement(_text2.default, { size: 's', className: 'searchInput', name: 'Name', onChange: this.onChange, value: this.state.searchTask.Name }),
	            _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('295'), id: 'Active', name: 'Active', onChange: this.onChange, checked: this.state.searchTask.Active }),
	            _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('296'), id: 'Inactive', name: 'Inactive', onChange: this.onChange, checked: this.state.searchTask.Inactive }),
	            _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('23'), id: 'IsFinished', name: 'IsFinished', onChange: this.onChange, checked: this.state.searchTask.IsFinished })
	          )
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _tableContainer2.default,
	            null,
	            !this.state.IsMobile && renderHeader(),
	            this.state.Tasks.map(tasksList)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tasks;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getTasks: _tasks.getTasks
	})(Tasks);

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  activeEmployees: [],
	  StepAssignments: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _constants.SET_ACTIVE_EMPLOYEES:
	      return _extends({}, state, {
	        activeEmployees: action.employees
	      });
	    case _constants.SET_STEP_ASSIGNMENTS:
	      return _extends({}, state, {
	        StepAssignments: action.StepAssignments
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  isAuthenticated: false,
	  user: {},
	  permissions: {},
	  inactiveUsers: [],
	  myscreen: {
	    UserId: 0,
	    Active: false,
	    Step1: false,
	    Step2: false,
	    Step3: false,
	    Step4: false,
	    Step5: false,
	    Step6: false,
	    Step7: false
	  },
	  accountingSystem: 0,
	  carRentalSystem: 0,
	  hasPartner: false,
	  departmentType: 0,
	  customerAllowChangeDelivery: false,
	  shopUseTimeForPickupOnOrderList: true,
	  prevWorkscreen: null,
	  allowNoCustomer: false,
	  newOrdersGrouping: 0,
	  companyHaveAssignedESG: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _constants.SET_ACCOUNTING_TYPE:
	      return _extends({}, state, {
	        accountingSystem: action.accountingSystem
	      });
	    case _constants.SET_CAR_RENTALSYSTEM_TYPE:
	      return _extends({}, state, {
	        carRentalSystem: action.carRentalSystem
	      });
	    case _constants.SET_HAS_PARTNER:
	      return _extends({}, state, {
	        hasPartner: action.hasPartner,
	        partnerName: action.partnerName,
	        partnerForsiBodyShopId: action.partnerForsiBodyShopId
	      });
	    case _constants.SET_DEPARTMENT_TYPE:
	      return _extends({}, state, {
	        departmentType: action.departmentType
	        // case SET_ALLOWCARRENTALOVERVIEW:
	        //   return {
	        //     ...state,
	        //     allowCarRentalOverview: action.allowCarRentalOverview
	        //   }
	      });case _constants.SET_ALLOW_CHANGE_DELIVERY:
	      return _extends({}, state, {
	        customerAllowChangeDelivery: action.customerAllowChangeDelivery
	      });
	    case _constants.SET_ALLOW_NO_CUSTOMER:
	      return _extends({}, state, {
	        allowNoCustomer: action.payload
	      });
	    case _constants.SET_ORDERLIST_USE_TIME_PICUP:
	      return _extends({}, state, {
	        shopUseTimeForPickupOnOrderList: action.shopUseTimeForPickupOnOrderList
	      });
	    case _constants.SET_SHOP_ACTIVE_PUNCHCLOCK:
	      return _extends({}, state, {
	        shopPunchClockActive: action.shopPunchClockActive
	      });
	    case _constants.SET_NEW_ORDERS_GROUPING:
	      return _extends({}, state, {
	        newOrdersGrouping: action.grouping
	      });
	    case _constants.SET_CURRENT_USER:
	      return _extends({}, state, {
	        isAuthenticated: !(Object.keys(action.user).length === 0),
	        user: action.user
	      });
	    case _constants.SET_USER_PERMISSIONS:
	      return _extends({}, state, {
	        permissions: action.permissions
	      });
	    case _constants.SET_WORKSCREEN:
	      return _extends({}, state, {
	        myscreen: action.myscreen
	      });
	    case _constants.SET_PREV_WORKSCREEN:
	      // console.log('[reducers/auth] SET_PREV_WORKSCREEN', action)
	      return _extends({}, state, {
	        prevWorkscreen: action.prevWorkscreen
	      });
	    case _constants.LOGIN_AS_USER:
	      var inactiveUsers = [].concat(_toConsumableArray(state.inactiveUsers));
	      var user = null;
	      if (action.user === null) {
	        user = action.newUser;
	        inactiveUsers = inactiveUsers.slice(0, inactiveUsers.findIndex(function (x) {
	          return x.UserId === user.UserId && x.UserType === user.UserType;
	        }));
	        // console.log('login as user, action user is null', user)
	      } else {
	        if (typeof action.companyId !== 'string') {
	          var oldUser = _extends({}, state.user);
	          var ws = parseInt(window.localStorage.getItem('workscreen_view'));
	          if (ws > -1) oldUser.PrevWorkscreenView = ws;
	          inactiveUsers.push(oldUser);
	          // console.log('[reducers/auth] set inactive OldUser', oldUser)
	        }
	        user = action.user;
	        // console.log('login as user', user)
	      }
	      // if (user.myscreen === undefined || user.myscreen.Active) {
	      //   window.localStorage.setItem('workscreen_view', null)
	      // }
	      console.log('[reducers/auth] login as user', user);
	      window.localStorage.setItem('inactiveUsers', JSON.stringify(inactiveUsers));
	      window.localStorage.setItem('loginAsUser', JSON.stringify(user));
	      return _extends({}, state, {
	        inactiveUsers: inactiveUsers,
	        user: user
	      });
	    case _constants.SET_LOGIN_AS:
	      return _extends({}, state, {
	        inactiveUsers: action.inactiveUsers,
	        user: action.user
	      });
	    case _constants.SET_COMPANY_HAVE_ASSIGNED_ESG:
	      return _extends({}, state, {
	        companyHaveAssignedESG: action.companyHaveAssignedESG
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  backdropOpen: false,
	  menuOpen: false,
	  modalOpen: false,
	  backdropHighZindex: false,
	  infoPopup: false,
	  bodyScroll: true
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _constants.OPEN_MENU:
	      return _extends({}, state, {
	        menuOpen: action.state,
	        backdropOpen: action.state
	      });
	    case _constants.OPEN_POPUP:
	      return _extends({}, state, {
	        modalOpen: action.state,
	        backdropOpen: action.state
	      });
	    case _constants.OPEN_POPUP_BG:
	      return _extends({}, state, {
	        backdropOpen: action.state,
	        backdropHighZindex: action.state
	      });
	    case _constants.SET_INFO_MODAL:
	      return _extends({}, state, {
	        infoPopup: action.content
	      });
	    case _constants.BODY_SCROLL:
	      return _extends({}, state, {
	        bodyScroll: action.bodyScroll
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  isActive: true
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_CAR_ACTIVE_STATE:
	      return {
	        isActive: action.isActive
	      };
	    default:
	      return state;
	  }
	};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  pageTitle: {
	    title: 'Apromas',
	    extra: null,
	    icon: null
	  },
	  helpIconPopupUpdates: 0,
	  slidePanels: [],
	  overlays: [],
	  popups: [],
	  loginTimer: undefined,
	  uploads: [],
	  brands: [],
	  customers: [],
	  activeCustomer: {},
	  customergroups: [],
	  companies: [],
	  countries: [],
	  employees: [],
	  currencyCode: '',
	  phonecodes: [],
	  vehicleLookupServices: [],
	  phonecode: {
	    Id: 1
	  },
	  partSides: {
	    0: 'None',
	    1: 'Left',
	    2: 'Right',
	    3: 'Front',
	    4: 'Back',
	    5: 'FrontLeft',
	    6: 'FrontRight',
	    7: 'BackLeft',
	    8: 'BackRight'
	
	  },
	  transport: [{ Id: 1, Name: '154' }, { Id: 3, Name: '26' }, { Id: 2, Name: '351' }],
	  doors: [{ Id: 1, Name: '' }, { Id: 2, Name: '2' }, { Id: 3, Name: '3' }, { Id: 4, Name: '4' }, { Id: 5, Name: '5' }, { Id: -1, Name: 'ST' }],
	  loosePartType: [{ Id: true, Name: '75' }, { Id: false, Name: '76' }],
	  enums: {
	    carSizes: {
	      1: 'small',
	      2: 'medium',
	      3: 'large'
	    },
	    orderTypes: {
	      1: '13360',
	      2: '71',
	      3: '13361',
	      4: '73',
	      5: '301',
	      6: '785'
	    },
	    complaintTypes: {
	      1: 'ColorDifference',
	      2: 'Gloss',
	      3: 'Dirt',
	      4: 'Blisters',
	      5: 'Runners',
	      6: 'Flicker',
	      7: 'Scratches',
	      8: 'Chopping',
	      9: 'SprayDust',
	      10: 'Sinking',
	      11: 'Rust',
	      12: 'Other'
	    }
	  },
	  enums_new: [],
	  headerInfo: {
	    Updates: [],
	    ManualMerges: [],
	    EconomicMatches: [],
	    ForsiActive: true,
	    UnreadMessages: 0,
	    IncompletedTasks: 0,
	    BookingPortalDrafts: [],
	    ChainNotification: null,
	    ForsiTokenActive: false,
	    UsesForsiToken: false
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (state.loginTimer === undefined) {
	    var date = new Date();
	    date.setSeconds(date.getSeconds() + 60);
	    state.loginTimer = date;
	  }
	  switch (action.type) {
	    case _constants.SET_HELPICON_POPUP_UPDATES:
	      return _extends({}, state, {
	        helpIconPopupUpdates: action.number
	      });
	    case _constants.SET_SLIDEPANELS:
	      return _extends({}, state, {
	        slidePanels: action.slidePanels
	      });
	    case _constants.SET_OVERLAYS:
	      return _extends({}, state, {
	        overlays: action.overlays
	      });
	    case _constants.SET_POPUPS:
	      return _extends({}, state, {
	        popups: action.popups
	      });
	    case _constants.SET_PAGE_TITLE:
	      return _extends({}, state, {
	        pageTitle: action.pageTitle
	      });
	    case _constants.SET_PAGE_TITLE_EXTRA:
	      return _extends({}, state, {
	        pageTitle: _extends({}, state.pageTitle, {
	          extra: action.pageTitleExtra
	        })
	      });
	    case _constants.SET_LOGINTIMER:
	      return _extends({}, state, {
	        loginTimer: action.loginTimer
	      });
	    case _constants.SET_CUSTOMERS:
	      return _extends({}, state, {
	        customers: action.customers
	      });
	    case _constants.SET_ACTIVE_CUSTOMER:
	      var activeCustomer = state.customers.find(function (_) {
	        return _.CustomerId === action.payload;
	      });
	      if (!activeCustomer) activeCustomer = {};
	      return _extends({}, state, { activeCustomer: activeCustomer });
	    case _constants.SET_CUSTOMERGROUPS:
	      return _extends({}, state, {
	        customergroups: action.customergroups
	      });
	    case _constants.SET_COMPANIES:
	      return _extends({}, state, {
	        companies: action.companies
	      });
	    case _constants.SET_EMPLOYEES:
	      return _extends({}, state, {
	        employees: action.employees
	      });
	    case _constants.SET_PHONECODES:
	      return _extends({}, state, {
	        phonecodes: action.phonecodes
	      });
	    case _constants.SET_VEHICLE_LOOKUP_SEVICES:
	      return _extends({}, state, {
	        vehicleLookupServices: action.vehicleLookupServices
	      });
	    case _constants.SET_DEFAULT_PHONECODE:
	      return _extends({}, state, {
	        phonecode: action.phonecode
	      });
	    case _constants.SET_BRANDS:
	      return _extends({}, state, {
	        brands: action.brands
	      });
	    case _constants.SET_ENUMS:
	      return _extends({}, state, {
	        enums_new: action.enums
	      });
	    case _constants.SET_COUNTRIES:
	      return _extends({}, state, {
	        countries: action.countries
	      });
	    case _constants.SET_HEADERINFO:
	      return _extends({}, state, {
	        headerInfo: action.headerInfo
	      });
	    case _constants.SET_HEADERINFO_FORSI:
	      return _extends({}, state, {
	        headerInfo: _extends({}, state.headerInfo, {
	          ForsiTokenActive: action.ForsiTokenActive
	        })
	      });
	    case _constants.SET_HEADERINFO_MESSAGES:
	      return _extends({}, state, {
	        headerInfo: _extends({}, state.headerInfo, {
	          UnreadMessages: action.UnreadMessages
	        })
	      });
	    case _constants.SET_HEADERINFO_TASKS:
	      return _extends({}, state, {
	        headerInfo: _extends({}, state.headerInfo, {
	          IncompletedTasks: action.IncompletedTasks
	        })
	      });
	    case _constants.SET_HEADERINFO_EVALUATION:
	      return _extends({}, state, {
	        headerInfo: _extends({}, state.headerInfo, {
	          Updates: action.Updates
	        })
	      });
	    case _constants.SET_HEADERINFO_UPDATES:
	      return _extends({}, state, {
	        headerInfo: _extends({}, state.headerInfo, {
	          ManualMerges: action.ManualMerges
	        })
	      });
	    case _constants.SET_HEADERINFO_CHAINNOTIFICATION:
	      return _extends({}, state, {
	        headerInfo: _extends({}, state.headerInfo, {
	          ChainNotification: action.ChainNotification
	        })
	      });
	    case _constants.SET_HEADERINFO_BOOKINGPORTALDRAFTS:
	      return _extends({}, state, {
	        headerInfo: _extends({}, state.headerInfo, {
	          BookingPortalDrafts: action.BookingPortalDrafts
	        })
	      });
	    case _constants.SET_HEADERINFO_ORDERS:
	      return _extends({}, state, {
	        headerInfo: _extends({}, state.headerInfo, {
	          AssignedOrders: action.AssignedOrders
	        })
	      });
	    case _constants.SET_CURRENCY_CODE:
	      return _extends({}, state, {
	        currencyCode: action.currencyCode
	      });
	    case _constants.SET_HAS_PAINT_PARTNER:
	      return _extends({}, state, {
	        hasPaintPartner: action.hasPaintPartner
	      });
	    case _constants.SET_BODY_DEFAULT_LEAD_TIME:
	      return _extends({}, state, {
	        bodyShopDefaultLeadTime: action.bodyShopDefaultLeadTime
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  IsComplete: false,
	  CurrentStep: 0,
	  CarData: {
	    RegNumber: '',
	    BrandName: '',
	    Model: '',
	    ChassisNumber: '',
	    Km: 0,
	    DamageComment: ''
	  },
	  FilesInfo: { Files: [] },
	  OtherInfo: {
	    DamageNr: '',
	    InsuranceCompanyId: 0,
	    NeedRental: false,
	    CarRentalId: 0,
	    DamageDate: null
	  },
	  ContactInfo: {},
	  InsuranceCompanies: [],
	  CarRentalAlternatives: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_EMBEDDED_BOOKING_CARDATA:
	      return _extends({}, state, {
	        CarData: action.carData
	      });
	    case _constants.SET_EMBEDDED_BOOKING_OTHERINFO:
	      return _extends({}, state, {
	        OtherInfo: action.otherInfo
	      });
	    case _constants.SET_EMBEDDED_BOOKING_CONTACTINFO:
	      return _extends({}, state, {
	        ContactInfo: action.contactInfo
	      });
	    case _constants.SET_EMBEDDED_BOOKING_DATA:
	      return _extends({}, state, action.data);
	    case _constants.SET_EMBEDDED_INSURANCE_COMPANIES:
	      return _extends({}, state, {
	        InsuranceCompanies: action.insuranceCompanies
	      });
	    case _constants.SET_EMBEDDED_CARRENTAL_ALTERNATIVES:
	      return _extends({}, state, {
	        CarRentalAlternatives: action.carRentalAlts
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rootReducer;
	
	var _redux = __webpack_require__(389);
	
	var _reactRouterRedux = __webpack_require__(690);
	
	var _auth = __webpack_require__(991);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _orders = __webpack_require__(997);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _backdrop = __webpack_require__(992);
	
	var _backdrop2 = _interopRequireDefault(_backdrop);
	
	var _common = __webpack_require__(994);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _price = __webpack_require__(999);
	
	var _price2 = _interopRequireDefault(_price);
	
	var _assign = __webpack_require__(990);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _uploads = __webpack_require__(1001);
	
	var _uploads2 = _interopRequireDefault(_uploads);
	
	var _car = __webpack_require__(993);
	
	var _car2 = _interopRequireDefault(_car);
	
	var _spareparts = __webpack_require__(1000);
	
	var _spareparts2 = _interopRequireDefault(_spareparts);
	
	var _embeddedbooking = __webpack_require__(995);
	
	var _embeddedbooking2 = _interopRequireDefault(_embeddedbooking);
	
	var _overview = __webpack_require__(998);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _language = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appReducer = (0, _redux.combineReducers)({
	  auth: _auth2.default,
	  orders: _orders2.default,
	  backdrop: _backdrop2.default,
	  common: _common2.default,
	  price: _price2.default,
	  i18nState: _language.i18nState,
	  assign: _assign2.default,
	  uploads: _uploads2.default,
	  car: _car2.default,
	  spareParts: _spareparts2.default,
	  embeddedbooking: _embeddedbooking2.default,
	  routing: _reactRouterRedux.routerReducer,
	  overview: _overview2.default
	});
	
	// Language
	function rootReducer(state, action) {
	  if (action.type === 'SET_CURRENT_USER') {
	    if (typeof action.user.Token === 'undefined') {
	      state.assign = undefined;
	      state.auth = undefined;
	      state.backdrop = undefined;
	      state.common = undefined;
	      state.price = undefined;
	      state.uploads = undefined;
	      // Reset orders
	      state.orders.orders = [];
	      state.orders.order = {};
	      state.orders.errors = false;
	      state.orders.filter = state.orders.initialFilter;
	    }
	  }
	  return appReducer(state, action);
	}

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  order: {},
	  workcardOrder: {},
	  orders: [],
	  workscreenOrders: [],
	  errors: false,
	
	  filterOrderlist: {
	    process: {
	      draft: true,
	      draft1: false,
	      draft2: true,
	      InProcess: true,
	      Completed: false,
	      CompletedThisWeek: true
	    },
	    external_control: 'all',
	    invoicing: 'all',
	    evaluation: {
	      missing: false,
	      evaluated: false
	    },
	    update: {
	      missing: false,
	      updated: false
	    },
	    customergroup: {
	      CustomerGroupId: -1,
	      CustomerGroupName: ''
	    },
	    pricemodel: {
	      PriceModelId: -1,
	      PriceModelName: ''
	    },
	    orderType: '0',
	    identification: {
	      ordernumber: {
	        value: '',
	        option: 1
	      },
	      rekvnumber: {
	        value: '',
	        option: 1
	      }
	    },
	    delivery: {
	      delivery: {
	        start: '',
	        end: ''
	      },
	      production: {
	        start: '',
	        end: ''
	      },
	      pickup: {
	        start: '',
	        end: ''
	      },
	      transport: 0
	    },
	    vehicle: {
	      regnumber: {
	        value: '',
	        option: 1
	      },
	      brand: {
	        value: '',
	        option: 1
	      },
	      model: {
	        value: '',
	        option: 1
	      },
	      year: {
	        value: '',
	        option: 1
	      }
	    },
	    color: {
	      color: {
	        value: '',
	        option: 1
	      },
	      code: {
	        value: '',
	        option: 1
	      },
	      ctype: {
	        value: '',
	        option: 1
	      },
	      amount: {
	        value: '',
	        option: 1
	      }
	    },
	    customer: {
	      name: {
	        value: '',
	        option: 1
	      },
	      city: {
	        value: '',
	        option: 1
	      },
	      zipcode: {
	        value: '',
	        option: 1
	      },
	      phone: {
	        value: '',
	        option: 1
	      },
	      contact_name: {
	        value: '',
	        option: 1
	      }
	    },
	    invoice: {
	      notApprovedForInvoicing: false,
	      approvedForInvoicing: false,
	      isInvoiced: false
	    },
	    economicfilter: {
	      economicFilterNotMatched: false,
	      economicFilterMatched: false
	    },
	    additionalreport: {
	      awaiting: false,
	      received: false
	    },
	    movedOrders: true,
	    parts: {
	      bodyNotOrdered: false,
	      bodyOrdered: false,
	      bodyInStock: false,
	      bodyArrived: false,
	      paintNotOrdered: false,
	      paintOrdered: false,
	      paintInStock: false,
	      paintArrived: false
	    },
	    HasPaintWork: true,
	    HasBodyWork: true,
	    NewOrdersFilter: 0,
	    AssignedToMe: false
	  },
	  filterWorkscreen: {
	    process: {
	      draft: false, // true,
	      draft1: false,
	      draft2: true,
	      InProcess: true,
	      Completed: false,
	      CompletedThisWeek: false // true
	    },
	    external_control: 'all',
	    invoicing: 'all',
	    evaluation: {
	      missing: false,
	      evaluated: false
	    },
	    update: {
	      missing: false,
	      updated: false
	    },
	    customergroup: {
	      CustomerGroupId: -1,
	      CustomerGroupName: ''
	    },
	    pricemodel: {
	      PriceModelId: -1,
	      PriceModelName: ''
	    },
	    orderType: '0',
	    identification: {
	      ordernumber: {
	        value: '',
	        option: 1
	      },
	      rekvnumber: {
	        value: '',
	        option: 1
	      }
	    },
	    delivery: {
	      delivery: {
	        start: '',
	        end: ''
	      },
	      production: {
	        start: '',
	        end: ''
	      },
	      pickup: {
	        start: '',
	        end: ''
	      },
	      transport: 0
	    },
	    vehicle: {
	      regnumber: {
	        value: '',
	        option: 1
	      },
	      brand: {
	        value: '',
	        option: 1
	      },
	      model: {
	        value: '',
	        option: 1
	      },
	      year: {
	        value: '',
	        option: 1
	      }
	    },
	    color: {
	      color: {
	        value: '',
	        option: 1
	      },
	      code: {
	        value: '',
	        option: 1
	      },
	      ctype: {
	        value: '',
	        option: 1
	      },
	      amount: {
	        value: '',
	        option: 1
	      }
	    },
	    customer: {
	      name: {
	        value: '',
	        option: 1
	      },
	      city: {
	        value: '',
	        option: 1
	      },
	      zipcode: {
	        value: '',
	        option: 1
	      },
	      phone: {
	        value: '',
	        option: 1
	      },
	      contact_name: {
	        value: '',
	        option: 1
	      }
	    },
	    invoice: {
	      notApprovedForInvoicing: false,
	      approvedForInvoicing: false,
	      isInvoiced: false
	    },
	    economicfilter: {
	      economicFilterNotMatched: false,
	      economicFilterMatched: false
	    },
	    additionalreport: {
	      awaiting: false,
	      received: false
	    },
	    movedOrders: false,
	    parts: {
	      bodyNotOrdered: false,
	      bodyOrdered: false,
	      bodyInStock: false,
	      bodyArrived: false,
	      paintNotOrdered: false,
	      paintOrdered: false,
	      paintInStock: false,
	      paintArrived: false
	    },
	    HasPaintWork: true,
	    HasBodyWork: true,
	    NewOrdersFilter: 0,
	    AssignedToMe: false
	  },
	  filterCustomer: {
	    process: {
	      draft: true,
	      draft1: false,
	      draft2: true,
	      InProcess: true,
	      Completed: false,
	      CompletedThisWeek: false
	    },
	    external_control: 'all',
	    invoicing: 'all',
	    evaluation: {
	      missing: false,
	      evaluated: false
	    },
	    update: {
	      missing: false,
	      updated: false
	    },
	    customergroup: {
	      CustomerGroupId: -1,
	      CustomerGroupName: ''
	    },
	    pricemodel: {
	      PriceModelId: -1,
	      PriceModelName: ''
	    },
	    orderType: '0',
	    identification: {
	      ordernumber: {
	        value: '',
	        option: 1
	      },
	      rekvnumber: {
	        value: '',
	        option: 1
	      }
	    },
	    delivery: {
	      delivery: {
	        start: '',
	        end: ''
	      },
	      production: {
	        start: '',
	        end: ''
	      },
	      pickup: {
	        start: '',
	        end: ''
	      },
	      transport: 0
	    },
	    vehicle: {
	      regnumber: {
	        value: '',
	        option: 1
	      },
	      brand: {
	        value: '',
	        option: 1
	      },
	      model: {
	        value: '',
	        option: 1
	      },
	      year: {
	        value: '',
	        option: 1
	      }
	    },
	    color: {
	      color: {
	        value: '',
	        option: 1
	      },
	      code: {
	        value: '',
	        option: 1
	      },
	      ctype: {
	        value: '',
	        option: 1
	      },
	      amount: {
	        value: '',
	        option: 1
	      }
	    },
	    customer: {
	      name: {
	        value: '',
	        option: 1
	      },
	      city: {
	        value: '',
	        option: 1
	      },
	      zipcode: {
	        value: '',
	        option: 1
	      },
	      phone: {
	        value: '',
	        option: 1
	      },
	      contact_name: {
	        value: '',
	        option: 1
	      }
	    },
	    invoice: {
	      notApprovedForInvoicing: false,
	      approvedForInvoicing: false,
	      isInvoiced: false
	    },
	    economicfilter: {
	      economicFilterNotMatched: false,
	      economicFilterMatched: false
	    },
	    additionalreport: {
	      awaiting: false,
	      received: false
	    },
	    movedOrders: true,
	    parts: {
	      bodyNotOrdered: false,
	      bodyOrdered: false,
	      bodyInStock: false,
	      bodyArrived: false,
	      paintNotOrdered: false,
	      paintOrdered: false,
	      paintInStock: false,
	      paintArrived: false
	    },
	    HasPaintWork: true,
	    HasBodyWork: true,
	    NewOrdersFilter: 0
	  },
	  filterWP: {
	    process: {
	      draft: false,
	      draft1: false,
	      draft2: false,
	      InProcess: true,
	      Completed: false,
	      CompletedThisWeek: true
	    },
	    external_control: 'all',
	    invoicing: 'all',
	    evaluation: {
	      missing: false,
	      evaluated: false
	    },
	    update: {
	      missing: false,
	      updated: false
	    },
	    customergroup: {
	      CustomerGroupId: -1,
	      CustomerGroupName: ''
	    },
	    pricemodel: {
	      PriceModelId: -1,
	      PriceModelName: ''
	    },
	    orderType: '0',
	    identification: {
	      ordernumber: {
	        value: '',
	        option: 1
	      },
	      rekvnumber: {
	        value: '',
	        option: 1
	      }
	    },
	    delivery: {
	      delivery: {
	        start: '',
	        end: ''
	      },
	      production: {
	        start: '',
	        end: ''
	      },
	      pickup: {
	        start: '',
	        end: ''
	      },
	      transport: 0
	    },
	    vehicle: {
	      regnumber: {
	        value: '',
	        option: 1
	      },
	      brand: {
	        value: '',
	        option: 1
	      },
	      model: {
	        value: '',
	        option: 1
	      },
	      year: {
	        value: '',
	        option: 1
	      }
	    },
	    color: {
	      color: {
	        value: '',
	        option: 1
	      },
	      code: {
	        value: '',
	        option: 1
	      },
	      ctype: {
	        value: '',
	        option: 1
	      },
	      amount: {
	        value: '',
	        option: 1
	      }
	    },
	    customer: {
	      name: {
	        value: '',
	        option: 1
	      },
	      city: {
	        value: '',
	        option: 1
	      },
	      zipcode: {
	        value: '',
	        option: 1
	      },
	      phone: {
	        value: '',
	        option: 1
	      },
	      contact_name: {
	        value: '',
	        option: 1
	      }
	    },
	    invoice: {
	      notApprovedForInvoicing: false,
	      approvedForInvoicing: false,
	      isInvoiced: false
	    },
	    economicfilter: {
	      economicFilterNotMatched: false,
	      economicFilterMatched: false
	    },
	    additionalreport: {
	      awaiting: false,
	      received: false
	    },
	    movedOrders: true,
	    parts: {
	      bodyNotOrdered: false,
	      bodyOrdered: false,
	      bodyInStock: false,
	      bodyArrived: false,
	      paintNotOrdered: false,
	      paintOrdered: false,
	      paintInStock: false,
	      paintArrived: false
	    },
	    HasPaintWork: true,
	    HasBodyWork: true,
	    NewOrdersFilter: 0
	  },
	  initialFilterOrderlist: {
	    process: {
	      draft: true,
	      draft1: false,
	      draft2: true,
	      InProcess: true,
	      Completed: false,
	      CompletedThisWeek: true
	    },
	    external_control: 'all',
	    invoicing: 'all',
	    evaluation: {
	      missing: false,
	      evaluated: false
	    },
	    update: {
	      missing: false,
	      updated: false
	    },
	    customergroup: {
	      CustomerGroupId: -1,
	      CustomerGroupName: ''
	    },
	    pricemodel: {
	      PriceModelId: -1,
	      PriceModelName: ''
	    },
	    orderType: '0',
	    identification: {
	      ordernumber: {
	        value: '',
	        option: 1
	      },
	      rekvnumber: {
	        value: '',
	        option: 1
	      }
	    },
	    delivery: {
	      delivery: {
	        start: '',
	        end: ''
	      },
	      production: {
	        start: '',
	        end: ''
	      },
	      pickup: {
	        start: '',
	        end: ''
	      },
	      transport: 0
	    },
	    vehicle: {
	      regnumber: {
	        value: '',
	        option: 1
	      },
	      brand: {
	        value: '',
	        option: 1
	      },
	      model: {
	        value: '',
	        option: 1
	      },
	      year: {
	        value: '',
	        option: 1
	      }
	    },
	    color: {
	      color: {
	        value: '',
	        option: 1
	      },
	      code: {
	        value: '',
	        option: 1
	      },
	      ctype: {
	        value: '',
	        option: 1
	      },
	      amount: {
	        value: '',
	        option: 1
	      }
	    },
	    customer: {
	      name: {
	        value: '',
	        option: 1
	      },
	      city: {
	        value: '',
	        option: 1
	      },
	      zipcode: {
	        value: '',
	        option: 1
	      },
	      phone: {
	        value: '',
	        option: 1
	      },
	      contact_name: {
	        value: '',
	        option: 1
	      }
	    },
	    invoice: {
	      notApprovedForInvoicing: false,
	      approvedForInvoicing: false,
	      isInvoiced: false
	    },
	    economicfilter: {
	      economicFilterNotMatched: false,
	      economicFilterMatched: false
	    },
	    additionalreport: {
	      awaiting: false,
	      received: false
	    },
	    movedOrders: true,
	    parts: {
	      bodyNotOrdered: false,
	      bodyOrdered: false,
	      bodyInStock: false,
	      bodyArrived: false,
	      paintNotOrdered: false,
	      paintOrdered: false,
	      paintInStock: false,
	      paintArrived: false
	    },
	    HasPaintWork: true,
	    HasBodyWork: true,
	    NewOrdersFilter: 0,
	    AssignedToMe: false
	  },
	  initialFilterWorkscreen: {
	    // INITIAL_WORKSCREEN: 'yep',
	    process: {
	      draft: false, // true
	      draft1: false,
	      draft2: true,
	      InProcess: true,
	      Completed: false,
	      CompletedThisWeek: false // true
	    },
	    external_control: 'all',
	    invoicing: 'all',
	    evaluation: {
	      missing: false,
	      evaluated: false
	    },
	    update: {
	      missing: false,
	      updated: false
	    },
	    customergroup: {
	      CustomerGroupId: -1,
	      CustomerGroupName: ''
	    },
	    pricemodel: {
	      PriceModelId: -1,
	      PriceModelName: ''
	    },
	    orderType: '0',
	    identification: {
	      ordernumber: {
	        value: '',
	        option: 1
	      },
	      rekvnumber: {
	        value: '',
	        option: 1
	      }
	    },
	    delivery: {
	      delivery: {
	        start: '',
	        end: ''
	      },
	      production: {
	        start: '',
	        end: ''
	      },
	      pickup: {
	        start: '',
	        end: ''
	      },
	      transport: 0
	    },
	    vehicle: {
	      regnumber: {
	        value: '',
	        option: 1
	      },
	      brand: {
	        value: '',
	        option: 1
	      },
	      model: {
	        value: '',
	        option: 1
	      },
	      year: {
	        value: '',
	        option: 1
	      }
	    },
	    color: {
	      color: {
	        value: '',
	        option: 1
	      },
	      code: {
	        value: '',
	        option: 1
	      },
	      ctype: {
	        value: '',
	        option: 1
	      },
	      amount: {
	        value: '',
	        option: 1
	      }
	    },
	    customer: {
	      name: {
	        value: '',
	        option: 1
	      },
	      city: {
	        value: '',
	        option: 1
	      },
	      zipcode: {
	        value: '',
	        option: 1
	      },
	      phone: {
	        value: '',
	        option: 1
	      },
	      contact_name: {
	        value: '',
	        option: 1
	      }
	    },
	    invoice: {
	      notApprovedForInvoicing: false,
	      approvedForInvoicing: false,
	      isInvoiced: false
	    },
	    economicfilter: {
	      economicFilterNotMatched: false,
	      economicFilterMatched: false
	    },
	    additionalreport: {
	      awaiting: false,
	      received: false
	    },
	    movedOrders: false,
	    parts: {
	      bodyNotOrdered: false,
	      bodyOrdered: false,
	      bodyInStock: false,
	      bodyArrived: false,
	      paintNotOrdered: false,
	      paintOrdered: false,
	      paintInStock: false,
	      paintArrived: false
	    },
	    HasPaintWork: true,
	    HasBodyWork: true,
	    NewOrdersFilter: 0,
	    AssignedToMe: false
	  },
	  initialFilterCustomer: {
	    process: {
	      draft: true,
	      draft1: false,
	      draft2: true,
	      InProcess: true,
	      Completed: false,
	      CompletedThisWeek: false
	    },
	    external_control: 'all',
	    invoicing: 'all',
	    evaluation: {
	      missing: false,
	      evaluated: false
	    },
	    update: {
	      missing: false,
	      updated: false
	    },
	    customergroup: {
	      CustomerGroupId: -1,
	      CustomerGroupName: ''
	    },
	    pricemodel: {
	      PriceModelId: -1,
	      PriceModelName: ''
	    },
	    orderType: '0',
	    identification: {
	      ordernumber: {
	        value: '',
	        option: 1
	      },
	      rekvnumber: {
	        value: '',
	        option: 1
	      }
	    },
	    delivery: {
	      delivery: {
	        start: '',
	        end: ''
	      },
	      production: {
	        start: '',
	        end: ''
	      },
	      pickup: {
	        start: '',
	        end: ''
	      },
	      transport: 0
	    },
	    vehicle: {
	      regnumber: {
	        value: '',
	        option: 1
	      },
	      brand: {
	        value: '',
	        option: 1
	      },
	      model: {
	        value: '',
	        option: 1
	      },
	      year: {
	        value: '',
	        option: 1
	      }
	    },
	    color: {
	      color: {
	        value: '',
	        option: 1
	      },
	      code: {
	        value: '',
	        option: 1
	      },
	      ctype: {
	        value: '',
	        option: 1
	      },
	      amount: {
	        value: '',
	        option: 1
	      }
	    },
	    customer: {
	      name: {
	        value: '',
	        option: 1
	      },
	      city: {
	        value: '',
	        option: 1
	      },
	      zipcode: {
	        value: '',
	        option: 1
	      },
	      phone: {
	        value: '',
	        option: 1
	      },
	      contact_name: {
	        value: '',
	        option: 1
	      }
	    },
	    invoice: {
	      notApprovedForInvoicing: false,
	      approvedForInvoicing: false,
	      isInvoiced: false
	    },
	    economicfilter: {
	      economicFilterNotMatched: false,
	      economicFilterMatched: false
	    },
	    additionalreport: {
	      awaiting: false,
	      received: false
	    },
	    movedOrders: true,
	    parts: {
	      bodyNotOrdered: false,
	      bodyOrdered: false,
	      bodyInStock: false,
	      bodyArrived: false,
	      paintNotOrdered: false,
	      paintOrdered: false,
	      paintInStock: false,
	      paintArrived: false
	    },
	    HasPaintWork: true,
	    HasBodyWork: true,
	    NewOrdersFilter: 0
	  },
	  initialFilterWP: {
	    process: {
	      draft: false,
	      draft1: false,
	      draft2: false,
	      InProcess: true,
	      Completed: false,
	      CompletedThisWeek: true
	    },
	    external_control: 'all',
	    invoicing: 'all',
	    evaluation: {
	      missing: false,
	      evaluated: false
	    },
	    update: {
	      missing: false,
	      updated: false
	    },
	    customergroup: {
	      CustomerGroupId: -1,
	      CustomerGroupName: ''
	    },
	    pricemodel: {
	      PriceModelId: -1,
	      PriceModelName: ''
	    },
	    orderType: '0',
	    identification: {
	      ordernumber: {
	        value: '',
	        option: 1
	      },
	      rekvnumber: {
	        value: '',
	        option: 1
	      }
	    },
	    delivery: {
	      delivery: {
	        start: '',
	        end: ''
	      },
	      production: {
	        start: '',
	        end: ''
	      },
	      pickup: {
	        start: '',
	        end: ''
	      },
	      transport: 0
	    },
	    vehicle: {
	      regnumber: {
	        value: '',
	        option: 1
	      },
	      brand: {
	        value: '',
	        option: 1
	      },
	      model: {
	        value: '',
	        option: 1
	      },
	      year: {
	        value: '',
	        option: 1
	      }
	    },
	    color: {
	      color: {
	        value: '',
	        option: 1
	      },
	      code: {
	        value: '',
	        option: 1
	      },
	      ctype: {
	        value: '',
	        option: 1
	      },
	      amount: {
	        value: '',
	        option: 1
	      }
	    },
	    customer: {
	      name: {
	        value: '',
	        option: 1
	      },
	      city: {
	        value: '',
	        option: 1
	      },
	      zipcode: {
	        value: '',
	        option: 1
	      },
	      phone: {
	        value: '',
	        option: 1
	      },
	      contact_name: {
	        value: '',
	        option: 1
	      }
	    },
	    invoice: {
	      notApprovedForInvoicing: false,
	      approvedForInvoicing: false,
	      isInvoiced: false
	    },
	    economicfilter: {
	      economicFilterNotMatched: false,
	      economicFilterMatched: false
	    },
	    additionalreport: {
	      awaiting: false,
	      received: false
	    },
	    movedOrders: true,
	    parts: {
	      bodyNotOrdered: false,
	      bodyOrdered: false,
	      bodyInStock: false,
	      bodyArrived: false,
	      paintNotOrdered: false,
	      paintOrdered: false,
	      paintInStock: false,
	      paintArrived: false
	    },
	    HasPaintWork: true,
	    HasBodyWork: true,
	    NewOrdersFilter: 0
	  },
	  simplesearch: {
	    save: true,
	    value: ''
	  },
	  simplesearchWorkscreen: {
	    save: true,
	    value: ''
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _constants.SET_ORDER:
	      return _extends({}, state, {
	        order: action.order
	      });
	    case _constants.SET_ORDER_BOOKING_TIMES:
	      var combineDateTime = function combineDateTime(obj) {
	        return obj.Date.replace('00:00:00', obj.Time);
	      };
	      var data = _extends({}, state, { order: _extends({}, state.order) });
	      var _action$data = action.data,
	          Body = _action$data.Body,
	          Paint = _action$data.Paint;
	
	      console.log('SET_ORDER_BOOKING_TIMES:', Body, Paint);
	      if (Body !== null) {
	        if (Body.Pickup !== null) data.order.BodyShopPickupTime = combineDateTime(Body.Pickup);
	        if (Body.Production !== null) data.order.BodyShopProductionTime = combineDateTime(Body.Production);
	        if (Body.Delivery !== null) data.order.BodyShopDeliveryTime = combineDateTime(Body.Delivery);
	      }
	      if (Paint !== null) {
	        if (Paint.Pickup !== null) data.order.Pickup = combineDateTime(Paint.Pickup);
	        if (Paint.Production !== null) data.order.ProductionDate = combineDateTime(Paint.Production);
	        if (Paint.Delivery !== null) data.order.Delivery = combineDateTime(Paint.Delivery);
	      }
	      return data;
	    case _constants.SET_WORKCARD_ORDER:
	      return _extends({}, state, {
	        workcardOrder: action.order
	      });
	    case _constants.SET_ORDERS:
	      if (action.orders === undefined && action.newUpdatedOrder !== undefined) {
	        var updatedOrders = JSON.parse(JSON.stringify(state.orders));
	        // console.log('action.newUpdatedOrderGroupIndex', action.newUpdatedOrderGroupIndex)
	        // console.log('action.newUpdatedOrderItemIndex', action.newUpdatedOrderItemIndex)
	        updatedOrders[action.newUpdatedOrderGroupIndex].Orders[action.newUpdatedOrderItemIndex] = action.newUpdatedOrder;
	        return _extends({}, state, {
	          orders: updatedOrders
	        });
	      } else {
	        return _extends({}, state, {
	          orders: action.orders
	        });
	      }
	    case _constants.SET_WORKSCREEN_ORDERS:
	      if (action.orders === undefined && action.newUpdatedOrder !== undefined) {
	        var _updatedOrders = JSON.parse(JSON.stringify(state.orders));
	        // console.log('action.newUpdatedOrderGroupIndex', action.newUpdatedOrderGroupIndex)
	        // console.log('action.newUpdatedOrderItemIndex', action.newUpdatedOrderItemIndex)
	        _updatedOrders[action.newUpdatedOrderGroupIndex].Orders[action.newUpdatedOrderItemIndex] = action.newUpdatedOrder;
	        return _extends({}, state, {
	          workscreenOrders: _updatedOrders
	        });
	      } else {
	        return _extends({}, state, {
	          workscreenOrders: action.orders
	        });
	      }
	    case _constants.SET_ORDERS_SEARCH:
	      return _extends({}, state, {
	        isSearching: action.isSearching
	      });
	    case _constants.SET_ORDERS_ERRORS:
	      return _extends({}, state, {
	        errors: action.error
	        // case SET_ORDER_FILTER:
	        //   return {
	        //     ...state,
	        //     filter: action.filter
	        //   }
	      });case _constants.SET_ORDERLIST_FILTER:
	      return _extends({}, state, {
	        filterOrderlist: action.filter
	      });
	    case _constants.SET_WORKSCREEN_ORDER_FILTER:
	      return _extends({}, state, {
	        filterWorkscreen: action.filter
	      });
	    case _constants.SET_CUSTOMER_ORDER_FILTER:
	      return _extends({}, state, {
	        filterCustomer: action.filter
	      });
	    case _constants.SET_WP_ORDER_FILTER:
	      return _extends({}, state, {
	        filterWP: action.filter
	        // case RESET_ORDER_FILTER:
	        //   let newFilter = JSON.parse(JSON.stringify(initialState.initialFilter))
	        //   window.localStorage.setItem('ordersFilter', JSON.stringify(initialState.initialFilter))
	        //   // newFilter.process.Completed = true
	        //   return {
	        //     ...state,
	        //     filter: newFilter
	        //   }
	      });case _constants.RESET_ORDERLIST_FILTER:
	      var newOrderListFilter = JSON.parse(JSON.stringify(initialState.initialFilterOrderlist));
	      window.localStorage.setItem('filterOrderlist', JSON.stringify(initialState.initialFilterOrderlist));
	      return _extends({}, state, {
	        filterOrderlist: newOrderListFilter
	      });
	    case _constants.RESET_WORKSCREEN_ORDER_FILTER:
	      var newWorkscreenOrdersFilter = JSON.parse(JSON.stringify(initialState.initialFilterWorkscreen));
	      window.localStorage.setItem('filterWorkscreen', JSON.stringify(initialState.initialFilterWorkscreen));
	      return _extends({}, state, {
	        filterWorkscreen: newWorkscreenOrdersFilter
	      });
	    case _constants.RESET_CUSTOMER_ORDER_FILTER:
	      var newCustomerOrdersFilter = JSON.parse(JSON.stringify(initialState.initialFilterCustomer));
	      window.localStorage.setItem('filterCustomer', JSON.stringify(initialState.initialFilterCustomer));
	      return _extends({}, state, {
	        filterCustomer: newCustomerOrdersFilter
	      });
	    case _constants.RESET_WP_ORDER_FILTER:
	      var newWPOrdersFilter = JSON.parse(JSON.stringify(initialState.initialFilterWP));
	      window.localStorage.setItem('filterWP', JSON.stringify(initialState.initialFilterWP));
	      return _extends({}, state, {
	        filterWP: newWPOrdersFilter
	      });
	    case _constants.SET_SIMPLESEARCH:
	      return _extends({}, state, {
	        simplesearch: action.simplesearch
	      });
	    case _constants.SET_SIMPLESEARCH_WORKSCREEN:
	      return _extends({}, state, {
	        simplesearchWorkscreen: action.simplesearch
	      });
	    case _constants.RESET_SIMPLESEARCH:
	      var simpleSearch = { save: true, value: '' };
	      window.localStorage.setItem('simpleSearch', JSON.stringify(simpleSearch));
	      return _extends({}, state, {
	        simplesearch: {
	          save: true,
	          value: ''
	        }
	      });
	    case _constants.RESET_SIMPLESEARCH_WORKSCREEN:
	      var simplesearchWorkscreen = { save: true, value: '' };
	      window.localStorage.setItem('simplesearchWorkscreen', JSON.stringify(simplesearchWorkscreen));
	      return _extends({}, state, {
	        simplesearchWorkscreen: {
	          save: true,
	          value: ''
	        }
	      });
	    case _constants.SET_LAST_VISITED_ORDER:
	      var parsed = parseInt(action.orderId);
	      return _extends({}, state, {
	        lastVisitedOrderId: isNaN(parsed) ? undefined : parsed
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  OverviewDeliveryData: {
	    ExecutionTime: null
	  },
	  OverviewPickupData: {
	    ExecutionTime: null
	  },
	  OverviewProductionData: {
	    ExecutionTime: null
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_DELIVERY_STATUS:
	      return _extends({}, state, {
	        OverviewDeliveryData: action.data
	      });
	    case _constants.SET_PICKUP_STATUS:
	      return _extends({}, state, {
	        OverviewPickupData: action.data
	      });
	    case _constants.SET_PRODUCTION_STATUS:
	      return _extends({}, state, {
	        OverviewProductionData: action.data
	      });
	
	    default:
	      return state;
	  }
	};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  price: {},
	  showPopupForParts: false,
	  carParts: [],
	  carPriceParts: [],
	  carSelectedParts: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _constants.SET_PRICECALC_PRICES:
	      return _extends({}, state, {
	        price: action.price
	      });
	    case _constants.OPEN_POPUP_PARTS:
	      return _extends({}, state, {
	        showPopupForParts: action.showPopupForParts,
	        selectedBodyPart: action.selectedBodyPart,
	        selectedBodyPartSide: action.selectedBodyPartSide
	      });
	    case _constants.SET_CAR_PARTS:
	      return _extends({}, state, {
	        carParts: action.carParts
	      });
	    case _constants.SET_CAR_PRICEPARTS:
	      return _extends({}, state, {
	        carPriceParts: action.carPriceParts
	      });
	    case _constants.SET_CAR_SELECTED_PARTS:
	      return _extends({}, state, {
	        carSelectedParts: action.carSelectedParts
	      });
	    case _constants.SET_CAR_ITEMS:
	      return _extends({}, state, {
	        carItems: action.carItems
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  sparePartsOrdering: [],
	  sparePartsCommentsOrdering: [],
	  sparePartsFilterOrdering: {},
	  sparePartsReception: [],
	  sparePartsCommentsReception: [],
	  sparePartsFilterReception: {},
	  sparePartsForMatching: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var res = _extends({}, state);
	  switch (action.type) {
	    case _constants.SET_SPARE_PARTS_ORDERING:
	      res.sparePartsOrdering = action.payload.spareParts;
	      res.sparePartsCommentsOrdering = action.payload.comments;
	      if (action.payload.filter != null) res.sparePartsFilterOrdering = action.payload.filter;
	      return res;
	    case _constants.SET_SPARE_PARTS_RECEPTION:
	      res.sparePartsReception = action.payload.spareParts;
	      res.sparePartsCommentsReception = action.payload.comments;
	      if (action.payload.filter != null) res.sparePartsFilterReception = action.payload.filter;
	      return res;
	    case _constants.SET_SPARE_PARTS_FOR_MATCHING:
	      res.sparePartsForMatching = action.payload.spareParts;
	      return res;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(5);
	
	var initialState = {
	  uploads: [],
	  progress: 100,
	  inProgress: false,
	  bytesTotal: 0,
	  bytesUploaded: 0
	};
	
	var calcProgress = function calcProgress(total, uploaded) {
	  if (total === uploaded) return 100;
	  if (uploaded === 0) return 0;
	  var result = parseInt(uploaded / total * 100);
	  return result;
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _constants.FINISH_UPLOADS:
	      var allDone = state.uploads.every(function (u) {
	        return calcProgress(u.file.size, u.file.loaded) === 100;
	      });
	      if (!allDone) {
	        return state;
	      }
	
	      console.log('Uploads finished');
	      // Clear uploads
	      if (window.uploads !== undefined && window.uploads !== null) {
	        window.uploads.splice(0, window.uploads.length);
	      }
	      action.payload = [];
	    // Fall through to next case
	    case _constants.SET_UPLOADS:
	      var uploads = action.payload;
	      var bytesTotal = 0;
	      var bytesUploaded = 0;
	      for (var i = 0; i < uploads.length; i++) {
	        bytesTotal += uploads[i].file.size;
	        bytesUploaded += uploads[i].file.loaded;
	      }
	      var progress = calcProgress(bytesTotal, bytesUploaded);
	      return _extends({}, state, {
	        uploads: uploads,
	        progress: progress,
	        inProgress: progress < 100,
	        bytesTotal: bytesTotal,
	        bytesUploaded: bytesUploaded
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarContent = function (_Component) {
	  _inherits(CalendarContent, _Component);
	
	  function CalendarContent(props) {
	    _classCallCheck(this, CalendarContent);
	
	    var _this = _possibleConstructorReturn(this, (CalendarContent.__proto__ || Object.getPrototypeOf(CalendarContent)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CalendarContent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar__content', style: this.props.style },
	        this.props.children
	      );
	    }
	  }]);
	
	  return CalendarContent;
	}(_react.Component);
	
	exports.default = CalendarContent;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1483);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarFooter = function (_Component) {
	  _inherits(CalendarFooter, _Component);
	
	  function CalendarFooter(props) {
	    _classCallCheck(this, CalendarFooter);
	
	    var _this = _possibleConstructorReturn(this, (CalendarFooter.__proto__ || Object.getPrototypeOf(CalendarFooter)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CalendarFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          footerItems = _props.footerItems,
	          height = _props.height;
	
	      var contentStyle = {};
	      if (footerItems && footerItems.length > 0) {
	        contentStyle.gridTemplateColumns = 'repeat(' + footerItems.length + ', minmax(16px, 1fr))';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-footer', style: height },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-footer__info' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-footer__content', style: contentStyle },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return CalendarFooter;
	}(_react.Component);
	
	exports.default = CalendarFooter;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _scrollingCalendar = __webpack_require__(1078);
	
	var _scrollingCalendar2 = _interopRequireDefault(_scrollingCalendar);
	
	__webpack_require__(1484);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarHeader = function (_Component) {
	  _inherits(CalendarHeader, _Component);
	
	  function CalendarHeader() {
	    _classCallCheck(this, CalendarHeader);
	
	    return _possibleConstructorReturn(this, (CalendarHeader.__proto__ || Object.getPrototypeOf(CalendarHeader)).apply(this, arguments));
	  }
	
	  _createClass(CalendarHeader, [{
	    key: 'render',
	    value: function render() {
	      switch (this.props.viewMode) {
	        case 'month':
	          return this.renderMonthView();
	        case 'week':
	          return this.renderWeekView();
	      }
	    }
	  }, {
	    key: 'renderMonthView',
	    value: function renderMonthView() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-header__buttons' },
	          this.props.renderButtons()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-header__content month' },
	          _react2.default.createElement(_scrollingCalendar2.default, { onItemClick: this.props.onItemClick, onRangeUpdated: this.props.onRangeUpdated, showFromDate: (0, _moment2.default)(this.props.showFromDate) })
	        )
	      );
	    }
	  }, {
	    key: 'renderDay',
	    value: function renderDay(item, key) {
	      // const text = translation(item.LongTextDictionaryKey)
	      var active = item.isSame((0, _moment2.default)(), 'day');
	      var text = item.format('dddd');
	      // const date = item.Text || moment(item.Date).format('DD.MM')
	      var date = item.format('DD.MM');
	      var classNames = 'calendar-header__item';
	      if (active) {
	        classNames += ' active';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames, key: key },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-header__txt' },
	          text
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-header__date' },
	          date
	        )
	      );
	    }
	
	    /**
	     * Renders header for week + navigation (at some point refactor to new component, same as month view)
	     * @returns
	     */
	
	  }, {
	    key: 'renderWeekView',
	    value: function renderWeekView() {
	      var _this2 = this;
	
	      // const { headerItems } = this.props
	
	      // Determine days to display
	      var fromDate = this.props.showFromDate;
	      var days = [];
	      for (var d = 0; d < 7; d++) {
	        var day = (0, _moment2.default)(fromDate).add(d, 'days');
	        days.push(day);
	      }
	
	      var contentStyle = {
	        gridTemplateColumns: 'repeat(' + days.length + ', minmax(48px, 1fr))'
	      };
	
	      var now = (0, _moment2.default)();
	      var showGotoNow = now.isBefore(days[0], 'day') || now.isAfter(days[days.length - 1], 'day');
	
	      var navPrev = function navPrev() {
	        var from = (0, _moment2.default)(fromDate).startOf('week').subtract(7, 'days');
	        var to = (0, _moment2.default)(from).add(7, 'days');
	        _this2.props.onRangeUpdated(from, to);
	      };
	
	      var navNext = function navNext() {
	        var from = (0, _moment2.default)(fromDate).startOf('week').add(7, 'days');
	        var to = (0, _moment2.default)(from).add(7, 'days');
	        _this2.props.onRangeUpdated(from, to);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-header__buttons' },
	          this.props.renderButtons()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-header__content week' },
	          _react2.default.createElement(
	            'div',
	            { className: 'controls' },
	            showGotoNow && _react2.default.createElement(
	              'div',
	              { className: 'go-to-now', onClick: function onClick() {
	                  _this2.props.onRangeUpdated((0, _moment2.default)(now).startOf('week'), (0, _moment2.default)(now).endOf('week'));
	                } },
	              (0, _helpers.translation)(18281)
	            ) || _react2.default.createElement(
	              'div',
	              null,
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'nav' },
	              _react2.default.createElement(
	                'div',
	                { className: 'prev' },
	                _react2.default.createElement(_icon2.default, { icon: _icons.GeneralIcons.Arrow_Left_Blue, size: 't', onClick: navPrev })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'current' },
	                (0, _helpers.translation)(250) + ' ' + fromDate.format('W')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'next' },
	                _react2.default.createElement(_icon2.default, { icon: _icons.GeneralIcons.Arrow_Right_Blue, size: 't', onClick: navNext })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'days', style: contentStyle },
	            days.map(this.renderDay)
	          )
	        )
	      );
	    }
	  }]);
	
	  return CalendarHeader;
	}(_react.Component);
	
	CalendarHeader.defaultProps = {
	  viewMode: 'month', // 'month' or 'week'
	  showFromDate: null, // moment
	  onItemClick: null,
	  onRangeUpdated: null,
	  renderButtons: function renderButtons() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      '\xA0'
	    );
	  }
	
	  // // Test data
	  // headerItems: [
	  //   { Text: '14.12', TextDictionaryKey: '169', ShortTextDictionaryKey: '15133', Date: '2020-12-14T00:00:00', Active: false, IsClosed: false },
	  //   { Text: '15.12', TextDictionaryKey: '170', ShortTextDictionaryKey: '15134', Date: '2020-12-14T00:00:00', Active: false, IsClosed: false },
	  //   { Text: '16.12', TextDictionaryKey: '171', ShortTextDictionaryKey: '15135', Date: '2020-12-14T00:00:00', Active: false, IsClosed: false },
	  //   { Text: '17.12', TextDictionaryKey: '172', ShortTextDictionaryKey: '15136', Date: '2020-12-14T00:00:00', Active: true, IsClosed: false },
	  //   { Text: '18.12', TextDictionaryKey: '173', ShortTextDictionaryKey: '15137', Date: '2020-12-14T00:00:00', Active: false, IsClosed: false },
	  //   { Text: '19.12', TextDictionaryKey: '174', ShortTextDictionaryKey: '15138', Date: '2020-12-14T00:00:00', Active: false, IsClosed: true },
	  //   { Text: '20.12', TextDictionaryKey: '175', ShortTextDictionaryKey: '15139', Date: '2020-12-14T00:00:00', Active: false, IsClosed: true }
	  // ]
	};
	
	exports.default = CalendarHeader;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarItemStatus = function (_PureComponent) {
	  _inherits(CalendarItemStatus, _PureComponent);
	
	  function CalendarItemStatus() {
	    _classCallCheck(this, CalendarItemStatus);
	
	    return _possibleConstructorReturn(this, (CalendarItemStatus.__proto__ || Object.getPrototypeOf(CalendarItemStatus)).apply(this, arguments));
	  }
	
	  _createClass(CalendarItemStatus, [{
	    key: 'render',
	    value: function render() {
	      var step = this.props.step;
	
	      var style = {
	        left: step.FromPercent + '%',
	        right: 100 - step.ToPercent + '%'
	      };
	      var classNames = 'calendar-item-status';
	      return _react2.default.createElement(
	        'div',
	        { className: classNames, style: style },
	        this.props.children
	      );
	    }
	  }]);
	
	  return CalendarItemStatus;
	}(_react.PureComponent);
	
	CalendarItemStatus.defaultProps = {
	  step: {
	    FromPercent: 0,
	    ToPercent: 5
	  }
	};
	
	exports.default = CalendarItemStatus;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarItemStep = function (_PureComponent) {
	  _inherits(CalendarItemStep, _PureComponent);
	
	  function CalendarItemStep() {
	    _classCallCheck(this, CalendarItemStep);
	
	    return _possibleConstructorReturn(this, (CalendarItemStep.__proto__ || Object.getPrototypeOf(CalendarItemStep)).apply(this, arguments));
	  }
	
	  _createClass(CalendarItemStep, [{
	    key: 'render',
	    value: function render() {
	      var step = this.props.step;
	
	      var style = {
	        left: step.FromPercent + '%',
	        right: 100 - step.ToPercent + '%'
	      };
	      var classNames = 'calendar-item-step';
	      return _react2.default.createElement(
	        'div',
	        { className: classNames, style: style },
	        this.props.children
	      );
	    }
	  }]);
	
	  return CalendarItemStep;
	}(_react.PureComponent);
	
	CalendarItemStep.defaultProps = {
	  step: {
	    FromPercent: 0,
	    ToPercent: 5,
	    Type: 1
	  }
	};
	
	exports.default = CalendarItemStep;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarItem = function (_Component) {
	  _inherits(CalendarItem, _Component);
	
	  function CalendarItem() {
	    _classCallCheck(this, CalendarItem);
	
	    return _possibleConstructorReturn(this, (CalendarItem.__proto__ || Object.getPrototypeOf(CalendarItem)).apply(this, arguments));
	  }
	
	  _createClass(CalendarItem, [{
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	
	      var style = {
	        left: item.FromPercent + '%',
	        right: 100 - item.ToPercent + '%'
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-item', style: style },
	        this.props.children
	      );
	    }
	  }]);
	
	  return CalendarItem;
	}(_react.Component);
	
	// Test data
	
	
	CalendarItem.defaultProps = {
	  item: { // order
	    FromPercent: 0,
	    ToPercent: 35,
	    Steps: [{ FromPercent: 0, ToPercent: 5, Type: 1 }, { FromPercent: 5, ToPercent: 78, Type: 2 }, { FromPercent: 78, ToPercent: 95, Type: 3 }, { FromPercent: 95, ToPercent: 100, Type: 1 }]
	  }
	};
	
	exports.default = CalendarItem;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1488);
	
	var _circle = __webpack_require__(300);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarOrderInfo = function (_PureComponent) {
	  _inherits(CalendarOrderInfo, _PureComponent);
	
	  function CalendarOrderInfo() {
	    _classCallCheck(this, CalendarOrderInfo);
	
	    return _possibleConstructorReturn(this, (CalendarOrderInfo.__proto__ || Object.getPrototypeOf(CalendarOrderInfo)).apply(this, arguments));
	  }
	
	  _createClass(CalendarOrderInfo, [{
	    key: 'render',
	    value: function render() {
	      if (!this.props.info) {
	        console.error('CalendarOrderInfo requires info prop');
	      }
	
	      var info = this.props.info;
	
	      var activeClass = this.props.active ? ' active' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-order-info' },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-order-info__content' + activeClass },
	          _react2.default.createElement(
	            'div',
	            { onClick: this.props.onHeaderClick, className: 'calendar-order-info__content__title ellipsis' },
	            info.Identity,
	            ' ',
	            info.IsWorkedOn !== undefined && info.IsWorkedOn && _react2.default.createElement(_circle2.default, { size: 't', color: 'brand-2' })
	          ),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return CalendarOrderInfo;
	}(_react.PureComponent);
	
	CalendarOrderInfo.defaultProps = {
	  onHeaderClick: function onHeaderClick() {},
	  active: false
	};
	
	exports.default = CalendarOrderInfo;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1489);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarRowGroup = function (_Component) {
	  _inherits(CalendarRowGroup, _Component);
	
	  function CalendarRowGroup() {
	    _classCallCheck(this, CalendarRowGroup);
	
	    return _possibleConstructorReturn(this, (CalendarRowGroup.__proto__ || Object.getPrototypeOf(CalendarRowGroup)).apply(this, arguments));
	  }
	
	  _createClass(CalendarRowGroup, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-row-group' },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-row-group__heading' },
	          _react2.default.createElement(
	            'div',
	            { className: 'calendar-row-group__info' },
	            this.props.renderInfo && this.props.renderInfo()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'calendar-row-group__controls' },
	            this.props.renderControls && this.props.renderControls()
	          )
	        ),
	        this.props.open && _react2.default.createElement(
	          'div',
	          { className: 'calendar-row-group__content' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return CalendarRowGroup;
	}(_react.Component);
	
	CalendarRowGroup.defaultProps = {
	  open: true
	};
	
	exports.default = CalendarRowGroup;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarRowMonth = function (_Component) {
	  _inherits(CalendarRowMonth, _Component);
	
	  function CalendarRowMonth(props) {
	    _classCallCheck(this, CalendarRowMonth);
	
	    var _this = _possibleConstructorReturn(this, (CalendarRowMonth.__proto__ || Object.getPrototypeOf(CalendarRowMonth)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CalendarRowMonth, [{
	    key: 'renderRowColumn',
	    value: function renderRowColumn(column, key) {
	      var classNames = 'calendar-row-month__column';
	      if (column.IsClosed) {
	        classNames += ' closed';
	      }
	
	      return _react2.default.createElement('div', { className: classNames, key: key });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          rowColumns = _props.rowColumns,
	          children = _props.children,
	          orderInfo = _props.orderInfo;
	
	
	      var contentStyle = {};
	      if (rowColumns && rowColumns.length > 0) {
	        contentStyle.gridTemplateColumns = 'repeat(' + rowColumns.length + ', minmax(16px, 1fr))';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-row-month' },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-row-month__info' },
	          orderInfo
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-row-month__content', style: contentStyle },
	          _react2.default.createElement(
	            'div',
	            { className: 'calendar-row-month__items' },
	            children
	          ),
	          rowColumns.map(this.renderRowColumn)
	        )
	      );
	    }
	  }]);
	
	  return CalendarRowMonth;
	}(_react.Component);
	
	exports.default = CalendarRowMonth;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarRowWeek = function (_Component) {
	  _inherits(CalendarRowWeek, _Component);
	
	  function CalendarRowWeek(props) {
	    _classCallCheck(this, CalendarRowWeek);
	
	    var _this = _possibleConstructorReturn(this, (CalendarRowWeek.__proto__ || Object.getPrototypeOf(CalendarRowWeek)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CalendarRowWeek, [{
	    key: 'renderRowColumn',
	    value: function renderRowColumn(column, key) {
	      var classNames = 'calendar-row-week__column';
	      if (column.IsClosed) {
	        classNames += ' closed';
	      }
	
	      return _react2.default.createElement('div', { className: classNames, key: key });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          rowColumns = _props.rowColumns,
	          children = _props.children,
	          orderInfo = _props.orderInfo;
	
	
	      var contentStyle = {};
	      if (rowColumns && rowColumns.length > 0) {
	        contentStyle.gridTemplateColumns = 'repeat(' + rowColumns.length + ', minmax(16px, 1fr))';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-row-week' },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-row-week__info' },
	          orderInfo
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar-row-week__content', style: contentStyle },
	          _react2.default.createElement(
	            'div',
	            { className: 'calendar-row-week__items' },
	            children
	          ),
	          rowColumns.map(this.renderRowColumn)
	        )
	      );
	    }
	  }]);
	
	  return CalendarRowWeek;
	}(_react.Component);
	
	exports.default = CalendarRowWeek;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './calendar.scss'
	
	var Calendar = function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar(props) {
	    _classCallCheck(this, Calendar);
	
	    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar', style: this.props.style },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Calendar;
	}(_react.Component);
	
	exports.default = Calendar;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _backdrop = __webpack_require__(29);
	
	var _common = __webpack_require__(25);
	
	var _carownerportal = __webpack_require__(192);
	
	var _icons = __webpack_require__(6);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(1492);
	
	var _spinner = __webpack_require__(1080);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router'
	
	
	var CarOwnerPortalInviteStatus = function (_Component) {
	  _inherits(CarOwnerPortalInviteStatus, _Component);
	
	  function CarOwnerPortalInviteStatus(props) {
	    _classCallCheck(this, CarOwnerPortalInviteStatus);
	
	    var _this = _possibleConstructorReturn(this, (CarOwnerPortalInviteStatus.__proto__ || Object.getPrototypeOf(CarOwnerPortalInviteStatus)).call(this));
	
	    _this.state = {
	      showSendModal: false
	    };
	    _this.getCarOwnerStatus = _this.getCarOwnerStatus.bind(_this);
	    _this.openOverlay = _this.openOverlay.bind(_this);
	    _this.openCarOwnerResendPopup = _this.openCarOwnerResendPopup.bind(_this);
	    _this.sendInvitation = _this.sendInvitation.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarOwnerPortalInviteStatus, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCarOwnerStatus(this.props.orderId);
	      _events2.default.addListener('UPDATE_CAROWNER', this.getCarOwnerStatus, this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _events2.default.removeListener('UPDATE_CAROWNER', this.getCarOwnerStatus);
	    }
	  }, {
	    key: 'openOverlay',
	    value: function openOverlay(e) {
	      e.persist();
	      this.setState({
	        showSendModal: false
	      });
	      this.props.triggerPopup(false);
	    }
	  }, {
	    key: 'openCarOwnerResendPopup',
	    value: function openCarOwnerResendPopup(date) {
	      this.setState({
	        showSendModal: true,
	        carOwnerPortalResend: {
	          date: (0, _time.renderFullDate)(date)
	        }
	      });
	      this.props.triggerPopup(true);
	    }
	  }, {
	    key: 'getCarOwnerStatus',
	    value: function getCarOwnerStatus() {
	      var _this2 = this;
	
	      var orderId = this.props.orderId;
	      this.setState({ carOwnerPortalStatus: null }, function () {
	        _this2.props.getCarOwnerStatus(orderId).then(function (res) {
	          _this2.setState({ carOwnerPortalStatus: res.data });
	        });
	      });
	    }
	  }, {
	    key: 'sendInvitation',
	    value: function sendInvitation() {
	      var _this3 = this;
	
	      var param = {
	        orderId: this.props.orderId,
	        isSendSMS: true,
	        IsSendEmail: true
	      };
	
	      this.props.sendInvitation(param).then(function (res) {
	        _this3.props.triggerPopup(false);
	        _this3.setState({
	          showSendModal: false
	        });
	        _this3.getCarOwnerStatus();
	
	        // window.toastr.success(translation('18189'), translation('13424'))
	      }, function () {
	        // Err saving
	        window.toastr.error((0, _helpers.translation)('18190'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.orderId) return null;
	      // Check permissions
	      // let hasData = this.state.carOwnerPortalStatus && this.state.carOwnerPortalStatus.Logs
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: 18217, className: 'carownerportalinvitestatus' },
	        this.renderContent() || _react2.default.createElement(_spinner2.default, { size: 2 })
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this4 = this;
	
	      // Render car owner portal status and invitation options
	      // console.log('state (car owner)', this.state)
	      var noticeText = '';
	      var dateOfStatusText = '';
	      var date = '';
	      var statusText = '';
	      var statusIcon = _icons.CarOwnerPortalIcons.NotSent;
	      var showSendLink = false;
	      var sendLinkText = (0, _helpers.translation)(18264); // Send invitation
	      var sendButtonText = (0, _helpers.translation)(1301);
	      var carOwnerPortalLatestLogDate = null;
	      var carOwnerPortalStatus = this.state.carOwnerPortalStatus;
	
	      if (typeof carOwnerPortalStatus !== 'undefined' && this.state.carOwnerPortalStatus !== null) {
	        if (carOwnerPortalStatus && carOwnerPortalStatus.Logs && carOwnerPortalStatus.Logs.length > 0) carOwnerPortalLatestLogDate = carOwnerPortalStatus.Logs[0].Date;
	        switch (carOwnerPortalStatus.Status) {
	          case 1:
	            // Active
	            statusText = (0, _helpers.translation)(295); // Active
	            statusIcon = _icons.CarOwnerPortalIcons.Active;
	            showSendLink = false;
	            noticeText = (0, _helpers.translation)(18221); // The car owner portal is active and can be used by car owner
	            dateOfStatusText = (0, _helpers.translation)(18254); // Accepted by the car owner
	            date = this.state.carOwnerPortalStatus.Logs.filter(function (x) {
	              return x.Status === 1;
	            }).slice(0, 1)[0].Date; // Latest date of car owner accept (active)
	            break;
	          case 2:
	            // NotInvited
	            statusText = (0, _helpers.translation)(18262); // No invitation sent
	            statusIcon = _icons.CarOwnerPortalIcons.NotSent;
	            showSendLink = true;
	            noticeText = (0, _helpers.translation)(18222); // no invitation has been sent to the car owner
	            dateOfStatusText = null;
	            break;
	          case 3:
	            // Invited
	            statusText = (0, _helpers.translation)(15000); // Awaiting approval
	            statusIcon = _icons.CarOwnerPortalIcons.Awaiting;
	            showSendLink = true;
	            sendLinkText = (0, _helpers.translation)(18219); // Re-send invitation
	            sendButtonText = (0, _helpers.translation)(18234); // Re-send
	            noticeText = (0, _helpers.translation)(18223); // An invitation has been sent by SMS or e-mail to the car owner, pending for approval of terms and conditions
	            dateOfStatusText = (0, _helpers.translation)(18255); // The car owner was invited
	            date = carOwnerPortalStatus.Logs.filter(function (x) {
	              return x.Status === 3;
	            }).slice(0, 1)[0].Date; // Latest date of invite
	            break;
	          case 4:
	            // RejectedByCarOwner
	            statusText = (0, _helpers.translation)(18263); // Declined
	            statusIcon = _icons.CarOwnerPortalIcons.Declined;
	            showSendLink = true;
	            sendLinkText = (0, _helpers.translation)(18219); // Re-send invitation
	            sendButtonText = (0, _helpers.translation)(18234); // Re-send
	            noticeText = (0, _helpers.translation)(18233); // The invitation has previously been rejected by the car owner. Please ensure a verbal consent before re-sending the invitation.
	            dateOfStatusText = (0, _helpers.translation)(18227); // Rejected by car owner
	            date = carOwnerPortalStatus.Logs.filter(function (x) {
	              return x.Status === 4;
	            }).slice(0, 1)[0].Date; // Latest date of car owner decline
	            break;
	        }
	      } else {
	        statusText = (0, _helpers.translation)(18262); // Declined
	        statusIcon = _icons.CarOwnerPortalIcons.NotSent;
	        showSendLink = true;
	        sendLinkText = (0, _helpers.translation)(18264); // Re-send invitation
	        sendButtonText = (0, _helpers.translation)(18234); // Re-send
	        noticeText = (0, _helpers.translation)(18222);
	      }
	
	      var renderSendLink = function renderSendLink() {
	        var mailOrPhoneAvailable = false;
	        if (typeof carOwnerPortalStatus !== 'undefined' && carOwnerPortalStatus !== null) {
	          mailOrPhoneAvailable = carOwnerPortalStatus.Phone || carOwnerPortalStatus.Mail;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { className: mailOrPhoneAvailable ? 'link-send' : 'link-send__disabled', href: '#', onClick: function onClick() {
	                return mailOrPhoneAvailable ? _this4.openCarOwnerResendPopup(carOwnerPortalLatestLogDate) : window.toastr.error((0, _helpers.translation)('18297'), (0, _helpers.translation)('216'));
	              } },
	            sendLinkText
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _inline2.default,
	          null,
	          statusText,
	          _react2.default.createElement(_icon2.default, { icon: statusIcon, size: 'xs' })
	        ),
	        showSendLink && renderSendLink(),
	        this.state.showSendModal && this.renderSendInvitationModal(noticeText, dateOfStatusText, date, sendLinkText, sendButtonText)
	      );
	    }
	  }, {
	    key: 'renderSendInvitationModal',
	    value: function renderSendInvitationModal(noticeText, dateOfStatusText, date, headerText, actionText) {
	      var _this5 = this;
	
	      var closeSendModal = function closeSendModal() {
	        _this5.props.triggerPopup(false);
	        _this5.setState({ showSendModal: false });
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'sendinvitation_modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            show: this.state.showSendModal,
	            onClose: closeSendModal,
	            header: headerText,
	            icon: _icons.ModalIcons.Note,
	            bottomBarProps: {
	              actionLabelText: actionText,
	              onActionClick: this.sendInvitation
	            } },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-bold' },
	              noticeText
	            ),
	            dateOfStatusText,
	            ' ',
	            (0, _time.renderFullDate)(date)
	          )
	        )
	      );
	    }
	  }]);
	
	  return CarOwnerPortalInviteStatus;
	}(_react.Component);
	
	CarOwnerPortalInviteStatus.defaultProps = {
	  orderId: 0
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getCarOwnerStatus: _carownerportal.getCarOwnerStatus,
	  triggerPopupActionBG: _backdrop.triggerPopupActionBG,
	  openOverlay: _common.openOverlay,
	  triggerPopup: _backdrop.triggerPopup,
	  sendInvitation: _carownerportal.sendInvitation
	})(CarOwnerPortalInviteStatus);

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1493);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// contants
	
	
	var CarRentalAssignmentList = function (_Component) {
	  _inherits(CarRentalAssignmentList, _Component);
	
	  function CarRentalAssignmentList() {
	    _classCallCheck(this, CarRentalAssignmentList);
	
	    return _possibleConstructorReturn(this, (CarRentalAssignmentList.__proto__ || Object.getPrototypeOf(CarRentalAssignmentList)).apply(this, arguments));
	  }
	
	  _createClass(CarRentalAssignmentList, [{
	    key: 'renderGroup',
	    value: function renderGroup(group, i) {
	      var groupName = '';
	      if (group.CarRentalId > 0) {
	        groupName = (0, _helpers.translation)(14859) + ' ' + group.CarNumber + ' - ' + group.Identity;
	      } else {
	        groupName = group.Identity;
	      }
	
	      var getDate = function getDate(dateTime) {
	        return dateTime.split(' - ')[0];
	      };
	      var getTime = function getTime(dateTime) {
	        return dateTime.split(' - ')[1];
	      };
	
	      var renderPeriod = function renderPeriod(p, i) {
	        var start = (0, _time.renderFullDate)(p.Start);
	        var end = (0, _time.renderFullDate)(p.End);
	        return _react2.default.createElement(
	          'div',
	          { key: 'period_' + i, className: 'period' },
	          _react2.default.createElement(
	            'div',
	            { className: 'period__start' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(16771)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'period__date' },
	              _react2.default.createElement(
	                'span',
	                null,
	                getDate(start)
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                getTime(start)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'period__end' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(16772)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'period__date' },
	              _react2.default.createElement(
	                'span',
	                null,
	                getDate(end)
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                getTime(end)
	              )
	            )
	          )
	        );
	      };
	
	      var renderContractStatus = function renderContractStatus() {
	        if (group.CarRentalSystem === _constants.CarRentalSystemTypes.RENTLOG) return;
	        if (group.ContractStatus === 1) {
	          // Not created
	          return _react2.default.createElement(
	            'div',
	            { className: 'assignment-contract' },
	            _react2.default.createElement(_icon2.default, { icon: _icons.CarRentalIcons.Warning }),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(16814)
	            )
	          );
	        } else if (group.ContractStatus === 2) {
	          // Created
	          return _react2.default.createElement(
	            'div',
	            { className: 'assignment-contract' },
	            _react2.default.createElement(_icon2.default, { icon: _icons.CarRentalIcons.OK }),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _helpers.translation)(16815)
	            )
	          );
	        }
	        return null;
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'assignment_' + i, className: 'assignment' },
	        _react2.default.createElement(
	          'div',
	          { className: 'rental-title' },
	          groupName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'assignment-periods' },
	          group.Periods.map(renderPeriod)
	        ),
	        group.CarRentalSystem === _constants.CarRentalSystemTypes.RENTLOG && _react2.default.createElement('br', null),
	        renderContractStatus()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Data comes in as list of periods. Group items by car / car alternative
	      var groupBy = function groupBy(item) {
	        return item.CarRentalId + '_' + item.CarRentalAltId;
	      };
	      var groups = {};
	      this.props.items.map(function (i) {
	        var groupKey = groupBy(i);
	        if (groups[groupKey] === undefined) {
	          // new group
	          groups[groupKey] = {
	            CarRentalId: i.CarRentalId,
	            CarRentalAltId: i.CarRentalAltId,
	            CarNumber: i.CarNumber,
	            Identity: i.Identity,
	            ContractStatus: i.ContractStatus,
	            Periods: [{ Start: i.Start, End: i.End }],
	            CarRentalSystem: _this2.props.auth.carRentalSystem
	          };
	        } else {
	          // Add period to existing group
	          groups[groupKey].Periods.push({ Start: i.Start, End: i.End });
	        }
	      });
	
	      var groupArray = Object.keys(groups).map(function (x) {
	        return groups[x];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'carrental-assignment' },
	        groupArray.map(this.renderGroup)
	      );
	    }
	  }]);
	
	  return CarRentalAssignmentList;
	}(_react.Component);
	
	CarRentalAssignmentList.defaultProps = {
	  items: []
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(CarRentalAssignmentList);

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LicensePlate = __webpack_require__(295);
	
	var _LicensePlate2 = _interopRequireDefault(_LicensePlate);
	
	__webpack_require__(1494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CarRentalPlate = function (_Component) {
	  _inherits(CarRentalPlate, _Component);
	
	  function CarRentalPlate() {
	    _classCallCheck(this, CarRentalPlate);
	
	    return _possibleConstructorReturn(this, (CarRentalPlate.__proto__ || Object.getPrototypeOf(CarRentalPlate)).apply(this, arguments));
	  }
	
	  _createClass(CarRentalPlate, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'carrental-plate' },
	        _react2.default.createElement(_LicensePlate2.default, { regNr: this.props.regNr, countryCode: this.props.countryCode }),
	        _react2.default.createElement(
	          'div',
	          { className: 'carnumber' },
	          _react2.default.createElement('div', { className: 'carnumber__line' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'carnumber__nr' },
	            this.props.nr
	          )
	        )
	      );
	    }
	  }]);
	
	  return CarRentalPlate;
	}(_react.Component);
	
	CarRentalPlate.defaultProps = {
	  regNr: 'XX 12 123',
	  countryCode: 'dk',
	  nr: '10'
	};
	
	exports.default = CarRentalPlate;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _price = __webpack_require__(115);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// import styles
	// import '../car.scss'
	// import './carpopup.scss'
	
	var DeviationList = function (_Component) {
	  _inherits(DeviationList, _Component);
	
	  function DeviationList(props) {
	    _classCallCheck(this, DeviationList);
	
	    var _this = _possibleConstructorReturn(this, (DeviationList.__proto__ || Object.getPrototypeOf(DeviationList)).call(this, props));
	
	    _this.state = {
	      selectedPart: {},
	      selectedBodyPart: undefined,
	      showPopupForParts: _this.props.showPopupForParts === true,
	      selectedPartsOriginal: [],
	      carItems: _this.props.carItems,
	      carPartItems: []
	    };
	    _this.renderComplaintOrDeviation = _this.renderComplaintOrDeviation.bind(_this);
	    _this.setSelectedProp = _this.setSelectedProp.bind(_this);
	    _this.close = _this.close.bind(_this);
	    _this.getTaskSide = _this.getTaskSide.bind(_this);
	    _this.manualTaskId = 9000000000000000;
	    return _this;
	  }
	
	  _createClass(DeviationList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.reset.bind(this);
	      this.init(this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.reset();
	    }
	  }, {
	    key: 'getTaskSide',
	    value: function getTaskSide(key) {
	      if (key.indexOf('tag') !== -1) {
	        return 0;
	      }
	      if (key.endsWith('-for')) {
	        if (key.indexOf('venstre-') !== -1) return 5;
	        if (key.indexOf('hojre-') !== -1) return 6;
	      } else if (key.endsWith('-bag')) {
	        if (key.indexOf('venstre-') !== -1) return 7;
	        if (key.indexOf('hojre-') !== -1) return 8;
	      }
	
	      if (key.indexOf('venstre-') !== -1) {
	        return 1;
	      } else if (key.indexOf('hojre-') !== -1) {
	        return 2;
	      } else if (key.indexOf('for-') !== -1) {
	        return 3;
	      } else if (key.indexOf('bag-') !== -1) {
	        return 4;
	      }
	      // console.log(key, ' - no side')
	      return 0;
	    }
	  }, {
	    key: 'setSelectedProp',
	    value: function setSelectedProp() {
	      var _this2 = this;
	
	      var part = this.state.selectedBodyPart;
	      var partTaskSide = this.getTaskSide(part);
	      var carItems = this.state.carItems;
	      if (window.carHandler.priceCalcType === 5 || window.carHandler.priceCalcType === 10) {
	        if (window.carHandler.priceCalcType !== 5 && !(window.carHandler.priceCalcType === 10 && window.carHandler.realOrderType === 5)) {
	          var carPartItems = [];
	          // console.log('carItems', carItems)
	          carItems.map(function (val) {
	            var item = _extends({}, val);
	            item.id = part + '_' + item.EnumValue;
	            item.IsSelected = false;
	            _this2.props.price.Parts.map(function (pricePart) {
	              // console.log('MappingName', pricePart.Part.MappingName, 'TaskSide', partTaskSide, 'pricePart', pricePart)
	              if (pricePart.Part.TaskSide === partTaskSide && part.includes(pricePart.Part.MappingName)) {
	                pricePart.DeviationReasons.map(function (reason) {
	                  if ('' + reason.DeviationType.Id === '' + item.EnumValue) item.IsSelected = true;
	                });
	              }
	
	              // let indexI = part.indexOf(pricePart.Part.MappingName)
	              // let indexV = part.indexOf('venstre-')
	              // let indexH = part.indexOf('hojre-')
	              // if ((indexI === 0 && pricePart.Part.TaskSide === 0) || (indexI > -1 && (indexV === 0 && pricePart.Part.TaskSide === 1 || indexH === 0 && pricePart.Part.TaskSide === 2))) {
	              //   pricePart.DeviationReasons.map((reason) => {
	              //     if ('' + reason.DeviationType.Id === '' + item.EnumValue) item.IsSelected = true
	              //   })
	              // }
	            });
	            carPartItems.push(item);
	          });
	          this.props.price.Parts.map(function (pricePart) {
	            if (pricePart.Part.TaskSide === partTaskSide && part.includes(pricePart.Part.MappingName)) {
	              pricePart.CustomDeviationReasons.map(function (reason) {
	                var customReason = _this2.getBlankDeviation(part);
	                customReason.id = part + '_' + reason.CustomDeviationReasonId;
	                customReason.IsSelected = true;
	                customReason.CustomReason = reason.CustomReason;
	                customReason.IsNew = false;
	                customReason.name = part + '_' + reason.CustomDeviationReasonId;
	                customReason.CustomDeviationReasonId = reason.CustomDeviationReasonId;
	                if (carPartItems.filter(function (item) {
	                  item.CustomDeviationReasonId === customReason.CustomDeviationReasonId;
	                }).length === 0) {
	                  carPartItems.push(customReason);
	                }
	              });
	            }
	
	            // let indexI = part.indexOf(pricePart.Part.MappingName)
	            // let indexV = part.indexOf('venstre-')
	            // let indexH = part.indexOf('hojre-')
	            // if ((indexI === 0 && pricePart.Part.TaskSide === 0) ||
	            //   (indexI > -1 && (indexV === 0 && pricePart.Part.TaskSide === 1 || indexH === 0 && pricePart.Part.TaskSide === 2))) {
	            //   pricePart.CustomDeviationReasons.map((reason) => {
	            //     let customReason = this.getBlankDeviation(part)
	            //     customReason.id = part + '_' + reason.CustomDeviationReasonId
	            //     customReason.IsSelected = true
	            //     customReason.CustomReason = reason.CustomReason
	            //     customReason.IsNew = false
	            //     customReason.name = part + '_' + reason.CustomDeviationReasonId
	            //     customReason.CustomDeviationReasonId = reason.CustomDeviationReasonId
	            //     if (carPartItems.filter((item) => { item.CustomDeviationReasonId === customReason.CustomDeviationReasonId }).length === 0) carPartItems.push(customReason)
	            //   })
	            // }
	          });
	          carPartItems.push(this.getBlankDeviation(part));
	          this.setState({
	            carPartItems: carPartItems
	          });
	        } else {
	          var _carPartItems = [];
	          carItems.map(function (val) {
	            var item = _extends({}, val);
	            item.id = part + '_' + item.EnumValue;
	            item.IsSelected = false;
	            _this2.props.price.Parts.map(function (pricePart) {
	              var indexI = part.indexOf(pricePart.Part.MappingName);
	              var indexV = part.indexOf('venstre-');
	              var indexH = part.indexOf('hojre-');
	              if (indexI === 0 && pricePart.Part.TaskSide === 0 || indexI > -1 && (indexV === 0 && pricePart.Part.TaskSide === 1 || indexH === 0 && pricePart.Part.TaskSide === 2)) {
	                pricePart.Complaints.map(function (reason) {
	                  if ('' + reason.ComplaintType === '' + item.EnumValue) item.IsSelected = true;
	                });
	              }
	            });
	            _carPartItems.push(item);
	          });
	          this.setState({
	            carPartItems: _carPartItems
	          });
	        }
	      }
	      return carItems;
	    }
	  }, {
	    key: 'getBlankDeviation',
	    value: function getBlankDeviation(part) {
	      this.manualTaskId++;
	      return {
	        id: part + '_' + this.manualTaskId,
	        EnumValue: '',
	        IsSelected: false,
	        name: '',
	        IsNew: true,
	        IsCustomDeviation: true
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset(props) {
	      this.manualTaskId = 9000000000000000;
	      this.setState({
	        selectedParts: [],
	        inputs: [],
	        inputsOriginal: [],
	        carParts: [],
	        priceParts: [],
	        selectedPart: {},
	        selectedBodyPart: typeof props === 'undefined' ? undefined : props.selectedBodyPart,
	        showPopupForParts: typeof props === 'undefined' ? false : props.showPopupForParts === true,
	        selectedPartsOriginal: [],
	        carItems: typeof props === 'undefined' ? [] : props.carItems,
	        carPartItems: []
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.showPopupForParts !== nextProps.showPopupForParts || this.props.selectedBodyPart !== nextProps.selectedBodyPart || this.props.selectedBodyPartSide !== nextProps.selectedBodyPartSide || !(0, _lodash.isEqual)(nextProps.carItems, this.props.carItems)) {
	        if (nextProps.showPopupForParts) {
	          this.init(nextProps);
	        } else {
	          this.reset(nextProps);
	        }
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init(props) {
	      var _this3 = this;
	
	      this.reset(props);
	      if (props.showPopupForParts !== true) return null;
	      this.setState({
	        selectedBodyPart: props.selectedBodyPart,
	        showPopupForParts: props.showPopupForParts === true
	      }, function () {
	        _this3.setSelectedProp();
	      });
	    }
	  }, {
	    key: 'renderComplaintOrDeviation',
	    value: function renderComplaintOrDeviation() {
	      var _this4 = this;
	
	      // Complaints & Deviation
	      if (window.carHandler.priceCalcType !== 5 && window.carHandler.priceCalcType !== 10) return null;
	      var submit = function submit() {
	        var extents = Object.assign([], _this4.state.carPartItems);
	        var extentsToSubmit = extents.filter(function (item) {
	          return item.IsSelected;
	        });
	        if (window.carHandler.priceCalcType === 5 || window.carHandler.priceCalcType === 10 && window.carHandler.realOrderType === 5) {
	          extentsToSubmit.map(function (item) {
	            item.name = item.id;
	            item.ComplaintType = item.EnumValue;
	          });
	        }
	        var toSubmit = [];
	        toSubmit.push(extentsToSubmit);
	        _this4.props.setCarSelectedParts(extentsToSubmit);
	        _this4.close();
	      };
	      var onChange = function onChange(e, type) {
	        var _state = _extends({}, _this4.state),
	            carPartItems = _state.carPartItems;
	
	        var item = carPartItems.filter(function (x) {
	          return x.id === e.target.id;
	        })[0];
	        if (window.carHandler.priceCalcType === 5 || window.carHandler.priceCalcType === 10 && window.carHandler.realOrderType === 5) {
	          item.IsSelected = !item.IsSelected;
	        } else {
	          if (e.target.name !== 'CustomReason') {
	            if (typeof item.CustomReason === 'undefined' || typeof item.CustomReason !== 'undefined' && item.CustomReason.length > 0) item.IsSelected = e.target.checked;
	          } else {
	            if (!item.IsSelected) {
	              item.IsSelected = true;
	              if (carPartItems.indexOf(item) === carPartItems.length - 1) {
	                carPartItems.push(_this4.getBlankDeviation(_this4.state.selectedBodyPart));
	              }
	            }
	            item[e.target.name] = e.target.value;
	            if (item.CustomReason.length === 0) {
	              item.IsSelected = false;
	              var lastItem = carPartItems[carPartItems.length - 1];
	              if (!lastItem.IsSelected && lastItem.CustomReason === '' && item.id !== lastItem.id) {
	                carPartItems.splice(carPartItems.length - 1, 1);
	              }
	            }
	          }
	        }
	        _this4.setState({
	          carPartItems: carPartItems
	        });
	      };
	      var inputs = this.state.carPartItems;
	      var renderInputs = function renderInputs(item, key) {
	        var id = item.id;
	        var isSelected = item.IsSelected;
	        var isCustom = item.IsCustomDeviation && item.IsNew;
	        // let checkboxClass = 'carCheckbox__custom'
	        // if (isCustom) checkboxClass += ' custom'
	        // if (!isCustom) checkboxClass += ' standard'
	        // console.log('key', id, item)
	        var idKey = '-' + id + '-' + item.IsCustomDeviation + '-' + item.IsNew;
	        var labelText = !item.IsCustomDeviation && !item.IsNew ? item.name : '';
	        labelText += item.IsCustomDeviation && !item.IsNew ? ' ' + item.CustomReason : '';
	        // labelText = isCustom ? <Text size='s' name={'CustomReason'} id={id} value={item.CustomReason} placeholder={translation('227')} onChange={onChange} /> : labelText
	        return isCustom ? _react2.default.createElement(
	          _inline2.default,
	          { alignChildren: 'center', block: true },
	          _react2.default.createElement(_check2.default, { simple: true, key: idKey, name: id, id: id, value: id, checked: isSelected, onChange: onChange }),
	          _react2.default.createElement(_text2.default, { size: 'm', name: 'CustomReason', id: id, value: item.CustomReason, placeholder: (0, _helpers.translation)('227'), onChange: onChange })
	        ) : _react2.default.createElement(_check2.default, { key: idKey, labelText: labelText, name: id, id: id, value: id, checked: isSelected, onChange: onChange });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        inputs.map(renderInputs),
	        _react2.default.createElement(_divider2.default, { size: 3, noLine: true }),
	        _react2.default.createElement(_button2.default, { onClick: submit, labelText: (0, _helpers.translation)('1208') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.showPopupForParts !== true) return null;
	      return this.renderComplaintOrDeviation();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.reset(this.props);
	      this.setState({
	        carItems: []
	      });
	      this.props.close();
	    }
	  }]);
	
	  return DeviationList;
	}(_react.Component);
	
	DeviationList.propTypes = {
	  close: _propTypes2.default.func.isRequired
	};
	DeviationList.contextTypes = {
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    price: state.price.price,
	    order: state.orders.order,
	    showPopupForParts: state.price.showPopupForParts,
	    selectedBodyPart: state.price.selectedBodyPart,
	    selectedBodyPartSide: state.price.selectedBodyPartSide,
	    carItems: state.price.carItems
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  showPopupParts: _price.showPopupParts,
	  setCarSelectedParts: _price.setCarSelectedParts
	})(DeviationList);

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _price = __webpack_require__(115);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var EstimationList = function (_Component) {
	  _inherits(EstimationList, _Component);
	
	  function EstimationList(props) {
	    _classCallCheck(this, EstimationList);
	
	    var _this = _possibleConstructorReturn(this, (EstimationList.__proto__ || Object.getPrototypeOf(EstimationList)).call(this, props));
	
	    _this.state = {
	      selectedPart: {},
	      selectedBodyPart: undefined,
	      carItems: [],
	      carPartItems: { tasks: [], extra: [], extents: [] }
	    };
	    _this.close = _this.close.bind(_this);
	    _this.reset.bind(_this);
	    _this.manualTaskId = 9000000000000000;
	    _this.manualExtraId = 9000000000000000;
	    return _this;
	  }
	
	  _createClass(EstimationList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.init(this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.reset();
	    }
	  }, {
	    key: 'getTaskSide',
	    value: function getTaskSide(key) {
	      if (key.indexOf('tag') !== -1) {
	        return 0;
	      }
	      if (key.endsWith('-for')) {
	        if (key.indexOf('venstre-') !== -1) return 5;
	        if (key.indexOf('hojre-') !== -1) return 6;
	      } else if (key.endsWith('-bag')) {
	        if (key.indexOf('venstre-') !== -1) return 7;
	        if (key.indexOf('hojre-') !== -1) return 8;
	      }
	
	      if (key.indexOf('venstre-') !== -1) {
	        return 1;
	      } else if (key.indexOf('hojre-') !== -1) {
	        return 2;
	      } else if (key.indexOf('for-') !== -1) {
	        return 3;
	      } else if (key.indexOf('bag-') !== -1) {
	        return 4;
	      }
	      // console.log(key, ' - no side')
	      return 0;
	    }
	  }, {
	    key: 'setSelectedProp',
	    value: function setSelectedProp() {
	      var _this2 = this;
	
	      if (window.carHandler.priceCalcType !== 5 && window.carHandler.priceCalcType !== 10) {
	        var part = this.state.selectedBodyPart;
	        var carPartItems = this.state.carPartItems;
	        var carItems = this.state.carItems;
	
	        if (part) {
	          var tasks = Object.assign({}, carItems.tasks);
	          var extra = Object.assign({}, carItems.extra);
	          var extents = Object.assign([], carItems.extents);
	          if (typeof tasks !== 'undefined') {
	            tasks[part].map(function (item) {
	              item.IsSelected = false;
	              var id = part + '_' + item.EstimationTaskId;
	              if (item.EstimationTaskId === 0 && item.OrderEstimationTaskId > 0) id = part + '_' + item.OrderEstimationTaskId;
	              item.id = id;
	              return item;
	            });
	          }
	          if (typeof extra !== 'undefined') {
	            extra[part].map(function (item) {
	              item.IsSelected = false;
	              var id = part + '_extra_' + item.EstimationExtraId;
	              item.id = id;
	              return item;
	            });
	          }
	          if (typeof extents !== 'undefined') {
	            extents.map(function (item) {
	              item.IsSelected = false;
	              var id = part + '_extent_' + item.PriceModelExtentId;
	              item.id = id;
	              return item;
	            });
	          }
	          if (tasks !== undefined && part !== undefined) {
	            var partTasks = tasks[part];
	            this.props.price.Parts.map(function (pricePart) {
	              pricePart.EstimationTasks.map(function (estimationTask) {
	                var taskSide = _this2.getTaskSide(part);
	                var indexI = part.indexOf(estimationTask.PartName);
	                if (estimationTask.EstimationTaskId === 0 && estimationTask.PartName === pricePart.Part.MappingName && indexI > -1 && estimationTask.TaskSide === taskSide) {
	                  var filteredPartTasks = [];
	                  partTasks.map(function (i) {
	                    if (typeof i.OrderEstimationTaskId !== 'undefined' && i.OrderEstimationTaskId === estimationTask.OrderEstimationTaskId) filteredPartTasks.push(i);
	                  });
	                  if (filteredPartTasks.length === 0 && typeof estimationTask.OrderEstimationTaskId !== 'undefined') {
	                    var blankItem = {
	                      id: estimationTask.PartName + '_' + estimationTask.OrderEstimationTaskId,
	                      AE: 0,
	                      EstimationTaskId: estimationTask.EstimationTaskId,
	                      IsSelected: false,
	                      Material: 0,
	                      Name: '',
	                      SortIndex: null
	                    };
	                    blankItem.OrderEstimationTaskId = estimationTask.OrderEstimationTaskId;
	                    blankItem.TaskName = estimationTask.TaskName;
	                    blankItem.IsDisabled = true;
	                    partTasks.push(blankItem);
	                  }
	                } else {
	                  var estimationFilteredTasks = [];
	                  partTasks.map(function (item) {
	                    if (item.OrderEstimationTaskId === estimationTask.OrderEstimationTaskId) {
	                      estimationFilteredTasks.push(item);
	                    }
	                  });
	                  var item = estimationFilteredTasks[0];
	                  if (typeof item !== 'undefined') {
	                    item.IsDisabled = true;
	                  }
	                }
	              });
	            });
	          }
	          var filteredTasks = [];
	          tasks[part].map(function (item) {
	            if (item.EstimationTaskId === 0 && item.OrderEstimationTaskId === 0) {
	              filteredTasks.push(item);
	            }
	          });
	          if (typeof tasks !== 'undefined' && typeof tasks[part] !== 'undefined' && filteredTasks.length === 0) {
	            this.manualTaskId++;
	            var newTask = {
	              id: part + '_' + this.manualTaskId,
	              OrderEstimationTaskId: 0,
	              EstimationTaskId: 0,
	              IsSelected: false,
	              IsDisabled: false,
	              SortIndex: null,
	              TaskName: ''
	            };
	            tasks[part].push(newTask);
	          }
	          var filteredExtra = [];
	          extra[part].map(function (item) {
	            if (item.EstimationExtraId === _this2.manualExtraId + 1) {
	              filteredExtra.push(item);
	            }
	          });
	          if (typeof extra !== 'undefined' && typeof extra[part] !== 'undefined' && filteredExtra.length === 0) {
	            extra[part].push(this.getBlankExtra(part));
	          }
	
	          var filteredExtents = [];
	          extents.map(function (item) {
	            if (item.id === part + '_extent_' + 0) filteredExtents.push(item);
	          });
	          if (typeof extents !== 'undefined' && filteredExtents.length === 0) {
	            extents.push({
	              id: part + '_extent_' + 0,
	              Group: 1,
	              IsSelected: false,
	              PriceModelExtentId: 0,
	              SortIndex: null,
	              Type: ''
	            }); // sest
	          } else {
	            filteredExtents.map(function (item) {
	              item.Type = '';
	            });
	          }
	          carPartItems.tasks = Object.assign({}, tasks);
	          carPartItems.extents = extents;
	          carPartItems.extra = extra;
	          this.setState({
	            carPartItems: carPartItems
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getBlankExtra',
	    value: function getBlankExtra(part) {
	      this.manualExtraId++;
	      return {
	        id: part + '_extra_' + this.manualExtraId,
	        AE: 0,
	        EstimationExtraId: this.manualExtraId,
	        EstimationTaskId: this.manualExtraId,
	        IsSelected: false,
	        Material: 0,
	        Name: '',
	        SortIndex: null
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset(props) {
	      this.manualTaskId = 9000000000000000;
	      this.manualExtraId = 9000000000000000;
	      this.setState({
	        selectedPart: {},
	        selectedBodyPart: typeof props === 'undefined' ? undefined : props.selectedBodyPart,
	        carItems: [],
	        carPartItems: { tasks: [], extra: [], extents: [] }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // console.log('[EstimationList props recieived]', nextProps, this.props)
	      if (this.props.selectedBodyPart !== nextProps.selectedBodyPart || this.props.selectedBodyPartSide !== nextProps.selectedBodyPartSide || !(0, _lodash.isEqual)(nextProps.carItems, this.props.carItems)) {
	        this.reset(nextProps);
	        if (nextProps.show) {
	          this.init(nextProps);
	        } else {
	          this.reset(nextProps);
	        }
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init(props) {
	      var _this3 = this;
	
	      this.reset(props);
	      this.setState({
	        selectedBodyPart: props.selectedBodyPart,
	        carItems: typeof props !== 'undefined' ? Object.assign({}, props.carItems) : { tasks: [], extra: [], extents: [] },
	        carPartItems: { tasks: [], extra: [], extents: [] }
	      }, function () {
	        if (props.show !== true) return null;
	        _this3.setSelectedProp();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      if (Number(window.carHandler.priceCalcType) !== 1) return null;
	      var part = this.props.selectedBodyPart;
	      var tasks = this.state.carPartItems.tasks[part];
	      var extra = this.state.carPartItems.extra[part];
	      var extents = this.state.carPartItems.extents;
	
	      // Dont render popup No tasks, return null
	      if (typeof tasks === 'undefined' || tasks.length === 0) {
	        return null;
	      }
	      var resetSelected = function resetSelected(items) {
	        items.map(function (item) {
	          item.IsSelected = false;
	        });
	      };
	      var onChange = function onChange(e, type) {
	        var _state = _extends({}, _this4.state),
	            carPartItems = _state.carPartItems;
	
	        if (e.target.name === 'extra') {
	          var item = carPartItems.extra[_this4.state.selectedBodyPart].filter(function (x) {
	            return x.id === e.target.id;
	          })[0];
	          if (item.Name.length > 0) item.IsSelected = e.target.checked;
	        }
	        if (e.target.name === 'task') {
	          resetSelected(carPartItems.tasks[_this4.state.selectedBodyPart]);
	          var _item = carPartItems.tasks[_this4.state.selectedBodyPart].filter(function (x) {
	            return x.id === e.target.id;
	          })[0];
	          _item.IsSelected = true;
	        }
	        if (e.target.name === 'extent') {
	          resetSelected(carPartItems.extents);
	          var _item2 = carPartItems.extents.filter(function (x) {
	            return x.id === e.target.id;
	          })[0];
	          _item2.IsSelected = true;
	        }
	        if (['TaskName', 'Type', 'Name'].includes(e.target.name)) {
	          var _item3 = {};
	          if (e.target.name === 'TaskName') _item3 = carPartItems.tasks[_this4.state.selectedBodyPart].filter(function (x) {
	            return x.id === e.target.id;
	          })[0];
	          if (e.target.name === 'Type') _item3 = carPartItems.extents.filter(function (x) {
	            return x.id === e.target.id;
	          })[0];
	          if (e.target.name === 'Name') _item3 = carPartItems.extra[_this4.state.selectedBodyPart].filter(function (x) {
	            return x.id === e.target.id;
	          })[0];
	          if (!_item3.IsSelected) {
	            if (e.target.name !== 'Name') resetSelected(e.target.name === 'Type' ? carPartItems.extents : carPartItems.tasks[_this4.state.selectedBodyPart]);
	            _item3.IsSelected = true;
	          }
	          if (e.target.name === 'Name' && carPartItems.extra[_this4.state.selectedBodyPart][carPartItems.extra[_this4.state.selectedBodyPart].length - 1].id === _item3.id) {
	            // add new input if this is the last one
	            carPartItems.extra[_this4.state.selectedBodyPart].push(_this4.getBlankExtra(_this4.state.selectedBodyPart));
	          }
	          _item3[e.target.name] = e.target.value;
	          if (_item3.IsSelected && e.target.name === 'Name') {
	            if (_item3.Name.length === 0) {
	              _item3.IsSelected = false;
	              // Remove last input field if empty
	              var lastItem = carPartItems.extra[_this4.state.selectedBodyPart][carPartItems.extra[_this4.state.selectedBodyPart].length - 1];
	              if (!lastItem.IsSelected && lastItem.Name === '' && _item3.id !== lastItem.id) {
	                carPartItems.extra[_this4.state.selectedBodyPart].splice(carPartItems.extra[_this4.state.selectedBodyPart].length - 1, 1);
	              }
	            }
	          }
	        }
	        if (['AE', 'Material'].includes(e.target.name)) {
	          var _item4 = carPartItems.extra[_this4.state.selectedBodyPart].filter(function (x) {
	            return x.id === e.target.id;
	          })[0];
	          _item4[e.target.name] = e.target.value;
	        }
	        _this4.setState({
	          carPartItems: carPartItems
	        });
	      };
	      var mapTasks = function mapTasks(item, key) {
	        var id = item.id;
	        var disabled = item.IsDisabled === true;
	        var isCustom = item.OrderEstimationTaskId === 0;
	        if (!isCustom && item.EstimationTaskId === 0 && item.TaskName === '') return null;
	        // let radioClass = 'carRadio__custom'
	        // if (isCustom) radioClass += ' custom'
	        return _react2.default.createElement(
	          'div',
	          { className: 'customRadio', key: '11task' + id },
	          isCustom && _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0, alignChildren: 'center' },
	            _react2.default.createElement(_radio2.default, { simple: true, name: 'task', id: id, value: id, disabled: disabled, checked: item.IsSelected, onChange: onChange }),
	            _react2.default.createElement(_text2.default, { size: 's', name: 'TaskName', id: id, value: item.TaskName, placeholder: (0, _helpers.translation)('227'), onChange: onChange })
	          ),
	          !isCustom && _react2.default.createElement(_radio2.default, { labelText: item.TaskName, name: 'task', id: id, value: id, disabled: disabled, checked: item.IsSelected, onChange: onChange })
	        );
	      };
	      var mapExtents = function mapExtents(item, key) {
	        var id = item.id;
	        var isCustom = item.PriceModelExtentId === 0;
	        // let radioClass = 'carRadio__custom'
	        // if (isCustom) radioClass += ' custom'
	        return _react2.default.createElement(
	          'div',
	          { className: 'customRadio', key: 'extent' + id },
	          isCustom && _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0, alignChildren: 'center' },
	            _react2.default.createElement(_radio2.default, { simple: true, name: 'extent', id: id, value: id, checked: item.IsSelected, onChange: onChange }),
	            _react2.default.createElement(_text2.default, { size: 's', name: 'Type', id: id, value: item.Type, placeholder: (0, _helpers.translation)('227'), onChange: onChange })
	          ),
	          !isCustom && _react2.default.createElement(_radio2.default, { labelText: item.Type, name: 'extent', id: id, value: id, checked: item.IsSelected, onChange: onChange })
	        );
	      };
	      var mapExtra = function mapExtra(item, key) {
	        var id = item.id;
	        var isCustom = item.EstimationExtraId > 9000000000000000;
	        // let widthLeft = ' sixty'
	        // let widthRight = ' fourty'
	        // let leftClass = 'leftcontent' + widthLeft
	        // let rightClass = 'rightcontent' + widthRight
	        // let checkboxClass = 'carCheckbox__custom'
	        // if (isCustom) checkboxClass += ' custom'
	        // if (!isCustom) checkboxClass += ' standard'
	        return _react2.default.createElement(
	          _grid2.default,
	          { key: 'extra' + id, cols: [2, 0.50, 0.50], align: 'center' },
	          isCustom ? _react2.default.createElement(
	            _inline2.default,
	            { alignChildren: 'center', spacing: 0 },
	            _react2.default.createElement(_check2.default, { spacing: 1, name: 'extra', id: id, value: id, checked: item.IsSelected === true, onChange: onChange }),
	            _react2.default.createElement(_text2.default, { size: 's', name: 'Name', id: id, value: item.Name, placeholder: (0, _helpers.translation)('227'), onChange: onChange })
	          ) : _react2.default.createElement(_check2.default, { spacing: 1, labelText: item.Name, name: 'extra', id: id, value: id, checked: item.IsSelected === true, onChange: onChange }),
	          _react2.default.createElement(_text2.default, { size: 's', name: 'AE', id: id, value: item.AE, onChange: onChange }),
	          _react2.default.createElement(_text2.default, { size: 's', name: 'Material', id: id, value: item.Material, onChange: onChange })
	        );
	      };
	      var submit = function submit() {
	        var tasks = Object.assign([], _this4.state.carPartItems.tasks[_this4.state.selectedBodyPart]);
	        var extras = Object.assign([], _this4.state.carPartItems.extra[_this4.state.selectedBodyPart]);
	        var extents = Object.assign([], _this4.state.carPartItems.extents);
	        var tasksToSubmit = tasks.filter(function (item) {
	          return item.IsSelected;
	        });
	        var extrasToSubmit = extras.filter(function (item) {
	          return item.IsSelected;
	        });
	        var extentsToSubmit = extents.filter(function (item) {
	          return item.IsSelected;
	        });
	        var taskItem = tasksToSubmit[0];
	        var extentItem = extentsToSubmit[0];
	        var extraItems = [];
	        extrasToSubmit.map(function (item) {
	          extraItems.push({
	            id: item.id,
	            ae: item.AE,
	            mat: item.Material,
	            isnew: item.EstimationExtraId > 9000000000000000,
	            name: item.Name
	          });
	        });
	
	        var submitObject = {
	          isEstimation: true,
	          name: typeof taskItem !== 'undefined' ? taskItem.id : extrasToSubmit !== undefined && extrasToSubmit.length > 0 ? extrasToSubmit[0].id : '',
	          isnew: typeof taskItem !== 'undefined' ? taskItem.OrderEstimationTaskId === 0 : '',
	          taskname: typeof taskItem !== 'undefined' ? taskItem.TaskName : '',
	          value: {
	            extra: extraItems
	          }
	        };
	        if (typeof extentItem !== 'undefined') {
	          submitObject.value = {
	            extent: extentItem.id,
	            type: extentItem.Type,
	            isnew: extentItem.PriceModelExtentId === 0,
	            extra: extraItems
	          };
	        }
	        var toSubmit = [];
	        toSubmit.push(submitObject);
	        _this4.props.setCarSelectedParts(toSubmit);
	        _this4.close();
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('1227') }),
	            tasks.map(mapTasks)
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('889') }),
	            extents.map(mapExtents)
	          )
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            { span: '2' },
	            _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13374') }),
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [2, 0.5, 0.5] },
	              _react2.default.createElement('span', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('885')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('13443')
	              )
	            ),
	            extra.map(mapExtra),
	            _react2.default.createElement(_divider2.default, { size: 3, noLine: true })
	          ),
	          _react2.default.createElement(_button2.default, { onClick: submit, labelText: (0, _helpers.translation)('1208') })
	        )
	      );
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.reset(this.props);
	      this.setState({
	        carItems: []
	      });
	      this.props.close();
	    }
	  }]);
	
	  return EstimationList;
	}(_react.Component);
	
	EstimationList.defaultProps = {};
	EstimationList.propTypes = {
	  close: _propTypes2.default.func.isRequired
	};
	EstimationList.contextTypes = {
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    price: state.price.price,
	    order: state.orders.order,
	    selectedBodyPart: state.price.selectedBodyPart,
	    selectedBodyPartSide: state.price.selectedBodyPartSide,
	    carPriceParts: state.price.carPriceParts,
	    carItems: state.price.carItems
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  showPopupParts: _price.showPopupParts,
	  setCarSelectedParts: _price.setCarSelectedParts
	})(EstimationList);

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _price = __webpack_require__(115);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import styles
	
	// Elements
	
	
	var ExtentList = function (_Component) {
	  _inherits(ExtentList, _Component);
	
	  function ExtentList(props) {
	    _classCallCheck(this, ExtentList);
	
	    var _this = _possibleConstructorReturn(this, (ExtentList.__proto__ || Object.getPrototypeOf(ExtentList)).call(this, props));
	
	    _this.state = {
	      selectedParts: [],
	      inputs: [],
	      inputsOriginal: [],
	      carParts: [],
	      priceParts: [],
	      selectedPart: {},
	      selectedBodyPart: undefined,
	      showPopupForParts: _this.props.showPopupForParts === true,
	      selectedPartsOriginal: []
	    };
	    _this.addNewInput = _this.addNewInput.bind(_this);
	    _this.close = _this.close.bind(_this);
	    _this.manualTaskId = 9000000000000000;
	    _this.manualSpareTaskId = 9000000010000000;
	    _this.findTaskFromTextId = _this.findTaskFromTextId.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExtentList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.reset.bind(this);
	      this.init(this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.reset();
	    }
	  }, {
	    key: 'getBlankTask',
	    value: function getBlankTask(part) {
	      this.manualTaskId++;
	      return {
	        id: part + '_extra_' + this.manualTaskId,
	        AE: 0,
	        EstimationExtraId: this.manualTaskId,
	        IsSelected: false,
	        Material: 0,
	        Name: '',
	        SortIndex: null
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset(props) {
	      this.manualTaskId = 9000000000000000;
	      this.setState({
	        selectedParts: [],
	        inputs: [],
	        inputsOriginal: [],
	        carParts: [],
	        priceParts: [],
	        selectedPart: {},
	        selectedBodyPart: typeof props === 'undefined' ? undefined : props.selectedBodyPart,
	        showPopupForParts: typeof props === 'undefined' ? false : props.showPopupForParts === true,
	        selectedPartsOriginal: []
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.showPopupForParts !== nextProps.showPopupForParts || this.props.selectedBodyPart !== nextProps.selectedBodyPart || this.props.selectedBodyPartSide !== nextProps.selectedBodyPartSide || this.props.isPaint !== nextProps.isPaint) {
	        if (nextProps.showPopupForParts) {
	          this.init(nextProps);
	        } else {
	          this.reset(nextProps);
	        }
	      }
	    }
	  }, {
	    key: 'formatCurrencies',
	    value: function formatCurrencies(e) {
	      if (e.SparePartPrice !== null) e.SparePartPrice = (0, _currency.formatCurrency)(parseFloat((0, _currency.reverseFormatCurrency)(e.SparePartPrice)));
	      if (e.AE !== null) e.AE = (0, _currency.formatCurrency)(parseFloat((0, _currency.reverseFormatCurrency)(e.AE)), 1);
	      if (e.Gross !== null) e.Gross = (0, _currency.formatCurrency)(parseFloat(e.Gross));
	    }
	  }, {
	    key: 'init',
	    value: function init(props) {
	      var _this2 = this;
	
	      var filterParts = function filterParts(val) {
	        return props.selectedBodyPart.indexOf(val.Part.MappingName) > -1 && (0, _lodash.isEqual)(val.Part.TaskSide, props.selectedBodyPartSide);
	      };
	      var filterCarParts = function filterCarParts(val) {
	        return val.Mapping === props.selectedBodyPart;
	      };
	      var createCarPartMapping = function createCarPartMapping(part, partItemId, taskSide) {
	        var carParts = [];
	        var list = !props.isPaint ? JSON.parse(JSON.stringify(part.BodyTasks)) : JSON.parse(JSON.stringify(part.Tasks));
	        var tasks = _this2.state.orderTasks; // part.Tasks
	        list.forEach(function (e) {
	          if (e !== undefined) {
	            if (!props.isPaint) _this2.formatCurrencies(e);
	            if (e.OrderTaskId === undefined && e.TaskId !== undefined) {
	              var foundTask = false;
	              for (var key in tasks) {
	                var task = tasks[key];
	                if (!props.isPaint) _this2.formatCurrencies(task);
	                if (e.TaskId === task.TaskPriceId) {
	                  task.FromOrderPrice = true;
	                  task.IsSelected = true;
	                  carParts.push(task);
	                  foundTask = true;
	                  break;
	                }
	              }
	              if (!foundTask) {
	                carParts.push(_this2.getInputFromPart(e, partItemId, taskSide));
	              }
	            } else if (e.OrderTaskId !== undefined) {
	              var item = JSON.parse(JSON.stringify(e));
	              if (!props.isPaint) _this2.formatCurrencies(item);
	              carParts.push(item);
	            }
	          }
	        });
	        tasks.forEach(function (e) {
	          var item = JSON.parse(JSON.stringify(e));
	          if (!props.isPaint) _this2.formatCurrencies(item);
	          if (item.OrderTaskId > 0 && item.TaskPriceId === 0) {
	            item.IsSelected = true;
	            item.name = _this2.state.selectedBodyPart + '_' + item.OrderTaskId + '_text';
	            carParts.push(item);
	          }
	        });
	        return carParts;
	      };
	      if (props.showPopupForParts !== true) return null;
	      this.reset(props);
	      var parts = JSON.parse(JSON.stringify(props.carPriceParts));
	      parts = parts.filter(filterParts);
	      var part = parts[0];
	      var carParts = JSON.parse(JSON.stringify(props.carParts));
	      carParts = carParts.filter(filterCarParts);
	      var carPart = carParts[0];
	      this.setState({
	        selectedBodyPart: props.selectedBodyPart,
	        showPopupForParts: props.showPopupForParts === true,
	        orderTasks: typeof part !== 'undefined' ? part.Tasks : []
	      }, function () {
	        if (part === undefined) {
	          part = carPart;
	        }
	        if (!props.isPaint) {
	          part.BodyTasks = JSON.parse(JSON.stringify(carPart.BodyTasks));
	          if (part !== undefined) {
	            if (part.PartId === undefined) part.PartId = part.Part.PartItemId;
	            if (part.TaskSide === undefined) part.TaskSide = part.Part.TaskSide;
	            part.BodyTasks = createCarPartMapping(part, part.PartId, part.TaskSide);
	          }
	        } else {
	          part.Tasks = JSON.parse(JSON.stringify(carPart.Tasks));
	          if (part !== undefined) {
	            if (part.PartId === undefined) part.PartId = part.Part.PartItemId;
	            if (part.TaskSide === undefined) part.TaskSide = part.Part.TaskSide;
	            part.Tasks = createCarPartMapping(part, part.PartId, part.TaskSide);
	          }
	        }
	        _this2.setState({
	          selectedBodyPart: props.selectedBodyPart,
	          showPopupForParts: props.showPopupForParts === true,
	          selectedPartsOriginal: props.showPopupForParts === true ? JSON.parse(JSON.stringify(_this2.props.carSelectedParts)) : [],
	          selectedParts: props.showPopupForParts === true ? JSON.parse(JSON.stringify(_this2.props.carSelectedParts)) : [],
	          inputs: props.isPaint ? JSON.parse(JSON.stringify(part.Tasks)) : part !== undefined ? part.BodyTasks !== undefined ? JSON.parse(JSON.stringify(part.BodyTasks)) : JSON.parse(JSON.stringify(part.Tasks)) : [],
	          inputsOriginal: props.isPaint ? JSON.parse(JSON.stringify(part.Tasks)) : part !== undefined ? part.BodyTasks !== undefined ? JSON.parse(JSON.stringify(part.BodyTasks)) : JSON.parse(JSON.stringify(part.Tasks)) : [],
	          selectedPart: part,
	          priceParts: JSON.parse(JSON.stringify(props.carPriceParts)),
	          carParts: props.carParts
	        }, function () {
	          // console.log('CarPopup init state', this.state.inputs)
	          if (_this2.shouldPushOther(_this2.state.inputs, _this2.manualTaskId, false)) _this2.addNewInput(_this2.manualTaskId, false);
	          if (!_this2.props.isPaint && _this2.shouldPushOther(_this2.state.inputs, _this2.manualSpareTaskId, true)) _this2.addNewInput(_this2.manualSpareTaskId, true);
	        });
	      });
	    }
	  }, {
	    key: 'getInputFromPart',
	    value: function getInputFromPart(task, partItemId, taskSide) {
	      var newTask = this.getInput(task.TaskId, task.TaskName, partItemId, taskSide, true, task.TaskId);
	      newTask.IsNew = true;
	      if (!this.props.isPaint) {
	        newTask.AE = task.AE;
	        newTask.Gross = task.TaskPrice;
	        this.formatCurrencies(newTask);
	      }
	      return newTask;
	    }
	  }, {
	    key: 'getInput',
	    value: function getInput(id, taskName, partItemId, taskSide, fromOrderPrice) {
	      var taskPriceId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	      var newInput = {
	        AE: 0,
	        AgreementDiscount: 0,
	        Discount: 0,
	        EnvAfterDiscountWP: 0,
	        Environment: 0,
	        EnvironmentAfterDiscount: 0,
	        EnvironmentWP: 0,
	        Gross: 0,
	        GrossWP: 0,
	        IsDeleted: false,
	        Mat: 0,
	        Net: 0,
	        NetWP: 0,
	        OrderTaskId: id,
	        PartItemId: partItemId,
	        TaskName: taskName,
	        TaskPriceId: taskPriceId,
	        TaskSide: taskSide,
	        Total: 0,
	        TotalWP: 0,
	        IsSelected: false,
	        FromOrderPrice: fromOrderPrice,
	        SparePartCount: '',
	        SparePartPrice: '',
	        IsSparePart: false,
	        name: this.state.selectedBodyPart + '_' + id + '_text'
	      };
	      return newInput;
	    }
	  }, {
	    key: 'addNewInput',
	    value: function addNewInput(id, isSpare) {
	      var inputs = this.state.inputs;
	      var selectedPart = this.state.selectedPart;
	
	      if (selectedPart === undefined) return null;
	      var newInput = this.getInput(id, '', selectedPart.PartId, selectedPart.TaskSide, false);
	      newInput.IsNew = true;
	      newInput.IsSparePart = isSpare;
	      if (isSpare) newInput.SparePartCount = 1;
	      inputs.push(newInput);
	      this.setState({
	        inputs: inputs
	      });
	    }
	  }, {
	    key: 'shouldPushOther',
	    value: function shouldPushOther(inputs, id, isSpare) {
	      var notPermittet = [1, 5, 10];
	      if (notPermittet.indexOf(Number(window.carHandler.priceCalcType)) > -1) return false;
	      return this.findTask(inputs, id, isSpare) === undefined;
	    }
	  }, {
	    key: 'findTask',
	    value: function findTask(inputs, id, isSpare) {
	      for (var i = 0; i < inputs.length; i++) {
	        var item = inputs[i];
	        if (isSpare !== undefined && item.OrderTaskId === id && item.IsSparePart === isSpare) {
	          return item;
	        }
	        if (isSpare === undefined && item.OrderTaskId === id) {
	          return item;
	        }
	      }
	      return undefined;
	    }
	  }, {
	    key: 'findTaskFromTextId',
	    value: function findTaskFromTextId(textId) {
	      var id = textId.replace('_text', '').replace(this.props.selectedBodyPart + '_', '');
	      id = Number(id);
	      var inputs = this.state.inputs;
	
	      var task = this.findTask(inputs, id);
	      return task;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.showPopupForParts !== true) return null;
	      var notPermitted = [1, 5, 10];
	      if (notPermitted.indexOf(Number(window.carHandler.priceCalcType)) > -1) return null;
	      var priceText = (0, _helpers.translation)('641');
	      var currencyCode = (0, _helpers.translation)(this.props.currencyCode);
	      var currencyText = priceText + ' (' + currencyCode + ')';
	      // const renderLineHeading = (icon, text) => {
	      //   if (this.props.price.Department !== 1) return null
	
	      //   return (
	      //     <div className='title'>
	      //       <div className='icon titleIcon'>
	      //         <img src={icon} />
	      //       </div>
	      //       {translation(text)}
	      //       <span />
	      //     </div>
	      //   )
	      // }
	      var renderHeadings = function renderHeadings() {
	        if (_this3.props.price.Department !== 1) return null;
	        return _react2.default.createElement(
	          _grid2.default,
	          { spacing: 1, cols: [1.30, 0.35, 0.35] },
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'ae' },
	            (0, _helpers.translation)('13345')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'price' },
	            currencyText
	          )
	        );
	      };
	      var part = this.props.selectedBodyPart;
	      // Default price calculation
	      if (typeof this.state.inputs === 'undefined' || this.state.inputs.length === 0) {
	        return null;
	      }
	      var findPropName = function findPropName(name) {
	        var notName = ['ae', 'partCount', 'partPrice', 'price'];
	        var index = notName.indexOf(name);
	        switch (index) {
	          case 0:
	            return 'AE';
	          case 1:
	            return 'SparePartCount';
	          case 2:
	            return 'SparePartPrice';
	          case 3:
	            return 'Gross';
	          default:
	            return 'TaskName';
	        }
	      };
	      var change = function change(e) {
	        var prop = findPropName(e.target.name);
	        var inputs = _this3.state.inputs;
	
	        var task = _this3.findTaskFromTextId(e.target.id);
	        var oldValue = task[prop];
	        var newValue = e.target.value;
	        var isSpare = task.IsSparePart;
	        if (prop !== 'TaskName') {
	          // make sure it is a number
	          if (prop === 'SparePartCount') {
	            newValue = Number(newValue);
	            if (isNaN(newValue)) newValue = oldValue;
	          }
	        }
	        task[prop] = newValue;
	        task.IsSelected = true;
	        _this3.setState({
	          inputs: inputs
	        });
	        var id = e.target.id.replace('_text', '').replace(_this3.props.selectedBodyPart + '_', '');
	        id = Number(id);
	        id++;
	        var nextTask = _this3.findTask(inputs, id, isSpare);
	        if (nextTask === undefined && id < (isSpare ? _this3.manualSpareTaskId : _this3.manualTaskId)) {
	          id = isSpare ? _this3.manualSpareTaskId : _this3.manualTaskId;
	          id++;
	          nextTask = _this3.findTask(inputs, id, isSpare);
	        }
	        var id2 = Number(e.target.id.replace('_text', '').replace(_this3.props.selectedBodyPart + '_', ''));
	        if (nextTask === undefined && _this3.shouldPushOther(_this3.state.inputs, id, isSpare) && (0, _lodash.isEqual)(id2, isSpare ? _this3.manualSpareTaskId : _this3.manualTaskId)) {
	          _this3.addNewInput(id, isSpare);
	          if (isSpare) {
	            _this3.manualSpareTaskId++;
	          } else {
	            _this3.manualTaskId++;
	          }
	        }
	      };
	      var onBlur = function onBlur(e) {
	        var prop = findPropName(e.target.name);
	        if (prop === 'TaskName') return null;
	        var inputs = _this3.state.inputs;
	
	        var task = _this3.findTaskFromTextId(e.target.id);
	        if (prop !== 'SparePartCount') {
	          var oldValue = parseFloat((0, _currency.reverseFormatCurrency)(task[prop]));
	          var newValue = (0, _currency.formatCurrency)(oldValue);
	          task[prop] = newValue;
	        }
	        if (prop === 'SparePartCount' || prop === 'SparePartPrice') {
	          var gross = 0;
	          if (task.SparePartCount > 0) {
	            gross = task.SparePartCount * parseFloat((0, _currency.reverseFormatCurrency)(task.SparePartPrice));
	          }
	          task.Gross = (0, _currency.formatCurrency)(gross);
	          task.Net = task.Gross;
	        }
	        _this3.setState({
	          inputs: inputs
	        });
	      };
	      var checkChange = function checkChange(e) {};
	      var click = function click(e) {
	        var id = e.target.name.replace('_text', '').replace(_this3.props.selectedBodyPart + '_', '');
	        var inputs = _this3.state.inputs;
	
	        var task = _this3.findTask(inputs, Number(id));
	        var index = inputs.indexOf(task);
	        inputs.splice(index, 1, task);
	        task.IsSelected = e.target.value === 'false';
	        _this3.setState({
	          inputs: inputs
	        });
	      };
	      var renderPartHeadings = function renderPartHeadings() {
	        if (_this3.props.price.Department !== 1) return null;
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: [2.1, 1.15, 0.25, 1, 1], spacing: 1 },
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'spareprice' },
	            (0, _helpers.translation)('14833')
	          ),
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'ae' },
	            (0, _helpers.translation)('385')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'price' },
	            currencyText
	          )
	        );
	      };
	      var mapSpareInputs = function mapSpareInputs(value, key) {
	        // let { inputs } = this.state
	        var task = value; // this.findTask(inputs, Number(value.OrderTaskId))
	        var id = part + '_' + task.OrderTaskId;
	        var textVal = task.TaskName;
	        var isSelected = task.IsSelected;
	        // let specialClassName = 'carSpecialText row clearfix newcarrow'
	        // let labelText = ''
	        var inputName = id + '_text';
	        var partCount = task.SparePartCount;
	        var sparePrice = task.SparePartPrice;
	        var cost = task.Gross;
	        var idkey = '' + task.OrderTaskId;
	        // let leftClass = 'leftcontent sixty'
	        // let rightClass = 'rightcontent fourty'
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _grid2.default,
	            { key: idkey, cols: ['min-content', 1, 0.75, 'min-content', 1.25], align: 'center', spacing: 1 },
	            _react2.default.createElement(_check2.default, { simple: true, name: id, id: id, value: isSelected, checked: isSelected, onChange: checkChange, onClick: click }),
	            _react2.default.createElement(_text2.default, { size: 's', className: 'carTextInput spare', name: inputName, id: inputName, value: textVal, placeholder: (0, _helpers.translation)('227'), onChange: change.bind(_this3), onBlur: onBlur.bind(_this3) }),
	            _react2.default.createElement(_text2.default, { size: 's', className: 'partprice', name: 'partPrice', id: id, value: sparePrice, placeholder: (0, _helpers.translation)('14833'), onChange: change.bind(_this3), onBlur: onBlur.bind(_this3) }),
	            _react2.default.createElement(
	              'span',
	              { className: 'multi' },
	              ' X '
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0, block: true },
	              _react2.default.createElement(_text2.default, { size: 's', className: 'count', name: 'partCount', id: id, value: partCount, placeholder: (0, _helpers.translation)('385'), onChange: change.bind(_this3), onBlur: onBlur.bind(_this3) }),
	              _react2.default.createElement(_text2.default, { size: 's', className: 'price spare', name: 'price', id: id, value: cost, placeholder: currencyText, onChange: change.bind(_this3), onBlur: onBlur.bind(_this3) })
	            )
	          ),
	          _react2.default.createElement(_divider2.default, { noLine: true })
	        );
	      };
	      var mapInputs = function mapInputs(value, key) {
	        // let { inputs } = this.state
	        var task = value; // this.findTask(inputs, Number(value.OrderTaskId))
	        var id = part + '_' + task.OrderTaskId;
	        var isSpecial = task.OrderTaskId >= _this3.manualTaskId || task.TaskPriceId === 0 && !task.FromOrderPrice;
	        var textVal = task.TaskName;
	        var isSelected = task.IsSelected;
	        // let specialClassName = isSpecial ? 'carSpecialText' : ''
	        // specialClassName += ' row clearfix newcarrow'
	        var labelText = isSpecial ? '' : task.TaskName;
	        var inputName = id + '_text';
	        var ae = task.AE;
	        var cost = task.Gross;
	        var idkey = '' + task.OrderTaskId;
	        // let widthLeft = ' sixty'
	        // let widthRight = ' fourty'
	        // let leftClass = 'leftcontent' + widthLeft
	        // let rightClass = 'rightcontent' + widthRight
	        // DecimalInput instead of Text
	        return _react2.default.createElement(
	          _grid2.default,
	          { key: idkey, align: 'center', spacing: 1, cols: [1.25, 0.75] },
	          isSpecial ? _react2.default.createElement(
	            _inline2.default,
	            { block: true, alignChildren: 'center', spacing: 0 },
	            _react2.default.createElement(_check2.default, { simple: true, name: id, id: id, value: isSelected, checked: isSelected, onChange: checkChange, onClick: click }),
	            _react2.default.createElement(_text2.default, { size: 's', name: inputName, id: inputName, value: textVal, placeholder: (0, _helpers.translation)('227'), onChange: change.bind(_this3), onBlur: onBlur.bind(_this3) })
	          ) : _react2.default.createElement(_check2.default, { spacing: 0, labelText: labelText, name: id, id: id, value: isSelected, checked: isSelected, onChange: checkChange, onClick: click }),
	          !_this3.props.isPaint && _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0 },
	            _react2.default.createElement(_text2.default, { size: 's', name: 'ae', id: id, value: ae, placeholder: (0, _helpers.translation)('13345'), onChange: change.bind(_this3), onBlur: onBlur.bind(_this3) }),
	            _react2.default.createElement(_text2.default, { size: 's', name: 'price', id: id, value: cost, placeholder: currencyText, onChange: change.bind(_this3), onBlur: onBlur.bind(_this3) })
	          )
	        );
	      };
	      var submit = function submit() {
	        var details = JSON.parse(JSON.stringify(_this3.state.inputs));
	        var toSubmit = [];
	
	        var _loop = function _loop(key) {
	          var task = details[key];
	          task.name = _this3.state.selectedBodyPart + '_' + task.OrderTaskId + '_text';
	          if (!_this3.props.isPaint) {
	            if (task.SparePartPrice === null) task.SparePartPrice = 0;
	            if (task.AE === null) task.AE = 0;
	            if (task.Gross === null) task.Gross = 0;
	            task.SparePartPrice = parseFloat((0, _currency.reverseFormatCurrency)(task.SparePartPrice));
	            task.AE = parseFloat((0, _currency.reverseFormatCurrency)(task.AE));
	            task.Gross = parseFloat((0, _currency.reverseFormatCurrency)(task.Gross));
	            task.Net = task.Gross;
	          }
	          if (task.IsSelected === false && task.OrderTaskId < 9000000000000000 && _this3.state.orderTasks.filter(function (t) {
	            return task.OrderTaskId === t.OrderTaskId;
	          }).length === 1) {
	            // console.log('not selected task', task)
	            task.IsDeleted = true;
	          } else {
	            if (task.IsNew === true) {
	              task.OrderTaskId = 0;
	            }
	          }
	          if (task.IsSelected === true || task.IsDeleted === true) {
	            toSubmit.push(task);
	          }
	        };
	
	        for (var key in details) {
	          _loop(key);
	        }
	        _this3.props.setCarSelectedParts(toSubmit);
	        _this3.close();
	      };
	      var notSpares = this.state.inputs.filter(function (val, index) {
	        return !val.IsSparePart;
	      });
	
	      var isSpares = this.state.inputs.filter(function (val, index) {
	        return val.IsSparePart;
	      });
	      // {renderLineHeading('/images/svgs/pricecalculation/workflow.svg', '14852')}
	      // {renderLineHeading('/images/svgs/pricecalculation/spare-parts.svg', '14853')}
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.price.Department === 1 && [_react2.default.createElement(_panelHeader2.default, { key: '1', text: _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0, block: true, alignChildren: 'center' },
	            _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Workflow }),
	            (0, _helpers.translation)('14852')
	          ) }), _react2.default.createElement(_divider2.default, { key: '2' })],
	        renderHeadings(),
	        _react2.default.createElement(
	          'div',
	          { className: 'taskslist' },
	          notSpares.map(mapInputs)
	        ),
	        this.props.price.Department === 1 && [_react2.default.createElement(_panelHeader2.default, { key: '5', text: _react2.default.createElement(
	            _inline2.default,
	            { spacing: 0, block: true, alignChildren: 'center' },
	            _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Spare_Parts }),
	            (0, _helpers.translation)('14853')
	          ) }), _react2.default.createElement(_divider2.default, { key: '6' })],
	        renderPartHeadings(),
	        isSpares.map(mapSpareInputs),
	        _react2.default.createElement(_divider2.default, { size: 3, noLine: true }),
	        _react2.default.createElement(_button2.default, { onClick: submit, labelText: (0, _helpers.translation)('1208') })
	      );
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.reset(this.props);
	      this.props.close();
	    }
	  }]);
	
	  return ExtentList;
	}(_react.Component);
	
	ExtentList.defaultProps = {};
	ExtentList.propTypes = {
	  isPaint: _propTypes2.default.bool.isRequired,
	  close: _propTypes2.default.func.isRequired
	};
	ExtentList.contextTypes = {
	  // t: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    price: state.price.price,
	    order: state.orders.order,
	    showPopupForParts: state.price.showPopupForParts,
	    selectedBodyPart: state.price.selectedBodyPart,
	    selectedBodyPartSide: state.price.selectedBodyPartSide,
	    carParts: state.price.carParts,
	    carPriceParts: state.price.carPriceParts,
	    carSelectedParts: state.price.carSelectedParts,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  showPopupParts: _price.showPopupParts,
	  setCarSelectedParts: _price.setCarSelectedParts
	})(ExtentList);

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _price = __webpack_require__(115);
	
	var _helpers = __webpack_require__(2);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OtherDamageList = function (_Component) {
	  _inherits(OtherDamageList, _Component);
	
	  function OtherDamageList(props) {
	    _classCallCheck(this, OtherDamageList);
	
	    var _this = _possibleConstructorReturn(this, (OtherDamageList.__proto__ || Object.getPrototypeOf(OtherDamageList)).call(this, props));
	
	    _this.state = {
	      selectedPart: {},
	      selectedBodyPart: undefined,
	      showPopupForParts: _this.props.showPopupForParts === true,
	      selectedPartsOriginal: [],
	      carItems: _this.props.carItems,
	      carPartItems: []
	    };
	
	    _this.init = _this.init.bind(_this);
	    _this.reset = _this.reset.bind(_this);
	    _this.setSelectedProp = _this.setSelectedProp.bind(_this);
	    _this.close = _this.close.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.renderInputs = _this.renderInputs.bind(_this);
	
	    _this.manualTaskId = 9000000000000000;
	    return _this;
	  }
	
	  _createClass(OtherDamageList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.init(this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.reset();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.showPopupForParts !== nextProps.showPopupForParts || this.props.selectedBodyPart !== nextProps.selectedBodyPart || this.props.selectedBodyPartSide !== nextProps.selectedBodyPartSide || !(0, _lodash.isEqual)(this.props.carItems, nextProps.carItems)) {
	        if (nextProps.showPopupForParts) {
	          this.init(nextProps);
	        } else {
	          this.reset(nextProps);
	        }
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init(props) {
	      var _this2 = this;
	
	      this.reset(props);
	      if (props.showPopupForParts !== true) return null;
	      this.setState({
	        selectedBodyPart: props.selectedBodyPart,
	        showPopupForParts: props.showPopupForParts === true
	      }, function () {
	        _this2.setSelectedProp();
	      });
	    }
	  }, {
	    key: 'reset',
	    value: function reset(props) {
	      this.manualTaskId = 9000000000000000;
	      this.setState({
	        selectedPart: {},
	        selectedBodyPart: !props ? null : props.selectedBodyPart,
	        showPopupForParts: !props ? false : props.showPopupForParts,
	        carItems: !props ? [] : props.carItems,
	        carPartItems: []
	      });
	    }
	  }, {
	    key: 'setSelectedProp',
	    value: function setSelectedProp() {
	      var _this3 = this;
	
	      var part = this.state.selectedBodyPart;
	      var carItems = this.state.carItems;
	
	      var hasCustomSelected = false;
	      var additionalCustomParts = [];
	      var carPartItems = carItems.map(function (cItem) {
	        var item = _extends({}, cItem);
	
	        item.id = part + '_' + item.EnumValue;
	        item.IsSelected = false;
	
	        var validOtherDamage = _this3.props.price.OtherDamages.find(function (od) {
	          return !od.Active;
	        });
	
	        _this3.props.price.Parts.forEach(function (pricePart) {
	          var indexI = part.indexOf(pricePart.Part.MappingName);
	          var indexV = part.indexOf('venstre-');
	          var indexH = part.indexOf('hojre-');
	          var indexF = part.indexOf('-for');
	          var indexB = part.indexOf('-bag');
	
	          var isMiddle = indexI === 0 && pricePart.Part.TaskSide === 0;
	          var isLeft = indexV === 0 && pricePart.Part.TaskSide === 1;
	          var isRight = indexH === 0 && pricePart.Part.TaskSide === 2;
	          var isLeftFront = indexV === 0 && indexF !== -1 && pricePart.Part.TaskSide === 5;
	          var isRightFront = indexH === 0 && indexF !== -1 && pricePart.Part.TaskSide === 6;
	          var isLeftBack = indexV === 0 && indexB !== -1 && pricePart.Part.TaskSide === 7;
	          var isRightBack = indexH === 0 && indexB !== -1 && pricePart.Part.TaskSide === 8;
	
	          if (isMiddle || indexI > -1 && (isLeft || isRight || isLeftFront || isRightFront || isLeftBack || isRightBack)) {
	            pricePart.OtherDamages.forEach(function (od) {
	              if (od.Type === item.EnumValue && od.OtherDamageId === validOtherDamage.Id) {
	                item.IsSelected = true;
	
	                if (od.Type === 10) {
	                  // For not the first item
	                  if (hasCustomSelected) {
	                    additionalCustomParts = [].concat(_toConsumableArray(additionalCustomParts), [_extends({}, item, { CustomName: od.CustomName })]);
	                  } else {
	                    item.CustomName = od.CustomName;
	                  }
	
	                  hasCustomSelected = true;
	                }
	              }
	            });
	          }
	        });
	        return item;
	      });
	
	      carPartItems = [].concat(_toConsumableArray(carPartItems), _toConsumableArray(additionalCustomParts));
	
	      if (hasCustomSelected) {
	        carPartItems = [].concat(_toConsumableArray(carPartItems), [this.createBlankDamage(this.state.selectedBodyPart)]);
	      }
	
	      this.setState({
	        carPartItems: carPartItems
	      });
	
	      return carItems;
	    }
	  }, {
	    key: 'createBlankDamage',
	    value: function createBlankDamage(part) {
	      return {
	        id: part + '_' + ++this.manualTaskId,
	        EnumValue: 10,
	        IsSelected: false,
	        name: 'Andet',
	        CustomName: null
	      };
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.reset(this.props);
	      this.setState({
	        carItems: []
	      });
	      this.props.close();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var carPartItems = this.state.carPartItems;
	
	      var extents = carPartItems.filter(function (cpi) {
	        return cpi.IsSelected;
	      });
	
	      this.props.setCarSelectedParts(extents);
	      this.close();
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _e$target = e.target,
	          id = _e$target.id,
	          name = _e$target.name,
	          value = _e$target.value,
	          checked = _e$target.checked;
	
	      var _state = _extends({}, this.state),
	          carPartItems = _state.carPartItems;
	
	      var item = carPartItems.find(function (cpi) {
	        return cpi.id === id;
	      });
	
	      if (name !== 'CustomDamage') {
	        item.IsSelected = checked;
	      } else {
	        var isNew = false;
	
	        if (!item.IsSelected) {
	          item.IsSelected = true;
	          isNew = true;
	
	          var isLast = carPartItems.indexOf(item) === carPartItems.length - 1;
	          if (isLast) {
	            carPartItems = [].concat(_toConsumableArray(carPartItems), [this.createBlankDamage(this.state.selectedBodyPart)]);
	          }
	        }
	
	        item.CustomName = id !== value ? value : '';
	
	        if (!isNew && item.CustomName.length === 0) {
	          item.IsSelected = false;
	
	          var lastItem = carPartItems[carPartItems.length - 1];
	          if (!lastItem.IsSelected && lastItem.name === 'Andet' && item.id !== lastItem.id) {
	            carPartItems = carPartItems.filter(function (cpi) {
	              return cpi.id !== item.id;
	            });
	          }
	        }
	      }
	
	      this.setState({
	        carPartItems: carPartItems
	      });
	    }
	  }, {
	    key: 'renderInputs',
	    value: function renderInputs(item, key) {
	      var id = item.id;
	      var isSelected = item.IsSelected;
	      var isCustom = item.EnumValue === 10;
	
	      // let checkboxClass = 'carCheckbox__custom'
	      // if (isCustom) checkboxClass += ' custom'
	
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        !isCustom && _react2.default.createElement(_check2.default, { id: id, name: !isCustom ? id : 'CustomDamage', value: id, checked: isSelected, onChange: this.onChange, labelText: !isCustom && item.name, spacing: 1 }),
	        isCustom && _react2.default.createElement(
	          _inline2.default,
	          { spacing: 0, alignChildren: 'center' },
	          _react2.default.createElement(_check2.default, { id: id, name: !isCustom ? id : 'CustomDamage', value: id, checked: isSelected, onChange: this.onChange, spacing: 1 }),
	          _react2.default.createElement(_text2.default, { size: 's', id: id, name: 'CustomDamage', value: item.CustomName || '', placeholder: (0, _helpers.translation)('227'), onChange: this.onChange })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.showPopupForParts !== true) return null;
	      if (window.carHandler.priceCalcType !== 30) return null;
	
	      var inputs = this.state.carPartItems;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        inputs.map(this.renderInputs),
	        _react2.default.createElement(_divider2.default, { size: 3, noLine: true }),
	        _react2.default.createElement(_button2.default, { onClick: this.submit, labelText: (0, _helpers.translation)('1208') })
	      );
	    }
	  }]);
	
	  return OtherDamageList;
	}(_react.Component);
	
	OtherDamageList.propTypes = {
	  close: _react2.default.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    price: state.price.price,
	    showPopupForParts: state.price.showPopupForParts,
	    selectedBodyPart: state.price.selectedBodyPart,
	    selectedBodyPartSide: state.price.selectedBodyPartSide,
	    carItems: state.price.carItems
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  showPopupParts: _price.showPopupParts,
	  setCarSelectedParts: _price.setCarSelectedParts
	})(OtherDamageList);

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _price = __webpack_require__(115);
	
	var _DeviationList = __webpack_require__(1016);
	
	var _DeviationList2 = _interopRequireDefault(_DeviationList);
	
	var _OtherDamageList = __webpack_require__(1019);
	
	var _OtherDamageList2 = _interopRequireDefault(_OtherDamageList);
	
	var _EstimationList = __webpack_require__(1017);
	
	var _EstimationList2 = _interopRequireDefault(_EstimationList);
	
	var _ExtentList = __webpack_require__(1018);
	
	var _ExtentList2 = _interopRequireDefault(_ExtentList);
	
	__webpack_require__(520);
	
	__webpack_require__(1495);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import styles
	
	
	// Elements
	// import Icon from '../../../elements/icon'
	
	
	// import { Icons } from '../../../elements/icons'
	
	var CarPopup = function (_Component) {
	  _inherits(CarPopup, _Component);
	
	  function CarPopup(props) {
	    _classCallCheck(this, CarPopup);
	
	    var _this = _possibleConstructorReturn(this, (CarPopup.__proto__ || Object.getPrototypeOf(CarPopup)).call(this, props));
	
	    _this.state = {
	      showPopupForParts: _this.props.showPopupForParts === true
	    };
	    _this.renderPopupContent = _this.renderPopupContent.bind(_this);
	    _this.renderInsuranceContent = _this.renderInsuranceContent.bind(_this);
	    _this.renderComplaintOrDeviation = _this.renderComplaintOrDeviation.bind(_this);
	    _this.renderNormalContent = _this.renderNormalContent.bind(_this);
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarPopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'reset',
	    value: function reset(props) {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.showPopupForParts !== this.state.showPopupForParts) {
	        this.setState({
	          showPopupForParts: nextProps.showPopupForParts
	        });
	      }
	    }
	  }, {
	    key: 'renderInsuranceContent',
	    value: function renderInsuranceContent() {
	      // if (Number(window.carHandler.priceCalcType) !== 1) return null
	      // if (window.carHandler.priceCalcType === 5 || window.carHandler.priceCalcType === 10) return null
	      // Insurance or estimation list content
	      return _react2.default.createElement(_EstimationList2.default, { close: this.close, show: this.state.showPopupForParts });
	    }
	  }, {
	    key: 'renderComplaintOrDeviation',
	    value: function renderComplaintOrDeviation() {
	      // if ((window.carHandler.priceCalcType !== 5 && window.carHandler.priceCalcType !== 10) return null
	      // Complaints & Deviation
	      return _react2.default.createElement(_DeviationList2.default, { close: this.close, show: this.state.showPopupForParts });
	    }
	  }, {
	    key: 'renderOtherDamage',
	    value: function renderOtherDamage() {
	      // if (window.carHandler.priceCalcType !== 30) return null
	      // Other Damages
	      return _react2.default.createElement(_OtherDamageList2.default, { close: this.close, show: this.state.showPopupForParts });
	    }
	  }, {
	    key: 'renderNormalContent',
	    value: function renderNormalContent() {
	      // let notPermitted = [1, 5, 10]
	      // if (notPermitted.includes(Number(window.carHandler.priceCalcType))) return null
	      // Normal price list extent
	      return _react2.default.createElement(_ExtentList2.default, { close: this.close, isPaint: this.props.isPaint, show: this.state.showPopupForParts });
	    }
	  }, {
	    key: 'renderPopupContent',
	    value: function renderPopupContent() {
	      var isInsurance = window.carHandler.priceCalcType === 1 && window.carHandler.priceCalcType !== 5 && window.carHandler.priceCalcType !== 10;
	      var isComplaintOrDeviation = window.carHandler.priceCalcType === 5 || window.carHandler.priceCalcType === 10;
	      var isOtherDamage = window.carHandler.priceCalcType === 30;
	      var isNormalContent = ![1, 5, 10, 30].includes(window.carHandler.priceCalcType);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'carPopup--content carForm' },
	        _react2.default.createElement(
	          'div',
	          { className: 'carSection fullWidth clearfixer' },
	          isInsurance && this.renderInsuranceContent(),
	          isComplaintOrDeviation && this.renderComplaintOrDeviation(),
	          isOtherDamage && this.renderOtherDamage(),
	          isNormalContent && this.renderNormalContent()
	        )
	      );
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.props.showPopupParts(false);
	      this.setState({
	        showPopupForParts: false
	      });
	      this.reset(this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.showPopupForParts !== true) return null;
	      // Render
	      var title = 'Part';
	      if (typeof window.carHandler.headers[this.props.selectedBodyPart] !== 'undefined') {
	        title = window.carHandler.headers[this.props.selectedBodyPart];
	      }
	      var baseClassName = 'carPopup carPopup1';
	      var notPermitted = [1, 5, 10];
	      var showBig = notPermitted.indexOf(Number(window.carHandler.priceCalcType)) > -1;
	      if (this.props.isPaint && !showBig) {
	        baseClassName += ' smaller';
	      }
	      if (this.props.isPaint && showBig) {
	        baseClassName += ' estimate';
	      }
	      var backdropClassname = 'carPopupBackdrop';
	      if (showBig && Number(window.carHandler.priceCalcType) !== 1) backdropClassname += ' estimate';
	      return _react2.default.createElement(
	        'div',
	        { className: 'carPopupWrapper1' },
	        _react2.default.createElement('div', { className: 'carPopupBackdrop1', onClick: this.close }),
	        _react2.default.createElement('div', { className: backdropClassname, onClick: this.close }),
	        _react2.default.createElement(
	          'div',
	          { className: baseClassName },
	          _react2.default.createElement(
	            'div',
	            { className: 'carPopup--title' },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [0], spacing: 0, alignChildren: 'center' },
	              title,
	              _react2.default.createElement(_closeButton2.default, { onClick: this.close })
	            )
	          ),
	          this.renderPopupContent()
	        )
	      );
	    }
	  }]);
	
	  return CarPopup;
	}(_react.Component);
	
	CarPopup.defaultProps = {
	  isPaint: false
	};
	CarPopup.propTypes = {
	  isPaint: _propTypes2.default.bool,
	  show: _propTypes2.default.bool.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    price: state.price.price,
	    order: state.orders.order,
	    showPopupForParts: state.price.showPopupForParts,
	    selectedBodyPart: state.price.selectedBodyPart
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  showPopupParts: _price.showPopupParts
	})(CarPopup);

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _price = __webpack_require__(115);
	
	var _car = __webpack_require__(222);
	
	__webpack_require__(520);
	
	var _CarPopup = __webpack_require__(1020);
	
	var _CarPopup2 = _interopRequireDefault(_CarPopup);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import styles
	
	
	// Utils
	
	
	var Car = function (_Component) {
	  _inherits(Car, _Component);
	
	  function Car(props) {
	    _classCallCheck(this, Car);
	
	    var _this = _possibleConstructorReturn(this, (Car.__proto__ || Object.getPrototypeOf(Car)).call(this, props));
	
	    _this.state = {
	      showPopup: false,
	      isBodyDepartment: props.order.OrderType !== 5 && props.order.OrderType !== 1 && (props.addon === 'bodyextent' || props.addon === 'bodyaddon') || props.order.OrderType === 1 && props.addon === 'bodyaddon' || props.order.OrderType === 5 && props.addon === 'bodyaddon'
	    };
	    _this.bodyClickEvent = _this.bodyClickEvent.bind(_this);
	    return _this;
	  }
	
	  _createClass(Car, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var priceChanged = !(0, _lodash.isEqual)(this.props.price, nextProps.price);
	      var activeStateChanged = this.props.isCarActive !== nextProps.isCarActive;
	      return priceChanged || !(0, _lodash.isEqual)(this.props.data, nextProps.data) || !(0, _lodash.isEqual)(this.props.price.CarSize, nextProps.price.CarSize) || activeStateChanged;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setCarInformation();
	      document.addEventListener('carhandler-body-click', this.bodyClickEvent);
	      var addon = this.props.addon;
	      var isBodyDepartment = this.props.order.OrderType !== 5 && this.props.order.OrderType !== 1 && (addon === 'bodyextent' || addon === 'bodyaddon') || this.props.order.OrderType === 1 && addon === 'bodyaddon' || this.props.order.OrderType === 5 && addon === 'bodyaddon';
	      // console.log('this.props.order.OrderType', this.props.order.OrderType, 'addon', addon, 'isBodyDepartment', isBodyDepartment)
	      this.setState({
	        isBodyDepartment: isBodyDepartment
	      }, function () {
	        // console.log('didmount, setorderdepartment', isBodyDepartment)
	      });
	      this.props.setCarActiveState(true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('carhandler-body-click', this.bodyClickEvent);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setCarInformation();
	    }
	  }, {
	    key: 'bodyClickEvent',
	    value: function bodyClickEvent(e) {
	      // if (this.props.addon === 'manualbody') {
	      //   window.toastr.error(translation('15198'), translation('216'))
	      //   return
	      // }
	
	      if (this.props.order.OrderType === 1 && this.props.addon !== '2' && this.props.addon !== 'bodyaddon' || this.props.addon === '3' || this.props.addon === '4' || this.props.price.UseEstimation) {
	        var hasPermission = false;
	        if (this.props.auth.departmentType === 1 && this.props.price.Department === 0 && this.props.auth.hasPartner) {
	          hasPermission = (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 30);
	        } else {
	          hasPermission = (0, _auth.hasSubscriptionPermission)(this.props.auth, 30);
	        }
	
	        if (!hasPermission) {
	          window.toastr.error((0, _helpers.translation)('2087'), (0, _helpers.translation)('216'));
	          return;
	        }
	      }
	      var taskSide = 0;
	      if (e.detail.partType.indexOf('hojre') > -1) taskSide = 2;
	      if (e.detail.partType.indexOf('venstre') > -1) taskSide = 1;
	      console.log(e.detail);
	      // let parts = this.props.carParts
	      // parts = parts.filter(filterCarParts)[0]
	      this.props.showPopupParts(true, e.detail.partType, taskSide);
	      // if (this.state.isBodyDepartment) {
	      //   if (parts.BodyTasks.length > 0) {
	      //     this.props.showPopupParts(true, e.detail.partType, taskSide)
	      //   } else {
	      //     window.toastr.error(translation('14855'), translation('216'))
	      //   }
	      // } else {
	      //   console.log('bodyclick parts', parts)
	      //   if (parts.Tasks.length > 0) {
	      //     this.props.showPopupParts(true, e.detail.partType, taskSide)
	      //   } else {
	      //     window.toastr.error(translation('13426'), translation('216'))
	      //   }
	      // }
	    }
	  }, {
	    key: 'makeCarData',
	    value: function makeCarData(parts) {
	      var finalArray = [];
	      parts.map(function (val, index) {
	        finalArray[val.Mapping] = [];
	        val.Tasks.map(function (task, idx) {
	          finalArray[val.Mapping].push(task);
	        });
	      });
	      return finalArray;
	    }
	  }, {
	    key: 'makeSelectedParts',
	    value: function makeSelectedParts(parts) {
	      if (typeof parts === 'undefined') {
	        return [];
	      }
	
	      var makePartName = function makePartName(taskSide, mappingName, id) {
	        var side = '';
	        var sideExtra = '';
	        switch (taskSide) {
	          case 1:
	            side = 'venstre-';
	            break;
	          case 2:
	            side = 'hojre-';
	            break;
	          case 5:
	            side = 'venstre-';
	            sideExtra = '-for';
	            break;
	          case 6:
	            side = 'hojre-';
	            sideExtra = '-for';
	            break;
	          case 7:
	            side = 'venstre-';
	            sideExtra = '-bag';
	            break;
	          case 8:
	            side = 'hojre-';
	            sideExtra = '-bag';
	            break;
	        }
	        return side + '' + mappingName + sideExtra + '_' + id;
	      };
	
	      var finalData = [];
	
	      if (this.props.addon === '5' || this.props.addon === '6') {
	        parts.map(function (val, index) {
	          val.DeviationReasons.map(function (v, i) {
	            // console.log('val', val)
	            // let side = ''
	            // if (v.TaskSide === 1) {
	            //   side = 'venstre-'
	            // } else if (v.TaskSide === 2) {
	            //   side = 'hojre-'
	            // }
	            // let name = side + '' + val.Part.MappingName + '_' + v.DeviationType.Id
	
	            var name = makePartName(v.TaskSide, val.Part.MappingName, v.DeviationType.Id);
	
	            // let name = makePartName(v.TaskSide, val.Part.MappingName, v.DeviationType.Id)
	            finalData.push({
	              name: name
	            });
	          });
	          val.CustomDeviationReasons.map(function (v, i) {
	            // console.log('val', val)
	            // let side = ''
	            // if (v.TaskSide === 1) {
	            //   side = 'venstre-'
	            // } else if (v.TaskSide === 2) {
	            //   side = 'hojre-'
	            // }
	            // let name = side + '' + val.Part.MappingName + '_' + v.DeviationType.Id
	
	            var name = makePartName(v.TaskSide, val.Part.MappingName, v.CustomDeviationReasonId);
	
	            // let name = makePartName(v.TaskSide, val.Part.MappingName, v.DeviationType.Id)
	            finalData.push({
	              name: name
	            });
	          });
	        });
	      } else if (this.props.addon === '7') {
	        var validOtherDamage = this.props.price.OtherDamages.find(function (od) {
	          return !od.Active;
	        });
	        parts.map(function (val) {
	          val.OtherDamages.map(function (v) {
	            if (validOtherDamage && v.OtherDamageId === validOtherDamage.Id) {
	              var name = makePartName(v.TaskSide, val.Part.MappingName, v.Type + '-' + v.Id);
	
	              finalData.push({
	                name: name
	              });
	            }
	          });
	        });
	      } else if (this.props.order.OrderType === 1 && this.props.addon !== '2' && this.props.addon !== 'bodyaddon' || this.props.addon === '3' || this.props.addon === '4' || this.props.price.UseEstimation) {
	        // console.log('ordertype', this.props.order.OrderType, 'addon', this.props.addon, 'price.UseEstimation', this.props.price.UseEstimation)
	        parts.map(function (val, index) {
	          val.EstimationTasks.map(function (v, i) {
	            /*
	            let side = ''
	            if (v.TaskSide === 1) {
	              side = 'venstre-'
	            } else if (v.TaskSide === 2) {
	              side = 'hojre-'
	            }
	            */
	            // let name = side + '' + val.Part.MappingName + '_task_' + v.EstimationTaskId
	            // let name = side + '' + val.Part.MappingName + '_' + v.EstimationTaskId
	            var name = makePartName(v.TaskSide, val.Part.MappingName, v.EstimationTaskId);
	            finalData.push({
	              name: name
	            });
	          });
	        });
	      } else if (this.props.order.OrderType === 5 && this.props.addon !== '2' && this.props.addon !== 'bodyaddon') {
	        parts.map(function (val, index) {
	          val.Complaints.map(function (v, i) {
	            /*
	            let side = ''
	            if (v.TaskSide === 1) {
	              side = 'venstre-'
	            } else if (v.TaskSide === 2) {
	              side = 'hojre-'
	            }
	            let name = side + '' + val.Part.MappingName + '_' + v.ComplaintType
	            */
	            var name = makePartName(v.TaskSide, val.Part.MappingName, v.ComplaintType);
	            finalData.push({
	              name: name
	            });
	          });
	        });
	      } else {
	        parts.map(function (val, index) {
	          val.Tasks.map(function (v, i) {
	            if (val.Part.PartItemId === 0) {
	              return false;
	            }
	            // if (v.TaskSide === 1) {
	            //   side = 'venstre-'
	            // } else if (v.TaskSide === 2) {
	            //   side = 'hojre-'
	            // }
	            var taskId = v.TaskPriceId !== 0 ? v.TaskPriceId : '900000000000000000000';
	            var name = makePartName(v.TaskSide, val.Part.MappingName, taskId); // side + '' + val.Part.MappingName + sideExtra + '_' + taskId
	            if (v.TaskPriceId === 0) {
	              finalData.push({
	                name: name,
	                value: v.TaskName
	              });
	            } else {
	              finalData.push({
	                name: name
	              });
	            }
	          });
	        });
	      }
	      return finalData;
	    }
	  }, {
	    key: 'makeInsuranceItems',
	    value: function makeInsuranceItems(parts) {
	      var finalArray = [];
	      var finalExtra = [];
	      parts.map(function (val, index) {
	        finalArray[val.Mapping] = [];
	        finalExtra[val.Mapping] = [];
	        val.EstimationTasks.map(function (task, idx) {
	          finalArray[val.Mapping].push(task);
	        });
	        val.EstimationExtra.map(function (extra, idx) {
	          finalExtra[val.Mapping].push(extra);
	        });
	      });
	      return {
	        tasks: finalArray,
	        extra: finalExtra
	      };
	    }
	  }, {
	    key: 'makeComplaintItems',
	    value: function makeComplaintItems(complaints) {
	      var finalArray = [];
	      complaints.map(function (val, index) {
	        finalArray.push({
	          name: (0, _helpers.translation)(val.DictionaryKey),
	          EnumValue: val.EnumValue
	        });
	      });
	      return finalArray;
	    }
	  }, {
	    key: 'makeDeviationItems',
	    value: function makeDeviationItems(reasons) {
	      var finalArray = [];
	      Object.keys(reasons).map(function (val, key) {
	        finalArray.push({
	          name: (0, _helpers.translation)(reasons[val]),
	          EnumValue: val
	        });
	      });
	      return finalArray;
	    }
	  }, {
	    key: 'makeOtherDamageItems',
	    value: function makeOtherDamageItems(otherDamages) {
	      return otherDamages.map(function (val) {
	        return {
	          name: (0, _helpers.translation)(val.DictionaryKey),
	          EnumValue: val.EnumValue
	        };
	      });
	    }
	  }, {
	    key: 'setCarInformation',
	    value: function setCarInformation() {
	      if (Object.keys(this.props.price).length === 0) return null;
	      // Return false?
	      if (this.props.order.OrderType === 5) {
	        if (this.props.data.complaints === 0 || typeof this.props.data.complaints === 'undefined') return null;
	      } else {
	        if (this.props.data.parts === 0 || typeof this.props.data.parts === 'undefined') return null;
	      }
	
	      var carItems = [];
	      var addon = this.props.addon;
	      // Get car size
	      var size = 'small';
	      if (this.props.price.CarSize === 2) {
	        size = 'medium';
	      } else if (this.props.price.CarSize === 3) {
	        size = 'large';
	      }
	
	      var orderType = this.props.order.OrderType;
	      var realOrderType = orderType;
	      if ((addon === '2' || addon === 'bodyaddon') && orderType === 1) {
	        orderType = 3;
	      }
	
	      if (addon === '3' || this.props.afterEvaluation) {
	        orderType = 1;
	      }
	
	      if (this.props.price.UseEstimation) {
	        orderType = 1;
	      }
	
	      if (addon === '5' || addon === '6' || this.props.order.OrderType === 5 && addon === 'bodyextent') {
	        orderType = 10;
	      }
	
	      if (orderType === 5 && (addon === '2' || addon === 'bodyaddon')) {
	        orderType = 100;
	      }
	
	      if (addon === 'manual_body') {
	        orderType = 20;
	      }
	
	      if (addon === '7') {
	        orderType = 30;
	      }
	
	      window.carHandler.setPriceCalcType(orderType);
	      // console.log('setCarInformation', orderType, this.props.data)
	      switch (orderType) {
	        case 1:
	          carItems = this.makeInsuranceItems(this.props.data.parts);
	          carItems.extents = this.props.data.extents;
	          window.carInnerItems = carItems;
	          break;
	        case 5:
	          carItems = this.makeComplaintItems(this.props.data.complaints);
	          window.carInnerItems = carItems;
	          break;
	        case 10:
	          carItems = this.makeDeviationItems(this.props.data.reasons);
	          // console.log('carItems', carItems)
	          window.carInnerItems = carItems;
	          break;
	        case 20:
	          carItems = null;
	          break;
	        case 30:
	          carItems = this.makeOtherDamageItems(this.props.data.otherDamages);
	          window.carInnerItems = carItems;
	          break;
	        default:
	          carItems = this.makeCarData(this.props.data.parts);
	          window.carInnerItems = carItems;
	          break;
	      }
	      this.props.setCarItems(carItems);
	
	      window.carHandler.init(size, true);
	
	      window.carHandler.t = _helpers.translation;
	      window.carHandler.realOrderType = realOrderType;
	      window.carHandler.department = this.state.isBodyDepartment === true ? 1 : 0;
	      // console.log(this.props.order.OrderType, isBodyDepartment === true, window.carHandler.department)
	
	      if (!this.props.order.IsDraft && !this.props.afterEvaluation) {
	        window.carHandler.setLocked(true);
	      } else {
	        window.carHandler.setLocked(false);
	      }
	
	      // Shop, unlock car
	      if ((this.props.auth.user.UserType === 3 || this.props.auth.user.UserType === 5 || this.props.auth.user.UserType === 6 || this.props.auth.user.UserType === 7) && this.props.price.HasAwaiting === false) {
	        window.carHandler.setLocked(false);
	      }
	
	      // Lock if after/evaluation
	      window.carHandler.setEvaluation(false);
	      if (this.props.afterEvaluation || this.props.evaluation) {
	        if (this.props.price.ApprovalShop !== 0 && this.props.price.ApprovalShop !== 1) {
	          window.carHandler.setLocked(true);
	          window.carHandler.setEvaluation(true);
	        }
	      }
	
	      if (this.props.price.UseEstimation && !this.props.price.IsAfterEvaluation && !this.props.price.IsEvaluation) {
	        window.carHandler.setLocked(false);
	      }
	      // Fill parts
	      // console.log('this.props.price.Parts', this.props.price.Parts)
	      window.carHandler.selectedParts = this.makeSelectedParts(this.props.price.Parts);
	      // console.log('selectedParts', window.carHandler.selectedParts, this.props.price.Parts)
	      window.carHandler.fillParts(true);
	      // Make header titles
	      var headers = {};
	      this.props.data.parts.map(function (part, index) {
	        headers[part.Mapping] = (0, _helpers.translation)(part.DictionaryKey);
	      });
	      window.carHandler.headers = headers;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var disabled = false;
	      if (this.props.addon === 'manualbody') {
	        disabled = true;
	      }
	
	      if (Object.keys(this.props.price).length === 0) return null;
	      // Is car size set?
	      if (this.props.price.CarSize === 0) return null;
	      // Return false?
	      if (this.props.order.OrderType === 5) {
	        if (this.props.data.complaints === 0 || typeof this.props.data.complaints === 'undefined') return null;
	      } else {
	        if (this.props.data.parts === 0 || typeof this.props.data.parts === 'undefined') return null;
	      }
	
	      var classes = 'car_container';
	      var onDisabledClick = null;
	      var forsiEnable = this.props.auth.permissions.ChainAssessmentSystem === 1; // Forsi is available for the company
	      var translationKey = forsiEnable ? '15198' : '18042';
	      if (!this.props.isCarActive || disabled) {
	        classes += ' car_container_disabled';
	        onDisabledClick = function onDisabledClick() {
	          window.toastr.error((0, _helpers.translation)(translationKey), (0, _helpers.translation)('216'));
	        };
	      }
	
	      // Render
	      return _react2.default.createElement(
	        'div',
	        { className: classes, onClick: onDisabledClick },
	        _react2.default.createElement('div', { id: 'wsp_damage_svg_cont' }),
	        !disabled && _react2.default.createElement(_CarPopup2.default, { show: this.props.showPopupForParts, isPaint: !this.state.isBodyDepartment, addon: this.props.addon })
	      );
	    }
	  }]);
	
	  return Car;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    price: state.price.price,
	    order: state.orders.order,
	    carParts: state.price.carParts,
	    showPopupForParts: state.price.showPopupForParts,
	    isCarActive: state.car.isActive
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  showPopupParts: _price.showPopupParts,
	  setCarItems: _price.setCarItems,
	  setCarActiveState: _car.setCarActiveState
	})(Car);

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _auth = __webpack_require__(8);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactDOM from 'react-dom'
	// import { GetDataWarehouse } from '../../../actions/shops'
	
	
	var REPORT_URLS = ['GetShop', 'GetChain'];
	
	var DWHouse = function (_Component) {
	  _inherits(DWHouse, _Component);
	
	  function DWHouse() {
	    _classCallCheck(this, DWHouse);
	
	    return _possibleConstructorReturn(this, (DWHouse.__proto__ || Object.getPrototypeOf(DWHouse)).apply(this, arguments));
	  }
	
	  _createClass(DWHouse, [{
	    key: 'render',
	
	    // Implementation notes:
	    // -  Doesn't work correctly when getting from api and setting content in iframe (powerbi scripts doesn't initialize)
	    // -  Have to let iframe get content through src, which means we can not include the additional headers we send with all other API calls (such as authentication token)
	    //    For that reason, the auth token is included as url parameter and must also be handled on the API side.
	
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30, 10)) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'dw-house' },
	        _react2.default.createElement('iframe', { src: _constants.API_BASE + '/DataWarehouse/' + REPORT_URLS[this.props.reportType] + '?authToken=' + encodeURIComponent(this.props.auth.user.Token) })
	      );
	    }
	  }]);
	
	  return DWHouse;
	}(_react.Component);
	
	DWHouse.defaultProps = {
	  reportType: 0
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  // GetDataWarehouse
	})(DWHouse);

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// elements
	
	
	// Utils
	
	
	var DateTimePeriod = function (_Component) {
	  _inherits(DateTimePeriod, _Component);
	
	  function DateTimePeriod(props) {
	    _classCallCheck(this, DateTimePeriod);
	
	    var _this = _possibleConstructorReturn(this, (DateTimePeriod.__proto__ || Object.getPrototypeOf(DateTimePeriod)).call(this, props));
	
	    _this.state = {
	      dateFrom: null,
	      dateTo: null,
	      dateFrom_hour: null,
	      dateTo_hour: null
	    };
	
	    _this.makeTime = _this.makeTime.bind(_this);
	    _this.onDateChange = _this.onDateChange.bind(_this);
	    _this.onTimeChange = _this.onTimeChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateTimePeriod, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        dateFrom: (0, _moment2.default)(this.props.dateFrom),
	        dateTo: (0, _moment2.default)(this.props.dateTo),
	        dateFrom_hour: this.makeTime(this.props.dateFrom),
	        dateTo_hour: this.makeTime(this.props.dateTo)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.dateFrom !== this.props.dateFrom || (0, _moment2.default)(nextProps.dateFrom) !== this.state.dateFrom) {
	        this.setState({
	          dateFrom: (0, _moment2.default)(nextProps.dateFrom),
	          dateFrom_hour: this.makeTime(nextProps.dateFrom)
	        });
	      }
	    }
	  }, {
	    key: 'makeTime',
	    value: function makeTime(date) {
	      var time = (0, _moment2.default)(date).format('HH:mm');
	      return time;
	    }
	  }, {
	    key: 'onDateChange',
	    value: function onDateChange(name, date) {
	      var _setState,
	          _this2 = this;
	
	      // Set date and reset time
	      var timeName = name + '_hour';
	      // let newDateTime = moment(date).hour(0).minute(0)
	      this.setState((_setState = {}, _defineProperty(_setState, name, date), _defineProperty(_setState, timeName, '-'), _setState), function () {
	        console.log('onDateChange', name, timeName, _this2.state);
	      });
	      // this.props.onChangePeriod(`${this.props.name}_${name}`, newDateTime)
	      if (this.props.onChangeDate) this.props.onChangeDate(name, date);
	    }
	  }, {
	    key: 'onTimeChange',
	    value: function onTimeChange(e) {
	      var previousTime = this.state[e.target.name];
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	      // from/to
	      var dateTimeSet = e.target.name.indexOf('From') > -1 ? 'from' : 'to';
	
	      // Combine selected date and time and send to handler.
	      var date = this.state[e.target.name.split('_')[0]];
	      var hours = e.target.value.split(':')[0];
	      var minutes = e.target.value.split(':')[1];
	      var combined = (0, _moment2.default)(date).hours(parseInt(hours)).minutes(parseInt(minutes));
	
	      var dateTimeSetName = this.props.name + '_' + dateTimeSet;
	      if (this.props.onValidation(dateTimeSetName, combined)) {
	        // console.log('onTimeChange', dateTimeSetName, combined.format('YYYY-MM-DD HH:mm'))
	        this.props.onChangePeriod(dateTimeSetName, combined);
	      } else {
	        this.setState(_defineProperty({}, e.target.name, previousTime));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // let dateFrom = moment(this.props.dateFrom)
	      // let dateTo = moment(this.props.dateTo)
	      // let timeFromString = this.state. this.makeTime(this.props.dateFrom)
	      // let timeToString = this.makeTime(this.props.dateTo)
	
	      var mapTimes = function mapTimes(val, index) {
	        return _react2.default.createElement(
	          'option',
	          { key: index, value: val },
	          val
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'datetime-period' },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('16771') },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [2, 1] },
	            _react2.default.createElement(_datetime2.default, {
	              closeOnSelect: true,
	              timeFormat: false,
	              value: this.state.dateFrom,
	              isValidDate: this.props.onlyValidAfterCurrentDate ? function (x) {
	                return new Date(x) >= new Date().setHours(0, 0, 0, 0);
	              } : undefined,
	              inputProps: {
	                name: 'dateFrom',
	                disabled: this.props.disabled
	              },
	              onChange: this.onDateChange.bind(this, 'dateFrom')
	            }),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'dateFrom_hour', value: this.state.dateFrom_hour, disabled: this.props.disabled, onChange: this.onTimeChange },
	              _react2.default.createElement('option', { key: -1, value: '-', label: (0, _helpers.translation)(16821), disabled: true }),
	              this.props.timesFrom.map(mapTimes),
	              this.props.disabled && [this.state.dateFrom_hour].map(mapTimes)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('16772') },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [2, 1] },
	            _react2.default.createElement(_datetime2.default, {
	              closeOnSelect: true,
	              timeFormat: false,
	              value: this.state.dateTo,
	              isValidDate: this.props.onlyValidAfterCurrentDate ? function (x) {
	                return new Date(x) >= new Date().setHours(0, 0, 0, 0);
	              } : undefined,
	              inputProps: {
	                name: 'dateTo',
	                disabled: this.props.disabled
	              },
	              onChange: this.onDateChange.bind(this, 'dateTo')
	            }),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'dateTo_hour', value: this.state.dateTo_hour, disabled: this.props.disabled, onChange: this.onTimeChange },
	              _react2.default.createElement('option', { key: -1, value: '-', label: (0, _helpers.translation)(16821), disabled: true }),
	              !this.props.disabled && this.props.timesTo.map(mapTimes),
	              this.props.disabled && [this.state.dateTo_hour].map(mapTimes)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DateTimePeriod;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {};
	}
	
	DateTimePeriod.defaultProps = {
	  name: 'dateTimePeriod',
	  onValidation: function onValidation(dateTime) {
	    return true;
	  },
	  onlyValidAfterCurrentDate: false
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(DateTimePeriod);

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _customers = __webpack_require__(74);
	
	__webpack_require__(1503);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	// Styles
	
	
	// Utils
	
	
	// Elements
	
	
	var DealerSettings = function (_Component) {
	  _inherits(DealerSettings, _Component);
	
	  function DealerSettings(props) {
	    _classCallCheck(this, DealerSettings);
	
	    var _this = _possibleConstructorReturn(this, (DealerSettings.__proto__ || Object.getPrototypeOf(DealerSettings)).call(this, props));
	
	    _this.state = {
	      CustomerId: 0,
	      EvaluationRequired: undefined,
	      WPPriceApprovalRequired: undefined,
	      WPAddonApprovalRequired: undefined,
	      AddonSaleSeparate: undefined,
	      TransferMaterialSalaryTotal: false,
	      WPShowReferredTo: undefined,
	      canChange: false
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(DealerSettings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomer(this.props);
	    }
	  }, {
	    key: 'getCustomer',
	    value: function getCustomer(props) {
	      var _this2 = this;
	
	      this.setState({
	        CustomerId: 0,
	        EvaluationRequired: undefined,
	        WPPriceApprovalRequired: undefined,
	        WPAddonApprovalRequired: undefined,
	        AddonSaleSeparate: undefined,
	        TransferMaterialSalaryTotal: false,
	        WPShowReferredTo: undefined,
	        canChange: false // Block change while loading
	      }, function () {
	        if (props.CustomerId !== undefined) {
	          var customerId = props.CustomerId;
	          props.getCustomerSettings(customerId).then(function (res) {
	            console.log('props after get', props);
	            _this2.setState({
	              CustomerId: res.data.CustomerId,
	              EvaluationRequired: res.data.EvaluationRequired,
	              WPPriceApprovalRequired: res.data.WPPriceApprovalRequired,
	              WPAddonApprovalRequired: res.data.WPAddonApprovalRequired,
	              AddonSaleSeparate: res.data.AddonSaleSeparate,
	              TransferMaterialSalaryTotal: res.data.TransferMaterialSalaryTotal,
	              WPShowReferredTo: res.data.WPShowReferredTo,
	              canChange: true
	            });
	          }, function (err) {
	            console.log(err);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.CustomerId !== nextProps.CustomerId) {
	        this.getCustomer(nextProps);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this3 = this;
	
	      e.persist();
	      var value = e.target.value;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	      }
	
	      this.setState(_defineProperty({}, e.target.name, value), function () {
	        if (e.target.type === 'checkbox') {
	          _this3.onBlur(e);
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this4 = this;
	
	      this.setState({
	        canChange: false // Block change while loading
	      }, function () {
	        if (_this4.state.CustomerId > 0) {
	          var data = {
	            CustomerId: _this4.state.CustomerId,
	            EvaluationRequired: _this4.state.EvaluationRequired,
	            WPPriceApprovalRequired: _this4.state.WPPriceApprovalRequired,
	            WPAddonApprovalRequired: _this4.state.WPAddonApprovalRequired,
	            AddonSaleSeparate: _this4.state.AddonSaleSeparate,
	            TransferMaterialSalaryTotal: _this4.state.TransferMaterialSalaryTotal,
	            WPShowReferredTo: _this4.state.WPShowReferredTo
	          };
	          _this4.props.updateCustomerSettings(data).then(function (res) {
	            var dat = res.data;
	            _this4.setState({
	              CustomerId: dat.CustomerId,
	              EvaluationRequired: dat.EvaluationRequired,
	              WPPriceApprovalRequired: dat.WPPriceApprovalRequired,
	              WPAddonApprovalRequired: dat.WPAddonApprovalRequired,
	              AddonSaleSeparate: dat.AddonSaleSeparate,
	              TransferMaterialSalaryTotal: dat.TransferMaterialSalaryTotal,
	              WPShowReferredTo: dat.WPShowReferredTo,
	              canChange: true
	            });
	
	            // window.toastr.success(translation('14746'), translation('13424'))
	          }, function (err) {
	            // Toastr
	            if (err.response !== undefined && err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
	              var errors = err.response.data.Errors;
	              var errText = '';
	              for (var i = 0; i < errors.length; i++) {
	                var dictKey = errors[i].DictionaryKey;
	                errText += '<br/>' + (0, _helpers.translation)(dictKey);
	              }
	              window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	            } else {
	              window.toastr.error((0, _helpers.translation)('13465'), (0, _helpers.translation)('216'));
	            }
	            _this4.getCustomer(_this4.props);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('6') },
	        _react2.default.createElement(_switch2.default, { onChange: this.onChange, name: 'EvaluationRequired', checked: this.state.EvaluationRequired, labelText: (0, _helpers.translation)('14729'), disabled: !this.state.canChange }),
	        _react2.default.createElement(_switch2.default, { onChange: this.onChange, name: 'WPPriceApprovalRequired', checked: this.state.WPPriceApprovalRequired, labelText: (0, _helpers.translation)('2044'), disabled: !this.state.canChange }),
	        _react2.default.createElement(_switch2.default, { onChange: this.onChange, name: 'WPAddonApprovalRequired', checked: this.state.WPAddonApprovalRequired, labelText: (0, _helpers.translation)(16824), disabled: !this.state.canChange }),
	        _react2.default.createElement(_switch2.default, { onChange: this.onChange, name: 'AddonSaleSeparate', checked: this.state.AddonSaleSeparate, labelText: (0, _helpers.translation)('2092'), disabled: !this.state.canChange }),
	        _react2.default.createElement(_switch2.default, { onChange: this.onChange, name: 'TransferMaterialSalaryTotal', checked: this.state.TransferMaterialSalaryTotal, labelText: (0, _helpers.translation)('14943'), disabled: !this.state.canChange }),
	        _react2.default.createElement(_switch2.default, { onChange: this.onChange, name: 'WPShowReferredTo', checked: this.state.WPShowReferredTo, labelText: (0, _helpers.translation)('14931'), helpText: (0, _helpers.translation)('14933'), disabled: !this.state.canChange })
	      );
	    }
	  }]);
	
	  return DealerSettings;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateCustomerSettings: _customers.updateCustomerSettings,
	  getCustomerSettings: _customers.getCustomerSettings
	})(DealerSettings);

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dracar = __webpack_require__(224);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _backdrop = __webpack_require__(29);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _DracarModal = __webpack_require__(1084);
	
	var _DracarModal2 = _interopRequireDefault(_DracarModal);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _StatusBox = __webpack_require__(298);
	
	var _StatusBox2 = _interopRequireDefault(_StatusBox);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Functions
	
	
	// Elements
	
	
	var Dracar = function (_Component) {
	  _inherits(Dracar, _Component);
	
	  function Dracar(props) {
	    _classCallCheck(this, Dracar);
	
	    var _this = _possibleConstructorReturn(this, (Dracar.__proto__ || Object.getPrototypeOf(Dracar)).call(this, props));
	
	    _this.state = {
	      orderNumber: _this.props.order ? _this.props.order.DracarRepairOrderId ? _this.props.order.DracarRepairOrderId : '' : '',
	      tempOrderNumber: '',
	      state: 0,
	      dracarAllowed: false,
	      isSet: _this.props.order ? _this.props.order.DracarRepairOrderSet : false,
	
	      showDracarModal: false,
	      showSpinner: false
	    };
	
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.getContent = _this.getContent.bind(_this);
	    _this.getOption = _this.getOption.bind(_this);
	    _this.useExistingOrder = _this.useExistingOrder.bind(_this);
	    _this.handleCreateRepairOrder = _this.handleCreateRepairOrder.bind(_this);
	    _this.getKeyLoopSystemName = _this.getKeyLoopSystemName.bind(_this);
	    _this.getRepairOrderAlias = _this.getRepairOrderAlias.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dracar, [{
	    key: 'toggleModal',
	    value: function toggleModal(e) {
	      var _this2 = this;
	
	      var value = !this.state.showDracarModal;
	      this.setState({ showDracarModal: value }, function () {
	        _this2.props.triggerPopup(value);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'handleCreateRepairOrder',
	    value: function handleCreateRepairOrder(data) {
	      var _this3 = this;
	
	      this.setState({
	        orderNumber: data.RepairOrder,
	        isSet: data.IsSet
	      }, function () {
	        _this3.toggleModal();
	        if (data.IsCreated) {
	          // window.toastr.success(translation('16632').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()).replace('[RepairOrderAlias]', this.getRepairOrderAlias()), translation('13424'))
	        } else {
	            // window.toastr.success(translation('16819').replace('[RepairOrderAlias]', this.getRepairOrderAlias()), translation('13424'))
	          }
	      });
	    }
	  }, {
	    key: 'getKeyLoopSystemName',
	    value: function getKeyLoopSystemName() {
	      switch (this.props.auth.accountingSystem) {
	        case 4:
	          return (0, _helpers.translation)(15352);
	        case 6:
	          return (0, _helpers.translation)(18138);
	      }
	      return '';
	    }
	  }, {
	    key: 'getRepairOrderAlias',
	    value: function getRepairOrderAlias() {
	      switch (this.props.auth.accountingSystem) {
	        case 4:
	          return (0, _helpers.translation)(18149);
	        case 6:
	          return (0, _helpers.translation)(18150);
	      }
	      return '';
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      var _state = this.state,
	          isSet = _state.isSet,
	          orderNumber = _state.orderNumber;
	
	      // const setChoice = (e) => {
	      //   this.setState({
	      //     state: e.target.value
	      //   })
	      // }
	
	      var dracarIcon = isSet ? _icons.SparePartModuleIcons.OK : _icons.SparePartModuleIcons.Attention;
	      var dracarText = isSet ? (0, _helpers.translation)(16633).replace('[RepairOrderAlias]', this.getRepairOrderAlias()) + ': ' + orderNumber : (0, _helpers.translation)(16609).replace('[KeyLoopSystem]', this.getKeyLoopSystemName());
	      var statusColor = isSet ? 'green' : 'orange';
	
	      var action = void 0;
	      if ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 2) && !isSet) {
	        action = this.toggleModal;
	      }
	      return _react2.default.createElement(_StatusBox2.default, {
	        onClick: !isSet ? action : null,
	        icon: dracarIcon,
	        color: statusColor,
	        title: this.getKeyLoopSystemName(),
	        subTitle: dracarText,
	        chevron: this.state.showDracarModal
	      });
	    }
	  }, {
	    key: 'useExistingOrder',
	    value: function useExistingOrder(e) {
	      var _this4 = this;
	
	      var data = { ExistingRepairOrderId: this.state.tempOrderNumber, OrderId: this.props.order.Id };
	      this.props.useDracarRepairOrder(data).then(function (res) {
	        _this4.setState({ orderNumber: res.data.RepairOrder, isSet: res.data.IsSet });
	      }).catch(function (err) {
	        return console.err(err);
	      });
	    }
	  }, {
	    key: 'getOption',
	    value: function getOption(val) {
	      if (val === '1') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(_button2.default, { size: 'l', onClick: this.toggleModal, labelText: (0, _helpers.translation)('27') })
	        );
	      } else if (val === '2') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('16422') },
	            _react2.default.createElement(_text2.default, { id: 'DracarUserRepairOrderInput', name: 'tempOrderNumber', value: this.state.tempOrderNumber, onChange: this.onChange })
	          ),
	          _react2.default.createElement(_button2.default, { size: 'l', onClick: this.useExistingOrder, labelText: (0, _helpers.translation)('1218') })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderSetOrder',
	    value: function renderSetOrder() {
	      if (this.state.showSpinner) {
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: ['min-content', 1, 'max-content'], align: 'center' },
	          _react2.default.createElement('div', { className: 'divider', key: '1' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice', key: '2' },
	            _react2.default.createElement(
	              'span',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.getContent()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasAccess)([3, 5, 6, 7], this.props.auth.user.UserType)) return null;
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      // if (this.props.auth.accountingSystem !== 4) return null
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.hasHeader && _react2.default.createElement(_panelHeader2.default, { text: '' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'white__box invoice_wrapper' },
	          this.renderSetOrder()
	        ),
	        this.state.showDracarModal && _react2.default.createElement(_DracarModal2.default, {
	          show: this.state.showDracarModal,
	          onClose: this.toggleModal,
	          onSuccess: this.handleCreateRepairOrder,
	          order: this.props.order,
	          handleToggle: this.toggleModal
	        })
	      );
	    }
	  }]);
	
	  return Dracar;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  useDracarRepairOrder: _dracar.useDracarRepairOrder
	})(Dracar);

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	/*eslint-disable */
	'use strict';
	
	var cache = {};
	var start = '(?:^|\\s)';
	var end = '(?:\\s|$)';
	
	function lookupClass(className) {
	  var cached = cache[className];
	  if (cached) {
	    cached.lastIndex = 0;
	  } else {
	    cache[className] = cached = new RegExp(start + className + end, 'g');
	  }
	  return cached;
	}
	
	function addClass(el, className) {
	  var current = el.className;
	  if (!current.length) {
	    el.className = className;
	  } else if (!lookupClass(className).test(current)) {
	    el.className += ' ' + className;
	  }
	}
	
	function rmClass(el, className) {
	  el.className = el.className.replace(lookupClass(className), ' ').trim();
	}
	
	module.exports = {
	  add: addClass,
	  rm: rmClass
	};
	/*eslint-enable */

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1507);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Styles
	
	
	var DummyExtent = function (_Component) {
	  _inherits(DummyExtent, _Component);
	
	  function DummyExtent(props) {
	    _classCallCheck(this, DummyExtent);
	
	    var _this = _possibleConstructorReturn(this, (DummyExtent.__proto__ || Object.getPrototypeOf(DummyExtent)).call(this, props));
	
	    _this.state = {
	      item: props.item,
	      showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1'
	    };
	    return _this;
	  }
	
	  _createClass(DummyExtent, [{
	    key: 'renderForsiReport',
	    value: function renderForsiReport() {
	      var DummyForsiReports = this.state.item.DummyForsiReports;
	
	      if (DummyForsiReports === null) return null;
	      var renderDummyForsi = function renderDummyForsi(item, key) {
	        var hasPaint = item.PaintHours > 0;
	        var hasBodywork = item.BodyHours > 0;
	
	        // 13535 'Timekorrektion @'
	        // 13536 'Tillæg @'
	        // 13537 'Plade timepris @'
	        // 13538 'Plade materialepris @'
	        // 13539 'Plade arbejdspris @'
	        // 13540 'Plade arbejdstimer @'
	        // 13541 'Lak timepris @'
	        // 13542 'Lak materialepris @'
	        // 13543 'Lak arbejdspris @'
	        // 13544 'Lak arbejdstimer @'
	        // 13545 'Plade ordre rabat @'
	        // 13546 'Manuelt pladeomfang'
	        // 13547 'Manuelt lakomfang'
	        // 13548 'Lak ordre'
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            'div',
	            null,
	            hasBodywork && _react2.default.createElement(
	              'div',
	              { className: 'extent_dummy' },
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix title' },
	                (0, _helpers.translation)('781')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13540')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.BodyHours)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13537')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.BodyHourPrice)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13538')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.BodyMaterialsPrice)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13539')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.BodyWorkPrice)
	                )
	              ),
	              item.BodyCorrectionPrice !== 0 && _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)(item.BodyCorrectionText)
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.BodyCorrectionPrice)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13353')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.BodyTotalAfterCorrection)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                '\xA0'
	              )
	            ),
	            hasPaint && _react2.default.createElement(
	              'div',
	              { className: 'extent_dummy' },
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix title' },
	                (0, _helpers.translation)('13548')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13544')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.PaintHours)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13541')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.PaintHourPrice)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13542')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.PaintMaterialsPrice)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13543')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.PaintWorkPrice)
	                )
	              ),
	              item.PaintCorrectionPrice !== 0 && _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)(item.PaintCorrectionText)
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.PaintCorrectionPrice)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  (0, _helpers.translation)('13353')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.PaintTotalAfterCorrection)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                '\xA0'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'extent_dummy' },
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix title' },
	                (0, _helpers.translation)('945'),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _currency.formatCurrency)(item.TotalAfterCorrection)
	                )
	              )
	            )
	          )
	        );
	      };
	      // Render
	      return _react2.default.createElement(
	        'div',
	        { className: 'form' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          (0, _helpers.translation)('13438')
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'ul',
	            null,
	            DummyForsiReports.map(renderDummyForsi)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isDummy = this.state.item.IsDummy;
	      var renderDummy = function renderDummy(key, value) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'clearfix', key: value },
	          _react2.default.createElement(
	            'div',
	            null,
	            key
	          )
	        );
	      };
	      if (isDummy) {
	        var dummyTextArray = this.state.item.DummyText.split('<br />');
	        var extentArray = this.state.item.OrderExtent.split('<br />');
	        var hasDummyText = this.state.item.DummyText !== '' && dummyTextArray !== undefined && dummyTextArray !== null && dummyTextArray.length > 0;
	        var hasExtent = this.state.item.OrderExtent !== '' && extentArray !== undefined && extentArray !== null && extentArray.length > 0;
	        return _react2.default.createElement(
	          'div',
	          { className: 'dummy__view' },
	          hasDummyText && _react2.default.createElement(
	            'ul',
	            { className: 'extent_dummy' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              (0, _helpers.translation)('13546')
	            ),
	            extentArray.map(renderDummy)
	          ),
	          hasExtent && _react2.default.createElement(
	            'ul',
	            { className: 'extent_dummy' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              (0, _helpers.translation)('13547')
	            ),
	            dummyTextArray.map(renderDummy)
	          ),
	          this.renderForsiReport(),
	          _react2.default.createElement(
	            'div',
	            { className: 'extent_dummy' },
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'label',
	                null,
	                (0, _helpers.translation)('641')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _currency.formatCurrency)(this.state.item.TotalPrice || 0)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'label',
	                null,
	                (0, _helpers.translation)('13339')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _currency.formatCurrency)(this.state.item.Environment || 0)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'label',
	                null,
	                (0, _helpers.translation)('2325')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _currency.formatCurrency)(this.state.item.AddonPrice || 0)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'label',
	                null,
	                (0, _helpers.translation)('2326')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _currency.formatCurrency)(this.state.item.AddonEnvironment || 0)
	              )
	            )
	          )
	        );
	      }
	      return undefined;
	    }
	  }]);
	
	  return DummyExtent;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(DummyExtent);

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uuid = __webpack_require__(1989);
	
	var _echarts = __webpack_require__(1350);
	
	var echarts = _interopRequireWildcard(_echarts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Examples: https://echarts.apache.org/examples/en/index.html
	 * API docs: https://echarts.apache.org/en/api.html#echarts
	*/
	var EChart = function (_Component) {
	  _inherits(EChart, _Component);
	
	  function EChart(props) {
	    _classCallCheck(this, EChart);
	
	    var _this = _possibleConstructorReturn(this, (EChart.__proto__ || Object.getPrototypeOf(EChart)).call(this, props));
	
	    _this.uuid = (0, _uuid.v4)();
	    _this.chart = undefined;
	    return _this;
	  }
	
	  _createClass(EChart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.chart = echarts.init(document.getElementById(this.uuid), null, {
	        width: this.props.width,
	        height: this.props.height
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.chart) {
	        this.chart.setOption(this.props.options);
	      }
	
	      return _react2.default.createElement('div', { id: this.uuid });
	    }
	  }]);
	
	  return EChart;
	}(_react.Component);
	
	EChart.defaultProps = {
	  width: 1200,
	  height: 400
	};
	
	exports.default = EChart;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _language = __webpack_require__(139);
	
	var _common = __webpack_require__(25);
	
	var _embedded = __webpack_require__(408);
	
	var _store = __webpack_require__(83);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(1508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Redux
	
	
	// Elements
	
	
	var EmbedView = function (_Component) {
	  _inherits(EmbedView, _Component);
	
	  function EmbedView(props) {
	    _classCallCheck(this, EmbedView);
	
	    var _this = _possibleConstructorReturn(this, (EmbedView.__proto__ || Object.getPrototypeOf(EmbedView)).call(this, props));
	
	    _this.state = {
	      view: 'loading', // Valid views: 'loading', 'error', 'companyselection', 'logincomplete'
	      companies: []
	    };
	    _this.setView = _this.setView.bind(_this);
	    _this.restart = _this.restart.bind(_this);
	    return _this;
	  }
	
	  _createClass(EmbedView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(props) {
	      var lang = this.props.language;
	      switch (this.props.language) {
	        case 'danish':
	        case 'Dk':
	        case 'dk':
	          lang = 'Danish';
	          break;
	        case 'english':
	        case 'Uk':
	        case 'uk':
	        case 'En':
	        case 'en':
	          lang = 'English';
	          break;
	      }
	      if (typeof lang === 'string') {
	        (0, _language.InitLanguage)().then(function (res) {
	          _store2.default.dispatch((0, _language.setTranslations)(res.translations));
	          _store2.default.dispatch((0, _language.setLanguage)(lang));
	          _store2.default.dispatch((0, _common.setPhoneCodes)(res.data.PhoneCodes));
	          _store2.default.dispatch((0, _common.setBrands)(res.data.Brands));
	          _store2.default.dispatch((0, _common.setEnums)(res.data.Enums));
	          _store2.default.dispatch((0, _common.setCountries)(res.data.Countries));
	        });
	      }
	      this.restart();
	    }
	  }, {
	    key: 'restart',
	    value: function restart() {
	      var _this2 = this;
	
	      console.log('EmbedView -> restart 1');
	      if (typeof this.props.embedToken === 'string') {
	        var requireCompany = false;
	        var usage = 0;
	        switch (this.props.embedType) {
	          case 'bookingportal':
	            requireCompany = true;
	            usage = 1;
	        }
	        if (_typeof(this.props.auth.user) === 'object' && typeof this.props.auth.user.Token === 'string' && this.props.auth.user.Usage === usage) {
	          this.setView('logincomplete');
	          if (requireCompany) {
	            this.props.getCompaniesFromToken(this.props.embedToken, this.props.embedType).then(function (res) {
	              _this2.setState({ companies: res.data });
	              if (res.data.length > 0) {
	                console.log('EmbedView -> restart 3 -> onCompanyTokensReceived');
	                if (typeof _this2.props.onCompanyTokensReceived === 'function') {
	                  _this2.props.onCompanyTokensReceived(res.data);
	                }
	              }
	            });
	          }
	          if (typeof this.props.onLoginComplete === 'function') {
	            this.props.onLoginComplete();
	          }
	          return;
	        }
	        console.log('EmbedView -> restart 2');
	        if (requireCompany) {
	          this.props.getCompaniesFromToken(this.props.embedToken, this.props.embedType).then(function (res) {
	            _this2.setState({ companies: res.data });
	            _this2.setView('companyselection');
	            if (res.data.length > 0) {
	              console.log('EmbedView -> restart 4 -> onCompanyTokensReceived');
	              if (typeof _this2.props.onCompanyTokensReceived === 'function') {
	                _this2.props.onCompanyTokensReceived(res.data);
	              }
	            }
	          }, function () {
	            _this2.setView('error');
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (_typeof(props.view) !== undefined && props.view !== this.state.view && props.view !== null) {
	        this.setState({ view: props.view });
	      }
	    }
	  }, {
	    key: 'setView',
	    value: function setView(view) {
	      var _this3 = this;
	
	      this.setState({ view: view }, function () {
	        if (typeof _this3.props.onViewChange === 'function') {
	          _this3.props.onViewChange(view);
	        }
	      });
	    }
	  }, {
	    key: 'loginWithToken',
	    value: function loginWithToken(token) {
	      var _this4 = this;
	
	      this.props.loginWithToken(token, this.props.embedType).then(function (res) {
	        _this4.setView('logincomplete');
	        if (typeof _this4.props.onLoginComplete === 'function') {
	          _this4.props.onLoginComplete();
	        }
	      }, function () {
	        _this4.setState({ view: 'error' });
	      });
	    }
	  }, {
	    key: 'renderCompanySelection',
	    value: function renderCompanySelection() {
	      var _this5 = this;
	
	      var renderCompanyButton = function renderCompanyButton(company, i) {
	        return _react2.default.createElement(_button2.default, { style: 'link', key: 'key_' + i, labelText: company.CompanyName, onClick: function onClick() {
	            return _this5.loginWithToken(company.Token);
	          } });
	      };
	      var renderNoAvailableCompanies = function renderNoAvailableCompanies() {
	        var notAvailableMsg = 'No available companies!';
	        if (typeof _this5.props.notAvailableMsg === 'string') notAvailableMsg = _this5.props.notAvailableMsg;
	        return _react2.default.createElement(
	          'div',
	          { className: 'embedview error' },
	          _react2.default.createElement(
	            'p',
	            null,
	            notAvailableMsg
	          )
	        );
	      };
	      if (this.state.companies === null) {
	        return renderNoAvailableCompanies();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'embedview company-select' },
	        this.props.children,
	        _react2.default.createElement(
	          'div',
	          { className: 'companies' },
	          this.state.companies.length > 1 && this.state.companies.map(renderCompanyButton)
	        )
	      );
	    }
	  }, {
	    key: 'renderLoadingView',
	    value: function renderLoadingView() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'embedview loading' },
	        _react2.default.createElement(
	          'div',
	          { className: 'spinner' },
	          _react2.default.createElement('div', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	        )
	      );
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      var errorMsg = 'There seems to be a configuration error with the embedded view!';
	      if (typeof this.props.configErrorMsg === 'string') errorMsg = this.props.configErrorMsg;
	      return _react2.default.createElement(
	        'div',
	        { className: 'embedview error' },
	        _react2.default.createElement(
	          'div',
	          null,
	          errorMsg
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      switch (this.state.view) {
	        case 'loading':
	          return this.renderLoadingView();
	        case 'error':
	          return this.renderError();
	        case 'companyselection':
	          return this.renderCompanySelection();
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'embedview' },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return EmbedView;
	}(_react.Component);
	
	EmbedView.propTypes = {
	  embedType: _propTypes2.default.string.isRequired,
	  auth: _propTypes2.default.object.isRequired,
	  setLanguage: _propTypes2.default.func.isRequired,
	  setPhoneCodes: _propTypes2.default.func.isRequired,
	  setBrands: _propTypes2.default.func.isRequired,
	  setCountries: _propTypes2.default.func.isRequired,
	  setEnums: _propTypes2.default.func.isRequired,
	  InitLanguage: _propTypes2.default.func.isRequired,
	  loginWithToken: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getCompaniesFromToken: _embedded.getCompaniesFromToken,
	  loginWithToken: _embedded.loginWithToken,
	  InitLanguage: _language.InitLanguage,
	  setLanguage: _language.setLanguage,
	  setPhoneCodes: _common.setPhoneCodes,
	  setBrands: _common.setBrands,
	  setCountries: _common.setCountries,
	  setEnums: _common.setEnums
	})(EmbedView);

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1509);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var EstimationsList = function (_Component) {
	  _inherits(EstimationsList, _Component);
	
	  function EstimationsList(props) {
	    _classCallCheck(this, EstimationsList);
	
	    var _this = _possibleConstructorReturn(this, (EstimationsList.__proto__ || Object.getPrototypeOf(EstimationsList)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EstimationsList, [{
	    key: 'render',
	    value: function render() {
	      if (!this.props.price || !this.props.priceInformation) return null;
	      var _props$priceInformati = this.props.priceInformation,
	          RefinishTypes = _props$priceInformati.RefinishTypes,
	          StartTimes = _props$priceInformati.StartTimes,
	          HourPrices = _props$priceInformati.HourPrices,
	          MaterialsShares = _props$priceInformati.MaterialsShares;
	      var _props$price = this.props.price,
	          OrderEstimationRefinishTypeDetails = _props$price.OrderEstimationRefinishTypeDetails,
	          OrderEstimationStartTimeDetails = _props$price.OrderEstimationStartTimeDetails,
	          OrderEstimationHourPriceDetails = _props$price.OrderEstimationHourPriceDetails,
	          OrderEstimationMaterialsShareDetails = _props$price.OrderEstimationMaterialsShareDetails;
	
	
	      var renderEstimationTypes = function renderEstimationTypes(titleCode, estimationTypes) {
	        if (!estimationTypes || estimationTypes.length === 0) return null;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'estimationExtent' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'estimationTitle' },
	            (0, _helpers.translation)(titleCode)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            estimationTypes.map(function (et, key) {
	              return _react2.default.createElement(
	                'div',
	                { key: key },
	                et.Type || et.Price || et.Share
	              );
	            })
	          )
	        );
	      };
	
	      var refTypes = RefinishTypes.filter(function (rt) {
	        return !!OrderEstimationRefinishTypeDetails.find(function (rtd) {
	          return rt.EstimationRefinishTypeId === rtd.EstimationRefinishTypeId && rtd.IsDeleted !== true;
	        });
	      });
	      var strtTimes = StartTimes.filter(function (st) {
	        return !!OrderEstimationStartTimeDetails.find(function (std) {
	          return st.EstimationStartTimeId === std.EstimationStartTimeId && std.IsDeleted !== true;
	        });
	      });
	      var hrPrices = HourPrices.filter(function (hp) {
	        return !!OrderEstimationHourPriceDetails.find(function (hpd) {
	          return hp.EstimationHourPriceId === hpd.EstimationHourPriceId && hpd.IsDeleted !== true;
	        });
	      });
	      var matShares = MaterialsShares.filter(function (ms) {
	        return !!OrderEstimationMaterialsShareDetails.find(function (msd) {
	          return ms.EstimationMaterialsShareId === msd.EstimationMaterialsShareId && msd.IsDeleted !== true;
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderEstimationTypes('161', refTypes),
	        renderEstimationTypes('1195', strtTimes),
	        renderEstimationTypes('419', hrPrices),
	        renderEstimationTypes('415', matShares)
	      );
	    }
	  }]);
	
	  return EstimationsList;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(EstimationsList);

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1511);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentDBSLine = function (_Component) {
	  _inherits(AssesmentDBSLine, _Component);
	
	  function AssesmentDBSLine() {
	    _classCallCheck(this, AssesmentDBSLine);
	
	    return _possibleConstructorReturn(this, (AssesmentDBSLine.__proto__ || Object.getPrototypeOf(AssesmentDBSLine)).apply(this, arguments));
	  }
	
	  _createClass(AssesmentDBSLine, [{
	    key: 'renderLine',
	    value: function renderLine() {
	      var notation = '';
	      var line = this.props.line;
	      var reportType = this.props.reportType;
	      var currencyCode = this.props.currencyCode;
	      var useSubline = reportType === 3; // ForsiManual // RPreport
	      var className = 'dbs-body__line';
	      var amount = void 0;
	      if (line.ManualPrice !== null && this.props.showPrices) {
	        amount = line.ManualPrice;notation = (0, _helpers.translation)(currencyCode);
	      }
	      if (line.CalculatedPrice !== null && this.props.showPrices) {
	        amount = line.CalculatedPrice;notation = (0, _helpers.translation)(currencyCode);
	      }
	      if (line.UnitPrice !== null && this.props.showAE) {
	        amount = line.UnitPrice;
	      }
	      if (line.WorkUnits !== null && this.props.showAE) {
	        amount = line.WorkUnits;notation = (0, _helpers.translation)('885');
	      }
	      if (line.GenericValue !== null) {
	        amount = line.GenericValue;
	      }
	      var lineText = line.LineText ? line.LineText.split('\r\n') : [];
	
	      if (lineText.length > 1) {
	        var first = lineText[0];
	        var last = lineText.slice(-1);
	        var rest = lineText.filter(function (n, i) {
	          return i !== 0 && i !== lineText.length - 1;
	        });
	        return _react2.default.createElement(
	          _Line2.default,
	          { boldText: true, text: first },
	          rest.map(function (n, key) {
	            return _react2.default.createElement(_Line2.default, { text: n, className: className, subLine: useSubline, key: key });
	          }),
	          _react2.default.createElement(_Line2.default, { text: last, amount: amount, noFormat: true, currencyType: notation, className: className, subLine: useSubline })
	        );
	      } else {
	        // method // LineType: 0 = Generic
	        if (line.LineType === 0 && !line.GenericValue && line.LineNumber) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              line.LineNumber,
	              ' '
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              line.LineText
	            )
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          line.AdditionalText ? _react2.default.createElement(
	            _Line2.default,
	            { bold: true, text: line.LineText },
	            _react2.default.createElement(_Line2.default, { text: line.AdditionalText, amount: amount, noFormat: true, currencyType: notation, subLine: true })
	          ) : _react2.default.createElement(_Line2.default, { boldText: true, boldAmount: this.props.boldAmount, text: line.LineText, amount: amount, noFormat: true, currencyType: notation })
	        );
	      }
	    }
	    // <Line boldText={this.props.boldText} boldAmount={this.props.boldAmount} text={line.LineText} amount={amount} noFormat currencyType={notation} />
	
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.line) return this.renderLine();
	      return null;
	    }
	  }]);
	
	  return AssesmentDBSLine;
	}(_react.Component);
	
	exports.default = AssesmentDBSLine;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1515);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {  } from '../../../elements/icons'
	
	// Elements
	
	
	// import Icon from '../../../elements/icon'
	var AssessmentRPReportFiles = function (_Component) {
	  _inherits(AssessmentRPReportFiles, _Component);
	
	  function AssessmentRPReportFiles(props) {
	    _classCallCheck(this, AssessmentRPReportFiles);
	
	    var _this = _possibleConstructorReturn(this, (AssessmentRPReportFiles.__proto__ || Object.getPrototypeOf(AssessmentRPReportFiles)).call(this, props));
	
	    _this.state = {
	      selectedFile: null
	    };
	    return _this;
	  }
	
	  _createClass(AssessmentRPReportFiles, [{
	    key: 'renderUpload',
	    value: function renderUpload() {
	      var _this2 = this;
	
	      var onDropAccepted = function onDropAccepted(files) {
	        var file = files[0];
	        if (file.type === 'application/pdf') {
	          _this2.props.uploadFileToOrder(file, _this2.props.order.Id, 12).then(function (res) {
	            if (!res) {
	              // Toastr
	              window.toastr.error((0, _helpers.translation)(15194), (0, _helpers.translation)('216'));
	            } else {
	              // Toastr
	              // window.toastr.success(translation(15193), translation('13424'))
	              if (_this2.props.onUploadSuccess !== undefined) {
	                _this2.props.onUploadSuccess(res);
	              }
	            }
	          }, function (err) {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)(15194), (0, _helpers.translation)('216'));
	            if (_this2.props.onUploadError !== undefined) {
	              _this2.props.onUploadSuccess(err.response);
	            }
	          });
	        } else {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(15194), (0, _helpers.translation)('216'));
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'browse clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'h-line' },
	          (0, _helpers.translation)(15192)
	        ),
	        _react2.default.createElement(
	          _Dropzone2.default
	          // onDrop={onDrop}
	          ,
	          { onDropAccepted: onDropAccepted
	            // onDropRejected={onDropRejected}
	            , includeCircles: false },
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _helpers.translation)(13397)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderReportFile',
	    value: function renderReportFile(file, key) {
	      var _this3 = this;
	
	      if (!file || file.FileName === null) return null;
	      var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token);
	      var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	      var fileTitle = file.FileName;
	      switch (file.SectionType) {
	        case 1:
	          fileTitle = 14836; // 'Lakrapport @'
	          break;
	        case 2:
	          fileTitle = 15199; // 'Karosserirapport @'
	          break;
	        case 4:
	          fileTitle = 14837; // 'Reservedelsrapport @'
	          break;
	      }
	      var renderDate = function renderDate() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'date' },
	          (0, _time.renderFullDate)(_this3.props.order.Report.CreatedDate)
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { key: key, className: 'rp-report-file clearfix' },
	        _react2.default.createElement(
	          'a',
	          { target: '_BLANK', href: newFileUrl },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: ['max-content', 'min-content', 1], align: 'center' },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(fileTitle)
	            ),
	            _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	            this.props.showDates && renderDate()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var file = this.props.attachment;
	      var forsiEnable = this.props.auth.permissions.ChainAssessmentSystem === 1; // Forsi is available for the company
	      var hidden = this.props.editable !== true && file === null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'rp-file-box' + (hidden ? ' hidden' : '') },
	        forsiEnable && this.props.editable && this.renderUpload(),
	        this.renderReportFile(file)
	      );
	    }
	  }]);
	
	  return AssessmentRPReportFiles;
	}(_react.Component);
	
	AssessmentRPReportFiles.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  uploadFileToOrder: _orders.uploadFileToOrder
	})(AssessmentRPReportFiles);

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _AssessmentReportSums = __webpack_require__(198);
	
	var _AssessmentReportSums2 = _interopRequireDefault(_AssessmentReportSums);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CombinedPrice = function (_Component) {
	  _inherits(CombinedPrice, _Component);
	
	  function CombinedPrice(props) {
	    _classCallCheck(this, CombinedPrice);
	
	    var _this = _possibleConstructorReturn(this, (CombinedPrice.__proto__ || Object.getPrototypeOf(CombinedPrice)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CombinedPrice, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.noRef) {
	        this.props.onRef(this);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.noRef) {
	        this.props.onRef(undefined);
	      }
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(1396);
	      }
	      switch (this.props.order.OrderType) {
	        case 1:
	          return (0, _helpers.translation)(13360);
	        case 2:
	          return (0, _helpers.translation)(71);
	        case 3:
	          return (0, _helpers.translation)(13361);
	        case 6:
	          return (0, _helpers.translation)(785);
	      }
	      return 'No title';
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return '/images/svgs/taksering/Additional-sales-new.svg';
	      }
	      switch (this.props.order.OrderType) {
	        case 1:
	          return '/images/svgs/ordrer/Insurance-black.svg';
	        case 2:
	          return '/images/svgs/ordrer/Salescar-black.svg';
	        case 3:
	          return '/images/svgs/ordrer/Garanteed-black.svg';
	        case 6:
	          return '/images/svgs/ordrer/Private_c-black.svg';
	      }
	      return null;
	    }
	  }, {
	    key: 'getTitleAria',
	    value: function getTitleAria() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(34) + ' ' + (0, _helpers.translation)(1396);
	      }
	      return (0, _helpers.translation)(2705);
	    }
	  }, {
	    key: 'renderAmountField',
	    value: function renderAmountField(label, value) {
	      var bold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (value === null) value = 0;
	      var amount = value;
	      return _react2.default.createElement(_Line2.default, { text: label, amount: amount, boldText: bold, bold: bold, currencyType: this.props.currencyCode });
	    }
	  }, {
	    key: 'renderManualAmounts',
	    value: function renderManualAmounts() {
	      var _props = this.props,
	          order = _props.order,
	          viewMode = _props.viewMode;
	
	
	      var hasPaintPriceList = order.HasBasePaintPriceList;
	      var isCorrectViewMode = viewMode !== 'simple';
	      // let hasBodyPriceList = true
	
	      var renderDivider = function renderDivider(text) {
	        if (text !== undefined) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'title spacing' },
	            text
	          );
	        }
	        return _react2.default.createElement('div', { className: 'h-line bold' });
	      };
	
	      var addon = order.AddonPrice + order.AddonEnvironment + order.BodyShopAddonPrice + order.BodyShopAddonEnvironment;
	      var total = order.ManualBodyGross + order.Price + order.Environment + addon;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        isCorrectViewMode && this.renderAmountField((0, _helpers.translation)(416), order.ManualBodyWorkPrice),
	        isCorrectViewMode && this.renderAmountField((0, _helpers.translation)(15156), order.ManualBodyWorkEnvPrice),
	        isCorrectViewMode && this.renderAmountField((0, _helpers.translation)(637), order.ManualBodySparePartPrice),
	        isCorrectViewMode && this.renderAmountField((0, _helpers.translation)(15154), order.ManualBodyMiscPrice),
	        isCorrectViewMode && !hasPaintPriceList && this.renderAmountField((0, _helpers.translation)(660), order.Price),
	        isCorrectViewMode && !hasPaintPriceList && this.renderAmountField((0, _helpers.translation)(15155), order.Environment),
	        isCorrectViewMode && this.renderAmountField((0, _helpers.translation)(1396), addon),
	        _react2.default.createElement(
	          'div',
	          { className: 'totals' },
	          isCorrectViewMode && renderDivider(),
	          this.renderAmountField((0, _helpers.translation)(17889), total, true)
	        )
	      );
	    }
	  }, {
	    key: 'renderReportSums',
	    value: function renderReportSums() {
	      // If bodyshop, we want to show both paint and body prices in this case.
	      var department = this.props.department;
	      if (department === 1) {
	        department = 2;
	      }
	
	      return _react2.default.createElement(_AssessmentReportSums2.default, { report: this.props.order.Report, department: department, currencyCode: this.props.currencyCode, includeTotal: true, includeTotalDivider: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          editable = _props2.editable,
	          viewMode = _props2.viewMode;
	
	
	      if (editable) {
	        console.error('CombinedPrice has no edit support!');
	      }
	
	      var css = 'manualbody';
	      return _react2.default.createElement(
	        'div',
	        { className: css },
	        viewMode === 'mobile' && this.props.renderInside(),
	        this.props.order.Report ? this.renderReportSums() : this.renderManualAmounts()
	      );
	    }
	  }]);
	
	  return CombinedPrice;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    currencyCode: state.common.currencyCode
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(CombinedPrice);

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComplaintLine = function (_Component) {
	  _inherits(ComplaintLine, _Component);
	
	  function ComplaintLine() {
	    _classCallCheck(this, ComplaintLine);
	
	    return _possibleConstructorReturn(this, (ComplaintLine.__proto__ || Object.getPrototypeOf(ComplaintLine)).apply(this, arguments));
	  }
	
	  _createClass(ComplaintLine, [{
	    key: 'render',
	    value: function render() {
	      var text = '';
	      if (this.props.complaint !== undefined && this.props.complaint !== null) {
	        var complaint = this.props.complaint;
	        text = (0, _helpers.translation)((0, _helpers.enumtranslate)('ComplaintTypes', complaint.ComplaintType));
	      }
	
	      return _react2.default.createElement(_Line2.default, { text: text, onDelete: this.props.onDelete && this.props.onDelete.bind(this, this.props.complaint) });
	    }
	  }]);
	
	  return ComplaintLine;
	}(_react.Component);
	
	exports.default = ComplaintLine;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	var _Part = __webpack_require__(152);
	
	var _Part2 = _interopRequireDefault(_Part);
	
	__webpack_require__(1518);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var Complaint = function (_Component) {
	  _inherits(Complaint, _Component);
	
	  function Complaint(props) {
	    _classCallCheck(this, Complaint);
	
	    var _this = _possibleConstructorReturn(this, (Complaint.__proto__ || Object.getPrototypeOf(Complaint)).call(this, props));
	
	    _this.state = {
	      comment: '',
	      refNr: ''
	    };
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.orderpriceSave = _this.orderpriceSave.bind(_this);
	    return _this;
	  }
	
	  _createClass(Complaint, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onRef(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onRef(undefined);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      if (_typeof(next.orderPrice) !== 'object') return;
	      if (next.orderPrice.Department === 0) {
	        this.setState({
	          comment: next.orderPrice.ComplaintComment,
	          refNr: next.orderPrice.ComplaintRefNr
	        });
	      } else {
	        this.setState({
	          comment: next.orderPrice.BodyShopComplaintComment,
	          refNr: next.orderPrice.BodyShopComplaintRefNr
	        });
	      }
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      return (0, _helpers.translation)(333);
	    }
	  }, {
	    key: 'getTitleAria',
	    value: function getTitleAria() {
	      return (0, _helpers.translation)(2705);
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      return '/images/svgs/ordrer/Complaint-black.svg';
	    }
	  }, {
	    key: 'getEditUrl',
	    value: function getEditUrl() {
	      if (this.props.orderPrice.Department === 0) {
	        return '/pricecalculation/' + this.props.order.Id + '/1';
	      } else {
	        return '/pricecalculation/' + this.props.order.Id + '/bodyextent';
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'orderpriceSave',
	    value: function orderpriceSave() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        var data = _this2.props.orderPrice;
	        if (data.Department === 0) {
	          data.ComplaintComment = _this2.state.comment;
	          data.ComplaintRefNr = _this2.state.refNr;
	        } else {
	          data.BodyShopComplaintComment = _this2.state.comment;
	          data.BodyShopComplaintRefNr = _this2.state.refNr;
	        }
	        _this2.props.saveOrderPrice(data);
	      }, 50);
	    }
	  }, {
	    key: 'renderComment',
	    value: function renderComment() {
	      return this.props.editable ? _react2.default.createElement(_textarea2.default, {
	        labelText: (0, _helpers.translation)('149'),
	        name: 'comment',
	        value: this.state.comment || '',
	        onBlur: this.orderpriceSave,
	        onChange: this.onInputChange }) : _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('149') },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.state.comment
	        )
	      );
	    }
	  }, {
	    key: 'renderRefNr',
	    value: function renderRefNr() {
	      return this.props.editable ? _react2.default.createElement(_text2.default, {
	        labelText: (0, _helpers.translation)('13410'),
	        name: 'refNr',
	        value: this.state.refNr || '',
	        onBlur: this.orderpriceSave,
	        onChange: this.onInputChange }) : _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('13410') },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.state.refNr
	        )
	      );
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(part, task) {
	      if (part && task) {
	        part.Complaints.map(function (x) {
	          if (x.ComplaintType === task.ComplaintType) x.IsDeleted = true;
	          return x;
	        });
	
	        this.props.orderPrice.Parts.map(function (x) {
	          if (x.Part.TaskSide === part.Part.TaskSide && x.Part.PartItemId === part.Part.PartItemId) x = part;
	          return x;
	        });
	
	        this.orderpriceSave();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.orderPrice === undefined || this.props.orderPrice === null) return null;
	      var parts = this.props.orderPrice.Parts;
	
	      var goBack = function goBack() {
	        _this3.orderpriceSave;
	        _this3.props.goBack();
	      };
	
	      var css = '';
	      if (this.props.editable) {
	        css += 'price__view editable';
	      }
	      css += ' extent_complaint';
	
	      var renderPart = function renderPart(part) {
	        return _react2.default.createElement(_Part2.default, {
	          key: 'part_' + part.Part.PartItemId + '_' + part.Part.TaskSide,
	          onDelete: _this3.props.editable && _this3.onDelete.bind(_this3, part),
	          part: part });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: css },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.viewMode === 'mobile' && this.props.renderInside(),
	          this.props.editable && _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('304') }),
	          parts.map(renderPart)
	        ),
	        this.renderComment(),
	        this.renderRefNr(),
	        this.props.editable && _react2.default.createElement(_button2.default, { onClick: goBack, labelText: (0, _helpers.translation)('956') })
	      );
	    }
	  }]);
	
	  return Complaint;
	}(_react.Component);
	
	exports.default = Complaint;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeviationLine = function (_Component) {
	  _inherits(DeviationLine, _Component);
	
	  function DeviationLine() {
	    _classCallCheck(this, DeviationLine);
	
	    return _possibleConstructorReturn(this, (DeviationLine.__proto__ || Object.getPrototypeOf(DeviationLine)).apply(this, arguments));
	  }
	
	  _createClass(DeviationLine, [{
	    key: 'render',
	    value: function render() {
	      var reason = this.props.reason;
	      if (!reason) return null;
	
	      var enumName = '';
	      var deviationName = '';
	
	      if (this.props.isCustomReason) {
	        enumName = reason.DeviationGroup === 0 ? 'InternalDeviationTypes' : 'ExternalDeviationTypes';
	        deviationName = reason.CustomReason;
	      } else {
	        enumName = reason.DeviationType.ClassId - 1 === 0 ? 'InternalDeviationTypes' : 'ExternalDeviationTypes';
	        deviationName = (0, _helpers.translation)((0, _helpers.enumtranslate)(enumName, reason.DeviationType.Type));
	      }
	
	      return _react2.default.createElement(_Line2.default, { text: deviationName, onDelete: this.props.onDelete && this.props.onDelete.bind(this, this.props.reason), subLine: !this.props.editable });
	    }
	  }]);
	
	  return DeviationLine;
	}(_react.Component);
	
	exports.default = DeviationLine;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Part = __webpack_require__(152);
	
	var _Part2 = _interopRequireDefault(_Part);
	
	var _Photo = __webpack_require__(233);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _Comment = __webpack_require__(232);
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _currency = __webpack_require__(41);
	
	var _shops = __webpack_require__(79);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1519);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	// import PanelHeader from '../../../elements/panelHeader'
	
	var Deviation = function (_Component) {
	  _inherits(Deviation, _Component);
	
	  function Deviation(props) {
	    _classCallCheck(this, Deviation);
	
	    var _this = _possibleConstructorReturn(this, (Deviation.__proto__ || Object.getPrototypeOf(Deviation)).call(this, props));
	
	    _this.state = {
	      price: null,
	      order: null,
	      deviation: null
	    };
	    _this.deviationInitialized = false;
	    return _this;
	  }
	
	  _createClass(Deviation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.onRef(this);
	      this.props.getShop(this.props.auth.user.ShopId).then(function (res) {
	        _this2.setState({
	          transferDeviation: res.data.AddExternalDeviations
	        });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onRef(undefined);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      var _this3 = this;
	
	      if (_typeof(next.orderPrice) !== 'object') return;
	
	      var deviation = {
	        MoveBackStepId: next.router.location.state ? next.router.location.state.stepId : next.order.StepId,
	        ShowCostCustomer: false,
	        TransferCostToInvoice: false,
	        DeviationFiles: []
	      };
	
	      if (next.orderPrice.Deviations.length > 0) deviation = next.orderPrice.Deviations[0];else next.orderPrice.Deviations[0] = deviation;
	
	      this.setState({
	        price: next.orderPrice,
	        deviation: deviation,
	        order: next.order
	      }, function () {
	        if (!_this3.deviationInitialized) {
	          _this3.deviationInitialized = true;
	          _this3.savePrice();
	        }
	      });
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      if (this.props.orderPrice === null) return null;
	      return (0, _helpers.translation)(333);
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(part, reason) {
	      if (part && reason) {
	        if (reason.DeviationReasonId !== undefined) {
	          part.DeviationReasons.map(function (x) {
	            if (x.DeviationReasonId === reason.DeviationReasonId) x.IsDeleted = true;
	            return x;
	          });
	        } else if (reason.CustomDeviationReasonId !== undefined) {
	          part.CustomDeviationReasons.map(function (x) {
	            if (x.CustomDeviationReasonId === reason.CustomDeviationReasonId) x.IsDeleted = true;
	          });
	        }
	
	        // this.state.price.Parts.map(x => {
	        //   if (x.Part.TaskSide === part.Part.TaskSide && x.Part.PartItemId === part.Part.PartItemId) x = part
	        //   return x
	        // })
	
	        this.savePrice();
	      }
	    }
	  }, {
	    key: 'savePrice',
	    value: function savePrice() {
	      var price = this.state.price;
	      price.Deviations[0] = this.state.deviation;
	      return this.props.saveOrderPrice(price);
	    }
	  }, {
	    key: 'renderStepSection',
	    value: function renderStepSection() {
	      var _this4 = this;
	
	      var getNameTranslation = function getNameTranslation(id) {
	        switch (id) {
	          case 1:
	            return 164;
	          case 2:
	            return 96;
	          case 3:
	            return 160;
	          case 4:
	            return 158;
	          case 5:
	            return 161;
	          case 6:
	            return 162;
	          case 7:
	            return 163;
	          case 8:
	            return 23;
	          default:
	            return '';
	        }
	      };
	      var onChange = function onChange(e) {
	        _this4.setState({
	          deviation: _extends({}, _this4.state.deviation, {
	            MoveBackStepId: parseInt(e.target.value)
	          }),
	          hasChanged: true
	        }, function () {
	          setTimeout(function () {
	            _this4.savePrice();
	          }, 50);
	        });
	      };
	      var steps = Array.apply(null, { length: this.state.order.StepId }).map(Number.call, Number);
	
	      // Return
	      return _react2.default.createElement(
	        'div',
	        { className: 'deviationMoveBackward' },
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('13481') }),
	        steps.map(function (val, key) {
	          var id = val + 1;
	          var name = getNameTranslation(id);
	          var disabled = false;
	          var stepId = _this4.state.deviation.MoveBackStepId;
	
	          if (_this4.state.order.IsArchived || _this4.state.order.StepId === 8) {
	            disabled = true;
	          }
	          return _react2.default.createElement(_radio2.default, { key: key, labelText: (0, _helpers.translation)(name), id: 'step-' + id, name: 'Step', value: id, checked: stepId === id, onChange: onChange, disabled: disabled });
	        })
	      );
	    }
	  }, {
	    key: 'renderCostSection',
	    value: function renderCostSection() {
	      var _this5 = this;
	
	      var onBlur = function onBlur(e) {
	        _this5.setState({
	          deviation: _extends({}, _this5.state.deviation, {
	            Cost: parseFloat((0, _currency.reverseFormatCurrency2)(e.target.value))
	          })
	        }, function () {
	          setTimeout(function () {
	            _this5.savePrice();
	          }, 50);
	        });
	      };
	      var onInputChange = function onInputChange(e) {
	        _this5.setState({
	          deviation: _extends({}, _this5.state.deviation, {
	            Cost: e.target.value
	          })
	        });
	      };
	      var onCheckChange = function onCheckChange(e) {
	        _this5.setState({
	          deviation: _extends({}, _this5.state.deviation, _defineProperty({}, e.target.name, e.target.checked))
	        }, function () {
	          setTimeout(function () {
	            _this5.savePrice();
	          }, 50);
	        });
	      };
	
	      var showCostCustomer = this.state.deviation.ShowCostCustomer === true;
	      var transferCostToInvoice = this.state.deviation.TransferCostToInvoice === true;
	      var isInternal = this.state.price.IsInternalDeviation === true;
	      return _react2.default.createElement(
	        'div',
	        { className: 'deviationCost' },
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('337') }),
	        _react2.default.createElement(_text2.default, { value: (0, _currency.formatCurrency2)(this.state.deviation.Cost), onBlur: onBlur, onChange: onInputChange }),
	        !isInternal && _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('14935'), id: 'Cost_ShowToCustomer', name: 'ShowCostCustomer', onChange: onCheckChange, checked: showCostCustomer, disabled: !this.props.editable }),
	        !isInternal && _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('14936'), id: 'Cost_TransferToInvoice', name: 'TransferCostToInvoice', onChange: onCheckChange, checked: transferCostToInvoice, disabled: !this.state.transferDeviation })
	      );
	    }
	  }, {
	    key: 'renderReason',
	    value: function renderReason() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('333') }),
	        this.state.price.Parts.map(function (val) {
	          return _react2.default.createElement(_Part2.default, {
	            key: 'part_' + val.Part.PartItemId + '_' + val.Part.TaskSide,
	            part: val,
	            onDelete: _this6.props.editable === true && _this6.onDelete.bind(_this6, val),
	            editable: _this6.props.editable
	          });
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      if (!this.state.price || !this.state.order || !this.state.deviation) return null;
	
	      var goBack = function goBack() {
	        _this7.setState({
	          deviation: _extends({}, _this7.state.deviation, {
	            Active: true,
	            SendToApproval: true
	          })
	        }, function () {
	          _this7.savePrice().then(function () {
	            _this7.props.goBack();
	          });
	        });
	      };
	
	      var changeSource = this.state.price.IsInternalDeviation ? 9 : this.state.price.IsExternalDeviation ? 10 : null;
	      var comment = this.state.deviation.Comment;
	
	      var css = 'price__view';
	      if (this.props.editable) {
	        css += ' editable';
	      }
	
	      // If there is no reasons then user cant save - we disable the button
	      var hasReasons = this.state.price.Parts[0] ? this.state.price.Parts[0].DeviationReasons.length > 0 || this.state.price.Parts[0].CustomDeviationReasons.length > 0 : false;
	      return _react2.default.createElement(
	        'div',
	        { className: css },
	        this.props.viewMode === 'mobile' && this.props.renderInside(),
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('889') }),
	        this.renderReason(),
	        this.renderStepSection(),
	        this.renderCostSection(),
	        _react2.default.createElement(_Photo2.default, {
	          saveOrder: this.props.saveOrder,
	          saveOrderPrice: this.props.saveOrderPrice,
	          orderPrice: this.state.price,
	          order: this.state.order,
	          loadOrder: this.props.loadOrder }),
	        _react2.default.createElement(_Comment2.default, {
	          comment: comment,
	          changeSource: changeSource,
	          deviationId: this.state.deviation.DeviationId,
	          order: this.state.order,
	          transferDeviation: this.state.transferDeviation }),
	        _react2.default.createElement(_divider2.default, { noLine: true }),
	        this.props.editable && _react2.default.createElement(_button2.default, { disabled: hasReasons === false, onClick: goBack, labelText: (0, _helpers.translation)('956') })
	      );
	    }
	  }]);
	
	  return Deviation;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getShop: _shops.getShop
	})(Deviation);

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(27);
	
	__webpack_require__(1520);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _helpers = __webpack_require__(2);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _ForsiLine = __webpack_require__(1039);
	
	var _ForsiLine2 = _interopRequireDefault(_ForsiLine);
	
	var _AssesmentForsiLine = __webpack_require__(434);
	
	var _AssesmentForsiLine2 = _interopRequireDefault(_AssesmentForsiLine);
	
	var _EstimationLine = __webpack_require__(437);
	
	var _EstimationLine2 = _interopRequireDefault(_EstimationLine);
	
	var _AssessmentReportSums = __webpack_require__(198);
	
	var _AssessmentReportSums2 = _interopRequireDefault(_AssessmentReportSums);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Elements
	
	// import Expand from '../../../../elements/expand'
	
	// Components
	
	
	var EstimationExtents = function (_Component) {
	  _inherits(EstimationExtents, _Component);
	
	  function EstimationExtents(props) {
	    _classCallCheck(this, EstimationExtents);
	
	    var _this = _possibleConstructorReturn(this, (EstimationExtents.__proto__ || Object.getPrototypeOf(EstimationExtents)).call(this, props));
	
	    _this.state = {
	      price: _this.props.orderPrice !== undefined ? _this.props.orderPrice : null,
	      partTasks: _this.props.partTasks !== undefined ? _this.props.partTasks : null,
	      accordions: {
	        refinish0: false,
	        refinish1: false,
	        refinish2: false,
	        refinish3: false,
	        refinish4: false,
	        refinish5: false,
	        starttime1: false,
	        starttime2: false,
	        starttime3: false,
	        starttime4: false,
	        hourlyprice: false,
	        materialshare: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(EstimationExtents, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.componentWillReceiveProps(this);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      if (next.orderPrice === undefined && next.partTasks === undefined) return;
	      var orderPrice = this.state.price;
	      var partTasks = this.state.partTasks;
	      if (next.orderPrice !== undefined) orderPrice = next.orderPrice;
	      if (next.partTasks !== undefined) partTasks = next.partTasks;
	
	      // Allow override ForsiReport object used.
	      if (orderPrice !== null && orderPrice.Report === null && this.props.forsiReport !== undefined) {
	        // Looks like this never happens???
	        orderPrice.Report = this.props.forsiReport;
	      }
	      this.setState({
	        price: orderPrice,
	        partTasks: partTasks
	      });
	    }
	  }, {
	    key: 'toggleOpen',
	    value: function toggleOpen(name) {
	      if (this.props.editable !== true) return;
	      this.setState({
	        accordions: _extends({}, this.state.accordions, _defineProperty({}, name, !this.state.accordions[name]))
	      });
	    }
	  }, {
	    key: 'renderPaintRefinishTypesAccordion',
	    value: function renderPaintRefinishTypesAccordion(RefinishTypes) {
	      var _this2 = this;
	
	      var renderPickerRefinish = function renderPickerRefinish(refinishTypes, price) {
	        if (price.OrderEstimationRefinishTypeDetails.length === 0) return null;
	
	        var picked = refinishTypes.filter(function (rt) {
	          var rtId = rt.EstimationRefinishTypeId;
	          return !!price.OrderEstimationRefinishTypeDetails.find(function (rtd) {
	            return rtd.PaintLineId === null && rtd.EstimationRefinishTypeId === rtId;
	          });
	        });
	        if (!picked) return null;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          picked.map(function (p, key) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'picked refinish clearfix', key: key },
	              p.Type
	            );
	          })
	        );
	      };
	
	      var checkHasAdded = function checkHasAdded() {
	        var result = false;
	        _this2.state.price.OrderEstimationRefinishTypeDetails.map(function (item) {
	          if (item.PaintLineId === null) result = true;
	        });
	        return result;
	      };
	
	      var price = this.state.price;
	      var accordions = this.state.accordions;
	
	
	      if (this.props.editable === false && price.OrderEstimationRefinishTypeDetails.length === 0) return null;
	      if (!this.props.editable && this.props.renderReport !== true && !checkHasAdded()) return null;
	
	      return _react2.default.createElement(
	        'li',
	        { key: Math.random() },
	        _react2.default.createElement(
	          'div',
	          { onClick: this.toggleOpen.bind(this, 'refinish' + 1) },
	          _react2.default.createElement(
	            'strong',
	            { className: 'estimation-accordion__title' },
	            (0, _helpers.translation)('161')
	          )
	        ),
	        !accordions['refinish' + 1] && renderPickerRefinish(RefinishTypes, price),
	        accordions['refinish' + 1] && RefinishTypes.map(function (item, index) {
	          return _this2.renderRefinishType(null, item, index);
	        })
	      );
	    }
	  }, {
	    key: 'renderStartTimes',
	    value: function renderStartTimes(type, reportLine, item, key) {
	      var _this3 = this;
	
	      if (!reportLine) reportLine = { LineId: null };
	      var toggleItem = function toggleItem(e) {
	        if (_this3.props.editable !== true) return;
	        var price = _extends({}, _this3.state.price);
	        if (e.target.checked) {
	          price.OrderEstimationStartTimeDetails.push({
	            EstimationStartTimeId: item.EstimationStartTimeId,
	            PaintLineId: reportLine.LineId
	          });
	        } else {
	          price.OrderEstimationStartTimeDetails.map(function (val) {
	            if (val.EstimationStartTimeId === item.EstimationStartTimeId && val.PaintLineId === reportLine.LineId) {
	              val.IsDeleted = true;
	            }
	          });
	        }
	        _this3.props.saveOrderPrice(price);
	      };
	      // Checked
	      var checked = false;
	      var price = this.state.price;
	
	      price.OrderEstimationStartTimeDetails.map(function (val) {
	        if (val.EstimationStartTimeId === item.EstimationStartTimeId && val.PaintLineId === reportLine.LineId) {
	          checked = true;
	        }
	      });
	      return _react2.default.createElement(_check2.default, { key: key, labelText: item.Type + ' (' + item.Ae + ' ' + (0, _helpers.translation)(885) + ')', id: 'StartTime_' + type + '_' + item.EstimationStartTimeId, name: 'StartTime', checked: checked, value: item.EstimationStartTimeId, onChange: toggleItem });
	    }
	  }, {
	    key: 'renderStartTimeAccordion',
	    value: function renderStartTimeAccordion(StartTimes) {
	      var _this4 = this;
	
	      var renderPickedStartTime = function renderPickedStartTime(startTimes, price) {
	        if (price.OrderEstimationStartTimeDetails.length === 0) return null;
	
	        var picked = startTimes.filter(function (st) {
	          var stId = st.EstimationStartTimeId;
	
	          return !!price.OrderEstimationStartTimeDetails.find(function (std) {
	            return std.PaintLineId === null && std.EstimationStartTimeId === stId;
	          });
	        });
	        if (!picked) return null;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          picked.map(function (p, key) {
	            return _react2.default.createElement(
	              'div',
	              { key: key, className: 'picked starttime clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                p.Type
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                '(',
	                p.Ae,
	                ' ',
	                (0, _helpers.translation)(885),
	                ')'
	              )
	            );
	          })
	        );
	      };
	
	      var checkHasAdded = function checkHasAdded() {
	        var result = false;
	        _this4.state.price.OrderEstimationStartTimeDetails.map(function (item) {
	          if (item.PaintLineId === null) result = true;
	        });
	        return result;
	      };
	
	      var price = this.state.price;
	      var accordions = this.state.accordions;
	
	      if (!this.props.editable && price.OrderEstimationStartTimeDetails.length === 0) return null;
	      if (!this.props.editable && this.props.renderReport !== true && !checkHasAdded()) return null;
	      return _react2.default.createElement(
	        'li',
	        { key: Math.random() },
	        _react2.default.createElement(
	          'div',
	          { onClick: this.toggleOpen.bind(this, 'starttime1') },
	          _react2.default.createElement(
	            'strong',
	            { className: 'estimation-accordion__title' },
	            (0, _helpers.translation)('1195')
	          )
	        ),
	        !accordions.starttime1 && renderPickedStartTime(StartTimes, price),
	        accordions.starttime1 && StartTimes.map(this.renderStartTimes.bind(this, null, null))
	      );
	    }
	  }, {
	    key: 'renderHourPrices',
	    value: function renderHourPrices(report, item, key) {
	      var _this5 = this;
	
	      var toggleItem = function toggleItem(e) {
	        var price = _extends({}, _this5.state.price);
	        price.OrderEstimationHourPriceDetails.map(function (val) {
	          val.IsDeleted = true;
	        });
	        if (e.target.checked) {
	          if (!report) report = { ReportId: null };
	
	          price.OrderEstimationHourPriceDetails.push({
	            EstimationHourPriceId: item.EstimationHourPriceId,
	            ReportId: report.ReportId
	          });
	        }
	        _this5.props.saveOrderPrice(price);
	      };
	      // Checked
	      var checked = false;
	      var price = this.state.price;
	
	      price.OrderEstimationHourPriceDetails.map(function (val) {
	        if (val.EstimationHourPriceId === item.EstimationHourPriceId) {
	          checked = true;
	        }
	      });
	      return _react2.default.createElement(_check2.default, { key: key, labelText: '' + item.Price, id: 'HourPrice_' + item.Price, name: 'HourPrice', checked: checked, value: item.EstimationHourPriceId, onChange: toggleItem });
	    }
	  }, {
	    key: 'renderHourlyRateAccordion',
	    value: function renderHourlyRateAccordion(HourPrices) {
	      var _this6 = this;
	
	      var price = this.state.price;
	      var accordions = this.state.accordions;
	
	
	      var renderPickedHourlyPrice = function renderPickedHourlyPrice(hourPrices, price) {
	        if (price.OrderEstimationHourPriceDetails.length === 0) return null;
	
	        var picked = hourPrices.find(function (hp) {
	          return hp.EstimationHourPriceId === price.OrderEstimationHourPriceDetails[0].EstimationHourPriceId;
	        });
	
	        if (!picked) return null;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'picked hourlyprice clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            picked.Price,
	            ' ',
	            _this6.props.currencyCode
	          )
	        );
	      };
	
	      if (this.props.editable === false && price.OrderEstimationHourPriceDetails.length === 0) return null;
	      return _react2.default.createElement(
	        'li',
	        { key: Math.random() },
	        _react2.default.createElement(
	          'div',
	          { onClick: this.toggleOpen.bind(this, 'hourlyprice') },
	          _react2.default.createElement(
	            'strong',
	            { className: 'estimation-accordion__title' },
	            (0, _helpers.translation)('419')
	          )
	        ),
	        !accordions.hourlyprice && renderPickedHourlyPrice(HourPrices, price),
	        accordions.hourlyprice && _react2.default.createElement(
	          'div',
	          { className: 'radio__wrapper' },
	          HourPrices.map(this.renderHourPrices.bind(this, null))
	        )
	      );
	    }
	  }, {
	    key: 'renderMaterialShare',
	    value: function renderMaterialShare(reportLine, item, key) {
	      var _this7 = this;
	
	      var toggleItem = function toggleItem(e) {
	        var price = _this7.state.price;
	
	        price.OrderEstimationMaterialsShareDetails.map(function (val) {
	          val.IsDeleted = true;
	        });
	        if (e.target.checked) {
	          if (!reportLine) reportLine = { LineId: null };
	
	          price.OrderEstimationMaterialsShareDetails.push({
	            EstimationMaterialsShareId: item.EstimationMaterialsShareId,
	            PaintLineId: reportLine.LineId
	          });
	        }
	        _this7.props.saveOrderPrice(price);
	      };
	      // Checked
	      var checked = false;
	      this.state.price.OrderEstimationMaterialsShareDetails.map(function (val) {
	        if (val.EstimationMaterialsShareId === item.EstimationMaterialsShareId) {
	          checked = true;
	        }
	      });
	      return _react2.default.createElement(_check2.default, { key: key, labelText: '' + item.Share, id: 'MaterialIdx_' + item.Share, name: 'MaterialShare', checked: checked, value: item.EstimationMaterialsShareId, onChange: toggleItem });
	    }
	  }, {
	    key: 'renderMaterialIndexAccordion',
	    value: function renderMaterialIndexAccordion(MaterialsShares) {
	      var price = this.state.price;
	      var accordions = this.state.accordions;
	
	
	      var renderPickedMaterialIndex = function renderPickedMaterialIndex(materialsShares, price) {
	        if (price.OrderEstimationMaterialsShareDetails.length === 0) return null;
	
	        var picked = materialsShares.find(function (ms) {
	          return ms.EstimationMaterialsShareId === price.OrderEstimationMaterialsShareDetails[0].EstimationMaterialsShareId;
	        });
	
	        if (!picked) return null;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'picked matindex clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            picked.Share,
	            '%'
	          )
	        );
	      };
	
	      if (this.props.editable === false && price.OrderEstimationMaterialsShareDetails.length === 0) return null;
	      return _react2.default.createElement(
	        'li',
	        { key: Math.random() },
	        _react2.default.createElement(
	          'div',
	          { onClick: this.toggleOpen.bind(this, 'materialshare') },
	          _react2.default.createElement(
	            'strong',
	            { className: 'estimation-accordion__title' },
	            (0, _helpers.translation)('415')
	          )
	        ),
	        !accordions.materialshare && renderPickedMaterialIndex(MaterialsShares, price),
	        accordions.materialshare && _react2.default.createElement(
	          'div',
	          { className: 'radio__wrapper' },
	          MaterialsShares.map(this.renderMaterialShare.bind(this, null))
	        )
	      );
	    }
	  }, {
	    key: 'renderPickedHourlyPrice',
	    value: function renderPickedHourlyPrice() {
	      var _this8 = this;
	
	      if (this.state.price.OrderEstimationHourPriceDetails.length !== 0) {
	        var item = this.state.partTasks === undefined ? [] : this.state.partTasks.HourPrices.filter(function (val) {
	          if (val.EstimationHourPriceId === _this8.state.price.OrderEstimationHourPriceDetails[0].EstimationHourPriceId) {
	            return true;
	          }
	        });
	        if (item.length === 0) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'picked hourlyprice clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            item[0].Price,
	            ' ',
	            this.props.currencyCode
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderPickedMaterialIndex',
	    value: function renderPickedMaterialIndex() {
	      var _this9 = this;
	
	      if (this.state.price.OrderEstimationMaterialsShareDetails.length !== 0) {
	        var item = this.state.partTasks === undefined ? [] : this.state.partTasks.MaterialsShares.filter(function (val) {
	          if (val.EstimationMaterialsShareId === _this9.state.price.OrderEstimationMaterialsShareDetails[0].EstimationMaterialsShareId) {
	            return true;
	          }
	        });
	        if (item.length === 0) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'picked matindex clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            item[0].Share,
	            ' %'
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderRefinishType',
	    value: function renderRefinishType(methodID, item, key) {
	      var _this10 = this;
	
	      var toggleItem = function toggleItem(e) {
	        var price = _extends({}, _this10.state.price);
	        if (e.target.checked) {
	          price.OrderEstimationRefinishTypeDetails.push({
	            EstimationRefinishTypeId: item.EstimationRefinishTypeId,
	            PaintLineId: methodID
	          });
	        } else {
	          price.OrderEstimationRefinishTypeDetails.map(function (val) {
	            if (val.EstimationRefinishTypeId === item.EstimationRefinishTypeId && val.PaintLineId === methodID) {
	              val.IsDeleted = true;
	            }
	          });
	        }
	        _this10.props.saveOrderPrice(price);
	      };
	      // Checked
	      var checked = false;
	      var price = this.state.price;
	
	      price.OrderEstimationRefinishTypeDetails.map(function (val) {
	        if (val.EstimationRefinishTypeId === item.EstimationRefinishTypeId && val.PaintLineId === methodID) {
	          checked = true;
	        }
	      });
	      return _react2.default.createElement(_check2.default, { key: key, labelText: item.Type, id: 'RefinishType_' + methodID + '_' + item.EstimationRefinishTypeId, name: 'RefinishType', checked: checked, value: item.EstimationRefinishTypeId, onChange: toggleItem.bind(this) });
	    }
	  }, {
	    key: 'renderForForsi',
	    value: function renderForForsi() {
	      var _this11 = this;
	
	      var shouldRenderStrikeThrough = function shouldRenderStrikeThrough(type, key) {
	        var found = false;
	        switch (type) {
	          case 'refinish':
	            _this11.state.price.OrderEstimationRefinishTypeDetails.map(function (val) {
	              if (val.PaintLineId === key) {
	                found = true;
	              }
	            });
	            break;
	          case 'starttime':
	            _this11.state.price.OrderEstimationStartTimeDetails.map(function (val) {
	              if (val.ReportLineSubType === key) {
	                found = true;
	              }
	            });
	            break;
	          case 'materialshare':
	            if (_this11.state.price.OrderEstimationMaterialsShareDetails.length !== 0) found = true;
	            break;
	          case 'hourlyprice':
	            if (_this11.state.price.OrderEstimationHourPriceDetails.length !== 0) found = true;
	            break;
	        }
	
	        return found;
	        // if (found) {
	        //   return <div className='strike_through' />
	        // }
	        // return null
	      };
	
	      var renderPickedStartTime = function renderPickedStartTime(id) {
	        if (_this11.state.price.OrderEstimationStartTimeDetails.length !== 0) {
	          var picked = JSON.parse(JSON.stringify(_this11.state.price.OrderEstimationStartTimeDetails)).filter(function (val) {
	            return val.ReportLineSubType === id;
	          });
	          if (picked.length === 0) return null;
	          var renderItem = function renderItem(v, k) {
	            var item = _this11.state.partTasks === undefined ? [] : _this11.state.partTasks.StartTimes.filter(function (val) {
	              return val.EstimationStartTimeId === v.EstimationStartTimeId;
	            });
	            if (item.length === 0) return null;
	            return _react2.default.createElement(
	              'div',
	              { className: 'picked starttime clearfix', key: k },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                item[0].Type
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                item[0].Ae + ' ' + (0, _helpers.translation)(885)
	              )
	            );
	          };
	          return _react2.default.createElement(
	            'div',
	            null,
	            picked.map(renderItem)
	          );
	        }
	        return null;
	      };
	
	      var renderMethod = function renderMethod(item, key) {
	        var _state = _this11.state,
	            price = _state.price,
	            partTasks = _state.partTasks,
	            accordions = _state.accordions;
	
	        var renderPickerRefinish = function renderPickerRefinish(methodID) {
	          if (price.OrderEstimationRefinishTypeDetails.length !== 0) {
	            var picked = price.OrderEstimationRefinishTypeDetails.filter(function (val) {
	              return val.PaintLineId === methodID;
	            });
	            if (picked.length === 0) return null;
	            var renderPicked = function renderPicked(val, k) {
	              var item = partTasks === undefined ? [] : partTasks.RefinishTypes.filter(function (v) {
	                return v.EstimationRefinishTypeId === val.EstimationRefinishTypeId;
	              });
	              if (item.length === 0) return null;
	              return _react2.default.createElement(
	                'div',
	                { key: k },
	                item[0].Type
	              );
	            };
	            return _react2.default.createElement(
	              'div',
	              null,
	              picked.map(renderPicked)
	            );
	          }
	          return null;
	        };
	
	        var methodClasses = shouldRenderStrikeThrough('refinish', item.LineId) ? 'estimation-extents__forsi-method--strike_through' : '';
	        return _react2.default.createElement(
	          'li',
	          { className: methodClasses, key: Math.random() },
	          _react2.default.createElement(_ForsiLine2.default, { method: { Name: item.LineText, Code: item.LineNumber, AE: item.WorkUnits }, onClick: _this11.toggleOpen.bind(_this11, 'refinish' + key) }),
	          !accordions['refinish' + key] && renderPickerRefinish(item.LineId),
	          accordions['refinish' + key] && partTasks.RefinishTypes.map(function (item, index) {
	            return _this11.renderRefinishType(item.LineId, item, index);
	          })
	        );
	      };
	
	      var renderPart = function renderPart(item) {
	        // console.log('renderPart: ', item)
	        var extraCSS = _this11.state.activeTaskId === item.LineId ? 'active' : '';
	        var onClick = function onClick() {
	          var taskId = _this11.state.activeTaskId === 0 || _this11.state.activeTaskId !== item.LineId ? item.LineId : 0;
	          _this11.setState({
	            activeTaskId: taskId
	          });
	          // Call event to store ID until something is added
	          _events2.default.emit('pricecalc_activeitem', taskId);
	        };
	        var renderSelectedItem = function renderSelectedItem(getBack) {
	          var items = [];
	          _this11.state.price.Parts.map(function (val) {
	            val.EstimationTasks.map(function (v) {
	              if (v.PaintLineId === item.LineId) {
	                items.push(v);
	              }
	            });
	          });
	          if (getBack) return items.length;
	          if (items.length === 0) return null;
	
	          return _react2.default.createElement(
	            'ul',
	            { className: 'selectedItem added' },
	            items.map(function (item, k) {
	              return _react2.default.createElement(_EstimationLine2.default, {
	                key: k + '_' + item.OrderEstimationTaskId,
	                orderEstimationTask: item,
	                onDelete: _this11.props.editable !== true ? undefined : _this11.props.onDelete && _this11.props.onDelete.bind(_this11, item.OrderEstimationTaskId),
	                currencyCode: _this11.props.currencyCode
	              });
	            })
	          );
	        };
	
	        var hasSelectedItems = renderSelectedItem(true) !== 0;
	        if (extraCSS !== '' && hasSelectedItems) {
	          onClick();
	        }
	        if (hasSelectedItems) {
	          extraCSS += ' estimation-extents__forsi-part--strike_through';
	        }
	
	        var showAE = _this11.props.order && _this11.props.order.ShowAE;
	        var showPrices = _this11.props.order && _this11.props.order.ShowPrices;
	
	        return _react2.default.createElement(
	          'li',
	          { key: Math.random(), className: 'clearfix ' + extraCSS, onClick: hasSelectedItems ? null : onClick },
	          _react2.default.createElement(_AssesmentForsiLine2.default, { line: item, currencyCode: _this11.props.currencyCode, showAE: showAE, showPrices: showPrices }),
	          hasSelectedItems && _react2.default.createElement('div', { className: 'strike_through' }),
	          renderSelectedItem()
	        );
	      };
	
	      var REPORT_GENERIC_LINETYPE = 0;
	      var REPORT_WORK_LINETYPE = 1;
	      var REPORT_STARTTIME_LINETYPE = 4;
	
	      var REPORT_MATERIALINDEX_LINESUBTYPE = 1;
	      var REPORT_REFINISH_LINESUBTYPE = 6;
	
	      var renderStarttime = function renderStarttime(number) {
	        var startTimeLines = _this11.state.price.Report.Paint.Lines.filter(function (l) {
	          return l.LineType === REPORT_STARTTIME_LINETYPE && l.LineSubType === number;
	        });
	        if (startTimeLines.length === 0) return;
	
	        // For now assume max one starttime line for each type, so we just take the first.
	        var reportStartTimeLine = startTimeLines[0];
	        var startTimeValue = reportStartTimeLine.WorkUnits;
	        var startTimeName = reportStartTimeLine.LineText;
	
	        var startTimeClasses = shouldRenderStrikeThrough('starttime', number) ? ' strike_through' : '';
	
	        return _react2.default.createElement(
	          'li',
	          { className: 'estimation-starttime-grouping', key: 'starttime_type_' + number },
	          _react2.default.createElement(
	            'div',
	            { className: 'estimation-accordion-line', onClick: _this11.toggleOpen.bind(_this11, 'starttime' + number) },
	            _react2.default.createElement(
	              'strong',
	              { className: 'estimation-accordion__title' },
	              startTimeName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'estimation-accordion__value' + startTimeClasses },
	              startTimeValue || 0,
	              ' ',
	              (0, _helpers.translation)('885')
	            )
	          ),
	          !_this11.state.accordions['starttime' + number] && renderPickedStartTime(number),
	          _this11.state.accordions['starttime' + number] && (_this11.state.partTasks === undefined ? null : _this11.state.partTasks.StartTimes.map(_this11.renderStartTimes.bind(_this11, number, reportStartTimeLine)))
	        );
	      };
	
	      var hourlyPriceClasses = shouldRenderStrikeThrough('hourlyprice') ? ' strike_through' : '';
	      var materialShareClasses = shouldRenderStrikeThrough('materialshare') ? ' strike_through' : '';
	
	      var css = 'forsiExtent';
	      if (this.props.editable !== true) css += ' show';
	
	      var reportWorkLines = void 0;
	      var reportRefinishLines = void 0;
	      var reportMaterialIndexLines = void 0;
	      var startTimeTypes = void 0;
	      var hourPrice = void 0;
	
	      if (this.state.price.Report.Paint) {
	        var _state$price$Report$P = this.state.price.Report.Paint,
	            Lines = _state$price$Report$P.Lines,
	            HourPrice = _state$price$Report$P.HourPrice;
	
	
	        reportWorkLines = Lines.filter(function (l) {
	          return l.LineType === REPORT_WORK_LINETYPE;
	        });
	        reportRefinishLines = Lines.filter(function (l) {
	          return l.LineType === REPORT_GENERIC_LINETYPE && l.LineSubType === REPORT_REFINISH_LINESUBTYPE;
	        });
	        reportMaterialIndexLines = Lines.filter(function (l) {
	          return l.LineType === REPORT_GENERIC_LINETYPE && l.LineSubType === REPORT_MATERIALINDEX_LINESUBTYPE;
	        });
	        startTimeTypes = (0, _lodash.uniq)(Lines.filter(function (l) {
	          return l.LineType === REPORT_STARTTIME_LINETYPE;
	        }).map(function (l) {
	          return l.LineSubType;
	        }));
	        hourPrice = HourPrice;
	      }
	
	      var materialIndexLine = reportMaterialIndexLines && reportMaterialIndexLines.length > 0 ? reportMaterialIndexLines[0] : null;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: css },
	        reportWorkLines && reportWorkLines.map(renderPart),
	        reportRefinishLines && reportRefinishLines.length !== 0 ? reportRefinishLines.map(renderMethod) : this.renderPaintRefinishTypesAccordion(this.state.partTasks === undefined ? [] : this.state.partTasks.RefinishTypes),
	        startTimeTypes && startTimeTypes.map(function (t) {
	          return renderStarttime(t);
	        }),
	        _react2.default.createElement(
	          'li',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'estimation-accordion-line', onClick: this.toggleOpen.bind(this, 'hourlyprice') },
	            _react2.default.createElement(
	              'strong',
	              { className: 'estimation-accordion__title' },
	              (0, _helpers.translation)('419')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'estimation-accordion__value' + hourlyPriceClasses },
	              hourPrice || 0,
	              ' ',
	              this.props.currencyCode
	            )
	          ),
	          !this.state.accordions.hourlyprice && this.renderPickedHourlyPrice(),
	          this.state.accordions.hourlyprice && _react2.default.createElement(
	            'div',
	            { className: 'radio__custom__wrapper' },
	            this.state.partTasks === undefined ? null : this.state.partTasks.HourPrices.map(this.renderHourPrices.bind(this, this.state.price.Report))
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'estimation-accordion-line', onClick: this.toggleOpen.bind(this, 'materialshare') },
	            _react2.default.createElement(
	              'strong',
	              { className: 'estimation-accordion__title' },
	              (0, _helpers.translation)('415')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'estimation-accordion__value' + materialShareClasses },
	              materialIndexLine ? materialIndexLine.GenericValue : 0
	            )
	          ),
	          !this.state.accordions.materialshare && this.renderPickedMaterialIndex(),
	          this.state.accordions.materialshare && _react2.default.createElement(
	            'div',
	            { className: 'radio__custom__wrapper' },
	            this.state.partTasks === undefined ? null : this.state.partTasks.MaterialsShares.map(this.renderMaterialShare.bind(this, materialIndexLine))
	          )
	        ),
	        !this.props.editable && _react2.default.createElement(_divider2.default, null),
	        !this.props.editable && _react2.default.createElement(
	          'li',
	          { className: 'clearfix' },
	          _react2.default.createElement(_AssessmentReportSums2.default, { report: this.state.price.Report, department: this.state.price.Department, currencyCode: this.props.currencyCode, includeTotal: true })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var hasReport = this.state.price.Report !== null && this.state.price.Report.ReportId !== 0;
	      var css = 'forsiExtent';
	      if (this.props.editable !== true) css += ' show';
	      if (!this.state.partTasks || !this.state.price) return null;
	      if (this.state.price.Report && _typeof(this.state.price.Report) === 'object' && this.props.renderReport === true) {
	        return this.renderForForsi();
	      } else {
	        var _state$partTasks = this.state.partTasks,
	            RefinishTypes = _state$partTasks.RefinishTypes,
	            StartTimes = _state$partTasks.StartTimes,
	            HourPrices = _state$partTasks.HourPrices,
	            MaterialsShares = _state$partTasks.MaterialsShares;
	
	        return _react2.default.createElement(
	          'ul',
	          { className: css + ' added' },
	          RefinishTypes.length !== 0 && this.renderPaintRefinishTypesAccordion(RefinishTypes),
	          StartTimes.length !== 0 && this.renderStartTimeAccordion(StartTimes),
	          HourPrices.length !== 0 && !hasReport && this.renderHourlyRateAccordion(HourPrices),
	          MaterialsShares.length !== 0 && !hasReport && this.renderMaterialIndexAccordion(MaterialsShares)
	        );
	      }
	    }
	  }]);
	
	  return EstimationExtents;
	}(_react.Component);
	
	exports.default = EstimationExtents;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForsiLine = function (_Component) {
	  _inherits(ForsiLine, _Component);
	
	  function ForsiLine() {
	    _classCallCheck(this, ForsiLine);
	
	    return _possibleConstructorReturn(this, (ForsiLine.__proto__ || Object.getPrototypeOf(ForsiLine)).apply(this, arguments));
	  }
	
	  _createClass(ForsiLine, [{
	    key: 'renderPart',
	    value: function renderPart() {
	      var notation = (0, _helpers.translation)('885');
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.part.Method ? _react2.default.createElement(
	          _Line2.default,
	          { bold: true, text: this.props.part.Name },
	          _react2.default.createElement(_Line2.default, { text: this.props.part.Method, amount: this.props.part.AE, noFormat: true, currencyType: notation, subLine: true })
	        ) : _react2.default.createElement(_Line2.default, { boldText: true, text: this.props.part.Name, amount: this.props.part.AE, noFormat: true, currencyType: notation, subLine: true })
	      );
	    }
	  }, {
	    key: 'renderMethod',
	    value: function renderMethod() {
	      var _this2 = this;
	
	      var renderText = function renderText() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'text' },
	          _this2.props.method.Code && _react2.default.createElement(
	            'span',
	            { className: 'bold' },
	            _this2.props.method.Code,
	            ' '
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _this2.props.method.Name
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: this.props.onClick },
	        _react2.default.createElement(_Line2.default, { text: renderText })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.part) return this.renderPart();
	      if (this.props.method) return this.renderMethod();
	      return null;
	    }
	  }]);
	
	  return ForsiLine;
	}(_react.Component);
	
	exports.default = ForsiLine;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OtherDamageLine = function (_Component) {
	  _inherits(OtherDamageLine, _Component);
	
	  function OtherDamageLine() {
	    _classCallCheck(this, OtherDamageLine);
	
	    return _possibleConstructorReturn(this, (OtherDamageLine.__proto__ || Object.getPrototypeOf(OtherDamageLine)).apply(this, arguments));
	  }
	
	  _createClass(OtherDamageLine, [{
	    key: 'render',
	    value: function render() {
	      var damage = this.props.damage;
	      if (!damage) return null;
	
	      var damageName = void 0;
	      if (damage.Type === 10) {
	        damageName = damage.CustomName;
	      } else {
	        damageName = (0, _helpers.translation)((0, _helpers.enumtranslate)('OtherDamageTypes', damage.Type));
	      }
	
	      return _react2.default.createElement(_Line2.default, { text: damageName, onDelete: this.props.onDelete.bind(this, this.props.damage) });
	    }
	  }]);
	
	  return OtherDamageLine;
	}(_react.Component);
	
	exports.default = OtherDamageLine;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Part = __webpack_require__(152);
	
	var _Part2 = _interopRequireDefault(_Part);
	
	var _Photo = __webpack_require__(233);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _Comment = __webpack_require__(232);
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	var OtherDamages = function (_Component) {
	  _inherits(OtherDamages, _Component);
	
	  function OtherDamages(props) {
	    _classCallCheck(this, OtherDamages);
	
	    var _this = _possibleConstructorReturn(this, (OtherDamages.__proto__ || Object.getPrototypeOf(OtherDamages)).call(this, props));
	
	    _this.state = {
	      price: null,
	      order: null,
	      otherDamage: null
	    };
	
	    _this.setComment = _this.setComment.bind(_this);
	    return _this;
	  }
	
	  _createClass(OtherDamages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onRef(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onRef(undefined);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      var _this2 = this;
	
	      if (_typeof(next.orderPrice) !== 'object') return;
	
	      var price = next.orderPrice;
	      var otherDamage = this.findInactiveOtherDamage(price);
	
	      if (!otherDamage) {
	        otherDamage = {
	          Id: 0,
	          Active: false,
	          StepId: this.props.order.StepId
	        };
	
	        this.setState({
	          price: price,
	          otherDamage: otherDamage
	        }, function () {
	          _this2.savePrice();
	        });
	      } else {
	        this.setState({
	          price: price,
	          order: next.order,
	          otherDamage: otherDamage
	        });
	      }
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      if (this.props.orderPrice === null) return null;
	      return (0, _helpers.translation)('15188');
	    }
	  }, {
	    key: 'savePrice',
	    value: function savePrice() {
	      var price = this.state.price;
	      price.OtherDamages = [].concat(_toConsumableArray(price.OtherDamages), [this.state.otherDamage]);
	
	      return this.props.saveOrderPrice(price);
	    }
	  }, {
	    key: 'findInactiveOtherDamage',
	    value: function findInactiveOtherDamage(price) {
	      return price.OtherDamages.find(function (od) {
	        return !od.Active;
	      });
	    }
	  }, {
	    key: 'setComment',
	    value: function setComment(comment) {
	      var _this3 = this;
	
	      return new Promise(function (resolve) {
	        _this3.setState({
	          otherDamage: _extends({}, _this3.state.otherDamage, {
	            Comment: comment
	          })
	        }, function () {
	          _this3.savePrice().then(function () {
	            resolve();
	          });
	        });
	      });
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(part, damage) {
	      if (part && damage) {
	        part.OtherDamages.map(function (x) {
	          if (x.Id === damage.Id) x.IsDeleted = true;
	          return x;
	        });
	
	        this.state.price.Parts.map(function (x) {
	          if (x.Part.TaskSide === part.Part.TaskSide && x.Part.PartItemId === part.Part.PartItemId) x = part;
	          return x;
	        });
	
	        this.savePrice();
	      }
	    }
	  }, {
	    key: 'renderOtherDamage',
	    value: function renderOtherDamage() {
	      var _this4 = this;
	
	      var price = _extends({}, this.state.price);
	      var inactiveDmg = this.state.otherDamage; // this.findInactiveOtherDamage(price)
	      var filteredParts = price.Parts.reduce(function (filtered, part) {
	        var inactiveParts = part.OtherDamages.filter(function (od) {
	          return od.OtherDamageId === inactiveDmg.Id;
	        });
	
	        if (inactiveParts.length > 0) {
	          return [].concat(_toConsumableArray(filtered), [_extends({}, part, { OtherDamages: inactiveParts })]);
	        }
	        return filtered;
	      }, []);
	      var renderPart = function renderPart(part) {
	        return _react2.default.createElement(_Part2.default, {
	          key: 'part_' + part.Part.PartItemId + '_' + part.Part.TaskSide,
	          part: part,
	          onDelete: _this4.props.editable && _this4.onDelete.bind(_this4, part) });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('15188') }),
	        filteredParts.map(renderPart)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      if (!this.state.price || !this.state.order || !this.state.otherDamage) return null;
	
	      var goBack = function goBack() {
	        var price = _this5.state.price;
	        var hasDamages = false;
	        var validOtherDamage = _this5.state.otherDamage;
	        price.Parts.forEach(function (p) {
	          if (!hasDamages) {
	            hasDamages = !!p.OtherDamages.find(function (od) {
	              return od.OtherDamageId === validOtherDamage.Id;
	            });
	          }
	        });
	
	        if (price.Parts.length === 0 || !hasDamages) {
	          window.toastr.error((0, _helpers.translation)('15189'), (0, _helpers.translation)('216'));
	        } else {
	          var orderFileIds = [];
	          var inputs = document.getElementsByTagName('input');
	          for (var i = 0; i < inputs.length; i++) {
	            if (inputs[i].name === 'checkbox_image' && inputs[i].checked === true) {
	              orderFileIds.push(inputs[i].id);
	            }
	          }
	
	          _this5.props.UpdateOrderFileSelection({
	            OrderFileIds: orderFileIds,
	            Type: 7,
	            Step: _this5.state.order.StepId,
	            TypeId: _this5.state.otherDamage.Id
	          });
	
	          // this.ensureSaved().then(() => {
	          _this5.setState({
	            otherDamage: _extends({}, _this5.state.otherDamage, {
	              Active: true
	            })
	          }, function () {
	            _this5.savePrice().then(function () {
	              _this5.props.goBack();
	            });
	          });
	          // })
	        }
	      };
	
	      var comment = this.state.otherDamage.Comment;
	
	      var css = 'price__view';
	      if (this.props.editable) {
	        css += ' editable';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: css },
	        this.props.viewMode === 'mobile' && this.props.renderInside(),
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('889') }),
	        this.renderOtherDamage(),
	        _react2.default.createElement(_Photo2.default, {
	          saveOrder: this.props.saveOrder,
	          saveOrderPrice: this.props.saveOrderPrice,
	          orderPrice: this.state.price,
	          order: this.state.order,
	          loadOrder: this.props.loadOrder
	        }),
	        _react2.default.createElement(_Comment2.default, {
	          comment: comment,
	          changeSource: 19,
	          orderPriceId: this.state.price.OrderPriceId,
	          order: this.state.order,
	          setComment: this.setComment
	          // onRef={ref => {
	          //   this.ensureSaved = ref
	          // }}
	        }),
	        this.props.editable && _react2.default.createElement(_button2.default, { onClick: goBack, labelText: (0, _helpers.translation)('956') })
	      );
	    }
	  }]);
	
	  return OtherDamages;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  UpdateOrderFileSelection: _orders.UpdateOrderFileSelection
	})(OtherDamages);

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _OtherPriceModal = __webpack_require__(303);
	
	var _OtherPriceModal2 = _interopRequireDefault(_OtherPriceModal);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _backdrop = __webpack_require__(29);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	__webpack_require__(1524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	// import { formatCurrency } from '../../../../utils/currency'
	
	
	// Actions
	
	
	var Other = function (_Component) {
	  _inherits(Other, _Component);
	
	  function Other(props) {
	    _classCallCheck(this, Other);
	
	    var _this = _possibleConstructorReturn(this, (Other.__proto__ || Object.getPrototypeOf(Other)).call(this, props));
	
	    _this.state = {
	      showEditPopup: false
	    };
	
	    _this.editModalDisplayState = _this.editModalDisplayState.bind(_this);
	    return _this;
	  }
	
	  _createClass(Other, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onRef(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onRef(undefined);
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      var _this2 = this;
	
	      var showEditLink = this.props.showEditLink && this.props.order.OrderType === 4;
	      // let title = null
	      // let icon = null
	      // switch (this.props.order.OrderType) {
	      //   case 1:
	      //     title = translation(13360)
	      //     icon = '/images/svgs/ordrer/Insurance-black.svg'
	      //     break
	      //   case 2:
	      //     title = translation(71)
	      //     icon = '/images/svgs/ordrer/Salescar-black.svg'
	      //     break
	      //   case 3:
	      //     title = translation(13361)
	      //     icon = '/images/svgs/ordrer/Garanteed-black.svg'
	      //     break
	      //   case 4:
	      //     title = translation(73)
	      //     icon = '/images/svgs/ordrer/Other-black.svg'
	      //     break
	      //   case 6:
	      //     title = translation(785)
	      //     icon = '/images/svgs/ordrer/Private_c-black.svg'
	      //     break
	      // }
	
	      return function () {
	        return showEditLink && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't', ariaText: (0, _helpers.translation)('2706'), ariaPos: 'top', onClick: _this2.editModalDisplayState });
	        // return (
	        //   <div >
	        //     <div>
	        //       <img src={icon} className='subtitleIMG' />
	        //     </div>
	        //     {title}
	        //     {showEditLink && <div className='icon hint--top' aria-label={translation('2706')}><img src='/images/icons/edit_16.png' /></div>}
	        //   </div>
	        // )
	      };
	    }
	  }, {
	    key: 'editModalDisplayState',
	    value: function editModalDisplayState() {
	      // console.log('this.state.showEditPopup', this.state.showEditPopup)
	      this.props.triggerPopup(this.state.showEditPopup !== true);
	      this.setState({
	        showEditPopup: this.state.showEditPopup !== true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var beforeDiscountLabel = this.props.order.HasDiscount ? ' ' + (0, _helpers.translation)('15012') : '';
	
	      // Paint
	      var renderPriceAmount = function renderPriceAmount() {
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('641') + beforeDiscountLabel, amount: _this3.props.order.Price || 0 });
	      };
	
	      var renderEnvironmentAmount = function renderEnvironmentAmount() {
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('13339') + beforeDiscountLabel, amount: _this3.props.order.Environment || 0 });
	      };
	
	      // Body
	      var renderSparePartAmount = function renderSparePartAmount() {
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('637') + beforeDiscountLabel, amount: _this3.props.order.ManualBodySparePartPrice || 0 });
	      };
	
	      var renderMiscAmount = function renderMiscAmount() {
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('15154') + beforeDiscountLabel, amount: _this3.props.order.ManualBodyMiscPrice || 0 });
	      };
	
	      var renderWorkPriceAmount = function renderWorkPriceAmount() {
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('416') + beforeDiscountLabel, amount: _this3.props.order.ManualBodyWorkPrice || 0 });
	      };
	
	      var renderWorkEnvPriceAmount = function renderWorkEnvPriceAmount() {
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('15156') + beforeDiscountLabel, amount: _this3.props.order.ManualBodyWorkEnvPrice || 0 });
	      };
	
	      var renderTitle = function renderTitle() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'label',
	            null,
	            (0, _helpers.translation)('1206')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _this3.props.order.OtherTitle || ''
	          )
	        );
	      };
	
	      var renderDescription = function renderDescription() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'label',
	            null,
	            (0, _helpers.translation)('1021')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _this3.props.order.OtherDescription || ''
	          )
	        );
	      };
	
	      var showEditLink = this.props.showEditLink && this.props.order.OrderType === 4;
	      return _react2.default.createElement(
	        'div',
	        { className: 'extent_other' },
	        _react2.default.createElement(
	          'div',
	          { className: 'lines', onClick: showEditLink ? this.editModalDisplayState : undefined },
	          this.props.order.OrderType === 4 && renderTitle(),
	          this.props.order.OrderType === 4 && renderDescription(),
	          this.props.order.OrderType === 4 && _react2.default.createElement('div', { className: 'spacing triple' }),
	          this.props.department === 0 && renderPriceAmount(),
	          this.props.department === 0 && renderEnvironmentAmount(),
	          this.props.department === 1 && renderWorkPriceAmount(),
	          this.props.department === 1 && renderSparePartAmount(),
	          this.props.department === 1 && renderMiscAmount(),
	          this.props.department === 1 && renderWorkEnvPriceAmount()
	        ),
	        _react2.default.createElement(_OtherPriceModal2.default, {
	          type: 1,
	          show: this.state.showEditPopup,
	          onClose: this.editModalDisplayState,
	          other: {
	            Title: this.props.order.OtherTitle,
	            Description: this.props.order.OtherDescription,
	            Price: this.props.order.Price,
	            Environment: this.props.order.Environment
	          },
	          bodyShopPrice: {
	            ManualBodySparePartPrice: this.props.order.ManualBodySparePartPrice,
	            ManualBodyMiscPrice: this.props.order.ManualBodyMiscPrice,
	            ManualBodyWorkPrice: this.props.order.ManualBodyWorkPrice,
	            ManualBodyWorkEnvPrice: this.props.order.ManualBodyWorkEnvPrice
	          },
	          order: this.props.order,
	          saveOrder: this.props.saveOrder,
	          department: this.props.department })
	      );
	    }
	  }]);
	
	  return Other;
	}(_react.Component);
	
	Other.propTypes = {
	  order: _react2.default.PropTypes.object.isRequired,
	  editable: _react2.default.PropTypes.bool.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { triggerPopup: _backdrop.triggerPopup })(Other);

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Part = __webpack_require__(152);
	
	var _Part2 = _interopRequireDefault(_Part);
	
	var _Line = __webpack_require__(81);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _PriceLine = __webpack_require__(439);
	
	var _PriceLine2 = _interopRequireDefault(_PriceLine);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _PriceApprovalModal = __webpack_require__(304);
	
	var _PriceApprovalModal2 = _interopRequireDefault(_PriceApprovalModal);
	
	var _ConfirmPricechanges = __webpack_require__(430);
	
	var _ConfirmPricechanges2 = _interopRequireDefault(_ConfirmPricechanges);
	
	var _Photo = __webpack_require__(233);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _Comment = __webpack_require__(232);
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _auth = __webpack_require__(8);
	
	var _icons = __webpack_require__(6);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	__webpack_require__(1528);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import DropDown from '../../../elements/dropDown'
	
	
	// import Text from '../../../elements/text'
	
	var Price = function (_Component) {
	  _inherits(Price, _Component);
	
	  function Price(props) {
	    _classCallCheck(this, Price);
	
	    var _this = _possibleConstructorReturn(this, (Price.__proto__ || Object.getPrototypeOf(Price)).call(this, props));
	
	    _this.state = {
	      showNet: false,
	      isLoosePart: false,
	      newTask: {
	        TaskPriceId: 0,
	        BodyTaskPriceId: 0,
	        OrderTaskId: 0,
	        PartItemId: 0,
	        TaskName: ''
	      },
	      hasChanged: false,
	      initialTaskCount: null,
	      visibleGroups: {
	        gross1: false,
	        gross2: false,
	        total: false
	      },
	      gross_shop_radio: 'DiscountShop',
	      gross_customer_radio: 'DiscountCustomer',
	      // shopMustApprove: null,
	      confirmDialog: {
	        open: false
	        // noApproval: false
	      }
	    };
	
	    _this.saveOrderPrice = _this.saveOrderPrice.bind(_this);
	    _this.resetNewItem = _this.resetNewTask.bind(_this);
	    _this.changeValue = _this.changeValue.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.backToWorkcard = _this.backToWorkcard.bind(_this);
	    return _this;
	  }
	
	  _createClass(Price, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onRef(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onRef(undefined);
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(1396);
	      }
	      switch (this.props.order.OrderType) {
	        case 2:
	          return (0, _helpers.translation)(71);
	        case 3:
	          return (0, _helpers.translation)(13361);
	        case 6:
	          return (0, _helpers.translation)(785);
	      }
	      return 'No title';
	    }
	  }, {
	    key: 'getTitleAria',
	    value: function getTitleAria() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return (0, _helpers.translation)(34) + ' ' + (0, _helpers.translation)(1396);
	      }
	      return (0, _helpers.translation)(2705);
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      if (this.props.orderPrice === null) return null;
	      if (this.props.orderPrice.IsAddonPrice) {
	        return '/images/svgs/taksering/Additional-sales-new.svg';
	      }
	      switch (this.props.order.OrderType) {
	        case 2:
	          return '/images/svgs/ordrer/Salescar-black.svg';
	        case 3:
	          return '/images/svgs/ordrer/Garanteed-black.svg';
	        case 6:
	          return '/images/svgs/ordrer/Private_c-black.svg';
	      }
	      return null;
	    }
	  }, {
	    key: 'getEditUrl',
	    value: function getEditUrl() {
	      if (this.props.order !== null && this.props.department === 0 && this.props.order.IsAssessmentOk === true || this.props.department === 1 && this.props.order.IsBodyShopAssessmentOk) return null;
	      // if (this.props.order !== null && this.props.order.IsReferredIn === true) return null
	      if (this.props.orderPrice === null) return null;
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return null;
	      if (this.props.order !== null && ((0, _auth.hasAccess)([4], this.props.auth.user.UserType) || (0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType) && this.props.auth.user.DepartmentType === 1) && this.props.order.IsDraft !== true && this.props.orderPrice.Department === 0) return null;
	      if (this.props.orderPrice.Department === 1) {
	        return '/pricecalculation/' + this.props.order.Id + '/bodyextent';
	      }
	      return '/pricecalculation/' + this.props.order.Id + '/1';
	    }
	  }, {
	    key: 'resetNewTask',
	    value: function resetNewTask() {
	      this.setState({
	        newTask: {
	          TaskPriceId: 0,
	          BodyTaskPriceId: 0,
	          OrderTaskId: 0,
	          PartItemId: 0,
	          TaskName: ''
	        }
	      });
	    }
	
	    /**
	     * Change value, and save orderprice
	     * @param {object} args Object in the format: { name, value }
	     */
	
	  }, {
	    key: 'changeValue',
	    value: function changeValue(args) {
	      var _this2 = this;
	
	      var orderPrice = this.props.orderPrice;
	      if (orderPrice[args.name] === args.value) return;
	
	      var state = this.state;
	      switch (args.name) {
	        case 'Net':
	          orderPrice.CustomerNetOrDiscount = 1;
	          state.gross_shop_radio = args.name;
	          break;
	        case 'DiscountShop':
	          orderPrice.CustomerNetOrDiscount = 0;
	          state.gross_shop_radio = args.name;
	          break;
	        case 'NetCustomer':
	          orderPrice.CustomerNetOrDiscount = 1;
	          state.gross_customer_radio = args.name;
	          break;
	        case 'DiscountCustomer':
	          orderPrice.CustomerNetOrDiscount = 0;
	          state.gross_customer_radio = args.name;
	          break;
	        case 'Total':
	          orderPrice.HoldTotal = true;
	          break;
	      }
	      this.setState({
	        gross_shop_radio: state.gross_shop_radio,
	        gross_customer_radio: state.gross_customer_radio
	      }, function () {
	        orderPrice[args.name] = args.value;
	        _this2.saveOrderPrice(orderPrice);
	      });
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      // console.log('radio change', e.target.name, e.target.value)
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var orderPrice = newProps.orderPrice;
	
	      this.setState({
	        isLoosePart: orderPrice ? orderPrice.IsLoosePart : false,
	        visibleGroups: _extends({}, this.state.visibleGroups, {
	          gross1: newProps.showNet
	        })
	      });
	    }
	  }, {
	    key: 'saveOrderPrice',
	    value: function saveOrderPrice(orderPrice) {
	      var stripTasks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var _this3 = this;
	
	      var stripExtras = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var stripServices = arguments[3];
	
	      return new Promise(function (resolve, reject) {
	        if (_this3.displayOnly()) {
	          resolve();
	          return;
	        }
	        orderPrice.IsLoosePart = _this3.state.isLoosePart;
	
	        if (stripTasks) {
	          orderPrice.Parts = [];
	        }
	
	        if (stripExtras) {
	          orderPrice.Extras = [];
	        }
	
	        if (stripServices) {
	          orderPrice.Services = [];
	        }
	        if (!_this3.props.isCustomer) {
	          switch (_this3.state.gross_shop_radio) {
	            case 'DiscountShop':
	              orderPrice.CustomerNetOrDiscount = 0;
	              break;
	            case 'Net':
	              orderPrice.CustomerNetOrDiscount = 1;
	              break;
	          }
	        } else {
	          switch (_this3.state.gross_customer_radio) {
	            case 'DiscountCustomer':
	              orderPrice.CustomerNetOrDiscount = 0;
	              break;
	            case 'NetCustomer':
	              orderPrice.CustomerNetOrDiscount = 1;
	              break;
	          }
	        }
	        // console.log('orderPrice', this.state.gross_shop_radio, '---> CustomerNetOrDiscount', orderPrice.CustomerNetOrDiscount)
	        _this3.props.saveOrderPrice(orderPrice).then(function (res) {
	          _this3.resetNewTask();
	          resolve(res);
	          return;
	        }, function (err) {
	          reject(err);
	          return;
	        });
	      });
	    }
	  }, {
	    key: 'displayOnly',
	    value: function displayOnly() {
	      var result = !this.props.editable || this.props.orderPrice.HasAwaiting === true;
	      return result;
	    }
	  }, {
	    key: 'allowEdit',
	    value: function allowEdit() {
	      var result = !this.displayOnly() && (!this.props.isCustomer || this.props.order.IsDraft);
	      return result;
	    }
	
	    // Back to workcard function
	
	  }, {
	    key: 'backToWorkcard',
	    value: function backToWorkcard(skipPriceChangeCheck) {
	      var _this4 = this;
	
	      var orderPrice = this.props.orderPrice;
	      var confirmChangeAndGoBack = function confirmChangeAndGoBack() {
	        if (!_this4.props.order.IsDraft /* && !orderPrice.IsAddonPrice */) {
	            // let noApproval = false
	            // if (!orderPrice.RequireShopApproval && orderPrice.HasChanged) {
	            //   noApproval = true
	            // }
	            if (orderPrice.RequireShopApproval /* || orderPrice.HasChanged */) {
	                _this4.setState({
	                  // shopMustApprove: true,
	                  confirmDialog: {
	                    // mustApprove: true,
	                    open: true
	                    // noApproval: noApproval
	                  }
	                });
	              } else {
	              _this4.props.goBack();
	            }
	          } else {
	          _this4.props.goBack();
	        }
	      };
	
	      if (!this.displayOnly()) {
	        setTimeout(function () {
	          // Price/price changes
	          var orderPrice = _this4.props.orderPrice;
	          if (orderPrice.RequireShopApproval) {
	            // priceObj.SendToApproval = true
	          }
	          _this4.saveOrderPrice(orderPrice).then(function () {
	            confirmChangeAndGoBack();
	          });
	        }, 800);
	      } else {
	        this.props.goBack();
	      }
	    }
	  }, {
	    key: 'renderConfirm',
	    value: function renderConfirm() {
	      var _this5 = this;
	
	      var onClose = function onClose() {
	        var goBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        _this5.setState({
	          confirmDialog: _extends({}, _this5.state.confirmDialog, {
	            open: false
	          })
	        });
	        if (goBack) _this5.props.goBack();
	      };
	
	      // console.log('renderConfirm', this.state.confirmDialog, this.props.orderPrice.RequireCustomerApproval, this.props.orderPrice.RequireShopApproval)
	      if (this.state.confirmDialog.open) {
	        if (this.props.orderPrice.RequireShopApproval) {
	          return _react2.default.createElement(_PriceApprovalModal2.default, { orderId: this.props.order.Id, show: this.state.confirmDialog.open && this.props.orderPrice.RequireShopApproval === true, closeModal: onClose.bind(this, false), overflowHidden: false });
	        } else {
	          return _react2.default.createElement(
	            _Portal2.default,
	            { className: 'confirm_popup', onPortalClose: function onPortalClose() {
	                return;
	              } },
	            _react2.default.createElement(_ConfirmPricechanges2.default, { changes: this.props.orderPrice.RequireCustomerApproval, confirm: onClose.bind(this) })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'renderOkButton',
	    value: function renderOkButton() {
	      var orderPrice = this.props.orderPrice;
	      // console.log('renderOkButton', orderPrice.RequireApproval, orderPrice.HasAwaiting)
	      if (orderPrice.RequireApproval) {
	        return _react2.default.createElement(_button2.default, { onClick: this.backToWorkcard.bind(this), labelText: (0, _helpers.translation)('791') });
	      } else if (orderPrice.HasAwaiting) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'spacing' },
	          (0, _helpers.translation)('1320'),
	          ' ',
	          (0, _time.renderFullDate)(orderPrice.CreatedDate, true)
	        );
	      } else {
	        return _react2.default.createElement(_button2.default, { onClick: this.backToWorkcard.bind(this), labelText: (0, _helpers.translation)('956') });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      // let isCustomer = this.props.isCustomer
	      var orderPrice = null;
	      if (this.props.orderPrice) {
	        orderPrice = _extends({}, this.props.orderPrice);
	      }
	
	      if (orderPrice === undefined || orderPrice === null) return null;
	      var toggleNet = function toggleNet() {
	        _this6.setState({ showNet: !_this6.state.showNet });
	      };
	      var renderInnerTitle = function renderInnerTitle() {
	        var showPrices = _this6.props.order.ShowPrices || _this6.props.editable;
	        var canToggleNet = _this6.props.orderPrice.Department === 0 && showPrices;
	        // let netGrossTxt = this.state.showNet ? translation('13351') : translation('13350')
	        var title = ''; // translation(889)
	        if (_this6.props.overrideInnerTitle !== null) {
	          title = _this6.props.overrideInnerTitle;
	        }
	        return (
	          // <div className='h-line title'>
	          _react2.default.createElement(
	            'div',
	            null,
	            title,
	            canToggleNet && _react2.default.createElement(_check2.default, { checked: _this6.state.showNet, onChange: toggleNet, labelText: (0, _helpers.translation)('13351') })
	          )
	        );
	      };
	
	      /**
	       * Sets IsDeleted of an item
	       * @param {object} item
	       */
	      var onDelete = function onDelete(item) {
	        if (_this6.allowEdit()) {
	          item.IsDeleted = true;
	          _this6.saveOrderPrice(orderPrice);
	        }
	      };
	
	      /**
	       * Reduces Count of an item (and marks IsDeleted if 0)
	       * @param {object} item
	       */
	      var onReduce = function onReduce(item) {
	        if (_this6.allowEdit() && item.Count > 0) {
	          item.Count--;
	          if (item.Count === 0) item.IsDeleted = true;
	          _this6.saveOrderPrice(orderPrice);
	        }
	      };
	
	      var renderStartPrice = function renderStartPrice() {
	        var amount = _this6.props.isWp && _this6.props.showAgreementPrice ? orderPrice.StartPriceGrossWP : orderPrice.StartPrice;
	        if (_this6.state.showNet) {
	          amount = _this6.props.isWp && _this6.props.showAgreementPrice ? orderPrice.StartPriceNetWP : orderPrice.StartPriceNet;
	        }
	
	        var showPrices = _this6.props.order.ShowPrices || _this6.props.editable;
	        if (!showPrices) amount = '';
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('13378'), amount: amount });
	      };
	
	      var renderEnvironment = function renderEnvironment() {
	        var amount = _this6.props.isWp && _this6.props.showAgreementPrice ? orderPrice.EnvironmentWP : orderPrice.Environment;
	        if (_this6.state.showNet) {
	          amount = _this6.props.isWp && _this6.props.showAgreementPrice ? orderPrice.EnvironmentNetWP : orderPrice.EnvironmentNet;
	        }
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('13339'), amount: amount });
	      };
	
	      var renderShopGross = function renderShopGross() {
	        var amount = orderPrice.Gross;
	        var discountField = 'DiscountShop';
	        var netField = 'Net';
	        if (_this6.props.isWp && _this6.props.showAgreementPrice) {
	          amount = orderPrice.GrossWP;
	          discountField = 'DiscountWP';
	          netField = 'NetWp';
	        }
	        if (_this6.props.isCustomer) {
	          discountField = 'Discount';
	        }
	
	        // Rendering shop discount/net fold-out for editing
	        if (!_this6.displayOnly()) {
	          var renderRadio = function renderRadio(fieldName, label) {
	            return _react2.default.createElement(_radio2.default, { spacing: 1, labelText: label, name: 'gross_shop_radio', value: fieldName, checked: _this6.state.gross_shop_radio === fieldName, onChange: _this6.onRadioChange });
	          };
	
	          var editable = true;
	          if (_this6.props.isCustomer || _this6.props.order.IsAgreementOrder || _this6.props.order.IsAgreement) {
	            editable = false;
	          }
	          if (_this6.props.department === 0 && _this6.props.auth.departmentType === 1 && _this6.props.auth.hasPartner) {
	            editable = false;
	          }
	
	          var renderEdit = function renderEdit(fieldName) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'amount blue' },
	              _react2.default.createElement(_DecimalInput2.default, { size: 's', className: fieldName.toLowerCase(), value: orderPrice[fieldName], name: fieldName, onBlur: _this6.changeValue })
	            );
	          };
	
	          // Render text part of the line (text or radio)
	          var renderText = function renderText(fieldName) {
	            var label = '';
	            switch (fieldName) {
	              case 'DiscountShop':
	                label = (0, _helpers.translation)(15014);
	                break;
	              case 'Net':
	                label = (0, _helpers.translation)(1392);
	                break;
	              case 'Discount':
	                label = (0, _helpers.translation)(1199);
	                break;
	            }
	
	            // if (this.props.isCustomer || this.props.order.IsAgreementOrder) return label
	            if (!editable) return label;
	            return renderRadio.bind(_this6, fieldName, label);
	          };
	
	          // Render amount part of the line (text or input)
	          var renderAmount = function renderAmount(fieldName) {
	            // if (this.props.isCustomer || this.props.order.IsAgreementOrder) return orderPrice[fieldName]
	            if (!editable) return orderPrice[fieldName];
	            return renderEdit.bind(_this6, fieldName);
	          };
	
	          return _react2.default.createElement(
	            _Line2.default,
	            { text: (0, _helpers.translation)('13376'), amount: amount, isBlue: true, canExpand: true },
	            _react2.default.createElement(_Line2.default, { text: renderText(discountField), amount: renderAmount(discountField) }),
	            _react2.default.createElement(_Line2.default, { text: renderText(netField), amount: renderAmount(netField) }),
	            _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)(2142), amount: orderPrice.NetExclEnvironment, isBlue: true })
	          );
	        }
	        // Only showing gross
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('13376'), amount: amount });
	      };
	
	      var renderShopDiscount = function renderShopDiscount() {
	        var amount = orderPrice.DiscountShop;
	        if (_this6.props.isWp && _this6.props.showAgreementPrice) amount = orderPrice.DiscountWP;
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('1199') + ' (%)', amount: amount });
	      };
	
	      var renderShopNet = function renderShopNet() {
	        var amount = orderPrice.Net;
	        if (_this6.props.isWp && _this6.props.showAgreementPrice) amount = orderPrice.NetWP;
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('1392'), amount: amount });
	      };
	
	      var renderCustomerGross = function renderCustomerGross() {
	        var amount = orderPrice.GrossCustomer;
	        var discountField = 'DiscountCustomer';
	        var netField = 'NetCustomer';
	
	        // Rendering customer discount/net fold-out for editing
	        if (_this6.allowEdit()) {
	          var renderRadio = function renderRadio(fieldName, label) {
	            return _react2.default.createElement(_radio2.default, { spacing: 1, labelText: label, name: 'gross_customer_radio', value: fieldName, checked: _this6.state.gross_customer_radio === fieldName, onChange: _this6.onRadioChange });
	          };
	          var renderEdit = function renderEdit(fieldName) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'amount blue' },
	              _react2.default.createElement(_DecimalInput2.default, { size: 's', className: fieldName.toLowerCase(), value: orderPrice[fieldName], name: fieldName, onBlur: _this6.changeValue })
	            );
	          };
	
	          // Render text part of the line (text or radio)
	          var renderText = function renderText(fieldName) {
	            var label = '';
	            switch (fieldName) {
	              case 'DiscountCustomer':
	                label = (0, _helpers.translation)(15014);
	                break;
	              case 'NetCustomer':
	                label = (0, _helpers.translation)(1392);
	                break;
	            }
	
	            return renderRadio.bind(_this6, fieldName, label);
	          };
	
	          // Render amount part of the line (text or input)
	          var renderAmount = function renderAmount(fieldName) {
	            return renderEdit.bind(_this6, fieldName);
	          };
	
	          return _react2.default.createElement(
	            _Line2.default,
	            { text: (0, _helpers.translation)('393'), amount: amount, canExpand: true },
	            _react2.default.createElement(_Line2.default, { text: renderText(discountField), amount: renderAmount(discountField) }),
	            _react2.default.createElement(_Line2.default, { text: renderText(netField), amount: renderAmount(netField) })
	          );
	        }
	
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('393'), amount: amount });
	      };
	
	      var renderCustomerDiscount = function renderCustomerDiscount() {
	        var amount = orderPrice.DiscountCustomer;
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('15014'), amount: amount });
	      };
	
	      var renderCustomerNet = function renderCustomerNet() {
	        var amount = orderPrice.NetCustomer;
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('1392'), amount: amount });
	      };
	
	      var renderVat = function renderVat() {
	        var amount = orderPrice.Vat;
	        if (_this6.props.isWp && _this6.props.showAgreementPrice) amount = orderPrice.VatWP;
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('13390'), amount: amount, isVat: true });
	      };
	
	      var renderTotal = function renderTotal() {
	        var fieldName = 'Total';
	        if (_this6.props.isWp && _this6.props.showAgreementPrice) {
	          fieldName = 'TotalWP';
	        }
	        var amount = orderPrice[fieldName];
	
	        var editable = true;
	        if (_this6.props.order.IsAgreementOrder || _this6.props.order.IsAgreement) {
	          editable = false;
	        }
	        if (_this6.props.department === 0 && _this6.props.auth.departmentType === 1 && _this6.props.auth.hasPartner) {
	          editable = false;
	        }
	        if (!_this6.displayOnly() && /* !this.props.order.IsAgreementOrder */editable) {
	          var renderEdit = function renderEdit(fieldName) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'amount' },
	              _react2.default.createElement(_DecimalInput2.default, { size: 's', className: fieldName.toLowerCase(), value: orderPrice[fieldName], name: fieldName, onBlur: _this6.changeValue })
	            );
	          };
	          return _react2.default.createElement(
	            _Line2.default,
	            { text: (0, _helpers.translation)('393'), amount: amount, amountOpen: '', canExpand: true, bold: true },
	            _react2.default.createElement(_Line2.default, { text: '', amount: renderEdit.bind(_this6, fieldName) })
	          );
	        }
	
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('393'), amount: amount, bold: true });
	      };
	
	      var renderOwnServicesGross = function renderOwnServicesGross() {
	        var amount = orderPrice.GrossServices;
	        return _react2.default.createElement(_Line2.default, { text: (0, _helpers.translation)('13376'), amount: amount });
	      };
	
	      var renderDivider = function renderDivider(text) {
	        if (text !== undefined) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'title spacing' },
	            text
	          );
	        }
	        return _react2.default.createElement('div', { className: 'h-line bold' });
	      };
	
	      var renderParts = function renderParts() {
	        var includeNormalParts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var includeOtherPart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        var parts = [];
	        if (includeNormalParts) {
	          orderPrice.Parts.filter(function (p) {
	            return p.Part.PartItemId > 0;
	          }).map(function (p) {
	            parts.push(renderPart(p));
	          });
	        }
	        if (includeOtherPart) {
	          orderPrice.Parts.filter(function (p) {
	            return p.Part.PartItemId === 0;
	          }).map(function (p) {
	            parts.push(renderPart(p));
	          });
	        }
	        return parts;
	      };
	
	      var renderPart = function renderPart(item) {
	        return _react2.default.createElement(_Part2.default, _extends({}, _this6.props, {
	          key: 'part_' + item.Part.PartItemId + '_' + item.Part.TaskSide,
	          part: item,
	          saveOrderPrice: _this6.saveOrderPrice,
	          onDelete: _this6.allowEdit() ? onDelete : undefined,
	          showNet: _this6.state.showNet,
	          noPrice: _this6.props.viewMode === 'simple'
	        }));
	      };
	
	      var renderServiceTask = function renderServiceTask(item) {
	        if (item.OrderServiceTaskId === undefined) return null;
	        var key = 'service_' + item.OrderServiceTaskId;
	        if (item.IsExtra) key = 'extra_' + item.OrderServiceTaskId;
	        return _react2.default.createElement(_PriceLine2.default, _extends({}, _this6.props, {
	          key: key,
	          orderServiceTask: item,
	          saveOrderPrice: _this6.saveOrderPrice,
	          onDelete: _this6.allowEdit() ? onReduce : undefined,
	          showNet: _this6.state.showNet,
	          noPrice: _this6.props.viewMode === 'simple'
	        }));
	      };
	
	      var renderAddonPart = function renderAddonPart(item) {
	        if (item.OrderAddonPartId === undefined) return null;
	        return _react2.default.createElement(_PriceLine2.default, _extends({}, _this6.props, {
	          key: 'addonpart_' + item.OrderAddonPartId,
	          orderAddonPart: item,
	          saveOrderPrice: _this6.saveOrderPrice,
	          onDelete: _this6.allowEdit() ? onDelete : undefined,
	          showNet: _this6.state.showNet,
	          noPrice: _this6.props.viewMode === 'simple'
	        }));
	      };
	
	      var renderAddonStartTime = function renderAddonStartTime(item) {
	        if (item.OrderAddonStartTimeId === undefined) return null;
	        return _react2.default.createElement(_PriceLine2.default, _extends({}, _this6.props, {
	          key: 'addonstarttime_' + item.OrderAddonStartTimeId,
	          orderAddonStartTime: item,
	          saveOrderPrice: _this6.saveOrderPrice,
	          onDelete: _this6.allowEdit() ? onDelete : undefined,
	          showNet: _this6.state.showNet,
	          noPrice: _this6.props.viewMode === 'simple'
	        }));
	      };
	
	      var renderNewItem = function renderNewItem() {
	        var item = _extends({}, _this6.state.newTask);
	        return _react2.default.createElement(_PriceLine2.default, _extends({}, _this6.props, {
	          orderTaskPrice: item,
	          saveOrderPrice: _this6.saveOrderPrice,
	          showNet: _this6.state.showNet
	        }));
	      };
	
	      var renderToggleLoosePart = function renderToggleLoosePart() {
	        var toggle = function toggle() {
	          var isLoosePart = _this6.state.isLoosePart;
	          _this6.setState({
	            isLoosePart: !isLoosePart,
	            hasChanged: true
	          }, function () {
	            _this6.saveOrderPrice(_this6.props.orderPrice);
	          });
	        };
	
	        return _react2.default.createElement(
	          _inline2.default,
	          { fillChildNum: [0], alignChildren: 'center', block: true },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('351')
	          ),
	          _react2.default.createElement(_check2.default, { labelAlignment: 'l', labelText: _react2.default.createElement(_icon2.default, { icon: _icons.TransportTypeIcons.Loose_Part }), id: 'IsLoosePart_check', name: 'IsLoosePart_check', checked: _this6.state.isLoosePart, disabled: _this6.props.isCustomer && !_this6.props.order.IsDraft && !_this6.displayOnly(), onChange: toggle })
	        );
	      };
	
	      var renderSendMailButton = function renderSendMailButton() {
	        var emailClick = function emailClick() {
	          _events2.default.emit('Price_Email_Click');
	        };
	        return _this6.props.order.IsDraft && _react2.default.createElement(
	          'div',
	          { onClick: emailClick, style: { textAlign: 'right', marginTop: 6, cursor: 'pointer' } },
	          _react2.default.createElement('img', { src: '/images/svgs/Messages-send.svg', width: 22 })
	        );
	      };
	
	      var renderPhotoAndComments = function renderPhotoAndComments() {
	        var hasCommentAndPhotoAccess = (0, _auth.hasSubscriptionPermission)(_this6.props.auth, 10);
	        if (_this6.props.auth.departmentType === 1 && _this6.props.department === 0 && _this6.props.auth.hasPartner) {
	          hasCommentAndPhotoAccess = (0, _auth.hasPartnerSubscriptionPermission)(_this6.props.auth, 10);
	        }
	        if (!hasCommentAndPhotoAccess) return null;
	
	        var comment = _this6.props.orderPrice.Notes.find(function (n) {
	          return n.SourceID === 11;
	        });
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Photo2.default, { saveOrderPrice: _this6.props.saveOrderPrice, orderPrice: _this6.props.orderPrice, order: _this6.props.order }),
	          _react2.default.createElement(_Comment2.default, { comment: comment, changeSource: 11, orderPriceId: _this6.props.orderPrice.OrderPriceId, order: _this6.props.order })
	        );
	      };
	
	      var renderShop = function renderShop() {
	        // let isPriceChange = this.props.orderPrice.ApprovalShop === 1 || this.props.orderPrice.ApprovalCustomer === 1
	        var showPrices = _this6.props.order.ShowPrices || _this6.props.editable;
	        var isCorrectViewMode = !['hover', 'simple'].includes(_this6.props.viewMode);
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'totals shop' },
	            isCorrectViewMode && showPrices && renderEnvironment(),
	            _react2.default.createElement(_divider2.default, null),
	            isCorrectViewMode && showPrices && renderShopGross(),
	            isCorrectViewMode && showPrices && _this6.displayOnly() && renderShopDiscount(),
	            isCorrectViewMode && showPrices && _this6.displayOnly() && renderShopNet(),
	            _this6.props.viewMode !== 'simple' && showPrices && renderVat(),
	            showPrices && _react2.default.createElement(_divider2.default, null),
	            showPrices && renderTotal(),
	            _this6.props.editable && renderPhotoAndComments()
	          )
	        );
	      };
	
	      var renderCustomer = function renderCustomer() {
	        var showPrices = _this6.props.order.ShowPrices || _this6.props.editable;
	        var isCorrectViewMode = !['hover', 'simple'].includes(_this6.props.viewMode);
	        var isPaint = _this6.props.auth.departmentType === 0;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'totals shop' },
	            isCorrectViewMode && showPrices && renderEnvironment(),
	            _react2.default.createElement(_divider2.default, null),
	            isCorrectViewMode && showPrices && renderShopGross(),
	            isCorrectViewMode && showPrices && _this6.displayOnly() && renderShopDiscount(),
	            isCorrectViewMode && showPrices && _this6.displayOnly() && renderShopNet()
	          ),
	          orderPrice.Services.length > 0 && _react2.default.createElement(
	            'div',
	            null,
	            renderDivider((0, _helpers.translation)(13375)),
	            orderPrice.Services.map(renderServiceTask),
	            isCorrectViewMode && renderOwnServicesGross()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'totals customer' },
	            isCorrectViewMode && isPaint && renderDivider((0, _helpers.translation)(13377)),
	            isCorrectViewMode && isPaint && renderCustomerGross(),
	            isCorrectViewMode && isPaint && !_this6.allowEdit() && renderCustomerDiscount(),
	            isCorrectViewMode && isPaint && !_this6.allowEdit() && renderCustomerNet(),
	            isCorrectViewMode && showPrices && renderVat(),
	            showPrices && _react2.default.createElement(_divider2.default, null),
	            showPrices && renderTotal(),
	            _this6.props.editable && renderPhotoAndComments()
	          )
	        );
	      };
	
	      var css = '';
	      if (this.props.editable) {
	        css += 'price__view editable test';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: css },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: function onSubmit(e) {
	              e.preventDefault();
	            } },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.viewMode === 'mobile' && this.props.renderInside(),
	            renderInnerTitle(),
	            this.allowEdit() && !this.props.orderPrice.IsAddonPrice && renderToggleLoosePart(),
	            orderPrice.Department === 0 && renderStartPrice(),
	            renderParts(true, false),
	            orderPrice.Extras.map(renderServiceTask),
	            orderPrice.OrderAddonParts.map(renderAddonPart),
	            orderPrice.OrderAddonStartTimes.map(renderAddonStartTime),
	            renderParts(false, true),
	            !this.props.isWp && this.allowEdit() && this.props.orderPrice.Department === 0 && renderNewItem(),
	            this.props.isCustomer ? renderCustomer() : renderShop(),
	            this.props.editable && this.renderOkButton(),
	            !this.props.isWp && this.allowEdit() && renderSendMailButton()
	          )
	        ),
	        this.renderConfirm()
	      );
	    }
	  }]);
	
	  return Price;
	}(_react.Component);
	
	Price.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(Price);

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(5);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _OtherFileList = __webpack_require__(1055);
	
	var _OtherFileList2 = _interopRequireDefault(_OtherFileList);
	
	__webpack_require__(1531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import components
	
	
	// import styles
	
	
	var FileArea = function (_Component) {
	  _inherits(FileArea, _Component);
	
	  function FileArea() {
	    _classCallCheck(this, FileArea);
	
	    return _possibleConstructorReturn(this, (FileArea.__proto__ || Object.getPrototypeOf(FileArea)).apply(this, arguments));
	  }
	
	  _createClass(FileArea, [{
	    key: 'renderImage',
	
	    // Render image
	    value: function renderImage(image, index) {
	      var url = _constants.FILE_STORAGE + image.ThumbURL;
	      var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	      return _react2.default.createElement(
	        'div',
	        { key: index, className: 'file-image' },
	        _react2.default.createElement(
	          'a',
	          { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	          _react2.default.createElement('img', { src: url })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        (this.props.showFiles === undefined || this.props.showFiles === true) && _react2.default.createElement(_OtherFileList2.default, {
	          files: this.props.otherFiles,
	          showDelete: this.props.showDelete,
	          auth: this.props.auth }),
	        (this.props.showImages === undefined || this.props.showImages === true) && _react2.default.createElement(_Gallery2.default, { files: this.props.images, renderImage: this.renderImage })
	      );
	    }
	  }]);
	
	  return FileArea;
	}(_react.Component);
	
	exports.default = FileArea;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PrivacyPolicy = __webpack_require__(444);
	
	var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1532);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Utils
	
	
	// styles
	
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'footer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'footer__info' },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('2125')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('38'),
	            ': +45 70 70 72 85'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('2126'),
	            ': info@apromas.com'
	          )
	        ),
	        _react2.default.createElement(_PrivacyPolicy2.default, { text: (0, _helpers.translation)(16653) })
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1537);
	
	var _modalHeader = __webpack_require__(176);
	
	var _modalHeader2 = _interopRequireDefault(_modalHeader);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Elements
	
	
	var InfoPopup = function (_Component) {
	  _inherits(InfoPopup, _Component);
	
	  function InfoPopup() {
	    _classCallCheck(this, InfoPopup);
	
	    return _possibleConstructorReturn(this, (InfoPopup.__proto__ || Object.getPrototypeOf(InfoPopup)).apply(this, arguments));
	  }
	
	  _createClass(InfoPopup, [{
	    key: 'render',
	    value: function render() {
	      var higher = this.props.higher ? 'higher' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'confirm_Price_modal__wrapper' },
	        _react2.default.createElement('div', { className: 'backdrop__modal ' + higher }),
	        _react2.default.createElement(
	          'div',
	          { className: 'confirm__modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'confirm__content' },
	            _react2.default.createElement(_modalHeader2.default, { text: this.props.t(this.props.Hedder) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'pg-pb-2' },
	              this.props.t(this.props.Text)
	            )
	          ),
	          _react2.default.createElement(_bottomBar2.default, {
	            actionLabelText: this.props.t('956'),
	            onActionClick: this.props.click,
	            center: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return InfoPopup;
	}(_react.Component);
	
	exports.default = InfoPopup;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icons = __webpack_require__(6);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(1538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// import styles
	
	
	var InputState = function (_Component) {
	  _inherits(InputState, _Component);
	
	  function InputState(props) {
	    _classCallCheck(this, InputState);
	
	    var _this = _possibleConstructorReturn(this, (InputState.__proto__ || Object.getPrototypeOf(InputState)).call(this, props));
	
	    _this.state = {
	      option: _this.props.option,
	      value: _this.props.value
	    };
	    _this.changeInputState = _this.changeInputState.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(InputState, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        option: nextProps.option,
	        value: nextProps.value
	      });
	    }
	  }, {
	    key: 'changeInputState',
	    value: function changeInputState() {
	      var option = this.state.option;
	      if (option === 4) {
	        option = 0;
	      }
	      this.setState({
	        option: option + 1
	      });
	      this.props.triggerHandler(option + 1, this.props.triggerName);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState({
	        value: e.target.value
	      });
	      this.props.triggerChange(e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var stateImage = _icons.ElementIcons.Include;
	      if (this.state.option === 2) {
	        stateImage = _icons.ElementIcons.Empty;
	      }
	      if (this.state.option === 3) {
	        stateImage = _icons.ElementIcons.Filled_In;
	      }
	      if (this.state.option === 4) {
	        stateImage = _icons.ElementIcons.Exclude;
	      }
	
	      return _react2.default.createElement(
	        _inline2.default,
	        { alignChildren: 'center' },
	        _react2.default.createElement(_text2.default, { placeholder: this.props.placeholder, name: this.props.triggerName, value: this.state.value, onChange: this.onChange }),
	        _react2.default.createElement(
	          'span',
	          { className: 'inputstate', onClick: this.changeInputState },
	          _react2.default.createElement(_icon2.default, { icon: stateImage })
	        )
	      );
	    }
	  }]);
	
	  return InputState;
	}(_react.Component);
	
	exports.default = InputState;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1541);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShortCutBar = function (_Component) {
	  _inherits(ShortCutBar, _Component);
	
	  function ShortCutBar(props) {
	    _classCallCheck(this, ShortCutBar);
	
	    var _this = _possibleConstructorReturn(this, (ShortCutBar.__proto__ || Object.getPrototypeOf(ShortCutBar)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ShortCutBar, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.overlaysLength > 0) return null;
	
	      var orientationClass = this.props.horizontal ? ' horizontal' : ' vertical';
	      return _react2.default.createElement(
	        'div',
	        { className: 'layout__shortcuts' + orientationClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          this.props.children,
	          _react2.default.createElement(
	            'div',
	            { className: 'shortcut1' },
	            _react2.default.createElement(_icon2.default, { size: 'l', icon: null })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'shortcut2' },
	            _react2.default.createElement(_icon2.default, { size: 'l', icon: null })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'shortcut3' },
	            _react2.default.createElement(_icon2.default, { size: 'l', icon: null })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'logo' },
	            _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.GeneralIcons.Apromas_Logo })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShortCutBar;
	}(_react.Component);
	
	ShortCutBar.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    overlaysLength: state.common.overlays.length
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(ShortCutBar);

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _common = __webpack_require__(25);
	
	var _lodash = __webpack_require__(27);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1542);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Icons } from '../../../elements/icons'
	
	var TopBar = function (_Component) {
	  _inherits(TopBar, _Component);
	
	  function TopBar(props) {
	    _classCallCheck(this, TopBar);
	
	    var _this = _possibleConstructorReturn(this, (TopBar.__proto__ || Object.getPrototypeOf(TopBar)).call(this, props));
	
	    _this.prevRoutePath = props.router.routes[props.router.routes.length - 1].path;
	    _this.prevCurrentUserToken = '';
	    return _this;
	  }
	
	  _createClass(TopBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var defaultPageTitle = { title: 'Apromas', icon: null };
	      var topRoute = nextProps.router.routes[nextProps.router.routes.length - 1];
	
	      // Set page title from route only if route was changed (ignore certain route parameter changes).
	      var filterRouteParameters = function filterRouteParameters(route) {
	        if (typeof route === 'string') {
	          route = route.replace('/:type', '');
	          route = route.replace('/:value', '');
	          route = route.replace('/:separateType', '');
	        }
	        return route;
	      };
	
	      var checkCurrentUserChanged = function checkCurrentUserChanged() {
	        if (_this2.props.auth !== undefined && _this2.props.auth.Token !== _this2.prevCurrentUserToken) {
	          _this2.prevCurrentUserToken = _this2.props.auth.Token;
	          return true;
	        }
	        return false;
	      };
	
	      if (filterRouteParameters(topRoute.path) !== filterRouteParameters(this.prevRoutePath) || this.props.pageTitle.title === defaultPageTitle.title || checkCurrentUserChanged()) {
	        // let before = filterRouteParameters(this.prevRoutePath)
	        this.prevRoutePath = filterRouteParameters(topRoute.path);
	        var topBarData = null;
	        if (topRoute.topBar) {
	          topBarData = _extends({}, topRoute.topBar);
	        }
	        if (topBarData === null) {
	          if (!(0, _lodash.isEqual)(defaultPageTitle, this.props.pageTitle)) {
	            // this.props.setPageTitle(defaultPageTitle)
	          }
	        } else {
	          if (!(0, _lodash.isEqual)(topBarData, this.props.pageTitle)) {
	            this.props.setPageTitle(topBarData);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var icon = null;
	      var title = 'Apromas';
	      if (this.props.pageTitle !== null) {
	        if (this.props.pageTitle.icon !== undefined) icon = this.props.pageTitle.icon;
	        if (this.props.pageTitle.title !== undefined) {
	          title = this.props.pageTitle.title;
	
	          if (typeof title === 'number') title = (0, _helpers.translation)(title);
	        }
	        if (typeof this.props.pageTitle.extra === 'string' && this.props.pageTitle.extra.trim().length > 0) {
	          title += ' - ' + this.props.pageTitle.extra;
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'layout__header' },
	        _react2.default.createElement(_icon2.default, { size: 'm', icon: icon }),
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          title
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return TopBar;
	}(_react.Component);
	
	TopBar.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    pageTitle: state.common.pageTitle
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  setPageTitle: _common.setPageTitle
	})(TopBar);

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _lodash = __webpack_require__(27);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _constants = __webpack_require__(5);
	
	var _backdrop = __webpack_require__(29);
	
	var _common = __webpack_require__(25);
	
	var _orders = __webpack_require__(21);
	
	var _Menu = __webpack_require__(1051);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _UserMenu = __webpack_require__(1062);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _NewsFeed = __webpack_require__(1052);
	
	var _NewsFeed2 = _interopRequireDefault(_NewsFeed);
	
	var _TopBar = __webpack_require__(1049);
	
	var _TopBar2 = _interopRequireDefault(_TopBar);
	
	var _ShortCutBar = __webpack_require__(1048);
	
	var _ShortCutBar2 = _interopRequireDefault(_ShortCutBar);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1696);
	
	var _auth = __webpack_require__(8);
	
	var _detect = __webpack_require__(102);
	
	var _helpers = __webpack_require__(2);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ReportMerge = __webpack_require__(1127);
	
	var _ReportMerge2 = _interopRequireDefault(_ReportMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import components
	
	
	// import Null from '../../elements/null'
	
	
	// import styles
	
	
	// Utils
	
	
	// Elements
	
	
	// Overlays
	
	
	var Layout = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout(props) {
	    _classCallCheck(this, Layout);
	
	    var _this = _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props));
	
	    _this.state = {
	      headerInfo: {
	        Updates_open: false,
	        ManualMerges_open: false,
	        ForsiActive_open: false
	      },
	      headerInfos: props.headerInfo,
	      timerId: -1,
	      selectedReportMergeInfo: undefined
	    };
	    _this.openMenu = _this.openMenu.bind(_this);
	    _this.handle = _this.handle.bind(_this);
	    _this.toggleHeaderInfo = _this.toggleHeaderInfo.bind(_this);
	    _this.updateHeaderInfo = _this.updateHeaderInfo.bind(_this);
	    _this.UpdateEconomicMatch = _this.UpdateEconomicMatch.bind(_this);
	    _this.getHeaderInfo = _this.getHeaderInfo.bind(_this);
	    _this.startTimer = _this.startTimer.bind(_this);
	    _this.stopTimer = _this.stopTimer.bind(_this);
	    _this.tickTimer = _this.tickTimer.bind(_this);
	    _this.searchEconomicNotMatched = _this.searchEconomicNotMatched.bind(_this);
	    return _this;
	  }
	
	  _createClass(Layout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('click', this.handle, true);
	      this.getHeaderInfo();
	      this.initSocket();
	      this.startTimer();
	
	      if (_constants.isiOS) {
	        document.body.classList.add('iOS');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.handle, true);
	      _events2.default.removeListener('HEADER_INFO', this.updateHeaderInfo);
	      this.stopTimer();
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this2 = this;
	
	      // timer should not be needed anymore with wp socket updates, but is kept for just in case when socket does not update
	      var loc = window.location;
	      if (this.state.timerId > -1 || !(0, _auth.hasAccess)([6], this.props.auth.user.UserType) || loc.hostname === 'localhost') return; // Only start one timer, and only for wp
	      this.setState({
	        timerId: setInterval(this.tickTimer, 30000)
	      }, function () {
	        console.log('[Layout] started timer, id: ' + _this2.state.timerId);
	      });
	    }
	  }, {
	    key: 'stopTimer',
	    value: function stopTimer() {
	      clearInterval(this.state.timerId);
	      this.setState({
	        timerId: -1
	      }, function () {
	        console.log('[Layout] stopped timer');
	      });
	    }
	  }, {
	    key: 'tickTimer',
	    value: function tickTimer() {
	      console.log('[Layout] timer ticked, id: ' + this.state.timerId);
	      this.getHeaderInfo();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      // if (this.props.auth.user.ShopId !== nextProps.auth.user.ShopId) {
	      // console.log('Layout props', nextProps.auth)
	      if (!(0, _lodash.isEqual)(this.props.auth.user, nextProps.auth.user) || !(0, _lodash.isEqual)(this.props.auth.myscreen.Active, nextProps.auth.myscreen.Active)) {
	        // console.log('[Layout] props', nextProps.auth)
	        if (nextProps.auth.prevWorkscreen !== null || nextProps.auth.myscreen.Active) {
	          console.log('[Layout] AUTH NOT THE SAME, set workscreen to', nextProps.auth.prevWorkscreen);
	          window.localStorage.setItem('workscreen_view', nextProps.auth.prevWorkscreen);
	        }
	        this.stopTimer();
	        setTimeout(function () {
	          _this3.getHeaderInfo();
	          _this3.startTimer();
	        }, 500);
	      }
	      if (!(0, _lodash.isEqual)(this.props.headerInfo, nextProps.headerInfo)) {
	        this.state.headerInfos = nextProps.headerInfo;
	      }
	    }
	  }, {
	    key: 'initSocket',
	    value: function initSocket() {
	      // Fix init socket
	      // window.sock.send(JSON.stringify({
	      //   Type: 'CONNECTION',
	      //   ShopId: parseInt(this.props.auth.user.ShopId)
	      // }))
	      _events2.default.removeListener('HEADER_INFO', this.updateHeaderInfo);
	      _events2.default.addListener('HEADER_INFO', this.updateHeaderInfo, this);
	    }
	  }, {
	    key: 'searchEconomicNotMatched',
	    value: function searchEconomicNotMatched(e) {
	      var _this4 = this;
	
	      // e.preventDefault()
	      // this.props.resetFilter()
	      var source = 'orderlist';
	      if ((0, _auth.hasAccess)([4], this.props.auth.user.UserType)) {
	        source = 'customer';
	      } else if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) {
	        source = 'wp';
	      } else if (this.props.router.location.pathname === '/workscreen') {
	        source = 'workscreen';
	      }
	
	      var filter = JSON.parse(JSON.stringify(this.props.filter));
	      filter.economicfilter = {
	        economicFilterNotMatched: true,
	        economicFilterMatched: false
	      };
	      filter.process = _extends({}, filter.process, {
	        InProcess: true,
	        CompletedThisWeek: true,
	        Completed: true
	      });
	      this.props.setOrdersSearch(true);
	      this.props.setOrdersFilter(filter, source);
	      setTimeout(function () {
	        if (_this4.props.router.location.pathname === '/orders') {
	          // TODO: Actually search again if in orderslist
	          _this4.props.getOrdersAdvanced(filter, _this4.props.auth.user.UserType);
	          _this4.toggleHeaderInfo();
	        } else {
	          _this4.props.router.replace('/orders');
	          _this4.toggleHeaderInfo();
	        }
	      }, 50);
	    }
	  }, {
	    key: 'updateHeaderInfo',
	    value: function updateHeaderInfo(data) {
	      var _this5 = this;
	
	      // console.log('Update header info', data) // noget går galt her.
	      switch (data.Type) {
	        case 'HEADER_INFO_FORSI':
	          this.props.setHeaderInfo('SET_HEADERINFO_FORSI', 'ForsiActive', data.Data.Active);
	          break;
	        case 'HEADER_INFO_MESSAGES':
	          var dataObject = data.Data;
	          // Other task
	          if (dataObject.Type === 2) {
	            if (dataObject.UserId === this.props.auth.user.UserId) {
	              this.props.setHeaderInfo('SET_HEADERINFO_TASKS', 'IncompletedTasks', dataObject.Count);
	            }
	          } else {
	            // Messages
	            data.Data.map(function (val) {
	              if (val.UserId === _this5.props.auth.user.UserId) {
	                _this5.props.setHeaderInfo('SET_HEADERINFO_MESSAGES', 'UnreadMessages', val.Count);
	              }
	            });
	          }
	          break;
	        case 'HEADER_INFO_EVALUATION':
	          this.props.setHeaderInfo('SET_HEADERINFO_EVALUATION', 'Updates', data.Data);
	          break;
	        case 'HEADER_INFO_UPDATES':
	          if (data.Data.Type === 2) {
	            this.props.setHeaderInfo('SET_HEADERINFO_BOOKINGPORTALDRAFTS', 'BookingPortalDrafts', data.Data.BookingPortalDrafts);
	          } else if (data.Data.OrderAssignmentCount !== undefined) {
	            data.Data.OrderAssignmentCount.map(function (val) {
	              if (val.UserId === _this5.props.auth.user.UserId) {
	                _this5.props.setHeaderInfo('SET_HEADERINFO_ORDERS', 'AssignedOrders', val.AssignedCount);
	              }
	            });
	          } else {
	            this.props.setHeaderInfo('SET_HEADERINFO_UPDATES', 'ManualMerges', data.Data);
	          }
	          break;
	        case 'HEADER_INFO_CHAINNOTIFICATION':
	          this.props.setHeaderInfo('SET_HEADERINFO_CHAINNOTIFICATION', 'ChainNotification', data.Data[0].Message);
	          break;
	      }
	    }
	  }, {
	    key: 'getHeaderInfo',
	    value: function getHeaderInfo() {
	      if (!(0, _auth.hasAccess)([3, 4, 5, 6, 7], this.props.auth.user.UserType)) return null;
	      this.props.getHeaderInfo(0);
	    }
	  }, {
	    key: 'openMenu',
	    value: function openMenu() {
	      if (!this.props.backdrop.menuOpen) {
	        // document.getElementById('app').className = 'menu-open'
	        document.getElementById('app').classList.add('menu-open');
	      } else {
	        document.getElementById('app').classList.remove('menu-open');
	        // document.getElementById('app').className = ''
	      }
	      this.props.triggerMenu(!this.props.backdrop.menuOpen);
	    }
	  }, {
	    key: 'UpdateEconomicMatch',
	    value: function UpdateEconomicMatch(item, e) {
	      var matches = [].concat(_toConsumableArray(this.state.headerInfos.EconomicMatches));
	      if (matches === null) return null;
	      item.Checked = !item.Checked;
	      for (var i = 0; i < matches.length; i++) {
	        if (matches[i].OrderId === item.OrderId) {
	          matches[i] = item;
	        }
	      }
	      this.props.UpdateEconomicMatch(item);
	      this.setState({
	        headerInfos: _extends({}, this.state.headerInfos, {
	          EconomicMatches: matches
	        })
	      }, function () {
	        console.log('matches', matches);
	      });
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(item) {
	      var title = '';
	      // Model
	      if (item.Model) {
	        title += item.Model;
	      }
	      // RegNumber
	      if (item.RegNr) {
	        if (item.Model) {
	          title += ', ';
	        }
	        title += item.RegNr;
	      }
	      // Title empty
	      if (title === '') {
	        title += item.OrderId;
	      }
	      return title;
	    }
	  }, {
	    key: 'handle',
	    value: function handle(e) {
	      var pathTest = [];
	      var node = e.target;
	      while (node !== null && node !== document && node !== document.body) {
	        pathTest.push(node);
	        node = node.parentNode;
	      }
	      // this.toggleHeaderInfo()
	      // if (!(e.path.filter(x => x.className === 'headerInfos').length === 1)) this.toggleHeaderInfo() // only works in Chrome
	      if (!(pathTest.filter(function (x) {
	        return x.className === 'headerInfos';
	      }).length === 1)) this.toggleHeaderInfo();
	
	      if (!(0, _auth.hasAccess)([3, 5, 7], this.props.auth.user.UserType)) return null;
	      // if (!el.contains(e.target) && this.state.headerInfo.open) this.toggleHeaderInfo()
	    }
	  }, {
	    key: 'toggleHeaderInfo',
	    value: function toggleHeaderInfo(name) {
	      this.setState({
	        headerInfo: _defineProperty({
	          // ...this.state.headerInfo,
	          Updates_open: false,
	          ManualMerges_open: false,
	          ForsiActive_open: false,
	          EconomicMatches_open: false
	        }, name, !this.state.headerInfo[name])
	      });
	    }
	  }, {
	    key: 'renderHeaderInfo',
	    value: function renderHeaderInfo() {
	      var _this6 = this;
	
	      var _props = this.props,
	          headerInfo = _props.headerInfo,
	          auth = _props.auth;
	
	      if (!(0, _auth.hasAccess)([3, 5, 6, 7], auth.user.UserType)) return null;
	      // Render updates
	      var renderUpdates = function renderUpdates(item, key) {
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/pricecalculation/' + item.OrderId + '/3', onClick: _this6.toggleHeaderInfo },
	            '- ',
	            _this6.renderTitle(item)
	          )
	        );
	      };
	      var renderEconomicMatches = function renderEconomicMatches(item, key) {
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(_check2.default, { labelText: '- ' + _this6.renderTitle(item) + ' (' + item.CustomerName + ')', checked: item.Checked, onChange: _this6.UpdateEconomicMatch.bind(_this6, item) })
	        );
	      };
	      var renderMerge = function renderMerge(item, key) {
	        var onClick = function onClick(_) {
	          _this6.toggleHeaderInfo();
	          _this6.props.openOverlay('ReportMergeOverlay');
	          _this6.setState({ selectedReportMergeInfo: item });
	        };
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: window.location.pathname, replace: true, onClick: onClick },
	            '- ',
	            _this6.renderTitle(item)
	          )
	        );
	      };
	      var renderBookingPortalDraft = function renderBookingPortalDraft(item, key) {
	        return _react2.default.createElement(
	          'li',
	          { key: key },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/orders/' + item.OrderId, onClick: _this6.toggleHeaderInfo },
	            '- ',
	            _this6.renderTitle(item)
	          )
	        );
	      };
	      var renderNoti = function renderNoti() {
	        if (_this6.props.auth.departmentType === 1) return null;
	        if (headerInfo.Updates.length !== 0 && ((0, _auth.hasSubscriptionPermission)(_this6.props.auth, 30, 25) || (0, _auth.hasAccess)([6], auth.user.UserType))) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'noti needTaksering', onClick: _this6.toggleHeaderInfo.bind(_this6, 'Updates_open') },
	            _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.HeaderIcons.Estimation_Request_White, ariaText: (0, _helpers.translation)('2200'), ariaPos: 'bottom' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-number' },
	              headerInfo.Updates.length
	            )
	          );
	        }
	        return null;
	      };
	
	      var renderMessages = function renderMessages() {
	        if (headerInfo.UnreadMessages === 0) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'noti' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/mypage/messages' },
	            _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.HeaderIcons.Message_With_Circle_White }),
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-number' },
	              _this6.props.headerInfo.UnreadMessages
	            )
	          )
	        );
	      };
	
	      var renderTasks = function renderTasks() {
	        if (!(0, _auth.hasSubscriptionPermission)(_this6.props.auth, 30) || _this6.props.headerInfo.IncompletedTasks === 0) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'noti' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/mypage/tasks' },
	            _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.HeaderIcons.Task_With_Circle_White }),
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-number' },
	              _this6.props.headerInfo.IncompletedTasks
	            )
	          )
	        );
	      };
	
	      var renderOrders = function renderOrders() {
	        if (!(0, _auth.hasSubscriptionPermission)(_this6.props.auth, 20) || _this6.props.headerInfo.AssignedOrders === 0) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'noti' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/mypage/orders' },
	            _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.HeaderIcons.Order_With_Circle_White }),
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-number' },
	              _this6.props.headerInfo.AssignedOrders
	            )
	          )
	        );
	      };
	
	      // Return
	      // let SpecialBrowserClass = (navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1 || navigator.userAgent.indexOf('Edge') > -1) ? 'left' : ''
	      var forsiEnable = this.props.auth.permissions.ChainAssessmentSystem === 1; // Forsi is available for the company
	      return _react2.default.createElement(
	        'div',
	        { className: 'headerInfos', ref: 'container' },
	        renderNoti(),
	        this.state.headerInfos.EconomicMatches.length !== 0 && (0, _auth.hasAccess)([6], auth.user.UserType) && _react2.default.createElement(
	          'div',
	          { className: 'noti needEconomicHandling', onClick: this.toggleHeaderInfo.bind(this, 'EconomicMatches_open') },
	          _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.HeaderIcons.Payment_Notification_White, ariaText: (0, _helpers.translation)(13040), ariaPos: 'bottom' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'icon-number' },
	            this.state.headerInfos.EconomicMatches.length
	          )
	        ),
	        headerInfo.ManualMerges.length !== 0 && (0, _auth.hasSubscriptionPermission)(this.props.auth, 0, 4) && _react2.default.createElement(
	          'div',
	          { className: 'noti needForsi', onClick: this.toggleHeaderInfo.bind(this, 'ManualMerges_open') },
	          _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.HeaderIcons.Update_With_Circle_White, ariaText: (0, _helpers.translation)(auth.permissions.ChainAssessmentSystem === 2 ? 18065 : 2201), ariaPos: 'bottom' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'icon-number' },
	            headerInfo.ManualMerges.length
	          )
	        ),
	        forsiEnable && (!headerInfo.ForsiActive || headerInfo.UsesForsiToken && !headerInfo.ForsiTokenActive) && _react2.default.createElement(
	          'div',
	          { className: 'noti', onClick: this.toggleHeaderInfo.bind(this, 'ForsiActive_open') },
	          _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.HeaderIcons.Forsi_Not_Active_White, ariaText: (0, _helpers.translation)('1800'), ariaPos: 'bottom' })
	        ),
	        headerInfo.BookingPortalDrafts !== null && Array.isArray(headerInfo.BookingPortalDrafts) && headerInfo.BookingPortalDrafts.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'noti', onClick: this.toggleHeaderInfo.bind(this, 'BookingPortalDrafts_open') },
	          _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.HeaderIcons.BookingRequest_White, ariaText: (0, _helpers.translation)(16749), ariaPos: 'bottom' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'icon-number' },
	            headerInfo.BookingPortalDrafts.length
	          )
	        ),
	        renderMessages(),
	        renderTasks(),
	        renderOrders(),
	        this.state.headerInfo.Updates_open && headerInfo.Updates.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'dropdown__menu' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              (0, _helpers.translation)('13363')
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              headerInfo.Updates.map(renderUpdates)
	            )
	          )
	        ),
	        this.state.headerInfo.EconomicMatches_open && this.state.headerInfos.EconomicMatches.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'dropdown__menu' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              (0, _helpers.translation)('13040'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'search_link', onClick: this.searchEconomicNotMatched },
	              (0, _helpers.translation)('14810')
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              this.state.headerInfos.EconomicMatches.map(renderEconomicMatches)
	            )
	          )
	        ),
	        this.state.headerInfo.ManualMerges_open && headerInfo.ManualMerges.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: 'dropdown__menu' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              (0, _helpers.translation)('941')
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              headerInfo.ManualMerges.map(renderMerge)
	            )
	          )
	        ),
	        this.state.headerInfo.ForsiActive_open && (!headerInfo.ForsiActive || headerInfo.UsesForsiToken && !headerInfo.ForsiTokenActive) && _react2.default.createElement(
	          'div',
	          { className: 'dropdown__menu' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              (0, _helpers.translation)('6')
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/settings/forsi', onClick: this.toggleHeaderInfo },
	                  '- ',
	                  (0, _helpers.translation)('13438')
	                )
	              )
	            )
	          )
	        ),
	        this.state.headerInfo.BookingPortalDrafts_open && _react2.default.createElement(
	          'div',
	          { className: 'dropdown__menu' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              (0, _helpers.translation)(16749)
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              headerInfo.BookingPortalDrafts.map(renderBookingPortalDraft)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var backdropClass = '';
	      var backdropClick = this.openMenu;
	      var loadingDiv = void 0;
	      var hasNotificationClass = '';
	      if (this.props.headerInfo.ChainNotification !== null && this.props.headerInfo.ChainNotification !== '' && this.props.headerInfo.ChainNotification !== undefined) {
	        hasNotificationClass = 'hasNotification';
	      }
	      if (this.props.backdrop.backdropOpen) {
	        backdropClass += 'open ';
	      } else {
	        backdropClass += 'closed ';
	      }
	      if (this.props.backdrop.modalOpen && !this.props.backdrop.menuOpen) {
	        backdropClass += 'modal-open ';
	      }
	      if (this.props.backdrop.backdropHighZindex) {
	        backdropClass += 'zindexBackdrop ';
	        backdropClick = false;
	        loadingDiv = _react2.default.createElement(
	          'div',
	          { className: 'updating--state' },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('13382')
	          ),
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	        );
	      }
	
	      if (!this.props.backdrop.bodyScroll) {
	        backdropClass += 'noScroll ';
	      }
	
	      // Touch class
	      var touchClass = 'body-no-touch';
	      if ((0, _detect.isTouchDevice)()) {
	        touchClass = 'body-has-touch';
	      }
	
	      // const freeBox = () => {
	      //   if (!hasAccess([3, 4, 5, 7, 8], this.props.auth.user.UserType)) return null
	      //   if (hasSubscriptionPermission(this.props.auth, 0)) return null
	      //   return (
	      //     <div className='freeBox'>
	      //       <img src='/images/icons/Apromas-free200x200px.png' />
	      //       <a href='/'>{translation('2147')} <b>{translation('2148').toUpperCase()}</b></a>
	      //     </div>
	      //   )
	      // }
	
	      var renderChainMsg = function renderChainMsg() {
	        var msg = _this7.props.headerInfo.ChainNotification;
	        if (msg === undefined || msg === null || msg === '') return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'chain-notification' },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('div', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              msg
	            )
	          )
	        );
	      };
	      // {false && freeBox()}
	      // if (routeBlank.includes(this.props.location.pathname)) {
	      //   return (
	      //     <div className={'backdrop-' + backdropClass + ' ' + touchClass + ' ' + hasNotificationClass + ' ' + (this.props.backdrop.menuOpen ? 'menu-open' : 'menu-closed') + (this.props.hasOverlay ? ' overlay-open' : ' overlay-closed')}>
	      //       <div className='layout__content'>
	      //         {this.props.children}
	      //       </div>
	      //     </div>
	      //   )
	      // }
	      // else {
	      return _react2.default.createElement(
	        'div',
	        { className: 'backdrop-' + backdropClass + ' ' + touchClass + ' ' + hasNotificationClass + ' ' + (this.props.backdrop.menuOpen ? 'menu-open' : 'menu-closed') + (this.props.hasOverlay ? ' overlay-open' : ' overlay-closed') },
	        _react2.default.createElement('div', { onClick: backdropClick, className: 'backdrop ' + (this.props.backdrop.backdropOpen ? 'open' : 'closed') }),
	        loadingDiv,
	        _react2.default.createElement(
	          _ShortCutBar2.default,
	          { horizontal: true },
	          _react2.default.createElement(_Menu2.default, { openMenu: this.openMenu, menuOpen: this.props.backdrop.menuOpen })
	        ),
	        renderChainMsg(),
	        _react2.default.createElement(
	          _TopBar2.default,
	          { router: this.props.router },
	          this.renderHeaderInfo(),
	          _react2.default.createElement(
	            'div',
	            { className: 'layout__dropdowns' },
	            (0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.auth.departmentType === 0 && _react2.default.createElement(_NewsFeed2.default, { item: this.props.headerInfo.NewsItem, refreshItem: this.getHeaderInfo }),
	            _react2.default.createElement(_UserMenu2.default, { router: this.props.router })
	          )
	        ),
	        _react2.default.createElement(
	          _ShortCutBar2.default,
	          null,
	          _react2.default.createElement(_Menu2.default, { openMenu: this.openMenu, menuOpen: this.props.backdrop.menuOpen })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'layout__content' },
	          this.props.children
	        ),
	        _react2.default.createElement(_ReportMerge2.default, { item: this.state.selectedReportMergeInfo })
	      );
	    }
	    // }
	
	  }]);
	
	  return Layout;
	}(_react.Component);
	
	Layout.propTypes = {
	  setOrdersFilter: _propTypes2.default.func.isRequired,
	  backdrop: _propTypes2.default.object.isRequired,
	  triggerMenu: _propTypes2.default.func.isRequired,
	  isBlank: _propTypes2.default.bool
	};
	
	Layout.defaultProps = {
	  isBlank: false
	};
	
	function mapStateToProps(state) {
	  var filter = state.orders.filterOrderlist;
	  if ((0, _auth.hasAccess)([4], state.auth.user.UserType)) {
	    filter = state.orders.filterCustomer;
	  } else if ((0, _auth.hasAccess)([6], state.auth.user.UserType)) {
	    filter = state.orders.filterWP;
	  } else if (state.routing.locationBeforeTransitions.pathname === '/workscreen') {
	    filter = state.orders.filterWorkscreen;
	  }
	  return {
	    filter: filter,
	    auth: state.auth,
	    backdrop: state.backdrop,
	    headerInfo: state.common.headerInfo,
	    hasOverlay: state.common.overlays.length > 0
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerMenu: _backdrop.triggerMenu,
	  getHeaderInfo: _common.getHeaderInfo,
	  setHeaderInfo: _common.setHeaderInfo,
	  UpdateEconomicMatch: _orders.UpdateEconomicMatch,
	  getOrdersAdvanced: _orders.getOrdersAdvanced,
	  setOrdersFilter: _orders.setOrdersFilter,
	  setOrdersSearch: _orders.setOrdersSearch,
	  openOverlay: _common.openOverlay
	})(Layout);

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _auth = __webpack_require__(68);
	
	var _routes = __webpack_require__(426);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	__webpack_require__(1544);
	
	var _helpers = __webpack_require__(2);
	
	var _auth2 = __webpack_require__(8);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import routes
	
	
	// import styles
	
	
	// Utils
	
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu(props) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));
	
	    _this.state = {
	      routes: []
	    };
	    _this.openMenu = _this.openMenu.bind(_this);
	    _this.renderRoute = _this.renderRoute.bind(_this);
	    _this.support = _this.support.bind(_this);
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.makeMenuItems();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.makeMenuItems(); // Recreate menu items to ensure links are valid for the current user (ex. if user switched login from one customer to another...)
	    }
	  }, {
	    key: 'makeMenuItems',
	    value: function makeMenuItems() {
	      var _this2 = this;
	
	      var finalRoutes = [];
	      (0, _routes2.default)(null).map(function (outerRoute) {
	        if (outerRoute.path === '/') {
	          outerRoute.childRoutes.map(function (childRoute) {
	            if (typeof childRoute.menu !== 'undefined') {
	              var link = childRoute.path;
	              if (typeof childRoute.menu.parser !== 'undefined') {
	                link = childRoute.menu.parser(_this2.props.auth.user, childRoute.path);
	              }
	              var title = childRoute.menu.title;
	              if (typeof childRoute.menu.title === 'function') {
	                title = childRoute.menu.title(_this2.props.auth.departmentType);
	              }
	              if (link !== null) {
	                finalRoutes.push({
	                  order: childRoute.menu.order || 100,
	                  title: title,
	                  icon: childRoute.menu.icon,
	                  access: childRoute.menu.access || childRoute.access,
	                  link: link,
	                  isAvailableFree: childRoute.isAvailableFree,
	                  checkAuth: childRoute.checkAuth,
	                  hasValidShop: childRoute.hasValidShop,
	                  permissionId: childRoute.permissionId,
	                  exclPermissionId: childRoute.exclPermissionId,
	                  onlyDev: childRoute.onlyDev,
	                  ValidShopCheck: childRoute.ValidShopCheck,
	                  subscriptionValue: childRoute.subscriptionValue || -10,
	                  maxSubscriptionValue: childRoute.maxSubscriptionValue,
	                  checkPartnerSubscription: childRoute.checkPartnerSubscription === true
	                });
	              }
	            }
	          });
	        }
	      });
	      finalRoutes = finalRoutes.sort(function (a, b) {
	        return a.order - b.order;
	      });
	      this.setState({
	        routes: finalRoutes
	      });
	    }
	  }, {
	    key: 'openMenu',
	    value: function openMenu() {
	      this.props.openMenu();
	    }
	  }, {
	    key: 'renderRoute',
	    value: function renderRoute(item, key) {
	      var UserType = this.props.auth.user.UserType;
	      if ((0, _auth2.isLoginFromShop)(this.props.auth.inactiveUsers)) {
	        // if you logged in as a shop, you shouldn't be able to get an employees rights
	        UserType = 5;
	      }
	      // Check free permissions
	      var permissionId = item.permissionId !== undefined && item.permissionId !== null ? item.permissionId : 0;
	      // if (!hasPermission(this.props.auth, permissionId, item.isAvailableFree)) return null
	      if (!((0, _auth2.hasSubscriptionPermission)(this.props.auth, item.subscriptionValue, permissionId) || item.checkPartnerSubscription && (0, _auth2.hasPartnerSubscriptionPermission)(this.props.auth, item.subscriptionValue))) return null;
	      if (item.exclPermissionId !== undefined) {
	        // let excludeByPermission = hasSubscriptionPermission(this.props.auth, item.subscriptionValue, item.exclPermissionId)
	        if ((0, _auth2.hasSubscriptionPermission)(this.props.auth, item.subscriptionValue, item.exclPermissionId)) return null;
	      }
	      if (typeof item.checkAuth === 'function' && !item.checkAuth(this.props.auth)) return null;
	      if (item.maxSubscriptionValue !== undefined && (0, _auth2.hasSubscriptionPermission)(this.props.auth, item.maxSubscriptionValue)) return null;
	      if (!(0, _auth2.hasAccess)(item.access, UserType)) return null;
	      if (("production") !== 'dev' && item.onlyDev) return null;
	      var hasValidShops = item.hasValidShop;
	      var isValidShop = true;
	      if (hasValidShops !== undefined && hasValidShops.length > 0) {
	        isValidShop = (0, _auth2.hasDepartmentType)(this.props.auth, hasValidShops, UserType, item.ValidShopCheck);
	      }
	      if (isValidShop !== true) {
	        return null;
	      }
	      // if (item.link === '/CarRentals/Overview' && this.props.auth.allowCarRentalOverview !== true) return null
	      // if (item.link === '/CarRental' && this.props.auth.allowCarRentalOverview === true) return null
	      // if (item.link === '/qualitychecksettings' && this.props.auth.departmentType === 1) return null
	      if (item.link === '/insurancecompanylist' && (this.props.auth.departmentType === 0 || this.props.auth.permissions.ChainAssessmentSystem === 0)) return null;
	      if (item.link === '/CarRental' && this.props.auth.departmentType === 0) return null;
	      if (item.link === '/CarRentals/Overview' && this.props.auth.departmentType === 0) return null;
	      if (item.link === '/addresses' && this.props.auth.departmentType === 0 && (0, _auth2.hasAccess)([3, 5, 7], UserType)) return null;
	      if (item.link === '/punchclock' && this.props.auth.shopPunchClockActive !== true) return null;
	      if (item.link === '/forsilist' && this.props.auth.permissions.ChainAssessmentSystem !== 1) return null;
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { className: 'menu-line', key: key, onClick: this.openMenu, to: item.link },
	        _react2.default.createElement(_icon2.default, { size: 'm', icon: item.icon, injectSvg: true }),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)(item.title)
	        )
	      );
	    }
	  }, {
	    key: 'support',
	    value: function support() {
	      if (this.props.auth.user.ChainId === 2 || this.props.auth.user.ChainId === '2' || this.props.auth.user.ChainName === 'LakExperten') {
	        return _react2.default.createElement(
	          'li',
	          { className: 'support' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { target: '_blank', to: 'https://898.tv/apromaslakexpertensupport' },
	            _react2.default.createElement('img', { src: '/images/Q-grey.svg' }),
	            ' ',
	            (0, _helpers.translation)('Fjernsupport')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '70 70 72 85'
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'main__menu' },
	        _react2.default.createElement(
	          'div',
	          { className: 'icon', onClick: this.openMenu },
	          _react2.default.createElement('i', { className: 'fa fa-bars' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'menu__wrapper ' + (this.props.menuOpen ? 'open' : 'closed') },
	          _react2.default.createElement(
	            'ul',
	            null,
	            this.state.routes.map(this.renderRoute),
	            1 === 2 && this.support()
	          )
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	Menu.propTypes = {
	  logout: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { logout: _auth.logout })(Menu);

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1547);
	
	var _helpers = __webpack_require__(2);
	
	var _lodash = __webpack_require__(27);
	
	var _messages = __webpack_require__(280);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Utils
	
	
	// Actions
	
	
	// Elements
	
	
	// import PanelHeader from '../../elements/panelHeader'
	
	var NewsFeed = function (_Component) {
	  _inherits(NewsFeed, _Component);
	
	  function NewsFeed(props) {
	    _classCallCheck(this, NewsFeed);
	
	    var _this = _possibleConstructorReturn(this, (NewsFeed.__proto__ || Object.getPrototypeOf(NewsFeed)).call(this, props));
	
	    _this.state = {
	      isOpened: false,
	      reminder: false,
	      nointerest: false
	    };
	
	    _this.initItem = _this.initItem.bind(_this);
	    _this.toggleNews = _this.toggleNews.bind(_this);
	    // this.handle = this.handle.bind(this)
	    _this.handleAction = _this.handleAction.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewsFeed, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // document.addEventListener('click', this.handle, true)
	      this.initItem(this.props.item);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(next) {
	      if (!(0, _lodash.isEqual)(next.item, this.props.item)) {
	        this.initItem(next.item || this.props.item);
	      }
	    }
	
	    // componentWillUnmount () {
	    // document.removeEventListener('click', this.handle, true)
	    // }
	
	  }, {
	    key: 'initItem',
	    value: function initItem(item) {
	      if (item) {
	        this.setState({
	          isOpened: !item.IsRead,
	          reminder: item.HasReminder
	        });
	      }
	    }
	
	    // handle (e) {
	    //   const el = this.refs.newsContainer
	    //   if (!el.contains(e.target) && this.state.isOpened) this.toggleNews({ target: false })
	    // }
	
	  }, {
	    key: 'toggleNews',
	    value: function toggleNews(open) {
	      var _this2 = this;
	
	      open = typeof open.target !== 'undefined' ? !this.state.isOpened : open;
	      this.setState({
	        isOpened: open
	      }, function () {
	        if (open === false && !_this2.props.item.IsRead) {
	          _this2.handleAction(true);
	        }
	      });
	    }
	  }, {
	    key: 'handleAction',
	    value: function handleAction() {
	      var _this3 = this;
	
	      var isRead = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var data = {
	        MessageId: this.props.item.Id,
	        RemindMe: this.state.reminder,
	        IsDismissed: this.state.nointerest
	      };
	
	      if (isRead) {
	        data = {
	          MessageId: this.props.item.Id,
	          IsRead: true
	        };
	      }
	
	      this.props.updateNewsShowStatus(data).then(function (res) {
	        _this3.setState({
	          isOpened: false
	        });
	
	        if (_this3.state.nointerest) {
	          _this3.props.refreshItem();
	        }
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var name = e.target.name;
	      var value = e.target.checked;
	
	      this.setState(_defineProperty({}, name, value), this.handleAction);
	    }
	  }, {
	    key: 'renderDownloadButton',
	    value: function renderDownloadButton(msgDocument) {
	      if (msgDocument === null || !msgDocument.FileURL) return null;
	
	      var src = msgDocument.FileURL;
	      var label = /.*.pdf$/.test(src.toLowerCase()) ? '2238' : '15294';
	      // return (
	      //   <div className='getPDF'>
	      //     <a href={src} target='_BLANK'>{translation(label)}</a>
	      //   </div>
	      // )
	      return _react2.default.createElement(_button2.default, { spacing: 2, labelText: (0, _helpers.translation)(label), onClick: function onClick() {
	          return window.open(src, '_blank');
	        } });
	    }
	  }, {
	    key: 'renderIllustration',
	    value: function renderIllustration(msgIllustration) {
	      if (msgIllustration === null || !msgIllustration.FileURL) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'news__content-graphics' },
	        _react2.default.createElement('img', { src: msgIllustration.FileURL })
	      );
	    }
	  }, {
	    key: 'renderNewsMenu',
	    value: function renderNewsMenu(item) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'news__dropdown__menu' },
	        _react2.default.createElement(
	          'div',
	          { className: 'news__content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            item.Subtitle
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            item.Body
	          ),
	          this.renderDownloadButton(item.MessageDocument),
	          this.renderIllustration(item.MessageIllustration),
	          _react2.default.createElement(
	            'div',
	            { className: 'news__content-checkboxgroup' },
	            _react2.default.createElement(_check2.default, { spacing: 2, labelText: (0, _helpers.translation)('15278'), id: 'reminder', name: 'reminder', onChange: this.onChange, checked: this.state.reminder }),
	            _react2.default.createElement(_check2.default, { spacing: 2, labelText: (0, _helpers.translation)('15279'), id: 'nointerest', name: 'nointerest', onChange: this.onChange, checked: this.state.nointerest })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'news__footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            (0, _helpers.translation)('15280')
	          ),
	          _react2.default.createElement('img', { src: '/images/icons/support-100x100px.png' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'contact__info' },
	            _react2.default.createElement(
	              'span',
	              null,
	              '+45 70 70 72 85'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'info@apromas.com'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'sales@apromas.com'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      console.log('here ', this.props.item);
	      if (!this.props.item) return null;
	      var item = this.props.item;
	
	      console.log('NEWSFEED - this.props.item ', this.props.item);
	
	      var triggerClass = 'fa fa-chevron-down';
	      if (this.state.isOpened) {
	        triggerClass = 'fa fa-close';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'news__menu', ref: 'newsContainer' },
	        this.state.isOpened && _react2.default.createElement('div', { className: 'news__menu__backdrop', onClick: function onClick() {
	            return _this4.toggleNews({ target: false });
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'newsBox', onClick: this.toggleNews },
	          _react2.default.createElement('img', { src: '/images/svgs/Cirkle_info-white.svg' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'news_title' },
	            _react2.default.createElement(
	              'span',
	              null,
	              item.Title
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              item.Subtitle
	            )
	          ),
	          _react2.default.createElement('i', { className: triggerClass })
	        ),
	        this.state.isOpened && this.renderNewsMenu(item)
	      );
	    }
	  }]);
	
	  return NewsFeed;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateNewsShowStatus: _messages.updateNewsShowStatus
	})(NewsFeed);

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1548);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _UserInfo = __webpack_require__(87);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// elements
	
	// import LabelWrapper from '../../elements/labelWrapper'
	// components
	
	
	// uitils
	
	
	var Notes = function (_Component) {
	  _inherits(Notes, _Component);
	
	  function Notes() {
	    _classCallCheck(this, Notes);
	
	    return _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).apply(this, arguments));
	  }
	
	  _createClass(Notes, [{
	    key: 'renderNote',
	    value: function renderNote(item, key) {
	      return _react2.default.createElement(
	        'div',
	        { key: key, className: 'display-note-item' },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'max-content'], align: 'start' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_UserInfo2.default, { user: item.UserInfo }),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: [0] },
	              (0, _time.renderFullDate)(item.NoteDate)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)(item.SourceDictionaryKey),
	          ': ',
	          item.Note
	        ),
	        item.ShareType > 0 && _react2.default.createElement(
	          _label2.default,
	          null,
	          (0, _helpers.translation)('17861'),
	          (0, _helpers.getOrderNoteShareString)(item.ShareType)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.notes) return null;
	
	      if (this.props.inline) {
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: '1fr', nogap: true },
	          this.props.notes.map(this.renderNote)
	        );
	      }
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(14834) + ' (' + this.props.notes.length + ')' },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: '1fr', nogap: true },
	          this.props.notes.map(this.renderNote)
	        )
	      );
	    }
	  }]);
	
	  return Notes;
	}(_react.Component);
	
	Notes.defaultProps = {
	  notes: [],
	  inline: false // Determines if elements wrapped in a Panel
	};
	
	exports.default = Notes;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _common = __webpack_require__(25);
	
	__webpack_require__(1549);
	
	var _HelpText = __webpack_require__(130);
	
	var _HelpText2 = _interopRequireDefault(_HelpText);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	var NotificationCopy = function (_Component) {
	  _inherits(NotificationCopy, _Component);
	
	  function NotificationCopy(props) {
	    _classCallCheck(this, NotificationCopy);
	
	    var _this = _possibleConstructorReturn(this, (NotificationCopy.__proto__ || Object.getPrototypeOf(NotificationCopy)).call(this, props));
	
	    _this.onCheck = _this.onCheck.bind(_this);
	    return _this;
	  }
	
	  _createClass(NotificationCopy, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.notificationEventType === undefined) {
	        this.props.getEnums();
	      }
	    }
	  }, {
	    key: 'renderNotifications',
	    value: function renderNotifications() {
	      var _this2 = this;
	
	      if (this.props.notificationEventType === undefined || this.props.notificationEventType === null || this.props.notificationEventType.length === 0) {
	        return;
	      }
	      // if (!hasPermission(this.props.auth, 0, false)) return null
	      var user = this.props.user;
	
	      var NotificationEventTypeList = function NotificationEventTypeList(val, key) {
	        if (val.Id >= 100) {
	          var helptext = '';
	          switch (val.Id) {
	            case 100:
	              helptext = '2169';
	              break;
	            case 102:
	              helptext = '15023'; // '2170'
	              break;
	            case 103:
	              helptext = '2171';
	              break;
	            case 104:
	              helptext = '15024'; // '2198'
	              break;
	            case 105:
	              helptext = '2172';
	              break;
	            case 106:
	              helptext = '2173';
	              break;
	            case 108:
	              helptext = '15022';
	              break;
	          }
	
	          var notification = [];
	          if (user.NotificationSettings !== undefined) {
	            notification = user.NotificationSettings.filter(function (x) {
	              return x.NotificationEvent === val.Id;
	            });
	          }
	          var Email = false;
	          var Sms = false;
	          if (notification.length > 0) {
	            Email = notification[0].Email;
	            Sms = notification[0].Sms;
	          }
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: [_this2.props.SMS ? 2 : 3], spacing: 1, key: key },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(val.key),
	              ' ',
	              _react2.default.createElement(_HelpText2.default, { text: (0, _helpers.translation)(helptext) })
	            ),
	            _react2.default.createElement(_check2.default, { name: 'Email', value: val.Id, checked: Email, onChange: _this2.onCheck, disabled: user.Email === null || user.Email.length === 0, simple: true }),
	            _this2.props.SMS && _react2.default.createElement(_check2.default, { name: 'Sms', value: val.Id, checked: Sms, onChange: _this2.onCheck, disabled: user.Phone === null || user.Phone.length === 0, simple: true })
	          );
	        } else {
	          return null;
	        }
	      };
	      var notificationEventType = [];
	      var vals = Object.values(this.props.notificationEventType);
	      var keys = Object.keys(this.props.notificationEventType);
	      for (var i = 0; i < keys.length; i++) {
	        notificationEventType.push({ Id: parseInt(keys[i]), key: vals[i] });
	      }
	      var title = user.Department !== 0 ? '13461' : '14947';
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(title) },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [this.props.SMS ? 2 : 3], spacing: 1 },
	          _react2.default.createElement('span', null),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('1052')
	          ),
	          this.props.SMS && _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('15')
	          )
	        ),
	        notificationEventType.map(NotificationEventTypeList)
	      );
	    }
	  }, {
	    key: 'onCheck',
	    value: function onCheck(e) {
	      var user = _extends({}, this.props.user);
	      // check if set
	      var set = false;
	      var array = [].concat(_toConsumableArray(user.NotificationSettings));
	      array.map(function (val, key) {
	        // console.log('Checked: ', key, val)
	        if (val.NotificationEvent === Number(e.target.value)) {
	          set = true;
	          if (e.target.name === 'Sms') {
	            array[key].Sms = e.target.checked;
	          } else if (e.target.name === 'Email') {
	            array[key].Email = e.target.checked;
	          }
	        }
	      });
	      // if not set - add object
	      if (set === false) {
	        var newItem = {};
	        if (e.target.name === 'Sms') {
	          newItem = {
	            NotificationEvent: Number(e.target.value),
	            Sms: e.target.checked,
	            Email: false
	          };
	        } else if (e.target.name === 'Email') {
	          newItem = {
	            NotificationEvent: Number(e.target.value),
	            Sms: false,
	            Email: e.target.checked
	          };
	        }
	        array.push(newItem);
	        // if set change
	      }
	
	      this.props.SaveNotifications(array);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'notification_copy__wrapper' },
	        this.renderNotifications()
	      );
	    }
	  }]);
	
	  return NotificationCopy;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    notificationEventType: state.common.enums_new.NotificationEventType
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getEnums: _common.getEnums
	})(NotificationCopy);

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1550);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Constants
	
	
	// import styles
	
	
	var OtherFileList = function (_Component) {
	  _inherits(OtherFileList, _Component);
	
	  function OtherFileList() {
	    _classCallCheck(this, OtherFileList);
	
	    return _possibleConstructorReturn(this, (OtherFileList.__proto__ || Object.getPrototypeOf(OtherFileList)).apply(this, arguments));
	  }
	
	  _createClass(OtherFileList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderFile = function renderFile(file, index) {
	        console.log('file', file);
	        var deleteFile = function deleteFile(file) {
	          var confirm = {
	            confirm: true,
	            file: file
	          };
	          _this2.setState({
	            confirmFileDelete: confirm
	          });
	        };
	        // let fileUrl = file.FileURL.replace('API/', '')
	        if (file.ActualFileName === null) return null;
	        var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(_this2.props.auth.user.Token);
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	        // Return
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-document clearfix' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          _react2.default.createElement(
	            'a',
	            { target: '_BLANK', href: newFileUrl },
	            file.FileName
	          ),
	          _this2.props.showDelete && file.IsDeletable && _react2.default.createElement('img', { className: 'file-delete', src: '/images/icons/Delete_16.png', onClick: function onClick() {
	              return deleteFile(file);
	            } })
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: '' },
	        console.log('this.props', this.props),
	        this.props.files.map(renderFile)
	      );
	    }
	  }]);
	
	  return OtherFileList;
	}(_react.Component);
	
	exports.default = OtherFileList;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _reactHoverObserver = __webpack_require__(684);
	
	var _reactHoverObserver2 = _interopRequireDefault(_reactHoverObserver);
	
	var _mypage = __webpack_require__(151);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1551);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Components
	
	
	// Utils
	
	
	// Styles
	
	
	// Elements
	
	
	var OthertaskHover = function (_Component) {
	  _inherits(OthertaskHover, _Component);
	
	  function OthertaskHover(props) {
	    _classCallCheck(this, OthertaskHover);
	
	    var _this = _possibleConstructorReturn(this, (OthertaskHover.__proto__ || Object.getPrototypeOf(OthertaskHover)).call(this, props));
	
	    _this.onHoverChanged = _this.onHoverChanged.bind(_this);
	    _this.state = {
	      active: false,
	      status: 'loading'
	    };
	    return _this;
	  }
	
	  _createClass(OthertaskHover, [{
	    key: 'getFiles',
	    value: function getFiles(id) {
	      var _this2 = this;
	
	      this.props.getOccurenceFiles(id).then(function (res) {
	        _this2.setState({
	          files: res.data,
	          status: 'loaded'
	        });
	      }, function () {
	        _this2.setState({
	          status: 'failed'
	        });
	      });
	    }
	  }, {
	    key: 'onHoverChanged',
	    value: function onHoverChanged(data) {
	      var _this3 = this;
	
	      if (data.isHovering !== this.state.active) {
	        this.setState({
	          active: data.isHovering,
	          status: data.isHovering ? this.state.status : 'loading',
	          files: data.isHovering ? this.state.files : undefined
	        }, function () {
	          if (data.isHovering) {
	            _this3.getFiles(_this3.props.id);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'renderAttachments',
	    value: function renderAttachments(files) {
	      if (files.length === 0) return null;
	
	      var imgFiles = [];
	      var otherFiles = [];
	      files.forEach(function (file) {
	        return file.IsImage ? imgFiles.push(file) : otherFiles.push(file);
	      });
	
	      var renderFile = function renderFile(file, index) {
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	        return _react2.default.createElement(
	          'li',
	          { key: index, className: 'file-document' },
	          _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	          _react2.default.createElement(
	            'a',
	            { target: '_BLANK', href: file.FileURL },
	            file.FileName
	          )
	        );
	      };
	      // Render image
	      var renderImage = function renderImage(image, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            'a',
	            { href: image.FileURL, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	            _react2.default.createElement('img', { src: image.ThumbURL })
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'attachments' },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('352') },
	          otherFiles.length !== 0 && _react2.default.createElement(
	            'div',
	            { className: 'docs' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              otherFiles.map(renderFile)
	            )
	          ),
	          imgFiles.length !== 0 && _react2.default.createElement(_Gallery2.default, { files: imgFiles, renderImage: renderImage })
	        )
	      );
	    }
	  }, {
	    key: 'renderPopup',
	    value: function renderPopup() {
	      if (this.state.status === 'loading') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'hover_extent-popup' },
	          _react2.default.createElement(
	            'p',
	            { className: 'loading' },
	            _react2.default.createElement(
	              'span',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            )
	          )
	        );
	      }
	      if (this.state.status === 'failed') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'hover_extent-popup' },
	          _react2.default.createElement(
	            'p',
	            { className: 'loading' },
	            (0, _helpers.translation)('2269')
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'hover_extent-popup' },
	        _react2.default.createElement(
	          'div',
	          { className: 'extent_box clearfix' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('1021') },
	              this.props.item.Description ? this.props.item.Description : (0, _helpers.translation)('15101')
	            ),
	            this.state.files && this.renderAttachments(this.state.files.OtherTaskFiles)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactHoverObserver2.default,
	        {
	          className: 'othertaskHover',
	          hoverDelayInMs: 1000,
	          hoverOffDelayInMs: 500,
	          onHoverChanged: this.onHoverChanged,
	          shouldDecorateChildren: false },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.children,
	          this.state.active && this.renderPopup()
	        )
	      );
	    }
	  }]);
	
	  return OthertaskHover;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOccurenceFiles: _mypage.getOccurenceFiles
	})(OthertaskHover);

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1554);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay(props) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));
	
	    _this.state = {
	      isOpen: false
	    };
	    _this.triggerOpen = _this.triggerOpen.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._mounted = true;
	      if (typeof this.props.open !== 'undefined') {
	        if (this.props.open) {
	          this.triggerOpen();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (typeof nextProps.open !== 'undefined') {
	        if (this.props.open !== nextProps.open) {
	          if (nextProps.open) {
	            this.triggerOpen();
	          }
	        }
	      }
	      if (this.nextProps !== undefined && this.nextProps.checkForPopups !== undefined) this.nextProps.checkForPopups();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.dontHandleClick) {
	        document.removeEventListener('click', this.handleClick, false);
	      }
	      this._mounted = false;
	    }
	  }, {
	    key: 'triggerOpen',
	    value: function triggerOpen(e) {
	      var _this2 = this;
	
	      if (e !== undefined) {
	        e.preventDefault();
	      }
	      setTimeout(function () {
	        if (_this2.props.checkForPopups !== undefined) _this2.props.checkForPopups();
	      }, 100);
	      if (!this.state.isOpen) {
	        if (!this.props.dontHandleClick) {
	          document.addEventListener('click', this.handleClick, false);
	        }
	        if (typeof this.props.openClick !== 'undefined') {
	          this.props.openClick(true);
	        }
	      } else {
	        if (typeof this.props.openClick !== 'undefined') {
	          this.props.openClick(false);
	        }
	        if (!this.props.dontHandleClick) {
	          document.removeEventListener('click', this.handleClick, false);
	        }
	      }
	
	      this.setState({
	        isOpen: !this.state.isOpen
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      document.removeEventListener('click', this.handleClick, false);
	      this.setState({
	        isOpen: false
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (e.defaultPrevented === true) {
	        e.preventDefault();
	        return false;
	      }
	      if (e.target.dataset.action === 'close') {
	        if (this._mounted) {
	          this.triggerOpen();
	        }
	        return false;
	      }
	      var component = _reactDom2.default.findDOMNode(this.refs.component);
	      if (e.target === component || component.contains(e.target) || this.props.allowExtraClasses.indexOf(e.target.className) !== -1) {
	        if (e.target.tagName.toLowerCase() === 'a') {
	          this.props.handleClick(e.target);
	          if (e.target.dataset.action !== 'delete') {
	            if (this._mounted) {
	              this.triggerOpen();
	            }
	          }
	        }
	      } else {
	        if (this._mounted) {
	          this.triggerOpen();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var actionMenu = '';
	      if (this.state.isOpen) {
	        actionMenu = this.props.renderActionMenu(this.triggerOpen);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className, ref: 'component' },
	        this.props.renderActionOpener(this.triggerOpen),
	        actionMenu
	      );
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.propTypes = {
	  renderActionMenu: _propTypes2.default.func.isRequired,
	  renderActionOpener: _propTypes2.default.func.isRequired
	};
	
	Overlay.defaultProps = {
	  className: 'overlay',
	  allowExtraClasses: [],
	  renderActionOpener: function renderActionOpener(triggerOpen) {
	    return _react2.default.createElement(
	      'span',
	      { onClick: triggerOpen },
	      _react2.default.createElement('img', { src: '/images/icons/menu_dots16.png' })
	    );
	  },
	  renderActionMenu: function renderActionMenu() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'poppedup' },
	      'Content'
	    );
	  }
	};
	
	exports.default = Overlay;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(43);
	
	var _LicensePlate = __webpack_require__(295);
	
	var _LicensePlate2 = _interopRequireDefault(_LicensePlate);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1556);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverviewOrderItem = function (_Component) {
	  _inherits(OverviewOrderItem, _Component);
	
	  function OverviewOrderItem() {
	    _classCallCheck(this, OverviewOrderItem);
	
	    return _possibleConstructorReturn(this, (OverviewOrderItem.__proto__ || Object.getPrototypeOf(OverviewOrderItem)).apply(this, arguments));
	  }
	
	  _createClass(OverviewOrderItem, [{
	    key: 'getIcon',
	    value: function getIcon(orderStep) {
	      switch (orderStep) {
	        // Draft = 0,
	        // New = 1,
	        // BodyShopDisassemply = 101,
	        // BodyShopRepair = 102,
	        // BodyShopPainting = 105,
	        // Pretreatment = 2,
	        // Filling = 3,
	        // Sanding = 4,
	        // Painting = 5,
	        // Finishing = 6,
	        // BodyShopAssemply = 103,
	        // BodyShopFinishing = 104,
	        // Delivery = 7,
	        // Archive = 8
	        case 0:
	        case 1:
	          return _icons.ProductionStatus.Step_New;
	        case 2:
	          return _icons.ProductionStatus.Step_Preparing;
	        case 3:
	          return _icons.ProductionStatus.Step_Filler;
	        case 4:
	          return _icons.ProductionStatus.Step_Sanding;
	        case 5:
	          return _icons.ProductionStatus.Step_Painting;
	        case 6:
	          return _icons.ProductionStatus.Step_Finishing;
	        case 7:
	          return _icons.ProductionStatus.Step_Handover;
	        case 101:
	          return _icons.ProductionStatus.Step_BodyShopDisassemply;
	        case 102:
	          return _icons.ProductionStatus.Step_BodyShopRepair;
	        case 103:
	          return _icons.ProductionStatus.Step_BodyShopAssembly;
	        case 104:
	          return _icons.ProductionStatus.Step_BodyShopFinishing;
	        case 105:
	          return _icons.ProductionStatus.Step_Painting;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var brandName = this.props.BrandName === '2000' ? (0, _helpers.translation)(this.props.BrandName) : this.props.BrandName;
	      var orderLink = this.props.OrderId > 0 ? '/orders/' + this.props.OrderId : null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'overvieworderitem' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: orderLink },
	          _react2.default.createElement(
	            'div',
	            { className: 'top' },
	            _react2.default.createElement(
	              'div',
	              { className: 'brand-model' },
	              brandName + ' ' + this.props.Model
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bottom' },
	            _react2.default.createElement(_LicensePlate2.default, { regNr: this.props.RegNr, countryCode: this.props.CountryCode }),
	            _react2.default.createElement(
	              'div',
	              { className: 'secondarytext' },
	              this.props.SecondaryText
	            ),
	            _react2.default.createElement(_icon2.default, { size: 's', icon: this.getIcon(this.props.OrderStep) })
	          )
	        )
	      );
	    }
	  }]);
	
	  return OverviewOrderItem;
	}(_react.Component);
	
	OverviewOrderItem.defaultProps = {
	  OrderId: 0,
	  BrandName: '',
	  Model: '',
	  RegNr: '',
	  PlateType: 0,
	  OrderStep: 1,
	  SecondaryText: null
	};
	
	exports.default = OverviewOrderItem;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1559);
	
	var _auth = __webpack_require__(8);
	
	var _overview = __webpack_require__(225);
	
	var _Overview = __webpack_require__(297);
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	var PickupStatusOverview = function (_Component) {
	  _inherits(PickupStatusOverview, _Component);
	
	  function PickupStatusOverview(props) {
	    _classCallCheck(this, PickupStatusOverview);
	
	    var _this = _possibleConstructorReturn(this, (PickupStatusOverview.__proto__ || Object.getPrototypeOf(PickupStatusOverview)).call(this, props));
	
	    _this.pageRef = null;
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(PickupStatusOverview, [{
	    key: 'render',
	    value: function render() {
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 30)) return null;
	
	      return _react2.default.createElement(_Overview2.default, {
	        itemType: 'order',
	        getItems: this.props.getPickupStatus
	      });
	    }
	  }]);
	
	  return PickupStatusOverview;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPickupStatus: _overview.getPickupStatus
	})(PickupStatusOverview);

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isTouchDevice } from '../../../utils/detect'
	
	// styles
	
	
	var StickyContainer = function (_Component) {
	  _inherits(StickyContainer, _Component);
	
	  function StickyContainer(props) {
	    _classCallCheck(this, StickyContainer);
	
	    var _this = _possibleConstructorReturn(this, (StickyContainer.__proto__ || Object.getPrototypeOf(StickyContainer)).call(this, props));
	
	    _this.state = {};
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.getDistanceFromTop = _this.getDistanceFromTop.bind(_this);
	    return _this;
	  }
	
	  _createClass(StickyContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var el = Array.from(document.querySelectorAll('.sticky'))[this.props.order];
	      var shortcuts = document.querySelector('.layout__shortcuts.horizontal');
	      this.setState({
	        top: el.getBoundingClientRect().top,
	        height: el.offsetHeight,
	        width: el.offsetWidth,
	        posRight: el.getBoundingClientRect().right,
	        offset: shortcuts.offsetHeight
	      });
	      window.addEventListener('scroll', this.handleScroll, true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll, true);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      var appDiv = document.getElementById('app');
	      // appDiv.scrollTop > this.state.top - pos ? el.style.paddingTop = `${this.state.height + pos}px` : el.style.paddingTop = 0
	      this.setState({
	        scroll: appDiv.scrollTop
	      });
	    }
	  }, {
	    key: 'getDistanceFromTop',
	    value: function getDistanceFromTop() {
	      // if not first sticky div, account for the others before it, when setting top position
	      var fixedStickies = Array.from(document.querySelectorAll('.sticky')).slice(0, this.props.order);
	      var dist = fixedStickies.reduce(function (distanceTop, el) {
	        distanceTop += el.offsetHeight;
	        return distanceTop;
	      }, 0);
	
	      return this.state.offset + dist;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var stickyClass = 'sticky';
	      var dist = this.getDistanceFromTop();
	      var style = void 0;
	
	      if (this.state.scroll >= this.state.top - dist) {
	        stickyClass += ' fixed_sticky';
	        var el = Array.from(document.querySelectorAll('.sticky'))[this.props.order];
	        el.style.top = (this.props.order > 0 ? dist : this.state.offset) + 'px';
	      }
	
	      // to fix multiple sticky components used, where some could conflict like a dropdown
	      if (this.props.specificIndex && Number.isInteger(this.props.specificIndex)) style = { zIndex: this.props.specificIndex };
	      return _react2.default.createElement(
	        'div',
	        { ref: 'sticky', className: stickyClass, style: style },
	        this.props.renderContent()
	      );
	    }
	  }]);
	
	  return StickyContainer;
	}(_react.Component);
	
	StickyContainer.PropTypes = {
	  renderContent: _propTypes2.default.func,
	  order: _propTypes2.default.required
	};
	
	exports.default = StickyContainer;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _upload = __webpack_require__(309);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1566);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	var UploadOverlay = function (_Component) {
	  _inherits(UploadOverlay, _Component);
	
	  function UploadOverlay(props) {
	    _classCallCheck(this, UploadOverlay);
	
	    var _this = _possibleConstructorReturn(this, (UploadOverlay.__proto__ || Object.getPrototypeOf(UploadOverlay)).call(this, props));
	
	    _this.state = {
	      inProgress: false,
	      progress: 0
	    };
	
	    _this.newProps = _this.newProps.bind(_this);
	    return _this;
	  }
	
	  _createClass(UploadOverlay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _upload.clearUploads)();
	      this.newProps(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      this.newProps(next);
	    }
	  }, {
	    key: 'newProps',
	    value: function newProps(props) {
	      this.setState({
	        inProgress: props.inProgress,
	        progress: props.progress
	      }, this.forceUpdate);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          inProgress = _state.inProgress,
	          progress = _state.progress;
	
	      if (!inProgress || progress >= 100) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'upload_window' },
	        _react2.default.createElement(
	          'div',
	          { className: 'count' },
	          _react2.default.createElement(
	            'span',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'sr-only' },
	              (0, _helpers.translation)('13382'),
	              '...'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'right' },
	          _react2.default.createElement(
	            'div',
	            { className: 'top' },
	            _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              (0, _helpers.translation)('14750')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'abort' },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)('14751')
	              ),
	              _react2.default.createElement(
	                'span',
	                { onClick: function onClick() {
	                    (0, _upload.cancelUploads)();
	                  } },
	                'X'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'progressframe' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'fill', style: { width: progress + '%' } },
	                '\xA0'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UploadOverlay;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    progress: state.uploads.progress,
	    inProgress: state.uploads.inProgress
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(UploadOverlay);

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _auth = __webpack_require__(68);
	
	var _actions = __webpack_require__(129);
	
	var _mypage = __webpack_require__(151);
	
	var _common = __webpack_require__(25);
	
	__webpack_require__(1568);
	
	var _auth2 = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _HelpText = __webpack_require__(130);
	
	var _HelpText2 = _interopRequireDefault(_HelpText);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	
	
	// Components
	
	// import Icon from '../../elements/icon'
	// import { HeaderIcons } from '../../elements/icons'
	
	// Elements
	
	
	var UserMenu = function (_Component) {
	  _inherits(UserMenu, _Component);
	
	  function UserMenu(props) {
	    _classCallCheck(this, UserMenu);
	
	    var _this = _possibleConstructorReturn(this, (UserMenu.__proto__ || Object.getPrototypeOf(UserMenu)).call(this, props));
	
	    _this.state = {
	      isOpen: false,
	      isLanguageOpen: false,
	      myPage: {
	        Orders: 0,
	        Tasks: 0,
	        Messages: 0
	      },
	      countdown: 0
	      // selectedShop: 0
	    };
	    _this.toggleMenu = _this.toggleMenu.bind(_this);
	    _this.toggleLanguageMenu = _this.toggleLanguageMenu.bind(_this);
	    _this.signOut = _this.signOut.bind(_this);
	    _this.changeLanguage = _this.changeLanguage.bind(_this);
	    _this.changeLanguageInfo = _this.changeLanguageInfo.bind(_this);
	    _this.handle = _this.handle.bind(_this);
	    _this.renderShopSelector = _this.renderShopSelector.bind(_this);
	    _this.renderName = _this.renderName.bind(_this);
	    _this.timer = undefined;
	    return _this;
	  }
	
	  _createClass(UserMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('click', this.handle, true);
	      this.startTimer();
	      // this.setState({
	      //   selectedShop: Number(this.props.auth.user.ShopId)
	      // })
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.handle, true);
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.loginTimer.getTime() !== this.props.loginTimer.getTime()) {
	        this.startTimer();
	      }
	      // console.log('this.props.auth.user.ShopId ', this.props.auth.user.ShopId)
	      // if (nextProps.auth.user.ShopId !== this.props.auth.user.ShopId) {
	      //   this.setState({
	      //     selectedShop: Number(nextProps.auth.user.ShopId)
	      //   })
	      // }
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this2 = this;
	
	      if (!(0, _auth2.hasAccess)([3], this.props.auth.user.UserType) || this.props.auth.inactiveUsers.length === 0) return null;
	      // console.log('this.props.auth.inactiveUsers.length ', this.props.auth.inactiveUsers.length)
	      clearInterval(this.timer);
	      this.timer = setInterval(function () {
	        var now = window.CustomDate();
	        var diff = Math.floor((_this2.props.loginTimer.getTime() - now.getTime()) / 1000);
	        if (diff <= 0) diff = 0;
	        _this2.setState({
	          countdown: diff
	        });
	      }, 1000);
	    }
	  }, {
	    key: 'handle',
	    value: function handle(e) {
	      var el = this.refs.container1;
	      if (!el.contains(e.target) && this.state.isOpen) this.toggleMenu({ target: false });
	    }
	  }, {
	    key: 'toggleMenu',
	    value: function toggleMenu(open) {
	      var _this3 = this;
	
	      open = typeof open.target !== 'undefined' ? !this.state.isOpen : open;
	      this.setState({
	        isOpen: open
	      }, function () {
	        if (_this3.state.isOpen) {
	          _this3.getMyPageInformation();
	        }
	      });
	    }
	  }, {
	    key: 'toggleLanguageMenu',
	    value: function toggleLanguageMenu(open) {
	      open = typeof open.target !== 'undefined' ? !this.state.isLanguageOpen : open;
	      this.setState({
	        isLanguageOpen: open
	      });
	    }
	  }, {
	    key: 'getMyPageInformation',
	    value: function getMyPageInformation() {
	      var _this4 = this;
	
	      if (!(0, _auth2.hasAccess)([3], this.props.auth.user.UserType)) return null;
	      this.props.myPageInformation(0).then(function (res) {
	        _this4.setState({
	          myPage: res.data
	        });
	      });
	    }
	  }, {
	    key: 'signOut',
	    value: function signOut(e) {
	      var _this5 = this;
	
	      e.preventDefault();
	      this.toggleMenu({ target: false });
	      if (this.props.auth.inactiveUsers.length === 0) {
	        this.props.logout();
	        this.props.router.push('/login');
	      } else {
	        this.props.logOutAs().then(function () {
	          _this5.props.router.push('/');
	        });
	      }
	    }
	  }, {
	    key: 'changeLanguage',
	    value: function changeLanguage(e) {
	      e.preventDefault();
	      this.toggleMenu({ target: false });
	      var lang = window.localStorage.getItem('user_language') === 'English' ? 'Danish' : 'English';
	      this.props.setLanguage(lang);
	    }
	  }, {
	    key: 'changeLanguageInfo',
	    value: function changeLanguageInfo(langInfo) {
	      this.toggleLanguageMenu({ target: false });
	      var lang = langInfo.LanguageName;
	      this.props.setLanguage(lang);
	    }
	
	    // renderMessages () { // Moved to layout with other header info
	    //   if (this.props.headerInfo.UnreadMessages === 0) return null
	    //   return (
	    //     <div className='notification'>
	    //       <Link to='/mypage/messages' onClick={this.toggleMenu.bind(this, false)}>
	    //         <Icon size='m' icon={HeaderIcons.Message_With_Circle_White} />
	    //       </Link>
	    //     </div>
	    //   )
	    // }
	
	    // renderTasks () {  // Moved to layout with other header info
	    //   if (!hasSubscriptionPermission(this.props.auth, 30) || this.props.headerInfo.IncompletedTasks === 0) return null
	    //   return (
	    //     <div className='notification'>
	    //       <Link to='/mypage/tasks' onClick={this.toggleMenu.bind(this, false)}>
	    //         <Icon size='m' icon={HeaderIcons.Task_With_Circle_White} />
	    //       </Link>
	    //     </div>
	    //   )
	    // }
	
	  }, {
	    key: 'renderTimeLeft',
	    value: function renderTimeLeft() {
	      if (!(0, _auth2.hasAccess)([3], this.props.auth.user.UserType) || this.props.auth.inactiveUsers.length === 0 || (0, _auth2.isLoginFromChainOrSuper)(this.props.auth.inactiveUsers) || (0, _auth2.hasAccess)([3], this.props.auth.user.UserType) && (0, _auth2.isLoginFromWP)(this.props.auth.inactiveUsers)) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'user__timer' },
	        (0, _helpers.translation)('1891'),
	        ' ',
	        this.state.countdown
	      );
	    }
	  }, {
	    key: 'renderShopSelector',
	    value: function renderShopSelector() {
	      var _this6 = this;
	
	      if (!(0, _auth2.hasAccess)([7], this.props.auth.user.UserType) || this.props.auth.inactiveUsers.length === 0) return null;
	      if (this.props.companies.length === 1) return null;
	      var onChange = function onChange(e) {
	        // e.preventDefault()
	        // window.localStorage.setItem('workscreen_view', null)
	        _this6.props.loginAs(0, e.target.value).then(function (res) {
	          _this6.toggleMenu({ target: false });
	          setTimeout(function () {
	            _this6.props.router.replace('/empty');
	            _this6.props.router.replace('/workscreen');
	          }, 2000);
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('1892'), (0, _helpers.translation)('216'));
	        });
	      };
	      // console.log('this.state.selectedShop ', this.state.selectedShop)
	      return [_react2.default.createElement(_divider2.default, { key: 'shop1' }), _react2.default.createElement(
	        'div',
	        { key: 'shop2', className: 'menu shop__selector form' },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { value: Number(this.props.auth.user.ShopId), key: 'shopselector_' + this.props.auth.user.ShopId, onChange: onChange },
	          this.props.companies.map(function (val, key) {
	            return _react2.default.createElement(
	              'option',
	              { key: key, value: val.ShopId },
	              val.ShopName
	            );
	          })
	        )
	      )];
	    }
	  }, {
	    key: 'renderChainShopSelector',
	    value: function renderChainShopSelector() {
	      var _this7 = this;
	
	      // this.props.auth.inactiveUsers
	      if (!(0, _auth2.hasAccess)([2], this.props.auth.user.UserType)) return null;
	      var companies = this.props.companies.filter(function (company) {
	        return company.Active ? company : false;
	      });
	      if (companies.length === 0) return null;
	      var onChange = function onChange(e) {
	        // e.preventDefault()
	        if (e.target.value !== '0') {
	          _this7.props.loginAs(0, parseInt(e.target.value)).then(function (res) {
	            _this7.toggleMenu({ target: false });
	            _this7.props.router.replace('/empty');
	            _this7.props.router.replace(res.data.StartScreen);
	          }, function () {
	            window.toastr.error((0, _helpers.translation)('1892'), (0, _helpers.translation)('216'));
	          });
	        }
	      };
	      return [_react2.default.createElement(_divider2.default, { key: 'chain1' }), _react2.default.createElement(
	        'div',
	        { key: 'chain2', className: 'menu shop__selector form' },
	        _react2.default.createElement(
	          _dropDown2.default,
	          { value: this.props.auth.user.ShopId, key: 'shopselector_' + this.props.auth.user.ShopId, onChange: onChange },
	          _react2.default.createElement(
	            'option',
	            { value: '0' },
	            (0, _helpers.translation)('1896')
	          ),
	          companies.map(function (val, key) {
	            return _react2.default.createElement(
	              'option',
	              { key: key, value: val.ShopId },
	              val.ShopName
	            );
	          })
	        )
	      )];
	    }
	  }, {
	    key: 'renderName',
	    value: function renderName(extraClass) {
	      // let twoLines = extraClass || ''
	      var lastPartOfName = this.props.auth.user.ShopName || '';
	      if (this.props.auth.user.CustomerName !== null) lastPartOfName = this.props.auth.user.CustomerName || '';
	
	      // if (lastPartOfName !== '') twoLines += ' two-lines'
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'user-info' },
	        _react2.default.createElement(
	          'span',
	          { className: 'user' },
	          this.props.auth.user.ContactName || 'Unknown'
	        ),
	        lastPartOfName && _react2.default.createElement(
	          'span',
	          { className: 'company' },
	          lastPartOfName
	        )
	      );
	
	      // return <span className={twoLines}><span>{this.props.auth.user.ContactName || 'Unknown'}</span> {lastPartOfName && <br />}<span className='company'>{lastPartOfName}</span></span>
	    }
	  }, {
	    key: 'renderVersion',
	    value: function renderVersion() {
	      var localVersion = window.localStorage.getItem('clientVersion');
	      var clientBuild = window.localStorage.getItem('clientBuild');
	      clientBuild += ' width: ' + window.innerWidth + ', height: ' + window.innerHeight;
	      return _react2.default.createElement(
	        'div',
	        { className: 'right' },
	        localVersion,
	        ' ',
	        _react2.default.createElement(_HelpText2.default, { text: clientBuild })
	      );
	    }
	  }, {
	    key: 'renderShop',
	    value: function renderShop() {
	      var text = (0, _helpers.translation)('14864');
	      var shopName = this.props.auth.user.ShopName;
	      var number = this.props.auth.user.ForsiBodyShopId;
	      if ((0, _auth2.hasAccess)([4], this.props.auth.user.UserType) && (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2)) {
	        text = (0, _helpers.translation)('14934');
	      } else if (!(0, _auth2.hasAccess)([4], this.props.auth.user.UserType) && (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2) && this.props.auth.hasPartner) {
	        shopName = this.props.auth.partnerName;
	        number = this.props.auth.partnerForsiBodyShopId;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'booking' },
	        _react2.default.createElement('img', { className: 'bookingimage', src: '/images/svgs/listheader/pick-up-time.svg' }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'support text' },
	            (0, _helpers.translation)(text)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            shopName
	          ),
	          number && _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('14803')
	            ),
	            ': ',
	            _react2.default.createElement(
	              'span',
	              null,
	              number
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'support',
	    value: function support(isSupportUser) {
	      var _this8 = this;
	
	      var isQuarsMenmber = this.props.auth.user.ChainId === 2 || this.props.auth.user.ChainId === '2';
	      var showSupportAccess = (0, _auth2.hasAccess)([3, 7], this.props.auth.user.UserType);
	      return _react2.default.createElement(
	        'div',
	        { className: 'supportsection' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'support', onClick: function onClick() {
	              return _this8.props.getSupportLink().then(function (res) {
	                return window.open(res.data);
	              });
	            } },
	          _react2.default.createElement('img', { className: 'supportimage', src: '/images/help-guide.svg' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'text bold' },
	            (0, _helpers.translation)('16396')
	          )
	        ),
	        isQuarsMenmber && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'support', target: '_blank', to: 'https://898.tv/apromaslakexpertensupport' },
	            _react2.default.createElement('img', { className: 'supportimage', src: '/images/Q-grey.svg' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'text bold' },
	              (0, _helpers.translation)('Fjernsupport')
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'textphone' },
	            '+45 70 70 72 85'
	          )
	        ),
	        showSupportAccess && !isSupportUser && _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'support', to: '/supportaccess', onClick: this.toggleMenu },
	          _react2.default.createElement('img', { className: 'supportimage', src: '/images/svgs/menuicons/Employees-black.svg' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)('17967')
	          )
	        )
	      );
	      // return (
	      //   <div className='support'>
	      //     <li className='clearfix help-guides'>
	      //       <img className='supportimage' src={'/images/help-guide.svg'} />
	      //       <button onClick={() => this.props.getSupportLink().then(res => window.open(res.data))}>{translation('16396')}</button>
	      //     </li>
	      //     {isQuarsMenmber && <li>
	      //       <Link target='_blank' to={'https://898.tv/apromaslakexpertensupport'}>
	      //         <img className='supportimage' src={'/images/Q-logo.svg'} />
	      //         <div className='text bold'>{translation('Fjernsupport')}</div>
	      //       </Link>
	      //       <p className='textphone'>{'+45 70 70 72 85'}</p>
	      //     </li>}
	      //   </div>
	      // )
	    }
	  }, {
	    key: 'renderPasswordAndPinCodeSection',
	    value: function renderPasswordAndPinCodeSection(isSupportUser) {
	      if (!isSupportUser) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'menu' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'changepassword', to: '/changepassword', onClick: this.toggleMenu },
	              _react2.default.createElement('img', { className: 'hardcodedimage', src: '/images/svgs/menuicons/Change_password.svg' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('1777')
	              )
	            )
	          ),
	          (0, _auth2.hasAccess)([3], this.props.auth.user.UserType) && _react2.default.createElement(
	            'div',
	            { className: 'menu' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'changepassword', to: '/changepin', onClick: this.toggleMenu },
	              _react2.default.createElement('img', { className: 'hardcodedimage', src: '/images/svgs/menuicons/Change_password.svg' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.props.auth.user.UserHasPincode ? (0, _helpers.translation)('17961') : (0, _helpers.translation)('17977')
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var isSupportUser = this.props.auth.user.IsSupportUser;
	      var usermenu = '';
	      var activeClass = '';
	      var triggerClass = 'fa fa-chevron-right';
	      var renderMyPageSection = function renderMyPageSection() {
	        if (!(0, _auth2.hasAccess)([3], _this9.props.auth.user.UserType) || !(0, _auth2.hasSubscriptionPermission)(_this9.props.auth, 20, 0)) return null;
	        var myOrdersEntry = '';
	        if ((0, _auth2.hasSubscriptionPermission)(_this9.props.auth, 20)) {
	          myOrdersEntry = _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'line', to: '/mypage/orders', onClick: _this9.toggleMenu },
	            _react2.default.createElement('img', { src: '/images/svgs/menuicons/order-orderlist.svg' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1888')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              _this9.state.myPage.Orders
	            )
	          );
	        }
	
	        var myTasksEntry = '';
	        if ((0, _auth2.hasSubscriptionPermission)(_this9.props.auth, 20, 0)) {
	          myTasksEntry = _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'line', to: '/mypage/tasks', onClick: _this9.toggleMenu },
	            _react2.default.createElement('img', { src: '/images/svgs/menuicons/Task-Black.svg' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1889')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              _this9.state.myPage.Tasks
	            )
	          );
	        }
	        var myMessagesEntry = '';
	        if ((0, _auth2.hasSubscriptionPermission)(_this9.props.auth, 20)) {
	          myMessagesEntry = _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'line', to: '/mypage/messages', onClick: _this9.toggleMenu },
	            _react2.default.createElement('img', { src: '/images/svgs/menuicons/Messages-Black.svg' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('1243')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              _this9.state.myPage.Messages
	            )
	          );
	        }
	        // <a className='nohover'>
	        //   <img src='/images/svgs/menuicons/Employees-VS.svg' />
	        //   <strong>{translation('1887')}</strong>
	        // </a>
	        return [_react2.default.createElement(_divider2.default, { key: 'mypage1' }), _react2.default.createElement(
	          'div',
	          { key: 'mypage2', className: 'menu myPage' },
	          myOrdersEntry,
	          myTasksEntry,
	          myMessagesEntry
	        )];
	      };
	
	      var renderLangNames = function renderLangNames(val, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key, className: 'langname' },
	          _react2.default.createElement(
	            'a',
	            { onClick: _this9.changeLanguageInfo.bind(_this9, val), href: '#' },
	            _react2.default.createElement('img', { src: val.Image }),
	            _react2.default.createElement(
	              'label',
	              null,
	              val.SelfLangName
	            )
	          )
	        );
	      };
	      var showSupport = (0, _auth2.hasAccess)([4], this.props.auth.user.UserType) || (0, _auth2.hasAccess)([3], this.props.auth.user.UserType) || (0, _auth2.hasAccess)([7], this.props.auth.user.UserType);
	      var showPaintCompanyInfo = (0, _auth2.hasAccess)([4], this.props.auth.user.UserType) || this.props.auth.departmentType === 1 && this.props.auth.hasPartner;
	      if (this.state.isOpen) {
	        activeClass = 'open';
	        triggerClass = 'fa fa-chevron-down';
	        var languageTriggerClass = 'fa fa-chevron-right';
	        var activeLangItem = window.localStorage.getItem('user_language');
	        var langInfo = this.props.getLanguageInfo(activeLangItem);
	        var languageMenu = null;
	        var currentLanguage = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('img', { src: langInfo.Image }),
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(
	              'a',
	              { className: 'language nohover' },
	              langInfo.SelfLangName
	            )
	          )
	        );
	        if (this.state.isLanguageOpen) {
	          currentLanguage = null;
	          languageTriggerClass = 'fa fa-chevron-down';
	          var langInfos = this.props.getLanguageInfos();
	          languageMenu = langInfos.map(renderLangNames);
	        }
	        usermenu = _react2.default.createElement(
	          'div',
	          { className: 'dropdown__menu' },
	          _react2.default.createElement(
	            'div',
	            { className: 'menu title' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              this.renderName('dropdown__name')
	            )
	          ),
	          showSupport === true && [_react2.default.createElement(_divider2.default, { key: 'sup1' }), _react2.default.createElement(
	            'div',
	            { key: 'sup2', className: 'menu' },
	            showPaintCompanyInfo === true && this.renderShop(),
	            this.support(isSupportUser)
	          )],
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'menu languages' },
	            _react2.default.createElement(
	              'div',
	              { className: 'currentLanguage', onClick: this.toggleLanguageMenu },
	              _react2.default.createElement(
	                'div',
	                { className: 'language_trigger' },
	                (0, _helpers.translation)('2146'),
	                ' ',
	                _react2.default.createElement('i', { className: languageTriggerClass })
	              ),
	              currentLanguage
	            ),
	            languageMenu
	          ),
	          renderMyPageSection(),
	          this.renderShopSelector(),
	          this.renderChainShopSelector(),
	          this.renderPasswordAndPinCodeSection(isSupportUser),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'menu last' },
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: this.signOut, className: 'logout' },
	              _react2.default.createElement('img', { src: '/images/svgs/menuicons/Logout-black.svg' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)('267')
	              )
	            ),
	            this.renderVersion()
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'user__menu ' + activeClass, ref: 'container1' },
	        this.renderTimeLeft(),
	        _react2.default.createElement(
	          'div',
	          { onClick: this.toggleMenu, className: 'trigger' },
	          this.renderName(),
	          ' ',
	          _react2.default.createElement('i', { className: triggerClass })
	        ),
	        usermenu
	      );
	    }
	  }]);
	
	  return UserMenu;
	}(_react.Component);
	
	UserMenu.propTypes = {
	  logout: _propTypes2.default.func.isRequired,
	  setLanguage: _propTypes2.default.func.isRequired,
	  getLanguageInfos: _propTypes2.default.func.isRequired,
	  getLanguageInfo: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    headerInfo: state.common.headerInfo,
	    loginTimer: state.common.loginTimer,
	    companies: state.common.companies
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  logout: _auth.logout,
	  setLanguage: _actions.setLanguage,
	  getLanguageInfos: _actions.getLanguageInfos,
	  getLanguageInfo: _actions.getLanguageInfo,
	  myPageInformation: _mypage.myPageInformation,
	  logOutAs: _auth.logOutAs,
	  loginAs: _auth.loginAs,
	  getSupportLink: _common.getSupportLink
	})(UserMenu);

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _videoReact = __webpack_require__(2002);
	
	__webpack_require__(1569);
	
	__webpack_require__(1570);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoPlayer = function (_Component) {
	  _inherits(VideoPlayer, _Component);
	
	  function VideoPlayer() {
	    _classCallCheck(this, VideoPlayer);
	
	    return _possibleConstructorReturn(this, (VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).apply(this, arguments));
	  }
	
	  _createClass(VideoPlayer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'embedded-video' },
	        _react2.default.createElement(
	          _videoReact.Player,
	          { poster: this.props.poster },
	          _react2.default.createElement(
	            _videoReact.ControlBar,
	            { autoHide: this.props.autoHide, autoHideTime: this.props.autoHideTime },
	            _react2.default.createElement(_videoReact.PlayToggle, null),
	            _react2.default.createElement(_videoReact.CurrentTimeDisplay, { order: 4.1 }),
	            _react2.default.createElement(_videoReact.TimeDivider, { order: 4.2 }),
	            _react2.default.createElement(_videoReact.VolumeMenuButton, { disabled: this.props.hideVolume })
	          ),
	          _react2.default.createElement(_videoReact.BigPlayButton, { position: this.props.position }),
	          _react2.default.createElement('source', { src: this.props.src })
	        )
	      );
	    }
	  }]);
	
	  return VideoPlayer;
	}(_react.Component);
	
	exports.default = VideoPlayer;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1577);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Box = function (_Component) {
	  _inherits(Box, _Component);
	
	  function Box(props) {
	    _classCallCheck(this, Box);
	
	    var _this = _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Box, [{
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-box ' + this.getColor();
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      var color = this.props.color;
	
	      switch (color) {
	        case 'orange':
	          return 'orange';
	        case 'green':
	          return 'green';
	        case 'blue':
	          return 'blue';
	        case null:
	        case undefined:
	        case 'red':
	        default:
	          return 'red';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Box;
	}(_react.Component);
	
	Box.defaultProps = {
	  color: 'red' // colors: 'red', 'green', 'orange', 'blue'
	};
	
	exports.default = Box;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1581);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Expand = function (_Component) {
	  _inherits(Expand, _Component);
	
	  function Expand(props) {
	    _classCallCheck(this, Expand);
	
	    var _this = _possibleConstructorReturn(this, (Expand.__proto__ || Object.getPrototypeOf(Expand)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Expand, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      if (typeof this.props.onClick === 'function') {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chevronClass = 'element-chevron__right';
	      if (this.props.open) {
	        chevronClass = 'element-chevron__down';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-chevron', onClick: this.onClick },
	        this.props.isOpenUp && _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Chevron_Right, className: 'chevron_up', injectSvg: true }),
	        _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Chevron_Right, className: chevronClass, injectSvg: true })
	      );
	    }
	  }]);
	
	  return Expand;
	}(_react.Component);
	
	Expand.defaultProps = {
	  open: false,
	  isOpenUp: false
	};
	
	exports.default = Expand;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	__webpack_require__(1586);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Icon from '../icon'
	
	// import { ElementIcons } from '../icons'
	
	// import '../elements.scss'
	
	var Color = function (_Component) {
	  _inherits(Color, _Component);
	
	  function Color(props) {
	    _classCallCheck(this, Color);
	
	    var _this = _possibleConstructorReturn(this, (Color.__proto__ || Object.getPrototypeOf(Color)).call(this, props));
	
	    _this.state = {
	      showHint: false
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.showIcon = true;
	    return _this;
	  }
	
	  _createClass(Color, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      // console.log('Text onChange triggered! ', e)
	      if (this.props.onChange !== null) {
	        this.showIcon = false;
	        this.props.onChange(e);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      // console.log('Text onBlur triggered! ', e)
	      if (this.props.onBlur !== null) {
	        this.showIcon = true;
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(e) {
	      // console.log('Text onFocus triggered!', e)
	      if (this.props.onFocus !== null) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      // console.log('Text onKeyDown triggered!', e)
	      if (this.props.onKeyDown !== null) {
	        this.props.onKeyDown(e);
	      }
	    }
	  }, {
	    key: 'onKeyPress',
	    value: function onKeyPress(e) {
	      // console.log('Text onKeyPress triggered!', e)
	      if (this.props.onKeyPress !== null) {
	        this.props.onKeyPress(e);
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      // console.log('Text onClick triggered!', e)
	      if (this.props.onClick !== null) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return 'size-large';
	        case 'm':
	          return 'size-medium';
	        case 's':
	          return 'size-small';
	      }
	    }
	  }, {
	    key: 'getIconSize',
	    value: function getIconSize() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 's':
	        case 'm':
	          return 't';
	        case 'l':
	          return 's';
	      }
	    }
	
	    // getIconClass () {
	    //   let iconClass = (this.props.showValidationIcon && this.showIcon) ? 'text-success' : ''
	    //   return iconClass
	    // }
	
	  }, {
	    key: 'getCustomClass',
	    value: function getCustomClass() {
	      return this.props.className;
	    }
	  }, {
	    key: 'getSolidClass',
	    value: function getSolidClass() {
	      return '';
	    }
	  }, {
	    key: 'getBorderClass',
	    value: function getBorderClass() {
	      return '';
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-color' + this.getSolidClass() + this.getBorderClass();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // const renderIcon = () => {
	      //   if (!this.props.showValidationIcon) return null
	      //   return (
	      //     <Icon icon={ElementIcons.Text_Success} className={'text-success'} size={iconSize} injectSvg />
	      //   )
	      // }
	
	      var renderInput = function renderInput() {
	        return _react2.default.createElement('input', {
	          ref: 'input',
	          className: _this2.getSizeClass() + ' ' + _this2.getCustomClass(),
	          type: 'color',
	          id: _this2.props.id,
	          name: _this2.props.name,
	          value: _this2.props.value,
	          onChange: _this2.onChange.bind(_this2),
	          onBlur: _this2.onBlur.bind(_this2),
	          onFocus: _this2.onFocus.bind(_this2),
	          onKeyDown: _this2.onKeyDown.bind(_this2),
	          onKeyPress: _this2.onKeyPress.bind(_this2),
	          onClick: _this2.onClick.bind(_this2),
	          readOnly: _this2.props.readOnly,
	          required: _this2.props.required,
	          placeholder: _this2.props.placeholder,
	          disabled: _this2.props.disabled,
	          defaultValue: _this2.props.defaultValue,
	          maxLength: _this2.props.maxLength
	        });
	      };
	
	      var renderWrapper = function renderWrapper(content) {
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          {
	            labelText: _this2.props.labelText,
	            hintText: _this2.props.hintText,
	            helpText: _this2.props.helpText,
	            errorText: _this2.props.errorText
	          },
	          content
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        !this.props.simple && this.props.labelText !== null ? renderWrapper(renderInput()) : renderInput()
	      );
	    }
	  }]);
	
	  return Color;
	}(_react.Component);
	
	Color.defaultProps = {
	  size: 'l',
	  style: 'default',
	  labelText: null,
	  hintText: null,
	  helpText: null,
	  onChange: null,
	  onKeyDown: null,
	  onKeyPress: null,
	  onBlur: null,
	  onFocus: null,
	  onClick: null,
	  readOnly: false,
	  required: false,
	  // value: '', // For defaultValue to work, this must be able to be undefined
	  placeholder: '',
	  errorText: null,
	  disabled: false,
	  maxLength: null,
	  simple: false,
	  className: '',
	  showValidationIcon: false
	};
	
	exports.default = Color;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1587);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectorLine = function (_Component) {
	  _inherits(ConnectorLine, _Component);
	
	  function ConnectorLine(props) {
	    _classCallCheck(this, ConnectorLine);
	
	    var _this = _possibleConstructorReturn(this, (ConnectorLine.__proto__ || Object.getPrototypeOf(ConnectorLine)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ConnectorLine, [{
	    key: 'render',
	    value: function render() {
	      var lineClass = 'connectorLine';
	      if (this.props.className) {
	        lineClass += ' ' + this.props.className;
	      }
	      return _react2.default.createElement('div', { className: lineClass });
	    }
	  }]);
	
	  return ConnectorLine;
	}(_react.Component);
	
	exports.default = ConnectorLine;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(714);
	
	__webpack_require__(1591);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Activator = function Activator(props) {
	  var className = props.className,
	      classNamePrefix = props.classNamePrefix,
	      size = props.size,
	      disabled = props.disabled,
	      onClick = props.onClick,
	      labelText = props.labelText,
	      style = props.style;
	
	
	  var onActivatorClick = function onActivatorClick(e) {
	    if (!disabled) {
	      onClick(e);
	    }
	  };
	
	  var getSizeClass = function getSizeClass() {
	    switch (size) {
	      case undefined:
	      case null:
	      case 'l':
	        return ' size-large';
	      case 'm':
	        return ' size-medium';
	      case 's':
	        return ' size-small';
	    }
	  };
	
	  // const limit = 20
	  // let label = labelText
	  // if (label.length > limit) {
	  //   // Cut label to 'limit' size
	  //   label = label.split(' ').reduce((lbl, l) => {
	  //     const lblLength = lbl.length
	  //     const isFirst = lblLength === 0
	  //     if (!isFirst && lblLength > limit) return lbl
	
	  //     if (!isFirst && (l.length + lblLength) > (limit + 3)) {
	  //       return lbl
	  //     }
	
	  //     return `${lbl} ${l}`
	  //   }, '')
	
	  //   if (label.endsWith(',')) {
	  //     label += ' ...'
	  //   } else if (label.trim() !== labelText) {
	  //     label += '...'
	  //   }
	  // }
	
	  var prefixify = function prefixify(innerClass) {
	    if (!classNamePrefix) return innerClass;
	    return classNamePrefix + '__' + innerClass;
	  };
	
	  var classes = className + getSizeClass();
	  if (disabled) {
	    classes += ' ' + prefixify('activator--is-disabled');
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: prefixify('activator ') + classes, style: style, onClick: onActivatorClick },
	    _react2.default.createElement(
	      'div',
	      { className: prefixify('activator-label') },
	      labelText
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: prefixify('activator-indicators') },
	      _react2.default.createElement(
	        'div',
	        { className: prefixify('activator-indicator') },
	        _react2.default.createElement(_reactSelect.components.DownChevron, null)
	      )
	    )
	  );
	};
	
	exports.default = Activator;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectMultiOption = function (_Component) {
	  _inherits(SelectMultiOption, _Component);
	
	  function SelectMultiOption() {
	    _classCallCheck(this, SelectMultiOption);
	
	    return _possibleConstructorReturn(this, (SelectMultiOption.__proto__ || Object.getPrototypeOf(SelectMultiOption)).apply(this, arguments));
	  }
	
	  _createClass(SelectMultiOption, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      if (nextProps.selected !== this.props.selected) return true;
	      if (nextProps.className !== this.props.className) return true;
	      if (nextProps.label !== this.props.label) return true;
	      if (nextProps.disabled !== this.props.disabled) return true;
	
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'option-container multi-option element-dropdown__option ' + this.props.className },
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          this.props.label
	        ),
	        _react2.default.createElement('input', { type: 'checkbox', onChange: function onChange() {}, checked: this.props.selected, disabled: this.props.disabled }),
	        _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_Selected, className: 'checked', icon2: _icons.ElementIcons.Check_Selected_Check, size: this.props.size, injectSvg: true }),
	        _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_Normal, className: 'normal', size: this.props.size, injectSvg: true }),
	        _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_Disabled, className: 'disabled', size: this.props.size, injectSvg: true }),
	        _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_SelectedDisabled, className: 'checked-disabled', size: this.props.size, injectSvg: true }),
	        _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Check_Hover, className: 'hover', size: this.props.size, injectSvg: true })
	      );
	    }
	  }]);
	
	  return SelectMultiOption;
	}(_react.Component);
	
	exports.default = SelectMultiOption;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(714);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _SelectMultiOption = __webpack_require__(1069);
	
	var _SelectMultiOption2 = _interopRequireDefault(_SelectMultiOption);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var SelectBox = function (_Component) {
	  _inherits(SelectBox, _Component);
	
	  function SelectBox(props) {
	    _classCallCheck(this, SelectBox);
	
	    var _this = _possibleConstructorReturn(this, (SelectBox.__proto__ || Object.getPrototypeOf(SelectBox)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.formatOptionLabel = _this.formatOptionLabel.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelectBox, [{
	    key: 'onChange',
	    value: function onChange(data) {
	      var _props = this.props,
	          onChange = _props.onChange,
	          isMulti = _props.isMulti,
	          name = _props.name;
	
	
	      if (onChange !== null) {
	        var value = void 0;
	        if (isMulti) {
	          value = [].concat(_toConsumableArray(new Set(data.map(function (opt) {
	            return opt.value;
	          }))));
	        } else {
	          value = data.value;
	        }
	
	        var event = {
	          target: {
	            name: name,
	            value: value,
	            type: isMulti ? 'select-multiple' : 'select-one'
	          },
	          // Dummy function
	          persist: function persist() {}
	        };
	
	        onChange(event);
	      }
	    }
	  }, {
	    key: 'formatOptionLabel',
	    value: function formatOptionLabel(option, meta) {
	      if (meta.context === 'value') {
	        return option.label;
	      }
	
	      var label = typeof option.label === 'number' ? '' + option.label : option.label;
	      var optionClass = option.className || '';
	
	      if (!this.props.isMulti) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'option-container element-dropdown__option ' + optionClass },
	          _react2.default.createElement(
	            _label2.default,
	            null,
	            label
	          )
	        );
	      }
	
	      return _react2.default.createElement(_SelectMultiOption2.default, {
	        label: label,
	        selected: this.props.isSelected(option),
	        disabled: option.disabled,
	        size: this.props.size,
	        className: optionClass
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          name = _props2.name,
	          options = _props2.options,
	          value = _props2.value,
	          disabled = _props2.disabled,
	          isMulti = _props2.isMulti,
	          isSearchable = _props2.isSearchable,
	          show = _props2.show,
	          openOnTop = _props2.openOnTop;
	
	
	      var customComponents = {};
	      if (isSearchable) {
	        customComponents.IndicatorSeparator = null;
	        // customComponents.DropdownIndicator = () => (
	        //   <Icon icon={ElementIcons.Check_Normal} className='normal' size={this.props.size} />
	        // )
	      } else {
	        customComponents.Control = function () {
	          return null;
	        };
	      }
	
	      var visibilityStyles = {};
	      var visibilityStylesMenu = {};
	      if (!show) {
	        visibilityStyles.display = 'none';
	      }
	
	      if (openOnTop) {
	        /* visibilityStyles.bottom = '100%' */
	
	        visibilityStylesMenu.top = 'auto';
	        visibilityStylesMenu.bottom = '0';
	        visibilityStylesMenu.marginBottom = '0';
	      }
	
	      var renderSearch = function renderSearch(content) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drop__search' },
	          content
	        );
	      };
	
	      var renderSelect = function renderSelect() {
	        return _react2.default.createElement(_reactSelect2.default, {
	          ref: 'dropDownSelect',
	          classNamePrefix: 'drop',
	          name: name,
	          value: value,
	          options: options,
	          placeholder: 'Search',
	          isDisabled: disabled,
	          onChange: _this2.onChange,
	          styles: { container: function container(provided, state) {
	              return _extends({}, provided, visibilityStyles);
	            }, menu: function menu(provided, state) {
	              return _extends({}, provided, visibilityStylesMenu);
	            } },
	
	          formatOptionLabel: _this2.formatOptionLabel,
	          isOptionDisabled: function isOptionDisabled(opt) {
	            return opt.disabled;
	          },
	
	          menuIsOpen: true,
	          isMulti: isMulti,
	          hideSelectedOptions: false,
	          backspaceRemovesValue: false,
	          closeMenuOnSelect: !isMulti,
	          blurInputOnSelect: !isMulti,
	          controlShouldRenderValue: false,
	          isClearable: false,
	          tabSelectsValue: false,
	
	          onMenuClose: function onMenuClose() {
	            return _this2.refs.dropDownSelect.blur();
	          },
	          components: customComponents,
	          captureMenuScroll: true,
	          closeMenuOnScroll: true
	          // menuShouldBlockScroll
	          // menuPortalTarget={document.body}   // Doesn't work. React version issue??
	          // menuPlacement={'auto'}
	          // menuPosition={'fixed'}
	        });
	      };
	
	      return isSearchable ? renderSearch(renderSelect()) : renderSelect();
	    }
	  }]);
	
	  return SelectBox;
	}(_react.Component);
	
	SelectBox.defaultProps = {
	  size: 's',
	  name: null,
	  onChange: null,
	  value: null,
	  options: null,
	  disabled: false,
	  show: false,
	  isMulti: false,
	  isSearchable: false,
	  isSelected: function isSelected() {
	    return console.error('isSelected() is required in Select');
	  }
	};
	
	exports.default = SelectBox;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconCycle = function (_Component) {
	  _inherits(IconCycle, _Component);
	
	  function IconCycle(props) {
	    _classCallCheck(this, IconCycle);
	
	    var _this = _possibleConstructorReturn(this, (IconCycle.__proto__ || Object.getPrototypeOf(IconCycle)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(IconCycle, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var selectedIndex = this.props.icons.findIndex(function (x) {
	        return x.value === _this2.props.value;
	      });
	      var onClick = function onClick() {
	        var nextIndex = selectedIndex + 1;
	        if (_this2.props.icons.length === nextIndex) nextIndex = 0;
	        _this2.props.onChange({ target: { type: 'cycle', name: _this2.props.name, value: _this2.props.icons[nextIndex].value } });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-icon-scycle', onClick: onClick },
	        _react2.default.createElement(_icon2.default, { size: this.props.size, icon: this.props.icons[selectedIndex].icon, injectSvg: true })
	      );
	    }
	  }]);
	
	  return IconCycle;
	}(_react.Component);
	
	IconCycle.defaultProps = {
	  size: 't',
	  value: 0,
	  onChange: null,
	  name: '',
	  icons: [] // should be an array of type: { icon: ElementIcons.Edit, value: 0 }
	};
	
	exports.default = (0, _reactRedux.connect)(null, {})(IconCycle);
	// export default AddButton

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1604);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NextButton = function (_Component) {
	  _inherits(NextButton, _Component);
	
	  function NextButton(props) {
	    _classCallCheck(this, NextButton);
	
	    var _this = _possibleConstructorReturn(this, (NextButton.__proto__ || Object.getPrototypeOf(NextButton)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(NextButton, [{
	    key: 'render',
	    value: function render() {
	      var buttonProps = _extends({}, this.props);
	      var icon = null;
	      switch (this.props.size) {
	        case 's':
	          icon = _icons.ButtonIcons.Arrow_Link_16;
	          break;
	        case 'm':
	          icon = _icons.ButtonIcons.Arrow_Link_20;
	          break;
	        case 'l':
	          icon = _icons.ButtonIcons.Arrow_Link_24;
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-nextbutton' },
	        _react2.default.createElement(
	          _button2.default,
	          buttonProps,
	          _react2.default.createElement(_icon2.default, { size: this.props.size, icon: icon, injectSvg: true })
	        )
	      );
	    }
	  }]);
	
	  return NextButton;
	}(_react.Component);
	
	NextButton.defaultProps = {
	  size: 'l',
	  style: 'link',
	  spacing: 0
	};
	
	NextButton.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(NextButton);

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1605);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// elements
	
	
	var NumPad = function (_Component) {
	  _inherits(NumPad, _Component);
	
	  function NumPad(props) {
	    _classCallCheck(this, NumPad);
	
	    var _this = _possibleConstructorReturn(this, (NumPad.__proto__ || Object.getPrototypeOf(NumPad)).call(this, props));
	
	    _this.state = {};
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(NumPad, [{
	    key: 'onClick',
	    value: function onClick(val) {
	      if (this.props.onClick !== null) {
	        this.props.onClick(val);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-numpad' },
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '1') },
	          1
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '2') },
	          2
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '3') },
	          3
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '4') },
	          4
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '5') },
	          5
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '6') },
	          6
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '7') },
	          7
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '8') },
	          8
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '9') },
	          9
	        ),
	        _react2.default.createElement('span', null),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, '0') },
	          0
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.onClick.bind(this, 'delete') },
	          _react2.default.createElement(_icon2.default, { icon: _icons.NumPadIcons.Delete_Red })
	        )
	      );
	    }
	  }]);
	
	  return NumPad;
	}(_react.Component);
	
	exports.default = NumPad;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders a page header
	 */
	
	var PageHeader = function (_Component) {
	  _inherits(PageHeader, _Component);
	
	  function PageHeader(props) {
	    _classCallCheck(this, PageHeader);
	
	    var _this = _possibleConstructorReturn(this, (PageHeader.__proto__ || Object.getPrototypeOf(PageHeader)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(PageHeader, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-page-header' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return PageHeader;
	}(_react.Component);
	
	exports.default = PageHeader;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PinCode = function (_Component) {
	  _inherits(PinCode, _Component);
	
	  function PinCode(props) {
	    _classCallCheck(this, PinCode);
	
	    var _this = _possibleConstructorReturn(this, (PinCode.__proto__ || Object.getPrototypeOf(PinCode)).call(this, props));
	
	    _this.state = {};
	    _this.getClass = _this.getClass.bind(_this);
	    return _this;
	  }
	
	  _createClass(PinCode, [{
	    key: 'getClass',
	    value: function getClass(key) {
	      var pin = this.props.pin;
	
	      console.log('pin length ', pin.length, pin);
	
	      var className = 'pin-circle';
	      if (key === pin.length) {
	        className += ' active';
	      } else if (key < pin.length) {
	        className += ' filledout';
	      }
	      return className;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-pincode' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pin-digit' },
	          _react2.default.createElement('div', { className: this.getClass(0) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pin-digit' },
	          _react2.default.createElement('div', { className: this.getClass(1) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pin-digit' },
	          _react2.default.createElement('div', { className: this.getClass(2) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pin-digit' },
	          _react2.default.createElement('div', { className: this.getClass(3) })
	        )
	      );
	    }
	  }]);
	
	  return PinCode;
	}(_react.Component);
	
	exports.default = PinCode;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PreviousButton = function (_Component) {
	  _inherits(PreviousButton, _Component);
	
	  function PreviousButton(props) {
	    _classCallCheck(this, PreviousButton);
	
	    var _this = _possibleConstructorReturn(this, (PreviousButton.__proto__ || Object.getPrototypeOf(PreviousButton)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(PreviousButton, [{
	    key: 'render',
	    value: function render() {
	      var buttonProps = _extends({}, this.props);
	      var icon = null;
	      switch (this.props.size) {
	        case 's':
	          icon = _icons.ButtonIcons.Arrow_Link_16;
	          break;
	        case 'm':
	          icon = _icons.ButtonIcons.Arrow_Link_20;
	          break;
	        case 'l':
	          icon = _icons.ButtonIcons.Arrow_Link_24;
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-previousbutton' },
	        _react2.default.createElement(
	          _button2.default,
	          buttonProps,
	          _react2.default.createElement(_icon2.default, { size: this.props.size, icon: icon, injectSvg: true })
	        )
	      );
	    }
	  }]);
	
	  return PreviousButton;
	}(_react.Component);
	
	PreviousButton.defaultProps = {
	  size: 'l',
	  style: 'link',
	  spacing: 0
	};
	
	PreviousButton.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(PreviousButton);

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1617);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollToTop = function (_Component) {
	  _inherits(ScrollToTop, _Component);
	
	  function ScrollToTop(props) {
	    _classCallCheck(this, ScrollToTop);
	
	    var _this = _possibleConstructorReturn(this, (ScrollToTop.__proto__ || Object.getPrototypeOf(ScrollToTop)).call(this, props));
	
	    _this.body = null;
	    _this.state = {
	      showGoToTop: false
	    };
	    _this.goToTop = _this.goToTop.bind(_this);
	    _this.removeListener = _this.removeListener.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScrollToTop, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListener();
	    }
	  }, {
	    key: 'removeListener',
	    value: function removeListener() {
	      this.body.removeEventListener(this.props.elementToScrollToClassName, null);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.body = document.getElementsByClassName('element-overlay')[0];
	
	      this.body.addEventListener('scroll', function () {
	        if (_this2.body.scrollTop > 100) {
	          if (_this2.state.showGoToTop) return;
	          _this2.setShowTopBtn(true);
	        } else {
	          if (!_this2.state.showGoToTop) return;
	          _this2.setShowTopBtn(false);
	        }
	      });
	    }
	  }, {
	    key: 'setShowTopBtn',
	    value: function setShowTopBtn(e) {
	      this.setState({
	        showGoToTop: e
	      });
	    }
	  }, {
	    key: 'goToTop',
	    value: function goToTop() {
	      this.body.scrollTo({
	        top: 0,
	        behavior: 'smooth'
	      });
	      // this.removeListener()
	      this.setState({
	        showGoToTop: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-scrollToTop' },
	        this.state.showGoToTop && _react2.default.createElement(
	          'div',
	          { className: 'scrollToTop-content', onClick: this.goToTop.bind(this) },
	          _react2.default.createElement('img', { src: '/images/svgs/go-to-top.svg', alt: (0, _helpers.translation)('13025'), title: (0, _helpers.translation)('13025') })
	        )
	      );
	    }
	  }]);
	
	  return ScrollToTop;
	}(_react.Component);
	
	exports.default = ScrollToTop;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(1953);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux'
	
	
	var VISIBLE_DAYS = 31;
	var PADDING_DAYS = 45;
	
	var ScrollingCalendar = function (_Component) {
	  _inherits(ScrollingCalendar, _Component);
	
	  function ScrollingCalendar(props) {
	    _classCallCheck(this, ScrollingCalendar);
	
	    var _this = _possibleConstructorReturn(this, (ScrollingCalendar.__proto__ || Object.getPrototypeOf(ScrollingCalendar)).call(this, props));
	
	    _this.state = {
	      visibleDays: []
	    };
	    _this.prevResizeWidth = 0;
	    _this.beforeChangeInitialized = false;
	    _this.lastNavigatedDate = null;
	    _this.isDragging = false;
	    _this.itemWidth = 32;
	    _this.sliderRef = null;
	    _this.sliderContainerRef = null;
	    _this.startDate = null;
	    _this.endDate = null;
	    _this.padStart = null;
	    _this.padEnd = null;
	    _this.updateVisibleDays = _this.updateVisibleDays.bind(_this);
	    _this.sliderSettings = {
	      infinite: false,
	      variableWidth: true,
	      slidesToShow: 1, // VISIBLE_DAYS,   // does nothing with variablewidth
	      // slidesToShow: 4.42857142855,    // Weeks in 31 days
	      touchThreshold: 100,
	      arrows: false,
	      dots: false,
	      swipeToSlide: true,
	      swipe: true,
	      speed: 200, // Lower is faster
	      beforeChange: function beforeChange(index) {
	        // console.log('beforeChange', index)
	        if (_this.beforeChangeInitialized) {
	          // For some reason this is called right after mounting, without an afterChange following, which locks up clicking.
	          _this.isDragging = true;
	        }
	        _this.beforeChangeInitialized = true;
	      },
	      afterChange: function afterChange(index) {
	        // console.log('afterChange', index)
	        _this.isDragging = false;
	        _this.updateVisibleDays(_this.state.visibleDays[index]);
	        // console.log('auth', this.props.auth)
	      }
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.updateItemWidth = _this.updateItemWidth.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScrollingCalendar, [{
	    key: 'updateItemWidth',
	    value: function updateItemWidth() {
	      if (this.sliderContainerRef) {
	        this.itemWidth = this.sliderContainerRef.clientWidth / VISIBLE_DAYS;
	        return;
	      }
	      this.itemWidth = 0;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      this.updateVisibleDays(this.props.showFromDate);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return true;
	      // console.log('thisProps', this.props.showFromDate.toISOString(), 'nextProps', nextProps.showFromDate.toISOString())   // Why is this always the same??
	      // if (!nextProps.showFromDate || !this.props.showFromDate) return true
	      // if (nextProps.showFromDate.toISOString() !== this.props.showFromDate.toISOString()) return true
	      // return false
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // console.log('Scrolling calendar did update', this.props)
	      this.updateItemWidth();
	      this.updateVisibleDays(this.props.showFromDate);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(args) {
	      if (args.currentTarget.innerWidth && args.currentTarget.innerWidth !== this.prevResizeWidth) {
	        this.updateItemWidth();
	        this.prevResizeWidth = args.currentTarget.innerWidth;
	      }
	    }
	  }, {
	    key: 'updateVisibleDays',
	    value: function updateVisibleDays(mom) {
	      var _this2 = this;
	
	      if (!mom) mom = (0, _moment2.default)();
	      mom.startOf('day'); // Set to start of day to remove hours, minutes etc..
	
	      if (mom.isSame(this.startDate, 'day')) return;
	      var prevStartDate = (0, _moment2.default)(this.startDate);
	      var prevEndDate = (0, _moment2.default)(this.endDate);
	      this.startDate = mom;
	      this.endDate = (0, _moment2.default)(mom).add(VISIBLE_DAYS - 1, 'days'); // - The 31th. day
	      var start = (0, _moment2.default)(mom).subtract(Math.ceil(VISIBLE_DAYS), 'days');
	      var end = (0, _moment2.default)(mom).add(Math.ceil(VISIBLE_DAYS * 2), 'days');
	      var recreateDays = true;
	
	      // In order to minimize the number of times we recreate the scrollable range of days, we add a good amount of "padding" dates.
	      // We only recreate the days, if the start or end ends up outside of these.
	      if (!this.padStart || !this.padEnd) {
	        this.padStart = (0, _moment2.default)(start).subtract(PADDING_DAYS, 'days');
	        this.padEnd = (0, _moment2.default)(end).add(PADDING_DAYS, 'days');
	      }
	
	      if (this.props.onRangeUpdated) {
	        this.props.onRangeUpdated(this.startDate, this.endDate);
	      }
	
	      // Don't do anything if our start and end is within pad start/end
	      if (this.state.visibleDays.length > 0 && start.isAfter(this.padStart) && end.isBefore(this.padEnd)) {
	        if (this.startDate.month() !== prevStartDate.month() || this.endDate.month() !== prevEndDate.month()) {
	          this.forceUpdate(); // trigger re-render to allow displayed months to update.
	        }
	        recreateDays = false;
	      }
	
	      var days = this.state.visibleDays || [];
	
	      if (recreateDays) {
	        this.padStart = (0, _moment2.default)(start).subtract(PADDING_DAYS, 'days');
	        this.padEnd = (0, _moment2.default)(end).add(PADDING_DAYS, 'days');
	
	        var totalDays = _moment2.default.duration(this.padEnd.diff(this.padStart)).as('days');
	
	        // Clear existing days, and recreate from new range
	        days.length = 0;
	        for (var d = 0; d < totalDays; d++) {
	          days.push((0, _moment2.default)(this.padStart).add(d, 'days'));
	        }
	      }
	
	      var index = days.findIndex(function (x) {
	        return x.isSame(mom, 'day');
	      });
	      if (recreateDays) {
	        this.setState({ visibleDays: days }, function () {
	          // Look in array for index of day that matches the one we want to scroll to.
	          if (index === -1) {
	            index = 0;
	          }
	          setTimeout(function () {
	            // this.currentDayIndex = index
	            _this2.sliderRef.slickGoTo(index, true);
	          });
	        });
	      } else {
	        // If startDate was changed, make sure the slider is scrolled to that day.
	        if (!prevStartDate.isSame(this.startDate, 'day')) {
	          var _index = days.findIndex(function (x) {
	            return x.isSame(mom, 'day');
	          });
	          if (_index !== -1) {
	            this.sliderRef.slickGoTo(_index);
	          }
	        }
	      }
	      this.isDragging = false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-scrollingcalendar' },
	        this.renderControls(),
	        this.renderCalendar()
	      );
	    }
	  }, {
	    key: 'renderCalendar',
	    value: function renderCalendar() {
	      var _this3 = this;
	
	      var renderScrollableDay = function renderScrollableDay(mom, index) {
	        var isStartOfWeek = mom.day() === 1; // Monday
	        var isEndOfWeek = mom.day() === 0; // Sunday
	        var isMiddleOfWeek = mom.day() === 4; // Thursday
	        var weekText = (0, _helpers.translation)(250) + ' ' + mom.format('W');
	        var dayOfMonthText = mom.date();
	        var isToday = mom.isSame((0, _moment2.default)(), 'day');
	        var onClick = function onClick() {
	          // console.log('onClick', 'isdragging', this.isDragging)
	          if (_this3.isDragging) return;
	          if (_this3.props.onItemClick) _this3.props.onItemClick(mom);
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: 'item_' + index, className: 'element-scrollingcalendar__item', style: { width: _this3.itemWidth }, onClick: onClick },
	          isStartOfWeek && _react2.default.createElement(
	            'div',
	            { className: 'week week__start' },
	            '\xA0'
	          ),
	          isMiddleOfWeek && _react2.default.createElement(
	            'div',
	            { className: 'week' },
	            weekText
	          ),
	          isEndOfWeek && _react2.default.createElement(
	            'div',
	            { className: 'week week__end' },
	            '\xA0'
	          ),
	          !isStartOfWeek && !isMiddleOfWeek && !isEndOfWeek && _react2.default.createElement(
	            'div',
	            null,
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: isToday ? 'day current' : 'day' },
	            dayOfMonthText
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-scrollingcalendar__container', ref: function ref(sliderContainer) {
	            _this3.sliderContainerRef = sliderContainer;
	          } },
	        _react2.default.createElement(
	          _reactSlick2.default,
	          _extends({}, this.sliderSettings, { ref: function ref(slider) {
	              _this3.sliderRef = slider;
	            } }),
	          this.state.visibleDays.map(function (x, i) {
	            return renderScrollableDay(x, i);
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderControls',
	    value: function renderControls() {
	      var _this4 = this;
	
	      if (!this.props.showControls) return null;
	      if (!this.startDate || !this.endDate) return;
	      var firstMonth = this.startDate.month();
	      var lastMonth = this.endDate.month();
	
	      // Determine the month(s) we need to display.
	      var shownMonths = [];
	      for (var m = firstMonth; m !== lastMonth; m = (m + 1) % 12) {
	        // Handle end of year wrap around. ("++m % 12" currently crashes Chrome???)
	        shownMonths.push(m);
	      }
	      if (!shownMonths.includes(lastMonth)) {
	        shownMonths.push(lastMonth);
	      }
	
	      // We potentially have to display up to 3 months, in which case we shorten the names.
	      var formattedMonths = shownMonths.length < 3 ? shownMonths.map(function (m) {
	        return (0, _moment2.default)().month(m).format('MMMM');
	      }) : shownMonths.map(function (m) {
	        return (0, _moment2.default)().month(m).format('MMM');
	      });
	      var monthsText = formattedMonths.join(' / ');
	
	      var now = (0, _moment2.default)();
	      var showGotoNow = now.isBefore(this.startDate, 'day') || now.isAfter(this.endDate, 'day');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-scrollingcalendar__controls' },
	        showGotoNow && _react2.default.createElement(
	          'div',
	          { className: 'go-to-now', onClick: function onClick() {
	              _this4.updateVisibleDays((0, _moment2.default)().startOf('week'));
	            } },
	          (0, _helpers.translation)(18281)
	        ) || _react2.default.createElement(
	          'div',
	          null,
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'months' },
	          monthsText
	        )
	      );
	    }
	  }]);
	
	  return ScrollingCalendar;
	}(_react.Component);
	
	ScrollingCalendar.defaultProps = {
	  showControls: true,
	  showFromDate: (0, _moment2.default)(),
	  onRangeUpdated: function onRangeUpdated(from, to) {
	    console.log('Range updated', from.format('YYYY-MM-DD'), ' - ', to.format('YYYY-MM-DD'));
	  }, // Callback to retrieve the displayed range as two moments when the calendar is scrolled.
	  onItemClick: function onItemClick(mom) {
	    console.log('Clicked', mom.format('YYYY-MM-DD'));
	  }
	
	  // function mapStateToProps (state) {
	  //   return {
	  //     auth: state.auth
	  //   }
	  // }
	  // export default connect(mapStateToProps, { })(ScrollingCalendar)
	
	};exports.default = ScrollingCalendar;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1620);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Styles
	
	
	var SideMenuHeader = function (_Component) {
	  _inherits(SideMenuHeader, _Component);
	
	  function SideMenuHeader() {
	    _classCallCheck(this, SideMenuHeader);
	
	    return _possibleConstructorReturn(this, (SideMenuHeader.__proto__ || Object.getPrototypeOf(SideMenuHeader)).apply(this, arguments));
	  }
	
	  _createClass(SideMenuHeader, [{
	    key: 'getSizeClass',
	    value: function getSizeClass() {
	      switch (this.props.size) {
	        case undefined:
	        case null:
	        case 'l':
	          return ' size-large';
	        case 'm':
	          return ' size-medium';
	        case 's':
	          return ' size-small';
	      }
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return 'element-sidemenu-header__label' + this.getSizeClass();
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.getStyle() },
	        _react2.default.createElement(_icon2.default, { icon: this.props.icon, size: 's' }),
	        this.props.label
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'element-sidemenu-header' },
	        this.renderLabel(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return SideMenuHeader;
	}(_react.Component);
	
	SideMenuHeader.defaultProps = {
	  size: 'l',
	  label: null
	};
	
	exports.default = SideMenuHeader;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = function (_PureComponent) {
	  _inherits(Spinner, _PureComponent);
	
	  function Spinner() {
	    _classCallCheck(this, Spinner);
	
	    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
	  }
	
	  _createClass(Spinner, [{
	    key: 'render',
	    value: function render() {
	      var sizeClass = 'fa-' + this.props.size + 'x';
	      return _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin ' + sizeClass + ' fa-fw' });
	    }
	  }]);
	
	  return Spinner;
	}(_react.PureComponent);
	
	Spinner.defaultProps = {
	  size: 3
	};
	
	exports.default = Spinner;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _common = __webpack_require__(25);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _icons = __webpack_require__(6);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	__webpack_require__(1634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// elements
	
	// import Divider from '../../elements/divider'
	
	// styles
	
	
	var CarRentalContractModal = function (_Component) {
	  _inherits(CarRentalContractModal, _Component);
	
	  function CarRentalContractModal(props) {
	    _classCallCheck(this, CarRentalContractModal);
	
	    var _this = _possibleConstructorReturn(this, (CarRentalContractModal.__proto__ || Object.getPrototypeOf(CarRentalContractModal)).call(this, props));
	
	    _this.state = {};
	    _this.printContract = _this.printContract.bind(_this);
	    _this.onAfterPrint = _this.onAfterPrint.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarRentalContractModal, [{
	    key: 'renderLender',
	    value: function renderLender() {
	      var Company = this.props.contract.Company;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__title' },
	          (0, _helpers.translation)(16782)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          Company.Name
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          Company.Address
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          Company.Zip
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          Company.City
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(41)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Company.CVR
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRenter',
	    value: function renderRenter() {
	      var Renter = this.props.contract.Renter;
	
	
	      var renderPhones = function renderPhones(val, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          val
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__title' },
	          (0, _helpers.translation)(16783)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          Renter.Name
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          Renter.Address
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          Renter.Zip
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          Renter.City
	        ),
	        Renter.Phones.map(renderPhones),
	        _react2.default.createElement(
	          'div',
	          null,
	          Renter.Mail
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(16795)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Renter.DriverLicense
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(41)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Renter.CVR
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCar',
	    value: function renderCar() {
	      var Car = this.props.contract.Car;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__title' },
	          (0, _helpers.translation)(629)
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(16792)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Car.Nr
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(2005)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Car.RegNumber
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(145)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Car.Brand
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(146)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Car.Model
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPeriods',
	    value: function renderPeriods() {
	      var Periods = this.props.contract.Periods;
	
	
	      var getDate = function getDate(dateTime) {
	        return dateTime.split(' - ')[0];
	      };
	      var getTime = function getTime(dateTime) {
	        return dateTime.split(' - ')[1];
	      };
	
	      var renderPeriod = function renderPeriod(p, i) {
	        var start = (0, _time.renderFullDate)(p.Start);
	        var end = (0, _time.renderFullDate)(p.End);
	
	        return _react2.default.createElement(
	          'div',
	          { key: 'period_' + i },
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16771)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              getDate(start) + ' ' + getTime(start)
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16772)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              getDate(end) + ' ' + getTime(end)
	            )
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__title' },
	          (0, _helpers.translation)(16784)
	        ),
	        Periods.map(renderPeriod)
	      );
	    }
	  }, {
	    key: 'renderRent',
	    value: function renderRent() {
	      var Rent = this.props.contract.Rent;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__title' },
	          (0, _helpers.translation)(16785)
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(16797)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Rent.Fuel ? (0, _helpers.translation)(47) : (0, _helpers.translation)(48)
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(16798)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Rent.Tank
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(16800)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Rent.UpToKm
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(16801)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Rent.ExtraKm
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderHandover',
	    value: function renderHandover() {
	      var KmAtStart = this.props.contract.KmAtStart;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__title' },
	          (0, _helpers.translation)(16787)
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(16802)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            KmAtStart
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderInsurance',
	    value: function renderInsurance() {
	      var Insurance = this.props.contract.Insurance;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__title' },
	          (0, _helpers.translation)(16786)
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(16793)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Insurance.Kasko ? (0, _helpers.translation)(47) : (0, _helpers.translation)(48)
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(16794) + ' ' + (0, _helpers.translation)(this.props.currencyCode) + ' ' + Insurance.SelfRiskCoverageAmount + ' ' + (0, _helpers.translation)(971)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            Insurance.SelfRiskCoverage ? (0, _helpers.translation)(47) : (0, _helpers.translation)(48)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDrivers',
	    value: function renderDrivers() {
	      var Drivers = this.props.contract.Drivers;
	
	      var mapDrivers = function mapDrivers(val, key) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'spacing' },
	          _react2.default.createElement(
	            'span',
	            null,
	            val.Name
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { key: key },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16795)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              val.DriverLicense
	            )
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__title' },
	          (0, _helpers.translation)(16788)
	        ),
	        Drivers.map(mapDrivers)
	      );
	    }
	  }, {
	    key: 'renderConditions',
	    value: function renderConditions() {
	      var Conditions = this.props.contract.Conditions;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section conditions' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__title' },
	          (0, _helpers.translation)(16789)
	        ),
	        Conditions
	      );
	    }
	  }, {
	    key: 'renderSignature',
	    value: function renderSignature() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)(16806) + ' ' + (0, _helpers.translation)(16807) + ' ' + (0, _helpers.translation)(16808)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__signature' },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [0.5, 1] },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('div', { className: 'line' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)(388)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('div', { className: 'line' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _helpers.translation)(16783)
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'onAfterPrint',
	    value: function onAfterPrint() {
	      // close all, back to workcard
	      this.props.onClose();
	      this.props.closeOverlay('CarRentalContractOverlay', true);
	    }
	  }, {
	    key: 'printContract',
	    value: function printContract() {
	      var _this2 = this;
	
	      window.print();
	      if (window.matchMedia) {
	        var mediaQueryList = window.matchMedia('print');
	        console.log('mediaQueryList ', mediaQueryList);
	        mediaQueryList.addListener(function (mql) {
	          console.log('mql ', mql);
	          if (!mql.matches) {
	            _this2.onAfterPrint();
	          }
	        });
	      }
	      window.onafterprint = this.onAfterPrint();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var bottomBarProps = {
	        actionLabelText: (0, _helpers.translation)(16805),
	        onActionClick: this.printContract,
	        center: true
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'carrentalcontract_modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            show: this.props.show,
	            onClose: this.props.onClose,
	            header: (0, _helpers.translation)(16781),
	            icon: _icons.ModalIcons.CarRental,
	            bottomBarProps: bottomBarProps,
	            overflowHidden: true },
	          _react2.default.createElement(
	            'div',
	            { className: 'contract__content' },
	            _react2.default.createElement(
	              _row2.default,
	              null,
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                this.renderLender(),
	                this.renderRenter(),
	                this.renderInsurance(),
	                this.renderDrivers()
	              ),
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                this.renderCar(),
	                this.renderPeriods(),
	                this.renderRent(),
	                this.renderHandover()
	              )
	            ),
	            _react2.default.createElement(
	              _row2.default,
	              null,
	              _react2.default.createElement(
	                _col2.default,
	                { span: 3 },
	                this.renderConditions(),
	                this.renderSignature()
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CarRentalContractModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { closeOverlay: _common.closeOverlay })(CarRentalContractModal);

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1635);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _helpers = __webpack_require__(2);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Utils
	
	
	// Elements
	// import Icon from '../../elements/icon'
	
	
	var CarsizeModal = function (_Component) {
	  _inherits(CarsizeModal, _Component);
	
	  function CarsizeModal(props) {
	    _classCallCheck(this, CarsizeModal);
	
	    var _this = _possibleConstructorReturn(this, (CarsizeModal.__proto__ || Object.getPrototypeOf(CarsizeModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false
	    };
	    return _this;
	  }
	
	  _createClass(CarsizeModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'carsize__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: (0, _helpers.translation)('251'), overflowHidden: this.state.overflowHidden,
	            icon: _icons.ModalIcons.Help }),
	          _react2.default.createElement(
	            'div',
	            { className: 'size_wrap' },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('1357')
	            ),
	            _react2.default.createElement('div', { className: 'car_image car-small' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'C1, Up, Swift, Ka, Fiesta, i10, Picanto, Twingo, Mazda 2'
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'size_wrap' },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('1288')
	            ),
	            _react2.default.createElement('div', { className: 'car_image car-medium' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Golf, C\xADmax, i20, i30, C4, Fabia, Focus, Ceed, Clio, Mazda 3'
	            )
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'size_wrap' },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('1358')
	            ),
	            _react2.default.createElement('div', { className: 'car_image car-large' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Stationcar, MPV/SUV, VAN, Passat, Mondeo, S-max, i35, C5, i40, Insignia, Scenic, Mazda 5'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CarsizeModal;
	}(_react.Component);
	
	exports.default = CarsizeModal;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1636);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	var CleanModal = function (_Component) {
	  _inherits(CleanModal, _Component);
	
	  function CleanModal(props) {
	    _classCallCheck(this, CleanModal);
	
	    var _this = _possibleConstructorReturn(this, (CleanModal.__proto__ || Object.getPrototypeOf(CleanModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false
	    };
	    return _this;
	  }
	
	  _createClass(CleanModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'clean__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { overflowHidden: this.state.overflowHidden }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return CleanModal;
	}(_react.Component);
	
	exports.default = CleanModal;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	__webpack_require__(1639);
	
	var _dracar = __webpack_require__(224);
	
	var _orders = __webpack_require__(21);
	
	var _spareparts = __webpack_require__(108);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _orangeDivider = __webpack_require__(453);
	
	var _orangeDivider2 = _interopRequireDefault(_orangeDivider);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Style
	
	
	// Actions
	
	
	// Functions
	
	
	// Elements
	
	// import PanelHeader from '../../elements/panelHeader'
	
	
	// import Inline from '../../elements/inline'
	
	var CustomerType = {
	  company: 0,
	  customer: 1
	};
	
	var DracarModal = function (_Component) {
	  _inherits(DracarModal, _Component);
	
	  function DracarModal(props) {
	    _classCallCheck(this, DracarModal);
	
	    var _this = _possibleConstructorReturn(this, (DracarModal.__proto__ || Object.getPrototypeOf(DracarModal)).call(this, props));
	
	    _this.state = {
	      step: 1,
	      showSpinner: false,
	      showSearchSpinner: false,
	      showButtonSpinner: false,
	      showCreateOrderButton: false,
	      overflowHidden: false,
	
	      stepOneValid: false,
	      stepTwoValid: false,
	
	      createNewRepairOrder: true,
	      repairOrderId: '',
	
	      dracar: {
	        orderId: _this.props.order.Id,
	        sparePartSupplier: 0,
	        customerId: '0',
	        isInsuranceType: false,
	        isCustomerType: false,
	        isCompanyType: false,
	        customerType: 0,
	        isCompany: false,
	        givenName: '',
	        familyName: '',
	        phone: '',
	        email: '',
	        licensePlate: _this.props.order.RegNumber ? _this.props.order.RegNumber : '',
	        vin: _this.props.order.ChassisNumber ? _this.props.order.ChassisNumber : '',
	        brandNameId: _this.props.order.BrandName ? _this.props.order.BrandName.Id : 0,
	        brandName: _this.props.order.BrandName ? _this.props.order.BrandName.Name : '',
	        model: _this.props.order.Model ? _this.props.Model : '',
	        modelYear: 0
	      },
	
	      sparePartSuppliers: [],
	      searchGivenName: '',
	      searchFamilyName: '',
	      searchPhone: _this.props.order ? _this.props.order.CarOwnerPhone ? _this.props.order.CarOwnerPhone : '' : '',
	      searchEmail: _this.props.order ? _this.props.order.CarOwnerMail ? _this.props.order.CarOwnerMail : '' : '',
	
	      selectedSuggested: false,
	      customerTypeChecked: true,
	      customerSuggestions: [],
	      disableCustomerInput: false,
	      disableLicensePlateInput: false,
	
	      insuranceIndracarMatchedCompanyType: 0,
	      hasInsuranceDebtorInDracar: false,
	      vehicleExist: false,
	      foundVehicle: null,
	      invalidOrder: false,
	      handledFirstTimeLicensePlateSearch: false
	    };
	
	    _this.handleOnChangeLicensePlate = _this.handleOnChangeLicensePlate.bind(_this);
	    _this.handleOnSearchChange = _this.handleOnSearchChange.bind(_this);
	    _this.handleOnChangeCustomerType = _this.handleOnChangeCustomerType.bind(_this);
	    _this.handleSuggestedCustomer = _this.handleSuggestedCustomer.bind(_this);
	    _this.handleSelectRecipientInvoice = _this.handleSelectRecipientInvoice.bind(_this);
	    _this.handleOnChangeCreateNewRepairOrder = _this.handleOnChangeCreateNewRepairOrder.bind(_this);
	    _this.handleSearchForSuggestedCustomer = _this.handleSearchForSuggestedCustomer.bind(_this);
	    _this.handleSearchForVehicle = _this.handleSearchForVehicle.bind(_this);
	    _this.handleRefreshCustomerSuggestions = _this.handleRefreshCustomerSuggestions.bind(_this);
	    _this.handleValidation = _this.handleValidation.bind(_this);
	    _this.getDracarRepairOrder = _this.getDracarRepairOrder.bind(_this);
	    _this.handleErrors = _this.handleErrors.bind(_this);
	    _this.hasSelectedCustomerState = _this.hasSelectedCustomerState.bind(_this);
	    _this.getDefaultDracarClientState = _this.getDefaultDracarClientState.bind(_this);
	    _this.onSupplierChange = _this.onSupplierChange.bind(_this);
	    _this.resetState = _this.resetState.bind(_this);
	    _this.getSparePartSuppliers = _this.getSparePartSuppliers.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.getKeyLoopSystemName = _this.getKeyLoopSystemName.bind(_this);
	    _this.getRepairOrderAlias = _this.getRepairOrderAlias.bind(_this);
	    return _this;
	  }
	
	  _createClass(DracarModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.order) {
	        this.getSparePartSuppliers();
	      }
	    }
	  }, {
	    key: 'resetState',
	    value: function resetState() {
	      this.setState(_extends({}, this.state, {
	        dracar: _extends({}, this.state.dracar, {
	          customerId: '0',
	          isInsuranceType: false,
	          isCustomerType: false,
	          isCompanyType: false,
	          isCompany: false,
	          givenName: '',
	          familyName: '',
	          phone: '',
	          email: '',
	          licensePlate: this.props.order.RegNumber ? this.props.order.RegNumber : '',
	          vin: this.props.order.ChassisNumber ? this.props.order.ChassisNumber : '',
	          brandNameId: this.props.order.BrandName ? this.props.order.BrandName.Id : 0,
	          brandName: this.props.order.BrandName ? this.props.order.BrandName.Name : '',
	          model: this.props.order.Model ? this.props.Model : '',
	          modelYear: 0
	        }),
	        searchGivenName: '',
	        searchFamilyName: '',
	        searchPhone: this.props.order ? this.props.order.CarOwnerPhone ? this.props.order.CarOwnerPhone : '' : '',
	        searchEmail: this.props.order ? this.props.order.CarOwnerMail ? this.props.order.CarOwnerMail : '' : '',
	        selectedSuggested: false,
	        customerTypeChecked: true,
	        customerSuggestions: [],
	        disableCustomerInput: false
	      }));
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var value = e.target.value;
	      this.setState(_defineProperty({}, e.target.name, value));
	    }
	  }, {
	    key: 'getSparePartSuppliers',
	    value: function getSparePartSuppliers() {
	      var _this2 = this;
	
	      this.props.getListSimple(true).then(function (res) {
	        _this2.setState({
	          sparePartSuppliers: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getDefaultDracarClientState',
	    value: function getDefaultDracarClientState() {
	      return {
	        customerId: '0',
	        givenName: '',
	        familyName: '',
	        phone: '',
	        email: ''
	      };
	    }
	  }, {
	    key: 'hasSelectedCustomerState',
	    value: function hasSelectedCustomerState() {
	      var _state = this.state,
	          dracar = _state.dracar,
	          vehicleExist = _state.vehicleExist,
	          selectedSuggested = _state.selectedSuggested;
	
	
	      if (!vehicleExist && dracar.customerId === '0' || dracar.customerId === null || !selectedSuggested) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'handleErrors',
	    value: function handleErrors(err) {
	      if (err) {
	        if (err.response) {
	          if (err.response.data !== undefined && err.response.data !== null && Array.isArray(err.response.data) && err.response.data.length > 0) {
	            var errors = err.response.data;
	            var errText = '';
	            for (var i = 0; i < errors.length; i++) {
	              var dictKey = errors[i].DictionaryKey;
	              errText += '<br/>' + (0, _helpers.translation)(dictKey);
	            }
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	          }
	        } else {
	          window.toastr.error(err, (0, _helpers.translation)('216'));
	        }
	      }
	    }
	  }, {
	    key: 'onSupplierChange',
	    value: function onSupplierChange(e) {
	      var _this3 = this;
	
	      var value = typeof e.target.value !== 'number' ? parseInt(e.target.value) : e.target.value;
	      var reset = this.state.dracar.sparePartSupplier !== 0 && this.state.dracar.sparePartSupplier !== value;
	      this.setState({
	        dracar: _extends({}, this.state.dracar, {
	          sparePartSupplier: value
	        })
	      }, function () {
	        if (reset) {
	          _this3.resetState();
	        }
	        _this3.handleSearchForVehicle(null, false, false);
	      });
	    }
	  }, {
	    key: 'handleOnSearchChange',
	    value: function handleOnSearchChange(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'handleOnChangeLicensePlate',
	    value: function handleOnChangeLicensePlate(e) {
	      var _state2 = this.state,
	          dracar = _state2.dracar,
	          foundVehicle = _state2.foundVehicle,
	          vehicleExist = _state2.vehicleExist;
	
	      var noLicensePlateInput = e.target.value ? e.target.value.length === 0 : true;
	
	      this.setState({
	        dracar: _extends({}, dracar, _defineProperty({}, e.target.name, e.target.value)),
	        foundVehicle: noLicensePlateInput ? null : foundVehicle,
	        vehicleExist: noLicensePlateInput ? false : vehicleExist,
	        showCreateOrderButton: noLicensePlateInput
	      });
	    }
	  }, {
	    key: 'handleOnChangeCustomerType',
	    value: function handleOnChangeCustomerType(e, value) {
	      var dracar = this.state.dracar;
	
	      this.setState({
	        dracar: _extends({}, dracar, this.getDefaultDracarClientState(), _defineProperty({}, e.target.name, value)),
	        customerSuggestions: [],
	        customerTypeChecked: true,
	        selectedSuggested: false
	      });
	    }
	  }, {
	    key: 'handleOnChangeCreateNewRepairOrder',
	    value: function handleOnChangeCreateNewRepairOrder(e, value) {
	      this.setState({
	        createNewRepairOrder: value
	      });
	    }
	  }, {
	    key: 'handleSuggestedCustomer',
	    value: function handleSuggestedCustomer(radioName, item) {
	      var dracar = this.state.dracar;
	
	      var itemId = item.companyId || item.customerId;
	      this.setState({
	        dracar: _extends({}, dracar, {
	          customerId: itemId,
	          givenName: '' + item.givenName,
	          familyName: '' + item.familyName,
	          isCompany: item.isCompany,
	          phone: item.phone,
	          email: item.email
	        }),
	        selectedSuggested: true
	      });
	    }
	  }, {
	    key: 'handleSelectRecipientInvoice',
	    value: function handleSelectRecipientInvoice(e) {
	      var dracar = this.state.dracar;
	
	      var isCustomerType = dracar.isCustomerType;
	      var isCompanyType = dracar.isCompanyType;
	      var customerType = dracar.customerType;
	      var isInsuranceType = dracar.isInsuranceType;
	      var disableCustomerInput = this.state.disableCustomerInput;
	      var selectedSuggested = false;
	      var customerSuggestions = [];
	
	      if (e.target.name === 'isCompanyType') {
	        isCustomerType = false;
	        customerType = CustomerType.company;
	        isInsuranceType = false;
	        disableCustomerInput = false;
	        customerSuggestions = [];
	      } else if (e.target.name === 'isCustomerType') {
	        isCompanyType = false;
	        customerType = CustomerType.customer;
	        isInsuranceType = false;
	        disableCustomerInput = false;
	        customerSuggestions = [];
	      } else if (e.target.name === 'isInsuranceType') {
	        isCompanyType = false;
	        isCustomerType = false;
	        customerType = this.state.insuranceIndracarMatchedCompanyType;
	        disableCustomerInput = true;
	        selectedSuggested = true;
	      }
	
	      this.setState({
	        dracar: _extends({}, dracar, _defineProperty({
	          customerId: '0',
	          isCustomerType: isCustomerType,
	          isCompanyType: isCompanyType,
	          isInsuranceType: isInsuranceType,
	          isCompany: isCompanyType,
	          customerType: customerType
	        }, e.target.name, e.target.value)),
	        customerSuggestions: customerSuggestions,
	        selectedSuggested: selectedSuggested,
	        disableCustomerInput: disableCustomerInput
	      });
	    }
	  }, {
	    key: 'handleSearchForSuggestedCustomer',
	    value: function handleSearchForSuggestedCustomer(e) {
	      var _this4 = this;
	
	      var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      if (!search) return;
	
	      var dracar = {
	        IsCompany: this.state.dracar.isCompany,
	        GivenName: this.state.searchGivenName,
	        FamilyName: this.state.searchFamilyName,
	        Phone: this.state.searchPhone,
	        Email: this.state.searchEmail,
	        sparePartSupplier: this.state.dracar.sparePartSupplier,
	        customerType: this.state.customerType
	      };
	
	      this.setState({ showSearchSpinner: true }, function () {
	        if (_this4.state.dracar.isCompanyType || _this4.state.dracar.isCustomerType) {
	          if (_this4.state.dracar.isCompany || _this4.state.dracar.isCompanyType) {
	            _this4.props.searchDracarCompany(dracar).then(function (res) {
	              _this4.handleRefreshCustomerSuggestions(false, res.data);
	            }).catch(function (err) {
	              _this4.handleRefreshCustomerSuggestions(false, []);
	              _this4.handleErrors(err);
	            });
	          } else {
	            _this4.props.searchDracarCustomer(dracar).then(function (res) {
	              _this4.handleRefreshCustomerSuggestions(false, res.data);
	            }).catch(function (err) {
	              _this4.handleRefreshCustomerSuggestions(false, []);
	              _this4.handleErrors(err);
	            });
	          }
	        } else _this4.handleRefreshCustomerSuggestions(false, []);
	      });
	    }
	  }, {
	    key: 'handleRefreshCustomerSuggestions',
	    value: function handleRefreshCustomerSuggestions(spinnerValue, data) {
	      var suggestions = [];
	      if (Array.isArray(data)) {
	        suggestions = data;
	      }
	
	      this.setState({ showSearchSpinner: spinnerValue, customerSuggestions: suggestions, hasInsuranceDebtorInDracar: false });
	    }
	  }, {
	    key: 'handleSearchForVehicle',
	    value: function handleSearchForVehicle(e) {
	      var _this5 = this;
	
	      var showErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var showSpinner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	      var dracar = this.state.dracar;
	
	
	      this.setState({ showSearchSpinner: showSpinner, disableLicensePlateInput: true }, function () {
	        _this5.props.getOrderVehicleData(dracar.licensePlate, 'RegNumber').then(function (vehicleRes) {
	          if (vehicleRes.data.Success) {
	            _this5.props.checkForDracarVehicle({ LicensePlate: dracar.licensePlate, sparePartSupplier: dracar.sparePartSupplier, OrderId: dracar.orderId }).then(function (res) {
	              var updateObj = {
	                vehicleExist: res.data.VehicleExist,
	                hasInsuranceDebtorInDracar: res.data.HasInsuranceDebtorInDracar,
	                foundVehicle: res.data.DracarVehicleInfo,
	                showSearchSpinner: false,
	                disableLicensePlateInput: false,
	                disableCustomerInput: res.data.HasInsuranceDebtorInDracar,
	                selectedSuggested: true,
	                insuranceIndracarMatchedCompanyType: res.data.IsCompany ? CustomerType.company : CustomerType.customer,
	                dracar: _extends({}, dracar, {
	                  vin: vehicleRes.data.ChassisNumber,
	                  brandNameId: vehicleRes.data.BrandNameId,
	                  brandName: vehicleRes.data.BrandName,
	                  model: vehicleRes.data.Model,
	                  customerId: res.data.Id,
	                  givenName: res.data.GivenName,
	                  familyName: res.data.FamilyName,
	                  phone: res.data.Phone,
	                  email: res.data.Email,
	                  isCompany: res.data.IsCompany,
	                  isInsuranceType: res.data.HasInsuranceDebtorInDracar
	                }),
	                handledFirstTimeLicensePlateSearch: true,
	                showCreateOrderButton: true
	              };
	              _this5.setState(_extends({}, updateObj));
	            }).catch(function (err) {
	              if (showErrors) _this5.handleErrors(err);
	              _this5.setState({ showSearchSpinner: false, disableLicensePlateInput: false });
	            });
	          } else {
	            if (showErrors) window.toastr.error((0, _helpers.translation)('16631'), (0, _helpers.translation)('216'));
	            _this5.setState({ showSearchSpinner: false, disableLicensePlateInput: false });
	          }
	        }).catch(function () {
	          if (showErrors) window.toastr.error((0, _helpers.translation)('16631'), (0, _helpers.translation)('216'));
	          _this5.setState({
	            dracar: _extends({}, dracar, {
	              licensePlate: ''
	            }),
	            showSearchSpinner: false,
	            disableLicensePlateInput: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'getDracarRepairOrder',
	    value: function getDracarRepairOrder() {
	      var _this6 = this;
	
	      var getRepairOrderData = {
	        RepairOrderId: this.state.repairOrderId,
	        OrderId: this.state.dracar.orderId,
	        SparePartSupplierId: this.state.dracar.sparePartSupplier
	      };
	      this.props.getDracarRepairOrder(getRepairOrderData).then(function (res) {
	        _this6.props.onSuccess(res.data);
	      }, function (err) {
	        console.log('error', err.data);
	        _this6.handleErrors(err);
	      });
	    }
	  }, {
	    key: 'handleValidation',
	    value: function handleValidation(step) {
	      var _this7 = this;
	
	      var _state3 = this.state,
	          dracar = _state3.dracar,
	          showButtonSpinner = _state3.showButtonSpinner,
	          selectedSuggested = _state3.selectedSuggested,
	          hasInsuranceDebtorInDracar = _state3.hasInsuranceDebtorInDracar;
	
	      if (showButtonSpinner) return;
	
	      if (step === 1) {
	        this.setState({ step: step });
	      } else if (step === 2) {
	        if (dracar.sparePartSupplier !== 0) {
	          this.setState({ step: step });
	        }
	      } else if (step === 3) {
	        if (this.hasSelectedCustomerState()) return;
	        this.setState({ disableCustomerInput: true, showButtonSpinner: true }, function () {
	          _this7.props.validateDracarCustomer(dracar).then(function (res) {
	            _this7.setState({ step: step, showButtonSpinner: false, disableCustomerInput: hasInsuranceDebtorInDracar || false });
	          }).catch(function (err) {
	            _this7.setState({ showButtonSpinner: false, disableCustomerInput: false }, function () {
	              _this7.handleErrors(err);
	            });
	          });
	        });
	      } else if (step === 4) {
	        if (this.hasSelectedCustomerState()) return;
	        var spinnersOff = { showSpinner: false, showButtonSpinner: false, disableLicensePlateInput: false };
	
	        this.setState({ showButtonSpinner: true, disableLicensePlateInput: true }, function () {
	          _this7.props.validateDracarVehicle(dracar).then(function (res) {
	            _this7.setState({ showSpinner: true, showButtonSpinner: false, disableLicensePlateInput: false }, function () {
	              _this7.props.createDracarRepairOrder(dracar).then(function (dracarRes) {
	                _this7.props.getOrder(_this7.props.order.Id).then(function (res) {
	                  _this7.setState(_extends({}, spinnersOff), function () {
	                    _this7.props.onSuccess(dracarRes.data);
	                  });
	                }).catch(function (err) {
	                  _this7.handleErrors(err);
	                  _this7.setState(_extends({}, spinnersOff));
	                });
	              }).catch(function (err) {
	                _this7.handleErrors(err);
	                var stateObj = _extends({}, spinnersOff, { dracar: _extends({}, dracar), selectedSuggested: selectedSuggested });
	                var search = false;
	
	                // In the case of successfully getting to the create repair order part, and the order
	                // creation fails, we have by that point, most likely created a customer and vehicle,
	                // thus, we search for the customer, mark them as a suggested and ensure we do not
	                // create duplicates
	                if (err.response) {
	                  var data = err.response.data;
	                  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	                    if ('Email' in data && 'FamilyName' in data && 'GivenName' in data && 'Phone' in data) {
	                      Object.keys(data).map(function (key) {
	                        var camelKey = key.charAt(0).toLowerCase() + key.substring(1);
	                        stateObj.dracar[camelKey] = data[key];
	                      });
	                      stateObj.selectedSuggested = true;
	                      stateObj['searchEmail'] = data['Email'];
	                      stateObj['searchFamilyName'] = data['FamilyName'];
	                      stateObj['searchGivenName'] = data['GivenName'];
	                      stateObj['searchPhone'] = data['Phone'];
	                      search = true;
	                    }
	                  }
	                }
	
	                _this7.setState(_extends({}, stateObj), function () {
	                  _this7.handleSearchForSuggestedCustomer(null, search);
	                });
	              });
	            });
	          }).catch(function (err) {
	            _this7.setState(_extends({}, spinnersOff), function () {
	              _this7.handleErrors(err);
	            });
	          });
	        });
	      }
	    }
	  }, {
	    key: 'getKeyLoopSystemName',
	    value: function getKeyLoopSystemName() {
	      switch (this.props.auth.accountingSystem) {
	        case 4:
	          return (0, _helpers.translation)(15352);
	        case 6:
	          return (0, _helpers.translation)(18138);
	      }
	      return '';
	    }
	  }, {
	    key: 'getRepairOrderAlias',
	    value: function getRepairOrderAlias() {
	      switch (this.props.auth.accountingSystem) {
	        case 4:
	          return (0, _helpers.translation)(18149);
	        case 6:
	          return (0, _helpers.translation)(18150);
	      }
	      return '';
	    }
	  }, {
	    key: 'renderMatchedCustomers',
	    value: function renderMatchedCustomers() {
	      var _this8 = this;
	
	      var _state4 = this.state,
	          dracar = _state4.dracar,
	          customerSuggestions = _state4.customerSuggestions,
	          showSearchSpinner = _state4.showSearchSpinner,
	          hasInsuranceDebtorInDracar = _state4.hasInsuranceDebtorInDracar;
	
	
	      if (showSearchSpinner) return this.renderSpinner();
	
	      var renderLabel = function renderLabel(item) {
	        var label = '';
	        if (item.givenName) {
	          label += item.givenName + ' ';
	        }
	        if (item.familyName) {
	          label += '' + item.familyName;
	        }
	        if (item.phone) {
	          label += '\n' + item.phone;
	        }
	        if (item.email) {
	          label += '\n' + item.email;
	        }
	        if (item.companyId) {
	          label += '\n' + item.companyId;
	        }
	        if (label === '') {
	          label += (0, _helpers.translation)('16594');
	        }
	
	        return label;
	      };
	
	      var content = _react2.default.createElement(
	        _label2.default,
	        null,
	        (0, _helpers.translation)('16594')
	      );
	      if (customerSuggestions.length > 0) {
	        content = customerSuggestions.map(function (item, index) {
	          var radioName = 'customerSuggestion-' + index;
	          var itemId = item.customerId !== undefined ? item.customerId : item.companyId;
	          return _react2.default.createElement(_radio2.default, { key: 'suggestion-' + index,
	            name: radioName,
	            onChange: function onChange(e) {
	              return _this8.handleSuggestedCustomer(radioName, item);
	            },
	            checked: itemId === dracar.customerId,
	            labelText: renderLabel(item)
	          });
	        });
	      } else if (hasInsuranceDebtorInDracar) {
	        return renderLabel(dracar);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: dracar.isCompany ? 'dracarModal__customers' : 'dracarModal__customers__private' },
	        content
	      );
	    }
	  }, {
	    key: 'renderSpinner',
	    value: function renderSpinner() {
	      return _react2.default.createElement(
	        _grid2.default,
	        { cols: ['min-content', 1, 'max-content'], align: 'center' },
	        _react2.default.createElement('div', { className: 'divider', key: '1' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'dracarModal__spinner', key: '2' },
	          _react2.default.createElement(
	            'span',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(step) {
	      var _this9 = this;
	
	      if (this.state.showSpinner) return this.renderSpinner();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dracarModal__header' },
	        _react2.default.createElement(
	          _tabBar2.default,
	          null,
	          _react2.default.createElement(
	            _tabItem2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: step === 1 ? 'active' : '', onClick: function onClick(e) {
	                  return _this9.handleValidation(1);
	                } },
	              (0, _helpers.translation)('16765')
	            )
	          ),
	          this.state.createNewRepairOrder && [_react2.default.createElement(
	            _tabItem2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: step === 2 ? 'active' : '', onClick: function onClick(e) {
	                  return _this9.handleValidation(2);
	                } },
	              (0, _helpers.translation)('58')
	            )
	          ), _react2.default.createElement(
	            _tabItem2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: step === 3 ? 'active' : '', onClick: function onClick(e) {
	                  return _this9.handleValidation(3);
	                } },
	              (0, _helpers.translation)('16587')
	            )
	          )]
	        )
	      );
	    }
	  }, {
	    key: 'renderStepOne',
	    value: function renderStepOne() {
	      var _this10 = this;
	
	      var _state5 = this.state,
	          sparePartSuppliers = _state5.sparePartSuppliers,
	          dracar = _state5.dracar,
	          createNewRepairOrder = _state5.createNewRepairOrder;
	
	      var supplier = function supplier(val, key) {
	        return _react2.default.createElement(
	          'option',
	          { key: key, value: val.Id },
	          val.Name
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'dracarModal__suppliers' },
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('16766')
	            ),
	            _react2.default.createElement(
	              _dropDown2.default,
	              { name: 'sparePartSupplier', value: dracar.sparePartSupplier, onChange: this.onSupplierChange, labelText: (0, _helpers.translation)('16767') },
	              _react2.default.createElement(
	                'option',
	                { value: '0' },
	                (0, _helpers.translation)('16768')
	              ),
	              sparePartSuppliers.map(supplier)
	            ),
	            _react2.default.createElement(_divider2.default, { noLine: true }),
	            _react2.default.createElement(_radio2.default, {
	              name: 'createNewRepairOrder',
	              onChange: function onChange(e) {
	                return _this10.handleOnChangeCreateNewRepairOrder(e, true);
	              },
	              checked: createNewRepairOrder,
	              labelText: (0, _helpers.translation)('16816').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()).replace('[RepairOrderAlias]', this.getRepairOrderAlias())
	            }),
	            _react2.default.createElement(_radio2.default, {
	              name: 'createNewRepairOrder',
	              onChange: function onChange(e) {
	                return _this10.handleOnChangeCreateNewRepairOrder(e, false);
	              },
	              checked: !createNewRepairOrder,
	              labelText: (0, _helpers.translation)('16817').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()).replace('[RepairOrderAlias]', this.getRepairOrderAlias())
	            }),
	            !createNewRepairOrder && [_react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('16820').replace('[RepairOrderAlias]', this.getRepairOrderAlias()), name: 'repairOrderId', onChange: this.onChange.bind(this), value: this.state.repairOrderId })]
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderStepTwo',
	    value: function renderStepTwo() {
	      var _this11 = this;
	
	      var _state6 = this.state,
	          dracar = _state6.dracar,
	          selectedSuggested = _state6.selectedSuggested,
	          disableCustomerInput = _state6.disableCustomerInput,
	          customerTypeChecked = _state6.customerTypeChecked,
	          searchGivenName = _state6.searchGivenName,
	          searchFamilyName = _state6.searchFamilyName,
	          searchPhone = _state6.searchPhone,
	          searchEmail = _state6.searchEmail,
	          vehicleExist = _state6.vehicleExist,
	          hasInsuranceDebtorInDracar = _state6.hasInsuranceDebtorInDracar;
	
	
	      var searchButtonStyle = 'primary';
	      if (selectedSuggested) searchButtonStyle = 'link';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        vehicleExist && _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'dracarModal__col' },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('58') },
	                _react2.default.createElement(_divider2.default, { noLine: true }),
	                !customerTypeChecked ? null : _react2.default.createElement(_text2.default, {
	                  labelText: dracar.isCompany || dracar.isCompanyType ? (0, _helpers.translation)('30') : (0, _helpers.translation)('16606'),
	                  name: 'searchGivenName',
	                  onChange: this.handleOnSearchChange,
	                  value: searchGivenName,
	                  disabled: disableCustomerInput
	                }),
	                !customerTypeChecked ? null : dracar.isCompany || dracar.customerType === CustomerType.company ? null : _react2.default.createElement(_text2.default, {
	                  labelText: (0, _helpers.translation)('16607'),
	                  name: 'searchFamilyName',
	                  onChange: this.handleOnSearchChange,
	                  value: searchFamilyName,
	                  disabled: disableCustomerInput
	                }),
	                _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('31'), name: 'searchPhone', onChange: this.handleOnSearchChange, value: searchPhone, disabled: disableCustomerInput }),
	                _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('1052'), name: 'searchEmail', onChange: this.handleOnSearchChange, value: searchEmail, disabled: disableCustomerInput }),
	                _react2.default.createElement(_button2.default, { style: searchButtonStyle, spacing: '0', size: 'l', onClick: this.handleSearchForSuggestedCustomer, labelText: (0, _helpers.translation)('16625'), disabled: disableCustomerInput })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('16763').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()) },
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              this.props.auth.accountingSystem === 4 && _react2.default.createElement(_radio2.default, {
	                name: 'isInsuranceType',
	                onChange: function onChange(e) {
	                  return _this11.handleSelectRecipientInvoice({ target: { name: e.target.name, value: e.target.checked } });
	                },
	                checked: dracar.isInsuranceType,
	                labelText: (0, _helpers.translation)('418'),
	                disabled: !hasInsuranceDebtorInDracar
	              }),
	              _react2.default.createElement(_radio2.default, {
	                name: 'isCustomerType',
	                onChange: function onChange(e) {
	                  return _this11.handleSelectRecipientInvoice({ target: { name: e.target.name, value: e.target.checked } });
	                },
	                checked: dracar.isCustomerType,
	                labelText: (0, _helpers.translation)('14893')
	              }),
	              _react2.default.createElement(_radio2.default, {
	                name: 'isCompanyType',
	                onChange: function onChange(e) {
	                  return _this11.handleSelectRecipientInvoice({ target: { name: e.target.name, value: e.target.checked } });
	                },
	                checked: dracar.isCompanyType,
	                labelText: (0, _helpers.translation)('65')
	              }),
	              _react2.default.createElement(_orangeDivider2.default, { size: 2 }),
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('16590') },
	                this.renderMatchedCustomers()
	              )
	            )
	          )
	        ),
	        !vehicleExist && _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('17951').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()) },
	              (0, _helpers.translation)('17952').replace('[KeyLoopSystem]', this.getKeyLoopSystemName())
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderStepThree',
	    value: function renderStepThree() {
	      var _state7 = this.state,
	          dracar = _state7.dracar,
	          vehicleExist = _state7.vehicleExist,
	          disableLicensePlateInput = _state7.disableLicensePlateInput,
	          showSearchSpinner = _state7.showSearchSpinner,
	          handledFirstTimeLicensePlateSearch = _state7.handledFirstTimeLicensePlateSearch,
	          showCreateOrderButton = _state7.showCreateOrderButton;
	
	
	      var hasLicensePlateFilled = dracar.licensePlate.replace(/\s/g, '').length > 0;
	      var searchButtonStyle = handledFirstTimeLicensePlateSearch && hasLicensePlateFilled && showCreateOrderButton ? 'link' : 'primary';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('16587') },
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('78'),
	                name: 'licensePlate',
	                onChange: this.handleOnChangeLicensePlate,
	                value: dracar.licensePlate,
	                disabled: disableLicensePlateInput,
	                placeholder: (0, _helpers.translation)('16498')
	              }),
	              this.renderVehicleInfo(),
	              vehicleExist ? null : _react2.default.createElement(_button2.default, { style: searchButtonStyle, spacing: '0', size: 'l', onClick: this.handleSearchForVehicle.bind(this), labelText: (0, _helpers.translation)('16635'), disabled: showSearchSpinner })
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('16588') },
	              _react2.default.createElement(_divider2.default, { noLine: true }),
	              showSearchSpinner ? this.renderSpinner() : _react2.default.createElement(
	                _label2.default,
	                null,
	                vehicleExist ? (0, _helpers.translation)('16592').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()) : !handledFirstTimeLicensePlateSearch || !hasLicensePlateFilled || !showCreateOrderButton ? '' : (0, _helpers.translation)('16634')
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderVehicleInfo',
	    value: function renderVehicleInfo() {
	      var _state8 = this.state,
	          vehicleExist = _state8.vehicleExist,
	          foundVehicle = _state8.foundVehicle;
	
	      if (!vehicleExist || !foundVehicle) return null;
	
	      return _react2.default.createElement(
	        _label2.default,
	        null,
	        foundVehicle.make + ' ' + foundVehicle.model + ' ' + foundVehicle.modelYear + '\n' + foundVehicle.vin
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      var _state9 = this.state,
	          dracar = _state9.dracar,
	          step = _state9.step,
	          showSpinner = _state9.showSpinner,
	          showButtonSpinner = _state9.showButtonSpinner,
	          customerTypeChecked = _state9.customerTypeChecked,
	          selectedSuggested = _state9.selectedSuggested,
	          invalidOrder = _state9.invalidOrder,
	          vehicleExist = _state9.vehicleExist,
	          hasInsuranceDebtorInDracar = _state9.hasInsuranceDebtorInDracar,
	          disableCustomerInput = _state9.disableCustomerInput;
	
	
	      var nextButtonDisabled = (showButtonSpinner || this.hasSelectedCustomerState() || !customerTypeChecked) && selectedSuggested || invalidOrder;
	      var hasLicensePlateFilled = dracar.licensePlate.replace(/\s/g, '').length > 0;
	
	      if (!hasInsuranceDebtorInDracar) {
	        if (!dracar.isCustomerType && !dracar.isCompanyType) nextButtonDisabled = true;else nextButtonDisabled = !selectedSuggested;
	      } else nextButtonDisabled = false;
	
	      if ((dracar.isCustomerType || dracar.isCompanyType) && !selectedSuggested && !disableCustomerInput) nextButtonDisabled = true;
	
	      var renderView = function renderView() {
	        return null;
	      };
	      var bottomBarProps = null;
	      var className = 'dracarModal';
	      var hiddeButton = ' disabled-action-label';
	
	      switch (step) {
	        case 1:
	        default:
	          var stepOneAction = this.handleValidation.bind(this, 2);
	          if (!this.state.createNewRepairOrder) {
	            stepOneAction = this.getDracarRepairOrder.bind(this);
	          }
	          if (dracar.sparePartSupplier === 0) className += hiddeButton;
	          renderView = function renderView() {
	            return _this12.renderStepOne();
	          };
	          bottomBarProps = {
	            actionLabelText: (0, _helpers.translation)('237'),
	            onActionClick: stepOneAction,
	            cancelLabelText: (0, _helpers.translation)('1155'),
	            onCancelClick: function onCancelClick() {
	              return _this12.props.handleToggle();
	            },
	            center: true
	          };
	          break;
	        case 2:
	          if (nextButtonDisabled) className += hiddeButton;
	          renderView = function renderView() {
	            return _this12.renderStepTwo();
	          };
	          bottomBarProps = {
	            actionLabelText: (0, _helpers.translation)('237'),
	            onActionClick: function onActionClick() {
	              return _this12.handleValidation(3);
	            },
	            cancelLabelText: (0, _helpers.translation)('1155'),
	            onCancelClick: function onCancelClick() {
	              return _this12.props.handleToggle();
	            },
	            center: true
	          };
	          break;
	        case 3:
	          if (!hasLicensePlateFilled || !vehicleExist || showSpinner) className += hiddeButton;
	          renderView = function renderView() {
	            return _this12.renderStepThree();
	          };
	          bottomBarProps = {
	            actionLabelText: (0, _helpers.translation)('16589').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()),
	            onActionClick: function onActionClick() {
	              return _this12.handleValidation(4);
	            },
	            cancelLabelText: (0, _helpers.translation)('1155'),
	            onCancelClick: function onCancelClick() {
	              return _this12.props.handleToggle();
	            },
	            center: true
	          };
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('16591').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()),
	            overflowHidden: this.state.overflowHidden,
	            icon: _icons.MainMenuIcons.Forsi_White,
	            bottomBarProps: showSpinner ? null : bottomBarProps
	          }),
	          this.renderHeader(step),
	          _react2.default.createElement(
	            'div',
	            null,
	            !showSpinner && renderView()
	          )
	        )
	      );
	    }
	  }]);
	
	  return DracarModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createDracarRepairOrder: _dracar.createDracarRepairOrder,
	  useDracarRepairOrder: _dracar.useDracarRepairOrder,
	  searchDracarCustomer: _dracar.searchDracarCustomer,
	  searchDracarCompany: _dracar.searchDracarCompany,
	  searchDracarCustomerCompany: _dracar.searchDracarCustomerCompany,
	  searchDracarVehicle: _dracar.searchDracarVehicle,
	  checkForDracarVehicle: _dracar.checkForDracarVehicle,
	  validateOrder: _dracar.validateOrder,
	  validateDracarCustomer: _dracar.validateDracarCustomer,
	  validateDracarVehicle: _dracar.validateDracarVehicle,
	  getDracarRepairOrder: _dracar.getDracarRepairOrder,
	  getOrder: _orders.getOrder,
	  getOrderVehicleData: _orders.getOrderVehicleData,
	  getListSimple: _spareparts.getListSimple
	})(DracarModal);

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icons = __webpack_require__(6);
	
	var _carownerportal = __webpack_require__(192);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// import components
	
	
	// Actions
	
	
	var EnableCarOwnerPortalModal = function (_Component) {
	  _inherits(EnableCarOwnerPortalModal, _Component);
	
	  function EnableCarOwnerPortalModal(props) {
	    _classCallCheck(this, EnableCarOwnerPortalModal);
	
	    var _this = _possibleConstructorReturn(this, (EnableCarOwnerPortalModal.__proto__ || Object.getPrototypeOf(EnableCarOwnerPortalModal)).call(this, props));
	
	    _this.state = {
	      tabView: 'draft',
	      headerTitle: '18152',
	      overflowHidden: false,
	      CarOwnerPhone: '',
	      CarOwnerMail: ''
	    };
	
	    _this.renderButtonText = _this.renderButtonText.bind(_this);
	    _this.redirectToOrder = _this.redirectToOrder.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    _this.onButtonYesClick = _this.onButtonYesClick.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.onMailChange = _this.onMailChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(EnableCarOwnerPortalModal, [{
	    key: 'renderButtonText',
	    value: function renderButtonText(text) {
	      if (this.state.forsiIsLoading) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'animated-background' },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-x fa-fw', style: { lineHeight: '13px' } })
	        );
	      }
	      return (0, _helpers.translation)(text);
	    }
	  }, {
	    key: 'redirectToOrder',
	    value: function redirectToOrder(orderId) {
	      this.props.router.push({
	        pathname: '/orders/' + orderId,
	        state: { createdNew: true }
	      });
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose(e) {
	      // this.redirectToOrder(this.props.orderId)
	      e.preventDefault();
	      this.props.onCloseCarOwnerMadal();
	    }
	  }, {
	    key: 'onButtonYesClick',
	    value: function onButtonYesClick(e) {
	      e.preventDefault();
	      this.props.addCarOwnerInformation(this.state.CarOwnerPhone, this.state.CarOwnerMail);
	      // let request = {
	      //   OrderId: this.props.orderId,
	      //   CarOwnerPhone: this.state.CarOwnerPhone,
	      //   CarOwnerMail: this.state.CarOwnerMail
	      // }
	      // this.props.enableCarOwnerPortalAccess(request).then((res) => {
	      //   this.redirectToOrder(this.props.orderId)
	      // })
	    }
	  }, {
	    key: 'onPhoneChange',
	    value: function onPhoneChange(e) {
	      this.setState({ CarOwnerPhone: e.target.value });
	    }
	  }, {
	    key: 'onMailChange',
	    value: function onMailChange(e) {
	      this.setState({ CarOwnerMail: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalClass = 'neworder__modal';
	
	      var view = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('18312') }),
	        _react2.default.createElement(_labelWrapper2.default, { labelText: (0, _helpers.translation)('18313') }),
	        _react2.default.createElement(_text2.default, { key: 'CarOwnerPhone', labelText: (0, _helpers.translation)('14762'), type: 'text', name: 'CarOwnerPhone', value: this.state.CarOwnerPhone, onChange: this.onPhoneChange, autoComplete: 'off' }),
	        _react2.default.createElement(_text2.default, { key: 'CarOwnerMail', labelText: (0, _helpers.translation)('14763'), type: 'text', name: 'CarOwnerMail', value: this.state.CarOwnerMail, onChange: this.onMailChange, autoComplete: 'off' }),
	        _react2.default.createElement(_button2.default, {
	          labelText: this.renderButtonText('1406'),
	          onClick: this.onButtonYesClick,
	          style: 'link',
	          disabled: !this.state.CarOwnerPhone && !this.state.CarOwnerMail
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: modalClass },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({ ref: 'modal' }, this.props, {
	            header: (0, _helpers.translation)(this.state.headerTitle),
	            overflowHidden: this.state.overflowHidden,
	            clickOutsideClose: false,
	            onClose: this.onClose,
	            icon: _icons.ModalIcons.Quality_Check
	          }),
	          view
	        )
	      );
	    }
	  }]);
	
	  return EnableCarOwnerPortalModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  enableCarOwnerPortalAccess: _carownerportal.enableCarOwnerPortalAccess
	})(EnableCarOwnerPortalModal);

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _null = __webpack_require__(236);
	
	var _null2 = _interopRequireDefault(_null);
	
	var _helpers = __webpack_require__(2);
	
	var _password = __webpack_require__(796);
	
	__webpack_require__(1640);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import components
	
	
	// Utils
	
	// actions
	
	
	// styles
	
	
	var ForgotPasswordModal = function (_Component) {
	  _inherits(ForgotPasswordModal, _Component);
	
	  function ForgotPasswordModal(props) {
	    _classCallCheck(this, ForgotPasswordModal);
	
	    var _this = _possibleConstructorReturn(this, (ForgotPasswordModal.__proto__ || Object.getPrototypeOf(ForgotPasswordModal)).call(this, props));
	
	    _this.state = {
	      email: '',
	      emailSent: false
	    };
	    _this.resetPassword = _this.resetPassword.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(ForgotPasswordModal, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState({
	        email: e.target.value
	      });
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword() {
	      var _this2 = this;
	
	      var email = this.state.email;
	      if (email === '') {
	        window.toastr.error((0, _helpers.translation)('16329'), (0, _helpers.translation)('216'));
	        return;
	      }
	      this.props.forgotPassword(email).then(function (res) {
	        _this2.setState({
	          emailSent: true
	        });
	      }, function (err) {
	        if (err.response.data !== undefined) {
	          var error = err.response.data;
	          // Toastr
	          window.toastr.error((0, _helpers.translation)(error.DictionaryKey), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      var _this3 = this;
	
	      // Close and reset state
	      this.setState({ emailSent: false, email: '' }, function () {
	        _this3.props.onClose();
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.emailSent === true) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'content ' },
	          _react2.default.createElement(
	            _col2.default,
	            { span: 2 },
	            _react2.default.createElement(
	              _panel2.default,
	              { title: (0, _helpers.translation)('16328') },
	              _react2.default.createElement(
	                'p',
	                null,
	                (0, _helpers.translation)('16325')
	              ),
	              _react2.default.createElement(_button2.default, { labelText: (0, _helpers.translation)(956), onClick: this.onClose })
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('16321') },
	            _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('1052'), name: 'email', value: this.state.email, onChange: this.onChange }),
	            _react2.default.createElement(_button2.default, { labelText: (0, _helpers.translation)('16327'), onClick: this.resetPassword })
	          )
	        ),
	        _react2.default.createElement(
	          _null2.default,
	          null,
	          _react2.default.createElement('div', { className: 'divider' })
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(
	            _panel2.default,
	            { title: (0, _helpers.translation)('16322') },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                (0, _helpers.translation)('16323')
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                (0, _helpers.translation)('16324')
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                (0, _helpers.translation)('16325')
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                (0, _helpers.translation)('16326')
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                (0, _helpers.translation)('16389')
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalTitle = this.state.emailSent ? (0, _helpers.translation)('16328') : (0, _helpers.translation)('2144');
	      return _react2.default.createElement(
	        'div',
	        { className: 'forgotPassword_modal' + (this.state.emailSent ? ' isSent' : '') },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: modalTitle }),
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	
	  return ForgotPasswordModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, { forgotPassword: _password.forgotPassword })(ForgotPasswordModal);

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _generalnotes = __webpack_require__(279);
	
	__webpack_require__(1641);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _icons = __webpack_require__(6);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Utils
	
	
	var GeneralNotesModal = function (_Component) {
	  _inherits(GeneralNotesModal, _Component);
	
	  function GeneralNotesModal(props) {
	    _classCallCheck(this, GeneralNotesModal);
	
	    var _this = _possibleConstructorReturn(this, (GeneralNotesModal.__proto__ || Object.getPrototypeOf(GeneralNotesModal)).call(this, props));
	
	    _this.state = {
	      show: false,
	      showEdit: false,
	      note: props.note,
	      standardNotes: [],
	      isLoading: false,
	      error: ''
	    };
	    _this.manipulateNote = _this.manipulateNote.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(GeneralNotesModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (props.show !== this.state.show) {
	        this.setState({
	          show: props.show,
	          note: _extends({}, this.state.note, props.note),
	          isLoading: false,
	          error: ''
	        });
	      }
	    }
	  }, {
	    key: 'manipulateNote',
	    value: function manipulateNote(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      this.setState({ isLoading: true, error: '' });
	
	      setTimeout(function () {
	        if (_this2.validateInputs()) {
	          // Edit note
	          // console.log('post', this.state.note)
	          _this2.props.postNote(_this2.state.note).then(function (res) {
	            _this2.props.onSuccess(res.data);
	            _this2.props.onClose(false);
	            // Toastr
	            // window.toastr.success(translation('1931'), translation('13424'))
	          }, function (err) {
	            if (err) {
	              _this2.setState({
	                isLoading: false
	              });
	              // Toastr
	              window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	            }
	          });
	        } else {
	          _this2.setState({
	            isLoading: false
	          });
	          window.toastr.error((0, _helpers.translation)('13430'), (0, _helpers.translation)('216'));
	        }
	      }, 50);
	    }
	  }, {
	    key: 'validateInputs',
	    value: function validateInputs() {
	      if (this.state.note.Note === '') {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      // called at "onClick" for checkbox... for some reason "onChange" doesn't work here
	      this.setState({
	        note: _extends({}, this.state.note, {
	          Note: e.target.value
	        })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (typeof this.props.note.Note === 'undefined') return null;
	
	      var modalTitle = (0, _helpers.translation)('13356');
	      var buttonText = (0, _helpers.translation)('13358');
	      if (typeof this.props.note.IsMine !== 'undefined') {
	        buttonText = (0, _helpers.translation)('13357');
	        modalTitle = (0, _helpers.translation)('13357');
	      }
	
	      var bottomBarProps = {
	        disabled: this.state.isLoading,
	        actionLabelText: buttonText,
	        onActionClick: this.manipulateNote
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'notes_modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: modalTitle, icon: _icons.ModalIcons.Note, bottomBarProps: bottomBarProps }),
	          this.state.error && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.state.error
	          ),
	          _react2.default.createElement(_textarea2.default, { name: 'Note', onChange: this.onInputChange, value: this.state.note.Note })
	        )
	      );
	    }
	  }]);
	
	  return GeneralNotesModal;
	}(_react.Component);
	
	GeneralNotesModal.propTypes = {
	  postNote: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { postNote: _generalnotes.postNote })(GeneralNotesModal);

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _shops = __webpack_require__(79);
	
	var _carrental = __webpack_require__(223);
	
	var _carrentalalternatives = __webpack_require__(403);
	
	var _orders = __webpack_require__(21);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _DateTimePeriod = __webpack_require__(1023);
	
	var _DateTimePeriod2 = _interopRequireDefault(_DateTimePeriod);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _icons = __webpack_require__(6);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _addButton = __webpack_require__(62);
	
	var _addButton2 = _interopRequireDefault(_addButton);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _helpers = __webpack_require__(2);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// components
	
	
	// elements
	
	
	// Utils
	
	
	// contants
	
	
	// styles
	
	
	var HandleCarRentalModal = function (_Component) {
	  _inherits(HandleCarRentalModal, _Component);
	
	  function HandleCarRentalModal(props) {
	    _classCallCheck(this, HandleCarRentalModal);
	
	    var _this = _possibleConstructorReturn(this, (HandleCarRentalModal.__proto__ || Object.getPrototypeOf(HandleCarRentalModal)).call(this, props));
	
	    _this.state = {
	      isLoading: false,
	      CurrentPeriod: null,
	      SelectedPeriods: [],
	      AvailableRentalCars: [],
	      AvailableRentalAlts: [],
	      AvailablePeriods: [],
	      timesFrom: [],
	      timesTo: [],
	      confirmDiscardCurrentPeriod: {
	        open: false
	      }
	    };
	
	    _this.makeTimes = _this.makeTimes.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.renderPeriods = _this.renderPeriods.bind(_this);
	    _this.addPeriod = _this.addPeriod.bind(_this);
	    _this.createNewPeriod = _this.createNewPeriod.bind(_this);
	    _this.removePeriod = _this.removePeriod.bind(_this);
	    _this.savePeriods = _this.savePeriods.bind(_this);
	    _this.onChangePeriod = _this.onChangePeriod.bind(_this);
	    _this.onChangeDate = _this.onChangeDate.bind(_this);
	    _this.onValidatePeriod = _this.onValidatePeriod.bind(_this);
	    _this.setTimesFrom = _this.setTimesFrom.bind(_this);
	    _this.setTimesTo = _this.setTimesTo.bind(_this);
	
	    _this.getCarAvailabilityForPeriod = _this.getCarAvailabilityForPeriod.bind(_this);
	    // this.validateAssignments = this.validateAssignments.bind(this)
	    _this.getAssignments = _this.getAssignments.bind(_this);
	    _this.updateAssignments = _this.updateAssignments.bind(_this);
	    _this.newAssignment = _this.newAssignment.bind(_this);
	    _this.getCarRentalAlts = _this.getCarRentalAlts.bind(_this);
	    _this.onConfirmClose = _this.onConfirmClose.bind(_this);
	    _this.onConfirm = _this.onConfirm.bind(_this);
	    _this.savePeriodsCheckCurrent = _this.savePeriodsCheckCurrent.bind(_this);
	    return _this;
	  }
	
	  _createClass(HandleCarRentalModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCarAvailabilityForPeriod(null, null);
	      this.getCarRentalAlts();
	      this.getAssignments(false, true);
	
	      this.setState({
	        timesFrom: this.props.pickupTimes,
	        timesTo: this.props.deliveryTimes
	      });
	    }
	  }, {
	    key: 'getCarRentalAlts',
	    value: function getCarRentalAlts() {
	      var _this2 = this;
	
	      this.props.GetCarRentalAlts().then(function (res) {
	        _this2.setState({
	          AvailableRentalAlts: res.data
	        });
	      });
	    }
	  }, {
	    key: 'getCarAvailabilityForPeriod',
	    value: function getCarAvailabilityForPeriod(start, end) {
	      var _this3 = this;
	
	      this.props.GetAvailableCars(this.props.orderId, start, end).then(function (res) {
	        _this3.setState({
	          AvailableRentalCars: res.data.Cars
	        });
	      });
	    }
	  }, {
	    key: 'getAssignments',
	    value: function getAssignments(getInactive) {
	      var _this4 = this;
	
	      var clearInactive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.props.GetAssignments(this.props.orderId, getInactive, clearInactive).then(function (res) {
	        var assignments = res.data.Assignments.map(function (x) {
	          return _extends({}, x, { added: true, RentalOption: x.CarRentalAltId !== null ? 1 : 0 });
	        });
	        _this4.setState({
	          SelectedPeriods: assignments
	        });
	      });
	    }
	  }, {
	    key: 'updateAssignments',
	    value: function updateAssignments(assignments, activate) {
	      return this.props.UpdateAssignments(this.props.orderId, true, activate, assignments);
	    }
	
	    // validateAssignments () {
	    //   let assignments = []
	    //   for (let i = 0; i < this.state.SelectedPeriods.length; i++) {
	    //     assignments.push(this.state.SelectedPeriods[i])
	    //     // const period = this.state.SelectedPeriods[i]
	    //     // assignments.push({ CarRentalId: period.CarRentalId, Start: period.Start, End: period.DateTo })
	    //   }
	    //   assignments.push(this.state.CurrentPeriod)
	    //   // assignments.push({ CarRentalId: this.state.CurrentPeriod.CarRentalId, Start: this.state.CurrentPeriod.Start, End: this.state.CurrentPeriod.End })
	
	    //   this.props.ValidateAssignments(this.props.orderId, assignments).then(res => {
	    //     if (!res.data.IsValid) {
	    //       window.toastr.error('Invalid', translation('216'))
	    //     }
	    //   })
	    // }
	
	  }, {
	    key: 'makeTimes',
	    value: function makeTimes(date, times) {
	      if (times === null || times.length === 0) {
	        times = [(0, _moment2.default)(date).format('HH:mm')];
	      }
	      return times;
	    }
	  }, {
	    key: 'newAssignment',
	    value: function newAssignment() {
	      return {
	        Start: this.props.pickup || '',
	        End: this.props.delivery || '',
	        RentalOption: 0, // 0 - CarRental, 1- CarRentalAlt
	        CarRentalId: 0,
	        // CarRentalAltId: 0
	        added: false
	      };
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e, t) {
	      var value = e.target.value;
	      var name = e.target.name;
	      if (e.target.type === 'radio') {
	        value = parseInt(e.target.value);
	        name = name.split('_')[0];
	      }
	      var currentPeriod = this.state.CurrentPeriod;
	      if (name === 'CarRentalId') {
	        currentPeriod.CarRentalAltId = null;
	      } else if (name === 'CarRentalAltId') {
	        currentPeriod.CarRentalId = null;
	      }
	      currentPeriod[name] = value;
	      this.setState({
	        CurrentPeriod: currentPeriod
	      });
	    }
	  }, {
	    key: 'addPeriod',
	    value: function addPeriod() {
	      var _this5 = this;
	
	      var selectedPeriods = [].concat(_toConsumableArray(this.state.SelectedPeriods));
	      if (this.state.CurrentPeriod !== null) {
	        selectedPeriods.push(this.state.CurrentPeriod);
	      }
	
	      this.updateAssignments(selectedPeriods, false).then(function (res) {
	        if (res.data.Errors.length > 0) {
	          res.data.Errors.map(function (x) {
	            return window.toastr.error((0, _helpers.translation)(x.DictionaryKey), (0, _helpers.translation)('216'));
	          });
	        } else {
	          var assignments = res.data.Assignments.map(function (x) {
	            return _extends({}, x, { added: true, RentalOption: x.CarRentalAltId !== null ? 1 : 0 });
	          });
	          _this5.setState({ SelectedPeriods: assignments, CurrentPeriod: null });
	        }
	      });
	    }
	  }, {
	    key: 'removePeriod',
	    value: function removePeriod(key) {
	      var index = parseInt(key);
	      var selectedPeriods = [].concat(_toConsumableArray(this.state.SelectedPeriods));
	      selectedPeriods.splice(index, 1);
	      this.setState({
	        SelectedPeriods: selectedPeriods
	      });
	    }
	  }, {
	    key: 'createNewPeriod',
	    value: function createNewPeriod() {
	      var _this6 = this;
	
	      var start = this.state.SelectedPeriods.length > 0 ? this.state.SelectedPeriods[this.state.SelectedPeriods.length - 1].End : this.props.pickup || '';
	      this.setState({
	        CurrentPeriod: {
	          Start: start,
	          End: this.props.delivery || '',
	          RentalOption: 0,
	          CarRentalId: 0,
	          CarRentalAltId: null,
	          added: false
	        }
	      }, function () {
	        _this6.setTimesFrom(start);
	        _this6.setTimesTo(_this6.props.delivery);
	      });
	    }
	  }, {
	    key: 'onChangeDate',
	    value: function onChangeDate(name, date) {
	      if (name.endsWith('From')) {
	        // Pickup
	        this.setTimesFrom(date, true);
	      } else {
	        // Delivery
	        this.setTimesTo(date);
	      }
	    }
	  }, {
	    key: 'setTimesFrom',
	    value: function setTimesFrom(date, changed) {
	      var _this7 = this;
	
	      var dateString = void 0;
	      if (typeof date.format === 'function') {
	        dateString = date.format('YYYY-MM-DDTHH:mm');
	      } else {
	        dateString = date;
	      }
	
	      var data = {
	        OrderId: this.props.orderId,
	        Department: 1,
	        Date: dateString
	      };
	      this.props.getAvailablePickupTimes(data).then(function (res) {
	        var availableTimes = res.data.AvailableTimes;
	        var stateValues = {
	          timesFrom: availableTimes
	        };
	        if (_this7.state.CurrentPeriod) {
	          var start = (0, _moment2.default)(_this7.state.CurrentPeriod.Start).format('HH:mm');
	          var notOriginalDate = (0, _moment2.default)(res.data.NextValidDate).format('YYYY-MM-DD') !== (0, _moment2.default)(dateString).format('YYYY-MM-DD');
	          if (availableTimes.indexOf(start) === -1 || changed || notOriginalDate) {
	            var newStart = void 0;
	            if (notOriginalDate) {
	              newStart = (0, _moment2.default)(res.data.NextValidDate).format('YYYY-MM-DDT');
	            } else if (changed) {
	              newStart = (0, _moment2.default)(dateString).format('YYYY-MM-DDT');
	            } else {
	              newStart = (0, _moment2.default)(_this7.state.CurrentPeriod.Start).format('YYYY-MM-DDT');
	            }
	            newStart += availableTimes[0];
	            stateValues.CurrentPeriod = _extends({}, _this7.state.CurrentPeriod, {
	              Start: newStart
	            });
	          }
	        }
	        _this7.setState(stateValues, function () {
	          _this7.getCarAvailabilityForPeriod(_this7.state.CurrentPeriod.Start, _this7.state.CurrentPeriod.End);
	        });
	      });
	    }
	  }, {
	    key: 'setTimesTo',
	    value: function setTimesTo(date) {
	      var _this8 = this;
	
	      var dateString = void 0;
	      if (typeof date.format === 'function') {
	        dateString = date.format('YYYY-MM-DDTHH:mm');
	      } else {
	        dateString = date;
	      }
	
	      this.props.getDeliveryTimes(dateString, 1, this.props.orderId).then(function (res) {
	        _this8.setState({ timesTo: res.data.AvailableDeliveryTimes }, function () {
	          return _this8.getCarAvailabilityForPeriod(_this8.state.CurrentPeriod.Start, _this8.state.CurrentPeriod.End);
	        });
	      });
	    }
	  }, {
	    key: 'onChangePeriod',
	    value: function onChangePeriod(name, date) {
	      var _this9 = this;
	
	      var field = name.endsWith('from') ? 'Start' : 'End';
	      this.setState({
	        CurrentPeriod: _extends({}, this.state.CurrentPeriod, _defineProperty({}, field, date.format('YYYY-MM-DDTHH:mm')))
	      }, function () {
	        _this9.getCarAvailabilityForPeriod(_this9.state.CurrentPeriod.Start, _this9.state.CurrentPeriod.End);
	      });
	    }
	  }, {
	    key: 'onValidatePeriod',
	    value: function onValidatePeriod(name, date) {
	      var pickupMoment = (0, _moment2.default)(this.props.pickup);
	      var deliveryMoment = (0, _moment2.default)(this.props.delivery);
	      if (this.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.NONE && (date.isBefore(pickupMoment) || date.isAfter(deliveryMoment))) {
	        window.toastr.error((0, _helpers.translation)(16811), (0, _helpers.translation)('216'));
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'renderPeriods',
	    value: function renderPeriods() {
	      var _this10 = this;
	
	      var CurrentPeriod = this.state.CurrentPeriod;
	      var SelectedPeriods = this.state.SelectedPeriods;
	
	      var usedRentLog = this.props.auth.carRentalSystem === _constants.CarRentalSystemTypes.RENTLOG;
	      var renderPeriod = function renderPeriod(val, key) {
	        var disabled = key !== 'current';
	
	        var renderRentals = function renderRentals() {
	          var rentalList = [];
	          var labelText = '';
	          if (val.RentalOption === 0) {
	            rentalList = _this10.state.AvailableRentalCars;
	            labelText = (0, _helpers.translation)('14790');
	          } else {
	            rentalList = _this10.state.AvailableRentalAlts;
	            labelText = (0, _helpers.translation)('16774');
	          }
	
	          var renderCarOptions = function renderCarOptions(val, carKey) {
	            var style = !val.Available ? 'warning' : '';
	            return _react2.default.createElement(
	              'option',
	              { key: carKey, value: val.CarRentalId, disabled: usedRentLog && !val.Available, className: style },
	              val.CarNumber + ' - ' + val.Identity
	            );
	          };
	
	          var renderAltOptions = function renderAltOptions(val, altKey) {
	            // let style = !val.Available ? 'warning' : ''
	            var style = null;
	            return _react2.default.createElement(
	              'option',
	              { key: altKey, value: val.Id, className: style },
	              val.Name
	            );
	          };
	
	          if (val.RentalOption === 0) {
	            return _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: labelText },
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: [1, 'min-content'] },
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  { name: 'CarRentalId', value: val.CarRentalId, onChange: _this10.onChange, disabled: disabled },
	                  _react2.default.createElement(
	                    'option',
	                    { key: 'default', value: 0 },
	                    labelText
	                  ),
	                  rentalList.map(renderCarOptions)
	                ),
	                val.added ? _react2.default.createElement(_removeButton2.default, { name: 'Remove_' + key, onClick: _this10.removePeriod.bind(_this10, key) }) : _react2.default.createElement(_addButton2.default, { onClick: _this10.addPeriod })
	              )
	            );
	          } else {
	            return _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: labelText },
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: [1, 'min-content'] },
	                _react2.default.createElement(
	                  _dropDown2.default,
	                  { name: 'CarRentalAltId', value: val.CarRentalAltId, onChange: _this10.onChange, disabled: disabled },
	                  _react2.default.createElement(
	                    'option',
	                    { key: 'default', value: 0 },
	                    labelText
	                  ),
	                  rentalList.map(renderAltOptions)
	                ),
	                val.added ? _react2.default.createElement(_removeButton2.default, { name: 'Remove_' + key, onClick: _this10.removePeriod.bind(_this10, key) }) : _react2.default.createElement(_addButton2.default, { onClick: _this10.addPeriod })
	              )
	            );
	          }
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(_DateTimePeriod2.default, {
	            name: 'Period_' + key,
	            dateFrom: val.Start,
	            dateTo: val.End,
	            timesFrom: _this10.state.timesFrom,
	            timesTo: _this10.state.timesTo,
	            disabled: disabled,
	            onlyValidAfterCurrentDate: !usedRentLog,
	            onChangeDate: _this10.onChangeDate,
	            onChangePeriod: _this10.onChangePeriod
	            // onValidation={this.onValidatePeriod}
	          }),
	          !val.added && !usedRentLog && _react2.default.createElement(_radio2.default, { name: 'RentalOption_' + key, value: 0, checked: val.RentalOption === 0, onChange: _this10.onChange, disabled: disabled, labelText: (0, _helpers.translation)('14790') }),
	          !val.added && !usedRentLog && _react2.default.createElement(_radio2.default, { name: 'RentalOption_' + key, value: 1, checked: val.RentalOption === 1, onChange: _this10.onChange, disabled: disabled, labelText: (0, _helpers.translation)('16774') }),
	          renderRentals()
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        SelectedPeriods.map(renderPeriod),
	        CurrentPeriod !== null && renderPeriod(CurrentPeriod, 'current'),
	        CurrentPeriod === null && _react2.default.createElement(_button2.default, { style: 'link', onClick: this.createNewPeriod, labelText: (0, _helpers.translation)('16775') })
	      );
	    }
	  }, {
	    key: 'savePeriods',
	    value: function savePeriods() {
	      var _this11 = this;
	
	      this.updateAssignments(this.state.SelectedPeriods, true).then(function (res) {
	        if (Array.isArray(res.data.Errors) && res.data.Errors.length > 0) {
	          // Error msg.
	        } else {
	          _this11.props.onClose();
	        }
	      });
	    }
	  }, {
	    key: 'savePeriodsCheckCurrent',
	    value: function savePeriodsCheckCurrent() {
	      if (this.state.CurrentPeriod === null) {
	        this.savePeriods();
	      } else {
	        this.setState({
	          confirmDiscardCurrentPeriod: {
	            open: true
	          }
	        });
	      }
	    }
	  }, {
	    key: 'onConfirmClose',
	    value: function onConfirmClose() {
	      this.setState({
	        confirmDiscardCurrentPeriod: {
	          open: false
	        }
	      });
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm() {
	      this.onConfirmClose();
	      this.savePeriods();
	    }
	  }, {
	    key: 'renderConfirm',
	    value: function renderConfirm() {
	      return _react2.default.createElement(
	        _Portal2.default,
	        { className: 'confirm_popup', onPortalClose: this.onConfirmClose },
	        _react2.default.createElement(_Confirm2.default, { renderText: function renderText() {
	            return (0, _helpers.translation)(16838);
	          }, confirm: this.onConfirm, notConfirm: this.onConfirmClose })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pickupDate = (0, _moment2.default)(this.props.pickup).format('DD-MM-YYYY HH:mm');
	      var deliveryDate = (0, _moment2.default)(this.props.delivery).format('DD-MM-YYYY HH:mm');
	      var bottomBarProps = {
	        // disabled: this.state.isLoading,
	        actionLabelText: (0, _helpers.translation)('791'),
	        onActionClick: this.savePeriodsCheckCurrent
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'handlecarrental__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('16770'),
	            icon: _icons.ModalIcons.CarRental,
	            bottomBarProps: bottomBarProps
	          }),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 1] },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('15102')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              this.props.orderId
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 1] },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('14827')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              pickupDate
	            )
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [1, 1], spacing: 2 },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              (0, _helpers.translation)('193')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              deliveryDate
	            )
	          ),
	          this.renderPeriods(),
	          this.state.confirmDiscardCurrentPeriod.open && this.renderConfirm()
	        )
	      );
	    }
	  }]);
	
	  return HandleCarRentalModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetSimpleCarRentals: _shops.GetSimpleCarRentals,
	  GetAvailableCars: _carrental.GetAvailableCars,
	  // ValidateAssignments,
	  getAvailablePickupTimes: _orders.getAvailablePickupTimes,
	  getDeliveryTimes: _orders.getDeliveryTimes,
	  GetAssignments: _carrental.GetAssignments,
	  UpdateAssignments: _carrental.UpdateAssignments,
	  GetCarRentalAlts: _carrentalalternatives.GetCarRentalAlts
	})(HandleCarRentalModal);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _orderfiles = __webpack_require__(409);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _icons = __webpack_require__(6);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1643);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// components
	
	
	// utils
	
	
	// styles
	
	
	var HandleFilesModal = function (_Component) {
	  _inherits(HandleFilesModal, _Component);
	
	  function HandleFilesModal(props) {
	    _classCallCheck(this, HandleFilesModal);
	
	    var _this = _possibleConstructorReturn(this, (HandleFilesModal.__proto__ || Object.getPrototypeOf(HandleFilesModal)).call(this, props));
	
	    _this.state = {
	      files: [],
	      images: []
	    };
	    _this.onCheckImage = _this.onCheckImage.bind(_this);
	    _this.onCheckFile = _this.onCheckFile.bind(_this);
	    _this.saveSharing = _this.saveSharing.bind(_this);
	    return _this;
	  }
	
	  _createClass(HandleFilesModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.getOrderFileSharing(this.props.orderId).then(function (res) {
	        var files = res.data.filter(function (x) {
	          return !x.IsImage;
	        });
	        var images = res.data.filter(function (x) {
	          return x.IsImage;
	        });
	        _this2.setState({
	          files: files,
	          images: images
	        });
	      });
	    }
	  }, {
	    key: 'onCheckImage',
	    value: function onCheckImage(e) {
	      var images = this.state.images;
	
	      var sharing = e.target.checked ? 1 : 0;
	      var updatedImages = images.filter(function (image) {
	        if (image.OrderFileID === parseInt(e.target.id)) {
	          image.SharingType = sharing;
	        }
	        return images;
	      });
	      this.setState({
	        images: updatedImages
	      });
	    }
	  }, {
	    key: 'onCheckFile',
	    value: function onCheckFile(e) {
	      var files = this.state.files;
	
	      var sharing = e.target.checked ? 1 : 0;
	      var updatedFiles = files.filter(function (file) {
	        if (file.OrderFileID === parseInt(e.target.id)) {
	          file.SharingType = sharing;
	        }
	        return file;
	      });
	
	      this.setState({
	        files: updatedFiles
	      });
	    }
	  }, {
	    key: 'saveSharing',
	    value: function saveSharing() {
	      var files = [].concat(_toConsumableArray(this.state.files), _toConsumableArray(this.state.images));
	      var data = {
	        files: files,
	        orderId: this.props.orderId
	      };
	      this.props.saveOrderFileSharing(data);
	      this.props.onClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var renderImage = function renderImage(image, index) {
	        var url = _constants.FILE_STORAGE + image.ThumbURL;
	        var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-image' },
	          _react2.default.createElement(
	            'div',
	            { className: 'divImg' },
	            _react2.default.createElement(
	              'a',
	              { href: fullUrl, 'data-lightbox': 'gallery' },
	              _react2.default.createElement('img', { className: 'img3', id: image.OrderFileID, name: 'oldImages', src: url })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'divCheckbox' },
	            _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)(1218), id: image.OrderFileID, name: 'SharingType', onClick: _this3.onCheckImage, checked: image.SharingType === 1 })
	          )
	        );
	      };
	      var renderFile = function renderFile(file, index) {
	        if (file.ActualFileName === null) return null;
	        var newFileUrl = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(_this3.props.auth.user.Token);
	        var thumbUrl = _constants.API_URL + '/FileService/GetIcon?fileName=' + file.FileName;
	        var fileError = function fileError() {
	          window.toastr.error((0, _helpers.translation)('15191'), (0, _helpers.translation)('216'));
	        };
	        // Return
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: 'file-document clearfix' },
	          _react2.default.createElement(
	            _grid2.default,
	            { spacing: 1, cols: ['min-content', 'min-content', 1] },
	            _react2.default.createElement(_check2.default, { name: 'SharingType', id: file.OrderFileID, onChange: _this3.onCheckFile, checked: file.SharingType === 1, simple: true }),
	            _react2.default.createElement('img', { className: 'file-icon', alt: 'icon', src: thumbUrl }),
	            file.FileExists ? _react2.default.createElement(
	              'a',
	              { target: '_BLANK', href: newFileUrl },
	              file.FileName
	            ) : _react2.default.createElement(
	              'a',
	              { onClick: fileError },
	              file.FileName
	            )
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'handlefiles__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)(16812),
	            icon: _icons.ModalIcons.Note,
	            onClose: this.props.onClose,
	            show: this.props.show,
	            bottomBarProps: {
	              actionLabelText: (0, _helpers.translation)(791),
	              onActionClick: this.saveSharing
	            } }),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)(16813)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.state.files.map(renderFile)
	          ),
	          _react2.default.createElement(_Gallery2.default, { files: this.state.images, renderImage: renderImage })
	        )
	      );
	    }
	  }]);
	
	  return HandleFilesModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getOrderFileSharing: _orderfiles.getOrderFileSharing, saveOrderFileSharing: _orderfiles.saveOrderFileSharing })(HandleFilesModal);

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1644);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Utils
	
	
	var InfoModal = function (_Component) {
	  _inherits(InfoModal, _Component);
	
	  function InfoModal(props) {
	    _classCallCheck(this, InfoModal);
	
	    var _this = _possibleConstructorReturn(this, (InfoModal.__proto__ || Object.getPrototypeOf(InfoModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false
	    };
	    return _this;
	  }
	
	  _createClass(InfoModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'info__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: (0, _helpers.translation)('13420'), overflowHidden: this.state.overflowHidden }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return InfoModal;
	}(_react.Component);
	
	exports.default = InfoModal;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1645);
	
	var _orders = __webpack_require__(21);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// import components
	
	
	// Utils
	
	
	// Elements
	
	// import LabelWrapper from '../../../elements/labelWrapper'
	
	
	var ChooseDatesModal = function (_Component) {
	  _inherits(ChooseDatesModal, _Component);
	
	  function ChooseDatesModal(props) {
	    _classCallCheck(this, ChooseDatesModal);
	
	    var _this = _possibleConstructorReturn(this, (ChooseDatesModal.__proto__ || Object.getPrototypeOf(ChooseDatesModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      mainOrder: null,
	      orders: [],
	      chosenTransport: 0,
	      saving: false
	    };
	
	    _this.changeDates = _this.changeDates.bind(_this);
	    _this.done = _this.done.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChooseDatesModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          getOrderSimple = _props.getOrderSimple,
	          mainOrderId = _props.mainOrderId,
	          orderIds = _props.orderIds;
	
	
	      var promises = [getOrderSimple(mainOrderId)].concat(_toConsumableArray(orderIds.map(function (id) {
	        return getOrderSimple(id);
	      })));
	
	      Promise.all(promises).then(function (res) {
	        var mainOrder = res[0].data;
	        var orders = res.reduce(function (orders, r, i) {
	          return i !== 0 ? [].concat(_toConsumableArray(orders), [r.data]) : orders;
	        }, []);
	
	        _this2.setState({
	          mainOrder: mainOrder,
	          orders: orders
	        });
	      });
	    }
	  }, {
	    key: 'changeDates',
	    value: function changeDates() {
	      var _this3 = this;
	
	      var _state = this.state,
	          orders = _state.orders,
	          mainOrder = _state.mainOrder;
	
	      var isBodyShop = mainOrder.IsBodyShopOrder;
	
	      this.setState({
	        booking: true
	      }, function () {
	        var savings = orders.map(function (o) {
	          return _this3.props.saveOrder(_defineProperty({
	            OrderId: o.Id
	          }, isBodyShop ? 'BodyShopDelivery' : 'Delivery', {
	            IsDirty: true,
	            Delivery: isBodyShop ? mainOrder.BodyShopDeliveryTime : mainOrder.Delivery,
	            IsDeliveryDateChanged: true,
	            DeliveryChangeReason: 4,
	            ProductionDate: isBodyShop ? mainOrder.BodyShopProductionTime : mainOrder.ProductionDate,
	            Pickup: isBodyShop ? mainOrder.BodyShopPickupTime : mainOrder.Pickup
	          }));
	        });
	
	        Promise.all(savings).then(function (res) {
	          _this3.done();
	        }).catch(function () {
	          _this3.setState({
	            booking: false
	          });
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        });
	      });
	    }
	  }, {
	    key: 'done',
	    value: function done() {
	      this.props.complete();
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _state2 = this.state,
	          mainOrder = _state2.mainOrder,
	          orders = _state2.orders;
	
	
	      var loadingSpinner = function loadingSpinner() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'chooseDates-loading' },
	          _react2.default.createElement(
	            'div',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'sr-only' },
	              (0, _helpers.translation)('13382'),
	              '...'
	            )
	          )
	        );
	      };
	      if (!mainOrder || orders.length === 0) return loadingSpinner();
	
	      var renderOrder = function renderOrder(order, key) {
	        var Id = order.Id,
	            Model = order.Model,
	            Pickup = order.Pickup,
	            BodyShopPickupTime = order.BodyShopPickupTime,
	            ProductionDate = order.ProductionDate,
	            BodyShopProductionTime = order.BodyShopProductionTime,
	            Delivery = order.Delivery,
	            BodyShopDeliveryTime = order.BodyShopDeliveryTime;
	
	        var isBodyShop = order.IsBodyShopOrder;
	
	        var notMain = key !== 'main';
	
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          notMain && _react2.default.createElement(
	            _label2.default,
	            null,
	            Model + ' (' + Id + ')',
	            ':'
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(
	              'span',
	              { className: 'chooseDates__title' },
	              (0, _helpers.translation)('14948'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'chooseDates__date' },
	              (0, _time.renderFullDate)(isBodyShop ? BodyShopPickupTime : Pickup, true)
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(
	              'span',
	              { className: 'chooseDates__title' },
	              (0, _helpers.translation)('13394'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'chooseDates__date' },
	              (0, _time.renderFullDate)(isBodyShop ? BodyShopProductionTime : ProductionDate, true)
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0] },
	            _react2.default.createElement(
	              'span',
	              { className: 'chooseDates__title' },
	              (0, _helpers.translation)('14724'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'chooseDates__date' },
	              (0, _time.renderFullDate)(isBodyShop ? BodyShopDeliveryTime : Delivery, true)
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'chooseDates' },
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _helpers.translation)('14728')
	        ),
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('14954') + ':' }),
	        orders.map(renderOrder),
	        _react2.default.createElement(_divider2.default, { size: 1, noLine: true }),
	        _react2.default.createElement(_button2.default, { style: 'link', onClick: this.done, labelText: (0, _helpers.translation)('14956') }),
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)('14955') + ':' }),
	        renderOrder(mainOrder, 'main'),
	        _react2.default.createElement(_divider2.default, { size: 1, noLine: true }),
	        _react2.default.createElement(_button2.default, { style: 'link', onClick: this.changeDates, labelText: (0, _helpers.translation)('14957') }),
	        this.state.booking && loadingSpinner()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            header: (0, _helpers.translation)('1848'),
	            overflowHidden: this.state.overflowHidden,
	            onClose: this.props.onClose,
	            clickOutsideClose: false,
	            icon: _icons.ModalIcons.Link,
	            show: this.props.show },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return ChooseDatesModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  getOrderSimple: _orders.getOrderSimple,
	  saveOrder: _orders.saveOrder
	})(ChooseDatesModal);

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1646);
	
	var _orders = __webpack_require__(21);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _order = __webpack_require__(92);
	
	var _helpers = __webpack_require__(2);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// import components
	
	
	// Utils
	
	
	// Elements
	
	// import Icon from '../../../elements/icon'
	
	
	var LinkDraftsModal = function (_Component) {
	  _inherits(LinkDraftsModal, _Component);
	
	  function LinkDraftsModal(props) {
	    _classCallCheck(this, LinkDraftsModal);
	
	    var _this = _possibleConstructorReturn(this, (LinkDraftsModal.__proto__ || Object.getPrototypeOf(LinkDraftsModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      mainOrder: null,
	      draft: null,
	      hasTransport: false,
	      chosenTransport: 0,
	      booking: false
	    };
	
	    _this.bookDraft = _this.bookDraft.bind(_this);
	    return _this;
	  }
	
	  _createClass(LinkDraftsModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          getOrderSimple = _props.getOrderSimple,
	          mainOrderId = _props.mainOrderId,
	          draftId = _props.draftId;
	
	
	      Promise.all([getOrderSimple(mainOrderId), getOrderSimple(draftId)]).then(function (res) {
	        var orders = res.map(function (r) {
	          return r.data;
	        });
	
	        _this2.setState({
	          mainOrder: orders[0],
	          draft: orders[1],
	          hasTransport: !!orders[1].Transport
	        });
	      });
	    }
	  }, {
	    key: 'bookDraft',
	    value: function bookDraft() {
	      var _this3 = this;
	
	      var _state = this.state,
	          draft = _state.draft,
	          mainOrder = _state.mainOrder,
	          hasTransport = _state.hasTransport;
	
	
	      var book = function book() {
	        _this3.props.bookOrder({
	          OrderId: draft.Id
	        }).then(function (res) {
	          _this3.props.complete();
	        }).catch(function (err) {
	          var errorText = [];
	          if (err.response && err.response.data && err.response.data.Errors) {
	            var Errors = err.response.data.Errors;
	
	            errorText = Errors.map(function (e) {
	              return e.DictionaryKey && '<br />' + (0, _helpers.translation)(e.DictionaryKey) + '<br />';
	            });
	            // Toastr
	            window.toastr.error(errorText.join(), (0, _helpers.translation)('216'));
	          } else {
	            // Toastr
	            window.toastr.error((0, _helpers.translation)('13417'), (0, _helpers.translation)('216'));
	          }
	
	          _this3.setState({
	            booking: false
	          });
	        });
	      };
	
	      this.setState({
	        booking: true
	      }, function () {
	        if (!hasTransport) {
	          var isBodyShop = mainOrder.IsBodyShopOrder;
	
	          var data = _defineProperty({
	            OrderId: draft.Id
	          }, isBodyShop ? 'BodyShopDelivery' : 'Delivery', {
	            IsDirty: true,
	            Delivery: isBodyShop ? mainOrder.BodyShopDeliveryTime : mainOrder.Delivery,
	            ProductionDate: isBodyShop ? mainOrder.BodyShopProductionTime : mainOrder.ProductionDate,
	            Pickup: isBodyShop ? mainOrder.BodyShopPickupTime : mainOrder.Pickup,
	            Transport: _this3.state.chosenTransport
	          });
	
	          if (isBodyShop) {
	            data.Delivery = {
	              IsDirty: true,
	              Delivery: mainOrder.Delivery,
	              ProductionDate: mainOrder.ProductionDate,
	              Pickup: mainOrder.Pickup,
	              Transport: mainOrder.Transport
	            };
	          }
	
	          _this3.props.saveOrder(data).then(book).catch(function () {
	            _this3.setState({
	              booking: false
	            });
	            // Toastr
	            window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	          });
	        } else {
	          book();
	        }
	      });
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          draft = _state2.draft,
	          mainOrder = _state2.mainOrder;
	
	
	      var loadingSpinner = function loadingSpinner() {
	        return _react2.default.createElement(
	          'div',
	          { className: 'linkdraft-loading' },
	          _react2.default.createElement(
	            'div',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'sr-only' },
	              (0, _helpers.translation)('13382'),
	              '...'
	            )
	          )
	        );
	      };
	      if (!draft || !mainOrder) return loadingSpinner();
	
	      var formatDate = function formatDate(dateStr) {
	        return (0, _moment2.default)(dateStr).format('DD-MM-YYYY – hh:mm');
	      };
	
	      var renderDraft = function renderDraft() {
	        var Pickup = draft.Pickup,
	            BodyShopPickupTime = draft.BodyShopPickupTime,
	            ProductionDate = draft.ProductionDate,
	            BodyShopProductionTime = draft.BodyShopProductionTime,
	            Delivery = draft.Delivery,
	            BodyShopDeliveryTime = draft.BodyShopDeliveryTime;
	
	        var isBodyShop = draft.IsBodyShopOrder;
	
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { key: 0, labelText: (0, _helpers.translation)('14722') + ':' },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0], key: 1 },
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__title' },
	              (0, _helpers.translation)('14948'),
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__date' },
	              formatDate(isBodyShop ? BodyShopPickupTime : Pickup)
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0], key: 2 },
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__title' },
	              (0, _helpers.translation)('13394'),
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__date' },
	              formatDate(isBodyShop ? BodyShopProductionTime : ProductionDate)
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0], key: 3 },
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__title' },
	              (0, _helpers.translation)('14724'),
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__date' },
	              formatDate(isBodyShop ? BodyShopDeliveryTime : Delivery)
	            )
	          )
	        );
	      };
	
	      var renderMain = function renderMain() {
	        var StepId = mainOrder.StepId,
	            Pickup = mainOrder.Pickup,
	            BodyShopPickupTime = mainOrder.BodyShopPickupTime,
	            ProductionDate = mainOrder.ProductionDate,
	            BodyShopProductionTime = mainOrder.BodyShopProductionTime,
	            Delivery = mainOrder.Delivery,
	            BodyShopDeliveryTime = mainOrder.BodyShopDeliveryTime;
	
	        var isBodyShop = mainOrder.IsBodyShopOrder;
	
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { key: 0, labelText: (0, _helpers.translation)('14725') + ':' },
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0], key: 1 },
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__title' },
	              (0, _helpers.translation)('946'),
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__date' },
	              (0, _helpers.translation)((0, _order.getStepName)(StepId))
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0], key: 2 },
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__title' },
	              (0, _helpers.translation)('14948'),
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__date' },
	              formatDate(isBodyShop ? BodyShopPickupTime : Pickup)
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0], key: 3 },
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__title' },
	              (0, _helpers.translation)('13394'),
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__date' },
	              formatDate(isBodyShop ? BodyShopProductionTime : ProductionDate)
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { block: true, fillChildNum: [0], key: 4 },
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__title' },
	              (0, _helpers.translation)('14724'),
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'linkdraft__date' },
	              formatDate(isBodyShop ? BodyShopDeliveryTime : Delivery)
	            )
	          )
	        );
	      };
	
	      var renderRadioList = function renderRadioList() {
	        var name = 'Transport';
	        var transportId = _this4.state.chosenTransport;
	        var listItems = _this4.props.transport;
	
	        // Transport formatter to add icons?
	        // const formatter = ({ Id, Name }) => {
	        //   let transportImage = 'can_drive16'
	        //   if (Id === 3) { transportImage = 'transport16' }
	        //   if (Id === 2) { transportImage = 'loose_part16' }
	
	        //   return (
	        //     <span className='linkdraft__img'>
	        //       <span>{translation(Name)}</span>
	        //       <img src={'/images/icons/' + transportImage + '.png'} />
	        //     </span>
	        //   )
	        // }
	
	        var onInputChange = function onInputChange(_ref) {
	          var value = _ref.target.value;
	
	          _this4.setState({
	            chosenTransport: value
	          });
	        };
	
	        return listItems.map(function (transportType, index) {
	          var id = name + '_' + transportType.Id + '_input';
	          // let label = (
	          //   <Inline>
	          //     {translation(transportType.Name)}
	          //     <Icon icon={makeTransportIcon(transportType.Id)} />
	          //   </Inline>
	          // )
	          return _react2.default.createElement(_radio2.default, { key: index,
	            labelText: (0, _helpers.translation)(transportType.Name),
	            id: id,
	            name: name,
	            value: transportType.Id,
	            onChange: onInputChange,
	            checked: transportId.toString() === transportType.Id.toString() ? 'checked' : false });
	        });
	      };
	      // console.log('draft', this.state.draft, 'main', this.state.mainOrder, this.state.hasTransport)
	      // 'Transport', 6, 6, 1, 6, transportFormatter, 'list', this.props.transport, ['Id', 'Name'])
	      // value, draftCustomer, draftShop, bookedCustomer, bookedShop, formatter, type, listItems, listItemValName, translate
	      console.log('this.state.hasTransport ', this.state.hasTransport);
	      return _react2.default.createElement(
	        'div',
	        { className: 'linkdraft' },
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)('14952')
	        ),
	        _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(13373) }),
	        renderDraft(),
	        renderMain(),
	        !this.state.hasTransport && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)(13371) },
	          renderRadioList()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pg-mb-2' },
	          (0, _helpers.translation)('14953')
	        ),
	        this.state.booking && loadingSpinner()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            header: (0, _helpers.translation)('1848'),
	            overflowHidden: this.state.overflowHidden,
	            onClose: this.props.onClose,
	            clickOutsideClose: false,
	            icon: _icons.ModalIcons.Link,
	            show: this.props.show,
	            bottomBarProps: {
	              actionLabelText: (0, _helpers.translation)(47),
	              onActionClick: this.bookDraft,
	              cancelLabelText: (0, _helpers.translation)(48),
	              onCancelClick: this.props.onClose
	            }
	          },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return LinkDraftsModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    transport: state.common.transport
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrderSimple: _orders.getOrderSimple,
	  bookOrder: _orders.bookOrder,
	  saveOrder: _orders.saveOrder
	})(LinkDraftsModal);

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	__webpack_require__(1647);
	
	var _orders = __webpack_require__(21);
	
	var _order = __webpack_require__(92);
	
	var _helpers = __webpack_require__(2);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _LinkDraftsModal = __webpack_require__(1092);
	
	var _LinkDraftsModal2 = _interopRequireDefault(_LinkDraftsModal);
	
	var _ChooseDatesModal = __webpack_require__(1091);
	
	var _ChooseDatesModal2 = _interopRequireDefault(_ChooseDatesModal);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Utils
	
	
	// import components
	
	
	// Elements
	
	
	var LinkOrdersModal = function (_Component) {
	  _inherits(LinkOrdersModal, _Component);
	
	  function LinkOrdersModal(props) {
	    _classCallCheck(this, LinkOrdersModal);
	
	    var _this = _possibleConstructorReturn(this, (LinkOrdersModal.__proto__ || Object.getPrototypeOf(LinkOrdersModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      lists: {
	        AlreadyLinked: [],
	        MatchingDrafts: [],
	        MatchingRegNrs: [],
	        MatchingProcessStep: [],
	        MatchingOthers: []
	      },
	      selectedOrderIds: [],
	      selectedDraft: 0,
	      linkDraft: {
	        open: false,
	        matchingDraft: null,
	        complete: false
	      },
	      chooseDates: {
	        open: false,
	        complete: false
	      }
	    };
	    _this.renderItem = _this.renderItem.bind(_this);
	    _this.renderRadioItem = _this.renderRadioItem.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.deselect = _this.deselect.bind(_this);
	    _this.linkOrders = _this.linkOrders.bind(_this);
	    _this.completeLinkDraft = _this.completeLinkDraft.bind(_this);
	    _this.completeChooseDates = _this.completeChooseDates.bind(_this);
	    return _this;
	  }
	
	  _createClass(LinkOrdersModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getLinkOrderData();
	    }
	  }, {
	    key: 'getLinkOrderData',
	    value: function getLinkOrderData() {
	      var _this2 = this;
	
	      this.props.getLinkOrderData(this.props.id).then(function (res) {
	        var selectedOrderIds = [];
	        res.data.AlreadyLinked.map(function (val) {
	          selectedOrderIds.push(val.OrderId);
	        });
	        _this2.setState({
	          lists: res.data,
	          selectedOrderIds: selectedOrderIds
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1932'), (0, _helpers.translation)('216'));
	        _this2.props.onClose();
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var id = parseInt(e.target.value);
	      var selectedOrderIds = [].concat(_toConsumableArray(this.state.selectedOrderIds));
	      var isSelected = this.isSelected(id);
	      if (isSelected !== false) {
	        selectedOrderIds.splice(isSelected, 1);
	      } else {
	        selectedOrderIds.push(id);
	      }
	      this.setState({
	        selectedOrderIds: selectedOrderIds
	      });
	    }
	  }, {
	    key: 'isSelected',
	    value: function isSelected(id) {
	      var found = false;
	      this.state.selectedOrderIds.map(function (val, key) {
	        if (val === id && found === false) {
	          found = key;
	        }
	      });
	      return found;
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      var _this3 = this;
	
	      var id = parseInt(e.target.value);
	      var hasBeenCompleted = this.state.linkDraft.complete;
	
	      var selectedOrderIds = [].concat(_toConsumableArray(this.state.selectedOrderIds));
	      var newSelected = selectedOrderIds.filter(function (s) {
	        return s !== _this3.state.selectedDraft;
	      });
	
	      if (id !== this.state.selectedDraft) {
	        newSelected.push(id);
	
	        if (hasBeenCompleted) {
	          hasBeenCompleted = false;
	        }
	      } else {
	        id = 0;
	      }
	
	      this.setState({
	        selectedOrderIds: newSelected,
	        selectedDraft: id,
	        linkDraft: _extends({}, this.state.linkDraft, {
	          complete: hasBeenCompleted
	        })
	      });
	    }
	  }, {
	    key: 'completeLinkDraft',
	    value: function completeLinkDraft() {
	      var _this4 = this;
	
	      return this.setState({
	        linkDraft: _extends({}, this.state.linkDraft, {
	          complete: true,
	          open: false
	        })
	      }, function () {
	        return _this4.linkOrders();
	      });
	    }
	  }, {
	    key: 'completeChooseDates',
	    value: function completeChooseDates() {
	      var _this5 = this;
	
	      return this.setState({
	        chooseDates: _extends({}, this.state.chooseDates, {
	          complete: true,
	          open: false
	        })
	      }, function () {
	        _this5.linkOrders();
	      });
	    }
	  }, {
	    key: 'linkOrders',
	    value: function linkOrders(e) {
	      var _this6 = this;
	
	      if (e) e.preventDefault();
	
	      var _state = this.state,
	          linkDraft = _state.linkDraft,
	          chooseDates = _state.chooseDates;
	
	      var data = {
	        MainOrderId: this.props.id,
	        LinkOrderIds: this.state.selectedOrderIds
	      };
	
	      var AlreadyLinked = this.state.lists.AlreadyLinked;
	
	      var shouldUnlink = false;
	
	      if (AlreadyLinked.length >= data.LinkOrderIds.length || data.LinkOrderIds.length === 0) {
	        var allAlrLinked = AlreadyLinked.every(function (al) {
	          return data.LinkOrderIds.includes(al.OrderId);
	        });
	        var sameLength = data.LinkOrderIds.length === AlreadyLinked.length;
	        var isBigger = data.LinkOrderIds.length > AlreadyLinked.length;
	
	        if (AlreadyLinked.length === 0 || allAlrLinked && (!isBigger || sameLength)) {
	          return window.toastr.error((0, _helpers.translation)('14985'), (0, _helpers.translation)('216'));
	        } else if (AlreadyLinked.length > 0 && data.LinkOrderIds.length < AlreadyLinked.length) {
	          // Should unlink orders
	          shouldUnlink = true;
	        }
	      }
	
	      var draft = null;
	      if (!linkDraft.complete) {
	        draft = this.state.lists.MatchingDrafts.find(function (mrn) {
	          return data.LinkOrderIds.includes(mrn.OrderId);
	        });
	        if (draft) {
	          this.setState({
	            linkDraft: _extends({}, linkDraft, {
	              open: true,
	              matchingDraft: draft.OrderId
	            })
	          });
	        } else {
	          return this.setState({
	            linkDraft: _extends({}, linkDraft, {
	              complete: true
	            })
	          }, function () {
	            return _this6.linkOrders();
	          });
	        }
	      }
	
	      if (!chooseDates.complete && linkDraft.complete) {
	        this.setState({
	          chooseDates: _extends({}, chooseDates, {
	            open: true
	          })
	        });
	      }
	
	      if (shouldUnlink || linkDraft.complete && chooseDates.complete) {
	        this.props.LinkOrders(data).then(function (res) {
	          _this6.props.onClose();
	          _events2.default.emit('updateorderlist', true);
	          // window.toastr.success(translation('2341'), translation('13424'))
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('2342'), (0, _helpers.translation)('216'));
	        });
	      }
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(item, key) {
	      var id = item.OrderId;
	      var name = !item.RegNr ? id : item.RegNr;
	      name += ',';
	      var label = _react2.default.createElement(
	        _inline2.default,
	        { spacing: 0 },
	        _react2.default.createElement(_icon2.default, { icon: (0, _order.makeOrderTypeIcon)(item.OrderType) }),
	        name,
	        ' ',
	        (0, _helpers.translation)((0, _order.getStepName)(item.StepId))
	      );
	      return _react2.default.createElement(_check2.default, { key: key, id: 'LinkOrder-' + id, name: 'LinkOrder', value: id, onChange: this.onInputChange, checked: this.isSelected(id) !== false, labelText: label });
	    }
	  }, {
	    key: 'deselect',
	    value: function deselect(e) {
	      if (parseInt(e.target.value) === this.state.selectedDraft) {
	        this.onRadioChange(e);
	      }
	    }
	  }, {
	    key: 'renderRadioItem',
	    value: function renderRadioItem(item, key) {
	      var id = item.OrderId;
	      var name = item.RegNr === '' ? id : item.RegNr;
	      name += ',';
	      var label = _react2.default.createElement(
	        _inline2.default,
	        { spacing: 0 },
	        _react2.default.createElement(_icon2.default, { icon: (0, _order.makeOrderTypeIcon)(item.OrderType) }),
	        name,
	        ' ',
	        (0, _helpers.translation)('14722')
	      );
	
	      return _react2.default.createElement(_radio2.default, { key: key,
	        labelText: label,
	        id: 'LinkOrder-' + id,
	        name: 'LinkOrder',
	        value: id,
	        onChange: this.onRadioChange,
	        onClick: this.deselect,
	        checked: this.state.selectedDraft === id })
	      // <div className='checkbox__custom clearfix' key={key}>
	      //   <input
	      //     type='radio'
	      //     id={'LinkOrder-' + id}
	      //     name='LinkOrder'
	      //     value={id}
	      //     onChange={this.onRadioChange}
	      //     onClick={this.deselect}
	      //     checked={this.state.selectedDraft === id} />
	      //   <label htmlFor={'LinkOrder-' + id}>
	      //     <img src={makeOrderTypeImage(item.OrderType)} />
	      //     {name}, {translation('14722')}
	      //   </label>
	      // </div>
	      ;
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var lists = this.state.lists;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1849') },
	          lists.AlreadyLinked.length === 0 ? _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('1850')
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'linkItems' },
	            lists.AlreadyLinked.map(this.renderItem)
	          )
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('14951') },
	          lists.MatchingDrafts.length === 0 ? _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('1855')
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'linkItems' },
	            lists.MatchingDrafts.map(this.renderRadioItem)
	          )
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1851') },
	          lists.MatchingRegNrs.length === 0 ? _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('1855')
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'linkItems' },
	            lists.MatchingRegNrs.map(this.renderItem)
	          )
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('1852') },
	          lists.MatchingProcessStep.length === 0 ? _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('1855')
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'linkItems' },
	            lists.MatchingProcessStep.map(this.renderItem)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var chooseDatesClose = function chooseDatesClose() {
	        _this7.setState({
	          chooseDates: _extends({}, _this7.state.chooseDates, {
	            open: false
	          })
	        });
	      };
	      var linkDraftClose = function linkDraftClose() {
	        _this7.setState({
	          linkDraft: _extends({}, _this7.state.linkDraft, {
	            open: false
	          })
	        });
	      };
	
	      var showBackdrop = this.state.chooseDates.open || this.state.linkDraft.open ? ' linkorders__hide-backdrop' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'linkorders__modal' + showBackdrop },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('1848'),
	            overflowHidden: this.state.overflowHidden,
	            onClose: this.props.onClose,
	            icon: _icons.ModalIcons.Link,
	            bottomBarProps: {
	              actionLabelText: (0, _helpers.translation)('1854'),
	              onActionClick: this.linkOrders
	            }
	          }),
	          this.renderView()
	        ),
	        this.state.chooseDates.open && _react2.default.createElement(_ChooseDatesModal2.default, {
	          onClose: chooseDatesClose,
	          show: this.state.chooseDates.open,
	          complete: this.completeChooseDates,
	          mainOrderId: this.props.id,
	          orderIds: this.state.selectedOrderIds }),
	        this.state.linkDraft.open && _react2.default.createElement(_LinkDraftsModal2.default, {
	          onClose: linkDraftClose,
	          draftId: this.state.linkDraft.matchingDraft,
	          mainOrderId: this.props.id,
	          complete: this.completeLinkDraft,
	          show: this.state.linkDraft.open })
	      );
	    }
	  }]);
	
	  return LinkOrdersModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  LinkOrders: _orders.LinkOrders,
	  getLinkOrderData: _orders.getLinkOrderData
	})(LinkOrdersModal);

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1649);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _orders = __webpack_require__(21);
	
	var _notes = __webpack_require__(114);
	
	var _invoicing = __webpack_require__(150);
	
	var _helpers = __webpack_require__(2);
	
	var _order = __webpack_require__(92);
	
	var _time = __webpack_require__(17);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var MarkAsWreckedModal = function (_Component) {
	  _inherits(MarkAsWreckedModal, _Component);
	
	  function MarkAsWreckedModal(props) {
	    _classCallCheck(this, MarkAsWreckedModal);
	
	    var _this = _possibleConstructorReturn(this, (MarkAsWreckedModal.__proto__ || Object.getPrototypeOf(MarkAsWreckedModal)).call(this, props));
	
	    _this.state = {
	      view: null,
	      isLoadingLastHistory: false,
	      lastHistory: {},
	      comment: ''
	    };
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.wreckOrder = _this.wreckOrder.bind(_this);
	    _this.onConfirmInvoicedMarkAsWrecked = _this.onConfirmInvoicedMarkAsWrecked.bind(_this);
	    _this.renderConfirmInvoicedMarkAsWrecked = _this.renderConfirmInvoicedMarkAsWrecked.bind(_this);
	    return _this;
	  }
	
	  _createClass(MarkAsWreckedModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.order.IsInvoiced) {
	        this.setState({
	          view: 'invoicedConfirm',
	          isLoadingLastHistory: true
	        }, function () {
	          _this2.props.invoiceHistory(_this2.props.order.Id).then(function (res) {
	            _this2.setState({
	              lastHistory: res.data,
	              isLoadingLastHistory: false
	              // }, { () => console.log('[OrderActions][loadinglasthistory]', this.state)
	            });
	          });
	        });
	      } else {
	        this.setState({
	          view: 'wreck'
	        });
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.setState({
	        comment: e.target.value
	      });
	    }
	  }, {
	    key: 'wreckOrder',
	    value: function wreckOrder() {
	      var _this3 = this;
	
	      var wreckIt = function wreckIt() {
	        // Mark as wrecked
	        _this3.props.markAsWrecked(_this3.props.order.Id).then(function (res) {
	          // window.toastr.success(translation('15241'), translation('13424'))
	          if (_this3.props.onMoveSuccess) {
	            _this3.props.onMoveSuccess(res.data, res.data.Orders);
	          }
	          _this3.props.onClose();
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        });
	      };
	
	      if (this.state.comment) {
	        var newNote = {
	          Note: this.state.comment,
	          OrderID: this.props.order.Id,
	          SourceID: 20
	
	          // Save comment
	        };this.props.createNote(newNote).then(function () {
	          wreckIt();
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        });
	      } else {
	        wreckIt();
	      }
	    }
	  }, {
	    key: 'renderConfirmInvoicedMarkAsWrecked',
	    value: function renderConfirmInvoicedMarkAsWrecked() {
	      var resendText = (0, _helpers.translation)('14950') + '.';
	      if (this.state.isLoadingLastHistory) {
	        resendText = '';
	      }
	      var name = this.state.lastHistory.UserName;
	      var date = (0, _time.renderFullDate)(this.state.lastHistory.Date);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'pg-mb-1' },
	          resendText
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0] },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('14937')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            name
	          )
	        ),
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true, fillChildNum: [0] },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _helpers.translation)('14938')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            date
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pg-mb-1' },
	          (0, _helpers.translation)('14927'),
	          ' ',
	          (0, _helpers.translation)('15238')
	        )
	      );
	    }
	  }, {
	    key: 'onConfirmInvoicedMarkAsWrecked',
	    value: function onConfirmInvoicedMarkAsWrecked() {
	      this.setState({
	        view: 'wreck'
	      });
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)('15240')
	        ),
	        _react2.default.createElement(_textarea2.default, { name: 'comment', value: this.state.comment, onChange: this.onInputChange, labelText: (0, _helpers.translation)('15197') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var orderTitle = (0, _order.makeOrderTitle)(this.props.order, null, null, true);
	      var header = (0, _helpers.translation)('15239') + ' - ' + orderTitle;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'totalwreck' },
	        this.state.view === 'wreck' && _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: header,
	            overflowHidden: false,
	            onClose: this.props.onClose,
	            icon: _icons.ModalIcons.Total_Wreck,
	            bottomBarProps: {
	              actionLabelText: (0, _helpers.translation)('752'),
	              onActionClick: this.wreckOrder,
	              cancelLabelText: (0, _helpers.translation)('1155'),
	              onCancelClick: this.props.onClose
	            }
	          }),
	          this.renderView()
	        ),
	        this.state.view === 'invoicedConfirm' && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'resendModal', onPortalClose: function onPortalClose() {} },
	          _react2.default.createElement(_Confirm2.default, {
	            renderText: this.renderConfirmInvoicedMarkAsWrecked,
	            confirm: this.onConfirmInvoicedMarkAsWrecked,
	            notConfirm: this.props.onClose,
	            disabled: this.state.isLoadingLastHistory })
	        )
	      );
	    }
	  }]);
	
	  return MarkAsWreckedModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  markAsWrecked: _orders.markAsWrecked,
	  createNote: _notes.createNote,
	  invoiceHistory: _invoicing.invoiceHistory
	})(MarkAsWreckedModal);

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1650);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _invoicing = __webpack_require__(150);
	
	var _priceModel = __webpack_require__(75);
	
	var _order = __webpack_require__(92);
	
	var _auth = __webpack_require__(8);
	
	var _currency = __webpack_require__(41);
	
	var _helpers = __webpack_require__(2);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Utils
	
	// import { isTouchDevice } from '../../../utils/detect'
	
	
	// Elements
	
	
	var MassInvoice = function (_Component) {
	  _inherits(MassInvoice, _Component);
	
	  function MassInvoice(props) {
	    _classCallCheck(this, MassInvoice);
	
	    var _this = _possibleConstructorReturn(this, (MassInvoice.__proto__ || Object.getPrototypeOf(MassInvoice)).call(this, props));
	
	    _this.state = {
	      orders: [],
	      invoicedOrders: [],
	      selectedOrders: [],
	      // allSelected: false,
	      selectedAction: 0,
	      addon: false,
	      limit: 20
	    };
	
	    _this.isWP = _this.isWP.bind(_this);
	    _this.getActionName = _this.getActionName.bind(_this);
	    _this.onActionChange = _this.onActionChange.bind(_this);
	    _this.onOrderChange = _this.onOrderChange.bind(_this);
	    _this.isSelected = _this.isSelected.bind(_this);
	    _this.renderActions = _this.renderActions.bind(_this);
	    _this.renderCheckbox = _this.renderCheckbox.bind(_this);
	    _this.renderOrders = _this.renderOrders.bind(_this);
	    _this.executeAction = _this.executeAction.bind(_this);
	    _this.renderView = _this.renderView.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    _this.fixSuccessfulOrders = _this.fixSuccessfulOrders.bind(_this);
	    _this.filterSuccessfulSelectedOrders = _this.filterSuccessfulSelectedOrders.bind(_this);
	    return _this;
	  }
	
	  _createClass(MassInvoice, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var notInvoicingOrders = this.props.orders.reduce(function (filtered, orderGroup, groupKey) {
	        var readyForInvoice = orderGroup.orders.filter(function (o, orderKey) {
	          return !_this2.props.itemsIsInvoicing.includes(o.Id);
	        });
	
	        if (readyForInvoice.length !== 0) {
	          filtered.push({
	            StepId: orderGroup.StepId,
	            DictionaryKey: orderGroup.DictionaryKey,
	            orders: readyForInvoice
	          });
	        }
	
	        return filtered;
	      }, []);
	
	      var notInvoicingInvoicedOrders = this.props.invoicedOrders.reduce(function (filtered, orderGroup, groupKey) {
	        var notInvoicing = orderGroup.orders.filter(function (o, orderKey) {
	          return !_this2.props.itemsIsInvoicing.includes(o.Id);
	        });
	
	        if (notInvoicing.length !== 0) {
	          filtered.push({
	            StepId: orderGroup.StepId,
	            DictionaryKey: orderGroup.DictionaryKey,
	            orders: notInvoicing
	          });
	        }
	
	        return filtered;
	      }, []);
	
	      this.setState({
	        orders: notInvoicingOrders,
	        invoicedOrders: notInvoicingInvoicedOrders
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.orders !== this.state.orders || nextProps.invoicedOrders !== this.state.invoicedOrders) {
	        var orders = nextProps.orders,
	            invoicedOrders = nextProps.invoicedOrders,
	            response = nextProps.response;
	        var selectedOrders = this.state.selectedOrders;
	
	        var invOrders = this.fixSuccessfulOrders(response, invoicedOrders);
	        var newOrders = this.fixSuccessfulOrders(response, orders);
	        var selOrders = this.filterSuccessfulSelectedOrders(response, selectedOrders);
	        this.setState({
	          orders: newOrders,
	          invoicedOrders: invOrders,
	          selectedOrders: selOrders
	        });
	      }
	    }
	  }, {
	    key: 'fixSuccessfulOrders',
	    value: function fixSuccessfulOrders(response, orders) {
	      if (response) {
	        var success = response.success;
	
	        if (success !== undefined && success !== true && success.length !== 0) {
	          // Remove the successful orders
	          orders = orders.reduce(function (newOrders, group) {
	            var filtered = group.orders.filter(function (o) {
	              return !success.find(function (s) {
	                return s.Id === o.Id;
	              });
	            });
	
	            if (filtered.length !== 0) {
	              var newGroup = _extends({}, group);
	              newGroup.orders = filtered;
	
	              return [].concat(_toConsumableArray(newOrders), [newGroup]);
	            }
	            return newOrders;
	          }, []);
	        }
	      }
	      return orders;
	    }
	  }, {
	    key: 'filterSuccessfulSelectedOrders',
	    value: function filterSuccessfulSelectedOrders(response, orders) {
	      if (response) {
	        var success = response.success;
	
	        if (success !== undefined && success !== true && success.length !== 0) {
	          // Remove the successful orders
	          orders = orders.filter(function (o) {
	            return !success.find(function (s) {
	              return s.Id === o;
	            });
	          });
	        }
	      }
	      return orders;
	    }
	  }, {
	    key: 'isWP',
	    value: function isWP() {
	      return (0, _auth.hasAccess)([6], this.props.auth.user.UserType);
	    }
	  }, {
	    key: 'getActionName',
	    value: function getActionName(id) {
	      var dictionaryKey = '13503';
	      if (id === 1) {
	        dictionaryKey = '13504';
	      } else if (id === 2) {
	        dictionaryKey = '13505';
	      }
	
	      return (0, _helpers.translation)(dictionaryKey);
	    }
	  }, {
	    key: 'onActionChange',
	    value: function onActionChange(_ref) {
	      var _ref$target = _ref.target,
	          value = _ref$target.value,
	          name = _ref$target.name;
	
	      if (name === 'Addon') {
	        return this.setState({
	          addon: !this.state.addon
	        });
	      }
	
	      this.setState({
	        selectedAction: parseInt(value, 10),
	        selectedOrders: []
	        // allSelected: false
	      });
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      var _this3 = this;
	
	      var selectedAction = this.state.selectedAction;
	
	
	      var renderAddon = function renderAddon() {
	        var addonInputValue = true;
	        return _react2.default.createElement(_check2.default, {
	          spacing: 0,
	          id: 'Addon',
	          name: 'Addon',
	          value: addonInputValue,
	          onChange: _this3.onActionChange,
	          checked: _this3.state.addon,
	          labelText: (0, _helpers.translation)('2092') });
	      };
	
	      var renderAction = function renderAction(id, value) {
	        // let img = '/images/svgs/invoice/posted-not-billed.svg'
	        var dictionaryKey = 13503;
	        if (value === 1) {
	          // img = '/images/svgs/invoice/billed-not-posted.svg'
	          dictionaryKey = 13504;
	        } else if (value === 2) {
	          // img = '/images/svgs/invoice/Payment-ok-VS.svg'
	          dictionaryKey = 13505;
	        }
	
	        var label = _react2.default.createElement(
	          _inline2.default,
	          { spacing: 0 },
	          _react2.default.createElement(_icon2.default, { injectSvg: false, icon: (0, _order.makeOrderInvoiceIcon)(value), 'aria-label': (0, _helpers.translation)(dictionaryKey) }),
	          _this3.getActionName(value)
	        );
	
	        return _react2.default.createElement(_radio2.default, {
	          spacing: 1,
	          key: value,
	          id: id,
	          name: id,
	          value: value,
	          onChange: _this3.onActionChange,
	          checked: selectedAction === value,
	          labelText: label });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'massinvoice__actions' },
	        renderAction('OnlySend', 0),
	        !this.isWP() && selectedAction === 0 && renderAddon(),
	        renderAction('Mark', 1),
	        renderAction('SendAndMark', 2),
	        !this.isWP() && selectedAction === 2 && renderAddon(),
	        _react2.default.createElement(_divider2.default, null)
	      );
	    }
	  }, {
	    key: 'onOrderChange',
	    value: function onOrderChange(_ref2) {
	      var _ref2$target = _ref2.target,
	          value = _ref2$target.value,
	          name = _ref2$target.name;
	
	      // const { selectedAction, orders, invoicedOrders } = this.state
	      // const ordersList = selectedAction === 1 ? invoicedOrders : orders
	
	      // if (name === 'All') {
	      //   if (this.state.allSelected) {
	      //     return this.setState({
	      //       selectedOrders: [],
	      //       allSelected: false
	      //     })
	      //   } else {
	      //     const ids = ordersList.reduce((ids, group) => [...ids, ...group.orders.map(o => o.Id)], [])
	
	      //     return this.setState({
	      //       selectedOrders: ids,
	      //       allSelected: true
	      //     })
	      //   }
	      // }
	
	      var selected = [].concat(_toConsumableArray(this.state.selectedOrders));
	      value = parseInt(value, 10);
	      // let allSelected = this.state.allSelected
	
	      if (this.isSelected(value)) {
	        selected = selected.filter(function (s) {
	          return s !== value;
	        });
	
	        // if (this.state.allSelected) {
	        //   allSelected = false
	        // }
	      } else {
	        // If selected limit has been reached, return error msg
	        if (selected.length === this.state.limit) {
	          window.toastr.error((0, _helpers.translation)('15176'), (0, _helpers.translation)('216'));
	          return;
	        }
	
	        selected.push(value);
	
	        // const ordersLength = ordersList.reduce((count, group) => count + group.orders.length, 0)
	        // if (selected.length === ordersLength) {
	        //   allSelected = true
	        // }
	      }
	
	      this.setState({
	        // allSelected,
	        selectedOrders: selected
	      });
	    }
	  }, {
	    key: 'isSelected',
	    value: function isSelected(id) {
	      return this.state.selectedOrders.includes(id);
	    }
	  }, {
	    key: 'renderCheckbox',
	    value: function renderCheckbox(label, id, key) {
	      return _react2.default.createElement(_check2.default, {
	        key: key,
	        spacing: 0,
	        labelText: label(),
	        id: 'MassInvoice_' + id,
	        name: 'MassInvoice',
	        value: id,
	        onChange: this.onOrderChange,
	        checked: this.isSelected(id) });
	    }
	  }, {
	    key: 'renderOrders',
	    value: function renderOrders(orders) {
	      var _this4 = this;
	
	      if (!orders || orders.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'massinvoice__orders massinvoice__noorders' },
	          (0, _helpers.translation)('14988')
	        );
	      }
	
	      var renderGroup = function renderGroup(group, key) {
	        if (group.DictionaryKey === 395) return null;
	        var orders = group.orders;
	        var result = [];
	        if (group.DictionaryKey === 2703) {
	          var archivedOrders = [];
	          var date = new Date();
	          date.setDate(date.getDate() - (date.getDay() || 7) + 1);
	          date.setHours(0);
	          date.setMinutes(0);
	          date.setMilliseconds(0);
	          orders.map(function (order) {
	            if (archivedOrders.filter(function (archiveOrder) {
	              return archiveOrder.Id === order.Id;
	            }).length === 0) {
	              archivedOrders.push(order);
	            }
	          });
	          var ordersThisWeek = archivedOrders.filter(function (order) {
	            return new Date(order.ArchiveDate) > date;
	          });
	          orders = archivedOrders.filter(function (order) {
	            return new Date(order.ArchiveDate) <= date;
	          });
	          if (ordersThisWeek.length > 0) {
	            result.push(_react2.default.createElement(
	              'div',
	              { key: key },
	              _react2.default.createElement(
	                _tableRow2.default,
	                { header: true },
	                _react2.default.createElement(
	                  _inline2.default,
	                  { alignChildren: 'center', spacing: 0 },
	                  _this4.props.getHeaderIcon(group),
	                  (0, _helpers.translation)(2702)
	                )
	              ),
	              ordersThisWeek.map(renderOrder)
	            ));
	            key = key + '_1';
	          }
	        }
	        result.push(_react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true },
	            _react2.default.createElement(
	              _inline2.default,
	              { alignChildren: 'center', spacing: 0 },
	              _this4.props.getHeaderIcon(group),
	              (0, _helpers.translation)(group.DictionaryKey)
	            )
	          ),
	          orders.map(renderOrder)
	        ));
	        return result;
	      };
	
	      var renderOrder = function renderOrder(o, key) {
	        var label = function label() {
	          var key = 0;
	          var brand = o.BrandName && o.BrandName.Name !== '2000' ? o.BrandName.Name : '';
	          var typeHover = (0, _helpers.translation)((0, _helpers.enumtranslate)('OrderTypes', o.OrderType));
	          if (o.HasInvoiceError) {
	            var dictionaryKey = _this4.props.getErrDictionaryKey(o.InvoiceError);
	            typeHover += ' - ' + (0, _helpers.translation)(dictionaryKey);
	          }
	
	          return _react2.default.createElement(
	            _grid2.default,
	            { cols: ['min-content', 1, 2.25, 2.75, 1, 1], align: 'center' },
	            _react2.default.createElement(
	              'span',
	              { className: 'hint--right', 'aria-label': typeHover, key: key++ },
	              _react2.default.createElement('img', { style: { width: 25, height: 25 }, src: !o.HasInvoiceError ? (0, _order.makeOrderTypeImage)(o.OrderType) : 'images/svgs/invoice/warning-sign.svg' })
	            ),
	            _react2.default.createElement(
	              'span',
	              { key: key++ },
	              o.RegNumber
	            ),
	            _react2.default.createElement(
	              'span',
	              { key: key++ },
	              brand,
	              ' ',
	              o.Model
	            ),
	            _react2.default.createElement(
	              'span',
	              { key: key++ },
	              o.CustomerName
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'centered', key: key++ },
	              (0, _moment2.default)(o.Delivery).format('DD-MM-YYYY')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'price', key: key++ },
	              (0, _currency.formatCurrency)(o.TotalPrice)
	            )
	          );
	        };
	
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { key: key },
	          _this4.renderCheckbox(label, o.Id, key)
	        );
	      };
	
	      // Not sure if this is supposed to be used at some point
	      /* <input
	        type='checkbox'
	        id={`MassInvoice_All`}
	        name='All'
	        value={this.state.allSelected}
	        onChange={this.onOrderChange}
	        checked={this.state.allSelected} />
	        <label htmlFor='MassInvoice_All'>{translation('531')}</label> */
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'category-icons' },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: ['67px', 1, 2.25, 2.75, 1, 1], spacing: 1, align: 'center', justify: 'center' },
	            _react2.default.createElement('span', null),
	            _react2.default.createElement(
	              'span',
	              { 'aria-label': (0, _helpers.translation)('78'), className: 'hint--top' },
	              _react2.default.createElement(_icon2.default, { injectSvg: false, icon: _icons.MassInvoiceIcons.Reg_No })
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'aria-label': (0, _helpers.translation)('145') + ' & ' + (0, _helpers.translation)('146'), className: 'hint--top' },
	              _react2.default.createElement(_icon2.default, { injectSvg: false, icon: _icons.MassInvoiceIcons.Type_Model })
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'aria-label': (0, _helpers.translation)('58'), className: 'hint--top' },
	              _react2.default.createElement(_icon2.default, { injectSvg: false, icon: _icons.MassInvoiceIcons.Customer })
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'aria-label': (0, _helpers.translation)('193'), className: 'hint--top' },
	              _react2.default.createElement(_icon2.default, { injectSvg: false, icon: _icons.MassInvoiceIcons.Handsover })
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'aria-label': (0, _helpers.translation)('641'), className: 'hint--top' },
	              _react2.default.createElement(_icon2.default, { injectSvg: false, icon: _icons.MassInvoiceIcons.Total_price })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'listcontainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'list' },
	            orders.map(renderGroup)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'executeAction',
	    value: function executeAction() {
	      if (this.props.isLoading) return;
	
	      var _state = this.state,
	          selectedAction = _state.selectedAction,
	          selectedOrders = _state.selectedOrders,
	          addon = _state.addon,
	          orders = _state.orders,
	          invoicedOrders = _state.invoicedOrders;
	      var orderKeys = this.props.meta.orderKeys;
	
	      if (selectedOrders.length !== 0) {
	        var realOrders = selectedAction !== 1 ? orders : invoicedOrders;
	
	        // Filter out all selected orders
	        var actionOrders = realOrders.reduce(function (ords, group) {
	          var orders = group.orders.filter(function (o) {
	            return selectedOrders.includes(o.Id);
	          });
	          return orders.length !== 0 ? [].concat(_toConsumableArray(ords), _toConsumableArray(orders)) : ords;
	        }, []);
	
	        this.props.executeMassInvoice(actionOrders, selectedAction, addon, { orderKeys: orderKeys });
	      } else {
	        window.toastr.error((0, _helpers.translation)('14989'), (0, _helpers.translation)('216'));
	      }
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _state2 = this.state,
	          selectedAction = _state2.selectedAction,
	          orders = _state2.orders,
	          invoicedOrders = _state2.invoicedOrders;
	
	
	      var listOrders = selectedAction === 1 ? invoicedOrders : orders;
	
	      // Response handling
	      var responseMsg = '';
	      var responseClass = 'massinvoice__success';
	      if (this.props.response) {
	        var _props$response = this.props.response,
	            errors = _props$response.errors,
	            action = _props$response.action;
	
	        if (!errors) {
	          switch (action) {
	            case 0:
	              responseMsg = (0, _helpers.translation)('13424') + ' \u2013 ' + (0, _helpers.translation)('14990');
	              break;
	            case 1:
	              responseMsg = (0, _helpers.translation)('13424') + ' \u2013 ' + (0, _helpers.translation)('14991');
	              break;
	            case 2:
	              responseMsg = (0, _helpers.translation)('13424') + ' \u2013 ' + (0, _helpers.translation)('14992');
	              break;
	            default:
	              break;
	          }
	          // if (success !== true && success.length !== 0) {
	          //   console.log('fix successful orders')
	          //   // Remove the successful orders
	          //   listOrders = listOrders.reduce((newOrders, group) => {
	          //     const filtered = group.orders.filter(o => {
	          //       return !success.find(s => s.Id === o.Id)
	          //     })
	
	          //     if (filtered.length !== 0) {
	          //       const newGroup = { ...group }
	          //       newGroup.orders = filtered
	
	          //       return [ ...newOrders, newGroup ]
	          //     }
	          //     return newOrders
	          //   }, [])
	          // }
	        } else {
	          if (errors !== true && errors.length !== 0) {
	            // Filter out the failing orders
	            // listOrders = listOrders.reduce((errOrders, group) => {
	            //     const filtered = group.orders.reduce((errorOrders, o) => {
	            //         const eo = errors.find(e => e.order.Id === o.Id)
	            //         return eo ? [ ...errorOrders, eo.order ] : errorOrders
	            //     }, [])
	
	            //     if (filtered.length !== 0) {
	            //         const errGroup = { ...group }
	            //         errGroup.orders = filtered
	
	            //         return [ ...errOrders, errGroup ]
	            //     }
	            //     return errOrders
	            // }, [])
	            responseMsg = (0, _helpers.translation)('960') + ' \u2013 ' + (0, _helpers.translation)('14993');
	          } else {
	            responseMsg = (0, _helpers.translation)('960');
	          }
	
	          responseClass = 'massinvoice__error';
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'massinvoice__content' },
	        this.renderActions(),
	        responseMsg && _react2.default.createElement(
	          'div',
	          { className: responseClass },
	          responseMsg
	        ),
	        this.renderOrders(listOrders)
	      );
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      var _this5 = this;
	
	      this.setState({
	        orders: [],
	        invoicedOrders: [],
	        selectedOrders: [],
	        // allSelected: false,
	        selectedAction: 0,
	        addon: false
	      }, function () {
	        return _this5.props.onClose();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      // const header = () => {
	      //   return [
	      //     <img src={'/images/svgs/listheader/mass-invoiceing-white.svg'} className='header__icon' />,
	      //     translation('14994')
	      //   ]
	      // }
	
	      var renderText = function renderText() {
	        if (_this6.props.isLoading) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'animated-background' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	          );
	        }
	        return _this6.getActionName(_this6.state.selectedAction);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'massinvoice' },
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            header: (0, _helpers.translation)('14994'),
	            icon: _icons.ModalIcons.Mass_Invoice,
	            onClose: this.onClose,
	            show: this.props.show,
	            bottomBarProps: {
	              actionLabelText: renderText(),
	              onActionClick: this.executeAction
	            }
	          },
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return MassInvoice;
	}(_react.Component);
	
	MassInvoice.contextTypes = {
	  // t: React.PropTypes.func.isRequired,
	  // enum: React.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  massInvoiceOrders: _invoicing.massInvoiceOrders,
	  getPriceList: _priceModel.getPriceList
	})(MassInvoice);

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1652);
	
	var _employees = __webpack_require__(128);
	
	var _orders = __webpack_require__(21);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _icons = __webpack_require__(6);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// import components
	
	
	// Utils
	
	
	var MultiStartModal = function (_Component) {
	  _inherits(MultiStartModal, _Component);
	
	  function MultiStartModal(props) {
	    _classCallCheck(this, MultiStartModal);
	
	    var _this = _possibleConstructorReturn(this, (MultiStartModal.__proto__ || Object.getPrototypeOf(MultiStartModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      selectedOrderIds: [],
	      selectedUserIds: [],
	      startOrderIds: [],
	      startUserIds: [],
	      showBtns: false
	    };
	    _this.onChangeUsers = _this.onChangeUsers.bind(_this);
	    _this.UserCheckbox = _this.UserCheckbox.bind(_this);
	    _this.OrderCheckbox = _this.OrderCheckbox.bind(_this);
	    _this.onChangeOrders = _this.onChangeOrders.bind(_this);
	    _this.modalTitle = _this.modalTitle.bind(_this);
	    _this.click = _this.click.bind(_this);
	    _this.Pause = _this.Pause.bind(_this);
	    _this.Complete = _this.Complete.bind(_this);
	    return _this;
	  }
	
	  _createClass(MultiStartModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.getOrdersInStep(this.props.step).then(function (res) {
	        _this2.setState({
	          selectedOrderIds: res.data.OrderIds,
	          selectedUserIds: res.data.UserIds,
	          startOrderIds: res.data.OrderIds,
	          startUserIds: res.data.UserIds,
	          showBtns: res.data.OrderIds.length > 0
	        }, function () {
	          console.log(_this2.state.selectedOrderIds, _this2.state.selectedUserIds);
	        });
	      });
	    }
	  }, {
	    key: 'modalTitle',
	    value: function modalTitle(item) {
	      var title = '';
	
	      // Model
	      if (item.Model) {
	        title += item.Model;
	      }
	
	      // RegNumber
	      if (item.RegNumber) {
	        if (item.Model) {
	          title += ', ';
	        }
	        title += item.RegNumber;
	      }
	
	      // Title empty
	      if (title === '') {
	        title += item.Id || item.OrderId;
	      }
	
	      return title;
	    }
	  }, {
	    key: 'onChangeUsers',
	    value: function onChangeUsers(e) {
	      if (e.target.id === 'allUsers') {
	        if (e.target.checked === true) {
	          this.setState({
	            selectedUserIds: [].concat(_toConsumableArray(this.props.employees.map(function (el) {
	              return Number(el.UserId);
	            })))
	          });
	        } else if (e.target.checked === false) {
	          this.setState({
	            selectedUserIds: []
	          });
	        }
	      } else if (e.target.checked === true) {
	        this.state.selectedUserIds.push(Number(e.target.id));
	        this.setState({
	          selectedUserIds: [].concat(_toConsumableArray(this.state.selectedUserIds))
	        });
	      } else if (e.target.checked === false) {
	        var arrayEm = this.state.selectedUserIds;
	        this.state.selectedUserIds = arrayEm.filter(function (el) {
	          return el !== Number(e.target.id);
	        });
	        this.setState({
	          selectedUserIds: [].concat(_toConsumableArray(this.state.selectedUserIds))
	        });
	      }
	    }
	  }, {
	    key: 'UserCheckbox',
	    value: function UserCheckbox() {
	      var _this3 = this;
	
	      var employeesList = function employeesList(val, key) {
	        var checked = _this3.state.selectedUserIds.includes(Number(val.UserId));
	        return _react2.default.createElement(
	          'div',
	          { className: 'checkbox__custom control__field', key: key },
	          _react2.default.createElement('input', { type: 'checkbox', id: val.UserId, value: val.UserId, name: key, checked: checked, onChange: _this3.onChangeUsers }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: val.UserId, className: 'inputCheck' },
	            val.Name
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'col floatLeft' },
	        _react2.default.createElement(
	          'div',
	          { className: 'white__box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            (0, _helpers.translation)('10')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'checklist' },
	            _react2.default.createElement(
	              'div',
	              { className: 'checkbox__custom control__field' },
	              _react2.default.createElement('input', { type: 'checkbox', id: 'allUsers', checked: this.props.employees.filter(function (e) {
	                  return !_this3.state.selectedUserIds.includes(Number(e.UserId));
	                }).length === 0, onChange: this.onChangeUsers }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'allUsers', className: 'inputCheck' },
	                (0, _helpers.translation)('531')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              this.props.employees.map(employeesList)
	            )
	          )
	        )
	      );
	    }
	
	    // orders
	
	  }, {
	    key: 'onChangeOrders',
	    value: function onChangeOrders(e) {
	      if (e.target.id === 'allOrders') {
	        if (e.target.checked === true) {
	          this.setState({
	            selectedOrderIds: [].concat(_toConsumableArray(this.props.orders.map(function (el) {
	              return Number(el.Id);
	            })))
	          });
	        } else if (e.target.checked === false) {
	          this.setState({
	            selectedOrderIds: []
	          });
	        }
	      } else if (e.target.checked === true) {
	        this.state.selectedOrderIds.push(Number(e.target.id));
	        this.setState({
	          selectedOrderIds: [].concat(_toConsumableArray(this.state.selectedOrderIds))
	        });
	      } else if (e.target.checked === false) {
	        var arrayEm = this.state.selectedOrderIds;
	        this.state.selectedOrderIds = arrayEm.filter(function (el) {
	          return el !== Number(e.target.id);
	        });
	        this.setState({
	          selectedOrderIds: [].concat(_toConsumableArray(this.state.selectedOrderIds))
	        });
	      }
	    }
	  }, {
	    key: 'OrderCheckbox',
	    value: function OrderCheckbox() {
	      var _this4 = this;
	
	      var orderList = function orderList(val, key) {
	        var checked = _this4.state.selectedOrderIds.includes(Number(val.Id));
	        return _react2.default.createElement(
	          'div',
	          { className: 'checkbox__custom control__field', key: key },
	          _react2.default.createElement('input', { type: 'checkbox', id: val.Id, value: val.Id, name: key, checked: checked, onChange: _this4.onChangeOrders }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: val.Id, className: 'inputCheck' },
	            _this4.modalTitle(val)
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'col floatRight' },
	        _react2.default.createElement(
	          'div',
	          { className: 'white__box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            (0, _helpers.translation)('720')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'checklist' },
	            _react2.default.createElement(
	              'div',
	              { className: 'checkbox__custom control__field' },
	              _react2.default.createElement('input', { type: 'checkbox', id: 'allOrders', checked: this.props.orders.filter(function (e) {
	                  return !_this4.state.selectedOrderIds.includes(Number(e.Id));
	                }).length === 0, onChange: this.onChangeOrders }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'allOrders', className: 'inputCheck' },
	                (0, _helpers.translation)('531')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              this.props.orders.map(orderList)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'click',
	    value: function click() {
	      console.log('orders', this.state.selectedOrderIds);
	      this.props.start(this.state.selectedOrderIds, this.state.selectedUserIds);
	    }
	  }, {
	    key: 'Pause',
	    value: function Pause() {
	      var _this5 = this;
	
	      var data = {
	        OrderId: this.state.startOrderIds[0],
	        UserId: 0,
	        StopAll: true
	      };
	
	      this.props.stopOrder(data).then(function (res) {
	        _this5.setState({
	          selectedOrderIds: [],
	          selectedUserIds: [],
	          startOrderIds: [],
	          startUserIds: []
	        });
	        // window.toastr.success(translation('12340'), translation('13424'))
	        _this5.props.onClose();
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('12342'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'Complete',
	    value: function Complete(all) {
	      var OrderIds = [];
	      this.props.orders.forEach(function (item) {
	        var val = item.Id;
	        OrderIds.push(val);
	      });
	
	      var data = {
	        OrderIds: all === true ? OrderIds : this.state.startOrderIds,
	        UserId: 0,
	        StepFrom: this.props.step,
	        StepTo: this.props.step + 1,
	        Comment: '',
	        FilterSettings: {},
	        MoveAll: true
	      };
	
	      this.props.move(data);
	      this.props.onClose();
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'top' },
	          this.state.showBtns && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'button full primary', onClick: this.Pause },
	              (0, _helpers.translation)('12344')
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'button full primary', onClick: this.Complete.bind(this, false) },
	              (0, _helpers.translation)('12345')
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'button full primary', onClick: this.Complete.bind(this, true) },
	            (0, _helpers.translation)('12346')
	          )
	        ),
	        this.UserCheckbox(),
	        this.OrderCheckbox(),
	        _react2.default.createElement(
	          'button',
	          { className: 'button full primary', disabled: this.state.selectedUserIds.length === 0 || this.state.selectedOrderIds.length === 0, onClick: this.click },
	          (0, _helpers.translation)('956')
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'MultiStart__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('2317'),
	            overflowHidden: this.state.overflowHidden,
	            onClose: this.props.onClose,
	            icon: _icons.ModalIcons.Shared_Screen }),
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return MultiStartModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    employees: state.common.employees.filter(function (x) {
	      return x.Active;
	    })
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getEmployees: _employees.getEmployees,
	  getOrdersInStep: _orders.getOrdersInStep,
	  stopOrder: _orders.stopOrder
	})(MultiStartModal);

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(43);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _async = __webpack_require__(147);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(27);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1653);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _helpers = __webpack_require__(2);
	
	var _forsitoken = __webpack_require__(795);
	
	var _orders = __webpack_require__(21);
	
	var _icons = __webpack_require__(6);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _panelHeader = __webpack_require__(40);
	
	var _panelHeader2 = _interopRequireDefault(_panelHeader);
	
	var _DecimalInput = __webpack_require__(84);
	
	var _DecimalInput2 = _interopRequireDefault(_DecimalInput);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import style
	
	
	// import components
	
	
	// Utils
	
	
	// Actions
	
	
	// Elements
	
	
	var NewForsiRPModal = function (_Component) {
	  _inherits(NewForsiRPModal, _Component);
	
	  function NewForsiRPModal(props) {
	    _classCallCheck(this, NewForsiRPModal);
	
	    var _this = _possibleConstructorReturn(this, (NewForsiRPModal.__proto__ || Object.getPrototypeOf(NewForsiRPModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      step: 1,
	      forsiReport: {
	        OrderId: props.order ? props.order.Id : null,
	        DistanceDriven: props.order.DistanceDriven ? props.order.DistanceDriven : '',
	        RegNumber: props.order.RegNumber ? props.order.RegNumber : '',
	        ChassisNumber: props.order.ChassisNumber ? props.order.ChassisNumber : '',
	        // since we d'ont have ModelYear all the time from vehicle info, we take it from the vehicle's first registration date.
	        ModelYear: !props.order.RegistrationDate ? '' : props.order.RegistrationDate.split('-')[2] !== undefined ? props.order.RegistrationDate.split('-')[2] : '', // 25-06-2021
	        InsuranceCompanyId: 0,
	        DamageZones: [],
	        PlateTypeId: 0,
	        DamageTypeId: 0,
	        Images: [],
	        IncidentDate: props.order.InsuranceDamageDate ? props.order.InsuranceDamageDate : null
	      },
	      allZones: [],
	      plateTypes: [],
	      damageTypes: [],
	      markedImages: [],
	      insuranceCompany: null,
	      showSpinner: false,
	      loadingDamageTypes: false,
	      loadingEnums: true,
	      upload: {
	        loading: false,
	        errors: []
	      }
	    };
	
	    _this.handleCreateOrder = _this.handleCreateOrder.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onChangeDate = _this.onChangeDate.bind(_this);
	    _this.onChangeForsi = _this.onChangeForsi.bind(_this);
	    _this.onChangePlate = _this.onChangePlate.bind(_this);
	    _this.onChangeZones = _this.onChangeZones.bind(_this);
	    _this.handleSpinner = _this.handleSpinner.bind(_this);
	    _this.handleLoadingDamageTypes = _this.handleLoadingDamageTypes.bind(_this);
	    _this.handleErrors = _this.handleErrors.bind(_this);
	    _this.handleRequiredInputs = _this.handleRequiredInputs.bind(_this);
	    _this.isDamageType = _this.isDamageType.bind(_this);
	    _this.isPlateType = _this.isPlateType.bind(_this);
	    _this.getImageFiles = _this.getImageFiles.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewForsiRPModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.GetForsiDraftEnums().then(function (res) {
	        _this2.setState({
	          allZones: res.data.DamageZones,
	          plateTypes: res.data.LicensePlateTypes,
	          damageTypes: res.data.DamageTypes,
	          loadingEnums: false,
	          markedImages: _this2.props.order.OrderFiles.map(function (item) {
	            return true;
	          })
	        }, function () {
	          if (_this2.props.order) {
	            if (_this2.props.order.InsuranceCompanyId) {
	              if (_this2.props.order.InsuranceCompanyId > 0) {
	                _this2.onChangeForsi({
	                  target: {
	                    name: 'InsuranceCompanyId',
	                    value: _this2.props.order.InsuranceCompanyId
	                  }
	                });
	              }
	            }
	          }
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!(0, _lodash.isEqual)(prevProps.order.OrderFiles, this.props.order.OrderFiles)) {
	        this.setState({
	          markedImages: this.props.order.OrderFiles.map(function (item) {
	            return true;
	          })
	        });
	      }
	    }
	  }, {
	    key: 'handleSpinner',
	    value: function handleSpinner(value) {
	      this.setState({ showSpinner: value });
	    }
	  }, {
	    key: 'handleLoadingDamageTypes',
	    value: function handleLoadingDamageTypes(value) {
	      this.setState({ loadingDamageTypes: value });
	    }
	  }, {
	    key: 'handleCreateOrder',
	    value: function handleCreateOrder(e) {
	      var _this3 = this;
	
	      var _state = this.state,
	          forsiReport = _state.forsiReport,
	          markedImages = _state.markedImages;
	
	      var dataObj = _extends({}, forsiReport);
	
	      var imgFiles = [];
	      this.props.order.OrderFiles.map(function (file) {
	        if (file.IsImage) imgFiles.push(file);
	      });
	
	      var images = [];
	      markedImages.map(function (value, index) {
	        if (value) {
	          images.push(imgFiles[index]);
	        }
	      });
	
	      dataObj.OrderId = this.props.order.Id;
	      dataObj.Images = images;
	
	      this.handleSpinner(true);
	      if (this.handleRequiredInputs(dataObj)) {
	        this.props.CreateForsiDraft(dataObj).then(function (res) {
	          _this3.props.getOrder(forsiReport.OrderId).then(function (res) {
	            _this3.handleSpinner(false);
	            _this3.props.onSuccess(res.data);
	          }).catch(function (err) {
	            _this3.handleErrors(err);
	            _this3.handleSpinner(false);
	            _this3.props.onSuccess();
	          });
	        }).catch(function (err) {
	          _this3.handleErrors(err);
	          _this3.handleSpinner(false);
	        });
	      } else {
	        this.handleSpinner(false);
	      }
	    }
	  }, {
	    key: 'handleRequiredInputs',
	    value: function handleRequiredInputs(draft) {
	      var errors = [];
	
	      if (!draft.PlateTypeId === 0) {
	        errors.push((0, _helpers.translation)('16492'));
	      }
	
	      if (draft.DamageZones.length === 0) {
	        errors.push((0, _helpers.translation)('16493'));
	      }
	
	      if (!draft.DamageTypeId === 0) {
	        errors.push((0, _helpers.translation)('16494'));
	      }
	
	      if (draft.ChassisNumber.length === 0) {
	        errors.push((0, _helpers.translation)('16495'));
	      }
	
	      if (draft.DistanceDriven.length === 0) {
	        errors.push((0, _helpers.translation)('16496'));
	      }
	
	      if (draft.ModelYear.length === 0) {
	        errors.push((0, _helpers.translation)('16497'));
	      }
	
	      if (draft.RegNumber.length === 0) {
	        if (draft.PlateTypeId) {
	          if (draft.PlateTypeId !== 1) {
	            errors.push((0, _helpers.translation)('16498'));
	          }
	        } else {
	          errors.push((0, _helpers.translation)('16498'));
	        }
	      }
	
	      // if (!draft.IncidentDate) {
	      //   errors.push(translation('16500'))
	      // }
	
	      if (draft.InsuranceCompanyId <= 0) {
	        errors.push((0, _helpers.translation)('16502'));
	      }
	
	      if (errors.length > 0) {
	        var errText = '';
	        for (var i = 0; i < errors.length; i++) {
	          errText += '<br/>' + errors[i];
	        }
	        this.handleErrors(errText);
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'handleErrors',
	    value: function handleErrors(err) {
	      if (err) {
	        if (err.response) {
	          if (err.response.data !== undefined && err.response.data !== null && Array.isArray(err.response.data) && err.response.data.length > 0) {
	            var errors = err.response.data;
	            var errText = '';
	            for (var i = 0; i < errors.length; i++) {
	              var dictKey = errors[i].DictionaryKey;
	              errText += '<br/>' + (0, _helpers.translation)(dictKey);
	              if (dictKey === 16501 || dictKey === '16501') {
	                this.props.onTokenExpired();
	              }
	            }
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          } else {
	            window.toastr.error((0, _helpers.translation)('910'), (0, _helpers.translation)('216'));
	          }
	        } else {
	          window.toastr.error(err, (0, _helpers.translation)('216'));
	        }
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var forsiReport = this.state.forsiReport;
	
	      this.setState({ forsiReport: _extends({}, forsiReport, _defineProperty({}, e.target.name, e.target.value)) });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      // Empty method. It is used to deter errors thrown by DecimalInput
	      // which requires onBlur
	    }
	  }, {
	    key: 'onChangeDate',
	    value: function onChangeDate(e) {
	      var forsiReport = this.state.forsiReport;
	
	      this.setState({ forsiReport: _extends({}, forsiReport, { IncidentDate: e.toDate() }) });
	    }
	  }, {
	    key: 'onChangeForsi',
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
	        var _this4 = this;
	
	        var forsiReport;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                forsiReport = this.state.forsiReport;
	
	
	                this.handleLoadingDamageTypes(true);
	                _context.next = 4;
	                return this.props.GetForsiDamageTypes(e.target.value).then(function (resp) {
	                  var data = resp.data;
	                  if (data) {
	                    if (Array.isArray(data)) {
	                      if (data.length > 0) {
	                        _this4.setState({
	                          forsiReport: _extends({}, forsiReport, _defineProperty({}, e.target.name, e.target.value)),
	                          damageTypes: data,
	                          loadingDamageTypes: false
	                        });
	                      }
	                    }
	                  }
	                }).catch(function (err) {
	                  console.log(err);
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function onChangeForsi(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return onChangeForsi;
	    }()
	  }, {
	    key: 'onChangeImages',
	    value: function onChangeImages(e, file, index) {
	      var markedImages = this.state.markedImages;
	
	
	      markedImages[index] = !markedImages[index];
	
	      this.setState({
	        markedImages: markedImages
	      });
	    }
	  }, {
	    key: 'onChangePlate',
	    value: function onChangePlate(e) {
	      var forsiReport = this.state.forsiReport;
	
	
	      this.setState({
	        forsiReport: _extends({}, forsiReport, _defineProperty({}, e.target.name, parseInt(e.target.value)))
	      });
	    }
	  }, {
	    key: 'onChangeDamageType',
	    value: function onChangeDamageType(e, type) {
	      var forsiReport = this.state.forsiReport;
	
	
	      this.setState({
	        forsiReport: _extends({}, forsiReport, _defineProperty({}, e.target.name, type.Id))
	      });
	    }
	  }, {
	    key: 'onChangeZones',
	    value: function onChangeZones(e, zone) {
	      var forsiReport = this.state.forsiReport;
	
	
	      var updateObj = _extends({}, forsiReport);
	
	      if (updateObj[e.target.name].includes(zone)) {
	        updateObj[e.target.name] = updateObj[e.target.name].filter(function (val) {
	          return val.Id !== zone.Id;
	        });
	      } else {
	        updateObj[e.target.name].push(zone);
	      }
	
	      this.setState({
	        forsiReport: _extends({}, updateObj)
	      });
	    }
	  }, {
	    key: 'renderGallery',
	    value: function renderGallery(files) {
	      var _this5 = this;
	
	      var markedImages = this.state.markedImages;
	
	
	      if (files.length === 0) {
	        return null;
	      }
	
	      var renderImage = function renderImage(image, index) {
	        var url = _constants.FILE_STORAGE + image.ThumbURL;
	        var fullUrl = _constants.FILE_STORAGE + image.FileURL;
	
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          _react2.default.createElement(
	            'div',
	            { className: 'divImg' },
	            _react2.default.createElement('img', { className: 'img2', src: url }),
	            _react2.default.createElement(
	              'a',
	              { href: fullUrl, 'data-lightbox': 'gallery', 'data-title': image.FileName },
	              _react2.default.createElement('img', { src: url })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'divCheckbox' },
	            _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('1218'), name: 'Images', value: image, onChange: function onChange(e) {
	                return _this5.onChangeImages(e, image, index);
	              }, checked: markedImages[index] })
	          )
	        );
	      };
	
	      return _react2.default.createElement(_Gallery2.default, { files: files, renderImage: renderImage });
	    }
	  }, {
	    key: 'renderStepTwo',
	    value: function renderStepTwo() {
	      var _this6 = this;
	
	      var imgFiles = this.getImageFiles();
	
	      var onDrop = function onDrop() {
	        _this6.setState({
	          upload: _extends({}, _this6.state.upload, {
	            errors: []
	          })
	        });
	      };
	
	      var onDropAccepted = function onDropAccepted(files) {
	        var newErrors = [];
	        _this6.setState({
	          upload: _extends({}, _this6.state.upload, {
	            loading: true,
	            errors: []
	          })
	        });
	
	        _async2.default.each(files, function (file, cb) {
	          // Upload each file
	          _this6.props.uploadFileToOrder(file, _this6.props.order.Id).then(function (res) {
	            cb();
	          }, function () {
	            newErrors.push((0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13406') + '.');
	            cb();
	          });
	        }, function () {
	          if (newErrors.length !== 0) {
	            _this6.setState({
	              upload: _extends({}, _this6.state.upload, {
	                errors: _this6.state.upload.errors.concat(newErrors)
	              })
	            });
	          }
	
	          _this6.setState({
	            upload: _extends({}, _this6.state.upload, {
	              loading: false
	            })
	          }, function () {
	            return _this6.props.getOrder(_this6.props.order.Id);
	          });
	        });
	      };
	
	      var onDropRejected = function onDropRejected(files) {
	        var newErrors = files.map(function (file) {
	          return (0, _helpers.translation)('1207') + ': ' + file.name + ' ' + (0, _helpers.translation)('13405') + '.';
	        });
	        _this6.setState({
	          upload: _extends({}, _this6.state.upload, {
	            errors: newErrors
	          })
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'newForsiReport__photos' },
	          _react2.default.createElement(
	            'div',
	            null,
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)(1011) },
	              this.state.upload.errors.length !== 0 && _react2.default.createElement(
	                'div',
	                { className: 'alert alert-danger' },
	                this.state.upload.errors.map(function (err, key) {
	                  return _react2.default.createElement(
	                    'p',
	                    { key: key },
	                    err
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                _Dropzone2.default,
	                {
	                  onDrop: onDrop,
	                  onDropAccepted: onDropAccepted,
	                  onDropRejected: onDropRejected,
	                  multiple: true,
	                  includeCircles: false
	                },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  (0, _helpers.translation)('13397')
	                )
	              ),
	              imgFiles.length === 0 && _react2.default.createElement(_panelHeader2.default, { text: (0, _helpers.translation)(16504) }),
	              imgFiles.length > 0 && this.renderGallery(imgFiles)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            '\xA0'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'isDamageType',
	    value: function isDamageType(type) {
	      var forsiReport = this.state.forsiReport;
	
	      if (!forsiReport.DamageType) return false;
	      return forsiReport.DamageType.ForsiDamageTypeId === type.Id;
	    }
	  }, {
	    key: 'isPlateType',
	    value: function isPlateType(index) {
	      var _state2 = this.state,
	          forsiReport = _state2.forsiReport,
	          plateTypes = _state2.plateTypes;
	
	      if (!forsiReport.PlateType) return false;
	      return forsiReport.PlateType.Name === plateTypes[index];
	    }
	  }, {
	    key: 'getImageFiles',
	    value: function getImageFiles() {
	      var order = this.props.order;
	
	      var imgFiles = [];
	
	      if (order.OrderFiles) {
	        order.OrderFiles.map(function (file) {
	          if (file.IsImage) imgFiles.push(file);
	        });
	      }
	
	      return imgFiles;
	    }
	  }, {
	    key: 'renderSpinner',
	    value: function renderSpinner() {
	      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'showSpinner';
	
	      if (!this.state[name]) return null;
	
	      return [_react2.default.createElement('div', { className: 'divider', key: '1' }), _react2.default.createElement(
	        'div',
	        { className: 'newForsiReport__spinner', key: '2' },
	        _react2.default.createElement(
	          'span',
	          { className: 'animated-background' },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-2x fa-fw' })
	        )
	      )];
	    }
	  }, {
	    key: 'renderStepOne',
	    value: function renderStepOne() {
	      var _this7 = this;
	
	      var _props = this.props,
	          insuranceCompanies = _props.insuranceCompanies,
	          order = _props.order;
	      var _state3 = this.state,
	          allZones = _state3.allZones,
	          plateTypes = _state3.plateTypes,
	          forsiReport = _state3.forsiReport,
	          damageTypes = _state3.damageTypes,
	          loadingDamageTypes = _state3.loadingDamageTypes;
	
	      // console.log(order)
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'newForsiReport__col' },
	              _react2.default.createElement(
	                _dropDown2.default,
	                { name: 'InsuranceCompanyId', value: this.state.forsiReport.InsuranceCompanyId, onChange: this.onChangeForsi, labelText: (0, _helpers.translation)('418') },
	                _react2.default.createElement(
	                  'option',
	                  { value: '0' },
	                  (0, _helpers.translation)('418')
	                ),
	                insuranceCompanies.map(function (val, index) {
	                  if (val.Active) {
	                    if (val.InsuranceCompanyId === order.InsuranceCompanyId) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: val.InsuranceCompanyId, key: index, selected: true },
	                        val.Company
	                      );
	                    } else {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: val.InsuranceCompanyId, key: index },
	                        val.Company
	                      );
	                    }
	                  }
	                })
	              ),
	              _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('78'), onChange: this.onChange, name: 'RegNumber', value: forsiReport.RegNumber }),
	              _react2.default.createElement(_DecimalInput2.default, { decimals: 0, labelText: (0, _helpers.translation)('860'), onChange: this.onChange, onBlur: this.onBlur, name: 'DistanceDriven', value: forsiReport.DistanceDriven }),
	              _react2.default.createElement(_DecimalInput2.default, { decimals: 0, labelText: (0, _helpers.translation)('148'), onChange: this.onChange, onBlur: this.onBlur, name: 'ModelYear', value: forsiReport.ModelYear }),
	              _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)('81'), onChange: this.onChange, name: 'ChassisNumber', value: forsiReport.ChassisNumber }),
	              _react2.default.createElement(_datetime2.default, {
	                inputProps: {
	                  name: 'IncidentDate',
	                  readOnly: true,
	                  placeholder: (0, _helpers.translation)('1728')
	                },
	                dateFormat: 'DD-MM-YYYY',
	                timeFormat: false,
	                value: (0, _moment2.default)(forsiReport.IncidentDate),
	                closeOnSelect: true,
	                onChange: this.onChangeDate,
	                labelText: (0, _helpers.translation)('16572')
	              }),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _labelWrapper2.default,
	                  { labelText: (0, _helpers.translation)('16577') },
	                  this.renderSpinner('loadingEnums'),
	                  plateTypes.map(function (plate, index) {
	                    return _react2.default.createElement(_radio2.default, {
	                      key: plate.Id + '-key',
	                      id: plate.Id + '-index',
	                      name: 'PlateTypeId',
	                      value: plate.Id,
	                      onChange: _this7.onChangePlate,
	                      checked: forsiReport.PlateTypeId === plate.Id,
	                      labelText: (0, _helpers.translation)(plate.DictionaryKey)
	                    });
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'newForsiReport__col' },
	              _react2.default.createElement(
	                _labelWrapper2.default,
	                { labelText: (0, _helpers.translation)('16480') },
	                this.renderSpinner('loadingEnums'),
	                allZones.map(function (zone, index) {
	                  return _react2.default.createElement(_check2.default, { key: zone.Name + '-key', id: zone + '-index', name: 'DamageZones', value: allZones[index].Name, onChange: function onChange(e) {
	                      return _this7.onChangeZones(e, zone);
	                    }, checked: forsiReport.DamageZones.includes(zone), labelText: (0, _helpers.translation)(zone.DictionaryKey) });
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _col2.default,
	            null,
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)('16478') },
	              this.renderSpinner('loadingDamageTypes'),
	              this.renderSpinner('loadingEnums'),
	              loadingDamageTypes ? null : damageTypes.map(function (type, index) {
	                return _react2.default.createElement(_radio2.default, {
	                  key: type.Id + '-key',
	                  id: type.Id + '-index',
	                  name: 'DamageTypeId', value: type.Id,
	                  onChange: function onChange(e) {
	                    return _this7.onChangeDamageType(e, type);
	                  },
	                  checked: forsiReport.DamageTypeId === type.Id,
	                  labelText: (0, _helpers.translation)(type.DictionaryKey) || type.Name
	                });
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(step) {
	      var _this8 = this;
	
	      if (this.state.showSpinner) return this.renderSpinner();
	      var imagesFound = this.getImageFiles().length;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'newForsiReport__header' },
	        _react2.default.createElement(
	          _tabBar2.default,
	          null,
	          _react2.default.createElement(
	            _tabItem2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: step === 1 ? 'active' : '', onClick: function onClick(e) {
	                  return _this8.setState({ step: 1 });
	                } },
	              (0, _helpers.translation)('16478')
	            )
	          ),
	          _react2.default.createElement(
	            _tabItem2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: step === 2 ? 'active' : '', onClick: function onClick(e) {
	                  return _this8.setState({ step: 2 });
	                } },
	              (0, _helpers.translation)('1011') + ' (' + imagesFound + ')'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _state4 = this.state,
	          step = _state4.step,
	          showSpinner = _state4.showSpinner;
	
	
	      var renderView = function renderView() {
	        return null;
	      };
	      var bottomBarProps = null;
	      switch (step) {
	        case 1:
	        default:
	          renderView = function renderView() {
	            return _this9.renderStepOne();
	          };
	          bottomBarProps = {
	            actionLabelText: (0, _helpers.translation)('237'),
	            onActionClick: function onActionClick() {
	              return _this9.setState({ step: 2 });
	            },
	            cancelLabelText: false
	          };
	          break;
	        case 2:
	          renderView = function renderView() {
	            return _this9.renderStepTwo();
	          };
	          bottomBarProps = {
	            actionLabelText: (0, _helpers.translation)('16475'),
	            onActionClick: this.handleCreateOrder,
	            cancelLabelText: false
	          };
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'newForsiReport' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('13438'),
	            overflowHidden: this.state.overflowHidden,
	            icon: _icons.MainMenuIcons.Forsi_White,
	            bottomBarProps: bottomBarProps
	          }),
	          this.renderHeader(step),
	          _react2.default.createElement(
	            'div',
	            null,
	            !showSpinner && renderView()
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewForsiRPModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetForsiDraftEnums: _forsitoken.GetForsiDraftEnums,
	  CreateForsiDraft: _forsitoken.CreateForsiDraft,
	  GetForsiDamageTypes: _forsitoken.GetForsiDamageTypes,
	  UpdateForsiDraft: _forsitoken.UpdateForsiDraft,
	  getOrder: _orders.getOrder,
	  uploadFileToOrder: _orders.uploadFileToOrder
	})(NewForsiRPModal);

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _Forsi = __webpack_require__(465);
	
	var _Forsi2 = _interopRequireDefault(_Forsi);
	
	var _RegistrationNumber = __webpack_require__(468);
	
	var _RegistrationNumber2 = _interopRequireDefault(_RegistrationNumber);
	
	var _OrderTypes = __webpack_require__(467);
	
	var _OrderTypes2 = _interopRequireDefault(_OrderTypes);
	
	var _Brand = __webpack_require__(459);
	
	var _Brand2 = _interopRequireDefault(_Brand);
	
	var _ChassisNumber = __webpack_require__(460);
	
	var _ChassisNumber2 = _interopRequireDefault(_ChassisNumber);
	
	var _Customer = __webpack_require__(462);
	
	var _Customer2 = _interopRequireDefault(_Customer);
	
	var _FileArea = __webpack_require__(464);
	
	var _FileArea2 = _interopRequireDefault(_FileArea);
	
	var _Estimation = __webpack_require__(463);
	
	var _Estimation2 = _interopRequireDefault(_Estimation);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _timeSpan = __webpack_require__(456);
	
	var _timeSpan2 = _interopRequireDefault(_timeSpan);
	
	var _MarkImage = __webpack_require__(466);
	
	var _MarkImage2 = _interopRequireDefault(_MarkImage);
	
	var _Complaint = __webpack_require__(461);
	
	var _Complaint2 = _interopRequireDefault(_Complaint);
	
	var _orders = __webpack_require__(21);
	
	var _address = __webpack_require__(277);
	
	var _insurancecompanies = __webpack_require__(172);
	
	var _settings = __webpack_require__(51);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	var _EnableCarOwnerPortalModal = __webpack_require__(1085);
	
	var _EnableCarOwnerPortalModal2 = _interopRequireDefault(_EnableCarOwnerPortalModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { isTouchDevice } from '../../../../utils/detect'
	
	// Components
	
	
	// Elements
	
	
	// Actions
	
	
	// Utils
	
	
	var NewBodyDraft = function (_Component) {
	  _inherits(NewBodyDraft, _Component);
	
	  function NewBodyDraft(props) {
	    _classCallCheck(this, NewBodyDraft);
	
	    var _this = _possibleConstructorReturn(this, (NewBodyDraft.__proto__ || Object.getPrototypeOf(NewBodyDraft)).call(this, props));
	
	    _this.newOrder = {};
	
	    _this.state = {
	      customerClients: [],
	      InsuranceCompanies: [],
	      MostUsedInsuranceCompanies: [],
	      CarRental: [],
	
	      isLoading: false,
	
	      CustomerId: 0,
	
	      RegNumber: '',
	      ChassisNumber: '',
	      BrandOriginal: '', // brandname,
	      ExtraData: {},
	
	      OrderType: '0',
	
	      fileContainerId: null,
	      images: [],
	      files: [],
	      activeImage: {},
	
	      evaluationAllowed: true,
	      Estimation: '0',
	      Estimation_comment: '',
	
	      InsuranceCompanyId: 0,
	
	      PickupAltLocationChecked: '0',
	      PickupAltLocationId: 0,
	      PickupAltLocation_comment: '',
	      DeliveryAltLocationChecked: '0',
	      DeliveryAltLocationId: 0,
	      DeliveryAltLocation_comment: '',
	
	      CarOwnerName: '',
	      CarOwnerLastName: '',
	      CarOwnerPhone: '',
	      CarOwnerMail: '',
	      EnableCarOwnerPortal: false,
	      IsCarOwnerPortalAccess: '0',
	      ShowCarOwnerPortalModal: false,
	      NewOrderId: null,
	
	      CarRentalChecked: '0',
	      CarRentalId: 0,
	
	      EstimatedProcessTime: null,
	      EstimatedProcessTimeCalculated: null,
	      estimatedProcessTimeValid: true,
	      BodyShopLeadTime: null,
	
	      orderdata: {},
	      listingID: '0'
	    };
	
	    _this.submitOrder = _this.submitOrder.bind(_this);
	    _this.createOrder = _this.createOrder.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onTimeSpanBlur = _this.onTimeSpanBlur.bind(_this);
	    _this.updateState = _this.updateState.bind(_this);
	    _this.addCarOwnerInformation = _this.addCarOwnerInformation.bind(_this);
	    _this.onCloseCarOwnerMadal = _this.onCloseCarOwnerMadal.bind(_this);
	    _this.createNewOrder = _this.createNewOrder.bind(_this);
	    // this.createCustomSelect = this.createCustomSelect.bind(this)
	    return _this;
	  }
	
	  _createClass(NewBodyDraft, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.updateModal({
	        bottomBarProps: {
	          actionLabelText: (0, _helpers.translation)('21'),
	          onActionClick: this.submitOrder
	        }
	      });
	
	      if (this.props.allowNoCustomer && this.props.tabView === 'draft') {
	        this.setState({ CustomerId: -1 });
	      } else {
	        var ownShopCustomer = this.props.customers.find(function (cust) {
	          return cust.IsOwnShop === true;
	        });
	        if (ownShopCustomer !== undefined) {
	          this.setState({ CustomerId: ownShopCustomer.CustomerId });
	        }
	      }
	      this.props.getInsuranceCompanies().then(function (res) {
	        _this2.setState({
	          InsuranceCompanies: res.data.Item2,
	          MostUsedInsuranceCompanies: res.data.Item1
	        });
	      });
	
	      if (this.props.carRentalDefaultInfo) {
	        this.setDefaultRentalCarInfo(this.props.carRentalDefaultInfo);
	      }
	
	      if (this.props.auth.permissions.AllowCarOwnerPortal) {
	        this.props.getCarOwnerPortalInformation().then(function (res) {
	          _this2.setState({ EnableCarOwnerPortal: res.data.CarOwnerPortalEnabled });
	        });
	      }
	
	      if (this.props.bodyShopDefaultLeadTime) {
	        this.setState({ BodyShopLeadTime: this.props.bodyShopDefaultLeadTime });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(nextProps, this.props)) {
	        if (nextProps.carRentalDefaultInfo) {
	          this.setDefaultRentalCarInfo(nextProps.carRentalDefaultInfo);
	        }
	      }
	    }
	  }, {
	    key: 'setDefaultRentalCarInfo',
	    value: function setDefaultRentalCarInfo(carRentalDefaultInfo) {
	      if (carRentalDefaultInfo.carRentalId) {
	        this.setState({
	          CarRentalChecked: '1',
	          CarRentalId: carRentalDefaultInfo.carRentalId + ''
	        });
	      }
	    }
	  }, {
	    key: 'setErrors',
	    value: function setErrors(errors) {
	      this.setState(errors);
	      var el = _reactDom2.default.findDOMNode(this.refs.addorderpopup);
	      if (el && el.parentNode) {
	        el.parentNode.scrollTop = 0;
	      }
	    }
	  }, {
	    key: 'submitOrder',
	    value: function submitOrder(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      this.setState({ isLoading: true, error: '' });
	
	      // If user filled in regnumber, but chassis is empty, try to look up data before continuing.
	      if (this.state.RegNumber !== null && this.state.RegNumber !== '' && (this.state.ChassisNumber === null || this.state.ChassisNumber === '') && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10, 0)) {
	        this.setState({ ExtraData: {} });
	
	        this.props.getOrderVehicleData(this.state.RegNumber, 'RegNumber').then(function (res) {
	          if (res.data.BrandOriginal !== null) {
	            _this3.setState({
	              ChassisNumber: res.data.ChassisNumber,
	              BrandOriginal: res.data.BrandName,
	              ExtraData: res.data
	            }, function () {
	              _this3.createOrder();
	            });
	          }
	        }, function () {});
	        this.createOrder();
	      } else {
	        this.createOrder();
	      }
	    }
	  }, {
	    key: 'createOrder',
	    value: function createOrder() {
	      var _this4 = this;
	
	      if (this.state.isLoading) return;
	
	      var customerId = 0;
	      if (this.props.auth.user.CustomerId === '-1') {
	        customerId = this.state.CustomerId;
	      } else {
	        customerId = parseInt(this.props.auth.user.CustomerId);
	      }
	
	      // VALIDATION START
	      var errors = [];
	
	      if (customerId === 0) {
	        errors.push((0, _helpers.translation)('1736')); // please select customer
	      }
	
	      if (this.state.OrderType === '0') {
	        errors.push((0, _helpers.translation)('13454')); // please select order type
	      }
	
	      if (!this.state.estimatedProcessTimeValid) {
	        errors.push((0, _helpers.translation)(16837)); // Estimated process time must be specified in valid format
	      }
	
	      if (errors.length > 0) {
	        this.setErrors({
	          isLoading: false
	        });
	        // Toastr
	        var errorText = '';
	        for (var i = 0; i < errors.length; i++) {
	          errorText += '<br />' + errors[i];
	        }
	        window.toastr.error(errorText, (0, _helpers.translation)('216'));
	        return false;
	      }
	      // VALIDATION END
	
	      // IsEvaluation
	      var IsEvaluation = false;
	      if (this.state.Estimation !== '0' && this.state.evaluationAllowed) {
	        IsEvaluation = true;
	      }
	
	      // Evaluation comment
	      var evaluationComment = '';
	      if (IsEvaluation) {
	        evaluationComment = this.state.Estimation_comment;
	      }
	
	      // PickupAltLocation comment
	      var PickupAltLocationComment = '';
	      var PickupAltLocationId = void 0;
	      if (this.state.PickupAltLocationChecked !== '0') {
	        PickupAltLocationId = this.state.PickupAltLocationId;
	        PickupAltLocationComment = this.state.PickupAltLocation_comment !== '' ? this.state.PickupAltLocation_comment : undefined;
	      }
	      // DeliveryAltLocation comment
	      var DeliveryAltLocationComment = '';
	      var DeliveryAltLocationId = void 0;
	      if (this.state.DeliveryAltLocationChecked !== '0') {
	        DeliveryAltLocationId = this.state.DeliveryAltLocationId;
	        DeliveryAltLocationComment = this.state.DeliveryAltLocation_comment !== '' ? this.state.DeliveryAltLocation_comment : undefined;
	      }
	
	      // Car rental default info
	      var DefaultPickupDate = null;
	      var PickupCarRentalCalc = false;
	      if (this.props.carRentalDefaultInfo && this.props.carRentalDefaultInfo.date) {
	        DefaultPickupDate = this.props.carRentalDefaultInfo.date;
	        PickupCarRentalCalc = true;
	      }
	
	      // Files
	      var files = [];
	      if (this.state.images.length !== 0 || this.state.files.length !== 0) {
	        files = [].concat(_toConsumableArray(this.state.images), _toConsumableArray(this.state.files));
	      }
	
	      // Brand
	      var BrandName = this.state.ExtraData.BrandName;
	      if (!BrandName) BrandName = this.state.BrandOriginal;
	
	      // Estimated process time.
	      var estimatedProcessTime = this.state.EstimatedProcessTimeCalculated === null ? null : this.state.EstimatedProcessTimeCalculated.decimal;
	      if (estimatedProcessTime === null || Number.isNaN(estimatedProcessTime) || estimatedProcessTime === 0) {
	        estimatedProcessTime = null;
	      } else {
	        estimatedProcessTime *= 60;
	      }
	
	      this.props.modal.isLoading(true);
	      if (this.props.options && this.props.options.pickup) {
	        DefaultPickupDate = this.props.options.pickup;
	      }
	
	      this.setState({ isLoading: true }, function () {
	        var order = {
	          RegNr: _this4.state.RegNumber,
	          ChassisNumber: _this4.state.ChassisNumber,
	          OrderType: _this4.state.OrderType,
	          BrandOriginal: _this4.state.ExtraData.BrandOriginal,
	          Model: _this4.state.ExtraData.Model,
	          BrandName: BrandName,
	          BrandCode: _this4.state.ExtraData.BrandCode,
	          RegistrationDate: _this4.state.ExtraData.RegistrationDate,
	          CustomerId: customerId,
	          IsEvaluation: IsEvaluation,
	          Case: {
	            Comment: evaluationComment
	          },
	          ImageTypes: files,
	          FileContainerId: _this4.state.fileContainerId,
	          DefaultPickupDate: DefaultPickupDate,
	          PickupCarRentalCalc: PickupCarRentalCalc,
	          EstimatedProcessTimeInMin: estimatedProcessTime,
	          BodyShopLeadTime: _this4.state.BodyShopLeadTime,
	          BodyShopData: {
	            DepartmentType: _this4.props.auth.departmentType, // 1
	            PickupAltLocationId: PickupAltLocationId,
	            DeliveryAltLocationId: DeliveryAltLocationId,
	            CarRentalId: _this4.state.CarRentalChecked === '1' ? _this4.state.CarRentalId : undefined,
	            CarOwnerName: _this4.state.CarOwnerName,
	            CarOwnerLastName: _this4.state.CarOwnerLastName,
	            CarOwnerPhone: _this4.state.CarOwnerPhone,
	            CarOwnerMail: _this4.state.CarOwnerMail,
	            IsCarOwnerPortalAccess: _this4.state.IsCarOwnerPortalAccess === '1',
	            PickupAltLocationComment: PickupAltLocationComment,
	            DeliveryAltLocationComment: DeliveryAltLocationComment,
	            InsuranceCompanyId: _this4.state.InsuranceCompanyId
	          }
	
	          // store order in newOrder object
	        };_this4.newOrder = order;
	        // console.log('state.IsCarOwnerPortalAccess', this.state.IsCarOwnerPortalAccess, 'BodyShopdata.IsCarOwnerPortalAccess', order.BodyShopData.IsCarOwnerPortalAccess)
	
	        if (_this4.state.EnableCarOwnerPortal && order.BodyShopData.IsCarOwnerPortalAccess && _this4.state.CarOwnerMail === '' && _this4.state.CarOwnerPhone === '') {
	          // display enable car owner portal modal
	          _this4.props.modal.isLoading(false);
	          _this4.setState({
	            ShowCarOwnerPortalModal: true,
	            isLoading: false
	          });
	        } else {
	          _this4.createNewOrder(order);
	        }
	      });
	    }
	
	    // Create new order function
	
	  }, {
	    key: 'createNewOrder',
	    value: function createNewOrder(order) {
	      var _this5 = this;
	
	      this.props.createOrder(order).then(function (res) {
	        _this5.props.modal.isLoading(false);
	        _this5.props.uploadImageMarkings(_this5.state.images);
	        if (_this5.state.OrderType === '5' && res.data.PreviousOrders.length > 0) {
	          _this5.setState({
	            isLoading: false,
	            orderdata: res.data
	          }, function () {
	            return _this5.props.updateModal({ tabView: 'complaint' });
	          });
	        } else {
	          // Toastr
	          // window.toastr.success(translation('13439'), translation('13424'))
	          _this5.props.onDraftCreated && _this5.props.onDraftCreated(res.data.OrderId);
	          _this5.props.redirectToOrder(res.data.OrderId);
	        }
	      }).catch(function (err) {
	        _this5.props.modal.isLoading(false);
	        _this5.setErrors({ isLoading: false });
	        // Toastr
	        if (err.response.data.DictionaryKey !== undefined) {
	          window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	        } else if (err.response.data.Errors !== undefined) {
	          // Toastr
	          var errorText = '';
	          var errors = err.response.data.Errors;
	          for (var i = 0; i < errors.length; i++) {
	            if (errors[i].StatusCode === 4) {
	              _this5.setState({ Estimation: '1' });
	            }
	            errorText += '<br />' + (0, _helpers.translation)(errors[i].DictionaryKey);
	          }
	          window.toastr.error(errorText, (0, _helpers.translation)('216'));
	        }
	      });
	    }
	
	    // add car owner info from the modal and create order
	
	  }, {
	    key: 'addCarOwnerInformation',
	    value: function addCarOwnerInformation(phone, mail) {
	      var _this6 = this;
	
	      this.setState({
	        ShowCarOwnerPortalModal: false
	      }, function () {
	        _this6.newOrder.BodyShopData.CarOwnerPhone = phone;
	        _this6.newOrder.BodyShopData.CarOwnerMail = mail;
	        _this6.props.modal.isLoading(true);
	        _this6.createNewOrder(_this6.newOrder);
	      });
	    }
	
	    // close car owner modal and create order
	
	  }, {
	    key: 'onCloseCarOwnerMadal',
	    value: function onCloseCarOwnerMadal() {
	      this.props.modal.isLoading(true);
	      this.createNewOrder(this.newOrder);
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _this7 = this;
	
	      var _e$target = e.target,
	          name = _e$target.name,
	          type = _e$target.type,
	          checked = _e$target.checked;
	      var value = e.target.value;
	
	      if (type === 'checkbox' && !checked) value = '0';
	      if (name === 'CustomerId') value = parseInt(value);
	      if (name === 'BodyShopLeadTime') {
	        value = parseInt(value);
	        if (isNaN(value)) {
	          value = '';
	        }
	        if (value === '' || value < 1 || value > 99) {
	          window.toastr.error((0, _helpers.translation)(18340), (0, _helpers.translation)('216'));
	        }
	      }
	
	      this.setState(_defineProperty({}, name, value));
	      // Retrieve info
	      if ((name === 'PickupAltLocationChecked' || name === 'DeliveryAltLocationChecked') && (!this.state.customerClients || this.state.customerClients.length === 0)) {
	        var id = (0, _auth.hasAccess)([4], this.props.auth.user.UserType) && this.props.auth.user.CustomerId > 0 ? this.props.auth.user.CustomerId : this.props.auth.user.ShopId;
	        this.props.getAddressses(id).then(function (res) {
	          _this7.setState({
	            customerClients: res.data
	          });
	        });
	      }
	    }
	  }, {
	    key: 'onTimeSpanBlur',
	    value: function onTimeSpanBlur(e) {
	      if (e.target.currentFormat === -1 && this.state.EstimatedProcessTime) {
	        // (-1 = invalid format)
	        window.toastr.error((0, _helpers.translation)(16837), (0, _helpers.translation)('216'));
	        this.setState({ estimatedProcessTimeValid: false });
	      } else {
	        this.setState({
	          EstimatedProcessTimeCalculated: e.target.value,
	          estimatedProcessTimeValid: true
	        });
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(data, cb) {
	      this.setState(data, cb);
	    }
	  }, {
	    key: 'renderAltLocation',
	    value: function renderAltLocation(titleKey, commentTitleKey, type) {
	      var base = type + 'AltLocation';
	      var checkedName = base + 'Checked';
	      var idName = base + 'Id';
	      var commentName = base + '_comment';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_check2.default, { spacing: 1, labelText: (0, _helpers.translation)(titleKey), id: checkedName, name: checkedName, value: '1', onChange: this.onInputChange, checked: this.state[checkedName] !== '0' }),
	        this.state[checkedName] === '1' && _react2.default.createElement(
	          'div',
	          { className: 'pg-mb-1' },
	          _react2.default.createElement(
	            _dropDown2.default,
	            { name: idName, value: this.state[idName], onChange: this.onInputChange },
	            _react2.default.createElement(
	              'option',
	              { value: '0' },
	              (0, _helpers.translation)('227')
	            ),
	            this.state.customerClients !== undefined && this.state.customerClients.map(function (val, index) {
	              return _react2.default.createElement(
	                'option',
	                { value: val.CustomerClientId, key: index },
	                (0, _helpers.translation)(val.Name)
	              );
	            })
	          )
	        ),
	        this.state[checkedName] === '1' && _react2.default.createElement(_textarea2.default, { labelText: (0, _helpers.translation)(commentTitleKey), name: commentName, onChange: this.onInputChange, value: this.state[commentName] })
	      );
	    }
	  }, {
	    key: 'renderInsuranceCompany',
	    value: function renderInsuranceCompany() {
	      var _this8 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	
	      var renderOptions = function renderOptions() {
	        if (_this8.state.InsuranceCompanies.length > 0) {
	          var insuranceCompaniesRanked = [];
	          var rankedList = [];
	          rankedList.push({ value: 0, label: (0, _helpers.translation)('14863') });
	
	          var renderOptGroup = function renderOptGroup(company, index) {
	            return { value: company.InsuranceCompanyId, label: company.Company };
	          };
	
	          if (_this8.state.MostUsedInsuranceCompanies.length > 0) {
	            insuranceCompaniesRanked = _this8.state.MostUsedInsuranceCompanies.map(renderOptGroup);
	            rankedList.push({
	              label: (0, _helpers.translation)('16301'),
	              options: insuranceCompaniesRanked
	            });
	          }
	          var insuranceCompanies = _this8.state.InsuranceCompanies.map(renderOptGroup);
	
	          rankedList.push({
	            label: (0, _helpers.translation)('13044'),
	            options: insuranceCompanies
	          });
	
	          return rankedList;
	        }
	        return [];
	      };
	
	      var InsuranceCompanyId = this.state.InsuranceCompanyId;
	
	
	      return this.state.InsuranceCompanies !== undefined && _react2.default.createElement(_dropDown2.default, {
	        isGrouping: true,
	        labelText: (0, _helpers.translation)('418'),
	        name: 'InsuranceCompanyId',
	        value: InsuranceCompanyId,
	        onChange: this.onInputChange,
	        options: renderOptions()
	      });
	    }
	  }, {
	    key: 'renderBodyShopLeadTime',
	    value: function renderBodyShopLeadTime() {
	      var _this9 = this;
	
	      var name = 'BodyShopLeadTime';
	      var onBlur = function onBlur() {
	        var bodyShopLeadTime = _this9.state.BodyShopLeadTime;
	        var inValidbodyShopLeadTime = bodyShopLeadTime === '' || bodyShopLeadTime < 1 || bodyShopLeadTime > 99 || isNaN(bodyShopLeadTime);
	        if (inValidbodyShopLeadTime) {
	          _this9.setState({ BodyShopLeadTime: _this9.props.bodyShopDefaultLeadTime });
	        }
	      };
	
	      return _react2.default.createElement(_text2.default, { key: name, labelText: (0, _helpers.translation)(18341), type: 'text', name: name, value: this.state[name], onChange: this.onInputChange, onBlur: onBlur, autoComplete: 'off' });
	    }
	  }, {
	    key: 'renderCarInfo',
	    value: function renderCarInfo() {
	      var _this10 = this;
	
	      if (!(0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) return null;
	      var renderField = function renderField(titleKey, name) {
	        return _react2.default.createElement(_text2.default, { key: name, labelText: (0, _helpers.translation)(titleKey), type: 'text', name: name, value: _this10.state[name], onChange: _this10.onInputChange, autoComplete: 'off' });
	      };
	
	      return [renderField('16776', 'CarOwnerName'), renderField('16777', 'CarOwnerLastName'), renderField('14762', 'CarOwnerPhone'), renderField('14763', 'CarOwnerMail'), this.renderCarOwnerPortalAccess(), this.renderEnableCarOwnerPortalModal()];
	    }
	  }, {
	    key: 'renderCarOwnerPortalAccess',
	    value: function renderCarOwnerPortalAccess() {
	      if (!this.state.EnableCarOwnerPortal) return null;
	      return _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('18158'), id: 'isCarOwnerPortalAccess', name: 'IsCarOwnerPortalAccess', value: '1', onChange: this.onInputChange, checked: this.state.IsCarOwnerPortalAccess !== '0' });
	    }
	  }, {
	    key: 'renderEnableCarOwnerPortalModal',
	    value: function renderEnableCarOwnerPortalModal() {
	      if (!this.state.EnableCarOwnerPortal) return null;
	      return _react2.default.createElement(_EnableCarOwnerPortalModal2.default, {
	        router: this.props.router,
	        orderId: this.state.NewOrderId,
	        show: this.state.ShowCarOwnerPortalModal,
	        phone: this.state.CarOwnerPhone,
	        addCarOwnerInformation: this.addCarOwnerInformation,
	        onCloseCarOwnerMadal: this.onCloseCarOwnerMadal });
	    }
	  }, {
	    key: 'renderCarRental',
	    value: function renderCarRental() {
	      return _react2.default.createElement(_check2.default, { labelText: (0, _helpers.translation)('629'), id: 'carRentalChecked', name: 'CarRentalChecked', value: '1', onChange: this.onInputChange, checked: this.state.CarRentalChecked !== '0' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var defaultProps = {
	        updateState: this.updateState,
	        onInputChange: this.onInputChange,
	        updateModal: this.props.updateModal
	      };
	
	      switch (this.props.tabView) {
	        case 'image':
	          return _react2.default.createElement(_MarkImage2.default, _extends({ currentImg: this.state.activeImage, images: this.state.images }, defaultProps));
	        case 'complaint':
	          return _react2.default.createElement(_Complaint2.default, _extends({
	            listingID: this.state.listingID,
	            orderdata: this.state.orderdata,
	            setErrors: this.setErrors,
	            redirectToOrder: this.props.redirectToOrder,
	            onModalClose: this.props.onModalClose
	          }, defaultProps, {
	            bodyShop: true
	          }));
	        case 'draft':
	          return _react2.default.createElement(
	            'form',
	            { className: 'addOrderPopup clearfix', ref: 'addorderpopup' },
	            _react2.default.createElement(_Forsi2.default, { redirectToOrder: this.props.redirectToOrder }),
	            _react2.default.createElement(_RegistrationNumber2.default, _extends({ regNr: this.state.RegNumber }, defaultProps)),
	            _react2.default.createElement(_Brand2.default, _extends({ selected: this.state.BrandOriginal }, defaultProps)),
	            _react2.default.createElement(_ChassisNumber2.default, _extends({ chassisNumber: this.state.ChassisNumber }, defaultProps)),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.renderAltLocation('14764', '14769', 'Pickup'),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 20) && this.renderAltLocation('14765', '14770', 'Delivery'),
	            _react2.default.createElement(_divider2.default, null),
	            this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(_Customer2.default, _extends({ selected: this.state.CustomerId }, defaultProps, { bodyShop: true })),
	            _react2.default.createElement('div', { className: 'empty_space clearfix' }),
	            this.renderInsuranceCompany(),
	            _react2.default.createElement('div', { className: 'empty_space clearfix' }),
	            this.renderCarInfo(),
	            _react2.default.createElement('div', { className: 'empty_space clearfix' }),
	            _react2.default.createElement(_timeSpan2.default, { name: 'EstimatedProcessTime', value: this.state.EstimatedProcessTime || '', labelText: 16835, onBlur: this.onTimeSpanBlur, onChange: this.onInputChange }),
	            this.renderBodyShopLeadTime(),
	            this.renderCarRental(),
	            _react2.default.createElement(_OrderTypes2.default, _extends({ selected: this.state.OrderType }, defaultProps, { bodyShop: true })),
	            _react2.default.createElement(_divider2.default, null),
	            _react2.default.createElement(
	              'div',
	              null,
	              ((0, _auth.hasSubscriptionPermission)(this.props.auth, 10) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && _react2.default.createElement(_FileArea2.default, _extends({
	                fileContainerId: this.state.fileContainerId,
	                files: this.state.files,
	                images: this.state.images,
	                setErrors: this.setErrors
	              }, defaultProps)),
	              ((0, _auth.hasSubscriptionPermission)(this.props.auth, 30, 25) || (0, _auth.hasPartnerSubscriptionPermission)(this.props.auth, 10)) && this.props.hasPaintPartner && _react2.default.createElement(_Estimation2.default, _extends({
	                evaluationAllowed: this.state.evaluationAllowed,
	                showComment: this.state.Estimation === '1',
	                comment: this.state.Estimation_comment
	              }, defaultProps))
	            )
	          );
	      }
	    }
	  }]);
	
	  return NewBodyDraft;
	}(_react.Component);
	
	NewBodyDraft.propTypes = {
	  tabView: _propTypes2.default.string.isRequired,
	  uploadImageMarkings: _propTypes2.default.func.isRequired,
	  redirectToOrder: _propTypes2.default.func.isRequired,
	  updateModal: _propTypes2.default.func.isRequired,
	  modal: _propTypes2.default.object.isRequired,
	  onModalClose: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers,
	    allowNoCustomer: state.auth.allowNoCustomer,
	    hasPaintPartner: state.common.hasPaintPartner,
	    bodyShopDefaultLeadTime: state.common.bodyShopDefaultLeadTime
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createOrder: _orders.createOrder,
	  getOrderVehicleData: _orders.getOrderVehicleData,
	  getAddressses: _address.getAddressses,
	  getInsuranceCompanies: _insurancecompanies.getInsuranceCompanies,
	  getCarOwnerPortalInformation: _settings.getCarOwnerPortalInformation
	})(NewBodyDraft);

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(77);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Forsi = __webpack_require__(465);
	
	var _Forsi2 = _interopRequireDefault(_Forsi);
	
	var _Customer = __webpack_require__(462);
	
	var _Customer2 = _interopRequireDefault(_Customer);
	
	var _RegistrationNumber = __webpack_require__(468);
	
	var _RegistrationNumber2 = _interopRequireDefault(_RegistrationNumber);
	
	var _OrderTypes = __webpack_require__(467);
	
	var _OrderTypes2 = _interopRequireDefault(_OrderTypes);
	
	var _Brand = __webpack_require__(459);
	
	var _Brand2 = _interopRequireDefault(_Brand);
	
	var _ChassisNumber = __webpack_require__(460);
	
	var _ChassisNumber2 = _interopRequireDefault(_ChassisNumber);
	
	var _FileArea = __webpack_require__(464);
	
	var _FileArea2 = _interopRequireDefault(_FileArea);
	
	var _Estimation = __webpack_require__(463);
	
	var _Estimation2 = _interopRequireDefault(_Estimation);
	
	var _MarkImage = __webpack_require__(466);
	
	var _MarkImage2 = _interopRequireDefault(_MarkImage);
	
	var _Complaint = __webpack_require__(461);
	
	var _Complaint2 = _interopRequireDefault(_Complaint);
	
	var _orders = __webpack_require__(21);
	
	var _helpers = __webpack_require__(2);
	
	var _auth = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Actions
	
	
	// Utils
	
	
	var NewPaintDraft = function (_Component) {
	  _inherits(NewPaintDraft, _Component);
	
	  function NewPaintDraft(props) {
	    _classCallCheck(this, NewPaintDraft);
	
	    var _this = _possibleConstructorReturn(this, (NewPaintDraft.__proto__ || Object.getPrototypeOf(NewPaintDraft)).call(this, props));
	
	    _this.state = {
	      InsuranceCompanies: [],
	
	      isLoading: false,
	
	      CustomerId: 0,
	
	      RegNumber: '',
	      ChassisNumber: '',
	      BrandOriginal: '', // brandname,
	      ExtraData: {},
	
	      OrderType: '0',
	
	      fileContainerId: null,
	      images: [],
	      files: [],
	      activeImage: {},
	
	      evaluationAllowed: true,
	      Estimation: '0',
	      Estimation_comment: '',
	
	      orderdata: {},
	      listingID: '0'
	    };
	
	    _this.submitOrder = _this.submitOrder.bind(_this);
	    _this.createOrder = _this.createOrder.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.updateState = _this.updateState.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewPaintDraft, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.updateModal({
	        bottomBarProps: {
	          actionLabelText: (0, _helpers.translation)('21'),
	          onActionClick: this.submitOrder
	        }
	      });
	
	      var ownShopCustomer = this.props.customers.find(function (cust) {
	        return cust.IsOwnShop === true;
	      });
	      if (ownShopCustomer !== undefined) {
	        this.setState({
	          CustomerId: ownShopCustomer.CustomerId
	        });
	      }
	    }
	  }, {
	    key: 'setErrors',
	    value: function setErrors(errors) {
	      this.setState(errors);
	      var el = _reactDom2.default.findDOMNode(this.refs.addorderpopup).parentNode;
	      el.scrollTop = 0;
	    }
	  }, {
	    key: 'submitOrder',
	    value: function submitOrder(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      this.setState({ isLoading: true, error: '' });
	
	      // If user filled in regnumber, but chassis is empty, try to look up data before continuing.
	      if (this.state.RegNumber !== null && this.state.RegNumber !== '' && (this.state.ChassisNumber === null || this.state.ChassisNumber === '') && (0, _auth.hasSubscriptionPermission)(this.props.auth, 10)) {
	        this.setState({ ExtraData: {} });
	
	        this.props.getOrderVehicleData(this.state.RegNumber, 'RegNumber').then(function (res) {
	          if (res.data.BrandOriginal !== null) {
	            _this2.setState({
	              ChassisNumber: res.data.ChassisNumber,
	              BrandOriginal: res.data.BrandName,
	              ExtraData: res.data
	            }, function () {
	              _this2.createOrder();
	            });
	          }
	        }, function () {});
	        this.createOrder();
	      } else {
	        this.createOrder();
	      }
	    }
	  }, {
	    key: 'createOrder',
	    value: function createOrder() {
	      var _this3 = this;
	
	      if (this.state.isLoading) return;
	
	      var customerId = 0;
	      if (this.props.auth.user.CustomerId === '-1') {
	        customerId = parseInt(this.state.CustomerId);
	      } else {
	        customerId = parseInt(this.props.auth.user.CustomerId);
	      }
	
	      // VALIDATION START
	      var errors = [];
	
	      if (customerId === 0) {
	        errors.push((0, _helpers.translation)('1736')); // please select customer
	      }
	
	      if (this.state.OrderType === '0') {
	        errors.push((0, _helpers.translation)('13454')); // please select order type
	      }
	
	      if (errors.length > 0) {
	        this.setErrors({
	          isLoading: false
	        });
	        // Toastr
	        var errorText = '';
	        for (var i = 0; i < errors.length; i++) {
	          errorText += '<br />' + errors[i];
	        }
	        window.toastr.error(errorText, (0, _helpers.translation)('216'));
	        return false;
	      }
	      // VALIDATION END
	
	      // IsEvaluation
	      var IsEvaluation = false;
	      if (this.state.Estimation !== '0' && this.state.evaluationAllowed) {
	        IsEvaluation = true;
	      }
	
	      // Evaluation comment
	      var evaluationComment = '';
	      if (IsEvaluation) {
	        evaluationComment = this.state.Estimation_comment;
	      }
	
	      // Files
	      var files = [];
	      if (this.state.images.length !== 0 || this.state.files.length !== 0) {
	        files = [].concat(_toConsumableArray(this.state.images), _toConsumableArray(this.state.files));
	      }
	
	      // Brand
	      var BrandName = this.state.ExtraData.BrandName;
	      if (!BrandName) BrandName = this.state.BrandOriginal;
	
	      this.props.modal.isLoading(true);
	
	      this.setState({ isLoading: true }, function () {
	        _this3.props.createOrder({
	          RegNr: _this3.state.RegNumber,
	          ChassisNumber: _this3.state.ChassisNumber,
	          OrderType: _this3.state.OrderType,
	          BrandOriginal: _this3.state.ExtraData.BrandOriginal,
	          Model: _this3.state.ExtraData.Model,
	          BrandName: BrandName,
	          BrandCode: _this3.state.ExtraData.BrandCode,
	          RegistrationDate: _this3.state.ExtraData.RegistrationDate,
	          CustomerId: parseInt(customerId),
	          IsEvaluation: IsEvaluation,
	          Case: {
	            Comment: evaluationComment
	          },
	          ImageTypes: files,
	          FileContainerId: _this3.state.fileContainerId
	        }).then(function (res) {
	          _this3.props.modal.isLoading(false);
	
	          _this3.props.uploadImageMarkings(_this3.state.images);
	
	          if (_this3.state.OrderType === '5' && res.data.PreviousOrders.length > 0) {
	            _this3.setState({
	              isLoading: false,
	              orderdata: res.data
	            }, function () {
	              return _this3.props.updateModal({ tabView: 'complaint' });
	            });
	          } else {
	            // Toastr
	            // window.toastr.success(translation('13439'), translation('13424'))
	
	            _this3.props.redirectToOrder(res.data.OrderId);
	          }
	        }, function (err) {
	          _this3.props.modal.isLoading(false);
	          _this3.setErrors({
	            isLoading: false
	          });
	
	          // Toastr
	          if (err.response.data.DictionaryKey !== undefined) {
	            window.toastr.error((0, _helpers.translation)(err.response.data.DictionaryKey), (0, _helpers.translation)('216'));
	          } else if (err.response.data.Errors !== undefined) {
	            // Toastr
	            var _errorText = '';
	            var _errors = err.response.data.Errors;
	            for (var _i = 0; _i < _errors.length; _i++) {
	              if (_errors[_i].StatusCode === 4) {
	                _this3.setState({
	                  Estimation: '1'
	                });
	              }
	              _errorText += '<br />' + (0, _helpers.translation)(_errors[_i].DictionaryKey);
	            }
	            window.toastr.error(_errorText, (0, _helpers.translation)('216'));
	          }
	        });
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var _e$target = e.target,
	          name = _e$target.name,
	          type = _e$target.type,
	          checked = _e$target.checked;
	      var value = e.target.value;
	
	
	      if (type === 'checkbox') {
	        if (!checked) {
	          value = '0';
	        }
	      }
	      // This prevents Paint Shop to book order with Apromas workshop customer
	      if (e.target.name === 'CustomerId') {
	        var customer = this.props.customers.filter(function (c) {
	          return c.CustomerId === parseInt(e.target.value);
	        });
	        if (customer.length > 0 && customer[0].IsApromasWorkshop) {
	          window.toastr.error((0, _helpers.translation)('15329'), (0, _helpers.translation)('216'));
	          value = '0';
	        }
	      }
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(data, cb) {
	      this.setState(data, cb);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var defaultProps = {
	        updateState: this.updateState,
	        onInputChange: this.onInputChange,
	        updateModal: this.props.updateModal
	      };
	
	      switch (this.props.tabView) {
	        case 'image':
	          return _react2.default.createElement(_MarkImage2.default, _extends({ currentImg: this.state.activeImage, images: this.state.images }, defaultProps));
	        case 'complaint':
	          return _react2.default.createElement(_Complaint2.default, _extends({
	            listingID: this.state.listingID,
	            orderdata: this.state.orderdata,
	            setErrors: this.setErrors,
	            redirectToOrder: this.props.redirectToOrder,
	            onModalClose: this.props.onModalClose
	          }, defaultProps));
	        case 'draft':
	          return _react2.default.createElement(
	            'form',
	            { className: 'addOrderPopup clearfix', ref: 'addorderpopup' },
	            _react2.default.createElement(_Forsi2.default, { redirectToOrder: this.props.redirectToOrder }),
	            this.props.auth.user.CustomerId === '-1' && _react2.default.createElement(_Customer2.default, _extends({ selected: parseInt(this.state.CustomerId) }, defaultProps)),
	            _react2.default.createElement(_RegistrationNumber2.default, _extends({ regNr: this.state.RegNumber }, defaultProps)),
	            _react2.default.createElement(_OrderTypes2.default, _extends({ selected: this.state.OrderType }, defaultProps)),
	            _react2.default.createElement(_Brand2.default, _extends({ selected: this.state.BrandOriginal }, defaultProps)),
	            _react2.default.createElement(_ChassisNumber2.default, _extends({ chassisNumber: this.state.ChassisNumber }, defaultProps)),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 10) && _react2.default.createElement(_FileArea2.default, _extends({
	              fileContainerId: this.state.fileContainerId,
	              files: this.state.files,
	              images: this.state.images,
	              setErrors: this.setErrors
	            }, defaultProps)),
	            (0, _auth.hasSubscriptionPermission)(this.props.auth, 30, 25) && _react2.default.createElement(_Estimation2.default, _extends({
	              evaluationAllowed: this.state.evaluationAllowed,
	              showComment: this.state.Estimation === '1',
	              comment: this.state.Estimation_comment
	            }, defaultProps))
	          );
	      }
	    }
	  }]);
	
	  return NewPaintDraft;
	}(_react.Component);
	
	NewPaintDraft.propTypes = {
	  tabView: _propTypes2.default.string.isRequired,
	  uploadImageMarkings: _propTypes2.default.func.isRequired,
	  redirectToOrder: _propTypes2.default.func.isRequired,
	  updateModal: _propTypes2.default.func.isRequired,
	  modal: _propTypes2.default.object.isRequired,
	  onModalClose: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createOrder: _orders.createOrder,
	  getOrderVehicleData: _orders.getOrderVehicleData
	})(NewPaintDraft);

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1655);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _auth = __webpack_require__(8);
	
	var _priceModel = __webpack_require__(75);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var NewPriceModal = function (_Component) {
	  _inherits(NewPriceModal, _Component);
	
	  function NewPriceModal(props) {
	    _classCallCheck(this, NewPriceModal);
	
	    var _this = _possibleConstructorReturn(this, (NewPriceModal.__proto__ || Object.getPrototypeOf(NewPriceModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      selectedPriceModelId: 0,
	      PriceModels: [{
	        Id: 0,
	        PriceType: -1,
	        Name: 'New',
	        IsCustomer: false,
	        IsShop: false,
	        IsChain: false
	      }]
	    };
	    _this.renderForm = _this.renderForm.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewPriceModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPriceListimports();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // this.getPriceListimports()
	    }
	  }, {
	    key: 'addNew',
	    value: function addNew(data) {
	      if (data === 0 || data === 1) {
	        data = {
	          Name: 'New',
	          PriceModelId: 0,
	          PriceType: -1,
	          Department: data
	        };
	      }
	      this.props.onCreate(data);
	      this.props.onClose();
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      var _this2 = this;
	
	      var PriceModels = [].concat(_toConsumableArray(this.state.PriceModels));
	      var PriceModelsGrouped = {
	        0: {
	          name: '2029',
	          items: []
	        },
	        1: {
	          name: '700',
	          items: []
	        },
	        2: {
	          name: '58',
	          items: []
	        },
	        3: {
	          name: '2030',
	          items: []
	        }
	        // console.log('PriceModels ', PriceModels)
	        // console.log('IsCustomer ', this.props.customer)
	      };var renderPriceModelList = function renderPriceModelList() {
	        PriceModels.map(function (val) {
	          var added = false;
	          if (val.IsChain && (0, _auth.hasSubscriptionPermission)(_this2.props.auth, 10, 0)) {
	            added = true;
	            PriceModelsGrouped[0].items.push(val);
	          } else {
	            // Make sure the skipped pricemodels are not grouped under "Other"
	            added = true;
	          }
	          if (val.IsShop) {
	            added = true;
	            PriceModelsGrouped[1].items.push(val);
	          }
	          if (val.IsCustomer) {
	            added = true;
	            PriceModelsGrouped[2].items.push(val);
	          }
	          if (!added) {
	            PriceModelsGrouped[3].items.push(val);
	          }
	        });
	        // console.log(PriceModelsGrouped[3])
	
	        var renderPriceModelItem = function renderPriceModelItem(val, key) {
	          // let src = '/images/svgs/bodyshop-steps/Coating-White.svg'
	          // if (val.Department === 1) src = '/images/svgs/bodyshop-steps/bodywork-2-white.svg'
	          // {/* <img src={src} width='20' height='20' /> */}
	          return _react2.default.createElement(_button2.default, { key: key, style: 'link', onClick: _this2.addNew.bind(_this2, val), labelText: val.Name });
	        };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'ul',
	            null,
	            Object.keys(PriceModelsGrouped).map(function (key) {
	              var group = PriceModelsGrouped[key];
	              if (group.items.length === 0) return null;
	              return _react2.default.createElement(
	                _labelWrapper2.default,
	                { key: key, labelText: (0, _helpers.translation)(group.name) },
	                group.items.map(renderPriceModelItem)
	              );
	            })
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderPriceModelList()
	      );
	    }
	  }, {
	    key: 'getBottomBarProps',
	    value: function getBottomBarProps() {
	      if (this.props.customer === true) return null;
	
	      var departmentType = this.props.auth.departmentType;
	      switch (departmentType) {
	        case 2:
	          return {
	            actionStyle: 'link',
	            actionLabelText: (0, _helpers.translation)('14875'),
	            onActionClick: this.addNew.bind(this, 0),
	            cancelStyle: 'link',
	            cancelLabelText: (0, _helpers.translation)('14874'),
	            onCancelClick: this.addNew.bind(this, 1)
	          };
	        case 1:
	        case 0:
	          var text = (0, _helpers.translation)('14875');
	          if (departmentType === 1) {
	            text = (0, _helpers.translation)('14874');
	          }
	
	          return {
	            actionLabelText: text,
	            onActionClick: this.addNew.bind(this, departmentType)
	          };
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'getPriceListimports',
	    value: function getPriceListimports() {
	      var _this3 = this;
	
	      if ((0, _auth.hasAccess)([6], this.props.auth.user.UserType)) return null;
	      var customerId = 0;
	      if (this.props.activeCustomerId !== undefined) {
	        customerId = this.props.activeCustomerId;
	      }
	
	      this.props.getPriceListimports(customerId).then(function (res) {
	        _this3.setState({
	          PriceModels: res.data
	        });
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'newprice_modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('1306'),
	            overflowHidden: this.state.overflowHidden,
	            icon: _icons.ModalIcons.Plus,
	            bottomBarProps: this.getBottomBarProps()
	          }),
	          this.renderForm()
	        )
	      );
	    }
	  }]);
	
	  return NewPriceModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPriceListimports: _priceModel.getPriceListimports
	})(NewPriceModal);

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1656);
	
	var _helpers = __webpack_require__(2);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Datetime from 'react-datetime'
	
	// import actions
	// import { getEmployeePunchTimes } from './../../../actions/punchclock'
	
	// import styles
	
	
	// Utils
	// import { renderFullDate } from '../../../utils/time'
	
	
	// import components
	
	
	// Elements
	
	
	var NewPunchModal = function (_Component) {
	  _inherits(NewPunchModal, _Component);
	
	  function NewPunchModal(props) {
	    _classCallCheck(this, NewPunchModal);
	
	    var _this = _possibleConstructorReturn(this, (NewPunchModal.__proto__ || Object.getPrototypeOf(NewPunchModal)).call(this, props));
	
	    _this.state = {
	      show: false,
	      selDate: '',
	      selIn: '00:00',
	      selOut: '00:00',
	      selAwayType: null
	    };
	    _this.saveEntry = _this.saveEntry.bind(_this);
	    _this.renderContent = _this.renderContent.bind(_this);
	    _this.setHourMin = _this.setHourMin.bind(_this);
	    // this.onInputChange = this.onInputChange.bind(this)
	    return _this;
	  }
	
	  _createClass(NewPunchModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (props.show !== this.state.show) {
	        this.setState({
	          show: props.show
	        });
	      }
	    }
	  }, {
	    key: 'saveEntry',
	    value: function saveEntry(e) {
	      e.preventDefault();
	      if (this.state.selDate === null || this.state.selDate === '') return;
	      var entry = {
	        PunchClockStatId: 0,
	        PunchIn: null,
	        PunchOut: null,
	        AwayDate: null,
	        ModifiedByAdmin: false,
	        CheckVacation: false,
	        CheckSick: false,
	        CheckSickChild: false,
	        CheckPaidAbsence: false,
	        CheckUnPaidAbsence: false
	      };
	
	      var datePart = this.state.selDate.format('YYYY-MM-DD');
	      var timePart = this.state.selDate.format('HH:mm:ss');
	
	      if (this.state.selAwayType !== null) {
	        entry.AwayDate = datePart + ' ' + timePart;
	        entry.PunchIn = null;
	        entry.PunchOut = null;
	        switch (this.state.selAwayType) {
	          case 0:
	            entry.CheckVacation = true;
	            break;
	          case 1:
	            entry.CheckSick = true;
	            break;
	          case 2:
	            entry.CheckSickChild = true;
	            break;
	          case 3:
	            entry.CheckPaidAbsence = true;
	            break;
	          case 4:
	            entry.CheckUnPaidAbsence = true;
	            break;
	        }
	      } else {
	        entry.AwayDate = null;
	        entry.PunchIn = this.setHourMin(datePart + ' ' + timePart, this.state.selIn);
	        entry.PunchOut = this.setHourMin(datePart + ' ' + timePart, this.state.selOut);
	      }
	
	      console.log('Create entry: ', entry);
	      this.props.saveNewEntry(entry);
	    }
	  }, {
	    key: 'setHourMin',
	    value: function setHourMin(dateTime, hhmm) {
	      // Format is 2017-04-02T10:41:16
	      if (hhmm !== null && hhmm.length === 4) {
	        if (hhmm.indexOf(':') === -1) {
	          hhmm = hhmm.substring(0, 2) + ':' + hhmm.substring(2, 4);
	        } else if (hhmm.indexOf(':') === 1) {
	          hhmm = '0' + hhmm;
	        }
	      }
	      if (dateTime === null) return hhmm;
	      return dateTime.substring(0, 11) + hhmm;
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var onDateChange = function onDateChange(e) {
	        _this2.setState({
	          selDate: e
	        });
	      };
	
	      var onChangeTime = function onChangeTime(e) {
	        var value = e.target.value;
	        var punchIn = _this2.state.selIn;
	        var punchOut = _this2.state.selOut;
	        if (value === '') value = null;
	        if (e.target.name === 'punchIn') {
	          punchIn = _this2.setHourMin(null, value);
	        } else if (e.target.name === 'punchOut') {
	          punchOut = _this2.setHourMin(null, value);
	        }
	        _this2.setState({
	          selIn: punchIn,
	          selOut: punchOut
	        }, function () {
	          console.log('state', _this2.state);
	        });
	      };
	
	      var onChangeAwayType = function onChangeAwayType(e) {
	        // e.preventDefault()
	        console.log(e.target, e.target.checked);
	        var value = parseInt(e.target.value);
	        var checked = e.target.checked;
	        if (!checked) value = null;
	        _this2.setState({
	          selAwayType: value
	        }, function () {
	          console.log('state', _this2.state);
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_datetime2.default, {
	          inputProps: {
	            name: 'date',
	            readOnly: true,
	            placeholder: (0, _helpers.translation)('1728')
	          },
	          dateFormat: 'DD-MM-YYYY',
	          timeFormat: false,
	          closeOnSelect: true,
	          value: this.state.selDate,
	          onChange: onDateChange,
	          labelText: (0, _helpers.translation)('388') }),
	        _react2.default.createElement(
	          _inline2.default,
	          { block: true },
	          _react2.default.createElement(_text2.default, { name: 'punchIn', value: this.state.selIn, onChange: onChangeTime, maxLength: '5', labelText: (0, _helpers.translation)('438') }),
	          _react2.default.createElement(_text2.default, { name: 'punchOut', value: this.state.selOut, onChange: onChangeTime, maxLength: '5', labelText: (0, _helpers.translation)('439') })
	        ),
	        _react2.default.createElement(_check2.default, { id: 'away_0', name: 'away_0', value: '0', onChange: onChangeAwayType, checked: this.state.selAwayType === 0, labelText: (0, _helpers.translation)('500') }),
	        _react2.default.createElement(_check2.default, { id: 'away_1', name: 'away_1', value: '1', onChange: onChangeAwayType, checked: this.state.selAwayType === 1, labelText: (0, _helpers.translation)('508') }),
	        _react2.default.createElement(_check2.default, { id: 'away_2', name: 'away_2', value: '2', onChange: onChangeAwayType, checked: this.state.selAwayType === 2, labelText: (0, _helpers.translation)('502') }),
	        _react2.default.createElement(_check2.default, { id: 'away_3', name: 'away_3', value: '3', onChange: onChangeAwayType, checked: this.state.selAwayType === 3, labelText: (0, _helpers.translation)('1436') }),
	        _react2.default.createElement(_check2.default, { id: 'away_4', name: 'away_4', value: '4', onChange: onChangeAwayType, checked: this.state.selAwayType === 4, labelText: (0, _helpers.translation)('1435') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalTitle = (0, _helpers.translation)('2210');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'newpunch__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: modalTitle,
	            bottomBarProps: {
	              actionLabelText: (0, _helpers.translation)('27'),
	              onActionClick: this.saveEntry
	            }
	          }),
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	
	  return NewPunchModal;
	}(_react.Component);
	
	NewPunchModal.propTypes = {
	  saveNewEntry: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {/* getEmployeePunchTimes */})(NewPunchModal);

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1658);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Utils
	
	
	var OkModal = function (_Component) {
	  _inherits(OkModal, _Component);
	
	  function OkModal(props) {
	    _classCallCheck(this, OkModal);
	
	    var _this = _possibleConstructorReturn(this, (OkModal.__proto__ || Object.getPrototypeOf(OkModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false
	    };
	    return _this;
	  }
	
	  _createClass(OkModal, [{
	    key: 'render',
	    value: function render() {
	      var bottomBarProps = {
	        actionLabelText: (0, _helpers.translation)('956'),
	        onActionClick: this.props.onClose
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'ok__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: (0, _helpers.translation)(this.props.headerTranslation), overflowHidden: this.state.overflowHidden, bottomBarProps: bottomBarProps }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return OkModal;
	}(_react.Component);
	
	OkModal.defaultProps = {
	  headerTranslation: '534',
	  hideX: true
	};
	
	exports.default = OkModal;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _CircleImage = __webpack_require__(231);
	
	var _CircleImage2 = _interopRequireDefault(_CircleImage);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import components
	
	
	// Utils
	
	
	var PhotoMarkModal = function (_Component) {
	  _inherits(PhotoMarkModal, _Component);
	
	  function PhotoMarkModal(props) {
	    _classCallCheck(this, PhotoMarkModal);
	
	    var _this = _possibleConstructorReturn(this, (PhotoMarkModal.__proto__ || Object.getPrototypeOf(PhotoMarkModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      image: null
	    };
	    _this.submitImage = _this.submitImage.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(PhotoMarkModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var image = _extends({}, this.props.image);
	      var url = image.realURL;
	      image.image = {
	        imageUrl: url,
	        circles: []
	      };
	      this.setState({
	        image: image
	      });
	    }
	  }, {
	    key: 'submitImage',
	    value: function submitImage(image, update) {
	      var _this2 = this;
	
	      if (!update) return null;
	      var markings = [];
	      image.image.circles.map(function (circle) {
	        markings.push({
	          PositionX: circle.left,
	          PositionY: circle.top,
	          Scale: parseFloat(circle.scale.toFixed(2)),
	          Size: 50
	        });
	      });
	      var imageMarkings = [{
	        ImageSize: image.image.ImageSize,
	        OrderFileID: image.OrderFileID || image.OrderFile.OrderFileID,
	        Markings: markings
	      }];
	      if (markings.length !== 0) {
	        this.props.uploadImageMarkings(imageMarkings).then(function (res) {
	          // window.toastr.success(translation('2034'), translation('13424'))
	          _this2.onClose(true);
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('2035'), (0, _helpers.translation)('216'));
	        });
	      } else {
	        this.onClose(false);
	      }
	    }
	  }, {
	    key: 'renderimage',
	    value: function renderimage() {
	      if (this.state.image === null) return null;
	      console.log('qweasd');
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_CircleImage2.default, { submitImage: this.submitImage, image: this.state.image })
	      );
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose(update) {
	      this.props.onClose(update);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clickOutsideClose = false;
	      return _react2.default.createElement(
	        'div',
	        { className: 'photomark__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: (0, _helpers.translation)('2033'), overflowHidden: this.state.overflowHidden, clickOutsideClose: clickOutsideClose, onClose: this.onClose.bind(this, false),
	            icon: _icons.ModalIcons.Plus }),
	          this.renderimage()
	        )
	      );
	    }
	  }]);
	
	  return PhotoMarkModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  uploadImageMarkings: _orders.uploadImageMarkings
	})(PhotoMarkModal);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1661);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _auth = __webpack_require__(68);
	
	var _auth2 = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _numPad = __webpack_require__(1073);
	
	var _numPad2 = _interopRequireDefault(_numPad);
	
	var _pinCode = __webpack_require__(1075);
	
	var _pinCode2 = _interopRequireDefault(_pinCode);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Actions
	
	// utils
	
	
	// elements
	
	
	var PinCodeModal = function (_Component) {
	  _inherits(PinCodeModal, _Component);
	
	  function PinCodeModal(props) {
	    _classCallCheck(this, PinCodeModal);
	
	    var _this = _possibleConstructorReturn(this, (PinCodeModal.__proto__ || Object.getPrototypeOf(PinCodeModal)).call(this, props));
	
	    _this.state = {
	      pincode: '',
	      translationKey: '17974'
	    };
	    _this.onClick = _this.onClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PinCodeModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getKeyEvent();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.handleKeydown);
	    }
	  }, {
	    key: 'getKeyEvent',
	    value: function getKeyEvent() {
	      window.addEventListener('keydown', this.handleKeydown);
	    }
	  }, {
	    key: 'getKeyCode',
	    value: function getKeyCode(keyCode) {
	      var pincode = '';
	      switch (keyCode) {
	        case 96:
	          pincode = '0';
	          break;
	        case 97:
	          pincode = '1';
	          break;
	        case 98:
	          pincode = '2';
	          break;
	        case 99:
	          pincode = '3';
	          break;
	        case 100:
	          pincode = '4';
	          break;
	        case 101:
	          pincode = '5';
	          break;
	        case 102:
	          pincode = '6';
	          break;
	        case 103:
	          pincode = '7';
	          break;
	        case 104:
	          pincode = '8';
	          break;
	        case 105:
	          pincode = '9';
	          break;
	        case 8:
	          pincode = 'delete';
	          break;
	        default:
	          break;
	      }
	      return pincode;
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      var pincode = this.getKeyCode(e.keyCode);
	      if (pincode) {
	        this.onClick(pincode);
	      }
	    }
	  }, {
	    key: 'onLogin',
	    value: function onLogin(pinCode) {
	      var _this2 = this;
	
	      this.props.loginAs(this.props.user.UserId, 0, false, false, pinCode).then(function (res) {
	        var translationKey = res ? '18034' : '17976';
	        if (res) {
	          _this2.props.getAuthResources().then(function (res) {
	            res.data.permissions = res.data.Permissions;
	            if (typeof _this2.props.data.type !== 'undefined') {
	              switch (_this2.props.data.type) {
	                case 'inspection':
	                  if ((0, _auth2.hasSubscriptionPermission)(res.data, 10, 30)) {
	                    _this2.props.router.push('/orders/' + _this2.props.data.id + '/orderinspection');
	                  } else {
	                    _this2.props.onClose();
	                  }
	                  break;
	                case 'workcard':
	                  _this2.props.router.push('/orders/' + _this2.props.data.id);
	                  break;
	              }
	            }
	          }).finally(function () {
	            _this2.props.onClose();
	          });
	        }
	        _this2.setState({
	          translationKey: translationKey,
	          pincode: ''
	        }, function () {
	          if (res) {
	            _this2.props.onClose();
	          }
	        });
	      }, function (err) {
	        _this2.setState({
	          translationKey: err.response.data.DictionaryKey,
	          pincode: ''
	        });
	      });
	    }
	  }, {
	    key: 'getClasse',
	    value: function getClasse() {
	      var key = this.state.translationKey;
	      var className = 'pincode-label ';
	      switch (key.toString()) {
	        case '18034':
	          // approved pin
	          className += 'success';
	          break;
	        case '17976':
	          // wrong pincode
	          className += 'error';
	          break;
	      }
	      return className;
	    }
	  }, {
	    key: 'pincodeSubmit',
	    value: function pincodeSubmit(val) {
	      var _this3 = this;
	
	      var pincode = this.state.pincode;
	      if (val === 'delete') {
	        pincode = pincode.substring(0, pincode.length - 1);
	      } else {
	        pincode += val;
	      }
	      this.setState({
	        pincode: pincode
	      }, function () {
	        if (pincode.length > 3) {
	          _this3.onLogin(pincode);
	        }
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(val) {
	      this.pincodeSubmit(val);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var user = this.props.user;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pincode_modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: (0, _helpers.translation)('57'), overflowHidden: false, icon: _icons.ModalIcons.Employees_White }),
	          _react2.default.createElement(
	            'div',
	            { className: 'pincode_modal--content' },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, alignChildren: 'center' },
	              _react2.default.createElement(_icon2.default, { size: 's', icon: _icons.MainMenuIcons.Customers_Black }),
	              user.Name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getClasse() },
	              (0, _helpers.translation)(this.state.translationKey)
	            ),
	            _react2.default.createElement(_pinCode2.default, { pin: this.state.pincode }),
	            _react2.default.createElement(_numPad2.default, { onClick: this.onClick })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PinCodeModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  loginAs: _auth.loginAs,
	  getAuthResources: _auth.getAuthResources
	})(PinCodeModal);

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1664);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Elements
	
	
	// Utils
	
	
	var PrivacyPolicyModal = function (_Component) {
	  _inherits(PrivacyPolicyModal, _Component);
	
	  function PrivacyPolicyModal(props) {
	    _classCallCheck(this, PrivacyPolicyModal);
	
	    var _this = _possibleConstructorReturn(this, (PrivacyPolicyModal.__proto__ || Object.getPrototypeOf(PrivacyPolicyModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false
	    };
	    return _this;
	  }
	
	  _createClass(PrivacyPolicyModal, [{
	    key: 'getPolicyText',
	    value: function getPolicyText() {
	      return {
	        __html: (0, _helpers.translation)(16654)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'privacypolicy__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: (0, _helpers.translation)('16653') }),
	          _react2.default.createElement(_icon2.default, { icon: _icons.GeneralIcons.Print, className: 'non-printable', size: 's', onClick: function onClick() {
	              return window.print();
	            } }),
	          _react2.default.createElement(
	            _col2.default,
	            { span: '4' },
	            _react2.default.createElement('div', { className: 'text', dangerouslySetInnerHTML: this.getPolicyText() })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PrivacyPolicyModal;
	}(_react.Component);
	
	exports.default = PrivacyPolicyModal;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1665);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _punchclock = __webpack_require__(173);
	
	var _helpers = __webpack_require__(2);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// import actions
	
	
	// Util
	
	
	// Elements
	
	
	var PunchReportModal = function (_Component) {
	  _inherits(PunchReportModal, _Component);
	
	  function PunchReportModal(props) {
	    _classCallCheck(this, PunchReportModal);
	
	    var _this = _possibleConstructorReturn(this, (PunchReportModal.__proto__ || Object.getPrototypeOf(PunchReportModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      employees: []
	    };
	
	    _this.downloadPDF = _this.downloadPDF.bind(_this);
	    _this.renderSelectAll = _this.renderSelectAll.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(PunchReportModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getEmployees(this.props);
	    }
	  }, {
	    key: 'getEmployees',
	    value: function getEmployees(props) {
	      var employeeList = props.employees.filter(function (employee) {
	        return employee.Active ? employee : false;
	      });
	      var employees = [];
	      employeeList.map(function (employee) {
	        employees.push({
	          id: employee.UserId,
	          name: employee.Name,
	          checked: false
	        });
	      });
	      this.setState({
	        employees: employees
	      });
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.props.onClose();
	    }
	  }, {
	    key: 'downloadPDF',
	    value: function downloadPDF(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      // Generate employee list
	      var employeeList = [];
	      this.state.employees.map(function (employee) {
	        if (employee.checked === true) {
	          employeeList.push(employee.id);
	        }
	      });
	
	      // Data
	      var data = {
	        FromTime: this.props.From.format('YYYY-MM-DD'),
	        ToTime: this.props.To.format('YYYY-MM-DD'),
	        Employees: employeeList
	
	        // Loading ON
	      };this.refs.modal.isLoading(true);
	
	      // Call API
	      this.props.getMultipleShopPunchTimeReport(data).then(function (res) {
	        // Loading OFF
	        _this2.refs.modal.isLoading(false);
	        // FileURL
	        var downloadURL = _constants.FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + res.data.FileURL + '&token=' + encodeURIComponent(_this2.props.auth.user.Token);
	        // Open file in new window
	        var win = window.open(downloadURL, '_blank');
	
	        if (win.focus !== undefined) {
	          win.focus();
	        }
	        // Close modal
	        _this2.props.onClose();
	      }, function () {
	        // Loading OFF
	        _this2.refs.modal.isLoading(false);
	        // Error message
	        window.toastr.error((0, _helpers.translation)('2239'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList() {
	      var _this3 = this;
	
	      // Render employee
	      var renderEmployee = function renderEmployee(employee, key) {
	        var onChange = function onChange(e) {
	          var employees = _this3.state.employees;
	          employees.map(function (item) {
	            if (item.id === employee.id) {
	              item.checked = !employee.checked;
	            }
	          });
	          _this3.setState({
	            employees: employees
	          });
	        };
	        return _react2.default.createElement(_check2.default, { key: key, ref: 'employee_' + employee.id, id: employee.id + '_checkbox', onChange: onChange, value: employee.id, checked: employee.checked, labelText: employee.name });
	      };
	      // Return
	      return _react2.default.createElement(
	        'ul',
	        null,
	        this.state.employees.map(renderEmployee)
	      );
	    }
	  }, {
	    key: 'renderDates',
	    value: function renderDates() {
	      var fromDate = this.props.From.format('DD-MM-YYYY');
	      var toDate = this.props.To.format('DD-MM-YYYY');
	      return _react2.default.createElement(
	        'div',
	        { className: 'punch_dates' },
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)('188'),
	          ':'
	        ),
	        ' ',
	        fromDate,
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)('187'),
	          ':'
	        ),
	        ' ',
	        toDate
	      );
	    }
	  }, {
	    key: 'renderSelectAll',
	    value: function renderSelectAll() {
	      var _this4 = this;
	
	      var changeSelectAll = function changeSelectAll(e) {
	        var value = e.target.checked;
	        var employees = _this4.state.employees;
	        employees.map(function (employee) {
	          employee.checked = value;
	        });
	        _this4.setState({
	          employees: employees
	        });
	      };
	
	      return _react2.default.createElement(_check2.default, { ref: 'select_all', id: 'all_checkbox', onChange: changeSelectAll, labelText: (0, _helpers.translation)('531') });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'punchreport__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({
	            ref: 'modal'
	          }, this.props, {
	            header: (0, _helpers.translation)('2159'),
	            overflowHidden: this.state.overflowHidden,
	            clickOutsideClose: true,
	            onClose: this.onClose,
	            icon: _icons.ModalIcons.Plus,
	            bottomBarProps: {
	              actionLabelText: (0, _helpers.translation)('2238'),
	              onActionClick: this.downloadPDF
	            }
	          }),
	          this.renderDates(),
	          this.renderSelectAll(),
	          this.renderList()
	        )
	      );
	    }
	  }]);
	
	  return PunchReportModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    employees: state.common.employees
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getMultipleShopPunchTimeReport: _punchclock.getMultipleShopPunchTimeReport
	})(PunchReportModal);

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1666);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _punchclock = __webpack_require__(173);
	
	var _helpers = __webpack_require__(2);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// import components
	
	
	// Actions
	
	
	// Utils
	
	
	// Elements
	
	
	var PunchStatsModal = function (_Component) {
	  _inherits(PunchStatsModal, _Component);
	
	  function PunchStatsModal(props) {
	    _classCallCheck(this, PunchStatsModal);
	
	    var _this = _possibleConstructorReturn(this, (PunchStatsModal.__proto__ || Object.getPrototypeOf(PunchStatsModal)).call(this, props));
	
	    _this.state = {
	      overflowHidden: false,
	      stats: []
	    };
	    _this.renderStats = _this.renderStats.bind(_this);
	    return _this;
	  }
	
	  _createClass(PunchStatsModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getStats(this.props);
	    }
	  }, {
	    key: 'getStats',
	    value: function getStats(props) {
	      var _this2 = this;
	
	      this.setState({
	        stats: []
	      });
	      var data = {
	        UserId: props.id
	      };
	      this.props.getUserPunchStats(data).then(function (res) {
	        _this2.setState({
	          stats: res.data
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('Could not get user punch stats'), (0, _helpers.translation)('216'));
	        _this2.props.onClose();
	      });
	    }
	  }, {
	    key: 'renderStats',
	    value: function renderStats(stats, key) {
	      var renderStat = function renderStat(item, k) {
	        if (item.PunchIn === '' && item.PunchOut === '') return null;
	        return _react2.default.createElement(
	          'div',
	          { key: k },
	          _react2.default.createElement(
	            'span',
	            null,
	            item.PunchIn
	          ),
	          '-',
	          _react2.default.createElement(
	            'span',
	            null,
	            item.PunchOut
	          )
	        );
	      };
	      var overAllText = '';
	      if (stats.OverallHours !== '') {
	        overAllText = '(' + stats.OverallHours + ')';
	      }
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { key: key, labelText: _react2.default.createElement(
	            _inline2.default,
	            null,
	            (0, _helpers.translation)(stats.DateDictionaryKey),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              null,
	              stats.Date,
	              ' ',
	              overAllText
	            )
	          ) },
	        stats.PunchStats.map(renderStat),
	        stats.DateDictionaryKey === 169 && _react2.default.createElement(_divider2.default, null)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var title = (0, _helpers.translation)('Punch stats') + ': ' + this.props.name;
	      return _react2.default.createElement(
	        'div',
	        { className: 'punchstats__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, { header: title, overflowHidden: this.state.overflowHidden }),
	          this.state.stats.map(this.renderStats)
	        )
	      );
	    }
	  }]);
	
	  return PunchStatsModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getUserPunchStats: _punchclock.getUserPunchStats
	})(PunchStatsModal);

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _customers = __webpack_require__(74);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _helpers = __webpack_require__(2);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Elements
	
	
	// Utils
	
	
	var MigrationInfo = function (_Component) {
	  _inherits(MigrationInfo, _Component);
	
	  function MigrationInfo(props) {
	    _classCallCheck(this, MigrationInfo);
	
	    var _this = _possibleConstructorReturn(this, (MigrationInfo.__proto__ || Object.getPrototypeOf(MigrationInfo)).call(this, props));
	
	    _this.state = {
	      Customer: {},
	      PrimaryCompanyName: '',
	      Customers: [],
	      UsedCustomerIds: [],
	      SelectedCustomerId: 0,
	      NewCustomer: false,
	      OtherCustomer: false,
	      BookingType: null
	    };
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onSave = _this.onSave.bind(_this);
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(MigrationInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData(this.props.customerId);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.NewCustomer !== this.state.NewCustomer || prevState.SelectedCustomerId !== this.state.SelectedCustomerId || prevState.BookingType !== this.state.BookingType) {
	        if (this.props.setBottomBarProps) {
	          this.props.setBottomBarProps({
	            disabled: this.state.NewCustomer === false && (this.state.SelectedCustomerId <= 0 || this.state.BookingType === null),
	            actionLabelText: (0, _helpers.translation)(791),
	            onActionClick: this.onSave
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      if (this.props.customerId !== next.customerId) {
	        this.getData(next.customerId);
	      }
	    }
	  }, {
	    key: 'getData',
	    value: function getData(customerId) {
	      var _this2 = this;
	
	      if (isNaN(customerId) || customerId <= 0) return;
	
	      this.props.getCustomerMergeInfo(customerId).then(function (res) {
	        _this2.setState({
	          Customer: res.data.Customer,
	          Customers: res.data.Customers,
	          PrimaryCompanyName: res.data.PrimaryCompanyName,
	          UsedCustomerIds: res.data.UsedCustomerIds
	        });
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e, isTop) {
	      if (e.target === undefined) e = isTop;
	
	      var targetName = e.target.name;
	      var value = e.target.value;
	      var extra = { BookingType: null };
	
	      if (targetName === 'NewCustomer') {
	        value = true;
	        extra = { OtherCustomer: false, SelectedCustomerId: 0, BookingType: null };
	      } else if (targetName === 'OtherCustomer') {
	        value = true;
	        extra = { NewCustomer: false, SelectedCustomerId: 0, BookingType: null };
	      } else if (isTop) {
	        extra = { NewCustomer: false, OtherCustomer: false, BookingType: null };
	      }
	
	      this.setState(_extends({}, extra, _defineProperty({}, targetName, value)));
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave() {
	      var _this3 = this;
	
	      var data = {
	        SourceCustomerId: this.state.Customer.CustomerId,
	        DestinationCustomerId: this.state.SelectedCustomerId,
	        BookingType: this.state.BookingType,
	        IsNewCustomer: this.state.NewCustomer
	      };
	
	      this.props.PostCustomerMergeInfo(data).then(function () {
	        _this3.props.onClose();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var renderTopCustomers = function renderTopCustomers() {
	        var customers = _this4.state.Customers;
	        if (customers.length === 0) return;
	
	        var renderTopCustomerItem = function renderTopCustomerItem(item, key) {
	          var isSelected = item.CustomerId === Number(_this4.state.SelectedCustomerId);
	          return _react2.default.createElement(_radio2.default, {
	            labelText: [_react2.default.createElement(
	              'span',
	              null,
	              item.Name
	            ), _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16412).replace('[x]', item.Count)
	            )],
	            name: 'SelectedCustomerId',
	            value: item.CustomerId,
	            onChange: _this4.onInputChange.bind(_this4, true),
	            checked: isSelected
	          });
	        };
	
	        return customers.map(renderTopCustomerItem);
	      };
	
	      var renderCustomerSelect = function renderCustomerSelect() {
	        var options = [{ label: (0, _helpers.translation)('2259'), value: 0 }];
	        _this4.props.customers.filter(function (c) {
	          return c.Active && !c.IsApromasWorkshop && !c.IsPerformingCustomer && !_this4.state.Customers.some(function (x) {
	            return x.CustomerId === c.CustomerId;
	          }) && !_this4.state.UsedCustomerIds.some(function (x) {
	            return x === c.CustomerId;
	          });
	        }).map(function (c, i) {
	          return options.push({ label: c.Name, value: c.CustomerId });
	        });
	
	        return _react2.default.createElement(
	          _inline2.default,
	          null,
	          _react2.default.createElement(_radio2.default, { simple: true, name: 'OtherCustomer', onChange: _this4.onInputChange, checked: _this4.state.OtherCustomer }),
	          _react2.default.createElement(_dropDown2.default, {
	            name: 'SelectedCustomerId',
	            options: options,
	            value: _this4.state.SelectedCustomerId,
	            onChange: _this4.onInputChange,
	            disabled: !_this4.state.OtherCustomer
	          })
	        );
	      };
	
	      var renderCustomerBookingType = function renderCustomerBookingType() {
	        return _react2.default.createElement(
	          _labelWrapper2.default,
	          { className: 'booking-type', labelText: (0, _helpers.translation)(16418).replace('[primaryCustomer]', _this4.state.Customer.CompanyName) },
	          _react2.default.createElement(_radio2.default, {
	            name: 'BookingType',
	            value: '0',
	            onChange: _this4.onInputChange,
	            checked: _this4.state.BookingType === '0',
	            labelText: (0, _helpers.translation)(16410).replace('[primaryCompanyName]', _this4.state.PrimaryCompanyName)
	          }),
	          _react2.default.createElement(_radio2.default, {
	            name: 'BookingType',
	            value: '1',
	            onChange: _this4.onInputChange,
	            checked: _this4.state.BookingType === '1',
	            labelText: (0, _helpers.translation)(16411).replace('[primaryCompanyName]', _this4.state.PrimaryCompanyName).replace('[currentCompanyName]', _this4.props.auth.user.ShopName)
	          }),
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)(16419)
	          )
	        );
	      };
	
	      var renderCustomerInfo = function renderCustomerInfo() {
	        var customer = _this4.state.Customer;
	        if (customer === undefined) return;
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { cols: 'auto auto', className: 'customer_info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-1' },
	            (0, _helpers.translation)(30)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'first' },
	            customer.CompanyName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-1' },
	            (0, _helpers.translation)(25)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            customer.CompanyAddress
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-1' },
	            (0, _helpers.translation)(41)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            customer.CompanyCVR
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-1' },
	            (0, _helpers.translation)(38)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            customer.CompanyPhoneNumber
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'migration' },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)(751) },
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)(16414).replace('[primaryCompanyName]', this.state.PrimaryCompanyName)
	          ),
	          renderCustomerInfo()
	        ),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { className: 'customer-selection', labelText: (0, _helpers.translation)(16416) },
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)(16415)
	          ),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: 'min-content auto' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              (0, _helpers.translation)(47)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              renderTopCustomers(),
	              renderCustomerSelect()
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              (0, _helpers.translation)(48)
	            ),
	            _react2.default.createElement(_radio2.default, { name: 'NewCustomer', labelText: (0, _helpers.translation)(723), onChange: this.onInputChange, checked: this.state.NewCustomer })
	          )
	        ),
	        this.state.SelectedCustomerId > 0 && renderCustomerBookingType()
	      );
	    }
	  }]);
	
	  return MigrationInfo;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    customers: state.common.customers
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getCustomerMergeInfo: _customers.getCustomerMergeInfo,
	  PostCustomerMergeInfo: _customers.PostCustomerMergeInfo
	})(MigrationInfo);

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _ReferencedFrom = __webpack_require__(474);
	
	var _ReferencedFrom2 = _interopRequireDefault(_ReferencedFrom);
	
	var _ReferenceOrderData = __webpack_require__(473);
	
	var _ReferenceOrderData2 = _interopRequireDefault(_ReferenceOrderData);
	
	var _ReferenceExtent = __webpack_require__(1112);
	
	var _ReferenceExtent2 = _interopRequireDefault(_ReferenceExtent);
	
	var _ReferenceActions = __webpack_require__(471);
	
	var _ReferenceActions2 = _interopRequireDefault(_ReferenceActions);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _ReferenceContactInfo = __webpack_require__(472);
	
	var _ReferenceContactInfo2 = _interopRequireDefault(_ReferenceContactInfo);
	
	var _icons = __webpack_require__(6);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Elements
	
	
	var ReferenceApproval = function (_Component) {
	  _inherits(ReferenceApproval, _Component);
	
	  function ReferenceApproval(props) {
	    _classCallCheck(this, ReferenceApproval);
	
	    var _this = _possibleConstructorReturn(this, (ReferenceApproval.__proto__ || Object.getPrototypeOf(ReferenceApproval)).call(this, props));
	
	    _this.state = {
	      view: 0
	    };
	
	    _this.renderPaint = _this.renderPaint.bind(_this);
	    _this.renderBodyShop = _this.renderBodyShop.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReferenceApproval, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        view: this.props.department
	      });
	    }
	  }, {
	    key: 'renderDivider',
	    value: function renderDivider() {
	      return _react2.default.createElement('div', { className: 'refOrderApproval__divider' });
	    }
	  }, {
	    key: 'renderPaint',
	    value: function renderPaint() {
	      var _props = this.props,
	          referenceInfo = _props.referenceInfo,
	          department = _props.department,
	          onClose = _props.onClose,
	          setBottomBarProps = _props.setBottomBarProps;
	
	      var customer = referenceInfo.Customer;
	
	      var actionSection = _react2.default.createElement(_ReferenceActions2.default, { referenceInfo: referenceInfo, onClose: onClose, setBottomBarProps: setBottomBarProps, department: department, isApproval: true });
	      var extent = _react2.default.createElement(_ReferenceExtent2.default, { orderId: referenceInfo.OrderInfo.Orderid, department: department });
	      var customerInfo = _react2.default.createElement(_ReferenceContactInfo2.default, { title: (0, _helpers.translation)('58'), icon: _icons.ReferenceIcons.Customer, name: customer.Name, address: customer.Address, phone: customer.Phone });
	
	      var largeScreen = this.props.dimensionShow([[900, 10000]]);
	      var smallScreen = this.props.dimensionShow([[0, 700]]);
	
	      var column1 = function column1() {
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(_ReferencedFrom2.default, { referenceInfo: referenceInfo, department: department }),
	          _react2.default.createElement(_ReferenceOrderData2.default, { referenceInfo: referenceInfo, department: department, isApproval: true }),
	          smallScreen && extent,
	          !largeScreen && customerInfo,
	          !largeScreen && actionSection
	        );
	      };
	
	      var column2 = function column2() {
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          extent
	        );
	      };
	
	      var column3 = function column3() {
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          customerInfo,
	          actionSection
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'refOrderApproval__content' },
	        column1(),
	        !smallScreen && this.renderDivider(),
	        !smallScreen && column2(),
	        largeScreen && this.renderDivider(),
	        largeScreen && column3()
	      );
	    }
	  }, {
	    key: 'renderBodyShop',
	    value: function renderBodyShop() {
	      var _props2 = this.props,
	          referenceInfo = _props2.referenceInfo,
	          department = _props2.department,
	          onClose = _props2.onClose,
	          setBottomBarProps = _props2.setBottomBarProps;
	
	      var originalCompany = referenceInfo.OriginalCompany;
	      var customer = referenceInfo.Customer;
	
	      var actionSection = _react2.default.createElement(_ReferenceActions2.default, { referenceInfo: referenceInfo, onClose: onClose, setBottomBarProps: setBottomBarProps, department: department, isApproval: true });
	      var extent = _react2.default.createElement(_ReferenceExtent2.default, { orderId: referenceInfo.OrderInfo.Orderid, department: department });
	      var originalCompanyInfo = _react2.default.createElement(_ReferenceContactInfo2.default, { title: (0, _helpers.translation)('17865'), name: originalCompany.Name, address: originalCompany.Address, phone: originalCompany.Phone });
	      var customerInfo = _react2.default.createElement(_ReferenceContactInfo2.default, { title: (0, _helpers.translation)('58'), name: customer.Name, address: customer.Address, phone: customer.Phone, onlyName: true });
	
	      var largeScreen = this.props.dimensionShow([[900, 10000]]);
	      var smallScreen = this.props.dimensionShow([[0, 700]]);
	
	      var column1 = function column1() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ReferencedFrom2.default, { referenceInfo: referenceInfo }),
	          originalCompanyInfo,
	          customerInfo,
	          !largeScreen && column3(),
	          smallScreen && column2()
	        );
	      };
	
	      var column2 = function column2() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ReferenceOrderData2.default, { referenceInfo: referenceInfo, department: department, isApproval: true }),
	          actionSection
	        );
	      };
	
	      var column3 = function column3() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          extent,
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0, 1], block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('418'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              referenceInfo.InsuranceCompany
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'refOrderApproval__content' },
	        _react2.default.createElement(
	          _col2.default,
	          null,
	          column1()
	        ),
	        !smallScreen && this.renderDivider(),
	        !smallScreen && _react2.default.createElement(
	          _col2.default,
	          null,
	          column2()
	        ),
	        largeScreen && this.renderDivider(),
	        largeScreen && _react2.default.createElement(
	          _col2.default,
	          null,
	          column3()
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var view = this.state.view;
	
	
	      switch (view) {
	        default:
	        case 0:
	          // Paint
	          return this.renderPaint();
	        case 1:
	          // Bodyshop
	          return this.renderBodyShop();
	      }
	    }
	  }]);
	
	  return ReferenceApproval;
	}(_react.Component);
	
	ReferenceApproval.propTypes = {
	  referenceInfo: _propTypes2.default.object.isRequired,
	  department: _propTypes2.default.number.isRequired,
	  dimensionShow: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired
	};
	
	exports.default = ReferenceApproval;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import SimpleHeader from '../SimpleHeader'
	
	// Utils
	
	
	// Elements
	
	
	var ReferenceApproved = function (_Component) {
	  _inherits(ReferenceApproved, _Component);
	
	  function ReferenceApproved(props) {
	    _classCallCheck(this, ReferenceApproved);
	
	    var _this = _possibleConstructorReturn(this, (ReferenceApproved.__proto__ || Object.getPrototypeOf(ReferenceApproved)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ReferenceApproved, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('2257'), icon: _icons.ReferenceIcons.Referred_Approved },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0, 1], block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('30'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              this.props.referenceInfo.ApprovedBy
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0, 1], block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)('388'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _time.renderFullDate)(this.props.referenceInfo.ApproveDate)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReferenceApproved;
	}(_react.Component);
	
	ReferenceApproved.propTypes = {
	  referenceInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = ReferenceApproved;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(2);
	
	var _ReferencedFrom = __webpack_require__(474);
	
	var _ReferencedFrom2 = _interopRequireDefault(_ReferencedFrom);
	
	var _ReferenceApproved = __webpack_require__(1110);
	
	var _ReferenceApproved2 = _interopRequireDefault(_ReferenceApproved);
	
	var _ReferenceOrderData = __webpack_require__(473);
	
	var _ReferenceOrderData2 = _interopRequireDefault(_ReferenceOrderData);
	
	var _ReferenceActions = __webpack_require__(471);
	
	var _ReferenceActions2 = _interopRequireDefault(_ReferenceActions);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _ReferenceContactInfo = __webpack_require__(472);
	
	var _ReferenceContactInfo2 = _interopRequireDefault(_ReferenceContactInfo);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var ReferenceCancel = function (_Component) {
	  _inherits(ReferenceCancel, _Component);
	
	  function ReferenceCancel() {
	    _classCallCheck(this, ReferenceCancel);
	
	    return _possibleConstructorReturn(this, (ReferenceCancel.__proto__ || Object.getPrototypeOf(ReferenceCancel)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceCancel, [{
	    key: 'renderDivider',
	    value: function renderDivider() {
	      return _react2.default.createElement('div', { className: 'refOrderApproval__divider' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          referenceInfo = _props.referenceInfo,
	          department = _props.department,
	          onClose = _props.onClose,
	          setBottomBarProps = _props.setBottomBarProps;
	
	      var customer = referenceInfo.Customer;
	
	      var actionSection = _react2.default.createElement(_ReferenceActions2.default, { referenceInfo: referenceInfo, onClose: onClose, setBottomBarProps: setBottomBarProps, isCancellation: true });
	      var orderData = _react2.default.createElement(_ReferenceOrderData2.default, { referenceInfo: referenceInfo, department: department });
	      var customerInfo = _react2.default.createElement(_ReferenceContactInfo2.default, { title: (0, _helpers.translation)('58'), icon: _icons.ReferenceIcons.Customer, name: customer.Name, address: customer.Address, phone: customer.Phone });
	
	      var largeScreen = this.props.dimensionShow([[900, 10000]]);
	      var smallScreen = this.props.dimensionShow([[0, 700]]);
	
	      var column1 = function column1() {
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          _react2.default.createElement(_ReferencedFrom2.default, { referenceInfo: referenceInfo, department: department }),
	          _react2.default.createElement(_ReferenceApproved2.default, { referenceInfo: referenceInfo }),
	          smallScreen && orderData,
	          !largeScreen && customerInfo,
	          !largeScreen && actionSection
	        );
	      };
	
	      var column2 = function column2() {
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          orderData
	        );
	      };
	
	      var column3 = function column3() {
	        return _react2.default.createElement(
	          _col2.default,
	          null,
	          customerInfo,
	          actionSection
	        );
	      };
	
	      console.log('cancel item.....');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'refOrderApproval__content' },
	        column1(),
	        !smallScreen && this.renderDivider(),
	        !smallScreen && column2(),
	        largeScreen && this.renderDivider(),
	        largeScreen && column3()
	      );
	    }
	  }]);
	
	  return ReferenceCancel;
	}(_react.Component);
	
	ReferenceCancel.propTypes = {
	  referenceInfo: _propTypes2.default.object.isRequired,
	  dimensionShow: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired
	};
	
	exports.default = ReferenceCancel;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Extent = __webpack_require__(153);
	
	var _Extent2 = _interopRequireDefault(_Extent);
	
	var _helpers = __webpack_require__(2);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	// import SimpleHeader from '../SimpleHeader'
	
	
	// Utils
	
	
	// Elements
	
	
	var ReferenceExtent = function (_Component) {
	  _inherits(ReferenceExtent, _Component);
	
	  function ReferenceExtent() {
	    _classCallCheck(this, ReferenceExtent);
	
	    return _possibleConstructorReturn(this, (ReferenceExtent.__proto__ || Object.getPrototypeOf(ReferenceExtent)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceExtent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          department = _props.department,
	          orderId = _props.orderId;
	
	
	      var isPaint = department === 0;
	      var icon = isPaint ? _icons.ReferenceIcons.Extent : null;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)('889'), icon: icon },
	        isPaint && _react2.default.createElement(_Extent2.default, {
	          order: orderId,
	          department: department,
	          extents: [{ type: 'base', editable: false, showEditLink: false }, { type: 'addon', editable: false, showEditLink: false }],
	          key: 'base'
	        }),
	        !isPaint && _react2.default.createElement(
	          'label',
	          { className: 'full' },
	          (0, _helpers.translation)('70')
	        ),
	        !isPaint && _react2.default.createElement(_Extent2.default, {
	          order: orderId,
	          department: department,
	          extents: [{ type: 'base', editable: false, showEditLink: false, noTitle: true, combined: true }]
	        })
	      );
	    }
	  }]);
	
	  return ReferenceExtent;
	}(_react.Component);
	
	ReferenceExtent.propTypes = {
	  orderId: _propTypes2.default.number.isRequired,
	  department: _propTypes2.default.number.isRequired
	};
	
	exports.default = ReferenceExtent;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1669);
	
	var _orders = __webpack_require__(21);
	
	var _shops = __webpack_require__(79);
	
	var _events = __webpack_require__(38);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icons = __webpack_require__(6);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// Utils
	
	
	// import components
	
	
	// Elements
	
	
	var ReferenceOrderModal = function (_Component) {
	  _inherits(ReferenceOrderModal, _Component);
	
	  function ReferenceOrderModal(props) {
	    _classCallCheck(this, ReferenceOrderModal);
	
	    var _this = _possibleConstructorReturn(this, (ReferenceOrderModal.__proto__ || Object.getPrototypeOf(ReferenceOrderModal)).call(this, props));
	
	    _this.state = {
	      isLoaded: false,
	      Partners: [],
	      OrderId: _this.props.id,
	      PartnerName: '',
	      PartnerId: 0,
	      MoveType: 0,
	      TransportBeforePaint: 0,
	      Pickup: 0,
	      TransportAfterPaint: 0,
	      IsWorkProviderOrder: false,
	      canSend: false,
	
	      IsReferredIn: false,
	      ReferredFromShopName: '',
	      ReferredByEmployee: '',
	      ReferralRequestTime: null,
	      IsMultiReferred: false,
	      OriginalShopName: '',
	      OriginalShopAddress: '',
	      OriginalShopPhone: ''
	    };
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.referenceOrder = _this.referenceOrder.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReferenceOrderModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.GetPartners(this.state.OrderId);
	    }
	  }, {
	    key: 'GetPartners',
	    value: function GetPartners(id) {
	      var _this2 = this;
	
	      this.props.getPartnersForOrder(id).then(function (res) {
	        _this2.setState(_extends({
	          isLoaded: true
	        }, res.data), function () {
	          if (_this2.state.Partners.length > 0) {
	            var partner = _this2.state.Partners[0];
	            _this2.setState({
	              PartnerId: partner.ShopId,
	              PartnerName: partner.ShopName,
	              canSend: true
	            });
	          }
	          if (_this2.state.Partners.length === 0 && _this2.state.IsWorkProviderOrder) {
	            var errorText = (0, _helpers.translation)('14877').replace('[WPName]', _this2.props.item.WPName);
	            window.toastr.error(errorText, (0, _helpers.translation)('216'));
	            _this2.props.onClose();
	          }
	          if (_this2.state.IsWorkProviderOrder) {
	            _this2.setState({
	              MoveType: '1'
	            });
	          }
	        });
	      }, function () {
	        window.toastr.error((0, _helpers.translation)('1932'), (0, _helpers.translation)('216'));
	        _this2.props.onClose();
	      });
	    }
	  }, {
	    key: 'referenceOrder',
	    value: function referenceOrder(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      if (!this.state.canSend) return null;
	      var data = {
	        OrderId: this.props.id,
	        PartnerId: parseInt(this.state.PartnerId),
	        MoveType: parseInt(this.state.MoveType),
	        TransportBeforePaint: parseInt(this.state.TransportBeforePaint),
	        Pickup: parseInt(this.state.Pickup),
	        TransportAfterPaint: parseInt(this.state.TransportAfterPaint)
	        // console.log('data', data)
	      };this.setState({
	        canSend: false
	      }, function () {
	        _this3.props.ReferenceOrder(data).then(function (res) {
	          _this3.props.onClose();
	          // console.log('update List')
	          _events2.default.emit('updateorderlist', true);
	        }, function () {
	          // Toastr
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        });
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	      if (e.target.name === 'PartnerId') {
	        for (var i = 0; i < this.state.Partners.length; i++) {
	          var partner = this.state.Partners[i];
	          if (partner.ShopId === parseInt(e.target.value)) {
	            this.state.PartnerName = partner.ShopName;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this4 = this;
	
	      var isBodyShop = this.props.auth.departmentType === 1;
	
	      var renderPartnerId = function renderPartnerId() {
	        if (_this4.state.Partners === undefined) return null;
	        return _react2.default.createElement(
	          _dropDown2.default,
	          { labelText: (0, _helpers.translation)('1735') + ':', name: 'PartnerId', onChange: _this4.onInputChange, value: _this4.state.PartnerId },
	          _this4.state.Partners.map(function (val, key) {
	            return _react2.default.createElement(
	              'option',
	              { value: val.ShopId, key: key },
	              val.ShopName
	            );
	          })
	        );
	      };
	
	      var renderPaintView = function renderPaintView() {
	        var renderMoveType = function renderMoveType() {
	          var disabled = _this4.state.IsWorkProviderOrder;
	          var onClick = function onClick(e) {
	            if (!disabled) return null;
	            var errorText = (0, _helpers.translation)('14879').replace('[WPName]', _this4.props.item.WPName);
	            window.toastr.error(errorText, (0, _helpers.translation)('216'));
	          };
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('703'), id: 'move_type-1', name: 'MoveType', value: '1', onChange: _this4.onInputChange, checked: _this4.state.MoveType === '1', disabled: disabled }),
	            _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('704'), id: 'move_type-0', name: 'MoveType', value: '0', onChange: _this4.onInputChange, checked: _this4.state.MoveType === '0', disabled: disabled, onClick: onClick })
	          );
	        };
	
	        var renderTransportBefore = function renderTransportBefore() {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_radio2.default, { labelText: _this4.props.auth.user.ShopName, id: 'transport_before_paint-0', name: 'TransportBeforePaint', value: '0', onChange: _this4.onInputChange, checked: _this4.state.TransportBeforePaint === '0' }),
	            _react2.default.createElement(_radio2.default, { labelText: _this4.state.PartnerName, id: 'transport_before_paint-1', name: 'TransportBeforePaint', value: '1', onChange: _this4.onInputChange, checked: _this4.state.TransportBeforePaint === '1' })
	          );
	        };
	
	        var renderPickupAt = function renderPickupAt() {
	          if (_this4.state.TransportBeforePaint !== '1') return null;
	          return _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('710') },
	            _react2.default.createElement(_radio2.default, { labelText: (0, _helpers.translation)('363'), id: 'pickup-0', name: 'Pickup', value: '0', onChange: _this4.onInputChange, checked: _this4.state.Pickup === '0' }),
	            _react2.default.createElement(_radio2.default, { labelText: _this4.props.auth.user.ShopName, id: 'pickup-1', name: 'Pickup', value: '1', onChange: _this4.onInputChange, checked: _this4.state.Pickup === '1' })
	          );
	        };
	
	        var renderTransportAfter = function renderTransportAfter() {
	          if (_this4.state.MoveType !== '0') return null;
	          return _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('707') },
	            _react2.default.createElement(_divider2.default, null),
	            _react2.default.createElement(_radio2.default, { labelText: _this4.props.auth.user.ShopName, id: 'transport_after_paint-0', name: 'TransportAfterPaint', value: '0', onChange: _this4.onInputChange, checked: _this4.state.TransportAfterPaint === '0' }),
	            _react2.default.createElement(_radio2.default, { labelText: _this4.state.PartnerName, id: 'transport_after_paint-1', name: 'TransportAfterPaint', value: '1', onChange: _this4.onInputChange, checked: _this4.state.TransportAfterPaint === '1' })
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          renderMoveType(),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)('705') },
	            _react2.default.createElement(_divider2.default, null),
	            renderTransportBefore(),
	            renderPickupAt()
	          ),
	          renderTransportAfter()
	        );
	      };
	
	      var renderBodyView = function renderBodyView() {
	        var _state = _this4.state,
	            IsReferredIn = _state.IsReferredIn,
	            ReferredFromShopName = _state.ReferredFromShopName,
	            ReferredByEmployee = _state.ReferredByEmployee,
	            ReferralRequestTime = _state.ReferralRequestTime,
	            IsMultiReferred = _state.IsMultiReferred,
	            OriginalShopName = _state.OriginalShopName,
	            OriginalShopAddress = _state.OriginalShopAddress,
	            OriginalShopPhone = _state.OriginalShopPhone;
	
	
	        var renderLabel = function renderLabel(dictionaryKey, label) {
	          var extraCss = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	          return _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0, 1], block: true },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(dictionaryKey)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              label
	            )
	          );
	        };
	
	        var renderReferredFrom = function renderReferredFrom(_) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'black-h-3-left pg-mb-2' },
	              (0, _helpers.translation)(719)
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: ReferredFromShopName },
	              renderLabel(30, ReferredByEmployee),
	              renderLabel(388, (0, _time.renderFullDate)(ReferralRequestTime))
	            ),
	            _react2.default.createElement(_divider2.default, null)
	          );
	        };
	
	        var renderOriginalShop = function renderOriginalShop(_) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'black-h-3-left pg-mb-2' },
	              (0, _helpers.translation)(17865)
	            ),
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: OriginalShopName },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                OriginalShopAddress
	              ),
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                OriginalShopPhone
	              )
	            ),
	            _react2.default.createElement(_divider2.default, null)
	          );
	        };
	
	        var renderOrderData = function renderOrderData(_) {
	          var order = _this4.props.item;
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'black-h-3-left pg-mb-2' },
	              (0, _helpers.translation)(14918)
	            ),
	            renderLabel(17866, order.Id),
	            renderLabel(78, order.RegNumber),
	            renderLabel(145, (0, _helpers.translation)(order.BrandName.Name)),
	            renderLabel(146, order.Model),
	            _react2.default.createElement(_divider2.default, null)
	          );
	        };
	
	        var renderEstimatedArival = function renderEstimatedArival(_) {
	          var order = _this4.props.item;
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'black-h-3-left pg-mb-2' },
	              (0, _helpers.translation)(14827)
	            ),
	            renderLabel(order.ShopName, (0, _time.renderFullDate)(order.BodyShopPickupTime, false))
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          IsReferredIn && renderReferredFrom(),
	          IsMultiReferred && renderOriginalShop(),
	          renderOrderData(),
	          renderEstimatedArival()
	        );
	      };
	
	      return _react2.default.createElement(
	        'form',
	        null,
	        renderPartnerId(),
	        !isBodyShop && renderPaintView(),
	        isBodyShop && renderBodyView()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.isLoaded) return null;
	      var headerName = this.props.item.Model ? this.props.item.Model : '' + ' ' + this.props.item.RegNumber;
	      return _react2.default.createElement(
	        'div',
	        { className: 'referenceorder__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('709') + ' - ' + headerName,
	            overflowHidden: this.state.overflowHidden,
	            onClose: this.props.onClose,
	            icon: _icons.ModalIcons.Refer_Order,
	            bottomBarProps: {
	              disabled: !this.state.canSend,
	              actionLabelText: (0, _helpers.translation)('709'),
	              onActionClick: this.referenceOrder
	            }
	          }),
	          this.renderView()
	        )
	      );
	    }
	  }]);
	
	  return ReferenceOrderModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  LinkOrders: _orders.LinkOrders,
	  getLinkOrderData: _orders.getLinkOrderData,
	  ReferenceOrder: _orders.ReferenceOrder,
	  getPartnersForOrder: _shops.getPartnersForOrder
	})(ReferenceOrderModal);

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _orders = __webpack_require__(21);
	
	var _notes = __webpack_require__(114);
	
	__webpack_require__(1670);
	
	var _auth = __webpack_require__(8);
	
	var _helpers = __webpack_require__(2);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _icons = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import {
	//   API_URL
	// } from '../../../constants'
	
	// Actions
	
	
	// import styles
	
	
	// Utils
	
	
	// import components
	
	// import CircleImage from '../../components/CircleImage'
	// import Gallery from '../../components/Gallery'
	
	// import Portal from '../../components/Portal'
	// import Confirm from '../../components/Confirm'
	
	// Elements
	
	
	var RejectEvaluationModal = function (_Component) {
	  _inherits(RejectEvaluationModal, _Component);
	
	  function RejectEvaluationModal(props) {
	    _classCallCheck(this, RejectEvaluationModal);
	
	    var _this = _possibleConstructorReturn(this, (RejectEvaluationModal.__proto__ || Object.getPrototypeOf(RejectEvaluationModal)).call(this, props));
	
	    _this.state = _this.resetState(props);
	    _this.createRejection = _this.createRejection.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(RejectEvaluationModal, [{
	    key: 'resetState',
	    value: function resetState(props) {
	      var newState = {
	        confirm: false,
	        isLoading: false,
	        note: {
	          NoteID: 0,
	          Note: '',
	          NoteTypeID: 1,
	          OrderID: props.orderPrice !== undefined ? props.orderPrice.OrderId : 0,
	          SourceID: 12,
	          ApplyToInvoice: false,
	          DeviationId: 0
	        },
	        overflowHidden: false
	      };
	      return newState;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState(this.resetState(nextProps));
	    }
	  }, {
	    key: 'createRejection',
	    value: function createRejection() {
	      var _this2 = this;
	
	      // e.preventDefault()
	      this.setState({ isLoading: true });
	
	      var createRejection = function createRejection() {
	        var note = _this2.state.note;
	        _this2.props.createNote(note).then(function (res) {
	          // window.toastr.success(translation('13717'), translation('13424'))
	          // this.props.router.replace({
	          //   pathname: '/orders',
	          //   query: {
	          //     orderid: note.OrderID
	          //   }
	          // })
	          _this2.props.goBack();
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('1917'), (0, _helpers.translation)('216'));
	        });
	        _this2.setState({ isLoading: false });
	      };
	      createRejection();
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var value = e.target.value;
	      var name = e.target.name;
	      if (name === 'Note') {
	        this.setState({
	          note: _extends({}, this.state.note, _defineProperty({}, name, value))
	        }, function () {
	          // console.log(this.state)
	        });
	      } else {
	        this.setState(_defineProperty({}, name, value));
	      }
	    }
	  }, {
	    key: 'renderStep1',
	    value: function renderStep1() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_textarea2.default, { labelText: (0, _helpers.translation)('149'), name: 'Note', onChange: this.onInputChange, defaultValue: this.state.note.Note })
	      );
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.props.onClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'rejectestimation__modal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('316'),
	            overflowHidden: this.state.overflowHidden,
	            clickOutsideClose: false,
	            onClose: this.onClose,
	            icon: _icons.ModalIcons.Estimation,
	            bottomBarProps: {
	              disabled: this.state.isLoading,
	              actionLabelText: (0, _helpers.translation)('791'),
	              onActionClick: this.createRejection,
	              cancelLabelText: (0, _helpers.translation)('1155'),
	              onCancelClick: this.onClose
	            }
	          }),
	          this.renderStep1()
	        )
	      );
	    }
	  }]);
	
	  return RejectEvaluationModal;
	}(_react.Component);
	
	RejectEvaluationModal.propTypes = {
	  createOrderEstimation: _propTypes2.default.func.isRequired,
	  uploadFileToOrder: _propTypes2.default.func.isRequired,
	  hasSubscriptionPermission: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, {
	  createOrderEstimation: _orders.createOrderEstimation,
	  uploadFileToOrder: _orders.uploadFileToOrder,
	  hasSubscriptionPermission: _auth.hasSubscriptionPermission,
	  createNote: _notes.createNote
	})(RejectEvaluationModal);

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	__webpack_require__(1671);
	
	var _helpers = __webpack_require__(2);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _dropDown = __webpack_require__(23);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	
	var SparePartDeliverySettingEditModal = function (_Component) {
	  _inherits(SparePartDeliverySettingEditModal, _Component);
	
	  function SparePartDeliverySettingEditModal(props) {
	    _classCallCheck(this, SparePartDeliverySettingEditModal);
	
	    var _this = _possibleConstructorReturn(this, (SparePartDeliverySettingEditModal.__proto__ || Object.getPrototypeOf(SparePartDeliverySettingEditModal)).call(this, props));
	
	    _this.state = {
	      brands: [],
	
	      isLoading: false,
	      showConfirm: false
	    };
	
	    _this.onClose = _this.onClose.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onPortalClose = _this.onPortalClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(SparePartDeliverySettingEditModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateSelectedBrands(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(nextProps.selected, this.props.selected)) {
	        this.updateSelectedBrands(nextProps);
	      }
	    }
	  }, {
	    key: 'updateSelectedBrands',
	    value: function updateSelectedBrands(props) {
	      this.setState({
	        brands: props.selected
	      });
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.setState({
	        isLoading: false
	      });
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() {
	      var _this2 = this;
	
	      if (this.state.brands.length === 0 && this.state.showConfirm === false) {
	        this.setState({
	          showConfirm: true
	        });
	        return;
	      }
	
	      if (this.props.onSave !== null) {
	        this.setState({
	          isLoading: true,
	          showConfirm: false
	        });
	
	        this.props.onSave(this.state.brands).then(function () {
	          _this2.onClose();
	        });
	      }
	    }
	  }, {
	    key: 'onPortalClose',
	    value: function onPortalClose() {
	      this.setState({
	        showConfirm: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var brandOptions = this.props.brands.map(function (b, index) {
	        if (index === 0) {
	          return { value: b.Name, label: (0, _helpers.translation)(b.Name), disabled: true };
	        }
	
	        return { value: b.Name, label: b.Name };
	      });
	
	      var buttonLabel = (0, _helpers.translation)('791');
	      if (this.state.isLoading) {
	        buttonLabel = _react2.default.createElement(
	          'div',
	          { className: 'animated-background' },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'sr-only' },
	            (0, _helpers.translation)('13382'),
	            '...'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sparePartDeliverySettingModal' },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            header: (0, _helpers.translation)('13473'),
	            onClose: this.onClose
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'sparePartDeliverySettingModal__content' },
	            _react2.default.createElement(_dropDown2.default, {
	              name: 'brands',
	              value: this.state.brands,
	              onChange: this.onChange,
	              options: brandOptions,
	              isMulti: true
	            }),
	            _react2.default.createElement(_divider2.default, { spacing: 3, noLine: true }),
	            _react2.default.createElement(_button2.default, { onClick: this.onClick, labelText: buttonLabel }),
	            this.state.showConfirm && _react2.default.createElement(
	              _Portal2.default,
	              { className: 'confirm_popup', onPortalClose: this.onPortalClose },
	              _react2.default.createElement(_Confirm2.default, {
	                confirm: this.onClick,
	                notConfirm: this.onPortalClose,
	                renderText: function renderText() {
	                  return (0, _helpers.translation)('16526');
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SparePartDeliverySettingEditModal;
	}(_react.Component);
	
	SparePartDeliverySettingEditModal.defaultProps = {
	  onSave: null
	};
	
	function mapStateToProps(state) {
	  return {
	    brands: state.common.brands
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SparePartDeliverySettingEditModal);

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1673);
	
	var _employees = __webpack_require__(128);
	
	var _Modal = __webpack_require__(31);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Workhours = __webpack_require__(448);
	
	var _Workhours2 = _interopRequireDefault(_Workhours);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _sideMenu = __webpack_require__(50);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _sideMenuItem = __webpack_require__(53);
	
	var _sideMenuItem2 = _interopRequireDefault(_sideMenuItem);
	
	var _icons = __webpack_require__(6);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles
	
	
	// Actions
	
	
	// import components
	
	
	// Elements
	
	
	// Utils
	
	
	var WorkhoursModal = function (_Component) {
	  _inherits(WorkhoursModal, _Component);
	
	  function WorkhoursModal(props) {
	    _classCallCheck(this, WorkhoursModal);
	
	    var _this = _possibleConstructorReturn(this, (WorkhoursModal.__proto__ || Object.getPrototypeOf(WorkhoursModal)).call(this, props));
	
	    _this.state = {
	      Log: [],
	      SelectedIndex: 0,
	      openMenu: false,
	      bottomBarProps: null
	    };
	
	    _this.renderLog = _this.renderLog.bind(_this);
	    _this.renderEddit = _this.renderEddit.bind(_this);
	    _this.updateLogs = _this.updateLogs.bind(_this);
	    _this.triggerMenu = _this.triggerMenu.bind(_this);
	    _this.setBottomBarProps = _this.setBottomBarProps.bind(_this);
	    return _this;
	  }
	
	  _createClass(WorkhoursModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.GetWorkHourLogs(this.props.UserId).then(function (res) {
	        _this2.setState({
	          Log: res.data,
	          SelectedIndex: res.data.length - 1
	        });
	      });
	    }
	  }, {
	    key: 'setBottomBarProps',
	    value: function setBottomBarProps(bottomBarProps) {
	      this.setState({ bottomBarProps: bottomBarProps });
	    }
	  }, {
	    key: 'triggerMenu',
	    value: function triggerMenu() {
	      if (!this.state.openMenu) {
	        document.addEventListener('click', this.triggerMenu, true);
	      } else {
	        document.removeEventListener('click', this.triggerMenu, true);
	      }
	
	      this.setState({
	        openMenu: !this.state.openMenu
	      });
	    }
	  }, {
	    key: 'updateLogs',
	    value: function updateLogs(data) {
	      this.props.SetWorkHours(data[data.length - 1]);
	      this.props.onClose();
	    }
	  }, {
	    key: 'renderLog',
	    value: function renderLog() {
	      var _this3 = this;
	
	      var setSelectedIndex = function setSelectedIndex(index) {
	        _this3.setState({
	          SelectedIndex: index
	        });
	      };
	
	      var renderLogItem = function renderLogItem(val, key) {
	        // let classes = this.state.SelectedIndex === key ? 'selected' : ''
	
	        return _react2.default.createElement(_sideMenuItem2.default, {
	          label: (0, _time.renderFullDate)(val.Date, false),
	          onClick: setSelectedIndex.bind(_this3, key),
	          selected: key === _this3.state.SelectedIndex,
	          key: key
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'workhour' },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: ['max-content'] },
	          _react2.default.createElement(
	            _sideMenu2.default,
	            { disableFilter: true },
	            this.state.Log.map(renderLogItem)
	          ),
	          _react2.default.createElement(_Workhours2.default, { onlyShow: true, WorkHours: this.state.Log[this.state.SelectedIndex], InModal: true, IsLog: true, displayId: 2 })
	        )
	      );
	    }
	  }, {
	    key: 'renderEddit',
	    value: function renderEddit() {
	      if (this.state.Log[this.state.Log.length - 1] === undefined) return null;
	      var dates = this.state.Log.map(function (x) {
	        return x.Date;
	      });
	      return _react2.default.createElement(_Workhours2.default, {
	        updateLogs: this.updateLogs.bind(this),
	        Dates: dates,
	        WorkHours: this.state.Log[this.state.Log.length - 1],
	        InModal: true,
	        onClose: this.props.onClose,
	        displayId: 2,
	        onlyShow: false,
	        setBottomBarProps: this.setBottomBarProps
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var IsHistory = this.props.IsHistory;
	      var header = '';
	      var icon = '';
	
	      if (this.props.IsHistory) {
	        header = (0, _helpers.translation)('14731');
	        // icon = '../svgs/log-white.svg'
	        icon = _icons.ModalIcons.WorkHours_Log;
	      } else {
	        header = (0, _helpers.translation)('14730');
	        icon = undefined;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Workhours__modal' + (IsHistory ? ' IsLog' : '') },
	        _react2.default.createElement(
	          _Modal2.default,
	          _extends({}, this.props, {
	            show: true,
	            header: header,
	            icon: icon,
	            onClose: this.props.onClose,
	            bottomBarProps: this.state.bottomBarProps
	          }),
	          IsHistory ? this.renderLog() : this.renderEddit()
	        )
	      );
	    }
	  }]);
	
	  return WorkhoursModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  GetWorkHourLogs: _employees.GetWorkHourLogs
	})(WorkhoursModal);

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _constants = __webpack_require__(5);
	
	var _backdrop = __webpack_require__(29);
	
	var _carrentalcontracts = __webpack_require__(792);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _detect = __webpack_require__(102);
	
	var _OverlayHeader = __webpack_require__(174);
	
	var _OverlayHeader2 = _interopRequireDefault(_OverlayHeader);
	
	var _CarRentalContractModal = __webpack_require__(1081);
	
	var _CarRentalContractModal2 = _interopRequireDefault(_CarRentalContractModal);
	
	var _overlay = __webpack_require__(131);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _row = __webpack_require__(33);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(18);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _panel = __webpack_require__(14);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _switch = __webpack_require__(37);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _overlayContent = __webpack_require__(177);
	
	var _overlayContent2 = _interopRequireDefault(_overlayContent);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icons = __webpack_require__(6);
	
	__webpack_require__(1674);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// actions
	
	
	// utils
	
	
	// Components
	
	
	// modals
	
	
	// Elements
	
	
	// styles
	
	
	var CarRentalContractOverlay = function (_Component) {
	  _inherits(CarRentalContractOverlay, _Component);
	
	  function CarRentalContractOverlay(props) {
	    _classCallCheck(this, CarRentalContractOverlay);
	
	    var _this = _possibleConstructorReturn(this, (CarRentalContractOverlay.__proto__ || Object.getPrototypeOf(CarRentalContractOverlay)).call(this, props));
	
	    _this.state = {
	      carOwnerPhoneCount: 1,
	      conditionsEdit: false,
	      Company: {
	        Name: '', // 'Viborg Pladeværksted',
	        Address: '', // 'Vejnavn 00',
	        Zip: '', // '0000',
	        City: '', // 'Viborg',
	        CVR: '' // '000000000'
	      },
	      Car: {
	        Nr: '', // '2',
	        RegNumber: '', // 'AA 11 111',
	        Brand: '', // 'Toyota',
	        Model: '' // 'Aygo'
	      },
	      Insurance: {
	        Kasko: true,
	        SelfRiskCoverage: false,
	        SelfRiskCoverageAmount: 0
	      },
	      Renter: {
	        Name: '', // 'Elena',
	        Address: '', // 'Vejnavn 21',
	        Zip: '', // '8830',
	        City: '', // 'Tjele',
	        Phones: [], // '12345678',
	        Mail: '', // 'elena@itpilot.dk',
	        DriverLicense: '', // '12345600',
	        CVR: '' // '000111000'
	      },
	      Drivers: [{ Name: '', DriverLicense: '' }, { Name: '', DriverLicense: '' }],
	      Periods: [{ Start: null, End: null }],
	      Rent: {
	        Fuel: false,
	        Tank: 1,
	        UpToKm: null, // '80',
	        ExtraKm: null // '20'
	      },
	      KmAtStart: null, // '50',
	      Conditions: null // ''
	    };
	
	    _this.md = new window.MobileDetect(window.navigator.userAgent);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.openPopup = _this.openPopup.bind(_this);
	    _this.closePopup = _this.closePopup.bind(_this);
	    _this.getCarRentalContract = _this.getCarRentalContract.bind(_this);
	    _this.updateCarRentalContract = _this.updateCarRentalContract.bind(_this);
	    _this.toggleEditConditions = _this.toggleEditConditions.bind(_this);
	    _this.setDocHeight = _this.setDocHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(CarRentalContractOverlay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // console.log('componentDidMount', this.props)
	      if (this.props.order && this.props.carRentalId) {
	        this.getCarRentalContract(this.props.carRentalId, true);
	      }
	      // let isAndroid = this.md.is('AndroidOS')
	      // let isIOS = this.md.is('iPhone')
	      var isPhone = this.md.phone();
	      if (isPhone) {
	        var vh = window.innerHeight * 0.01;
	        document.documentElement.style.setProperty('--vh', vh + 'px');
	        document.documentElement.scrollTop = 20;
	        window.addEventListener('resize', this.setDocHeight);
	        window.addEventListener('orientationchange', this.setDocHeight);
	      }
	    }
	  }, {
	    key: 'setDocHeight',
	    value: function setDocHeight() {
	      var vh = window.innerHeight * 0.01;
	      document.documentElement.style.setProperty('--vh', vh + 'px');
	
	      var height1 = document.documentElement.clientHeight;
	      var height2 = window.innerHeight;
	      var dif = Math.abs(height1 - height2);
	      if (dif !== 0) {
	        vh = (window.innerHeight - 56) * 0.01;
	        document.documentElement.style.setProperty('--vh', vh + 'px');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var isPhone = this.md.phone();
	      if (isPhone) {
	        window.removeEventListener('resize');
	        window.removeEventListener('orientationchange');
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // console.log('componentWillReceiveProps', this.props, nextProps)
	      if (typeof nextProps.carRentalId === 'number' && this.props.carRentalId !== nextProps.carRentalId) {
	        this.getCarRentalContract(nextProps.carRentalId, true);
	      }
	    }
	  }, {
	    key: 'getCarRentalContract',
	    value: function getCarRentalContract(carRentalId, forceNew) {
	      var _this2 = this;
	
	      // console.log('getCarRentalContract', this.props, carRentalId)
	      if (_typeof(this.props.order) === 'object' && typeof carRentalId === 'number') {
	        this.props.getCarRentalContract(this.props.order.Id, carRentalId, forceNew).then(function (res) {
	          _this2.setState(_extends({}, _this2.state, res.data));
	        });
	      }
	    }
	  }, {
	    key: 'updateCarRentalContract',
	    value: function updateCarRentalContract() {
	      var _this3 = this;
	
	      if (this.props.order.Id && this.props.carRentalId) {
	        var data = {
	          OrderId: this.props.order.Id,
	          CarRentalId: this.props.carRentalId,
	          Renter: this.state.Renter,
	          Insurance: this.state.Insurance,
	          Rent: this.state.Rent,
	          Drivers: this.state.Drivers,
	          KmAtStart: this.state.KmAtStart
	        };
	        if (this.state.conditionsEdit) {
	          data.Conditions = this.state.Conditions;
	        }
	
	        var carOwnerPhoneCount = this.state.carOwnerPhoneCount;
	        carOwnerPhoneCount = data.Renter.Phones.length;
	        // console.log('Update contract: ', data)
	
	        this.props.updateCarRentalContract(data).then(function (res) {
	          var data = res.data;
	          var phoneCount = data.Renter.Phones.length;
	
	          if (phoneCount > carOwnerPhoneCount) carOwnerPhoneCount = phoneCount;
	          for (var i = phoneCount; i < carOwnerPhoneCount; i++) {
	            data.Renter.Phones.push('');
	          }
	          _this3.setState(_extends({}, _this3.state, data, {
	            carOwnerPhoneCount: carOwnerPhoneCount
	          }));
	        });
	      }
	    }
	  }, {
	    key: 'openPopup',
	    value: function openPopup(e) {
	      e.preventDefault();
	      this.setState({
	        carrentalcontractmodal: true
	      });
	      this.props.triggerPopup(true);
	    }
	  }, {
	    key: 'closePopup',
	    value: function closePopup() {
	      this.props.triggerPopup(false);
	      this.setState({
	        carrentalcontractmodal: false
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this4 = this;
	
	      // value
	      var value = e.target.value;
	      var doUpdate = false;
	      if (e.target.type === 'checkbox') {
	        value = e.target.checked;
	        doUpdate = true;
	      }
	      if (e.target.type === 'radio') {
	        value = parseInt(e.target.value);
	        doUpdate = true;
	      }
	      // name
	      var names = e.target.name.split('.');
	      // console.log('names.length ', names.length)
	      var nameOuter = names[0];
	      var namesInner = names[1];
	      if (names.length > 1) {
	        this.setState(_defineProperty({}, nameOuter, _extends({}, this.state[nameOuter], _defineProperty({}, namesInner, value))), function () {
	          return doUpdate && _this4.updateCarRentalContract();
	        });
	      } else {
	        this.setState(_defineProperty({}, nameOuter, value), function () {
	          return doUpdate && _this4.updateCarRentalContract();
	        });
	      }
	    }
	  }, {
	    key: 'toggleEditConditions',
	    value: function toggleEditConditions() {
	      this.setState({
	        conditionsEdit: !this.state.conditionsEdit
	      });
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var car = this.state.Car;
	      return _react2.default.createElement(
	        _OverlayHeader2.default,
	        { overlayId: 'CarRentalContractOverlay', onClose: this.props.onClose },
	        _react2.default.createElement(
	          'div',
	          { className: 'top topHeaderInfo' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              car.Nr + ' - ' + car.RegNumber
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderLender',
	    value: function renderLender() {
	      var Company = this.state.Company;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(16782) },
	        _react2.default.createElement(_text2.default, { name: 'Company.Name', value: Company.Name || '', disabled: true, labelText: (0, _helpers.translation)(16790) }),
	        _react2.default.createElement(_text2.default, { name: 'Company.Address', value: Company.Address || '', disabled: true, labelText: (0, _helpers.translation)(25) }),
	        _react2.default.createElement(_text2.default, { name: 'Company.Zip', value: Company.Zip || '', disabled: true, labelText: (0, _helpers.translation)(16791) }),
	        _react2.default.createElement(_text2.default, { name: 'Company.City', value: Company.City || '', disabled: true, labelText: (0, _helpers.translation)(37) }),
	        _react2.default.createElement(_text2.default, { name: 'Company.CVR', value: Company.CVR || '', disabled: true, labelText: (0, _helpers.translation)(41) })
	      );
	    }
	  }, {
	    key: 'renderCar',
	    value: function renderCar() {
	      var Car = this.state.Car;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(629) },
	        _react2.default.createElement(_text2.default, { name: 'Car.Nr', value: Car.Nr || '', disabled: true, labelText: (0, _helpers.translation)(16792) }),
	        _react2.default.createElement(_text2.default, { name: 'Car.RegNumber', value: Car.RegNumber || '', disabled: true, labelText: (0, _helpers.translation)(2005) }),
	        _react2.default.createElement(_text2.default, { name: 'Car.Brand', value: Car.Brand || '', disabled: true, labelText: (0, _helpers.translation)(145) }),
	        _react2.default.createElement(_text2.default, { name: 'Car.Model', value: Car.Model || '', disabled: true, labelText: (0, _helpers.translation)(146) })
	      );
	    }
	  }, {
	    key: 'renderInsurance',
	    value: function renderInsurance() {
	      var Insurance = this.state.Insurance;
	      // let selfRiskPrice = 50 // TODO: get from api
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(16786) },
	        _react2.default.createElement(_check2.default, { name: 'Insurance.Kasko', checked: Insurance.Kasko, onChange: this.onChange, labelText: (0, _helpers.translation)(16793) }),
	        _react2.default.createElement(_check2.default, { name: 'Insurance.SelfRiskCoverage', checked: Insurance.SelfRiskCoverage, onChange: this.onChange, labelText: (0, _helpers.translation)(16794) + ' ' + (0, _helpers.translation)(this.props.currencyCode) + ' ' + Insurance.SelfRiskCoverageAmount + ' ' + (0, _helpers.translation)(971) })
	      );
	    }
	  }, {
	    key: 'renderPhones',
	    value: function renderPhones() {
	      var _this5 = this;
	
	      var phones = this.state.Renter.Phones;
	
	      var newNumber = function newNumber(e) {
	        e.preventDefault();
	        var carOwnerPhoneCount = _this5.state.carOwnerPhoneCount;
	        if (phones.length > carOwnerPhoneCount) carOwnerPhoneCount = phones.length;
	        if (carOwnerPhoneCount < 4) {
	          carOwnerPhoneCount++;
	          phones.push('');
	          _this5.setState({
	            carOwnerPhoneCount: carOwnerPhoneCount
	          });
	        }
	      };
	
	      var onChangePhone = function onChangePhone(key, e) {
	        phones[key] = e.target.value;
	        _this5.setState({
	          phones: phones
	        });
	      };
	
	      var onBlurPhone = function onBlurPhone(key, e) {
	        phones[key] = e.target.value;
	        _this5.setState({
	          phones: phones
	        }, function () {
	          _this5.updateCarRentalContract();
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        phones.map(function (val, key) {
	          return _react2.default.createElement(_text2.default, { name: 'Text', value: val, key: 'number_' + key, labelText: (0, _helpers.translation)('38'), onBlur: onBlurPhone.bind(_this5, key), onChange: onChangePhone.bind(_this5, key) });
	        }),
	        _react2.default.createElement(_button2.default, { style: 'link', labelText: (0, _helpers.translation)('17899'), disabled: phones.length === 4, onClick: newNumber })
	      );
	    }
	  }, {
	    key: 'renderRenter',
	    value: function renderRenter() {
	      var Renter = this.state.Renter;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(16783) },
	        _react2.default.createElement(_text2.default, { name: 'Renter.Name', value: Renter.Name || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(30) }),
	        _react2.default.createElement(_text2.default, { name: 'Renter.Address', value: Renter.Address || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(25) }),
	        _react2.default.createElement(_text2.default, { name: 'Renter.Zip', value: Renter.Zip || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(16791) }),
	        _react2.default.createElement(_text2.default, { name: 'Renter.City', value: Renter.City || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(37) }),
	        this.renderPhones(),
	        _react2.default.createElement(_text2.default, { name: 'Renter.Mail', value: Renter.Mail || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(1052) }),
	        _react2.default.createElement(_text2.default, { name: 'Renter.DriverLicense', value: Renter.DriverLicense || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(16795) }),
	        _react2.default.createElement(_text2.default, { name: 'Renter.CVR', value: Renter.CVR || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(41) })
	      );
	    }
	  }, {
	    key: 'renderDrivers',
	    value: function renderDrivers() {
	      var _this6 = this;
	
	      var Drivers = this.state.Drivers;
	
	      var onChange = function onChange(e) {
	        var names = e.target.name.split('_');
	        var index = parseInt(names[1]);
	        var drivers = _this6.state.Drivers;
	        drivers[index][names[0]] = e.target.value;
	        _this6.setState({
	          Drivers: drivers
	        }, function () {
	          // console.log('Drivers: ', this.state.Drivers, 'index changed:', index)
	        });
	      };
	      var mapDrivers = function mapDrivers(val, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(_text2.default, { name: 'Name_' + key, value: val.Name || '', onChange: onChange, onBlur: _this6.updateCarRentalContract, labelText: (0, _helpers.translation)(30) + ' (' + (0, _helpers.translation)(16796).toLowerCase() + ' ' + (key + 1) + ')' }),
	          _react2.default.createElement(_text2.default, { name: 'DriverLicense_' + key, value: val.DriverLicense || '', onChange: onChange, onBlur: _this6.updateCarRentalContract, labelText: (0, _helpers.translation)(16795) })
	        );
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(16788) },
	        Drivers.map(mapDrivers)
	      );
	    }
	  }, {
	    key: 'renderPeriod',
	    value: function renderPeriod() {
	      var Periods = this.state.Periods;
	
	
	      var getDate = function getDate(dateTime) {
	        return dateTime.split(' - ')[0];
	      };
	      var getTime = function getTime(dateTime) {
	        return dateTime.split(' - ')[1];
	      };
	
	      var renderPeriod = function renderPeriod(p, i) {
	        var start = (0, _time.renderFullDate)(p.Start);
	        var end = (0, _time.renderFullDate)(p.End);
	
	        return _react2.default.createElement(
	          'div',
	          { key: 'period_' + i },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(16771) },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [0] },
	              _react2.default.createElement(_text2.default, { value: getDate(start) || '', disabled: true }),
	              _react2.default.createElement(_text2.default, { value: getTime(start) || '', disabled: true })
	            )
	          ),
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(16772) },
	            _react2.default.createElement(
	              _inline2.default,
	              { block: true, fillChildNum: [0] },
	              _react2.default.createElement(_text2.default, { value: getDate(end) || '', disabled: true }),
	              _react2.default.createElement(_text2.default, { value: getTime(end) || '', disabled: true })
	            )
	          )
	        );
	      };
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(16784) },
	        Periods.map(renderPeriod)
	      );
	    }
	  }, {
	    key: 'renderRent',
	    value: function renderRent() {
	      var Rent = this.state.Rent;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(16785) },
	        _react2.default.createElement(_switch2.default, { name: 'Rent.Fuel', checked: Rent.Fuel, onChange: this.onChange, labelText: (0, _helpers.translation)(16797) }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)(16798) },
	          _react2.default.createElement(_radio2.default, { name: 'Rent.Tank', value: 0, checked: Rent.Tank === 0, onChange: this.onChange, labelText: (0, _helpers.translation)(16799) }),
	          _react2.default.createElement(_radio2.default, { name: 'Rent.Tank', value: 1, checked: Rent.Tank === 1, onChange: this.onChange, labelText: '1/4' }),
	          _react2.default.createElement(_radio2.default, { name: 'Rent.Tank', value: 2, checked: Rent.Tank === 2, onChange: this.onChange, labelText: '1/2' }),
	          _react2.default.createElement(_radio2.default, { name: 'Rent.Tank', value: 3, checked: Rent.Tank === 3, onChange: this.onChange, labelText: '3/4' }),
	          _react2.default.createElement(_radio2.default, { name: 'Rent.Tank', value: 4, checked: Rent.Tank === 4, onChange: this.onChange, labelText: (0, _helpers.translation)(16804) })
	        ),
	        _react2.default.createElement(_text2.default, { name: 'Rent.UpToKm', value: Rent.UpToKm || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(16800) }),
	        _react2.default.createElement(_text2.default, { name: 'Rent.ExtraKm', value: Rent.ExtraKm || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(16801) })
	      );
	    }
	  }, {
	    key: 'renderSummary',
	    value: function renderSummary() {
	      var KmAtStart = this.state.KmAtStart;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(16787) },
	        _react2.default.createElement(_text2.default, { name: 'KmAtStart', value: KmAtStart || '', onChange: this.onChange, onBlur: this.updateCarRentalContract, labelText: (0, _helpers.translation)(16802) })
	      );
	    }
	  }, {
	    key: 'renderRentConditions',
	    value: function renderRentConditions() {
	      var Conditions = this.state.Conditions;
	
	      return _react2.default.createElement(
	        _panel2.default,
	        { title: (0, _helpers.translation)(16789) },
	        _react2.default.createElement(
	          _actions2.default,
	          null,
	          _react2.default.createElement(_icon2.default, { icon: _icons.ElementIcons.Edit, size: 't', onClick: this.toggleEditConditions })
	        ),
	        _react2.default.createElement(_textarea2.default, { name: 'Conditions', disabled: !this.state.conditionsEdit, value: Conditions || '', onChange: this.onChange, onBlur: this.updateCarRentalContract })
	      );
	    }
	  }, {
	    key: 'renderActionHeader',
	    value: function renderActionHeader() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'top renderActionHeader' },
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)(16781)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // do not show print button on mobile devies
	      var bottomBar = {};
	      var isiPadPro = (0, _detect.isTouchDevice)() && /MacIntel/.test(navigator.platform);
	      if (_constants.isiOS || isiPadPro || this.md.phone() || this.md.tablet()) {
	        bottomBar = _react2.default.createElement(_bottomBar2.default, {
	          cancelLabelText: (0, _helpers.translation)(235),
	          onCancelClick: this.props.onClose,
	          center: true
	        });
	      } else {
	        bottomBar = _react2.default.createElement(_bottomBar2.default, {
	          actionLabelText: (0, _helpers.translation)(16803),
	          onActionClick: this.openPopup,
	          cancelLabelText: (0, _helpers.translation)(235),
	          onCancelClick: this.props.onClose,
	          center: true
	        });
	      }
	
	      return _react2.default.createElement(
	        _overlay2.default,
	        { overlayId: 'CarRentalContractOverlay', extraClassName: 'carrentalcontract-overlay' },
	        this.renderHeader(),
	        _react2.default.createElement(
	          _overlayContent2.default,
	          null,
	          bottomBar,
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            this.renderActionHeader(),
	            _react2.default.createElement(
	              _row2.default,
	              null,
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                this.renderLender(),
	                this.renderCar(),
	                this.renderInsurance()
	              ),
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                this.renderRenter(),
	                this.renderDrivers()
	              ),
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                this.renderPeriod(),
	                this.renderRent(),
	                this.renderSummary()
	              )
	            ),
	            _react2.default.createElement(
	              _row2.default,
	              null,
	              _react2.default.createElement(
	                _col2.default,
	                null,
	                this.renderRentConditions()
	              )
	            )
	          )
	        ),
	        this.state.carrentalcontractmodal && _react2.default.createElement(_CarRentalContractModal2.default, { show: this.state.carrentalcontractmodal, contract: this.state, onClose: this.closePopup, currencyCode: this.props.currencyCode })
	      );
	    }
	  }]);
	
	  return CarRentalContractOverlay;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    headerInfo: state.common.headerInfo,
	    currencyCode: state.common.currencyCode
	  };
	}
	
	CarRentalContractOverlay.defaultProps = {
	  carRentalId: 0
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  triggerPopup: _backdrop.triggerPopup,
	  getCarRentalContract: _carrentalcontracts.getCarRentalContract,
	  updateCarRentalContract: _carrentalcontracts.updateCarRentalContract
	})(CarRentalContractOverlay);

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1675);
	
	var _helpers = __webpack_require__(2);
	
	var _DeliveryStatusOverview = __webpack_require__(433);
	
	var _DeliveryStatusOverview2 = _interopRequireDefault(_DeliveryStatusOverview);
	
	var _overlay = __webpack_require__(131);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _OverlayHeader = __webpack_require__(174);
	
	var _OverlayHeader2 = _interopRequireDefault(_OverlayHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	
	var DeliveryStatusOverlay = function (_Component) {
	  _inherits(DeliveryStatusOverlay, _Component);
	
	  function DeliveryStatusOverlay(props) {
	    _classCallCheck(this, DeliveryStatusOverlay);
	
	    var _this = _possibleConstructorReturn(this, (DeliveryStatusOverlay.__proto__ || Object.getPrototypeOf(DeliveryStatusOverlay)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(DeliveryStatusOverlay, [{
	    key: 'renderExecutionTime',
	    value: function renderExecutionTime() {
	      var executionTime = null;
	      var overviewDeliveryData = this.props.OverviewDeliveryData;
	      if (overviewDeliveryData !== null && overviewDeliveryData.ExecutionTime !== null) {
	        executionTime = (0, _moment2.default)(overviewDeliveryData.ExecutionTime).format('HH:mm');
	      }
	      if (executionTime == null) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'executionTime' },
	        (0, _helpers.translation)('16608').replace('[time]', executionTime)
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      return _react2.default.createElement(
	        _OverlayHeader2.default,
	        { overlayId: 'DeliveryStatusOverlay', onClose: this.props.onClose },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderExecutionTime(),
	          _react2.default.createElement(
	            'div',
	            { className: 'heading-title' },
	            (0, _helpers.translation)('16721')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _overlay2.default,
	        { overlayId: 'DeliveryStatusOverlay', extraClassName: 'deliveryStatusOverlay' },
	        this.renderHeader(),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(_DeliveryStatusOverview2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return DeliveryStatusOverlay;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    OverviewDeliveryData: state.overview.OverviewDeliveryData
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(DeliveryStatusOverlay);

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _cloneDeep = __webpack_require__(531);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	__webpack_require__(1676);
	
	var _slidePanel = __webpack_require__(202);
	
	var _slidePanel2 = _interopRequireDefault(_slidePanel);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _common = __webpack_require__(25);
	
	var _employees = __webpack_require__(128);
	
	var _helpers = __webpack_require__(2);
	
	var _avatar = __webpack_require__(234);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// elements
	
	
	// Actions
	
	
	var SparePartStatus = {
	  None: 0, // Are ready
	  Unknown: 1, // Await order
	  NotInUse: 2,
	  InStock: 4, // Are ready
	  Ordered: 8, // Await receipt
	  Received: 16, // Are ready
	  Defective: 32,
	  Incorrect: 64
	};
	
	var FilterSlidePanel = function (_Component) {
	  _inherits(FilterSlidePanel, _Component);
	
	  function FilterSlidePanel(props) {
	    _classCallCheck(this, FilterSlidePanel);
	
	    var _this = _possibleConstructorReturn(this, (FilterSlidePanel.__proto__ || Object.getPrototypeOf(FilterSlidePanel)).call(this, props));
	
	    _this.state = {
	      filter: {
	        unassigned: false,
	        arrived: false,
	        estimationApproved: false,
	        sparePartsAreReady: false,
	        sparePartsAwaitReception: false,
	        sparePartsAreAwaitingOrder: false,
	        selectedEmployees: []
	      },
	      filteredOverview: [],
	      originalOverview: [],
	      employees: []
	      // employeesInRow: []
	    };
	    _this.filterSlidePanel = _this.filterSlidePanel.bind(_this);
	    _this.closeFilterSlidePanel = _this.closeFilterSlidePanel.bind(_this);
	    _this.updatefilterOverview = _this.updatefilterOverview.bind(_this);
	    _this.filterEmployeeFromRows = _this.filterEmployeeFromRows.bind(_this);
	    return _this;
	  }
	
	  _createClass(FilterSlidePanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(props) {
	      var _this2 = this;
	
	      this.setState({
	        originalOverview: this.props.data
	      }, function () {
	        _this2.filterSlidePanel();
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(previewProps) {
	      var _this3 = this;
	
	      if (this.props.view !== previewProps.view) {
	        if (this.props.view === 'employee' && this.state.employees.length < 1) {
	          this.props.getEmployees(this.props.auth.user.ShopId).then(function (res) {
	            if (Array.isArray(res.data)) {
	              var employees = res.data.filter(function (x) {
	                return x.Active && x.Confirmed;
	              });
	              employees.unshift({ UserId: 0, Name: (0, _helpers.translation)(17911), Initials: 'UA' }); // add unassign user at the first position.
	              _this3.setState({
	                employees: employees
	              });
	            }
	          });
	        }
	        this.setState({
	          originalOverview: previewProps.data
	        }, function () {
	          _this3.filterSlidePanel();
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this4 = this;
	
	      if (this.props.view !== nextProps.view) {
	        var filterStatus = (0, _cloneDeep2.default)(this.props.filterStatus);
	        this.setState({
	          filter: filterStatus,
	          originalOverview: nextProps.data
	        }, function () {
	          _this4.filterSlidePanel();
	        });
	      }
	    }
	  }, {
	    key: 'filterSlidePanel',
	    value: function filterSlidePanel() {
	      var overviewCopy = (0, _cloneDeep2.default)(this.state.originalOverview);
	      overviewCopy = this.props.filterCollection(overviewCopy, this.state.filter);
	      this.setState({
	        filteredOverview: overviewCopy
	      });
	    }
	  }, {
	    key: 'filterEmployeeFromRows',
	    value: function filterEmployeeFromRows(thisEmployee, rows) {
	      var count = 0;
	      var unAssignUser = { UserId: 0 };
	      rows.map(function (row) {
	        var employeesInRow = [];
	        row.Assignments.map(function (assignment) {
	          assignment.Employees.map(function (employee) {
	            if (employeesInRow.findIndex(function (x) {
	              return x.UserId === employee.UserId;
	            }) === -1) {
	              employeesInRow.push(employee);
	              if (thisEmployee.UserId === employee.UserId) {
	                count++;
	              }
	            }
	          });
	        });
	
	        // filter by unassign user
	        if (thisEmployee.UserId === 0 && row.HasUnassignedSteps) {
	          employeesInRow.push(unAssignUser);
	          count++;
	        }
	      });
	      return count;
	    }
	  }, {
	    key: 'closeFilterSlidePanel',
	    value: function closeFilterSlidePanel() {
	      if (this.props.onClose) this.props.onClose();
	      this.props.closeSlidePanel('filterOrder');
	    }
	  }, {
	    key: 'updatefilterOverview',
	    value: function updatefilterOverview() {
	      var filterCopy = (0, _cloneDeep2.default)(this.state.filter);
	      var filter = _extends({}, this.props.filterStatus, filterCopy);
	      this.props.filterOverview(filter);
	      this.closeFilterSlidePanel();
	    }
	  }, {
	    key: 'renderSparePart',
	    value: function renderSparePart() {
	      var _this5 = this;
	
	      if (this.state.filteredOverview === null) return null;
	      var filteredOverview = this.state.filteredOverview;
	      var originalOverview = this.state.originalOverview;
	      var sparePartsAreReadyCount = originalOverview.Rows.filter(function (x) {
	        return x.SparePartStatusSum === SparePartStatus.InStock || x.SparePartStatusSum === SparePartStatus.Received || x.SparePartStatusSum === SparePartStatus.None;
	      }).length;
	
	      var sparePartsAwaitReceptionCount = originalOverview.Rows.filter(function (x) {
	        return x.SparePartStatusSum === SparePartStatus.Ordered;
	      }).length;
	
	      var sparePartsAreAwaitingOrderCount = originalOverview.Rows.filter(function (x) {
	        return x.SparePartStatusSum === SparePartStatus.Unknown;
	      }).length;
	
	      var renderSpareParts = function renderSpareParts() {
	        var filter = _this5.state.filter;
	
	        var onChange = function onChange(e) {
	          var name = e.target.name;
	
	          if (name === 'sparePartsAreReady') {
	            filter.sparePartsAreReady = !filter.sparePartsAreReady;
	          }
	          if (name === 'sparePartsAwaitReception') {
	            filter.sparePartsAwaitReception = !filter.sparePartsAwaitReception;
	          }
	          if (name === 'sparePartsAreAwaitingOrder') {
	            filter.sparePartsAreAwaitingOrder = !filter.sparePartsAreAwaitingOrder;
	          }
	
	          _this5.setState({
	            filter: filter
	          }, function () {
	            return _this5.filterSlidePanel();
	          });
	        };
	        var customLabelText = function customLabelText(name) {
	          var className = '';
	          var translate = '';
	          if (name === 'sparePartsAreReady') {
	            className = sparePartsAreReadyCount === 0 && 'disabled-label-text';
	            translate = '17919';
	          }
	          if (name === 'sparePartsAwaitReception') {
	            className = sparePartsAwaitReceptionCount === 0 && 'disabled-label-text';
	            translate = '17920';
	          }
	          if (name === 'sparePartsAreAwaitingOrder') {
	            className = sparePartsAreAwaitingOrderCount === 0 && 'disabled-label-text';
	            translate = '17921';
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: className },
	            (0, _helpers.translation)(translate)
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(_check2.default, {
	              name: 'sparePartsAreReady',
	              labelText: customLabelText('sparePartsAreReady'),
	              checked: filter.sparePartsAreReady,
	              onChange: onChange,
	              disabled: sparePartsAreReadyCount === 0
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'filter-count' },
	              sparePartsAreReadyCount
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(_check2.default, {
	              name: 'sparePartsAwaitReception',
	              checked: filter.sparePartsAwaitReception,
	              labelText: customLabelText('sparePartsAwaitReception'),
	              onChange: onChange,
	              disabled: sparePartsAwaitReceptionCount === 0
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'filter-count' },
	              sparePartsAwaitReceptionCount
	            )
	          ),
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(_check2.default, {
	              name: 'sparePartsAreAwaitingOrder',
	              checked: filter.sparePartsAreAwaitingOrder,
	              labelText: customLabelText('sparePartsAreAwaitingOrder'),
	              onChange: onChange,
	              disabled: sparePartsAreAwaitingOrderCount === 0
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'filter-count' },
	              sparePartsAreAwaitingOrderCount
	            )
	          )
	        );
	      };
	
	      var actionText = (0, _helpers.translation)('16656').replace('[count]', filteredOverview.Rows.length);
	      return [_react2.default.createElement(
	        'div',
	        { className: 'header top', key: 0 },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          (0, _helpers.translation)('17917')
	        )
	      ), _react2.default.createElement(
	        'div',
	        { className: 'content filter', key: 1 },
	        renderSpareParts()
	      ), _react2.default.createElement(_bottomBar2.default, {
	        disabled: filteredOverview.Rows.length === 0,
	        actionLabelText: actionText,
	        onActionClick: function onActionClick() {
	          return _this5.updatefilterOverview('spareParts');
	        },
	        cancelLabelText: (0, _helpers.translation)('16444'),
	        onCancelClick: this.closeFilterSlidePanel,
	        key: 2
	      })];
	    }
	  }, {
	    key: 'renderEmployees',
	    value: function renderEmployees() {
	      var _this6 = this;
	
	      if (this.state.filteredOverview === null) return null;
	      var employees = this.state.employees;
	      var filteredOverview = this.state.filteredOverview;
	      var filter = this.state.filter;
	
	      var updateFilter = function updateFilter(filter) {
	        _this6.setState({
	          filter: filter
	        }, function () {
	          _this6.filterSlidePanel();
	        });
	      };
	
	      var renderAllEmployees = function renderAllEmployees(employee, key) {
	        var count = _this6.filterEmployeeFromRows(employee, _this6.state.originalOverview.Rows);
	        key += 1;
	        var onChange = function onChange(e) {
	          var _e$target = e.target,
	              value = _e$target.value,
	              checked = _e$target.checked;
	
	          var val = parseInt(value, 10);
	          if (checked) {
	            filter.selectedEmployees.push(val);
	            updateFilter(filter);
	          } else {
	            filter.selectedEmployees = _this6.state.filter.selectedEmployees.filter(function (x) {
	              return x !== val;
	            });
	            updateFilter(filter);
	          }
	        };
	        var labelText = function labelText() {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_avatar2.default, { initials: employee.Initials, size: 's' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              employee.Name
	            )
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [0], block: true },
	            _react2.default.createElement(_check2.default, {
	              name: employee.Name,
	              value: employee.UserId,
	              labelText: labelText(),
	              checked: _this6.state.filter.selectedEmployees.includes(employee.UserId),
	              onChange: onChange
	              // disabled={count === 0}
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'filter-count' },
	              count
	            )
	          )
	        );
	      };
	
	      var actionText = (0, _helpers.translation)('16656').replace('[count]', filteredOverview.Rows.length);
	      return [_react2.default.createElement(
	        'div',
	        { className: 'header top', key: 0 },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          (0, _helpers.translation)('17918')
	        )
	      ), _react2.default.createElement(
	        'div',
	        { className: 'content filter', key: 1 },
	        employees.map(renderAllEmployees)
	      ), _react2.default.createElement(_bottomBar2.default, {
	        disabled: filteredOverview.Rows.length === 0,
	        actionLabelText: actionText,
	        onActionClick: function onActionClick() {
	          return _this6.updatefilterOverview('spareParts');
	        },
	        cancelLabelText: (0, _helpers.translation)('16444'),
	        onCancelClick: this.closeFilterSlidePanel,
	        key: 2
	      })];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = null;
	      switch (this.props.view) {
	        case 'spareParts':
	          content = this.renderSparePart();
	          break;
	        case 'employee':
	          content = this.renderEmployees();
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'filterSlidePanel' },
	        _react2.default.createElement(
	          _slidePanel2.default,
	          { slidePanelId: 'filterOrder' },
	          content
	        )
	      );
	    }
	  }]);
	
	  return FilterSlidePanel;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  closeSlidePanel: _common.closeSlidePanel,
	  getEmployees: _employees.getEmployees
	})(FilterSlidePanel);

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _CarRentalPlate = __webpack_require__(1015);
	
	var _CarRentalPlate2 = _interopRequireDefault(_CarRentalPlate);
	
	var _timeLineSegment = __webpack_require__(455);
	
	var _timeLineSegment2 = _interopRequireDefault(_timeLineSegment);
	
	__webpack_require__(1677);
	
	var _lodash = __webpack_require__(27);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeLineStep = function (_Component) {
	  _inherits(TimeLineStep, _Component);
	
	  function TimeLineStep() {
	    _classCallCheck(this, TimeLineStep);
	
	    return _possibleConstructorReturn(this, (TimeLineStep.__proto__ || Object.getPrototypeOf(TimeLineStep)).apply(this, arguments));
	  }
	
	  _createClass(TimeLineStep, [{
	    key: 'getProcessLine',
	    value: function getProcessLine(step) {
	      var _this2 = this;
	
	      var icon = void 0,
	          text = void 0,
	          bottom = void 0;
	      switch (step.StepType) {
	        case 1:
	          icon = _icons.ProductionStatus.Step_New;
	          text = 164;
	          break;
	
	        case 2:
	          icon = _icons.ProductionStatus.Step_BodyShopDisassemply;
	          text = 617;
	          if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date);
	          break;
	
	        case 3:
	          icon = _icons.ProductionStatus.Step_BodyShopRepair;
	          text = 618;
	          if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date);
	          if (this.props.orderTimeLine.NeedSparePartOrdering) bottom = this.renderIssueLine((0, _helpers.translation)(637)); // Spare parts
	          break;
	
	        case 4:
	        case 8:
	          icon = _icons.ProductionStatus.Step_Painting;
	          text = 161;
	          if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date);
	          if (this.props.orderTimeLine.NeedPaintBooking) bottom = this.renderIssueLine((0, _helpers.translation)(412)); // Not booked
	          break;
	
	        case 10:
	          icon = _icons.ProductionStatus.Step_BodyShopAssembly;
	          text = 619;
	          if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date);
	          break;
	
	        case 11:
	          icon = _icons.ProductionStatus.Step_BodyShopFinishing;
	          text = 162;
	          if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date);
	          break;
	
	        case 12:
	          icon = _icons.ProductionStatus.Step_Handover;
	          text = 163;
	          if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date);
	          break;
	
	        case 13:
	          icon = _icons.ProductionStatus.Step_Completed;
	          text = 16669;
	          if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date);
	          break;
	
	        case 14:
	        case 15:
	          icon = _icons.MainMenuIcons.CarRental_Black;
	          text = 629;
	          bottom = this.renderDateLine(step.Date);
	          break;
	
	        default:
	          break;
	      }
	
	      var renderCarRental = function renderCarRental(step) {
	        if ((0, _lodash.isArray)(step.CarRentals) && step.CarRentals.length > 0) {
	          // Show only 2 rentals
	          var carRentals = step.CarRentals.slice(0, 2);
	          var hiddenEntries = step.CarRentals.length - 2;
	          return _react2.default.createElement(
	            'span',
	            { className: 'carrental-plates' },
	            carRentals.map(function (x) {
	              return _react2.default.createElement(_CarRentalPlate2.default, { regNr: x.RegNr, countryCode: _this2.props.CountryCode, nr: x.CarNumber });
	            }),
	            hiddenEntries > 0 ? _react2.default.createElement(
	              'span',
	              { className: 'hidden-cars' },
	              '+ ' + hiddenEntries
	            ) : null
	          );
	        }
	        return null;
	      };
	      var topLineClasses = 'top';
	      if ((0, _lodash.isArray)(step.CarRentals) && step.CarRentals.length > 0) topLineClasses += ' full rental';
	      return [_react2.default.createElement(
	        'div',
	        { className: topLineClasses, key: 'top' },
	        _react2.default.createElement(
	          'div',
	          { className: 'processIcon' },
	          _react2.default.createElement(_icon2.default, { icon: icon, size: 's', injectSvg: true })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'processName' },
	          _react2.default.createElement(
	            'span',
	            { className: 'processName__text' },
	            (0, _helpers.translation)(text)
	          ),
	          renderCarRental(step)
	        )
	      ), _react2.default.createElement(
	        'div',
	        { className: 'bottom', key: 'bottom' },
	        bottom
	      )];
	    }
	  }, {
	    key: 'renderDateLine',
	    value: function renderDateLine(dateTime) {
	      if (dateTime === null) return null;
	
	      var formatDateTime = function formatDateTime(dateTime) {
	        var locale = 'en';
	        var languageName = window.localStorage.getItem('user_language');
	        switch (languageName) {
	          case 'Danish':
	            locale = 'da';
	            break;
	          case 'English':
	            locale = 'en';
	            break;
	          case 'Swedish':
	            locale = 'se';
	            break;
	          case 'Norwegian':
	            locale = 'nb_NO';
	            break;
	        }
	
	        var mom = (0, _moment2.default)(dateTime).locale(locale);
	        var dayOfWeek = mom.format('dddd');
	        var day = mom.format('D');
	        var month = mom.format('MMM');
	        var hour = mom.format('k'); // "k" of all things...!
	        var min = mom.format('mm');
	        dayOfWeek = dayOfWeek.slice(0, 1).toUpperCase() + dayOfWeek.slice(1);
	        month = month.slice(0, 1).toUpperCase() + month.slice(1);
	        return dayOfWeek + ', ' + day + ' ' + month + ' \xB7 ' + hour + ':' + min;
	      };
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'indented-datetime' },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Indent, injectSvg: true, size: 't' })
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          formatDateTime(dateTime)
	        )
	      );
	    }
	  }, {
	    key: 'renderIssueLine',
	    value: function renderIssueLine(issueText) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'indented-issue' },
	        _react2.default.createElement(
	          'span',
	          { className: 'indent-icon' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Indent, injectSvg: true, size: 't' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'issue-icon' },
	          _react2.default.createElement(_icon2.default, { icon: _icons.TimeLineIcons.Exclamation_Red, size: 't' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'issue-text' },
	          issueText
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.step === undefined || this.props.step === null) return null;
	      var step = this.props.step;
	
	      var stepClassname = 'timelineStep';
	      if (step.Active) {
	        stepClassname += ' active';
	      } else if (step.Completed) {
	        stepClassname += ' completed';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: stepClassname, key: this.props.key },
	        _react2.default.createElement(
	          'div',
	          { className: 'lines' },
	          _react2.default.createElement(_timeLineSegment2.default, { lines: step.Lines, active: step.Active, topHeight: '14px', bottomHeight: '1fr' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'process' },
	          this.getProcessLine(step)
	        ),
	        step.TimeAssessment !== undefined && _react2.default.createElement(
	          'div',
	          { className: 'assessment' },
	          step.TimeAssessment
	        ),
	        step.TimeAssessment !== undefined && _react2.default.createElement(
	          'div',
	          { className: 'available' },
	          step.TimeAvailable
	        )
	      );
	    }
	  }]);
	
	  return TimeLineStep;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(TimeLineStep);

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1678);
	
	var _slidePanel = __webpack_require__(202);
	
	var _slidePanel2 = _interopRequireDefault(_slidePanel);
	
	var _icons = __webpack_require__(6);
	
	var _iconAccordion = __webpack_require__(201);
	
	var _iconAccordion2 = _interopRequireDefault(_iconAccordion);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _avatar = __webpack_require__(234);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _common = __webpack_require__(25);
	
	var _calendarOverview = __webpack_require__(402);
	
	var _helpers = __webpack_require__(2);
	
	var _TimeLineStep = __webpack_require__(1120);
	
	var _TimeLineStep2 = _interopRequireDefault(_TimeLineStep);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _FileArea = __webpack_require__(1044);
	
	var _FileArea2 = _interopRequireDefault(_FileArea);
	
	var _Notes = __webpack_require__(1053);
	
	var _Notes2 = _interopRequireDefault(_Notes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// elements
	
	// import Inline from '../../../elements/inline'
	// import Panel from '../../../elements/panel'
	// import Label from '../../../elements/label'
	// import Grid from '../../../elements/grid'
	
	// Actions
	
	// import { renderFullDate } from '../../../../utils/time'
	
	// components
	
	// import Inline from '../../../elements/inline'
	
	// import UserInfo from '../../../components/UserInfo'
	
	
	// import LabelWrapper from '../../../elements/labelWrapper'
	// import PanelHeader from '../../../elements/panelHeader'
	
	var TimelineSlidePanel = function (_Component) {
	  _inherits(TimelineSlidePanel, _Component);
	
	  function TimelineSlidePanel(props) {
	    _classCallCheck(this, TimelineSlidePanel);
	
	    var _this = _possibleConstructorReturn(this, (TimelineSlidePanel.__proto__ || Object.getPrototypeOf(TimelineSlidePanel)).call(this, props));
	
	    _this.state = {
	      orderTimeline: undefined
	    };
	    _this.closeTimeLineSlidePanel = _this.closeTimeLineSlidePanel.bind(_this);
	    return _this;
	  }
	
	  _createClass(TimelineSlidePanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(props) {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.props.orderId !== undefined && this.props.orderId !== null && this.props.orderId !== prevProps.orderId) {
	        this.props.getOrderTimeline(this.props.orderId, this.props.currentTime || new Date()).then(function (res) {
	          _this2.setState({
	            orderTimeline: res.data
	          });
	        });
	      }
	    }
	  }, {
	    key: 'closeTimeLineSlidePanel',
	    value: function closeTimeLineSlidePanel() {
	      var _this3 = this;
	
	      if (this.props.onClose) this.props.onClose();
	      this.setState({
	        orderTimeline: undefined
	      }, function () {
	        _this3.props.closeSlidePanel('orderTimeline');
	      });
	    }
	  }, {
	    key: 'renderTop',
	    value: function renderTop() {
	      var _state$orderTimeline = this.state.orderTimeline,
	          OrderId = _state$orderTimeline.OrderId,
	          RegNr = _state$orderTimeline.RegNr,
	          Model = _state$orderTimeline.Model,
	          BrandName = _state$orderTimeline.BrandName,
	          Color = _state$orderTimeline.Color;
	
	
	      var carIdentity = RegNr;
	      if (carIdentity === null || carIdentity === '') carIdentity = Model;
	      if (carIdentity === null || carIdentity === '') carIdentity = OrderId;
	
	      var carInfo = (BrandName + ' ' + Model).trim();
	      if (carInfo !== null && carInfo !== '' && Color !== null && Color !== '') carInfo += ' - ' + Color;else if (carInfo === null || carInfo === '') carInfo = Color || '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'header top', key: 'top' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          carIdentity
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'sub-title' },
	          carInfo.toUpperCase()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'close title-right' },
	          _react2.default.createElement(_closeButton2.default, { onClick: this.closeTimeLineSlidePanel })
	        )
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this4 = this;
	
	      var renderEmployees = function renderEmployees() {
	        var employees = _this4.state.orderTimeline.EmployeeAssignments;
	        var hasUnassigned = _this4.state.orderTimeline.HasUnassignedSteps;
	        if (!Array.isArray(employees)) return null;
	
	        var accordionComponents = employees.map(function (x) {
	          return { customComponent: _avatar2.default, initials: x.Initials, noCircle: true };
	        });
	
	        if (hasUnassigned) {
	          accordionComponents.push({ icon: _icons.CapacityManagementIcons.Warning_assign, size: 'm', noCircle: true });
	        }
	        var firstEmployeeName = null;
	        var additionalEmployeeCount = employees.length - 1;
	        if (employees.length > 0) {
	          firstEmployeeName = employees.slice(0, 1)[0].Name;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'employees', key: 'employees' },
	          _react2.default.createElement(_iconAccordion2.default, { icons: accordionComponents, size: 'm' }),
	          !hasUnassigned && firstEmployeeName !== null && _react2.default.createElement(
	            'span',
	            { className: 'employee-name' },
	            firstEmployeeName
	          ),
	          !hasUnassigned && additionalEmployeeCount > 0 && _react2.default.createElement(
	            'span',
	            { className: 'employee-additional' },
	            '+ ' + additionalEmployeeCount
	          ),
	          hasUnassigned && _react2.default.createElement(
	            'span',
	            { className: 'employee-issue' },
	            (0, _helpers.translation)(17911)
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'content timeline', key: 'content' },
	        renderEmployees(),
	        _react2.default.createElement(
	          'div',
	          { className: 'timelineContent' },
	          _react2.default.createElement(
	            'div',
	            { className: 'timelineTitle' },
	            _react2.default.createElement(
	              'div',
	              { className: 'process' },
	              (0, _helpers.translation)(359)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'assessment' },
	              (0, _helpers.translation)(17928)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'available' },
	              (0, _helpers.translation)(1780)
	            )
	          ),
	          this.state.orderTimeline.TimelineSteps.map(function (x, index) {
	            return _react2.default.createElement(_TimeLineStep2.default, { step: x, orderTimeLine: _this4.state.orderTimeline, key: index });
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderBottom',
	    value: function renderBottom() {
	      var _this5 = this;
	
	      var workCardOnClick = function workCardOnClick() {
	        if (_this5.props.orderId !== -1) {
	          _this5.props.openWorkcard('/orders/' + _this5.props.orderId);
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'totals-sticky', key: 'bottom' },
	        _react2.default.createElement(_button2.default, { size: 'm', style: 'link', spacing: 0, labelText: 159, onClick: workCardOnClick.bind(this) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'process' },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _helpers.translation)(470)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'assessment' },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.state.orderTimeline.TotalTimeAssessment
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'available' },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.state.orderTimeline.TotalTimeAvaliable
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTimeline',
	    value: function renderTimeline() {
	      var orderTimeline = this.state.orderTimeline;
	      if (orderTimeline === undefined) return null;
	
	      return [this.renderTop(), _react2.default.createElement(
	        'div',
	        { className: 'content', key: 'content-wrap' },
	        [this.renderContent(), this.renderBottom(), this.renderOrderNotesAndImages()]
	      )];
	    }
	  }, {
	    key: 'renderOrderNotesAndImages',
	    value: function renderOrderNotesAndImages() {
	      if (!this.state.orderTimeline) return null;
	      var _state$orderTimeline2 = this.state.orderTimeline,
	          OrderFiles = _state$orderTimeline2.OrderFiles,
	          orderNotes = _state$orderTimeline2.Notes;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'notes-files', key: 'notes' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            (0, _helpers.translation)(14834) + ' (' + (orderNotes ? orderNotes.length : 0) + ')'
	          ),
	          _react2.default.createElement(_Notes2.default, { notes: orderNotes, inline: true })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            (0, _helpers.translation)(1043)
	          ),
	          _react2.default.createElement(_FileArea2.default, { otherFiles: OrderFiles.filter(function (x) {
	              return !x.IsImage;
	            }), images: OrderFiles.filter(function (x) {
	              return x.IsImage;
	            }), auth: this.props.auth })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'timelineSlidePanel' },
	        _react2.default.createElement(
	          _slidePanel2.default,
	          { slidePanelId: 'orderTimeline' },
	          this.renderTimeline()
	        )
	      );
	    }
	  }]);
	
	  return TimelineSlidePanel;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  closeSlidePanel: _common.closeSlidePanel,
	  getOrderTimeline: _calendarOverview.getOrderTimeline
	})(TimelineSlidePanel);

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	__webpack_require__(1679);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterBar = function (_Component) {
	  _inherits(FilterBar, _Component);
	
	  function FilterBar(props) {
	    _classCallCheck(this, FilterBar);
	
	    var _this = _possibleConstructorReturn(this, (FilterBar.__proto__ || Object.getPrototypeOf(FilterBar)).call(this, props));
	
	    _this.openFilterSlidePanel = _this.openFilterSlidePanel.bind(_this);
	    return _this;
	  }
	
	  _createClass(FilterBar, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      if (this.props.onChange !== null) {
	        this.props.onChange(e);
	      }
	    }
	  }, {
	    key: 'openFilterSlidePanel',
	    value: function openFilterSlidePanel(e) {
	      if (this.props.openFilterSlidePanel !== null) {
	        this.props.openFilterSlidePanel(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'min-content'], align: 'center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'filter-bar__items' },
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(
	                'span',
	                { className: 'filter-bar__title' },
	                (0, _helpers.translation)('16659')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_check2.default, {
	                name: 'arrived',
	                labelText: 14798,
	                spacing: 0,
	                checked: this.props.filter.arrived,
	                onChange: this.props.onChange
	              })
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_check2.default, {
	                name: 'estimationApproved',
	                labelText: (0, _helpers.translation)('15002'),
	                spacing: 0,
	                checked: this.props.filter.estimationApproved,
	                onChange: this.props.onChange
	              })
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_button2.default, { size: 'm', style: 'link', spacing: 0, labelText: 17926, onClick: this.props.openFilterSlidePanel.bind(this, 'spareParts') })
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_button2.default, { size: 'm', style: 'link', spacing: 0, labelText: 450, onClick: this.props.openFilterSlidePanel.bind(this, 'employee') })
	            )
	          ),
	          _react2.default.createElement(_closeButton2.default, { size: 's', spacing: 0, ariaLabel: (0, _helpers.translation)('394'), onClick: this.props.onClose })
	        )
	      );
	    }
	  }]);
	
	  return FilterBar;
	}(_react.Component);
	
	exports.default = FilterBar;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(2);
	
	var _icons = __webpack_require__(6);
	
	var _closeButton = __webpack_require__(63);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _circle = __webpack_require__(300);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _progressLine = __webpack_require__(454);
	
	var _progressLine2 = _interopRequireDefault(_progressLine);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(1680);
	
	var _circleButton = __webpack_require__(450);
	
	var _circleButton2 = _interopRequireDefault(_circleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoBar = function (_Component) {
	  _inherits(InfoBar, _Component);
	
	  function InfoBar(props) {
	    _classCallCheck(this, InfoBar);
	
	    var _this = _possibleConstructorReturn(this, (InfoBar.__proto__ || Object.getPrototypeOf(InfoBar)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(InfoBar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'capacity-calendar-info-bar' },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [1, 'min-content'], align: 'center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'capacity-calendar-info-bar__icons' },
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_circle2.default, { size: 't', color: 'brand-2' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('17897')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_progressLine2.default, null),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('16600')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_progressLine2.default, { color: 'yellow' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('18332')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_progressLine2.default, { color: 'red' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('17898')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_circleButton2.default, { size: 's', icon: _icons.CapacityManagementIcons.Calendar }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('18299')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_circleButton2.default, { size: 's', icon: _icons.CapacityManagementIcons.List_View }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('18300')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_circleButton2.default, { size: 's', icon: _icons.CapacityManagementIcons.Assign }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('1856')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Warning_attention_white, size: 's', injectSvg: true }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('18301')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Warning_Order_stop, size: 's', injectSvg: true }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('18302')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Warning_spare_part, size: 's', injectSvg: true }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('18303')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Warning_delayed, size: 's', injectSvg: true }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('18304')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.warning_painter, size: 's', injectSvg: true }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('18305')
	              )
	            ),
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_icon2.default, { icon: _icons.CapacityManagementIcons.Warning_assign, size: 's', injectSvg: true }),
	              _react2.default.createElement(
	                'span',
	                { className: 'capacity-calendar-info-bar__label' },
	                (0, _helpers.translation)('18306')
	              )
	            )
	          ),
	          _react2.default.createElement(_closeButton2.default, { size: 's', spacing: 0, ariaLabel: (0, _helpers.translation)('394'), onClick: this.props.onClose })
	        )
	      );
	    }
	  }]);
	
	  return InfoBar;
	}(_react.Component);
	
	exports.default = InfoBar;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1682);
	
	var _circle = __webpack_require__(300);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverviewOrderInfo = function (_Component) {
	  _inherits(OverviewOrderInfo, _Component);
	
	  function OverviewOrderInfo(props) {
	    _classCallCheck(this, OverviewOrderInfo);
	
	    var _this = _possibleConstructorReturn(this, (OverviewOrderInfo.__proto__ || Object.getPrototypeOf(OverviewOrderInfo)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(OverviewOrderInfo, [{
	    key: 'render',
	    value: function render() {
	      if (!this.props.info) {
	        console.error('OverviewOrderInfo requires info prop');
	      }
	
	      var info = this.props.info;
	
	      var activeClass = this.props.active ? ' active' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'overview-order-info' },
	        this.props.orderInfoIcon,
	        _react2.default.createElement(
	          'div',
	          { className: 'overview-order-info__content' + activeClass },
	          _react2.default.createElement(
	            'div',
	            { onClick: this.props.onHeaderClick, className: 'overview-order-info__content__title ellipsis' },
	            info.Identity,
	            ' ',
	            info.IsWorkedOn !== undefined && info.IsWorkedOn && _react2.default.createElement(_circle2.default, { size: 't', color: 'brand-2' })
	          ),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return OverviewOrderInfo;
	}(_react.Component);
	
	OverviewOrderInfo.defaultProps = {
	  onHeaderClick: function onHeaderClick() {},
	  active: false
	};
	
	exports.default = OverviewOrderInfo;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1683);
	
	var _helpers = __webpack_require__(2);
	
	var _PickupStatusOverview = __webpack_require__(1059);
	
	var _PickupStatusOverview2 = _interopRequireDefault(_PickupStatusOverview);
	
	var _overlay = __webpack_require__(131);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _OverlayHeader = __webpack_require__(174);
	
	var _OverlayHeader2 = _interopRequireDefault(_OverlayHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	
	var PickupStatusOverlay = function (_Component) {
	  _inherits(PickupStatusOverlay, _Component);
	
	  function PickupStatusOverlay(props) {
	    _classCallCheck(this, PickupStatusOverlay);
	
	    var _this = _possibleConstructorReturn(this, (PickupStatusOverlay.__proto__ || Object.getPrototypeOf(PickupStatusOverlay)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(PickupStatusOverlay, [{
	    key: 'renderExecutionTime',
	    value: function renderExecutionTime() {
	      var executionTime = null;
	      var overviewPickupData = this.props.OverviewPickupData;
	      if (overviewPickupData !== null && overviewPickupData.ExecutionTime !== null) {
	        executionTime = (0, _moment2.default)(overviewPickupData.ExecutionTime).format('HH:mm');
	      }
	      if (executionTime == null) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'executionTime' },
	        (0, _helpers.translation)('16608').replace('[time]', executionTime)
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      return _react2.default.createElement(
	        _OverlayHeader2.default,
	        { overlayId: 'PickupStatusOverlay', onClose: this.props.onClose },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderExecutionTime(),
	          _react2.default.createElement(
	            'div',
	            { className: 'heading-title' },
	            (0, _helpers.translation)('16839')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _overlay2.default,
	        { overlayId: 'PickupStatusOverlay', extraClassName: 'pickupStatusOverlay' },
	        this.renderHeader(),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(_PickupStatusOverview2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return PickupStatusOverlay;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    OverviewPickupData: state.overview.OverviewPickupData
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(PickupStatusOverlay);

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1684);
	
	var _helpers = __webpack_require__(2);
	
	var _ProductionStatusOverview = __webpack_require__(445);
	
	var _ProductionStatusOverview2 = _interopRequireDefault(_ProductionStatusOverview);
	
	var _overlay = __webpack_require__(131);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _OverlayHeader = __webpack_require__(174);
	
	var _OverlayHeader2 = _interopRequireDefault(_OverlayHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Components
	
	
	// Elements
	
	
	var ProductionStatusOverlay = function (_Component) {
	  _inherits(ProductionStatusOverlay, _Component);
	
	  function ProductionStatusOverlay(props) {
	    _classCallCheck(this, ProductionStatusOverlay);
	
	    var _this = _possibleConstructorReturn(this, (ProductionStatusOverlay.__proto__ || Object.getPrototypeOf(ProductionStatusOverlay)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ProductionStatusOverlay, [{
	    key: 'renderExecutionTime',
	    value: function renderExecutionTime() {
	      var executionTime = null;
	      var overviewProductionData = this.props.OverviewProductionData;
	      if (overviewProductionData !== null && overviewProductionData.ExecutionTime !== null) {
	        executionTime = (0, _moment2.default)(overviewProductionData.ExecutionTime).format('HH:mm');
	      }
	      if (executionTime == null) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'executionTime' },
	        (0, _helpers.translation)('16608').replace('[time]', executionTime)
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      return _react2.default.createElement(
	        _OverlayHeader2.default,
	        { overlayId: 'ProductionStatusOverlay', onClose: this.props.onClose },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderExecutionTime(),
	          _react2.default.createElement(
	            'div',
	            { className: 'heading-title' },
	            (0, _helpers.translation)('16599')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _overlay2.default,
	        { overlayId: 'ProductionStatusOverlay', extraClassName: 'productionStatusOverlay' },
	        this.renderHeader(),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(_ProductionStatusOverview2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return ProductionStatusOverlay;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    OverviewProductionData: state.overview.OverviewProductionData
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(ProductionStatusOverlay);

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reports = __webpack_require__(798);
	
	var _common = __webpack_require__(25);
	
	var _overlay = __webpack_require__(131);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _matching = __webpack_require__(1128);
	
	var _matching2 = _interopRequireDefault(_matching);
	
	var _OverlayHeaderBare = __webpack_require__(296);
	
	var _OverlayHeaderBare2 = _interopRequireDefault(_OverlayHeaderBare);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Components
	
	
	// Misc.
	
	
	var ReportMergeOverlay = function (_Component) {
	  _inherits(ReportMergeOverlay, _Component);
	
	  function ReportMergeOverlay(props) {
	    _classCallCheck(this, ReportMergeOverlay);
	
	    var _this = _possibleConstructorReturn(this, (ReportMergeOverlay.__proto__ || Object.getPrototypeOf(ReportMergeOverlay)).call(this, props));
	
	    _this.state = {
	      title: '',
	      targets: [],
	      sources: [],
	      isLoading: true
	    };
	
	    _this.renderHeader = _this.renderHeader.bind(_this);
	    _this.handleOnMatch = _this.handleOnMatch.bind(_this);
	    _this.handleResponseData = _this.handleResponseData.bind(_this);
	    _this.handleOnCancallation = _this.handleOnCancallation.bind(_this);
	    _this.getMerges = _this.getMerges.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReportMergeOverlay, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.item) return;
	
	      if (JSON.stringify(this.props.item) !== JSON.stringify(prevProps.item)) {
	        this.getMerges();
	      }
	    }
	  }, {
	    key: 'getMerges',
	    value: function getMerges() {
	      var _this2 = this;
	
	      this.setState({ title: '', targets: [], sources: [], isLoading: true });
	      this.props.getPendingMerges(this.props.item.OrderId).then(function (res) {
	        var _res$data = res.data,
	            Sources = _res$data.Sources,
	            Targets = _res$data.Targets,
	            Title = _res$data.Title;
	
	        _this2.setState({
	          title: Title,
	          sources: Sources,
	          targets: Targets,
	          isLoading: false
	        });
	      }).catch(function (_) {
	        return window.toastr.error((0, _helpers.translation)('2269'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'handleOnMatch',
	    value: function handleOnMatch(data) {
	      var _this3 = this;
	
	      this.props.reportOrderMatch(data).then(function (res) {
	        // window.toastr.success(translation('18078'), translation('13424'))
	        _this3.handleResponseData(res.data);
	      }).catch(function (_) {
	        return window.toastr.error((0, _helpers.translation)('18068'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'handleOnCancallation',
	    value: function handleOnCancallation(data) {
	      var _this4 = this;
	
	      this.props.cancelReportOrder(data).then(function (res) {
	        // window.toastr.success(translation('18080'), translation('13424'))
	        _this4.handleResponseData(res.data);
	      }).catch(function (_) {
	        return window.toastr.error((0, _helpers.translation)('18081'), (0, _helpers.translation)('216'));
	      });
	    }
	  }, {
	    key: 'handleResponseData',
	    value: function handleResponseData(data) {
	      var Sources = data.Sources,
	          Targets = data.Targets,
	          Title = data.Title;
	
	      if (Sources.length === 0) this.props.closeOverlay('ReportMergeOverlay');
	
	      this.setState({
	        title: Title,
	        sources: Sources,
	        targets: Targets
	      });
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      return _react2.default.createElement(
	        _OverlayHeaderBare2.default,
	        { overlayId: 'ReportMergeOverlay', custom: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'top topHeaderInfo' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.state.title
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          sources = _state.sources,
	          targets = _state.targets,
	          isLoading = _state.isLoading;
	
	
	      return _react2.default.createElement(
	        _overlay2.default,
	        { overlayId: 'ReportMergeOverlay', extraClassName: 'report-merge-overlay' },
	        this.renderHeader(),
	        _react2.default.createElement(_matching2.default, {
	          isLoading: isLoading,
	          targets: targets,
	          sources: sources,
	          onMatch: this.handleOnMatch,
	          onCancallation: this.handleOnCancallation
	        })
	      );
	    }
	  }]);
	
	  return ReportMergeOverlay;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    headerInfo: state.common.headerInfo
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getPendingMerges: _reports.getPendingMerges,
	  reportOrderMatch: _reports.reportOrderMatch,
	  cancelReportOrder: _reports.cancelReportOrder,
	  closeOverlay: _common.closeOverlay
	})(ReportMergeOverlay);

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _orders = __webpack_require__(21);
	
	var _Extent = __webpack_require__(153);
	
	var _Extent2 = _interopRequireDefault(_Extent);
	
	var _List = __webpack_require__(421);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _tableExpand = __webpack_require__(140);
	
	var _tableExpand2 = _interopRequireDefault(_tableExpand);
	
	var _tableHeader = __webpack_require__(132);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _overlayContent = __webpack_require__(177);
	
	var _overlayContent2 = _interopRequireDefault(_overlayContent);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _currency = __webpack_require__(41);
	
	__webpack_require__(1685);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Elements
	
	
	// Utils
	
	
	var Matching = function (_Component) {
	  _inherits(Matching, _Component);
	
	  function Matching(props) {
	    _classCallCheck(this, Matching);
	
	    var _this = _possibleConstructorReturn(this, (Matching.__proto__ || Object.getPrototypeOf(Matching)).call(this, props));
	
	    _this.state = {
	      targets: [],
	      sources: [],
	      selectedTarget: undefined,
	      selectedSource: undefined,
	      orderItems: {}
	    };
	
	    _this.resetMatch = _this.resetMatch.bind(_this);
	    _this.handleMatch = _this.handleMatch.bind(_this);
	    _this.renderTargets = _this.renderTargets.bind(_this);
	    _this.renderSources = _this.renderSources.bind(_this);
	    _this.checkForPropChanges = _this.checkForPropChanges.bind(_this);
	    _this.handleCancallation = _this.handleCancallation.bind(_this);
	    return _this;
	  }
	
	  _createClass(Matching, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkForPropChanges();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.checkForPropChanges();
	    }
	  }, {
	    key: 'checkForPropChanges',
	    value: function checkForPropChanges() {
	      var _this2 = this;
	
	      if (!(0, _lodash.isEqual)(this.props.targets, this.state.targets)) {
	        this.setState({ targets: this.props.targets });
	      }
	
	      if (!(0, _lodash.isEqual)(this.props.sources, this.state.sources)) {
	        this.setState({ sources: this.props.sources });
	      }
	
	      if (!(0, _lodash.isEqual)(this.props.sources, this.state.sources) || !(0, _lodash.isEqual)(this.props.targets, this.state.targets)) {
	        this.resetMatch();
	
	        var orderIds = [].concat(_toConsumableArray(this.props.targets), _toConsumableArray(this.props.sources));
	        for (var i = 0; i < orderIds.length; i++) {
	          // Get data for the  missing orders
	          var orderId = orderIds[i].OrderId;
	          if (this.state.orderItems[orderId] === undefined) {
	            this.props.getOrderSimple(orderId).then(function (res) {
	              _this2.setState({
	                orderItems: _extends({}, _this2.state.orderItems, _defineProperty({}, res.data.Id, res.data))
	              });
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'handleMatch',
	    value: function handleMatch() {
	      var data = {
	        TargetOrderId: this.state.selectedTarget,
	        SourceOrderId: this.state.selectedSource
	      };
	      this.props.onMatch(data);
	    }
	  }, {
	    key: 'handleCancallation',
	    value: function handleCancallation() {
	      this.props.onCancallation(this.state.selectedSource);
	    }
	  }, {
	    key: 'resetMatch',
	    value: function resetMatch() {
	      this.setState({
	        selectedTarget: undefined,
	        selectedSource: undefined
	      });
	    }
	  }, {
	    key: 'renderLinePair',
	    value: function renderLinePair(langKey, value) {
	      return [_react2.default.createElement(
	        _label2.default,
	        { key: 0 },
	        (0, _helpers.translation)(langKey).replace(':', ''),
	        ':'
	      ), _react2.default.createElement(
	        _label2.default,
	        { key: 1 },
	        value
	      )];
	    }
	  }, {
	    key: 'renderSectionExpander',
	    value: function renderSectionExpander(title, children) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'grid-span-2', onClick: function onClick(e) {
	            return e.stopPropagation();
	          } },
	        _react2.default.createElement(
	          _tableContainer2.default,
	          null,
	          _react2.default.createElement(
	            _tableExpand2.default,
	            null,
	            _react2.default.createElement(
	              _tableHeader2.default,
	              { cols: '1fr min-content' },
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                title
	              )
	            ),
	            _react2.default.createElement(
	              _tableRow2.default,
	              { cols: '1fr' },
	              children
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTargets',
	    value: function renderTargets() {
	      var _this3 = this;
	
	      var _state = this.state,
	          targets = _state.targets,
	          selectedTarget = _state.selectedTarget;
	      var isLoading = this.props.isLoading;
	
	
	      var renderItem = function renderItem(item, index) {
	        var OrderId = item.OrderId,
	            CreationDate = item.CreationDate,
	            Price = item.Price,
	            CreatedBy = item.CreatedBy,
	            BookedBy = item.BookedBy,
	            StepDictionaryKey = item.StepDictionaryKey,
	            RekvNumber = item.RekvNumber;
	
	        var isSelected = OrderId === selectedTarget;
	        var showBodyExtent = _this3.props.auth.departmentType === 1;
	        var orderItem = _this3.state.orderItems[OrderId];
	        var orderItemHasSpareParts = orderItem && (Array.isArray(orderItem.NewSparePartItems) && orderItem.NewSparePartItems.length > 0 || Array.isArray(orderItem.SparePartItems) && orderItem.SparePartItems.length > 0);
	
	        var onSelect = function onSelect(_) {
	          return _this3.setState({ selectedTarget: OrderId });
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          {
	            key: index,
	            cols: 'min-content 1fr',
	            className: 'order__item',
	            onClick: onSelect },
	          _react2.default.createElement(_radio2.default, {
	            size: 'l',
	            labelText: '',
	            onClick: onSelect,
	            checked: isSelected
	          }),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: 'auto 1fr', className: 'item-content' },
	            _this3.renderLinePair(294, '' + OrderId),
	            _this3.renderLinePair(13387, (0, _time.renderFullDate)(CreationDate)),
	            _this3.renderLinePair(641, (0, _currency.formatCurrency2)(Price)),
	            _this3.renderLinePair(946, StepDictionaryKey),
	            _this3.renderLinePair(263, CreatedBy),
	            _this3.renderLinePair(13011, BookedBy),
	            _this3.renderLinePair(1337, RekvNumber)
	          ),
	          showBodyExtent && _this3.renderSectionExpander(14779, orderItem && _react2.default.createElement(_Extent2.default, {
	            order: orderItem,
	            department: 1,
	            getPrices: true,
	            extents: [{
	              type: 'base',
	              editable: false,
	              noTitle: true
	            }, {
	              type: 'addon',
	              editable: false,
	              noTitle: true
	            }]
	          })),
	          _this3.renderSectionExpander(253, orderItem && _react2.default.createElement(_Extent2.default, {
	            order: orderItem,
	            department: 0,
	            getPrices: true,
	            extents: [{
	              type: 'base',
	              editable: false,
	              noTitle: true
	            }, {
	              type: 'addon',
	              editable: false,
	              noTitle: true
	            }]
	          })),
	          orderItemHasSpareParts && _this3.renderSectionExpander(17926, _react2.default.createElement(_List2.default, { order: orderItem }))
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col_content' },
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          683
	        ),
	        isLoading && _react2.default.createElement(
	          'div',
	          { className: 'spinner' },
	          _react2.default.createElement('div', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	        ),
	        !isLoading && targets.length === 0 && _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)('18083')
	        ),
	        !isLoading && targets.map(renderItem)
	      );
	    }
	  }, {
	    key: 'renderSources',
	    value: function renderSources() {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          sources = _state2.sources,
	          selectedSource = _state2.selectedSource;
	      var isLoading = this.props.isLoading;
	
	
	      var renderItem = function renderItem(item, index) {
	        var OrderId = item.OrderId,
	            CurrentReportUid = item.CurrentReportUid,
	            CurrentReportVersionText = item.CurrentReportVersionText,
	            CreationDate = item.CreationDate,
	            Price = item.Price;
	
	        var isSelected = OrderId === selectedSource;
	        var showBodyExtent = _this4.props.auth.departmentType === 1;
	        var orderItem = _this4.state.orderItems[OrderId];
	        var orderItemHasSpareParts = orderItem && (Array.isArray(orderItem.NewSparePartItems) && orderItem.NewSparePartItems.length > 0 || Array.isArray(orderItem.SparePartItems) && orderItem.SparePartItems.length > 0);
	
	        var onSelect = function onSelect(_) {
	          return _this4.setState({ selectedSource: OrderId });
	        };
	
	        return _react2.default.createElement(
	          _grid2.default,
	          {
	            key: index,
	            cols: 'min-content 1fr',
	            className: 'report__item',
	            onClick: onSelect },
	          _react2.default.createElement(_radio2.default, {
	            size: 'l',
	            labelText: '',
	            onClick: onSelect,
	            checked: isSelected
	          }),
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: 'auto 1fr', className: 'item-content' },
	            _this4.renderLinePair(14900, CurrentReportUid + (CurrentReportVersionText || '')),
	            _this4.renderLinePair(13387, (0, _time.renderFullDate)(CreationDate)),
	            _this4.renderLinePair(641, (0, _currency.formatCurrency2)(Price))
	          ),
	          showBodyExtent && _this4.renderSectionExpander(14779, orderItem && _react2.default.createElement(_Extent2.default, {
	            order: orderItem,
	            department: 1,
	            getPrices: true,
	            extents: [{
	              type: 'base',
	              editable: false,
	              noTitle: true
	            }]
	          })),
	          _this4.renderSectionExpander(253, orderItem && _react2.default.createElement(_Extent2.default, {
	            order: orderItem,
	            department: 0,
	            getPrices: true,
	            extents: [{
	              type: 'base',
	              editable: false,
	              noTitle: true
	            }]
	          })),
	          orderItemHasSpareParts && _this4.renderSectionExpander(17926, _react2.default.createElement(_List2.default, { order: orderItem }))
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col_content' },
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          436
	        ),
	        isLoading && _react2.default.createElement(
	          'div',
	          { className: 'spinner' },
	          _react2.default.createElement('div', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
	        ),
	        !isLoading && sources.length === 0 && _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)('18084')
	        ),
	        !isLoading && sources.map(renderItem)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state3 = this.state,
	          selectedTarget = _state3.selectedTarget,
	          selectedSource = _state3.selectedSource;
	
	      var pairSelected = selectedTarget && selectedSource;
	      var showBottomBar = selectedSource;
	
	      return _react2.default.createElement(
	        _overlayContent2.default,
	        null,
	        showBottomBar && _react2.default.createElement(_bottomBar2.default, {
	          actionLabelText: (0, _helpers.translation)(pairSelected ? 16588 : 18082),
	          onActionClick: pairSelected ? this.handleMatch : this.handleCancallation,
	          cancelLabelText: (0, _helpers.translation)(1155),
	          onCancelClick: this.resetMatch,
	          center: true
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-grid' },
	            this.renderSources(),
	            _react2.default.createElement(_divider2.default, { vertical: true }),
	            this.renderTargets()
	          )
	        )
	      );
	    }
	  }]);
	
	  return Matching;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getOrderSimple: _orders.getOrderSimple
	})(Matching);

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _overlay = __webpack_require__(131);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _matching = __webpack_require__(1130);
	
	var _matching2 = _interopRequireDefault(_matching);
	
	var _OverlayHeaderBare = __webpack_require__(296);
	
	var _OverlayHeaderBare2 = _interopRequireDefault(_OverlayHeaderBare);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1688);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Components
	
	
	// Misc.
	
	
	var MatchingPartsOverlay = function (_Component) {
	  _inherits(MatchingPartsOverlay, _Component);
	
	  function MatchingPartsOverlay(props) {
	    _classCallCheck(this, MatchingPartsOverlay);
	
	    var _this = _possibleConstructorReturn(this, (MatchingPartsOverlay.__proto__ || Object.getPrototypeOf(MatchingPartsOverlay)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(MatchingPartsOverlay, [{
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var order = this.props.order;
	      var reportId = order.Report ? order.Report.ReportUid : '';
	
	      return _react2.default.createElement(
	        _OverlayHeaderBare2.default,
	        { overlayId: 'MatchingPartsOverlay', onClose: this.props.onClose, custom: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'matchOverlay' },
	          _react2.default.createElement(
	            'div',
	            { className: 'top topHeaderInfo' },
	            _react2.default.createElement(
	              'div',
	              { className: 'matchOverlay__content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'top' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.translation)(16668)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'bottom' },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  order.InsuranceCompanyName || '',
	                  ' - ',
	                  (0, _helpers.translation)(459) + ': ' + reportId
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _overlay2.default,
	        { overlayId: 'MatchingPartsOverlay', extraClassName: '', noContentScroll: true },
	        this.renderHeader(),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(_matching2.default, { orderId: this.props.order.Id })
	        )
	      );
	    }
	  }]);
	
	  return MatchingPartsOverlay;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    headerInfo: state.common.headerInfo
	  };
	}
	
	MatchingPartsOverlay.propTypes = {
	  order: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(MatchingPartsOverlay);

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _overlayContent = __webpack_require__(177);
	
	var _overlayContent2 = _interopRequireDefault(_overlayContent);
	
	var _spareparts = __webpack_require__(108);
	
	var _helpers = __webpack_require__(2);
	
	__webpack_require__(1689);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _connectorLine = __webpack_require__(1067);
	
	var _connectorLine2 = _interopRequireDefault(_connectorLine);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icons = __webpack_require__(6);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	var Matching = function (_Component) {
	  _inherits(Matching, _Component);
	
	  function Matching(props) {
	    _classCallCheck(this, Matching);
	
	    var _this = _possibleConstructorReturn(this, (Matching.__proto__ || Object.getPrototypeOf(Matching)).call(this, props));
	
	    _this.state = {
	      isLoading: false,
	      spareParts: [],
	
	      lastedMatched: null,
	
	      selectedPartLeft: null,
	      selectedPartRight: null
	    };
	
	    _this.renderColumn = _this.renderColumn.bind(_this);
	    _this.renderRecentMatch = _this.renderRecentMatch.bind(_this);
	    _this.renderMerged = _this.renderMerged.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.usesDracar = _this.usesDracar.bind(_this);
	    _this.usesDracarCreation = _this.usesDracarCreation.bind(_this);
	    _this.handlePairing = _this.handlePairing.bind(_this);
	    _this.handlePairingReset = _this.handlePairingReset.bind(_this);
	    _this.deselect = _this.deselect.bind(_this);
	    return _this;
	  }
	
	  _createClass(Matching, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        isLoading: true
	      }, function () {
	        _this2.props.getSparePartsForMatching({ OrderId: _this2.props.orderId }).then(function (res) {
	          _this2.setState({ isLoading: false });
	          _this2.handleErrors(res);
	        });
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!(0, _lodash.isEqual)(this.props.spareParts, this.state.spareParts)) {
	        this.setState({ spareParts: this.props.spareParts });
	      }
	    }
	  }, {
	    key: 'handleErrors',
	    value: function handleErrors(err) {
	      if (err) {
	        if (err.data) {
	          if (err.data.Errors !== undefined && err.data.Errors !== null && Array.isArray(err.data.Errors) && err.data.Errors.length > 0) {
	            var errors = err.data.Errors;
	            var errText = '';
	            for (var i = 0; i < errors.length; i++) {
	              var dictKey = errors[i].DictionaryKey;
	              errText += '<br/>' + (0, _helpers.translation)(dictKey);
	            }
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	            return true;
	          }
	        } else {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'usesDracar',
	    value: function usesDracar() {
	      // We do not check if invoicing to Dracar is active, just that they are allowed and have it selected.
	      return this.props.auth.permissions.DracarUsable;
	    }
	  }, {
	    key: 'usesDracarCreation',
	    value: function usesDracarCreation() {
	      return this.props.auth.permissions.UseDracarSparePartCreation;
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(_ref) {
	      var _ref$target = _ref.target,
	          name = _ref$target.name,
	          value = _ref$target.value;
	      var isDeselect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!name) return;
	
	      var newValue = void 0;
	      if (isDeselect) {
	        newValue = null;
	      } else {
	        newValue = value;
	      }
	
	      if (name === 'left') {
	        this.setState({ selectedPartLeft: newValue });
	      } else if (name === 'right') {
	        this.setState({ selectedPartRight: newValue });
	      }
	    }
	  }, {
	    key: 'deselect',
	    value: function deselect(e, side) {
	      var selected = side === 'left' ? this.state.selectedPartLeft : this.state.selectedPartRight;
	      if (selected) {
	        this.onInputChange(e, true);
	      }
	    }
	  }, {
	    key: 'handlePairing',
	    value: function handlePairing() {
	      var _this3 = this;
	
	      var _state = this.state,
	          selectedPartLeft = _state.selectedPartLeft,
	          selectedPartRight = _state.selectedPartRight,
	          spareParts = _state.spareParts;
	
	
	      var mergeFromPart = spareParts.find(function (s) {
	        return s.OriginalSparePartNumber === selectedPartLeft || s.SparePartNumberAlias === selectedPartLeft;
	      });
	      var mergeToPart = spareParts.find(function (s) {
	        return s.OriginalSparePartNumber === selectedPartRight || s.SparePartNumberAlias === selectedPartRight;
	      });
	
	      var matchType = 1;
	      // if (this.usesDracar() && this.usesDracarCreation()) matchType = 2
	      if (this.usesDracar()) {
	        matchType = 2;
	        // // For KeyLoop, switch left and right part
	        // let part = mergeFromPart
	        // mergeFromPart = mergeToPart
	        // mergeToPart = part
	      }
	
	      var dataObj = {
	        OrderId: this.props.orderId,
	        MatchingType: matchType,
	        MergeFrom: mergeFromPart,
	        MergeTo: mergeToPart
	      };
	
	      this.props.matchingSpareParts(dataObj).then(function (res) {
	        if (!_this3.handleErrors(res)) {
	          _this3.setState({
	            lastedMatched: {
	              left: mergeFromPart,
	              right: mergeToPart
	            },
	            selectedPartLeft: null,
	            selectedPartRight: null
	          }, function () {
	            return _this3.props.getSparePartsForMatching({ OrderId: _this3.props.orderId });
	          }); // Update sparepart statuses
	        }
	      }).catch(function (err) {
	        return _this3.handleErrors(err);
	      });
	    }
	  }, {
	    key: 'handlePairingReset',
	    value: function handlePairingReset() {
	      this.setState({ selectedPartLeft: null, selectedPartRight: null });
	    }
	  }, {
	    key: 'renderColumn',
	    value: function renderColumn(side, spareParts) {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          selectedPartLeft = _state2.selectedPartLeft,
	          selectedPartRight = _state2.selectedPartRight;
	
	
	      var renderLabel = function renderLabel(item, partNumber) {
	        var getDescription = function getDescription(item) {
	          return item.Description ? item.Description.length > 0 ? item.Description : partNumber : partNumber;
	        };
	
	        partNumber = _this4.usesDracar() ? item.DracarPartNumber || partNumber : partNumber || ' ';
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          getDescription(item),
	          _react2.default.createElement(
	            'div',
	            { className: 'description__partnumber' },
	            partNumber
	          )
	        );
	      };
	
	      var renderItem = function renderItem(item, index) {
	        var partNumber = item.SparePartNumberAlias || item.OriginalSparePartNumber;
	
	        var isChecked = false;
	        if (side === 'left') {
	          isChecked = selectedPartLeft === partNumber;
	        }
	        if (side === 'right') {
	          isChecked = selectedPartRight === partNumber;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'parts', key: index },
	          _react2.default.createElement(_radio2.default, {
	            size: 'l',
	            labelText: renderLabel(item, partNumber),
	            id: side + '-' + partNumber,
	            name: side,
	            value: partNumber,
	            onChange: _this4.onInputChange,
	            onClick: function onClick(e) {
	              return _this4.deselect(e, side);
	            },
	            checked: isChecked
	          })
	        );
	      };
	      var colText = side === 'left' ? 16437 : 16438;
	
	      // if (this.usesDracar()) {
	      //   // When using Dracar/KeyLoop - Left: From report, Right: Added manually
	      //   colText = side === 'left' ? 16438 : 16437
	      // }
	      return _react2.default.createElement(
	        'div',
	        { className: 'col_content' },
	        _react2.default.createElement(
	          'label',
	          null,
	          (0, _helpers.translation)(colText)
	        ),
	        spareParts.map(function (item, index) {
	          return renderItem(item, index);
	        })
	      );
	    }
	  }, {
	    key: 'renderRecentMatch',
	    value: function renderRecentMatch() {
	      var _this5 = this;
	
	      var lastedMatched = this.state.lastedMatched;
	
	      if (!lastedMatched) return null;
	      if (!lastedMatched.left || !lastedMatched.right) return null;
	
	      var renderLabel = function renderLabel(item, partNumber) {
	        var getDescription = function getDescription(item) {
	          return item.Description ? item.Description.length > 0 ? item.Description : partNumber : partNumber;
	        };
	
	        partNumber = _this5.usesDracar() && _this5.usesDracarCreation() ? item.DracarPartNumber || partNumber : partNumber || ' ';
	
	        return _react2.default.createElement(
	          _label2.default,
	          null,
	          getDescription(item),
	          _react2.default.createElement(
	            'div',
	            { className: 'description__partnumber' },
	            partNumber
	          )
	        );
	      };
	
	      var renderItem = function renderItem(item, key) {
	        var partNumber = item.SparePartNumberAlias || item.OriginalSparePartNumber;
	
	        return _react2.default.createElement(
	          _grid2.default,
	          { key: key, cols: ['min-content', 1], align: 'center', className: 'pairedItem', gap: 2 },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_icon2.default, { size: 2, icon: _icons.SparePartModuleIcons.OK, injectSvg: true })
	          ),
	          renderLabel(item, partNumber)
	        );
	      };
	
	      return [renderItem(lastedMatched.left, 0), _react2.default.createElement(_connectorLine2.default, { key: 'connector' }), renderItem(lastedMatched.right, 1)];
	    }
	  }, {
	    key: 'renderMerged',
	    value: function renderMerged() {
	      var _this6 = this;
	
	      var spareParts = this.state.spareParts.filter(function (x) {
	        return x.IsMerged;
	      });
	      if (spareParts.length === 0) return;
	      var automaticlyMergedParts = spareParts.filter(function (x) {
	        return x.MergedFrom.some(function (y) {
	          return y.MergeType === 1;
	        });
	      });
	      var manuallyMergedParts = spareParts.filter(function (x) {
	        return x.MergedFrom.some(function (y) {
	          return y.MergeType === 2;
	        });
	      });
	      var renderSparePart = function renderSparePart(sparePart, mergeType) {
	        var lines = sparePart.MergedFrom.map(function (merge) {
	          if (merge.MergeType !== mergeType) return;
	          return {
	            from: {
	              partNumber: merge.PartNumber,
	              OriginalSparePartNumber: merge.PartNumber,
	              Description: merge.Description
	            },
	            to: sparePart
	          };
	        });
	        var renderLine = function renderLine(sparePartLine, index) {
	          if (sparePartLine === undefined) return;
	          var renderBlock = function renderBlock(item, index) {
	            var partNumber = item.SparePartNumberAlias || item.OriginalSparePartNumber;
	            var gridClass = 'pairedItem';
	            if (index === 0) {
	              gridClass += ' left';
	            } else if (index === 1) {
	              gridClass += ' right';
	            }
	            var renderLabel = function renderLabel(item, partNumber) {
	              var getDescription = function getDescription(item) {
	                if (_this6.usesDracar() && item.DracarDescription && item.DracarDescription.length > 0) {
	                  return item.DracarDescription;
	                }
	                return item.Description && item.Description.length > 0 ? item.Description : partNumber;
	              };
	              partNumber = _this6.usesDracar() ? item.DracarPartNumber || partNumber : partNumber || ' ';
	
	              return _react2.default.createElement(
	                _label2.default,
	                null,
	                getDescription(item),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'description__partnumber' },
	                  partNumber
	                )
	              );
	            };
	            return _react2.default.createElement(
	              _grid2.default,
	              { key: index, cols: ['min-content', 1], align: 'center', className: gridClass, gap: 2 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { size: 2, icon: _icons.SparePartModuleIcons.OK, injectSvg: true })
	              ),
	              renderLabel(item, partNumber)
	            );
	          };
	          return _react2.default.createElement(
	            'div',
	            { className: 'mergedLine' },
	            renderBlock(sparePartLine.from, 0),
	            _react2.default.createElement(_connectorLine2.default, { className: 'middle', key: 'connector' }),
	            renderBlock(sparePartLine.to, 1)
	          );
	        };
	        return lines.map(renderLine);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'mergedParts' },
	        _react2.default.createElement(_divider2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'subheader center' },
	          _react2.default.createElement(
	            'label',
	            null,
	            (0, _helpers.translation)(17876)
	          )
	        ),
	        automaticlyMergedParts.length > 0 && _react2.default.createElement(
	          'div',
	          { className: 'mergedSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'subheader' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)(17877)
	            )
	          ),
	          automaticlyMergedParts.map(function (x) {
	            return renderSparePart(x, 1);
	          })
	        ),
	        manuallyMergedParts.length > 0 && _react2.default.createElement(
	          'div',
	          { className: 'mergedSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'subheader' },
	            _react2.default.createElement(
	              'label',
	              null,
	              (0, _helpers.translation)(17878)
	            )
	          ),
	          manuallyMergedParts.map(function (x) {
	            return renderSparePart(x, 2);
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state3 = this.state,
	          spareParts = _state3.spareParts,
	          selectedPartLeft = _state3.selectedPartLeft,
	          selectedPartRight = _state3.selectedPartRight;
	
	
	      var DracarStatus = {
	        Unknown: 0,
	        NotMatched: 1,
	        Matched: 2,
	        UnusedPart: 3,
	        ManuallyMatched: 4,
	        MatchedViaDracar: 1001, // It wasn't found, but later added to the DMS in Dracar
	        AddedFromDracar: 2001 // It wasn't found, but later added to the DMS in Dracar
	      };
	      var SparepartStatus = {
	        None: 0,
	        Unknown: 1,
	        NotInUse: 2,
	        InStock: 4,
	        Ordered: 8,
	        Received: 16,
	        Defective: 32,
	        Incorrect: 64,
	        BackOrder: 128
	      };
	      var orderedStatuses = SparepartStatus.Unknown | SparepartStatus.NotInUse | SparepartStatus.InStock | SparepartStatus.Ordered;
	      // const recievedStatuses = SparepartStatus.Ordered | SparepartStatus.Received | SparepartStatus.Defective | SparepartStatus.Incorrect | SparepartStatus.BackOrder
	
	      var leftParts = [];
	      var rightParts = [];
	      var pairSelected = selectedPartLeft && selectedPartRight;
	
	      if (this.usesDracar()) {
	        leftParts = spareParts.filter(function (x) {
	          return !x.IsDeleted && (x.DracarStatus === DracarStatus.AddedFromDracar || x.DracarPartNumber && !x.OrderSparePartId || x.DracarStatus === DracarStatus.Unknown && Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport);
	        });
	        rightParts = spareParts.filter(function (x) {
	          return !x.IsDeleted && (x.DracarStatus === DracarStatus.NotMatched || Number(x.OrderSparePartId) > 0 && x.DracarStatus === DracarStatus.Unknown);
	        });
	        // console.log('parts (all/left/right)', spareParts, leftParts, rightParts)
	      } else {
	        leftParts = spareParts.filter(function (x) {
	          return Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport && (orderedStatuses & x.Status) > 0;
	        });
	        rightParts = spareParts.filter(function (x) {
	          return Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport && x.Status !== SparepartStatus.None;
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'matchingPartsContent' },
	        _react2.default.createElement(
	          _overlayContent2.default,
	          null,
	          pairSelected ? _react2.default.createElement(_bottomBar2.default, {
	            actionLabelText: (0, _helpers.translation)(16588),
	            onActionClick: this.handlePairing,
	            cancelLabelText: (0, _helpers.translation)(1155),
	            onCancelClick: this.handlePairingReset,
	            center: true
	          }) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            this.renderColumn('left', leftParts),
	            _react2.default.createElement(_divider2.default, { vertical: true }),
	            this.renderColumn('right', rightParts),
	            this.renderMerged()
	          )
	        )
	      );
	    }
	  }]);
	
	  return Matching;
	}(_react.Component);
	
	Matching.propTypes = {
	  orderId: _react2.default.PropTypes.number.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    spareParts: state.spareParts.sparePartsForMatching,
	    headerInfo: state.common.headerInfo // Contains information used to determine if the shop uses DRACAR
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getSparePartsForMatching: _spareparts.getSparePartsForMatching,
	  matchingSpareParts: _spareparts.matchingSpareParts
	})(Matching);

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _spareparts = __webpack_require__(108);
	
	var _common = __webpack_require__(25);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _countSpecifier = __webpack_require__(451);
	
	var _countSpecifier2 = _interopRequireDefault(_countSpecifier);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _slidePanel = __webpack_require__(202);
	
	var _slidePanel2 = _interopRequireDefault(_slidePanel);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _icons = __webpack_require__(6);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _time2 = __webpack_require__(301);
	
	var _time3 = _interopRequireDefault(_time2);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Elements
	
	// import Check from '../../../elements/check'
	
	
	var ReceptionSlidePanel = function (_Component) {
	  _inherits(ReceptionSlidePanel, _Component);
	
	  function ReceptionSlidePanel(props) {
	    _classCallCheck(this, ReceptionSlidePanel);
	
	    var _this = _possibleConstructorReturn(this, (ReceptionSlidePanel.__proto__ || Object.getPrototypeOf(ReceptionSlidePanel)).call(this, props));
	
	    _this.state = {
	      view: 'status',
	      totalCount: 0,
	      disabled: true,
	      Quantity: 1,
	      Status: 1,
	      Comment: '',
	      NewDeliveryDate: false,
	      DeliveryDate: '',
	      DefaultDate: '',
	      DeliveryChange: {
	        deliveryDate: '',
	        deliveryTime: ''
	      },
	
	      ModifySpecific: false,
	      modifySpecificSparePart: null,
	
	      sparePartDetails: []
	
	      // this.getSpareParts = this.getSpareParts.bind(this)
	    };_this.onChange = _this.onChange.bind(_this);
	    _this.submitSpareParts = _this.submitSpareParts.bind(_this);
	    _this.resetState = _this.resetState.bind(_this);
	    _this.onDone = _this.onDone.bind(_this);
	    _this.changeToModifyStatusView = _this.changeToModifyStatusView.bind(_this);
	    _this.onTimeChange = _this.onTimeChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReceptionSlidePanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        view: this.props.view
	      });
	    }
	
	    // componentDidUpdate () {
	    //   const totalCount = this.props.spareParts.reduce((total, part) => {
	    //     return total + (part.Count - part.Handled)
	    //   }, 0)
	
	    //   if (totalCount !== this.state.totalCount) {
	    //     this.setState({
	    //       totalCount: totalCount,
	    //       Quantity: totalCount
	    //     })
	    //   }
	    // }
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var isDiffSpareParts = !(0, _lodash.isEqual)(nextProps.spareParts, this.props.spareParts);
	
	      if (nextProps.view !== this.state.view) {
	        this.setState({
	          view: nextProps.view
	        });
	      }
	
	      var isDiff = isDiffSpareParts && nextProps.spareParts.length === 1;
	
	      if (isDiff) {
	        this.props.getReceptionSparePartDetails(nextProps.spareParts[0]).then(function (res) {
	          var unhandledSparePart = res.data.find(function (sp) {
	            return sp.Status === 8;
	          });
	          var totalCount = unhandledSparePart ? unhandledSparePart.Count : 0;
	
	          var date = window.CustomDate(res.data[0].DefaultDate);
	          var time = (0, _time.renderFullDate)(date, true, true).toString();
	
	          var newState = {
	            totalCount: totalCount,
	            Quantity: totalCount,
	            sparePartDetails: res.data,
	            DeliveryChange: {
	              deliveryDate: date,
	              deliveryTime: time
	            }
	          };
	
	          if (_this2.state.view !== 'listDetail' && res.data.length === 1 && !unhandledSparePart) {
	            newState = _extends({}, newState, _this2.changeToModifyStatusView(res.data[0], true));
	          } else if (totalCount === 0) {
	            newState.view = 'listDetail';
	            _this2.setState({
	              DefaultDate: res.data[0].DefaultDate,
	              DeliveryChange: {
	                deliveryDate: date,
	                deliveryTime: time,
	                disabled: res.data[0].Status === 1
	              }
	            });
	          }
	
	          _this2.setState(newState);
	        });
	      } else if (nextProps.spareParts.length > 1) {
	        this.resetState();
	      }
	    }
	
	    // componentDidMount () {
	    //   this.getSpareParts()
	    // }
	
	    // componentDidUpdate () {
	    //   const isSame = this.props.sparePartNumbers.every(spn => {
	    //     return this.state.spareParts.some(sp => {
	    //       return spn === (sp.SparePartNumberAlias || sp.OriginalSparePartNumber)
	    //     })
	    //   })
	
	    //   if (!isEqual(this.state.spareParts, this.props.spareParts)) {
	    //     this.getSpareParts()
	    //   }
	    // }
	
	    // getSpareParts () {
	    //   const { spareParts } = this.props
	
	    //   const relevantParts = spareParts.filter(sp => {
	    //     return this.props.sparePartNumbers.includes(sp.SparePartNumberAlias || sp.OriginalSparePartNumber)
	    //   })
	
	    //   this.setState({
	    //     spareParts: relevantParts
	    //   })
	    // }
	
	  }, {
	    key: 'isMultipleSpareParts',
	    value: function isMultipleSpareParts() {
	      var spareParts = this.props.spareParts;
	
	      return spareParts.length > 1;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _setState;
	
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value,
	          checked = _e$target.checked;
	
	
	      var newValue = value;
	      if (name === 'Status') {
	        newValue = +value;
	      }
	      if (name === 'NewDeliveryDate') {
	        newValue = checked;
	      }
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, newValue), _defineProperty(_setState, 'disabled', false), _setState));
	    }
	  }, {
	    key: 'submitSpareParts',
	    value: function submitSpareParts() {
	      var _this3 = this;
	
	      var _state = this.state,
	          Quantity = _state.Quantity,
	          Status = _state.Status,
	          Comment = _state.Comment,
	          ModifySpecific = _state.ModifySpecific,
	          modifySpecificSparePart = _state.modifySpecificSparePart,
	          NewDeliveryDate = _state.NewDeliveryDate,
	          DefaultDate = _state.DefaultDate,
	          DeliveryChange = _state.DeliveryChange;
	
	      var isMulti = this.isMultipleSpareParts();
	      var momentDate = (0, _moment2.default)(DeliveryChange.deliveryDate);
	      var newDate = momentDate.format('YYYY-MM-DD') + ' ' + DeliveryChange.deliveryTime;
	
	      var sparePartsBody = {
	        OrderId: this.props.orderId,
	        SpareParts: !ModifySpecific ? this.props.spareParts : [modifySpecificSparePart],
	        Quantity: !isMulti ? Quantity : null,
	        Status: Status,
	        Comment: Comment,
	        ModifySpecific: !isMulti ? ModifySpecific : false,
	        Filter: this.props.sparePartsFilter,
	        DeliveryDate: NewDeliveryDate ? newDate : null
	      };
	
	      this.props.updateSparePartsReception(sparePartsBody).then(function (res) {
	        _this3.onDone();
	      }, function (err) {
	        var errorKey = err.response.data.DictionaryKey;
	        if (errorKey && errorKey === 18109) {
	          window.toastr.error((0, _helpers.translation)(errorKey), (0, _helpers.translation)('216'));
	          var date = window.CustomDate(DefaultDate);
	          var time = (0, _time.renderFullDate)(date, true, true).toString();
	          _this3.setState({
	            DeliveryChange: {
	              deliveryDate: date,
	              deliveryTime: time
	            },
	            NewDeliveryDate: false
	          });
	        } else {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        }
	      });
	    }
	  }, {
	    key: 'resetState',
	    value: function resetState() {
	      this.setState({
	        view: 'status',
	        totalCount: 0,
	
	        Quantity: 1,
	        Status: 1,
	        Comment: '',
	        ModifySpecific: false,
	        modifySpecificSparePart: null,
	        NewDeliveryDate: false,
	        disabled: true
	      });
	    }
	  }, {
	    key: 'onDone',
	    value: function onDone() {
	      this.resetState();
	
	      this.props.closeSlidePanel('sparePartsReception');
	
	      if (this.props.onDone !== null) {
	        this.props.onDone();
	      }
	    }
	  }, {
	    key: 'onTimeChange',
	    value: function onTimeChange(e) {
	      var value = e.target.value;
	
	
	      this.setState({
	        DeliveryChange: _extends({}, this.state.DeliveryChange, {
	          deliveryTime: value
	        }),
	        disabled: false,
	        NewDeliveryDate: true
	      });
	    }
	  }, {
	    key: 'renderDefaultDeliveryTime',
	    value: function renderDefaultDeliveryTime() {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          NewDeliveryDate = _state2.NewDeliveryDate,
	          DeliveryChange = _state2.DeliveryChange;
	
	      var inputProps = {
	        name: 'date'
	      };
	
	      var date = window.CustomDate(DeliveryChange.deliveryDate);
	      var time = DeliveryChange.deliveryTime;
	
	      var onDateChange = function onDateChange(date) {
	        var momentDate = (0, _moment2.default)(date);
	        _this4.setState({
	          DeliveryChange: _extends({}, _this4.state.DeliveryChange, {
	            deliveryDate: momentDate.format('YYYY-MM-DD')
	          }),
	          disabled: false,
	          NewDeliveryDate: true
	        });
	      };
	
	      return _react2.default.createElement(
	        _labelWrapper2.default,
	        { labelText: (0, _helpers.translation)('18107') },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: [0.3, 2, 1] },
	          _react2.default.createElement(_check2.default, { spacing: 0, name: 'NewDeliveryDate', value: NewDeliveryDate, onChange: this.onChange, checked: NewDeliveryDate }),
	          _react2.default.createElement(_datetime2.default, {
	            inputProps: inputProps,
	            timeFormat: false,
	            closeOnSelect: true,
	            value: date,
	            onChange: onDateChange
	          }),
	          _react2.default.createElement(_time3.default, { name: 'DefaultDate', value: time, onChange: this.onTimeChange, id: 10 })
	        )
	      );
	    }
	  }, {
	    key: 'renderStatusChange',
	    value: function renderStatusChange() {
	      var _this5 = this;
	
	      var spareParts = this.props.spareParts;
	      var _state3 = this.state,
	          totalCount = _state3.totalCount,
	          Quantity = _state3.Quantity,
	          Status = _state3.Status,
	          Comment = _state3.Comment,
	          disabled = _state3.disabled;
	
	
	      var renderContent = function renderContent() {
	        var renderPreviousComment = function renderPreviousComment(item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              item.Note
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              item.NoteUserName + ' - ' + (0, _time.renderFullDate)(item.NoteDate)
	            ),
	            _react2.default.createElement(_divider2.default, null)
	          );
	        };
	
	        var showCounter = totalCount > 1 && !_this5.isMultipleSpareParts();
	        return _react2.default.createElement(
	          'div',
	          { className: 'content', key: 1 },
	          showCounter && [_react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(16447), key: 1 },
	            _react2.default.createElement(_countSpecifier2.default, { name: 'Quantity', value: Quantity, total: totalCount, onChange: _this5.onChange })
	          ), _react2.default.createElement(_divider2.default, { key: 2 })],
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(16448) },
	            _this5.state.ModifySpecific && _react2.default.createElement(_radio2.default, { name: 'Status', value: 8, checked: Status === 8, onChange: _this5.onChange, labelText: (0, _helpers.translation)(16535) }),
	            _react2.default.createElement(_radio2.default, { name: 'Status', value: 16, checked: Status === 16, onChange: _this5.onChange, labelText: (0, _helpers.translation)(16452) }),
	            _react2.default.createElement(_radio2.default, { name: 'Status', value: 32, checked: Status === 32, onChange: _this5.onChange, labelText: (0, _helpers.translation)(16453) }),
	            _react2.default.createElement(_radio2.default, { name: 'Status', value: 64, checked: Status === 64, onChange: _this5.onChange, labelText: (0, _helpers.translation)(16454) }),
	            _react2.default.createElement(_radio2.default, { name: 'Status', value: 128, checked: Status === 128, onChange: _this5.onChange, labelText: (0, _helpers.translation)(18108) })
	          ),
	          _react2.default.createElement(_divider2.default, null),
	          _this5.renderDefaultDeliveryTime(),
	          _react2.default.createElement(_divider2.default, null),
	          _react2.default.createElement(_textarea2.default, { name: 'Comment', value: Comment, onChange: _this5.onChange, labelText: (0, _helpers.translation)(149) }),
	          _this5.props.previousComments.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'previous-comments' },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)(16459) },
	              _this5.props.previousComments.map(renderPreviousComment)
	            )
	          )
	        );
	      };
	
	      return [_react2.default.createElement(
	        'div',
	        { className: 'top', key: 0 },
	        _react2.default.createElement(
	          'h1',
	          null,
	          (0, _helpers.translation)(13052)
	        ),
	        spareParts.length === 1 && _react2.default.createElement(
	          'h3',
	          null,
	          totalCount + ' x ' + (spareParts[0].SparePartNumberAlias || spareParts[0].OriginalSparePartNumber)
	        ),
	        spareParts.length > 1 && _react2.default.createElement(
	          'h3',
	          null,
	          (0, _helpers.translation)(16451),
	          ' #'
	        )
	      ), renderContent(), _react2.default.createElement(_bottomBar2.default, {
	        actionLabelText: (0, _helpers.translation)(16455),
	        onActionClick: this.submitSpareParts,
	        cancelLabelText: (0, _helpers.translation)(16444),
	        onCancelClick: this.onDone,
	        disabled: disabled,
	        key: 2
	      })];
	    }
	  }, {
	    key: 'changeToModifyStatusView',
	    value: function changeToModifyStatusView(part) {
	      var returnState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var newState = {
	        view: 'status',
	        totalCount: part.Count,
	        Quantity: part.Count,
	        Status: part.Status,
	        ModifySpecific: true,
	        modifySpecificSparePart: part,
	        DefaultDate: part.DefaultDate,
	        disabled: part.Status === 1
	      };
	
	      if (returnState) {
	        return newState;
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'renderListDetail',
	    value: function renderListDetail() {
	      var _this6 = this;
	
	      var spareParts = this.props.spareParts;
	      var _state4 = this.state,
	          sparePartDetails = _state4.sparePartDetails,
	          totalCount = _state4.totalCount;
	
	
	      var renderContent = function renderContent() {
	        var renderPart = function renderPart(part, key) {
	          var icon = _icons.SparePartModuleIcons.OK;
	          if (part.Status !== 16) icon = _icons.SparePartModuleIcons.Warning;
	
	          var status = void 0;
	          switch (part.Status) {
	            case 8:
	              status = (0, _helpers.translation)(16457) + '...';
	              break;
	            case 16:
	              status = (0, _helpers.translation)(16452);
	              break;
	            case 32:
	              status = (0, _helpers.translation)(16453);
	              break;
	            case 64:
	            case 128:
	              status = (0, _helpers.translation)(18108);
	              break;
	            default:
	              status = (0, _helpers.translation)(16454);
	              break;
	          }
	
	          return [_react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(13052) + ' - ' + status, key: key },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: 'min-content 1fr min-content', onClick: function onClick() {
	                  return _this6.changeToModifyStatusView(part);
	                }, align: 'center' },
	              _react2.default.createElement(_icon2.default, { icon: icon, injectSvg: true }),
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: 'auto' },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  part.Count + ' x ' + (part.Status === 8 ? part.Suppliers[0].Name : status)
	                ),
	                part.RequiresPaint && _react2.default.createElement(
	                  'h4',
	                  null,
	                  (0, _helpers.translation)(16450)
	                ),
	                part.Pickup && _react2.default.createElement(
	                  'h4',
	                  null,
	                  (0, _helpers.translation)(16458)
	                )
	              ),
	              _react2.default.createElement('i', { className: 'fa fa-chevron-right' })
	            )
	          ), _react2.default.createElement(_divider2.default, { size: 3 })];
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'content status-list', key: 1 },
	          sparePartDetails.map(renderPart)
	        );
	      };
	
	      var sparePart = spareParts[0] || {};
	      return [_react2.default.createElement(
	        'div',
	        { className: 'top', key: 0 },
	        _react2.default.createElement(
	          'h1',
	          null,
	          (0, _helpers.translation)(13052)
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          totalCount + ' x ' + (sparePart.SparePartNumberAlias || sparePart.OriginalSparePartNumber)
	        )
	      ), renderContent(), _react2.default.createElement(_bottomBar2.default, {
	        cancelLabelText: (0, _helpers.translation)(235),
	        onCancelClick: this.onDone,
	        key: 2
	      })];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = null;
	      switch (this.state.view) {
	        case 'status':
	        default:
	          content = this.renderStatusChange();
	          break;
	        case 'listDetail':
	          content = this.renderListDetail();
	          break;
	      }
	
	      return _react2.default.createElement(
	        _slidePanel2.default,
	        { slidePanelId: 'sparePartsReception' },
	        content
	      );
	    }
	  }]);
	
	  return ReceptionSlidePanel;
	}(_react.Component);
	
	ReceptionSlidePanel.defaultProps = {
	  onDone: null
	};
	
	function mapStateToProps(state) {
	  return {
	    previousComments: state.spareParts.sparePartsCommentsReception,
	    sparePartsFilter: state.spareParts.sparePartsFilterReception
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateSparePartsReception: _spareparts.updateSparePartsReception,
	  closeSlidePanel: _common.closeSlidePanel,
	  getReceptionSparePartDetails: _spareparts.getReceptionSparePartDetails
	})(ReceptionSlidePanel);

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _spareparts = __webpack_require__(108);
	
	var _overlay = __webpack_require__(131);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _tabBar = __webpack_require__(91);
	
	var _tabBar2 = _interopRequireDefault(_tabBar);
	
	var _tabItem = __webpack_require__(95);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _OverlayHeader = __webpack_require__(174);
	
	var _OverlayHeader2 = _interopRequireDefault(_OverlayHeader);
	
	var _matchingSpareParts = __webpack_require__(1129);
	
	var _matchingSpareParts2 = _interopRequireDefault(_matchingSpareParts);
	
	var _ordering = __webpack_require__(1134);
	
	var _ordering2 = _interopRequireDefault(_ordering);
	
	var _receiving = __webpack_require__(1135);
	
	var _receiving2 = _interopRequireDefault(_receiving);
	
	__webpack_require__(1692);
	
	var _helpers = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions
	
	
	// Elements
	
	
	// Components
	
	
	// Tabs
	
	// import Control from './tabs/control'
	
	var SparePartsOverlay = function (_Component) {
	  _inherits(SparePartsOverlay, _Component);
	
	  function SparePartsOverlay(props) {
	    _classCallCheck(this, SparePartsOverlay);
	
	    var _this = _possibleConstructorReturn(this, (SparePartsOverlay.__proto__ || Object.getPrototypeOf(SparePartsOverlay)).call(this, props));
	
	    _this.state = {
	      activeTabIndex: 0
	    };
	
	    _this.getTabs = _this.getTabs.bind(_this);
	    _this.openOverlay = _this.openOverlay.bind(_this);
	    _this.updateSpareParts = _this.updateSpareParts(_this);
	    return _this;
	  }
	
	  _createClass(SparePartsOverlay, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var _this2 = this;
	
	      var tabs = [];
	
	      var orderingTabTitleId = 16435;
	      if (this.props.auth.permissions.DracarUsable) {
	        orderingTabTitleId = 16646;
	      }
	
	      tabs.push({
	        titleId: orderingTabTitleId, // Dictionary key for the tabbar item
	        getComponent: function getComponent(props) {
	          return _react2.default.createElement(_ordering2.default, _extends({}, props, { orderId: _this2.props.order.Id }));
	        } // Component to render when tab is active
	      }, {
	        titleId: 16434,
	        getComponent: function getComponent(props) {
	          return _react2.default.createElement(_receiving2.default, _extends({}, props, { orderId: _this2.props.order.Id }));
	        }
	      });
	
	      return tabs;
	    }
	  }, {
	    key: 'openOverlay',
	    value: function openOverlay() {
	      this.props.openOverlay('MatchingPartsOverlay');
	    }
	  }, {
	    key: 'updateSpareParts',
	    value: function updateSpareParts() {
	      var _this3 = this;
	
	      this.props.getSparePartsOrdering({ OrderId: this.props.order.Id }).then(function (res) {
	        _this3.setState({ isLoading: false });
	        // this.handleErrors(res) // function not implemented
	      });
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var _this4 = this;
	
	      var renderTab = function renderTab(tab, index) {
	        var changeTab = function changeTab() {
	          _this4.setState({
	            activeTabIndex: index
	          });
	        };
	        var isActive = _this4.state.activeTabIndex === index;
	        return _react2.default.createElement(_tabItem2.default, { key: index, labelText: (0, _helpers.translation)(tab.titleId), active: isActive, onClick: changeTab });
	      };
	
	      var order = this.props.order;
	      var reportId = null;
	      var hasForsiReport = order.Report !== null && order.Report.ReportType === 1;
	      var hasRPReport = order.Report !== null && order.Report.ReportType === 2;
	
	      // if (order.HasForsiReport) reportId = order.ForsiReportId
	      // else if (order.RpReport) reportId = order.RpReport.FullReportId
	
	      if (hasForsiReport || hasRPReport) reportId = order.Report.ReportUid;
	      // else if (hasRPReport) reportId = order.Report.ReportUid
	
	      if (reportId != null) {
	        reportId = reportId.substring(0, 2) + ' ' + reportId.substring(2, 7) + ' ' + reportId.substring(7, 9) + ' ' + reportId.substring(9, 13) + ' ' + reportId.substring(13);
	      }
	
	      return _react2.default.createElement(
	        _OverlayHeader2.default,
	        { overlayId: 'SparePartsOverlay', onClose: this.props.onClose },
	        _react2.default.createElement(
	          'div',
	          { className: 'bottom' },
	          _react2.default.createElement(
	            _tabBar2.default,
	            null,
	            this.getTabs().map(renderTab)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'top topHeaderInfo' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              order.RegNumber
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (order.BrandName.Name || '') + ' ' + (order.Model || '') + ' \xB7 ' + (order.ChassisNumber || '')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (order.CustomerName || '') + ' \xB7 ' + (order.CreatedByName || '')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              '' + (order.InsuranceCompanyName || '')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(459) + ' ' + (reportId || '')
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _overlay2.default,
	        { overlayId: 'SparePartsOverlay', extraClassName: 'spareparts-overlay', noContentScroll: true },
	        this.renderHeader(),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          this.getTabs()[this.state.activeTabIndex].getComponent()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'matchingPartOverlay' },
	          _react2.default.createElement(_matchingSpareParts2.default, { order: this.props.order, onClose: this.updateSpareParts })
	        )
	      );
	    }
	  }]);
	
	  return SparePartsOverlay;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    headerInfo: state.common.headerInfo
	  };
	}
	
	SparePartsOverlay.propTypes = {
	  order: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getSparePartsOrdering: _spareparts.getSparePartsOrdering
	})(SparePartsOverlay);

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _currency = __webpack_require__(41);
	
	var _text = __webpack_require__(12);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _countSpecifier = __webpack_require__(451);
	
	var _countSpecifier2 = _interopRequireDefault(_countSpecifier);
	
	var _slidePanel = __webpack_require__(202);
	
	var _slidePanel2 = _interopRequireDefault(_slidePanel);
	
	var _divider = __webpack_require__(20);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _orangeDivider = __webpack_require__(453);
	
	var _orangeDivider2 = _interopRequireDefault(_orangeDivider);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _textarea = __webpack_require__(35);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _labelWrapper = __webpack_require__(13);
	
	var _labelWrapper2 = _interopRequireDefault(_labelWrapper);
	
	var _icons = __webpack_require__(6);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _datetime = __webpack_require__(54);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _time2 = __webpack_require__(301);
	
	var _time3 = _interopRequireDefault(_time2);
	
	var _removeButton = __webpack_require__(36);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Dropzone = __webpack_require__(85);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _Gallery = __webpack_require__(60);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Portal = __webpack_require__(30);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Confirm = __webpack_require__(32);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _spareparts = __webpack_require__(108);
	
	var _orders = __webpack_require__(21);
	
	var _common = __webpack_require__(25);
	
	var _orderfiles = __webpack_require__(409);
	
	var _constants = __webpack_require__(5);
	
	__webpack_require__(1691);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Actions
	
	
	// Constants
	
	
	var OrderingSlidePanel = function (_Component) {
	  _inherits(OrderingSlidePanel, _Component);
	
	  function OrderingSlidePanel(props) {
	    _classCallCheck(this, OrderingSlidePanel);
	
	    var _this = _possibleConstructorReturn(this, (OrderingSlidePanel.__proto__ || Object.getPrototypeOf(OrderingSlidePanel)).call(this, props));
	
	    _this.state = {
	      selectedSpareParts: [],
	      view: '',
	      isOpen: false,
	      isLoading: false,
	      spareParts: [],
	      SelectedFilesIds: [],
	      SelectedFileSizes: {
	        FileSizesInByte: {},
	        TotalSizeInByte: 0,
	        TotalSizeInKB: 0,
	        TotalSizeInMB: 0,
	        MaxEmailFileSizeInByte: 0,
	        MaxEmailFileSizeInKB: 0,
	        MaxEmailFileSizeInMB: 0,
	        HasExeededMaxEmailFileSize: false
	      },
	      suppliers: [],
	      add: {
	        sparepart: {
	          OrderId: 0,
	          SparePartNumber: '',
	          Quantity: 1
	        }
	      },
	      statusChange: {
	        Quantity: 1,
	        Status: 1,
	        QualityType: 0,
	        SubQualityType: null,
	        Comment: '',
	        SupplierId: null,
	        Pickup: null,
	        Discount: null,
	        DeliveryDate: null,
	        AddCommentToOrderEmail: true
	      },
	      partNumberChange: {
	        Quantity: 1,
	        SparePartNumberAlias: '',
	        useAlternativePartNumber: 0
	      },
	      supplierDeliveryChange: {
	        supplierId: 0,
	        deliveryDate: '',
	        deliveryTime: ''
	      },
	
	      images: [],
	      upload: {
	        shouldCapture: true,
	        errors: []
	      },
	      activeImage: {},
	      imageUploadsStarted: 0,
	      imageUploadsCompleted: 0,
	      confirm: false,
	      imageToDeleteId: 0
	    };
	
	    _this.getOrderFileSizes = _this.getOrderFileSizes.bind(_this);
	    _this.getSpareParts = _this.getSpareParts.bind(_this);
	    _this.renderAddSparepart = _this.renderAddSparepart.bind(_this);
	    _this.renderStatusChange = _this.renderStatusChange.bind(_this);
	    _this.renderListDetail = _this.renderListDetail.bind(_this);
	    _this.renderSparepartNumberChange = _this.renderSparepartNumberChange.bind(_this);
	    _this.closeSlidePanel = _this.closeSlidePanel.bind(_this);
	    _this.changeView = _this.changeView.bind(_this);
	    _this.isDracarMatch = _this.isDracarMatch.bind(_this);
	    _this.usesDracar = _this.usesDracar.bind(_this);
	    _this.usesDracarCreation = _this.usesDracarCreation.bind(_this);
	    // Image
	    // this.submitImage = this.submitImage.bind(this)
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onDropAccepted = _this.onDropAccepted.bind(_this);
	    _this.onDropRejected = _this.onDropRejected.bind(_this);
	    _this.checkboxChange = _this.checkboxChange.bind(_this);
	    _this.renderFileSizeError = _this.renderFileSizeError.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderingSlidePanel, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var images = [];
	      this.props.getOrderFiles(this.props.orderId, 1).then(function (res) {
	        res.data.forEach(function (element) {
	          images.push({
	            imagePath: _constants.FILE_STORAGE + element.FileURL,
	            thumbPath: _constants.FILE_STORAGE + element.ThumbURL,
	            OrderFileID: element.OrderFileID
	          });
	        }, _this2);
	        _this2.setState({
	          images: images
	        });
	      });
	
	      this.setState({
	        view: this.props.view,
	        spareParts: this.props.selectedSpareParts
	      });
	
	      this.getOrderFileSizes();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      var _this3 = this;
	
	      var selectedSpareParts = next.selectedSpareParts;
	      if (next.view === 'listDetail' && !(0, _lodash.isEqual)(this.props.spareparts, next.selectedSpareParts) && next.selectedSpareParts.length === 1) {
	        this.props.getOrderingSparePartDetails(next.selectedSpareParts[0]).then(function (res) {
	          _this3.setState({
	            spareParts: res.data,
	            selectedSpareParts: selectedSpareParts
	          }, function () {
	            if (next.view !== _this3.state.view) {
	              _this3.changeView(next.view);
	            }
	          });
	        });
	      } else if (!(0, _lodash.isEqual)(this.state.spareparts, next.selectedSpareParts)) {
	        var extra = {};
	        var multiViewTotal = next.selectedSpareParts.reduce(function (total, part) {
	          return total + (part.Count - part.Handled);
	        }, 0);
	        var totalCount = next.selectedSpareParts.reduce(function (total, part) {
	          return total + part.Count;
	        }, 0);
	        var selectedQualityType = this.state.statusChange.QualityType;
	        var selectedSubQualityType = this.state.statusChange.QualityType;
	        var status = this.state.statusChange.Status;
	
	        if (next.selectedSpareParts.length > 0) {
	          selectedQualityType = next.selectedSpareParts[0].QualityType;
	          selectedSubQualityType = next.selectedSpareParts[0].SubQualityType;
	          status = next.selectedSpareParts[0].Status;
	          if (!next.selectedSpareParts.every(function (x) {
	            return x.QualityType === selectedQualityType;
	          })) selectedQualityType = 0;
	          if (!next.selectedSpareParts.every(function (x) {
	            return x.SubQualityType === selectedSubQualityType;
	          })) selectedSubQualityType = null;
	        }
	        if (next.view === 'status') {
	          // multi qualityType selection, is separate view
	          if (next.selectedSpareParts.length > 1) {
	            selectedQualityType = null;
	            selectedSubQualityType = null;
	            // in multi row selection, take only spare parts with unknown status
	            totalCount = multiViewTotal;
	            status = 1;
	          }
	          extra.statusChange = _extends({}, this.state.statusChange, {
	            Quantity: totalCount,
	            Status: status,
	            QualityType: selectedQualityType,
	            SubQualityType: selectedSubQualityType
	          });
	        } else if (next.view === 'partNumber') {
	          extra.partNumberChange = _extends({}, this.state.partNumberChange, {
	            Quantity: totalCount
	          });
	        } else if (next.view === 'multiQuality') {
	          extra.statusChange = _extends({}, this.state.statusChange, {
	            Quantity: multiViewTotal,
	            Status: 1,
	            QualityType: selectedQualityType,
	            SubQualityType: selectedSubQualityType
	          });
	        }
	
	        this.setState(_extends({
	          selectedSpareParts: selectedSpareParts,
	          spareParts: next.selectedSpareParts
	        }, extra), function () {
	          if (next.view !== _this3.state.view || next.isOpen) {
	            _this3.changeView(next.view);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getOrderFileSizes',
	    value: function getOrderFileSizes() {
	      var _this4 = this;
	
	      this.props.getOrderFileSizes(this.state.SelectedFilesIds).then(function (res) {
	        _this4.setState({ SelectedFileSizes: res.data });
	      });
	    }
	  }, {
	    key: 'changeView',
	    value: function changeView(view, index) {
	      if (index !== undefined) {
	        this.setState({
	          spareParts: [this.state.spareParts[index]],
	          statusChange: _extends({}, this.state.statusChange, {
	            Status: this.state.spareParts[index].Status,
	            Quantity: this.state.spareParts[index].Count,
	            QualityType: this.state.spareParts[index].QualityType,
	            SubQualityType: this.state.spareParts[index].SubQualityType })
	        });
	      }
	      this.setState({
	        view: view
	      });
	      if (view === 'status') this.getOrderingSparePartSuppliers();
	    }
	  }, {
	    key: 'checkboxChange',
	    value: function checkboxChange(e) {
	      this.getSelectedFiles();
	    }
	  }, {
	    key: 'renderFileSizeError',
	    value: function renderFileSizeError() {
	      var _state$SelectedFileSi = this.state.SelectedFileSizes,
	          TotalSizeInMB = _state$SelectedFileSi.TotalSizeInMB,
	          MaxEmailFileSizeInMB = _state$SelectedFileSi.MaxEmailFileSizeInMB,
	          HasExeededMaxEmailFileSize = _state$SelectedFileSi.HasExeededMaxEmailFileSize;
	
	
	      var text = (0, _currency.formatCurrency)(TotalSizeInMB, 1) + ' / ' + (0, _currency.formatCurrency)(MaxEmailFileSizeInMB, 1) + ' MB';
	
	      if (!HasExeededMaxEmailFileSize) {
	        return _react2.default.createElement(
	          _label2.default,
	          null,
	          text
	        );
	      }
	
	      return _react2.default.createElement(
	        _grid2.default,
	        { align: 'center', cols: ['min-content', 'auto'] },
	        _react2.default.createElement(_icon2.default, { size: 's', icon: _icons.ElementIcons.Warning }),
	        _react2.default.createElement(
	          'span',
	          { className: 'alert-message' },
	          text
	        )
	      );
	    }
	  }, {
	    key: 'renderImages',
	    value: function renderImages() {
	      var _this5 = this;
	
	      var images = this.state.images;
	      // Render image
	
	      var renderImage = function renderImage(image, index) {
	        if (image.imageUrl !== undefined) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'div',
	                { className: 'delete' },
	                _react2.default.createElement(_removeButton2.default, _extends({}, _this5.props, { onClick: function onClick() {
	                    return _this5.deleteImage(image, index);
	                  }, size: 's' }))
	              ),
	              _react2.default.createElement('img', { className: 'img2', id: image.OrderFileID, src: image.imageUrl })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'divCheckbox' },
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('1218'), id: image.OrderFileID, name: 'checkbox_image', checked: true, disabled: true })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'divImg' },
	              _react2.default.createElement(
	                'a',
	                { href: image.imagePath, 'data-lightbox': 'gallery' },
	                _react2.default.createElement('img', { className: 'img3', id: image.OrderFileID, name: 'oldImages', src: image.thumbPath })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'divCheckbox' },
	              _react2.default.createElement(_check2.default, { spacing: 0, labelText: (0, _helpers.translation)('1218'), id: image.OrderFileID, name: 'checkbox_image', checked: _this5.state.SelectedFilesIds.includes(image.OrderFileID), onChange: _this5.checkboxChange })
	            )
	          );
	        }
	      };
	
	      // Confirm
	      var onPortalClose = function onPortalClose() {
	        _this5.setState({
	          confirm: false
	        });
	      };
	      var onConfirm = function onConfirm() {
	        if (_this5.state.imageToDeleteId !== 0) {
	          var files = _this5.state.SelectedFilesIds.filter(function (x) {
	            return x !== _this5.state.imageToDeleteId;
	          });
	          _this5.setState({
	            SelectedFilesIds: files,
	            imageToDeleteId: 0
	          }, _this5.getOrderFileSizes);
	        }
	        var images = [].concat(_toConsumableArray(_this5.state.images));
	        images.splice(_this5.state.confirm, 1);
	        _this5.setState({
	          confirm: false,
	          images: images
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderFileSizeError(),
	        _react2.default.createElement(_Gallery2.default, { files: images, renderImage: renderImage }),
	        this.state.confirm !== false && _react2.default.createElement(
	          _Portal2.default,
	          { className: 'deleteModal', t: this.props.t, onPortalClose: onPortalClose },
	          _react2.default.createElement(_Confirm2.default, { confirm: onConfirm, notConfirm: onPortalClose })
	        )
	      );
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop() {
	      this.setState({ upload: _extends({}, this.state.upload, { errors: [] }) });
	    }
	  }, {
	    key: 'onDropAccepted',
	    value: function onDropAccepted(files) {
	      var _this6 = this;
	
	      this.setState({ imageUploadsStarted: this.state.imageUploadsStarted + files.length });
	      this.props.uploadMultipleFiles(files, this.props.orderId, undefined, undefined, undefined).then(function (fileResponse) {
	        var newImages = [].concat(_toConsumableArray(_this6.state.images));
	        var uploadedFiles = fileResponse.data;
	        uploadedFiles.map(function (val, index) {
	          if (val.IsImage) {
	            newImages.push({
	              imageUrl: val.RealFileURL,
	              ImageSize: {
	                Width: 0,
	                Height: 0
	              },
	              OrderFileID: val.OrderFileID,
	              circles: [],
	              ImageType: 2,
	              base64: files[index].imageUrl,
	              rotation: 0
	            });
	          }
	        });
	        newImages.map(function (val) {
	          if (typeof val.ImageSize === 'undefined') {
	            val.ImageSize = {
	              Width: 0,
	              Height: 0
	            };
	          }
	        });
	        _this6.setState({ images: newImages, imageUploadsCompleted: _this6.state.imageUploadsCompleted + files.length });
	        _this6.getSelectedFiles();
	      }).catch(function () {
	        _this6.setState({ imageUploadsCompleted: _this6.state.imageUploadsCompleted + files.length });
	      });
	    }
	  }, {
	    key: 'onDropRejected',
	    value: function onDropRejected(files) {
	      var newErrors = [];
	      files.map(function (val, index) {
	        newErrors.push((0, _helpers.translation)('1207') + ': ' + val.name + ' ' + (0, _helpers.translation)('13405') + '.');
	      });
	      this.setState({ upload: _extends({}, this.state.upload, { errors: newErrors }) });
	    }
	  }, {
	    key: 'deleteImage',
	    value: function deleteImage(image, index) {
	      this.setState({
	        confirm: index,
	        imageToDeleteId: image.OrderFileID
	      });
	    }
	  }, {
	    key: 'getSelectedFiles',
	    value: function getSelectedFiles() {
	      var orderFileIds = [];
	      var inp = document.getElementsByTagName('input');
	      for (var i = 0; i < inp.length; i++) {
	        if (inp[i].name === 'checkbox_image' && inp[i].checked === true) {
	          orderFileIds.push(Number(inp[i].id));
	        }
	      }
	      this.setState({
	        SelectedFilesIds: orderFileIds
	      }, this.getOrderFileSizes);
	    }
	  }, {
	    key: 'getSpareParts',
	    value: function getSpareParts(sparePartNumbers) {
	      var relevantParts = this.props.spareParts.filter(function (sp) {
	        return sparePartNumbers.includes(sp.OriginalSparePartNumber);
	      });
	
	      this.setState({
	        spareParts: relevantParts
	      });
	    }
	  }, {
	    key: 'getOrderingSparePartSuppliers',
	    value: function getOrderingSparePartSuppliers() {
	      var _this7 = this;
	
	      var hasUrgent = this.state.selectedSpareParts.findIndex(function (x) {
	        return x.UrgentDelivery;
	      }) !== -1;
	      this.props.getOrderingSparePartSuppliers(this.props.orderId, hasUrgent ? 2 : 1).then(function (res) {
	        _this7.setState({
	          suppliers: res.data
	        });
	      });
	    }
	  }, {
	    key: 'closeSlidePanel',
	    value: function closeSlidePanel() {
	      var preventResetingView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.setState({ // Dafault state
	        view: preventResetingView ? this.state.view : '',
	        spareParts: [],
	        add: {
	          sparepart: {
	            OrderId: 0,
	            SparePartNumber: '',
	            Quantity: 1
	          }
	        },
	        statusChange: {
	          Quantity: 1,
	          Status: 1,
	          Comment: '',
	          SupplierId: null,
	          Pickup: null
	        },
	        partNumberChange: {
	          Quantity: 1,
	          SparePartNumberAlias: '',
	          useAlternativePartNumber: 0
	        }
	      });
	      this.props.onDone();
	      this.props.closeSlidePanel(this.props.slidePanelId);
	    }
	  }, {
	    key: 'isMultipleSpareParts',
	    value: function isMultipleSpareParts() {
	      return this.state.spareParts.length > 1;
	    }
	  }, {
	    key: 'isDracarMatch',
	    value: function isDracarMatch(status) {
	      switch (status) {
	        case 2:
	        case 4:
	        case 5:
	        case 1001:
	        case 2002:
	          return true;
	        default:
	          return false;
	      }
	    }
	  }, {
	    key: 'usesDracar',
	    value: function usesDracar() {
	      // We do not check if invoicing to Dracar is active, just that they are allowed and have it selected.
	      return this.props.auth.permissions.DracarUsable;
	    }
	  }, {
	    key: 'usesDracarCreation',
	    value: function usesDracarCreation() {
	      return this.props.auth.permissions.UseDracarSparePartCreation;
	    }
	  }, {
	    key: 'renderAddSparepart',
	    value: function renderAddSparepart() {
	      var _this8 = this;
	
	      var createSparePart = function createSparePart() {
	        var data = _this8.state.add.sparepart;
	        data.OrderId = _this8.props.orderId;
	        data.Filter = _this8.props.sparePartsFilter;
	        _this8.props.createSparePart(data).then(function () {
	          // this.changeView('status')
	          _this8.getSpareParts([data.SparePartNumber]);
	          _this8.closeSlidePanel();
	          // this.props.onDone('add', data.SparePartNumber)
	          _this8.props.onDone();
	        });
	      };
	
	      var onChange = function onChange(e) {
	        var target = e.target;
	        if (!target) target = e;
	
	        _this8.setState({
	          add: _extends({}, _this8.state.add, {
	            sparepart: _extends({}, _this8.state.add.sparepart, _defineProperty({}, target.name, target.value))
	          })
	        });
	      };
	
	      var sparepart = this.state.add.sparepart;
	      var isDisabled = sparepart.SparePartNumber.length === 0 || this.usesDracar() && this.usesDracarCreation();
	      return [_react2.default.createElement(
	        'div',
	        { className: 'top', key: 0 },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          (0, _helpers.translation)(16445)
	        )
	      ), _react2.default.createElement(
	        'div',
	        { className: 'content', key: 1 },
	        _react2.default.createElement(_text2.default, { labelText: (0, _helpers.translation)(16445), placeholder: (0, _helpers.translation)(16446), name: 'SparePartNumber', value: sparepart.SparePartNumber, onChange: onChange }),
	        _react2.default.createElement(_countSpecifier2.default, { disabled: isDisabled, value: sparepart.Quantity, name: 'Quantity', onChange: onChange }),
	        _react2.default.createElement(_divider2.default, null)
	      ), _react2.default.createElement(_bottomBar2.default, { disabled: isDisabled, actionLabelText: (0, _helpers.translation)(1208), cancelLabelText: (0, _helpers.translation)(16444), onCancelClick: function onCancelClick() {
	          return _this8.closeSlidePanel(true);
	        }, onActionClick: createSparePart, key: 2 })];
	    }
	  }, {
	    key: 'renderStatusChange',
	    value: function renderStatusChange(multiType) {
	      var _this9 = this;
	
	      var _state = this.state,
	          spareParts = _state.spareParts,
	          statusChange = _state.statusChange,
	          suppliers = _state.suppliers;
	
	      var showStatus = !multiType || multiType === 'status' || !this.isMultipleSpareParts();
	      var showQuality = !multiType || multiType === 'quality' || !this.isMultipleSpareParts();
	      var onChange = function onChange(e) {
	        var _e$target = e.target,
	            name = _e$target.name,
	            value = _e$target.value,
	            checked = _e$target.checked,
	            type = _e$target.type;
	
	
	        var newValue = value;
	        var extra = {};
	
	        var setExtraForSupplier = function setExtraForSupplier(supplier) {
	          extra.SupplierId = supplier.Id;
	          extra.Pickup = supplier.PickupSelf; // Set default value for pickup
	          extra.Discount = supplier.Discount;
	          extra.DeliveryDate = supplier.DeliveryDate;
	        };
	
	        if (type === 'checkbox') {
	          newValue = checked;
	        }
	
	        if (name === 'Status' || name === 'QualityType' || name === 'SubQualityType') {
	          newValue = Number(value);
	
	          if (newValue === 8 && Array.isArray(suppliers) && suppliers.length === 1) {
	            // If only one supplier, select
	            setExtraForSupplier(suppliers[0]);
	          }
	        }
	        if (name === 'QualityType' && newValue === 2) {
	          statusChange.SubQualityType = 1;
	        }
	
	        if (name === 'SupplierId') {
	          newValue = Number(value);
	
	          var supplier = suppliers.find(function (x) {
	            return x.Id === newValue;
	          });
	          setExtraForSupplier(supplier);
	        }
	
	        _this9.setState({
	          statusChange: _extends({}, statusChange, extra, _defineProperty({}, name, newValue))
	        });
	      };
	
	      var totalCount = spareParts.reduce(function (total, part) {
	        return total + part.Count;
	      }, 0);
	
	      var renderContent = function renderContent() {
	        var hasSuppliers = Array.isArray(suppliers) && suppliers.length > 0;
	
	        var renderSupplierRadio = function renderSupplierRadio(supplier, key) {
	          var name = 'SupplierId';
	          var value = supplier.Id;
	          var checked = statusChange.SupplierId === supplier.Id;
	
	          var onClick = function onClick() {
	            var supplier = suppliers.find(function (x) {
	              return x.Id === value;
	            });
	
	            var date = '';
	            var time = '';
	            if (checked && statusChange.DeliveryDate) {
	              date = (0, _moment2.default)(statusChange.DeliveryDate);
	            }
	            if ((!_moment2.default.isMoment(date) || !date.isValid()) && supplier.DeliveryDate) {
	              date = (0, _moment2.default)(supplier.DeliveryDate);
	            }
	            if (_moment2.default.isMoment(date) && date.isValid()) {
	              time = date.format('HH:mm');
	            }
	
	            _this9.setState({
	              supplierDeliveryChange: {
	                supplierId: value,
	                deliveryDate: date,
	                deliveryTime: time
	              }
	            });
	
	            _this9.changeView('supplierDelivery');
	          };
	
	          var renderSupplierInfo = function renderSupplierInfo() {
	            var date = checked ? statusChange.DeliveryDate : supplier.DeliveryDate;
	            return _react2.default.createElement(
	              _grid2.default,
	              { cols: ['min-content', 1], align: 'center', onClick: onClick },
	              supplier.Discount ? _react2.default.createElement(
	                'span',
	                { className: 'suppliers__discount' },
	                '-',
	                supplier.Discount,
	                ' %'
	              ) : _react2.default.createElement('div', null),
	              _react2.default.createElement(
	                'span',
	                { className: 'suppliers__delivery' },
	                date && (0, _time.getRelativeDateTime)(date)
	              )
	            );
	          };
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'suppliers__item', key: 'suppliersItem_' + key },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: [1, 'min-content'], align: 'center' },
	              _react2.default.createElement(_radio2.default, { name: name, value: value, checked: checked, onChange: onChange, labelText: supplier.Name }),
	              _react2.default.createElement('i', { className: 'fa fa-chevron-right', onClick: onClick })
	            ),
	            renderSupplierInfo()
	          );
	        };
	
	        var renderPreviousComment = function renderPreviousComment(item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              _label2.default,
	              null,
	              item.Note
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              item.NoteUserName + ' - ' + (0, _time.renderFullDate)(item.NoteDate)
	            ),
	            _react2.default.createElement(_divider2.default, null)
	          );
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'content status', key: 'content' },
	          totalCount > 1 && !_this9.isMultipleSpareParts() && [_react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(16447), key: 0 },
	            _react2.default.createElement(_countSpecifier2.default, { total: totalCount, name: 'Quantity', value: statusChange.Quantity, onChange: onChange })
	          ), _react2.default.createElement(_divider2.default, { size: 3, key: 1 })],
	          showQuality && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(17849) },
	            _react2.default.createElement(_radio2.default, { name: 'QualityType', value: 0, checked: statusChange.QualityType === 0, onChange: onChange, labelText: (0, _helpers.translation)(17850) }),
	            _react2.default.createElement(_radio2.default, { name: 'QualityType', value: 1, checked: statusChange.QualityType === 1, onChange: onChange, labelText: (0, _helpers.translation)(17851) }),
	            _react2.default.createElement(_radio2.default, { name: 'QualityType', value: 2, checked: statusChange.QualityType === 2, onChange: onChange, labelText: (0, _helpers.translation)(76) }),
	            statusChange.QualityType === 2 && _react2.default.createElement(
	              'div',
	              { className: 'subquality' },
	              _react2.default.createElement(_radio2.default, { name: 'SubQualityType', value: 1, checked: statusChange.SubQualityType === 1, onChange: onChange, labelText: (0, _helpers.translation)(17852) }),
	              _react2.default.createElement(_radio2.default, { name: 'SubQualityType', value: 2, checked: statusChange.SubQualityType === 2, onChange: onChange, labelText: (0, _helpers.translation)(17853) }),
	              _react2.default.createElement(_radio2.default, { name: 'SubQualityType', value: 3, checked: statusChange.SubQualityType === 3, onChange: onChange, labelText: (0, _helpers.translation)(17854) })
	            )
	          ),
	          showStatus && _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(16448) },
	            _react2.default.createElement(_radio2.default, { name: 'Status', value: 1, checked: statusChange.Status === 1, onChange: onChange, labelText: (0, _helpers.translation)(15392) }),
	            _react2.default.createElement(_radio2.default, { name: 'Status', value: 2, checked: statusChange.Status === 2, onChange: onChange, labelText: (0, _helpers.translation)(16449) }),
	            !_this9.usesDracar() ? _react2.default.createElement(_radio2.default, { name: 'Status', value: 4, checked: statusChange.Status === 4, onChange: onChange, labelText: (0, _helpers.translation)(14799) }) : null,
	            _react2.default.createElement(_radio2.default, { name: 'Status', value: 8, checked: statusChange.Status === 8, onChange: onChange, labelText: (0, _helpers.translation)(16457) + '...', disabled: !hasSuppliers }),
	            _react2.default.createElement(
	              'div',
	              { className: 'suppliers' },
	              !hasSuppliers && _react2.default.createElement(
	                'label',
	                null,
	                (0, _helpers.translation)(16460)
	              ),
	              hasSuppliers && statusChange.Status === 8 && [suppliers.map(renderSupplierRadio), _react2.default.createElement(_divider2.default, { key: 'divider_0' }), _react2.default.createElement(_check2.default, { key: 'check_1', name: 'Pickup', checked: statusChange.Pickup, onChange: onChange, labelText: _react2.default.createElement(
	                  _inline2.default,
	                  { spacing: 0 },
	                  (0, _helpers.translation)(16458),
	                  _react2.default.createElement(_icon2.default, { icon: _icons.SparePartModuleIcons.Pickup })
	                ) })]
	            )
	          ),
	          _react2.default.createElement(_divider2.default, { size: 3 }),
	          _react2.default.createElement(_textarea2.default, { name: 'Comment', value: statusChange.Comment, onChange: onChange, labelText: (0, _helpers.translation)(149) }),
	          _react2.default.createElement(_check2.default, { key: 1, name: 'AddCommentToOrderEmail', checked: statusChange.AddCommentToOrderEmail, onChange: onChange, labelText: _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              (0, _helpers.translation)(18072)
	            ) }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Dropzone2.default,
	              {
	                onDrop: _this9.onDrop,
	                onDropAccepted: _this9.onDropAccepted,
	                onDropRejected: _this9.onDropRejected },
	              _react2.default.createElement(
	                'p',
	                null,
	                (0, _helpers.translation)('13397')
	              )
	            )
	          ),
	          _this9.renderImages(),
	          _this9.props.previousComments.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'previous-comments' },
	            _react2.default.createElement(
	              _labelWrapper2.default,
	              { labelText: (0, _helpers.translation)(16459) },
	              _this9.props.previousComments.map(renderPreviousComment)
	            )
	          )
	        );
	      };
	
	      var submitSpareParts = function submitSpareParts() {
	        var sparePartsBody = _extends({
	          OrderId: _this9.props.orderId,
	          SpareParts: _this9.state.spareParts
	        }, statusChange, {
	          Quantity: !_this9.isMultipleSpareParts() ? statusChange.Quantity : null,
	          Filter: _this9.props.sparePartsFilter,
	          SelectedFilesIds: _this9.state.SelectedFilesIds
	        });
	
	        _this9.setState({
	          isLoading: true
	        });
	
	        _this9.props.updateSparePartsOrdering(sparePartsBody).then(function (res) {
	          if (res.data.Errors !== null && res.data.Errors.length > 0) {
	            res.data.Errors.map(function (x) {
	              return window.toastr.info((0, _helpers.translation)(x.DictionaryKey));
	            });
	          } else if (sparePartsBody.Status === 8) {// Status is ordering
	            // window.toastr.success(translation('16462'), translation('13424'))
	          }
	
	          _this9.setState({
	            isLoading: false
	          }, _this9.closeSlidePanel);
	        }, function () {
	          _this9.setState({
	            isLoading: false
	          });
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        });
	      };
	
	      var titleText = (0, _helpers.translation)(13052);
	      var statusHeader = [];
	
	      if (spareParts.length === 1) {
	        if (this.usesDracar() && this.isDracarMatch(spareParts[0].DracarStatus)) {
	          statusHeader.push(_react2.default.createElement(
	            'h3',
	            { key: 'header_0', className: 'sub-title' },
	            totalCount + ' x ' + (spareParts[0].SparePartNumberAlias || spareParts[0].OriginalSparePartNumber)
	          ));
	        } else {
	          statusHeader.push(_react2.default.createElement(
	            'h3',
	            { key: 'header_1', className: 'clickable sub-title', onClick: function onClick() {
	                return _this9.changeView('partNumber');
	              } },
	            totalCount + ' x ' + (spareParts[0].SparePartNumberAlias || spareParts[0].OriginalSparePartNumber)
	          ));
	          statusHeader.push(_react2.default.createElement('i', { key: 'header_2', className: 'fa fa-chevron-right clickable sub-title-right', onClick: function onClick() {
	              return _this9.changeView('partNumber');
	            } }));
	        }
	      } else {
	        var hasUrgent = this.state.selectedSpareParts.findIndex(function (x) {
	          return x.UrgentDelivery;
	        }) !== -1;
	        var header = _react2.default.createElement(
	          'div',
	          { className: 'sub-title', key: 'header_3' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            (0, _helpers.translation)(16451),
	            ' #'
	          ),
	          hasUrgent && _react2.default.createElement(
	            'p',
	            { className: 'alert-urgent' },
	            (0, _helpers.translation)(17905)
	          )
	        );
	        statusHeader.push(header);
	      }
	
	      return [_react2.default.createElement(
	        'div',
	        { className: 'top', key: 'top' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          titleText
	        ),
	        statusHeader
	      ), renderContent(), _react2.default.createElement(_bottomBar2.default, { disabled: this.state.isLoading || this.state.SelectedFileSizes.HasExeededMaxEmailFileSize, actionLabelText: (0, _helpers.translation)(16455), cancelLabelText: (0, _helpers.translation)(16444), onCancelClick: this.closeSlidePanel, onActionClick: submitSpareParts, key: 2 })];
	    }
	  }, {
	    key: 'renderListDetail',
	    value: function renderListDetail() {
	      var _this10 = this;
	
	      var spareParts = this.state.spareParts;
	
	
	      var totalCount = spareParts.reduce(function (total, part) {
	        return total + part.Count;
	      }, 0);
	
	      var renderStatus = function renderStatus(item, index) {
	        var icon = _icons.SparePartModuleIcons.OK;
	        var isOrdered = item.Status === 8;
	        if (item.Status === 1) icon = _icons.SparePartModuleIcons.Warning;
	        var status = void 0;
	        switch (item.Status) {
	          case 2:
	            status = (0, _helpers.translation)(16449);
	            break;
	          case 4:
	            status = (0, _helpers.translation)(14799);
	            break;
	          case 8:
	            status = (0, _helpers.translation)(16457) + '...';
	            break;
	          case 1:
	          default:
	            status = (0, _helpers.translation)(15392);
	            break;
	        }
	
	        var supplier = item.Suppliers[0];
	
	        return [_react2.default.createElement(
	          _grid2.default,
	          { cols: 'auto min-content' },
	          _react2.default.createElement(
	            _labelWrapper2.default,
	            { labelText: (0, _helpers.translation)(13052) + ' - ' + status, key: index },
	            _react2.default.createElement(
	              _grid2.default,
	              { cols: 'min-content auto' },
	              _react2.default.createElement(_icon2.default, { icon: icon, injectSvg: true }),
	              _react2.default.createElement(
	                _grid2.default,
	                { cols: 'auto' },
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  item.Count + ' x ' + (item.Status === 8 ? supplier.Name : status)
	                ),
	                _react2.default.createElement(
	                  _label2.default,
	                  null,
	                  item.Count + ' x ' + (isOrdered ? item.Suppliers[0].Name : status)
	                ),
	                supplier && (supplier.Discount > 0 || supplier.DeliveryDate) && _react2.default.createElement(
	                  'div',
	                  { className: 'suppliers' },
	                  _react2.default.createElement(
	                    _grid2.default,
	                    { cols: ['max-content', 'min-content'], align: 'center' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'suppliers__delivery' },
	                      supplier.DeliveryDate && (0, _time.getRelativeDateTime)(supplier.DeliveryDate)
	                    ),
	                    supplier.Discount ? _react2.default.createElement(
	                      'span',
	                      { className: 'suppliers__discount' },
	                      '-',
	                      supplier.Discount,
	                      ' %'
	                    ) : _react2.default.createElement('div', null)
	                  )
	                ),
	                item.RequiresPaint && _react2.default.createElement(
	                  'h4',
	                  null,
	                  (0, _helpers.translation)(16450)
	                ),
	                item.Pickup && _react2.default.createElement(
	                  'h4',
	                  null,
	                  (0, _helpers.translation)(16458)
	                )
	              )
	            )
	          ),
	          !isOrdered ? _react2.default.createElement('i', { className: 'fa fa-chevron-right clickable sub-title-right', onClick: function onClick() {
	              return _this10.changeView('status', index);
	            } }) : _react2.default.createElement('div', null)
	        ), _react2.default.createElement(_divider2.default, { size: 3, key: index + 1 })];
	      };
	
	      var sparePart = spareParts[0] || {};
	      var partCount = totalCount + ' x ' + (sparePart.SparePartNumberAlias || sparePart.OriginalSparePartNumber);
	      var titleText = (0, _helpers.translation)(13052);
	      var allowSparePartNumberChange = true;
	      var clickableSubtitle = _react2.default.createElement(
	        'h3',
	        { className: 'sub-title clickable', onClick: function onClick() {
	            return _this10.changeView('partNumber');
	          } },
	        partCount
	      );
	
	      if (this.usesDracar()) {
	        var foundMatched = spareParts.find(function (sp) {
	          return _this10.isDracarMatch(sp.DracarStatus);
	        });
	
	        if (foundMatched) {
	          allowSparePartNumberChange = false;
	          clickableSubtitle = _react2.default.createElement(
	            'h3',
	            { className: 'sub-title' },
	            partCount
	          );
	        }
	      }
	
	      return [_react2.default.createElement(
	        'div',
	        { className: 'top', key: 0 },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          titleText
	        ),
	        clickableSubtitle,
	        allowSparePartNumberChange ? _react2.default.createElement('i', { className: 'fa fa-chevron-right clickable sub-title-right', onClick: function onClick() {
	            return _this10.changeView('partNumber');
	          } }) : _react2.default.createElement('div', null)
	      ), _react2.default.createElement(
	        'div',
	        { className: 'content status-list', key: 1 },
	        spareParts.map(renderStatus)
	      ), _react2.default.createElement(_bottomBar2.default, { cancelLabelText: (0, _helpers.translation)(235), onCancelClick: this.closeSlidePanel, key: 2 })];
	    }
	  }, {
	    key: 'renderSparepartNumberChange',
	    value: function renderSparepartNumberChange() {
	      var _this11 = this;
	
	      var _state2 = this.state,
	          spareParts = _state2.spareParts,
	          partNumberChange = _state2.partNumberChange;
	
	      var sparepart = spareParts[0];
	      var count = sparepart.Count;
	
	      if (this.usesDracar()) {
	        if (spareParts.length > 1) {
	          sparepart = spareParts.find(function (sp) {
	            return sp.Status === 1;
	          });
	
	          if (!sparepart) {
	            sparepart = spareParts.find(function (sp) {
	              return sp.Status === 2;
	            });
	          }
	
	          count = sparepart.Count;
	        } else {
	          count = sparepart.Count - sparepart.Handled;
	        }
	      }
	
	      var onChange = function onChange(e) {
	        var target = e.target;
	        if (!target) target = e;
	
	        var extra = {};
	        var newValue = target.value;
	        var name = target.name;
	
	        if (name === 'useAlternativePartNumber') newValue = Number(newValue);
	        if (name === 'SparePartNumberAlias' && newValue.length > 0 || name === 'useAlternativePartNumber' && newValue === 1) extra.useAlternativePartNumber = 1;else if (name === 'SparePartNumberAlias' && (!newValue || newValue.length === 0) || name === 'useAlternativePartNumber' && newValue === 0) extra.useAlternativePartNumber = 0;
	
	        _this11.setState({
	          partNumberChange: _extends({}, partNumberChange, extra, _defineProperty({}, name, newValue))
	        });
	      };
	
	      var onDone = function onDone() {
	        _this11.changeView(_this11.props.view);
	      };
	
	      var submitSpareParts = function submitSpareParts() {
	        if (partNumberChange.useAlternativePartNumber === 0) {
	          // If not use alias go back to previous view
	          onDone();
	          return;
	        }
	
	        var data = {
	          OrderId: _this11.props.orderId,
	          SpareParts: spareParts,
	          Quantity: partNumberChange.Quantity,
	          SparePartNumberAlias: partNumberChange.SparePartNumberAlias,
	          Filter: _this11.props.sparePartsFilter,
	          SelectedFilesIds: _this11.state.SelectedFilesIds
	        };
	
	        _this11.props.updateSparePartsOrdering(data).then(function (res) {
	          if (res.data.Errors.length > 0) {
	            res.data.Errors.map(function (x) {
	              return window.toastr.info((0, _helpers.translation)(x.DictionaryKey));
	            });
	          }
	
	          _this11.closeSlidePanel();
	        }, function () {
	          window.toastr.error((0, _helpers.translation)('960'), (0, _helpers.translation)('216'));
	        });
	      };
	
	      var totalCount = count; // - sparepart.Handled
	      var hasValidPartNumber = partNumberChange.SparePartNumberAlias.length > 0;
	      var useAlternative = partNumberChange.useAlternativePartNumber === 1;
	      var allowAlternatePartNumber = true;
	      if (this.usesDracar()) {
	        allowAlternatePartNumber = count > 0;
	      }
	
	      var renderOriginalSparePartNUmberInfo = function renderOriginalSparePartNUmberInfo() {
	        return [_react2.default.createElement(
	          _label2.default,
	          { key: 0, size: 't' },
	          sparepart.SparePartNumberAlias || sparepart.OriginalSparePartNumber
	        ), _react2.default.createElement(
	          _label2.default,
	          { key: 1, size: 't' },
	          sparepart.Description
	        )];
	      };
	      return [_react2.default.createElement(
	        'div',
	        { className: 'top', key: 0 },
	        _react2.default.createElement(_icon2.default, { className: 'clickable title-left', icon: _icons.SparePartModuleIcons.Back, onClick: onDone }),
	        _react2.default.createElement(
	          'h1',
	          { className: 'clickable title', onClick: onDone },
	          (0, _helpers.translation)(16463)
	        )
	      ), _react2.default.createElement(
	        'div',
	        { className: 'content partnumber', key: 1 },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: sparepart.OrderSparePartId ? (0, _helpers.translation)(16464) : (0, _helpers.translation)(16465) },
	          _react2.default.createElement(_radio2.default, { name: 'useAlternativePartNumber', value: 0, checked: partNumberChange.useAlternativePartNumber === 0, onChange: onChange, labelText: renderOriginalSparePartNUmberInfo() })
	        ),
	        _react2.default.createElement(_orangeDivider2.default, { labelText: 16467, size: 2 }),
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)(16466) },
	          _react2.default.createElement(
	            _inline2.default,
	            null,
	            _react2.default.createElement(_radio2.default, { simple: true, name: 'useAlternativePartNumber', value: 1, checked: useAlternative, onChange: onChange, disabled: !allowAlternatePartNumber }),
	            _react2.default.createElement(_text2.default, { placeholder: (0, _helpers.translation)(16446), name: 'SparePartNumberAlias', value: partNumberChange.SparePartNumberAlias, onChange: onChange, disabled: !allowAlternatePartNumber })
	          )
	        ),
	        useAlternative && totalCount > 1 && _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)(16441) },
	          _react2.default.createElement(_countSpecifier2.default, { disabled: !hasValidPartNumber, value: partNumberChange.Quantity, total: totalCount, name: 'Quantity', onChange: onChange })
	        ),
	        _react2.default.createElement(_divider2.default, null)
	      ), _react2.default.createElement(_bottomBar2.default, { disabled: useAlternative && !hasValidPartNumber && allowAlternatePartNumber, actionLabelText: (0, _helpers.translation)(791), cancelLabelText: (0, _helpers.translation)(1155), onCancelClick: onDone, onActionClick: submitSpareParts, key: 2 })];
	    }
	  }, {
	    key: 'renderSupplierDelivery',
	    value: function renderSupplierDelivery() {
	      var _this12 = this;
	
	      var _state3 = this.state,
	          spareParts = _state3.spareParts,
	          suppliers = _state3.suppliers,
	          _state3$supplierDeliv = _state3.supplierDeliveryChange,
	          supplierId = _state3$supplierDeliv.supplierId,
	          deliveryDate = _state3$supplierDeliv.deliveryDate,
	          deliveryTime = _state3$supplierDeliv.deliveryTime;
	
	      var sparePart = spareParts[0] || {};
	
	      var onDone = function onDone() {
	        _this12.changeView(_this12.props.view);
	      };
	
	      var onDateChange = function onDateChange(date) {
	        _this12.setState({
	          supplierDeliveryChange: _extends({}, _this12.state.supplierDeliveryChange, {
	            deliveryDate: date
	          })
	        });
	      };
	
	      var onChange = function onChange(e) {
	        var value = e.target.value;
	
	
	        _this12.setState({
	          supplierDeliveryChange: _extends({}, _this12.state.supplierDeliveryChange, {
	            deliveryTime: value
	          })
	        });
	      };
	
	      var onSaveChanges = function onSaveChanges() {
	        var newDate = _moment2.default.isMoment(deliveryDate) ? deliveryDate.clone() : '';
	
	        var hourMin = deliveryTime.split(':');
	        newDate.set({ hour: hourMin[0], minute: hourMin[1] || 0, second: 0, millisecond: 0 });
	
	        var supplier = suppliers.find(function (x) {
	          return x.Id === supplierId;
	        });
	
	        _this12.setState({
	          statusChange: _extends({}, _this12.state.statusChange, {
	            SupplierId: supplierId,
	            Pickup: supplier.PickupSelf,
	            Discount: supplier.Discount,
	            DeliveryDate: newDate.format('YYYY-MM-DD[T]HH:mm:ss')
	          })
	        }, function () {
	          return onDone();
	        });
	      };
	
	      var inputProps = {
	        name: 'date'
	      };
	
	      return [_react2.default.createElement(
	        'div',
	        { className: 'top', key: 0 },
	        _react2.default.createElement(_icon2.default, { className: 'clickable title-left', icon: _icons.SparePartModuleIcons.Back, onClick: onDone }),
	        _react2.default.createElement(
	          'h1',
	          { className: 'clickable title', onClick: onDone },
	          (0, _helpers.translation)('15370')
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'sub-title clickable' },
	          '' + (sparePart.SparePartNumberAlias || sparePart.OriginalSparePartNumber)
	        )
	      ), _react2.default.createElement(
	        'div',
	        { className: 'content supplierDelivery', key: 1 },
	        _react2.default.createElement(
	          _labelWrapper2.default,
	          { labelText: (0, _helpers.translation)('16520') },
	          _react2.default.createElement(
	            _grid2.default,
	            { cols: [2, 1] },
	            _react2.default.createElement(_datetime2.default, {
	              inputProps: inputProps,
	              timeFormat: false,
	              closeOnSelect: true,
	              value: deliveryDate,
	              onChange: onDateChange
	            }),
	            _react2.default.createElement(_time3.default, { name: 'time', value: deliveryTime, onChange: onChange })
	          )
	        )
	      ), _react2.default.createElement(_bottomBar2.default, { actionLabelText: (0, _helpers.translation)('14732'), onActionClick: onSaveChanges, key: 2 })];
	    }
	  }, {
	    key: 'renderSlidePanelContent',
	    value: function renderSlidePanelContent() {
	      switch (this.state.view) {
	        case 'add':
	          return this.renderAddSparepart();
	        case 'status':
	          return this.renderStatusChange('status');
	        case 'multiQuality':
	          return this.renderStatusChange('quality');
	        case 'listDetail':
	          return this.renderListDetail();
	        case 'partNumber':
	          return this.renderSparepartNumberChange();
	        case 'supplierDelivery':
	          return this.renderSupplierDelivery();
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _slidePanel2.default,
	        { slidePanelId: this.props.slidePanelId, isLoading: this.state.isLoading },
	        this.renderSlidePanelContent()
	      );
	    }
	  }]);
	
	  return OrderingSlidePanel;
	}(_react.Component);
	
	OrderingSlidePanel.propTypes = {
	  orderId: _react2.default.PropTypes.number.isRequired,
	  slidePanelId: _react2.default.PropTypes.string.isRequired,
	  view: _react2.default.PropTypes.string.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    spareParts: state.spareParts.sparePartsOrdering,
	    sparePartsFilter: state.spareParts.sparePartsFilterOrdering,
	    previousComments: state.spareParts.sparePartsCommentsOrdering,
	    headerInfo: state.common.headerInfo
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  createSparePart: _spareparts.createSparePart,
	  closeSlidePanel: _common.closeSlidePanel,
	  isSlidePanelOpen: _common.isSlidePanelOpen,
	  updateSparePartsOrdering: _spareparts.updateSparePartsOrdering,
	  getOrderingSparePartSuppliers: _spareparts.getOrderingSparePartSuppliers,
	  getOrderingSparePartDetails: _spareparts.getOrderingSparePartDetails,
	  uploadMultipleFiles: _orders.uploadMultipleFiles,
	  getOrderFiles: _orders.getOrderFiles,
	  getOrderFileSizes: _orderfiles.getOrderFileSizes
	})(OrderingSlidePanel);

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _helpers = __webpack_require__(2);
	
	var _time = __webpack_require__(17);
	
	var _currency = __webpack_require__(41);
	
	var _constants = __webpack_require__(5);
	
	var _detect = __webpack_require__(102);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableExpand = __webpack_require__(140);
	
	var _tableExpand2 = _interopRequireDefault(_tableExpand);
	
	var _tableHeader = __webpack_require__(132);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _arrowButton = __webpack_require__(200);
	
	var _arrowButton2 = _interopRequireDefault(_arrowButton);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _iconAccordion = __webpack_require__(201);
	
	var _iconAccordion2 = _interopRequireDefault(_iconAccordion);
	
	var _icons = __webpack_require__(6);
	
	var _overlayContent = __webpack_require__(177);
	
	var _overlayContent2 = _interopRequireDefault(_overlayContent);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _checkButton = __webpack_require__(449);
	
	var _checkButton2 = _interopRequireDefault(_checkButton);
	
	var _orderingSlidePanel = __webpack_require__(1133);
	
	var _orderingSlidePanel2 = _interopRequireDefault(_orderingSlidePanel);
	
	var _filterSlidePanel = __webpack_require__(477);
	
	var _filterSlidePanel2 = _interopRequireDefault(_filterSlidePanel);
	
	var _spareparts = __webpack_require__(108);
	
	var _common = __webpack_require__(25);
	
	__webpack_require__(1693);
	
	var _radio = __webpack_require__(28);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Elements
	
	
	// Actions
	
	
	var UsedInStepType = {
	  BodyShopRepair: 102,
	  BodyShopAssemply: 103
	};
	
	var Ordering = function (_Component) {
	  _inherits(Ordering, _Component);
	
	  function Ordering(props) {
	    _classCallCheck(this, Ordering);
	
	    var _this = _possibleConstructorReturn(this, (Ordering.__proto__ || Object.getPrototypeOf(Ordering)).call(this, props));
	
	    _this.state = {
	      spareParts: [],
	      sparePartComments: [],
	      groups: [],
	      slidePanelId: 'sparePartsOrdering',
	      selectedSpareParts: [],
	      rowClicked: false,
	      slidePanelView: '',
	      filterPanelView: '',
	
	      isLoading: false
	    };
	
	    _this.groupData = _this.groupData.bind(_this);
	    _this.resetSelected = _this.resetSelected.bind(_this);
	    _this.renderGroup = _this.renderGroup.bind(_this);
	    _this.onDone = _this.onDone.bind(_this);
	    _this.handleErrors = _this.handleErrors.bind(_this);
	    _this.isDracarMatch = _this.isDracarMatch.bind(_this);
	    _this.fromDracar = _this.fromDracar.bind(_this);
	    _this.usesDracar = _this.usesDracar.bind(_this);
	    _this.usesDracarCreation = _this.usesDracarCreation.bind(_this);
	    _this.openOverlay = _this.openOverlay.bind(_this);
	    _this.getKeyLoopSystemName = _this.getKeyLoopSystemName.bind(_this);
	    return _this;
	  }
	
	  _createClass(Ordering, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        isLoading: true
	      }, function () {
	        return _this2.props.getSparePartsOrdering(_extends({}, _this2.props.sparePartsFilter, { OrderId: _this2.props.orderId })).then(function (res) {
	          _this2.setState({ isLoading: false });
	          _this2.handleErrors(res);
	        });
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!(0, _lodash.isEqual)(this.props.spareParts, this.state.spareParts)) {
	        this.setState({
	          spareParts: this.props.spareParts
	        }, this.groupData);
	      }
	    }
	  }, {
	    key: 'openSlidePanel',
	    value: function openSlidePanel(type) {
	      var _this3 = this;
	
	      var newState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.setState(_extends({}, newState, {
	        slidePanelView: type
	      }), function () {
	        _this3.props.openSlidePanel(_this3.state.slidePanelId);
	      });
	    }
	  }, {
	    key: 'openOverlay',
	    value: function openOverlay() {
	      this.props.openOverlay('MatchingPartsOverlay');
	    }
	  }, {
	    key: 'resetSelected',
	    value: function resetSelected() {
	      this.setState({
	        selectedSpareParts: []
	      });
	    }
	  }, {
	    key: 'onDone',
	    value: function onDone(type, sparePartNumber) {
	      if (type === 'add') {
	        var selected = this.props.spareParts.filter(function (sp) {
	          return sparePartNumber === sp.OriginalSparePartNumber;
	        });
	        this.setState({
	          selectedSpareParts: selected,
	          rowClicked: true,
	          slidePanelView: 'status'
	        });
	        return;
	      }
	      this.resetSelected();
	    }
	  }, {
	    key: 'usesDracar',
	    value: function usesDracar() {
	      // We do not check if invoicing to Dracar is active, just that they are allowed and have it selected.
	      return this.props.auth.permissions.DracarUsable;
	    }
	  }, {
	    key: 'usesDracarCreation',
	    value: function usesDracarCreation() {
	      return this.props.auth.permissions.UseDracarSparePartCreation;
	    }
	  }, {
	    key: 'fromDracar',
	    value: function fromDracar(status) {
	      switch (status) {
	        case 1001:
	        case 2001:
	          return true;
	        default:
	          return false;
	      }
	    }
	  }, {
	    key: 'isDracarMatch',
	    value: function isDracarMatch(status) {
	      switch (status) {
	        case 2:
	        case 4:
	          return true;
	        default:
	          return false;
	      }
	    }
	  }, {
	    key: 'groupData',
	    value: function groupData() {
	      var _this4 = this;
	
	      var spareParts = this.state.spareParts;
	      var currentGroups = this.state.groups;
	      var hasGroups = currentGroups.length > 0;
	      var groupData = [];
	
	      if (this.usesDracar()) {
	        spareParts = spareParts.sort(function (a, b) {
	          var x = Number(a.Number);
	          var y = Number(b.Number);
	
	          if (x > y) return 1;
	          if (x < y) return -1;
	          return 0;
	        });
	
	        groupData.push({
	          title: 17870, // Added manually Non-matching
	          items: spareParts.filter(function (x) {
	            return !_this4.isDracarMatch(x.DracarStatus) && !_this4.fromDracar(x.DracarStatus) && Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport;
	          }),
	          expand: hasGroups ? currentGroups[0].expand : true
	        }, {
	          title: 17871, // Added manually matching
	          items: spareParts.filter(function (x) {
	            return _this4.isDracarMatch(x.DracarStatus) && !_this4.fromDracar(x.DracarStatus) && Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport;
	          }),
	          expand: hasGroups ? currentGroups[1].expand : true
	        }, {
	          title: 17872, // Non-matching
	          items: spareParts.filter(function (x) {
	            return !_this4.isDracarMatch(x.DracarStatus) && !_this4.fromDracar(x.DracarStatus) && Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport;
	          }),
	          expand: hasGroups ? currentGroups[2].expand : true
	        }, {
	          title: 16638, // From [KeyLoopSystem]
	          items: spareParts.filter(function (x) {
	            return x.DracarStatus !== 3 && _this4.fromDracar(x.DracarStatus) && !x.RemovedFromReport;
	          }),
	          expand: hasGroups ? currentGroups[3].expand : true
	        }, {
	          title: 17873, // Matching
	          items: spareParts.filter(function (x) {
	            return _this4.isDracarMatch(x.DracarStatus) && !_this4.fromDracar(x.DracarStatus) && Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport;
	          }),
	          expand: hasGroups ? currentGroups[4].expand : true
	        });
	      }
	
	      var groupNumber = this.usesDracar() ? 5 : 0;
	      groupData.push({
	        title: 16499, // Removed from report
	        items: spareParts.filter(function (x) {
	          return x.RemovedFromReport;
	        }),
	        expand: hasGroups ? currentGroups[groupNumber].expand : true
	      });
	      //   {
	      //     title: 16437,   // Added manually
	      //     items: spareParts.filter(x => Number(x.OrderSparePartId) === 0 && !this.fromDracar(x.DracarStatus) && !x.RemovedFromReport),
	      //     expand: hasGroups ? currentGroups[groupNumber + 1].expand : true
	      //   }
	      // )
	      // if (!this.usesDracar()) {
	      //   groupData.push(
	      //     {
	      //       title: 16438,   // From report
	      //       items: spareParts.filter(x => Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport),
	      //       expand: hasGroups ? currentGroups[groupNumber + 2].expand : true
	      //     }
	      //   )
	      // }
	
	      if (!this.usesDracar()) {
	        groupData.push({
	          title: 16437, // Added manually
	          items: spareParts.filter(function (x) {
	            return Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport;
	          }),
	          expand: hasGroups ? currentGroups[groupNumber + 1].expand : true
	        }, {
	          title: 16438, // From report
	          items: spareParts.filter(function (x) {
	            return Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport;
	          }),
	          expand: hasGroups ? currentGroups[groupNumber + 2].expand : true
	        });
	      }
	      // else {
	      //   groupData.push(
	      //     {
	      //       title: 16438,
	      //       items: spareParts.filter(x => Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport),
	      //       expand: hasGroups ? currentGroups[groupNumber + 1].expand : true
	      //     }
	      //   )
	      // }
	
	      this.setState({ groups: groupData });
	    }
	  }, {
	    key: 'getStatusIcons',
	    value: function getStatusIcons(row) {
	      var isHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var statusIcons = [{ icon: _icons.SparePartModuleIcons.Warning, noCircle: true }];
	      if (row.Handled === row.Count) {
	        statusIcons = [{ icon: _icons.SparePartModuleIcons.OK, noCircle: true }];
	      }
	
	      if (row.Pickup) {
	        statusIcons.push({ icon: _icons.SparePartModuleIcons.Pickup });
	      }
	      if (isHeader && row.RequiresPaint) {
	        statusIcons.push({ icon: _icons.SparePartModuleIcons.Coating });
	      }
	      if (isHeader && row.UrgentDelivery) {
	        statusIcons.push({ icon: _icons.SparePartModuleIcons.Urgent });
	      }
	      if (isHeader && row.UsedInStep) {
	        switch (row.UsedInStep) {
	          case UsedInStepType.BodyShopAssemply:
	            statusIcons.push({ icon: _icons.ProductionStatus.Step_BodyShopAssembly });
	            break;
	          case UsedInStepType.BodyShopRepair:
	            statusIcons.push({ icon: _icons.ProductionStatus.Step_BodyShopRepair });
	            break;
	        }
	      }
	
	      return statusIcons;
	    }
	  }, {
	    key: 'getStatusInfo',
	    value: function getStatusInfo(row) {
	      var statusIcons = this.getStatusIcons(row);
	
	      var getStatusText = function getStatusText() {
	        // Has multiple statuses
	        if ((row.Status & row.Status - 1) !== 0 || row.Suppliers.length > 1) {
	          return 16514;
	        }
	
	        switch (row.Status) {
	          case 2:
	            return 16449;
	          case 4:
	            return 14799;
	          case 8:
	            var name = '';
	            var relativeDateTime = '';
	            if (row.Suppliers.length > 0) {
	              var supplier = row.Suppliers[0];
	              name = supplier.Name;
	              relativeDateTime = (0, _time.getRelativeDateTime)(supplier.DeliveryDate);
	            }
	            return [_react2.default.createElement(
	              'div',
	              { key: 0 },
	              name
	            ), _react2.default.createElement(
	              'div',
	              { className: 'supplier__delivery', key: 1 },
	              relativeDateTime
	            )];
	          case 1:
	          default:
	            return 15392;
	        }
	      };
	
	      return _react2.default.createElement(
	        _grid2.default,
	        { cols: ['100px', 'auto'], align: 'center' },
	        _react2.default.createElement(_iconAccordion2.default, { icons: statusIcons }),
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          getStatusText()
	        )
	      );
	    }
	  }, {
	    key: 'handleErrors',
	    value: function handleErrors(err) {
	      if (err) {
	        if (err.data) {
	          if (err.data.Errors !== undefined && err.data.Errors !== null && Array.isArray(err.data.Errors) && err.data.Errors.length > 0) {
	            var errors = err.data.Errors;
	            var errText = '';
	            for (var i = 0; i < errors.length; i++) {
	              var dictKey = errors[i].DictionaryKey;
	              errText += '<br/>' + (0, _helpers.translation)(dictKey);
	            }
	            window.toastr.error((0, _helpers.translation)(errText), (0, _helpers.translation)('216'));
	          }
	        } else {
	          window.toastr.error(err, (0, _helpers.translation)('216'));
	        }
	      }
	    }
	  }, {
	    key: 'getKeyLoopSystemName',
	    value: function getKeyLoopSystemName() {
	      switch (this.props.auth.accountingSystem) {
	        case 4:
	          return (0, _helpers.translation)(15352);
	        case 6:
	          return (0, _helpers.translation)(18138);
	      }
	      return '';
	    }
	  }, {
	    key: 'renderGroup',
	    value: function renderGroup(group, index) {
	      var _this5 = this;
	
	      var items = group.items;
	      var headerCols = '6.8fr 6.2fr 6fr';
	      var cols = '1fr 1.5fr 4fr 1.5fr 2fr 5fr 2fr .5fr .5fr .5fr .5fr 32px';
	
	      if (this.usesDracar()) {
	        headerCols = '1fr 5.8fr 6.2fr 6fr';
	      }
	
	      if (items.length === 0) return null;
	
	      var isChecked = function isChecked(item) {
	        var isAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var isRow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (isAll) {
	          var validSpareParts = items.filter(function (x) {
	            return x.Handled < x.Count;
	          });
	          return validSpareParts.length > 0 && validSpareParts.every(function (v) {
	            return _this5.state.selectedSpareParts.includes(v);
	          }) && !_this5.state.rowClicked;
	        }
	        return _this5.state.selectedSpareParts.includes(item) && _this5.state.rowClicked === isRow;
	      };
	
	      var onCheckChange = function onCheckChange(e, item) {
	        if (item !== undefined) {
	          var temp = e;
	          e = item;
	          item = temp;
	        }
	        var _e$target = e.target,
	            name = _e$target.name,
	            checked = _e$target.checked;
	
	        var stateSpareParts = _this5.state.selectedSpareParts;
	        if (_this5.state.rowClicked) stateSpareParts = [];
	
	        if (name === 'all') {
	          stateSpareParts = stateSpareParts.filter(function (x) {
	            return !items.includes(x);
	          }); // Remove all from current group
	
	          if (checked) {
	            stateSpareParts = stateSpareParts.concat(items.filter(function (x) {
	              return x.Handled < x.Count;
	            })); // add all from curentgroup exept those where all have a status
	          }
	        } else if (name === 'sparePart') {
	          if (checked === true) {
	            stateSpareParts = [].concat(_toConsumableArray(stateSpareParts), [item]); // Array.push() doesn't work here
	          } else {
	            stateSpareParts = stateSpareParts.filter(function (pt) {
	              return pt !== item;
	            });
	          }
	        }
	        if (stateSpareParts.length === 0 || _this5.state.rowClicked) _this5.props.closeSlidePanel(_this5.state.slidePanelId);
	        _this5.setState({
	          selectedSpareParts: stateSpareParts,
	          rowClicked: false
	        });
	      };
	
	      var renderRow = function renderRow(row, index) {
	        var _onClick = function _onClick(type) {
	          if (!type) {
	            // if all are ordered or have same status, show status view
	            var multipleStatus = (row.Status & row.Status - 1) !== 0;
	            type = row.status === 8 || row.Count > 1 && multipleStatus ? 'listDetail' : 'status';
	          }
	
	          _this5.openSlidePanel(type, {
	            selectedSpareParts: [row],
	            rowClicked: true
	          });
	        };
	
	        var updateSparePart = function updateSparePart(e) {
	          var _sparePartsBody;
	
	          var _e$target2 = e.target,
	              name = _e$target2.name,
	              checked = _e$target2.checked,
	              value = _e$target2.value,
	              type = _e$target2.type;
	
	          var val = checked;
	          if (type === 'radio') {
	            name = name.substring(name.indexOf('.') + 1);
	            val = value;
	          }
	
	          var sparePartsBody = (_sparePartsBody = {
	            OrderId: _this5.props.orderId,
	            SpareParts: [row]
	          }, _defineProperty(_sparePartsBody, name, val), _defineProperty(_sparePartsBody, 'Filter', _this5.props.sparePartsFilter), _sparePartsBody);
	
	          _this5.props.updateSparePartsOrdering(sparePartsBody).then(function () {
	            // window.toastr.success(translation('16579'), translation('13424'))
	          });
	        };
	        var disabled = _this5.state.selectedSpareParts.length > 0;
	        var partNumber = row.SparePartNumberAlias || row.OriginalSparePartNumber;
	        var searchNumber = row.Number ? row.Number : '';
	        var partPrice = row.Price ? row.Price : 0.0;
	        var partCount = row.Handled + ' ' + (0, _helpers.translation)(16436) + ' ' + row.Count;
	        var itemPrice = _react2.default.createElement(
	          'span',
	          null,
	          (0, _currency.formatCurrency)(partPrice)
	        );
	
	        if (_this5.usesDracar()) {
	          partCount = row.Handled + '/' + row.Count;
	
	          if (_this5.fromDracar(row.DracarStatus)) {
	            partPrice = row.ListPrice;
	          }
	
	          itemPrice = _react2.default.createElement(
	            'div',
	            { className: 'amount' },
	            (0, _currency.formatCurrency)(partPrice),
	            _this5.isDracarMatch(row.DracarStatus) && row.ListPrice > 0 ? _react2.default.createElement(
	              'div',
	              { className: 'description__dracar__price' },
	              (0, _currency.formatCurrency)(row.ListPrice)
	            ) : null
	          );
	        }
	
	        var getQualityInfo = function getQualityInfo() {
	          var qualityInfo = '';
	          switch (row.QualityType) {
	            case 0:
	              qualityInfo = (0, _helpers.translation)(17850);
	              break;
	            case 1:
	              qualityInfo = (0, _helpers.translation)(17851);
	              break;
	            case 2:
	              qualityInfo = (0, _helpers.translation)(76);
	              var subQualityInfo = '';
	              switch (row.SubQualityType) {
	                case 1:
	                  subQualityInfo = ', ' + (0, _helpers.translation)(17852) + ')';
	                  break;
	                case 2:
	                  subQualityInfo = ', ' + (0, _helpers.translation)(17853) + ')';
	                  break;
	                case 3:
	                  subQualityInfo = ', ' + (0, _helpers.translation)(17854) + ')';
	                  break;
	              }
	              qualityInfo += subQualityInfo;
	              break;
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            qualityInfo
	          );
	        };
	
	        var uniqueId = index + '_' + row.InstanceId + '_' + row.OrderSparePartId;
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { key: index, cols: cols, onClick: function onClick() {
	              return _onClick();
	            }, selected: isChecked(row, false, true) },
	          _react2.default.createElement(_check2.default, { name: 'sparePart', value: partNumber, checked: isChecked(row), onChange: onCheckChange.bind(_this5, row), disabled: row.Handled === row.Count, simple: true }),
	          _react2.default.createElement(
	            'span',
	            null,
	            searchNumber
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              row.Description,
	              _react2.default.createElement(
	                'div',
	                { className: 'description__partnumber' },
	                partNumber
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            partCount
	          ),
	          itemPrice,
	          _this5.getStatusInfo(row),
	          getQualityInfo(),
	          _react2.default.createElement(_radio2.default, { name: uniqueId + '.UsedInStep', id: uniqueId + '.UsedInStepType.BodyShopRepair', value: UsedInStepType.BodyShopRepair, checked: row.UsedInStep === UsedInStepType.BodyShopRepair, onChange: updateSparePart }),
	          _react2.default.createElement(_radio2.default, { name: uniqueId + '.UsedInStep', id: uniqueId + '.UsedInStepType.BodyShopAssemply', value: UsedInStepType.BodyShopAssemply, checked: row.UsedInStep === UsedInStepType.BodyShopAssemply, onChange: updateSparePart }),
	          _react2.default.createElement(_check2.default, { name: 'RequiresPaint', value: partNumber, checked: row.RequiresPaint, onChange: updateSparePart, disabled: disabled, simple: true }),
	          _react2.default.createElement(_check2.default, { name: 'UrgentDelivery', value: partNumber, checked: row.UrgentDelivery, onChange: updateSparePart, disabled: disabled || (row.Status & 8) === 8, simple: true }),
	          row.Count > 1 ? _react2.default.createElement(_arrowButton2.default, { size: 'm', onClick: function onClick(e) {
	              e.stopPropagation();_onClick('listDetail');
	            } }) : _react2.default.createElement('div', null)
	        );
	      };
	
	      var totalSpareparts = items.reduce(function (a, b) {
	        return a + b.Count;
	      }, 0);
	      var totalHandledSpareparts = items.reduce(function (a, b) {
	        return a + b.Handled;
	      }, 0);
	      var totalStatus = items.reduce(function (status, part) {
	        status.Handled += part.Handled;
	        status.Count += part.Count;
	        status.Pickup |= part.Pickup;
	        status.RequiresPaint |= part.RequiresPaint;
	        status.UrgentDelivery |= part.UrgentDelivery;
	
	        return status;
	      }, { Handled: 0, Count: 0 });
	      var statusIcons = this.getStatusIcons(totalStatus, true);
	
	      var onClick = function onClick(expand) {
	        var groups = _this5.state.groups;
	        groups[index].expand = expand;
	
	        _this5.setState({
	          groups: groups
	        });
	      };
	
	      var getTableIcon = function getTableIcon(title) {
	        if (!_this5.usesDracar()) return null;
	        switch (title) {
	          case 16611:
	            return _react2.default.createElement(_icon2.default, { size: 'l', icon: _icons.SparePartModuleIcons.Warning, injectSvg: true });
	          case 16595:
	            return _react2.default.createElement(_icon2.default, { size: 'l', icon: _icons.SparePartModuleIcons.OK, injectSvg: true });
	          default:
	            return _react2.default.createElement('span', null);
	        }
	      };
	
	      var statusText = 13052;
	      var sparePartsAmountText = (0, _helpers.translation)(16439).replace('[count]', totalHandledSpareparts).replace('[total]', totalSpareparts);
	      if (this.usesDracar()) {
	        statusText = 16644;
	        sparePartsAmountText = totalSpareparts + ' ' + (0, _helpers.translation)(14853).toLowerCase();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: index },
	        _react2.default.createElement(
	          _tableContainer2.default /* key={index} */,
	          { fullWidth: true },
	          _react2.default.createElement(
	            _tableExpand2.default,
	            { expand: group.expand, onClick: onClick },
	            _react2.default.createElement(
	              _tableHeader2.default,
	              { cols: headerCols },
	              getTableIcon(group.title),
	              _react2.default.createElement(
	                'span',
	                { className: '' },
	                (0, _helpers.translation)(group.title).replace('[KeyLoopSystem]', this.getKeyLoopSystemName())
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                sparePartsAmountText
	              ),
	              !group.expand && _react2.default.createElement(_iconAccordion2.default, { icons: statusIcons }),
	              group.expand && _react2.default.createElement('span', null)
	            ),
	            _react2.default.createElement(
	              _tableRow2.default,
	              { header: true, cols: cols },
	              _react2.default.createElement(_check2.default, { name: 'all', checked: isChecked(null, true), onChange: onCheckChange, spacing: 0, disabled: totalHandledSpareparts === totalSpareparts, simple: true }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(906) + ' #'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(1021)
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(16441)
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: this.usesDracar() ? 'unitprice' : '' },
	                (0, _helpers.translation)(16642)
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(statusText)
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _helpers.translation)(17849)
	              ),
	              _react2.default.createElement(_icon2.default, { className: 'ordering__icon', icon: _icons.ProductionStatus.Step_BodyShopRepair, ariaText: (0, _helpers.translation)('18095'), ariaPos: 'top', injectSvg: true }),
	              _react2.default.createElement(_icon2.default, { className: 'ordering__icon', icon: _icons.ProductionStatus.Step_BodyShopAssembly, ariaText: (0, _helpers.translation)('18094'), ariaPos: 'top', injectSvg: true }),
	              _react2.default.createElement(_icon2.default, { className: 'ordering__icon', icon: _icons.SparePartModuleIcons.Coating, ariaText: (0, _helpers.translation)('14829'), ariaPos: 'top', injectSvg: true }),
	              _react2.default.createElement(_icon2.default, { className: 'ordering__icon', icon: _icons.SparePartModuleIcons.Urgent, ariaText: (0, _helpers.translation)('16578'), ariaPos: 'top', injectSvg: true }),
	              _react2.default.createElement('div', null)
	            ),
	            items.map(renderRow)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderActionHeader',
	    value: function renderActionHeader() {
	      var _this6 = this;
	
	      var groups = this.state.groups;
	
	      var showMatchingButton = false;
	      var cols = [1];
	
	      if (groups.length > 0) {
	        // console.log('Groups: ', groups)
	
	        if (this.usesDracar() && !this.usesDracarCreation()) {
	          showMatchingButton = (groups[0].items.length > 0 || groups[1].items.length > 0) && (groups[2].items.length > 0 || groups[4].items.length > 0);
	        } else if (this.usesDracar() && this.usesDracarCreation()) {
	          showMatchingButton = groups[2].items.length > 0 && groups[3].items.length > 0;
	        } else {
	          showMatchingButton = groups[1].items.length > 0 && groups[2].items.length > 0;
	          if (showMatchingButton) {
	            cols.push(1);
	          }
	        }
	      }
	
	      var actionButtons = _react2.default.createElement(
	        'div',
	        { className: 'action-buttons' },
	        _react2.default.createElement(
	          _grid2.default,
	          { cols: cols },
	          !this.usesDracarCreation() && _react2.default.createElement(
	            _button2.default,
	            { size: 's', spacing: 0, style: 'link', onClick: function onClick() {
	                return _this6.openSlidePanel('add');
	              } },
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_icon2.default, { size: this.props.size, icon: _icons.ButtonIcons.Add_Plus_16, injectSvg: true }),
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)(1208)
	              )
	            )
	          ),
	          showMatchingButton ? _react2.default.createElement(
	            _button2.default,
	            { size: 's', spacing: 0, style: 'link', onClick: this.openOverlay },
	            _react2.default.createElement(
	              _inline2.default,
	              { spacing: 0 },
	              _react2.default.createElement(_icon2.default, { size: this.props.size, icon: _icons.ButtonIcons.Add_Plus_16, injectSvg: true }),
	              _react2.default.createElement(
	                _label2.default,
	                null,
	                (0, _helpers.translation)(16588)
	              )
	            )
	          ) : null
	        )
	      );
	
	      var pageTitle = 16442;
	      if (this.usesDracar()) {
	        pageTitle = 16643;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'top renderActionHeader' },
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)(pageTitle)
	        ),
	        actionButtons
	      );
	    }
	  }, {
	    key: 'renderFilterActions',
	    value: function renderFilterActions() {
	      var _this7 = this;
	
	      var onClick = function onClick(e) {
	        _this7.setState({
	          filterPanelView: e.target.name
	        }, function () {
	          return _this7.props.openSlidePanel('sparePartsFilter');
	        });
	      };
	
	      return _react2.default.createElement(
	        _inline2.default,
	        { className: 'filter' },
	        _react2.default.createElement(
	          'div',
	          { className: 'filter__title' },
	          (0, _helpers.translation)('16659')
	        ),
	        _react2.default.createElement(_checkButton2.default, { name: 'supplier', onClick: onClick, checked: (this.props.sparePartsFilter.SelectedFilters & 2) === 2, labelText: (0, _helpers.translation)('16657'), size: 'm' }),
	        _react2.default.createElement(_checkButton2.default, { name: 'status', onClick: onClick, checked: (this.props.sparePartsFilter.SelectedFilters & 1) === 1, labelText: (0, _helpers.translation)('13052'), size: 'm' })
	      );
	    }
	  }, {
	    key: 'renderTableGroupsTitle',
	    value: function renderTableGroupsTitle() {
	      if (!this.usesDracar() || this.state.isLoading) return null;
	
	      // Icon needs to be medium. Hence why PanelHeader isn't used.
	      return _react2.default.createElement(
	        'div',
	        { className: 'groups__title' },
	        _react2.default.createElement(
	          'div',
	          { className: 'element-header' },
	          _react2.default.createElement(
	            _inline2.default,
	            { fillChildNum: [1], alignChildren: 'center', block: true },
	            _react2.default.createElement(_icon2.default, { size: 'm', icon: _icons.OrderTypeIcons.Insurance_Black }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              (0, _helpers.translation)(13360)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var hasSelectedSpareParts = this.state.selectedSpareParts.length > 1;
	      var filterOnClose = function filterOnClose() {
	        _this8.setState({
	          filterPanelView: ''
	        });
	      };
	
	      // custom ios, ipad style to show the bottombar
	      var iosCustomStyle = '';
	      var isiPadPro = (0, _detect.isTouchDevice)() && /MacIntel/.test(navigator.platform);
	      if (_constants.isiOS || isiPadPro) {
	        iosCustomStyle = 'customIosStyle';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ordering' },
	        _react2.default.createElement(
	          _overlayContent2.default,
	          null,
	          hasSelectedSpareParts && !this.props.isSlidePanelOpen(this.state.slidePanelId) && _react2.default.createElement(
	            _bottomBar2.default,
	            {
	              cancelLabelText: (0, _helpers.translation)(1155),
	              onCancelClick: this.resetSelected,
	              className: iosCustomStyle
	            },
	            _react2.default.createElement(_button2.default, {
	              style: 'secondary',
	              spacing: 0,
	              size: 'l',
	              onClick: function onClick() {
	                return _this8.openSlidePanel('multiQuality');
	              },
	              labelText: (0, _helpers.translation)(17849)
	            }),
	            _react2.default.createElement(_button2.default, {
	              style: 'secondary',
	              spacing: 0,
	              size: 'l',
	              onClick: function onClick() {
	                return _this8.openSlidePanel('status');
	              },
	              labelText: (0, _helpers.translation)(16448)
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            this.renderActionHeader(),
	            this.renderFilterActions(),
	            this.state.isLoading && _react2.default.createElement(
	              'div',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            ),
	            !this.state.isLoading && this.state.groups.map(this.renderGroup)
	          )
	        ),
	        _react2.default.createElement(_orderingSlidePanel2.default, {
	          orderId: this.props.orderId,
	          slidePanelId: this.state.slidePanelId,
	          view: this.state.slidePanelView,
	          selectedSpareParts: this.state.selectedSpareParts,
	          onDone: this.onDone,
	          isOpen: this.props.isSlidePanelOpen(this.state.slidePanelId)
	        }),
	        _react2.default.createElement(_filterSlidePanel2.default, {
	          type: 'ordering',
	          orderId: this.props.orderId,
	          view: this.state.filterPanelView,
	          filter: this.props.sparePartsFilter,
	          onClose: filterOnClose.bind(this)
	        })
	      );
	    }
	  }]);
	
	  return Ordering;
	}(_react.Component);
	
	Ordering.propTypes = {
	  orderId: _react2.default.PropTypes.number.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    spareParts: state.spareParts.sparePartsOrdering,
	    sparePartsFilter: state.spareParts.sparePartsFilterOrdering,
	    slidePanelsLength: state.common.slidePanels.length, // Necessary for the isSlidePanelOpen check to function
	    headerInfo: state.common.headerInfo // Contains information used to determine if the shop uses DRACAR
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getSparePartsOrdering: _spareparts.getSparePartsOrdering,
	  updateSparePartsOrdering: _spareparts.updateSparePartsOrdering,
	  closeSlidePanel: _common.closeSlidePanel,
	  openSlidePanel: _common.openSlidePanel,
	  isSlidePanelOpen: _common.isSlidePanelOpen,
	  openOverlay: _common.openOverlay
	})(Ordering);

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(27);
	
	var _time = __webpack_require__(17);
	
	var _helpers = __webpack_require__(2);
	
	var _spareparts = __webpack_require__(108);
	
	var _common = __webpack_require__(25);
	
	var _tableContainer = __webpack_require__(76);
	
	var _tableContainer2 = _interopRequireDefault(_tableContainer);
	
	var _tableExpand = __webpack_require__(140);
	
	var _tableExpand2 = _interopRequireDefault(_tableExpand);
	
	var _tableHeader = __webpack_require__(132);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableRow = __webpack_require__(55);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _check = __webpack_require__(19);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _arrowButton = __webpack_require__(200);
	
	var _arrowButton2 = _interopRequireDefault(_arrowButton);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _iconAccordion = __webpack_require__(201);
	
	var _iconAccordion2 = _interopRequireDefault(_iconAccordion);
	
	var _grid = __webpack_require__(15);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _label = __webpack_require__(24);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _icons = __webpack_require__(6);
	
	var _overlayContent = __webpack_require__(177);
	
	var _overlayContent2 = _interopRequireDefault(_overlayContent);
	
	var _bottomBar = __webpack_require__(82);
	
	var _bottomBar2 = _interopRequireDefault(_bottomBar);
	
	var _inline = __webpack_require__(16);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _checkButton = __webpack_require__(449);
	
	var _checkButton2 = _interopRequireDefault(_checkButton);
	
	var _ReceptionSlidePanel = __webpack_require__(1131);
	
	var _ReceptionSlidePanel2 = _interopRequireDefault(_ReceptionSlidePanel);
	
	var _filterSlidePanel = __webpack_require__(477);
	
	var _filterSlidePanel2 = _interopRequireDefault(_filterSlidePanel);
	
	__webpack_require__(1694);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Actions
	
	
	// Elements
	
	
	// Components
	
	
	var Receiving = function (_Component) {
	  _inherits(Receiving, _Component);
	
	  function Receiving(props) {
	    _classCallCheck(this, Receiving);
	
	    var _this = _possibleConstructorReturn(this, (Receiving.__proto__ || Object.getPrototypeOf(Receiving)).call(this, props));
	
	    _this.state = {
	      spareParts: [],
	      sparePartComments: [],
	      // groups: [],
	      selectedSpareParts: [],
	      rowClicked: false,
	      expand: {},
	      slidePanelView: '',
	      filterPanelView: '',
	
	      isLoading: false
	    };
	
	    _this.openSlidePanel = _this.openSlidePanel.bind(_this);
	    _this.resetSelected = _this.resetSelected.bind(_this);
	    // this.groupData = this.groupData.bind(this)
	    _this.getStatusIcons = _this.getStatusIcons.bind(_this);
	    _this.renderGroup = _this.renderGroup.bind(_this);
	    return _this;
	  }
	
	  _createClass(Receiving, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        isLoading: true
	      }, function () {
	        return _this2.props.getSparePartsReception(_extends({}, _this2.props.sparePartsFilter, { OrderId: _this2.props.orderId })).then(function () {
	          _this2.setState({
	            isLoading: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!(0, _lodash.isEqual)(this.props.spareParts, this.state.spareParts)) {
	        this.setState({
	          spareParts: this.props.spareParts
	        });
	      }
	    }
	  }, {
	    key: 'openSlidePanel',
	    value: function openSlidePanel(type) {
	      var _this3 = this;
	
	      var newState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.setState(_extends({}, newState, {
	        slidePanelView: type
	      }), function () {
	        return _this3.props.openSlidePanel('sparePartsReception');
	      });
	    }
	  }, {
	    key: 'resetSelected',
	    value: function resetSelected() {
	      this.setState({
	        selectedSpareParts: []
	      });
	    }
	  }, {
	    key: 'getGroupedSpareParts',
	    value: function getGroupedSpareParts() {
	      var spareParts = this.state.spareParts.reduce(function (grouped, part) {
	        var supplierName = part.Suppliers && part.Suppliers.length > 0 ? part.Suppliers[0].Name : '';
	
	        if (!grouped[supplierName]) {
	          grouped[supplierName] = [part];
	        } else {
	          grouped[supplierName] = [].concat(_toConsumableArray(grouped[supplierName]), [part]);
	        }
	
	        return grouped;
	      }, {});
	
	      return spareParts;
	    }
	  }, {
	    key: 'getStatusIcons',
	    value: function getStatusIcons(part) {
	      var statusIcons = [{ icon: _icons.SparePartModuleIcons.Warning, noCircle: true }];
	      if (part.Handled === part.Count) {
	        statusIcons = [{ icon: _icons.SparePartModuleIcons.OK, noCircle: true }];
	      }
	
	      // Defective part
	      if ((part.Status & 32) !== 0) {
	        statusIcons.push({ icon: _icons.SparePartModuleIcons.Defective });
	      }
	      // Incorrect part
	      if ((part.Status & 64) !== 0) {
	        statusIcons.push({ icon: _icons.SparePartModuleIcons.Incorrect });
	      }
	
	      return statusIcons;
	    }
	  }, {
	    key: 'getDeliveryTime',
	    value: function getDeliveryTime(part) {
	      var relativeDateTime = '';
	
	      if (part.Suppliers.length > 0) {
	        var supplier = part.Suppliers[0];
	        relativeDateTime = (0, _time.getRelativeDateTime)(supplier.DeliveryDate);
	      }
	
	      return _react2.default.createElement(
	        _label2.default,
	        null,
	        relativeDateTime
	      );
	    }
	  }, {
	    key: 'getStatusInfo',
	    value: function getStatusInfo(part) {
	      var statusIcons = this.getStatusIcons(part);
	
	      var getStatusText = function getStatusText() {
	        switch (part.Status) {
	          case 32:
	            return 16453;
	          case 64:
	            return 16454;
	          default:
	            return null;
	        }
	      };
	
	      return _react2.default.createElement(
	        _grid2.default,
	        { cols: ['100px', 'auto'] },
	        _react2.default.createElement(_iconAccordion2.default, { icons: statusIcons }),
	        _react2.default.createElement(
	          _label2.default,
	          null,
	          getStatusText()
	        )
	      );
	    }
	  }, {
	    key: 'renderGroup',
	    value: function renderGroup(group, index) {
	      var _this4 = this;
	
	      var title = group[0];
	      var items = group[1];
	      var headerCols = '5fr 6fr 8fr';
	      var cols = '1fr 2.5fr 3fr 2.5fr 2.5fr 3fr 3fr 2fr 32px';
	
	      var hasOrderedStatus = function hasOrderedStatus(status) {
	        return (status & 8) === 8;
	      };
	
	      var isChecked = function isChecked(part) {
	        var isAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var isRow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (isAll) {
	          var notHandledItems = items.filter(function (x) {
	            return hasOrderedStatus(x.Status);
	          });
	          var checked = notHandledItems.every(function (x) {
	            return _this4.state.selectedSpareParts.some(function (selected) {
	              return (0, _lodash.isEqual)(selected, x);
	            });
	          });
	          checked = checked && notHandledItems.length > 0;
	          checked = checked && !_this4.state.rowClicked;
	          return checked;
	        }
	
	        return _this4.state.selectedSpareParts.findIndex(function (selected) {
	          return (0, _lodash.isEqual)(selected, part);
	        }) > -1 && _this4.state.rowClicked === isRow;
	      };
	
	      var onCheckAll = function onCheckAll(e) {
	        var _e$target = e.target,
	            name = _e$target.name,
	            checked = _e$target.checked;
	
	
	        if (name === 'all') {
	          var updatedSpareParts = [].concat(_toConsumableArray(_this4.state.selectedSpareParts));
	          if (_this4.state.rowClicked) updatedSpareParts = [];
	
	          // Remove all from current group
	          updatedSpareParts = updatedSpareParts.filter(function (selected) {
	            return !(items.findIndex(function (part) {
	              return (0, _lodash.isEqual)(part, selected);
	            }) > -1);
	          });
	
	          if (checked === true) {
	            updatedSpareParts = [].concat(_toConsumableArray(updatedSpareParts), _toConsumableArray(items.filter(function (x) {
	              return hasOrderedStatus(x.Status);
	            })));
	          }
	
	          if (updatedSpareParts.length === 0) _this4.props.closeSlidePanel('sparePartsReception');
	          _this4.setState({
	            selectedSpareParts: updatedSpareParts,
	            rowClicked: false
	          });
	        }
	      };
	
	      var renderRow = function renderRow(row, index) {
	        var partNumber = row.SparePartNumberAlias || row.OriginalSparePartNumber;
	
	        var onCheckChange = function onCheckChange(e) {
	          var _e$target2 = e.target,
	              name = _e$target2.name,
	              checked = _e$target2.checked;
	
	
	          if (name === 'sparePart') {
	            var updatedSpareParts = [].concat(_toConsumableArray(_this4.state.selectedSpareParts));
	            if (_this4.state.rowClicked) updatedSpareParts = [];
	
	            if (checked === true) {
	              updatedSpareParts = [].concat(_toConsumableArray(updatedSpareParts), [row]);
	            } else {
	              updatedSpareParts = updatedSpareParts.filter(function (pt) {
	                return !(0, _lodash.isEqual)(pt, row);
	              });
	            }
	
	            if (updatedSpareParts.length === 0 || _this4.state.rowClicked) _this4.props.closeSlidePanel('sparePartsReception');
	            _this4.setState({
	              selectedSpareParts: updatedSpareParts,
	              rowClicked: false
	            });
	          }
	        };
	
	        var onRowClick = function onRowClick(type) {
	          if (!type) {
	            var hasOnlyOneStatus = (row.Status & row.Status - 1) === 0;
	            // if all has a status show list view
	            type = /* row.Handled !== row.Count || */hasOnlyOneStatus || hasOrderedStatus ? 'status' : 'listDetail';
	          }
	
	          _this4.openSlidePanel(type, {
	            selectedSpareParts: [row],
	            rowClicked: true
	          });
	        };
	
	        var receiveSparePart = function receiveSparePart(e) {
	          e.stopPropagation();
	
	          var sparePartsBody = {
	            OrderId: _this4.props.orderId,
	            SpareParts: [row],
	            Status: 16, // Received
	            Filter: _this4.props.sparePartsFilter
	          };
	
	          _this4.props.updateSparePartsReception(sparePartsBody);
	        };
	
	        var getQualityInfo = function getQualityInfo() {
	          var qualityInfo = '';
	          switch (row.QualityType) {
	            case 0:
	              qualityInfo = (0, _helpers.translation)(17850);
	              break;
	            case 1:
	              qualityInfo = (0, _helpers.translation)(17851);
	              break;
	            case 2:
	              qualityInfo = (0, _helpers.translation)(76);
	              var subQualityInfo = '';
	              switch (row.SubQualityType) {
	                case 1:
	                  subQualityInfo = ', ' + (0, _helpers.translation)(17852) + ')';
	                  break;
	                case 2:
	                  subQualityInfo = ', ' + (0, _helpers.translation)(17853) + ')';
	                  break;
	                case 3:
	                  subQualityInfo = ', ' + (0, _helpers.translation)(17854) + ')';
	                  break;
	              }
	              qualityInfo += subQualityInfo;
	              break;
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            qualityInfo
	          );
	        };
	
	        // const disabled = !hasOrderedStatus(row.Status)
	        var isReceived = row.Status === 16;
	        return _react2.default.createElement(
	          _tableRow2.default,
	          { key: index, cols: cols, onClick: function onClick() {
	              return onRowClick();
	            }, selected: isChecked(row, false, true) },
	          _react2.default.createElement(_check2.default, { name: 'sparePart', value: row, checked: isChecked(row), onChange: onCheckChange /* disabled={disabled} */, simple: true }),
	          _react2.default.createElement(
	            'span',
	            null,
	            partNumber
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            row.Description || ''
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            row.Handled + ' ' + (0, _helpers.translation)(16436) + ' ' + row.Count
	          ),
	          _this4.getStatusInfo(row),
	          _this4.getDeliveryTime(row),
	          getQualityInfo(),
	          !isReceived && _react2.default.createElement(_button2.default, { onClick: receiveSparePart, style: 'link', size: 'm', labelText: (0, _helpers.translation)(16452) }),
	          row.Count > 1 ? _react2.default.createElement(_arrowButton2.default, { size: 'm', onClick: function onClick(e) {
	              e.stopPropagation();onRowClick('listDetail');
	            } }) : ''
	        );
	      };
	
	      // const totalSpareParts = items.reduce((a, b) => a + b.Count, 0)
	      // const totalHandledSpareParts = items.reduce((a, b) => a + b.Handled, 0)
	      var totalStatus = items.reduce(function (status, part) {
	        status.Handled += part.Handled;
	        status.Count += part.Count;
	
	        // if (part.Pickup) {
	        //   status.Pickup = true
	        // }
	        // if (part.RequirePaint) {
	        //   status.RequirePaint = true
	        // }
	        status.Status |= part.Status;
	
	        return status;
	      }, { Handled: 0, Count: 0 });
	
	      var statusIcons = this.getStatusIcons(totalStatus);
	      var totalText = (0, _helpers.translation)(16439).replace('[count]', totalStatus.Handled).replace('[total]', totalStatus.Count);
	      var expand = this.state.expand[title] === true || typeof this.state.expand[title] === 'undefined';
	
	      var onClick = function onClick(expand) {
	        _this4.setState({
	          expand: _extends({}, _this4.state.expand, _defineProperty({}, title, expand))
	        });
	      };
	
	      return _react2.default.createElement(
	        _tableContainer2.default,
	        { key: index, fullWidth: true },
	        _react2.default.createElement(
	          _tableExpand2.default,
	          { expand: expand, onClick: onClick },
	          _react2.default.createElement(
	            _tableHeader2.default,
	            { cols: headerCols },
	            _react2.default.createElement(
	              'span',
	              null,
	              title
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              totalText
	            ),
	            !expand && _react2.default.createElement(_iconAccordion2.default, { icons: statusIcons }),
	            expand && _react2.default.createElement('span', null)
	          ),
	          _react2.default.createElement(
	            _tableRow2.default,
	            { header: true, cols: cols },
	            _react2.default.createElement(_check2.default, { name: 'all', checked: isChecked(null, true), onChange: onCheckAll, spacing: 0, simple: true }),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16440)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(1021)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(16441)
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(13052)
	            ),
	            _react2.default.createElement('span', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _helpers.translation)(17849)
	            ),
	            _react2.default.createElement('div', null),
	            _react2.default.createElement('div', null)
	          ),
	          items.map(renderRow)
	        )
	      );
	    }
	  }, {
	    key: 'renderActionHeader',
	    value: function renderActionHeader() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'top renderActionHeader' },
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _helpers.translation)(16580)
	        )
	      );
	    }
	  }, {
	    key: 'renderFilterActions',
	    value: function renderFilterActions() {
	      var _this5 = this;
	
	      var onClick = function onClick(e) {
	        _this5.setState({
	          filterPanelView: e.target.name
	        }, function () {
	          return _this5.props.openSlidePanel('sparePartsFilter');
	        });
	      };
	
	      return _react2.default.createElement(
	        _inline2.default,
	        { className: 'filter' },
	        _react2.default.createElement(
	          'div',
	          { className: 'filter__title' },
	          (0, _helpers.translation)('16659')
	        ),
	        _react2.default.createElement(_checkButton2.default, { name: 'supplier', onClick: onClick, checked: (this.props.sparePartsFilter.SelectedFilters & 2) === 2, labelText: (0, _helpers.translation)('16657'), size: 'm' }),
	        _react2.default.createElement(_checkButton2.default, { name: 'status', onClick: onClick, checked: (this.props.sparePartsFilter.SelectedFilters & 1) === 1, labelText: (0, _helpers.translation)('13052'), size: 'm' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var hasSelectedSpareParts = this.state.selectedSpareParts.length > 1;
	
	      var groupedSpareParts = Object.entries(this.getGroupedSpareParts());
	      return _react2.default.createElement(
	        'div',
	        { className: 'receiving' },
	        _react2.default.createElement(
	          _overlayContent2.default,
	          null,
	          hasSelectedSpareParts && !this.props.isSlidePanelOpen('sparePartsReception') && _react2.default.createElement(_bottomBar2.default, {
	            actionLabelText: (0, _helpers.translation)(16448),
	            onActionClick: function onActionClick() {
	              return _this6.openSlidePanel('status');
	            },
	            cancelLabelText: (0, _helpers.translation)(1155),
	            onCancelClick: this.resetSelected,
	            center: true
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            this.renderActionHeader(),
	            this.renderFilterActions(),
	            this.state.isLoading && _react2.default.createElement(
	              'div',
	              { className: 'animated-background' },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                (0, _helpers.translation)('13382'),
	                '...'
	              )
	            ),
	            !this.state.isLoading && groupedSpareParts.map(this.renderGroup)
	          )
	        ),
	        _react2.default.createElement(_ReceptionSlidePanel2.default, {
	          orderId: this.props.orderId,
	          spareParts: this.state.selectedSpareParts,
	          view: this.state.slidePanelView,
	          onDone: this.resetSelected
	        }),
	        _react2.default.createElement(_filterSlidePanel2.default, {
	          type: 'reception',
	          orderId: this.props.orderId,
	          view: this.state.filterPanelView,
	          filter: this.props.sparePartsFilter
	        })
	      );
	    }
	  }]);
	
	  return Receiving;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    spareParts: state.spareParts.sparePartsReception,
	    sparePartsFilter: state.spareParts.sparePartsFilterReception,
	    slidePanelsLength: state.common.slidePanels.length // Necessary for the isSlidePanelOpen check to function
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getSparePartsReception: _spareparts.getSparePartsReception,
	  updateSparePartsReception: _spareparts.updateSparePartsReception,
	  closeSlidePanel: _common.closeSlidePanel,
	  openSlidePanel: _common.openSlidePanel,
	  isSlidePanelOpen: _common.isSlidePanelOpen
	})(Receiving);

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = function (ComposedComponent) {
	  var Authenticate = function (_Component) {
	    _inherits(Authenticate, _Component);
	
	    function Authenticate() {
	      _classCallCheck(this, Authenticate);
	
	      return _possibleConstructorReturn(this, (Authenticate.__proto__ || Object.getPrototypeOf(Authenticate)).apply(this, arguments));
	    }
	
	    _createClass(Authenticate, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (!this.props.isAuthenticated) {
	          this.props.router.push('/login');
	        } else {
	          // Get auth resources
	          if (Object.keys(this.props.auth.permissions).length === 0) {
	            this.props.getAuthResources();
	          }
	        }
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps) {
	        var _this2 = this;
	
	        if (!nextProps.isAuthenticated) {
	          this.props.router.push('/login');
	        } else {
	          setTimeout(function () {
	            // Get auth resources
	            if (Object.keys(_this2.props.auth.permissions).length === 0) {
	              _this2.props.getAuthResources();
	            }
	          }, 1000);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ComposedComponent, this.props);
	      }
	    }]);
	
	    return Authenticate;
	  }(_react.Component);
	
	  Authenticate.propTypes = {
	    isAuthenticated: _propTypes2.default.bool.isRequired,
	    getAuthResources: _propTypes2.default.func.isRequired
	  };
	
	  function mapStateToProps(state) {
	    return {
	      auth: state.auth,
	      isAuthenticated: state.auth.isAuthenticated
	    };
	  }
	
	  return (0, _reactRedux.connect)(mapStateToProps, {
	    getAuthResources: _auth.getAuthResources
	  })(Authenticate);
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _auth = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Actions

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1337);
	
	__webpack_require__(1338);
	
	__webpack_require__(1138);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1145);
	module.exports = __webpack_require__(118).RegExp.escape;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	var isArray = __webpack_require__(243);
	var SPECIES = __webpack_require__(56)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(47);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(122);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(159);
	var gOPS = __webpack_require__(247);
	var pIE = __webpack_require__(209);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(10);
	var $re = __webpack_require__(1143)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(10);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(479) });
	
	__webpack_require__(141)('copyWithin');


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $every = __webpack_require__(117)(4);
	
	$export($export.P + $export.F * !__webpack_require__(111)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(10);
	
	$export($export.P, 'Array', { fill: __webpack_require__(310) });
	
	__webpack_require__(141)('fill');


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $filter = __webpack_require__(117)(2);
	
	$export($export.P + $export.F * !__webpack_require__(111)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(10);
	var $find = __webpack_require__(117)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(141)(KEY);


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(10);
	var $find = __webpack_require__(117)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(141)(KEY);


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $forEach = __webpack_require__(117)(0);
	var STRICT = __webpack_require__(111)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(110);
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(80);
	var call = __webpack_require__(490);
	var isArrayIter = __webpack_require__(318);
	var toLength = __webpack_require__(72);
	var createProperty = __webpack_require__(312);
	var getIterFn = __webpack_require__(334);
	
	$export($export.S + $export.F * !__webpack_require__(245)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $indexOf = __webpack_require__(239)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(111)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(243) });


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(10);
	var toIObject = __webpack_require__(105);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(208) != Object || !__webpack_require__(111)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toIObject = __webpack_require__(105);
	var toInteger = __webpack_require__(121);
	var toLength = __webpack_require__(72);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(111)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $map = __webpack_require__(117)(1);
	
	$export($export.P + $export.F * !__webpack_require__(111)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var createProperty = __webpack_require__(312);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(47)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $reduce = __webpack_require__(481);
	
	$export($export.P + $export.F * !__webpack_require__(111)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $reduce = __webpack_require__(481);
	
	$export($export.P + $export.F * !__webpack_require__(111)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var html = __webpack_require__(316);
	var cof = __webpack_require__(109);
	var toAbsoluteIndex = __webpack_require__(163);
	var toLength = __webpack_require__(72);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(47)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $some = __webpack_require__(117)(3);
	
	$export($export.P + $export.F * !__webpack_require__(111)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var aFunction = __webpack_require__(88);
	var toObject = __webpack_require__(80);
	var fails = __webpack_require__(47);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(111)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(162)('Array');


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(10);
	var toISOString = __webpack_require__(1140);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(80);
	var toPrimitive = __webpack_require__(122);
	
	$export($export.P + $export.F * __webpack_require__(47)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(56)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(97)(proto, TO_PRIMITIVE, __webpack_require__(1141));


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(98)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(10);
	
	$export($export.P, 'Function', { bind: __webpack_require__(482) });


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(49);
	var getPrototypeOf = __webpack_require__(104);
	var HAS_INSTANCE = __webpack_require__(56)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(71).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(71).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(70) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(10);
	var log1p = __webpack_require__(493);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(10);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(10);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(10);
	var sign = __webpack_require__(322);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(10);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(10);
	var $expm1 = __webpack_require__(321);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { fround: __webpack_require__(492) });


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(10);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(10);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(47)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(493) });


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { sign: __webpack_require__(322) });


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(10);
	var expm1 = __webpack_require__(321);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(47)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(10);
	var expm1 = __webpack_require__(321);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(44);
	var has = __webpack_require__(96);
	var cof = __webpack_require__(109);
	var inheritIfRequired = __webpack_require__(317);
	var toPrimitive = __webpack_require__(122);
	var fails = __webpack_require__(47);
	var gOPN = __webpack_require__(158).f;
	var gOPD = __webpack_require__(103).f;
	var dP = __webpack_require__(71).f;
	var $trim = __webpack_require__(181).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(157)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(70) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(98)(global, NUMBER, $Number);
	}


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(10);
	var _isFinite = __webpack_require__(44).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(489) });


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(10);
	var isInteger = __webpack_require__(489);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $parseFloat = __webpack_require__(501);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $parseInt = __webpack_require__(502);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toInteger = __webpack_require__(121);
	var aNumberValue = __webpack_require__(478);
	var repeat = __webpack_require__(329);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(47)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $fails = __webpack_require__(47);
	var aNumberValue = __webpack_require__(478);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(10);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(495) });


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(157) });


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(70), 'Object', { defineProperties: __webpack_require__(496) });


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(70), 'Object', { defineProperty: __webpack_require__(71).f });


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(49);
	var meta = __webpack_require__(142).onFreeze;
	
	__webpack_require__(120)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(105);
	var $getOwnPropertyDescriptor = __webpack_require__(103).f;
	
	__webpack_require__(120)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(120)('getOwnPropertyNames', function () {
	  return __webpack_require__(497).f;
	});


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(80);
	var $getPrototypeOf = __webpack_require__(104);
	
	__webpack_require__(120)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(49);
	
	__webpack_require__(120)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(49);
	
	__webpack_require__(120)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(49);
	
	__webpack_require__(120)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(10);
	$export($export.S, 'Object', { is: __webpack_require__(1144) });


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(80);
	var $keys = __webpack_require__(159);
	
	__webpack_require__(120)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(49);
	var meta = __webpack_require__(142).onFreeze;
	
	__webpack_require__(120)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(49);
	var meta = __webpack_require__(142).onFreeze;
	
	__webpack_require__(120)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(10);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(325).set });


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(207);
	var test = {};
	test[__webpack_require__(56)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(98)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $parseFloat = __webpack_require__(501);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $parseInt = __webpack_require__(502);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(156);
	var global = __webpack_require__(44);
	var ctx = __webpack_require__(110);
	var classof = __webpack_require__(207);
	var $export = __webpack_require__(10);
	var isObject = __webpack_require__(49);
	var aFunction = __webpack_require__(88);
	var anInstance = __webpack_require__(154);
	var forOf = __webpack_require__(155);
	var speciesConstructor = __webpack_require__(251);
	var task = __webpack_require__(331).set;
	var microtask = __webpack_require__(323)();
	var newPromiseCapabilityModule = __webpack_require__(324);
	var perform = __webpack_require__(503);
	var promiseResolve = __webpack_require__(504);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(56)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  if (promise._h == 1) return false;
	  var chain = promise._a || promise._c;
	  var i = 0;
	  var reaction;
	  while (chain.length > i) {
	    reaction = chain[i++];
	    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	  } return true;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(161)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(180)($Promise, PROMISE);
	__webpack_require__(162)(PROMISE);
	Wrapper = __webpack_require__(118)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(245)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(10);
	var aFunction = __webpack_require__(88);
	var anObject = __webpack_require__(39);
	var rApply = (__webpack_require__(44).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(47)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(10);
	var create = __webpack_require__(157);
	var aFunction = __webpack_require__(88);
	var anObject = __webpack_require__(39);
	var isObject = __webpack_require__(49);
	var fails = __webpack_require__(47);
	var bind = __webpack_require__(482);
	var rConstruct = (__webpack_require__(44).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(71);
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(122);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(47)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(10);
	var gOPD = __webpack_require__(103).f;
	var anObject = __webpack_require__(39);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(39);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(319)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(103);
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(39);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(10);
	var getProto = __webpack_require__(104);
	var anObject = __webpack_require__(39);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(103);
	var getPrototypeOf = __webpack_require__(104);
	var has = __webpack_require__(96);
	var $export = __webpack_require__(10);
	var isObject = __webpack_require__(49);
	var anObject = __webpack_require__(39);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(39);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(500) });


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(39);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(10);
	var setProto = __webpack_require__(325);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(71);
	var gOPD = __webpack_require__(103);
	var getPrototypeOf = __webpack_require__(104);
	var has = __webpack_require__(96);
	var $export = __webpack_require__(10);
	var createDesc = __webpack_require__(160);
	var anObject = __webpack_require__(39);
	var isObject = __webpack_require__(49);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(44);
	var inheritIfRequired = __webpack_require__(317);
	var dP = __webpack_require__(71).f;
	var gOPN = __webpack_require__(158).f;
	var isRegExp = __webpack_require__(244);
	var $flags = __webpack_require__(242);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(70) && (!CORRECT_NEW || __webpack_require__(47)(function () {
	  re2[__webpack_require__(56)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(98)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(162)('RegExp');


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(241)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(241)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(241)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(241)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(244);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(509);
	var anObject = __webpack_require__(39);
	var $flags = __webpack_require__(242);
	var DESCRIPTORS = __webpack_require__(70);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(98)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(47)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(99)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(99)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(99)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(99)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $at = __webpack_require__(327)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(10);
	var toLength = __webpack_require__(72);
	var context = __webpack_require__(328);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(315)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(99)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(99)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(99)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var toAbsoluteIndex = __webpack_require__(163);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(10);
	var context = __webpack_require__(328);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(315)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(99)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(327)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(320)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(99)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var toIObject = __webpack_require__(105);
	var toLength = __webpack_require__(72);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(329)
	});


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(99)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(10);
	var toLength = __webpack_require__(72);
	var context = __webpack_require__(328);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(315)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(99)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(99)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(99)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(181)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(44);
	var has = __webpack_require__(96);
	var DESCRIPTORS = __webpack_require__(70);
	var $export = __webpack_require__(10);
	var redefine = __webpack_require__(98);
	var META = __webpack_require__(142).KEY;
	var $fails = __webpack_require__(47);
	var shared = __webpack_require__(250);
	var setToStringTag = __webpack_require__(180);
	var uid = __webpack_require__(164);
	var wks = __webpack_require__(56);
	var wksExt = __webpack_require__(507);
	var wksDefine = __webpack_require__(333);
	var enumKeys = __webpack_require__(1142);
	var isArray = __webpack_require__(243);
	var anObject = __webpack_require__(39);
	var toIObject = __webpack_require__(105);
	var toPrimitive = __webpack_require__(122);
	var createDesc = __webpack_require__(160);
	var _create = __webpack_require__(157);
	var gOPNExt = __webpack_require__(497);
	var $GOPD = __webpack_require__(103);
	var $DP = __webpack_require__(71);
	var $keys = __webpack_require__(159);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(158).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(209).f = $propertyIsEnumerable;
	  __webpack_require__(247).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(156)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(97)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $typed = __webpack_require__(252);
	var buffer = __webpack_require__(332);
	var anObject = __webpack_require__(39);
	var toAbsoluteIndex = __webpack_require__(163);
	var toLength = __webpack_require__(72);
	var isObject = __webpack_require__(49);
	var ArrayBuffer = __webpack_require__(44).ArrayBuffer;
	var speciesConstructor = __webpack_require__(251);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(47)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(162)(ARRAY_BUFFER);


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	$export($export.G + $export.W + $export.F * !__webpack_require__(252).ABV, {
	  DataView: __webpack_require__(332).DataView
	});


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(485);
	var validate = __webpack_require__(182);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(240)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(10);
	var flattenIntoArray = __webpack_require__(486);
	var toObject = __webpack_require__(80);
	var toLength = __webpack_require__(72);
	var aFunction = __webpack_require__(88);
	var arraySpeciesCreate = __webpack_require__(311);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(141)('flatMap');


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(10);
	var flattenIntoArray = __webpack_require__(486);
	var toObject = __webpack_require__(80);
	var toLength = __webpack_require__(72);
	var toInteger = __webpack_require__(121);
	var arraySpeciesCreate = __webpack_require__(311);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(141)('flatten');


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(10);
	var $includes = __webpack_require__(239)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(141)('includes');


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(10);
	var microtask = __webpack_require__(323)();
	var process = __webpack_require__(44).process;
	var isNode = __webpack_require__(109)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(10);
	var cof = __webpack_require__(109);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(10);
	
	$export($export.G, { global: __webpack_require__(44) });


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(248)('Map');


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(249)('Map');


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(10);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(484)('Map') });


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	var scale = __webpack_require__(494);
	var fround = __webpack_require__(492);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { scale: __webpack_require__(494) });


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(80);
	var aFunction = __webpack_require__(88);
	var $defineProperty = __webpack_require__(71);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(70) && $export($export.P + __webpack_require__(246), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(80);
	var aFunction = __webpack_require__(88);
	var $defineProperty = __webpack_require__(71);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(70) && $export($export.P + __webpack_require__(246), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(10);
	var $entries = __webpack_require__(499)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(10);
	var ownKeys = __webpack_require__(500);
	var toIObject = __webpack_require__(105);
	var gOPD = __webpack_require__(103);
	var createProperty = __webpack_require__(312);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(80);
	var toPrimitive = __webpack_require__(122);
	var getPrototypeOf = __webpack_require__(104);
	var getOwnPropertyDescriptor = __webpack_require__(103).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(70) && $export($export.P + __webpack_require__(246), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(80);
	var toPrimitive = __webpack_require__(122);
	var getPrototypeOf = __webpack_require__(104);
	var getOwnPropertyDescriptor = __webpack_require__(103).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(70) && $export($export.P + __webpack_require__(246), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(10);
	var $values = __webpack_require__(499)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(10);
	var global = __webpack_require__(44);
	var core = __webpack_require__(118);
	var microtask = __webpack_require__(323)();
	var OBSERVABLE = __webpack_require__(56)('observable');
	var aFunction = __webpack_require__(88);
	var anObject = __webpack_require__(39);
	var anInstance = __webpack_require__(154);
	var redefineAll = __webpack_require__(161);
	var hide = __webpack_require__(97);
	var forOf = __webpack_require__(155);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(162)('Observable');


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(10);
	var core = __webpack_require__(118);
	var global = __webpack_require__(44);
	var speciesConstructor = __webpack_require__(251);
	var promiseResolve = __webpack_require__(504);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(10);
	var newPromiseCapability = __webpack_require__(324);
	var perform = __webpack_require__(503);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(133);
	var anObject = __webpack_require__(39);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(133);
	var anObject = __webpack_require__(39);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(510);
	var from = __webpack_require__(480);
	var metadata = __webpack_require__(133);
	var anObject = __webpack_require__(39);
	var getPrototypeOf = __webpack_require__(104);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(133);
	var anObject = __webpack_require__(39);
	var getPrototypeOf = __webpack_require__(104);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(133);
	var anObject = __webpack_require__(39);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(133);
	var anObject = __webpack_require__(39);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(133);
	var anObject = __webpack_require__(39);
	var getPrototypeOf = __webpack_require__(104);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(133);
	var anObject = __webpack_require__(39);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(133);
	var anObject = __webpack_require__(39);
	var aFunction = __webpack_require__(88);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(248)('Set');


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(249)('Set');


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(10);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(484)('Set') });


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(10);
	var $at = __webpack_require__(327)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(10);
	var defined = __webpack_require__(119);
	var toLength = __webpack_require__(72);
	var isRegExp = __webpack_require__(244);
	var getFlags = __webpack_require__(242);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(319)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(10);
	var $pad = __webpack_require__(505);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(10);
	var $pad = __webpack_require__(505);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(181)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(181)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(333)('asyncIterator');


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(333)('observable');


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(10);
	
	$export($export.S, 'System', { global: __webpack_require__(44) });


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(248)('WeakMap');


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(249)('WeakMap');


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(248)('WeakSet');


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(249)('WeakSet');


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(335);
	var getKeys = __webpack_require__(159);
	var redefine = __webpack_require__(98);
	var global = __webpack_require__(44);
	var hide = __webpack_require__(97);
	var Iterators = __webpack_require__(179);
	var wks = __webpack_require__(56);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $task = __webpack_require__(331);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(44);
	var $export = __webpack_require__(10);
	var navigator = global.navigator;
	var slice = [].slice;
	var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1265);
	__webpack_require__(1204);
	__webpack_require__(1206);
	__webpack_require__(1205);
	__webpack_require__(1208);
	__webpack_require__(1210);
	__webpack_require__(1215);
	__webpack_require__(1209);
	__webpack_require__(1207);
	__webpack_require__(1217);
	__webpack_require__(1216);
	__webpack_require__(1212);
	__webpack_require__(1213);
	__webpack_require__(1211);
	__webpack_require__(1203);
	__webpack_require__(1214);
	__webpack_require__(1218);
	__webpack_require__(1219);
	__webpack_require__(1171);
	__webpack_require__(1173);
	__webpack_require__(1172);
	__webpack_require__(1221);
	__webpack_require__(1220);
	__webpack_require__(1191);
	__webpack_require__(1201);
	__webpack_require__(1202);
	__webpack_require__(1192);
	__webpack_require__(1193);
	__webpack_require__(1194);
	__webpack_require__(1195);
	__webpack_require__(1196);
	__webpack_require__(1197);
	__webpack_require__(1198);
	__webpack_require__(1199);
	__webpack_require__(1200);
	__webpack_require__(1174);
	__webpack_require__(1175);
	__webpack_require__(1176);
	__webpack_require__(1177);
	__webpack_require__(1178);
	__webpack_require__(1179);
	__webpack_require__(1180);
	__webpack_require__(1181);
	__webpack_require__(1182);
	__webpack_require__(1183);
	__webpack_require__(1184);
	__webpack_require__(1185);
	__webpack_require__(1186);
	__webpack_require__(1187);
	__webpack_require__(1188);
	__webpack_require__(1189);
	__webpack_require__(1190);
	__webpack_require__(1252);
	__webpack_require__(1257);
	__webpack_require__(1264);
	__webpack_require__(1255);
	__webpack_require__(1247);
	__webpack_require__(1248);
	__webpack_require__(1253);
	__webpack_require__(1258);
	__webpack_require__(1260);
	__webpack_require__(1243);
	__webpack_require__(1244);
	__webpack_require__(1245);
	__webpack_require__(1246);
	__webpack_require__(1249);
	__webpack_require__(1250);
	__webpack_require__(1251);
	__webpack_require__(1254);
	__webpack_require__(1256);
	__webpack_require__(1259);
	__webpack_require__(1261);
	__webpack_require__(1262);
	__webpack_require__(1263);
	__webpack_require__(1166);
	__webpack_require__(1168);
	__webpack_require__(1167);
	__webpack_require__(1170);
	__webpack_require__(1169);
	__webpack_require__(1155);
	__webpack_require__(1153);
	__webpack_require__(1159);
	__webpack_require__(1156);
	__webpack_require__(1162);
	__webpack_require__(1164);
	__webpack_require__(1152);
	__webpack_require__(1158);
	__webpack_require__(1149);
	__webpack_require__(1163);
	__webpack_require__(1147);
	__webpack_require__(1161);
	__webpack_require__(1160);
	__webpack_require__(1154);
	__webpack_require__(1157);
	__webpack_require__(1146);
	__webpack_require__(1148);
	__webpack_require__(1151);
	__webpack_require__(1150);
	__webpack_require__(1165);
	__webpack_require__(335);
	__webpack_require__(1237);
	__webpack_require__(1242);
	__webpack_require__(509);
	__webpack_require__(1238);
	__webpack_require__(1239);
	__webpack_require__(1240);
	__webpack_require__(1241);
	__webpack_require__(1222);
	__webpack_require__(508);
	__webpack_require__(510);
	__webpack_require__(511);
	__webpack_require__(1277);
	__webpack_require__(1266);
	__webpack_require__(1267);
	__webpack_require__(1272);
	__webpack_require__(1275);
	__webpack_require__(1276);
	__webpack_require__(1270);
	__webpack_require__(1273);
	__webpack_require__(1271);
	__webpack_require__(1274);
	__webpack_require__(1268);
	__webpack_require__(1269);
	__webpack_require__(1223);
	__webpack_require__(1224);
	__webpack_require__(1225);
	__webpack_require__(1226);
	__webpack_require__(1227);
	__webpack_require__(1230);
	__webpack_require__(1228);
	__webpack_require__(1229);
	__webpack_require__(1231);
	__webpack_require__(1232);
	__webpack_require__(1233);
	__webpack_require__(1234);
	__webpack_require__(1236);
	__webpack_require__(1235);
	__webpack_require__(1280);
	__webpack_require__(1278);
	__webpack_require__(1279);
	__webpack_require__(1321);
	__webpack_require__(1324);
	__webpack_require__(1323);
	__webpack_require__(1325);
	__webpack_require__(1326);
	__webpack_require__(1322);
	__webpack_require__(1327);
	__webpack_require__(1328);
	__webpack_require__(1302);
	__webpack_require__(1305);
	__webpack_require__(1301);
	__webpack_require__(1299);
	__webpack_require__(1300);
	__webpack_require__(1303);
	__webpack_require__(1304);
	__webpack_require__(1286);
	__webpack_require__(1320);
	__webpack_require__(1285);
	__webpack_require__(1319);
	__webpack_require__(1331);
	__webpack_require__(1333);
	__webpack_require__(1284);
	__webpack_require__(1318);
	__webpack_require__(1330);
	__webpack_require__(1332);
	__webpack_require__(1283);
	__webpack_require__(1329);
	__webpack_require__(1282);
	__webpack_require__(1287);
	__webpack_require__(1288);
	__webpack_require__(1289);
	__webpack_require__(1290);
	__webpack_require__(1291);
	__webpack_require__(1293);
	__webpack_require__(1292);
	__webpack_require__(1294);
	__webpack_require__(1295);
	__webpack_require__(1296);
	__webpack_require__(1298);
	__webpack_require__(1297);
	__webpack_require__(1307);
	__webpack_require__(1308);
	__webpack_require__(1309);
	__webpack_require__(1310);
	__webpack_require__(1312);
	__webpack_require__(1311);
	__webpack_require__(1314);
	__webpack_require__(1313);
	__webpack_require__(1315);
	__webpack_require__(1316);
	__webpack_require__(1317);
	__webpack_require__(1281);
	__webpack_require__(1306);
	__webpack_require__(1336);
	__webpack_require__(1335);
	__webpack_require__(1334);
	module.exports = __webpack_require__(118);


/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ticky = __webpack_require__(1342);
	
	module.exports = function debounce (fn, args, ctx) {
	  if (!fn) { return; }
	  ticky(function run () {
	    fn.apply(ctx || null, args || []);
	  });
	};


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var atoa = __webpack_require__(1341);
	var debounce = __webpack_require__(1339);
	
	module.exports = function emitter (thing, options) {
	  var opts = options || {};
	  var evt = {};
	  if (thing === undefined) { thing = {}; }
	  thing.on = function (type, fn) {
	    if (!evt[type]) {
	      evt[type] = [fn];
	    } else {
	      evt[type].push(fn);
	    }
	    return thing;
	  };
	  thing.once = function (type, fn) {
	    fn._once = true; // thing.off(fn) still works!
	    thing.on(type, fn);
	    return thing;
	  };
	  thing.off = function (type, fn) {
	    var c = arguments.length;
	    if (c === 1) {
	      delete evt[type];
	    } else if (c === 0) {
	      evt = {};
	    } else {
	      var et = evt[type];
	      if (!et) { return thing; }
	      et.splice(et.indexOf(fn), 1);
	    }
	    return thing;
	  };
	  thing.emit = function () {
	    var args = atoa(arguments);
	    return thing.emitterSnapshot(args.shift()).apply(this, args);
	  };
	  thing.emitterSnapshot = function (type) {
	    var et = (evt[type] || []).slice(0);
	    return function () {
	      var args = atoa(arguments);
	      var ctx = this || thing;
	      if (type === 'error' && opts.throws !== false && !et.length) { throw args.length === 1 ? args[0] : args; }
	      et.forEach(function emitter (listen) {
	        if (opts.async) { debounce(listen, args, ctx); } else { listen.apply(ctx, args); }
	        if (listen._once) { thing.off(type, listen); }
	      });
	      return thing;
	    };
	  };
	  return thing;
	};


/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {var si = typeof setImmediate === 'function', tick;
	if (si) {
	  tick = function (fn) { setImmediate(fn); };
	} else {
	  tick = function (fn) { setTimeout(fn, 0); };
	}
	
	module.exports = tick;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(760).setImmediate))

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(768));
	var unitless = _interopDefault(__webpack_require__(770));
	var hashString = _interopDefault(__webpack_require__(767));
	var Stylis = _interopDefault(__webpack_require__(769));
	var stylisRuleSheet = _interopDefault(__webpack_require__(1988));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var processStyleName = memoize(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  if (unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  !isNaN(value) && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    return oldProcessStyleValue(key, value);
	  };
	}
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'function':
	        if (false) {
	          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
	        }
	
	        toAdd = classnames([arg()]);
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	var isBrowser = typeof document !== 'undefined';
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function makeStyleTag(opts) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', opts.key || '');
	
	  if (opts.nonce !== undefined) {
	    tag.setAttribute('nonce', opts.nonce);
	  }
	
	  tag.appendChild(document.createTextNode('')) // $FlowFixMe
	  ;
	  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = ("production") === 'production'; // the big drawback here is that the css won't be editable in devtools
	
	    this.tags = [];
	    this.ctr = 0;
	    this.opts = options;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.inject = function inject() {
	    if (this.injected) {
	      throw new Error('already injected!');
	    }
	
	    this.tags[0] = makeStyleTag(this.opts);
	    this.injected = true;
	  };
	
	  _proto.speedy = function speedy(bool) {
	    if (this.ctr !== 0) {
	      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
	      throw new Error("cannot change speedy now");
	    }
	
	    this.isSpeedy = !!bool;
	  };
	
	  _proto.insert = function insert(rule, sourceMap) {
	    // this is the ultrafast version, works across browsers
	    if (this.isSpeedy) {
	      var tag = this.tags[this.tags.length - 1];
	      var sheet = sheetForTag(tag);
	
	      try {
	        sheet.insertRule(rule, sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn('illegal rule', rule); // eslint-disable-line no-console
	        }
	      }
	    } else {
	      var _tag = makeStyleTag(this.opts);
	
	      this.tags.push(_tag);
	
	      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
	    }
	
	    this.ctr++;
	
	    if (this.ctr % 65000 === 0) {
	      this.tags.push(makeStyleTag(this.opts));
	    }
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0; // todo - look for remnants in document.styleSheets
	
	    this.injected = false;
	  };
	
	  return StyleSheet;
	}();
	
	function createEmotion(context, options) {
	  if (context.__SECRET_EMOTION__ !== undefined) {
	    return context.__SECRET_EMOTION__;
	  }
	
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	
	  if (false) {
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var current;
	
	  function insertRule(rule) {
	    current += rule;
	
	    if (isBrowser) {
	      sheet.insert(rule, currentSourceMap);
	    }
	  }
	
	  var insertionPlugin = stylisRuleSheet(insertRule);
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var caches = {
	    registered: {},
	    inserted: {},
	    nonce: options.nonce,
	    key: key
	  };
	  var sheet = new StyleSheet(options);
	
	  if (isBrowser) {
	    // 🚀
	    sheet.inject();
	  }
	
	  var stylis = new Stylis(stylisOptions);
	  stylis.use(options.stylisPlugins)(insertionPlugin);
	  var currentSourceMap = '';
	
	  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
	    if (interpolation == null) {
	      return '';
	    }
	
	    switch (typeof interpolation) {
	      case 'boolean':
	        return '';
	
	      case 'function':
	        if (interpolation.__emotion_styles !== undefined) {
	          var selector = interpolation.toString();
	
	          if (selector === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          return selector;
	        }
	
	        if (this === undefined && ("production") !== 'production') {
	          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
	        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
	
	      case 'object':
	        return createStringFromObject.call(this, interpolation);
	
	      default:
	        var cached = caches.registered[interpolation];
	        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
	    }
	  }
	
	  var objectToStringCache = new WeakMap();
	
	  function createStringFromObject(obj) {
	    if (objectToStringCache.has(obj)) {
	      // $FlowFixMe
	      return objectToStringCache.get(obj);
	    }
	
	    var string = '';
	
	    if (Array.isArray(obj)) {
	      obj.forEach(function (interpolation) {
	        string += handleInterpolation.call(this, interpolation, false);
	      }, this);
	    } else {
	      Object.keys(obj).forEach(function (key) {
	        if (typeof obj[key] !== 'object') {
	          if (caches.registered[obj[key]] !== undefined) {
	            string += key + "{" + caches.registered[obj[key]] + "}";
	          } else {
	            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
	          }
	        } else {
	          if (key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
	            obj[key].forEach(function (value) {
	              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
	            });
	          } else {
	            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
	          }
	        }
	      }, this);
	    }
	
	    objectToStringCache.set(obj, string);
	    return string;
	  }
	
	  var name;
	  var stylesWithLabel;
	  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	
	  var createClassName = function createClassName(styles, identifierName) {
	    return hashString(styles + identifierName) + identifierName;
	  };
	
	  if (false) {
	    var oldCreateClassName = createClassName;
	    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
	
	    createClassName = function createClassName(styles, identifierName) {
	      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
	        currentSourceMap = sourceMap;
	        return '';
	      }), identifierName);
	    };
	  }
	
	  var createStyles = function createStyles(strings) {
	    var stringMode = true;
	    var styles = '';
	    var identifierName = '';
	
	    if (strings == null || strings.raw === undefined) {
	      stringMode = false;
	      styles += handleInterpolation.call(this, strings, false);
	    } else {
	      styles += strings[0];
	    }
	
	    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    interpolations.forEach(function (interpolation, i) {
	      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
	      );
	
	      if (stringMode === true && strings[i + 1] !== undefined) {
	        styles += strings[i + 1];
	      }
	    }, this);
	    stylesWithLabel = styles;
	    styles = styles.replace(labelPattern, function (match, p1) {
	      identifierName += "-" + p1;
	      return '';
	    });
	    name = createClassName(styles, identifierName);
	    return styles;
	  };
	
	  if (false) {
	    var oldStylis = stylis;
	
	    stylis = function stylis(selector, styles) {
	      oldStylis(selector, styles);
	      currentSourceMap = '';
	    };
	  }
	
	  function insert(scope, styles) {
	    if (caches.inserted[name] === undefined) {
	      current = '';
	      stylis(scope, styles);
	      caches.inserted[name] = current;
	    }
	  }
	
	  var css = function css() {
	    var styles = createStyles.apply(this, arguments);
	    var selector = key + "-" + name;
	
	    if (caches.registered[selector] === undefined) {
	      caches.registered[selector] = stylesWithLabel;
	    }
	
	    insert("." + selector, styles);
	    return selector;
	  };
	
	  var keyframes = function keyframes() {
	    var styles = createStyles.apply(this, arguments);
	    var animation = "animation-" + name;
	    insert('', "@keyframes " + animation + "{" + styles + "}");
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    var styles = createStyles.apply(this, arguments);
	    insert('', styles);
	  };
	
	  function getRegisteredStyles(registeredStyles, classNames) {
	    var rawClassName = '';
	    classNames.split(' ').forEach(function (className) {
	      if (caches.registered[className] !== undefined) {
	        registeredStyles.push(className);
	      } else {
	        rawClassName += className + " ";
	      }
	    });
	    return rawClassName;
	  }
	
	  function merge(className, sourceMap) {
	    var registeredStyles = [];
	    var rawClassName = getRegisteredStyles(registeredStyles, className);
	
	    if (registeredStyles.length < 2) {
	      return className;
	    }
	
	    return rawClassName + css(registeredStyles, sourceMap);
	  }
	
	  function cx() {
	    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      classNames[_key2] = arguments[_key2];
	    }
	
	    return merge(classnames(classNames));
	  }
	
	  function hydrateSingleId(id) {
	    caches.inserted[id] = true;
	  }
	
	  function hydrate(ids) {
	    ids.forEach(hydrateSingleId);
	  }
	
	  function flush() {
	    if (isBrowser) {
	      sheet.flush();
	      sheet.inject();
	    }
	
	    caches.inserted = {};
	    caches.registered = {};
	  }
	
	  if (isBrowser) {
	    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(chunks, function (node) {
	      // $FlowFixMe
	      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe
	
	      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
	    });
	  }
	
	  var emotion = {
	    flush: flush,
	    hydrate: hydrate,
	    cx: cx,
	    merge: merge,
	    getRegisteredStyles: getRegisteredStyles,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    css: css,
	    sheet: sheet,
	    caches: caches
	  };
	  context.__SECRET_EMOTION__ = emotion;
	  return emotion;
	}
	
	module.exports = createEmotion;


/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	var NativeCustomEvent = global.CustomEvent;
	
	function useNative () {
	  try {
	    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
	    return  'cat' === p.type && 'bar' === p.detail.foo;
	  } catch (e) {
	  }
	  return false;
	}
	
	/**
	 * Cross-browser `CustomEvent` constructor.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
	 *
	 * @public
	 */
	
	module.exports = useNative() ? NativeCustomEvent :
	
	// IE >= 9
	'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent (type, params) {
	  var e = document.createEvent('CustomEvent');
	  if (params) {
	    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
	  } else {
	    e.initCustomEvent(type, false, false, void 0);
	  }
	  return e;
	} :
	
	// IE <= 8
	function CustomEvent (type, params) {
	  var e = document.createEventObject();
	  e.type = type;
	  if (params) {
	    e.bubbles = Boolean(params.bubbles);
	    e.cancelable = Boolean(params.cancelable);
	    e.detail = params.detail;
	  } else {
	    e.bubbles = false;
	    e.cancelable = false;
	    e.detail = void 0;
	  }
	  return e;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var customEvent = __webpack_require__(1344);
	var eventmap = __webpack_require__(1346);
	var doc = global.document;
	var addEvent = addEventEasy;
	var removeEvent = removeEventEasy;
	var hardCache = [];
	
	if (!global.addEventListener) {
	  addEvent = addEventHard;
	  removeEvent = removeEventHard;
	}
	
	module.exports = {
	  add: addEvent,
	  remove: removeEvent,
	  fabricate: fabricateEvent
	};
	
	function addEventEasy (el, type, fn, capturing) {
	  return el.addEventListener(type, fn, capturing);
	}
	
	function addEventHard (el, type, fn) {
	  return el.attachEvent('on' + type, wrap(el, type, fn));
	}
	
	function removeEventEasy (el, type, fn, capturing) {
	  return el.removeEventListener(type, fn, capturing);
	}
	
	function removeEventHard (el, type, fn) {
	  var listener = unwrap(el, type, fn);
	  if (listener) {
	    return el.detachEvent('on' + type, listener);
	  }
	}
	
	function fabricateEvent (el, type, model) {
	  var e = eventmap.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
	  if (el.dispatchEvent) {
	    el.dispatchEvent(e);
	  } else {
	    el.fireEvent('on' + type, e);
	  }
	  function makeClassicEvent () {
	    var e;
	    if (doc.createEvent) {
	      e = doc.createEvent('Event');
	      e.initEvent(type, true, true);
	    } else if (doc.createEventObject) {
	      e = doc.createEventObject();
	    }
	    return e;
	  }
	  function makeCustomEvent () {
	    return new customEvent(type, { detail: model });
	  }
	}
	
	function wrapperFactory (el, type, fn) {
	  return function wrapper (originalEvent) {
	    var e = originalEvent || global.event;
	    e.target = e.target || e.srcElement;
	    e.preventDefault = e.preventDefault || function preventDefault () { e.returnValue = false; };
	    e.stopPropagation = e.stopPropagation || function stopPropagation () { e.cancelBubble = true; };
	    e.which = e.which || e.keyCode;
	    fn.call(el, e);
	  };
	}
	
	function wrap (el, type, fn) {
	  var wrapper = unwrap(el, type, fn) || wrapperFactory(el, type, fn);
	  hardCache.push({
	    wrapper: wrapper,
	    element: el,
	    type: type,
	    fn: fn
	  });
	  return wrapper;
	}
	
	function unwrap (el, type, fn) {
	  var i = find(el, type, fn);
	  if (i) {
	    var wrapper = hardCache[i].wrapper;
	    hardCache.splice(i, 1); // free up a tad of memory
	    return wrapper;
	  }
	}
	
	function find (el, type, fn) {
	  var i, item;
	  for (i = 0; i < hardCache.length; i++) {
	    item = hardCache[i];
	    if (item.element === el && item.type === type && item.fn === fn) {
	      return i;
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var eventmap = [];
	var eventname = '';
	var ron = /^on/;
	
	for (eventname in global) {
	  if (ron.test(eventname)) {
	    eventmap.push(eventname.slice(2));
	  }
	}
	
	module.exports = eventmap;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1348));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	(function (global, factory) {
	     true ? factory(exports) :
	    typeof define === 'function' && define.amd ? define(['exports'], factory) :
	    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.echarts = {}));
	}(this, (function (exports) { 'use strict';
	
	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.
	
	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.
	
	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */
	    /* global Reflect, Promise */
	
	    var extendStatics = function(d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	
	    function __extends(d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }
	
	    var Browser = (function () {
	        function Browser() {
	            this.firefox = false;
	            this.ie = false;
	            this.edge = false;
	            this.newEdge = false;
	            this.weChat = false;
	        }
	        return Browser;
	    }());
	    var Env = (function () {
	        function Env() {
	            this.browser = new Browser();
	            this.node = false;
	            this.wxa = false;
	            this.worker = false;
	            this.svgSupported = false;
	            this.touchEventsSupported = false;
	            this.pointerEventsSupported = false;
	            this.domSupported = false;
	            this.transformSupported = false;
	            this.transform3dSupported = false;
	            this.hasGlobalWindow = typeof window !== 'undefined';
	        }
	        return Env;
	    }());
	    var env = new Env();
	    if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
	        env.wxa = true;
	        env.touchEventsSupported = true;
	    }
	    else if (typeof document === 'undefined' && typeof self !== 'undefined') {
	        env.worker = true;
	    }
	    else if (typeof navigator === 'undefined') {
	        env.node = true;
	        env.svgSupported = true;
	    }
	    else {
	        detect(navigator.userAgent, env);
	    }
	    function detect(ua, env) {
	        var browser = env.browser;
	        var firefox = ua.match(/Firefox\/([\d.]+)/);
	        var ie = ua.match(/MSIE\s([\d.]+)/)
	            || ua.match(/Trident\/.+?rv:(([\d.]+))/);
	        var edge = ua.match(/Edge?\/([\d.]+)/);
	        var weChat = (/micromessenger/i).test(ua);
	        if (firefox) {
	            browser.firefox = true;
	            browser.version = firefox[1];
	        }
	        if (ie) {
	            browser.ie = true;
	            browser.version = ie[1];
	        }
	        if (edge) {
	            browser.edge = true;
	            browser.version = edge[1];
	            browser.newEdge = +edge[1].split('.')[0] > 18;
	        }
	        if (weChat) {
	            browser.weChat = true;
	        }
	        env.svgSupported = typeof SVGRect !== 'undefined';
	        env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
	        env.pointerEventsSupported = 'onpointerdown' in window
	            && (browser.edge || (browser.ie && +browser.version >= 11));
	        env.domSupported = typeof document !== 'undefined';
	        var style = document.documentElement.style;
	        env.transform3dSupported = ((browser.ie && 'transition' in style)
	            || browser.edge
	            || (('WebKitCSSMatrix' in window) && ('m11' in new WebKitCSSMatrix()))
	            || 'MozPerspective' in style)
	            && !('OTransition' in style);
	        env.transformSupported = env.transform3dSupported
	            || (browser.ie && +browser.version >= 9);
	    }
	
	    var DEFAULT_FONT_SIZE = 12;
	    var DEFAULT_FONT_FAMILY = 'sans-serif';
	    var DEFAULT_FONT = DEFAULT_FONT_SIZE + "px " + DEFAULT_FONT_FAMILY;
	    var OFFSET = 20;
	    var SCALE = 100;
	    var defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
	    function getTextWidthMap(mapStr) {
	        var map = {};
	        if (typeof JSON === 'undefined') {
	            return map;
	        }
	        for (var i = 0; i < mapStr.length; i++) {
	            var char = String.fromCharCode(i + 32);
	            var size = (mapStr.charCodeAt(i) - OFFSET) / SCALE;
	            map[char] = size;
	        }
	        return map;
	    }
	    var DEFAULT_TEXT_WIDTH_MAP = getTextWidthMap(defaultWidthMapStr);
	    var platformApi = {
	        createCanvas: function () {
	            return typeof document !== 'undefined'
	                && document.createElement('canvas');
	        },
	        measureText: (function () {
	            var _ctx;
	            var _cachedFont;
	            return function (text, font) {
	                if (!_ctx) {
	                    var canvas = platformApi.createCanvas();
	                    _ctx = canvas && canvas.getContext('2d');
	                }
	                if (_ctx) {
	                    if (_cachedFont !== font) {
	                        _cachedFont = _ctx.font = font || DEFAULT_FONT;
	                    }
	                    return _ctx.measureText(text);
	                }
	                else {
	                    text = text || '';
	                    font = font || DEFAULT_FONT;
	                    var res = /(\d+)px/.exec(font);
	                    var fontSize = res && +res[1] || DEFAULT_FONT_SIZE;
	                    var width = 0;
	                    if (font.indexOf('mono') >= 0) {
	                        width = fontSize * text.length;
	                    }
	                    else {
	                        for (var i = 0; i < text.length; i++) {
	                            var preCalcWidth = DEFAULT_TEXT_WIDTH_MAP[text[i]];
	                            width += preCalcWidth == null ? fontSize : (preCalcWidth * fontSize);
	                        }
	                    }
	                    return { width: width };
	                }
	            };
	        })(),
	        loadImage: function (src, onload, onerror) {
	            var image = new Image();
	            image.onload = onload;
	            image.onerror = onerror;
	            image.src = src;
	            return image;
	        }
	    };
	    function setPlatformAPI(newPlatformApis) {
	        for (var key in platformApi) {
	            if (newPlatformApis[key]) {
	                platformApi[key] = newPlatformApis[key];
	            }
	        }
	    }
	
	    var BUILTIN_OBJECT = reduce([
	        'Function',
	        'RegExp',
	        'Date',
	        'Error',
	        'CanvasGradient',
	        'CanvasPattern',
	        'Image',
	        'Canvas'
	    ], function (obj, val) {
	        obj['[object ' + val + ']'] = true;
	        return obj;
	    }, {});
	    var TYPED_ARRAY = reduce([
	        'Int8',
	        'Uint8',
	        'Uint8Clamped',
	        'Int16',
	        'Uint16',
	        'Int32',
	        'Uint32',
	        'Float32',
	        'Float64'
	    ], function (obj, val) {
	        obj['[object ' + val + 'Array]'] = true;
	        return obj;
	    }, {});
	    var objToString = Object.prototype.toString;
	    var arrayProto = Array.prototype;
	    var nativeForEach = arrayProto.forEach;
	    var nativeFilter = arrayProto.filter;
	    var nativeSlice = arrayProto.slice;
	    var nativeMap = arrayProto.map;
	    var ctorFunction = function () { }.constructor;
	    var protoFunction = ctorFunction ? ctorFunction.prototype : null;
	    var protoKey = '__proto__';
	    var idStart = 0x0907;
	    function guid() {
	        return idStart++;
	    }
	    function logError() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (typeof console !== 'undefined') {
	            console.error.apply(console, args);
	        }
	    }
	    function clone(source) {
	        if (source == null || typeof source !== 'object') {
	            return source;
	        }
	        var result = source;
	        var typeStr = objToString.call(source);
	        if (typeStr === '[object Array]') {
	            if (!isPrimitive(source)) {
	                result = [];
	                for (var i = 0, len = source.length; i < len; i++) {
	                    result[i] = clone(source[i]);
	                }
	            }
	        }
	        else if (TYPED_ARRAY[typeStr]) {
	            if (!isPrimitive(source)) {
	                var Ctor = source.constructor;
	                if (Ctor.from) {
	                    result = Ctor.from(source);
	                }
	                else {
	                    result = new Ctor(source.length);
	                    for (var i = 0, len = source.length; i < len; i++) {
	                        result[i] = source[i];
	                    }
	                }
	            }
	        }
	        else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
	            result = {};
	            for (var key in source) {
	                if (source.hasOwnProperty(key) && key !== protoKey) {
	                    result[key] = clone(source[key]);
	                }
	            }
	        }
	        return result;
	    }
	    function merge(target, source, overwrite) {
	        if (!isObject(source) || !isObject(target)) {
	            return overwrite ? clone(source) : target;
	        }
	        for (var key in source) {
	            if (source.hasOwnProperty(key) && key !== protoKey) {
	                var targetProp = target[key];
	                var sourceProp = source[key];
	                if (isObject(sourceProp)
	                    && isObject(targetProp)
	                    && !isArray(sourceProp)
	                    && !isArray(targetProp)
	                    && !isDom(sourceProp)
	                    && !isDom(targetProp)
	                    && !isBuiltInObject(sourceProp)
	                    && !isBuiltInObject(targetProp)
	                    && !isPrimitive(sourceProp)
	                    && !isPrimitive(targetProp)) {
	                    merge(targetProp, sourceProp, overwrite);
	                }
	                else if (overwrite || !(key in target)) {
	                    target[key] = clone(source[key]);
	                }
	            }
	        }
	        return target;
	    }
	    function mergeAll(targetAndSources, overwrite) {
	        var result = targetAndSources[0];
	        for (var i = 1, len = targetAndSources.length; i < len; i++) {
	            result = merge(result, targetAndSources[i], overwrite);
	        }
	        return result;
	    }
	    function extend(target, source) {
	        if (Object.assign) {
	            Object.assign(target, source);
	        }
	        else {
	            for (var key in source) {
	                if (source.hasOwnProperty(key) && key !== protoKey) {
	                    target[key] = source[key];
	                }
	            }
	        }
	        return target;
	    }
	    function defaults(target, source, overlay) {
	        var keysArr = keys(source);
	        for (var i = 0; i < keysArr.length; i++) {
	            var key = keysArr[i];
	            if ((overlay ? source[key] != null : target[key] == null)) {
	                target[key] = source[key];
	            }
	        }
	        return target;
	    }
	    var createCanvas = platformApi.createCanvas;
	    function indexOf(array, value) {
	        if (array) {
	            if (array.indexOf) {
	                return array.indexOf(value);
	            }
	            for (var i = 0, len = array.length; i < len; i++) {
	                if (array[i] === value) {
	                    return i;
	                }
	            }
	        }
	        return -1;
	    }
	    function inherits(clazz, baseClazz) {
	        var clazzPrototype = clazz.prototype;
	        function F() { }
	        F.prototype = baseClazz.prototype;
	        clazz.prototype = new F();
	        for (var prop in clazzPrototype) {
	            if (clazzPrototype.hasOwnProperty(prop)) {
	                clazz.prototype[prop] = clazzPrototype[prop];
	            }
	        }
	        clazz.prototype.constructor = clazz;
	        clazz.superClass = baseClazz;
	    }
	    function mixin(target, source, override) {
	        target = 'prototype' in target ? target.prototype : target;
	        source = 'prototype' in source ? source.prototype : source;
	        if (Object.getOwnPropertyNames) {
	            var keyList = Object.getOwnPropertyNames(source);
	            for (var i = 0; i < keyList.length; i++) {
	                var key = keyList[i];
	                if (key !== 'constructor') {
	                    if ((override ? source[key] != null : target[key] == null)) {
	                        target[key] = source[key];
	                    }
	                }
	            }
	        }
	        else {
	            defaults(target, source, override);
	        }
	    }
	    function isArrayLike(data) {
	        if (!data) {
	            return false;
	        }
	        if (typeof data === 'string') {
	            return false;
	        }
	        return typeof data.length === 'number';
	    }
	    function each(arr, cb, context) {
	        if (!(arr && cb)) {
	            return;
	        }
	        if (arr.forEach && arr.forEach === nativeForEach) {
	            arr.forEach(cb, context);
	        }
	        else if (arr.length === +arr.length) {
	            for (var i = 0, len = arr.length; i < len; i++) {
	                cb.call(context, arr[i], i, arr);
	            }
	        }
	        else {
	            for (var key in arr) {
	                if (arr.hasOwnProperty(key)) {
	                    cb.call(context, arr[key], key, arr);
	                }
	            }
	        }
	    }
	    function map(arr, cb, context) {
	        if (!arr) {
	            return [];
	        }
	        if (!cb) {
	            return slice(arr);
	        }
	        if (arr.map && arr.map === nativeMap) {
	            return arr.map(cb, context);
	        }
	        else {
	            var result = [];
	            for (var i = 0, len = arr.length; i < len; i++) {
	                result.push(cb.call(context, arr[i], i, arr));
	            }
	            return result;
	        }
	    }
	    function reduce(arr, cb, memo, context) {
	        if (!(arr && cb)) {
	            return;
	        }
	        for (var i = 0, len = arr.length; i < len; i++) {
	            memo = cb.call(context, memo, arr[i], i, arr);
	        }
	        return memo;
	    }
	    function filter(arr, cb, context) {
	        if (!arr) {
	            return [];
	        }
	        if (!cb) {
	            return slice(arr);
	        }
	        if (arr.filter && arr.filter === nativeFilter) {
	            return arr.filter(cb, context);
	        }
	        else {
	            var result = [];
	            for (var i = 0, len = arr.length; i < len; i++) {
	                if (cb.call(context, arr[i], i, arr)) {
	                    result.push(arr[i]);
	                }
	            }
	            return result;
	        }
	    }
	    function find(arr, cb, context) {
	        if (!(arr && cb)) {
	            return;
	        }
	        for (var i = 0, len = arr.length; i < len; i++) {
	            if (cb.call(context, arr[i], i, arr)) {
	                return arr[i];
	            }
	        }
	    }
	    function keys(obj) {
	        if (!obj) {
	            return [];
	        }
	        if (Object.keys) {
	            return Object.keys(obj);
	        }
	        var keyList = [];
	        for (var key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                keyList.push(key);
	            }
	        }
	        return keyList;
	    }
	    function bindPolyfill(func, context) {
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        return function () {
	            return func.apply(context, args.concat(nativeSlice.call(arguments)));
	        };
	    }
	    var bind = (protoFunction && isFunction(protoFunction.bind))
	        ? protoFunction.call.bind(protoFunction.bind)
	        : bindPolyfill;
	    function curry(func) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        return function () {
	            return func.apply(this, args.concat(nativeSlice.call(arguments)));
	        };
	    }
	    function isArray(value) {
	        if (Array.isArray) {
	            return Array.isArray(value);
	        }
	        return objToString.call(value) === '[object Array]';
	    }
	    function isFunction(value) {
	        return typeof value === 'function';
	    }
	    function isString(value) {
	        return typeof value === 'string';
	    }
	    function isStringSafe(value) {
	        return objToString.call(value) === '[object String]';
	    }
	    function isNumber(value) {
	        return typeof value === 'number';
	    }
	    function isObject(value) {
	        var type = typeof value;
	        return type === 'function' || (!!value && type === 'object');
	    }
	    function isBuiltInObject(value) {
	        return !!BUILTIN_OBJECT[objToString.call(value)];
	    }
	    function isTypedArray(value) {
	        return !!TYPED_ARRAY[objToString.call(value)];
	    }
	    function isDom(value) {
	        return typeof value === 'object'
	            && typeof value.nodeType === 'number'
	            && typeof value.ownerDocument === 'object';
	    }
	    function isGradientObject(value) {
	        return value.colorStops != null;
	    }
	    function isImagePatternObject(value) {
	        return value.image != null;
	    }
	    function isRegExp(value) {
	        return objToString.call(value) === '[object RegExp]';
	    }
	    function eqNaN(value) {
	        return value !== value;
	    }
	    function retrieve() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        for (var i = 0, len = args.length; i < len; i++) {
	            if (args[i] != null) {
	                return args[i];
	            }
	        }
	    }
	    function retrieve2(value0, value1) {
	        return value0 != null
	            ? value0
	            : value1;
	    }
	    function retrieve3(value0, value1, value2) {
	        return value0 != null
	            ? value0
	            : value1 != null
	                ? value1
	                : value2;
	    }
	    function slice(arr) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        return nativeSlice.apply(arr, args);
	    }
	    function normalizeCssArray(val) {
	        if (typeof (val) === 'number') {
	            return [val, val, val, val];
	        }
	        var len = val.length;
	        if (len === 2) {
	            return [val[0], val[1], val[0], val[1]];
	        }
	        else if (len === 3) {
	            return [val[0], val[1], val[2], val[1]];
	        }
	        return val;
	    }
	    function assert(condition, message) {
	        if (!condition) {
	            throw new Error(message);
	        }
	    }
	    function trim(str) {
	        if (str == null) {
	            return null;
	        }
	        else if (typeof str.trim === 'function') {
	            return str.trim();
	        }
	        else {
	            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	        }
	    }
	    var primitiveKey = '__ec_primitive__';
	    function setAsPrimitive(obj) {
	        obj[primitiveKey] = true;
	    }
	    function isPrimitive(obj) {
	        return obj[primitiveKey];
	    }
	    var MapPolyfill = (function () {
	        function MapPolyfill() {
	            this.data = {};
	        }
	        MapPolyfill.prototype["delete"] = function (key) {
	            var existed = this.has(key);
	            if (existed) {
	                delete this.data[key];
	            }
	            return existed;
	        };
	        MapPolyfill.prototype.has = function (key) {
	            return this.data.hasOwnProperty(key);
	        };
	        MapPolyfill.prototype.get = function (key) {
	            return this.data[key];
	        };
	        MapPolyfill.prototype.set = function (key, value) {
	            this.data[key] = value;
	            return this;
	        };
	        MapPolyfill.prototype.keys = function () {
	            return keys(this.data);
	        };
	        MapPolyfill.prototype.forEach = function (callback) {
	            var data = this.data;
	            for (var key in data) {
	                if (data.hasOwnProperty(key)) {
	                    callback(data[key], key);
	                }
	            }
	        };
	        return MapPolyfill;
	    }());
	    var isNativeMapSupported = typeof Map === 'function';
	    function maybeNativeMap() {
	        return (isNativeMapSupported ? new Map() : new MapPolyfill());
	    }
	    var HashMap = (function () {
	        function HashMap(obj) {
	            var isArr = isArray(obj);
	            this.data = maybeNativeMap();
	            var thisMap = this;
	            (obj instanceof HashMap)
	                ? obj.each(visit)
	                : (obj && each(obj, visit));
	            function visit(value, key) {
	                isArr ? thisMap.set(value, key) : thisMap.set(key, value);
	            }
	        }
	        HashMap.prototype.hasKey = function (key) {
	            return this.data.has(key);
	        };
	        HashMap.prototype.get = function (key) {
	            return this.data.get(key);
	        };
	        HashMap.prototype.set = function (key, value) {
	            this.data.set(key, value);
	            return value;
	        };
	        HashMap.prototype.each = function (cb, context) {
	            this.data.forEach(function (value, key) {
	                cb.call(context, value, key);
	            });
	        };
	        HashMap.prototype.keys = function () {
	            var keys = this.data.keys();
	            return isNativeMapSupported
	                ? Array.from(keys)
	                : keys;
	        };
	        HashMap.prototype.removeKey = function (key) {
	            this.data["delete"](key);
	        };
	        return HashMap;
	    }());
	    function createHashMap(obj) {
	        return new HashMap(obj);
	    }
	    function concatArray(a, b) {
	        var newArray = new a.constructor(a.length + b.length);
	        for (var i = 0; i < a.length; i++) {
	            newArray[i] = a[i];
	        }
	        var offset = a.length;
	        for (var i = 0; i < b.length; i++) {
	            newArray[i + offset] = b[i];
	        }
	        return newArray;
	    }
	    function createObject(proto, properties) {
	        var obj;
	        if (Object.create) {
	            obj = Object.create(proto);
	        }
	        else {
	            var StyleCtor = function () { };
	            StyleCtor.prototype = proto;
	            obj = new StyleCtor();
	        }
	        if (properties) {
	            extend(obj, properties);
	        }
	        return obj;
	    }
	    function disableUserSelect(dom) {
	        var domStyle = dom.style;
	        domStyle.webkitUserSelect = 'none';
	        domStyle.userSelect = 'none';
	        domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
	        domStyle['-webkit-touch-callout'] = 'none';
	    }
	    function hasOwn(own, prop) {
	        return own.hasOwnProperty(prop);
	    }
	    function noop() { }
	    var RADIAN_TO_DEGREE = 180 / Math.PI;
	
	    var util = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        guid: guid,
	        logError: logError,
	        clone: clone,
	        merge: merge,
	        mergeAll: mergeAll,
	        extend: extend,
	        defaults: defaults,
	        createCanvas: createCanvas,
	        indexOf: indexOf,
	        inherits: inherits,
	        mixin: mixin,
	        isArrayLike: isArrayLike,
	        each: each,
	        map: map,
	        reduce: reduce,
	        filter: filter,
	        find: find,
	        keys: keys,
	        bind: bind,
	        curry: curry,
	        isArray: isArray,
	        isFunction: isFunction,
	        isString: isString,
	        isStringSafe: isStringSafe,
	        isNumber: isNumber,
	        isObject: isObject,
	        isBuiltInObject: isBuiltInObject,
	        isTypedArray: isTypedArray,
	        isDom: isDom,
	        isGradientObject: isGradientObject,
	        isImagePatternObject: isImagePatternObject,
	        isRegExp: isRegExp,
	        eqNaN: eqNaN,
	        retrieve: retrieve,
	        retrieve2: retrieve2,
	        retrieve3: retrieve3,
	        slice: slice,
	        normalizeCssArray: normalizeCssArray,
	        assert: assert,
	        trim: trim,
	        setAsPrimitive: setAsPrimitive,
	        isPrimitive: isPrimitive,
	        HashMap: HashMap,
	        createHashMap: createHashMap,
	        concatArray: concatArray,
	        createObject: createObject,
	        disableUserSelect: disableUserSelect,
	        hasOwn: hasOwn,
	        noop: noop,
	        RADIAN_TO_DEGREE: RADIAN_TO_DEGREE
	    });
	
	    function create(x, y) {
	        if (x == null) {
	            x = 0;
	        }
	        if (y == null) {
	            y = 0;
	        }
	        return [x, y];
	    }
	    function copy(out, v) {
	        out[0] = v[0];
	        out[1] = v[1];
	        return out;
	    }
	    function clone$1(v) {
	        return [v[0], v[1]];
	    }
	    function set(out, a, b) {
	        out[0] = a;
	        out[1] = b;
	        return out;
	    }
	    function add(out, v1, v2) {
	        out[0] = v1[0] + v2[0];
	        out[1] = v1[1] + v2[1];
	        return out;
	    }
	    function scaleAndAdd(out, v1, v2, a) {
	        out[0] = v1[0] + v2[0] * a;
	        out[1] = v1[1] + v2[1] * a;
	        return out;
	    }
	    function sub(out, v1, v2) {
	        out[0] = v1[0] - v2[0];
	        out[1] = v1[1] - v2[1];
	        return out;
	    }
	    function len(v) {
	        return Math.sqrt(lenSquare(v));
	    }
	    var length = len;
	    function lenSquare(v) {
	        return v[0] * v[0] + v[1] * v[1];
	    }
	    var lengthSquare = lenSquare;
	    function mul(out, v1, v2) {
	        out[0] = v1[0] * v2[0];
	        out[1] = v1[1] * v2[1];
	        return out;
	    }
	    function div(out, v1, v2) {
	        out[0] = v1[0] / v2[0];
	        out[1] = v1[1] / v2[1];
	        return out;
	    }
	    function dot(v1, v2) {
	        return v1[0] * v2[0] + v1[1] * v2[1];
	    }
	    function scale(out, v, s) {
	        out[0] = v[0] * s;
	        out[1] = v[1] * s;
	        return out;
	    }
	    function normalize(out, v) {
	        var d = len(v);
	        if (d === 0) {
	            out[0] = 0;
	            out[1] = 0;
	        }
	        else {
	            out[0] = v[0] / d;
	            out[1] = v[1] / d;
	        }
	        return out;
	    }
	    function distance(v1, v2) {
	        return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0])
	            + (v1[1] - v2[1]) * (v1[1] - v2[1]));
	    }
	    var dist = distance;
	    function distanceSquare(v1, v2) {
	        return (v1[0] - v2[0]) * (v1[0] - v2[0])
	            + (v1[1] - v2[1]) * (v1[1] - v2[1]);
	    }
	    var distSquare = distanceSquare;
	    function negate(out, v) {
	        out[0] = -v[0];
	        out[1] = -v[1];
	        return out;
	    }
	    function lerp(out, v1, v2, t) {
	        out[0] = v1[0] + t * (v2[0] - v1[0]);
	        out[1] = v1[1] + t * (v2[1] - v1[1]);
	        return out;
	    }
	    function applyTransform(out, v, m) {
	        var x = v[0];
	        var y = v[1];
	        out[0] = m[0] * x + m[2] * y + m[4];
	        out[1] = m[1] * x + m[3] * y + m[5];
	        return out;
	    }
	    function min(out, v1, v2) {
	        out[0] = Math.min(v1[0], v2[0]);
	        out[1] = Math.min(v1[1], v2[1]);
	        return out;
	    }
	    function max(out, v1, v2) {
	        out[0] = Math.max(v1[0], v2[0]);
	        out[1] = Math.max(v1[1], v2[1]);
	        return out;
	    }
	
	    var vector = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        create: create,
	        copy: copy,
	        clone: clone$1,
	        set: set,
	        add: add,
	        scaleAndAdd: scaleAndAdd,
	        sub: sub,
	        len: len,
	        length: length,
	        lenSquare: lenSquare,
	        lengthSquare: lengthSquare,
	        mul: mul,
	        div: div,
	        dot: dot,
	        scale: scale,
	        normalize: normalize,
	        distance: distance,
	        dist: dist,
	        distanceSquare: distanceSquare,
	        distSquare: distSquare,
	        negate: negate,
	        lerp: lerp,
	        applyTransform: applyTransform,
	        min: min,
	        max: max
	    });
	
	    var Param = (function () {
	        function Param(target, e) {
	            this.target = target;
	            this.topTarget = e && e.topTarget;
	        }
	        return Param;
	    }());
	    var Draggable = (function () {
	        function Draggable(handler) {
	            this.handler = handler;
	            handler.on('mousedown', this._dragStart, this);
	            handler.on('mousemove', this._drag, this);
	            handler.on('mouseup', this._dragEnd, this);
	        }
	        Draggable.prototype._dragStart = function (e) {
	            var draggingTarget = e.target;
	            while (draggingTarget && !draggingTarget.draggable) {
	                draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
	            }
	            if (draggingTarget) {
	                this._draggingTarget = draggingTarget;
	                draggingTarget.dragging = true;
	                this._x = e.offsetX;
	                this._y = e.offsetY;
	                this.handler.dispatchToElement(new Param(draggingTarget, e), 'dragstart', e.event);
	            }
	        };
	        Draggable.prototype._drag = function (e) {
	            var draggingTarget = this._draggingTarget;
	            if (draggingTarget) {
	                var x = e.offsetX;
	                var y = e.offsetY;
	                var dx = x - this._x;
	                var dy = y - this._y;
	                this._x = x;
	                this._y = y;
	                draggingTarget.drift(dx, dy, e);
	                this.handler.dispatchToElement(new Param(draggingTarget, e), 'drag', e.event);
	                var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
	                var lastDropTarget = this._dropTarget;
	                this._dropTarget = dropTarget;
	                if (draggingTarget !== dropTarget) {
	                    if (lastDropTarget && dropTarget !== lastDropTarget) {
	                        this.handler.dispatchToElement(new Param(lastDropTarget, e), 'dragleave', e.event);
	                    }
	                    if (dropTarget && dropTarget !== lastDropTarget) {
	                        this.handler.dispatchToElement(new Param(dropTarget, e), 'dragenter', e.event);
	                    }
	                }
	            }
	        };
	        Draggable.prototype._dragEnd = function (e) {
	            var draggingTarget = this._draggingTarget;
	            if (draggingTarget) {
	                draggingTarget.dragging = false;
	            }
	            this.handler.dispatchToElement(new Param(draggingTarget, e), 'dragend', e.event);
	            if (this._dropTarget) {
	                this.handler.dispatchToElement(new Param(this._dropTarget, e), 'drop', e.event);
	            }
	            this._draggingTarget = null;
	            this._dropTarget = null;
	        };
	        return Draggable;
	    }());
	
	    var Eventful = (function () {
	        function Eventful(eventProcessors) {
	            if (eventProcessors) {
	                this._$eventProcessor = eventProcessors;
	            }
	        }
	        Eventful.prototype.on = function (event, query, handler, context) {
	            if (!this._$handlers) {
	                this._$handlers = {};
	            }
	            var _h = this._$handlers;
	            if (typeof query === 'function') {
	                context = handler;
	                handler = query;
	                query = null;
	            }
	            if (!handler || !event) {
	                return this;
	            }
	            var eventProcessor = this._$eventProcessor;
	            if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
	                query = eventProcessor.normalizeQuery(query);
	            }
	            if (!_h[event]) {
	                _h[event] = [];
	            }
	            for (var i = 0; i < _h[event].length; i++) {
	                if (_h[event][i].h === handler) {
	                    return this;
	                }
	            }
	            var wrap = {
	                h: handler,
	                query: query,
	                ctx: (context || this),
	                callAtLast: handler.zrEventfulCallAtLast
	            };
	            var lastIndex = _h[event].length - 1;
	            var lastWrap = _h[event][lastIndex];
	            (lastWrap && lastWrap.callAtLast)
	                ? _h[event].splice(lastIndex, 0, wrap)
	                : _h[event].push(wrap);
	            return this;
	        };
	        Eventful.prototype.isSilent = function (eventName) {
	            var _h = this._$handlers;
	            return !_h || !_h[eventName] || !_h[eventName].length;
	        };
	        Eventful.prototype.off = function (eventType, handler) {
	            var _h = this._$handlers;
	            if (!_h) {
	                return this;
	            }
	            if (!eventType) {
	                this._$handlers = {};
	                return this;
	            }
	            if (handler) {
	                if (_h[eventType]) {
	                    var newList = [];
	                    for (var i = 0, l = _h[eventType].length; i < l; i++) {
	                        if (_h[eventType][i].h !== handler) {
	                            newList.push(_h[eventType][i]);
	                        }
	                    }
	                    _h[eventType] = newList;
	                }
	                if (_h[eventType] && _h[eventType].length === 0) {
	                    delete _h[eventType];
	                }
	            }
	            else {
	                delete _h[eventType];
	            }
	            return this;
	        };
	        Eventful.prototype.trigger = function (eventType) {
	            var args = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                args[_i - 1] = arguments[_i];
	            }
	            if (!this._$handlers) {
	                return this;
	            }
	            var _h = this._$handlers[eventType];
	            var eventProcessor = this._$eventProcessor;
	            if (_h) {
	                var argLen = args.length;
	                var len = _h.length;
	                for (var i = 0; i < len; i++) {
	                    var hItem = _h[i];
	                    if (eventProcessor
	                        && eventProcessor.filter
	                        && hItem.query != null
	                        && !eventProcessor.filter(eventType, hItem.query)) {
	                        continue;
	                    }
	                    switch (argLen) {
	                        case 0:
	                            hItem.h.call(hItem.ctx);
	                            break;
	                        case 1:
	                            hItem.h.call(hItem.ctx, args[0]);
	                            break;
	                        case 2:
	                            hItem.h.call(hItem.ctx, args[0], args[1]);
	                            break;
	                        default:
	                            hItem.h.apply(hItem.ctx, args);
	                            break;
	                    }
	                }
	            }
	            eventProcessor && eventProcessor.afterTrigger
	                && eventProcessor.afterTrigger(eventType);
	            return this;
	        };
	        Eventful.prototype.triggerWithContext = function (type) {
	            var args = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                args[_i - 1] = arguments[_i];
	            }
	            if (!this._$handlers) {
	                return this;
	            }
	            var _h = this._$handlers[type];
	            var eventProcessor = this._$eventProcessor;
	            if (_h) {
	                var argLen = args.length;
	                var ctx = args[argLen - 1];
	                var len = _h.length;
	                for (var i = 0; i < len; i++) {
	                    var hItem = _h[i];
	                    if (eventProcessor
	                        && eventProcessor.filter
	                        && hItem.query != null
	                        && !eventProcessor.filter(type, hItem.query)) {
	                        continue;
	                    }
	                    switch (argLen) {
	                        case 0:
	                            hItem.h.call(ctx);
	                            break;
	                        case 1:
	                            hItem.h.call(ctx, args[0]);
	                            break;
	                        case 2:
	                            hItem.h.call(ctx, args[0], args[1]);
	                            break;
	                        default:
	                            hItem.h.apply(ctx, args.slice(1, argLen - 1));
	                            break;
	                    }
	                }
	            }
	            eventProcessor && eventProcessor.afterTrigger
	                && eventProcessor.afterTrigger(type);
	            return this;
	        };
	        return Eventful;
	    }());
	
	    var LN2 = Math.log(2);
	    function determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
	        var cacheKey = rowMask + '-' + colMask;
	        var fullRank = rows.length;
	        if (detCache.hasOwnProperty(cacheKey)) {
	            return detCache[cacheKey];
	        }
	        if (rank === 1) {
	            var colStart = Math.round(Math.log(((1 << fullRank) - 1) & ~colMask) / LN2);
	            return rows[rowStart][colStart];
	        }
	        var subRowMask = rowMask | (1 << rowStart);
	        var subRowStart = rowStart + 1;
	        while (rowMask & (1 << subRowStart)) {
	            subRowStart++;
	        }
	        var sum = 0;
	        for (var j = 0, colLocalIdx = 0; j < fullRank; j++) {
	            var colTag = 1 << j;
	            if (!(colTag & colMask)) {
	                sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j]
	                    * determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
	                colLocalIdx++;
	            }
	        }
	        detCache[cacheKey] = sum;
	        return sum;
	    }
	    function buildTransformer(src, dest) {
	        var mA = [
	            [src[0], src[1], 1, 0, 0, 0, -dest[0] * src[0], -dest[0] * src[1]],
	            [0, 0, 0, src[0], src[1], 1, -dest[1] * src[0], -dest[1] * src[1]],
	            [src[2], src[3], 1, 0, 0, 0, -dest[2] * src[2], -dest[2] * src[3]],
	            [0, 0, 0, src[2], src[3], 1, -dest[3] * src[2], -dest[3] * src[3]],
	            [src[4], src[5], 1, 0, 0, 0, -dest[4] * src[4], -dest[4] * src[5]],
	            [0, 0, 0, src[4], src[5], 1, -dest[5] * src[4], -dest[5] * src[5]],
	            [src[6], src[7], 1, 0, 0, 0, -dest[6] * src[6], -dest[6] * src[7]],
	            [0, 0, 0, src[6], src[7], 1, -dest[7] * src[6], -dest[7] * src[7]]
	        ];
	        var detCache = {};
	        var det = determinant(mA, 8, 0, 0, 0, detCache);
	        if (det === 0) {
	            return;
	        }
	        var vh = [];
	        for (var i = 0; i < 8; i++) {
	            for (var j = 0; j < 8; j++) {
	                vh[j] == null && (vh[j] = 0);
	                vh[j] += ((i + j) % 2 ? -1 : 1)
	                    * determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache)
	                    / det * dest[i];
	            }
	        }
	        return function (out, srcPointX, srcPointY) {
	            var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
	            out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
	            out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
	        };
	    }
	
	    var EVENT_SAVED_PROP = '___zrEVENTSAVED';
	    var _calcOut = [];
	    function transformLocalCoord(out, elFrom, elTarget, inX, inY) {
	        return transformCoordWithViewport(_calcOut, elFrom, inX, inY, true)
	            && transformCoordWithViewport(out, elTarget, _calcOut[0], _calcOut[1]);
	    }
	    function transformCoordWithViewport(out, el, inX, inY, inverse) {
	        if (el.getBoundingClientRect && env.domSupported && !isCanvasEl(el)) {
	            var saved = el[EVENT_SAVED_PROP] || (el[EVENT_SAVED_PROP] = {});
	            var markers = prepareCoordMarkers(el, saved);
	            var transformer = preparePointerTransformer(markers, saved, inverse);
	            if (transformer) {
	                transformer(out, inX, inY);
	                return true;
	            }
	        }
	        return false;
	    }
	    function prepareCoordMarkers(el, saved) {
	        var markers = saved.markers;
	        if (markers) {
	            return markers;
	        }
	        markers = saved.markers = [];
	        var propLR = ['left', 'right'];
	        var propTB = ['top', 'bottom'];
	        for (var i = 0; i < 4; i++) {
	            var marker = document.createElement('div');
	            var stl = marker.style;
	            var idxLR = i % 2;
	            var idxTB = (i >> 1) % 2;
	            stl.cssText = [
	                'position: absolute',
	                'visibility: hidden',
	                'padding: 0',
	                'margin: 0',
	                'border-width: 0',
	                'user-select: none',
	                'width:0',
	                'height:0',
	                propLR[idxLR] + ':0',
	                propTB[idxTB] + ':0',
	                propLR[1 - idxLR] + ':auto',
	                propTB[1 - idxTB] + ':auto',
	                ''
	            ].join('!important;');
	            el.appendChild(marker);
	            markers.push(marker);
	        }
	        return markers;
	    }
	    function preparePointerTransformer(markers, saved, inverse) {
	        var transformerName = inverse ? 'invTrans' : 'trans';
	        var transformer = saved[transformerName];
	        var oldSrcCoords = saved.srcCoords;
	        var srcCoords = [];
	        var destCoords = [];
	        var oldCoordTheSame = true;
	        for (var i = 0; i < 4; i++) {
	            var rect = markers[i].getBoundingClientRect();
	            var ii = 2 * i;
	            var x = rect.left;
	            var y = rect.top;
	            srcCoords.push(x, y);
	            oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
	            destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
	        }
	        return (oldCoordTheSame && transformer)
	            ? transformer
	            : (saved.srcCoords = srcCoords,
	                saved[transformerName] = inverse
	                    ? buildTransformer(destCoords, srcCoords)
	                    : buildTransformer(srcCoords, destCoords));
	    }
	    function isCanvasEl(el) {
	        return el.nodeName.toUpperCase() === 'CANVAS';
	    }
	    var replaceReg = /([&<>"'])/g;
	    var replaceMap = {
	        '&': '&amp;',
	        '<': '&lt;',
	        '>': '&gt;',
	        '"': '&quot;',
	        '\'': '&#39;'
	    };
	    function encodeHTML(source) {
	        return source == null
	            ? ''
	            : (source + '').replace(replaceReg, function (str, c) {
	                return replaceMap[c];
	            });
	    }
	
	    var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
	    var _calcOut$1 = [];
	    var firefoxNotSupportOffsetXY = env.browser.firefox
	        && +env.browser.version.split('.')[0] < 39;
	    function clientToLocal(el, e, out, calculate) {
	        out = out || {};
	        if (calculate) {
	            calculateZrXY(el, e, out);
	        }
	        else if (firefoxNotSupportOffsetXY
	            && e.layerX != null
	            && e.layerX !== e.offsetX) {
	            out.zrX = e.layerX;
	            out.zrY = e.layerY;
	        }
	        else if (e.offsetX != null) {
	            out.zrX = e.offsetX;
	            out.zrY = e.offsetY;
	        }
	        else {
	            calculateZrXY(el, e, out);
	        }
	        return out;
	    }
	    function calculateZrXY(el, e, out) {
	        if (env.domSupported && el.getBoundingClientRect) {
	            var ex = e.clientX;
	            var ey = e.clientY;
	            if (isCanvasEl(el)) {
	                var box = el.getBoundingClientRect();
	                out.zrX = ex - box.left;
	                out.zrY = ey - box.top;
	                return;
	            }
	            else {
	                if (transformCoordWithViewport(_calcOut$1, el, ex, ey)) {
	                    out.zrX = _calcOut$1[0];
	                    out.zrY = _calcOut$1[1];
	                    return;
	                }
	            }
	        }
	        out.zrX = out.zrY = 0;
	    }
	    function getNativeEvent(e) {
	        return e
	            || window.event;
	    }
	    function normalizeEvent(el, e, calculate) {
	        e = getNativeEvent(e);
	        if (e.zrX != null) {
	            return e;
	        }
	        var eventType = e.type;
	        var isTouch = eventType && eventType.indexOf('touch') >= 0;
	        if (!isTouch) {
	            clientToLocal(el, e, e, calculate);
	            var wheelDelta = getWheelDeltaMayPolyfill(e);
	            e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
	        }
	        else {
	            var touch = eventType !== 'touchend'
	                ? e.targetTouches[0]
	                : e.changedTouches[0];
	            touch && clientToLocal(el, touch, e, calculate);
	        }
	        var button = e.button;
	        if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
	            e.which = (button & 1 ? 1 : (button & 2 ? 3 : (button & 4 ? 2 : 0)));
	        }
	        return e;
	    }
	    function getWheelDeltaMayPolyfill(e) {
	        var rawWheelDelta = e.wheelDelta;
	        if (rawWheelDelta) {
	            return rawWheelDelta;
	        }
	        var deltaX = e.deltaX;
	        var deltaY = e.deltaY;
	        if (deltaX == null || deltaY == null) {
	            return rawWheelDelta;
	        }
	        var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
	        var sign = deltaY > 0 ? -1
	            : deltaY < 0 ? 1
	                : deltaX > 0 ? -1
	                    : 1;
	        return 3 * delta * sign;
	    }
	    function addEventListener(el, name, handler, opt) {
	        el.addEventListener(name, handler, opt);
	    }
	    function removeEventListener(el, name, handler, opt) {
	        el.removeEventListener(name, handler, opt);
	    }
	    var stop = function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        e.cancelBubble = true;
	    };
	    function isMiddleOrRightButtonOnMouseUpDown(e) {
	        return e.which === 2 || e.which === 3;
	    }
	
	    var GestureMgr = (function () {
	        function GestureMgr() {
	            this._track = [];
	        }
	        GestureMgr.prototype.recognize = function (event, target, root) {
	            this._doTrack(event, target, root);
	            return this._recognize(event);
	        };
	        GestureMgr.prototype.clear = function () {
	            this._track.length = 0;
	            return this;
	        };
	        GestureMgr.prototype._doTrack = function (event, target, root) {
	            var touches = event.touches;
	            if (!touches) {
	                return;
	            }
	            var trackItem = {
	                points: [],
	                touches: [],
	                target: target,
	                event: event
	            };
	            for (var i = 0, len = touches.length; i < len; i++) {
	                var touch = touches[i];
	                var pos = clientToLocal(root, touch, {});
	                trackItem.points.push([pos.zrX, pos.zrY]);
	                trackItem.touches.push(touch);
	            }
	            this._track.push(trackItem);
	        };
	        GestureMgr.prototype._recognize = function (event) {
	            for (var eventName in recognizers) {
	                if (recognizers.hasOwnProperty(eventName)) {
	                    var gestureInfo = recognizers[eventName](this._track, event);
	                    if (gestureInfo) {
	                        return gestureInfo;
	                    }
	                }
	            }
	        };
	        return GestureMgr;
	    }());
	    function dist$1(pointPair) {
	        var dx = pointPair[1][0] - pointPair[0][0];
	        var dy = pointPair[1][1] - pointPair[0][1];
	        return Math.sqrt(dx * dx + dy * dy);
	    }
	    function center(pointPair) {
	        return [
	            (pointPair[0][0] + pointPair[1][0]) / 2,
	            (pointPair[0][1] + pointPair[1][1]) / 2
	        ];
	    }
	    var recognizers = {
	        pinch: function (tracks, event) {
	            var trackLen = tracks.length;
	            if (!trackLen) {
	                return;
	            }
	            var pinchEnd = (tracks[trackLen - 1] || {}).points;
	            var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
	            if (pinchPre
	                && pinchPre.length > 1
	                && pinchEnd
	                && pinchEnd.length > 1) {
	                var pinchScale = dist$1(pinchEnd) / dist$1(pinchPre);
	                !isFinite(pinchScale) && (pinchScale = 1);
	                event.pinchScale = pinchScale;
	                var pinchCenter = center(pinchEnd);
	                event.pinchX = pinchCenter[0];
	                event.pinchY = pinchCenter[1];
	                return {
	                    type: 'pinch',
	                    target: tracks[0].target,
	                    event: event
	                };
	            }
	        }
	    };
	
	    function create$1() {
	        return [1, 0, 0, 1, 0, 0];
	    }
	    function identity(out) {
	        out[0] = 1;
	        out[1] = 0;
	        out[2] = 0;
	        out[3] = 1;
	        out[4] = 0;
	        out[5] = 0;
	        return out;
	    }
	    function copy$1(out, m) {
	        out[0] = m[0];
	        out[1] = m[1];
	        out[2] = m[2];
	        out[3] = m[3];
	        out[4] = m[4];
	        out[5] = m[5];
	        return out;
	    }
	    function mul$1(out, m1, m2) {
	        var out0 = m1[0] * m2[0] + m1[2] * m2[1];
	        var out1 = m1[1] * m2[0] + m1[3] * m2[1];
	        var out2 = m1[0] * m2[2] + m1[2] * m2[3];
	        var out3 = m1[1] * m2[2] + m1[3] * m2[3];
	        var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
	        var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
	        out[0] = out0;
	        out[1] = out1;
	        out[2] = out2;
	        out[3] = out3;
	        out[4] = out4;
	        out[5] = out5;
	        return out;
	    }
	    function translate(out, a, v) {
	        out[0] = a[0];
	        out[1] = a[1];
	        out[2] = a[2];
	        out[3] = a[3];
	        out[4] = a[4] + v[0];
	        out[5] = a[5] + v[1];
	        return out;
	    }
	    function rotate(out, a, rad) {
	        var aa = a[0];
	        var ac = a[2];
	        var atx = a[4];
	        var ab = a[1];
	        var ad = a[3];
	        var aty = a[5];
	        var st = Math.sin(rad);
	        var ct = Math.cos(rad);
	        out[0] = aa * ct + ab * st;
	        out[1] = -aa * st + ab * ct;
	        out[2] = ac * ct + ad * st;
	        out[3] = -ac * st + ct * ad;
	        out[4] = ct * atx + st * aty;
	        out[5] = ct * aty - st * atx;
	        return out;
	    }
	    function scale$1(out, a, v) {
	        var vx = v[0];
	        var vy = v[1];
	        out[0] = a[0] * vx;
	        out[1] = a[1] * vy;
	        out[2] = a[2] * vx;
	        out[3] = a[3] * vy;
	        out[4] = a[4] * vx;
	        out[5] = a[5] * vy;
	        return out;
	    }
	    function invert(out, a) {
	        var aa = a[0];
	        var ac = a[2];
	        var atx = a[4];
	        var ab = a[1];
	        var ad = a[3];
	        var aty = a[5];
	        var det = aa * ad - ab * ac;
	        if (!det) {
	            return null;
	        }
	        det = 1.0 / det;
	        out[0] = ad * det;
	        out[1] = -ab * det;
	        out[2] = -ac * det;
	        out[3] = aa * det;
	        out[4] = (ac * aty - ad * atx) * det;
	        out[5] = (ab * atx - aa * aty) * det;
	        return out;
	    }
	    function clone$2(a) {
	        var b = create$1();
	        copy$1(b, a);
	        return b;
	    }
	
	    var matrix = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        create: create$1,
	        identity: identity,
	        copy: copy$1,
	        mul: mul$1,
	        translate: translate,
	        rotate: rotate,
	        scale: scale$1,
	        invert: invert,
	        clone: clone$2
	    });
	
	    var Point = (function () {
	        function Point(x, y) {
	            this.x = x || 0;
	            this.y = y || 0;
	        }
	        Point.prototype.copy = function (other) {
	            this.x = other.x;
	            this.y = other.y;
	            return this;
	        };
	        Point.prototype.clone = function () {
	            return new Point(this.x, this.y);
	        };
	        Point.prototype.set = function (x, y) {
	            this.x = x;
	            this.y = y;
	            return this;
	        };
	        Point.prototype.equal = function (other) {
	            return other.x === this.x && other.y === this.y;
	        };
	        Point.prototype.add = function (other) {
	            this.x += other.x;
	            this.y += other.y;
	            return this;
	        };
	        Point.prototype.scale = function (scalar) {
	            this.x *= scalar;
	            this.y *= scalar;
	        };
	        Point.prototype.scaleAndAdd = function (other, scalar) {
	            this.x += other.x * scalar;
	            this.y += other.y * scalar;
	        };
	        Point.prototype.sub = function (other) {
	            this.x -= other.x;
	            this.y -= other.y;
	            return this;
	        };
	        Point.prototype.dot = function (other) {
	            return this.x * other.x + this.y * other.y;
	        };
	        Point.prototype.len = function () {
	            return Math.sqrt(this.x * this.x + this.y * this.y);
	        };
	        Point.prototype.lenSquare = function () {
	            return this.x * this.x + this.y * this.y;
	        };
	        Point.prototype.normalize = function () {
	            var len = this.len();
	            this.x /= len;
	            this.y /= len;
	            return this;
	        };
	        Point.prototype.distance = function (other) {
	            var dx = this.x - other.x;
	            var dy = this.y - other.y;
	            return Math.sqrt(dx * dx + dy * dy);
	        };
	        Point.prototype.distanceSquare = function (other) {
	            var dx = this.x - other.x;
	            var dy = this.y - other.y;
	            return dx * dx + dy * dy;
	        };
	        Point.prototype.negate = function () {
	            this.x = -this.x;
	            this.y = -this.y;
	            return this;
	        };
	        Point.prototype.transform = function (m) {
	            if (!m) {
	                return;
	            }
	            var x = this.x;
	            var y = this.y;
	            this.x = m[0] * x + m[2] * y + m[4];
	            this.y = m[1] * x + m[3] * y + m[5];
	            return this;
	        };
	        Point.prototype.toArray = function (out) {
	            out[0] = this.x;
	            out[1] = this.y;
	            return out;
	        };
	        Point.prototype.fromArray = function (input) {
	            this.x = input[0];
	            this.y = input[1];
	        };
	        Point.set = function (p, x, y) {
	            p.x = x;
	            p.y = y;
	        };
	        Point.copy = function (p, p2) {
	            p.x = p2.x;
	            p.y = p2.y;
	        };
	        Point.len = function (p) {
	            return Math.sqrt(p.x * p.x + p.y * p.y);
	        };
	        Point.lenSquare = function (p) {
	            return p.x * p.x + p.y * p.y;
	        };
	        Point.dot = function (p0, p1) {
	            return p0.x * p1.x + p0.y * p1.y;
	        };
	        Point.add = function (out, p0, p1) {
	            out.x = p0.x + p1.x;
	            out.y = p0.y + p1.y;
	        };
	        Point.sub = function (out, p0, p1) {
	            out.x = p0.x - p1.x;
	            out.y = p0.y - p1.y;
	        };
	        Point.scale = function (out, p0, scalar) {
	            out.x = p0.x * scalar;
	            out.y = p0.y * scalar;
	        };
	        Point.scaleAndAdd = function (out, p0, p1, scalar) {
	            out.x = p0.x + p1.x * scalar;
	            out.y = p0.y + p1.y * scalar;
	        };
	        Point.lerp = function (out, p0, p1, t) {
	            var onet = 1 - t;
	            out.x = onet * p0.x + t * p1.x;
	            out.y = onet * p0.y + t * p1.y;
	        };
	        return Point;
	    }());
	
	    var mathMin = Math.min;
	    var mathMax = Math.max;
	    var lt = new Point();
	    var rb = new Point();
	    var lb = new Point();
	    var rt = new Point();
	    var minTv = new Point();
	    var maxTv = new Point();
	    var BoundingRect = (function () {
	        function BoundingRect(x, y, width, height) {
	            if (width < 0) {
	                x = x + width;
	                width = -width;
	            }
	            if (height < 0) {
	                y = y + height;
	                height = -height;
	            }
	            this.x = x;
	            this.y = y;
	            this.width = width;
	            this.height = height;
	        }
	        BoundingRect.prototype.union = function (other) {
	            var x = mathMin(other.x, this.x);
	            var y = mathMin(other.y, this.y);
	            if (isFinite(this.x) && isFinite(this.width)) {
	                this.width = mathMax(other.x + other.width, this.x + this.width) - x;
	            }
	            else {
	                this.width = other.width;
	            }
	            if (isFinite(this.y) && isFinite(this.height)) {
	                this.height = mathMax(other.y + other.height, this.y + this.height) - y;
	            }
	            else {
	                this.height = other.height;
	            }
	            this.x = x;
	            this.y = y;
	        };
	        BoundingRect.prototype.applyTransform = function (m) {
	            BoundingRect.applyTransform(this, this, m);
	        };
	        BoundingRect.prototype.calculateTransform = function (b) {
	            var a = this;
	            var sx = b.width / a.width;
	            var sy = b.height / a.height;
	            var m = create$1();
	            translate(m, m, [-a.x, -a.y]);
	            scale$1(m, m, [sx, sy]);
	            translate(m, m, [b.x, b.y]);
	            return m;
	        };
	        BoundingRect.prototype.intersect = function (b, mtv) {
	            if (!b) {
	                return false;
	            }
	            if (!(b instanceof BoundingRect)) {
	                b = BoundingRect.create(b);
	            }
	            var a = this;
	            var ax0 = a.x;
	            var ax1 = a.x + a.width;
	            var ay0 = a.y;
	            var ay1 = a.y + a.height;
	            var bx0 = b.x;
	            var bx1 = b.x + b.width;
	            var by0 = b.y;
	            var by1 = b.y + b.height;
	            var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
	            if (mtv) {
	                var dMin = Infinity;
	                var dMax = 0;
	                var d0 = Math.abs(ax1 - bx0);
	                var d1 = Math.abs(bx1 - ax0);
	                var d2 = Math.abs(ay1 - by0);
	                var d3 = Math.abs(by1 - ay0);
	                var dx = Math.min(d0, d1);
	                var dy = Math.min(d2, d3);
	                if (ax1 < bx0 || bx1 < ax0) {
	                    if (dx > dMax) {
	                        dMax = dx;
	                        if (d0 < d1) {
	                            Point.set(maxTv, -d0, 0);
	                        }
	                        else {
	                            Point.set(maxTv, d1, 0);
	                        }
	                    }
	                }
	                else {
	                    if (dx < dMin) {
	                        dMin = dx;
	                        if (d0 < d1) {
	                            Point.set(minTv, d0, 0);
	                        }
	                        else {
	                            Point.set(minTv, -d1, 0);
	                        }
	                    }
	                }
	                if (ay1 < by0 || by1 < ay0) {
	                    if (dy > dMax) {
	                        dMax = dy;
	                        if (d2 < d3) {
	                            Point.set(maxTv, 0, -d2);
	                        }
	                        else {
	                            Point.set(maxTv, 0, d3);
	                        }
	                    }
	                }
	                else {
	                    if (dx < dMin) {
	                        dMin = dx;
	                        if (d2 < d3) {
	                            Point.set(minTv, 0, d2);
	                        }
	                        else {
	                            Point.set(minTv, 0, -d3);
	                        }
	                    }
	                }
	            }
	            if (mtv) {
	                Point.copy(mtv, overlap ? minTv : maxTv);
	            }
	            return overlap;
	        };
	        BoundingRect.prototype.contain = function (x, y) {
	            var rect = this;
	            return x >= rect.x
	                && x <= (rect.x + rect.width)
	                && y >= rect.y
	                && y <= (rect.y + rect.height);
	        };
	        BoundingRect.prototype.clone = function () {
	            return new BoundingRect(this.x, this.y, this.width, this.height);
	        };
	        BoundingRect.prototype.copy = function (other) {
	            BoundingRect.copy(this, other);
	        };
	        BoundingRect.prototype.plain = function () {
	            return {
	                x: this.x,
	                y: this.y,
	                width: this.width,
	                height: this.height
	            };
	        };
	        BoundingRect.prototype.isFinite = function () {
	            return isFinite(this.x)
	                && isFinite(this.y)
	                && isFinite(this.width)
	                && isFinite(this.height);
	        };
	        BoundingRect.prototype.isZero = function () {
	            return this.width === 0 || this.height === 0;
	        };
	        BoundingRect.create = function (rect) {
	            return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
	        };
	        BoundingRect.copy = function (target, source) {
	            target.x = source.x;
	            target.y = source.y;
	            target.width = source.width;
	            target.height = source.height;
	        };
	        BoundingRect.applyTransform = function (target, source, m) {
	            if (!m) {
	                if (target !== source) {
	                    BoundingRect.copy(target, source);
	                }
	                return;
	            }
	            if (m[1] < 1e-5 && m[1] > -1e-5 && m[2] < 1e-5 && m[2] > -1e-5) {
	                var sx = m[0];
	                var sy = m[3];
	                var tx = m[4];
	                var ty = m[5];
	                target.x = source.x * sx + tx;
	                target.y = source.y * sy + ty;
	                target.width = source.width * sx;
	                target.height = source.height * sy;
	                if (target.width < 0) {
	                    target.x += target.width;
	                    target.width = -target.width;
	                }
	                if (target.height < 0) {
	                    target.y += target.height;
	                    target.height = -target.height;
	                }
	                return;
	            }
	            lt.x = lb.x = source.x;
	            lt.y = rt.y = source.y;
	            rb.x = rt.x = source.x + source.width;
	            rb.y = lb.y = source.y + source.height;
	            lt.transform(m);
	            rt.transform(m);
	            rb.transform(m);
	            lb.transform(m);
	            target.x = mathMin(lt.x, rb.x, lb.x, rt.x);
	            target.y = mathMin(lt.y, rb.y, lb.y, rt.y);
	            var maxX = mathMax(lt.x, rb.x, lb.x, rt.x);
	            var maxY = mathMax(lt.y, rb.y, lb.y, rt.y);
	            target.width = maxX - target.x;
	            target.height = maxY - target.y;
	        };
	        return BoundingRect;
	    }());
	
	    var SILENT = 'silent';
	    function makeEventPacket(eveType, targetInfo, event) {
	        return {
	            type: eveType,
	            event: event,
	            target: targetInfo.target,
	            topTarget: targetInfo.topTarget,
	            cancelBubble: false,
	            offsetX: event.zrX,
	            offsetY: event.zrY,
	            gestureEvent: event.gestureEvent,
	            pinchX: event.pinchX,
	            pinchY: event.pinchY,
	            pinchScale: event.pinchScale,
	            wheelDelta: event.zrDelta,
	            zrByTouch: event.zrByTouch,
	            which: event.which,
	            stop: stopEvent
	        };
	    }
	    function stopEvent() {
	        stop(this.event);
	    }
	    var EmptyProxy = (function (_super) {
	        __extends(EmptyProxy, _super);
	        function EmptyProxy() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.handler = null;
	            return _this;
	        }
	        EmptyProxy.prototype.dispose = function () { };
	        EmptyProxy.prototype.setCursor = function () { };
	        return EmptyProxy;
	    }(Eventful));
	    var HoveredResult = (function () {
	        function HoveredResult(x, y) {
	            this.x = x;
	            this.y = y;
	        }
	        return HoveredResult;
	    }());
	    var handlerNames = [
	        'click', 'dblclick', 'mousewheel', 'mouseout',
	        'mouseup', 'mousedown', 'mousemove', 'contextmenu'
	    ];
	    var tmpRect = new BoundingRect(0, 0, 0, 0);
	    var Handler = (function (_super) {
	        __extends(Handler, _super);
	        function Handler(storage, painter, proxy, painterRoot, pointerSize) {
	            var _this = _super.call(this) || this;
	            _this._hovered = new HoveredResult(0, 0);
	            _this.storage = storage;
	            _this.painter = painter;
	            _this.painterRoot = painterRoot;
	            _this._pointerSize = pointerSize;
	            proxy = proxy || new EmptyProxy();
	            _this.proxy = null;
	            _this.setHandlerProxy(proxy);
	            _this._draggingMgr = new Draggable(_this);
	            return _this;
	        }
	        Handler.prototype.setHandlerProxy = function (proxy) {
	            if (this.proxy) {
	                this.proxy.dispose();
	            }
	            if (proxy) {
	                each(handlerNames, function (name) {
	                    proxy.on && proxy.on(name, this[name], this);
	                }, this);
	                proxy.handler = this;
	            }
	            this.proxy = proxy;
	        };
	        Handler.prototype.mousemove = function (event) {
	            var x = event.zrX;
	            var y = event.zrY;
	            var isOutside = isOutsideBoundary(this, x, y);
	            var lastHovered = this._hovered;
	            var lastHoveredTarget = lastHovered.target;
	            if (lastHoveredTarget && !lastHoveredTarget.__zr) {
	                lastHovered = this.findHover(lastHovered.x, lastHovered.y);
	                lastHoveredTarget = lastHovered.target;
	            }
	            var hovered = this._hovered = isOutside ? new HoveredResult(x, y) : this.findHover(x, y);
	            var hoveredTarget = hovered.target;
	            var proxy = this.proxy;
	            proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
	            if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
	                this.dispatchToElement(lastHovered, 'mouseout', event);
	            }
	            this.dispatchToElement(hovered, 'mousemove', event);
	            if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
	                this.dispatchToElement(hovered, 'mouseover', event);
	            }
	        };
	        Handler.prototype.mouseout = function (event) {
	            var eventControl = event.zrEventControl;
	            if (eventControl !== 'only_globalout') {
	                this.dispatchToElement(this._hovered, 'mouseout', event);
	            }
	            if (eventControl !== 'no_globalout') {
	                this.trigger('globalout', { type: 'globalout', event: event });
	            }
	        };
	        Handler.prototype.resize = function () {
	            this._hovered = new HoveredResult(0, 0);
	        };
	        Handler.prototype.dispatch = function (eventName, eventArgs) {
	            var handler = this[eventName];
	            handler && handler.call(this, eventArgs);
	        };
	        Handler.prototype.dispose = function () {
	            this.proxy.dispose();
	            this.storage = null;
	            this.proxy = null;
	            this.painter = null;
	        };
	        Handler.prototype.setCursorStyle = function (cursorStyle) {
	            var proxy = this.proxy;
	            proxy.setCursor && proxy.setCursor(cursorStyle);
	        };
	        Handler.prototype.dispatchToElement = function (targetInfo, eventName, event) {
	            targetInfo = targetInfo || {};
	            var el = targetInfo.target;
	            if (el && el.silent) {
	                return;
	            }
	            var eventKey = ('on' + eventName);
	            var eventPacket = makeEventPacket(eventName, targetInfo, event);
	            while (el) {
	                el[eventKey]
	                    && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
	                el.trigger(eventName, eventPacket);
	                el = el.__hostTarget ? el.__hostTarget : el.parent;
	                if (eventPacket.cancelBubble) {
	                    break;
	                }
	            }
	            if (!eventPacket.cancelBubble) {
	                this.trigger(eventName, eventPacket);
	                if (this.painter && this.painter.eachOtherLayer) {
	                    this.painter.eachOtherLayer(function (layer) {
	                        if (typeof (layer[eventKey]) === 'function') {
	                            layer[eventKey].call(layer, eventPacket);
	                        }
	                        if (layer.trigger) {
	                            layer.trigger(eventName, eventPacket);
	                        }
	                    });
	                }
	            }
	        };
	        Handler.prototype.findHover = function (x, y, exclude) {
	            var list = this.storage.getDisplayList();
	            var out = new HoveredResult(x, y);
	            setHoverTarget(list, out, x, y, exclude);
	            if (this._pointerSize && !out.target) {
	                var candidates = [];
	                var pointerSize = this._pointerSize;
	                var targetSizeHalf = pointerSize / 2;
	                var pointerRect = new BoundingRect(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
	                for (var i = list.length - 1; i >= 0; i--) {
	                    var el = list[i];
	                    if (el !== exclude
	                        && !el.ignore
	                        && !el.ignoreCoarsePointer
	                        && (!el.parent || !el.parent.ignoreCoarsePointer)) {
	                        tmpRect.copy(el.getBoundingRect());
	                        if (el.transform) {
	                            tmpRect.applyTransform(el.transform);
	                        }
	                        if (tmpRect.intersect(pointerRect)) {
	                            candidates.push(el);
	                        }
	                    }
	                }
	                if (candidates.length) {
	                    var rStep = 4;
	                    var thetaStep = Math.PI / 12;
	                    var PI2 = Math.PI * 2;
	                    for (var r = 0; r < targetSizeHalf; r += rStep) {
	                        for (var theta = 0; theta < PI2; theta += thetaStep) {
	                            var x1 = x + r * Math.cos(theta);
	                            var y1 = y + r * Math.sin(theta);
	                            setHoverTarget(candidates, out, x1, y1, exclude);
	                            if (out.target) {
	                                return out;
	                            }
	                        }
	                    }
	                }
	            }
	            return out;
	        };
	        Handler.prototype.processGesture = function (event, stage) {
	            if (!this._gestureMgr) {
	                this._gestureMgr = new GestureMgr();
	            }
	            var gestureMgr = this._gestureMgr;
	            stage === 'start' && gestureMgr.clear();
	            var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
	            stage === 'end' && gestureMgr.clear();
	            if (gestureInfo) {
	                var type = gestureInfo.type;
	                event.gestureEvent = type;
	                var res = new HoveredResult();
	                res.target = gestureInfo.target;
	                this.dispatchToElement(res, type, gestureInfo.event);
	            }
	        };
	        return Handler;
	    }(Eventful));
	    each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	        Handler.prototype[name] = function (event) {
	            var x = event.zrX;
	            var y = event.zrY;
	            var isOutside = isOutsideBoundary(this, x, y);
	            var hovered;
	            var hoveredTarget;
	            if (name !== 'mouseup' || !isOutside) {
	                hovered = this.findHover(x, y);
	                hoveredTarget = hovered.target;
	            }
	            if (name === 'mousedown') {
	                this._downEl = hoveredTarget;
	                this._downPoint = [event.zrX, event.zrY];
	                this._upEl = hoveredTarget;
	            }
	            else if (name === 'mouseup') {
	                this._upEl = hoveredTarget;
	            }
	            else if (name === 'click') {
	                if (this._downEl !== this._upEl
	                    || !this._downPoint
	                    || dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
	                    return;
	                }
	                this._downPoint = null;
	            }
	            this.dispatchToElement(hovered, name, event);
	        };
	    });
	    function isHover(displayable, x, y) {
	        if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
	            var el = displayable;
	            var isSilent = void 0;
	            var ignoreClip = false;
	            while (el) {
	                if (el.ignoreClip) {
	                    ignoreClip = true;
	                }
	                if (!ignoreClip) {
	                    var clipPath = el.getClipPath();
	                    if (clipPath && !clipPath.contain(x, y)) {
	                        return false;
	                    }
	                    if (el.silent) {
	                        isSilent = true;
	                    }
	                }
	                var hostEl = el.__hostTarget;
	                el = hostEl ? hostEl : el.parent;
	            }
	            return isSilent ? SILENT : true;
	        }
	        return false;
	    }
	    function setHoverTarget(list, out, x, y, exclude) {
	        for (var i = list.length - 1; i >= 0; i--) {
	            var el = list[i];
	            var hoverCheckResult = void 0;
	            if (el !== exclude
	                && !el.ignore
	                && (hoverCheckResult = isHover(el, x, y))) {
	                !out.topTarget && (out.topTarget = el);
	                if (hoverCheckResult !== SILENT) {
	                    out.target = el;
	                    break;
	                }
	            }
	        }
	    }
	    function isOutsideBoundary(handlerInstance, x, y) {
	        var painter = handlerInstance.painter;
	        return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
	    }
	
	    var DEFAULT_MIN_MERGE = 32;
	    var DEFAULT_MIN_GALLOPING = 7;
	    function minRunLength(n) {
	        var r = 0;
	        while (n >= DEFAULT_MIN_MERGE) {
	            r |= n & 1;
	            n >>= 1;
	        }
	        return n + r;
	    }
	    function makeAscendingRun(array, lo, hi, compare) {
	        var runHi = lo + 1;
	        if (runHi === hi) {
	            return 1;
	        }
	        if (compare(array[runHi++], array[lo]) < 0) {
	            while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
	                runHi++;
	            }
	            reverseRun(array, lo, runHi);
	        }
	        else {
	            while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
	                runHi++;
	            }
	        }
	        return runHi - lo;
	    }
	    function reverseRun(array, lo, hi) {
	        hi--;
	        while (lo < hi) {
	            var t = array[lo];
	            array[lo++] = array[hi];
	            array[hi--] = t;
	        }
	    }
	    function binaryInsertionSort(array, lo, hi, start, compare) {
	        if (start === lo) {
	            start++;
	        }
	        for (; start < hi; start++) {
	            var pivot = array[start];
	            var left = lo;
	            var right = start;
	            var mid;
	            while (left < right) {
	                mid = left + right >>> 1;
	                if (compare(pivot, array[mid]) < 0) {
	                    right = mid;
	                }
	                else {
	                    left = mid + 1;
	                }
	            }
	            var n = start - left;
	            switch (n) {
	                case 3:
	                    array[left + 3] = array[left + 2];
	                case 2:
	                    array[left + 2] = array[left + 1];
	                case 1:
	                    array[left + 1] = array[left];
	                    break;
	                default:
	                    while (n > 0) {
	                        array[left + n] = array[left + n - 1];
	                        n--;
	                    }
	            }
	            array[left] = pivot;
	        }
	    }
	    function gallopLeft(value, array, start, length, hint, compare) {
	        var lastOffset = 0;
	        var maxOffset = 0;
	        var offset = 1;
	        if (compare(value, array[start + hint]) > 0) {
	            maxOffset = length - hint;
	            while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
	                lastOffset = offset;
	                offset = (offset << 1) + 1;
	                if (offset <= 0) {
	                    offset = maxOffset;
	                }
	            }
	            if (offset > maxOffset) {
	                offset = maxOffset;
	            }
	            lastOffset += hint;
	            offset += hint;
	        }
	        else {
	            maxOffset = hint + 1;
	            while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
	                lastOffset = offset;
	                offset = (offset << 1) + 1;
	                if (offset <= 0) {
	                    offset = maxOffset;
	                }
	            }
	            if (offset > maxOffset) {
	                offset = maxOffset;
	            }
	            var tmp = lastOffset;
	            lastOffset = hint - offset;
	            offset = hint - tmp;
	        }
	        lastOffset++;
	        while (lastOffset < offset) {
	            var m = lastOffset + (offset - lastOffset >>> 1);
	            if (compare(value, array[start + m]) > 0) {
	                lastOffset = m + 1;
	            }
	            else {
	                offset = m;
	            }
	        }
	        return offset;
	    }
	    function gallopRight(value, array, start, length, hint, compare) {
	        var lastOffset = 0;
	        var maxOffset = 0;
	        var offset = 1;
	        if (compare(value, array[start + hint]) < 0) {
	            maxOffset = hint + 1;
	            while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
	                lastOffset = offset;
	                offset = (offset << 1) + 1;
	                if (offset <= 0) {
	                    offset = maxOffset;
	                }
	            }
	            if (offset > maxOffset) {
	                offset = maxOffset;
	            }
	            var tmp = lastOffset;
	            lastOffset = hint - offset;
	            offset = hint - tmp;
	        }
	        else {
	            maxOffset = length - hint;
	            while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
	                lastOffset = offset;
	                offset = (offset << 1) + 1;
	                if (offset <= 0) {
	                    offset = maxOffset;
	                }
	            }
	            if (offset > maxOffset) {
	                offset = maxOffset;
	            }
	            lastOffset += hint;
	            offset += hint;
	        }
	        lastOffset++;
	        while (lastOffset < offset) {
	            var m = lastOffset + (offset - lastOffset >>> 1);
	            if (compare(value, array[start + m]) < 0) {
	                offset = m;
	            }
	            else {
	                lastOffset = m + 1;
	            }
	        }
	        return offset;
	    }
	    function TimSort(array, compare) {
	        var minGallop = DEFAULT_MIN_GALLOPING;
	        var length = 0;
	        var runStart;
	        var runLength;
	        var stackSize = 0;
	        length = array.length;
	        var tmp = [];
	        runStart = [];
	        runLength = [];
	        function pushRun(_runStart, _runLength) {
	            runStart[stackSize] = _runStart;
	            runLength[stackSize] = _runLength;
	            stackSize += 1;
	        }
	        function mergeRuns() {
	            while (stackSize > 1) {
	                var n = stackSize - 2;
	                if ((n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1])
	                    || (n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1])) {
	                    if (runLength[n - 1] < runLength[n + 1]) {
	                        n--;
	                    }
	                }
	                else if (runLength[n] > runLength[n + 1]) {
	                    break;
	                }
	                mergeAt(n);
	            }
	        }
	        function forceMergeRuns() {
	            while (stackSize > 1) {
	                var n = stackSize - 2;
	                if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
	                    n--;
	                }
	                mergeAt(n);
	            }
	        }
	        function mergeAt(i) {
	            var start1 = runStart[i];
	            var length1 = runLength[i];
	            var start2 = runStart[i + 1];
	            var length2 = runLength[i + 1];
	            runLength[i] = length1 + length2;
	            if (i === stackSize - 3) {
	                runStart[i + 1] = runStart[i + 2];
	                runLength[i + 1] = runLength[i + 2];
	            }
	            stackSize--;
	            var k = gallopRight(array[start2], array, start1, length1, 0, compare);
	            start1 += k;
	            length1 -= k;
	            if (length1 === 0) {
	                return;
	            }
	            length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
	            if (length2 === 0) {
	                return;
	            }
	            if (length1 <= length2) {
	                mergeLow(start1, length1, start2, length2);
	            }
	            else {
	                mergeHigh(start1, length1, start2, length2);
	            }
	        }
	        function mergeLow(start1, length1, start2, length2) {
	            var i = 0;
	            for (i = 0; i < length1; i++) {
	                tmp[i] = array[start1 + i];
	            }
	            var cursor1 = 0;
	            var cursor2 = start2;
	            var dest = start1;
	            array[dest++] = array[cursor2++];
	            if (--length2 === 0) {
	                for (i = 0; i < length1; i++) {
	                    array[dest + i] = tmp[cursor1 + i];
	                }
	                return;
	            }
	            if (length1 === 1) {
	                for (i = 0; i < length2; i++) {
	                    array[dest + i] = array[cursor2 + i];
	                }
	                array[dest + length2] = tmp[cursor1];
	                return;
	            }
	            var _minGallop = minGallop;
	            var count1;
	            var count2;
	            var exit;
	            while (1) {
	                count1 = 0;
	                count2 = 0;
	                exit = false;
	                do {
	                    if (compare(array[cursor2], tmp[cursor1]) < 0) {
	                        array[dest++] = array[cursor2++];
	                        count2++;
	                        count1 = 0;
	                        if (--length2 === 0) {
	                            exit = true;
	                            break;
	                        }
	                    }
	                    else {
	                        array[dest++] = tmp[cursor1++];
	                        count1++;
	                        count2 = 0;
	                        if (--length1 === 1) {
	                            exit = true;
	                            break;
	                        }
	                    }
	                } while ((count1 | count2) < _minGallop);
	                if (exit) {
	                    break;
	                }
	                do {
	                    count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
	                    if (count1 !== 0) {
	                        for (i = 0; i < count1; i++) {
	                            array[dest + i] = tmp[cursor1 + i];
	                        }
	                        dest += count1;
	                        cursor1 += count1;
	                        length1 -= count1;
	                        if (length1 <= 1) {
	                            exit = true;
	                            break;
	                        }
	                    }
	                    array[dest++] = array[cursor2++];
	                    if (--length2 === 0) {
	                        exit = true;
	                        break;
	                    }
	                    count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
	                    if (count2 !== 0) {
	                        for (i = 0; i < count2; i++) {
	                            array[dest + i] = array[cursor2 + i];
	                        }
	                        dest += count2;
	                        cursor2 += count2;
	                        length2 -= count2;
	                        if (length2 === 0) {
	                            exit = true;
	                            break;
	                        }
	                    }
	                    array[dest++] = tmp[cursor1++];
	                    if (--length1 === 1) {
	                        exit = true;
	                        break;
	                    }
	                    _minGallop--;
	                } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	                if (exit) {
	                    break;
	                }
	                if (_minGallop < 0) {
	                    _minGallop = 0;
	                }
	                _minGallop += 2;
	            }
	            minGallop = _minGallop;
	            minGallop < 1 && (minGallop = 1);
	            if (length1 === 1) {
	                for (i = 0; i < length2; i++) {
	                    array[dest + i] = array[cursor2 + i];
	                }
	                array[dest + length2] = tmp[cursor1];
	            }
	            else if (length1 === 0) {
	                throw new Error();
	            }
	            else {
	                for (i = 0; i < length1; i++) {
	                    array[dest + i] = tmp[cursor1 + i];
	                }
	            }
	        }
	        function mergeHigh(start1, length1, start2, length2) {
	            var i = 0;
	            for (i = 0; i < length2; i++) {
	                tmp[i] = array[start2 + i];
	            }
	            var cursor1 = start1 + length1 - 1;
	            var cursor2 = length2 - 1;
	            var dest = start2 + length2 - 1;
	            var customCursor = 0;
	            var customDest = 0;
	            array[dest--] = array[cursor1--];
	            if (--length1 === 0) {
	                customCursor = dest - (length2 - 1);
	                for (i = 0; i < length2; i++) {
	                    array[customCursor + i] = tmp[i];
	                }
	                return;
	            }
	            if (length2 === 1) {
	                dest -= length1;
	                cursor1 -= length1;
	                customDest = dest + 1;
	                customCursor = cursor1 + 1;
	                for (i = length1 - 1; i >= 0; i--) {
	                    array[customDest + i] = array[customCursor + i];
	                }
	                array[dest] = tmp[cursor2];
	                return;
	            }
	            var _minGallop = minGallop;
	            while (true) {
	                var count1 = 0;
	                var count2 = 0;
	                var exit = false;
	                do {
	                    if (compare(tmp[cursor2], array[cursor1]) < 0) {
	                        array[dest--] = array[cursor1--];
	                        count1++;
	                        count2 = 0;
	                        if (--length1 === 0) {
	                            exit = true;
	                            break;
	                        }
	                    }
	                    else {
	                        array[dest--] = tmp[cursor2--];
	                        count2++;
	                        count1 = 0;
	                        if (--length2 === 1) {
	                            exit = true;
	                            break;
	                        }
	                    }
	                } while ((count1 | count2) < _minGallop);
	                if (exit) {
	                    break;
	                }
	                do {
	                    count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
	                    if (count1 !== 0) {
	                        dest -= count1;
	                        cursor1 -= count1;
	                        length1 -= count1;
	                        customDest = dest + 1;
	                        customCursor = cursor1 + 1;
	                        for (i = count1 - 1; i >= 0; i--) {
	                            array[customDest + i] = array[customCursor + i];
	                        }
	                        if (length1 === 0) {
	                            exit = true;
	                            break;
	                        }
	                    }
	                    array[dest--] = tmp[cursor2--];
	                    if (--length2 === 1) {
	                        exit = true;
	                        break;
	                    }
	                    count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
	                    if (count2 !== 0) {
	                        dest -= count2;
	                        cursor2 -= count2;
	                        length2 -= count2;
	                        customDest = dest + 1;
	                        customCursor = cursor2 + 1;
	                        for (i = 0; i < count2; i++) {
	                            array[customDest + i] = tmp[customCursor + i];
	                        }
	                        if (length2 <= 1) {
	                            exit = true;
	                            break;
	                        }
	                    }
	                    array[dest--] = array[cursor1--];
	                    if (--length1 === 0) {
	                        exit = true;
	                        break;
	                    }
	                    _minGallop--;
	                } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	                if (exit) {
	                    break;
	                }
	                if (_minGallop < 0) {
	                    _minGallop = 0;
	                }
	                _minGallop += 2;
	            }
	            minGallop = _minGallop;
	            if (minGallop < 1) {
	                minGallop = 1;
	            }
	            if (length2 === 1) {
	                dest -= length1;
	                cursor1 -= length1;
	                customDest = dest + 1;
	                customCursor = cursor1 + 1;
	                for (i = length1 - 1; i >= 0; i--) {
	                    array[customDest + i] = array[customCursor + i];
	                }
	                array[dest] = tmp[cursor2];
	            }
	            else if (length2 === 0) {
	                throw new Error();
	            }
	            else {
	                customCursor = dest - (length2 - 1);
	                for (i = 0; i < length2; i++) {
	                    array[customCursor + i] = tmp[i];
	                }
	            }
	        }
	        return {
	            mergeRuns: mergeRuns,
	            forceMergeRuns: forceMergeRuns,
	            pushRun: pushRun
	        };
	    }
	    function sort(array, compare, lo, hi) {
	        if (!lo) {
	            lo = 0;
	        }
	        if (!hi) {
	            hi = array.length;
	        }
	        var remaining = hi - lo;
	        if (remaining < 2) {
	            return;
	        }
	        var runLength = 0;
	        if (remaining < DEFAULT_MIN_MERGE) {
	            runLength = makeAscendingRun(array, lo, hi, compare);
	            binaryInsertionSort(array, lo, hi, lo + runLength, compare);
	            return;
	        }
	        var ts = TimSort(array, compare);
	        var minRun = minRunLength(remaining);
	        do {
	            runLength = makeAscendingRun(array, lo, hi, compare);
	            if (runLength < minRun) {
	                var force = remaining;
	                if (force > minRun) {
	                    force = minRun;
	                }
	                binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
	                runLength = force;
	            }
	            ts.pushRun(lo, runLength);
	            ts.mergeRuns();
	            remaining -= runLength;
	            lo += runLength;
	        } while (remaining !== 0);
	        ts.forceMergeRuns();
	    }
	
	    var REDRAW_BIT = 1;
	    var STYLE_CHANGED_BIT = 2;
	    var SHAPE_CHANGED_BIT = 4;
	
	    var invalidZErrorLogged = false;
	    function logInvalidZError() {
	        if (invalidZErrorLogged) {
	            return;
	        }
	        invalidZErrorLogged = true;
	        console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
	    }
	    function shapeCompareFunc(a, b) {
	        if (a.zlevel === b.zlevel) {
	            if (a.z === b.z) {
	                return a.z2 - b.z2;
	            }
	            return a.z - b.z;
	        }
	        return a.zlevel - b.zlevel;
	    }
	    var Storage = (function () {
	        function Storage() {
	            this._roots = [];
	            this._displayList = [];
	            this._displayListLen = 0;
	            this.displayableSortFunc = shapeCompareFunc;
	        }
	        Storage.prototype.traverse = function (cb, context) {
	            for (var i = 0; i < this._roots.length; i++) {
	                this._roots[i].traverse(cb, context);
	            }
	        };
	        Storage.prototype.getDisplayList = function (update, includeIgnore) {
	            includeIgnore = includeIgnore || false;
	            var displayList = this._displayList;
	            if (update || !displayList.length) {
	                this.updateDisplayList(includeIgnore);
	            }
	            return displayList;
	        };
	        Storage.prototype.updateDisplayList = function (includeIgnore) {
	            this._displayListLen = 0;
	            var roots = this._roots;
	            var displayList = this._displayList;
	            for (var i = 0, len = roots.length; i < len; i++) {
	                this._updateAndAddDisplayable(roots[i], null, includeIgnore);
	            }
	            displayList.length = this._displayListLen;
	            sort(displayList, shapeCompareFunc);
	        };
	        Storage.prototype._updateAndAddDisplayable = function (el, clipPaths, includeIgnore) {
	            if (el.ignore && !includeIgnore) {
	                return;
	            }
	            el.beforeUpdate();
	            el.update();
	            el.afterUpdate();
	            var userSetClipPath = el.getClipPath();
	            if (el.ignoreClip) {
	                clipPaths = null;
	            }
	            else if (userSetClipPath) {
	                if (clipPaths) {
	                    clipPaths = clipPaths.slice();
	                }
	                else {
	                    clipPaths = [];
	                }
	                var currentClipPath = userSetClipPath;
	                var parentClipPath = el;
	                while (currentClipPath) {
	                    currentClipPath.parent = parentClipPath;
	                    currentClipPath.updateTransform();
	                    clipPaths.push(currentClipPath);
	                    parentClipPath = currentClipPath;
	                    currentClipPath = currentClipPath.getClipPath();
	                }
	            }
	            if (el.childrenRef) {
	                var children = el.childrenRef();
	                for (var i = 0; i < children.length; i++) {
	                    var child = children[i];
	                    if (el.__dirty) {
	                        child.__dirty |= REDRAW_BIT;
	                    }
	                    this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
	                }
	                el.__dirty = 0;
	            }
	            else {
	                var disp = el;
	                if (clipPaths && clipPaths.length) {
	                    disp.__clipPaths = clipPaths;
	                }
	                else if (disp.__clipPaths && disp.__clipPaths.length > 0) {
	                    disp.__clipPaths = [];
	                }
	                if (isNaN(disp.z)) {
	                    logInvalidZError();
	                    disp.z = 0;
	                }
	                if (isNaN(disp.z2)) {
	                    logInvalidZError();
	                    disp.z2 = 0;
	                }
	                if (isNaN(disp.zlevel)) {
	                    logInvalidZError();
	                    disp.zlevel = 0;
	                }
	                this._displayList[this._displayListLen++] = disp;
	            }
	            var decalEl = el.getDecalElement && el.getDecalElement();
	            if (decalEl) {
	                this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
	            }
	            var textGuide = el.getTextGuideLine();
	            if (textGuide) {
	                this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
	            }
	            var textEl = el.getTextContent();
	            if (textEl) {
	                this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
	            }
	        };
	        Storage.prototype.addRoot = function (el) {
	            if (el.__zr && el.__zr.storage === this) {
	                return;
	            }
	            this._roots.push(el);
	        };
	        Storage.prototype.delRoot = function (el) {
	            if (el instanceof Array) {
	                for (var i = 0, l = el.length; i < l; i++) {
	                    this.delRoot(el[i]);
	                }
	                return;
	            }
	            var idx = indexOf(this._roots, el);
	            if (idx >= 0) {
	                this._roots.splice(idx, 1);
	            }
	        };
	        Storage.prototype.delAllRoots = function () {
	            this._roots = [];
	            this._displayList = [];
	            this._displayListLen = 0;
	            return;
	        };
	        Storage.prototype.getRoots = function () {
	            return this._roots;
	        };
	        Storage.prototype.dispose = function () {
	            this._displayList = null;
	            this._roots = null;
	        };
	        return Storage;
	    }());
	
	    var requestAnimationFrame;
	    requestAnimationFrame = (env.hasGlobalWindow
	        && ((window.requestAnimationFrame && window.requestAnimationFrame.bind(window))
	            || (window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window))
	            || window.mozRequestAnimationFrame
	            || window.webkitRequestAnimationFrame)) || function (func) {
	        return setTimeout(func, 16);
	    };
	    var requestAnimationFrame$1 = requestAnimationFrame;
	
	    var easingFuncs = {
	        linear: function (k) {
	            return k;
	        },
	        quadraticIn: function (k) {
	            return k * k;
	        },
	        quadraticOut: function (k) {
	            return k * (2 - k);
	        },
	        quadraticInOut: function (k) {
	            if ((k *= 2) < 1) {
	                return 0.5 * k * k;
	            }
	            return -0.5 * (--k * (k - 2) - 1);
	        },
	        cubicIn: function (k) {
	            return k * k * k;
	        },
	        cubicOut: function (k) {
	            return --k * k * k + 1;
	        },
	        cubicInOut: function (k) {
	            if ((k *= 2) < 1) {
	                return 0.5 * k * k * k;
	            }
	            return 0.5 * ((k -= 2) * k * k + 2);
	        },
	        quarticIn: function (k) {
	            return k * k * k * k;
	        },
	        quarticOut: function (k) {
	            return 1 - (--k * k * k * k);
	        },
	        quarticInOut: function (k) {
	            if ((k *= 2) < 1) {
	                return 0.5 * k * k * k * k;
	            }
	            return -0.5 * ((k -= 2) * k * k * k - 2);
	        },
	        quinticIn: function (k) {
	            return k * k * k * k * k;
	        },
	        quinticOut: function (k) {
	            return --k * k * k * k * k + 1;
	        },
	        quinticInOut: function (k) {
	            if ((k *= 2) < 1) {
	                return 0.5 * k * k * k * k * k;
	            }
	            return 0.5 * ((k -= 2) * k * k * k * k + 2);
	        },
	        sinusoidalIn: function (k) {
	            return 1 - Math.cos(k * Math.PI / 2);
	        },
	        sinusoidalOut: function (k) {
	            return Math.sin(k * Math.PI / 2);
	        },
	        sinusoidalInOut: function (k) {
	            return 0.5 * (1 - Math.cos(Math.PI * k));
	        },
	        exponentialIn: function (k) {
	            return k === 0 ? 0 : Math.pow(1024, k - 1);
	        },
	        exponentialOut: function (k) {
	            return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
	        },
	        exponentialInOut: function (k) {
	            if (k === 0) {
	                return 0;
	            }
	            if (k === 1) {
	                return 1;
	            }
	            if ((k *= 2) < 1) {
	                return 0.5 * Math.pow(1024, k - 1);
	            }
	            return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
	        },
	        circularIn: function (k) {
	            return 1 - Math.sqrt(1 - k * k);
	        },
	        circularOut: function (k) {
	            return Math.sqrt(1 - (--k * k));
	        },
	        circularInOut: function (k) {
	            if ((k *= 2) < 1) {
	                return -0.5 * (Math.sqrt(1 - k * k) - 1);
	            }
	            return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
	        },
	        elasticIn: function (k) {
	            var s;
	            var a = 0.1;
	            var p = 0.4;
	            if (k === 0) {
	                return 0;
	            }
	            if (k === 1) {
	                return 1;
	            }
	            if (!a || a < 1) {
	                a = 1;
	                s = p / 4;
	            }
	            else {
	                s = p * Math.asin(1 / a) / (2 * Math.PI);
	            }
	            return -(a * Math.pow(2, 10 * (k -= 1))
	                * Math.sin((k - s) * (2 * Math.PI) / p));
	        },
	        elasticOut: function (k) {
	            var s;
	            var a = 0.1;
	            var p = 0.4;
	            if (k === 0) {
	                return 0;
	            }
	            if (k === 1) {
	                return 1;
	            }
	            if (!a || a < 1) {
	                a = 1;
	                s = p / 4;
	            }
	            else {
	                s = p * Math.asin(1 / a) / (2 * Math.PI);
	            }
	            return (a * Math.pow(2, -10 * k)
	                * Math.sin((k - s) * (2 * Math.PI) / p) + 1);
	        },
	        elasticInOut: function (k) {
	            var s;
	            var a = 0.1;
	            var p = 0.4;
	            if (k === 0) {
	                return 0;
	            }
	            if (k === 1) {
	                return 1;
	            }
	            if (!a || a < 1) {
	                a = 1;
	                s = p / 4;
	            }
	            else {
	                s = p * Math.asin(1 / a) / (2 * Math.PI);
	            }
	            if ((k *= 2) < 1) {
	                return -0.5 * (a * Math.pow(2, 10 * (k -= 1))
	                    * Math.sin((k - s) * (2 * Math.PI) / p));
	            }
	            return a * Math.pow(2, -10 * (k -= 1))
	                * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
	        },
	        backIn: function (k) {
	            var s = 1.70158;
	            return k * k * ((s + 1) * k - s);
	        },
	        backOut: function (k) {
	            var s = 1.70158;
	            return --k * k * ((s + 1) * k + s) + 1;
	        },
	        backInOut: function (k) {
	            var s = 1.70158 * 1.525;
	            if ((k *= 2) < 1) {
	                return 0.5 * (k * k * ((s + 1) * k - s));
	            }
	            return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
	        },
	        bounceIn: function (k) {
	            return 1 - easingFuncs.bounceOut(1 - k);
	        },
	        bounceOut: function (k) {
	            if (k < (1 / 2.75)) {
	                return 7.5625 * k * k;
	            }
	            else if (k < (2 / 2.75)) {
	                return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
	            }
	            else if (k < (2.5 / 2.75)) {
	                return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
	            }
	            else {
	                return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
	            }
	        },
	        bounceInOut: function (k) {
	            if (k < 0.5) {
	                return easingFuncs.bounceIn(k * 2) * 0.5;
	            }
	            return easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
	        }
	    };
	
	    var mathPow = Math.pow;
	    var mathSqrt = Math.sqrt;
	    var EPSILON = 1e-8;
	    var EPSILON_NUMERIC = 1e-4;
	    var THREE_SQRT = mathSqrt(3);
	    var ONE_THIRD = 1 / 3;
	    var _v0 = create();
	    var _v1 = create();
	    var _v2 = create();
	    function isAroundZero(val) {
	        return val > -EPSILON && val < EPSILON;
	    }
	    function isNotAroundZero(val) {
	        return val > EPSILON || val < -EPSILON;
	    }
	    function cubicAt(p0, p1, p2, p3, t) {
	        var onet = 1 - t;
	        return onet * onet * (onet * p0 + 3 * t * p1)
	            + t * t * (t * p3 + 3 * onet * p2);
	    }
	    function cubicDerivativeAt(p0, p1, p2, p3, t) {
	        var onet = 1 - t;
	        return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet
	            + (p3 - p2) * t * t);
	    }
	    function cubicRootAt(p0, p1, p2, p3, val, roots) {
	        var a = p3 + 3 * (p1 - p2) - p0;
	        var b = 3 * (p2 - p1 * 2 + p0);
	        var c = 3 * (p1 - p0);
	        var d = p0 - val;
	        var A = b * b - 3 * a * c;
	        var B = b * c - 9 * a * d;
	        var C = c * c - 3 * b * d;
	        var n = 0;
	        if (isAroundZero(A) && isAroundZero(B)) {
	            if (isAroundZero(b)) {
	                roots[0] = 0;
	            }
	            else {
	                var t1 = -c / b;
	                if (t1 >= 0 && t1 <= 1) {
	                    roots[n++] = t1;
	                }
	            }
	        }
	        else {
	            var disc = B * B - 4 * A * C;
	            if (isAroundZero(disc)) {
	                var K = B / A;
	                var t1 = -b / a + K;
	                var t2 = -K / 2;
	                if (t1 >= 0 && t1 <= 1) {
	                    roots[n++] = t1;
	                }
	                if (t2 >= 0 && t2 <= 1) {
	                    roots[n++] = t2;
	                }
	            }
	            else if (disc > 0) {
	                var discSqrt = mathSqrt(disc);
	                var Y1 = A * b + 1.5 * a * (-B + discSqrt);
	                var Y2 = A * b + 1.5 * a * (-B - discSqrt);
	                if (Y1 < 0) {
	                    Y1 = -mathPow(-Y1, ONE_THIRD);
	                }
	                else {
	                    Y1 = mathPow(Y1, ONE_THIRD);
	                }
	                if (Y2 < 0) {
	                    Y2 = -mathPow(-Y2, ONE_THIRD);
	                }
	                else {
	                    Y2 = mathPow(Y2, ONE_THIRD);
	                }
	                var t1 = (-b - (Y1 + Y2)) / (3 * a);
	                if (t1 >= 0 && t1 <= 1) {
	                    roots[n++] = t1;
	                }
	            }
	            else {
	                var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
	                var theta = Math.acos(T) / 3;
	                var ASqrt = mathSqrt(A);
	                var tmp = Math.cos(theta);
	                var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
	                var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
	                var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);
	                if (t1 >= 0 && t1 <= 1) {
	                    roots[n++] = t1;
	                }
	                if (t2 >= 0 && t2 <= 1) {
	                    roots[n++] = t2;
	                }
	                if (t3 >= 0 && t3 <= 1) {
	                    roots[n++] = t3;
	                }
	            }
	        }
	        return n;
	    }
	    function cubicExtrema(p0, p1, p2, p3, extrema) {
	        var b = 6 * p2 - 12 * p1 + 6 * p0;
	        var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
	        var c = 3 * p1 - 3 * p0;
	        var n = 0;
	        if (isAroundZero(a)) {
	            if (isNotAroundZero(b)) {
	                var t1 = -c / b;
	                if (t1 >= 0 && t1 <= 1) {
	                    extrema[n++] = t1;
	                }
	            }
	        }
	        else {
	            var disc = b * b - 4 * a * c;
	            if (isAroundZero(disc)) {
	                extrema[0] = -b / (2 * a);
	            }
	            else if (disc > 0) {
	                var discSqrt = mathSqrt(disc);
	                var t1 = (-b + discSqrt) / (2 * a);
	                var t2 = (-b - discSqrt) / (2 * a);
	                if (t1 >= 0 && t1 <= 1) {
	                    extrema[n++] = t1;
	                }
	                if (t2 >= 0 && t2 <= 1) {
	                    extrema[n++] = t2;
	                }
	            }
	        }
	        return n;
	    }
	    function cubicSubdivide(p0, p1, p2, p3, t, out) {
	        var p01 = (p1 - p0) * t + p0;
	        var p12 = (p2 - p1) * t + p1;
	        var p23 = (p3 - p2) * t + p2;
	        var p012 = (p12 - p01) * t + p01;
	        var p123 = (p23 - p12) * t + p12;
	        var p0123 = (p123 - p012) * t + p012;
	        out[0] = p0;
	        out[1] = p01;
	        out[2] = p012;
	        out[3] = p0123;
	        out[4] = p0123;
	        out[5] = p123;
	        out[6] = p23;
	        out[7] = p3;
	    }
	    function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
	        var t;
	        var interval = 0.005;
	        var d = Infinity;
	        var prev;
	        var next;
	        var d1;
	        var d2;
	        _v0[0] = x;
	        _v0[1] = y;
	        for (var _t = 0; _t < 1; _t += 0.05) {
	            _v1[0] = cubicAt(x0, x1, x2, x3, _t);
	            _v1[1] = cubicAt(y0, y1, y2, y3, _t);
	            d1 = distSquare(_v0, _v1);
	            if (d1 < d) {
	                t = _t;
	                d = d1;
	            }
	        }
	        d = Infinity;
	        for (var i = 0; i < 32; i++) {
	            if (interval < EPSILON_NUMERIC) {
	                break;
	            }
	            prev = t - interval;
	            next = t + interval;
	            _v1[0] = cubicAt(x0, x1, x2, x3, prev);
	            _v1[1] = cubicAt(y0, y1, y2, y3, prev);
	            d1 = distSquare(_v1, _v0);
	            if (prev >= 0 && d1 < d) {
	                t = prev;
	                d = d1;
	            }
	            else {
	                _v2[0] = cubicAt(x0, x1, x2, x3, next);
	                _v2[1] = cubicAt(y0, y1, y2, y3, next);
	                d2 = distSquare(_v2, _v0);
	                if (next <= 1 && d2 < d) {
	                    t = next;
	                    d = d2;
	                }
	                else {
	                    interval *= 0.5;
	                }
	            }
	        }
	        if (out) {
	            out[0] = cubicAt(x0, x1, x2, x3, t);
	            out[1] = cubicAt(y0, y1, y2, y3, t);
	        }
	        return mathSqrt(d);
	    }
	    function cubicLength(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
	        var px = x0;
	        var py = y0;
	        var d = 0;
	        var step = 1 / iteration;
	        for (var i = 1; i <= iteration; i++) {
	            var t = i * step;
	            var x = cubicAt(x0, x1, x2, x3, t);
	            var y = cubicAt(y0, y1, y2, y3, t);
	            var dx = x - px;
	            var dy = y - py;
	            d += Math.sqrt(dx * dx + dy * dy);
	            px = x;
	            py = y;
	        }
	        return d;
	    }
	    function quadraticAt(p0, p1, p2, t) {
	        var onet = 1 - t;
	        return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
	    }
	    function quadraticDerivativeAt(p0, p1, p2, t) {
	        return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
	    }
	    function quadraticRootAt(p0, p1, p2, val, roots) {
	        var a = p0 - 2 * p1 + p2;
	        var b = 2 * (p1 - p0);
	        var c = p0 - val;
	        var n = 0;
	        if (isAroundZero(a)) {
	            if (isNotAroundZero(b)) {
	                var t1 = -c / b;
	                if (t1 >= 0 && t1 <= 1) {
	                    roots[n++] = t1;
	                }
	            }
	        }
	        else {
	            var disc = b * b - 4 * a * c;
	            if (isAroundZero(disc)) {
	                var t1 = -b / (2 * a);
	                if (t1 >= 0 && t1 <= 1) {
	                    roots[n++] = t1;
	                }
	            }
	            else if (disc > 0) {
	                var discSqrt = mathSqrt(disc);
	                var t1 = (-b + discSqrt) / (2 * a);
	                var t2 = (-b - discSqrt) / (2 * a);
	                if (t1 >= 0 && t1 <= 1) {
	                    roots[n++] = t1;
	                }
	                if (t2 >= 0 && t2 <= 1) {
	                    roots[n++] = t2;
	                }
	            }
	        }
	        return n;
	    }
	    function quadraticExtremum(p0, p1, p2) {
	        var divider = p0 + p2 - 2 * p1;
	        if (divider === 0) {
	            return 0.5;
	        }
	        else {
	            return (p0 - p1) / divider;
	        }
	    }
	    function quadraticSubdivide(p0, p1, p2, t, out) {
	        var p01 = (p1 - p0) * t + p0;
	        var p12 = (p2 - p1) * t + p1;
	        var p012 = (p12 - p01) * t + p01;
	        out[0] = p0;
	        out[1] = p01;
	        out[2] = p012;
	        out[3] = p012;
	        out[4] = p12;
	        out[5] = p2;
	    }
	    function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
	        var t;
	        var interval = 0.005;
	        var d = Infinity;
	        _v0[0] = x;
	        _v0[1] = y;
	        for (var _t = 0; _t < 1; _t += 0.05) {
	            _v1[0] = quadraticAt(x0, x1, x2, _t);
	            _v1[1] = quadraticAt(y0, y1, y2, _t);
	            var d1 = distSquare(_v0, _v1);
	            if (d1 < d) {
	                t = _t;
	                d = d1;
	            }
	        }
	        d = Infinity;
	        for (var i = 0; i < 32; i++) {
	            if (interval < EPSILON_NUMERIC) {
	                break;
	            }
	            var prev = t - interval;
	            var next = t + interval;
	            _v1[0] = quadraticAt(x0, x1, x2, prev);
	            _v1[1] = quadraticAt(y0, y1, y2, prev);
	            var d1 = distSquare(_v1, _v0);
	            if (prev >= 0 && d1 < d) {
	                t = prev;
	                d = d1;
	            }
	            else {
	                _v2[0] = quadraticAt(x0, x1, x2, next);
	                _v2[1] = quadraticAt(y0, y1, y2, next);
	                var d2 = distSquare(_v2, _v0);
	                if (next <= 1 && d2 < d) {
	                    t = next;
	                    d = d2;
	                }
	                else {
	                    interval *= 0.5;
	                }
	            }
	        }
	        if (out) {
	            out[0] = quadraticAt(x0, x1, x2, t);
	            out[1] = quadraticAt(y0, y1, y2, t);
	        }
	        return mathSqrt(d);
	    }
	    function quadraticLength(x0, y0, x1, y1, x2, y2, iteration) {
	        var px = x0;
	        var py = y0;
	        var d = 0;
	        var step = 1 / iteration;
	        for (var i = 1; i <= iteration; i++) {
	            var t = i * step;
	            var x = quadraticAt(x0, x1, x2, t);
	            var y = quadraticAt(y0, y1, y2, t);
	            var dx = x - px;
	            var dy = y - py;
	            d += Math.sqrt(dx * dx + dy * dy);
	            px = x;
	            py = y;
	        }
	        return d;
	    }
	
	    var regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
	    function createCubicEasingFunc(cubicEasingStr) {
	        var cubic = cubicEasingStr && regexp.exec(cubicEasingStr);
	        if (cubic) {
	            var points = cubic[1].split(',');
	            var a_1 = +trim(points[0]);
	            var b_1 = +trim(points[1]);
	            var c_1 = +trim(points[2]);
	            var d_1 = +trim(points[3]);
	            if (isNaN(a_1 + b_1 + c_1 + d_1)) {
	                return;
	            }
	            var roots_1 = [];
	            return function (p) {
	                return p <= 0
	                    ? 0 : p >= 1
	                    ? 1
	                    : cubicRootAt(0, a_1, c_1, 1, p, roots_1) && cubicAt(0, b_1, d_1, 1, roots_1[0]);
	            };
	        }
	    }
	
	    var Clip = (function () {
	        function Clip(opts) {
	            this._inited = false;
	            this._startTime = 0;
	            this._pausedTime = 0;
	            this._paused = false;
	            this._life = opts.life || 1000;
	            this._delay = opts.delay || 0;
	            this.loop = opts.loop || false;
	            this.onframe = opts.onframe || noop;
	            this.ondestroy = opts.ondestroy || noop;
	            this.onrestart = opts.onrestart || noop;
	            opts.easing && this.setEasing(opts.easing);
	        }
	        Clip.prototype.step = function (globalTime, deltaTime) {
	            if (!this._inited) {
	                this._startTime = globalTime + this._delay;
	                this._inited = true;
	            }
	            if (this._paused) {
	                this._pausedTime += deltaTime;
	                return;
	            }
	            var life = this._life;
	            var elapsedTime = globalTime - this._startTime - this._pausedTime;
	            var percent = elapsedTime / life;
	            if (percent < 0) {
	                percent = 0;
	            }
	            percent = Math.min(percent, 1);
	            var easingFunc = this.easingFunc;
	            var schedule = easingFunc ? easingFunc(percent) : percent;
	            this.onframe(schedule);
	            if (percent === 1) {
	                if (this.loop) {
	                    var remainder = elapsedTime % life;
	                    this._startTime = globalTime - remainder;
	                    this._pausedTime = 0;
	                    this.onrestart();
	                }
	                else {
	                    return true;
	                }
	            }
	            return false;
	        };
	        Clip.prototype.pause = function () {
	            this._paused = true;
	        };
	        Clip.prototype.resume = function () {
	            this._paused = false;
	        };
	        Clip.prototype.setEasing = function (easing) {
	            this.easing = easing;
	            this.easingFunc = isFunction(easing)
	                ? easing
	                : easingFuncs[easing] || createCubicEasingFunc(easing);
	        };
	        return Clip;
	    }());
	
	    var Entry = (function () {
	        function Entry(val) {
	            this.value = val;
	        }
	        return Entry;
	    }());
	    var LinkedList = (function () {
	        function LinkedList() {
	            this._len = 0;
	        }
	        LinkedList.prototype.insert = function (val) {
	            var entry = new Entry(val);
	            this.insertEntry(entry);
	            return entry;
	        };
	        LinkedList.prototype.insertEntry = function (entry) {
	            if (!this.head) {
	                this.head = this.tail = entry;
	            }
	            else {
	                this.tail.next = entry;
	                entry.prev = this.tail;
	                entry.next = null;
	                this.tail = entry;
	            }
	            this._len++;
	        };
	        LinkedList.prototype.remove = function (entry) {
	            var prev = entry.prev;
	            var next = entry.next;
	            if (prev) {
	                prev.next = next;
	            }
	            else {
	                this.head = next;
	            }
	            if (next) {
	                next.prev = prev;
	            }
	            else {
	                this.tail = prev;
	            }
	            entry.next = entry.prev = null;
	            this._len--;
	        };
	        LinkedList.prototype.len = function () {
	            return this._len;
	        };
	        LinkedList.prototype.clear = function () {
	            this.head = this.tail = null;
	            this._len = 0;
	        };
	        return LinkedList;
	    }());
	    var LRU = (function () {
	        function LRU(maxSize) {
	            this._list = new LinkedList();
	            this._maxSize = 10;
	            this._map = {};
	            this._maxSize = maxSize;
	        }
	        LRU.prototype.put = function (key, value) {
	            var list = this._list;
	            var map = this._map;
	            var removed = null;
	            if (map[key] == null) {
	                var len = list.len();
	                var entry = this._lastRemovedEntry;
	                if (len >= this._maxSize && len > 0) {
	                    var leastUsedEntry = list.head;
	                    list.remove(leastUsedEntry);
	                    delete map[leastUsedEntry.key];
	                    removed = leastUsedEntry.value;
	                    this._lastRemovedEntry = leastUsedEntry;
	                }
	                if (entry) {
	                    entry.value = value;
	                }
	                else {
	                    entry = new Entry(value);
	                }
	                entry.key = key;
	                list.insertEntry(entry);
	                map[key] = entry;
	            }
	            return removed;
	        };
	        LRU.prototype.get = function (key) {
	            var entry = this._map[key];
	            var list = this._list;
	            if (entry != null) {
	                if (entry !== list.tail) {
	                    list.remove(entry);
	                    list.insertEntry(entry);
	                }
	                return entry.value;
	            }
	        };
	        LRU.prototype.clear = function () {
	            this._list.clear();
	            this._map = {};
	        };
	        LRU.prototype.len = function () {
	            return this._list.len();
	        };
	        return LRU;
	    }());
	
	    var kCSSColorTable = {
	        'transparent': [0, 0, 0, 0], 'aliceblue': [240, 248, 255, 1],
	        'antiquewhite': [250, 235, 215, 1], 'aqua': [0, 255, 255, 1],
	        'aquamarine': [127, 255, 212, 1], 'azure': [240, 255, 255, 1],
	        'beige': [245, 245, 220, 1], 'bisque': [255, 228, 196, 1],
	        'black': [0, 0, 0, 1], 'blanchedalmond': [255, 235, 205, 1],
	        'blue': [0, 0, 255, 1], 'blueviolet': [138, 43, 226, 1],
	        'brown': [165, 42, 42, 1], 'burlywood': [222, 184, 135, 1],
	        'cadetblue': [95, 158, 160, 1], 'chartreuse': [127, 255, 0, 1],
	        'chocolate': [210, 105, 30, 1], 'coral': [255, 127, 80, 1],
	        'cornflowerblue': [100, 149, 237, 1], 'cornsilk': [255, 248, 220, 1],
	        'crimson': [220, 20, 60, 1], 'cyan': [0, 255, 255, 1],
	        'darkblue': [0, 0, 139, 1], 'darkcyan': [0, 139, 139, 1],
	        'darkgoldenrod': [184, 134, 11, 1], 'darkgray': [169, 169, 169, 1],
	        'darkgreen': [0, 100, 0, 1], 'darkgrey': [169, 169, 169, 1],
	        'darkkhaki': [189, 183, 107, 1], 'darkmagenta': [139, 0, 139, 1],
	        'darkolivegreen': [85, 107, 47, 1], 'darkorange': [255, 140, 0, 1],
	        'darkorchid': [153, 50, 204, 1], 'darkred': [139, 0, 0, 1],
	        'darksalmon': [233, 150, 122, 1], 'darkseagreen': [143, 188, 143, 1],
	        'darkslateblue': [72, 61, 139, 1], 'darkslategray': [47, 79, 79, 1],
	        'darkslategrey': [47, 79, 79, 1], 'darkturquoise': [0, 206, 209, 1],
	        'darkviolet': [148, 0, 211, 1], 'deeppink': [255, 20, 147, 1],
	        'deepskyblue': [0, 191, 255, 1], 'dimgray': [105, 105, 105, 1],
	        'dimgrey': [105, 105, 105, 1], 'dodgerblue': [30, 144, 255, 1],
	        'firebrick': [178, 34, 34, 1], 'floralwhite': [255, 250, 240, 1],
	        'forestgreen': [34, 139, 34, 1], 'fuchsia': [255, 0, 255, 1],
	        'gainsboro': [220, 220, 220, 1], 'ghostwhite': [248, 248, 255, 1],
	        'gold': [255, 215, 0, 1], 'goldenrod': [218, 165, 32, 1],
	        'gray': [128, 128, 128, 1], 'green': [0, 128, 0, 1],
	        'greenyellow': [173, 255, 47, 1], 'grey': [128, 128, 128, 1],
	        'honeydew': [240, 255, 240, 1], 'hotpink': [255, 105, 180, 1],
	        'indianred': [205, 92, 92, 1], 'indigo': [75, 0, 130, 1],
	        'ivory': [255, 255, 240, 1], 'khaki': [240, 230, 140, 1],
	        'lavender': [230, 230, 250, 1], 'lavenderblush': [255, 240, 245, 1],
	        'lawngreen': [124, 252, 0, 1], 'lemonchiffon': [255, 250, 205, 1],
	        'lightblue': [173, 216, 230, 1], 'lightcoral': [240, 128, 128, 1],
	        'lightcyan': [224, 255, 255, 1], 'lightgoldenrodyellow': [250, 250, 210, 1],
	        'lightgray': [211, 211, 211, 1], 'lightgreen': [144, 238, 144, 1],
	        'lightgrey': [211, 211, 211, 1], 'lightpink': [255, 182, 193, 1],
	        'lightsalmon': [255, 160, 122, 1], 'lightseagreen': [32, 178, 170, 1],
	        'lightskyblue': [135, 206, 250, 1], 'lightslategray': [119, 136, 153, 1],
	        'lightslategrey': [119, 136, 153, 1], 'lightsteelblue': [176, 196, 222, 1],
	        'lightyellow': [255, 255, 224, 1], 'lime': [0, 255, 0, 1],
	        'limegreen': [50, 205, 50, 1], 'linen': [250, 240, 230, 1],
	        'magenta': [255, 0, 255, 1], 'maroon': [128, 0, 0, 1],
	        'mediumaquamarine': [102, 205, 170, 1], 'mediumblue': [0, 0, 205, 1],
	        'mediumorchid': [186, 85, 211, 1], 'mediumpurple': [147, 112, 219, 1],
	        'mediumseagreen': [60, 179, 113, 1], 'mediumslateblue': [123, 104, 238, 1],
	        'mediumspringgreen': [0, 250, 154, 1], 'mediumturquoise': [72, 209, 204, 1],
	        'mediumvioletred': [199, 21, 133, 1], 'midnightblue': [25, 25, 112, 1],
	        'mintcream': [245, 255, 250, 1], 'mistyrose': [255, 228, 225, 1],
	        'moccasin': [255, 228, 181, 1], 'navajowhite': [255, 222, 173, 1],
	        'navy': [0, 0, 128, 1], 'oldlace': [253, 245, 230, 1],
	        'olive': [128, 128, 0, 1], 'olivedrab': [107, 142, 35, 1],
	        'orange': [255, 165, 0, 1], 'orangered': [255, 69, 0, 1],
	        'orchid': [218, 112, 214, 1], 'palegoldenrod': [238, 232, 170, 1],
	        'palegreen': [152, 251, 152, 1], 'paleturquoise': [175, 238, 238, 1],
	        'palevioletred': [219, 112, 147, 1], 'papayawhip': [255, 239, 213, 1],
	        'peachpuff': [255, 218, 185, 1], 'peru': [205, 133, 63, 1],
	        'pink': [255, 192, 203, 1], 'plum': [221, 160, 221, 1],
	        'powderblue': [176, 224, 230, 1], 'purple': [128, 0, 128, 1],
	        'red': [255, 0, 0, 1], 'rosybrown': [188, 143, 143, 1],
	        'royalblue': [65, 105, 225, 1], 'saddlebrown': [139, 69, 19, 1],
	        'salmon': [250, 128, 114, 1], 'sandybrown': [244, 164, 96, 1],
	        'seagreen': [46, 139, 87, 1], 'seashell': [255, 245, 238, 1],
	        'sienna': [160, 82, 45, 1], 'silver': [192, 192, 192, 1],
	        'skyblue': [135, 206, 235, 1], 'slateblue': [106, 90, 205, 1],
	        'slategray': [112, 128, 144, 1], 'slategrey': [112, 128, 144, 1],
	        'snow': [255, 250, 250, 1], 'springgreen': [0, 255, 127, 1],
	        'steelblue': [70, 130, 180, 1], 'tan': [210, 180, 140, 1],
	        'teal': [0, 128, 128, 1], 'thistle': [216, 191, 216, 1],
	        'tomato': [255, 99, 71, 1], 'turquoise': [64, 224, 208, 1],
	        'violet': [238, 130, 238, 1], 'wheat': [245, 222, 179, 1],
	        'white': [255, 255, 255, 1], 'whitesmoke': [245, 245, 245, 1],
	        'yellow': [255, 255, 0, 1], 'yellowgreen': [154, 205, 50, 1]
	    };
	    function clampCssByte(i) {
	        i = Math.round(i);
	        return i < 0 ? 0 : i > 255 ? 255 : i;
	    }
	    function clampCssAngle(i) {
	        i = Math.round(i);
	        return i < 0 ? 0 : i > 360 ? 360 : i;
	    }
	    function clampCssFloat(f) {
	        return f < 0 ? 0 : f > 1 ? 1 : f;
	    }
	    function parseCssInt(val) {
	        var str = val;
	        if (str.length && str.charAt(str.length - 1) === '%') {
	            return clampCssByte(parseFloat(str) / 100 * 255);
	        }
	        return clampCssByte(parseInt(str, 10));
	    }
	    function parseCssFloat(val) {
	        var str = val;
	        if (str.length && str.charAt(str.length - 1) === '%') {
	            return clampCssFloat(parseFloat(str) / 100);
	        }
	        return clampCssFloat(parseFloat(str));
	    }
	    function cssHueToRgb(m1, m2, h) {
	        if (h < 0) {
	            h += 1;
	        }
	        else if (h > 1) {
	            h -= 1;
	        }
	        if (h * 6 < 1) {
	            return m1 + (m2 - m1) * h * 6;
	        }
	        if (h * 2 < 1) {
	            return m2;
	        }
	        if (h * 3 < 2) {
	            return m1 + (m2 - m1) * (2 / 3 - h) * 6;
	        }
	        return m1;
	    }
	    function lerpNumber(a, b, p) {
	        return a + (b - a) * p;
	    }
	    function setRgba(out, r, g, b, a) {
	        out[0] = r;
	        out[1] = g;
	        out[2] = b;
	        out[3] = a;
	        return out;
	    }
	    function copyRgba(out, a) {
	        out[0] = a[0];
	        out[1] = a[1];
	        out[2] = a[2];
	        out[3] = a[3];
	        return out;
	    }
	    var colorCache = new LRU(20);
	    var lastRemovedArr = null;
	    function putToCache(colorStr, rgbaArr) {
	        if (lastRemovedArr) {
	            copyRgba(lastRemovedArr, rgbaArr);
	        }
	        lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || (rgbaArr.slice()));
	    }
	    function parse(colorStr, rgbaArr) {
	        if (!colorStr) {
	            return;
	        }
	        rgbaArr = rgbaArr || [];
	        var cached = colorCache.get(colorStr);
	        if (cached) {
	            return copyRgba(rgbaArr, cached);
	        }
	        colorStr = colorStr + '';
	        var str = colorStr.replace(/ /g, '').toLowerCase();
	        if (str in kCSSColorTable) {
	            copyRgba(rgbaArr, kCSSColorTable[str]);
	            putToCache(colorStr, rgbaArr);
	            return rgbaArr;
	        }
	        var strLen = str.length;
	        if (str.charAt(0) === '#') {
	            if (strLen === 4 || strLen === 5) {
	                var iv = parseInt(str.slice(1, 4), 16);
	                if (!(iv >= 0 && iv <= 0xfff)) {
	                    setRgba(rgbaArr, 0, 0, 0, 1);
	                    return;
	                }
	                setRgba(rgbaArr, ((iv & 0xf00) >> 4) | ((iv & 0xf00) >> 8), (iv & 0xf0) | ((iv & 0xf0) >> 4), (iv & 0xf) | ((iv & 0xf) << 4), strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
	                putToCache(colorStr, rgbaArr);
	                return rgbaArr;
	            }
	            else if (strLen === 7 || strLen === 9) {
	                var iv = parseInt(str.slice(1, 7), 16);
	                if (!(iv >= 0 && iv <= 0xffffff)) {
	                    setRgba(rgbaArr, 0, 0, 0, 1);
	                    return;
	                }
	                setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
	                putToCache(colorStr, rgbaArr);
	                return rgbaArr;
	            }
	            return;
	        }
	        var op = str.indexOf('(');
	        var ep = str.indexOf(')');
	        if (op !== -1 && ep + 1 === strLen) {
	            var fname = str.substr(0, op);
	            var params = str.substr(op + 1, ep - (op + 1)).split(',');
	            var alpha = 1;
	            switch (fname) {
	                case 'rgba':
	                    if (params.length !== 4) {
	                        return params.length === 3
	                            ? setRgba(rgbaArr, +params[0], +params[1], +params[2], 1)
	                            : setRgba(rgbaArr, 0, 0, 0, 1);
	                    }
	                    alpha = parseCssFloat(params.pop());
	                case 'rgb':
	                    if (params.length >= 3) {
	                        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), params.length === 3 ? alpha : parseCssFloat(params[3]));
	                        putToCache(colorStr, rgbaArr);
	                        return rgbaArr;
	                    }
	                    else {
	                        setRgba(rgbaArr, 0, 0, 0, 1);
	                        return;
	                    }
	                case 'hsla':
	                    if (params.length !== 4) {
	                        setRgba(rgbaArr, 0, 0, 0, 1);
	                        return;
	                    }
	                    params[3] = parseCssFloat(params[3]);
	                    hsla2rgba(params, rgbaArr);
	                    putToCache(colorStr, rgbaArr);
	                    return rgbaArr;
	                case 'hsl':
	                    if (params.length !== 3) {
	                        setRgba(rgbaArr, 0, 0, 0, 1);
	                        return;
	                    }
	                    hsla2rgba(params, rgbaArr);
	                    putToCache(colorStr, rgbaArr);
	                    return rgbaArr;
	                default:
	                    return;
	            }
	        }
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return;
	    }
	    function hsla2rgba(hsla, rgba) {
	        var h = (((parseFloat(hsla[0]) % 360) + 360) % 360) / 360;
	        var s = parseCssFloat(hsla[1]);
	        var l = parseCssFloat(hsla[2]);
	        var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	        var m1 = l * 2 - m2;
	        rgba = rgba || [];
	        setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
	        if (hsla.length === 4) {
	            rgba[3] = hsla[3];
	        }
	        return rgba;
	    }
	    function rgba2hsla(rgba) {
	        if (!rgba) {
	            return;
	        }
	        var R = rgba[0] / 255;
	        var G = rgba[1] / 255;
	        var B = rgba[2] / 255;
	        var vMin = Math.min(R, G, B);
	        var vMax = Math.max(R, G, B);
	        var delta = vMax - vMin;
	        var L = (vMax + vMin) / 2;
	        var H;
	        var S;
	        if (delta === 0) {
	            H = 0;
	            S = 0;
	        }
	        else {
	            if (L < 0.5) {
	                S = delta / (vMax + vMin);
	            }
	            else {
	                S = delta / (2 - vMax - vMin);
	            }
	            var deltaR = (((vMax - R) / 6) + (delta / 2)) / delta;
	            var deltaG = (((vMax - G) / 6) + (delta / 2)) / delta;
	            var deltaB = (((vMax - B) / 6) + (delta / 2)) / delta;
	            if (R === vMax) {
	                H = deltaB - deltaG;
	            }
	            else if (G === vMax) {
	                H = (1 / 3) + deltaR - deltaB;
	            }
	            else if (B === vMax) {
	                H = (2 / 3) + deltaG - deltaR;
	            }
	            if (H < 0) {
	                H += 1;
	            }
	            if (H > 1) {
	                H -= 1;
	            }
	        }
	        var hsla = [H * 360, S, L];
	        if (rgba[3] != null) {
	            hsla.push(rgba[3]);
	        }
	        return hsla;
	    }
	    function lift(color, level) {
	        var colorArr = parse(color);
	        if (colorArr) {
	            for (var i = 0; i < 3; i++) {
	                if (level < 0) {
	                    colorArr[i] = colorArr[i] * (1 - level) | 0;
	                }
	                else {
	                    colorArr[i] = ((255 - colorArr[i]) * level + colorArr[i]) | 0;
	                }
	                if (colorArr[i] > 255) {
	                    colorArr[i] = 255;
	                }
	                else if (colorArr[i] < 0) {
	                    colorArr[i] = 0;
	                }
	            }
	            return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
	        }
	    }
	    function toHex(color) {
	        var colorArr = parse(color);
	        if (colorArr) {
	            return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + (+colorArr[2])).toString(16).slice(1);
	        }
	    }
	    function fastLerp(normalizedValue, colors, out) {
	        if (!(colors && colors.length)
	            || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	            return;
	        }
	        out = out || [];
	        var value = normalizedValue * (colors.length - 1);
	        var leftIndex = Math.floor(value);
	        var rightIndex = Math.ceil(value);
	        var leftColor = colors[leftIndex];
	        var rightColor = colors[rightIndex];
	        var dv = value - leftIndex;
	        out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
	        out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
	        out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
	        out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
	        return out;
	    }
	    var fastMapToColor = fastLerp;
	    function lerp$1(normalizedValue, colors, fullOutput) {
	        if (!(colors && colors.length)
	            || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	            return;
	        }
	        var value = normalizedValue * (colors.length - 1);
	        var leftIndex = Math.floor(value);
	        var rightIndex = Math.ceil(value);
	        var leftColor = parse(colors[leftIndex]);
	        var rightColor = parse(colors[rightIndex]);
	        var dv = value - leftIndex;
	        var color = stringify([
	            clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)),
	            clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)),
	            clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)),
	            clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))
	        ], 'rgba');
	        return fullOutput
	            ? {
	                color: color,
	                leftIndex: leftIndex,
	                rightIndex: rightIndex,
	                value: value
	            }
	            : color;
	    }
	    var mapToColor = lerp$1;
	    function modifyHSL(color, h, s, l) {
	        var colorArr = parse(color);
	        if (color) {
	            colorArr = rgba2hsla(colorArr);
	            h != null && (colorArr[0] = clampCssAngle(h));
	            s != null && (colorArr[1] = parseCssFloat(s));
	            l != null && (colorArr[2] = parseCssFloat(l));
	            return stringify(hsla2rgba(colorArr), 'rgba');
	        }
	    }
	    function modifyAlpha(color, alpha) {
	        var colorArr = parse(color);
	        if (colorArr && alpha != null) {
	            colorArr[3] = clampCssFloat(alpha);
	            return stringify(colorArr, 'rgba');
	        }
	    }
	    function stringify(arrColor, type) {
	        if (!arrColor || !arrColor.length) {
	            return;
	        }
	        var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
	        if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
	            colorStr += ',' + arrColor[3];
	        }
	        return type + '(' + colorStr + ')';
	    }
	    function lum(color, backgroundLum) {
	        var arr = parse(color);
	        return arr
	            ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255
	                + (1 - arr[3]) * backgroundLum
	            : 0;
	    }
	    function random() {
	        return stringify([
	            Math.round(Math.random() * 255),
	            Math.round(Math.random() * 255),
	            Math.round(Math.random() * 255)
	        ], 'rgb');
	    }
	
	    var color = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        parse: parse,
	        lift: lift,
	        toHex: toHex,
	        fastLerp: fastLerp,
	        fastMapToColor: fastMapToColor,
	        lerp: lerp$1,
	        mapToColor: mapToColor,
	        modifyHSL: modifyHSL,
	        modifyAlpha: modifyAlpha,
	        stringify: stringify,
	        lum: lum,
	        random: random
	    });
	
	    var mathRound = Math.round;
	    function normalizeColor(color) {
	        var opacity;
	        if (!color || color === 'transparent') {
	            color = 'none';
	        }
	        else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
	            var arr = parse(color);
	            if (arr) {
	                color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
	                opacity = arr[3];
	            }
	        }
	        return {
	            color: color,
	            opacity: opacity == null ? 1 : opacity
	        };
	    }
	    var EPSILON$1 = 1e-4;
	    function isAroundZero$1(transform) {
	        return transform < EPSILON$1 && transform > -EPSILON$1;
	    }
	    function round3(transform) {
	        return mathRound(transform * 1e3) / 1e3;
	    }
	    function round4(transform) {
	        return mathRound(transform * 1e4) / 1e4;
	    }
	    function getMatrixStr(m) {
	        return 'matrix('
	            + round3(m[0]) + ','
	            + round3(m[1]) + ','
	            + round3(m[2]) + ','
	            + round3(m[3]) + ','
	            + round4(m[4]) + ','
	            + round4(m[5])
	            + ')';
	    }
	    var TEXT_ALIGN_TO_ANCHOR = {
	        left: 'start',
	        right: 'end',
	        center: 'middle',
	        middle: 'middle'
	    };
	    function adjustTextY(y, lineHeight, textBaseline) {
	        if (textBaseline === 'top') {
	            y += lineHeight / 2;
	        }
	        else if (textBaseline === 'bottom') {
	            y -= lineHeight / 2;
	        }
	        return y;
	    }
	    function hasShadow(style) {
	        return style
	            && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
	    }
	    function getShadowKey(displayable) {
	        var style = displayable.style;
	        var globalScale = displayable.getGlobalScale();
	        return [
	            style.shadowColor,
	            (style.shadowBlur || 0).toFixed(2),
	            (style.shadowOffsetX || 0).toFixed(2),
	            (style.shadowOffsetY || 0).toFixed(2),
	            globalScale[0],
	            globalScale[1]
	        ].join(',');
	    }
	    function isImagePattern(val) {
	        return val && (!!val.image);
	    }
	    function isSVGPattern(val) {
	        return val && (!!val.svgElement);
	    }
	    function isPattern(val) {
	        return isImagePattern(val) || isSVGPattern(val);
	    }
	    function isLinearGradient(val) {
	        return val.type === 'linear';
	    }
	    function isRadialGradient(val) {
	        return val.type === 'radial';
	    }
	    function isGradient(val) {
	        return val && (val.type === 'linear'
	            || val.type === 'radial');
	    }
	    function getIdURL(id) {
	        return "url(#" + id + ")";
	    }
	    function getPathPrecision(el) {
	        var scale = el.getGlobalScale();
	        var size = Math.max(scale[0], scale[1]);
	        return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
	    }
	    function getSRTTransformString(transform) {
	        var x = transform.x || 0;
	        var y = transform.y || 0;
	        var rotation = (transform.rotation || 0) * RADIAN_TO_DEGREE;
	        var scaleX = retrieve2(transform.scaleX, 1);
	        var scaleY = retrieve2(transform.scaleY, 1);
	        var skewX = transform.skewX || 0;
	        var skewY = transform.skewY || 0;
	        var res = [];
	        if (x || y) {
	            res.push("translate(" + x + "px," + y + "px)");
	        }
	        if (rotation) {
	            res.push("rotate(" + rotation + ")");
	        }
	        if (scaleX !== 1 || scaleY !== 1) {
	            res.push("scale(" + scaleX + "," + scaleY + ")");
	        }
	        if (skewX || skewY) {
	            res.push("skew(" + mathRound(skewX * RADIAN_TO_DEGREE) + "deg, " + mathRound(skewY * RADIAN_TO_DEGREE) + "deg)");
	        }
	        return res.join(' ');
	    }
	    var encodeBase64 = (function () {
	        if (env.hasGlobalWindow && isFunction(window.btoa)) {
	            return function (str) {
	                return window.btoa(unescape(encodeURIComponent(str)));
	            };
	        }
	        if (typeof Buffer !== 'undefined') {
	            return function (str) {
	                return Buffer.from(str).toString('base64');
	            };
	        }
	        return function (str) {
	            if (true) {
	                logError('Base64 isn\'t natively supported in the current environment.');
	            }
	            return null;
	        };
	    })();
	
	    var arraySlice = Array.prototype.slice;
	    function interpolateNumber(p0, p1, percent) {
	        return (p1 - p0) * percent + p0;
	    }
	    function interpolate1DArray(out, p0, p1, percent) {
	        var len = p0.length;
	        for (var i = 0; i < len; i++) {
	            out[i] = interpolateNumber(p0[i], p1[i], percent);
	        }
	        return out;
	    }
	    function interpolate2DArray(out, p0, p1, percent) {
	        var len = p0.length;
	        var len2 = len && p0[0].length;
	        for (var i = 0; i < len; i++) {
	            if (!out[i]) {
	                out[i] = [];
	            }
	            for (var j = 0; j < len2; j++) {
	                out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
	            }
	        }
	        return out;
	    }
	    function add1DArray(out, p0, p1, sign) {
	        var len = p0.length;
	        for (var i = 0; i < len; i++) {
	            out[i] = p0[i] + p1[i] * sign;
	        }
	        return out;
	    }
	    function add2DArray(out, p0, p1, sign) {
	        var len = p0.length;
	        var len2 = len && p0[0].length;
	        for (var i = 0; i < len; i++) {
	            if (!out[i]) {
	                out[i] = [];
	            }
	            for (var j = 0; j < len2; j++) {
	                out[i][j] = p0[i][j] + p1[i][j] * sign;
	            }
	        }
	        return out;
	    }
	    function fillColorStops(val0, val1) {
	        var len0 = val0.length;
	        var len1 = val1.length;
	        var shorterArr = len0 > len1 ? val1 : val0;
	        var shorterLen = Math.min(len0, len1);
	        var last = shorterArr[shorterLen - 1] || { color: [0, 0, 0, 0], offset: 0 };
	        for (var i = shorterLen; i < Math.max(len0, len1); i++) {
	            shorterArr.push({
	                offset: last.offset,
	                color: last.color.slice()
	            });
	        }
	    }
	    function fillArray(val0, val1, arrDim) {
	        var arr0 = val0;
	        var arr1 = val1;
	        if (!arr0.push || !arr1.push) {
	            return;
	        }
	        var arr0Len = arr0.length;
	        var arr1Len = arr1.length;
	        if (arr0Len !== arr1Len) {
	            var isPreviousLarger = arr0Len > arr1Len;
	            if (isPreviousLarger) {
	                arr0.length = arr1Len;
	            }
	            else {
	                for (var i = arr0Len; i < arr1Len; i++) {
	                    arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
	                }
	            }
	        }
	        var len2 = arr0[0] && arr0[0].length;
	        for (var i = 0; i < arr0.length; i++) {
	            if (arrDim === 1) {
	                if (isNaN(arr0[i])) {
	                    arr0[i] = arr1[i];
	                }
	            }
	            else {
	                for (var j = 0; j < len2; j++) {
	                    if (isNaN(arr0[i][j])) {
	                        arr0[i][j] = arr1[i][j];
	                    }
	                }
	            }
	        }
	    }
	    function cloneValue(value) {
	        if (isArrayLike(value)) {
	            var len = value.length;
	            if (isArrayLike(value[0])) {
	                var ret = [];
	                for (var i = 0; i < len; i++) {
	                    ret.push(arraySlice.call(value[i]));
	                }
	                return ret;
	            }
	            return arraySlice.call(value);
	        }
	        return value;
	    }
	    function rgba2String(rgba) {
	        rgba[0] = Math.floor(rgba[0]) || 0;
	        rgba[1] = Math.floor(rgba[1]) || 0;
	        rgba[2] = Math.floor(rgba[2]) || 0;
	        rgba[3] = rgba[3] == null ? 1 : rgba[3];
	        return 'rgba(' + rgba.join(',') + ')';
	    }
	    function guessArrayDim(value) {
	        return isArrayLike(value && value[0]) ? 2 : 1;
	    }
	    var VALUE_TYPE_NUMBER = 0;
	    var VALUE_TYPE_1D_ARRAY = 1;
	    var VALUE_TYPE_2D_ARRAY = 2;
	    var VALUE_TYPE_COLOR = 3;
	    var VALUE_TYPE_LINEAR_GRADIENT = 4;
	    var VALUE_TYPE_RADIAL_GRADIENT = 5;
	    var VALUE_TYPE_UNKOWN = 6;
	    function isGradientValueType(valType) {
	        return valType === VALUE_TYPE_LINEAR_GRADIENT || valType === VALUE_TYPE_RADIAL_GRADIENT;
	    }
	    function isArrayValueType(valType) {
	        return valType === VALUE_TYPE_1D_ARRAY || valType === VALUE_TYPE_2D_ARRAY;
	    }
	    var tmpRgba = [0, 0, 0, 0];
	    var Track = (function () {
	        function Track(propName) {
	            this.keyframes = [];
	            this.discrete = false;
	            this._invalid = false;
	            this._needsSort = false;
	            this._lastFr = 0;
	            this._lastFrP = 0;
	            this.propName = propName;
	        }
	        Track.prototype.isFinished = function () {
	            return this._finished;
	        };
	        Track.prototype.setFinished = function () {
	            this._finished = true;
	            if (this._additiveTrack) {
	                this._additiveTrack.setFinished();
	            }
	        };
	        Track.prototype.needsAnimate = function () {
	            return this.keyframes.length >= 1;
	        };
	        Track.prototype.getAdditiveTrack = function () {
	            return this._additiveTrack;
	        };
	        Track.prototype.addKeyframe = function (time, rawValue, easing) {
	            this._needsSort = true;
	            var keyframes = this.keyframes;
	            var len = keyframes.length;
	            var discrete = false;
	            var valType = VALUE_TYPE_UNKOWN;
	            var value = rawValue;
	            if (isArrayLike(rawValue)) {
	                var arrayDim = guessArrayDim(rawValue);
	                valType = arrayDim;
	                if (arrayDim === 1 && !isNumber(rawValue[0])
	                    || arrayDim === 2 && !isNumber(rawValue[0][0])) {
	                    discrete = true;
	                }
	            }
	            else {
	                if (isNumber(rawValue) && !eqNaN(rawValue)) {
	                    valType = VALUE_TYPE_NUMBER;
	                }
	                else if (isString(rawValue)) {
	                    if (!isNaN(+rawValue)) {
	                        valType = VALUE_TYPE_NUMBER;
	                    }
	                    else {
	                        var colorArray = parse(rawValue);
	                        if (colorArray) {
	                            value = colorArray;
	                            valType = VALUE_TYPE_COLOR;
	                        }
	                    }
	                }
	                else if (isGradientObject(rawValue)) {
	                    var parsedGradient = extend({}, value);
	                    parsedGradient.colorStops = map(rawValue.colorStops, function (colorStop) { return ({
	                        offset: colorStop.offset,
	                        color: parse(colorStop.color)
	                    }); });
	                    if (isLinearGradient(rawValue)) {
	                        valType = VALUE_TYPE_LINEAR_GRADIENT;
	                    }
	                    else if (isRadialGradient(rawValue)) {
	                        valType = VALUE_TYPE_RADIAL_GRADIENT;
	                    }
	                    value = parsedGradient;
	                }
	            }
	            if (len === 0) {
	                this.valType = valType;
	            }
	            else if (valType !== this.valType || valType === VALUE_TYPE_UNKOWN) {
	                discrete = true;
	            }
	            this.discrete = this.discrete || discrete;
	            var kf = {
	                time: time,
	                value: value,
	                rawValue: rawValue,
	                percent: 0
	            };
	            if (easing) {
	                kf.easing = easing;
	                kf.easingFunc = isFunction(easing)
	                    ? easing
	                    : easingFuncs[easing] || createCubicEasingFunc(easing);
	            }
	            keyframes.push(kf);
	            return kf;
	        };
	        Track.prototype.prepare = function (maxTime, additiveTrack) {
	            var kfs = this.keyframes;
	            if (this._needsSort) {
	                kfs.sort(function (a, b) {
	                    return a.time - b.time;
	                });
	            }
	            var valType = this.valType;
	            var kfsLen = kfs.length;
	            var lastKf = kfs[kfsLen - 1];
	            var isDiscrete = this.discrete;
	            var isArr = isArrayValueType(valType);
	            var isGradient = isGradientValueType(valType);
	            for (var i = 0; i < kfsLen; i++) {
	                var kf = kfs[i];
	                var value = kf.value;
	                var lastValue = lastKf.value;
	                kf.percent = kf.time / maxTime;
	                if (!isDiscrete) {
	                    if (isArr && i !== kfsLen - 1) {
	                        fillArray(value, lastValue, valType);
	                    }
	                    else if (isGradient) {
	                        fillColorStops(value.colorStops, lastValue.colorStops);
	                    }
	                }
	            }
	            if (!isDiscrete
	                && valType !== VALUE_TYPE_RADIAL_GRADIENT
	                && additiveTrack
	                && this.needsAnimate()
	                && additiveTrack.needsAnimate()
	                && valType === additiveTrack.valType
	                && !additiveTrack._finished) {
	                this._additiveTrack = additiveTrack;
	                var startValue = kfs[0].value;
	                for (var i = 0; i < kfsLen; i++) {
	                    if (valType === VALUE_TYPE_NUMBER) {
	                        kfs[i].additiveValue = kfs[i].value - startValue;
	                    }
	                    else if (valType === VALUE_TYPE_COLOR) {
	                        kfs[i].additiveValue =
	                            add1DArray([], kfs[i].value, startValue, -1);
	                    }
	                    else if (isArrayValueType(valType)) {
	                        kfs[i].additiveValue = valType === VALUE_TYPE_1D_ARRAY
	                            ? add1DArray([], kfs[i].value, startValue, -1)
	                            : add2DArray([], kfs[i].value, startValue, -1);
	                    }
	                }
	            }
	        };
	        Track.prototype.step = function (target, percent) {
	            if (this._finished) {
	                return;
	            }
	            if (this._additiveTrack && this._additiveTrack._finished) {
	                this._additiveTrack = null;
	            }
	            var isAdditive = this._additiveTrack != null;
	            var valueKey = isAdditive ? 'additiveValue' : 'value';
	            var valType = this.valType;
	            var keyframes = this.keyframes;
	            var kfsNum = keyframes.length;
	            var propName = this.propName;
	            var isValueColor = valType === VALUE_TYPE_COLOR;
	            var frameIdx;
	            var lastFrame = this._lastFr;
	            var mathMin = Math.min;
	            var frame;
	            var nextFrame;
	            if (kfsNum === 1) {
	                frame = nextFrame = keyframes[0];
	            }
	            else {
	                if (percent < 0) {
	                    frameIdx = 0;
	                }
	                else if (percent < this._lastFrP) {
	                    var start = mathMin(lastFrame + 1, kfsNum - 1);
	                    for (frameIdx = start; frameIdx >= 0; frameIdx--) {
	                        if (keyframes[frameIdx].percent <= percent) {
	                            break;
	                        }
	                    }
	                    frameIdx = mathMin(frameIdx, kfsNum - 2);
	                }
	                else {
	                    for (frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++) {
	                        if (keyframes[frameIdx].percent > percent) {
	                            break;
	                        }
	                    }
	                    frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
	                }
	                nextFrame = keyframes[frameIdx + 1];
	                frame = keyframes[frameIdx];
	            }
	            if (!(frame && nextFrame)) {
	                return;
	            }
	            this._lastFr = frameIdx;
	            this._lastFrP = percent;
	            var interval = (nextFrame.percent - frame.percent);
	            var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
	            if (nextFrame.easingFunc) {
	                w = nextFrame.easingFunc(w);
	            }
	            var targetArr = isAdditive ? this._additiveValue
	                : (isValueColor ? tmpRgba : target[propName]);
	            if ((isArrayValueType(valType) || isValueColor) && !targetArr) {
	                targetArr = this._additiveValue = [];
	            }
	            if (this.discrete) {
	                target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
	            }
	            else if (isArrayValueType(valType)) {
	                valType === VALUE_TYPE_1D_ARRAY
	                    ? interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w)
	                    : interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
	            }
	            else if (isGradientValueType(valType)) {
	                var val = frame[valueKey];
	                var nextVal_1 = nextFrame[valueKey];
	                var isLinearGradient_1 = valType === VALUE_TYPE_LINEAR_GRADIENT;
	                target[propName] = {
	                    type: isLinearGradient_1 ? 'linear' : 'radial',
	                    x: interpolateNumber(val.x, nextVal_1.x, w),
	                    y: interpolateNumber(val.y, nextVal_1.y, w),
	                    colorStops: map(val.colorStops, function (colorStop, idx) {
	                        var nextColorStop = nextVal_1.colorStops[idx];
	                        return {
	                            offset: interpolateNumber(colorStop.offset, nextColorStop.offset, w),
	                            color: rgba2String(interpolate1DArray([], colorStop.color, nextColorStop.color, w))
	                        };
	                    }),
	                    global: nextVal_1.global
	                };
	                if (isLinearGradient_1) {
	                    target[propName].x2 = interpolateNumber(val.x2, nextVal_1.x2, w);
	                    target[propName].y2 = interpolateNumber(val.y2, nextVal_1.y2, w);
	                }
	                else {
	                    target[propName].r = interpolateNumber(val.r, nextVal_1.r, w);
	                }
	            }
	            else if (isValueColor) {
	                interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
	                if (!isAdditive) {
	                    target[propName] = rgba2String(targetArr);
	                }
	            }
	            else {
	                var value = interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
	                if (isAdditive) {
	                    this._additiveValue = value;
	                }
	                else {
	                    target[propName] = value;
	                }
	            }
	            if (isAdditive) {
	                this._addToTarget(target);
	            }
	        };
	        Track.prototype._addToTarget = function (target) {
	            var valType = this.valType;
	            var propName = this.propName;
	            var additiveValue = this._additiveValue;
	            if (valType === VALUE_TYPE_NUMBER) {
	                target[propName] = target[propName] + additiveValue;
	            }
	            else if (valType === VALUE_TYPE_COLOR) {
	                parse(target[propName], tmpRgba);
	                add1DArray(tmpRgba, tmpRgba, additiveValue, 1);
	                target[propName] = rgba2String(tmpRgba);
	            }
	            else if (valType === VALUE_TYPE_1D_ARRAY) {
	                add1DArray(target[propName], target[propName], additiveValue, 1);
	            }
	            else if (valType === VALUE_TYPE_2D_ARRAY) {
	                add2DArray(target[propName], target[propName], additiveValue, 1);
	            }
	        };
	        return Track;
	    }());
	    var Animator = (function () {
	        function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
	            this._tracks = {};
	            this._trackKeys = [];
	            this._maxTime = 0;
	            this._started = 0;
	            this._clip = null;
	            this._target = target;
	            this._loop = loop;
	            if (loop && additiveTo) {
	                logError('Can\' use additive animation on looped animation.');
	                return;
	            }
	            this._additiveAnimators = additiveTo;
	            this._allowDiscrete = allowDiscreteAnimation;
	        }
	        Animator.prototype.getMaxTime = function () {
	            return this._maxTime;
	        };
	        Animator.prototype.getDelay = function () {
	            return this._delay;
	        };
	        Animator.prototype.getLoop = function () {
	            return this._loop;
	        };
	        Animator.prototype.getTarget = function () {
	            return this._target;
	        };
	        Animator.prototype.changeTarget = function (target) {
	            this._target = target;
	        };
	        Animator.prototype.when = function (time, props, easing) {
	            return this.whenWithKeys(time, props, keys(props), easing);
	        };
	        Animator.prototype.whenWithKeys = function (time, props, propNames, easing) {
	            var tracks = this._tracks;
	            for (var i = 0; i < propNames.length; i++) {
	                var propName = propNames[i];
	                var track = tracks[propName];
	                if (!track) {
	                    track = tracks[propName] = new Track(propName);
	                    var initialValue = void 0;
	                    var additiveTrack = this._getAdditiveTrack(propName);
	                    if (additiveTrack) {
	                        var addtiveTrackKfs = additiveTrack.keyframes;
	                        var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
	                        initialValue = lastFinalKf && lastFinalKf.value;
	                        if (additiveTrack.valType === VALUE_TYPE_COLOR && initialValue) {
	                            initialValue = rgba2String(initialValue);
	                        }
	                    }
	                    else {
	                        initialValue = this._target[propName];
	                    }
	                    if (initialValue == null) {
	                        continue;
	                    }
	                    if (time > 0) {
	                        track.addKeyframe(0, cloneValue(initialValue), easing);
	                    }
	                    this._trackKeys.push(propName);
	                }
	                track.addKeyframe(time, cloneValue(props[propName]), easing);
	            }
	            this._maxTime = Math.max(this._maxTime, time);
	            return this;
	        };
	        Animator.prototype.pause = function () {
	            this._clip.pause();
	            this._paused = true;
	        };
	        Animator.prototype.resume = function () {
	            this._clip.resume();
	            this._paused = false;
	        };
	        Animator.prototype.isPaused = function () {
	            return !!this._paused;
	        };
	        Animator.prototype.duration = function (duration) {
	            this._maxTime = duration;
	            this._force = true;
	            return this;
	        };
	        Animator.prototype._doneCallback = function () {
	            this._setTracksFinished();
	            this._clip = null;
	            var doneList = this._doneCbs;
	            if (doneList) {
	                var len = doneList.length;
	                for (var i = 0; i < len; i++) {
	                    doneList[i].call(this);
	                }
	            }
	        };
	        Animator.prototype._abortedCallback = function () {
	            this._setTracksFinished();
	            var animation = this.animation;
	            var abortedList = this._abortedCbs;
	            if (animation) {
	                animation.removeClip(this._clip);
	            }
	            this._clip = null;
	            if (abortedList) {
	                for (var i = 0; i < abortedList.length; i++) {
	                    abortedList[i].call(this);
	                }
	            }
	        };
	        Animator.prototype._setTracksFinished = function () {
	            var tracks = this._tracks;
	            var tracksKeys = this._trackKeys;
	            for (var i = 0; i < tracksKeys.length; i++) {
	                tracks[tracksKeys[i]].setFinished();
	            }
	        };
	        Animator.prototype._getAdditiveTrack = function (trackName) {
	            var additiveTrack;
	            var additiveAnimators = this._additiveAnimators;
	            if (additiveAnimators) {
	                for (var i = 0; i < additiveAnimators.length; i++) {
	                    var track = additiveAnimators[i].getTrack(trackName);
	                    if (track) {
	                        additiveTrack = track;
	                    }
	                }
	            }
	            return additiveTrack;
	        };
	        Animator.prototype.start = function (easing) {
	            if (this._started > 0) {
	                return;
	            }
	            this._started = 1;
	            var self = this;
	            var tracks = [];
	            var maxTime = this._maxTime || 0;
	            for (var i = 0; i < this._trackKeys.length; i++) {
	                var propName = this._trackKeys[i];
	                var track = this._tracks[propName];
	                var additiveTrack = this._getAdditiveTrack(propName);
	                var kfs = track.keyframes;
	                var kfsNum = kfs.length;
	                track.prepare(maxTime, additiveTrack);
	                if (track.needsAnimate()) {
	                    if (!this._allowDiscrete && track.discrete) {
	                        var lastKf = kfs[kfsNum - 1];
	                        if (lastKf) {
	                            self._target[track.propName] = lastKf.rawValue;
	                        }
	                        track.setFinished();
	                    }
	                    else {
	                        tracks.push(track);
	                    }
	                }
	            }
	            if (tracks.length || this._force) {
	                var clip = new Clip({
	                    life: maxTime,
	                    loop: this._loop,
	                    delay: this._delay || 0,
	                    onframe: function (percent) {
	                        self._started = 2;
	                        var additiveAnimators = self._additiveAnimators;
	                        if (additiveAnimators) {
	                            var stillHasAdditiveAnimator = false;
	                            for (var i = 0; i < additiveAnimators.length; i++) {
	                                if (additiveAnimators[i]._clip) {
	                                    stillHasAdditiveAnimator = true;
	                                    break;
	                                }
	                            }
	                            if (!stillHasAdditiveAnimator) {
	                                self._additiveAnimators = null;
	                            }
	                        }
	                        for (var i = 0; i < tracks.length; i++) {
	                            tracks[i].step(self._target, percent);
	                        }
	                        var onframeList = self._onframeCbs;
	                        if (onframeList) {
	                            for (var i = 0; i < onframeList.length; i++) {
	                                onframeList[i](self._target, percent);
	                            }
	                        }
	                    },
	                    ondestroy: function () {
	                        self._doneCallback();
	                    }
	                });
	                this._clip = clip;
	                if (this.animation) {
	                    this.animation.addClip(clip);
	                }
	                if (easing) {
	                    clip.setEasing(easing);
	                }
	            }
	            else {
	                this._doneCallback();
	            }
	            return this;
	        };
	        Animator.prototype.stop = function (forwardToLast) {
	            if (!this._clip) {
	                return;
	            }
	            var clip = this._clip;
	            if (forwardToLast) {
	                clip.onframe(1);
	            }
	            this._abortedCallback();
	        };
	        Animator.prototype.delay = function (time) {
	            this._delay = time;
	            return this;
	        };
	        Animator.prototype.during = function (cb) {
	            if (cb) {
	                if (!this._onframeCbs) {
	                    this._onframeCbs = [];
	                }
	                this._onframeCbs.push(cb);
	            }
	            return this;
	        };
	        Animator.prototype.done = function (cb) {
	            if (cb) {
	                if (!this._doneCbs) {
	                    this._doneCbs = [];
	                }
	                this._doneCbs.push(cb);
	            }
	            return this;
	        };
	        Animator.prototype.aborted = function (cb) {
	            if (cb) {
	                if (!this._abortedCbs) {
	                    this._abortedCbs = [];
	                }
	                this._abortedCbs.push(cb);
	            }
	            return this;
	        };
	        Animator.prototype.getClip = function () {
	            return this._clip;
	        };
	        Animator.prototype.getTrack = function (propName) {
	            return this._tracks[propName];
	        };
	        Animator.prototype.getTracks = function () {
	            var _this = this;
	            return map(this._trackKeys, function (key) { return _this._tracks[key]; });
	        };
	        Animator.prototype.stopTracks = function (propNames, forwardToLast) {
	            if (!propNames.length || !this._clip) {
	                return true;
	            }
	            var tracks = this._tracks;
	            var tracksKeys = this._trackKeys;
	            for (var i = 0; i < propNames.length; i++) {
	                var track = tracks[propNames[i]];
	                if (track && !track.isFinished()) {
	                    if (forwardToLast) {
	                        track.step(this._target, 1);
	                    }
	                    else if (this._started === 1) {
	                        track.step(this._target, 0);
	                    }
	                    track.setFinished();
	                }
	            }
	            var allAborted = true;
	            for (var i = 0; i < tracksKeys.length; i++) {
	                if (!tracks[tracksKeys[i]].isFinished()) {
	                    allAborted = false;
	                    break;
	                }
	            }
	            if (allAborted) {
	                this._abortedCallback();
	            }
	            return allAborted;
	        };
	        Animator.prototype.saveTo = function (target, trackKeys, firstOrLast) {
	            if (!target) {
	                return;
	            }
	            trackKeys = trackKeys || this._trackKeys;
	            for (var i = 0; i < trackKeys.length; i++) {
	                var propName = trackKeys[i];
	                var track = this._tracks[propName];
	                if (!track || track.isFinished()) {
	                    continue;
	                }
	                var kfs = track.keyframes;
	                var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
	                if (kf) {
	                    target[propName] = cloneValue(kf.rawValue);
	                }
	            }
	        };
	        Animator.prototype.__changeFinalValue = function (finalProps, trackKeys) {
	            trackKeys = trackKeys || keys(finalProps);
	            for (var i = 0; i < trackKeys.length; i++) {
	                var propName = trackKeys[i];
	                var track = this._tracks[propName];
	                if (!track) {
	                    continue;
	                }
	                var kfs = track.keyframes;
	                if (kfs.length > 1) {
	                    var lastKf = kfs.pop();
	                    track.addKeyframe(lastKf.time, finalProps[propName]);
	                    track.prepare(this._maxTime, track.getAdditiveTrack());
	                }
	            }
	        };
	        return Animator;
	    }());
	
	    function getTime() {
	        return new Date().getTime();
	    }
	    var Animation = (function (_super) {
	        __extends(Animation, _super);
	        function Animation(opts) {
	            var _this = _super.call(this) || this;
	            _this._running = false;
	            _this._time = 0;
	            _this._pausedTime = 0;
	            _this._pauseStart = 0;
	            _this._paused = false;
	            opts = opts || {};
	            _this.stage = opts.stage || {};
	            return _this;
	        }
	        Animation.prototype.addClip = function (clip) {
	            if (clip.animation) {
	                this.removeClip(clip);
	            }
	            if (!this._head) {
	                this._head = this._tail = clip;
	            }
	            else {
	                this._tail.next = clip;
	                clip.prev = this._tail;
	                clip.next = null;
	                this._tail = clip;
	            }
	            clip.animation = this;
	        };
	        Animation.prototype.addAnimator = function (animator) {
	            animator.animation = this;
	            var clip = animator.getClip();
	            if (clip) {
	                this.addClip(clip);
	            }
	        };
	        Animation.prototype.removeClip = function (clip) {
	            if (!clip.animation) {
	                return;
	            }
	            var prev = clip.prev;
	            var next = clip.next;
	            if (prev) {
	                prev.next = next;
	            }
	            else {
	                this._head = next;
	            }
	            if (next) {
	                next.prev = prev;
	            }
	            else {
	                this._tail = prev;
	            }
	            clip.next = clip.prev = clip.animation = null;
	        };
	        Animation.prototype.removeAnimator = function (animator) {
	            var clip = animator.getClip();
	            if (clip) {
	                this.removeClip(clip);
	            }
	            animator.animation = null;
	        };
	        Animation.prototype.update = function (notTriggerFrameAndStageUpdate) {
	            var time = getTime() - this._pausedTime;
	            var delta = time - this._time;
	            var clip = this._head;
	            while (clip) {
	                var nextClip = clip.next;
	                var finished = clip.step(time, delta);
	                if (finished) {
	                    clip.ondestroy();
	                    this.removeClip(clip);
	                    clip = nextClip;
	                }
	                else {
	                    clip = nextClip;
	                }
	            }
	            this._time = time;
	            if (!notTriggerFrameAndStageUpdate) {
	                this.trigger('frame', delta);
	                this.stage.update && this.stage.update();
	            }
	        };
	        Animation.prototype._startLoop = function () {
	            var self = this;
	            this._running = true;
	            function step() {
	                if (self._running) {
	                    requestAnimationFrame$1(step);
	                    !self._paused && self.update();
	                }
	            }
	            requestAnimationFrame$1(step);
	        };
	        Animation.prototype.start = function () {
	            if (this._running) {
	                return;
	            }
	            this._time = getTime();
	            this._pausedTime = 0;
	            this._startLoop();
	        };
	        Animation.prototype.stop = function () {
	            this._running = false;
	        };
	        Animation.prototype.pause = function () {
	            if (!this._paused) {
	                this._pauseStart = getTime();
	                this._paused = true;
	            }
	        };
	        Animation.prototype.resume = function () {
	            if (this._paused) {
	                this._pausedTime += getTime() - this._pauseStart;
	                this._paused = false;
	            }
	        };
	        Animation.prototype.clear = function () {
	            var clip = this._head;
	            while (clip) {
	                var nextClip = clip.next;
	                clip.prev = clip.next = clip.animation = null;
	                clip = nextClip;
	            }
	            this._head = this._tail = null;
	        };
	        Animation.prototype.isFinished = function () {
	            return this._head == null;
	        };
	        Animation.prototype.animate = function (target, options) {
	            options = options || {};
	            this.start();
	            var animator = new Animator(target, options.loop);
	            this.addAnimator(animator);
	            return animator;
	        };
	        return Animation;
	    }(Eventful));
	
	    var TOUCH_CLICK_DELAY = 300;
	    var globalEventSupported = env.domSupported;
	    var localNativeListenerNames = (function () {
	        var mouseHandlerNames = [
	            'click', 'dblclick', 'mousewheel', 'wheel', 'mouseout',
	            'mouseup', 'mousedown', 'mousemove', 'contextmenu'
	        ];
	        var touchHandlerNames = [
	            'touchstart', 'touchend', 'touchmove'
	        ];
	        var pointerEventNameMap = {
	            pointerdown: 1, pointerup: 1, pointermove: 1, pointerout: 1
	        };
	        var pointerHandlerNames = map(mouseHandlerNames, function (name) {
	            var nm = name.replace('mouse', 'pointer');
	            return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
	        });
	        return {
	            mouse: mouseHandlerNames,
	            touch: touchHandlerNames,
	            pointer: pointerHandlerNames
	        };
	    })();
	    var globalNativeListenerNames = {
	        mouse: ['mousemove', 'mouseup'],
	        pointer: ['pointermove', 'pointerup']
	    };
	    var wheelEventSupported = false;
	    function isPointerFromTouch(event) {
	        var pointerType = event.pointerType;
	        return pointerType === 'pen' || pointerType === 'touch';
	    }
	    function setTouchTimer(scope) {
	        scope.touching = true;
	        if (scope.touchTimer != null) {
	            clearTimeout(scope.touchTimer);
	            scope.touchTimer = null;
	        }
	        scope.touchTimer = setTimeout(function () {
	            scope.touching = false;
	            scope.touchTimer = null;
	        }, 700);
	    }
	    function markTouch(event) {
	        event && (event.zrByTouch = true);
	    }
	    function normalizeGlobalEvent(instance, event) {
	        return normalizeEvent(instance.dom, new FakeGlobalEvent(instance, event), true);
	    }
	    function isLocalEl(instance, el) {
	        var elTmp = el;
	        var isLocal = false;
	        while (elTmp && elTmp.nodeType !== 9
	            && !(isLocal = elTmp.domBelongToZr
	                || (elTmp !== el && elTmp === instance.painterRoot))) {
	            elTmp = elTmp.parentNode;
	        }
	        return isLocal;
	    }
	    var FakeGlobalEvent = (function () {
	        function FakeGlobalEvent(instance, event) {
	            this.stopPropagation = noop;
	            this.stopImmediatePropagation = noop;
	            this.preventDefault = noop;
	            this.type = event.type;
	            this.target = this.currentTarget = instance.dom;
	            this.pointerType = event.pointerType;
	            this.clientX = event.clientX;
	            this.clientY = event.clientY;
	        }
	        return FakeGlobalEvent;
	    }());
	    var localDOMHandlers = {
	        mousedown: function (event) {
	            event = normalizeEvent(this.dom, event);
	            this.__mayPointerCapture = [event.zrX, event.zrY];
	            this.trigger('mousedown', event);
	        },
	        mousemove: function (event) {
	            event = normalizeEvent(this.dom, event);
	            var downPoint = this.__mayPointerCapture;
	            if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) {
	                this.__togglePointerCapture(true);
	            }
	            this.trigger('mousemove', event);
	        },
	        mouseup: function (event) {
	            event = normalizeEvent(this.dom, event);
	            this.__togglePointerCapture(false);
	            this.trigger('mouseup', event);
	        },
	        mouseout: function (event) {
	            event = normalizeEvent(this.dom, event);
	            var element = event.toElement || event.relatedTarget;
	            if (!isLocalEl(this, element)) {
	                if (this.__pointerCapturing) {
	                    event.zrEventControl = 'no_globalout';
	                }
	                this.trigger('mouseout', event);
	            }
	        },
	        wheel: function (event) {
	            wheelEventSupported = true;
	            event = normalizeEvent(this.dom, event);
	            this.trigger('mousewheel', event);
	        },
	        mousewheel: function (event) {
	            if (wheelEventSupported) {
	                return;
	            }
	            event = normalizeEvent(this.dom, event);
	            this.trigger('mousewheel', event);
	        },
	        touchstart: function (event) {
	            event = normalizeEvent(this.dom, event);
	            markTouch(event);
	            this.__lastTouchMoment = new Date();
	            this.handler.processGesture(event, 'start');
	            localDOMHandlers.mousemove.call(this, event);
	            localDOMHandlers.mousedown.call(this, event);
	        },
	        touchmove: function (event) {
	            event = normalizeEvent(this.dom, event);
	            markTouch(event);
	            this.handler.processGesture(event, 'change');
	            localDOMHandlers.mousemove.call(this, event);
	        },
	        touchend: function (event) {
	            event = normalizeEvent(this.dom, event);
	            markTouch(event);
	            this.handler.processGesture(event, 'end');
	            localDOMHandlers.mouseup.call(this, event);
	            if (+new Date() - (+this.__lastTouchMoment) < TOUCH_CLICK_DELAY) {
	                localDOMHandlers.click.call(this, event);
	            }
	        },
	        pointerdown: function (event) {
	            localDOMHandlers.mousedown.call(this, event);
	        },
	        pointermove: function (event) {
	            if (!isPointerFromTouch(event)) {
	                localDOMHandlers.mousemove.call(this, event);
	            }
	        },
	        pointerup: function (event) {
	            localDOMHandlers.mouseup.call(this, event);
	        },
	        pointerout: function (event) {
	            if (!isPointerFromTouch(event)) {
	                localDOMHandlers.mouseout.call(this, event);
	            }
	        }
	    };
	    each(['click', 'dblclick', 'contextmenu'], function (name) {
	        localDOMHandlers[name] = function (event) {
	            event = normalizeEvent(this.dom, event);
	            this.trigger(name, event);
	        };
	    });
	    var globalDOMHandlers = {
	        pointermove: function (event) {
	            if (!isPointerFromTouch(event)) {
	                globalDOMHandlers.mousemove.call(this, event);
	            }
	        },
	        pointerup: function (event) {
	            globalDOMHandlers.mouseup.call(this, event);
	        },
	        mousemove: function (event) {
	            this.trigger('mousemove', event);
	        },
	        mouseup: function (event) {
	            var pointerCaptureReleasing = this.__pointerCapturing;
	            this.__togglePointerCapture(false);
	            this.trigger('mouseup', event);
	            if (pointerCaptureReleasing) {
	                event.zrEventControl = 'only_globalout';
	                this.trigger('mouseout', event);
	            }
	        }
	    };
	    function mountLocalDOMEventListeners(instance, scope) {
	        var domHandlers = scope.domHandlers;
	        if (env.pointerEventsSupported) {
	            each(localNativeListenerNames.pointer, function (nativeEventName) {
	                mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	                    domHandlers[nativeEventName].call(instance, event);
	                });
	            });
	        }
	        else {
	            if (env.touchEventsSupported) {
	                each(localNativeListenerNames.touch, function (nativeEventName) {
	                    mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	                        domHandlers[nativeEventName].call(instance, event);
	                        setTouchTimer(scope);
	                    });
	                });
	            }
	            each(localNativeListenerNames.mouse, function (nativeEventName) {
	                mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	                    event = getNativeEvent(event);
	                    if (!scope.touching) {
	                        domHandlers[nativeEventName].call(instance, event);
	                    }
	                });
	            });
	        }
	    }
	    function mountGlobalDOMEventListeners(instance, scope) {
	        if (env.pointerEventsSupported) {
	            each(globalNativeListenerNames.pointer, mount);
	        }
	        else if (!env.touchEventsSupported) {
	            each(globalNativeListenerNames.mouse, mount);
	        }
	        function mount(nativeEventName) {
	            function nativeEventListener(event) {
	                event = getNativeEvent(event);
	                if (!isLocalEl(instance, event.target)) {
	                    event = normalizeGlobalEvent(instance, event);
	                    scope.domHandlers[nativeEventName].call(instance, event);
	                }
	            }
	            mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, { capture: true });
	        }
	    }
	    function mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
	        scope.mounted[nativeEventName] = listener;
	        scope.listenerOpts[nativeEventName] = opt;
	        addEventListener(scope.domTarget, nativeEventName, listener, opt);
	    }
	    function unmountDOMEventListeners(scope) {
	        var mounted = scope.mounted;
	        for (var nativeEventName in mounted) {
	            if (mounted.hasOwnProperty(nativeEventName)) {
	                removeEventListener(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
	            }
	        }
	        scope.mounted = {};
	    }
	    var DOMHandlerScope = (function () {
	        function DOMHandlerScope(domTarget, domHandlers) {
	            this.mounted = {};
	            this.listenerOpts = {};
	            this.touching = false;
	            this.domTarget = domTarget;
	            this.domHandlers = domHandlers;
	        }
	        return DOMHandlerScope;
	    }());
	    var HandlerDomProxy = (function (_super) {
	        __extends(HandlerDomProxy, _super);
	        function HandlerDomProxy(dom, painterRoot) {
	            var _this = _super.call(this) || this;
	            _this.__pointerCapturing = false;
	            _this.dom = dom;
	            _this.painterRoot = painterRoot;
	            _this._localHandlerScope = new DOMHandlerScope(dom, localDOMHandlers);
	            if (globalEventSupported) {
	                _this._globalHandlerScope = new DOMHandlerScope(document, globalDOMHandlers);
	            }
	            mountLocalDOMEventListeners(_this, _this._localHandlerScope);
	            return _this;
	        }
	        HandlerDomProxy.prototype.dispose = function () {
	            unmountDOMEventListeners(this._localHandlerScope);
	            if (globalEventSupported) {
	                unmountDOMEventListeners(this._globalHandlerScope);
	            }
	        };
	        HandlerDomProxy.prototype.setCursor = function (cursorStyle) {
	            this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
	        };
	        HandlerDomProxy.prototype.__togglePointerCapture = function (isPointerCapturing) {
	            this.__mayPointerCapture = null;
	            if (globalEventSupported
	                && ((+this.__pointerCapturing) ^ (+isPointerCapturing))) {
	                this.__pointerCapturing = isPointerCapturing;
	                var globalHandlerScope = this._globalHandlerScope;
	                isPointerCapturing
	                    ? mountGlobalDOMEventListeners(this, globalHandlerScope)
	                    : unmountDOMEventListeners(globalHandlerScope);
	            }
	        };
	        return HandlerDomProxy;
	    }(Eventful));
	
	    var dpr = 1;
	    if (env.hasGlobalWindow) {
	        dpr = Math.max(window.devicePixelRatio
	            || (window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI)
	            || 1, 1);
	    }
	    var devicePixelRatio = dpr;
	    var DARK_MODE_THRESHOLD = 0.4;
	    var DARK_LABEL_COLOR = '#333';
	    var LIGHT_LABEL_COLOR = '#ccc';
	    var LIGHTER_LABEL_COLOR = '#eee';
	
	    var mIdentity = identity;
	    var EPSILON$2 = 5e-5;
	    function isNotAroundZero$1(val) {
	        return val > EPSILON$2 || val < -EPSILON$2;
	    }
	    var scaleTmp = [];
	    var tmpTransform = [];
	    var originTransform = create$1();
	    var abs = Math.abs;
	    var Transformable = (function () {
	        function Transformable() {
	        }
	        Transformable.prototype.getLocalTransform = function (m) {
	            return Transformable.getLocalTransform(this, m);
	        };
	        Transformable.prototype.setPosition = function (arr) {
	            this.x = arr[0];
	            this.y = arr[1];
	        };
	        Transformable.prototype.setScale = function (arr) {
	            this.scaleX = arr[0];
	            this.scaleY = arr[1];
	        };
	        Transformable.prototype.setSkew = function (arr) {
	            this.skewX = arr[0];
	            this.skewY = arr[1];
	        };
	        Transformable.prototype.setOrigin = function (arr) {
	            this.originX = arr[0];
	            this.originY = arr[1];
	        };
	        Transformable.prototype.needLocalTransform = function () {
	            return isNotAroundZero$1(this.rotation)
	                || isNotAroundZero$1(this.x)
	                || isNotAroundZero$1(this.y)
	                || isNotAroundZero$1(this.scaleX - 1)
	                || isNotAroundZero$1(this.scaleY - 1)
	                || isNotAroundZero$1(this.skewX)
	                || isNotAroundZero$1(this.skewY);
	        };
	        Transformable.prototype.updateTransform = function () {
	            var parentTransform = this.parent && this.parent.transform;
	            var needLocalTransform = this.needLocalTransform();
	            var m = this.transform;
	            if (!(needLocalTransform || parentTransform)) {
	                if (m) {
	                    mIdentity(m);
	                    this.invTransform = null;
	                }
	                return;
	            }
	            m = m || create$1();
	            if (needLocalTransform) {
	                this.getLocalTransform(m);
	            }
	            else {
	                mIdentity(m);
	            }
	            if (parentTransform) {
	                if (needLocalTransform) {
	                    mul$1(m, parentTransform, m);
	                }
	                else {
	                    copy$1(m, parentTransform);
	                }
	            }
	            this.transform = m;
	            this._resolveGlobalScaleRatio(m);
	        };
	        Transformable.prototype._resolveGlobalScaleRatio = function (m) {
	            var globalScaleRatio = this.globalScaleRatio;
	            if (globalScaleRatio != null && globalScaleRatio !== 1) {
	                this.getGlobalScale(scaleTmp);
	                var relX = scaleTmp[0] < 0 ? -1 : 1;
	                var relY = scaleTmp[1] < 0 ? -1 : 1;
	                var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
	                var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
	                m[0] *= sx;
	                m[1] *= sx;
	                m[2] *= sy;
	                m[3] *= sy;
	            }
	            this.invTransform = this.invTransform || create$1();
	            invert(this.invTransform, m);
	        };
	        Transformable.prototype.getComputedTransform = function () {
	            var transformNode = this;
	            var ancestors = [];
	            while (transformNode) {
	                ancestors.push(transformNode);
	                transformNode = transformNode.parent;
	            }
	            while (transformNode = ancestors.pop()) {
	                transformNode.updateTransform();
	            }
	            return this.transform;
	        };
	        Transformable.prototype.setLocalTransform = function (m) {
	            if (!m) {
	                return;
	            }
	            var sx = m[0] * m[0] + m[1] * m[1];
	            var sy = m[2] * m[2] + m[3] * m[3];
	            var rotation = Math.atan2(m[1], m[0]);
	            var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
	            sy = Math.sqrt(sy) * Math.cos(shearX);
	            sx = Math.sqrt(sx);
	            this.skewX = shearX;
	            this.skewY = 0;
	            this.rotation = -rotation;
	            this.x = +m[4];
	            this.y = +m[5];
	            this.scaleX = sx;
	            this.scaleY = sy;
	            this.originX = 0;
	            this.originY = 0;
	        };
	        Transformable.prototype.decomposeTransform = function () {
	            if (!this.transform) {
	                return;
	            }
	            var parent = this.parent;
	            var m = this.transform;
	            if (parent && parent.transform) {
	                mul$1(tmpTransform, parent.invTransform, m);
	                m = tmpTransform;
	            }
	            var ox = this.originX;
	            var oy = this.originY;
	            if (ox || oy) {
	                originTransform[4] = ox;
	                originTransform[5] = oy;
	                mul$1(tmpTransform, m, originTransform);
	                tmpTransform[4] -= ox;
	                tmpTransform[5] -= oy;
	                m = tmpTransform;
	            }
	            this.setLocalTransform(m);
	        };
	        Transformable.prototype.getGlobalScale = function (out) {
	            var m = this.transform;
	            out = out || [];
	            if (!m) {
	                out[0] = 1;
	                out[1] = 1;
	                return out;
	            }
	            out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
	            out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
	            if (m[0] < 0) {
	                out[0] = -out[0];
	            }
	            if (m[3] < 0) {
	                out[1] = -out[1];
	            }
	            return out;
	        };
	        Transformable.prototype.transformCoordToLocal = function (x, y) {
	            var v2 = [x, y];
	            var invTransform = this.invTransform;
	            if (invTransform) {
	                applyTransform(v2, v2, invTransform);
	            }
	            return v2;
	        };
	        Transformable.prototype.transformCoordToGlobal = function (x, y) {
	            var v2 = [x, y];
	            var transform = this.transform;
	            if (transform) {
	                applyTransform(v2, v2, transform);
	            }
	            return v2;
	        };
	        Transformable.prototype.getLineScale = function () {
	            var m = this.transform;
	            return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10
	                ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1]))
	                : 1;
	        };
	        Transformable.prototype.copyTransform = function (source) {
	            copyTransform(this, source);
	        };
	        Transformable.getLocalTransform = function (target, m) {
	            m = m || [];
	            var ox = target.originX || 0;
	            var oy = target.originY || 0;
	            var sx = target.scaleX;
	            var sy = target.scaleY;
	            var ax = target.anchorX;
	            var ay = target.anchorY;
	            var rotation = target.rotation || 0;
	            var x = target.x;
	            var y = target.y;
	            var skewX = target.skewX ? Math.tan(target.skewX) : 0;
	            var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
	            if (ox || oy || ax || ay) {
	                var dx = ox + ax;
	                var dy = oy + ay;
	                m[4] = -dx * sx - skewX * dy * sy;
	                m[5] = -dy * sy - skewY * dx * sx;
	            }
	            else {
	                m[4] = m[5] = 0;
	            }
	            m[0] = sx;
	            m[3] = sy;
	            m[1] = skewY * sx;
	            m[2] = skewX * sy;
	            rotation && rotate(m, m, rotation);
	            m[4] += ox + x;
	            m[5] += oy + y;
	            return m;
	        };
	        Transformable.initDefaultProps = (function () {
	            var proto = Transformable.prototype;
	            proto.scaleX =
	                proto.scaleY =
	                    proto.globalScaleRatio = 1;
	            proto.x =
	                proto.y =
	                    proto.originX =
	                        proto.originY =
	                            proto.skewX =
	                                proto.skewY =
	                                    proto.rotation =
	                                        proto.anchorX =
	                                            proto.anchorY = 0;
	        })();
	        return Transformable;
	    }());
	    var TRANSFORMABLE_PROPS = [
	        'x', 'y', 'originX', 'originY', 'anchorX', 'anchorY', 'rotation', 'scaleX', 'scaleY', 'skewX', 'skewY'
	    ];
	    function copyTransform(target, source) {
	        for (var i = 0; i < TRANSFORMABLE_PROPS.length; i++) {
	            var propName = TRANSFORMABLE_PROPS[i];
	            target[propName] = source[propName];
	        }
	    }
	
	    var textWidthCache = {};
	    function getWidth(text, font) {
	        font = font || DEFAULT_FONT;
	        var cacheOfFont = textWidthCache[font];
	        if (!cacheOfFont) {
	            cacheOfFont = textWidthCache[font] = new LRU(500);
	        }
	        var width = cacheOfFont.get(text);
	        if (width == null) {
	            width = platformApi.measureText(text, font).width;
	            cacheOfFont.put(text, width);
	        }
	        return width;
	    }
	    function innerGetBoundingRect(text, font, textAlign, textBaseline) {
	        var width = getWidth(text, font);
	        var height = getLineHeight(font);
	        var x = adjustTextX(0, width, textAlign);
	        var y = adjustTextY$1(0, height, textBaseline);
	        var rect = new BoundingRect(x, y, width, height);
	        return rect;
	    }
	    function getBoundingRect(text, font, textAlign, textBaseline) {
	        var textLines = ((text || '') + '').split('\n');
	        var len = textLines.length;
	        if (len === 1) {
	            return innerGetBoundingRect(textLines[0], font, textAlign, textBaseline);
	        }
	        else {
	            var uniondRect = new BoundingRect(0, 0, 0, 0);
	            for (var i = 0; i < textLines.length; i++) {
	                var rect = innerGetBoundingRect(textLines[i], font, textAlign, textBaseline);
	                i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
	            }
	            return uniondRect;
	        }
	    }
	    function adjustTextX(x, width, textAlign) {
	        if (textAlign === 'right') {
	            x -= width;
	        }
	        else if (textAlign === 'center') {
	            x -= width / 2;
	        }
	        return x;
	    }
	    function adjustTextY$1(y, height, verticalAlign) {
	        if (verticalAlign === 'middle') {
	            y -= height / 2;
	        }
	        else if (verticalAlign === 'bottom') {
	            y -= height;
	        }
	        return y;
	    }
	    function getLineHeight(font) {
	        return getWidth('国', font);
	    }
	    function parsePercent(value, maxValue) {
	        if (typeof value === 'string') {
	            if (value.lastIndexOf('%') >= 0) {
	                return parseFloat(value) / 100 * maxValue;
	            }
	            return parseFloat(value);
	        }
	        return value;
	    }
	    function calculateTextPosition(out, opts, rect) {
	        var textPosition = opts.position || 'inside';
	        var distance = opts.distance != null ? opts.distance : 5;
	        var height = rect.height;
	        var width = rect.width;
	        var halfHeight = height / 2;
	        var x = rect.x;
	        var y = rect.y;
	        var textAlign = 'left';
	        var textVerticalAlign = 'top';
	        if (textPosition instanceof Array) {
	            x += parsePercent(textPosition[0], rect.width);
	            y += parsePercent(textPosition[1], rect.height);
	            textAlign = null;
	            textVerticalAlign = null;
	        }
	        else {
	            switch (textPosition) {
	                case 'left':
	                    x -= distance;
	                    y += halfHeight;
	                    textAlign = 'right';
	                    textVerticalAlign = 'middle';
	                    break;
	                case 'right':
	                    x += distance + width;
	                    y += halfHeight;
	                    textVerticalAlign = 'middle';
	                    break;
	                case 'top':
	                    x += width / 2;
	                    y -= distance;
	                    textAlign = 'center';
	                    textVerticalAlign = 'bottom';
	                    break;
	                case 'bottom':
	                    x += width / 2;
	                    y += height + distance;
	                    textAlign = 'center';
	                    break;
	                case 'inside':
	                    x += width / 2;
	                    y += halfHeight;
	                    textAlign = 'center';
	                    textVerticalAlign = 'middle';
	                    break;
	                case 'insideLeft':
	                    x += distance;
	                    y += halfHeight;
	                    textVerticalAlign = 'middle';
	                    break;
	                case 'insideRight':
	                    x += width - distance;
	                    y += halfHeight;
	                    textAlign = 'right';
	                    textVerticalAlign = 'middle';
	                    break;
	                case 'insideTop':
	                    x += width / 2;
	                    y += distance;
	                    textAlign = 'center';
	                    break;
	                case 'insideBottom':
	                    x += width / 2;
	                    y += height - distance;
	                    textAlign = 'center';
	                    textVerticalAlign = 'bottom';
	                    break;
	                case 'insideTopLeft':
	                    x += distance;
	                    y += distance;
	                    break;
	                case 'insideTopRight':
	                    x += width - distance;
	                    y += distance;
	                    textAlign = 'right';
	                    break;
	                case 'insideBottomLeft':
	                    x += distance;
	                    y += height - distance;
	                    textVerticalAlign = 'bottom';
	                    break;
	                case 'insideBottomRight':
	                    x += width - distance;
	                    y += height - distance;
	                    textAlign = 'right';
	                    textVerticalAlign = 'bottom';
	                    break;
	            }
	        }
	        out = out || {};
	        out.x = x;
	        out.y = y;
	        out.align = textAlign;
	        out.verticalAlign = textVerticalAlign;
	        return out;
	    }
	
	    var PRESERVED_NORMAL_STATE = '__zr_normal__';
	    var PRIMARY_STATES_KEYS = TRANSFORMABLE_PROPS.concat(['ignore']);
	    var DEFAULT_ANIMATABLE_MAP = reduce(TRANSFORMABLE_PROPS, function (obj, key) {
	        obj[key] = true;
	        return obj;
	    }, { ignore: false });
	    var tmpTextPosCalcRes = {};
	    var tmpBoundingRect = new BoundingRect(0, 0, 0, 0);
	    var Element = (function () {
	        function Element(props) {
	            this.id = guid();
	            this.animators = [];
	            this.currentStates = [];
	            this.states = {};
	            this._init(props);
	        }
	        Element.prototype._init = function (props) {
	            this.attr(props);
	        };
	        Element.prototype.drift = function (dx, dy, e) {
	            switch (this.draggable) {
	                case 'horizontal':
	                    dy = 0;
	                    break;
	                case 'vertical':
	                    dx = 0;
	                    break;
	            }
	            var m = this.transform;
	            if (!m) {
	                m = this.transform = [1, 0, 0, 1, 0, 0];
	            }
	            m[4] += dx;
	            m[5] += dy;
	            this.decomposeTransform();
	            this.markRedraw();
	        };
	        Element.prototype.beforeUpdate = function () { };
	        Element.prototype.afterUpdate = function () { };
	        Element.prototype.update = function () {
	            this.updateTransform();
	            if (this.__dirty) {
	                this.updateInnerText();
	            }
	        };
	        Element.prototype.updateInnerText = function (forceUpdate) {
	            var textEl = this._textContent;
	            if (textEl && (!textEl.ignore || forceUpdate)) {
	                if (!this.textConfig) {
	                    this.textConfig = {};
	                }
	                var textConfig = this.textConfig;
	                var isLocal = textConfig.local;
	                var innerTransformable = textEl.innerTransformable;
	                var textAlign = void 0;
	                var textVerticalAlign = void 0;
	                var textStyleChanged = false;
	                innerTransformable.parent = isLocal ? this : null;
	                var innerOrigin = false;
	                innerTransformable.copyTransform(textEl);
	                if (textConfig.position != null) {
	                    var layoutRect = tmpBoundingRect;
	                    if (textConfig.layoutRect) {
	                        layoutRect.copy(textConfig.layoutRect);
	                    }
	                    else {
	                        layoutRect.copy(this.getBoundingRect());
	                    }
	                    if (!isLocal) {
	                        layoutRect.applyTransform(this.transform);
	                    }
	                    if (this.calculateTextPosition) {
	                        this.calculateTextPosition(tmpTextPosCalcRes, textConfig, layoutRect);
	                    }
	                    else {
	                        calculateTextPosition(tmpTextPosCalcRes, textConfig, layoutRect);
	                    }
	                    innerTransformable.x = tmpTextPosCalcRes.x;
	                    innerTransformable.y = tmpTextPosCalcRes.y;
	                    textAlign = tmpTextPosCalcRes.align;
	                    textVerticalAlign = tmpTextPosCalcRes.verticalAlign;
	                    var textOrigin = textConfig.origin;
	                    if (textOrigin && textConfig.rotation != null) {
	                        var relOriginX = void 0;
	                        var relOriginY = void 0;
	                        if (textOrigin === 'center') {
	                            relOriginX = layoutRect.width * 0.5;
	                            relOriginY = layoutRect.height * 0.5;
	                        }
	                        else {
	                            relOriginX = parsePercent(textOrigin[0], layoutRect.width);
	                            relOriginY = parsePercent(textOrigin[1], layoutRect.height);
	                        }
	                        innerOrigin = true;
	                        innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
	                        innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
	                    }
	                }
	                if (textConfig.rotation != null) {
	                    innerTransformable.rotation = textConfig.rotation;
	                }
	                var textOffset = textConfig.offset;
	                if (textOffset) {
	                    innerTransformable.x += textOffset[0];
	                    innerTransformable.y += textOffset[1];
	                    if (!innerOrigin) {
	                        innerTransformable.originX = -textOffset[0];
	                        innerTransformable.originY = -textOffset[1];
	                    }
	                }
	                var isInside = textConfig.inside == null
	                    ? (typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0)
	                    : textConfig.inside;
	                var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
	                var textFill = void 0;
	                var textStroke = void 0;
	                var autoStroke = void 0;
	                if (isInside && this.canBeInsideText()) {
	                    textFill = textConfig.insideFill;
	                    textStroke = textConfig.insideStroke;
	                    if (textFill == null || textFill === 'auto') {
	                        textFill = this.getInsideTextFill();
	                    }
	                    if (textStroke == null || textStroke === 'auto') {
	                        textStroke = this.getInsideTextStroke(textFill);
	                        autoStroke = true;
	                    }
	                }
	                else {
	                    textFill = textConfig.outsideFill;
	                    textStroke = textConfig.outsideStroke;
	                    if (textFill == null || textFill === 'auto') {
	                        textFill = this.getOutsideFill();
	                    }
	                    if (textStroke == null || textStroke === 'auto') {
	                        textStroke = this.getOutsideStroke(textFill);
	                        autoStroke = true;
	                    }
	                }
	                textFill = textFill || '#000';
	                if (textFill !== innerTextDefaultStyle.fill
	                    || textStroke !== innerTextDefaultStyle.stroke
	                    || autoStroke !== innerTextDefaultStyle.autoStroke
	                    || textAlign !== innerTextDefaultStyle.align
	                    || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
	                    textStyleChanged = true;
	                    innerTextDefaultStyle.fill = textFill;
	                    innerTextDefaultStyle.stroke = textStroke;
	                    innerTextDefaultStyle.autoStroke = autoStroke;
	                    innerTextDefaultStyle.align = textAlign;
	                    innerTextDefaultStyle.verticalAlign = textVerticalAlign;
	                    textEl.setDefaultTextStyle(innerTextDefaultStyle);
	                }
	                textEl.__dirty |= REDRAW_BIT;
	                if (textStyleChanged) {
	                    textEl.dirtyStyle(true);
	                }
	            }
	        };
	        Element.prototype.canBeInsideText = function () {
	            return true;
	        };
	        Element.prototype.getInsideTextFill = function () {
	            return '#fff';
	        };
	        Element.prototype.getInsideTextStroke = function (textFill) {
	            return '#000';
	        };
	        Element.prototype.getOutsideFill = function () {
	            return this.__zr && this.__zr.isDarkMode() ? LIGHT_LABEL_COLOR : DARK_LABEL_COLOR;
	        };
	        Element.prototype.getOutsideStroke = function (textFill) {
	            var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
	            var colorArr = typeof backgroundColor === 'string' && parse(backgroundColor);
	            if (!colorArr) {
	                colorArr = [255, 255, 255, 1];
	            }
	            var alpha = colorArr[3];
	            var isDark = this.__zr.isDarkMode();
	            for (var i = 0; i < 3; i++) {
	                colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
	            }
	            colorArr[3] = 1;
	            return stringify(colorArr, 'rgba');
	        };
	        Element.prototype.traverse = function (cb, context) { };
	        Element.prototype.attrKV = function (key, value) {
	            if (key === 'textConfig') {
	                this.setTextConfig(value);
	            }
	            else if (key === 'textContent') {
	                this.setTextContent(value);
	            }
	            else if (key === 'clipPath') {
	                this.setClipPath(value);
	            }
	            else if (key === 'extra') {
	                this.extra = this.extra || {};
	                extend(this.extra, value);
	            }
	            else {
	                this[key] = value;
	            }
	        };
	        Element.prototype.hide = function () {
	            this.ignore = true;
	            this.markRedraw();
	        };
	        Element.prototype.show = function () {
	            this.ignore = false;
	            this.markRedraw();
	        };
	        Element.prototype.attr = function (keyOrObj, value) {
	            if (typeof keyOrObj === 'string') {
	                this.attrKV(keyOrObj, value);
	            }
	            else if (isObject(keyOrObj)) {
	                var obj = keyOrObj;
	                var keysArr = keys(obj);
	                for (var i = 0; i < keysArr.length; i++) {
	                    var key = keysArr[i];
	                    this.attrKV(key, keyOrObj[key]);
	                }
	            }
	            this.markRedraw();
	            return this;
	        };
	        Element.prototype.saveCurrentToNormalState = function (toState) {
	            this._innerSaveToNormal(toState);
	            var normalState = this._normalState;
	            for (var i = 0; i < this.animators.length; i++) {
	                var animator = this.animators[i];
	                var fromStateTransition = animator.__fromStateTransition;
	                if (animator.getLoop() || fromStateTransition && fromStateTransition !== PRESERVED_NORMAL_STATE) {
	                    continue;
	                }
	                var targetName = animator.targetName;
	                var target = targetName
	                    ? normalState[targetName] : normalState;
	                animator.saveTo(target);
	            }
	        };
	        Element.prototype._innerSaveToNormal = function (toState) {
	            var normalState = this._normalState;
	            if (!normalState) {
	                normalState = this._normalState = {};
	            }
	            if (toState.textConfig && !normalState.textConfig) {
	                normalState.textConfig = this.textConfig;
	            }
	            this._savePrimaryToNormal(toState, normalState, PRIMARY_STATES_KEYS);
	        };
	        Element.prototype._savePrimaryToNormal = function (toState, normalState, primaryKeys) {
	            for (var i = 0; i < primaryKeys.length; i++) {
	                var key = primaryKeys[i];
	                if (toState[key] != null && !(key in normalState)) {
	                    normalState[key] = this[key];
	                }
	            }
	        };
	        Element.prototype.hasState = function () {
	            return this.currentStates.length > 0;
	        };
	        Element.prototype.getState = function (name) {
	            return this.states[name];
	        };
	        Element.prototype.ensureState = function (name) {
	            var states = this.states;
	            if (!states[name]) {
	                states[name] = {};
	            }
	            return states[name];
	        };
	        Element.prototype.clearStates = function (noAnimation) {
	            this.useState(PRESERVED_NORMAL_STATE, false, noAnimation);
	        };
	        Element.prototype.useState = function (stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
	            var toNormalState = stateName === PRESERVED_NORMAL_STATE;
	            var hasStates = this.hasState();
	            if (!hasStates && toNormalState) {
	                return;
	            }
	            var currentStates = this.currentStates;
	            var animationCfg = this.stateTransition;
	            if (indexOf(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) {
	                return;
	            }
	            var state;
	            if (this.stateProxy && !toNormalState) {
	                state = this.stateProxy(stateName);
	            }
	            if (!state) {
	                state = (this.states && this.states[stateName]);
	            }
	            if (!state && !toNormalState) {
	                logError("State " + stateName + " not exists.");
	                return;
	            }
	            if (!toNormalState) {
	                this.saveCurrentToNormalState(state);
	            }
	            var useHoverLayer = !!((state && state.hoverLayer) || forceUseHoverLayer);
	            if (useHoverLayer) {
	                this._toggleHoverLayerFlag(true);
	            }
	            this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
	            var textContent = this._textContent;
	            var textGuide = this._textGuide;
	            if (textContent) {
	                textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
	            }
	            if (textGuide) {
	                textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
	            }
	            if (toNormalState) {
	                this.currentStates = [];
	                this._normalState = {};
	            }
	            else {
	                if (!keepCurrentStates) {
	                    this.currentStates = [stateName];
	                }
	                else {
	                    this.currentStates.push(stateName);
	                }
	            }
	            this._updateAnimationTargets();
	            this.markRedraw();
	            if (!useHoverLayer && this.__inHover) {
	                this._toggleHoverLayerFlag(false);
	                this.__dirty &= ~REDRAW_BIT;
	            }
	            return state;
	        };
	        Element.prototype.useStates = function (states, noAnimation, forceUseHoverLayer) {
	            if (!states.length) {
	                this.clearStates();
	            }
	            else {
	                var stateObjects = [];
	                var currentStates = this.currentStates;
	                var len = states.length;
	                var notChange = len === currentStates.length;
	                if (notChange) {
	                    for (var i = 0; i < len; i++) {
	                        if (states[i] !== currentStates[i]) {
	                            notChange = false;
	                            break;
	                        }
	                    }
	                }
	                if (notChange) {
	                    return;
	                }
	                for (var i = 0; i < len; i++) {
	                    var stateName = states[i];
	                    var stateObj = void 0;
	                    if (this.stateProxy) {
	                        stateObj = this.stateProxy(stateName, states);
	                    }
	                    if (!stateObj) {
	                        stateObj = this.states[stateName];
	                    }
	                    if (stateObj) {
	                        stateObjects.push(stateObj);
	                    }
	                }
	                var lastStateObj = stateObjects[len - 1];
	                var useHoverLayer = !!((lastStateObj && lastStateObj.hoverLayer) || forceUseHoverLayer);
	                if (useHoverLayer) {
	                    this._toggleHoverLayerFlag(true);
	                }
	                var mergedState = this._mergeStates(stateObjects);
	                var animationCfg = this.stateTransition;
	                this.saveCurrentToNormalState(mergedState);
	                this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
	                var textContent = this._textContent;
	                var textGuide = this._textGuide;
	                if (textContent) {
	                    textContent.useStates(states, noAnimation, useHoverLayer);
	                }
	                if (textGuide) {
	                    textGuide.useStates(states, noAnimation, useHoverLayer);
	                }
	                this._updateAnimationTargets();
	                this.currentStates = states.slice();
	                this.markRedraw();
	                if (!useHoverLayer && this.__inHover) {
	                    this._toggleHoverLayerFlag(false);
	                    this.__dirty &= ~REDRAW_BIT;
	                }
	            }
	        };
	        Element.prototype._updateAnimationTargets = function () {
	            for (var i = 0; i < this.animators.length; i++) {
	                var animator = this.animators[i];
	                if (animator.targetName) {
	                    animator.changeTarget(this[animator.targetName]);
	                }
	            }
	        };
	        Element.prototype.removeState = function (state) {
	            var idx = indexOf(this.currentStates, state);
	            if (idx >= 0) {
	                var currentStates = this.currentStates.slice();
	                currentStates.splice(idx, 1);
	                this.useStates(currentStates);
	            }
	        };
	        Element.prototype.replaceState = function (oldState, newState, forceAdd) {
	            var currentStates = this.currentStates.slice();
	            var idx = indexOf(currentStates, oldState);
	            var newStateExists = indexOf(currentStates, newState) >= 0;
	            if (idx >= 0) {
	                if (!newStateExists) {
	                    currentStates[idx] = newState;
	                }
	                else {
	                    currentStates.splice(idx, 1);
	                }
	            }
	            else if (forceAdd && !newStateExists) {
	                currentStates.push(newState);
	            }
	            this.useStates(currentStates);
	        };
	        Element.prototype.toggleState = function (state, enable) {
	            if (enable) {
	                this.useState(state, true);
	            }
	            else {
	                this.removeState(state);
	            }
	        };
	        Element.prototype._mergeStates = function (states) {
	            var mergedState = {};
	            var mergedTextConfig;
	            for (var i = 0; i < states.length; i++) {
	                var state = states[i];
	                extend(mergedState, state);
	                if (state.textConfig) {
	                    mergedTextConfig = mergedTextConfig || {};
	                    extend(mergedTextConfig, state.textConfig);
	                }
	            }
	            if (mergedTextConfig) {
	                mergedState.textConfig = mergedTextConfig;
	            }
	            return mergedState;
	        };
	        Element.prototype._applyStateObj = function (stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
	            var needsRestoreToNormal = !(state && keepCurrentStates);
	            if (state && state.textConfig) {
	                this.textConfig = extend({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
	                extend(this.textConfig, state.textConfig);
	            }
	            else if (needsRestoreToNormal) {
	                if (normalState.textConfig) {
	                    this.textConfig = normalState.textConfig;
	                }
	            }
	            var transitionTarget = {};
	            var hasTransition = false;
	            for (var i = 0; i < PRIMARY_STATES_KEYS.length; i++) {
	                var key = PRIMARY_STATES_KEYS[i];
	                var propNeedsTransition = transition && DEFAULT_ANIMATABLE_MAP[key];
	                if (state && state[key] != null) {
	                    if (propNeedsTransition) {
	                        hasTransition = true;
	                        transitionTarget[key] = state[key];
	                    }
	                    else {
	                        this[key] = state[key];
	                    }
	                }
	                else if (needsRestoreToNormal) {
	                    if (normalState[key] != null) {
	                        if (propNeedsTransition) {
	                            hasTransition = true;
	                            transitionTarget[key] = normalState[key];
	                        }
	                        else {
	                            this[key] = normalState[key];
	                        }
	                    }
	                }
	            }
	            if (!transition) {
	                for (var i = 0; i < this.animators.length; i++) {
	                    var animator = this.animators[i];
	                    var targetName = animator.targetName;
	                    if (!animator.getLoop()) {
	                        animator.__changeFinalValue(targetName
	                            ? (state || normalState)[targetName]
	                            : (state || normalState));
	                    }
	                }
	            }
	            if (hasTransition) {
	                this._transitionState(stateName, transitionTarget, animationCfg);
	            }
	        };
	        Element.prototype._attachComponent = function (componentEl) {
	            if (componentEl.__zr && !componentEl.__hostTarget) {
	                if (true) {
	                    throw new Error('Text element has been added to zrender.');
	                }
	                return;
	            }
	            if (componentEl === this) {
	                if (true) {
	                    throw new Error('Recursive component attachment.');
	                }
	                return;
	            }
	            var zr = this.__zr;
	            if (zr) {
	                componentEl.addSelfToZr(zr);
	            }
	            componentEl.__zr = zr;
	            componentEl.__hostTarget = this;
	        };
	        Element.prototype._detachComponent = function (componentEl) {
	            if (componentEl.__zr) {
	                componentEl.removeSelfFromZr(componentEl.__zr);
	            }
	            componentEl.__zr = null;
	            componentEl.__hostTarget = null;
	        };
	        Element.prototype.getClipPath = function () {
	            return this._clipPath;
	        };
	        Element.prototype.setClipPath = function (clipPath) {
	            if (this._clipPath && this._clipPath !== clipPath) {
	                this.removeClipPath();
	            }
	            this._attachComponent(clipPath);
	            this._clipPath = clipPath;
	            this.markRedraw();
	        };
	        Element.prototype.removeClipPath = function () {
	            var clipPath = this._clipPath;
	            if (clipPath) {
	                this._detachComponent(clipPath);
	                this._clipPath = null;
	                this.markRedraw();
	            }
	        };
	        Element.prototype.getTextContent = function () {
	            return this._textContent;
	        };
	        Element.prototype.setTextContent = function (textEl) {
	            var previousTextContent = this._textContent;
	            if (previousTextContent === textEl) {
	                return;
	            }
	            if (previousTextContent && previousTextContent !== textEl) {
	                this.removeTextContent();
	            }
	            if (true) {
	                if (textEl.__zr && !textEl.__hostTarget) {
	                    throw new Error('Text element has been added to zrender.');
	                }
	            }
	            textEl.innerTransformable = new Transformable();
	            this._attachComponent(textEl);
	            this._textContent = textEl;
	            this.markRedraw();
	        };
	        Element.prototype.setTextConfig = function (cfg) {
	            if (!this.textConfig) {
	                this.textConfig = {};
	            }
	            extend(this.textConfig, cfg);
	            this.markRedraw();
	        };
	        Element.prototype.removeTextConfig = function () {
	            this.textConfig = null;
	            this.markRedraw();
	        };
	        Element.prototype.removeTextContent = function () {
	            var textEl = this._textContent;
	            if (textEl) {
	                textEl.innerTransformable = null;
	                this._detachComponent(textEl);
	                this._textContent = null;
	                this._innerTextDefaultStyle = null;
	                this.markRedraw();
	            }
	        };
	        Element.prototype.getTextGuideLine = function () {
	            return this._textGuide;
	        };
	        Element.prototype.setTextGuideLine = function (guideLine) {
	            if (this._textGuide && this._textGuide !== guideLine) {
	                this.removeTextGuideLine();
	            }
	            this._attachComponent(guideLine);
	            this._textGuide = guideLine;
	            this.markRedraw();
	        };
	        Element.prototype.removeTextGuideLine = function () {
	            var textGuide = this._textGuide;
	            if (textGuide) {
	                this._detachComponent(textGuide);
	                this._textGuide = null;
	                this.markRedraw();
	            }
	        };
	        Element.prototype.markRedraw = function () {
	            this.__dirty |= REDRAW_BIT;
	            var zr = this.__zr;
	            if (zr) {
	                if (this.__inHover) {
	                    zr.refreshHover();
	                }
	                else {
	                    zr.refresh();
	                }
	            }
	            if (this.__hostTarget) {
	                this.__hostTarget.markRedraw();
	            }
	        };
	        Element.prototype.dirty = function () {
	            this.markRedraw();
	        };
	        Element.prototype._toggleHoverLayerFlag = function (inHover) {
	            this.__inHover = inHover;
	            var textContent = this._textContent;
	            var textGuide = this._textGuide;
	            if (textContent) {
	                textContent.__inHover = inHover;
	            }
	            if (textGuide) {
	                textGuide.__inHover = inHover;
	            }
	        };
	        Element.prototype.addSelfToZr = function (zr) {
	            if (this.__zr === zr) {
	                return;
	            }
	            this.__zr = zr;
	            var animators = this.animators;
	            if (animators) {
	                for (var i = 0; i < animators.length; i++) {
	                    zr.animation.addAnimator(animators[i]);
	                }
	            }
	            if (this._clipPath) {
	                this._clipPath.addSelfToZr(zr);
	            }
	            if (this._textContent) {
	                this._textContent.addSelfToZr(zr);
	            }
	            if (this._textGuide) {
	                this._textGuide.addSelfToZr(zr);
	            }
	        };
	        Element.prototype.removeSelfFromZr = function (zr) {
	            if (!this.__zr) {
	                return;
	            }
	            this.__zr = null;
	            var animators = this.animators;
	            if (animators) {
	                for (var i = 0; i < animators.length; i++) {
	                    zr.animation.removeAnimator(animators[i]);
	                }
	            }
	            if (this._clipPath) {
	                this._clipPath.removeSelfFromZr(zr);
	            }
	            if (this._textContent) {
	                this._textContent.removeSelfFromZr(zr);
	            }
	            if (this._textGuide) {
	                this._textGuide.removeSelfFromZr(zr);
	            }
	        };
	        Element.prototype.animate = function (key, loop, allowDiscreteAnimation) {
	            var target = key ? this[key] : this;
	            if (true) {
	                if (!target) {
	                    logError('Property "'
	                        + key
	                        + '" is not existed in element '
	                        + this.id);
	                    return;
	                }
	            }
	            var animator = new Animator(target, loop, allowDiscreteAnimation);
	            key && (animator.targetName = key);
	            this.addAnimator(animator, key);
	            return animator;
	        };
	        Element.prototype.addAnimator = function (animator, key) {
	            var zr = this.__zr;
	            var el = this;
	            animator.during(function () {
	                el.updateDuringAnimation(key);
	            }).done(function () {
	                var animators = el.animators;
	                var idx = indexOf(animators, animator);
	                if (idx >= 0) {
	                    animators.splice(idx, 1);
	                }
	            });
	            this.animators.push(animator);
	            if (zr) {
	                zr.animation.addAnimator(animator);
	            }
	            zr && zr.wakeUp();
	        };
	        Element.prototype.updateDuringAnimation = function (key) {
	            this.markRedraw();
	        };
	        Element.prototype.stopAnimation = function (scope, forwardToLast) {
	            var animators = this.animators;
	            var len = animators.length;
	            var leftAnimators = [];
	            for (var i = 0; i < len; i++) {
	                var animator = animators[i];
	                if (!scope || scope === animator.scope) {
	                    animator.stop(forwardToLast);
	                }
	                else {
	                    leftAnimators.push(animator);
	                }
	            }
	            this.animators = leftAnimators;
	            return this;
	        };
	        Element.prototype.animateTo = function (target, cfg, animationProps) {
	            animateTo(this, target, cfg, animationProps);
	        };
	        Element.prototype.animateFrom = function (target, cfg, animationProps) {
	            animateTo(this, target, cfg, animationProps, true);
	        };
	        Element.prototype._transitionState = function (stateName, target, cfg, animationProps) {
	            var animators = animateTo(this, target, cfg, animationProps);
	            for (var i = 0; i < animators.length; i++) {
	                animators[i].__fromStateTransition = stateName;
	            }
	        };
	        Element.prototype.getBoundingRect = function () {
	            return null;
	        };
	        Element.prototype.getPaintRect = function () {
	            return null;
	        };
	        Element.initDefaultProps = (function () {
	            var elProto = Element.prototype;
	            elProto.type = 'element';
	            elProto.name = '';
	            elProto.ignore =
	                elProto.silent =
	                    elProto.isGroup =
	                        elProto.draggable =
	                            elProto.dragging =
	                                elProto.ignoreClip =
	                                    elProto.__inHover = false;
	            elProto.__dirty = REDRAW_BIT;
	            var logs = {};
	            function logDeprecatedError(key, xKey, yKey) {
	                if (!logs[key + xKey + yKey]) {
	                    console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
	                    logs[key + xKey + yKey] = true;
	                }
	            }
	            function createLegacyProperty(key, privateKey, xKey, yKey) {
	                Object.defineProperty(elProto, key, {
	                    get: function () {
	                        if (true) {
	                            logDeprecatedError(key, xKey, yKey);
	                        }
	                        if (!this[privateKey]) {
	                            var pos = this[privateKey] = [];
	                            enhanceArray(this, pos);
	                        }
	                        return this[privateKey];
	                    },
	                    set: function (pos) {
	                        if (true) {
	                            logDeprecatedError(key, xKey, yKey);
	                        }
	                        this[xKey] = pos[0];
	                        this[yKey] = pos[1];
	                        this[privateKey] = pos;
	                        enhanceArray(this, pos);
	                    }
	                });
	                function enhanceArray(self, pos) {
	                    Object.defineProperty(pos, 0, {
	                        get: function () {
	                            return self[xKey];
	                        },
	                        set: function (val) {
	                            self[xKey] = val;
	                        }
	                    });
	                    Object.defineProperty(pos, 1, {
	                        get: function () {
	                            return self[yKey];
	                        },
	                        set: function (val) {
	                            self[yKey] = val;
	                        }
	                    });
	                }
	            }
	            if (Object.defineProperty) {
	                createLegacyProperty('position', '_legacyPos', 'x', 'y');
	                createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
	                createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
	            }
	        })();
	        return Element;
	    }());
	    mixin(Element, Eventful);
	    mixin(Element, Transformable);
	    function animateTo(animatable, target, cfg, animationProps, reverse) {
	        cfg = cfg || {};
	        var animators = [];
	        animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
	        var finishCount = animators.length;
	        var doneHappened = false;
	        var cfgDone = cfg.done;
	        var cfgAborted = cfg.aborted;
	        var doneCb = function () {
	            doneHappened = true;
	            finishCount--;
	            if (finishCount <= 0) {
	                doneHappened
	                    ? (cfgDone && cfgDone())
	                    : (cfgAborted && cfgAborted());
	            }
	        };
	        var abortedCb = function () {
	            finishCount--;
	            if (finishCount <= 0) {
	                doneHappened
	                    ? (cfgDone && cfgDone())
	                    : (cfgAborted && cfgAborted());
	            }
	        };
	        if (!finishCount) {
	            cfgDone && cfgDone();
	        }
	        if (animators.length > 0 && cfg.during) {
	            animators[0].during(function (target, percent) {
	                cfg.during(percent);
	            });
	        }
	        for (var i = 0; i < animators.length; i++) {
	            var animator = animators[i];
	            if (doneCb) {
	                animator.done(doneCb);
	            }
	            if (abortedCb) {
	                animator.aborted(abortedCb);
	            }
	            if (cfg.force) {
	                animator.duration(cfg.duration);
	            }
	            animator.start(cfg.easing);
	        }
	        return animators;
	    }
	    function copyArrShallow(source, target, len) {
	        for (var i = 0; i < len; i++) {
	            source[i] = target[i];
	        }
	    }
	    function is2DArray(value) {
	        return isArrayLike(value[0]);
	    }
	    function copyValue(target, source, key) {
	        if (isArrayLike(source[key])) {
	            if (!isArrayLike(target[key])) {
	                target[key] = [];
	            }
	            if (isTypedArray(source[key])) {
	                var len = source[key].length;
	                if (target[key].length !== len) {
	                    target[key] = new (source[key].constructor)(len);
	                    copyArrShallow(target[key], source[key], len);
	                }
	            }
	            else {
	                var sourceArr = source[key];
	                var targetArr = target[key];
	                var len0 = sourceArr.length;
	                if (is2DArray(sourceArr)) {
	                    var len1 = sourceArr[0].length;
	                    for (var i = 0; i < len0; i++) {
	                        if (!targetArr[i]) {
	                            targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
	                        }
	                        else {
	                            copyArrShallow(targetArr[i], sourceArr[i], len1);
	                        }
	                    }
	                }
	                else {
	                    copyArrShallow(targetArr, sourceArr, len0);
	                }
	                targetArr.length = sourceArr.length;
	            }
	        }
	        else {
	            target[key] = source[key];
	        }
	    }
	    function isValueSame(val1, val2) {
	        return val1 === val2
	            || isArrayLike(val1) && isArrayLike(val2) && is1DArraySame(val1, val2);
	    }
	    function is1DArraySame(arr0, arr1) {
	        var len = arr0.length;
	        if (len !== arr1.length) {
	            return false;
	        }
	        for (var i = 0; i < len; i++) {
	            if (arr0[i] !== arr1[i]) {
	                return false;
	            }
	        }
	        return true;
	    }
	    function animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
	        var targetKeys = keys(target);
	        var duration = cfg.duration;
	        var delay = cfg.delay;
	        var additive = cfg.additive;
	        var setToFinal = cfg.setToFinal;
	        var animateAll = !isObject(animationProps);
	        var existsAnimators = animatable.animators;
	        var animationKeys = [];
	        for (var k = 0; k < targetKeys.length; k++) {
	            var innerKey = targetKeys[k];
	            var targetVal = target[innerKey];
	            if (targetVal != null && animateObj[innerKey] != null
	                && (animateAll || animationProps[innerKey])) {
	                if (isObject(targetVal)
	                    && !isArrayLike(targetVal)
	                    && !isGradientObject(targetVal)) {
	                    if (topKey) {
	                        if (!reverse) {
	                            animateObj[innerKey] = targetVal;
	                            animatable.updateDuringAnimation(topKey);
	                        }
	                        continue;
	                    }
	                    animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
	                }
	                else {
	                    animationKeys.push(innerKey);
	                }
	            }
	            else if (!reverse) {
	                animateObj[innerKey] = targetVal;
	                animatable.updateDuringAnimation(topKey);
	                animationKeys.push(innerKey);
	            }
	        }
	        var keyLen = animationKeys.length;
	        if (!additive && keyLen) {
	            for (var i = 0; i < existsAnimators.length; i++) {
	                var animator = existsAnimators[i];
	                if (animator.targetName === topKey) {
	                    var allAborted = animator.stopTracks(animationKeys);
	                    if (allAborted) {
	                        var idx = indexOf(existsAnimators, animator);
	                        existsAnimators.splice(idx, 1);
	                    }
	                }
	            }
	        }
	        if (!cfg.force) {
	            animationKeys = filter(animationKeys, function (key) { return !isValueSame(target[key], animateObj[key]); });
	            keyLen = animationKeys.length;
	        }
	        if (keyLen > 0
	            || (cfg.force && !animators.length)) {
	            var revertedSource = void 0;
	            var reversedTarget = void 0;
	            var sourceClone = void 0;
	            if (reverse) {
	                reversedTarget = {};
	                if (setToFinal) {
	                    revertedSource = {};
	                }
	                for (var i = 0; i < keyLen; i++) {
	                    var innerKey = animationKeys[i];
	                    reversedTarget[innerKey] = animateObj[innerKey];
	                    if (setToFinal) {
	                        revertedSource[innerKey] = target[innerKey];
	                    }
	                    else {
	                        animateObj[innerKey] = target[innerKey];
	                    }
	                }
	            }
	            else if (setToFinal) {
	                sourceClone = {};
	                for (var i = 0; i < keyLen; i++) {
	                    var innerKey = animationKeys[i];
	                    sourceClone[innerKey] = cloneValue(animateObj[innerKey]);
	                    copyValue(animateObj, target, innerKey);
	                }
	            }
	            var animator = new Animator(animateObj, false, false, additive ? filter(existsAnimators, function (animator) { return animator.targetName === topKey; }) : null);
	            animator.targetName = topKey;
	            if (cfg.scope) {
	                animator.scope = cfg.scope;
	            }
	            if (setToFinal && revertedSource) {
	                animator.whenWithKeys(0, revertedSource, animationKeys);
	            }
	            if (sourceClone) {
	                animator.whenWithKeys(0, sourceClone, animationKeys);
	            }
	            animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
	            animatable.addAnimator(animator, topKey);
	            animators.push(animator);
	        }
	    }
	
	    var Group = (function (_super) {
	        __extends(Group, _super);
	        function Group(opts) {
	            var _this = _super.call(this) || this;
	            _this.isGroup = true;
	            _this._children = [];
	            _this.attr(opts);
	            return _this;
	        }
	        Group.prototype.childrenRef = function () {
	            return this._children;
	        };
	        Group.prototype.children = function () {
	            return this._children.slice();
	        };
	        Group.prototype.childAt = function (idx) {
	            return this._children[idx];
	        };
	        Group.prototype.childOfName = function (name) {
	            var children = this._children;
	            for (var i = 0; i < children.length; i++) {
	                if (children[i].name === name) {
	                    return children[i];
	                }
	            }
	        };
	        Group.prototype.childCount = function () {
	            return this._children.length;
	        };
	        Group.prototype.add = function (child) {
	            if (child) {
	                if (child !== this && child.parent !== this) {
	                    this._children.push(child);
	                    this._doAdd(child);
	                }
	                if (true) {
	                    if (child.__hostTarget) {
	                        throw 'This elemenet has been used as an attachment';
	                    }
	                }
	            }
	            return this;
	        };
	        Group.prototype.addBefore = function (child, nextSibling) {
	            if (child && child !== this && child.parent !== this
	                && nextSibling && nextSibling.parent === this) {
	                var children = this._children;
	                var idx = children.indexOf(nextSibling);
	                if (idx >= 0) {
	                    children.splice(idx, 0, child);
	                    this._doAdd(child);
	                }
	            }
	            return this;
	        };
	        Group.prototype.replace = function (oldChild, newChild) {
	            var idx = indexOf(this._children, oldChild);
	            if (idx >= 0) {
	                this.replaceAt(newChild, idx);
	            }
	            return this;
	        };
	        Group.prototype.replaceAt = function (child, index) {
	            var children = this._children;
	            var old = children[index];
	            if (child && child !== this && child.parent !== this && child !== old) {
	                children[index] = child;
	                old.parent = null;
	                var zr = this.__zr;
	                if (zr) {
	                    old.removeSelfFromZr(zr);
	                }
	                this._doAdd(child);
	            }
	            return this;
	        };
	        Group.prototype._doAdd = function (child) {
	            if (child.parent) {
	                child.parent.remove(child);
	            }
	            child.parent = this;
	            var zr = this.__zr;
	            if (zr && zr !== child.__zr) {
	                child.addSelfToZr(zr);
	            }
	            zr && zr.refresh();
	        };
	        Group.prototype.remove = function (child) {
	            var zr = this.__zr;
	            var children = this._children;
	            var idx = indexOf(children, child);
	            if (idx < 0) {
	                return this;
	            }
	            children.splice(idx, 1);
	            child.parent = null;
	            if (zr) {
	                child.removeSelfFromZr(zr);
	            }
	            zr && zr.refresh();
	            return this;
	        };
	        Group.prototype.removeAll = function () {
	            var children = this._children;
	            var zr = this.__zr;
	            for (var i = 0; i < children.length; i++) {
	                var child = children[i];
	                if (zr) {
	                    child.removeSelfFromZr(zr);
	                }
	                child.parent = null;
	            }
	            children.length = 0;
	            return this;
	        };
	        Group.prototype.eachChild = function (cb, context) {
	            var children = this._children;
	            for (var i = 0; i < children.length; i++) {
	                var child = children[i];
	                cb.call(context, child, i);
	            }
	            return this;
	        };
	        Group.prototype.traverse = function (cb, context) {
	            for (var i = 0; i < this._children.length; i++) {
	                var child = this._children[i];
	                var stopped = cb.call(context, child);
	                if (child.isGroup && !stopped) {
	                    child.traverse(cb, context);
	                }
	            }
	            return this;
	        };
	        Group.prototype.addSelfToZr = function (zr) {
	            _super.prototype.addSelfToZr.call(this, zr);
	            for (var i = 0; i < this._children.length; i++) {
	                var child = this._children[i];
	                child.addSelfToZr(zr);
	            }
	        };
	        Group.prototype.removeSelfFromZr = function (zr) {
	            _super.prototype.removeSelfFromZr.call(this, zr);
	            for (var i = 0; i < this._children.length; i++) {
	                var child = this._children[i];
	                child.removeSelfFromZr(zr);
	            }
	        };
	        Group.prototype.getBoundingRect = function (includeChildren) {
	            var tmpRect = new BoundingRect(0, 0, 0, 0);
	            var children = includeChildren || this._children;
	            var tmpMat = [];
	            var rect = null;
	            for (var i = 0; i < children.length; i++) {
	                var child = children[i];
	                if (child.ignore || child.invisible) {
	                    continue;
	                }
	                var childRect = child.getBoundingRect();
	                var transform = child.getLocalTransform(tmpMat);
	                if (transform) {
	                    BoundingRect.applyTransform(tmpRect, childRect, transform);
	                    rect = rect || tmpRect.clone();
	                    rect.union(tmpRect);
	                }
	                else {
	                    rect = rect || childRect.clone();
	                    rect.union(childRect);
	                }
	            }
	            return rect || tmpRect;
	        };
	        return Group;
	    }(Element));
	    Group.prototype.type = 'group';
	
	    /*!
	    * ZRender, a high performance 2d drawing library.
	    *
	    * Copyright (c) 2013, Baidu Inc.
	    * All rights reserved.
	    *
	    * LICENSE
	    * https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
	    */
	    var painterCtors = {};
	    var instances = {};
	    function delInstance(id) {
	        delete instances[id];
	    }
	    function isDarkMode(backgroundColor) {
	        if (!backgroundColor) {
	            return false;
	        }
	        if (typeof backgroundColor === 'string') {
	            return lum(backgroundColor, 1) < DARK_MODE_THRESHOLD;
	        }
	        else if (backgroundColor.colorStops) {
	            var colorStops = backgroundColor.colorStops;
	            var totalLum = 0;
	            var len = colorStops.length;
	            for (var i = 0; i < len; i++) {
	                totalLum += lum(colorStops[i].color, 1);
	            }
	            totalLum /= len;
	            return totalLum < DARK_MODE_THRESHOLD;
	        }
	        return false;
	    }
	    var ZRender = (function () {
	        function ZRender(id, dom, opts) {
	            var _this = this;
	            this._sleepAfterStill = 10;
	            this._stillFrameAccum = 0;
	            this._needsRefresh = true;
	            this._needsRefreshHover = true;
	            this._darkMode = false;
	            opts = opts || {};
	            this.dom = dom;
	            this.id = id;
	            var storage = new Storage();
	            var rendererType = opts.renderer || 'canvas';
	            if (!painterCtors[rendererType]) {
	                rendererType = keys(painterCtors)[0];
	            }
	            if (true) {
	                if (!painterCtors[rendererType]) {
	                    throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
	                }
	            }
	            opts.useDirtyRect = opts.useDirtyRect == null
	                ? false
	                : opts.useDirtyRect;
	            var painter = new painterCtors[rendererType](dom, storage, opts, id);
	            var ssrMode = opts.ssr || painter.ssrOnly;
	            this.storage = storage;
	            this.painter = painter;
	            var handerProxy = (!env.node && !env.worker && !ssrMode)
	                ? new HandlerDomProxy(painter.getViewportRoot(), painter.root)
	                : null;
	            var useCoarsePointer = opts.useCoarsePointer;
	            var usePointerSize = (useCoarsePointer == null || useCoarsePointer === 'auto')
	                ? env.touchEventsSupported
	                : !!useCoarsePointer;
	            var defaultPointerSize = 44;
	            var pointerSize;
	            if (usePointerSize) {
	                pointerSize = retrieve2(opts.pointerSize, defaultPointerSize);
	            }
	            this.handler = new Handler(storage, painter, handerProxy, painter.root, pointerSize);
	            this.animation = new Animation({
	                stage: {
	                    update: ssrMode ? null : function () { return _this._flush(true); }
	                }
	            });
	            if (!ssrMode) {
	                this.animation.start();
	            }
	        }
	        ZRender.prototype.add = function (el) {
	            if (!el) {
	                return;
	            }
	            this.storage.addRoot(el);
	            el.addSelfToZr(this);
	            this.refresh();
	        };
	        ZRender.prototype.remove = function (el) {
	            if (!el) {
	                return;
	            }
	            this.storage.delRoot(el);
	            el.removeSelfFromZr(this);
	            this.refresh();
	        };
	        ZRender.prototype.configLayer = function (zLevel, config) {
	            if (this.painter.configLayer) {
	                this.painter.configLayer(zLevel, config);
	            }
	            this.refresh();
	        };
	        ZRender.prototype.setBackgroundColor = function (backgroundColor) {
	            if (this.painter.setBackgroundColor) {
	                this.painter.setBackgroundColor(backgroundColor);
	            }
	            this.refresh();
	            this._backgroundColor = backgroundColor;
	            this._darkMode = isDarkMode(backgroundColor);
	        };
	        ZRender.prototype.getBackgroundColor = function () {
	            return this._backgroundColor;
	        };
	        ZRender.prototype.setDarkMode = function (darkMode) {
	            this._darkMode = darkMode;
	        };
	        ZRender.prototype.isDarkMode = function () {
	            return this._darkMode;
	        };
	        ZRender.prototype.refreshImmediately = function (fromInside) {
	            if (!fromInside) {
	                this.animation.update(true);
	            }
	            this._needsRefresh = false;
	            this.painter.refresh();
	            this._needsRefresh = false;
	        };
	        ZRender.prototype.refresh = function () {
	            this._needsRefresh = true;
	            this.animation.start();
	        };
	        ZRender.prototype.flush = function () {
	            this._flush(false);
	        };
	        ZRender.prototype._flush = function (fromInside) {
	            var triggerRendered;
	            var start = getTime();
	            if (this._needsRefresh) {
	                triggerRendered = true;
	                this.refreshImmediately(fromInside);
	            }
	            if (this._needsRefreshHover) {
	                triggerRendered = true;
	                this.refreshHoverImmediately();
	            }
	            var end = getTime();
	            if (triggerRendered) {
	                this._stillFrameAccum = 0;
	                this.trigger('rendered', {
	                    elapsedTime: end - start
	                });
	            }
	            else if (this._sleepAfterStill > 0) {
	                this._stillFrameAccum++;
	                if (this._stillFrameAccum > this._sleepAfterStill) {
	                    this.animation.stop();
	                }
	            }
	        };
	        ZRender.prototype.setSleepAfterStill = function (stillFramesCount) {
	            this._sleepAfterStill = stillFramesCount;
	        };
	        ZRender.prototype.wakeUp = function () {
	            this.animation.start();
	            this._stillFrameAccum = 0;
	        };
	        ZRender.prototype.refreshHover = function () {
	            this._needsRefreshHover = true;
	        };
	        ZRender.prototype.refreshHoverImmediately = function () {
	            this._needsRefreshHover = false;
	            if (this.painter.refreshHover && this.painter.getType() === 'canvas') {
	                this.painter.refreshHover();
	            }
	        };
	        ZRender.prototype.resize = function (opts) {
	            opts = opts || {};
	            this.painter.resize(opts.width, opts.height);
	            this.handler.resize();
	        };
	        ZRender.prototype.clearAnimation = function () {
	            this.animation.clear();
	        };
	        ZRender.prototype.getWidth = function () {
	            return this.painter.getWidth();
	        };
	        ZRender.prototype.getHeight = function () {
	            return this.painter.getHeight();
	        };
	        ZRender.prototype.setCursorStyle = function (cursorStyle) {
	            this.handler.setCursorStyle(cursorStyle);
	        };
	        ZRender.prototype.findHover = function (x, y) {
	            return this.handler.findHover(x, y);
	        };
	        ZRender.prototype.on = function (eventName, eventHandler, context) {
	            this.handler.on(eventName, eventHandler, context);
	            return this;
	        };
	        ZRender.prototype.off = function (eventName, eventHandler) {
	            this.handler.off(eventName, eventHandler);
	        };
	        ZRender.prototype.trigger = function (eventName, event) {
	            this.handler.trigger(eventName, event);
	        };
	        ZRender.prototype.clear = function () {
	            var roots = this.storage.getRoots();
	            for (var i = 0; i < roots.length; i++) {
	                if (roots[i] instanceof Group) {
	                    roots[i].removeSelfFromZr(this);
	                }
	            }
	            this.storage.delAllRoots();
	            this.painter.clear();
	        };
	        ZRender.prototype.dispose = function () {
	            this.animation.stop();
	            this.clear();
	            this.storage.dispose();
	            this.painter.dispose();
	            this.handler.dispose();
	            this.animation =
	                this.storage =
	                    this.painter =
	                        this.handler = null;
	            delInstance(this.id);
	        };
	        return ZRender;
	    }());
	    function init(dom, opts) {
	        var zr = new ZRender(guid(), dom, opts);
	        instances[zr.id] = zr;
	        return zr;
	    }
	    function dispose(zr) {
	        zr.dispose();
	    }
	    function disposeAll() {
	        for (var key in instances) {
	            if (instances.hasOwnProperty(key)) {
	                instances[key].dispose();
	            }
	        }
	        instances = {};
	    }
	    function getInstance(id) {
	        return instances[id];
	    }
	    function registerPainter(name, Ctor) {
	        painterCtors[name] = Ctor;
	    }
	    var version = '5.4.4';
	
	    var zrender = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init,
	        dispose: dispose,
	        disposeAll: disposeAll,
	        getInstance: getInstance,
	        registerPainter: registerPainter,
	        version: version
	    });
	
	    var RADIAN_EPSILON = 1e-4; // Although chrome already enlarge this number to 100 for `toFixed`, but
	    // we sill follow the spec for compatibility.
	
	    var ROUND_SUPPORTED_PRECISION_MAX = 20;
	
	    function _trim(str) {
	      return str.replace(/^\s+|\s+$/g, '');
	    }
	    /**
	     * Linear mapping a value from domain to range
	     * @param  val
	     * @param  domain Domain extent domain[0] can be bigger than domain[1]
	     * @param  range  Range extent range[0] can be bigger than range[1]
	     * @param  clamp Default to be false
	     */
	
	
	    function linearMap(val, domain, range, clamp) {
	      var d0 = domain[0];
	      var d1 = domain[1];
	      var r0 = range[0];
	      var r1 = range[1];
	      var subDomain = d1 - d0;
	      var subRange = r1 - r0;
	
	      if (subDomain === 0) {
	        return subRange === 0 ? r0 : (r0 + r1) / 2;
	      } // Avoid accuracy problem in edge, such as
	      // 146.39 - 62.83 === 83.55999999999999.
	      // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
	      // It is a little verbose for efficiency considering this method
	      // is a hotspot.
	
	
	      if (clamp) {
	        if (subDomain > 0) {
	          if (val <= d0) {
	            return r0;
	          } else if (val >= d1) {
	            return r1;
	          }
	        } else {
	          if (val >= d0) {
	            return r0;
	          } else if (val <= d1) {
	            return r1;
	          }
	        }
	      } else {
	        if (val === d0) {
	          return r0;
	        }
	
	        if (val === d1) {
	          return r1;
	        }
	      }
	
	      return (val - d0) / subDomain * subRange + r0;
	    }
	    /**
	     * Convert a percent string to absolute number.
	     * Returns NaN if percent is not a valid string or number
	     */
	
	    function parsePercent$1(percent, all) {
	      switch (percent) {
	        case 'center':
	        case 'middle':
	          percent = '50%';
	          break;
	
	        case 'left':
	        case 'top':
	          percent = '0%';
	          break;
	
	        case 'right':
	        case 'bottom':
	          percent = '100%';
	          break;
	      }
	
	      if (isString(percent)) {
	        if (_trim(percent).match(/%$/)) {
	          return parseFloat(percent) / 100 * all;
	        }
	
	        return parseFloat(percent);
	      }
	
	      return percent == null ? NaN : +percent;
	    }
	    function round(x, precision, returnStr) {
	      if (precision == null) {
	        precision = 10;
	      } // Avoid range error
	
	
	      precision = Math.min(Math.max(0, precision), ROUND_SUPPORTED_PRECISION_MAX); // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
	
	      x = (+x).toFixed(precision);
	      return returnStr ? x : +x;
	    }
	    /**
	     * Inplacd asc sort arr.
	     * The input arr will be modified.
	     */
	
	    function asc(arr) {
	      arr.sort(function (a, b) {
	        return a - b;
	      });
	      return arr;
	    }
	    /**
	     * Get precision.
	     */
	
	    function getPrecision(val) {
	      val = +val;
	
	      if (isNaN(val)) {
	        return 0;
	      } // It is much faster than methods converting number to string as follows
	      //      let tmp = val.toString();
	      //      return tmp.length - 1 - tmp.indexOf('.');
	      // especially when precision is low
	      // Notice:
	      // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
	      //     (see https://jsbench.me/2vkpcekkvw/1)
	      // (2) If the val is less than for example 1e-15, the result may be incorrect.
	      //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
	
	
	      if (val > 1e-14) {
	        var e = 1;
	
	        for (var i = 0; i < 15; i++, e *= 10) {
	          if (Math.round(val * e) / e === val) {
	            return i;
	          }
	        }
	      }
	
	      return getPrecisionSafe(val);
	    }
	    /**
	     * Get precision with slow but safe method
	     */
	
	    function getPrecisionSafe(val) {
	      // toLowerCase for: '3.4E-12'
	      var str = val.toString().toLowerCase(); // Consider scientific notation: '3.4e-12' '3.4e+12'
	
	      var eIndex = str.indexOf('e');
	      var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
	      var significandPartLen = eIndex > 0 ? eIndex : str.length;
	      var dotIndex = str.indexOf('.');
	      var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
	      return Math.max(0, decimalPartLen - exp);
	    }
	    /**
	     * Minimal dicernible data precisioin according to a single pixel.
	     */
	
	    function getPixelPrecision(dataExtent, pixelExtent) {
	      var log = Math.log;
	      var LN10 = Math.LN10;
	      var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
	      var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
	
	      var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
	      return !isFinite(precision) ? 20 : precision;
	    }
	    /**
	     * Get a data of given precision, assuring the sum of percentages
	     * in valueList is 1.
	     * The largest remainder method is used.
	     * https://en.wikipedia.org/wiki/Largest_remainder_method
	     *
	     * @param valueList a list of all data
	     * @param idx index of the data to be processed in valueList
	     * @param precision integer number showing digits of precision
	     * @return percent ranging from 0 to 100
	     */
	
	    function getPercentWithPrecision(valueList, idx, precision) {
	      if (!valueList[idx]) {
	        return 0;
	      }
	
	      var seats = getPercentSeats(valueList, precision);
	      return seats[idx] || 0;
	    }
	    /**
	     * Get a data of given precision, assuring the sum of percentages
	     * in valueList is 1.
	     * The largest remainder method is used.
	     * https://en.wikipedia.org/wiki/Largest_remainder_method
	     *
	     * @param valueList a list of all data
	     * @param precision integer number showing digits of precision
	     * @return {Array<number>}
	     */
	
	    function getPercentSeats(valueList, precision) {
	      var sum = reduce(valueList, function (acc, val) {
	        return acc + (isNaN(val) ? 0 : val);
	      }, 0);
	
	      if (sum === 0) {
	        return [];
	      }
	
	      var digits = Math.pow(10, precision);
	      var votesPerQuota = map(valueList, function (val) {
	        return (isNaN(val) ? 0 : val) / sum * digits * 100;
	      });
	      var targetSeats = digits * 100;
	      var seats = map(votesPerQuota, function (votes) {
	        // Assign automatic seats.
	        return Math.floor(votes);
	      });
	      var currentSum = reduce(seats, function (acc, val) {
	        return acc + val;
	      }, 0);
	      var remainder = map(votesPerQuota, function (votes, idx) {
	        return votes - seats[idx];
	      }); // Has remainding votes.
	
	      while (currentSum < targetSeats) {
	        // Find next largest remainder.
	        var max = Number.NEGATIVE_INFINITY;
	        var maxId = null;
	
	        for (var i = 0, len = remainder.length; i < len; ++i) {
	          if (remainder[i] > max) {
	            max = remainder[i];
	            maxId = i;
	          }
	        } // Add a vote to max remainder.
	
	
	        ++seats[maxId];
	        remainder[maxId] = 0;
	        ++currentSum;
	      }
	
	      return map(seats, function (seat) {
	        return seat / digits;
	      });
	    }
	    /**
	     * Solve the floating point adding problem like 0.1 + 0.2 === 0.30000000000000004
	     * See <http://0.30000000000000004.com/>
	     */
	
	    function addSafe(val0, val1) {
	      var maxPrecision = Math.max(getPrecision(val0), getPrecision(val1)); // const multiplier = Math.pow(10, maxPrecision);
	      // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
	
	      var sum = val0 + val1; // // PENDING: support more?
	
	      return maxPrecision > ROUND_SUPPORTED_PRECISION_MAX ? sum : round(sum, maxPrecision);
	    } // Number.MAX_SAFE_INTEGER, ie do not support.
	
	    var MAX_SAFE_INTEGER = 9007199254740991;
	    /**
	     * To 0 - 2 * PI, considering negative radian.
	     */
	
	    function remRadian(radian) {
	      var pi2 = Math.PI * 2;
	      return (radian % pi2 + pi2) % pi2;
	    }
	    /**
	     * @param {type} radian
	     * @return {boolean}
	     */
	
	    function isRadianAroundZero(val) {
	      return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
	    } // eslint-disable-next-line
	
	    var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
	
	    /**
	     * @param value valid type: number | string | Date, otherwise return `new Date(NaN)`
	     *   These values can be accepted:
	     *   + An instance of Date, represent a time in its own time zone.
	     *   + Or string in a subset of ISO 8601, only including:
	     *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
	     *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
	     *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
	     *     all of which will be treated as local time if time zone is not specified
	     *     (see <https://momentjs.com/>).
	     *   + Or other string format, including (all of which will be treated as local time):
	     *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
	     *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
	     *   + a timestamp, which represent a time in UTC.
	     * @return date Never be null/undefined. If invalid, return `new Date(NaN)`.
	     */
	
	    function parseDate(value) {
	      if (value instanceof Date) {
	        return value;
	      } else if (isString(value)) {
	        // Different browsers parse date in different way, so we parse it manually.
	        // Some other issues:
	        // new Date('1970-01-01') is UTC,
	        // new Date('1970/01/01') and new Date('1970-1-01') is local.
	        // See issue #3623
	        var match = TIME_REG.exec(value);
	
	        if (!match) {
	          // return Invalid Date.
	          return new Date(NaN);
	        } // Use local time when no timezone offset is specified.
	
	
	        if (!match[8]) {
	          // match[n] can only be string or undefined.
	          // But take care of '12' + 1 => '121'.
	          return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
	        } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
	        // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
	        // For example, system timezone is set as "Time Zone: America/Toronto",
	        // then these code will get different result:
	        // `new Date(1478411999999).getTimezoneOffset();  // get 240`
	        // `new Date(1478412000000).getTimezoneOffset();  // get 300`
	        // So we should not use `new Date`, but use `Date.UTC`.
	        else {
	            var hour = +match[4] || 0;
	
	            if (match[8].toUpperCase() !== 'Z') {
	              hour -= +match[8].slice(0, 3);
	            }
	
	            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
	          }
	      } else if (value == null) {
	        return new Date(NaN);
	      }
	
	      return new Date(Math.round(value));
	    }
	    /**
	     * Quantity of a number. e.g. 0.1, 1, 10, 100
	     *
	     * @param val
	     * @return
	     */
	
	    function quantity(val) {
	      return Math.pow(10, quantityExponent(val));
	    }
	    /**
	     * Exponent of the quantity of a number
	     * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
	     *
	     * @param val non-negative value
	     * @return
	     */
	
	    function quantityExponent(val) {
	      if (val === 0) {
	        return 0;
	      }
	
	      var exp = Math.floor(Math.log(val) / Math.LN10);
	      /**
	       * exp is expected to be the rounded-down result of the base-10 log of val.
	       * But due to the precision loss with Math.log(val), we need to restore it
	       * using 10^exp to make sure we can get val back from exp. #11249
	       */
	
	      if (val / Math.pow(10, exp) >= 10) {
	        exp++;
	      }
	
	      return exp;
	    }
	    /**
	     * find a “nice” number approximately equal to x. Round the number if round = true,
	     * take ceiling if round = false. The primary observation is that the “nicest”
	     * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
	     *
	     * See "Nice Numbers for Graph Labels" of Graphic Gems.
	     *
	     * @param  val Non-negative value.
	     * @param  round
	     * @return Niced number
	     */
	
	    function nice(val, round) {
	      var exponent = quantityExponent(val);
	      var exp10 = Math.pow(10, exponent);
	      var f = val / exp10; // 1 <= f < 10
	
	      var nf;
	
	      if (round) {
	        if (f < 1.5) {
	          nf = 1;
	        } else if (f < 2.5) {
	          nf = 2;
	        } else if (f < 4) {
	          nf = 3;
	        } else if (f < 7) {
	          nf = 5;
	        } else {
	          nf = 10;
	        }
	      } else {
	        if (f < 1) {
	          nf = 1;
	        } else if (f < 2) {
	          nf = 2;
	        } else if (f < 3) {
	          nf = 3;
	        } else if (f < 5) {
	          nf = 5;
	        } else {
	          nf = 10;
	        }
	      }
	
	      val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
	      // 20 is the uppper bound of toFixed.
	
	      return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
	    }
	    /**
	     * This code was copied from "d3.js"
	     * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
	     * See the license statement at the head of this file.
	     * @param ascArr
	     */
	
	    function quantile(ascArr, p) {
	      var H = (ascArr.length - 1) * p + 1;
	      var h = Math.floor(H);
	      var v = +ascArr[h - 1];
	      var e = H - h;
	      return e ? v + e * (ascArr[h] - v) : v;
	    }
	    /**
	     * Order intervals asc, and split them when overlap.
	     * expect(numberUtil.reformIntervals([
	     *     {interval: [18, 62], close: [1, 1]},
	     *     {interval: [-Infinity, -70], close: [0, 0]},
	     *     {interval: [-70, -26], close: [1, 1]},
	     *     {interval: [-26, 18], close: [1, 1]},
	     *     {interval: [62, 150], close: [1, 1]},
	     *     {interval: [106, 150], close: [1, 1]},
	     *     {interval: [150, Infinity], close: [0, 0]}
	     * ])).toEqual([
	     *     {interval: [-Infinity, -70], close: [0, 0]},
	     *     {interval: [-70, -26], close: [1, 1]},
	     *     {interval: [-26, 18], close: [0, 1]},
	     *     {interval: [18, 62], close: [0, 1]},
	     *     {interval: [62, 150], close: [0, 1]},
	     *     {interval: [150, Infinity], close: [0, 0]}
	     * ]);
	     * @param list, where `close` mean open or close
	     *        of the interval, and Infinity can be used.
	     * @return The origin list, which has been reformed.
	     */
	
	    function reformIntervals(list) {
	      list.sort(function (a, b) {
	        return littleThan(a, b, 0) ? -1 : 1;
	      });
	      var curr = -Infinity;
	      var currClose = 1;
	
	      for (var i = 0; i < list.length;) {
	        var interval = list[i].interval;
	        var close_1 = list[i].close;
	
	        for (var lg = 0; lg < 2; lg++) {
	          if (interval[lg] <= curr) {
	            interval[lg] = curr;
	            close_1[lg] = !lg ? 1 - currClose : 1;
	          }
	
	          curr = interval[lg];
	          currClose = close_1[lg];
	        }
	
	        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) {
	          list.splice(i, 1);
	        } else {
	          i++;
	        }
	      }
	
	      return list;
	
	      function littleThan(a, b, lg) {
	        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
	      }
	    }
	    /**
	     * [Numeric is defined as]:
	     *     `parseFloat(val) == val`
	     * For example:
	     * numeric:
	     *     typeof number except NaN, '-123', '123', '2e3', '-2e3', '011', 'Infinity', Infinity,
	     *     and they rounded by white-spaces or line-terminal like ' -123 \n ' (see es spec)
	     * not-numeric:
	     *     null, undefined, [], {}, true, false, 'NaN', NaN, '123ab',
	     *     empty string, string with only white-spaces or line-terminal (see es spec),
	     *     0x12, '0x12', '-0x12', 012, '012', '-012',
	     *     non-string, ...
	     *
	     * @test See full test cases in `test/ut/spec/util/number.js`.
	     * @return Must be a typeof number. If not numeric, return NaN.
	     */
	
	    function numericToNumber(val) {
	      var valFloat = parseFloat(val);
	      return valFloat == val // eslint-disable-line eqeqeq
	      && (valFloat !== 0 || !isString(val) || val.indexOf('x') <= 0) // For case ' 0x0 '.
	      ? valFloat : NaN;
	    }
	    /**
	     * Definition of "numeric": see `numericToNumber`.
	     */
	
	    function isNumeric(val) {
	      return !isNaN(numericToNumber(val));
	    }
	    /**
	     * Use random base to prevent users hard code depending on
	     * this auto generated marker id.
	     * @return An positive integer.
	     */
	
	    function getRandomIdBase() {
	      return Math.round(Math.random() * 9);
	    }
	    /**
	     * Get the greatest common divisor.
	     *
	     * @param {number} a one number
	     * @param {number} b the other number
	     */
	
	    function getGreatestCommonDividor(a, b) {
	      if (b === 0) {
	        return a;
	      }
	
	      return getGreatestCommonDividor(b, a % b);
	    }
	    /**
	     * Get the least common multiple.
	     *
	     * @param {number} a one number
	     * @param {number} b the other number
	     */
	
	    function getLeastCommonMultiple(a, b) {
	      if (a == null) {
	        return b;
	      }
	
	      if (b == null) {
	        return a;
	      }
	
	      return a * b / getGreatestCommonDividor(a, b);
	    }
	
	    var ECHARTS_PREFIX = '[ECharts] ';
	    var storedLogs = {};
	    var hasConsole = typeof console !== 'undefined' // eslint-disable-next-line
	    && console.warn && console.log;
	
	    function outputLog(type, str, onlyOnce) {
	      if (hasConsole) {
	        if (onlyOnce) {
	          if (storedLogs[str]) {
	            return;
	          }
	
	          storedLogs[str] = true;
	        } // eslint-disable-next-line
	
	
	        console[type](ECHARTS_PREFIX + str);
	      }
	    }
	
	    function log(str, onlyOnce) {
	      outputLog('log', str, onlyOnce);
	    }
	    function warn(str, onlyOnce) {
	      outputLog('warn', str, onlyOnce);
	    }
	    function error(str, onlyOnce) {
	      outputLog('error', str, onlyOnce);
	    }
	    function deprecateLog(str) {
	      if (true) {
	        // Not display duplicate message.
	        outputLog('warn', 'DEPRECATED: ' + str, true);
	      }
	    }
	    function deprecateReplaceLog(oldOpt, newOpt, scope) {
	      if (true) {
	        deprecateLog((scope ? "[" + scope + "]" : '') + (oldOpt + " is deprecated, use " + newOpt + " instead."));
	      }
	    }
	    /**
	     * If in __DEV__ environment, get console printable message for users hint.
	     * Parameters are separated by ' '.
	     * @usage
	     * makePrintable('This is an error on', someVar, someObj);
	     *
	     * @param hintInfo anything about the current execution context to hint users.
	     * @throws Error
	     */
	
	    function makePrintable() {
	      var hintInfo = [];
	
	      for (var _i = 0; _i < arguments.length; _i++) {
	        hintInfo[_i] = arguments[_i];
	      }
	
	      var msg = '';
	
	      if (true) {
	        // Fuzzy stringify for print.
	        // This code only exist in dev environment.
	        var makePrintableStringIfPossible_1 = function (val) {
	          return val === void 0 ? 'undefined' : val === Infinity ? 'Infinity' : val === -Infinity ? '-Infinity' : eqNaN(val) ? 'NaN' : val instanceof Date ? 'Date(' + val.toISOString() + ')' : isFunction(val) ? 'function () { ... }' : isRegExp(val) ? val + '' : null;
	        };
	
	        msg = map(hintInfo, function (arg) {
	          if (isString(arg)) {
	            // Print without quotation mark for some statement.
	            return arg;
	          } else {
	            var printableStr = makePrintableStringIfPossible_1(arg);
	
	            if (printableStr != null) {
	              return printableStr;
	            } else if (typeof JSON !== 'undefined' && JSON.stringify) {
	              try {
	                return JSON.stringify(arg, function (n, val) {
	                  var printableStr = makePrintableStringIfPossible_1(val);
	                  return printableStr == null ? val : printableStr;
	                }); // In most cases the info object is small, so do not line break.
	              } catch (err) {
	                return '?';
	              }
	            } else {
	              return '?';
	            }
	          }
	        }).join(' ');
	      }
	
	      return msg;
	    }
	    /**
	     * @throws Error
	     */
	
	    function throwError(msg) {
	      throw new Error(msg);
	    }
	
	    function interpolateNumber$1(p0, p1, percent) {
	      return (p1 - p0) * percent + p0;
	    }
	    /**
	     * Make the name displayable. But we should
	     * make sure it is not duplicated with user
	     * specified name, so use '\0';
	     */
	
	
	    var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
	    var INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
	    /**
	     * If value is not array, then translate it to array.
	     * @param  {*} value
	     * @return {Array} [value] or value
	     */
	
	    function normalizeToArray(value) {
	      return value instanceof Array ? value : value == null ? [] : [value];
	    }
	    /**
	     * Sync default option between normal and emphasis like `position` and `show`
	     * In case some one will write code like
	     *     label: {
	     *          show: false,
	     *          position: 'outside',
	     *          fontSize: 18
	     *     },
	     *     emphasis: {
	     *          label: { show: true }
	     *     }
	     */
	
	    function defaultEmphasis(opt, key, subOpts) {
	      // Caution: performance sensitive.
	      if (opt) {
	        opt[key] = opt[key] || {};
	        opt.emphasis = opt.emphasis || {};
	        opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
	
	        for (var i = 0, len = subOpts.length; i < len; i++) {
	          var subOptName = subOpts[i];
	
	          if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
	            opt.emphasis[key][subOptName] = opt[key][subOptName];
	          }
	        }
	      }
	    }
	    var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
	    //     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
	    //     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
	    //     // FIXME: deprecated, check and remove it.
	    //     'textStyle'
	    // ]);
	
	    /**
	     * The method does not ensure performance.
	     * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	     * This helper method retrieves value from data.
	     */
	
	    function getDataItemValue(dataItem) {
	      return isObject(dataItem) && !isArray(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
	    }
	    /**
	     * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	     * This helper method determine if dataItem has extra option besides value
	     */
	
	    function isDataItemOption(dataItem) {
	      return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
	      // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
	    }
	    /**
	     * Mapping to existings for merge.
	     *
	     * Mode "normalMege":
	     *     The mapping result (merge result) will keep the order of the existing
	     *     component, rather than the order of new option. Because we should ensure
	     *     some specified index reference (like xAxisIndex) keep work.
	     *     And in most cases, "merge option" is used to update partial option but not
	     *     be expected to change the order.
	     *
	     * Mode "replaceMege":
	     *     (1) Only the id mapped components will be merged.
	     *     (2) Other existing components (except internal components) will be removed.
	     *     (3) Other new options will be used to create new component.
	     *     (4) The index of the existing components will not be modified.
	     *     That means their might be "hole" after the removal.
	     *     The new components are created first at those available index.
	     *
	     * Mode "replaceAll":
	     *     This mode try to support that reproduce an echarts instance from another
	     *     echarts instance (via `getOption`) in some simple cases.
	     *     In this scenario, the `result` index are exactly the consistent with the `newCmptOptions`,
	     *     which ensures the component index referring (like `xAxisIndex: ?`) corrent. That is,
	     *     the "hole" in `newCmptOptions` will also be kept.
	     *     On the contrary, other modes try best to eliminate holes.
	     *     PENDING: This is an experimental mode yet.
	     *
	     * @return See the comment of <MappingResult>.
	     */
	
	    function mappingToExists(existings, newCmptOptions, mode) {
	      var isNormalMergeMode = mode === 'normalMerge';
	      var isReplaceMergeMode = mode === 'replaceMerge';
	      var isReplaceAllMode = mode === 'replaceAll';
	      existings = existings || [];
	      newCmptOptions = (newCmptOptions || []).slice();
	      var existingIdIdxMap = createHashMap(); // Validate id and name on user input option.
	
	      each(newCmptOptions, function (cmptOption, index) {
	        if (!isObject(cmptOption)) {
	          newCmptOptions[index] = null;
	          return;
	        }
	
	        if (true) {
	          // There is some legacy case that name is set as `false`.
	          // But should work normally rather than throw error.
	          if (cmptOption.id != null && !isValidIdOrName(cmptOption.id)) {
	            warnInvalidateIdOrName(cmptOption.id);
	          }
	
	          if (cmptOption.name != null && !isValidIdOrName(cmptOption.name)) {
	            warnInvalidateIdOrName(cmptOption.name);
	          }
	        }
	      });
	      var result = prepareResult(existings, existingIdIdxMap, mode);
	
	      if (isNormalMergeMode || isReplaceMergeMode) {
	        mappingById(result, existings, existingIdIdxMap, newCmptOptions);
	      }
	
	      if (isNormalMergeMode) {
	        mappingByName(result, newCmptOptions);
	      }
	
	      if (isNormalMergeMode || isReplaceMergeMode) {
	        mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
	      } else if (isReplaceAllMode) {
	        mappingInReplaceAllMode(result, newCmptOptions);
	      }
	
	      makeIdAndName(result); // The array `result` MUST NOT contain elided items, otherwise the
	      // forEach will omit those items and result in incorrect result.
	
	      return result;
	    }
	
	    function prepareResult(existings, existingIdIdxMap, mode) {
	      var result = [];
	
	      if (mode === 'replaceAll') {
	        return result;
	      } // Do not use native `map` to in case that the array `existings`
	      // contains elided items, which will be omitted.
	
	
	      for (var index = 0; index < existings.length; index++) {
	        var existing = existings[index]; // Because of replaceMerge, `existing` may be null/undefined.
	
	        if (existing && existing.id != null) {
	          existingIdIdxMap.set(existing.id, index);
	        } // For non-internal-componnets:
	        //     Mode "normalMerge": all existings kept.
	        //     Mode "replaceMerge": all existing removed unless mapped by id.
	        // For internal-components:
	        //     go with "replaceMerge" approach in both mode.
	
	
	        result.push({
	          existing: mode === 'replaceMerge' || isComponentIdInternal(existing) ? null : existing,
	          newOption: null,
	          keyInfo: null,
	          brandNew: null
	        });
	      }
	
	      return result;
	    }
	
	    function mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
	      // Mapping by id if specified.
	      each(newCmptOptions, function (cmptOption, index) {
	        if (!cmptOption || cmptOption.id == null) {
	          return;
	        }
	
	        var optionId = makeComparableKey(cmptOption.id);
	        var existingIdx = existingIdIdxMap.get(optionId);
	
	        if (existingIdx != null) {
	          var resultItem = result[existingIdx];
	          assert(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
	          resultItem.newOption = cmptOption; // In both mode, if id matched, new option will be merged to
	          // the existings rather than creating new component model.
	
	          resultItem.existing = existings[existingIdx];
	          newCmptOptions[index] = null;
	        }
	      });
	    }
	
	    function mappingByName(result, newCmptOptions) {
	      // Mapping by name if specified.
	      each(newCmptOptions, function (cmptOption, index) {
	        if (!cmptOption || cmptOption.name == null) {
	          return;
	        }
	
	        for (var i = 0; i < result.length; i++) {
	          var existing = result[i].existing;
	
	          if (!result[i].newOption // Consider name: two map to one.
	          // Can not match when both ids existing but different.
	          && existing && (existing.id == null || cmptOption.id == null) && !isComponentIdInternal(cmptOption) && !isComponentIdInternal(existing) && keyExistAndEqual('name', existing, cmptOption)) {
	            result[i].newOption = cmptOption;
	            newCmptOptions[index] = null;
	            return;
	          }
	        }
	      });
	    }
	
	    function mappingByIndex(result, newCmptOptions, brandNew) {
	      each(newCmptOptions, function (cmptOption) {
	        if (!cmptOption) {
	          return;
	        } // Find the first place that not mapped by id and not internal component (consider the "hole").
	
	
	        var resultItem;
	        var nextIdx = 0;
	
	        while ( // Be `!resultItem` only when `nextIdx >= result.length`.
	        (resultItem = result[nextIdx]) && ( // (1) Existing models that already have id should be able to mapped to. Because
	        // after mapping performed, model will always be assigned with an id if user not given.
	        // After that all models have id.
	        // (2) If new option has id, it can only set to a hole or append to the last. It should
	        // not be merged to the existings with different id. Because id should not be overwritten.
	        // (3) Name can be overwritten, because axis use name as 'show label text'.
	        resultItem.newOption || isComponentIdInternal(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
	        resultItem.existing && cmptOption.id != null && !keyExistAndEqual('id', cmptOption, resultItem.existing))) {
	          nextIdx++;
	        }
	
	        if (resultItem) {
	          resultItem.newOption = cmptOption;
	          resultItem.brandNew = brandNew;
	        } else {
	          result.push({
	            newOption: cmptOption,
	            brandNew: brandNew,
	            existing: null,
	            keyInfo: null
	          });
	        }
	
	        nextIdx++;
	      });
	    }
	
	    function mappingInReplaceAllMode(result, newCmptOptions) {
	      each(newCmptOptions, function (cmptOption) {
	        // The feature "reproduce" requires "hole" will also reproduced
	        // in case that component index referring are broken.
	        result.push({
	          newOption: cmptOption,
	          brandNew: true,
	          existing: null,
	          keyInfo: null
	        });
	      });
	    }
	    /**
	     * Make id and name for mapping result (result of mappingToExists)
	     * into `keyInfo` field.
	     */
	
	
	    function makeIdAndName(mapResult) {
	      // We use this id to hash component models and view instances
	      // in echarts. id can be specified by user, or auto generated.
	      // The id generation rule ensures new view instance are able
	      // to mapped to old instance when setOption are called in
	      // no-merge mode. So we generate model id by name and plus
	      // type in view id.
	      // name can be duplicated among components, which is convenient
	      // to specify multi components (like series) by one name.
	      // Ensure that each id is distinct.
	      var idMap = createHashMap();
	      each(mapResult, function (item) {
	        var existing = item.existing;
	        existing && idMap.set(existing.id, item);
	      });
	      each(mapResult, function (item) {
	        var opt = item.newOption; // Force ensure id not duplicated.
	
	        assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
	        opt && opt.id != null && idMap.set(opt.id, item);
	        !item.keyInfo && (item.keyInfo = {});
	      }); // Make name and id.
	
	      each(mapResult, function (item, index) {
	        var existing = item.existing;
	        var opt = item.newOption;
	        var keyInfo = item.keyInfo;
	
	        if (!isObject(opt)) {
	          return;
	        } // Name can be overwritten. Consider case: axis.name = '20km'.
	        // But id generated by name will not be changed, which affect
	        // only in that case: setOption with 'not merge mode' and view
	        // instance will be recreated, which can be accepted.
	
	
	        keyInfo.name = opt.name != null ? makeComparableKey(opt.name) : existing ? existing.name // Avoid that different series has the same name,
	        // because name may be used like in color pallet.
	        : DUMMY_COMPONENT_NAME_PREFIX + index;
	
	        if (existing) {
	          keyInfo.id = makeComparableKey(existing.id);
	        } else if (opt.id != null) {
	          keyInfo.id = makeComparableKey(opt.id);
	        } else {
	          // Consider this situatoin:
	          //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
	          //  optionB [{..}, {name: 'a'}, {name: 'a'}]
	          // Series with the same name between optionA and optionB
	          // should be mapped.
	          var idNum = 0;
	
	          do {
	            keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
	          } while (idMap.get(keyInfo.id));
	        }
	
	        idMap.set(keyInfo.id, item);
	      });
	    }
	
	    function keyExistAndEqual(attr, obj1, obj2) {
	      var key1 = convertOptionIdName(obj1[attr], null);
	      var key2 = convertOptionIdName(obj2[attr], null); // See `MappingExistingItem`. `id` and `name` trade string equals to number.
	
	      return key1 != null && key2 != null && key1 === key2;
	    }
	    /**
	     * @return return null if not exist.
	     */
	
	
	    function makeComparableKey(val) {
	      if (true) {
	        if (val == null) {
	          throw new Error();
	        }
	      }
	
	      return convertOptionIdName(val, '');
	    }
	
	    function convertOptionIdName(idOrName, defaultValue) {
	      if (idOrName == null) {
	        return defaultValue;
	      }
	
	      return isString(idOrName) ? idOrName : isNumber(idOrName) || isStringSafe(idOrName) ? idOrName + '' : defaultValue;
	    }
	
	    function warnInvalidateIdOrName(idOrName) {
	      if (true) {
	        warn('`' + idOrName + '` is invalid id or name. Must be a string or number.');
	      }
	    }
	
	    function isValidIdOrName(idOrName) {
	      return isStringSafe(idOrName) || isNumeric(idOrName);
	    }
	
	    function isNameSpecified(componentModel) {
	      var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
	
	      return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
	    }
	    /**
	     * @public
	     * @param {Object} cmptOption
	     * @return {boolean}
	     */
	
	    function isComponentIdInternal(cmptOption) {
	      return cmptOption && cmptOption.id != null && makeComparableKey(cmptOption.id).indexOf(INTERNAL_COMPONENT_ID_PREFIX) === 0;
	    }
	    function makeInternalComponentId(idSuffix) {
	      return INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
	    }
	    function setComponentTypeToKeyInfo(mappingResult, mainType, componentModelCtor) {
	      // Set mainType and complete subType.
	      each(mappingResult, function (item) {
	        var newOption = item.newOption;
	
	        if (isObject(newOption)) {
	          item.keyInfo.mainType = mainType;
	          item.keyInfo.subType = determineSubType(mainType, newOption, item.existing, componentModelCtor);
	        }
	      });
	    }
	
	    function determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
	      var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
	      : componentModelCtor.determineSubType(mainType, newCmptOption); // tooltip, markline, markpoint may always has no subType
	
	      return subType;
	    }
	    /**
	     * A helper for removing duplicate items between batchA and batchB,
	     * and in themselves, and categorize by series.
	     *
	     * @param batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	     * @param batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	     * @return result: [resultBatchA, resultBatchB]
	     */
	
	
	    function compressBatches(batchA, batchB) {
	      var mapA = {};
	      var mapB = {};
	      makeMap(batchA || [], mapA);
	      makeMap(batchB || [], mapB, mapA);
	      return [mapToArray(mapA), mapToArray(mapB)];
	
	      function makeMap(sourceBatch, map, otherMap) {
	        for (var i = 0, len = sourceBatch.length; i < len; i++) {
	          var seriesId = convertOptionIdName(sourceBatch[i].seriesId, null);
	
	          if (seriesId == null) {
	            return;
	          }
	
	          var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
	          var otherDataIndices = otherMap && otherMap[seriesId];
	
	          for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
	            var dataIndex = dataIndices[j];
	
	            if (otherDataIndices && otherDataIndices[dataIndex]) {
	              otherDataIndices[dataIndex] = null;
	            } else {
	              (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
	            }
	          }
	        }
	      }
	
	      function mapToArray(map, isData) {
	        var result = [];
	
	        for (var i in map) {
	          if (map.hasOwnProperty(i) && map[i] != null) {
	            if (isData) {
	              result.push(+i);
	            } else {
	              var dataIndices = mapToArray(map[i], true);
	              dataIndices.length && result.push({
	                seriesId: i,
	                dataIndex: dataIndices
	              });
	            }
	          }
	        }
	
	        return result;
	      }
	    }
	    /**
	     * @param payload Contains dataIndex (means rawIndex) / dataIndexInside / name
	     *                         each of which can be Array or primary type.
	     * @return dataIndex If not found, return undefined/null.
	     */
	
	    function queryDataIndex(data, payload) {
	      if (payload.dataIndexInside != null) {
	        return payload.dataIndexInside;
	      } else if (payload.dataIndex != null) {
	        return isArray(payload.dataIndex) ? map(payload.dataIndex, function (value) {
	          return data.indexOfRawIndex(value);
	        }) : data.indexOfRawIndex(payload.dataIndex);
	      } else if (payload.name != null) {
	        return isArray(payload.name) ? map(payload.name, function (value) {
	          return data.indexOfName(value);
	        }) : data.indexOfName(payload.name);
	      }
	    }
	    /**
	     * Enable property storage to any host object.
	     * Notice: Serialization is not supported.
	     *
	     * For example:
	     * let inner = zrUitl.makeInner();
	     *
	     * function some1(hostObj) {
	     *      inner(hostObj).someProperty = 1212;
	     *      ...
	     * }
	     * function some2() {
	     *      let fields = inner(this);
	     *      fields.someProperty1 = 1212;
	     *      fields.someProperty2 = 'xx';
	     *      ...
	     * }
	     *
	     * @return {Function}
	     */
	
	    function makeInner() {
	      var key = '__ec_inner_' + innerUniqueIndex++;
	      return function (hostObj) {
	        return hostObj[key] || (hostObj[key] = {});
	      };
	    }
	    var innerUniqueIndex = getRandomIdBase();
	    /**
	     * The same behavior as `component.getReferringComponents`.
	     */
	
	    function parseFinder(ecModel, finderInput, opt) {
	      var _a = preParseFinder(finderInput, opt),
	          mainTypeSpecified = _a.mainTypeSpecified,
	          queryOptionMap = _a.queryOptionMap,
	          others = _a.others;
	
	      var result = others;
	      var defaultMainType = opt ? opt.defaultMainType : null;
	
	      if (!mainTypeSpecified && defaultMainType) {
	        queryOptionMap.set(defaultMainType, {});
	      }
	
	      queryOptionMap.each(function (queryOption, mainType) {
	        var queryResult = queryReferringComponents(ecModel, mainType, queryOption, {
	          useDefault: defaultMainType === mainType,
	          enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
	          enableNone: opt && opt.enableNone != null ? opt.enableNone : true
	        });
	        result[mainType + 'Models'] = queryResult.models;
	        result[mainType + 'Model'] = queryResult.models[0];
	      });
	      return result;
	    }
	    function preParseFinder(finderInput, opt) {
	      var finder;
	
	      if (isString(finderInput)) {
	        var obj = {};
	        obj[finderInput + 'Index'] = 0;
	        finder = obj;
	      } else {
	        finder = finderInput;
	      }
	
	      var queryOptionMap = createHashMap();
	      var others = {};
	      var mainTypeSpecified = false;
	      each(finder, function (value, key) {
	        // Exclude 'dataIndex' and other illgal keys.
	        if (key === 'dataIndex' || key === 'dataIndexInside') {
	          others[key] = value;
	          return;
	        }
	
	        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
	        var mainType = parsedKey[1];
	        var queryType = (parsedKey[2] || '').toLowerCase();
	
	        if (!mainType || !queryType || opt && opt.includeMainTypes && indexOf(opt.includeMainTypes, mainType) < 0) {
	          return;
	        }
	
	        mainTypeSpecified = mainTypeSpecified || !!mainType;
	        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
	        queryOption[queryType] = value;
	      });
	      return {
	        mainTypeSpecified: mainTypeSpecified,
	        queryOptionMap: queryOptionMap,
	        others: others
	      };
	    }
	    var SINGLE_REFERRING = {
	      useDefault: true,
	      enableAll: false,
	      enableNone: false
	    };
	    var MULTIPLE_REFERRING = {
	      useDefault: false,
	      enableAll: true,
	      enableNone: true
	    };
	    function queryReferringComponents(ecModel, mainType, userOption, opt) {
	      opt = opt || SINGLE_REFERRING;
	      var indexOption = userOption.index;
	      var idOption = userOption.id;
	      var nameOption = userOption.name;
	      var result = {
	        models: null,
	        specified: indexOption != null || idOption != null || nameOption != null
	      };
	
	      if (!result.specified) {
	        // Use the first as default if `useDefault`.
	        var firstCmpt = void 0;
	        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [firstCmpt] : [];
	        return result;
	      }
	
	      if (indexOption === 'none' || indexOption === false) {
	        assert(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
	        result.models = [];
	        return result;
	      } // `queryComponents` will return all components if
	      // both all of index/id/name are null/undefined.
	
	
	      if (indexOption === 'all') {
	        assert(opt.enableAll, '`"all"` is not a valid value on index option.');
	        indexOption = idOption = nameOption = null;
	      }
	
	      result.models = ecModel.queryComponents({
	        mainType: mainType,
	        index: indexOption,
	        id: idOption,
	        name: nameOption
	      });
	      return result;
	    }
	    function setAttribute(dom, key, value) {
	      dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
	    }
	    function getAttribute(dom, key) {
	      return dom.getAttribute ? dom.getAttribute(key) : dom[key];
	    }
	    function getTooltipRenderMode(renderModeOption) {
	      if (renderModeOption === 'auto') {
	        // Using html when `document` exists, use richText otherwise
	        return env.domSupported ? 'html' : 'richText';
	      } else {
	        return renderModeOption || 'html';
	      }
	    }
	    /**
	     * Group a list by key.
	     */
	
	    function groupData(array, getKey // return key
	    ) {
	      var buckets = createHashMap();
	      var keys = [];
	      each(array, function (item) {
	        var key = getKey(item);
	        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
	      });
	      return {
	        keys: keys,
	        buckets: buckets
	      };
	    }
	    /**
	     * Interpolate raw values of a series with percent
	     *
	     * @param data         data
	     * @param labelModel   label model of the text element
	     * @param sourceValue  start value. May be null/undefined when init.
	     * @param targetValue  end value
	     * @param percent      0~1 percentage; 0 uses start value while 1 uses end value
	     * @return             interpolated values
	     *                     If `sourceValue` and `targetValue` are `number`, return `number`.
	     *                     If `sourceValue` and `targetValue` are `string`, return `string`.
	     *                     If `sourceValue` and `targetValue` are `(string | number)[]`, return `(string | number)[]`.
	     *                     Other cases do not supported.
	     */
	
	    function interpolateRawValues(data, precision, sourceValue, targetValue, percent) {
	      var isAutoPrecision = precision == null || precision === 'auto';
	
	      if (targetValue == null) {
	        return targetValue;
	      }
	
	      if (isNumber(targetValue)) {
	        var value = interpolateNumber$1(sourceValue || 0, targetValue, percent);
	        return round(value, isAutoPrecision ? Math.max(getPrecision(sourceValue || 0), getPrecision(targetValue)) : precision);
	      } else if (isString(targetValue)) {
	        return percent < 1 ? sourceValue : targetValue;
	      } else {
	        var interpolated = [];
	        var leftArr = sourceValue;
	        var rightArr = targetValue;
	        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
	
	        for (var i = 0; i < length_1; ++i) {
	          var info = data.getDimensionInfo(i); // Don't interpolate ordinal dims
	
	          if (info && info.type === 'ordinal') {
	            // In init, there is no `sourceValue`, but should better not to get undefined result.
	            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
	          } else {
	            var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
	            var rightVal = rightArr[i];
	            var value = interpolateNumber$1(leftVal, rightVal, percent);
	            interpolated[i] = round(value, isAutoPrecision ? Math.max(getPrecision(leftVal), getPrecision(rightVal)) : precision);
	          }
	        }
	
	        return interpolated;
	      }
	    }
	
	    var TYPE_DELIMITER = '.';
	    var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
	    var IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
	    /**
	     * Notice, parseClassType('') should returns {main: '', sub: ''}
	     * @public
	     */
	
	    function parseClassType(componentType) {
	      var ret = {
	        main: '',
	        sub: ''
	      };
	
	      if (componentType) {
	        var typeArr = componentType.split(TYPE_DELIMITER);
	        ret.main = typeArr[0] || '';
	        ret.sub = typeArr[1] || '';
	      }
	
	      return ret;
	    }
	    /**
	     * @public
	     */
	
	    function checkClassType(componentType) {
	      assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
	    }
	
	    function isExtendedClass(clz) {
	      return !!(clz && clz[IS_EXTENDED_CLASS]);
	    }
	    /**
	     * Implements `ExtendableConstructor` for `rootClz`.
	     *
	     * @usage
	     * ```ts
	     * class Xxx {}
	     * type XxxConstructor = typeof Xxx & ExtendableConstructor
	     * enableClassExtend(Xxx as XxxConstructor);
	     * ```
	     */
	
	    function enableClassExtend(rootClz, mandatoryMethods) {
	      rootClz.$constructor = rootClz; // FIXME: not necessary?
	
	      rootClz.extend = function (proto) {
	        if (true) {
	          each(mandatoryMethods, function (method) {
	            if (!proto[method]) {
	              console.warn('Method `' + method + '` should be implemented' + (proto.type ? ' in ' + proto.type : '') + '.');
	            }
	          });
	        }
	
	        var superClass = this;
	        var ExtendedClass;
	
	        if (isESClass(superClass)) {
	          ExtendedClass =
	          /** @class */
	          function (_super) {
	            __extends(class_1, _super);
	
	            function class_1() {
	              return _super.apply(this, arguments) || this;
	            }
	
	            return class_1;
	          }(superClass);
	        } else {
	          // For backward compat, we both support ts class inheritance and this
	          // "extend" approach.
	          // The constructor should keep the same behavior as ts class inheritance:
	          // If this constructor/$constructor is not declared, auto invoke the super
	          // constructor.
	          // If this constructor/$constructor is declared, it is responsible for
	          // calling the super constructor.
	          ExtendedClass = function () {
	            (proto.$constructor || superClass).apply(this, arguments);
	          };
	
	          inherits(ExtendedClass, this);
	        }
	
	        extend(ExtendedClass.prototype, proto);
	        ExtendedClass[IS_EXTENDED_CLASS] = true;
	        ExtendedClass.extend = this.extend;
	        ExtendedClass.superCall = superCall;
	        ExtendedClass.superApply = superApply;
	        ExtendedClass.superClass = superClass;
	        return ExtendedClass;
	      };
	    }
	
	    function isESClass(fn) {
	      return isFunction(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
	    }
	    /**
	     * A work around to both support ts extend and this extend mechanism.
	     * on sub-class.
	     * @usage
	     * ```ts
	     * class Component { ... }
	     * classUtil.enableClassExtend(Component);
	     * classUtil.enableClassManagement(Component, {registerWhenExtend: true});
	     *
	     * class Series extends Component { ... }
	     * // Without calling `markExtend`, `registerWhenExtend` will not work.
	     * Component.markExtend(Series);
	     * ```
	     */
	
	
	    function mountExtend(SubClz, SupperClz) {
	      SubClz.extend = SupperClz.extend;
	    } // A random offset.
	
	    var classBase = Math.round(Math.random() * 10);
	    /**
	     * Implements `CheckableConstructor` for `target`.
	     * Can not use instanceof, consider different scope by
	     * cross domain or es module import in ec extensions.
	     * Mount a method "isInstance()" to Clz.
	     *
	     * @usage
	     * ```ts
	     * class Xxx {}
	     * type XxxConstructor = typeof Xxx & CheckableConstructor;
	     * enableClassCheck(Xxx as XxxConstructor)
	     * ```
	     */
	
	    function enableClassCheck(target) {
	      var classAttr = ['__\0is_clz', classBase++].join('_');
	      target.prototype[classAttr] = true;
	
	      if (true) {
	        assert(!target.isInstance, 'The method "is" can not be defined.');
	      }
	
	      target.isInstance = function (obj) {
	        return !!(obj && obj[classAttr]);
	      };
	    } // superCall should have class info, which can not be fetched from 'this'.
	    // Consider this case:
	    // class A has method f,
	    // class B inherits class A, overrides method f, f call superApply('f'),
	    // class C inherits class B, does not override method f,
	    // then when method of class C is called, dead loop occurred.
	
	    function superCall(context, methodName) {
	      var args = [];
	
	      for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	      }
	
	      return this.superClass.prototype[methodName].apply(context, args);
	    }
	
	    function superApply(context, methodName, args) {
	      return this.superClass.prototype[methodName].apply(context, args);
	    }
	    /**
	     * Implements `ClassManager` for `target`
	     *
	     * @usage
	     * ```ts
	     * class Xxx {}
	     * type XxxConstructor = typeof Xxx & ClassManager
	     * enableClassManagement(Xxx as XxxConstructor);
	     * ```
	     */
	
	
	    function enableClassManagement(target) {
	      /**
	       * Component model classes
	       * key: componentType,
	       * value:
	       *     componentClass, when componentType is 'a'
	       *     or Object.<subKey, componentClass>, when componentType is 'a.b'
	       */
	      var storage = {};
	
	      target.registerClass = function (clz) {
	        // `type` should not be a "instance member".
	        // If using TS class, should better declared as `static type = 'series.pie'`.
	        // otherwise users have to mount `type` on prototype manually.
	        // For backward compat and enable instance visit type via `this.type`,
	        // we still support fetch `type` from prototype.
	        var componentFullType = clz.type || clz.prototype.type;
	
	        if (componentFullType) {
	          checkClassType(componentFullType); // If only static type declared, we assign it to prototype mandatorily.
	
	          clz.prototype.type = componentFullType;
	          var componentTypeInfo = parseClassType(componentFullType);
	
	          if (!componentTypeInfo.sub) {
	            if (true) {
	              if (storage[componentTypeInfo.main]) {
	                console.warn(componentTypeInfo.main + ' exists.');
	              }
	            }
	
	            storage[componentTypeInfo.main] = clz;
	          } else if (componentTypeInfo.sub !== IS_CONTAINER) {
	            var container = makeContainer(componentTypeInfo);
	            container[componentTypeInfo.sub] = clz;
	          }
	        }
	
	        return clz;
	      };
	
	      target.getClass = function (mainType, subType, throwWhenNotFound) {
	        var clz = storage[mainType];
	
	        if (clz && clz[IS_CONTAINER]) {
	          clz = subType ? clz[subType] : null;
	        }
	
	        if (throwWhenNotFound && !clz) {
	          throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
	        }
	
	        return clz;
	      };
	
	      target.getClassesByMainType = function (componentType) {
	        var componentTypeInfo = parseClassType(componentType);
	        var result = [];
	        var obj = storage[componentTypeInfo.main];
	
	        if (obj && obj[IS_CONTAINER]) {
	          each(obj, function (o, type) {
	            type !== IS_CONTAINER && result.push(o);
	          });
	        } else {
	          result.push(obj);
	        }
	
	        return result;
	      };
	
	      target.hasClass = function (componentType) {
	        // Just consider componentType.main.
	        var componentTypeInfo = parseClassType(componentType);
	        return !!storage[componentTypeInfo.main];
	      };
	      /**
	       * @return Like ['aa', 'bb'], but can not be ['aa.xx']
	       */
	
	
	      target.getAllClassMainTypes = function () {
	        var types = [];
	        each(storage, function (obj, type) {
	          types.push(type);
	        });
	        return types;
	      };
	      /**
	       * If a main type is container and has sub types
	       */
	
	
	      target.hasSubTypes = function (componentType) {
	        var componentTypeInfo = parseClassType(componentType);
	        var obj = storage[componentTypeInfo.main];
	        return obj && obj[IS_CONTAINER];
	      };
	
	      function makeContainer(componentTypeInfo) {
	        var container = storage[componentTypeInfo.main];
	
	        if (!container || !container[IS_CONTAINER]) {
	          container = storage[componentTypeInfo.main] = {};
	          container[IS_CONTAINER] = true;
	        }
	
	        return container;
	      }
	    } // /**
	    //  * @param {string|Array.<string>} properties
	    //  */
	    // export function setReadOnly(obj, properties) {
	    // FIXME It seems broken in IE8 simulation of IE11
	    // if (!zrUtil.isArray(properties)) {
	    //     properties = properties != null ? [properties] : [];
	    // }
	    // zrUtil.each(properties, function (prop) {
	    //     let value = obj[prop];
	    //     Object.defineProperty
	    //         && Object.defineProperty(obj, prop, {
	    //             value: value, writable: false
	    //         });
	    //     zrUtil.isArray(obj[prop])
	    //         && Object.freeze
	    //         && Object.freeze(obj[prop]);
	    // });
	    // }
	
	    function makeStyleMapper(properties, ignoreParent) {
	      // Normalize
	      for (var i = 0; i < properties.length; i++) {
	        if (!properties[i][1]) {
	          properties[i][1] = properties[i][0];
	        }
	      }
	
	      ignoreParent = ignoreParent || false;
	      return function (model, excludes, includes) {
	        var style = {};
	
	        for (var i = 0; i < properties.length; i++) {
	          var propName = properties[i][1];
	
	          if (excludes && indexOf(excludes, propName) >= 0 || includes && indexOf(includes, propName) < 0) {
	            continue;
	          }
	
	          var val = model.getShallow(propName, ignoreParent);
	
	          if (val != null) {
	            style[properties[i][0]] = val;
	          }
	        } // TODO Text or image?
	
	
	        return style;
	      };
	    }
	
	    var AREA_STYLE_KEY_MAP = [['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
	    // So do not transfer decal directly.
	    ];
	    var getAreaStyle = makeStyleMapper(AREA_STYLE_KEY_MAP);
	
	    var AreaStyleMixin =
	    /** @class */
	    function () {
	      function AreaStyleMixin() {}
	
	      AreaStyleMixin.prototype.getAreaStyle = function (excludes, includes) {
	        return getAreaStyle(this, excludes, includes);
	      };
	
	      return AreaStyleMixin;
	    }();
	
	    var globalImageCache = new LRU(50);
	    function findExistImage(newImageOrSrc) {
	        if (typeof newImageOrSrc === 'string') {
	            var cachedImgObj = globalImageCache.get(newImageOrSrc);
	            return cachedImgObj && cachedImgObj.image;
	        }
	        else {
	            return newImageOrSrc;
	        }
	    }
	    function createOrUpdateImage(newImageOrSrc, image, hostEl, onload, cbPayload) {
	        if (!newImageOrSrc) {
	            return image;
	        }
	        else if (typeof newImageOrSrc === 'string') {
	            if ((image && image.__zrImageSrc === newImageOrSrc) || !hostEl) {
	                return image;
	            }
	            var cachedImgObj = globalImageCache.get(newImageOrSrc);
	            var pendingWrap = { hostEl: hostEl, cb: onload, cbPayload: cbPayload };
	            if (cachedImgObj) {
	                image = cachedImgObj.image;
	                !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
	            }
	            else {
	                image = platformApi.loadImage(newImageOrSrc, imageOnLoad, imageOnLoad);
	                image.__zrImageSrc = newImageOrSrc;
	                globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
	                    image: image,
	                    pending: [pendingWrap]
	                });
	            }
	            return image;
	        }
	        else {
	            return newImageOrSrc;
	        }
	    }
	    function imageOnLoad() {
	        var cachedImgObj = this.__cachedImgObj;
	        this.onload = this.onerror = this.__cachedImgObj = null;
	        for (var i = 0; i < cachedImgObj.pending.length; i++) {
	            var pendingWrap = cachedImgObj.pending[i];
	            var cb = pendingWrap.cb;
	            cb && cb(this, pendingWrap.cbPayload);
	            pendingWrap.hostEl.dirty();
	        }
	        cachedImgObj.pending.length = 0;
	    }
	    function isImageReady(image) {
	        return image && image.width && image.height;
	    }
	
	    var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
	    function truncateText(text, containerWidth, font, ellipsis, options) {
	        if (!containerWidth) {
	            return '';
	        }
	        var textLines = (text + '').split('\n');
	        options = prepareTruncateOptions(containerWidth, font, ellipsis, options);
	        for (var i = 0, len = textLines.length; i < len; i++) {
	            textLines[i] = truncateSingleLine(textLines[i], options);
	        }
	        return textLines.join('\n');
	    }
	    function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
	        options = options || {};
	        var preparedOpts = extend({}, options);
	        preparedOpts.font = font;
	        ellipsis = retrieve2(ellipsis, '...');
	        preparedOpts.maxIterations = retrieve2(options.maxIterations, 2);
	        var minChar = preparedOpts.minChar = retrieve2(options.minChar, 0);
	        preparedOpts.cnCharWidth = getWidth('国', font);
	        var ascCharWidth = preparedOpts.ascCharWidth = getWidth('a', font);
	        preparedOpts.placeholder = retrieve2(options.placeholder, '');
	        var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
	        for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
	            contentWidth -= ascCharWidth;
	        }
	        var ellipsisWidth = getWidth(ellipsis, font);
	        if (ellipsisWidth > contentWidth) {
	            ellipsis = '';
	            ellipsisWidth = 0;
	        }
	        contentWidth = containerWidth - ellipsisWidth;
	        preparedOpts.ellipsis = ellipsis;
	        preparedOpts.ellipsisWidth = ellipsisWidth;
	        preparedOpts.contentWidth = contentWidth;
	        preparedOpts.containerWidth = containerWidth;
	        return preparedOpts;
	    }
	    function truncateSingleLine(textLine, options) {
	        var containerWidth = options.containerWidth;
	        var font = options.font;
	        var contentWidth = options.contentWidth;
	        if (!containerWidth) {
	            return '';
	        }
	        var lineWidth = getWidth(textLine, font);
	        if (lineWidth <= containerWidth) {
	            return textLine;
	        }
	        for (var j = 0;; j++) {
	            if (lineWidth <= contentWidth || j >= options.maxIterations) {
	                textLine += options.ellipsis;
	                break;
	            }
	            var subLength = j === 0
	                ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth)
	                : lineWidth > 0
	                    ? Math.floor(textLine.length * contentWidth / lineWidth)
	                    : 0;
	            textLine = textLine.substr(0, subLength);
	            lineWidth = getWidth(textLine, font);
	        }
	        if (textLine === '') {
	            textLine = options.placeholder;
	        }
	        return textLine;
	    }
	    function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
	        var width = 0;
	        var i = 0;
	        for (var len = text.length; i < len && width < contentWidth; i++) {
	            var charCode = text.charCodeAt(i);
	            width += (0 <= charCode && charCode <= 127) ? ascCharWidth : cnCharWidth;
	        }
	        return i;
	    }
	    function parsePlainText(text, style) {
	        text != null && (text += '');
	        var overflow = style.overflow;
	        var padding = style.padding;
	        var font = style.font;
	        var truncate = overflow === 'truncate';
	        var calculatedLineHeight = getLineHeight(font);
	        var lineHeight = retrieve2(style.lineHeight, calculatedLineHeight);
	        var bgColorDrawn = !!(style.backgroundColor);
	        var truncateLineOverflow = style.lineOverflow === 'truncate';
	        var width = style.width;
	        var lines;
	        if (width != null && (overflow === 'break' || overflow === 'breakAll')) {
	            lines = text ? wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
	        }
	        else {
	            lines = text ? text.split('\n') : [];
	        }
	        var contentHeight = lines.length * lineHeight;
	        var height = retrieve2(style.height, contentHeight);
	        if (contentHeight > height && truncateLineOverflow) {
	            var lineCount = Math.floor(height / lineHeight);
	            lines = lines.slice(0, lineCount);
	        }
	        if (text && truncate && width != null) {
	            var options = prepareTruncateOptions(width, font, style.ellipsis, {
	                minChar: style.truncateMinChar,
	                placeholder: style.placeholder
	            });
	            for (var i = 0; i < lines.length; i++) {
	                lines[i] = truncateSingleLine(lines[i], options);
	            }
	        }
	        var outerHeight = height;
	        var contentWidth = 0;
	        for (var i = 0; i < lines.length; i++) {
	            contentWidth = Math.max(getWidth(lines[i], font), contentWidth);
	        }
	        if (width == null) {
	            width = contentWidth;
	        }
	        var outerWidth = contentWidth;
	        if (padding) {
	            outerHeight += padding[0] + padding[2];
	            outerWidth += padding[1] + padding[3];
	            width += padding[1] + padding[3];
	        }
	        if (bgColorDrawn) {
	            outerWidth = width;
	        }
	        return {
	            lines: lines,
	            height: height,
	            outerWidth: outerWidth,
	            outerHeight: outerHeight,
	            lineHeight: lineHeight,
	            calculatedLineHeight: calculatedLineHeight,
	            contentWidth: contentWidth,
	            contentHeight: contentHeight,
	            width: width
	        };
	    }
	    var RichTextToken = (function () {
	        function RichTextToken() {
	        }
	        return RichTextToken;
	    }());
	    var RichTextLine = (function () {
	        function RichTextLine(tokens) {
	            this.tokens = [];
	            if (tokens) {
	                this.tokens = tokens;
	            }
	        }
	        return RichTextLine;
	    }());
	    var RichTextContentBlock = (function () {
	        function RichTextContentBlock() {
	            this.width = 0;
	            this.height = 0;
	            this.contentWidth = 0;
	            this.contentHeight = 0;
	            this.outerWidth = 0;
	            this.outerHeight = 0;
	            this.lines = [];
	        }
	        return RichTextContentBlock;
	    }());
	    function parseRichText(text, style) {
	        var contentBlock = new RichTextContentBlock();
	        text != null && (text += '');
	        if (!text) {
	            return contentBlock;
	        }
	        var topWidth = style.width;
	        var topHeight = style.height;
	        var overflow = style.overflow;
	        var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null
	            ? { width: topWidth, accumWidth: 0, breakAll: overflow === 'breakAll' }
	            : null;
	        var lastIndex = STYLE_REG.lastIndex = 0;
	        var result;
	        while ((result = STYLE_REG.exec(text)) != null) {
	            var matchedIndex = result.index;
	            if (matchedIndex > lastIndex) {
	                pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
	            }
	            pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
	            lastIndex = STYLE_REG.lastIndex;
	        }
	        if (lastIndex < text.length) {
	            pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
	        }
	        var pendingList = [];
	        var calculatedHeight = 0;
	        var calculatedWidth = 0;
	        var stlPadding = style.padding;
	        var truncate = overflow === 'truncate';
	        var truncateLine = style.lineOverflow === 'truncate';
	        function finishLine(line, lineWidth, lineHeight) {
	            line.width = lineWidth;
	            line.lineHeight = lineHeight;
	            calculatedHeight += lineHeight;
	            calculatedWidth = Math.max(calculatedWidth, lineWidth);
	        }
	        outer: for (var i = 0; i < contentBlock.lines.length; i++) {
	            var line = contentBlock.lines[i];
	            var lineHeight = 0;
	            var lineWidth = 0;
	            for (var j = 0; j < line.tokens.length; j++) {
	                var token = line.tokens[j];
	                var tokenStyle = token.styleName && style.rich[token.styleName] || {};
	                var textPadding = token.textPadding = tokenStyle.padding;
	                var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
	                var font = token.font = tokenStyle.font || style.font;
	                token.contentHeight = getLineHeight(font);
	                var tokenHeight = retrieve2(tokenStyle.height, token.contentHeight);
	                token.innerHeight = tokenHeight;
	                textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
	                token.height = tokenHeight;
	                token.lineHeight = retrieve3(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
	                token.align = tokenStyle && tokenStyle.align || style.align;
	                token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
	                if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
	                    if (j > 0) {
	                        line.tokens = line.tokens.slice(0, j);
	                        finishLine(line, lineWidth, lineHeight);
	                        contentBlock.lines = contentBlock.lines.slice(0, i + 1);
	                    }
	                    else {
	                        contentBlock.lines = contentBlock.lines.slice(0, i);
	                    }
	                    break outer;
	                }
	                var styleTokenWidth = tokenStyle.width;
	                var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
	                if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
	                    token.percentWidth = styleTokenWidth;
	                    pendingList.push(token);
	                    token.contentWidth = getWidth(token.text, font);
	                }
	                else {
	                    if (tokenWidthNotSpecified) {
	                        var textBackgroundColor = tokenStyle.backgroundColor;
	                        var bgImg = textBackgroundColor && textBackgroundColor.image;
	                        if (bgImg) {
	                            bgImg = findExistImage(bgImg);
	                            if (isImageReady(bgImg)) {
	                                token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
	                            }
	                        }
	                    }
	                    var remainTruncWidth = truncate && topWidth != null
	                        ? topWidth - lineWidth : null;
	                    if (remainTruncWidth != null && remainTruncWidth < token.width) {
	                        if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
	                            token.text = '';
	                            token.width = token.contentWidth = 0;
	                        }
	                        else {
	                            token.text = truncateText(token.text, remainTruncWidth - paddingH, font, style.ellipsis, { minChar: style.truncateMinChar });
	                            token.width = token.contentWidth = getWidth(token.text, font);
	                        }
	                    }
	                    else {
	                        token.contentWidth = getWidth(token.text, font);
	                    }
	                }
	                token.width += paddingH;
	                lineWidth += token.width;
	                tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
	            }
	            finishLine(line, lineWidth, lineHeight);
	        }
	        contentBlock.outerWidth = contentBlock.width = retrieve2(topWidth, calculatedWidth);
	        contentBlock.outerHeight = contentBlock.height = retrieve2(topHeight, calculatedHeight);
	        contentBlock.contentHeight = calculatedHeight;
	        contentBlock.contentWidth = calculatedWidth;
	        if (stlPadding) {
	            contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
	            contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
	        }
	        for (var i = 0; i < pendingList.length; i++) {
	            var token = pendingList[i];
	            var percentWidth = token.percentWidth;
	            token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
	        }
	        return contentBlock;
	    }
	    function pushTokens(block, str, style, wrapInfo, styleName) {
	        var isEmptyStr = str === '';
	        var tokenStyle = styleName && style.rich[styleName] || {};
	        var lines = block.lines;
	        var font = tokenStyle.font || style.font;
	        var newLine = false;
	        var strLines;
	        var linesWidths;
	        if (wrapInfo) {
	            var tokenPadding = tokenStyle.padding;
	            var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
	            if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
	                var outerWidth_1 = parsePercent(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
	                if (lines.length > 0) {
	                    if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
	                        strLines = str.split('\n');
	                        newLine = true;
	                    }
	                }
	                wrapInfo.accumWidth = outerWidth_1;
	            }
	            else {
	                var res = wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
	                wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
	                linesWidths = res.linesWidths;
	                strLines = res.lines;
	            }
	        }
	        else {
	            strLines = str.split('\n');
	        }
	        for (var i = 0; i < strLines.length; i++) {
	            var text = strLines[i];
	            var token = new RichTextToken();
	            token.styleName = styleName;
	            token.text = text;
	            token.isLineHolder = !text && !isEmptyStr;
	            if (typeof tokenStyle.width === 'number') {
	                token.width = tokenStyle.width;
	            }
	            else {
	                token.width = linesWidths
	                    ? linesWidths[i]
	                    : getWidth(text, font);
	            }
	            if (!i && !newLine) {
	                var tokens = (lines[lines.length - 1] || (lines[0] = new RichTextLine())).tokens;
	                var tokensLen = tokens.length;
	                (tokensLen === 1 && tokens[0].isLineHolder)
	                    ? (tokens[0] = token)
	                    : ((text || !tokensLen || isEmptyStr) && tokens.push(token));
	            }
	            else {
	                lines.push(new RichTextLine([token]));
	            }
	        }
	    }
	    function isAlphabeticLetter(ch) {
	        var code = ch.charCodeAt(0);
	        return code >= 0x20 && code <= 0x24F
	            || code >= 0x370 && code <= 0x10FF
	            || code >= 0x1200 && code <= 0x13FF
	            || code >= 0x1E00 && code <= 0x206F;
	    }
	    var breakCharMap = reduce(',&?/;] '.split(''), function (obj, ch) {
	        obj[ch] = true;
	        return obj;
	    }, {});
	    function isWordBreakChar(ch) {
	        if (isAlphabeticLetter(ch)) {
	            if (breakCharMap[ch]) {
	                return true;
	            }
	            return false;
	        }
	        return true;
	    }
	    function wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
	        var lines = [];
	        var linesWidths = [];
	        var line = '';
	        var currentWord = '';
	        var currentWordWidth = 0;
	        var accumWidth = 0;
	        for (var i = 0; i < text.length; i++) {
	            var ch = text.charAt(i);
	            if (ch === '\n') {
	                if (currentWord) {
	                    line += currentWord;
	                    accumWidth += currentWordWidth;
	                }
	                lines.push(line);
	                linesWidths.push(accumWidth);
	                line = '';
	                currentWord = '';
	                currentWordWidth = 0;
	                accumWidth = 0;
	                continue;
	            }
	            var chWidth = getWidth(ch, font);
	            var inWord = isBreakAll ? false : !isWordBreakChar(ch);
	            if (!lines.length
	                ? lastAccumWidth + accumWidth + chWidth > lineWidth
	                : accumWidth + chWidth > lineWidth) {
	                if (!accumWidth) {
	                    if (inWord) {
	                        lines.push(currentWord);
	                        linesWidths.push(currentWordWidth);
	                        currentWord = ch;
	                        currentWordWidth = chWidth;
	                    }
	                    else {
	                        lines.push(ch);
	                        linesWidths.push(chWidth);
	                    }
	                }
	                else if (line || currentWord) {
	                    if (inWord) {
	                        if (!line) {
	                            line = currentWord;
	                            currentWord = '';
	                            currentWordWidth = 0;
	                            accumWidth = currentWordWidth;
	                        }
	                        lines.push(line);
	                        linesWidths.push(accumWidth - currentWordWidth);
	                        currentWord += ch;
	                        currentWordWidth += chWidth;
	                        line = '';
	                        accumWidth = currentWordWidth;
	                    }
	                    else {
	                        if (currentWord) {
	                            line += currentWord;
	                            currentWord = '';
	                            currentWordWidth = 0;
	                        }
	                        lines.push(line);
	                        linesWidths.push(accumWidth);
	                        line = ch;
	                        accumWidth = chWidth;
	                    }
	                }
	                continue;
	            }
	            accumWidth += chWidth;
	            if (inWord) {
	                currentWord += ch;
	                currentWordWidth += chWidth;
	            }
	            else {
	                if (currentWord) {
	                    line += currentWord;
	                    currentWord = '';
	                    currentWordWidth = 0;
	                }
	                line += ch;
	            }
	        }
	        if (!lines.length && !line) {
	            line = text;
	            currentWord = '';
	            currentWordWidth = 0;
	        }
	        if (currentWord) {
	            line += currentWord;
	        }
	        if (line) {
	            lines.push(line);
	            linesWidths.push(accumWidth);
	        }
	        if (lines.length === 1) {
	            accumWidth += lastAccumWidth;
	        }
	        return {
	            accumWidth: accumWidth,
	            lines: lines,
	            linesWidths: linesWidths
	        };
	    }
	
	    var STYLE_MAGIC_KEY = '__zr_style_' + Math.round((Math.random() * 10));
	    var DEFAULT_COMMON_STYLE = {
	        shadowBlur: 0,
	        shadowOffsetX: 0,
	        shadowOffsetY: 0,
	        shadowColor: '#000',
	        opacity: 1,
	        blend: 'source-over'
	    };
	    var DEFAULT_COMMON_ANIMATION_PROPS = {
	        style: {
	            shadowBlur: true,
	            shadowOffsetX: true,
	            shadowOffsetY: true,
	            shadowColor: true,
	            opacity: true
	        }
	    };
	    DEFAULT_COMMON_STYLE[STYLE_MAGIC_KEY] = true;
	    var PRIMARY_STATES_KEYS$1 = ['z', 'z2', 'invisible'];
	    var PRIMARY_STATES_KEYS_IN_HOVER_LAYER = ['invisible'];
	    var Displayable = (function (_super) {
	        __extends(Displayable, _super);
	        function Displayable(props) {
	            return _super.call(this, props) || this;
	        }
	        Displayable.prototype._init = function (props) {
	            var keysArr = keys(props);
	            for (var i = 0; i < keysArr.length; i++) {
	                var key = keysArr[i];
	                if (key === 'style') {
	                    this.useStyle(props[key]);
	                }
	                else {
	                    _super.prototype.attrKV.call(this, key, props[key]);
	                }
	            }
	            if (!this.style) {
	                this.useStyle({});
	            }
	        };
	        Displayable.prototype.beforeBrush = function () { };
	        Displayable.prototype.afterBrush = function () { };
	        Displayable.prototype.innerBeforeBrush = function () { };
	        Displayable.prototype.innerAfterBrush = function () { };
	        Displayable.prototype.shouldBePainted = function (viewWidth, viewHeight, considerClipPath, considerAncestors) {
	            var m = this.transform;
	            if (this.ignore
	                || this.invisible
	                || this.style.opacity === 0
	                || (this.culling
	                    && isDisplayableCulled(this, viewWidth, viewHeight))
	                || (m && !m[0] && !m[3])) {
	                return false;
	            }
	            if (considerClipPath && this.__clipPaths) {
	                for (var i = 0; i < this.__clipPaths.length; ++i) {
	                    if (this.__clipPaths[i].isZeroArea()) {
	                        return false;
	                    }
	                }
	            }
	            if (considerAncestors && this.parent) {
	                var parent_1 = this.parent;
	                while (parent_1) {
	                    if (parent_1.ignore) {
	                        return false;
	                    }
	                    parent_1 = parent_1.parent;
	                }
	            }
	            return true;
	        };
	        Displayable.prototype.contain = function (x, y) {
	            return this.rectContain(x, y);
	        };
	        Displayable.prototype.traverse = function (cb, context) {
	            cb.call(context, this);
	        };
	        Displayable.prototype.rectContain = function (x, y) {
	            var coord = this.transformCoordToLocal(x, y);
	            var rect = this.getBoundingRect();
	            return rect.contain(coord[0], coord[1]);
	        };
	        Displayable.prototype.getPaintRect = function () {
	            var rect = this._paintRect;
	            if (!this._paintRect || this.__dirty) {
	                var transform = this.transform;
	                var elRect = this.getBoundingRect();
	                var style = this.style;
	                var shadowSize = style.shadowBlur || 0;
	                var shadowOffsetX = style.shadowOffsetX || 0;
	                var shadowOffsetY = style.shadowOffsetY || 0;
	                rect = this._paintRect || (this._paintRect = new BoundingRect(0, 0, 0, 0));
	                if (transform) {
	                    BoundingRect.applyTransform(rect, elRect, transform);
	                }
	                else {
	                    rect.copy(elRect);
	                }
	                if (shadowSize || shadowOffsetX || shadowOffsetY) {
	                    rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
	                    rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
	                    rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
	                    rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
	                }
	                var tolerance = this.dirtyRectTolerance;
	                if (!rect.isZero()) {
	                    rect.x = Math.floor(rect.x - tolerance);
	                    rect.y = Math.floor(rect.y - tolerance);
	                    rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
	                    rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
	                }
	            }
	            return rect;
	        };
	        Displayable.prototype.setPrevPaintRect = function (paintRect) {
	            if (paintRect) {
	                this._prevPaintRect = this._prevPaintRect || new BoundingRect(0, 0, 0, 0);
	                this._prevPaintRect.copy(paintRect);
	            }
	            else {
	                this._prevPaintRect = null;
	            }
	        };
	        Displayable.prototype.getPrevPaintRect = function () {
	            return this._prevPaintRect;
	        };
	        Displayable.prototype.animateStyle = function (loop) {
	            return this.animate('style', loop);
	        };
	        Displayable.prototype.updateDuringAnimation = function (targetKey) {
	            if (targetKey === 'style') {
	                this.dirtyStyle();
	            }
	            else {
	                this.markRedraw();
	            }
	        };
	        Displayable.prototype.attrKV = function (key, value) {
	            if (key !== 'style') {
	                _super.prototype.attrKV.call(this, key, value);
	            }
	            else {
	                if (!this.style) {
	                    this.useStyle(value);
	                }
	                else {
	                    this.setStyle(value);
	                }
	            }
	        };
	        Displayable.prototype.setStyle = function (keyOrObj, value) {
	            if (typeof keyOrObj === 'string') {
	                this.style[keyOrObj] = value;
	            }
	            else {
	                extend(this.style, keyOrObj);
	            }
	            this.dirtyStyle();
	            return this;
	        };
	        Displayable.prototype.dirtyStyle = function (notRedraw) {
	            if (!notRedraw) {
	                this.markRedraw();
	            }
	            this.__dirty |= STYLE_CHANGED_BIT;
	            if (this._rect) {
	                this._rect = null;
	            }
	        };
	        Displayable.prototype.dirty = function () {
	            this.dirtyStyle();
	        };
	        Displayable.prototype.styleChanged = function () {
	            return !!(this.__dirty & STYLE_CHANGED_BIT);
	        };
	        Displayable.prototype.styleUpdated = function () {
	            this.__dirty &= ~STYLE_CHANGED_BIT;
	        };
	        Displayable.prototype.createStyle = function (obj) {
	            return createObject(DEFAULT_COMMON_STYLE, obj);
	        };
	        Displayable.prototype.useStyle = function (obj) {
	            if (!obj[STYLE_MAGIC_KEY]) {
	                obj = this.createStyle(obj);
	            }
	            if (this.__inHover) {
	                this.__hoverStyle = obj;
	            }
	            else {
	                this.style = obj;
	            }
	            this.dirtyStyle();
	        };
	        Displayable.prototype.isStyleObject = function (obj) {
	            return obj[STYLE_MAGIC_KEY];
	        };
	        Displayable.prototype._innerSaveToNormal = function (toState) {
	            _super.prototype._innerSaveToNormal.call(this, toState);
	            var normalState = this._normalState;
	            if (toState.style && !normalState.style) {
	                normalState.style = this._mergeStyle(this.createStyle(), this.style);
	            }
	            this._savePrimaryToNormal(toState, normalState, PRIMARY_STATES_KEYS$1);
	        };
	        Displayable.prototype._applyStateObj = function (stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
	            _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
	            var needsRestoreToNormal = !(state && keepCurrentStates);
	            var targetStyle;
	            if (state && state.style) {
	                if (transition) {
	                    if (keepCurrentStates) {
	                        targetStyle = state.style;
	                    }
	                    else {
	                        targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
	                        this._mergeStyle(targetStyle, state.style);
	                    }
	                }
	                else {
	                    targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
	                    this._mergeStyle(targetStyle, state.style);
	                }
	            }
	            else if (needsRestoreToNormal) {
	                targetStyle = normalState.style;
	            }
	            if (targetStyle) {
	                if (transition) {
	                    var sourceStyle = this.style;
	                    this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
	                    if (needsRestoreToNormal) {
	                        var changedKeys = keys(sourceStyle);
	                        for (var i = 0; i < changedKeys.length; i++) {
	                            var key = changedKeys[i];
	                            if (key in targetStyle) {
	                                targetStyle[key] = targetStyle[key];
	                                this.style[key] = sourceStyle[key];
	                            }
	                        }
	                    }
	                    var targetKeys = keys(targetStyle);
	                    for (var i = 0; i < targetKeys.length; i++) {
	                        var key = targetKeys[i];
	                        this.style[key] = this.style[key];
	                    }
	                    this._transitionState(stateName, {
	                        style: targetStyle
	                    }, animationCfg, this.getAnimationStyleProps());
	                }
	                else {
	                    this.useStyle(targetStyle);
	                }
	            }
	            var statesKeys = this.__inHover ? PRIMARY_STATES_KEYS_IN_HOVER_LAYER : PRIMARY_STATES_KEYS$1;
	            for (var i = 0; i < statesKeys.length; i++) {
	                var key = statesKeys[i];
	                if (state && state[key] != null) {
	                    this[key] = state[key];
	                }
	                else if (needsRestoreToNormal) {
	                    if (normalState[key] != null) {
	                        this[key] = normalState[key];
	                    }
	                }
	            }
	        };
	        Displayable.prototype._mergeStates = function (states) {
	            var mergedState = _super.prototype._mergeStates.call(this, states);
	            var mergedStyle;
	            for (var i = 0; i < states.length; i++) {
	                var state = states[i];
	                if (state.style) {
	                    mergedStyle = mergedStyle || {};
	                    this._mergeStyle(mergedStyle, state.style);
	                }
	            }
	            if (mergedStyle) {
	                mergedState.style = mergedStyle;
	            }
	            return mergedState;
	        };
	        Displayable.prototype._mergeStyle = function (targetStyle, sourceStyle) {
	            extend(targetStyle, sourceStyle);
	            return targetStyle;
	        };
	        Displayable.prototype.getAnimationStyleProps = function () {
	            return DEFAULT_COMMON_ANIMATION_PROPS;
	        };
	        Displayable.initDefaultProps = (function () {
	            var dispProto = Displayable.prototype;
	            dispProto.type = 'displayable';
	            dispProto.invisible = false;
	            dispProto.z = 0;
	            dispProto.z2 = 0;
	            dispProto.zlevel = 0;
	            dispProto.culling = false;
	            dispProto.cursor = 'pointer';
	            dispProto.rectHover = false;
	            dispProto.incremental = false;
	            dispProto._rect = null;
	            dispProto.dirtyRectTolerance = 0;
	            dispProto.__dirty = REDRAW_BIT | STYLE_CHANGED_BIT;
	        })();
	        return Displayable;
	    }(Element));
	    var tmpRect$1 = new BoundingRect(0, 0, 0, 0);
	    var viewRect = new BoundingRect(0, 0, 0, 0);
	    function isDisplayableCulled(el, width, height) {
	        tmpRect$1.copy(el.getBoundingRect());
	        if (el.transform) {
	            tmpRect$1.applyTransform(el.transform);
	        }
	        viewRect.width = width;
	        viewRect.height = height;
	        return !tmpRect$1.intersect(viewRect);
	    }
	
	    var mathMin$1 = Math.min;
	    var mathMax$1 = Math.max;
	    var mathSin = Math.sin;
	    var mathCos = Math.cos;
	    var PI2 = Math.PI * 2;
	    var start = create();
	    var end = create();
	    var extremity = create();
	    function fromPoints(points, min, max) {
	        if (points.length === 0) {
	            return;
	        }
	        var p = points[0];
	        var left = p[0];
	        var right = p[0];
	        var top = p[1];
	        var bottom = p[1];
	        for (var i = 1; i < points.length; i++) {
	            p = points[i];
	            left = mathMin$1(left, p[0]);
	            right = mathMax$1(right, p[0]);
	            top = mathMin$1(top, p[1]);
	            bottom = mathMax$1(bottom, p[1]);
	        }
	        min[0] = left;
	        min[1] = top;
	        max[0] = right;
	        max[1] = bottom;
	    }
	    function fromLine(x0, y0, x1, y1, min, max) {
	        min[0] = mathMin$1(x0, x1);
	        min[1] = mathMin$1(y0, y1);
	        max[0] = mathMax$1(x0, x1);
	        max[1] = mathMax$1(y0, y1);
	    }
	    var xDim = [];
	    var yDim = [];
	    function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
	        var cubicExtrema$1 = cubicExtrema;
	        var cubicAt$1 = cubicAt;
	        var n = cubicExtrema$1(x0, x1, x2, x3, xDim);
	        min[0] = Infinity;
	        min[1] = Infinity;
	        max[0] = -Infinity;
	        max[1] = -Infinity;
	        for (var i = 0; i < n; i++) {
	            var x = cubicAt$1(x0, x1, x2, x3, xDim[i]);
	            min[0] = mathMin$1(x, min[0]);
	            max[0] = mathMax$1(x, max[0]);
	        }
	        n = cubicExtrema$1(y0, y1, y2, y3, yDim);
	        for (var i = 0; i < n; i++) {
	            var y = cubicAt$1(y0, y1, y2, y3, yDim[i]);
	            min[1] = mathMin$1(y, min[1]);
	            max[1] = mathMax$1(y, max[1]);
	        }
	        min[0] = mathMin$1(x0, min[0]);
	        max[0] = mathMax$1(x0, max[0]);
	        min[0] = mathMin$1(x3, min[0]);
	        max[0] = mathMax$1(x3, max[0]);
	        min[1] = mathMin$1(y0, min[1]);
	        max[1] = mathMax$1(y0, max[1]);
	        min[1] = mathMin$1(y3, min[1]);
	        max[1] = mathMax$1(y3, max[1]);
	    }
	    function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
	        var quadraticExtremum$1 = quadraticExtremum;
	        var quadraticAt$1 = quadraticAt;
	        var tx = mathMax$1(mathMin$1(quadraticExtremum$1(x0, x1, x2), 1), 0);
	        var ty = mathMax$1(mathMin$1(quadraticExtremum$1(y0, y1, y2), 1), 0);
	        var x = quadraticAt$1(x0, x1, x2, tx);
	        var y = quadraticAt$1(y0, y1, y2, ty);
	        min[0] = mathMin$1(x0, x2, x);
	        min[1] = mathMin$1(y0, y2, y);
	        max[0] = mathMax$1(x0, x2, x);
	        max[1] = mathMax$1(y0, y2, y);
	    }
	    function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min$1, max$1) {
	        var vec2Min = min;
	        var vec2Max = max;
	        var diff = Math.abs(startAngle - endAngle);
	        if (diff % PI2 < 1e-4 && diff > 1e-4) {
	            min$1[0] = x - rx;
	            min$1[1] = y - ry;
	            max$1[0] = x + rx;
	            max$1[1] = y + ry;
	            return;
	        }
	        start[0] = mathCos(startAngle) * rx + x;
	        start[1] = mathSin(startAngle) * ry + y;
	        end[0] = mathCos(endAngle) * rx + x;
	        end[1] = mathSin(endAngle) * ry + y;
	        vec2Min(min$1, start, end);
	        vec2Max(max$1, start, end);
	        startAngle = startAngle % (PI2);
	        if (startAngle < 0) {
	            startAngle = startAngle + PI2;
	        }
	        endAngle = endAngle % (PI2);
	        if (endAngle < 0) {
	            endAngle = endAngle + PI2;
	        }
	        if (startAngle > endAngle && !anticlockwise) {
	            endAngle += PI2;
	        }
	        else if (startAngle < endAngle && anticlockwise) {
	            startAngle += PI2;
	        }
	        if (anticlockwise) {
	            var tmp = endAngle;
	            endAngle = startAngle;
	            startAngle = tmp;
	        }
	        for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
	            if (angle > startAngle) {
	                extremity[0] = mathCos(angle) * rx + x;
	                extremity[1] = mathSin(angle) * ry + y;
	                vec2Min(min$1, extremity, min$1);
	                vec2Max(max$1, extremity, max$1);
	            }
	        }
	    }
	
	    var CMD = {
	        M: 1,
	        L: 2,
	        C: 3,
	        Q: 4,
	        A: 5,
	        Z: 6,
	        R: 7
	    };
	    var tmpOutX = [];
	    var tmpOutY = [];
	    var min$1 = [];
	    var max$1 = [];
	    var min2 = [];
	    var max2 = [];
	    var mathMin$2 = Math.min;
	    var mathMax$2 = Math.max;
	    var mathCos$1 = Math.cos;
	    var mathSin$1 = Math.sin;
	    var mathAbs = Math.abs;
	    var PI = Math.PI;
	    var PI2$1 = PI * 2;
	    var hasTypedArray = typeof Float32Array !== 'undefined';
	    var tmpAngles = [];
	    function modPI2(radian) {
	        var n = Math.round(radian / PI * 1e8) / 1e8;
	        return (n % 2) * PI;
	    }
	    function normalizeArcAngles(angles, anticlockwise) {
	        var newStartAngle = modPI2(angles[0]);
	        if (newStartAngle < 0) {
	            newStartAngle += PI2$1;
	        }
	        var delta = newStartAngle - angles[0];
	        var newEndAngle = angles[1];
	        newEndAngle += delta;
	        if (!anticlockwise && newEndAngle - newStartAngle >= PI2$1) {
	            newEndAngle = newStartAngle + PI2$1;
	        }
	        else if (anticlockwise && newStartAngle - newEndAngle >= PI2$1) {
	            newEndAngle = newStartAngle - PI2$1;
	        }
	        else if (!anticlockwise && newStartAngle > newEndAngle) {
	            newEndAngle = newStartAngle + (PI2$1 - modPI2(newStartAngle - newEndAngle));
	        }
	        else if (anticlockwise && newStartAngle < newEndAngle) {
	            newEndAngle = newStartAngle - (PI2$1 - modPI2(newEndAngle - newStartAngle));
	        }
	        angles[0] = newStartAngle;
	        angles[1] = newEndAngle;
	    }
	    var PathProxy = (function () {
	        function PathProxy(notSaveData) {
	            this.dpr = 1;
	            this._xi = 0;
	            this._yi = 0;
	            this._x0 = 0;
	            this._y0 = 0;
	            this._len = 0;
	            if (notSaveData) {
	                this._saveData = false;
	            }
	            if (this._saveData) {
	                this.data = [];
	            }
	        }
	        PathProxy.prototype.increaseVersion = function () {
	            this._version++;
	        };
	        PathProxy.prototype.getVersion = function () {
	            return this._version;
	        };
	        PathProxy.prototype.setScale = function (sx, sy, segmentIgnoreThreshold) {
	            segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
	            if (segmentIgnoreThreshold > 0) {
	                this._ux = mathAbs(segmentIgnoreThreshold / devicePixelRatio / sx) || 0;
	                this._uy = mathAbs(segmentIgnoreThreshold / devicePixelRatio / sy) || 0;
	            }
	        };
	        PathProxy.prototype.setDPR = function (dpr) {
	            this.dpr = dpr;
	        };
	        PathProxy.prototype.setContext = function (ctx) {
	            this._ctx = ctx;
	        };
	        PathProxy.prototype.getContext = function () {
	            return this._ctx;
	        };
	        PathProxy.prototype.beginPath = function () {
	            this._ctx && this._ctx.beginPath();
	            this.reset();
	            return this;
	        };
	        PathProxy.prototype.reset = function () {
	            if (this._saveData) {
	                this._len = 0;
	            }
	            if (this._pathSegLen) {
	                this._pathSegLen = null;
	                this._pathLen = 0;
	            }
	            this._version++;
	        };
	        PathProxy.prototype.moveTo = function (x, y) {
	            this._drawPendingPt();
	            this.addData(CMD.M, x, y);
	            this._ctx && this._ctx.moveTo(x, y);
	            this._x0 = x;
	            this._y0 = y;
	            this._xi = x;
	            this._yi = y;
	            return this;
	        };
	        PathProxy.prototype.lineTo = function (x, y) {
	            var dx = mathAbs(x - this._xi);
	            var dy = mathAbs(y - this._yi);
	            var exceedUnit = dx > this._ux || dy > this._uy;
	            this.addData(CMD.L, x, y);
	            if (this._ctx && exceedUnit) {
	                this._ctx.lineTo(x, y);
	            }
	            if (exceedUnit) {
	                this._xi = x;
	                this._yi = y;
	                this._pendingPtDist = 0;
	            }
	            else {
	                var d2 = dx * dx + dy * dy;
	                if (d2 > this._pendingPtDist) {
	                    this._pendingPtX = x;
	                    this._pendingPtY = y;
	                    this._pendingPtDist = d2;
	                }
	            }
	            return this;
	        };
	        PathProxy.prototype.bezierCurveTo = function (x1, y1, x2, y2, x3, y3) {
	            this._drawPendingPt();
	            this.addData(CMD.C, x1, y1, x2, y2, x3, y3);
	            if (this._ctx) {
	                this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
	            }
	            this._xi = x3;
	            this._yi = y3;
	            return this;
	        };
	        PathProxy.prototype.quadraticCurveTo = function (x1, y1, x2, y2) {
	            this._drawPendingPt();
	            this.addData(CMD.Q, x1, y1, x2, y2);
	            if (this._ctx) {
	                this._ctx.quadraticCurveTo(x1, y1, x2, y2);
	            }
	            this._xi = x2;
	            this._yi = y2;
	            return this;
	        };
	        PathProxy.prototype.arc = function (cx, cy, r, startAngle, endAngle, anticlockwise) {
	            this._drawPendingPt();
	            tmpAngles[0] = startAngle;
	            tmpAngles[1] = endAngle;
	            normalizeArcAngles(tmpAngles, anticlockwise);
	            startAngle = tmpAngles[0];
	            endAngle = tmpAngles[1];
	            var delta = endAngle - startAngle;
	            this.addData(CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
	            this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
	            this._xi = mathCos$1(endAngle) * r + cx;
	            this._yi = mathSin$1(endAngle) * r + cy;
	            return this;
	        };
	        PathProxy.prototype.arcTo = function (x1, y1, x2, y2, radius) {
	            this._drawPendingPt();
	            if (this._ctx) {
	                this._ctx.arcTo(x1, y1, x2, y2, radius);
	            }
	            return this;
	        };
	        PathProxy.prototype.rect = function (x, y, w, h) {
	            this._drawPendingPt();
	            this._ctx && this._ctx.rect(x, y, w, h);
	            this.addData(CMD.R, x, y, w, h);
	            return this;
	        };
	        PathProxy.prototype.closePath = function () {
	            this._drawPendingPt();
	            this.addData(CMD.Z);
	            var ctx = this._ctx;
	            var x0 = this._x0;
	            var y0 = this._y0;
	            if (ctx) {
	                ctx.closePath();
	            }
	            this._xi = x0;
	            this._yi = y0;
	            return this;
	        };
	        PathProxy.prototype.fill = function (ctx) {
	            ctx && ctx.fill();
	            this.toStatic();
	        };
	        PathProxy.prototype.stroke = function (ctx) {
	            ctx && ctx.stroke();
	            this.toStatic();
	        };
	        PathProxy.prototype.len = function () {
	            return this._len;
	        };
	        PathProxy.prototype.setData = function (data) {
	            var len = data.length;
	            if (!(this.data && this.data.length === len) && hasTypedArray) {
	                this.data = new Float32Array(len);
	            }
	            for (var i = 0; i < len; i++) {
	                this.data[i] = data[i];
	            }
	            this._len = len;
	        };
	        PathProxy.prototype.appendPath = function (path) {
	            if (!(path instanceof Array)) {
	                path = [path];
	            }
	            var len = path.length;
	            var appendSize = 0;
	            var offset = this._len;
	            for (var i = 0; i < len; i++) {
	                appendSize += path[i].len();
	            }
	            if (hasTypedArray && (this.data instanceof Float32Array)) {
	                this.data = new Float32Array(offset + appendSize);
	            }
	            for (var i = 0; i < len; i++) {
	                var appendPathData = path[i].data;
	                for (var k = 0; k < appendPathData.length; k++) {
	                    this.data[offset++] = appendPathData[k];
	                }
	            }
	            this._len = offset;
	        };
	        PathProxy.prototype.addData = function (cmd, a, b, c, d, e, f, g, h) {
	            if (!this._saveData) {
	                return;
	            }
	            var data = this.data;
	            if (this._len + arguments.length > data.length) {
	                this._expandData();
	                data = this.data;
	            }
	            for (var i = 0; i < arguments.length; i++) {
	                data[this._len++] = arguments[i];
	            }
	        };
	        PathProxy.prototype._drawPendingPt = function () {
	            if (this._pendingPtDist > 0) {
	                this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
	                this._pendingPtDist = 0;
	            }
	        };
	        PathProxy.prototype._expandData = function () {
	            if (!(this.data instanceof Array)) {
	                var newData = [];
	                for (var i = 0; i < this._len; i++) {
	                    newData[i] = this.data[i];
	                }
	                this.data = newData;
	            }
	        };
	        PathProxy.prototype.toStatic = function () {
	            if (!this._saveData) {
	                return;
	            }
	            this._drawPendingPt();
	            var data = this.data;
	            if (data instanceof Array) {
	                data.length = this._len;
	                if (hasTypedArray && this._len > 11) {
	                    this.data = new Float32Array(data);
	                }
	            }
	        };
	        PathProxy.prototype.getBoundingRect = function () {
	            min$1[0] = min$1[1] = min2[0] = min2[1] = Number.MAX_VALUE;
	            max$1[0] = max$1[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
	            var data = this.data;
	            var xi = 0;
	            var yi = 0;
	            var x0 = 0;
	            var y0 = 0;
	            var i;
	            for (i = 0; i < this._len;) {
	                var cmd = data[i++];
	                var isFirst = i === 1;
	                if (isFirst) {
	                    xi = data[i];
	                    yi = data[i + 1];
	                    x0 = xi;
	                    y0 = yi;
	                }
	                switch (cmd) {
	                    case CMD.M:
	                        xi = x0 = data[i++];
	                        yi = y0 = data[i++];
	                        min2[0] = x0;
	                        min2[1] = y0;
	                        max2[0] = x0;
	                        max2[1] = y0;
	                        break;
	                    case CMD.L:
	                        fromLine(xi, yi, data[i], data[i + 1], min2, max2);
	                        xi = data[i++];
	                        yi = data[i++];
	                        break;
	                    case CMD.C:
	                        fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
	                        xi = data[i++];
	                        yi = data[i++];
	                        break;
	                    case CMD.Q:
	                        fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
	                        xi = data[i++];
	                        yi = data[i++];
	                        break;
	                    case CMD.A:
	                        var cx = data[i++];
	                        var cy = data[i++];
	                        var rx = data[i++];
	                        var ry = data[i++];
	                        var startAngle = data[i++];
	                        var endAngle = data[i++] + startAngle;
	                        i += 1;
	                        var anticlockwise = !data[i++];
	                        if (isFirst) {
	                            x0 = mathCos$1(startAngle) * rx + cx;
	                            y0 = mathSin$1(startAngle) * ry + cy;
	                        }
	                        fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
	                        xi = mathCos$1(endAngle) * rx + cx;
	                        yi = mathSin$1(endAngle) * ry + cy;
	                        break;
	                    case CMD.R:
	                        x0 = xi = data[i++];
	                        y0 = yi = data[i++];
	                        var width = data[i++];
	                        var height = data[i++];
	                        fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
	                        break;
	                    case CMD.Z:
	                        xi = x0;
	                        yi = y0;
	                        break;
	                }
	                min(min$1, min$1, min2);
	                max(max$1, max$1, max2);
	            }
	            if (i === 0) {
	                min$1[0] = min$1[1] = max$1[0] = max$1[1] = 0;
	            }
	            return new BoundingRect(min$1[0], min$1[1], max$1[0] - min$1[0], max$1[1] - min$1[1]);
	        };
	        PathProxy.prototype._calculateLength = function () {
	            var data = this.data;
	            var len = this._len;
	            var ux = this._ux;
	            var uy = this._uy;
	            var xi = 0;
	            var yi = 0;
	            var x0 = 0;
	            var y0 = 0;
	            if (!this._pathSegLen) {
	                this._pathSegLen = [];
	            }
	            var pathSegLen = this._pathSegLen;
	            var pathTotalLen = 0;
	            var segCount = 0;
	            for (var i = 0; i < len;) {
	                var cmd = data[i++];
	                var isFirst = i === 1;
	                if (isFirst) {
	                    xi = data[i];
	                    yi = data[i + 1];
	                    x0 = xi;
	                    y0 = yi;
	                }
	                var l = -1;
	                switch (cmd) {
	                    case CMD.M:
	                        xi = x0 = data[i++];
	                        yi = y0 = data[i++];
	                        break;
	                    case CMD.L: {
	                        var x2 = data[i++];
	                        var y2 = data[i++];
	                        var dx = x2 - xi;
	                        var dy = y2 - yi;
	                        if (mathAbs(dx) > ux || mathAbs(dy) > uy || i === len - 1) {
	                            l = Math.sqrt(dx * dx + dy * dy);
	                            xi = x2;
	                            yi = y2;
	                        }
	                        break;
	                    }
	                    case CMD.C: {
	                        var x1 = data[i++];
	                        var y1 = data[i++];
	                        var x2 = data[i++];
	                        var y2 = data[i++];
	                        var x3 = data[i++];
	                        var y3 = data[i++];
	                        l = cubicLength(xi, yi, x1, y1, x2, y2, x3, y3, 10);
	                        xi = x3;
	                        yi = y3;
	                        break;
	                    }
	                    case CMD.Q: {
	                        var x1 = data[i++];
	                        var y1 = data[i++];
	                        var x2 = data[i++];
	                        var y2 = data[i++];
	                        l = quadraticLength(xi, yi, x1, y1, x2, y2, 10);
	                        xi = x2;
	                        yi = y2;
	                        break;
	                    }
	                    case CMD.A:
	                        var cx = data[i++];
	                        var cy = data[i++];
	                        var rx = data[i++];
	                        var ry = data[i++];
	                        var startAngle = data[i++];
	                        var delta = data[i++];
	                        var endAngle = delta + startAngle;
	                        i += 1;
	                        var anticlockwise = !data[i++];
	                        if (isFirst) {
	                            x0 = mathCos$1(startAngle) * rx + cx;
	                            y0 = mathSin$1(startAngle) * ry + cy;
	                        }
	                        l = mathMax$2(rx, ry) * mathMin$2(PI2$1, Math.abs(delta));
	                        xi = mathCos$1(endAngle) * rx + cx;
	                        yi = mathSin$1(endAngle) * ry + cy;
	                        break;
	                    case CMD.R: {
	                        x0 = xi = data[i++];
	                        y0 = yi = data[i++];
	                        var width = data[i++];
	                        var height = data[i++];
	                        l = width * 2 + height * 2;
	                        break;
	                    }
	                    case CMD.Z: {
	                        var dx = x0 - xi;
	                        var dy = y0 - yi;
	                        l = Math.sqrt(dx * dx + dy * dy);
	                        xi = x0;
	                        yi = y0;
	                        break;
	                    }
	                }
	                if (l >= 0) {
	                    pathSegLen[segCount++] = l;
	                    pathTotalLen += l;
	                }
	            }
	            this._pathLen = pathTotalLen;
	            return pathTotalLen;
	        };
	        PathProxy.prototype.rebuildPath = function (ctx, percent) {
	            var d = this.data;
	            var ux = this._ux;
	            var uy = this._uy;
	            var len = this._len;
	            var x0;
	            var y0;
	            var xi;
	            var yi;
	            var x;
	            var y;
	            var drawPart = percent < 1;
	            var pathSegLen;
	            var pathTotalLen;
	            var accumLength = 0;
	            var segCount = 0;
	            var displayedLength;
	            var pendingPtDist = 0;
	            var pendingPtX;
	            var pendingPtY;
	            if (drawPart) {
	                if (!this._pathSegLen) {
	                    this._calculateLength();
	                }
	                pathSegLen = this._pathSegLen;
	                pathTotalLen = this._pathLen;
	                displayedLength = percent * pathTotalLen;
	                if (!displayedLength) {
	                    return;
	                }
	            }
	            lo: for (var i = 0; i < len;) {
	                var cmd = d[i++];
	                var isFirst = i === 1;
	                if (isFirst) {
	                    xi = d[i];
	                    yi = d[i + 1];
	                    x0 = xi;
	                    y0 = yi;
	                }
	                if (cmd !== CMD.L && pendingPtDist > 0) {
	                    ctx.lineTo(pendingPtX, pendingPtY);
	                    pendingPtDist = 0;
	                }
	                switch (cmd) {
	                    case CMD.M:
	                        x0 = xi = d[i++];
	                        y0 = yi = d[i++];
	                        ctx.moveTo(xi, yi);
	                        break;
	                    case CMD.L: {
	                        x = d[i++];
	                        y = d[i++];
	                        var dx = mathAbs(x - xi);
	                        var dy = mathAbs(y - yi);
	                        if (dx > ux || dy > uy) {
	                            if (drawPart) {
	                                var l = pathSegLen[segCount++];
	                                if (accumLength + l > displayedLength) {
	                                    var t = (displayedLength - accumLength) / l;
	                                    ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
	                                    break lo;
	                                }
	                                accumLength += l;
	                            }
	                            ctx.lineTo(x, y);
	                            xi = x;
	                            yi = y;
	                            pendingPtDist = 0;
	                        }
	                        else {
	                            var d2 = dx * dx + dy * dy;
	                            if (d2 > pendingPtDist) {
	                                pendingPtX = x;
	                                pendingPtY = y;
	                                pendingPtDist = d2;
	                            }
	                        }
	                        break;
	                    }
	                    case CMD.C: {
	                        var x1 = d[i++];
	                        var y1 = d[i++];
	                        var x2 = d[i++];
	                        var y2 = d[i++];
	                        var x3 = d[i++];
	                        var y3 = d[i++];
	                        if (drawPart) {
	                            var l = pathSegLen[segCount++];
	                            if (accumLength + l > displayedLength) {
	                                var t = (displayedLength - accumLength) / l;
	                                cubicSubdivide(xi, x1, x2, x3, t, tmpOutX);
	                                cubicSubdivide(yi, y1, y2, y3, t, tmpOutY);
	                                ctx.bezierCurveTo(tmpOutX[1], tmpOutY[1], tmpOutX[2], tmpOutY[2], tmpOutX[3], tmpOutY[3]);
	                                break lo;
	                            }
	                            accumLength += l;
	                        }
	                        ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
	                        xi = x3;
	                        yi = y3;
	                        break;
	                    }
	                    case CMD.Q: {
	                        var x1 = d[i++];
	                        var y1 = d[i++];
	                        var x2 = d[i++];
	                        var y2 = d[i++];
	                        if (drawPart) {
	                            var l = pathSegLen[segCount++];
	                            if (accumLength + l > displayedLength) {
	                                var t = (displayedLength - accumLength) / l;
	                                quadraticSubdivide(xi, x1, x2, t, tmpOutX);
	                                quadraticSubdivide(yi, y1, y2, t, tmpOutY);
	                                ctx.quadraticCurveTo(tmpOutX[1], tmpOutY[1], tmpOutX[2], tmpOutY[2]);
	                                break lo;
	                            }
	                            accumLength += l;
	                        }
	                        ctx.quadraticCurveTo(x1, y1, x2, y2);
	                        xi = x2;
	                        yi = y2;
	                        break;
	                    }
	                    case CMD.A:
	                        var cx = d[i++];
	                        var cy = d[i++];
	                        var rx = d[i++];
	                        var ry = d[i++];
	                        var startAngle = d[i++];
	                        var delta = d[i++];
	                        var psi = d[i++];
	                        var anticlockwise = !d[i++];
	                        var r = (rx > ry) ? rx : ry;
	                        var isEllipse = mathAbs(rx - ry) > 1e-3;
	                        var endAngle = startAngle + delta;
	                        var breakBuild = false;
	                        if (drawPart) {
	                            var l = pathSegLen[segCount++];
	                            if (accumLength + l > displayedLength) {
	                                endAngle = startAngle + delta * (displayedLength - accumLength) / l;
	                                breakBuild = true;
	                            }
	                            accumLength += l;
	                        }
	                        if (isEllipse && ctx.ellipse) {
	                            ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
	                        }
	                        else {
	                            ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
	                        }
	                        if (breakBuild) {
	                            break lo;
	                        }
	                        if (isFirst) {
	                            x0 = mathCos$1(startAngle) * rx + cx;
	                            y0 = mathSin$1(startAngle) * ry + cy;
	                        }
	                        xi = mathCos$1(endAngle) * rx + cx;
	                        yi = mathSin$1(endAngle) * ry + cy;
	                        break;
	                    case CMD.R:
	                        x0 = xi = d[i];
	                        y0 = yi = d[i + 1];
	                        x = d[i++];
	                        y = d[i++];
	                        var width = d[i++];
	                        var height = d[i++];
	                        if (drawPart) {
	                            var l = pathSegLen[segCount++];
	                            if (accumLength + l > displayedLength) {
	                                var d_1 = displayedLength - accumLength;
	                                ctx.moveTo(x, y);
	                                ctx.lineTo(x + mathMin$2(d_1, width), y);
	                                d_1 -= width;
	                                if (d_1 > 0) {
	                                    ctx.lineTo(x + width, y + mathMin$2(d_1, height));
	                                }
	                                d_1 -= height;
	                                if (d_1 > 0) {
	                                    ctx.lineTo(x + mathMax$2(width - d_1, 0), y + height);
	                                }
	                                d_1 -= width;
	                                if (d_1 > 0) {
	                                    ctx.lineTo(x, y + mathMax$2(height - d_1, 0));
	                                }
	                                break lo;
	                            }
	                            accumLength += l;
	                        }
	                        ctx.rect(x, y, width, height);
	                        break;
	                    case CMD.Z:
	                        if (drawPart) {
	                            var l = pathSegLen[segCount++];
	                            if (accumLength + l > displayedLength) {
	                                var t = (displayedLength - accumLength) / l;
	                                ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
	                                break lo;
	                            }
	                            accumLength += l;
	                        }
	                        ctx.closePath();
	                        xi = x0;
	                        yi = y0;
	                }
	            }
	        };
	        PathProxy.prototype.clone = function () {
	            var newProxy = new PathProxy();
	            var data = this.data;
	            newProxy.data = data.slice ? data.slice()
	                : Array.prototype.slice.call(data);
	            newProxy._len = this._len;
	            return newProxy;
	        };
	        PathProxy.CMD = CMD;
	        PathProxy.initDefaultProps = (function () {
	            var proto = PathProxy.prototype;
	            proto._saveData = true;
	            proto._ux = 0;
	            proto._uy = 0;
	            proto._pendingPtDist = 0;
	            proto._version = 0;
	        })();
	        return PathProxy;
	    }());
	
	    function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
	        if (lineWidth === 0) {
	            return false;
	        }
	        var _l = lineWidth;
	        var _a = 0;
	        var _b = x0;
	        if ((y > y0 + _l && y > y1 + _l)
	            || (y < y0 - _l && y < y1 - _l)
	            || (x > x0 + _l && x > x1 + _l)
	            || (x < x0 - _l && x < x1 - _l)) {
	            return false;
	        }
	        if (x0 !== x1) {
	            _a = (y0 - y1) / (x0 - x1);
	            _b = (x0 * y1 - x1 * y0) / (x0 - x1);
	        }
	        else {
	            return Math.abs(x - x0) <= _l / 2;
	        }
	        var tmp = _a * x - y + _b;
	        var _s = tmp * tmp / (_a * _a + 1);
	        return _s <= _l / 2 * _l / 2;
	    }
	
	    function containStroke$1(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
	        if (lineWidth === 0) {
	            return false;
	        }
	        var _l = lineWidth;
	        if ((y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l)
	            || (y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l)
	            || (x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l)
	            || (x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l)) {
	            return false;
	        }
	        var d = cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
	        return d <= _l / 2;
	    }
	
	    function containStroke$2(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
	        if (lineWidth === 0) {
	            return false;
	        }
	        var _l = lineWidth;
	        if ((y > y0 + _l && y > y1 + _l && y > y2 + _l)
	            || (y < y0 - _l && y < y1 - _l && y < y2 - _l)
	            || (x > x0 + _l && x > x1 + _l && x > x2 + _l)
	            || (x < x0 - _l && x < x1 - _l && x < x2 - _l)) {
	            return false;
	        }
	        var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
	        return d <= _l / 2;
	    }
	
	    var PI2$2 = Math.PI * 2;
	    function normalizeRadian(angle) {
	        angle %= PI2$2;
	        if (angle < 0) {
	            angle += PI2$2;
	        }
	        return angle;
	    }
	
	    var PI2$3 = Math.PI * 2;
	    function containStroke$3(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
	        if (lineWidth === 0) {
	            return false;
	        }
	        var _l = lineWidth;
	        x -= cx;
	        y -= cy;
	        var d = Math.sqrt(x * x + y * y);
	        if ((d - _l > r) || (d + _l < r)) {
	            return false;
	        }
	        if (Math.abs(startAngle - endAngle) % PI2$3 < 1e-4) {
	            return true;
	        }
	        if (anticlockwise) {
	            var tmp = startAngle;
	            startAngle = normalizeRadian(endAngle);
	            endAngle = normalizeRadian(tmp);
	        }
	        else {
	            startAngle = normalizeRadian(startAngle);
	            endAngle = normalizeRadian(endAngle);
	        }
	        if (startAngle > endAngle) {
	            endAngle += PI2$3;
	        }
	        var angle = Math.atan2(y, x);
	        if (angle < 0) {
	            angle += PI2$3;
	        }
	        return (angle >= startAngle && angle <= endAngle)
	            || (angle + PI2$3 >= startAngle && angle + PI2$3 <= endAngle);
	    }
	
	    function windingLine(x0, y0, x1, y1, x, y) {
	        if ((y > y0 && y > y1) || (y < y0 && y < y1)) {
	            return 0;
	        }
	        if (y1 === y0) {
	            return 0;
	        }
	        var t = (y - y0) / (y1 - y0);
	        var dir = y1 < y0 ? 1 : -1;
	        if (t === 1 || t === 0) {
	            dir = y1 < y0 ? 0.5 : -0.5;
	        }
	        var x_ = t * (x1 - x0) + x0;
	        return x_ === x ? Infinity : x_ > x ? dir : 0;
	    }
	
	    var CMD$1 = PathProxy.CMD;
	    var PI2$4 = Math.PI * 2;
	    var EPSILON$3 = 1e-4;
	    function isAroundEqual(a, b) {
	        return Math.abs(a - b) < EPSILON$3;
	    }
	    var roots = [-1, -1, -1];
	    var extrema = [-1, -1];
	    function swapExtrema() {
	        var tmp = extrema[0];
	        extrema[0] = extrema[1];
	        extrema[1] = tmp;
	    }
	    function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
	        if ((y > y0 && y > y1 && y > y2 && y > y3)
	            || (y < y0 && y < y1 && y < y2 && y < y3)) {
	            return 0;
	        }
	        var nRoots = cubicRootAt(y0, y1, y2, y3, y, roots);
	        if (nRoots === 0) {
	            return 0;
	        }
	        else {
	            var w = 0;
	            var nExtrema = -1;
	            var y0_ = void 0;
	            var y1_ = void 0;
	            for (var i = 0; i < nRoots; i++) {
	                var t = roots[i];
	                var unit = (t === 0 || t === 1) ? 0.5 : 1;
	                var x_ = cubicAt(x0, x1, x2, x3, t);
	                if (x_ < x) {
	                    continue;
	                }
	                if (nExtrema < 0) {
	                    nExtrema = cubicExtrema(y0, y1, y2, y3, extrema);
	                    if (extrema[1] < extrema[0] && nExtrema > 1) {
	                        swapExtrema();
	                    }
	                    y0_ = cubicAt(y0, y1, y2, y3, extrema[0]);
	                    if (nExtrema > 1) {
	                        y1_ = cubicAt(y0, y1, y2, y3, extrema[1]);
	                    }
	                }
	                if (nExtrema === 2) {
	                    if (t < extrema[0]) {
	                        w += y0_ < y0 ? unit : -unit;
	                    }
	                    else if (t < extrema[1]) {
	                        w += y1_ < y0_ ? unit : -unit;
	                    }
	                    else {
	                        w += y3 < y1_ ? unit : -unit;
	                    }
	                }
	                else {
	                    if (t < extrema[0]) {
	                        w += y0_ < y0 ? unit : -unit;
	                    }
	                    else {
	                        w += y3 < y0_ ? unit : -unit;
	                    }
	                }
	            }
	            return w;
	        }
	    }
	    function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
	        if ((y > y0 && y > y1 && y > y2)
	            || (y < y0 && y < y1 && y < y2)) {
	            return 0;
	        }
	        var nRoots = quadraticRootAt(y0, y1, y2, y, roots);
	        if (nRoots === 0) {
	            return 0;
	        }
	        else {
	            var t = quadraticExtremum(y0, y1, y2);
	            if (t >= 0 && t <= 1) {
	                var w = 0;
	                var y_ = quadraticAt(y0, y1, y2, t);
	                for (var i = 0; i < nRoots; i++) {
	                    var unit = (roots[i] === 0 || roots[i] === 1) ? 0.5 : 1;
	                    var x_ = quadraticAt(x0, x1, x2, roots[i]);
	                    if (x_ < x) {
	                        continue;
	                    }
	                    if (roots[i] < t) {
	                        w += y_ < y0 ? unit : -unit;
	                    }
	                    else {
	                        w += y2 < y_ ? unit : -unit;
	                    }
	                }
	                return w;
	            }
	            else {
	                var unit = (roots[0] === 0 || roots[0] === 1) ? 0.5 : 1;
	                var x_ = quadraticAt(x0, x1, x2, roots[0]);
	                if (x_ < x) {
	                    return 0;
	                }
	                return y2 < y0 ? unit : -unit;
	            }
	        }
	    }
	    function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
	        y -= cy;
	        if (y > r || y < -r) {
	            return 0;
	        }
	        var tmp = Math.sqrt(r * r - y * y);
	        roots[0] = -tmp;
	        roots[1] = tmp;
	        var dTheta = Math.abs(startAngle - endAngle);
	        if (dTheta < 1e-4) {
	            return 0;
	        }
	        if (dTheta >= PI2$4 - 1e-4) {
	            startAngle = 0;
	            endAngle = PI2$4;
	            var dir = anticlockwise ? 1 : -1;
	            if (x >= roots[0] + cx && x <= roots[1] + cx) {
	                return dir;
	            }
	            else {
	                return 0;
	            }
	        }
	        if (startAngle > endAngle) {
	            var tmp_1 = startAngle;
	            startAngle = endAngle;
	            endAngle = tmp_1;
	        }
	        if (startAngle < 0) {
	            startAngle += PI2$4;
	            endAngle += PI2$4;
	        }
	        var w = 0;
	        for (var i = 0; i < 2; i++) {
	            var x_ = roots[i];
	            if (x_ + cx > x) {
	                var angle = Math.atan2(y, x_);
	                var dir = anticlockwise ? 1 : -1;
	                if (angle < 0) {
	                    angle = PI2$4 + angle;
	                }
	                if ((angle >= startAngle && angle <= endAngle)
	                    || (angle + PI2$4 >= startAngle && angle + PI2$4 <= endAngle)) {
	                    if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
	                        dir = -dir;
	                    }
	                    w += dir;
	                }
	            }
	        }
	        return w;
	    }
	    function containPath(path, lineWidth, isStroke, x, y) {
	        var data = path.data;
	        var len = path.len();
	        var w = 0;
	        var xi = 0;
	        var yi = 0;
	        var x0 = 0;
	        var y0 = 0;
	        var x1;
	        var y1;
	        for (var i = 0; i < len;) {
	            var cmd = data[i++];
	            var isFirst = i === 1;
	            if (cmd === CMD$1.M && i > 1) {
	                if (!isStroke) {
	                    w += windingLine(xi, yi, x0, y0, x, y);
	                }
	            }
	            if (isFirst) {
	                xi = data[i];
	                yi = data[i + 1];
	                x0 = xi;
	                y0 = yi;
	            }
	            switch (cmd) {
	                case CMD$1.M:
	                    x0 = data[i++];
	                    y0 = data[i++];
	                    xi = x0;
	                    yi = y0;
	                    break;
	                case CMD$1.L:
	                    if (isStroke) {
	                        if (containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
	                            return true;
	                        }
	                    }
	                    else {
	                        w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
	                    }
	                    xi = data[i++];
	                    yi = data[i++];
	                    break;
	                case CMD$1.C:
	                    if (isStroke) {
	                        if (containStroke$1(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	                            return true;
	                        }
	                    }
	                    else {
	                        w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	                    }
	                    xi = data[i++];
	                    yi = data[i++];
	                    break;
	                case CMD$1.Q:
	                    if (isStroke) {
	                        if (containStroke$2(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	                            return true;
	                        }
	                    }
	                    else {
	                        w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	                    }
	                    xi = data[i++];
	                    yi = data[i++];
	                    break;
	                case CMD$1.A:
	                    var cx = data[i++];
	                    var cy = data[i++];
	                    var rx = data[i++];
	                    var ry = data[i++];
	                    var theta = data[i++];
	                    var dTheta = data[i++];
	                    i += 1;
	                    var anticlockwise = !!(1 - data[i++]);
	                    x1 = Math.cos(theta) * rx + cx;
	                    y1 = Math.sin(theta) * ry + cy;
	                    if (!isFirst) {
	                        w += windingLine(xi, yi, x1, y1, x, y);
	                    }
	                    else {
	                        x0 = x1;
	                        y0 = y1;
	                    }
	                    var _x = (x - cx) * ry / rx + cx;
	                    if (isStroke) {
	                        if (containStroke$3(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
	                            return true;
	                        }
	                    }
	                    else {
	                        w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
	                    }
	                    xi = Math.cos(theta + dTheta) * rx + cx;
	                    yi = Math.sin(theta + dTheta) * ry + cy;
	                    break;
	                case CMD$1.R:
	                    x0 = xi = data[i++];
	                    y0 = yi = data[i++];
	                    var width = data[i++];
	                    var height = data[i++];
	                    x1 = x0 + width;
	                    y1 = y0 + height;
	                    if (isStroke) {
	                        if (containStroke(x0, y0, x1, y0, lineWidth, x, y)
	                            || containStroke(x1, y0, x1, y1, lineWidth, x, y)
	                            || containStroke(x1, y1, x0, y1, lineWidth, x, y)
	                            || containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
	                            return true;
	                        }
	                    }
	                    else {
	                        w += windingLine(x1, y0, x1, y1, x, y);
	                        w += windingLine(x0, y1, x0, y0, x, y);
	                    }
	                    break;
	                case CMD$1.Z:
	                    if (isStroke) {
	                        if (containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
	                            return true;
	                        }
	                    }
	                    else {
	                        w += windingLine(xi, yi, x0, y0, x, y);
	                    }
	                    xi = x0;
	                    yi = y0;
	                    break;
	            }
	        }
	        if (!isStroke && !isAroundEqual(yi, y0)) {
	            w += windingLine(xi, yi, x0, y0, x, y) || 0;
	        }
	        return w !== 0;
	    }
	    function contain(pathProxy, x, y) {
	        return containPath(pathProxy, 0, false, x, y);
	    }
	    function containStroke$4(pathProxy, lineWidth, x, y) {
	        return containPath(pathProxy, lineWidth, true, x, y);
	    }
	
	    var DEFAULT_PATH_STYLE = defaults({
	        fill: '#000',
	        stroke: null,
	        strokePercent: 1,
	        fillOpacity: 1,
	        strokeOpacity: 1,
	        lineDashOffset: 0,
	        lineWidth: 1,
	        lineCap: 'butt',
	        miterLimit: 10,
	        strokeNoScale: false,
	        strokeFirst: false
	    }, DEFAULT_COMMON_STYLE);
	    var DEFAULT_PATH_ANIMATION_PROPS = {
	        style: defaults({
	            fill: true,
	            stroke: true,
	            strokePercent: true,
	            fillOpacity: true,
	            strokeOpacity: true,
	            lineDashOffset: true,
	            lineWidth: true,
	            miterLimit: true
	        }, DEFAULT_COMMON_ANIMATION_PROPS.style)
	    };
	    var pathCopyParams = TRANSFORMABLE_PROPS.concat(['invisible',
	        'culling', 'z', 'z2', 'zlevel', 'parent'
	    ]);
	    var Path = (function (_super) {
	        __extends(Path, _super);
	        function Path(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Path.prototype.update = function () {
	            var _this = this;
	            _super.prototype.update.call(this);
	            var style = this.style;
	            if (style.decal) {
	                var decalEl = this._decalEl = this._decalEl || new Path();
	                if (decalEl.buildPath === Path.prototype.buildPath) {
	                    decalEl.buildPath = function (ctx) {
	                        _this.buildPath(ctx, _this.shape);
	                    };
	                }
	                decalEl.silent = true;
	                var decalElStyle = decalEl.style;
	                for (var key in style) {
	                    if (decalElStyle[key] !== style[key]) {
	                        decalElStyle[key] = style[key];
	                    }
	                }
	                decalElStyle.fill = style.fill ? style.decal : null;
	                decalElStyle.decal = null;
	                decalElStyle.shadowColor = null;
	                style.strokeFirst && (decalElStyle.stroke = null);
	                for (var i = 0; i < pathCopyParams.length; ++i) {
	                    decalEl[pathCopyParams[i]] = this[pathCopyParams[i]];
	                }
	                decalEl.__dirty |= REDRAW_BIT;
	            }
	            else if (this._decalEl) {
	                this._decalEl = null;
	            }
	        };
	        Path.prototype.getDecalElement = function () {
	            return this._decalEl;
	        };
	        Path.prototype._init = function (props) {
	            var keysArr = keys(props);
	            this.shape = this.getDefaultShape();
	            var defaultStyle = this.getDefaultStyle();
	            if (defaultStyle) {
	                this.useStyle(defaultStyle);
	            }
	            for (var i = 0; i < keysArr.length; i++) {
	                var key = keysArr[i];
	                var value = props[key];
	                if (key === 'style') {
	                    if (!this.style) {
	                        this.useStyle(value);
	                    }
	                    else {
	                        extend(this.style, value);
	                    }
	                }
	                else if (key === 'shape') {
	                    extend(this.shape, value);
	                }
	                else {
	                    _super.prototype.attrKV.call(this, key, value);
	                }
	            }
	            if (!this.style) {
	                this.useStyle({});
	            }
	        };
	        Path.prototype.getDefaultStyle = function () {
	            return null;
	        };
	        Path.prototype.getDefaultShape = function () {
	            return {};
	        };
	        Path.prototype.canBeInsideText = function () {
	            return this.hasFill();
	        };
	        Path.prototype.getInsideTextFill = function () {
	            var pathFill = this.style.fill;
	            if (pathFill !== 'none') {
	                if (isString(pathFill)) {
	                    var fillLum = lum(pathFill, 0);
	                    if (fillLum > 0.5) {
	                        return DARK_LABEL_COLOR;
	                    }
	                    else if (fillLum > 0.2) {
	                        return LIGHTER_LABEL_COLOR;
	                    }
	                    return LIGHT_LABEL_COLOR;
	                }
	                else if (pathFill) {
	                    return LIGHT_LABEL_COLOR;
	                }
	            }
	            return DARK_LABEL_COLOR;
	        };
	        Path.prototype.getInsideTextStroke = function (textFill) {
	            var pathFill = this.style.fill;
	            if (isString(pathFill)) {
	                var zr = this.__zr;
	                var isDarkMode = !!(zr && zr.isDarkMode());
	                var isDarkLabel = lum(textFill, 0) < DARK_MODE_THRESHOLD;
	                if (isDarkMode === isDarkLabel) {
	                    return pathFill;
	                }
	            }
	        };
	        Path.prototype.buildPath = function (ctx, shapeCfg, inBatch) { };
	        Path.prototype.pathUpdated = function () {
	            this.__dirty &= ~SHAPE_CHANGED_BIT;
	        };
	        Path.prototype.getUpdatedPathProxy = function (inBatch) {
	            !this.path && this.createPathProxy();
	            this.path.beginPath();
	            this.buildPath(this.path, this.shape, inBatch);
	            return this.path;
	        };
	        Path.prototype.createPathProxy = function () {
	            this.path = new PathProxy(false);
	        };
	        Path.prototype.hasStroke = function () {
	            var style = this.style;
	            var stroke = style.stroke;
	            return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
	        };
	        Path.prototype.hasFill = function () {
	            var style = this.style;
	            var fill = style.fill;
	            return fill != null && fill !== 'none';
	        };
	        Path.prototype.getBoundingRect = function () {
	            var rect = this._rect;
	            var style = this.style;
	            var needsUpdateRect = !rect;
	            if (needsUpdateRect) {
	                var firstInvoke = false;
	                if (!this.path) {
	                    firstInvoke = true;
	                    this.createPathProxy();
	                }
	                var path = this.path;
	                if (firstInvoke || (this.__dirty & SHAPE_CHANGED_BIT)) {
	                    path.beginPath();
	                    this.buildPath(path, this.shape, false);
	                    this.pathUpdated();
	                }
	                rect = path.getBoundingRect();
	            }
	            this._rect = rect;
	            if (this.hasStroke() && this.path && this.path.len() > 0) {
	                var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
	                if (this.__dirty || needsUpdateRect) {
	                    rectStroke.copy(rect);
	                    var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
	                    var w = style.lineWidth;
	                    if (!this.hasFill()) {
	                        var strokeContainThreshold = this.strokeContainThreshold;
	                        w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
	                    }
	                    if (lineScale > 1e-10) {
	                        rectStroke.width += w / lineScale;
	                        rectStroke.height += w / lineScale;
	                        rectStroke.x -= w / lineScale / 2;
	                        rectStroke.y -= w / lineScale / 2;
	                    }
	                }
	                return rectStroke;
	            }
	            return rect;
	        };
	        Path.prototype.contain = function (x, y) {
	            var localPos = this.transformCoordToLocal(x, y);
	            var rect = this.getBoundingRect();
	            var style = this.style;
	            x = localPos[0];
	            y = localPos[1];
	            if (rect.contain(x, y)) {
	                var pathProxy = this.path;
	                if (this.hasStroke()) {
	                    var lineWidth = style.lineWidth;
	                    var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
	                    if (lineScale > 1e-10) {
	                        if (!this.hasFill()) {
	                            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
	                        }
	                        if (containStroke$4(pathProxy, lineWidth / lineScale, x, y)) {
	                            return true;
	                        }
	                    }
	                }
	                if (this.hasFill()) {
	                    return contain(pathProxy, x, y);
	                }
	            }
	            return false;
	        };
	        Path.prototype.dirtyShape = function () {
	            this.__dirty |= SHAPE_CHANGED_BIT;
	            if (this._rect) {
	                this._rect = null;
	            }
	            if (this._decalEl) {
	                this._decalEl.dirtyShape();
	            }
	            this.markRedraw();
	        };
	        Path.prototype.dirty = function () {
	            this.dirtyStyle();
	            this.dirtyShape();
	        };
	        Path.prototype.animateShape = function (loop) {
	            return this.animate('shape', loop);
	        };
	        Path.prototype.updateDuringAnimation = function (targetKey) {
	            if (targetKey === 'style') {
	                this.dirtyStyle();
	            }
	            else if (targetKey === 'shape') {
	                this.dirtyShape();
	            }
	            else {
	                this.markRedraw();
	            }
	        };
	        Path.prototype.attrKV = function (key, value) {
	            if (key === 'shape') {
	                this.setShape(value);
	            }
	            else {
	                _super.prototype.attrKV.call(this, key, value);
	            }
	        };
	        Path.prototype.setShape = function (keyOrObj, value) {
	            var shape = this.shape;
	            if (!shape) {
	                shape = this.shape = {};
	            }
	            if (typeof keyOrObj === 'string') {
	                shape[keyOrObj] = value;
	            }
	            else {
	                extend(shape, keyOrObj);
	            }
	            this.dirtyShape();
	            return this;
	        };
	        Path.prototype.shapeChanged = function () {
	            return !!(this.__dirty & SHAPE_CHANGED_BIT);
	        };
	        Path.prototype.createStyle = function (obj) {
	            return createObject(DEFAULT_PATH_STYLE, obj);
	        };
	        Path.prototype._innerSaveToNormal = function (toState) {
	            _super.prototype._innerSaveToNormal.call(this, toState);
	            var normalState = this._normalState;
	            if (toState.shape && !normalState.shape) {
	                normalState.shape = extend({}, this.shape);
	            }
	        };
	        Path.prototype._applyStateObj = function (stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
	            _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
	            var needsRestoreToNormal = !(state && keepCurrentStates);
	            var targetShape;
	            if (state && state.shape) {
	                if (transition) {
	                    if (keepCurrentStates) {
	                        targetShape = state.shape;
	                    }
	                    else {
	                        targetShape = extend({}, normalState.shape);
	                        extend(targetShape, state.shape);
	                    }
	                }
	                else {
	                    targetShape = extend({}, keepCurrentStates ? this.shape : normalState.shape);
	                    extend(targetShape, state.shape);
	                }
	            }
	            else if (needsRestoreToNormal) {
	                targetShape = normalState.shape;
	            }
	            if (targetShape) {
	                if (transition) {
	                    this.shape = extend({}, this.shape);
	                    var targetShapePrimaryProps = {};
	                    var shapeKeys = keys(targetShape);
	                    for (var i = 0; i < shapeKeys.length; i++) {
	                        var key = shapeKeys[i];
	                        if (typeof targetShape[key] === 'object') {
	                            this.shape[key] = targetShape[key];
	                        }
	                        else {
	                            targetShapePrimaryProps[key] = targetShape[key];
	                        }
	                    }
	                    this._transitionState(stateName, {
	                        shape: targetShapePrimaryProps
	                    }, animationCfg);
	                }
	                else {
	                    this.shape = targetShape;
	                    this.dirtyShape();
	                }
	            }
	        };
	        Path.prototype._mergeStates = function (states) {
	            var mergedState = _super.prototype._mergeStates.call(this, states);
	            var mergedShape;
	            for (var i = 0; i < states.length; i++) {
	                var state = states[i];
	                if (state.shape) {
	                    mergedShape = mergedShape || {};
	                    this._mergeStyle(mergedShape, state.shape);
	                }
	            }
	            if (mergedShape) {
	                mergedState.shape = mergedShape;
	            }
	            return mergedState;
	        };
	        Path.prototype.getAnimationStyleProps = function () {
	            return DEFAULT_PATH_ANIMATION_PROPS;
	        };
	        Path.prototype.isZeroArea = function () {
	            return false;
	        };
	        Path.extend = function (defaultProps) {
	            var Sub = (function (_super) {
	                __extends(Sub, _super);
	                function Sub(opts) {
	                    var _this = _super.call(this, opts) || this;
	                    defaultProps.init && defaultProps.init.call(_this, opts);
	                    return _this;
	                }
	                Sub.prototype.getDefaultStyle = function () {
	                    return clone(defaultProps.style);
	                };
	                Sub.prototype.getDefaultShape = function () {
	                    return clone(defaultProps.shape);
	                };
	                return Sub;
	            }(Path));
	            for (var key in defaultProps) {
	                if (typeof defaultProps[key] === 'function') {
	                    Sub.prototype[key] = defaultProps[key];
	                }
	            }
	            return Sub;
	        };
	        Path.initDefaultProps = (function () {
	            var pathProto = Path.prototype;
	            pathProto.type = 'path';
	            pathProto.strokeContainThreshold = 5;
	            pathProto.segmentIgnoreThreshold = 0;
	            pathProto.subPixelOptimize = false;
	            pathProto.autoBatch = false;
	            pathProto.__dirty = REDRAW_BIT | STYLE_CHANGED_BIT | SHAPE_CHANGED_BIT;
	        })();
	        return Path;
	    }(Displayable));
	
	    var DEFAULT_TSPAN_STYLE = defaults({
	        strokeFirst: true,
	        font: DEFAULT_FONT,
	        x: 0,
	        y: 0,
	        textAlign: 'left',
	        textBaseline: 'top',
	        miterLimit: 2
	    }, DEFAULT_PATH_STYLE);
	    var TSpan = (function (_super) {
	        __extends(TSpan, _super);
	        function TSpan() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        TSpan.prototype.hasStroke = function () {
	            var style = this.style;
	            var stroke = style.stroke;
	            return stroke != null && stroke !== 'none' && style.lineWidth > 0;
	        };
	        TSpan.prototype.hasFill = function () {
	            var style = this.style;
	            var fill = style.fill;
	            return fill != null && fill !== 'none';
	        };
	        TSpan.prototype.createStyle = function (obj) {
	            return createObject(DEFAULT_TSPAN_STYLE, obj);
	        };
	        TSpan.prototype.setBoundingRect = function (rect) {
	            this._rect = rect;
	        };
	        TSpan.prototype.getBoundingRect = function () {
	            var style = this.style;
	            if (!this._rect) {
	                var text = style.text;
	                text != null ? (text += '') : (text = '');
	                var rect = getBoundingRect(text, style.font, style.textAlign, style.textBaseline);
	                rect.x += style.x || 0;
	                rect.y += style.y || 0;
	                if (this.hasStroke()) {
	                    var w = style.lineWidth;
	                    rect.x -= w / 2;
	                    rect.y -= w / 2;
	                    rect.width += w;
	                    rect.height += w;
	                }
	                this._rect = rect;
	            }
	            return this._rect;
	        };
	        TSpan.initDefaultProps = (function () {
	            var tspanProto = TSpan.prototype;
	            tspanProto.dirtyRectTolerance = 10;
	        })();
	        return TSpan;
	    }(Displayable));
	    TSpan.prototype.type = 'tspan';
	
	    var DEFAULT_IMAGE_STYLE = defaults({
	        x: 0,
	        y: 0
	    }, DEFAULT_COMMON_STYLE);
	    var DEFAULT_IMAGE_ANIMATION_PROPS = {
	        style: defaults({
	            x: true,
	            y: true,
	            width: true,
	            height: true,
	            sx: true,
	            sy: true,
	            sWidth: true,
	            sHeight: true
	        }, DEFAULT_COMMON_ANIMATION_PROPS.style)
	    };
	    function isImageLike(source) {
	        return !!(source
	            && typeof source !== 'string'
	            && source.width && source.height);
	    }
	    var ZRImage = (function (_super) {
	        __extends(ZRImage, _super);
	        function ZRImage() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        ZRImage.prototype.createStyle = function (obj) {
	            return createObject(DEFAULT_IMAGE_STYLE, obj);
	        };
	        ZRImage.prototype._getSize = function (dim) {
	            var style = this.style;
	            var size = style[dim];
	            if (size != null) {
	                return size;
	            }
	            var imageSource = isImageLike(style.image)
	                ? style.image : this.__image;
	            if (!imageSource) {
	                return 0;
	            }
	            var otherDim = dim === 'width' ? 'height' : 'width';
	            var otherDimSize = style[otherDim];
	            if (otherDimSize == null) {
	                return imageSource[dim];
	            }
	            else {
	                return imageSource[dim] / imageSource[otherDim] * otherDimSize;
	            }
	        };
	        ZRImage.prototype.getWidth = function () {
	            return this._getSize('width');
	        };
	        ZRImage.prototype.getHeight = function () {
	            return this._getSize('height');
	        };
	        ZRImage.prototype.getAnimationStyleProps = function () {
	            return DEFAULT_IMAGE_ANIMATION_PROPS;
	        };
	        ZRImage.prototype.getBoundingRect = function () {
	            var style = this.style;
	            if (!this._rect) {
	                this._rect = new BoundingRect(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
	            }
	            return this._rect;
	        };
	        return ZRImage;
	    }(Displayable));
	    ZRImage.prototype.type = 'image';
	
	    function buildPath(ctx, shape) {
	        var x = shape.x;
	        var y = shape.y;
	        var width = shape.width;
	        var height = shape.height;
	        var r = shape.r;
	        var r1;
	        var r2;
	        var r3;
	        var r4;
	        if (width < 0) {
	            x = x + width;
	            width = -width;
	        }
	        if (height < 0) {
	            y = y + height;
	            height = -height;
	        }
	        if (typeof r === 'number') {
	            r1 = r2 = r3 = r4 = r;
	        }
	        else if (r instanceof Array) {
	            if (r.length === 1) {
	                r1 = r2 = r3 = r4 = r[0];
	            }
	            else if (r.length === 2) {
	                r1 = r3 = r[0];
	                r2 = r4 = r[1];
	            }
	            else if (r.length === 3) {
	                r1 = r[0];
	                r2 = r4 = r[1];
	                r3 = r[2];
	            }
	            else {
	                r1 = r[0];
	                r2 = r[1];
	                r3 = r[2];
	                r4 = r[3];
	            }
	        }
	        else {
	            r1 = r2 = r3 = r4 = 0;
	        }
	        var total;
	        if (r1 + r2 > width) {
	            total = r1 + r2;
	            r1 *= width / total;
	            r2 *= width / total;
	        }
	        if (r3 + r4 > width) {
	            total = r3 + r4;
	            r3 *= width / total;
	            r4 *= width / total;
	        }
	        if (r2 + r3 > height) {
	            total = r2 + r3;
	            r2 *= height / total;
	            r3 *= height / total;
	        }
	        if (r1 + r4 > height) {
	            total = r1 + r4;
	            r1 *= height / total;
	            r4 *= height / total;
	        }
	        ctx.moveTo(x + r1, y);
	        ctx.lineTo(x + width - r2, y);
	        r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
	        ctx.lineTo(x + width, y + height - r3);
	        r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
	        ctx.lineTo(x + r4, y + height);
	        r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
	        ctx.lineTo(x, y + r1);
	        r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
	    }
	
	    var round$1 = Math.round;
	    function subPixelOptimizeLine(outputShape, inputShape, style) {
	        if (!inputShape) {
	            return;
	        }
	        var x1 = inputShape.x1;
	        var x2 = inputShape.x2;
	        var y1 = inputShape.y1;
	        var y2 = inputShape.y2;
	        outputShape.x1 = x1;
	        outputShape.x2 = x2;
	        outputShape.y1 = y1;
	        outputShape.y2 = y2;
	        var lineWidth = style && style.lineWidth;
	        if (!lineWidth) {
	            return outputShape;
	        }
	        if (round$1(x1 * 2) === round$1(x2 * 2)) {
	            outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
	        }
	        if (round$1(y1 * 2) === round$1(y2 * 2)) {
	            outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
	        }
	        return outputShape;
	    }
	    function subPixelOptimizeRect(outputShape, inputShape, style) {
	        if (!inputShape) {
	            return;
	        }
	        var originX = inputShape.x;
	        var originY = inputShape.y;
	        var originWidth = inputShape.width;
	        var originHeight = inputShape.height;
	        outputShape.x = originX;
	        outputShape.y = originY;
	        outputShape.width = originWidth;
	        outputShape.height = originHeight;
	        var lineWidth = style && style.lineWidth;
	        if (!lineWidth) {
	            return outputShape;
	        }
	        outputShape.x = subPixelOptimize(originX, lineWidth, true);
	        outputShape.y = subPixelOptimize(originY, lineWidth, true);
	        outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
	        outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
	        return outputShape;
	    }
	    function subPixelOptimize(position, lineWidth, positiveOrNegative) {
	        if (!lineWidth) {
	            return position;
	        }
	        var doubledPosition = round$1(position * 2);
	        return (doubledPosition + round$1(lineWidth)) % 2 === 0
	            ? doubledPosition / 2
	            : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
	    }
	
	    var RectShape = (function () {
	        function RectShape() {
	            this.x = 0;
	            this.y = 0;
	            this.width = 0;
	            this.height = 0;
	        }
	        return RectShape;
	    }());
	    var subPixelOptimizeOutputShape = {};
	    var Rect = (function (_super) {
	        __extends(Rect, _super);
	        function Rect(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Rect.prototype.getDefaultShape = function () {
	            return new RectShape();
	        };
	        Rect.prototype.buildPath = function (ctx, shape) {
	            var x;
	            var y;
	            var width;
	            var height;
	            if (this.subPixelOptimize) {
	                var optimizedShape = subPixelOptimizeRect(subPixelOptimizeOutputShape, shape, this.style);
	                x = optimizedShape.x;
	                y = optimizedShape.y;
	                width = optimizedShape.width;
	                height = optimizedShape.height;
	                optimizedShape.r = shape.r;
	                shape = optimizedShape;
	            }
	            else {
	                x = shape.x;
	                y = shape.y;
	                width = shape.width;
	                height = shape.height;
	            }
	            if (!shape.r) {
	                ctx.rect(x, y, width, height);
	            }
	            else {
	                buildPath(ctx, shape);
	            }
	        };
	        Rect.prototype.isZeroArea = function () {
	            return !this.shape.width || !this.shape.height;
	        };
	        return Rect;
	    }(Path));
	    Rect.prototype.type = 'rect';
	
	    var DEFAULT_RICH_TEXT_COLOR = {
	        fill: '#000'
	    };
	    var DEFAULT_STROKE_LINE_WIDTH = 2;
	    var DEFAULT_TEXT_ANIMATION_PROPS = {
	        style: defaults({
	            fill: true,
	            stroke: true,
	            fillOpacity: true,
	            strokeOpacity: true,
	            lineWidth: true,
	            fontSize: true,
	            lineHeight: true,
	            width: true,
	            height: true,
	            textShadowColor: true,
	            textShadowBlur: true,
	            textShadowOffsetX: true,
	            textShadowOffsetY: true,
	            backgroundColor: true,
	            padding: true,
	            borderColor: true,
	            borderWidth: true,
	            borderRadius: true
	        }, DEFAULT_COMMON_ANIMATION_PROPS.style)
	    };
	    var ZRText = (function (_super) {
	        __extends(ZRText, _super);
	        function ZRText(opts) {
	            var _this = _super.call(this) || this;
	            _this.type = 'text';
	            _this._children = [];
	            _this._defaultStyle = DEFAULT_RICH_TEXT_COLOR;
	            _this.attr(opts);
	            return _this;
	        }
	        ZRText.prototype.childrenRef = function () {
	            return this._children;
	        };
	        ZRText.prototype.update = function () {
	            _super.prototype.update.call(this);
	            if (this.styleChanged()) {
	                this._updateSubTexts();
	            }
	            for (var i = 0; i < this._children.length; i++) {
	                var child = this._children[i];
	                child.zlevel = this.zlevel;
	                child.z = this.z;
	                child.z2 = this.z2;
	                child.culling = this.culling;
	                child.cursor = this.cursor;
	                child.invisible = this.invisible;
	            }
	        };
	        ZRText.prototype.updateTransform = function () {
	            var innerTransformable = this.innerTransformable;
	            if (innerTransformable) {
	                innerTransformable.updateTransform();
	                if (innerTransformable.transform) {
	                    this.transform = innerTransformable.transform;
	                }
	            }
	            else {
	                _super.prototype.updateTransform.call(this);
	            }
	        };
	        ZRText.prototype.getLocalTransform = function (m) {
	            var innerTransformable = this.innerTransformable;
	            return innerTransformable
	                ? innerTransformable.getLocalTransform(m)
	                : _super.prototype.getLocalTransform.call(this, m);
	        };
	        ZRText.prototype.getComputedTransform = function () {
	            if (this.__hostTarget) {
	                this.__hostTarget.getComputedTransform();
	                this.__hostTarget.updateInnerText(true);
	            }
	            return _super.prototype.getComputedTransform.call(this);
	        };
	        ZRText.prototype._updateSubTexts = function () {
	            this._childCursor = 0;
	            normalizeTextStyle(this.style);
	            this.style.rich
	                ? this._updateRichTexts()
	                : this._updatePlainTexts();
	            this._children.length = this._childCursor;
	            this.styleUpdated();
	        };
	        ZRText.prototype.addSelfToZr = function (zr) {
	            _super.prototype.addSelfToZr.call(this, zr);
	            for (var i = 0; i < this._children.length; i++) {
	                this._children[i].__zr = zr;
	            }
	        };
	        ZRText.prototype.removeSelfFromZr = function (zr) {
	            _super.prototype.removeSelfFromZr.call(this, zr);
	            for (var i = 0; i < this._children.length; i++) {
	                this._children[i].__zr = null;
	            }
	        };
	        ZRText.prototype.getBoundingRect = function () {
	            if (this.styleChanged()) {
	                this._updateSubTexts();
	            }
	            if (!this._rect) {
	                var tmpRect = new BoundingRect(0, 0, 0, 0);
	                var children = this._children;
	                var tmpMat = [];
	                var rect = null;
	                for (var i = 0; i < children.length; i++) {
	                    var child = children[i];
	                    var childRect = child.getBoundingRect();
	                    var transform = child.getLocalTransform(tmpMat);
	                    if (transform) {
	                        tmpRect.copy(childRect);
	                        tmpRect.applyTransform(transform);
	                        rect = rect || tmpRect.clone();
	                        rect.union(tmpRect);
	                    }
	                    else {
	                        rect = rect || childRect.clone();
	                        rect.union(childRect);
	                    }
	                }
	                this._rect = rect || tmpRect;
	            }
	            return this._rect;
	        };
	        ZRText.prototype.setDefaultTextStyle = function (defaultTextStyle) {
	            this._defaultStyle = defaultTextStyle || DEFAULT_RICH_TEXT_COLOR;
	        };
	        ZRText.prototype.setTextContent = function (textContent) {
	            if (true) {
	                throw new Error('Can\'t attach text on another text');
	            }
	        };
	        ZRText.prototype._mergeStyle = function (targetStyle, sourceStyle) {
	            if (!sourceStyle) {
	                return targetStyle;
	            }
	            var sourceRich = sourceStyle.rich;
	            var targetRich = targetStyle.rich || (sourceRich && {});
	            extend(targetStyle, sourceStyle);
	            if (sourceRich && targetRich) {
	                this._mergeRich(targetRich, sourceRich);
	                targetStyle.rich = targetRich;
	            }
	            else if (targetRich) {
	                targetStyle.rich = targetRich;
	            }
	            return targetStyle;
	        };
	        ZRText.prototype._mergeRich = function (targetRich, sourceRich) {
	            var richNames = keys(sourceRich);
	            for (var i = 0; i < richNames.length; i++) {
	                var richName = richNames[i];
	                targetRich[richName] = targetRich[richName] || {};
	                extend(targetRich[richName], sourceRich[richName]);
	            }
	        };
	        ZRText.prototype.getAnimationStyleProps = function () {
	            return DEFAULT_TEXT_ANIMATION_PROPS;
	        };
	        ZRText.prototype._getOrCreateChild = function (Ctor) {
	            var child = this._children[this._childCursor];
	            if (!child || !(child instanceof Ctor)) {
	                child = new Ctor();
	            }
	            this._children[this._childCursor++] = child;
	            child.__zr = this.__zr;
	            child.parent = this;
	            return child;
	        };
	        ZRText.prototype._updatePlainTexts = function () {
	            var style = this.style;
	            var textFont = style.font || DEFAULT_FONT;
	            var textPadding = style.padding;
	            var text = getStyleText(style);
	            var contentBlock = parsePlainText(text, style);
	            var needDrawBg = needDrawBackground(style);
	            var bgColorDrawn = !!(style.backgroundColor);
	            var outerHeight = contentBlock.outerHeight;
	            var outerWidth = contentBlock.outerWidth;
	            var contentWidth = contentBlock.contentWidth;
	            var textLines = contentBlock.lines;
	            var lineHeight = contentBlock.lineHeight;
	            var defaultStyle = this._defaultStyle;
	            var baseX = style.x || 0;
	            var baseY = style.y || 0;
	            var textAlign = style.align || defaultStyle.align || 'left';
	            var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
	            var textX = baseX;
	            var textY = adjustTextY$1(baseY, contentBlock.contentHeight, verticalAlign);
	            if (needDrawBg || textPadding) {
	                var boxX = adjustTextX(baseX, outerWidth, textAlign);
	                var boxY = adjustTextY$1(baseY, outerHeight, verticalAlign);
	                needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
	            }
	            textY += lineHeight / 2;
	            if (textPadding) {
	                textX = getTextXForPadding(baseX, textAlign, textPadding);
	                if (verticalAlign === 'top') {
	                    textY += textPadding[0];
	                }
	                else if (verticalAlign === 'bottom') {
	                    textY -= textPadding[2];
	                }
	            }
	            var defaultLineWidth = 0;
	            var useDefaultFill = false;
	            var textFill = getFill('fill' in style
	                ? style.fill
	                : (useDefaultFill = true, defaultStyle.fill));
	            var textStroke = getStroke('stroke' in style
	                ? style.stroke
	                : (!bgColorDrawn
	                    && (!defaultStyle.autoStroke || useDefaultFill))
	                    ? (defaultLineWidth = DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke)
	                    : null);
	            var hasShadow = style.textShadowBlur > 0;
	            var fixedBoundingRect = style.width != null
	                && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
	            var calculatedLineHeight = contentBlock.calculatedLineHeight;
	            for (var i = 0; i < textLines.length; i++) {
	                var el = this._getOrCreateChild(TSpan);
	                var subElStyle = el.createStyle();
	                el.useStyle(subElStyle);
	                subElStyle.text = textLines[i];
	                subElStyle.x = textX;
	                subElStyle.y = textY;
	                if (textAlign) {
	                    subElStyle.textAlign = textAlign;
	                }
	                subElStyle.textBaseline = 'middle';
	                subElStyle.opacity = style.opacity;
	                subElStyle.strokeFirst = true;
	                if (hasShadow) {
	                    subElStyle.shadowBlur = style.textShadowBlur || 0;
	                    subElStyle.shadowColor = style.textShadowColor || 'transparent';
	                    subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
	                    subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
	                }
	                subElStyle.stroke = textStroke;
	                subElStyle.fill = textFill;
	                if (textStroke) {
	                    subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
	                    subElStyle.lineDash = style.lineDash;
	                    subElStyle.lineDashOffset = style.lineDashOffset || 0;
	                }
	                subElStyle.font = textFont;
	                setSeparateFont(subElStyle, style);
	                textY += lineHeight;
	                if (fixedBoundingRect) {
	                    el.setBoundingRect(new BoundingRect(adjustTextX(subElStyle.x, style.width, subElStyle.textAlign), adjustTextY$1(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), contentWidth, calculatedLineHeight));
	                }
	            }
	        };
	        ZRText.prototype._updateRichTexts = function () {
	            var style = this.style;
	            var text = getStyleText(style);
	            var contentBlock = parseRichText(text, style);
	            var contentWidth = contentBlock.width;
	            var outerWidth = contentBlock.outerWidth;
	            var outerHeight = contentBlock.outerHeight;
	            var textPadding = style.padding;
	            var baseX = style.x || 0;
	            var baseY = style.y || 0;
	            var defaultStyle = this._defaultStyle;
	            var textAlign = style.align || defaultStyle.align;
	            var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
	            var boxX = adjustTextX(baseX, outerWidth, textAlign);
	            var boxY = adjustTextY$1(baseY, outerHeight, verticalAlign);
	            var xLeft = boxX;
	            var lineTop = boxY;
	            if (textPadding) {
	                xLeft += textPadding[3];
	                lineTop += textPadding[0];
	            }
	            var xRight = xLeft + contentWidth;
	            if (needDrawBackground(style)) {
	                this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
	            }
	            var bgColorDrawn = !!(style.backgroundColor);
	            for (var i = 0; i < contentBlock.lines.length; i++) {
	                var line = contentBlock.lines[i];
	                var tokens = line.tokens;
	                var tokenCount = tokens.length;
	                var lineHeight = line.lineHeight;
	                var remainedWidth = line.width;
	                var leftIndex = 0;
	                var lineXLeft = xLeft;
	                var lineXRight = xRight;
	                var rightIndex = tokenCount - 1;
	                var token = void 0;
	                while (leftIndex < tokenCount
	                    && (token = tokens[leftIndex], !token.align || token.align === 'left')) {
	                    this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
	                    remainedWidth -= token.width;
	                    lineXLeft += token.width;
	                    leftIndex++;
	                }
	                while (rightIndex >= 0
	                    && (token = tokens[rightIndex], token.align === 'right')) {
	                    this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
	                    remainedWidth -= token.width;
	                    lineXRight -= token.width;
	                    rightIndex--;
	                }
	                lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
	                while (leftIndex <= rightIndex) {
	                    token = tokens[leftIndex];
	                    this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
	                    lineXLeft += token.width;
	                    leftIndex++;
	                }
	                lineTop += lineHeight;
	            }
	        };
	        ZRText.prototype._placeToken = function (token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
	            var tokenStyle = style.rich[token.styleName] || {};
	            tokenStyle.text = token.text;
	            var verticalAlign = token.verticalAlign;
	            var y = lineTop + lineHeight / 2;
	            if (verticalAlign === 'top') {
	                y = lineTop + token.height / 2;
	            }
	            else if (verticalAlign === 'bottom') {
	                y = lineTop + lineHeight - token.height / 2;
	            }
	            var needDrawBg = !token.isLineHolder && needDrawBackground(tokenStyle);
	            needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right'
	                ? x - token.width
	                : textAlign === 'center'
	                    ? x - token.width / 2
	                    : x, y - token.height / 2, token.width, token.height);
	            var bgColorDrawn = !!tokenStyle.backgroundColor;
	            var textPadding = token.textPadding;
	            if (textPadding) {
	                x = getTextXForPadding(x, textAlign, textPadding);
	                y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
	            }
	            var el = this._getOrCreateChild(TSpan);
	            var subElStyle = el.createStyle();
	            el.useStyle(subElStyle);
	            var defaultStyle = this._defaultStyle;
	            var useDefaultFill = false;
	            var defaultLineWidth = 0;
	            var textFill = getFill('fill' in tokenStyle ? tokenStyle.fill
	                : 'fill' in style ? style.fill
	                    : (useDefaultFill = true, defaultStyle.fill));
	            var textStroke = getStroke('stroke' in tokenStyle ? tokenStyle.stroke
	                : 'stroke' in style ? style.stroke
	                    : (!bgColorDrawn
	                        && !parentBgColorDrawn
	                        && (!defaultStyle.autoStroke || useDefaultFill)) ? (defaultLineWidth = DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke)
	                        : null);
	            var hasShadow = tokenStyle.textShadowBlur > 0
	                || style.textShadowBlur > 0;
	            subElStyle.text = token.text;
	            subElStyle.x = x;
	            subElStyle.y = y;
	            if (hasShadow) {
	                subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
	                subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
	                subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
	                subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
	            }
	            subElStyle.textAlign = textAlign;
	            subElStyle.textBaseline = 'middle';
	            subElStyle.font = token.font || DEFAULT_FONT;
	            subElStyle.opacity = retrieve3(tokenStyle.opacity, style.opacity, 1);
	            setSeparateFont(subElStyle, tokenStyle);
	            if (textStroke) {
	                subElStyle.lineWidth = retrieve3(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
	                subElStyle.lineDash = retrieve2(tokenStyle.lineDash, style.lineDash);
	                subElStyle.lineDashOffset = style.lineDashOffset || 0;
	                subElStyle.stroke = textStroke;
	            }
	            if (textFill) {
	                subElStyle.fill = textFill;
	            }
	            var textWidth = token.contentWidth;
	            var textHeight = token.contentHeight;
	            el.setBoundingRect(new BoundingRect(adjustTextX(subElStyle.x, textWidth, subElStyle.textAlign), adjustTextY$1(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
	        };
	        ZRText.prototype._renderBackground = function (style, topStyle, x, y, width, height) {
	            var textBackgroundColor = style.backgroundColor;
	            var textBorderWidth = style.borderWidth;
	            var textBorderColor = style.borderColor;
	            var isImageBg = textBackgroundColor && textBackgroundColor.image;
	            var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
	            var textBorderRadius = style.borderRadius;
	            var self = this;
	            var rectEl;
	            var imgEl;
	            if (isPlainOrGradientBg || style.lineHeight || (textBorderWidth && textBorderColor)) {
	                rectEl = this._getOrCreateChild(Rect);
	                rectEl.useStyle(rectEl.createStyle());
	                rectEl.style.fill = null;
	                var rectShape = rectEl.shape;
	                rectShape.x = x;
	                rectShape.y = y;
	                rectShape.width = width;
	                rectShape.height = height;
	                rectShape.r = textBorderRadius;
	                rectEl.dirtyShape();
	            }
	            if (isPlainOrGradientBg) {
	                var rectStyle = rectEl.style;
	                rectStyle.fill = textBackgroundColor || null;
	                rectStyle.fillOpacity = retrieve2(style.fillOpacity, 1);
	            }
	            else if (isImageBg) {
	                imgEl = this._getOrCreateChild(ZRImage);
	                imgEl.onload = function () {
	                    self.dirtyStyle();
	                };
	                var imgStyle = imgEl.style;
	                imgStyle.image = textBackgroundColor.image;
	                imgStyle.x = x;
	                imgStyle.y = y;
	                imgStyle.width = width;
	                imgStyle.height = height;
	            }
	            if (textBorderWidth && textBorderColor) {
	                var rectStyle = rectEl.style;
	                rectStyle.lineWidth = textBorderWidth;
	                rectStyle.stroke = textBorderColor;
	                rectStyle.strokeOpacity = retrieve2(style.strokeOpacity, 1);
	                rectStyle.lineDash = style.borderDash;
	                rectStyle.lineDashOffset = style.borderDashOffset || 0;
	                rectEl.strokeContainThreshold = 0;
	                if (rectEl.hasFill() && rectEl.hasStroke()) {
	                    rectStyle.strokeFirst = true;
	                    rectStyle.lineWidth *= 2;
	                }
	            }
	            var commonStyle = (rectEl || imgEl).style;
	            commonStyle.shadowBlur = style.shadowBlur || 0;
	            commonStyle.shadowColor = style.shadowColor || 'transparent';
	            commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
	            commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
	            commonStyle.opacity = retrieve3(style.opacity, topStyle.opacity, 1);
	        };
	        ZRText.makeFont = function (style) {
	            var font = '';
	            if (hasSeparateFont(style)) {
	                font = [
	                    style.fontStyle,
	                    style.fontWeight,
	                    parseFontSize(style.fontSize),
	                    style.fontFamily || 'sans-serif'
	                ].join(' ');
	            }
	            return font && trim(font) || style.textFont || style.font;
	        };
	        return ZRText;
	    }(Displayable));
	    var VALID_TEXT_ALIGN = { left: true, right: 1, center: 1 };
	    var VALID_TEXT_VERTICAL_ALIGN = { top: 1, bottom: 1, middle: 1 };
	    var FONT_PARTS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily'];
	    function parseFontSize(fontSize) {
	        if (typeof fontSize === 'string'
	            && (fontSize.indexOf('px') !== -1
	                || fontSize.indexOf('rem') !== -1
	                || fontSize.indexOf('em') !== -1)) {
	            return fontSize;
	        }
	        else if (!isNaN(+fontSize)) {
	            return fontSize + 'px';
	        }
	        else {
	            return DEFAULT_FONT_SIZE + 'px';
	        }
	    }
	    function setSeparateFont(targetStyle, sourceStyle) {
	        for (var i = 0; i < FONT_PARTS.length; i++) {
	            var fontProp = FONT_PARTS[i];
	            var val = sourceStyle[fontProp];
	            if (val != null) {
	                targetStyle[fontProp] = val;
	            }
	        }
	    }
	    function hasSeparateFont(style) {
	        return style.fontSize != null || style.fontFamily || style.fontWeight;
	    }
	    function normalizeTextStyle(style) {
	        normalizeStyle(style);
	        each(style.rich, normalizeStyle);
	        return style;
	    }
	    function normalizeStyle(style) {
	        if (style) {
	            style.font = ZRText.makeFont(style);
	            var textAlign = style.align;
	            textAlign === 'middle' && (textAlign = 'center');
	            style.align = (textAlign == null || VALID_TEXT_ALIGN[textAlign]) ? textAlign : 'left';
	            var verticalAlign = style.verticalAlign;
	            verticalAlign === 'center' && (verticalAlign = 'middle');
	            style.verticalAlign = (verticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[verticalAlign]) ? verticalAlign : 'top';
	            var textPadding = style.padding;
	            if (textPadding) {
	                style.padding = normalizeCssArray(style.padding);
	            }
	        }
	    }
	    function getStroke(stroke, lineWidth) {
	        return (stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none')
	            ? null
	            : (stroke.image || stroke.colorStops)
	                ? '#000'
	                : stroke;
	    }
	    function getFill(fill) {
	        return (fill == null || fill === 'none')
	            ? null
	            : (fill.image || fill.colorStops)
	                ? '#000'
	                : fill;
	    }
	    function getTextXForPadding(x, textAlign, textPadding) {
	        return textAlign === 'right'
	            ? (x - textPadding[1])
	            : textAlign === 'center'
	                ? (x + textPadding[3] / 2 - textPadding[1] / 2)
	                : (x + textPadding[3]);
	    }
	    function getStyleText(style) {
	        var text = style.text;
	        text != null && (text += '');
	        return text;
	    }
	    function needDrawBackground(style) {
	        return !!(style.backgroundColor
	            || style.lineHeight
	            || (style.borderWidth && style.borderColor));
	    }
	
	    var getECData = makeInner();
	    var setCommonECData = function (seriesIndex, dataType, dataIdx, el) {
	      if (el) {
	        var ecData = getECData(el); // Add data index and series index for indexing the data by element
	        // Useful in tooltip
	
	        ecData.dataIndex = dataIdx;
	        ecData.dataType = dataType;
	        ecData.seriesIndex = seriesIndex; // TODO: not store dataIndex on children.
	
	        if (el.type === 'group') {
	          el.traverse(function (child) {
	            var childECData = getECData(child);
	            childECData.seriesIndex = seriesIndex;
	            childECData.dataIndex = dataIdx;
	            childECData.dataType = dataType;
	          });
	        }
	      }
	    };
	
	    var _highlightNextDigit = 1;
	    var _highlightKeyMap = {};
	    var getSavedStates = makeInner();
	    var getComponentStates = makeInner();
	    var HOVER_STATE_NORMAL = 0;
	    var HOVER_STATE_BLUR = 1;
	    var HOVER_STATE_EMPHASIS = 2;
	    var SPECIAL_STATES = ['emphasis', 'blur', 'select'];
	    var DISPLAY_STATES = ['normal', 'emphasis', 'blur', 'select'];
	    var Z2_EMPHASIS_LIFT = 10;
	    var Z2_SELECT_LIFT = 9;
	    var HIGHLIGHT_ACTION_TYPE = 'highlight';
	    var DOWNPLAY_ACTION_TYPE = 'downplay';
	    var SELECT_ACTION_TYPE = 'select';
	    var UNSELECT_ACTION_TYPE = 'unselect';
	    var TOGGLE_SELECT_ACTION_TYPE = 'toggleSelect';
	
	    function hasFillOrStroke(fillOrStroke) {
	      return fillOrStroke != null && fillOrStroke !== 'none';
	    } // Most lifted color are duplicated.
	
	
	    var liftedColorCache = new LRU(100);
	
	    function liftColor(color$1) {
	      if (isString(color$1)) {
	        var liftedColor = liftedColorCache.get(color$1);
	
	        if (!liftedColor) {
	          liftedColor = lift(color$1, -0.1);
	          liftedColorCache.put(color$1, liftedColor);
	        }
	
	        return liftedColor;
	      } else if (isGradientObject(color$1)) {
	        var ret = extend({}, color$1);
	        ret.colorStops = map(color$1.colorStops, function (stop) {
	          return {
	            offset: stop.offset,
	            color: lift(stop.color, -0.1)
	          };
	        });
	        return ret;
	      } // Change nothing.
	
	
	      return color$1;
	    }
	
	    function doChangeHoverState(el, stateName, hoverStateEnum) {
	      if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) {
	        el.onHoverStateChange(stateName);
	      }
	
	      el.hoverState = hoverStateEnum;
	    }
	
	    function singleEnterEmphasis(el) {
	      // Only mark the flag.
	      // States will be applied in the echarts.ts in next frame.
	      doChangeHoverState(el, 'emphasis', HOVER_STATE_EMPHASIS);
	    }
	
	    function singleLeaveEmphasis(el) {
	      // Only mark the flag.
	      // States will be applied in the echarts.ts in next frame.
	      if (el.hoverState === HOVER_STATE_EMPHASIS) {
	        doChangeHoverState(el, 'normal', HOVER_STATE_NORMAL);
	      }
	    }
	
	    function singleEnterBlur(el) {
	      doChangeHoverState(el, 'blur', HOVER_STATE_BLUR);
	    }
	
	    function singleLeaveBlur(el) {
	      if (el.hoverState === HOVER_STATE_BLUR) {
	        doChangeHoverState(el, 'normal', HOVER_STATE_NORMAL);
	      }
	    }
	
	    function singleEnterSelect(el) {
	      el.selected = true;
	    }
	
	    function singleLeaveSelect(el) {
	      el.selected = false;
	    }
	
	    function updateElementState(el, updater, commonParam) {
	      updater(el, commonParam);
	    }
	
	    function traverseUpdateState(el, updater, commonParam) {
	      updateElementState(el, updater, commonParam);
	      el.isGroup && el.traverse(function (child) {
	        updateElementState(child, updater, commonParam);
	      });
	    }
	
	    function setStatesFlag(el, stateName) {
	      switch (stateName) {
	        case 'emphasis':
	          el.hoverState = HOVER_STATE_EMPHASIS;
	          break;
	
	        case 'normal':
	          el.hoverState = HOVER_STATE_NORMAL;
	          break;
	
	        case 'blur':
	          el.hoverState = HOVER_STATE_BLUR;
	          break;
	
	        case 'select':
	          el.selected = true;
	      }
	    }
	
	    function getFromStateStyle(el, props, toStateName, defaultValue) {
	      var style = el.style;
	      var fromState = {};
	
	      for (var i = 0; i < props.length; i++) {
	        var propName = props[i];
	        var val = style[propName];
	        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
	      }
	
	      for (var i = 0; i < el.animators.length; i++) {
	        var animator = el.animators[i];
	
	        if (animator.__fromStateTransition // Don't consider the animation to emphasis state.
	        && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') {
	          animator.saveTo(fromState, props);
	        }
	      }
	
	      return fromState;
	    }
	
	    function createEmphasisDefaultState(el, stateName, targetStates, state) {
	      var hasSelect = targetStates && indexOf(targetStates, 'select') >= 0;
	      var cloned = false;
	
	      if (el instanceof Path) {
	        var store = getSavedStates(el);
	        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
	        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
	
	        if (hasFillOrStroke(fromFill) || hasFillOrStroke(fromStroke)) {
	          state = state || {};
	          var emphasisStyle = state.style || {}; // inherit case
	
	          if (emphasisStyle.fill === 'inherit') {
	            cloned = true;
	            state = extend({}, state);
	            emphasisStyle = extend({}, emphasisStyle);
	            emphasisStyle.fill = fromFill;
	          } // Apply default color lift
	          else if (!hasFillOrStroke(emphasisStyle.fill) && hasFillOrStroke(fromFill)) {
	              cloned = true; // Not modify the original value.
	
	              state = extend({}, state);
	              emphasisStyle = extend({}, emphasisStyle); // Already being applied 'emphasis'. DON'T lift color multiple times.
	
	              emphasisStyle.fill = liftColor(fromFill);
	            } // Not highlight stroke if fill has been highlighted.
	            else if (!hasFillOrStroke(emphasisStyle.stroke) && hasFillOrStroke(fromStroke)) {
	                if (!cloned) {
	                  state = extend({}, state);
	                  emphasisStyle = extend({}, emphasisStyle);
	                }
	
	                emphasisStyle.stroke = liftColor(fromStroke);
	              }
	
	          state.style = emphasisStyle;
	        }
	      }
	
	      if (state) {
	        // TODO Share with textContent?
	        if (state.z2 == null) {
	          if (!cloned) {
	            state = extend({}, state);
	          }
	
	          var z2EmphasisLift = el.z2EmphasisLift;
	          state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : Z2_EMPHASIS_LIFT);
	        }
	      }
	
	      return state;
	    }
	
	    function createSelectDefaultState(el, stateName, state) {
	      // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
	      if (state) {
	        // TODO Share with textContent?
	        if (state.z2 == null) {
	          state = extend({}, state);
	          var z2SelectLift = el.z2SelectLift;
	          state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : Z2_SELECT_LIFT);
	        }
	      }
	
	      return state;
	    }
	
	    function createBlurDefaultState(el, stateName, state) {
	      var hasBlur = indexOf(el.currentStates, stateName) >= 0;
	      var currentOpacity = el.style.opacity;
	      var fromState = !hasBlur ? getFromStateStyle(el, ['opacity'], stateName, {
	        opacity: 1
	      }) : null;
	      state = state || {};
	      var blurStyle = state.style || {};
	
	      if (blurStyle.opacity == null) {
	        // clone state
	        state = extend({}, state);
	        blurStyle = extend({
	          // Already being applied 'emphasis'. DON'T mul opacity multiple times.
	          opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
	        }, blurStyle);
	        state.style = blurStyle;
	      }
	
	      return state;
	    }
	
	    function elementStateProxy(stateName, targetStates) {
	      var state = this.states[stateName];
	
	      if (this.style) {
	        if (stateName === 'emphasis') {
	          return createEmphasisDefaultState(this, stateName, targetStates, state);
	        } else if (stateName === 'blur') {
	          return createBlurDefaultState(this, stateName, state);
	        } else if (stateName === 'select') {
	          return createSelectDefaultState(this, stateName, state);
	        }
	      }
	
	      return state;
	    }
	    /**
	     * Set hover style (namely "emphasis style") of element.
	     * @param el Should not be `zrender/graphic/Group`.
	     * @param focus 'self' | 'selfInSeries' | 'series'
	     */
	
	
	    function setDefaultStateProxy(el) {
	      el.stateProxy = elementStateProxy;
	      var textContent = el.getTextContent();
	      var textGuide = el.getTextGuideLine();
	
	      if (textContent) {
	        textContent.stateProxy = elementStateProxy;
	      }
	
	      if (textGuide) {
	        textGuide.stateProxy = elementStateProxy;
	      }
	    }
	    function enterEmphasisWhenMouseOver(el, e) {
	      !shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
	      && !el.__highByOuter && traverseUpdateState(el, singleEnterEmphasis);
	    }
	    function leaveEmphasisWhenMouseOut(el, e) {
	      !shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
	      && !el.__highByOuter && traverseUpdateState(el, singleLeaveEmphasis);
	    }
	    function enterEmphasis(el, highlightDigit) {
	      el.__highByOuter |= 1 << (highlightDigit || 0);
	      traverseUpdateState(el, singleEnterEmphasis);
	    }
	    function leaveEmphasis(el, highlightDigit) {
	      !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && traverseUpdateState(el, singleLeaveEmphasis);
	    }
	    function enterBlur(el) {
	      traverseUpdateState(el, singleEnterBlur);
	    }
	    function leaveBlur(el) {
	      traverseUpdateState(el, singleLeaveBlur);
	    }
	    function enterSelect(el) {
	      traverseUpdateState(el, singleEnterSelect);
	    }
	    function leaveSelect(el) {
	      traverseUpdateState(el, singleLeaveSelect);
	    }
	
	    function shouldSilent(el, e) {
	      return el.__highDownSilentOnTouch && e.zrByTouch;
	    }
	
	    function allLeaveBlur(api) {
	      var model = api.getModel();
	      var leaveBlurredSeries = [];
	      var allComponentViews = [];
	      model.eachComponent(function (componentType, componentModel) {
	        var componentStates = getComponentStates(componentModel);
	        var isSeries = componentType === 'series';
	        var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
	        !isSeries && allComponentViews.push(view);
	
	        if (componentStates.isBlured) {
	          // Leave blur anyway
	          view.group.traverse(function (child) {
	            singleLeaveBlur(child);
	          });
	          isSeries && leaveBlurredSeries.push(componentModel);
	        }
	
	        componentStates.isBlured = false;
	      });
	      each(allComponentViews, function (view) {
	        if (view && view.toggleBlurSeries) {
	          view.toggleBlurSeries(leaveBlurredSeries, false, model);
	        }
	      });
	    }
	    function blurSeries(targetSeriesIndex, focus, blurScope, api) {
	      var ecModel = api.getModel();
	      blurScope = blurScope || 'coordinateSystem';
	
	      function leaveBlurOfIndices(data, dataIndices) {
	        for (var i = 0; i < dataIndices.length; i++) {
	          var itemEl = data.getItemGraphicEl(dataIndices[i]);
	          itemEl && leaveBlur(itemEl);
	        }
	      }
	
	      if (targetSeriesIndex == null) {
	        return;
	      }
	
	      if (!focus || focus === 'none') {
	        return;
	      }
	
	      var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
	      var targetCoordSys = targetSeriesModel.coordinateSystem;
	
	      if (targetCoordSys && targetCoordSys.master) {
	        targetCoordSys = targetCoordSys.master;
	      }
	
	      var blurredSeries = [];
	      ecModel.eachSeries(function (seriesModel) {
	        var sameSeries = targetSeriesModel === seriesModel;
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (coordSys && coordSys.master) {
	          coordSys = coordSys.master;
	        }
	
	        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
	
	        if (!( // Not blur other series if blurScope series
	        blurScope === 'series' && !sameSeries // Not blur other coordinate system if blurScope is coordinateSystem
	        || blurScope === 'coordinateSystem' && !sameCoordSys // Not blur self series if focus is series.
	        || focus === 'series' && sameSeries // TODO blurScope: coordinate system
	        )) {
	          var view = api.getViewOfSeriesModel(seriesModel);
	          view.group.traverse(function (child) {
	            // For the elements that have been triggered by other components,
	            // and are still required to be highlighted,
	            // because the current is directly forced to blur the element,
	            // it will cause the focus self to be unable to highlight, so skip the blur of this element.
	            if (child.__highByOuter && sameSeries && focus === 'self') {
	              return;
	            }
	
	            singleEnterBlur(child);
	          });
	
	          if (isArrayLike(focus)) {
	            leaveBlurOfIndices(seriesModel.getData(), focus);
	          } else if (isObject(focus)) {
	            var dataTypes = keys(focus);
	
	            for (var d = 0; d < dataTypes.length; d++) {
	              leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
	            }
	          }
	
	          blurredSeries.push(seriesModel);
	          getComponentStates(seriesModel).isBlured = true;
	        }
	      });
	      ecModel.eachComponent(function (componentType, componentModel) {
	        if (componentType === 'series') {
	          return;
	        }
	
	        var view = api.getViewOfComponentModel(componentModel);
	
	        if (view && view.toggleBlurSeries) {
	          view.toggleBlurSeries(blurredSeries, true, ecModel);
	        }
	      });
	    }
	    function blurComponent(componentMainType, componentIndex, api) {
	      if (componentMainType == null || componentIndex == null) {
	        return;
	      }
	
	      var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
	
	      if (!componentModel) {
	        return;
	      }
	
	      getComponentStates(componentModel).isBlured = true;
	      var view = api.getViewOfComponentModel(componentModel);
	
	      if (!view || !view.focusBlurEnabled) {
	        return;
	      }
	
	      view.group.traverse(function (child) {
	        singleEnterBlur(child);
	      });
	    }
	    function blurSeriesFromHighlightPayload(seriesModel, payload, api) {
	      var seriesIndex = seriesModel.seriesIndex;
	      var data = seriesModel.getData(payload.dataType);
	
	      if (!data) {
	        if (true) {
	          error("Unknown dataType " + payload.dataType);
	        }
	
	        return;
	      }
	
	      var dataIndex = queryDataIndex(data, payload); // Pick the first one if there is multiple/none exists.
	
	      dataIndex = (isArray(dataIndex) ? dataIndex[0] : dataIndex) || 0;
	      var el = data.getItemGraphicEl(dataIndex);
	
	      if (!el) {
	        var count = data.count();
	        var current = 0; // If data on dataIndex is NaN.
	
	        while (!el && current < count) {
	          el = data.getItemGraphicEl(current++);
	        }
	      }
	
	      if (el) {
	        var ecData = getECData(el);
	        blurSeries(seriesIndex, ecData.focus, ecData.blurScope, api);
	      } else {
	        // If there is no element put on the data. Try getting it from raw option
	        // TODO Should put it on seriesModel?
	        var focus_1 = seriesModel.get(['emphasis', 'focus']);
	        var blurScope = seriesModel.get(['emphasis', 'blurScope']);
	
	        if (focus_1 != null) {
	          blurSeries(seriesIndex, focus_1, blurScope, api);
	        }
	      }
	    }
	    function findComponentHighDownDispatchers(componentMainType, componentIndex, name, api) {
	      var ret = {
	        focusSelf: false,
	        dispatchers: null
	      };
	
	      if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) {
	        return ret;
	      }
	
	      var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
	
	      if (!componentModel) {
	        return ret;
	      }
	
	      var view = api.getViewOfComponentModel(componentModel);
	
	      if (!view || !view.findHighDownDispatchers) {
	        return ret;
	      }
	
	      var dispatchers = view.findHighDownDispatchers(name); // At presnet, the component (like Geo) only blur inside itself.
	      // So we do not use `blurScope` in component.
	
	      var focusSelf;
	
	      for (var i = 0; i < dispatchers.length; i++) {
	        if ("development" !== 'production' && !isHighDownDispatcher(dispatchers[i])) {
	          error('param should be highDownDispatcher');
	        }
	
	        if (getECData(dispatchers[i]).focus === 'self') {
	          focusSelf = true;
	          break;
	        }
	      }
	
	      return {
	        focusSelf: focusSelf,
	        dispatchers: dispatchers
	      };
	    }
	    function handleGlobalMouseOverForHighDown(dispatcher, e, api) {
	      if ("development" !== 'production' && !isHighDownDispatcher(dispatcher)) {
	        error('param should be highDownDispatcher');
	      }
	
	      var ecData = getECData(dispatcher);
	
	      var _a = findComponentHighDownDispatchers(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api),
	          dispatchers = _a.dispatchers,
	          focusSelf = _a.focusSelf; // If `findHighDownDispatchers` is supported on the component,
	      // highlight/downplay elements with the same name.
	
	
	      if (dispatchers) {
	        if (focusSelf) {
	          blurComponent(ecData.componentMainType, ecData.componentIndex, api);
	        }
	
	        each(dispatchers, function (dispatcher) {
	          return enterEmphasisWhenMouseOver(dispatcher, e);
	        });
	      } else {
	        // Try blur all in the related series. Then emphasis the hoverred.
	        // TODO. progressive mode.
	        blurSeries(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
	
	        if (ecData.focus === 'self') {
	          blurComponent(ecData.componentMainType, ecData.componentIndex, api);
	        } // Other than series, component that not support `findHighDownDispatcher` will
	        // also use it. But in this case, highlight/downplay are only supported in
	        // mouse hover but not in dispatchAction.
	
	
	        enterEmphasisWhenMouseOver(dispatcher, e);
	      }
	    }
	    function handleGlobalMouseOutForHighDown(dispatcher, e, api) {
	      if ("development" !== 'production' && !isHighDownDispatcher(dispatcher)) {
	        error('param should be highDownDispatcher');
	      }
	
	      allLeaveBlur(api);
	      var ecData = getECData(dispatcher);
	      var dispatchers = findComponentHighDownDispatchers(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
	
	      if (dispatchers) {
	        each(dispatchers, function (dispatcher) {
	          return leaveEmphasisWhenMouseOut(dispatcher, e);
	        });
	      } else {
	        leaveEmphasisWhenMouseOut(dispatcher, e);
	      }
	    }
	    function toggleSelectionFromPayload(seriesModel, payload, api) {
	      if (!isSelectChangePayload(payload)) {
	        return;
	      }
	
	      var dataType = payload.dataType;
	      var data = seriesModel.getData(dataType);
	      var dataIndex = queryDataIndex(data, payload);
	
	      if (!isArray(dataIndex)) {
	        dataIndex = [dataIndex];
	      }
	
	      seriesModel[payload.type === TOGGLE_SELECT_ACTION_TYPE ? 'toggleSelect' : payload.type === SELECT_ACTION_TYPE ? 'select' : 'unselect'](dataIndex, dataType);
	    }
	    function updateSeriesElementSelection(seriesModel) {
	      var allData = seriesModel.getAllData();
	      each(allData, function (_a) {
	        var data = _a.data,
	            type = _a.type;
	        data.eachItemGraphicEl(function (el, idx) {
	          seriesModel.isSelected(idx, type) ? enterSelect(el) : leaveSelect(el);
	        });
	      });
	    }
	    function getAllSelectedIndices(ecModel) {
	      var ret = [];
	      ecModel.eachSeries(function (seriesModel) {
	        var allData = seriesModel.getAllData();
	        each(allData, function (_a) {
	          var data = _a.data,
	              type = _a.type;
	          var dataIndices = seriesModel.getSelectedDataIndices();
	
	          if (dataIndices.length > 0) {
	            var item = {
	              dataIndex: dataIndices,
	              seriesIndex: seriesModel.seriesIndex
	            };
	
	            if (type != null) {
	              item.dataType = type;
	            }
	
	            ret.push(item);
	          }
	        });
	      });
	      return ret;
	    }
	    /**
	     * Enable the function that mouseover will trigger the emphasis state.
	     *
	     * NOTE:
	     * This function should be used on the element with dataIndex, seriesIndex.
	     *
	     */
	
	    function enableHoverEmphasis(el, focus, blurScope) {
	      setAsHighDownDispatcher(el, true);
	      traverseUpdateState(el, setDefaultStateProxy);
	      enableHoverFocus(el, focus, blurScope);
	    }
	    function disableHoverEmphasis(el) {
	      setAsHighDownDispatcher(el, false);
	    }
	    function toggleHoverEmphasis(el, focus, blurScope, isDisabled) {
	      isDisabled ? disableHoverEmphasis(el) : enableHoverEmphasis(el, focus, blurScope);
	    }
	    function enableHoverFocus(el, focus, blurScope) {
	      var ecData = getECData(el);
	
	      if (focus != null) {
	        // TODO dataIndex may be set after this function. This check is not useful.
	        // if (ecData.dataIndex == null) {
	        //     if (__DEV__) {
	        //         console.warn('focus can only been set on element with dataIndex');
	        //     }
	        // }
	        // else {
	        ecData.focus = focus;
	        ecData.blurScope = blurScope; // }
	      } else if (ecData.focus) {
	        ecData.focus = null;
	      }
	    }
	    var OTHER_STATES = ['emphasis', 'blur', 'select'];
	    var defaultStyleGetterMap = {
	      itemStyle: 'getItemStyle',
	      lineStyle: 'getLineStyle',
	      areaStyle: 'getAreaStyle'
	    };
	    /**
	     * Set emphasis/blur/selected states of element.
	     */
	
	    function setStatesStylesFromModel(el, itemModel, styleType, // default itemStyle
	    getter) {
	      styleType = styleType || 'itemStyle';
	
	      for (var i = 0; i < OTHER_STATES.length; i++) {
	        var stateName = OTHER_STATES[i];
	        var model = itemModel.getModel([stateName, styleType]);
	        var state = el.ensureState(stateName); // Let it throw error if getterType is not found.
	
	        state.style = getter ? getter(model) : model[defaultStyleGetterMap[styleType]]();
	      }
	    }
	    /**
	     *
	     * Set element as highlight / downplay dispatcher.
	     * It will be checked when element received mouseover event or from highlight action.
	     * It's in change of all highlight/downplay behavior of it's children.
	     *
	     * @param el
	     * @param el.highDownSilentOnTouch
	     *        In touch device, mouseover event will be trigger on touchstart event
	     *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
	     *        conveniently use hoverStyle when tap on touch screen without additional
	     *        code for compatibility.
	     *        But if the chart/component has select feature, which usually also use
	     *        hoverStyle, there might be conflict between 'select-highlight' and
	     *        'hover-highlight' especially when roam is enabled (see geo for example).
	     *        In this case, `highDownSilentOnTouch` should be used to disable
	     *        hover-highlight on touch device.
	     * @param asDispatcher If `false`, do not set as "highDownDispatcher".
	     */
	
	    function setAsHighDownDispatcher(el, asDispatcher) {
	      var disable = asDispatcher === false;
	      var extendedEl = el; // Make `highDownSilentOnTouch` and `onStateChange` only work after
	      // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
	
	      if (el.highDownSilentOnTouch) {
	        extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
	      } // Simple optimize, since this method might be
	      // called for each elements of a group in some cases.
	
	
	      if (!disable || extendedEl.__highDownDispatcher) {
	        // Emphasis, normal can be triggered manually by API or other components like hover link.
	        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
	        // Also keep previous record.
	        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
	        extendedEl.__highDownDispatcher = !disable;
	      }
	    }
	    function isHighDownDispatcher(el) {
	      return !!(el && el.__highDownDispatcher);
	    }
	    /**
	     * Enable component highlight/downplay features:
	     * + hover link (within the same name)
	     * + focus blur in component
	     */
	
	    function enableComponentHighDownFeatures(el, componentModel, componentHighDownName) {
	      var ecData = getECData(el);
	      ecData.componentMainType = componentModel.mainType;
	      ecData.componentIndex = componentModel.componentIndex;
	      ecData.componentHighDownName = componentHighDownName;
	    }
	    /**
	     * Support highlight/downplay record on each elements.
	     * For the case: hover highlight/downplay (legend, visualMap, ...) and
	     * user triggered highlight/downplay should not conflict.
	     * Only all of the highlightDigit cleared, return to normal.
	     * @param {string} highlightKey
	     * @return {number} highlightDigit
	     */
	
	    function getHighlightDigit(highlightKey) {
	      var highlightDigit = _highlightKeyMap[highlightKey];
	
	      if (highlightDigit == null && _highlightNextDigit <= 32) {
	        highlightDigit = _highlightKeyMap[highlightKey] = _highlightNextDigit++;
	      }
	
	      return highlightDigit;
	    }
	    function isSelectChangePayload(payload) {
	      var payloadType = payload.type;
	      return payloadType === SELECT_ACTION_TYPE || payloadType === UNSELECT_ACTION_TYPE || payloadType === TOGGLE_SELECT_ACTION_TYPE;
	    }
	    function isHighDownPayload(payload) {
	      var payloadType = payload.type;
	      return payloadType === HIGHLIGHT_ACTION_TYPE || payloadType === DOWNPLAY_ACTION_TYPE;
	    }
	    function savePathStates(el) {
	      var store = getSavedStates(el);
	      store.normalFill = el.style.fill;
	      store.normalStroke = el.style.stroke;
	      var selectState = el.states.select || {};
	      store.selectFill = selectState.style && selectState.style.fill || null;
	      store.selectStroke = selectState.style && selectState.style.stroke || null;
	    }
	
	    var CMD$2 = PathProxy.CMD;
	    var points = [[], [], []];
	    var mathSqrt$1 = Math.sqrt;
	    var mathAtan2 = Math.atan2;
	    function transformPath(path, m) {
	        if (!m) {
	            return;
	        }
	        var data = path.data;
	        var len = path.len();
	        var cmd;
	        var nPoint;
	        var i;
	        var j;
	        var k;
	        var p;
	        var M = CMD$2.M;
	        var C = CMD$2.C;
	        var L = CMD$2.L;
	        var R = CMD$2.R;
	        var A = CMD$2.A;
	        var Q = CMD$2.Q;
	        for (i = 0, j = 0; i < len;) {
	            cmd = data[i++];
	            j = i;
	            nPoint = 0;
	            switch (cmd) {
	                case M:
	                    nPoint = 1;
	                    break;
	                case L:
	                    nPoint = 1;
	                    break;
	                case C:
	                    nPoint = 3;
	                    break;
	                case Q:
	                    nPoint = 2;
	                    break;
	                case A:
	                    var x = m[4];
	                    var y = m[5];
	                    var sx = mathSqrt$1(m[0] * m[0] + m[1] * m[1]);
	                    var sy = mathSqrt$1(m[2] * m[2] + m[3] * m[3]);
	                    var angle = mathAtan2(-m[1] / sy, m[0] / sx);
	                    data[i] *= sx;
	                    data[i++] += x;
	                    data[i] *= sy;
	                    data[i++] += y;
	                    data[i++] *= sx;
	                    data[i++] *= sy;
	                    data[i++] += angle;
	                    data[i++] += angle;
	                    i += 2;
	                    j = i;
	                    break;
	                case R:
	                    p[0] = data[i++];
	                    p[1] = data[i++];
	                    applyTransform(p, p, m);
	                    data[j++] = p[0];
	                    data[j++] = p[1];
	                    p[0] += data[i++];
	                    p[1] += data[i++];
	                    applyTransform(p, p, m);
	                    data[j++] = p[0];
	                    data[j++] = p[1];
	            }
	            for (k = 0; k < nPoint; k++) {
	                var p_1 = points[k];
	                p_1[0] = data[i++];
	                p_1[1] = data[i++];
	                applyTransform(p_1, p_1, m);
	                data[j++] = p_1[0];
	                data[j++] = p_1[1];
	            }
	        }
	        path.increaseVersion();
	    }
	
	    var mathSqrt$2 = Math.sqrt;
	    var mathSin$2 = Math.sin;
	    var mathCos$2 = Math.cos;
	    var PI$1 = Math.PI;
	    function vMag(v) {
	        return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	    }
	    function vRatio(u, v) {
	        return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
	    }
	    function vAngle(u, v) {
	        return (u[0] * v[1] < u[1] * v[0] ? -1 : 1)
	            * Math.acos(vRatio(u, v));
	    }
	    function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
	        var psi = psiDeg * (PI$1 / 180.0);
	        var xp = mathCos$2(psi) * (x1 - x2) / 2.0
	            + mathSin$2(psi) * (y1 - y2) / 2.0;
	        var yp = -1 * mathSin$2(psi) * (x1 - x2) / 2.0
	            + mathCos$2(psi) * (y1 - y2) / 2.0;
	        var lambda = (xp * xp) / (rx * rx) + (yp * yp) / (ry * ry);
	        if (lambda > 1) {
	            rx *= mathSqrt$2(lambda);
	            ry *= mathSqrt$2(lambda);
	        }
	        var f = (fa === fs ? -1 : 1)
	            * mathSqrt$2((((rx * rx) * (ry * ry))
	                - ((rx * rx) * (yp * yp))
	                - ((ry * ry) * (xp * xp))) / ((rx * rx) * (yp * yp)
	                + (ry * ry) * (xp * xp))) || 0;
	        var cxp = f * rx * yp / ry;
	        var cyp = f * -ry * xp / rx;
	        var cx = (x1 + x2) / 2.0
	            + mathCos$2(psi) * cxp
	            - mathSin$2(psi) * cyp;
	        var cy = (y1 + y2) / 2.0
	            + mathSin$2(psi) * cxp
	            + mathCos$2(psi) * cyp;
	        var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
	        var u = [(xp - cxp) / rx, (yp - cyp) / ry];
	        var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
	        var dTheta = vAngle(u, v);
	        if (vRatio(u, v) <= -1) {
	            dTheta = PI$1;
	        }
	        if (vRatio(u, v) >= 1) {
	            dTheta = 0;
	        }
	        if (dTheta < 0) {
	            var n = Math.round(dTheta / PI$1 * 1e6) / 1e6;
	            dTheta = PI$1 * 2 + (n % 2) * PI$1;
	        }
	        path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
	    }
	    var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
	    var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
	    function createPathProxyFromString(data) {
	        var path = new PathProxy();
	        if (!data) {
	            return path;
	        }
	        var cpx = 0;
	        var cpy = 0;
	        var subpathX = cpx;
	        var subpathY = cpy;
	        var prevCmd;
	        var CMD = PathProxy.CMD;
	        var cmdList = data.match(commandReg);
	        if (!cmdList) {
	            return path;
	        }
	        for (var l = 0; l < cmdList.length; l++) {
	            var cmdText = cmdList[l];
	            var cmdStr = cmdText.charAt(0);
	            var cmd = void 0;
	            var p = cmdText.match(numberReg) || [];
	            var pLen = p.length;
	            for (var i = 0; i < pLen; i++) {
	                p[i] = parseFloat(p[i]);
	            }
	            var off = 0;
	            while (off < pLen) {
	                var ctlPtx = void 0;
	                var ctlPty = void 0;
	                var rx = void 0;
	                var ry = void 0;
	                var psi = void 0;
	                var fa = void 0;
	                var fs = void 0;
	                var x1 = cpx;
	                var y1 = cpy;
	                var len = void 0;
	                var pathData = void 0;
	                switch (cmdStr) {
	                    case 'l':
	                        cpx += p[off++];
	                        cpy += p[off++];
	                        cmd = CMD.L;
	                        path.addData(cmd, cpx, cpy);
	                        break;
	                    case 'L':
	                        cpx = p[off++];
	                        cpy = p[off++];
	                        cmd = CMD.L;
	                        path.addData(cmd, cpx, cpy);
	                        break;
	                    case 'm':
	                        cpx += p[off++];
	                        cpy += p[off++];
	                        cmd = CMD.M;
	                        path.addData(cmd, cpx, cpy);
	                        subpathX = cpx;
	                        subpathY = cpy;
	                        cmdStr = 'l';
	                        break;
	                    case 'M':
	                        cpx = p[off++];
	                        cpy = p[off++];
	                        cmd = CMD.M;
	                        path.addData(cmd, cpx, cpy);
	                        subpathX = cpx;
	                        subpathY = cpy;
	                        cmdStr = 'L';
	                        break;
	                    case 'h':
	                        cpx += p[off++];
	                        cmd = CMD.L;
	                        path.addData(cmd, cpx, cpy);
	                        break;
	                    case 'H':
	                        cpx = p[off++];
	                        cmd = CMD.L;
	                        path.addData(cmd, cpx, cpy);
	                        break;
	                    case 'v':
	                        cpy += p[off++];
	                        cmd = CMD.L;
	                        path.addData(cmd, cpx, cpy);
	                        break;
	                    case 'V':
	                        cpy = p[off++];
	                        cmd = CMD.L;
	                        path.addData(cmd, cpx, cpy);
	                        break;
	                    case 'C':
	                        cmd = CMD.C;
	                        path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
	                        cpx = p[off - 2];
	                        cpy = p[off - 1];
	                        break;
	                    case 'c':
	                        cmd = CMD.C;
	                        path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
	                        cpx += p[off - 2];
	                        cpy += p[off - 1];
	                        break;
	                    case 'S':
	                        ctlPtx = cpx;
	                        ctlPty = cpy;
	                        len = path.len();
	                        pathData = path.data;
	                        if (prevCmd === CMD.C) {
	                            ctlPtx += cpx - pathData[len - 4];
	                            ctlPty += cpy - pathData[len - 3];
	                        }
	                        cmd = CMD.C;
	                        x1 = p[off++];
	                        y1 = p[off++];
	                        cpx = p[off++];
	                        cpy = p[off++];
	                        path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	                        break;
	                    case 's':
	                        ctlPtx = cpx;
	                        ctlPty = cpy;
	                        len = path.len();
	                        pathData = path.data;
	                        if (prevCmd === CMD.C) {
	                            ctlPtx += cpx - pathData[len - 4];
	                            ctlPty += cpy - pathData[len - 3];
	                        }
	                        cmd = CMD.C;
	                        x1 = cpx + p[off++];
	                        y1 = cpy + p[off++];
	                        cpx += p[off++];
	                        cpy += p[off++];
	                        path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	                        break;
	                    case 'Q':
	                        x1 = p[off++];
	                        y1 = p[off++];
	                        cpx = p[off++];
	                        cpy = p[off++];
	                        cmd = CMD.Q;
	                        path.addData(cmd, x1, y1, cpx, cpy);
	                        break;
	                    case 'q':
	                        x1 = p[off++] + cpx;
	                        y1 = p[off++] + cpy;
	                        cpx += p[off++];
	                        cpy += p[off++];
	                        cmd = CMD.Q;
	                        path.addData(cmd, x1, y1, cpx, cpy);
	                        break;
	                    case 'T':
	                        ctlPtx = cpx;
	                        ctlPty = cpy;
	                        len = path.len();
	                        pathData = path.data;
	                        if (prevCmd === CMD.Q) {
	                            ctlPtx += cpx - pathData[len - 4];
	                            ctlPty += cpy - pathData[len - 3];
	                        }
	                        cpx = p[off++];
	                        cpy = p[off++];
	                        cmd = CMD.Q;
	                        path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	                        break;
	                    case 't':
	                        ctlPtx = cpx;
	                        ctlPty = cpy;
	                        len = path.len();
	                        pathData = path.data;
	                        if (prevCmd === CMD.Q) {
	                            ctlPtx += cpx - pathData[len - 4];
	                            ctlPty += cpy - pathData[len - 3];
	                        }
	                        cpx += p[off++];
	                        cpy += p[off++];
	                        cmd = CMD.Q;
	                        path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	                        break;
	                    case 'A':
	                        rx = p[off++];
	                        ry = p[off++];
	                        psi = p[off++];
	                        fa = p[off++];
	                        fs = p[off++];
	                        x1 = cpx, y1 = cpy;
	                        cpx = p[off++];
	                        cpy = p[off++];
	                        cmd = CMD.A;
	                        processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	                        break;
	                    case 'a':
	                        rx = p[off++];
	                        ry = p[off++];
	                        psi = p[off++];
	                        fa = p[off++];
	                        fs = p[off++];
	                        x1 = cpx, y1 = cpy;
	                        cpx += p[off++];
	                        cpy += p[off++];
	                        cmd = CMD.A;
	                        processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	                        break;
	                }
	            }
	            if (cmdStr === 'z' || cmdStr === 'Z') {
	                cmd = CMD.Z;
	                path.addData(cmd);
	                cpx = subpathX;
	                cpy = subpathY;
	            }
	            prevCmd = cmd;
	        }
	        path.toStatic();
	        return path;
	    }
	    var SVGPath = (function (_super) {
	        __extends(SVGPath, _super);
	        function SVGPath() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        SVGPath.prototype.applyTransform = function (m) { };
	        return SVGPath;
	    }(Path));
	    function isPathProxy(path) {
	        return path.setData != null;
	    }
	    function createPathOptions(str, opts) {
	        var pathProxy = createPathProxyFromString(str);
	        var innerOpts = extend({}, opts);
	        innerOpts.buildPath = function (path) {
	            if (isPathProxy(path)) {
	                path.setData(pathProxy.data);
	                var ctx = path.getContext();
	                if (ctx) {
	                    path.rebuildPath(ctx, 1);
	                }
	            }
	            else {
	                var ctx = path;
	                pathProxy.rebuildPath(ctx, 1);
	            }
	        };
	        innerOpts.applyTransform = function (m) {
	            transformPath(pathProxy, m);
	            this.dirtyShape();
	        };
	        return innerOpts;
	    }
	    function createFromString(str, opts) {
	        return new SVGPath(createPathOptions(str, opts));
	    }
	    function extendFromString(str, defaultOpts) {
	        var innerOpts = createPathOptions(str, defaultOpts);
	        var Sub = (function (_super) {
	            __extends(Sub, _super);
	            function Sub(opts) {
	                var _this = _super.call(this, opts) || this;
	                _this.applyTransform = innerOpts.applyTransform;
	                _this.buildPath = innerOpts.buildPath;
	                return _this;
	            }
	            return Sub;
	        }(SVGPath));
	        return Sub;
	    }
	    function mergePath(pathEls, opts) {
	        var pathList = [];
	        var len = pathEls.length;
	        for (var i = 0; i < len; i++) {
	            var pathEl = pathEls[i];
	            pathList.push(pathEl.getUpdatedPathProxy(true));
	        }
	        var pathBundle = new Path(opts);
	        pathBundle.createPathProxy();
	        pathBundle.buildPath = function (path) {
	            if (isPathProxy(path)) {
	                path.appendPath(pathList);
	                var ctx = path.getContext();
	                if (ctx) {
	                    path.rebuildPath(ctx, 1);
	                }
	            }
	        };
	        return pathBundle;
	    }
	    function clonePath(sourcePath, opts) {
	        opts = opts || {};
	        var path = new Path();
	        if (sourcePath.shape) {
	            path.setShape(sourcePath.shape);
	        }
	        path.setStyle(sourcePath.style);
	        if (opts.bakeTransform) {
	            transformPath(path.path, sourcePath.getComputedTransform());
	        }
	        else {
	            if (opts.toLocal) {
	                path.setLocalTransform(sourcePath.getComputedTransform());
	            }
	            else {
	                path.copyTransform(sourcePath);
	            }
	        }
	        path.buildPath = sourcePath.buildPath;
	        path.applyTransform = path.applyTransform;
	        path.z = sourcePath.z;
	        path.z2 = sourcePath.z2;
	        path.zlevel = sourcePath.zlevel;
	        return path;
	    }
	
	    var CircleShape = (function () {
	        function CircleShape() {
	            this.cx = 0;
	            this.cy = 0;
	            this.r = 0;
	        }
	        return CircleShape;
	    }());
	    var Circle = (function (_super) {
	        __extends(Circle, _super);
	        function Circle(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Circle.prototype.getDefaultShape = function () {
	            return new CircleShape();
	        };
	        Circle.prototype.buildPath = function (ctx, shape) {
	            ctx.moveTo(shape.cx + shape.r, shape.cy);
	            ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
	        };
	        return Circle;
	    }(Path));
	    Circle.prototype.type = 'circle';
	
	    var EllipseShape = (function () {
	        function EllipseShape() {
	            this.cx = 0;
	            this.cy = 0;
	            this.rx = 0;
	            this.ry = 0;
	        }
	        return EllipseShape;
	    }());
	    var Ellipse = (function (_super) {
	        __extends(Ellipse, _super);
	        function Ellipse(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Ellipse.prototype.getDefaultShape = function () {
	            return new EllipseShape();
	        };
	        Ellipse.prototype.buildPath = function (ctx, shape) {
	            var k = 0.5522848;
	            var x = shape.cx;
	            var y = shape.cy;
	            var a = shape.rx;
	            var b = shape.ry;
	            var ox = a * k;
	            var oy = b * k;
	            ctx.moveTo(x - a, y);
	            ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
	            ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
	            ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
	            ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
	            ctx.closePath();
	        };
	        return Ellipse;
	    }(Path));
	    Ellipse.prototype.type = 'ellipse';
	
	    var PI$2 = Math.PI;
	    var PI2$5 = PI$2 * 2;
	    var mathSin$3 = Math.sin;
	    var mathCos$3 = Math.cos;
	    var mathACos = Math.acos;
	    var mathATan2 = Math.atan2;
	    var mathAbs$1 = Math.abs;
	    var mathSqrt$3 = Math.sqrt;
	    var mathMax$3 = Math.max;
	    var mathMin$3 = Math.min;
	    var e = 1e-4;
	    function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	        var dx10 = x1 - x0;
	        var dy10 = y1 - y0;
	        var dx32 = x3 - x2;
	        var dy32 = y3 - y2;
	        var t = dy32 * dx10 - dx32 * dy10;
	        if (t * t < e) {
	            return;
	        }
	        t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
	        return [x0 + t * dx10, y0 + t * dy10];
	    }
	    function computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
	        var x01 = x0 - x1;
	        var y01 = y0 - y1;
	        var lo = (clockwise ? cr : -cr) / mathSqrt$3(x01 * x01 + y01 * y01);
	        var ox = lo * y01;
	        var oy = -lo * x01;
	        var x11 = x0 + ox;
	        var y11 = y0 + oy;
	        var x10 = x1 + ox;
	        var y10 = y1 + oy;
	        var x00 = (x11 + x10) / 2;
	        var y00 = (y11 + y10) / 2;
	        var dx = x10 - x11;
	        var dy = y10 - y11;
	        var d2 = dx * dx + dy * dy;
	        var r = radius - cr;
	        var s = x11 * y10 - x10 * y11;
	        var d = (dy < 0 ? -1 : 1) * mathSqrt$3(mathMax$3(0, r * r * d2 - s * s));
	        var cx0 = (s * dy - dx * d) / d2;
	        var cy0 = (-s * dx - dy * d) / d2;
	        var cx1 = (s * dy + dx * d) / d2;
	        var cy1 = (-s * dx + dy * d) / d2;
	        var dx0 = cx0 - x00;
	        var dy0 = cy0 - y00;
	        var dx1 = cx1 - x00;
	        var dy1 = cy1 - y00;
	        if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
	            cx0 = cx1;
	            cy0 = cy1;
	        }
	        return {
	            cx: cx0,
	            cy: cy0,
	            x0: -ox,
	            y0: -oy,
	            x1: cx0 * (radius / r - 1),
	            y1: cy0 * (radius / r - 1)
	        };
	    }
	    function normalizeCornerRadius(cr) {
	        var arr;
	        if (isArray(cr)) {
	            var len = cr.length;
	            if (!len) {
	                return cr;
	            }
	            if (len === 1) {
	                arr = [cr[0], cr[0], 0, 0];
	            }
	            else if (len === 2) {
	                arr = [cr[0], cr[0], cr[1], cr[1]];
	            }
	            else if (len === 3) {
	                arr = cr.concat(cr[2]);
	            }
	            else {
	                arr = cr;
	            }
	        }
	        else {
	            arr = [cr, cr, cr, cr];
	        }
	        return arr;
	    }
	    function buildPath$1(ctx, shape) {
	        var _a;
	        var radius = mathMax$3(shape.r, 0);
	        var innerRadius = mathMax$3(shape.r0 || 0, 0);
	        var hasRadius = radius > 0;
	        var hasInnerRadius = innerRadius > 0;
	        if (!hasRadius && !hasInnerRadius) {
	            return;
	        }
	        if (!hasRadius) {
	            radius = innerRadius;
	            innerRadius = 0;
	        }
	        if (innerRadius > radius) {
	            var tmp = radius;
	            radius = innerRadius;
	            innerRadius = tmp;
	        }
	        var startAngle = shape.startAngle, endAngle = shape.endAngle;
	        if (isNaN(startAngle) || isNaN(endAngle)) {
	            return;
	        }
	        var cx = shape.cx, cy = shape.cy;
	        var clockwise = !!shape.clockwise;
	        var arc = mathAbs$1(endAngle - startAngle);
	        var mod = arc > PI2$5 && arc % PI2$5;
	        mod > e && (arc = mod);
	        if (!(radius > e)) {
	            ctx.moveTo(cx, cy);
	        }
	        else if (arc > PI2$5 - e) {
	            ctx.moveTo(cx + radius * mathCos$3(startAngle), cy + radius * mathSin$3(startAngle));
	            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
	            if (innerRadius > e) {
	                ctx.moveTo(cx + innerRadius * mathCos$3(endAngle), cy + innerRadius * mathSin$3(endAngle));
	                ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
	            }
	        }
	        else {
	            var icrStart = void 0;
	            var icrEnd = void 0;
	            var ocrStart = void 0;
	            var ocrEnd = void 0;
	            var ocrs = void 0;
	            var ocre = void 0;
	            var icrs = void 0;
	            var icre = void 0;
	            var ocrMax = void 0;
	            var icrMax = void 0;
	            var limitedOcrMax = void 0;
	            var limitedIcrMax = void 0;
	            var xre = void 0;
	            var yre = void 0;
	            var xirs = void 0;
	            var yirs = void 0;
	            var xrs = radius * mathCos$3(startAngle);
	            var yrs = radius * mathSin$3(startAngle);
	            var xire = innerRadius * mathCos$3(endAngle);
	            var yire = innerRadius * mathSin$3(endAngle);
	            var hasArc = arc > e;
	            if (hasArc) {
	                var cornerRadius = shape.cornerRadius;
	                if (cornerRadius) {
	                    _a = normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
	                }
	                var halfRd = mathAbs$1(radius - innerRadius) / 2;
	                ocrs = mathMin$3(halfRd, ocrStart);
	                ocre = mathMin$3(halfRd, ocrEnd);
	                icrs = mathMin$3(halfRd, icrStart);
	                icre = mathMin$3(halfRd, icrEnd);
	                limitedOcrMax = ocrMax = mathMax$3(ocrs, ocre);
	                limitedIcrMax = icrMax = mathMax$3(icrs, icre);
	                if (ocrMax > e || icrMax > e) {
	                    xre = radius * mathCos$3(endAngle);
	                    yre = radius * mathSin$3(endAngle);
	                    xirs = innerRadius * mathCos$3(startAngle);
	                    yirs = innerRadius * mathSin$3(startAngle);
	                    if (arc < PI$2) {
	                        var it_1 = intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
	                        if (it_1) {
	                            var x0 = xrs - it_1[0];
	                            var y0 = yrs - it_1[1];
	                            var x1 = xre - it_1[0];
	                            var y1 = yre - it_1[1];
	                            var a = 1 / mathSin$3(mathACos((x0 * x1 + y0 * y1) / (mathSqrt$3(x0 * x0 + y0 * y0) * mathSqrt$3(x1 * x1 + y1 * y1))) / 2);
	                            var b = mathSqrt$3(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
	                            limitedOcrMax = mathMin$3(ocrMax, (radius - b) / (a + 1));
	                            limitedIcrMax = mathMin$3(icrMax, (innerRadius - b) / (a - 1));
	                        }
	                    }
	                }
	            }
	            if (!hasArc) {
	                ctx.moveTo(cx + xrs, cy + yrs);
	            }
	            else if (limitedOcrMax > e) {
	                var crStart = mathMin$3(ocrStart, limitedOcrMax);
	                var crEnd = mathMin$3(ocrEnd, limitedOcrMax);
	                var ct0 = computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
	                var ct1 = computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
	                ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
	                if (limitedOcrMax < ocrMax && crStart === crEnd) {
	                    ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, mathATan2(ct0.y0, ct0.x0), mathATan2(ct1.y0, ct1.x0), !clockwise);
	                }
	                else {
	                    crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, mathATan2(ct0.y0, ct0.x0), mathATan2(ct0.y1, ct0.x1), !clockwise);
	                    ctx.arc(cx, cy, radius, mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
	                    crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, mathATan2(ct1.y1, ct1.x1), mathATan2(ct1.y0, ct1.x0), !clockwise);
	                }
	            }
	            else {
	                ctx.moveTo(cx + xrs, cy + yrs);
	                ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
	            }
	            if (!(innerRadius > e) || !hasArc) {
	                ctx.lineTo(cx + xire, cy + yire);
	            }
	            else if (limitedIcrMax > e) {
	                var crStart = mathMin$3(icrStart, limitedIcrMax);
	                var crEnd = mathMin$3(icrEnd, limitedIcrMax);
	                var ct0 = computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
	                var ct1 = computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
	                ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
	                if (limitedIcrMax < icrMax && crStart === crEnd) {
	                    ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, mathATan2(ct0.y0, ct0.x0), mathATan2(ct1.y0, ct1.x0), !clockwise);
	                }
	                else {
	                    crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, mathATan2(ct0.y0, ct0.x0), mathATan2(ct0.y1, ct0.x1), !clockwise);
	                    ctx.arc(cx, cy, innerRadius, mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
	                    crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, mathATan2(ct1.y1, ct1.x1), mathATan2(ct1.y0, ct1.x0), !clockwise);
	                }
	            }
	            else {
	                ctx.lineTo(cx + xire, cy + yire);
	                ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
	            }
	        }
	        ctx.closePath();
	    }
	
	    var SectorShape = (function () {
	        function SectorShape() {
	            this.cx = 0;
	            this.cy = 0;
	            this.r0 = 0;
	            this.r = 0;
	            this.startAngle = 0;
	            this.endAngle = Math.PI * 2;
	            this.clockwise = true;
	            this.cornerRadius = 0;
	        }
	        return SectorShape;
	    }());
	    var Sector = (function (_super) {
	        __extends(Sector, _super);
	        function Sector(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Sector.prototype.getDefaultShape = function () {
	            return new SectorShape();
	        };
	        Sector.prototype.buildPath = function (ctx, shape) {
	            buildPath$1(ctx, shape);
	        };
	        Sector.prototype.isZeroArea = function () {
	            return this.shape.startAngle === this.shape.endAngle
	                || this.shape.r === this.shape.r0;
	        };
	        return Sector;
	    }(Path));
	    Sector.prototype.type = 'sector';
	
	    var RingShape = (function () {
	        function RingShape() {
	            this.cx = 0;
	            this.cy = 0;
	            this.r = 0;
	            this.r0 = 0;
	        }
	        return RingShape;
	    }());
	    var Ring = (function (_super) {
	        __extends(Ring, _super);
	        function Ring(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Ring.prototype.getDefaultShape = function () {
	            return new RingShape();
	        };
	        Ring.prototype.buildPath = function (ctx, shape) {
	            var x = shape.cx;
	            var y = shape.cy;
	            var PI2 = Math.PI * 2;
	            ctx.moveTo(x + shape.r, y);
	            ctx.arc(x, y, shape.r, 0, PI2, false);
	            ctx.moveTo(x + shape.r0, y);
	            ctx.arc(x, y, shape.r0, 0, PI2, true);
	        };
	        return Ring;
	    }(Path));
	    Ring.prototype.type = 'ring';
	
	    function smoothBezier(points, smooth, isLoop, constraint) {
	        var cps = [];
	        var v = [];
	        var v1 = [];
	        var v2 = [];
	        var prevPoint;
	        var nextPoint;
	        var min$1;
	        var max$1;
	        if (constraint) {
	            min$1 = [Infinity, Infinity];
	            max$1 = [-Infinity, -Infinity];
	            for (var i = 0, len = points.length; i < len; i++) {
	                min(min$1, min$1, points[i]);
	                max(max$1, max$1, points[i]);
	            }
	            min(min$1, min$1, constraint[0]);
	            max(max$1, max$1, constraint[1]);
	        }
	        for (var i = 0, len = points.length; i < len; i++) {
	            var point = points[i];
	            if (isLoop) {
	                prevPoint = points[i ? i - 1 : len - 1];
	                nextPoint = points[(i + 1) % len];
	            }
	            else {
	                if (i === 0 || i === len - 1) {
	                    cps.push(clone$1(points[i]));
	                    continue;
	                }
	                else {
	                    prevPoint = points[i - 1];
	                    nextPoint = points[i + 1];
	                }
	            }
	            sub(v, nextPoint, prevPoint);
	            scale(v, v, smooth);
	            var d0 = distance(point, prevPoint);
	            var d1 = distance(point, nextPoint);
	            var sum = d0 + d1;
	            if (sum !== 0) {
	                d0 /= sum;
	                d1 /= sum;
	            }
	            scale(v1, v, -d0);
	            scale(v2, v, d1);
	            var cp0 = add([], point, v1);
	            var cp1 = add([], point, v2);
	            if (constraint) {
	                max(cp0, cp0, min$1);
	                min(cp0, cp0, max$1);
	                max(cp1, cp1, min$1);
	                min(cp1, cp1, max$1);
	            }
	            cps.push(cp0);
	            cps.push(cp1);
	        }
	        if (isLoop) {
	            cps.push(cps.shift());
	        }
	        return cps;
	    }
	
	    function buildPath$2(ctx, shape, closePath) {
	        var smooth = shape.smooth;
	        var points = shape.points;
	        if (points && points.length >= 2) {
	            if (smooth) {
	                var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
	                ctx.moveTo(points[0][0], points[0][1]);
	                var len = points.length;
	                for (var i = 0; i < (closePath ? len : len - 1); i++) {
	                    var cp1 = controlPoints[i * 2];
	                    var cp2 = controlPoints[i * 2 + 1];
	                    var p = points[(i + 1) % len];
	                    ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
	                }
	            }
	            else {
	                ctx.moveTo(points[0][0], points[0][1]);
	                for (var i = 1, l = points.length; i < l; i++) {
	                    ctx.lineTo(points[i][0], points[i][1]);
	                }
	            }
	            closePath && ctx.closePath();
	        }
	    }
	
	    var PolygonShape = (function () {
	        function PolygonShape() {
	            this.points = null;
	            this.smooth = 0;
	            this.smoothConstraint = null;
	        }
	        return PolygonShape;
	    }());
	    var Polygon = (function (_super) {
	        __extends(Polygon, _super);
	        function Polygon(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Polygon.prototype.getDefaultShape = function () {
	            return new PolygonShape();
	        };
	        Polygon.prototype.buildPath = function (ctx, shape) {
	            buildPath$2(ctx, shape, true);
	        };
	        return Polygon;
	    }(Path));
	    Polygon.prototype.type = 'polygon';
	
	    var PolylineShape = (function () {
	        function PolylineShape() {
	            this.points = null;
	            this.percent = 1;
	            this.smooth = 0;
	            this.smoothConstraint = null;
	        }
	        return PolylineShape;
	    }());
	    var Polyline = (function (_super) {
	        __extends(Polyline, _super);
	        function Polyline(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Polyline.prototype.getDefaultStyle = function () {
	            return {
	                stroke: '#000',
	                fill: null
	            };
	        };
	        Polyline.prototype.getDefaultShape = function () {
	            return new PolylineShape();
	        };
	        Polyline.prototype.buildPath = function (ctx, shape) {
	            buildPath$2(ctx, shape, false);
	        };
	        return Polyline;
	    }(Path));
	    Polyline.prototype.type = 'polyline';
	
	    var subPixelOptimizeOutputShape$1 = {};
	    var LineShape = (function () {
	        function LineShape() {
	            this.x1 = 0;
	            this.y1 = 0;
	            this.x2 = 0;
	            this.y2 = 0;
	            this.percent = 1;
	        }
	        return LineShape;
	    }());
	    var Line = (function (_super) {
	        __extends(Line, _super);
	        function Line(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Line.prototype.getDefaultStyle = function () {
	            return {
	                stroke: '#000',
	                fill: null
	            };
	        };
	        Line.prototype.getDefaultShape = function () {
	            return new LineShape();
	        };
	        Line.prototype.buildPath = function (ctx, shape) {
	            var x1;
	            var y1;
	            var x2;
	            var y2;
	            if (this.subPixelOptimize) {
	                var optimizedShape = subPixelOptimizeLine(subPixelOptimizeOutputShape$1, shape, this.style);
	                x1 = optimizedShape.x1;
	                y1 = optimizedShape.y1;
	                x2 = optimizedShape.x2;
	                y2 = optimizedShape.y2;
	            }
	            else {
	                x1 = shape.x1;
	                y1 = shape.y1;
	                x2 = shape.x2;
	                y2 = shape.y2;
	            }
	            var percent = shape.percent;
	            if (percent === 0) {
	                return;
	            }
	            ctx.moveTo(x1, y1);
	            if (percent < 1) {
	                x2 = x1 * (1 - percent) + x2 * percent;
	                y2 = y1 * (1 - percent) + y2 * percent;
	            }
	            ctx.lineTo(x2, y2);
	        };
	        Line.prototype.pointAt = function (p) {
	            var shape = this.shape;
	            return [
	                shape.x1 * (1 - p) + shape.x2 * p,
	                shape.y1 * (1 - p) + shape.y2 * p
	            ];
	        };
	        return Line;
	    }(Path));
	    Line.prototype.type = 'line';
	
	    var out = [];
	    var BezierCurveShape = (function () {
	        function BezierCurveShape() {
	            this.x1 = 0;
	            this.y1 = 0;
	            this.x2 = 0;
	            this.y2 = 0;
	            this.cpx1 = 0;
	            this.cpy1 = 0;
	            this.percent = 1;
	        }
	        return BezierCurveShape;
	    }());
	    function someVectorAt(shape, t, isTangent) {
	        var cpx2 = shape.cpx2;
	        var cpy2 = shape.cpy2;
	        if (cpx2 != null || cpy2 != null) {
	            return [
	                (isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
	                (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
	            ];
	        }
	        else {
	            return [
	                (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t),
	                (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)
	            ];
	        }
	    }
	    var BezierCurve = (function (_super) {
	        __extends(BezierCurve, _super);
	        function BezierCurve(opts) {
	            return _super.call(this, opts) || this;
	        }
	        BezierCurve.prototype.getDefaultStyle = function () {
	            return {
	                stroke: '#000',
	                fill: null
	            };
	        };
	        BezierCurve.prototype.getDefaultShape = function () {
	            return new BezierCurveShape();
	        };
	        BezierCurve.prototype.buildPath = function (ctx, shape) {
	            var x1 = shape.x1;
	            var y1 = shape.y1;
	            var x2 = shape.x2;
	            var y2 = shape.y2;
	            var cpx1 = shape.cpx1;
	            var cpy1 = shape.cpy1;
	            var cpx2 = shape.cpx2;
	            var cpy2 = shape.cpy2;
	            var percent = shape.percent;
	            if (percent === 0) {
	                return;
	            }
	            ctx.moveTo(x1, y1);
	            if (cpx2 == null || cpy2 == null) {
	                if (percent < 1) {
	                    quadraticSubdivide(x1, cpx1, x2, percent, out);
	                    cpx1 = out[1];
	                    x2 = out[2];
	                    quadraticSubdivide(y1, cpy1, y2, percent, out);
	                    cpy1 = out[1];
	                    y2 = out[2];
	                }
	                ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
	            }
	            else {
	                if (percent < 1) {
	                    cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
	                    cpx1 = out[1];
	                    cpx2 = out[2];
	                    x2 = out[3];
	                    cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
	                    cpy1 = out[1];
	                    cpy2 = out[2];
	                    y2 = out[3];
	                }
	                ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
	            }
	        };
	        BezierCurve.prototype.pointAt = function (t) {
	            return someVectorAt(this.shape, t, false);
	        };
	        BezierCurve.prototype.tangentAt = function (t) {
	            var p = someVectorAt(this.shape, t, true);
	            return normalize(p, p);
	        };
	        return BezierCurve;
	    }(Path));
	    BezierCurve.prototype.type = 'bezier-curve';
	
	    var ArcShape = (function () {
	        function ArcShape() {
	            this.cx = 0;
	            this.cy = 0;
	            this.r = 0;
	            this.startAngle = 0;
	            this.endAngle = Math.PI * 2;
	            this.clockwise = true;
	        }
	        return ArcShape;
	    }());
	    var Arc = (function (_super) {
	        __extends(Arc, _super);
	        function Arc(opts) {
	            return _super.call(this, opts) || this;
	        }
	        Arc.prototype.getDefaultStyle = function () {
	            return {
	                stroke: '#000',
	                fill: null
	            };
	        };
	        Arc.prototype.getDefaultShape = function () {
	            return new ArcShape();
	        };
	        Arc.prototype.buildPath = function (ctx, shape) {
	            var x = shape.cx;
	            var y = shape.cy;
	            var r = Math.max(shape.r, 0);
	            var startAngle = shape.startAngle;
	            var endAngle = shape.endAngle;
	            var clockwise = shape.clockwise;
	            var unitX = Math.cos(startAngle);
	            var unitY = Math.sin(startAngle);
	            ctx.moveTo(unitX * r + x, unitY * r + y);
	            ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	        };
	        return Arc;
	    }(Path));
	    Arc.prototype.type = 'arc';
	
	    var CompoundPath = (function (_super) {
	        __extends(CompoundPath, _super);
	        function CompoundPath() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.type = 'compound';
	            return _this;
	        }
	        CompoundPath.prototype._updatePathDirty = function () {
	            var paths = this.shape.paths;
	            var dirtyPath = this.shapeChanged();
	            for (var i = 0; i < paths.length; i++) {
	                dirtyPath = dirtyPath || paths[i].shapeChanged();
	            }
	            if (dirtyPath) {
	                this.dirtyShape();
	            }
	        };
	        CompoundPath.prototype.beforeBrush = function () {
	            this._updatePathDirty();
	            var paths = this.shape.paths || [];
	            var scale = this.getGlobalScale();
	            for (var i = 0; i < paths.length; i++) {
	                if (!paths[i].path) {
	                    paths[i].createPathProxy();
	                }
	                paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
	            }
	        };
	        CompoundPath.prototype.buildPath = function (ctx, shape) {
	            var paths = shape.paths || [];
	            for (var i = 0; i < paths.length; i++) {
	                paths[i].buildPath(ctx, paths[i].shape, true);
	            }
	        };
	        CompoundPath.prototype.afterBrush = function () {
	            var paths = this.shape.paths || [];
	            for (var i = 0; i < paths.length; i++) {
	                paths[i].pathUpdated();
	            }
	        };
	        CompoundPath.prototype.getBoundingRect = function () {
	            this._updatePathDirty.call(this);
	            return Path.prototype.getBoundingRect.call(this);
	        };
	        return CompoundPath;
	    }(Path));
	
	    var Gradient = (function () {
	        function Gradient(colorStops) {
	            this.colorStops = colorStops || [];
	        }
	        Gradient.prototype.addColorStop = function (offset, color) {
	            this.colorStops.push({
	                offset: offset,
	                color: color
	            });
	        };
	        return Gradient;
	    }());
	
	    var LinearGradient = (function (_super) {
	        __extends(LinearGradient, _super);
	        function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
	            var _this = _super.call(this, colorStops) || this;
	            _this.x = x == null ? 0 : x;
	            _this.y = y == null ? 0 : y;
	            _this.x2 = x2 == null ? 1 : x2;
	            _this.y2 = y2 == null ? 0 : y2;
	            _this.type = 'linear';
	            _this.global = globalCoord || false;
	            return _this;
	        }
	        return LinearGradient;
	    }(Gradient));
	
	    var RadialGradient = (function (_super) {
	        __extends(RadialGradient, _super);
	        function RadialGradient(x, y, r, colorStops, globalCoord) {
	            var _this = _super.call(this, colorStops) || this;
	            _this.x = x == null ? 0.5 : x;
	            _this.y = y == null ? 0.5 : y;
	            _this.r = r == null ? 0.5 : r;
	            _this.type = 'radial';
	            _this.global = globalCoord || false;
	            return _this;
	        }
	        return RadialGradient;
	    }(Gradient));
	
	    var extent = [0, 0];
	    var extent2 = [0, 0];
	    var minTv$1 = new Point();
	    var maxTv$1 = new Point();
	    var OrientedBoundingRect = (function () {
	        function OrientedBoundingRect(rect, transform) {
	            this._corners = [];
	            this._axes = [];
	            this._origin = [0, 0];
	            for (var i = 0; i < 4; i++) {
	                this._corners[i] = new Point();
	            }
	            for (var i = 0; i < 2; i++) {
	                this._axes[i] = new Point();
	            }
	            if (rect) {
	                this.fromBoundingRect(rect, transform);
	            }
	        }
	        OrientedBoundingRect.prototype.fromBoundingRect = function (rect, transform) {
	            var corners = this._corners;
	            var axes = this._axes;
	            var x = rect.x;
	            var y = rect.y;
	            var x2 = x + rect.width;
	            var y2 = y + rect.height;
	            corners[0].set(x, y);
	            corners[1].set(x2, y);
	            corners[2].set(x2, y2);
	            corners[3].set(x, y2);
	            if (transform) {
	                for (var i = 0; i < 4; i++) {
	                    corners[i].transform(transform);
	                }
	            }
	            Point.sub(axes[0], corners[1], corners[0]);
	            Point.sub(axes[1], corners[3], corners[0]);
	            axes[0].normalize();
	            axes[1].normalize();
	            for (var i = 0; i < 2; i++) {
	                this._origin[i] = axes[i].dot(corners[0]);
	            }
	        };
	        OrientedBoundingRect.prototype.intersect = function (other, mtv) {
	            var overlapped = true;
	            var noMtv = !mtv;
	            minTv$1.set(Infinity, Infinity);
	            maxTv$1.set(0, 0);
	            if (!this._intersectCheckOneSide(this, other, minTv$1, maxTv$1, noMtv, 1)) {
	                overlapped = false;
	                if (noMtv) {
	                    return overlapped;
	                }
	            }
	            if (!this._intersectCheckOneSide(other, this, minTv$1, maxTv$1, noMtv, -1)) {
	                overlapped = false;
	                if (noMtv) {
	                    return overlapped;
	                }
	            }
	            if (!noMtv) {
	                Point.copy(mtv, overlapped ? minTv$1 : maxTv$1);
	            }
	            return overlapped;
	        };
	        OrientedBoundingRect.prototype._intersectCheckOneSide = function (self, other, minTv, maxTv, noMtv, inverse) {
	            var overlapped = true;
	            for (var i = 0; i < 2; i++) {
	                var axis = this._axes[i];
	                this._getProjMinMaxOnAxis(i, self._corners, extent);
	                this._getProjMinMaxOnAxis(i, other._corners, extent2);
	                if (extent[1] < extent2[0] || extent[0] > extent2[1]) {
	                    overlapped = false;
	                    if (noMtv) {
	                        return overlapped;
	                    }
	                    var dist0 = Math.abs(extent2[0] - extent[1]);
	                    var dist1 = Math.abs(extent[0] - extent2[1]);
	                    if (Math.min(dist0, dist1) > maxTv.len()) {
	                        if (dist0 < dist1) {
	                            Point.scale(maxTv, axis, -dist0 * inverse);
	                        }
	                        else {
	                            Point.scale(maxTv, axis, dist1 * inverse);
	                        }
	                    }
	                }
	                else if (minTv) {
	                    var dist0 = Math.abs(extent2[0] - extent[1]);
	                    var dist1 = Math.abs(extent[0] - extent2[1]);
	                    if (Math.min(dist0, dist1) < minTv.len()) {
	                        if (dist0 < dist1) {
	                            Point.scale(minTv, axis, dist0 * inverse);
	                        }
	                        else {
	                            Point.scale(minTv, axis, -dist1 * inverse);
	                        }
	                    }
	                }
	            }
	            return overlapped;
	        };
	        OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function (dim, corners, out) {
	            var axis = this._axes[dim];
	            var origin = this._origin;
	            var proj = corners[0].dot(axis) + origin[dim];
	            var min = proj;
	            var max = proj;
	            for (var i = 1; i < corners.length; i++) {
	                var proj_1 = corners[i].dot(axis) + origin[dim];
	                min = Math.min(proj_1, min);
	                max = Math.max(proj_1, max);
	            }
	            out[0] = min;
	            out[1] = max;
	        };
	        return OrientedBoundingRect;
	    }());
	
	    var m = [];
	    var IncrementalDisplayable = (function (_super) {
	        __extends(IncrementalDisplayable, _super);
	        function IncrementalDisplayable() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.notClear = true;
	            _this.incremental = true;
	            _this._displayables = [];
	            _this._temporaryDisplayables = [];
	            _this._cursor = 0;
	            return _this;
	        }
	        IncrementalDisplayable.prototype.traverse = function (cb, context) {
	            cb.call(context, this);
	        };
	        IncrementalDisplayable.prototype.useStyle = function () {
	            this.style = {};
	        };
	        IncrementalDisplayable.prototype.getCursor = function () {
	            return this._cursor;
	        };
	        IncrementalDisplayable.prototype.innerAfterBrush = function () {
	            this._cursor = this._displayables.length;
	        };
	        IncrementalDisplayable.prototype.clearDisplaybles = function () {
	            this._displayables = [];
	            this._temporaryDisplayables = [];
	            this._cursor = 0;
	            this.markRedraw();
	            this.notClear = false;
	        };
	        IncrementalDisplayable.prototype.clearTemporalDisplayables = function () {
	            this._temporaryDisplayables = [];
	        };
	        IncrementalDisplayable.prototype.addDisplayable = function (displayable, notPersistent) {
	            if (notPersistent) {
	                this._temporaryDisplayables.push(displayable);
	            }
	            else {
	                this._displayables.push(displayable);
	            }
	            this.markRedraw();
	        };
	        IncrementalDisplayable.prototype.addDisplayables = function (displayables, notPersistent) {
	            notPersistent = notPersistent || false;
	            for (var i = 0; i < displayables.length; i++) {
	                this.addDisplayable(displayables[i], notPersistent);
	            }
	        };
	        IncrementalDisplayable.prototype.getDisplayables = function () {
	            return this._displayables;
	        };
	        IncrementalDisplayable.prototype.getTemporalDisplayables = function () {
	            return this._temporaryDisplayables;
	        };
	        IncrementalDisplayable.prototype.eachPendingDisplayable = function (cb) {
	            for (var i = this._cursor; i < this._displayables.length; i++) {
	                cb && cb(this._displayables[i]);
	            }
	            for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	                cb && cb(this._temporaryDisplayables[i]);
	            }
	        };
	        IncrementalDisplayable.prototype.update = function () {
	            this.updateTransform();
	            for (var i = this._cursor; i < this._displayables.length; i++) {
	                var displayable = this._displayables[i];
	                displayable.parent = this;
	                displayable.update();
	                displayable.parent = null;
	            }
	            for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	                var displayable = this._temporaryDisplayables[i];
	                displayable.parent = this;
	                displayable.update();
	                displayable.parent = null;
	            }
	        };
	        IncrementalDisplayable.prototype.getBoundingRect = function () {
	            if (!this._rect) {
	                var rect = new BoundingRect(Infinity, Infinity, -Infinity, -Infinity);
	                for (var i = 0; i < this._displayables.length; i++) {
	                    var displayable = this._displayables[i];
	                    var childRect = displayable.getBoundingRect().clone();
	                    if (displayable.needLocalTransform()) {
	                        childRect.applyTransform(displayable.getLocalTransform(m));
	                    }
	                    rect.union(childRect);
	                }
	                this._rect = rect;
	            }
	            return this._rect;
	        };
	        IncrementalDisplayable.prototype.contain = function (x, y) {
	            var localPos = this.transformCoordToLocal(x, y);
	            var rect = this.getBoundingRect();
	            if (rect.contain(localPos[0], localPos[1])) {
	                for (var i = 0; i < this._displayables.length; i++) {
	                    var displayable = this._displayables[i];
	                    if (displayable.contain(x, y)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        };
	        return IncrementalDisplayable;
	    }(Displayable));
	
	    var transitionStore = makeInner();
	    /**
	     * Return null if animation is disabled.
	     */
	
	    function getAnimationConfig(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
	    extraOpts, // TODO It's only for pictorial bar now.
	    extraDelayParams) {
	      var animationPayload; // Check if there is global animation configuration from dataZoom/resize can override the config in option.
	      // If animation is enabled. Will use this animation config in payload.
	      // If animation is disabled. Just ignore it.
	
	      if (animatableModel && animatableModel.ecModel) {
	        var updatePayload = animatableModel.ecModel.getUpdatePayload();
	        animationPayload = updatePayload && updatePayload.animation;
	      }
	
	      var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
	      var isUpdate = animationType === 'update';
	
	      if (animationEnabled) {
	        var duration = void 0;
	        var easing = void 0;
	        var delay = void 0;
	
	        if (extraOpts) {
	          duration = retrieve2(extraOpts.duration, 200);
	          easing = retrieve2(extraOpts.easing, 'cubicOut');
	          delay = 0;
	        } else {
	          duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
	          easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
	          delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
	        } // animation from payload has highest priority.
	
	
	        if (animationPayload) {
	          animationPayload.duration != null && (duration = animationPayload.duration);
	          animationPayload.easing != null && (easing = animationPayload.easing);
	          animationPayload.delay != null && (delay = animationPayload.delay);
	        }
	
	        if (isFunction(delay)) {
	          delay = delay(dataIndex, extraDelayParams);
	        }
	
	        if (isFunction(duration)) {
	          duration = duration(dataIndex);
	        }
	
	        var config = {
	          duration: duration || 0,
	          delay: delay,
	          easing: easing
	        };
	        return config;
	      } else {
	        return null;
	      }
	    }
	
	    function animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
	      var isFrom = false;
	      var removeOpt;
	
	      if (isFunction(dataIndex)) {
	        during = cb;
	        cb = dataIndex;
	        dataIndex = null;
	      } else if (isObject(dataIndex)) {
	        cb = dataIndex.cb;
	        during = dataIndex.during;
	        isFrom = dataIndex.isFrom;
	        removeOpt = dataIndex.removeOpt;
	        dataIndex = dataIndex.dataIndex;
	      }
	
	      var isRemove = animationType === 'leave';
	
	      if (!isRemove) {
	        // Must stop the remove animation.
	        el.stopAnimation('leave');
	      }
	
	      var animationConfig = getAnimationConfig(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
	
	      if (animationConfig && animationConfig.duration > 0) {
	        var duration = animationConfig.duration;
	        var animationDelay = animationConfig.delay;
	        var animationEasing = animationConfig.easing;
	        var animateConfig = {
	          duration: duration,
	          delay: animationDelay || 0,
	          easing: animationEasing,
	          done: cb,
	          force: !!cb || !!during,
	          // Set to final state in update/init animation.
	          // So the post processing based on the path shape can be done correctly.
	          setToFinal: !isRemove,
	          scope: animationType,
	          during: during
	        };
	        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
	      } else {
	        el.stopAnimation(); // If `isFrom`, the props is the "from" props.
	
	        !isFrom && el.attr(props); // Call during at least once.
	
	        during && during(1);
	        cb && cb();
	      }
	    }
	    /**
	     * Update graphic element properties with or without animation according to the
	     * configuration in series.
	     *
	     * Caution: this method will stop previous animation.
	     * So do not use this method to one element twice before
	     * animation starts, unless you know what you are doing.
	     * @example
	     *     graphic.updateProps(el, {
	     *         position: [100, 100]
	     *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
	     *     // Or
	     *     graphic.updateProps(el, {
	     *         position: [100, 100]
	     *     }, seriesModel, function () { console.log('Animation done!'); });
	     */
	
	
	    function updateProps(el, props, // TODO: TYPE AnimatableModel
	    animatableModel, dataIndex, cb, during) {
	      animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
	    }
	    /**
	     * Init graphic element properties with or without animation according to the
	     * configuration in series.
	     *
	     * Caution: this method will stop previous animation.
	     * So do not use this method to one element twice before
	     * animation starts, unless you know what you are doing.
	     */
	
	    function initProps(el, props, animatableModel, dataIndex, cb, during) {
	      animateOrSetProps('enter', el, props, animatableModel, dataIndex, cb, during);
	    }
	    /**
	     * If element is removed.
	     * It can determine if element is having remove animation.
	     */
	
	    function isElementRemoved(el) {
	      if (!el.__zr) {
	        return true;
	      }
	
	      for (var i = 0; i < el.animators.length; i++) {
	        var animator = el.animators[i];
	
	        if (animator.scope === 'leave') {
	          return true;
	        }
	      }
	
	      return false;
	    }
	    /**
	     * Remove graphic element
	     */
	
	    function removeElement(el, props, animatableModel, dataIndex, cb, during) {
	      // Don't do remove animation twice.
	      if (isElementRemoved(el)) {
	        return;
	      }
	
	      animateOrSetProps('leave', el, props, animatableModel, dataIndex, cb, during);
	    }
	
	    function fadeOutDisplayable(el, animatableModel, dataIndex, done) {
	      el.removeTextContent();
	      el.removeTextGuideLine();
	      removeElement(el, {
	        style: {
	          opacity: 0
	        }
	      }, animatableModel, dataIndex, done);
	    }
	
	    function removeElementWithFadeOut(el, animatableModel, dataIndex) {
	      function doRemove() {
	        el.parent && el.parent.remove(el);
	      } // Hide label and labelLine first
	      // TODO Also use fade out animation?
	
	
	      if (!el.isGroup) {
	        fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
	      } else {
	        el.traverse(function (disp) {
	          if (!disp.isGroup) {
	            // Can invoke doRemove multiple times.
	            fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
	          }
	        });
	      }
	    }
	    /**
	     * Save old style for style transition in universalTransition module.
	     * It's used when element will be reused in each render.
	     * For chart like map, heatmap, which will always create new element.
	     * We don't need to save this because universalTransition can get old style from the old element
	     */
	
	    function saveOldStyle(el) {
	      transitionStore(el).oldStyle = el.style;
	    }
	    function getOldStyle(el) {
	      return transitionStore(el).oldStyle;
	    }
	
	    var mathMax$4 = Math.max;
	    var mathMin$4 = Math.min;
	    var _customShapeMap = {};
	    /**
	     * Extend shape with parameters
	     */
	
	    function extendShape(opts) {
	      return Path.extend(opts);
	    }
	    var extendPathFromString = extendFromString;
	    /**
	     * Extend path
	     */
	
	    function extendPath(pathData, opts) {
	      return extendPathFromString(pathData, opts);
	    }
	    /**
	     * Register a user defined shape.
	     * The shape class can be fetched by `getShapeClass`
	     * This method will overwrite the registered shapes, including
	     * the registered built-in shapes, if using the same `name`.
	     * The shape can be used in `custom series` and
	     * `graphic component` by declaring `{type: name}`.
	     *
	     * @param name
	     * @param ShapeClass Can be generated by `extendShape`.
	     */
	
	    function registerShape(name, ShapeClass) {
	      _customShapeMap[name] = ShapeClass;
	    }
	    /**
	     * Find shape class registered by `registerShape`. Usually used in
	     * fetching user defined shape.
	     *
	     * [Caution]:
	     * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
	     * to use user registered shapes.
	     * Because the built-in shape (see `getBuiltInShape`) will be registered by
	     * `registerShape` by default. That enables users to get both built-in
	     * shapes as well as the shapes belonging to themsleves. But users can overwrite
	     * the built-in shapes by using names like 'circle', 'rect' via calling
	     * `registerShape`. So the echarts inner featrues should not fetch shapes from here
	     * in case that it is overwritten by users, except that some features, like
	     * `custom series`, `graphic component`, do it deliberately.
	     *
	     * (2) In the features like `custom series`, `graphic component`, the user input
	     * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
	     * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
	     * are reserved names, that is, if some user registers a shape named `'image'`,
	     * the shape will not be used. If we intending to add some more reserved names
	     * in feature, that might bring break changes (disable some existing user shape
	     * names). But that case probably rarely happens. So we don't make more mechanism
	     * to resolve this issue here.
	     *
	     * @param name
	     * @return The shape class. If not found, return nothing.
	     */
	
	    function getShapeClass(name) {
	      if (_customShapeMap.hasOwnProperty(name)) {
	        return _customShapeMap[name];
	      }
	    }
	    /**
	     * Create a path element from path data string
	     * @param pathData
	     * @param opts
	     * @param rect
	     * @param layout 'center' or 'cover' default to be cover
	     */
	
	    function makePath(pathData, opts, rect, layout) {
	      var path = createFromString(pathData, opts);
	
	      if (rect) {
	        if (layout === 'center') {
	          rect = centerGraphic(rect, path.getBoundingRect());
	        }
	
	        resizePath(path, rect);
	      }
	
	      return path;
	    }
	    /**
	     * Create a image element from image url
	     * @param imageUrl image url
	     * @param opts options
	     * @param rect constrain rect
	     * @param layout 'center' or 'cover'. Default to be 'cover'
	     */
	
	    function makeImage(imageUrl, rect, layout) {
	      var zrImg = new ZRImage({
	        style: {
	          image: imageUrl,
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        },
	        onload: function (img) {
	          if (layout === 'center') {
	            var boundingRect = {
	              width: img.width,
	              height: img.height
	            };
	            zrImg.setStyle(centerGraphic(rect, boundingRect));
	          }
	        }
	      });
	      return zrImg;
	    }
	    /**
	     * Get position of centered element in bounding box.
	     *
	     * @param  rect         element local bounding box
	     * @param  boundingRect constraint bounding box
	     * @return element position containing x, y, width, and height
	     */
	
	    function centerGraphic(rect, boundingRect) {
	      // Set rect to center, keep width / height ratio.
	      var aspect = boundingRect.width / boundingRect.height;
	      var width = rect.height * aspect;
	      var height;
	
	      if (width <= rect.width) {
	        height = rect.height;
	      } else {
	        width = rect.width;
	        height = width / aspect;
	      }
	
	      var cx = rect.x + rect.width / 2;
	      var cy = rect.y + rect.height / 2;
	      return {
	        x: cx - width / 2,
	        y: cy - height / 2,
	        width: width,
	        height: height
	      };
	    }
	
	    var mergePath$1 = mergePath;
	    /**
	     * Resize a path to fit the rect
	     * @param path
	     * @param rect
	     */
	
	    function resizePath(path, rect) {
	      if (!path.applyTransform) {
	        return;
	      }
	
	      var pathRect = path.getBoundingRect();
	      var m = pathRect.calculateTransform(rect);
	      path.applyTransform(m);
	    }
	    /**
	     * Sub pixel optimize line for canvas
	     */
	
	    function subPixelOptimizeLine$1(shape, lineWidth) {
	      subPixelOptimizeLine(shape, shape, {
	        lineWidth: lineWidth
	      });
	      return shape;
	    }
	    /**
	     * Sub pixel optimize rect for canvas
	     */
	
	    function subPixelOptimizeRect$1(param) {
	      subPixelOptimizeRect(param.shape, param.shape, param.style);
	      return param;
	    }
	    /**
	     * Sub pixel optimize for canvas
	     *
	     * @param position Coordinate, such as x, y
	     * @param lineWidth Should be nonnegative integer.
	     * @param positiveOrNegative Default false (negative).
	     * @return Optimized position.
	     */
	
	    var subPixelOptimize$1 = subPixelOptimize;
	    /**
	     * Get transform matrix of target (param target),
	     * in coordinate of its ancestor (param ancestor)
	     *
	     * @param target
	     * @param [ancestor]
	     */
	
	    function getTransform(target, ancestor) {
	      var mat = identity([]);
	
	      while (target && target !== ancestor) {
	        mul$1(mat, target.getLocalTransform(), mat);
	        target = target.parent;
	      }
	
	      return mat;
	    }
	    /**
	     * Apply transform to an vertex.
	     * @param target [x, y]
	     * @param transform Can be:
	     *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
	     *      + {position, rotation, scale}, the same as `zrender/Transformable`.
	     * @param invert Whether use invert matrix.
	     * @return [x, y]
	     */
	
	    function applyTransform$1(target, transform, invert$1) {
	      if (transform && !isArrayLike(transform)) {
	        transform = Transformable.getLocalTransform(transform);
	      }
	
	      if (invert$1) {
	        transform = invert([], transform);
	      }
	
	      return applyTransform([], target, transform);
	    }
	    /**
	     * @param direction 'left' 'right' 'top' 'bottom'
	     * @param transform Transform matrix: like [1, 0, 0, 1, 0, 0]
	     * @param invert Whether use invert matrix.
	     * @return Transformed direction. 'left' 'right' 'top' 'bottom'
	     */
	
	    function transformDirection(direction, transform, invert) {
	      // Pick a base, ensure that transform result will not be (0, 0).
	      var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
	      var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
	      var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
	      vertex = applyTransform$1(vertex, transform, invert);
	      return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
	    }
	
	    function isNotGroup(el) {
	      return !el.isGroup;
	    }
	
	    function isPath(el) {
	      return el.shape != null;
	    }
	    /**
	     * Apply group transition animation from g1 to g2.
	     * If no animatableModel, no animation.
	     */
	
	
	    function groupTransition(g1, g2, animatableModel) {
	      if (!g1 || !g2) {
	        return;
	      }
	
	      function getElMap(g) {
	        var elMap = {};
	        g.traverse(function (el) {
	          if (isNotGroup(el) && el.anid) {
	            elMap[el.anid] = el;
	          }
	        });
	        return elMap;
	      }
	
	      function getAnimatableProps(el) {
	        var obj = {
	          x: el.x,
	          y: el.y,
	          rotation: el.rotation
	        };
	
	        if (isPath(el)) {
	          obj.shape = extend({}, el.shape);
	        }
	
	        return obj;
	      }
	
	      var elMap1 = getElMap(g1);
	      g2.traverse(function (el) {
	        if (isNotGroup(el) && el.anid) {
	          var oldEl = elMap1[el.anid];
	
	          if (oldEl) {
	            var newProp = getAnimatableProps(el);
	            el.attr(getAnimatableProps(oldEl));
	            updateProps(el, newProp, animatableModel, getECData(el).dataIndex);
	          }
	        }
	      });
	    }
	    function clipPointsByRect(points, rect) {
	      // FIXME: This way might be incorrect when graphic clipped by a corner
	      // and when element has a border.
	      return map(points, function (point) {
	        var x = point[0];
	        x = mathMax$4(x, rect.x);
	        x = mathMin$4(x, rect.x + rect.width);
	        var y = point[1];
	        y = mathMax$4(y, rect.y);
	        y = mathMin$4(y, rect.y + rect.height);
	        return [x, y];
	      });
	    }
	    /**
	     * Return a new clipped rect. If rect size are negative, return undefined.
	     */
	
	    function clipRectByRect(targetRect, rect) {
	      var x = mathMax$4(targetRect.x, rect.x);
	      var x2 = mathMin$4(targetRect.x + targetRect.width, rect.x + rect.width);
	      var y = mathMax$4(targetRect.y, rect.y);
	      var y2 = mathMin$4(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
	      // should be painted. So return undefined.
	
	      if (x2 >= x && y2 >= y) {
	        return {
	          x: x,
	          y: y,
	          width: x2 - x,
	          height: y2 - y
	        };
	      }
	    }
	    function createIcon(iconStr, // Support 'image://' or 'path://' or direct svg path.
	    opt, rect) {
	      var innerOpts = extend({
	        rectHover: true
	      }, opt);
	      var style = innerOpts.style = {
	        strokeNoScale: true
	      };
	      rect = rect || {
	        x: -1,
	        y: -1,
	        width: 2,
	        height: 2
	      };
	
	      if (iconStr) {
	        return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), defaults(style, rect), new ZRImage(innerOpts)) : makePath(iconStr.replace('path://', ''), innerOpts, rect, 'center');
	      }
	    }
	    /**
	     * Return `true` if the given line (line `a`) and the given polygon
	     * are intersect.
	     * Note that we do not count colinear as intersect here because no
	     * requirement for that. We could do that if required in future.
	     */
	
	    function linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
	      for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
	        var p = points[i];
	
	        if (lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) {
	          return true;
	        }
	
	        p2 = p;
	      }
	    }
	    /**
	     * Return `true` if the given two lines (line `a` and line `b`)
	     * are intersect.
	     * Note that we do not count colinear as intersect here because no
	     * requirement for that. We could do that if required in future.
	     */
	
	    function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
	      // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
	      var mx = a2x - a1x;
	      var my = a2y - a1y;
	      var nx = b2x - b1x;
	      var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
	      //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
	
	      var nmCrossProduct = crossProduct2d(nx, ny, mx, my);
	
	      if (nearZero(nmCrossProduct)) {
	        return false;
	      } // `vec_m` and `vec_n` are intersect iff
	      //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
	      //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
	      //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
	
	
	      var b1a1x = a1x - b1x;
	      var b1a1y = a1y - b1y;
	      var q = crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
	
	      if (q < 0 || q > 1) {
	        return false;
	      }
	
	      var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
	
	      if (p < 0 || p > 1) {
	        return false;
	      }
	
	      return true;
	    }
	    /**
	     * Cross product of 2-dimension vector.
	     */
	
	    function crossProduct2d(x1, y1, x2, y2) {
	      return x1 * y2 - x2 * y1;
	    }
	
	    function nearZero(val) {
	      return val <= 1e-6 && val >= -1e-6;
	    }
	
	    function setTooltipConfig(opt) {
	      var itemTooltipOption = opt.itemTooltipOption;
	      var componentModel = opt.componentModel;
	      var itemName = opt.itemName;
	      var itemTooltipOptionObj = isString(itemTooltipOption) ? {
	        formatter: itemTooltipOption
	      } : itemTooltipOption;
	      var mainType = componentModel.mainType;
	      var componentIndex = componentModel.componentIndex;
	      var formatterParams = {
	        componentType: mainType,
	        name: itemName,
	        $vars: ['name']
	      };
	      formatterParams[mainType + 'Index'] = componentIndex;
	      var formatterParamsExtra = opt.formatterParamsExtra;
	
	      if (formatterParamsExtra) {
	        each(keys(formatterParamsExtra), function (key) {
	          if (!hasOwn(formatterParams, key)) {
	            formatterParams[key] = formatterParamsExtra[key];
	            formatterParams.$vars.push(key);
	          }
	        });
	      }
	
	      var ecData = getECData(opt.el);
	      ecData.componentMainType = mainType;
	      ecData.componentIndex = componentIndex;
	      ecData.tooltipConfig = {
	        name: itemName,
	        option: defaults({
	          content: itemName,
	          formatterParams: formatterParams
	        }, itemTooltipOptionObj)
	      };
	    }
	
	    function traverseElement(el, cb) {
	      var stopped; // TODO
	      // Polyfill for fixing zrender group traverse don't visit it's root issue.
	
	      if (el.isGroup) {
	        stopped = cb(el);
	      }
	
	      if (!stopped) {
	        el.traverse(cb);
	      }
	    }
	
	    function traverseElements(els, cb) {
	      if (els) {
	        if (isArray(els)) {
	          for (var i = 0; i < els.length; i++) {
	            traverseElement(els[i], cb);
	          }
	        } else {
	          traverseElement(els, cb);
	        }
	      }
	    } // Register built-in shapes. These shapes might be overwritten
	    // by users, although we do not recommend that.
	
	    registerShape('circle', Circle);
	    registerShape('ellipse', Ellipse);
	    registerShape('sector', Sector);
	    registerShape('ring', Ring);
	    registerShape('polygon', Polygon);
	    registerShape('polyline', Polyline);
	    registerShape('rect', Rect);
	    registerShape('line', Line);
	    registerShape('bezierCurve', BezierCurve);
	    registerShape('arc', Arc);
	
	    var graphic = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        updateProps: updateProps,
	        initProps: initProps,
	        removeElement: removeElement,
	        removeElementWithFadeOut: removeElementWithFadeOut,
	        isElementRemoved: isElementRemoved,
	        extendShape: extendShape,
	        extendPath: extendPath,
	        registerShape: registerShape,
	        getShapeClass: getShapeClass,
	        makePath: makePath,
	        makeImage: makeImage,
	        mergePath: mergePath$1,
	        resizePath: resizePath,
	        subPixelOptimizeLine: subPixelOptimizeLine$1,
	        subPixelOptimizeRect: subPixelOptimizeRect$1,
	        subPixelOptimize: subPixelOptimize$1,
	        getTransform: getTransform,
	        applyTransform: applyTransform$1,
	        transformDirection: transformDirection,
	        groupTransition: groupTransition,
	        clipPointsByRect: clipPointsByRect,
	        clipRectByRect: clipRectByRect,
	        createIcon: createIcon,
	        linePolygonIntersect: linePolygonIntersect,
	        lineLineIntersect: lineLineIntersect,
	        setTooltipConfig: setTooltipConfig,
	        traverseElements: traverseElements,
	        Group: Group,
	        Image: ZRImage,
	        Text: ZRText,
	        Circle: Circle,
	        Ellipse: Ellipse,
	        Sector: Sector,
	        Ring: Ring,
	        Polygon: Polygon,
	        Polyline: Polyline,
	        Rect: Rect,
	        Line: Line,
	        BezierCurve: BezierCurve,
	        Arc: Arc,
	        IncrementalDisplayable: IncrementalDisplayable,
	        CompoundPath: CompoundPath,
	        LinearGradient: LinearGradient,
	        RadialGradient: RadialGradient,
	        BoundingRect: BoundingRect,
	        OrientedBoundingRect: OrientedBoundingRect,
	        Point: Point,
	        Path: Path
	    });
	
	    var EMPTY_OBJ = {};
	    function setLabelText(label, labelTexts) {
	      for (var i = 0; i < SPECIAL_STATES.length; i++) {
	        var stateName = SPECIAL_STATES[i];
	        var text = labelTexts[stateName];
	        var state = label.ensureState(stateName);
	        state.style = state.style || {};
	        state.style.text = text;
	      }
	
	      var oldStates = label.currentStates.slice();
	      label.clearStates(true);
	      label.setStyle({
	        text: labelTexts.normal
	      });
	      label.useStates(oldStates, true);
	    }
	
	    function getLabelText(opt, stateModels, interpolatedValue) {
	      var labelFetcher = opt.labelFetcher;
	      var labelDataIndex = opt.labelDataIndex;
	      var labelDimIndex = opt.labelDimIndex;
	      var normalModel = stateModels.normal;
	      var baseText;
	
	      if (labelFetcher) {
	        baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
	          interpolatedValue: interpolatedValue
	        } : null);
	      }
	
	      if (baseText == null) {
	        baseText = isFunction(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
	      }
	
	      var statesText = {
	        normal: baseText
	      };
	
	      for (var i = 0; i < SPECIAL_STATES.length; i++) {
	        var stateName = SPECIAL_STATES[i];
	        var stateModel = stateModels[stateName];
	        statesText[stateName] = retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
	      }
	
	      return statesText;
	    }
	
	    function setLabelStyle(targetEl, labelStatesModels, opt, stateSpecified // TODO specified position?
	    ) {
	      opt = opt || EMPTY_OBJ;
	      var isSetOnText = targetEl instanceof ZRText;
	      var needsCreateText = false;
	
	      for (var i = 0; i < DISPLAY_STATES.length; i++) {
	        var stateModel = labelStatesModels[DISPLAY_STATES[i]];
	
	        if (stateModel && stateModel.getShallow('show')) {
	          needsCreateText = true;
	          break;
	        }
	      }
	
	      var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
	
	      if (needsCreateText) {
	        if (!isSetOnText) {
	          // Reuse the previous
	          if (!textContent) {
	            textContent = new ZRText();
	            targetEl.setTextContent(textContent);
	          } // Use same state proxy
	
	
	          if (targetEl.stateProxy) {
	            textContent.stateProxy = targetEl.stateProxy;
	          }
	        }
	
	        var labelStatesTexts = getLabelText(opt, labelStatesModels);
	        var normalModel = labelStatesModels.normal;
	        var showNormal = !!normalModel.getShallow('show');
	        var normalStyle = createTextStyle(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
	        normalStyle.text = labelStatesTexts.normal;
	
	        if (!isSetOnText) {
	          // Always create new
	          targetEl.setTextConfig(createTextConfig(normalModel, opt, false));
	        }
	
	        for (var i = 0; i < SPECIAL_STATES.length; i++) {
	          var stateName = SPECIAL_STATES[i];
	          var stateModel = labelStatesModels[stateName];
	
	          if (stateModel) {
	            var stateObj = textContent.ensureState(stateName);
	            var stateShow = !!retrieve2(stateModel.getShallow('show'), showNormal);
	
	            if (stateShow !== showNormal) {
	              stateObj.ignore = !stateShow;
	            }
	
	            stateObj.style = createTextStyle(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
	            stateObj.style.text = labelStatesTexts[stateName];
	
	            if (!isSetOnText) {
	              var targetElEmphasisState = targetEl.ensureState(stateName);
	              targetElEmphasisState.textConfig = createTextConfig(stateModel, opt, true);
	            }
	          }
	        } // PENDING: if there is many requirements that emphasis position
	        // need to be different from normal position, we might consider
	        // auto silent is those cases.
	
	
	        textContent.silent = !!normalModel.getShallow('silent'); // Keep x and y
	
	        if (textContent.style.x != null) {
	          normalStyle.x = textContent.style.x;
	        }
	
	        if (textContent.style.y != null) {
	          normalStyle.y = textContent.style.y;
	        }
	
	        textContent.ignore = !showNormal; // Always create new style.
	
	        textContent.useStyle(normalStyle);
	        textContent.dirty();
	
	        if (opt.enableTextSetter) {
	          labelInner(textContent).setLabelText = function (interpolatedValue) {
	            var labelStatesTexts = getLabelText(opt, labelStatesModels, interpolatedValue);
	            setLabelText(textContent, labelStatesTexts);
	          };
	        }
	      } else if (textContent) {
	        // Not display rich text.
	        textContent.ignore = true;
	      }
	
	      targetEl.dirty();
	    }
	    function getLabelStatesModels(itemModel, labelName) {
	      labelName = labelName || 'label';
	      var statesModels = {
	        normal: itemModel.getModel(labelName)
	      };
	
	      for (var i = 0; i < SPECIAL_STATES.length; i++) {
	        var stateName = SPECIAL_STATES[i];
	        statesModels[stateName] = itemModel.getModel([stateName, labelName]);
	      }
	
	      return statesModels;
	    }
	    /**
	     * Set basic textStyle properties.
	     */
	
	    function createTextStyle(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
	    opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
	    ) {
	      var textStyle = {};
	      setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
	      specifiedTextStyle && extend(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	
	      return textStyle;
	    }
	    function createTextConfig(textStyleModel, opt, isNotNormal) {
	      opt = opt || {};
	      var textConfig = {};
	      var labelPosition;
	      var labelRotate = textStyleModel.getShallow('rotate');
	      var labelDistance = retrieve2(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
	      var labelOffset = textStyleModel.getShallow('offset');
	      labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
	      // in bar series, and magric type should be considered.
	
	      labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
	
	      if (labelPosition != null) {
	        textConfig.position = labelPosition;
	      }
	
	      if (labelOffset != null) {
	        textConfig.offset = labelOffset;
	      }
	
	      if (labelRotate != null) {
	        labelRotate *= Math.PI / 180;
	        textConfig.rotation = labelRotate;
	      }
	
	      if (labelDistance != null) {
	        textConfig.distance = labelDistance;
	      } // fill and auto is determined by the color of path fill if it's not specified by developers.
	
	
	      textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
	      return textConfig;
	    }
	    /**
	     * The uniform entry of set text style, that is, retrieve style definitions
	     * from `model` and set to `textStyle` object.
	     *
	     * Never in merge mode, but in overwrite mode, that is, all of the text style
	     * properties will be set. (Consider the states of normal and emphasis and
	     * default value can be adopted, merge would make the logic too complicated
	     * to manage.)
	     */
	
	    function setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
	      // Consider there will be abnormal when merge hover style to normal style if given default value.
	      opt = opt || EMPTY_OBJ;
	      var ecModel = textStyleModel.ecModel;
	      var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
	      // {
	      //     data: [{
	      //         value: 12,
	      //         label: {
	      //             rich: {
	      //                 // no 'a' here but using parent 'a'.
	      //             }
	      //         }
	      //     }],
	      //     rich: {
	      //         a: { ... }
	      //     }
	      // }
	
	      var richItemNames = getRichItemNames(textStyleModel);
	      var richResult;
	
	      if (richItemNames) {
	        richResult = {};
	
	        for (var name_1 in richItemNames) {
	          if (richItemNames.hasOwnProperty(name_1)) {
	            // Cascade is supported in rich.
	            var richTextStyle = textStyleModel.getModel(['rich', name_1]); // In rich, never `disableBox`.
	            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
	            // the default color `'blue'` will not be adopted if no color declared in `rich`.
	            // That might confuses users. So probably we should put `textStyleModel` as the
	            // root ancestor of the `richTextStyle`. But that would be a break change.
	
	            setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
	          }
	        }
	      }
	
	      if (richResult) {
	        textStyle.rich = richResult;
	      }
	
	      var overflow = textStyleModel.get('overflow');
	
	      if (overflow) {
	        textStyle.overflow = overflow;
	      }
	
	      var margin = textStyleModel.get('minMargin');
	
	      if (margin != null) {
	        textStyle.margin = margin;
	      }
	
	      setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
	    } // Consider case:
	    // {
	    //     data: [{
	    //         value: 12,
	    //         label: {
	    //             rich: {
	    //                 // no 'a' here but using parent 'a'.
	    //             }
	    //         }
	    //     }],
	    //     rich: {
	    //         a: { ... }
	    //     }
	    // }
	    // TODO TextStyleModel
	
	
	    function getRichItemNames(textStyleModel) {
	      // Use object to remove duplicated names.
	      var richItemNameMap;
	
	      while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
	        var rich = (textStyleModel.option || EMPTY_OBJ).rich;
	
	        if (rich) {
	          richItemNameMap = richItemNameMap || {};
	          var richKeys = keys(rich);
	
	          for (var i = 0; i < richKeys.length; i++) {
	            var richKey = richKeys[i];
	            richItemNameMap[richKey] = 1;
	          }
	        }
	
	        textStyleModel = textStyleModel.parentModel;
	      }
	
	      return richItemNameMap;
	    }
	
	    var TEXT_PROPS_WITH_GLOBAL = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY'];
	    var TEXT_PROPS_SELF = ['align', 'lineHeight', 'width', 'height', 'tag', 'verticalAlign', 'ellipsis'];
	    var TEXT_PROPS_BOX = ['padding', 'borderWidth', 'borderRadius', 'borderDashOffset', 'backgroundColor', 'borderColor', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
	
	    function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
	      // In merge mode, default value should not be given.
	      globalTextStyle = !isNotNormal && globalTextStyle || EMPTY_OBJ;
	      var inheritColor = opt && opt.inheritColor;
	      var fillColor = textStyleModel.getShallow('color');
	      var strokeColor = textStyleModel.getShallow('textBorderColor');
	      var opacity = retrieve2(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
	
	      if (fillColor === 'inherit' || fillColor === 'auto') {
	        if (true) {
	          if (fillColor === 'auto') {
	            deprecateReplaceLog('color: \'auto\'', 'color: \'inherit\'');
	          }
	        }
	
	        if (inheritColor) {
	          fillColor = inheritColor;
	        } else {
	          fillColor = null;
	        }
	      }
	
	      if (strokeColor === 'inherit' || strokeColor === 'auto') {
	        if (true) {
	          if (strokeColor === 'auto') {
	            deprecateReplaceLog('color: \'auto\'', 'color: \'inherit\'');
	          }
	        }
	
	        if (inheritColor) {
	          strokeColor = inheritColor;
	        } else {
	          strokeColor = null;
	        }
	      }
	
	      if (!isAttached) {
	        // Only use default global textStyle.color if text is individual.
	        // Otherwise it will use the strategy of attached text color because text may be on a path.
	        fillColor = fillColor || globalTextStyle.color;
	        strokeColor = strokeColor || globalTextStyle.textBorderColor;
	      }
	
	      if (fillColor != null) {
	        textStyle.fill = fillColor;
	      }
	
	      if (strokeColor != null) {
	        textStyle.stroke = strokeColor;
	      }
	
	      var textBorderWidth = retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
	
	      if (textBorderWidth != null) {
	        textStyle.lineWidth = textBorderWidth;
	      }
	
	      var textBorderType = retrieve2(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
	
	      if (textBorderType != null) {
	        textStyle.lineDash = textBorderType;
	      }
	
	      var textBorderDashOffset = retrieve2(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
	
	      if (textBorderDashOffset != null) {
	        textStyle.lineDashOffset = textBorderDashOffset;
	      }
	
	      if (!isNotNormal && opacity == null && !inRich) {
	        opacity = opt && opt.defaultOpacity;
	      }
	
	      if (opacity != null) {
	        textStyle.opacity = opacity;
	      } // TODO
	
	
	      if (!isNotNormal && !isAttached) {
	        // Set default finally.
	        if (textStyle.fill == null && opt.inheritColor) {
	          textStyle.fill = opt.inheritColor;
	        }
	      } // Do not use `getFont` here, because merge should be supported, where
	      // part of these properties may be changed in emphasis style, and the
	      // others should remain their original value got from normal style.
	
	
	      for (var i = 0; i < TEXT_PROPS_WITH_GLOBAL.length; i++) {
	        var key = TEXT_PROPS_WITH_GLOBAL[i];
	        var val = retrieve2(textStyleModel.getShallow(key), globalTextStyle[key]);
	
	        if (val != null) {
	          textStyle[key] = val;
	        }
	      }
	
	      for (var i = 0; i < TEXT_PROPS_SELF.length; i++) {
	        var key = TEXT_PROPS_SELF[i];
	        var val = textStyleModel.getShallow(key);
	
	        if (val != null) {
	          textStyle[key] = val;
	        }
	      }
	
	      if (textStyle.verticalAlign == null) {
	        var baseline = textStyleModel.getShallow('baseline');
	
	        if (baseline != null) {
	          textStyle.verticalAlign = baseline;
	        }
	      }
	
	      if (!isBlock || !opt.disableBox) {
	        for (var i = 0; i < TEXT_PROPS_BOX.length; i++) {
	          var key = TEXT_PROPS_BOX[i];
	          var val = textStyleModel.getShallow(key);
	
	          if (val != null) {
	            textStyle[key] = val;
	          }
	        }
	
	        var borderType = textStyleModel.getShallow('borderType');
	
	        if (borderType != null) {
	          textStyle.borderDash = borderType;
	        }
	
	        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) {
	          if (true) {
	            if (textStyle.backgroundColor === 'auto') {
	              deprecateReplaceLog('backgroundColor: \'auto\'', 'backgroundColor: \'inherit\'');
	            }
	          }
	
	          textStyle.backgroundColor = inheritColor;
	        }
	
	        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) {
	          if (true) {
	            if (textStyle.borderColor === 'auto') {
	              deprecateReplaceLog('borderColor: \'auto\'', 'borderColor: \'inherit\'');
	            }
	          }
	
	          textStyle.borderColor = inheritColor;
	        }
	      }
	    }
	
	    function getFont(opt, ecModel) {
	      var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
	      return trim([// FIXME in node-canvas fontWeight is before fontStyle
	      opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
	    }
	    var labelInner = makeInner();
	    function setLabelValueAnimation(label, labelStatesModels, value, getDefaultText) {
	      if (!label) {
	        return;
	      }
	
	      var obj = labelInner(label);
	      obj.prevValue = obj.value;
	      obj.value = value;
	      var normalLabelModel = labelStatesModels.normal;
	      obj.valueAnimation = normalLabelModel.get('valueAnimation');
	
	      if (obj.valueAnimation) {
	        obj.precision = normalLabelModel.get('precision');
	        obj.defaultInterpolatedText = getDefaultText;
	        obj.statesModels = labelStatesModels;
	      }
	    }
	    function animateLabelValue(textEl, dataIndex, data, animatableModel, labelFetcher) {
	      var labelInnerStore = labelInner(textEl);
	
	      if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) {
	        // Value not changed, no new label animation
	        return;
	      }
	
	      var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText; // Consider the case that being animating, do not use the `obj.value`,
	      // Otherwise it will jump to the `obj.value` when this new animation started.
	
	      var currValue = retrieve2(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
	      var targetValue = labelInnerStore.value;
	
	      function during(percent) {
	        var interpolated = interpolateRawValues(data, labelInnerStore.precision, currValue, targetValue, percent);
	        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
	        var labelText = getLabelText({
	          labelDataIndex: dataIndex,
	          labelFetcher: labelFetcher,
	          defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
	        }, labelInnerStore.statesModels, interpolated);
	        setLabelText(textEl, labelText);
	      }
	
	      textEl.percent = 0;
	      (labelInnerStore.prevValue == null ? initProps : updateProps)(textEl, {
	        // percent is used to prevent animation from being aborted #15916
	        percent: 1
	      }, animatableModel, dataIndex, null, during);
	    }
	
	    var PATH_COLOR = ['textStyle', 'color'];
	    var textStyleParams = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'padding', 'lineHeight', 'rich', 'width', 'height', 'overflow']; // TODO Performance improvement?
	
	    var tmpText = new ZRText();
	
	    var TextStyleMixin =
	    /** @class */
	    function () {
	      function TextStyleMixin() {}
	      /**
	       * Get color property or get color from option.textStyle.color
	       */
	      // TODO Callback
	
	
	      TextStyleMixin.prototype.getTextColor = function (isEmphasis) {
	        var ecModel = this.ecModel;
	        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
	      };
	      /**
	       * Create font string from fontStyle, fontWeight, fontSize, fontFamily
	       * @return {string}
	       */
	
	
	      TextStyleMixin.prototype.getFont = function () {
	        return getFont({
	          fontStyle: this.getShallow('fontStyle'),
	          fontWeight: this.getShallow('fontWeight'),
	          fontSize: this.getShallow('fontSize'),
	          fontFamily: this.getShallow('fontFamily')
	        }, this.ecModel);
	      };
	
	      TextStyleMixin.prototype.getTextRect = function (text) {
	        var style = {
	          text: text,
	          verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline')
	        };
	
	        for (var i = 0; i < textStyleParams.length; i++) {
	          style[textStyleParams[i]] = this.getShallow(textStyleParams[i]);
	        }
	
	        tmpText.useStyle(style);
	        tmpText.update();
	        return tmpText.getBoundingRect();
	      };
	
	      return TextStyleMixin;
	    }();
	
	    var LINE_STYLE_KEY_MAP = [['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['lineDash', 'type'], ['lineDashOffset', 'dashOffset'], ['lineCap', 'cap'], ['lineJoin', 'join'], ['miterLimit'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
	    // So do not transfer decal directly.
	    ];
	    var getLineStyle = makeStyleMapper(LINE_STYLE_KEY_MAP);
	
	    var LineStyleMixin =
	    /** @class */
	    function () {
	      function LineStyleMixin() {}
	
	      LineStyleMixin.prototype.getLineStyle = function (excludes) {
	        return getLineStyle(this, excludes);
	      };
	
	      return LineStyleMixin;
	    }();
	
	    var ITEM_STYLE_KEY_MAP = [['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['lineDash', 'borderType'], ['lineDashOffset', 'borderDashOffset'], ['lineCap', 'borderCap'], ['lineJoin', 'borderJoin'], ['miterLimit', 'borderMiterLimit'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
	    // So do not transfer decal directly.
	    ];
	    var getItemStyle = makeStyleMapper(ITEM_STYLE_KEY_MAP);
	
	    var ItemStyleMixin =
	    /** @class */
	    function () {
	      function ItemStyleMixin() {}
	
	      ItemStyleMixin.prototype.getItemStyle = function (excludes, includes) {
	        return getItemStyle(this, excludes, includes);
	      };
	
	      return ItemStyleMixin;
	    }();
	
	    var Model =
	    /** @class */
	    function () {
	      function Model(option, parentModel, ecModel) {
	        this.parentModel = parentModel;
	        this.ecModel = ecModel;
	        this.option = option; // Simple optimization
	        // if (this.init) {
	        //     if (arguments.length <= 4) {
	        //         this.init(option, parentModel, ecModel, extraOpt);
	        //     }
	        //     else {
	        //         this.init.apply(this, arguments);
	        //     }
	        // }
	      }
	
	      Model.prototype.init = function (option, parentModel, ecModel) {
	        var rest = [];
	
	        for (var _i = 3; _i < arguments.length; _i++) {
	          rest[_i - 3] = arguments[_i];
	        }
	      };
	      /**
	       * Merge the input option to me.
	       */
	
	
	      Model.prototype.mergeOption = function (option, ecModel) {
	        merge(this.option, option, true);
	      }; // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
	      // TODO: TYPE strict key check?
	      // get(path: string | string[], ignoreParent?: boolean): ModelOption;
	
	
	      Model.prototype.get = function (path, ignoreParent) {
	        if (path == null) {
	          return this.option;
	        }
	
	        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
	      };
	
	      Model.prototype.getShallow = function (key, ignoreParent) {
	        var option = this.option;
	        var val = option == null ? option : option[key];
	
	        if (val == null && !ignoreParent) {
	          var parentModel = this.parentModel;
	
	          if (parentModel) {
	            // FIXME:TS do not know how to make it works
	            val = parentModel.getShallow(key);
	          }
	        }
	
	        return val;
	      }; // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
	      // getModel(path: string | string[], parentModel?: Model): Model;
	      // TODO 'a.b.c' is deprecated
	
	
	      Model.prototype.getModel = function (path, parentModel) {
	        var hasPath = path != null;
	        var pathFinal = hasPath ? this.parsePath(path) : null;
	        var obj = hasPath ? this._doGet(pathFinal) : this.option;
	        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
	        return new Model(obj, parentModel, this.ecModel);
	      };
	      /**
	       * If model has option
	       */
	
	
	      Model.prototype.isEmpty = function () {
	        return this.option == null;
	      };
	
	      Model.prototype.restoreData = function () {}; // Pending
	
	
	      Model.prototype.clone = function () {
	        var Ctor = this.constructor;
	        return new Ctor(clone(this.option));
	      }; // setReadOnly(properties): void {
	      // clazzUtil.setReadOnly(this, properties);
	      // }
	      // If path is null/undefined, return null/undefined.
	
	
	      Model.prototype.parsePath = function (path) {
	        if (typeof path === 'string') {
	          return path.split('.');
	        }
	
	        return path;
	      }; // Resolve path for parent. Perhaps useful when parent use a different property.
	      // Default to be a identity resolver.
	      // Can be modified to a different resolver.
	
	
	      Model.prototype.resolveParentPath = function (path) {
	        return path;
	      }; // FIXME:TS check whether put this method here
	
	
	      Model.prototype.isAnimationEnabled = function () {
	        if (!env.node && this.option) {
	          if (this.option.animation != null) {
	            return !!this.option.animation;
	          } else if (this.parentModel) {
	            return this.parentModel.isAnimationEnabled();
	          }
	        }
	      };
	
	      Model.prototype._doGet = function (pathArr, parentModel) {
	        var obj = this.option;
	
	        if (!pathArr) {
	          return obj;
	        }
	
	        for (var i = 0; i < pathArr.length; i++) {
	          // Ignore empty
	          if (!pathArr[i]) {
	            continue;
	          } // obj could be number/string/... (like 0)
	
	
	          obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
	
	          if (obj == null) {
	            break;
	          }
	        }
	
	        if (obj == null && parentModel) {
	          obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
	        }
	
	        return obj;
	      };
	
	      return Model;
	    }();
	
	    enableClassExtend(Model);
	    enableClassCheck(Model);
	    mixin(Model, LineStyleMixin);
	    mixin(Model, ItemStyleMixin);
	    mixin(Model, AreaStyleMixin);
	    mixin(Model, TextStyleMixin);
	
	    var base = Math.round(Math.random() * 10);
	    /**
	     * @public
	     * @param {string} type
	     * @return {string}
	     */
	
	    function getUID(type) {
	      // Considering the case of crossing js context,
	      // use Math.random to make id as unique as possible.
	      return [type || '', base++].join('_');
	    }
	    /**
	     * Implements `SubTypeDefaulterManager` for `target`.
	     */
	
	    function enableSubTypeDefaulter(target) {
	      var subTypeDefaulters = {};
	
	      target.registerSubTypeDefaulter = function (componentType, defaulter) {
	        var componentTypeInfo = parseClassType(componentType);
	        subTypeDefaulters[componentTypeInfo.main] = defaulter;
	      };
	
	      target.determineSubType = function (componentType, option) {
	        var type = option.type;
	
	        if (!type) {
	          var componentTypeMain = parseClassType(componentType).main;
	
	          if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
	            type = subTypeDefaulters[componentTypeMain](option);
	          }
	        }
	
	        return type;
	      };
	    }
	    /**
	     * Implements `TopologicalTravelable<any>` for `entity`.
	     *
	     * Topological travel on Activity Network (Activity On Vertices).
	     * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
	     * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
	     * If there is circular dependencey, Error will be thrown.
	     */
	
	    function enableTopologicalTravel(entity, dependencyGetter) {
	      /**
	       * @param targetNameList Target Component type list.
	       *                       Can be ['aa', 'bb', 'aa.xx']
	       * @param fullNameList By which we can build dependency graph.
	       * @param callback Params: componentType, dependencies.
	       * @param context Scope of callback.
	       */
	      entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
	        if (!targetNameList.length) {
	          return;
	        }
	
	        var result = makeDepndencyGraph(fullNameList);
	        var graph = result.graph;
	        var noEntryList = result.noEntryList;
	        var targetNameSet = {};
	        each(targetNameList, function (name) {
	          targetNameSet[name] = true;
	        });
	
	        while (noEntryList.length) {
	          var currComponentType = noEntryList.pop();
	          var currVertex = graph[currComponentType];
	          var isInTargetNameSet = !!targetNameSet[currComponentType];
	
	          if (isInTargetNameSet) {
	            callback.call(context, currComponentType, currVertex.originalDeps.slice());
	            delete targetNameSet[currComponentType];
	          }
	
	          each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
	        }
	
	        each(targetNameSet, function () {
	          var errMsg = '';
	
	          if (true) {
	            errMsg = makePrintable('Circular dependency may exists: ', targetNameSet, targetNameList, fullNameList);
	          }
	
	          throw new Error(errMsg);
	        });
	
	        function removeEdge(succComponentType) {
	          graph[succComponentType].entryCount--;
	
	          if (graph[succComponentType].entryCount === 0) {
	            noEntryList.push(succComponentType);
	          }
	        } // Consider this case: legend depends on series, and we call
	        // chart.setOption({series: [...]}), where only series is in option.
	        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
	        // not be called, but only sereis.mergeOption is called. Thus legend
	        // have no chance to update its local record about series (like which
	        // name of series is available in legend).
	
	
	        function removeEdgeAndAdd(succComponentType) {
	          targetNameSet[succComponentType] = true;
	          removeEdge(succComponentType);
	        }
	      };
	
	      function makeDepndencyGraph(fullNameList) {
	        var graph = {};
	        var noEntryList = [];
	        each(fullNameList, function (name) {
	          var thisItem = createDependencyGraphItem(graph, name);
	          var originalDeps = thisItem.originalDeps = dependencyGetter(name);
	          var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
	          thisItem.entryCount = availableDeps.length;
	
	          if (thisItem.entryCount === 0) {
	            noEntryList.push(name);
	          }
	
	          each(availableDeps, function (dependentName) {
	            if (indexOf(thisItem.predecessor, dependentName) < 0) {
	              thisItem.predecessor.push(dependentName);
	            }
	
	            var thatItem = createDependencyGraphItem(graph, dependentName);
	
	            if (indexOf(thatItem.successor, dependentName) < 0) {
	              thatItem.successor.push(name);
	            }
	          });
	        });
	        return {
	          graph: graph,
	          noEntryList: noEntryList
	        };
	      }
	
	      function createDependencyGraphItem(graph, name) {
	        if (!graph[name]) {
	          graph[name] = {
	            predecessor: [],
	            successor: []
	          };
	        }
	
	        return graph[name];
	      }
	
	      function getAvailableDependencies(originalDeps, fullNameList) {
	        var availableDeps = [];
	        each(originalDeps, function (dep) {
	          indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
	        });
	        return availableDeps;
	      }
	    }
	    function inheritDefaultOption(superOption, subOption) {
	      // See also `model/Component.ts#getDefaultOption`
	      return merge(merge({}, superOption, true), subOption, true);
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	     * Licensed to the Apache Software Foundation (ASF) under one
	     * or more contributor license agreements.  See the NOTICE file
	     * distributed with this work for additional information
	     * regarding copyright ownership.  The ASF licenses this file
	     * to you under the Apache License, Version 2.0 (the
	     * "License"); you may not use this file except in compliance
	     * with the License.  You may obtain a copy of the License at
	     *
	     *   http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing,
	     * software distributed under the License is distributed on an
	     * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	     * KIND, either express or implied.  See the License for the
	     * specific language governing permissions and limitations
	     * under the License.
	     */
	
	    /**
	     * Language: English.
	     */
	    var langEN = {
	      time: {
	        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	        monthAbbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	        dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	        dayOfWeekAbbr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
	      },
	      legend: {
	        selector: {
	          all: 'All',
	          inverse: 'Inv'
	        }
	      },
	      toolbox: {
	        brush: {
	          title: {
	            rect: 'Box Select',
	            polygon: 'Lasso Select',
	            lineX: 'Horizontally Select',
	            lineY: 'Vertically Select',
	            keep: 'Keep Selections',
	            clear: 'Clear Selections'
	          }
	        },
	        dataView: {
	          title: 'Data View',
	          lang: ['Data View', 'Close', 'Refresh']
	        },
	        dataZoom: {
	          title: {
	            zoom: 'Zoom',
	            back: 'Zoom Reset'
	          }
	        },
	        magicType: {
	          title: {
	            line: 'Switch to Line Chart',
	            bar: 'Switch to Bar Chart',
	            stack: 'Stack',
	            tiled: 'Tile'
	          }
	        },
	        restore: {
	          title: 'Restore'
	        },
	        saveAsImage: {
	          title: 'Save as Image',
	          lang: ['Right Click to Save Image']
	        }
	      },
	      series: {
	        typeNames: {
	          pie: 'Pie chart',
	          bar: 'Bar chart',
	          line: 'Line chart',
	          scatter: 'Scatter plot',
	          effectScatter: 'Ripple scatter plot',
	          radar: 'Radar chart',
	          tree: 'Tree',
	          treemap: 'Treemap',
	          boxplot: 'Boxplot',
	          candlestick: 'Candlestick',
	          k: 'K line chart',
	          heatmap: 'Heat map',
	          map: 'Map',
	          parallel: 'Parallel coordinate map',
	          lines: 'Line graph',
	          graph: 'Relationship graph',
	          sankey: 'Sankey diagram',
	          funnel: 'Funnel chart',
	          gauge: 'Gauge',
	          pictorialBar: 'Pictorial bar',
	          themeRiver: 'Theme River Map',
	          sunburst: 'Sunburst'
	        }
	      },
	      aria: {
	        general: {
	          withTitle: 'This is a chart about "{title}"',
	          withoutTitle: 'This is a chart'
	        },
	        series: {
	          single: {
	            prefix: '',
	            withName: ' with type {seriesType} named {seriesName}.',
	            withoutName: ' with type {seriesType}.'
	          },
	          multiple: {
	            prefix: '. It consists of {seriesCount} series count.',
	            withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
	            withoutName: ' The {seriesId} series is a {seriesType}.',
	            separator: {
	              middle: '',
	              end: ''
	            }
	          }
	        },
	        data: {
	          allData: 'The data is as follows: ',
	          partialData: 'The first {displayCnt} items are: ',
	          withName: 'the data for {name} is {value}',
	          withoutName: '{value}',
	          separator: {
	            middle: ', ',
	            end: '. '
	          }
	        }
	      }
	    };
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	     * Licensed to the Apache Software Foundation (ASF) under one
	     * or more contributor license agreements.  See the NOTICE file
	     * distributed with this work for additional information
	     * regarding copyright ownership.  The ASF licenses this file
	     * to you under the Apache License, Version 2.0 (the
	     * "License"); you may not use this file except in compliance
	     * with the License.  You may obtain a copy of the License at
	     *
	     *   http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing,
	     * software distributed under the License is distributed on an
	     * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	     * KIND, either express or implied.  See the License for the
	     * specific language governing permissions and limitations
	     * under the License.
	     */
	    var langZH = {
	      time: {
	        month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
	        monthAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	        dayOfWeek: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
	        dayOfWeekAbbr: ['日', '一', '二', '三', '四', '五', '六']
	      },
	      legend: {
	        selector: {
	          all: '全选',
	          inverse: '反选'
	        }
	      },
	      toolbox: {
	        brush: {
	          title: {
	            rect: '矩形选择',
	            polygon: '圈选',
	            lineX: '横向选择',
	            lineY: '纵向选择',
	            keep: '保持选择',
	            clear: '清除选择'
	          }
	        },
	        dataView: {
	          title: '数据视图',
	          lang: ['数据视图', '关闭', '刷新']
	        },
	        dataZoom: {
	          title: {
	            zoom: '区域缩放',
	            back: '区域缩放还原'
	          }
	        },
	        magicType: {
	          title: {
	            line: '切换为折线图',
	            bar: '切换为柱状图',
	            stack: '切换为堆叠',
	            tiled: '切换为平铺'
	          }
	        },
	        restore: {
	          title: '还原'
	        },
	        saveAsImage: {
	          title: '保存为图片',
	          lang: ['右键另存为图片']
	        }
	      },
	      series: {
	        typeNames: {
	          pie: '饼图',
	          bar: '柱状图',
	          line: '折线图',
	          scatter: '散点图',
	          effectScatter: '涟漪散点图',
	          radar: '雷达图',
	          tree: '树图',
	          treemap: '矩形树图',
	          boxplot: '箱型图',
	          candlestick: 'K线图',
	          k: 'K线图',
	          heatmap: '热力图',
	          map: '地图',
	          parallel: '平行坐标图',
	          lines: '线图',
	          graph: '关系图',
	          sankey: '桑基图',
	          funnel: '漏斗图',
	          gauge: '仪表盘图',
	          pictorialBar: '象形柱图',
	          themeRiver: '主题河流图',
	          sunburst: '旭日图'
	        }
	      },
	      aria: {
	        general: {
	          withTitle: '这是一个关于“{title}”的图表。',
	          withoutTitle: '这是一个图表，'
	        },
	        series: {
	          single: {
	            prefix: '',
	            withName: '图表类型是{seriesType}，表示{seriesName}。',
	            withoutName: '图表类型是{seriesType}。'
	          },
	          multiple: {
	            prefix: '它由{seriesCount}个图表系列组成。',
	            withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
	            withoutName: '第{seriesId}个系列是一个{seriesType}，',
	            separator: {
	              middle: '；',
	              end: '。'
	            }
	          }
	        },
	        data: {
	          allData: '其数据是——',
	          partialData: '其中，前{displayCnt}项是——',
	          withName: '{name}的数据是{value}',
	          withoutName: '{value}',
	          separator: {
	            middle: '，',
	            end: ''
	          }
	        }
	      }
	    };
	
	    var LOCALE_ZH = 'ZH';
	    var LOCALE_EN = 'EN';
	    var DEFAULT_LOCALE = LOCALE_EN;
	    var localeStorage = {};
	    var localeModels = {};
	    var SYSTEM_LANG = !env.domSupported ? DEFAULT_LOCALE : function () {
	      var langStr = (
	      /* eslint-disable-next-line */
	      document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
	      return langStr.indexOf(LOCALE_ZH) > -1 ? LOCALE_ZH : DEFAULT_LOCALE;
	    }();
	    function registerLocale(locale, localeObj) {
	      locale = locale.toUpperCase();
	      localeModels[locale] = new Model(localeObj);
	      localeStorage[locale] = localeObj;
	    } // export function getLocale(locale: string) {
	    //     return localeStorage[locale];
	    // }
	
	    function createLocaleObject(locale) {
	      if (isString(locale)) {
	        var localeObj = localeStorage[locale.toUpperCase()] || {};
	
	        if (locale === LOCALE_ZH || locale === LOCALE_EN) {
	          return clone(localeObj);
	        } else {
	          return merge(clone(localeObj), clone(localeStorage[DEFAULT_LOCALE]), false);
	        }
	      } else {
	        return merge(clone(locale), clone(localeStorage[DEFAULT_LOCALE]), false);
	      }
	    }
	    function getLocaleModel(lang) {
	      return localeModels[lang];
	    }
	    function getDefaultLocaleModel() {
	      return localeModels[DEFAULT_LOCALE];
	    } // Default locale
	
	    registerLocale(LOCALE_EN, langEN);
	    registerLocale(LOCALE_ZH, langZH);
	
	    var ONE_SECOND = 1000;
	    var ONE_MINUTE = ONE_SECOND * 60;
	    var ONE_HOUR = ONE_MINUTE * 60;
	    var ONE_DAY = ONE_HOUR * 24;
	    var ONE_YEAR = ONE_DAY * 365;
	    var defaultLeveledFormatter = {
	      year: '{yyyy}',
	      month: '{MMM}',
	      day: '{d}',
	      hour: '{HH}:{mm}',
	      minute: '{HH}:{mm}',
	      second: '{HH}:{mm}:{ss}',
	      millisecond: '{HH}:{mm}:{ss} {SSS}',
	      none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
	    };
	    var fullDayFormatter = '{yyyy}-{MM}-{dd}';
	    var fullLeveledFormatter = {
	      year: '{yyyy}',
	      month: '{yyyy}-{MM}',
	      day: fullDayFormatter,
	      hour: fullDayFormatter + ' ' + defaultLeveledFormatter.hour,
	      minute: fullDayFormatter + ' ' + defaultLeveledFormatter.minute,
	      second: fullDayFormatter + ' ' + defaultLeveledFormatter.second,
	      millisecond: defaultLeveledFormatter.none
	    };
	    var primaryTimeUnits = ['year', 'month', 'day', 'hour', 'minute', 'second', 'millisecond'];
	    var timeUnits = ['year', 'half-year', 'quarter', 'month', 'week', 'half-week', 'day', 'half-day', 'quarter-day', 'hour', 'minute', 'second', 'millisecond'];
	    function pad(str, len) {
	      str += '';
	      return '0000'.substr(0, len - str.length) + str;
	    }
	    function getPrimaryTimeUnit(timeUnit) {
	      switch (timeUnit) {
	        case 'half-year':
	        case 'quarter':
	          return 'month';
	
	        case 'week':
	        case 'half-week':
	          return 'day';
	
	        case 'half-day':
	        case 'quarter-day':
	          return 'hour';
	
	        default:
	          // year, minutes, second, milliseconds
	          return timeUnit;
	      }
	    }
	    function isPrimaryTimeUnit(timeUnit) {
	      return timeUnit === getPrimaryTimeUnit(timeUnit);
	    }
	    function getDefaultFormatPrecisionOfInterval(timeUnit) {
	      switch (timeUnit) {
	        case 'year':
	        case 'month':
	          return 'day';
	
	        case 'millisecond':
	          return 'millisecond';
	
	        default:
	          // Also for day, hour, minute, second
	          return 'second';
	      }
	    }
	    function format( // Note: The result based on `isUTC` are totally different, which can not be just simply
	    // substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
	    time, template, isUTC, lang) {
	      var date = parseDate(time);
	      var y = date[fullYearGetterName(isUTC)]();
	      var M = date[monthGetterName(isUTC)]() + 1;
	      var q = Math.floor((M - 1) / 3) + 1;
	      var d = date[dateGetterName(isUTC)]();
	      var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
	      var H = date[hoursGetterName(isUTC)]();
	      var h = (H - 1) % 12 + 1;
	      var m = date[minutesGetterName(isUTC)]();
	      var s = date[secondsGetterName(isUTC)]();
	      var S = date[millisecondsGetterName(isUTC)]();
	      var localeModel = lang instanceof Model ? lang : getLocaleModel(lang || SYSTEM_LANG) || getDefaultLocaleModel();
	      var timeModel = localeModel.getModel('time');
	      var month = timeModel.get('month');
	      var monthAbbr = timeModel.get('monthAbbr');
	      var dayOfWeek = timeModel.get('dayOfWeek');
	      var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
	      return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, pad(y % 100 + '', 2)).replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, pad(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, pad(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, pad(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, pad(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, pad(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, pad(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, pad(S, 3)).replace(/{S}/g, S + '');
	    }
	    function leveledFormat(tick, idx, formatter, lang, isUTC) {
	      var template = null;
	
	      if (isString(formatter)) {
	        // Single formatter for all units at all levels
	        template = formatter;
	      } else if (isFunction(formatter)) {
	        // Callback formatter
	        template = formatter(tick.value, idx, {
	          level: tick.level
	        });
	      } else {
	        var defaults$1 = extend({}, defaultLeveledFormatter);
	
	        if (tick.level > 0) {
	          for (var i = 0; i < primaryTimeUnits.length; ++i) {
	            defaults$1[primaryTimeUnits[i]] = "{primary|" + defaults$1[primaryTimeUnits[i]] + "}";
	          }
	        }
	
	        var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
	        : defaults(formatter, defaults$1) : defaults$1;
	        var unit = getUnitFromValue(tick.value, isUTC);
	
	        if (mergedFormatter[unit]) {
	          template = mergedFormatter[unit];
	        } else if (mergedFormatter.inherit) {
	          // Unit formatter is not defined and should inherit from bigger units
	          var targetId = timeUnits.indexOf(unit);
	
	          for (var i = targetId - 1; i >= 0; --i) {
	            if (mergedFormatter[unit]) {
	              template = mergedFormatter[unit];
	              break;
	            }
	          }
	
	          template = template || defaults$1.none;
	        }
	
	        if (isArray(template)) {
	          var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
	          levelId = Math.min(levelId, template.length - 1);
	          template = template[levelId];
	        }
	      }
	
	      return format(new Date(tick.value), template, isUTC, lang);
	    }
	    function getUnitFromValue(value, isUTC) {
	      var date = parseDate(value);
	      var M = date[monthGetterName(isUTC)]() + 1;
	      var d = date[dateGetterName(isUTC)]();
	      var h = date[hoursGetterName(isUTC)]();
	      var m = date[minutesGetterName(isUTC)]();
	      var s = date[secondsGetterName(isUTC)]();
	      var S = date[millisecondsGetterName(isUTC)]();
	      var isSecond = S === 0;
	      var isMinute = isSecond && s === 0;
	      var isHour = isMinute && m === 0;
	      var isDay = isHour && h === 0;
	      var isMonth = isDay && d === 1;
	      var isYear = isMonth && M === 1;
	
	      if (isYear) {
	        return 'year';
	      } else if (isMonth) {
	        return 'month';
	      } else if (isDay) {
	        return 'day';
	      } else if (isHour) {
	        return 'hour';
	      } else if (isMinute) {
	        return 'minute';
	      } else if (isSecond) {
	        return 'second';
	      } else {
	        return 'millisecond';
	      }
	    }
	    function getUnitValue(value, unit, isUTC) {
	      var date = isNumber(value) ? parseDate(value) : value;
	      unit = unit || getUnitFromValue(value, isUTC);
	
	      switch (unit) {
	        case 'year':
	          return date[fullYearGetterName(isUTC)]();
	
	        case 'half-year':
	          return date[monthGetterName(isUTC)]() >= 6 ? 1 : 0;
	
	        case 'quarter':
	          return Math.floor((date[monthGetterName(isUTC)]() + 1) / 4);
	
	        case 'month':
	          return date[monthGetterName(isUTC)]();
	
	        case 'day':
	          return date[dateGetterName(isUTC)]();
	
	        case 'half-day':
	          return date[hoursGetterName(isUTC)]() / 24;
	
	        case 'hour':
	          return date[hoursGetterName(isUTC)]();
	
	        case 'minute':
	          return date[minutesGetterName(isUTC)]();
	
	        case 'second':
	          return date[secondsGetterName(isUTC)]();
	
	        case 'millisecond':
	          return date[millisecondsGetterName(isUTC)]();
	      }
	    }
	    function fullYearGetterName(isUTC) {
	      return isUTC ? 'getUTCFullYear' : 'getFullYear';
	    }
	    function monthGetterName(isUTC) {
	      return isUTC ? 'getUTCMonth' : 'getMonth';
	    }
	    function dateGetterName(isUTC) {
	      return isUTC ? 'getUTCDate' : 'getDate';
	    }
	    function hoursGetterName(isUTC) {
	      return isUTC ? 'getUTCHours' : 'getHours';
	    }
	    function minutesGetterName(isUTC) {
	      return isUTC ? 'getUTCMinutes' : 'getMinutes';
	    }
	    function secondsGetterName(isUTC) {
	      return isUTC ? 'getUTCSeconds' : 'getSeconds';
	    }
	    function millisecondsGetterName(isUTC) {
	      return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
	    }
	    function fullYearSetterName(isUTC) {
	      return isUTC ? 'setUTCFullYear' : 'setFullYear';
	    }
	    function monthSetterName(isUTC) {
	      return isUTC ? 'setUTCMonth' : 'setMonth';
	    }
	    function dateSetterName(isUTC) {
	      return isUTC ? 'setUTCDate' : 'setDate';
	    }
	    function hoursSetterName(isUTC) {
	      return isUTC ? 'setUTCHours' : 'setHours';
	    }
	    function minutesSetterName(isUTC) {
	      return isUTC ? 'setUTCMinutes' : 'setMinutes';
	    }
	    function secondsSetterName(isUTC) {
	      return isUTC ? 'setUTCSeconds' : 'setSeconds';
	    }
	    function millisecondsSetterName(isUTC) {
	      return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
	    }
	
	    function getTextRect(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
	      var textEl = new ZRText({
	        style: {
	          text: text,
	          font: font,
	          align: align,
	          verticalAlign: verticalAlign,
	          padding: padding,
	          rich: rich,
	          overflow: truncate ? 'truncate' : null,
	          lineHeight: lineHeight
	        }
	      });
	      return textEl.getBoundingRect();
	    }
	
	    /**
	     * Add a comma each three digit.
	     */
	
	    function addCommas(x) {
	      if (!isNumeric(x)) {
	        return isString(x) ? x : '-';
	      }
	
	      var parts = (x + '').split('.');
	      return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
	    }
	    function toCamelCase(str, upperCaseFirst) {
	      str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
	        return group1.toUpperCase();
	      });
	
	      if (upperCaseFirst && str) {
	        str = str.charAt(0).toUpperCase() + str.slice(1);
	      }
	
	      return str;
	    }
	    var normalizeCssArray$1 = normalizeCssArray;
	    /**
	     * Make value user readable for tooltip and label.
	     * "User readable":
	     *     Try to not print programmer-specific text like NaN, Infinity, null, undefined.
	     *     Avoid to display an empty string, which users can not recognize there is
	     *     a value and it might look like a bug.
	     */
	
	    function makeValueReadable(value, valueType, useUTC) {
	      var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}';
	
	      function stringToUserReadable(str) {
	        return str && trim(str) ? str : '-';
	      }
	
	      function isNumberUserReadable(num) {
	        return !!(num != null && !isNaN(num) && isFinite(num));
	      }
	
	      var isTypeTime = valueType === 'time';
	      var isValueDate = value instanceof Date;
	
	      if (isTypeTime || isValueDate) {
	        var date = isTypeTime ? parseDate(value) : value;
	
	        if (!isNaN(+date)) {
	          return format(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
	        } else if (isValueDate) {
	          return '-';
	        } // In other cases, continue to try to display the value in the following code.
	
	      }
	
	      if (valueType === 'ordinal') {
	        return isStringSafe(value) ? stringToUserReadable(value) : isNumber(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
	      } // By default.
	
	
	      var numericResult = numericToNumber(value);
	      return isNumberUserReadable(numericResult) ? addCommas(numericResult) : isStringSafe(value) ? stringToUserReadable(value) : typeof value === 'boolean' ? value + '' : '-';
	    }
	    var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
	
	    var wrapVar = function (varName, seriesIdx) {
	      return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
	    };
	    /**
	     * Template formatter
	     * @param {Array.<Object>|Object} paramsList
	     */
	
	
	    function formatTpl(tpl, paramsList, encode) {
	      if (!isArray(paramsList)) {
	        paramsList = [paramsList];
	      }
	
	      var seriesLen = paramsList.length;
	
	      if (!seriesLen) {
	        return '';
	      }
	
	      var $vars = paramsList[0].$vars || [];
	
	      for (var i = 0; i < $vars.length; i++) {
	        var alias = TPL_VAR_ALIAS[i];
	        tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
	      }
	
	      for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
	        for (var k = 0; k < $vars.length; k++) {
	          var val = paramsList[seriesIdx][$vars[k]];
	          tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
	        }
	      }
	
	      return tpl;
	    }
	    /**
	     * simple Template formatter
	     */
	
	    function formatTplSimple(tpl, param, encode) {
	      each(param, function (value, key) {
	        tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
	      });
	      return tpl;
	    }
	    function getTooltipMarker(inOpt, extraCssText) {
	      var opt = isString(inOpt) ? {
	        color: inOpt,
	        extraCssText: extraCssText
	      } : inOpt || {};
	      var color = opt.color;
	      var type = opt.type;
	      extraCssText = opt.extraCssText;
	      var renderMode = opt.renderMode || 'html';
	
	      if (!color) {
	        return '';
	      }
	
	      if (renderMode === 'html') {
	        return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' // Only support string
	        + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
	      } else {
	        // Should better not to auto generate style name by auto-increment number here.
	        // Because this util is usually called in tooltip formatter, which is probably
	        // called repeatedly when mouse move and the auto-increment number increases fast.
	        // Users can make their own style name by theirselves, make it unique and readable.
	        var markerId = opt.markerId || 'markerX';
	        return {
	          renderMode: renderMode,
	          content: '{' + markerId + '|}  ',
	          style: type === 'subItem' ? {
	            width: 4,
	            height: 4,
	            borderRadius: 2,
	            backgroundColor: color
	          } : {
	            width: 10,
	            height: 10,
	            borderRadius: 5,
	            backgroundColor: color
	          }
	        };
	      }
	    }
	    /**
	     * @deprecated Use `time/format` instead.
	     * ISO Date format
	     * @param {string} tpl
	     * @param {number} value
	     * @param {boolean} [isUTC=false] Default in local time.
	     *           see `module:echarts/scale/Time`
	     *           and `module:echarts/util/number#parseDate`.
	     * @inner
	     */
	
	    function formatTime(tpl, value, isUTC) {
	      if (true) {
	        deprecateReplaceLog('echarts.format.formatTime', 'echarts.time.format');
	      }
	
	      if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
	        tpl = 'MM-dd\nyyyy';
	      }
	
	      var date = parseDate(value);
	      var getUTC = isUTC ? 'getUTC' : 'get';
	      var y = date[getUTC + 'FullYear']();
	      var M = date[getUTC + 'Month']() + 1;
	      var d = date[getUTC + 'Date']();
	      var h = date[getUTC + 'Hours']();
	      var m = date[getUTC + 'Minutes']();
	      var s = date[getUTC + 'Seconds']();
	      var S = date[getUTC + 'Milliseconds']();
	      tpl = tpl.replace('MM', pad(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', pad(y % 100 + '', 2)).replace('dd', pad(d, 2)).replace('d', d).replace('hh', pad(h, 2)).replace('h', h).replace('mm', pad(m, 2)).replace('m', m).replace('ss', pad(s, 2)).replace('s', s).replace('SSS', pad(S, 3));
	      return tpl;
	    }
	    /**
	     * Capital first
	     * @param {string} str
	     * @return {string}
	     */
	
	    function capitalFirst(str) {
	      return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
	    }
	    /**
	     * @return Never be null/undefined.
	     */
	
	    function convertToColorString(color, defaultColor) {
	      defaultColor = defaultColor || 'transparent';
	      return isString(color) ? color : isObject(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
	    }
	    /**
	     * open new tab
	     * @param link url
	     * @param target blank or self
	     */
	
	    function windowOpen(link, target) {
	      /* global window */
	      if (target === '_blank' || target === 'blank') {
	        var blank = window.open();
	        blank.opener = null;
	        blank.location.href = link;
	      } else {
	        window.open(link, target);
	      }
	    }
	
	    var each$1 = each;
	    /**
	     * @public
	     */
	
	    var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
	    /**
	     * @public
	     */
	
	    var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];
	
	    function boxLayout(orient, group, gap, maxWidth, maxHeight) {
	      var x = 0;
	      var y = 0;
	
	      if (maxWidth == null) {
	        maxWidth = Infinity;
	      }
	
	      if (maxHeight == null) {
	        maxHeight = Infinity;
	      }
	
	      var currentLineMaxSize = 0;
	      group.eachChild(function (child, idx) {
	        var rect = child.getBoundingRect();
	        var nextChild = group.childAt(idx + 1);
	        var nextChildRect = nextChild && nextChild.getBoundingRect();
	        var nextX;
	        var nextY;
	
	        if (orient === 'horizontal') {
	          var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
	          nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
	          // FIXME compare before adding gap?
	
	          if (nextX > maxWidth || child.newline) {
	            x = 0;
	            nextX = moveX;
	            y += currentLineMaxSize + gap;
	            currentLineMaxSize = rect.height;
	          } else {
	            // FIXME: consider rect.y is not `0`?
	            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
	          }
	        } else {
	          var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
	          nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
	
	          if (nextY > maxHeight || child.newline) {
	            x += currentLineMaxSize + gap;
	            y = 0;
	            nextY = moveY;
	            currentLineMaxSize = rect.width;
	          } else {
	            currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
	          }
	        }
	
	        if (child.newline) {
	          return;
	        }
	
	        child.x = x;
	        child.y = y;
	        child.markRedraw();
	        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
	      });
	    }
	    /**
	     * VBox or HBox layouting
	     * @param {string} orient
	     * @param {module:zrender/graphic/Group} group
	     * @param {number} gap
	     * @param {number} [width=Infinity]
	     * @param {number} [height=Infinity]
	     */
	
	
	    var box = boxLayout;
	    /**
	     * VBox layouting
	     * @param {module:zrender/graphic/Group} group
	     * @param {number} gap
	     * @param {number} [width=Infinity]
	     * @param {number} [height=Infinity]
	     */
	
	    var vbox = curry(boxLayout, 'vertical');
	    /**
	     * HBox layouting
	     * @param {module:zrender/graphic/Group} group
	     * @param {number} gap
	     * @param {number} [width=Infinity]
	     * @param {number} [height=Infinity]
	     */
	
	    var hbox = curry(boxLayout, 'horizontal');
	    /**
	     * If x or x2 is not specified or 'center' 'left' 'right',
	     * the width would be as long as possible.
	     * If y or y2 is not specified or 'middle' 'top' 'bottom',
	     * the height would be as long as possible.
	     */
	
	    function getAvailableSize(positionInfo, containerRect, margin) {
	      var containerWidth = containerRect.width;
	      var containerHeight = containerRect.height;
	      var x = parsePercent$1(positionInfo.left, containerWidth);
	      var y = parsePercent$1(positionInfo.top, containerHeight);
	      var x2 = parsePercent$1(positionInfo.right, containerWidth);
	      var y2 = parsePercent$1(positionInfo.bottom, containerHeight);
	      (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
	      (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
	      (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
	      (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
	      margin = normalizeCssArray$1(margin || 0);
	      return {
	        width: Math.max(x2 - x - margin[1] - margin[3], 0),
	        height: Math.max(y2 - y - margin[0] - margin[2], 0)
	      };
	    }
	    /**
	     * Parse position info.
	     */
	
	    function getLayoutRect(positionInfo, containerRect, margin) {
	      margin = normalizeCssArray$1(margin || 0);
	      var containerWidth = containerRect.width;
	      var containerHeight = containerRect.height;
	      var left = parsePercent$1(positionInfo.left, containerWidth);
	      var top = parsePercent$1(positionInfo.top, containerHeight);
	      var right = parsePercent$1(positionInfo.right, containerWidth);
	      var bottom = parsePercent$1(positionInfo.bottom, containerHeight);
	      var width = parsePercent$1(positionInfo.width, containerWidth);
	      var height = parsePercent$1(positionInfo.height, containerHeight);
	      var verticalMargin = margin[2] + margin[0];
	      var horizontalMargin = margin[1] + margin[3];
	      var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
	
	      if (isNaN(width)) {
	        width = containerWidth - right - horizontalMargin - left;
	      }
	
	      if (isNaN(height)) {
	        height = containerHeight - bottom - verticalMargin - top;
	      }
	
	      if (aspect != null) {
	        // If width and height are not given
	        // 1. Graph should not exceeds the container
	        // 2. Aspect must be keeped
	        // 3. Graph should take the space as more as possible
	        // FIXME
	        // Margin is not considered, because there is no case that both
	        // using margin and aspect so far.
	        if (isNaN(width) && isNaN(height)) {
	          if (aspect > containerWidth / containerHeight) {
	            width = containerWidth * 0.8;
	          } else {
	            height = containerHeight * 0.8;
	          }
	        } // Calculate width or height with given aspect
	
	
	        if (isNaN(width)) {
	          width = aspect * height;
	        }
	
	        if (isNaN(height)) {
	          height = width / aspect;
	        }
	      } // If left is not specified, calculate left from right and width
	
	
	      if (isNaN(left)) {
	        left = containerWidth - right - width - horizontalMargin;
	      }
	
	      if (isNaN(top)) {
	        top = containerHeight - bottom - height - verticalMargin;
	      } // Align left and top
	
	
	      switch (positionInfo.left || positionInfo.right) {
	        case 'center':
	          left = containerWidth / 2 - width / 2 - margin[3];
	          break;
	
	        case 'right':
	          left = containerWidth - width - horizontalMargin;
	          break;
	      }
	
	      switch (positionInfo.top || positionInfo.bottom) {
	        case 'middle':
	        case 'center':
	          top = containerHeight / 2 - height / 2 - margin[0];
	          break;
	
	        case 'bottom':
	          top = containerHeight - height - verticalMargin;
	          break;
	      } // If something is wrong and left, top, width, height are calculated as NaN
	
	
	      left = left || 0;
	      top = top || 0;
	
	      if (isNaN(width)) {
	        // Width may be NaN if only one value is given except width
	        width = containerWidth - horizontalMargin - left - (right || 0);
	      }
	
	      if (isNaN(height)) {
	        // Height may be NaN if only one value is given except height
	        height = containerHeight - verticalMargin - top - (bottom || 0);
	      }
	
	      var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
	      rect.margin = margin;
	      return rect;
	    }
	    /**
	     * Position a zr element in viewport
	     *  Group position is specified by either
	     *  {left, top}, {right, bottom}
	     *  If all properties exists, right and bottom will be igonred.
	     *
	     * Logic:
	     *     1. Scale (against origin point in parent coord)
	     *     2. Rotate (against origin point in parent coord)
	     *     3. Translate (with el.position by this method)
	     * So this method only fixes the last step 'Translate', which does not affect
	     * scaling and rotating.
	     *
	     * If be called repeatedly with the same input el, the same result will be gotten.
	     *
	     * Return true if the layout happened.
	     *
	     * @param el Should have `getBoundingRect` method.
	     * @param positionInfo
	     * @param positionInfo.left
	     * @param positionInfo.top
	     * @param positionInfo.right
	     * @param positionInfo.bottom
	     * @param positionInfo.width Only for opt.boundingModel: 'raw'
	     * @param positionInfo.height Only for opt.boundingModel: 'raw'
	     * @param containerRect
	     * @param margin
	     * @param opt
	     * @param opt.hv Only horizontal or only vertical. Default to be [1, 1]
	     * @param opt.boundingMode
	     *        Specify how to calculate boundingRect when locating.
	     *        'all': Position the boundingRect that is transformed and uioned
	     *               both itself and its descendants.
	     *               This mode simplies confine the elements in the bounding
	     *               of their container (e.g., using 'right: 0').
	     *        'raw': Position the boundingRect that is not transformed and only itself.
	     *               This mode is useful when you want a element can overflow its
	     *               container. (Consider a rotated circle needs to be located in a corner.)
	     *               In this mode positionInfo.width/height can only be number.
	     */
	
	    function positionElement(el, positionInfo, containerRect, margin, opt, out) {
	      var h = !opt || !opt.hv || opt.hv[0];
	      var v = !opt || !opt.hv || opt.hv[1];
	      var boundingMode = opt && opt.boundingMode || 'all';
	      out = out || el;
	      out.x = el.x;
	      out.y = el.y;
	
	      if (!h && !v) {
	        return false;
	      }
	
	      var rect;
	
	      if (boundingMode === 'raw') {
	        rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
	      } else {
	        rect = el.getBoundingRect();
	
	        if (el.needLocalTransform()) {
	          var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
	          // which should not be modified.
	
	          rect = rect.clone();
	          rect.applyTransform(transform);
	        }
	      } // The real width and height can not be specified but calculated by the given el.
	
	
	      var layoutRect = getLayoutRect(defaults({
	        width: rect.width,
	        height: rect.height
	      }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
	      // (see zrender/core/Transformable#getLocalTransform),
	      // we can just only modify el.position to get final result.
	
	      var dx = h ? layoutRect.x - rect.x : 0;
	      var dy = v ? layoutRect.y - rect.y : 0;
	
	      if (boundingMode === 'raw') {
	        out.x = dx;
	        out.y = dy;
	      } else {
	        out.x += dx;
	        out.y += dy;
	      }
	
	      if (out === el) {
	        el.markRedraw();
	      }
	
	      return true;
	    }
	    /**
	     * @param option Contains some of the properties in HV_NAMES.
	     * @param hvIdx 0: horizontal; 1: vertical.
	     */
	
	    function sizeCalculable(option, hvIdx) {
	      return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
	    }
	    function fetchLayoutMode(ins) {
	      var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
	      return isObject(layoutMode) ? layoutMode : layoutMode ? {
	        type: layoutMode
	      } : null;
	    }
	    /**
	     * Consider Case:
	     * When default option has {left: 0, width: 100}, and we set {right: 0}
	     * through setOption or media query, using normal zrUtil.merge will cause
	     * {right: 0} does not take effect.
	     *
	     * @example
	     * ComponentModel.extend({
	     *     init: function () {
	     *         ...
	     *         let inputPositionParams = layout.getLayoutParams(option);
	     *         this.mergeOption(inputPositionParams);
	     *     },
	     *     mergeOption: function (newOption) {
	     *         newOption && zrUtil.merge(thisOption, newOption, true);
	     *         layout.mergeLayoutParam(thisOption, newOption);
	     *     }
	     * });
	     *
	     * @param targetOption
	     * @param newOption
	     * @param opt
	     */
	
	    function mergeLayoutParam(targetOption, newOption, opt) {
	      var ignoreSize = opt && opt.ignoreSize;
	      !isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
	      var hResult = merge(HV_NAMES[0], 0);
	      var vResult = merge(HV_NAMES[1], 1);
	      copy(HV_NAMES[0], targetOption, hResult);
	      copy(HV_NAMES[1], targetOption, vResult);
	
	      function merge(names, hvIdx) {
	        var newParams = {};
	        var newValueCount = 0;
	        var merged = {};
	        var mergedValueCount = 0;
	        var enoughParamNumber = 2;
	        each$1(names, function (name) {
	          merged[name] = targetOption[name];
	        });
	        each$1(names, function (name) {
	          // Consider case: newOption.width is null, which is
	          // set by user for removing width setting.
	          hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
	          hasValue(newParams, name) && newValueCount++;
	          hasValue(merged, name) && mergedValueCount++;
	        });
	
	        if (ignoreSize[hvIdx]) {
	          // Only one of left/right is premitted to exist.
	          if (hasValue(newOption, names[1])) {
	            merged[names[2]] = null;
	          } else if (hasValue(newOption, names[2])) {
	            merged[names[1]] = null;
	          }
	
	          return merged;
	        } // Case: newOption: {width: ..., right: ...},
	        // or targetOption: {right: ...} and newOption: {width: ...},
	        // There is no conflict when merged only has params count
	        // little than enoughParamNumber.
	
	
	        if (mergedValueCount === enoughParamNumber || !newValueCount) {
	          return merged;
	        } // Case: newOption: {width: ..., right: ...},
	        // Than we can make sure user only want those two, and ignore
	        // all origin params in targetOption.
	        else if (newValueCount >= enoughParamNumber) {
	            return newParams;
	          } else {
	            // Chose another param from targetOption by priority.
	            for (var i = 0; i < names.length; i++) {
	              var name_1 = names[i];
	
	              if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
	                newParams[name_1] = targetOption[name_1];
	                break;
	              }
	            }
	
	            return newParams;
	          }
	      }
	
	      function hasProp(obj, name) {
	        return obj.hasOwnProperty(name);
	      }
	
	      function hasValue(obj, name) {
	        return obj[name] != null && obj[name] !== 'auto';
	      }
	
	      function copy(names, target, source) {
	        each$1(names, function (name) {
	          target[name] = source[name];
	        });
	      }
	    }
	    /**
	     * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	     */
	
	    function getLayoutParams(source) {
	      return copyLayoutParams({}, source);
	    }
	    /**
	     * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	     * @param {Object} source
	     * @return {Object} Result contains those props.
	     */
	
	    function copyLayoutParams(target, source) {
	      source && target && each$1(LOCATION_PARAMS, function (name) {
	        source.hasOwnProperty(name) && (target[name] = source[name]);
	      });
	      return target;
	    }
	
	    var inner = makeInner();
	
	    var ComponentModel =
	    /** @class */
	    function (_super) {
	      __extends(ComponentModel, _super);
	
	      function ComponentModel(option, parentModel, ecModel) {
	        var _this = _super.call(this, option, parentModel, ecModel) || this;
	
	        _this.uid = getUID('ec_cpt_model');
	        return _this;
	      }
	
	      ComponentModel.prototype.init = function (option, parentModel, ecModel) {
	        this.mergeDefaultAndTheme(option, ecModel);
	      };
	
	      ComponentModel.prototype.mergeDefaultAndTheme = function (option, ecModel) {
	        var layoutMode = fetchLayoutMode(this);
	        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
	        var themeModel = ecModel.getTheme();
	        merge(option, themeModel.get(this.mainType));
	        merge(option, this.getDefaultOption());
	
	        if (layoutMode) {
	          mergeLayoutParam(option, inputPositionParams, layoutMode);
	        }
	      };
	
	      ComponentModel.prototype.mergeOption = function (option, ecModel) {
	        merge(this.option, option, true);
	        var layoutMode = fetchLayoutMode(this);
	
	        if (layoutMode) {
	          mergeLayoutParam(this.option, option, layoutMode);
	        }
	      };
	      /**
	       * Called immediately after `init` or `mergeOption` of this instance called.
	       */
	
	
	      ComponentModel.prototype.optionUpdated = function (newCptOption, isInit) {};
	      /**
	       * [How to declare defaultOption]:
	       *
	       * (A) If using class declaration in typescript (since echarts 5):
	       * ```ts
	       * import {ComponentOption} from '../model/option.js';
	       * export interface XxxOption extends ComponentOption {
	       *     aaa: number
	       * }
	       * export class XxxModel extends Component {
	       *     static type = 'xxx';
	       *     static defaultOption: XxxOption = {
	       *         aaa: 123
	       *     }
	       * }
	       * Component.registerClass(XxxModel);
	       * ```
	       * ```ts
	       * import {inheritDefaultOption} from '../util/component.js';
	       * import {XxxModel, XxxOption} from './XxxModel.js';
	       * export interface XxxSubOption extends XxxOption {
	       *     bbb: number
	       * }
	       * class XxxSubModel extends XxxModel {
	       *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
	       *         bbb: 456
	       *     })
	       *     fn() {
	       *         let opt = this.getDefaultOption();
	       *         // opt is {aaa: 123, bbb: 456}
	       *     }
	       * }
	       * ```
	       *
	       * (B) If using class extend (previous approach in echarts 3 & 4):
	       * ```js
	       * let XxxComponent = Component.extend({
	       *     defaultOption: {
	       *         xx: 123
	       *     }
	       * })
	       * ```
	       * ```js
	       * let XxxSubComponent = XxxComponent.extend({
	       *     defaultOption: {
	       *         yy: 456
	       *     },
	       *     fn: function () {
	       *         let opt = this.getDefaultOption();
	       *         // opt is {xx: 123, yy: 456}
	       *     }
	       * })
	       * ```
	       */
	
	
	      ComponentModel.prototype.getDefaultOption = function () {
	        var ctor = this.constructor; // If using class declaration, it is different to travel super class
	        // in legacy env and auto merge defaultOption. So if using class
	        // declaration, defaultOption should be merged manually.
	
	        if (!isExtendedClass(ctor)) {
	          // When using ts class, defaultOption must be declared as static.
	          return ctor.defaultOption;
	        } // FIXME: remove this approach?
	
	
	        var fields = inner(this);
	
	        if (!fields.defaultOption) {
	          var optList = [];
	          var clz = ctor;
	
	          while (clz) {
	            var opt = clz.prototype.defaultOption;
	            opt && optList.push(opt);
	            clz = clz.superClass;
	          }
	
	          var defaultOption = {};
	
	          for (var i = optList.length - 1; i >= 0; i--) {
	            defaultOption = merge(defaultOption, optList[i], true);
	          }
	
	          fields.defaultOption = defaultOption;
	        }
	
	        return fields.defaultOption;
	      };
	      /**
	       * Notice: always force to input param `useDefault` in case that forget to consider it.
	       * The same behavior as `modelUtil.parseFinder`.
	       *
	       * @param useDefault In many cases like series refer axis and axis refer grid,
	       *        If axis index / axis id not specified, use the first target as default.
	       *        In other cases like dataZoom refer axis, if not specified, measn no refer.
	       */
	
	
	      ComponentModel.prototype.getReferringComponents = function (mainType, opt) {
	        var indexKey = mainType + 'Index';
	        var idKey = mainType + 'Id';
	        return queryReferringComponents(this.ecModel, mainType, {
	          index: this.get(indexKey, true),
	          id: this.get(idKey, true)
	        }, opt);
	      };
	
	      ComponentModel.prototype.getBoxLayoutParams = function () {
	        // Consider itself having box layout configs.
	        var boxLayoutModel = this;
	        return {
	          left: boxLayoutModel.get('left'),
	          top: boxLayoutModel.get('top'),
	          right: boxLayoutModel.get('right'),
	          bottom: boxLayoutModel.get('bottom'),
	          width: boxLayoutModel.get('width'),
	          height: boxLayoutModel.get('height')
	        };
	      };
	      /**
	       * Get key for zlevel.
	       * If developers don't configure zlevel. We will assign zlevel to series based on the key.
	       * For example, lines with trail effect and progressive series will in an individual zlevel.
	       */
	
	
	      ComponentModel.prototype.getZLevelKey = function () {
	        return '';
	      };
	
	      ComponentModel.prototype.setZLevel = function (zlevel) {
	        this.option.zlevel = zlevel;
	      };
	
	      ComponentModel.protoInitialize = function () {
	        var proto = ComponentModel.prototype;
	        proto.type = 'component';
	        proto.id = '';
	        proto.name = '';
	        proto.mainType = '';
	        proto.subType = '';
	        proto.componentIndex = 0;
	      }();
	
	      return ComponentModel;
	    }(Model);
	
	    mountExtend(ComponentModel, Model);
	    enableClassManagement(ComponentModel);
	    enableSubTypeDefaulter(ComponentModel);
	    enableTopologicalTravel(ComponentModel, getDependencies);
	
	    function getDependencies(componentType) {
	      var deps = [];
	      each(ComponentModel.getClassesByMainType(componentType), function (clz) {
	        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
	      }); // Ensure main type.
	
	      deps = map(deps, function (type) {
	        return parseClassType(type).main;
	      }); // Hack dataset for convenience.
	
	      if (componentType !== 'dataset' && indexOf(deps, 'dataset') <= 0) {
	        deps.unshift('dataset');
	      }
	
	      return deps;
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var platform = ''; // Navigator not exists in node
	
	    if (typeof navigator !== 'undefined') {
	      /* global navigator */
	      platform = navigator.platform || '';
	    }
	
	    var decalColor = 'rgba(0, 0, 0, 0.2)';
	    var globalDefault = {
	      darkMode: 'auto',
	      // backgroundColor: 'rgba(0,0,0,0)',
	      colorBy: 'series',
	      color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
	      gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
	      aria: {
	        decal: {
	          decals: [{
	            color: decalColor,
	            dashArrayX: [1, 0],
	            dashArrayY: [2, 5],
	            symbolSize: 1,
	            rotation: Math.PI / 6
	          }, {
	            color: decalColor,
	            symbol: 'circle',
	            dashArrayX: [[8, 8], [0, 8, 8, 0]],
	            dashArrayY: [6, 0],
	            symbolSize: 0.8
	          }, {
	            color: decalColor,
	            dashArrayX: [1, 0],
	            dashArrayY: [4, 3],
	            rotation: -Math.PI / 4
	          }, {
	            color: decalColor,
	            dashArrayX: [[6, 6], [0, 6, 6, 0]],
	            dashArrayY: [6, 0]
	          }, {
	            color: decalColor,
	            dashArrayX: [[1, 0], [1, 6]],
	            dashArrayY: [1, 0, 6, 0],
	            rotation: Math.PI / 4
	          }, {
	            color: decalColor,
	            symbol: 'triangle',
	            dashArrayX: [[9, 9], [0, 9, 9, 0]],
	            dashArrayY: [7, 2],
	            symbolSize: 0.75
	          }]
	        }
	      },
	      // If xAxis and yAxis declared, grid is created by default.
	      // grid: {},
	      textStyle: {
	        // color: '#000',
	        // decoration: 'none',
	        // PENDING
	        fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
	        // fontFamily: 'Arial, Verdana, sans-serif',
	        fontSize: 12,
	        fontStyle: 'normal',
	        fontWeight: 'normal'
	      },
	      // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
	      // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	      // Default is source-over
	      blendMode: null,
	      stateAnimation: {
	        duration: 300,
	        easing: 'cubicOut'
	      },
	      animation: 'auto',
	      animationDuration: 1000,
	      animationDurationUpdate: 500,
	      animationEasing: 'cubicInOut',
	      animationEasingUpdate: 'cubicInOut',
	      animationThreshold: 2000,
	      // Configuration for progressive/incremental rendering
	      progressiveThreshold: 3000,
	      progressive: 400,
	      // Threshold of if use single hover layer to optimize.
	      // It is recommended that `hoverLayerThreshold` is equivalent to or less than
	      // `progressiveThreshold`, otherwise hover will cause restart of progressive,
	      // which is unexpected.
	      // see example <echarts/test/heatmap-large.html>.
	      hoverLayerThreshold: 3000,
	      // See: module:echarts/scale/Time
	      useUTC: false
	    };
	
	    var VISUAL_DIMENSIONS = createHashMap(['tooltip', 'label', 'itemName', 'itemId', 'itemGroupId', 'seriesName']);
	    var SOURCE_FORMAT_ORIGINAL = 'original';
	    var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
	    var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
	    var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
	    var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
	    var SOURCE_FORMAT_UNKNOWN = 'unknown';
	    var SERIES_LAYOUT_BY_COLUMN = 'column';
	    var SERIES_LAYOUT_BY_ROW = 'row';
	
	    var BE_ORDINAL = {
	      Must: 1,
	      Might: 2,
	      Not: 3 // Other cases
	
	    };
	    var innerGlobalModel = makeInner();
	    /**
	     * MUST be called before mergeOption of all series.
	     */
	
	    function resetSourceDefaulter(ecModel) {
	      // `datasetMap` is used to make default encode.
	      innerGlobalModel(ecModel).datasetMap = createHashMap();
	    }
	    /**
	     * [The strategy of the arrengment of data dimensions for dataset]:
	     * "value way": all axes are non-category axes. So series one by one take
	     *     several (the number is coordSysDims.length) dimensions from dataset.
	     *     The result of data arrengment of data dimensions like:
	     *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
	     * "category way": at least one axis is category axis. So the the first data
	     *     dimension is always mapped to the first category axis and shared by
	     *     all of the series. The other data dimensions are taken by series like
	     *     "value way" does.
	     *     The result of data arrengment of data dimensions like:
	     *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
	     *
	     * @return encode Never be `null/undefined`.
	     */
	
	    function makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
	      var encode = {};
	      var datasetModel = querySeriesUpstreamDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	      if (!datasetModel || !coordDimensions) {
	        return encode;
	      }
	
	      var encodeItemName = [];
	      var encodeSeriesName = [];
	      var ecModel = seriesModel.ecModel;
	      var datasetMap = innerGlobalModel(ecModel).datasetMap;
	      var key = datasetModel.uid + '_' + source.seriesLayoutBy;
	      var baseCategoryDimIndex;
	      var categoryWayValueDimStart;
	      coordDimensions = coordDimensions.slice();
	      each(coordDimensions, function (coordDimInfoLoose, coordDimIdx) {
	        var coordDimInfo = isObject(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
	          name: coordDimInfoLoose
	        };
	
	        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
	          baseCategoryDimIndex = coordDimIdx;
	          categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
	        }
	
	        encode[coordDimInfo.name] = [];
	      });
	      var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
	        categoryWayDim: categoryWayValueDimStart,
	        valueWayDim: 0
	      }); // TODO
	      // Auto detect first time axis and do arrangement.
	
	      each(coordDimensions, function (coordDimInfo, coordDimIdx) {
	        var coordDimName = coordDimInfo.name;
	        var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
	
	        if (baseCategoryDimIndex == null) {
	          var start = datasetRecord.valueWayDim;
	          pushDim(encode[coordDimName], start, count);
	          pushDim(encodeSeriesName, start, count);
	          datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
	          // especially when encode x y specified.
	          // consider: when multiple series share one dimension
	          // category axis, series name should better use
	          // the other dimension name. On the other hand, use
	          // both dimensions name.
	        } // In category way, the first category axis.
	        else if (baseCategoryDimIndex === coordDimIdx) {
	            pushDim(encode[coordDimName], 0, count);
	            pushDim(encodeItemName, 0, count);
	          } // In category way, the other axis.
	          else {
	              var start = datasetRecord.categoryWayDim;
	              pushDim(encode[coordDimName], start, count);
	              pushDim(encodeSeriesName, start, count);
	              datasetRecord.categoryWayDim += count;
	            }
	      });
	
	      function pushDim(dimIdxArr, idxFrom, idxCount) {
	        for (var i = 0; i < idxCount; i++) {
	          dimIdxArr.push(idxFrom + i);
	        }
	      }
	
	      function getDataDimCountOnCoordDim(coordDimInfo) {
	        var dimsDef = coordDimInfo.dimsDef;
	        return dimsDef ? dimsDef.length : 1;
	      }
	
	      encodeItemName.length && (encode.itemName = encodeItemName);
	      encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
	      return encode;
	    }
	    /**
	     * Work for data like [{name: ..., value: ...}, ...].
	     *
	     * @return encode Never be `null/undefined`.
	     */
	
	    function makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
	      var encode = {};
	      var datasetModel = querySeriesUpstreamDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	      if (!datasetModel) {
	        return encode;
	      }
	
	      var sourceFormat = source.sourceFormat;
	      var dimensionsDefine = source.dimensionsDefine;
	      var potentialNameDimIndex;
	
	      if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	        each(dimensionsDefine, function (dim, idx) {
	          if ((isObject(dim) ? dim.name : dim) === 'name') {
	            potentialNameDimIndex = idx;
	          }
	        });
	      }
	
	      var idxResult = function () {
	        var idxRes0 = {};
	        var idxRes1 = {};
	        var guessRecords = []; // 5 is an experience value.
	
	        for (var i = 0, len = Math.min(5, dimCount); i < len; i++) {
	          var guessResult = doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
	          guessRecords.push(guessResult);
	          var isPureNumber = guessResult === BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
	          // and then find a name dim with the priority:
	          // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
	
	          if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) {
	            idxRes0.v = i;
	          }
	
	          if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === BE_ORDINAL.Not) {
	            idxRes0.n = i;
	          }
	
	          if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== BE_ORDINAL.Not) {
	            return idxRes0;
	          } // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
	          // find the first BE_ORDINAL.Might as the value dim,
	          // and then find a name dim with the priority:
	          // "other dim" > "the value dim itself".
	          // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
	          // treated as number.
	
	
	          if (!isPureNumber) {
	            if (guessResult === BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) {
	              idxRes1.v = i;
	            }
	
	            if (idxRes1.n == null || idxRes1.n === idxRes1.v) {
	              idxRes1.n = i;
	            }
	          }
	        }
	
	        function fulfilled(idxResult) {
	          return idxResult.v != null && idxResult.n != null;
	        }
	
	        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
	      }();
	
	      if (idxResult) {
	        encode.value = [idxResult.v]; // `potentialNameDimIndex` has highest priority.
	
	        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label uses itemName in charts.
	        // So we don't set encodeLabel here.
	
	        encode.itemName = [nameDimIndex];
	        encode.seriesName = [nameDimIndex];
	      }
	
	      return encode;
	    }
	    /**
	     * @return If return null/undefined, indicate that should not use datasetModel.
	     */
	
	    function querySeriesUpstreamDatasetModel(seriesModel) {
	      // Caution: consider the scenario:
	      // A dataset is declared and a series is not expected to use the dataset,
	      // and at the beginning `setOption({series: { noData })` (just prepare other
	      // option but no data), then `setOption({series: {data: [...]}); In this case,
	      // the user should set an empty array to avoid that dataset is used by default.
	      var thisData = seriesModel.get('data', true);
	
	      if (!thisData) {
	        return queryReferringComponents(seriesModel.ecModel, 'dataset', {
	          index: seriesModel.get('datasetIndex', true),
	          id: seriesModel.get('datasetId', true)
	        }, SINGLE_REFERRING).models[0];
	      }
	    }
	    /**
	     * @return Always return an array event empty.
	     */
	
	    function queryDatasetUpstreamDatasetModels(datasetModel) {
	      // Only these attributes declared, we by defualt reference to `datasetIndex: 0`.
	      // Otherwise, no reference.
	      if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) {
	        return [];
	      }
	
	      return queryReferringComponents(datasetModel.ecModel, 'dataset', {
	        index: datasetModel.get('fromDatasetIndex', true),
	        id: datasetModel.get('fromDatasetId', true)
	      }, SINGLE_REFERRING).models;
	    }
	    /**
	     * The rule should not be complex, otherwise user might not
	     * be able to known where the data is wrong.
	     * The code is ugly, but how to make it neat?
	     */
	
	    function guessOrdinal(source, dimIndex) {
	      return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
	    } // dimIndex may be overflow source data.
	    // return {BE_ORDINAL}
	
	    function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
	      var result; // Experience value.
	
	      var maxLoop = 5;
	
	      if (isTypedArray(data)) {
	        return BE_ORDINAL.Not;
	      } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
	      // always exists in source.
	
	
	      var dimName;
	      var dimType;
	
	      if (dimensionsDefine) {
	        var dimDefItem = dimensionsDefine[dimIndex];
	
	        if (isObject(dimDefItem)) {
	          dimName = dimDefItem.name;
	          dimType = dimDefItem.type;
	        } else if (isString(dimDefItem)) {
	          dimName = dimDefItem;
	        }
	      }
	
	      if (dimType != null) {
	        return dimType === 'ordinal' ? BE_ORDINAL.Must : BE_ORDINAL.Not;
	      }
	
	      if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	        var dataArrayRows = data;
	
	        if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	          var sample = dataArrayRows[dimIndex];
	
	          for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
	            if ((result = detectValue(sample[startIndex + i])) != null) {
	              return result;
	            }
	          }
	        } else {
	          for (var i = 0; i < dataArrayRows.length && i < maxLoop; i++) {
	            var row = dataArrayRows[startIndex + i];
	
	            if (row && (result = detectValue(row[dimIndex])) != null) {
	              return result;
	            }
	          }
	        }
	      } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	        var dataObjectRows = data;
	
	        if (!dimName) {
	          return BE_ORDINAL.Not;
	        }
	
	        for (var i = 0; i < dataObjectRows.length && i < maxLoop; i++) {
	          var item = dataObjectRows[i];
	
	          if (item && (result = detectValue(item[dimName])) != null) {
	            return result;
	          }
	        }
	      } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	        var dataKeyedColumns = data;
	
	        if (!dimName) {
	          return BE_ORDINAL.Not;
	        }
	
	        var sample = dataKeyedColumns[dimName];
	
	        if (!sample || isTypedArray(sample)) {
	          return BE_ORDINAL.Not;
	        }
	
	        for (var i = 0; i < sample.length && i < maxLoop; i++) {
	          if ((result = detectValue(sample[i])) != null) {
	            return result;
	          }
	        }
	      } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	        var dataOriginal = data;
	
	        for (var i = 0; i < dataOriginal.length && i < maxLoop; i++) {
	          var item = dataOriginal[i];
	          var val = getDataItemValue(item);
	
	          if (!isArray(val)) {
	            return BE_ORDINAL.Not;
	          }
	
	          if ((result = detectValue(val[dimIndex])) != null) {
	            return result;
	          }
	        }
	      }
	
	      function detectValue(val) {
	        var beStr = isString(val); // Consider usage convenience, '1', '2' will be treated as "number".
	        // `isFinit('')` get `true`.
	
	        if (val != null && isFinite(val) && val !== '') {
	          return beStr ? BE_ORDINAL.Might : BE_ORDINAL.Not;
	        } else if (beStr && val !== '-') {
	          return BE_ORDINAL.Must;
	        }
	      }
	
	      return BE_ORDINAL.Not;
	    }
	
	    var internalOptionCreatorMap = createHashMap();
	    function registerInternalOptionCreator(mainType, creator) {
	      assert(internalOptionCreatorMap.get(mainType) == null && creator);
	      internalOptionCreatorMap.set(mainType, creator);
	    }
	    function concatInternalOptions(ecModel, mainType, newCmptOptionList) {
	      var internalOptionCreator = internalOptionCreatorMap.get(mainType);
	
	      if (!internalOptionCreator) {
	        return newCmptOptionList;
	      }
	
	      var internalOptions = internalOptionCreator(ecModel);
	
	      if (!internalOptions) {
	        return newCmptOptionList;
	      }
	
	      if (true) {
	        for (var i = 0; i < internalOptions.length; i++) {
	          assert(isComponentIdInternal(internalOptions[i]));
	        }
	      }
	
	      return newCmptOptionList.concat(internalOptions);
	    }
	
	    var innerColor = makeInner();
	    var innerDecal = makeInner();
	
	    var PaletteMixin =
	    /** @class */
	    function () {
	      function PaletteMixin() {}
	
	      PaletteMixin.prototype.getColorFromPalette = function (name, scope, requestNum) {
	        var defaultPalette = normalizeToArray(this.get('color', true));
	        var layeredPalette = this.get('colorLayer', true);
	        return getFromPalette(this, innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
	      };
	
	      PaletteMixin.prototype.clearColorPalette = function () {
	        clearPalette(this, innerColor);
	      };
	
	      return PaletteMixin;
	    }();
	
	    function getDecalFromPalette(ecModel, name, scope, requestNum) {
	      var defaultDecals = normalizeToArray(ecModel.get(['aria', 'decal', 'decals']));
	      return getFromPalette(ecModel, innerDecal, defaultDecals, null, name, scope, requestNum);
	    }
	
	    function getNearestPalette(palettes, requestColorNum) {
	      var paletteNum = palettes.length; // TODO palettes must be in order
	
	      for (var i = 0; i < paletteNum; i++) {
	        if (palettes[i].length > requestColorNum) {
	          return palettes[i];
	        }
	      }
	
	      return palettes[paletteNum - 1];
	    }
	    /**
	     * @param name MUST NOT be null/undefined. Otherwise call this function
	     *             twise with the same parameters will get different result.
	     * @param scope default this.
	     * @return Can be null/undefined
	     */
	
	
	    function getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
	      scope = scope || that;
	      var scopeFields = inner(scope);
	      var paletteIdx = scopeFields.paletteIdx || 0;
	      var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
	
	      if (paletteNameMap.hasOwnProperty(name)) {
	        return paletteNameMap[name];
	      }
	
	      var palette = requestNum == null || !layeredPalette ? defaultPalette : getNearestPalette(layeredPalette, requestNum); // In case can't find in layered color palette.
	
	      palette = palette || defaultPalette;
	
	      if (!palette || !palette.length) {
	        return;
	      }
	
	      var pickedPaletteItem = palette[paletteIdx];
	
	      if (name) {
	        paletteNameMap[name] = pickedPaletteItem;
	      }
	
	      scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
	      return pickedPaletteItem;
	    }
	
	    function clearPalette(that, inner) {
	      inner(that).paletteIdx = 0;
	      inner(that).paletteNameMap = {};
	    }
	
	    // Internal method names:
	    // -----------------------
	
	    var reCreateSeriesIndices;
	    var assertSeriesInitialized;
	    var initBase;
	    var OPTION_INNER_KEY = '\0_ec_inner';
	    var OPTION_INNER_VALUE = 1;
	    var BUITIN_COMPONENTS_MAP = {
	      grid: 'GridComponent',
	      polar: 'PolarComponent',
	      geo: 'GeoComponent',
	      singleAxis: 'SingleAxisComponent',
	      parallel: 'ParallelComponent',
	      calendar: 'CalendarComponent',
	      graphic: 'GraphicComponent',
	      toolbox: 'ToolboxComponent',
	      tooltip: 'TooltipComponent',
	      axisPointer: 'AxisPointerComponent',
	      brush: 'BrushComponent',
	      title: 'TitleComponent',
	      timeline: 'TimelineComponent',
	      markPoint: 'MarkPointComponent',
	      markLine: 'MarkLineComponent',
	      markArea: 'MarkAreaComponent',
	      legend: 'LegendComponent',
	      dataZoom: 'DataZoomComponent',
	      visualMap: 'VisualMapComponent',
	      // aria: 'AriaComponent',
	      // dataset: 'DatasetComponent',
	      // Dependencies
	      xAxis: 'GridComponent',
	      yAxis: 'GridComponent',
	      angleAxis: 'PolarComponent',
	      radiusAxis: 'PolarComponent'
	    };
	    var BUILTIN_CHARTS_MAP = {
	      line: 'LineChart',
	      bar: 'BarChart',
	      pie: 'PieChart',
	      scatter: 'ScatterChart',
	      radar: 'RadarChart',
	      map: 'MapChart',
	      tree: 'TreeChart',
	      treemap: 'TreemapChart',
	      graph: 'GraphChart',
	      gauge: 'GaugeChart',
	      funnel: 'FunnelChart',
	      parallel: 'ParallelChart',
	      sankey: 'SankeyChart',
	      boxplot: 'BoxplotChart',
	      candlestick: 'CandlestickChart',
	      effectScatter: 'EffectScatterChart',
	      lines: 'LinesChart',
	      heatmap: 'HeatmapChart',
	      pictorialBar: 'PictorialBarChart',
	      themeRiver: 'ThemeRiverChart',
	      sunburst: 'SunburstChart',
	      custom: 'CustomChart'
	    };
	    var componetsMissingLogPrinted = {};
	
	    function checkMissingComponents(option) {
	      each(option, function (componentOption, mainType) {
	        if (!ComponentModel.hasClass(mainType)) {
	          var componentImportName = BUITIN_COMPONENTS_MAP[mainType];
	
	          if (componentImportName && !componetsMissingLogPrinted[componentImportName]) {
	            error("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
	            componetsMissingLogPrinted[componentImportName] = true;
	          }
	        }
	      });
	    }
	
	    var GlobalModel =
	    /** @class */
	    function (_super) {
	      __extends(GlobalModel, _super);
	
	      function GlobalModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      GlobalModel.prototype.init = function (option, parentModel, ecModel, theme, locale, optionManager) {
	        theme = theme || {};
	        this.option = null; // Mark as not initialized.
	
	        this._theme = new Model(theme);
	        this._locale = new Model(locale);
	        this._optionManager = optionManager;
	      };
	
	      GlobalModel.prototype.setOption = function (option, opts, optionPreprocessorFuncs) {
	        if (true) {
	          assert(option != null, 'option is null/undefined');
	          assert(option[OPTION_INNER_KEY] !== OPTION_INNER_VALUE, 'please use chart.getOption()');
	        }
	
	        var innerOpt = normalizeSetOptionInput(opts);
	
	        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
	
	        this._resetOption(null, innerOpt);
	      };
	      /**
	       * @param type null/undefined: reset all.
	       *        'recreate': force recreate all.
	       *        'timeline': only reset timeline option
	       *        'media': only reset media query option
	       * @return Whether option changed.
	       */
	
	
	      GlobalModel.prototype.resetOption = function (type, opt) {
	        return this._resetOption(type, normalizeSetOptionInput(opt));
	      };
	
	      GlobalModel.prototype._resetOption = function (type, opt) {
	        var optionChanged = false;
	        var optionManager = this._optionManager;
	
	        if (!type || type === 'recreate') {
	          var baseOption = optionManager.mountOption(type === 'recreate');
	
	          if (true) {
	            checkMissingComponents(baseOption);
	          }
	
	          if (!this.option || type === 'recreate') {
	            initBase(this, baseOption);
	          } else {
	            this.restoreData();
	
	            this._mergeOption(baseOption, opt);
	          }
	
	          optionChanged = true;
	        }
	
	        if (type === 'timeline' || type === 'media') {
	          this.restoreData();
	        } // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
	        // it should better not have the same props with `MediaUnit['option']`.
	        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
	        // rather than original "baseOption". If they both override a prop, the result might be
	        // unexpected when media state changed after `setOption` called.
	        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
	        // (`{baseOption, media}`) in `setOption`.
	        // For `timeline`, the case is the same.
	
	
	        if (!type || type === 'recreate' || type === 'timeline') {
	          var timelineOption = optionManager.getTimelineOption(this);
	
	          if (timelineOption) {
	            optionChanged = true;
	
	            this._mergeOption(timelineOption, opt);
	          }
	        }
	
	        if (!type || type === 'recreate' || type === 'media') {
	          var mediaOptions = optionManager.getMediaOption(this);
	
	          if (mediaOptions.length) {
	            each(mediaOptions, function (mediaOption) {
	              optionChanged = true;
	
	              this._mergeOption(mediaOption, opt);
	            }, this);
	          }
	        }
	
	        return optionChanged;
	      };
	
	      GlobalModel.prototype.mergeOption = function (option) {
	        this._mergeOption(option, null);
	      };
	
	      GlobalModel.prototype._mergeOption = function (newOption, opt) {
	        var option = this.option;
	        var componentsMap = this._componentsMap;
	        var componentsCount = this._componentsCount;
	        var newCmptTypes = [];
	        var newCmptTypeMap = createHashMap();
	        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
	        resetSourceDefaulter(this); // If no component class, merge directly.
	        // For example: color, animaiton options, etc.
	
	        each(newOption, function (componentOption, mainType) {
	          if (componentOption == null) {
	            return;
	          }
	
	          if (!ComponentModel.hasClass(mainType)) {
	            // globalSettingTask.dirty();
	            option[mainType] = option[mainType] == null ? clone(componentOption) : merge(option[mainType], componentOption, true);
	          } else if (mainType) {
	            newCmptTypes.push(mainType);
	            newCmptTypeMap.set(mainType, true);
	          }
	        });
	
	        if (replaceMergeMainTypeMap) {
	          // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
	          // we trade it as it is declared in option as `{xxx: []}`. Because:
	          // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
	          // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
	          replaceMergeMainTypeMap.each(function (val, mainTypeInReplaceMerge) {
	            if (ComponentModel.hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
	              newCmptTypes.push(mainTypeInReplaceMerge);
	              newCmptTypeMap.set(mainTypeInReplaceMerge, true);
	            }
	          });
	        }
	
	        ComponentModel.topologicalTravel(newCmptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);
	
	        function visitComponent(mainType) {
	          var newCmptOptionList = concatInternalOptions(this, mainType, normalizeToArray(newOption[mainType]));
	          var oldCmptList = componentsMap.get(mainType);
	          var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
	          !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
	          var mappingResult = mappingToExists(oldCmptList, newCmptOptionList, mergeMode); // Set mainType and complete subType.
	
	          setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel); // Empty it before the travel, in order to prevent `this._componentsMap`
	          // from being used in the `init`/`mergeOption`/`optionUpdated` of some
	          // components, which is probably incorrect logic.
	
	          option[mainType] = null;
	          componentsMap.set(mainType, null);
	          componentsCount.set(mainType, 0);
	          var optionsByMainType = [];
	          var cmptsByMainType = [];
	          var cmptsCountByMainType = 0;
	          var tooltipExists;
	          var tooltipWarningLogged;
	          each(mappingResult, function (resultItem, index) {
	            var componentModel = resultItem.existing;
	            var newCmptOption = resultItem.newOption;
	
	            if (!newCmptOption) {
	              if (componentModel) {
	                // Consider where is no new option and should be merged using {},
	                // see removeEdgeAndAdd in topologicalTravel and
	                // ComponentModel.getAllClassMainTypes.
	                componentModel.mergeOption({}, this);
	                componentModel.optionUpdated({}, false);
	              } // If no both `resultItem.exist` and `resultItem.option`,
	              // either it is in `replaceMerge` and not matched by any id,
	              // or it has been removed in previous `replaceMerge` and left a "hole" in this component index.
	
	            } else {
	              var isSeriesType = mainType === 'series';
	              var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
	              );
	
	              if (!ComponentModelClass) {
	                if (true) {
	                  var subType = resultItem.keyInfo.subType;
	                  var seriesImportName = BUILTIN_CHARTS_MAP[subType];
	
	                  if (!componetsMissingLogPrinted[subType]) {
	                    componetsMissingLogPrinted[subType] = true;
	
	                    if (seriesImportName) {
	                      error("Series " + subType + " is used but not imported.\nimport { " + seriesImportName + " } from 'echarts/charts';\necharts.use([" + seriesImportName + "]);");
	                    } else {
	                      error("Unknown series " + subType);
	                    }
	                  }
	                }
	
	                return;
	              } // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
	
	
	              if (mainType === 'tooltip') {
	                if (tooltipExists) {
	                  if (true) {
	                    if (!tooltipWarningLogged) {
	                      warn('Currently only one tooltip component is allowed.');
	                      tooltipWarningLogged = true;
	                    }
	                  }
	
	                  return;
	                }
	
	                tooltipExists = true;
	              }
	
	              if (componentModel && componentModel.constructor === ComponentModelClass) {
	                componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
	
	                componentModel.mergeOption(newCmptOption, this);
	                componentModel.optionUpdated(newCmptOption, false);
	              } else {
	                // PENDING Global as parent ?
	                var extraOpt = extend({
	                  componentIndex: index
	                }, resultItem.keyInfo);
	                componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt); // Assign `keyInfo`
	
	                extend(componentModel, extraOpt);
	
	                if (resultItem.brandNew) {
	                  componentModel.__requireNewView = true;
	                }
	
	                componentModel.init(newCmptOption, this, this); // Call optionUpdated after init.
	                // newCmptOption has been used as componentModel.option
	                // and may be merged with theme and default, so pass null
	                // to avoid confusion.
	
	                componentModel.optionUpdated(null, true);
	              }
	            }
	
	            if (componentModel) {
	              optionsByMainType.push(componentModel.option);
	              cmptsByMainType.push(componentModel);
	              cmptsCountByMainType++;
	            } else {
	              // Always do assign to avoid elided item in array.
	              optionsByMainType.push(void 0);
	              cmptsByMainType.push(void 0);
	            }
	          }, this);
	          option[mainType] = optionsByMainType;
	          componentsMap.set(mainType, cmptsByMainType);
	          componentsCount.set(mainType, cmptsCountByMainType); // Backup series for filtering.
	
	          if (mainType === 'series') {
	            reCreateSeriesIndices(this);
	          }
	        } // If no series declared, ensure `_seriesIndices` initialized.
	
	
	        if (!this._seriesIndices) {
	          reCreateSeriesIndices(this);
	        }
	      };
	      /**
	       * Get option for output (cloned option and inner info removed)
	       */
	
	
	      GlobalModel.prototype.getOption = function () {
	        var option = clone(this.option);
	        each(option, function (optInMainType, mainType) {
	          if (ComponentModel.hasClass(mainType)) {
	            var opts = normalizeToArray(optInMainType); // Inner cmpts need to be removed.
	            // Inner cmpts might not be at last since ec5.0, but still
	            // compatible for users: if inner cmpt at last, splice the returned array.
	
	            var realLen = opts.length;
	            var metNonInner = false;
	
	            for (var i = realLen - 1; i >= 0; i--) {
	              // Remove options with inner id.
	              if (opts[i] && !isComponentIdInternal(opts[i])) {
	                metNonInner = true;
	              } else {
	                opts[i] = null;
	                !metNonInner && realLen--;
	              }
	            }
	
	            opts.length = realLen;
	            option[mainType] = opts;
	          }
	        });
	        delete option[OPTION_INNER_KEY];
	        return option;
	      };
	
	      GlobalModel.prototype.getTheme = function () {
	        return this._theme;
	      };
	
	      GlobalModel.prototype.getLocaleModel = function () {
	        return this._locale;
	      };
	
	      GlobalModel.prototype.setUpdatePayload = function (payload) {
	        this._payload = payload;
	      };
	
	      GlobalModel.prototype.getUpdatePayload = function () {
	        return this._payload;
	      };
	      /**
	       * @param idx If not specified, return the first one.
	       */
	
	
	      GlobalModel.prototype.getComponent = function (mainType, idx) {
	        var list = this._componentsMap.get(mainType);
	
	        if (list) {
	          var cmpt = list[idx || 0];
	
	          if (cmpt) {
	            return cmpt;
	          } else if (idx == null) {
	            for (var i = 0; i < list.length; i++) {
	              if (list[i]) {
	                return list[i];
	              }
	            }
	          }
	        }
	      };
	      /**
	       * @return Never be null/undefined.
	       */
	
	
	      GlobalModel.prototype.queryComponents = function (condition) {
	        var mainType = condition.mainType;
	
	        if (!mainType) {
	          return [];
	        }
	
	        var index = condition.index;
	        var id = condition.id;
	        var name = condition.name;
	
	        var cmpts = this._componentsMap.get(mainType);
	
	        if (!cmpts || !cmpts.length) {
	          return [];
	        }
	
	        var result;
	
	        if (index != null) {
	          result = [];
	          each(normalizeToArray(index), function (idx) {
	            cmpts[idx] && result.push(cmpts[idx]);
	          });
	        } else if (id != null) {
	          result = queryByIdOrName('id', id, cmpts);
	        } else if (name != null) {
	          result = queryByIdOrName('name', name, cmpts);
	        } else {
	          // Return all non-empty components in that mainType
	          result = filter(cmpts, function (cmpt) {
	            return !!cmpt;
	          });
	        }
	
	        return filterBySubType(result, condition);
	      };
	      /**
	       * The interface is different from queryComponents,
	       * which is convenient for inner usage.
	       *
	       * @usage
	       * let result = findComponents(
	       *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
	       * );
	       * let result = findComponents(
	       *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
	       * );
	       * let result = findComponents(
	       *     {mainType: 'series',
	       *     filter: function (model, index) {...}}
	       * );
	       * // result like [component0, componnet1, ...]
	       */
	
	
	      GlobalModel.prototype.findComponents = function (condition) {
	        var query = condition.query;
	        var mainType = condition.mainType;
	        var queryCond = getQueryCond(query);
	        var result = queryCond ? this.queryComponents(queryCond) // Retrieve all non-empty components.
	        : filter(this._componentsMap.get(mainType), function (cmpt) {
	          return !!cmpt;
	        });
	        return doFilter(filterBySubType(result, condition));
	
	        function getQueryCond(q) {
	          var indexAttr = mainType + 'Index';
	          var idAttr = mainType + 'Id';
	          var nameAttr = mainType + 'Name';
	          return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
	            mainType: mainType,
	            // subType will be filtered finally.
	            index: q[indexAttr],
	            id: q[idAttr],
	            name: q[nameAttr]
	          } : null;
	        }
	
	        function doFilter(res) {
	          return condition.filter ? filter(res, condition.filter) : res;
	        }
	      };
	
	      GlobalModel.prototype.eachComponent = function (mainType, cb, context) {
	        var componentsMap = this._componentsMap;
	
	        if (isFunction(mainType)) {
	          var ctxForAll_1 = cb;
	          var cbForAll_1 = mainType;
	          componentsMap.each(function (cmpts, componentType) {
	            for (var i = 0; cmpts && i < cmpts.length; i++) {
	              var cmpt = cmpts[i];
	              cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
	            }
	          });
	        } else {
	          var cmpts = isString(mainType) ? componentsMap.get(mainType) : isObject(mainType) ? this.findComponents(mainType) : null;
	
	          for (var i = 0; cmpts && i < cmpts.length; i++) {
	            var cmpt = cmpts[i];
	            cmpt && cb.call(context, cmpt, cmpt.componentIndex);
	          }
	        }
	      };
	      /**
	       * Get series list before filtered by name.
	       */
	
	
	      GlobalModel.prototype.getSeriesByName = function (name) {
	        var nameStr = convertOptionIdName(name, null);
	        return filter(this._componentsMap.get('series'), function (oneSeries) {
	          return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
	        });
	      };
	      /**
	       * Get series list before filtered by index.
	       */
	
	
	      GlobalModel.prototype.getSeriesByIndex = function (seriesIndex) {
	        return this._componentsMap.get('series')[seriesIndex];
	      };
	      /**
	       * Get series list before filtered by type.
	       * FIXME: rename to getRawSeriesByType?
	       */
	
	
	      GlobalModel.prototype.getSeriesByType = function (subType) {
	        return filter(this._componentsMap.get('series'), function (oneSeries) {
	          return !!oneSeries && oneSeries.subType === subType;
	        });
	      };
	      /**
	       * Get all series before filtered.
	       */
	
	
	      GlobalModel.prototype.getSeries = function () {
	        return filter(this._componentsMap.get('series'), function (oneSeries) {
	          return !!oneSeries;
	        });
	      };
	      /**
	       * Count series before filtered.
	       */
	
	
	      GlobalModel.prototype.getSeriesCount = function () {
	        return this._componentsCount.get('series');
	      };
	      /**
	       * After filtering, series may be different
	       * from raw series.
	       */
	
	
	      GlobalModel.prototype.eachSeries = function (cb, context) {
	        assertSeriesInitialized(this);
	        each(this._seriesIndices, function (rawSeriesIndex) {
	          var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	          cb.call(context, series, rawSeriesIndex);
	        }, this);
	      };
	      /**
	       * Iterate raw series before filtered.
	       *
	       * @param {Function} cb
	       * @param {*} context
	       */
	
	
	      GlobalModel.prototype.eachRawSeries = function (cb, context) {
	        each(this._componentsMap.get('series'), function (series) {
	          series && cb.call(context, series, series.componentIndex);
	        });
	      };
	      /**
	       * After filtering, series may be different.
	       * from raw series.
	       */
	
	
	      GlobalModel.prototype.eachSeriesByType = function (subType, cb, context) {
	        assertSeriesInitialized(this);
	        each(this._seriesIndices, function (rawSeriesIndex) {
	          var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	          if (series.subType === subType) {
	            cb.call(context, series, rawSeriesIndex);
	          }
	        }, this);
	      };
	      /**
	       * Iterate raw series before filtered of given type.
	       */
	
	
	      GlobalModel.prototype.eachRawSeriesByType = function (subType, cb, context) {
	        return each(this.getSeriesByType(subType), cb, context);
	      };
	
	      GlobalModel.prototype.isSeriesFiltered = function (seriesModel) {
	        assertSeriesInitialized(this);
	        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
	      };
	
	      GlobalModel.prototype.getCurrentSeriesIndices = function () {
	        return (this._seriesIndices || []).slice();
	      };
	
	      GlobalModel.prototype.filterSeries = function (cb, context) {
	        assertSeriesInitialized(this);
	        var newSeriesIndices = [];
	        each(this._seriesIndices, function (seriesRawIdx) {
	          var series = this._componentsMap.get('series')[seriesRawIdx];
	
	          cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
	        }, this);
	        this._seriesIndices = newSeriesIndices;
	        this._seriesIndicesMap = createHashMap(newSeriesIndices);
	      };
	
	      GlobalModel.prototype.restoreData = function (payload) {
	        reCreateSeriesIndices(this);
	        var componentsMap = this._componentsMap;
	        var componentTypes = [];
	        componentsMap.each(function (components, componentType) {
	          if (ComponentModel.hasClass(componentType)) {
	            componentTypes.push(componentType);
	          }
	        });
	        ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType) {
	          each(componentsMap.get(componentType), function (component) {
	            if (component && (componentType !== 'series' || !isNotTargetSeries(component, payload))) {
	              component.restoreData();
	            }
	          });
	        });
	      };
	
	      GlobalModel.internalField = function () {
	        reCreateSeriesIndices = function (ecModel) {
	          var seriesIndices = ecModel._seriesIndices = [];
	          each(ecModel._componentsMap.get('series'), function (series) {
	            // series may have been removed by `replaceMerge`.
	            series && seriesIndices.push(series.componentIndex);
	          });
	          ecModel._seriesIndicesMap = createHashMap(seriesIndices);
	        };
	
	        assertSeriesInitialized = function (ecModel) {
	          // Components that use _seriesIndices should depends on series component,
	          // which make sure that their initialization is after series.
	          if (true) {
	            if (!ecModel._seriesIndices) {
	              throw new Error('Option should contains series.');
	            }
	          }
	        };
	
	        initBase = function (ecModel, baseOption) {
	          // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
	          // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
	          ecModel.option = {};
	          ecModel.option[OPTION_INNER_KEY] = OPTION_INNER_VALUE; // Init with series: [], in case of calling findSeries method
	          // before series initialized.
	
	          ecModel._componentsMap = createHashMap({
	            series: []
	          });
	          ecModel._componentsCount = createHashMap(); // If user spefied `option.aria`, aria will be enable. This detection should be
	          // performed before theme and globalDefault merge.
	
	          var airaOption = baseOption.aria;
	
	          if (isObject(airaOption) && airaOption.enabled == null) {
	            airaOption.enabled = true;
	          }
	
	          mergeTheme(baseOption, ecModel._theme.option); // TODO Needs clone when merging to the unexisted property
	
	          merge(baseOption, globalDefault, false);
	
	          ecModel._mergeOption(baseOption, null);
	        };
	      }();
	
	      return GlobalModel;
	    }(Model);
	
	    function isNotTargetSeries(seriesModel, payload) {
	      if (payload) {
	        var index = payload.seriesIndex;
	        var id = payload.seriesId;
	        var name_1 = payload.seriesName;
	        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
	      }
	    }
	
	    function mergeTheme(option, theme) {
	      // PENDING
	      // NOT use `colorLayer` in theme if option has `color`
	      var notMergeColorLayer = option.color && !option.colorLayer;
	      each(theme, function (themeItem, name) {
	        if (name === 'colorLayer' && notMergeColorLayer) {
	          return;
	        } // If it is component model mainType, the model handles that merge later.
	        // otherwise, merge them here.
	
	
	        if (!ComponentModel.hasClass(name)) {
	          if (typeof themeItem === 'object') {
	            option[name] = !option[name] ? clone(themeItem) : merge(option[name], themeItem, false);
	          } else {
	            if (option[name] == null) {
	              option[name] = themeItem;
	            }
	          }
	        }
	      });
	    }
	
	    function queryByIdOrName(attr, idOrName, cmpts) {
	      // Here is a break from echarts4: string and number are
	      // treated as equal.
	      if (isArray(idOrName)) {
	        var keyMap_1 = createHashMap();
	        each(idOrName, function (idOrNameItem) {
	          if (idOrNameItem != null) {
	            var idName = convertOptionIdName(idOrNameItem, null);
	            idName != null && keyMap_1.set(idOrNameItem, true);
	          }
	        });
	        return filter(cmpts, function (cmpt) {
	          return cmpt && keyMap_1.get(cmpt[attr]);
	        });
	      } else {
	        var idName_1 = convertOptionIdName(idOrName, null);
	        return filter(cmpts, function (cmpt) {
	          return cmpt && idName_1 != null && cmpt[attr] === idName_1;
	        });
	      }
	    }
	
	    function filterBySubType(components, condition) {
	      // Using hasOwnProperty for restrict. Consider
	      // subType is undefined in user payload.
	      return condition.hasOwnProperty('subType') ? filter(components, function (cmpt) {
	        return cmpt && cmpt.subType === condition.subType;
	      }) : components;
	    }
	
	    function normalizeSetOptionInput(opts) {
	      var replaceMergeMainTypeMap = createHashMap();
	      opts && each(normalizeToArray(opts.replaceMerge), function (mainType) {
	        if (true) {
	          assert(ComponentModel.hasClass(mainType), '"' + mainType + '" is not valid component main type in "replaceMerge"');
	        }
	
	        replaceMergeMainTypeMap.set(mainType, true);
	      });
	      return {
	        replaceMergeMainTypeMap: replaceMergeMainTypeMap
	      };
	    }
	
	    mixin(GlobalModel, PaletteMixin);
	
	    var availableMethods = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isSSR', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', // 'getModel',
	    'getOption', // 'getViewOfComponentModel',
	    // 'getViewOfSeriesModel',
	    'getId', 'updateLabelLayout'];
	
	    var ExtensionAPI =
	    /** @class */
	    function () {
	      function ExtensionAPI(ecInstance) {
	        each(availableMethods, function (methodName) {
	          this[methodName] = bind(ecInstance[methodName], ecInstance);
	        }, this);
	      }
	
	      return ExtensionAPI;
	    }();
	
	    var coordinateSystemCreators = {};
	
	    var CoordinateSystemManager =
	    /** @class */
	    function () {
	      function CoordinateSystemManager() {
	        this._coordinateSystems = [];
	      }
	
	      CoordinateSystemManager.prototype.create = function (ecModel, api) {
	        var coordinateSystems = [];
	        each(coordinateSystemCreators, function (creator, type) {
	          var list = creator.create(ecModel, api);
	          coordinateSystems = coordinateSystems.concat(list || []);
	        });
	        this._coordinateSystems = coordinateSystems;
	      };
	
	      CoordinateSystemManager.prototype.update = function (ecModel, api) {
	        each(this._coordinateSystems, function (coordSys) {
	          coordSys.update && coordSys.update(ecModel, api);
	        });
	      };
	
	      CoordinateSystemManager.prototype.getCoordinateSystems = function () {
	        return this._coordinateSystems.slice();
	      };
	
	      CoordinateSystemManager.register = function (type, creator) {
	        coordinateSystemCreators[type] = creator;
	      };
	
	      CoordinateSystemManager.get = function (type) {
	        return coordinateSystemCreators[type];
	      };
	
	      return CoordinateSystemManager;
	    }();
	
	    var QUERY_REG = /^(min|max)?(.+)$/; // Key: mainType
	    // type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
	
	    /**
	     * TERM EXPLANATIONS:
	     * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
	     */
	
	    var OptionManager =
	    /** @class */
	    function () {
	      // timeline.notMerge is not supported in ec3. Firstly there is rearly
	      // case that notMerge is needed. Secondly supporting 'notMerge' requires
	      // rawOption cloned and backuped when timeline changed, which does no
	      // good to performance. What's more, that both timeline and setOption
	      // method supply 'notMerge' brings complex and some problems.
	      // Consider this case:
	      // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
	      // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
	      function OptionManager(api) {
	        this._timelineOptions = [];
	        this._mediaList = [];
	        /**
	         * -1, means default.
	         * empty means no media.
	         */
	
	        this._currentMediaIndices = [];
	        this._api = api;
	      }
	
	      OptionManager.prototype.setOption = function (rawOption, optionPreprocessorFuncs, opt) {
	        if (rawOption) {
	          // That set dat primitive is dangerous if user reuse the data when setOption again.
	          each(normalizeToArray(rawOption.series), function (series) {
	            series && series.data && isTypedArray(series.data) && setAsPrimitive(series.data);
	          });
	          each(normalizeToArray(rawOption.dataset), function (dataset) {
	            dataset && dataset.source && isTypedArray(dataset.source) && setAsPrimitive(dataset.source);
	          });
	        } // Caution: some series modify option data, if do not clone,
	        // it should ensure that the repeat modify correctly
	        // (create a new object when modify itself).
	
	
	        rawOption = clone(rawOption); // FIXME
	        // If some property is set in timeline options or media option but
	        // not set in baseOption, a warning should be given.
	
	        var optionBackup = this._optionBackup;
	        var newParsedOption = parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
	        this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
	
	        if (optionBackup) {
	          // FIXME
	          // the restore merge solution is essentially incorrect.
	          // the mapping can not be 100% consistent with ecModel, which probably brings
	          // potential bug!
	          // The first merge is delayed, because in most cases, users do not call `setOption` twice.
	          // let fakeCmptsMap = this._fakeCmptsMap;
	          // if (!fakeCmptsMap) {
	          //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
	          //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
	          // }
	          // mergeToBackupOption(
	          //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
	          // );
	          // For simplicity, timeline options and media options do not support merge,
	          // that is, if you `setOption` twice and both has timeline options, the latter
	          // timeline options will not be merged to the former, but just substitute them.
	          if (newParsedOption.timelineOptions.length) {
	            optionBackup.timelineOptions = newParsedOption.timelineOptions;
	          }
	
	          if (newParsedOption.mediaList.length) {
	            optionBackup.mediaList = newParsedOption.mediaList;
	          }
	
	          if (newParsedOption.mediaDefault) {
	            optionBackup.mediaDefault = newParsedOption.mediaDefault;
	          }
	        } else {
	          this._optionBackup = newParsedOption;
	        }
	      };
	
	      OptionManager.prototype.mountOption = function (isRecreate) {
	        var optionBackup = this._optionBackup;
	        this._timelineOptions = optionBackup.timelineOptions;
	        this._mediaList = optionBackup.mediaList;
	        this._mediaDefault = optionBackup.mediaDefault;
	        this._currentMediaIndices = [];
	        return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
	        // called, and is merged into every new option by inner method `mergeToBackupOption`
	        // each time `setOption` called, can be only used in `isRecreate`, because
	        // its reliability is under suspicion. In other cases option merge is
	        // performed by `model.mergeOption`.
	        ? optionBackup.baseOption : this._newBaseOption);
	      };
	
	      OptionManager.prototype.getTimelineOption = function (ecModel) {
	        var option;
	        var timelineOptions = this._timelineOptions;
	
	        if (timelineOptions.length) {
	          // getTimelineOption can only be called after ecModel inited,
	          // so we can get currentIndex from timelineModel.
	          var timelineModel = ecModel.getComponent('timeline');
	
	          if (timelineModel) {
	            option = clone( // FIXME:TS as TimelineModel or quivlant interface
	            timelineOptions[timelineModel.getCurrentIndex()]);
	          }
	        }
	
	        return option;
	      };
	
	      OptionManager.prototype.getMediaOption = function (ecModel) {
	        var ecWidth = this._api.getWidth();
	
	        var ecHeight = this._api.getHeight();
	
	        var mediaList = this._mediaList;
	        var mediaDefault = this._mediaDefault;
	        var indices = [];
	        var result = []; // No media defined.
	
	        if (!mediaList.length && !mediaDefault) {
	          return result;
	        } // Multi media may be applied, the latter defined media has higher priority.
	
	
	        for (var i = 0, len = mediaList.length; i < len; i++) {
	          if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
	            indices.push(i);
	          }
	        } // FIXME
	        // Whether mediaDefault should force users to provide? Otherwise
	        // the change by media query can not be recorvered.
	
	
	        if (!indices.length && mediaDefault) {
	          indices = [-1];
	        }
	
	        if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
	          result = map(indices, function (index) {
	            return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
	          });
	        } // Otherwise return nothing.
	
	
	        this._currentMediaIndices = indices;
	        return result;
	      };
	
	      return OptionManager;
	    }();
	    /**
	     * [RAW_OPTION_PATTERNS]
	     * (Note: "series: []" represents all other props in `ECUnitOption`)
	     *
	     * (1) No prop "baseOption" declared:
	     * Root option is used as "baseOption" (except prop "options" and "media").
	     * ```js
	     * option = {
	     *     series: [],
	     *     timeline: {},
	     *     options: [],
	     * };
	     * option = {
	     *     series: [],
	     *     media: {},
	     * };
	     * option = {
	     *     series: [],
	     *     timeline: {},
	     *     options: [],
	     *     media: {},
	     * }
	     * ```
	     *
	     * (2) Prop "baseOption" declared:
	     * If "baseOption" declared, `ECUnitOption` props can only be declared
	     * inside "baseOption" except prop "timeline" (compat ec2).
	     * ```js
	     * option = {
	     *     baseOption: {
	     *         timeline: {},
	     *         series: [],
	     *     },
	     *     options: []
	     * };
	     * option = {
	     *     baseOption: {
	     *         series: [],
	     *     },
	     *     media: []
	     * };
	     * option = {
	     *     baseOption: {
	     *         timeline: {},
	     *         series: [],
	     *     },
	     *     options: []
	     *     media: []
	     * };
	     * option = {
	     *     // ec3 compat ec2: allow (only) `timeline` declared
	     *     // outside baseOption. Keep this setting for compat.
	     *     timeline: {},
	     *     baseOption: {
	     *         series: [],
	     *     },
	     *     options: [],
	     *     media: []
	     * };
	     * ```
	     */
	
	
	    function parseRawOption( // `rawOption` May be modified
	    rawOption, optionPreprocessorFuncs, isNew) {
	      var mediaList = [];
	      var mediaDefault;
	      var baseOption;
	      var declaredBaseOption = rawOption.baseOption; // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
	
	      var timelineOnRoot = rawOption.timeline;
	      var timelineOptionsOnRoot = rawOption.options;
	      var mediaOnRoot = rawOption.media;
	      var hasMedia = !!rawOption.media;
	      var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
	
	      if (declaredBaseOption) {
	        baseOption = declaredBaseOption; // For merge option.
	
	        if (!baseOption.timeline) {
	          baseOption.timeline = timelineOnRoot;
	        }
	      } // For convenience, enable to use the root option as the `baseOption`:
	      // `{ ...normalOptionProps, media: [{ ... }, { ... }] }`
	      else {
	          if (hasTimeline || hasMedia) {
	            rawOption.options = rawOption.media = null;
	          }
	
	          baseOption = rawOption;
	        }
	
	      if (hasMedia) {
	        if (isArray(mediaOnRoot)) {
	          each(mediaOnRoot, function (singleMedia) {
	            if (true) {
	              // Real case of wrong config.
	              if (singleMedia && !singleMedia.option && isObject(singleMedia.query) && isObject(singleMedia.query.option)) {
	                error('Illegal media option. Must be like { media: [ { query: {}, option: {} } ] }');
	              }
	            }
	
	            if (singleMedia && singleMedia.option) {
	              if (singleMedia.query) {
	                mediaList.push(singleMedia);
	              } else if (!mediaDefault) {
	                // Use the first media default.
	                mediaDefault = singleMedia;
	              }
	            }
	          });
	        } else {
	          if (true) {
	            // Real case of wrong config.
	            error('Illegal media option. Must be an array. Like { media: [ {...}, {...} ] }');
	          }
	        }
	      }
	
	      doPreprocess(baseOption);
	      each(timelineOptionsOnRoot, function (option) {
	        return doPreprocess(option);
	      });
	      each(mediaList, function (media) {
	        return doPreprocess(media.option);
	      });
	
	      function doPreprocess(option) {
	        each(optionPreprocessorFuncs, function (preProcess) {
	          preProcess(option, isNew);
	        });
	      }
	
	      return {
	        baseOption: baseOption,
	        timelineOptions: timelineOptionsOnRoot || [],
	        mediaDefault: mediaDefault,
	        mediaList: mediaList
	      };
	    }
	    /**
	     * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
	     * Support: width, height, aspectRatio
	     * Can use max or min as prefix.
	     */
	
	
	    function applyMediaQuery(query, ecWidth, ecHeight) {
	      var realMap = {
	        width: ecWidth,
	        height: ecHeight,
	        aspectratio: ecWidth / ecHeight // lower case for convenience.
	
	      };
	      var applicable = true;
	      each(query, function (value, attr) {
	        var matched = attr.match(QUERY_REG);
	
	        if (!matched || !matched[1] || !matched[2]) {
	          return;
	        }
	
	        var operator = matched[1];
	        var realAttr = matched[2].toLowerCase();
	
	        if (!compare(realMap[realAttr], value, operator)) {
	          applicable = false;
	        }
	      });
	      return applicable;
	    }
	
	    function compare(real, expect, operator) {
	      if (operator === 'min') {
	        return real >= expect;
	      } else if (operator === 'max') {
	        return real <= expect;
	      } else {
	        // Equals
	        return real === expect;
	      }
	    }
	
	    function indicesEquals(indices1, indices2) {
	      // indices is always order by asc and has only finite number.
	      return indices1.join(',') === indices2.join(',');
	    }
	
	    var each$2 = each;
	    var isObject$1 = isObject;
	    var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];
	
	    function compatEC2ItemStyle(opt) {
	      var itemStyleOpt = opt && opt.itemStyle;
	
	      if (!itemStyleOpt) {
	        return;
	      }
	
	      for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
	        var styleName = POSSIBLE_STYLES[i];
	        var normalItemStyleOpt = itemStyleOpt.normal;
	        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
	
	        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
	          if (true) {
	            deprecateReplaceLog("itemStyle.normal." + styleName, styleName);
	          }
	
	          opt[styleName] = opt[styleName] || {};
	
	          if (!opt[styleName].normal) {
	            opt[styleName].normal = normalItemStyleOpt[styleName];
	          } else {
	            merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
	          }
	
	          normalItemStyleOpt[styleName] = null;
	        }
	
	        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
	          if (true) {
	            deprecateReplaceLog("itemStyle.emphasis." + styleName, "emphasis." + styleName);
	          }
	
	          opt[styleName] = opt[styleName] || {};
	
	          if (!opt[styleName].emphasis) {
	            opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
	          } else {
	            merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
	          }
	
	          emphasisItemStyleOpt[styleName] = null;
	        }
	      }
	    }
	
	    function convertNormalEmphasis(opt, optType, useExtend) {
	      if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
	        var normalOpt = opt[optType].normal;
	        var emphasisOpt = opt[optType].emphasis;
	
	        if (normalOpt) {
	          if (true) {
	            // eslint-disable-next-line max-len
	            deprecateLog("'normal' hierarchy in " + optType + " has been removed since 4.0. All style properties are configured in " + optType + " directly now.");
	          } // Timeline controlStyle has other properties besides normal and emphasis
	
	
	          if (useExtend) {
	            opt[optType].normal = opt[optType].emphasis = null;
	            defaults(opt[optType], normalOpt);
	          } else {
	            opt[optType] = normalOpt;
	          }
	        }
	
	        if (emphasisOpt) {
	          if (true) {
	            deprecateLog(optType + ".emphasis has been changed to emphasis." + optType + " since 4.0");
	          }
	
	          opt.emphasis = opt.emphasis || {};
	          opt.emphasis[optType] = emphasisOpt; // Also compat the case user mix the style and focus together in ec3 style
	          // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
	
	          if (emphasisOpt.focus) {
	            opt.emphasis.focus = emphasisOpt.focus;
	          }
	
	          if (emphasisOpt.blurScope) {
	            opt.emphasis.blurScope = emphasisOpt.blurScope;
	          }
	        }
	      }
	    }
	
	    function removeEC3NormalStatus(opt) {
	      convertNormalEmphasis(opt, 'itemStyle');
	      convertNormalEmphasis(opt, 'lineStyle');
	      convertNormalEmphasis(opt, 'areaStyle');
	      convertNormalEmphasis(opt, 'label');
	      convertNormalEmphasis(opt, 'labelLine'); // treemap
	
	      convertNormalEmphasis(opt, 'upperLabel'); // graph
	
	      convertNormalEmphasis(opt, 'edgeLabel');
	    }
	
	    function compatTextStyle(opt, propName) {
	      // Check whether is not object (string\null\undefined ...)
	      var labelOptSingle = isObject$1(opt) && opt[propName];
	      var textStyle = isObject$1(labelOptSingle) && labelOptSingle.textStyle;
	
	      if (textStyle) {
	        if (true) {
	          // eslint-disable-next-line max-len
	          deprecateLog("textStyle hierarchy in " + propName + " has been removed since 4.0. All textStyle properties are configured in " + propName + " directly now.");
	        }
	
	        for (var i = 0, len = TEXT_STYLE_OPTIONS.length; i < len; i++) {
	          var textPropName = TEXT_STYLE_OPTIONS[i];
	
	          if (textStyle.hasOwnProperty(textPropName)) {
	            labelOptSingle[textPropName] = textStyle[textPropName];
	          }
	        }
	      }
	    }
	
	    function compatEC3CommonStyles(opt) {
	      if (opt) {
	        removeEC3NormalStatus(opt);
	        compatTextStyle(opt, 'label');
	        opt.emphasis && compatTextStyle(opt.emphasis, 'label');
	      }
	    }
	
	    function processSeries(seriesOpt) {
	      if (!isObject$1(seriesOpt)) {
	        return;
	      }
	
	      compatEC2ItemStyle(seriesOpt);
	      removeEC3NormalStatus(seriesOpt);
	      compatTextStyle(seriesOpt, 'label'); // treemap
	
	      compatTextStyle(seriesOpt, 'upperLabel'); // graph
	
	      compatTextStyle(seriesOpt, 'edgeLabel');
	
	      if (seriesOpt.emphasis) {
	        compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
	
	        compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
	
	        compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
	      }
	
	      var markPoint = seriesOpt.markPoint;
	
	      if (markPoint) {
	        compatEC2ItemStyle(markPoint);
	        compatEC3CommonStyles(markPoint);
	      }
	
	      var markLine = seriesOpt.markLine;
	
	      if (markLine) {
	        compatEC2ItemStyle(markLine);
	        compatEC3CommonStyles(markLine);
	      }
	
	      var markArea = seriesOpt.markArea;
	
	      if (markArea) {
	        compatEC3CommonStyles(markArea);
	      }
	
	      var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
	      // then the backward compat based on option type will not be performed.
	
	      if (seriesOpt.type === 'graph') {
	        data = data || seriesOpt.nodes;
	        var edgeData = seriesOpt.links || seriesOpt.edges;
	
	        if (edgeData && !isTypedArray(edgeData)) {
	          for (var i = 0; i < edgeData.length; i++) {
	            compatEC3CommonStyles(edgeData[i]);
	          }
	        }
	
	        each(seriesOpt.categories, function (opt) {
	          removeEC3NormalStatus(opt);
	        });
	      }
	
	      if (data && !isTypedArray(data)) {
	        for (var i = 0; i < data.length; i++) {
	          compatEC3CommonStyles(data[i]);
	        }
	      } // mark point data
	
	
	      markPoint = seriesOpt.markPoint;
	
	      if (markPoint && markPoint.data) {
	        var mpData = markPoint.data;
	
	        for (var i = 0; i < mpData.length; i++) {
	          compatEC3CommonStyles(mpData[i]);
	        }
	      } // mark line data
	
	
	      markLine = seriesOpt.markLine;
	
	      if (markLine && markLine.data) {
	        var mlData = markLine.data;
	
	        for (var i = 0; i < mlData.length; i++) {
	          if (isArray(mlData[i])) {
	            compatEC3CommonStyles(mlData[i][0]);
	            compatEC3CommonStyles(mlData[i][1]);
	          } else {
	            compatEC3CommonStyles(mlData[i]);
	          }
	        }
	      } // Series
	
	
	      if (seriesOpt.type === 'gauge') {
	        compatTextStyle(seriesOpt, 'axisLabel');
	        compatTextStyle(seriesOpt, 'title');
	        compatTextStyle(seriesOpt, 'detail');
	      } else if (seriesOpt.type === 'treemap') {
	        convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
	        each(seriesOpt.levels, function (opt) {
	          removeEC3NormalStatus(opt);
	        });
	      } else if (seriesOpt.type === 'tree') {
	        removeEC3NormalStatus(seriesOpt.leaves);
	      } // sunburst starts from ec4, so it does not need to compat levels.
	
	    }
	
	    function toArr(o) {
	      return isArray(o) ? o : o ? [o] : [];
	    }
	
	    function toObj(o) {
	      return (isArray(o) ? o[0] : o) || {};
	    }
	
	    function globalCompatStyle(option, isTheme) {
	      each$2(toArr(option.series), function (seriesOpt) {
	        isObject$1(seriesOpt) && processSeries(seriesOpt);
	      });
	      var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
	      isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
	      each$2(axes, function (axisName) {
	        each$2(toArr(option[axisName]), function (axisOpt) {
	          if (axisOpt) {
	            compatTextStyle(axisOpt, 'axisLabel');
	            compatTextStyle(axisOpt.axisPointer, 'label');
	          }
	        });
	      });
	      each$2(toArr(option.parallel), function (parallelOpt) {
	        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
	        compatTextStyle(parallelAxisDefault, 'axisLabel');
	        compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
	      });
	      each$2(toArr(option.calendar), function (calendarOpt) {
	        convertNormalEmphasis(calendarOpt, 'itemStyle');
	        compatTextStyle(calendarOpt, 'dayLabel');
	        compatTextStyle(calendarOpt, 'monthLabel');
	        compatTextStyle(calendarOpt, 'yearLabel');
	      }); // radar.name.textStyle
	
	      each$2(toArr(option.radar), function (radarOpt) {
	        compatTextStyle(radarOpt, 'name'); // Use axisName instead of name because component has name property
	
	        if (radarOpt.name && radarOpt.axisName == null) {
	          radarOpt.axisName = radarOpt.name;
	          delete radarOpt.name;
	
	          if (true) {
	            deprecateLog('name property in radar component has been changed to axisName');
	          }
	        }
	
	        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
	          radarOpt.axisNameGap = radarOpt.nameGap;
	          delete radarOpt.nameGap;
	
	          if (true) {
	            deprecateLog('nameGap property in radar component has been changed to axisNameGap');
	          }
	        }
	
	        if (true) {
	          each$2(radarOpt.indicator, function (indicatorOpt) {
	            if (indicatorOpt.text) {
	              deprecateReplaceLog('text', 'name', 'radar.indicator');
	            }
	          });
	        }
	      });
	      each$2(toArr(option.geo), function (geoOpt) {
	        if (isObject$1(geoOpt)) {
	          compatEC3CommonStyles(geoOpt);
	          each$2(toArr(geoOpt.regions), function (regionObj) {
	            compatEC3CommonStyles(regionObj);
	          });
	        }
	      });
	      each$2(toArr(option.timeline), function (timelineOpt) {
	        compatEC3CommonStyles(timelineOpt);
	        convertNormalEmphasis(timelineOpt, 'label');
	        convertNormalEmphasis(timelineOpt, 'itemStyle');
	        convertNormalEmphasis(timelineOpt, 'controlStyle', true);
	        var data = timelineOpt.data;
	        isArray(data) && each(data, function (item) {
	          if (isObject(item)) {
	            convertNormalEmphasis(item, 'label');
	            convertNormalEmphasis(item, 'itemStyle');
	          }
	        });
	      });
	      each$2(toArr(option.toolbox), function (toolboxOpt) {
	        convertNormalEmphasis(toolboxOpt, 'iconStyle');
	        each$2(toolboxOpt.feature, function (featureOpt) {
	          convertNormalEmphasis(featureOpt, 'iconStyle');
	        });
	      });
	      compatTextStyle(toObj(option.axisPointer), 'label');
	      compatTextStyle(toObj(option.tooltip).axisPointer, 'label'); // Clean logs
	      // storedLogs = {};
	    }
	
	    function get(opt, path) {
	      var pathArr = path.split(',');
	      var obj = opt;
	
	      for (var i = 0; i < pathArr.length; i++) {
	        obj = obj && obj[pathArr[i]];
	
	        if (obj == null) {
	          break;
	        }
	      }
	
	      return obj;
	    }
	
	    function set$1(opt, path, val, overwrite) {
	      var pathArr = path.split(',');
	      var obj = opt;
	      var key;
	      var i = 0;
	
	      for (; i < pathArr.length - 1; i++) {
	        key = pathArr[i];
	
	        if (obj[key] == null) {
	          obj[key] = {};
	        }
	
	        obj = obj[key];
	      }
	
	      if (overwrite || obj[pathArr[i]] == null) {
	        obj[pathArr[i]] = val;
	      }
	    }
	
	    function compatLayoutProperties(option) {
	      option && each(LAYOUT_PROPERTIES, function (prop) {
	        if (prop[0] in option && !(prop[1] in option)) {
	          option[prop[1]] = option[prop[0]];
	        }
	      });
	    }
	
	    var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
	    var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
	    var BAR_ITEM_STYLE_MAP = [['borderRadius', 'barBorderRadius'], ['borderColor', 'barBorderColor'], ['borderWidth', 'barBorderWidth']];
	
	    function compatBarItemStyle(option) {
	      var itemStyle = option && option.itemStyle;
	
	      if (itemStyle) {
	        for (var i = 0; i < BAR_ITEM_STYLE_MAP.length; i++) {
	          var oldName = BAR_ITEM_STYLE_MAP[i][1];
	          var newName = BAR_ITEM_STYLE_MAP[i][0];
	
	          if (itemStyle[oldName] != null) {
	            itemStyle[newName] = itemStyle[oldName];
	
	            if (true) {
	              deprecateReplaceLog(oldName, newName);
	            }
	          }
	        }
	      }
	    }
	
	    function compatPieLabel(option) {
	      if (!option) {
	        return;
	      }
	
	      if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) {
	        if (true) {
	          deprecateReplaceLog('label.margin', 'label.edgeDistance', 'pie');
	        }
	
	        option.edgeDistance = option.margin;
	      }
	    }
	
	    function compatSunburstState(option) {
	      if (!option) {
	        return;
	      }
	
	      if (option.downplay && !option.blur) {
	        option.blur = option.downplay;
	
	        if (true) {
	          deprecateReplaceLog('downplay', 'blur', 'sunburst');
	        }
	      }
	    }
	
	    function compatGraphFocus(option) {
	      if (!option) {
	        return;
	      }
	
	      if (option.focusNodeAdjacency != null) {
	        option.emphasis = option.emphasis || {};
	
	        if (option.emphasis.focus == null) {
	          if (true) {
	            deprecateReplaceLog('focusNodeAdjacency', 'emphasis: { focus: \'adjacency\'}', 'graph/sankey');
	          }
	
	          option.emphasis.focus = 'adjacency';
	        }
	      }
	    }
	
	    function traverseTree(data, cb) {
	      if (data) {
	        for (var i = 0; i < data.length; i++) {
	          cb(data[i]);
	          data[i] && traverseTree(data[i].children, cb);
	        }
	      }
	    }
	
	    function globalBackwardCompat(option, isTheme) {
	      globalCompatStyle(option, isTheme); // Make sure series array for model initialization.
	
	      option.series = normalizeToArray(option.series);
	      each(option.series, function (seriesOpt) {
	        if (!isObject(seriesOpt)) {
	          return;
	        }
	
	        var seriesType = seriesOpt.type;
	
	        if (seriesType === 'line') {
	          if (seriesOpt.clipOverflow != null) {
	            seriesOpt.clip = seriesOpt.clipOverflow;
	
	            if (true) {
	              deprecateReplaceLog('clipOverflow', 'clip', 'line');
	            }
	          }
	        } else if (seriesType === 'pie' || seriesType === 'gauge') {
	          if (seriesOpt.clockWise != null) {
	            seriesOpt.clockwise = seriesOpt.clockWise;
	
	            if (true) {
	              deprecateReplaceLog('clockWise', 'clockwise');
	            }
	          }
	
	          compatPieLabel(seriesOpt.label);
	          var data = seriesOpt.data;
	
	          if (data && !isTypedArray(data)) {
	            for (var i = 0; i < data.length; i++) {
	              compatPieLabel(data[i]);
	            }
	          }
	
	          if (seriesOpt.hoverOffset != null) {
	            seriesOpt.emphasis = seriesOpt.emphasis || {};
	
	            if (seriesOpt.emphasis.scaleSize = null) {
	              if (true) {
	                deprecateReplaceLog('hoverOffset', 'emphasis.scaleSize');
	              }
	
	              seriesOpt.emphasis.scaleSize = seriesOpt.hoverOffset;
	            }
	          }
	        } else if (seriesType === 'gauge') {
	          var pointerColor = get(seriesOpt, 'pointer.color');
	          pointerColor != null && set$1(seriesOpt, 'itemStyle.color', pointerColor);
	        } else if (seriesType === 'bar') {
	          compatBarItemStyle(seriesOpt);
	          compatBarItemStyle(seriesOpt.backgroundStyle);
	          compatBarItemStyle(seriesOpt.emphasis);
	          var data = seriesOpt.data;
	
	          if (data && !isTypedArray(data)) {
	            for (var i = 0; i < data.length; i++) {
	              if (typeof data[i] === 'object') {
	                compatBarItemStyle(data[i]);
	                compatBarItemStyle(data[i] && data[i].emphasis);
	              }
	            }
	          }
	        } else if (seriesType === 'sunburst') {
	          var highlightPolicy = seriesOpt.highlightPolicy;
	
	          if (highlightPolicy) {
	            seriesOpt.emphasis = seriesOpt.emphasis || {};
	
	            if (!seriesOpt.emphasis.focus) {
	              seriesOpt.emphasis.focus = highlightPolicy;
	
	              if (true) {
	                deprecateReplaceLog('highlightPolicy', 'emphasis.focus', 'sunburst');
	              }
	            }
	          }
	
	          compatSunburstState(seriesOpt);
	          traverseTree(seriesOpt.data, compatSunburstState);
	        } else if (seriesType === 'graph' || seriesType === 'sankey') {
	          compatGraphFocus(seriesOpt); // TODO nodes, edges?
	        } else if (seriesType === 'map') {
	          if (seriesOpt.mapType && !seriesOpt.map) {
	            if (true) {
	              deprecateReplaceLog('mapType', 'map', 'map');
	            }
	
	            seriesOpt.map = seriesOpt.mapType;
	          }
	
	          if (seriesOpt.mapLocation) {
	            if (true) {
	              deprecateLog('`mapLocation` is not used anymore.');
	            }
	
	            defaults(seriesOpt, seriesOpt.mapLocation);
	          }
	        }
	
	        if (seriesOpt.hoverAnimation != null) {
	          seriesOpt.emphasis = seriesOpt.emphasis || {};
	
	          if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) {
	            if (true) {
	              deprecateReplaceLog('hoverAnimation', 'emphasis.scale');
	            }
	
	            seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
	          }
	        }
	
	        compatLayoutProperties(seriesOpt);
	      }); // dataRange has changed to visualMap
	
	      if (option.dataRange) {
	        option.visualMap = option.dataRange;
	      }
	
	      each(COMPATITABLE_COMPONENTS, function (componentName) {
	        var options = option[componentName];
	
	        if (options) {
	          if (!isArray(options)) {
	            options = [options];
	          }
	
	          each(options, function (option) {
	            compatLayoutProperties(option);
	          });
	        }
	      });
	    }
	
	    //     data processing stage is blocked in stream.
	    //     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
	    // (2) Only register once when import repeatedly.
	    //     Should be executed after series is filtered and before stack calculation.
	
	    function dataStack(ecModel) {
	      var stackInfoMap = createHashMap();
	      ecModel.eachSeries(function (seriesModel) {
	        var stack = seriesModel.get('stack'); // Compatible: when `stack` is set as '', do not stack.
	
	        if (stack) {
	          var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
	          var data = seriesModel.getData();
	          var stackInfo = {
	            // Used for calculate axis extent automatically.
	            // TODO: Type getCalculationInfo return more specific type?
	            stackResultDimension: data.getCalculationInfo('stackResultDimension'),
	            stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
	            stackedDimension: data.getCalculationInfo('stackedDimension'),
	            stackedByDimension: data.getCalculationInfo('stackedByDimension'),
	            isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
	            data: data,
	            seriesModel: seriesModel
	          }; // If stacked on axis that do not support data stack.
	
	          if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
	            return;
	          }
	
	          stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
	          stackInfoList.push(stackInfo);
	        }
	      });
	      stackInfoMap.each(calculateStack);
	    }
	
	    function calculateStack(stackInfoList) {
	      each(stackInfoList, function (targetStackInfo, idxInStack) {
	        var resultVal = [];
	        var resultNaN = [NaN, NaN];
	        var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
	        var targetData = targetStackInfo.data;
	        var isStackedByIndex = targetStackInfo.isStackedByIndex;
	        var stackStrategy = targetStackInfo.seriesModel.get('stackStrategy') || 'samesign'; // Should not write on raw data, because stack series model list changes
	        // depending on legend selection.
	
	        targetData.modify(dims, function (v0, v1, dataIndex) {
	          var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
	          // should also be NaN, to draw a appropriate belt area.
	
	          if (isNaN(sum)) {
	            return resultNaN;
	          }
	
	          var byValue;
	          var stackedDataRawIndex;
	
	          if (isStackedByIndex) {
	            stackedDataRawIndex = targetData.getRawIndex(dataIndex);
	          } else {
	            byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
	          } // If stackOver is NaN, chart view will render point on value start.
	
	
	          var stackedOver = NaN;
	
	          for (var j = idxInStack - 1; j >= 0; j--) {
	            var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
	
	            if (!isStackedByIndex) {
	              stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
	            }
	
	            if (stackedDataRawIndex >= 0) {
	              var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
	
	              if (stackStrategy === 'all' // single stack group
	              || stackStrategy === 'positive' && val > 0 || stackStrategy === 'negative' && val < 0 || stackStrategy === 'samesign' && sum >= 0 && val > 0 // All positive stack
	              || stackStrategy === 'samesign' && sum <= 0 && val < 0 // All negative stack
	              ) {
	                  // The sum has to be very small to be affected by the
	                  // floating arithmetic problem. An incorrect result will probably
	                  // cause axis min/max to be filtered incorrectly.
	                  sum = addSafe(sum, val);
	                  stackedOver = val;
	                  break;
	                }
	            }
	          }
	
	          resultVal[0] = sum;
	          resultVal[1] = stackedOver;
	          return resultVal;
	        });
	      });
	    }
	
	    var SourceImpl =
	    /** @class */
	    function () {
	      function SourceImpl(fields) {
	        this.data = fields.data || (fields.sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
	        this.sourceFormat = fields.sourceFormat || SOURCE_FORMAT_UNKNOWN; // Visit config
	
	        this.seriesLayoutBy = fields.seriesLayoutBy || SERIES_LAYOUT_BY_COLUMN;
	        this.startIndex = fields.startIndex || 0;
	        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
	        this.metaRawOption = fields.metaRawOption;
	        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
	
	        if (dimensionsDefine) {
	          for (var i = 0; i < dimensionsDefine.length; i++) {
	            var dim = dimensionsDefine[i];
	
	            if (dim.type == null) {
	              if (guessOrdinal(this, i) === BE_ORDINAL.Must) {
	                dim.type = 'ordinal';
	              }
	            }
	          }
	        }
	      }
	
	      return SourceImpl;
	    }();
	
	    function isSourceInstance(val) {
	      return val instanceof SourceImpl;
	    }
	    /**
	     * Create a source from option.
	     * NOTE: Created source is immutable. Don't change any properties in it.
	     */
	
	    function createSource(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
	    sourceFormat) {
	      sourceFormat = sourceFormat || detectSourceFormat(sourceData);
	      var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
	      var determined = determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
	      var source = new SourceImpl({
	        data: sourceData,
	        sourceFormat: sourceFormat,
	        seriesLayoutBy: seriesLayoutBy,
	        dimensionsDefine: determined.dimensionsDefine,
	        startIndex: determined.startIndex,
	        dimensionsDetectedCount: determined.dimensionsDetectedCount,
	        metaRawOption: clone(thisMetaRawOption)
	      });
	      return source;
	    }
	    /**
	     * Wrap original series data for some compatibility cases.
	     */
	
	    function createSourceFromSeriesDataOption(data) {
	      return new SourceImpl({
	        data: data,
	        sourceFormat: isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL
	      });
	    }
	    /**
	     * Clone source but excludes source data.
	     */
	
	    function cloneSourceShallow(source) {
	      return new SourceImpl({
	        data: source.data,
	        sourceFormat: source.sourceFormat,
	        seriesLayoutBy: source.seriesLayoutBy,
	        dimensionsDefine: clone(source.dimensionsDefine),
	        startIndex: source.startIndex,
	        dimensionsDetectedCount: source.dimensionsDetectedCount
	      });
	    }
	    /**
	     * Note: An empty array will be detected as `SOURCE_FORMAT_ARRAY_ROWS`.
	     */
	
	    function detectSourceFormat(data) {
	      var sourceFormat = SOURCE_FORMAT_UNKNOWN;
	
	      if (isTypedArray(data)) {
	        sourceFormat = SOURCE_FORMAT_TYPED_ARRAY;
	      } else if (isArray(data)) {
	        // FIXME Whether tolerate null in top level array?
	        if (data.length === 0) {
	          sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	        }
	
	        for (var i = 0, len = data.length; i < len; i++) {
	          var item = data[i];
	
	          if (item == null) {
	            continue;
	          } else if (isArray(item)) {
	            sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	            break;
	          } else if (isObject(item)) {
	            sourceFormat = SOURCE_FORMAT_OBJECT_ROWS;
	            break;
	          }
	        }
	      } else if (isObject(data)) {
	        for (var key in data) {
	          if (hasOwn(data, key) && isArrayLike(data[key])) {
	            sourceFormat = SOURCE_FORMAT_KEYED_COLUMNS;
	            break;
	          }
	        }
	      }
	
	      return sourceFormat;
	    }
	    /**
	     * Determine the source definitions from data standalone dimensions definitions
	     * are not specified.
	     */
	
	    function determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
	    // {
	    //     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
	    // }
	    // in `dataset` or `series`
	    dimensionsDefine) {
	      var dimensionsDetectedCount;
	      var startIndex; // PENDING: Could data be null/undefined here?
	      // currently, if `dataset.source` not specified, error thrown.
	      // if `series.data` not specified, nothing rendered without error thrown.
	      // Should test these cases.
	
	      if (!data) {
	        return {
	          dimensionsDefine: normalizeDimensionsOption(dimensionsDefine),
	          startIndex: startIndex,
	          dimensionsDetectedCount: dimensionsDetectedCount
	        };
	      }
	
	      if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	        var dataArrayRows = data; // Rule: Most of the first line are string: it is header.
	        // Caution: consider a line with 5 string and 1 number,
	        // it still can not be sure it is a head, because the
	        // 5 string may be 5 values of category columns.
	
	        if (sourceHeader === 'auto' || sourceHeader == null) {
	          arrayRowsTravelFirst(function (val) {
	            // '-' is regarded as null/undefined.
	            if (val != null && val !== '-') {
	              if (isString(val)) {
	                startIndex == null && (startIndex = 1);
	              } else {
	                startIndex = 0;
	              }
	            } // 10 is an experience number, avoid long loop.
	
	          }, seriesLayoutBy, dataArrayRows, 10);
	        } else {
	          startIndex = isNumber(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
	        }
	
	        if (!dimensionsDefine && startIndex === 1) {
	          dimensionsDefine = [];
	          arrayRowsTravelFirst(function (val, index) {
	            dimensionsDefine[index] = val != null ? val + '' : '';
	          }, seriesLayoutBy, dataArrayRows, Infinity);
	        }
	
	        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === SERIES_LAYOUT_BY_ROW ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
	      } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	        if (!dimensionsDefine) {
	          dimensionsDefine = objectRowsCollectDimensions(data);
	        }
	      } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	        if (!dimensionsDefine) {
	          dimensionsDefine = [];
	          each(data, function (colArr, key) {
	            dimensionsDefine.push(key);
	          });
	        }
	      } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	        var value0 = getDataItemValue(data[0]);
	        dimensionsDetectedCount = isArray(value0) && value0.length || 1;
	      } else if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
	        if (true) {
	          assert(!!dimensionsDefine, 'dimensions must be given if data is TypedArray.');
	        }
	      }
	
	      return {
	        startIndex: startIndex,
	        dimensionsDefine: normalizeDimensionsOption(dimensionsDefine),
	        dimensionsDetectedCount: dimensionsDetectedCount
	      };
	    }
	
	    function objectRowsCollectDimensions(data) {
	      var firstIndex = 0;
	      var obj;
	
	      while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line
	
	
	      if (obj) {
	        return keys(obj);
	      }
	    } // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
	    // which is reasonable. But dimension name is duplicated.
	    // Returns undefined or an array contains only object without null/undefined or string.
	
	
	    function normalizeDimensionsOption(dimensionsDefine) {
	      if (!dimensionsDefine) {
	        // The meaning of null/undefined is different from empty array.
	        return;
	      }
	
	      var nameMap = createHashMap();
	      return map(dimensionsDefine, function (rawItem, index) {
	        rawItem = isObject(rawItem) ? rawItem : {
	          name: rawItem
	        }; // Other fields will be discarded.
	
	        var item = {
	          name: rawItem.name,
	          displayName: rawItem.displayName,
	          type: rawItem.type
	        }; // User can set null in dimensions.
	        // We don't auto specify name, otherwise a given name may
	        // cause it to be referred unexpectedly.
	
	        if (item.name == null) {
	          return item;
	        } // Also consider number form like 2012.
	
	
	        item.name += ''; // User may also specify displayName.
	        // displayName will always exists except user not
	        // specified or dim name is not specified or detected.
	        // (A auto generated dim name will not be used as
	        // displayName).
	
	        if (item.displayName == null) {
	          item.displayName = item.name;
	        }
	
	        var exist = nameMap.get(item.name);
	
	        if (!exist) {
	          nameMap.set(item.name, {
	            count: 1
	          });
	        } else {
	          item.name += '-' + exist.count++;
	        }
	
	        return item;
	      });
	    }
	
	    function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
	      if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	        for (var i = 0; i < data.length && i < maxLoop; i++) {
	          cb(data[i] ? data[i][0] : null, i);
	        }
	      } else {
	        var value0 = data[0] || [];
	
	        for (var i = 0; i < value0.length && i < maxLoop; i++) {
	          cb(value0[i], i);
	        }
	      }
	    }
	
	    function shouldRetrieveDataByName(source) {
	      var sourceFormat = source.sourceFormat;
	      return sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS;
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var _a, _b, _c; // TODO
	    var providerMethods;
	    var mountMethods;
	    /**
	     * If normal array used, mutable chunk size is supported.
	     * If typed array used, chunk size must be fixed.
	     */
	
	    var DefaultDataProvider =
	    /** @class */
	    function () {
	      function DefaultDataProvider(sourceParam, dimSize) {
	        // let source: Source;
	        var source = !isSourceInstance(sourceParam) ? createSourceFromSeriesDataOption(sourceParam) : sourceParam; // declare source is Source;
	
	        this._source = source;
	        var data = this._data = source.data; // Typed array. TODO IE10+?
	
	        if (source.sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
	          if (true) {
	            if (dimSize == null) {
	              throw new Error('Typed array data must specify dimension size');
	            }
	          }
	
	          this._offset = 0;
	          this._dimSize = dimSize;
	          this._data = data;
	        }
	
	        mountMethods(this, data, source);
	      }
	
	      DefaultDataProvider.prototype.getSource = function () {
	        return this._source;
	      };
	
	      DefaultDataProvider.prototype.count = function () {
	        return 0;
	      };
	
	      DefaultDataProvider.prototype.getItem = function (idx, out) {
	        return;
	      };
	
	      DefaultDataProvider.prototype.appendData = function (newData) {};
	
	      DefaultDataProvider.prototype.clean = function () {};
	
	      DefaultDataProvider.protoInitialize = function () {
	        // PENDING: To avoid potential incompat (e.g., prototype
	        // is visited somewhere), still init them on prototype.
	        var proto = DefaultDataProvider.prototype;
	        proto.pure = false;
	        proto.persistent = true;
	      }();
	
	      DefaultDataProvider.internalField = function () {
	        var _a;
	
	        mountMethods = function (provider, data, source) {
	          var sourceFormat = source.sourceFormat;
	          var seriesLayoutBy = source.seriesLayoutBy;
	          var startIndex = source.startIndex;
	          var dimsDef = source.dimensionsDefine;
	          var methods = providerMethods[getMethodMapKey(sourceFormat, seriesLayoutBy)];
	
	          if (true) {
	            assert(methods, 'Invalide sourceFormat: ' + sourceFormat);
	          }
	
	          extend(provider, methods);
	
	          if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
	            provider.getItem = getItemForTypedArray;
	            provider.count = countForTypedArray;
	            provider.fillStorage = fillStorageForTypedArray;
	          } else {
	            var rawItemGetter = getRawSourceItemGetter(sourceFormat, seriesLayoutBy);
	            provider.getItem = bind(rawItemGetter, null, data, startIndex, dimsDef);
	            var rawCounter = getRawSourceDataCounter(sourceFormat, seriesLayoutBy);
	            provider.count = bind(rawCounter, null, data, startIndex, dimsDef);
	          }
	        };
	
	        var getItemForTypedArray = function (idx, out) {
	          idx = idx - this._offset;
	          out = out || [];
	          var data = this._data;
	          var dimSize = this._dimSize;
	          var offset = dimSize * idx;
	
	          for (var i = 0; i < dimSize; i++) {
	            out[i] = data[offset + i];
	          }
	
	          return out;
	        };
	
	        var fillStorageForTypedArray = function (start, end, storage, extent) {
	          var data = this._data;
	          var dimSize = this._dimSize;
	
	          for (var dim = 0; dim < dimSize; dim++) {
	            var dimExtent = extent[dim];
	            var min = dimExtent[0] == null ? Infinity : dimExtent[0];
	            var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
	            var count = end - start;
	            var arr = storage[dim];
	
	            for (var i = 0; i < count; i++) {
	              // appendData with TypedArray will always do replace in provider.
	              var val = data[i * dimSize + dim];
	              arr[start + i] = val;
	              val < min && (min = val);
	              val > max && (max = val);
	            }
	
	            dimExtent[0] = min;
	            dimExtent[1] = max;
	          }
	        };
	
	        var countForTypedArray = function () {
	          return this._data ? this._data.length / this._dimSize : 0;
	        };
	
	        providerMethods = (_a = {}, _a[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_COLUMN] = {
	          pure: true,
	          appendData: appendDataSimply
	        }, _a[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_ROW] = {
	          pure: true,
	          appendData: function () {
	            throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
	          }
	        }, _a[SOURCE_FORMAT_OBJECT_ROWS] = {
	          pure: true,
	          appendData: appendDataSimply
	        }, _a[SOURCE_FORMAT_KEYED_COLUMNS] = {
	          pure: true,
	          appendData: function (newData) {
	            var data = this._data;
	            each(newData, function (newCol, key) {
	              var oldCol = data[key] || (data[key] = []);
	
	              for (var i = 0; i < (newCol || []).length; i++) {
	                oldCol.push(newCol[i]);
	              }
	            });
	          }
	        }, _a[SOURCE_FORMAT_ORIGINAL] = {
	          appendData: appendDataSimply
	        }, _a[SOURCE_FORMAT_TYPED_ARRAY] = {
	          persistent: false,
	          pure: true,
	          appendData: function (newData) {
	            if (true) {
	              assert(isTypedArray(newData), 'Added data must be TypedArray if data in initialization is TypedArray');
	            }
	
	            this._data = newData;
	          },
	          // Clean self if data is already used.
	          clean: function () {
	            // PENDING
	            this._offset += this.count();
	            this._data = null;
	          }
	        }, _a);
	
	        function appendDataSimply(newData) {
	          for (var i = 0; i < newData.length; i++) {
	            this._data.push(newData[i]);
	          }
	        }
	      }();
	
	      return DefaultDataProvider;
	    }();
	
	    var getItemSimply = function (rawData, startIndex, dimsDef, idx) {
	      return rawData[idx];
	    };
	
	    var rawSourceItemGetterMap = (_a = {}, _a[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_COLUMN] = function (rawData, startIndex, dimsDef, idx) {
	      return rawData[idx + startIndex];
	    }, _a[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_ROW] = function (rawData, startIndex, dimsDef, idx, out) {
	      idx += startIndex;
	      var item = out || [];
	      var data = rawData;
	
	      for (var i = 0; i < data.length; i++) {
	        var row = data[i];
	        item[i] = row ? row[idx] : null;
	      }
	
	      return item;
	    }, _a[SOURCE_FORMAT_OBJECT_ROWS] = getItemSimply, _a[SOURCE_FORMAT_KEYED_COLUMNS] = function (rawData, startIndex, dimsDef, idx, out) {
	      var item = out || [];
	
	      for (var i = 0; i < dimsDef.length; i++) {
	        var dimName = dimsDef[i].name;
	
	        if (true) {
	          if (dimName == null) {
	            throw new Error();
	          }
	        }
	
	        var col = rawData[dimName];
	        item[i] = col ? col[idx] : null;
	      }
	
	      return item;
	    }, _a[SOURCE_FORMAT_ORIGINAL] = getItemSimply, _a);
	    function getRawSourceItemGetter(sourceFormat, seriesLayoutBy) {
	      var method = rawSourceItemGetterMap[getMethodMapKey(sourceFormat, seriesLayoutBy)];
	
	      if (true) {
	        assert(method, 'Do not support get item on "' + sourceFormat + '", "' + seriesLayoutBy + '".');
	      }
	
	      return method;
	    }
	
	    var countSimply = function (rawData, startIndex, dimsDef) {
	      return rawData.length;
	    };
	
	    var rawSourceDataCounterMap = (_b = {}, _b[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_COLUMN] = function (rawData, startIndex, dimsDef) {
	      return Math.max(0, rawData.length - startIndex);
	    }, _b[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_ROW] = function (rawData, startIndex, dimsDef) {
	      var row = rawData[0];
	      return row ? Math.max(0, row.length - startIndex) : 0;
	    }, _b[SOURCE_FORMAT_OBJECT_ROWS] = countSimply, _b[SOURCE_FORMAT_KEYED_COLUMNS] = function (rawData, startIndex, dimsDef) {
	      var dimName = dimsDef[0].name;
	
	      if (true) {
	        if (dimName == null) {
	          throw new Error();
	        }
	      }
	
	      var col = rawData[dimName];
	      return col ? col.length : 0;
	    }, _b[SOURCE_FORMAT_ORIGINAL] = countSimply, _b);
	    function getRawSourceDataCounter(sourceFormat, seriesLayoutBy) {
	      var method = rawSourceDataCounterMap[getMethodMapKey(sourceFormat, seriesLayoutBy)];
	
	      if (true) {
	        assert(method, 'Do not support count on "' + sourceFormat + '", "' + seriesLayoutBy + '".');
	      }
	
	      return method;
	    }
	
	    var getRawValueSimply = function (dataItem, dimIndex, property) {
	      return dataItem[dimIndex];
	    };
	
	    var rawSourceValueGetterMap = (_c = {}, _c[SOURCE_FORMAT_ARRAY_ROWS] = getRawValueSimply, _c[SOURCE_FORMAT_OBJECT_ROWS] = function (dataItem, dimIndex, property) {
	      return dataItem[property];
	    }, _c[SOURCE_FORMAT_KEYED_COLUMNS] = getRawValueSimply, _c[SOURCE_FORMAT_ORIGINAL] = function (dataItem, dimIndex, property) {
	      // FIXME: In some case (markpoint in geo (geo-map.html)),
	      // dataItem is {coord: [...]}
	      var value = getDataItemValue(dataItem);
	      return !(value instanceof Array) ? value : value[dimIndex];
	    }, _c[SOURCE_FORMAT_TYPED_ARRAY] = getRawValueSimply, _c);
	    function getRawSourceValueGetter(sourceFormat) {
	      var method = rawSourceValueGetterMap[sourceFormat];
	
	      if (true) {
	        assert(method, 'Do not support get value on "' + sourceFormat + '".');
	      }
	
	      return method;
	    }
	
	    function getMethodMapKey(sourceFormat, seriesLayoutBy) {
	      return sourceFormat === SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
	    } // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
	    // Consider persistent.
	    // Caution: why use raw value to display on label or tooltip?
	    // A reason is to avoid format. For example time value we do not know
	    // how to format is expected. More over, if stack is used, calculated
	    // value may be 0.91000000001, which have brings trouble to display.
	    // TODO: consider how to treat null/undefined/NaN when display?
	
	
	    function retrieveRawValue(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
	    // Otherwise, return OptionDataValue.
	    dim) {
	      if (!data) {
	        return;
	      } // Consider data may be not persistent.
	
	
	      var dataItem = data.getRawDataItem(dataIndex);
	
	      if (dataItem == null) {
	        return;
	      }
	
	      var store = data.getStore();
	      var sourceFormat = store.getSource().sourceFormat;
	
	      if (dim != null) {
	        var dimIndex = data.getDimensionIndex(dim);
	        var property = store.getDimensionProperty(dimIndex);
	        return getRawSourceValueGetter(sourceFormat)(dataItem, dimIndex, property);
	      } else {
	        var result = dataItem;
	
	        if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	          result = getDataItemValue(dataItem);
	        }
	
	        return result;
	      }
	    }
	
	    var DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
	
	    var DataFormatMixin =
	    /** @class */
	    function () {
	      function DataFormatMixin() {}
	      /**
	       * Get params for formatter
	       */
	
	
	      DataFormatMixin.prototype.getDataParams = function (dataIndex, dataType) {
	        var data = this.getData(dataType);
	        var rawValue = this.getRawValue(dataIndex, dataType);
	        var rawDataIndex = data.getRawIndex(dataIndex);
	        var name = data.getName(dataIndex);
	        var itemOpt = data.getRawDataItem(dataIndex);
	        var style = data.getItemVisual(dataIndex, 'style');
	        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
	        var borderColor = style && style.stroke;
	        var mainType = this.mainType;
	        var isSeries = mainType === 'series';
	        var userOutput = data.userOutput && data.userOutput.get();
	        return {
	          componentType: mainType,
	          componentSubType: this.subType,
	          componentIndex: this.componentIndex,
	          seriesType: isSeries ? this.subType : null,
	          seriesIndex: this.seriesIndex,
	          seriesId: isSeries ? this.id : null,
	          seriesName: isSeries ? this.name : null,
	          name: name,
	          dataIndex: rawDataIndex,
	          data: itemOpt,
	          dataType: dataType,
	          value: rawValue,
	          color: color,
	          borderColor: borderColor,
	          dimensionNames: userOutput ? userOutput.fullDimensions : null,
	          encode: userOutput ? userOutput.encode : null,
	          // Param name list for mapping `a`, `b`, `c`, `d`, `e`
	          $vars: ['seriesName', 'name', 'value']
	        };
	      };
	      /**
	       * Format label
	       * @param dataIndex
	       * @param status 'normal' by default
	       * @param dataType
	       * @param labelDimIndex Only used in some chart that
	       *        use formatter in different dimensions, like radar.
	       * @param formatter Formatter given outside.
	       * @return return null/undefined if no formatter
	       */
	
	
	      DataFormatMixin.prototype.getFormattedLabel = function (dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
	        status = status || 'normal';
	        var data = this.getData(dataType);
	        var params = this.getDataParams(dataIndex, dataType);
	
	        if (extendParams) {
	          params.value = extendParams.interpolatedValue;
	        }
	
	        if (labelDimIndex != null && isArray(params.value)) {
	          params.value = params.value[labelDimIndex];
	        }
	
	        if (!formatter) {
	          var itemModel = data.getItemModel(dataIndex); // @ts-ignore
	
	          formatter = itemModel.get(status === 'normal' ? ['label', 'formatter'] : [status, 'label', 'formatter']);
	        }
	
	        if (isFunction(formatter)) {
	          params.status = status;
	          params.dimensionIndex = labelDimIndex;
	          return formatter(params);
	        } else if (isString(formatter)) {
	          var str = formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
	          // Do not support '}' in dim name util have to.
	
	          return str.replace(DIMENSION_LABEL_REG, function (origin, dimStr) {
	            var len = dimStr.length;
	            var dimLoose = dimStr;
	
	            if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') {
	              dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
	
	              if (true) {
	                if (isNaN(dimLoose)) {
	                  error("Invalide label formatter: @" + dimStr + ", only support @[0], @[1], @[2], ...");
	                }
	              }
	            }
	
	            var val = retrieveRawValue(data, dataIndex, dimLoose);
	
	            if (extendParams && isArray(extendParams.interpolatedValue)) {
	              var dimIndex = data.getDimensionIndex(dimLoose);
	
	              if (dimIndex >= 0) {
	                val = extendParams.interpolatedValue[dimIndex];
	              }
	            }
	
	            return val != null ? val + '' : '';
	          });
	        }
	      };
	      /**
	       * Get raw value in option
	       */
	
	
	      DataFormatMixin.prototype.getRawValue = function (idx, dataType) {
	        return retrieveRawValue(this.getData(dataType), idx);
	      };
	      /**
	       * Should be implemented.
	       * @param {number} dataIndex
	       * @param {boolean} [multipleSeries=false]
	       * @param {string} [dataType]
	       */
	
	
	      DataFormatMixin.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        // Empty function
	        return;
	      };
	
	      return DataFormatMixin;
	    }();
	    // but guess little chance has been used outside. Do we need to backward
	    // compat it?
	    // type TooltipFormatResultLegacyObject = {
	    //     // `html` means the markup language text, either in 'html' or 'richText'.
	    //     // The name `html` is not appropriate because in 'richText' it is not a HTML
	    //     // string. But still support it for backward compatibility.
	    //     html: string;
	    //     markers: Dictionary<ColorString>;
	    // };
	
	    /**
	     * For backward compat, normalize the return from `formatTooltip`.
	     */
	
	    function normalizeTooltipFormatResult(result) {
	      var markupText; // let markers: Dictionary<ColorString>;
	
	      var markupFragment;
	
	      if (isObject(result)) {
	        if (result.type) {
	          markupFragment = result;
	        } else {
	          if (true) {
	            console.warn('The return type of `formatTooltip` is not supported: ' + makePrintable(result));
	          }
	        } // else {
	        //     markupText = (result as TooltipFormatResultLegacyObject).html;
	        //     markers = (result as TooltipFormatResultLegacyObject).markers;
	        //     if (markersExisting) {
	        //         markers = zrUtil.merge(markersExisting, markers);
	        //     }
	        // }
	
	      } else {
	        markupText = result;
	      }
	
	      return {
	        text: markupText,
	        // markers: markers || markersExisting,
	        frag: markupFragment
	      };
	    }
	
	    /**
	     * @param {Object} define
	     * @return See the return of `createTask`.
	     */
	
	    function createTask(define) {
	      return new Task(define);
	    }
	
	    var Task =
	    /** @class */
	    function () {
	      function Task(define) {
	        define = define || {};
	        this._reset = define.reset;
	        this._plan = define.plan;
	        this._count = define.count;
	        this._onDirty = define.onDirty;
	        this._dirty = true;
	      }
	      /**
	       * @param step Specified step.
	       * @param skip Skip customer perform call.
	       * @param modBy Sampling window size.
	       * @param modDataCount Sampling count.
	       * @return whether unfinished.
	       */
	
	
	      Task.prototype.perform = function (performArgs) {
	        var upTask = this._upstream;
	        var skip = performArgs && performArgs.skip; // TODO some refactor.
	        // Pull data. Must pull data each time, because context.data
	        // may be updated by Series.setData.
	
	        if (this._dirty && upTask) {
	          var context = this.context;
	          context.data = context.outputData = upTask.context.outputData;
	        }
	
	        if (this.__pipeline) {
	          this.__pipeline.currentTask = this;
	        }
	
	        var planResult;
	
	        if (this._plan && !skip) {
	          planResult = this._plan(this.context);
	        } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
	        // elements uniformed distributed when progress, especially when moving or zooming.
	
	
	        var lastModBy = normalizeModBy(this._modBy);
	        var lastModDataCount = this._modDataCount || 0;
	        var modBy = normalizeModBy(performArgs && performArgs.modBy);
	        var modDataCount = performArgs && performArgs.modDataCount || 0;
	
	        if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
	          planResult = 'reset';
	        }
	
	        function normalizeModBy(val) {
	          !(val >= 1) && (val = 1); // jshint ignore:line
	
	          return val;
	        }
	
	        var forceFirstProgress;
	
	        if (this._dirty || planResult === 'reset') {
	          this._dirty = false;
	          forceFirstProgress = this._doReset(skip);
	        }
	
	        this._modBy = modBy;
	        this._modDataCount = modDataCount;
	        var step = performArgs && performArgs.step;
	
	        if (upTask) {
	          if (true) {
	            assert(upTask._outputDueEnd != null);
	          }
	
	          this._dueEnd = upTask._outputDueEnd;
	        } // DataTask or overallTask
	        else {
	            if (true) {
	              assert(!this._progress || this._count);
	            }
	
	            this._dueEnd = this._count ? this._count(this.context) : Infinity;
	          } // Note: Stubs, that its host overall task let it has progress, has progress.
	        // If no progress, pass index from upstream to downstream each time plan called.
	
	
	        if (this._progress) {
	          var start = this._dueIndex;
	          var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
	
	          if (!skip && (forceFirstProgress || start < end)) {
	            var progress = this._progress;
	
	            if (isArray(progress)) {
	              for (var i = 0; i < progress.length; i++) {
	                this._doProgress(progress[i], start, end, modBy, modDataCount);
	              }
	            } else {
	              this._doProgress(progress, start, end, modBy, modDataCount);
	            }
	          }
	
	          this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
	          // input data is the same, so use `dueIndex` as `outputDueEnd`.
	
	          var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
	
	          if (true) {
	            // ??? Can not rollback.
	            assert(outputDueEnd >= this._outputDueEnd);
	          }
	
	          this._outputDueEnd = outputDueEnd;
	        } else {
	          // (1) Some overall task has no progress.
	          // (2) Stubs, that its host overall task do not let it has progress, has no progress.
	          // This should always be performed so it can be passed to downstream.
	          this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
	        }
	
	        return this.unfinished();
	      };
	
	      Task.prototype.dirty = function () {
	        this._dirty = true;
	        this._onDirty && this._onDirty(this.context);
	      };
	
	      Task.prototype._doProgress = function (progress, start, end, modBy, modDataCount) {
	        iterator.reset(start, end, modBy, modDataCount);
	        this._callingProgress = progress;
	
	        this._callingProgress({
	          start: start,
	          end: end,
	          count: end - start,
	          next: iterator.next
	        }, this.context);
	      };
	
	      Task.prototype._doReset = function (skip) {
	        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
	        this._settedOutputEnd = null;
	        var progress;
	        var forceFirstProgress;
	
	        if (!skip && this._reset) {
	          progress = this._reset(this.context);
	
	          if (progress && progress.progress) {
	            forceFirstProgress = progress.forceFirstProgress;
	            progress = progress.progress;
	          } // To simplify no progress checking, array must has item.
	
	
	          if (isArray(progress) && !progress.length) {
	            progress = null;
	          }
	        }
	
	        this._progress = progress;
	        this._modBy = this._modDataCount = null;
	        var downstream = this._downstream;
	        downstream && downstream.dirty();
	        return forceFirstProgress;
	      };
	
	      Task.prototype.unfinished = function () {
	        return this._progress && this._dueIndex < this._dueEnd;
	      };
	      /**
	       * @param downTask The downstream task.
	       * @return The downstream task.
	       */
	
	
	      Task.prototype.pipe = function (downTask) {
	        if (true) {
	          assert(downTask && !downTask._disposed && downTask !== this);
	        } // If already downstream, do not dirty downTask.
	
	
	        if (this._downstream !== downTask || this._dirty) {
	          this._downstream = downTask;
	          downTask._upstream = this;
	          downTask.dirty();
	        }
	      };
	
	      Task.prototype.dispose = function () {
	        if (this._disposed) {
	          return;
	        }
	
	        this._upstream && (this._upstream._downstream = null);
	        this._downstream && (this._downstream._upstream = null);
	        this._dirty = false;
	        this._disposed = true;
	      };
	
	      Task.prototype.getUpstream = function () {
	        return this._upstream;
	      };
	
	      Task.prototype.getDownstream = function () {
	        return this._downstream;
	      };
	
	      Task.prototype.setOutputEnd = function (end) {
	        // This only happens in dataTask, dataZoom, map, currently.
	        // where dataZoom do not set end each time, but only set
	        // when reset. So we should record the set end, in case
	        // that the stub of dataZoom perform again and earse the
	        // set end by upstream.
	        this._outputDueEnd = this._settedOutputEnd = end;
	      };
	
	      return Task;
	    }();
	
	    var iterator = function () {
	      var end;
	      var current;
	      var modBy;
	      var modDataCount;
	      var winCount;
	      var it = {
	        reset: function (s, e, sStep, sCount) {
	          current = s;
	          end = e;
	          modBy = sStep;
	          modDataCount = sCount;
	          winCount = Math.ceil(modDataCount / modBy);
	          it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
	        }
	      };
	      return it;
	
	      function sequentialNext() {
	        return current < end ? current++ : null;
	      }
	
	      function modNext() {
	        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
	        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
	        // Use normal linear rendering mode.
	        : current;
	        current++;
	        return result;
	      }
	    }(); // -----------------------------------------------------------------------------
	    // For stream debug (Should be commented out after used!)
	    // @usage: printTask(this, 'begin');
	    // @usage: printTask(this, null, {someExtraProp});
	    // @usage: Use `__idxInPipeline` as conditional breakpiont.
	    //
	    // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
	    //     window.ecTaskUID == null && (window.ecTaskUID = 0);
	    //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
	    //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
	    //     let props = [];
	    //     if (task.__pipeline) {
	    //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
	    //         props.push({text: '__idxInPipeline/total', value: val});
	    //     } else {
	    //         let stubCount = 0;
	    //         task.agentStubMap.each(() => stubCount++);
	    //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
	    //     }
	    //     props.push({text: 'uid', value: task.uidDebug});
	    //     if (task.__pipeline) {
	    //         props.push({text: 'pipelineId', value: task.__pipeline.id});
	    //         task.agent && props.push(
	    //             {text: 'stubFor', value: task.agent.uidDebug}
	    //         );
	    //     }
	    //     props.push(
	    //         {text: 'dirty', value: task._dirty},
	    //         {text: 'dueIndex', value: task._dueIndex},
	    //         {text: 'dueEnd', value: task._dueEnd},
	    //         {text: 'outputDueEnd', value: task._outputDueEnd}
	    //     );
	    //     if (extra) {
	    //         Object.keys(extra).forEach(key => {
	    //             props.push({text: key, value: extra[key]});
	    //         });
	    //     }
	    //     let args = ['color: blue'];
	    //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
	    //         args.push('color: green', 'color: red'),
	    //         `${item.text}: %c${item.value}`
	    //     )).join('%c, ');
	    //     console.log.apply(console, [msg].concat(args));
	    //     // console.log(this);
	    // };
	    // window.printPipeline = function (task: any, prefix: string) {
	    //     const pipeline = task.__pipeline;
	    //     let currTask = pipeline.head;
	    //     while (currTask) {
	    //         window.printTask(currTask, prefix);
	    //         currTask = currTask._downstream;
	    //     }
	    // };
	    // window.showChain = function (chainHeadTask) {
	    //     var chain = [];
	    //     var task = chainHeadTask;
	    //     while (task) {
	    //         chain.push({
	    //             task: task,
	    //             up: task._upstream,
	    //             down: task._downstream,
	    //             idxInPipeline: task.__idxInPipeline
	    //         });
	    //         task = task._downstream;
	    //     }
	    //     return chain;
	    // };
	    // window.findTaskInChain = function (task, chainHeadTask) {
	    //     let chain = window.showChain(chainHeadTask);
	    //     let result = [];
	    //     for (let i = 0; i < chain.length; i++) {
	    //         let chainItem = chain[i];
	    //         if (chainItem.task === task) {
	    //             result.push(i);
	    //         }
	    //     }
	    //     return result;
	    // };
	    // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
	    //     let chainA = window.showChain(chainHeadTaskA);
	    //     for (let i = 0; i < chainA.length; i++) {
	    //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
	    //     }
	    // };
	
	    /**
	     * Convert raw the value in to inner value in List.
	     *
	     * [Performance sensitive]
	     *
	     * [Caution]: this is the key logic of user value parser.
	     * For backward compatibility, do not modify it until you have to!
	     */
	
	    function parseDataValue(value, // For high performance, do not omit the second param.
	    opt) {
	      // Performance sensitive.
	      var dimType = opt && opt.type;
	
	      if (dimType === 'ordinal') {
	        // If given value is a category string
	        return value;
	      }
	
	      if (dimType === 'time' // spead up when using timestamp
	      && !isNumber(value) && value != null && value !== '-') {
	        value = +parseDate(value);
	      } // dimType defaults 'number'.
	      // If dimType is not ordinal and value is null or undefined or NaN or '-',
	      // parse to NaN.
	      // number-like string (like ' 123 ') can be converted to a number.
	      // where null/undefined or other string will be converted to NaN.
	
	
	      return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
	      // If object, also parse to NaN
	      : +value;
	    }
	    var valueParserMap = createHashMap({
	      'number': function (val) {
	        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
	        // Here the number parser can have loose rule:
	        // enable to cut suffix: "120px" => 120, "14%" => 14.
	        return parseFloat(val);
	      },
	      'time': function (val) {
	        // return timestamp.
	        return +parseDate(val);
	      },
	      'trim': function (val) {
	        return isString(val) ? trim(val) : val;
	      }
	    });
	    function getRawValueParser(type) {
	      return valueParserMap.get(type);
	    }
	    var ORDER_COMPARISON_OP_MAP = {
	      lt: function (lval, rval) {
	        return lval < rval;
	      },
	      lte: function (lval, rval) {
	        return lval <= rval;
	      },
	      gt: function (lval, rval) {
	        return lval > rval;
	      },
	      gte: function (lval, rval) {
	        return lval >= rval;
	      }
	    };
	
	    var FilterOrderComparator =
	    /** @class */
	    function () {
	      function FilterOrderComparator(op, rval) {
	        if (!isNumber(rval)) {
	          var errMsg = '';
	
	          if (true) {
	            errMsg = 'rvalue of "<", ">", "<=", ">=" can only be number in filter.';
	          }
	
	          throwError(errMsg);
	        }
	
	        this._opFn = ORDER_COMPARISON_OP_MAP[op];
	        this._rvalFloat = numericToNumber(rval);
	      } // Performance sensitive.
	
	
	      FilterOrderComparator.prototype.evaluate = function (lval) {
	        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
	        return isNumber(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn(numericToNumber(lval), this._rvalFloat);
	      };
	
	      return FilterOrderComparator;
	    }();
	
	    var SortOrderComparator =
	    /** @class */
	    function () {
	      /**
	       * @param order by default: 'asc'
	       * @param incomparable by default: Always on the tail.
	       *        That is, if 'asc' => 'max', if 'desc' => 'min'
	       *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
	       */
	      function SortOrderComparator(order, incomparable) {
	        var isDesc = order === 'desc';
	        this._resultLT = isDesc ? 1 : -1;
	
	        if (incomparable == null) {
	          incomparable = isDesc ? 'min' : 'max';
	        }
	
	        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
	      } // See [SORT_COMPARISON_RULE].
	      // Performance sensitive.
	
	
	      SortOrderComparator.prototype.evaluate = function (lval, rval) {
	        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
	        var lvalFloat = isNumber(lval) ? lval : numericToNumber(lval);
	        var rvalFloat = isNumber(rval) ? rval : numericToNumber(rval);
	        var lvalNotNumeric = isNaN(lvalFloat);
	        var rvalNotNumeric = isNaN(rvalFloat);
	
	        if (lvalNotNumeric) {
	          lvalFloat = this._incomparable;
	        }
	
	        if (rvalNotNumeric) {
	          rvalFloat = this._incomparable;
	        }
	
	        if (lvalNotNumeric && rvalNotNumeric) {
	          var lvalIsStr = isString(lval);
	          var rvalIsStr = isString(rval);
	
	          if (lvalIsStr) {
	            lvalFloat = rvalIsStr ? lval : 0;
	          }
	
	          if (rvalIsStr) {
	            rvalFloat = lvalIsStr ? rval : 0;
	          }
	        }
	
	        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
	      };
	
	      return SortOrderComparator;
	    }();
	
	    var FilterEqualityComparator =
	    /** @class */
	    function () {
	      function FilterEqualityComparator(isEq, rval) {
	        this._rval = rval;
	        this._isEQ = isEq;
	        this._rvalTypeof = typeof rval;
	        this._rvalFloat = numericToNumber(rval);
	      } // Performance sensitive.
	
	
	      FilterEqualityComparator.prototype.evaluate = function (lval) {
	        var eqResult = lval === this._rval;
	
	        if (!eqResult) {
	          var lvalTypeof = typeof lval;
	
	          if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) {
	            eqResult = numericToNumber(lval) === this._rvalFloat;
	          }
	        }
	
	        return this._isEQ ? eqResult : !eqResult;
	      };
	
	      return FilterEqualityComparator;
	    }();
	    /**
	     * [FILTER_COMPARISON_RULE]
	     * `lt`|`lte`|`gt`|`gte`:
	     * + rval must be a number. And lval will be converted to number (`numericToNumber`) to compare.
	     * `eq`:
	     * + If same type, compare with `===`.
	     * + If there is one number, convert to number (`numericToNumber`) to compare.
	     * + Else return `false`.
	     * `ne`:
	     * + Not `eq`.
	     *
	     *
	     * [SORT_COMPARISON_RULE]
	     * All the values are grouped into three categories:
	     * + "numeric" (number and numeric string)
	     * + "non-numeric-string" (string that excluding numeric string)
	     * + "others"
	     * "numeric" vs "numeric": values are ordered by number order.
	     * "non-numeric-string" vs "non-numeric-string": values are ordered by ES spec (#sec-abstract-relational-comparison).
	     * "others" vs "others": do not change order (always return 0).
	     * "numeric" vs "non-numeric-string": "non-numeric-string" is treated as "incomparable".
	     * "number" vs "others": "others" is treated as "incomparable".
	     * "non-numeric-string" vs "others": "others" is treated as "incomparable".
	     * "incomparable" will be seen as -Infinity or Infinity (depends on the settings).
	     * MEMO:
	     *   Non-numeric string sort makes sense when we need to put the items with the same tag together.
	     *   But if we support string sort, we still need to avoid the misleading like `'2' > '12'`,
	     *   So we treat "numeric-string" sorted by number order rather than string comparison.
	     *
	     *
	     * [CHECK_LIST_OF_THE_RULE_DESIGN]
	     * + Do not support string comparison until required. And also need to
	     *   avoid the misleading of "2" > "12".
	     * + Should avoid the misleading case:
	     *   `" 22 " gte "22"` is `true` but `" 22 " eq "22"` is `false`.
	     * + JS bad case should be avoided: null <= 0, [] <= 0, ' ' <= 0, ...
	     * + Only "numeric" can be converted to comparable number, otherwise converted to NaN.
	     *   See `util/number.ts#numericToNumber`.
	     *
	     * @return If `op` is not `RelationalOperator`, return null;
	     */
	
	
	    function createFilterComparator(op, rval) {
	      return op === 'eq' || op === 'ne' ? new FilterEqualityComparator(op === 'eq', rval) : hasOwn(ORDER_COMPARISON_OP_MAP, op) ? new FilterOrderComparator(op, rval) : null;
	    }
	
	    /**
	     * TODO: disable writable.
	     * This structure will be exposed to users.
	     */
	
	    var ExternalSource =
	    /** @class */
	    function () {
	      function ExternalSource() {}
	
	      ExternalSource.prototype.getRawData = function () {
	        // Only built-in transform available.
	        throw new Error('not supported');
	      };
	
	      ExternalSource.prototype.getRawDataItem = function (dataIndex) {
	        // Only built-in transform available.
	        throw new Error('not supported');
	      };
	
	      ExternalSource.prototype.cloneRawData = function () {
	        return;
	      };
	      /**
	       * @return If dimension not found, return null/undefined.
	       */
	
	
	      ExternalSource.prototype.getDimensionInfo = function (dim) {
	        return;
	      };
	      /**
	       * dimensions defined if and only if either:
	       * (a) dataset.dimensions are declared.
	       * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
	       * If dimensions are defined, `dimensionInfoAll` is corresponding to
	       * the defined dimensions.
	       * Otherwise, `dimensionInfoAll` is determined by data columns.
	       * @return Always return an array (even empty array).
	       */
	
	
	      ExternalSource.prototype.cloneAllDimensionInfo = function () {
	        return;
	      };
	
	      ExternalSource.prototype.count = function () {
	        return;
	      };
	      /**
	       * Only support by dimension index.
	       * No need to support by dimension name in transform function,
	       * because transform function is not case-specific, no need to use name literally.
	       */
	
	
	      ExternalSource.prototype.retrieveValue = function (dataIndex, dimIndex) {
	        return;
	      };
	
	      ExternalSource.prototype.retrieveValueFromItem = function (dataItem, dimIndex) {
	        return;
	      };
	
	      ExternalSource.prototype.convertValue = function (rawVal, dimInfo) {
	        return parseDataValue(rawVal, dimInfo);
	      };
	
	      return ExternalSource;
	    }();
	
	    function createExternalSource(internalSource, externalTransform) {
	      var extSource = new ExternalSource();
	      var data = internalSource.data;
	      var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
	      var sourceHeaderCount = internalSource.startIndex;
	      var errMsg = '';
	
	      if (internalSource.seriesLayoutBy !== SERIES_LAYOUT_BY_COLUMN) {
	        // For the logic simplicity in transformer, only 'culumn' is
	        // supported in data transform. Otherwise, the `dimensionsDefine`
	        // might be detected by 'row', which probably confuses users.
	        if (true) {
	          errMsg = '`seriesLayoutBy` of upstream dataset can only be "column" in data transform.';
	        }
	
	        throwError(errMsg);
	      } // [MEMO]
	      // Create a new dimensions structure for exposing.
	      // Do not expose all dimension info to users directly.
	      // Because the dimension is probably auto detected from data and not might reliable.
	      // Should not lead the transformers to think that is reliable and return it.
	      // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
	
	
	      var dimensions = [];
	      var dimsByName = {};
	      var dimsDef = internalSource.dimensionsDefine;
	
	      if (dimsDef) {
	        each(dimsDef, function (dimDef, idx) {
	          var name = dimDef.name;
	          var dimDefExt = {
	            index: idx,
	            name: name,
	            displayName: dimDef.displayName
	          };
	          dimensions.push(dimDefExt); // Users probably do not specify dimension name. For simplicity, data transform
	          // does not generate dimension name.
	
	          if (name != null) {
	            // Dimension name should not be duplicated.
	            // For simplicity, data transform forbids name duplication, do not generate
	            // new name like module `completeDimensions.ts` did, but just tell users.
	            var errMsg_1 = '';
	
	            if (hasOwn(dimsByName, name)) {
	              if (true) {
	                errMsg_1 = 'dimension name "' + name + '" duplicated.';
	              }
	
	              throwError(errMsg_1);
	            }
	
	            dimsByName[name] = dimDefExt;
	          }
	        });
	      } // If dimension definitions are not defined and can not be detected.
	      // e.g., pure data `[[11, 22], ...]`.
	      else {
	          for (var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++) {
	            // Do not generete name or anything others. The consequence process in
	            // `transform` or `series` probably have there own name generation strategry.
	            dimensions.push({
	              index: i
	            });
	          }
	        } // Implement public methods:
	
	
	      var rawItemGetter = getRawSourceItemGetter(sourceFormat, SERIES_LAYOUT_BY_COLUMN);
	
	      if (externalTransform.__isBuiltIn) {
	        extSource.getRawDataItem = function (dataIndex) {
	          return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
	        };
	
	        extSource.getRawData = bind(getRawData, null, internalSource);
	      }
	
	      extSource.cloneRawData = bind(cloneRawData, null, internalSource);
	      var rawCounter = getRawSourceDataCounter(sourceFormat, SERIES_LAYOUT_BY_COLUMN);
	      extSource.count = bind(rawCounter, null, data, sourceHeaderCount, dimensions);
	      var rawValueGetter = getRawSourceValueGetter(sourceFormat);
	
	      extSource.retrieveValue = function (dataIndex, dimIndex) {
	        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
	        return retrieveValueFromItem(rawItem, dimIndex);
	      };
	
	      var retrieveValueFromItem = extSource.retrieveValueFromItem = function (dataItem, dimIndex) {
	        if (dataItem == null) {
	          return;
	        }
	
	        var dimDef = dimensions[dimIndex]; // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
	
	        if (dimDef) {
	          return rawValueGetter(dataItem, dimIndex, dimDef.name);
	        }
	      };
	
	      extSource.getDimensionInfo = bind(getDimensionInfo, null, dimensions, dimsByName);
	      extSource.cloneAllDimensionInfo = bind(cloneAllDimensionInfo, null, dimensions);
	      return extSource;
	    }
	
	    function getRawData(upstream) {
	      var sourceFormat = upstream.sourceFormat;
	
	      if (!isSupportedSourceFormat(sourceFormat)) {
	        var errMsg = '';
	
	        if (true) {
	          errMsg = '`getRawData` is not supported in source format ' + sourceFormat;
	        }
	
	        throwError(errMsg);
	      }
	
	      return upstream.data;
	    }
	
	    function cloneRawData(upstream) {
	      var sourceFormat = upstream.sourceFormat;
	      var data = upstream.data;
	
	      if (!isSupportedSourceFormat(sourceFormat)) {
	        var errMsg = '';
	
	        if (true) {
	          errMsg = '`cloneRawData` is not supported in source format ' + sourceFormat;
	        }
	
	        throwError(errMsg);
	      }
	
	      if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	        var result = [];
	
	        for (var i = 0, len = data.length; i < len; i++) {
	          // Not strictly clone for performance
	          result.push(data[i].slice());
	        }
	
	        return result;
	      } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	        var result = [];
	
	        for (var i = 0, len = data.length; i < len; i++) {
	          // Not strictly clone for performance
	          result.push(extend({}, data[i]));
	        }
	
	        return result;
	      }
	    }
	
	    function getDimensionInfo(dimensions, dimsByName, dim) {
	      if (dim == null) {
	        return;
	      } // Keep the same logic as `List::getDimension` did.
	
	
	      if (isNumber(dim) // If being a number-like string but not being defined a dimension name.
	      || !isNaN(dim) && !hasOwn(dimsByName, dim)) {
	        return dimensions[dim];
	      } else if (hasOwn(dimsByName, dim)) {
	        return dimsByName[dim];
	      }
	    }
	
	    function cloneAllDimensionInfo(dimensions) {
	      return clone(dimensions);
	    }
	
	    var externalTransformMap = createHashMap();
	    function registerExternalTransform(externalTransform) {
	      externalTransform = clone(externalTransform);
	      var type = externalTransform.type;
	      var errMsg = '';
	
	      if (!type) {
	        if (true) {
	          errMsg = 'Must have a `type` when `registerTransform`.';
	        }
	
	        throwError(errMsg);
	      }
	
	      var typeParsed = type.split(':');
	
	      if (typeParsed.length !== 2) {
	        if (true) {
	          errMsg = 'Name must include namespace like "ns:regression".';
	        }
	
	        throwError(errMsg);
	      } // Namespace 'echarts:xxx' is official namespace, where the transforms should
	      // be called directly via 'xxx' rather than 'echarts:xxx'.
	
	
	      var isBuiltIn = false;
	
	      if (typeParsed[0] === 'echarts') {
	        type = typeParsed[1];
	        isBuiltIn = true;
	      }
	
	      externalTransform.__isBuiltIn = isBuiltIn;
	      externalTransformMap.set(type, externalTransform);
	    }
	    function applyDataTransform(rawTransOption, sourceList, infoForPrint) {
	      var pipedTransOption = normalizeToArray(rawTransOption);
	      var pipeLen = pipedTransOption.length;
	      var errMsg = '';
	
	      if (!pipeLen) {
	        if (true) {
	          errMsg = 'If `transform` declared, it should at least contain one transform.';
	        }
	
	        throwError(errMsg);
	      }
	
	      for (var i = 0, len = pipeLen; i < len; i++) {
	        var transOption = pipedTransOption[i];
	        sourceList = applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i); // piped transform only support single input, except the fist one.
	        // piped transform only support single output, except the last one.
	
	        if (i !== len - 1) {
	          sourceList.length = Math.max(sourceList.length, 1);
	        }
	      }
	
	      return sourceList;
	    }
	
	    function applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
	    pipeIndex) {
	      var errMsg = '';
	
	      if (!upSourceList.length) {
	        if (true) {
	          errMsg = 'Must have at least one upstream dataset.';
	        }
	
	        throwError(errMsg);
	      }
	
	      if (!isObject(transOption)) {
	        if (true) {
	          errMsg = 'transform declaration must be an object rather than ' + typeof transOption + '.';
	        }
	
	        throwError(errMsg);
	      }
	
	      var transType = transOption.type;
	      var externalTransform = externalTransformMap.get(transType);
	
	      if (!externalTransform) {
	        if (true) {
	          errMsg = 'Can not find transform on type "' + transType + '".';
	        }
	
	        throwError(errMsg);
	      } // Prepare source
	
	
	      var extUpSourceList = map(upSourceList, function (upSource) {
	        return createExternalSource(upSource, externalTransform);
	      });
	      var resultList = normalizeToArray(externalTransform.transform({
	        upstream: extUpSourceList[0],
	        upstreamList: extUpSourceList,
	        config: clone(transOption.config)
	      }));
	
	      if (true) {
	        if (transOption.print) {
	          var printStrArr = map(resultList, function (extSource) {
	            var pipeIndexStr = pipeIndex != null ? ' === pipe index: ' + pipeIndex : '';
	            return ['=== dataset index: ' + infoForPrint.datasetIndex + pipeIndexStr + ' ===', '- transform result data:', makePrintable(extSource.data), '- transform result dimensions:', makePrintable(extSource.dimensions)].join('\n');
	          }).join('\n');
	          log(printStrArr);
	        }
	      }
	
	      return map(resultList, function (result, resultIndex) {
	        var errMsg = '';
	
	        if (!isObject(result)) {
	          if (true) {
	            errMsg = 'A transform should not return some empty results.';
	          }
	
	          throwError(errMsg);
	        }
	
	        if (!result.data) {
	          if (true) {
	            errMsg = 'Transform result data should be not be null or undefined';
	          }
	
	          throwError(errMsg);
	        }
	
	        var sourceFormat = detectSourceFormat(result.data);
	
	        if (!isSupportedSourceFormat(sourceFormat)) {
	          if (true) {
	            errMsg = 'Transform result data should be array rows or object rows.';
	          }
	
	          throwError(errMsg);
	        }
	
	        var resultMetaRawOption;
	        var firstUpSource = upSourceList[0];
	        /**
	         * Intuitively, the end users known the content of the original `dataset.source`,
	         * calucating the transform result in mind.
	         * Suppose the original `dataset.source` is:
	         * ```js
	         * [
	         *     ['product', '2012', '2013', '2014', '2015'],
	         *     ['AAA', 41.1, 30.4, 65.1, 53.3],
	         *     ['BBB', 86.5, 92.1, 85.7, 83.1],
	         *     ['CCC', 24.1, 67.2, 79.5, 86.4]
	         * ]
	         * ```
	         * The dimension info have to be detected from the source data.
	         * Some of the transformers (like filter, sort) will follow the dimension info
	         * of upstream, while others use new dimensions (like aggregate).
	         * Transformer can output a field `dimensions` to define the its own output dimensions.
	         * We also allow transformers to ignore the output `dimensions` field, and
	         * inherit the upstream dimensions definition. It can reduce the burden of handling
	         * dimensions in transformers.
	         *
	         * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
	         */
	
	        if (firstUpSource && resultIndex === 0 // If transformer returns `dimensions`, it means that the transformer has different
	        // dimensions definitions. We do not inherit anything from upstream.
	        && !result.dimensions) {
	          var startIndex = firstUpSource.startIndex; // We copy the header of upstream to the result, because:
	          // (1) The returned data always does not contain header line and can not be used
	          // as dimension-detection. In this case we can not use "detected dimensions" of
	          // upstream directly, because it might be detected based on different `seriesLayoutBy`.
	          // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
	          // So the original detected header should be add to the result, otherwise they can not be read.
	
	          if (startIndex) {
	            result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
	          }
	
	          resultMetaRawOption = {
	            seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
	            sourceHeader: startIndex,
	            dimensions: firstUpSource.metaRawOption.dimensions
	          };
	        } else {
	          resultMetaRawOption = {
	            seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
	            sourceHeader: 0,
	            dimensions: result.dimensions
	          };
	        }
	
	        return createSource(result.data, resultMetaRawOption, null);
	      });
	    }
	
	    function isSupportedSourceFormat(sourceFormat) {
	      return sourceFormat === SOURCE_FORMAT_ARRAY_ROWS || sourceFormat === SOURCE_FORMAT_OBJECT_ROWS;
	    }
	
	    var UNDEFINED = 'undefined';
	    /* global Float64Array, Int32Array, Uint32Array, Uint16Array */
	    // Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
	    // different from the Ctor of typed array.
	
	    var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
	    var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;
	    var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
	    var CtorFloat64Array = typeof Float64Array === UNDEFINED ? Array : Float64Array;
	    /**
	     * Multi dimensional data store
	     */
	
	    var dataCtors = {
	      'float': CtorFloat64Array,
	      'int': CtorInt32Array,
	      // Ordinal data type can be string or int
	      'ordinal': Array,
	      'number': Array,
	      'time': CtorFloat64Array
	    };
	    var defaultDimValueGetters;
	
	    function getIndicesCtor(rawCount) {
	      // The possible max value in this._indicies is always this._rawCount despite of filtering.
	      return rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
	    }
	
	    function getInitialExtent() {
	      return [Infinity, -Infinity];
	    }
	
	    function cloneChunk(originalChunk) {
	      var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
	
	      return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
	    }
	
	    function prepareStore(store, dimIdx, dimType, end, append) {
	      var DataCtor = dataCtors[dimType || 'float'];
	
	      if (append) {
	        var oldStore = store[dimIdx];
	        var oldLen = oldStore && oldStore.length;
	
	        if (!(oldLen === end)) {
	          var newStore = new DataCtor(end); // The cost of the copy is probably inconsiderable
	          // within the initial chunkSize.
	
	          for (var j = 0; j < oldLen; j++) {
	            newStore[j] = oldStore[j];
	          }
	
	          store[dimIdx] = newStore;
	        }
	      } else {
	        store[dimIdx] = new DataCtor(end);
	      }
	    }
	    /**
	     * Basically, DataStore API keep immutable.
	     */
	
	    var DataStore =
	    /** @class */
	    function () {
	      function DataStore() {
	        this._chunks = []; // It will not be calculated until needed.
	
	        this._rawExtent = [];
	        this._extent = [];
	        this._count = 0;
	        this._rawCount = 0;
	        this._calcDimNameToIdx = createHashMap();
	      }
	      /**
	       * Initialize from data
	       */
	
	
	      DataStore.prototype.initData = function (provider, inputDimensions, dimValueGetter) {
	        if (true) {
	          assert(isFunction(provider.getItem) && isFunction(provider.count), 'Invalid data provider.');
	        }
	
	        this._provider = provider; // Clear
	
	        this._chunks = [];
	        this._indices = null;
	        this.getRawIndex = this._getRawIdxIdentity;
	        var source = provider.getSource();
	        var defaultGetter = this.defaultDimValueGetter = defaultDimValueGetters[source.sourceFormat]; // Default dim value getter
	
	        this._dimValueGetter = dimValueGetter || defaultGetter; // Reset raw extent.
	
	        this._rawExtent = [];
	        var willRetrieveDataByName = shouldRetrieveDataByName(source);
	        this._dimensions = map(inputDimensions, function (dim) {
	          if (true) {
	            if (willRetrieveDataByName) {
	              assert(dim.property != null);
	            }
	          }
	
	          return {
	            // Only pick these two props. Not leak other properties like orderMeta.
	            type: dim.type,
	            property: dim.property
	          };
	        });
	
	        this._initDataFromProvider(0, provider.count());
	      };
	
	      DataStore.prototype.getProvider = function () {
	        return this._provider;
	      };
	      /**
	       * Caution: even when a `source` instance owned by a series, the created data store
	       * may still be shared by different sereis (the source hash does not use all `source`
	       * props, see `sourceManager`). In this case, the `source` props that are not used in
	       * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
	       * thus should not be fetch here.
	       */
	
	
	      DataStore.prototype.getSource = function () {
	        return this._provider.getSource();
	      };
	      /**
	       * @caution Only used in dataStack.
	       */
	
	
	      DataStore.prototype.ensureCalculationDimension = function (dimName, type) {
	        var calcDimNameToIdx = this._calcDimNameToIdx;
	        var dimensions = this._dimensions;
	        var calcDimIdx = calcDimNameToIdx.get(dimName);
	
	        if (calcDimIdx != null) {
	          if (dimensions[calcDimIdx].type === type) {
	            return calcDimIdx;
	          }
	        } else {
	          calcDimIdx = dimensions.length;
	        }
	
	        dimensions[calcDimIdx] = {
	          type: type
	        };
	        calcDimNameToIdx.set(dimName, calcDimIdx);
	        this._chunks[calcDimIdx] = new dataCtors[type || 'float'](this._rawCount);
	        this._rawExtent[calcDimIdx] = getInitialExtent();
	        return calcDimIdx;
	      };
	
	      DataStore.prototype.collectOrdinalMeta = function (dimIdx, ordinalMeta) {
	        var chunk = this._chunks[dimIdx];
	        var dim = this._dimensions[dimIdx];
	        var rawExtents = this._rawExtent;
	        var offset = dim.ordinalOffset || 0;
	        var len = chunk.length;
	
	        if (offset === 0) {
	          // We need to reset the rawExtent if collect is from start.
	          // Because this dimension may be guessed as number and calcuating a wrong extent.
	          rawExtents[dimIdx] = getInitialExtent();
	        }
	
	        var dimRawExtent = rawExtents[dimIdx]; // Parse from previous data offset. len may be changed after appendData
	
	        for (var i = offset; i < len; i++) {
	          var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
	
	          if (!isNaN(val)) {
	            dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
	            dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
	          }
	        }
	
	        dim.ordinalMeta = ordinalMeta;
	        dim.ordinalOffset = len;
	        dim.type = 'ordinal'; // Force to be ordinal
	      };
	
	      DataStore.prototype.getOrdinalMeta = function (dimIdx) {
	        var dimInfo = this._dimensions[dimIdx];
	        var ordinalMeta = dimInfo.ordinalMeta;
	        return ordinalMeta;
	      };
	
	      DataStore.prototype.getDimensionProperty = function (dimIndex) {
	        var item = this._dimensions[dimIndex];
	        return item && item.property;
	      };
	      /**
	       * Caution: Can be only called on raw data (before `this._indices` created).
	       */
	
	
	      DataStore.prototype.appendData = function (data) {
	        if (true) {
	          assert(!this._indices, 'appendData can only be called on raw data.');
	        }
	
	        var provider = this._provider;
	        var start = this.count();
	        provider.appendData(data);
	        var end = provider.count();
	
	        if (!provider.persistent) {
	          end += start;
	        }
	
	        if (start < end) {
	          this._initDataFromProvider(start, end, true);
	        }
	
	        return [start, end];
	      };
	
	      DataStore.prototype.appendValues = function (values, minFillLen) {
	        var chunks = this._chunks;
	        var dimensions = this._dimensions;
	        var dimLen = dimensions.length;
	        var rawExtent = this._rawExtent;
	        var start = this.count();
	        var end = start + Math.max(values.length, minFillLen || 0);
	
	        for (var i = 0; i < dimLen; i++) {
	          var dim = dimensions[i];
	          prepareStore(chunks, i, dim.type, end, true);
	        }
	
	        var emptyDataItem = [];
	
	        for (var idx = start; idx < end; idx++) {
	          var sourceIdx = idx - start; // Store the data by dimensions
	
	          for (var dimIdx = 0; dimIdx < dimLen; dimIdx++) {
	            var dim = dimensions[dimIdx];
	            var val = defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
	            chunks[dimIdx][idx] = val;
	            var dimRawExtent = rawExtent[dimIdx];
	            val < dimRawExtent[0] && (dimRawExtent[0] = val);
	            val > dimRawExtent[1] && (dimRawExtent[1] = val);
	          }
	        }
	
	        this._rawCount = this._count = end;
	        return {
	          start: start,
	          end: end
	        };
	      };
	
	      DataStore.prototype._initDataFromProvider = function (start, end, append) {
	        var provider = this._provider;
	        var chunks = this._chunks;
	        var dimensions = this._dimensions;
	        var dimLen = dimensions.length;
	        var rawExtent = this._rawExtent;
	        var dimNames = map(dimensions, function (dim) {
	          return dim.property;
	        });
	
	        for (var i = 0; i < dimLen; i++) {
	          var dim = dimensions[i];
	
	          if (!rawExtent[i]) {
	            rawExtent[i] = getInitialExtent();
	          }
	
	          prepareStore(chunks, i, dim.type, end, append);
	        }
	
	        if (provider.fillStorage) {
	          provider.fillStorage(start, end, chunks, rawExtent);
	        } else {
	          var dataItem = [];
	
	          for (var idx = start; idx < end; idx++) {
	            // NOTICE: Try not to write things into dataItem
	            dataItem = provider.getItem(idx, dataItem); // Each data item is value
	            // [1, 2]
	            // 2
	            // Bar chart, line chart which uses category axis
	            // only gives the 'y' value. 'x' value is the indices of category
	            // Use a tempValue to normalize the value to be a (x, y) value
	            // Store the data by dimensions
	
	            for (var dimIdx = 0; dimIdx < dimLen; dimIdx++) {
	              var dimStorage = chunks[dimIdx]; // PENDING NULL is empty or zero
	
	              var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
	
	              dimStorage[idx] = val;
	              var dimRawExtent = rawExtent[dimIdx];
	              val < dimRawExtent[0] && (dimRawExtent[0] = val);
	              val > dimRawExtent[1] && (dimRawExtent[1] = val);
	            }
	          }
	        }
	
	        if (!provider.persistent && provider.clean) {
	          // Clean unused data if data source is typed array.
	          provider.clean();
	        }
	
	        this._rawCount = this._count = end; // Reset data extent
	
	        this._extent = [];
	      };
	
	      DataStore.prototype.count = function () {
	        return this._count;
	      };
	      /**
	       * Get value. Return NaN if idx is out of range.
	       */
	
	
	      DataStore.prototype.get = function (dim, idx) {
	        if (!(idx >= 0 && idx < this._count)) {
	          return NaN;
	        }
	
	        var dimStore = this._chunks[dim];
	        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
	      };
	
	      DataStore.prototype.getValues = function (dimensions, idx) {
	        var values = [];
	        var dimArr = [];
	
	        if (idx == null) {
	          idx = dimensions; // TODO get all from store?
	
	          dimensions = []; // All dimensions
	
	          for (var i = 0; i < this._dimensions.length; i++) {
	            dimArr.push(i);
	          }
	        } else {
	          dimArr = dimensions;
	        }
	
	        for (var i = 0, len = dimArr.length; i < len; i++) {
	          values.push(this.get(dimArr[i], idx));
	        }
	
	        return values;
	      };
	      /**
	       * @param dim concrete dim
	       */
	
	
	      DataStore.prototype.getByRawIndex = function (dim, rawIdx) {
	        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
	          return NaN;
	        }
	
	        var dimStore = this._chunks[dim];
	        return dimStore ? dimStore[rawIdx] : NaN;
	      };
	      /**
	       * Get sum of data in one dimension
	       */
	
	
	      DataStore.prototype.getSum = function (dim) {
	        var dimData = this._chunks[dim];
	        var sum = 0;
	
	        if (dimData) {
	          for (var i = 0, len = this.count(); i < len; i++) {
	            var value = this.get(dim, i);
	
	            if (!isNaN(value)) {
	              sum += value;
	            }
	          }
	        }
	
	        return sum;
	      };
	      /**
	       * Get median of data in one dimension
	       */
	
	
	      DataStore.prototype.getMedian = function (dim) {
	        var dimDataArray = []; // map all data of one dimension
	
	        this.each([dim], function (val) {
	          if (!isNaN(val)) {
	            dimDataArray.push(val);
	          }
	        }); // TODO
	        // Use quick select?
	
	        var sortedDimDataArray = dimDataArray.sort(function (a, b) {
	          return a - b;
	        });
	        var len = this.count(); // calculate median
	
	        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
	      };
	      /**
	       * Retrieve the index with given raw data index.
	       */
	
	
	      DataStore.prototype.indexOfRawIndex = function (rawIndex) {
	        if (rawIndex >= this._rawCount || rawIndex < 0) {
	          return -1;
	        }
	
	        if (!this._indices) {
	          return rawIndex;
	        } // Indices are ascending
	
	
	        var indices = this._indices; // If rawIndex === dataIndex
	
	        var rawDataIndex = indices[rawIndex];
	
	        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
	          return rawIndex;
	        }
	
	        var left = 0;
	        var right = this._count - 1;
	
	        while (left <= right) {
	          var mid = (left + right) / 2 | 0;
	
	          if (indices[mid] < rawIndex) {
	            left = mid + 1;
	          } else if (indices[mid] > rawIndex) {
	            right = mid - 1;
	          } else {
	            return mid;
	          }
	        }
	
	        return -1;
	      };
	      /**
	       * Retrieve the index of nearest value.
	       * @param dim
	       * @param value
	       * @param [maxDistance=Infinity]
	       * @return If and only if multiple indices have
	       *         the same value, they are put to the result.
	       */
	
	
	      DataStore.prototype.indicesOfNearest = function (dim, value, maxDistance) {
	        var chunks = this._chunks;
	        var dimData = chunks[dim];
	        var nearestIndices = [];
	
	        if (!dimData) {
	          return nearestIndices;
	        }
	
	        if (maxDistance == null) {
	          maxDistance = Infinity;
	        }
	
	        var minDist = Infinity;
	        var minDiff = -1;
	        var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/SeriesData.js`.
	
	        for (var i = 0, len = this.count(); i < len; i++) {
	          var dataIndex = this.getRawIndex(i);
	          var diff = value - dimData[dataIndex];
	          var dist = Math.abs(diff);
	
	          if (dist <= maxDistance) {
	            // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
	            // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
	            // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
	            // So we choose the one that `diff >= 0` in this case.
	            // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
	            // should be push to `nearestIndices`.
	            if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
	              minDist = dist;
	              minDiff = diff;
	              nearestIndicesLen = 0;
	            }
	
	            if (diff === minDiff) {
	              nearestIndices[nearestIndicesLen++] = i;
	            }
	          }
	        }
	
	        nearestIndices.length = nearestIndicesLen;
	        return nearestIndices;
	      };
	
	      DataStore.prototype.getIndices = function () {
	        var newIndices;
	        var indices = this._indices;
	
	        if (indices) {
	          var Ctor = indices.constructor;
	          var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
	
	          if (Ctor === Array) {
	            newIndices = new Ctor(thisCount);
	
	            for (var i = 0; i < thisCount; i++) {
	              newIndices[i] = indices[i];
	            }
	          } else {
	            newIndices = new Ctor(indices.buffer, 0, thisCount);
	          }
	        } else {
	          var Ctor = getIndicesCtor(this._rawCount);
	          newIndices = new Ctor(this.count());
	
	          for (var i = 0; i < newIndices.length; i++) {
	            newIndices[i] = i;
	          }
	        }
	
	        return newIndices;
	      };
	      /**
	       * Data filter.
	       */
	
	
	      DataStore.prototype.filter = function (dims, cb) {
	        if (!this._count) {
	          return this;
	        }
	
	        var newStore = this.clone();
	        var count = newStore.count();
	        var Ctor = getIndicesCtor(newStore._rawCount);
	        var newIndices = new Ctor(count);
	        var value = [];
	        var dimSize = dims.length;
	        var offset = 0;
	        var dim0 = dims[0];
	        var chunks = newStore._chunks;
	
	        for (var i = 0; i < count; i++) {
	          var keep = void 0;
	          var rawIdx = newStore.getRawIndex(i); // Simple optimization
	
	          if (dimSize === 0) {
	            keep = cb(i);
	          } else if (dimSize === 1) {
	            var val = chunks[dim0][rawIdx];
	            keep = cb(val, i);
	          } else {
	            var k = 0;
	
	            for (; k < dimSize; k++) {
	              value[k] = chunks[dims[k]][rawIdx];
	            }
	
	            value[k] = i;
	            keep = cb.apply(null, value);
	          }
	
	          if (keep) {
	            newIndices[offset++] = rawIdx;
	          }
	        } // Set indices after filtered.
	
	
	        if (offset < count) {
	          newStore._indices = newIndices;
	        }
	
	        newStore._count = offset; // Reset data extent
	
	        newStore._extent = [];
	
	        newStore._updateGetRawIdx();
	
	        return newStore;
	      };
	      /**
	       * Select data in range. (For optimization of filter)
	       * (Manually inline code, support 5 million data filtering in data zoom.)
	       */
	
	
	      DataStore.prototype.selectRange = function (range) {
	        var newStore = this.clone();
	        var len = newStore._count;
	
	        if (!len) {
	          return this;
	        }
	
	        var dims = keys(range);
	        var dimSize = dims.length;
	
	        if (!dimSize) {
	          return this;
	        }
	
	        var originalCount = newStore.count();
	        var Ctor = getIndicesCtor(newStore._rawCount);
	        var newIndices = new Ctor(originalCount);
	        var offset = 0;
	        var dim0 = dims[0];
	        var min = range[dim0][0];
	        var max = range[dim0][1];
	        var storeArr = newStore._chunks;
	        var quickFinished = false;
	
	        if (!newStore._indices) {
	          // Extreme optimization for common case. About 2x faster in chrome.
	          var idx = 0;
	
	          if (dimSize === 1) {
	            var dimStorage = storeArr[dims[0]];
	
	            for (var i = 0; i < len; i++) {
	              var val = dimStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
	              // value indicates the line should be broken. But for the case like
	              // scatter plot, a data item with empty value will not be rendered,
	              // but the axis extent may be effected if some other dim of the data
	              // item has value. Fortunately it is not a significant negative effect.
	
	              if (val >= min && val <= max || isNaN(val)) {
	                newIndices[offset++] = idx;
	              }
	
	              idx++;
	            }
	
	            quickFinished = true;
	          } else if (dimSize === 2) {
	            var dimStorage = storeArr[dims[0]];
	            var dimStorage2 = storeArr[dims[1]];
	            var min2 = range[dims[1]][0];
	            var max2 = range[dims[1]][1];
	
	            for (var i = 0; i < len; i++) {
	              var val = dimStorage[i];
	              var val2 = dimStorage2[i]; // Do not filter NaN, see comment above.
	
	              if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
	                newIndices[offset++] = idx;
	              }
	
	              idx++;
	            }
	
	            quickFinished = true;
	          }
	        }
	
	        if (!quickFinished) {
	          if (dimSize === 1) {
	            for (var i = 0; i < originalCount; i++) {
	              var rawIndex = newStore.getRawIndex(i);
	              var val = storeArr[dims[0]][rawIndex]; // Do not filter NaN, see comment above.
	
	              if (val >= min && val <= max || isNaN(val)) {
	                newIndices[offset++] = rawIndex;
	              }
	            }
	          } else {
	            for (var i = 0; i < originalCount; i++) {
	              var keep = true;
	              var rawIndex = newStore.getRawIndex(i);
	
	              for (var k = 0; k < dimSize; k++) {
	                var dimk = dims[k];
	                var val = storeArr[dimk][rawIndex]; // Do not filter NaN, see comment above.
	
	                if (val < range[dimk][0] || val > range[dimk][1]) {
	                  keep = false;
	                }
	              }
	
	              if (keep) {
	                newIndices[offset++] = newStore.getRawIndex(i);
	              }
	            }
	          }
	        } // Set indices after filtered.
	
	
	        if (offset < originalCount) {
	          newStore._indices = newIndices;
	        }
	
	        newStore._count = offset; // Reset data extent
	
	        newStore._extent = [];
	
	        newStore._updateGetRawIdx();
	
	        return newStore;
	      }; // /**
	      //  * Data mapping to a plain array
	      //  */
	      // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
	      //     const result: any[] = [];
	      //     this.each(dims, function () {
	      //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
	      //     });
	      //     return result;
	      // }
	
	      /**
	       * Data mapping to a new List with given dimensions
	       */
	
	
	      DataStore.prototype.map = function (dims, cb) {
	        // TODO only clone picked chunks.
	        var target = this.clone(dims);
	
	        this._updateDims(target, dims, cb);
	
	        return target;
	      };
	      /**
	       * @caution Danger!! Only used in dataStack.
	       */
	
	
	      DataStore.prototype.modify = function (dims, cb) {
	        this._updateDims(this, dims, cb);
	      };
	
	      DataStore.prototype._updateDims = function (target, dims, cb) {
	        var targetChunks = target._chunks;
	        var tmpRetValue = [];
	        var dimSize = dims.length;
	        var dataCount = target.count();
	        var values = [];
	        var rawExtent = target._rawExtent;
	
	        for (var i = 0; i < dims.length; i++) {
	          rawExtent[dims[i]] = getInitialExtent();
	        }
	
	        for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
	          var rawIndex = target.getRawIndex(dataIndex);
	
	          for (var k = 0; k < dimSize; k++) {
	            values[k] = targetChunks[dims[k]][rawIndex];
	          }
	
	          values[dimSize] = dataIndex;
	          var retValue = cb && cb.apply(null, values);
	
	          if (retValue != null) {
	            // a number or string (in oridinal dimension)?
	            if (typeof retValue !== 'object') {
	              tmpRetValue[0] = retValue;
	              retValue = tmpRetValue;
	            }
	
	            for (var i = 0; i < retValue.length; i++) {
	              var dim = dims[i];
	              var val = retValue[i];
	              var rawExtentOnDim = rawExtent[dim];
	              var dimStore = targetChunks[dim];
	
	              if (dimStore) {
	                dimStore[rawIndex] = val;
	              }
	
	              if (val < rawExtentOnDim[0]) {
	                rawExtentOnDim[0] = val;
	              }
	
	              if (val > rawExtentOnDim[1]) {
	                rawExtentOnDim[1] = val;
	              }
	            }
	          }
	        }
	      };
	      /**
	       * Large data down sampling using largest-triangle-three-buckets
	       * @param {string} valueDimension
	       * @param {number} targetCount
	       */
	
	
	      DataStore.prototype.lttbDownSample = function (valueDimension, rate) {
	        var target = this.clone([valueDimension], true);
	        var targetStorage = target._chunks;
	        var dimStore = targetStorage[valueDimension];
	        var len = this.count();
	        var sampledIndex = 0;
	        var frameSize = Math.floor(1 / rate);
	        var currentRawIndex = this.getRawIndex(0);
	        var maxArea;
	        var area;
	        var nextRawIndex;
	        var newIndices = new (getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len)); // First frame use the first data.
	
	        newIndices[sampledIndex++] = currentRawIndex;
	
	        for (var i = 1; i < len - 1; i += frameSize) {
	          var nextFrameStart = Math.min(i + frameSize, len - 1);
	          var nextFrameEnd = Math.min(i + frameSize * 2, len);
	          var avgX = (nextFrameEnd + nextFrameStart) / 2;
	          var avgY = 0;
	
	          for (var idx = nextFrameStart; idx < nextFrameEnd; idx++) {
	            var rawIndex = this.getRawIndex(idx);
	            var y = dimStore[rawIndex];
	
	            if (isNaN(y)) {
	              continue;
	            }
	
	            avgY += y;
	          }
	
	          avgY /= nextFrameEnd - nextFrameStart;
	          var frameStart = i;
	          var frameEnd = Math.min(i + frameSize, len);
	          var pointAX = i - 1;
	          var pointAY = dimStore[currentRawIndex];
	          maxArea = -1;
	          nextRawIndex = frameStart;
	          var firstNaNIndex = -1;
	          var countNaN = 0; // Find a point from current frame that construct a triangle with largest area with previous selected point
	          // And the average of next frame.
	
	          for (var idx = frameStart; idx < frameEnd; idx++) {
	            var rawIndex = this.getRawIndex(idx);
	            var y = dimStore[rawIndex];
	
	            if (isNaN(y)) {
	              countNaN++;
	
	              if (firstNaNIndex < 0) {
	                firstNaNIndex = rawIndex;
	              }
	
	              continue;
	            } // Calculate triangle area over three buckets
	
	
	            area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
	
	            if (area > maxArea) {
	              maxArea = area;
	              nextRawIndex = rawIndex; // Next a is this b
	            }
	          }
	
	          if (countNaN > 0 && countNaN < frameEnd - frameStart) {
	            // Append first NaN point in every bucket.
	            // It is necessary to ensure the correct order of indices.
	            newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
	            nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
	          }
	
	          newIndices[sampledIndex++] = nextRawIndex;
	          currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
	        } // First frame use the last data.
	
	
	        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
	        target._count = sampledIndex;
	        target._indices = newIndices;
	        target.getRawIndex = this._getRawIdx;
	        return target;
	      };
	      /**
	       * Large data down sampling on given dimension
	       * @param sampleIndex Sample index for name and id
	       */
	
	
	      DataStore.prototype.downSample = function (dimension, rate, sampleValue, sampleIndex) {
	        var target = this.clone([dimension], true);
	        var targetStorage = target._chunks;
	        var frameValues = [];
	        var frameSize = Math.floor(1 / rate);
	        var dimStore = targetStorage[dimension];
	        var len = this.count();
	        var rawExtentOnDim = target._rawExtent[dimension] = getInitialExtent();
	        var newIndices = new (getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
	        var offset = 0;
	
	        for (var i = 0; i < len; i += frameSize) {
	          // Last frame
	          if (frameSize > len - i) {
	            frameSize = len - i;
	            frameValues.length = frameSize;
	          }
	
	          for (var k = 0; k < frameSize; k++) {
	            var dataIdx = this.getRawIndex(i + k);
	            frameValues[k] = dimStore[dataIdx];
	          }
	
	          var value = sampleValue(frameValues);
	          var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1)); // Only write value on the filtered data
	
	          dimStore[sampleFrameIdx] = value;
	
	          if (value < rawExtentOnDim[0]) {
	            rawExtentOnDim[0] = value;
	          }
	
	          if (value > rawExtentOnDim[1]) {
	            rawExtentOnDim[1] = value;
	          }
	
	          newIndices[offset++] = sampleFrameIdx;
	        }
	
	        target._count = offset;
	        target._indices = newIndices;
	
	        target._updateGetRawIdx();
	
	        return target;
	      };
	      /**
	       * Data iteration
	       * @param ctx default this
	       * @example
	       *  list.each('x', function (x, idx) {});
	       *  list.each(['x', 'y'], function (x, y, idx) {});
	       *  list.each(function (idx) {})
	       */
	
	
	      DataStore.prototype.each = function (dims, cb) {
	        if (!this._count) {
	          return;
	        }
	
	        var dimSize = dims.length;
	        var chunks = this._chunks;
	
	        for (var i = 0, len = this.count(); i < len; i++) {
	          var rawIdx = this.getRawIndex(i); // Simple optimization
	
	          switch (dimSize) {
	            case 0:
	              cb(i);
	              break;
	
	            case 1:
	              cb(chunks[dims[0]][rawIdx], i);
	              break;
	
	            case 2:
	              cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
	              break;
	
	            default:
	              var k = 0;
	              var value = [];
	
	              for (; k < dimSize; k++) {
	                value[k] = chunks[dims[k]][rawIdx];
	              } // Index
	
	
	              value[k] = i;
	              cb.apply(null, value);
	          }
	        }
	      };
	      /**
	       * Get extent of data in one dimension
	       */
	
	
	      DataStore.prototype.getDataExtent = function (dim) {
	        // Make sure use concrete dim as cache name.
	        var dimData = this._chunks[dim];
	        var initialExtent = getInitialExtent();
	
	        if (!dimData) {
	          return initialExtent;
	        } // Make more strict checkings to ensure hitting cache.
	
	
	        var currEnd = this.count(); // Consider the most cases when using data zoom, `getDataExtent`
	        // happened before filtering. We cache raw extent, which is not
	        // necessary to be cleared and recalculated when restore data.
	
	        var useRaw = !this._indices;
	        var dimExtent;
	
	        if (useRaw) {
	          return this._rawExtent[dim].slice();
	        }
	
	        dimExtent = this._extent[dim];
	
	        if (dimExtent) {
	          return dimExtent.slice();
	        }
	
	        dimExtent = initialExtent;
	        var min = dimExtent[0];
	        var max = dimExtent[1];
	
	        for (var i = 0; i < currEnd; i++) {
	          var rawIdx = this.getRawIndex(i);
	          var value = dimData[rawIdx];
	          value < min && (min = value);
	          value > max && (max = value);
	        }
	
	        dimExtent = [min, max];
	        this._extent[dim] = dimExtent;
	        return dimExtent;
	      };
	      /**
	       * Get raw data item
	       */
	
	
	      DataStore.prototype.getRawDataItem = function (idx) {
	        var rawIdx = this.getRawIndex(idx);
	
	        if (!this._provider.persistent) {
	          var val = [];
	          var chunks = this._chunks;
	
	          for (var i = 0; i < chunks.length; i++) {
	            val.push(chunks[i][rawIdx]);
	          }
	
	          return val;
	        } else {
	          return this._provider.getItem(rawIdx);
	        }
	      };
	      /**
	       * Clone shallow.
	       *
	       * @param clonedDims Determine which dims to clone. Will share the data if not specified.
	       */
	
	
	      DataStore.prototype.clone = function (clonedDims, ignoreIndices) {
	        var target = new DataStore();
	        var chunks = this._chunks;
	        var clonedDimsMap = clonedDims && reduce(clonedDims, function (obj, dimIdx) {
	          obj[dimIdx] = true;
	          return obj;
	        }, {});
	
	        if (clonedDimsMap) {
	          for (var i = 0; i < chunks.length; i++) {
	            // Not clone if dim is not picked.
	            target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : cloneChunk(chunks[i]);
	          }
	        } else {
	          target._chunks = chunks;
	        }
	
	        this._copyCommonProps(target);
	
	        if (!ignoreIndices) {
	          target._indices = this._cloneIndices();
	        }
	
	        target._updateGetRawIdx();
	
	        return target;
	      };
	
	      DataStore.prototype._copyCommonProps = function (target) {
	        target._count = this._count;
	        target._rawCount = this._rawCount;
	        target._provider = this._provider;
	        target._dimensions = this._dimensions;
	        target._extent = clone(this._extent);
	        target._rawExtent = clone(this._rawExtent);
	      };
	
	      DataStore.prototype._cloneIndices = function () {
	        if (this._indices) {
	          var Ctor = this._indices.constructor;
	          var indices = void 0;
	
	          if (Ctor === Array) {
	            var thisCount = this._indices.length;
	            indices = new Ctor(thisCount);
	
	            for (var i = 0; i < thisCount; i++) {
	              indices[i] = this._indices[i];
	            }
	          } else {
	            indices = new Ctor(this._indices);
	          }
	
	          return indices;
	        }
	
	        return null;
	      };
	
	      DataStore.prototype._getRawIdxIdentity = function (idx) {
	        return idx;
	      };
	
	      DataStore.prototype._getRawIdx = function (idx) {
	        if (idx < this._count && idx >= 0) {
	          return this._indices[idx];
	        }
	
	        return -1;
	      };
	
	      DataStore.prototype._updateGetRawIdx = function () {
	        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
	      };
	
	      DataStore.internalField = function () {
	        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
	          return parseDataValue(dataItem[dimIndex], this._dimensions[dimIndex]);
	        }
	
	        defaultDimValueGetters = {
	          arrayRows: getDimValueSimply,
	          objectRows: function (dataItem, property, dataIndex, dimIndex) {
	            return parseDataValue(dataItem[property], this._dimensions[dimIndex]);
	          },
	          keyedColumns: getDimValueSimply,
	          original: function (dataItem, property, dataIndex, dimIndex) {
	            // Performance sensitive, do not use modelUtil.getDataItemValue.
	            // If dataItem is an plain object with no value field, the let `value`
	            // will be assigned with the object, but it will be tread correctly
	            // in the `convertValue`.
	            var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
	            return parseDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
	            : value, this._dimensions[dimIndex]);
	          },
	          typedArray: function (dataItem, property, dataIndex, dimIndex) {
	            return dataItem[dimIndex];
	          }
	        };
	      }();
	
	      return DataStore;
	    }();
	
	    /**
	     * [REQUIREMENT_MEMO]:
	     * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
	     * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
	     * `root-dataset`. Them on `series` has higher priority.
	     * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
	     * confuse users: whether those props indicate how to visit the upstream source or visit
	     * the transform result source, and some transforms has nothing to do with these props,
	     * and some transforms might have multiple upstream.
	     * (3) Transforms should specify `metaRawOption` in each output, just like they can be
	     * declared in `root-dataset`.
	     * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
	     * That is for reducing complexity in transforms.
	     * PENDING: Whether to provide transposition transform?
	     *
	     * [IMPLEMENTAION_MEMO]:
	     * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
	     * They will not be calculated until `source` is about to be visited (to prevent from
	     * duplicate calcuation). `source` is visited only in series and input to transforms.
	     *
	     * [DIMENSION_INHERIT_RULE]:
	     * By default the dimensions are inherited from ancestors, unless a transform return
	     * a new dimensions definition.
	     * Consider the case:
	     * ```js
	     * dataset: [{
	     *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
	     * }, {
	     *     transform: { type: 'filter', ... }
	     * }]
	     * dataset: [{
	     *     dimension: ['Product', 'Sales', 'Prise'],
	     *     source: [ ['Cookies', 321, 44.21], ...]
	     * }, {
	     *     transform: { type: 'filter', ... }
	     * }]
	     * ```
	     * The two types of option should have the same behavior after transform.
	     *
	     *
	     * [SCENARIO]:
	     * (1) Provide source data directly:
	     * ```js
	     * series: {
	     *     encode: {...},
	     *     dimensions: [...]
	     *     seriesLayoutBy: 'row',
	     *     data: [[...]]
	     * }
	     * ```
	     * (2) Series refer to dataset.
	     * ```js
	     * series: [{
	     *     encode: {...}
	     *     // Ignore datasetIndex means `datasetIndex: 0`
	     *     // and the dimensions defination in dataset is used
	     * }, {
	     *     encode: {...},
	     *     seriesLayoutBy: 'column',
	     *     datasetIndex: 1
	     * }]
	     * ```
	     * (3) dataset transform
	     * ```js
	     * dataset: [{
	     *     source: [...]
	     * }, {
	     *     source: [...]
	     * }, {
	     *     // By default from 0.
	     *     transform: { type: 'filter', config: {...} }
	     * }, {
	     *     // Piped.
	     *     transform: [
	     *         { type: 'filter', config: {...} },
	     *         { type: 'sort', config: {...} }
	     *     ]
	     * }, {
	     *     id: 'regressionData',
	     *     fromDatasetIndex: 1,
	     *     // Third-party transform
	     *     transform: { type: 'ecStat:regression', config: {...} }
	     * }, {
	     *     // retrieve the extra result.
	     *     id: 'regressionFormula',
	     *     fromDatasetId: 'regressionData',
	     *     fromTransformResult: 1
	     * }]
	     * ```
	     */
	
	    var SourceManager =
	    /** @class */
	    function () {
	      function SourceManager(sourceHost) {
	        // Cached source. Do not repeat calculating if not dirty.
	        this._sourceList = [];
	        this._storeList = []; // version sign of each upstream source manager.
	
	        this._upstreamSignList = [];
	        this._versionSignBase = 0;
	        this._dirty = true;
	        this._sourceHost = sourceHost;
	      }
	      /**
	       * Mark dirty.
	       */
	
	
	      SourceManager.prototype.dirty = function () {
	        this._setLocalSource([], []);
	
	        this._storeList = [];
	        this._dirty = true;
	      };
	
	      SourceManager.prototype._setLocalSource = function (sourceList, upstreamSignList) {
	        this._sourceList = sourceList;
	        this._upstreamSignList = upstreamSignList;
	        this._versionSignBase++;
	
	        if (this._versionSignBase > 9e10) {
	          this._versionSignBase = 0;
	        }
	      };
	      /**
	       * For detecting whether the upstream source is dirty, so that
	       * the local cached source (in `_sourceList`) should be discarded.
	       */
	
	
	      SourceManager.prototype._getVersionSign = function () {
	        return this._sourceHost.uid + '_' + this._versionSignBase;
	      };
	      /**
	       * Always return a source instance. Otherwise throw error.
	       */
	
	
	      SourceManager.prototype.prepareSource = function () {
	        // For the case that call `setOption` multiple time but no data changed,
	        // cache the result source to prevent from repeating transform.
	        if (this._isDirty()) {
	          this._createSource();
	
	          this._dirty = false;
	        }
	      };
	
	      SourceManager.prototype._createSource = function () {
	        this._setLocalSource([], []);
	
	        var sourceHost = this._sourceHost;
	
	        var upSourceMgrList = this._getUpstreamSourceManagers();
	
	        var hasUpstream = !!upSourceMgrList.length;
	        var resultSourceList;
	        var upstreamSignList;
	
	        if (isSeries(sourceHost)) {
	          var seriesModel = sourceHost;
	          var data = void 0;
	          var sourceFormat = void 0;
	          var upSource = void 0; // Has upstream dataset
	
	          if (hasUpstream) {
	            var upSourceMgr = upSourceMgrList[0];
	            upSourceMgr.prepareSource();
	            upSource = upSourceMgr.getSource();
	            data = upSource.data;
	            sourceFormat = upSource.sourceFormat;
	            upstreamSignList = [upSourceMgr._getVersionSign()];
	          } // Series data is from own.
	          else {
	              data = seriesModel.get('data', true);
	              sourceFormat = isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL;
	              upstreamSignList = [];
	            } // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
	
	
	          var newMetaRawOption = this._getSourceMetaRawOption() || {};
	          var upMetaRawOption = upSource && upSource.metaRawOption || {};
	          var seriesLayoutBy = retrieve2(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
	          var sourceHeader = retrieve2(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader); // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
	          // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
	          // but series need `seriesLayoutBy: 'row'`.
	
	          var dimensions = retrieve2(newMetaRawOption.dimensions, upMetaRawOption.dimensions); // We share source with dataset as much as possible
	          // to avoid extra memory cost of high dimensional data.
	
	          var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
	          resultSourceList = needsCreateSource ? [createSource(data, {
	            seriesLayoutBy: seriesLayoutBy,
	            sourceHeader: sourceHeader,
	            dimensions: dimensions
	          }, sourceFormat)] : [];
	        } else {
	          var datasetModel = sourceHost; // Has upstream dataset.
	
	          if (hasUpstream) {
	            var result = this._applyTransform(upSourceMgrList);
	
	            resultSourceList = result.sourceList;
	            upstreamSignList = result.upstreamSignList;
	          } // Is root dataset.
	          else {
	              var sourceData = datasetModel.get('source', true);
	              resultSourceList = [createSource(sourceData, this._getSourceMetaRawOption(), null)];
	              upstreamSignList = [];
	            }
	        }
	
	        if (true) {
	          assert(resultSourceList && upstreamSignList);
	        }
	
	        this._setLocalSource(resultSourceList, upstreamSignList);
	      };
	
	      SourceManager.prototype._applyTransform = function (upMgrList) {
	        var datasetModel = this._sourceHost;
	        var transformOption = datasetModel.get('transform', true);
	        var fromTransformResult = datasetModel.get('fromTransformResult', true);
	
	        if (true) {
	          assert(fromTransformResult != null || transformOption != null);
	        }
	
	        if (fromTransformResult != null) {
	          var errMsg = '';
	
	          if (upMgrList.length !== 1) {
	            if (true) {
	              errMsg = 'When using `fromTransformResult`, there should be only one upstream dataset';
	            }
	
	            doThrow(errMsg);
	          }
	        }
	
	        var sourceList;
	        var upSourceList = [];
	        var upstreamSignList = [];
	        each(upMgrList, function (upMgr) {
	          upMgr.prepareSource();
	          var upSource = upMgr.getSource(fromTransformResult || 0);
	          var errMsg = '';
	
	          if (fromTransformResult != null && !upSource) {
	            if (true) {
	              errMsg = 'Can not retrieve result by `fromTransformResult`: ' + fromTransformResult;
	            }
	
	            doThrow(errMsg);
	          }
	
	          upSourceList.push(upSource);
	          upstreamSignList.push(upMgr._getVersionSign());
	        });
	
	        if (transformOption) {
	          sourceList = applyDataTransform(transformOption, upSourceList, {
	            datasetIndex: datasetModel.componentIndex
	          });
	        } else if (fromTransformResult != null) {
	          sourceList = [cloneSourceShallow(upSourceList[0])];
	        }
	
	        return {
	          sourceList: sourceList,
	          upstreamSignList: upstreamSignList
	        };
	      };
	
	      SourceManager.prototype._isDirty = function () {
	        if (this._dirty) {
	          return true;
	        } // All sourceList is from the some upstream.
	
	
	        var upSourceMgrList = this._getUpstreamSourceManagers();
	
	        for (var i = 0; i < upSourceMgrList.length; i++) {
	          var upSrcMgr = upSourceMgrList[i];
	
	          if ( // Consider the case that there is ancestor diry, call it recursively.
	          // The performance is probably not an issue because usually the chain is not long.
	          upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) {
	            return true;
	          }
	        }
	      };
	      /**
	       * @param sourceIndex By default 0, means "main source".
	       *                    In most cases there is only one source.
	       */
	
	
	      SourceManager.prototype.getSource = function (sourceIndex) {
	        sourceIndex = sourceIndex || 0;
	        var source = this._sourceList[sourceIndex];
	
	        if (!source) {
	          // Series may share source instance with dataset.
	          var upSourceMgrList = this._getUpstreamSourceManagers();
	
	          return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
	        }
	
	        return source;
	      };
	      /**
	       *
	       * Get a data store which can be shared across series.
	       * Only available for series.
	       *
	       * @param seriesDimRequest Dimensions that are generated in series.
	       *        Should have been sorted by `storeDimIndex` asc.
	       */
	
	
	      SourceManager.prototype.getSharedDataStore = function (seriesDimRequest) {
	        if (true) {
	          assert(isSeries(this._sourceHost), 'Can only call getDataStore on series source manager.');
	        }
	
	        var schema = seriesDimRequest.makeStoreSchema();
	        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
	      };
	
	      SourceManager.prototype._innerGetDataStore = function (storeDims, seriesSource, sourceReadKey) {
	        // TODO Can use other sourceIndex?
	        var sourceIndex = 0;
	        var storeList = this._storeList;
	        var cachedStoreMap = storeList[sourceIndex];
	
	        if (!cachedStoreMap) {
	          cachedStoreMap = storeList[sourceIndex] = {};
	        }
	
	        var cachedStore = cachedStoreMap[sourceReadKey];
	
	        if (!cachedStore) {
	          var upSourceMgr = this._getUpstreamSourceManagers()[0];
	
	          if (isSeries(this._sourceHost) && upSourceMgr) {
	            cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
	          } else {
	            cachedStore = new DataStore(); // Always create store from source of series.
	
	            cachedStore.initData(new DefaultDataProvider(seriesSource, storeDims.length), storeDims);
	          }
	
	          cachedStoreMap[sourceReadKey] = cachedStore;
	        }
	
	        return cachedStore;
	      };
	      /**
	       * PENDING: Is it fast enough?
	       * If no upstream, return empty array.
	       */
	
	
	      SourceManager.prototype._getUpstreamSourceManagers = function () {
	        // Always get the relationship from the raw option.
	        // Do not cache the link of the dependency graph, so that
	        // there is no need to update them when change happens.
	        var sourceHost = this._sourceHost;
	
	        if (isSeries(sourceHost)) {
	          var datasetModel = querySeriesUpstreamDatasetModel(sourceHost);
	          return !datasetModel ? [] : [datasetModel.getSourceManager()];
	        } else {
	          return map(queryDatasetUpstreamDatasetModels(sourceHost), function (datasetModel) {
	            return datasetModel.getSourceManager();
	          });
	        }
	      };
	
	      SourceManager.prototype._getSourceMetaRawOption = function () {
	        var sourceHost = this._sourceHost;
	        var seriesLayoutBy;
	        var sourceHeader;
	        var dimensions;
	
	        if (isSeries(sourceHost)) {
	          seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
	          sourceHeader = sourceHost.get('sourceHeader', true);
	          dimensions = sourceHost.get('dimensions', true);
	        } // See [REQUIREMENT_MEMO], `non-root-dataset` do not support them.
	        else if (!this._getUpstreamSourceManagers().length) {
	            var model = sourceHost;
	            seriesLayoutBy = model.get('seriesLayoutBy', true);
	            sourceHeader = model.get('sourceHeader', true);
	            dimensions = model.get('dimensions', true);
	          }
	
	        return {
	          seriesLayoutBy: seriesLayoutBy,
	          sourceHeader: sourceHeader,
	          dimensions: dimensions
	        };
	      };
	
	      return SourceManager;
	    }();
	    // disable the transform merge, but do not disable transform clone from rawOption.
	
	    function disableTransformOptionMerge(datasetModel) {
	      var transformOption = datasetModel.option.transform;
	      transformOption && setAsPrimitive(datasetModel.option.transform);
	    }
	
	    function isSeries(sourceHost) {
	      // Avoid circular dependency with Series.ts
	      return sourceHost.mainType === 'series';
	    }
	
	    function doThrow(errMsg) {
	      throw new Error(errMsg);
	    }
	
	    var TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1'; // TODO: more textStyle option
	
	    function getTooltipTextStyle(textStyle, renderMode) {
	      var nameFontColor = textStyle.color || '#6e7079';
	      var nameFontSize = textStyle.fontSize || 12;
	      var nameFontWeight = textStyle.fontWeight || '400';
	      var valueFontColor = textStyle.color || '#464646';
	      var valueFontSize = textStyle.fontSize || 14;
	      var valueFontWeight = textStyle.fontWeight || '900';
	
	      if (renderMode === 'html') {
	        // `textStyle` is probably from user input, should be encoded to reduce security risk.
	        return {
	          // eslint-disable-next-line max-len
	          nameStyle: "font-size:" + encodeHTML(nameFontSize + '') + "px;color:" + encodeHTML(nameFontColor) + ";font-weight:" + encodeHTML(nameFontWeight + ''),
	          // eslint-disable-next-line max-len
	          valueStyle: "font-size:" + encodeHTML(valueFontSize + '') + "px;color:" + encodeHTML(valueFontColor) + ";font-weight:" + encodeHTML(valueFontWeight + '')
	        };
	      } else {
	        return {
	          nameStyle: {
	            fontSize: nameFontSize,
	            fill: nameFontColor,
	            fontWeight: nameFontWeight
	          },
	          valueStyle: {
	            fontSize: valueFontSize,
	            fill: valueFontColor,
	            fontWeight: valueFontWeight
	          }
	        };
	      }
	    } // See `TooltipMarkupLayoutIntent['innerGapLevel']`.
	    // (value from UI design)
	
	
	    var HTML_GAPS = [0, 10, 20, 30];
	    var RICH_TEXT_GAPS = ['', '\n', '\n\n', '\n\n\n']; // eslint-disable-next-line max-len
	
	    function createTooltipMarkup(type, option) {
	      option.type = type;
	      return option;
	    }
	
	    function isSectionFragment(frag) {
	      return frag.type === 'section';
	    }
	
	    function getBuilder(frag) {
	      return isSectionFragment(frag) ? buildSection : buildNameValue;
	    }
	
	    function getBlockGapLevel(frag) {
	      if (isSectionFragment(frag)) {
	        var gapLevel_1 = 0;
	        var subBlockLen = frag.blocks.length;
	        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
	        each(frag.blocks, function (subBlock) {
	          var subGapLevel = getBlockGapLevel(subBlock); // If the some of the sub-blocks have some gaps (like 10px) inside, this block
	          // should use a larger gap (like 20px) to distinguish those sub-blocks.
	
	          if (subGapLevel >= gapLevel_1) {
	            gapLevel_1 = subGapLevel + +(hasInnerGap_1 && ( // 0 always can not be readable gap level.
	            !subGapLevel // If no header, always keep the sub gap level. Otherwise
	            // look weird in case `multipleSeries`.
	            || isSectionFragment(subBlock) && !subBlock.noHeader));
	          }
	        });
	        return gapLevel_1;
	      }
	
	      return 0;
	    }
	
	    function buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
	      var noHeader = fragment.noHeader;
	      var gaps = getGap(getBlockGapLevel(fragment));
	      var subMarkupTextList = [];
	      var subBlocks = fragment.blocks || [];
	      assert(!subBlocks || isArray(subBlocks));
	      subBlocks = subBlocks || [];
	      var orderMode = ctx.orderMode;
	
	      if (fragment.sortBlocks && orderMode) {
	        subBlocks = subBlocks.slice();
	        var orderMap = {
	          valueAsc: 'asc',
	          valueDesc: 'desc'
	        };
	
	        if (hasOwn(orderMap, orderMode)) {
	          var comparator_1 = new SortOrderComparator(orderMap[orderMode], null);
	          subBlocks.sort(function (a, b) {
	            return comparator_1.evaluate(a.sortParam, b.sortParam);
	          });
	        } // FIXME 'seriesDesc' necessary?
	        else if (orderMode === 'seriesDesc') {
	            subBlocks.reverse();
	          }
	      }
	
	      each(subBlocks, function (subBlock, idx) {
	        var valueFormatter = fragment.valueFormatter;
	        var subMarkupText = getBuilder(subBlock)( // Inherit valueFormatter
	        valueFormatter ? extend(extend({}, ctx), {
	          valueFormatter: valueFormatter
	        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
	        subMarkupText != null && subMarkupTextList.push(subMarkupText);
	      });
	      var subMarkupText = ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : wrapBlockHTML(subMarkupTextList.join(''), noHeader ? topMarginForOuterGap : gaps.html);
	
	      if (noHeader) {
	        return subMarkupText;
	      }
	
	      var displayableHeader = makeValueReadable(fragment.header, 'ordinal', ctx.useUTC);
	      var nameStyle = getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
	
	      if (ctx.renderMode === 'richText') {
	        return wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
	      } else {
	        return wrapBlockHTML("<div style=\"" + nameStyle + ";" + TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodeHTML(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
	      }
	    }
	
	    function buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
	      var renderMode = ctx.renderMode;
	      var noName = fragment.noName;
	      var noValue = fragment.noValue;
	      var noMarker = !fragment.markerType;
	      var name = fragment.name;
	      var useUTC = ctx.useUTC;
	
	      var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function (value) {
	        value = isArray(value) ? value : [value];
	        return map(value, function (val, idx) {
	          return makeValueReadable(val, isArray(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
	        });
	      };
	
	      if (noName && noValue) {
	        return;
	      }
	
	      var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
	      var readableName = noName ? '' : makeValueReadable(name, 'ordinal', useUTC);
	      var valueTypeOption = fragment.valueType;
	      var readableValueList = noValue ? [] : valueFormatter(fragment.value);
	      var valueAlignRight = !noMarker || !noName; // It little weird if only value next to marker but far from marker.
	
	      var valueCloseToMarker = !noMarker && noName;
	
	      var _a = getTooltipTextStyle(toolTipTextStyle, renderMode),
	          nameStyle = _a.nameStyle,
	          valueStyle = _a.valueStyle;
	
	      return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : wrapInlineNameRichText(ctx, readableName, nameStyle)) // Value has commas inside, so use ' ' as delimiter for multiple values.
	      + (noValue ? '' : wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
	    }
	    /**
	     * @return markupText. null/undefined means no content.
	     */
	
	
	    function buildTooltipMarkup(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
	      if (!fragment) {
	        return;
	      }
	
	      var builder = getBuilder(fragment);
	      var ctx = {
	        useUTC: useUTC,
	        renderMode: renderMode,
	        orderMode: orderMode,
	        markupStyleCreator: markupStyleCreator,
	        valueFormatter: fragment.valueFormatter
	      };
	      return builder(ctx, fragment, 0, toolTipTextStyle);
	    }
	
	    function getGap(gapLevel) {
	      return {
	        html: HTML_GAPS[gapLevel],
	        richText: RICH_TEXT_GAPS[gapLevel]
	      };
	    }
	
	    function wrapBlockHTML(encodedContent, topGap) {
	      var clearfix = '<div style="clear:both"></div>';
	      var marginCSS = "margin: " + topGap + "px 0 0";
	      return "<div style=\"" + marginCSS + ";" + TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
	    }
	
	    function wrapInlineNameHTML(name, leftHasMarker, style) {
	      var marginCss = leftHasMarker ? 'margin-left:2px' : '';
	      return "<span style=\"" + style + ";" + marginCss + "\">" + encodeHTML(name) + '</span>';
	    }
	
	    function wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
	      // Do not too close to marker, considering there are multiple values separated by spaces.
	      var paddingStr = valueCloseToMarker ? '10px' : '20px';
	      var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
	      valueList = isArray(valueList) ? valueList : [valueList];
	      return "<span style=\"" + alignCSS + ";" + style + "\">" // Value has commas inside, so use '  ' as delimiter for multiple values.
	      + map(valueList, function (value) {
	        return encodeHTML(value);
	      }).join('&nbsp;&nbsp;') + '</span>';
	    }
	
	    function wrapInlineNameRichText(ctx, name, style) {
	      return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
	    }
	
	    function wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
	      var styles = [style];
	      var paddingLeft = valueCloseToMarker ? 10 : 20;
	      alignRight && styles.push({
	        padding: [0, 0, 0, paddingLeft],
	        align: 'right'
	      }); // Value has commas inside, so use '  ' as delimiter for multiple values.
	
	      return ctx.markupStyleCreator.wrapRichTextStyle(isArray(values) ? values.join('  ') : values, styles);
	    }
	
	    function retrieveVisualColorForTooltipMarker(series, dataIndex) {
	      var style = series.getData().getItemVisual(dataIndex, 'style');
	      var color = style[series.visualDrawType];
	      return convertToColorString(color);
	    }
	    function getPaddingFromTooltipModel(model, renderMode) {
	      var padding = model.get('padding');
	      return padding != null ? padding // We give slightly different to look pretty.
	      : renderMode === 'richText' ? [8, 10] : 10;
	    }
	    /**
	     * The major feature is generate styles for `renderMode: 'richText'`.
	     * But it also serves `renderMode: 'html'` to provide
	     * "renderMode-independent" API.
	     */
	
	    var TooltipMarkupStyleCreator =
	    /** @class */
	    function () {
	      function TooltipMarkupStyleCreator() {
	        this.richTextStyles = {}; // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
	        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
	        // rather than static shared by all creators (which will cause it increase to fast).
	
	        this._nextStyleNameId = getRandomIdBase();
	      }
	
	      TooltipMarkupStyleCreator.prototype._generateStyleName = function () {
	        return '__EC_aUTo_' + this._nextStyleNameId++;
	      };
	
	      TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function (markerType, colorStr, renderMode) {
	        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
	        var marker = getTooltipMarker({
	          color: colorStr,
	          type: markerType,
	          renderMode: renderMode,
	          markerId: markerId
	        });
	
	        if (isString(marker)) {
	          return marker;
	        } else {
	          if (true) {
	            assert(markerId);
	          }
	
	          this.richTextStyles[markerId] = marker.style;
	          return marker.content;
	        }
	      };
	      /**
	       * @usage
	       * ```ts
	       * const styledText = markupStyleCreator.wrapRichTextStyle([
	       *     // The styles will be auto merged.
	       *     {
	       *         fontSize: 12,
	       *         color: 'blue'
	       *     },
	       *     {
	       *         padding: 20
	       *     }
	       * ]);
	       * ```
	       */
	
	
	      TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function (text, styles) {
	        var finalStl = {};
	
	        if (isArray(styles)) {
	          each(styles, function (stl) {
	            return extend(finalStl, stl);
	          });
	        } else {
	          extend(finalStl, styles);
	        }
	
	        var styleName = this._generateStyleName();
	
	        this.richTextStyles[styleName] = finalStl;
	        return "{" + styleName + "|" + text + "}";
	      };
	
	      return TooltipMarkupStyleCreator;
	    }();
	
	    function defaultSeriesFormatTooltip(opt) {
	      var series = opt.series;
	      var dataIndex = opt.dataIndex;
	      var multipleSeries = opt.multipleSeries;
	      var data = series.getData();
	      var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
	      var tooltipDimLen = tooltipDims.length;
	      var value = series.getRawValue(dataIndex);
	      var isValueArr = isArray(value);
	      var markerColor = retrieveVisualColorForTooltipMarker(series, dataIndex); // Complicated rule for pretty tooltip.
	
	      var inlineValue;
	      var inlineValueType;
	      var subBlocks;
	      var sortParam;
	
	      if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
	        var formatArrResult = formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
	        inlineValue = formatArrResult.inlineValues;
	        inlineValueType = formatArrResult.inlineValueTypes;
	        subBlocks = formatArrResult.blocks; // Only support tooltip sort by the first inline value. It's enough in most cases.
	
	        sortParam = formatArrResult.inlineValues[0];
	      } else if (tooltipDimLen) {
	        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
	        sortParam = inlineValue = retrieveRawValue(data, dataIndex, tooltipDims[0]);
	        inlineValueType = dimInfo.type;
	      } else {
	        sortParam = inlineValue = isValueArr ? value[0] : value;
	      } // Do not show generated series name. It might not be readable.
	
	
	      var seriesNameSpecified = isNameSpecified(series);
	      var seriesName = seriesNameSpecified && series.name || '';
	      var itemName = data.getName(dataIndex);
	      var inlineName = multipleSeries ? seriesName : itemName;
	      return createTooltipMarkup('section', {
	        header: seriesName,
	        // When series name is not specified, do not show a header line with only '-'.
	        // This case always happens in tooltip.trigger: 'item'.
	        noHeader: multipleSeries || !seriesNameSpecified,
	        sortParam: sortParam,
	        blocks: [createTooltipMarkup('nameValue', {
	          markerType: 'item',
	          markerColor: markerColor,
	          // Do not mix display seriesName and itemName in one tooltip,
	          // which might confuses users.
	          name: inlineName,
	          // name dimension might be auto assigned, where the name might
	          // be not readable. So we check trim here.
	          noName: !trim(inlineName),
	          value: inlineValue,
	          valueType: inlineValueType
	        })].concat(subBlocks || [])
	      });
	    }
	
	    function formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
	      // check: category-no-encode-has-axis-data in dataset.html
	      var data = series.getData();
	      var isValueMultipleLine = reduce(value, function (isValueMultipleLine, val, idx) {
	        var dimItem = data.getDimensionInfo(idx);
	        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
	      }, false);
	      var inlineValues = [];
	      var inlineValueTypes = [];
	      var blocks = [];
	      tooltipDims.length ? each(tooltipDims, function (dim) {
	        setEachItem(retrieveRawValue(data, dataIndex, dim), dim);
	      }) // By default, all dims is used on tooltip.
	      : each(value, setEachItem);
	
	      function setEachItem(val, dim) {
	        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
	
	        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
	          return;
	        }
	
	        if (isValueMultipleLine) {
	          blocks.push(createTooltipMarkup('nameValue', {
	            markerType: 'subItem',
	            markerColor: colorStr,
	            name: dimInfo.displayName,
	            value: val,
	            valueType: dimInfo.type
	          }));
	        } else {
	          inlineValues.push(val);
	          inlineValueTypes.push(dimInfo.type);
	        }
	      }
	
	      return {
	        inlineValues: inlineValues,
	        inlineValueTypes: inlineValueTypes,
	        blocks: blocks
	      };
	    }
	
	    var inner$1 = makeInner();
	
	    function getSelectionKey(data, dataIndex) {
	      return data.getName(dataIndex) || data.getId(dataIndex);
	    }
	
	    var SERIES_UNIVERSAL_TRANSITION_PROP = '__universalTransitionEnabled';
	
	    var SeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(SeriesModel, _super);
	
	      function SeriesModel() {
	        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
	        // the class members must not be initialized in constructor or declaration place.
	        // Otherwise there is bad case:
	        //   class A {xxx = 1;}
	        //   enableClassExtend(A);
	        //   class B extends A {}
	        //   var C = B.extend({xxx: 5});
	        //   var c = new C();
	        //   console.log(c.xxx); // expect 5 but always 1.
	        var _this = _super !== null && _super.apply(this, arguments) || this; // ---------------------------------------
	        // Props about data selection
	        // ---------------------------------------
	
	
	        _this._selectedDataIndicesMap = {};
	        return _this;
	      }
	
	      SeriesModel.prototype.init = function (option, parentModel, ecModel) {
	        this.seriesIndex = this.componentIndex;
	        this.dataTask = createTask({
	          count: dataTaskCount,
	          reset: dataTaskReset
	        });
	        this.dataTask.context = {
	          model: this
	        };
	        this.mergeDefaultAndTheme(option, ecModel);
	        var sourceManager = inner$1(this).sourceManager = new SourceManager(this);
	        sourceManager.prepareSource();
	        var data = this.getInitialData(option, ecModel);
	        wrapData(data, this);
	        this.dataTask.context.data = data;
	
	        if (true) {
	          assert(data, 'getInitialData returned invalid data.');
	        }
	
	        inner$1(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
	        // dataBeforeProcessed by cloneShallow), cloneShallow will
	        // cause data.graph.data !== data when using
	        // module:echarts/data/Graph or module:echarts/data/Tree.
	        // See module:echarts/data/helper/linkSeriesData
	        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
	        // init or merge stage, because the data can be restored. So we do not `restoreData`
	        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
	        // Call `seriesModel.getRawData()` instead.
	        // this.restoreData();
	
	        autoSeriesName(this);
	
	        this._initSelectedMapFromData(data);
	      };
	      /**
	       * Util for merge default and theme to option
	       */
	
	
	      SeriesModel.prototype.mergeDefaultAndTheme = function (option, ecModel) {
	        var layoutMode = fetchLayoutMode(this);
	        var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
	        // But if name duplicate between series subType
	        // (for example: parallel) add component mainType,
	        // add suffix 'Series'.
	
	        var themeSubType = this.subType;
	
	        if (ComponentModel.hasClass(themeSubType)) {
	          themeSubType += 'Series';
	        }
	
	        merge(option, ecModel.getTheme().get(this.subType));
	        merge(option, this.getDefaultOption()); // Default label emphasis `show`
	
	        defaultEmphasis(option, 'label', ['show']);
	        this.fillDataTextStyle(option.data);
	
	        if (layoutMode) {
	          mergeLayoutParam(option, inputPositionParams, layoutMode);
	        }
	      };
	
	      SeriesModel.prototype.mergeOption = function (newSeriesOption, ecModel) {
	        // this.settingTask.dirty();
	        newSeriesOption = merge(this.option, newSeriesOption, true);
	        this.fillDataTextStyle(newSeriesOption.data);
	        var layoutMode = fetchLayoutMode(this);
	
	        if (layoutMode) {
	          mergeLayoutParam(this.option, newSeriesOption, layoutMode);
	        }
	
	        var sourceManager = inner$1(this).sourceManager;
	        sourceManager.dirty();
	        sourceManager.prepareSource();
	        var data = this.getInitialData(newSeriesOption, ecModel);
	        wrapData(data, this);
	        this.dataTask.dirty();
	        this.dataTask.context.data = data;
	        inner$1(this).dataBeforeProcessed = data;
	        autoSeriesName(this);
	
	        this._initSelectedMapFromData(data);
	      };
	
	      SeriesModel.prototype.fillDataTextStyle = function (data) {
	        // Default data label emphasis `show`
	        // FIXME Tree structure data ?
	        // FIXME Performance ?
	        if (data && !isTypedArray(data)) {
	          var props = ['show'];
	
	          for (var i = 0; i < data.length; i++) {
	            if (data[i] && data[i].label) {
	              defaultEmphasis(data[i], 'label', props);
	            }
	          }
	        }
	      };
	      /**
	       * Init a data structure from data related option in series
	       * Must be overridden.
	       */
	
	
	      SeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return;
	      };
	      /**
	       * Append data to list
	       */
	
	
	      SeriesModel.prototype.appendData = function (params) {
	        // FIXME ???
	        // (1) If data from dataset, forbidden append.
	        // (2) support append data of dataset.
	        var data = this.getRawData();
	        data.appendData(params.data);
	      };
	      /**
	       * Consider some method like `filter`, `map` need make new data,
	       * We should make sure that `seriesModel.getData()` get correct
	       * data in the stream procedure. So we fetch data from upstream
	       * each time `task.perform` called.
	       */
	
	
	      SeriesModel.prototype.getData = function (dataType) {
	        var task = getCurrentTask(this);
	
	        if (task) {
	          var data = task.context.data;
	          return dataType == null ? data : data.getLinkedData(dataType);
	        } else {
	          // When series is not alive (that may happen when click toolbox
	          // restore or setOption with not merge mode), series data may
	          // be still need to judge animation or something when graphic
	          // elements want to know whether fade out.
	          return inner$1(this).data;
	        }
	      };
	
	      SeriesModel.prototype.getAllData = function () {
	        var mainData = this.getData();
	        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [{
	          data: mainData
	        }];
	      };
	
	      SeriesModel.prototype.setData = function (data) {
	        var task = getCurrentTask(this);
	
	        if (task) {
	          var context = task.context; // Consider case: filter, data sample.
	          // FIXME:TS never used, so comment it
	          // if (context.data !== data && task.modifyOutputEnd) {
	          //     task.setOutputEnd(data.count());
	          // }
	
	          context.outputData = data; // Caution: setData should update context.data,
	          // Because getData may be called multiply in a
	          // single stage and expect to get the data just
	          // set. (For example, AxisProxy, x y both call
	          // getData and setDate sequentially).
	          // So the context.data should be fetched from
	          // upstream each time when a stage starts to be
	          // performed.
	
	          if (task !== this.dataTask) {
	            context.data = data;
	          }
	        }
	
	        inner$1(this).data = data;
	      };
	
	      SeriesModel.prototype.getEncode = function () {
	        var encode = this.get('encode', true);
	
	        if (encode) {
	          return createHashMap(encode);
	        }
	      };
	
	      SeriesModel.prototype.getSourceManager = function () {
	        return inner$1(this).sourceManager;
	      };
	
	      SeriesModel.prototype.getSource = function () {
	        return this.getSourceManager().getSource();
	      };
	      /**
	       * Get data before processed
	       */
	
	
	      SeriesModel.prototype.getRawData = function () {
	        return inner$1(this).dataBeforeProcessed;
	      };
	
	      SeriesModel.prototype.getColorBy = function () {
	        var colorBy = this.get('colorBy');
	        return colorBy || 'series';
	      };
	
	      SeriesModel.prototype.isColorBySeries = function () {
	        return this.getColorBy() === 'series';
	      };
	      /**
	       * Get base axis if has coordinate system and has axis.
	       * By default use coordSys.getBaseAxis();
	       * Can be overridden for some chart.
	       * @return {type} description
	       */
	
	
	      SeriesModel.prototype.getBaseAxis = function () {
	        var coordSys = this.coordinateSystem; // @ts-ignore
	
	        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
	      };
	      /**
	       * Default tooltip formatter
	       *
	       * @param dataIndex
	       * @param multipleSeries
	       * @param dataType
	       * @param renderMode valid values: 'html'(by default) and 'richText'.
	       *        'html' is used for rendering tooltip in extra DOM form, and the result
	       *        string is used as DOM HTML content.
	       *        'richText' is used for rendering tooltip in rich text form, for those where
	       *        DOM operation is not supported.
	       * @return formatted tooltip with `html` and `markers`
	       *        Notice: The override method can also return string
	       */
	
	
	      SeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        return defaultSeriesFormatTooltip({
	          series: this,
	          dataIndex: dataIndex,
	          multipleSeries: multipleSeries
	        });
	      };
	
	      SeriesModel.prototype.isAnimationEnabled = function () {
	        var ecModel = this.ecModel; // Disable animation if using echarts in node but not give ssr flag.
	        // In ssr mode, renderToString will generate svg with css animation.
	
	        if (env.node && !(ecModel && ecModel.ssr)) {
	          return false;
	        }
	
	        var animationEnabled = this.getShallow('animation');
	
	        if (animationEnabled) {
	          if (this.getData().count() > this.getShallow('animationThreshold')) {
	            animationEnabled = false;
	          }
	        }
	
	        return !!animationEnabled;
	      };
	
	      SeriesModel.prototype.restoreData = function () {
	        this.dataTask.dirty();
	      };
	
	      SeriesModel.prototype.getColorFromPalette = function (name, scope, requestColorNum) {
	        var ecModel = this.ecModel; // PENDING
	
	        var color = PaletteMixin.prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
	
	        if (!color) {
	          color = ecModel.getColorFromPalette(name, scope, requestColorNum);
	        }
	
	        return color;
	      };
	      /**
	       * Use `data.mapDimensionsAll(coordDim)` instead.
	       * @deprecated
	       */
	
	
	      SeriesModel.prototype.coordDimToDataDim = function (coordDim) {
	        return this.getRawData().mapDimensionsAll(coordDim);
	      };
	      /**
	       * Get progressive rendering count each step
	       */
	
	
	      SeriesModel.prototype.getProgressive = function () {
	        return this.get('progressive');
	      };
	      /**
	       * Get progressive rendering count each step
	       */
	
	
	      SeriesModel.prototype.getProgressiveThreshold = function () {
	        return this.get('progressiveThreshold');
	      }; // PENGING If selectedMode is null ?
	
	
	      SeriesModel.prototype.select = function (innerDataIndices, dataType) {
	        this._innerSelect(this.getData(dataType), innerDataIndices);
	      };
	
	      SeriesModel.prototype.unselect = function (innerDataIndices, dataType) {
	        var selectedMap = this.option.selectedMap;
	
	        if (!selectedMap) {
	          return;
	        }
	
	        var selectedMode = this.option.selectedMode;
	        var data = this.getData(dataType);
	
	        if (selectedMode === 'series' || selectedMap === 'all') {
	          this.option.selectedMap = {};
	          this._selectedDataIndicesMap = {};
	          return;
	        }
	
	        for (var i = 0; i < innerDataIndices.length; i++) {
	          var dataIndex = innerDataIndices[i];
	          var nameOrId = getSelectionKey(data, dataIndex);
	          selectedMap[nameOrId] = false;
	          this._selectedDataIndicesMap[nameOrId] = -1;
	        }
	      };
	
	      SeriesModel.prototype.toggleSelect = function (innerDataIndices, dataType) {
	        var tmpArr = [];
	
	        for (var i = 0; i < innerDataIndices.length; i++) {
	          tmpArr[0] = innerDataIndices[i];
	          this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
	        }
	      };
	
	      SeriesModel.prototype.getSelectedDataIndices = function () {
	        if (this.option.selectedMap === 'all') {
	          return [].slice.call(this.getData().getIndices());
	        }
	
	        var selectedDataIndicesMap = this._selectedDataIndicesMap;
	        var nameOrIds = keys(selectedDataIndicesMap);
	        var dataIndices = [];
	
	        for (var i = 0; i < nameOrIds.length; i++) {
	          var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
	
	          if (dataIndex >= 0) {
	            dataIndices.push(dataIndex);
	          }
	        }
	
	        return dataIndices;
	      };
	
	      SeriesModel.prototype.isSelected = function (dataIndex, dataType) {
	        var selectedMap = this.option.selectedMap;
	
	        if (!selectedMap) {
	          return false;
	        }
	
	        var data = this.getData(dataType);
	        return (selectedMap === 'all' || selectedMap[getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get(['select', 'disabled']);
	      };
	
	      SeriesModel.prototype.isUniversalTransitionEnabled = function () {
	        if (this[SERIES_UNIVERSAL_TRANSITION_PROP]) {
	          return true;
	        }
	
	        var universalTransitionOpt = this.option.universalTransition; // Quick reject
	
	        if (!universalTransitionOpt) {
	          return false;
	        }
	
	        if (universalTransitionOpt === true) {
	          return true;
	        } // Can be simply 'universalTransition: true'
	
	
	        return universalTransitionOpt && universalTransitionOpt.enabled;
	      };
	
	      SeriesModel.prototype._innerSelect = function (data, innerDataIndices) {
	        var _a, _b;
	
	        var option = this.option;
	        var selectedMode = option.selectedMode;
	        var len = innerDataIndices.length;
	
	        if (!selectedMode || !len) {
	          return;
	        }
	
	        if (selectedMode === 'series') {
	          option.selectedMap = 'all';
	        } else if (selectedMode === 'multiple') {
	          if (!isObject(option.selectedMap)) {
	            option.selectedMap = {};
	          }
	
	          var selectedMap = option.selectedMap;
	
	          for (var i = 0; i < len; i++) {
	            var dataIndex = innerDataIndices[i]; // TODO different types of data share same object.
	
	            var nameOrId = getSelectionKey(data, dataIndex);
	            selectedMap[nameOrId] = true;
	            this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
	          }
	        } else if (selectedMode === 'single' || selectedMode === true) {
	          var lastDataIndex = innerDataIndices[len - 1];
	          var nameOrId = getSelectionKey(data, lastDataIndex);
	          option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
	          this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
	        }
	      };
	
	      SeriesModel.prototype._initSelectedMapFromData = function (data) {
	        // Ignore select info in data if selectedMap exists.
	        // NOTE It's only for legacy usage. edge data is not supported.
	        if (this.option.selectedMap) {
	          return;
	        }
	
	        var dataIndices = [];
	
	        if (data.hasItemOption) {
	          data.each(function (idx) {
	            var rawItem = data.getRawDataItem(idx);
	
	            if (rawItem && rawItem.selected) {
	              dataIndices.push(idx);
	            }
	          });
	        }
	
	        if (dataIndices.length > 0) {
	          this._innerSelect(data, dataIndices);
	        }
	      }; // /**
	      //  * @see {module:echarts/stream/Scheduler}
	      //  */
	      // abstract pipeTask: null
	
	
	      SeriesModel.registerClass = function (clz) {
	        return ComponentModel.registerClass(clz);
	      };
	
	      SeriesModel.protoInitialize = function () {
	        var proto = SeriesModel.prototype;
	        proto.type = 'series.__base__';
	        proto.seriesIndex = 0;
	        proto.ignoreStyleOnData = false;
	        proto.hasSymbolVisual = false;
	        proto.defaultSymbol = 'circle'; // Make sure the values can be accessed!
	
	        proto.visualStyleAccessPath = 'itemStyle';
	        proto.visualDrawType = 'fill';
	      }();
	
	      return SeriesModel;
	    }(ComponentModel);
	
	    mixin(SeriesModel, DataFormatMixin);
	    mixin(SeriesModel, PaletteMixin);
	    mountExtend(SeriesModel, ComponentModel);
	    /**
	     * MUST be called after `prepareSource` called
	     * Here we need to make auto series, especially for auto legend. But we
	     * do not modify series.name in option to avoid side effects.
	     */
	
	    function autoSeriesName(seriesModel) {
	      // User specified name has higher priority, otherwise it may cause
	      // series can not be queried unexpectedly.
	      var name = seriesModel.name;
	
	      if (!isNameSpecified(seriesModel)) {
	        seriesModel.name = getSeriesAutoName(seriesModel) || name;
	      }
	    }
	
	    function getSeriesAutoName(seriesModel) {
	      var data = seriesModel.getRawData();
	      var dataDims = data.mapDimensionsAll('seriesName');
	      var nameArr = [];
	      each(dataDims, function (dataDim) {
	        var dimInfo = data.getDimensionInfo(dataDim);
	        dimInfo.displayName && nameArr.push(dimInfo.displayName);
	      });
	      return nameArr.join(' ');
	    }
	
	    function dataTaskCount(context) {
	      return context.model.getRawData().count();
	    }
	
	    function dataTaskReset(context) {
	      var seriesModel = context.model;
	      seriesModel.setData(seriesModel.getRawData().cloneShallow());
	      return dataTaskProgress;
	    }
	
	    function dataTaskProgress(param, context) {
	      // Avoid repeat cloneShallow when data just created in reset.
	      if (context.outputData && param.end > context.outputData.count()) {
	        context.model.getRawData().cloneShallow(context.outputData);
	      }
	    } // TODO refactor
	
	
	    function wrapData(data, seriesModel) {
	      each(concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function (methodName) {
	        data.wrapMethod(methodName, curry(onDataChange, seriesModel));
	      });
	    }
	
	    function onDataChange(seriesModel, newList) {
	      var task = getCurrentTask(seriesModel);
	
	      if (task) {
	        // Consider case: filter, selectRange
	        task.setOutputEnd((newList || this).count());
	      }
	
	      return newList;
	    }
	
	    function getCurrentTask(seriesModel) {
	      var scheduler = (seriesModel.ecModel || {}).scheduler;
	      var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
	
	      if (pipeline) {
	        // When pipline finished, the currrentTask keep the last
	        // task (renderTask).
	        var task = pipeline.currentTask;
	
	        if (task) {
	          var agentStubMap = task.agentStubMap;
	
	          if (agentStubMap) {
	            task = agentStubMap.get(seriesModel.uid);
	          }
	        }
	
	        return task;
	      }
	    }
	
	    var ComponentView =
	    /** @class */
	    function () {
	      function ComponentView() {
	        this.group = new Group();
	        this.uid = getUID('viewComponent');
	      }
	
	      ComponentView.prototype.init = function (ecModel, api) {};
	
	      ComponentView.prototype.render = function (model, ecModel, api, payload) {};
	
	      ComponentView.prototype.dispose = function (ecModel, api) {};
	
	      ComponentView.prototype.updateView = function (model, ecModel, api, payload) {// Do nothing;
	      };
	
	      ComponentView.prototype.updateLayout = function (model, ecModel, api, payload) {// Do nothing;
	      };
	
	      ComponentView.prototype.updateVisual = function (model, ecModel, api, payload) {// Do nothing;
	      };
	      /**
	       * Hook for toggle blur target series.
	       * Can be used in marker for blur or leave blur the markers
	       */
	
	
	      ComponentView.prototype.toggleBlurSeries = function (seriesModels, isBlur, ecModel) {// Do nothing;
	      };
	      /**
	       * Traverse the new rendered elements.
	       *
	       * It will traverse the new added element in progressive rendering.
	       * And traverse all in normal rendering.
	       */
	
	
	      ComponentView.prototype.eachRendered = function (cb) {
	        var group = this.group;
	
	        if (group) {
	          group.traverse(cb);
	        }
	      };
	
	      return ComponentView;
	    }();
	    enableClassExtend(ComponentView);
	    enableClassManagement(ComponentView);
	
	    /**
	     * @return {string} If large mode changed, return string 'reset';
	     */
	
	    function createRenderPlanner() {
	      var inner = makeInner();
	      return function (seriesModel) {
	        var fields = inner(seriesModel);
	        var pipelineContext = seriesModel.pipelineContext;
	        var originalLarge = !!fields.large;
	        var originalProgressive = !!fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
	        // exists. See #11611 . Probably we need to modify this structure, see the comment
	        // on `performRawSeries` in `Schedular.js`.
	
	        var large = fields.large = !!(pipelineContext && pipelineContext.large);
	        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
	        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
	      };
	    }
	
	    var inner$2 = makeInner();
	    var renderPlanner = createRenderPlanner();
	
	    var ChartView =
	    /** @class */
	    function () {
	      function ChartView() {
	        this.group = new Group();
	        this.uid = getUID('viewChart');
	        this.renderTask = createTask({
	          plan: renderTaskPlan,
	          reset: renderTaskReset
	        });
	        this.renderTask.context = {
	          view: this
	        };
	      }
	
	      ChartView.prototype.init = function (ecModel, api) {};
	
	      ChartView.prototype.render = function (seriesModel, ecModel, api, payload) {
	        if (true) {
	          throw new Error('render method must been implemented');
	        }
	      };
	      /**
	       * Highlight series or specified data item.
	       */
	
	
	      ChartView.prototype.highlight = function (seriesModel, ecModel, api, payload) {
	        var data = seriesModel.getData(payload && payload.dataType);
	
	        if (!data) {
	          if (true) {
	            error("Unknown dataType " + payload.dataType);
	          }
	
	          return;
	        }
	
	        toggleHighlight(data, payload, 'emphasis');
	      };
	      /**
	       * Downplay series or specified data item.
	       */
	
	
	      ChartView.prototype.downplay = function (seriesModel, ecModel, api, payload) {
	        var data = seriesModel.getData(payload && payload.dataType);
	
	        if (!data) {
	          if (true) {
	            error("Unknown dataType " + payload.dataType);
	          }
	
	          return;
	        }
	
	        toggleHighlight(data, payload, 'normal');
	      };
	      /**
	       * Remove self.
	       */
	
	
	      ChartView.prototype.remove = function (ecModel, api) {
	        this.group.removeAll();
	      };
	      /**
	       * Dispose self.
	       */
	
	
	      ChartView.prototype.dispose = function (ecModel, api) {};
	
	      ChartView.prototype.updateView = function (seriesModel, ecModel, api, payload) {
	        this.render(seriesModel, ecModel, api, payload);
	      }; // FIXME never used?
	
	
	      ChartView.prototype.updateLayout = function (seriesModel, ecModel, api, payload) {
	        this.render(seriesModel, ecModel, api, payload);
	      }; // FIXME never used?
	
	
	      ChartView.prototype.updateVisual = function (seriesModel, ecModel, api, payload) {
	        this.render(seriesModel, ecModel, api, payload);
	      };
	      /**
	       * Traverse the new rendered elements.
	       *
	       * It will traverse the new added element in progressive rendering.
	       * And traverse all in normal rendering.
	       */
	
	
	      ChartView.prototype.eachRendered = function (cb) {
	        traverseElements(this.group, cb);
	      };
	
	      ChartView.markUpdateMethod = function (payload, methodName) {
	        inner$2(payload).updateMethod = methodName;
	      };
	
	      ChartView.protoInitialize = function () {
	        var proto = ChartView.prototype;
	        proto.type = 'chart';
	      }();
	
	      return ChartView;
	    }();
	    /**
	     * Set state of single element
	     */
	
	    function elSetState(el, state, highlightDigit) {
	      if (el && isHighDownDispatcher(el)) {
	        (state === 'emphasis' ? enterEmphasis : leaveEmphasis)(el, highlightDigit);
	      }
	    }
	
	    function toggleHighlight(data, payload, state) {
	      var dataIndex = queryDataIndex(data, payload);
	      var highlightDigit = payload && payload.highlightKey != null ? getHighlightDigit(payload.highlightKey) : null;
	
	      if (dataIndex != null) {
	        each(normalizeToArray(dataIndex), function (dataIdx) {
	          elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
	        });
	      } else {
	        data.eachItemGraphicEl(function (el) {
	          elSetState(el, state, highlightDigit);
	        });
	      }
	    }
	
	    enableClassExtend(ChartView, ['dispose']);
	    enableClassManagement(ChartView);
	
	    function renderTaskPlan(context) {
	      return renderPlanner(context.model);
	    }
	
	    function renderTaskReset(context) {
	      var seriesModel = context.model;
	      var ecModel = context.ecModel;
	      var api = context.api;
	      var payload = context.payload; // FIXME: remove updateView updateVisual
	
	      var progressiveRender = seriesModel.pipelineContext.progressiveRender;
	      var view = context.view;
	      var updateMethod = payload && inner$2(payload).updateMethod;
	      var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
	      // is less than progressive threshold.
	      : 'render';
	
	      if (methodName !== 'render') {
	        view[methodName](seriesModel, ecModel, api, payload);
	      }
	
	      return progressMethodMap[methodName];
	    }
	
	    var progressMethodMap = {
	      incrementalPrepareRender: {
	        progress: function (params, context) {
	          context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
	        }
	      },
	      render: {
	        // Put view.render in `progress` to support appendData. But in this case
	        // view.render should not be called in reset, otherwise it will be called
	        // twise. Use `forceFirstProgress` to make sure that view.render is called
	        // in any cases.
	        forceFirstProgress: true,
	        progress: function (params, context) {
	          context.view.render(context.model, context.ecModel, context.api, context.payload);
	        }
	      }
	    };
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var ORIGIN_METHOD = '\0__throttleOriginMethod';
	    var RATE = '\0__throttleRate';
	    var THROTTLE_TYPE = '\0__throttleType';
	    /**
	     * @public
	     * @param {(Function)} fn
	     * @param {number} [delay=0] Unit: ms.
	     * @param {boolean} [debounce=false]
	     *        true: If call interval less than `delay`, only the last call works.
	     *        false: If call interval less than `delay, call works on fixed rate.
	     * @return {(Function)} throttled fn.
	     */
	
	    function throttle(fn, delay, debounce) {
	      var currCall;
	      var lastCall = 0;
	      var lastExec = 0;
	      var timer = null;
	      var diff;
	      var scope;
	      var args;
	      var debounceNextCall;
	      delay = delay || 0;
	
	      function exec() {
	        lastExec = new Date().getTime();
	        timer = null;
	        fn.apply(scope, args || []);
	      }
	
	      var cb = function () {
	        var cbArgs = [];
	
	        for (var _i = 0; _i < arguments.length; _i++) {
	          cbArgs[_i] = arguments[_i];
	        }
	
	        currCall = new Date().getTime();
	        scope = this;
	        args = cbArgs;
	        var thisDelay = debounceNextCall || delay;
	        var thisDebounce = debounceNextCall || debounce;
	        debounceNextCall = null;
	        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
	        clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
	        // than a new call of `cb`, that is, preserving the command order. Consider
	        // calculating "scale rate" when roaming as an example. When a call of `cb`
	        // happens, either the `exec` is called dierectly, or the call is delayed.
	        // But the delayed call should never be later than next call of `cb`. Under
	        // this assurance, we can simply update view state each time `dispatchAction`
	        // triggered by user roaming, but not need to add extra code to avoid the
	        // state being "rolled-back".
	
	        if (thisDebounce) {
	          timer = setTimeout(exec, thisDelay);
	        } else {
	          if (diff >= 0) {
	            exec();
	          } else {
	            timer = setTimeout(exec, -diff);
	          }
	        }
	
	        lastCall = currCall;
	      };
	      /**
	       * Clear throttle.
	       * @public
	       */
	
	
	      cb.clear = function () {
	        if (timer) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      /**
	       * Enable debounce once.
	       */
	
	
	      cb.debounceNextCall = function (debounceDelay) {
	        debounceNextCall = debounceDelay;
	      };
	
	      return cb;
	    }
	    /**
	     * Create throttle method or update throttle rate.
	     *
	     * @example
	     * ComponentView.prototype.render = function () {
	     *     ...
	     *     throttle.createOrUpdate(
	     *         this,
	     *         '_dispatchAction',
	     *         this.model.get('throttle'),
	     *         'fixRate'
	     *     );
	     * };
	     * ComponentView.prototype.remove = function () {
	     *     throttle.clear(this, '_dispatchAction');
	     * };
	     * ComponentView.prototype.dispose = function () {
	     *     throttle.clear(this, '_dispatchAction');
	     * };
	     *
	     */
	
	    function createOrUpdate(obj, fnAttr, rate, throttleType) {
	      var fn = obj[fnAttr];
	
	      if (!fn) {
	        return;
	      }
	
	      var originFn = fn[ORIGIN_METHOD] || fn;
	      var lastThrottleType = fn[THROTTLE_TYPE];
	      var lastRate = fn[RATE];
	
	      if (lastRate !== rate || lastThrottleType !== throttleType) {
	        if (rate == null || !throttleType) {
	          return obj[fnAttr] = originFn;
	        }
	
	        fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
	        fn[ORIGIN_METHOD] = originFn;
	        fn[THROTTLE_TYPE] = throttleType;
	        fn[RATE] = rate;
	      }
	
	      return fn;
	    }
	    /**
	     * Clear throttle. Example see throttle.createOrUpdate.
	     */
	
	    function clear(obj, fnAttr) {
	      var fn = obj[fnAttr];
	
	      if (fn && fn[ORIGIN_METHOD]) {
	        // Clear throttle
	        fn.clear && fn.clear();
	        obj[fnAttr] = fn[ORIGIN_METHOD];
	      }
	    }
	
	    var inner$3 = makeInner();
	    var defaultStyleMappers = {
	      itemStyle: makeStyleMapper(ITEM_STYLE_KEY_MAP, true),
	      lineStyle: makeStyleMapper(LINE_STYLE_KEY_MAP, true)
	    };
	    var defaultColorKey = {
	      lineStyle: 'stroke',
	      itemStyle: 'fill'
	    };
	
	    function getStyleMapper(seriesModel, stylePath) {
	      var styleMapper = seriesModel.visualStyleMapper || defaultStyleMappers[stylePath];
	
	      if (!styleMapper) {
	        console.warn("Unknown style type '" + stylePath + "'.");
	        return defaultStyleMappers.itemStyle;
	      }
	
	      return styleMapper;
	    }
	
	    function getDefaultColorKey(seriesModel, stylePath) {
	      // return defaultColorKey[stylePath] ||
	      var colorKey = seriesModel.visualDrawType || defaultColorKey[stylePath];
	
	      if (!colorKey) {
	        console.warn("Unknown style type '" + stylePath + "'.");
	        return 'fill';
	      }
	
	      return colorKey;
	    }
	
	    var seriesStyleTask = {
	      createOnAllSeries: true,
	      performRawSeries: true,
	      reset: function (seriesModel, ecModel) {
	        var data = seriesModel.getData();
	        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
	
	        var styleModel = seriesModel.getModel(stylePath);
	        var getStyle = getStyleMapper(seriesModel, stylePath);
	        var globalStyle = getStyle(styleModel);
	        var decalOption = styleModel.getShallow('decal');
	
	        if (decalOption) {
	          data.setVisual('decal', decalOption);
	          decalOption.dirty = true;
	        } // TODO
	
	
	        var colorKey = getDefaultColorKey(seriesModel, stylePath);
	        var color = globalStyle[colorKey]; // TODO style callback
	
	        var colorCallback = isFunction(color) ? color : null;
	        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto'; // Get from color palette by default.
	
	        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
	          // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
	          // make it effect palette. Because some scenarios users need to make some series
	          // transparent or as background, which should better not effect the palette.
	          var colorPalette = seriesModel.getColorFromPalette( // TODO series count changed.
	          seriesModel.name, null, ecModel.getSeriesCount());
	
	          if (!globalStyle[colorKey]) {
	            globalStyle[colorKey] = colorPalette;
	            data.setVisual('colorFromPalette', true);
	          }
	
	          globalStyle.fill = globalStyle.fill === 'auto' || isFunction(globalStyle.fill) ? colorPalette : globalStyle.fill;
	          globalStyle.stroke = globalStyle.stroke === 'auto' || isFunction(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
	        }
	
	        data.setVisual('style', globalStyle);
	        data.setVisual('drawType', colorKey); // Only visible series has each data be visual encoded
	
	        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
	          data.setVisual('colorFromPalette', false);
	          return {
	            dataEach: function (data, idx) {
	              var dataParams = seriesModel.getDataParams(idx);
	              var itemStyle = extend({}, globalStyle);
	              itemStyle[colorKey] = colorCallback(dataParams);
	              data.setItemVisual(idx, 'style', itemStyle);
	            }
	          };
	        }
	      }
	    };
	    var sharedModel = new Model();
	    var dataStyleTask = {
	      createOnAllSeries: true,
	      performRawSeries: true,
	      reset: function (seriesModel, ecModel) {
	        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) {
	          return;
	        }
	
	        var data = seriesModel.getData();
	        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
	
	        var getStyle = getStyleMapper(seriesModel, stylePath);
	        var colorKey = data.getVisual('drawType');
	        return {
	          dataEach: data.hasItemOption ? function (data, idx) {
	            // Not use getItemModel for performance considuration
	            var rawItem = data.getRawDataItem(idx);
	
	            if (rawItem && rawItem[stylePath]) {
	              sharedModel.option = rawItem[stylePath];
	              var style = getStyle(sharedModel);
	              var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
	              extend(existsStyle, style);
	
	              if (sharedModel.option.decal) {
	                data.setItemVisual(idx, 'decal', sharedModel.option.decal);
	                sharedModel.option.decal.dirty = true;
	              }
	
	              if (colorKey in style) {
	                data.setItemVisual(idx, 'colorFromPalette', false);
	              }
	            }
	          } : null
	        };
	      }
	    }; // Pick color from palette for the data which has not been set with color yet.
	    // Note: do not support stream rendering. No such cases yet.
	
	    var dataColorPaletteTask = {
	      performRawSeries: true,
	      overallReset: function (ecModel) {
	        // Each type of series uses one scope.
	        // Pie and funnel are using different scopes.
	        var paletteScopeGroupByType = createHashMap();
	        ecModel.eachSeries(function (seriesModel) {
	          var colorBy = seriesModel.getColorBy();
	
	          if (seriesModel.isColorBySeries()) {
	            return;
	          }
	
	          var key = seriesModel.type + '-' + colorBy;
	          var colorScope = paletteScopeGroupByType.get(key);
	
	          if (!colorScope) {
	            colorScope = {};
	            paletteScopeGroupByType.set(key, colorScope);
	          }
	
	          inner$3(seriesModel).scope = colorScope;
	        });
	        ecModel.eachSeries(function (seriesModel) {
	          if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) {
	            return;
	          }
	
	          var dataAll = seriesModel.getRawData();
	          var idxMap = {};
	          var data = seriesModel.getData();
	          var colorScope = inner$3(seriesModel).scope;
	          var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
	          var colorKey = getDefaultColorKey(seriesModel, stylePath);
	          data.each(function (idx) {
	            var rawIdx = data.getRawIndex(idx);
	            idxMap[rawIdx] = idx;
	          }); // Iterate on data before filtered. To make sure color from palette can be
	          // Consistent when toggling legend.
	
	          dataAll.each(function (rawIdx) {
	            var idx = idxMap[rawIdx];
	            var fromPalette = data.getItemVisual(idx, 'colorFromPalette'); // Get color from palette for each data only when the color is inherited from series color, which is
	            // also picked from color palette. So following situation is not in the case:
	            // 1. series.itemStyle.color is set
	            // 2. color is encoded by visualMap
	
	            if (fromPalette) {
	              var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
	              var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
	              var dataCount = dataAll.count();
	              itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
	            }
	          });
	        });
	      }
	    };
	
	    var PI$3 = Math.PI;
	    /**
	     * @param {module:echarts/ExtensionAPI} api
	     * @param {Object} [opts]
	     * @param {string} [opts.text]
	     * @param {string} [opts.color]
	     * @param {string} [opts.textColor]
	     * @return {module:zrender/Element}
	     */
	
	    function defaultLoading(api, opts) {
	      opts = opts || {};
	      defaults(opts, {
	        text: 'loading',
	        textColor: '#000',
	        fontSize: 12,
	        fontWeight: 'normal',
	        fontStyle: 'normal',
	        fontFamily: 'sans-serif',
	        maskColor: 'rgba(255, 255, 255, 0.8)',
	        showSpinner: true,
	        color: '#5470c6',
	        spinnerRadius: 10,
	        lineWidth: 5,
	        zlevel: 0
	      });
	      var group = new Group();
	      var mask = new Rect({
	        style: {
	          fill: opts.maskColor
	        },
	        zlevel: opts.zlevel,
	        z: 10000
	      });
	      group.add(mask);
	      var textContent = new ZRText({
	        style: {
	          text: opts.text,
	          fill: opts.textColor,
	          fontSize: opts.fontSize,
	          fontWeight: opts.fontWeight,
	          fontStyle: opts.fontStyle,
	          fontFamily: opts.fontFamily
	        },
	        zlevel: opts.zlevel,
	        z: 10001
	      });
	      var labelRect = new Rect({
	        style: {
	          fill: 'none'
	        },
	        textContent: textContent,
	        textConfig: {
	          position: 'right',
	          distance: 10
	        },
	        zlevel: opts.zlevel,
	        z: 10001
	      });
	      group.add(labelRect);
	      var arc;
	
	      if (opts.showSpinner) {
	        arc = new Arc({
	          shape: {
	            startAngle: -PI$3 / 2,
	            endAngle: -PI$3 / 2 + 0.1,
	            r: opts.spinnerRadius
	          },
	          style: {
	            stroke: opts.color,
	            lineCap: 'round',
	            lineWidth: opts.lineWidth
	          },
	          zlevel: opts.zlevel,
	          z: 10001
	        });
	        arc.animateShape(true).when(1000, {
	          endAngle: PI$3 * 3 / 2
	        }).start('circularInOut');
	        arc.animateShape(true).when(1000, {
	          startAngle: PI$3 * 3 / 2
	        }).delay(300).start('circularInOut');
	        group.add(arc);
	      } // Inject resize
	
	
	      group.resize = function () {
	        var textWidth = textContent.getBoundingRect().width;
	        var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
	        // textDistance needs to be calculated when both animation and text exist
	
	        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) // only show the text
	        + (opts.showSpinner ? 0 : textWidth / 2) // only show the spinner
	        + (textWidth ? 0 : r);
	        var cy = api.getHeight() / 2;
	        opts.showSpinner && arc.setShape({
	          cx: cx,
	          cy: cy
	        });
	        labelRect.setShape({
	          x: cx - r,
	          y: cy - r,
	          width: r * 2,
	          height: r * 2
	        });
	        mask.setShape({
	          x: 0,
	          y: 0,
	          width: api.getWidth(),
	          height: api.getHeight()
	        });
	      };
	
	      group.resize();
	      return group;
	    }
	
	    var Scheduler =
	    /** @class */
	    function () {
	      function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
	        // key: handlerUID
	        this._stageTaskMap = createHashMap();
	        this.ecInstance = ecInstance;
	        this.api = api; // Fix current processors in case that in some rear cases that
	        // processors might be registered after echarts instance created.
	        // Register processors incrementally for a echarts instance is
	        // not supported by this stream architecture.
	
	        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
	        visualHandlers = this._visualHandlers = visualHandlers.slice();
	        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
	      }
	
	      Scheduler.prototype.restoreData = function (ecModel, payload) {
	        // TODO: Only restore needed series and components, but not all components.
	        // Currently `restoreData` of all of the series and component will be called.
	        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
	        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
	        // and some components like coordinate system, axes, dataZoom, visualMap only
	        // need their target series refresh.
	        // (1) If we are implementing this feature some day, we should consider these cases:
	        // if a data processor depends on a component (e.g., dataZoomProcessor depends
	        // on the settings of `dataZoom`), it should be re-performed if the component
	        // is modified by `setOption`.
	        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
	        // it should be re-performed when the result array of `getTargetSeries` changed.
	        // We use `dependencies` to cover these issues.
	        // (3) How to update target series when coordinate system related components modified.
	        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
	        // and this case all of the tasks will be set as dirty.
	        ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
	        // depends on all of the series.
	        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
	        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
	        // that the overall task is set as dirty and to be performed, otherwise it probably cause
	        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
	        // probably cause state chaos (consider `dataZoomProcessor`).
	
	        this._stageTaskMap.each(function (taskRecord) {
	          var overallTask = taskRecord.overallTask;
	          overallTask && overallTask.dirty();
	        });
	      }; // If seriesModel provided, incremental threshold is check by series data.
	
	
	      Scheduler.prototype.getPerformArgs = function (task, isBlock) {
	        // For overall task
	        if (!task.__pipeline) {
	          return;
	        }
	
	        var pipeline = this._pipelineMap.get(task.__pipeline.id);
	
	        var pCtx = pipeline.context;
	        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
	        var step = incremental ? pipeline.step : null;
	        var modDataCount = pCtx && pCtx.modDataCount;
	        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
	        return {
	          step: step,
	          modBy: modBy,
	          modDataCount: modDataCount
	        };
	      };
	
	      Scheduler.prototype.getPipeline = function (pipelineId) {
	        return this._pipelineMap.get(pipelineId);
	      };
	      /**
	       * Current, progressive rendering starts from visual and layout.
	       * Always detect render mode in the same stage, avoiding that incorrect
	       * detection caused by data filtering.
	       * Caution:
	       * `updateStreamModes` use `seriesModel.getData()`.
	       */
	
	
	      Scheduler.prototype.updateStreamModes = function (seriesModel, view) {
	        var pipeline = this._pipelineMap.get(seriesModel.uid);
	
	        var data = seriesModel.getData();
	        var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
	        // animation frame. Note that some types of series do not provide
	        // `view.incrementalPrepareRender` but support `chart.appendData`. We
	        // use the term `incremental` but not `progressive` to describe the
	        // case that `chart.appendData`.
	
	        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
	        var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
	        // see `test/candlestick-large3.html`
	
	        var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
	        seriesModel.pipelineContext = pipeline.context = {
	          progressiveRender: progressiveRender,
	          modDataCount: modDataCount,
	          large: large
	        };
	      };
	
	      Scheduler.prototype.restorePipelines = function (ecModel) {
	        var scheduler = this;
	        var pipelineMap = scheduler._pipelineMap = createHashMap();
	        ecModel.eachSeries(function (seriesModel) {
	          var progressive = seriesModel.getProgressive();
	          var pipelineId = seriesModel.uid;
	          pipelineMap.set(pipelineId, {
	            id: pipelineId,
	            head: null,
	            tail: null,
	            threshold: seriesModel.getProgressiveThreshold(),
	            progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
	            blockIndex: -1,
	            step: Math.round(progressive || 700),
	            count: 0
	          });
	
	          scheduler._pipe(seriesModel, seriesModel.dataTask);
	        });
	      };
	
	      Scheduler.prototype.prepareStageTasks = function () {
	        var stageTaskMap = this._stageTaskMap;
	        var ecModel = this.api.getModel();
	        var api = this.api;
	        each(this._allHandlers, function (handler) {
	          var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
	          var errMsg = '';
	
	          if (true) {
	            // Currently do not need to support to sepecify them both.
	            errMsg = '"reset" and "overallReset" must not be both specified.';
	          }
	
	          assert(!(handler.reset && handler.overallReset), errMsg);
	          handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
	          handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
	        }, this);
	      };
	
	      Scheduler.prototype.prepareView = function (view, model, ecModel, api) {
	        var renderTask = view.renderTask;
	        var context = renderTask.context;
	        context.model = model;
	        context.ecModel = ecModel;
	        context.api = api;
	        renderTask.__block = !view.incrementalPrepareRender;
	
	        this._pipe(model, renderTask);
	      };
	
	      Scheduler.prototype.performDataProcessorTasks = function (ecModel, payload) {
	        // If we do not use `block` here, it should be considered when to update modes.
	        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
	          block: true
	        });
	      };
	
	      Scheduler.prototype.performVisualTasks = function (ecModel, payload, opt) {
	        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
	      };
	
	      Scheduler.prototype._performStageTasks = function (stageHandlers, ecModel, payload, opt) {
	        opt = opt || {};
	        var unfinished = false;
	        var scheduler = this;
	        each(stageHandlers, function (stageHandler, idx) {
	          if (opt.visualType && opt.visualType !== stageHandler.visualType) {
	            return;
	          }
	
	          var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
	
	          var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
	          var overallTask = stageHandlerRecord.overallTask;
	
	          if (overallTask) {
	            var overallNeedDirty_1;
	            var agentStubMap = overallTask.agentStubMap;
	            agentStubMap.each(function (stub) {
	              if (needSetDirty(opt, stub)) {
	                stub.dirty();
	                overallNeedDirty_1 = true;
	              }
	            });
	            overallNeedDirty_1 && overallTask.dirty();
	            scheduler.updatePayload(overallTask, payload);
	            var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
	            // then execute the overall task. And stub will call seriesModel.setData,
	            // which ensures that in the overallTask seriesModel.getData() will not
	            // return incorrect data.
	
	            agentStubMap.each(function (stub) {
	              stub.perform(performArgs_1);
	            });
	
	            if (overallTask.perform(performArgs_1)) {
	              unfinished = true;
	            }
	          } else if (seriesTaskMap) {
	            seriesTaskMap.each(function (task, pipelineId) {
	              if (needSetDirty(opt, task)) {
	                task.dirty();
	              }
	
	              var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
	              // if intending to declare `performRawSeries` in handlers, only
	              // stream-independent (specifically, data item independent) operations can be
	              // performed. Because if a series is filtered, most of the tasks will not
	              // be performed. A stream-dependent operation probably cause wrong biz logic.
	              // Perhaps we should not provide a separate callback for this case instead
	              // of providing the config `performRawSeries`. The stream-dependent operations
	              // and stream-independent operations should better not be mixed.
	
	              performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
	              scheduler.updatePayload(task, payload);
	
	              if (task.perform(performArgs)) {
	                unfinished = true;
	              }
	            });
	          }
	        });
	
	        function needSetDirty(opt, task) {
	          return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
	        }
	
	        this.unfinished = unfinished || this.unfinished;
	      };
	
	      Scheduler.prototype.performSeriesTasks = function (ecModel) {
	        var unfinished;
	        ecModel.eachSeries(function (seriesModel) {
	          // Progress to the end for dataInit and dataRestore.
	          unfinished = seriesModel.dataTask.perform() || unfinished;
	        });
	        this.unfinished = unfinished || this.unfinished;
	      };
	
	      Scheduler.prototype.plan = function () {
	        // Travel pipelines, check block.
	        this._pipelineMap.each(function (pipeline) {
	          var task = pipeline.tail;
	
	          do {
	            if (task.__block) {
	              pipeline.blockIndex = task.__idxInPipeline;
	              break;
	            }
	
	            task = task.getUpstream();
	          } while (task);
	        });
	      };
	
	      Scheduler.prototype.updatePayload = function (task, payload) {
	        payload !== 'remain' && (task.context.payload = payload);
	      };
	
	      Scheduler.prototype._createSeriesStageTask = function (stageHandler, stageHandlerRecord, ecModel, api) {
	        var scheduler = this;
	        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap; // The count of stages are totally about only several dozen, so
	        // do not need to reuse the map.
	
	        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = createHashMap();
	        var seriesType = stageHandler.seriesType;
	        var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
	        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
	        // it works but it may cause other irrelevant charts blocked.
	
	        if (stageHandler.createOnAllSeries) {
	          ecModel.eachRawSeries(create);
	        } else if (seriesType) {
	          ecModel.eachRawSeriesByType(seriesType, create);
	        } else if (getTargetSeries) {
	          getTargetSeries(ecModel, api).each(create);
	        }
	
	        function create(seriesModel) {
	          var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
	          // Reuse original task instance.
	
	          var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || createTask({
	            plan: seriesTaskPlan,
	            reset: seriesTaskReset,
	            count: seriesTaskCount
	          }));
	          task.context = {
	            model: seriesModel,
	            ecModel: ecModel,
	            api: api,
	            // PENDING: `useClearVisual` not used?
	            useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
	            plan: stageHandler.plan,
	            reset: stageHandler.reset,
	            scheduler: scheduler
	          };
	
	          scheduler._pipe(seriesModel, task);
	        }
	      };
	
	      Scheduler.prototype._createOverallStageTask = function (stageHandler, stageHandlerRecord, ecModel, api) {
	        var scheduler = this;
	        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
	        || createTask({
	          reset: overallTaskReset
	        });
	        overallTask.context = {
	          ecModel: ecModel,
	          api: api,
	          overallReset: stageHandler.overallReset,
	          scheduler: scheduler
	        };
	        var oldAgentStubMap = overallTask.agentStubMap; // The count of stages are totally about only several dozen, so
	        // do not need to reuse the map.
	
	        var newAgentStubMap = overallTask.agentStubMap = createHashMap();
	        var seriesType = stageHandler.seriesType;
	        var getTargetSeries = stageHandler.getTargetSeries;
	        var overallProgress = true;
	        var shouldOverallTaskDirty = false; // FIXME:TS never used, so comment it
	        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
	        // An overall task with seriesType detected or has `getTargetSeries`, we add
	        // stub in each pipelines, it will set the overall task dirty when the pipeline
	        // progress. Moreover, to avoid call the overall task each frame (too frequent),
	        // we set the pipeline block.
	
	        var errMsg = '';
	
	        if (true) {
	          errMsg = '"createOnAllSeries" is not supported for "overallReset", ' + 'because it will block all streams.';
	        }
	
	        assert(!stageHandler.createOnAllSeries, errMsg);
	
	        if (seriesType) {
	          ecModel.eachRawSeriesByType(seriesType, createStub);
	        } else if (getTargetSeries) {
	          getTargetSeries(ecModel, api).each(createStub);
	        } // Otherwise, (usually it is legacy case), the overall task will only be
	        // executed when upstream is dirty. Otherwise the progressive rendering of all
	        // pipelines will be disabled unexpectedly. But it still needs stubs to receive
	        // dirty info from upstream.
	        else {
	            overallProgress = false;
	            each(ecModel.getSeries(), createStub);
	          }
	
	        function createStub(seriesModel) {
	          var pipelineId = seriesModel.uid;
	          var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || ( // When the result of `getTargetSeries` changed, the overallTask
	          // should be set as dirty and re-performed.
	          shouldOverallTaskDirty = true, createTask({
	            reset: stubReset,
	            onDirty: stubOnDirty
	          })));
	          stub.context = {
	            model: seriesModel,
	            overallProgress: overallProgress // FIXME:TS never used, so comment it
	            // modifyOutputEnd: modifyOutputEnd
	
	          };
	          stub.agent = overallTask;
	          stub.__block = overallProgress;
	
	          scheduler._pipe(seriesModel, stub);
	        }
	
	        if (shouldOverallTaskDirty) {
	          overallTask.dirty();
	        }
	      };
	
	      Scheduler.prototype._pipe = function (seriesModel, task) {
	        var pipelineId = seriesModel.uid;
	
	        var pipeline = this._pipelineMap.get(pipelineId);
	
	        !pipeline.head && (pipeline.head = task);
	        pipeline.tail && pipeline.tail.pipe(task);
	        pipeline.tail = task;
	        task.__idxInPipeline = pipeline.count++;
	        task.__pipeline = pipeline;
	      };
	
	      Scheduler.wrapStageHandler = function (stageHandler, visualType) {
	        if (isFunction(stageHandler)) {
	          stageHandler = {
	            overallReset: stageHandler,
	            seriesType: detectSeriseType(stageHandler)
	          };
	        }
	
	        stageHandler.uid = getUID('stageHandler');
	        visualType && (stageHandler.visualType = visualType);
	        return stageHandler;
	      };
	      return Scheduler;
	    }();
	
	    function overallTaskReset(context) {
	      context.overallReset(context.ecModel, context.api, context.payload);
	    }
	
	    function stubReset(context) {
	      return context.overallProgress && stubProgress;
	    }
	
	    function stubProgress() {
	      this.agent.dirty();
	      this.getDownstream().dirty();
	    }
	
	    function stubOnDirty() {
	      this.agent && this.agent.dirty();
	    }
	
	    function seriesTaskPlan(context) {
	      return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
	    }
	
	    function seriesTaskReset(context) {
	      if (context.useClearVisual) {
	        context.data.clearAllVisual();
	      }
	
	      var resetDefines = context.resetDefines = normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
	      return resetDefines.length > 1 ? map(resetDefines, function (v, idx) {
	        return makeSeriesTaskProgress(idx);
	      }) : singleSeriesTaskProgress;
	    }
	
	    var singleSeriesTaskProgress = makeSeriesTaskProgress(0);
	
	    function makeSeriesTaskProgress(resetDefineIdx) {
	      return function (params, context) {
	        var data = context.data;
	        var resetDefine = context.resetDefines[resetDefineIdx];
	
	        if (resetDefine && resetDefine.dataEach) {
	          for (var i = params.start; i < params.end; i++) {
	            resetDefine.dataEach(data, i);
	          }
	        } else if (resetDefine && resetDefine.progress) {
	          resetDefine.progress(params, data);
	        }
	      };
	    }
	
	    function seriesTaskCount(context) {
	      return context.data.count();
	    }
	    /**
	     * Only some legacy stage handlers (usually in echarts extensions) are pure function.
	     * To ensure that they can work normally, they should work in block mode, that is,
	     * they should not be started util the previous tasks finished. So they cause the
	     * progressive rendering disabled. We try to detect the series type, to narrow down
	     * the block range to only the series type they concern, but not all series.
	     */
	
	
	    function detectSeriseType(legacyFunc) {
	      seriesType = null;
	
	      try {
	        // Assume there is no async when calling `eachSeriesByType`.
	        legacyFunc(ecModelMock, apiMock);
	      } catch (e) {}
	
	      return seriesType;
	    }
	
	    var ecModelMock = {};
	    var apiMock = {};
	    var seriesType;
	    mockMethods(ecModelMock, GlobalModel);
	    mockMethods(apiMock, ExtensionAPI);
	
	    ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
	      seriesType = type;
	    };
	
	    ecModelMock.eachComponent = function (cond) {
	      if (cond.mainType === 'series' && cond.subType) {
	        seriesType = cond.subType;
	      }
	    };
	
	    function mockMethods(target, Clz) {
	      /* eslint-disable */
	      for (var name_1 in Clz.prototype) {
	        // Do not use hasOwnProperty
	        target[name_1] = noop;
	      }
	      /* eslint-enable */
	
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
	    var lightTheme = {
	      color: colorAll,
	      colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
	    };
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var contrastColor = '#B9B8CE';
	    var backgroundColor = '#100C2A';
	
	    var axisCommon = function () {
	      return {
	        axisLine: {
	          lineStyle: {
	            color: contrastColor
	          }
	        },
	        splitLine: {
	          lineStyle: {
	            color: '#484753'
	          }
	        },
	        splitArea: {
	          areaStyle: {
	            color: ['rgba(255,255,255,0.02)', 'rgba(255,255,255,0.05)']
	          }
	        },
	        minorSplitLine: {
	          lineStyle: {
	            color: '#20203B'
	          }
	        }
	      };
	    };
	
	    var colorPalette = ['#4992ff', '#7cffb2', '#fddd60', '#ff6e76', '#58d9f9', '#05c091', '#ff8a45', '#8d48e3', '#dd79ff'];
	    var theme = {
	      darkMode: true,
	      color: colorPalette,
	      backgroundColor: backgroundColor,
	      axisPointer: {
	        lineStyle: {
	          color: '#817f91'
	        },
	        crossStyle: {
	          color: '#817f91'
	        },
	        label: {
	          // TODO Contrast of label backgorundColor
	          color: '#fff'
	        }
	      },
	      legend: {
	        textStyle: {
	          color: contrastColor
	        }
	      },
	      textStyle: {
	        color: contrastColor
	      },
	      title: {
	        textStyle: {
	          color: '#EEF1FA'
	        },
	        subtextStyle: {
	          color: '#B9B8CE'
	        }
	      },
	      toolbox: {
	        iconStyle: {
	          borderColor: contrastColor
	        }
	      },
	      dataZoom: {
	        borderColor: '#71708A',
	        textStyle: {
	          color: contrastColor
	        },
	        brushStyle: {
	          color: 'rgba(135,163,206,0.3)'
	        },
	        handleStyle: {
	          color: '#353450',
	          borderColor: '#C5CBE3'
	        },
	        moveHandleStyle: {
	          color: '#B0B6C3',
	          opacity: 0.3
	        },
	        fillerColor: 'rgba(135,163,206,0.2)',
	        emphasis: {
	          handleStyle: {
	            borderColor: '#91B7F2',
	            color: '#4D587D'
	          },
	          moveHandleStyle: {
	            color: '#636D9A',
	            opacity: 0.7
	          }
	        },
	        dataBackground: {
	          lineStyle: {
	            color: '#71708A',
	            width: 1
	          },
	          areaStyle: {
	            color: '#71708A'
	          }
	        },
	        selectedDataBackground: {
	          lineStyle: {
	            color: '#87A3CE'
	          },
	          areaStyle: {
	            color: '#87A3CE'
	          }
	        }
	      },
	      visualMap: {
	        textStyle: {
	          color: contrastColor
	        }
	      },
	      timeline: {
	        lineStyle: {
	          color: contrastColor
	        },
	        label: {
	          color: contrastColor
	        },
	        controlStyle: {
	          color: contrastColor,
	          borderColor: contrastColor
	        }
	      },
	      calendar: {
	        itemStyle: {
	          color: backgroundColor
	        },
	        dayLabel: {
	          color: contrastColor
	        },
	        monthLabel: {
	          color: contrastColor
	        },
	        yearLabel: {
	          color: contrastColor
	        }
	      },
	      timeAxis: axisCommon(),
	      logAxis: axisCommon(),
	      valueAxis: axisCommon(),
	      categoryAxis: axisCommon(),
	      line: {
	        symbol: 'circle'
	      },
	      graph: {
	        color: colorPalette
	      },
	      gauge: {
	        title: {
	          color: contrastColor
	        },
	        axisLine: {
	          lineStyle: {
	            color: [[1, 'rgba(207,212,219,0.2)']]
	          }
	        },
	        axisLabel: {
	          color: contrastColor
	        },
	        detail: {
	          color: '#EEF1FA'
	        }
	      },
	      candlestick: {
	        itemStyle: {
	          color: '#f64e56',
	          color0: '#54ea92',
	          borderColor: '#f64e56',
	          borderColor0: '#54ea92' // borderColor: '#ca2824',
	          // borderColor0: '#09a443'
	
	        }
	      }
	    };
	    theme.categoryAxis.splitLine.show = false;
	
	    /**
	     * Usage of query:
	     * `chart.on('click', query, handler);`
	     * The `query` can be:
	     * + The component type query string, only `mainType` or `mainType.subType`,
	     *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
	     * + The component query object, like:
	     *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
	     *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
	     * + The data query object, like:
	     *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
	     * + The other query object (cmponent customized query), like:
	     *   `{element: 'some'}` (only available in custom series).
	     *
	     * Caveat: If a prop in the `query` object is `null/undefined`, it is the
	     * same as there is no such prop in the `query` object.
	     */
	
	    var ECEventProcessor =
	    /** @class */
	    function () {
	      function ECEventProcessor() {}
	
	      ECEventProcessor.prototype.normalizeQuery = function (query) {
	        var cptQuery = {};
	        var dataQuery = {};
	        var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
	
	        if (isString(query)) {
	          var condCptType = parseClassType(query); // `.main` and `.sub` may be ''.
	
	          cptQuery.mainType = condCptType.main || null;
	          cptQuery.subType = condCptType.sub || null;
	        } // `query` is an object, convert to {mainType, index, name, id}.
	        else {
	            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
	            // can not be used in `compomentModel.filterForExposedEvent`.
	            var suffixes_1 = ['Index', 'Name', 'Id'];
	            var dataKeys_1 = {
	              name: 1,
	              dataIndex: 1,
	              dataType: 1
	            };
	            each(query, function (val, key) {
	              var reserved = false;
	
	              for (var i = 0; i < suffixes_1.length; i++) {
	                var propSuffix = suffixes_1[i];
	                var suffixPos = key.lastIndexOf(propSuffix);
	
	                if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
	                  var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
	
	                  if (mainType !== 'data') {
	                    cptQuery.mainType = mainType;
	                    cptQuery[propSuffix.toLowerCase()] = val;
	                    reserved = true;
	                  }
	                }
	              }
	
	              if (dataKeys_1.hasOwnProperty(key)) {
	                dataQuery[key] = val;
	                reserved = true;
	              }
	
	              if (!reserved) {
	                otherQuery[key] = val;
	              }
	            });
	          }
	
	        return {
	          cptQuery: cptQuery,
	          dataQuery: dataQuery,
	          otherQuery: otherQuery
	        };
	      };
	
	      ECEventProcessor.prototype.filter = function (eventType, query) {
	        // They should be assigned before each trigger call.
	        var eventInfo = this.eventInfo;
	
	        if (!eventInfo) {
	          return true;
	        }
	
	        var targetEl = eventInfo.targetEl;
	        var packedEvent = eventInfo.packedEvent;
	        var model = eventInfo.model;
	        var view = eventInfo.view; // For event like 'globalout'.
	
	        if (!model || !view) {
	          return true;
	        }
	
	        var cptQuery = query.cptQuery;
	        var dataQuery = query.dataQuery;
	        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
	
	        function check(query, host, prop, propOnHost) {
	          return query[prop] == null || host[propOnHost || prop] === query[prop];
	        }
	      };
	
	      ECEventProcessor.prototype.afterTrigger = function () {
	        // Make sure the eventInfo won't be used in next trigger.
	        this.eventInfo = null;
	      };
	
	      return ECEventProcessor;
	    }();
	
	    var SYMBOL_PROPS_WITH_CB = ['symbol', 'symbolSize', 'symbolRotate', 'symbolOffset'];
	    var SYMBOL_PROPS = SYMBOL_PROPS_WITH_CB.concat(['symbolKeepAspect']); // Encoding visual for all series include which is filtered for legend drawing
	
	    var seriesSymbolTask = {
	      createOnAllSeries: true,
	      // For legend.
	      performRawSeries: true,
	      reset: function (seriesModel, ecModel) {
	        var data = seriesModel.getData();
	
	        if (seriesModel.legendIcon) {
	          data.setVisual('legendIcon', seriesModel.legendIcon);
	        }
	
	        if (!seriesModel.hasSymbolVisual) {
	          return;
	        }
	
	        var symbolOptions = {};
	        var symbolOptionsCb = {};
	        var hasCallback = false;
	
	        for (var i = 0; i < SYMBOL_PROPS_WITH_CB.length; i++) {
	          var symbolPropName = SYMBOL_PROPS_WITH_CB[i];
	          var val = seriesModel.get(symbolPropName);
	
	          if (isFunction(val)) {
	            hasCallback = true;
	            symbolOptionsCb[symbolPropName] = val;
	          } else {
	            symbolOptions[symbolPropName] = val;
	          }
	        }
	
	        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
	        data.setVisual(extend({
	          legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
	          symbolKeepAspect: seriesModel.get('symbolKeepAspect')
	        }, symbolOptions)); // Only visible series has each data be visual encoded
	
	        if (ecModel.isSeriesFiltered(seriesModel)) {
	          return;
	        }
	
	        var symbolPropsCb = keys(symbolOptionsCb);
	
	        function dataEach(data, idx) {
	          var rawValue = seriesModel.getRawValue(idx);
	          var params = seriesModel.getDataParams(idx);
	
	          for (var i = 0; i < symbolPropsCb.length; i++) {
	            var symbolPropName = symbolPropsCb[i];
	            data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
	          }
	        }
	
	        return {
	          dataEach: hasCallback ? dataEach : null
	        };
	      }
	    };
	    var dataSymbolTask = {
	      createOnAllSeries: true,
	      // For legend.
	      performRawSeries: true,
	      reset: function (seriesModel, ecModel) {
	        if (!seriesModel.hasSymbolVisual) {
	          return;
	        } // Only visible series has each data be visual encoded
	
	
	        if (ecModel.isSeriesFiltered(seriesModel)) {
	          return;
	        }
	
	        var data = seriesModel.getData();
	
	        function dataEach(data, idx) {
	          var itemModel = data.getItemModel(idx);
	
	          for (var i = 0; i < SYMBOL_PROPS.length; i++) {
	            var symbolPropName = SYMBOL_PROPS[i];
	            var val = itemModel.getShallow(symbolPropName, true);
	
	            if (val != null) {
	              data.setItemVisual(idx, symbolPropName, val);
	            }
	          }
	        }
	
	        return {
	          dataEach: data.hasItemOption ? dataEach : null
	        };
	      }
	    };
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function getItemVisualFromData(data, dataIndex, key) {
	      switch (key) {
	        case 'color':
	          var style = data.getItemVisual(dataIndex, 'style');
	          return style[data.getVisual('drawType')];
	
	        case 'opacity':
	          return data.getItemVisual(dataIndex, 'style').opacity;
	
	        case 'symbol':
	        case 'symbolSize':
	        case 'liftZ':
	          return data.getItemVisual(dataIndex, key);
	
	        default:
	          if (true) {
	            console.warn("Unknown visual type " + key);
	          }
	
	      }
	    }
	    function getVisualFromData(data, key) {
	      switch (key) {
	        case 'color':
	          var style = data.getVisual('style');
	          return style[data.getVisual('drawType')];
	
	        case 'opacity':
	          return data.getVisual('style').opacity;
	
	        case 'symbol':
	        case 'symbolSize':
	        case 'liftZ':
	          return data.getVisual(key);
	
	        default:
	          if (true) {
	            console.warn("Unknown visual type " + key);
	          }
	
	      }
	    }
	    function setItemVisualFromData(data, dataIndex, key, value) {
	      switch (key) {
	        case 'color':
	          // Make sure not sharing style object.
	          var style = data.ensureUniqueItemVisual(dataIndex, 'style');
	          style[data.getVisual('drawType')] = value; // Mark the color has been changed, not from palette anymore
	
	          data.setItemVisual(dataIndex, 'colorFromPalette', false);
	          break;
	
	        case 'opacity':
	          data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
	          break;
	
	        case 'symbol':
	        case 'symbolSize':
	        case 'liftZ':
	          data.setItemVisual(dataIndex, key, value);
	          break;
	
	        default:
	          if (true) {
	            console.warn("Unknown visual type " + key);
	          }
	
	      }
	    }
	
	    // Includes: pieSelect, pieUnSelect, pieToggleSelect, mapSelect, mapUnSelect, mapToggleSelect
	
	    function createLegacyDataSelectAction(seriesType, ecRegisterAction) {
	      function getSeriesIndices(ecModel, payload) {
	        var seriesIndices = [];
	        ecModel.eachComponent({
	          mainType: 'series',
	          subType: seriesType,
	          query: payload
	        }, function (seriesModel) {
	          seriesIndices.push(seriesModel.seriesIndex);
	        });
	        return seriesIndices;
	      }
	
	      each([[seriesType + 'ToggleSelect', 'toggleSelect'], [seriesType + 'Select', 'select'], [seriesType + 'UnSelect', 'unselect']], function (eventsMap) {
	        ecRegisterAction(eventsMap[0], function (payload, ecModel, api) {
	          payload = extend({}, payload);
	
	          if (true) {
	            deprecateReplaceLog(payload.type, eventsMap[1]);
	          }
	
	          api.dispatchAction(extend(payload, {
	            type: eventsMap[1],
	            seriesIndex: getSeriesIndices(ecModel, payload)
	          }));
	        });
	      });
	    }
	
	    function handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
	      var legacyEventName = type + eventPostfix;
	
	      if (!ecIns.isSilent(legacyEventName)) {
	        if (true) {
	          deprecateLog("event " + legacyEventName + " is deprecated.");
	        }
	
	        ecModel.eachComponent({
	          mainType: 'series',
	          subType: 'pie'
	        }, function (seriesModel) {
	          var seriesIndex = seriesModel.seriesIndex;
	          var selectedMap = seriesModel.option.selectedMap;
	          var selected = payload.selected;
	
	          for (var i = 0; i < selected.length; i++) {
	            if (selected[i].seriesIndex === seriesIndex) {
	              var data = seriesModel.getData();
	              var dataIndex = queryDataIndex(data, payload.fromActionPayload);
	              ecIns.trigger(legacyEventName, {
	                type: legacyEventName,
	                seriesId: seriesModel.id,
	                name: isArray(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
	                selected: isString(selectedMap) ? selectedMap : extend({}, selectedMap)
	              });
	            }
	          }
	        });
	      }
	    }
	
	    function handleLegacySelectEvents(messageCenter, ecIns, api) {
	      messageCenter.on('selectchanged', function (params) {
	        var ecModel = api.getModel();
	
	        if (params.isFromClick) {
	          handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
	          handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
	        } else if (params.fromAction === 'select') {
	          handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
	          handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
	        } else if (params.fromAction === 'unselect') {
	          handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
	          handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
	        }
	      });
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function findEventDispatcher(target, det, returnFirstMatch) {
	      var found;
	
	      while (target) {
	        if (det(target)) {
	          found = target;
	
	          if (returnFirstMatch) {
	            break;
	          }
	        }
	
	        target = target.__hostTarget || target.parent;
	      }
	
	      return found;
	    }
	
	    var wmUniqueIndex = Math.round(Math.random() * 9);
	    var supportDefineProperty = typeof Object.defineProperty === 'function';
	    var WeakMap = (function () {
	        function WeakMap() {
	            this._id = '__ec_inner_' + wmUniqueIndex++;
	        }
	        WeakMap.prototype.get = function (key) {
	            return this._guard(key)[this._id];
	        };
	        WeakMap.prototype.set = function (key, value) {
	            var target = this._guard(key);
	            if (supportDefineProperty) {
	                Object.defineProperty(target, this._id, {
	                    value: value,
	                    enumerable: false,
	                    configurable: true
	                });
	            }
	            else {
	                target[this._id] = value;
	            }
	            return this;
	        };
	        WeakMap.prototype["delete"] = function (key) {
	            if (this.has(key)) {
	                delete this._guard(key)[this._id];
	                return true;
	            }
	            return false;
	        };
	        WeakMap.prototype.has = function (key) {
	            return !!this._guard(key)[this._id];
	        };
	        WeakMap.prototype._guard = function (key) {
	            if (key !== Object(key)) {
	                throw TypeError('Value of WeakMap is not a non-null object.');
	            }
	            return key;
	        };
	        return WeakMap;
	    }());
	
	    /**
	     * Triangle shape
	     * @inner
	     */
	
	    var Triangle = Path.extend({
	      type: 'triangle',
	      shape: {
	        cx: 0,
	        cy: 0,
	        width: 0,
	        height: 0
	      },
	      buildPath: function (path, shape) {
	        var cx = shape.cx;
	        var cy = shape.cy;
	        var width = shape.width / 2;
	        var height = shape.height / 2;
	        path.moveTo(cx, cy - height);
	        path.lineTo(cx + width, cy + height);
	        path.lineTo(cx - width, cy + height);
	        path.closePath();
	      }
	    });
	    /**
	     * Diamond shape
	     * @inner
	     */
	
	    var Diamond = Path.extend({
	      type: 'diamond',
	      shape: {
	        cx: 0,
	        cy: 0,
	        width: 0,
	        height: 0
	      },
	      buildPath: function (path, shape) {
	        var cx = shape.cx;
	        var cy = shape.cy;
	        var width = shape.width / 2;
	        var height = shape.height / 2;
	        path.moveTo(cx, cy - height);
	        path.lineTo(cx + width, cy);
	        path.lineTo(cx, cy + height);
	        path.lineTo(cx - width, cy);
	        path.closePath();
	      }
	    });
	    /**
	     * Pin shape
	     * @inner
	     */
	
	    var Pin = Path.extend({
	      type: 'pin',
	      shape: {
	        // x, y on the cusp
	        x: 0,
	        y: 0,
	        width: 0,
	        height: 0
	      },
	      buildPath: function (path, shape) {
	        var x = shape.x;
	        var y = shape.y;
	        var w = shape.width / 5 * 3; // Height must be larger than width
	
	        var h = Math.max(w, shape.height);
	        var r = w / 2; // Dist on y with tangent point and circle center
	
	        var dy = r * r / (h - r);
	        var cy = y - h + r + dy;
	        var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
	
	        var dx = Math.cos(angle) * r;
	        var tanX = Math.sin(angle);
	        var tanY = Math.cos(angle);
	        var cpLen = r * 0.6;
	        var cpLen2 = r * 0.7;
	        path.moveTo(x - dx, cy + dy);
	        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
	        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
	        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
	        path.closePath();
	      }
	    });
	    /**
	     * Arrow shape
	     * @inner
	     */
	
	    var Arrow = Path.extend({
	      type: 'arrow',
	      shape: {
	        x: 0,
	        y: 0,
	        width: 0,
	        height: 0
	      },
	      buildPath: function (ctx, shape) {
	        var height = shape.height;
	        var width = shape.width;
	        var x = shape.x;
	        var y = shape.y;
	        var dx = width / 3 * 2;
	        ctx.moveTo(x, y);
	        ctx.lineTo(x + dx, y + height);
	        ctx.lineTo(x, y + height / 4 * 3);
	        ctx.lineTo(x - dx, y + height);
	        ctx.lineTo(x, y);
	        ctx.closePath();
	      }
	    });
	    /**
	     * Map of path constructors
	     */
	    // TODO Use function to build symbol path.
	
	    var symbolCtors = {
	      line: Line,
	      rect: Rect,
	      roundRect: Rect,
	      square: Rect,
	      circle: Circle,
	      diamond: Diamond,
	      pin: Pin,
	      arrow: Arrow,
	      triangle: Triangle
	    };
	    var symbolShapeMakers = {
	      line: function (x, y, w, h, shape) {
	        shape.x1 = x;
	        shape.y1 = y + h / 2;
	        shape.x2 = x + w;
	        shape.y2 = y + h / 2;
	      },
	      rect: function (x, y, w, h, shape) {
	        shape.x = x;
	        shape.y = y;
	        shape.width = w;
	        shape.height = h;
	      },
	      roundRect: function (x, y, w, h, shape) {
	        shape.x = x;
	        shape.y = y;
	        shape.width = w;
	        shape.height = h;
	        shape.r = Math.min(w, h) / 4;
	      },
	      square: function (x, y, w, h, shape) {
	        var size = Math.min(w, h);
	        shape.x = x;
	        shape.y = y;
	        shape.width = size;
	        shape.height = size;
	      },
	      circle: function (x, y, w, h, shape) {
	        // Put circle in the center of square
	        shape.cx = x + w / 2;
	        shape.cy = y + h / 2;
	        shape.r = Math.min(w, h) / 2;
	      },
	      diamond: function (x, y, w, h, shape) {
	        shape.cx = x + w / 2;
	        shape.cy = y + h / 2;
	        shape.width = w;
	        shape.height = h;
	      },
	      pin: function (x, y, w, h, shape) {
	        shape.x = x + w / 2;
	        shape.y = y + h / 2;
	        shape.width = w;
	        shape.height = h;
	      },
	      arrow: function (x, y, w, h, shape) {
	        shape.x = x + w / 2;
	        shape.y = y + h / 2;
	        shape.width = w;
	        shape.height = h;
	      },
	      triangle: function (x, y, w, h, shape) {
	        shape.cx = x + w / 2;
	        shape.cy = y + h / 2;
	        shape.width = w;
	        shape.height = h;
	      }
	    };
	    var symbolBuildProxies = {};
	    each(symbolCtors, function (Ctor, name) {
	      symbolBuildProxies[name] = new Ctor();
	    });
	    var SymbolClz = Path.extend({
	      type: 'symbol',
	      shape: {
	        symbolType: '',
	        x: 0,
	        y: 0,
	        width: 0,
	        height: 0
	      },
	      calculateTextPosition: function (out, config, rect) {
	        var res = calculateTextPosition(out, config, rect);
	        var shape = this.shape;
	
	        if (shape && shape.symbolType === 'pin' && config.position === 'inside') {
	          res.y = rect.y + rect.height * 0.4;
	        }
	
	        return res;
	      },
	      buildPath: function (ctx, shape, inBundle) {
	        var symbolType = shape.symbolType;
	
	        if (symbolType !== 'none') {
	          var proxySymbol = symbolBuildProxies[symbolType];
	
	          if (!proxySymbol) {
	            // Default rect
	            symbolType = 'rect';
	            proxySymbol = symbolBuildProxies[symbolType];
	          }
	
	          symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
	          proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
	        }
	      }
	    }); // Provide setColor helper method to avoid determine if set the fill or stroke outside
	
	    function symbolPathSetColor(color, innerColor) {
	      if (this.type !== 'image') {
	        var symbolStyle = this.style;
	
	        if (this.__isEmptyBrush) {
	          symbolStyle.stroke = color;
	          symbolStyle.fill = innerColor || '#fff'; // TODO Same width with lineStyle in LineView
	
	          symbolStyle.lineWidth = 2;
	        } else if (this.shape.symbolType === 'line') {
	          symbolStyle.stroke = color;
	        } else {
	          symbolStyle.fill = color;
	        }
	
	        this.markRedraw();
	      }
	    }
	    /**
	     * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	     */
	
	
	    function createSymbol(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
	    keepAspect) {
	      // TODO Support image object, DynamicImage.
	      var isEmpty = symbolType.indexOf('empty') === 0;
	
	      if (isEmpty) {
	        symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
	      }
	
	      var symbolPath;
	
	      if (symbolType.indexOf('image://') === 0) {
	        symbolPath = makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	      } else if (symbolType.indexOf('path://') === 0) {
	        symbolPath = makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	      } else {
	        symbolPath = new SymbolClz({
	          shape: {
	            symbolType: symbolType,
	            x: x,
	            y: y,
	            width: w,
	            height: h
	          }
	        });
	      }
	
	      symbolPath.__isEmptyBrush = isEmpty; // TODO Should deprecate setColor
	
	      symbolPath.setColor = symbolPathSetColor;
	
	      if (color) {
	        symbolPath.setColor(color);
	      }
	
	      return symbolPath;
	    }
	    function normalizeSymbolSize(symbolSize) {
	      if (!isArray(symbolSize)) {
	        symbolSize = [+symbolSize, +symbolSize];
	      }
	
	      return [symbolSize[0] || 0, symbolSize[1] || 0];
	    }
	    function normalizeSymbolOffset(symbolOffset, symbolSize) {
	      if (symbolOffset == null) {
	        return;
	      }
	
	      if (!isArray(symbolOffset)) {
	        symbolOffset = [symbolOffset, symbolOffset];
	      }
	
	      return [parsePercent$1(symbolOffset[0], symbolSize[0]) || 0, parsePercent$1(retrieve2(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0];
	    }
	
	    function isSafeNum(num) {
	        return isFinite(num);
	    }
	    function createLinearGradient(ctx, obj, rect) {
	        var x = obj.x == null ? 0 : obj.x;
	        var x2 = obj.x2 == null ? 1 : obj.x2;
	        var y = obj.y == null ? 0 : obj.y;
	        var y2 = obj.y2 == null ? 0 : obj.y2;
	        if (!obj.global) {
	            x = x * rect.width + rect.x;
	            x2 = x2 * rect.width + rect.x;
	            y = y * rect.height + rect.y;
	            y2 = y2 * rect.height + rect.y;
	        }
	        x = isSafeNum(x) ? x : 0;
	        x2 = isSafeNum(x2) ? x2 : 1;
	        y = isSafeNum(y) ? y : 0;
	        y2 = isSafeNum(y2) ? y2 : 0;
	        var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
	        return canvasGradient;
	    }
	    function createRadialGradient(ctx, obj, rect) {
	        var width = rect.width;
	        var height = rect.height;
	        var min = Math.min(width, height);
	        var x = obj.x == null ? 0.5 : obj.x;
	        var y = obj.y == null ? 0.5 : obj.y;
	        var r = obj.r == null ? 0.5 : obj.r;
	        if (!obj.global) {
	            x = x * width + rect.x;
	            y = y * height + rect.y;
	            r = r * min;
	        }
	        x = isSafeNum(x) ? x : 0.5;
	        y = isSafeNum(y) ? y : 0.5;
	        r = r >= 0 && isSafeNum(r) ? r : 0.5;
	        var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
	        return canvasGradient;
	    }
	    function getCanvasGradient(ctx, obj, rect) {
	        var canvasGradient = obj.type === 'radial'
	            ? createRadialGradient(ctx, obj, rect)
	            : createLinearGradient(ctx, obj, rect);
	        var colorStops = obj.colorStops;
	        for (var i = 0; i < colorStops.length; i++) {
	            canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
	        }
	        return canvasGradient;
	    }
	    function isClipPathChanged(clipPaths, prevClipPaths) {
	        if (clipPaths === prevClipPaths || (!clipPaths && !prevClipPaths)) {
	            return false;
	        }
	        if (!clipPaths || !prevClipPaths || (clipPaths.length !== prevClipPaths.length)) {
	            return true;
	        }
	        for (var i = 0; i < clipPaths.length; i++) {
	            if (clipPaths[i] !== prevClipPaths[i]) {
	                return true;
	            }
	        }
	        return false;
	    }
	    function parseInt10(val) {
	        return parseInt(val, 10);
	    }
	    function getSize(root, whIdx, opts) {
	        var wh = ['width', 'height'][whIdx];
	        var cwh = ['clientWidth', 'clientHeight'][whIdx];
	        var plt = ['paddingLeft', 'paddingTop'][whIdx];
	        var prb = ['paddingRight', 'paddingBottom'][whIdx];
	        if (opts[wh] != null && opts[wh] !== 'auto') {
	            return parseFloat(opts[wh]);
	        }
	        var stl = document.defaultView.getComputedStyle(root);
	        return ((root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh]))
	            - (parseInt10(stl[plt]) || 0)
	            - (parseInt10(stl[prb]) || 0)) | 0;
	    }
	
	    function normalizeLineDash(lineType, lineWidth) {
	        if (!lineType || lineType === 'solid' || !(lineWidth > 0)) {
	            return null;
	        }
	        return lineType === 'dashed'
	            ? [4 * lineWidth, 2 * lineWidth]
	            : lineType === 'dotted'
	                ? [lineWidth]
	                : isNumber(lineType)
	                    ? [lineType] : isArray(lineType) ? lineType : null;
	    }
	    function getLineDash(el) {
	        var style = el.style;
	        var lineDash = style.lineDash && style.lineWidth > 0 && normalizeLineDash(style.lineDash, style.lineWidth);
	        var lineDashOffset = style.lineDashOffset;
	        if (lineDash) {
	            var lineScale_1 = (style.strokeNoScale && el.getLineScale) ? el.getLineScale() : 1;
	            if (lineScale_1 && lineScale_1 !== 1) {
	                lineDash = map(lineDash, function (rawVal) {
	                    return rawVal / lineScale_1;
	                });
	                lineDashOffset /= lineScale_1;
	            }
	        }
	        return [lineDash, lineDashOffset];
	    }
	
	    var pathProxyForDraw = new PathProxy(true);
	    function styleHasStroke(style) {
	        var stroke = style.stroke;
	        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
	    }
	    function isValidStrokeFillStyle(strokeOrFill) {
	        return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
	    }
	    function styleHasFill(style) {
	        var fill = style.fill;
	        return fill != null && fill !== 'none';
	    }
	    function doFillPath(ctx, style) {
	        if (style.fillOpacity != null && style.fillOpacity !== 1) {
	            var originalGlobalAlpha = ctx.globalAlpha;
	            ctx.globalAlpha = style.fillOpacity * style.opacity;
	            ctx.fill();
	            ctx.globalAlpha = originalGlobalAlpha;
	        }
	        else {
	            ctx.fill();
	        }
	    }
	    function doStrokePath(ctx, style) {
	        if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
	            var originalGlobalAlpha = ctx.globalAlpha;
	            ctx.globalAlpha = style.strokeOpacity * style.opacity;
	            ctx.stroke();
	            ctx.globalAlpha = originalGlobalAlpha;
	        }
	        else {
	            ctx.stroke();
	        }
	    }
	    function createCanvasPattern(ctx, pattern, el) {
	        var image = createOrUpdateImage(pattern.image, pattern.__image, el);
	        if (isImageReady(image)) {
	            var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
	            if (typeof DOMMatrix === 'function'
	                && canvasPattern
	                && canvasPattern.setTransform) {
	                var matrix = new DOMMatrix();
	                matrix.translateSelf((pattern.x || 0), (pattern.y || 0));
	                matrix.rotateSelf(0, 0, (pattern.rotation || 0) * RADIAN_TO_DEGREE);
	                matrix.scaleSelf((pattern.scaleX || 1), (pattern.scaleY || 1));
	                canvasPattern.setTransform(matrix);
	            }
	            return canvasPattern;
	        }
	    }
	    function brushPath(ctx, el, style, inBatch) {
	        var _a;
	        var hasStroke = styleHasStroke(style);
	        var hasFill = styleHasFill(style);
	        var strokePercent = style.strokePercent;
	        var strokePart = strokePercent < 1;
	        var firstDraw = !el.path;
	        if ((!el.silent || strokePart) && firstDraw) {
	            el.createPathProxy();
	        }
	        var path = el.path || pathProxyForDraw;
	        var dirtyFlag = el.__dirty;
	        if (!inBatch) {
	            var fill = style.fill;
	            var stroke = style.stroke;
	            var hasFillGradient = hasFill && !!fill.colorStops;
	            var hasStrokeGradient = hasStroke && !!stroke.colorStops;
	            var hasFillPattern = hasFill && !!fill.image;
	            var hasStrokePattern = hasStroke && !!stroke.image;
	            var fillGradient = void 0;
	            var strokeGradient = void 0;
	            var fillPattern = void 0;
	            var strokePattern = void 0;
	            var rect = void 0;
	            if (hasFillGradient || hasStrokeGradient) {
	                rect = el.getBoundingRect();
	            }
	            if (hasFillGradient) {
	                fillGradient = dirtyFlag
	                    ? getCanvasGradient(ctx, fill, rect)
	                    : el.__canvasFillGradient;
	                el.__canvasFillGradient = fillGradient;
	            }
	            if (hasStrokeGradient) {
	                strokeGradient = dirtyFlag
	                    ? getCanvasGradient(ctx, stroke, rect)
	                    : el.__canvasStrokeGradient;
	                el.__canvasStrokeGradient = strokeGradient;
	            }
	            if (hasFillPattern) {
	                fillPattern = (dirtyFlag || !el.__canvasFillPattern)
	                    ? createCanvasPattern(ctx, fill, el)
	                    : el.__canvasFillPattern;
	                el.__canvasFillPattern = fillPattern;
	            }
	            if (hasStrokePattern) {
	                strokePattern = (dirtyFlag || !el.__canvasStrokePattern)
	                    ? createCanvasPattern(ctx, stroke, el)
	                    : el.__canvasStrokePattern;
	                el.__canvasStrokePattern = fillPattern;
	            }
	            if (hasFillGradient) {
	                ctx.fillStyle = fillGradient;
	            }
	            else if (hasFillPattern) {
	                if (fillPattern) {
	                    ctx.fillStyle = fillPattern;
	                }
	                else {
	                    hasFill = false;
	                }
	            }
	            if (hasStrokeGradient) {
	                ctx.strokeStyle = strokeGradient;
	            }
	            else if (hasStrokePattern) {
	                if (strokePattern) {
	                    ctx.strokeStyle = strokePattern;
	                }
	                else {
	                    hasStroke = false;
	                }
	            }
	        }
	        var scale = el.getGlobalScale();
	        path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
	        var lineDash;
	        var lineDashOffset;
	        if (ctx.setLineDash && style.lineDash) {
	            _a = getLineDash(el), lineDash = _a[0], lineDashOffset = _a[1];
	        }
	        var needsRebuild = true;
	        if (firstDraw || (dirtyFlag & SHAPE_CHANGED_BIT)) {
	            path.setDPR(ctx.dpr);
	            if (strokePart) {
	                path.setContext(null);
	            }
	            else {
	                path.setContext(ctx);
	                needsRebuild = false;
	            }
	            path.reset();
	            el.buildPath(path, el.shape, inBatch);
	            path.toStatic();
	            el.pathUpdated();
	        }
	        if (needsRebuild) {
	            path.rebuildPath(ctx, strokePart ? strokePercent : 1);
	        }
	        if (lineDash) {
	            ctx.setLineDash(lineDash);
	            ctx.lineDashOffset = lineDashOffset;
	        }
	        if (!inBatch) {
	            if (style.strokeFirst) {
	                if (hasStroke) {
	                    doStrokePath(ctx, style);
	                }
	                if (hasFill) {
	                    doFillPath(ctx, style);
	                }
	            }
	            else {
	                if (hasFill) {
	                    doFillPath(ctx, style);
	                }
	                if (hasStroke) {
	                    doStrokePath(ctx, style);
	                }
	            }
	        }
	        if (lineDash) {
	            ctx.setLineDash([]);
	        }
	    }
	    function brushImage(ctx, el, style) {
	        var image = el.__image = createOrUpdateImage(style.image, el.__image, el, el.onload);
	        if (!image || !isImageReady(image)) {
	            return;
	        }
	        var x = style.x || 0;
	        var y = style.y || 0;
	        var width = el.getWidth();
	        var height = el.getHeight();
	        var aspect = image.width / image.height;
	        if (width == null && height != null) {
	            width = height * aspect;
	        }
	        else if (height == null && width != null) {
	            height = width / aspect;
	        }
	        else if (width == null && height == null) {
	            width = image.width;
	            height = image.height;
	        }
	        if (style.sWidth && style.sHeight) {
	            var sx = style.sx || 0;
	            var sy = style.sy || 0;
	            ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
	        }
	        else if (style.sx && style.sy) {
	            var sx = style.sx;
	            var sy = style.sy;
	            var sWidth = width - sx;
	            var sHeight = height - sy;
	            ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
	        }
	        else {
	            ctx.drawImage(image, x, y, width, height);
	        }
	    }
	    function brushText(ctx, el, style) {
	        var _a;
	        var text = style.text;
	        text != null && (text += '');
	        if (text) {
	            ctx.font = style.font || DEFAULT_FONT;
	            ctx.textAlign = style.textAlign;
	            ctx.textBaseline = style.textBaseline;
	            var lineDash = void 0;
	            var lineDashOffset = void 0;
	            if (ctx.setLineDash && style.lineDash) {
	                _a = getLineDash(el), lineDash = _a[0], lineDashOffset = _a[1];
	            }
	            if (lineDash) {
	                ctx.setLineDash(lineDash);
	                ctx.lineDashOffset = lineDashOffset;
	            }
	            if (style.strokeFirst) {
	                if (styleHasStroke(style)) {
	                    ctx.strokeText(text, style.x, style.y);
	                }
	                if (styleHasFill(style)) {
	                    ctx.fillText(text, style.x, style.y);
	                }
	            }
	            else {
	                if (styleHasFill(style)) {
	                    ctx.fillText(text, style.x, style.y);
	                }
	                if (styleHasStroke(style)) {
	                    ctx.strokeText(text, style.x, style.y);
	                }
	            }
	            if (lineDash) {
	                ctx.setLineDash([]);
	            }
	        }
	    }
	    var SHADOW_NUMBER_PROPS = ['shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
	    var STROKE_PROPS = [
	        ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]
	    ];
	    function bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
	        var styleChanged = false;
	        if (!forceSetAll) {
	            prevStyle = prevStyle || {};
	            if (style === prevStyle) {
	                return false;
	            }
	        }
	        if (forceSetAll || style.opacity !== prevStyle.opacity) {
	            flushPathDrawn(ctx, scope);
	            styleChanged = true;
	            var opacity = Math.max(Math.min(style.opacity, 1), 0);
	            ctx.globalAlpha = isNaN(opacity) ? DEFAULT_COMMON_STYLE.opacity : opacity;
	        }
	        if (forceSetAll || style.blend !== prevStyle.blend) {
	            if (!styleChanged) {
	                flushPathDrawn(ctx, scope);
	                styleChanged = true;
	            }
	            ctx.globalCompositeOperation = style.blend || DEFAULT_COMMON_STYLE.blend;
	        }
	        for (var i = 0; i < SHADOW_NUMBER_PROPS.length; i++) {
	            var propName = SHADOW_NUMBER_PROPS[i];
	            if (forceSetAll || style[propName] !== prevStyle[propName]) {
	                if (!styleChanged) {
	                    flushPathDrawn(ctx, scope);
	                    styleChanged = true;
	                }
	                ctx[propName] = ctx.dpr * (style[propName] || 0);
	            }
	        }
	        if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
	            if (!styleChanged) {
	                flushPathDrawn(ctx, scope);
	                styleChanged = true;
	            }
	            ctx.shadowColor = style.shadowColor || DEFAULT_COMMON_STYLE.shadowColor;
	        }
	        return styleChanged;
	    }
	    function bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
	        var style = getStyle(el, scope.inHover);
	        var prevStyle = forceSetAll
	            ? null
	            : (prevEl && getStyle(prevEl, scope.inHover) || {});
	        if (style === prevStyle) {
	            return false;
	        }
	        var styleChanged = bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
	        if (forceSetAll || style.fill !== prevStyle.fill) {
	            if (!styleChanged) {
	                flushPathDrawn(ctx, scope);
	                styleChanged = true;
	            }
	            isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
	        }
	        if (forceSetAll || style.stroke !== prevStyle.stroke) {
	            if (!styleChanged) {
	                flushPathDrawn(ctx, scope);
	                styleChanged = true;
	            }
	            isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
	        }
	        if (forceSetAll || style.opacity !== prevStyle.opacity) {
	            if (!styleChanged) {
	                flushPathDrawn(ctx, scope);
	                styleChanged = true;
	            }
	            ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
	        }
	        if (el.hasStroke()) {
	            var lineWidth = style.lineWidth;
	            var newLineWidth = lineWidth / ((style.strokeNoScale && el.getLineScale) ? el.getLineScale() : 1);
	            if (ctx.lineWidth !== newLineWidth) {
	                if (!styleChanged) {
	                    flushPathDrawn(ctx, scope);
	                    styleChanged = true;
	                }
	                ctx.lineWidth = newLineWidth;
	            }
	        }
	        for (var i = 0; i < STROKE_PROPS.length; i++) {
	            var prop = STROKE_PROPS[i];
	            var propName = prop[0];
	            if (forceSetAll || style[propName] !== prevStyle[propName]) {
	                if (!styleChanged) {
	                    flushPathDrawn(ctx, scope);
	                    styleChanged = true;
	                }
	                ctx[propName] = style[propName] || prop[1];
	            }
	        }
	        return styleChanged;
	    }
	    function bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
	        return bindCommonProps(ctx, getStyle(el, scope.inHover), prevEl && getStyle(prevEl, scope.inHover), forceSetAll, scope);
	    }
	    function setContextTransform(ctx, el) {
	        var m = el.transform;
	        var dpr = ctx.dpr || 1;
	        if (m) {
	            ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
	        }
	        else {
	            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	        }
	    }
	    function updateClipStatus(clipPaths, ctx, scope) {
	        var allClipped = false;
	        for (var i = 0; i < clipPaths.length; i++) {
	            var clipPath = clipPaths[i];
	            allClipped = allClipped || clipPath.isZeroArea();
	            setContextTransform(ctx, clipPath);
	            ctx.beginPath();
	            clipPath.buildPath(ctx, clipPath.shape);
	            ctx.clip();
	        }
	        scope.allClipped = allClipped;
	    }
	    function isTransformChanged(m0, m1) {
	        if (m0 && m1) {
	            return m0[0] !== m1[0]
	                || m0[1] !== m1[1]
	                || m0[2] !== m1[2]
	                || m0[3] !== m1[3]
	                || m0[4] !== m1[4]
	                || m0[5] !== m1[5];
	        }
	        else if (!m0 && !m1) {
	            return false;
	        }
	        return true;
	    }
	    var DRAW_TYPE_PATH = 1;
	    var DRAW_TYPE_IMAGE = 2;
	    var DRAW_TYPE_TEXT = 3;
	    var DRAW_TYPE_INCREMENTAL = 4;
	    function canPathBatch(style) {
	        var hasFill = styleHasFill(style);
	        var hasStroke = styleHasStroke(style);
	        return !(style.lineDash
	            || !(+hasFill ^ +hasStroke)
	            || (hasFill && typeof style.fill !== 'string')
	            || (hasStroke && typeof style.stroke !== 'string')
	            || style.strokePercent < 1
	            || style.strokeOpacity < 1
	            || style.fillOpacity < 1);
	    }
	    function flushPathDrawn(ctx, scope) {
	        scope.batchFill && ctx.fill();
	        scope.batchStroke && ctx.stroke();
	        scope.batchFill = '';
	        scope.batchStroke = '';
	    }
	    function getStyle(el, inHover) {
	        return inHover ? (el.__hoverStyle || el.style) : el.style;
	    }
	    function brushSingle(ctx, el) {
	        brush(ctx, el, { inHover: false, viewWidth: 0, viewHeight: 0 }, true);
	    }
	    function brush(ctx, el, scope, isLast) {
	        var m = el.transform;
	        if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
	            el.__dirty &= ~REDRAW_BIT;
	            el.__isRendered = false;
	            return;
	        }
	        var clipPaths = el.__clipPaths;
	        var prevElClipPaths = scope.prevElClipPaths;
	        var forceSetTransform = false;
	        var forceSetStyle = false;
	        if (!prevElClipPaths || isClipPathChanged(clipPaths, prevElClipPaths)) {
	            if (prevElClipPaths && prevElClipPaths.length) {
	                flushPathDrawn(ctx, scope);
	                ctx.restore();
	                forceSetStyle = forceSetTransform = true;
	                scope.prevElClipPaths = null;
	                scope.allClipped = false;
	                scope.prevEl = null;
	            }
	            if (clipPaths && clipPaths.length) {
	                flushPathDrawn(ctx, scope);
	                ctx.save();
	                updateClipStatus(clipPaths, ctx, scope);
	                forceSetTransform = true;
	            }
	            scope.prevElClipPaths = clipPaths;
	        }
	        if (scope.allClipped) {
	            el.__isRendered = false;
	            return;
	        }
	        el.beforeBrush && el.beforeBrush();
	        el.innerBeforeBrush();
	        var prevEl = scope.prevEl;
	        if (!prevEl) {
	            forceSetStyle = forceSetTransform = true;
	        }
	        var canBatchPath = el instanceof Path
	            && el.autoBatch
	            && canPathBatch(el.style);
	        if (forceSetTransform || isTransformChanged(m, prevEl.transform)) {
	            flushPathDrawn(ctx, scope);
	            setContextTransform(ctx, el);
	        }
	        else if (!canBatchPath) {
	            flushPathDrawn(ctx, scope);
	        }
	        var style = getStyle(el, scope.inHover);
	        if (el instanceof Path) {
	            if (scope.lastDrawType !== DRAW_TYPE_PATH) {
	                forceSetStyle = true;
	                scope.lastDrawType = DRAW_TYPE_PATH;
	            }
	            bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
	            if (!canBatchPath || (!scope.batchFill && !scope.batchStroke)) {
	                ctx.beginPath();
	            }
	            brushPath(ctx, el, style, canBatchPath);
	            if (canBatchPath) {
	                scope.batchFill = style.fill || '';
	                scope.batchStroke = style.stroke || '';
	            }
	        }
	        else {
	            if (el instanceof TSpan) {
	                if (scope.lastDrawType !== DRAW_TYPE_TEXT) {
	                    forceSetStyle = true;
	                    scope.lastDrawType = DRAW_TYPE_TEXT;
	                }
	                bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
	                brushText(ctx, el, style);
	            }
	            else if (el instanceof ZRImage) {
	                if (scope.lastDrawType !== DRAW_TYPE_IMAGE) {
	                    forceSetStyle = true;
	                    scope.lastDrawType = DRAW_TYPE_IMAGE;
	                }
	                bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
	                brushImage(ctx, el, style);
	            }
	            else if (el.getTemporalDisplayables) {
	                if (scope.lastDrawType !== DRAW_TYPE_INCREMENTAL) {
	                    forceSetStyle = true;
	                    scope.lastDrawType = DRAW_TYPE_INCREMENTAL;
	                }
	                brushIncremental(ctx, el, scope);
	            }
	        }
	        if (canBatchPath && isLast) {
	            flushPathDrawn(ctx, scope);
	        }
	        el.innerAfterBrush();
	        el.afterBrush && el.afterBrush();
	        scope.prevEl = el;
	        el.__dirty = 0;
	        el.__isRendered = true;
	    }
	    function brushIncremental(ctx, el, scope) {
	        var displayables = el.getDisplayables();
	        var temporalDisplayables = el.getTemporalDisplayables();
	        ctx.save();
	        var innerScope = {
	            prevElClipPaths: null,
	            prevEl: null,
	            allClipped: false,
	            viewWidth: scope.viewWidth,
	            viewHeight: scope.viewHeight,
	            inHover: scope.inHover
	        };
	        var i;
	        var len;
	        for (i = el.getCursor(), len = displayables.length; i < len; i++) {
	            var displayable = displayables[i];
	            displayable.beforeBrush && displayable.beforeBrush();
	            displayable.innerBeforeBrush();
	            brush(ctx, displayable, innerScope, i === len - 1);
	            displayable.innerAfterBrush();
	            displayable.afterBrush && displayable.afterBrush();
	            innerScope.prevEl = displayable;
	        }
	        for (var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++) {
	            var displayable = temporalDisplayables[i_1];
	            displayable.beforeBrush && displayable.beforeBrush();
	            displayable.innerBeforeBrush();
	            brush(ctx, displayable, innerScope, i_1 === len_1 - 1);
	            displayable.innerAfterBrush();
	            displayable.afterBrush && displayable.afterBrush();
	            innerScope.prevEl = displayable;
	        }
	        el.clearTemporalDisplayables();
	        el.notClear = true;
	        ctx.restore();
	    }
	
	    var decalMap = new WeakMap();
	    var decalCache = new LRU(100);
	    var decalKeys = ['symbol', 'symbolSize', 'symbolKeepAspect', 'color', 'backgroundColor', 'dashArrayX', 'dashArrayY', 'maxTileWidth', 'maxTileHeight'];
	    /**
	     * Create or update pattern image from decal options
	     *
	     * @param {InnerDecalObject | 'none'} decalObject decal options, 'none' if no decal
	     * @return {Pattern} pattern with generated image, null if no decal
	     */
	
	    function createOrUpdatePatternFromDecal(decalObject, api) {
	      if (decalObject === 'none') {
	        return null;
	      }
	
	      var dpr = api.getDevicePixelRatio();
	      var zr = api.getZr();
	      var isSVG = zr.painter.type === 'svg';
	
	      if (decalObject.dirty) {
	        decalMap["delete"](decalObject);
	      }
	
	      var oldPattern = decalMap.get(decalObject);
	
	      if (oldPattern) {
	        return oldPattern;
	      }
	
	      var decalOpt = defaults(decalObject, {
	        symbol: 'rect',
	        symbolSize: 1,
	        symbolKeepAspect: true,
	        color: 'rgba(0, 0, 0, 0.2)',
	        backgroundColor: null,
	        dashArrayX: 5,
	        dashArrayY: 5,
	        rotation: 0,
	        maxTileWidth: 512,
	        maxTileHeight: 512
	      });
	
	      if (decalOpt.backgroundColor === 'none') {
	        decalOpt.backgroundColor = null;
	      }
	
	      var pattern = {
	        repeat: 'repeat'
	      };
	      setPatternnSource(pattern);
	      pattern.rotation = decalOpt.rotation;
	      pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
	      decalMap.set(decalObject, pattern);
	      decalObject.dirty = false;
	      return pattern;
	
	      function setPatternnSource(pattern) {
	        var keys = [dpr];
	        var isValidKey = true;
	
	        for (var i = 0; i < decalKeys.length; ++i) {
	          var value = decalOpt[decalKeys[i]];
	
	          if (value != null && !isArray(value) && !isString(value) && !isNumber(value) && typeof value !== 'boolean') {
	            isValidKey = false;
	            break;
	          }
	
	          keys.push(value);
	        }
	
	        var cacheKey;
	
	        if (isValidKey) {
	          cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
	          var cache = decalCache.get(cacheKey);
	
	          if (cache) {
	            isSVG ? pattern.svgElement = cache : pattern.image = cache;
	          }
	        }
	
	        var dashArrayX = normalizeDashArrayX(decalOpt.dashArrayX);
	        var dashArrayY = normalizeDashArrayY(decalOpt.dashArrayY);
	        var symbolArray = normalizeSymbolArray(decalOpt.symbol);
	        var lineBlockLengthsX = getLineBlockLengthX(dashArrayX);
	        var lineBlockLengthY = getLineBlockLengthY(dashArrayY);
	        var canvas = !isSVG && platformApi.createCanvas();
	        var svgRoot = isSVG && {
	          tag: 'g',
	          attrs: {},
	          key: 'dcl',
	          children: []
	        };
	        var pSize = getPatternSize();
	        var ctx;
	
	        if (canvas) {
	          canvas.width = pSize.width * dpr;
	          canvas.height = pSize.height * dpr;
	          ctx = canvas.getContext('2d');
	        }
	
	        brushDecal();
	
	        if (isValidKey) {
	          decalCache.put(cacheKey, canvas || svgRoot);
	        }
	
	        pattern.image = canvas;
	        pattern.svgElement = svgRoot;
	        pattern.svgWidth = pSize.width;
	        pattern.svgHeight = pSize.height;
	        /**
	         * Get minimum length that can make a repeatable pattern.
	         *
	         * @return {Object} pattern width and height
	         */
	
	        function getPatternSize() {
	          /**
	           * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
	           * |---  ---  ---  ---  --- ...
	           * |-- -- -- -- -- -- -- -- ...
	           * |---  ---  ---  ---  --- ...
	           * |-- -- -- -- -- -- -- -- ...
	           * So the minimum length of X is 15,
	           * which is the least common multiple of `3 + 2` and `2 + 1`
	           * |---  ---  ---  |---  --- ...
	           * |-- -- -- -- -- |-- -- -- ...
	           */
	          var width = 1;
	
	          for (var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i) {
	            width = getLeastCommonMultiple(width, lineBlockLengthsX[i]);
	          }
	
	          var symbolRepeats = 1;
	
	          for (var i = 0, xlen = symbolArray.length; i < xlen; ++i) {
	            symbolRepeats = getLeastCommonMultiple(symbolRepeats, symbolArray[i].length);
	          }
	
	          width *= symbolRepeats;
	          var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
	
	          if (true) {
	            var warn = function (attrName) {
	              /* eslint-disable-next-line */
	              console.warn("Calculated decal size is greater than " + attrName + " due to decal option settings so " + attrName + " is used for the decal size. Please consider changing the decal option to make a smaller decal or set " + attrName + " to be larger to avoid incontinuity.");
	            };
	
	            if (width > decalOpt.maxTileWidth) {
	              warn('maxTileWidth');
	            }
	
	            if (height > decalOpt.maxTileHeight) {
	              warn('maxTileHeight');
	            }
	          }
	
	          return {
	            width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
	            height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
	          };
	        }
	
	        function brushDecal() {
	          if (ctx) {
	            ctx.clearRect(0, 0, canvas.width, canvas.height);
	
	            if (decalOpt.backgroundColor) {
	              ctx.fillStyle = decalOpt.backgroundColor;
	              ctx.fillRect(0, 0, canvas.width, canvas.height);
	            }
	          }
	
	          var ySum = 0;
	
	          for (var i = 0; i < dashArrayY.length; ++i) {
	            ySum += dashArrayY[i];
	          }
	
	          if (ySum <= 0) {
	            // dashArrayY is 0, draw nothing
	            return;
	          }
	
	          var y = -lineBlockLengthY;
	          var yId = 0;
	          var yIdTotal = 0;
	          var xId0 = 0;
	
	          while (y < pSize.height) {
	            if (yId % 2 === 0) {
	              var symbolYId = yIdTotal / 2 % symbolArray.length;
	              var x = 0;
	              var xId1 = 0;
	              var xId1Total = 0;
	
	              while (x < pSize.width * 2) {
	                var xSum = 0;
	
	                for (var i = 0; i < dashArrayX[xId0].length; ++i) {
	                  xSum += dashArrayX[xId0][i];
	                }
	
	                if (xSum <= 0) {
	                  // Skip empty line
	                  break;
	                } // E.g., [15, 5, 20, 5] draws only for 15 and 20
	
	
	                if (xId1 % 2 === 0) {
	                  var size = (1 - decalOpt.symbolSize) * 0.5;
	                  var left = x + dashArrayX[xId0][xId1] * size;
	                  var top_1 = y + dashArrayY[yId] * size;
	                  var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
	                  var height = dashArrayY[yId] * decalOpt.symbolSize;
	                  var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
	                  brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
	                }
	
	                x += dashArrayX[xId0][xId1];
	                ++xId1Total;
	                ++xId1;
	
	                if (xId1 === dashArrayX[xId0].length) {
	                  xId1 = 0;
	                }
	              }
	
	              ++xId0;
	
	              if (xId0 === dashArrayX.length) {
	                xId0 = 0;
	              }
	            }
	
	            y += dashArrayY[yId];
	            ++yIdTotal;
	            ++yId;
	
	            if (yId === dashArrayY.length) {
	              yId = 0;
	            }
	          }
	
	          function brushSymbol(x, y, width, height, symbolType) {
	            var scale = isSVG ? 1 : dpr;
	            var symbol = createSymbol(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
	
	            if (isSVG) {
	              var symbolVNode = zr.painter.renderOneToVNode(symbol);
	
	              if (symbolVNode) {
	                svgRoot.children.push(symbolVNode);
	              }
	            } else {
	              // Paint to canvas for all other renderers.
	              brushSingle(ctx, symbol);
	            }
	          }
	        }
	      }
	    }
	    /**
	     * Convert symbol array into normalized array
	     *
	     * @param {string | (string | string[])[]} symbol symbol input
	     * @return {string[][]} normolized symbol array
	     */
	
	    function normalizeSymbolArray(symbol) {
	      if (!symbol || symbol.length === 0) {
	        return [['rect']];
	      }
	
	      if (isString(symbol)) {
	        return [[symbol]];
	      }
	
	      var isAllString = true;
	
	      for (var i = 0; i < symbol.length; ++i) {
	        if (!isString(symbol[i])) {
	          isAllString = false;
	          break;
	        }
	      }
	
	      if (isAllString) {
	        return normalizeSymbolArray([symbol]);
	      }
	
	      var result = [];
	
	      for (var i = 0; i < symbol.length; ++i) {
	        if (isString(symbol[i])) {
	          result.push([symbol[i]]);
	        } else {
	          result.push(symbol[i]);
	        }
	      }
	
	      return result;
	    }
	    /**
	     * Convert dash input into dashArray
	     *
	     * @param {DecalDashArrayX} dash dash input
	     * @return {number[][]} normolized dash array
	     */
	
	
	    function normalizeDashArrayX(dash) {
	      if (!dash || dash.length === 0) {
	        return [[0, 0]];
	      }
	
	      if (isNumber(dash)) {
	        var dashValue = Math.ceil(dash);
	        return [[dashValue, dashValue]];
	      }
	      /**
	       * [20, 5] should be normalized into [[20, 5]],
	       * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
	       */
	
	
	      var isAllNumber = true;
	
	      for (var i = 0; i < dash.length; ++i) {
	        if (!isNumber(dash[i])) {
	          isAllNumber = false;
	          break;
	        }
	      }
	
	      if (isAllNumber) {
	        return normalizeDashArrayX([dash]);
	      }
	
	      var result = [];
	
	      for (var i = 0; i < dash.length; ++i) {
	        if (isNumber(dash[i])) {
	          var dashValue = Math.ceil(dash[i]);
	          result.push([dashValue, dashValue]);
	        } else {
	          var dashValue = map(dash[i], function (n) {
	            return Math.ceil(n);
	          });
	
	          if (dashValue.length % 2 === 1) {
	            // [4, 2, 1] means |----  -    -- |----  -    -- |
	            // so normalize it to be [4, 2, 1, 4, 2, 1]
	            result.push(dashValue.concat(dashValue));
	          } else {
	            result.push(dashValue);
	          }
	        }
	      }
	
	      return result;
	    }
	    /**
	     * Convert dash input into dashArray
	     *
	     * @param {DecalDashArrayY} dash dash input
	     * @return {number[]} normolized dash array
	     */
	
	
	    function normalizeDashArrayY(dash) {
	      if (!dash || typeof dash === 'object' && dash.length === 0) {
	        return [0, 0];
	      }
	
	      if (isNumber(dash)) {
	        var dashValue_1 = Math.ceil(dash);
	        return [dashValue_1, dashValue_1];
	      }
	
	      var dashValue = map(dash, function (n) {
	        return Math.ceil(n);
	      });
	      return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
	    }
	    /**
	     * Get block length of each line. A block is the length of dash line and space.
	     * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
	     * that, so the block length of this line is 5.
	     *
	     * @param {number[][]} dash dash array of X or Y
	     * @return {number[]} block length of each line
	     */
	
	
	    function getLineBlockLengthX(dash) {
	      return map(dash, function (line) {
	        return getLineBlockLengthY(line);
	      });
	    }
	
	    function getLineBlockLengthY(dash) {
	      var blockLength = 0;
	
	      for (var i = 0; i < dash.length; ++i) {
	        blockLength += dash[i];
	      }
	
	      if (dash.length % 2 === 1) {
	        // [4, 2, 1] means |----  -    -- |----  -    -- |
	        // So total length is (4 + 2 + 1) * 2
	        return blockLength * 2;
	      }
	
	      return blockLength;
	    }
	
	    function decalVisual(ecModel, api) {
	      ecModel.eachRawSeries(function (seriesModel) {
	        if (ecModel.isSeriesFiltered(seriesModel)) {
	          return;
	        }
	
	        var data = seriesModel.getData();
	
	        if (data.hasItemVisual()) {
	          data.each(function (idx) {
	            var decal = data.getItemVisual(idx, 'decal');
	
	            if (decal) {
	              var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
	              itemStyle.decal = createOrUpdatePatternFromDecal(decal, api);
	            }
	          });
	        }
	
	        var decal = data.getVisual('decal');
	
	        if (decal) {
	          var style = data.getVisual('style');
	          style.decal = createOrUpdatePatternFromDecal(decal, api);
	        }
	      });
	    }
	
	    var lifecycle = new Eventful();
	
	    // The implementations will be registered when installing the component.
	    // Avoid these code being bundled to the core module.
	
	    var implsStore = {}; // TODO Type
	
	    function registerImpl(name, impl) {
	      if (true) {
	        if (implsStore[name]) {
	          error("Already has an implementation of " + name + ".");
	        }
	      }
	
	      implsStore[name] = impl;
	    }
	    function getImpl(name) {
	      if (true) {
	        if (!implsStore[name]) {
	          error("Implementation of " + name + " doesn't exists.");
	        }
	      }
	
	      return implsStore[name];
	    }
	
	    var version$1 = '5.4.3';
	    var dependencies = {
	      zrender: '5.4.4'
	    };
	    var TEST_FRAME_REMAIN_TIME = 1;
	    var PRIORITY_PROCESSOR_SERIES_FILTER = 800; // Some data processors depends on the stack result dimension (to calculate data extent).
	    // So data stack stage should be in front of data processing stage.
	
	    var PRIORITY_PROCESSOR_DATASTACK = 900; // "Data filter" will block the stream, so it should be
	    // put at the beginning of data processing.
	
	    var PRIORITY_PROCESSOR_FILTER = 1000;
	    var PRIORITY_PROCESSOR_DEFAULT = 2000;
	    var PRIORITY_PROCESSOR_STATISTIC = 5000;
	    var PRIORITY_VISUAL_LAYOUT = 1000;
	    var PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
	    var PRIORITY_VISUAL_GLOBAL = 2000;
	    var PRIORITY_VISUAL_CHART = 3000;
	    var PRIORITY_VISUAL_COMPONENT = 4000; // Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
	    // overwrite the viusal result of component (like `visualMap`)
	    // using data item specific setting (like itemStyle.xxx on data item)
	
	    var PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500; // Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
	    // visual result like `symbolSize`.
	
	    var PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
	    var PRIORITY_VISUAL_BRUSH = 5000;
	    var PRIORITY_VISUAL_ARIA = 6000;
	    var PRIORITY_VISUAL_DECAL = 7000;
	    var PRIORITY = {
	      PROCESSOR: {
	        FILTER: PRIORITY_PROCESSOR_FILTER,
	        SERIES_FILTER: PRIORITY_PROCESSOR_SERIES_FILTER,
	        STATISTIC: PRIORITY_PROCESSOR_STATISTIC
	      },
	      VISUAL: {
	        LAYOUT: PRIORITY_VISUAL_LAYOUT,
	        PROGRESSIVE_LAYOUT: PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
	        GLOBAL: PRIORITY_VISUAL_GLOBAL,
	        CHART: PRIORITY_VISUAL_CHART,
	        POST_CHART_LAYOUT: PRIORITY_VISUAL_POST_CHART_LAYOUT,
	        COMPONENT: PRIORITY_VISUAL_COMPONENT,
	        BRUSH: PRIORITY_VISUAL_BRUSH,
	        CHART_ITEM: PRIORITY_VISUAL_CHART_DATA_CUSTOM,
	        ARIA: PRIORITY_VISUAL_ARIA,
	        DECAL: PRIORITY_VISUAL_DECAL
	      }
	    }; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
	    // where they must not be invoked nestedly, except the only case: invoke
	    // dispatchAction with updateMethod "none" in main process.
	    // This flag is used to carry out this rule.
	    // All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
	
	    var IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
	    var PENDING_UPDATE = '__pendingUpdate';
	    var STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
	    var ACTION_REG = /^[a-zA-Z0-9_]+$/;
	    var CONNECT_STATUS_KEY = '__connectUpdateStatus';
	    var CONNECT_STATUS_PENDING = 0;
	    var CONNECT_STATUS_UPDATING = 1;
	    var CONNECT_STATUS_UPDATED = 2;
	
	    function createRegisterEventWithLowercaseECharts(method) {
	      return function () {
	        var args = [];
	
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	
	        if (this.isDisposed()) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        return toLowercaseNameAndCallEventful(this, method, args);
	      };
	    }
	
	    function createRegisterEventWithLowercaseMessageCenter(method) {
	      return function () {
	        var args = [];
	
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	
	        return toLowercaseNameAndCallEventful(this, method, args);
	      };
	    }
	
	    function toLowercaseNameAndCallEventful(host, method, args) {
	      // `args[0]` is event name. Event name is all lowercase.
	      args[0] = args[0] && args[0].toLowerCase();
	      return Eventful.prototype[method].apply(host, args);
	    }
	
	    var MessageCenter =
	    /** @class */
	    function (_super) {
	      __extends(MessageCenter, _super);
	
	      function MessageCenter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      return MessageCenter;
	    }(Eventful);
	
	    var messageCenterProto = MessageCenter.prototype;
	    messageCenterProto.on = createRegisterEventWithLowercaseMessageCenter('on');
	    messageCenterProto.off = createRegisterEventWithLowercaseMessageCenter('off'); // ---------------------------------------
	    // Internal method names for class ECharts
	    // ---------------------------------------
	
	    var prepare;
	    var prepareView;
	    var updateDirectly;
	    var updateMethods;
	    var doConvertPixel;
	    var updateStreamModes;
	    var doDispatchAction;
	    var flushPendingActions;
	    var triggerUpdatedEvent;
	    var bindRenderedEvent;
	    var bindMouseEvent;
	    var render;
	    var renderComponents;
	    var renderSeries;
	    var createExtensionAPI;
	    var enableConnect;
	    var markStatusToUpdate;
	    var applyChangedStates;
	
	    var ECharts =
	    /** @class */
	    function (_super) {
	      __extends(ECharts, _super);
	
	      function ECharts(dom, // Theme name or themeOption.
	      theme, opts) {
	        var _this = _super.call(this, new ECEventProcessor()) || this;
	
	        _this._chartsViews = [];
	        _this._chartsMap = {};
	        _this._componentsViews = [];
	        _this._componentsMap = {}; // Can't dispatch action during rendering procedure
	
	        _this._pendingActions = [];
	        opts = opts || {}; // Get theme by name
	
	        if (isString(theme)) {
	          theme = themeStorage[theme];
	        }
	
	        _this._dom = dom;
	        var defaultRenderer = 'canvas';
	        var defaultCoarsePointer = 'auto';
	        var defaultUseDirtyRect = false;
	
	        if (true) {
	          var root =
	          /* eslint-disable-next-line */
	          env.hasGlobalWindow ? window : global;
	          defaultRenderer = root.__ECHARTS__DEFAULT__RENDERER__ || defaultRenderer;
	          defaultCoarsePointer = retrieve2(root.__ECHARTS__DEFAULT__COARSE_POINTER, defaultCoarsePointer);
	          var devUseDirtyRect = root.__ECHARTS__DEFAULT__USE_DIRTY_RECT__;
	          defaultUseDirtyRect = devUseDirtyRect == null ? defaultUseDirtyRect : devUseDirtyRect;
	        }
	
	        var zr = _this._zr = init(dom, {
	          renderer: opts.renderer || defaultRenderer,
	          devicePixelRatio: opts.devicePixelRatio,
	          width: opts.width,
	          height: opts.height,
	          ssr: opts.ssr,
	          useDirtyRect: retrieve2(opts.useDirtyRect, defaultUseDirtyRect),
	          useCoarsePointer: retrieve2(opts.useCoarsePointer, defaultCoarsePointer),
	          pointerSize: opts.pointerSize
	        });
	        _this._ssr = opts.ssr; // Expect 60 fps.
	
	        _this._throttledZrFlush = throttle(bind(zr.flush, zr), 17);
	        theme = clone(theme);
	        theme && globalBackwardCompat(theme, true);
	        _this._theme = theme;
	        _this._locale = createLocaleObject(opts.locale || SYSTEM_LANG);
	        _this._coordSysMgr = new CoordinateSystemManager();
	        var api = _this._api = createExtensionAPI(_this); // Sort on demand
	
	        function prioritySortFunc(a, b) {
	          return a.__prio - b.__prio;
	        }
	
	        sort(visualFuncs, prioritySortFunc);
	        sort(dataProcessorFuncs, prioritySortFunc);
	        _this._scheduler = new Scheduler(_this, api, dataProcessorFuncs, visualFuncs);
	        _this._messageCenter = new MessageCenter(); // Init mouse events
	
	        _this._initEvents(); // In case some people write `window.onresize = chart.resize`
	
	
	        _this.resize = bind(_this.resize, _this);
	        zr.animation.on('frame', _this._onframe, _this);
	        bindRenderedEvent(zr, _this);
	        bindMouseEvent(zr, _this); // ECharts instance can be used as value.
	
	        setAsPrimitive(_this);
	        return _this;
	      }
	
	      ECharts.prototype._onframe = function () {
	        if (this._disposed) {
	          return;
	        }
	
	        applyChangedStates(this);
	        var scheduler = this._scheduler; // Lazy update
	
	        if (this[PENDING_UPDATE]) {
	          var silent = this[PENDING_UPDATE].silent;
	          this[IN_MAIN_PROCESS_KEY] = true;
	
	          try {
	            prepare(this);
	            updateMethods.update.call(this, null, this[PENDING_UPDATE].updateParams);
	          } catch (e) {
	            this[IN_MAIN_PROCESS_KEY] = false;
	            this[PENDING_UPDATE] = null;
	            throw e;
	          } // At present, in each frame, zrender performs:
	          //   (1) animation step forward.
	          //   (2) trigger('frame') (where this `_onframe` is called)
	          //   (3) zrender flush (render).
	          // If we do nothing here, since we use `setToFinal: true`, the step (3) above
	          // will render the final state of the elements before the real animation started.
	
	
	          this._zr.flush();
	
	          this[IN_MAIN_PROCESS_KEY] = false;
	          this[PENDING_UPDATE] = null;
	          flushPendingActions.call(this, silent);
	          triggerUpdatedEvent.call(this, silent);
	        } // Avoid do both lazy update and progress in one frame.
	        else if (scheduler.unfinished) {
	            // Stream progress.
	            var remainTime = TEST_FRAME_REMAIN_TIME;
	            var ecModel = this._model;
	            var api = this._api;
	            scheduler.unfinished = false;
	
	            do {
	              var startTime = +new Date();
	              scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
	
	              scheduler.performDataProcessorTasks(ecModel);
	              updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
	              // each frame is not a good user experience. So we follow the rule that
	              // the extent of the coordinate system is determined in the first frame (the
	              // frame is executed immediately after task reset.
	              // this._coordSysMgr.update(ecModel, api);
	              // console.log('--- ec frame visual ---', remainTime);
	
	              scheduler.performVisualTasks(ecModel);
	              renderSeries(this, this._model, api, 'remain', {});
	              remainTime -= +new Date() - startTime;
	            } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
	
	
	            if (!scheduler.unfinished) {
	              this._zr.flush();
	            } // Else, zr flushing be ensue within the same frame,
	            // because zr flushing is after onframe event.
	
	          }
	      };
	
	      ECharts.prototype.getDom = function () {
	        return this._dom;
	      };
	
	      ECharts.prototype.getId = function () {
	        return this.id;
	      };
	
	      ECharts.prototype.getZr = function () {
	        return this._zr;
	      };
	
	      ECharts.prototype.isSSR = function () {
	        return this._ssr;
	      };
	      /* eslint-disable-next-line */
	
	
	      ECharts.prototype.setOption = function (option, notMerge, lazyUpdate) {
	        if (this[IN_MAIN_PROCESS_KEY]) {
	          if (true) {
	            error('`setOption` should not be called during main process.');
	          }
	
	          return;
	        }
	
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        var silent;
	        var replaceMerge;
	        var transitionOpt;
	
	        if (isObject(notMerge)) {
	          lazyUpdate = notMerge.lazyUpdate;
	          silent = notMerge.silent;
	          replaceMerge = notMerge.replaceMerge;
	          transitionOpt = notMerge.transition;
	          notMerge = notMerge.notMerge;
	        }
	
	        this[IN_MAIN_PROCESS_KEY] = true;
	
	        if (!this._model || notMerge) {
	          var optionManager = new OptionManager(this._api);
	          var theme = this._theme;
	          var ecModel = this._model = new GlobalModel();
	          ecModel.scheduler = this._scheduler;
	          ecModel.ssr = this._ssr;
	          ecModel.init(null, null, null, theme, this._locale, optionManager);
	        }
	
	        this._model.setOption(option, {
	          replaceMerge: replaceMerge
	        }, optionPreprocessorFuncs);
	
	        var updateParams = {
	          seriesTransition: transitionOpt,
	          optionChanged: true
	        };
	
	        if (lazyUpdate) {
	          this[PENDING_UPDATE] = {
	            silent: silent,
	            updateParams: updateParams
	          };
	          this[IN_MAIN_PROCESS_KEY] = false; // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
	          // It should wake it up to make sure zrender start to render at the next frame.
	
	          this.getZr().wakeUp();
	        } else {
	          try {
	            prepare(this);
	            updateMethods.update.call(this, null, updateParams);
	          } catch (e) {
	            this[PENDING_UPDATE] = null;
	            this[IN_MAIN_PROCESS_KEY] = false;
	            throw e;
	          } // Ensure zr refresh sychronously, and then pixel in canvas can be
	          // fetched after `setOption`.
	
	
	          if (!this._ssr) {
	            // not use flush when using ssr mode.
	            this._zr.flush();
	          }
	
	          this[PENDING_UPDATE] = null;
	          this[IN_MAIN_PROCESS_KEY] = false;
	          flushPendingActions.call(this, silent);
	          triggerUpdatedEvent.call(this, silent);
	        }
	      };
	      /**
	       * @deprecated
	       */
	
	
	      ECharts.prototype.setTheme = function () {
	        deprecateLog('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
	      }; // We don't want developers to use getModel directly.
	
	
	      ECharts.prototype.getModel = function () {
	        return this._model;
	      };
	
	      ECharts.prototype.getOption = function () {
	        return this._model && this._model.getOption();
	      };
	
	      ECharts.prototype.getWidth = function () {
	        return this._zr.getWidth();
	      };
	
	      ECharts.prototype.getHeight = function () {
	        return this._zr.getHeight();
	      };
	
	      ECharts.prototype.getDevicePixelRatio = function () {
	        return this._zr.painter.dpr
	        /* eslint-disable-next-line */
	        || env.hasGlobalWindow && window.devicePixelRatio || 1;
	      };
	      /**
	       * Get canvas which has all thing rendered
	       * @deprecated Use renderToCanvas instead.
	       */
	
	
	      ECharts.prototype.getRenderedCanvas = function (opts) {
	        if (true) {
	          deprecateReplaceLog('getRenderedCanvas', 'renderToCanvas');
	        }
	
	        return this.renderToCanvas(opts);
	      };
	
	      ECharts.prototype.renderToCanvas = function (opts) {
	        opts = opts || {};
	        var painter = this._zr.painter;
	
	        if (true) {
	          if (painter.type !== 'canvas') {
	            throw new Error('renderToCanvas can only be used in the canvas renderer.');
	          }
	        }
	
	        return painter.getRenderedCanvas({
	          backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
	          pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
	        });
	      };
	
	      ECharts.prototype.renderToSVGString = function (opts) {
	        opts = opts || {};
	        var painter = this._zr.painter;
	
	        if (true) {
	          if (painter.type !== 'svg') {
	            throw new Error('renderToSVGString can only be used in the svg renderer.');
	          }
	        }
	
	        return painter.renderToString({
	          useViewBox: opts.useViewBox
	        });
	      };
	      /**
	       * Get svg data url
	       */
	
	
	      ECharts.prototype.getSvgDataURL = function () {
	        if (!env.svgSupported) {
	          return;
	        }
	
	        var zr = this._zr;
	        var list = zr.storage.getDisplayList(); // Stop animations
	
	        each(list, function (el) {
	          el.stopAnimation(null, true);
	        });
	        return zr.painter.toDataURL();
	      };
	
	      ECharts.prototype.getDataURL = function (opts) {
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        opts = opts || {};
	        var excludeComponents = opts.excludeComponents;
	        var ecModel = this._model;
	        var excludesComponentViews = [];
	        var self = this;
	        each(excludeComponents, function (componentType) {
	          ecModel.eachComponent({
	            mainType: componentType
	          }, function (component) {
	            var view = self._componentsMap[component.__viewId];
	
	            if (!view.group.ignore) {
	              excludesComponentViews.push(view);
	              view.group.ignore = true;
	            }
	          });
	        });
	        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
	        each(excludesComponentViews, function (view) {
	          view.group.ignore = false;
	        });
	        return url;
	      };
	
	      ECharts.prototype.getConnectedDataURL = function (opts) {
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        var isSvg = opts.type === 'svg';
	        var groupId = this.group;
	        var mathMin = Math.min;
	        var mathMax = Math.max;
	        var MAX_NUMBER = Infinity;
	
	        if (connectedGroups[groupId]) {
	          var left_1 = MAX_NUMBER;
	          var top_1 = MAX_NUMBER;
	          var right_1 = -MAX_NUMBER;
	          var bottom_1 = -MAX_NUMBER;
	          var canvasList_1 = [];
	          var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
	          each(instances$1, function (chart, id) {
	            if (chart.group === groupId) {
	              var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas(clone(opts));
	              var boundingRect = chart.getDom().getBoundingClientRect();
	              left_1 = mathMin(boundingRect.left, left_1);
	              top_1 = mathMin(boundingRect.top, top_1);
	              right_1 = mathMax(boundingRect.right, right_1);
	              bottom_1 = mathMax(boundingRect.bottom, bottom_1);
	              canvasList_1.push({
	                dom: canvas,
	                left: boundingRect.left,
	                top: boundingRect.top
	              });
	            }
	          });
	          left_1 *= dpr_1;
	          top_1 *= dpr_1;
	          right_1 *= dpr_1;
	          bottom_1 *= dpr_1;
	          var width = right_1 - left_1;
	          var height = bottom_1 - top_1;
	          var targetCanvas = platformApi.createCanvas();
	          var zr_1 = init(targetCanvas, {
	            renderer: isSvg ? 'svg' : 'canvas'
	          });
	          zr_1.resize({
	            width: width,
	            height: height
	          });
	
	          if (isSvg) {
	            var content_1 = '';
	            each(canvasList_1, function (item) {
	              var x = item.left - left_1;
	              var y = item.top - top_1;
	              content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
	            });
	            zr_1.painter.getSvgRoot().innerHTML = content_1;
	
	            if (opts.connectedBackgroundColor) {
	              zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
	            }
	
	            zr_1.refreshImmediately();
	            return zr_1.painter.toDataURL();
	          } else {
	            // Background between the charts
	            if (opts.connectedBackgroundColor) {
	              zr_1.add(new Rect({
	                shape: {
	                  x: 0,
	                  y: 0,
	                  width: width,
	                  height: height
	                },
	                style: {
	                  fill: opts.connectedBackgroundColor
	                }
	              }));
	            }
	
	            each(canvasList_1, function (item) {
	              var img = new ZRImage({
	                style: {
	                  x: item.left * dpr_1 - left_1,
	                  y: item.top * dpr_1 - top_1,
	                  image: item.dom
	                }
	              });
	              zr_1.add(img);
	            });
	            zr_1.refreshImmediately();
	            return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
	          }
	        } else {
	          return this.getDataURL(opts);
	        }
	      };
	
	      ECharts.prototype.convertToPixel = function (finder, value) {
	        return doConvertPixel(this, 'convertToPixel', finder, value);
	      };
	
	      ECharts.prototype.convertFromPixel = function (finder, value) {
	        return doConvertPixel(this, 'convertFromPixel', finder, value);
	      };
	      /**
	       * Is the specified coordinate systems or components contain the given pixel point.
	       * @param {Array|number} value
	       * @return {boolean} result
	       */
	
	
	      ECharts.prototype.containPixel = function (finder, value) {
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        var ecModel = this._model;
	        var result;
	        var findResult = parseFinder(ecModel, finder);
	        each(findResult, function (models, key) {
	          key.indexOf('Models') >= 0 && each(models, function (model) {
	            var coordSys = model.coordinateSystem;
	
	            if (coordSys && coordSys.containPoint) {
	              result = result || !!coordSys.containPoint(value);
	            } else if (key === 'seriesModels') {
	              var view = this._chartsMap[model.__viewId];
	
	              if (view && view.containPoint) {
	                result = result || view.containPoint(value, model);
	              } else {
	                if (true) {
	                  warn(key + ': ' + (view ? 'The found component do not support containPoint.' : 'No view mapping to the found component.'));
	                }
	              }
	            } else {
	              if (true) {
	                warn(key + ': containPoint is not supported');
	              }
	            }
	          }, this);
	        }, this);
	        return !!result;
	      };
	      /**
	       * Get visual from series or data.
	       * @param finder
	       *        If string, e.g., 'series', means {seriesIndex: 0}.
	       *        If Object, could contain some of these properties below:
	       *        {
	       *            seriesIndex / seriesId / seriesName,
	       *            dataIndex / dataIndexInside
	       *        }
	       *        If dataIndex is not specified, series visual will be fetched,
	       *        but not data item visual.
	       *        If all of seriesIndex, seriesId, seriesName are not specified,
	       *        visual will be fetched from first series.
	       * @param visualType 'color', 'symbol', 'symbolSize'
	       */
	
	
	      ECharts.prototype.getVisual = function (finder, visualType) {
	        var ecModel = this._model;
	        var parsedFinder = parseFinder(ecModel, finder, {
	          defaultMainType: 'series'
	        });
	        var seriesModel = parsedFinder.seriesModel;
	
	        if (true) {
	          if (!seriesModel) {
	            warn('There is no specified series model');
	          }
	        }
	
	        var data = seriesModel.getData();
	        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
	        return dataIndexInside != null ? getItemVisualFromData(data, dataIndexInside, visualType) : getVisualFromData(data, visualType);
	      };
	      /**
	       * Get view of corresponding component model
	       */
	
	
	      ECharts.prototype.getViewOfComponentModel = function (componentModel) {
	        return this._componentsMap[componentModel.__viewId];
	      };
	      /**
	       * Get view of corresponding series model
	       */
	
	
	      ECharts.prototype.getViewOfSeriesModel = function (seriesModel) {
	        return this._chartsMap[seriesModel.__viewId];
	      };
	
	      ECharts.prototype._initEvents = function () {
	        var _this = this;
	
	        each(MOUSE_EVENT_NAMES, function (eveName) {
	          var handler = function (e) {
	            var ecModel = _this.getModel();
	
	            var el = e.target;
	            var params;
	            var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
	
	            if (isGlobalOut) {
	              params = {};
	            } else {
	              el && findEventDispatcher(el, function (parent) {
	                var ecData = getECData(parent);
	
	                if (ecData && ecData.dataIndex != null) {
	                  var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
	                  params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
	                  return true;
	                } // If element has custom eventData of components
	                else if (ecData.eventData) {
	                    params = extend({}, ecData.eventData);
	                    return true;
	                  }
	              }, true);
	            } // Contract: if params prepared in mouse event,
	            // these properties must be specified:
	            // {
	            //    componentType: string (component main type)
	            //    componentIndex: number
	            // }
	            // Otherwise event query can not work.
	
	
	            if (params) {
	              var componentType = params.componentType;
	              var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
	              // markLine/markPoint/markArea, the componentType is
	              // 'markLine'/'markPoint'/'markArea', but we should better
	              // enable them to be queried by seriesIndex, since their
	              // option is set in each series.
	
	              if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
	                componentType = 'series';
	                componentIndex = params.seriesIndex;
	              }
	
	              var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
	              var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
	
	              if (true) {
	                // `event.componentType` and `event[componentTpype + 'Index']` must not
	                // be missed, otherwise there is no way to distinguish source component.
	                // See `dataFormat.getDataParams`.
	                if (!isGlobalOut && !(model && view)) {
	                  warn('model or view can not be found by params');
	                }
	              }
	
	              params.event = e;
	              params.type = eveName;
	              _this._$eventProcessor.eventInfo = {
	                targetEl: el,
	                packedEvent: params,
	                model: model,
	                view: view
	              };
	
	              _this.trigger(eveName, params);
	            }
	          }; // Consider that some component (like tooltip, brush, ...)
	          // register zr event handler, but user event handler might
	          // do anything, such as call `setOption` or `dispatchAction`,
	          // which probably update any of the content and probably
	          // cause problem if it is called previous other inner handlers.
	
	
	          handler.zrEventfulCallAtLast = true;
	
	          _this._zr.on(eveName, handler, _this);
	        });
	        each(eventActionMap, function (actionType, eventType) {
	          _this._messageCenter.on(eventType, function (event) {
	            this.trigger(eventType, event);
	          }, _this);
	        }); // Extra events
	        // TODO register?
	
	        each(['selectchanged'], function (eventType) {
	          _this._messageCenter.on(eventType, function (event) {
	            this.trigger(eventType, event);
	          }, _this);
	        });
	        handleLegacySelectEvents(this._messageCenter, this, this._api);
	      };
	
	      ECharts.prototype.isDisposed = function () {
	        return this._disposed;
	      };
	
	      ECharts.prototype.clear = function () {
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        this.setOption({
	          series: []
	        }, true);
	      };
	
	      ECharts.prototype.dispose = function () {
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        this._disposed = true;
	        var dom = this.getDom();
	
	        if (dom) {
	          setAttribute(this.getDom(), DOM_ATTRIBUTE_KEY, '');
	        }
	
	        var chart = this;
	        var api = chart._api;
	        var ecModel = chart._model;
	        each(chart._componentsViews, function (component) {
	          component.dispose(ecModel, api);
	        });
	        each(chart._chartsViews, function (chart) {
	          chart.dispose(ecModel, api);
	        }); // Dispose after all views disposed
	
	        chart._zr.dispose(); // Set properties to null.
	        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
	
	
	        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
	        delete instances$1[chart.id];
	      };
	      /**
	       * Resize the chart
	       */
	
	
	      ECharts.prototype.resize = function (opts) {
	        if (this[IN_MAIN_PROCESS_KEY]) {
	          if (true) {
	            error('`resize` should not be called during main process.');
	          }
	
	          return;
	        }
	
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        this._zr.resize(opts);
	
	        var ecModel = this._model; // Resize loading effect
	
	        this._loadingFX && this._loadingFX.resize();
	
	        if (!ecModel) {
	          return;
	        }
	
	        var needPrepare = ecModel.resetOption('media');
	        var silent = opts && opts.silent; // There is some real cases that:
	        // chart.setOption(option, { lazyUpdate: true });
	        // chart.resize();
	
	        if (this[PENDING_UPDATE]) {
	          if (silent == null) {
	            silent = this[PENDING_UPDATE].silent;
	          }
	
	          needPrepare = true;
	          this[PENDING_UPDATE] = null;
	        }
	
	        this[IN_MAIN_PROCESS_KEY] = true;
	
	        try {
	          needPrepare && prepare(this);
	          updateMethods.update.call(this, {
	            type: 'resize',
	            animation: extend({
	              // Disable animation
	              duration: 0
	            }, opts && opts.animation)
	          });
	        } catch (e) {
	          this[IN_MAIN_PROCESS_KEY] = false;
	          throw e;
	        }
	
	        this[IN_MAIN_PROCESS_KEY] = false;
	        flushPendingActions.call(this, silent);
	        triggerUpdatedEvent.call(this, silent);
	      };
	
	      ECharts.prototype.showLoading = function (name, cfg) {
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        if (isObject(name)) {
	          cfg = name;
	          name = '';
	        }
	
	        name = name || 'default';
	        this.hideLoading();
	
	        if (!loadingEffects[name]) {
	          if (true) {
	            warn('Loading effects ' + name + ' not exists.');
	          }
	
	          return;
	        }
	
	        var el = loadingEffects[name](this._api, cfg);
	        var zr = this._zr;
	        this._loadingFX = el;
	        zr.add(el);
	      };
	      /**
	       * Hide loading effect
	       */
	
	
	      ECharts.prototype.hideLoading = function () {
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        this._loadingFX && this._zr.remove(this._loadingFX);
	        this._loadingFX = null;
	      };
	
	      ECharts.prototype.makeActionFromEvent = function (eventObj) {
	        var payload = extend({}, eventObj);
	        payload.type = eventActionMap[eventObj.type];
	        return payload;
	      };
	      /**
	       * @param opt If pass boolean, means opt.silent
	       * @param opt.silent Default `false`. Whether trigger events.
	       * @param opt.flush Default `undefined`.
	       *        true: Flush immediately, and then pixel in canvas can be fetched
	       *            immediately. Caution: it might affect performance.
	       *        false: Not flush.
	       *        undefined: Auto decide whether perform flush.
	       */
	
	
	      ECharts.prototype.dispatchAction = function (payload, opt) {
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        if (!isObject(opt)) {
	          opt = {
	            silent: !!opt
	          };
	        }
	
	        if (!actions[payload.type]) {
	          return;
	        } // Avoid dispatch action before setOption. Especially in `connect`.
	
	
	        if (!this._model) {
	          return;
	        } // May dispatchAction in rendering procedure
	
	
	        if (this[IN_MAIN_PROCESS_KEY]) {
	          this._pendingActions.push(payload);
	
	          return;
	        }
	
	        var silent = opt.silent;
	        doDispatchAction.call(this, payload, silent);
	        var flush = opt.flush;
	
	        if (flush) {
	          this._zr.flush();
	        } else if (flush !== false && env.browser.weChat) {
	          // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
	          // hang when sliding page (on touch event), which cause that zr does not
	          // refresh until user interaction finished, which is not expected.
	          // But `dispatchAction` may be called too frequently when pan on touch
	          // screen, which impacts performance if do not throttle them.
	          this._throttledZrFlush();
	        }
	
	        flushPendingActions.call(this, silent);
	        triggerUpdatedEvent.call(this, silent);
	      };
	
	      ECharts.prototype.updateLabelLayout = function () {
	        lifecycle.trigger('series:layoutlabels', this._model, this._api, {
	          // Not adding series labels.
	          // TODO
	          updatedSeries: []
	        });
	      };
	
	      ECharts.prototype.appendData = function (params) {
	        if (this._disposed) {
	          disposedWarning(this.id);
	          return;
	        }
	
	        var seriesIndex = params.seriesIndex;
	        var ecModel = this.getModel();
	        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	
	        if (true) {
	          assert(params.data && seriesModel);
	        }
	
	        seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
	        // system, util some scenario require that. In the expected usage of
	        // `appendData`, the initial extent of coordinate system should better
	        // be fixed by axis `min`/`max` setting or initial data, otherwise if
	        // the extent changed while `appendData`, the location of the painted
	        // graphic elements have to be changed, which make the usage of
	        // `appendData` meaningless.
	
	        this._scheduler.unfinished = true;
	        this.getZr().wakeUp();
	      }; // A work around for no `internal` modifier in ts yet but
	      // need to strictly hide private methods to JS users.
	
	
	      ECharts.internalField = function () {
	        prepare = function (ecIns) {
	          var scheduler = ecIns._scheduler;
	          scheduler.restorePipelines(ecIns._model);
	          scheduler.prepareStageTasks();
	          prepareView(ecIns, true);
	          prepareView(ecIns, false);
	          scheduler.plan();
	        };
	        /**
	         * Prepare view instances of charts and components
	         */
	
	
	        prepareView = function (ecIns, isComponent) {
	          var ecModel = ecIns._model;
	          var scheduler = ecIns._scheduler;
	          var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
	          var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
	          var zr = ecIns._zr;
	          var api = ecIns._api;
	
	          for (var i = 0; i < viewList.length; i++) {
	            viewList[i].__alive = false;
	          }
	
	          isComponent ? ecModel.eachComponent(function (componentType, model) {
	            componentType !== 'series' && doPrepare(model);
	          }) : ecModel.eachSeries(doPrepare);
	
	          function doPrepare(model) {
	            // By default view will be reused if possible for the case that `setOption` with "notMerge"
	            // mode and need to enable transition animation. (Usually, when they have the same id, or
	            // especially no id but have the same type & name & index. See the `model.id` generation
	            // rule in `makeIdAndName` and `viewId` generation rule here).
	            // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
	            // the new model has nothing to do with the old model.
	            var requireNewView = model.__requireNewView; // This command should not work twice.
	
	            model.__requireNewView = false; // Consider: id same and type changed.
	
	            var viewId = '_ec_' + model.id + '_' + model.type;
	            var view = !requireNewView && viewMap[viewId];
	
	            if (!view) {
	              var classType = parseClassType(model.type);
	              var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : // FIXME:TS
	              // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
	              // For backward compat, still support a chart type declared as only subType
	              // like "liquidfill", but recommend "series.liquidfill"
	              // But need a base class to make a type series.
	              ChartView.getClass(classType.sub);
	
	              if (true) {
	                assert(Clazz, classType.sub + ' does not exist.');
	              }
	
	              view = new Clazz();
	              view.init(ecModel, api);
	              viewMap[viewId] = view;
	              viewList.push(view);
	              zr.add(view.group);
	            }
	
	            model.__viewId = view.__id = viewId;
	            view.__alive = true;
	            view.__model = model;
	            view.group.__ecComponentInfo = {
	              mainType: model.mainType,
	              index: model.componentIndex
	            };
	            !isComponent && scheduler.prepareView(view, model, ecModel, api);
	          }
	
	          for (var i = 0; i < viewList.length;) {
	            var view = viewList[i];
	
	            if (!view.__alive) {
	              !isComponent && view.renderTask.dispose();
	              zr.remove(view.group);
	              view.dispose(ecModel, api);
	              viewList.splice(i, 1);
	
	              if (viewMap[view.__id] === view) {
	                delete viewMap[view.__id];
	              }
	
	              view.__id = view.group.__ecComponentInfo = null;
	            } else {
	              i++;
	            }
	          }
	        };
	
	        updateDirectly = function (ecIns, method, payload, mainType, subType) {
	          var ecModel = ecIns._model;
	          ecModel.setUpdatePayload(payload); // broadcast
	
	          if (!mainType) {
	            // FIXME
	            // Chart will not be update directly here, except set dirty.
	            // But there is no such scenario now.
	            each([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
	            return;
	          }
	
	          var query = {};
	          query[mainType + 'Id'] = payload[mainType + 'Id'];
	          query[mainType + 'Index'] = payload[mainType + 'Index'];
	          query[mainType + 'Name'] = payload[mainType + 'Name'];
	          var condition = {
	            mainType: mainType,
	            query: query
	          };
	          subType && (condition.subType = subType); // subType may be '' by parseClassType;
	
	          var excludeSeriesId = payload.excludeSeriesId;
	          var excludeSeriesIdMap;
	
	          if (excludeSeriesId != null) {
	            excludeSeriesIdMap = createHashMap();
	            each(normalizeToArray(excludeSeriesId), function (id) {
	              var modelId = convertOptionIdName(id, null);
	
	              if (modelId != null) {
	                excludeSeriesIdMap.set(modelId, true);
	              }
	            });
	          } // If dispatchAction before setOption, do nothing.
	
	
	          ecModel && ecModel.eachComponent(condition, function (model) {
	            var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
	
	            if (isExcluded) {
	              return;
	            }
	
	            if (isHighDownPayload(payload)) {
	              if (model instanceof SeriesModel) {
	                if (payload.type === HIGHLIGHT_ACTION_TYPE && !payload.notBlur && !model.get(['emphasis', 'disabled'])) {
	                  blurSeriesFromHighlightPayload(model, payload, ecIns._api);
	                }
	              } else {
	                var _a = findComponentHighDownDispatchers(model.mainType, model.componentIndex, payload.name, ecIns._api),
	                    focusSelf = _a.focusSelf,
	                    dispatchers = _a.dispatchers;
	
	                if (payload.type === HIGHLIGHT_ACTION_TYPE && focusSelf && !payload.notBlur) {
	                  blurComponent(model.mainType, model.componentIndex, ecIns._api);
	                } // PENDING:
	                // Whether to put this "enter emphasis" code in `ComponentView`,
	                // which will be the same as `ChartView` but might be not necessary
	                // and will be far from this logic.
	
	
	                if (dispatchers) {
	                  each(dispatchers, function (dispatcher) {
	                    payload.type === HIGHLIGHT_ACTION_TYPE ? enterEmphasis(dispatcher) : leaveEmphasis(dispatcher);
	                  });
	                }
	              }
	            } else if (isSelectChangePayload(payload)) {
	              // TODO geo
	              if (model instanceof SeriesModel) {
	                toggleSelectionFromPayload(model, payload, ecIns._api);
	                updateSeriesElementSelection(model);
	                markStatusToUpdate(ecIns);
	              }
	            }
	          }, ecIns);
	          ecModel && ecModel.eachComponent(condition, function (model) {
	            var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
	
	            if (isExcluded) {
	              return;
	            }
	            callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
	          }, ecIns);
	
	          function callView(view) {
	            view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
	          }
	        };
	
	        updateMethods = {
	          prepareAndUpdate: function (payload) {
	            prepare(this);
	            updateMethods.update.call(this, payload, {
	              // Needs to mark option changed if newOption is given.
	              // It's from MagicType.
	              // TODO If use a separate flag optionChanged in payload?
	              optionChanged: payload.newOption != null
	            });
	          },
	          update: function (payload, updateParams) {
	            var ecModel = this._model;
	            var api = this._api;
	            var zr = this._zr;
	            var coordSysMgr = this._coordSysMgr;
	            var scheduler = this._scheduler; // update before setOption
	
	            if (!ecModel) {
	              return;
	            }
	
	            ecModel.setUpdatePayload(payload);
	            scheduler.restoreData(ecModel, payload);
	            scheduler.performSeriesTasks(ecModel); // TODO
	            // Save total ecModel here for undo/redo (after restoring data and before processing data).
	            // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
	            // Create new coordinate system each update
	            // In LineView may save the old coordinate system and use it to get the original point.
	
	            coordSysMgr.create(ecModel, api);
	            scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
	            // stream modes after data processing, where the filtered data is used to
	            // determine whether to use progressive rendering.
	
	            updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
	            // can be fetched when coord sys updating (consider the barGrid extent fix). But
	            // the drawback is the full coord info can not be fetched. Fortunately this full
	            // coord is not required in stream mode updater currently.
	
	            coordSysMgr.update(ecModel, api);
	            clearColorPalette(ecModel);
	            scheduler.performVisualTasks(ecModel, payload);
	            render(this, ecModel, api, payload, updateParams); // Set background
	
	            var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
	            var darkMode = ecModel.get('darkMode');
	            zr.setBackgroundColor(backgroundColor); // Force set dark mode.
	
	            if (darkMode != null && darkMode !== 'auto') {
	              zr.setDarkMode(darkMode);
	            }
	
	            lifecycle.trigger('afterupdate', ecModel, api);
	          },
	          updateTransform: function (payload) {
	            var _this = this;
	
	            var ecModel = this._model;
	            var api = this._api; // update before setOption
	
	            if (!ecModel) {
	              return;
	            }
	
	            ecModel.setUpdatePayload(payload); // ChartView.markUpdateMethod(payload, 'updateTransform');
	
	            var componentDirtyList = [];
	            ecModel.eachComponent(function (componentType, componentModel) {
	              if (componentType === 'series') {
	                return;
	              }
	
	              var componentView = _this.getViewOfComponentModel(componentModel);
	
	              if (componentView && componentView.__alive) {
	                if (componentView.updateTransform) {
	                  var result = componentView.updateTransform(componentModel, ecModel, api, payload);
	                  result && result.update && componentDirtyList.push(componentView);
	                } else {
	                  componentDirtyList.push(componentView);
	                }
	              }
	            });
	            var seriesDirtyMap = createHashMap();
	            ecModel.eachSeries(function (seriesModel) {
	              var chartView = _this._chartsMap[seriesModel.__viewId];
	
	              if (chartView.updateTransform) {
	                var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
	                result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
	              } else {
	                seriesDirtyMap.set(seriesModel.uid, 1);
	              }
	            });
	            clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	            // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	
	            this._scheduler.performVisualTasks(ecModel, payload, {
	              setDirty: true,
	              dirtyMap: seriesDirtyMap
	            }); // Currently, not call render of components. Geo render cost a lot.
	            // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
	
	
	            renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
	            lifecycle.trigger('afterupdate', ecModel, api);
	          },
	          updateView: function (payload) {
	            var ecModel = this._model; // update before setOption
	
	            if (!ecModel) {
	              return;
	            }
	
	            ecModel.setUpdatePayload(payload);
	            ChartView.markUpdateMethod(payload, 'updateView');
	            clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	
	            this._scheduler.performVisualTasks(ecModel, payload, {
	              setDirty: true
	            });
	
	            render(this, ecModel, this._api, payload, {});
	            lifecycle.trigger('afterupdate', ecModel, this._api);
	          },
	          updateVisual: function (payload) {
	            // updateMethods.update.call(this, payload);
	            var _this = this;
	
	            var ecModel = this._model; // update before setOption
	
	            if (!ecModel) {
	              return;
	            }
	
	            ecModel.setUpdatePayload(payload); // clear all visual
	
	            ecModel.eachSeries(function (seriesModel) {
	              seriesModel.getData().clearAllVisual();
	            }); // Perform visual
	
	            ChartView.markUpdateMethod(payload, 'updateVisual');
	            clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	
	            this._scheduler.performVisualTasks(ecModel, payload, {
	              visualType: 'visual',
	              setDirty: true
	            });
	
	            ecModel.eachComponent(function (componentType, componentModel) {
	              if (componentType !== 'series') {
	                var componentView = _this.getViewOfComponentModel(componentModel);
	
	                componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
	              }
	            });
	            ecModel.eachSeries(function (seriesModel) {
	              var chartView = _this._chartsMap[seriesModel.__viewId];
	              chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
	            });
	            lifecycle.trigger('afterupdate', ecModel, this._api);
	          },
	          updateLayout: function (payload) {
	            updateMethods.update.call(this, payload);
	          }
	        };
	
	        doConvertPixel = function (ecIns, methodName, finder, value) {
	          if (ecIns._disposed) {
	            disposedWarning(ecIns.id);
	            return;
	          }
	
	          var ecModel = ecIns._model;
	
	          var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
	
	          var result;
	          var parsedFinder = parseFinder(ecModel, finder);
	
	          for (var i = 0; i < coordSysList.length; i++) {
	            var coordSys = coordSysList[i];
	
	            if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) {
	              return result;
	            }
	          }
	
	          if (true) {
	            warn('No coordinate system that supports ' + methodName + ' found by the given finder.');
	          }
	        };
	
	        updateStreamModes = function (ecIns, ecModel) {
	          var chartsMap = ecIns._chartsMap;
	          var scheduler = ecIns._scheduler;
	          ecModel.eachSeries(function (seriesModel) {
	            scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
	          });
	        };
	
	        doDispatchAction = function (payload, silent) {
	          var _this = this;
	
	          var ecModel = this.getModel();
	          var payloadType = payload.type;
	          var escapeConnect = payload.escapeConnect;
	          var actionWrap = actions[payloadType];
	          var actionInfo = actionWrap.actionInfo;
	          var cptTypeTmp = (actionInfo.update || 'update').split(':');
	          var updateMethod = cptTypeTmp.pop();
	          var cptType = cptTypeTmp[0] != null && parseClassType(cptTypeTmp[0]);
	          this[IN_MAIN_PROCESS_KEY] = true;
	          var payloads = [payload];
	          var batched = false; // Batch action
	
	          if (payload.batch) {
	            batched = true;
	            payloads = map(payload.batch, function (item) {
	              item = defaults(extend({}, item), payload);
	              item.batch = null;
	              return item;
	            });
	          }
	
	          var eventObjBatch = [];
	          var eventObj;
	          var isSelectChange = isSelectChangePayload(payload);
	          var isHighDown = isHighDownPayload(payload); // Only leave blur once if there are multiple batches.
	
	          if (isHighDown) {
	            allLeaveBlur(this._api);
	          }
	
	          each(payloads, function (batchItem) {
	            // Action can specify the event by return it.
	            eventObj = actionWrap.action(batchItem, _this._model, _this._api); // Emit event outside
	
	            eventObj = eventObj || extend({}, batchItem); // Convert type to eventType
	
	            eventObj.type = actionInfo.event || eventObj.type;
	            eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
	
	            if (isHighDown) {
	              var _a = preParseFinder(payload),
	                  queryOptionMap = _a.queryOptionMap,
	                  mainTypeSpecified = _a.mainTypeSpecified;
	
	              var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
	              updateDirectly(_this, updateMethod, batchItem, componentMainType);
	              markStatusToUpdate(_this);
	            } else if (isSelectChange) {
	              // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
	              // geo still use 'geoselect'.
	              updateDirectly(_this, updateMethod, batchItem, 'series');
	              markStatusToUpdate(_this);
	            } else if (cptType) {
	              updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
	            }
	          });
	
	          if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
	            try {
	              // Still dirty
	              if (this[PENDING_UPDATE]) {
	                prepare(this);
	                updateMethods.update.call(this, payload);
	                this[PENDING_UPDATE] = null;
	              } else {
	                updateMethods[updateMethod].call(this, payload);
	              }
	            } catch (e) {
	              this[IN_MAIN_PROCESS_KEY] = false;
	              throw e;
	            }
	          } // Follow the rule of action batch
	
	
	          if (batched) {
	            eventObj = {
	              type: actionInfo.event || payloadType,
	              escapeConnect: escapeConnect,
	              batch: eventObjBatch
	            };
	          } else {
	            eventObj = eventObjBatch[0];
	          }
	
	          this[IN_MAIN_PROCESS_KEY] = false;
	
	          if (!silent) {
	            var messageCenter = this._messageCenter;
	            messageCenter.trigger(eventObj.type, eventObj); // Extra triggered 'selectchanged' event
	
	            if (isSelectChange) {
	              var newObj = {
	                type: 'selectchanged',
	                escapeConnect: escapeConnect,
	                selected: getAllSelectedIndices(ecModel),
	                isFromClick: payload.isFromClick || false,
	                fromAction: payload.type,
	                fromActionPayload: payload
	              };
	              messageCenter.trigger(newObj.type, newObj);
	            }
	          }
	        };
	
	        flushPendingActions = function (silent) {
	          var pendingActions = this._pendingActions;
	
	          while (pendingActions.length) {
	            var payload = pendingActions.shift();
	            doDispatchAction.call(this, payload, silent);
	          }
	        };
	
	        triggerUpdatedEvent = function (silent) {
	          !silent && this.trigger('updated');
	        };
	        /**
	         * Event `rendered` is triggered when zr
	         * rendered. It is useful for realtime
	         * snapshot (reflect animation).
	         *
	         * Event `finished` is triggered when:
	         * (1) zrender rendering finished.
	         * (2) initial animation finished.
	         * (3) progressive rendering finished.
	         * (4) no pending action.
	         * (5) no delayed setOption needs to be processed.
	         */
	
	
	        bindRenderedEvent = function (zr, ecIns) {
	          zr.on('rendered', function (params) {
	            ecIns.trigger('rendered', params); // The `finished` event should not be triggered repeatedly,
	            // so it should only be triggered when rendering indeed happens
	            // in zrender. (Consider the case that dipatchAction is keep
	            // triggering when mouse move).
	
	            if ( // Although zr is dirty if initial animation is not finished
	            // and this checking is called on frame, we also check
	            // animation finished for robustness.
	            zr.animation.isFinished() && !ecIns[PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
	              ecIns.trigger('finished');
	            }
	          });
	        };
	
	        bindMouseEvent = function (zr, ecIns) {
	          zr.on('mouseover', function (e) {
	            var el = e.target;
	            var dispatcher = findEventDispatcher(el, isHighDownDispatcher);
	
	            if (dispatcher) {
	              handleGlobalMouseOverForHighDown(dispatcher, e, ecIns._api);
	              markStatusToUpdate(ecIns);
	            }
	          }).on('mouseout', function (e) {
	            var el = e.target;
	            var dispatcher = findEventDispatcher(el, isHighDownDispatcher);
	
	            if (dispatcher) {
	              handleGlobalMouseOutForHighDown(dispatcher, e, ecIns._api);
	              markStatusToUpdate(ecIns);
	            }
	          }).on('click', function (e) {
	            var el = e.target;
	            var dispatcher = findEventDispatcher(el, function (target) {
	              return getECData(target).dataIndex != null;
	            }, true);
	
	            if (dispatcher) {
	              var actionType = dispatcher.selected ? 'unselect' : 'select';
	              var ecData = getECData(dispatcher);
	
	              ecIns._api.dispatchAction({
	                type: actionType,
	                dataType: ecData.dataType,
	                dataIndexInside: ecData.dataIndex,
	                seriesIndex: ecData.seriesIndex,
	                isFromClick: true
	              });
	            }
	          });
	        };
	
	        function clearColorPalette(ecModel) {
	          ecModel.clearColorPalette();
	          ecModel.eachSeries(function (seriesModel) {
	            seriesModel.clearColorPalette();
	          });
	        }
	
	        function allocateZlevels(ecModel) {
	          var componentZLevels = [];
	          var seriesZLevels = [];
	          var hasSeperateZLevel = false;
	          ecModel.eachComponent(function (componentType, componentModel) {
	            var zlevel = componentModel.get('zlevel') || 0;
	            var z = componentModel.get('z') || 0;
	            var zlevelKey = componentModel.getZLevelKey();
	            hasSeperateZLevel = hasSeperateZLevel || !!zlevelKey;
	            (componentType === 'series' ? seriesZLevels : componentZLevels).push({
	              zlevel: zlevel,
	              z: z,
	              idx: componentModel.componentIndex,
	              type: componentType,
	              key: zlevelKey
	            });
	          });
	
	          if (hasSeperateZLevel) {
	            // Series after component
	            var zLevels = componentZLevels.concat(seriesZLevels);
	            var lastSeriesZLevel_1;
	            var lastSeriesKey_1;
	            sort(zLevels, function (a, b) {
	              if (a.zlevel === b.zlevel) {
	                return a.z - b.z;
	              }
	
	              return a.zlevel - b.zlevel;
	            });
	            each(zLevels, function (item) {
	              var componentModel = ecModel.getComponent(item.type, item.idx);
	              var zlevel = item.zlevel;
	              var key = item.key;
	
	              if (lastSeriesZLevel_1 != null) {
	                zlevel = Math.max(lastSeriesZLevel_1, zlevel);
	              }
	
	              if (key) {
	                if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) {
	                  zlevel++;
	                }
	
	                lastSeriesKey_1 = key;
	              } else if (lastSeriesKey_1) {
	                if (zlevel === lastSeriesZLevel_1) {
	                  zlevel++;
	                }
	
	                lastSeriesKey_1 = '';
	              }
	
	              lastSeriesZLevel_1 = zlevel;
	              componentModel.setZLevel(zlevel);
	            });
	          }
	        }
	
	        render = function (ecIns, ecModel, api, payload, updateParams) {
	          allocateZlevels(ecModel);
	          renderComponents(ecIns, ecModel, api, payload, updateParams);
	          each(ecIns._chartsViews, function (chart) {
	            chart.__alive = false;
	          });
	          renderSeries(ecIns, ecModel, api, payload, updateParams); // Remove groups of unrendered charts
	
	          each(ecIns._chartsViews, function (chart) {
	            if (!chart.__alive) {
	              chart.remove(ecModel, api);
	            }
	          });
	        };
	
	        renderComponents = function (ecIns, ecModel, api, payload, updateParams, dirtyList) {
	          each(dirtyList || ecIns._componentsViews, function (componentView) {
	            var componentModel = componentView.__model;
	            clearStates(componentModel, componentView);
	            componentView.render(componentModel, ecModel, api, payload);
	            updateZ(componentModel, componentView);
	            updateStates(componentModel, componentView);
	          });
	        };
	        /**
	         * Render each chart and component
	         */
	
	
	        renderSeries = function (ecIns, ecModel, api, payload, updateParams, dirtyMap) {
	          // Render all charts
	          var scheduler = ecIns._scheduler;
	          updateParams = extend(updateParams || {}, {
	            updatedSeries: ecModel.getSeries()
	          }); // TODO progressive?
	
	          lifecycle.trigger('series:beforeupdate', ecModel, api, updateParams);
	          var unfinished = false;
	          ecModel.eachSeries(function (seriesModel) {
	            var chartView = ecIns._chartsMap[seriesModel.__viewId];
	            chartView.__alive = true;
	            var renderTask = chartView.renderTask;
	            scheduler.updatePayload(renderTask, payload); // TODO states on marker.
	
	            clearStates(seriesModel, chartView);
	
	            if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
	              renderTask.dirty();
	            }
	
	            if (renderTask.perform(scheduler.getPerformArgs(renderTask))) {
	              unfinished = true;
	            }
	
	            chartView.group.silent = !!seriesModel.get('silent'); // Should not call markRedraw on group, because it will disable zrender
	            // incremental render (always render from the __startIndex each frame)
	            // chartView.group.markRedraw();
	
	            updateBlend(seriesModel, chartView);
	            updateSeriesElementSelection(seriesModel);
	          });
	          scheduler.unfinished = unfinished || scheduler.unfinished;
	          lifecycle.trigger('series:layoutlabels', ecModel, api, updateParams); // transition after label is layouted.
	
	          lifecycle.trigger('series:transition', ecModel, api, updateParams);
	          ecModel.eachSeries(function (seriesModel) {
	            var chartView = ecIns._chartsMap[seriesModel.__viewId]; // Update Z after labels updated. Before applying states.
	
	            updateZ(seriesModel, chartView); // NOTE: Update states after label is updated.
	            // label should be in normal status when layouting.
	
	            updateStates(seriesModel, chartView);
	          }); // If use hover layer
	
	          updateHoverLayerStatus(ecIns, ecModel);
	          lifecycle.trigger('series:afterupdate', ecModel, api, updateParams);
	        };
	
	        markStatusToUpdate = function (ecIns) {
	          ecIns[STATUS_NEEDS_UPDATE_KEY] = true; // Wake up zrender if it's sleep. Let it update states in the next frame.
	
	          ecIns.getZr().wakeUp();
	        };
	
	        applyChangedStates = function (ecIns) {
	          if (!ecIns[STATUS_NEEDS_UPDATE_KEY]) {
	            return;
	          }
	
	          ecIns.getZr().storage.traverse(function (el) {
	            // Not applied on removed elements, it may still in fading.
	            if (isElementRemoved(el)) {
	              return;
	            }
	
	            applyElementStates(el);
	          });
	          ecIns[STATUS_NEEDS_UPDATE_KEY] = false;
	        };
	
	        function applyElementStates(el) {
	          var newStates = [];
	          var oldStates = el.currentStates; // Keep other states.
	
	          for (var i = 0; i < oldStates.length; i++) {
	            var stateName = oldStates[i];
	
	            if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) {
	              newStates.push(stateName);
	            }
	          } // Only use states when it's exists.
	
	
	          if (el.selected && el.states.select) {
	            newStates.push('select');
	          }
	
	          if (el.hoverState === HOVER_STATE_EMPHASIS && el.states.emphasis) {
	            newStates.push('emphasis');
	          } else if (el.hoverState === HOVER_STATE_BLUR && el.states.blur) {
	            newStates.push('blur');
	          }
	
	          el.useStates(newStates);
	        }
	
	        function updateHoverLayerStatus(ecIns, ecModel) {
	          var zr = ecIns._zr;
	          var storage = zr.storage;
	          var elCount = 0;
	          storage.traverse(function (el) {
	            if (!el.isGroup) {
	              elCount++;
	            }
	          });
	
	          if (elCount > ecModel.get('hoverLayerThreshold') && !env.node && !env.worker) {
	            ecModel.eachSeries(function (seriesModel) {
	              if (seriesModel.preventUsingHoverLayer) {
	                return;
	              }
	
	              var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	              if (chartView.__alive) {
	                chartView.eachRendered(function (el) {
	                  if (el.states.emphasis) {
	                    el.states.emphasis.hoverLayer = true;
	                  }
	                });
	              }
	            });
	          }
	        }
	        /**
	         * Update chart and blend.
	         */
	
	        function updateBlend(seriesModel, chartView) {
	          var blendMode = seriesModel.get('blendMode') || null;
	          chartView.eachRendered(function (el) {
	            // FIXME marker and other components
	            if (!el.isGroup) {
	              // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
	              el.style.blend = blendMode;
	            }
	          });
	        }
	
	        function updateZ(model, view) {
	          if (model.preventAutoZ) {
	            return;
	          }
	
	          var z = model.get('z') || 0;
	          var zlevel = model.get('zlevel') || 0; // Set z and zlevel
	
	          view.eachRendered(function (el) {
	            doUpdateZ(el, z, zlevel, -Infinity); // Don't traverse the children because it has been traversed in _updateZ.
	
	            return true;
	          });
	        }
	
	        function doUpdateZ(el, z, zlevel, maxZ2) {
	          // Group may also have textContent
	          var label = el.getTextContent();
	          var labelLine = el.getTextGuideLine();
	          var isGroup = el.isGroup;
	
	          if (isGroup) {
	            // set z & zlevel of children elements of Group
	            var children = el.childrenRef();
	
	            for (var i = 0; i < children.length; i++) {
	              maxZ2 = Math.max(doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
	            }
	          } else {
	            // not Group
	            el.z = z;
	            el.zlevel = zlevel;
	            maxZ2 = Math.max(el.z2, maxZ2);
	          } // always set z and zlevel if label/labelLine exists
	
	
	          if (label) {
	            label.z = z;
	            label.zlevel = zlevel; // lift z2 of text content
	            // TODO if el.emphasis.z2 is spcefied, what about textContent.
	
	            isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
	          }
	
	          if (labelLine) {
	            var textGuideLineConfig = el.textGuideLineConfig;
	            labelLine.z = z;
	            labelLine.zlevel = zlevel;
	            isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
	          }
	
	          return maxZ2;
	        } // Clear states without animation.
	        // TODO States on component.
	
	
	        function clearStates(model, view) {
	          view.eachRendered(function (el) {
	            // Not applied on removed elements, it may still in fading.
	            if (isElementRemoved(el)) {
	              return;
	            }
	
	            var textContent = el.getTextContent();
	            var textGuide = el.getTextGuideLine();
	
	            if (el.stateTransition) {
	              el.stateTransition = null;
	            }
	
	            if (textContent && textContent.stateTransition) {
	              textContent.stateTransition = null;
	            }
	
	            if (textGuide && textGuide.stateTransition) {
	              textGuide.stateTransition = null;
	            } // TODO If el is incremental.
	
	
	            if (el.hasState()) {
	              el.prevStates = el.currentStates;
	              el.clearStates();
	            } else if (el.prevStates) {
	              el.prevStates = null;
	            }
	          });
	        }
	
	        function updateStates(model, view) {
	          var stateAnimationModel = model.getModel('stateAnimation');
	          var enableAnimation = model.isAnimationEnabled();
	          var duration = stateAnimationModel.get('duration');
	          var stateTransition = duration > 0 ? {
	            duration: duration,
	            delay: stateAnimationModel.get('delay'),
	            easing: stateAnimationModel.get('easing') // additive: stateAnimationModel.get('additive')
	
	          } : null;
	          view.eachRendered(function (el) {
	            if (el.states && el.states.emphasis) {
	              // Not applied on removed elements, it may still in fading.
	              if (isElementRemoved(el)) {
	                return;
	              }
	
	              if (el instanceof Path) {
	                savePathStates(el);
	              } // Only updated on changed element. In case element is incremental and don't want to rerender.
	              // TODO, a more proper way?
	
	
	              if (el.__dirty) {
	                var prevStates = el.prevStates; // Restore states without animation
	
	                if (prevStates) {
	                  el.useStates(prevStates);
	                }
	              } // Update state transition and enable animation again.
	
	
	              if (enableAnimation) {
	                el.stateTransition = stateTransition;
	                var textContent = el.getTextContent();
	                var textGuide = el.getTextGuideLine(); // TODO Is it necessary to animate label?
	
	                if (textContent) {
	                  textContent.stateTransition = stateTransition;
	                }
	
	                if (textGuide) {
	                  textGuide.stateTransition = stateTransition;
	                }
	              } // Use highlighted and selected flag to toggle states.
	
	
	              if (el.__dirty) {
	                applyElementStates(el);
	              }
	            }
	          });
	        }
	
	        createExtensionAPI = function (ecIns) {
	          return new (
	          /** @class */
	          function (_super) {
	            __extends(class_1, _super);
	
	            function class_1() {
	              return _super !== null && _super.apply(this, arguments) || this;
	            }
	
	            class_1.prototype.getCoordinateSystems = function () {
	              return ecIns._coordSysMgr.getCoordinateSystems();
	            };
	
	            class_1.prototype.getComponentByElement = function (el) {
	              while (el) {
	                var modelInfo = el.__ecComponentInfo;
	
	                if (modelInfo != null) {
	                  return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
	                }
	
	                el = el.parent;
	              }
	            };
	
	            class_1.prototype.enterEmphasis = function (el, highlightDigit) {
	              enterEmphasis(el, highlightDigit);
	              markStatusToUpdate(ecIns);
	            };
	
	            class_1.prototype.leaveEmphasis = function (el, highlightDigit) {
	              leaveEmphasis(el, highlightDigit);
	              markStatusToUpdate(ecIns);
	            };
	
	            class_1.prototype.enterBlur = function (el) {
	              enterBlur(el);
	              markStatusToUpdate(ecIns);
	            };
	
	            class_1.prototype.leaveBlur = function (el) {
	              leaveBlur(el);
	              markStatusToUpdate(ecIns);
	            };
	
	            class_1.prototype.enterSelect = function (el) {
	              enterSelect(el);
	              markStatusToUpdate(ecIns);
	            };
	
	            class_1.prototype.leaveSelect = function (el) {
	              leaveSelect(el);
	              markStatusToUpdate(ecIns);
	            };
	
	            class_1.prototype.getModel = function () {
	              return ecIns.getModel();
	            };
	
	            class_1.prototype.getViewOfComponentModel = function (componentModel) {
	              return ecIns.getViewOfComponentModel(componentModel);
	            };
	
	            class_1.prototype.getViewOfSeriesModel = function (seriesModel) {
	              return ecIns.getViewOfSeriesModel(seriesModel);
	            };
	
	            return class_1;
	          }(ExtensionAPI))(ecIns);
	        };
	
	        enableConnect = function (chart) {
	          function updateConnectedChartsStatus(charts, status) {
	            for (var i = 0; i < charts.length; i++) {
	              var otherChart = charts[i];
	              otherChart[CONNECT_STATUS_KEY] = status;
	            }
	          }
	
	          each(eventActionMap, function (actionType, eventType) {
	            chart._messageCenter.on(eventType, function (event) {
	              if (connectedGroups[chart.group] && chart[CONNECT_STATUS_KEY] !== CONNECT_STATUS_PENDING) {
	                if (event && event.escapeConnect) {
	                  return;
	                }
	
	                var action_1 = chart.makeActionFromEvent(event);
	                var otherCharts_1 = [];
	                each(instances$1, function (otherChart) {
	                  if (otherChart !== chart && otherChart.group === chart.group) {
	                    otherCharts_1.push(otherChart);
	                  }
	                });
	                updateConnectedChartsStatus(otherCharts_1, CONNECT_STATUS_PENDING);
	                each(otherCharts_1, function (otherChart) {
	                  if (otherChart[CONNECT_STATUS_KEY] !== CONNECT_STATUS_UPDATING) {
	                    otherChart.dispatchAction(action_1);
	                  }
	                });
	                updateConnectedChartsStatus(otherCharts_1, CONNECT_STATUS_UPDATED);
	              }
	            });
	          });
	        };
	      }();
	
	      return ECharts;
	    }(Eventful);
	
	    var echartsProto = ECharts.prototype;
	    echartsProto.on = createRegisterEventWithLowercaseECharts('on');
	    echartsProto.off = createRegisterEventWithLowercaseECharts('off');
	    /**
	     * @deprecated
	     */
	    // @ts-ignore
	
	    echartsProto.one = function (eventName, cb, ctx) {
	      var self = this;
	      deprecateLog('ECharts#one is deprecated.');
	
	      function wrapped() {
	        var args2 = [];
	
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args2[_i] = arguments[_i];
	        }
	
	        cb && cb.apply && cb.apply(this, args2); // @ts-ignore
	
	        self.off(eventName, wrapped);
	      }
	
	      this.on.call(this, eventName, wrapped, ctx);
	    };
	
	    var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
	
	    function disposedWarning(id) {
	      if (true) {
	        warn('Instance ' + id + ' has been disposed');
	      }
	    }
	
	    var actions = {};
	    /**
	     * Map eventType to actionType
	     */
	
	    var eventActionMap = {};
	    var dataProcessorFuncs = [];
	    var optionPreprocessorFuncs = [];
	    var visualFuncs = [];
	    var themeStorage = {};
	    var loadingEffects = {};
	    var instances$1 = {};
	    var connectedGroups = {};
	    var idBase = +new Date() - 0;
	    var groupIdBase = +new Date() - 0;
	    var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
	    /**
	     * @param opts.devicePixelRatio Use window.devicePixelRatio by default
	     * @param opts.renderer Can choose 'canvas' or 'svg' to render the chart.
	     * @param opts.width Use clientWidth of the input `dom` by default.
	     *        Can be 'auto' (the same as null/undefined)
	     * @param opts.height Use clientHeight of the input `dom` by default.
	     *        Can be 'auto' (the same as null/undefined)
	     * @param opts.locale Specify the locale.
	     * @param opts.useDirtyRect Enable dirty rectangle rendering or not.
	     */
	
	    function init$1(dom, theme, opts) {
	      var isClient = !(opts && opts.ssr);
	
	      if (isClient) {
	        if (true) {
	          if (!dom) {
	            throw new Error('Initialize failed: invalid dom.');
	          }
	        }
	
	        var existInstance = getInstanceByDom(dom);
	
	        if (existInstance) {
	          if (true) {
	            warn('There is a chart instance already initialized on the dom.');
	          }
	
	          return existInstance;
	        }
	
	        if (true) {
	          if (isDom(dom) && dom.nodeName.toUpperCase() !== 'CANVAS' && (!dom.clientWidth && (!opts || opts.width == null) || !dom.clientHeight && (!opts || opts.height == null))) {
	            warn('Can\'t get DOM width or height. Please check ' + 'dom.clientWidth and dom.clientHeight. They should not be 0.' + 'For example, you may need to call this in the callback ' + 'of window.onload.');
	          }
	        }
	      }
	
	      var chart = new ECharts(dom, theme, opts);
	      chart.id = 'ec_' + idBase++;
	      instances$1[chart.id] = chart;
	      isClient && setAttribute(dom, DOM_ATTRIBUTE_KEY, chart.id);
	      enableConnect(chart);
	      lifecycle.trigger('afterinit', chart);
	      return chart;
	    }
	    /**
	     * @usage
	     * (A)
	     * ```js
	     * let chart1 = echarts.init(dom1);
	     * let chart2 = echarts.init(dom2);
	     * chart1.group = 'xxx';
	     * chart2.group = 'xxx';
	     * echarts.connect('xxx');
	     * ```
	     * (B)
	     * ```js
	     * let chart1 = echarts.init(dom1);
	     * let chart2 = echarts.init(dom2);
	     * echarts.connect('xxx', [chart1, chart2]);
	     * ```
	     */
	
	    function connect(groupId) {
	      // Is array of charts
	      if (isArray(groupId)) {
	        var charts = groupId;
	        groupId = null; // If any chart has group
	
	        each(charts, function (chart) {
	          if (chart.group != null) {
	            groupId = chart.group;
	          }
	        });
	        groupId = groupId || 'g_' + groupIdBase++;
	        each(charts, function (chart) {
	          chart.group = groupId;
	        });
	      }
	
	      connectedGroups[groupId] = true;
	      return groupId;
	    }
	    function disconnect(groupId) {
	      connectedGroups[groupId] = false;
	    }
	    /**
	     * Alias and backward compatibility
	     * @deprecated
	     */
	
	    var disConnect = disconnect;
	    /**
	     * Dispose a chart instance
	     */
	
	    function dispose$1(chart) {
	      if (isString(chart)) {
	        chart = instances$1[chart];
	      } else if (!(chart instanceof ECharts)) {
	        // Try to treat as dom
	        chart = getInstanceByDom(chart);
	      }
	
	      if (chart instanceof ECharts && !chart.isDisposed()) {
	        chart.dispose();
	      }
	    }
	    function getInstanceByDom(dom) {
	      return instances$1[getAttribute(dom, DOM_ATTRIBUTE_KEY)];
	    }
	    function getInstanceById(key) {
	      return instances$1[key];
	    }
	    /**
	     * Register theme
	     */
	
	    function registerTheme(name, theme) {
	      themeStorage[name] = theme;
	    }
	    /**
	     * Register option preprocessor
	     */
	
	    function registerPreprocessor(preprocessorFunc) {
	      if (indexOf(optionPreprocessorFuncs, preprocessorFunc) < 0) {
	        optionPreprocessorFuncs.push(preprocessorFunc);
	      }
	    }
	    function registerProcessor(priority, processor) {
	      normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_DEFAULT);
	    }
	    /**
	     * Register postIniter
	     * @param {Function} postInitFunc
	     */
	
	    function registerPostInit(postInitFunc) {
	      registerUpdateLifecycle('afterinit', postInitFunc);
	    }
	    /**
	     * Register postUpdater
	     * @param {Function} postUpdateFunc
	     */
	
	    function registerPostUpdate(postUpdateFunc) {
	      registerUpdateLifecycle('afterupdate', postUpdateFunc);
	    }
	    function registerUpdateLifecycle(name, cb) {
	      lifecycle.on(name, cb);
	    }
	    function registerAction(actionInfo, eventName, action) {
	      if (isFunction(eventName)) {
	        action = eventName;
	        eventName = '';
	      }
	
	      var actionType = isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
	        event: eventName
	      }][0]; // Event name is all lowercase
	
	      actionInfo.event = (actionInfo.event || actionType).toLowerCase();
	      eventName = actionInfo.event;
	
	      if (eventActionMap[eventName]) {
	        // Already registered.
	        return;
	      } // Validate action type and event name.
	
	
	      assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));
	
	      if (!actions[actionType]) {
	        actions[actionType] = {
	          action: action,
	          actionInfo: actionInfo
	        };
	      }
	
	      eventActionMap[eventName] = actionType;
	    }
	    function registerCoordinateSystem(type, coordSysCreator) {
	      CoordinateSystemManager.register(type, coordSysCreator);
	    }
	    /**
	     * Get dimensions of specified coordinate system.
	     * @param {string} type
	     * @return {Array.<string|Object>}
	     */
	
	    function getCoordinateSystemDimensions(type) {
	      var coordSysCreator = CoordinateSystemManager.get(type);
	
	      if (coordSysCreator) {
	        return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
	      }
	    }
	
	    function registerLayout(priority, layoutTask) {
	      normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
	    }
	
	    function registerVisual(priority, visualTask) {
	      normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
	    }
	    var registeredTasks = [];
	
	    function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
	      if (isFunction(priority) || isObject(priority)) {
	        fn = priority;
	        priority = defaultPriority;
	      }
	
	      if (true) {
	        if (isNaN(priority) || priority == null) {
	          throw new Error('Illegal priority');
	        } // Check duplicate
	
	
	        each(targetList, function (wrap) {
	          assert(wrap.__raw !== fn);
	        });
	      } // Already registered
	
	
	      if (indexOf(registeredTasks, fn) >= 0) {
	        return;
	      }
	
	      registeredTasks.push(fn);
	      var stageHandler = Scheduler.wrapStageHandler(fn, visualType);
	      stageHandler.__prio = priority;
	      stageHandler.__raw = fn;
	      targetList.push(stageHandler);
	    }
	
	    function registerLoading(name, loadingFx) {
	      loadingEffects[name] = loadingFx;
	    }
	    /**
	     * ZRender need a canvas context to do measureText.
	     * But in node environment canvas may be created by node-canvas.
	     * So we need to specify how to create a canvas instead of using document.createElement('canvas')
	     *
	     *
	     * @deprecated use setPlatformAPI({ createCanvas }) instead.
	     *
	     * @example
	     *     let Canvas = require('canvas');
	     *     let echarts = require('echarts');
	     *     echarts.setCanvasCreator(function () {
	     *         // Small size is enough.
	     *         return new Canvas(32, 32);
	     *     });
	     */
	
	    function setCanvasCreator(creator) {
	      if (true) {
	        deprecateLog('setCanvasCreator is deprecated. Use setPlatformAPI({ createCanvas }) instead.');
	      }
	
	      setPlatformAPI({
	        createCanvas: creator
	      });
	    }
	    /**
	     * The parameters and usage: see `geoSourceManager.registerMap`.
	     * Compatible with previous `echarts.registerMap`.
	     */
	
	    function registerMap(mapName, geoJson, specialAreas) {
	      var registerMap = getImpl('registerMap');
	      registerMap && registerMap(mapName, geoJson, specialAreas);
	    }
	    function getMap(mapName) {
	      var getMap = getImpl('getMap');
	      return getMap && getMap(mapName);
	    }
	    var registerTransform = registerExternalTransform;
	    /**
	     * Globa dispatchAction to a specified chart instance.
	     */
	    // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
	    //     if (!payload || !payload.chartId) {
	    //         // Must have chartId to find chart
	    //         return;
	    //     }
	    //     const chart = instances[payload.chartId];
	    //     if (chart) {
	    //         chart.dispatchAction(payload, opt);
	    //     }
	    // }
	    // Builtin global visual
	
	    registerVisual(PRIORITY_VISUAL_GLOBAL, seriesStyleTask);
	    registerVisual(PRIORITY_VISUAL_CHART_DATA_CUSTOM, dataStyleTask);
	    registerVisual(PRIORITY_VISUAL_CHART_DATA_CUSTOM, dataColorPaletteTask);
	    registerVisual(PRIORITY_VISUAL_GLOBAL, seriesSymbolTask);
	    registerVisual(PRIORITY_VISUAL_CHART_DATA_CUSTOM, dataSymbolTask);
	    registerVisual(PRIORITY_VISUAL_DECAL, decalVisual);
	    registerPreprocessor(globalBackwardCompat);
	    registerProcessor(PRIORITY_PROCESSOR_DATASTACK, dataStack);
	    registerLoading('default', defaultLoading); // Default actions
	
	    registerAction({
	      type: HIGHLIGHT_ACTION_TYPE,
	      event: HIGHLIGHT_ACTION_TYPE,
	      update: HIGHLIGHT_ACTION_TYPE
	    }, noop);
	    registerAction({
	      type: DOWNPLAY_ACTION_TYPE,
	      event: DOWNPLAY_ACTION_TYPE,
	      update: DOWNPLAY_ACTION_TYPE
	    }, noop);
	    registerAction({
	      type: SELECT_ACTION_TYPE,
	      event: SELECT_ACTION_TYPE,
	      update: SELECT_ACTION_TYPE
	    }, noop);
	    registerAction({
	      type: UNSELECT_ACTION_TYPE,
	      event: UNSELECT_ACTION_TYPE,
	      update: UNSELECT_ACTION_TYPE
	    }, noop);
	    registerAction({
	      type: TOGGLE_SELECT_ACTION_TYPE,
	      event: TOGGLE_SELECT_ACTION_TYPE,
	      update: TOGGLE_SELECT_ACTION_TYPE
	    }, noop); // Default theme
	
	    registerTheme('light', lightTheme);
	    registerTheme('dark', theme); // For backward compatibility, where the namespace `dataTool` will
	    // be mounted on `echarts` is the extension `dataTool` is imported.
	
	    var dataTool = {};
	
	    var extensions = [];
	    var extensionRegisters = {
	      registerPreprocessor: registerPreprocessor,
	      registerProcessor: registerProcessor,
	      registerPostInit: registerPostInit,
	      registerPostUpdate: registerPostUpdate,
	      registerUpdateLifecycle: registerUpdateLifecycle,
	      registerAction: registerAction,
	      registerCoordinateSystem: registerCoordinateSystem,
	      registerLayout: registerLayout,
	      registerVisual: registerVisual,
	      registerTransform: registerTransform,
	      registerLoading: registerLoading,
	      registerMap: registerMap,
	      registerImpl: registerImpl,
	      PRIORITY: PRIORITY,
	      ComponentModel: ComponentModel,
	      ComponentView: ComponentView,
	      SeriesModel: SeriesModel,
	      ChartView: ChartView,
	      // TODO Use ComponentModel and SeriesModel instead of Constructor
	      registerComponentModel: function (ComponentModelClass) {
	        ComponentModel.registerClass(ComponentModelClass);
	      },
	      registerComponentView: function (ComponentViewClass) {
	        ComponentView.registerClass(ComponentViewClass);
	      },
	      registerSeriesModel: function (SeriesModelClass) {
	        SeriesModel.registerClass(SeriesModelClass);
	      },
	      registerChartView: function (ChartViewClass) {
	        ChartView.registerClass(ChartViewClass);
	      },
	      registerSubTypeDefaulter: function (componentType, defaulter) {
	        ComponentModel.registerSubTypeDefaulter(componentType, defaulter);
	      },
	      registerPainter: function (painterType, PainterCtor) {
	        registerPainter(painterType, PainterCtor);
	      }
	    };
	    function use(ext) {
	      if (isArray(ext)) {
	        // use([ChartLine, ChartBar]);
	        each(ext, function (singleExt) {
	          use(singleExt);
	        });
	        return;
	      }
	
	      if (indexOf(extensions, ext) >= 0) {
	        return;
	      }
	
	      extensions.push(ext);
	
	      if (isFunction(ext)) {
	        ext = {
	          install: ext
	        };
	      }
	
	      ext.install(extensionRegisters);
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
	      return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
	    }
	
	    function defaultKeyGetter(item) {
	      return item;
	    }
	
	    var DataDiffer =
	    /** @class */
	    function () {
	      /**
	       * @param context Can be visited by this.context in callback.
	       */
	      function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
	      diffMode) {
	        this._old = oldArr;
	        this._new = newArr;
	        this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
	        this._newKeyGetter = newKeyGetter || defaultKeyGetter; // Visible in callback via `this.context`;
	
	        this.context = context;
	        this._diffModeMultiple = diffMode === 'multiple';
	      }
	      /**
	       * Callback function when add a data
	       */
	
	
	      DataDiffer.prototype.add = function (func) {
	        this._add = func;
	        return this;
	      };
	      /**
	       * Callback function when update a data
	       */
	
	
	      DataDiffer.prototype.update = function (func) {
	        this._update = func;
	        return this;
	      };
	      /**
	       * Callback function when update a data and only work in `cbMode: 'byKey'`.
	       */
	
	
	      DataDiffer.prototype.updateManyToOne = function (func) {
	        this._updateManyToOne = func;
	        return this;
	      };
	      /**
	       * Callback function when update a data and only work in `cbMode: 'byKey'`.
	       */
	
	
	      DataDiffer.prototype.updateOneToMany = function (func) {
	        this._updateOneToMany = func;
	        return this;
	      };
	      /**
	       * Callback function when update a data and only work in `cbMode: 'byKey'`.
	       */
	
	
	      DataDiffer.prototype.updateManyToMany = function (func) {
	        this._updateManyToMany = func;
	        return this;
	      };
	      /**
	       * Callback function when remove a data
	       */
	
	
	      DataDiffer.prototype.remove = function (func) {
	        this._remove = func;
	        return this;
	      };
	
	      DataDiffer.prototype.execute = function () {
	        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
	      };
	
	      DataDiffer.prototype._executeOneToOne = function () {
	        var oldArr = this._old;
	        var newArr = this._new;
	        var newDataIndexMap = {};
	        var oldDataKeyArr = new Array(oldArr.length);
	        var newDataKeyArr = new Array(newArr.length);
	
	        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
	
	        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
	
	        for (var i = 0; i < oldArr.length; i++) {
	          var oldKey = oldDataKeyArr[i];
	          var newIdxMapVal = newDataIndexMap[oldKey];
	          var newIdxMapValLen = dataIndexMapValueLength(newIdxMapVal); // idx can never be empty array here. see 'set null' logic below.
	
	          if (newIdxMapValLen > 1) {
	            // Consider there is duplicate key (for example, use dataItem.name as key).
	            // We should make sure every item in newArr and oldArr can be visited.
	            var newIdx = newIdxMapVal.shift();
	
	            if (newIdxMapVal.length === 1) {
	              newDataIndexMap[oldKey] = newIdxMapVal[0];
	            }
	
	            this._update && this._update(newIdx, i);
	          } else if (newIdxMapValLen === 1) {
	            newDataIndexMap[oldKey] = null;
	            this._update && this._update(newIdxMapVal, i);
	          } else {
	            this._remove && this._remove(i);
	          }
	        }
	
	        this._performRestAdd(newDataKeyArr, newDataIndexMap);
	      };
	      /**
	       * For example, consider the case:
	       * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
	       * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
	       * Where:
	       *     o0, o1, n0 has key 'a' (many to one)
	       *     o5, n4, n5, n6 has key 'b' (one to many)
	       *     o2, n1 has key 'c' (one to one)
	       *     n2, n3 has key 'd' (add)
	       *     o3, o4 has key 'e' (remove)
	       *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
	       * Then:
	       *     (The order of the following directives are not ensured.)
	       *     this._updateManyToOne(n0, [o0, o1]);
	       *     this._updateOneToMany([n4, n5, n6], o5);
	       *     this._update(n1, o2);
	       *     this._remove(o3);
	       *     this._remove(o4);
	       *     this._remove(o6);
	       *     this._remove(o7);
	       *     this._add(n2);
	       *     this._add(n3);
	       *     this._add(n7);
	       *     this._add(n8);
	       */
	
	
	      DataDiffer.prototype._executeMultiple = function () {
	        var oldArr = this._old;
	        var newArr = this._new;
	        var oldDataIndexMap = {};
	        var newDataIndexMap = {};
	        var oldDataKeyArr = [];
	        var newDataKeyArr = [];
	
	        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
	
	        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
	
	        for (var i = 0; i < oldDataKeyArr.length; i++) {
	          var oldKey = oldDataKeyArr[i];
	          var oldIdxMapVal = oldDataIndexMap[oldKey];
	          var newIdxMapVal = newDataIndexMap[oldKey];
	          var oldIdxMapValLen = dataIndexMapValueLength(oldIdxMapVal);
	          var newIdxMapValLen = dataIndexMapValueLength(newIdxMapVal);
	
	          if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
	            this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
	            newDataIndexMap[oldKey] = null;
	          } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
	            this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
	            newDataIndexMap[oldKey] = null;
	          } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
	            this._update && this._update(newIdxMapVal, oldIdxMapVal);
	            newDataIndexMap[oldKey] = null;
	          } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
	            this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
	            newDataIndexMap[oldKey] = null;
	          } else if (oldIdxMapValLen > 1) {
	            for (var i_1 = 0; i_1 < oldIdxMapValLen; i_1++) {
	              this._remove && this._remove(oldIdxMapVal[i_1]);
	            }
	          } else {
	            this._remove && this._remove(oldIdxMapVal);
	          }
	        }
	
	        this._performRestAdd(newDataKeyArr, newDataIndexMap);
	      };
	
	      DataDiffer.prototype._performRestAdd = function (newDataKeyArr, newDataIndexMap) {
	        for (var i = 0; i < newDataKeyArr.length; i++) {
	          var newKey = newDataKeyArr[i];
	          var newIdxMapVal = newDataIndexMap[newKey];
	          var idxMapValLen = dataIndexMapValueLength(newIdxMapVal);
	
	          if (idxMapValLen > 1) {
	            for (var j = 0; j < idxMapValLen; j++) {
	              this._add && this._add(newIdxMapVal[j]);
	            }
	          } else if (idxMapValLen === 1) {
	            this._add && this._add(newIdxMapVal);
	          } // Support both `newDataKeyArr` are duplication removed or not removed.
	
	
	          newDataIndexMap[newKey] = null;
	        }
	      };
	
	      DataDiffer.prototype._initIndexMap = function (arr, // Can be null.
	      map, // In 'byKey', the output `keyArr` is duplication removed.
	      // In 'byIndex', the output `keyArr` is not duplication removed and
	      //     its indices are accurately corresponding to `arr`.
	      keyArr, keyGetterName) {
	        var cbModeMultiple = this._diffModeMultiple;
	
	        for (var i = 0; i < arr.length; i++) {
	          // Add prefix to avoid conflict with Object.prototype.
	          var key = '_ec_' + this[keyGetterName](arr[i], i);
	
	          if (!cbModeMultiple) {
	            keyArr[i] = key;
	          }
	
	          if (!map) {
	            continue;
	          }
	
	          var idxMapVal = map[key];
	          var idxMapValLen = dataIndexMapValueLength(idxMapVal);
	
	          if (idxMapValLen === 0) {
	            // Simple optimize: in most cases, one index has one key,
	            // do not need array.
	            map[key] = i;
	
	            if (cbModeMultiple) {
	              keyArr.push(key);
	            }
	          } else if (idxMapValLen === 1) {
	            map[key] = [idxMapVal, i];
	          } else {
	            idxMapVal.push(i);
	          }
	        }
	      };
	
	      return DataDiffer;
	    }();
	
	    var DimensionUserOuput =
	    /** @class */
	    function () {
	      function DimensionUserOuput(encode, dimRequest) {
	        this._encode = encode;
	        this._schema = dimRequest;
	      }
	
	      DimensionUserOuput.prototype.get = function () {
	        return {
	          // Do not generate full dimension name until fist used.
	          fullDimensions: this._getFullDimensionNames(),
	          encode: this._encode
	        };
	      };
	      /**
	       * Get all data store dimension names.
	       * Theoretically a series data store is defined both by series and used dataset (if any).
	       * If some dimensions are omitted for performance reason in `this.dimensions`,
	       * the dimension name may not be auto-generated if user does not specify a dimension name.
	       * In this case, the dimension name is `null`/`undefined`.
	       */
	
	
	      DimensionUserOuput.prototype._getFullDimensionNames = function () {
	        if (!this._cachedDimNames) {
	          this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
	        }
	
	        return this._cachedDimNames;
	      };
	
	      return DimensionUserOuput;
	    }();
	    function summarizeDimensions(data, schema) {
	      var summary = {};
	      var encode = summary.encode = {};
	      var notExtraCoordDimMap = createHashMap();
	      var defaultedLabel = [];
	      var defaultedTooltip = [];
	      var userOutputEncode = {};
	      each(data.dimensions, function (dimName) {
	        var dimItem = data.getDimensionInfo(dimName);
	        var coordDim = dimItem.coordDim;
	
	        if (coordDim) {
	          if (true) {
	            assert(VISUAL_DIMENSIONS.get(coordDim) == null);
	          }
	
	          var coordDimIndex = dimItem.coordDimIndex;
	          getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
	
	          if (!dimItem.isExtraCoord) {
	            notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
	            // because when dataset is used, it is hard to guess which dimension
	            // can be value dimension. If both show x, y on label is not look good,
	            // and conventionally y axis is focused more.
	
	            if (mayLabelDimType(dimItem.type)) {
	              defaultedLabel[0] = dimName;
	            } // User output encode do not contain generated coords.
	            // And it only has index. User can use index to retrieve value from the raw item array.
	
	
	            getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
	          }
	
	          if (dimItem.defaultTooltip) {
	            defaultedTooltip.push(dimName);
	          }
	        }
	
	        VISUAL_DIMENSIONS.each(function (v, otherDim) {
	          var encodeArr = getOrCreateEncodeArr(encode, otherDim);
	          var dimIndex = dimItem.otherDims[otherDim];
	
	          if (dimIndex != null && dimIndex !== false) {
	            encodeArr[dimIndex] = dimItem.name;
	          }
	        });
	      });
	      var dataDimsOnCoord = [];
	      var encodeFirstDimNotExtra = {};
	      notExtraCoordDimMap.each(function (v, coordDim) {
	        var dimArr = encode[coordDim];
	        encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
	        // dim canot on more than one coordDim.
	
	        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
	      });
	      summary.dataDimsOnCoord = dataDimsOnCoord;
	      summary.dataDimIndicesOnCoord = map(dataDimsOnCoord, function (dimName) {
	        return data.getDimensionInfo(dimName).storeDimIndex;
	      });
	      summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
	      var encodeLabel = encode.label; // FIXME `encode.label` is not recommended, because formatter cannot be set
	      // in this way. Use label.formatter instead. Maybe remove this approach someday.
	
	      if (encodeLabel && encodeLabel.length) {
	        defaultedLabel = encodeLabel.slice();
	      }
	
	      var encodeTooltip = encode.tooltip;
	
	      if (encodeTooltip && encodeTooltip.length) {
	        defaultedTooltip = encodeTooltip.slice();
	      } else if (!defaultedTooltip.length) {
	        defaultedTooltip = defaultedLabel.slice();
	      }
	
	      encode.defaultedLabel = defaultedLabel;
	      encode.defaultedTooltip = defaultedTooltip;
	      summary.userOutput = new DimensionUserOuput(userOutputEncode, schema);
	      return summary;
	    }
	
	    function getOrCreateEncodeArr(encode, dim) {
	      if (!encode.hasOwnProperty(dim)) {
	        encode[dim] = [];
	      }
	
	      return encode[dim];
	    } // FIXME:TS should be type `AxisType`
	
	
	    function getDimensionTypeByAxis(axisType) {
	      return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
	    }
	
	    function mayLabelDimType(dimType) {
	      // In most cases, ordinal and time do not suitable for label.
	      // Ordinal info can be displayed on axis. Time is too long.
	      return !(dimType === 'ordinal' || dimType === 'time');
	    } // function findTheLastDimMayLabel(data) {
	    //     // Get last value dim
	    //     let dimensions = data.dimensions.slice();
	    //     let valueType;
	    //     let valueDim;
	    //     while (dimensions.length && (
	    //         valueDim = dimensions.pop(),
	    //         valueType = data.getDimensionInfo(valueDim).type,
	    //         valueType === 'ordinal' || valueType === 'time'
	    //     )) {} // jshint ignore:line
	    //     return valueDim;
	    // }
	
	    var SeriesDimensionDefine =
	    /** @class */
	    function () {
	      /**
	       * @param opt All of the fields will be shallow copied.
	       */
	      function SeriesDimensionDefine(opt) {
	        /**
	         * The format of `otherDims` is:
	         * ```js
	         * {
	         *     tooltip?: number
	         *     label?: number
	         *     itemName?: number
	         *     seriesName?: number
	         * }
	         * ```
	         *
	         * A `series.encode` can specified these fields:
	         * ```js
	         * encode: {
	         *     // "3, 1, 5" is the index of data dimension.
	         *     tooltip: [3, 1, 5],
	         *     label: [0, 3],
	         *     ...
	         * }
	         * ```
	         * `otherDims` is the parse result of the `series.encode` above, like:
	         * ```js
	         * // Suppose the index of this data dimension is `3`.
	         * this.otherDims = {
	         *     // `3` is at the index `0` of the `encode.tooltip`
	         *     tooltip: 0,
	         *     // `3` is at the index `1` of the `encode.label`
	         *     label: 1
	         * };
	         * ```
	         *
	         * This prop should never be `null`/`undefined` after initialized.
	         */
	        this.otherDims = {};
	
	        if (opt != null) {
	          extend(this, opt);
	        }
	      }
	
	      return SeriesDimensionDefine;
	    }();
	
	    var inner$4 = makeInner();
	    var dimTypeShort = {
	      float: 'f',
	      int: 'i',
	      ordinal: 'o',
	      number: 'n',
	      time: 't'
	    };
	    /**
	     * Represents the dimension requirement of a series.
	     *
	     * NOTICE:
	     * When there are too many dimensions in dataset and many series, only the used dimensions
	     * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
	     * But users may query data by other unused dimension names.
	     * In this case, users can only query data if and only if they have defined dimension names
	     * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
	     * `source` dimensions.
	     */
	
	    var SeriesDataSchema =
	    /** @class */
	    function () {
	      function SeriesDataSchema(opt) {
	        this.dimensions = opt.dimensions;
	        this._dimOmitted = opt.dimensionOmitted;
	        this.source = opt.source;
	        this._fullDimCount = opt.fullDimensionCount;
	
	        this._updateDimOmitted(opt.dimensionOmitted);
	      }
	
	      SeriesDataSchema.prototype.isDimensionOmitted = function () {
	        return this._dimOmitted;
	      };
	
	      SeriesDataSchema.prototype._updateDimOmitted = function (dimensionOmitted) {
	        this._dimOmitted = dimensionOmitted;
	
	        if (!dimensionOmitted) {
	          return;
	        }
	
	        if (!this._dimNameMap) {
	          this._dimNameMap = ensureSourceDimNameMap(this.source);
	        }
	      };
	      /**
	       * @caution Can only be used when `dimensionOmitted: true`.
	       *
	       * Get index by user defined dimension name (i.e., not internal generate name).
	       * That is, get index from `dimensionsDefine`.
	       * If no `dimensionsDefine`, or no name get, return -1.
	       */
	
	
	      SeriesDataSchema.prototype.getSourceDimensionIndex = function (dimName) {
	        return retrieve2(this._dimNameMap.get(dimName), -1);
	      };
	      /**
	       * @caution Can only be used when `dimensionOmitted: true`.
	       *
	       * Notice: may return `null`/`undefined` if user not specify dimension names.
	       */
	
	
	      SeriesDataSchema.prototype.getSourceDimension = function (dimIndex) {
	        var dimensionsDefine = this.source.dimensionsDefine;
	
	        if (dimensionsDefine) {
	          return dimensionsDefine[dimIndex];
	        }
	      };
	
	      SeriesDataSchema.prototype.makeStoreSchema = function () {
	        var dimCount = this._fullDimCount;
	        var willRetrieveDataByName = shouldRetrieveDataByName(this.source);
	        var makeHashStrict = !shouldOmitUnusedDimensions(dimCount); // If source don't have dimensions or series don't omit unsed dimensions.
	        // Generate from seriesDimList directly
	
	        var dimHash = '';
	        var dims = [];
	
	        for (var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++) {
	          var property = void 0;
	          var type = void 0;
	          var ordinalMeta = void 0;
	          var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
	
	          if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
	            property = willRetrieveDataByName ? seriesDimDef.name : null;
	            type = seriesDimDef.type;
	            ordinalMeta = seriesDimDef.ordinalMeta;
	            seriesDimIdx++;
	          } else {
	            var sourceDimDef = this.getSourceDimension(fullDimIdx);
	
	            if (sourceDimDef) {
	              property = willRetrieveDataByName ? sourceDimDef.name : null;
	              type = sourceDimDef.type;
	            }
	          }
	
	          dims.push({
	            property: property,
	            type: type,
	            ordinalMeta: ordinalMeta
	          }); // If retrieving data by index,
	          //   use <index, type, ordinalMeta> to determine whether data can be shared.
	          //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
	          //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
	          // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
	          //   use <property, type, ordinalMeta> in hash.
	
	          if (willRetrieveDataByName && property != null // For data stack, we have make sure each series has its own dim on this store.
	          // So we do not add property to hash to make sure they can share this store.
	          && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) {
	            dimHash += makeHashStrict // Use escape character '`' in case that property name contains '$'.
	            ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') // For better performance, when there are large dimensions, tolerant this defects that hardly meet.
	            : property;
	          }
	
	          dimHash += '$';
	          dimHash += dimTypeShort[type] || 'f';
	
	          if (ordinalMeta) {
	            dimHash += ordinalMeta.uid;
	          }
	
	          dimHash += '$';
	        } // Source from endpoint(usually series) will be read differently
	        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
	        // So we use this three props as key.
	
	
	        var source = this.source;
	        var hash = [source.seriesLayoutBy, source.startIndex, dimHash].join('$$');
	        return {
	          dimensions: dims,
	          hash: hash
	        };
	      };
	
	      SeriesDataSchema.prototype.makeOutputDimensionNames = function () {
	        var result = [];
	
	        for (var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++) {
	          var name_1 = void 0;
	          var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
	
	          if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
	            if (!seriesDimDef.isCalculationCoord) {
	              name_1 = seriesDimDef.name;
	            }
	
	            seriesDimIdx++;
	          } else {
	            var sourceDimDef = this.getSourceDimension(fullDimIdx);
	
	            if (sourceDimDef) {
	              name_1 = sourceDimDef.name;
	            }
	          }
	
	          result.push(name_1);
	        }
	
	        return result;
	      };
	
	      SeriesDataSchema.prototype.appendCalculationDimension = function (dimDef) {
	        this.dimensions.push(dimDef);
	        dimDef.isCalculationCoord = true;
	        this._fullDimCount++; // If append dimension on a data store, consider the store
	        // might be shared by different series, series dimensions not
	        // really map to store dimensions.
	
	        this._updateDimOmitted(true);
	      };
	
	      return SeriesDataSchema;
	    }();
	    function isSeriesDataSchema(schema) {
	      return schema instanceof SeriesDataSchema;
	    }
	    function createDimNameMap(dimsDef) {
	      var dataDimNameMap = createHashMap();
	
	      for (var i = 0; i < (dimsDef || []).length; i++) {
	        var dimDefItemRaw = dimsDef[i];
	        var userDimName = isObject(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
	
	        if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
	          dataDimNameMap.set(userDimName, i);
	        }
	      }
	
	      return dataDimNameMap;
	    }
	    function ensureSourceDimNameMap(source) {
	      var innerSource = inner$4(source);
	      return innerSource.dimNameMap || (innerSource.dimNameMap = createDimNameMap(source.dimensionsDefine));
	    }
	    function shouldOmitUnusedDimensions(dimCount) {
	      return dimCount > 30;
	    }
	
	    var isObject$2 = isObject;
	    var map$1 = map;
	    var CtorInt32Array$1 = typeof Int32Array === 'undefined' ? Array : Int32Array; // Use prefix to avoid index to be the same as otherIdList[idx],
	    // which will cause weird update animation.
	
	    var ID_PREFIX = 'e\0\0';
	    var INDEX_NOT_FOUND = -1; // type SeriesDimensionIndex = DimensionIndex;
	
	    var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_dimSummary', 'userOutput', '_rawData', '_dimValueGetter', '_nameDimIdx', '_idDimIdx', '_nameRepeatCount'];
	    var CLONE_PROPERTIES = ['_approximateExtent']; // -----------------------------
	    // Internal method declarations:
	    // -----------------------------
	
	    var prepareInvertedIndex;
	    var getId;
	    var getIdNameFromStore;
	    var normalizeDimensions;
	    var transferProperties;
	    var cloneListForMapAndSample;
	    var makeIdFromName;
	
	    var SeriesData =
	    /** @class */
	    function () {
	      /**
	       * @param dimensionsInput.dimensions
	       *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
	       *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
	       */
	      function SeriesData(dimensionsInput, hostModel) {
	        this.type = 'list';
	        this._dimOmitted = false;
	        this._nameList = [];
	        this._idList = []; // Models of data option is stored sparse for optimizing memory cost
	        // Never used yet (not used yet).
	        // private _optionModels: Model[] = [];
	        // Global visual properties after visual coding
	
	        this._visual = {}; // Global layout properties.
	
	        this._layout = {}; // Item visual properties after visual coding
	
	        this._itemVisuals = []; // Item layout properties after layout
	
	        this._itemLayouts = []; // Graphic elements
	
	        this._graphicEls = []; // key: dim, value: extent
	
	        this._approximateExtent = {};
	        this._calculationInfo = {}; // Having detected that there is data item is non primitive type
	        // (in type `OptionDataItemObject`).
	        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
	        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
	
	        this.hasItemOption = false; // Methods that create a new list based on this list should be listed here.
	        // Notice that those method should `RETURN` the new list.
	
	        this.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'lttbDownSample', 'map']; // Methods that change indices of this list should be listed here.
	
	        this.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
	        this.DOWNSAMPLE_METHODS = ['downSample', 'lttbDownSample'];
	        var dimensions;
	        var assignStoreDimIdx = false;
	
	        if (isSeriesDataSchema(dimensionsInput)) {
	          dimensions = dimensionsInput.dimensions;
	          this._dimOmitted = dimensionsInput.isDimensionOmitted();
	          this._schema = dimensionsInput;
	        } else {
	          assignStoreDimIdx = true;
	          dimensions = dimensionsInput;
	        }
	
	        dimensions = dimensions || ['x', 'y'];
	        var dimensionInfos = {};
	        var dimensionNames = [];
	        var invertedIndicesMap = {};
	        var needsHasOwn = false;
	        var emptyObj = {};
	
	        for (var i = 0; i < dimensions.length; i++) {
	          // Use the original dimensions[i], where other flag props may exists.
	          var dimInfoInput = dimensions[i];
	          var dimensionInfo = isString(dimInfoInput) ? new SeriesDimensionDefine({
	            name: dimInfoInput
	          }) : !(dimInfoInput instanceof SeriesDimensionDefine) ? new SeriesDimensionDefine(dimInfoInput) : dimInfoInput;
	          var dimensionName = dimensionInfo.name;
	          dimensionInfo.type = dimensionInfo.type || 'float';
	
	          if (!dimensionInfo.coordDim) {
	            dimensionInfo.coordDim = dimensionName;
	            dimensionInfo.coordDimIndex = 0;
	          }
	
	          var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
	          dimensionNames.push(dimensionName);
	          dimensionInfos[dimensionName] = dimensionInfo;
	
	          if (emptyObj[dimensionName] != null) {
	            needsHasOwn = true;
	          }
	
	          if (dimensionInfo.createInvertedIndices) {
	            invertedIndicesMap[dimensionName] = [];
	          }
	
	          if (otherDims.itemName === 0) {
	            this._nameDimIdx = i;
	          }
	
	          if (otherDims.itemId === 0) {
	            this._idDimIdx = i;
	          }
	
	          if (true) {
	            assert(assignStoreDimIdx || dimensionInfo.storeDimIndex >= 0);
	          }
	
	          if (assignStoreDimIdx) {
	            dimensionInfo.storeDimIndex = i;
	          }
	        }
	
	        this.dimensions = dimensionNames;
	        this._dimInfos = dimensionInfos;
	
	        this._initGetDimensionInfo(needsHasOwn);
	
	        this.hostModel = hostModel;
	        this._invertedIndicesMap = invertedIndicesMap;
	
	        if (this._dimOmitted) {
	          var dimIdxToName_1 = this._dimIdxToName = createHashMap();
	          each(dimensionNames, function (dimName) {
	            dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
	          });
	        }
	      }
	      /**
	       *
	       * Get concrete dimension name by dimension name or dimension index.
	       * If input a dimension name, do not validate whether the dimension name exits.
	       *
	       * @caution
	       * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
	       * Because only those dimensions will have auto-generated dimension names if not
	       * have a user-specified name, and other dimensions will get a return of null/undefined.
	       *
	       * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
	       * ```js
	       * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
	       * ```
	       *
	       * @return Concrete dim name.
	       */
	
	
	      SeriesData.prototype.getDimension = function (dim) {
	        var dimIdx = this._recognizeDimIndex(dim);
	
	        if (dimIdx == null) {
	          return dim;
	        }
	
	        dimIdx = dim;
	
	        if (!this._dimOmitted) {
	          return this.dimensions[dimIdx];
	        } // Retrieve from series dimension definition because it probably contains
	        // generated dimension name (like 'x', 'y').
	
	
	        var dimName = this._dimIdxToName.get(dimIdx);
	
	        if (dimName != null) {
	          return dimName;
	        }
	
	        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
	
	        if (sourceDimDef) {
	          return sourceDimDef.name;
	        }
	      };
	      /**
	       * Get dimension index in data store. Return -1 if not found.
	       * Can be used to index value from getRawValue.
	       */
	
	
	      SeriesData.prototype.getDimensionIndex = function (dim) {
	        var dimIdx = this._recognizeDimIndex(dim);
	
	        if (dimIdx != null) {
	          return dimIdx;
	        }
	
	        if (dim == null) {
	          return -1;
	        }
	
	        var dimInfo = this._getDimInfo(dim);
	
	        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
	      };
	      /**
	       * The meanings of the input parameter `dim`:
	       *
	       * + If dim is a number (e.g., `1`), it means the index of the dimension.
	       *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
	       * + If dim is a number-like string (e.g., `"1"`):
	       *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
	       *        it means that concrete name.
	       *     + If not, it will be converted to a number, which means the index of the dimension.
	       *        (why? because of the backward compatibility. We have been tolerating number-like string in
	       *        dimension setting, although now it seems that it is not a good idea.)
	       *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
	       *     if no dimension name is defined as `"1"`.
	       * + If dim is a not-number-like string, it means the concrete dim name.
	       *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
	       *   or customized in `dimensions` property of option like `"age"`.
	       *
	       * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
	       */
	
	
	      SeriesData.prototype._recognizeDimIndex = function (dim) {
	        if (isNumber(dim) // If being a number-like string but not being defined as a dimension name.
	        || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) {
	          return +dim;
	        }
	      };
	
	      SeriesData.prototype._getStoreDimIndex = function (dim) {
	        var dimIdx = this.getDimensionIndex(dim);
	
	        if (true) {
	          if (dimIdx == null) {
	            throw new Error('Unknown dimension ' + dim);
	          }
	        }
	
	        return dimIdx;
	      };
	      /**
	       * Get type and calculation info of particular dimension
	       * @param dim
	       *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
	       *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
	       */
	
	
	      SeriesData.prototype.getDimensionInfo = function (dim) {
	        // Do not clone, because there may be categories in dimInfo.
	        return this._getDimInfo(this.getDimension(dim));
	      };
	
	      SeriesData.prototype._initGetDimensionInfo = function (needsHasOwn) {
	        var dimensionInfos = this._dimInfos;
	        this._getDimInfo = needsHasOwn ? function (dimName) {
	          return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
	        } : function (dimName) {
	          return dimensionInfos[dimName];
	        };
	      };
	      /**
	       * concrete dimension name list on coord.
	       */
	
	
	      SeriesData.prototype.getDimensionsOnCoord = function () {
	        return this._dimSummary.dataDimsOnCoord.slice();
	      };
	
	      SeriesData.prototype.mapDimension = function (coordDim, idx) {
	        var dimensionsSummary = this._dimSummary;
	
	        if (idx == null) {
	          return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
	        }
	
	        var dims = dimensionsSummary.encode[coordDim];
	        return dims ? dims[idx] : null;
	      };
	
	      SeriesData.prototype.mapDimensionsAll = function (coordDim) {
	        var dimensionsSummary = this._dimSummary;
	        var dims = dimensionsSummary.encode[coordDim];
	        return (dims || []).slice();
	      };
	
	      SeriesData.prototype.getStore = function () {
	        return this._store;
	      };
	      /**
	       * Initialize from data
	       * @param data source or data or data store.
	       * @param nameList The name of a datum is used on data diff and
	       *        default label/tooltip.
	       *        A name can be specified in encode.itemName,
	       *        or dataItem.name (only for series option data),
	       *        or provided in nameList from outside.
	       */
	
	
	      SeriesData.prototype.initData = function (data, nameList, dimValueGetter) {
	        var _this = this;
	
	        var store;
	
	        if (data instanceof DataStore) {
	          store = data;
	        }
	
	        if (!store) {
	          var dimensions = this.dimensions;
	          var provider = isSourceInstance(data) || isArrayLike(data) ? new DefaultDataProvider(data, dimensions.length) : data;
	          store = new DataStore();
	          var dimensionInfos = map$1(dimensions, function (dimName) {
	            return {
	              type: _this._dimInfos[dimName].type,
	              property: dimName
	            };
	          });
	          store.initData(provider, dimensionInfos, dimValueGetter);
	        }
	
	        this._store = store; // Reset
	
	        this._nameList = (nameList || []).slice();
	        this._idList = [];
	        this._nameRepeatCount = {};
	
	        this._doInit(0, store.count()); // Cache summary info for fast visit. See "dimensionHelper".
	        // Needs to be initialized after store is prepared.
	
	
	        this._dimSummary = summarizeDimensions(this, this._schema);
	        this.userOutput = this._dimSummary.userOutput;
	      };
	      /**
	       * Caution: Can be only called on raw data (before `this._indices` created).
	       */
	
	
	      SeriesData.prototype.appendData = function (data) {
	        var range = this._store.appendData(data);
	
	        this._doInit(range[0], range[1]);
	      };
	      /**
	       * Caution: Can be only called on raw data (before `this._indices` created).
	       * This method does not modify `rawData` (`dataProvider`), but only
	       * add values to store.
	       *
	       * The final count will be increased by `Math.max(values.length, names.length)`.
	       *
	       * @param values That is the SourceType: 'arrayRows', like
	       *        [
	       *            [12, 33, 44],
	       *            [NaN, 43, 1],
	       *            ['-', 'asdf', 0]
	       *        ]
	       *        Each item is exactly corresponding to a dimension.
	       */
	
	
	      SeriesData.prototype.appendValues = function (values, names) {
	        var _a = this._store.appendValues(values, names.length),
	            start = _a.start,
	            end = _a.end;
	
	        var shouldMakeIdFromName = this._shouldMakeIdFromName();
	
	        this._updateOrdinalMeta();
	
	        if (names) {
	          for (var idx = start; idx < end; idx++) {
	            var sourceIdx = idx - start;
	            this._nameList[idx] = names[sourceIdx];
	
	            if (shouldMakeIdFromName) {
	              makeIdFromName(this, idx);
	            }
	          }
	        }
	      };
	
	      SeriesData.prototype._updateOrdinalMeta = function () {
	        var store = this._store;
	        var dimensions = this.dimensions;
	
	        for (var i = 0; i < dimensions.length; i++) {
	          var dimInfo = this._dimInfos[dimensions[i]];
	
	          if (dimInfo.ordinalMeta) {
	            store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
	          }
	        }
	      };
	
	      SeriesData.prototype._shouldMakeIdFromName = function () {
	        var provider = this._store.getProvider();
	
	        return this._idDimIdx == null && provider.getSource().sourceFormat !== SOURCE_FORMAT_TYPED_ARRAY && !provider.fillStorage;
	      };
	
	      SeriesData.prototype._doInit = function (start, end) {
	        if (start >= end) {
	          return;
	        }
	
	        var store = this._store;
	        var provider = store.getProvider();
	
	        this._updateOrdinalMeta();
	
	        var nameList = this._nameList;
	        var idList = this._idList;
	        var sourceFormat = provider.getSource().sourceFormat;
	        var isFormatOriginal = sourceFormat === SOURCE_FORMAT_ORIGINAL; // Each data item is value
	        // [1, 2]
	        // 2
	        // Bar chart, line chart which uses category axis
	        // only gives the 'y' value. 'x' value is the indices of category
	        // Use a tempValue to normalize the value to be a (x, y) value
	        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
	        // This kind of ids and names are always stored `_nameList` and `_idList`.
	
	        if (isFormatOriginal && !provider.pure) {
	          var sharedDataItem = [];
	
	          for (var idx = start; idx < end; idx++) {
	            // NOTICE: Try not to write things into dataItem
	            var dataItem = provider.getItem(idx, sharedDataItem);
	
	            if (!this.hasItemOption && isDataItemOption(dataItem)) {
	              this.hasItemOption = true;
	            }
	
	            if (dataItem) {
	              var itemName = dataItem.name;
	
	              if (nameList[idx] == null && itemName != null) {
	                nameList[idx] = convertOptionIdName(itemName, null);
	              }
	
	              var itemId = dataItem.id;
	
	              if (idList[idx] == null && itemId != null) {
	                idList[idx] = convertOptionIdName(itemId, null);
	              }
	            }
	          }
	        }
	
	        if (this._shouldMakeIdFromName()) {
	          for (var idx = start; idx < end; idx++) {
	            makeIdFromName(this, idx);
	          }
	        }
	
	        prepareInvertedIndex(this);
	      };
	      /**
	       * PENDING: In fact currently this function is only used to short-circuit
	       * the calling of `scale.unionExtentFromData` when data have been filtered by modules
	       * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
	       * an axis, but if a "axis related data filter module" is used, the extent of the axis have
	       * been fixed and no need to calling `scale.unionExtentFromData` actually.
	       * But if we add "custom data filter" in future, which is not "axis related", this method may
	       * be still needed.
	       *
	       * Optimize for the scenario that data is filtered by a given extent.
	       * Consider that if data amount is more than hundreds of thousand,
	       * extent calculation will cost more than 10ms and the cache will
	       * be erased because of the filtering.
	       */
	
	
	      SeriesData.prototype.getApproximateExtent = function (dim) {
	        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
	      };
	      /**
	       * Calculate extent on a filtered data might be time consuming.
	       * Approximate extent is only used for: calculate extent of filtered data outside.
	       */
	
	
	      SeriesData.prototype.setApproximateExtent = function (extent, dim) {
	        dim = this.getDimension(dim);
	        this._approximateExtent[dim] = extent.slice();
	      };
	
	      SeriesData.prototype.getCalculationInfo = function (key) {
	        return this._calculationInfo[key];
	      };
	
	      SeriesData.prototype.setCalculationInfo = function (key, value) {
	        isObject$2(key) ? extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
	      };
	      /**
	       * @return Never be null/undefined. `number` will be converted to string. Because:
	       * In most cases, name is used in display, where returning a string is more convenient.
	       * In other cases, name is used in query (see `indexOfName`), where we can keep the
	       * rule that name `2` equals to name `'2'`.
	       */
	
	
	      SeriesData.prototype.getName = function (idx) {
	        var rawIndex = this.getRawIndex(idx);
	        var name = this._nameList[rawIndex];
	
	        if (name == null && this._nameDimIdx != null) {
	          name = getIdNameFromStore(this, this._nameDimIdx, rawIndex);
	        }
	
	        if (name == null) {
	          name = '';
	        }
	
	        return name;
	      };
	
	      SeriesData.prototype._getCategory = function (dimIdx, idx) {
	        var ordinal = this._store.get(dimIdx, idx);
	
	        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
	
	        if (ordinalMeta) {
	          return ordinalMeta.categories[ordinal];
	        }
	
	        return ordinal;
	      };
	      /**
	       * @return Never null/undefined. `number` will be converted to string. Because:
	       * In all cases having encountered at present, id is used in making diff comparison, which
	       * are usually based on hash map. We can keep the rule that the internal id are always string
	       * (treat `2` is the same as `'2'`) to make the related logic simple.
	       */
	
	
	      SeriesData.prototype.getId = function (idx) {
	        return getId(this, this.getRawIndex(idx));
	      };
	
	      SeriesData.prototype.count = function () {
	        return this._store.count();
	      };
	      /**
	       * Get value. Return NaN if idx is out of range.
	       *
	       * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
	       */
	
	
	      SeriesData.prototype.get = function (dim, idx) {
	        var store = this._store;
	        var dimInfo = this._dimInfos[dim];
	
	        if (dimInfo) {
	          return store.get(dimInfo.storeDimIndex, idx);
	        }
	      };
	      /**
	       * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
	       */
	
	
	      SeriesData.prototype.getByRawIndex = function (dim, rawIdx) {
	        var store = this._store;
	        var dimInfo = this._dimInfos[dim];
	
	        if (dimInfo) {
	          return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
	        }
	      };
	
	      SeriesData.prototype.getIndices = function () {
	        return this._store.getIndices();
	      };
	
	      SeriesData.prototype.getDataExtent = function (dim) {
	        return this._store.getDataExtent(this._getStoreDimIndex(dim));
	      };
	
	      SeriesData.prototype.getSum = function (dim) {
	        return this._store.getSum(this._getStoreDimIndex(dim));
	      };
	
	      SeriesData.prototype.getMedian = function (dim) {
	        return this._store.getMedian(this._getStoreDimIndex(dim));
	      };
	
	      SeriesData.prototype.getValues = function (dimensions, idx) {
	        var _this = this;
	
	        var store = this._store;
	        return isArray(dimensions) ? store.getValues(map$1(dimensions, function (dim) {
	          return _this._getStoreDimIndex(dim);
	        }), idx) : store.getValues(dimensions);
	      };
	      /**
	       * If value is NaN. Including '-'
	       * Only check the coord dimensions.
	       */
	
	
	      SeriesData.prototype.hasValue = function (idx) {
	        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
	
	        for (var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++) {
	          // Ordinal type originally can be string or number.
	          // But when an ordinal type is used on coord, it can
	          // not be string but only number. So we can also use isNaN.
	          if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) {
	            return false;
	          }
	        }
	
	        return true;
	      };
	      /**
	       * Retrieve the index with given name
	       */
	
	
	      SeriesData.prototype.indexOfName = function (name) {
	        for (var i = 0, len = this._store.count(); i < len; i++) {
	          if (this.getName(i) === name) {
	            return i;
	          }
	        }
	
	        return -1;
	      };
	
	      SeriesData.prototype.getRawIndex = function (idx) {
	        return this._store.getRawIndex(idx);
	      };
	
	      SeriesData.prototype.indexOfRawIndex = function (rawIndex) {
	        return this._store.indexOfRawIndex(rawIndex);
	      };
	      /**
	       * Only support the dimension which inverted index created.
	       * Do not support other cases until required.
	       * @param dim concrete dim
	       * @param value ordinal index
	       * @return rawIndex
	       */
	
	
	      SeriesData.prototype.rawIndexOf = function (dim, value) {
	        var invertedIndices = dim && this._invertedIndicesMap[dim];
	
	        if (true) {
	          if (!invertedIndices) {
	            throw new Error('Do not supported yet');
	          }
	        }
	
	        var rawIndex = invertedIndices[value];
	
	        if (rawIndex == null || isNaN(rawIndex)) {
	          return INDEX_NOT_FOUND;
	        }
	
	        return rawIndex;
	      };
	      /**
	       * Retrieve the index of nearest value
	       * @param dim
	       * @param value
	       * @param [maxDistance=Infinity]
	       * @return If and only if multiple indices has
	       *         the same value, they are put to the result.
	       */
	
	
	      SeriesData.prototype.indicesOfNearest = function (dim, value, maxDistance) {
	        return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
	      };
	
	      SeriesData.prototype.each = function (dims, cb, ctx) {
	
	        if (isFunction(dims)) {
	          ctx = cb;
	          cb = dims;
	          dims = [];
	        } // ctxCompat just for compat echarts3
	
	
	        var fCtx = ctx || this;
	        var dimIndices = map$1(normalizeDimensions(dims), this._getStoreDimIndex, this);
	
	        this._store.each(dimIndices, fCtx ? bind(cb, fCtx) : cb);
	      };
	
	      SeriesData.prototype.filterSelf = function (dims, cb, ctx) {
	
	        if (isFunction(dims)) {
	          ctx = cb;
	          cb = dims;
	          dims = [];
	        } // ctxCompat just for compat echarts3
	
	
	        var fCtx = ctx || this;
	        var dimIndices = map$1(normalizeDimensions(dims), this._getStoreDimIndex, this);
	        this._store = this._store.filter(dimIndices, fCtx ? bind(cb, fCtx) : cb);
	        return this;
	      };
	      /**
	       * Select data in range. (For optimization of filter)
	       * (Manually inline code, support 5 million data filtering in data zoom.)
	       */
	
	
	      SeriesData.prototype.selectRange = function (range) {
	
	        var _this = this;
	
	        var innerRange = {};
	        var dims = keys(range);
	        each(dims, function (dim) {
	          var dimIdx = _this._getStoreDimIndex(dim);
	
	          innerRange[dimIdx] = range[dim];
	        });
	        this._store = this._store.selectRange(innerRange);
	        return this;
	      };
	      /* eslint-enable max-len */
	
	
	      SeriesData.prototype.mapArray = function (dims, cb, ctx) {
	
	        if (isFunction(dims)) {
	          ctx = cb;
	          cb = dims;
	          dims = [];
	        } // ctxCompat just for compat echarts3
	
	
	        ctx = ctx || this;
	        var result = [];
	        this.each(dims, function () {
	          result.push(cb && cb.apply(this, arguments));
	        }, ctx);
	        return result;
	      };
	
	      SeriesData.prototype.map = function (dims, cb, ctx, ctxCompat) {
	
	        var fCtx = ctx || ctxCompat || this;
	        var dimIndices = map$1(normalizeDimensions(dims), this._getStoreDimIndex, this);
	        var list = cloneListForMapAndSample(this);
	        list._store = this._store.map(dimIndices, fCtx ? bind(cb, fCtx) : cb);
	        return list;
	      };
	
	      SeriesData.prototype.modify = function (dims, cb, ctx, ctxCompat) {
	        var _this = this; // ctxCompat just for compat echarts3
	
	
	        var fCtx = ctx || ctxCompat || this;
	
	        if (true) {
	          each(normalizeDimensions(dims), function (dim) {
	            var dimInfo = _this.getDimensionInfo(dim);
	
	            if (!dimInfo.isCalculationCoord) {
	              console.error('Danger: only stack dimension can be modified');
	            }
	          });
	        }
	
	        var dimIndices = map$1(normalizeDimensions(dims), this._getStoreDimIndex, this); // If do shallow clone here, if there are too many stacked series,
	        // it still cost lots of memory, because `_store.dimensions` are not shared.
	        // We should consider there probably be shallow clone happen in each series
	        // in consequent filter/map.
	
	        this._store.modify(dimIndices, fCtx ? bind(cb, fCtx) : cb);
	      };
	      /**
	       * Large data down sampling on given dimension
	       * @param sampleIndex Sample index for name and id
	       */
	
	
	      SeriesData.prototype.downSample = function (dimension, rate, sampleValue, sampleIndex) {
	        var list = cloneListForMapAndSample(this);
	        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
	        return list;
	      };
	      /**
	       * Large data down sampling using largest-triangle-three-buckets
	       * @param {string} valueDimension
	       * @param {number} targetCount
	       */
	
	
	      SeriesData.prototype.lttbDownSample = function (valueDimension, rate) {
	        var list = cloneListForMapAndSample(this);
	        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
	        return list;
	      };
	
	      SeriesData.prototype.getRawDataItem = function (idx) {
	        return this._store.getRawDataItem(idx);
	      };
	      /**
	       * Get model of one data item.
	       */
	      // TODO: Type of data item
	
	
	      SeriesData.prototype.getItemModel = function (idx) {
	        var hostModel = this.hostModel;
	        var dataItem = this.getRawDataItem(idx);
	        return new Model(dataItem, hostModel, hostModel && hostModel.ecModel);
	      };
	      /**
	       * Create a data differ
	       */
	
	
	      SeriesData.prototype.diff = function (otherList) {
	        var thisList = this;
	        return new DataDiffer(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function (idx) {
	          return getId(otherList, idx);
	        }, function (idx) {
	          return getId(thisList, idx);
	        });
	      };
	      /**
	       * Get visual property.
	       */
	
	
	      SeriesData.prototype.getVisual = function (key) {
	        var visual = this._visual;
	        return visual && visual[key];
	      };
	
	      SeriesData.prototype.setVisual = function (kvObj, val) {
	        this._visual = this._visual || {};
	
	        if (isObject$2(kvObj)) {
	          extend(this._visual, kvObj);
	        } else {
	          this._visual[kvObj] = val;
	        }
	      };
	      /**
	       * Get visual property of single data item
	       */
	      // eslint-disable-next-line
	
	
	      SeriesData.prototype.getItemVisual = function (idx, key) {
	        var itemVisual = this._itemVisuals[idx];
	        var val = itemVisual && itemVisual[key];
	
	        if (val == null) {
	          // Use global visual property
	          return this.getVisual(key);
	        }
	
	        return val;
	      };
	      /**
	       * If exists visual property of single data item
	       */
	
	
	      SeriesData.prototype.hasItemVisual = function () {
	        return this._itemVisuals.length > 0;
	      };
	      /**
	       * Make sure itemVisual property is unique
	       */
	      // TODO: use key to save visual to reduce memory.
	
	
	      SeriesData.prototype.ensureUniqueItemVisual = function (idx, key) {
	        var itemVisuals = this._itemVisuals;
	        var itemVisual = itemVisuals[idx];
	
	        if (!itemVisual) {
	          itemVisual = itemVisuals[idx] = {};
	        }
	
	        var val = itemVisual[key];
	
	        if (val == null) {
	          val = this.getVisual(key); // TODO Performance?
	
	          if (isArray(val)) {
	            val = val.slice();
	          } else if (isObject$2(val)) {
	            val = extend({}, val);
	          }
	
	          itemVisual[key] = val;
	        }
	
	        return val;
	      }; // eslint-disable-next-line
	
	
	      SeriesData.prototype.setItemVisual = function (idx, key, value) {
	        var itemVisual = this._itemVisuals[idx] || {};
	        this._itemVisuals[idx] = itemVisual;
	
	        if (isObject$2(key)) {
	          extend(itemVisual, key);
	        } else {
	          itemVisual[key] = value;
	        }
	      };
	      /**
	       * Clear itemVisuals and list visual.
	       */
	
	
	      SeriesData.prototype.clearAllVisual = function () {
	        this._visual = {};
	        this._itemVisuals = [];
	      };
	
	      SeriesData.prototype.setLayout = function (key, val) {
	        isObject$2(key) ? extend(this._layout, key) : this._layout[key] = val;
	      };
	      /**
	       * Get layout property.
	       */
	
	
	      SeriesData.prototype.getLayout = function (key) {
	        return this._layout[key];
	      };
	      /**
	       * Get layout of single data item
	       */
	
	
	      SeriesData.prototype.getItemLayout = function (idx) {
	        return this._itemLayouts[idx];
	      };
	      /**
	       * Set layout of single data item
	       */
	
	
	      SeriesData.prototype.setItemLayout = function (idx, layout, merge) {
	        this._itemLayouts[idx] = merge ? extend(this._itemLayouts[idx] || {}, layout) : layout;
	      };
	      /**
	       * Clear all layout of single data item
	       */
	
	
	      SeriesData.prototype.clearItemLayouts = function () {
	        this._itemLayouts.length = 0;
	      };
	      /**
	       * Set graphic element relative to data. It can be set as null
	       */
	
	
	      SeriesData.prototype.setItemGraphicEl = function (idx, el) {
	        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
	        setCommonECData(seriesIndex, this.dataType, idx, el);
	        this._graphicEls[idx] = el;
	      };
	
	      SeriesData.prototype.getItemGraphicEl = function (idx) {
	        return this._graphicEls[idx];
	      };
	
	      SeriesData.prototype.eachItemGraphicEl = function (cb, context) {
	        each(this._graphicEls, function (el, idx) {
	          if (el) {
	            cb && cb.call(context, el, idx);
	          }
	        });
	      };
	      /**
	       * Shallow clone a new list except visual and layout properties, and graph elements.
	       * New list only change the indices.
	       */
	
	
	      SeriesData.prototype.cloneShallow = function (list) {
	        if (!list) {
	          list = new SeriesData(this._schema ? this._schema : map$1(this.dimensions, this._getDimInfo, this), this.hostModel);
	        }
	
	        transferProperties(list, this);
	        list._store = this._store;
	        return list;
	      };
	      /**
	       * Wrap some method to add more feature
	       */
	
	
	      SeriesData.prototype.wrapMethod = function (methodName, injectFunction) {
	        var originalMethod = this[methodName];
	
	        if (!isFunction(originalMethod)) {
	          return;
	        }
	
	        this.__wrappedMethods = this.__wrappedMethods || [];
	
	        this.__wrappedMethods.push(methodName);
	
	        this[methodName] = function () {
	          var res = originalMethod.apply(this, arguments);
	          return injectFunction.apply(this, [res].concat(slice(arguments)));
	        };
	      }; // ----------------------------------------------------------
	      // A work around for internal method visiting private member.
	      // ----------------------------------------------------------
	
	
	      SeriesData.internalField = function () {
	        prepareInvertedIndex = function (data) {
	          var invertedIndicesMap = data._invertedIndicesMap;
	          each(invertedIndicesMap, function (invertedIndices, dim) {
	            var dimInfo = data._dimInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
	
	            var ordinalMeta = dimInfo.ordinalMeta;
	            var store = data._store;
	
	            if (ordinalMeta) {
	              invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array$1(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
	              // mapping to 0, we should set it as INDEX_NOT_FOUND.
	
	              for (var i = 0; i < invertedIndices.length; i++) {
	                invertedIndices[i] = INDEX_NOT_FOUND;
	              }
	
	              for (var i = 0; i < store.count(); i++) {
	                // Only support the case that all values are distinct.
	                invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
	              }
	            }
	          });
	        };
	
	        getIdNameFromStore = function (data, dimIdx, idx) {
	          return convertOptionIdName(data._getCategory(dimIdx, idx), null);
	        };
	        /**
	         * @see the comment of `List['getId']`.
	         */
	
	
	        getId = function (data, rawIndex) {
	          var id = data._idList[rawIndex];
	
	          if (id == null && data._idDimIdx != null) {
	            id = getIdNameFromStore(data, data._idDimIdx, rawIndex);
	          }
	
	          if (id == null) {
	            id = ID_PREFIX + rawIndex;
	          }
	
	          return id;
	        };
	
	        normalizeDimensions = function (dimensions) {
	          if (!isArray(dimensions)) {
	            dimensions = dimensions != null ? [dimensions] : [];
	          }
	
	          return dimensions;
	        };
	        /**
	         * Data in excludeDimensions is copied, otherwise transferred.
	         */
	
	
	        cloneListForMapAndSample = function (original) {
	          var list = new SeriesData(original._schema ? original._schema : map$1(original.dimensions, original._getDimInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
	
	          transferProperties(list, original);
	          return list;
	        };
	
	        transferProperties = function (target, source) {
	          each(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
	            if (source.hasOwnProperty(propName)) {
	              target[propName] = source[propName];
	            }
	          });
	          target.__wrappedMethods = source.__wrappedMethods;
	          each(CLONE_PROPERTIES, function (propName) {
	            target[propName] = clone(source[propName]);
	          });
	          target._calculationInfo = extend({}, source._calculationInfo);
	        };
	
	        makeIdFromName = function (data, idx) {
	          var nameList = data._nameList;
	          var idList = data._idList;
	          var nameDimIdx = data._nameDimIdx;
	          var idDimIdx = data._idDimIdx;
	          var name = nameList[idx];
	          var id = idList[idx];
	
	          if (name == null && nameDimIdx != null) {
	            nameList[idx] = name = getIdNameFromStore(data, nameDimIdx, idx);
	          }
	
	          if (id == null && idDimIdx != null) {
	            idList[idx] = id = getIdNameFromStore(data, idDimIdx, idx);
	          }
	
	          if (id == null && name != null) {
	            var nameRepeatCount = data._nameRepeatCount;
	            var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
	            id = name;
	
	            if (nmCnt > 1) {
	              id += '__ec__' + nmCnt;
	            }
	
	            idList[idx] = id;
	          }
	        };
	      }();
	
	      return SeriesData;
	    }();
	
	    /**
	     * For outside usage compat (like echarts-gl are using it).
	     */
	
	    function createDimensions(source, opt) {
	      return prepareSeriesDataSchema(source, opt).dimensions;
	    }
	    /**
	     * This method builds the relationship between:
	     * + "what the coord sys or series requires (see `coordDimensions`)",
	     * + "what the user defines (in `encode` and `dimensions`, see `opt.dimensionsDefine` and `opt.encodeDefine`)"
	     * + "what the data source provids (see `source`)".
	     *
	     * Some guess strategy will be adapted if user does not define something.
	     * If no 'value' dimension specified, the first no-named dimension will be
	     * named as 'value'.
	     *
	     * @return The results are always sorted by `storeDimIndex` asc.
	     */
	
	    function prepareSeriesDataSchema( // TODO: TYPE completeDimensions type
	    source, opt) {
	      if (!isSourceInstance(source)) {
	        source = createSourceFromSeriesDataOption(source);
	      }
	
	      opt = opt || {};
	      var sysDims = opt.coordDimensions || [];
	      var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
	      var coordDimNameMap = createHashMap();
	      var resultList = [];
	      var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimensionsCount); // Try to ignore unused dimensions if sharing a high dimension datastore
	      // 30 is an experience value.
	
	      var omitUnusedDimensions = opt.canOmitUnusedDimensions && shouldOmitUnusedDimensions(dimCount);
	      var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
	      var dataDimNameMap = isUsingSourceDimensionsDef ? ensureSourceDimNameMap(source) : createDimNameMap(dimsDef);
	      var encodeDef = opt.encodeDefine;
	
	      if (!encodeDef && opt.encodeDefaulter) {
	        encodeDef = opt.encodeDefaulter(source, dimCount);
	      }
	
	      var encodeDefMap = createHashMap(encodeDef);
	      var indicesMap = new CtorInt32Array(dimCount);
	
	      for (var i = 0; i < indicesMap.length; i++) {
	        indicesMap[i] = -1;
	      }
	
	      function getResultItem(dimIdx) {
	        var idx = indicesMap[dimIdx];
	
	        if (idx < 0) {
	          var dimDefItemRaw = dimsDef[dimIdx];
	          var dimDefItem = isObject(dimDefItemRaw) ? dimDefItemRaw : {
	            name: dimDefItemRaw
	          };
	          var resultItem = new SeriesDimensionDefine();
	          var userDimName = dimDefItem.name;
	
	          if (userDimName != null && dataDimNameMap.get(userDimName) != null) {
	            // Only if `series.dimensions` is defined in option
	            // displayName, will be set, and dimension will be displayed vertically in
	            // tooltip by default.
	            resultItem.name = resultItem.displayName = userDimName;
	          }
	
	          dimDefItem.type != null && (resultItem.type = dimDefItem.type);
	          dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
	          var newIdx = resultList.length;
	          indicesMap[dimIdx] = newIdx;
	          resultItem.storeDimIndex = dimIdx;
	          resultList.push(resultItem);
	          return resultItem;
	        }
	
	        return resultList[idx];
	      }
	
	      if (!omitUnusedDimensions) {
	        for (var i = 0; i < dimCount; i++) {
	          getResultItem(i);
	        }
	      } // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
	
	
	      encodeDefMap.each(function (dataDimsRaw, coordDim) {
	        var dataDims = normalizeToArray(dataDimsRaw).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
	        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
	        // this case.
	
	        if (dataDims.length === 1 && !isString(dataDims[0]) && dataDims[0] < 0) {
	          encodeDefMap.set(coordDim, false);
	          return;
	        }
	
	        var validDataDims = encodeDefMap.set(coordDim, []);
	        each(dataDims, function (resultDimIdxOrName, idx) {
	          // The input resultDimIdx can be dim name or index.
	          var resultDimIdx = isString(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
	
	          if (resultDimIdx != null && resultDimIdx < dimCount) {
	            validDataDims[idx] = resultDimIdx;
	            applyDim(getResultItem(resultDimIdx), coordDim, idx);
	          }
	        });
	      }); // Apply templates and default order from `sysDims`.
	
	      var availDimIdx = 0;
	      each(sysDims, function (sysDimItemRaw) {
	        var coordDim;
	        var sysDimItemDimsDef;
	        var sysDimItemOtherDims;
	        var sysDimItem;
	
	        if (isString(sysDimItemRaw)) {
	          coordDim = sysDimItemRaw;
	          sysDimItem = {};
	        } else {
	          sysDimItem = sysDimItemRaw;
	          coordDim = sysDimItem.name;
	          var ordinalMeta = sysDimItem.ordinalMeta;
	          sysDimItem.ordinalMeta = null;
	          sysDimItem = extend({}, sysDimItem);
	          sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
	
	          sysDimItemDimsDef = sysDimItem.dimsDef;
	          sysDimItemOtherDims = sysDimItem.otherDims;
	          sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
	        }
	
	        var dataDims = encodeDefMap.get(coordDim); // negative resultDimIdx means no need to mapping.
	
	        if (dataDims === false) {
	          return;
	        }
	
	        dataDims = normalizeToArray(dataDims); // dimensions provides default dim sequences.
	
	        if (!dataDims.length) {
	          for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
	            while (availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null) {
	              availDimIdx++;
	            }
	
	            availDimIdx < dimCount && dataDims.push(availDimIdx++);
	          }
	        } // Apply templates.
	
	
	        each(dataDims, function (resultDimIdx, coordDimIndex) {
	          var resultItem = getResultItem(resultDimIdx); // Coordinate system has a higher priority on dim type than source.
	
	          if (isUsingSourceDimensionsDef && sysDimItem.type != null) {
	            resultItem.type = sysDimItem.type;
	          }
	
	          applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);
	
	          if (resultItem.name == null && sysDimItemDimsDef) {
	            var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
	            !isObject(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
	              name: sysDimItemDimsDefItem
	            });
	            resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
	            resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
	          } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
	
	
	          sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
	        });
	      });
	
	      function applyDim(resultItem, coordDim, coordDimIndex) {
	        if (VISUAL_DIMENSIONS.get(coordDim) != null) {
	          resultItem.otherDims[coordDim] = coordDimIndex;
	        } else {
	          resultItem.coordDim = coordDim;
	          resultItem.coordDimIndex = coordDimIndex;
	          coordDimNameMap.set(coordDim, true);
	        }
	      } // Make sure the first extra dim is 'value'.
	
	
	      var generateCoord = opt.generateCoord;
	      var generateCoordCount = opt.generateCoordCount;
	      var fromZero = generateCoordCount != null;
	      generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
	      var extra = generateCoord || 'value';
	
	      function ifNoNameFillWithCoordName(resultItem) {
	        if (resultItem.name == null) {
	          // Duplication will be removed in the next step.
	          resultItem.name = resultItem.coordDim;
	        }
	      } // Set dim `name` and other `coordDim` and other props.
	
	
	      if (!omitUnusedDimensions) {
	        for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
	          var resultItem = getResultItem(resultDimIdx);
	          var coordDim = resultItem.coordDim;
	
	          if (coordDim == null) {
	            // TODO no need to generate coordDim for isExtraCoord?
	            resultItem.coordDim = genCoordDimName(extra, coordDimNameMap, fromZero);
	            resultItem.coordDimIndex = 0; // Series specified generateCoord is using out.
	
	            if (!generateCoord || generateCoordCount <= 0) {
	              resultItem.isExtraCoord = true;
	            }
	
	            generateCoordCount--;
	          }
	
	          ifNoNameFillWithCoordName(resultItem);
	
	          if (resultItem.type == null && (guessOrdinal(source, resultDimIdx) === BE_ORDINAL.Must // Consider the case:
	          // {
	          //    dataset: {source: [
	          //        ['2001', 123],
	          //        ['2002', 456],
	          //        ...
	          //        ['The others', 987],
	          //    ]},
	          //    series: {type: 'pie'}
	          // }
	          // The first column should better be treated as a "ordinal" although it
	          // might not be detected as an "ordinal" by `guessOrdinal`.
	          || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) {
	            resultItem.type = 'ordinal';
	          }
	        }
	      } else {
	        each(resultList, function (resultItem) {
	          // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
	          ifNoNameFillWithCoordName(resultItem);
	        }); // Sort dimensions: there are some rule that use the last dim as label,
	        // and for some latter travel process easier.
	
	        resultList.sort(function (item0, item1) {
	          return item0.storeDimIndex - item1.storeDimIndex;
	        });
	      }
	
	      removeDuplication(resultList);
	      return new SeriesDataSchema({
	        source: source,
	        dimensions: resultList,
	        fullDimensionCount: dimCount,
	        dimensionOmitted: omitUnusedDimensions
	      });
	    }
	
	    function removeDuplication(result) {
	      var duplicationMap = createHashMap();
	
	      for (var i = 0; i < result.length; i++) {
	        var dim = result[i];
	        var dimOriginalName = dim.name;
	        var count = duplicationMap.get(dimOriginalName) || 0;
	
	        if (count > 0) {
	          // Starts from 0.
	          dim.name = dimOriginalName + (count - 1);
	        }
	
	        count++;
	        duplicationMap.set(dimOriginalName, count);
	      }
	    } // ??? TODO
	    // Originally detect dimCount by data[0]. Should we
	    // optimize it to only by sysDims and dimensions and encode.
	    // So only necessary dims will be initialized.
	    // But
	    // (1) custom series should be considered. where other dims
	    // may be visited.
	    // (2) sometimes user need to calculate bubble size or use visualMap
	    // on other dimensions besides coordSys needed.
	    // So, dims that is not used by system, should be shared in data store?
	
	
	    function getDimCount(source, sysDims, dimsDef, optDimCount) {
	      // Note that the result dimCount should not small than columns count
	      // of data, otherwise `dataDimNameMap` checking will be incorrect.
	      var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
	      each(sysDims, function (sysDimItem) {
	        var sysDimItemDimsDef;
	
	        if (isObject(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) {
	          dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
	        }
	      });
	      return dimCount;
	    }
	
	    function genCoordDimName(name, map, fromZero) {
	      if (fromZero || map.hasKey(name)) {
	        var i = 0;
	
	        while (map.hasKey(name + i)) {
	          i++;
	        }
	
	        name += i;
	      }
	
	      map.set(name, true);
	      return name;
	    }
	
	    /**
	     * @class
	     * For example:
	     * {
	     *     coordSysName: 'cartesian2d',
	     *     coordSysDims: ['x', 'y', ...],
	     *     axisMap: HashMap({
	     *         x: xAxisModel,
	     *         y: yAxisModel
	     *     }),
	     *     categoryAxisMap: HashMap({
	     *         x: xAxisModel,
	     *         y: undefined
	     *     }),
	     *     // The index of the first category axis in `coordSysDims`.
	     *     // `null/undefined` means no category axis exists.
	     *     firstCategoryDimIndex: 1,
	     *     // To replace user specified encode.
	     * }
	     */
	
	    var CoordSysInfo =
	    /** @class */
	    function () {
	      function CoordSysInfo(coordSysName) {
	        this.coordSysDims = [];
	        this.axisMap = createHashMap();
	        this.categoryAxisMap = createHashMap();
	        this.coordSysName = coordSysName;
	      }
	
	      return CoordSysInfo;
	    }();
	
	    function getCoordSysInfoBySeries(seriesModel) {
	      var coordSysName = seriesModel.get('coordinateSystem');
	      var result = new CoordSysInfo(coordSysName);
	      var fetch = fetchers[coordSysName];
	
	      if (fetch) {
	        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
	        return result;
	      }
	    }
	    var fetchers = {
	      cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
	        var xAxisModel = seriesModel.getReferringComponents('xAxis', SINGLE_REFERRING).models[0];
	        var yAxisModel = seriesModel.getReferringComponents('yAxis', SINGLE_REFERRING).models[0];
	
	        if (true) {
	          if (!xAxisModel) {
	            throw new Error('xAxis "' + retrieve(seriesModel.get('xAxisIndex'), seriesModel.get('xAxisId'), 0) + '" not found');
	          }
	
	          if (!yAxisModel) {
	            throw new Error('yAxis "' + retrieve(seriesModel.get('xAxisIndex'), seriesModel.get('yAxisId'), 0) + '" not found');
	          }
	        }
	
	        result.coordSysDims = ['x', 'y'];
	        axisMap.set('x', xAxisModel);
	        axisMap.set('y', yAxisModel);
	
	        if (isCategory(xAxisModel)) {
	          categoryAxisMap.set('x', xAxisModel);
	          result.firstCategoryDimIndex = 0;
	        }
	
	        if (isCategory(yAxisModel)) {
	          categoryAxisMap.set('y', yAxisModel);
	          result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
	        }
	      },
	      singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
	        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', SINGLE_REFERRING).models[0];
	
	        if (true) {
	          if (!singleAxisModel) {
	            throw new Error('singleAxis should be specified.');
	          }
	        }
	
	        result.coordSysDims = ['single'];
	        axisMap.set('single', singleAxisModel);
	
	        if (isCategory(singleAxisModel)) {
	          categoryAxisMap.set('single', singleAxisModel);
	          result.firstCategoryDimIndex = 0;
	        }
	      },
	      polar: function (seriesModel, result, axisMap, categoryAxisMap) {
	        var polarModel = seriesModel.getReferringComponents('polar', SINGLE_REFERRING).models[0];
	        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	        var angleAxisModel = polarModel.findAxisModel('angleAxis');
	
	        if (true) {
	          if (!angleAxisModel) {
	            throw new Error('angleAxis option not found');
	          }
	
	          if (!radiusAxisModel) {
	            throw new Error('radiusAxis option not found');
	          }
	        }
	
	        result.coordSysDims = ['radius', 'angle'];
	        axisMap.set('radius', radiusAxisModel);
	        axisMap.set('angle', angleAxisModel);
	
	        if (isCategory(radiusAxisModel)) {
	          categoryAxisMap.set('radius', radiusAxisModel);
	          result.firstCategoryDimIndex = 0;
	        }
	
	        if (isCategory(angleAxisModel)) {
	          categoryAxisMap.set('angle', angleAxisModel);
	          result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
	        }
	      },
	      geo: function (seriesModel, result, axisMap, categoryAxisMap) {
	        result.coordSysDims = ['lng', 'lat'];
	      },
	      parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
	        var ecModel = seriesModel.ecModel;
	        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
	        each(parallelModel.parallelAxisIndex, function (axisIndex, index) {
	          var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	          var axisDim = coordSysDims[index];
	          axisMap.set(axisDim, axisModel);
	
	          if (isCategory(axisModel)) {
	            categoryAxisMap.set(axisDim, axisModel);
	
	            if (result.firstCategoryDimIndex == null) {
	              result.firstCategoryDimIndex = index;
	            }
	          }
	        });
	      }
	    };
	
	    function isCategory(axisModel) {
	      return axisModel.get('type') === 'category';
	    }
	
	    /**
	     * Note that it is too complicated to support 3d stack by value
	     * (have to create two-dimension inverted index), so in 3d case
	     * we just support that stacked by index.
	     *
	     * @param seriesModel
	     * @param dimensionsInput The same as the input of <module:echarts/data/SeriesData>.
	     *        The input will be modified.
	     * @param opt
	     * @param opt.stackedCoordDimension Specify a coord dimension if needed.
	     * @param opt.byIndex=false
	     * @return calculationInfo
	     * {
	     *     stackedDimension: string
	     *     stackedByDimension: string
	     *     isStackedByIndex: boolean
	     *     stackedOverDimension: string
	     *     stackResultDimension: string
	     * }
	     */
	
	    function enableDataStack(seriesModel, dimensionsInput, opt) {
	      opt = opt || {};
	      var byIndex = opt.byIndex;
	      var stackedCoordDimension = opt.stackedCoordDimension;
	      var dimensionDefineList;
	      var schema;
	      var store;
	
	      if (isLegacyDimensionsInput(dimensionsInput)) {
	        dimensionDefineList = dimensionsInput;
	      } else {
	        schema = dimensionsInput.schema;
	        dimensionDefineList = schema.dimensions;
	        store = dimensionsInput.store;
	      } // Compatibal: when `stack` is set as '', do not stack.
	
	
	      var mayStack = !!(seriesModel && seriesModel.get('stack'));
	      var stackedByDimInfo;
	      var stackedDimInfo;
	      var stackResultDimension;
	      var stackedOverDimension;
	      each(dimensionDefineList, function (dimensionInfo, index) {
	        if (isString(dimensionInfo)) {
	          dimensionDefineList[index] = dimensionInfo = {
	            name: dimensionInfo
	          };
	        }
	
	        if (mayStack && !dimensionInfo.isExtraCoord) {
	          // Find the first ordinal dimension as the stackedByDimInfo.
	          if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
	            stackedByDimInfo = dimensionInfo;
	          } // Find the first stackable dimension as the stackedDimInfo.
	
	
	          if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
	            stackedDimInfo = dimensionInfo;
	          }
	        }
	      });
	
	      if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
	        // Compatible with previous design, value axis (time axis) only stack by index.
	        // It may make sense if the user provides elaborately constructed data.
	        byIndex = true;
	      } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
	      // That put stack logic in List is for using conveniently in echarts extensions, but it
	      // might not be a good way.
	
	
	      if (stackedDimInfo) {
	        // Use a weird name that not duplicated with other names.
	        // Also need to use seriesModel.id as postfix because different
	        // series may share same data store. The stack dimension needs to be distinguished.
	        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
	        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id; // Create inverted index to fast query index by value.
	
	        if (stackedByDimInfo) {
	          stackedByDimInfo.createInvertedIndices = true;
	        }
	
	        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
	        var stackedDimType = stackedDimInfo.type;
	        var stackedDimCoordIndex_1 = 0;
	        each(dimensionDefineList, function (dimensionInfo) {
	          if (dimensionInfo.coordDim === stackedDimCoordDim_1) {
	            stackedDimCoordIndex_1++;
	          }
	        });
	        var stackedOverDimensionDefine = {
	          name: stackResultDimension,
	          coordDim: stackedDimCoordDim_1,
	          coordDimIndex: stackedDimCoordIndex_1,
	          type: stackedDimType,
	          isExtraCoord: true,
	          isCalculationCoord: true,
	          storeDimIndex: dimensionDefineList.length
	        };
	        var stackResultDimensionDefine = {
	          name: stackedOverDimension,
	          // This dimension contains stack base (generally, 0), so do not set it as
	          // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
	          coordDim: stackedOverDimension,
	          coordDimIndex: stackedDimCoordIndex_1 + 1,
	          type: stackedDimType,
	          isExtraCoord: true,
	          isCalculationCoord: true,
	          storeDimIndex: dimensionDefineList.length + 1
	        };
	
	        if (schema) {
	          if (store) {
	            stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
	            stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
	          }
	
	          schema.appendCalculationDimension(stackedOverDimensionDefine);
	          schema.appendCalculationDimension(stackResultDimensionDefine);
	        } else {
	          dimensionDefineList.push(stackedOverDimensionDefine);
	          dimensionDefineList.push(stackResultDimensionDefine);
	        }
	      }
	
	      return {
	        stackedDimension: stackedDimInfo && stackedDimInfo.name,
	        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
	        isStackedByIndex: byIndex,
	        stackedOverDimension: stackedOverDimension,
	        stackResultDimension: stackResultDimension
	      };
	    }
	
	    function isLegacyDimensionsInput(dimensionsInput) {
	      return !isSeriesDataSchema(dimensionsInput.schema);
	    }
	
	    function isDimensionStacked(data, stackedDim) {
	      // Each single series only maps to one pair of axis. So we do not need to
	      // check stackByDim, whatever stacked by a dimension or stacked by index.
	      return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
	    }
	    function getStackedDimension(data, targetDim) {
	      return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
	    }
	
	    function getCoordSysDimDefs(seriesModel, coordSysInfo) {
	      var coordSysName = seriesModel.get('coordinateSystem');
	      var registeredCoordSys = CoordinateSystemManager.get(coordSysName);
	      var coordSysDimDefs;
	
	      if (coordSysInfo && coordSysInfo.coordSysDims) {
	        coordSysDimDefs = map(coordSysInfo.coordSysDims, function (dim) {
	          var dimInfo = {
	            name: dim
	          };
	          var axisModel = coordSysInfo.axisMap.get(dim);
	
	          if (axisModel) {
	            var axisType = axisModel.get('type');
	            dimInfo.type = getDimensionTypeByAxis(axisType);
	          }
	
	          return dimInfo;
	        });
	      }
	
	      if (!coordSysDimDefs) {
	        // Get dimensions from registered coordinate system
	        coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
	      }
	
	      return coordSysDimDefs;
	    }
	
	    function injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
	      var firstCategoryDimIndex;
	      var hasNameEncode;
	      coordSysInfo && each(dimInfoList, function (dimInfo, dimIndex) {
	        var coordDim = dimInfo.coordDim;
	        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
	
	        if (categoryAxisModel) {
	          if (firstCategoryDimIndex == null) {
	            firstCategoryDimIndex = dimIndex;
	          }
	
	          dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
	
	          if (createInvertedIndices) {
	            dimInfo.createInvertedIndices = true;
	          }
	        }
	
	        if (dimInfo.otherDims.itemName != null) {
	          hasNameEncode = true;
	        }
	      });
	
	      if (!hasNameEncode && firstCategoryDimIndex != null) {
	        dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
	      }
	
	      return firstCategoryDimIndex;
	    }
	    /**
	     * Caution: there are side effects to `sourceManager` in this method.
	     * Should better only be called in `Series['getInitialData']`.
	     */
	
	
	    function createSeriesData(sourceRaw, seriesModel, opt) {
	      opt = opt || {};
	      var sourceManager = seriesModel.getSourceManager();
	      var source;
	      var isOriginalSource = false;
	
	      if (sourceRaw) {
	        isOriginalSource = true;
	        source = createSourceFromSeriesDataOption(sourceRaw);
	      } else {
	        source = sourceManager.getSource(); // Is series.data. not dataset.
	
	        isOriginalSource = source.sourceFormat === SOURCE_FORMAT_ORIGINAL;
	      }
	
	      var coordSysInfo = getCoordSysInfoBySeries(seriesModel);
	      var coordSysDimDefs = getCoordSysDimDefs(seriesModel, coordSysInfo);
	      var useEncodeDefaulter = opt.useEncodeDefaulter;
	      var encodeDefaulter = isFunction(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? curry(makeSeriesEncodeForAxisCoordSys, coordSysDimDefs, seriesModel) : null;
	      var createDimensionOptions = {
	        coordDimensions: coordSysDimDefs,
	        generateCoord: opt.generateCoord,
	        encodeDefine: seriesModel.getEncode(),
	        encodeDefaulter: encodeDefaulter,
	        canOmitUnusedDimensions: !isOriginalSource
	      };
	      var schema = prepareSeriesDataSchema(source, createDimensionOptions);
	      var firstCategoryDimIndex = injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
	      var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
	      var stackCalculationInfo = enableDataStack(seriesModel, {
	        schema: schema,
	        store: store
	      });
	      var data = new SeriesData(schema, seriesModel);
	      data.setCalculationInfo(stackCalculationInfo);
	      var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
	        // Use dataIndex as ordinal value in categoryAxis
	        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
	      } : null;
	      data.hasItemOption = false;
	      data.initData( // Try to reuse the data store in sourceManager if using dataset.
	      isOriginalSource ? source : store, null, dimValueGetter);
	      return data;
	    }
	
	    function isNeedCompleteOrdinalData(source) {
	      if (source.sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	        var sampleItem = firstDataNotNull(source.data || []);
	        return !isArray(getDataItemValue(sampleItem));
	      }
	    }
	
	    function firstDataNotNull(arr) {
	      var i = 0;
	
	      while (i < arr.length && arr[i] == null) {
	        i++;
	      }
	
	      return arr[i];
	    }
	
	    var Scale =
	    /** @class */
	    function () {
	      function Scale(setting) {
	        this._setting = setting || {};
	        this._extent = [Infinity, -Infinity];
	      }
	
	      Scale.prototype.getSetting = function (name) {
	        return this._setting[name];
	      };
	      /**
	       * Set extent from data
	       */
	
	
	      Scale.prototype.unionExtent = function (other) {
	        var extent = this._extent;
	        other[0] < extent[0] && (extent[0] = other[0]);
	        other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
	        // this.setExtent(extent[0], extent[1]);
	      };
	      /**
	       * Set extent from data
	       */
	
	
	      Scale.prototype.unionExtentFromData = function (data, dim) {
	        this.unionExtent(data.getApproximateExtent(dim));
	      };
	      /**
	       * Get extent
	       *
	       * Extent is always in increase order.
	       */
	
	
	      Scale.prototype.getExtent = function () {
	        return this._extent.slice();
	      };
	      /**
	       * Set extent
	       */
	
	
	      Scale.prototype.setExtent = function (start, end) {
	        var thisExtent = this._extent;
	
	        if (!isNaN(start)) {
	          thisExtent[0] = start;
	        }
	
	        if (!isNaN(end)) {
	          thisExtent[1] = end;
	        }
	      };
	      /**
	       * If value is in extent range
	       */
	
	
	      Scale.prototype.isInExtentRange = function (value) {
	        return this._extent[0] <= value && this._extent[1] >= value;
	      };
	      /**
	       * When axis extent depends on data and no data exists,
	       * axis ticks should not be drawn, which is named 'blank'.
	       */
	
	
	      Scale.prototype.isBlank = function () {
	        return this._isBlank;
	      };
	      /**
	       * When axis extent depends on data and no data exists,
	       * axis ticks should not be drawn, which is named 'blank'.
	       */
	
	
	      Scale.prototype.setBlank = function (isBlank) {
	        this._isBlank = isBlank;
	      };
	
	      return Scale;
	    }();
	
	    enableClassManagement(Scale);
	
	    var uidBase = 0;
	
	    var OrdinalMeta =
	    /** @class */
	    function () {
	      function OrdinalMeta(opt) {
	        this.categories = opt.categories || [];
	        this._needCollect = opt.needCollect;
	        this._deduplication = opt.deduplication;
	        this.uid = ++uidBase;
	      }
	
	      OrdinalMeta.createByAxisModel = function (axisModel) {
	        var option = axisModel.option;
	        var data = option.data;
	        var categories = data && map(data, getName);
	        return new OrdinalMeta({
	          categories: categories,
	          needCollect: !categories,
	          // deduplication is default in axis.
	          deduplication: option.dedplication !== false
	        });
	      };
	
	      OrdinalMeta.prototype.getOrdinal = function (category) {
	        // @ts-ignore
	        return this._getOrCreateMap().get(category);
	      };
	      /**
	       * @return The ordinal. If not found, return NaN.
	       */
	
	
	      OrdinalMeta.prototype.parseAndCollect = function (category) {
	        var index;
	        var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
	        // This feature is only supported when !needCollect, because we should
	        // consider a common case: a value is 2017, which is a number but is
	        // expected to be tread as a category. This case usually happen in dataset,
	        // where it happent to be no need of the index feature.
	
	        if (!isString(category) && !needCollect) {
	          return category;
	        } // Optimize for the scenario:
	        // category is ['2012-01-01', '2012-01-02', ...], where the input
	        // data has been ensured not duplicate and is large data.
	        // Notice, if a dataset dimension provide categroies, usually echarts
	        // should remove duplication except user tell echarts dont do that
	        // (set axis.deduplication = false), because echarts do not know whether
	        // the values in the category dimension has duplication (consider the
	        // parallel-aqi example)
	
	
	        if (needCollect && !this._deduplication) {
	          index = this.categories.length;
	          this.categories[index] = category;
	          return index;
	        }
	
	        var map = this._getOrCreateMap(); // @ts-ignore
	
	
	        index = map.get(category);
	
	        if (index == null) {
	          if (needCollect) {
	            index = this.categories.length;
	            this.categories[index] = category; // @ts-ignore
	
	            map.set(category, index);
	          } else {
	            index = NaN;
	          }
	        }
	
	        return index;
	      }; // Consider big data, do not create map until needed.
	
	
	      OrdinalMeta.prototype._getOrCreateMap = function () {
	        return this._map || (this._map = createHashMap(this.categories));
	      };
	
	      return OrdinalMeta;
	    }();
	
	    function getName(obj) {
	      if (isObject(obj) && obj.value != null) {
	        return obj.value;
	      } else {
	        return obj + '';
	      }
	    }
	
	    function isValueNice(val) {
	      var exp10 = Math.pow(10, quantityExponent(Math.abs(val)));
	      var f = Math.abs(val / exp10);
	      return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
	    }
	    function isIntervalOrLogScale(scale) {
	      return scale.type === 'interval' || scale.type === 'log';
	    }
	    /**
	     * @param extent Both extent[0] and extent[1] should be valid number.
	     *               Should be extent[0] < extent[1].
	     * @param splitNumber splitNumber should be >= 1.
	     */
	
	    function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
	      var result = {};
	      var span = extent[1] - extent[0];
	      var interval = result.interval = nice(span / splitNumber, true);
	
	      if (minInterval != null && interval < minInterval) {
	        interval = result.interval = minInterval;
	      }
	
	      if (maxInterval != null && interval > maxInterval) {
	        interval = result.interval = maxInterval;
	      } // Tow more digital for tick.
	
	
	      var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent
	
	      var niceTickExtent = result.niceTickExtent = [round(Math.ceil(extent[0] / interval) * interval, precision), round(Math.floor(extent[1] / interval) * interval, precision)];
	      fixExtent(niceTickExtent, extent);
	      return result;
	    }
	    function increaseInterval(interval) {
	      var exp10 = Math.pow(10, quantityExponent(interval)); // Increase interval
	
	      var f = interval / exp10;
	
	      if (!f) {
	        f = 1;
	      } else if (f === 2) {
	        f = 3;
	      } else if (f === 3) {
	        f = 5;
	      } else {
	        // f is 1 or 5
	        f *= 2;
	      }
	
	      return round(f * exp10);
	    }
	    /**
	     * @return interval precision
	     */
	
	    function getIntervalPrecision(interval) {
	      // Tow more digital for tick.
	      return getPrecision(interval) + 2;
	    }
	
	    function clamp(niceTickExtent, idx, extent) {
	      niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
	    } // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
	
	
	    function fixExtent(niceTickExtent, extent) {
	      !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
	      !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
	      clamp(niceTickExtent, 0, extent);
	      clamp(niceTickExtent, 1, extent);
	
	      if (niceTickExtent[0] > niceTickExtent[1]) {
	        niceTickExtent[0] = niceTickExtent[1];
	      }
	    }
	    function contain$1(val, extent) {
	      return val >= extent[0] && val <= extent[1];
	    }
	    function normalize$1(val, extent) {
	      if (extent[1] === extent[0]) {
	        return 0.5;
	      }
	
	      return (val - extent[0]) / (extent[1] - extent[0]);
	    }
	    function scale$2(val, extent) {
	      return val * (extent[1] - extent[0]) + extent[0];
	    }
	
	    var OrdinalScale =
	    /** @class */
	    function (_super) {
	      __extends(OrdinalScale, _super);
	
	      function OrdinalScale(setting) {
	        var _this = _super.call(this, setting) || this;
	
	        _this.type = 'ordinal';
	
	        var ordinalMeta = _this.getSetting('ordinalMeta'); // Caution: Should not use instanceof, consider ec-extensions using
	        // import approach to get OrdinalMeta class.
	
	
	        if (!ordinalMeta) {
	          ordinalMeta = new OrdinalMeta({});
	        }
	
	        if (isArray(ordinalMeta)) {
	          ordinalMeta = new OrdinalMeta({
	            categories: map(ordinalMeta, function (item) {
	              return isObject(item) ? item.value : item;
	            })
	          });
	        }
	
	        _this._ordinalMeta = ordinalMeta;
	        _this._extent = _this.getSetting('extent') || [0, ordinalMeta.categories.length - 1];
	        return _this;
	      }
	
	      OrdinalScale.prototype.parse = function (val) {
	        // Caution: Math.round(null) will return `0` rather than `NaN`
	        if (val == null) {
	          return NaN;
	        }
	
	        return isString(val) ? this._ordinalMeta.getOrdinal(val) // val might be float.
	        : Math.round(val);
	      };
	
	      OrdinalScale.prototype.contain = function (rank) {
	        rank = this.parse(rank);
	        return contain$1(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
	      };
	      /**
	       * Normalize given rank or name to linear [0, 1]
	       * @param val raw ordinal number.
	       * @return normalized value in [0, 1].
	       */
	
	
	      OrdinalScale.prototype.normalize = function (val) {
	        val = this._getTickNumber(this.parse(val));
	        return normalize$1(val, this._extent);
	      };
	      /**
	       * @param val normalized value in [0, 1].
	       * @return raw ordinal number.
	       */
	
	
	      OrdinalScale.prototype.scale = function (val) {
	        val = Math.round(scale$2(val, this._extent));
	        return this.getRawOrdinalNumber(val);
	      };
	
	      OrdinalScale.prototype.getTicks = function () {
	        var ticks = [];
	        var extent = this._extent;
	        var rank = extent[0];
	
	        while (rank <= extent[1]) {
	          ticks.push({
	            value: rank
	          });
	          rank++;
	        }
	
	        return ticks;
	      };
	
	      OrdinalScale.prototype.getMinorTicks = function (splitNumber) {
	        // Not support.
	        return;
	      };
	      /**
	       * @see `Ordinal['_ordinalNumbersByTick']`
	       */
	
	
	      OrdinalScale.prototype.setSortInfo = function (info) {
	        if (info == null) {
	          this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
	          return;
	        }
	
	        var infoOrdinalNumbers = info.ordinalNumbers;
	        var ordinalsByTick = this._ordinalNumbersByTick = [];
	        var ticksByOrdinal = this._ticksByOrdinalNumber = []; // Unnecessary support negative tick in `realtimeSort`.
	
	        var tickNum = 0;
	        var allCategoryLen = this._ordinalMeta.categories.length;
	
	        for (var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum) {
	          var ordinalNumber = infoOrdinalNumbers[tickNum];
	          ordinalsByTick[tickNum] = ordinalNumber;
	          ticksByOrdinal[ordinalNumber] = tickNum;
	        } // Handle that `series.data` only covers part of the `axis.category.data`.
	
	
	        var unusedOrdinal = 0;
	
	        for (; tickNum < allCategoryLen; ++tickNum) {
	          while (ticksByOrdinal[unusedOrdinal] != null) {
	            unusedOrdinal++;
	          }
	          ordinalsByTick.push(unusedOrdinal);
	          ticksByOrdinal[unusedOrdinal] = tickNum;
	        }
	      };
	
	      OrdinalScale.prototype._getTickNumber = function (ordinal) {
	        var ticksByOrdinalNumber = this._ticksByOrdinalNumber; // also support ordinal out of range of `ordinalMeta.categories.length`,
	        // where ordinal numbers are used as tick value directly.
	
	        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
	      };
	      /**
	       * @usage
	       * ```js
	       * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
	       *
	       * // case0
	       * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
	       * // case1
	       * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
	       * // case2
	       * const coord = axis.dataToCoord(ordinalNumber);
	       * ```
	       *
	       * @param {OrdinalNumber} tickNumber index of display
	       */
	
	
	      OrdinalScale.prototype.getRawOrdinalNumber = function (tickNumber) {
	        var ordinalNumbersByTick = this._ordinalNumbersByTick; // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
	        // where ordinal numbers are used as tick value directly.
	
	        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
	      };
	      /**
	       * Get item on tick
	       */
	
	
	      OrdinalScale.prototype.getLabel = function (tick) {
	        if (!this.isBlank()) {
	          var ordinalNumber = this.getRawOrdinalNumber(tick.value);
	          var cateogry = this._ordinalMeta.categories[ordinalNumber]; // Note that if no data, ordinalMeta.categories is an empty array.
	          // Return empty if it's not exist.
	
	          return cateogry == null ? '' : cateogry + '';
	        }
	      };
	
	      OrdinalScale.prototype.count = function () {
	        return this._extent[1] - this._extent[0] + 1;
	      };
	
	      OrdinalScale.prototype.unionExtentFromData = function (data, dim) {
	        this.unionExtent(data.getApproximateExtent(dim));
	      };
	      /**
	       * @override
	       * If value is in extent range
	       */
	
	
	      OrdinalScale.prototype.isInExtentRange = function (value) {
	        value = this._getTickNumber(value);
	        return this._extent[0] <= value && this._extent[1] >= value;
	      };
	
	      OrdinalScale.prototype.getOrdinalMeta = function () {
	        return this._ordinalMeta;
	      };
	
	      OrdinalScale.prototype.calcNiceTicks = function () {};
	
	      OrdinalScale.prototype.calcNiceExtent = function () {};
	
	      OrdinalScale.type = 'ordinal';
	      return OrdinalScale;
	    }(Scale);
	
	    Scale.registerClass(OrdinalScale);
	
	    var roundNumber = round;
	
	    var IntervalScale =
	    /** @class */
	    function (_super) {
	      __extends(IntervalScale, _super);
	
	      function IntervalScale() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = 'interval'; // Step is calculated in adjustExtent.
	
	        _this._interval = 0;
	        _this._intervalPrecision = 2;
	        return _this;
	      }
	
	      IntervalScale.prototype.parse = function (val) {
	        return val;
	      };
	
	      IntervalScale.prototype.contain = function (val) {
	        return contain$1(val, this._extent);
	      };
	
	      IntervalScale.prototype.normalize = function (val) {
	        return normalize$1(val, this._extent);
	      };
	
	      IntervalScale.prototype.scale = function (val) {
	        return scale$2(val, this._extent);
	      };
	
	      IntervalScale.prototype.setExtent = function (start, end) {
	        var thisExtent = this._extent; // start,end may be a Number like '25',so...
	
	        if (!isNaN(start)) {
	          thisExtent[0] = parseFloat(start);
	        }
	
	        if (!isNaN(end)) {
	          thisExtent[1] = parseFloat(end);
	        }
	      };
	
	      IntervalScale.prototype.unionExtent = function (other) {
	        var extent = this._extent;
	        other[0] < extent[0] && (extent[0] = other[0]);
	        other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
	
	        this.setExtent(extent[0], extent[1]);
	      };
	
	      IntervalScale.prototype.getInterval = function () {
	        return this._interval;
	      };
	
	      IntervalScale.prototype.setInterval = function (interval) {
	        this._interval = interval; // Dropped auto calculated niceExtent and use user-set extent.
	        // We assume user wants to set both interval, min, max to get a better result.
	
	        this._niceExtent = this._extent.slice();
	        this._intervalPrecision = getIntervalPrecision(interval);
	      };
	      /**
	       * @param expandToNicedExtent Whether expand the ticks to niced extent.
	       */
	
	
	      IntervalScale.prototype.getTicks = function (expandToNicedExtent) {
	        var interval = this._interval;
	        var extent = this._extent;
	        var niceTickExtent = this._niceExtent;
	        var intervalPrecision = this._intervalPrecision;
	        var ticks = []; // If interval is 0, return [];
	
	        if (!interval) {
	          return ticks;
	        } // Consider this case: using dataZoom toolbox, zoom and zoom.
	
	
	        var safeLimit = 10000;
	
	        if (extent[0] < niceTickExtent[0]) {
	          if (expandToNicedExtent) {
	            ticks.push({
	              value: roundNumber(niceTickExtent[0] - interval, intervalPrecision)
	            });
	          } else {
	            ticks.push({
	              value: extent[0]
	            });
	          }
	        }
	
	        var tick = niceTickExtent[0];
	
	        while (tick <= niceTickExtent[1]) {
	          ticks.push({
	            value: tick
	          }); // Avoid rounding error
	
	          tick = roundNumber(tick + interval, intervalPrecision);
	
	          if (tick === ticks[ticks.length - 1].value) {
	            // Consider out of safe float point, e.g.,
	            // -3711126.9907707 + 2e-10 === -3711126.9907707
	            break;
	          }
	
	          if (ticks.length > safeLimit) {
	            return [];
	          }
	        } // Consider this case: the last item of ticks is smaller
	        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
	
	
	        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
	
	        if (extent[1] > lastNiceTick) {
	          if (expandToNicedExtent) {
	            ticks.push({
	              value: roundNumber(lastNiceTick + interval, intervalPrecision)
	            });
	          } else {
	            ticks.push({
	              value: extent[1]
	            });
	          }
	        }
	
	        return ticks;
	      };
	
	      IntervalScale.prototype.getMinorTicks = function (splitNumber) {
	        var ticks = this.getTicks(true);
	        var minorTicks = [];
	        var extent = this.getExtent();
	
	        for (var i = 1; i < ticks.length; i++) {
	          var nextTick = ticks[i];
	          var prevTick = ticks[i - 1];
	          var count = 0;
	          var minorTicksGroup = [];
	          var interval = nextTick.value - prevTick.value;
	          var minorInterval = interval / splitNumber;
	
	          while (count < splitNumber - 1) {
	            var minorTick = roundNumber(prevTick.value + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
	
	            if (minorTick > extent[0] && minorTick < extent[1]) {
	              minorTicksGroup.push(minorTick);
	            }
	
	            count++;
	          }
	
	          minorTicks.push(minorTicksGroup);
	        }
	
	        return minorTicks;
	      };
	      /**
	       * @param opt.precision If 'auto', use nice presision.
	       * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
	       */
	
	
	      IntervalScale.prototype.getLabel = function (data, opt) {
	        if (data == null) {
	          return '';
	        }
	
	        var precision = opt && opt.precision;
	
	        if (precision == null) {
	          precision = getPrecision(data.value) || 0;
	        } else if (precision === 'auto') {
	          // Should be more precise then tick.
	          precision = this._intervalPrecision;
	        } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
	        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
	
	
	        var dataNum = roundNumber(data.value, precision, true);
	        return addCommas(dataNum);
	      };
	      /**
	       * @param splitNumber By default `5`.
	       */
	
	
	      IntervalScale.prototype.calcNiceTicks = function (splitNumber, minInterval, maxInterval) {
	        splitNumber = splitNumber || 5;
	        var extent = this._extent;
	        var span = extent[1] - extent[0];
	
	        if (!isFinite(span)) {
	          return;
	        } // User may set axis min 0 and data are all negative
	        // FIXME If it needs to reverse ?
	
	
	        if (span < 0) {
	          span = -span;
	          extent.reverse();
	        }
	
	        var result = intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
	        this._intervalPrecision = result.intervalPrecision;
	        this._interval = result.interval;
	        this._niceExtent = result.niceTickExtent;
	      };
	
	      IntervalScale.prototype.calcNiceExtent = function (opt) {
	        var extent = this._extent; // If extent start and end are same, expand them
	
	        if (extent[0] === extent[1]) {
	          if (extent[0] !== 0) {
	            // Expand extent
	            // Note that extents can be both negative. See #13154
	            var expandSize = Math.abs(extent[0]); // In the fowllowing case
	            //      Axis has been fixed max 100
	            //      Plus data are all 100 and axis extent are [100, 100].
	            // Extend to the both side will cause expanded max is larger than fixed max.
	            // So only expand to the smaller side.
	
	            if (!opt.fixMax) {
	              extent[1] += expandSize / 2;
	              extent[0] -= expandSize / 2;
	            } else {
	              extent[0] -= expandSize / 2;
	            }
	          } else {
	            extent[1] = 1;
	          }
	        }
	
	        var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
	
	        if (!isFinite(span)) {
	          extent[0] = 0;
	          extent[1] = 1;
	        }
	
	        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // let extent = this._extent;
	
	        var interval = this._interval;
	
	        if (!opt.fixMin) {
	          extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
	        }
	
	        if (!opt.fixMax) {
	          extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
	        }
	      };
	
	      IntervalScale.prototype.setNiceExtent = function (min, max) {
	        this._niceExtent = [min, max];
	      };
	
	      IntervalScale.type = 'interval';
	      return IntervalScale;
	    }(Scale);
	
	    Scale.registerClass(IntervalScale);
	
	    /* global Float32Array */
	
	    var supportFloat32Array = typeof Float32Array !== 'undefined';
	    var Float32ArrayCtor = !supportFloat32Array ? Array : Float32Array;
	    function createFloat32Array(arg) {
	      if (isArray(arg)) {
	        // Return self directly if don't support TypedArray.
	        return supportFloat32Array ? new Float32Array(arg) : arg;
	      } // Else is number
	
	
	      return new Float32ArrayCtor(arg);
	    }
	
	    var STACK_PREFIX = '__ec_stack_';
	
	    function getSeriesStackId(seriesModel) {
	      return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
	    }
	
	    function getAxisKey(axis) {
	      return axis.dim + axis.index;
	    }
	    /**
	     * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
	     */
	
	
	    function getLayoutOnAxis(opt) {
	      var params = [];
	      var baseAxis = opt.axis;
	      var axisKey = 'axis0';
	
	      if (baseAxis.type !== 'category') {
	        return;
	      }
	
	      var bandWidth = baseAxis.getBandWidth();
	
	      for (var i = 0; i < opt.count || 0; i++) {
	        params.push(defaults({
	          bandWidth: bandWidth,
	          axisKey: axisKey,
	          stackId: STACK_PREFIX + i
	        }, opt));
	      }
	
	      var widthAndOffsets = doCalBarWidthAndOffset(params);
	      var result = [];
	
	      for (var i = 0; i < opt.count; i++) {
	        var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
	        item.offsetCenter = item.offset + item.width / 2;
	        result.push(item);
	      }
	
	      return result;
	    }
	    function prepareLayoutBarSeries(seriesType, ecModel) {
	      var seriesModels = [];
	      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	        // Check series coordinate, do layout for cartesian2d only
	        if (isOnCartesian(seriesModel)) {
	          seriesModels.push(seriesModel);
	        }
	      });
	      return seriesModels;
	    }
	    /**
	     * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
	     * values.
	     * This works for time axes, value axes, and log axes.
	     * For a single time axis, return value is in the form like
	     * {'x_0': [1000000]}.
	     * The value of 1000000 is in milliseconds.
	     */
	
	    function getValueAxesMinGaps(barSeries) {
	      /**
	       * Map from axis.index to values.
	       * For a single time axis, axisValues is in the form like
	       * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
	       * Items in axisValues[x], e.g. 1495555200000, are time values of all
	       * series.
	       */
	      var axisValues = {};
	      each(barSeries, function (seriesModel) {
	        var cartesian = seriesModel.coordinateSystem;
	        var baseAxis = cartesian.getBaseAxis();
	
	        if (baseAxis.type !== 'time' && baseAxis.type !== 'value') {
	          return;
	        }
	
	        var data = seriesModel.getData();
	        var key = baseAxis.dim + '_' + baseAxis.index;
	        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
	        var store = data.getStore();
	
	        for (var i = 0, cnt = store.count(); i < cnt; ++i) {
	          var value = store.get(dimIdx, i);
	
	          if (!axisValues[key]) {
	            // No previous data for the axis
	            axisValues[key] = [value];
	          } else {
	            // No value in previous series
	            axisValues[key].push(value);
	          } // Ignore duplicated time values in the same axis
	
	        }
	      });
	      var axisMinGaps = {};
	
	      for (var key in axisValues) {
	        if (axisValues.hasOwnProperty(key)) {
	          var valuesInAxis = axisValues[key];
	
	          if (valuesInAxis) {
	            // Sort axis values into ascending order to calculate gaps
	            valuesInAxis.sort(function (a, b) {
	              return a - b;
	            });
	            var min = null;
	
	            for (var j = 1; j < valuesInAxis.length; ++j) {
	              var delta = valuesInAxis[j] - valuesInAxis[j - 1];
	
	              if (delta > 0) {
	                // Ignore 0 delta because they are of the same axis value
	                min = min === null ? delta : Math.min(min, delta);
	              }
	            } // Set to null if only have one data
	
	
	            axisMinGaps[key] = min;
	          }
	        }
	      }
	
	      return axisMinGaps;
	    }
	
	    function makeColumnLayout(barSeries) {
	      var axisMinGaps = getValueAxesMinGaps(barSeries);
	      var seriesInfoList = [];
	      each(barSeries, function (seriesModel) {
	        var cartesian = seriesModel.coordinateSystem;
	        var baseAxis = cartesian.getBaseAxis();
	        var axisExtent = baseAxis.getExtent();
	        var bandWidth;
	
	        if (baseAxis.type === 'category') {
	          bandWidth = baseAxis.getBandWidth();
	        } else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
	          var key = baseAxis.dim + '_' + baseAxis.index;
	          var minGap = axisMinGaps[key];
	          var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
	          var scale = baseAxis.scale.getExtent();
	          var scaleSpan = Math.abs(scale[1] - scale[0]);
	          bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
	        } else {
	          var data = seriesModel.getData();
	          bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	        }
	
	        var barWidth = parsePercent$1(seriesModel.get('barWidth'), bandWidth);
	        var barMaxWidth = parsePercent$1(seriesModel.get('barMaxWidth'), bandWidth);
	        var barMinWidth = parsePercent$1( // barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
	        // the auto-calculated bar width might be less than 0.5 / 1.
	        seriesModel.get('barMinWidth') || (isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
	        var barGap = seriesModel.get('barGap');
	        var barCategoryGap = seriesModel.get('barCategoryGap');
	        seriesInfoList.push({
	          bandWidth: bandWidth,
	          barWidth: barWidth,
	          barMaxWidth: barMaxWidth,
	          barMinWidth: barMinWidth,
	          barGap: barGap,
	          barCategoryGap: barCategoryGap,
	          axisKey: getAxisKey(baseAxis),
	          stackId: getSeriesStackId(seriesModel)
	        });
	      });
	      return doCalBarWidthAndOffset(seriesInfoList);
	    }
	
	    function doCalBarWidthAndOffset(seriesInfoList) {
	      // Columns info on each category axis. Key is cartesian name
	      var columnsMap = {};
	      each(seriesInfoList, function (seriesInfo, idx) {
	        var axisKey = seriesInfo.axisKey;
	        var bandWidth = seriesInfo.bandWidth;
	        var columnsOnAxis = columnsMap[axisKey] || {
	          bandWidth: bandWidth,
	          remainedWidth: bandWidth,
	          autoWidthCount: 0,
	          categoryGap: null,
	          gap: '20%',
	          stacks: {}
	        };
	        var stacks = columnsOnAxis.stacks;
	        columnsMap[axisKey] = columnsOnAxis;
	        var stackId = seriesInfo.stackId;
	
	        if (!stacks[stackId]) {
	          columnsOnAxis.autoWidthCount++;
	        }
	
	        stacks[stackId] = stacks[stackId] || {
	          width: 0,
	          maxWidth: 0
	        }; // Caution: In a single coordinate system, these barGrid attributes
	        // will be shared by series. Consider that they have default values,
	        // only the attributes set on the last series will work.
	        // Do not change this fact unless there will be a break change.
	
	        var barWidth = seriesInfo.barWidth;
	
	        if (barWidth && !stacks[stackId].width) {
	          // See #6312, do not restrict width.
	          stacks[stackId].width = barWidth;
	          barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	          columnsOnAxis.remainedWidth -= barWidth;
	        }
	
	        var barMaxWidth = seriesInfo.barMaxWidth;
	        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	        var barMinWidth = seriesInfo.barMinWidth;
	        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
	        var barGap = seriesInfo.barGap;
	        barGap != null && (columnsOnAxis.gap = barGap);
	        var barCategoryGap = seriesInfo.barCategoryGap;
	        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	      });
	      var result = {};
	      each(columnsMap, function (columnsOnAxis, coordSysName) {
	        result[coordSysName] = {};
	        var stacks = columnsOnAxis.stacks;
	        var bandWidth = columnsOnAxis.bandWidth;
	        var categoryGapPercent = columnsOnAxis.categoryGap;
	
	        if (categoryGapPercent == null) {
	          var columnCount = keys(stacks).length; // More columns in one group
	          // the spaces between group is smaller. Or the column will be too thin.
	
	          categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
	        }
	
	        var categoryGap = parsePercent$1(categoryGapPercent, bandWidth);
	        var barGapPercent = parsePercent$1(columnsOnAxis.gap, 1);
	        var remainedWidth = columnsOnAxis.remainedWidth;
	        var autoWidthCount = columnsOnAxis.autoWidthCount;
	        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	        autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	        each(stacks, function (column) {
	          var maxWidth = column.maxWidth;
	          var minWidth = column.minWidth;
	
	          if (!column.width) {
	            var finalWidth = autoWidth;
	
	            if (maxWidth && maxWidth < finalWidth) {
	              finalWidth = Math.min(maxWidth, remainedWidth);
	            } // `minWidth` has higher priority. `minWidth` decide that whether the
	            // bar is able to be visible. So `minWidth` should not be restricted
	            // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
	            // the extreme cases for `value` axis, bars are allowed to overlap
	            // with each other if `minWidth` specified.
	
	
	            if (minWidth && minWidth > finalWidth) {
	              finalWidth = minWidth;
	            }
	
	            if (finalWidth !== autoWidth) {
	              column.width = finalWidth;
	              remainedWidth -= finalWidth + barGapPercent * finalWidth;
	              autoWidthCount--;
	            }
	          } else {
	            // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
	            // CSS does. Because barWidth can be a percent value, where
	            // `barMaxWidth` can be used to restrict the final width.
	            var finalWidth = column.width;
	
	            if (maxWidth) {
	              finalWidth = Math.min(finalWidth, maxWidth);
	            } // `minWidth` has higher priority, as described above
	
	
	            if (minWidth) {
	              finalWidth = Math.max(finalWidth, minWidth);
	            }
	
	            column.width = finalWidth;
	            remainedWidth -= finalWidth + barGapPercent * finalWidth;
	            autoWidthCount--;
	          }
	        }); // Recalculate width again
	
	        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	        autoWidth = Math.max(autoWidth, 0);
	        var widthSum = 0;
	        var lastColumn;
	        each(stacks, function (column, idx) {
	          if (!column.width) {
	            column.width = autoWidth;
	          }
	
	          lastColumn = column;
	          widthSum += column.width * (1 + barGapPercent);
	        });
	
	        if (lastColumn) {
	          widthSum -= lastColumn.width * barGapPercent;
	        }
	
	        var offset = -widthSum / 2;
	        each(stacks, function (column, stackId) {
	          result[coordSysName][stackId] = result[coordSysName][stackId] || {
	            bandWidth: bandWidth,
	            offset: offset,
	            width: column.width
	          };
	          offset += column.width * (1 + barGapPercent);
	        });
	      });
	      return result;
	    }
	
	    function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
	      if (barWidthAndOffset && axis) {
	        var result = barWidthAndOffset[getAxisKey(axis)];
	
	        if (result != null && seriesModel != null) {
	          return result[getSeriesStackId(seriesModel)];
	        }
	
	        return result;
	      }
	    }
	    function layout(seriesType, ecModel) {
	      var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
	      var barWidthAndOffset = makeColumnLayout(seriesModels);
	      each(seriesModels, function (seriesModel) {
	        var data = seriesModel.getData();
	        var cartesian = seriesModel.coordinateSystem;
	        var baseAxis = cartesian.getBaseAxis();
	        var stackId = getSeriesStackId(seriesModel);
	        var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
	        var columnOffset = columnLayoutInfo.offset;
	        var columnWidth = columnLayoutInfo.width;
	        data.setLayout({
	          bandWidth: columnLayoutInfo.bandWidth,
	          offset: columnOffset,
	          size: columnWidth
	        });
	      });
	    } // TODO: Do not support stack in large mode yet.
	
	    function createProgressiveLayout(seriesType) {
	      return {
	        seriesType: seriesType,
	        plan: createRenderPlanner(),
	        reset: function (seriesModel) {
	          if (!isOnCartesian(seriesModel)) {
	            return;
	          }
	
	          var data = seriesModel.getData();
	          var cartesian = seriesModel.coordinateSystem;
	          var baseAxis = cartesian.getBaseAxis();
	          var valueAxis = cartesian.getOtherAxis(baseAxis);
	          var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
	          var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
	          var drawBackground = seriesModel.get('showBackground', true);
	          var valueDim = data.mapDimension(valueAxis.dim);
	          var stackResultDim = data.getCalculationInfo('stackResultDimension');
	          var stacked = isDimensionStacked(data, valueDim) && !!data.getCalculationInfo('stackedOnSeries');
	          var isValueAxisH = valueAxis.isHorizontal();
	          var valueAxisStart = getValueAxisStart(baseAxis, valueAxis);
	          var isLarge = isInLargeMode(seriesModel);
	          var barMinHeight = seriesModel.get('barMinHeight') || 0;
	          var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim); // Layout info.
	
	          var columnWidth = data.getLayout('size');
	          var columnOffset = data.getLayout('offset');
	          return {
	            progress: function (params, data) {
	              var count = params.count;
	              var largePoints = isLarge && createFloat32Array(count * 3);
	              var largeBackgroundPoints = isLarge && drawBackground && createFloat32Array(count * 3);
	              var largeDataIndices = isLarge && createFloat32Array(count);
	              var coordLayout = cartesian.master.getRect();
	              var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
	              var dataIndex;
	              var store = data.getStore();
	              var idxOffset = 0;
	
	              while ((dataIndex = params.next()) != null) {
	                var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
	                var baseValue = store.get(baseDimIdx, dataIndex);
	                var baseCoord = valueAxisStart;
	                var startValue = void 0; // Because of the barMinHeight, we can not use the value in
	                // stackResultDimension directly.
	
	                if (stacked) {
	                  startValue = +value - store.get(valueDimIdx, dataIndex);
	                }
	
	                var x = void 0;
	                var y = void 0;
	                var width = void 0;
	                var height = void 0;
	
	                if (isValueAxisH) {
	                  var coord = cartesian.dataToPoint([value, baseValue]);
	
	                  if (stacked) {
	                    var startCoord = cartesian.dataToPoint([startValue, baseValue]);
	                    baseCoord = startCoord[0];
	                  }
	
	                  x = baseCoord;
	                  y = coord[1] + columnOffset;
	                  width = coord[0] - baseCoord;
	                  height = columnWidth;
	
	                  if (Math.abs(width) < barMinHeight) {
	                    width = (width < 0 ? -1 : 1) * barMinHeight;
	                  }
	                } else {
	                  var coord = cartesian.dataToPoint([baseValue, value]);
	
	                  if (stacked) {
	                    var startCoord = cartesian.dataToPoint([baseValue, startValue]);
	                    baseCoord = startCoord[1];
	                  }
	
	                  x = coord[0] + columnOffset;
	                  y = baseCoord;
	                  width = columnWidth;
	                  height = coord[1] - baseCoord;
	
	                  if (Math.abs(height) < barMinHeight) {
	                    // Include zero to has a positive bar
	                    height = (height <= 0 ? -1 : 1) * barMinHeight;
	                  }
	                }
	
	                if (!isLarge) {
	                  data.setItemLayout(dataIndex, {
	                    x: x,
	                    y: y,
	                    width: width,
	                    height: height
	                  });
	                } else {
	                  largePoints[idxOffset] = x;
	                  largePoints[idxOffset + 1] = y;
	                  largePoints[idxOffset + 2] = isValueAxisH ? width : height;
	
	                  if (largeBackgroundPoints) {
	                    largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
	                    largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
	                    largeBackgroundPoints[idxOffset + 2] = bgSize;
	                  }
	
	                  largeDataIndices[dataIndex] = dataIndex;
	                }
	
	                idxOffset += 3;
	              }
	
	              if (isLarge) {
	                data.setLayout({
	                  largePoints: largePoints,
	                  largeDataIndices: largeDataIndices,
	                  largeBackgroundPoints: largeBackgroundPoints,
	                  valueAxisHorizontal: isValueAxisH
	                });
	              }
	            }
	          };
	        }
	      };
	    }
	
	    function isOnCartesian(seriesModel) {
	      return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
	    }
	
	    function isInLargeMode(seriesModel) {
	      return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
	    } // See cases in `test/bar-start.html` and `#7412`, `#8747`.
	
	
	    function getValueAxisStart(baseAxis, valueAxis) {
	      return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
	    }
	
	    var bisect = function (a, x, lo, hi) {
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	
	        if (a[mid][1] < x) {
	          lo = mid + 1;
	        } else {
	          hi = mid;
	        }
	      }
	
	      return lo;
	    };
	
	    var TimeScale =
	    /** @class */
	    function (_super) {
	      __extends(TimeScale, _super);
	
	      function TimeScale(settings) {
	        var _this = _super.call(this, settings) || this;
	
	        _this.type = 'time';
	        return _this;
	      }
	      /**
	       * Get label is mainly for other components like dataZoom, tooltip.
	       */
	
	
	      TimeScale.prototype.getLabel = function (tick) {
	        var useUTC = this.getSetting('useUTC');
	        return format(tick.value, fullLeveledFormatter[getDefaultFormatPrecisionOfInterval(getPrimaryTimeUnit(this._minLevelUnit))] || fullLeveledFormatter.second, useUTC, this.getSetting('locale'));
	      };
	
	      TimeScale.prototype.getFormattedLabel = function (tick, idx, labelFormatter) {
	        var isUTC = this.getSetting('useUTC');
	        var lang = this.getSetting('locale');
	        return leveledFormat(tick, idx, labelFormatter, lang, isUTC);
	      };
	      /**
	       * @override
	       */
	
	
	      TimeScale.prototype.getTicks = function () {
	        var interval = this._interval;
	        var extent = this._extent;
	        var ticks = []; // If interval is 0, return [];
	
	        if (!interval) {
	          return ticks;
	        }
	
	        ticks.push({
	          value: extent[0],
	          level: 0
	        });
	        var useUTC = this.getSetting('useUTC');
	        var innerTicks = getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
	        ticks = ticks.concat(innerTicks);
	        ticks.push({
	          value: extent[1],
	          level: 0
	        });
	        return ticks;
	      };
	
	      TimeScale.prototype.calcNiceExtent = function (opt) {
	        var extent = this._extent; // If extent start and end are same, expand them
	
	        if (extent[0] === extent[1]) {
	          // Expand extent
	          extent[0] -= ONE_DAY;
	          extent[1] += ONE_DAY;
	        } // If there are no data and extent are [Infinity, -Infinity]
	
	
	        if (extent[1] === -Infinity && extent[0] === Infinity) {
	          var d = new Date();
	          extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
	          extent[0] = extent[1] - ONE_DAY;
	        }
	
	        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
	      };
	
	      TimeScale.prototype.calcNiceTicks = function (approxTickNum, minInterval, maxInterval) {
	        approxTickNum = approxTickNum || 10;
	        var extent = this._extent;
	        var span = extent[1] - extent[0];
	        this._approxInterval = span / approxTickNum;
	
	        if (minInterval != null && this._approxInterval < minInterval) {
	          this._approxInterval = minInterval;
	        }
	
	        if (maxInterval != null && this._approxInterval > maxInterval) {
	          this._approxInterval = maxInterval;
	        }
	
	        var scaleIntervalsLen = scaleIntervals.length;
	        var idx = Math.min(bisect(scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1); // Interval that can be used to calculate ticks
	
	        this._interval = scaleIntervals[idx][1]; // Min level used when picking ticks from top down.
	        // We check one more level to avoid the ticks are to sparse in some case.
	
	        this._minLevelUnit = scaleIntervals[Math.max(idx - 1, 0)][0];
	      };
	
	      TimeScale.prototype.parse = function (val) {
	        // val might be float.
	        return isNumber(val) ? val : +parseDate(val);
	      };
	
	      TimeScale.prototype.contain = function (val) {
	        return contain$1(this.parse(val), this._extent);
	      };
	
	      TimeScale.prototype.normalize = function (val) {
	        return normalize$1(this.parse(val), this._extent);
	      };
	
	      TimeScale.prototype.scale = function (val) {
	        return scale$2(val, this._extent);
	      };
	
	      TimeScale.type = 'time';
	      return TimeScale;
	    }(IntervalScale);
	    /**
	     * This implementation was originally copied from "d3.js"
	     * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
	     * with some modifications made for this program.
	     * See the license statement at the head of this file.
	     */
	
	
	    var scaleIntervals = [// Format                           interval
	    ['second', ONE_SECOND], ['minute', ONE_MINUTE], ['hour', ONE_HOUR], ['quarter-day', ONE_HOUR * 6], ['half-day', ONE_HOUR * 12], ['day', ONE_DAY * 1.2], ['half-week', ONE_DAY * 3.5], ['week', ONE_DAY * 7], ['month', ONE_DAY * 31], ['quarter', ONE_DAY * 95], ['half-year', ONE_YEAR / 2], ['year', ONE_YEAR] // 1Y
	    ];
	
	    function isUnitValueSame(unit, valueA, valueB, isUTC) {
	      var dateA = parseDate(valueA);
	      var dateB = parseDate(valueB);
	
	      var isSame = function (unit) {
	        return getUnitValue(dateA, unit, isUTC) === getUnitValue(dateB, unit, isUTC);
	      };
	
	      var isSameYear = function () {
	        return isSame('year');
	      }; // const isSameHalfYear = () => isSameYear() && isSame('half-year');
	      // const isSameQuater = () => isSameYear() && isSame('quarter');
	
	
	      var isSameMonth = function () {
	        return isSameYear() && isSame('month');
	      };
	
	      var isSameDay = function () {
	        return isSameMonth() && isSame('day');
	      }; // const isSameHalfDay = () => isSameDay() && isSame('half-day');
	
	
	      var isSameHour = function () {
	        return isSameDay() && isSame('hour');
	      };
	
	      var isSameMinute = function () {
	        return isSameHour() && isSame('minute');
	      };
	
	      var isSameSecond = function () {
	        return isSameMinute() && isSame('second');
	      };
	
	      var isSameMilliSecond = function () {
	        return isSameSecond() && isSame('millisecond');
	      };
	
	      switch (unit) {
	        case 'year':
	          return isSameYear();
	
	        case 'month':
	          return isSameMonth();
	
	        case 'day':
	          return isSameDay();
	
	        case 'hour':
	          return isSameHour();
	
	        case 'minute':
	          return isSameMinute();
	
	        case 'second':
	          return isSameSecond();
	
	        case 'millisecond':
	          return isSameMilliSecond();
	      }
	    } // const primaryUnitGetters = {
	    //     year: fullYearGetterName(),
	    //     month: monthGetterName(),
	    //     day: dateGetterName(),
	    //     hour: hoursGetterName(),
	    //     minute: minutesGetterName(),
	    //     second: secondsGetterName(),
	    //     millisecond: millisecondsGetterName()
	    // };
	    // const primaryUnitUTCGetters = {
	    //     year: fullYearGetterName(true),
	    //     month: monthGetterName(true),
	    //     day: dateGetterName(true),
	    //     hour: hoursGetterName(true),
	    //     minute: minutesGetterName(true),
	    //     second: secondsGetterName(true),
	    //     millisecond: millisecondsGetterName(true)
	    // };
	    // function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
	    //     step = step || 1;
	    //     switch (getPrimaryTimeUnit(unitName)) {
	    //         case 'year':
	    //             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
	    //             break;
	    //         case 'month':
	    //             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
	    //             break;
	    //         case 'day':
	    //             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
	    //             break;
	    //         case 'hour':
	    //             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
	    //             break;
	    //         case 'minute':
	    //             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
	    //             break;
	    //         case 'second':
	    //             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
	    //             break;
	    //         case 'millisecond':
	    //             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
	    //             break;
	    //     }
	    //     return date.getTime();
	    // }
	    // const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
	    // const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
	    // const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
	
	
	    function getDateInterval(approxInterval, daysInMonth) {
	      approxInterval /= ONE_DAY;
	      return approxInterval > 16 ? 16 // Math.floor(daysInMonth / 2) + 1  // In this case we only want one tick between two months.
	      : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
	      : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
	    }
	
	    function getMonthInterval(approxInterval) {
	      var APPROX_ONE_MONTH = 30 * ONE_DAY;
	      approxInterval /= APPROX_ONE_MONTH;
	      return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
	    }
	
	    function getHourInterval(approxInterval) {
	      approxInterval /= ONE_HOUR;
	      return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
	    }
	
	    function getMinutesAndSecondsInterval(approxInterval, isMinutes) {
	      approxInterval /= isMinutes ? ONE_MINUTE : ONE_SECOND;
	      return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
	    }
	
	    function getMillisecondsInterval(approxInterval) {
	      return nice(approxInterval, true);
	    }
	
	    function getFirstTimestampOfUnit(date, unitName, isUTC) {
	      var outDate = new Date(date);
	
	      switch (getPrimaryTimeUnit(unitName)) {
	        case 'year':
	        case 'month':
	          outDate[monthSetterName(isUTC)](0);
	
	        case 'day':
	          outDate[dateSetterName(isUTC)](1);
	
	        case 'hour':
	          outDate[hoursSetterName(isUTC)](0);
	
	        case 'minute':
	          outDate[minutesSetterName(isUTC)](0);
	
	        case 'second':
	          outDate[secondsSetterName(isUTC)](0);
	          outDate[millisecondsSetterName(isUTC)](0);
	      }
	
	      return outDate.getTime();
	    }
	
	    function getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
	      var safeLimit = 10000;
	      var unitNames = timeUnits;
	      var iter = 0;
	
	      function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
	        var date = new Date(minTimestamp);
	        var dateTime = minTimestamp;
	        var d = date[getMethodName](); // if (isDate) {
	        //     d -= 1; // Starts with 0;   PENDING
	        // }
	
	        while (dateTime < maxTimestamp && dateTime <= extent[1]) {
	          out.push({
	            value: dateTime
	          });
	          d += interval;
	          date[setMethodName](d);
	          dateTime = date.getTime();
	        } // This extra tick is for calcuating ticks of next level. Will not been added to the final result
	
	
	        out.push({
	          value: dateTime,
	          notAdd: true
	        });
	      }
	
	      function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
	        var newAddedTicks = [];
	        var isFirstLevel = !lastLevelTicks.length;
	
	        if (isUnitValueSame(getPrimaryTimeUnit(unitName), extent[0], extent[1], isUTC)) {
	          return;
	        }
	
	        if (isFirstLevel) {
	          lastLevelTicks = [{
	            // TODO Optimize. Not include so may ticks.
	            value: getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
	          }, {
	            value: extent[1]
	          }];
	        }
	
	        for (var i = 0; i < lastLevelTicks.length - 1; i++) {
	          var startTick = lastLevelTicks[i].value;
	          var endTick = lastLevelTicks[i + 1].value;
	
	          if (startTick === endTick) {
	            continue;
	          }
	
	          var interval = void 0;
	          var getterName = void 0;
	          var setterName = void 0;
	          var isDate = false;
	
	          switch (unitName) {
	            case 'year':
	              interval = Math.max(1, Math.round(approxInterval / ONE_DAY / 365));
	              getterName = fullYearGetterName(isUTC);
	              setterName = fullYearSetterName(isUTC);
	              break;
	
	            case 'half-year':
	            case 'quarter':
	            case 'month':
	              interval = getMonthInterval(approxInterval);
	              getterName = monthGetterName(isUTC);
	              setterName = monthSetterName(isUTC);
	              break;
	
	            case 'week': // PENDING If week is added. Ignore day.
	
	            case 'half-week':
	            case 'day':
	              interval = getDateInterval(approxInterval); // Use 32 days and let interval been 16
	
	              getterName = dateGetterName(isUTC);
	              setterName = dateSetterName(isUTC);
	              isDate = true;
	              break;
	
	            case 'half-day':
	            case 'quarter-day':
	            case 'hour':
	              interval = getHourInterval(approxInterval);
	              getterName = hoursGetterName(isUTC);
	              setterName = hoursSetterName(isUTC);
	              break;
	
	            case 'minute':
	              interval = getMinutesAndSecondsInterval(approxInterval, true);
	              getterName = minutesGetterName(isUTC);
	              setterName = minutesSetterName(isUTC);
	              break;
	
	            case 'second':
	              interval = getMinutesAndSecondsInterval(approxInterval, false);
	              getterName = secondsGetterName(isUTC);
	              setterName = secondsSetterName(isUTC);
	              break;
	
	            case 'millisecond':
	              interval = getMillisecondsInterval(approxInterval);
	              getterName = millisecondsGetterName(isUTC);
	              setterName = millisecondsSetterName(isUTC);
	              break;
	          }
	
	          addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
	
	          if (unitName === 'year' && levelTicks.length > 1 && i === 0) {
	            // Add nearest years to the left extent.
	            levelTicks.unshift({
	              value: levelTicks[0].value - interval
	            });
	          }
	        }
	
	        for (var i = 0; i < newAddedTicks.length; i++) {
	          levelTicks.push(newAddedTicks[i]);
	        } // newAddedTicks.length && console.log(unitName, newAddedTicks);
	
	
	        return newAddedTicks;
	      }
	
	      var levelsTicks = [];
	      var currentLevelTicks = [];
	      var tickCount = 0;
	      var lastLevelTickCount = 0;
	
	      for (var i = 0; i < unitNames.length && iter++ < safeLimit; ++i) {
	        var primaryTimeUnit = getPrimaryTimeUnit(unitNames[i]);
	
	        if (!isPrimaryTimeUnit(unitNames[i])) {
	          // TODO
	          continue;
	        }
	
	        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
	        var nextPrimaryTimeUnit = unitNames[i + 1] ? getPrimaryTimeUnit(unitNames[i + 1]) : null;
	
	        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
	          if (currentLevelTicks.length) {
	            lastLevelTickCount = tickCount; // Remove the duplicate so the tick count can be precisely.
	
	            currentLevelTicks.sort(function (a, b) {
	              return a.value - b.value;
	            });
	            var levelTicksRemoveDuplicated = [];
	
	            for (var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1) {
	              var tickValue = currentLevelTicks[i_1].value;
	
	              if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
	                levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
	
	                if (tickValue >= extent[0] && tickValue <= extent[1]) {
	                  tickCount++;
	                }
	              }
	            }
	
	            var targetTickNum = (extent[1] - extent[0]) / approxInterval; // Added too much in this level and not too less in last level
	
	            if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) {
	              break;
	            } // Only treat primary time unit as one level.
	
	
	            levelsTicks.push(levelTicksRemoveDuplicated);
	
	            if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) {
	              break;
	            }
	          } // Reset if next unitName is primary
	
	
	          currentLevelTicks = [];
	        }
	      }
	
	      if (true) {
	        if (iter >= safeLimit) {
	          warn('Exceed safe limit.');
	        }
	      }
	
	      var levelsTicksInExtent = filter(map(levelsTicks, function (levelTicks) {
	        return filter(levelTicks, function (tick) {
	          return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
	        });
	      }), function (levelTicks) {
	        return levelTicks.length > 0;
	      });
	      var ticks = [];
	      var maxLevel = levelsTicksInExtent.length - 1;
	
	      for (var i = 0; i < levelsTicksInExtent.length; ++i) {
	        var levelTicks = levelsTicksInExtent[i];
	
	        for (var k = 0; k < levelTicks.length; ++k) {
	          ticks.push({
	            value: levelTicks[k].value,
	            level: maxLevel - i
	          });
	        }
	      }
	
	      ticks.sort(function (a, b) {
	        return a.value - b.value;
	      }); // Remove duplicates
	
	      var result = [];
	
	      for (var i = 0; i < ticks.length; ++i) {
	        if (i === 0 || ticks[i].value !== ticks[i - 1].value) {
	          result.push(ticks[i]);
	        }
	      }
	
	      return result;
	    }
	
	    Scale.registerClass(TimeScale);
	
	    var scaleProto = Scale.prototype; // FIXME:TS refactor: not good to call it directly with `this`?
	
	    var intervalScaleProto = IntervalScale.prototype;
	    var roundingErrorFix = round;
	    var mathFloor = Math.floor;
	    var mathCeil = Math.ceil;
	    var mathPow$1 = Math.pow;
	    var mathLog = Math.log;
	
	    var LogScale =
	    /** @class */
	    function (_super) {
	      __extends(LogScale, _super);
	
	      function LogScale() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = 'log';
	        _this.base = 10;
	        _this._originalScale = new IntervalScale(); // FIXME:TS actually used by `IntervalScale`
	
	        _this._interval = 0;
	        return _this;
	      }
	      /**
	       * @param Whether expand the ticks to niced extent.
	       */
	
	
	      LogScale.prototype.getTicks = function (expandToNicedExtent) {
	        var originalScale = this._originalScale;
	        var extent = this._extent;
	        var originalExtent = originalScale.getExtent();
	        var ticks = intervalScaleProto.getTicks.call(this, expandToNicedExtent);
	        return map(ticks, function (tick) {
	          var val = tick.value;
	          var powVal = round(mathPow$1(this.base, val)); // Fix #4158
	
	          powVal = val === extent[0] && this._fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
	          powVal = val === extent[1] && this._fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
	          return {
	            value: powVal
	          };
	        }, this);
	      };
	
	      LogScale.prototype.setExtent = function (start, end) {
	        var base = mathLog(this.base); // log(-Infinity) is NaN, so safe guard here
	
	        start = mathLog(Math.max(0, start)) / base;
	        end = mathLog(Math.max(0, end)) / base;
	        intervalScaleProto.setExtent.call(this, start, end);
	      };
	      /**
	       * @return {number} end
	       */
	
	
	      LogScale.prototype.getExtent = function () {
	        var base = this.base;
	        var extent = scaleProto.getExtent.call(this);
	        extent[0] = mathPow$1(base, extent[0]);
	        extent[1] = mathPow$1(base, extent[1]); // Fix #4158
	
	        var originalScale = this._originalScale;
	        var originalExtent = originalScale.getExtent();
	        this._fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
	        this._fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
	        return extent;
	      };
	
	      LogScale.prototype.unionExtent = function (extent) {
	        this._originalScale.unionExtent(extent);
	
	        var base = this.base;
	        extent[0] = mathLog(extent[0]) / mathLog(base);
	        extent[1] = mathLog(extent[1]) / mathLog(base);
	        scaleProto.unionExtent.call(this, extent);
	      };
	
	      LogScale.prototype.unionExtentFromData = function (data, dim) {
	        // TODO
	        // filter value that <= 0
	        this.unionExtent(data.getApproximateExtent(dim));
	      };
	      /**
	       * Update interval and extent of intervals for nice ticks
	       * @param approxTickNum default 10 Given approx tick number
	       */
	
	
	      LogScale.prototype.calcNiceTicks = function (approxTickNum) {
	        approxTickNum = approxTickNum || 10;
	        var extent = this._extent;
	        var span = extent[1] - extent[0];
	
	        if (span === Infinity || span <= 0) {
	          return;
	        }
	
	        var interval = quantity(span);
	        var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
	
	        if (err <= 0.5) {
	          interval *= 10;
	        } // Interval should be integer
	
	
	        while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
	          interval *= 10;
	        }
	
	        var niceExtent = [round(mathCeil(extent[0] / interval) * interval), round(mathFloor(extent[1] / interval) * interval)];
	        this._interval = interval;
	        this._niceExtent = niceExtent;
	      };
	
	      LogScale.prototype.calcNiceExtent = function (opt) {
	        intervalScaleProto.calcNiceExtent.call(this, opt);
	        this._fixMin = opt.fixMin;
	        this._fixMax = opt.fixMax;
	      };
	
	      LogScale.prototype.parse = function (val) {
	        return val;
	      };
	
	      LogScale.prototype.contain = function (val) {
	        val = mathLog(val) / mathLog(this.base);
	        return contain$1(val, this._extent);
	      };
	
	      LogScale.prototype.normalize = function (val) {
	        val = mathLog(val) / mathLog(this.base);
	        return normalize$1(val, this._extent);
	      };
	
	      LogScale.prototype.scale = function (val) {
	        val = scale$2(val, this._extent);
	        return mathPow$1(this.base, val);
	      };
	
	      LogScale.type = 'log';
	      return LogScale;
	    }(Scale);
	
	    var proto = LogScale.prototype;
	    proto.getMinorTicks = intervalScaleProto.getMinorTicks;
	    proto.getLabel = intervalScaleProto.getLabel;
	
	    function fixRoundingError(val, originalVal) {
	      return roundingErrorFix(val, getPrecision(originalVal));
	    }
	
	    Scale.registerClass(LogScale);
	
	    var ScaleRawExtentInfo =
	    /** @class */
	    function () {
	      function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
	      originalExtent) {
	        this._prepareParams(scale, model, originalExtent);
	      }
	      /**
	       * Parameters depending on outside (like model, user callback)
	       * are prepared and fixed here.
	       */
	
	
	      ScaleRawExtentInfo.prototype._prepareParams = function (scale, model, // Usually: data extent from all series on this axis.
	      dataExtent) {
	        if (dataExtent[1] < dataExtent[0]) {
	          dataExtent = [NaN, NaN];
	        }
	
	        this._dataMin = dataExtent[0];
	        this._dataMax = dataExtent[1];
	        var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
	        this._needCrossZero = scale.type === 'interval' && model.getNeedCrossZero && model.getNeedCrossZero();
	        var modelMinRaw = this._modelMinRaw = model.get('min', true);
	
	        if (isFunction(modelMinRaw)) {
	          // This callback always provides users the full data extent (before data is filtered).
	          this._modelMinNum = parseAxisModelMinMax(scale, modelMinRaw({
	            min: dataExtent[0],
	            max: dataExtent[1]
	          }));
	        } else if (modelMinRaw !== 'dataMin') {
	          this._modelMinNum = parseAxisModelMinMax(scale, modelMinRaw);
	        }
	
	        var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
	
	        if (isFunction(modelMaxRaw)) {
	          // This callback always provides users the full data extent (before data is filtered).
	          this._modelMaxNum = parseAxisModelMinMax(scale, modelMaxRaw({
	            min: dataExtent[0],
	            max: dataExtent[1]
	          }));
	        } else if (modelMaxRaw !== 'dataMax') {
	          this._modelMaxNum = parseAxisModelMinMax(scale, modelMaxRaw);
	        }
	
	        if (isOrdinal) {
	          // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
	          // and progressive rendering is using, here the category result might just only contain
	          // the processed chunk rather than the entire result.
	          this._axisDataLen = model.getCategories().length;
	        } else {
	          var boundaryGap = model.get('boundaryGap');
	          var boundaryGapArr = isArray(boundaryGap) ? boundaryGap : [boundaryGap || 0, boundaryGap || 0];
	
	          if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') {
	            if (true) {
	              console.warn('Boolean type for boundaryGap is only ' + 'allowed for ordinal axis. Please use string in ' + 'percentage instead, e.g., "20%". Currently, ' + 'boundaryGap is set to be 0.');
	            }
	
	            this._boundaryGapInner = [0, 0];
	          } else {
	            this._boundaryGapInner = [parsePercent(boundaryGapArr[0], 1), parsePercent(boundaryGapArr[1], 1)];
	          }
	        }
	      };
	      /**
	       * Calculate extent by prepared parameters.
	       * This method has no external dependency and can be called duplicatedly,
	       * getting the same result.
	       * If parameters changed, should call this method to recalcuate.
	       */
	
	
	      ScaleRawExtentInfo.prototype.calculate = function () {
	        // Notice: When min/max is not set (that is, when there are null/undefined,
	        // which is the most common case), these cases should be ensured:
	        // (1) For 'ordinal', show all axis.data.
	        // (2) For others:
	        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
	        //      disabled).
	        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
	        //      be the result that originalExtent enlarged by boundaryGap.
	        // (3) If no data, it should be ensured that `scale.setBlank` is set.
	        var isOrdinal = this._isOrdinal;
	        var dataMin = this._dataMin;
	        var dataMax = this._dataMax;
	        var axisDataLen = this._axisDataLen;
	        var boundaryGapInner = this._boundaryGapInner;
	        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null; // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
	        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
	
	        var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
	        var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum; // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
	
	        var minFixed = min != null;
	        var maxFixed = max != null;
	
	        if (min == null) {
	          min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
	        }
	
	        if (max == null) {
	          max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
	        }
	
	        (min == null || !isFinite(min)) && (min = NaN);
	        (max == null || !isFinite(max)) && (max = NaN);
	        var isBlank = eqNaN(min) || eqNaN(max) || isOrdinal && !axisDataLen; // If data extent modified, need to recalculated to ensure cross zero.
	
	        if (this._needCrossZero) {
	          // Axis is over zero and min is not set
	          if (min > 0 && max > 0 && !minFixed) {
	            min = 0; // minFixed = true;
	          } // Axis is under zero and max is not set
	
	
	          if (min < 0 && max < 0 && !maxFixed) {
	            max = 0; // maxFixed = true;
	          } // PENDING:
	          // When `needCrossZero` and all data is positive/negative, should it be ensured
	          // that the results processed by boundaryGap are positive/negative?
	          // If so, here `minFixed`/`maxFixed` need to be set.
	
	        }
	
	        var determinedMin = this._determinedMin;
	        var determinedMax = this._determinedMax;
	
	        if (determinedMin != null) {
	          min = determinedMin;
	          minFixed = true;
	        }
	
	        if (determinedMax != null) {
	          max = determinedMax;
	          maxFixed = true;
	        } // Ensure min/max be finite number or NaN here. (not to be null/undefined)
	        // `NaN` means min/max axis is blank.
	
	
	        return {
	          min: min,
	          max: max,
	          minFixed: minFixed,
	          maxFixed: maxFixed,
	          isBlank: isBlank
	        };
	      };
	
	      ScaleRawExtentInfo.prototype.modifyDataMinMax = function (minMaxName, val) {
	        if (true) {
	          assert(!this.frozen);
	        }
	
	        this[DATA_MIN_MAX_ATTR[minMaxName]] = val;
	      };
	
	      ScaleRawExtentInfo.prototype.setDeterminedMinMax = function (minMaxName, val) {
	        var attr = DETERMINED_MIN_MAX_ATTR[minMaxName];
	
	        if (true) {
	          assert(!this.frozen // Earse them usually means logic flaw.
	          && this[attr] == null);
	        }
	
	        this[attr] = val;
	      };
	
	      ScaleRawExtentInfo.prototype.freeze = function () {
	        // @ts-ignore
	        this.frozen = true;
	      };
	
	      return ScaleRawExtentInfo;
	    }();
	    var DETERMINED_MIN_MAX_ATTR = {
	      min: '_determinedMin',
	      max: '_determinedMax'
	    };
	    var DATA_MIN_MAX_ATTR = {
	      min: '_dataMin',
	      max: '_dataMax'
	    };
	    /**
	     * Get scale min max and related info only depends on model settings.
	     * This method can be called after coordinate system created.
	     * For example, in data processing stage.
	     *
	     * Scale extent info probably be required multiple times during a workflow.
	     * For example:
	     * (1) `dataZoom` depends it to get the axis extent in "100%" state.
	     * (2) `processor/extentCalculator` depends it to make sure whether axis extent is specified.
	     * (3) `coordSys.update` use it to finally decide the scale extent.
	     * But the callback of `min`/`max` should not be called multiple times.
	     * The code below should not be implemented repeatedly either.
	     * So we cache the result in the scale instance, which will be recreated at the beginning
	     * of the workflow (because `scale` instance will be recreated each round of the workflow).
	     */
	
	    function ensureScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
	    originalExtent) {
	      // Do not permit to recreate.
	      var rawExtentInfo = scale.rawExtentInfo;
	
	      if (rawExtentInfo) {
	        return rawExtentInfo;
	      }
	
	      rawExtentInfo = new ScaleRawExtentInfo(scale, model, originalExtent); // @ts-ignore
	
	      scale.rawExtentInfo = rawExtentInfo;
	      return rawExtentInfo;
	    }
	    function parseAxisModelMinMax(scale, minMax) {
	      return minMax == null ? null : eqNaN(minMax) ? NaN : scale.parse(minMax);
	    }
	
	    /**
	     * Get axis scale extent before niced.
	     * Item of returned array can only be number (including Infinity and NaN).
	     *
	     * Caution:
	     * Precondition of calling this method:
	     * The scale extent has been initialized using series data extent via
	     * `scale.setExtent` or `scale.unionExtentFromData`;
	     */
	
	    function getScaleExtent(scale, model) {
	      var scaleType = scale.type;
	      var rawExtentResult = ensureScaleRawExtentInfo(scale, model, scale.getExtent()).calculate();
	      scale.setBlank(rawExtentResult.isBlank);
	      var min = rawExtentResult.min;
	      var max = rawExtentResult.max; // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
	      // is base axis
	      // FIXME
	      // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
	      // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
	      //     Should not depend on series type `bar`?
	      // (3) Fix that might overlap when using dataZoom.
	      // (4) Consider other chart types using `barGrid`?
	      // See #6728, #4862, `test/bar-overflow-time-plot.html`
	
	      var ecModel = model.ecModel;
	
	      if (ecModel && scaleType === 'time'
	      /* || scaleType === 'interval' */
	      ) {
	        var barSeriesModels = prepareLayoutBarSeries('bar', ecModel);
	        var isBaseAxisAndHasBarSeries_1 = false;
	        each(barSeriesModels, function (seriesModel) {
	          isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
	        });
	
	        if (isBaseAxisAndHasBarSeries_1) {
	          // Calculate placement of bars on axis. TODO should be decoupled
	          // with barLayout
	          var barWidthAndOffset = makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow
	
	          var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
	          min = adjustedScale.min;
	          max = adjustedScale.max;
	        }
	      }
	
	      return {
	        extent: [min, max],
	        // "fix" means "fixed", the value should not be
	        // changed in the subsequent steps.
	        fixMin: rawExtentResult.minFixed,
	        fixMax: rawExtentResult.maxFixed
	      };
	    }
	
	    function adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
	    barWidthAndOffset) {
	      // Get Axis Length
	      var axisExtent = model.axis.getExtent();
	      var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
	
	      var barsOnCurrentAxis = retrieveColumnLayout(barWidthAndOffset, model.axis);
	
	      if (barsOnCurrentAxis === undefined) {
	        return {
	          min: min,
	          max: max
	        };
	      }
	
	      var minOverflow = Infinity;
	      each(barsOnCurrentAxis, function (item) {
	        minOverflow = Math.min(item.offset, minOverflow);
	      });
	      var maxOverflow = -Infinity;
	      each(barsOnCurrentAxis, function (item) {
	        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
	      });
	      minOverflow = Math.abs(minOverflow);
	      maxOverflow = Math.abs(maxOverflow);
	      var totalOverFlow = minOverflow + maxOverflow; // Calculate required buffer based on old range and overflow
	
	      var oldRange = max - min;
	      var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
	      var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
	      max += overflowBuffer * (maxOverflow / totalOverFlow);
	      min -= overflowBuffer * (minOverflow / totalOverFlow);
	      return {
	        min: min,
	        max: max
	      };
	    } // Precondition of calling this method:
	    // The scale extent has been initialized using series data extent via
	    // `scale.setExtent` or `scale.unionExtentFromData`;
	
	
	    function niceScaleExtent(scale, inModel) {
	      var model = inModel;
	      var extentInfo = getScaleExtent(scale, model);
	      var extent = extentInfo.extent;
	      var splitNumber = model.get('splitNumber');
	
	      if (scale instanceof LogScale) {
	        scale.base = model.get('logBase');
	      }
	
	      var scaleType = scale.type;
	      var interval = model.get('interval');
	      var isIntervalOrTime = scaleType === 'interval' || scaleType === 'time';
	      scale.setExtent(extent[0], extent[1]);
	      scale.calcNiceExtent({
	        splitNumber: splitNumber,
	        fixMin: extentInfo.fixMin,
	        fixMax: extentInfo.fixMax,
	        minInterval: isIntervalOrTime ? model.get('minInterval') : null,
	        maxInterval: isIntervalOrTime ? model.get('maxInterval') : null
	      }); // If some one specified the min, max. And the default calculated interval
	      // is not good enough. He can specify the interval. It is often appeared
	      // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
	      // to be 60.
	      // FIXME
	
	      if (interval != null) {
	        scale.setInterval && scale.setInterval(interval);
	      }
	    }
	    /**
	     * @param axisType Default retrieve from model.type
	     */
	
	    function createScaleByModel(model, axisType) {
	      axisType = axisType || model.get('type');
	
	      if (axisType) {
	        switch (axisType) {
	          // Buildin scale
	          case 'category':
	            return new OrdinalScale({
	              ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
	              extent: [Infinity, -Infinity]
	            });
	
	          case 'time':
	            return new TimeScale({
	              locale: model.ecModel.getLocaleModel(),
	              useUTC: model.ecModel.get('useUTC')
	            });
	
	          default:
	            // case 'value'/'interval', 'log', or others.
	            return new (Scale.getClass(axisType) || IntervalScale)();
	        }
	      }
	    }
	    /**
	     * Check if the axis cross 0
	     */
	
	    function ifAxisCrossZero(axis) {
	      var dataExtent = axis.scale.getExtent();
	      var min = dataExtent[0];
	      var max = dataExtent[1];
	      return !(min > 0 && max > 0 || min < 0 && max < 0);
	    }
	    /**
	     * @param axis
	     * @return Label formatter function.
	     *         param: {number} tickValue,
	     *         param: {number} idx, the index in all ticks.
	     *                         If category axis, this param is not required.
	     *         return: {string} label string.
	     */
	
	    function makeLabelFormatter(axis) {
	      var labelFormatter = axis.getLabelModel().get('formatter');
	      var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
	
	      if (axis.scale.type === 'time') {
	        return function (tpl) {
	          return function (tick, idx) {
	            return axis.scale.getFormattedLabel(tick, idx, tpl);
	          };
	        }(labelFormatter);
	      } else if (isString(labelFormatter)) {
	        return function (tpl) {
	          return function (tick) {
	            // For category axis, get raw value; for numeric axis,
	            // get formatted label like '1,333,444'.
	            var label = axis.scale.getLabel(tick);
	            var text = tpl.replace('{value}', label != null ? label : '');
	            return text;
	          };
	        }(labelFormatter);
	      } else if (isFunction(labelFormatter)) {
	        return function (cb) {
	          return function (tick, idx) {
	            // The original intention of `idx` is "the index of the tick in all ticks".
	            // But the previous implementation of category axis do not consider the
	            // `axisLabel.interval`, which cause that, for example, the `interval` is
	            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
	            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
	            // the definition here for back compatibility.
	            if (categoryTickStart != null) {
	              idx = tick.value - categoryTickStart;
	            }
	
	            return cb(getAxisRawValue(axis, tick), idx, tick.level != null ? {
	              level: tick.level
	            } : null);
	          };
	        }(labelFormatter);
	      } else {
	        return function (tick) {
	          return axis.scale.getLabel(tick);
	        };
	      }
	    }
	    function getAxisRawValue(axis, tick) {
	      // In category axis with data zoom, tick is not the original
	      // index of axis.data. So tick should not be exposed to user
	      // in category axis.
	      return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
	    }
	    /**
	     * @param axis
	     * @return Be null/undefined if no labels.
	     */
	
	    function estimateLabelUnionRect(axis) {
	      var axisModel = axis.model;
	      var scale = axis.scale;
	
	      if (!axisModel.get(['axisLabel', 'show']) || scale.isBlank()) {
	        return;
	      }
	
	      var realNumberScaleTicks;
	      var tickCount;
	      var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
	
	      if (scale instanceof OrdinalScale) {
	        tickCount = scale.count();
	      } else {
	        realNumberScaleTicks = scale.getTicks();
	        tickCount = realNumberScaleTicks.length;
	      }
	
	      var axisLabelModel = axis.getLabelModel();
	      var labelFormatter = makeLabelFormatter(axis);
	      var rect;
	      var step = 1; // Simple optimization for large amount of labels
	
	      if (tickCount > 40) {
	        step = Math.ceil(tickCount / 40);
	      }
	
	      for (var i = 0; i < tickCount; i += step) {
	        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
	          value: categoryScaleExtent[0] + i
	        };
	        var label = labelFormatter(tick, i);
	        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
	        var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
	        rect ? rect.union(singleRect) : rect = singleRect;
	      }
	
	      return rect;
	    }
	
	    function rotateTextRect(textRect, rotate) {
	      var rotateRadians = rotate * Math.PI / 180;
	      var beforeWidth = textRect.width;
	      var beforeHeight = textRect.height;
	      var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
	      var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
	      var rotatedRect = new BoundingRect(textRect.x, textRect.y, afterWidth, afterHeight);
	      return rotatedRect;
	    }
	    /**
	     * @param model axisLabelModel or axisTickModel
	     * @return {number|String} Can be null|'auto'|number|function
	     */
	
	
	    function getOptionCategoryInterval(model) {
	      var interval = model.get('interval');
	      return interval == null ? 'auto' : interval;
	    }
	    /**
	     * Set `categoryInterval` as 0 implicitly indicates that
	     * show all labels regardless of overlap.
	     * @param {Object} axis axisModel.axis
	     */
	
	    function shouldShowAllLabels(axis) {
	      return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
	    }
	    function getDataDimensionsOnAxis(data, axisDim) {
	      // Remove duplicated dat dimensions caused by `getStackedDimension`.
	      var dataDimMap = {}; // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
	      // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
	      // there has been stacked result dim?
	
	      each(data.mapDimensionsAll(axisDim), function (dataDim) {
	        // For example, the extent of the original dimension
	        // is [0.1, 0.5], the extent of the `stackResultDimension`
	        // is [7, 9], the final extent should NOT include [0.1, 0.5],
	        // because there is no graphic corresponding to [0.1, 0.5].
	        // See the case in `test/area-stack.html` `main1`, where area line
	        // stack needs `yAxis` not start from 0.
	        dataDimMap[getStackedDimension(data, dataDim)] = true;
	      });
	      return keys(dataDimMap);
	    }
	    function unionAxisExtentFromData(dataExtent, data, axisDim) {
	      if (data) {
	        each(getDataDimensionsOnAxis(data, axisDim), function (dim) {
	          var seriesExtent = data.getApproximateExtent(dim);
	          seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
	          seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
	        });
	      }
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    // eslint-disable-next-line @typescript-eslint/no-unused-vars
	    var AxisModelCommonMixin =
	    /** @class */
	    function () {
	      function AxisModelCommonMixin() {}
	
	      AxisModelCommonMixin.prototype.getNeedCrossZero = function () {
	        var option = this.option;
	        return !option.scale;
	      };
	      /**
	       * Should be implemented by each axis model if necessary.
	       * @return coordinate system model
	       */
	
	
	      AxisModelCommonMixin.prototype.getCoordSysModel = function () {
	        return;
	      };
	
	      return AxisModelCommonMixin;
	    }();
	
	    /**
	     * Create a multi dimension List structure from seriesModel.
	     */
	
	    function createList(seriesModel) {
	      return createSeriesData(null, seriesModel);
	    } // export function createGraph(seriesModel) {
	    var dataStack$1 = {
	      isDimensionStacked: isDimensionStacked,
	      enableDataStack: enableDataStack,
	      getStackedDimension: getStackedDimension
	    };
	    /**
	     * Create scale
	     * @param {Array.<number>} dataExtent
	     * @param {Object|module:echarts/Model} option If `optoin.type`
	     *        is secified, it can only be `'value'` currently.
	     */
	
	    function createScale(dataExtent, option) {
	      var axisModel = option;
	
	      if (!(option instanceof Model)) {
	        axisModel = new Model(option); // FIXME
	        // Currently AxisModelCommonMixin has nothing to do with the
	        // the requirements of `axisHelper.createScaleByModel`. For
	        // example the methods `getCategories` and `getOrdinalMeta`
	        // are required for `'category'` axis, and ecModel is required
	        // for `'time'` axis. But occasionally echarts-gl happened
	        // to only use `'value'` axis.
	        // zrUtil.mixin(axisModel, AxisModelCommonMixin);
	      }
	
	      var scale = createScaleByModel(axisModel);
	      scale.setExtent(dataExtent[0], dataExtent[1]);
	      niceScaleExtent(scale, axisModel);
	      return scale;
	    }
	    /**
	     * Mixin common methods to axis model,
	     *
	     * Include methods
	     * `getFormattedLabels() => Array.<string>`
	     * `getCategories() => Array.<string>`
	     * `getMin(origin: boolean) => number`
	     * `getMax(origin: boolean) => number`
	     * `getNeedCrossZero() => boolean`
	     */
	
	    function mixinAxisModelCommonMethods(Model) {
	      mixin(Model, AxisModelCommonMixin);
	    }
	    function createTextStyle$1(textStyleModel, opts) {
	      opts = opts || {};
	      return createTextStyle(textStyleModel, null, null, opts.state !== 'normal');
	    }
	
	    var helper = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        createList: createList,
	        getLayoutRect: getLayoutRect,
	        dataStack: dataStack$1,
	        createScale: createScale,
	        mixinAxisModelCommonMethods: mixinAxisModelCommonMethods,
	        getECData: getECData,
	        createTextStyle: createTextStyle$1,
	        createDimensions: createDimensions,
	        createSymbol: createSymbol,
	        enableHoverEmphasis: enableHoverEmphasis
	    });
	
	    var EPSILON$4 = 1e-8;
	    function isAroundEqual$1(a, b) {
	        return Math.abs(a - b) < EPSILON$4;
	    }
	    function contain$2(points, x, y) {
	        var w = 0;
	        var p = points[0];
	        if (!p) {
	            return false;
	        }
	        for (var i = 1; i < points.length; i++) {
	            var p2 = points[i];
	            w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
	            p = p2;
	        }
	        var p0 = points[0];
	        if (!isAroundEqual$1(p[0], p0[0]) || !isAroundEqual$1(p[1], p0[1])) {
	            w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
	        }
	        return w !== 0;
	    }
	
	    var TMP_TRANSFORM = [];
	
	    function transformPoints(points, transform) {
	      for (var p = 0; p < points.length; p++) {
	        applyTransform(points[p], points[p], transform);
	      }
	    }
	
	    function updateBBoxFromPoints(points, min$1, max$1, projection) {
	      for (var i = 0; i < points.length; i++) {
	        var p = points[i];
	
	        if (projection) {
	          // projection may return null point.
	          p = projection.project(p);
	        }
	
	        if (p && isFinite(p[0]) && isFinite(p[1])) {
	          min(min$1, min$1, p);
	          max(max$1, max$1, p);
	        }
	      }
	    }
	
	    function centroid(points) {
	      var signedArea = 0;
	      var cx = 0;
	      var cy = 0;
	      var len = points.length;
	      var x0 = points[len - 1][0];
	      var y0 = points[len - 1][1]; // Polygon should been closed.
	
	      for (var i = 0; i < len; i++) {
	        var x1 = points[i][0];
	        var y1 = points[i][1];
	        var a = x0 * y1 - x1 * y0;
	        signedArea += a;
	        cx += (x0 + x1) * a;
	        cy += (y0 + y1) * a;
	        x0 = x1;
	        y0 = y1;
	      }
	
	      return signedArea ? [cx / signedArea / 3, cy / signedArea / 3, signedArea] : [points[0][0] || 0, points[0][1] || 0];
	    }
	
	    var Region =
	    /** @class */
	    function () {
	      function Region(name) {
	        this.name = name;
	      }
	
	      Region.prototype.setCenter = function (center) {
	        this._center = center;
	      };
	      /**
	       * Get center point in data unit. That is,
	       * for GeoJSONRegion, the unit is lat/lng,
	       * for GeoSVGRegion, the unit is SVG local coord.
	       */
	
	
	      Region.prototype.getCenter = function () {
	        var center = this._center;
	
	        if (!center) {
	          // In most cases there are no need to calculate this center.
	          // So calculate only when called.
	          center = this._center = this.calcCenter();
	        }
	
	        return center;
	      };
	
	      return Region;
	    }();
	
	    var GeoJSONPolygonGeometry =
	    /** @class */
	    function () {
	      function GeoJSONPolygonGeometry(exterior, interiors) {
	        this.type = 'polygon';
	        this.exterior = exterior;
	        this.interiors = interiors;
	      }
	
	      return GeoJSONPolygonGeometry;
	    }();
	
	    var GeoJSONLineStringGeometry =
	    /** @class */
	    function () {
	      function GeoJSONLineStringGeometry(points) {
	        this.type = 'linestring';
	        this.points = points;
	      }
	
	      return GeoJSONLineStringGeometry;
	    }();
	
	    var GeoJSONRegion =
	    /** @class */
	    function (_super) {
	      __extends(GeoJSONRegion, _super);
	
	      function GeoJSONRegion(name, geometries, cp) {
	        var _this = _super.call(this, name) || this;
	
	        _this.type = 'geoJSON';
	        _this.geometries = geometries;
	        _this._center = cp && [cp[0], cp[1]];
	        return _this;
	      }
	
	      GeoJSONRegion.prototype.calcCenter = function () {
	        var geometries = this.geometries;
	        var largestGeo;
	        var largestGeoSize = 0;
	
	        for (var i = 0; i < geometries.length; i++) {
	          var geo = geometries[i];
	          var exterior = geo.exterior; // Simple trick to use points count instead of polygon area as region size.
	          // Ignore linestring
	
	          var size = exterior && exterior.length;
	
	          if (size > largestGeoSize) {
	            largestGeo = geo;
	            largestGeoSize = size;
	          }
	        }
	
	        if (largestGeo) {
	          return centroid(largestGeo.exterior);
	        } // from bounding rect by default.
	
	
	        var rect = this.getBoundingRect();
	        return [rect.x + rect.width / 2, rect.y + rect.height / 2];
	      };
	
	      GeoJSONRegion.prototype.getBoundingRect = function (projection) {
	        var rect = this._rect; // Always recalculate if using projection.
	
	        if (rect && !projection) {
	          return rect;
	        }
	
	        var min = [Infinity, Infinity];
	        var max = [-Infinity, -Infinity];
	        var geometries = this.geometries;
	        each(geometries, function (geo) {
	          if (geo.type === 'polygon') {
	            // Doesn't consider hole
	            updateBBoxFromPoints(geo.exterior, min, max, projection);
	          } else {
	            each(geo.points, function (points) {
	              updateBBoxFromPoints(points, min, max, projection);
	            });
	          }
	        }); // Normalie invalid bounding.
	
	        if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) {
	          min[0] = min[1] = max[0] = max[1] = 0;
	        }
	
	        rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	
	        if (!projection) {
	          this._rect = rect;
	        }
	
	        return rect;
	      };
	
	      GeoJSONRegion.prototype.contain = function (coord) {
	        var rect = this.getBoundingRect();
	        var geometries = this.geometries;
	
	        if (!rect.contain(coord[0], coord[1])) {
	          return false;
	        }
	
	        loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
	          var geo = geometries[i]; // Only support polygon.
	
	          if (geo.type !== 'polygon') {
	            continue;
	          }
	
	          var exterior = geo.exterior;
	          var interiors = geo.interiors;
	
	          if (contain$2(exterior, coord[0], coord[1])) {
	            // Not in the region if point is in the hole.
	            for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
	              if (contain$2(interiors[k], coord[0], coord[1])) {
	                continue loopGeo;
	              }
	            }
	
	            return true;
	          }
	        }
	
	        return false;
	      };
	      /**
	       * Transform the raw coords to target bounding.
	       * @param x
	       * @param y
	       * @param width
	       * @param height
	       */
	
	
	      GeoJSONRegion.prototype.transformTo = function (x, y, width, height) {
	        var rect = this.getBoundingRect();
	        var aspect = rect.width / rect.height;
	
	        if (!width) {
	          width = aspect * height;
	        } else if (!height) {
	          height = width / aspect;
	        }
	
	        var target = new BoundingRect(x, y, width, height);
	        var transform = rect.calculateTransform(target);
	        var geometries = this.geometries;
	
	        for (var i = 0; i < geometries.length; i++) {
	          var geo = geometries[i];
	
	          if (geo.type === 'polygon') {
	            transformPoints(geo.exterior, transform);
	            each(geo.interiors, function (interior) {
	              transformPoints(interior, transform);
	            });
	          } else {
	            each(geo.points, function (points) {
	              transformPoints(points, transform);
	            });
	          }
	        }
	
	        rect = this._rect;
	        rect.copy(target); // Update center
	
	        this._center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	      };
	
	      GeoJSONRegion.prototype.cloneShallow = function (name) {
	        name == null && (name = this.name);
	        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
	        newRegion._rect = this._rect;
	        newRegion.transformTo = null; // Simply avoid to be called.
	
	        return newRegion;
	      };
	
	      return GeoJSONRegion;
	    }(Region);
	
	    var GeoSVGRegion =
	    /** @class */
	    function (_super) {
	      __extends(GeoSVGRegion, _super);
	
	      function GeoSVGRegion(name, elOnlyForCalculate) {
	        var _this = _super.call(this, name) || this;
	
	        _this.type = 'geoSVG';
	        _this._elOnlyForCalculate = elOnlyForCalculate;
	        return _this;
	      }
	
	      GeoSVGRegion.prototype.calcCenter = function () {
	        var el = this._elOnlyForCalculate;
	        var rect = el.getBoundingRect();
	        var center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	        var mat = identity(TMP_TRANSFORM);
	        var target = el;
	
	        while (target && !target.isGeoSVGGraphicRoot) {
	          mul$1(mat, target.getLocalTransform(), mat);
	          target = target.parent;
	        }
	
	        invert(mat, mat);
	        applyTransform(center, center, mat);
	        return center;
	      };
	
	      return GeoSVGRegion;
	    }(Region);
	
	    function decode(json) {
	      if (!json.UTF8Encoding) {
	        return json;
	      }
	
	      var jsonCompressed = json;
	      var encodeScale = jsonCompressed.UTF8Scale;
	
	      if (encodeScale == null) {
	        encodeScale = 1024;
	      }
	
	      var features = jsonCompressed.features;
	      each(features, function (feature) {
	        var geometry = feature.geometry;
	        var encodeOffsets = geometry.encodeOffsets;
	        var coordinates = geometry.coordinates; // Geometry may be appeded manually in the script after json loaded.
	        // In this case this geometry is usually not encoded.
	
	        if (!encodeOffsets) {
	          return;
	        }
	
	        switch (geometry.type) {
	          case 'LineString':
	            geometry.coordinates = decodeRing(coordinates, encodeOffsets, encodeScale);
	            break;
	
	          case 'Polygon':
	            decodeRings(coordinates, encodeOffsets, encodeScale);
	            break;
	
	          case 'MultiLineString':
	            decodeRings(coordinates, encodeOffsets, encodeScale);
	            break;
	
	          case 'MultiPolygon':
	            each(coordinates, function (rings, idx) {
	              return decodeRings(rings, encodeOffsets[idx], encodeScale);
	            });
	        }
	      }); // Has been decoded
	
	      jsonCompressed.UTF8Encoding = false;
	      return jsonCompressed;
	    }
	
	    function decodeRings(rings, encodeOffsets, encodeScale) {
	      for (var c = 0; c < rings.length; c++) {
	        rings[c] = decodeRing(rings[c], encodeOffsets[c], encodeScale);
	      }
	    }
	
	    function decodeRing(coordinate, encodeOffsets, encodeScale) {
	      var result = [];
	      var prevX = encodeOffsets[0];
	      var prevY = encodeOffsets[1];
	
	      for (var i = 0; i < coordinate.length; i += 2) {
	        var x = coordinate.charCodeAt(i) - 64;
	        var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
	
	        x = x >> 1 ^ -(x & 1);
	        y = y >> 1 ^ -(y & 1); // Delta deocding
	
	        x += prevX;
	        y += prevY;
	        prevX = x;
	        prevY = y; // Dequantize
	
	        result.push([x / encodeScale, y / encodeScale]);
	      }
	
	      return result;
	    }
	
	    function parseGeoJSON(geoJson, nameProperty) {
	      geoJson = decode(geoJson);
	      return map(filter(geoJson.features, function (featureObj) {
	        // Output of mapshaper may have geometry null
	        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
	      }), function (featureObj) {
	        var properties = featureObj.properties;
	        var geo = featureObj.geometry;
	        var geometries = [];
	
	        switch (geo.type) {
	          case 'Polygon':
	            var coordinates = geo.coordinates; // According to the GeoJSON specification.
	            // First must be exterior, and the rest are all interior(holes).
	
	            geometries.push(new GeoJSONPolygonGeometry(coordinates[0], coordinates.slice(1)));
	            break;
	
	          case 'MultiPolygon':
	            each(geo.coordinates, function (item) {
	              if (item[0]) {
	                geometries.push(new GeoJSONPolygonGeometry(item[0], item.slice(1)));
	              }
	            });
	            break;
	
	          case 'LineString':
	            geometries.push(new GeoJSONLineStringGeometry([geo.coordinates]));
	            break;
	
	          case 'MultiLineString':
	            geometries.push(new GeoJSONLineStringGeometry(geo.coordinates));
	        }
	
	        var region = new GeoJSONRegion(properties[nameProperty || 'name'], geometries, properties.cp);
	        region.properties = properties;
	        return region;
	      });
	    }
	
	    var number = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        linearMap: linearMap,
	        round: round,
	        asc: asc,
	        getPrecision: getPrecision,
	        getPrecisionSafe: getPrecisionSafe,
	        getPixelPrecision: getPixelPrecision,
	        getPercentWithPrecision: getPercentWithPrecision,
	        MAX_SAFE_INTEGER: MAX_SAFE_INTEGER,
	        remRadian: remRadian,
	        isRadianAroundZero: isRadianAroundZero,
	        parseDate: parseDate,
	        quantity: quantity,
	        quantityExponent: quantityExponent,
	        nice: nice,
	        quantile: quantile,
	        reformIntervals: reformIntervals,
	        isNumeric: isNumeric,
	        numericToNumber: numericToNumber
	    });
	
	    var time = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        parse: parseDate,
	        format: format
	    });
	
	    var graphic$1 = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        extendShape: extendShape,
	        extendPath: extendPath,
	        makePath: makePath,
	        makeImage: makeImage,
	        mergePath: mergePath$1,
	        resizePath: resizePath,
	        createIcon: createIcon,
	        updateProps: updateProps,
	        initProps: initProps,
	        getTransform: getTransform,
	        clipPointsByRect: clipPointsByRect,
	        clipRectByRect: clipRectByRect,
	        registerShape: registerShape,
	        getShapeClass: getShapeClass,
	        Group: Group,
	        Image: ZRImage,
	        Text: ZRText,
	        Circle: Circle,
	        Ellipse: Ellipse,
	        Sector: Sector,
	        Ring: Ring,
	        Polygon: Polygon,
	        Polyline: Polyline,
	        Rect: Rect,
	        Line: Line,
	        BezierCurve: BezierCurve,
	        Arc: Arc,
	        IncrementalDisplayable: IncrementalDisplayable,
	        CompoundPath: CompoundPath,
	        LinearGradient: LinearGradient,
	        RadialGradient: RadialGradient,
	        BoundingRect: BoundingRect
	    });
	
	    var format$1 = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        addCommas: addCommas,
	        toCamelCase: toCamelCase,
	        normalizeCssArray: normalizeCssArray$1,
	        encodeHTML: encodeHTML,
	        formatTpl: formatTpl,
	        getTooltipMarker: getTooltipMarker,
	        formatTime: formatTime,
	        capitalFirst: capitalFirst,
	        truncateText: truncateText,
	        getTextRect: getTextRect
	    });
	
	    var util$1 = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        map: map,
	        each: each,
	        indexOf: indexOf,
	        inherits: inherits,
	        reduce: reduce,
	        filter: filter,
	        bind: bind,
	        curry: curry,
	        isArray: isArray,
	        isString: isString,
	        isObject: isObject,
	        isFunction: isFunction,
	        extend: extend,
	        defaults: defaults,
	        clone: clone,
	        merge: merge
	    });
	
	    var inner$5 = makeInner();
	    function createAxisLabels(axis) {
	      // Only ordinal scale support tick interval
	      return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
	    }
	    /**
	     * @param {module:echats/coord/Axis} axis
	     * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
	     * @return {Object} {
	     *     ticks: Array.<number>
	     *     tickCategoryInterval: number
	     * }
	     */
	
	    function createAxisTicks(axis, tickModel) {
	      // Only ordinal scale support tick interval
	      return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
	        ticks: map(axis.scale.getTicks(), function (tick) {
	          return tick.value;
	        })
	      };
	    }
	
	    function makeCategoryLabels(axis) {
	      var labelModel = axis.getLabelModel();
	      var result = makeCategoryLabelsActually(axis, labelModel);
	      return !labelModel.get('show') || axis.scale.isBlank() ? {
	        labels: [],
	        labelCategoryInterval: result.labelCategoryInterval
	      } : result;
	    }
	
	    function makeCategoryLabelsActually(axis, labelModel) {
	      var labelsCache = getListCache(axis, 'labels');
	      var optionLabelInterval = getOptionCategoryInterval(labelModel);
	      var result = listCacheGet(labelsCache, optionLabelInterval);
	
	      if (result) {
	        return result;
	      }
	
	      var labels;
	      var numericLabelInterval;
	
	      if (isFunction(optionLabelInterval)) {
	        labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
	      } else {
	        numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
	        labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
	      } // Cache to avoid calling interval function repeatedly.
	
	
	      return listCacheSet(labelsCache, optionLabelInterval, {
	        labels: labels,
	        labelCategoryInterval: numericLabelInterval
	      });
	    }
	
	    function makeCategoryTicks(axis, tickModel) {
	      var ticksCache = getListCache(axis, 'ticks');
	      var optionTickInterval = getOptionCategoryInterval(tickModel);
	      var result = listCacheGet(ticksCache, optionTickInterval);
	
	      if (result) {
	        return result;
	      }
	
	      var ticks;
	      var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
	      // we should not return all ticks.
	
	      if (!tickModel.get('show') || axis.scale.isBlank()) {
	        ticks = [];
	      }
	
	      if (isFunction(optionTickInterval)) {
	        ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
	      } // Always use label interval by default despite label show. Consider this
	      // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
	      // labels. `splitLine` and `axisTick` should be consistent in this case.
	      else if (optionTickInterval === 'auto') {
	          var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
	          tickCategoryInterval = labelsResult.labelCategoryInterval;
	          ticks = map(labelsResult.labels, function (labelItem) {
	            return labelItem.tickValue;
	          });
	        } else {
	          tickCategoryInterval = optionTickInterval;
	          ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
	        } // Cache to avoid calling interval function repeatedly.
	
	
	      return listCacheSet(ticksCache, optionTickInterval, {
	        ticks: ticks,
	        tickCategoryInterval: tickCategoryInterval
	      });
	    }
	
	    function makeRealNumberLabels(axis) {
	      var ticks = axis.scale.getTicks();
	      var labelFormatter = makeLabelFormatter(axis);
	      return {
	        labels: map(ticks, function (tick, idx) {
	          return {
	            level: tick.level,
	            formattedLabel: labelFormatter(tick, idx),
	            rawLabel: axis.scale.getLabel(tick),
	            tickValue: tick.value
	          };
	        })
	      };
	    }
	
	    function getListCache(axis, prop) {
	      // Because key can be a function, and cache size always is small, we use array cache.
	      return inner$5(axis)[prop] || (inner$5(axis)[prop] = []);
	    }
	
	    function listCacheGet(cache, key) {
	      for (var i = 0; i < cache.length; i++) {
	        if (cache[i].key === key) {
	          return cache[i].value;
	        }
	      }
	    }
	
	    function listCacheSet(cache, key, value) {
	      cache.push({
	        key: key,
	        value: value
	      });
	      return value;
	    }
	
	    function makeAutoCategoryInterval(axis) {
	      var result = inner$5(axis).autoInterval;
	      return result != null ? result : inner$5(axis).autoInterval = axis.calculateCategoryInterval();
	    }
	    /**
	     * Calculate interval for category axis ticks and labels.
	     * To get precise result, at least one of `getRotate` and `isHorizontal`
	     * should be implemented in axis.
	     */
	
	
	    function calculateCategoryInterval(axis) {
	      var params = fetchAutoCategoryIntervalCalculationParams(axis);
	      var labelFormatter = makeLabelFormatter(axis);
	      var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
	      var ordinalScale = axis.scale;
	      var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	      // avoid generating a long array by `getTicks`
	      // in large category data case.
	
	      var tickCount = ordinalScale.count();
	
	      if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	        return 0;
	      }
	
	      var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
	
	      if (tickCount > 40) {
	        step = Math.max(1, Math.floor(tickCount / 40));
	      }
	
	      var tickValue = ordinalExtent[0];
	      var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	      var unitW = Math.abs(unitSpan * Math.cos(rotation));
	      var unitH = Math.abs(unitSpan * Math.sin(rotation));
	      var maxW = 0;
	      var maxH = 0; // Caution: Performance sensitive for large category data.
	      // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
	
	      for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	        var width = 0;
	        var height = 0; // Not precise, do not consider align and vertical align
	        // and each distance from axis line yet.
	
	        var rect = getBoundingRect(labelFormatter({
	          value: tickValue
	        }), params.font, 'center', 'top'); // Magic number
	
	        width = rect.width * 1.3;
	        height = rect.height * 1.3; // Min size, void long loop.
	
	        maxW = Math.max(maxW, width, 7);
	        maxH = Math.max(maxH, height, 7);
	      }
	
	      var dw = maxW / unitW;
	      var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	      isNaN(dw) && (dw = Infinity);
	      isNaN(dh) && (dh = Infinity);
	      var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
	      var cache = inner$5(axis.model);
	      var axisExtent = axis.getExtent();
	      var lastAutoInterval = cache.lastAutoInterval;
	      var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	      // otherwise the calculated interval might jitter when the zoom
	      // window size is close to the interval-changing size.
	      // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
	      // The jitter will cause that sometimes the displayed labels are
	      // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
	
	      if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	      // point is not the same when zooming in or zooming out.
	      && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
	      // be used. Otherwise some hidden labels might not be shown again.
	      && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) {
	        interval = lastAutoInterval;
	      } // Only update cache if cache not used, otherwise the
	      // changing of interval is too insensitive.
	      else {
	          cache.lastTickCount = tickCount;
	          cache.lastAutoInterval = interval;
	          cache.axisExtent0 = axisExtent[0];
	          cache.axisExtent1 = axisExtent[1];
	        }
	
	      return interval;
	    }
	
	    function fetchAutoCategoryIntervalCalculationParams(axis) {
	      var labelModel = axis.getLabelModel();
	      return {
	        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
	        labelRotate: labelModel.get('rotate') || 0,
	        font: labelModel.getFont()
	      };
	    }
	
	    function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
	      var labelFormatter = makeLabelFormatter(axis);
	      var ordinalScale = axis.scale;
	      var ordinalExtent = ordinalScale.getExtent();
	      var labelModel = axis.getLabelModel();
	      var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
	
	      var step = Math.max((categoryInterval || 0) + 1, 1);
	      var startTick = ordinalExtent[0];
	      var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
	      // while zooming and moving while interval > 0. Otherwise the selection
	      // of displayable ticks and symbols probably keep changing.
	      // 3 is empirical value.
	
	      if (startTick !== 0 && step > 1 && tickCount / step > 2) {
	        startTick = Math.round(Math.ceil(startTick / step) * step);
	      } // (1) Only add min max label here but leave overlap checking
	      // to render stage, which also ensure the returned list
	      // suitable for splitLine and splitArea rendering.
	      // (2) Scales except category always contain min max label so
	      // do not need to perform this process.
	
	
	      var showAllLabel = shouldShowAllLabels(axis);
	      var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
	      var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
	
	      if (includeMinLabel && startTick !== ordinalExtent[0]) {
	        addItem(ordinalExtent[0]);
	      } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
	
	
	      var tickValue = startTick;
	
	      for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	        addItem(tickValue);
	      }
	
	      if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) {
	        addItem(ordinalExtent[1]);
	      }
	
	      function addItem(tickValue) {
	        var tickObj = {
	          value: tickValue
	        };
	        result.push(onlyTick ? tickValue : {
	          formattedLabel: labelFormatter(tickObj),
	          rawLabel: ordinalScale.getLabel(tickObj),
	          tickValue: tickValue
	        });
	      }
	
	      return result;
	    }
	
	    function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
	      var ordinalScale = axis.scale;
	      var labelFormatter = makeLabelFormatter(axis);
	      var result = [];
	      each(ordinalScale.getTicks(), function (tick) {
	        var rawLabel = ordinalScale.getLabel(tick);
	        var tickValue = tick.value;
	
	        if (categoryInterval(tick.value, rawLabel)) {
	          result.push(onlyTick ? tickValue : {
	            formattedLabel: labelFormatter(tick),
	            rawLabel: rawLabel,
	            tickValue: tickValue
	          });
	        }
	      });
	      return result;
	    }
	
	    var NORMALIZED_EXTENT = [0, 1];
	    /**
	     * Base class of Axis.
	     */
	
	    var Axis =
	    /** @class */
	    function () {
	      function Axis(dim, scale, extent) {
	        this.onBand = false;
	        this.inverse = false;
	        this.dim = dim;
	        this.scale = scale;
	        this._extent = extent || [0, 0];
	      }
	      /**
	       * If axis extent contain given coord
	       */
	
	
	      Axis.prototype.contain = function (coord) {
	        var extent = this._extent;
	        var min = Math.min(extent[0], extent[1]);
	        var max = Math.max(extent[0], extent[1]);
	        return coord >= min && coord <= max;
	      };
	      /**
	       * If axis extent contain given data
	       */
	
	
	      Axis.prototype.containData = function (data) {
	        return this.scale.contain(data);
	      };
	      /**
	       * Get coord extent.
	       */
	
	
	      Axis.prototype.getExtent = function () {
	        return this._extent.slice();
	      };
	      /**
	       * Get precision used for formatting
	       */
	
	
	      Axis.prototype.getPixelPrecision = function (dataExtent) {
	        return getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
	      };
	      /**
	       * Set coord extent
	       */
	
	
	      Axis.prototype.setExtent = function (start, end) {
	        var extent = this._extent;
	        extent[0] = start;
	        extent[1] = end;
	      };
	      /**
	       * Convert data to coord. Data is the rank if it has an ordinal scale
	       */
	
	
	      Axis.prototype.dataToCoord = function (data, clamp) {
	        var extent = this._extent;
	        var scale = this.scale;
	        data = scale.normalize(data);
	
	        if (this.onBand && scale.type === 'ordinal') {
	          extent = extent.slice();
	          fixExtentWithBands(extent, scale.count());
	        }
	
	        return linearMap(data, NORMALIZED_EXTENT, extent, clamp);
	      };
	      /**
	       * Convert coord to data. Data is the rank if it has an ordinal scale
	       */
	
	
	      Axis.prototype.coordToData = function (coord, clamp) {
	        var extent = this._extent;
	        var scale = this.scale;
	
	        if (this.onBand && scale.type === 'ordinal') {
	          extent = extent.slice();
	          fixExtentWithBands(extent, scale.count());
	        }
	
	        var t = linearMap(coord, extent, NORMALIZED_EXTENT, clamp);
	        return this.scale.scale(t);
	      };
	      /**
	       * Convert pixel point to data in axis
	       */
	
	
	      Axis.prototype.pointToData = function (point, clamp) {
	        // Should be implemented in derived class if necessary.
	        return;
	      };
	      /**
	       * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
	       * `axis.getTicksCoords` considers `onBand`, which is used by
	       * `boundaryGap:true` of category axis and splitLine and splitArea.
	       * @param opt.tickModel default: axis.model.getModel('axisTick')
	       * @param opt.clamp If `true`, the first and the last
	       *        tick must be at the axis end points. Otherwise, clip ticks
	       *        that outside the axis extent.
	       */
	
	
	      Axis.prototype.getTicksCoords = function (opt) {
	        opt = opt || {};
	        var tickModel = opt.tickModel || this.getTickModel();
	        var result = createAxisTicks(this, tickModel);
	        var ticks = result.ticks;
	        var ticksCoords = map(ticks, function (tickVal) {
	          return {
	            coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
	            tickValue: tickVal
	          };
	        }, this);
	        var alignWithLabel = tickModel.get('alignWithLabel');
	        fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
	        return ticksCoords;
	      };
	
	      Axis.prototype.getMinorTicksCoords = function () {
	        if (this.scale.type === 'ordinal') {
	          // Category axis doesn't support minor ticks
	          return [];
	        }
	
	        var minorTickModel = this.model.getModel('minorTick');
	        var splitNumber = minorTickModel.get('splitNumber'); // Protection.
	
	        if (!(splitNumber > 0 && splitNumber < 100)) {
	          splitNumber = 5;
	        }
	
	        var minorTicks = this.scale.getMinorTicks(splitNumber);
	        var minorTicksCoords = map(minorTicks, function (minorTicksGroup) {
	          return map(minorTicksGroup, function (minorTick) {
	            return {
	              coord: this.dataToCoord(minorTick),
	              tickValue: minorTick
	            };
	          }, this);
	        }, this);
	        return minorTicksCoords;
	      };
	
	      Axis.prototype.getViewLabels = function () {
	        return createAxisLabels(this).labels;
	      };
	
	      Axis.prototype.getLabelModel = function () {
	        return this.model.getModel('axisLabel');
	      };
	      /**
	       * Notice here we only get the default tick model. For splitLine
	       * or splitArea, we should pass the splitLineModel or splitAreaModel
	       * manually when calling `getTicksCoords`.
	       * In GL, this method may be overridden to:
	       * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
	       */
	
	
	      Axis.prototype.getTickModel = function () {
	        return this.model.getModel('axisTick');
	      };
	      /**
	       * Get width of band
	       */
	
	
	      Axis.prototype.getBandWidth = function () {
	        var axisExtent = this._extent;
	        var dataExtent = this.scale.getExtent();
	        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
	
	        len === 0 && (len = 1);
	        var size = Math.abs(axisExtent[1] - axisExtent[0]);
	        return Math.abs(size) / len;
	      };
	      /**
	       * Only be called in category axis.
	       * Can be overridden, consider other axes like in 3D.
	       * @return Auto interval for cateogry axis tick and label
	       */
	
	
	      Axis.prototype.calculateCategoryInterval = function () {
	        return calculateCategoryInterval(this);
	      };
	
	      return Axis;
	    }();
	
	    function fixExtentWithBands(extent, nTick) {
	      var size = extent[1] - extent[0];
	      var len = nTick;
	      var margin = size / len / 2;
	      extent[0] += margin;
	      extent[1] -= margin;
	    } // If axis has labels [1, 2, 3, 4]. Bands on the axis are
	    // |---1---|---2---|---3---|---4---|.
	    // So the displayed ticks and splitLine/splitArea should between
	    // each data item, otherwise cause misleading (e.g., split tow bars
	    // of a single data item when there are two bar series).
	    // Also consider if tickCategoryInterval > 0 and onBand, ticks and
	    // splitLine/spliteArea should layout appropriately corresponding
	    // to displayed labels. (So we should not use `getBandWidth` in this
	    // case).
	
	
	    function fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
	      var ticksLen = ticksCoords.length;
	
	      if (!axis.onBand || alignWithLabel || !ticksLen) {
	        return;
	      }
	
	      var axisExtent = axis.getExtent();
	      var last;
	      var diffSize;
	
	      if (ticksLen === 1) {
	        ticksCoords[0].coord = axisExtent[0];
	        last = ticksCoords[1] = {
	          coord: axisExtent[1]
	        };
	      } else {
	        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
	        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
	        each(ticksCoords, function (ticksItem) {
	          ticksItem.coord -= shift_1 / 2;
	        });
	        var dataExtent = axis.scale.getExtent();
	        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
	        last = {
	          coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
	        };
	        ticksCoords.push(last);
	      }
	
	      var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
	
	      if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
	        clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
	      }
	
	      if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
	        ticksCoords.unshift({
	          coord: axisExtent[0]
	        });
	      }
	
	      if (littleThan(axisExtent[1], last.coord)) {
	        clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
	      }
	
	      if (clamp && littleThan(last.coord, axisExtent[1])) {
	        ticksCoords.push({
	          coord: axisExtent[1]
	        });
	      }
	
	      function littleThan(a, b) {
	        // Avoid rounding error cause calculated tick coord different with extent.
	        // It may cause an extra unnecessary tick added.
	        a = round(a);
	        b = round(b);
	        return inverse ? a > b : a < b;
	      }
	    }
	
	    // Should use `ComponentModel.extend` or `class XXXX extend ComponentModel` to create class.
	    // Then use `registerComponentModel` in `install` parameter when `use` this extension. For example:
	    // class Bar3DModel extends ComponentModel {}
	    // export function install(registers) { registers.registerComponentModel(Bar3DModel); }
	    // echarts.use(install);
	
	    function extendComponentModel(proto) {
	      var Model = ComponentModel.extend(proto);
	      ComponentModel.registerClass(Model);
	      return Model;
	    }
	    function extendComponentView(proto) {
	      var View = ComponentView.extend(proto);
	      ComponentView.registerClass(View);
	      return View;
	    }
	    function extendSeriesModel(proto) {
	      var Model = SeriesModel.extend(proto);
	      SeriesModel.registerClass(Model);
	      return Model;
	    }
	    function extendChartView(proto) {
	      var View = ChartView.extend(proto);
	      ChartView.registerClass(View);
	      return View;
	    }
	
	    var PI2$6 = Math.PI * 2;
	    var CMD$3 = PathProxy.CMD;
	    var DEFAULT_SEARCH_SPACE = ['top', 'right', 'bottom', 'left'];
	
	    function getCandidateAnchor(pos, distance, rect, outPt, outDir) {
	      var width = rect.width;
	      var height = rect.height;
	
	      switch (pos) {
	        case 'top':
	          outPt.set(rect.x + width / 2, rect.y - distance);
	          outDir.set(0, -1);
	          break;
	
	        case 'bottom':
	          outPt.set(rect.x + width / 2, rect.y + height + distance);
	          outDir.set(0, 1);
	          break;
	
	        case 'left':
	          outPt.set(rect.x - distance, rect.y + height / 2);
	          outDir.set(-1, 0);
	          break;
	
	        case 'right':
	          outPt.set(rect.x + width + distance, rect.y + height / 2);
	          outDir.set(1, 0);
	          break;
	      }
	    }
	
	    function projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
	      x -= cx;
	      y -= cy;
	      var d = Math.sqrt(x * x + y * y);
	      x /= d;
	      y /= d; // Intersect point.
	
	      var ox = x * r + cx;
	      var oy = y * r + cy;
	
	      if (Math.abs(startAngle - endAngle) % PI2$6 < 1e-4) {
	        // Is a circle
	        out[0] = ox;
	        out[1] = oy;
	        return d - r;
	      }
	
	      if (anticlockwise) {
	        var tmp = startAngle;
	        startAngle = normalizeRadian(endAngle);
	        endAngle = normalizeRadian(tmp);
	      } else {
	        startAngle = normalizeRadian(startAngle);
	        endAngle = normalizeRadian(endAngle);
	      }
	
	      if (startAngle > endAngle) {
	        endAngle += PI2$6;
	      }
	
	      var angle = Math.atan2(y, x);
	
	      if (angle < 0) {
	        angle += PI2$6;
	      }
	
	      if (angle >= startAngle && angle <= endAngle || angle + PI2$6 >= startAngle && angle + PI2$6 <= endAngle) {
	        // Project point is on the arc.
	        out[0] = ox;
	        out[1] = oy;
	        return d - r;
	      }
	
	      var x1 = r * Math.cos(startAngle) + cx;
	      var y1 = r * Math.sin(startAngle) + cy;
	      var x2 = r * Math.cos(endAngle) + cx;
	      var y2 = r * Math.sin(endAngle) + cy;
	      var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
	      var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
	
	      if (d1 < d2) {
	        out[0] = x1;
	        out[1] = y1;
	        return Math.sqrt(d1);
	      } else {
	        out[0] = x2;
	        out[1] = y2;
	        return Math.sqrt(d2);
	      }
	    }
	
	    function projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
	      var dx = x - x1;
	      var dy = y - y1;
	      var dx1 = x2 - x1;
	      var dy1 = y2 - y1;
	      var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
	      dx1 /= lineLen;
	      dy1 /= lineLen; // dot product
	
	      var projectedLen = dx * dx1 + dy * dy1;
	      var t = projectedLen / lineLen;
	
	      if (limitToEnds) {
	        t = Math.min(Math.max(t, 0), 1);
	      }
	
	      t *= lineLen;
	      var ox = out[0] = x1 + t * dx1;
	      var oy = out[1] = y1 + t * dy1;
	      return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
	    }
	
	    function projectPointToRect(x1, y1, width, height, x, y, out) {
	      if (width < 0) {
	        x1 = x1 + width;
	        width = -width;
	      }
	
	      if (height < 0) {
	        y1 = y1 + height;
	        height = -height;
	      }
	
	      var x2 = x1 + width;
	      var y2 = y1 + height;
	      var ox = out[0] = Math.min(Math.max(x, x1), x2);
	      var oy = out[1] = Math.min(Math.max(y, y1), y2);
	      return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
	    }
	
	    var tmpPt = [];
	
	    function nearestPointOnRect(pt, rect, out) {
	      var dist = projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, tmpPt);
	      out.set(tmpPt[0], tmpPt[1]);
	      return dist;
	    }
	    /**
	     * Calculate min distance corresponding point.
	     * This method won't evaluate if point is in the path.
	     */
	
	
	    function nearestPointOnPath(pt, path, out) {
	      var xi = 0;
	      var yi = 0;
	      var x0 = 0;
	      var y0 = 0;
	      var x1;
	      var y1;
	      var minDist = Infinity;
	      var data = path.data;
	      var x = pt.x;
	      var y = pt.y;
	
	      for (var i = 0; i < data.length;) {
	        var cmd = data[i++];
	
	        if (i === 1) {
	          xi = data[i];
	          yi = data[i + 1];
	          x0 = xi;
	          y0 = yi;
	        }
	
	        var d = minDist;
	
	        switch (cmd) {
	          case CMD$3.M:
	            // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	            // 在 closePath 的时候使用
	            x0 = data[i++];
	            y0 = data[i++];
	            xi = x0;
	            yi = y0;
	            break;
	
	          case CMD$3.L:
	            d = projectPointToLine(xi, yi, data[i], data[i + 1], x, y, tmpPt, true);
	            xi = data[i++];
	            yi = data[i++];
	            break;
	
	          case CMD$3.C:
	            d = cubicProjectPoint(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, tmpPt);
	            xi = data[i++];
	            yi = data[i++];
	            break;
	
	          case CMD$3.Q:
	            d = quadraticProjectPoint(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, tmpPt);
	            xi = data[i++];
	            yi = data[i++];
	            break;
	
	          case CMD$3.A:
	            // TODO Arc 判断的开销比较大
	            var cx = data[i++];
	            var cy = data[i++];
	            var rx = data[i++];
	            var ry = data[i++];
	            var theta = data[i++];
	            var dTheta = data[i++]; // TODO Arc 旋转
	
	            i += 1;
	            var anticlockwise = !!(1 - data[i++]);
	            x1 = Math.cos(theta) * rx + cx;
	            y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
	
	            if (i <= 1) {
	              // 第一个命令起点还未定义
	              x0 = x1;
	              y0 = y1;
	            } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
	
	
	            var _x = (x - cx) * ry / rx + cx;
	
	            d = projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, tmpPt);
	            xi = Math.cos(theta + dTheta) * rx + cx;
	            yi = Math.sin(theta + dTheta) * ry + cy;
	            break;
	
	          case CMD$3.R:
	            x0 = xi = data[i++];
	            y0 = yi = data[i++];
	            var width = data[i++];
	            var height = data[i++];
	            d = projectPointToRect(x0, y0, width, height, x, y, tmpPt);
	            break;
	
	          case CMD$3.Z:
	            d = projectPointToLine(xi, yi, x0, y0, x, y, tmpPt, true);
	            xi = x0;
	            yi = y0;
	            break;
	        }
	
	        if (d < minDist) {
	          minDist = d;
	          out.set(tmpPt[0], tmpPt[1]);
	        }
	      }
	
	      return minDist;
	    } // Temporal variable for intermediate usage.
	
	
	    var pt0 = new Point();
	    var pt1 = new Point();
	    var pt2 = new Point();
	    var dir = new Point();
	    var dir2 = new Point();
	    /**
	     * Calculate a proper guide line based on the label position and graphic element definition
	     * @param label
	     * @param labelRect
	     * @param target
	     * @param targetRect
	     */
	
	    function updateLabelLinePoints(target, labelLineModel) {
	      if (!target) {
	        return;
	      }
	
	      var labelLine = target.getTextGuideLine();
	      var label = target.getTextContent(); // Needs to create text guide in each charts.
	
	      if (!(label && labelLine)) {
	        return;
	      }
	
	      var labelGuideConfig = target.textGuideLineConfig || {};
	      var points = [[0, 0], [0, 0], [0, 0]];
	      var searchSpace = labelGuideConfig.candidates || DEFAULT_SEARCH_SPACE;
	      var labelRect = label.getBoundingRect().clone();
	      labelRect.applyTransform(label.getComputedTransform());
	      var minDist = Infinity;
	      var anchorPoint = labelGuideConfig.anchor;
	      var targetTransform = target.getComputedTransform();
	      var targetInversedTransform = targetTransform && invert([], targetTransform);
	      var len = labelLineModel.get('length2') || 0;
	
	      if (anchorPoint) {
	        pt2.copy(anchorPoint);
	      }
	
	      for (var i = 0; i < searchSpace.length; i++) {
	        var candidate = searchSpace[i];
	        getCandidateAnchor(candidate, 0, labelRect, pt0, dir);
	        Point.scaleAndAdd(pt1, pt0, dir, len); // Transform to target coord space.
	
	        pt1.transform(targetInversedTransform); // Note: getBoundingRect will ensure the `path` being created.
	
	        var boundingRect = target.getBoundingRect();
	        var dist = anchorPoint ? anchorPoint.distance(pt1) : target instanceof Path ? nearestPointOnPath(pt1, target.path, pt2) : nearestPointOnRect(pt1, boundingRect, pt2); // TODO pt2 is in the path
	
	        if (dist < minDist) {
	          minDist = dist; // Transform back to global space.
	
	          pt1.transform(targetTransform);
	          pt2.transform(targetTransform);
	          pt2.toArray(points[0]);
	          pt1.toArray(points[1]);
	          pt0.toArray(points[2]);
	        }
	      }
	
	      limitTurnAngle(points, labelLineModel.get('minTurnAngle'));
	      labelLine.setShape({
	        points: points
	      });
	    } // Temporal variable for the limitTurnAngle function
	
	    var tmpArr = [];
	    var tmpProjPoint = new Point();
	    /**
	     * Reduce the line segment attached to the label to limit the turn angle between two segments.
	     * @param linePoints
	     * @param minTurnAngle Radian of minimum turn angle. 0 - 180
	     */
	
	    function limitTurnAngle(linePoints, minTurnAngle) {
	      if (!(minTurnAngle <= 180 && minTurnAngle > 0)) {
	        return;
	      }
	
	      minTurnAngle = minTurnAngle / 180 * Math.PI; // The line points can be
	      //      /pt1----pt2 (label)
	      //     /
	      // pt0/
	
	      pt0.fromArray(linePoints[0]);
	      pt1.fromArray(linePoints[1]);
	      pt2.fromArray(linePoints[2]);
	      Point.sub(dir, pt0, pt1);
	      Point.sub(dir2, pt2, pt1);
	      var len1 = dir.len();
	      var len2 = dir2.len();
	
	      if (len1 < 1e-3 || len2 < 1e-3) {
	        return;
	      }
	
	      dir.scale(1 / len1);
	      dir2.scale(1 / len2);
	      var angleCos = dir.dot(dir2);
	      var minTurnAngleCos = Math.cos(minTurnAngle);
	
	      if (minTurnAngleCos < angleCos) {
	        // Smaller than minTurnAngle
	        // Calculate project point of pt0 on pt1-pt2
	        var d = projectPointToLine(pt1.x, pt1.y, pt2.x, pt2.y, pt0.x, pt0.y, tmpArr, false);
	        tmpProjPoint.fromArray(tmpArr); // Calculate new projected length with limited minTurnAngle and get the new connect point
	
	        tmpProjPoint.scaleAndAdd(dir2, d / Math.tan(Math.PI - minTurnAngle)); // Limit the new calculated connect point between pt1 and pt2.
	
	        var t = pt2.x !== pt1.x ? (tmpProjPoint.x - pt1.x) / (pt2.x - pt1.x) : (tmpProjPoint.y - pt1.y) / (pt2.y - pt1.y);
	
	        if (isNaN(t)) {
	          return;
	        }
	
	        if (t < 0) {
	          Point.copy(tmpProjPoint, pt1);
	        } else if (t > 1) {
	          Point.copy(tmpProjPoint, pt2);
	        }
	
	        tmpProjPoint.toArray(linePoints[1]);
	      }
	    }
	    /**
	     * Limit the angle of line and the surface
	     * @param maxSurfaceAngle Radian of minimum turn angle. 0 - 180. 0 is same direction to normal. 180 is opposite
	     */
	
	    function limitSurfaceAngle(linePoints, surfaceNormal, maxSurfaceAngle) {
	      if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) {
	        return;
	      }
	
	      maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
	      pt0.fromArray(linePoints[0]);
	      pt1.fromArray(linePoints[1]);
	      pt2.fromArray(linePoints[2]);
	      Point.sub(dir, pt1, pt0);
	      Point.sub(dir2, pt2, pt1);
	      var len1 = dir.len();
	      var len2 = dir2.len();
	
	      if (len1 < 1e-3 || len2 < 1e-3) {
	        return;
	      }
	
	      dir.scale(1 / len1);
	      dir2.scale(1 / len2);
	      var angleCos = dir.dot(surfaceNormal);
	      var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
	
	      if (angleCos < maxSurfaceAngleCos) {
	        // Calculate project point of pt0 on pt1-pt2
	        var d = projectPointToLine(pt1.x, pt1.y, pt2.x, pt2.y, pt0.x, pt0.y, tmpArr, false);
	        tmpProjPoint.fromArray(tmpArr);
	        var HALF_PI = Math.PI / 2;
	        var angle2 = Math.acos(dir2.dot(surfaceNormal));
	        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
	
	        if (newAngle >= HALF_PI) {
	          // parallel
	          Point.copy(tmpProjPoint, pt2);
	        } else {
	          // Calculate new projected length with limited minTurnAngle and get the new connect point
	          tmpProjPoint.scaleAndAdd(dir2, d / Math.tan(Math.PI / 2 - newAngle)); // Limit the new calculated connect point between pt1 and pt2.
	
	          var t = pt2.x !== pt1.x ? (tmpProjPoint.x - pt1.x) / (pt2.x - pt1.x) : (tmpProjPoint.y - pt1.y) / (pt2.y - pt1.y);
	
	          if (isNaN(t)) {
	            return;
	          }
	
	          if (t < 0) {
	            Point.copy(tmpProjPoint, pt1);
	          } else if (t > 1) {
	            Point.copy(tmpProjPoint, pt2);
	          }
	        }
	
	        tmpProjPoint.toArray(linePoints[1]);
	      }
	    }
	
	    function setLabelLineState(labelLine, ignore, stateName, stateModel) {
	      var isNormal = stateName === 'normal';
	      var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName); // Make sure display.
	
	      stateObj.ignore = ignore; // Set smooth
	
	      var smooth = stateModel.get('smooth');
	
	      if (smooth && smooth === true) {
	        smooth = 0.3;
	      }
	
	      stateObj.shape = stateObj.shape || {};
	
	      if (smooth > 0) {
	        stateObj.shape.smooth = smooth;
	      }
	
	      var styleObj = stateModel.getModel('lineStyle').getLineStyle();
	      isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
	    }
	
	    function buildLabelLinePath(path, shape) {
	      var smooth = shape.smooth;
	      var points = shape.points;
	
	      if (!points) {
	        return;
	      }
	
	      path.moveTo(points[0][0], points[0][1]);
	
	      if (smooth > 0 && points.length >= 3) {
	        var len1 = dist(points[0], points[1]);
	        var len2 = dist(points[1], points[2]);
	
	        if (!len1 || !len2) {
	          path.lineTo(points[1][0], points[1][1]);
	          path.lineTo(points[2][0], points[2][1]);
	          return;
	        }
	
	        var moveLen = Math.min(len1, len2) * smooth;
	        var midPoint0 = lerp([], points[1], points[0], moveLen / len1);
	        var midPoint2 = lerp([], points[1], points[2], moveLen / len2);
	        var midPoint1 = lerp([], midPoint0, midPoint2, 0.5);
	        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
	        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
	      } else {
	        for (var i = 1; i < points.length; i++) {
	          path.lineTo(points[i][0], points[i][1]);
	        }
	      }
	    }
	    /**
	     * Create a label line if necessary and set it's style.
	     */
	
	
	    function setLabelLineStyle(targetEl, statesModels, defaultStyle) {
	      var labelLine = targetEl.getTextGuideLine();
	      var label = targetEl.getTextContent();
	
	      if (!label) {
	        // Not show label line if there is no label.
	        if (labelLine) {
	          targetEl.removeTextGuideLine();
	        }
	
	        return;
	      }
	
	      var normalModel = statesModels.normal;
	      var showNormal = normalModel.get('show');
	      var labelIgnoreNormal = label.ignore;
	
	      for (var i = 0; i < DISPLAY_STATES.length; i++) {
	        var stateName = DISPLAY_STATES[i];
	        var stateModel = statesModels[stateName];
	        var isNormal = stateName === 'normal';
	
	        if (stateModel) {
	          var stateShow = stateModel.get('show');
	          var isLabelIgnored = isNormal ? labelIgnoreNormal : retrieve2(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
	
	          if (isLabelIgnored // Not show when label is not shown in this state.
	          || !retrieve2(stateShow, showNormal) // Use normal state by default if not set.
	          ) {
	              var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];
	
	              if (stateObj) {
	                stateObj.ignore = true;
	              }
	
	              continue;
	            } // Create labelLine if not exists
	
	
	          if (!labelLine) {
	            labelLine = new Polyline();
	            targetEl.setTextGuideLine(labelLine); // Reset state of normal because it's new created.
	            // NOTE: NORMAL should always been the first!
	
	            if (!isNormal && (labelIgnoreNormal || !showNormal)) {
	              setLabelLineState(labelLine, true, 'normal', statesModels.normal);
	            } // Use same state proxy.
	
	
	            if (targetEl.stateProxy) {
	              labelLine.stateProxy = targetEl.stateProxy;
	            }
	          }
	
	          setLabelLineState(labelLine, false, stateName, stateModel);
	        }
	      }
	
	      if (labelLine) {
	        defaults(labelLine.style, defaultStyle); // Not fill.
	
	        labelLine.style.fill = null;
	        var showAbove = normalModel.get('showAbove');
	        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
	        labelLineConfig.showAbove = showAbove || false; // Custom the buildPath.
	
	        labelLine.buildPath = buildLabelLinePath;
	      }
	    }
	    function getLabelLineStatesModels(itemModel, labelLineName) {
	      labelLineName = labelLineName || 'labelLine';
	      var statesModels = {
	        normal: itemModel.getModel(labelLineName)
	      };
	
	      for (var i = 0; i < SPECIAL_STATES.length; i++) {
	        var stateName = SPECIAL_STATES[i];
	        statesModels[stateName] = itemModel.getModel([stateName, labelLineName]);
	      }
	
	      return statesModels;
	    }
	
	    function prepareLayoutList(input) {
	      var list = [];
	
	      for (var i = 0; i < input.length; i++) {
	        var rawItem = input[i];
	
	        if (rawItem.defaultAttr.ignore) {
	          continue;
	        }
	
	        var label = rawItem.label;
	        var transform = label.getComputedTransform(); // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.
	
	        var localRect = label.getBoundingRect();
	        var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
	        var minMargin = label.style.margin || 0;
	        var globalRect = localRect.clone();
	        globalRect.applyTransform(transform);
	        globalRect.x -= minMargin / 2;
	        globalRect.y -= minMargin / 2;
	        globalRect.width += minMargin;
	        globalRect.height += minMargin;
	        var obb = isAxisAligned ? new OrientedBoundingRect(localRect, transform) : null;
	        list.push({
	          label: label,
	          labelLine: rawItem.labelLine,
	          rect: globalRect,
	          localRect: localRect,
	          obb: obb,
	          priority: rawItem.priority,
	          defaultAttr: rawItem.defaultAttr,
	          layoutOption: rawItem.computedLayoutOption,
	          axisAligned: isAxisAligned,
	          transform: transform
	        });
	      }
	
	      return list;
	    }
	
	    function shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
	      var len = list.length;
	
	      if (len < 2) {
	        return;
	      }
	
	      list.sort(function (a, b) {
	        return a.rect[xyDim] - b.rect[xyDim];
	      });
	      var lastPos = 0;
	      var delta;
	      var adjusted = false;
	      var totalShifts = 0;
	
	      for (var i = 0; i < len; i++) {
	        var item = list[i];
	        var rect = item.rect;
	        delta = rect[xyDim] - lastPos;
	
	        if (delta < 0) {
	          // shiftForward(i, len, -delta);
	          rect[xyDim] -= delta;
	          item.label[xyDim] -= delta;
	          adjusted = true;
	        }
	
	        var shift = Math.max(-delta, 0);
	        totalShifts += shift;
	        lastPos = rect[xyDim] + rect[sizeDim];
	      }
	
	      if (totalShifts > 0 && balanceShift) {
	        // Shift back to make the distribution more equally.
	        shiftList(-totalShifts / len, 0, len);
	      } // TODO bleedMargin?
	
	
	      var first = list[0];
	      var last = list[len - 1];
	      var minGap;
	      var maxGap;
	      updateMinMaxGap(); // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
	
	      minGap < 0 && squeezeGaps(-minGap, 0.8);
	      maxGap < 0 && squeezeGaps(maxGap, 0.8);
	      updateMinMaxGap();
	      takeBoundsGap(minGap, maxGap, 1);
	      takeBoundsGap(maxGap, minGap, -1); // Handle bailout when there is not enough space.
	
	      updateMinMaxGap();
	
	      if (minGap < 0) {
	        squeezeWhenBailout(-minGap);
	      }
	
	      if (maxGap < 0) {
	        squeezeWhenBailout(maxGap);
	      }
	
	      function updateMinMaxGap() {
	        minGap = first.rect[xyDim] - minBound;
	        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
	      }
	
	      function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
	        if (gapThisBound < 0) {
	          // Move from other gap if can.
	          var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
	
	          if (moveFromMaxGap > 0) {
	            shiftList(moveFromMaxGap * moveDir, 0, len);
	            var remained = moveFromMaxGap + gapThisBound;
	
	            if (remained < 0) {
	              squeezeGaps(-remained * moveDir, 1);
	            }
	          } else {
	            squeezeGaps(-gapThisBound * moveDir, 1);
	          }
	        }
	      }
	
	      function shiftList(delta, start, end) {
	        if (delta !== 0) {
	          adjusted = true;
	        }
	
	        for (var i = start; i < end; i++) {
	          var item = list[i];
	          var rect = item.rect;
	          rect[xyDim] += delta;
	          item.label[xyDim] += delta;
	        }
	      } // Squeeze gaps if the labels exceed margin.
	
	
	      function squeezeGaps(delta, maxSqeezePercent) {
	        var gaps = [];
	        var totalGaps = 0;
	
	        for (var i = 1; i < len; i++) {
	          var prevItemRect = list[i - 1].rect;
	          var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
	          gaps.push(gap);
	          totalGaps += gap;
	        }
	
	        if (!totalGaps) {
	          return;
	        }
	
	        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
	
	        if (delta > 0) {
	          for (var i = 0; i < len - 1; i++) {
	            // Distribute the shift delta to all gaps.
	            var movement = gaps[i] * squeezePercent; // Forward
	
	            shiftList(movement, 0, i + 1);
	          }
	        } else {
	          // Backward
	          for (var i = len - 1; i > 0; i--) {
	            // Distribute the shift delta to all gaps.
	            var movement = gaps[i - 1] * squeezePercent;
	            shiftList(-movement, i, len);
	          }
	        }
	      }
	      /**
	       * Squeeze to allow overlap if there is no more space available.
	       * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
	       */
	
	
	      function squeezeWhenBailout(delta) {
	        var dir = delta < 0 ? -1 : 1;
	        delta = Math.abs(delta);
	        var moveForEachLabel = Math.ceil(delta / (len - 1));
	
	        for (var i = 0; i < len - 1; i++) {
	          if (dir > 0) {
	            // Forward
	            shiftList(moveForEachLabel, 0, i + 1);
	          } else {
	            // Backward
	            shiftList(-moveForEachLabel, len - i - 1, len);
	          }
	
	          delta -= moveForEachLabel;
	
	          if (delta <= 0) {
	            return;
	          }
	        }
	      }
	
	      return adjusted;
	    }
	    /**
	     * Adjust labels on x direction to avoid overlap.
	     */
	
	
	    function shiftLayoutOnX(list, leftBound, rightBound, // If average the shifts on all labels and add them to 0
	    // TODO: Not sure if should enable it.
	    // Pros: The angle of lines will distribute more equally
	    // Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
	    balanceShift) {
	      return shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
	    }
	    /**
	     * Adjust labels on y direction to avoid overlap.
	     */
	
	    function shiftLayoutOnY(list, topBound, bottomBound, // If average the shifts on all labels and add them to 0
	    balanceShift) {
	      return shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
	    }
	    function hideOverlap(labelList) {
	      var displayedLabels = []; // TODO, render overflow visible first, put in the displayedLabels.
	
	      labelList.sort(function (a, b) {
	        return b.priority - a.priority;
	      });
	      var globalRect = new BoundingRect(0, 0, 0, 0);
	
	      function hideEl(el) {
	        if (!el.ignore) {
	          // Show on emphasis.
	          var emphasisState = el.ensureState('emphasis');
	
	          if (emphasisState.ignore == null) {
	            emphasisState.ignore = false;
	          }
	        }
	
	        el.ignore = true;
	      }
	
	      for (var i = 0; i < labelList.length; i++) {
	        var labelItem = labelList[i];
	        var isAxisAligned = labelItem.axisAligned;
	        var localRect = labelItem.localRect;
	        var transform = labelItem.transform;
	        var label = labelItem.label;
	        var labelLine = labelItem.labelLine;
	        globalRect.copy(labelItem.rect); // Add a threshold because layout may be aligned precisely.
	
	        globalRect.width -= 0.1;
	        globalRect.height -= 0.1;
	        globalRect.x += 0.05;
	        globalRect.y += 0.05;
	        var obb = labelItem.obb;
	        var overlapped = false;
	
	        for (var j = 0; j < displayedLabels.length; j++) {
	          var existsTextCfg = displayedLabels[j]; // Fast rejection.
	
	          if (!globalRect.intersect(existsTextCfg.rect)) {
	            continue;
	          }
	
	          if (isAxisAligned && existsTextCfg.axisAligned) {
	            // Is overlapped
	            overlapped = true;
	            break;
	          }
	
	          if (!existsTextCfg.obb) {
	            // If self is not axis aligned. But other is.
	            existsTextCfg.obb = new OrientedBoundingRect(existsTextCfg.localRect, existsTextCfg.transform);
	          }
	
	          if (!obb) {
	            // If self is axis aligned. But other is not.
	            obb = new OrientedBoundingRect(localRect, transform);
	          }
	
	          if (obb.intersect(existsTextCfg.obb)) {
	            overlapped = true;
	            break;
	          }
	        } // TODO Callback to determine if this overlap should be handled?
	
	
	        if (overlapped) {
	          hideEl(label);
	          labelLine && hideEl(labelLine);
	        } else {
	          label.attr('ignore', labelItem.defaultAttr.ignore);
	          labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
	          displayedLabels.push(labelItem);
	        }
	      }
	    }
	
	    function cloneArr(points) {
	      if (points) {
	        var newPoints = [];
	
	        for (var i = 0; i < points.length; i++) {
	          newPoints.push(points[i].slice());
	        }
	
	        return newPoints;
	      }
	    }
	
	    function prepareLayoutCallbackParams(labelItem, hostEl) {
	      var label = labelItem.label;
	      var labelLine = hostEl && hostEl.getTextGuideLine();
	      return {
	        dataIndex: labelItem.dataIndex,
	        dataType: labelItem.dataType,
	        seriesIndex: labelItem.seriesModel.seriesIndex,
	        text: labelItem.label.style.text,
	        rect: labelItem.hostRect,
	        labelRect: labelItem.rect,
	        // x: labelAttr.x,
	        // y: labelAttr.y,
	        align: label.style.align,
	        verticalAlign: label.style.verticalAlign,
	        labelLinePoints: cloneArr(labelLine && labelLine.shape.points)
	      };
	    }
	
	    var LABEL_OPTION_TO_STYLE_KEYS = ['align', 'verticalAlign', 'width', 'height', 'fontSize'];
	    var dummyTransformable = new Transformable();
	    var labelLayoutInnerStore = makeInner();
	    var labelLineAnimationStore = makeInner();
	
	    function extendWithKeys(target, source, keys) {
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	
	        if (source[key] != null) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    var LABEL_LAYOUT_PROPS = ['x', 'y', 'rotation'];
	
	    var LabelManager =
	    /** @class */
	    function () {
	      function LabelManager() {
	        this._labelList = [];
	        this._chartViewList = [];
	      }
	
	      LabelManager.prototype.clearLabels = function () {
	        this._labelList = [];
	        this._chartViewList = [];
	      };
	      /**
	       * Add label to manager
	       */
	
	
	      LabelManager.prototype._addLabel = function (dataIndex, dataType, seriesModel, label, layoutOption) {
	        var labelStyle = label.style;
	        var hostEl = label.__hostTarget;
	        var textConfig = hostEl.textConfig || {}; // TODO: If label is in other state.
	
	        var labelTransform = label.getComputedTransform();
	        var labelRect = label.getBoundingRect().plain();
	        BoundingRect.applyTransform(labelRect, labelRect, labelTransform);
	
	        if (labelTransform) {
	          dummyTransformable.setLocalTransform(labelTransform);
	        } else {
	          // Identity transform.
	          dummyTransformable.x = dummyTransformable.y = dummyTransformable.rotation = dummyTransformable.originX = dummyTransformable.originY = 0;
	          dummyTransformable.scaleX = dummyTransformable.scaleY = 1;
	        }
	
	        dummyTransformable.rotation = normalizeRadian(dummyTransformable.rotation);
	        var host = label.__hostTarget;
	        var hostRect;
	
	        if (host) {
	          hostRect = host.getBoundingRect().plain();
	          var transform = host.getComputedTransform();
	          BoundingRect.applyTransform(hostRect, hostRect, transform);
	        }
	
	        var labelGuide = hostRect && host.getTextGuideLine();
	
	        this._labelList.push({
	          label: label,
	          labelLine: labelGuide,
	          seriesModel: seriesModel,
	          dataIndex: dataIndex,
	          dataType: dataType,
	          layoutOption: layoutOption,
	          computedLayoutOption: null,
	          rect: labelRect,
	          hostRect: hostRect,
	          // Label with lower priority will be hidden when overlapped
	          // Use rect size as default priority
	          priority: hostRect ? hostRect.width * hostRect.height : 0,
	          // Save default label attributes.
	          // For restore if developers want get back to default value in callback.
	          defaultAttr: {
	            ignore: label.ignore,
	            labelGuideIgnore: labelGuide && labelGuide.ignore,
	            x: dummyTransformable.x,
	            y: dummyTransformable.y,
	            scaleX: dummyTransformable.scaleX,
	            scaleY: dummyTransformable.scaleY,
	            rotation: dummyTransformable.rotation,
	            style: {
	              x: labelStyle.x,
	              y: labelStyle.y,
	              align: labelStyle.align,
	              verticalAlign: labelStyle.verticalAlign,
	              width: labelStyle.width,
	              height: labelStyle.height,
	              fontSize: labelStyle.fontSize
	            },
	            cursor: label.cursor,
	            attachedPos: textConfig.position,
	            attachedRot: textConfig.rotation
	          }
	        });
	      };
	
	      LabelManager.prototype.addLabelsOfSeries = function (chartView) {
	        var _this = this;
	
	        this._chartViewList.push(chartView);
	
	        var seriesModel = chartView.__model;
	        var layoutOption = seriesModel.get('labelLayout');
	        /**
	         * Ignore layouting if it's not specified anything.
	         */
	
	        if (!(isFunction(layoutOption) || keys(layoutOption).length)) {
	          return;
	        }
	
	        chartView.group.traverse(function (child) {
	          if (child.ignore) {
	            return true; // Stop traverse descendants.
	          } // Only support label being hosted on graphic elements.
	
	
	          var textEl = child.getTextContent();
	          var ecData = getECData(child); // Can only attach the text on the element with dataIndex
	
	          if (textEl && !textEl.disableLabelLayout) {
	            _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
	          }
	        });
	      };
	
	      LabelManager.prototype.updateLayoutConfig = function (api) {
	        var width = api.getWidth();
	        var height = api.getHeight();
	
	        function createDragHandler(el, labelLineModel) {
	          return function () {
	            updateLabelLinePoints(el, labelLineModel);
	          };
	        }
	
	        for (var i = 0; i < this._labelList.length; i++) {
	          var labelItem = this._labelList[i];
	          var label = labelItem.label;
	          var hostEl = label.__hostTarget;
	          var defaultLabelAttr = labelItem.defaultAttr;
	          var layoutOption = void 0; // TODO A global layout option?
	
	          if (isFunction(labelItem.layoutOption)) {
	            layoutOption = labelItem.layoutOption(prepareLayoutCallbackParams(labelItem, hostEl));
	          } else {
	            layoutOption = labelItem.layoutOption;
	          }
	
	          layoutOption = layoutOption || {};
	          labelItem.computedLayoutOption = layoutOption;
	          var degreeToRadian = Math.PI / 180; // TODO hostEl should always exists.
	          // Or label should not have parent because the x, y is all in global space.
	
	          if (hostEl) {
	            hostEl.setTextConfig({
	              // Force to set local false.
	              local: false,
	              // Ignore position and rotation config on the host el if x or y is changed.
	              position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
	              // Ignore rotation config on the host el if rotation is changed.
	              rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
	              offset: [layoutOption.dx || 0, layoutOption.dy || 0]
	            });
	          }
	
	          var needsUpdateLabelLine = false;
	
	          if (layoutOption.x != null) {
	            // TODO width of chart view.
	            label.x = parsePercent$1(layoutOption.x, width);
	            label.setStyle('x', 0); // Ignore movement in style. TODO: origin.
	
	            needsUpdateLabelLine = true;
	          } else {
	            label.x = defaultLabelAttr.x;
	            label.setStyle('x', defaultLabelAttr.style.x);
	          }
	
	          if (layoutOption.y != null) {
	            // TODO height of chart view.
	            label.y = parsePercent$1(layoutOption.y, height);
	            label.setStyle('y', 0); // Ignore movement in style.
	
	            needsUpdateLabelLine = true;
	          } else {
	            label.y = defaultLabelAttr.y;
	            label.setStyle('y', defaultLabelAttr.style.y);
	          }
	
	          if (layoutOption.labelLinePoints) {
	            var guideLine = hostEl.getTextGuideLine();
	
	            if (guideLine) {
	              guideLine.setShape({
	                points: layoutOption.labelLinePoints
	              }); // Not update
	
	              needsUpdateLabelLine = false;
	            }
	          }
	
	          var labelLayoutStore = labelLayoutInnerStore(label);
	          labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
	          label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
	          label.scaleX = defaultLabelAttr.scaleX;
	          label.scaleY = defaultLabelAttr.scaleY;
	
	          for (var k = 0; k < LABEL_OPTION_TO_STYLE_KEYS.length; k++) {
	            var key = LABEL_OPTION_TO_STYLE_KEYS[k];
	            label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
	          }
	
	          if (layoutOption.draggable) {
	            label.draggable = true;
	            label.cursor = 'move';
	
	            if (hostEl) {
	              var hostModel = labelItem.seriesModel;
	
	              if (labelItem.dataIndex != null) {
	                var data = labelItem.seriesModel.getData(labelItem.dataType);
	                hostModel = data.getItemModel(labelItem.dataIndex);
	              }
	
	              label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
	            }
	          } else {
	            // TODO Other drag functions?
	            label.off('drag');
	            label.cursor = defaultLabelAttr.cursor;
	          }
	        }
	      };
	
	      LabelManager.prototype.layout = function (api) {
	        var width = api.getWidth();
	        var height = api.getHeight();
	        var labelList = prepareLayoutList(this._labelList);
	        var labelsNeedsAdjustOnX = filter(labelList, function (item) {
	          return item.layoutOption.moveOverlap === 'shiftX';
	        });
	        var labelsNeedsAdjustOnY = filter(labelList, function (item) {
	          return item.layoutOption.moveOverlap === 'shiftY';
	        });
	        shiftLayoutOnX(labelsNeedsAdjustOnX, 0, width);
	        shiftLayoutOnY(labelsNeedsAdjustOnY, 0, height);
	        var labelsNeedsHideOverlap = filter(labelList, function (item) {
	          return item.layoutOption.hideOverlap;
	        });
	        hideOverlap(labelsNeedsHideOverlap);
	      };
	      /**
	       * Process all labels. Not only labels with layoutOption.
	       */
	
	
	      LabelManager.prototype.processLabelsOverall = function () {
	        var _this = this;
	
	        each(this._chartViewList, function (chartView) {
	          var seriesModel = chartView.__model;
	          var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
	          var animationEnabled = seriesModel.isAnimationEnabled();
	          chartView.group.traverse(function (child) {
	            if (child.ignore && !child.forceLabelAnimation) {
	              return true; // Stop traverse descendants.
	            }
	
	            var needsUpdateLabelLine = !ignoreLabelLineUpdate;
	            var label = child.getTextContent();
	
	            if (!needsUpdateLabelLine && label) {
	              needsUpdateLabelLine = labelLayoutInnerStore(label).needsUpdateLabelLine;
	            }
	
	            if (needsUpdateLabelLine) {
	              _this._updateLabelLine(child, seriesModel);
	            }
	
	            if (animationEnabled) {
	              _this._animateLabels(child, seriesModel);
	            }
	          });
	        });
	      };
	
	      LabelManager.prototype._updateLabelLine = function (el, seriesModel) {
	        // Only support label being hosted on graphic elements.
	        var textEl = el.getTextContent(); // Update label line style.
	
	        var ecData = getECData(el);
	        var dataIndex = ecData.dataIndex; // Only support labelLine on the labels represent data.
	
	        if (textEl && dataIndex != null) {
	          var data = seriesModel.getData(ecData.dataType);
	          var itemModel = data.getItemModel(dataIndex);
	          var defaultStyle = {};
	          var visualStyle = data.getItemVisual(dataIndex, 'style');
	
	          if (visualStyle) {
	            var visualType = data.getVisual('drawType'); // Default to be same with main color
	
	            defaultStyle.stroke = visualStyle[visualType];
	          }
	
	          var labelLineModel = itemModel.getModel('labelLine');
	          setLabelLineStyle(el, getLabelLineStatesModels(itemModel), defaultStyle);
	          updateLabelLinePoints(el, labelLineModel);
	        }
	      };
	
	      LabelManager.prototype._animateLabels = function (el, seriesModel) {
	        var textEl = el.getTextContent();
	        var guideLine = el.getTextGuideLine(); // Animate
	
	        if (textEl // `forceLabelAnimation` has the highest priority
	        && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !isElementRemoved(el))) {
	          var layoutStore = labelLayoutInnerStore(textEl);
	          var oldLayout = layoutStore.oldLayout;
	          var ecData = getECData(el);
	          var dataIndex = ecData.dataIndex;
	          var newProps = {
	            x: textEl.x,
	            y: textEl.y,
	            rotation: textEl.rotation
	          };
	          var data = seriesModel.getData(ecData.dataType);
	
	          if (!oldLayout) {
	            textEl.attr(newProps); // Disable fade in animation if value animation is enabled.
	
	            if (!labelInner(textEl).valueAnimation) {
	              var oldOpacity = retrieve2(textEl.style.opacity, 1); // Fade in animation
	
	              textEl.style.opacity = 0;
	              initProps(textEl, {
	                style: {
	                  opacity: oldOpacity
	                }
	              }, seriesModel, dataIndex);
	            }
	          } else {
	            textEl.attr(oldLayout); // Make sure the animation from is in the right status.
	
	            var prevStates = el.prevStates;
	
	            if (prevStates) {
	              if (indexOf(prevStates, 'select') >= 0) {
	                textEl.attr(layoutStore.oldLayoutSelect);
	              }
	
	              if (indexOf(prevStates, 'emphasis') >= 0) {
	                textEl.attr(layoutStore.oldLayoutEmphasis);
	              }
	            }
	
	            updateProps(textEl, newProps, seriesModel, dataIndex);
	          }
	
	          layoutStore.oldLayout = newProps;
	
	          if (textEl.states.select) {
	            var layoutSelect = layoutStore.oldLayoutSelect = {};
	            extendWithKeys(layoutSelect, newProps, LABEL_LAYOUT_PROPS);
	            extendWithKeys(layoutSelect, textEl.states.select, LABEL_LAYOUT_PROPS);
	          }
	
	          if (textEl.states.emphasis) {
	            var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
	            extendWithKeys(layoutEmphasis, newProps, LABEL_LAYOUT_PROPS);
	            extendWithKeys(layoutEmphasis, textEl.states.emphasis, LABEL_LAYOUT_PROPS);
	          }
	
	          animateLabelValue(textEl, dataIndex, data, seriesModel, seriesModel);
	        }
	
	        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
	          var layoutStore = labelLineAnimationStore(guideLine);
	          var oldLayout = layoutStore.oldLayout;
	          var newLayout = {
	            points: guideLine.shape.points
	          };
	
	          if (!oldLayout) {
	            guideLine.setShape(newLayout);
	            guideLine.style.strokePercent = 0;
	            initProps(guideLine, {
	              style: {
	                strokePercent: 1
	              }
	            }, seriesModel);
	          } else {
	            guideLine.attr({
	              shape: oldLayout
	            });
	            updateProps(guideLine, {
	              shape: newLayout
	            }, seriesModel);
	          }
	
	          layoutStore.oldLayout = newLayout;
	        }
	      };
	
	      return LabelManager;
	    }();
	
	    var getLabelManager = makeInner();
	    function installLabelLayout(registers) {
	      registers.registerUpdateLifecycle('series:beforeupdate', function (ecModel, api, params) {
	        // TODO api provide an namespace that can save stuff per instance
	        var labelManager = getLabelManager(api).labelManager;
	
	        if (!labelManager) {
	          labelManager = getLabelManager(api).labelManager = new LabelManager();
	        }
	
	        labelManager.clearLabels();
	      });
	      registers.registerUpdateLifecycle('series:layoutlabels', function (ecModel, api, params) {
	        var labelManager = getLabelManager(api).labelManager;
	        params.updatedSeries.forEach(function (series) {
	          labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
	        });
	        labelManager.updateLayoutConfig(api);
	        labelManager.layout(api);
	        labelManager.processLabelsOverall();
	      });
	    }
	
	    var mathSin$4 = Math.sin;
	    var mathCos$4 = Math.cos;
	    var PI$4 = Math.PI;
	    var PI2$7 = Math.PI * 2;
	    var degree = 180 / PI$4;
	    var SVGPathRebuilder = (function () {
	        function SVGPathRebuilder() {
	        }
	        SVGPathRebuilder.prototype.reset = function (precision) {
	            this._start = true;
	            this._d = [];
	            this._str = '';
	            this._p = Math.pow(10, precision || 4);
	        };
	        SVGPathRebuilder.prototype.moveTo = function (x, y) {
	            this._add('M', x, y);
	        };
	        SVGPathRebuilder.prototype.lineTo = function (x, y) {
	            this._add('L', x, y);
	        };
	        SVGPathRebuilder.prototype.bezierCurveTo = function (x, y, x2, y2, x3, y3) {
	            this._add('C', x, y, x2, y2, x3, y3);
	        };
	        SVGPathRebuilder.prototype.quadraticCurveTo = function (x, y, x2, y2) {
	            this._add('Q', x, y, x2, y2);
	        };
	        SVGPathRebuilder.prototype.arc = function (cx, cy, r, startAngle, endAngle, anticlockwise) {
	            this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
	        };
	        SVGPathRebuilder.prototype.ellipse = function (cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
	            var dTheta = endAngle - startAngle;
	            var clockwise = !anticlockwise;
	            var dThetaPositive = Math.abs(dTheta);
	            var isCircle = isAroundZero$1(dThetaPositive - PI2$7)
	                || (clockwise ? dTheta >= PI2$7 : -dTheta >= PI2$7);
	            var unifiedTheta = dTheta > 0 ? dTheta % PI2$7 : (dTheta % PI2$7 + PI2$7);
	            var large = false;
	            if (isCircle) {
	                large = true;
	            }
	            else if (isAroundZero$1(dThetaPositive)) {
	                large = false;
	            }
	            else {
	                large = (unifiedTheta >= PI$4) === !!clockwise;
	            }
	            var x0 = cx + rx * mathCos$4(startAngle);
	            var y0 = cy + ry * mathSin$4(startAngle);
	            if (this._start) {
	                this._add('M', x0, y0);
	            }
	            var xRot = Math.round(psi * degree);
	            if (isCircle) {
	                var p = 1 / this._p;
	                var dTheta_1 = (clockwise ? 1 : -1) * (PI2$7 - p);
	                this._add('A', rx, ry, xRot, 1, +clockwise, cx + rx * mathCos$4(startAngle + dTheta_1), cy + ry * mathSin$4(startAngle + dTheta_1));
	                if (p > 1e-2) {
	                    this._add('A', rx, ry, xRot, 0, +clockwise, x0, y0);
	                }
	            }
	            else {
	                var x = cx + rx * mathCos$4(endAngle);
	                var y = cy + ry * mathSin$4(endAngle);
	                this._add('A', rx, ry, xRot, +large, +clockwise, x, y);
	            }
	        };
	        SVGPathRebuilder.prototype.rect = function (x, y, w, h) {
	            this._add('M', x, y);
	            this._add('l', w, 0);
	            this._add('l', 0, h);
	            this._add('l', -w, 0);
	            this._add('Z');
	        };
	        SVGPathRebuilder.prototype.closePath = function () {
	            if (this._d.length > 0) {
	                this._add('Z');
	            }
	        };
	        SVGPathRebuilder.prototype._add = function (cmd, a, b, c, d, e, f, g, h) {
	            var vals = [];
	            var p = this._p;
	            for (var i = 1; i < arguments.length; i++) {
	                var val = arguments[i];
	                if (isNaN(val)) {
	                    this._invalid = true;
	                    return;
	                }
	                vals.push(Math.round(val * p) / p);
	            }
	            this._d.push(cmd + vals.join(' '));
	            this._start = cmd === 'Z';
	        };
	        SVGPathRebuilder.prototype.generateStr = function () {
	            this._str = this._invalid ? '' : this._d.join('');
	            this._d = [];
	        };
	        SVGPathRebuilder.prototype.getStr = function () {
	            return this._str;
	        };
	        return SVGPathRebuilder;
	    }());
	
	    var NONE = 'none';
	    var mathRound$1 = Math.round;
	    function pathHasFill(style) {
	        var fill = style.fill;
	        return fill != null && fill !== NONE;
	    }
	    function pathHasStroke(style) {
	        var stroke = style.stroke;
	        return stroke != null && stroke !== NONE;
	    }
	    var strokeProps = ['lineCap', 'miterLimit', 'lineJoin'];
	    var svgStrokeProps = map(strokeProps, function (prop) { return "stroke-" + prop.toLowerCase(); });
	    function mapStyleToAttrs(updateAttr, style, el, forceUpdate) {
	        var opacity = style.opacity == null ? 1 : style.opacity;
	        if (el instanceof ZRImage) {
	            updateAttr('opacity', opacity);
	            return;
	        }
	        if (pathHasFill(style)) {
	            var fill = normalizeColor(style.fill);
	            updateAttr('fill', fill.color);
	            var fillOpacity = style.fillOpacity != null
	                ? style.fillOpacity * fill.opacity * opacity
	                : fill.opacity * opacity;
	            if (forceUpdate || fillOpacity < 1) {
	                updateAttr('fill-opacity', fillOpacity);
	            }
	        }
	        else {
	            updateAttr('fill', NONE);
	        }
	        if (pathHasStroke(style)) {
	            var stroke = normalizeColor(style.stroke);
	            updateAttr('stroke', stroke.color);
	            var strokeScale = style.strokeNoScale
	                ? el.getLineScale()
	                : 1;
	            var strokeWidth = (strokeScale ? (style.lineWidth || 0) / strokeScale : 0);
	            var strokeOpacity = style.strokeOpacity != null
	                ? style.strokeOpacity * stroke.opacity * opacity
	                : stroke.opacity * opacity;
	            var strokeFirst = style.strokeFirst;
	            if (forceUpdate || strokeWidth !== 1) {
	                updateAttr('stroke-width', strokeWidth);
	            }
	            if (forceUpdate || strokeFirst) {
	                updateAttr('paint-order', strokeFirst ? 'stroke' : 'fill');
	            }
	            if (forceUpdate || strokeOpacity < 1) {
	                updateAttr('stroke-opacity', strokeOpacity);
	            }
	            if (style.lineDash) {
	                var _a = getLineDash(el), lineDash = _a[0], lineDashOffset = _a[1];
	                if (lineDash) {
	                    lineDashOffset = mathRound$1(lineDashOffset || 0);
	                    updateAttr('stroke-dasharray', lineDash.join(','));
	                    if (lineDashOffset || forceUpdate) {
	                        updateAttr('stroke-dashoffset', lineDashOffset);
	                    }
	                }
	            }
	            else if (forceUpdate) {
	                updateAttr('stroke-dasharray', NONE);
	            }
	            for (var i = 0; i < strokeProps.length; i++) {
	                var propName = strokeProps[i];
	                if (forceUpdate || style[propName] !== DEFAULT_PATH_STYLE[propName]) {
	                    var val = style[propName] || DEFAULT_PATH_STYLE[propName];
	                    val && updateAttr(svgStrokeProps[i], val);
	                }
	            }
	        }
	        else if (forceUpdate) {
	            updateAttr('stroke', NONE);
	        }
	    }
	
	    var SVGNS = 'http://www.w3.org/2000/svg';
	    var XLINKNS = 'http://www.w3.org/1999/xlink';
	    var XMLNS = 'http://www.w3.org/2000/xmlns/';
	    var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
	    function createElement(name) {
	        return document.createElementNS(SVGNS, name);
	    }
	    function createVNode(tag, key, attrs, children, text) {
	        return {
	            tag: tag,
	            attrs: attrs || {},
	            children: children,
	            text: text,
	            key: key
	        };
	    }
	    function createElementOpen(name, attrs) {
	        var attrsStr = [];
	        if (attrs) {
	            for (var key in attrs) {
	                var val = attrs[key];
	                var part = key;
	                if (val === false) {
	                    continue;
	                }
	                else if (val !== true && val != null) {
	                    part += "=\"" + val + "\"";
	                }
	                attrsStr.push(part);
	            }
	        }
	        return "<" + name + " " + attrsStr.join(' ') + ">";
	    }
	    function createElementClose(name) {
	        return "</" + name + ">";
	    }
	    function vNodeToString(el, opts) {
	        opts = opts || {};
	        var S = opts.newline ? '\n' : '';
	        function convertElToString(el) {
	            var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
	            return createElementOpen(tag, attrs)
	                + (tag !== 'style' ? encodeHTML(text) : text || '')
	                + (children ? "" + S + map(children, function (child) { return convertElToString(child); }).join(S) + S : '')
	                + createElementClose(tag);
	        }
	        return convertElToString(el);
	    }
	    function getCssString(selectorNodes, animationNodes, opts) {
	        opts = opts || {};
	        var S = opts.newline ? '\n' : '';
	        var bracketBegin = " {" + S;
	        var bracketEnd = S + "}";
	        var selectors = map(keys(selectorNodes), function (className) {
	            return className + bracketBegin + map(keys(selectorNodes[className]), function (attrName) {
	                return attrName + ":" + selectorNodes[className][attrName] + ";";
	            }).join(S) + bracketEnd;
	        }).join(S);
	        var animations = map(keys(animationNodes), function (animationName) {
	            return "@keyframes " + animationName + bracketBegin + map(keys(animationNodes[animationName]), function (percent) {
	                return percent + bracketBegin + map(keys(animationNodes[animationName][percent]), function (attrName) {
	                    var val = animationNodes[animationName][percent][attrName];
	                    if (attrName === 'd') {
	                        val = "path(\"" + val + "\")";
	                    }
	                    return attrName + ":" + val + ";";
	                }).join(S) + bracketEnd;
	            }).join(S) + bracketEnd;
	        }).join(S);
	        if (!selectors && !animations) {
	            return '';
	        }
	        return ['<![CDATA[', selectors, animations, ']]>'].join(S);
	    }
	    function createBrushScope(zrId) {
	        return {
	            zrId: zrId,
	            shadowCache: {},
	            patternCache: {},
	            gradientCache: {},
	            clipPathCache: {},
	            defs: {},
	            cssNodes: {},
	            cssAnims: {},
	            cssClassIdx: 0,
	            cssAnimIdx: 0,
	            shadowIdx: 0,
	            gradientIdx: 0,
	            patternIdx: 0,
	            clipPathIdx: 0
	        };
	    }
	    function createSVGVNode(width, height, children, useViewBox) {
	        return createVNode('svg', 'root', {
	            'width': width,
	            'height': height,
	            'xmlns': SVGNS,
	            'xmlns:xlink': XLINKNS,
	            'version': '1.1',
	            'baseProfile': 'full',
	            'viewBox': useViewBox ? "0 0 " + width + " " + height : false
	        }, children);
	    }
	
	    var EASING_MAP = {
	        cubicIn: '0.32,0,0.67,0',
	        cubicOut: '0.33,1,0.68,1',
	        cubicInOut: '0.65,0,0.35,1',
	        quadraticIn: '0.11,0,0.5,0',
	        quadraticOut: '0.5,1,0.89,1',
	        quadraticInOut: '0.45,0,0.55,1',
	        quarticIn: '0.5,0,0.75,0',
	        quarticOut: '0.25,1,0.5,1',
	        quarticInOut: '0.76,0,0.24,1',
	        quinticIn: '0.64,0,0.78,0',
	        quinticOut: '0.22,1,0.36,1',
	        quinticInOut: '0.83,0,0.17,1',
	        sinusoidalIn: '0.12,0,0.39,0',
	        sinusoidalOut: '0.61,1,0.88,1',
	        sinusoidalInOut: '0.37,0,0.63,1',
	        exponentialIn: '0.7,0,0.84,0',
	        exponentialOut: '0.16,1,0.3,1',
	        exponentialInOut: '0.87,0,0.13,1',
	        circularIn: '0.55,0,1,0.45',
	        circularOut: '0,0.55,0.45,1',
	        circularInOut: '0.85,0,0.15,1'
	    };
	    var transformOriginKey = 'transform-origin';
	    function buildPathString(el, kfShape, path) {
	        var shape = extend({}, el.shape);
	        extend(shape, kfShape);
	        el.buildPath(path, shape);
	        var svgPathBuilder = new SVGPathRebuilder();
	        svgPathBuilder.reset(getPathPrecision(el));
	        path.rebuildPath(svgPathBuilder, 1);
	        svgPathBuilder.generateStr();
	        return svgPathBuilder.getStr();
	    }
	    function setTransformOrigin(target, transform) {
	        var originX = transform.originX, originY = transform.originY;
	        if (originX || originY) {
	            target[transformOriginKey] = originX + "px " + originY + "px";
	        }
	    }
	    var ANIMATE_STYLE_MAP = {
	        fill: 'fill',
	        opacity: 'opacity',
	        lineWidth: 'stroke-width',
	        lineDashOffset: 'stroke-dashoffset'
	    };
	    function addAnimation(cssAnim, scope) {
	        var animationName = scope.zrId + '-ani-' + scope.cssAnimIdx++;
	        scope.cssAnims[animationName] = cssAnim;
	        return animationName;
	    }
	    function createCompoundPathCSSAnimation(el, attrs, scope) {
	        var paths = el.shape.paths;
	        var composedAnim = {};
	        var cssAnimationCfg;
	        var cssAnimationName;
	        each(paths, function (path) {
	            var subScope = createBrushScope(scope.zrId);
	            subScope.animation = true;
	            createCSSAnimation(path, {}, subScope, true);
	            var cssAnims = subScope.cssAnims;
	            var cssNodes = subScope.cssNodes;
	            var animNames = keys(cssAnims);
	            var len = animNames.length;
	            if (!len) {
	                return;
	            }
	            cssAnimationName = animNames[len - 1];
	            var lastAnim = cssAnims[cssAnimationName];
	            for (var percent in lastAnim) {
	                var kf = lastAnim[percent];
	                composedAnim[percent] = composedAnim[percent] || { d: '' };
	                composedAnim[percent].d += kf.d || '';
	            }
	            for (var className in cssNodes) {
	                var val = cssNodes[className].animation;
	                if (val.indexOf(cssAnimationName) >= 0) {
	                    cssAnimationCfg = val;
	                }
	            }
	        });
	        if (!cssAnimationCfg) {
	            return;
	        }
	        attrs.d = false;
	        var animationName = addAnimation(composedAnim, scope);
	        return cssAnimationCfg.replace(cssAnimationName, animationName);
	    }
	    function getEasingFunc(easing) {
	        return isString(easing)
	            ? EASING_MAP[easing]
	                ? "cubic-bezier(" + EASING_MAP[easing] + ")"
	                : createCubicEasingFunc(easing) ? easing : ''
	            : '';
	    }
	    function createCSSAnimation(el, attrs, scope, onlyShape) {
	        var animators = el.animators;
	        var len = animators.length;
	        var cssAnimations = [];
	        if (el instanceof CompoundPath) {
	            var animationCfg = createCompoundPathCSSAnimation(el, attrs, scope);
	            if (animationCfg) {
	                cssAnimations.push(animationCfg);
	            }
	            else if (!len) {
	                return;
	            }
	        }
	        else if (!len) {
	            return;
	        }
	        var groupAnimators = {};
	        for (var i = 0; i < len; i++) {
	            var animator = animators[i];
	            var cfgArr = [animator.getMaxTime() / 1000 + 's'];
	            var easing = getEasingFunc(animator.getClip().easing);
	            var delay = animator.getDelay();
	            if (easing) {
	                cfgArr.push(easing);
	            }
	            else {
	                cfgArr.push('linear');
	            }
	            if (delay) {
	                cfgArr.push(delay / 1000 + 's');
	            }
	            if (animator.getLoop()) {
	                cfgArr.push('infinite');
	            }
	            var cfg = cfgArr.join(' ');
	            groupAnimators[cfg] = groupAnimators[cfg] || [cfg, []];
	            groupAnimators[cfg][1].push(animator);
	        }
	        function createSingleCSSAnimation(groupAnimator) {
	            var animators = groupAnimator[1];
	            var len = animators.length;
	            var transformKfs = {};
	            var shapeKfs = {};
	            var finalKfs = {};
	            var animationTimingFunctionAttrName = 'animation-timing-function';
	            function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
	                var tracks = animator.getTracks();
	                var maxTime = animator.getMaxTime();
	                for (var k = 0; k < tracks.length; k++) {
	                    var track = tracks[k];
	                    if (track.needsAnimate()) {
	                        var kfs = track.keyframes;
	                        var attrName = track.propName;
	                        toCssAttrName && (attrName = toCssAttrName(attrName));
	                        if (attrName) {
	                            for (var i = 0; i < kfs.length; i++) {
	                                var kf = kfs[i];
	                                var percent = Math.round(kf.time / maxTime * 100) + '%';
	                                var kfEasing = getEasingFunc(kf.easing);
	                                var rawValue = kf.rawValue;
	                                if (isString(rawValue) || isNumber(rawValue)) {
	                                    cssKfs[percent] = cssKfs[percent] || {};
	                                    cssKfs[percent][attrName] = kf.rawValue;
	                                    if (kfEasing) {
	                                        cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            for (var i = 0; i < len; i++) {
	                var animator = animators[i];
	                var targetProp = animator.targetName;
	                if (!targetProp) {
	                    !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
	                }
	                else if (targetProp === 'shape') {
	                    saveAnimatorTrackToCssKfs(animator, shapeKfs);
	                }
	            }
	            for (var percent in transformKfs) {
	                var transform = {};
	                copyTransform(transform, el);
	                extend(transform, transformKfs[percent]);
	                var str = getSRTTransformString(transform);
	                var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
	                finalKfs[percent] = str ? {
	                    transform: str
	                } : {};
	                setTransformOrigin(finalKfs[percent], transform);
	                if (timingFunction) {
	                    finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
	                }
	            }
	            var path;
	            var canAnimateShape = true;
	            for (var percent in shapeKfs) {
	                finalKfs[percent] = finalKfs[percent] || {};
	                var isFirst = !path;
	                var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
	                if (isFirst) {
	                    path = new PathProxy();
	                }
	                var len_1 = path.len();
	                path.reset();
	                finalKfs[percent].d = buildPathString(el, shapeKfs[percent], path);
	                var newLen = path.len();
	                if (!isFirst && len_1 !== newLen) {
	                    canAnimateShape = false;
	                    break;
	                }
	                if (timingFunction) {
	                    finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
	                }
	            }
	            if (!canAnimateShape) {
	                for (var percent in finalKfs) {
	                    delete finalKfs[percent].d;
	                }
	            }
	            if (!onlyShape) {
	                for (var i = 0; i < len; i++) {
	                    var animator = animators[i];
	                    var targetProp = animator.targetName;
	                    if (targetProp === 'style') {
	                        saveAnimatorTrackToCssKfs(animator, finalKfs, function (propName) { return ANIMATE_STYLE_MAP[propName]; });
	                    }
	                }
	            }
	            var percents = keys(finalKfs);
	            var allTransformOriginSame = true;
	            var transformOrigin;
	            for (var i = 1; i < percents.length; i++) {
	                var p0 = percents[i - 1];
	                var p1 = percents[i];
	                if (finalKfs[p0][transformOriginKey] !== finalKfs[p1][transformOriginKey]) {
	                    allTransformOriginSame = false;
	                    break;
	                }
	                transformOrigin = finalKfs[p0][transformOriginKey];
	            }
	            if (allTransformOriginSame && transformOrigin) {
	                for (var percent in finalKfs) {
	                    if (finalKfs[percent][transformOriginKey]) {
	                        delete finalKfs[percent][transformOriginKey];
	                    }
	                }
	                attrs[transformOriginKey] = transformOrigin;
	            }
	            if (filter(percents, function (percent) { return keys(finalKfs[percent]).length > 0; }).length) {
	                var animationName = addAnimation(finalKfs, scope);
	                return animationName + " " + groupAnimator[0] + " both";
	            }
	        }
	        for (var key in groupAnimators) {
	            var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
	            if (animationCfg) {
	                cssAnimations.push(animationCfg);
	            }
	        }
	        if (cssAnimations.length) {
	            var className = scope.zrId + '-cls-' + scope.cssClassIdx++;
	            scope.cssNodes['.' + className] = {
	                animation: cssAnimations.join(',')
	            };
	            attrs["class"] = className;
	        }
	    }
	
	    var round$2 = Math.round;
	    function isImageLike$1(val) {
	        return val && isString(val.src);
	    }
	    function isCanvasLike(val) {
	        return val && isFunction(val.toDataURL);
	    }
	    function setStyleAttrs(attrs, style, el, scope) {
	        mapStyleToAttrs(function (key, val) {
	            var isFillStroke = key === 'fill' || key === 'stroke';
	            if (isFillStroke && isGradient(val)) {
	                setGradient(style, attrs, key, scope);
	            }
	            else if (isFillStroke && isPattern(val)) {
	                setPattern(el, attrs, key, scope);
	            }
	            else {
	                attrs[key] = val;
	            }
	        }, style, el, false);
	        setShadow(el, attrs, scope);
	    }
	    function noRotateScale(m) {
	        return isAroundZero$1(m[0] - 1)
	            && isAroundZero$1(m[1])
	            && isAroundZero$1(m[2])
	            && isAroundZero$1(m[3] - 1);
	    }
	    function noTranslate(m) {
	        return isAroundZero$1(m[4]) && isAroundZero$1(m[5]);
	    }
	    function setTransform(attrs, m, compress) {
	        if (m && !(noTranslate(m) && noRotateScale(m))) {
	            var mul = compress ? 10 : 1e4;
	            attrs.transform = noRotateScale(m)
	                ? "translate(" + round$2(m[4] * mul) / mul + " " + round$2(m[5] * mul) / mul + ")" : getMatrixStr(m);
	        }
	    }
	    function convertPolyShape(shape, attrs, mul) {
	        var points = shape.points;
	        var strArr = [];
	        for (var i = 0; i < points.length; i++) {
	            strArr.push(round$2(points[i][0] * mul) / mul);
	            strArr.push(round$2(points[i][1] * mul) / mul);
	        }
	        attrs.points = strArr.join(' ');
	    }
	    function validatePolyShape(shape) {
	        return !shape.smooth;
	    }
	    function createAttrsConvert(desc) {
	        var normalizedDesc = map(desc, function (item) {
	            return (typeof item === 'string' ? [item, item] : item);
	        });
	        return function (shape, attrs, mul) {
	            for (var i = 0; i < normalizedDesc.length; i++) {
	                var item = normalizedDesc[i];
	                var val = shape[item[0]];
	                if (val != null) {
	                    attrs[item[1]] = round$2(val * mul) / mul;
	                }
	            }
	        };
	    }
	    var builtinShapesDef = {
	        circle: [createAttrsConvert(['cx', 'cy', 'r'])],
	        polyline: [convertPolyShape, validatePolyShape],
	        polygon: [convertPolyShape, validatePolyShape]
	    };
	    function hasShapeAnimation(el) {
	        var animators = el.animators;
	        for (var i = 0; i < animators.length; i++) {
	            if (animators[i].targetName === 'shape') {
	                return true;
	            }
	        }
	        return false;
	    }
	    function brushSVGPath(el, scope) {
	        var style = el.style;
	        var shape = el.shape;
	        var builtinShpDef = builtinShapesDef[el.type];
	        var attrs = {};
	        var needsAnimate = scope.animation;
	        var svgElType = 'path';
	        var strokePercent = el.style.strokePercent;
	        var precision = (scope.compress && getPathPrecision(el)) || 4;
	        if (builtinShpDef
	            && !scope.willUpdate
	            && !(builtinShpDef[1] && !builtinShpDef[1](shape))
	            && !(needsAnimate && hasShapeAnimation(el))
	            && !(strokePercent < 1)) {
	            svgElType = el.type;
	            var mul = Math.pow(10, precision);
	            builtinShpDef[0](shape, attrs, mul);
	        }
	        else {
	            var needBuildPath = !el.path || el.shapeChanged();
	            if (!el.path) {
	                el.createPathProxy();
	            }
	            var path = el.path;
	            if (needBuildPath) {
	                path.beginPath();
	                el.buildPath(path, el.shape);
	                el.pathUpdated();
	            }
	            var pathVersion = path.getVersion();
	            var elExt = el;
	            var svgPathBuilder = elExt.__svgPathBuilder;
	            if (elExt.__svgPathVersion !== pathVersion
	                || !svgPathBuilder
	                || strokePercent !== elExt.__svgPathStrokePercent) {
	                if (!svgPathBuilder) {
	                    svgPathBuilder = elExt.__svgPathBuilder = new SVGPathRebuilder();
	                }
	                svgPathBuilder.reset(precision);
	                path.rebuildPath(svgPathBuilder, strokePercent);
	                svgPathBuilder.generateStr();
	                elExt.__svgPathVersion = pathVersion;
	                elExt.__svgPathStrokePercent = strokePercent;
	            }
	            attrs.d = svgPathBuilder.getStr();
	        }
	        setTransform(attrs, el.transform);
	        setStyleAttrs(attrs, style, el, scope);
	        scope.animation && createCSSAnimation(el, attrs, scope);
	        return createVNode(svgElType, el.id + '', attrs);
	    }
	    function brushSVGImage(el, scope) {
	        var style = el.style;
	        var image = style.image;
	        if (image && !isString(image)) {
	            if (isImageLike$1(image)) {
	                image = image.src;
	            }
	            else if (isCanvasLike(image)) {
	                image = image.toDataURL();
	            }
	        }
	        if (!image) {
	            return;
	        }
	        var x = style.x || 0;
	        var y = style.y || 0;
	        var dw = style.width;
	        var dh = style.height;
	        var attrs = {
	            href: image,
	            width: dw,
	            height: dh
	        };
	        if (x) {
	            attrs.x = x;
	        }
	        if (y) {
	            attrs.y = y;
	        }
	        setTransform(attrs, el.transform);
	        setStyleAttrs(attrs, style, el, scope);
	        scope.animation && createCSSAnimation(el, attrs, scope);
	        return createVNode('image', el.id + '', attrs);
	    }
	    function brushSVGTSpan(el, scope) {
	        var style = el.style;
	        var text = style.text;
	        text != null && (text += '');
	        if (!text || isNaN(style.x) || isNaN(style.y)) {
	            return;
	        }
	        var font = style.font || DEFAULT_FONT;
	        var x = style.x || 0;
	        var y = adjustTextY(style.y || 0, getLineHeight(font), style.textBaseline);
	        var textAlign = TEXT_ALIGN_TO_ANCHOR[style.textAlign]
	            || style.textAlign;
	        var attrs = {
	            'dominant-baseline': 'central',
	            'text-anchor': textAlign
	        };
	        if (hasSeparateFont(style)) {
	            var separatedFontStr = '';
	            var fontStyle = style.fontStyle;
	            var fontSize = parseFontSize(style.fontSize);
	            if (!parseFloat(fontSize)) {
	                return;
	            }
	            var fontFamily = style.fontFamily || DEFAULT_FONT_FAMILY;
	            var fontWeight = style.fontWeight;
	            separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
	            if (fontStyle && fontStyle !== 'normal') {
	                separatedFontStr += "font-style:" + fontStyle + ";";
	            }
	            if (fontWeight && fontWeight !== 'normal') {
	                separatedFontStr += "font-weight:" + fontWeight + ";";
	            }
	            attrs.style = separatedFontStr;
	        }
	        else {
	            attrs.style = "font: " + font;
	        }
	        if (text.match(/\s/)) {
	            attrs['xml:space'] = 'preserve';
	        }
	        if (x) {
	            attrs.x = x;
	        }
	        if (y) {
	            attrs.y = y;
	        }
	        setTransform(attrs, el.transform);
	        setStyleAttrs(attrs, style, el, scope);
	        scope.animation && createCSSAnimation(el, attrs, scope);
	        return createVNode('text', el.id + '', attrs, undefined, text);
	    }
	    function brush$1(el, scope) {
	        if (el instanceof Path) {
	            return brushSVGPath(el, scope);
	        }
	        else if (el instanceof ZRImage) {
	            return brushSVGImage(el, scope);
	        }
	        else if (el instanceof TSpan) {
	            return brushSVGTSpan(el, scope);
	        }
	    }
	    function setShadow(el, attrs, scope) {
	        var style = el.style;
	        if (hasShadow(style)) {
	            var shadowKey = getShadowKey(el);
	            var shadowCache = scope.shadowCache;
	            var shadowId = shadowCache[shadowKey];
	            if (!shadowId) {
	                var globalScale = el.getGlobalScale();
	                var scaleX = globalScale[0];
	                var scaleY = globalScale[1];
	                if (!scaleX || !scaleY) {
	                    return;
	                }
	                var offsetX = style.shadowOffsetX || 0;
	                var offsetY = style.shadowOffsetY || 0;
	                var blur_1 = style.shadowBlur;
	                var _a = normalizeColor(style.shadowColor), opacity = _a.opacity, color = _a.color;
	                var stdDx = blur_1 / 2 / scaleX;
	                var stdDy = blur_1 / 2 / scaleY;
	                var stdDeviation = stdDx + ' ' + stdDy;
	                shadowId = scope.zrId + '-s' + scope.shadowIdx++;
	                scope.defs[shadowId] = createVNode('filter', shadowId, {
	                    'id': shadowId,
	                    'x': '-100%',
	                    'y': '-100%',
	                    'width': '300%',
	                    'height': '300%'
	                }, [
	                    createVNode('feDropShadow', '', {
	                        'dx': offsetX / scaleX,
	                        'dy': offsetY / scaleY,
	                        'stdDeviation': stdDeviation,
	                        'flood-color': color,
	                        'flood-opacity': opacity
	                    })
	                ]);
	                shadowCache[shadowKey] = shadowId;
	            }
	            attrs.filter = getIdURL(shadowId);
	        }
	    }
	    function setGradient(style, attrs, target, scope) {
	        var val = style[target];
	        var gradientTag;
	        var gradientAttrs = {
	            'gradientUnits': val.global
	                ? 'userSpaceOnUse'
	                : 'objectBoundingBox'
	        };
	        if (isLinearGradient(val)) {
	            gradientTag = 'linearGradient';
	            gradientAttrs.x1 = val.x;
	            gradientAttrs.y1 = val.y;
	            gradientAttrs.x2 = val.x2;
	            gradientAttrs.y2 = val.y2;
	        }
	        else if (isRadialGradient(val)) {
	            gradientTag = 'radialGradient';
	            gradientAttrs.cx = retrieve2(val.x, 0.5);
	            gradientAttrs.cy = retrieve2(val.y, 0.5);
	            gradientAttrs.r = retrieve2(val.r, 0.5);
	        }
	        else {
	            if (true) {
	                logError('Illegal gradient type.');
	            }
	            return;
	        }
	        var colors = val.colorStops;
	        var colorStops = [];
	        for (var i = 0, len = colors.length; i < len; ++i) {
	            var offset = round4(colors[i].offset) * 100 + '%';
	            var stopColor = colors[i].color;
	            var _a = normalizeColor(stopColor), color = _a.color, opacity = _a.opacity;
	            var stopsAttrs = {
	                'offset': offset
	            };
	            stopsAttrs['stop-color'] = color;
	            if (opacity < 1) {
	                stopsAttrs['stop-opacity'] = opacity;
	            }
	            colorStops.push(createVNode('stop', i + '', stopsAttrs));
	        }
	        var gradientVNode = createVNode(gradientTag, '', gradientAttrs, colorStops);
	        var gradientKey = vNodeToString(gradientVNode);
	        var gradientCache = scope.gradientCache;
	        var gradientId = gradientCache[gradientKey];
	        if (!gradientId) {
	            gradientId = scope.zrId + '-g' + scope.gradientIdx++;
	            gradientCache[gradientKey] = gradientId;
	            gradientAttrs.id = gradientId;
	            scope.defs[gradientId] = createVNode(gradientTag, gradientId, gradientAttrs, colorStops);
	        }
	        attrs[target] = getIdURL(gradientId);
	    }
	    function setPattern(el, attrs, target, scope) {
	        var val = el.style[target];
	        var boundingRect = el.getBoundingRect();
	        var patternAttrs = {};
	        var repeat = val.repeat;
	        var noRepeat = repeat === 'no-repeat';
	        var repeatX = repeat === 'repeat-x';
	        var repeatY = repeat === 'repeat-y';
	        var child;
	        if (isImagePattern(val)) {
	            var imageWidth_1 = val.imageWidth;
	            var imageHeight_1 = val.imageHeight;
	            var imageSrc = void 0;
	            var patternImage = val.image;
	            if (isString(patternImage)) {
	                imageSrc = patternImage;
	            }
	            else if (isImageLike$1(patternImage)) {
	                imageSrc = patternImage.src;
	            }
	            else if (isCanvasLike(patternImage)) {
	                imageSrc = patternImage.toDataURL();
	            }
	            if (typeof Image === 'undefined') {
	                var errMsg = 'Image width/height must been given explictly in svg-ssr renderer.';
	                assert(imageWidth_1, errMsg);
	                assert(imageHeight_1, errMsg);
	            }
	            else if (imageWidth_1 == null || imageHeight_1 == null) {
	                var setSizeToVNode_1 = function (vNode, img) {
	                    if (vNode) {
	                        var svgEl = vNode.elm;
	                        var width = imageWidth_1 || img.width;
	                        var height = imageHeight_1 || img.height;
	                        if (vNode.tag === 'pattern') {
	                            if (repeatX) {
	                                height = 1;
	                                width /= boundingRect.width;
	                            }
	                            else if (repeatY) {
	                                width = 1;
	                                height /= boundingRect.height;
	                            }
	                        }
	                        vNode.attrs.width = width;
	                        vNode.attrs.height = height;
	                        if (svgEl) {
	                            svgEl.setAttribute('width', width);
	                            svgEl.setAttribute('height', height);
	                        }
	                    }
	                };
	                var createdImage = createOrUpdateImage(imageSrc, null, el, function (img) {
	                    noRepeat || setSizeToVNode_1(patternVNode, img);
	                    setSizeToVNode_1(child, img);
	                });
	                if (createdImage && createdImage.width && createdImage.height) {
	                    imageWidth_1 = imageWidth_1 || createdImage.width;
	                    imageHeight_1 = imageHeight_1 || createdImage.height;
	                }
	            }
	            child = createVNode('image', 'img', {
	                href: imageSrc,
	                width: imageWidth_1,
	                height: imageHeight_1
	            });
	            patternAttrs.width = imageWidth_1;
	            patternAttrs.height = imageHeight_1;
	        }
	        else if (val.svgElement) {
	            child = clone(val.svgElement);
	            patternAttrs.width = val.svgWidth;
	            patternAttrs.height = val.svgHeight;
	        }
	        if (!child) {
	            return;
	        }
	        var patternWidth;
	        var patternHeight;
	        if (noRepeat) {
	            patternWidth = patternHeight = 1;
	        }
	        else if (repeatX) {
	            patternHeight = 1;
	            patternWidth = patternAttrs.width / boundingRect.width;
	        }
	        else if (repeatY) {
	            patternWidth = 1;
	            patternHeight = patternAttrs.height / boundingRect.height;
	        }
	        else {
	            patternAttrs.patternUnits = 'userSpaceOnUse';
	        }
	        if (patternWidth != null && !isNaN(patternWidth)) {
	            patternAttrs.width = patternWidth;
	        }
	        if (patternHeight != null && !isNaN(patternHeight)) {
	            patternAttrs.height = patternHeight;
	        }
	        var patternTransform = getSRTTransformString(val);
	        patternTransform && (patternAttrs.patternTransform = patternTransform);
	        var patternVNode = createVNode('pattern', '', patternAttrs, [child]);
	        var patternKey = vNodeToString(patternVNode);
	        var patternCache = scope.patternCache;
	        var patternId = patternCache[patternKey];
	        if (!patternId) {
	            patternId = scope.zrId + '-p' + scope.patternIdx++;
	            patternCache[patternKey] = patternId;
	            patternAttrs.id = patternId;
	            patternVNode = scope.defs[patternId] = createVNode('pattern', patternId, patternAttrs, [child]);
	        }
	        attrs[target] = getIdURL(patternId);
	    }
	    function setClipPath(clipPath, attrs, scope) {
	        var clipPathCache = scope.clipPathCache, defs = scope.defs;
	        var clipPathId = clipPathCache[clipPath.id];
	        if (!clipPathId) {
	            clipPathId = scope.zrId + '-c' + scope.clipPathIdx++;
	            var clipPathAttrs = {
	                id: clipPathId
	            };
	            clipPathCache[clipPath.id] = clipPathId;
	            defs[clipPathId] = createVNode('clipPath', clipPathId, clipPathAttrs, [brushSVGPath(clipPath, scope)]);
	        }
	        attrs['clip-path'] = getIdURL(clipPathId);
	    }
	
	    function createTextNode(text) {
	        return document.createTextNode(text);
	    }
	    function insertBefore(parentNode, newNode, referenceNode) {
	        parentNode.insertBefore(newNode, referenceNode);
	    }
	    function removeChild(node, child) {
	        node.removeChild(child);
	    }
	    function appendChild(node, child) {
	        node.appendChild(child);
	    }
	    function parentNode(node) {
	        return node.parentNode;
	    }
	    function nextSibling(node) {
	        return node.nextSibling;
	    }
	    function setTextContent(node, text) {
	        node.textContent = text;
	    }
	
	    var colonChar = 58;
	    var xChar = 120;
	    var emptyNode = createVNode('', '');
	    function isUndef(s) {
	        return s === undefined;
	    }
	    function isDef(s) {
	        return s !== undefined;
	    }
	    function createKeyToOldIdx(children, beginIdx, endIdx) {
	        var map = {};
	        for (var i = beginIdx; i <= endIdx; ++i) {
	            var key = children[i].key;
	            if (key !== undefined) {
	                if (true) {
	                    if (map[key] != null) {
	                        console.error("Duplicate key " + key);
	                    }
	                }
	                map[key] = i;
	            }
	        }
	        return map;
	    }
	    function sameVnode(vnode1, vnode2) {
	        var isSameKey = vnode1.key === vnode2.key;
	        var isSameTag = vnode1.tag === vnode2.tag;
	        return isSameTag && isSameKey;
	    }
	    function createElm(vnode) {
	        var i;
	        var children = vnode.children;
	        var tag = vnode.tag;
	        if (isDef(tag)) {
	            var elm = (vnode.elm = createElement(tag));
	            updateAttrs(emptyNode, vnode);
	            if (isArray(children)) {
	                for (i = 0; i < children.length; ++i) {
	                    var ch = children[i];
	                    if (ch != null) {
	                        appendChild(elm, createElm(ch));
	                    }
	                }
	            }
	            else if (isDef(vnode.text) && !isObject(vnode.text)) {
	                appendChild(elm, createTextNode(vnode.text));
	            }
	        }
	        else {
	            vnode.elm = createTextNode(vnode.text);
	        }
	        return vnode.elm;
	    }
	    function addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
	        for (; startIdx <= endIdx; ++startIdx) {
	            var ch = vnodes[startIdx];
	            if (ch != null) {
	                insertBefore(parentElm, createElm(ch), before);
	            }
	        }
	    }
	    function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
	        for (; startIdx <= endIdx; ++startIdx) {
	            var ch = vnodes[startIdx];
	            if (ch != null) {
	                if (isDef(ch.tag)) {
	                    var parent_1 = parentNode(ch.elm);
	                    removeChild(parent_1, ch.elm);
	                }
	                else {
	                    removeChild(parentElm, ch.elm);
	                }
	            }
	        }
	    }
	    function updateAttrs(oldVnode, vnode) {
	        var key;
	        var elm = vnode.elm;
	        var oldAttrs = oldVnode && oldVnode.attrs || {};
	        var attrs = vnode.attrs || {};
	        if (oldAttrs === attrs) {
	            return;
	        }
	        for (key in attrs) {
	            var cur = attrs[key];
	            var old = oldAttrs[key];
	            if (old !== cur) {
	                if (cur === true) {
	                    elm.setAttribute(key, '');
	                }
	                else if (cur === false) {
	                    elm.removeAttribute(key);
	                }
	                else {
	                    if (key.charCodeAt(0) !== xChar) {
	                        elm.setAttribute(key, cur);
	                    }
	                    else if (key === 'xmlns:xlink' || key === 'xmlns') {
	                        elm.setAttributeNS(XMLNS, key, cur);
	                    }
	                    else if (key.charCodeAt(3) === colonChar) {
	                        elm.setAttributeNS(XML_NAMESPACE, key, cur);
	                    }
	                    else if (key.charCodeAt(5) === colonChar) {
	                        elm.setAttributeNS(XLINKNS, key, cur);
	                    }
	                    else {
	                        elm.setAttribute(key, cur);
	                    }
	                }
	            }
	        }
	        for (key in oldAttrs) {
	            if (!(key in attrs)) {
	                elm.removeAttribute(key);
	            }
	        }
	    }
	    function updateChildren(parentElm, oldCh, newCh) {
	        var oldStartIdx = 0;
	        var newStartIdx = 0;
	        var oldEndIdx = oldCh.length - 1;
	        var oldStartVnode = oldCh[0];
	        var oldEndVnode = oldCh[oldEndIdx];
	        var newEndIdx = newCh.length - 1;
	        var newStartVnode = newCh[0];
	        var newEndVnode = newCh[newEndIdx];
	        var oldKeyToIdx;
	        var idxInOld;
	        var elmToMove;
	        var before;
	        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	            if (oldStartVnode == null) {
	                oldStartVnode = oldCh[++oldStartIdx];
	            }
	            else if (oldEndVnode == null) {
	                oldEndVnode = oldCh[--oldEndIdx];
	            }
	            else if (newStartVnode == null) {
	                newStartVnode = newCh[++newStartIdx];
	            }
	            else if (newEndVnode == null) {
	                newEndVnode = newCh[--newEndIdx];
	            }
	            else if (sameVnode(oldStartVnode, newStartVnode)) {
	                patchVnode(oldStartVnode, newStartVnode);
	                oldStartVnode = oldCh[++oldStartIdx];
	                newStartVnode = newCh[++newStartIdx];
	            }
	            else if (sameVnode(oldEndVnode, newEndVnode)) {
	                patchVnode(oldEndVnode, newEndVnode);
	                oldEndVnode = oldCh[--oldEndIdx];
	                newEndVnode = newCh[--newEndIdx];
	            }
	            else if (sameVnode(oldStartVnode, newEndVnode)) {
	                patchVnode(oldStartVnode, newEndVnode);
	                insertBefore(parentElm, oldStartVnode.elm, nextSibling(oldEndVnode.elm));
	                oldStartVnode = oldCh[++oldStartIdx];
	                newEndVnode = newCh[--newEndIdx];
	            }
	            else if (sameVnode(oldEndVnode, newStartVnode)) {
	                patchVnode(oldEndVnode, newStartVnode);
	                insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	                oldEndVnode = oldCh[--oldEndIdx];
	                newStartVnode = newCh[++newStartIdx];
	            }
	            else {
	                if (isUndef(oldKeyToIdx)) {
	                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
	                }
	                idxInOld = oldKeyToIdx[newStartVnode.key];
	                if (isUndef(idxInOld)) {
	                    insertBefore(parentElm, createElm(newStartVnode), oldStartVnode.elm);
	                }
	                else {
	                    elmToMove = oldCh[idxInOld];
	                    if (elmToMove.tag !== newStartVnode.tag) {
	                        insertBefore(parentElm, createElm(newStartVnode), oldStartVnode.elm);
	                    }
	                    else {
	                        patchVnode(elmToMove, newStartVnode);
	                        oldCh[idxInOld] = undefined;
	                        insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
	                    }
	                }
	                newStartVnode = newCh[++newStartIdx];
	            }
	        }
	        if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
	            if (oldStartIdx > oldEndIdx) {
	                before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
	                addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
	            }
	            else {
	                removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	            }
	        }
	    }
	    function patchVnode(oldVnode, vnode) {
	        var elm = (vnode.elm = oldVnode.elm);
	        var oldCh = oldVnode.children;
	        var ch = vnode.children;
	        if (oldVnode === vnode) {
	            return;
	        }
	        updateAttrs(oldVnode, vnode);
	        if (isUndef(vnode.text)) {
	            if (isDef(oldCh) && isDef(ch)) {
	                if (oldCh !== ch) {
	                    updateChildren(elm, oldCh, ch);
	                }
	            }
	            else if (isDef(ch)) {
	                if (isDef(oldVnode.text)) {
	                    setTextContent(elm, '');
	                }
	                addVnodes(elm, null, ch, 0, ch.length - 1);
	            }
	            else if (isDef(oldCh)) {
	                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	            }
	            else if (isDef(oldVnode.text)) {
	                setTextContent(elm, '');
	            }
	        }
	        else if (oldVnode.text !== vnode.text) {
	            if (isDef(oldCh)) {
	                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	            }
	            setTextContent(elm, vnode.text);
	        }
	    }
	    function patch(oldVnode, vnode) {
	        if (sameVnode(oldVnode, vnode)) {
	            patchVnode(oldVnode, vnode);
	        }
	        else {
	            var elm = oldVnode.elm;
	            var parent_2 = parentNode(elm);
	            createElm(vnode);
	            if (parent_2 !== null) {
	                insertBefore(parent_2, vnode.elm, nextSibling(elm));
	                removeVnodes(parent_2, [oldVnode], 0, 0);
	            }
	        }
	        return vnode;
	    }
	
	    var svgId = 0;
	    var SVGPainter = (function () {
	        function SVGPainter(root, storage, opts) {
	            this.type = 'svg';
	            this.refreshHover = createMethodNotSupport('refreshHover');
	            this.configLayer = createMethodNotSupport('configLayer');
	            this.storage = storage;
	            this._opts = opts = extend({}, opts);
	            this.root = root;
	            this._id = 'zr' + svgId++;
	            this._oldVNode = createSVGVNode(opts.width, opts.height);
	            if (root && !opts.ssr) {
	                var viewport = this._viewport = document.createElement('div');
	                viewport.style.cssText = 'position:relative;overflow:hidden';
	                var svgDom = this._svgDom = this._oldVNode.elm = createElement('svg');
	                updateAttrs(null, this._oldVNode);
	                viewport.appendChild(svgDom);
	                root.appendChild(viewport);
	            }
	            this.resize(opts.width, opts.height);
	        }
	        SVGPainter.prototype.getType = function () {
	            return this.type;
	        };
	        SVGPainter.prototype.getViewportRoot = function () {
	            return this._viewport;
	        };
	        SVGPainter.prototype.getViewportRootOffset = function () {
	            var viewportRoot = this.getViewportRoot();
	            if (viewportRoot) {
	                return {
	                    offsetLeft: viewportRoot.offsetLeft || 0,
	                    offsetTop: viewportRoot.offsetTop || 0
	                };
	            }
	        };
	        SVGPainter.prototype.getSvgDom = function () {
	            return this._svgDom;
	        };
	        SVGPainter.prototype.refresh = function () {
	            if (this.root) {
	                var vnode = this.renderToVNode({
	                    willUpdate: true
	                });
	                vnode.attrs.style = 'position:absolute;left:0;top:0;user-select:none';
	                patch(this._oldVNode, vnode);
	                this._oldVNode = vnode;
	            }
	        };
	        SVGPainter.prototype.renderOneToVNode = function (el) {
	            return brush$1(el, createBrushScope(this._id));
	        };
	        SVGPainter.prototype.renderToVNode = function (opts) {
	            opts = opts || {};
	            var list = this.storage.getDisplayList(true);
	            var width = this._width;
	            var height = this._height;
	            var scope = createBrushScope(this._id);
	            scope.animation = opts.animation;
	            scope.willUpdate = opts.willUpdate;
	            scope.compress = opts.compress;
	            var children = [];
	            var bgVNode = this._bgVNode = createBackgroundVNode(width, height, this._backgroundColor, scope);
	            bgVNode && children.push(bgVNode);
	            var mainVNode = !opts.compress
	                ? (this._mainVNode = createVNode('g', 'main', {}, [])) : null;
	            this._paintList(list, scope, mainVNode ? mainVNode.children : children);
	            mainVNode && children.push(mainVNode);
	            var defs = map(keys(scope.defs), function (id) { return scope.defs[id]; });
	            if (defs.length) {
	                children.push(createVNode('defs', 'defs', {}, defs));
	            }
	            if (opts.animation) {
	                var animationCssStr = getCssString(scope.cssNodes, scope.cssAnims, { newline: true });
	                if (animationCssStr) {
	                    var styleNode = createVNode('style', 'stl', {}, [], animationCssStr);
	                    children.push(styleNode);
	                }
	            }
	            return createSVGVNode(width, height, children, opts.useViewBox);
	        };
	        SVGPainter.prototype.renderToString = function (opts) {
	            opts = opts || {};
	            return vNodeToString(this.renderToVNode({
	                animation: retrieve2(opts.cssAnimation, true),
	                willUpdate: false,
	                compress: true,
	                useViewBox: retrieve2(opts.useViewBox, true)
	            }), { newline: true });
	        };
	        SVGPainter.prototype.setBackgroundColor = function (backgroundColor) {
	            this._backgroundColor = backgroundColor;
	        };
	        SVGPainter.prototype.getSvgRoot = function () {
	            return this._mainVNode && this._mainVNode.elm;
	        };
	        SVGPainter.prototype._paintList = function (list, scope, out) {
	            var listLen = list.length;
	            var clipPathsGroupsStack = [];
	            var clipPathsGroupsStackDepth = 0;
	            var currentClipPathGroup;
	            var prevClipPaths;
	            var clipGroupNodeIdx = 0;
	            for (var i = 0; i < listLen; i++) {
	                var displayable = list[i];
	                if (!displayable.invisible) {
	                    var clipPaths = displayable.__clipPaths;
	                    var len = clipPaths && clipPaths.length || 0;
	                    var prevLen = prevClipPaths && prevClipPaths.length || 0;
	                    var lca = void 0;
	                    for (lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--) {
	                        if (clipPaths && prevClipPaths
	                            && clipPaths[lca] === prevClipPaths[lca]) {
	                            break;
	                        }
	                    }
	                    for (var i_1 = prevLen - 1; i_1 > lca; i_1--) {
	                        clipPathsGroupsStackDepth--;
	                        currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
	                    }
	                    for (var i_2 = lca + 1; i_2 < len; i_2++) {
	                        var groupAttrs = {};
	                        setClipPath(clipPaths[i_2], groupAttrs, scope);
	                        var g = createVNode('g', 'clip-g-' + clipGroupNodeIdx++, groupAttrs, []);
	                        (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
	                        clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
	                        currentClipPathGroup = g;
	                    }
	                    prevClipPaths = clipPaths;
	                    var ret = brush$1(displayable, scope);
	                    if (ret) {
	                        (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
	                    }
	                }
	            }
	        };
	        SVGPainter.prototype.resize = function (width, height) {
	            var opts = this._opts;
	            var root = this.root;
	            var viewport = this._viewport;
	            width != null && (opts.width = width);
	            height != null && (opts.height = height);
	            if (root && viewport) {
	                viewport.style.display = 'none';
	                width = getSize(root, 0, opts);
	                height = getSize(root, 1, opts);
	                viewport.style.display = '';
	            }
	            if (this._width !== width || this._height !== height) {
	                this._width = width;
	                this._height = height;
	                if (viewport) {
	                    var viewportStyle = viewport.style;
	                    viewportStyle.width = width + 'px';
	                    viewportStyle.height = height + 'px';
	                }
	                if (!isPattern(this._backgroundColor)) {
	                    var svgDom = this._svgDom;
	                    if (svgDom) {
	                        svgDom.setAttribute('width', width);
	                        svgDom.setAttribute('height', height);
	                    }
	                    var bgEl = this._bgVNode && this._bgVNode.elm;
	                    if (bgEl) {
	                        bgEl.setAttribute('width', width);
	                        bgEl.setAttribute('height', height);
	                    }
	                }
	                else {
	                    this.refresh();
	                }
	            }
	        };
	        SVGPainter.prototype.getWidth = function () {
	            return this._width;
	        };
	        SVGPainter.prototype.getHeight = function () {
	            return this._height;
	        };
	        SVGPainter.prototype.dispose = function () {
	            if (this.root) {
	                this.root.innerHTML = '';
	            }
	            this._svgDom =
	                this._viewport =
	                    this.storage =
	                        this._oldVNode =
	                            this._bgVNode =
	                                this._mainVNode = null;
	        };
	        SVGPainter.prototype.clear = function () {
	            if (this._svgDom) {
	                this._svgDom.innerHTML = null;
	            }
	            this._oldVNode = null;
	        };
	        SVGPainter.prototype.toDataURL = function (base64) {
	            var str = this.renderToString();
	            var prefix = 'data:image/svg+xml;';
	            if (base64) {
	                str = encodeBase64(str);
	                return str && prefix + 'base64,' + str;
	            }
	            return prefix + 'charset=UTF-8,' + encodeURIComponent(str);
	        };
	        return SVGPainter;
	    }());
	    function createMethodNotSupport(method) {
	        return function () {
	            if (true) {
	                logError('In SVG mode painter not support method "' + method + '"');
	            }
	        };
	    }
	    function createBackgroundVNode(width, height, backgroundColor, scope) {
	        var bgVNode;
	        if (backgroundColor && backgroundColor !== 'none') {
	            bgVNode = createVNode('rect', 'bg', {
	                width: width,
	                height: height,
	                x: '0',
	                y: '0',
	                id: '0'
	            });
	            if (isGradient(backgroundColor)) {
	                setGradient({ fill: backgroundColor }, bgVNode.attrs, 'fill', scope);
	            }
	            else if (isPattern(backgroundColor)) {
	                setPattern({
	                    style: {
	                        fill: backgroundColor
	                    },
	                    dirty: noop,
	                    getBoundingRect: function () { return ({ width: width, height: height }); }
	                }, bgVNode.attrs, 'fill', scope);
	            }
	            else {
	                var _a = normalizeColor(backgroundColor), color = _a.color, opacity = _a.opacity;
	                bgVNode.attrs.fill = color;
	                opacity < 1 && (bgVNode.attrs['fill-opacity'] = opacity);
	            }
	        }
	        return bgVNode;
	    }
	
	    function install(registers) {
	      registers.registerPainter('svg', SVGPainter);
	    }
	
	    function createDom(id, painter, dpr) {
	        var newDom = platformApi.createCanvas();
	        var width = painter.getWidth();
	        var height = painter.getHeight();
	        var newDomStyle = newDom.style;
	        if (newDomStyle) {
	            newDomStyle.position = 'absolute';
	            newDomStyle.left = '0';
	            newDomStyle.top = '0';
	            newDomStyle.width = width + 'px';
	            newDomStyle.height = height + 'px';
	            newDom.setAttribute('data-zr-dom-id', id);
	        }
	        newDom.width = width * dpr;
	        newDom.height = height * dpr;
	        return newDom;
	    }
	    var Layer = (function (_super) {
	        __extends(Layer, _super);
	        function Layer(id, painter, dpr) {
	            var _this = _super.call(this) || this;
	            _this.motionBlur = false;
	            _this.lastFrameAlpha = 0.7;
	            _this.dpr = 1;
	            _this.virtual = false;
	            _this.config = {};
	            _this.incremental = false;
	            _this.zlevel = 0;
	            _this.maxRepaintRectCount = 5;
	            _this.__dirty = true;
	            _this.__firstTimePaint = true;
	            _this.__used = false;
	            _this.__drawIndex = 0;
	            _this.__startIndex = 0;
	            _this.__endIndex = 0;
	            _this.__prevStartIndex = null;
	            _this.__prevEndIndex = null;
	            var dom;
	            dpr = dpr || devicePixelRatio;
	            if (typeof id === 'string') {
	                dom = createDom(id, painter, dpr);
	            }
	            else if (isObject(id)) {
	                dom = id;
	                id = dom.id;
	            }
	            _this.id = id;
	            _this.dom = dom;
	            var domStyle = dom.style;
	            if (domStyle) {
	                disableUserSelect(dom);
	                dom.onselectstart = function () { return false; };
	                domStyle.padding = '0';
	                domStyle.margin = '0';
	                domStyle.borderWidth = '0';
	            }
	            _this.painter = painter;
	            _this.dpr = dpr;
	            return _this;
	        }
	        Layer.prototype.getElementCount = function () {
	            return this.__endIndex - this.__startIndex;
	        };
	        Layer.prototype.afterBrush = function () {
	            this.__prevStartIndex = this.__startIndex;
	            this.__prevEndIndex = this.__endIndex;
	        };
	        Layer.prototype.initContext = function () {
	            this.ctx = this.dom.getContext('2d');
	            this.ctx.dpr = this.dpr;
	        };
	        Layer.prototype.setUnpainted = function () {
	            this.__firstTimePaint = true;
	        };
	        Layer.prototype.createBackBuffer = function () {
	            var dpr = this.dpr;
	            this.domBack = createDom('back-' + this.id, this.painter, dpr);
	            this.ctxBack = this.domBack.getContext('2d');
	            if (dpr !== 1) {
	                this.ctxBack.scale(dpr, dpr);
	            }
	        };
	        Layer.prototype.createRepaintRects = function (displayList, prevList, viewWidth, viewHeight) {
	            if (this.__firstTimePaint) {
	                this.__firstTimePaint = false;
	                return null;
	            }
	            var mergedRepaintRects = [];
	            var maxRepaintRectCount = this.maxRepaintRectCount;
	            var full = false;
	            var pendingRect = new BoundingRect(0, 0, 0, 0);
	            function addRectToMergePool(rect) {
	                if (!rect.isFinite() || rect.isZero()) {
	                    return;
	                }
	                if (mergedRepaintRects.length === 0) {
	                    var boundingRect = new BoundingRect(0, 0, 0, 0);
	                    boundingRect.copy(rect);
	                    mergedRepaintRects.push(boundingRect);
	                }
	                else {
	                    var isMerged = false;
	                    var minDeltaArea = Infinity;
	                    var bestRectToMergeIdx = 0;
	                    for (var i = 0; i < mergedRepaintRects.length; ++i) {
	                        var mergedRect = mergedRepaintRects[i];
	                        if (mergedRect.intersect(rect)) {
	                            var pendingRect_1 = new BoundingRect(0, 0, 0, 0);
	                            pendingRect_1.copy(mergedRect);
	                            pendingRect_1.union(rect);
	                            mergedRepaintRects[i] = pendingRect_1;
	                            isMerged = true;
	                            break;
	                        }
	                        else if (full) {
	                            pendingRect.copy(rect);
	                            pendingRect.union(mergedRect);
	                            var aArea = rect.width * rect.height;
	                            var bArea = mergedRect.width * mergedRect.height;
	                            var pendingArea = pendingRect.width * pendingRect.height;
	                            var deltaArea = pendingArea - aArea - bArea;
	                            if (deltaArea < minDeltaArea) {
	                                minDeltaArea = deltaArea;
	                                bestRectToMergeIdx = i;
	                            }
	                        }
	                    }
	                    if (full) {
	                        mergedRepaintRects[bestRectToMergeIdx].union(rect);
	                        isMerged = true;
	                    }
	                    if (!isMerged) {
	                        var boundingRect = new BoundingRect(0, 0, 0, 0);
	                        boundingRect.copy(rect);
	                        mergedRepaintRects.push(boundingRect);
	                    }
	                    if (!full) {
	                        full = mergedRepaintRects.length >= maxRepaintRectCount;
	                    }
	                }
	            }
	            for (var i = this.__startIndex; i < this.__endIndex; ++i) {
	                var el = displayList[i];
	                if (el) {
	                    var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
	                    var prevRect = el.__isRendered && ((el.__dirty & REDRAW_BIT) || !shouldPaint)
	                        ? el.getPrevPaintRect()
	                        : null;
	                    if (prevRect) {
	                        addRectToMergePool(prevRect);
	                    }
	                    var curRect = shouldPaint && ((el.__dirty & REDRAW_BIT) || !el.__isRendered)
	                        ? el.getPaintRect()
	                        : null;
	                    if (curRect) {
	                        addRectToMergePool(curRect);
	                    }
	                }
	            }
	            for (var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i) {
	                var el = prevList[i];
	                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
	                if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
	                    var prevRect = el.getPrevPaintRect();
	                    if (prevRect) {
	                        addRectToMergePool(prevRect);
	                    }
	                }
	            }
	            var hasIntersections;
	            do {
	                hasIntersections = false;
	                for (var i = 0; i < mergedRepaintRects.length;) {
	                    if (mergedRepaintRects[i].isZero()) {
	                        mergedRepaintRects.splice(i, 1);
	                        continue;
	                    }
	                    for (var j = i + 1; j < mergedRepaintRects.length;) {
	                        if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
	                            hasIntersections = true;
	                            mergedRepaintRects[i].union(mergedRepaintRects[j]);
	                            mergedRepaintRects.splice(j, 1);
	                        }
	                        else {
	                            j++;
	                        }
	                    }
	                    i++;
	                }
	            } while (hasIntersections);
	            this._paintRects = mergedRepaintRects;
	            return mergedRepaintRects;
	        };
	        Layer.prototype.debugGetPaintRects = function () {
	            return (this._paintRects || []).slice();
	        };
	        Layer.prototype.resize = function (width, height) {
	            var dpr = this.dpr;
	            var dom = this.dom;
	            var domStyle = dom.style;
	            var domBack = this.domBack;
	            if (domStyle) {
	                domStyle.width = width + 'px';
	                domStyle.height = height + 'px';
	            }
	            dom.width = width * dpr;
	            dom.height = height * dpr;
	            if (domBack) {
	                domBack.width = width * dpr;
	                domBack.height = height * dpr;
	                if (dpr !== 1) {
	                    this.ctxBack.scale(dpr, dpr);
	                }
	            }
	        };
	        Layer.prototype.clear = function (clearAll, clearColor, repaintRects) {
	            var dom = this.dom;
	            var ctx = this.ctx;
	            var width = dom.width;
	            var height = dom.height;
	            clearColor = clearColor || this.clearColor;
	            var haveMotionBLur = this.motionBlur && !clearAll;
	            var lastFrameAlpha = this.lastFrameAlpha;
	            var dpr = this.dpr;
	            var self = this;
	            if (haveMotionBLur) {
	                if (!this.domBack) {
	                    this.createBackBuffer();
	                }
	                this.ctxBack.globalCompositeOperation = 'copy';
	                this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
	            }
	            var domBack = this.domBack;
	            function doClear(x, y, width, height) {
	                ctx.clearRect(x, y, width, height);
	                if (clearColor && clearColor !== 'transparent') {
	                    var clearColorGradientOrPattern = void 0;
	                    if (isGradientObject(clearColor)) {
	                        var shouldCache = clearColor.global || (clearColor.__width === width
	                            && clearColor.__height === height);
	                        clearColorGradientOrPattern = shouldCache
	                            && clearColor.__canvasGradient
	                            || getCanvasGradient(ctx, clearColor, {
	                                x: 0,
	                                y: 0,
	                                width: width,
	                                height: height
	                            });
	                        clearColor.__canvasGradient = clearColorGradientOrPattern;
	                        clearColor.__width = width;
	                        clearColor.__height = height;
	                    }
	                    else if (isImagePatternObject(clearColor)) {
	                        clearColor.scaleX = clearColor.scaleX || dpr;
	                        clearColor.scaleY = clearColor.scaleY || dpr;
	                        clearColorGradientOrPattern = createCanvasPattern(ctx, clearColor, {
	                            dirty: function () {
	                                self.setUnpainted();
	                                self.__painter.refresh();
	                            }
	                        });
	                    }
	                    ctx.save();
	                    ctx.fillStyle = clearColorGradientOrPattern || clearColor;
	                    ctx.fillRect(x, y, width, height);
	                    ctx.restore();
	                }
	                if (haveMotionBLur) {
	                    ctx.save();
	                    ctx.globalAlpha = lastFrameAlpha;
	                    ctx.drawImage(domBack, x, y, width, height);
	                    ctx.restore();
	                }
	            }
	            if (!repaintRects || haveMotionBLur) {
	                doClear(0, 0, width, height);
	            }
	            else if (repaintRects.length) {
	                each(repaintRects, function (rect) {
	                    doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
	                });
	            }
	        };
	        return Layer;
	    }(Eventful));
	
	    var HOVER_LAYER_ZLEVEL = 1e5;
	    var CANVAS_ZLEVEL = 314159;
	    var EL_AFTER_INCREMENTAL_INC = 0.01;
	    var INCREMENTAL_INC = 0.001;
	    function isLayerValid(layer) {
	        if (!layer) {
	            return false;
	        }
	        if (layer.__builtin__) {
	            return true;
	        }
	        if (typeof (layer.resize) !== 'function'
	            || typeof (layer.refresh) !== 'function') {
	            return false;
	        }
	        return true;
	    }
	    function createRoot(width, height) {
	        var domRoot = document.createElement('div');
	        domRoot.style.cssText = [
	            'position:relative',
	            'width:' + width + 'px',
	            'height:' + height + 'px',
	            'padding:0',
	            'margin:0',
	            'border-width:0'
	        ].join(';') + ';';
	        return domRoot;
	    }
	    var CanvasPainter = (function () {
	        function CanvasPainter(root, storage, opts, id) {
	            this.type = 'canvas';
	            this._zlevelList = [];
	            this._prevDisplayList = [];
	            this._layers = {};
	            this._layerConfig = {};
	            this._needsManuallyCompositing = false;
	            this.type = 'canvas';
	            var singleCanvas = !root.nodeName
	                || root.nodeName.toUpperCase() === 'CANVAS';
	            this._opts = opts = extend({}, opts || {});
	            this.dpr = opts.devicePixelRatio || devicePixelRatio;
	            this._singleCanvas = singleCanvas;
	            this.root = root;
	            var rootStyle = root.style;
	            if (rootStyle) {
	                disableUserSelect(root);
	                root.innerHTML = '';
	            }
	            this.storage = storage;
	            var zlevelList = this._zlevelList;
	            this._prevDisplayList = [];
	            var layers = this._layers;
	            if (!singleCanvas) {
	                this._width = getSize(root, 0, opts);
	                this._height = getSize(root, 1, opts);
	                var domRoot = this._domRoot = createRoot(this._width, this._height);
	                root.appendChild(domRoot);
	            }
	            else {
	                var rootCanvas = root;
	                var width = rootCanvas.width;
	                var height = rootCanvas.height;
	                if (opts.width != null) {
	                    width = opts.width;
	                }
	                if (opts.height != null) {
	                    height = opts.height;
	                }
	                this.dpr = opts.devicePixelRatio || 1;
	                rootCanvas.width = width * this.dpr;
	                rootCanvas.height = height * this.dpr;
	                this._width = width;
	                this._height = height;
	                var mainLayer = new Layer(rootCanvas, this, this.dpr);
	                mainLayer.__builtin__ = true;
	                mainLayer.initContext();
	                layers[CANVAS_ZLEVEL] = mainLayer;
	                mainLayer.zlevel = CANVAS_ZLEVEL;
	                zlevelList.push(CANVAS_ZLEVEL);
	                this._domRoot = root;
	            }
	        }
	        CanvasPainter.prototype.getType = function () {
	            return 'canvas';
	        };
	        CanvasPainter.prototype.isSingleCanvas = function () {
	            return this._singleCanvas;
	        };
	        CanvasPainter.prototype.getViewportRoot = function () {
	            return this._domRoot;
	        };
	        CanvasPainter.prototype.getViewportRootOffset = function () {
	            var viewportRoot = this.getViewportRoot();
	            if (viewportRoot) {
	                return {
	                    offsetLeft: viewportRoot.offsetLeft || 0,
	                    offsetTop: viewportRoot.offsetTop || 0
	                };
	            }
	        };
	        CanvasPainter.prototype.refresh = function (paintAll) {
	            var list = this.storage.getDisplayList(true);
	            var prevList = this._prevDisplayList;
	            var zlevelList = this._zlevelList;
	            this._redrawId = Math.random();
	            this._paintList(list, prevList, paintAll, this._redrawId);
	            for (var i = 0; i < zlevelList.length; i++) {
	                var z = zlevelList[i];
	                var layer = this._layers[z];
	                if (!layer.__builtin__ && layer.refresh) {
	                    var clearColor = i === 0 ? this._backgroundColor : null;
	                    layer.refresh(clearColor);
	                }
	            }
	            if (this._opts.useDirtyRect) {
	                this._prevDisplayList = list.slice();
	            }
	            return this;
	        };
	        CanvasPainter.prototype.refreshHover = function () {
	            this._paintHoverList(this.storage.getDisplayList(false));
	        };
	        CanvasPainter.prototype._paintHoverList = function (list) {
	            var len = list.length;
	            var hoverLayer = this._hoverlayer;
	            hoverLayer && hoverLayer.clear();
	            if (!len) {
	                return;
	            }
	            var scope = {
	                inHover: true,
	                viewWidth: this._width,
	                viewHeight: this._height
	            };
	            var ctx;
	            for (var i = 0; i < len; i++) {
	                var el = list[i];
	                if (el.__inHover) {
	                    if (!hoverLayer) {
	                        hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
	                    }
	                    if (!ctx) {
	                        ctx = hoverLayer.ctx;
	                        ctx.save();
	                    }
	                    brush(ctx, el, scope, i === len - 1);
	                }
	            }
	            if (ctx) {
	                ctx.restore();
	            }
	        };
	        CanvasPainter.prototype.getHoverLayer = function () {
	            return this.getLayer(HOVER_LAYER_ZLEVEL);
	        };
	        CanvasPainter.prototype.paintOne = function (ctx, el) {
	            brushSingle(ctx, el);
	        };
	        CanvasPainter.prototype._paintList = function (list, prevList, paintAll, redrawId) {
	            if (this._redrawId !== redrawId) {
	                return;
	            }
	            paintAll = paintAll || false;
	            this._updateLayerStatus(list);
	            var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
	            if (this._needsManuallyCompositing) {
	                this._compositeManually();
	            }
	            if (needsRefreshHover) {
	                this._paintHoverList(list);
	            }
	            if (!finished) {
	                var self_1 = this;
	                requestAnimationFrame$1(function () {
	                    self_1._paintList(list, prevList, paintAll, redrawId);
	                });
	            }
	            else {
	                this.eachLayer(function (layer) {
	                    layer.afterBrush && layer.afterBrush();
	                });
	            }
	        };
	        CanvasPainter.prototype._compositeManually = function () {
	            var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
	            var width = this._domRoot.width;
	            var height = this._domRoot.height;
	            ctx.clearRect(0, 0, width, height);
	            this.eachBuiltinLayer(function (layer) {
	                if (layer.virtual) {
	                    ctx.drawImage(layer.dom, 0, 0, width, height);
	                }
	            });
	        };
	        CanvasPainter.prototype._doPaintList = function (list, prevList, paintAll) {
	            var _this = this;
	            var layerList = [];
	            var useDirtyRect = this._opts.useDirtyRect;
	            for (var zi = 0; zi < this._zlevelList.length; zi++) {
	                var zlevel = this._zlevelList[zi];
	                var layer = this._layers[zlevel];
	                if (layer.__builtin__
	                    && layer !== this._hoverlayer
	                    && (layer.__dirty || paintAll)) {
	                    layerList.push(layer);
	                }
	            }
	            var finished = true;
	            var needsRefreshHover = false;
	            var _loop_1 = function (k) {
	                var layer = layerList[k];
	                var ctx = layer.ctx;
	                var repaintRects = useDirtyRect
	                    && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
	                var start = paintAll ? layer.__startIndex : layer.__drawIndex;
	                var useTimer = !paintAll && layer.incremental && Date.now;
	                var startTime = useTimer && Date.now();
	                var clearColor = layer.zlevel === this_1._zlevelList[0]
	                    ? this_1._backgroundColor : null;
	                if (layer.__startIndex === layer.__endIndex) {
	                    layer.clear(false, clearColor, repaintRects);
	                }
	                else if (start === layer.__startIndex) {
	                    var firstEl = list[start];
	                    if (!firstEl.incremental || !firstEl.notClear || paintAll) {
	                        layer.clear(false, clearColor, repaintRects);
	                    }
	                }
	                if (start === -1) {
	                    console.error('For some unknown reason. drawIndex is -1');
	                    start = layer.__startIndex;
	                }
	                var i;
	                var repaint = function (repaintRect) {
	                    var scope = {
	                        inHover: false,
	                        allClipped: false,
	                        prevEl: null,
	                        viewWidth: _this._width,
	                        viewHeight: _this._height
	                    };
	                    for (i = start; i < layer.__endIndex; i++) {
	                        var el = list[i];
	                        if (el.__inHover) {
	                            needsRefreshHover = true;
	                        }
	                        _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
	                        if (useTimer) {
	                            var dTime = Date.now() - startTime;
	                            if (dTime > 15) {
	                                break;
	                            }
	                        }
	                    }
	                    if (scope.prevElClipPaths) {
	                        ctx.restore();
	                    }
	                };
	                if (repaintRects) {
	                    if (repaintRects.length === 0) {
	                        i = layer.__endIndex;
	                    }
	                    else {
	                        var dpr = this_1.dpr;
	                        for (var r = 0; r < repaintRects.length; ++r) {
	                            var rect = repaintRects[r];
	                            ctx.save();
	                            ctx.beginPath();
	                            ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
	                            ctx.clip();
	                            repaint(rect);
	                            ctx.restore();
	                        }
	                    }
	                }
	                else {
	                    ctx.save();
	                    repaint();
	                    ctx.restore();
	                }
	                layer.__drawIndex = i;
	                if (layer.__drawIndex < layer.__endIndex) {
	                    finished = false;
	                }
	            };
	            var this_1 = this;
	            for (var k = 0; k < layerList.length; k++) {
	                _loop_1(k);
	            }
	            if (env.wxa) {
	                each(this._layers, function (layer) {
	                    if (layer && layer.ctx && layer.ctx.draw) {
	                        layer.ctx.draw();
	                    }
	                });
	            }
	            return {
	                finished: finished,
	                needsRefreshHover: needsRefreshHover
	            };
	        };
	        CanvasPainter.prototype._doPaintEl = function (el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
	            var ctx = currentLayer.ctx;
	            if (useDirtyRect) {
	                var paintRect = el.getPaintRect();
	                if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
	                    brush(ctx, el, scope, isLast);
	                    el.setPrevPaintRect(paintRect);
	                }
	            }
	            else {
	                brush(ctx, el, scope, isLast);
	            }
	        };
	        CanvasPainter.prototype.getLayer = function (zlevel, virtual) {
	            if (this._singleCanvas && !this._needsManuallyCompositing) {
	                zlevel = CANVAS_ZLEVEL;
	            }
	            var layer = this._layers[zlevel];
	            if (!layer) {
	                layer = new Layer('zr_' + zlevel, this, this.dpr);
	                layer.zlevel = zlevel;
	                layer.__builtin__ = true;
	                if (this._layerConfig[zlevel]) {
	                    merge(layer, this._layerConfig[zlevel], true);
	                }
	                else if (this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC]) {
	                    merge(layer, this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC], true);
	                }
	                if (virtual) {
	                    layer.virtual = virtual;
	                }
	                this.insertLayer(zlevel, layer);
	                layer.initContext();
	            }
	            return layer;
	        };
	        CanvasPainter.prototype.insertLayer = function (zlevel, layer) {
	            var layersMap = this._layers;
	            var zlevelList = this._zlevelList;
	            var len = zlevelList.length;
	            var domRoot = this._domRoot;
	            var prevLayer = null;
	            var i = -1;
	            if (layersMap[zlevel]) {
	                if (true) {
	                    logError('ZLevel ' + zlevel + ' has been used already');
	                }
	                return;
	            }
	            if (!isLayerValid(layer)) {
	                if (true) {
	                    logError('Layer of zlevel ' + zlevel + ' is not valid');
	                }
	                return;
	            }
	            if (len > 0 && zlevel > zlevelList[0]) {
	                for (i = 0; i < len - 1; i++) {
	                    if (zlevelList[i] < zlevel
	                        && zlevelList[i + 1] > zlevel) {
	                        break;
	                    }
	                }
	                prevLayer = layersMap[zlevelList[i]];
	            }
	            zlevelList.splice(i + 1, 0, zlevel);
	            layersMap[zlevel] = layer;
	            if (!layer.virtual) {
	                if (prevLayer) {
	                    var prevDom = prevLayer.dom;
	                    if (prevDom.nextSibling) {
	                        domRoot.insertBefore(layer.dom, prevDom.nextSibling);
	                    }
	                    else {
	                        domRoot.appendChild(layer.dom);
	                    }
	                }
	                else {
	                    if (domRoot.firstChild) {
	                        domRoot.insertBefore(layer.dom, domRoot.firstChild);
	                    }
	                    else {
	                        domRoot.appendChild(layer.dom);
	                    }
	                }
	            }
	            layer.__painter = this;
	        };
	        CanvasPainter.prototype.eachLayer = function (cb, context) {
	            var zlevelList = this._zlevelList;
	            for (var i = 0; i < zlevelList.length; i++) {
	                var z = zlevelList[i];
	                cb.call(context, this._layers[z], z);
	            }
	        };
	        CanvasPainter.prototype.eachBuiltinLayer = function (cb, context) {
	            var zlevelList = this._zlevelList;
	            for (var i = 0; i < zlevelList.length; i++) {
	                var z = zlevelList[i];
	                var layer = this._layers[z];
	                if (layer.__builtin__) {
	                    cb.call(context, layer, z);
	                }
	            }
	        };
	        CanvasPainter.prototype.eachOtherLayer = function (cb, context) {
	            var zlevelList = this._zlevelList;
	            for (var i = 0; i < zlevelList.length; i++) {
	                var z = zlevelList[i];
	                var layer = this._layers[z];
	                if (!layer.__builtin__) {
	                    cb.call(context, layer, z);
	                }
	            }
	        };
	        CanvasPainter.prototype.getLayers = function () {
	            return this._layers;
	        };
	        CanvasPainter.prototype._updateLayerStatus = function (list) {
	            this.eachBuiltinLayer(function (layer, z) {
	                layer.__dirty = layer.__used = false;
	            });
	            function updatePrevLayer(idx) {
	                if (prevLayer) {
	                    if (prevLayer.__endIndex !== idx) {
	                        prevLayer.__dirty = true;
	                    }
	                    prevLayer.__endIndex = idx;
	                }
	            }
	            if (this._singleCanvas) {
	                for (var i_1 = 1; i_1 < list.length; i_1++) {
	                    var el = list[i_1];
	                    if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
	                        this._needsManuallyCompositing = true;
	                        break;
	                    }
	                }
	            }
	            var prevLayer = null;
	            var incrementalLayerCount = 0;
	            var prevZlevel;
	            var i;
	            for (i = 0; i < list.length; i++) {
	                var el = list[i];
	                var zlevel = el.zlevel;
	                var layer = void 0;
	                if (prevZlevel !== zlevel) {
	                    prevZlevel = zlevel;
	                    incrementalLayerCount = 0;
	                }
	                if (el.incremental) {
	                    layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
	                    layer.incremental = true;
	                    incrementalLayerCount = 1;
	                }
	                else {
	                    layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
	                }
	                if (!layer.__builtin__) {
	                    logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
	                }
	                if (layer !== prevLayer) {
	                    layer.__used = true;
	                    if (layer.__startIndex !== i) {
	                        layer.__dirty = true;
	                    }
	                    layer.__startIndex = i;
	                    if (!layer.incremental) {
	                        layer.__drawIndex = i;
	                    }
	                    else {
	                        layer.__drawIndex = -1;
	                    }
	                    updatePrevLayer(i);
	                    prevLayer = layer;
	                }
	                if ((el.__dirty & REDRAW_BIT) && !el.__inHover) {
	                    layer.__dirty = true;
	                    if (layer.incremental && layer.__drawIndex < 0) {
	                        layer.__drawIndex = i;
	                    }
	                }
	            }
	            updatePrevLayer(i);
	            this.eachBuiltinLayer(function (layer, z) {
	                if (!layer.__used && layer.getElementCount() > 0) {
	                    layer.__dirty = true;
	                    layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
	                }
	                if (layer.__dirty && layer.__drawIndex < 0) {
	                    layer.__drawIndex = layer.__startIndex;
	                }
	            });
	        };
	        CanvasPainter.prototype.clear = function () {
	            this.eachBuiltinLayer(this._clearLayer);
	            return this;
	        };
	        CanvasPainter.prototype._clearLayer = function (layer) {
	            layer.clear();
	        };
	        CanvasPainter.prototype.setBackgroundColor = function (backgroundColor) {
	            this._backgroundColor = backgroundColor;
	            each(this._layers, function (layer) {
	                layer.setUnpainted();
	            });
	        };
	        CanvasPainter.prototype.configLayer = function (zlevel, config) {
	            if (config) {
	                var layerConfig = this._layerConfig;
	                if (!layerConfig[zlevel]) {
	                    layerConfig[zlevel] = config;
	                }
	                else {
	                    merge(layerConfig[zlevel], config, true);
	                }
	                for (var i = 0; i < this._zlevelList.length; i++) {
	                    var _zlevel = this._zlevelList[i];
	                    if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
	                        var layer = this._layers[_zlevel];
	                        merge(layer, layerConfig[zlevel], true);
	                    }
	                }
	            }
	        };
	        CanvasPainter.prototype.delLayer = function (zlevel) {
	            var layers = this._layers;
	            var zlevelList = this._zlevelList;
	            var layer = layers[zlevel];
	            if (!layer) {
	                return;
	            }
	            layer.dom.parentNode.removeChild(layer.dom);
	            delete layers[zlevel];
	            zlevelList.splice(indexOf(zlevelList, zlevel), 1);
	        };
	        CanvasPainter.prototype.resize = function (width, height) {
	            if (!this._domRoot.style) {
	                if (width == null || height == null) {
	                    return;
	                }
	                this._width = width;
	                this._height = height;
	                this.getLayer(CANVAS_ZLEVEL).resize(width, height);
	            }
	            else {
	                var domRoot = this._domRoot;
	                domRoot.style.display = 'none';
	                var opts = this._opts;
	                var root = this.root;
	                width != null && (opts.width = width);
	                height != null && (opts.height = height);
	                width = getSize(root, 0, opts);
	                height = getSize(root, 1, opts);
	                domRoot.style.display = '';
	                if (this._width !== width || height !== this._height) {
	                    domRoot.style.width = width + 'px';
	                    domRoot.style.height = height + 'px';
	                    for (var id in this._layers) {
	                        if (this._layers.hasOwnProperty(id)) {
	                            this._layers[id].resize(width, height);
	                        }
	                    }
	                    this.refresh(true);
	                }
	                this._width = width;
	                this._height = height;
	            }
	            return this;
	        };
	        CanvasPainter.prototype.clearLayer = function (zlevel) {
	            var layer = this._layers[zlevel];
	            if (layer) {
	                layer.clear();
	            }
	        };
	        CanvasPainter.prototype.dispose = function () {
	            this.root.innerHTML = '';
	            this.root =
	                this.storage =
	                    this._domRoot =
	                        this._layers = null;
	        };
	        CanvasPainter.prototype.getRenderedCanvas = function (opts) {
	            opts = opts || {};
	            if (this._singleCanvas && !this._compositeManually) {
	                return this._layers[CANVAS_ZLEVEL].dom;
	            }
	            var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
	            imageLayer.initContext();
	            imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
	            var ctx = imageLayer.ctx;
	            if (opts.pixelRatio <= this.dpr) {
	                this.refresh();
	                var width_1 = imageLayer.dom.width;
	                var height_1 = imageLayer.dom.height;
	                this.eachLayer(function (layer) {
	                    if (layer.__builtin__) {
	                        ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
	                    }
	                    else if (layer.renderToCanvas) {
	                        ctx.save();
	                        layer.renderToCanvas(ctx);
	                        ctx.restore();
	                    }
	                });
	            }
	            else {
	                var scope = {
	                    inHover: false,
	                    viewWidth: this._width,
	                    viewHeight: this._height
	                };
	                var displayList = this.storage.getDisplayList(true);
	                for (var i = 0, len = displayList.length; i < len; i++) {
	                    var el = displayList[i];
	                    brush(ctx, el, scope, i === len - 1);
	                }
	            }
	            return imageLayer.dom;
	        };
	        CanvasPainter.prototype.getWidth = function () {
	            return this._width;
	        };
	        CanvasPainter.prototype.getHeight = function () {
	            return this._height;
	        };
	        return CanvasPainter;
	    }());
	
	    function install$1(registers) {
	      registers.registerPainter('canvas', CanvasPainter);
	    }
	
	    var LineSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(LineSeriesModel, _super);
	
	      function LineSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = LineSeriesModel.type;
	        _this.hasSymbolVisual = true;
	        return _this;
	      }
	
	      LineSeriesModel.prototype.getInitialData = function (option) {
	        if (true) {
	          var coordSys = option.coordinateSystem;
	
	          if (coordSys !== 'polar' && coordSys !== 'cartesian2d') {
	            throw new Error('Line not support coordinateSystem besides cartesian and polar');
	          }
	        }
	
	        return createSeriesData(null, this, {
	          useEncodeDefaulter: true
	        });
	      };
	
	      LineSeriesModel.prototype.getLegendIcon = function (opt) {
	        var group = new Group();
	        var line = createSymbol('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
	        group.add(line);
	        line.setStyle(opt.lineStyle);
	        var visualType = this.getData().getVisual('symbol');
	        var visualRotate = this.getData().getVisual('symbolRotate');
	        var symbolType = visualType === 'none' ? 'circle' : visualType; // Symbol size is 80% when there is a line
	
	        var size = opt.itemHeight * 0.8;
	        var symbol = createSymbol(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
	        group.add(symbol);
	        symbol.setStyle(opt.itemStyle);
	        var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
	        symbol.rotation = symbolRotate * Math.PI / 180;
	        symbol.setOrigin([opt.itemWidth / 2, opt.itemHeight / 2]);
	
	        if (symbolType.indexOf('empty') > -1) {
	          symbol.style.stroke = symbol.style.fill;
	          symbol.style.fill = '#fff';
	          symbol.style.lineWidth = 2;
	        }
	
	        return group;
	      };
	
	      LineSeriesModel.type = 'series.line';
	      LineSeriesModel.dependencies = ['grid', 'polar'];
	      LineSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 3,
	        coordinateSystem: 'cartesian2d',
	        legendHoverLink: true,
	        clip: true,
	        label: {
	          position: 'top'
	        },
	        // itemStyle: {
	        // },
	        endLabel: {
	          show: false,
	          valueAnimation: true,
	          distance: 8
	        },
	        lineStyle: {
	          width: 2,
	          type: 'solid'
	        },
	        emphasis: {
	          scale: true
	        },
	        // areaStyle: {
	        // origin of areaStyle. Valid values:
	        // `'auto'/null/undefined`: from axisLine to data
	        // `'start'`: from min to data
	        // `'end'`: from data to max
	        // origin: 'auto'
	        // },
	        // false, 'start', 'end', 'middle'
	        step: false,
	        // Disabled if step is true
	        smooth: false,
	        smoothMonotone: null,
	        symbol: 'emptyCircle',
	        symbolSize: 4,
	        symbolRotate: null,
	        showSymbol: true,
	        // `false`: follow the label interval strategy.
	        // `true`: show all symbols.
	        // `'auto'`: If possible, show all symbols, otherwise
	        //           follow the label interval strategy.
	        showAllSymbol: 'auto',
	        // Whether to connect break point.
	        connectNulls: false,
	        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
	        sampling: 'none',
	        animationEasing: 'linear',
	        // Disable progressive
	        progressive: 0,
	        hoverLayerThreshold: Infinity,
	        universalTransition: {
	          divideShape: 'clone'
	        },
	        triggerLineEvent: false
	      };
	      return LineSeriesModel;
	    }(SeriesModel);
	
	    /**
	     * @return label string. Not null/undefined
	     */
	
	    function getDefaultLabel(data, dataIndex) {
	      var labelDims = data.mapDimensionsAll('defaultedLabel');
	      var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
	
	      if (len === 1) {
	        var rawVal = retrieveRawValue(data, dataIndex, labelDims[0]);
	        return rawVal != null ? rawVal + '' : null;
	      } else if (len) {
	        var vals = [];
	
	        for (var i = 0; i < labelDims.length; i++) {
	          vals.push(retrieveRawValue(data, dataIndex, labelDims[i]));
	        }
	
	        return vals.join(' ');
	      }
	    }
	    function getDefaultInterpolatedLabel(data, interpolatedValue) {
	      var labelDims = data.mapDimensionsAll('defaultedLabel');
	
	      if (!isArray(interpolatedValue)) {
	        return interpolatedValue + '';
	      }
	
	      var vals = [];
	
	      for (var i = 0; i < labelDims.length; i++) {
	        var dimIndex = data.getDimensionIndex(labelDims[i]);
	
	        if (dimIndex >= 0) {
	          vals.push(interpolatedValue[dimIndex]);
	        }
	      }
	
	      return vals.join(' ');
	    }
	
	    var Symbol =
	    /** @class */
	    function (_super) {
	      __extends(Symbol, _super);
	
	      function Symbol(data, idx, seriesScope, opts) {
	        var _this = _super.call(this) || this;
	
	        _this.updateData(data, idx, seriesScope, opts);
	
	        return _this;
	      }
	
	      Symbol.prototype._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
	        // Remove paths created before
	        this.removeAll(); // let symbolPath = createSymbol(
	        //     symbolType, -0.5, -0.5, 1, 1, color
	        // );
	        // If width/height are set too small (e.g., set to 1) on ios10
	        // and macOS Sierra, a circle stroke become a rect, no matter what
	        // the scale is set. So we set width/height as 2. See #4150.
	
	        var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, null, keepAspect);
	        symbolPath.attr({
	          z2: 100,
	          culling: true,
	          scaleX: symbolSize[0] / 2,
	          scaleY: symbolSize[1] / 2
	        }); // Rewrite drift method
	
	        symbolPath.drift = driftSymbol;
	        this._symbolType = symbolType;
	        this.add(symbolPath);
	      };
	      /**
	       * Stop animation
	       * @param {boolean} toLastFrame
	       */
	
	
	      Symbol.prototype.stopSymbolAnimation = function (toLastFrame) {
	        this.childAt(0).stopAnimation(null, toLastFrame);
	      };
	
	      Symbol.prototype.getSymbolType = function () {
	        return this._symbolType;
	      };
	      /**
	       * FIXME:
	       * Caution: This method breaks the encapsulation of this module,
	       * but it indeed brings convenience. So do not use the method
	       * unless you detailedly know all the implements of `Symbol`,
	       * especially animation.
	       *
	       * Get symbol path element.
	       */
	
	
	      Symbol.prototype.getSymbolPath = function () {
	        return this.childAt(0);
	      };
	      /**
	       * Highlight symbol
	       */
	
	
	      Symbol.prototype.highlight = function () {
	        enterEmphasis(this.childAt(0));
	      };
	      /**
	       * Downplay symbol
	       */
	
	
	      Symbol.prototype.downplay = function () {
	        leaveEmphasis(this.childAt(0));
	      };
	      /**
	       * @param {number} zlevel
	       * @param {number} z
	       */
	
	
	      Symbol.prototype.setZ = function (zlevel, z) {
	        var symbolPath = this.childAt(0);
	        symbolPath.zlevel = zlevel;
	        symbolPath.z = z;
	      };
	
	      Symbol.prototype.setDraggable = function (draggable, hasCursorOption) {
	        var symbolPath = this.childAt(0);
	        symbolPath.draggable = draggable;
	        symbolPath.cursor = !hasCursorOption && draggable ? 'move' : symbolPath.cursor;
	      };
	      /**
	       * Update symbol properties
	       */
	
	
	      Symbol.prototype.updateData = function (data, idx, seriesScope, opts) {
	        this.silent = false;
	        var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	        var seriesModel = data.hostModel;
	        var symbolSize = Symbol.getSymbolSize(data, idx);
	        var isInit = symbolType !== this._symbolType;
	        var disableAnimation = opts && opts.disableAnimation;
	
	        if (isInit) {
	          var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
	
	          this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
	        } else {
	          var symbolPath = this.childAt(0);
	          symbolPath.silent = false;
	          var target = {
	            scaleX: symbolSize[0] / 2,
	            scaleY: symbolSize[1] / 2
	          };
	          disableAnimation ? symbolPath.attr(target) : updateProps(symbolPath, target, seriesModel, idx);
	          saveOldStyle(symbolPath);
	        }
	
	        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
	
	        if (isInit) {
	          var symbolPath = this.childAt(0);
	
	          if (!disableAnimation) {
	            var target = {
	              scaleX: this._sizeX,
	              scaleY: this._sizeY,
	              style: {
	                // Always fadeIn. Because it has fadeOut animation when symbol is removed..
	                opacity: symbolPath.style.opacity
	              }
	            };
	            symbolPath.scaleX = symbolPath.scaleY = 0;
	            symbolPath.style.opacity = 0;
	            initProps(symbolPath, target, seriesModel, idx);
	          }
	        }
	
	        if (disableAnimation) {
	          // Must stop leave transition manually if don't call initProps or updateProps.
	          this.childAt(0).stopAnimation('leave');
	        }
	      };
	
	      Symbol.prototype._updateCommon = function (data, idx, symbolSize, seriesScope, opts) {
	        var symbolPath = this.childAt(0);
	        var seriesModel = data.hostModel;
	        var emphasisItemStyle;
	        var blurItemStyle;
	        var selectItemStyle;
	        var focus;
	        var blurScope;
	        var emphasisDisabled;
	        var labelStatesModels;
	        var hoverScale;
	        var cursorStyle;
	
	        if (seriesScope) {
	          emphasisItemStyle = seriesScope.emphasisItemStyle;
	          blurItemStyle = seriesScope.blurItemStyle;
	          selectItemStyle = seriesScope.selectItemStyle;
	          focus = seriesScope.focus;
	          blurScope = seriesScope.blurScope;
	          labelStatesModels = seriesScope.labelStatesModels;
	          hoverScale = seriesScope.hoverScale;
	          cursorStyle = seriesScope.cursorStyle;
	          emphasisDisabled = seriesScope.emphasisDisabled;
	        }
	
	        if (!seriesScope || data.hasItemOption) {
	          var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
	          var emphasisModel = itemModel.getModel('emphasis');
	          emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
	          selectItemStyle = itemModel.getModel(['select', 'itemStyle']).getItemStyle();
	          blurItemStyle = itemModel.getModel(['blur', 'itemStyle']).getItemStyle();
	          focus = emphasisModel.get('focus');
	          blurScope = emphasisModel.get('blurScope');
	          emphasisDisabled = emphasisModel.get('disabled');
	          labelStatesModels = getLabelStatesModels(itemModel);
	          hoverScale = emphasisModel.getShallow('scale');
	          cursorStyle = itemModel.getShallow('cursor');
	        }
	
	        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	        symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
	        var symbolOffset = normalizeSymbolOffset(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
	
	        if (symbolOffset) {
	          symbolPath.x = symbolOffset[0];
	          symbolPath.y = symbolOffset[1];
	        }
	
	        cursorStyle && symbolPath.attr('cursor', cursorStyle);
	        var symbolStyle = data.getItemVisual(idx, 'style');
	        var visualColor = symbolStyle.fill;
	
	        if (symbolPath instanceof ZRImage) {
	          var pathStyle = symbolPath.style;
	          symbolPath.useStyle(extend({
	            // TODO other properties like x, y ?
	            image: pathStyle.image,
	            x: pathStyle.x,
	            y: pathStyle.y,
	            width: pathStyle.width,
	            height: pathStyle.height
	          }, symbolStyle));
	        } else {
	          if (symbolPath.__isEmptyBrush) {
	            // fill and stroke will be swapped if it's empty.
	            // So we cloned a new style to avoid it affecting the original style in visual storage.
	            // TODO Better implementation. No empty logic!
	            symbolPath.useStyle(extend({}, symbolStyle));
	          } else {
	            symbolPath.useStyle(symbolStyle);
	          } // Disable decal because symbol scale will been applied on the decal.
	
	
	          symbolPath.style.decal = null;
	          symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
	          symbolPath.style.strokeNoScale = true;
	        }
	
	        var liftZ = data.getItemVisual(idx, 'liftZ');
	        var z2Origin = this._z2;
	
	        if (liftZ != null) {
	          if (z2Origin == null) {
	            this._z2 = symbolPath.z2;
	            symbolPath.z2 += liftZ;
	          }
	        } else if (z2Origin != null) {
	          symbolPath.z2 = z2Origin;
	          this._z2 = null;
	        }
	
	        var useNameLabel = opts && opts.useNameLabel;
	        setLabelStyle(symbolPath, labelStatesModels, {
	          labelFetcher: seriesModel,
	          labelDataIndex: idx,
	          defaultText: getLabelDefaultText,
	          inheritColor: visualColor,
	          defaultOpacity: symbolStyle.opacity
	        }); // Do not execute util needed.
	
	        function getLabelDefaultText(idx) {
	          return useNameLabel ? data.getName(idx) : getDefaultLabel(data, idx);
	        }
	
	        this._sizeX = symbolSize[0] / 2;
	        this._sizeY = symbolSize[1] / 2;
	        var emphasisState = symbolPath.ensureState('emphasis');
	        emphasisState.style = emphasisItemStyle;
	        symbolPath.ensureState('select').style = selectItemStyle;
	        symbolPath.ensureState('blur').style = blurItemStyle; // null / undefined / true means to use default strategy.
	        // 0 / false / negative number / NaN / Infinity means no scale.
	
	        var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) // PENDING: restrict hoverScale > 1? It seems unreasonable to scale down
	        : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1; // always set scale to allow resetting
	
	        emphasisState.scaleX = this._sizeX * scaleRatio;
	        emphasisState.scaleY = this._sizeY * scaleRatio;
	        this.setSymbolScale(1);
	        toggleHoverEmphasis(this, focus, blurScope, emphasisDisabled);
	      };
	
	      Symbol.prototype.setSymbolScale = function (scale) {
	        this.scaleX = this.scaleY = scale;
	      };
	
	      Symbol.prototype.fadeOut = function (cb, seriesModel, opt) {
	        var symbolPath = this.childAt(0);
	        var dataIndex = getECData(this).dataIndex;
	        var animationOpt = opt && opt.animation; // Avoid mistaken hover when fading out
	
	        this.silent = symbolPath.silent = true; // Not show text when animating
	
	        if (opt && opt.fadeLabel) {
	          var textContent = symbolPath.getTextContent();
	
	          if (textContent) {
	            removeElement(textContent, {
	              style: {
	                opacity: 0
	              }
	            }, seriesModel, {
	              dataIndex: dataIndex,
	              removeOpt: animationOpt,
	              cb: function () {
	                symbolPath.removeTextContent();
	              }
	            });
	          }
	        } else {
	          symbolPath.removeTextContent();
	        }
	
	        removeElement(symbolPath, {
	          style: {
	            opacity: 0
	          },
	          scaleX: 0,
	          scaleY: 0
	        }, seriesModel, {
	          dataIndex: dataIndex,
	          cb: cb,
	          removeOpt: animationOpt
	        });
	      };
	
	      Symbol.getSymbolSize = function (data, idx) {
	        return normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	      };
	
	      return Symbol;
	    }(Group);
	
	    function driftSymbol(dx, dy) {
	      this.parent.drift(dx, dy);
	    }
	
	    function symbolNeedsDraw(data, point, idx, opt) {
	      return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
	      // the symbol element shape. We use the same clip shape here as
	      // the line clip.
	      && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
	    }
	
	    function normalizeUpdateOpt(opt) {
	      if (opt != null && !isObject(opt)) {
	        opt = {
	          isIgnore: opt
	        };
	      }
	
	      return opt || {};
	    }
	
	    function makeSeriesScope(data) {
	      var seriesModel = data.hostModel;
	      var emphasisModel = seriesModel.getModel('emphasis');
	      return {
	        emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
	        blurItemStyle: seriesModel.getModel(['blur', 'itemStyle']).getItemStyle(),
	        selectItemStyle: seriesModel.getModel(['select', 'itemStyle']).getItemStyle(),
	        focus: emphasisModel.get('focus'),
	        blurScope: emphasisModel.get('blurScope'),
	        emphasisDisabled: emphasisModel.get('disabled'),
	        hoverScale: emphasisModel.get('scale'),
	        labelStatesModels: getLabelStatesModels(seriesModel),
	        cursorStyle: seriesModel.get('cursor')
	      };
	    }
	
	    var SymbolDraw =
	    /** @class */
	    function () {
	      function SymbolDraw(SymbolCtor) {
	        this.group = new Group();
	        this._SymbolCtor = SymbolCtor || Symbol;
	      }
	      /**
	       * Update symbols draw by new data
	       */
	
	
	      SymbolDraw.prototype.updateData = function (data, opt) {
	        // Remove progressive els.
	        this._progressiveEls = null;
	        opt = normalizeUpdateOpt(opt);
	        var group = this.group;
	        var seriesModel = data.hostModel;
	        var oldData = this._data;
	        var SymbolCtor = this._SymbolCtor;
	        var disableAnimation = opt.disableAnimation;
	        var seriesScope = makeSeriesScope(data);
	        var symbolUpdateOpt = {
	          disableAnimation: disableAnimation
	        };
	
	        var getSymbolPoint = opt.getSymbolPoint || function (idx) {
	          return data.getItemLayout(idx);
	        }; // There is no oldLineData only when first rendering or switching from
	        // stream mode to normal mode, where previous elements should be removed.
	
	
	        if (!oldData) {
	          group.removeAll();
	        }
	
	        data.diff(oldData).add(function (newIdx) {
	          var point = getSymbolPoint(newIdx);
	
	          if (symbolNeedsDraw(data, point, newIdx, opt)) {
	            var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
	            symbolEl.setPosition(point);
	            data.setItemGraphicEl(newIdx, symbolEl);
	            group.add(symbolEl);
	          }
	        }).update(function (newIdx, oldIdx) {
	          var symbolEl = oldData.getItemGraphicEl(oldIdx);
	          var point = getSymbolPoint(newIdx);
	
	          if (!symbolNeedsDraw(data, point, newIdx, opt)) {
	            group.remove(symbolEl);
	            return;
	          }
	
	          var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
	          var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
	
	          if (!symbolEl // Create a new if symbol type changed.
	          || oldSymbolType && oldSymbolType !== newSymbolType) {
	            group.remove(symbolEl);
	            symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
	            symbolEl.setPosition(point);
	          } else {
	            symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
	            var target = {
	              x: point[0],
	              y: point[1]
	            };
	            disableAnimation ? symbolEl.attr(target) : updateProps(symbolEl, target, seriesModel);
	          } // Add back
	
	
	          group.add(symbolEl);
	          data.setItemGraphicEl(newIdx, symbolEl);
	        }).remove(function (oldIdx) {
	          var el = oldData.getItemGraphicEl(oldIdx);
	          el && el.fadeOut(function () {
	            group.remove(el);
	          }, seriesModel);
	        }).execute();
	        this._getSymbolPoint = getSymbolPoint;
	        this._data = data;
	      };
	
	      SymbolDraw.prototype.updateLayout = function () {
	        var _this = this;
	
	        var data = this._data;
	
	        if (data) {
	          // Not use animation
	          data.eachItemGraphicEl(function (el, idx) {
	            var point = _this._getSymbolPoint(idx);
	
	            el.setPosition(point);
	            el.markRedraw();
	          });
	        }
	      };
	
	      SymbolDraw.prototype.incrementalPrepareUpdate = function (data) {
	        this._seriesScope = makeSeriesScope(data);
	        this._data = null;
	        this.group.removeAll();
	      };
	      /**
	       * Update symbols draw by new data
	       */
	
	      SymbolDraw.prototype.incrementalUpdate = function (taskParams, data, opt) {
	        // Clear
	        this._progressiveEls = [];
	        opt = normalizeUpdateOpt(opt);
	
	        function updateIncrementalAndHover(el) {
	          if (!el.isGroup) {
	            el.incremental = true;
	            el.ensureState('emphasis').hoverLayer = true;
	          }
	        }
	
	        for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	          var point = data.getItemLayout(idx);
	
	          if (symbolNeedsDraw(data, point, idx, opt)) {
	            var el = new this._SymbolCtor(data, idx, this._seriesScope);
	            el.traverse(updateIncrementalAndHover);
	            el.setPosition(point);
	            this.group.add(el);
	            data.setItemGraphicEl(idx, el);
	
	            this._progressiveEls.push(el);
	          }
	        }
	      };
	
	      SymbolDraw.prototype.eachRendered = function (cb) {
	        traverseElements(this._progressiveEls || this.group, cb);
	      };
	
	      SymbolDraw.prototype.remove = function (enableAnimation) {
	        var group = this.group;
	        var data = this._data; // Incremental model do not have this._data.
	
	        if (data && enableAnimation) {
	          data.eachItemGraphicEl(function (el) {
	            el.fadeOut(function () {
	              group.remove(el);
	            }, data.hostModel);
	          });
	        } else {
	          group.removeAll();
	        }
	      };
	      return SymbolDraw;
	    }();
	
	    function prepareDataCoordInfo(coordSys, data, valueOrigin) {
	      var baseAxis = coordSys.getBaseAxis();
	      var valueAxis = coordSys.getOtherAxis(baseAxis);
	      var valueStart = getValueStart(valueAxis, valueOrigin);
	      var baseAxisDim = baseAxis.dim;
	      var valueAxisDim = valueAxis.dim;
	      var valueDim = data.mapDimension(valueAxisDim);
	      var baseDim = data.mapDimension(baseAxisDim);
	      var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
	      var dims = map(coordSys.dimensions, function (coordDim) {
	        return data.mapDimension(coordDim);
	      });
	      var stacked = false;
	      var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	      if (isDimensionStacked(data, dims[0]
	      /* , dims[1] */
	      )) {
	        // jshint ignore:line
	        stacked = true;
	        dims[0] = stackResultDim;
	      }
	
	      if (isDimensionStacked(data, dims[1]
	      /* , dims[0] */
	      )) {
	        // jshint ignore:line
	        stacked = true;
	        dims[1] = stackResultDim;
	      }
	
	      return {
	        dataDimsForPoint: dims,
	        valueStart: valueStart,
	        valueAxisDim: valueAxisDim,
	        baseAxisDim: baseAxisDim,
	        stacked: !!stacked,
	        valueDim: valueDim,
	        baseDim: baseDim,
	        baseDataOffset: baseDataOffset,
	        stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
	      };
	    }
	
	    function getValueStart(valueAxis, valueOrigin) {
	      var valueStart = 0;
	      var extent = valueAxis.scale.getExtent();
	
	      if (valueOrigin === 'start') {
	        valueStart = extent[0];
	      } else if (valueOrigin === 'end') {
	        valueStart = extent[1];
	      } // If origin is specified as a number, use it as
	      // valueStart directly
	      else if (isNumber(valueOrigin) && !isNaN(valueOrigin)) {
	          valueStart = valueOrigin;
	        } // auto
	        else {
	            // Both positive
	            if (extent[0] > 0) {
	              valueStart = extent[0];
	            } // Both negative
	            else if (extent[1] < 0) {
	                valueStart = extent[1];
	              } // If is one positive, and one negative, onZero shall be true
	
	          }
	
	      return valueStart;
	    }
	
	    function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
	      var value = NaN;
	
	      if (dataCoordInfo.stacked) {
	        value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
	      }
	
	      if (isNaN(value)) {
	        value = dataCoordInfo.valueStart;
	      }
	
	      var baseDataOffset = dataCoordInfo.baseDataOffset;
	      var stackedData = [];
	      stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
	      stackedData[1 - baseDataOffset] = value;
	      return coordSys.dataToPoint(stackedData);
	    }
	
	    function diffData(oldData, newData) {
	      var diffResult = [];
	      newData.diff(oldData).add(function (idx) {
	        diffResult.push({
	          cmd: '+',
	          idx: idx
	        });
	      }).update(function (newIdx, oldIdx) {
	        diffResult.push({
	          cmd: '=',
	          idx: oldIdx,
	          idx1: newIdx
	        });
	      }).remove(function (idx) {
	        diffResult.push({
	          cmd: '-',
	          idx: idx
	        });
	      }).execute();
	      return diffResult;
	    }
	
	    function lineAnimationDiff(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
	      var diff = diffData(oldData, newData); // let newIdList = newData.mapArray(newData.getId);
	      // let oldIdList = oldData.mapArray(oldData.getId);
	      // convertToIntId(newIdList, oldIdList);
	      // // FIXME One data ?
	      // diff = arrayDiff(oldIdList, newIdList);
	
	      var currPoints = [];
	      var nextPoints = []; // Points for stacking base line
	
	      var currStackedPoints = [];
	      var nextStackedPoints = [];
	      var status = [];
	      var sortedIndices = [];
	      var rawIndices = [];
	      var newDataOldCoordInfo = prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin); // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
	
	      var oldPoints = oldData.getLayout('points') || [];
	      var newPoints = newData.getLayout('points') || [];
	
	      for (var i = 0; i < diff.length; i++) {
	        var diffItem = diff[i];
	        var pointAdded = true;
	        var oldIdx2 = void 0;
	        var newIdx2 = void 0; // FIXME, animation is not so perfect when dataZoom window moves fast
	        // Which is in case remvoing or add more than one data in the tail or head
	
	        switch (diffItem.cmd) {
	          case '=':
	            oldIdx2 = diffItem.idx * 2;
	            newIdx2 = diffItem.idx1 * 2;
	            var currentX = oldPoints[oldIdx2];
	            var currentY = oldPoints[oldIdx2 + 1];
	            var nextX = newPoints[newIdx2];
	            var nextY = newPoints[newIdx2 + 1]; // If previous data is NaN, use next point directly
	
	            if (isNaN(currentX) || isNaN(currentY)) {
	              currentX = nextX;
	              currentY = nextY;
	            }
	
	            currPoints.push(currentX, currentY);
	            nextPoints.push(nextX, nextY);
	            currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
	            nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
	            rawIndices.push(newData.getRawIndex(diffItem.idx1));
	            break;
	
	          case '+':
	            var newIdx = diffItem.idx;
	            var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
	            var oldPt = oldCoordSys.dataToPoint([newData.get(newDataDimsForPoint[0], newIdx), newData.get(newDataDimsForPoint[1], newIdx)]);
	            newIdx2 = newIdx * 2;
	            currPoints.push(oldPt[0], oldPt[1]);
	            nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
	            var stackedOnPoint = getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
	            currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
	            nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
	            rawIndices.push(newData.getRawIndex(newIdx));
	            break;
	
	          case '-':
	            pointAdded = false;
	        } // Original indices
	
	
	        if (pointAdded) {
	          status.push(diffItem);
	          sortedIndices.push(sortedIndices.length);
	        }
	      } // Diff result may be crossed if all items are changed
	      // Sort by data index
	
	
	      sortedIndices.sort(function (a, b) {
	        return rawIndices[a] - rawIndices[b];
	      });
	      var len = currPoints.length;
	      var sortedCurrPoints = createFloat32Array(len);
	      var sortedNextPoints = createFloat32Array(len);
	      var sortedCurrStackedPoints = createFloat32Array(len);
	      var sortedNextStackedPoints = createFloat32Array(len);
	      var sortedStatus = [];
	
	      for (var i = 0; i < sortedIndices.length; i++) {
	        var idx = sortedIndices[i];
	        var i2 = i * 2;
	        var idx2 = idx * 2;
	        sortedCurrPoints[i2] = currPoints[idx2];
	        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
	        sortedNextPoints[i2] = nextPoints[idx2];
	        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
	        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
	        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
	        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
	        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
	        sortedStatus[i] = status[idx];
	      }
	
	      return {
	        current: sortedCurrPoints,
	        next: sortedNextPoints,
	        stackedOnCurrent: sortedCurrStackedPoints,
	        stackedOnNext: sortedNextStackedPoints,
	        status: sortedStatus
	      };
	    }
	
	    var mathMin$5 = Math.min;
	    var mathMax$5 = Math.max;
	
	    function isPointNull(x, y) {
	      return isNaN(x) || isNaN(y);
	    }
	    /**
	     * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
	     * situations. This should be used when points are non-monotone neither in x or
	     * y dimension.
	     */
	
	
	    function drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
	      var prevX;
	      var prevY;
	      var cpx0;
	      var cpy0;
	      var cpx1;
	      var cpy1;
	      var idx = start;
	      var k = 0;
	
	      for (; k < segLen; k++) {
	        var x = points[idx * 2];
	        var y = points[idx * 2 + 1];
	
	        if (idx >= allLen || idx < 0) {
	          break;
	        }
	
	        if (isPointNull(x, y)) {
	          if (connectNulls) {
	            idx += dir;
	            continue;
	          }
	
	          break;
	        }
	
	        if (idx === start) {
	          ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
	          cpx0 = x;
	          cpy0 = y;
	        } else {
	          var dx = x - prevX;
	          var dy = y - prevY; // Ignore tiny segment.
	
	          if (dx * dx + dy * dy < 0.5) {
	            idx += dir;
	            continue;
	          }
	
	          if (smooth > 0) {
	            var nextIdx = idx + dir;
	            var nextX = points[nextIdx * 2];
	            var nextY = points[nextIdx * 2 + 1]; // Ignore duplicate point
	
	            while (nextX === x && nextY === y && k < segLen) {
	              k++;
	              nextIdx += dir;
	              idx += dir;
	              nextX = points[nextIdx * 2];
	              nextY = points[nextIdx * 2 + 1];
	              x = points[idx * 2];
	              y = points[idx * 2 + 1];
	              dx = x - prevX;
	              dy = y - prevY;
	            }
	
	            var tmpK = k + 1;
	
	            if (connectNulls) {
	              // Find next point not null
	              while (isPointNull(nextX, nextY) && tmpK < segLen) {
	                tmpK++;
	                nextIdx += dir;
	                nextX = points[nextIdx * 2];
	                nextY = points[nextIdx * 2 + 1];
	              }
	            }
	
	            var ratioNextSeg = 0.5;
	            var vx = 0;
	            var vy = 0;
	            var nextCpx0 = void 0;
	            var nextCpy0 = void 0; // Is last point
	
	            if (tmpK >= segLen || isPointNull(nextX, nextY)) {
	              cpx1 = x;
	              cpy1 = y;
	            } else {
	              vx = nextX - prevX;
	              vy = nextY - prevY;
	              var dx0 = x - prevX;
	              var dx1 = nextX - x;
	              var dy0 = y - prevY;
	              var dy1 = nextY - y;
	              var lenPrevSeg = void 0;
	              var lenNextSeg = void 0;
	
	              if (smoothMonotone === 'x') {
	                lenPrevSeg = Math.abs(dx0);
	                lenNextSeg = Math.abs(dx1);
	                var dir_1 = vx > 0 ? 1 : -1;
	                cpx1 = x - dir_1 * lenPrevSeg * smooth;
	                cpy1 = y;
	                nextCpx0 = x + dir_1 * lenNextSeg * smooth;
	                nextCpy0 = y;
	              } else if (smoothMonotone === 'y') {
	                lenPrevSeg = Math.abs(dy0);
	                lenNextSeg = Math.abs(dy1);
	                var dir_2 = vy > 0 ? 1 : -1;
	                cpx1 = x;
	                cpy1 = y - dir_2 * lenPrevSeg * smooth;
	                nextCpx0 = x;
	                nextCpy0 = y + dir_2 * lenNextSeg * smooth;
	              } else {
	                lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
	                lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1); // Use ratio of seg length
	
	                ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
	                cpx1 = x - vx * smooth * (1 - ratioNextSeg);
	                cpy1 = y - vy * smooth * (1 - ratioNextSeg); // cp0 of next segment
	
	                nextCpx0 = x + vx * smooth * ratioNextSeg;
	                nextCpy0 = y + vy * smooth * ratioNextSeg; // Smooth constraint between point and next point.
	                // Avoid exceeding extreme after smoothing.
	
	                nextCpx0 = mathMin$5(nextCpx0, mathMax$5(nextX, x));
	                nextCpy0 = mathMin$5(nextCpy0, mathMax$5(nextY, y));
	                nextCpx0 = mathMax$5(nextCpx0, mathMin$5(nextX, x));
	                nextCpy0 = mathMax$5(nextCpy0, mathMin$5(nextY, y)); // Reclaculate cp1 based on the adjusted cp0 of next seg.
	
	                vx = nextCpx0 - x;
	                vy = nextCpy0 - y;
	                cpx1 = x - vx * lenPrevSeg / lenNextSeg;
	                cpy1 = y - vy * lenPrevSeg / lenNextSeg; // Smooth constraint between point and prev point.
	                // Avoid exceeding extreme after smoothing.
	
	                cpx1 = mathMin$5(cpx1, mathMax$5(prevX, x));
	                cpy1 = mathMin$5(cpy1, mathMax$5(prevY, y));
	                cpx1 = mathMax$5(cpx1, mathMin$5(prevX, x));
	                cpy1 = mathMax$5(cpy1, mathMin$5(prevY, y)); // Adjust next cp0 again.
	
	                vx = x - cpx1;
	                vy = y - cpy1;
	                nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
	                nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
	              }
	            }
	
	            ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
	            cpx0 = nextCpx0;
	            cpy0 = nextCpy0;
	          } else {
	            ctx.lineTo(x, y);
	          }
	        }
	
	        prevX = x;
	        prevY = y;
	        idx += dir;
	      }
	
	      return k;
	    }
	
	    var ECPolylineShape =
	    /** @class */
	    function () {
	      function ECPolylineShape() {
	        this.smooth = 0;
	        this.smoothConstraint = true;
	      }
	
	      return ECPolylineShape;
	    }();
	
	    var ECPolyline =
	    /** @class */
	    function (_super) {
	      __extends(ECPolyline, _super);
	
	      function ECPolyline(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this.type = 'ec-polyline';
	        return _this;
	      }
	
	      ECPolyline.prototype.getDefaultStyle = function () {
	        return {
	          stroke: '#000',
	          fill: null
	        };
	      };
	
	      ECPolyline.prototype.getDefaultShape = function () {
	        return new ECPolylineShape();
	      };
	
	      ECPolyline.prototype.buildPath = function (ctx, shape) {
	        var points = shape.points;
	        var i = 0;
	        var len = points.length / 2; // const result = getBoundingBox(points, shape.smoothConstraint);
	
	        if (shape.connectNulls) {
	          // Must remove first and last null values avoid draw error in polygon
	          for (; len > 0; len--) {
	            if (!isPointNull(points[len * 2 - 2], points[len * 2 - 1])) {
	              break;
	            }
	          }
	
	          for (; i < len; i++) {
	            if (!isPointNull(points[i * 2], points[i * 2 + 1])) {
	              break;
	            }
	          }
	        }
	
	        while (i < len) {
	          i += drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
	        }
	      };
	
	      ECPolyline.prototype.getPointOn = function (xOrY, dim) {
	        if (!this.path) {
	          this.createPathProxy();
	          this.buildPath(this.path, this.shape);
	        }
	
	        var path = this.path;
	        var data = path.data;
	        var CMD = PathProxy.CMD;
	        var x0;
	        var y0;
	        var isDimX = dim === 'x';
	        var roots = [];
	
	        for (var i = 0; i < data.length;) {
	          var cmd = data[i++];
	          var x = void 0;
	          var y = void 0;
	          var x2 = void 0;
	          var y2 = void 0;
	          var x3 = void 0;
	          var y3 = void 0;
	          var t = void 0;
	
	          switch (cmd) {
	            case CMD.M:
	              x0 = data[i++];
	              y0 = data[i++];
	              break;
	
	            case CMD.L:
	              x = data[i++];
	              y = data[i++];
	              t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
	
	              if (t <= 1 && t >= 0) {
	                var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
	                return isDimX ? [xOrY, val] : [val, xOrY];
	              }
	
	              x0 = x;
	              y0 = y;
	              break;
	
	            case CMD.C:
	              x = data[i++];
	              y = data[i++];
	              x2 = data[i++];
	              y2 = data[i++];
	              x3 = data[i++];
	              y3 = data[i++];
	              var nRoot = isDimX ? cubicRootAt(x0, x, x2, x3, xOrY, roots) : cubicRootAt(y0, y, y2, y3, xOrY, roots);
	
	              if (nRoot > 0) {
	                for (var i_1 = 0; i_1 < nRoot; i_1++) {
	                  var t_1 = roots[i_1];
	
	                  if (t_1 <= 1 && t_1 >= 0) {
	                    var val = isDimX ? cubicAt(y0, y, y2, y3, t_1) : cubicAt(x0, x, x2, x3, t_1);
	                    return isDimX ? [xOrY, val] : [val, xOrY];
	                  }
	                }
	              }
	
	              x0 = x3;
	              y0 = y3;
	              break;
	          }
	        }
	      };
	
	      return ECPolyline;
	    }(Path);
	
	    var ECPolygonShape =
	    /** @class */
	    function (_super) {
	      __extends(ECPolygonShape, _super);
	
	      function ECPolygonShape() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      return ECPolygonShape;
	    }(ECPolylineShape);
	
	    var ECPolygon =
	    /** @class */
	    function (_super) {
	      __extends(ECPolygon, _super);
	
	      function ECPolygon(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this.type = 'ec-polygon';
	        return _this;
	      }
	
	      ECPolygon.prototype.getDefaultShape = function () {
	        return new ECPolygonShape();
	      };
	
	      ECPolygon.prototype.buildPath = function (ctx, shape) {
	        var points = shape.points;
	        var stackedOnPoints = shape.stackedOnPoints;
	        var i = 0;
	        var len = points.length / 2;
	        var smoothMonotone = shape.smoothMonotone;
	
	        if (shape.connectNulls) {
	          // Must remove first and last null values avoid draw error in polygon
	          for (; len > 0; len--) {
	            if (!isPointNull(points[len * 2 - 2], points[len * 2 - 1])) {
	              break;
	            }
	          }
	
	          for (; i < len; i++) {
	            if (!isPointNull(points[i * 2], points[i * 2 + 1])) {
	              break;
	            }
	          }
	        }
	
	        while (i < len) {
	          var k = drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
	          drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
	          i += k + 1;
	          ctx.closePath();
	        }
	      };
	
	      return ECPolygon;
	    }(Path);
	
	    function createGridClipPath(cartesian, hasAnimation, seriesModel, done, during) {
	      var rect = cartesian.getArea();
	      var x = rect.x;
	      var y = rect.y;
	      var width = rect.width;
	      var height = rect.height;
	      var lineWidth = seriesModel.get(['lineStyle', 'width']) || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
	
	      x -= lineWidth / 2;
	      y -= lineWidth / 2;
	      width += lineWidth;
	      height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
	
	      x = Math.floor(x);
	      width = Math.round(width);
	      var clipPath = new Rect({
	        shape: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        }
	      });
	
	      if (hasAnimation) {
	        var baseAxis = cartesian.getBaseAxis();
	        var isHorizontal = baseAxis.isHorizontal();
	        var isAxisInversed = baseAxis.inverse;
	
	        if (isHorizontal) {
	          if (isAxisInversed) {
	            clipPath.shape.x += width;
	          }
	
	          clipPath.shape.width = 0;
	        } else {
	          if (!isAxisInversed) {
	            clipPath.shape.y += height;
	          }
	
	          clipPath.shape.height = 0;
	        }
	
	        var duringCb = isFunction(during) ? function (percent) {
	          during(percent, clipPath);
	        } : null;
	        initProps(clipPath, {
	          shape: {
	            width: width,
	            height: height,
	            x: x,
	            y: y
	          }
	        }, seriesModel, null, done, duringCb);
	      }
	
	      return clipPath;
	    }
	
	    function createPolarClipPath(polar, hasAnimation, seriesModel) {
	      var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	
	      var r0 = round(sectorArea.r0, 1);
	      var r = round(sectorArea.r, 1);
	      var clipPath = new Sector({
	        shape: {
	          cx: round(polar.cx, 1),
	          cy: round(polar.cy, 1),
	          r0: r0,
	          r: r,
	          startAngle: sectorArea.startAngle,
	          endAngle: sectorArea.endAngle,
	          clockwise: sectorArea.clockwise
	        }
	      });
	
	      if (hasAnimation) {
	        var isRadial = polar.getBaseAxis().dim === 'angle';
	
	        if (isRadial) {
	          clipPath.shape.endAngle = sectorArea.startAngle;
	        } else {
	          clipPath.shape.r = r0;
	        }
	
	        initProps(clipPath, {
	          shape: {
	            endAngle: sectorArea.endAngle,
	            r: r
	          }
	        }, seriesModel);
	      }
	
	      return clipPath;
	    }
	
	    function createClipPath(coordSys, hasAnimation, seriesModel, done, during) {
	      if (!coordSys) {
	        return null;
	      } else if (coordSys.type === 'polar') {
	        return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	      } else if (coordSys.type === 'cartesian2d') {
	        return createGridClipPath(coordSys, hasAnimation, seriesModel, done, during);
	      }
	
	      return null;
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function isCoordinateSystemType(coordSys, type) {
	      return coordSys.type === type;
	    }
	
	    function isPointsSame(points1, points2) {
	      if (points1.length !== points2.length) {
	        return;
	      }
	
	      for (var i = 0; i < points1.length; i++) {
	        if (points1[i] !== points2[i]) {
	          return;
	        }
	      }
	
	      return true;
	    }
	
	    function bboxFromPoints(points) {
	      var minX = Infinity;
	      var minY = Infinity;
	      var maxX = -Infinity;
	      var maxY = -Infinity;
	
	      for (var i = 0; i < points.length;) {
	        var x = points[i++];
	        var y = points[i++];
	
	        if (!isNaN(x)) {
	          minX = Math.min(x, minX);
	          maxX = Math.max(x, maxX);
	        }
	
	        if (!isNaN(y)) {
	          minY = Math.min(y, minY);
	          maxY = Math.max(y, maxY);
	        }
	      }
	
	      return [[minX, minY], [maxX, maxY]];
	    }
	
	    function getBoundingDiff(points1, points2) {
	      var _a = bboxFromPoints(points1),
	          min1 = _a[0],
	          max1 = _a[1];
	
	      var _b = bboxFromPoints(points2),
	          min2 = _b[0],
	          max2 = _b[1]; // Get a max value from each corner of two boundings.
	
	
	      return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
	    }
	
	    function getSmooth(smooth) {
	      return isNumber(smooth) ? smooth : smooth ? 0.5 : 0;
	    }
	
	    function getStackedOnPoints(coordSys, data, dataCoordInfo) {
	      if (!dataCoordInfo.valueDim) {
	        return [];
	      }
	
	      var len = data.count();
	      var points = createFloat32Array(len * 2);
	
	      for (var idx = 0; idx < len; idx++) {
	        var pt = getStackedOnPoint(dataCoordInfo, coordSys, data, idx);
	        points[idx * 2] = pt[0];
	        points[idx * 2 + 1] = pt[1];
	      }
	
	      return points;
	    }
	
	    function turnPointsIntoStep(points, coordSys, stepTurnAt, connectNulls) {
	      var baseAxis = coordSys.getBaseAxis();
	      var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
	      var stepPoints = [];
	      var i = 0;
	      var stepPt = [];
	      var pt = [];
	      var nextPt = [];
	      var filteredPoints = [];
	
	      if (connectNulls) {
	        for (i = 0; i < points.length; i += 2) {
	          if (!isNaN(points[i]) && !isNaN(points[i + 1])) {
	            filteredPoints.push(points[i], points[i + 1]);
	          }
	        }
	
	        points = filteredPoints;
	      }
	
	      for (i = 0; i < points.length - 2; i += 2) {
	        nextPt[0] = points[i + 2];
	        nextPt[1] = points[i + 3];
	        pt[0] = points[i];
	        pt[1] = points[i + 1];
	        stepPoints.push(pt[0], pt[1]);
	
	        switch (stepTurnAt) {
	          case 'end':
	            stepPt[baseIndex] = nextPt[baseIndex];
	            stepPt[1 - baseIndex] = pt[1 - baseIndex];
	            stepPoints.push(stepPt[0], stepPt[1]);
	            break;
	
	          case 'middle':
	            var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
	            var stepPt2 = [];
	            stepPt[baseIndex] = stepPt2[baseIndex] = middle;
	            stepPt[1 - baseIndex] = pt[1 - baseIndex];
	            stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
	            stepPoints.push(stepPt[0], stepPt[1]);
	            stepPoints.push(stepPt2[0], stepPt2[1]);
	            break;
	
	          default:
	            // default is start
	            stepPt[baseIndex] = pt[baseIndex];
	            stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
	            stepPoints.push(stepPt[0], stepPt[1]);
	        }
	      } // Last points
	
	
	      stepPoints.push(points[i++], points[i++]);
	      return stepPoints;
	    }
	    /**
	     * Clip color stops to edge. Avoid creating too large gradients.
	     * Which may lead to blurry when GPU acceleration is enabled. See #15680
	     *
	     * The stops has been sorted from small to large.
	     */
	
	
	    function clipColorStops(colorStops, maxSize) {
	      var newColorStops = [];
	      var len = colorStops.length; // coord will always < 0 in prevOutOfRangeColorStop.
	
	      var prevOutOfRangeColorStop;
	      var prevInRangeColorStop;
	
	      function lerpStop(stop0, stop1, clippedCoord) {
	        var coord0 = stop0.coord;
	        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
	        var color = lerp$1(p, [stop0.color, stop1.color]);
	        return {
	          coord: clippedCoord,
	          color: color
	        };
	      }
	
	      for (var i = 0; i < len; i++) {
	        var stop_1 = colorStops[i];
	        var coord = stop_1.coord;
	
	        if (coord < 0) {
	          prevOutOfRangeColorStop = stop_1;
	        } else if (coord > maxSize) {
	          if (prevInRangeColorStop) {
	            newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
	          } else if (prevOutOfRangeColorStop) {
	            // If there are two stops and coord range is between these two stops
	            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
	          } // All following stop will be out of range. So just ignore them.
	
	
	          break;
	        } else {
	          if (prevOutOfRangeColorStop) {
	            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0)); // Reset
	
	            prevOutOfRangeColorStop = null;
	          }
	
	          newColorStops.push(stop_1);
	          prevInRangeColorStop = stop_1;
	        }
	      }
	
	      return newColorStops;
	    }
	
	    function getVisualGradient(data, coordSys, api) {
	      var visualMetaList = data.getVisual('visualMeta');
	
	      if (!visualMetaList || !visualMetaList.length || !data.count()) {
	        // When data.count() is 0, gradient range can not be calculated.
	        return;
	      }
	
	      if (coordSys.type !== 'cartesian2d') {
	        if (true) {
	          console.warn('Visual map on line style is only supported on cartesian2d.');
	        }
	
	        return;
	      }
	
	      var coordDim;
	      var visualMeta;
	
	      for (var i = visualMetaList.length - 1; i >= 0; i--) {
	        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
	        coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
	
	        if (coordDim === 'x' || coordDim === 'y') {
	          visualMeta = visualMetaList[i];
	          break;
	        }
	      }
	
	      if (!visualMeta) {
	        if (true) {
	          console.warn('Visual map on line style only support x or y dimension.');
	        }
	
	        return;
	      } // If the area to be rendered is bigger than area defined by LinearGradient,
	      // the canvas spec prescribes that the color of the first stop and the last
	      // stop should be used. But if two stops are added at offset 0, in effect
	      // browsers use the color of the second stop to render area outside
	      // LinearGradient. So we can only infinitesimally extend area defined in
	      // LinearGradient to render `outerColors`.
	
	
	      var axis = coordSys.getAxis(coordDim); // dataToCoord mapping may not be linear, but must be monotonic.
	
	      var colorStops = map(visualMeta.stops, function (stop) {
	        // offset will be calculated later.
	        return {
	          coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
	          color: stop.color
	        };
	      });
	      var stopLen = colorStops.length;
	      var outerColors = visualMeta.outerColors.slice();
	
	      if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
	        colorStops.reverse();
	        outerColors.reverse();
	      }
	
	      var colorStopsInRange = clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
	      var inRangeStopLen = colorStopsInRange.length;
	
	      if (!inRangeStopLen && stopLen) {
	        // All stops are out of range. All will be the same color.
	        return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
	      }
	
	      var tinyExtent = 10; // Arbitrary value: 10px
	
	      var minCoord = colorStopsInRange[0].coord - tinyExtent;
	      var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
	      var coordSpan = maxCoord - minCoord;
	
	      if (coordSpan < 1e-3) {
	        return 'transparent';
	      }
	
	      each(colorStopsInRange, function (stop) {
	        stop.offset = (stop.coord - minCoord) / coordSpan;
	      });
	      colorStopsInRange.push({
	        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
	        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
	        color: outerColors[1] || 'transparent'
	      });
	      colorStopsInRange.unshift({
	        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
	        color: outerColors[0] || 'transparent'
	      });
	      var gradient = new LinearGradient(0, 0, 0, 0, colorStopsInRange, true);
	      gradient[coordDim] = minCoord;
	      gradient[coordDim + '2'] = maxCoord;
	      return gradient;
	    }
	
	    function getIsIgnoreFunc(seriesModel, data, coordSys) {
	      var showAllSymbol = seriesModel.get('showAllSymbol');
	      var isAuto = showAllSymbol === 'auto';
	
	      if (showAllSymbol && !isAuto) {
	        return;
	      }
	
	      var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	      if (!categoryAxis) {
	        return;
	      } // Note that category label interval strategy might bring some weird effect
	      // in some scenario: users may wonder why some of the symbols are not
	      // displayed. So we show all symbols as possible as we can.
	
	
	      if (isAuto // Simplify the logic, do not determine label overlap here.
	      && canShowAllSymbolForCategory(categoryAxis, data)) {
	        return;
	      } // Otherwise follow the label interval strategy on category axis.
	
	
	      var categoryDataDim = data.mapDimension(categoryAxis.dim);
	      var labelMap = {};
	      each(categoryAxis.getViewLabels(), function (labelItem) {
	        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
	        labelMap[ordinalNumber] = 1;
	      });
	      return function (dataIndex) {
	        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
	      };
	    }
	
	    function canShowAllSymbolForCategory(categoryAxis, data) {
	      // In most cases, line is monotonous on category axis, and the label size
	      // is close with each other. So we check the symbol size and some of the
	      // label size alone with the category axis to estimate whether all symbol
	      // can be shown without overlap.
	      var axisExtent = categoryAxis.getExtent();
	      var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
	      isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
	      // Sampling some points, max 5.
	
	      var dataLen = data.count();
	      var step = Math.max(1, Math.round(dataLen / 5));
	
	      for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
	        if (Symbol.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
	        )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
	        * 1.5 > availSize) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    function isPointNull$1(x, y) {
	      return isNaN(x) || isNaN(y);
	    }
	
	    function getLastIndexNotNull(points) {
	      var len = points.length / 2;
	
	      for (; len > 0; len--) {
	        if (!isPointNull$1(points[len * 2 - 2], points[len * 2 - 1])) {
	          break;
	        }
	      }
	
	      return len - 1;
	    }
	
	    function getPointAtIndex(points, idx) {
	      return [points[idx * 2], points[idx * 2 + 1]];
	    }
	
	    function getIndexRange(points, xOrY, dim) {
	      var len = points.length / 2;
	      var dimIdx = dim === 'x' ? 0 : 1;
	      var a;
	      var b;
	      var prevIndex = 0;
	      var nextIndex = -1;
	
	      for (var i = 0; i < len; i++) {
	        b = points[i * 2 + dimIdx];
	
	        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) {
	          continue;
	        }
	
	        if (i === 0) {
	          a = b;
	          continue;
	        }
	
	        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
	          nextIndex = i;
	          break;
	        }
	
	        prevIndex = i;
	        a = b;
	      }
	
	      return {
	        range: [prevIndex, nextIndex],
	        t: (xOrY - a) / (b - a)
	      };
	    }
	
	    function anyStateShowEndLabel(seriesModel) {
	      if (seriesModel.get(['endLabel', 'show'])) {
	        return true;
	      }
	
	      for (var i = 0; i < SPECIAL_STATES.length; i++) {
	        if (seriesModel.get([SPECIAL_STATES[i], 'endLabel', 'show'])) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    function createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
	      if (isCoordinateSystemType(coordSys, 'cartesian2d')) {
	        var endLabelModel_1 = seriesModel.getModel('endLabel');
	        var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
	        var data_1 = seriesModel.getData();
	        var labelAnimationRecord_1 = {
	          lastFrameIndex: 0
	        };
	        var during = anyStateShowEndLabel(seriesModel) ? function (percent, clipRect) {
	          lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
	        } : null;
	        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
	        var clipPath = createGridClipPath(coordSys, hasAnimation, seriesModel, function () {
	          var endLabel = lineView._endLabel;
	
	          if (endLabel && hasAnimation) {
	            if (labelAnimationRecord_1.originalX != null) {
	              endLabel.attr({
	                x: labelAnimationRecord_1.originalX,
	                y: labelAnimationRecord_1.originalY
	              });
	            }
	          }
	        }, during); // Expand clip shape to avoid clipping when line value exceeds axis
	
	        if (!seriesModel.get('clip', true)) {
	          var rectShape = clipPath.shape;
	          var expandSize = Math.max(rectShape.width, rectShape.height);
	
	          if (isHorizontal) {
	            rectShape.y -= expandSize;
	            rectShape.height += expandSize * 2;
	          } else {
	            rectShape.x -= expandSize;
	            rectShape.width += expandSize * 2;
	          }
	        } // Set to the final frame. To make sure label layout is right.
	
	
	        if (during) {
	          during(1, clipPath);
	        }
	
	        return clipPath;
	      } else {
	        if (true) {
	          if (seriesModel.get(['endLabel', 'show'])) {
	            console.warn('endLabel is not supported for lines in polar systems.');
	          }
	        }
	
	        return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	      }
	    }
	
	    function getEndLabelStateSpecified(endLabelModel, coordSys) {
	      var baseAxis = coordSys.getBaseAxis();
	      var isHorizontal = baseAxis.isHorizontal();
	      var isBaseInversed = baseAxis.inverse;
	      var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
	      var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
	      return {
	        normal: {
	          align: endLabelModel.get('align') || align,
	          verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
	        }
	      };
	    }
	
	    var LineView =
	    /** @class */
	    function (_super) {
	      __extends(LineView, _super);
	
	      function LineView() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      LineView.prototype.init = function () {
	        var lineGroup = new Group();
	        var symbolDraw = new SymbolDraw();
	        this.group.add(symbolDraw.group);
	        this._symbolDraw = symbolDraw;
	        this._lineGroup = lineGroup;
	      };
	
	      LineView.prototype.render = function (seriesModel, ecModel, api) {
	        var _this = this;
	
	        var coordSys = seriesModel.coordinateSystem;
	        var group = this.group;
	        var data = seriesModel.getData();
	        var lineStyleModel = seriesModel.getModel('lineStyle');
	        var areaStyleModel = seriesModel.getModel('areaStyle');
	        var points = data.getLayout('points') || [];
	        var isCoordSysPolar = coordSys.type === 'polar';
	        var prevCoordSys = this._coordSys;
	        var symbolDraw = this._symbolDraw;
	        var polyline = this._polyline;
	        var polygon = this._polygon;
	        var lineGroup = this._lineGroup;
	        var hasAnimation = !ecModel.ssr && seriesModel.isAnimationEnabled();
	        var isAreaChart = !areaStyleModel.isEmpty();
	        var valueOrigin = areaStyleModel.get('origin');
	        var dataCoordInfo = prepareDataCoordInfo(coordSys, data, valueOrigin);
	        var stackedOnPoints = isAreaChart && getStackedOnPoints(coordSys, data, dataCoordInfo);
	        var showSymbol = seriesModel.get('showSymbol');
	        var connectNulls = seriesModel.get('connectNulls');
	        var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
	
	        var oldData = this._data;
	        oldData && oldData.eachItemGraphicEl(function (el, idx) {
	          if (el.__temp) {
	            group.remove(el);
	            oldData.setItemGraphicEl(idx, null);
	          }
	        }); // Remove previous created symbols if showSymbol changed to false
	
	        if (!showSymbol) {
	          symbolDraw.remove();
	        }
	
	        group.add(lineGroup); // FIXME step not support polar
	
	        var step = !isCoordSysPolar ? seriesModel.get('step') : false;
	        var clipShapeForSymbol;
	
	        if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
	          clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	          // See #7913 and `test/dataZoom-clip.html`.
	
	          if (clipShapeForSymbol.width != null) {
	            clipShapeForSymbol.x -= 0.1;
	            clipShapeForSymbol.y -= 0.1;
	            clipShapeForSymbol.width += 0.2;
	            clipShapeForSymbol.height += 0.2;
	          } else if (clipShapeForSymbol.r0) {
	            clipShapeForSymbol.r0 -= 0.5;
	            clipShapeForSymbol.r += 0.5;
	          }
	        }
	
	        this._clipShapeForSymbol = clipShapeForSymbol;
	        var visualColor = getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')]; // Initialization animation or coordinate system changed
	
	        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
	          showSymbol && symbolDraw.updateData(data, {
	            isIgnore: isIgnoreFunc,
	            clipShape: clipShapeForSymbol,
	            disableAnimation: true,
	            getSymbolPoint: function (idx) {
	              return [points[idx * 2], points[idx * 2 + 1]];
	            }
	          });
	          hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
	
	          if (step) {
	            // TODO If stacked series is not step
	            points = turnPointsIntoStep(points, coordSys, step, connectNulls);
	
	            if (stackedOnPoints) {
	              stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
	            }
	          }
	
	          polyline = this._newPolyline(points);
	
	          if (isAreaChart) {
	            polygon = this._newPolygon(points, stackedOnPoints);
	          } // If areaStyle is removed
	          else if (polygon) {
	              lineGroup.remove(polygon);
	              polygon = this._polygon = null;
	            } // NOTE: Must update _endLabel before setClipPath.
	
	
	          if (!isCoordSysPolar) {
	            this._initOrUpdateEndLabel(seriesModel, coordSys, convertToColorString(visualColor));
	          }
	
	          lineGroup.setClipPath(createLineClipPath(this, coordSys, true, seriesModel));
	        } else {
	          if (isAreaChart && !polygon) {
	            // If areaStyle is added
	            polygon = this._newPolygon(points, stackedOnPoints);
	          } else if (polygon && !isAreaChart) {
	            // If areaStyle is removed
	            lineGroup.remove(polygon);
	            polygon = this._polygon = null;
	          } // NOTE: Must update _endLabel before setClipPath.
	
	
	          if (!isCoordSysPolar) {
	            this._initOrUpdateEndLabel(seriesModel, coordSys, convertToColorString(visualColor));
	          } // Update clipPath
	
	
	          var oldClipPath = lineGroup.getClipPath();
	
	          if (oldClipPath) {
	            var newClipPath = createLineClipPath(this, coordSys, false, seriesModel);
	            initProps(oldClipPath, {
	              shape: newClipPath.shape
	            }, seriesModel);
	          } else {
	            lineGroup.setClipPath(createLineClipPath(this, coordSys, true, seriesModel));
	          } // Always update, or it is wrong in the case turning on legend
	          // because points are not changed.
	
	
	          showSymbol && symbolDraw.updateData(data, {
	            isIgnore: isIgnoreFunc,
	            clipShape: clipShapeForSymbol,
	            disableAnimation: true,
	            getSymbolPoint: function (idx) {
	              return [points[idx * 2], points[idx * 2 + 1]];
	            }
	          }); // In the case data zoom triggered refreshing frequently
	          // Data may not change if line has a category axis. So it should animate nothing.
	
	          if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
	            if (hasAnimation) {
	              this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
	            } else {
	              // Not do it in update with animation
	              if (step) {
	                // TODO If stacked series is not step
	                points = turnPointsIntoStep(points, coordSys, step, connectNulls);
	
	                if (stackedOnPoints) {
	                  stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
	                }
	              }
	
	              polyline.setShape({
	                points: points
	              });
	              polygon && polygon.setShape({
	                points: points,
	                stackedOnPoints: stackedOnPoints
	              });
	            }
	          }
	        }
	
	        var emphasisModel = seriesModel.getModel('emphasis');
	        var focus = emphasisModel.get('focus');
	        var blurScope = emphasisModel.get('blurScope');
	        var emphasisDisabled = emphasisModel.get('disabled');
	        polyline.useStyle(defaults( // Use color in lineStyle first
	        lineStyleModel.getLineStyle(), {
	          fill: 'none',
	          stroke: visualColor,
	          lineJoin: 'bevel'
	        }));
	        setStatesStylesFromModel(polyline, seriesModel, 'lineStyle');
	
	        if (polyline.style.lineWidth > 0 && seriesModel.get(['emphasis', 'lineStyle', 'width']) === 'bolder') {
	          var emphasisLineStyle = polyline.getState('emphasis').style;
	          emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
	        } // Needs seriesIndex for focus
	
	
	        getECData(polyline).seriesIndex = seriesModel.seriesIndex;
	        toggleHoverEmphasis(polyline, focus, blurScope, emphasisDisabled);
	        var smooth = getSmooth(seriesModel.get('smooth'));
	        var smoothMonotone = seriesModel.get('smoothMonotone');
	        polyline.setShape({
	          smooth: smooth,
	          smoothMonotone: smoothMonotone,
	          connectNulls: connectNulls
	        });
	
	        if (polygon) {
	          var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	          var stackedOnSmooth = 0;
	          polygon.useStyle(defaults(areaStyleModel.getAreaStyle(), {
	            fill: visualColor,
	            opacity: 0.7,
	            lineJoin: 'bevel',
	            decal: data.getVisual('style').decal
	          }));
	
	          if (stackedOnSeries) {
	            stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
	          }
	
	          polygon.setShape({
	            smooth: smooth,
	            stackedOnSmooth: stackedOnSmooth,
	            smoothMonotone: smoothMonotone,
	            connectNulls: connectNulls
	          });
	          setStatesStylesFromModel(polygon, seriesModel, 'areaStyle'); // Needs seriesIndex for focus
	
	          getECData(polygon).seriesIndex = seriesModel.seriesIndex;
	          toggleHoverEmphasis(polygon, focus, blurScope, emphasisDisabled);
	        }
	
	        var changePolyState = function (toState) {
	          _this._changePolyState(toState);
	        };
	
	        data.eachItemGraphicEl(function (el) {
	          // Switch polyline / polygon state if element changed its state.
	          el && (el.onHoverStateChange = changePolyState);
	        });
	        this._polyline.onHoverStateChange = changePolyState;
	        this._data = data; // Save the coordinate system for transition animation when data changed
	
	        this._coordSys = coordSys;
	        this._stackedOnPoints = stackedOnPoints;
	        this._points = points;
	        this._step = step;
	        this._valueOrigin = valueOrigin;
	
	        if (seriesModel.get('triggerLineEvent')) {
	          this.packEventData(seriesModel, polyline);
	          polygon && this.packEventData(seriesModel, polygon);
	        }
	      };
	
	      LineView.prototype.packEventData = function (seriesModel, el) {
	        getECData(el).eventData = {
	          componentType: 'series',
	          componentSubType: 'line',
	          componentIndex: seriesModel.componentIndex,
	          seriesIndex: seriesModel.seriesIndex,
	          seriesName: seriesModel.name,
	          seriesType: 'line'
	        };
	      };
	
	      LineView.prototype.highlight = function (seriesModel, ecModel, api, payload) {
	        var data = seriesModel.getData();
	        var dataIndex = queryDataIndex(data, payload);
	
	        this._changePolyState('emphasis');
	
	        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
	          var points = data.getLayout('points');
	          var symbol = data.getItemGraphicEl(dataIndex);
	
	          if (!symbol) {
	            // Create a temporary symbol if it is not exists
	            var x = points[dataIndex * 2];
	            var y = points[dataIndex * 2 + 1];
	
	            if (isNaN(x) || isNaN(y)) {
	              // Null data
	              return;
	            } // fix #11360: shouldn't draw symbol outside clipShapeForSymbol
	
	
	            if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) {
	              return;
	            }
	
	            var zlevel = seriesModel.get('zlevel') || 0;
	            var z = seriesModel.get('z') || 0;
	            symbol = new Symbol(data, dataIndex);
	            symbol.x = x;
	            symbol.y = y;
	            symbol.setZ(zlevel, z); // ensure label text of the temporary symbol is in front of line and area polygon
	
	            var symbolLabel = symbol.getSymbolPath().getTextContent();
	
	            if (symbolLabel) {
	              symbolLabel.zlevel = zlevel;
	              symbolLabel.z = z;
	              symbolLabel.z2 = this._polyline.z2 + 1;
	            }
	
	            symbol.__temp = true;
	            data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
	
	            symbol.stopSymbolAnimation(true);
	            this.group.add(symbol);
	          }
	
	          symbol.highlight();
	        } else {
	          // Highlight whole series
	          ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
	        }
	      };
	
	      LineView.prototype.downplay = function (seriesModel, ecModel, api, payload) {
	        var data = seriesModel.getData();
	        var dataIndex = queryDataIndex(data, payload);
	
	        this._changePolyState('normal');
	
	        if (dataIndex != null && dataIndex >= 0) {
	          var symbol = data.getItemGraphicEl(dataIndex);
	
	          if (symbol) {
	            if (symbol.__temp) {
	              data.setItemGraphicEl(dataIndex, null);
	              this.group.remove(symbol);
	            } else {
	              symbol.downplay();
	            }
	          }
	        } else {
	          // FIXME
	          // can not downplay completely.
	          // Downplay whole series
	          ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
	        }
	      };
	
	      LineView.prototype._changePolyState = function (toState) {
	        var polygon = this._polygon;
	        setStatesFlag(this._polyline, toState);
	        polygon && setStatesFlag(polygon, toState);
	      };
	
	      LineView.prototype._newPolyline = function (points) {
	        var polyline = this._polyline; // Remove previous created polyline
	
	        if (polyline) {
	          this._lineGroup.remove(polyline);
	        }
	
	        polyline = new ECPolyline({
	          shape: {
	            points: points
	          },
	          segmentIgnoreThreshold: 2,
	          z2: 10
	        });
	
	        this._lineGroup.add(polyline);
	
	        this._polyline = polyline;
	        return polyline;
	      };
	
	      LineView.prototype._newPolygon = function (points, stackedOnPoints) {
	        var polygon = this._polygon; // Remove previous created polygon
	
	        if (polygon) {
	          this._lineGroup.remove(polygon);
	        }
	
	        polygon = new ECPolygon({
	          shape: {
	            points: points,
	            stackedOnPoints: stackedOnPoints
	          },
	          segmentIgnoreThreshold: 2
	        });
	
	        this._lineGroup.add(polygon);
	
	        this._polygon = polygon;
	        return polygon;
	      };
	
	      LineView.prototype._initSymbolLabelAnimation = function (data, coordSys, clipShape) {
	        var isHorizontalOrRadial;
	        var isCoordSysPolar;
	        var baseAxis = coordSys.getBaseAxis();
	        var isAxisInverse = baseAxis.inverse;
	
	        if (coordSys.type === 'cartesian2d') {
	          isHorizontalOrRadial = baseAxis.isHorizontal();
	          isCoordSysPolar = false;
	        } else if (coordSys.type === 'polar') {
	          isHorizontalOrRadial = baseAxis.dim === 'angle';
	          isCoordSysPolar = true;
	        }
	
	        var seriesModel = data.hostModel;
	        var seriesDuration = seriesModel.get('animationDuration');
	
	        if (isFunction(seriesDuration)) {
	          seriesDuration = seriesDuration(null);
	        }
	
	        var seriesDelay = seriesModel.get('animationDelay') || 0;
	        var seriesDelayValue = isFunction(seriesDelay) ? seriesDelay(null) : seriesDelay;
	        data.eachItemGraphicEl(function (symbol, idx) {
	          var el = symbol;
	
	          if (el) {
	            var point = [symbol.x, symbol.y];
	            var start = void 0;
	            var end = void 0;
	            var current = void 0;
	
	            if (clipShape) {
	              if (isCoordSysPolar) {
	                var polarClip = clipShape;
	                var coord = coordSys.pointToCoord(point);
	
	                if (isHorizontalOrRadial) {
	                  start = polarClip.startAngle;
	                  end = polarClip.endAngle;
	                  current = -coord[1] / 180 * Math.PI;
	                } else {
	                  start = polarClip.r0;
	                  end = polarClip.r;
	                  current = coord[0];
	                }
	              } else {
	                var gridClip = clipShape;
	
	                if (isHorizontalOrRadial) {
	                  start = gridClip.x;
	                  end = gridClip.x + gridClip.width;
	                  current = symbol.x;
	                } else {
	                  start = gridClip.y + gridClip.height;
	                  end = gridClip.y;
	                  current = symbol.y;
	                }
	              }
	            }
	
	            var ratio = end === start ? 0 : (current - start) / (end - start);
	
	            if (isAxisInverse) {
	              ratio = 1 - ratio;
	            }
	
	            var delay = isFunction(seriesDelay) ? seriesDelay(idx) : seriesDuration * ratio + seriesDelayValue;
	            var symbolPath = el.getSymbolPath();
	            var text = symbolPath.getTextContent();
	            el.attr({
	              scaleX: 0,
	              scaleY: 0
	            });
	            el.animateTo({
	              scaleX: 1,
	              scaleY: 1
	            }, {
	              duration: 200,
	              setToFinal: true,
	              delay: delay
	            });
	
	            if (text) {
	              text.animateFrom({
	                style: {
	                  opacity: 0
	                }
	              }, {
	                duration: 300,
	                delay: delay
	              });
	            }
	
	            symbolPath.disableLabelAnimation = true;
	          }
	        });
	      };
	
	      LineView.prototype._initOrUpdateEndLabel = function (seriesModel, coordSys, inheritColor) {
	        var endLabelModel = seriesModel.getModel('endLabel');
	
	        if (anyStateShowEndLabel(seriesModel)) {
	          var data_2 = seriesModel.getData();
	          var polyline = this._polyline; // series may be filtered.
	
	          var points = data_2.getLayout('points');
	
	          if (!points) {
	            polyline.removeTextContent();
	            this._endLabel = null;
	            return;
	          }
	
	          var endLabel = this._endLabel;
	
	          if (!endLabel) {
	            endLabel = this._endLabel = new ZRText({
	              z2: 200 // should be higher than item symbol
	
	            });
	            endLabel.ignoreClip = true;
	            polyline.setTextContent(this._endLabel);
	            polyline.disableLabelAnimation = true;
	          } // Find last non-NaN data to display data
	
	
	          var dataIndex = getLastIndexNotNull(points);
	
	          if (dataIndex >= 0) {
	            setLabelStyle(polyline, getLabelStatesModels(seriesModel, 'endLabel'), {
	              inheritColor: inheritColor,
	              labelFetcher: seriesModel,
	              labelDataIndex: dataIndex,
	              defaultText: function (dataIndex, opt, interpolatedValue) {
	                return interpolatedValue != null ? getDefaultInterpolatedLabel(data_2, interpolatedValue) : getDefaultLabel(data_2, dataIndex);
	              },
	              enableTextSetter: true
	            }, getEndLabelStateSpecified(endLabelModel, coordSys));
	            polyline.textConfig.position = null;
	          }
	        } else if (this._endLabel) {
	          this._polyline.removeTextContent();
	
	          this._endLabel = null;
	        }
	      };
	
	      LineView.prototype._endLabelOnDuring = function (percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
	        var endLabel = this._endLabel;
	        var polyline = this._polyline;
	
	        if (endLabel) {
	          // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
	          // The label is not prepared at this time.
	          if (percent < 1 && animationRecord.originalX == null) {
	            animationRecord.originalX = endLabel.x;
	            animationRecord.originalY = endLabel.y;
	          }
	
	          var points = data.getLayout('points');
	          var seriesModel = data.hostModel;
	          var connectNulls = seriesModel.get('connectNulls');
	          var precision = endLabelModel.get('precision');
	          var distance = endLabelModel.get('distance') || 0;
	          var baseAxis = coordSys.getBaseAxis();
	          var isHorizontal = baseAxis.isHorizontal();
	          var isBaseInversed = baseAxis.inverse;
	          var clipShape = clipRect.shape;
	          var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
	          var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
	          var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
	          var dim = isHorizontal ? 'x' : 'y';
	          var dataIndexRange = getIndexRange(points, xOrY, dim);
	          var indices = dataIndexRange.range;
	          var diff = indices[1] - indices[0];
	          var value = void 0;
	
	          if (diff >= 1) {
	            // diff > 1 && connectNulls, which is on the null data.
	            if (diff > 1 && !connectNulls) {
	              var pt = getPointAtIndex(points, indices[0]);
	              endLabel.attr({
	                x: pt[0] + distanceX,
	                y: pt[1] + distanceY
	              });
	              valueAnimation && (value = seriesModel.getRawValue(indices[0]));
	            } else {
	              var pt = polyline.getPointOn(xOrY, dim);
	              pt && endLabel.attr({
	                x: pt[0] + distanceX,
	                y: pt[1] + distanceY
	              });
	              var startValue = seriesModel.getRawValue(indices[0]);
	              var endValue = seriesModel.getRawValue(indices[1]);
	              valueAnimation && (value = interpolateRawValues(data, precision, startValue, endValue, dataIndexRange.t));
	            }
	
	            animationRecord.lastFrameIndex = indices[0];
	          } else {
	            // If diff <= 0, which is the range is not found(Include NaN)
	            // Choose the first point or last point.
	            var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
	            var pt = getPointAtIndex(points, idx);
	            valueAnimation && (value = seriesModel.getRawValue(idx));
	            endLabel.attr({
	              x: pt[0] + distanceX,
	              y: pt[1] + distanceY
	            });
	          }
	
	          if (valueAnimation) {
	            var inner = labelInner(endLabel);
	
	            if (typeof inner.setLabelText === 'function') {
	              inner.setLabelText(value);
	            }
	          }
	        }
	      };
	      /**
	       * @private
	       */
	      // FIXME Two value axis
	
	
	      LineView.prototype._doUpdateAnimation = function (data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
	        var polyline = this._polyline;
	        var polygon = this._polygon;
	        var seriesModel = data.hostModel;
	        var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin);
	        var current = diff.current;
	        var stackedOnCurrent = diff.stackedOnCurrent;
	        var next = diff.next;
	        var stackedOnNext = diff.stackedOnNext;
	
	        if (step) {
	          // TODO If stacked series is not step
	          current = turnPointsIntoStep(diff.current, coordSys, step, connectNulls);
	          stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step, connectNulls);
	          next = turnPointsIntoStep(diff.next, coordSys, step, connectNulls);
	          stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step, connectNulls);
	        } // Don't apply animation if diff is large.
	        // For better result and avoid memory explosion problems like
	        // https://github.com/apache/incubator-echarts/issues/12229
	
	
	        if (getBoundingDiff(current, next) > 3000 || polygon && getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
	          polyline.stopAnimation();
	          polyline.setShape({
	            points: next
	          });
	
	          if (polygon) {
	            polygon.stopAnimation();
	            polygon.setShape({
	              points: next,
	              stackedOnPoints: stackedOnNext
	            });
	          }
	
	          return;
	        }
	
	        polyline.shape.__points = diff.current;
	        polyline.shape.points = current;
	        var target = {
	          shape: {
	            points: next
	          }
	        }; // Also animate the original points.
	        // If points reference is changed when turning into step line.
	
	        if (diff.current !== current) {
	          target.shape.__points = diff.next;
	        } // Stop previous animation.
	
	
	        polyline.stopAnimation();
	        updateProps(polyline, target, seriesModel);
	
	        if (polygon) {
	          polygon.setShape({
	            // Reuse the points with polyline.
	            points: current,
	            stackedOnPoints: stackedOnCurrent
	          });
	          polygon.stopAnimation();
	          updateProps(polygon, {
	            shape: {
	              stackedOnPoints: stackedOnNext
	            }
	          }, seriesModel); // If use attr directly in updateProps.
	
	          if (polyline.shape.points !== polygon.shape.points) {
	            polygon.shape.points = polyline.shape.points;
	          }
	        }
	
	        var updatedDataInfo = [];
	        var diffStatus = diff.status;
	
	        for (var i = 0; i < diffStatus.length; i++) {
	          var cmd = diffStatus[i].cmd;
	
	          if (cmd === '=') {
	            var el = data.getItemGraphicEl(diffStatus[i].idx1);
	
	            if (el) {
	              updatedDataInfo.push({
	                el: el,
	                ptIdx: i // Index of points
	
	              });
	            }
	          }
	        }
	
	        if (polyline.animators && polyline.animators.length) {
	          polyline.animators[0].during(function () {
	            polygon && polygon.dirtyShape();
	            var points = polyline.shape.__points;
	
	            for (var i = 0; i < updatedDataInfo.length; i++) {
	              var el = updatedDataInfo[i].el;
	              var offset = updatedDataInfo[i].ptIdx * 2;
	              el.x = points[offset];
	              el.y = points[offset + 1];
	              el.markRedraw();
	            }
	          });
	        }
	      };
	
	      LineView.prototype.remove = function (ecModel) {
	        var group = this.group;
	        var oldData = this._data;
	
	        this._lineGroup.removeAll();
	
	        this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
	
	
	        oldData && oldData.eachItemGraphicEl(function (el, idx) {
	          if (el.__temp) {
	            group.remove(el);
	            oldData.setItemGraphicEl(idx, null);
	          }
	        });
	        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
	      };
	
	      LineView.type = 'line';
	      return LineView;
	    }(ChartView);
	
	    function pointsLayout(seriesType, forceStoreInTypedArray) {
	      return {
	        seriesType: seriesType,
	        plan: createRenderPlanner(),
	        reset: function (seriesModel) {
	          var data = seriesModel.getData();
	          var coordSys = seriesModel.coordinateSystem;
	          var pipelineContext = seriesModel.pipelineContext;
	          var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
	
	          if (!coordSys) {
	            return;
	          }
	
	          var dims = map(coordSys.dimensions, function (dim) {
	            return data.mapDimension(dim);
	          }).slice(0, 2);
	          var dimLen = dims.length;
	          var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	          if (isDimensionStacked(data, dims[0])) {
	            dims[0] = stackResultDim;
	          }
	
	          if (isDimensionStacked(data, dims[1])) {
	            dims[1] = stackResultDim;
	          }
	
	          var store = data.getStore();
	          var dimIdx0 = data.getDimensionIndex(dims[0]);
	          var dimIdx1 = data.getDimensionIndex(dims[1]);
	          return dimLen && {
	            progress: function (params, data) {
	              var segCount = params.end - params.start;
	              var points = useTypedArray && createFloat32Array(segCount * dimLen);
	              var tmpIn = [];
	              var tmpOut = [];
	
	              for (var i = params.start, offset = 0; i < params.end; i++) {
	                var point = void 0;
	
	                if (dimLen === 1) {
	                  var x = store.get(dimIdx0, i); // NOTE: Make sure the second parameter is null to use default strategy.
	
	                  point = coordSys.dataToPoint(x, null, tmpOut);
	                } else {
	                  tmpIn[0] = store.get(dimIdx0, i);
	                  tmpIn[1] = store.get(dimIdx1, i); // Let coordinate system to handle the NaN data.
	
	                  point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	                }
	
	                if (useTypedArray) {
	                  points[offset++] = point[0];
	                  points[offset++] = point[1];
	                } else {
	                  data.setItemLayout(i, point.slice());
	                }
	              }
	
	              useTypedArray && data.setLayout('points', points);
	            }
	          };
	        }
	      };
	    }
	
	    var samplers = {
	      average: function (frame) {
	        var sum = 0;
	        var count = 0;
	
	        for (var i = 0; i < frame.length; i++) {
	          if (!isNaN(frame[i])) {
	            sum += frame[i];
	            count++;
	          }
	        } // Return NaN if count is 0
	
	
	        return count === 0 ? NaN : sum / count;
	      },
	      sum: function (frame) {
	        var sum = 0;
	
	        for (var i = 0; i < frame.length; i++) {
	          // Ignore NaN
	          sum += frame[i] || 0;
	        }
	
	        return sum;
	      },
	      max: function (frame) {
	        var max = -Infinity;
	
	        for (var i = 0; i < frame.length; i++) {
	          frame[i] > max && (max = frame[i]);
	        } // NaN will cause illegal axis extent.
	
	
	        return isFinite(max) ? max : NaN;
	      },
	      min: function (frame) {
	        var min = Infinity;
	
	        for (var i = 0; i < frame.length; i++) {
	          frame[i] < min && (min = frame[i]);
	        } // NaN will cause illegal axis extent.
	
	
	        return isFinite(min) ? min : NaN;
	      },
	      // TODO
	      // Median
	      nearest: function (frame) {
	        return frame[0];
	      }
	    };
	
	    var indexSampler = function (frame) {
	      return Math.round(frame.length / 2);
	    };
	
	    function dataSample(seriesType) {
	      return {
	        seriesType: seriesType,
	        // FIXME:TS never used, so comment it
	        // modifyOutputEnd: true,
	        reset: function (seriesModel, ecModel, api) {
	          var data = seriesModel.getData();
	          var sampling = seriesModel.get('sampling');
	          var coordSys = seriesModel.coordinateSystem;
	          var count = data.count(); // Only cartesian2d support down sampling. Disable it when there is few data.
	
	          if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
	            var baseAxis = coordSys.getBaseAxis();
	            var valueAxis = coordSys.getOtherAxis(baseAxis);
	            var extent = baseAxis.getExtent();
	            var dpr = api.getDevicePixelRatio(); // Coordinste system has been resized
	
	            var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
	            var rate = Math.round(count / size);
	
	            if (isFinite(rate) && rate > 1) {
	              if (sampling === 'lttb') {
	                seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
	              }
	
	              var sampler = void 0;
	
	              if (isString(sampling)) {
	                sampler = samplers[sampling];
	              } else if (isFunction(sampling)) {
	                sampler = sampling;
	              }
	
	              if (sampler) {
	                // Only support sample the first dim mapped from value axis.
	                seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
	              }
	            }
	          }
	        }
	      };
	    }
	
	    function install$2(registers) {
	      registers.registerChartView(LineView);
	      registers.registerSeriesModel(LineSeriesModel);
	      registers.registerLayout(pointsLayout('line', true));
	      registers.registerVisual({
	        seriesType: 'line',
	        reset: function (seriesModel) {
	          var data = seriesModel.getData(); // Visual coding for legend
	
	          var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
	
	          if (lineStyle && !lineStyle.stroke) {
	            // Fill in visual should be palette color if
	            // has color callback
	            lineStyle.stroke = data.getVisual('style').fill;
	          }
	
	          data.setVisual('legendLineStyle', lineStyle);
	        }
	      }); // Down sample after filter
	
	      registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, dataSample('line'));
	    }
	
	    var BaseBarSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(BaseBarSeriesModel, _super);
	
	      function BaseBarSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = BaseBarSeriesModel.type;
	        return _this;
	      }
	
	      BaseBarSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return createSeriesData(null, this, {
	          useEncodeDefaulter: true
	        });
	      };
	
	      BaseBarSeriesModel.prototype.getMarkerPosition = function (value, dims, startingAtTick) {
	        var coordSys = this.coordinateSystem;
	
	        if (coordSys && coordSys.clampData) {
	          // PENDING if clamp ?
	          var clampData_1 = coordSys.clampData(value);
	          var pt_1 = coordSys.dataToPoint(clampData_1);
	
	          if (startingAtTick) {
	            each(coordSys.getAxes(), function (axis, idx) {
	              // If axis type is category, use tick coords instead
	              if (axis.type === 'category' && dims != null) {
	                var tickCoords = axis.getTicksCoords();
	                var targetTickId = clampData_1[idx]; // The index of rightmost tick of markArea is 1 larger than x1/y1 index
	
	                var isEnd = dims[idx] === 'x1' || dims[idx] === 'y1';
	
	                if (isEnd) {
	                  targetTickId += 1;
	                } // The only contains one tick, tickCoords is
	                // like [{coord: 0, tickValue: 0}, {coord: 0}]
	                // to the length should always be larger than 1
	
	
	                if (tickCoords.length < 2) {
	                  return;
	                } else if (tickCoords.length === 2) {
	                  // The left value and right value of the axis are
	                  // the same. coord is 0 in both items. Use the max
	                  // value of the axis as the coord
	                  pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
	                  return;
	                }
	
	                var leftCoord = void 0;
	                var coord = void 0;
	                var stepTickValue = 1;
	
	                for (var i = 0; i < tickCoords.length; i++) {
	                  var tickCoord = tickCoords[i].coord; // The last item of tickCoords doesn't contain
	                  // tickValue
	
	                  var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
	
	                  if (tickValue === targetTickId) {
	                    coord = tickCoord;
	                    break;
	                  } else if (tickValue < targetTickId) {
	                    leftCoord = tickCoord;
	                  } else if (leftCoord != null && tickValue > targetTickId) {
	                    coord = (tickCoord + leftCoord) / 2;
	                    break;
	                  }
	
	                  if (i === 1) {
	                    // Here we assume the step of category axes is
	                    // the same
	                    stepTickValue = tickValue - tickCoords[0].tickValue;
	                  }
	                }
	
	                if (coord == null) {
	                  if (!leftCoord) {
	                    // targetTickId is smaller than all tick ids in the
	                    // visible area, use the leftmost tick coord
	                    coord = tickCoords[0].coord;
	                  } else if (leftCoord) {
	                    // targetTickId is larger than all tick ids in the
	                    // visible area, use the rightmost tick coord
	                    coord = tickCoords[tickCoords.length - 1].coord;
	                  }
	                }
	
	                pt_1[idx] = axis.toGlobalCoord(coord);
	              }
	            });
	          } else {
	            var data = this.getData();
	            var offset = data.getLayout('offset');
	            var size = data.getLayout('size');
	            var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
	            pt_1[offsetIndex] += offset + size / 2;
	          }
	
	          return pt_1;
	        }
	
	        return [NaN, NaN];
	      };
	
	      BaseBarSeriesModel.type = 'series.__base_bar__';
	      BaseBarSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        coordinateSystem: 'cartesian2d',
	        legendHoverLink: true,
	        // stack: null
	        // Cartesian coordinate system
	        // xAxisIndex: 0,
	        // yAxisIndex: 0,
	        barMinHeight: 0,
	        barMinAngle: 0,
	        // cursor: null,
	        large: false,
	        largeThreshold: 400,
	        progressive: 3e3,
	        progressiveChunkMode: 'mod'
	      };
	      return BaseBarSeriesModel;
	    }(SeriesModel);
	
	    SeriesModel.registerClass(BaseBarSeriesModel);
	
	    var BarSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(BarSeriesModel, _super);
	
	      function BarSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = BarSeriesModel.type;
	        return _this;
	      }
	
	      BarSeriesModel.prototype.getInitialData = function () {
	        return createSeriesData(null, this, {
	          useEncodeDefaulter: true,
	          createInvertedIndices: !!this.get('realtimeSort', true) || null
	        });
	      };
	      /**
	       * @override
	       */
	
	
	      BarSeriesModel.prototype.getProgressive = function () {
	        // Do not support progressive in normal mode.
	        return this.get('large') ? this.get('progressive') : false;
	      };
	      /**
	       * @override
	       */
	
	
	      BarSeriesModel.prototype.getProgressiveThreshold = function () {
	        // Do not support progressive in normal mode.
	        var progressiveThreshold = this.get('progressiveThreshold');
	        var largeThreshold = this.get('largeThreshold');
	
	        if (largeThreshold > progressiveThreshold) {
	          progressiveThreshold = largeThreshold;
	        }
	
	        return progressiveThreshold;
	      };
	
	      BarSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
	        return selectors.rect(data.getItemLayout(dataIndex));
	      };
	
	      BarSeriesModel.type = 'series.bar';
	      BarSeriesModel.dependencies = ['grid', 'polar'];
	      BarSeriesModel.defaultOption = inheritDefaultOption(BaseBarSeriesModel.defaultOption, {
	        // If clipped
	        // Only available on cartesian2d
	        clip: true,
	        roundCap: false,
	        showBackground: false,
	        backgroundStyle: {
	          color: 'rgba(180, 180, 180, 0.2)',
	          borderColor: null,
	          borderWidth: 0,
	          borderType: 'solid',
	          borderRadius: 0,
	          shadowBlur: 0,
	          shadowColor: null,
	          shadowOffsetX: 0,
	          shadowOffsetY: 0,
	          opacity: 1
	        },
	        select: {
	          itemStyle: {
	            borderColor: '#212121'
	          }
	        },
	        realtimeSort: false
	      });
	      return BarSeriesModel;
	    }(BaseBarSeriesModel);
	
	    /**
	     * Sausage: similar to sector, but have half circle on both sides
	     */
	
	    var SausageShape =
	    /** @class */
	    function () {
	      function SausageShape() {
	        this.cx = 0;
	        this.cy = 0;
	        this.r0 = 0;
	        this.r = 0;
	        this.startAngle = 0;
	        this.endAngle = Math.PI * 2;
	        this.clockwise = true;
	      }
	
	      return SausageShape;
	    }();
	
	    var SausagePath =
	    /** @class */
	    function (_super) {
	      __extends(SausagePath, _super);
	
	      function SausagePath(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this.type = 'sausage';
	        return _this;
	      }
	
	      SausagePath.prototype.getDefaultShape = function () {
	        return new SausageShape();
	      };
	
	      SausagePath.prototype.buildPath = function (ctx, shape) {
	        var cx = shape.cx;
	        var cy = shape.cy;
	        var r0 = Math.max(shape.r0 || 0, 0);
	        var r = Math.max(shape.r, 0);
	        var dr = (r - r0) * 0.5;
	        var rCenter = r0 + dr;
	        var startAngle = shape.startAngle;
	        var endAngle = shape.endAngle;
	        var clockwise = shape.clockwise;
	        var PI2 = Math.PI * 2;
	        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
	
	        if (!lessThanCircle) {
	          // Normalize angles
	          startAngle = endAngle - (clockwise ? PI2 : -PI2);
	        }
	
	        var unitStartX = Math.cos(startAngle);
	        var unitStartY = Math.sin(startAngle);
	        var unitEndX = Math.cos(endAngle);
	        var unitEndY = Math.sin(endAngle);
	
	        if (lessThanCircle) {
	          ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
	          ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
	        } else {
	          ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
	        }
	
	        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
	        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
	
	        if (r0 !== 0) {
	          ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
	        } // ctx.closePath();
	
	      };
	
	      return SausagePath;
	    }(Path);
	
	    function createSectorCalculateTextPosition(positionMapping, opts) {
	      opts = opts || {};
	      var isRoundCap = opts.isRoundCap;
	      return function (out, opts, boundingRect) {
	        var textPosition = opts.position;
	
	        if (!textPosition || textPosition instanceof Array) {
	          return calculateTextPosition(out, opts, boundingRect);
	        }
	
	        var mappedSectorPosition = positionMapping(textPosition);
	        var distance = opts.distance != null ? opts.distance : 5;
	        var sector = this.shape;
	        var cx = sector.cx;
	        var cy = sector.cy;
	        var r = sector.r;
	        var r0 = sector.r0;
	        var middleR = (r + r0) / 2;
	        var startAngle = sector.startAngle;
	        var endAngle = sector.endAngle;
	        var middleAngle = (startAngle + endAngle) / 2;
	        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
	        var mathCos = Math.cos;
	        var mathSin = Math.sin; // base position: top-left
	
	        var x = cx + r * mathCos(startAngle);
	        var y = cy + r * mathSin(startAngle);
	        var textAlign = 'left';
	        var textVerticalAlign = 'top';
	
	        switch (mappedSectorPosition) {
	          case 'startArc':
	            x = cx + (r0 - distance) * mathCos(middleAngle);
	            y = cy + (r0 - distance) * mathSin(middleAngle);
	            textAlign = 'center';
	            textVerticalAlign = 'top';
	            break;
	
	          case 'insideStartArc':
	            x = cx + (r0 + distance) * mathCos(middleAngle);
	            y = cy + (r0 + distance) * mathSin(middleAngle);
	            textAlign = 'center';
	            textVerticalAlign = 'bottom';
	            break;
	
	          case 'startAngle':
	            x = cx + middleR * mathCos(startAngle) + adjustAngleDistanceX(startAngle, distance + extraDist, false);
	            y = cy + middleR * mathSin(startAngle) + adjustAngleDistanceY(startAngle, distance + extraDist, false);
	            textAlign = 'right';
	            textVerticalAlign = 'middle';
	            break;
	
	          case 'insideStartAngle':
	            x = cx + middleR * mathCos(startAngle) + adjustAngleDistanceX(startAngle, -distance + extraDist, false);
	            y = cy + middleR * mathSin(startAngle) + adjustAngleDistanceY(startAngle, -distance + extraDist, false);
	            textAlign = 'left';
	            textVerticalAlign = 'middle';
	            break;
	
	          case 'middle':
	            x = cx + middleR * mathCos(middleAngle);
	            y = cy + middleR * mathSin(middleAngle);
	            textAlign = 'center';
	            textVerticalAlign = 'middle';
	            break;
	
	          case 'endArc':
	            x = cx + (r + distance) * mathCos(middleAngle);
	            y = cy + (r + distance) * mathSin(middleAngle);
	            textAlign = 'center';
	            textVerticalAlign = 'bottom';
	            break;
	
	          case 'insideEndArc':
	            x = cx + (r - distance) * mathCos(middleAngle);
	            y = cy + (r - distance) * mathSin(middleAngle);
	            textAlign = 'center';
	            textVerticalAlign = 'top';
	            break;
	
	          case 'endAngle':
	            x = cx + middleR * mathCos(endAngle) + adjustAngleDistanceX(endAngle, distance + extraDist, true);
	            y = cy + middleR * mathSin(endAngle) + adjustAngleDistanceY(endAngle, distance + extraDist, true);
	            textAlign = 'left';
	            textVerticalAlign = 'middle';
	            break;
	
	          case 'insideEndAngle':
	            x = cx + middleR * mathCos(endAngle) + adjustAngleDistanceX(endAngle, -distance + extraDist, true);
	            y = cy + middleR * mathSin(endAngle) + adjustAngleDistanceY(endAngle, -distance + extraDist, true);
	            textAlign = 'right';
	            textVerticalAlign = 'middle';
	            break;
	
	          default:
	            return calculateTextPosition(out, opts, boundingRect);
	        }
	
	        out = out || {};
	        out.x = x;
	        out.y = y;
	        out.align = textAlign;
	        out.verticalAlign = textVerticalAlign;
	        return out;
	      };
	    }
	    function setSectorTextRotation(sector, textPosition, positionMapping, rotateType) {
	      if (isNumber(rotateType)) {
	        // user-set rotation
	        sector.setTextConfig({
	          rotation: rotateType
	        });
	        return;
	      } else if (isArray(textPosition)) {
	        // user-set position, use 0 as auto rotation
	        sector.setTextConfig({
	          rotation: 0
	        });
	        return;
	      }
	
	      var shape = sector.shape;
	      var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
	      var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
	      var middleAngle = (startAngle + endAngle) / 2;
	      var anchorAngle;
	      var mappedSectorPosition = positionMapping(textPosition);
	
	      switch (mappedSectorPosition) {
	        case 'startArc':
	        case 'insideStartArc':
	        case 'middle':
	        case 'insideEndArc':
	        case 'endArc':
	          anchorAngle = middleAngle;
	          break;
	
	        case 'startAngle':
	        case 'insideStartAngle':
	          anchorAngle = startAngle;
	          break;
	
	        case 'endAngle':
	        case 'insideEndAngle':
	          anchorAngle = endAngle;
	          break;
	
	        default:
	          sector.setTextConfig({
	            rotation: 0
	          });
	          return;
	      }
	
	      var rotate = Math.PI * 1.5 - anchorAngle;
	      /**
	       * TODO: labels with rotate > Math.PI / 2 should be rotate another
	       * half round flipped to increase readability. However, only middle
	       * position supports this for now, because in other positions, the
	       * anchor point is not at the center of the text, so the positions
	       * after rotating is not as expected.
	       */
	
	      if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) {
	        rotate -= Math.PI;
	      }
	
	      sector.setTextConfig({
	        rotation: rotate
	      });
	    }
	
	    function adjustAngleDistanceX(angle, distance, isEnd) {
	      return distance * Math.sin(angle) * (isEnd ? -1 : 1);
	    }
	
	    function adjustAngleDistanceY(angle, distance, isEnd) {
	      return distance * Math.cos(angle) * (isEnd ? 1 : -1);
	    }
	
	    function getSectorCornerRadius(model, shape, zeroIfNull) {
	      var cornerRadius = model.get('borderRadius');
	
	      if (cornerRadius == null) {
	        return zeroIfNull ? {
	          cornerRadius: 0
	        } : null;
	      }
	
	      if (!isArray(cornerRadius)) {
	        cornerRadius = [cornerRadius, cornerRadius, cornerRadius, cornerRadius];
	      }
	
	      var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
	      return {
	        cornerRadius: map(cornerRadius, function (cr) {
	          return parsePercent(cr, dr);
	        })
	      };
	    }
	
	    var mathMax$6 = Math.max;
	    var mathMin$6 = Math.min;
	
	    function getClipArea(coord, data) {
	      var coordSysClipArea = coord.getArea && coord.getArea();
	
	      if (isCoordinateSystemType(coord, 'cartesian2d')) {
	        var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
	        // We should not clip this part.
	        // See test/bar2.html
	
	        if (baseAxis.type !== 'category' || !baseAxis.onBand) {
	          var expandWidth = data.getLayout('bandWidth');
	
	          if (baseAxis.isHorizontal()) {
	            coordSysClipArea.x -= expandWidth;
	            coordSysClipArea.width += expandWidth * 2;
	          } else {
	            coordSysClipArea.y -= expandWidth;
	            coordSysClipArea.height += expandWidth * 2;
	          }
	        }
	      }
	
	      return coordSysClipArea;
	    }
	
	    var BarView =
	    /** @class */
	    function (_super) {
	      __extends(BarView, _super);
	
	      function BarView() {
	        var _this = _super.call(this) || this;
	
	        _this.type = BarView.type;
	        _this._isFirstFrame = true;
	        return _this;
	      }
	
	      BarView.prototype.render = function (seriesModel, ecModel, api, payload) {
	        this._model = seriesModel;
	
	        this._removeOnRenderedListener(api);
	
	        this._updateDrawMode(seriesModel);
	
	        var coordinateSystemType = seriesModel.get('coordinateSystem');
	
	        if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
	          // Clear previously rendered progressive elements.
	          this._progressiveEls = null;
	          this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
	        } else if (true) {
	          warn('Only cartesian2d and polar supported for bar.');
	        }
	      };
	
	      BarView.prototype.incrementalPrepareRender = function (seriesModel) {
	        this._clear();
	
	        this._updateDrawMode(seriesModel); // incremental also need to clip, otherwise might be overlow.
	        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
	
	
	        this._updateLargeClip(seriesModel);
	      };
	
	      BarView.prototype.incrementalRender = function (params, seriesModel) {
	        // Reset
	        this._progressiveEls = []; // Do not support progressive in normal mode.
	
	        this._incrementalRenderLarge(params, seriesModel);
	      };
	
	      BarView.prototype.eachRendered = function (cb) {
	        traverseElements(this._progressiveEls || this.group, cb);
	      };
	
	      BarView.prototype._updateDrawMode = function (seriesModel) {
	        var isLargeDraw = seriesModel.pipelineContext.large;
	
	        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
	          this._isLargeDraw = isLargeDraw;
	
	          this._clear();
	        }
	      };
	
	      BarView.prototype._renderNormal = function (seriesModel, ecModel, api, payload) {
	        var group = this.group;
	        var data = seriesModel.getData();
	        var oldData = this._data;
	        var coord = seriesModel.coordinateSystem;
	        var baseAxis = coord.getBaseAxis();
	        var isHorizontalOrRadial;
	
	        if (coord.type === 'cartesian2d') {
	          isHorizontalOrRadial = baseAxis.isHorizontal();
	        } else if (coord.type === 'polar') {
	          isHorizontalOrRadial = baseAxis.dim === 'angle';
	        }
	
	        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
	        var realtimeSortCfg = shouldRealtimeSort(seriesModel, coord);
	
	        if (realtimeSortCfg) {
	          this._enableRealtimeSort(realtimeSortCfg, data, api);
	        }
	
	        var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
	        var coordSysClipArea = getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.
	
	        group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
	        // And don't want the label are clipped.
	
	        var roundCap = seriesModel.get('roundCap', true);
	        var drawBackground = seriesModel.get('showBackground', true);
	        var backgroundModel = seriesModel.getModel('backgroundStyle');
	        var barBorderRadius = backgroundModel.get('borderRadius') || 0;
	        var bgEls = [];
	        var oldBgEls = this._backgroundEls;
	        var isInitSort = payload && payload.isInitSort;
	        var isChangeOrder = payload && payload.type === 'changeAxisOrder';
	
	        function createBackground(dataIndex) {
	          var bgLayout = getLayout[coord.type](data, dataIndex);
	          var bgEl = createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
	          bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.
	
	          if (coord.type === 'cartesian2d') {
	            bgEl.setShape('r', barBorderRadius);
	          } else {
	            bgEl.setShape('cornerRadius', barBorderRadius);
	          }
	
	          bgEls[dataIndex] = bgEl;
	          return bgEl;
	        }
	        data.diff(oldData).add(function (dataIndex) {
	          var itemModel = data.getItemModel(dataIndex);
	          var layout = getLayout[coord.type](data, dataIndex, itemModel);
	
	          if (drawBackground) {
	            createBackground(dataIndex);
	          } // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
	
	
	          if (!data.hasValue(dataIndex) || !isValidLayout[coord.type](layout)) {
	            return;
	          }
	
	          var isClipped = false;
	
	          if (needsClip) {
	            // Clip will modify the layout params.
	            // And return a boolean to determine if the shape are fully clipped.
	            isClipped = clip[coord.type](coordSysClipArea, layout);
	          }
	
	          var el = elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
	
	          if (realtimeSortCfg) {
	            /**
	             * Force label animation because even if the element is
	             * ignored because it's clipped, it may not be clipped after
	             * changing order. Then, if not using forceLabelAnimation,
	             * the label animation was never started, in which case,
	             * the label will be the final value and doesn't have label
	             * animation.
	             */
	            el.forceLabelAnimation = true;
	          }
	
	          updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	
	          if (isInitSort) {
	            el.attr({
	              shape: layout
	            });
	          } else if (realtimeSortCfg) {
	            updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
	          } else {
	            initProps(el, {
	              shape: layout
	            }, seriesModel, dataIndex);
	          }
	
	          data.setItemGraphicEl(dataIndex, el);
	          group.add(el);
	          el.ignore = isClipped;
	        }).update(function (newIndex, oldIndex) {
	          var itemModel = data.getItemModel(newIndex);
	          var layout = getLayout[coord.type](data, newIndex, itemModel);
	
	          if (drawBackground) {
	            var bgEl = void 0;
	
	            if (oldBgEls.length === 0) {
	              bgEl = createBackground(oldIndex);
	            } else {
	              bgEl = oldBgEls[oldIndex];
	              bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.
	
	              if (coord.type === 'cartesian2d') {
	                bgEl.setShape('r', barBorderRadius);
	              } else {
	                bgEl.setShape('cornerRadius', barBorderRadius);
	              }
	
	              bgEls[newIndex] = bgEl;
	            }
	
	            var bgLayout = getLayout[coord.type](data, newIndex);
	            var shape = createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
	            updateProps(bgEl, {
	              shape: shape
	            }, animationModel, newIndex);
	          }
	
	          var el = oldData.getItemGraphicEl(oldIndex);
	
	          if (!data.hasValue(newIndex) || !isValidLayout[coord.type](layout)) {
	            group.remove(el);
	            return;
	          }
	
	          var isClipped = false;
	
	          if (needsClip) {
	            isClipped = clip[coord.type](coordSysClipArea, layout);
	
	            if (isClipped) {
	              group.remove(el);
	            }
	          }
	
	          if (!el) {
	            el = elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
	          } else {
	            saveOldStyle(el);
	          }
	
	          if (realtimeSortCfg) {
	            el.forceLabelAnimation = true;
	          }
	
	          if (isChangeOrder) {
	            var textEl = el.getTextContent();
	
	            if (textEl) {
	              var labelInnerStore = labelInner(textEl);
	
	              if (labelInnerStore.prevValue != null) {
	                /**
	                 * Set preValue to be value so that no new label
	                 * should be started, otherwise, it will take a full
	                 * `animationDurationUpdate` time to finish the
	                 * animation, which is not expected.
	                 */
	                labelInnerStore.prevValue = labelInnerStore.value;
	              }
	            }
	          } // Not change anything if only order changed.
	          // Especially not change label.
	          else {
	              updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	            }
	
	          if (isInitSort) {
	            el.attr({
	              shape: layout
	            });
	          } else if (realtimeSortCfg) {
	            updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
	          } else {
	            updateProps(el, {
	              shape: layout
	            }, seriesModel, newIndex, null);
	          }
	
	          data.setItemGraphicEl(newIndex, el);
	          el.ignore = isClipped;
	          group.add(el);
	        }).remove(function (dataIndex) {
	          var el = oldData.getItemGraphicEl(dataIndex);
	          el && removeElementWithFadeOut(el, seriesModel, dataIndex);
	        }).execute();
	        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new Group());
	        bgGroup.removeAll();
	
	        for (var i = 0; i < bgEls.length; ++i) {
	          bgGroup.add(bgEls[i]);
	        }
	
	        group.add(bgGroup);
	        this._backgroundEls = bgEls;
	        this._data = data;
	      };
	
	      BarView.prototype._renderLarge = function (seriesModel, ecModel, api) {
	        this._clear();
	
	        createLarge(seriesModel, this.group);
	
	        this._updateLargeClip(seriesModel);
	      };
	
	      BarView.prototype._incrementalRenderLarge = function (params, seriesModel) {
	        this._removeBackground();
	
	        createLarge(seriesModel, this.group, this._progressiveEls, true);
	      };
	
	      BarView.prototype._updateLargeClip = function (seriesModel) {
	        // Use clipPath in large mode.
	        var clipPath = seriesModel.get('clip', true) && createClipPath(seriesModel.coordinateSystem, false, seriesModel);
	        var group = this.group;
	
	        if (clipPath) {
	          group.setClipPath(clipPath);
	        } else {
	          group.removeClipPath();
	        }
	      };
	
	      BarView.prototype._enableRealtimeSort = function (realtimeSortCfg, data, api) {
	        var _this = this; // If no data in the first frame, wait for data to initSort
	
	
	        if (!data.count()) {
	          return;
	        }
	
	        var baseAxis = realtimeSortCfg.baseAxis;
	
	        if (this._isFirstFrame) {
	          this._dispatchInitSort(data, realtimeSortCfg, api);
	
	          this._isFirstFrame = false;
	        } else {
	          var orderMapping_1 = function (idx) {
	            var el = data.getItemGraphicEl(idx);
	            var shape = el && el.shape;
	            return shape && // The result should be consistent with the initial sort by data value.
	            // Do not support the case that both positive and negative exist.
	            Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) // If data is NaN, shape.xxx may be NaN, so use || 0 here in case
	            || 0;
	          };
	
	          this._onRendered = function () {
	            _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
	          };
	
	          api.getZr().on('rendered', this._onRendered);
	        }
	      };
	
	      BarView.prototype._dataSort = function (data, baseAxis, orderMapping) {
	        var info = [];
	        data.each(data.mapDimension(baseAxis.dim), function (ordinalNumber, dataIdx) {
	          var mappedValue = orderMapping(dataIdx);
	          mappedValue = mappedValue == null ? NaN : mappedValue;
	          info.push({
	            dataIndex: dataIdx,
	            mappedValue: mappedValue,
	            ordinalNumber: ordinalNumber
	          });
	        });
	        info.sort(function (a, b) {
	          // If NaN, it will be treated as min val.
	          return b.mappedValue - a.mappedValue;
	        });
	        return {
	          ordinalNumbers: map(info, function (item) {
	            return item.ordinalNumber;
	          })
	        };
	      };
	
	      BarView.prototype._isOrderChangedWithinSameData = function (data, orderMapping, baseAxis) {
	        var scale = baseAxis.scale;
	        var ordinalDataDim = data.mapDimension(baseAxis.dim);
	        var lastValue = Number.MAX_VALUE;
	
	        for (var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum) {
	          var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
	          var value = rawIdx < 0 // If some tick have no bar, the tick will be treated as min.
	          ? Number.MIN_VALUE // PENDING: if dataZoom on baseAxis exits, is it a performance issue?
	          : orderMapping(data.indexOfRawIndex(rawIdx));
	
	          if (value > lastValue) {
	            return true;
	          }
	
	          lastValue = value;
	        }
	
	        return false;
	      };
	      /*
	       * Consider the case when A and B changed order, whose representing
	       * bars are both out of sight, we don't wish to trigger reorder action
	       * as long as the order in the view doesn't change.
	       */
	
	
	      BarView.prototype._isOrderDifferentInView = function (orderInfo, baseAxis) {
	        var scale = baseAxis.scale;
	        var extent = scale.getExtent();
	        var tickNum = Math.max(0, extent[0]);
	        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
	
	        for (; tickNum <= tickMax; ++tickNum) {
	          if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) {
	            return true;
	          }
	        }
	      };
	
	      BarView.prototype._updateSortWithinSameData = function (data, orderMapping, baseAxis, api) {
	        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) {
	          return;
	        }
	
	        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
	
	        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
	          this._removeOnRenderedListener(api);
	
	          api.dispatchAction({
	            type: 'changeAxisOrder',
	            componentType: baseAxis.dim + 'Axis',
	            axisId: baseAxis.index,
	            sortInfo: sortInfo
	          });
	        }
	      };
	
	      BarView.prototype._dispatchInitSort = function (data, realtimeSortCfg, api) {
	        var baseAxis = realtimeSortCfg.baseAxis;
	
	        var sortResult = this._dataSort(data, baseAxis, function (dataIdx) {
	          return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
	        });
	
	        api.dispatchAction({
	          type: 'changeAxisOrder',
	          componentType: baseAxis.dim + 'Axis',
	          isInitSort: true,
	          axisId: baseAxis.index,
	          sortInfo: sortResult
	        });
	      };
	
	      BarView.prototype.remove = function (ecModel, api) {
	        this._clear(this._model);
	
	        this._removeOnRenderedListener(api);
	      };
	
	      BarView.prototype.dispose = function (ecModel, api) {
	        this._removeOnRenderedListener(api);
	      };
	
	      BarView.prototype._removeOnRenderedListener = function (api) {
	        if (this._onRendered) {
	          api.getZr().off('rendered', this._onRendered);
	          this._onRendered = null;
	        }
	      };
	
	      BarView.prototype._clear = function (model) {
	        var group = this.group;
	        var data = this._data;
	
	        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
	          this._removeBackground();
	
	          this._backgroundEls = [];
	          data.eachItemGraphicEl(function (el) {
	            removeElementWithFadeOut(el, model, getECData(el).dataIndex);
	          });
	        } else {
	          group.removeAll();
	        }
	
	        this._data = null;
	        this._isFirstFrame = true;
	      };
	
	      BarView.prototype._removeBackground = function () {
	        this.group.remove(this._backgroundGroup);
	        this._backgroundGroup = null;
	      };
	
	      BarView.type = 'bar';
	      return BarView;
	    }(ChartView);
	
	    var clip = {
	      cartesian2d: function (coordSysBoundingRect, layout) {
	        var signWidth = layout.width < 0 ? -1 : 1;
	        var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height
	
	        if (signWidth < 0) {
	          layout.x += layout.width;
	          layout.width = -layout.width;
	        }
	
	        if (signHeight < 0) {
	          layout.y += layout.height;
	          layout.height = -layout.height;
	        }
	
	        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
	        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
	        var x = mathMax$6(layout.x, coordSysBoundingRect.x);
	        var x2 = mathMin$6(layout.x + layout.width, coordSysX2);
	        var y = mathMax$6(layout.y, coordSysBoundingRect.y);
	        var y2 = mathMin$6(layout.y + layout.height, coordSysY2);
	        var xClipped = x2 < x;
	        var yClipped = y2 < y; // When xClipped or yClipped, the element will be marked as `ignore`.
	        // But we should also place the element at the edge of the coord sys bounding rect.
	        // Because if data changed and the bar shows again, its transition animation
	        // will begin at this place.
	
	        layout.x = xClipped && x > coordSysX2 ? x2 : x;
	        layout.y = yClipped && y > coordSysY2 ? y2 : y;
	        layout.width = xClipped ? 0 : x2 - x;
	        layout.height = yClipped ? 0 : y2 - y; // Reverse back
	
	        if (signWidth < 0) {
	          layout.x += layout.width;
	          layout.width = -layout.width;
	        }
	
	        if (signHeight < 0) {
	          layout.y += layout.height;
	          layout.height = -layout.height;
	        }
	
	        return xClipped || yClipped;
	      },
	      polar: function (coordSysClipArea, layout) {
	        var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0
	
	        if (signR < 0) {
	          var tmp = layout.r;
	          layout.r = layout.r0;
	          layout.r0 = tmp;
	        }
	
	        var r = mathMin$6(layout.r, coordSysClipArea.r);
	        var r0 = mathMax$6(layout.r0, coordSysClipArea.r0);
	        layout.r = r;
	        layout.r0 = r0;
	        var clipped = r - r0 < 0; // Reverse back
	
	        if (signR < 0) {
	          var tmp = layout.r;
	          layout.r = layout.r0;
	          layout.r0 = tmp;
	        }
	
	        return clipped;
	      }
	    };
	    var elementCreator = {
	      cartesian2d: function (seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
	        var rect = new Rect({
	          shape: extend({}, layout),
	          z2: 1
	        });
	        rect.__dataIndex = newIndex;
	        rect.name = 'item';
	
	        if (animationModel) {
	          var rectShape = rect.shape;
	          var animateProperty = isHorizontal ? 'height' : 'width';
	          rectShape[animateProperty] = 0;
	        }
	
	        return rect;
	      },
	      polar: function (seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
	        var ShapeClass = !isRadial && roundCap ? SausagePath : Sector;
	        var sector = new ShapeClass({
	          shape: layout,
	          z2: 1
	        });
	        sector.name = 'item';
	        var positionMap = createPolarPositionMapping(isRadial);
	        sector.calculateTextPosition = createSectorCalculateTextPosition(positionMap, {
	          isRoundCap: ShapeClass === SausagePath
	        }); // Animation
	
	        if (animationModel) {
	          var sectorShape = sector.shape;
	          var animateProperty = isRadial ? 'r' : 'endAngle';
	          var animateTarget = {};
	          sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
	          animateTarget[animateProperty] = layout[animateProperty];
	          (isUpdate ? updateProps : initProps)(sector, {
	            shape: animateTarget // __value: typeof dataValue === 'string' ? parseInt(dataValue, 10) : dataValue
	
	          }, animationModel);
	        }
	
	        return sector;
	      }
	    };
	
	    function shouldRealtimeSort(seriesModel, coordSys) {
	      var realtimeSortOption = seriesModel.get('realtimeSort', true);
	      var baseAxis = coordSys.getBaseAxis();
	
	      if (true) {
	        if (realtimeSortOption) {
	          if (baseAxis.type !== 'category') {
	            warn('`realtimeSort` will not work because this bar series is not based on a category axis.');
	          }
	
	          if (coordSys.type !== 'cartesian2d') {
	            warn('`realtimeSort` will not work because this bar series is not on cartesian2d.');
	          }
	        }
	      }
	
	      if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') {
	        return {
	          baseAxis: baseAxis,
	          otherAxis: coordSys.getOtherAxis(baseAxis)
	        };
	      }
	    }
	
	    function updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
	      var seriesTarget;
	      var axisTarget;
	
	      if (isHorizontal) {
	        axisTarget = {
	          x: layout.x,
	          width: layout.width
	        };
	        seriesTarget = {
	          y: layout.y,
	          height: layout.height
	        };
	      } else {
	        axisTarget = {
	          y: layout.y,
	          height: layout.height
	        };
	        seriesTarget = {
	          x: layout.x,
	          width: layout.width
	        };
	      }
	
	      if (!isChangeOrder) {
	        // Keep the original growth animation if only axis order changed.
	        // Not start a new animation.
	        (isUpdate ? updateProps : initProps)(el, {
	          shape: seriesTarget
	        }, seriesAnimationModel, newIndex, null);
	      }
	
	      var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
	      (isUpdate ? updateProps : initProps)(el, {
	        shape: axisTarget
	      }, axisAnimationModel, newIndex);
	    }
	
	    function checkPropertiesNotValid(obj, props) {
	      for (var i = 0; i < props.length; i++) {
	        if (!isFinite(obj[props[i]])) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    var rectPropties = ['x', 'y', 'width', 'height'];
	    var polarPropties = ['cx', 'cy', 'r', 'startAngle', 'endAngle'];
	    var isValidLayout = {
	      cartesian2d: function (layout) {
	        return !checkPropertiesNotValid(layout, rectPropties);
	      },
	      polar: function (layout) {
	        return !checkPropertiesNotValid(layout, polarPropties);
	      }
	    };
	    var getLayout = {
	      // itemModel is only used to get borderWidth, which is not needed
	      // when calculating bar background layout.
	      cartesian2d: function (data, dataIndex, itemModel) {
	        var layout = data.getItemLayout(dataIndex);
	        var fixedLineWidth = itemModel ? getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth
	
	        var signX = layout.width > 0 ? 1 : -1;
	        var signY = layout.height > 0 ? 1 : -1;
	        return {
	          x: layout.x + signX * fixedLineWidth / 2,
	          y: layout.y + signY * fixedLineWidth / 2,
	          width: layout.width - signX * fixedLineWidth,
	          height: layout.height - signY * fixedLineWidth
	        };
	      },
	      polar: function (data, dataIndex, itemModel) {
	        var layout = data.getItemLayout(dataIndex);
	        return {
	          cx: layout.cx,
	          cy: layout.cy,
	          r0: layout.r0,
	          r: layout.r,
	          startAngle: layout.startAngle,
	          endAngle: layout.endAngle,
	          clockwise: layout.clockwise
	        };
	      }
	    };
	
	    function isZeroOnPolar(layout) {
	      return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
	    }
	
	    function createPolarPositionMapping(isRadial) {
	      return function (isRadial) {
	        var arcOrAngle = isRadial ? 'Arc' : 'Angle';
	        return function (position) {
	          switch (position) {
	            case 'start':
	            case 'insideStart':
	            case 'end':
	            case 'insideEnd':
	              return position + arcOrAngle;
	
	            default:
	              return position;
	          }
	        };
	      }(isRadial);
	    }
	
	    function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
	      var style = data.getItemVisual(dataIndex, 'style');
	
	      if (!isPolar) {
	        var borderRadius = itemModel.get(['itemStyle', 'borderRadius']) || 0;
	        el.setShape('r', borderRadius);
	      } else if (!seriesModel.get('roundCap')) {
	        var sectorShape = el.shape;
	        var cornerRadius = getSectorCornerRadius(itemModel.getModel('itemStyle'), sectorShape, true);
	        extend(sectorShape, cornerRadius);
	        el.setShape(sectorShape);
	      }
	
	      el.useStyle(style);
	      var cursorStyle = itemModel.getShallow('cursor');
	      cursorStyle && el.attr('cursor', cursorStyle);
	      var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
	      var labelStatesModels = getLabelStatesModels(itemModel);
	      setLabelStyle(el, labelStatesModels, {
	        labelFetcher: seriesModel,
	        labelDataIndex: dataIndex,
	        defaultText: getDefaultLabel(seriesModel.getData(), dataIndex),
	        inheritColor: style.fill,
	        defaultOpacity: style.opacity,
	        defaultOutsidePosition: labelPositionOutside
	      });
	      var label = el.getTextContent();
	
	      if (isPolar && label) {
	        var position = itemModel.get(['label', 'position']);
	        el.textConfig.inside = position === 'middle' ? true : null;
	        setSectorTextRotation(el, position === 'outside' ? labelPositionOutside : position, createPolarPositionMapping(isHorizontalOrRadial), itemModel.get(['label', 'rotate']));
	      }
	
	      setLabelValueAnimation(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function (value) {
	        return getDefaultInterpolatedLabel(data, value);
	      });
	      var emphasisModel = itemModel.getModel(['emphasis']);
	      toggleHoverEmphasis(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	      setStatesStylesFromModel(el, itemModel);
	
	      if (isZeroOnPolar(layout)) {
	        el.style.fill = 'none';
	        el.style.stroke = 'none';
	        each(el.states, function (state) {
	          if (state.style) {
	            state.style.fill = state.style.stroke = 'none';
	          }
	        });
	      }
	    } // In case width or height are too small.
	
	
	    function getLineWidth(itemModel, rawLayout) {
	      // Has no border.
	      var borderColor = itemModel.get(['itemStyle', 'borderColor']);
	
	      if (!borderColor || borderColor === 'none') {
	        return 0;
	      }
	
	      var lineWidth = itemModel.get(['itemStyle', 'borderWidth']) || 0; // width or height may be NaN for empty data
	
	      var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
	      var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
	      return Math.min(lineWidth, width, height);
	    }
	
	    var LagePathShape =
	    /** @class */
	    function () {
	      function LagePathShape() {}
	
	      return LagePathShape;
	    }();
	
	    var LargePath =
	    /** @class */
	    function (_super) {
	      __extends(LargePath, _super);
	
	      function LargePath(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this.type = 'largeBar';
	        return _this;
	      }
	
	      LargePath.prototype.getDefaultShape = function () {
	        return new LagePathShape();
	      };
	
	      LargePath.prototype.buildPath = function (ctx, shape) {
	        // Drawing lines is more efficient than drawing
	        // a whole line or drawing rects.
	        var points = shape.points;
	        var baseDimIdx = this.baseDimIdx;
	        var valueDimIdx = 1 - this.baseDimIdx;
	        var startPoint = [];
	        var size = [];
	        var barWidth = this.barWidth;
	
	        for (var i = 0; i < points.length; i += 3) {
	          size[baseDimIdx] = barWidth;
	          size[valueDimIdx] = points[i + 2];
	          startPoint[baseDimIdx] = points[i + baseDimIdx];
	          startPoint[valueDimIdx] = points[i + valueDimIdx];
	          ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
	        }
	      };
	
	      return LargePath;
	    }(Path);
	
	    function createLarge(seriesModel, group, progressiveEls, incremental) {
	      // TODO support polar
	      var data = seriesModel.getData();
	      var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
	      var largeDataIndices = data.getLayout('largeDataIndices');
	      var barWidth = data.getLayout('size');
	      var backgroundModel = seriesModel.getModel('backgroundStyle');
	      var bgPoints = data.getLayout('largeBackgroundPoints');
	
	      if (bgPoints) {
	        var bgEl = new LargePath({
	          shape: {
	            points: bgPoints
	          },
	          incremental: !!incremental,
	          silent: true,
	          z2: 0
	        });
	        bgEl.baseDimIdx = baseDimIdx;
	        bgEl.largeDataIndices = largeDataIndices;
	        bgEl.barWidth = barWidth;
	        bgEl.useStyle(backgroundModel.getItemStyle());
	        group.add(bgEl);
	        progressiveEls && progressiveEls.push(bgEl);
	      }
	
	      var el = new LargePath({
	        shape: {
	          points: data.getLayout('largePoints')
	        },
	        incremental: !!incremental,
	        ignoreCoarsePointer: true,
	        z2: 1
	      });
	      el.baseDimIdx = baseDimIdx;
	      el.largeDataIndices = largeDataIndices;
	      el.barWidth = barWidth;
	      group.add(el);
	      el.useStyle(data.getVisual('style')); // Enable tooltip and user mouse/touch event handlers.
	
	      getECData(el).seriesIndex = seriesModel.seriesIndex;
	
	      if (!seriesModel.get('silent')) {
	        el.on('mousedown', largePathUpdateDataIndex);
	        el.on('mousemove', largePathUpdateDataIndex);
	      }
	
	      progressiveEls && progressiveEls.push(el);
	    } // Use throttle to avoid frequently traverse to find dataIndex.
	
	
	    var largePathUpdateDataIndex = throttle(function (event) {
	      var largePath = this;
	      var dataIndex = largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
	      getECData(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
	    }, 30, false);
	
	    function largePathFindDataIndex(largePath, x, y) {
	      var baseDimIdx = largePath.baseDimIdx;
	      var valueDimIdx = 1 - baseDimIdx;
	      var points = largePath.shape.points;
	      var largeDataIndices = largePath.largeDataIndices;
	      var startPoint = [];
	      var size = [];
	      var barWidth = largePath.barWidth;
	
	      for (var i = 0, len = points.length / 3; i < len; i++) {
	        var ii = i * 3;
	        size[baseDimIdx] = barWidth;
	        size[valueDimIdx] = points[ii + 2];
	        startPoint[baseDimIdx] = points[ii + baseDimIdx];
	        startPoint[valueDimIdx] = points[ii + valueDimIdx];
	
	        if (size[valueDimIdx] < 0) {
	          startPoint[valueDimIdx] += size[valueDimIdx];
	          size[valueDimIdx] = -size[valueDimIdx];
	        }
	
	        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) {
	          return largeDataIndices[i];
	        }
	      }
	
	      return -1;
	    }
	
	    function createBackgroundShape(isHorizontalOrRadial, layout, coord) {
	      if (isCoordinateSystemType(coord, 'cartesian2d')) {
	        var rectShape = layout;
	        var coordLayout = coord.getArea();
	        return {
	          x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
	          y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
	          width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
	          height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
	        };
	      } else {
	        var coordLayout = coord.getArea();
	        var sectorShape = layout;
	        return {
	          cx: coordLayout.cx,
	          cy: coordLayout.cy,
	          r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
	          r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
	          startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
	          endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
	        };
	      }
	    }
	
	    function createBackgroundEl(coord, isHorizontalOrRadial, layout) {
	      var ElementClz = coord.type === 'polar' ? Sector : Rect;
	      return new ElementClz({
	        shape: createBackgroundShape(isHorizontalOrRadial, layout, coord),
	        silent: true,
	        z2: 0
	      });
	    }
	
	    function install$3(registers) {
	      registers.registerChartView(BarView);
	      registers.registerSeriesModel(BarSeriesModel);
	      registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, curry(layout, 'bar')); // Do layout after other overall layout, which can prepare some information.
	
	      registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, createProgressiveLayout('bar')); // Down sample after filter
	
	      registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, dataSample('bar'));
	      /**
	       * @payload
	       * @property {string} [componentType=series]
	       * @property {number} [dx]
	       * @property {number} [dy]
	       * @property {number} [zoom]
	       * @property {number} [originX]
	       * @property {number} [originY]
	       */
	
	      registers.registerAction({
	        type: 'changeAxisOrder',
	        event: 'changeAxisOrder',
	        update: 'update'
	      }, function (payload, ecModel) {
	        var componentType = payload.componentType || 'series';
	        ecModel.eachComponent({
	          mainType: componentType,
	          query: payload
	        }, function (componentModel) {
	          if (payload.sortInfo) {
	            componentModel.axis.setCategorySortInfo(payload.sortInfo);
	          }
	        });
	      });
	    }
	
	    var PI2$8 = Math.PI * 2;
	    var RADIAN = Math.PI / 180;
	
	    function getViewRect(seriesModel, api) {
	      return getLayoutRect(seriesModel.getBoxLayoutParams(), {
	        width: api.getWidth(),
	        height: api.getHeight()
	      });
	    }
	
	    function getBasicPieLayout(seriesModel, api) {
	      var viewRect = getViewRect(seriesModel, api); // center can be string or number when coordinateSystem is specified
	
	      var center = seriesModel.get('center');
	      var radius = seriesModel.get('radius');
	
	      if (!isArray(radius)) {
	        radius = [0, radius];
	      }
	
	      var width = parsePercent$1(viewRect.width, api.getWidth());
	      var height = parsePercent$1(viewRect.height, api.getHeight());
	      var size = Math.min(width, height);
	      var r0 = parsePercent$1(radius[0], size / 2);
	      var r = parsePercent$1(radius[1], size / 2);
	      var cx;
	      var cy;
	      var coordSys = seriesModel.coordinateSystem;
	
	      if (coordSys) {
	        // percentage is not allowed when coordinate system is specified
	        var point = coordSys.dataToPoint(center);
	        cx = point[0] || 0;
	        cy = point[1] || 0;
	      } else {
	        if (!isArray(center)) {
	          center = [center, center];
	        }
	
	        cx = parsePercent$1(center[0], width) + viewRect.x;
	        cy = parsePercent$1(center[1], height) + viewRect.y;
	      }
	
	      return {
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: r
	      };
	    }
	    function pieLayout(seriesType, ecModel, api) {
	      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	        var data = seriesModel.getData();
	        var valueDim = data.mapDimension('value');
	        var viewRect = getViewRect(seriesModel, api);
	
	        var _a = getBasicPieLayout(seriesModel, api),
	            cx = _a.cx,
	            cy = _a.cy,
	            r = _a.r,
	            r0 = _a.r0;
	
	        var startAngle = -seriesModel.get('startAngle') * RADIAN;
	        var minAngle = seriesModel.get('minAngle') * RADIAN;
	        var validDataCount = 0;
	        data.each(valueDim, function (value) {
	          !isNaN(value) && validDataCount++;
	        });
	        var sum = data.getSum(valueDim); // Sum may be 0
	
	        var unitRadian = Math.PI / (sum || validDataCount) * 2;
	        var clockwise = seriesModel.get('clockwise');
	        var roseType = seriesModel.get('roseType');
	        var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]
	
	        var extent = data.getDataExtent(valueDim);
	        extent[0] = 0; // In the case some sector angle is smaller than minAngle
	
	        var restAngle = PI2$8;
	        var valueSumLargerThanMinAngle = 0;
	        var currentAngle = startAngle;
	        var dir = clockwise ? 1 : -1;
	        data.setLayout({
	          viewRect: viewRect,
	          r: r
	        });
	        data.each(valueDim, function (value, idx) {
	          var angle;
	
	          if (isNaN(value)) {
	            data.setItemLayout(idx, {
	              angle: NaN,
	              startAngle: NaN,
	              endAngle: NaN,
	              clockwise: clockwise,
	              cx: cx,
	              cy: cy,
	              r0: r0,
	              r: roseType ? NaN : r
	            });
	            return;
	          } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
	
	
	          if (roseType !== 'area') {
	            angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	          } else {
	            angle = PI2$8 / validDataCount;
	          }
	
	          if (angle < minAngle) {
	            angle = minAngle;
	            restAngle -= minAngle;
	          } else {
	            valueSumLargerThanMinAngle += value;
	          }
	
	          var endAngle = currentAngle + dir * angle;
	          data.setItemLayout(idx, {
	            angle: angle,
	            startAngle: currentAngle,
	            endAngle: endAngle,
	            clockwise: clockwise,
	            cx: cx,
	            cy: cy,
	            r0: r0,
	            r: roseType ? linearMap(value, extent, [r0, r]) : r
	          });
	          currentAngle = endAngle;
	        }); // Some sector is constrained by minAngle
	        // Rest sectors needs recalculate angle
	
	        if (restAngle < PI2$8 && validDataCount) {
	          // Average the angle if rest angle is not enough after all angles is
	          // Constrained by minAngle
	          if (restAngle <= 1e-3) {
	            var angle_1 = PI2$8 / validDataCount;
	            data.each(valueDim, function (value, idx) {
	              if (!isNaN(value)) {
	                var layout_1 = data.getItemLayout(idx);
	                layout_1.angle = angle_1;
	                layout_1.startAngle = startAngle + dir * idx * angle_1;
	                layout_1.endAngle = startAngle + dir * (idx + 1) * angle_1;
	              }
	            });
	          } else {
	            unitRadian = restAngle / valueSumLargerThanMinAngle;
	            currentAngle = startAngle;
	            data.each(valueDim, function (value, idx) {
	              if (!isNaN(value)) {
	                var layout_2 = data.getItemLayout(idx);
	                var angle = layout_2.angle === minAngle ? minAngle : value * unitRadian;
	                layout_2.startAngle = currentAngle;
	                layout_2.endAngle = currentAngle + dir * angle;
	                currentAngle += dir * angle;
	              }
	            });
	          }
	        }
	      });
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function dataFilter(seriesType) {
	      return {
	        seriesType: seriesType,
	        reset: function (seriesModel, ecModel) {
	          var legendModels = ecModel.findComponents({
	            mainType: 'legend'
	          });
	
	          if (!legendModels || !legendModels.length) {
	            return;
	          }
	
	          var data = seriesModel.getData();
	          data.filterSelf(function (idx) {
	            var name = data.getName(idx); // If in any legend component the status is not selected.
	
	            for (var i = 0; i < legendModels.length; i++) {
	              // @ts-ignore FIXME: LegendModel
	              if (!legendModels[i].isSelected(name)) {
	                return false;
	              }
	            }
	
	            return true;
	          });
	        }
	      };
	    }
	
	    var RADIAN$1 = Math.PI / 180;
	
	    function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
	      if (list.length < 2) {
	        return;
	      }
	
	      function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
	        var rB = semi.rB;
	        var rB2 = rB * rB;
	
	        for (var i = 0; i < semi.list.length; i++) {
	          var item = semi.list[i];
	          var dy = Math.abs(item.label.y - cy); // horizontal r is always same with original r because x is not changed.
	
	          var rA = r + item.len;
	          var rA2 = rA * rA; // Use ellipse implicit function to calculate x
	
	          var dx = Math.sqrt((1 - Math.abs(dy * dy / rB2)) * rA2);
	          var newX = cx + (dx + item.len2) * dir;
	          var deltaX = newX - item.label.x;
	          var newTargetWidth = item.targetTextWidth - deltaX * dir; // text x is changed, so need to recalculate width.
	
	          constrainTextWidth(item, newTargetWidth, true);
	          item.label.x = newX;
	        }
	      } // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
	
	
	      function recalculateX(items) {
	        // Extremes of
	        var topSemi = {
	          list: [],
	          maxY: 0
	        };
	        var bottomSemi = {
	          list: [],
	          maxY: 0
	        };
	
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].labelAlignTo !== 'none') {
	            continue;
	          }
	
	          var item = items[i];
	          var semi = item.label.y > cy ? bottomSemi : topSemi;
	          var dy = Math.abs(item.label.y - cy);
	
	          if (dy >= semi.maxY) {
	            var dx = item.label.x - cx - item.len2 * dir; // horizontal r is always same with original r because x is not changed.
	
	            var rA = r + item.len; // Canculate rB based on the topest / bottemest label.
	
	            var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
	            semi.rB = rB;
	            semi.maxY = dy;
	          }
	
	          semi.list.push(item);
	        }
	
	        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
	        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
	      }
	
	      var len = list.length;
	
	      for (var i = 0; i < len; i++) {
	        if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
	          var dx = list[i].label.x - farthestX;
	          list[i].linePoints[1][0] += dx;
	          list[i].label.x = farthestX;
	        }
	      }
	
	      if (shiftLayoutOnY(list, viewTop, viewTop + viewHeight)) {
	        recalculateX(list);
	      }
	    }
	
	    function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
	      var leftList = [];
	      var rightList = [];
	      var leftmostX = Number.MAX_VALUE;
	      var rightmostX = -Number.MAX_VALUE;
	
	      for (var i = 0; i < labelLayoutList.length; i++) {
	        var label = labelLayoutList[i].label;
	
	        if (isPositionCenter(labelLayoutList[i])) {
	          continue;
	        }
	
	        if (label.x < cx) {
	          leftmostX = Math.min(leftmostX, label.x);
	          leftList.push(labelLayoutList[i]);
	        } else {
	          rightmostX = Math.max(rightmostX, label.x);
	          rightList.push(labelLayoutList[i]);
	        }
	      }
	
	      for (var i = 0; i < labelLayoutList.length; i++) {
	        var layout = labelLayoutList[i];
	
	        if (!isPositionCenter(layout) && layout.linePoints) {
	          if (layout.labelStyleWidth != null) {
	            continue;
	          }
	
	          var label = layout.label;
	          var linePoints = layout.linePoints;
	          var targetTextWidth = void 0;
	
	          if (layout.labelAlignTo === 'edge') {
	            if (label.x < cx) {
	              targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
	            } else {
	              targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
	            }
	          } else if (layout.labelAlignTo === 'labelLine') {
	            if (label.x < cx) {
	              targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
	            } else {
	              targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
	            }
	          } else {
	            if (label.x < cx) {
	              targetTextWidth = label.x - viewLeft - layout.bleedMargin;
	            } else {
	              targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
	            }
	          }
	
	          layout.targetTextWidth = targetTextWidth;
	          constrainTextWidth(layout, targetTextWidth);
	        }
	      }
	
	      adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
	      adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
	
	      for (var i = 0; i < labelLayoutList.length; i++) {
	        var layout = labelLayoutList[i];
	
	        if (!isPositionCenter(layout) && layout.linePoints) {
	          var label = layout.label;
	          var linePoints = layout.linePoints;
	          var isAlignToEdge = layout.labelAlignTo === 'edge';
	          var padding = label.style.padding;
	          var paddingH = padding ? padding[1] + padding[3] : 0; // textRect.width already contains paddingH if bgColor is set
	
	          var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
	          var realTextWidth = layout.rect.width + extraPaddingH;
	          var dist = linePoints[1][0] - linePoints[2][0];
	
	          if (isAlignToEdge) {
	            if (label.x < cx) {
	              linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
	            } else {
	              linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
	            }
	          } else {
	            if (label.x < cx) {
	              linePoints[2][0] = label.x + layout.labelDistance;
	            } else {
	              linePoints[2][0] = label.x - layout.labelDistance;
	            }
	
	            linePoints[1][0] = linePoints[2][0] + dist;
	          }
	
	          linePoints[1][1] = linePoints[2][1] = label.y;
	        }
	      }
	    }
	    /**
	     * Set max width of each label, and then wrap each label to the max width.
	     *
	     * @param layout label layout
	     * @param availableWidth max width for the label to display
	     * @param forceRecalculate recaculate the text layout even if the current width
	     * is smaller than `availableWidth`. This is useful when the text was previously
	     * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
	     * which case, previous wrapping should be redo.
	     */
	
	
	    function constrainTextWidth(layout, availableWidth, forceRecalculate) {
	      if (forceRecalculate === void 0) {
	        forceRecalculate = false;
	      }
	
	      if (layout.labelStyleWidth != null) {
	        // User-defined style.width has the highest priority.
	        return;
	      }
	
	      var label = layout.label;
	      var style = label.style;
	      var textRect = layout.rect;
	      var bgColor = style.backgroundColor;
	      var padding = style.padding;
	      var paddingH = padding ? padding[1] + padding[3] : 0;
	      var overflow = style.overflow; // textRect.width already contains paddingH if bgColor is set
	
	      var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);
	
	      if (availableWidth < oldOuterWidth || forceRecalculate) {
	        var oldHeight = textRect.height;
	
	        if (overflow && overflow.match('break')) {
	          // Temporarily set background to be null to calculate
	          // the bounding box without background.
	          label.setStyle('backgroundColor', null); // Set constraining width
	
	          label.setStyle('width', availableWidth - paddingH); // This is the real bounding box of the text without padding.
	
	          var innerRect = label.getBoundingRect();
	          label.setStyle('width', Math.ceil(innerRect.width));
	          label.setStyle('backgroundColor', bgColor);
	        } else {
	          var availableInnerWidth = availableWidth - paddingH;
	          var newWidth = availableWidth < oldOuterWidth // Current text is too wide, use `availableWidth` as max width.
	          ? availableInnerWidth : // Current available width is enough, but the text may have
	          // already been wrapped with a smaller available width.
	          forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth // Current available is larger than text width,
	          // so don't constrain width (otherwise it may have
	          // empty space in the background).
	          ? null // Current available is smaller than text width, so
	          // use the current available width as constraining
	          // width.
	          : availableInnerWidth : // Current available width is enough, so no need to
	          // constrain.
	          null;
	          label.setStyle('width', newWidth);
	        }
	
	        var newRect = label.getBoundingRect();
	        textRect.width = newRect.width;
	        var margin = (label.style.margin || 0) + 2.1;
	        textRect.height = newRect.height + margin;
	        textRect.y -= (textRect.height - oldHeight) / 2;
	      }
	    }
	
	    function isPositionCenter(sectorShape) {
	      // Not change x for center label
	      return sectorShape.position === 'center';
	    }
	
	    function pieLabelLayout(seriesModel) {
	      var data = seriesModel.getData();
	      var labelLayoutList = [];
	      var cx;
	      var cy;
	      var hasLabelRotate = false;
	      var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * RADIAN$1;
	      var viewRect = data.getLayout('viewRect');
	      var r = data.getLayout('r');
	      var viewWidth = viewRect.width;
	      var viewLeft = viewRect.x;
	      var viewTop = viewRect.y;
	      var viewHeight = viewRect.height;
	
	      function setNotShow(el) {
	        el.ignore = true;
	      }
	
	      function isLabelShown(label) {
	        if (!label.ignore) {
	          return true;
	        }
	
	        for (var key in label.states) {
	          if (label.states[key].ignore === false) {
	            return true;
	          }
	        }
	
	        return false;
	      }
	
	      data.each(function (idx) {
	        var sector = data.getItemGraphicEl(idx);
	        var sectorShape = sector.shape;
	        var label = sector.getTextContent();
	        var labelLine = sector.getTextGuideLine();
	        var itemModel = data.getItemModel(idx);
	        var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis
	
	        var labelPosition = labelModel.get('position') || itemModel.get(['emphasis', 'label', 'position']);
	        var labelDistance = labelModel.get('distanceToLabelLine');
	        var labelAlignTo = labelModel.get('alignTo');
	        var edgeDistance = parsePercent$1(labelModel.get('edgeDistance'), viewWidth);
	        var bleedMargin = labelModel.get('bleedMargin');
	        var labelLineModel = itemModel.getModel('labelLine');
	        var labelLineLen = labelLineModel.get('length');
	        labelLineLen = parsePercent$1(labelLineLen, viewWidth);
	        var labelLineLen2 = labelLineModel.get('length2');
	        labelLineLen2 = parsePercent$1(labelLineLen2, viewWidth);
	
	        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
	          each(label.states, setNotShow);
	          label.ignore = true;
	
	          if (labelLine) {
	            each(labelLine.states, setNotShow);
	            labelLine.ignore = true;
	          }
	
	          return;
	        }
	
	        if (!isLabelShown(label)) {
	          return;
	        }
	
	        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
	        var nx = Math.cos(midAngle);
	        var ny = Math.sin(midAngle);
	        var textX;
	        var textY;
	        var linePoints;
	        var textAlign;
	        cx = sectorShape.cx;
	        cy = sectorShape.cy;
	        var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
	
	        if (labelPosition === 'center') {
	          textX = sectorShape.cx;
	          textY = sectorShape.cy;
	          textAlign = 'center';
	        } else {
	          var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
	          var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
	          textX = x1 + nx * 3;
	          textY = y1 + ny * 3;
	
	          if (!isLabelInside) {
	            // For roseType
	            var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
	            var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
	            var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
	            var y3 = y2;
	
	            if (labelAlignTo === 'edge') {
	              // Adjust textX because text align of edge is opposite
	              textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
	            } else {
	              textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
	            }
	
	            textY = y3;
	            linePoints = [[x1, y1], [x2, y2], [x3, y3]];
	          }
	
	          textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? nx > 0 ? 'right' : 'left' : nx > 0 ? 'left' : 'right';
	        }
	
	        var PI = Math.PI;
	        var labelRotate = 0;
	        var rotate = labelModel.get('rotate');
	
	        if (isNumber(rotate)) {
	          labelRotate = rotate * (PI / 180);
	        } else if (labelPosition === 'center') {
	          labelRotate = 0;
	        } else if (rotate === 'radial' || rotate === true) {
	          var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
	          labelRotate = radialAngle;
	        } else if (rotate === 'tangential' && labelPosition !== 'outside' && labelPosition !== 'outer') {
	          var rad = Math.atan2(nx, ny);
	
	          if (rad < 0) {
	            rad = PI * 2 + rad;
	          }
	
	          var isDown = ny > 0;
	
	          if (isDown) {
	            rad = PI + rad;
	          }
	
	          labelRotate = rad - PI;
	        }
	
	        hasLabelRotate = !!labelRotate;
	        label.x = textX;
	        label.y = textY;
	        label.rotation = labelRotate;
	        label.setStyle({
	          verticalAlign: 'middle'
	        }); // Not sectorShape the inside label
	
	        if (!isLabelInside) {
	          var textRect = label.getBoundingRect().clone();
	          textRect.applyTransform(label.getComputedTransform()); // Text has a default 1px stroke. Exclude this.
	
	          var margin = (label.style.margin || 0) + 2.1;
	          textRect.y -= margin / 2;
	          textRect.height += margin;
	          labelLayoutList.push({
	            label: label,
	            labelLine: labelLine,
	            position: labelPosition,
	            len: labelLineLen,
	            len2: labelLineLen2,
	            minTurnAngle: labelLineModel.get('minTurnAngle'),
	            maxSurfaceAngle: labelLineModel.get('maxSurfaceAngle'),
	            surfaceNormal: new Point(nx, ny),
	            linePoints: linePoints,
	            textAlign: textAlign,
	            labelDistance: labelDistance,
	            labelAlignTo: labelAlignTo,
	            edgeDistance: edgeDistance,
	            bleedMargin: bleedMargin,
	            rect: textRect,
	            unconstrainedWidth: textRect.width,
	            labelStyleWidth: label.style.width
	          });
	        } else {
	          label.setStyle({
	            align: textAlign
	          });
	          var selectState = label.states.select;
	
	          if (selectState) {
	            selectState.x += label.x;
	            selectState.y += label.y;
	          }
	        }
	
	        sector.setTextConfig({
	          inside: isLabelInside
	        });
	      });
	
	      if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
	        avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
	      }
	
	      for (var i = 0; i < labelLayoutList.length; i++) {
	        var layout = labelLayoutList[i];
	        var label = layout.label;
	        var labelLine = layout.labelLine;
	        var notShowLabel = isNaN(label.x) || isNaN(label.y);
	
	        if (label) {
	          label.setStyle({
	            align: layout.textAlign
	          });
	
	          if (notShowLabel) {
	            each(label.states, setNotShow);
	            label.ignore = true;
	          }
	
	          var selectState = label.states.select;
	
	          if (selectState) {
	            selectState.x += label.x;
	            selectState.y += label.y;
	          }
	        }
	
	        if (labelLine) {
	          var linePoints = layout.linePoints;
	
	          if (notShowLabel || !linePoints) {
	            each(labelLine.states, setNotShow);
	            labelLine.ignore = true;
	          } else {
	            limitTurnAngle(linePoints, layout.minTurnAngle);
	            limitSurfaceAngle(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
	            labelLine.setShape({
	              points: linePoints
	            }); // Set the anchor to the midpoint of sector
	
	            label.__hostTarget.textGuideLineConfig = {
	              anchor: new Point(linePoints[0][0], linePoints[0][1])
	            };
	          }
	        }
	      }
	    }
	
	    /**
	     * Piece of pie including Sector, Label, LabelLine
	     */
	
	    var PiePiece =
	    /** @class */
	    function (_super) {
	      __extends(PiePiece, _super);
	
	      function PiePiece(data, idx, startAngle) {
	        var _this = _super.call(this) || this;
	
	        _this.z2 = 2;
	        var text = new ZRText();
	
	        _this.setTextContent(text);
	
	        _this.updateData(data, idx, startAngle, true);
	
	        return _this;
	      }
	
	      PiePiece.prototype.updateData = function (data, idx, startAngle, firstCreate) {
	        var sector = this;
	        var seriesModel = data.hostModel;
	        var itemModel = data.getItemModel(idx);
	        var emphasisModel = itemModel.getModel('emphasis');
	        var layout = data.getItemLayout(idx); // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
	        // see `setItemLayout` in `pieLayout.ts`.
	
	        var sectorShape = extend(getSectorCornerRadius(itemModel.getModel('itemStyle'), layout, true), layout); // Ignore NaN data.
	
	        if (isNaN(sectorShape.startAngle)) {
	          // Use NaN shape to avoid drawing shape.
	          sector.setShape(sectorShape);
	          return;
	        }
	
	        if (firstCreate) {
	          sector.setShape(sectorShape);
	          var animationType = seriesModel.getShallow('animationType');
	
	          if (seriesModel.ecModel.ssr) {
	            // Use scale animation in SSR mode(opacity?)
	            // Because CSS SVG animation doesn't support very customized shape animation.
	            initProps(sector, {
	              scaleX: 0,
	              scaleY: 0
	            }, seriesModel, {
	              dataIndex: idx,
	              isFrom: true
	            });
	            sector.originX = sectorShape.cx;
	            sector.originY = sectorShape.cy;
	          } else if (animationType === 'scale') {
	            sector.shape.r = layout.r0;
	            initProps(sector, {
	              shape: {
	                r: layout.r
	              }
	            }, seriesModel, idx);
	          } // Expansion
	          else {
	              if (startAngle != null) {
	                sector.setShape({
	                  startAngle: startAngle,
	                  endAngle: startAngle
	                });
	                initProps(sector, {
	                  shape: {
	                    startAngle: layout.startAngle,
	                    endAngle: layout.endAngle
	                  }
	                }, seriesModel, idx);
	              } else {
	                sector.shape.endAngle = layout.startAngle;
	                updateProps(sector, {
	                  shape: {
	                    endAngle: layout.endAngle
	                  }
	                }, seriesModel, idx);
	              }
	            }
	        } else {
	          saveOldStyle(sector); // Transition animation from the old shape
	
	          updateProps(sector, {
	            shape: sectorShape
	          }, seriesModel, idx);
	        }
	
	        sector.useStyle(data.getItemVisual(idx, 'style'));
	        setStatesStylesFromModel(sector, itemModel);
	        var midAngle = (layout.startAngle + layout.endAngle) / 2;
	        var offset = seriesModel.get('selectedOffset');
	        var dx = Math.cos(midAngle) * offset;
	        var dy = Math.sin(midAngle) * offset;
	        var cursorStyle = itemModel.getShallow('cursor');
	        cursorStyle && sector.attr('cursor', cursorStyle);
	
	        this._updateLabel(seriesModel, data, idx);
	
	        sector.ensureState('emphasis').shape = extend({
	          r: layout.r + (emphasisModel.get('scale') ? emphasisModel.get('scaleSize') || 0 : 0)
	        }, getSectorCornerRadius(emphasisModel.getModel('itemStyle'), layout));
	        extend(sector.ensureState('select'), {
	          x: dx,
	          y: dy,
	          shape: getSectorCornerRadius(itemModel.getModel(['select', 'itemStyle']), layout)
	        });
	        extend(sector.ensureState('blur'), {
	          shape: getSectorCornerRadius(itemModel.getModel(['blur', 'itemStyle']), layout)
	        });
	        var labelLine = sector.getTextGuideLine();
	        var labelText = sector.getTextContent();
	        labelLine && extend(labelLine.ensureState('select'), {
	          x: dx,
	          y: dy
	        }); // TODO: needs dx, dy in zrender?
	
	        extend(labelText.ensureState('select'), {
	          x: dx,
	          y: dy
	        });
	        toggleHoverEmphasis(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	      };
	
	      PiePiece.prototype._updateLabel = function (seriesModel, data, idx) {
	        var sector = this;
	        var itemModel = data.getItemModel(idx);
	        var labelLineModel = itemModel.getModel('labelLine');
	        var style = data.getItemVisual(idx, 'style');
	        var visualColor = style && style.fill;
	        var visualOpacity = style && style.opacity;
	        setLabelStyle(sector, getLabelStatesModels(itemModel), {
	          labelFetcher: data.hostModel,
	          labelDataIndex: idx,
	          inheritColor: visualColor,
	          defaultOpacity: visualOpacity,
	          defaultText: seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx)
	        });
	        var labelText = sector.getTextContent(); // Set textConfig on sector.
	
	        sector.setTextConfig({
	          // reset position, rotation
	          position: null,
	          rotation: null
	        }); // Make sure update style on labelText after setLabelStyle.
	        // Because setLabelStyle will replace a new style on it.
	
	        labelText.attr({
	          z2: 10
	        });
	        var labelPosition = seriesModel.get(['label', 'position']);
	
	        if (labelPosition !== 'outside' && labelPosition !== 'outer') {
	          sector.removeTextGuideLine();
	        } else {
	          var polyline = this.getTextGuideLine();
	
	          if (!polyline) {
	            polyline = new Polyline();
	            this.setTextGuideLine(polyline);
	          } // Default use item visual color
	
	
	          setLabelLineStyle(this, getLabelLineStatesModels(itemModel), {
	            stroke: visualColor,
	            opacity: retrieve3(labelLineModel.get(['lineStyle', 'opacity']), visualOpacity, 1)
	          });
	        }
	      };
	
	      return PiePiece;
	    }(Sector); // Pie view
	
	
	    var PieView =
	    /** @class */
	    function (_super) {
	      __extends(PieView, _super);
	
	      function PieView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.ignoreLabelLineUpdate = true;
	        return _this;
	      }
	
	      PieView.prototype.render = function (seriesModel, ecModel, api, payload) {
	        var data = seriesModel.getData();
	        var oldData = this._data;
	        var group = this.group;
	        var startAngle; // First render
	
	        if (!oldData && data.count() > 0) {
	          var shape = data.getItemLayout(0);
	
	          for (var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s) {
	            shape = data.getItemLayout(s);
	          }
	
	          if (shape) {
	            startAngle = shape.startAngle;
	          }
	        } // remove empty-circle if it exists
	
	
	        if (this._emptyCircleSector) {
	          group.remove(this._emptyCircleSector);
	        } // when all data are filtered, show lightgray empty circle
	
	
	        if (data.count() === 0 && seriesModel.get('showEmptyCircle')) {
	          var sector = new Sector({
	            shape: getBasicPieLayout(seriesModel, api)
	          });
	          sector.useStyle(seriesModel.getModel('emptyCircleStyle').getItemStyle());
	          this._emptyCircleSector = sector;
	          group.add(sector);
	        }
	
	        data.diff(oldData).add(function (idx) {
	          var piePiece = new PiePiece(data, idx, startAngle);
	          data.setItemGraphicEl(idx, piePiece);
	          group.add(piePiece);
	        }).update(function (newIdx, oldIdx) {
	          var piePiece = oldData.getItemGraphicEl(oldIdx);
	          piePiece.updateData(data, newIdx, startAngle);
	          piePiece.off('click');
	          group.add(piePiece);
	          data.setItemGraphicEl(newIdx, piePiece);
	        }).remove(function (idx) {
	          var piePiece = oldData.getItemGraphicEl(idx);
	          removeElementWithFadeOut(piePiece, seriesModel, idx);
	        }).execute();
	        pieLabelLayout(seriesModel); // Always use initial animation.
	
	        if (seriesModel.get('animationTypeUpdate') !== 'expansion') {
	          this._data = data;
	        }
	      };
	
	      PieView.prototype.dispose = function () {};
	
	      PieView.prototype.containPoint = function (point, seriesModel) {
	        var data = seriesModel.getData();
	        var itemLayout = data.getItemLayout(0);
	
	        if (itemLayout) {
	          var dx = point[0] - itemLayout.cx;
	          var dy = point[1] - itemLayout.cy;
	          var radius = Math.sqrt(dx * dx + dy * dy);
	          return radius <= itemLayout.r && radius >= itemLayout.r0;
	        }
	      };
	
	      PieView.type = 'pie';
	      return PieView;
	    }(ChartView);
	
	    /**
	     * [Usage]:
	     * (1)
	     * createListSimply(seriesModel, ['value']);
	     * (2)
	     * createListSimply(seriesModel, {
	     *     coordDimensions: ['value'],
	     *     dimensionsCount: 5
	     * });
	     */
	
	    function createSeriesDataSimply(seriesModel, opt, nameList) {
	      opt = isArray(opt) && {
	        coordDimensions: opt
	      } || extend({
	        encodeDefine: seriesModel.getEncode()
	      }, opt);
	      var source = seriesModel.getSource();
	      var dimensions = prepareSeriesDataSchema(source, opt).dimensions;
	      var list = new SeriesData(dimensions, seriesModel);
	      list.initData(source, nameList);
	      return list;
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	    /**
	     * LegendVisualProvider is an bridge that pick encoded color from data and
	     * provide to the legend component.
	     */
	    var LegendVisualProvider =
	    /** @class */
	    function () {
	      function LegendVisualProvider( // Function to get data after filtered. It stores all the encoding info
	      getDataWithEncodedVisual, // Function to get raw data before filtered.
	      getRawData) {
	        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
	        this._getRawData = getRawData;
	      }
	
	      LegendVisualProvider.prototype.getAllNames = function () {
	        var rawData = this._getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
	        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
	
	
	        return rawData.mapArray(rawData.getName);
	      };
	
	      LegendVisualProvider.prototype.containName = function (name) {
	        var rawData = this._getRawData();
	
	        return rawData.indexOfName(name) >= 0;
	      };
	
	      LegendVisualProvider.prototype.indexOfName = function (name) {
	        // Only get data when necessary.
	        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
	        // Invoking Series#getData immediately will throw an error.
	        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
	
	        return dataWithEncodedVisual.indexOfName(name);
	      };
	
	      LegendVisualProvider.prototype.getItemVisual = function (dataIndex, key) {
	        // Get encoded visual properties from final filtered data.
	        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
	
	        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
	      };
	
	      return LegendVisualProvider;
	    }();
	
	    var innerData = makeInner();
	
	    var PieSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(PieSeriesModel, _super);
	
	      function PieSeriesModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	      /**
	       * @overwrite
	       */
	
	
	      PieSeriesModel.prototype.init = function (option) {
	        _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
	        // Use a function instead of direct access because data reference may changed
	
	
	        this.legendVisualProvider = new LegendVisualProvider(bind(this.getData, this), bind(this.getRawData, this));
	
	        this._defaultLabelLine(option);
	      };
	      /**
	       * @overwrite
	       */
	
	
	      PieSeriesModel.prototype.mergeOption = function () {
	        _super.prototype.mergeOption.apply(this, arguments);
	      };
	      /**
	       * @overwrite
	       */
	
	
	      PieSeriesModel.prototype.getInitialData = function () {
	        return createSeriesDataSimply(this, {
	          coordDimensions: ['value'],
	          encodeDefaulter: curry(makeSeriesEncodeForNameBased, this)
	        });
	      };
	      /**
	       * @overwrite
	       */
	
	
	      PieSeriesModel.prototype.getDataParams = function (dataIndex) {
	        var data = this.getData(); // update seats when data is changed
	
	        var dataInner = innerData(data);
	        var seats = dataInner.seats;
	
	        if (!seats) {
	          var valueList_1 = [];
	          data.each(data.mapDimension('value'), function (value) {
	            valueList_1.push(value);
	          });
	          seats = dataInner.seats = getPercentSeats(valueList_1, data.hostModel.get('percentPrecision'));
	        }
	
	        var params = _super.prototype.getDataParams.call(this, dataIndex); // seats may be empty when sum is 0
	
	
	        params.percent = seats[dataIndex] || 0;
	        params.$vars.push('percent');
	        return params;
	      };
	
	      PieSeriesModel.prototype._defaultLabelLine = function (option) {
	        // Extend labelLine emphasis
	        defaultEmphasis(option, 'labelLine', ['show']);
	        var labelLineNormalOpt = option.labelLine;
	        var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	      };
	
	      PieSeriesModel.type = 'series.pie';
	      PieSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        legendHoverLink: true,
	        colorBy: 'data',
	        // 默认全局居中
	        center: ['50%', '50%'],
	        radius: [0, '75%'],
	        // 默认顺时针
	        clockwise: true,
	        startAngle: 90,
	        // 最小角度改为0
	        minAngle: 0,
	        // If the angle of a sector less than `minShowLabelAngle`,
	        // the label will not be displayed.
	        minShowLabelAngle: 0,
	        // 选中时扇区偏移量
	        selectedOffset: 10,
	        // 选择模式，默认关闭，可选single，multiple
	        // selectedMode: false,
	        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
	        // roseType: null,
	        percentPrecision: 2,
	        // If still show when all data zero.
	        stillShowZeroSum: true,
	        // cursor: null,
	        left: 0,
	        top: 0,
	        right: 0,
	        bottom: 0,
	        width: null,
	        height: null,
	        label: {
	          // color: 'inherit',
	          // If rotate around circle
	          rotate: 0,
	          show: true,
	          overflow: 'truncate',
	          // 'outer', 'inside', 'center'
	          position: 'outer',
	          // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
	          alignTo: 'none',
	          // Closest distance between label and chart edge.
	          // Works only position is 'outer' and alignTo is 'edge'.
	          edgeDistance: '25%',
	          // Works only position is 'outer' and alignTo is not 'edge'.
	          bleedMargin: 10,
	          // Distance between text and label line.
	          distanceToLabelLine: 5 // formatter: 标签文本格式器，同 tooltip.formatter，不支持异步回调
	          // 默认使用全局文本样式，详见 textStyle
	          // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数
	
	        },
	        // Enabled when label.normal.position is 'outer'
	        labelLine: {
	          show: true,
	          // 引导线两段中的第一段长度
	          length: 15,
	          // 引导线两段中的第二段长度
	          length2: 15,
	          smooth: false,
	          minTurnAngle: 90,
	          maxSurfaceAngle: 90,
	          lineStyle: {
	            // color: 各异,
	            width: 1,
	            type: 'solid'
	          }
	        },
	        itemStyle: {
	          borderWidth: 1,
	          borderJoin: 'round'
	        },
	        showEmptyCircle: true,
	        emptyCircleStyle: {
	          color: 'lightgray',
	          opacity: 1
	        },
	        labelLayout: {
	          // Hide the overlapped label.
	          hideOverlap: true
	        },
	        emphasis: {
	          scale: true,
	          scaleSize: 5
	        },
	        // If use strategy to avoid label overlapping
	        avoidLabelOverlap: true,
	        // Animation type. Valid values: expansion, scale
	        animationType: 'expansion',
	        animationDuration: 1000,
	        // Animation type when update. Valid values: transition, expansion
	        animationTypeUpdate: 'transition',
	        animationEasingUpdate: 'cubicInOut',
	        animationDurationUpdate: 500,
	        animationEasing: 'cubicInOut'
	      };
	      return PieSeriesModel;
	    }(SeriesModel);
	
	    function negativeDataFilter(seriesType) {
	      return {
	        seriesType: seriesType,
	        reset: function (seriesModel, ecModel) {
	          var data = seriesModel.getData();
	          data.filterSelf(function (idx) {
	            // handle negative value condition
	            var valueDim = data.mapDimension('value');
	            var curValue = data.get(valueDim, idx);
	
	            if (isNumber(curValue) && !isNaN(curValue) && curValue < 0) {
	              return false;
	            }
	
	            return true;
	          });
	        }
	      };
	    }
	
	    function install$4(registers) {
	      registers.registerChartView(PieView);
	      registers.registerSeriesModel(PieSeriesModel);
	      createLegacyDataSelectAction('pie', registers.registerAction);
	      registers.registerLayout(curry(pieLayout, 'pie'));
	      registers.registerProcessor(dataFilter('pie'));
	      registers.registerProcessor(negativeDataFilter('pie'));
	    }
	
	    var ScatterSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(ScatterSeriesModel, _super);
	
	      function ScatterSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ScatterSeriesModel.type;
	        _this.hasSymbolVisual = true;
	        return _this;
	      }
	
	      ScatterSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return createSeriesData(null, this, {
	          useEncodeDefaulter: true
	        });
	      };
	
	      ScatterSeriesModel.prototype.getProgressive = function () {
	        var progressive = this.option.progressive;
	
	        if (progressive == null) {
	          // PENDING
	          return this.option.large ? 5e3 : this.get('progressive');
	        }
	
	        return progressive;
	      };
	
	      ScatterSeriesModel.prototype.getProgressiveThreshold = function () {
	        var progressiveThreshold = this.option.progressiveThreshold;
	
	        if (progressiveThreshold == null) {
	          // PENDING
	          return this.option.large ? 1e4 : this.get('progressiveThreshold');
	        }
	
	        return progressiveThreshold;
	      };
	
	      ScatterSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
	        return selectors.point(data.getItemLayout(dataIndex));
	      };
	
	      ScatterSeriesModel.prototype.getZLevelKey = function () {
	        // Each progressive series has individual key.
	        return this.getData().count() > this.getProgressiveThreshold() ? this.id : '';
	      };
	
	      ScatterSeriesModel.type = 'series.scatter';
	      ScatterSeriesModel.dependencies = ['grid', 'polar', 'geo', 'singleAxis', 'calendar'];
	      ScatterSeriesModel.defaultOption = {
	        coordinateSystem: 'cartesian2d',
	        // zlevel: 0,
	        z: 2,
	        legendHoverLink: true,
	        symbolSize: 10,
	        // symbolRotate: null,  // 图形旋转控制
	        large: false,
	        // Available when large is true
	        largeThreshold: 2000,
	        // cursor: null,
	        itemStyle: {
	          opacity: 0.8 // color: 各异
	
	        },
	        emphasis: {
	          scale: true
	        },
	        // If clip the overflow graphics
	        // Works on cartesian / polar series
	        clip: true,
	        select: {
	          itemStyle: {
	            borderColor: '#212121'
	          }
	        },
	        universalTransition: {
	          divideShape: 'clone'
	        } // progressive: null
	
	      };
	      return ScatterSeriesModel;
	    }(SeriesModel);
	
	    var BOOST_SIZE_THRESHOLD = 4;
	
	    var LargeSymbolPathShape =
	    /** @class */
	    function () {
	      function LargeSymbolPathShape() {}
	
	      return LargeSymbolPathShape;
	    }();
	
	    var LargeSymbolPath =
	    /** @class */
	    function (_super) {
	      __extends(LargeSymbolPath, _super);
	
	      function LargeSymbolPath(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this._off = 0;
	        _this.hoverDataIdx = -1;
	        return _this;
	      }
	
	      LargeSymbolPath.prototype.getDefaultShape = function () {
	        return new LargeSymbolPathShape();
	      };
	
	      LargeSymbolPath.prototype.reset = function () {
	        this.notClear = false;
	        this._off = 0;
	      };
	
	      LargeSymbolPath.prototype.buildPath = function (path, shape) {
	        var points = shape.points;
	        var size = shape.size;
	        var symbolProxy = this.symbolProxy;
	        var symbolProxyShape = symbolProxy.shape;
	        var ctx = path.getContext ? path.getContext() : path;
	        var canBoost = ctx && size[0] < BOOST_SIZE_THRESHOLD;
	        var softClipShape = this.softClipShape;
	        var i; // Do draw in afterBrush.
	
	        if (canBoost) {
	          this._ctx = ctx;
	          return;
	        }
	
	        this._ctx = null;
	
	        for (i = this._off; i < points.length;) {
	          var x = points[i++];
	          var y = points[i++];
	
	          if (isNaN(x) || isNaN(y)) {
	            continue;
	          }
	
	          if (softClipShape && !softClipShape.contain(x, y)) {
	            continue;
	          }
	
	          symbolProxyShape.x = x - size[0] / 2;
	          symbolProxyShape.y = y - size[1] / 2;
	          symbolProxyShape.width = size[0];
	          symbolProxyShape.height = size[1];
	          symbolProxy.buildPath(path, symbolProxyShape, true);
	        }
	
	        if (this.incremental) {
	          this._off = i;
	          this.notClear = true;
	        }
	      };
	
	      LargeSymbolPath.prototype.afterBrush = function () {
	        var shape = this.shape;
	        var points = shape.points;
	        var size = shape.size;
	        var ctx = this._ctx;
	        var softClipShape = this.softClipShape;
	        var i;
	
	        if (!ctx) {
	          return;
	        } // PENDING If style or other canvas status changed?
	
	
	        for (i = this._off; i < points.length;) {
	          var x = points[i++];
	          var y = points[i++];
	
	          if (isNaN(x) || isNaN(y)) {
	            continue;
	          }
	
	          if (softClipShape && !softClipShape.contain(x, y)) {
	            continue;
	          } // fillRect is faster than building a rect path and draw.
	          // And it support light globalCompositeOperation.
	
	
	          ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
	        }
	
	        if (this.incremental) {
	          this._off = i;
	          this.notClear = true;
	        }
	      };
	
	      LargeSymbolPath.prototype.findDataIndex = function (x, y) {
	        // TODO ???
	        // Consider transform
	        var shape = this.shape;
	        var points = shape.points;
	        var size = shape.size;
	        var w = Math.max(size[0], 4);
	        var h = Math.max(size[1], 4); // Not consider transform
	        // Treat each element as a rect
	        // top down traverse
	
	        for (var idx = points.length / 2 - 1; idx >= 0; idx--) {
	          var i = idx * 2;
	          var x0 = points[i] - w / 2;
	          var y0 = points[i + 1] - h / 2;
	
	          if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) {
	            return idx;
	          }
	        }
	
	        return -1;
	      };
	
	      LargeSymbolPath.prototype.contain = function (x, y) {
	        var localPos = this.transformCoordToLocal(x, y);
	        var rect = this.getBoundingRect();
	        x = localPos[0];
	        y = localPos[1];
	
	        if (rect.contain(x, y)) {
	          // Cache found data index.
	          var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
	          return dataIdx >= 0;
	        }
	
	        this.hoverDataIdx = -1;
	        return false;
	      };
	
	      LargeSymbolPath.prototype.getBoundingRect = function () {
	        // Ignore stroke for large symbol draw.
	        var rect = this._rect;
	
	        if (!rect) {
	          var shape = this.shape;
	          var points = shape.points;
	          var size = shape.size;
	          var w = size[0];
	          var h = size[1];
	          var minX = Infinity;
	          var minY = Infinity;
	          var maxX = -Infinity;
	          var maxY = -Infinity;
	
	          for (var i = 0; i < points.length;) {
	            var x = points[i++];
	            var y = points[i++];
	            minX = Math.min(x, minX);
	            maxX = Math.max(x, maxX);
	            minY = Math.min(y, minY);
	            maxY = Math.max(y, maxY);
	          }
	
	          rect = this._rect = new BoundingRect(minX - w / 2, minY - h / 2, maxX - minX + w, maxY - minY + h);
	        }
	
	        return rect;
	      };
	
	      return LargeSymbolPath;
	    }(Path);
	
	    var LargeSymbolDraw =
	    /** @class */
	    function () {
	      function LargeSymbolDraw() {
	        this.group = new Group();
	      }
	      /**
	       * Update symbols draw by new data
	       */
	
	
	      LargeSymbolDraw.prototype.updateData = function (data, opt) {
	        this._clear();
	
	        var symbolEl = this._create();
	
	        symbolEl.setShape({
	          points: data.getLayout('points')
	        });
	
	        this._setCommon(symbolEl, data, opt);
	      };
	
	      LargeSymbolDraw.prototype.updateLayout = function (data) {
	        var points = data.getLayout('points');
	        this.group.eachChild(function (child) {
	          if (child.startIndex != null) {
	            var len = (child.endIndex - child.startIndex) * 2;
	            var byteOffset = child.startIndex * 4 * 2;
	            points = new Float32Array(points.buffer, byteOffset, len);
	          }
	
	          child.setShape('points', points); // Reset draw cursor.
	
	          child.reset();
	        });
	      };
	
	      LargeSymbolDraw.prototype.incrementalPrepareUpdate = function (data) {
	        this._clear();
	      };
	
	      LargeSymbolDraw.prototype.incrementalUpdate = function (taskParams, data, opt) {
	        var lastAdded = this._newAdded[0];
	        var points = data.getLayout('points');
	        var oldPoints = lastAdded && lastAdded.shape.points; // Merging the exists. Each element has 1e4 points.
	        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
	
	        if (oldPoints && oldPoints.length < 2e4) {
	          var oldLen = oldPoints.length;
	          var newPoints = new Float32Array(oldLen + points.length); // Concat two array
	
	          newPoints.set(oldPoints);
	          newPoints.set(points, oldLen); // Update endIndex
	
	          lastAdded.endIndex = taskParams.end;
	          lastAdded.setShape({
	            points: newPoints
	          });
	        } else {
	          // Clear
	          this._newAdded = [];
	
	          var symbolEl = this._create();
	
	          symbolEl.startIndex = taskParams.start;
	          symbolEl.endIndex = taskParams.end;
	          symbolEl.incremental = true;
	          symbolEl.setShape({
	            points: points
	          });
	
	          this._setCommon(symbolEl, data, opt);
	        }
	      };
	
	      LargeSymbolDraw.prototype.eachRendered = function (cb) {
	        this._newAdded[0] && cb(this._newAdded[0]);
	      };
	
	      LargeSymbolDraw.prototype._create = function () {
	        var symbolEl = new LargeSymbolPath({
	          cursor: 'default'
	        });
	        symbolEl.ignoreCoarsePointer = true;
	        this.group.add(symbolEl);
	
	        this._newAdded.push(symbolEl);
	
	        return symbolEl;
	      };
	
	      LargeSymbolDraw.prototype._setCommon = function (symbolEl, data, opt) {
	        var hostModel = data.hostModel;
	        opt = opt || {};
	        var size = data.getVisual('symbolSize');
	        symbolEl.setShape('size', size instanceof Array ? size : [size, size]);
	        symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data
	
	        symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method
	
	        symbolEl.setColor = symbolEl.symbolProxy.setColor;
	        var extrudeShadow = symbolEl.shape.size[0] < BOOST_SIZE_THRESHOLD;
	        symbolEl.useStyle( // Draw shadow when doing fillRect is extremely slow.
	        hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? ['color', 'shadowBlur', 'shadowColor'] : ['color']));
	        var globalStyle = data.getVisual('style');
	        var visualColor = globalStyle && globalStyle.fill;
	
	        if (visualColor) {
	          symbolEl.setColor(visualColor);
	        }
	
	        var ecData = getECData(symbolEl); // Enable tooltip
	        // PENDING May have performance issue when path is extremely large
	
	        ecData.seriesIndex = hostModel.seriesIndex;
	        symbolEl.on('mousemove', function (e) {
	          ecData.dataIndex = null;
	          var dataIndex = symbolEl.hoverDataIdx;
	
	          if (dataIndex >= 0) {
	            // Provide dataIndex for tooltip
	            ecData.dataIndex = dataIndex + (symbolEl.startIndex || 0);
	          }
	        });
	      };
	
	      LargeSymbolDraw.prototype.remove = function () {
	        this._clear();
	      };
	
	      LargeSymbolDraw.prototype._clear = function () {
	        this._newAdded = [];
	        this.group.removeAll();
	      };
	
	      return LargeSymbolDraw;
	    }();
	
	    var ScatterView =
	    /** @class */
	    function (_super) {
	      __extends(ScatterView, _super);
	
	      function ScatterView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ScatterView.type;
	        return _this;
	      }
	
	      ScatterView.prototype.render = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	
	        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	        symbolDraw.updateData(data, {
	          // TODO
	          // If this parameter should be a shape or a bounding volume
	          // shape will be more general.
	          // But bounding volume like bounding rect will be much faster in the contain calculation
	          clipShape: this._getClipShape(seriesModel)
	        });
	        this._finished = true;
	      };
	
	      ScatterView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	
	        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	        symbolDraw.incrementalPrepareUpdate(data);
	        this._finished = false;
	      };
	
	      ScatterView.prototype.incrementalRender = function (taskParams, seriesModel, ecModel) {
	        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
	          clipShape: this._getClipShape(seriesModel)
	        });
	
	        this._finished = taskParams.end === seriesModel.getData().count();
	      };
	
	      ScatterView.prototype.updateTransform = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
	        // PENDING
	
	        this.group.dirty();
	
	        if (!this._finished || data.count() > 1e4) {
	          return {
	            update: true
	          };
	        } else {
	          var res = pointsLayout('').reset(seriesModel, ecModel, api);
	
	          if (res.progress) {
	            res.progress({
	              start: 0,
	              end: data.count(),
	              count: data.count()
	            }, data);
	          }
	
	          this._symbolDraw.updateLayout(data);
	        }
	      };
	
	      ScatterView.prototype.eachRendered = function (cb) {
	        this._symbolDraw && this._symbolDraw.eachRendered(cb);
	      };
	
	      ScatterView.prototype._getClipShape = function (seriesModel) {
	        var coordSys = seriesModel.coordinateSystem;
	        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
	        return seriesModel.get('clip', true) ? clipArea : null;
	      };
	
	      ScatterView.prototype._updateSymbolDraw = function (data, seriesModel) {
	        var symbolDraw = this._symbolDraw;
	        var pipelineContext = seriesModel.pipelineContext;
	        var isLargeDraw = pipelineContext.large;
	
	        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
	          symbolDraw && symbolDraw.remove();
	          symbolDraw = this._symbolDraw = isLargeDraw ? new LargeSymbolDraw() : new SymbolDraw();
	          this._isLargeDraw = isLargeDraw;
	          this.group.removeAll();
	        }
	
	        this.group.add(symbolDraw.group);
	        return symbolDraw;
	      };
	
	      ScatterView.prototype.remove = function (ecModel, api) {
	        this._symbolDraw && this._symbolDraw.remove(true);
	        this._symbolDraw = null;
	      };
	
	      ScatterView.prototype.dispose = function () {};
	
	      ScatterView.type = 'scatter';
	      return ScatterView;
	    }(ChartView);
	
	    var GridModel =
	    /** @class */
	    function (_super) {
	      __extends(GridModel, _super);
	
	      function GridModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      GridModel.type = 'grid';
	      GridModel.dependencies = ['xAxis', 'yAxis'];
	      GridModel.layoutMode = 'box';
	      GridModel.defaultOption = {
	        show: false,
	        // zlevel: 0,
	        z: 0,
	        left: '10%',
	        top: 60,
	        right: '10%',
	        bottom: 70,
	        // If grid size contain label
	        containLabel: false,
	        // width: {totalWidth} - left - right,
	        // height: {totalHeight} - top - bottom,
	        backgroundColor: 'rgba(0,0,0,0)',
	        borderWidth: 1,
	        borderColor: '#ccc'
	      };
	      return GridModel;
	    }(ComponentModel);
	
	    var CartesianAxisModel =
	    /** @class */
	    function (_super) {
	      __extends(CartesianAxisModel, _super);
	
	      function CartesianAxisModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      CartesianAxisModel.prototype.getCoordSysModel = function () {
	        return this.getReferringComponents('grid', SINGLE_REFERRING).models[0];
	      };
	
	      CartesianAxisModel.type = 'cartesian2dAxis';
	      return CartesianAxisModel;
	    }(ComponentModel);
	    mixin(CartesianAxisModel, AxisModelCommonMixin);
	
	    var defaultOption = {
	      show: true,
	      // zlevel: 0,
	      z: 0,
	      // Inverse the axis.
	      inverse: false,
	      // Axis name displayed.
	      name: '',
	      // 'start' | 'middle' | 'end'
	      nameLocation: 'end',
	      // By degree. By default auto rotate by nameLocation.
	      nameRotate: null,
	      nameTruncate: {
	        maxWidth: null,
	        ellipsis: '...',
	        placeholder: '.'
	      },
	      // Use global text style by default.
	      nameTextStyle: {},
	      // The gap between axisName and axisLine.
	      nameGap: 15,
	      // Default `false` to support tooltip.
	      silent: false,
	      // Default `false` to avoid legacy user event listener fail.
	      triggerEvent: false,
	      tooltip: {
	        show: false
	      },
	      axisPointer: {},
	      axisLine: {
	        show: true,
	        onZero: true,
	        onZeroAxisIndex: null,
	        lineStyle: {
	          color: '#6E7079',
	          width: 1,
	          type: 'solid'
	        },
	        // The arrow at both ends the the axis.
	        symbol: ['none', 'none'],
	        symbolSize: [10, 15]
	      },
	      axisTick: {
	        show: true,
	        // Whether axisTick is inside the grid or outside the grid.
	        inside: false,
	        // The length of axisTick.
	        length: 5,
	        lineStyle: {
	          width: 1
	        }
	      },
	      axisLabel: {
	        show: true,
	        // Whether axisLabel is inside the grid or outside the grid.
	        inside: false,
	        rotate: 0,
	        // true | false | null/undefined (auto)
	        showMinLabel: null,
	        // true | false | null/undefined (auto)
	        showMaxLabel: null,
	        margin: 8,
	        // formatter: null,
	        fontSize: 12
	      },
	      splitLine: {
	        show: true,
	        lineStyle: {
	          color: ['#E0E6F1'],
	          width: 1,
	          type: 'solid'
	        }
	      },
	      splitArea: {
	        show: false,
	        areaStyle: {
	          color: ['rgba(250,250,250,0.2)', 'rgba(210,219,238,0.2)']
	        }
	      }
	    };
	    var categoryAxis = merge({
	      // The gap at both ends of the axis. For categoryAxis, boolean.
	      boundaryGap: true,
	      // Set false to faster category collection.
	      deduplication: null,
	      // splitArea: {
	      // show: false
	      // },
	      splitLine: {
	        show: false
	      },
	      axisTick: {
	        // If tick is align with label when boundaryGap is true
	        alignWithLabel: false,
	        interval: 'auto'
	      },
	      axisLabel: {
	        interval: 'auto'
	      }
	    }, defaultOption);
	    var valueAxis = merge({
	      boundaryGap: [0, 0],
	      axisLine: {
	        // Not shown when other axis is categoryAxis in cartesian
	        show: 'auto'
	      },
	      axisTick: {
	        // Not shown when other axis is categoryAxis in cartesian
	        show: 'auto'
	      },
	      // TODO
	      // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
	      splitNumber: 5,
	      minorTick: {
	        // Minor tick, not available for cateogry axis.
	        show: false,
	        // Split number of minor ticks. The value should be in range of (0, 100)
	        splitNumber: 5,
	        // Length of minor tick
	        length: 3,
	        // Line style
	        lineStyle: {// Default to be same with axisTick
	        }
	      },
	      minorSplitLine: {
	        show: false,
	        lineStyle: {
	          color: '#F4F7FD',
	          width: 1
	        }
	      }
	    }, defaultOption);
	    var timeAxis = merge({
	      splitNumber: 6,
	      axisLabel: {
	        // To eliminate labels that are not nice
	        showMinLabel: false,
	        showMaxLabel: false,
	        rich: {
	          primary: {
	            fontWeight: 'bold'
	          }
	        }
	      },
	      splitLine: {
	        show: false
	      }
	    }, valueAxis);
	    var logAxis = defaults({
	      logBase: 10
	    }, valueAxis);
	    var axisDefault = {
	      category: categoryAxis,
	      value: valueAxis,
	      time: timeAxis,
	      log: logAxis
	    };
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var AXIS_TYPES = {
	      value: 1,
	      category: 1,
	      time: 1,
	      log: 1
	    };
	
	    /**
	     * Generate sub axis model class
	     * @param axisName 'x' 'y' 'radius' 'angle' 'parallel' ...
	     */
	
	    function axisModelCreator(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
	      each(AXIS_TYPES, function (v, axisType) {
	        var defaultOption = merge(merge({}, axisDefault[axisType], true), extraDefaultOption, true);
	
	        var AxisModel =
	        /** @class */
	        function (_super) {
	          __extends(AxisModel, _super);
	
	          function AxisModel() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	
	            _this.type = axisName + 'Axis.' + axisType;
	            return _this;
	          }
	
	          AxisModel.prototype.mergeDefaultAndTheme = function (option, ecModel) {
	            var layoutMode = fetchLayoutMode(this);
	            var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
	            var themeModel = ecModel.getTheme();
	            merge(option, themeModel.get(axisType + 'Axis'));
	            merge(option, this.getDefaultOption());
	            option.type = getAxisType(option);
	
	            if (layoutMode) {
	              mergeLayoutParam(option, inputPositionParams, layoutMode);
	            }
	          };
	
	          AxisModel.prototype.optionUpdated = function () {
	            var thisOption = this.option;
	
	            if (thisOption.type === 'category') {
	              this.__ordinalMeta = OrdinalMeta.createByAxisModel(this);
	            }
	          };
	          /**
	           * Should not be called before all of 'getInitailData' finished.
	           * Because categories are collected during initializing data.
	           */
	
	
	          AxisModel.prototype.getCategories = function (rawData) {
	            var option = this.option; // FIXME
	            // warning if called before all of 'getInitailData' finished.
	
	            if (option.type === 'category') {
	              if (rawData) {
	                return option.data;
	              }
	
	              return this.__ordinalMeta.categories;
	            }
	          };
	
	          AxisModel.prototype.getOrdinalMeta = function () {
	            return this.__ordinalMeta;
	          };
	
	          AxisModel.type = axisName + 'Axis.' + axisType;
	          AxisModel.defaultOption = defaultOption;
	          return AxisModel;
	        }(BaseAxisModelClass);
	
	        registers.registerComponentModel(AxisModel);
	      });
	      registers.registerSubTypeDefaulter(axisName + 'Axis', getAxisType);
	    }
	
	    function getAxisType(option) {
	      // Default axis with data is category axis
	      return option.type || (option.data ? 'category' : 'value');
	    }
	
	    var Cartesian =
	    /** @class */
	    function () {
	      function Cartesian(name) {
	        this.type = 'cartesian';
	        this._dimList = [];
	        this._axes = {};
	        this.name = name || '';
	      }
	
	      Cartesian.prototype.getAxis = function (dim) {
	        return this._axes[dim];
	      };
	
	      Cartesian.prototype.getAxes = function () {
	        return map(this._dimList, function (dim) {
	          return this._axes[dim];
	        }, this);
	      };
	
	      Cartesian.prototype.getAxesByScale = function (scaleType) {
	        scaleType = scaleType.toLowerCase();
	        return filter(this.getAxes(), function (axis) {
	          return axis.scale.type === scaleType;
	        });
	      };
	
	      Cartesian.prototype.addAxis = function (axis) {
	        var dim = axis.dim;
	        this._axes[dim] = axis;
	
	        this._dimList.push(dim);
	      };
	
	      return Cartesian;
	    }();
	
	    var cartesian2DDimensions = ['x', 'y'];
	
	    function canCalculateAffineTransform(scale) {
	      return scale.type === 'interval' || scale.type === 'time';
	    }
	
	    var Cartesian2D =
	    /** @class */
	    function (_super) {
	      __extends(Cartesian2D, _super);
	
	      function Cartesian2D() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = 'cartesian2d';
	        _this.dimensions = cartesian2DDimensions;
	        return _this;
	      }
	      /**
	       * Calculate an affine transform matrix if two axes are time or value.
	       * It's mainly for accelartion on the large time series data.
	       */
	
	
	      Cartesian2D.prototype.calcAffineTransform = function () {
	        this._transform = this._invTransform = null;
	        var xAxisScale = this.getAxis('x').scale;
	        var yAxisScale = this.getAxis('y').scale;
	
	        if (!canCalculateAffineTransform(xAxisScale) || !canCalculateAffineTransform(yAxisScale)) {
	          return;
	        }
	
	        var xScaleExtent = xAxisScale.getExtent();
	        var yScaleExtent = yAxisScale.getExtent();
	        var start = this.dataToPoint([xScaleExtent[0], yScaleExtent[0]]);
	        var end = this.dataToPoint([xScaleExtent[1], yScaleExtent[1]]);
	        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
	        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
	
	        if (!xScaleSpan || !yScaleSpan) {
	          return;
	        } // Accelerate data to point calculation on the special large time series data.
	
	
	        var scaleX = (end[0] - start[0]) / xScaleSpan;
	        var scaleY = (end[1] - start[1]) / yScaleSpan;
	        var translateX = start[0] - xScaleExtent[0] * scaleX;
	        var translateY = start[1] - yScaleExtent[0] * scaleY;
	        var m = this._transform = [scaleX, 0, 0, scaleY, translateX, translateY];
	        this._invTransform = invert([], m);
	      };
	      /**
	       * Base axis will be used on stacking.
	       */
	
	
	      Cartesian2D.prototype.getBaseAxis = function () {
	        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
	      };
	
	      Cartesian2D.prototype.containPoint = function (point) {
	        var axisX = this.getAxis('x');
	        var axisY = this.getAxis('y');
	        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
	      };
	
	      Cartesian2D.prototype.containData = function (data) {
	        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
	      };
	
	      Cartesian2D.prototype.containZone = function (data1, data2) {
	        var zoneDiag1 = this.dataToPoint(data1);
	        var zoneDiag2 = this.dataToPoint(data2);
	        var area = this.getArea();
	        var zone = new BoundingRect(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
	        return area.intersect(zone);
	      };
	
	      Cartesian2D.prototype.dataToPoint = function (data, clamp, out) {
	        out = out || [];
	        var xVal = data[0];
	        var yVal = data[1]; // Fast path
	
	        if (this._transform // It's supported that if data is like `[Inifity, 123]`, where only Y pixel calculated.
	        && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) {
	          return applyTransform(out, data, this._transform);
	        }
	
	        var xAxis = this.getAxis('x');
	        var yAxis = this.getAxis('y');
	        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
	        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
	        return out;
	      };
	
	      Cartesian2D.prototype.clampData = function (data, out) {
	        var xScale = this.getAxis('x').scale;
	        var yScale = this.getAxis('y').scale;
	        var xAxisExtent = xScale.getExtent();
	        var yAxisExtent = yScale.getExtent();
	        var x = xScale.parse(data[0]);
	        var y = yScale.parse(data[1]);
	        out = out || [];
	        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
	        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
	        return out;
	      };
	
	      Cartesian2D.prototype.pointToData = function (point, clamp) {
	        var out = [];
	
	        if (this._invTransform) {
	          return applyTransform(out, point, this._invTransform);
	        }
	
	        var xAxis = this.getAxis('x');
	        var yAxis = this.getAxis('y');
	        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
	        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
	        return out;
	      };
	
	      Cartesian2D.prototype.getOtherAxis = function (axis) {
	        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
	      };
	      /**
	       * Get rect area of cartesian.
	       * Area will have a contain function to determine if a point is in the coordinate system.
	       */
	
	
	      Cartesian2D.prototype.getArea = function () {
	        var xExtent = this.getAxis('x').getGlobalExtent();
	        var yExtent = this.getAxis('y').getGlobalExtent();
	        var x = Math.min(xExtent[0], xExtent[1]);
	        var y = Math.min(yExtent[0], yExtent[1]);
	        var width = Math.max(xExtent[0], xExtent[1]) - x;
	        var height = Math.max(yExtent[0], yExtent[1]) - y;
	        return new BoundingRect(x, y, width, height);
	      };
	
	      return Cartesian2D;
	    }(Cartesian);
	
	    var Axis2D =
	    /** @class */
	    function (_super) {
	      __extends(Axis2D, _super);
	
	      function Axis2D(dim, scale, coordExtent, axisType, position) {
	        var _this = _super.call(this, dim, scale, coordExtent) || this;
	        /**
	         * Index of axis, can be used as key
	         * Injected outside.
	         */
	
	
	        _this.index = 0;
	        _this.type = axisType || 'value';
	        _this.position = position || 'bottom';
	        return _this;
	      }
	
	      Axis2D.prototype.isHorizontal = function () {
	        var position = this.position;
	        return position === 'top' || position === 'bottom';
	      };
	      /**
	       * Each item cooresponds to this.getExtent(), which
	       * means globalExtent[0] may greater than globalExtent[1],
	       * unless `asc` is input.
	       *
	       * @param {boolean} [asc]
	       * @return {Array.<number>}
	       */
	
	
	      Axis2D.prototype.getGlobalExtent = function (asc) {
	        var ret = this.getExtent();
	        ret[0] = this.toGlobalCoord(ret[0]);
	        ret[1] = this.toGlobalCoord(ret[1]);
	        asc && ret[0] > ret[1] && ret.reverse();
	        return ret;
	      };
	
	      Axis2D.prototype.pointToData = function (point, clamp) {
	        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
	      };
	      /**
	       * Set ordinalSortInfo
	       * @param info new OrdinalSortInfo
	       */
	
	
	      Axis2D.prototype.setCategorySortInfo = function (info) {
	        if (this.type !== 'category') {
	          return false;
	        }
	
	        this.model.option.categorySortInfo = info;
	        this.scale.setSortInfo(info);
	      };
	
	      return Axis2D;
	    }(Axis);
	
	    /**
	     * Can only be called after coordinate system creation stage.
	     * (Can be called before coordinate system update stage).
	     */
	
	    function layout$1(gridModel, axisModel, opt) {
	      opt = opt || {};
	      var grid = gridModel.coordinateSystem;
	      var axis = axisModel.axis;
	      var layout = {};
	      var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
	      var rawAxisPosition = axis.position;
	      var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
	      var axisDim = axis.dim;
	      var rect = grid.getRect();
	      var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	      var idx = {
	        left: 0,
	        right: 1,
	        top: 0,
	        bottom: 1,
	        onZero: 2
	      };
	      var axisOffset = axisModel.get('offset') || 0;
	      var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];
	
	      if (otherAxisOnZeroOf) {
	        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
	        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
	      } // Axis position
	
	
	      layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation
	
	      layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
	
	      var dirMap = {
	        top: -1,
	        bottom: 1,
	        left: -1,
	        right: 1
	      };
	      layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
	      layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
	
	      if (axisModel.get(['axisTick', 'inside'])) {
	        layout.tickDirection = -layout.tickDirection;
	      }
	
	      if (retrieve(opt.labelInside, axisModel.get(['axisLabel', 'inside']))) {
	        layout.labelDirection = -layout.labelDirection;
	      } // Special label rotation
	
	
	      var labelRotate = axisModel.get(['axisLabel', 'rotate']);
	      layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
	
	      layout.z2 = 1;
	      return layout;
	    }
	    function isCartesian2DSeries(seriesModel) {
	      return seriesModel.get('coordinateSystem') === 'cartesian2d';
	    }
	    function findAxisModels(seriesModel) {
	      var axisModelMap = {
	        xAxisModel: null,
	        yAxisModel: null
	      };
	      each(axisModelMap, function (v, key) {
	        var axisType = key.replace(/Model$/, '');
	        var axisModel = seriesModel.getReferringComponents(axisType, SINGLE_REFERRING).models[0];
	
	        if (true) {
	          if (!axisModel) {
	            throw new Error(axisType + ' "' + retrieve3(seriesModel.get(axisType + 'Index'), seriesModel.get(axisType + 'Id'), 0) + '" not found');
	          }
	        }
	
	        axisModelMap[key] = axisModel;
	      });
	      return axisModelMap;
	    }
	
	    var mathLog$1 = Math.log;
	    function alignScaleTicks(scale, axisModel, alignToScale) {
	      var intervalScaleProto = IntervalScale.prototype; // NOTE: There is a precondition for log scale  here:
	      // In log scale we store _interval and _extent of exponent value.
	      // So if we use the method of InternalScale to set/get these data.
	      // It process the exponent value, which is linear and what we want here.
	
	      var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
	      var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, true);
	      var alignToSplitNumber = alignToTicks.length - 1;
	      var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
	      var scaleExtent = getScaleExtent(scale, axisModel);
	      var rawExtent = scaleExtent.extent;
	      var isMinFixed = scaleExtent.fixMin;
	      var isMaxFixed = scaleExtent.fixMax;
	
	      if (scale.type === 'log') {
	        var logBase = mathLog$1(scale.base);
	        rawExtent = [mathLog$1(rawExtent[0]) / logBase, mathLog$1(rawExtent[1]) / logBase];
	      }
	
	      scale.setExtent(rawExtent[0], rawExtent[1]);
	      scale.calcNiceExtent({
	        splitNumber: alignToSplitNumber,
	        fixMin: isMinFixed,
	        fixMax: isMaxFixed
	      });
	      var extent = intervalScaleProto.getExtent.call(scale); // Need to update the rawExtent.
	      // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'
	
	      if (isMinFixed) {
	        rawExtent[0] = extent[0];
	      }
	
	      if (isMaxFixed) {
	        rawExtent[1] = extent[1];
	      }
	
	      var interval = intervalScaleProto.getInterval.call(scale);
	      var min = rawExtent[0];
	      var max = rawExtent[1];
	
	      if (isMinFixed && isMaxFixed) {
	        // User set min, max, divide to get new interval
	        interval = (max - min) / alignToSplitNumber;
	      } else if (isMinFixed) {
	        max = rawExtent[0] + interval * alignToSplitNumber; // User set min, expand extent on the other side
	
	        while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])) {
	          interval = increaseInterval(interval);
	          max = rawExtent[0] + interval * alignToSplitNumber;
	        }
	      } else if (isMaxFixed) {
	        // User set max, expand extent on the other side
	        min = rawExtent[1] - interval * alignToSplitNumber;
	
	        while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])) {
	          interval = increaseInterval(interval);
	          min = rawExtent[1] - interval * alignToSplitNumber;
	        }
	      } else {
	        var nicedSplitNumber = scale.getTicks().length - 1;
	
	        if (nicedSplitNumber > alignToSplitNumber) {
	          interval = increaseInterval(interval);
	        }
	
	        var range = interval * alignToSplitNumber;
	        max = Math.ceil(rawExtent[1] / interval) * interval;
	        min = round(max - range); // Not change the result that crossing zero.
	
	        if (min < 0 && rawExtent[0] >= 0) {
	          min = 0;
	          max = round(range);
	        } else if (max > 0 && rawExtent[1] <= 0) {
	          max = 0;
	          min = -round(range);
	        }
	      } // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
	
	
	      var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
	      var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval; // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.
	
	      intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
	      intervalScaleProto.setInterval.call(scale, interval);
	
	      if (t0 || t1) {
	        intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
	      }
	
	      if (true) {
	        var ticks = intervalScaleProto.getTicks.call(scale);
	
	        if (ticks[1] && (!isValueNice(interval) || getPrecisionSafe(ticks[1].value) > getPrecisionSafe(interval))) {
	          warn( // eslint-disable-next-line
	          "The ticks may be not readable when set min: " + axisModel.get('min') + ", max: " + axisModel.get('max') + " and alignTicks: true");
	        }
	      }
	    }
	
	    var Grid =
	    /** @class */
	    function () {
	      function Grid(gridModel, ecModel, api) {
	        // FIXME:TS where used (different from registered type 'cartesian2d')?
	        this.type = 'grid';
	        this._coordsMap = {};
	        this._coordsList = [];
	        this._axesMap = {};
	        this._axesList = [];
	        this.axisPointerEnabled = true;
	        this.dimensions = cartesian2DDimensions;
	
	        this._initCartesian(gridModel, ecModel, api);
	
	        this.model = gridModel;
	      }
	
	      Grid.prototype.getRect = function () {
	        return this._rect;
	      };
	
	      Grid.prototype.update = function (ecModel, api) {
	        var axesMap = this._axesMap;
	
	        this._updateScale(ecModel, this.model);
	
	        function updateAxisTicks(axes) {
	          var alignTo; // Axis is added in order of axisIndex.
	
	          var axesIndices = keys(axes);
	          var len = axesIndices.length;
	
	          if (!len) {
	            return;
	          }
	
	          var axisNeedsAlign = []; // Process once and calculate the ticks for those don't use alignTicks.
	
	          for (var i = len - 1; i >= 0; i--) {
	            var idx = +axesIndices[i]; // Convert to number.
	
	            var axis = axes[idx];
	            var model = axis.model;
	            var scale = axis.scale;
	
	            if ( // Only value and log axis without interval support alignTicks.
	            isIntervalOrLogScale(scale) && model.get('alignTicks') && model.get('interval') == null) {
	              axisNeedsAlign.push(axis);
	            } else {
	              niceScaleExtent(scale, model);
	
	              if (isIntervalOrLogScale(scale)) {
	                // Can only align to interval or log axis.
	                alignTo = axis;
	              }
	            }
	          }
	          // PENDING. Should we find the axis that both set interval, min, max and align to this one?
	
	          if (axisNeedsAlign.length) {
	            if (!alignTo) {
	              alignTo = axisNeedsAlign.pop();
	              niceScaleExtent(alignTo.scale, alignTo.model);
	            }
	
	            each(axisNeedsAlign, function (axis) {
	              alignScaleTicks(axis.scale, axis.model, alignTo.scale);
	            });
	          }
	        }
	
	        updateAxisTicks(axesMap.x);
	        updateAxisTicks(axesMap.y); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
	
	        var onZeroRecords = {};
	        each(axesMap.x, function (xAxis) {
	          fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
	        });
	        each(axesMap.y, function (yAxis) {
	          fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
	        }); // Resize again if containLabel is enabled
	        // FIXME It may cause getting wrong grid size in data processing stage
	
	        this.resize(this.model, api);
	      };
	      /**
	       * Resize the grid
	       */
	
	
	      Grid.prototype.resize = function (gridModel, api, ignoreContainLabel) {
	        var boxLayoutParams = gridModel.getBoxLayoutParams();
	        var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
	        var gridRect = getLayoutRect(boxLayoutParams, {
	          width: api.getWidth(),
	          height: api.getHeight()
	        });
	        this._rect = gridRect;
	        var axesList = this._axesList;
	        adjustAxes(); // Minus label size
	
	        if (isContainLabel) {
	          each(axesList, function (axis) {
	            if (!axis.model.get(['axisLabel', 'inside'])) {
	              var labelUnionRect = estimateLabelUnionRect(axis);
	
	              if (labelUnionRect) {
	                var dim = axis.isHorizontal() ? 'height' : 'width';
	                var margin = axis.model.get(['axisLabel', 'margin']);
	                gridRect[dim] -= labelUnionRect[dim] + margin;
	
	                if (axis.position === 'top') {
	                  gridRect.y += labelUnionRect.height + margin;
	                } else if (axis.position === 'left') {
	                  gridRect.x += labelUnionRect.width + margin;
	                }
	              }
	            }
	          });
	          adjustAxes();
	        }
	
	        each(this._coordsList, function (coord) {
	          // Calculate affine matrix to accelerate the data to point transform.
	          // If all the axes scales are time or value.
	          coord.calcAffineTransform();
	        });
	
	        function adjustAxes() {
	          each(axesList, function (axis) {
	            var isHorizontal = axis.isHorizontal();
	            var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
	            var idx = axis.inverse ? 1 : 0;
	            axis.setExtent(extent[idx], extent[1 - idx]);
	            updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
	          });
	        }
	      };
	
	      Grid.prototype.getAxis = function (dim, axisIndex) {
	        var axesMapOnDim = this._axesMap[dim];
	
	        if (axesMapOnDim != null) {
	          return axesMapOnDim[axisIndex || 0];
	        }
	      };
	
	      Grid.prototype.getAxes = function () {
	        return this._axesList.slice();
	      };
	
	      Grid.prototype.getCartesian = function (xAxisIndex, yAxisIndex) {
	        if (xAxisIndex != null && yAxisIndex != null) {
	          var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	          return this._coordsMap[key];
	        }
	
	        if (isObject(xAxisIndex)) {
	          yAxisIndex = xAxisIndex.yAxisIndex;
	          xAxisIndex = xAxisIndex.xAxisIndex;
	        }
	
	        for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
	          if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
	            return coordList[i];
	          }
	        }
	      };
	
	      Grid.prototype.getCartesians = function () {
	        return this._coordsList.slice();
	      };
	      /**
	       * @implements
	       */
	
	
	      Grid.prototype.convertToPixel = function (ecModel, finder, value) {
	        var target = this._findConvertTarget(finder);
	
	        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
	      };
	      /**
	       * @implements
	       */
	
	
	      Grid.prototype.convertFromPixel = function (ecModel, finder, value) {
	        var target = this._findConvertTarget(finder);
	
	        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
	      };
	
	      Grid.prototype._findConvertTarget = function (finder) {
	        var seriesModel = finder.seriesModel;
	        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', SINGLE_REFERRING).models[0];
	        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', SINGLE_REFERRING).models[0];
	        var gridModel = finder.gridModel;
	        var coordsList = this._coordsList;
	        var cartesian;
	        var axis;
	
	        if (seriesModel) {
	          cartesian = seriesModel.coordinateSystem;
	          indexOf(coordsList, cartesian) < 0 && (cartesian = null);
	        } else if (xAxisModel && yAxisModel) {
	          cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	        } else if (xAxisModel) {
	          axis = this.getAxis('x', xAxisModel.componentIndex);
	        } else if (yAxisModel) {
	          axis = this.getAxis('y', yAxisModel.componentIndex);
	        } // Lowest priority.
	        else if (gridModel) {
	            var grid = gridModel.coordinateSystem;
	
	            if (grid === this) {
	              cartesian = this._coordsList[0];
	            }
	          }
	
	        return {
	          cartesian: cartesian,
	          axis: axis
	        };
	      };
	      /**
	       * @implements
	       */
	
	
	      Grid.prototype.containPoint = function (point) {
	        var coord = this._coordsList[0];
	
	        if (coord) {
	          return coord.containPoint(point);
	        }
	      };
	      /**
	       * Initialize cartesian coordinate systems
	       */
	
	
	      Grid.prototype._initCartesian = function (gridModel, ecModel, api) {
	        var _this = this;
	
	        var grid = this;
	        var axisPositionUsed = {
	          left: false,
	          right: false,
	          top: false,
	          bottom: false
	        };
	        var axesMap = {
	          x: {},
	          y: {}
	        };
	        var axesCount = {
	          x: 0,
	          y: 0
	        }; // Create axis
	
	        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
	        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
	
	        if (!axesCount.x || !axesCount.y) {
	          // Roll back when there no either x or y axis
	          this._axesMap = {};
	          this._axesList = [];
	          return;
	        }
	
	        this._axesMap = axesMap; // Create cartesian2d
	
	        each(axesMap.x, function (xAxis, xAxisIndex) {
	          each(axesMap.y, function (yAxis, yAxisIndex) {
	            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	            var cartesian = new Cartesian2D(key);
	            cartesian.master = _this;
	            cartesian.model = gridModel;
	            _this._coordsMap[key] = cartesian;
	
	            _this._coordsList.push(cartesian);
	
	            cartesian.addAxis(xAxis);
	            cartesian.addAxis(yAxis);
	          });
	        });
	
	        function createAxisCreator(dimName) {
	          return function (axisModel, idx) {
	            if (!isAxisUsedInTheGrid(axisModel, gridModel)) {
	              return;
	            }
	
	            var axisPosition = axisModel.get('position');
	
	            if (dimName === 'x') {
	              // Fix position
	              if (axisPosition !== 'top' && axisPosition !== 'bottom') {
	                // Default bottom of X
	                axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
	              }
	            } else {
	              // Fix position
	              if (axisPosition !== 'left' && axisPosition !== 'right') {
	                // Default left of Y
	                axisPosition = axisPositionUsed.left ? 'right' : 'left';
	              }
	            }
	
	            axisPositionUsed[axisPosition] = true;
	            var axis = new Axis2D(dimName, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
	            var isCategory = axis.type === 'category';
	            axis.onBand = isCategory && axisModel.get('boundaryGap');
	            axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
	
	            axisModel.axis = axis; // Inject axisModel into axis
	
	            axis.model = axisModel; // Inject grid info axis
	
	            axis.grid = grid; // Index of axis, can be used as key
	
	            axis.index = idx;
	
	            grid._axesList.push(axis);
	
	            axesMap[dimName][idx] = axis;
	            axesCount[dimName]++;
	          };
	        }
	      };
	      /**
	       * Update cartesian properties from series.
	       */
	
	
	      Grid.prototype._updateScale = function (ecModel, gridModel) {
	        // Reset scale
	        each(this._axesList, function (axis) {
	          axis.scale.setExtent(Infinity, -Infinity);
	
	          if (axis.type === 'category') {
	            var categorySortInfo = axis.model.get('categorySortInfo');
	            axis.scale.setSortInfo(categorySortInfo);
	          }
	        });
	        ecModel.eachSeries(function (seriesModel) {
	          if (isCartesian2DSeries(seriesModel)) {
	            var axesModelMap = findAxisModels(seriesModel);
	            var xAxisModel = axesModelMap.xAxisModel;
	            var yAxisModel = axesModelMap.yAxisModel;
	
	            if (!isAxisUsedInTheGrid(xAxisModel, gridModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel)) {
	              return;
	            }
	
	            var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	            var data = seriesModel.getData();
	            var xAxis = cartesian.getAxis('x');
	            var yAxis = cartesian.getAxis('y');
	            unionExtent(data, xAxis);
	            unionExtent(data, yAxis);
	          }
	        }, this);
	
	        function unionExtent(data, axis) {
	          each(getDataDimensionsOnAxis(data, axis.dim), function (dim) {
	            axis.scale.unionExtentFromData(data, dim);
	          });
	        }
	      };
	      /**
	       * @param dim 'x' or 'y' or 'auto' or null/undefined
	       */
	
	
	      Grid.prototype.getTooltipAxes = function (dim) {
	        var baseAxes = [];
	        var otherAxes = [];
	        each(this.getCartesians(), function (cartesian) {
	          var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
	          var otherAxis = cartesian.getOtherAxis(baseAxis);
	          indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
	          indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
	        });
	        return {
	          baseAxes: baseAxes,
	          otherAxes: otherAxes
	        };
	      };
	
	      Grid.create = function (ecModel, api) {
	        var grids = [];
	        ecModel.eachComponent('grid', function (gridModel, idx) {
	          var grid = new Grid(gridModel, ecModel, api);
	          grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
	          // should be performed in create stage.
	
	          grid.resize(gridModel, api, true);
	          gridModel.coordinateSystem = grid;
	          grids.push(grid);
	        }); // Inject the coordinateSystems into seriesModel
	
	        ecModel.eachSeries(function (seriesModel) {
	          if (!isCartesian2DSeries(seriesModel)) {
	            return;
	          }
	
	          var axesModelMap = findAxisModels(seriesModel);
	          var xAxisModel = axesModelMap.xAxisModel;
	          var yAxisModel = axesModelMap.yAxisModel;
	          var gridModel = xAxisModel.getCoordSysModel();
	
	          if (true) {
	            if (!gridModel) {
	              throw new Error('Grid "' + retrieve3(xAxisModel.get('gridIndex'), xAxisModel.get('gridId'), 0) + '" not found');
	            }
	
	            if (xAxisModel.getCoordSysModel() !== yAxisModel.getCoordSysModel()) {
	              throw new Error('xAxis and yAxis must use the same grid');
	            }
	          }
	
	          var grid = gridModel.coordinateSystem;
	          seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	        });
	        return grids;
	      }; // For deciding which dimensions to use when creating list data
	
	
	      Grid.dimensions = cartesian2DDimensions;
	      return Grid;
	    }();
	    /**
	     * Check if the axis is used in the specified grid.
	     */
	
	
	    function isAxisUsedInTheGrid(axisModel, gridModel) {
	      return axisModel.getCoordSysModel() === gridModel;
	    }
	
	    function fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
	    onZeroRecords) {
	      axis.getAxesOnZeroOf = function () {
	        // TODO: onZero of multiple axes.
	        return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
	      }; // onZero can not be enabled in these two situations:
	      // 1. When any other axis is a category axis.
	      // 2. When no axis is cross 0 point.
	
	
	      var otherAxes = axesMap[otherAxisDim];
	      var otherAxisOnZeroOf;
	      var axisModel = axis.model;
	      var onZero = axisModel.get(['axisLine', 'onZero']);
	      var onZeroAxisIndex = axisModel.get(['axisLine', 'onZeroAxisIndex']);
	
	      if (!onZero) {
	        return;
	      } // If target axis is specified.
	
	
	      if (onZeroAxisIndex != null) {
	        if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
	          otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
	        }
	      } else {
	        // Find the first available other axis.
	        for (var idx in otherAxes) {
	          if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
	          // if both onZero, the two Y axes overlap.
	          && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
	            otherAxisOnZeroOf = otherAxes[idx];
	            break;
	          }
	        }
	      }
	
	      if (otherAxisOnZeroOf) {
	        onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
	      }
	
	      function getOnZeroRecordKey(axis) {
	        return axis.dim + '_' + axis.index;
	      }
	    }
	
	    function canOnZeroToAxis(axis) {
	      return axis && axis.type !== 'category' && axis.type !== 'time' && ifAxisCrossZero(axis);
	    }
	
	    function updateAxisTransform(axis, coordBase) {
	      var axisExtent = axis.getExtent();
	      var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
	
	      axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
	        return coord + coordBase;
	      } : function (coord) {
	        return axisExtentSum - coord + coordBase;
	      };
	      axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
	        return coord - coordBase;
	      } : function (coord) {
	        return axisExtentSum - coord + coordBase;
	      };
	    }
	
	    var PI$5 = Math.PI;
	    /**
	     * A final axis is translated and rotated from a "standard axis".
	     * So opt.position and opt.rotation is required.
	     *
	     * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
	     * for example: (0, 0) ------------> (0, 50)
	     *
	     * nameDirection or tickDirection or labelDirection is 1 means tick
	     * or label is below the standard axis, whereas is -1 means above
	     * the standard axis. labelOffset means offset between label and axis,
	     * which is useful when 'onZero', where axisLabel is in the grid and
	     * label in outside grid.
	     *
	     * Tips: like always,
	     * positive rotation represents anticlockwise, and negative rotation
	     * represents clockwise.
	     * The direction of position coordinate is the same as the direction
	     * of screen coordinate.
	     *
	     * Do not need to consider axis 'inverse', which is auto processed by
	     * axis extent.
	     */
	
	    var AxisBuilder =
	    /** @class */
	    function () {
	      function AxisBuilder(axisModel, opt) {
	        this.group = new Group();
	        this.opt = opt;
	        this.axisModel = axisModel; // Default value
	
	        defaults(opt, {
	          labelOffset: 0,
	          nameDirection: 1,
	          tickDirection: 1,
	          labelDirection: 1,
	          silent: true,
	          handleAutoShown: function () {
	            return true;
	          }
	        }); // FIXME Not use a separate text group?
	
	        var transformGroup = new Group({
	          x: opt.position[0],
	          y: opt.position[1],
	          rotation: opt.rotation
	        }); // this.group.add(transformGroup);
	        // this._transformGroup = transformGroup;
	
	        transformGroup.updateTransform();
	        this._transformGroup = transformGroup;
	      }
	
	      AxisBuilder.prototype.hasBuilder = function (name) {
	        return !!builders[name];
	      };
	
	      AxisBuilder.prototype.add = function (name) {
	        builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
	      };
	
	      AxisBuilder.prototype.getGroup = function () {
	        return this.group;
	      };
	
	      AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
	        var rotationDiff = remRadian(textRotation - axisRotation);
	        var textAlign;
	        var textVerticalAlign;
	
	        if (isRadianAroundZero(rotationDiff)) {
	          // Label is parallel with axis line.
	          textVerticalAlign = direction > 0 ? 'top' : 'bottom';
	          textAlign = 'center';
	        } else if (isRadianAroundZero(rotationDiff - PI$5)) {
	          // Label is inverse parallel with axis line.
	          textVerticalAlign = direction > 0 ? 'bottom' : 'top';
	          textAlign = 'center';
	        } else {
	          textVerticalAlign = 'middle';
	
	          if (rotationDiff > 0 && rotationDiff < PI$5) {
	            textAlign = direction > 0 ? 'right' : 'left';
	          } else {
	            textAlign = direction > 0 ? 'left' : 'right';
	          }
	        }
	
	        return {
	          rotation: rotationDiff,
	          textAlign: textAlign,
	          textVerticalAlign: textVerticalAlign
	        };
	      };
	
	      AxisBuilder.makeAxisEventDataBase = function (axisModel) {
	        var eventData = {
	          componentType: axisModel.mainType,
	          componentIndex: axisModel.componentIndex
	        };
	        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
	        return eventData;
	      };
	
	      AxisBuilder.isLabelSilent = function (axisModel) {
	        var tooltipOpt = axisModel.get('tooltip');
	        return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
	        || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
	      };
	
	      return AxisBuilder;
	    }();
	    var builders = {
	      axisLine: function (opt, axisModel, group, transformGroup) {
	        var shown = axisModel.get(['axisLine', 'show']);
	
	        if (shown === 'auto' && opt.handleAutoShown) {
	          shown = opt.handleAutoShown('axisLine');
	        }
	
	        if (!shown) {
	          return;
	        }
	
	        var extent = axisModel.axis.getExtent();
	        var matrix = transformGroup.transform;
	        var pt1 = [extent[0], 0];
	        var pt2 = [extent[1], 0];
	        var inverse = pt1[0] > pt2[0];
	
	        if (matrix) {
	          applyTransform(pt1, pt1, matrix);
	          applyTransform(pt2, pt2, matrix);
	        }
	
	        var lineStyle = extend({
	          lineCap: 'round'
	        }, axisModel.getModel(['axisLine', 'lineStyle']).getLineStyle());
	        var line = new Line({
	          shape: {
	            x1: pt1[0],
	            y1: pt1[1],
	            x2: pt2[0],
	            y2: pt2[1]
	          },
	          style: lineStyle,
	          strokeContainThreshold: opt.strokeContainThreshold || 5,
	          silent: true,
	          z2: 1
	        });
	        subPixelOptimizeLine$1(line.shape, line.style.lineWidth);
	        line.anid = 'line';
	        group.add(line);
	        var arrows = axisModel.get(['axisLine', 'symbol']);
	
	        if (arrows != null) {
	          var arrowSize = axisModel.get(['axisLine', 'symbolSize']);
	
	          if (isString(arrows)) {
	            // Use the same arrow for start and end point
	            arrows = [arrows, arrows];
	          }
	
	          if (isString(arrowSize) || isNumber(arrowSize)) {
	            // Use the same size for width and height
	            arrowSize = [arrowSize, arrowSize];
	          }
	
	          var arrowOffset = normalizeSymbolOffset(axisModel.get(['axisLine', 'symbolOffset']) || 0, arrowSize);
	          var symbolWidth_1 = arrowSize[0];
	          var symbolHeight_1 = arrowSize[1];
	          each([{
	            rotate: opt.rotation + Math.PI / 2,
	            offset: arrowOffset[0],
	            r: 0
	          }, {
	            rotate: opt.rotation - Math.PI / 2,
	            offset: arrowOffset[1],
	            r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
	          }], function (point, index) {
	            if (arrows[index] !== 'none' && arrows[index] != null) {
	              var symbol = createSymbol(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true); // Calculate arrow position with offset
	
	              var r = point.r + point.offset;
	              var pt = inverse ? pt2 : pt1;
	              symbol.attr({
	                rotation: point.rotate,
	                x: pt[0] + r * Math.cos(opt.rotation),
	                y: pt[1] - r * Math.sin(opt.rotation),
	                silent: true,
	                z2: 11
	              });
	              group.add(symbol);
	            }
	          });
	        }
	      },
	      axisTickLabel: function (opt, axisModel, group, transformGroup) {
	        var ticksEls = buildAxisMajorTicks(group, transformGroup, axisModel, opt);
	        var labelEls = buildAxisLabel(group, transformGroup, axisModel, opt);
	        fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
	        buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection); // This bit fixes the label overlap issue for the time chart.
	        // See https://github.com/apache/echarts/issues/14266 for more.
	
	        if (axisModel.get(['axisLabel', 'hideOverlap'])) {
	          var labelList = prepareLayoutList(map(labelEls, function (label) {
	            return {
	              label: label,
	              priority: label.z2,
	              defaultAttr: {
	                ignore: label.ignore
	              }
	            };
	          }));
	          hideOverlap(labelList);
	        }
	      },
	      axisName: function (opt, axisModel, group, transformGroup) {
	        var name = retrieve(opt.axisName, axisModel.get('name'));
	
	        if (!name) {
	          return;
	        }
	
	        var nameLocation = axisModel.get('nameLocation');
	        var nameDirection = opt.nameDirection;
	        var textStyleModel = axisModel.getModel('nameTextStyle');
	        var gap = axisModel.get('nameGap') || 0;
	        var extent = axisModel.axis.getExtent();
	        var gapSignal = extent[0] > extent[1] ? -1 : 1;
	        var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // Reuse labelOffset.
	        isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
	        var labelLayout;
	        var nameRotation = axisModel.get('nameRotate');
	
	        if (nameRotation != null) {
	          nameRotation = nameRotation * PI$5 / 180; // To radian.
	        }
	
	        var axisNameAvailableWidth;
	
	        if (isNameLocationCenter(nameLocation)) {
	          labelLayout = AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
	          nameDirection);
	        } else {
	          labelLayout = endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
	          axisNameAvailableWidth = opt.axisNameAvailableWidth;
	
	          if (axisNameAvailableWidth != null) {
	            axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
	            !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
	          }
	        }
	
	        var textFont = textStyleModel.getFont();
	        var truncateOpt = axisModel.get('nameTruncate', true) || {};
	        var ellipsis = truncateOpt.ellipsis;
	        var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
	        var textEl = new ZRText({
	          x: pos[0],
	          y: pos[1],
	          rotation: labelLayout.rotation,
	          silent: AxisBuilder.isLabelSilent(axisModel),
	          style: createTextStyle(textStyleModel, {
	            text: name,
	            font: textFont,
	            overflow: 'truncate',
	            width: maxWidth,
	            ellipsis: ellipsis,
	            fill: textStyleModel.getTextColor() || axisModel.get(['axisLine', 'lineStyle', 'color']),
	            align: textStyleModel.get('align') || labelLayout.textAlign,
	            verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
	          }),
	          z2: 1
	        });
	        setTooltipConfig({
	          el: textEl,
	          componentModel: axisModel,
	          itemName: name
	        });
	        textEl.__fullText = name; // Id for animation
	
	        textEl.anid = 'name';
	
	        if (axisModel.get('triggerEvent')) {
	          var eventData = AxisBuilder.makeAxisEventDataBase(axisModel);
	          eventData.targetType = 'axisName';
	          eventData.name = name;
	          getECData(textEl).eventData = eventData;
	        } // FIXME
	
	
	        transformGroup.add(textEl);
	        textEl.updateTransform();
	        group.add(textEl);
	        textEl.decomposeTransform();
	      }
	    };
	
	    function endTextLayout(rotation, textPosition, textRotate, extent) {
	      var rotationDiff = remRadian(textRotate - rotation);
	      var textAlign;
	      var textVerticalAlign;
	      var inverse = extent[0] > extent[1];
	      var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
	
	      if (isRadianAroundZero(rotationDiff - PI$5 / 2)) {
	        textVerticalAlign = onLeft ? 'bottom' : 'top';
	        textAlign = 'center';
	      } else if (isRadianAroundZero(rotationDiff - PI$5 * 1.5)) {
	        textVerticalAlign = onLeft ? 'top' : 'bottom';
	        textAlign = 'center';
	      } else {
	        textVerticalAlign = 'middle';
	
	        if (rotationDiff < PI$5 * 1.5 && rotationDiff > PI$5 / 2) {
	          textAlign = onLeft ? 'left' : 'right';
	        } else {
	          textAlign = onLeft ? 'right' : 'left';
	        }
	      }
	
	      return {
	        rotation: rotationDiff,
	        textAlign: textAlign,
	        textVerticalAlign: textVerticalAlign
	      };
	    }
	
	    function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
	      if (shouldShowAllLabels(axisModel.axis)) {
	        return;
	      } // If min or max are user set, we need to check
	      // If the tick on min(max) are overlap on their neighbour tick
	      // If they are overlapped, we need to hide the min(max) tick label
	
	
	      var showMinLabel = axisModel.get(['axisLabel', 'showMinLabel']);
	      var showMaxLabel = axisModel.get(['axisLabel', 'showMaxLabel']); // FIXME
	      // Have not consider onBand yet, where tick els is more than label els.
	
	      labelEls = labelEls || [];
	      tickEls = tickEls || [];
	      var firstLabel = labelEls[0];
	      var nextLabel = labelEls[1];
	      var lastLabel = labelEls[labelEls.length - 1];
	      var prevLabel = labelEls[labelEls.length - 2];
	      var firstTick = tickEls[0];
	      var nextTick = tickEls[1];
	      var lastTick = tickEls[tickEls.length - 1];
	      var prevTick = tickEls[tickEls.length - 2];
	
	      if (showMinLabel === false) {
	        ignoreEl(firstLabel);
	        ignoreEl(firstTick);
	      } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
	        if (showMinLabel) {
	          ignoreEl(nextLabel);
	          ignoreEl(nextTick);
	        } else {
	          ignoreEl(firstLabel);
	          ignoreEl(firstTick);
	        }
	      }
	
	      if (showMaxLabel === false) {
	        ignoreEl(lastLabel);
	        ignoreEl(lastTick);
	      } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
	        if (showMaxLabel) {
	          ignoreEl(prevLabel);
	          ignoreEl(prevTick);
	        } else {
	          ignoreEl(lastLabel);
	          ignoreEl(lastTick);
	        }
	      }
	    }
	
	    function ignoreEl(el) {
	      el && (el.ignore = true);
	    }
	
	    function isTwoLabelOverlapped(current, next) {
	      // current and next has the same rotation.
	      var firstRect = current && current.getBoundingRect().clone();
	      var nextRect = next && next.getBoundingRect().clone();
	
	      if (!firstRect || !nextRect) {
	        return;
	      } // When checking intersect of two rotated labels, we use mRotationBack
	      // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
	
	
	      var mRotationBack = identity([]);
	      rotate(mRotationBack, mRotationBack, -current.rotation);
	      firstRect.applyTransform(mul$1([], mRotationBack, current.getLocalTransform()));
	      nextRect.applyTransform(mul$1([], mRotationBack, next.getLocalTransform()));
	      return firstRect.intersect(nextRect);
	    }
	
	    function isNameLocationCenter(nameLocation) {
	      return nameLocation === 'middle' || nameLocation === 'center';
	    }
	
	    function createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
	      var tickEls = [];
	      var pt1 = [];
	      var pt2 = [];
	
	      for (var i = 0; i < ticksCoords.length; i++) {
	        var tickCoord = ticksCoords[i].coord;
	        pt1[0] = tickCoord;
	        pt1[1] = 0;
	        pt2[0] = tickCoord;
	        pt2[1] = tickEndCoord;
	
	        if (tickTransform) {
	          applyTransform(pt1, pt1, tickTransform);
	          applyTransform(pt2, pt2, tickTransform);
	        } // Tick line, Not use group transform to have better line draw
	
	
	        var tickEl = new Line({
	          shape: {
	            x1: pt1[0],
	            y1: pt1[1],
	            x2: pt2[0],
	            y2: pt2[1]
	          },
	          style: tickLineStyle,
	          z2: 2,
	          autoBatch: true,
	          silent: true
	        });
	        subPixelOptimizeLine$1(tickEl.shape, tickEl.style.lineWidth);
	        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
	        tickEls.push(tickEl);
	      }
	
	      return tickEls;
	    }
	
	    function buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
	      var axis = axisModel.axis;
	      var tickModel = axisModel.getModel('axisTick');
	      var shown = tickModel.get('show');
	
	      if (shown === 'auto' && opt.handleAutoShown) {
	        shown = opt.handleAutoShown('axisTick');
	      }
	
	      if (!shown || axis.scale.isBlank()) {
	        return;
	      }
	
	      var lineStyleModel = tickModel.getModel('lineStyle');
	      var tickEndCoord = opt.tickDirection * tickModel.get('length');
	      var ticksCoords = axis.getTicksCoords();
	      var ticksEls = createTicks(ticksCoords, transformGroup.transform, tickEndCoord, defaults(lineStyleModel.getLineStyle(), {
	        stroke: axisModel.get(['axisLine', 'lineStyle', 'color'])
	      }), 'ticks');
	
	      for (var i = 0; i < ticksEls.length; i++) {
	        group.add(ticksEls[i]);
	      }
	
	      return ticksEls;
	    }
	
	    function buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
	      var axis = axisModel.axis;
	      var minorTickModel = axisModel.getModel('minorTick');
	
	      if (!minorTickModel.get('show') || axis.scale.isBlank()) {
	        return;
	      }
	
	      var minorTicksCoords = axis.getMinorTicksCoords();
	
	      if (!minorTicksCoords.length) {
	        return;
	      }
	
	      var lineStyleModel = minorTickModel.getModel('lineStyle');
	      var tickEndCoord = tickDirection * minorTickModel.get('length');
	      var minorTickLineStyle = defaults(lineStyleModel.getLineStyle(), defaults(axisModel.getModel('axisTick').getLineStyle(), {
	        stroke: axisModel.get(['axisLine', 'lineStyle', 'color'])
	      }));
	
	      for (var i = 0; i < minorTicksCoords.length; i++) {
	        var minorTicksEls = createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
	
	        for (var k = 0; k < minorTicksEls.length; k++) {
	          group.add(minorTicksEls[k]);
	        }
	      }
	    }
	
	    function buildAxisLabel(group, transformGroup, axisModel, opt) {
	      var axis = axisModel.axis;
	      var show = retrieve(opt.axisLabelShow, axisModel.get(['axisLabel', 'show']));
	
	      if (!show || axis.scale.isBlank()) {
	        return;
	      }
	
	      var labelModel = axisModel.getModel('axisLabel');
	      var labelMargin = labelModel.get('margin');
	      var labels = axis.getViewLabels(); // Special label rotate.
	
	      var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI$5 / 180;
	      var labelLayout = AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
	      var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
	      var labelEls = [];
	      var silent = AxisBuilder.isLabelSilent(axisModel);
	      var triggerEvent = axisModel.get('triggerEvent');
	      each(labels, function (labelItem, index) {
	        var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
	        var formattedLabel = labelItem.formattedLabel;
	        var rawLabel = labelItem.rawLabel;
	        var itemLabelModel = labelModel;
	
	        if (rawCategoryData && rawCategoryData[tickValue]) {
	          var rawCategoryItem = rawCategoryData[tickValue];
	
	          if (isObject(rawCategoryItem) && rawCategoryItem.textStyle) {
	            itemLabelModel = new Model(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
	          }
	        }
	
	        var textColor = itemLabelModel.getTextColor() || axisModel.get(['axisLine', 'lineStyle', 'color']);
	        var tickCoord = axis.dataToCoord(tickValue);
	        var textEl = new ZRText({
	          x: tickCoord,
	          y: opt.labelOffset + opt.labelDirection * labelMargin,
	          rotation: labelLayout.rotation,
	          silent: silent,
	          z2: 10 + (labelItem.level || 0),
	          style: createTextStyle(itemLabelModel, {
	            text: formattedLabel,
	            align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
	            verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
	            fill: isFunction(textColor) ? textColor( // (1) In category axis with data zoom, tick is not the original
	            // index of axis.data. So tick should not be exposed to user
	            // in category axis.
	            // (2) Compatible with previous version, which always use formatted label as
	            // input. But in interval scale the formatted label is like '223,445', which
	            // maked user replace ','. So we modify it to return original val but remain
	            // it as 'string' to avoid error in replacing.
	            axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
	          })
	        });
	        textEl.anid = 'label_' + tickValue; // Pack data for mouse event
	
	        if (triggerEvent) {
	          var eventData = AxisBuilder.makeAxisEventDataBase(axisModel);
	          eventData.targetType = 'axisLabel';
	          eventData.value = rawLabel;
	          eventData.tickIndex = index;
	
	          if (axis.type === 'category') {
	            eventData.dataIndex = tickValue;
	          }
	
	          getECData(textEl).eventData = eventData;
	        } // FIXME
	
	
	        transformGroup.add(textEl);
	        textEl.updateTransform();
	        labelEls.push(textEl);
	        group.add(textEl);
	        textEl.decomposeTransform();
	      });
	      return labelEls;
	    }
	
	    // allAxesInfo should be updated when setOption performed.
	
	    function collect(ecModel, api) {
	      var result = {
	        /**
	         * key: makeKey(axis.model)
	         * value: {
	         *      axis,
	         *      coordSys,
	         *      axisPointerModel,
	         *      triggerTooltip,
	         *      triggerEmphasis,
	         *      involveSeries,
	         *      snap,
	         *      seriesModels,
	         *      seriesDataCount
	         * }
	         */
	        axesInfo: {},
	        seriesInvolved: false,
	
	        /**
	         * key: makeKey(coordSys.model)
	         * value: Object: key makeKey(axis.model), value: axisInfo
	         */
	        coordSysAxesInfo: {},
	        coordSysMap: {}
	      };
	      collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
	
	      result.seriesInvolved && collectSeriesInfo(result, ecModel);
	      return result;
	    }
	
	    function collectAxesInfo(result, ecModel, api) {
	      var globalTooltipModel = ecModel.getComponent('tooltip');
	      var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
	
	      var linksOption = globalAxisPointerModel.get('link', true) || [];
	      var linkGroups = []; // Collect axes info.
	
	      each(api.getCoordinateSystems(), function (coordSys) {
	        // Some coordinate system do not support axes, like geo.
	        if (!coordSys.axisPointerEnabled) {
	          return;
	        }
	
	        var coordSysKey = makeKey(coordSys.model);
	        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
	        result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convenient way to show axisPointer
	        // for user. So we enable setting tooltip on coordSys model.
	
	        var coordSysModel = coordSys.model;
	        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
	        each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
	        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
	
	        if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
	        // show but axisPointer will show as normal.
	        && baseTooltipModel.get('show')) {
	          // Compatible with previous logic. But series.tooltip.trigger: 'axis'
	          // or series.data[n].tooltip.trigger: 'axis' are not support any more.
	          var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
	          var cross = baseTooltipModel.get(['axisPointer', 'type']) === 'cross';
	          var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get(['axisPointer', 'axis']));
	
	          if (triggerAxis || cross) {
	            each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
	          }
	
	          if (cross) {
	            each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
	          }
	        } // fromTooltip: true | false | 'cross'
	        // triggerTooltip: true | false | null
	
	
	        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
	          var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
	          var axisPointerShow = axisPointerModel.get('show');
	
	          if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
	            return;
	          }
	
	          if (triggerTooltip == null) {
	            triggerTooltip = axisPointerModel.get('triggerTooltip');
	          }
	
	          axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
	          var snap = axisPointerModel.get('snap');
	          var triggerEmphasis = axisPointerModel.get('triggerEmphasis');
	          var axisKey = makeKey(axis.model);
	          var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
	
	          var axisInfo = result.axesInfo[axisKey] = {
	            key: axisKey,
	            axis: axis,
	            coordSys: coordSys,
	            axisPointerModel: axisPointerModel,
	            triggerTooltip: triggerTooltip,
	            triggerEmphasis: triggerEmphasis,
	            involveSeries: involveSeries,
	            snap: snap,
	            useHandle: isHandleTrigger(axisPointerModel),
	            seriesModels: [],
	            linkGroup: null
	          };
	          axesInfoInCoordSys[axisKey] = axisInfo;
	          result.seriesInvolved = result.seriesInvolved || involveSeries;
	          var groupIndex = getLinkGroupIndex(linksOption, axis);
	
	          if (groupIndex != null) {
	            var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
	              axesInfo: {}
	            });
	            linkGroup.axesInfo[axisKey] = axisInfo;
	            linkGroup.mapper = linksOption[groupIndex].mapper;
	            axisInfo.linkGroup = linkGroup;
	          }
	        }
	      });
	    }
	
	    function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
	      var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
	      var fields = ['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'];
	      var volatileOption = {};
	      each(fields, function (field) {
	        volatileOption[field] = clone(tooltipAxisPointerModel.get(field));
	      }); // category axis do not auto snap, otherwise some tick that do not
	      // has value can not be hovered. value/time/log axis default snap if
	      // triggered from tooltip and trigger tooltip.
	
	      volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatible with previous behavior, tooltip axis does not show label by default.
	      // Only these properties can be overridden from tooltip to axisPointer.
	
	      if (tooltipAxisPointerModel.get('type') === 'cross') {
	        volatileOption.type = 'line';
	      }
	
	      var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
	
	      labelOption.show == null && (labelOption.show = false);
	
	      if (fromTooltip === 'cross') {
	        // When 'cross', both axes show labels.
	        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get(['label', 'show']);
	        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
	        // (cross style is dashed by default)
	
	        if (!triggerTooltip) {
	          var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
	          crossStyle && defaults(labelOption, crossStyle.textStyle);
	        }
	      }
	
	      return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
	    }
	
	    function collectSeriesInfo(result, ecModel) {
	      // Prepare data for axis trigger
	      ecModel.eachSeries(function (seriesModel) {
	        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
	        var coordSys = seriesModel.coordinateSystem;
	        var seriesTooltipTrigger = seriesModel.get(['tooltip', 'trigger'], true);
	        var seriesTooltipShow = seriesModel.get(['tooltip', 'show'], true);
	
	        if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get(['axisPointer', 'show'], true) === false) {
	          return;
	        }
	
	        each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
	          var axis = axisInfo.axis;
	
	          if (coordSys.getAxis(axis.dim) === axis) {
	            axisInfo.seriesModels.push(seriesModel);
	            axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
	            axisInfo.seriesDataCount += seriesModel.getData().count();
	          }
	        });
	      });
	    }
	    /**
	     * For example:
	     * {
	     *     axisPointer: {
	     *         links: [{
	     *             xAxisIndex: [2, 4],
	     *             yAxisIndex: 'all'
	     *         }, {
	     *             xAxisId: ['a5', 'a7'],
	     *             xAxisName: 'xxx'
	     *         }]
	     *     }
	     * }
	     */
	
	
	    function getLinkGroupIndex(linksOption, axis) {
	      var axisModel = axis.model;
	      var dim = axis.dim;
	
	      for (var i = 0; i < linksOption.length; i++) {
	        var linkOption = linksOption[i] || {};
	
	        if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
	          return i;
	        }
	      }
	    }
	
	    function checkPropInLink(linkPropValue, axisPropValue) {
	      return linkPropValue === 'all' || isArray(linkPropValue) && indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
	    }
	
	    function fixValue(axisModel) {
	      var axisInfo = getAxisInfo(axisModel);
	
	      if (!axisInfo) {
	        return;
	      }
	
	      var axisPointerModel = axisInfo.axisPointerModel;
	      var scale = axisInfo.axis.scale;
	      var option = axisPointerModel.option;
	      var status = axisPointerModel.get('status');
	      var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
	
	      if (value != null) {
	        value = scale.parse(value);
	      }
	
	      var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
	      // and status should be initialized.
	
	      if (status == null) {
	        option.status = useHandle ? 'show' : 'hide';
	      }
	
	      var extent = scale.getExtent().slice();
	      extent[0] > extent[1] && extent.reverse();
	
	      if ( // Pick a value on axis when initializing.
	      value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
	      // where we should re-pick a value to keep `handle` displaying normally.
	      || value > extent[1]) {
	        // Make handle displayed on the end of the axis when init, which looks better.
	        value = extent[1];
	      }
	
	      if (value < extent[0]) {
	        value = extent[0];
	      }
	
	      option.value = value;
	
	      if (useHandle) {
	        option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
	      }
	    }
	    function getAxisInfo(axisModel) {
	      var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
	      return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
	    }
	    function getAxisPointerModel(axisModel) {
	      var axisInfo = getAxisInfo(axisModel);
	      return axisInfo && axisInfo.axisPointerModel;
	    }
	
	    function isHandleTrigger(axisPointerModel) {
	      return !!axisPointerModel.get(['handle', 'show']);
	    }
	    /**
	     * @param {module:echarts/model/Model} model
	     * @return {string} unique key
	     */
	
	
	    function makeKey(model) {
	      return model.type + '||' + model.id;
	    }
	
	    var axisPointerClazz = {};
	    /**
	     * Base class of AxisView.
	     */
	
	    var AxisView =
	    /** @class */
	    function (_super) {
	      __extends(AxisView, _super);
	
	      function AxisView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = AxisView.type;
	        return _this;
	      }
	      /**
	       * @override
	       */
	
	
	      AxisView.prototype.render = function (axisModel, ecModel, api, payload) {
	        // FIXME
	        // This process should proformed after coordinate systems updated
	        // (axis scale updated), and should be performed each time update.
	        // So put it here temporarily, although it is not appropriate to
	        // put a model-writing procedure in `view`.
	        this.axisPointerClass && fixValue(axisModel);
	
	        _super.prototype.render.apply(this, arguments);
	
	        this._doUpdateAxisPointerClass(axisModel, api, true);
	      };
	      /**
	       * Action handler.
	       */
	
	
	      AxisView.prototype.updateAxisPointer = function (axisModel, ecModel, api, payload) {
	        this._doUpdateAxisPointerClass(axisModel, api, false);
	      };
	      /**
	       * @override
	       */
	
	
	      AxisView.prototype.remove = function (ecModel, api) {
	        var axisPointer = this._axisPointer;
	        axisPointer && axisPointer.remove(api);
	      };
	      /**
	       * @override
	       */
	
	
	      AxisView.prototype.dispose = function (ecModel, api) {
	        this._disposeAxisPointer(api);
	
	        _super.prototype.dispose.apply(this, arguments);
	      };
	
	      AxisView.prototype._doUpdateAxisPointerClass = function (axisModel, api, forceRender) {
	        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
	
	        if (!Clazz) {
	          return;
	        }
	
	        var axisPointerModel = getAxisPointerModel(axisModel);
	        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
	      };
	
	      AxisView.prototype._disposeAxisPointer = function (api) {
	        this._axisPointer && this._axisPointer.dispose(api);
	        this._axisPointer = null;
	      };
	
	      AxisView.registerAxisPointerClass = function (type, clazz) {
	        if (true) {
	          if (axisPointerClazz[type]) {
	            throw new Error('axisPointer ' + type + ' exists');
	          }
	        }
	
	        axisPointerClazz[type] = clazz;
	      };
	
	      AxisView.getAxisPointerClass = function (type) {
	        return type && axisPointerClazz[type];
	      };
	      AxisView.type = 'axis';
	      return AxisView;
	    }(ComponentView);
	
	    var inner$6 = makeInner();
	    function rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
	      var axis = axisModel.axis;
	
	      if (axis.scale.isBlank()) {
	        return;
	      } // TODO: TYPE
	
	
	      var splitAreaModel = axisModel.getModel('splitArea');
	      var areaStyleModel = splitAreaModel.getModel('areaStyle');
	      var areaColors = areaStyleModel.get('color');
	      var gridRect = gridModel.coordinateSystem.getRect();
	      var ticksCoords = axis.getTicksCoords({
	        tickModel: splitAreaModel,
	        clamp: true
	      });
	
	      if (!ticksCoords.length) {
	        return;
	      } // For Making appropriate splitArea animation, the color and anid
	      // should be corresponding to previous one if possible.
	
	
	      var areaColorsLen = areaColors.length;
	      var lastSplitAreaColors = inner$6(axisView).splitAreaColors;
	      var newSplitAreaColors = createHashMap();
	      var colorIndex = 0;
	
	      if (lastSplitAreaColors) {
	        for (var i = 0; i < ticksCoords.length; i++) {
	          var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
	
	          if (cIndex != null) {
	            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
	            break;
	          }
	        }
	      }
	
	      var prev = axis.toGlobalCoord(ticksCoords[0].coord);
	      var areaStyle = areaStyleModel.getAreaStyle();
	      areaColors = isArray(areaColors) ? areaColors : [areaColors];
	
	      for (var i = 1; i < ticksCoords.length; i++) {
	        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	        var x = void 0;
	        var y = void 0;
	        var width = void 0;
	        var height = void 0;
	
	        if (axis.isHorizontal()) {
	          x = prev;
	          y = gridRect.y;
	          width = tickCoord - x;
	          height = gridRect.height;
	          prev = x + width;
	        } else {
	          x = gridRect.x;
	          y = prev;
	          width = gridRect.width;
	          height = tickCoord - y;
	          prev = y + height;
	        }
	
	        var tickValue = ticksCoords[i - 1].tickValue;
	        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
	        axisGroup.add(new Rect({
	          anid: tickValue != null ? 'area_' + tickValue : null,
	          shape: {
	            x: x,
	            y: y,
	            width: width,
	            height: height
	          },
	          style: defaults({
	            fill: areaColors[colorIndex]
	          }, areaStyle),
	          autoBatch: true,
	          silent: true
	        }));
	        colorIndex = (colorIndex + 1) % areaColorsLen;
	      }
	
	      inner$6(axisView).splitAreaColors = newSplitAreaColors;
	    }
	    function rectCoordAxisHandleRemove(axisView) {
	      inner$6(axisView).splitAreaColors = null;
	    }
	
	    var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	    var selfBuilderAttrs = ['splitArea', 'splitLine', 'minorSplitLine'];
	
	    var CartesianAxisView =
	    /** @class */
	    function (_super) {
	      __extends(CartesianAxisView, _super);
	
	      function CartesianAxisView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = CartesianAxisView.type;
	        _this.axisPointerClass = 'CartesianAxisPointer';
	        return _this;
	      }
	      /**
	       * @override
	       */
	
	
	      CartesianAxisView.prototype.render = function (axisModel, ecModel, api, payload) {
	        this.group.removeAll();
	        var oldAxisGroup = this._axisGroup;
	        this._axisGroup = new Group();
	        this.group.add(this._axisGroup);
	
	        if (!axisModel.get('show')) {
	          return;
	        }
	
	        var gridModel = axisModel.getCoordSysModel();
	        var layout = layout$1(gridModel, axisModel);
	        var axisBuilder = new AxisBuilder(axisModel, extend({
	          handleAutoShown: function (elementType) {
	            var cartesians = gridModel.coordinateSystem.getCartesians();
	
	            for (var i = 0; i < cartesians.length; i++) {
	              if (isIntervalOrLogScale(cartesians[i].getOtherAxis(axisModel.axis).scale)) {
	                // Still show axis tick or axisLine if other axis is value / log
	                return true;
	              }
	            } // Not show axisTick or axisLine if other axis is category / time
	
	
	            return false;
	          }
	        }, layout));
	        each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	
	        this._axisGroup.add(axisBuilder.getGroup());
	
	        each(selfBuilderAttrs, function (name) {
	          if (axisModel.get([name, 'show'])) {
	            axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
	          }
	        }, this); // THIS is a special case for bar racing chart.
	        // Update the axis label from the natural initial layout to
	        // sorted layout should has no animation.
	
	        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
	
	        if (!isInitialSortFromBarRacing) {
	          groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	        }
	
	        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
	      };
	
	      CartesianAxisView.prototype.remove = function () {
	        rectCoordAxisHandleRemove(this);
	      };
	
	      CartesianAxisView.type = 'cartesianAxis';
	      return CartesianAxisView;
	    }(AxisView);
	
	    var axisElementBuilders = {
	      splitLine: function (axisView, axisGroup, axisModel, gridModel) {
	        var axis = axisModel.axis;
	
	        if (axis.scale.isBlank()) {
	          return;
	        }
	
	        var splitLineModel = axisModel.getModel('splitLine');
	        var lineStyleModel = splitLineModel.getModel('lineStyle');
	        var lineColors = lineStyleModel.get('color');
	        lineColors = isArray(lineColors) ? lineColors : [lineColors];
	        var gridRect = gridModel.coordinateSystem.getRect();
	        var isHorizontal = axis.isHorizontal();
	        var lineCount = 0;
	        var ticksCoords = axis.getTicksCoords({
	          tickModel: splitLineModel
	        });
	        var p1 = [];
	        var p2 = [];
	        var lineStyle = lineStyleModel.getLineStyle();
	
	        for (var i = 0; i < ticksCoords.length; i++) {
	          var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	          if (isHorizontal) {
	            p1[0] = tickCoord;
	            p1[1] = gridRect.y;
	            p2[0] = tickCoord;
	            p2[1] = gridRect.y + gridRect.height;
	          } else {
	            p1[0] = gridRect.x;
	            p1[1] = tickCoord;
	            p2[0] = gridRect.x + gridRect.width;
	            p2[1] = tickCoord;
	          }
	
	          var colorIndex = lineCount++ % lineColors.length;
	          var tickValue = ticksCoords[i].tickValue;
	          var line = new Line({
	            anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
	            autoBatch: true,
	            shape: {
	              x1: p1[0],
	              y1: p1[1],
	              x2: p2[0],
	              y2: p2[1]
	            },
	            style: defaults({
	              stroke: lineColors[colorIndex]
	            }, lineStyle),
	            silent: true
	          });
	          subPixelOptimizeLine$1(line.shape, lineStyle.lineWidth);
	          axisGroup.add(line);
	        }
	      },
	      minorSplitLine: function (axisView, axisGroup, axisModel, gridModel) {
	        var axis = axisModel.axis;
	        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
	        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	        var gridRect = gridModel.coordinateSystem.getRect();
	        var isHorizontal = axis.isHorizontal();
	        var minorTicksCoords = axis.getMinorTicksCoords();
	
	        if (!minorTicksCoords.length) {
	          return;
	        }
	
	        var p1 = [];
	        var p2 = [];
	        var lineStyle = lineStyleModel.getLineStyle();
	
	        for (var i = 0; i < minorTicksCoords.length; i++) {
	          for (var k = 0; k < minorTicksCoords[i].length; k++) {
	            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
	
	            if (isHorizontal) {
	              p1[0] = tickCoord;
	              p1[1] = gridRect.y;
	              p2[0] = tickCoord;
	              p2[1] = gridRect.y + gridRect.height;
	            } else {
	              p1[0] = gridRect.x;
	              p1[1] = tickCoord;
	              p2[0] = gridRect.x + gridRect.width;
	              p2[1] = tickCoord;
	            }
	
	            var line = new Line({
	              anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
	              autoBatch: true,
	              shape: {
	                x1: p1[0],
	                y1: p1[1],
	                x2: p2[0],
	                y2: p2[1]
	              },
	              style: lineStyle,
	              silent: true
	            });
	            subPixelOptimizeLine$1(line.shape, lineStyle.lineWidth);
	            axisGroup.add(line);
	          }
	        }
	      },
	      splitArea: function (axisView, axisGroup, axisModel, gridModel) {
	        rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel);
	      }
	    };
	
	    var CartesianXAxisView =
	    /** @class */
	    function (_super) {
	      __extends(CartesianXAxisView, _super);
	
	      function CartesianXAxisView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = CartesianXAxisView.type;
	        return _this;
	      }
	
	      CartesianXAxisView.type = 'xAxis';
	      return CartesianXAxisView;
	    }(CartesianAxisView);
	
	    var CartesianYAxisView =
	    /** @class */
	    function (_super) {
	      __extends(CartesianYAxisView, _super);
	
	      function CartesianYAxisView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = CartesianXAxisView.type;
	        return _this;
	      }
	
	      CartesianYAxisView.type = 'yAxis';
	      return CartesianYAxisView;
	    }(CartesianAxisView);
	
	    var GridView =
	    /** @class */
	    function (_super) {
	      __extends(GridView, _super);
	
	      function GridView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = 'grid';
	        return _this;
	      }
	
	      GridView.prototype.render = function (gridModel, ecModel) {
	        this.group.removeAll();
	
	        if (gridModel.get('show')) {
	          this.group.add(new Rect({
	            shape: gridModel.coordinateSystem.getRect(),
	            style: defaults({
	              fill: gridModel.get('backgroundColor')
	            }, gridModel.getItemStyle()),
	            silent: true,
	            z2: -1
	          }));
	        }
	      };
	
	      GridView.type = 'grid';
	      return GridView;
	    }(ComponentView);
	
	    var extraOption = {
	      // gridIndex: 0,
	      // gridId: '',
	      offset: 0
	    };
	    function install$5(registers) {
	      registers.registerComponentView(GridView);
	      registers.registerComponentModel(GridModel);
	      registers.registerCoordinateSystem('cartesian2d', Grid);
	      axisModelCreator(registers, 'x', CartesianAxisModel, extraOption);
	      axisModelCreator(registers, 'y', CartesianAxisModel, extraOption);
	      registers.registerComponentView(CartesianXAxisView);
	      registers.registerComponentView(CartesianYAxisView);
	      registers.registerPreprocessor(function (option) {
	        // Only create grid when need
	        if (option.xAxis && option.yAxis && !option.grid) {
	          option.grid = {};
	        }
	      });
	    }
	
	    function install$6(registers) {
	      // In case developer forget to include grid component
	      use(install$5);
	      registers.registerSeriesModel(ScatterSeriesModel);
	      registers.registerChartView(ScatterView);
	      registers.registerLayout(pointsLayout('scatter'));
	    }
	
	    function radarLayout(ecModel) {
	      ecModel.eachSeriesByType('radar', function (seriesModel) {
	        var data = seriesModel.getData();
	        var points = [];
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (!coordSys) {
	          return;
	        }
	
	        var axes = coordSys.getIndicatorAxes();
	        each(axes, function (axis, axisIndex) {
	          data.each(data.mapDimension(axes[axisIndex].dim), function (val, dataIndex) {
	            points[dataIndex] = points[dataIndex] || [];
	            var point = coordSys.dataToPoint(val, axisIndex);
	            points[dataIndex][axisIndex] = isValidPoint(point) ? point : getValueMissingPoint(coordSys);
	          });
	        }); // Close polygon
	
	        data.each(function (idx) {
	          // TODO
	          // Is it appropriate to connect to the next data when some data is missing?
	          // Or, should trade it like `connectNull` in line chart?
	          var firstPoint = find(points[idx], function (point) {
	            return isValidPoint(point);
	          }) || getValueMissingPoint(coordSys); // Copy the first actual point to the end of the array
	
	          points[idx].push(firstPoint.slice());
	          data.setItemLayout(idx, points[idx]);
	        });
	      });
	    }
	
	    function isValidPoint(point) {
	      return !isNaN(point[0]) && !isNaN(point[1]);
	    }
	
	    function getValueMissingPoint(coordSys) {
	      // It is error-prone to input [NaN, NaN] into polygon, polygon.
	      // (probably cause problem when refreshing or animating)
	      return [coordSys.cx, coordSys.cy];
	    }
	
	    function radarBackwardCompat(option) {
	      var polarOptArr = option.polar;
	
	      if (polarOptArr) {
	        if (!isArray(polarOptArr)) {
	          polarOptArr = [polarOptArr];
	        }
	
	        var polarNotRadar_1 = [];
	        each(polarOptArr, function (polarOpt, idx) {
	          if (polarOpt.indicator) {
	            if (polarOpt.type && !polarOpt.shape) {
	              polarOpt.shape = polarOpt.type;
	            }
	
	            option.radar = option.radar || [];
	
	            if (!isArray(option.radar)) {
	              option.radar = [option.radar];
	            }
	
	            option.radar.push(polarOpt);
	          } else {
	            polarNotRadar_1.push(polarOpt);
	          }
	        });
	        option.polar = polarNotRadar_1;
	      }
	
	      each(option.series, function (seriesOpt) {
	        if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
	          seriesOpt.radarIndex = seriesOpt.polarIndex;
	        }
	      });
	    }
	
	    var RadarView =
	    /** @class */
	    function (_super) {
	      __extends(RadarView, _super);
	
	      function RadarView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = RadarView.type;
	        return _this;
	      }
	
	      RadarView.prototype.render = function (seriesModel, ecModel, api) {
	        var polar = seriesModel.coordinateSystem;
	        var group = this.group;
	        var data = seriesModel.getData();
	        var oldData = this._data;
	
	        function createSymbol$1(data, idx) {
	          var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	
	          if (symbolType === 'none') {
	            return;
	          }
	
	          var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	          var symbolPath = createSymbol(symbolType, -1, -1, 2, 2);
	          var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
	          symbolPath.attr({
	            style: {
	              strokeNoScale: true
	            },
	            z2: 100,
	            scaleX: symbolSize[0] / 2,
	            scaleY: symbolSize[1] / 2,
	            rotation: symbolRotate * Math.PI / 180 || 0
	          });
	          return symbolPath;
	        }
	
	        function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
	          // Simply rerender all
	          symbolGroup.removeAll();
	
	          for (var i = 0; i < newPoints.length - 1; i++) {
	            var symbolPath = createSymbol$1(data, idx);
	
	            if (symbolPath) {
	              symbolPath.__dimIdx = i;
	
	              if (oldPoints[i]) {
	                symbolPath.setPosition(oldPoints[i]);
	                graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
	                  x: newPoints[i][0],
	                  y: newPoints[i][1]
	                }, seriesModel, idx);
	              } else {
	                symbolPath.setPosition(newPoints[i]);
	              }
	
	              symbolGroup.add(symbolPath);
	            }
	          }
	        }
	
	        function getInitialPoints(points) {
	          return map(points, function (pt) {
	            return [polar.cx, polar.cy];
	          });
	        }
	
	        data.diff(oldData).add(function (idx) {
	          var points = data.getItemLayout(idx);
	
	          if (!points) {
	            return;
	          }
	
	          var polygon = new Polygon();
	          var polyline = new Polyline();
	          var target = {
	            shape: {
	              points: points
	            }
	          };
	          polygon.shape.points = getInitialPoints(points);
	          polyline.shape.points = getInitialPoints(points);
	          initProps(polygon, target, seriesModel, idx);
	          initProps(polyline, target, seriesModel, idx);
	          var itemGroup = new Group();
	          var symbolGroup = new Group();
	          itemGroup.add(polyline);
	          itemGroup.add(polygon);
	          itemGroup.add(symbolGroup);
	          updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
	          data.setItemGraphicEl(idx, itemGroup);
	        }).update(function (newIdx, oldIdx) {
	          var itemGroup = oldData.getItemGraphicEl(oldIdx);
	          var polyline = itemGroup.childAt(0);
	          var polygon = itemGroup.childAt(1);
	          var symbolGroup = itemGroup.childAt(2);
	          var target = {
	            shape: {
	              points: data.getItemLayout(newIdx)
	            }
	          };
	
	          if (!target.shape.points) {
	            return;
	          }
	
	          updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
	          saveOldStyle(polygon);
	          saveOldStyle(polyline);
	          updateProps(polyline, target, seriesModel);
	          updateProps(polygon, target, seriesModel);
	          data.setItemGraphicEl(newIdx, itemGroup);
	        }).remove(function (idx) {
	          group.remove(oldData.getItemGraphicEl(idx));
	        }).execute();
	        data.eachItemGraphicEl(function (itemGroup, idx) {
	          var itemModel = data.getItemModel(idx);
	          var polyline = itemGroup.childAt(0);
	          var polygon = itemGroup.childAt(1);
	          var symbolGroup = itemGroup.childAt(2); // Radar uses the visual encoded from itemStyle.
	
	          var itemStyle = data.getItemVisual(idx, 'style');
	          var color = itemStyle.fill;
	          group.add(itemGroup);
	          polyline.useStyle(defaults(itemModel.getModel('lineStyle').getLineStyle(), {
	            fill: 'none',
	            stroke: color
	          }));
	          setStatesStylesFromModel(polyline, itemModel, 'lineStyle');
	          setStatesStylesFromModel(polygon, itemModel, 'areaStyle');
	          var areaStyleModel = itemModel.getModel('areaStyle');
	          var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
	          polygon.ignore = polygonIgnore;
	          each(['emphasis', 'select', 'blur'], function (stateName) {
	            var stateModel = itemModel.getModel([stateName, 'areaStyle']);
	            var stateIgnore = stateModel.isEmpty() && stateModel.parentModel.isEmpty(); // Won't be ignore if normal state is not ignore.
	
	            polygon.ensureState(stateName).ignore = stateIgnore && polygonIgnore;
	          });
	          polygon.useStyle(defaults(areaStyleModel.getAreaStyle(), {
	            fill: color,
	            opacity: 0.7,
	            decal: itemStyle.decal
	          }));
	          var emphasisModel = itemModel.getModel('emphasis');
	          var itemHoverStyle = emphasisModel.getModel('itemStyle').getItemStyle();
	          symbolGroup.eachChild(function (symbolPath) {
	            if (symbolPath instanceof ZRImage) {
	              var pathStyle = symbolPath.style;
	              symbolPath.useStyle(extend({
	                // TODO other properties like x, y ?
	                image: pathStyle.image,
	                x: pathStyle.x,
	                y: pathStyle.y,
	                width: pathStyle.width,
	                height: pathStyle.height
	              }, itemStyle));
	            } else {
	              symbolPath.useStyle(itemStyle);
	              symbolPath.setColor(color);
	              symbolPath.style.strokeNoScale = true;
	            }
	
	            var pathEmphasisState = symbolPath.ensureState('emphasis');
	            pathEmphasisState.style = clone(itemHoverStyle);
	            var defaultText = data.getStore().get(data.getDimensionIndex(symbolPath.__dimIdx), idx);
	            (defaultText == null || isNaN(defaultText)) && (defaultText = '');
	            setLabelStyle(symbolPath, getLabelStatesModels(itemModel), {
	              labelFetcher: data.hostModel,
	              labelDataIndex: idx,
	              labelDimIndex: symbolPath.__dimIdx,
	              defaultText: defaultText,
	              inheritColor: color,
	              defaultOpacity: itemStyle.opacity
	            });
	          });
	          toggleHoverEmphasis(itemGroup, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	        });
	        this._data = data;
	      };
	
	      RadarView.prototype.remove = function () {
	        this.group.removeAll();
	        this._data = null;
	      };
	
	      RadarView.type = 'radar';
	      return RadarView;
	    }(ChartView);
	
	    var RadarSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(RadarSeriesModel, _super);
	
	      function RadarSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = RadarSeriesModel.type;
	        _this.hasSymbolVisual = true;
	        return _this;
	      } // Overwrite
	
	
	      RadarSeriesModel.prototype.init = function (option) {
	        _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
	        // Use a function instead of direct access because data reference may changed
	
	
	        this.legendVisualProvider = new LegendVisualProvider(bind(this.getData, this), bind(this.getRawData, this));
	      };
	
	      RadarSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return createSeriesDataSimply(this, {
	          generateCoord: 'indicator_',
	          generateCoordCount: Infinity
	        });
	      };
	
	      RadarSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        var data = this.getData();
	        var coordSys = this.coordinateSystem;
	        var indicatorAxes = coordSys.getIndicatorAxes();
	        var name = this.getData().getName(dataIndex);
	        var nameToDisplay = name === '' ? this.name : name;
	        var markerColor = retrieveVisualColorForTooltipMarker(this, dataIndex);
	        return createTooltipMarkup('section', {
	          header: nameToDisplay,
	          sortBlocks: true,
	          blocks: map(indicatorAxes, function (axis) {
	            var val = data.get(data.mapDimension(axis.dim), dataIndex);
	            return createTooltipMarkup('nameValue', {
	              markerType: 'subItem',
	              markerColor: markerColor,
	              name: axis.name,
	              value: val,
	              sortParam: val
	            });
	          })
	        });
	      };
	
	      RadarSeriesModel.prototype.getTooltipPosition = function (dataIndex) {
	        if (dataIndex != null) {
	          var data_1 = this.getData();
	          var coordSys = this.coordinateSystem;
	          var values = data_1.getValues(map(coordSys.dimensions, function (dim) {
	            return data_1.mapDimension(dim);
	          }), dataIndex);
	
	          for (var i = 0, len = values.length; i < len; i++) {
	            if (!isNaN(values[i])) {
	              var indicatorAxes = coordSys.getIndicatorAxes();
	              return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
	            }
	          }
	        }
	      };
	
	      RadarSeriesModel.type = 'series.radar';
	      RadarSeriesModel.dependencies = ['radar'];
	      RadarSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        colorBy: 'data',
	        coordinateSystem: 'radar',
	        legendHoverLink: true,
	        radarIndex: 0,
	        lineStyle: {
	          width: 2,
	          type: 'solid',
	          join: 'round'
	        },
	        label: {
	          position: 'top'
	        },
	        // areaStyle: {
	        // },
	        // itemStyle: {}
	        symbolSize: 8 // symbolRotate: null
	
	      };
	      return RadarSeriesModel;
	    }(SeriesModel);
	
	    var valueAxisDefault = axisDefault.value;
	
	    function defaultsShow(opt, show) {
	      return defaults({
	        show: show
	      }, opt);
	    }
	
	    var RadarModel =
	    /** @class */
	    function (_super) {
	      __extends(RadarModel, _super);
	
	      function RadarModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = RadarModel.type;
	        return _this;
	      }
	
	      RadarModel.prototype.optionUpdated = function () {
	        var boundaryGap = this.get('boundaryGap');
	        var splitNumber = this.get('splitNumber');
	        var scale = this.get('scale');
	        var axisLine = this.get('axisLine');
	        var axisTick = this.get('axisTick'); // let axisType = this.get('axisType');
	
	        var axisLabel = this.get('axisLabel');
	        var nameTextStyle = this.get('axisName');
	        var showName = this.get(['axisName', 'show']);
	        var nameFormatter = this.get(['axisName', 'formatter']);
	        var nameGap = this.get('axisNameGap');
	        var triggerEvent = this.get('triggerEvent');
	        var indicatorModels = map(this.get('indicator') || [], function (indicatorOpt) {
	          // PENDING
	          if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
	            indicatorOpt.min = 0;
	          } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
	            indicatorOpt.max = 0;
	          }
	
	          var iNameTextStyle = nameTextStyle;
	
	          if (indicatorOpt.color != null) {
	            iNameTextStyle = defaults({
	              color: indicatorOpt.color
	            }, nameTextStyle);
	          } // Use same configuration
	
	
	          var innerIndicatorOpt = merge(clone(indicatorOpt), {
	            boundaryGap: boundaryGap,
	            splitNumber: splitNumber,
	            scale: scale,
	            axisLine: axisLine,
	            axisTick: axisTick,
	            // axisType: axisType,
	            axisLabel: axisLabel,
	            // Compatible with 2 and use text
	            name: indicatorOpt.text,
	            showName: showName,
	            nameLocation: 'end',
	            nameGap: nameGap,
	            // min: 0,
	            nameTextStyle: iNameTextStyle,
	            triggerEvent: triggerEvent
	          }, false);
	
	          if (isString(nameFormatter)) {
	            var indName = innerIndicatorOpt.name;
	            innerIndicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
	          } else if (isFunction(nameFormatter)) {
	            innerIndicatorOpt.name = nameFormatter(innerIndicatorOpt.name, innerIndicatorOpt);
	          }
	
	          var model = new Model(innerIndicatorOpt, null, this.ecModel);
	          mixin(model, AxisModelCommonMixin.prototype); // For triggerEvent.
	
	          model.mainType = 'radar';
	          model.componentIndex = this.componentIndex;
	          return model;
	        }, this);
	        this._indicatorModels = indicatorModels;
	      };
	
	      RadarModel.prototype.getIndicatorModels = function () {
	        return this._indicatorModels;
	      };
	
	      RadarModel.type = 'radar';
	      RadarModel.defaultOption = {
	        // zlevel: 0,
	        z: 0,
	        center: ['50%', '50%'],
	        radius: '75%',
	        startAngle: 90,
	        axisName: {
	          show: true // formatter: null
	          // textStyle: {}
	
	        },
	        boundaryGap: [0, 0],
	        splitNumber: 5,
	        axisNameGap: 15,
	        scale: false,
	        // Polygon or circle
	        shape: 'polygon',
	        axisLine: merge({
	          lineStyle: {
	            color: '#bbb'
	          }
	        }, valueAxisDefault.axisLine),
	        axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
	        axisTick: defaultsShow(valueAxisDefault.axisTick, false),
	        // axisType: 'value',
	        splitLine: defaultsShow(valueAxisDefault.splitLine, true),
	        splitArea: defaultsShow(valueAxisDefault.splitArea, true),
	        // {text, min, max}
	        indicator: []
	      };
	      return RadarModel;
	    }(ComponentModel);
	
	    var axisBuilderAttrs$1 = ['axisLine', 'axisTickLabel', 'axisName'];
	
	    var RadarView$1 =
	    /** @class */
	    function (_super) {
	      __extends(RadarView, _super);
	
	      function RadarView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = RadarView.type;
	        return _this;
	      }
	
	      RadarView.prototype.render = function (radarModel, ecModel, api) {
	        var group = this.group;
	        group.removeAll();
	
	        this._buildAxes(radarModel);
	
	        this._buildSplitLineAndArea(radarModel);
	      };
	
	      RadarView.prototype._buildAxes = function (radarModel) {
	        var radar = radarModel.coordinateSystem;
	        var indicatorAxes = radar.getIndicatorAxes();
	        var axisBuilders = map(indicatorAxes, function (indicatorAxis) {
	          var axisName = indicatorAxis.model.get('showName') ? indicatorAxis.name : ''; // hide name
	
	          var axisBuilder = new AxisBuilder(indicatorAxis.model, {
	            axisName: axisName,
	            position: [radar.cx, radar.cy],
	            rotation: indicatorAxis.angle,
	            labelDirection: -1,
	            tickDirection: -1,
	            nameDirection: 1
	          });
	          return axisBuilder;
	        });
	        each(axisBuilders, function (axisBuilder) {
	          each(axisBuilderAttrs$1, axisBuilder.add, axisBuilder);
	          this.group.add(axisBuilder.getGroup());
	        }, this);
	      };
	
	      RadarView.prototype._buildSplitLineAndArea = function (radarModel) {
	        var radar = radarModel.coordinateSystem;
	        var indicatorAxes = radar.getIndicatorAxes();
	
	        if (!indicatorAxes.length) {
	          return;
	        }
	
	        var shape = radarModel.get('shape');
	        var splitLineModel = radarModel.getModel('splitLine');
	        var splitAreaModel = radarModel.getModel('splitArea');
	        var lineStyleModel = splitLineModel.getModel('lineStyle');
	        var areaStyleModel = splitAreaModel.getModel('areaStyle');
	        var showSplitLine = splitLineModel.get('show');
	        var showSplitArea = splitAreaModel.get('show');
	        var splitLineColors = lineStyleModel.get('color');
	        var splitAreaColors = areaStyleModel.get('color');
	        var splitLineColorsArr = isArray(splitLineColors) ? splitLineColors : [splitLineColors];
	        var splitAreaColorsArr = isArray(splitAreaColors) ? splitAreaColors : [splitAreaColors];
	        var splitLines = [];
	        var splitAreas = [];
	
	        function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
	          var colorIndex = idx % areaOrLineColorList.length;
	          areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
	          return colorIndex;
	        }
	
	        if (shape === 'circle') {
	          var ticksRadius = indicatorAxes[0].getTicksCoords();
	          var cx = radar.cx;
	          var cy = radar.cy;
	
	          for (var i = 0; i < ticksRadius.length; i++) {
	            if (showSplitLine) {
	              var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
	              splitLines[colorIndex].push(new Circle({
	                shape: {
	                  cx: cx,
	                  cy: cy,
	                  r: ticksRadius[i].coord
	                }
	              }));
	            }
	
	            if (showSplitArea && i < ticksRadius.length - 1) {
	              var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i);
	              splitAreas[colorIndex].push(new Ring({
	                shape: {
	                  cx: cx,
	                  cy: cy,
	                  r0: ticksRadius[i].coord,
	                  r: ticksRadius[i + 1].coord
	                }
	              }));
	            }
	          }
	        } // Polyyon
	        else {
	            var realSplitNumber_1;
	            var axesTicksPoints = map(indicatorAxes, function (indicatorAxis, idx) {
	              var ticksCoords = indicatorAxis.getTicksCoords();
	              realSplitNumber_1 = realSplitNumber_1 == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber_1);
	              return map(ticksCoords, function (tickCoord) {
	                return radar.coordToPoint(tickCoord.coord, idx);
	              });
	            });
	            var prevPoints = [];
	
	            for (var i = 0; i <= realSplitNumber_1; i++) {
	              var points = [];
	
	              for (var j = 0; j < indicatorAxes.length; j++) {
	                points.push(axesTicksPoints[j][i]);
	              } // Close
	
	
	              if (points[0]) {
	                points.push(points[0].slice());
	              } else {
	                if (true) {
	                  console.error('Can\'t draw value axis ' + i);
	                }
	              }
	
	              if (showSplitLine) {
	                var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
	                splitLines[colorIndex].push(new Polyline({
	                  shape: {
	                    points: points
	                  }
	                }));
	              }
	
	              if (showSplitArea && prevPoints) {
	                var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i - 1);
	                splitAreas[colorIndex].push(new Polygon({
	                  shape: {
	                    points: points.concat(prevPoints)
	                  }
	                }));
	              }
	
	              prevPoints = points.slice().reverse();
	            }
	          }
	
	        var lineStyle = lineStyleModel.getLineStyle();
	        var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine
	
	        each(splitAreas, function (splitAreas, idx) {
	          this.group.add(mergePath$1(splitAreas, {
	            style: defaults({
	              stroke: 'none',
	              fill: splitAreaColorsArr[idx % splitAreaColorsArr.length]
	            }, areaStyle),
	            silent: true
	          }));
	        }, this);
	        each(splitLines, function (splitLines, idx) {
	          this.group.add(mergePath$1(splitLines, {
	            style: defaults({
	              fill: 'none',
	              stroke: splitLineColorsArr[idx % splitLineColorsArr.length]
	            }, lineStyle),
	            silent: true
	          }));
	        }, this);
	      };
	
	      RadarView.type = 'radar';
	      return RadarView;
	    }(ComponentView);
	
	    var IndicatorAxis =
	    /** @class */
	    function (_super) {
	      __extends(IndicatorAxis, _super);
	
	      function IndicatorAxis(dim, scale, radiusExtent) {
	        var _this = _super.call(this, dim, scale, radiusExtent) || this;
	
	        _this.type = 'value';
	        _this.angle = 0;
	        _this.name = '';
	        return _this;
	      }
	
	      return IndicatorAxis;
	    }(Axis);
	
	    var Radar =
	    /** @class */
	    function () {
	      function Radar(radarModel, ecModel, api) {
	        /**
	         *
	         * Radar dimensions
	         */
	        this.dimensions = [];
	        this._model = radarModel;
	        this._indicatorAxes = map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
	          var dim = 'indicator_' + idx;
	          var indicatorAxis = new IndicatorAxis(dim, new IntervalScale() // (indicatorModel.get('axisType') === 'log') ? new LogScale() : new IntervalScale()
	          );
	          indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis
	
	          indicatorAxis.model = indicatorModel;
	          indicatorModel.axis = indicatorAxis;
	          this.dimensions.push(dim);
	          return indicatorAxis;
	        }, this);
	        this.resize(radarModel, api);
	      }
	
	      Radar.prototype.getIndicatorAxes = function () {
	        return this._indicatorAxes;
	      };
	
	      Radar.prototype.dataToPoint = function (value, indicatorIndex) {
	        var indicatorAxis = this._indicatorAxes[indicatorIndex];
	        return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
	      }; // TODO: API should be coordToPoint([coord, indicatorIndex])
	
	
	      Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
	        var indicatorAxis = this._indicatorAxes[indicatorIndex];
	        var angle = indicatorAxis.angle;
	        var x = this.cx + coord * Math.cos(angle);
	        var y = this.cy - coord * Math.sin(angle);
	        return [x, y];
	      };
	
	      Radar.prototype.pointToData = function (pt) {
	        var dx = pt[0] - this.cx;
	        var dy = pt[1] - this.cy;
	        var radius = Math.sqrt(dx * dx + dy * dy);
	        dx /= radius;
	        dy /= radius;
	        var radian = Math.atan2(-dy, dx); // Find the closest angle
	        // FIXME index can calculated directly
	
	        var minRadianDiff = Infinity;
	        var closestAxis;
	        var closestAxisIdx = -1;
	
	        for (var i = 0; i < this._indicatorAxes.length; i++) {
	          var indicatorAxis = this._indicatorAxes[i];
	          var diff = Math.abs(radian - indicatorAxis.angle);
	
	          if (diff < minRadianDiff) {
	            closestAxis = indicatorAxis;
	            closestAxisIdx = i;
	            minRadianDiff = diff;
	          }
	        }
	
	        return [closestAxisIdx, +(closestAxis && closestAxis.coordToData(radius))];
	      };
	
	      Radar.prototype.resize = function (radarModel, api) {
	        var center = radarModel.get('center');
	        var viewWidth = api.getWidth();
	        var viewHeight = api.getHeight();
	        var viewSize = Math.min(viewWidth, viewHeight) / 2;
	        this.cx = parsePercent$1(center[0], viewWidth);
	        this.cy = parsePercent$1(center[1], viewHeight);
	        this.startAngle = radarModel.get('startAngle') * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
	
	        var radius = radarModel.get('radius');
	
	        if (isString(radius) || isNumber(radius)) {
	          radius = [0, radius];
	        }
	
	        this.r0 = parsePercent$1(radius[0], viewSize);
	        this.r = parsePercent$1(radius[1], viewSize);
	        each(this._indicatorAxes, function (indicatorAxis, idx) {
	          indicatorAxis.setExtent(this.r0, this.r);
	          var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]
	
	          angle = Math.atan2(Math.sin(angle), Math.cos(angle));
	          indicatorAxis.angle = angle;
	        }, this);
	      };
	
	      Radar.prototype.update = function (ecModel, api) {
	        var indicatorAxes = this._indicatorAxes;
	        var radarModel = this._model;
	        each(indicatorAxes, function (indicatorAxis) {
	          indicatorAxis.scale.setExtent(Infinity, -Infinity);
	        });
	        ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
	          if (radarSeries.get('coordinateSystem') !== 'radar' // @ts-ignore
	          || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
	            return;
	          }
	
	          var data = radarSeries.getData();
	          each(indicatorAxes, function (indicatorAxis) {
	            indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
	          });
	        }, this);
	        var splitNumber = radarModel.get('splitNumber');
	        var dummyScale = new IntervalScale();
	        dummyScale.setExtent(0, splitNumber);
	        dummyScale.setInterval(1); // Force all the axis fixing the maxSplitNumber.
	
	        each(indicatorAxes, function (indicatorAxis, idx) {
	          alignScaleTicks(indicatorAxis.scale, indicatorAxis.model, dummyScale);
	        });
	      };
	
	      Radar.prototype.convertToPixel = function (ecModel, finder, value) {
	        console.warn('Not implemented.');
	        return null;
	      };
	
	      Radar.prototype.convertFromPixel = function (ecModel, finder, pixel) {
	        console.warn('Not implemented.');
	        return null;
	      };
	
	      Radar.prototype.containPoint = function (point) {
	        console.warn('Not implemented.');
	        return false;
	      };
	
	      Radar.create = function (ecModel, api) {
	        var radarList = [];
	        ecModel.eachComponent('radar', function (radarModel) {
	          var radar = new Radar(radarModel, ecModel, api);
	          radarList.push(radar);
	          radarModel.coordinateSystem = radar;
	        });
	        ecModel.eachSeriesByType('radar', function (radarSeries) {
	          if (radarSeries.get('coordinateSystem') === 'radar') {
	            // Inject coordinate system
	            // @ts-ignore
	            radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
	          }
	        });
	        return radarList;
	      };
	      /**
	       * Radar dimensions is based on the data
	       */
	
	
	      Radar.dimensions = [];
	      return Radar;
	    }();
	
	    function install$7(registers) {
	      registers.registerCoordinateSystem('radar', Radar);
	      registers.registerComponentModel(RadarModel);
	      registers.registerComponentView(RadarView$1);
	      registers.registerVisual({
	        seriesType: 'radar',
	        reset: function (seriesModel) {
	          var data = seriesModel.getData(); // itemVisual symbol is for selected data
	
	          data.each(function (idx) {
	            data.setItemVisual(idx, 'legendIcon', 'roundRect');
	          }); // visual is for unselected data
	
	          data.setVisual('legendIcon', 'roundRect');
	        }
	      });
	    }
	
	    function install$8(registers) {
	      use(install$7);
	      registers.registerChartView(RadarView);
	      registers.registerSeriesModel(RadarSeriesModel);
	      registers.registerLayout(radarLayout);
	      registers.registerProcessor(dataFilter('radar'));
	      registers.registerPreprocessor(radarBackwardCompat);
	    }
	
	    var ATTR = '\0_ec_interaction_mutex';
	    function take(zr, resourceKey, userKey) {
	      var store = getStore(zr);
	      store[resourceKey] = userKey;
	    }
	    function release(zr, resourceKey, userKey) {
	      var store = getStore(zr);
	      var uKey = store[resourceKey];
	
	      if (uKey === userKey) {
	        store[resourceKey] = null;
	      }
	    }
	    function isTaken(zr, resourceKey) {
	      return !!getStore(zr)[resourceKey];
	    }
	
	    function getStore(zr) {
	      return zr[ATTR] || (zr[ATTR] = {});
	    }
	    /**
	     * payload: {
	     *     type: 'takeGlobalCursor',
	     *     key: 'dataZoomSelect', or 'brush', or ...,
	     *         If no userKey, release global cursor.
	     * }
	     */
	    // TODO: SELF REGISTERED.
	
	
	    registerAction({
	      type: 'takeGlobalCursor',
	      event: 'globalCursorTaken',
	      update: 'update'
	    }, noop);
	
	    var RoamController =
	    /** @class */
	    function (_super) {
	      __extends(RoamController, _super);
	
	      function RoamController(zr) {
	        var _this = _super.call(this) || this;
	
	        _this._zr = zr; // Avoid two roamController bind the same handler
	
	        var mousedownHandler = bind(_this._mousedownHandler, _this);
	        var mousemoveHandler = bind(_this._mousemoveHandler, _this);
	        var mouseupHandler = bind(_this._mouseupHandler, _this);
	        var mousewheelHandler = bind(_this._mousewheelHandler, _this);
	        var pinchHandler = bind(_this._pinchHandler, _this);
	        /**
	         * Notice: only enable needed types. For example, if 'zoom'
	         * is not needed, 'zoom' should not be enabled, otherwise
	         * default mousewheel behaviour (scroll page) will be disabled.
	         */
	
	        _this.enable = function (controlType, opt) {
	          // Disable previous first
	          this.disable();
	          this._opt = defaults(clone(opt) || {}, {
	            zoomOnMouseWheel: true,
	            moveOnMouseMove: true,
	            // By default, wheel do not trigger move.
	            moveOnMouseWheel: false,
	            preventDefaultMouseMove: true
	          });
	
	          if (controlType == null) {
	            controlType = true;
	          }
	
	          if (controlType === true || controlType === 'move' || controlType === 'pan') {
	            zr.on('mousedown', mousedownHandler);
	            zr.on('mousemove', mousemoveHandler);
	            zr.on('mouseup', mouseupHandler);
	          }
	
	          if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
	            zr.on('mousewheel', mousewheelHandler);
	            zr.on('pinch', pinchHandler);
	          }
	        };
	
	        _this.disable = function () {
	          zr.off('mousedown', mousedownHandler);
	          zr.off('mousemove', mousemoveHandler);
	          zr.off('mouseup', mouseupHandler);
	          zr.off('mousewheel', mousewheelHandler);
	          zr.off('pinch', pinchHandler);
	        };
	
	        return _this;
	      }
	
	      RoamController.prototype.isDragging = function () {
	        return this._dragging;
	      };
	
	      RoamController.prototype.isPinching = function () {
	        return this._pinching;
	      };
	
	      RoamController.prototype.setPointerChecker = function (pointerChecker) {
	        this.pointerChecker = pointerChecker;
	      };
	
	      RoamController.prototype.dispose = function () {
	        this.disable();
	      };
	
	      RoamController.prototype._mousedownHandler = function (e) {
	        if (isMiddleOrRightButtonOnMouseUpDown(e)) {
	          return;
	        }
	
	        var el = e.target;
	
	        while (el) {
	          if (el.draggable) {
	            return;
	          } // check if host is draggable
	
	
	          el = el.__hostTarget || el.parent;
	        }
	
	        var x = e.offsetX;
	        var y = e.offsetY; // Only check on mosedown, but not mousemove.
	        // Mouse can be out of target when mouse moving.
	
	        if (this.pointerChecker && this.pointerChecker(e, x, y)) {
	          this._x = x;
	          this._y = y;
	          this._dragging = true;
	        }
	      };
	
	      RoamController.prototype._mousemoveHandler = function (e) {
	        if (!this._dragging || !isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || isTaken(this._zr, 'globalPan')) {
	          return;
	        }
	
	        var x = e.offsetX;
	        var y = e.offsetY;
	        var oldX = this._x;
	        var oldY = this._y;
	        var dx = x - oldX;
	        var dy = y - oldY;
	        this._x = x;
	        this._y = y;
	        this._opt.preventDefaultMouseMove && stop(e.event);
	        trigger(this, 'pan', 'moveOnMouseMove', e, {
	          dx: dx,
	          dy: dy,
	          oldX: oldX,
	          oldY: oldY,
	          newX: x,
	          newY: y,
	          isAvailableBehavior: null
	        });
	      };
	
	      RoamController.prototype._mouseupHandler = function (e) {
	        if (!isMiddleOrRightButtonOnMouseUpDown(e)) {
	          this._dragging = false;
	        }
	      };
	
	      RoamController.prototype._mousewheelHandler = function (e) {
	        var shouldZoom = isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
	        var shouldMove = isAvailableBehavior('moveOnMouseWheel', e, this._opt);
	        var wheelDelta = e.wheelDelta;
	        var absWheelDeltaDelta = Math.abs(wheelDelta);
	        var originX = e.offsetX;
	        var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.
	
	        if (wheelDelta === 0 || !shouldZoom && !shouldMove) {
	          return;
	        } // If both `shouldZoom` and `shouldMove` is true, trigger
	        // their event both, and the final behavior is determined
	        // by event listener themselves.
	
	
	        if (shouldZoom) {
	          // Convenience:
	          // Mac and VM Windows on Mac: scroll up: zoom out.
	          // Windows: scroll up: zoom in.
	          // FIXME: Should do more test in different environment.
	          // wheelDelta is too complicated in difference nvironment
	          // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
	          // although it has been normallized by zrender.
	          // wheelDelta of mouse wheel is bigger than touch pad.
	          var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
	          var scale = wheelDelta > 0 ? factor : 1 / factor;
	          checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
	            scale: scale,
	            originX: originX,
	            originY: originY,
	            isAvailableBehavior: null
	          });
	        }
	
	        if (shouldMove) {
	          // FIXME: Should do more test in different environment.
	          var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.
	
	          var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
	          checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
	            scrollDelta: scrollDelta,
	            originX: originX,
	            originY: originY,
	            isAvailableBehavior: null
	          });
	        }
	      };
	
	      RoamController.prototype._pinchHandler = function (e) {
	        if (isTaken(this._zr, 'globalPan')) {
	          return;
	        }
	
	        var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
	        checkPointerAndTrigger(this, 'zoom', null, e, {
	          scale: scale,
	          originX: e.pinchX,
	          originY: e.pinchY,
	          isAvailableBehavior: null
	        });
	      };
	
	      return RoamController;
	    }(Eventful);
	
	    function checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	      if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
	        // When mouse is out of roamController rect,
	        // default befavoius should not be be disabled, otherwise
	        // page sliding is disabled, contrary to expectation.
	        stop(e.event);
	        trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
	      }
	    }
	
	    function trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	      // Also provide behavior checker for event listener, for some case that
	      // multiple components share one listener.
	      contollerEvent.isAvailableBehavior = bind(isAvailableBehavior, null, behaviorToCheck, e); // TODO should not have type issue.
	
	      controller.trigger(eventName, contollerEvent);
	    } // settings: {
	    //     zoomOnMouseWheel
	    //     moveOnMouseMove
	    //     moveOnMouseWheel
	    // }
	    // The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	
	
	    function isAvailableBehavior(behaviorToCheck, e, settings) {
	      var setting = settings[behaviorToCheck];
	      return !behaviorToCheck || setting && (!isString(setting) || e.event[setting + 'Key']);
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	    /**
	     * For geo and graph.
	     */
	    function updateViewOnPan(controllerHost, dx, dy) {
	      var target = controllerHost.target;
	      target.x += dx;
	      target.y += dy;
	      target.dirty();
	    }
	    /**
	     * For geo and graph.
	     */
	
	    function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
	      var target = controllerHost.target;
	      var zoomLimit = controllerHost.zoomLimit;
	      var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
	      newZoom *= zoomDelta;
	
	      if (zoomLimit) {
	        var zoomMin = zoomLimit.min || 0;
	        var zoomMax = zoomLimit.max || Infinity;
	        newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
	      }
	
	      var zoomScale = newZoom / controllerHost.zoom;
	      controllerHost.zoom = newZoom; // Keep the mouse center when scaling
	
	      target.x -= (zoomX - target.x) * (zoomScale - 1);
	      target.y -= (zoomY - target.y) * (zoomScale - 1);
	      target.scaleX *= zoomScale;
	      target.scaleY *= zoomScale;
	      target.dirty();
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var IRRELEVANT_EXCLUDES = {
	      'axisPointer': 1,
	      'tooltip': 1,
	      'brush': 1
	    };
	    /**
	     * Avoid that: mouse click on a elements that is over geo or graph,
	     * but roam is triggered.
	     */
	
	    function onIrrelevantElement(e, api, targetCoordSysModel) {
	      var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.
	
	      var coordSys = model && model.coordinateSystem;
	      return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES.hasOwnProperty(model.mainType) && coordSys && coordSys.model !== targetCoordSysModel;
	    }
	
	    function parseXML(svg) {
	        if (isString(svg)) {
	            var parser = new DOMParser();
	            svg = parser.parseFromString(svg, 'text/xml');
	        }
	        var svgNode = svg;
	        if (svgNode.nodeType === 9) {
	            svgNode = svgNode.firstChild;
	        }
	        while (svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1) {
	            svgNode = svgNode.nextSibling;
	        }
	        return svgNode;
	    }
	
	    var nodeParsers;
	    var INHERITABLE_STYLE_ATTRIBUTES_MAP = {
	        'fill': 'fill',
	        'stroke': 'stroke',
	        'stroke-width': 'lineWidth',
	        'opacity': 'opacity',
	        'fill-opacity': 'fillOpacity',
	        'stroke-opacity': 'strokeOpacity',
	        'stroke-dasharray': 'lineDash',
	        'stroke-dashoffset': 'lineDashOffset',
	        'stroke-linecap': 'lineCap',
	        'stroke-linejoin': 'lineJoin',
	        'stroke-miterlimit': 'miterLimit',
	        'font-family': 'fontFamily',
	        'font-size': 'fontSize',
	        'font-style': 'fontStyle',
	        'font-weight': 'fontWeight',
	        'text-anchor': 'textAlign',
	        'visibility': 'visibility',
	        'display': 'display'
	    };
	    var INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = keys(INHERITABLE_STYLE_ATTRIBUTES_MAP);
	    var SELF_STYLE_ATTRIBUTES_MAP = {
	        'alignment-baseline': 'textBaseline',
	        'stop-color': 'stopColor'
	    };
	    var SELF_STYLE_ATTRIBUTES_MAP_KEYS = keys(SELF_STYLE_ATTRIBUTES_MAP);
	    var SVGParser = (function () {
	        function SVGParser() {
	            this._defs = {};
	            this._root = null;
	        }
	        SVGParser.prototype.parse = function (xml, opt) {
	            opt = opt || {};
	            var svg = parseXML(xml);
	            if (true) {
	                if (!svg) {
	                    throw new Error('Illegal svg');
	                }
	            }
	            this._defsUsePending = [];
	            var root = new Group();
	            this._root = root;
	            var named = [];
	            var viewBox = svg.getAttribute('viewBox') || '';
	            var width = parseFloat((svg.getAttribute('width') || opt.width));
	            var height = parseFloat((svg.getAttribute('height') || opt.height));
	            isNaN(width) && (width = null);
	            isNaN(height) && (height = null);
	            parseAttributes(svg, root, null, true, false);
	            var child = svg.firstChild;
	            while (child) {
	                this._parseNode(child, root, named, null, false, false);
	                child = child.nextSibling;
	            }
	            applyDefs(this._defs, this._defsUsePending);
	            this._defsUsePending = [];
	            var viewBoxRect;
	            var viewBoxTransform;
	            if (viewBox) {
	                var viewBoxArr = splitNumberSequence(viewBox);
	                if (viewBoxArr.length >= 4) {
	                    viewBoxRect = {
	                        x: parseFloat((viewBoxArr[0] || 0)),
	                        y: parseFloat((viewBoxArr[1] || 0)),
	                        width: parseFloat(viewBoxArr[2]),
	                        height: parseFloat(viewBoxArr[3])
	                    };
	                }
	            }
	            if (viewBoxRect && width != null && height != null) {
	                viewBoxTransform = makeViewBoxTransform(viewBoxRect, { x: 0, y: 0, width: width, height: height });
	                if (!opt.ignoreViewBox) {
	                    var elRoot = root;
	                    root = new Group();
	                    root.add(elRoot);
	                    elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
	                    elRoot.x = viewBoxTransform.x;
	                    elRoot.y = viewBoxTransform.y;
	                }
	            }
	            if (!opt.ignoreRootClip && width != null && height != null) {
	                root.setClipPath(new Rect({
	                    shape: { x: 0, y: 0, width: width, height: height }
	                }));
	            }
	            return {
	                root: root,
	                width: width,
	                height: height,
	                viewBoxRect: viewBoxRect,
	                viewBoxTransform: viewBoxTransform,
	                named: named
	            };
	        };
	        SVGParser.prototype._parseNode = function (xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
	            var nodeName = xmlNode.nodeName.toLowerCase();
	            var el;
	            var namedFromForSub = namedFrom;
	            if (nodeName === 'defs') {
	                isInDefs = true;
	            }
	            if (nodeName === 'text') {
	                isInText = true;
	            }
	            if (nodeName === 'defs' || nodeName === 'switch') {
	                el = parentGroup;
	            }
	            else {
	                if (!isInDefs) {
	                    var parser_1 = nodeParsers[nodeName];
	                    if (parser_1 && hasOwn(nodeParsers, nodeName)) {
	                        el = parser_1.call(this, xmlNode, parentGroup);
	                        var nameAttr = xmlNode.getAttribute('name');
	                        if (nameAttr) {
	                            var newNamed = {
	                                name: nameAttr,
	                                namedFrom: null,
	                                svgNodeTagLower: nodeName,
	                                el: el
	                            };
	                            named.push(newNamed);
	                            if (nodeName === 'g') {
	                                namedFromForSub = newNamed;
	                            }
	                        }
	                        else if (namedFrom) {
	                            named.push({
	                                name: namedFrom.name,
	                                namedFrom: namedFrom,
	                                svgNodeTagLower: nodeName,
	                                el: el
	                            });
	                        }
	                        parentGroup.add(el);
	                    }
	                }
	                var parser = paintServerParsers[nodeName];
	                if (parser && hasOwn(paintServerParsers, nodeName)) {
	                    var def = parser.call(this, xmlNode);
	                    var id = xmlNode.getAttribute('id');
	                    if (id) {
	                        this._defs[id] = def;
	                    }
	                }
	            }
	            if (el && el.isGroup) {
	                var child = xmlNode.firstChild;
	                while (child) {
	                    if (child.nodeType === 1) {
	                        this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
	                    }
	                    else if (child.nodeType === 3 && isInText) {
	                        this._parseText(child, el);
	                    }
	                    child = child.nextSibling;
	                }
	            }
	        };
	        SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
	            var text = new TSpan({
	                style: {
	                    text: xmlNode.textContent
	                },
	                silent: true,
	                x: this._textX || 0,
	                y: this._textY || 0
	            });
	            inheritStyle(parentGroup, text);
	            parseAttributes(xmlNode, text, this._defsUsePending, false, false);
	            applyTextAlignment(text, parentGroup);
	            var textStyle = text.style;
	            var fontSize = textStyle.fontSize;
	            if (fontSize && fontSize < 9) {
	                textStyle.fontSize = 9;
	                text.scaleX *= fontSize / 9;
	                text.scaleY *= fontSize / 9;
	            }
	            var font = (textStyle.fontSize || textStyle.fontFamily) && [
	                textStyle.fontStyle,
	                textStyle.fontWeight,
	                (textStyle.fontSize || 12) + 'px',
	                textStyle.fontFamily || 'sans-serif'
	            ].join(' ');
	            textStyle.font = font;
	            var rect = text.getBoundingRect();
	            this._textX += rect.width;
	            parentGroup.add(text);
	            return text;
	        };
	        SVGParser.internalField = (function () {
	            nodeParsers = {
	                'g': function (xmlNode, parentGroup) {
	                    var g = new Group();
	                    inheritStyle(parentGroup, g);
	                    parseAttributes(xmlNode, g, this._defsUsePending, false, false);
	                    return g;
	                },
	                'rect': function (xmlNode, parentGroup) {
	                    var rect = new Rect();
	                    inheritStyle(parentGroup, rect);
	                    parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
	                    rect.setShape({
	                        x: parseFloat(xmlNode.getAttribute('x') || '0'),
	                        y: parseFloat(xmlNode.getAttribute('y') || '0'),
	                        width: parseFloat(xmlNode.getAttribute('width') || '0'),
	                        height: parseFloat(xmlNode.getAttribute('height') || '0')
	                    });
	                    rect.silent = true;
	                    return rect;
	                },
	                'circle': function (xmlNode, parentGroup) {
	                    var circle = new Circle();
	                    inheritStyle(parentGroup, circle);
	                    parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
	                    circle.setShape({
	                        cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
	                        cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
	                        r: parseFloat(xmlNode.getAttribute('r') || '0')
	                    });
	                    circle.silent = true;
	                    return circle;
	                },
	                'line': function (xmlNode, parentGroup) {
	                    var line = new Line();
	                    inheritStyle(parentGroup, line);
	                    parseAttributes(xmlNode, line, this._defsUsePending, false, false);
	                    line.setShape({
	                        x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
	                        y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
	                        x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
	                        y2: parseFloat(xmlNode.getAttribute('y2') || '0')
	                    });
	                    line.silent = true;
	                    return line;
	                },
	                'ellipse': function (xmlNode, parentGroup) {
	                    var ellipse = new Ellipse();
	                    inheritStyle(parentGroup, ellipse);
	                    parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
	                    ellipse.setShape({
	                        cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
	                        cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
	                        rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
	                        ry: parseFloat(xmlNode.getAttribute('ry') || '0')
	                    });
	                    ellipse.silent = true;
	                    return ellipse;
	                },
	                'polygon': function (xmlNode, parentGroup) {
	                    var pointsStr = xmlNode.getAttribute('points');
	                    var pointsArr;
	                    if (pointsStr) {
	                        pointsArr = parsePoints(pointsStr);
	                    }
	                    var polygon = new Polygon({
	                        shape: {
	                            points: pointsArr || []
	                        },
	                        silent: true
	                    });
	                    inheritStyle(parentGroup, polygon);
	                    parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
	                    return polygon;
	                },
	                'polyline': function (xmlNode, parentGroup) {
	                    var pointsStr = xmlNode.getAttribute('points');
	                    var pointsArr;
	                    if (pointsStr) {
	                        pointsArr = parsePoints(pointsStr);
	                    }
	                    var polyline = new Polyline({
	                        shape: {
	                            points: pointsArr || []
	                        },
	                        silent: true
	                    });
	                    inheritStyle(parentGroup, polyline);
	                    parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
	                    return polyline;
	                },
	                'image': function (xmlNode, parentGroup) {
	                    var img = new ZRImage();
	                    inheritStyle(parentGroup, img);
	                    parseAttributes(xmlNode, img, this._defsUsePending, false, false);
	                    img.setStyle({
	                        image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
	                        x: +xmlNode.getAttribute('x'),
	                        y: +xmlNode.getAttribute('y'),
	                        width: +xmlNode.getAttribute('width'),
	                        height: +xmlNode.getAttribute('height')
	                    });
	                    img.silent = true;
	                    return img;
	                },
	                'text': function (xmlNode, parentGroup) {
	                    var x = xmlNode.getAttribute('x') || '0';
	                    var y = xmlNode.getAttribute('y') || '0';
	                    var dx = xmlNode.getAttribute('dx') || '0';
	                    var dy = xmlNode.getAttribute('dy') || '0';
	                    this._textX = parseFloat(x) + parseFloat(dx);
	                    this._textY = parseFloat(y) + parseFloat(dy);
	                    var g = new Group();
	                    inheritStyle(parentGroup, g);
	                    parseAttributes(xmlNode, g, this._defsUsePending, false, true);
	                    return g;
	                },
	                'tspan': function (xmlNode, parentGroup) {
	                    var x = xmlNode.getAttribute('x');
	                    var y = xmlNode.getAttribute('y');
	                    if (x != null) {
	                        this._textX = parseFloat(x);
	                    }
	                    if (y != null) {
	                        this._textY = parseFloat(y);
	                    }
	                    var dx = xmlNode.getAttribute('dx') || '0';
	                    var dy = xmlNode.getAttribute('dy') || '0';
	                    var g = new Group();
	                    inheritStyle(parentGroup, g);
	                    parseAttributes(xmlNode, g, this._defsUsePending, false, true);
	                    this._textX += parseFloat(dx);
	                    this._textY += parseFloat(dy);
	                    return g;
	                },
	                'path': function (xmlNode, parentGroup) {
	                    var d = xmlNode.getAttribute('d') || '';
	                    var path = createFromString(d);
	                    inheritStyle(parentGroup, path);
	                    parseAttributes(xmlNode, path, this._defsUsePending, false, false);
	                    path.silent = true;
	                    return path;
	                }
	            };
	        })();
	        return SVGParser;
	    }());
	    var paintServerParsers = {
	        'lineargradient': function (xmlNode) {
	            var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
	            var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
	            var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
	            var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
	            var gradient = new LinearGradient(x1, y1, x2, y2);
	            parsePaintServerUnit(xmlNode, gradient);
	            parseGradientColorStops(xmlNode, gradient);
	            return gradient;
	        },
	        'radialgradient': function (xmlNode) {
	            var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
	            var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
	            var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
	            var gradient = new RadialGradient(cx, cy, r);
	            parsePaintServerUnit(xmlNode, gradient);
	            parseGradientColorStops(xmlNode, gradient);
	            return gradient;
	        }
	    };
	    function parsePaintServerUnit(xmlNode, gradient) {
	        var gradientUnits = xmlNode.getAttribute('gradientUnits');
	        if (gradientUnits === 'userSpaceOnUse') {
	            gradient.global = true;
	        }
	    }
	    function parseGradientColorStops(xmlNode, gradient) {
	        var stop = xmlNode.firstChild;
	        while (stop) {
	            if (stop.nodeType === 1
	                && stop.nodeName.toLocaleLowerCase() === 'stop') {
	                var offsetStr = stop.getAttribute('offset');
	                var offset = void 0;
	                if (offsetStr && offsetStr.indexOf('%') > 0) {
	                    offset = parseInt(offsetStr, 10) / 100;
	                }
	                else if (offsetStr) {
	                    offset = parseFloat(offsetStr);
	                }
	                else {
	                    offset = 0;
	                }
	                var styleVals = {};
	                parseInlineStyle(stop, styleVals, styleVals);
	                var stopColor = styleVals.stopColor
	                    || stop.getAttribute('stop-color')
	                    || '#000000';
	                gradient.colorStops.push({
	                    offset: offset,
	                    color: stopColor
	                });
	            }
	            stop = stop.nextSibling;
	        }
	    }
	    function inheritStyle(parent, child) {
	        if (parent && parent.__inheritedStyle) {
	            if (!child.__inheritedStyle) {
	                child.__inheritedStyle = {};
	            }
	            defaults(child.__inheritedStyle, parent.__inheritedStyle);
	        }
	    }
	    function parsePoints(pointsString) {
	        var list = splitNumberSequence(pointsString);
	        var points = [];
	        for (var i = 0; i < list.length; i += 2) {
	            var x = parseFloat(list[i]);
	            var y = parseFloat(list[i + 1]);
	            points.push([x, y]);
	        }
	        return points;
	    }
	    function parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
	        var disp = el;
	        var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
	        var selfStyle = {};
	        if (xmlNode.nodeType === 1) {
	            parseTransformAttribute(xmlNode, el);
	            parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
	            if (!onlyInlineStyle) {
	                parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
	            }
	        }
	        disp.style = disp.style || {};
	        if (inheritedStyle.fill != null) {
	            disp.style.fill = getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
	        }
	        if (inheritedStyle.stroke != null) {
	            disp.style.stroke = getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
	        }
	        each([
	            'lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'
	        ], function (propName) {
	            if (inheritedStyle[propName] != null) {
	                disp.style[propName] = parseFloat(inheritedStyle[propName]);
	            }
	        });
	        each([
	            'lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign'
	        ], function (propName) {
	            if (inheritedStyle[propName] != null) {
	                disp.style[propName] = inheritedStyle[propName];
	            }
	        });
	        if (isTextGroup) {
	            disp.__selfStyle = selfStyle;
	        }
	        if (inheritedStyle.lineDash) {
	            disp.style.lineDash = map(splitNumberSequence(inheritedStyle.lineDash), function (str) {
	                return parseFloat(str);
	            });
	        }
	        if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') {
	            disp.invisible = true;
	        }
	        if (inheritedStyle.display === 'none') {
	            disp.ignore = true;
	        }
	    }
	    function applyTextAlignment(text, parentGroup) {
	        var parentSelfStyle = parentGroup.__selfStyle;
	        if (parentSelfStyle) {
	            var textBaseline = parentSelfStyle.textBaseline;
	            var zrTextBaseline = textBaseline;
	            if (!textBaseline || textBaseline === 'auto') {
	                zrTextBaseline = 'alphabetic';
	            }
	            else if (textBaseline === 'baseline') {
	                zrTextBaseline = 'alphabetic';
	            }
	            else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') {
	                zrTextBaseline = 'top';
	            }
	            else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') {
	                zrTextBaseline = 'bottom';
	            }
	            else if (textBaseline === 'central' || textBaseline === 'mathematical') {
	                zrTextBaseline = 'middle';
	            }
	            text.style.textBaseline = zrTextBaseline;
	        }
	        var parentInheritedStyle = parentGroup.__inheritedStyle;
	        if (parentInheritedStyle) {
	            var textAlign = parentInheritedStyle.textAlign;
	            var zrTextAlign = textAlign;
	            if (textAlign) {
	                if (textAlign === 'middle') {
	                    zrTextAlign = 'center';
	                }
	                text.style.textAlign = zrTextAlign;
	            }
	        }
	    }
	    var urlRegex = /^url\(\s*#(.*?)\)/;
	    function getFillStrokeStyle(el, method, str, defsUsePending) {
	        var urlMatch = str && str.match(urlRegex);
	        if (urlMatch) {
	            var url = trim(urlMatch[1]);
	            defsUsePending.push([el, method, url]);
	            return;
	        }
	        if (str === 'none') {
	            str = null;
	        }
	        return str;
	    }
	    function applyDefs(defs, defsUsePending) {
	        for (var i = 0; i < defsUsePending.length; i++) {
	            var item = defsUsePending[i];
	            item[0].style[item[1]] = defs[item[2]];
	        }
	    }
	    var numberReg$1 = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
	    function splitNumberSequence(rawStr) {
	        return rawStr.match(numberReg$1) || [];
	    }
	    var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
	    var DEGREE_TO_ANGLE = Math.PI / 180;
	    function parseTransformAttribute(xmlNode, node) {
	        var transform = xmlNode.getAttribute('transform');
	        if (transform) {
	            transform = transform.replace(/,/g, ' ');
	            var transformOps_1 = [];
	            var mt = null;
	            transform.replace(transformRegex, function (str, type, value) {
	                transformOps_1.push(type, value);
	                return '';
	            });
	            for (var i = transformOps_1.length - 1; i > 0; i -= 2) {
	                var value = transformOps_1[i];
	                var type = transformOps_1[i - 1];
	                var valueArr = splitNumberSequence(value);
	                mt = mt || create$1();
	                switch (type) {
	                    case 'translate':
	                        translate(mt, mt, [parseFloat(valueArr[0]), parseFloat(valueArr[1] || '0')]);
	                        break;
	                    case 'scale':
	                        scale$1(mt, mt, [parseFloat(valueArr[0]), parseFloat(valueArr[1] || valueArr[0])]);
	                        break;
	                    case 'rotate':
	                        rotate(mt, mt, -parseFloat(valueArr[0]) * DEGREE_TO_ANGLE);
	                        break;
	                    case 'skewX':
	                        var sx = Math.tan(parseFloat(valueArr[0]) * DEGREE_TO_ANGLE);
	                        mul$1(mt, [1, 0, sx, 1, 0, 0], mt);
	                        break;
	                    case 'skewY':
	                        var sy = Math.tan(parseFloat(valueArr[0]) * DEGREE_TO_ANGLE);
	                        mul$1(mt, [1, sy, 0, 1, 0, 0], mt);
	                        break;
	                    case 'matrix':
	                        mt[0] = parseFloat(valueArr[0]);
	                        mt[1] = parseFloat(valueArr[1]);
	                        mt[2] = parseFloat(valueArr[2]);
	                        mt[3] = parseFloat(valueArr[3]);
	                        mt[4] = parseFloat(valueArr[4]);
	                        mt[5] = parseFloat(valueArr[5]);
	                        break;
	                }
	            }
	            node.setLocalTransform(mt);
	        }
	    }
	    var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
	    function parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
	        var style = xmlNode.getAttribute('style');
	        if (!style) {
	            return;
	        }
	        styleRegex.lastIndex = 0;
	        var styleRegResult;
	        while ((styleRegResult = styleRegex.exec(style)) != null) {
	            var svgStlAttr = styleRegResult[1];
	            var zrInheritableStlAttr = hasOwn(INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr)
	                ? INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr]
	                : null;
	            if (zrInheritableStlAttr) {
	                inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
	            }
	            var zrSelfStlAttr = hasOwn(SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr)
	                ? SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr]
	                : null;
	            if (zrSelfStlAttr) {
	                selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
	            }
	        }
	    }
	    function parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
	        for (var i = 0; i < INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++) {
	            var svgAttrName = INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
	            var attrValue = xmlNode.getAttribute(svgAttrName);
	            if (attrValue != null) {
	                inheritableStyleResult[INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
	            }
	        }
	        for (var i = 0; i < SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++) {
	            var svgAttrName = SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
	            var attrValue = xmlNode.getAttribute(svgAttrName);
	            if (attrValue != null) {
	                selfStyleResult[SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
	            }
	        }
	    }
	    function makeViewBoxTransform(viewBoxRect, boundingRect) {
	        var scaleX = boundingRect.width / viewBoxRect.width;
	        var scaleY = boundingRect.height / viewBoxRect.height;
	        var scale = Math.min(scaleX, scaleY);
	        return {
	            scale: scale,
	            x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
	            y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
	        };
	    }
	    function parseSVG(xml, opt) {
	        var parser = new SVGParser();
	        return parser.parse(xml, opt);
	    }
	
	    /**
	     * "region available" means that: enable users to set attribute `name="xxx"` on those tags
	     * to make it be a region.
	     * 1. region styles and its label styles can be defined in echarts opton:
	     * ```js
	     * geo: {
	     *     regions: [{
	     *         name: 'xxx',
	     *         itemStyle: { ... },
	     *         label: { ... }
	     *     }, {
	     *         ...
	     *     },
	     *     ...]
	     * };
	     * ```
	     * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
	     * a region option. For exampel if there are two <path> representing two lung lobes. They have
	     * no common parents but both of them need to display label "lung" inside.
	     */
	
	    var REGION_AVAILABLE_SVG_TAG_MAP = createHashMap(['rect', 'circle', 'line', 'ellipse', 'polygon', 'polyline', 'path', // <text> <tspan> are also enabled because some SVG might paint text itself,
	    // but still need to trigger events or tooltip.
	    'text', 'tspan', // <g> is also enabled because this case: if multiple tags share one name
	    // and need label displayed, every tags will display the name, which is not
	    // expected. So we can put them into a <g name="xxx">. Thereby only one label
	    // displayed and located based on the bounding rect of the <g>.
	    'g']);
	
	    var GeoSVGResource =
	    /** @class */
	    function () {
	      function GeoSVGResource(mapName, svg) {
	        this.type = 'geoSVG'; // All used graphics. key: hostKey, value: root
	
	        this._usedGraphicMap = createHashMap(); // All unused graphics.
	
	        this._freedGraphics = [];
	        this._mapName = mapName; // Only perform parse to XML object here, which might be time
	        // consiming for large SVG.
	        // Although convert XML to zrender element is also time consiming,
	        // if we do it here, the clone of zrender elements has to be
	        // required. So we do it once for each geo instance, util real
	        // performance issues call for optimizing it.
	
	        this._parsedXML = parseXML(svg);
	      }
	
	      GeoSVGResource.prototype.load = function ()
	      /* nameMap: NameMap */
	      {
	        // In the "load" stage, graphic need to be built to
	        // get boundingRect for geo coordinate system.
	        var firstGraphic = this._firstGraphic; // Create the return data structure only when first graphic created.
	        // Because they will be used in geo coordinate system update stage,
	        // and `regions` will be mounted at `geo` coordinate system,
	        // in which there is no "view" info, so that it should better not to
	        // make references to graphic elements.
	
	        if (!firstGraphic) {
	          firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
	
	          this._freedGraphics.push(firstGraphic);
	
	          this._boundingRect = this._firstGraphic.boundingRect.clone(); // PENDING: `nameMap` will not be supported until some real requirement come.
	          // if (nameMap) {
	          //     named = applyNameMap(named, nameMap);
	          // }
	
	          var _a = createRegions(firstGraphic.named),
	              regions = _a.regions,
	              regionsMap = _a.regionsMap;
	
	          this._regions = regions;
	          this._regionsMap = regionsMap;
	        }
	
	        return {
	          boundingRect: this._boundingRect,
	          regions: this._regions,
	          regionsMap: this._regionsMap
	        };
	      };
	
	      GeoSVGResource.prototype._buildGraphic = function (svgXML) {
	        var result;
	        var rootFromParse;
	
	        try {
	          result = svgXML && parseSVG(svgXML, {
	            ignoreViewBox: true,
	            ignoreRootClip: true
	          }) || {};
	          rootFromParse = result.root;
	          assert(rootFromParse != null);
	        } catch (e) {
	          throw new Error('Invalid svg format\n' + e.message);
	        } // Note: we keep the covenant that the root has no transform. So always add an extra root.
	
	
	        var root = new Group();
	        root.add(rootFromParse);
	        root.isGeoSVGGraphicRoot = true; // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
	        //
	        // Consider: `<svg width="..." height="..." viewBox="...">`
	        // - the `width/height` we call it `svgWidth/svgHeight` for short.
	        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
	        //   "viewport boundingRect", or `boundingRect` for short.
	        // - `viewBox` defines the transform from the real content ot the viewport.
	        //   `viewBox` has the same unit as the content of SVG.
	        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
	        //   different from the content of SVG. Otherwise, they are the same.
	        //
	        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
	        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
	        // 1. Make a transform from `viewBox` to `boundingRect`.
	        //    Note: only support `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
	        //    the aspect ratio.
	        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
	        //    (`Geo`/`View` will do this job).
	        //    Note: this transform might not preserve aspect radio, which depending on how users specify
	        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
	        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
	        //
	        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
	        // layout look good.
	        //
	        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
	        // of the SVG content and use them to make SVG layout look good.
	
	        var svgWidth = result.width;
	        var svgHeight = result.height;
	        var viewBoxRect = result.viewBoxRect;
	        var boundingRect = this._boundingRect;
	
	        if (!boundingRect) {
	          var bRectX = void 0;
	          var bRectY = void 0;
	          var bRectWidth = void 0;
	          var bRectHeight = void 0;
	
	          if (svgWidth != null) {
	            bRectX = 0;
	            bRectWidth = svgWidth;
	          } else if (viewBoxRect) {
	            bRectX = viewBoxRect.x;
	            bRectWidth = viewBoxRect.width;
	          }
	
	          if (svgHeight != null) {
	            bRectY = 0;
	            bRectHeight = svgHeight;
	          } else if (viewBoxRect) {
	            bRectY = viewBoxRect.y;
	            bRectHeight = viewBoxRect.height;
	          } // If both viewBox and svgWidth/svgHeight not specified,
	          // we have to determine how to layout those element to make them look good.
	
	
	          if (bRectX == null || bRectY == null) {
	            var calculatedBoundingRect = rootFromParse.getBoundingRect();
	
	            if (bRectX == null) {
	              bRectX = calculatedBoundingRect.x;
	              bRectWidth = calculatedBoundingRect.width;
	            }
	
	            if (bRectY == null) {
	              bRectY = calculatedBoundingRect.y;
	              bRectHeight = calculatedBoundingRect.height;
	            }
	          }
	
	          boundingRect = this._boundingRect = new BoundingRect(bRectX, bRectY, bRectWidth, bRectHeight);
	        }
	
	        if (viewBoxRect) {
	          var viewBoxTransform = makeViewBoxTransform(viewBoxRect, boundingRect); // Only support `preserveAspectRatio 'xMidYMid'`
	
	          rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
	          rootFromParse.x = viewBoxTransform.x;
	          rootFromParse.y = viewBoxTransform.y;
	        } // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
	        // They do not strictly confine all of the content inside a display rect, but deliberately
	        // use a `viewBox` to define a displayable rect.
	        // PENDING:
	        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
	        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
	
	
	        root.setClipPath(new Rect({
	          shape: boundingRect.plain()
	        }));
	        var named = [];
	        each(result.named, function (namedItem) {
	          if (REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
	            named.push(namedItem);
	            setSilent(namedItem.el);
	          }
	        });
	        return {
	          root: root,
	          boundingRect: boundingRect,
	          named: named
	        };
	      };
	      /**
	       * Consider:
	       * (1) One graphic element can not be shared by different `geoView` running simultaneously.
	       *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
	       * (2) Converting SVG to graphic elements is time consuming.
	       * (3) In the current architecture, `load` should be called frequently to get boundingRect,
	       *     and it is called without view info.
	       * So we maintain graphic elements in this module, and enables `view` to use/return these
	       * graphics from/to the pool with it's uid.
	       */
	
	
	      GeoSVGResource.prototype.useGraphic = function (hostKey
	      /* , nameMap: NameMap */
	      ) {
	        var usedRootMap = this._usedGraphicMap;
	        var svgGraphic = usedRootMap.get(hostKey);
	
	        if (svgGraphic) {
	          return svgGraphic;
	        }
	
	        svgGraphic = this._freedGraphics.pop() // use the first boundingRect to avoid duplicated boundingRect calculation.
	        || this._buildGraphic(this._parsedXML);
	        usedRootMap.set(hostKey, svgGraphic); // PENDING: `nameMap` will not be supported until some real requirement come.
	        // `nameMap` can only be obtained from echarts option.
	        // The original `named` must not be modified.
	        // if (nameMap) {
	        //     svgGraphic = extend({}, svgGraphic);
	        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
	        // }
	
	        return svgGraphic;
	      };
	
	      GeoSVGResource.prototype.freeGraphic = function (hostKey) {
	        var usedRootMap = this._usedGraphicMap;
	        var svgGraphic = usedRootMap.get(hostKey);
	
	        if (svgGraphic) {
	          usedRootMap.removeKey(hostKey);
	
	          this._freedGraphics.push(svgGraphic);
	        }
	      };
	
	      return GeoSVGResource;
	    }();
	
	    function setSilent(el) {
	      // Only named element has silent: false, other elements should
	      // act as background and has no user interaction.
	      el.silent = false; // text|tspan will be converted to group.
	
	      if (el.isGroup) {
	        el.traverse(function (child) {
	          child.silent = false;
	        });
	      }
	    }
	
	    function createRegions(named) {
	      var regions = [];
	      var regionsMap = createHashMap(); // Create resions only for the first graphic.
	
	      each(named, function (namedItem) {
	        // Region has feature to calculate center for tooltip or other features.
	        // If there is a <g name="xxx">, the center should be the center of the
	        // bounding rect of the g.
	        if (namedItem.namedFrom != null) {
	          return;
	        }
	
	        var region = new GeoSVGRegion(namedItem.name, namedItem.el); // PENDING: if `nameMap` supported, this region can not be mounted on
	        // `this`, but can only be created each time `load()` called.
	
	        regions.push(region); // PENDING: if multiple tag named with the same name, only one will be
	        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
	        // by name. We use `region.getCenter()` as the coordinate.
	
	        regionsMap.set(namedItem.name, region);
	      });
	      return {
	        regions: regions,
	        regionsMap: regionsMap
	      };
	    } // PENDING: `nameMap` will not be supported until some real requirement come.
	    // /**
	    //  * Use the alias in geoNameMap.
	    //  * The input `named` must not be modified.
	    //  */
	    // function applyNameMap(
	    //     named: GeoSVGGraphicRecord['named'],
	    //     nameMap: NameMap
	    // ): GeoSVGGraphicRecord['named'] {
	    //     const result = [] as GeoSVGGraphicRecord['named'];
	    //     for (let i = 0; i < named.length; i++) {
	    //         let regionGraphic = named[i];
	    //         const name = regionGraphic.name;
	    //         if (nameMap && nameMap.hasOwnProperty(name)) {
	    //             regionGraphic = extend({}, regionGraphic);
	    //             regionGraphic.name = name;
	    //         }
	    //         result.push(regionGraphic);
	    //     }
	    //     return result;
	    // }
	
	    var geoCoord = [126, 25];
	    var nanhaiName = '南海诸岛';
	    var points$1 = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];
	
	    for (var i = 0; i < points$1.length; i++) {
	      for (var k = 0; k < points$1[i].length; k++) {
	        points$1[i][k][0] /= 10.5;
	        points$1[i][k][1] /= -10.5 / 0.75;
	        points$1[i][k][0] += geoCoord[0];
	        points$1[i][k][1] += geoCoord[1];
	      }
	    }
	
	    function fixNanhai(mapType, regions) {
	      if (mapType === 'china') {
	        for (var i = 0; i < regions.length; i++) {
	          // Already exists.
	          if (regions[i].name === nanhaiName) {
	            return;
	          }
	        }
	
	        regions.push(new GeoJSONRegion(nanhaiName, map(points$1, function (exterior) {
	          return {
	            type: 'polygon',
	            exterior: exterior
	          };
	        }), geoCoord));
	      }
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var coordsOffsetMap = {
	      '南海诸岛': [32, 80],
	      // 全国
	      '广东': [0, -10],
	      '香港': [10, 5],
	      '澳门': [-10, 10],
	      // '北京': [-10, 0],
	      '天津': [5, 5]
	    };
	    function fixTextCoords(mapType, region) {
	      if (mapType === 'china') {
	        var coordFix = coordsOffsetMap[region.name];
	
	        if (coordFix) {
	          var cp = region.getCenter();
	          cp[0] += coordFix[0] / 10.5;
	          cp[1] += -coordFix[1] / (10.5 / 0.75);
	          region.setCenter(cp);
	        }
	      }
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    // Fix for 钓鱼岛
	    // let Region = require('../Region');
	    // let zrUtil = require('zrender/lib/core/util');
	    // let geoCoord = [126, 25];
	    var points$2 = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
	    function fixDiaoyuIsland(mapType, region) {
	      if (mapType === 'china' && region.name === '台湾') {
	        region.geometries.push({
	          type: 'polygon',
	          exterior: points$2[0]
	        });
	      }
	    }
	
	    var DEFAULT_NAME_PROPERTY = 'name';
	
	    var GeoJSONResource =
	    /** @class */
	    function () {
	      function GeoJSONResource(mapName, geoJSON, specialAreas) {
	        this.type = 'geoJSON';
	        this._parsedMap = createHashMap();
	        this._mapName = mapName;
	        this._specialAreas = specialAreas; // PENDING: delay the parse to the first usage to rapid up the FMP?
	
	        this._geoJSON = parseInput(geoJSON);
	      }
	      /**
	       * @param nameMap can be null/undefined
	       * @param nameProperty can be null/undefined
	       */
	
	
	      GeoJSONResource.prototype.load = function (nameMap, nameProperty) {
	        nameProperty = nameProperty || DEFAULT_NAME_PROPERTY;
	
	        var parsed = this._parsedMap.get(nameProperty);
	
	        if (!parsed) {
	          var rawRegions = this._parseToRegions(nameProperty);
	
	          parsed = this._parsedMap.set(nameProperty, {
	            regions: rawRegions,
	            boundingRect: calculateBoundingRect(rawRegions)
	          });
	        }
	
	        var regionsMap = createHashMap();
	        var finalRegions = [];
	        each(parsed.regions, function (region) {
	          var regionName = region.name; // Try use the alias in geoNameMap
	
	          if (nameMap && hasOwn(nameMap, regionName)) {
	            region = region.cloneShallow(regionName = nameMap[regionName]);
	          }
	
	          finalRegions.push(region);
	          regionsMap.set(regionName, region);
	        });
	        return {
	          regions: finalRegions,
	          boundingRect: parsed.boundingRect || new BoundingRect(0, 0, 0, 0),
	          regionsMap: regionsMap
	        };
	      };
	
	      GeoJSONResource.prototype._parseToRegions = function (nameProperty) {
	        var mapName = this._mapName;
	        var geoJSON = this._geoJSON;
	        var rawRegions; // https://jsperf.com/try-catch-performance-overhead
	
	        try {
	          rawRegions = geoJSON ? parseGeoJSON(geoJSON, nameProperty) : [];
	        } catch (e) {
	          throw new Error('Invalid geoJson format\n' + e.message);
	        }
	
	        fixNanhai(mapName, rawRegions);
	        each(rawRegions, function (region) {
	          var regionName = region.name;
	          fixTextCoords(mapName, region);
	          fixDiaoyuIsland(mapName, region); // Some area like Alaska in USA map needs to be tansformed
	          // to look better
	
	          var specialArea = this._specialAreas && this._specialAreas[regionName];
	
	          if (specialArea) {
	            region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
	          }
	        }, this);
	        return rawRegions;
	      };
	      /**
	       * Only for exporting to users.
	       * **MUST NOT** used internally.
	       */
	
	
	      GeoJSONResource.prototype.getMapForUser = function () {
	        return {
	          // For backward compatibility, use geoJson
	          // PENDING: it has been returning them without clone.
	          // do we need to avoid outsite modification?
	          geoJson: this._geoJSON,
	          geoJSON: this._geoJSON,
	          specialAreas: this._specialAreas
	        };
	      };
	
	      return GeoJSONResource;
	    }();
	
	    function calculateBoundingRect(regions) {
	      var rect;
	
	      for (var i = 0; i < regions.length; i++) {
	        var regionRect = regions[i].getBoundingRect();
	        rect = rect || regionRect.clone();
	        rect.union(regionRect);
	      }
	
	      return rect;
	    }
	
	    function parseInput(source) {
	      return !isString(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
	    }
	
	    var storage = createHashMap();
	    var geoSourceManager = {
	      /**
	       * Compatible with previous `echarts.registerMap`.
	       *
	       * @usage
	       * ```js
	       *
	       * echarts.registerMap('USA', geoJson, specialAreas);
	       *
	       * echarts.registerMap('USA', {
	       *     geoJson: geoJson,
	       *     specialAreas: {...}
	       * });
	       * echarts.registerMap('USA', {
	       *     geoJSON: geoJson,
	       *     specialAreas: {...}
	       * });
	       *
	       * echarts.registerMap('airport', {
	       *     svg: svg
	       * }
	       * ```
	       *
	       * Note:
	       * Do not support that register multiple geoJSON or SVG
	       * one map name. Because different geoJSON and SVG have
	       * different unit. It's not easy to make sure how those
	       * units are mapping/normalize.
	       * If intending to use multiple geoJSON or SVG, we can
	       * use multiple geo coordinate system.
	       */
	      registerMap: function (mapName, rawDef, rawSpecialAreas) {
	        if (rawDef.svg) {
	          var resource = new GeoSVGResource(mapName, rawDef.svg);
	          storage.set(mapName, resource);
	        } else {
	          // Recommend:
	          //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
	          // Backward compatibility:
	          //     echarts.registerMap('eu', geoJSON, specialAreas);
	          //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
	          var geoJSON = rawDef.geoJson || rawDef.geoJSON;
	
	          if (geoJSON && !rawDef.features) {
	            rawSpecialAreas = rawDef.specialAreas;
	          } else {
	            geoJSON = rawDef;
	          }
	
	          var resource = new GeoJSONResource(mapName, geoJSON, rawSpecialAreas);
	          storage.set(mapName, resource);
	        }
	      },
	      getGeoResource: function (mapName) {
	        return storage.get(mapName);
	      },
	
	      /**
	       * Only for exporting to users.
	       * **MUST NOT** used internally.
	       */
	      getMapForUser: function (mapName) {
	        var resource = storage.get(mapName); // Do not support return SVG until some real requirement come.
	
	        return resource && resource.type === 'geoJSON' && resource.getMapForUser();
	      },
	      load: function (mapName, nameMap, nameProperty) {
	        var resource = storage.get(mapName);
	
	        if (!resource) {
	          if (true) {
	            console.error('Map ' + mapName + ' not exists. The GeoJSON of the map must be provided.');
	          }
	
	          return;
	        }
	
	        return resource.load(nameMap, nameProperty);
	      }
	    };
	
	    /**
	     * Only these tags enable use `itemStyle` if they are named in SVG.
	     * Other tags like <text> <tspan> <image> might not suitable for `itemStyle`.
	     * They will not be considered to be styled until some requirements come.
	     */
	
	    var OPTION_STYLE_ENABLED_TAGS = ['rect', 'circle', 'line', 'ellipse', 'polygon', 'polyline', 'path'];
	    var OPTION_STYLE_ENABLED_TAG_MAP = createHashMap(OPTION_STYLE_ENABLED_TAGS);
	    var STATE_TRIGGER_TAG_MAP = createHashMap(OPTION_STYLE_ENABLED_TAGS.concat(['g']));
	    var LABEL_HOST_MAP = createHashMap(OPTION_STYLE_ENABLED_TAGS.concat(['g']));
	    var mapLabelRaw = makeInner();
	
	    function getFixedItemStyle(model) {
	      var itemStyle = model.getItemStyle();
	      var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
	      // they should both set areaColor and color to be null.
	
	      if (areaColor != null) {
	        itemStyle.fill = areaColor;
	      }
	
	      return itemStyle;
	    } // Only stroke can be used for line.
	    // Using fill in style if stroke not exits.
	    // TODO Not sure yet. Perhaps a separate `lineStyle`?
	
	
	    function fixLineStyle(styleHost) {
	      var style = styleHost.style;
	
	      if (style) {
	        style.stroke = style.stroke || style.fill;
	        style.fill = null;
	      }
	    }
	
	    var MapDraw =
	    /** @class */
	    function () {
	      function MapDraw(api) {
	        var group = new Group();
	        this.uid = getUID('ec_map_draw');
	        this._controller = new RoamController(api.getZr());
	        this._controllerHost = {
	          target: group
	        };
	        this.group = group;
	        group.add(this._regionsGroup = new Group());
	        group.add(this._svgGroup = new Group());
	      }
	
	      MapDraw.prototype.draw = function (mapOrGeoModel, ecModel, api, fromView, payload) {
	        var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
	        // will be assigned with map data. Other GEO model has no data.
	
	        var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
	        isGeo && ecModel.eachComponent({
	          mainType: 'series',
	          subType: 'map'
	        }, function (mapSeries) {
	          if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
	            data = mapSeries.getData();
	          }
	        });
	        var geo = mapOrGeoModel.coordinateSystem;
	        var regionsGroup = this._regionsGroup;
	        var group = this.group;
	        var transformInfo = geo.getTransformInfo();
	        var transformInfoRaw = transformInfo.raw;
	        var transformInfoRoam = transformInfo.roam; // No animation when first draw or in action
	
	        var isFirstDraw = !regionsGroup.childAt(0) || payload;
	
	        if (isFirstDraw) {
	          group.x = transformInfoRoam.x;
	          group.y = transformInfoRoam.y;
	          group.scaleX = transformInfoRoam.scaleX;
	          group.scaleY = transformInfoRoam.scaleY;
	          group.dirty();
	        } else {
	          updateProps(group, transformInfoRoam, mapOrGeoModel);
	        }
	
	        var isVisualEncodedByVisualMap = data && data.getVisual('visualMeta') && data.getVisual('visualMeta').length > 0;
	        var viewBuildCtx = {
	          api: api,
	          geo: geo,
	          mapOrGeoModel: mapOrGeoModel,
	          data: data,
	          isVisualEncodedByVisualMap: isVisualEncodedByVisualMap,
	          isGeo: isGeo,
	          transformInfoRaw: transformInfoRaw
	        };
	
	        if (geo.resourceType === 'geoJSON') {
	          this._buildGeoJSON(viewBuildCtx);
	        } else if (geo.resourceType === 'geoSVG') {
	          this._buildSVG(viewBuildCtx);
	        }
	
	        this._updateController(mapOrGeoModel, ecModel, api);
	
	        this._updateMapSelectHandler(mapOrGeoModel, regionsGroup, api, fromView);
	      };
	
	      MapDraw.prototype._buildGeoJSON = function (viewBuildCtx) {
	        var regionsGroupByName = this._regionsGroupByName = createHashMap();
	        var regionsInfoByName = createHashMap();
	        var regionsGroup = this._regionsGroup;
	        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
	        var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
	        var data = viewBuildCtx.data;
	        var projection = viewBuildCtx.geo.projection;
	        var projectionStream = projection && projection.stream;
	
	        function transformPoint(point, project) {
	          if (project) {
	            // projection may return null point.
	            point = project(point);
	          }
	
	          return point && [point[0] * transformInfoRaw.scaleX + transformInfoRaw.x, point[1] * transformInfoRaw.scaleY + transformInfoRaw.y];
	        }
	
	        function transformPolygonPoints(inPoints) {
	          var outPoints = []; // If projectionStream is provided. Use it instead of single point project.
	
	          var project = !projectionStream && projection && projection.project;
	
	          for (var i = 0; i < inPoints.length; ++i) {
	            var newPt = transformPoint(inPoints[i], project);
	            newPt && outPoints.push(newPt);
	          }
	
	          return outPoints;
	        }
	
	        function getPolyShape(points) {
	          return {
	            shape: {
	              points: transformPolygonPoints(points)
	            }
	          };
	        }
	
	        regionsGroup.removeAll(); // Only when the resource is GeoJSON, there is `geo.regions`.
	
	        each(viewBuildCtx.geo.regions, function (region) {
	          var regionName = region.name; // Consider in GeoJson properties.name may be duplicated, for example,
	          // there is multiple region named "United Kindom" or "France" (so many
	          // colonies). And it is not appropriate to merge them in geo, which
	          // will make them share the same label and bring trouble in label
	          // location calculation.
	
	          var regionGroup = regionsGroupByName.get(regionName);
	
	          var _a = regionsInfoByName.get(regionName) || {},
	              dataIdx = _a.dataIdx,
	              regionModel = _a.regionModel;
	
	          if (!regionGroup) {
	            regionGroup = regionsGroupByName.set(regionName, new Group());
	            regionsGroup.add(regionGroup);
	            dataIdx = data ? data.indexOfName(regionName) : null;
	            regionModel = viewBuildCtx.isGeo ? mapOrGeoModel.getRegionModel(regionName) : data ? data.getItemModel(dataIdx) : null;
	            regionsInfoByName.set(regionName, {
	              dataIdx: dataIdx,
	              regionModel: regionModel
	            });
	          }
	
	          var polygonSubpaths = [];
	          var polylineSubpaths = [];
	          each(region.geometries, function (geometry) {
	            // Polygon and MultiPolygon
	            if (geometry.type === 'polygon') {
	              var polys = [geometry.exterior].concat(geometry.interiors || []);
	
	              if (projectionStream) {
	                polys = projectPolys(polys, projectionStream);
	              }
	
	              each(polys, function (poly) {
	                polygonSubpaths.push(new Polygon(getPolyShape(poly)));
	              });
	            } // LineString and MultiLineString
	            else {
	                var points = geometry.points;
	
	                if (projectionStream) {
	                  points = projectPolys(points, projectionStream, true);
	                }
	
	                each(points, function (points) {
	                  polylineSubpaths.push(new Polyline(getPolyShape(points)));
	                });
	              }
	          });
	          var centerPt = transformPoint(region.getCenter(), projection && projection.project);
	
	          function createCompoundPath(subpaths, isLine) {
	            if (!subpaths.length) {
	              return;
	            }
	
	            var compoundPath = new CompoundPath({
	              culling: true,
	              segmentIgnoreThreshold: 1,
	              shape: {
	                paths: subpaths
	              }
	            });
	            regionGroup.add(compoundPath);
	            applyOptionStyleForRegion(viewBuildCtx, compoundPath, dataIdx, regionModel);
	            resetLabelForRegion(viewBuildCtx, compoundPath, regionName, regionModel, mapOrGeoModel, dataIdx, centerPt);
	
	            if (isLine) {
	              fixLineStyle(compoundPath);
	              each(compoundPath.states, fixLineStyle);
	            }
	          }
	
	          createCompoundPath(polygonSubpaths);
	          createCompoundPath(polylineSubpaths, true);
	        }); // Ensure children have been added to `regionGroup` before calling them.
	
	        regionsGroupByName.each(function (regionGroup, regionName) {
	          var _a = regionsInfoByName.get(regionName),
	              dataIdx = _a.dataIdx,
	              regionModel = _a.regionModel;
	
	          resetEventTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel, dataIdx);
	          resetTooltipForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
	          resetStateTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
	        }, this);
	      };
	
	      MapDraw.prototype._buildSVG = function (viewBuildCtx) {
	        var mapName = viewBuildCtx.geo.map;
	        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
	        this._svgGroup.x = transformInfoRaw.x;
	        this._svgGroup.y = transformInfoRaw.y;
	        this._svgGroup.scaleX = transformInfoRaw.scaleX;
	        this._svgGroup.scaleY = transformInfoRaw.scaleY;
	
	        if (this._svgResourceChanged(mapName)) {
	          this._freeSVG();
	
	          this._useSVG(mapName);
	        }
	
	        var svgDispatcherMap = this._svgDispatcherMap = createHashMap();
	        var focusSelf = false;
	        each(this._svgGraphicRecord.named, function (namedItem) {
	          // Note that we also allow different elements have the same name.
	          // For example, a glyph of a city and the label of the city have
	          // the same name and their tooltip info can be defined in a single
	          // region option.
	          var regionName = namedItem.name;
	          var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
	          var data = viewBuildCtx.data;
	          var svgNodeTagLower = namedItem.svgNodeTagLower;
	          var el = namedItem.el;
	          var dataIdx = data ? data.indexOfName(regionName) : null;
	          var regionModel = mapOrGeoModel.getRegionModel(regionName);
	
	          if (OPTION_STYLE_ENABLED_TAG_MAP.get(svgNodeTagLower) != null && el instanceof Displayable) {
	            applyOptionStyleForRegion(viewBuildCtx, el, dataIdx, regionModel);
	          }
	
	          if (el instanceof Displayable) {
	            el.culling = true;
	          } // We do not know how the SVG like so we'd better not to change z2.
	          // Otherwise it might bring some unexpected result. For example,
	          // an area hovered that make some inner city can not be clicked.
	
	
	          el.z2EmphasisLift = 0; // If self named:
	
	          if (!namedItem.namedFrom) {
	            // label should batter to be displayed based on the center of <g>
	            // if it is named rather than displayed on each child.
	            if (LABEL_HOST_MAP.get(svgNodeTagLower) != null) {
	              resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx, null);
	            }
	
	            resetEventTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx);
	            resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
	
	            if (STATE_TRIGGER_TAG_MAP.get(svgNodeTagLower) != null) {
	              var focus_1 = resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
	
	              if (focus_1 === 'self') {
	                focusSelf = true;
	              }
	
	              var els = svgDispatcherMap.get(regionName) || svgDispatcherMap.set(regionName, []);
	              els.push(el);
	            }
	          }
	        }, this);
	
	        this._enableBlurEntireSVG(focusSelf, viewBuildCtx);
	      };
	
	      MapDraw.prototype._enableBlurEntireSVG = function (focusSelf, viewBuildCtx) {
	        // It's a little complicated to support blurring the entire geoSVG in series-map.
	        // So do not support it until some requirements come.
	        // At present, in series-map, only regions can be blurred.
	        if (focusSelf && viewBuildCtx.isGeo) {
	          var blurStyle = viewBuildCtx.mapOrGeoModel.getModel(['blur', 'itemStyle']).getItemStyle(); // Only support `opacity` here. Because not sure that other props are suitable for
	          // all of the elements generated by SVG (especially for Text/TSpan/Image/... ).
	
	          var opacity_1 = blurStyle.opacity;
	
	          this._svgGraphicRecord.root.traverse(function (el) {
	            if (!el.isGroup) {
	              // PENDING: clear those settings to SVG elements when `_freeSVG`.
	              // (Currently it happen not to be needed.)
	              setDefaultStateProxy(el);
	              var style = el.ensureState('blur').style || {}; // Do not overwrite the region style that already set from region option.
	
	              if (style.opacity == null && opacity_1 != null) {
	                style.opacity = opacity_1;
	              } // If `ensureState('blur').style = {}`, there will be default opacity.
	              // Enable `stateTransition` (animation).
	
	
	              el.ensureState('emphasis');
	            }
	          });
	        }
	      };
	
	      MapDraw.prototype.remove = function () {
	        this._regionsGroup.removeAll();
	
	        this._regionsGroupByName = null;
	
	        this._svgGroup.removeAll();
	
	        this._freeSVG();
	
	        this._controller.dispose();
	
	        this._controllerHost = null;
	      };
	
	      MapDraw.prototype.findHighDownDispatchers = function (name, geoModel) {
	        if (name == null) {
	          return [];
	        }
	
	        var geo = geoModel.coordinateSystem;
	
	        if (geo.resourceType === 'geoJSON') {
	          var regionsGroupByName = this._regionsGroupByName;
	
	          if (regionsGroupByName) {
	            var regionGroup = regionsGroupByName.get(name);
	            return regionGroup ? [regionGroup] : [];
	          }
	        } else if (geo.resourceType === 'geoSVG') {
	          return this._svgDispatcherMap && this._svgDispatcherMap.get(name) || [];
	        }
	      };
	
	      MapDraw.prototype._svgResourceChanged = function (mapName) {
	        return this._svgMapName !== mapName;
	      };
	
	      MapDraw.prototype._useSVG = function (mapName) {
	        var resource = geoSourceManager.getGeoResource(mapName);
	
	        if (resource && resource.type === 'geoSVG') {
	          var svgGraphic = resource.useGraphic(this.uid);
	
	          this._svgGroup.add(svgGraphic.root);
	
	          this._svgGraphicRecord = svgGraphic;
	          this._svgMapName = mapName;
	        }
	      };
	
	      MapDraw.prototype._freeSVG = function () {
	        var mapName = this._svgMapName;
	
	        if (mapName == null) {
	          return;
	        }
	
	        var resource = geoSourceManager.getGeoResource(mapName);
	
	        if (resource && resource.type === 'geoSVG') {
	          resource.freeGraphic(this.uid);
	        }
	
	        this._svgGraphicRecord = null;
	        this._svgDispatcherMap = null;
	
	        this._svgGroup.removeAll();
	
	        this._svgMapName = null;
	      };
	
	      MapDraw.prototype._updateController = function (mapOrGeoModel, ecModel, api) {
	        var geo = mapOrGeoModel.coordinateSystem;
	        var controller = this._controller;
	        var controllerHost = this._controllerHost; // @ts-ignore FIXME:TS
	
	        controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
	        controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
	        // @ts-ignore FIXME:TS
	
	        controller.enable(mapOrGeoModel.get('roam') || false);
	        var mainType = mapOrGeoModel.mainType;
	
	        function makeActionBase() {
	          var action = {
	            type: 'geoRoam',
	            componentType: mainType
	          };
	          action[mainType + 'Id'] = mapOrGeoModel.id;
	          return action;
	        }
	
	        controller.off('pan').on('pan', function (e) {
	          this._mouseDownFlag = false;
	          updateViewOnPan(controllerHost, e.dx, e.dy);
	          api.dispatchAction(extend(makeActionBase(), {
	            dx: e.dx,
	            dy: e.dy,
	            animation: {
	              duration: 0
	            }
	          }));
	        }, this);
	        controller.off('zoom').on('zoom', function (e) {
	          this._mouseDownFlag = false;
	          updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	          api.dispatchAction(extend(makeActionBase(), {
	            zoom: e.scale,
	            originX: e.originX,
	            originY: e.originY,
	            animation: {
	              duration: 0
	            }
	          }));
	        }, this);
	        controller.setPointerChecker(function (e, x, y) {
	          return geo.containPoint([x, y]) && !onIrrelevantElement(e, api, mapOrGeoModel);
	        });
	      };
	      /**
	       * FIXME: this is a temporarily workaround.
	       * When `geoRoam` the elements need to be reset in `MapView['render']`, because the props like
	       * `ignore` might have been modified by `LabelManager`, and `LabelManager#addLabelsOfSeries`
	       * will subsequently cache `defaultAttr` like `ignore`. If do not do this reset, the modified
	       * props will have no chance to be restored.
	       * Note: This reset should be after `clearStates` in `renderSeries` because `useStates` in
	       * `renderSeries` will cache the modified `ignore` to `el._normalState`.
	       * TODO:
	       * Use clone/immutable in `LabelManager`?
	       */
	
	
	      MapDraw.prototype.resetForLabelLayout = function () {
	        this.group.traverse(function (el) {
	          var label = el.getTextContent();
	
	          if (label) {
	            label.ignore = mapLabelRaw(label).ignore;
	          }
	        });
	      };
	
	      MapDraw.prototype._updateMapSelectHandler = function (mapOrGeoModel, regionsGroup, api, fromView) {
	        var mapDraw = this;
	        regionsGroup.off('mousedown');
	        regionsGroup.off('click'); // @ts-ignore FIXME:TS resolve type conflict
	
	        if (mapOrGeoModel.get('selectedMode')) {
	          regionsGroup.on('mousedown', function () {
	            mapDraw._mouseDownFlag = true;
	          });
	          regionsGroup.on('click', function (e) {
	            if (!mapDraw._mouseDownFlag) {
	              return;
	            }
	
	            mapDraw._mouseDownFlag = false;
	          });
	        }
	      };
	
	      return MapDraw;
	    }();
	
	    function applyOptionStyleForRegion(viewBuildCtx, el, dataIndex, regionModel) {
	      // All of the path are using `itemStyle`, because
	      // (1) Some SVG also use fill on polyline (The different between
	      // polyline and polygon is "open" or "close" but not fill or not).
	      // (2) For the common props like opacity, if some use itemStyle
	      // and some use `lineStyle`, it might confuse users.
	      // (3) Most SVG use <path>, where can not detect whether to draw a "line"
	      // or a filled shape, so use `itemStyle` for <path>.
	      var normalStyleModel = regionModel.getModel('itemStyle');
	      var emphasisStyleModel = regionModel.getModel(['emphasis', 'itemStyle']);
	      var blurStyleModel = regionModel.getModel(['blur', 'itemStyle']);
	      var selectStyleModel = regionModel.getModel(['select', 'itemStyle']); // NOTE: DON'T use 'style' in visual when drawing map.
	      // This component is used for drawing underlying map for both geo component and map series.
	
	      var normalStyle = getFixedItemStyle(normalStyleModel);
	      var emphasisStyle = getFixedItemStyle(emphasisStyleModel);
	      var selectStyle = getFixedItemStyle(selectStyleModel);
	      var blurStyle = getFixedItemStyle(blurStyleModel); // Update the itemStyle if has data visual
	
	      var data = viewBuildCtx.data;
	
	      if (data) {
	        // Only visual color of each item will be used. It can be encoded by visualMap
	        // But visual color of series is used in symbol drawing
	        // Visual color for each series is for the symbol draw
	        var style = data.getItemVisual(dataIndex, 'style');
	        var decal = data.getItemVisual(dataIndex, 'decal');
	
	        if (viewBuildCtx.isVisualEncodedByVisualMap && style.fill) {
	          normalStyle.fill = style.fill;
	        }
	
	        if (decal) {
	          normalStyle.decal = createOrUpdatePatternFromDecal(decal, viewBuildCtx.api);
	        }
	      } // SVG text, tspan and image can be named but not supporeted
	      // to be styled by region option yet.
	
	
	      el.setStyle(normalStyle);
	      el.style.strokeNoScale = true;
	      el.ensureState('emphasis').style = emphasisStyle;
	      el.ensureState('select').style = selectStyle;
	      el.ensureState('blur').style = blurStyle; // Enable blur
	
	      setDefaultStateProxy(el);
	    }
	
	    function resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
	    dataIdx, // If labelXY not provided, use `textConfig.position: 'inside'`
	    labelXY) {
	      var data = viewBuildCtx.data;
	      var isGeo = viewBuildCtx.isGeo;
	      var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
	      var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
	      // 1. In map series and data value is NaN
	      // 2. In geo component
	      // 3. Region has no series legendIcon, which will be add a showLabel flag in mapSymbolLayout
	
	      if (isGeo || isDataNaN || itemLayout && itemLayout.showLabel) {
	        var query = !isGeo ? dataIdx : regionName;
	        var labelFetcher = void 0; // Consider dataIdx not found.
	
	        if (!data || dataIdx >= 0) {
	          labelFetcher = mapOrGeoModel;
	        }
	
	        var specifiedTextOpt = labelXY ? {
	          normal: {
	            align: 'center',
	            verticalAlign: 'middle'
	          }
	        } : null; // Caveat: must be called after `setDefaultStateProxy(el);` called.
	        // because textContent will be assign with `el.stateProxy` inside.
	
	        setLabelStyle(el, getLabelStatesModels(regionModel), {
	          labelFetcher: labelFetcher,
	          labelDataIndex: query,
	          defaultText: regionName
	        }, specifiedTextOpt);
	        var textEl = el.getTextContent();
	
	        if (textEl) {
	          mapLabelRaw(textEl).ignore = textEl.ignore;
	
	          if (el.textConfig && labelXY) {
	            // Compute a relative offset based on the el bounding rect.
	            var rect = el.getBoundingRect().clone(); // Need to make sure the percent position base on the same rect in normal and
	            // emphasis state. Otherwise if using boundingRect of el, but the emphasis state
	            // has borderWidth (even 0.5px), the text position will be changed obviously
	            // if the position is very big like ['1234%', '1345%'].
	
	            el.textConfig.layoutRect = rect;
	            el.textConfig.position = [(labelXY[0] - rect.x) / rect.width * 100 + '%', (labelXY[1] - rect.y) / rect.height * 100 + '%'];
	          }
	        } // PENDING:
	        // If labelLayout is enabled (test/label-layout.html), el.dataIndex should be specified.
	        // But el.dataIndex is also used to determine whether user event should be triggered,
	        // where el.seriesIndex or el.dataModel must be specified. At present for a single el
	        // there is not case that "only label layout enabled but user event disabled", so here
	        // we depends `resetEventTriggerForRegion` to do the job of setting `el.dataIndex`.
	
	
	        el.disableLabelAnimation = true;
	      } else {
	        el.removeTextContent();
	        el.removeTextConfig();
	        el.disableLabelAnimation = null;
	      }
	    }
	
	    function resetEventTriggerForRegion(viewBuildCtx, eventTrigger, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
	    dataIdx) {
	      // setItemGraphicEl, setHoverStyle after all polygons and labels
	      // are added to the regionGroup
	      if (viewBuildCtx.data) {
	        // FIXME: when series-map use a SVG map, and there are duplicated name specified
	        // on different SVG elements, after `data.setItemGraphicEl(...)`:
	        // (1) all of them will be mounted with `dataIndex`, `seriesIndex`, so that tooltip
	        // can be triggered only mouse hover. That's correct.
	        // (2) only the last element will be kept in `data`, so that if trigger tooltip
	        // by `dispatchAction`, only the last one can be found and triggered. That might be
	        // not correct. We will fix it in future if anyone demanding that.
	        viewBuildCtx.data.setItemGraphicEl(dataIdx, eventTrigger);
	      } // series-map will not trigger "geoselectchange" no matter it is
	      // based on a declared geo component. Because series-map will
	      // trigger "selectchange". If it trigger both the two events,
	      // If users call `chart.dispatchAction({type: 'toggleSelect'})`,
	      // it not easy to also fire event "geoselectchanged".
	      else {
	          // Package custom mouse event for geo component
	          getECData(eventTrigger).eventData = {
	            componentType: 'geo',
	            componentIndex: mapOrGeoModel.componentIndex,
	            geoIndex: mapOrGeoModel.componentIndex,
	            name: regionName,
	            region: regionModel && regionModel.option || {}
	          };
	        }
	    }
	
	    function resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
	      if (!viewBuildCtx.data) {
	        setTooltipConfig({
	          el: el,
	          componentModel: mapOrGeoModel,
	          itemName: regionName,
	          // @ts-ignore FIXME:TS fix the "compatible with each other"?
	          itemTooltipOption: regionModel.get('tooltip')
	        });
	      }
	    }
	
	    function resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
	      // @ts-ignore FIXME:TS fix the "compatible with each other"?
	      el.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode'); // @ts-ignore FIXME:TS fix the "compatible with each other"?
	
	      var emphasisModel = regionModel.getModel('emphasis');
	      var focus = emphasisModel.get('focus');
	      toggleHoverEmphasis(el, focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	
	      if (viewBuildCtx.isGeo) {
	        enableComponentHighDownFeatures(el, mapOrGeoModel, regionName);
	      }
	
	      return focus;
	    }
	
	    function projectPolys(rings, // Polygons include exterior and interiors. Or polylines.
	    createStream, isLine) {
	      var polygons = [];
	      var curPoly;
	
	      function startPolygon() {
	        curPoly = [];
	      }
	
	      function endPolygon() {
	        if (curPoly.length) {
	          polygons.push(curPoly);
	          curPoly = [];
	        }
	      }
	
	      var stream = createStream({
	        polygonStart: startPolygon,
	        polygonEnd: endPolygon,
	        lineStart: startPolygon,
	        lineEnd: endPolygon,
	        point: function (x, y) {
	          // May have NaN values from stream.
	          if (isFinite(x) && isFinite(y)) {
	            curPoly.push([x, y]);
	          }
	        },
	        sphere: function () {}
	      });
	      !isLine && stream.polygonStart();
	      each(rings, function (ring) {
	        stream.lineStart();
	
	        for (var i = 0; i < ring.length; i++) {
	          stream.point(ring[i][0], ring[i][1]);
	        }
	
	        stream.lineEnd();
	      });
	      !isLine && stream.polygonEnd();
	      return polygons;
	    }
	     // @ts-ignore FIXME:TS fix the "compatible with each other"?
	
	    var MapView =
	    /** @class */
	    function (_super) {
	      __extends(MapView, _super);
	
	      function MapView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MapView.type;
	        return _this;
	      }
	
	      MapView.prototype.render = function (mapModel, ecModel, api, payload) {
	        // Not render if it is an toggleSelect action from self
	        if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
	          return;
	        }
	
	        var group = this.group;
	        group.removeAll();
	
	        if (mapModel.getHostGeoModel()) {
	          return;
	        }
	
	        if (this._mapDraw && payload && payload.type === 'geoRoam') {
	          this._mapDraw.resetForLabelLayout();
	        } // Not update map if it is an roam action from self
	
	
	        if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
	          if (mapModel.needsDrawMap) {
	            var mapDraw = this._mapDraw || new MapDraw(api);
	            group.add(mapDraw.group);
	            mapDraw.draw(mapModel, ecModel, api, this, payload);
	            this._mapDraw = mapDraw;
	          } else {
	            // Remove drawn map
	            this._mapDraw && this._mapDraw.remove();
	            this._mapDraw = null;
	          }
	        } else {
	          var mapDraw = this._mapDraw;
	          mapDraw && group.add(mapDraw.group);
	        }
	
	        mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
	      };
	
	      MapView.prototype.remove = function () {
	        this._mapDraw && this._mapDraw.remove();
	        this._mapDraw = null;
	        this.group.removeAll();
	      };
	
	      MapView.prototype.dispose = function () {
	        this._mapDraw && this._mapDraw.remove();
	        this._mapDraw = null;
	      };
	
	      MapView.prototype._renderSymbols = function (mapModel, ecModel, api) {
	        var originalData = mapModel.originalData;
	        var group = this.group;
	        originalData.each(originalData.mapDimension('value'), function (value, originalDataIndex) {
	          if (isNaN(value)) {
	            return;
	          }
	
	          var layout = originalData.getItemLayout(originalDataIndex);
	
	          if (!layout || !layout.point) {
	            // Not exists in map
	            return;
	          }
	
	          var point = layout.point;
	          var offset = layout.offset;
	          var circle = new Circle({
	            style: {
	              // Because the special of map draw.
	              // Which needs statistic of multiple series and draw on one map.
	              // And each series also need a symbol with legend color
	              //
	              // Layout and visual are put one the different data
	              // TODO
	              fill: mapModel.getData().getVisual('style').fill
	            },
	            shape: {
	              cx: point[0] + offset * 9,
	              cy: point[1],
	              r: 3
	            },
	            silent: true,
	            // Do not overlap the first series, on which labels are displayed.
	            z2: 8 + (!offset ? Z2_EMPHASIS_LIFT + 1 : 0)
	          }); // Only the series that has the first value on the same region is in charge of rendering the label.
	          // But consider the case:
	          // series: [
	          //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
	          //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
	          // ]
	          // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
	          // For backward compatibility, we follow the rule that render label `A` by the
	          // settings on series `X` but render label `C` by the settings on series `Y`.
	
	          if (!offset) {
	            var fullData = mapModel.mainSeries.getData();
	            var name_1 = originalData.getName(originalDataIndex);
	            var fullIndex_1 = fullData.indexOfName(name_1);
	            var itemModel = originalData.getItemModel(originalDataIndex);
	            var labelModel = itemModel.getModel('label');
	            var regionGroup = fullData.getItemGraphicEl(fullIndex_1); // `getFormattedLabel` needs to use `getData` inside. Here
	            // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
	            // FIXME
	            // If this is not the `mainSeries`, the item model (like label formatter)
	            // set on original data item will never get. But it has been working
	            // like that from the beginning, and this scenario is rarely encountered.
	            // So it won't be fixed until we have to.
	
	            setLabelStyle(circle, getLabelStatesModels(itemModel), {
	              labelFetcher: {
	                getFormattedLabel: function (idx, state) {
	                  return mapModel.getFormattedLabel(fullIndex_1, state);
	                }
	              },
	              defaultText: name_1
	            });
	            circle.disableLabelAnimation = true;
	
	            if (!labelModel.get('position')) {
	              circle.setTextConfig({
	                position: 'bottom'
	              });
	            }
	
	            regionGroup.onHoverStateChange = function (toState) {
	              setStatesFlag(circle, toState);
	            };
	          }
	
	          group.add(circle);
	        });
	      };
	
	      MapView.type = 'map';
	      return MapView;
	    }(ChartView);
	
	    var MapSeries =
	    /** @class */
	    function (_super) {
	      __extends(MapSeries, _super);
	
	      function MapSeries() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MapSeries.type; // Only first map series of same mapType will drawMap.
	
	        _this.needsDrawMap = false; // Group of all map series with same mapType
	
	        _this.seriesGroup = [];
	
	        _this.getTooltipPosition = function (dataIndex) {
	          if (dataIndex != null) {
	            var name_1 = this.getData().getName(dataIndex);
	            var geo = this.coordinateSystem;
	            var region = geo.getRegion(name_1);
	            return region && geo.dataToPoint(region.getCenter());
	          }
	        };
	
	        return _this;
	      }
	
	      MapSeries.prototype.getInitialData = function (option) {
	        var data = createSeriesDataSimply(this, {
	          coordDimensions: ['value'],
	          encodeDefaulter: curry(makeSeriesEncodeForNameBased, this)
	        });
	        var dataNameMap = createHashMap();
	        var toAppendNames = [];
	
	        for (var i = 0, len = data.count(); i < len; i++) {
	          var name_2 = data.getName(i);
	          dataNameMap.set(name_2, true);
	        }
	
	        var geoSource = geoSourceManager.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
	        each(geoSource.regions, function (region) {
	          var name = region.name;
	
	          if (!dataNameMap.get(name)) {
	            toAppendNames.push(name);
	          }
	        }); // Complete data with missing regions. The consequent processes (like visual
	        // map and render) can not be performed without a "full data". For example,
	        // find `dataIndex` by name.
	
	        data.appendValues([], toAppendNames);
	        return data;
	      };
	      /**
	       * If no host geo model, return null, which means using a
	       * inner exclusive geo model.
	       */
	
	
	      MapSeries.prototype.getHostGeoModel = function () {
	        var geoIndex = this.option.geoIndex;
	        return geoIndex != null ? this.ecModel.getComponent('geo', geoIndex) : null;
	      };
	
	      MapSeries.prototype.getMapType = function () {
	        return (this.getHostGeoModel() || this).option.map;
	      }; // _fillOption(option, mapName) {
	      // Shallow clone
	      // option = zrUtil.extend({}, option);
	      // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
	      // return option;
	      // }
	
	
	      MapSeries.prototype.getRawValue = function (dataIndex) {
	        // Use value stored in data instead because it is calculated from multiple series
	        // FIXME Provide all value of multiple series ?
	        var data = this.getData();
	        return data.get(data.mapDimension('value'), dataIndex);
	      };
	      /**
	       * Get model of region
	       */
	
	
	      MapSeries.prototype.getRegionModel = function (regionName) {
	        var data = this.getData();
	        return data.getItemModel(data.indexOfName(regionName));
	      };
	      /**
	       * Map tooltip formatter
	       */
	
	
	      MapSeries.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        // FIXME orignalData and data is a bit confusing
	        var data = this.getData();
	        var value = this.getRawValue(dataIndex);
	        var name = data.getName(dataIndex);
	        var seriesGroup = this.seriesGroup;
	        var seriesNames = [];
	
	        for (var i = 0; i < seriesGroup.length; i++) {
	          var otherIndex = seriesGroup[i].originalData.indexOfName(name);
	          var valueDim = data.mapDimension('value');
	
	          if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) {
	            seriesNames.push(seriesGroup[i].name);
	          }
	        }
	
	        return createTooltipMarkup('section', {
	          header: seriesNames.join(', '),
	          noHeader: !seriesNames.length,
	          blocks: [createTooltipMarkup('nameValue', {
	            name: name,
	            value: value
	          })]
	        });
	      };
	
	      MapSeries.prototype.setZoom = function (zoom) {
	        this.option.zoom = zoom;
	      };
	
	      MapSeries.prototype.setCenter = function (center) {
	        this.option.center = center;
	      };
	
	      MapSeries.prototype.getLegendIcon = function (opt) {
	        var iconType = opt.icon || 'roundRect';
	        var icon = createSymbol(iconType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill);
	        icon.setStyle(opt.itemStyle); // Map do not use itemStyle.borderWidth as border width
	
	        icon.style.stroke = 'none'; // No rotation because no series visual symbol for map
	
	        if (iconType.indexOf('empty') > -1) {
	          icon.style.stroke = icon.style.fill;
	          icon.style.fill = '#fff';
	          icon.style.lineWidth = 2;
	        }
	
	        return icon;
	      };
	
	      MapSeries.type = 'series.map';
	      MapSeries.dependencies = ['geo'];
	      MapSeries.layoutMode = 'box';
	      MapSeries.defaultOption = {
	        // 一级层叠
	        // zlevel: 0,
	        // 二级层叠
	        z: 2,
	        coordinateSystem: 'geo',
	        // map should be explicitly specified since ec3.
	        map: '',
	        // If `geoIndex` is not specified, a exclusive geo will be
	        // created. Otherwise use the specified geo component, and
	        // `map` and `mapType` are ignored.
	        // geoIndex: 0,
	        // 'center' | 'left' | 'right' | 'x%' | {number}
	        left: 'center',
	        // 'center' | 'top' | 'bottom' | 'x%' | {number}
	        top: 'center',
	        // right
	        // bottom
	        // width:
	        // height
	        // Aspect is width / height. Inited to be geoJson bbox aspect
	        // This parameter is used for scale this aspect
	        // Default value:
	        // for geoSVG source: 1,
	        // for geoJSON source: 0.75.
	        aspectScale: null,
	        // Layout with center and size
	        // If you want to put map in a fixed size box with right aspect ratio
	        // This two properties may be more convenient.
	        // layoutCenter: [50%, 50%]
	        // layoutSize: 100
	        showLegendSymbol: true,
	        // Define left-top, right-bottom coords to control view
	        // For example, [ [180, 90], [-180, -90] ],
	        // higher priority than center and zoom
	        boundingCoords: null,
	        // Default on center of map
	        center: null,
	        zoom: 1,
	        scaleLimit: null,
	        selectedMode: true,
	        label: {
	          show: false,
	          color: '#000'
	        },
	        // scaleLimit: null,
	        itemStyle: {
	          borderWidth: 0.5,
	          borderColor: '#444',
	          areaColor: '#eee'
	        },
	        emphasis: {
	          label: {
	            show: true,
	            color: 'rgb(100,0,0)'
	          },
	          itemStyle: {
	            areaColor: 'rgba(255,215,0,0.8)'
	          }
	        },
	        select: {
	          label: {
	            show: true,
	            color: 'rgb(100,0,0)'
	          },
	          itemStyle: {
	            color: 'rgba(255,215,0,0.8)'
	          }
	        },
	        nameProperty: 'name'
	      };
	      return MapSeries;
	    }(SeriesModel);
	
	    function dataStatistics(datas, statisticType) {
	      var dataNameMap = {};
	      each(datas, function (data) {
	        data.each(data.mapDimension('value'), function (value, idx) {
	          // Add prefix to avoid conflict with Object.prototype.
	          var mapKey = 'ec-' + data.getName(idx);
	          dataNameMap[mapKey] = dataNameMap[mapKey] || [];
	
	          if (!isNaN(value)) {
	            dataNameMap[mapKey].push(value);
	          }
	        });
	      });
	      return datas[0].map(datas[0].mapDimension('value'), function (value, idx) {
	        var mapKey = 'ec-' + datas[0].getName(idx);
	        var sum = 0;
	        var min = Infinity;
	        var max = -Infinity;
	        var len = dataNameMap[mapKey].length;
	
	        for (var i = 0; i < len; i++) {
	          min = Math.min(min, dataNameMap[mapKey][i]);
	          max = Math.max(max, dataNameMap[mapKey][i]);
	          sum += dataNameMap[mapKey][i];
	        }
	
	        var result;
	
	        if (statisticType === 'min') {
	          result = min;
	        } else if (statisticType === 'max') {
	          result = max;
	        } else if (statisticType === 'average') {
	          result = sum / len;
	        } else {
	          result = sum;
	        }
	
	        return len === 0 ? NaN : result;
	      });
	    }
	
	    function mapDataStatistic(ecModel) {
	      var seriesGroups = {};
	      ecModel.eachSeriesByType('map', function (seriesModel) {
	        var hostGeoModel = seriesModel.getHostGeoModel();
	        var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
	        (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
	      });
	      each(seriesGroups, function (seriesList, key) {
	        var data = dataStatistics(map(seriesList, function (seriesModel) {
	          return seriesModel.getData();
	        }), seriesList[0].get('mapValueCalculation'));
	
	        for (var i = 0; i < seriesList.length; i++) {
	          seriesList[i].originalData = seriesList[i].getData();
	        } // FIXME Put where?
	
	
	        for (var i = 0; i < seriesList.length; i++) {
	          seriesList[i].seriesGroup = seriesList;
	          seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
	          seriesList[i].setData(data.cloneShallow());
	          seriesList[i].mainSeries = seriesList[0];
	        }
	      });
	    }
	
	    function mapSymbolLayout(ecModel) {
	      var processedMapType = {};
	      ecModel.eachSeriesByType('map', function (mapSeries) {
	        var mapType = mapSeries.getMapType();
	
	        if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
	          return;
	        }
	
	        var mapSymbolOffsets = {};
	        each(mapSeries.seriesGroup, function (subMapSeries) {
	          var geo = subMapSeries.coordinateSystem;
	          var data = subMapSeries.originalData;
	
	          if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
	            data.each(data.mapDimension('value'), function (value, idx) {
	              var name = data.getName(idx);
	              var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
	              // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
	              // not be drawn. So here must validate if value is NaN.
	
	              if (!region || isNaN(value)) {
	                return;
	              }
	
	              var offset = mapSymbolOffsets[name] || 0;
	              var point = geo.dataToPoint(region.getCenter());
	              mapSymbolOffsets[name] = offset + 1;
	              data.setItemLayout(idx, {
	                point: point,
	                offset: offset
	              });
	            });
	          }
	        }); // Show label of those region not has legendIcon (which is offset 0)
	
	        var data = mapSeries.getData();
	        data.each(function (idx) {
	          var name = data.getName(idx);
	          var layout = data.getItemLayout(idx) || {};
	          layout.showLabel = !mapSymbolOffsets[name];
	          data.setItemLayout(idx, layout);
	        });
	        processedMapType[mapType] = true;
	      });
	    }
	
	    var v2ApplyTransform = applyTransform;
	
	    var View =
	    /** @class */
	    function (_super) {
	      __extends(View, _super);
	
	      function View(name) {
	        var _this = _super.call(this) || this;
	
	        _this.type = 'view';
	        _this.dimensions = ['x', 'y'];
	        /**
	         * Represents the transform brought by roam/zoom.
	         * If `View['_viewRect']` applies roam transform,
	         * we can get the final displayed rect.
	         */
	
	        _this._roamTransformable = new Transformable();
	        /**
	         * Represents the transform from `View['_rect']` to `View['_viewRect']`.
	         */
	
	        _this._rawTransformable = new Transformable();
	        _this.name = name;
	        return _this;
	      }
	
	      View.prototype.setBoundingRect = function (x, y, width, height) {
	        this._rect = new BoundingRect(x, y, width, height);
	        return this._rect;
	      };
	      /**
	       * @return {module:zrender/core/BoundingRect}
	       */
	
	
	      View.prototype.getBoundingRect = function () {
	        return this._rect;
	      };
	
	      View.prototype.setViewRect = function (x, y, width, height) {
	        this._transformTo(x, y, width, height);
	
	        this._viewRect = new BoundingRect(x, y, width, height);
	      };
	      /**
	       * Transformed to particular position and size
	       */
	
	
	      View.prototype._transformTo = function (x, y, width, height) {
	        var rect = this.getBoundingRect();
	        var rawTransform = this._rawTransformable;
	        rawTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	        var rawParent = rawTransform.parent;
	        rawTransform.parent = null;
	        rawTransform.decomposeTransform();
	        rawTransform.parent = rawParent;
	
	        this._updateTransform();
	      };
	      /**
	       * Set center of view
	       */
	
	
	      View.prototype.setCenter = function (centerCoord, api) {
	        if (!centerCoord) {
	          return;
	        }
	
	        this._center = [parsePercent$1(centerCoord[0], api.getWidth()), parsePercent$1(centerCoord[1], api.getHeight())];
	
	        this._updateCenterAndZoom();
	      };
	
	      View.prototype.setZoom = function (zoom) {
	        zoom = zoom || 1;
	        var zoomLimit = this.zoomLimit;
	
	        if (zoomLimit) {
	          if (zoomLimit.max != null) {
	            zoom = Math.min(zoomLimit.max, zoom);
	          }
	
	          if (zoomLimit.min != null) {
	            zoom = Math.max(zoomLimit.min, zoom);
	          }
	        }
	
	        this._zoom = zoom;
	
	        this._updateCenterAndZoom();
	      };
	      /**
	       * Get default center without roam
	       */
	
	
	      View.prototype.getDefaultCenter = function () {
	        // Rect before any transform
	        var rawRect = this.getBoundingRect();
	        var cx = rawRect.x + rawRect.width / 2;
	        var cy = rawRect.y + rawRect.height / 2;
	        return [cx, cy];
	      };
	
	      View.prototype.getCenter = function () {
	        return this._center || this.getDefaultCenter();
	      };
	
	      View.prototype.getZoom = function () {
	        return this._zoom || 1;
	      };
	
	      View.prototype.getRoamTransform = function () {
	        return this._roamTransformable.getLocalTransform();
	      };
	      /**
	       * Remove roam
	       */
	
	
	      View.prototype._updateCenterAndZoom = function () {
	        // Must update after view transform updated
	        var rawTransformMatrix = this._rawTransformable.getLocalTransform();
	
	        var roamTransform = this._roamTransformable;
	        var defaultCenter = this.getDefaultCenter();
	        var center = this.getCenter();
	        var zoom = this.getZoom();
	        center = applyTransform([], center, rawTransformMatrix);
	        defaultCenter = applyTransform([], defaultCenter, rawTransformMatrix);
	        roamTransform.originX = center[0];
	        roamTransform.originY = center[1];
	        roamTransform.x = defaultCenter[0] - center[0];
	        roamTransform.y = defaultCenter[1] - center[1];
	        roamTransform.scaleX = roamTransform.scaleY = zoom;
	
	        this._updateTransform();
	      };
	      /**
	       * Update transform props on `this` based on the current
	       * `this._roamTransformable` and `this._rawTransformable`.
	       */
	
	
	      View.prototype._updateTransform = function () {
	        var roamTransformable = this._roamTransformable;
	        var rawTransformable = this._rawTransformable;
	        rawTransformable.parent = roamTransformable;
	        roamTransformable.updateTransform();
	        rawTransformable.updateTransform();
	        copy$1(this.transform || (this.transform = []), rawTransformable.transform || create$1());
	        this._rawTransform = rawTransformable.getLocalTransform();
	        this.invTransform = this.invTransform || [];
	        invert(this.invTransform, this.transform);
	        this.decomposeTransform();
	      };
	
	      View.prototype.getTransformInfo = function () {
	        var rawTransformable = this._rawTransformable;
	        var roamTransformable = this._roamTransformable; // Because roamTransformabel has `originX/originY` modified,
	        // but the caller of `getTransformInfo` can not handle `originX/originY`,
	        // so need to recalculate them.
	
	        var dummyTransformable = new Transformable();
	        dummyTransformable.transform = roamTransformable.transform;
	        dummyTransformable.decomposeTransform();
	        return {
	          roam: {
	            x: dummyTransformable.x,
	            y: dummyTransformable.y,
	            scaleX: dummyTransformable.scaleX,
	            scaleY: dummyTransformable.scaleY
	          },
	          raw: {
	            x: rawTransformable.x,
	            y: rawTransformable.y,
	            scaleX: rawTransformable.scaleX,
	            scaleY: rawTransformable.scaleY
	          }
	        };
	      };
	
	      View.prototype.getViewRect = function () {
	        return this._viewRect;
	      };
	      /**
	       * Get view rect after roam transform
	       */
	
	
	      View.prototype.getViewRectAfterRoam = function () {
	        var rect = this.getBoundingRect().clone();
	        rect.applyTransform(this.transform);
	        return rect;
	      };
	      /**
	       * Convert a single (lon, lat) data item to (x, y) point.
	       */
	
	
	      View.prototype.dataToPoint = function (data, noRoam, out) {
	        var transform = noRoam ? this._rawTransform : this.transform;
	        out = out || [];
	        return transform ? v2ApplyTransform(out, data, transform) : copy(out, data);
	      };
	      /**
	       * Convert a (x, y) point to (lon, lat) data
	       */
	
	
	      View.prototype.pointToData = function (point) {
	        var invTransform = this.invTransform;
	        return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
	      };
	
	      View.prototype.convertToPixel = function (ecModel, finder, value) {
	        var coordSys = getCoordSys(finder);
	        return coordSys === this ? coordSys.dataToPoint(value) : null;
	      };
	
	      View.prototype.convertFromPixel = function (ecModel, finder, pixel) {
	        var coordSys = getCoordSys(finder);
	        return coordSys === this ? coordSys.pointToData(pixel) : null;
	      };
	      /**
	       * @implements
	       */
	
	
	      View.prototype.containPoint = function (point) {
	        return this.getViewRectAfterRoam().contain(point[0], point[1]);
	      };
	
	      View.dimensions = ['x', 'y'];
	      return View;
	    }(Transformable);
	
	    function getCoordSys(finder) {
	      var seriesModel = finder.seriesModel;
	      return seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
	    }
	
	    var GEO_DEFAULT_PARAMS = {
	      'geoJSON': {
	        aspectScale: 0.75,
	        invertLongitute: true
	      },
	      'geoSVG': {
	        aspectScale: 1,
	        invertLongitute: false
	      }
	    };
	    var geo2DDimensions = ['lng', 'lat'];
	
	    var Geo =
	    /** @class */
	    function (_super) {
	      __extends(Geo, _super);
	
	      function Geo(name, map, opt) {
	        var _this = _super.call(this, name) || this;
	
	        _this.dimensions = geo2DDimensions;
	        _this.type = 'geo'; // Only store specified name coord via `addGeoCoord`.
	
	        _this._nameCoordMap = createHashMap();
	        _this.map = map;
	        var projection = opt.projection;
	        var source = geoSourceManager.load(map, opt.nameMap, opt.nameProperty);
	        var resource = geoSourceManager.getGeoResource(map);
	        var resourceType = _this.resourceType = resource ? resource.type : null;
	        var regions = _this.regions = source.regions;
	        var defaultParams = GEO_DEFAULT_PARAMS[resource.type];
	        _this._regionsMap = source.regionsMap;
	        _this.regions = source.regions;
	
	        if ("development" !== 'production' && projection) {
	          // Do some check
	          if (resourceType === 'geoSVG') {
	            if (true) {
	              warn("Map " + map + " with SVG source can't use projection. Only GeoJSON source supports projection.");
	            }
	
	            projection = null;
	          }
	
	          if (!(projection.project && projection.unproject)) {
	            if (true) {
	              warn('project and unproject must be both provided in the projeciton.');
	            }
	
	            projection = null;
	          }
	        }
	
	        _this.projection = projection;
	        var boundingRect;
	
	        if (projection) {
	          // Can't reuse the raw bounding rect
	          for (var i = 0; i < regions.length; i++) {
	            var regionRect = regions[i].getBoundingRect(projection);
	            boundingRect = boundingRect || regionRect.clone();
	            boundingRect.union(regionRect);
	          }
	        } else {
	          boundingRect = source.boundingRect;
	        }
	
	        _this.setBoundingRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height); // aspectScale and invertLongitute actually is the parameters default raw projection.
	        // So we ignore them if projection is given.
	        // Ignore default aspect scale if projection exits.
	
	
	        _this.aspectScale = projection ? 1 : retrieve2(opt.aspectScale, defaultParams.aspectScale); // Not invert longitude if projection exits.
	
	        _this._invertLongitute = projection ? false : defaultParams.invertLongitute;
	        return _this;
	      }
	
	      Geo.prototype._transformTo = function (x, y, width, height) {
	        var rect = this.getBoundingRect();
	        var invertLongitute = this._invertLongitute;
	        rect = rect.clone();
	
	        if (invertLongitute) {
	          // Longitude is inverted.
	          rect.y = -rect.y - rect.height;
	        }
	
	        var rawTransformable = this._rawTransformable;
	        rawTransformable.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	        var rawParent = rawTransformable.parent;
	        rawTransformable.parent = null;
	        rawTransformable.decomposeTransform();
	        rawTransformable.parent = rawParent;
	
	        if (invertLongitute) {
	          rawTransformable.scaleY = -rawTransformable.scaleY;
	        }
	
	        this._updateTransform();
	      };
	
	      Geo.prototype.getRegion = function (name) {
	        return this._regionsMap.get(name);
	      };
	
	      Geo.prototype.getRegionByCoord = function (coord) {
	        var regions = this.regions;
	
	        for (var i = 0; i < regions.length; i++) {
	          var region = regions[i];
	
	          if (region.type === 'geoJSON' && region.contain(coord)) {
	            return regions[i];
	          }
	        }
	      };
	      /**
	       * Add geoCoord for indexing by name
	       */
	
	
	      Geo.prototype.addGeoCoord = function (name, geoCoord) {
	        this._nameCoordMap.set(name, geoCoord);
	      };
	      /**
	       * Get geoCoord by name
	       */
	
	
	      Geo.prototype.getGeoCoord = function (name) {
	        var region = this._regionsMap.get(name); // Calculate center only on demand.
	
	
	        return this._nameCoordMap.get(name) || region && region.getCenter();
	      };
	
	      Geo.prototype.dataToPoint = function (data, noRoam, out) {
	        if (isString(data)) {
	          // Map area name to geoCoord
	          data = this.getGeoCoord(data);
	        }
	
	        if (data) {
	          var projection = this.projection;
	
	          if (projection) {
	            // projection may return null point.
	            data = projection.project(data);
	          }
	
	          return data && this.projectedToPoint(data, noRoam, out);
	        }
	      };
	
	      Geo.prototype.pointToData = function (point) {
	        var projection = this.projection;
	
	        if (projection) {
	          // projection may return null point.
	          point = projection.unproject(point);
	        }
	
	        return point && this.pointToProjected(point);
	      };
	      /**
	       * Point to projected data. Same with pointToData when projection is used.
	       */
	
	
	      Geo.prototype.pointToProjected = function (point) {
	        return _super.prototype.pointToData.call(this, point);
	      };
	
	      Geo.prototype.projectedToPoint = function (projected, noRoam, out) {
	        return _super.prototype.dataToPoint.call(this, projected, noRoam, out);
	      };
	
	      Geo.prototype.convertToPixel = function (ecModel, finder, value) {
	        var coordSys = getCoordSys$1(finder);
	        return coordSys === this ? coordSys.dataToPoint(value) : null;
	      };
	
	      Geo.prototype.convertFromPixel = function (ecModel, finder, pixel) {
	        var coordSys = getCoordSys$1(finder);
	        return coordSys === this ? coordSys.pointToData(pixel) : null;
	      };
	
	      return Geo;
	    }(View);
	    mixin(Geo, View);
	
	    function getCoordSys$1(finder) {
	      var geoModel = finder.geoModel;
	      var seriesModel = finder.seriesModel;
	      return geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map series.
	      || (seriesModel.getReferringComponents('geo', SINGLE_REFERRING).models[0] || {}).coordinateSystem : null;
	    }
	
	    /**
	     * Resize method bound to the geo
	     */
	
	    function resizeGeo(geoModel, api) {
	      var boundingCoords = geoModel.get('boundingCoords');
	
	      if (boundingCoords != null) {
	        var leftTop_1 = boundingCoords[0];
	        var rightBottom_1 = boundingCoords[1];
	
	        if (!(isFinite(leftTop_1[0]) && isFinite(leftTop_1[1]) && isFinite(rightBottom_1[0]) && isFinite(rightBottom_1[1]))) {
	          if (true) {
	            console.error('Invalid boundingCoords');
	          }
	        } else {
	          // Sample around the lng/lat rect and use projection to calculate actual bounding rect.
	          var projection_1 = this.projection;
	
	          if (projection_1) {
	            var xMin = leftTop_1[0];
	            var yMin = leftTop_1[1];
	            var xMax = rightBottom_1[0];
	            var yMax = rightBottom_1[1];
	            leftTop_1 = [Infinity, Infinity];
	            rightBottom_1 = [-Infinity, -Infinity]; // TODO better way?
	
	            var sampleLine = function (x0, y0, x1, y1) {
	              var dx = x1 - x0;
	              var dy = y1 - y0;
	
	              for (var i = 0; i <= 100; i++) {
	                var p = i / 100;
	                var pt = projection_1.project([x0 + dx * p, y0 + dy * p]);
	                min(leftTop_1, leftTop_1, pt);
	                max(rightBottom_1, rightBottom_1, pt);
	              }
	            }; // Top
	
	
	            sampleLine(xMin, yMin, xMax, yMin); // Right
	
	            sampleLine(xMax, yMin, xMax, yMax); // Bottom
	
	            sampleLine(xMax, yMax, xMin, yMax); // Left
	
	            sampleLine(xMin, yMax, xMax, yMin);
	          }
	
	          this.setBoundingRect(leftTop_1[0], leftTop_1[1], rightBottom_1[0] - leftTop_1[0], rightBottom_1[1] - leftTop_1[1]);
	        }
	      }
	
	      var rect = this.getBoundingRect();
	      var centerOption = geoModel.get('layoutCenter');
	      var sizeOption = geoModel.get('layoutSize');
	      var viewWidth = api.getWidth();
	      var viewHeight = api.getHeight();
	      var aspect = rect.width / rect.height * this.aspectScale;
	      var useCenterAndSize = false;
	      var center;
	      var size;
	
	      if (centerOption && sizeOption) {
	        center = [parsePercent$1(centerOption[0], viewWidth), parsePercent$1(centerOption[1], viewHeight)];
	        size = parsePercent$1(sizeOption, Math.min(viewWidth, viewHeight));
	
	        if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
	          useCenterAndSize = true;
	        } else {
	          if (true) {
	            console.warn('Given layoutCenter or layoutSize data are invalid. Use left/top/width/height instead.');
	          }
	        }
	      }
	
	      var viewRect;
	
	      if (useCenterAndSize) {
	        viewRect = {};
	
	        if (aspect > 1) {
	          // Width is same with size
	          viewRect.width = size;
	          viewRect.height = size / aspect;
	        } else {
	          viewRect.height = size;
	          viewRect.width = size * aspect;
	        }
	
	        viewRect.y = center[1] - viewRect.height / 2;
	        viewRect.x = center[0] - viewRect.width / 2;
	      } else {
	        // Use left/top/width/height
	        var boxLayoutOption = geoModel.getBoxLayoutParams();
	        boxLayoutOption.aspect = aspect;
	        viewRect = getLayoutRect(boxLayoutOption, {
	          width: viewWidth,
	          height: viewHeight
	        });
	      }
	
	      this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
	      this.setCenter(geoModel.get('center'), api);
	      this.setZoom(geoModel.get('zoom'));
	    } // Back compat for ECharts2, where the coord map is set on map series:
	    // {type: 'map', geoCoord: {'cityA': [116.46,39.92], 'cityA': [119.12,24.61]}},
	
	
	    function setGeoCoords(geo, model) {
	      each(model.get('geoCoord'), function (geoCoord, name) {
	        geo.addGeoCoord(name, geoCoord);
	      });
	    }
	
	    var GeoCreator =
	    /** @class */
	    function () {
	      function GeoCreator() {
	        // For deciding which dimensions to use when creating list data
	        this.dimensions = geo2DDimensions;
	      }
	
	      GeoCreator.prototype.create = function (ecModel, api) {
	        var geoList = [];
	
	        function getCommonGeoProperties(model) {
	          return {
	            nameProperty: model.get('nameProperty'),
	            aspectScale: model.get('aspectScale'),
	            projection: model.get('projection')
	          };
	        } // FIXME Create each time may be slow
	
	
	        ecModel.eachComponent('geo', function (geoModel, idx) {
	          var mapName = geoModel.get('map');
	          var geo = new Geo(mapName + idx, mapName, extend({
	            nameMap: geoModel.get('nameMap')
	          }, getCommonGeoProperties(geoModel)));
	          geo.zoomLimit = geoModel.get('scaleLimit');
	          geoList.push(geo); // setGeoCoords(geo, geoModel);
	
	          geoModel.coordinateSystem = geo;
	          geo.model = geoModel; // Inject resize method
	
	          geo.resize = resizeGeo;
	          geo.resize(geoModel, api);
	        });
	        ecModel.eachSeries(function (seriesModel) {
	          var coordSys = seriesModel.get('coordinateSystem');
	
	          if (coordSys === 'geo') {
	            var geoIndex = seriesModel.get('geoIndex') || 0;
	            seriesModel.coordinateSystem = geoList[geoIndex];
	          }
	        }); // If has map series
	
	        var mapModelGroupBySeries = {};
	        ecModel.eachSeriesByType('map', function (seriesModel) {
	          if (!seriesModel.getHostGeoModel()) {
	            var mapType = seriesModel.getMapType();
	            mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
	            mapModelGroupBySeries[mapType].push(seriesModel);
	          }
	        });
	        each(mapModelGroupBySeries, function (mapSeries, mapType) {
	          var nameMapList = map(mapSeries, function (singleMapSeries) {
	            return singleMapSeries.get('nameMap');
	          });
	          var geo = new Geo(mapType, mapType, extend({
	            nameMap: mergeAll(nameMapList)
	          }, getCommonGeoProperties(mapSeries[0])));
	          geo.zoomLimit = retrieve.apply(null, map(mapSeries, function (singleMapSeries) {
	            return singleMapSeries.get('scaleLimit');
	          }));
	          geoList.push(geo); // Inject resize method
	
	          geo.resize = resizeGeo;
	          geo.resize(mapSeries[0], api);
	          each(mapSeries, function (singleMapSeries) {
	            singleMapSeries.coordinateSystem = geo;
	            setGeoCoords(geo, singleMapSeries);
	          });
	        });
	        return geoList;
	      };
	      /**
	       * Fill given regions array
	       */
	
	
	      GeoCreator.prototype.getFilledRegions = function (originRegionArr, mapName, nameMap, nameProperty) {
	        // Not use the original
	        var regionsArr = (originRegionArr || []).slice();
	        var dataNameMap = createHashMap();
	
	        for (var i = 0; i < regionsArr.length; i++) {
	          dataNameMap.set(regionsArr[i].name, regionsArr[i]);
	        }
	
	        var source = geoSourceManager.load(mapName, nameMap, nameProperty);
	        each(source.regions, function (region) {
	          var name = region.name;
	          !dataNameMap.get(name) && regionsArr.push({
	            name: name
	          });
	        });
	        return regionsArr;
	      };
	
	      return GeoCreator;
	    }();
	
	    var geoCreator = new GeoCreator();
	
	    var GeoModel =
	    /** @class */
	    function (_super) {
	      __extends(GeoModel, _super);
	
	      function GeoModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = GeoModel.type;
	        return _this;
	      }
	
	      GeoModel.prototype.init = function (option, parentModel, ecModel) {
	        var source = geoSourceManager.getGeoResource(option.map);
	
	        if (source && source.type === 'geoJSON') {
	          var itemStyle = option.itemStyle = option.itemStyle || {};
	
	          if (!('color' in itemStyle)) {
	            itemStyle.color = '#eee';
	          }
	        }
	
	        this.mergeDefaultAndTheme(option, ecModel); // Default label emphasis `show`
	
	        defaultEmphasis(option, 'label', ['show']);
	      };
	
	      GeoModel.prototype.optionUpdated = function () {
	        var _this = this;
	
	        var option = this.option;
	        option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap, option.nameProperty);
	        var selectedMap = {};
	        this._optionModelMap = reduce(option.regions || [], function (optionModelMap, regionOpt) {
	          var regionName = regionOpt.name;
	
	          if (regionName) {
	            optionModelMap.set(regionName, new Model(regionOpt, _this, _this.ecModel));
	
	            if (regionOpt.selected) {
	              selectedMap[regionName] = true;
	            }
	          }
	
	          return optionModelMap;
	        }, createHashMap());
	
	        if (!option.selectedMap) {
	          option.selectedMap = selectedMap;
	        }
	      };
	      /**
	       * Get model of region.
	       */
	
	
	      GeoModel.prototype.getRegionModel = function (name) {
	        return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
	      };
	      /**
	       * Format label
	       * @param name Region name
	       */
	
	
	      GeoModel.prototype.getFormattedLabel = function (name, status) {
	        var regionModel = this.getRegionModel(name);
	        var formatter = status === 'normal' ? regionModel.get(['label', 'formatter']) : regionModel.get(['emphasis', 'label', 'formatter']);
	        var params = {
	          name: name
	        };
	
	        if (isFunction(formatter)) {
	          params.status = status;
	          return formatter(params);
	        } else if (isString(formatter)) {
	          return formatter.replace('{a}', name != null ? name : '');
	        }
	      };
	
	      GeoModel.prototype.setZoom = function (zoom) {
	        this.option.zoom = zoom;
	      };
	
	      GeoModel.prototype.setCenter = function (center) {
	        this.option.center = center;
	      }; // PENGING If selectedMode is null ?
	
	
	      GeoModel.prototype.select = function (name) {
	        var option = this.option;
	        var selectedMode = option.selectedMode;
	
	        if (!selectedMode) {
	          return;
	        }
	
	        if (selectedMode !== 'multiple') {
	          option.selectedMap = null;
	        }
	
	        var selectedMap = option.selectedMap || (option.selectedMap = {});
	        selectedMap[name] = true;
	      };
	
	      GeoModel.prototype.unSelect = function (name) {
	        var selectedMap = this.option.selectedMap;
	
	        if (selectedMap) {
	          selectedMap[name] = false;
	        }
	      };
	
	      GeoModel.prototype.toggleSelected = function (name) {
	        this[this.isSelected(name) ? 'unSelect' : 'select'](name);
	      };
	
	      GeoModel.prototype.isSelected = function (name) {
	        var selectedMap = this.option.selectedMap;
	        return !!(selectedMap && selectedMap[name]);
	      };
	
	      GeoModel.type = 'geo';
	      GeoModel.layoutMode = 'box';
	      GeoModel.defaultOption = {
	        // zlevel: 0,
	        z: 0,
	        show: true,
	        left: 'center',
	        top: 'center',
	        // Default value:
	        // for geoSVG source: 1,
	        // for geoJSON source: 0.75.
	        aspectScale: null,
	        // /// Layout with center and size
	        // If you want to put map in a fixed size box with right aspect ratio
	        // This two properties may be more convenient
	        // layoutCenter: [50%, 50%]
	        // layoutSize: 100
	        silent: false,
	        // Map type
	        map: '',
	        // Define left-top, right-bottom coords to control view
	        // For example, [ [180, 90], [-180, -90] ]
	        boundingCoords: null,
	        // Default on center of map
	        center: null,
	        zoom: 1,
	        scaleLimit: null,
	        // selectedMode: false
	        label: {
	          show: false,
	          color: '#000'
	        },
	        itemStyle: {
	          borderWidth: 0.5,
	          borderColor: '#444' // Default color:
	          // + geoJSON: #eee
	          // + geoSVG: null (use SVG original `fill`)
	          // color: '#eee'
	
	        },
	        emphasis: {
	          label: {
	            show: true,
	            color: 'rgb(100,0,0)'
	          },
	          itemStyle: {
	            color: 'rgba(255,215,0,0.8)'
	          }
	        },
	        select: {
	          label: {
	            show: true,
	            color: 'rgb(100,0,0)'
	          },
	          itemStyle: {
	            color: 'rgba(255,215,0,0.8)'
	          }
	        },
	        regions: [] // tooltip: {
	        //     show: false
	        // }
	
	      };
	      return GeoModel;
	    }(ComponentModel);
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function getCenterCoord(view, point) {
	      // Use projected coord as center because it's linear.
	      return view.pointToProjected ? view.pointToProjected(point) : view.pointToData(point);
	    }
	
	    function updateCenterAndZoom(view, payload, zoomLimit, api) {
	      var previousZoom = view.getZoom();
	      var center = view.getCenter();
	      var zoom = payload.zoom;
	      var point = view.projectedToPoint ? view.projectedToPoint(center) : view.dataToPoint(center);
	
	      if (payload.dx != null && payload.dy != null) {
	        point[0] -= payload.dx;
	        point[1] -= payload.dy;
	        view.setCenter(getCenterCoord(view, point), api);
	      }
	
	      if (zoom != null) {
	        if (zoomLimit) {
	          var zoomMin = zoomLimit.min || 0;
	          var zoomMax = zoomLimit.max || Infinity;
	          zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
	        } // Zoom on given point(originX, originY)
	
	
	        view.scaleX *= zoom;
	        view.scaleY *= zoom;
	        var fixX = (payload.originX - view.x) * (zoom - 1);
	        var fixY = (payload.originY - view.y) * (zoom - 1);
	        view.x -= fixX;
	        view.y -= fixY;
	        view.updateTransform(); // Get the new center
	
	        view.setCenter(getCenterCoord(view, point), api);
	        view.setZoom(zoom * previousZoom);
	      }
	
	      return {
	        center: view.getCenter(),
	        zoom: view.getZoom()
	      };
	    }
	
	    var GeoView =
	    /** @class */
	    function (_super) {
	      __extends(GeoView, _super);
	
	      function GeoView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = GeoView.type;
	        _this.focusBlurEnabled = true;
	        return _this;
	      }
	
	      GeoView.prototype.init = function (ecModel, api) {
	        this._api = api;
	      };
	
	      GeoView.prototype.render = function (geoModel, ecModel, api, payload) {
	        this._model = geoModel;
	
	        if (!geoModel.get('show')) {
	          this._mapDraw && this._mapDraw.remove();
	          this._mapDraw = null;
	          return;
	        }
	
	        if (!this._mapDraw) {
	          this._mapDraw = new MapDraw(api);
	        }
	
	        var mapDraw = this._mapDraw;
	        mapDraw.draw(geoModel, ecModel, api, this, payload);
	        mapDraw.group.on('click', this._handleRegionClick, this);
	        mapDraw.group.silent = geoModel.get('silent');
	        this.group.add(mapDraw.group);
	        this.updateSelectStatus(geoModel, ecModel, api);
	      };
	
	      GeoView.prototype._handleRegionClick = function (e) {
	        var eventData;
	        findEventDispatcher(e.target, function (current) {
	          return (eventData = getECData(current).eventData) != null;
	        }, true);
	
	        if (eventData) {
	          this._api.dispatchAction({
	            type: 'geoToggleSelect',
	            geoId: this._model.id,
	            name: eventData.name
	          });
	        }
	      };
	
	      GeoView.prototype.updateSelectStatus = function (model, ecModel, api) {
	        var _this = this;
	
	        this._mapDraw.group.traverse(function (node) {
	          var eventData = getECData(node).eventData;
	
	          if (eventData) {
	            _this._model.isSelected(eventData.name) ? api.enterSelect(node) : api.leaveSelect(node); // No need to traverse children.
	
	            return true;
	          }
	        });
	      };
	
	      GeoView.prototype.findHighDownDispatchers = function (name) {
	        return this._mapDraw && this._mapDraw.findHighDownDispatchers(name, this._model);
	      };
	
	      GeoView.prototype.dispose = function () {
	        this._mapDraw && this._mapDraw.remove();
	      };
	
	      GeoView.type = 'geo';
	      return GeoView;
	    }(ComponentView);
	
	    function registerMap$1(mapName, geoJson, specialAreas) {
	      geoSourceManager.registerMap(mapName, geoJson, specialAreas);
	    }
	
	    function install$9(registers) {
	      registers.registerCoordinateSystem('geo', geoCreator);
	      registers.registerComponentModel(GeoModel);
	      registers.registerComponentView(GeoView);
	      registers.registerImpl('registerMap', registerMap$1);
	      registers.registerImpl('getMap', function (mapName) {
	        return geoSourceManager.getMapForUser(mapName);
	      });
	
	      function makeAction(method, actionInfo) {
	        actionInfo.update = 'geo:updateSelectStatus';
	        registers.registerAction(actionInfo, function (payload, ecModel) {
	          var selected = {};
	          var allSelected = [];
	          ecModel.eachComponent({
	            mainType: 'geo',
	            query: payload
	          }, function (geoModel) {
	            geoModel[method](payload.name);
	            var geo = geoModel.coordinateSystem;
	            each(geo.regions, function (region) {
	              selected[region.name] = geoModel.isSelected(region.name) || false;
	            }); // Notice: there might be duplicated name in different regions.
	
	            var names = [];
	            each(selected, function (v, name) {
	              selected[name] && names.push(name);
	            });
	            allSelected.push({
	              geoIndex: geoModel.componentIndex,
	              // Use singular, the same naming convention as the event `selectchanged`.
	              name: names
	            });
	          });
	          return {
	            selected: selected,
	            allSelected: allSelected,
	            name: payload.name
	          };
	        });
	      }
	
	      makeAction('toggleSelected', {
	        type: 'geoToggleSelect',
	        event: 'geoselectchanged'
	      });
	      makeAction('select', {
	        type: 'geoSelect',
	        event: 'geoselected'
	      });
	      makeAction('unSelect', {
	        type: 'geoUnSelect',
	        event: 'geounselected'
	      });
	      /**
	       * @payload
	       * @property {string} [componentType=series]
	       * @property {number} [dx]
	       * @property {number} [dy]
	       * @property {number} [zoom]
	       * @property {number} [originX]
	       * @property {number} [originY]
	       */
	
	      registers.registerAction({
	        type: 'geoRoam',
	        event: 'geoRoam',
	        update: 'updateTransform'
	      }, function (payload, ecModel, api) {
	        var componentType = payload.componentType || 'series';
	        ecModel.eachComponent({
	          mainType: componentType,
	          query: payload
	        }, function (componentModel) {
	          var geo = componentModel.coordinateSystem;
	
	          if (geo.type !== 'geo') {
	            return;
	          }
	
	          var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'), api);
	          componentModel.setCenter && componentModel.setCenter(res.center);
	          componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
	          // So the center and zoom must be in sync. Include the series not selected by legend
	
	          if (componentType === 'series') {
	            each(componentModel.seriesGroup, function (seriesModel) {
	              seriesModel.setCenter(res.center);
	              seriesModel.setZoom(res.zoom);
	            });
	          }
	        });
	      });
	    }
	
	    function install$a(registers) {
	      use(install$9);
	      registers.registerChartView(MapView);
	      registers.registerSeriesModel(MapSeries);
	      registers.registerLayout(mapSymbolLayout);
	      registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
	      createLegacyDataSelectAction('map', registers.registerAction);
	    }
	
	    /**
	     * Initialize all computational message for following algorithm.
	     */
	
	    function init$2(inRoot) {
	      var root = inRoot;
	      root.hierNode = {
	        defaultAncestor: null,
	        ancestor: root,
	        prelim: 0,
	        modifier: 0,
	        change: 0,
	        shift: 0,
	        i: 0,
	        thread: null
	      };
	      var nodes = [root];
	      var node;
	      var children;
	
	      while (node = nodes.pop()) {
	        // jshint ignore:line
	        children = node.children;
	
	        if (node.isExpand && children.length) {
	          var n = children.length;
	
	          for (var i = n - 1; i >= 0; i--) {
	            var child = children[i];
	            child.hierNode = {
	              defaultAncestor: null,
	              ancestor: child,
	              prelim: 0,
	              modifier: 0,
	              change: 0,
	              shift: 0,
	              i: i,
	              thread: null
	            };
	            nodes.push(child);
	          }
	        }
	      }
	    }
	    /**
	     * The implementation of this function was originally copied from "d3.js"
	     * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	     * with some modifications made for this program.
	     * See the license statement at the head of this file.
	     *
	     * Computes a preliminary x coordinate for node. Before that, this function is
	     * applied recursively to the children of node, as well as the function
	     * apportion(). After spacing out the children by calling executeShifts(), the
	     * node is placed to the midpoint of its outermost children.
	     */
	
	    function firstWalk(node, separation) {
	      var children = node.isExpand ? node.children : [];
	      var siblings = node.parentNode.children;
	      var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
	
	      if (children.length) {
	        executeShifts(node);
	        var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
	
	        if (subtreeW) {
	          node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	          node.hierNode.modifier = node.hierNode.prelim - midPoint;
	        } else {
	          node.hierNode.prelim = midPoint;
	        }
	      } else if (subtreeW) {
	        node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	      }
	
	      node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
	    }
	    /**
	     * The implementation of this function was originally copied from "d3.js"
	     * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	     * with some modifications made for this program.
	     * See the license statement at the head of this file.
	     *
	     * Computes all real x-coordinates by summing up the modifiers recursively.
	     */
	
	    function secondWalk(node) {
	      var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
	      node.setLayout({
	        x: nodeX
	      }, true);
	      node.hierNode.modifier += node.parentNode.hierNode.modifier;
	    }
	    function separation(cb) {
	      return arguments.length ? cb : defaultSeparation;
	    }
	    /**
	     * Transform the common coordinate to radial coordinate.
	     */
	
	    function radialCoordinate(rad, r) {
	      rad -= Math.PI / 2;
	      return {
	        x: r * Math.cos(rad),
	        y: r * Math.sin(rad)
	      };
	    }
	    /**
	     * Get the layout position of the whole view.
	     */
	
	    function getViewRect$1(seriesModel, api) {
	      return getLayoutRect(seriesModel.getBoxLayoutParams(), {
	        width: api.getWidth(),
	        height: api.getHeight()
	      });
	    }
	    /**
	     * All other shifts, applied to the smaller subtrees between w- and w+, are
	     * performed by this function.
	     *
	     * The implementation of this function was originally copied from "d3.js"
	     * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	     * with some modifications made for this program.
	     * See the license statement at the head of this file.
	     */
	
	    function executeShifts(node) {
	      var children = node.children;
	      var n = children.length;
	      var shift = 0;
	      var change = 0;
	
	      while (--n >= 0) {
	        var child = children[n];
	        child.hierNode.prelim += shift;
	        child.hierNode.modifier += shift;
	        change += child.hierNode.change;
	        shift += child.hierNode.shift + change;
	      }
	    }
	    /**
	     * The implementation of this function was originally copied from "d3.js"
	     * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	     * with some modifications made for this program.
	     * See the license statement at the head of this file.
	     *
	     * The core of the algorithm. Here, a new subtree is combined with the
	     * previous subtrees. Threads are used to traverse the inside and outside
	     * contours of the left and right subtree up to the highest common level.
	     * Whenever two nodes of the inside contours conflict, we compute the left
	     * one of the greatest uncommon ancestors using the function nextAncestor()
	     * and call moveSubtree() to shift the subtree and prepare the shifts of
	     * smaller subtrees. Finally, we add a new thread (if necessary).
	     */
	
	
	    function apportion(subtreeV, subtreeW, ancestor, separation) {
	      if (subtreeW) {
	        var nodeOutRight = subtreeV;
	        var nodeInRight = subtreeV;
	        var nodeOutLeft = nodeInRight.parentNode.children[0];
	        var nodeInLeft = subtreeW;
	        var sumOutRight = nodeOutRight.hierNode.modifier;
	        var sumInRight = nodeInRight.hierNode.modifier;
	        var sumOutLeft = nodeOutLeft.hierNode.modifier;
	        var sumInLeft = nodeInLeft.hierNode.modifier;
	
	        while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
	          nodeOutRight = nextRight(nodeOutRight);
	          nodeOutLeft = nextLeft(nodeOutLeft);
	          nodeOutRight.hierNode.ancestor = subtreeV;
	          var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
	
	          if (shift > 0) {
	            moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
	            sumInRight += shift;
	            sumOutRight += shift;
	          }
	
	          sumInLeft += nodeInLeft.hierNode.modifier;
	          sumInRight += nodeInRight.hierNode.modifier;
	          sumOutRight += nodeOutRight.hierNode.modifier;
	          sumOutLeft += nodeOutLeft.hierNode.modifier;
	        }
	
	        if (nodeInLeft && !nextRight(nodeOutRight)) {
	          nodeOutRight.hierNode.thread = nodeInLeft;
	          nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
	        }
	
	        if (nodeInRight && !nextLeft(nodeOutLeft)) {
	          nodeOutLeft.hierNode.thread = nodeInRight;
	          nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
	          ancestor = subtreeV;
	        }
	      }
	
	      return ancestor;
	    }
	    /**
	     * This function is used to traverse the right contour of a subtree.
	     * It returns the rightmost child of node or the thread of node. The function
	     * returns null if and only if node is on the highest depth of its subtree.
	     */
	
	
	    function nextRight(node) {
	      var children = node.children;
	      return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
	    }
	    /**
	     * This function is used to traverse the left contour of a subtree (or a subforest).
	     * It returns the leftmost child of node or the thread of node. The function
	     * returns null if and only if node is on the highest depth of its subtree.
	     */
	
	
	    function nextLeft(node) {
	      var children = node.children;
	      return children.length && node.isExpand ? children[0] : node.hierNode.thread;
	    }
	    /**
	     * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
	     * Otherwise, returns the specified ancestor.
	     */
	
	
	    function nextAncestor(nodeInLeft, node, ancestor) {
	      return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
	    }
	    /**
	     * The implementation of this function was originally copied from "d3.js"
	     * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	     * with some modifications made for this program.
	     * See the license statement at the head of this file.
	     *
	     * Shifts the current subtree rooted at wr.
	     * This is done by increasing prelim(w+) and modifier(w+) by shift.
	     */
	
	
	    function moveSubtree(wl, wr, shift) {
	      var change = shift / (wr.hierNode.i - wl.hierNode.i);
	      wr.hierNode.change -= change;
	      wr.hierNode.shift += shift;
	      wr.hierNode.modifier += shift;
	      wr.hierNode.prelim += shift;
	      wl.hierNode.change += change;
	    }
	    /**
	     * The implementation of this function was originally copied from "d3.js"
	     * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	     * with some modifications made for this program.
	     * See the license statement at the head of this file.
	     */
	
	
	    function defaultSeparation(node1, node2) {
	      return node1.parentNode === node2.parentNode ? 1 : 2;
	    }
	
	    var TreeEdgeShape =
	    /** @class */
	    function () {
	      function TreeEdgeShape() {
	        this.parentPoint = [];
	        this.childPoints = [];
	      }
	
	      return TreeEdgeShape;
	    }();
	
	    var TreePath =
	    /** @class */
	    function (_super) {
	      __extends(TreePath, _super);
	
	      function TreePath(opts) {
	        return _super.call(this, opts) || this;
	      }
	
	      TreePath.prototype.getDefaultStyle = function () {
	        return {
	          stroke: '#000',
	          fill: null
	        };
	      };
	
	      TreePath.prototype.getDefaultShape = function () {
	        return new TreeEdgeShape();
	      };
	
	      TreePath.prototype.buildPath = function (ctx, shape) {
	        var childPoints = shape.childPoints;
	        var childLen = childPoints.length;
	        var parentPoint = shape.parentPoint;
	        var firstChildPos = childPoints[0];
	        var lastChildPos = childPoints[childLen - 1];
	
	        if (childLen === 1) {
	          ctx.moveTo(parentPoint[0], parentPoint[1]);
	          ctx.lineTo(firstChildPos[0], firstChildPos[1]);
	          return;
	        }
	
	        var orient = shape.orient;
	        var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
	        var otherDim = 1 - forkDim;
	        var forkPosition = parsePercent$1(shape.forkPosition, 1);
	        var tmpPoint = [];
	        tmpPoint[forkDim] = parentPoint[forkDim];
	        tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
	        ctx.moveTo(parentPoint[0], parentPoint[1]);
	        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	        ctx.moveTo(firstChildPos[0], firstChildPos[1]);
	        tmpPoint[forkDim] = firstChildPos[forkDim];
	        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	        tmpPoint[forkDim] = lastChildPos[forkDim];
	        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	        ctx.lineTo(lastChildPos[0], lastChildPos[1]);
	
	        for (var i = 1; i < childLen - 1; i++) {
	          var point = childPoints[i];
	          ctx.moveTo(point[0], point[1]);
	          tmpPoint[forkDim] = point[forkDim];
	          ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	        }
	      };
	
	      return TreePath;
	    }(Path);
	
	    var TreeView =
	    /** @class */
	    function (_super) {
	      __extends(TreeView, _super);
	
	      function TreeView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = TreeView.type;
	        _this._mainGroup = new Group();
	        return _this;
	      }
	
	      TreeView.prototype.init = function (ecModel, api) {
	        this._controller = new RoamController(api.getZr());
	        this._controllerHost = {
	          target: this.group
	        };
	        this.group.add(this._mainGroup);
	      };
	
	      TreeView.prototype.render = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	        var layoutInfo = seriesModel.layoutInfo;
	        var group = this._mainGroup;
	        var layout = seriesModel.get('layout');
	
	        if (layout === 'radial') {
	          group.x = layoutInfo.x + layoutInfo.width / 2;
	          group.y = layoutInfo.y + layoutInfo.height / 2;
	        } else {
	          group.x = layoutInfo.x;
	          group.y = layoutInfo.y;
	        }
	
	        this._updateViewCoordSys(seriesModel, api);
	
	        this._updateController(seriesModel, ecModel, api);
	
	        var oldData = this._data;
	        data.diff(oldData).add(function (newIdx) {
	          if (symbolNeedsDraw$1(data, newIdx)) {
	            // Create node and edge
	            updateNode(data, newIdx, null, group, seriesModel);
	          }
	        }).update(function (newIdx, oldIdx) {
	          var symbolEl = oldData.getItemGraphicEl(oldIdx);
	
	          if (!symbolNeedsDraw$1(data, newIdx)) {
	            symbolEl && removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
	            return;
	          } // Update node and edge
	
	
	          updateNode(data, newIdx, symbolEl, group, seriesModel);
	        }).remove(function (oldIdx) {
	          var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
	          // node haven't been initialized with a symbol element,
	          // you can't found it's symbol element through index.
	          // so if we want to remove the symbol element we should insure
	          // that the symbol element is not null.
	
	          if (symbolEl) {
	            removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
	          }
	        }).execute();
	        this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
	
	        this._updateNodeAndLinkScale(seriesModel);
	
	        if (seriesModel.get('expandAndCollapse') === true) {
	          data.eachItemGraphicEl(function (el, dataIndex) {
	            el.off('click').on('click', function () {
	              api.dispatchAction({
	                type: 'treeExpandAndCollapse',
	                seriesId: seriesModel.id,
	                dataIndex: dataIndex
	              });
	            });
	          });
	        }
	
	        this._data = data;
	      };
	
	      TreeView.prototype._updateViewCoordSys = function (seriesModel, api) {
	        var data = seriesModel.getData();
	        var points = [];
	        data.each(function (idx) {
	          var layout = data.getItemLayout(idx);
	
	          if (layout && !isNaN(layout.x) && !isNaN(layout.y)) {
	            points.push([+layout.x, +layout.y]);
	          }
	        });
	        var min = [];
	        var max = [];
	        fromPoints(points, min, max); // If don't Store min max when collapse the root node after roam,
	        // the root node will disappear.
	
	        var oldMin = this._min;
	        var oldMax = this._max; // If width or height is 0
	
	        if (max[0] - min[0] === 0) {
	          min[0] = oldMin ? oldMin[0] : min[0] - 1;
	          max[0] = oldMax ? oldMax[0] : max[0] + 1;
	        }
	
	        if (max[1] - min[1] === 0) {
	          min[1] = oldMin ? oldMin[1] : min[1] - 1;
	          max[1] = oldMax ? oldMax[1] : max[1] + 1;
	        }
	
	        var viewCoordSys = seriesModel.coordinateSystem = new View();
	        viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	        viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	        viewCoordSys.setCenter(seriesModel.get('center'), api);
	        viewCoordSys.setZoom(seriesModel.get('zoom')); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
	
	        this.group.attr({
	          x: viewCoordSys.x,
	          y: viewCoordSys.y,
	          scaleX: viewCoordSys.scaleX,
	          scaleY: viewCoordSys.scaleY
	        });
	        this._min = min;
	        this._max = max;
	      };
	
	      TreeView.prototype._updateController = function (seriesModel, ecModel, api) {
	        var _this = this;
	
	        var controller = this._controller;
	        var controllerHost = this._controllerHost;
	        var group = this.group;
	        controller.setPointerChecker(function (e, x, y) {
	          var rect = group.getBoundingRect();
	          rect.applyTransform(group.transform);
	          return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	        });
	        controller.enable(seriesModel.get('roam'));
	        controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	        controller.off('pan').off('zoom').on('pan', function (e) {
	          updateViewOnPan(controllerHost, e.dx, e.dy);
	          api.dispatchAction({
	            seriesId: seriesModel.id,
	            type: 'treeRoam',
	            dx: e.dx,
	            dy: e.dy
	          });
	        }).on('zoom', function (e) {
	          updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	          api.dispatchAction({
	            seriesId: seriesModel.id,
	            type: 'treeRoam',
	            zoom: e.scale,
	            originX: e.originX,
	            originY: e.originY
	          });
	
	          _this._updateNodeAndLinkScale(seriesModel); // Only update label layout on zoom
	
	
	          api.updateLabelLayout();
	        });
	      };
	
	      TreeView.prototype._updateNodeAndLinkScale = function (seriesModel) {
	        var data = seriesModel.getData();
	
	        var nodeScale = this._getNodeGlobalScale(seriesModel);
	
	        data.eachItemGraphicEl(function (el, idx) {
	          el.setSymbolScale(nodeScale);
	        });
	      };
	
	      TreeView.prototype._getNodeGlobalScale = function (seriesModel) {
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (coordSys.type !== 'view') {
	          return 1;
	        }
	
	        var nodeScaleRatio = this._nodeScaleRatio;
	        var groupZoom = coordSys.scaleX || 1; // Scale node when zoom changes
	
	        var roamZoom = coordSys.getZoom();
	        var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	        return nodeScale / groupZoom;
	      };
	
	      TreeView.prototype.dispose = function () {
	        this._controller && this._controller.dispose();
	        this._controllerHost = null;
	      };
	
	      TreeView.prototype.remove = function () {
	        this._mainGroup.removeAll();
	
	        this._data = null;
	      };
	
	      TreeView.type = 'tree';
	      return TreeView;
	    }(ChartView);
	
	    function symbolNeedsDraw$1(data, dataIndex) {
	      var layout = data.getItemLayout(dataIndex);
	      return layout && !isNaN(layout.x) && !isNaN(layout.y);
	    }
	
	    function updateNode(data, dataIndex, symbolEl, group, seriesModel) {
	      var isInit = !symbolEl;
	      var node = data.tree.getNodeByDataIndex(dataIndex);
	      var itemModel = node.getModel();
	      var visualColor = node.getVisual('style').fill;
	      var symbolInnerColor = node.isExpand === false && node.children.length !== 0 ? visualColor : '#fff';
	      var virtualRoot = data.tree.root;
	      var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	      var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	      var sourceLayout = source.getLayout();
	      var sourceOldLayout = sourceSymbolEl ? {
	        x: sourceSymbolEl.__oldX,
	        y: sourceSymbolEl.__oldY,
	        rawX: sourceSymbolEl.__radialOldRawX,
	        rawY: sourceSymbolEl.__radialOldRawY
	      } : sourceLayout;
	      var targetLayout = node.getLayout();
	
	      if (isInit) {
	        symbolEl = new Symbol(data, dataIndex, null, {
	          symbolInnerColor: symbolInnerColor,
	          useNameLabel: true
	        });
	        symbolEl.x = sourceOldLayout.x;
	        symbolEl.y = sourceOldLayout.y;
	      } else {
	        symbolEl.updateData(data, dataIndex, null, {
	          symbolInnerColor: symbolInnerColor,
	          useNameLabel: true
	        });
	      }
	
	      symbolEl.__radialOldRawX = symbolEl.__radialRawX;
	      symbolEl.__radialOldRawY = symbolEl.__radialRawY;
	      symbolEl.__radialRawX = targetLayout.rawX;
	      symbolEl.__radialRawY = targetLayout.rawY;
	      group.add(symbolEl);
	      data.setItemGraphicEl(dataIndex, symbolEl);
	      symbolEl.__oldX = symbolEl.x;
	      symbolEl.__oldY = symbolEl.y;
	      updateProps(symbolEl, {
	        x: targetLayout.x,
	        y: targetLayout.y
	      }, seriesModel);
	      var symbolPath = symbolEl.getSymbolPath();
	
	      if (seriesModel.get('layout') === 'radial') {
	        var realRoot = virtualRoot.children[0];
	        var rootLayout = realRoot.getLayout();
	        var length_1 = realRoot.children.length;
	        var rad = void 0;
	        var isLeft = void 0;
	
	        if (targetLayout.x === rootLayout.x && node.isExpand === true && realRoot.children.length) {
	          var center = {
	            x: (realRoot.children[0].getLayout().x + realRoot.children[length_1 - 1].getLayout().x) / 2,
	            y: (realRoot.children[0].getLayout().y + realRoot.children[length_1 - 1].getLayout().y) / 2
	          };
	          rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
	
	          if (rad < 0) {
	            rad = Math.PI * 2 + rad;
	          }
	
	          isLeft = center.x < rootLayout.x;
	
	          if (isLeft) {
	            rad = rad - Math.PI;
	          }
	        } else {
	          rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
	
	          if (rad < 0) {
	            rad = Math.PI * 2 + rad;
	          }
	
	          if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
	            isLeft = targetLayout.x < rootLayout.x;
	
	            if (isLeft) {
	              rad = rad - Math.PI;
	            }
	          } else {
	            isLeft = targetLayout.x > rootLayout.x;
	
	            if (!isLeft) {
	              rad = rad - Math.PI;
	            }
	          }
	        }
	
	        var textPosition = isLeft ? 'left' : 'right';
	        var normalLabelModel = itemModel.getModel('label');
	        var rotate = normalLabelModel.get('rotate');
	        var labelRotateRadian = rotate * (Math.PI / 180);
	        var textContent = symbolPath.getTextContent();
	
	        if (textContent) {
	          symbolPath.setTextConfig({
	            position: normalLabelModel.get('position') || textPosition,
	            rotation: rotate == null ? -rad : labelRotateRadian,
	            origin: 'center'
	          });
	          textContent.setStyle('verticalAlign', 'middle');
	        }
	      } // Handle status
	
	
	      var focus = itemModel.get(['emphasis', 'focus']);
	      var focusDataIndices = focus === 'relative' ? concatArray(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : null;
	
	      if (focusDataIndices) {
	        // Modify the focus to data indices.
	        getECData(symbolEl).focus = focusDataIndices;
	      }
	
	      drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group);
	
	      if (symbolEl.__edge) {
	        symbolEl.onHoverStateChange = function (toState) {
	          if (toState !== 'blur') {
	            // NOTE: Ensure the parent elements will been blurred firstly.
	            // According to the return of getAncestorsIndices and getDescendantIndices
	            // TODO: A bit tricky.
	            var parentEl = node.parentNode && data.getItemGraphicEl(node.parentNode.dataIndex);
	
	            if (!(parentEl && parentEl.hoverState === HOVER_STATE_BLUR)) {
	              setStatesFlag(symbolEl.__edge, toState);
	            }
	          }
	        };
	      }
	    }
	
	    function drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group) {
	      var itemModel = node.getModel();
	      var edgeShape = seriesModel.get('edgeShape');
	      var layout = seriesModel.get('layout');
	      var orient = seriesModel.getOrient();
	      var curvature = seriesModel.get(['lineStyle', 'curveness']);
	      var edgeForkPosition = seriesModel.get('edgeForkPosition');
	      var lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	      var edge = symbolEl.__edge; // curve edge from node -> parent
	      // polyline edge from node -> children
	
	      if (edgeShape === 'curve') {
	        if (node.parentNode && node.parentNode !== virtualRoot) {
	          if (!edge) {
	            edge = symbolEl.__edge = new BezierCurve({
	              shape: getEdgeShape(layout, orient, curvature, sourceOldLayout, sourceOldLayout)
	            });
	          }
	
	          updateProps(edge, {
	            shape: getEdgeShape(layout, orient, curvature, sourceLayout, targetLayout)
	          }, seriesModel);
	        }
	      } else if (edgeShape === 'polyline') {
	        if (layout === 'orthogonal') {
	          if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
	            var children = node.children;
	            var childPoints = [];
	
	            for (var i = 0; i < children.length; i++) {
	              var childLayout = children[i].getLayout();
	              childPoints.push([childLayout.x, childLayout.y]);
	            }
	
	            if (!edge) {
	              edge = symbolEl.__edge = new TreePath({
	                shape: {
	                  parentPoint: [targetLayout.x, targetLayout.y],
	                  childPoints: [[targetLayout.x, targetLayout.y]],
	                  orient: orient,
	                  forkPosition: edgeForkPosition
	                }
	              });
	            }
	
	            updateProps(edge, {
	              shape: {
	                parentPoint: [targetLayout.x, targetLayout.y],
	                childPoints: childPoints
	              }
	            }, seriesModel);
	          }
	        } else {
	          if (true) {
	            throw new Error('The polyline edgeShape can only be used in orthogonal layout');
	          }
	        }
	      } // show all edge when edgeShape is 'curve', filter node `isExpand` is false when edgeShape is 'polyline'
	
	
	      if (edge && !(edgeShape === 'polyline' && !node.isExpand)) {
	        edge.useStyle(defaults({
	          strokeNoScale: true,
	          fill: null
	        }, lineStyle));
	        setStatesStylesFromModel(edge, itemModel, 'lineStyle');
	        setDefaultStateProxy(edge);
	        group.add(edge);
	      }
	    }
	
	    function removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt) {
	      var virtualRoot = data.tree.root;
	
	      var _a = getSourceNode(virtualRoot, node),
	          source = _a.source,
	          sourceLayout = _a.sourceLayout;
	
	      var symbolEl = data.getItemGraphicEl(node.dataIndex);
	
	      if (!symbolEl) {
	        return;
	      }
	
	      var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	      var sourceEdge = sourceSymbolEl.__edge; // 1. when expand the sub tree, delete the children node should delete the edge of
	      // the source at the same time. because the polyline edge shape is only owned by the source.
	      // 2.when the node is the only children of the source, delete the node should delete the edge of
	      // the source at the same time. the same reason as above.
	
	      var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
	      var edgeShape = seriesModel.get('edgeShape');
	      var layoutOpt = seriesModel.get('layout');
	      var orient = seriesModel.get('orient');
	      var curvature = seriesModel.get(['lineStyle', 'curveness']);
	
	      if (edge) {
	        if (edgeShape === 'curve') {
	          removeElement(edge, {
	            shape: getEdgeShape(layoutOpt, orient, curvature, sourceLayout, sourceLayout),
	            style: {
	              opacity: 0
	            }
	          }, seriesModel, {
	            cb: function () {
	              group.remove(edge);
	            },
	            removeOpt: removeAnimationOpt
	          });
	        } else if (edgeShape === 'polyline' && seriesModel.get('layout') === 'orthogonal') {
	          removeElement(edge, {
	            shape: {
	              parentPoint: [sourceLayout.x, sourceLayout.y],
	              childPoints: [[sourceLayout.x, sourceLayout.y]]
	            },
	            style: {
	              opacity: 0
	            }
	          }, seriesModel, {
	            cb: function () {
	              group.remove(edge);
	            },
	            removeOpt: removeAnimationOpt
	          });
	        }
	      }
	    }
	
	    function getSourceNode(virtualRoot, node) {
	      var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	      var sourceLayout;
	
	      while (sourceLayout = source.getLayout(), sourceLayout == null) {
	        source = source.parentNode === virtualRoot ? source : source.parentNode || source;
	      }
	
	      return {
	        source: source,
	        sourceLayout: sourceLayout
	      };
	    }
	
	    function removeNode(data, dataIndex, symbolEl, group, seriesModel) {
	      var node = data.tree.getNodeByDataIndex(dataIndex);
	      var virtualRoot = data.tree.root;
	      var sourceLayout = getSourceNode(virtualRoot, node).sourceLayout; // Use same duration and easing with update to have more consistent animation.
	
	      var removeAnimationOpt = {
	        duration: seriesModel.get('animationDurationUpdate'),
	        easing: seriesModel.get('animationEasingUpdate')
	      };
	      removeElement(symbolEl, {
	        x: sourceLayout.x + 1,
	        y: sourceLayout.y + 1
	      }, seriesModel, {
	        cb: function () {
	          group.remove(symbolEl);
	          data.setItemGraphicEl(dataIndex, null);
	        },
	        removeOpt: removeAnimationOpt
	      });
	      symbolEl.fadeOut(null, data.hostModel, {
	        fadeLabel: true,
	        animation: removeAnimationOpt
	      }); // remove edge as parent node
	
	      node.children.forEach(function (childNode) {
	        removeNodeEdge(childNode, data, group, seriesModel, removeAnimationOpt);
	      }); // remove edge as child node
	
	      removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt);
	    }
	
	    function getEdgeShape(layoutOpt, orient, curvature, sourceLayout, targetLayout) {
	      var cpx1;
	      var cpy1;
	      var cpx2;
	      var cpy2;
	      var x1;
	      var x2;
	      var y1;
	      var y2;
	
	      if (layoutOpt === 'radial') {
	        x1 = sourceLayout.rawX;
	        y1 = sourceLayout.rawY;
	        x2 = targetLayout.rawX;
	        y2 = targetLayout.rawY;
	        var radialCoor1 = radialCoordinate(x1, y1);
	        var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * curvature);
	        var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * curvature);
	        var radialCoor4 = radialCoordinate(x2, y2);
	        return {
	          x1: radialCoor1.x || 0,
	          y1: radialCoor1.y || 0,
	          x2: radialCoor4.x || 0,
	          y2: radialCoor4.y || 0,
	          cpx1: radialCoor2.x || 0,
	          cpy1: radialCoor2.y || 0,
	          cpx2: radialCoor3.x || 0,
	          cpy2: radialCoor3.y || 0
	        };
	      } else {
	        x1 = sourceLayout.x;
	        y1 = sourceLayout.y;
	        x2 = targetLayout.x;
	        y2 = targetLayout.y;
	
	        if (orient === 'LR' || orient === 'RL') {
	          cpx1 = x1 + (x2 - x1) * curvature;
	          cpy1 = y1;
	          cpx2 = x2 + (x1 - x2) * curvature;
	          cpy2 = y2;
	        }
	
	        if (orient === 'TB' || orient === 'BT') {
	          cpx1 = x1;
	          cpy1 = y1 + (y2 - y1) * curvature;
	          cpx2 = x2;
	          cpy2 = y2 + (y1 - y2) * curvature;
	        }
	      }
	
	      return {
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        cpx1: cpx1,
	        cpy1: cpy1,
	        cpx2: cpx2,
	        cpy2: cpy2
	      };
	    }
	
	    var inner$7 = makeInner();
	
	    function linkSeriesData(opt) {
	      var mainData = opt.mainData;
	      var datas = opt.datas;
	
	      if (!datas) {
	        datas = {
	          main: mainData
	        };
	        opt.datasAttr = {
	          main: 'data'
	        };
	      }
	
	      opt.datas = opt.mainData = null;
	      linkAll(mainData, datas, opt); // Porxy data original methods.
	
	      each(datas, function (data) {
	        each(mainData.TRANSFERABLE_METHODS, function (methodName) {
	          data.wrapMethod(methodName, curry(transferInjection, opt));
	        });
	      }); // Beyond transfer, additional features should be added to `cloneShallow`.
	
	      mainData.wrapMethod('cloneShallow', curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
	      // another changable methods, which may bring about dead lock.
	
	      each(mainData.CHANGABLE_METHODS, function (methodName) {
	        mainData.wrapMethod(methodName, curry(changeInjection, opt));
	      }); // Make sure datas contains mainData.
	
	      assert(datas[mainData.dataType] === mainData);
	    }
	
	    function transferInjection(opt, res) {
	      if (isMainData(this)) {
	        // Transfer datas to new main data.
	        var datas = extend({}, inner$7(this).datas);
	        datas[this.dataType] = res;
	        linkAll(res, datas, opt);
	      } else {
	        // Modify the reference in main data to point newData.
	        linkSingle(res, this.dataType, inner$7(this).mainData, opt);
	      }
	
	      return res;
	    }
	
	    function changeInjection(opt, res) {
	      opt.struct && opt.struct.update();
	      return res;
	    }
	
	    function cloneShallowInjection(opt, res) {
	      // cloneShallow, which brings about some fragilities, may be inappropriate
	      // to be exposed as an API. So for implementation simplicity we can make
	      // the restriction that cloneShallow of not-mainData should not be invoked
	      // outside, but only be invoked here.
	      each(inner$7(res).datas, function (data, dataType) {
	        data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
	      });
	      return res;
	    }
	    /**
	     * Supplement method to List.
	     *
	     * @public
	     * @param [dataType] If not specified, return mainData.
	     */
	
	
	    function getLinkedData(dataType) {
	      var mainData = inner$7(this).mainData;
	      return dataType == null || mainData == null ? mainData : inner$7(mainData).datas[dataType];
	    }
	    /**
	     * Get list of all linked data
	     */
	
	
	    function getLinkedDataAll() {
	      var mainData = inner$7(this).mainData;
	      return mainData == null ? [{
	        data: mainData
	      }] : map(keys(inner$7(mainData).datas), function (type) {
	        return {
	          type: type,
	          data: inner$7(mainData).datas[type]
	        };
	      });
	    }
	
	    function isMainData(data) {
	      return inner$7(data).mainData === data;
	    }
	
	    function linkAll(mainData, datas, opt) {
	      inner$7(mainData).datas = {};
	      each(datas, function (data, dataType) {
	        linkSingle(data, dataType, mainData, opt);
	      });
	    }
	
	    function linkSingle(data, dataType, mainData, opt) {
	      inner$7(mainData).datas[dataType] = data;
	      inner$7(data).mainData = mainData;
	      data.dataType = dataType;
	
	      if (opt.struct) {
	        data[opt.structAttr] = opt.struct;
	        opt.struct[opt.datasAttr[dataType]] = data;
	      } // Supplement method.
	
	
	      data.getLinkedData = getLinkedData;
	      data.getLinkedDataAll = getLinkedDataAll;
	    }
	
	    var TreeNode =
	    /** @class */
	    function () {
	      function TreeNode(name, hostTree) {
	        this.depth = 0;
	        this.height = 0;
	        /**
	         * Reference to list item.
	         * Do not persistent dataIndex outside,
	         * besause it may be changed by list.
	         * If dataIndex -1,
	         * this node is logical deleted (filtered) in list.
	         */
	
	        this.dataIndex = -1;
	        this.children = [];
	        this.viewChildren = [];
	        this.isExpand = false;
	        this.name = name || '';
	        this.hostTree = hostTree;
	      }
	      /**
	       * The node is removed.
	       */
	
	
	      TreeNode.prototype.isRemoved = function () {
	        return this.dataIndex < 0;
	      };
	
	      TreeNode.prototype.eachNode = function (options, cb, context) {
	        if (isFunction(options)) {
	          context = cb;
	          cb = options;
	          options = null;
	        }
	
	        options = options || {};
	
	        if (isString(options)) {
	          options = {
	            order: options
	          };
	        }
	
	        var order = options.order || 'preorder';
	        var children = this[options.attr || 'children'];
	        var suppressVisitSub;
	        order === 'preorder' && (suppressVisitSub = cb.call(context, this));
	
	        for (var i = 0; !suppressVisitSub && i < children.length; i++) {
	          children[i].eachNode(options, cb, context);
	        }
	
	        order === 'postorder' && cb.call(context, this);
	      };
	      /**
	       * Update depth and height of this subtree.
	       */
	
	
	      TreeNode.prototype.updateDepthAndHeight = function (depth) {
	        var height = 0;
	        this.depth = depth;
	
	        for (var i = 0; i < this.children.length; i++) {
	          var child = this.children[i];
	          child.updateDepthAndHeight(depth + 1);
	
	          if (child.height > height) {
	            height = child.height;
	          }
	        }
	
	        this.height = height + 1;
	      };
	
	      TreeNode.prototype.getNodeById = function (id) {
	        if (this.getId() === id) {
	          return this;
	        }
	
	        for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	          var res = children[i].getNodeById(id);
	
	          if (res) {
	            return res;
	          }
	        }
	      };
	
	      TreeNode.prototype.contains = function (node) {
	        if (node === this) {
	          return true;
	        }
	
	        for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	          var res = children[i].contains(node);
	
	          if (res) {
	            return res;
	          }
	        }
	      };
	      /**
	       * @param includeSelf Default false.
	       * @return order: [root, child, grandchild, ...]
	       */
	
	
	      TreeNode.prototype.getAncestors = function (includeSelf) {
	        var ancestors = [];
	        var node = includeSelf ? this : this.parentNode;
	
	        while (node) {
	          ancestors.push(node);
	          node = node.parentNode;
	        }
	
	        ancestors.reverse();
	        return ancestors;
	      };
	
	      TreeNode.prototype.getAncestorsIndices = function () {
	        var indices = [];
	        var currNode = this;
	
	        while (currNode) {
	          indices.push(currNode.dataIndex);
	          currNode = currNode.parentNode;
	        }
	
	        indices.reverse();
	        return indices;
	      };
	
	      TreeNode.prototype.getDescendantIndices = function () {
	        var indices = [];
	        this.eachNode(function (childNode) {
	          indices.push(childNode.dataIndex);
	        });
	        return indices;
	      };
	
	      TreeNode.prototype.getValue = function (dimension) {
	        var data = this.hostTree.data;
	        return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
	      };
	
	      TreeNode.prototype.setLayout = function (layout, merge) {
	        this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
	      };
	      /**
	       * @return {Object} layout
	       */
	
	
	      TreeNode.prototype.getLayout = function () {
	        return this.hostTree.data.getItemLayout(this.dataIndex);
	      }; // @depcrecated
	      // getModel<T = unknown, S extends keyof T = keyof T>(path: S): Model<T[S]>
	      // eslint-disable-next-line @typescript-eslint/no-unused-vars
	
	
	      TreeNode.prototype.getModel = function (path) {
	        if (this.dataIndex < 0) {
	          return;
	        }
	
	        var hostTree = this.hostTree;
	        var itemModel = hostTree.data.getItemModel(this.dataIndex);
	        return itemModel.getModel(path);
	      }; // TODO: TYPE More specific model
	
	
	      TreeNode.prototype.getLevelModel = function () {
	        return (this.hostTree.levelModels || [])[this.depth];
	      };
	
	      TreeNode.prototype.setVisual = function (key, value) {
	        this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
	      };
	      /**
	       * Get item visual
	       * FIXME: make return type better
	       */
	
	
	      TreeNode.prototype.getVisual = function (key) {
	        return this.hostTree.data.getItemVisual(this.dataIndex, key);
	      };
	
	      TreeNode.prototype.getRawIndex = function () {
	        return this.hostTree.data.getRawIndex(this.dataIndex);
	      };
	
	      TreeNode.prototype.getId = function () {
	        return this.hostTree.data.getId(this.dataIndex);
	      };
	      /**
	       * index in parent's children
	       */
	
	
	      TreeNode.prototype.getChildIndex = function () {
	        if (this.parentNode) {
	          var children = this.parentNode.children;
	
	          for (var i = 0; i < children.length; ++i) {
	            if (children[i] === this) {
	              return i;
	            }
	          }
	
	          return -1;
	        }
	
	        return -1;
	      };
	      /**
	       * if this is an ancestor of another node
	       *
	       * @param node another node
	       * @return if is ancestor
	       */
	
	
	      TreeNode.prototype.isAncestorOf = function (node) {
	        var parent = node.parentNode;
	
	        while (parent) {
	          if (parent === this) {
	            return true;
	          }
	
	          parent = parent.parentNode;
	        }
	
	        return false;
	      };
	      /**
	       * if this is an descendant of another node
	       *
	       * @param node another node
	       * @return if is descendant
	       */
	
	
	      TreeNode.prototype.isDescendantOf = function (node) {
	        return node !== this && node.isAncestorOf(this);
	      };
	
	      return TreeNode;
	    }();
	
	    var Tree =
	    /** @class */
	    function () {
	      function Tree(hostModel) {
	        this.type = 'tree';
	        this._nodes = [];
	        this.hostModel = hostModel;
	      }
	
	      Tree.prototype.eachNode = function (options, cb, context) {
	        this.root.eachNode(options, cb, context);
	      };
	
	      Tree.prototype.getNodeByDataIndex = function (dataIndex) {
	        var rawIndex = this.data.getRawIndex(dataIndex);
	        return this._nodes[rawIndex];
	      };
	
	      Tree.prototype.getNodeById = function (name) {
	        return this.root.getNodeById(name);
	      };
	      /**
	       * Update item available by list,
	       * when list has been performed options like 'filterSelf' or 'map'.
	       */
	
	
	      Tree.prototype.update = function () {
	        var data = this.data;
	        var nodes = this._nodes;
	
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          nodes[i].dataIndex = -1;
	        }
	
	        for (var i = 0, len = data.count(); i < len; i++) {
	          nodes[data.getRawIndex(i)].dataIndex = i;
	        }
	      };
	      /**
	       * Clear all layouts
	       */
	
	
	      Tree.prototype.clearLayouts = function () {
	        this.data.clearItemLayouts();
	      };
	      /**
	       * data node format:
	       * {
	       *     name: ...
	       *     value: ...
	       *     children: [
	       *         {
	       *             name: ...
	       *             value: ...
	       *             children: ...
	       *         },
	       *         ...
	       *     ]
	       * }
	       */
	
	
	      Tree.createTree = function (dataRoot, hostModel, beforeLink) {
	        var tree = new Tree(hostModel);
	        var listData = [];
	        var dimMax = 1;
	        buildHierarchy(dataRoot);
	
	        function buildHierarchy(dataNode, parentNode) {
	          var value = dataNode.value;
	          dimMax = Math.max(dimMax, isArray(value) ? value.length : 1);
	          listData.push(dataNode);
	          var node = new TreeNode(convertOptionIdName(dataNode.name, ''), tree);
	          parentNode ? addChild(node, parentNode) : tree.root = node;
	
	          tree._nodes.push(node);
	
	          var children = dataNode.children;
	
	          if (children) {
	            for (var i = 0; i < children.length; i++) {
	              buildHierarchy(children[i], node);
	            }
	          }
	        }
	
	        tree.root.updateDepthAndHeight(0);
	        var dimensions = prepareSeriesDataSchema(listData, {
	          coordDimensions: ['value'],
	          dimensionsCount: dimMax
	        }).dimensions;
	        var list = new SeriesData(dimensions, hostModel);
	        list.initData(listData);
	        beforeLink && beforeLink(list);
	        linkSeriesData({
	          mainData: list,
	          struct: tree,
	          structAttr: 'tree'
	        });
	        tree.update();
	        return tree;
	      };
	
	      return Tree;
	    }();
	    /**
	     * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
	     * so this function is not ready and not necessary to be public.
	     */
	
	
	    function addChild(child, node) {
	      var children = node.children;
	
	      if (child.parentNode === node) {
	        return;
	      }
	
	      children.push(child);
	      child.parentNode = node;
	    }
	
	    function retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
	      if (payload && indexOf(validPayloadTypes, payload.type) >= 0) {
	        var root = seriesModel.getData().tree.root;
	        var targetNode = payload.targetNode;
	
	        if (isString(targetNode)) {
	          targetNode = root.getNodeById(targetNode);
	        }
	
	        if (targetNode && root.contains(targetNode)) {
	          return {
	            node: targetNode
	          };
	        }
	
	        var targetNodeId = payload.targetNodeId;
	
	        if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
	          return {
	            node: targetNode
	          };
	        }
	      }
	    } // Not includes the given node at the last item.
	
	    function getPathToRoot(node) {
	      var path = [];
	
	      while (node) {
	        node = node.parentNode;
	        node && path.push(node);
	      }
	
	      return path.reverse();
	    }
	    function aboveViewRoot(viewRoot, node) {
	      var viewPath = getPathToRoot(viewRoot);
	      return indexOf(viewPath, node) >= 0;
	    } // From root to the input node (the input node will be included).
	
	    function wrapTreePathInfo(node, seriesModel) {
	      var treePathInfo = [];
	
	      while (node) {
	        var nodeDataIndex = node.dataIndex;
	        treePathInfo.push({
	          name: node.name,
	          dataIndex: nodeDataIndex,
	          value: seriesModel.getRawValue(nodeDataIndex)
	        });
	        node = node.parentNode;
	      }
	
	      treePathInfo.reverse();
	      return treePathInfo;
	    }
	
	    var TreeSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(TreeSeriesModel, _super);
	
	      function TreeSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.hasSymbolVisual = true; // Do it self.
	
	        _this.ignoreStyleOnData = true;
	        return _this;
	      }
	      /**
	       * Init a tree data structure from data in option series
	       */
	
	
	      TreeSeriesModel.prototype.getInitialData = function (option) {
	        // create a virtual root
	        var root = {
	          name: option.name,
	          children: option.data
	        };
	        var leaves = option.leaves || {};
	        var leavesModel = new Model(leaves, this, this.ecModel);
	        var tree = Tree.createTree(root, this, beforeLink);
	
	        function beforeLink(nodeData) {
	          nodeData.wrapMethod('getItemModel', function (model, idx) {
	            var node = tree.getNodeByDataIndex(idx);
	
	            if (!(node && node.children.length && node.isExpand)) {
	              model.parentModel = leavesModel;
	            }
	
	            return model;
	          });
	        }
	
	        var treeDepth = 0;
	        tree.eachNode('preorder', function (node) {
	          if (node.depth > treeDepth) {
	            treeDepth = node.depth;
	          }
	        });
	        var expandAndCollapse = option.expandAndCollapse;
	        var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
	        tree.root.eachNode('preorder', function (node) {
	          var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.
	
	          node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
	        });
	        return tree.data;
	      };
	      /**
	       * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
	       * @returns {string} orient
	       */
	
	
	      TreeSeriesModel.prototype.getOrient = function () {
	        var orient = this.get('orient');
	
	        if (orient === 'horizontal') {
	          orient = 'LR';
	        } else if (orient === 'vertical') {
	          orient = 'TB';
	        }
	
	        return orient;
	      };
	
	      TreeSeriesModel.prototype.setZoom = function (zoom) {
	        this.option.zoom = zoom;
	      };
	
	      TreeSeriesModel.prototype.setCenter = function (center) {
	        this.option.center = center;
	      };
	
	      TreeSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        var tree = this.getData().tree;
	        var realRoot = tree.root.children[0];
	        var node = tree.getNodeByDataIndex(dataIndex);
	        var value = node.getValue();
	        var name = node.name;
	
	        while (node && node !== realRoot) {
	          name = node.parentNode.name + '.' + name;
	          node = node.parentNode;
	        }
	
	        return createTooltipMarkup('nameValue', {
	          name: name,
	          value: value,
	          noValue: isNaN(value) || value == null
	        });
	      }; // Add tree path to tooltip param
	
	
	      TreeSeriesModel.prototype.getDataParams = function (dataIndex) {
	        var params = _super.prototype.getDataParams.apply(this, arguments);
	
	        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	        params.treeAncestors = wrapTreePathInfo(node, this);
	        params.collapsed = !node.isExpand;
	        return params;
	      };
	
	      TreeSeriesModel.type = 'series.tree'; // can support the position parameters 'left', 'top','right','bottom', 'width',
	      // 'height' in the setOption() with 'merge' mode normal.
	
	      TreeSeriesModel.layoutMode = 'box';
	      TreeSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        coordinateSystem: 'view',
	        // the position of the whole view
	        left: '12%',
	        top: '12%',
	        right: '12%',
	        bottom: '12%',
	        // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
	        layout: 'orthogonal',
	        // value can be 'polyline'
	        edgeShape: 'curve',
	        edgeForkPosition: '50%',
	        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
	        roam: false,
	        // Symbol size scale ratio in roam
	        nodeScaleRatio: 0.4,
	        // Default on center of graph
	        center: null,
	        zoom: 1,
	        orient: 'LR',
	        symbol: 'emptyCircle',
	        symbolSize: 7,
	        expandAndCollapse: true,
	        initialTreeDepth: 2,
	        lineStyle: {
	          color: '#ccc',
	          width: 1.5,
	          curveness: 0.5
	        },
	        itemStyle: {
	          color: 'lightsteelblue',
	          // borderColor: '#c23531',
	          borderWidth: 1.5
	        },
	        label: {
	          show: true
	        },
	        animationEasing: 'linear',
	        animationDuration: 700,
	        animationDurationUpdate: 500
	      };
	      return TreeSeriesModel;
	    }(SeriesModel);
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	    /**
	     * Traverse the tree from bottom to top and do something
	     */
	    function eachAfter(root, callback, separation) {
	      var nodes = [root];
	      var next = [];
	      var node;
	
	      while (node = nodes.pop()) {
	        // jshint ignore:line
	        next.push(node);
	
	        if (node.isExpand) {
	          var children = node.children;
	
	          if (children.length) {
	            for (var i = 0; i < children.length; i++) {
	              nodes.push(children[i]);
	            }
	          }
	        }
	      }
	
	      while (node = next.pop()) {
	        // jshint ignore:line
	        callback(node, separation);
	      }
	    }
	    /**
	     * Traverse the tree from top to bottom and do something
	     */
	
	
	    function eachBefore(root, callback) {
	      var nodes = [root];
	      var node;
	
	      while (node = nodes.pop()) {
	        // jshint ignore:line
	        callback(node);
	
	        if (node.isExpand) {
	          var children = node.children;
	
	          if (children.length) {
	            for (var i = children.length - 1; i >= 0; i--) {
	              nodes.push(children[i]);
	            }
	          }
	        }
	      }
	    }
	
	    function treeLayout(ecModel, api) {
	      ecModel.eachSeriesByType('tree', function (seriesModel) {
	        commonLayout(seriesModel, api);
	      });
	    }
	
	    function commonLayout(seriesModel, api) {
	      var layoutInfo = getViewRect$1(seriesModel, api);
	      seriesModel.layoutInfo = layoutInfo;
	      var layout = seriesModel.get('layout');
	      var width = 0;
	      var height = 0;
	      var separation$1 = null;
	
	      if (layout === 'radial') {
	        width = 2 * Math.PI;
	        height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
	        separation$1 = separation(function (node1, node2) {
	          return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
	        });
	      } else {
	        width = layoutInfo.width;
	        height = layoutInfo.height;
	        separation$1 = separation();
	      }
	
	      var virtualRoot = seriesModel.getData().tree.root;
	      var realRoot = virtualRoot.children[0];
	
	      if (realRoot) {
	        init$2(virtualRoot);
	        eachAfter(realRoot, firstWalk, separation$1);
	        virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
	        eachBefore(realRoot, secondWalk);
	        var left_1 = realRoot;
	        var right_1 = realRoot;
	        var bottom_1 = realRoot;
	        eachBefore(realRoot, function (node) {
	          var x = node.getLayout().x;
	
	          if (x < left_1.getLayout().x) {
	            left_1 = node;
	          }
	
	          if (x > right_1.getLayout().x) {
	            right_1 = node;
	          }
	
	          if (node.depth > bottom_1.depth) {
	            bottom_1 = node;
	          }
	        });
	        var delta = left_1 === right_1 ? 1 : separation$1(left_1, right_1) / 2;
	        var tx_1 = delta - left_1.getLayout().x;
	        var kx_1 = 0;
	        var ky_1 = 0;
	        var coorX_1 = 0;
	        var coorY_1 = 0;
	
	        if (layout === 'radial') {
	          kx_1 = width / (right_1.getLayout().x + delta + tx_1); // here we use (node.depth - 1), bucause the real root's depth is 1
	
	          ky_1 = height / (bottom_1.depth - 1 || 1);
	          eachBefore(realRoot, function (node) {
	            coorX_1 = (node.getLayout().x + tx_1) * kx_1;
	            coorY_1 = (node.depth - 1) * ky_1;
	            var finalCoor = radialCoordinate(coorX_1, coorY_1);
	            node.setLayout({
	              x: finalCoor.x,
	              y: finalCoor.y,
	              rawX: coorX_1,
	              rawY: coorY_1
	            }, true);
	          });
	        } else {
	          var orient_1 = seriesModel.getOrient();
	
	          if (orient_1 === 'RL' || orient_1 === 'LR') {
	            ky_1 = height / (right_1.getLayout().x + delta + tx_1);
	            kx_1 = width / (bottom_1.depth - 1 || 1);
	            eachBefore(realRoot, function (node) {
	              coorY_1 = (node.getLayout().x + tx_1) * ky_1;
	              coorX_1 = orient_1 === 'LR' ? (node.depth - 1) * kx_1 : width - (node.depth - 1) * kx_1;
	              node.setLayout({
	                x: coorX_1,
	                y: coorY_1
	              }, true);
	            });
	          } else if (orient_1 === 'TB' || orient_1 === 'BT') {
	            kx_1 = width / (right_1.getLayout().x + delta + tx_1);
	            ky_1 = height / (bottom_1.depth - 1 || 1);
	            eachBefore(realRoot, function (node) {
	              coorX_1 = (node.getLayout().x + tx_1) * kx_1;
	              coorY_1 = orient_1 === 'TB' ? (node.depth - 1) * ky_1 : height - (node.depth - 1) * ky_1;
	              node.setLayout({
	                x: coorX_1,
	                y: coorY_1
	              }, true);
	            });
	          }
	        }
	      }
	    }
	
	    function treeVisual(ecModel) {
	      ecModel.eachSeriesByType('tree', function (seriesModel) {
	        var data = seriesModel.getData();
	        var tree = data.tree;
	        tree.eachNode(function (node) {
	          var model = node.getModel(); // TODO Optimize
	
	          var style = model.getModel('itemStyle').getItemStyle();
	          var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
	          extend(existsStyle, style);
	        });
	      });
	    }
	
	    function installTreeAction(registers) {
	      registers.registerAction({
	        type: 'treeExpandAndCollapse',
	        event: 'treeExpandAndCollapse',
	        update: 'update'
	      }, function (payload, ecModel) {
	        ecModel.eachComponent({
	          mainType: 'series',
	          subType: 'tree',
	          query: payload
	        }, function (seriesModel) {
	          var dataIndex = payload.dataIndex;
	          var tree = seriesModel.getData().tree;
	          var node = tree.getNodeByDataIndex(dataIndex);
	          node.isExpand = !node.isExpand;
	        });
	      });
	      registers.registerAction({
	        type: 'treeRoam',
	        event: 'treeRoam',
	        // Here we set 'none' instead of 'update', because roam action
	        // just need to update the transform matrix without having to recalculate
	        // the layout. So don't need to go through the whole update process, such
	        // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
	        update: 'none'
	      }, function (payload, ecModel, api) {
	        ecModel.eachComponent({
	          mainType: 'series',
	          subType: 'tree',
	          query: payload
	        }, function (seriesModel) {
	          var coordSys = seriesModel.coordinateSystem;
	          var res = updateCenterAndZoom(coordSys, payload, undefined, api);
	          seriesModel.setCenter && seriesModel.setCenter(res.center);
	          seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	        });
	      });
	    }
	
	    function install$b(registers) {
	      registers.registerChartView(TreeView);
	      registers.registerSeriesModel(TreeSeriesModel);
	      registers.registerLayout(treeLayout);
	      registers.registerVisual(treeVisual);
	      installTreeAction(registers);
	    }
	
	    var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];
	    function installTreemapAction(registers) {
	      for (var i = 0; i < actionTypes.length; i++) {
	        registers.registerAction({
	          type: actionTypes[i],
	          update: 'updateView'
	        }, noop);
	      }
	
	      registers.registerAction({
	        type: 'treemapRootToNode',
	        update: 'updateView'
	      }, function (payload, ecModel) {
	        ecModel.eachComponent({
	          mainType: 'series',
	          subType: 'treemap',
	          query: payload
	        }, handleRootToNode);
	
	        function handleRootToNode(model, index) {
	          var types = ['treemapZoomToNode', 'treemapRootToNode'];
	          var targetInfo = retrieveTargetInfo(payload, types, model);
	
	          if (targetInfo) {
	            var originViewRoot = model.getViewRoot();
	
	            if (originViewRoot) {
	              payload.direction = aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	            }
	
	            model.resetViewRoot(targetInfo.node);
	          }
	        }
	      });
	    }
	
	    function enableAriaDecalForTree(seriesModel) {
	      var data = seriesModel.getData();
	      var tree = data.tree;
	      var decalPaletteScope = {};
	      tree.eachNode(function (node) {
	        // Use decal of level 1 node
	        var current = node;
	
	        while (current && current.depth > 1) {
	          current = current.parentNode;
	        }
	
	        var decal = getDecalFromPalette(seriesModel.ecModel, current.name || current.dataIndex + '', decalPaletteScope);
	        node.setVisual('decal', decal);
	      });
	    }
	
	    var TreemapSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(TreemapSeriesModel, _super);
	
	      function TreemapSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = TreemapSeriesModel.type;
	        _this.preventUsingHoverLayer = true;
	        return _this;
	      }
	      /**
	       * @override
	       */
	
	
	      TreemapSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        // Create a virtual root.
	        var root = {
	          name: option.name,
	          children: option.data
	        };
	        completeTreeValue(root);
	        var levels = option.levels || []; // Used in "visual priority" in `treemapVisual.js`.
	        // This way is a little tricky, must satisfy the precondition:
	        //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
	        //   2. The `Model.prototype.getModel()` will not use any clone-like way.
	
	        var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
	        var designatedVisualModel = new Model({
	          itemStyle: designatedVisualItemStyle
	        }, this, ecModel);
	        levels = option.levels = setDefault(levels, ecModel);
	        var levelModels = map(levels || [], function (levelDefine) {
	          return new Model(levelDefine, designatedVisualModel, ecModel);
	        }, this); // Make sure always a new tree is created when setOption,
	        // in TreemapView, we check whether oldTree === newTree
	        // to choose mappings approach among old shapes and new shapes.
	
	        var tree = Tree.createTree(root, this, beforeLink);
	
	        function beforeLink(nodeData) {
	          nodeData.wrapMethod('getItemModel', function (model, idx) {
	            var node = tree.getNodeByDataIndex(idx);
	            var levelModel = node ? levelModels[node.depth] : null; // If no levelModel, we also need `designatedVisualModel`.
	
	            model.parentModel = levelModel || designatedVisualModel;
	            return model;
	          });
	        }
	
	        return tree.data;
	      };
	
	      TreemapSeriesModel.prototype.optionUpdated = function () {
	        this.resetViewRoot();
	      };
	      /**
	       * @override
	       * @param {number} dataIndex
	       * @param {boolean} [mutipleSeries=false]
	       */
	
	
	      TreemapSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        var data = this.getData();
	        var value = this.getRawValue(dataIndex);
	        var name = data.getName(dataIndex);
	        return createTooltipMarkup('nameValue', {
	          name: name,
	          value: value
	        });
	      };
	      /**
	       * Add tree path to tooltip param
	       *
	       * @override
	       * @param {number} dataIndex
	       * @return {Object}
	       */
	
	
	      TreemapSeriesModel.prototype.getDataParams = function (dataIndex) {
	        var params = _super.prototype.getDataParams.apply(this, arguments);
	
	        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	        params.treeAncestors = wrapTreePathInfo(node, this); // compatitable the previous code.
	
	        params.treePathInfo = params.treeAncestors;
	        return params;
	      };
	      /**
	       * @public
	       * @param {Object} layoutInfo {
	       *                                x: containerGroup x
	       *                                y: containerGroup y
	       *                                width: containerGroup width
	       *                                height: containerGroup height
	       *                            }
	       */
	
	
	      TreemapSeriesModel.prototype.setLayoutInfo = function (layoutInfo) {
	        /**
	         * @readOnly
	         * @type {Object}
	         */
	        this.layoutInfo = this.layoutInfo || {};
	        extend(this.layoutInfo, layoutInfo);
	      };
	      /**
	       * @param  {string} id
	       * @return {number} index
	       */
	
	
	      TreemapSeriesModel.prototype.mapIdToIndex = function (id) {
	        // A feature is implemented:
	        // index is monotone increasing with the sequence of
	        // input id at the first time.
	        // This feature can make sure that each data item and its
	        // mapped color have the same index between data list and
	        // color list at the beginning, which is useful for user
	        // to adjust data-color mapping.
	
	        /**
	         * @private
	         * @type {Object}
	         */
	        var idIndexMap = this._idIndexMap;
	
	        if (!idIndexMap) {
	          idIndexMap = this._idIndexMap = createHashMap();
	          /**
	           * @private
	           * @type {number}
	           */
	
	          this._idIndexMapCount = 0;
	        }
	
	        var index = idIndexMap.get(id);
	
	        if (index == null) {
	          idIndexMap.set(id, index = this._idIndexMapCount++);
	        }
	
	        return index;
	      };
	
	      TreemapSeriesModel.prototype.getViewRoot = function () {
	        return this._viewRoot;
	      };
	
	      TreemapSeriesModel.prototype.resetViewRoot = function (viewRoot) {
	        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	        var root = this.getRawData().tree.root;
	
	        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	          this._viewRoot = root;
	        }
	      };
	
	      TreemapSeriesModel.prototype.enableAriaDecal = function () {
	        enableAriaDecalForTree(this);
	      };
	
	      TreemapSeriesModel.type = 'series.treemap';
	      TreemapSeriesModel.layoutMode = 'box';
	      TreemapSeriesModel.defaultOption = {
	        // Disable progressive rendering
	        progressive: 0,
	        // size: ['80%', '80%'],            // deprecated, compatible with ec2.
	        left: 'center',
	        top: 'middle',
	        width: '80%',
	        height: '80%',
	        sort: true,
	        clipWindow: 'origin',
	        squareRatio: 0.5 * (1 + Math.sqrt(5)),
	        leafDepth: null,
	        drillDownIcon: '▶',
	        // to align specialized icon. ▷▶❒❐▼✚
	        zoomToNodeRatio: 0.32 * 0.32,
	        roam: true,
	        nodeClick: 'zoomToNode',
	        animation: true,
	        animationDurationUpdate: 900,
	        animationEasing: 'quinticInOut',
	        breadcrumb: {
	          show: true,
	          height: 22,
	          left: 'center',
	          top: 'bottom',
	          // right
	          // bottom
	          emptyItemWidth: 25,
	          itemStyle: {
	            color: 'rgba(0,0,0,0.7)',
	            textStyle: {
	              color: '#fff'
	            }
	          },
	          emphasis: {
	            itemStyle: {
	              color: 'rgba(0,0,0,0.9)' // '#5793f3',
	
	            }
	          }
	        },
	        label: {
	          show: true,
	          // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
	          distance: 0,
	          padding: 5,
	          position: 'inside',
	          // formatter: null,
	          color: '#fff',
	          overflow: 'truncate' // align
	          // verticalAlign
	
	        },
	        upperLabel: {
	          show: false,
	          position: [0, '50%'],
	          height: 20,
	          // formatter: null,
	          // color: '#fff',
	          overflow: 'truncate',
	          // align: null,
	          verticalAlign: 'middle'
	        },
	        itemStyle: {
	          color: null,
	          colorAlpha: null,
	          colorSaturation: null,
	          borderWidth: 0,
	          gapWidth: 0,
	          borderColor: '#fff',
	          borderColorSaturation: null // If specified, borderColor will be ineffective, and the
	          // border color is evaluated by color of current node and
	          // borderColorSaturation.
	
	        },
	        emphasis: {
	          upperLabel: {
	            show: true,
	            position: [0, '50%'],
	            overflow: 'truncate',
	            verticalAlign: 'middle'
	          }
	        },
	        visualDimension: 0,
	        visualMin: null,
	        visualMax: null,
	        color: [],
	        // level[n].color (if necessary).
	        // + Specify color list of each level. level[0].color would be global
	        // color list if not specified. (see method `setDefault`).
	        // + But set as a empty array to forbid fetch color from global palette
	        // when using nodeModel.get('color'), otherwise nodes on deep level
	        // will always has color palette set and are not able to inherit color
	        // from parent node.
	        // + TreemapSeries.color can not be set as 'none', otherwise effect
	        // legend color fetching (see seriesColor.js).
	        colorAlpha: null,
	        colorSaturation: null,
	        colorMappingBy: 'index',
	        visibleMin: 10,
	        // be rendered. Only works when sort is 'asc' or 'desc'.
	        childrenVisibleMin: null,
	        // grandchildren will not show.
	        // Why grandchildren? If not grandchildren but children,
	        // some siblings show children and some not,
	        // the appearance may be mess and not consistent,
	        levels: [] // Each item: {
	        //     visibleMin, itemStyle, visualDimension, label
	        // }
	
	      };
	      return TreemapSeriesModel;
	    }(SeriesModel);
	    /**
	     * @param {Object} dataNode
	     */
	
	
	    function completeTreeValue(dataNode) {
	      // Postorder travel tree.
	      // If value of none-leaf node is not set,
	      // calculate it by suming up the value of all children.
	      var sum = 0;
	      each(dataNode.children, function (child) {
	        completeTreeValue(child);
	        var childValue = child.value;
	        isArray(childValue) && (childValue = childValue[0]);
	        sum += childValue;
	      });
	      var thisValue = dataNode.value;
	
	      if (isArray(thisValue)) {
	        thisValue = thisValue[0];
	      }
	
	      if (thisValue == null || isNaN(thisValue)) {
	        thisValue = sum;
	      } // Value should not less than 0.
	
	
	      if (thisValue < 0) {
	        thisValue = 0;
	      }
	
	      isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	    }
	    /**
	     * set default to level configuration
	     */
	
	
	    function setDefault(levels, ecModel) {
	      var globalColorList = normalizeToArray(ecModel.get('color'));
	      var globalDecalList = normalizeToArray(ecModel.get(['aria', 'decal', 'decals']));
	
	      if (!globalColorList) {
	        return;
	      }
	
	      levels = levels || [];
	      var hasColorDefine;
	      var hasDecalDefine;
	      each(levels, function (levelDefine) {
	        var model = new Model(levelDefine);
	        var modelColor = model.get('color');
	        var modelDecal = model.get('decal');
	
	        if (model.get(['itemStyle', 'color']) || modelColor && modelColor !== 'none') {
	          hasColorDefine = true;
	        }
	
	        if (model.get(['itemStyle', 'decal']) || modelDecal && modelDecal !== 'none') {
	          hasDecalDefine = true;
	        }
	      });
	      var level0 = levels[0] || (levels[0] = {});
	
	      if (!hasColorDefine) {
	        level0.color = globalColorList.slice();
	      }
	
	      if (!hasDecalDefine && globalDecalList) {
	        level0.decal = globalDecalList.slice();
	      }
	
	      return levels;
	    }
	
	    var TEXT_PADDING = 8;
	    var ITEM_GAP = 8;
	    var ARRAY_LENGTH = 5;
	
	    var Breadcrumb =
	    /** @class */
	    function () {
	      function Breadcrumb(containerGroup) {
	        this.group = new Group();
	        containerGroup.add(this.group);
	      }
	
	      Breadcrumb.prototype.render = function (seriesModel, api, targetNode, onSelect) {
	        var model = seriesModel.getModel('breadcrumb');
	        var thisGroup = this.group;
	        thisGroup.removeAll();
	
	        if (!model.get('show') || !targetNode) {
	          return;
	        }
	
	        var normalStyleModel = model.getModel('itemStyle');
	        var emphasisModel = model.getModel('emphasis');
	        var textStyleModel = normalStyleModel.getModel('textStyle');
	        var emphasisTextStyleModel = emphasisModel.getModel(['itemStyle', 'textStyle']);
	        var layoutParam = {
	          pos: {
	            left: model.get('left'),
	            right: model.get('right'),
	            top: model.get('top'),
	            bottom: model.get('bottom')
	          },
	          box: {
	            width: api.getWidth(),
	            height: api.getHeight()
	          },
	          emptyItemWidth: model.get('emptyItemWidth'),
	          totalWidth: 0,
	          renderList: []
	        };
	
	        this._prepare(targetNode, layoutParam, textStyleModel);
	
	        this._renderContent(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect);
	
	        positionElement(thisGroup, layoutParam.pos, layoutParam.box);
	      };
	      /**
	       * Prepare render list and total width
	       * @private
	       */
	
	
	      Breadcrumb.prototype._prepare = function (targetNode, layoutParam, textStyleModel) {
	        for (var node = targetNode; node; node = node.parentNode) {
	          var text = convertOptionIdName(node.getModel().get('name'), '');
	          var textRect = textStyleModel.getTextRect(text);
	          var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
	          layoutParam.totalWidth += itemWidth + ITEM_GAP;
	          layoutParam.renderList.push({
	            node: node,
	            text: text,
	            width: itemWidth
	          });
	        }
	      };
	      /**
	       * @private
	       */
	
	
	      Breadcrumb.prototype._renderContent = function (seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect) {
	        // Start rendering.
	        var lastX = 0;
	        var emptyItemWidth = layoutParam.emptyItemWidth;
	        var height = seriesModel.get(['breadcrumb', 'height']);
	        var availableSize = getAvailableSize(layoutParam.pos, layoutParam.box);
	        var totalWidth = layoutParam.totalWidth;
	        var renderList = layoutParam.renderList;
	        var emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
	
	        for (var i = renderList.length - 1; i >= 0; i--) {
	          var item = renderList[i];
	          var itemNode = item.node;
	          var itemWidth = item.width;
	          var text = item.text; // Hdie text and shorten width if necessary.
	
	          if (totalWidth > availableSize.width) {
	            totalWidth -= itemWidth - emptyItemWidth;
	            itemWidth = emptyItemWidth;
	            text = null;
	          }
	
	          var el = new Polygon({
	            shape: {
	              points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
	            },
	            style: defaults(normalStyleModel.getItemStyle(), {
	              lineJoin: 'bevel'
	            }),
	            textContent: new ZRText({
	              style: createTextStyle(textStyleModel, {
	                text: text
	              })
	            }),
	            textConfig: {
	              position: 'inside'
	            },
	            z2: Z2_EMPHASIS_LIFT * 1e4,
	            onclick: curry(onSelect, itemNode)
	          });
	          el.disableLabelAnimation = true;
	          el.getTextContent().ensureState('emphasis').style = createTextStyle(emphasisTextStyleModel, {
	            text: text
	          });
	          el.ensureState('emphasis').style = emphasisItemStyle;
	          toggleHoverEmphasis(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	          this.group.add(el);
	          packEventData(el, seriesModel, itemNode);
	          lastX += itemWidth + ITEM_GAP;
	        }
	      };
	
	      Breadcrumb.prototype.remove = function () {
	        this.group.removeAll();
	      };
	
	      return Breadcrumb;
	    }();
	
	    function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
	      var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
	      !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
	      !head && points.push([x, y + itemHeight / 2]);
	      return points;
	    } // Package custom mouse event.
	
	
	    function packEventData(el, seriesModel, itemNode) {
	      getECData(el).eventData = {
	        componentType: 'series',
	        componentSubType: 'treemap',
	        componentIndex: seriesModel.componentIndex,
	        seriesIndex: seriesModel.seriesIndex,
	        seriesName: seriesModel.name,
	        seriesType: 'treemap',
	        selfType: 'breadcrumb',
	        nodeData: {
	          dataIndex: itemNode && itemNode.dataIndex,
	          name: itemNode && itemNode.name
	        },
	        treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
	      };
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	    /**
	     * Animate multiple elements with a single done-callback.
	     *
	     * @example
	     *  animation
	     *      .createWrap()
	     *      .add(el1, {x: 10, y: 10})
	     *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
	     *      .done(function () { // done })
	     *      .start('cubicOut');
	     */
	    var AnimationWrap =
	    /** @class */
	    function () {
	      function AnimationWrap() {
	        this._storage = [];
	        this._elExistsMap = {};
	      }
	      /**
	       * Caution: a el can only be added once, otherwise 'done'
	       * might not be called. This method checks this (by el.id),
	       * suppresses adding and returns false when existing el found.
	       *
	       * @return Whether adding succeeded.
	       */
	
	
	      AnimationWrap.prototype.add = function (el, target, duration, delay, easing) {
	        if (this._elExistsMap[el.id]) {
	          return false;
	        }
	
	        this._elExistsMap[el.id] = true;
	
	        this._storage.push({
	          el: el,
	          target: target,
	          duration: duration,
	          delay: delay,
	          easing: easing
	        });
	
	        return true;
	      };
	      /**
	       * Only execute when animation done/aborted.
	       */
	
	
	      AnimationWrap.prototype.finished = function (callback) {
	        this._finishedCallback = callback;
	        return this;
	      };
	      /**
	       * Will stop exist animation firstly.
	       */
	
	
	      AnimationWrap.prototype.start = function () {
	        var _this = this;
	
	        var count = this._storage.length;
	
	        var checkTerminate = function () {
	          count--;
	
	          if (count <= 0) {
	            // Guard.
	            _this._storage.length = 0;
	            _this._elExistsMap = {};
	            _this._finishedCallback && _this._finishedCallback();
	          }
	        };
	
	        for (var i = 0, len = this._storage.length; i < len; i++) {
	          var item = this._storage[i];
	          item.el.animateTo(item.target, {
	            duration: item.duration,
	            delay: item.delay,
	            easing: item.easing,
	            setToFinal: true,
	            done: checkTerminate,
	            aborted: checkTerminate
	          });
	        }
	
	        return this;
	      };
	
	      return AnimationWrap;
	    }();
	
	    function createWrap() {
	      return new AnimationWrap();
	    }
	
	    var Group$1 = Group;
	    var Rect$1 = Rect;
	    var DRAG_THRESHOLD = 3;
	    var PATH_LABEL_NOAMAL = 'label';
	    var PATH_UPPERLABEL_NORMAL = 'upperLabel'; // Should larger than emphasis states lift z
	
	    var Z2_BASE = Z2_EMPHASIS_LIFT * 10; // Should bigger than every z2.
	
	    var Z2_BG = Z2_EMPHASIS_LIFT * 2;
	    var Z2_CONTENT = Z2_EMPHASIS_LIFT * 3;
	    var getStateItemStyle = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
	    // so use `stroke` to indicate the stroke of the rect.
	    ['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
	    // So do not transfer decal directly.
	    ]);
	
	    var getItemStyleNormal = function (model) {
	      // Normal style props should include emphasis style props.
	      var itemStyle = getStateItemStyle(model); // Clear styles set by emphasis.
	
	      itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
	      return itemStyle;
	    };
	
	    var inner$8 = makeInner();
	
	    var TreemapView =
	    /** @class */
	    function (_super) {
	      __extends(TreemapView, _super);
	
	      function TreemapView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = TreemapView.type;
	        _this._state = 'ready';
	        _this._storage = createStorage();
	        return _this;
	      }
	      /**
	       * @override
	       */
	
	
	      TreemapView.prototype.render = function (seriesModel, ecModel, api, payload) {
	        var models = ecModel.findComponents({
	          mainType: 'series',
	          subType: 'treemap',
	          query: payload
	        });
	
	        if (indexOf(models, seriesModel) < 0) {
	          return;
	        }
	
	        this.seriesModel = seriesModel;
	        this.api = api;
	        this.ecModel = ecModel;
	        var types = ['treemapZoomToNode', 'treemapRootToNode'];
	        var targetInfo = retrieveTargetInfo(payload, types, seriesModel);
	        var payloadType = payload && payload.type;
	        var layoutInfo = seriesModel.layoutInfo;
	        var isInit = !this._oldTree;
	        var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.
	
	        var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
	          rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
	          direction: payload.direction
	        } : null;
	
	        var containerGroup = this._giveContainerGroup(layoutInfo);
	
	        var hasAnimation = seriesModel.get('animation');
	
	        var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
	
	        hasAnimation && !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
	
	        this._resetController(api);
	
	        this._renderBreadcrumb(seriesModel, api, targetInfo);
	      };
	
	      TreemapView.prototype._giveContainerGroup = function (layoutInfo) {
	        var containerGroup = this._containerGroup;
	
	        if (!containerGroup) {
	          // FIXME
	          // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
	          containerGroup = this._containerGroup = new Group$1();
	
	          this._initEvents(containerGroup);
	
	          this.group.add(containerGroup);
	        }
	
	        containerGroup.x = layoutInfo.x;
	        containerGroup.y = layoutInfo.y;
	        return containerGroup;
	      };
	
	      TreemapView.prototype._doRender = function (containerGroup, seriesModel, reRoot) {
	        var thisTree = seriesModel.getData().tree;
	        var oldTree = this._oldTree; // Clear last shape records.
	
	        var lastsForAnimation = createStorage();
	        var thisStorage = createStorage();
	        var oldStorage = this._storage;
	        var willInvisibleEls = [];
	
	        function doRenderNode(thisNode, oldNode, parentGroup, depth) {
	          return renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth);
	        } // Notice: When thisTree and oldTree are the same tree (see list.cloneShallow),
	        // the oldTree is actually losted, so we cannot find all of the old graphic
	        // elements from tree. So we use this strategy: make element storage, move
	        // from old storage to new storage, clear old storage.
	
	
	        dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.
	
	        var willDeleteEls = clearStorage(oldStorage);
	        this._oldTree = thisTree;
	        this._storage = thisStorage;
	        return {
	          lastsForAnimation: lastsForAnimation,
	          willDeleteEls: willDeleteEls,
	          renderFinally: renderFinally
	        };
	
	        function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
	          // When 'render' is triggered by action,
	          // 'this' and 'old' may be the same tree,
	          // we use rawIndex in that case.
	          if (sameTree) {
	            oldViewChildren = thisViewChildren;
	            each(thisViewChildren, function (child, index) {
	              !child.isRemoved() && processNode(index, index);
	            });
	          } // Diff hierarchically (diff only in each subtree, but not whole).
	          // because, consistency of view is important.
	          else {
	              new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(curry(processNode, null)).execute();
	            }
	
	          function getKey(node) {
	            // Identify by name or raw index.
	            return node.getId();
	          }
	
	          function processNode(newIndex, oldIndex) {
	            var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
	            var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
	            var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
	            group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
	          }
	        }
	
	        function clearStorage(storage) {
	          var willDeleteEls = createStorage();
	          storage && each(storage, function (store, storageName) {
	            var delEls = willDeleteEls[storageName];
	            each(store, function (el) {
	              el && (delEls.push(el), inner$8(el).willDelete = true);
	            });
	          });
	          return willDeleteEls;
	        }
	
	        function renderFinally() {
	          each(willDeleteEls, function (els) {
	            each(els, function (el) {
	              el.parent && el.parent.remove(el);
	            });
	          });
	          each(willInvisibleEls, function (el) {
	            el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
	            // just mark as invisible.
	
	            el.dirty();
	          });
	        }
	      };
	
	      TreemapView.prototype._doAnimation = function (containerGroup, renderResult, seriesModel, reRoot) {
	        var durationOption = seriesModel.get('animationDurationUpdate');
	        var easingOption = seriesModel.get('animationEasing'); // TODO: do not support function until necessary.
	
	        var duration = (isFunction(durationOption) ? 0 : durationOption) || 0;
	        var easing = (isFunction(easingOption) ? null : easingOption) || 'cubicOut';
	        var animationWrap = createWrap(); // Make delete animations.
	
	        each(renderResult.willDeleteEls, function (store, storageName) {
	          each(store, function (el, rawIndex) {
	            if (el.invisible) {
	              return;
	            }
	
	            var parent = el.parent; // Always has parent, and parent is nodeGroup.
	
	            var target;
	            var innerStore = inner$8(parent);
	
	            if (reRoot && reRoot.direction === 'drillDown') {
	              target = parent === reRoot.rootNodeGroup // This is the content element of view root.
	              // Only `content` will enter this branch, because
	              // `background` and `nodeGroup` will not be deleted.
	              ? {
	                shape: {
	                  x: 0,
	                  y: 0,
	                  width: innerStore.nodeWidth,
	                  height: innerStore.nodeHeight
	                },
	                style: {
	                  opacity: 0
	                }
	              } // Others.
	              : {
	                style: {
	                  opacity: 0
	                }
	              };
	            } else {
	              var targetX = 0;
	              var targetY = 0;
	
	              if (!innerStore.willDelete) {
	                // Let node animate to right-bottom corner, cooperating with fadeout,
	                // which is appropriate for user understanding.
	                // Divided by 2 for reRoot rolling up effect.
	                targetX = innerStore.nodeWidth / 2;
	                targetY = innerStore.nodeHeight / 2;
	              }
	
	              target = storageName === 'nodeGroup' ? {
	                x: targetX,
	                y: targetY,
	                style: {
	                  opacity: 0
	                }
	              } : {
	                shape: {
	                  x: targetX,
	                  y: targetY,
	                  width: 0,
	                  height: 0
	                },
	                style: {
	                  opacity: 0
	                }
	              };
	            } // TODO: do not support delay until necessary.
	
	
	            target && animationWrap.add(el, target, duration, 0, easing);
	          });
	        }); // Make other animations
	
	        each(this._storage, function (store, storageName) {
	          each(store, function (el, rawIndex) {
	            var last = renderResult.lastsForAnimation[storageName][rawIndex];
	            var target = {};
	
	            if (!last) {
	              return;
	            }
	
	            if (el instanceof Group) {
	              if (last.oldX != null) {
	                target.x = el.x;
	                target.y = el.y;
	                el.x = last.oldX;
	                el.y = last.oldY;
	              }
	            } else {
	              if (last.oldShape) {
	                target.shape = extend({}, el.shape);
	                el.setShape(last.oldShape);
	              }
	
	              if (last.fadein) {
	                el.setStyle('opacity', 0);
	                target.style = {
	                  opacity: 1
	                };
	              } // When animation is stopped for succedent animation starting,
	              // el.style.opacity might not be 1
	              else if (el.style.opacity !== 1) {
	                  target.style = {
	                    opacity: 1
	                  };
	                }
	            }
	
	            animationWrap.add(el, target, duration, 0, easing);
	          });
	        }, this);
	        this._state = 'animating';
	        animationWrap.finished(bind(function () {
	          this._state = 'ready';
	          renderResult.renderFinally();
	        }, this)).start();
	      };
	
	      TreemapView.prototype._resetController = function (api) {
	        var controller = this._controller; // Init controller.
	
	        if (!controller) {
	          controller = this._controller = new RoamController(api.getZr());
	          controller.enable(this.seriesModel.get('roam'));
	          controller.on('pan', bind(this._onPan, this));
	          controller.on('zoom', bind(this._onZoom, this));
	        }
	
	        var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
	        controller.setPointerChecker(function (e, x, y) {
	          return rect.contain(x, y);
	        });
	      };
	
	      TreemapView.prototype._clearController = function () {
	        var controller = this._controller;
	
	        if (controller) {
	          controller.dispose();
	          controller = null;
	        }
	      };
	
	      TreemapView.prototype._onPan = function (e) {
	        if (this._state !== 'animating' && (Math.abs(e.dx) > DRAG_THRESHOLD || Math.abs(e.dy) > DRAG_THRESHOLD)) {
	          // These param must not be cached.
	          var root = this.seriesModel.getData().tree.root;
	
	          if (!root) {
	            return;
	          }
	
	          var rootLayout = root.getLayout();
	
	          if (!rootLayout) {
	            return;
	          }
	
	          this.api.dispatchAction({
	            type: 'treemapMove',
	            from: this.uid,
	            seriesId: this.seriesModel.id,
	            rootRect: {
	              x: rootLayout.x + e.dx,
	              y: rootLayout.y + e.dy,
	              width: rootLayout.width,
	              height: rootLayout.height
	            }
	          });
	        }
	      };
	
	      TreemapView.prototype._onZoom = function (e) {
	        var mouseX = e.originX;
	        var mouseY = e.originY;
	
	        if (this._state !== 'animating') {
	          // These param must not be cached.
	          var root = this.seriesModel.getData().tree.root;
	
	          if (!root) {
	            return;
	          }
	
	          var rootLayout = root.getLayout();
	
	          if (!rootLayout) {
	            return;
	          }
	
	          var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
	          var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.
	
	          mouseX -= layoutInfo.x;
	          mouseY -= layoutInfo.y; // Scale root bounding rect.
	
	          var m = create$1();
	          translate(m, m, [-mouseX, -mouseY]);
	          scale$1(m, m, [e.scale, e.scale]);
	          translate(m, m, [mouseX, mouseY]);
	          rect.applyTransform(m);
	          this.api.dispatchAction({
	            type: 'treemapRender',
	            from: this.uid,
	            seriesId: this.seriesModel.id,
	            rootRect: {
	              x: rect.x,
	              y: rect.y,
	              width: rect.width,
	              height: rect.height
	            }
	          });
	        }
	      };
	
	      TreemapView.prototype._initEvents = function (containerGroup) {
	        var _this = this;
	
	        containerGroup.on('click', function (e) {
	          if (_this._state !== 'ready') {
	            return;
	          }
	
	          var nodeClick = _this.seriesModel.get('nodeClick', true);
	
	          if (!nodeClick) {
	            return;
	          }
	
	          var targetInfo = _this.findTarget(e.offsetX, e.offsetY);
	
	          if (!targetInfo) {
	            return;
	          }
	
	          var node = targetInfo.node;
	
	          if (node.getLayout().isLeafRoot) {
	            _this._rootToNode(targetInfo);
	          } else {
	            if (nodeClick === 'zoomToNode') {
	              _this._zoomToNode(targetInfo);
	            } else if (nodeClick === 'link') {
	              var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
	              var link = itemModel.get('link', true);
	              var linkTarget = itemModel.get('target', true) || 'blank';
	              link && windowOpen(link, linkTarget);
	            }
	          }
	        }, this);
	      };
	
	      TreemapView.prototype._renderBreadcrumb = function (seriesModel, api, targetInfo) {
	        var _this = this;
	
	        if (!targetInfo) {
	          targetInfo = seriesModel.get('leafDepth', true) != null ? {
	            node: seriesModel.getViewRoot()
	          } // FIXME
	          // better way?
	          // Find breadcrumb tail on center of containerGroup.
	          : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
	
	          if (!targetInfo) {
	            targetInfo = {
	              node: seriesModel.getData().tree.root
	            };
	          }
	        }
	
	        (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, function (node) {
	          if (_this._state !== 'animating') {
	            aboveViewRoot(seriesModel.getViewRoot(), node) ? _this._rootToNode({
	              node: node
	            }) : _this._zoomToNode({
	              node: node
	            });
	          }
	        });
	      };
	      /**
	       * @override
	       */
	
	
	      TreemapView.prototype.remove = function () {
	        this._clearController();
	
	        this._containerGroup && this._containerGroup.removeAll();
	        this._storage = createStorage();
	        this._state = 'ready';
	        this._breadcrumb && this._breadcrumb.remove();
	      };
	
	      TreemapView.prototype.dispose = function () {
	        this._clearController();
	      };
	
	      TreemapView.prototype._zoomToNode = function (targetInfo) {
	        this.api.dispatchAction({
	          type: 'treemapZoomToNode',
	          from: this.uid,
	          seriesId: this.seriesModel.id,
	          targetNode: targetInfo.node
	        });
	      };
	
	      TreemapView.prototype._rootToNode = function (targetInfo) {
	        this.api.dispatchAction({
	          type: 'treemapRootToNode',
	          from: this.uid,
	          seriesId: this.seriesModel.id,
	          targetNode: targetInfo.node
	        });
	      };
	      /**
	       * @public
	       * @param {number} x Global coord x.
	       * @param {number} y Global coord y.
	       * @return {Object} info If not found, return undefined;
	       * @return {number} info.node Target node.
	       * @return {number} info.offsetX x refer to target node.
	       * @return {number} info.offsetY y refer to target node.
	       */
	
	
	      TreemapView.prototype.findTarget = function (x, y) {
	        var targetInfo;
	        var viewRoot = this.seriesModel.getViewRoot();
	        viewRoot.eachNode({
	          attr: 'viewChildren',
	          order: 'preorder'
	        }, function (node) {
	          var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.
	
	
	          if (bgEl) {
	            var point = bgEl.transformCoordToLocal(x, y);
	            var shape = bgEl.shape; // For performance consideration, don't use 'getBoundingRect'.
	
	            if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
	              targetInfo = {
	                node: node,
	                offsetX: point[0],
	                offsetY: point[1]
	              };
	            } else {
	              return false; // Suppress visit subtree.
	            }
	          }
	        }, this);
	        return targetInfo;
	      };
	
	      TreemapView.type = 'treemap';
	      return TreemapView;
	    }(ChartView);
	    /**
	     * @inner
	     */
	
	
	    function createStorage() {
	      return {
	        nodeGroup: [],
	        background: [],
	        content: []
	      };
	    }
	    /**
	     * @inner
	     * @return Return undefined means do not travel further.
	     */
	
	
	    function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
	      // Whether under viewRoot.
	      if (!thisNode) {
	        // Deleting nodes will be performed finally. This method just find
	        // element from old storage, or create new element, set them to new
	        // storage, and set styles.
	        return;
	      } // -------------------------------------------------------------------
	      // Start of closure variables available in "Procedures in renderNode".
	
	
	      var thisLayout = thisNode.getLayout();
	      var data = seriesModel.getData();
	      var nodeModel = thisNode.getModel(); // Only for enabling highlight/downplay. Clear firstly.
	      // Because some node will not be rendered.
	
	      data.setItemGraphicEl(thisNode.dataIndex, null);
	
	      if (!thisLayout || !thisLayout.isInView) {
	        return;
	      }
	
	      var thisWidth = thisLayout.width;
	      var thisHeight = thisLayout.height;
	      var borderWidth = thisLayout.borderWidth;
	      var thisInvisible = thisLayout.invisible;
	      var thisRawIndex = thisNode.getRawIndex();
	      var oldRawIndex = oldNode && oldNode.getRawIndex();
	      var thisViewChildren = thisNode.viewChildren;
	      var upperHeight = thisLayout.upperHeight;
	      var isParent = thisViewChildren && thisViewChildren.length;
	      var itemStyleNormalModel = nodeModel.getModel('itemStyle');
	      var itemStyleEmphasisModel = nodeModel.getModel(['emphasis', 'itemStyle']);
	      var itemStyleBlurModel = nodeModel.getModel(['blur', 'itemStyle']);
	      var itemStyleSelectModel = nodeModel.getModel(['select', 'itemStyle']);
	      var borderRadius = itemStyleNormalModel.get('borderRadius') || 0; // End of closure ariables available in "Procedures in renderNode".
	      // -----------------------------------------------------------------
	      // Node group
	
	      var group = giveGraphic('nodeGroup', Group$1);
	
	      if (!group) {
	        return;
	      }
	
	      parentGroup.add(group); // x,y are not set when el is above view root.
	
	      group.x = thisLayout.x || 0;
	      group.y = thisLayout.y || 0;
	      group.markRedraw();
	      inner$8(group).nodeWidth = thisWidth;
	      inner$8(group).nodeHeight = thisHeight;
	
	      if (thisLayout.isAboveViewRoot) {
	        return group;
	      } // Background
	
	
	      var bg = giveGraphic('background', Rect$1, depth, Z2_BG);
	      bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight);
	      var emphasisModel = nodeModel.getModel('emphasis');
	      var focus = emphasisModel.get('focus');
	      var blurScope = emphasisModel.get('blurScope');
	      var isDisabled = emphasisModel.get('disabled');
	      var focusOrIndices = focus === 'ancestor' ? thisNode.getAncestorsIndices() : focus === 'descendant' ? thisNode.getDescendantIndices() : focus; // No children, render content.
	
	      if (isParent) {
	        // Because of the implementation about "traverse" in graphic hover style, we
	        // can not set hover listener on the "group" of non-leaf node. Otherwise the
	        // hover event from the descendents will be listenered.
	        if (isHighDownDispatcher(group)) {
	          setAsHighDownDispatcher(group, false);
	        }
	
	        if (bg) {
	          setAsHighDownDispatcher(bg, !isDisabled); // Only for enabling highlight/downplay.
	
	          data.setItemGraphicEl(thisNode.dataIndex, bg);
	          enableHoverFocus(bg, focusOrIndices, blurScope);
	        }
	      } else {
	        var content = giveGraphic('content', Rect$1, depth, Z2_CONTENT);
	        content && renderContent(group, content);
	        bg.disableMorphing = true;
	
	        if (bg && isHighDownDispatcher(bg)) {
	          setAsHighDownDispatcher(bg, false);
	        }
	
	        setAsHighDownDispatcher(group, !isDisabled); // Only for enabling highlight/downplay.
	
	        data.setItemGraphicEl(thisNode.dataIndex, group);
	        enableHoverFocus(group, focusOrIndices, blurScope);
	      }
	
	      return group; // ----------------------------
	      // | Procedures in renderNode |
	      // ----------------------------
	
	      function renderBackground(group, bg, useUpperLabel) {
	        var ecData = getECData(bg); // For tooltip.
	
	        ecData.dataIndex = thisNode.dataIndex;
	        ecData.seriesIndex = seriesModel.seriesIndex;
	        bg.setShape({
	          x: 0,
	          y: 0,
	          width: thisWidth,
	          height: thisHeight,
	          r: borderRadius
	        });
	
	        if (thisInvisible) {
	          // If invisible, do not set visual, otherwise the element will
	          // change immediately before animation. We think it is OK to
	          // remain its origin color when moving out of the view window.
	          processInvisible(bg);
	        } else {
	          bg.invisible = false;
	          var style = thisNode.getVisual('style');
	          var visualBorderColor = style.stroke;
	          var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	          normalStyle.fill = visualBorderColor;
	          var emphasisStyle = getStateItemStyle(itemStyleEmphasisModel);
	          emphasisStyle.fill = itemStyleEmphasisModel.get('borderColor');
	          var blurStyle = getStateItemStyle(itemStyleBlurModel);
	          blurStyle.fill = itemStyleBlurModel.get('borderColor');
	          var selectStyle = getStateItemStyle(itemStyleSelectModel);
	          selectStyle.fill = itemStyleSelectModel.get('borderColor');
	
	          if (useUpperLabel) {
	            var upperLabelWidth = thisWidth - 2 * borderWidth;
	            prepareText( // PENDING: convert ZRColor to ColorString for text.
	            bg, visualBorderColor, style.opacity, {
	              x: borderWidth,
	              y: 0,
	              width: upperLabelWidth,
	              height: upperHeight
	            });
	          } // For old bg.
	          else {
	              bg.removeTextContent();
	            }
	
	          bg.setStyle(normalStyle);
	          bg.ensureState('emphasis').style = emphasisStyle;
	          bg.ensureState('blur').style = blurStyle;
	          bg.ensureState('select').style = selectStyle;
	          setDefaultStateProxy(bg);
	        }
	
	        group.add(bg);
	      }
	
	      function renderContent(group, content) {
	        var ecData = getECData(content); // For tooltip.
	
	        ecData.dataIndex = thisNode.dataIndex;
	        ecData.seriesIndex = seriesModel.seriesIndex;
	        var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
	        var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
	        content.culling = true;
	        content.setShape({
	          x: borderWidth,
	          y: borderWidth,
	          width: contentWidth,
	          height: contentHeight,
	          r: borderRadius
	        });
	
	        if (thisInvisible) {
	          // If invisible, do not set visual, otherwise the element will
	          // change immediately before animation. We think it is OK to
	          // remain its origin color when moving out of the view window.
	          processInvisible(content);
	        } else {
	          content.invisible = false;
	          var nodeStyle = thisNode.getVisual('style');
	          var visualColor = nodeStyle.fill;
	          var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	          normalStyle.fill = visualColor;
	          normalStyle.decal = nodeStyle.decal;
	          var emphasisStyle = getStateItemStyle(itemStyleEmphasisModel);
	          var blurStyle = getStateItemStyle(itemStyleBlurModel);
	          var selectStyle = getStateItemStyle(itemStyleSelectModel); // PENDING: convert ZRColor to ColorString for text.
	
	          prepareText(content, visualColor, nodeStyle.opacity, null);
	          content.setStyle(normalStyle);
	          content.ensureState('emphasis').style = emphasisStyle;
	          content.ensureState('blur').style = blurStyle;
	          content.ensureState('select').style = selectStyle;
	          setDefaultStateProxy(content);
	        }
	
	        group.add(content);
	      }
	
	      function processInvisible(element) {
	        // Delay invisible setting utill animation finished,
	        // avoid element vanish suddenly before animation.
	        !element.invisible && willInvisibleEls.push(element);
	      }
	
	      function prepareText(rectEl, visualColor, visualOpacity, // Can be null/undefined
	      upperLabelRect) {
	        var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
	        var defaultText = convertOptionIdName(nodeModel.get('name'), null);
	        var isShow = normalLabelModel.getShallow('show');
	        setLabelStyle(rectEl, getLabelStatesModels(nodeModel, upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL), {
	          defaultText: isShow ? defaultText : null,
	          inheritColor: visualColor,
	          defaultOpacity: visualOpacity,
	          labelFetcher: seriesModel,
	          labelDataIndex: thisNode.dataIndex
	        });
	        var textEl = rectEl.getTextContent();
	
	        if (!textEl) {
	          return;
	        }
	
	        var textStyle = textEl.style;
	        var textPadding = normalizeCssArray(textStyle.padding || 0);
	
	        if (upperLabelRect) {
	          rectEl.setTextConfig({
	            layoutRect: upperLabelRect
	          });
	          textEl.disableLabelLayout = true;
	        }
	
	        textEl.beforeUpdate = function () {
	          var width = Math.max((upperLabelRect ? upperLabelRect.width : rectEl.shape.width) - textPadding[1] - textPadding[3], 0);
	          var height = Math.max((upperLabelRect ? upperLabelRect.height : rectEl.shape.height) - textPadding[0] - textPadding[2], 0);
	
	          if (textStyle.width !== width || textStyle.height !== height) {
	            textEl.setStyle({
	              width: width,
	              height: height
	            });
	          }
	        };
	
	        textStyle.truncateMinChar = 2;
	        textStyle.lineOverflow = 'truncate';
	        addDrillDownIcon(textStyle, upperLabelRect, thisLayout);
	        var textEmphasisState = textEl.getState('emphasis');
	        addDrillDownIcon(textEmphasisState ? textEmphasisState.style : null, upperLabelRect, thisLayout);
	      }
	
	      function addDrillDownIcon(style, upperLabelRect, thisLayout) {
	        var text = style ? style.text : null;
	
	        if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
	          var iconChar = seriesModel.get('drillDownIcon', true);
	          style.text = iconChar ? iconChar + ' ' + text : text;
	        }
	      }
	
	      function giveGraphic(storageName, Ctor, depth, z) {
	        var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
	        var lasts = lastsForAnimation[storageName];
	
	        if (element) {
	          // Remove from oldStorage
	          oldStorage[storageName][oldRawIndex] = null;
	          prepareAnimationWhenHasOld(lasts, element);
	        } // If invisible and no old element, do not create new element (for optimizing).
	        else if (!thisInvisible) {
	            element = new Ctor();
	
	            if (element instanceof Displayable) {
	              element.z2 = calculateZ2(depth, z);
	            }
	
	            prepareAnimationWhenNoOld(lasts, element);
	          } // Set to thisStorage
	
	
	        return thisStorage[storageName][thisRawIndex] = element;
	      }
	
	      function prepareAnimationWhenHasOld(lasts, element) {
	        var lastCfg = lasts[thisRawIndex] = {};
	
	        if (element instanceof Group$1) {
	          lastCfg.oldX = element.x;
	          lastCfg.oldY = element.y;
	        } else {
	          lastCfg.oldShape = extend({}, element.shape);
	        }
	      } // If a element is new, we need to find the animation start point carefully,
	      // otherwise it will looks strange when 'zoomToNode'.
	
	
	      function prepareAnimationWhenNoOld(lasts, element) {
	        var lastCfg = lasts[thisRawIndex] = {};
	        var parentNode = thisNode.parentNode;
	        var isGroup = element instanceof Group;
	
	        if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
	          var parentOldX = 0;
	          var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
	          // For convenience, get old bounding rect from background.
	
	          var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
	
	          if (!reRoot && parentOldBg && parentOldBg.oldShape) {
	            parentOldX = parentOldBg.oldShape.width;
	            parentOldY = parentOldBg.oldShape.height;
	          } // When no parent old shape found, its parent is new too,
	          // so we can just use {x:0, y:0}.
	
	
	          if (isGroup) {
	            lastCfg.oldX = 0;
	            lastCfg.oldY = parentOldY;
	          } else {
	            lastCfg.oldShape = {
	              x: parentOldX,
	              y: parentOldY,
	              width: 0,
	              height: 0
	            };
	          }
	        } // Fade in, user can be aware that these nodes are new.
	
	
	        lastCfg.fadein = !isGroup;
	      }
	    } // We cannot set all background with the same z, because the behaviour of
	    // drill down and roll up differ background creation sequence from tree
	    // hierarchy sequence, which cause lower background elements to overlap
	    // upper ones. So we calculate z based on depth.
	    // Moreover, we try to shrink down z interval to [0, 1] to avoid that
	    // treemap with large z overlaps other components.
	
	
	    function calculateZ2(depth, z2InLevel) {
	      return depth * Z2_BASE + z2InLevel;
	    }
	
	    var each$3 = each;
	    var isObject$3 = isObject;
	    var CATEGORY_DEFAULT_VISUAL_INDEX = -1;
	
	    var VisualMapping =
	    /** @class */
	    function () {
	      function VisualMapping(option) {
	        var mappingMethod = option.mappingMethod;
	        var visualType = option.type;
	        var thisOption = this.option = clone(option);
	        this.type = visualType;
	        this.mappingMethod = mappingMethod;
	        this._normalizeData = normalizers[mappingMethod];
	        var visualHandler = VisualMapping.visualHandlers[visualType];
	        this.applyVisual = visualHandler.applyVisual;
	        this.getColorMapper = visualHandler.getColorMapper;
	        this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];
	
	        if (mappingMethod === 'piecewise') {
	          normalizeVisualRange(thisOption);
	          preprocessForPiecewise(thisOption);
	        } else if (mappingMethod === 'category') {
	          thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
	          // which need no more preprocess except normalize visual.
	          : normalizeVisualRange(thisOption, true);
	        } else {
	          // mappingMethod === 'linear' or 'fixed'
	          assert(mappingMethod !== 'linear' || thisOption.dataExtent);
	          normalizeVisualRange(thisOption);
	        }
	      }
	
	      VisualMapping.prototype.mapValueToVisual = function (value) {
	        var normalized = this._normalizeData(value);
	
	        return this._normalizedToVisual(normalized, value);
	      };
	
	      VisualMapping.prototype.getNormalizer = function () {
	        return bind(this._normalizeData, this);
	      };
	      /**
	       * List available visual types.
	       *
	       * @public
	       * @return {Array.<string>}
	       */
	
	
	      VisualMapping.listVisualTypes = function () {
	        return keys(VisualMapping.visualHandlers);
	      }; // /**
	      //  * @public
	      //  */
	      // static addVisualHandler(name, handler) {
	      //     visualHandlers[name] = handler;
	      // }
	
	      /**
	       * @public
	       */
	
	
	      VisualMapping.isValidType = function (visualType) {
	        return VisualMapping.visualHandlers.hasOwnProperty(visualType);
	      };
	      /**
	       * Convenient method.
	       * Visual can be Object or Array or primary type.
	       */
	
	
	      VisualMapping.eachVisual = function (visual, callback, context) {
	        if (isObject(visual)) {
	          each(visual, callback, context);
	        } else {
	          callback.call(context, visual);
	        }
	      };
	
	      VisualMapping.mapVisual = function (visual, callback, context) {
	        var isPrimary;
	        var newVisual = isArray(visual) ? [] : isObject(visual) ? {} : (isPrimary = true, null);
	        VisualMapping.eachVisual(visual, function (v, key) {
	          var newVal = callback.call(context, v, key);
	          isPrimary ? newVisual = newVal : newVisual[key] = newVal;
	        });
	        return newVisual;
	      };
	      /**
	       * Retrieve visual properties from given object.
	       */
	
	
	      VisualMapping.retrieveVisuals = function (obj) {
	        var ret = {};
	        var hasVisual;
	        obj && each$3(VisualMapping.visualHandlers, function (h, visualType) {
	          if (obj.hasOwnProperty(visualType)) {
	            ret[visualType] = obj[visualType];
	            hasVisual = true;
	          }
	        });
	        return hasVisual ? ret : null;
	      };
	      /**
	       * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
	       *
	       * @public
	       * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
	       *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
	       * @return {Array.<string>} Sorted visual types.
	       */
	
	
	      VisualMapping.prepareVisualTypes = function (visualTypes) {
	        if (isArray(visualTypes)) {
	          visualTypes = visualTypes.slice();
	        } else if (isObject$3(visualTypes)) {
	          var types_1 = [];
	          each$3(visualTypes, function (item, type) {
	            types_1.push(type);
	          });
	          visualTypes = types_1;
	        } else {
	          return [];
	        }
	
	        visualTypes.sort(function (type1, type2) {
	          // color should be front of colorSaturation, colorAlpha, ...
	          // symbol and symbolSize do not matter.
	          return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
	        });
	        return visualTypes;
	      };
	      /**
	       * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
	       * Other visuals are only depends on themself.
	       */
	
	
	      VisualMapping.dependsOn = function (visualType1, visualType2) {
	        return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
	      };
	      /**
	       * @param value
	       * @param pieceList [{value: ..., interval: [min, max]}, ...]
	       *                         Always from small to big.
	       * @param findClosestWhenOutside Default to be false
	       * @return index
	       */
	
	
	      VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
	        var possibleI;
	        var abs = Infinity; // value has the higher priority.
	
	        for (var i = 0, len = pieceList.length; i < len; i++) {
	          var pieceValue = pieceList[i].value;
	
	          if (pieceValue != null) {
	            if (pieceValue === value // FIXME
	            // It is supposed to compare value according to value type of dimension,
	            // but currently value type can exactly be string or number.
	            // Compromise for numeric-like string (like '12'), especially
	            // in the case that visualMap.categories is ['22', '33'].
	            || isString(pieceValue) && pieceValue === value + '') {
	              return i;
	            }
	
	            findClosestWhenOutside && updatePossible(pieceValue, i);
	          }
	        }
	
	        for (var i = 0, len = pieceList.length; i < len; i++) {
	          var piece = pieceList[i];
	          var interval = piece.interval;
	          var close_1 = piece.close;
	
	          if (interval) {
	            if (interval[0] === -Infinity) {
	              if (littleThan(close_1[1], value, interval[1])) {
	                return i;
	              }
	            } else if (interval[1] === Infinity) {
	              if (littleThan(close_1[0], interval[0], value)) {
	                return i;
	              }
	            } else if (littleThan(close_1[0], interval[0], value) && littleThan(close_1[1], value, interval[1])) {
	              return i;
	            }
	
	            findClosestWhenOutside && updatePossible(interval[0], i);
	            findClosestWhenOutside && updatePossible(interval[1], i);
	          }
	        }
	
	        if (findClosestWhenOutside) {
	          return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
	        }
	
	        function updatePossible(val, index) {
	          var newAbs = Math.abs(val - value);
	
	          if (newAbs < abs) {
	            abs = newAbs;
	            possibleI = index;
	          }
	        }
	      };
	
	      VisualMapping.visualHandlers = {
	        color: {
	          applyVisual: makeApplyVisual('color'),
	          getColorMapper: function () {
	            var thisOption = this.option;
	            return bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
	              !isNormalized && (value = this._normalizeData(value));
	              return doMapCategory.call(this, value);
	            } : function (value, isNormalized, out) {
	              // If output rgb array
	              // which will be much faster and useful in pixel manipulation
	              var returnRGBArray = !!out;
	              !isNormalized && (value = this._normalizeData(value));
	              out = fastLerp(value, thisOption.parsedVisual, out);
	              return returnRGBArray ? out : stringify(out, 'rgba');
	            }, this);
	          },
	          _normalizedToVisual: {
	            linear: function (normalized) {
	              return stringify(fastLerp(normalized, this.option.parsedVisual), 'rgba');
	            },
	            category: doMapCategory,
	            piecewise: function (normalized, value) {
	              var result = getSpecifiedVisual.call(this, value);
	
	              if (result == null) {
	                result = stringify(fastLerp(normalized, this.option.parsedVisual), 'rgba');
	              }
	
	              return result;
	            },
	            fixed: doMapFixed
	          }
	        },
	        colorHue: makePartialColorVisualHandler(function (color$1, value) {
	          return modifyHSL(color$1, value);
	        }),
	        colorSaturation: makePartialColorVisualHandler(function (color$1, value) {
	          return modifyHSL(color$1, null, value);
	        }),
	        colorLightness: makePartialColorVisualHandler(function (color$1, value) {
	          return modifyHSL(color$1, null, null, value);
	        }),
	        colorAlpha: makePartialColorVisualHandler(function (color$1, value) {
	          return modifyAlpha(color$1, value);
	        }),
	        decal: {
	          applyVisual: makeApplyVisual('decal'),
	          _normalizedToVisual: {
	            linear: null,
	            category: doMapCategory,
	            piecewise: null,
	            fixed: null
	          }
	        },
	        opacity: {
	          applyVisual: makeApplyVisual('opacity'),
	          _normalizedToVisual: createNormalizedToNumericVisual([0, 1])
	        },
	        liftZ: {
	          applyVisual: makeApplyVisual('liftZ'),
	          _normalizedToVisual: {
	            linear: doMapFixed,
	            category: doMapFixed,
	            piecewise: doMapFixed,
	            fixed: doMapFixed
	          }
	        },
	        symbol: {
	          applyVisual: function (value, getter, setter) {
	            var symbolCfg = this.mapValueToVisual(value);
	            setter('symbol', symbolCfg);
	          },
	          _normalizedToVisual: {
	            linear: doMapToArray,
	            category: doMapCategory,
	            piecewise: function (normalized, value) {
	              var result = getSpecifiedVisual.call(this, value);
	
	              if (result == null) {
	                result = doMapToArray.call(this, normalized);
	              }
	
	              return result;
	            },
	            fixed: doMapFixed
	          }
	        },
	        symbolSize: {
	          applyVisual: makeApplyVisual('symbolSize'),
	          _normalizedToVisual: createNormalizedToNumericVisual([0, 1])
	        }
	      };
	      return VisualMapping;
	    }();
	
	    function preprocessForPiecewise(thisOption) {
	      var pieceList = thisOption.pieceList;
	      thisOption.hasSpecialVisual = false;
	      each(pieceList, function (piece, index) {
	        piece.originIndex = index; // piece.visual is "result visual value" but not
	        // a visual range, so it does not need to be normalized.
	
	        if (piece.visual != null) {
	          thisOption.hasSpecialVisual = true;
	        }
	      });
	    }
	
	    function preprocessForSpecifiedCategory(thisOption) {
	      // Hash categories.
	      var categories = thisOption.categories;
	      var categoryMap = thisOption.categoryMap = {};
	      var visual = thisOption.visual;
	      each$3(categories, function (cate, index) {
	        categoryMap[cate] = index;
	      }); // Process visual map input.
	
	      if (!isArray(visual)) {
	        var visualArr_1 = [];
	
	        if (isObject(visual)) {
	          each$3(visual, function (v, cate) {
	            var index = categoryMap[cate];
	            visualArr_1[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
	          });
	        } else {
	          // Is primary type, represents default visual.
	          visualArr_1[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
	        }
	
	        visual = setVisualToOption(thisOption, visualArr_1);
	      } // Remove categories that has no visual,
	      // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
	
	
	      for (var i = categories.length - 1; i >= 0; i--) {
	        if (visual[i] == null) {
	          delete categoryMap[categories[i]];
	          categories.pop();
	        }
	      }
	    }
	
	    function normalizeVisualRange(thisOption, isCategory) {
	      var visual = thisOption.visual;
	      var visualArr = [];
	
	      if (isObject(visual)) {
	        each$3(visual, function (v) {
	          visualArr.push(v);
	        });
	      } else if (visual != null) {
	        visualArr.push(visual);
	      }
	
	      var doNotNeedPair = {
	        color: 1,
	        symbol: 1
	      };
	
	      if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
	        // Do not care visualArr.length === 0, which is illegal.
	        visualArr[1] = visualArr[0];
	      }
	
	      setVisualToOption(thisOption, visualArr);
	    }
	
	    function makePartialColorVisualHandler(applyValue) {
	      return {
	        applyVisual: function (value, getter, setter) {
	          // Only used in HSL
	          var colorChannel = this.mapValueToVisual(value); // Must not be array value
	
	          setter('color', applyValue(getter('color'), colorChannel));
	        },
	        _normalizedToVisual: createNormalizedToNumericVisual([0, 1])
	      };
	    }
	
	    function doMapToArray(normalized) {
	      var visual = this.option.visual;
	      return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {}; // TODO {}?
	    }
	
	    function makeApplyVisual(visualType) {
	      return function (value, getter, setter) {
	        setter(visualType, this.mapValueToVisual(value));
	      };
	    }
	
	    function doMapCategory(normalized) {
	      var visual = this.option.visual;
	      return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
	    }
	
	    function doMapFixed() {
	      // visual will be convert to array.
	      return this.option.visual[0];
	    }
	    /**
	     * Create mapped to numeric visual
	     */
	
	
	    function createNormalizedToNumericVisual(sourceExtent) {
	      return {
	        linear: function (normalized) {
	          return linearMap(normalized, sourceExtent, this.option.visual, true);
	        },
	        category: doMapCategory,
	        piecewise: function (normalized, value) {
	          var result = getSpecifiedVisual.call(this, value);
	
	          if (result == null) {
	            result = linearMap(normalized, sourceExtent, this.option.visual, true);
	          }
	
	          return result;
	        },
	        fixed: doMapFixed
	      };
	    }
	
	    function getSpecifiedVisual(value) {
	      var thisOption = this.option;
	      var pieceList = thisOption.pieceList;
	
	      if (thisOption.hasSpecialVisual) {
	        var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
	        var piece = pieceList[pieceIndex];
	
	        if (piece && piece.visual) {
	          return piece.visual[this.type];
	        }
	      }
	    }
	
	    function setVisualToOption(thisOption, visualArr) {
	      thisOption.visual = visualArr;
	
	      if (thisOption.type === 'color') {
	        thisOption.parsedVisual = map(visualArr, function (item) {
	          var color$1 = parse(item);
	
	          if (!color$1 && "development" !== 'production') {
	            warn("'" + item + "' is an illegal color, fallback to '#000000'", true);
	          }
	
	          return color$1 || [0, 0, 0, 1];
	        });
	      }
	
	      return visualArr;
	    }
	    /**
	     * Normalizers by mapping methods.
	     */
	
	
	    var normalizers = {
	      linear: function (value) {
	        return linearMap(value, this.option.dataExtent, [0, 1], true);
	      },
	      piecewise: function (value) {
	        var pieceList = this.option.pieceList;
	        var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);
	
	        if (pieceIndex != null) {
	          return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
	        }
	      },
	      category: function (value) {
	        var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value
	
	        return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
	      },
	      fixed: noop
	    };
	
	    function littleThan(close, a, b) {
	      return close ? a <= b : a < b;
	    }
	
	    var ITEM_STYLE_NORMAL = 'itemStyle';
	    var inner$9 = makeInner();
	    var treemapVisual = {
	      seriesType: 'treemap',
	      reset: function (seriesModel) {
	        var tree = seriesModel.getData().tree;
	        var root = tree.root;
	
	        if (root.isRemoved()) {
	          return;
	        }
	
	        travelTree(root, // Visual should calculate from tree root but not view root.
	        {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
	      }
	    };
	
	    function travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
	      var nodeModel = node.getModel();
	      var nodeLayout = node.getLayout();
	      var data = node.hostTree.data; // Optimize
	
	      if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
	        return;
	      }
	
	      var nodeItemStyleModel = nodeModel.getModel(ITEM_STYLE_NORMAL);
	      var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel);
	      var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style'); // calculate border color
	
	      var borderColor = nodeItemStyleModel.get('borderColor');
	      var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
	      var thisNodeColor;
	
	      if (borderColorSaturation != null) {
	        // For performance, do not always execute 'calculateColor'.
	        thisNodeColor = calculateColor(visuals);
	        borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
	      }
	
	      existsStyle.stroke = borderColor;
	      var viewChildren = node.viewChildren;
	
	      if (!viewChildren || !viewChildren.length) {
	        thisNodeColor = calculateColor(visuals); // Apply visual to this node.
	
	        existsStyle.fill = thisNodeColor;
	      } else {
	        var mapping_1 = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.
	
	        each(viewChildren, function (child, index) {
	          // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
	          if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
	            var childVisual = mapVisual(nodeModel, visuals, child, index, mapping_1, seriesModel);
	            travelTree(child, childVisual, viewRootAncestors, seriesModel);
	          }
	        });
	      }
	    }
	
	    function buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
	      var visuals = extend({}, designatedVisual);
	      var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
	      each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
	        // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
	        designatedVisualItemStyle[visualName] = designatedVisual[visualName];
	        var val = nodeItemStyleModel.get(visualName);
	        designatedVisualItemStyle[visualName] = null;
	        val != null && (visuals[visualName] = val);
	      });
	      return visuals;
	    }
	
	    function calculateColor(visuals) {
	      var color = getValueVisualDefine(visuals, 'color');
	
	      if (color) {
	        var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
	        var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');
	
	        if (colorSaturation) {
	          color = modifyHSL(color, null, null, colorSaturation);
	        }
	
	        if (colorAlpha) {
	          color = modifyAlpha(color, colorAlpha);
	        }
	
	        return color;
	      }
	    }
	
	    function calculateBorderColor(borderColorSaturation, thisNodeColor) {
	      return thisNodeColor != null // Can only be string
	      ? modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
	    }
	
	    function getValueVisualDefine(visuals, name) {
	      var value = visuals[name];
	
	      if (value != null && value !== 'none') {
	        return value;
	      }
	    }
	
	    function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
	      if (!viewChildren || !viewChildren.length) {
	        return;
	      }
	
	      var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));
	
	      if (!rangeVisual) {
	        return;
	      }
	
	      var visualMin = nodeModel.get('visualMin');
	      var visualMax = nodeModel.get('visualMax');
	      var dataExtent = nodeLayout.dataExtent.slice();
	      visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
	      visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
	      var colorMappingBy = nodeModel.get('colorMappingBy');
	      var opt = {
	        type: rangeVisual.name,
	        dataExtent: dataExtent,
	        visual: rangeVisual.range
	      };
	
	      if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
	        opt.mappingMethod = 'category';
	        opt.loop = true; // categories is ordinal, so do not set opt.categories.
	      } else {
	        opt.mappingMethod = 'linear';
	      }
	
	      var mapping = new VisualMapping(opt);
	      inner$9(mapping).drColorMappingBy = colorMappingBy;
	      return mapping;
	    } // Notice: If we don't have the attribute 'colorRange', but only use
	    // attribute 'color' to represent both concepts of 'colorRange' and 'color',
	    // (It means 'colorRange' when 'color' is Array, means 'color' when not array),
	    // this problem will be encountered:
	    // If a level-1 node doesn't have children, and its siblings have children,
	    // and colorRange is set on level-1, then the node cannot be colored.
	    // So we separate 'colorRange' and 'color' to different attributes.
	
	
	    function getRangeVisual(nodeModel, name) {
	      // 'colorRange', 'colorARange', 'colorSRange'.
	      // If not exists on this node, fetch from levels and series.
	      var range = nodeModel.get(name);
	      return isArray(range) && range.length ? {
	        name: name,
	        range: range
	      } : null;
	    }
	
	    function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
	      var childVisuals = extend({}, visuals);
	
	      if (mapping) {
	        // Only support color, colorAlpha, colorSaturation.
	        var mappingType = mapping.type;
	        var colorMappingBy = mappingType === 'color' && inner$9(mapping).drColorMappingBy;
	        var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
	        childVisuals[mappingType] = mapping.mapValueToVisual(value);
	      }
	
	      return childVisuals;
	    }
	
	    var mathMax$7 = Math.max;
	    var mathMin$7 = Math.min;
	    var retrieveValue = retrieve;
	    var each$4 = each;
	    var PATH_BORDER_WIDTH = ['itemStyle', 'borderWidth'];
	    var PATH_GAP_WIDTH = ['itemStyle', 'gapWidth'];
	    var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'show'];
	    var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'height'];
	    /**
	     * @public
	     */
	
	    var treemapLayout = {
	      seriesType: 'treemap',
	      reset: function (seriesModel, ecModel, api, payload) {
	        // Layout result in each node:
	        // {x, y, width, height, area, borderWidth}
	        var ecWidth = api.getWidth();
	        var ecHeight = api.getHeight();
	        var seriesOption = seriesModel.option;
	        var layoutInfo = getLayoutRect(seriesModel.getBoxLayoutParams(), {
	          width: api.getWidth(),
	          height: api.getHeight()
	        });
	        var size = seriesOption.size || []; // Compatible with ec2.
	
	        var containerWidth = parsePercent$1(retrieveValue(layoutInfo.width, size[0]), ecWidth);
	        var containerHeight = parsePercent$1(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.
	
	        var payloadType = payload && payload.type;
	        var types = ['treemapZoomToNode', 'treemapRootToNode'];
	        var targetInfo = retrieveTargetInfo(payload, types, seriesModel);
	        var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
	        var viewRoot = seriesModel.getViewRoot();
	        var viewAbovePath = getPathToRoot(viewRoot);
	
	        if (payloadType !== 'treemapMove') {
	          var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
	          var sort_1 = seriesOption.sort;
	
	          if (sort_1 && sort_1 !== 'asc' && sort_1 !== 'desc') {
	            // Default to be desc order.
	            sort_1 = 'desc';
	          }
	
	          var options = {
	            squareRatio: seriesOption.squareRatio,
	            sort: sort_1,
	            leafDepth: seriesOption.leafDepth
	          }; // layout should be cleared because using updateView but not update.
	
	          viewRoot.hostTree.clearLayouts(); // TODO
	          // optimize: if out of view clip, do not layout.
	          // But take care that if do not render node out of view clip,
	          // how to calculate start po
	
	          var viewRootLayout_1 = {
	            x: 0,
	            y: 0,
	            width: rootSize[0],
	            height: rootSize[1],
	            area: rootSize[0] * rootSize[1]
	          };
	          viewRoot.setLayout(viewRootLayout_1);
	          squarify(viewRoot, options, false, 0); // Supplement layout.
	
	          viewRootLayout_1 = viewRoot.getLayout();
	          each$4(viewAbovePath, function (node, index) {
	            var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
	            node.setLayout(extend({
	              dataExtent: [childValue, childValue],
	              borderWidth: 0,
	              upperHeight: 0
	            }, viewRootLayout_1));
	          });
	        }
	
	        var treeRoot = seriesModel.getData().tree.root;
	        treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
	        seriesModel.setLayoutInfo(layoutInfo); // FIXME
	        // 现在没有clip功能，暂时取ec高宽。
	
	        prunning(treeRoot, // Transform to base element coordinate system.
	        new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
	      }
	    };
	    /**
	     * Layout treemap with squarify algorithm.
	     * The original presentation of this algorithm
	     * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
	     * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
	     * The implementation of this algorithm was originally copied from "d3.js"
	     * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
	     * with some modifications made for this program.
	     * See the license statement at the head of this file.
	     *
	     * @protected
	     * @param {module:echarts/data/Tree~TreeNode} node
	     * @param {Object} options
	     * @param {string} options.sort 'asc' or 'desc'
	     * @param {number} options.squareRatio
	     * @param {boolean} hideChildren
	     * @param {number} depth
	     */
	
	    function squarify(node, options, hideChildren, depth) {
	      var width;
	      var height;
	
	      if (node.isRemoved()) {
	        return;
	      }
	
	      var thisLayout = node.getLayout();
	      width = thisLayout.width;
	      height = thisLayout.height; // Considering border and gap
	
	      var nodeModel = node.getModel();
	      var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
	      var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
	      var upperLabelHeight = getUpperLabelHeight(nodeModel);
	      var upperHeight = Math.max(borderWidth, upperLabelHeight);
	      var layoutOffset = borderWidth - halfGapWidth;
	      var layoutOffsetUpper = upperHeight - halfGapWidth;
	      node.setLayout({
	        borderWidth: borderWidth,
	        upperHeight: upperHeight,
	        upperLabelHeight: upperLabelHeight
	      }, true);
	      width = mathMax$7(width - 2 * layoutOffset, 0);
	      height = mathMax$7(height - layoutOffset - layoutOffsetUpper, 0);
	      var totalArea = width * height;
	      var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
	
	      if (!viewChildren.length) {
	        return;
	      }
	
	      var rect = {
	        x: layoutOffset,
	        y: layoutOffsetUpper,
	        width: width,
	        height: height
	      };
	      var rowFixedLength = mathMin$7(width, height);
	      var best = Infinity; // the best row score so far
	
	      var row = [];
	      row.area = 0;
	
	      for (var i = 0, len = viewChildren.length; i < len;) {
	        var child = viewChildren[i];
	        row.push(child);
	        row.area += child.getLayout().area;
	        var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation
	
	        if (score <= best) {
	          i++;
	          best = score;
	        } // abort, and try a different orientation
	        else {
	            row.area -= row.pop().getLayout().area;
	            position(row, rowFixedLength, rect, halfGapWidth, false);
	            rowFixedLength = mathMin$7(rect.width, rect.height);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	      }
	
	      if (row.length) {
	        position(row, rowFixedLength, rect, halfGapWidth, true);
	      }
	
	      if (!hideChildren) {
	        var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
	
	        if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
	          hideChildren = true;
	        }
	      }
	
	      for (var i = 0, len = viewChildren.length; i < len; i++) {
	        squarify(viewChildren[i], options, hideChildren, depth + 1);
	      }
	    }
	    /**
	     * Set area to each child, and calculate data extent for visual coding.
	     */
	
	
	    function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
	      var viewChildren = node.children || [];
	      var orderBy = options.sort;
	      orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
	      var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.
	
	      if (hideChildren && !overLeafDepth) {
	        return node.viewChildren = [];
	      } // Sort children, order by desc.
	
	
	      viewChildren = filter(viewChildren, function (child) {
	        return !child.isRemoved();
	      });
	      sort$1(viewChildren, orderBy);
	      var info = statistic(nodeModel, viewChildren, orderBy);
	
	      if (info.sum === 0) {
	        return node.viewChildren = [];
	      }
	
	      info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
	
	      if (info.sum === 0) {
	        return node.viewChildren = [];
	      } // Set area to each child.
	
	
	      for (var i = 0, len = viewChildren.length; i < len; i++) {
	        var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.
	
	        viewChildren[i].setLayout({
	          area: area
	        });
	      }
	
	      if (overLeafDepth) {
	        viewChildren.length && node.setLayout({
	          isLeafRoot: true
	        }, true);
	        viewChildren.length = 0;
	      }
	
	      node.viewChildren = viewChildren;
	      node.setLayout({
	        dataExtent: info.dataExtent
	      }, true);
	      return viewChildren;
	    }
	    /**
	     * Consider 'visibleMin'. Modify viewChildren and get new sum.
	     */
	
	
	    function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
	      // visibleMin is not supported yet when no option.sort.
	      if (!orderBy) {
	        return sum;
	      }
	
	      var visibleMin = nodeModel.get('visibleMin');
	      var len = orderedChildren.length;
	      var deletePoint = len; // Always travel from little value to big value.
	
	      for (var i = len - 1; i >= 0; i--) {
	        var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
	
	        if (value / sum * totalArea < visibleMin) {
	          deletePoint = i;
	          sum -= value;
	        }
	      }
	
	      orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
	      return sum;
	    }
	    /**
	     * Sort
	     */
	
	
	    function sort$1(viewChildren, orderBy) {
	      if (orderBy) {
	        viewChildren.sort(function (a, b) {
	          var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
	          return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
	        });
	      }
	
	      return viewChildren;
	    }
	    /**
	     * Statistic
	     */
	
	
	    function statistic(nodeModel, children, orderBy) {
	      // Calculate sum.
	      var sum = 0;
	
	      for (var i = 0, len = children.length; i < len; i++) {
	        sum += children[i].getValue();
	      } // Statistic data extent for latter visual coding.
	      // Notice: data extent should be calculate based on raw children
	      // but not filtered view children, otherwise visual mapping will not
	      // be stable when zoom (where children is filtered by visibleMin).
	
	
	      var dimension = nodeModel.get('visualDimension');
	      var dataExtent; // The same as area dimension.
	
	      if (!children || !children.length) {
	        dataExtent = [NaN, NaN];
	      } else if (dimension === 'value' && orderBy) {
	        dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
	        orderBy === 'asc' && dataExtent.reverse();
	      } // Other dimension.
	      else {
	          dataExtent = [Infinity, -Infinity];
	          each$4(children, function (child) {
	            var value = child.getValue(dimension);
	            value < dataExtent[0] && (dataExtent[0] = value);
	            value > dataExtent[1] && (dataExtent[1] = value);
	          });
	        }
	
	      return {
	        sum: sum,
	        dataExtent: dataExtent
	      };
	    }
	    /**
	     * Computes the score for the specified row,
	     * as the worst aspect ratio.
	     */
	
	
	    function worst(row, rowFixedLength, ratio) {
	      var areaMax = 0;
	      var areaMin = Infinity;
	
	      for (var i = 0, area = void 0, len = row.length; i < len; i++) {
	        area = row[i].getLayout().area;
	
	        if (area) {
	          area < areaMin && (areaMin = area);
	          area > areaMax && (areaMax = area);
	        }
	      }
	
	      var squareArea = row.area * row.area;
	      var f = rowFixedLength * rowFixedLength * ratio;
	      return squareArea ? mathMax$7(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
	    }
	    /**
	     * Positions the specified row of nodes. Modifies `rect`.
	     */
	
	
	    function position(row, rowFixedLength, rect, halfGapWidth, flush) {
	      // When rowFixedLength === rect.width,
	      // it is horizontal subdivision,
	      // rowFixedLength is the width of the subdivision,
	      // rowOtherLength is the height of the subdivision,
	      // and nodes will be positioned from left to right.
	      // wh[idx0WhenH] means: when horizontal,
	      //      wh[idx0WhenH] => wh[0] => 'width'.
	      //      xy[idx1WhenH] => xy[1] => 'y'.
	      var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
	      var idx1WhenH = 1 - idx0WhenH;
	      var xy = ['x', 'y'];
	      var wh = ['width', 'height'];
	      var last = rect[xy[idx0WhenH]];
	      var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
	
	      if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
	        rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
	      }
	
	      for (var i = 0, rowLen = row.length; i < rowLen; i++) {
	        var node = row[i];
	        var nodeLayout = {};
	        var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
	        var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax$7(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.
	
	        var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
	        var modWH = i === rowLen - 1 || remain < step ? remain : step;
	        var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax$7(modWH - 2 * halfGapWidth, 0);
	        nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin$7(halfGapWidth, wh1 / 2);
	        nodeLayout[xy[idx0WhenH]] = last + mathMin$7(halfGapWidth, wh0 / 2);
	        last += modWH;
	        node.setLayout(nodeLayout, true);
	      }
	
	      rect[xy[idx1WhenH]] += rowOtherLength;
	      rect[wh[idx1WhenH]] -= rowOtherLength;
	    } // Return [containerWidth, containerHeight] as default.
	
	
	    function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
	      // If targetInfo.node exists, we zoom to the node,
	      // so estimate whole width and height by target node.
	      var currNode = (targetInfo || {}).node;
	      var defaultSize = [containerWidth, containerHeight];
	
	      if (!currNode || currNode === viewRoot) {
	        return defaultSize;
	      }
	
	      var parent;
	      var viewArea = containerWidth * containerHeight;
	      var area = viewArea * seriesModel.option.zoomToNodeRatio;
	
	      while (parent = currNode.parentNode) {
	        // jshint ignore:line
	        var sum = 0;
	        var siblings = parent.children;
	
	        for (var i = 0, len = siblings.length; i < len; i++) {
	          sum += siblings[i].getValue();
	        }
	
	        var currNodeValue = currNode.getValue();
	
	        if (currNodeValue === 0) {
	          return defaultSize;
	        }
	
	        area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.
	
	        var parentModel = parent.getModel();
	        var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
	        var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel));
	        area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
	        area > MAX_SAFE_INTEGER && (area = MAX_SAFE_INTEGER);
	        currNode = parent;
	      }
	
	      area < viewArea && (area = viewArea);
	      var scale = Math.pow(area / viewArea, 0.5);
	      return [containerWidth * scale, containerHeight * scale];
	    } // Root position based on coord of containerGroup
	
	
	    function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
	      if (rootRect) {
	        return {
	          x: rootRect.x,
	          y: rootRect.y
	        };
	      }
	
	      var defaultPosition = {
	        x: 0,
	        y: 0
	      };
	
	      if (!targetInfo) {
	        return defaultPosition;
	      } // If targetInfo is fetched by 'retrieveTargetInfo',
	      // old tree and new tree are the same tree,
	      // so the node still exists and we can visit it.
	
	
	      var targetNode = targetInfo.node;
	      var layout = targetNode.getLayout();
	
	      if (!layout) {
	        return defaultPosition;
	      } // Transform coord from local to container.
	
	
	      var targetCenter = [layout.width / 2, layout.height / 2];
	      var node = targetNode;
	
	      while (node) {
	        var nodeLayout = node.getLayout();
	        targetCenter[0] += nodeLayout.x;
	        targetCenter[1] += nodeLayout.y;
	        node = node.parentNode;
	      }
	
	      return {
	        x: layoutInfo.width / 2 - targetCenter[0],
	        y: layoutInfo.height / 2 - targetCenter[1]
	      };
	    } // Mark nodes visible for prunning when visual coding and rendering.
	    // Prunning depends on layout and root position, so we have to do it after layout.
	
	
	    function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
	      var nodeLayout = node.getLayout();
	      var nodeInViewAbovePath = viewAbovePath[depth];
	      var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
	
	      if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
	        return;
	      }
	
	      node.setLayout({
	        // isInView means: viewRoot sub tree + viewAbovePath
	        isInView: true,
	        // invisible only means: outside view clip so that the node can not
	        // see but still layout for animation preparation but not render.
	        invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
	        isAboveViewRoot: isAboveViewRoot
	      }, true); // Transform to child coordinate.
	
	      var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
	      each$4(node.viewChildren || [], function (child) {
	        prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
	      });
	    }
	
	    function getUpperLabelHeight(model) {
	      return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
	    }
	
	    function install$c(registers) {
	      registers.registerSeriesModel(TreemapSeriesModel);
	      registers.registerChartView(TreemapView);
	      registers.registerVisual(treemapVisual);
	      registers.registerLayout(treemapLayout);
	      installTreemapAction(registers);
	    }
	
	    function categoryFilter(ecModel) {
	      var legendModels = ecModel.findComponents({
	        mainType: 'legend'
	      });
	
	      if (!legendModels || !legendModels.length) {
	        return;
	      }
	
	      ecModel.eachSeriesByType('graph', function (graphSeries) {
	        var categoriesData = graphSeries.getCategoriesData();
	        var graph = graphSeries.getGraph();
	        var data = graph.data;
	        var categoryNames = categoriesData.mapArray(categoriesData.getName);
	        data.filterSelf(function (idx) {
	          var model = data.getItemModel(idx);
	          var category = model.getShallow('category');
	
	          if (category != null) {
	            if (isNumber(category)) {
	              category = categoryNames[category];
	            } // If in any legend component the status is not selected.
	
	
	            for (var i = 0; i < legendModels.length; i++) {
	              if (!legendModels[i].isSelected(category)) {
	                return false;
	              }
	            }
	          }
	
	          return true;
	        });
	      });
	    }
	
	    function categoryVisual(ecModel) {
	      var paletteScope = {};
	      ecModel.eachSeriesByType('graph', function (seriesModel) {
	        var categoriesData = seriesModel.getCategoriesData();
	        var data = seriesModel.getData();
	        var categoryNameIdxMap = {};
	        categoriesData.each(function (idx) {
	          var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.
	
	          categoryNameIdxMap['ec-' + name] = idx;
	          var itemModel = categoriesData.getItemModel(idx);
	          var style = itemModel.getModel('itemStyle').getItemStyle();
	
	          if (!style.fill) {
	            // Get color from palette.
	            style.fill = seriesModel.getColorFromPalette(name, paletteScope);
	          }
	
	          categoriesData.setItemVisual(idx, 'style', style);
	          var symbolVisualList = ['symbol', 'symbolSize', 'symbolKeepAspect'];
	
	          for (var i = 0; i < symbolVisualList.length; i++) {
	            var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);
	
	            if (symbolVisual != null) {
	              categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
	            }
	          }
	        }); // Assign category color to visual
	
	        if (categoriesData.count()) {
	          data.each(function (idx) {
	            var model = data.getItemModel(idx);
	            var categoryIdx = model.getShallow('category');
	
	            if (categoryIdx != null) {
	              if (isString(categoryIdx)) {
	                categoryIdx = categoryNameIdxMap['ec-' + categoryIdx];
	              }
	
	              var categoryStyle = categoriesData.getItemVisual(categoryIdx, 'style');
	              var style = data.ensureUniqueItemVisual(idx, 'style');
	              extend(style, categoryStyle);
	              var visualList = ['symbol', 'symbolSize', 'symbolKeepAspect'];
	
	              for (var i = 0; i < visualList.length; i++) {
	                data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
	              }
	            }
	          });
	        }
	      });
	    }
	
	    function normalize$2(a) {
	      if (!(a instanceof Array)) {
	        a = [a, a];
	      }
	
	      return a;
	    }
	
	    function graphEdgeVisual(ecModel) {
	      ecModel.eachSeriesByType('graph', function (seriesModel) {
	        var graph = seriesModel.getGraph();
	        var edgeData = seriesModel.getEdgeData();
	        var symbolType = normalize$2(seriesModel.get('edgeSymbol'));
	        var symbolSize = normalize$2(seriesModel.get('edgeSymbolSize')); // const colorQuery = ['lineStyle', 'color'] as const;
	        // const opacityQuery = ['lineStyle', 'opacity'] as const;
	
	        edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
	        edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
	        edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	        edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	        edgeData.setVisual('style', seriesModel.getModel('lineStyle').getLineStyle());
	        edgeData.each(function (idx) {
	          var itemModel = edgeData.getItemModel(idx);
	          var edge = graph.getEdgeByIndex(idx);
	          var symbolType = normalize$2(itemModel.getShallow('symbol', true));
	          var symbolSize = normalize$2(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual
	
	          var style = itemModel.getModel('lineStyle').getLineStyle();
	          var existsStyle = edgeData.ensureUniqueItemVisual(idx, 'style');
	          extend(existsStyle, style);
	
	          switch (existsStyle.stroke) {
	            case 'source':
	              {
	                var nodeStyle = edge.node1.getVisual('style');
	                existsStyle.stroke = nodeStyle && nodeStyle.fill;
	                break;
	              }
	
	            case 'target':
	              {
	                var nodeStyle = edge.node2.getVisual('style');
	                existsStyle.stroke = nodeStyle && nodeStyle.fill;
	                break;
	              }
	          }
	
	          symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
	          symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
	          symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
	          symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
	        });
	      });
	    }
	
	    var KEY_DELIMITER = '-->';
	    /**
	     * params handler
	     * @param {module:echarts/model/SeriesModel} seriesModel
	     * @returns {*}
	     */
	
	    var getAutoCurvenessParams = function (seriesModel) {
	      return seriesModel.get('autoCurveness') || null;
	    };
	    /**
	     * Generate a list of edge curvatures, 20 is the default
	     * @param {module:echarts/model/SeriesModel} seriesModel
	     * @param {number} appendLength
	     * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
	     */
	
	
	    var createCurveness = function (seriesModel, appendLength) {
	      var autoCurvenessParmas = getAutoCurvenessParams(seriesModel);
	      var length = 20;
	      var curvenessList = []; // handler the function set
	
	      if (isNumber(autoCurvenessParmas)) {
	        length = autoCurvenessParmas;
	      } else if (isArray(autoCurvenessParmas)) {
	        seriesModel.__curvenessList = autoCurvenessParmas;
	        return;
	      } // append length
	
	
	      if (appendLength > length) {
	        length = appendLength;
	      } // make sure the length is even
	
	
	      var len = length % 2 ? length + 2 : length + 3;
	      curvenessList = [];
	
	      for (var i = 0; i < len; i++) {
	        curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
	      }
	
	      seriesModel.__curvenessList = curvenessList;
	    };
	    /**
	     * Create different cache key data in the positive and negative directions, in order to set the curvature later
	     * @param {number|string|module:echarts/data/Graph.Node} n1
	     * @param {number|string|module:echarts/data/Graph.Node} n2
	     * @param {module:echarts/model/SeriesModel} seriesModel
	     * @returns {string} key
	     */
	
	
	    var getKeyOfEdges = function (n1, n2, seriesModel) {
	      var source = [n1.id, n1.dataIndex].join('.');
	      var target = [n2.id, n2.dataIndex].join('.');
	      return [seriesModel.uid, source, target].join(KEY_DELIMITER);
	    };
	    /**
	     * get opposite key
	     * @param {string} key
	     * @returns {string}
	     */
	
	
	    var getOppositeKey = function (key) {
	      var keys = key.split(KEY_DELIMITER);
	      return [keys[0], keys[2], keys[1]].join(KEY_DELIMITER);
	    };
	    /**
	     * get edgeMap with key
	     * @param edge
	     * @param {module:echarts/model/SeriesModel} seriesModel
	     */
	
	
	    var getEdgeFromMap = function (edge, seriesModel) {
	      var key = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	      return seriesModel.__edgeMap[key];
	    };
	    /**
	     * calculate all cases total length
	     * @param edge
	     * @param seriesModel
	     * @returns {number}
	     */
	
	
	    var getTotalLengthBetweenNodes = function (edge, seriesModel) {
	      var len = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
	      var lenV = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
	      return len + lenV;
	    };
	    /**
	     *
	     * @param key
	     */
	
	
	    var getEdgeMapLengthWithKey = function (key, seriesModel) {
	      var edgeMap = seriesModel.__edgeMap;
	      return edgeMap[key] ? edgeMap[key].length : 0;
	    };
	    /**
	     * Count the number of edges between the same two points, used to obtain the curvature table and the parity of the edge
	     * @see /graph/GraphSeries.js@getInitialData
	     * @param {module:echarts/model/SeriesModel} seriesModel
	     */
	
	
	    function initCurvenessList(seriesModel) {
	      if (!getAutoCurvenessParams(seriesModel)) {
	        return;
	      }
	
	      seriesModel.__curvenessList = [];
	      seriesModel.__edgeMap = {}; // calc the array of curveness List
	
	      createCurveness(seriesModel);
	    }
	    /**
	     * set edgeMap with key
	     * @param {number|string|module:echarts/data/Graph.Node} n1
	     * @param {number|string|module:echarts/data/Graph.Node} n2
	     * @param {module:echarts/model/SeriesModel} seriesModel
	     * @param {number} index
	     */
	
	    function createEdgeMapForCurveness(n1, n2, seriesModel, index) {
	      if (!getAutoCurvenessParams(seriesModel)) {
	        return;
	      }
	
	      var key = getKeyOfEdges(n1, n2, seriesModel);
	      var edgeMap = seriesModel.__edgeMap;
	      var oppositeEdges = edgeMap[getOppositeKey(key)]; // set direction
	
	      if (edgeMap[key] && !oppositeEdges) {
	        edgeMap[key].isForward = true;
	      } else if (oppositeEdges && edgeMap[key]) {
	        oppositeEdges.isForward = true;
	        edgeMap[key].isForward = false;
	      }
	
	      edgeMap[key] = edgeMap[key] || [];
	      edgeMap[key].push(index);
	    }
	    /**
	     * get curvature for edge
	     * @param edge
	     * @param {module:echarts/model/SeriesModel} seriesModel
	     * @param index
	     */
	
	    function getCurvenessForEdge(edge, seriesModel, index, needReverse) {
	      var autoCurvenessParams = getAutoCurvenessParams(seriesModel);
	      var isArrayParam = isArray(autoCurvenessParams);
	
	      if (!autoCurvenessParams) {
	        return null;
	      }
	
	      var edgeArray = getEdgeFromMap(edge, seriesModel);
	
	      if (!edgeArray) {
	        return null;
	      }
	
	      var edgeIndex = -1;
	
	      for (var i = 0; i < edgeArray.length; i++) {
	        if (edgeArray[i] === index) {
	          edgeIndex = i;
	          break;
	        }
	      } // if totalLen is Longer createCurveness
	
	
	      var totalLen = getTotalLengthBetweenNodes(edge, seriesModel);
	      createCurveness(seriesModel, totalLen);
	      edge.lineStyle = edge.lineStyle || {}; // if is opposite edge, must set curvenss to opposite number
	
	      var curKey = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	      var curvenessList = seriesModel.__curvenessList; // if pass array no need parity
	
	      var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
	
	      if (!edgeArray.isForward) {
	        // the opposite edge show outside
	        var oppositeKey = getOppositeKey(curKey);
	        var len = getEdgeMapLengthWithKey(oppositeKey, seriesModel);
	        var resValue = curvenessList[edgeIndex + len + parityCorrection]; // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
	
	        if (needReverse) {
	          // set as array may make the parity handle with the len of opposite
	          if (isArrayParam) {
	            if (autoCurvenessParams && autoCurvenessParams[0] === 0) {
	              return (len + parityCorrection) % 2 ? resValue : -resValue;
	            } else {
	              return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
	            }
	          } else {
	            return (len + parityCorrection) % 2 ? resValue : -resValue;
	          }
	        } else {
	          return curvenessList[edgeIndex + len + parityCorrection];
	        }
	      } else {
	        return curvenessList[parityCorrection + edgeIndex];
	      }
	    }
	
	    function simpleLayout(seriesModel) {
	      var coordSys = seriesModel.coordinateSystem;
	
	      if (coordSys && coordSys.type !== 'view') {
	        return;
	      }
	
	      var graph = seriesModel.getGraph();
	      graph.eachNode(function (node) {
	        var model = node.getModel();
	        node.setLayout([+model.get('x'), +model.get('y')]);
	      });
	      simpleLayoutEdge(graph, seriesModel);
	    }
	    function simpleLayoutEdge(graph, seriesModel) {
	      graph.eachEdge(function (edge, index) {
	        var curveness = retrieve3(edge.getModel().get(['lineStyle', 'curveness']), -getCurvenessForEdge(edge, seriesModel, index, true), 0);
	        var p1 = clone$1(edge.node1.getLayout());
	        var p2 = clone$1(edge.node2.getLayout());
	        var points = [p1, p2];
	
	        if (+curveness) {
	          points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
	        }
	
	        edge.setLayout(points);
	      });
	    }
	
	    function graphSimpleLayout(ecModel, api) {
	      ecModel.eachSeriesByType('graph', function (seriesModel) {
	        var layout = seriesModel.get('layout');
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (coordSys && coordSys.type !== 'view') {
	          var data_1 = seriesModel.getData();
	          var dimensions_1 = [];
	          each(coordSys.dimensions, function (coordDim) {
	            dimensions_1 = dimensions_1.concat(data_1.mapDimensionsAll(coordDim));
	          });
	
	          for (var dataIndex = 0; dataIndex < data_1.count(); dataIndex++) {
	            var value = [];
	            var hasValue = false;
	
	            for (var i = 0; i < dimensions_1.length; i++) {
	              var val = data_1.get(dimensions_1[i], dataIndex);
	
	              if (!isNaN(val)) {
	                hasValue = true;
	              }
	
	              value.push(val);
	            }
	
	            if (hasValue) {
	              data_1.setItemLayout(dataIndex, coordSys.dataToPoint(value));
	            } else {
	              // Also {Array.<number>}, not undefined to avoid if...else... statement
	              data_1.setItemLayout(dataIndex, [NaN, NaN]);
	            }
	          }
	
	          simpleLayoutEdge(data_1.graph, seriesModel);
	        } else if (!layout || layout === 'none') {
	          simpleLayout(seriesModel);
	        }
	      });
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function getNodeGlobalScale(seriesModel) {
	      var coordSys = seriesModel.coordinateSystem;
	
	      if (coordSys.type !== 'view') {
	        return 1;
	      }
	
	      var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
	      var groupZoom = coordSys.scaleX; // Scale node when zoom changes
	
	      var roamZoom = coordSys.getZoom();
	      var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	      return nodeScale / groupZoom;
	    }
	    function getSymbolSize(node) {
	      var symbolSize = node.getVisual('symbolSize');
	
	      if (symbolSize instanceof Array) {
	        symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
	      }
	
	      return +symbolSize;
	    }
	
	    var PI$6 = Math.PI;
	    var _symbolRadiansHalf = [];
	    /**
	     * `basedOn` can be:
	     * 'value':
	     *     This layout is not accurate and have same bad case. For example,
	     *     if the min value is very smaller than the max value, the nodes
	     *     with the min value probably overlap even though there is enough
	     *     space to layout them. So we only use this approach in the as the
	     *     init layout of the force layout.
	     *     FIXME
	     *     Probably we do not need this method any more but use
	     *     `basedOn: 'symbolSize'` in force layout if
	     *     delay its init operations to GraphView.
	     * 'symbolSize':
	     *     This approach work only if all of the symbol size calculated.
	     *     That is, the progressive rendering is not applied to graph.
	     *     FIXME
	     *     If progressive rendering is applied to graph some day,
	     *     probably we have to use `basedOn: 'value'`.
	     */
	
	    function circularLayout(seriesModel, basedOn, draggingNode, pointer) {
	      var coordSys = seriesModel.coordinateSystem;
	
	      if (coordSys && coordSys.type !== 'view') {
	        return;
	      }
	
	      var rect = coordSys.getBoundingRect();
	      var nodeData = seriesModel.getData();
	      var graph = nodeData.graph;
	      var cx = rect.width / 2 + rect.x;
	      var cy = rect.height / 2 + rect.y;
	      var r = Math.min(rect.width, rect.height) / 2;
	      var count = nodeData.count();
	      nodeData.setLayout({
	        cx: cx,
	        cy: cy
	      });
	
	      if (!count) {
	        return;
	      }
	
	      if (draggingNode) {
	        var _a = coordSys.pointToData(pointer),
	            tempX = _a[0],
	            tempY = _a[1];
	
	        var v = [tempX - cx, tempY - cy];
	        normalize(v, v);
	        scale(v, v, r);
	        draggingNode.setLayout([cx + v[0], cy + v[1]], true);
	        var circularRotateLabel = seriesModel.get(['circular', 'rotateLabel']);
	        rotateNodeLabel(draggingNode, circularRotateLabel, cx, cy);
	      }
	
	      _layoutNodesBasedOn[basedOn](seriesModel, graph, nodeData, r, cx, cy, count);
	
	      graph.eachEdge(function (edge, index) {
	        var curveness = retrieve3(edge.getModel().get(['lineStyle', 'curveness']), getCurvenessForEdge(edge, seriesModel, index), 0);
	        var p1 = clone$1(edge.node1.getLayout());
	        var p2 = clone$1(edge.node2.getLayout());
	        var cp1;
	        var x12 = (p1[0] + p2[0]) / 2;
	        var y12 = (p1[1] + p2[1]) / 2;
	
	        if (+curveness) {
	          curveness *= 3;
	          cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
	        }
	
	        edge.setLayout([p1, p2, cp1]);
	      });
	    }
	    var _layoutNodesBasedOn = {
	      value: function (seriesModel, graph, nodeData, r, cx, cy, count) {
	        var angle = 0;
	        var sum = nodeData.getSum('value');
	        var unitAngle = Math.PI * 2 / (sum || count);
	        graph.eachNode(function (node) {
	          var value = node.getValue('value');
	          var radianHalf = unitAngle * (sum ? value : 1) / 2;
	          angle += radianHalf;
	          node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	          angle += radianHalf;
	        });
	      },
	      symbolSize: function (seriesModel, graph, nodeData, r, cx, cy, count) {
	        var sumRadian = 0;
	        _symbolRadiansHalf.length = count;
	        var nodeScale = getNodeGlobalScale(seriesModel);
	        graph.eachNode(function (node) {
	          var symbolSize = getSymbolSize(node); // Normally this case will not happen, but we still add
	          // some the defensive code (2px is an arbitrary value).
	
	          isNaN(symbolSize) && (symbolSize = 2);
	          symbolSize < 0 && (symbolSize = 0);
	          symbolSize *= nodeScale;
	          var symbolRadianHalf = Math.asin(symbolSize / 2 / r); // when `symbolSize / 2` is bigger than `r`.
	
	          isNaN(symbolRadianHalf) && (symbolRadianHalf = PI$6 / 2);
	          _symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
	          sumRadian += symbolRadianHalf * 2;
	        });
	        var halfRemainRadian = (2 * PI$6 - sumRadian) / count / 2;
	        var angle = 0;
	        graph.eachNode(function (node) {
	          var radianHalf = halfRemainRadian + _symbolRadiansHalf[node.dataIndex];
	          angle += radianHalf; // init circular layout for
	          // 1. layout undefined node
	          // 2. not fixed node
	
	          (!node.getLayout() || !node.getLayout().fixed) && node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	          angle += radianHalf;
	        });
	      }
	    };
	    function rotateNodeLabel(node, circularRotateLabel, cx, cy) {
	      var el = node.getGraphicEl(); // need to check if el exists. '-' value may not create node element.
	
	      if (!el) {
	        return;
	      }
	
	      var nodeModel = node.getModel();
	      var labelRotate = nodeModel.get(['label', 'rotate']) || 0;
	      var symbolPath = el.getSymbolPath();
	
	      if (circularRotateLabel) {
	        var pos = node.getLayout();
	        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
	
	        if (rad < 0) {
	          rad = Math.PI * 2 + rad;
	        }
	
	        var isLeft = pos[0] < cx;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	
	        var textPosition = isLeft ? 'left' : 'right';
	        symbolPath.setTextConfig({
	          rotation: -rad,
	          position: textPosition,
	          origin: 'center'
	        });
	        var emphasisState = symbolPath.ensureState('emphasis');
	        extend(emphasisState.textConfig || (emphasisState.textConfig = {}), {
	          position: textPosition
	        });
	      } else {
	        symbolPath.setTextConfig({
	          rotation: labelRotate *= Math.PI / 180
	        });
	      }
	    }
	
	    function graphCircularLayout(ecModel) {
	      ecModel.eachSeriesByType('graph', function (seriesModel) {
	        if (seriesModel.get('layout') === 'circular') {
	          circularLayout(seriesModel, 'symbolSize');
	        }
	      });
	    }
	
	    var scaleAndAdd$1 = scaleAndAdd; // function adjacentNode(n, e) {
	    //     return e.n1 === n ? e.n2 : e.n1;
	    // }
	
	    function forceLayout(inNodes, inEdges, opts) {
	      var nodes = inNodes;
	      var edges = inEdges;
	      var rect = opts.rect;
	      var width = rect.width;
	      var height = rect.height;
	      var center = [rect.x + width / 2, rect.y + height / 2]; // let scale = opts.scale || 1;
	
	      var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (let i = 0; i < edges.length; i++) {
	      //     let e = edges[i];
	      //     let n1 = e.n1;
	      //     let n2 = e.n2;
	      //     n1.edges = n1.edges || [];
	      //     n2.edges = n2.edges || [];
	      //     n1.edges.push(e);
	      //     n2.edges.push(e);
	      // }
	      // Init position
	
	      for (var i = 0; i < nodes.length; i++) {
	        var n = nodes[i];
	
	        if (!n.p) {
	          n.p = create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
	        }
	
	        n.pp = clone$1(n.p);
	        n.edges = null;
	      } // Formula in 'Graph Drawing by Force-directed Placement'
	      // let k = scale * Math.sqrt(width * height / nodes.length);
	      // let k2 = k * k;
	
	
	      var initialFriction = opts.friction == null ? 0.6 : opts.friction;
	      var friction = initialFriction;
	      var beforeStepCallback;
	      var afterStepCallback;
	      return {
	        warmUp: function () {
	          friction = initialFriction * 0.8;
	        },
	        setFixed: function (idx) {
	          nodes[idx].fixed = true;
	        },
	        setUnfixed: function (idx) {
	          nodes[idx].fixed = false;
	        },
	
	        /**
	         * Before step hook
	         */
	        beforeStep: function (cb) {
	          beforeStepCallback = cb;
	        },
	
	        /**
	         * After step hook
	         */
	        afterStep: function (cb) {
	          afterStepCallback = cb;
	        },
	
	        /**
	         * Some formulas were originally copied from "d3.js"
	         * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
	         * with some modifications made for this project.
	         * See the license statement at the head of this file.
	         */
	        step: function (cb) {
	          beforeStepCallback && beforeStepCallback(nodes, edges);
	          var v12 = [];
	          var nLen = nodes.length;
	
	          for (var i = 0; i < edges.length; i++) {
	            var e = edges[i];
	
	            if (e.ignoreForceLayout) {
	              continue;
	            }
	
	            var n1 = e.n1;
	            var n2 = e.n2;
	            sub(v12, n2.p, n1.p);
	            var d = len(v12) - e.d;
	            var w = n2.w / (n1.w + n2.w);
	
	            if (isNaN(w)) {
	              w = 0;
	            }
	
	            normalize(v12, v12);
	            !n1.fixed && scaleAndAdd$1(n1.p, n1.p, v12, w * d * friction);
	            !n2.fixed && scaleAndAdd$1(n2.p, n2.p, v12, -(1 - w) * d * friction);
	          } // Gravity
	
	
	          for (var i = 0; i < nLen; i++) {
	            var n = nodes[i];
	
	            if (!n.fixed) {
	              sub(v12, center, n.p); // let d = vec2.len(v12);
	              // vec2.scale(v12, v12, 1 / d);
	              // let gravityFactor = gravity;
	
	              scaleAndAdd$1(n.p, n.p, v12, gravity * friction);
	            }
	          } // Repulsive
	          // PENDING
	
	
	          for (var i = 0; i < nLen; i++) {
	            var n1 = nodes[i];
	
	            for (var j = i + 1; j < nLen; j++) {
	              var n2 = nodes[j];
	              sub(v12, n2.p, n1.p);
	              var d = len(v12);
	
	              if (d === 0) {
	                // Random repulse
	                set(v12, Math.random() - 0.5, Math.random() - 0.5);
	                d = 1;
	              }
	
	              var repFact = (n1.rep + n2.rep) / d / d;
	              !n1.fixed && scaleAndAdd$1(n1.pp, n1.pp, v12, repFact);
	              !n2.fixed && scaleAndAdd$1(n2.pp, n2.pp, v12, -repFact);
	            }
	          }
	
	          var v = [];
	
	          for (var i = 0; i < nLen; i++) {
	            var n = nodes[i];
	
	            if (!n.fixed) {
	              sub(v, n.p, n.pp);
	              scaleAndAdd$1(n.p, n.p, v, friction);
	              copy(n.pp, n.p);
	            }
	          }
	
	          friction = friction * 0.992;
	          var finished = friction < 0.01;
	          afterStepCallback && afterStepCallback(nodes, edges, finished);
	          cb && cb(finished);
	        }
	      };
	    }
	
	    function graphForceLayout(ecModel) {
	      ecModel.eachSeriesByType('graph', function (graphSeries) {
	        var coordSys = graphSeries.coordinateSystem;
	
	        if (coordSys && coordSys.type !== 'view') {
	          return;
	        }
	
	        if (graphSeries.get('layout') === 'force') {
	          var preservedPoints_1 = graphSeries.preservedPoints || {};
	          var graph_1 = graphSeries.getGraph();
	          var nodeData_1 = graph_1.data;
	          var edgeData = graph_1.edgeData;
	          var forceModel = graphSeries.getModel('force');
	          var initLayout = forceModel.get('initLayout');
	
	          if (graphSeries.preservedPoints) {
	            nodeData_1.each(function (idx) {
	              var id = nodeData_1.getId(idx);
	              nodeData_1.setItemLayout(idx, preservedPoints_1[id] || [NaN, NaN]);
	            });
	          } else if (!initLayout || initLayout === 'none') {
	            simpleLayout(graphSeries);
	          } else if (initLayout === 'circular') {
	            circularLayout(graphSeries, 'value');
	          }
	
	          var nodeDataExtent_1 = nodeData_1.getDataExtent('value');
	          var edgeDataExtent_1 = edgeData.getDataExtent('value'); // let edgeDataExtent = edgeData.getDataExtent('value');
	
	          var repulsion = forceModel.get('repulsion');
	          var edgeLength = forceModel.get('edgeLength');
	          var repulsionArr_1 = isArray(repulsion) ? repulsion : [repulsion, repulsion];
	          var edgeLengthArr_1 = isArray(edgeLength) ? edgeLength : [edgeLength, edgeLength]; // Larger value has smaller length
	
	          edgeLengthArr_1 = [edgeLengthArr_1[1], edgeLengthArr_1[0]];
	          var nodes_1 = nodeData_1.mapArray('value', function (value, idx) {
	            var point = nodeData_1.getItemLayout(idx);
	            var rep = linearMap(value, nodeDataExtent_1, repulsionArr_1);
	
	            if (isNaN(rep)) {
	              rep = (repulsionArr_1[0] + repulsionArr_1[1]) / 2;
	            }
	
	            return {
	              w: rep,
	              rep: rep,
	              fixed: nodeData_1.getItemModel(idx).get('fixed'),
	              p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
	            };
	          });
	          var edges = edgeData.mapArray('value', function (value, idx) {
	            var edge = graph_1.getEdgeByIndex(idx);
	            var d = linearMap(value, edgeDataExtent_1, edgeLengthArr_1);
	
	            if (isNaN(d)) {
	              d = (edgeLengthArr_1[0] + edgeLengthArr_1[1]) / 2;
	            }
	
	            var edgeModel = edge.getModel();
	            var curveness = retrieve3(edge.getModel().get(['lineStyle', 'curveness']), -getCurvenessForEdge(edge, graphSeries, idx, true), 0);
	            return {
	              n1: nodes_1[edge.node1.dataIndex],
	              n2: nodes_1[edge.node2.dataIndex],
	              d: d,
	              curveness: curveness,
	              ignoreForceLayout: edgeModel.get('ignoreForceLayout')
	            };
	          }); // let coordSys = graphSeries.coordinateSystem;
	
	          var rect = coordSys.getBoundingRect();
	          var forceInstance = forceLayout(nodes_1, edges, {
	            rect: rect,
	            gravity: forceModel.get('gravity'),
	            friction: forceModel.get('friction')
	          });
	          forceInstance.beforeStep(function (nodes, edges) {
	            for (var i = 0, l = nodes.length; i < l; i++) {
	              if (nodes[i].fixed) {
	                // Write back to layout instance
	                copy(nodes[i].p, graph_1.getNodeByIndex(i).getLayout());
	              }
	            }
	          });
	          forceInstance.afterStep(function (nodes, edges, stopped) {
	            for (var i = 0, l = nodes.length; i < l; i++) {
	              if (!nodes[i].fixed) {
	                graph_1.getNodeByIndex(i).setLayout(nodes[i].p);
	              }
	
	              preservedPoints_1[nodeData_1.getId(i)] = nodes[i].p;
	            }
	
	            for (var i = 0, l = edges.length; i < l; i++) {
	              var e = edges[i];
	              var edge = graph_1.getEdgeByIndex(i);
	              var p1 = e.n1.p;
	              var p2 = e.n2.p;
	              var points = edge.getLayout();
	              points = points ? points.slice() : [];
	              points[0] = points[0] || [];
	              points[1] = points[1] || [];
	              copy(points[0], p1);
	              copy(points[1], p2);
	
	              if (+e.curveness) {
	                points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
	              }
	
	              edge.setLayout(points);
	            }
	          });
	          graphSeries.forceLayout = forceInstance;
	          graphSeries.preservedPoints = preservedPoints_1; // Step to get the layout
	
	          forceInstance.step();
	        } else {
	          // Remove prev injected forceLayout instance
	          graphSeries.forceLayout = null;
	        }
	      });
	    }
	
	    function getViewRect$2(seriesModel, api, aspect) {
	      var option = extend(seriesModel.getBoxLayoutParams(), {
	        aspect: aspect
	      });
	      return getLayoutRect(option, {
	        width: api.getWidth(),
	        height: api.getHeight()
	      });
	    }
	
	    function createViewCoordSys(ecModel, api) {
	      var viewList = [];
	      ecModel.eachSeriesByType('graph', function (seriesModel) {
	        var coordSysType = seriesModel.get('coordinateSystem');
	
	        if (!coordSysType || coordSysType === 'view') {
	          var data_1 = seriesModel.getData();
	          var positions = data_1.mapArray(function (idx) {
	            var itemModel = data_1.getItemModel(idx);
	            return [+itemModel.get('x'), +itemModel.get('y')];
	          });
	          var min = [];
	          var max = [];
	          fromPoints(positions, min, max); // If width or height is 0
	
	          if (max[0] - min[0] === 0) {
	            max[0] += 1;
	            min[0] -= 1;
	          }
	
	          if (max[1] - min[1] === 0) {
	            max[1] += 1;
	            min[1] -= 1;
	          }
	
	          var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?
	
	          var viewRect = getViewRect$2(seriesModel, api, aspect); // Position may be NaN, use view rect instead
	
	          if (isNaN(aspect)) {
	            min = [viewRect.x, viewRect.y];
	            max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
	          }
	
	          var bbWidth = max[0] - min[0];
	          var bbHeight = max[1] - min[1];
	          var viewWidth = viewRect.width;
	          var viewHeight = viewRect.height;
	          var viewCoordSys = seriesModel.coordinateSystem = new View();
	          viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	          viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
	          viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info
	
	          viewCoordSys.setCenter(seriesModel.get('center'), api);
	          viewCoordSys.setZoom(seriesModel.get('zoom'));
	          viewList.push(viewCoordSys);
	        }
	      });
	      return viewList;
	    }
	
	    var straightLineProto = Line.prototype;
	    var bezierCurveProto = BezierCurve.prototype;
	
	    var StraightLineShape =
	    /** @class */
	    function () {
	      function StraightLineShape() {
	        // Start point
	        this.x1 = 0;
	        this.y1 = 0; // End point
	
	        this.x2 = 0;
	        this.y2 = 0;
	        this.percent = 1;
	      }
	
	      return StraightLineShape;
	    }();
	
	    var CurveShape =
	    /** @class */
	    function (_super) {
	      __extends(CurveShape, _super);
	
	      function CurveShape() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      return CurveShape;
	    }(StraightLineShape);
	
	    function isStraightLine(shape) {
	      return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
	    }
	
	    var ECLinePath =
	    /** @class */
	    function (_super) {
	      __extends(ECLinePath, _super);
	
	      function ECLinePath(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this.type = 'ec-line';
	        return _this;
	      }
	
	      ECLinePath.prototype.getDefaultStyle = function () {
	        return {
	          stroke: '#000',
	          fill: null
	        };
	      };
	
	      ECLinePath.prototype.getDefaultShape = function () {
	        return new StraightLineShape();
	      };
	
	      ECLinePath.prototype.buildPath = function (ctx, shape) {
	        if (isStraightLine(shape)) {
	          straightLineProto.buildPath.call(this, ctx, shape);
	        } else {
	          bezierCurveProto.buildPath.call(this, ctx, shape);
	        }
	      };
	
	      ECLinePath.prototype.pointAt = function (t) {
	        if (isStraightLine(this.shape)) {
	          return straightLineProto.pointAt.call(this, t);
	        } else {
	          return bezierCurveProto.pointAt.call(this, t);
	        }
	      };
	
	      ECLinePath.prototype.tangentAt = function (t) {
	        var shape = this.shape;
	        var p = isStraightLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : bezierCurveProto.tangentAt.call(this, t);
	        return normalize(p, p);
	      };
	
	      return ECLinePath;
	    }(Path);
	
	    var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];
	
	    function makeSymbolTypeKey(symbolCategory) {
	      return '_' + symbolCategory + 'Type';
	    }
	
	    function makeSymbolTypeValue(name, lineData, idx) {
	      var symbolType = lineData.getItemVisual(idx, name);
	
	      if (!symbolType || symbolType === 'none') {
	        return symbolType;
	      }
	
	      var symbolSize = lineData.getItemVisual(idx, name + 'Size');
	      var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
	      var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
	      var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
	      var symbolSizeArr = normalizeSymbolSize(symbolSize);
	      var symbolOffsetArr = normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
	      return symbolType + symbolSizeArr + symbolOffsetArr + (symbolRotate || '') + (symbolKeepAspect || '');
	    }
	    /**
	     * @inner
	     */
	
	
	    function createSymbol$1(name, lineData, idx) {
	      var symbolType = lineData.getItemVisual(idx, name);
	
	      if (!symbolType || symbolType === 'none') {
	        return;
	      }
	
	      var symbolSize = lineData.getItemVisual(idx, name + 'Size');
	      var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
	      var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
	      var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
	      var symbolSizeArr = normalizeSymbolSize(symbolSize);
	      var symbolOffsetArr = normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
	      var symbolPath = createSymbol(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
	      symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
	      symbolPath.name = name;
	      return symbolPath;
	    }
	
	    function createLine(points) {
	      var line = new ECLinePath({
	        name: 'line',
	        subPixelOptimize: true
	      });
	      setLinePoints(line.shape, points);
	      return line;
	    }
	
	    function setLinePoints(targetShape, points) {
	      targetShape.x1 = points[0][0];
	      targetShape.y1 = points[0][1];
	      targetShape.x2 = points[1][0];
	      targetShape.y2 = points[1][1];
	      targetShape.percent = 1;
	      var cp1 = points[2];
	
	      if (cp1) {
	        targetShape.cpx1 = cp1[0];
	        targetShape.cpy1 = cp1[1];
	      } else {
	        targetShape.cpx1 = NaN;
	        targetShape.cpy1 = NaN;
	      }
	    }
	
	    var Line$1 =
	    /** @class */
	    function (_super) {
	      __extends(Line, _super);
	
	      function Line(lineData, idx, seriesScope) {
	        var _this = _super.call(this) || this;
	
	        _this._createLine(lineData, idx, seriesScope);
	
	        return _this;
	      }
	
	      Line.prototype._createLine = function (lineData, idx, seriesScope) {
	        var seriesModel = lineData.hostModel;
	        var linePoints = lineData.getItemLayout(idx);
	        var line = createLine(linePoints);
	        line.shape.percent = 0;
	        initProps(line, {
	          shape: {
	            percent: 1
	          }
	        }, seriesModel, idx);
	        this.add(line);
	        each(SYMBOL_CATEGORIES, function (symbolCategory) {
	          var symbol = createSymbol$1(symbolCategory, lineData, idx); // symbols must added after line to make sure
	          // it will be updated after line#update.
	          // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
	
	          this.add(symbol);
	          this[makeSymbolTypeKey(symbolCategory)] = makeSymbolTypeValue(symbolCategory, lineData, idx);
	        }, this);
	
	        this._updateCommonStl(lineData, idx, seriesScope);
	      }; // TODO More strict on the List type in parameters?
	
	
	      Line.prototype.updateData = function (lineData, idx, seriesScope) {
	        var seriesModel = lineData.hostModel;
	        var line = this.childOfName('line');
	        var linePoints = lineData.getItemLayout(idx);
	        var target = {
	          shape: {}
	        };
	        setLinePoints(target.shape, linePoints);
	        updateProps(line, target, seriesModel, idx);
	        each(SYMBOL_CATEGORIES, function (symbolCategory) {
	          var symbolType = makeSymbolTypeValue(symbolCategory, lineData, idx);
	          var key = makeSymbolTypeKey(symbolCategory); // Symbol changed
	
	          if (this[key] !== symbolType) {
	            this.remove(this.childOfName(symbolCategory));
	            var symbol = createSymbol$1(symbolCategory, lineData, idx);
	            this.add(symbol);
	          }
	
	          this[key] = symbolType;
	        }, this);
	
	        this._updateCommonStl(lineData, idx, seriesScope);
	      };
	
	      Line.prototype.getLinePath = function () {
	        return this.childAt(0);
	      };
	
	      Line.prototype._updateCommonStl = function (lineData, idx, seriesScope) {
	        var seriesModel = lineData.hostModel;
	        var line = this.childOfName('line');
	        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
	        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
	        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
	        var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
	        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
	        var focus = seriesScope && seriesScope.focus;
	        var blurScope = seriesScope && seriesScope.blurScope; // Optimization for large dataset
	
	        if (!seriesScope || lineData.hasItemOption) {
	          var itemModel = lineData.getItemModel(idx);
	          var emphasisModel = itemModel.getModel('emphasis');
	          emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
	          blurLineStyle = itemModel.getModel(['blur', 'lineStyle']).getLineStyle();
	          selectLineStyle = itemModel.getModel(['select', 'lineStyle']).getLineStyle();
	          emphasisDisabled = emphasisModel.get('disabled');
	          focus = emphasisModel.get('focus');
	          blurScope = emphasisModel.get('blurScope');
	          labelStatesModels = getLabelStatesModels(itemModel);
	        }
	
	        var lineStyle = lineData.getItemVisual(idx, 'style');
	        var visualColor = lineStyle.stroke;
	        line.useStyle(lineStyle);
	        line.style.fill = null;
	        line.style.strokeNoScale = true;
	        line.ensureState('emphasis').style = emphasisLineStyle;
	        line.ensureState('blur').style = blurLineStyle;
	        line.ensureState('select').style = selectLineStyle; // Update symbol
	
	        each(SYMBOL_CATEGORIES, function (symbolCategory) {
	          var symbol = this.childOfName(symbolCategory);
	
	          if (symbol) {
	            // Share opacity and color with line.
	            symbol.setColor(visualColor);
	            symbol.style.opacity = lineStyle.opacity;
	
	            for (var i = 0; i < SPECIAL_STATES.length; i++) {
	              var stateName = SPECIAL_STATES[i];
	              var lineState = line.getState(stateName);
	
	              if (lineState) {
	                var lineStateStyle = lineState.style || {};
	                var state = symbol.ensureState(stateName);
	                var stateStyle = state.style || (state.style = {});
	
	                if (lineStateStyle.stroke != null) {
	                  stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
	                }
	
	                if (lineStateStyle.opacity != null) {
	                  stateStyle.opacity = lineStateStyle.opacity;
	                }
	              }
	            }
	
	            symbol.markRedraw();
	          }
	        }, this);
	        var rawVal = seriesModel.getRawValue(idx);
	        setLabelStyle(this, labelStatesModels, {
	          labelDataIndex: idx,
	          labelFetcher: {
	            getFormattedLabel: function (dataIndex, stateName) {
	              return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
	            }
	          },
	          inheritColor: visualColor || '#000',
	          defaultOpacity: lineStyle.opacity,
	          defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? round(rawVal) : rawVal) + ''
	        });
	        var label = this.getTextContent(); // Always set `textStyle` even if `normalStyle.text` is null, because default
	        // values have to be set on `normalStyle`.
	
	        if (label) {
	          var labelNormalModel = labelStatesModels.normal;
	          label.__align = label.style.align;
	          label.__verticalAlign = label.style.verticalAlign; // 'start', 'middle', 'end'
	
	          label.__position = labelNormalModel.get('position') || 'middle';
	          var distance = labelNormalModel.get('distance');
	
	          if (!isArray(distance)) {
	            distance = [distance, distance];
	          }
	
	          label.__labelDistance = distance;
	        }
	
	        this.setTextConfig({
	          position: null,
	          local: true,
	          inside: false // Can't be inside for stroke element.
	
	        });
	        toggleHoverEmphasis(this, focus, blurScope, emphasisDisabled);
	      };
	
	      Line.prototype.highlight = function () {
	        enterEmphasis(this);
	      };
	
	      Line.prototype.downplay = function () {
	        leaveEmphasis(this);
	      };
	
	      Line.prototype.updateLayout = function (lineData, idx) {
	        this.setLinePoints(lineData.getItemLayout(idx));
	      };
	
	      Line.prototype.setLinePoints = function (points) {
	        var linePath = this.childOfName('line');
	        setLinePoints(linePath.shape, points);
	        linePath.dirty();
	      };
	
	      Line.prototype.beforeUpdate = function () {
	        var lineGroup = this;
	        var symbolFrom = lineGroup.childOfName('fromSymbol');
	        var symbolTo = lineGroup.childOfName('toSymbol');
	        var label = lineGroup.getTextContent(); // Quick reject
	
	        if (!symbolFrom && !symbolTo && (!label || label.ignore)) {
	          return;
	        }
	
	        var invScale = 1;
	        var parentNode = this.parent;
	
	        while (parentNode) {
	          if (parentNode.scaleX) {
	            invScale /= parentNode.scaleX;
	          }
	
	          parentNode = parentNode.parent;
	        }
	
	        var line = lineGroup.childOfName('line'); // If line not changed
	        // FIXME Parent scale changed
	
	        if (!this.__dirty && !line.__dirty) {
	          return;
	        }
	
	        var percent = line.shape.percent;
	        var fromPos = line.pointAt(0);
	        var toPos = line.pointAt(percent);
	        var d = sub([], toPos, fromPos);
	        normalize(d, d);
	
	        function setSymbolRotation(symbol, percent) {
	          // Fix #12388
	          // when symbol is set to be 'arrow' in markLine,
	          // symbolRotate value will be ignored, and compulsively use tangent angle.
	          // rotate by default if symbol rotation is not specified
	          var specifiedRotation = symbol.__specifiedRotation;
	
	          if (specifiedRotation == null) {
	            var tangent = line.tangentAt(percent);
	            symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	          } else {
	            symbol.attr('rotation', specifiedRotation);
	          }
	        }
	
	        if (symbolFrom) {
	          symbolFrom.setPosition(fromPos);
	          setSymbolRotation(symbolFrom, 0);
	          symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
	          symbolFrom.markRedraw();
	        }
	
	        if (symbolTo) {
	          symbolTo.setPosition(toPos);
	          setSymbolRotation(symbolTo, 1);
	          symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
	          symbolTo.markRedraw();
	        }
	
	        if (label && !label.ignore) {
	          label.x = label.y = 0;
	          label.originX = label.originY = 0;
	          var textAlign = void 0;
	          var textVerticalAlign = void 0;
	          var distance = label.__labelDistance;
	          var distanceX = distance[0] * invScale;
	          var distanceY = distance[1] * invScale;
	          var halfPercent = percent / 2;
	          var tangent = line.tangentAt(halfPercent);
	          var n = [tangent[1], -tangent[0]];
	          var cp = line.pointAt(halfPercent);
	
	          if (n[1] > 0) {
	            n[0] = -n[0];
	            n[1] = -n[1];
	          }
	
	          var dir = tangent[0] < 0 ? -1 : 1;
	
	          if (label.__position !== 'start' && label.__position !== 'end') {
	            var rotation = -Math.atan2(tangent[1], tangent[0]);
	
	            if (toPos[0] < fromPos[0]) {
	              rotation = Math.PI + rotation;
	            }
	
	            label.rotation = rotation;
	          }
	
	          var dy = void 0;
	
	          switch (label.__position) {
	            case 'insideStartTop':
	            case 'insideMiddleTop':
	            case 'insideEndTop':
	            case 'middle':
	              dy = -distanceY;
	              textVerticalAlign = 'bottom';
	              break;
	
	            case 'insideStartBottom':
	            case 'insideMiddleBottom':
	            case 'insideEndBottom':
	              dy = distanceY;
	              textVerticalAlign = 'top';
	              break;
	
	            default:
	              dy = 0;
	              textVerticalAlign = 'middle';
	          }
	
	          switch (label.__position) {
	            case 'end':
	              label.x = d[0] * distanceX + toPos[0];
	              label.y = d[1] * distanceY + toPos[1];
	              textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
	              textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
	              break;
	
	            case 'start':
	              label.x = -d[0] * distanceX + fromPos[0];
	              label.y = -d[1] * distanceY + fromPos[1];
	              textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
	              textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
	              break;
	
	            case 'insideStartTop':
	            case 'insideStart':
	            case 'insideStartBottom':
	              label.x = distanceX * dir + fromPos[0];
	              label.y = fromPos[1] + dy;
	              textAlign = tangent[0] < 0 ? 'right' : 'left';
	              label.originX = -distanceX * dir;
	              label.originY = -dy;
	              break;
	
	            case 'insideMiddleTop':
	            case 'insideMiddle':
	            case 'insideMiddleBottom':
	            case 'middle':
	              label.x = cp[0];
	              label.y = cp[1] + dy;
	              textAlign = 'center';
	              label.originY = -dy;
	              break;
	
	            case 'insideEndTop':
	            case 'insideEnd':
	            case 'insideEndBottom':
	              label.x = -distanceX * dir + toPos[0];
	              label.y = toPos[1] + dy;
	              textAlign = tangent[0] >= 0 ? 'right' : 'left';
	              label.originX = distanceX * dir;
	              label.originY = -dy;
	              break;
	          }
	
	          label.scaleX = label.scaleY = invScale;
	          label.setStyle({
	            // Use the user specified text align and baseline first
	            verticalAlign: label.__verticalAlign || textVerticalAlign,
	            align: label.__align || textAlign
	          });
	        }
	      };
	
	      return Line;
	    }(Group);
	
	    var LineDraw =
	    /** @class */
	    function () {
	      function LineDraw(LineCtor) {
	        this.group = new Group();
	        this._LineCtor = LineCtor || Line$1;
	      }
	
	      LineDraw.prototype.updateData = function (lineData) {
	        var _this = this; // Remove progressive els.
	
	
	        this._progressiveEls = null;
	        var lineDraw = this;
	        var group = lineDraw.group;
	        var oldLineData = lineDraw._lineData;
	        lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
	        // stream mode to normal mode, where previous elements should be removed.
	
	        if (!oldLineData) {
	          group.removeAll();
	        }
	
	        var seriesScope = makeSeriesScope$1(lineData);
	        lineData.diff(oldLineData).add(function (idx) {
	          _this._doAdd(lineData, idx, seriesScope);
	        }).update(function (newIdx, oldIdx) {
	          _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
	        }).remove(function (idx) {
	          group.remove(oldLineData.getItemGraphicEl(idx));
	        }).execute();
	      };
	
	      LineDraw.prototype.updateLayout = function () {
	        var lineData = this._lineData; // Do not support update layout in incremental mode.
	
	        if (!lineData) {
	          return;
	        }
	
	        lineData.eachItemGraphicEl(function (el, idx) {
	          el.updateLayout(lineData, idx);
	        }, this);
	      };
	
	      LineDraw.prototype.incrementalPrepareUpdate = function (lineData) {
	        this._seriesScope = makeSeriesScope$1(lineData);
	        this._lineData = null;
	        this.group.removeAll();
	      };
	
	      LineDraw.prototype.incrementalUpdate = function (taskParams, lineData) {
	        this._progressiveEls = [];
	
	        function updateIncrementalAndHover(el) {
	          if (!el.isGroup && !isEffectObject(el)) {
	            el.incremental = true;
	            el.ensureState('emphasis').hoverLayer = true;
	          }
	        }
	
	        for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	          var itemLayout = lineData.getItemLayout(idx);
	
	          if (lineNeedsDraw(itemLayout)) {
	            var el = new this._LineCtor(lineData, idx, this._seriesScope);
	            el.traverse(updateIncrementalAndHover);
	            this.group.add(el);
	            lineData.setItemGraphicEl(idx, el);
	
	            this._progressiveEls.push(el);
	          }
	        }
	      };
	
	      LineDraw.prototype.remove = function () {
	        this.group.removeAll();
	      };
	
	      LineDraw.prototype.eachRendered = function (cb) {
	        traverseElements(this._progressiveEls || this.group, cb);
	      };
	
	      LineDraw.prototype._doAdd = function (lineData, idx, seriesScope) {
	        var itemLayout = lineData.getItemLayout(idx);
	
	        if (!lineNeedsDraw(itemLayout)) {
	          return;
	        }
	
	        var el = new this._LineCtor(lineData, idx, seriesScope);
	        lineData.setItemGraphicEl(idx, el);
	        this.group.add(el);
	      };
	
	      LineDraw.prototype._doUpdate = function (oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
	        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
	
	        if (!lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
	          this.group.remove(itemEl);
	          return;
	        }
	
	        if (!itemEl) {
	          itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
	        } else {
	          itemEl.updateData(newLineData, newIdx, seriesScope);
	        }
	
	        newLineData.setItemGraphicEl(newIdx, itemEl);
	        this.group.add(itemEl);
	      };
	
	      return LineDraw;
	    }();
	
	    function isEffectObject(el) {
	      return el.animators && el.animators.length > 0;
	    }
	
	    function makeSeriesScope$1(lineData) {
	      var hostModel = lineData.hostModel;
	      var emphasisModel = hostModel.getModel('emphasis');
	      return {
	        lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
	        emphasisLineStyle: emphasisModel.getModel(['lineStyle']).getLineStyle(),
	        blurLineStyle: hostModel.getModel(['blur', 'lineStyle']).getLineStyle(),
	        selectLineStyle: hostModel.getModel(['select', 'lineStyle']).getLineStyle(),
	        emphasisDisabled: emphasisModel.get('disabled'),
	        blurScope: emphasisModel.get('blurScope'),
	        focus: emphasisModel.get('focus'),
	        labelStatesModels: getLabelStatesModels(hostModel)
	      };
	    }
	
	    function isPointNaN(pt) {
	      return isNaN(pt[0]) || isNaN(pt[1]);
	    }
	
	    function lineNeedsDraw(pts) {
	      return pts && !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
	    }
	
	    var v1 = [];
	    var v2 = [];
	    var v3 = [];
	    var quadraticAt$1 = quadraticAt;
	    var v2DistSquare = distSquare;
	    var mathAbs$2 = Math.abs;
	
	    function intersectCurveCircle(curvePoints, center, radius) {
	      var p0 = curvePoints[0];
	      var p1 = curvePoints[1];
	      var p2 = curvePoints[2];
	      var d = Infinity;
	      var t;
	      var radiusSquare = radius * radius;
	      var interval = 0.1;
	
	      for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
	        v1[0] = quadraticAt$1(p0[0], p1[0], p2[0], _t);
	        v1[1] = quadraticAt$1(p0[1], p1[1], p2[1], _t);
	        var diff = mathAbs$2(v2DistSquare(v1, center) - radiusSquare);
	
	        if (diff < d) {
	          d = diff;
	          t = _t;
	        }
	      } // Assume the segment is monotone，Find root through Bisection method
	      // At most 32 iteration
	
	
	      for (var i = 0; i < 32; i++) {
	        // let prev = t - interval;
	        var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
	        // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
	
	        v2[0] = quadraticAt$1(p0[0], p1[0], p2[0], t);
	        v2[1] = quadraticAt$1(p0[1], p1[1], p2[1], t);
	        v3[0] = quadraticAt$1(p0[0], p1[0], p2[0], next);
	        v3[1] = quadraticAt$1(p0[1], p1[1], p2[1], next);
	        var diff = v2DistSquare(v2, center) - radiusSquare;
	
	        if (mathAbs$2(diff) < 1e-2) {
	          break;
	        } // let prevDiff = v2DistSquare(v1, center) - radiusSquare;
	
	
	        var nextDiff = v2DistSquare(v3, center) - radiusSquare;
	        interval /= 2;
	
	        if (diff < 0) {
	          if (nextDiff >= 0) {
	            t = t + interval;
	          } else {
	            t = t - interval;
	          }
	        } else {
	          if (nextDiff >= 0) {
	            t = t - interval;
	          } else {
	            t = t + interval;
	          }
	        }
	      }
	
	      return t;
	    } // Adjust edge to avoid
	
	
	    function adjustEdge(graph, scale) {
	      var tmp0 = [];
	      var quadraticSubdivide$1 = quadraticSubdivide;
	      var pts = [[], [], []];
	      var pts2 = [[], []];
	      var v = [];
	      scale /= 2;
	      graph.eachEdge(function (edge, idx) {
	        var linePoints = edge.getLayout();
	        var fromSymbol = edge.getVisual('fromSymbol');
	        var toSymbol = edge.getVisual('toSymbol');
	
	        if (!linePoints.__original) {
	          linePoints.__original = [clone$1(linePoints[0]), clone$1(linePoints[1])];
	
	          if (linePoints[2]) {
	            linePoints.__original.push(clone$1(linePoints[2]));
	          }
	        }
	
	        var originalPoints = linePoints.__original; // Quadratic curve
	
	        if (linePoints[2] != null) {
	          copy(pts[0], originalPoints[0]);
	          copy(pts[1], originalPoints[2]);
	          copy(pts[2], originalPoints[1]);
	
	          if (fromSymbol && fromSymbol !== 'none') {
	            var symbolSize = getSymbolSize(edge.node1);
	            var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second
	
	            quadraticSubdivide$1(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	            pts[0][0] = tmp0[3];
	            pts[1][0] = tmp0[4];
	            quadraticSubdivide$1(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	            pts[0][1] = tmp0[3];
	            pts[1][1] = tmp0[4];
	          }
	
	          if (toSymbol && toSymbol !== 'none') {
	            var symbolSize = getSymbolSize(edge.node2);
	            var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first
	
	            quadraticSubdivide$1(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	            pts[1][0] = tmp0[1];
	            pts[2][0] = tmp0[2];
	            quadraticSubdivide$1(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	            pts[1][1] = tmp0[1];
	            pts[2][1] = tmp0[2];
	          } // Copy back to layout
	
	
	          copy(linePoints[0], pts[0]);
	          copy(linePoints[1], pts[2]);
	          copy(linePoints[2], pts[1]);
	        } // Line
	        else {
	            copy(pts2[0], originalPoints[0]);
	            copy(pts2[1], originalPoints[1]);
	            sub(v, pts2[1], pts2[0]);
	            normalize(v, v);
	
	            if (fromSymbol && fromSymbol !== 'none') {
	              var symbolSize = getSymbolSize(edge.node1);
	              scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
	            }
	
	            if (toSymbol && toSymbol !== 'none') {
	              var symbolSize = getSymbolSize(edge.node2);
	              scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
	            }
	
	            copy(linePoints[0], pts2[0]);
	            copy(linePoints[1], pts2[1]);
	          }
	      });
	    }
	
	    function isViewCoordSys(coordSys) {
	      return coordSys.type === 'view';
	    }
	
	    var GraphView =
	    /** @class */
	    function (_super) {
	      __extends(GraphView, _super);
	
	      function GraphView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = GraphView.type;
	        return _this;
	      }
	
	      GraphView.prototype.init = function (ecModel, api) {
	        var symbolDraw = new SymbolDraw();
	        var lineDraw = new LineDraw();
	        var group = this.group;
	        this._controller = new RoamController(api.getZr());
	        this._controllerHost = {
	          target: group
	        };
	        group.add(symbolDraw.group);
	        group.add(lineDraw.group);
	        this._symbolDraw = symbolDraw;
	        this._lineDraw = lineDraw;
	        this._firstRender = true;
	      };
	
	      GraphView.prototype.render = function (seriesModel, ecModel, api) {
	        var _this = this;
	
	        var coordSys = seriesModel.coordinateSystem;
	        this._model = seriesModel;
	        var symbolDraw = this._symbolDraw;
	        var lineDraw = this._lineDraw;
	        var group = this.group;
	
	        if (isViewCoordSys(coordSys)) {
	          var groupNewProp = {
	            x: coordSys.x,
	            y: coordSys.y,
	            scaleX: coordSys.scaleX,
	            scaleY: coordSys.scaleY
	          };
	
	          if (this._firstRender) {
	            group.attr(groupNewProp);
	          } else {
	            updateProps(group, groupNewProp, seriesModel);
	          }
	        } // Fix edge contact point with node
	
	
	        adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	        var data = seriesModel.getData();
	        symbolDraw.updateData(data);
	        var edgeData = seriesModel.getEdgeData(); // TODO: TYPE
	
	        lineDraw.updateData(edgeData);
	
	        this._updateNodeAndLinkScale();
	
	        this._updateController(seriesModel, ecModel, api);
	
	        clearTimeout(this._layoutTimeout);
	        var forceLayout = seriesModel.forceLayout;
	        var layoutAnimation = seriesModel.get(['force', 'layoutAnimation']);
	
	        if (forceLayout) {
	          this._startForceLayoutIteration(forceLayout, layoutAnimation);
	        }
	
	        var layout = seriesModel.get('layout');
	        data.graph.eachNode(function (node) {
	          var idx = node.dataIndex;
	          var el = node.getGraphicEl();
	          var itemModel = node.getModel();
	
	          if (!el) {
	            return;
	          } // Update draggable
	
	
	          el.off('drag').off('dragend');
	          var draggable = itemModel.get('draggable');
	
	          if (draggable) {
	            el.on('drag', function (e) {
	              switch (layout) {
	                case 'force':
	                  forceLayout.warmUp();
	                  !_this._layouting && _this._startForceLayoutIteration(forceLayout, layoutAnimation);
	                  forceLayout.setFixed(idx); // Write position back to layout
	
	                  data.setItemLayout(idx, [el.x, el.y]);
	                  break;
	
	                case 'circular':
	                  data.setItemLayout(idx, [el.x, el.y]); // mark node fixed
	
	                  node.setLayout({
	                    fixed: true
	                  }, true); // recalculate circular layout
	
	                  circularLayout(seriesModel, 'symbolSize', node, [e.offsetX, e.offsetY]);
	
	                  _this.updateLayout(seriesModel);
	
	                  break;
	
	                case 'none':
	                default:
	                  data.setItemLayout(idx, [el.x, el.y]); // update edge
	
	                  simpleLayoutEdge(seriesModel.getGraph(), seriesModel);
	
	                  _this.updateLayout(seriesModel);
	
	                  break;
	              }
	            }).on('dragend', function () {
	              if (forceLayout) {
	                forceLayout.setUnfixed(idx);
	              }
	            });
	          }
	
	          el.setDraggable(draggable, !!itemModel.get('cursor'));
	          var focus = itemModel.get(['emphasis', 'focus']);
	
	          if (focus === 'adjacency') {
	            getECData(el).focus = node.getAdjacentDataIndices();
	          }
	        });
	        data.graph.eachEdge(function (edge) {
	          var el = edge.getGraphicEl();
	          var focus = edge.getModel().get(['emphasis', 'focus']);
	
	          if (!el) {
	            return;
	          }
	
	          if (focus === 'adjacency') {
	            getECData(el).focus = {
	              edge: [edge.dataIndex],
	              node: [edge.node1.dataIndex, edge.node2.dataIndex]
	            };
	          }
	        });
	        var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get(['circular', 'rotateLabel']);
	        var cx = data.getLayout('cx');
	        var cy = data.getLayout('cy');
	        data.graph.eachNode(function (node) {
	          rotateNodeLabel(node, circularRotateLabel, cx, cy);
	        });
	        this._firstRender = false;
	      };
	
	      GraphView.prototype.dispose = function () {
	        this._controller && this._controller.dispose();
	        this._controllerHost = null;
	      };
	
	      GraphView.prototype._startForceLayoutIteration = function (forceLayout, layoutAnimation) {
	        var self = this;
	
	        (function step() {
	          forceLayout.step(function (stopped) {
	            self.updateLayout(self._model);
	            (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
	          });
	        })();
	      };
	
	      GraphView.prototype._updateController = function (seriesModel, ecModel, api) {
	        var _this = this;
	
	        var controller = this._controller;
	        var controllerHost = this._controllerHost;
	        var group = this.group;
	        controller.setPointerChecker(function (e, x, y) {
	          var rect = group.getBoundingRect();
	          rect.applyTransform(group.transform);
	          return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	        });
	
	        if (!isViewCoordSys(seriesModel.coordinateSystem)) {
	          controller.disable();
	          return;
	        }
	
	        controller.enable(seriesModel.get('roam'));
	        controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	        controller.off('pan').off('zoom').on('pan', function (e) {
	          updateViewOnPan(controllerHost, e.dx, e.dy);
	          api.dispatchAction({
	            seriesId: seriesModel.id,
	            type: 'graphRoam',
	            dx: e.dx,
	            dy: e.dy
	          });
	        }).on('zoom', function (e) {
	          updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	          api.dispatchAction({
	            seriesId: seriesModel.id,
	            type: 'graphRoam',
	            zoom: e.scale,
	            originX: e.originX,
	            originY: e.originY
	          });
	
	          _this._updateNodeAndLinkScale();
	
	          adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	          _this._lineDraw.updateLayout(); // Only update label layout on zoom
	
	
	          api.updateLabelLayout();
	        });
	      };
	
	      GraphView.prototype._updateNodeAndLinkScale = function () {
	        var seriesModel = this._model;
	        var data = seriesModel.getData();
	        var nodeScale = getNodeGlobalScale(seriesModel);
	        data.eachItemGraphicEl(function (el, idx) {
	          el && el.setSymbolScale(nodeScale);
	        });
	      };
	
	      GraphView.prototype.updateLayout = function (seriesModel) {
	        adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	        this._symbolDraw.updateLayout();
	
	        this._lineDraw.updateLayout();
	      };
	
	      GraphView.prototype.remove = function (ecModel, api) {
	        this._symbolDraw && this._symbolDraw.remove();
	        this._lineDraw && this._lineDraw.remove();
	      };
	
	      GraphView.type = 'graph';
	      return GraphView;
	    }(ChartView);
	
	    function generateNodeKey(id) {
	      return '_EC_' + id;
	    }
	
	    var Graph =
	    /** @class */
	    function () {
	      function Graph(directed) {
	        this.type = 'graph';
	        this.nodes = [];
	        this.edges = [];
	        this._nodesMap = {};
	        /**
	         * @type {Object.<string, module:echarts/data/Graph.Edge>}
	         * @private
	         */
	
	        this._edgesMap = {};
	        this._directed = directed || false;
	      }
	      /**
	       * If is directed graph
	       */
	
	
	      Graph.prototype.isDirected = function () {
	        return this._directed;
	      };
	      /**
	       * Add a new node
	       */
	
	      Graph.prototype.addNode = function (id, dataIndex) {
	        id = id == null ? '' + dataIndex : '' + id;
	        var nodesMap = this._nodesMap;
	
	        if (nodesMap[generateNodeKey(id)]) {
	          if (true) {
	            console.error('Graph nodes have duplicate name or id');
	          }
	
	          return;
	        }
	
	        var node = new GraphNode(id, dataIndex);
	        node.hostGraph = this;
	        this.nodes.push(node);
	        nodesMap[generateNodeKey(id)] = node;
	        return node;
	      };
	      /**
	       * Get node by data index
	       */
	
	      Graph.prototype.getNodeByIndex = function (dataIndex) {
	        var rawIdx = this.data.getRawIndex(dataIndex);
	        return this.nodes[rawIdx];
	      };
	      /**
	       * Get node by id
	       */
	
	      Graph.prototype.getNodeById = function (id) {
	        return this._nodesMap[generateNodeKey(id)];
	      };
	      /**
	       * Add a new edge
	       */
	
	      Graph.prototype.addEdge = function (n1, n2, dataIndex) {
	        var nodesMap = this._nodesMap;
	        var edgesMap = this._edgesMap; // PENDING
	
	        if (isNumber(n1)) {
	          n1 = this.nodes[n1];
	        }
	
	        if (isNumber(n2)) {
	          n2 = this.nodes[n2];
	        }
	
	        if (!(n1 instanceof GraphNode)) {
	          n1 = nodesMap[generateNodeKey(n1)];
	        }
	
	        if (!(n2 instanceof GraphNode)) {
	          n2 = nodesMap[generateNodeKey(n2)];
	        }
	
	        if (!n1 || !n2) {
	          return;
	        }
	
	        var key = n1.id + '-' + n2.id;
	        var edge = new GraphEdge(n1, n2, dataIndex);
	        edge.hostGraph = this;
	
	        if (this._directed) {
	          n1.outEdges.push(edge);
	          n2.inEdges.push(edge);
	        }
	
	        n1.edges.push(edge);
	
	        if (n1 !== n2) {
	          n2.edges.push(edge);
	        }
	
	        this.edges.push(edge);
	        edgesMap[key] = edge;
	        return edge;
	      };
	      /**
	       * Get edge by data index
	       */
	
	      Graph.prototype.getEdgeByIndex = function (dataIndex) {
	        var rawIdx = this.edgeData.getRawIndex(dataIndex);
	        return this.edges[rawIdx];
	      };
	      /**
	       * Get edge by two linked nodes
	       */
	
	      Graph.prototype.getEdge = function (n1, n2) {
	        if (n1 instanceof GraphNode) {
	          n1 = n1.id;
	        }
	
	        if (n2 instanceof GraphNode) {
	          n2 = n2.id;
	        }
	
	        var edgesMap = this._edgesMap;
	
	        if (this._directed) {
	          return edgesMap[n1 + '-' + n2];
	        } else {
	          return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
	        }
	      };
	      /**
	       * Iterate all nodes
	       */
	
	      Graph.prototype.eachNode = function (cb, context) {
	        var nodes = this.nodes;
	        var len = nodes.length;
	
	        for (var i = 0; i < len; i++) {
	          if (nodes[i].dataIndex >= 0) {
	            cb.call(context, nodes[i], i);
	          }
	        }
	      };
	      /**
	       * Iterate all edges
	       */
	
	      Graph.prototype.eachEdge = function (cb, context) {
	        var edges = this.edges;
	        var len = edges.length;
	
	        for (var i = 0; i < len; i++) {
	          if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
	            cb.call(context, edges[i], i);
	          }
	        }
	      };
	      /**
	       * Breadth first traverse
	       * Return true to stop traversing
	       */
	
	      Graph.prototype.breadthFirstTraverse = function (cb, startNode, direction, context) {
	        if (!(startNode instanceof GraphNode)) {
	          startNode = this._nodesMap[generateNodeKey(startNode)];
	        }
	
	        if (!startNode) {
	          return;
	        }
	
	        var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
	
	        for (var i = 0; i < this.nodes.length; i++) {
	          this.nodes[i].__visited = false;
	        }
	
	        if (cb.call(context, startNode, null)) {
	          return;
	        }
	
	        var queue = [startNode];
	
	        while (queue.length) {
	          var currentNode = queue.shift();
	          var edges = currentNode[edgeType];
	
	          for (var i = 0; i < edges.length; i++) {
	            var e = edges[i];
	            var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
	
	            if (!otherNode.__visited) {
	              if (cb.call(context, otherNode, currentNode)) {
	                // Stop traversing
	                return;
	              }
	
	              queue.push(otherNode);
	              otherNode.__visited = true;
	            }
	          }
	        }
	      };
	      // depthFirstTraverse(
	      //     cb, startNode, direction, context
	      // ) {
	      // };
	      // Filter update
	
	      Graph.prototype.update = function () {
	        var data = this.data;
	        var edgeData = this.edgeData;
	        var nodes = this.nodes;
	        var edges = this.edges;
	
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          nodes[i].dataIndex = -1;
	        }
	
	        for (var i = 0, len = data.count(); i < len; i++) {
	          nodes[data.getRawIndex(i)].dataIndex = i;
	        }
	
	        edgeData.filterSelf(function (idx) {
	          var edge = edges[edgeData.getRawIndex(idx)];
	          return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
	        }); // Update edge
	
	        for (var i = 0, len = edges.length; i < len; i++) {
	          edges[i].dataIndex = -1;
	        }
	
	        for (var i = 0, len = edgeData.count(); i < len; i++) {
	          edges[edgeData.getRawIndex(i)].dataIndex = i;
	        }
	      };
	      /**
	       * @return {module:echarts/data/Graph}
	       */
	
	      Graph.prototype.clone = function () {
	        var graph = new Graph(this._directed);
	        var nodes = this.nodes;
	        var edges = this.edges;
	
	        for (var i = 0; i < nodes.length; i++) {
	          graph.addNode(nodes[i].id, nodes[i].dataIndex);
	        }
	
	        for (var i = 0; i < edges.length; i++) {
	          var e = edges[i];
	          graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
	        }
	
	        return graph;
	      };
	      return Graph;
	    }();
	
	    var GraphNode =
	    /** @class */
	    function () {
	      function GraphNode(id, dataIndex) {
	        this.inEdges = [];
	        this.outEdges = [];
	        this.edges = [];
	        this.dataIndex = -1;
	        this.id = id == null ? '' : id;
	        this.dataIndex = dataIndex == null ? -1 : dataIndex;
	      }
	      /**
	       * @return {number}
	       */
	
	
	      GraphNode.prototype.degree = function () {
	        return this.edges.length;
	      };
	      /**
	       * @return {number}
	       */
	
	
	      GraphNode.prototype.inDegree = function () {
	        return this.inEdges.length;
	      };
	      /**
	      * @return {number}
	      */
	
	
	      GraphNode.prototype.outDegree = function () {
	        return this.outEdges.length;
	      };
	
	      GraphNode.prototype.getModel = function (path) {
	        if (this.dataIndex < 0) {
	          return;
	        }
	
	        var graph = this.hostGraph;
	        var itemModel = graph.data.getItemModel(this.dataIndex);
	        return itemModel.getModel(path);
	      };
	
	      GraphNode.prototype.getAdjacentDataIndices = function () {
	        var dataIndices = {
	          edge: [],
	          node: []
	        };
	
	        for (var i = 0; i < this.edges.length; i++) {
	          var adjacentEdge = this.edges[i];
	
	          if (adjacentEdge.dataIndex < 0) {
	            continue;
	          }
	
	          dataIndices.edge.push(adjacentEdge.dataIndex);
	          dataIndices.node.push(adjacentEdge.node1.dataIndex, adjacentEdge.node2.dataIndex);
	        }
	
	        return dataIndices;
	      };
	
	      GraphNode.prototype.getTrajectoryDataIndices = function () {
	        var connectedEdgesMap = createHashMap();
	        var connectedNodesMap = createHashMap();
	
	        for (var i = 0; i < this.edges.length; i++) {
	          var adjacentEdge = this.edges[i];
	
	          if (adjacentEdge.dataIndex < 0) {
	            continue;
	          }
	
	          connectedEdgesMap.set(adjacentEdge.dataIndex, true);
	          var sourceNodesQueue = [adjacentEdge.node1];
	          var targetNodesQueue = [adjacentEdge.node2];
	          var nodeIteratorIndex = 0;
	
	          while (nodeIteratorIndex < sourceNodesQueue.length) {
	            var sourceNode = sourceNodesQueue[nodeIteratorIndex];
	            nodeIteratorIndex++;
	            connectedNodesMap.set(sourceNode.dataIndex, true);
	
	            for (var j = 0; j < sourceNode.inEdges.length; j++) {
	              connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
	              sourceNodesQueue.push(sourceNode.inEdges[j].node1);
	            }
	          }
	
	          nodeIteratorIndex = 0;
	
	          while (nodeIteratorIndex < targetNodesQueue.length) {
	            var targetNode = targetNodesQueue[nodeIteratorIndex];
	            nodeIteratorIndex++;
	            connectedNodesMap.set(targetNode.dataIndex, true);
	
	            for (var j = 0; j < targetNode.outEdges.length; j++) {
	              connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
	              targetNodesQueue.push(targetNode.outEdges[j].node2);
	            }
	          }
	        }
	
	        return {
	          edge: connectedEdgesMap.keys(),
	          node: connectedNodesMap.keys()
	        };
	      };
	
	      return GraphNode;
	    }();
	
	    var GraphEdge =
	    /** @class */
	    function () {
	      function GraphEdge(n1, n2, dataIndex) {
	        this.dataIndex = -1;
	        this.node1 = n1;
	        this.node2 = n2;
	        this.dataIndex = dataIndex == null ? -1 : dataIndex;
	      } // eslint-disable-next-line @typescript-eslint/no-unused-vars
	
	
	      GraphEdge.prototype.getModel = function (path) {
	        if (this.dataIndex < 0) {
	          return;
	        }
	
	        var graph = this.hostGraph;
	        var itemModel = graph.edgeData.getItemModel(this.dataIndex);
	        return itemModel.getModel(path);
	      };
	
	      GraphEdge.prototype.getAdjacentDataIndices = function () {
	        return {
	          edge: [this.dataIndex],
	          node: [this.node1.dataIndex, this.node2.dataIndex]
	        };
	      };
	
	      GraphEdge.prototype.getTrajectoryDataIndices = function () {
	        var connectedEdgesMap = createHashMap();
	        var connectedNodesMap = createHashMap();
	        connectedEdgesMap.set(this.dataIndex, true);
	        var sourceNodes = [this.node1];
	        var targetNodes = [this.node2];
	        var nodeIteratorIndex = 0;
	
	        while (nodeIteratorIndex < sourceNodes.length) {
	          var sourceNode = sourceNodes[nodeIteratorIndex];
	          nodeIteratorIndex++;
	          connectedNodesMap.set(sourceNode.dataIndex, true);
	
	          for (var j = 0; j < sourceNode.inEdges.length; j++) {
	            connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
	            sourceNodes.push(sourceNode.inEdges[j].node1);
	          }
	        }
	
	        nodeIteratorIndex = 0;
	
	        while (nodeIteratorIndex < targetNodes.length) {
	          var targetNode = targetNodes[nodeIteratorIndex];
	          nodeIteratorIndex++;
	          connectedNodesMap.set(targetNode.dataIndex, true);
	
	          for (var j = 0; j < targetNode.outEdges.length; j++) {
	            connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
	            targetNodes.push(targetNode.outEdges[j].node2);
	          }
	        }
	
	        return {
	          edge: connectedEdgesMap.keys(),
	          node: connectedNodesMap.keys()
	        };
	      };
	
	      return GraphEdge;
	    }();
	
	    function createGraphDataProxyMixin(hostName, dataName) {
	      return {
	        /**
	         * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
	         */
	        getValue: function (dimension) {
	          var data = this[hostName][dataName];
	          return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
	        },
	        // TODO: TYPE stricter type.
	        setVisual: function (key, value) {
	          this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
	        },
	        getVisual: function (key) {
	          return this[hostName][dataName].getItemVisual(this.dataIndex, key);
	        },
	        setLayout: function (layout, merge) {
	          this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
	        },
	        getLayout: function () {
	          return this[hostName][dataName].getItemLayout(this.dataIndex);
	        },
	        getGraphicEl: function () {
	          return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
	        },
	        getRawIndex: function () {
	          return this[hostName][dataName].getRawIndex(this.dataIndex);
	        }
	      };
	    }
	    mixin(GraphNode, createGraphDataProxyMixin('hostGraph', 'data'));
	    mixin(GraphEdge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
	
	    function createGraphFromNodeEdge(nodes, edges, seriesModel, directed, beforeLink) {
	      // ??? TODO
	      // support dataset?
	      var graph = new Graph(directed);
	
	      for (var i = 0; i < nodes.length; i++) {
	        graph.addNode(retrieve( // Id, name, dataIndex
	        nodes[i].id, nodes[i].name, i), i);
	      }
	
	      var linkNameList = [];
	      var validEdges = [];
	      var linkCount = 0;
	
	      for (var i = 0; i < edges.length; i++) {
	        var link = edges[i];
	        var source = link.source;
	        var target = link.target; // addEdge may fail when source or target not exists
	
	        if (graph.addEdge(source, target, linkCount)) {
	          validEdges.push(link);
	          linkNameList.push(retrieve(convertOptionIdName(link.id, null), source + ' > ' + target));
	          linkCount++;
	        }
	      }
	
	      var coordSys = seriesModel.get('coordinateSystem');
	      var nodeData;
	
	      if (coordSys === 'cartesian2d' || coordSys === 'polar') {
	        nodeData = createSeriesData(nodes, seriesModel);
	      } else {
	        var coordSysCtor = CoordinateSystemManager.get(coordSys);
	        var coordDimensions = coordSysCtor ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
	        // `value` dimension, but graph need `value` dimension. It's better to
	        // uniform this behavior.
	
	        if (indexOf(coordDimensions, 'value') < 0) {
	          coordDimensions.concat(['value']);
	        }
	
	        var dimensions = prepareSeriesDataSchema(nodes, {
	          coordDimensions: coordDimensions,
	          encodeDefine: seriesModel.getEncode()
	        }).dimensions;
	        nodeData = new SeriesData(dimensions, seriesModel);
	        nodeData.initData(nodes);
	      }
	
	      var edgeData = new SeriesData(['value'], seriesModel);
	      edgeData.initData(validEdges, linkNameList);
	      beforeLink && beforeLink(nodeData, edgeData);
	      linkSeriesData({
	        mainData: nodeData,
	        struct: graph,
	        structAttr: 'graph',
	        datas: {
	          node: nodeData,
	          edge: edgeData
	        },
	        datasAttr: {
	          node: 'data',
	          edge: 'edgeData'
	        }
	      }); // Update dataIndex of nodes and edges because invalid edge may be removed
	
	      graph.update();
	      return graph;
	    }
	
	    var GraphSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(GraphSeriesModel, _super);
	
	      function GraphSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = GraphSeriesModel.type;
	        _this.hasSymbolVisual = true;
	        return _this;
	      }
	
	      GraphSeriesModel.prototype.init = function (option) {
	        _super.prototype.init.apply(this, arguments);
	
	        var self = this;
	
	        function getCategoriesData() {
	          return self._categoriesData;
	        } // Provide data for legend select
	
	
	        this.legendVisualProvider = new LegendVisualProvider(getCategoriesData, getCategoriesData);
	        this.fillDataTextStyle(option.edges || option.links);
	
	        this._updateCategoriesData();
	      };
	
	      GraphSeriesModel.prototype.mergeOption = function (option) {
	        _super.prototype.mergeOption.apply(this, arguments);
	
	        this.fillDataTextStyle(option.edges || option.links);
	
	        this._updateCategoriesData();
	      };
	
	      GraphSeriesModel.prototype.mergeDefaultAndTheme = function (option) {
	        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
	
	        defaultEmphasis(option, 'edgeLabel', ['show']);
	      };
	
	      GraphSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        var edges = option.edges || option.links || [];
	        var nodes = option.data || option.nodes || [];
	        var self = this;
	
	        if (nodes && edges) {
	          // auto curveness
	          initCurvenessList(this);
	          var graph = createGraphFromNodeEdge(nodes, edges, this, true, beforeLink);
	          each(graph.edges, function (edge) {
	            createEdgeMapForCurveness(edge.node1, edge.node2, this, edge.dataIndex);
	          }, this);
	          return graph.data;
	        }
	
	        function beforeLink(nodeData, edgeData) {
	          // Overwrite nodeData.getItemModel to
	          nodeData.wrapMethod('getItemModel', function (model) {
	            var categoriesModels = self._categoriesModels;
	            var categoryIdx = model.getShallow('category');
	            var categoryModel = categoriesModels[categoryIdx];
	
	            if (categoryModel) {
	              categoryModel.parentModel = model.parentModel;
	              model.parentModel = categoryModel;
	            }
	
	            return model;
	          }); // TODO Inherit resolveParentPath by default in Model#getModel?
	
	          var oldGetModel = Model.prototype.getModel;
	
	          function newGetModel(path, parentModel) {
	            var model = oldGetModel.call(this, path, parentModel);
	            model.resolveParentPath = resolveParentPath;
	            return model;
	          }
	
	          edgeData.wrapMethod('getItemModel', function (model) {
	            model.resolveParentPath = resolveParentPath;
	            model.getModel = newGetModel;
	            return model;
	          });
	
	          function resolveParentPath(pathArr) {
	            if (pathArr && (pathArr[0] === 'label' || pathArr[1] === 'label')) {
	              var newPathArr = pathArr.slice();
	
	              if (pathArr[0] === 'label') {
	                newPathArr[0] = 'edgeLabel';
	              } else if (pathArr[1] === 'label') {
	                newPathArr[1] = 'edgeLabel';
	              }
	
	              return newPathArr;
	            }
	
	            return pathArr;
	          }
	        }
	      };
	
	      GraphSeriesModel.prototype.getGraph = function () {
	        return this.getData().graph;
	      };
	
	      GraphSeriesModel.prototype.getEdgeData = function () {
	        return this.getGraph().edgeData;
	      };
	
	      GraphSeriesModel.prototype.getCategoriesData = function () {
	        return this._categoriesData;
	      };
	
	      GraphSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        if (dataType === 'edge') {
	          var nodeData = this.getData();
	          var params = this.getDataParams(dataIndex, dataType);
	          var edge = nodeData.graph.getEdgeByIndex(dataIndex);
	          var sourceName = nodeData.getName(edge.node1.dataIndex);
	          var targetName = nodeData.getName(edge.node2.dataIndex);
	          var nameArr = [];
	          sourceName != null && nameArr.push(sourceName);
	          targetName != null && nameArr.push(targetName);
	          return createTooltipMarkup('nameValue', {
	            name: nameArr.join(' > '),
	            value: params.value,
	            noValue: params.value == null
	          });
	        } // dataType === 'node' or empty
	
	
	        var nodeMarkup = defaultSeriesFormatTooltip({
	          series: this,
	          dataIndex: dataIndex,
	          multipleSeries: multipleSeries
	        });
	        return nodeMarkup;
	      };
	
	      GraphSeriesModel.prototype._updateCategoriesData = function () {
	        var categories = map(this.option.categories || [], function (category) {
	          // Data must has value
	          return category.value != null ? category : extend({
	            value: 0
	          }, category);
	        });
	        var categoriesData = new SeriesData(['value'], this);
	        categoriesData.initData(categories);
	        this._categoriesData = categoriesData;
	        this._categoriesModels = categoriesData.mapArray(function (idx) {
	          return categoriesData.getItemModel(idx);
	        });
	      };
	
	      GraphSeriesModel.prototype.setZoom = function (zoom) {
	        this.option.zoom = zoom;
	      };
	
	      GraphSeriesModel.prototype.setCenter = function (center) {
	        this.option.center = center;
	      };
	
	      GraphSeriesModel.prototype.isAnimationEnabled = function () {
	        return _super.prototype.isAnimationEnabled.call(this) // Not enable animation when do force layout
	        && !(this.get('layout') === 'force' && this.get(['force', 'layoutAnimation']));
	      };
	
	      GraphSeriesModel.type = 'series.graph';
	      GraphSeriesModel.dependencies = ['grid', 'polar', 'geo', 'singleAxis', 'calendar'];
	      GraphSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        coordinateSystem: 'view',
	        // Default option for all coordinate systems
	        // xAxisIndex: 0,
	        // yAxisIndex: 0,
	        // polarIndex: 0,
	        // geoIndex: 0,
	        legendHoverLink: true,
	        layout: null,
	        // Configuration of circular layout
	        circular: {
	          rotateLabel: false
	        },
	        // Configuration of force directed layout
	        force: {
	          initLayout: null,
	          // Node repulsion. Can be an array to represent range.
	          repulsion: [0, 50],
	          gravity: 0.1,
	          // Initial friction
	          friction: 0.6,
	          // Edge length. Can be an array to represent range.
	          edgeLength: 30,
	          layoutAnimation: true
	        },
	        left: 'center',
	        top: 'center',
	        // right: null,
	        // bottom: null,
	        // width: '80%',
	        // height: '80%',
	        symbol: 'circle',
	        symbolSize: 10,
	        edgeSymbol: ['none', 'none'],
	        edgeSymbolSize: 10,
	        edgeLabel: {
	          position: 'middle',
	          distance: 5
	        },
	        draggable: false,
	        roam: false,
	        // Default on center of graph
	        center: null,
	        zoom: 1,
	        // Symbol size scale ratio in roam
	        nodeScaleRatio: 0.6,
	        // cursor: null,
	        // categories: [],
	        // data: []
	        // Or
	        // nodes: []
	        //
	        // links: []
	        // Or
	        // edges: []
	        label: {
	          show: false,
	          formatter: '{b}'
	        },
	        itemStyle: {},
	        lineStyle: {
	          color: '#aaa',
	          width: 1,
	          opacity: 0.5
	        },
	        emphasis: {
	          scale: true,
	          label: {
	            show: true
	          }
	        },
	        select: {
	          itemStyle: {
	            borderColor: '#212121'
	          }
	        }
	      };
	      return GraphSeriesModel;
	    }(SeriesModel);
	
	    var actionInfo = {
	      type: 'graphRoam',
	      event: 'graphRoam',
	      update: 'none'
	    };
	    function install$d(registers) {
	      registers.registerChartView(GraphView);
	      registers.registerSeriesModel(GraphSeriesModel);
	      registers.registerProcessor(categoryFilter);
	      registers.registerVisual(categoryVisual);
	      registers.registerVisual(graphEdgeVisual);
	      registers.registerLayout(graphSimpleLayout);
	      registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, graphCircularLayout);
	      registers.registerLayout(graphForceLayout);
	      registers.registerCoordinateSystem('graphView', {
	        dimensions: View.dimensions,
	        create: createViewCoordSys
	      }); // Register legacy focus actions
	
	      registers.registerAction({
	        type: 'focusNodeAdjacency',
	        event: 'focusNodeAdjacency',
	        update: 'series:focusNodeAdjacency'
	      }, noop);
	      registers.registerAction({
	        type: 'unfocusNodeAdjacency',
	        event: 'unfocusNodeAdjacency',
	        update: 'series:unfocusNodeAdjacency'
	      }, noop); // Register roam action.
	
	      registers.registerAction(actionInfo, function (payload, ecModel, api) {
	        ecModel.eachComponent({
	          mainType: 'series',
	          query: payload
	        }, function (seriesModel) {
	          var coordSys = seriesModel.coordinateSystem;
	          var res = updateCenterAndZoom(coordSys, payload, undefined, api);
	          seriesModel.setCenter && seriesModel.setCenter(res.center);
	          seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	        });
	      });
	    }
	
	    var PointerShape =
	    /** @class */
	    function () {
	      function PointerShape() {
	        this.angle = 0;
	        this.width = 10;
	        this.r = 10;
	        this.x = 0;
	        this.y = 0;
	      }
	
	      return PointerShape;
	    }();
	
	    var PointerPath =
	    /** @class */
	    function (_super) {
	      __extends(PointerPath, _super);
	
	      function PointerPath(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this.type = 'pointer';
	        return _this;
	      }
	
	      PointerPath.prototype.getDefaultShape = function () {
	        return new PointerShape();
	      };
	
	      PointerPath.prototype.buildPath = function (ctx, shape) {
	        var mathCos = Math.cos;
	        var mathSin = Math.sin;
	        var r = shape.r;
	        var width = shape.width;
	        var angle = shape.angle;
	        var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
	        var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
	        angle = shape.angle - Math.PI / 2;
	        ctx.moveTo(x, y);
	        ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
	        ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
	        ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
	        ctx.lineTo(x, y);
	      };
	
	      return PointerPath;
	    }(Path);
	
	    function parsePosition(seriesModel, api) {
	      var center = seriesModel.get('center');
	      var width = api.getWidth();
	      var height = api.getHeight();
	      var size = Math.min(width, height);
	      var cx = parsePercent$1(center[0], api.getWidth());
	      var cy = parsePercent$1(center[1], api.getHeight());
	      var r = parsePercent$1(seriesModel.get('radius'), size / 2);
	      return {
	        cx: cx,
	        cy: cy,
	        r: r
	      };
	    }
	
	    function formatLabel(value, labelFormatter) {
	      var label = value == null ? '' : value + '';
	
	      if (labelFormatter) {
	        if (isString(labelFormatter)) {
	          label = labelFormatter.replace('{value}', label);
	        } else if (isFunction(labelFormatter)) {
	          label = labelFormatter(value);
	        }
	      }
	
	      return label;
	    }
	
	    var GaugeView =
	    /** @class */
	    function (_super) {
	      __extends(GaugeView, _super);
	
	      function GaugeView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = GaugeView.type;
	        return _this;
	      }
	
	      GaugeView.prototype.render = function (seriesModel, ecModel, api) {
	        this.group.removeAll();
	        var colorList = seriesModel.get(['axisLine', 'lineStyle', 'color']);
	        var posInfo = parsePosition(seriesModel, api);
	
	        this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
	
	        this._data = seriesModel.getData();
	      };
	
	      GaugeView.prototype.dispose = function () {};
	
	      GaugeView.prototype._renderMain = function (seriesModel, ecModel, api, colorList, posInfo) {
	        var group = this.group;
	        var clockwise = seriesModel.get('clockwise');
	        var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
	        var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
	        var axisLineModel = seriesModel.getModel('axisLine');
	        var roundCap = axisLineModel.get('roundCap');
	        var MainPath = roundCap ? SausagePath : Sector;
	        var showAxis = axisLineModel.get('show');
	        var lineStyleModel = axisLineModel.getModel('lineStyle');
	        var axisLineWidth = lineStyleModel.get('width');
	        var angles = [startAngle, endAngle];
	        normalizeArcAngles(angles, !clockwise);
	        startAngle = angles[0];
	        endAngle = angles[1];
	        var angleRangeSpan = endAngle - startAngle;
	        var prevEndAngle = startAngle;
	        var sectors = [];
	
	        for (var i = 0; showAxis && i < colorList.length; i++) {
	          // Clamp
	          var percent = Math.min(Math.max(colorList[i][0], 0), 1);
	          endAngle = startAngle + angleRangeSpan * percent;
	          var sector = new MainPath({
	            shape: {
	              startAngle: prevEndAngle,
	              endAngle: endAngle,
	              cx: posInfo.cx,
	              cy: posInfo.cy,
	              clockwise: clockwise,
	              r0: posInfo.r - axisLineWidth,
	              r: posInfo.r
	            },
	            silent: true
	          });
	          sector.setStyle({
	            fill: colorList[i][1]
	          });
	          sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
	          // so the properties for stroking are useless
	          ['color', 'width']));
	          sectors.push(sector);
	          prevEndAngle = endAngle;
	        }
	
	        sectors.reverse();
	        each(sectors, function (sector) {
	          return group.add(sector);
	        });
	
	        var getColor = function (percent) {
	          // Less than 0
	          if (percent <= 0) {
	            return colorList[0][1];
	          }
	
	          var i;
	
	          for (i = 0; i < colorList.length; i++) {
	            if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
	              return colorList[i][1];
	            }
	          } // More than 1
	
	
	          return colorList[i - 1][1];
	        };
	
	        this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
	
	        this._renderTitleAndDetail(seriesModel, ecModel, api, getColor, posInfo);
	
	        this._renderAnchor(seriesModel, posInfo);
	
	        this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
	      };
	
	      GaugeView.prototype._renderTicks = function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
	        var group = this.group;
	        var cx = posInfo.cx;
	        var cy = posInfo.cy;
	        var r = posInfo.r;
	        var minVal = +seriesModel.get('min');
	        var maxVal = +seriesModel.get('max');
	        var splitLineModel = seriesModel.getModel('splitLine');
	        var tickModel = seriesModel.getModel('axisTick');
	        var labelModel = seriesModel.getModel('axisLabel');
	        var splitNumber = seriesModel.get('splitNumber');
	        var subSplitNumber = tickModel.get('splitNumber');
	        var splitLineLen = parsePercent$1(splitLineModel.get('length'), r);
	        var tickLen = parsePercent$1(tickModel.get('length'), r);
	        var angle = startAngle;
	        var step = (endAngle - startAngle) / splitNumber;
	        var subStep = step / subSplitNumber;
	        var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
	        var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
	        var splitLineDistance = splitLineModel.get('distance');
	        var unitX;
	        var unitY;
	
	        for (var i = 0; i <= splitNumber; i++) {
	          unitX = Math.cos(angle);
	          unitY = Math.sin(angle); // Split line
	
	          if (splitLineModel.get('show')) {
	            var distance = splitLineDistance ? splitLineDistance + axisLineWidth : axisLineWidth;
	            var splitLine = new Line({
	              shape: {
	                x1: unitX * (r - distance) + cx,
	                y1: unitY * (r - distance) + cy,
	                x2: unitX * (r - splitLineLen - distance) + cx,
	                y2: unitY * (r - splitLineLen - distance) + cy
	              },
	              style: splitLineStyle,
	              silent: true
	            });
	
	            if (splitLineStyle.stroke === 'auto') {
	              splitLine.setStyle({
	                stroke: getColor(i / splitNumber)
	              });
	            }
	
	            group.add(splitLine);
	          } // Label
	
	
	          if (labelModel.get('show')) {
	            var distance = labelModel.get('distance') + splitLineDistance;
	            var label = formatLabel(round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
	            var autoColor = getColor(i / splitNumber);
	            var textStyleX = unitX * (r - splitLineLen - distance) + cx;
	            var textStyleY = unitY * (r - splitLineLen - distance) + cy;
	            var rotateType = labelModel.get('rotate');
	            var rotate = 0;
	
	            if (rotateType === 'radial') {
	              rotate = -angle + 2 * Math.PI;
	
	              if (rotate > Math.PI / 2) {
	                rotate += Math.PI;
	              }
	            } else if (rotateType === 'tangential') {
	              rotate = -angle - Math.PI / 2;
	            } else if (isNumber(rotateType)) {
	              rotate = rotateType * Math.PI / 180;
	            }
	
	            if (rotate === 0) {
	              group.add(new ZRText({
	                style: createTextStyle(labelModel, {
	                  text: label,
	                  x: textStyleX,
	                  y: textStyleY,
	                  verticalAlign: unitY < -0.8 ? 'top' : unitY > 0.8 ? 'bottom' : 'middle',
	                  align: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
	                }, {
	                  inheritColor: autoColor
	                }),
	                silent: true
	              }));
	            } else {
	              group.add(new ZRText({
	                style: createTextStyle(labelModel, {
	                  text: label,
	                  x: textStyleX,
	                  y: textStyleY,
	                  verticalAlign: 'middle',
	                  align: 'center'
	                }, {
	                  inheritColor: autoColor
	                }),
	                silent: true,
	                originX: textStyleX,
	                originY: textStyleY,
	                rotation: rotate
	              }));
	            }
	          } // Axis tick
	
	
	          if (tickModel.get('show') && i !== splitNumber) {
	            var distance = tickModel.get('distance');
	            distance = distance ? distance + axisLineWidth : axisLineWidth;
	
	            for (var j = 0; j <= subSplitNumber; j++) {
	              unitX = Math.cos(angle);
	              unitY = Math.sin(angle);
	              var tickLine = new Line({
	                shape: {
	                  x1: unitX * (r - distance) + cx,
	                  y1: unitY * (r - distance) + cy,
	                  x2: unitX * (r - tickLen - distance) + cx,
	                  y2: unitY * (r - tickLen - distance) + cy
	                },
	                silent: true,
	                style: tickLineStyle
	              });
	
	              if (tickLineStyle.stroke === 'auto') {
	                tickLine.setStyle({
	                  stroke: getColor((i + j / subSplitNumber) / splitNumber)
	                });
	              }
	
	              group.add(tickLine);
	              angle += subStep;
	            }
	
	            angle -= subStep;
	          } else {
	            angle += step;
	          }
	        }
	      };
	
	      GaugeView.prototype._renderPointer = function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
	        var group = this.group;
	        var oldData = this._data;
	        var oldProgressData = this._progressEls;
	        var progressList = [];
	        var showPointer = seriesModel.get(['pointer', 'show']);
	        var progressModel = seriesModel.getModel('progress');
	        var showProgress = progressModel.get('show');
	        var data = seriesModel.getData();
	        var valueDim = data.mapDimension('value');
	        var minVal = +seriesModel.get('min');
	        var maxVal = +seriesModel.get('max');
	        var valueExtent = [minVal, maxVal];
	        var angleExtent = [startAngle, endAngle];
	
	        function createPointer(idx, angle) {
	          var itemModel = data.getItemModel(idx);
	          var pointerModel = itemModel.getModel('pointer');
	          var pointerWidth = parsePercent$1(pointerModel.get('width'), posInfo.r);
	          var pointerLength = parsePercent$1(pointerModel.get('length'), posInfo.r);
	          var pointerStr = seriesModel.get(['pointer', 'icon']);
	          var pointerOffset = pointerModel.get('offsetCenter');
	          var pointerOffsetX = parsePercent$1(pointerOffset[0], posInfo.r);
	          var pointerOffsetY = parsePercent$1(pointerOffset[1], posInfo.r);
	          var pointerKeepAspect = pointerModel.get('keepAspect');
	          var pointer; // not exist icon type will be set 'rect'
	
	          if (pointerStr) {
	            pointer = createSymbol(pointerStr, pointerOffsetX - pointerWidth / 2, pointerOffsetY - pointerLength, pointerWidth, pointerLength, null, pointerKeepAspect);
	          } else {
	            pointer = new PointerPath({
	              shape: {
	                angle: -Math.PI / 2,
	                width: pointerWidth,
	                r: pointerLength,
	                x: pointerOffsetX,
	                y: pointerOffsetY
	              }
	            });
	          }
	
	          pointer.rotation = -(angle + Math.PI / 2);
	          pointer.x = posInfo.cx;
	          pointer.y = posInfo.cy;
	          return pointer;
	        }
	
	        function createProgress(idx, endAngle) {
	          var roundCap = progressModel.get('roundCap');
	          var ProgressPath = roundCap ? SausagePath : Sector;
	          var isOverlap = progressModel.get('overlap');
	          var progressWidth = isOverlap ? progressModel.get('width') : axisLineWidth / data.count();
	          var r0 = isOverlap ? posInfo.r - progressWidth : posInfo.r - (idx + 1) * progressWidth;
	          var r = isOverlap ? posInfo.r : posInfo.r - idx * progressWidth;
	          var progress = new ProgressPath({
	            shape: {
	              startAngle: startAngle,
	              endAngle: endAngle,
	              cx: posInfo.cx,
	              cy: posInfo.cy,
	              clockwise: clockwise,
	              r0: r0,
	              r: r
	            }
	          });
	          isOverlap && (progress.z2 = maxVal - data.get(valueDim, idx) % maxVal);
	          return progress;
	        }
	
	        if (showProgress || showPointer) {
	          data.diff(oldData).add(function (idx) {
	            var val = data.get(valueDim, idx);
	
	            if (showPointer) {
	              var pointer = createPointer(idx, startAngle); // TODO hide pointer on NaN value?
	
	              initProps(pointer, {
	                rotation: -((isNaN(+val) ? angleExtent[0] : linearMap(val, valueExtent, angleExtent, true)) + Math.PI / 2)
	              }, seriesModel);
	              group.add(pointer);
	              data.setItemGraphicEl(idx, pointer);
	            }
	
	            if (showProgress) {
	              var progress = createProgress(idx, startAngle);
	              var isClip = progressModel.get('clip');
	              initProps(progress, {
	                shape: {
	                  endAngle: linearMap(val, valueExtent, angleExtent, isClip)
	                }
	              }, seriesModel);
	              group.add(progress); // Add data index and series index for indexing the data by element
	              // Useful in tooltip
	
	              setCommonECData(seriesModel.seriesIndex, data.dataType, idx, progress);
	              progressList[idx] = progress;
	            }
	          }).update(function (newIdx, oldIdx) {
	            var val = data.get(valueDim, newIdx);
	
	            if (showPointer) {
	              var previousPointer = oldData.getItemGraphicEl(oldIdx);
	              var previousRotate = previousPointer ? previousPointer.rotation : startAngle;
	              var pointer = createPointer(newIdx, previousRotate);
	              pointer.rotation = previousRotate;
	              updateProps(pointer, {
	                rotation: -((isNaN(+val) ? angleExtent[0] : linearMap(val, valueExtent, angleExtent, true)) + Math.PI / 2)
	              }, seriesModel);
	              group.add(pointer);
	              data.setItemGraphicEl(newIdx, pointer);
	            }
	
	            if (showProgress) {
	              var previousProgress = oldProgressData[oldIdx];
	              var previousEndAngle = previousProgress ? previousProgress.shape.endAngle : startAngle;
	              var progress = createProgress(newIdx, previousEndAngle);
	              var isClip = progressModel.get('clip');
	              updateProps(progress, {
	                shape: {
	                  endAngle: linearMap(val, valueExtent, angleExtent, isClip)
	                }
	              }, seriesModel);
	              group.add(progress); // Add data index and series index for indexing the data by element
	              // Useful in tooltip
	
	              setCommonECData(seriesModel.seriesIndex, data.dataType, newIdx, progress);
	              progressList[newIdx] = progress;
	            }
	          }).execute();
	          data.each(function (idx) {
	            var itemModel = data.getItemModel(idx);
	            var emphasisModel = itemModel.getModel('emphasis');
	            var focus = emphasisModel.get('focus');
	            var blurScope = emphasisModel.get('blurScope');
	            var emphasisDisabled = emphasisModel.get('disabled');
	
	            if (showPointer) {
	              var pointer = data.getItemGraphicEl(idx);
	              var symbolStyle = data.getItemVisual(idx, 'style');
	              var visualColor = symbolStyle.fill;
	
	              if (pointer instanceof ZRImage) {
	                var pathStyle = pointer.style;
	                pointer.useStyle(extend({
	                  image: pathStyle.image,
	                  x: pathStyle.x,
	                  y: pathStyle.y,
	                  width: pathStyle.width,
	                  height: pathStyle.height
	                }, symbolStyle));
	              } else {
	                pointer.useStyle(symbolStyle);
	                pointer.type !== 'pointer' && pointer.setColor(visualColor);
	              }
	
	              pointer.setStyle(itemModel.getModel(['pointer', 'itemStyle']).getItemStyle());
	
	              if (pointer.style.fill === 'auto') {
	                pointer.setStyle('fill', getColor(linearMap(data.get(valueDim, idx), valueExtent, [0, 1], true)));
	              }
	
	              pointer.z2EmphasisLift = 0;
	              setStatesStylesFromModel(pointer, itemModel);
	              toggleHoverEmphasis(pointer, focus, blurScope, emphasisDisabled);
	            }
	
	            if (showProgress) {
	              var progress = progressList[idx];
	              progress.useStyle(data.getItemVisual(idx, 'style'));
	              progress.setStyle(itemModel.getModel(['progress', 'itemStyle']).getItemStyle());
	              progress.z2EmphasisLift = 0;
	              setStatesStylesFromModel(progress, itemModel);
	              toggleHoverEmphasis(progress, focus, blurScope, emphasisDisabled);
	            }
	          });
	          this._progressEls = progressList;
	        }
	      };
	
	      GaugeView.prototype._renderAnchor = function (seriesModel, posInfo) {
	        var anchorModel = seriesModel.getModel('anchor');
	        var showAnchor = anchorModel.get('show');
	
	        if (showAnchor) {
	          var anchorSize = anchorModel.get('size');
	          var anchorType = anchorModel.get('icon');
	          var offsetCenter = anchorModel.get('offsetCenter');
	          var anchorKeepAspect = anchorModel.get('keepAspect');
	          var anchor = createSymbol(anchorType, posInfo.cx - anchorSize / 2 + parsePercent$1(offsetCenter[0], posInfo.r), posInfo.cy - anchorSize / 2 + parsePercent$1(offsetCenter[1], posInfo.r), anchorSize, anchorSize, null, anchorKeepAspect);
	          anchor.z2 = anchorModel.get('showAbove') ? 1 : 0;
	          anchor.setStyle(anchorModel.getModel('itemStyle').getItemStyle());
	          this.group.add(anchor);
	        }
	      };
	
	      GaugeView.prototype._renderTitleAndDetail = function (seriesModel, ecModel, api, getColor, posInfo) {
	        var _this = this;
	
	        var data = seriesModel.getData();
	        var valueDim = data.mapDimension('value');
	        var minVal = +seriesModel.get('min');
	        var maxVal = +seriesModel.get('max');
	        var contentGroup = new Group();
	        var newTitleEls = [];
	        var newDetailEls = [];
	        var hasAnimation = seriesModel.isAnimationEnabled();
	        var showPointerAbove = seriesModel.get(['pointer', 'showAbove']);
	        data.diff(this._data).add(function (idx) {
	          newTitleEls[idx] = new ZRText({
	            silent: true
	          });
	          newDetailEls[idx] = new ZRText({
	            silent: true
	          });
	        }).update(function (idx, oldIdx) {
	          newTitleEls[idx] = _this._titleEls[oldIdx];
	          newDetailEls[idx] = _this._detailEls[oldIdx];
	        }).execute();
	        data.each(function (idx) {
	          var itemModel = data.getItemModel(idx);
	          var value = data.get(valueDim, idx);
	          var itemGroup = new Group();
	          var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	          var itemTitleModel = itemModel.getModel('title');
	
	          if (itemTitleModel.get('show')) {
	            var titleOffsetCenter = itemTitleModel.get('offsetCenter');
	            var titleX = posInfo.cx + parsePercent$1(titleOffsetCenter[0], posInfo.r);
	            var titleY = posInfo.cy + parsePercent$1(titleOffsetCenter[1], posInfo.r);
	            var labelEl = newTitleEls[idx];
	            labelEl.attr({
	              z2: showPointerAbove ? 0 : 2,
	              style: createTextStyle(itemTitleModel, {
	                x: titleX,
	                y: titleY,
	                text: data.getName(idx),
	                align: 'center',
	                verticalAlign: 'middle'
	              }, {
	                inheritColor: autoColor
	              })
	            });
	            itemGroup.add(labelEl);
	          }
	
	          var itemDetailModel = itemModel.getModel('detail');
	
	          if (itemDetailModel.get('show')) {
	            var detailOffsetCenter = itemDetailModel.get('offsetCenter');
	            var detailX = posInfo.cx + parsePercent$1(detailOffsetCenter[0], posInfo.r);
	            var detailY = posInfo.cy + parsePercent$1(detailOffsetCenter[1], posInfo.r);
	            var width = parsePercent$1(itemDetailModel.get('width'), posInfo.r);
	            var height = parsePercent$1(itemDetailModel.get('height'), posInfo.r);
	            var detailColor = seriesModel.get(['progress', 'show']) ? data.getItemVisual(idx, 'style').fill : autoColor;
	            var labelEl = newDetailEls[idx];
	            var formatter_1 = itemDetailModel.get('formatter');
	            labelEl.attr({
	              z2: showPointerAbove ? 0 : 2,
	              style: createTextStyle(itemDetailModel, {
	                x: detailX,
	                y: detailY,
	                text: formatLabel(value, formatter_1),
	                width: isNaN(width) ? null : width,
	                height: isNaN(height) ? null : height,
	                align: 'center',
	                verticalAlign: 'middle'
	              }, {
	                inheritColor: detailColor
	              })
	            });
	            setLabelValueAnimation(labelEl, {
	              normal: itemDetailModel
	            }, value, function (value) {
	              return formatLabel(value, formatter_1);
	            });
	            hasAnimation && animateLabelValue(labelEl, idx, data, seriesModel, {
	              getFormattedLabel: function (labelDataIndex, status, dataType, labelDimIndex, fmt, extendParams) {
	                return formatLabel(extendParams ? extendParams.interpolatedValue : value, formatter_1);
	              }
	            });
	            itemGroup.add(labelEl);
	          }
	
	          contentGroup.add(itemGroup);
	        });
	        this.group.add(contentGroup);
	        this._titleEls = newTitleEls;
	        this._detailEls = newDetailEls;
	      };
	
	      GaugeView.type = 'gauge';
	      return GaugeView;
	    }(ChartView);
	
	    var GaugeSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(GaugeSeriesModel, _super);
	
	      function GaugeSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = GaugeSeriesModel.type;
	        _this.visualStyleAccessPath = 'itemStyle';
	        return _this;
	      }
	
	      GaugeSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return createSeriesDataSimply(this, ['value']);
	      };
	
	      GaugeSeriesModel.type = 'series.gauge';
	      GaugeSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        colorBy: 'data',
	        // 默认全局居中
	        center: ['50%', '50%'],
	        legendHoverLink: true,
	        radius: '75%',
	        startAngle: 225,
	        endAngle: -45,
	        clockwise: true,
	        // 最小值
	        min: 0,
	        // 最大值
	        max: 100,
	        // 分割段数，默认为10
	        splitNumber: 10,
	        // 坐标轴线
	        axisLine: {
	          // 默认显示，属性show控制显示与否
	          show: true,
	          roundCap: false,
	          lineStyle: {
	            color: [[1, '#E6EBF8']],
	            width: 10
	          }
	        },
	        // 坐标轴线
	        progress: {
	          // 默认显示，属性show控制显示与否
	          show: false,
	          overlap: true,
	          width: 10,
	          roundCap: false,
	          clip: true
	        },
	        // 分隔线
	        splitLine: {
	          // 默认显示，属性show控制显示与否
	          show: true,
	          // 属性length控制线长
	          length: 10,
	          distance: 10,
	          // 属性lineStyle（详见lineStyle）控制线条样式
	          lineStyle: {
	            color: '#63677A',
	            width: 3,
	            type: 'solid'
	          }
	        },
	        // 坐标轴小标记
	        axisTick: {
	          // 属性show控制显示与否，默认不显示
	          show: true,
	          // 每份split细分多少段
	          splitNumber: 5,
	          // 属性length控制线长
	          length: 6,
	          distance: 10,
	          // 属性lineStyle控制线条样式
	          lineStyle: {
	            color: '#63677A',
	            width: 1,
	            type: 'solid'
	          }
	        },
	        axisLabel: {
	          show: true,
	          distance: 15,
	          // formatter: null,
	          color: '#464646',
	          fontSize: 12,
	          rotate: 0
	        },
	        pointer: {
	          icon: null,
	          offsetCenter: [0, 0],
	          show: true,
	          showAbove: true,
	          length: '60%',
	          width: 6,
	          keepAspect: false
	        },
	        anchor: {
	          show: false,
	          showAbove: false,
	          size: 6,
	          icon: 'circle',
	          offsetCenter: [0, 0],
	          keepAspect: false,
	          itemStyle: {
	            color: '#fff',
	            borderWidth: 0,
	            borderColor: '#5470c6'
	          }
	        },
	        title: {
	          show: true,
	          // x, y，单位px
	          offsetCenter: [0, '20%'],
	          // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	          color: '#464646',
	          fontSize: 16,
	          valueAnimation: false
	        },
	        detail: {
	          show: true,
	          backgroundColor: 'rgba(0,0,0,0)',
	          borderWidth: 0,
	          borderColor: '#ccc',
	          width: 100,
	          height: null,
	          padding: [5, 10],
	          // x, y，单位px
	          offsetCenter: [0, '40%'],
	          // formatter: null,
	          // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	          color: '#464646',
	          fontSize: 30,
	          fontWeight: 'bold',
	          lineHeight: 30,
	          valueAnimation: false
	        }
	      };
	      return GaugeSeriesModel;
	    }(SeriesModel);
	
	    function install$e(registers) {
	      registers.registerChartView(GaugeView);
	      registers.registerSeriesModel(GaugeSeriesModel);
	    }
	
	    var opacityAccessPath = ['itemStyle', 'opacity'];
	    /**
	     * Piece of pie including Sector, Label, LabelLine
	     */
	
	    var FunnelPiece =
	    /** @class */
	    function (_super) {
	      __extends(FunnelPiece, _super);
	
	      function FunnelPiece(data, idx) {
	        var _this = _super.call(this) || this;
	
	        var polygon = _this;
	        var labelLine = new Polyline();
	        var text = new ZRText();
	        polygon.setTextContent(text);
	
	        _this.setTextGuideLine(labelLine);
	
	        _this.updateData(data, idx, true);
	
	        return _this;
	      }
	
	      FunnelPiece.prototype.updateData = function (data, idx, firstCreate) {
	        var polygon = this;
	        var seriesModel = data.hostModel;
	        var itemModel = data.getItemModel(idx);
	        var layout = data.getItemLayout(idx);
	        var emphasisModel = itemModel.getModel('emphasis');
	        var opacity = itemModel.get(opacityAccessPath);
	        opacity = opacity == null ? 1 : opacity;
	
	        if (!firstCreate) {
	          saveOldStyle(polygon);
	        } // Update common style
	
	
	        polygon.useStyle(data.getItemVisual(idx, 'style'));
	        polygon.style.lineJoin = 'round';
	
	        if (firstCreate) {
	          polygon.setShape({
	            points: layout.points
	          });
	          polygon.style.opacity = 0;
	          initProps(polygon, {
	            style: {
	              opacity: opacity
	            }
	          }, seriesModel, idx);
	        } else {
	          updateProps(polygon, {
	            style: {
	              opacity: opacity
	            },
	            shape: {
	              points: layout.points
	            }
	          }, seriesModel, idx);
	        }
	
	        setStatesStylesFromModel(polygon, itemModel);
	
	        this._updateLabel(data, idx);
	
	        toggleHoverEmphasis(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	      };
	
	      FunnelPiece.prototype._updateLabel = function (data, idx) {
	        var polygon = this;
	        var labelLine = this.getTextGuideLine();
	        var labelText = polygon.getTextContent();
	        var seriesModel = data.hostModel;
	        var itemModel = data.getItemModel(idx);
	        var layout = data.getItemLayout(idx);
	        var labelLayout = layout.label;
	        var style = data.getItemVisual(idx, 'style');
	        var visualColor = style.fill;
	        setLabelStyle( // position will not be used in setLabelStyle
	        labelText, getLabelStatesModels(itemModel), {
	          labelFetcher: data.hostModel,
	          labelDataIndex: idx,
	          defaultOpacity: style.opacity,
	          defaultText: data.getName(idx)
	        }, {
	          normal: {
	            align: labelLayout.textAlign,
	            verticalAlign: labelLayout.verticalAlign
	          }
	        });
	        polygon.setTextConfig({
	          local: true,
	          inside: !!labelLayout.inside,
	          insideStroke: visualColor,
	          // insideFill: 'auto',
	          outsideFill: visualColor
	        });
	        var linePoints = labelLayout.linePoints;
	        labelLine.setShape({
	          points: linePoints
	        });
	        polygon.textGuideLineConfig = {
	          anchor: linePoints ? new Point(linePoints[0][0], linePoints[0][1]) : null
	        }; // Make sure update style on labelText after setLabelStyle.
	        // Because setLabelStyle will replace a new style on it.
	
	        updateProps(labelText, {
	          style: {
	            x: labelLayout.x,
	            y: labelLayout.y
	          }
	        }, seriesModel, idx);
	        labelText.attr({
	          rotation: labelLayout.rotation,
	          originX: labelLayout.x,
	          originY: labelLayout.y,
	          z2: 10
	        });
	        setLabelLineStyle(polygon, getLabelLineStatesModels(itemModel), {
	          // Default use item visual color
	          stroke: visualColor
	        });
	      };
	
	      return FunnelPiece;
	    }(Polygon);
	
	    var FunnelView =
	    /** @class */
	    function (_super) {
	      __extends(FunnelView, _super);
	
	      function FunnelView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = FunnelView.type;
	        _this.ignoreLabelLineUpdate = true;
	        return _this;
	      }
	
	      FunnelView.prototype.render = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	        var oldData = this._data;
	        var group = this.group;
	        data.diff(oldData).add(function (idx) {
	          var funnelPiece = new FunnelPiece(data, idx);
	          data.setItemGraphicEl(idx, funnelPiece);
	          group.add(funnelPiece);
	        }).update(function (newIdx, oldIdx) {
	          var piece = oldData.getItemGraphicEl(oldIdx);
	          piece.updateData(data, newIdx);
	          group.add(piece);
	          data.setItemGraphicEl(newIdx, piece);
	        }).remove(function (idx) {
	          var piece = oldData.getItemGraphicEl(idx);
	          removeElementWithFadeOut(piece, seriesModel, idx);
	        }).execute();
	        this._data = data;
	      };
	
	      FunnelView.prototype.remove = function () {
	        this.group.removeAll();
	        this._data = null;
	      };
	
	      FunnelView.prototype.dispose = function () {};
	
	      FunnelView.type = 'funnel';
	      return FunnelView;
	    }(ChartView);
	
	    var FunnelSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(FunnelSeriesModel, _super);
	
	      function FunnelSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = FunnelSeriesModel.type;
	        return _this;
	      }
	
	      FunnelSeriesModel.prototype.init = function (option) {
	        _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
	        // Use a function instead of direct access because data reference may changed
	
	
	        this.legendVisualProvider = new LegendVisualProvider(bind(this.getData, this), bind(this.getRawData, this)); // Extend labelLine emphasis
	
	        this._defaultLabelLine(option);
	      };
	
	      FunnelSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return createSeriesDataSimply(this, {
	          coordDimensions: ['value'],
	          encodeDefaulter: curry(makeSeriesEncodeForNameBased, this)
	        });
	      };
	
	      FunnelSeriesModel.prototype._defaultLabelLine = function (option) {
	        // Extend labelLine emphasis
	        defaultEmphasis(option, 'labelLine', ['show']);
	        var labelLineNormalOpt = option.labelLine;
	        var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	      }; // Overwrite
	
	
	      FunnelSeriesModel.prototype.getDataParams = function (dataIndex) {
	        var data = this.getData();
	
	        var params = _super.prototype.getDataParams.call(this, dataIndex);
	
	        var valueDim = data.mapDimension('value');
	        var sum = data.getSum(valueDim); // Percent is 0 if sum is 0
	
	        params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
	        params.$vars.push('percent');
	        return params;
	      };
	
	      FunnelSeriesModel.type = 'series.funnel';
	      FunnelSeriesModel.defaultOption = {
	        // zlevel: 0,                  // 一级层叠
	        z: 2,
	        legendHoverLink: true,
	        colorBy: 'data',
	        left: 80,
	        top: 60,
	        right: 80,
	        bottom: 60,
	        // width: {totalWidth} - left - right,
	        // height: {totalHeight} - top - bottom,
	        // 默认取数据最小最大值
	        // min: 0,
	        // max: 100,
	        minSize: '0%',
	        maxSize: '100%',
	        sort: 'descending',
	        orient: 'vertical',
	        gap: 0,
	        funnelAlign: 'center',
	        label: {
	          show: true,
	          position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	        },
	        labelLine: {
	          show: true,
	          length: 20,
	          lineStyle: {
	            // color: 各异,
	            width: 1
	          }
	        },
	        itemStyle: {
	          // color: 各异,
	          borderColor: '#fff',
	          borderWidth: 1
	        },
	        emphasis: {
	          label: {
	            show: true
	          }
	        },
	        select: {
	          itemStyle: {
	            borderColor: '#212121'
	          }
	        }
	      };
	      return FunnelSeriesModel;
	    }(SeriesModel);
	
	    function getViewRect$3(seriesModel, api) {
	      return getLayoutRect(seriesModel.getBoxLayoutParams(), {
	        width: api.getWidth(),
	        height: api.getHeight()
	      });
	    }
	
	    function getSortedIndices(data, sort) {
	      var valueDim = data.mapDimension('value');
	      var valueArr = data.mapArray(valueDim, function (val) {
	        return val;
	      });
	      var indices = [];
	      var isAscending = sort === 'ascending';
	
	      for (var i = 0, len = data.count(); i < len; i++) {
	        indices[i] = i;
	      } // Add custom sortable function & none sortable opetion by "options.sort"
	
	
	      if (isFunction(sort)) {
	        indices.sort(sort);
	      } else if (sort !== 'none') {
	        indices.sort(function (a, b) {
	          return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
	        });
	      }
	
	      return indices;
	    }
	
	    function labelLayout(data) {
	      var seriesModel = data.hostModel;
	      var orient = seriesModel.get('orient');
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        var labelModel = itemModel.getModel('label');
	        var labelPosition = labelModel.get('position');
	        var labelLineModel = itemModel.getModel('labelLine');
	        var layout = data.getItemLayout(idx);
	        var points = layout.points;
	        var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
	        var textAlign;
	        var textX;
	        var textY;
	        var linePoints;
	
	        if (isLabelInside) {
	          if (labelPosition === 'insideLeft') {
	            textX = (points[0][0] + points[3][0]) / 2 + 5;
	            textY = (points[0][1] + points[3][1]) / 2;
	            textAlign = 'left';
	          } else if (labelPosition === 'insideRight') {
	            textX = (points[1][0] + points[2][0]) / 2 - 5;
	            textY = (points[1][1] + points[2][1]) / 2;
	            textAlign = 'right';
	          } else {
	            textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
	            textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
	            textAlign = 'center';
	          }
	
	          linePoints = [[textX, textY], [textX, textY]];
	        } else {
	          var x1 = void 0;
	          var y1 = void 0;
	          var x2 = void 0;
	          var y2 = void 0;
	          var labelLineLen = labelLineModel.get('length');
	
	          if (true) {
	            if (orient === 'vertical' && ['top', 'bottom'].indexOf(labelPosition) > -1) {
	              labelPosition = 'left';
	              console.warn('Position error: Funnel chart on vertical orient dose not support top and bottom.');
	            }
	
	            if (orient === 'horizontal' && ['left', 'right'].indexOf(labelPosition) > -1) {
	              labelPosition = 'bottom';
	              console.warn('Position error: Funnel chart on horizontal orient dose not support left and right.');
	            }
	          }
	
	          if (labelPosition === 'left') {
	            // Left side
	            x1 = (points[3][0] + points[0][0]) / 2;
	            y1 = (points[3][1] + points[0][1]) / 2;
	            x2 = x1 - labelLineLen;
	            textX = x2 - 5;
	            textAlign = 'right';
	          } else if (labelPosition === 'right') {
	            // Right side
	            x1 = (points[1][0] + points[2][0]) / 2;
	            y1 = (points[1][1] + points[2][1]) / 2;
	            x2 = x1 + labelLineLen;
	            textX = x2 + 5;
	            textAlign = 'left';
	          } else if (labelPosition === 'top') {
	            // Top side
	            x1 = (points[3][0] + points[0][0]) / 2;
	            y1 = (points[3][1] + points[0][1]) / 2;
	            y2 = y1 - labelLineLen;
	            textY = y2 - 5;
	            textAlign = 'center';
	          } else if (labelPosition === 'bottom') {
	            // Bottom side
	            x1 = (points[1][0] + points[2][0]) / 2;
	            y1 = (points[1][1] + points[2][1]) / 2;
	            y2 = y1 + labelLineLen;
	            textY = y2 + 5;
	            textAlign = 'center';
	          } else if (labelPosition === 'rightTop') {
	            // RightTop side
	            x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
	            y1 = orient === 'horizontal' ? points[3][1] : points[1][1];
	
	            if (orient === 'horizontal') {
	              y2 = y1 - labelLineLen;
	              textY = y2 - 5;
	              textAlign = 'center';
	            } else {
	              x2 = x1 + labelLineLen;
	              textX = x2 + 5;
	              textAlign = 'top';
	            }
	          } else if (labelPosition === 'rightBottom') {
	            // RightBottom side
	            x1 = points[2][0];
	            y1 = points[2][1];
	
	            if (orient === 'horizontal') {
	              y2 = y1 + labelLineLen;
	              textY = y2 + 5;
	              textAlign = 'center';
	            } else {
	              x2 = x1 + labelLineLen;
	              textX = x2 + 5;
	              textAlign = 'bottom';
	            }
	          } else if (labelPosition === 'leftTop') {
	            // LeftTop side
	            x1 = points[0][0];
	            y1 = orient === 'horizontal' ? points[0][1] : points[1][1];
	
	            if (orient === 'horizontal') {
	              y2 = y1 - labelLineLen;
	              textY = y2 - 5;
	              textAlign = 'center';
	            } else {
	              x2 = x1 - labelLineLen;
	              textX = x2 - 5;
	              textAlign = 'right';
	            }
	          } else if (labelPosition === 'leftBottom') {
	            // LeftBottom side
	            x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
	            y1 = orient === 'horizontal' ? points[1][1] : points[2][1];
	
	            if (orient === 'horizontal') {
	              y2 = y1 + labelLineLen;
	              textY = y2 + 5;
	              textAlign = 'center';
	            } else {
	              x2 = x1 - labelLineLen;
	              textX = x2 - 5;
	              textAlign = 'right';
	            }
	          } else {
	            // Right side or Bottom side
	            x1 = (points[1][0] + points[2][0]) / 2;
	            y1 = (points[1][1] + points[2][1]) / 2;
	
	            if (orient === 'horizontal') {
	              y2 = y1 + labelLineLen;
	              textY = y2 + 5;
	              textAlign = 'center';
	            } else {
	              x2 = x1 + labelLineLen;
	              textX = x2 + 5;
	              textAlign = 'left';
	            }
	          }
	
	          if (orient === 'horizontal') {
	            x2 = x1;
	            textX = x2;
	          } else {
	            y2 = y1;
	            textY = y2;
	          }
	
	          linePoints = [[x1, y1], [x2, y2]];
	        }
	
	        layout.label = {
	          linePoints: linePoints,
	          x: textX,
	          y: textY,
	          verticalAlign: 'middle',
	          textAlign: textAlign,
	          inside: isLabelInside
	        };
	      });
	    }
	
	    function funnelLayout(ecModel, api) {
	      ecModel.eachSeriesByType('funnel', function (seriesModel) {
	        var data = seriesModel.getData();
	        var valueDim = data.mapDimension('value');
	        var sort = seriesModel.get('sort');
	        var viewRect = getViewRect$3(seriesModel, api);
	        var orient = seriesModel.get('orient');
	        var viewWidth = viewRect.width;
	        var viewHeight = viewRect.height;
	        var indices = getSortedIndices(data, sort);
	        var x = viewRect.x;
	        var y = viewRect.y;
	        var sizeExtent = orient === 'horizontal' ? [parsePercent$1(seriesModel.get('minSize'), viewHeight), parsePercent$1(seriesModel.get('maxSize'), viewHeight)] : [parsePercent$1(seriesModel.get('minSize'), viewWidth), parsePercent$1(seriesModel.get('maxSize'), viewWidth)];
	        var dataExtent = data.getDataExtent(valueDim);
	        var min = seriesModel.get('min');
	        var max = seriesModel.get('max');
	
	        if (min == null) {
	          min = Math.min(dataExtent[0], 0);
	        }
	
	        if (max == null) {
	          max = dataExtent[1];
	        }
	
	        var funnelAlign = seriesModel.get('funnelAlign');
	        var gap = seriesModel.get('gap');
	        var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
	        var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
	
	        var getLinePoints = function (idx, offset) {
	          // End point index is data.count() and we assign it 0
	          if (orient === 'horizontal') {
	            var val_1 = data.get(valueDim, idx) || 0;
	            var itemHeight = linearMap(val_1, [min, max], sizeExtent, true);
	            var y0 = void 0;
	
	            switch (funnelAlign) {
	              case 'top':
	                y0 = y;
	                break;
	
	              case 'center':
	                y0 = y + (viewHeight - itemHeight) / 2;
	                break;
	
	              case 'bottom':
	                y0 = y + (viewHeight - itemHeight);
	                break;
	            }
	
	            return [[offset, y0], [offset, y0 + itemHeight]];
	          }
	
	          var val = data.get(valueDim, idx) || 0;
	          var itemWidth = linearMap(val, [min, max], sizeExtent, true);
	          var x0;
	
	          switch (funnelAlign) {
	            case 'left':
	              x0 = x;
	              break;
	
	            case 'center':
	              x0 = x + (viewWidth - itemWidth) / 2;
	              break;
	
	            case 'right':
	              x0 = x + viewWidth - itemWidth;
	              break;
	          }
	
	          return [[x0, offset], [x0 + itemWidth, offset]];
	        };
	
	        if (sort === 'ascending') {
	          // From bottom to top
	          itemSize = -itemSize;
	          gap = -gap;
	
	          if (orient === 'horizontal') {
	            x += viewWidth;
	          } else {
	            y += viewHeight;
	          }
	
	          indices = indices.reverse();
	        }
	
	        for (var i = 0; i < indices.length; i++) {
	          var idx = indices[i];
	          var nextIdx = indices[i + 1];
	          var itemModel = data.getItemModel(idx);
	
	          if (orient === 'horizontal') {
	            var width = itemModel.get(['itemStyle', 'width']);
	
	            if (width == null) {
	              width = itemSize;
	            } else {
	              width = parsePercent$1(width, viewWidth);
	
	              if (sort === 'ascending') {
	                width = -width;
	              }
	            }
	
	            var start = getLinePoints(idx, x);
	            var end = getLinePoints(nextIdx, x + width);
	            x += width + gap;
	            data.setItemLayout(idx, {
	              points: start.concat(end.slice().reverse())
	            });
	          } else {
	            var height = itemModel.get(['itemStyle', 'height']);
	
	            if (height == null) {
	              height = itemSize;
	            } else {
	              height = parsePercent$1(height, viewHeight);
	
	              if (sort === 'ascending') {
	                height = -height;
	              }
	            }
	
	            var start = getLinePoints(idx, y);
	            var end = getLinePoints(nextIdx, y + height);
	            y += height + gap;
	            data.setItemLayout(idx, {
	              points: start.concat(end.slice().reverse())
	            });
	          }
	        }
	
	        labelLayout(data);
	      });
	    }
	
	    function install$f(registers) {
	      registers.registerChartView(FunnelView);
	      registers.registerSeriesModel(FunnelSeriesModel);
	      registers.registerLayout(funnelLayout);
	      registers.registerProcessor(dataFilter('funnel'));
	    }
	
	    var DEFAULT_SMOOTH = 0.3;
	
	    var ParallelView =
	    /** @class */
	    function (_super) {
	      __extends(ParallelView, _super);
	
	      function ParallelView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ParallelView.type;
	        _this._dataGroup = new Group();
	        _this._initialized = false;
	        return _this;
	      }
	
	      ParallelView.prototype.init = function () {
	        this.group.add(this._dataGroup);
	      };
	      /**
	       * @override
	       */
	
	
	      ParallelView.prototype.render = function (seriesModel, ecModel, api, payload) {
	        // Clear previously rendered progressive elements.
	        this._progressiveEls = null;
	        var dataGroup = this._dataGroup;
	        var data = seriesModel.getData();
	        var oldData = this._data;
	        var coordSys = seriesModel.coordinateSystem;
	        var dimensions = coordSys.dimensions;
	        var seriesScope = makeSeriesScope$2(seriesModel);
	        data.diff(oldData).add(add).update(update).remove(remove).execute();
	
	        function add(newDataIndex) {
	          var line = addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
	          updateElCommon(line, data, newDataIndex, seriesScope);
	        }
	
	        function update(newDataIndex, oldDataIndex) {
	          var line = oldData.getItemGraphicEl(oldDataIndex);
	          var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
	          data.setItemGraphicEl(newDataIndex, line);
	          updateProps(line, {
	            shape: {
	              points: points
	            }
	          }, seriesModel, newDataIndex);
	          saveOldStyle(line);
	          updateElCommon(line, data, newDataIndex, seriesScope);
	        }
	
	        function remove(oldDataIndex) {
	          var line = oldData.getItemGraphicEl(oldDataIndex);
	          dataGroup.remove(line);
	        } // First create
	
	
	        if (!this._initialized) {
	          this._initialized = true;
	          var clipPath = createGridClipShape(coordSys, seriesModel, function () {
	            // Callback will be invoked immediately if there is no animation
	            setTimeout(function () {
	              dataGroup.removeClipPath();
	            });
	          });
	          dataGroup.setClipPath(clipPath);
	        }
	
	        this._data = data;
	      };
	
	      ParallelView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
	        this._initialized = true;
	        this._data = null;
	
	        this._dataGroup.removeAll();
	      };
	
	      ParallelView.prototype.incrementalRender = function (taskParams, seriesModel, ecModel) {
	        var data = seriesModel.getData();
	        var coordSys = seriesModel.coordinateSystem;
	        var dimensions = coordSys.dimensions;
	        var seriesScope = makeSeriesScope$2(seriesModel);
	        var progressiveEls = this._progressiveEls = [];
	
	        for (var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++) {
	          var line = addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
	          line.incremental = true;
	          updateElCommon(line, data, dataIndex, seriesScope);
	          progressiveEls.push(line);
	        }
	      };
	
	      ParallelView.prototype.remove = function () {
	        this._dataGroup && this._dataGroup.removeAll();
	        this._data = null;
	      };
	
	      ParallelView.type = 'parallel';
	      return ParallelView;
	    }(ChartView);
	
	    function createGridClipShape(coordSys, seriesModel, cb) {
	      var parallelModel = coordSys.model;
	      var rect = coordSys.getRect();
	      var rectEl = new Rect({
	        shape: {
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        }
	      });
	      var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
	      rectEl.setShape(dim, 0);
	      initProps(rectEl, {
	        shape: {
	          width: rect.width,
	          height: rect.height
	        }
	      }, seriesModel, cb);
	      return rectEl;
	    }
	
	    function createLinePoints(data, dataIndex, dimensions, coordSys) {
	      var points = [];
	
	      for (var i = 0; i < dimensions.length; i++) {
	        var dimName = dimensions[i];
	        var value = data.get(data.mapDimension(dimName), dataIndex);
	
	        if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
	          points.push(coordSys.dataToPoint(value, dimName));
	        }
	      }
	
	      return points;
	    }
	
	    function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
	      var points = createLinePoints(data, dataIndex, dimensions, coordSys);
	      var line = new Polyline({
	        shape: {
	          points: points
	        },
	        // silent: true,
	        z2: 10
	      });
	      dataGroup.add(line);
	      data.setItemGraphicEl(dataIndex, line);
	      return line;
	    }
	
	    function makeSeriesScope$2(seriesModel) {
	      var smooth = seriesModel.get('smooth', true);
	      smooth === true && (smooth = DEFAULT_SMOOTH);
	      smooth = numericToNumber(smooth);
	      eqNaN(smooth) && (smooth = 0);
	      return {
	        smooth: smooth
	      };
	    }
	
	    function updateElCommon(el, data, dataIndex, seriesScope) {
	      el.useStyle(data.getItemVisual(dataIndex, 'style'));
	      el.style.fill = null;
	      el.setShape('smooth', seriesScope.smooth);
	      var itemModel = data.getItemModel(dataIndex);
	      var emphasisModel = itemModel.getModel('emphasis');
	      setStatesStylesFromModel(el, itemModel, 'lineStyle');
	      toggleHoverEmphasis(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	    } // function simpleDiff(oldData, newData, dimensions) {
	    //     let oldLen;
	    //     if (!oldData
	    //         || !oldData.__plProgressive
	    //         || (oldLen = oldData.count()) !== newData.count()
	    //     ) {
	    //         return true;
	    //     }
	    //     let dimLen = dimensions.length;
	    //     for (let i = 0; i < oldLen; i++) {
	    //         for (let j = 0; j < dimLen; j++) {
	    //             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
	    //                 return true;
	    //             }
	    //         }
	    //     }
	    //     return false;
	    // }
	    // FIXME put in common util?
	
	
	    function isEmptyValue(val, axisType) {
	      return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
	    }
	
	    var ParallelSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(ParallelSeriesModel, _super);
	
	      function ParallelSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ParallelSeriesModel.type;
	        _this.visualStyleAccessPath = 'lineStyle';
	        _this.visualDrawType = 'stroke';
	        return _this;
	      }
	
	      ParallelSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return createSeriesData(null, this, {
	          useEncodeDefaulter: bind(makeDefaultEncode, null, this)
	        });
	      };
	      /**
	       * User can get data raw indices on 'axisAreaSelected' event received.
	       *
	       * @return Raw indices
	       */
	
	
	      ParallelSeriesModel.prototype.getRawIndicesByActiveState = function (activeState) {
	        var coordSys = this.coordinateSystem;
	        var data = this.getData();
	        var indices = [];
	        coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
	          if (activeState === theActiveState) {
	            indices.push(data.getRawIndex(dataIndex));
	          }
	        });
	        return indices;
	      };
	
	      ParallelSeriesModel.type = 'series.parallel';
	      ParallelSeriesModel.dependencies = ['parallel'];
	      ParallelSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        coordinateSystem: 'parallel',
	        parallelIndex: 0,
	        label: {
	          show: false
	        },
	        inactiveOpacity: 0.05,
	        activeOpacity: 1,
	        lineStyle: {
	          width: 1,
	          opacity: 0.45,
	          type: 'solid'
	        },
	        emphasis: {
	          label: {
	            show: false
	          }
	        },
	        progressive: 500,
	        smooth: false,
	        animationEasing: 'linear'
	      };
	      return ParallelSeriesModel;
	    }(SeriesModel);
	
	    function makeDefaultEncode(seriesModel) {
	      // The mapping of parallelAxis dimension to data dimension can
	      // be specified in parallelAxis.option.dim. For example, if
	      // parallelAxis.option.dim is 'dim3', it mapping to the third
	      // dimension of data. But `data.encode` has higher priority.
	      // Moreover, parallelModel.dimension should not be regarded as data
	      // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
	      var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	
	      if (!parallelModel) {
	        return;
	      }
	
	      var encodeDefine = {};
	      each(parallelModel.dimensions, function (axisDim) {
	        var dataDimIndex = convertDimNameToNumber(axisDim);
	        encodeDefine[axisDim] = dataDimIndex;
	      });
	      return encodeDefine;
	    }
	
	    function convertDimNameToNumber(dimName) {
	      return +dimName.replace('dim', '');
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var opacityAccessPath$1 = ['lineStyle', 'opacity'];
	    var parallelVisual = {
	      seriesType: 'parallel',
	      reset: function (seriesModel, ecModel) {
	        var coordSys = seriesModel.coordinateSystem;
	        var opacityMap = {
	          normal: seriesModel.get(['lineStyle', 'opacity']),
	          active: seriesModel.get('activeOpacity'),
	          inactive: seriesModel.get('inactiveOpacity')
	        };
	        return {
	          progress: function (params, data) {
	            coordSys.eachActiveState(data, function (activeState, dataIndex) {
	              var opacity = opacityMap[activeState];
	
	              if (activeState === 'normal' && data.hasItemOption) {
	                var itemOpacity = data.getItemModel(dataIndex).get(opacityAccessPath$1, true);
	                itemOpacity != null && (opacity = itemOpacity);
	              }
	
	              var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
	              existsStyle.opacity = opacity;
	            }, params.start, params.end);
	          }
	        };
	      }
	    };
	
	    function parallelPreprocessor(option) {
	      createParallelIfNeeded(option);
	      mergeAxisOptionFromParallel(option);
	    }
	    /**
	     * Create a parallel coordinate if not exists.
	     * @inner
	     */
	
	    function createParallelIfNeeded(option) {
	      if (option.parallel) {
	        return;
	      }
	
	      var hasParallelSeries = false;
	      each(option.series, function (seriesOpt) {
	        if (seriesOpt && seriesOpt.type === 'parallel') {
	          hasParallelSeries = true;
	        }
	      });
	
	      if (hasParallelSeries) {
	        option.parallel = [{}];
	      }
	    }
	    /**
	     * Merge aixs definition from parallel option (if exists) to axis option.
	     * @inner
	     */
	
	
	    function mergeAxisOptionFromParallel(option) {
	      var axes = normalizeToArray(option.parallelAxis);
	      each(axes, function (axisOption) {
	        if (!isObject(axisOption)) {
	          return;
	        }
	
	        var parallelIndex = axisOption.parallelIndex || 0;
	        var parallelOption = normalizeToArray(option.parallel)[parallelIndex];
	
	        if (parallelOption && parallelOption.parallelAxisDefault) {
	          merge(axisOption, parallelOption.parallelAxisDefault, false);
	        }
	      });
	    }
	
	    var CLICK_THRESHOLD = 5; // > 4
	
	    var ParallelView$1 =
	    /** @class */
	    function (_super) {
	      __extends(ParallelView, _super);
	
	      function ParallelView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ParallelView.type;
	        return _this;
	      }
	
	      ParallelView.prototype.render = function (parallelModel, ecModel, api) {
	        this._model = parallelModel;
	        this._api = api;
	
	        if (!this._handlers) {
	          this._handlers = {};
	          each(handlers, function (handler, eventName) {
	            api.getZr().on(eventName, this._handlers[eventName] = bind(handler, this));
	          }, this);
	        }
	
	        createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
	      };
	
	      ParallelView.prototype.dispose = function (ecModel, api) {
	        clear(this, '_throttledDispatchExpand');
	        each(this._handlers, function (handler, eventName) {
	          api.getZr().off(eventName, handler);
	        });
	        this._handlers = null;
	      };
	      /**
	       * @internal
	       * @param {Object} [opt] If null, cancel the last action triggering for debounce.
	       */
	
	
	      ParallelView.prototype._throttledDispatchExpand = function (opt) {
	        this._dispatchExpand(opt);
	      };
	      /**
	       * @internal
	       */
	
	
	      ParallelView.prototype._dispatchExpand = function (opt) {
	        opt && this._api.dispatchAction(extend({
	          type: 'parallelAxisExpand'
	        }, opt));
	      };
	
	      ParallelView.type = 'parallel';
	      return ParallelView;
	    }(ComponentView);
	
	    var handlers = {
	      mousedown: function (e) {
	        if (checkTrigger(this, 'click')) {
	          this._mouseDownPoint = [e.offsetX, e.offsetY];
	        }
	      },
	      mouseup: function (e) {
	        var mouseDownPoint = this._mouseDownPoint;
	
	        if (checkTrigger(this, 'click') && mouseDownPoint) {
	          var point = [e.offsetX, e.offsetY];
	          var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
	
	          if (dist > CLICK_THRESHOLD) {
	            return;
	          }
	
	          var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	
	          result.behavior !== 'none' && this._dispatchExpand({
	            axisExpandWindow: result.axisExpandWindow
	          });
	        }
	
	        this._mouseDownPoint = null;
	      },
	      mousemove: function (e) {
	        // Should do nothing when brushing.
	        if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
	          return;
	        }
	
	        var model = this._model;
	        var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	        var behavior = result.behavior;
	        behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
	
	        this._throttledDispatchExpand(behavior === 'none' ? null // Cancel the last trigger, in case that mouse slide out of the area quickly.
	        : {
	          axisExpandWindow: result.axisExpandWindow,
	          // Jumping uses animation, and sliding suppresses animation.
	          animation: behavior === 'jump' ? null : {
	            duration: 0 // Disable animation.
	
	          }
	        });
	      }
	    };
	
	    function checkTrigger(view, triggerOn) {
	      var model = view._model;
	      return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
	    }
	
	    var ParallelModel =
	    /** @class */
	    function (_super) {
	      __extends(ParallelModel, _super);
	
	      function ParallelModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ParallelModel.type;
	        return _this;
	      }
	
	      ParallelModel.prototype.init = function () {
	        _super.prototype.init.apply(this, arguments);
	
	        this.mergeOption({});
	      };
	
	      ParallelModel.prototype.mergeOption = function (newOption) {
	        var thisOption = this.option;
	        newOption && merge(thisOption, newOption, true);
	
	        this._initDimensions();
	      };
	      /**
	       * Whether series or axis is in this coordinate system.
	       */
	
	
	      ParallelModel.prototype.contains = function (model, ecModel) {
	        var parallelIndex = model.get('parallelIndex');
	        return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
	      };
	
	      ParallelModel.prototype.setAxisExpand = function (opt) {
	        each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
	          if (opt.hasOwnProperty(name)) {
	            // @ts-ignore FIXME: why "never" inferred in this.option[name]?
	            this.option[name] = opt[name];
	          }
	        }, this);
	      };
	
	      ParallelModel.prototype._initDimensions = function () {
	        var dimensions = this.dimensions = [];
	        var parallelAxisIndex = this.parallelAxisIndex = [];
	        var axisModels = filter(this.ecModel.queryComponents({
	          mainType: 'parallelAxis'
	        }), function (axisModel) {
	          // Can not use this.contains here, because
	          // initialization has not been completed yet.
	          return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
	        }, this);
	        each(axisModels, function (axisModel) {
	          dimensions.push('dim' + axisModel.get('dim'));
	          parallelAxisIndex.push(axisModel.componentIndex);
	        });
	      };
	
	      ParallelModel.type = 'parallel';
	      ParallelModel.dependencies = ['parallelAxis'];
	      ParallelModel.layoutMode = 'box';
	      ParallelModel.defaultOption = {
	        // zlevel: 0,
	        z: 0,
	        left: 80,
	        top: 60,
	        right: 80,
	        bottom: 60,
	        // width: {totalWidth} - left - right,
	        // height: {totalHeight} - top - bottom,
	        layout: 'horizontal',
	        // FIXME
	        // naming?
	        axisExpandable: false,
	        axisExpandCenter: null,
	        axisExpandCount: 0,
	        axisExpandWidth: 50,
	        axisExpandRate: 17,
	        axisExpandDebounce: 50,
	        // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
	        // Do not doc to user until necessary.
	        axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
	        axisExpandTriggerOn: 'click',
	        parallelAxisDefault: null
	      };
	      return ParallelModel;
	    }(ComponentModel);
	
	    var ParallelAxis =
	    /** @class */
	    function (_super) {
	      __extends(ParallelAxis, _super);
	
	      function ParallelAxis(dim, scale, coordExtent, axisType, axisIndex) {
	        var _this = _super.call(this, dim, scale, coordExtent) || this;
	
	        _this.type = axisType || 'value';
	        _this.axisIndex = axisIndex;
	        return _this;
	      }
	
	      ParallelAxis.prototype.isHorizontal = function () {
	        return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
	      };
	
	      return ParallelAxis;
	    }(Axis);
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	    /**
	     * Calculate slider move result.
	     * Usage:
	     * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
	     * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
	     * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
	     *
	     * @param delta Move length.
	     * @param handleEnds handleEnds[0] can be bigger then handleEnds[1].
	     *              handleEnds will be modified in this method.
	     * @param extent handleEnds is restricted by extent.
	     *              extent[0] should less or equals than extent[1].
	     * @param handleIndex Can be 'all', means that both move the two handleEnds.
	     * @param minSpan The range of dataZoom can not be smaller than that.
	     *              If not set, handle0 and cross handle1. If set as a non-negative
	     *              number (including `0`), handles will push each other when reaching
	     *              the minSpan.
	     * @param maxSpan The range of dataZoom can not be larger than that.
	     * @return The input handleEnds.
	     */
	    function sliderMove(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
	      delta = delta || 0;
	      var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.
	
	      if (minSpan != null) {
	        minSpan = restrict(minSpan, [0, extentSpan]);
	      }
	
	      if (maxSpan != null) {
	        maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
	      }
	
	      if (handleIndex === 'all') {
	        var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
	        handleSpan = restrict(handleSpan, [0, extentSpan]);
	        minSpan = maxSpan = restrict(handleSpan, [minSpan, maxSpan]);
	        handleIndex = 0;
	      }
	
	      handleEnds[0] = restrict(handleEnds[0], extent);
	      handleEnds[1] = restrict(handleEnds[1], extent);
	      var originalDistSign = getSpanSign(handleEnds, handleIndex);
	      handleEnds[handleIndex] += delta; // Restrict in extent.
	
	      var extentMinSpan = minSpan || 0;
	      var realExtent = extent.slice();
	      originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
	      handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.
	
	      var currDistSign;
	      currDistSign = getSpanSign(handleEnds, handleIndex);
	
	      if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
	        // If minSpan exists, 'cross' is forbidden.
	        handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
	      } // Shrink span.
	
	
	      currDistSign = getSpanSign(handleEnds, handleIndex);
	
	      if (maxSpan != null && currDistSign.span > maxSpan) {
	        handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
	      }
	
	      return handleEnds;
	    }
	
	    function getSpanSign(handleEnds, handleIndex) {
	      var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
	      // is at left of handleEnds[1] for non-cross case.
	
	      return {
	        span: Math.abs(dist),
	        sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
	      };
	    }
	
	    function restrict(value, extend) {
	      return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
	    }
	
	    var each$5 = each;
	    var mathMin$8 = Math.min;
	    var mathMax$8 = Math.max;
	    var mathFloor$1 = Math.floor;
	    var mathCeil$1 = Math.ceil;
	    var round$3 = round;
	    var PI$7 = Math.PI;
	
	    var Parallel =
	    /** @class */
	    function () {
	      function Parallel(parallelModel, ecModel, api) {
	        this.type = 'parallel';
	        /**
	         * key: dimension
	         */
	
	        this._axesMap = createHashMap();
	        /**
	         * key: dimension
	         * value: {position: [], rotation, }
	         */
	
	        this._axesLayout = {};
	        this.dimensions = parallelModel.dimensions;
	        this._model = parallelModel;
	
	        this._init(parallelModel, ecModel, api);
	      }
	
	      Parallel.prototype._init = function (parallelModel, ecModel, api) {
	        var dimensions = parallelModel.dimensions;
	        var parallelAxisIndex = parallelModel.parallelAxisIndex;
	        each$5(dimensions, function (dim, idx) {
	          var axisIndex = parallelAxisIndex[idx];
	          var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	
	          var axis = this._axesMap.set(dim, new ParallelAxis(dim, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));
	
	          var isCategory = axis.type === 'category';
	          axis.onBand = isCategory && axisModel.get('boundaryGap');
	          axis.inverse = axisModel.get('inverse'); // Injection
	
	          axisModel.axis = axis;
	          axis.model = axisModel;
	          axis.coordinateSystem = axisModel.coordinateSystem = this;
	        }, this);
	      };
	      /**
	       * Update axis scale after data processed
	       */
	
	
	      Parallel.prototype.update = function (ecModel, api) {
	        this._updateAxesFromSeries(this._model, ecModel);
	      };
	
	      Parallel.prototype.containPoint = function (point) {
	        var layoutInfo = this._makeLayoutInfo();
	
	        var axisBase = layoutInfo.axisBase;
	        var layoutBase = layoutInfo.layoutBase;
	        var pixelDimIndex = layoutInfo.pixelDimIndex;
	        var pAxis = point[1 - pixelDimIndex];
	        var pLayout = point[pixelDimIndex];
	        return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
	      };
	
	      Parallel.prototype.getModel = function () {
	        return this._model;
	      };
	      /**
	       * Update properties from series
	       */
	
	
	      Parallel.prototype._updateAxesFromSeries = function (parallelModel, ecModel) {
	        ecModel.eachSeries(function (seriesModel) {
	          if (!parallelModel.contains(seriesModel, ecModel)) {
	            return;
	          }
	
	          var data = seriesModel.getData();
	          each$5(this.dimensions, function (dim) {
	            var axis = this._axesMap.get(dim);
	
	            axis.scale.unionExtentFromData(data, data.mapDimension(dim));
	            niceScaleExtent(axis.scale, axis.model);
	          }, this);
	        }, this);
	      };
	      /**
	       * Resize the parallel coordinate system.
	       */
	
	
	      Parallel.prototype.resize = function (parallelModel, api) {
	        this._rect = getLayoutRect(parallelModel.getBoxLayoutParams(), {
	          width: api.getWidth(),
	          height: api.getHeight()
	        });
	
	        this._layoutAxes();
	      };
	
	      Parallel.prototype.getRect = function () {
	        return this._rect;
	      };
	
	      Parallel.prototype._makeLayoutInfo = function () {
	        var parallelModel = this._model;
	        var rect = this._rect;
	        var xy = ['x', 'y'];
	        var wh = ['width', 'height'];
	        var layout = parallelModel.get('layout');
	        var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
	        var layoutLength = rect[wh[pixelDimIndex]];
	        var layoutExtent = [0, layoutLength];
	        var axisCount = this.dimensions.length;
	        var axisExpandWidth = restrict$1(parallelModel.get('axisExpandWidth'), layoutExtent);
	        var axisExpandCount = restrict$1(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
	        var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
	        // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
	        // where collapsed axes should be overlapped.
	
	        var axisExpandWindow = parallelModel.get('axisExpandWindow');
	        var winSize;
	
	        if (!axisExpandWindow) {
	          winSize = restrict$1(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
	          var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor$1(axisCount / 2);
	          axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
	          axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	        } else {
	          winSize = restrict$1(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
	          axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	        }
	
	        var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.
	
	        axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].
	
	        var winInnerIndices = [mathFloor$1(round$3(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil$1(round$3(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.
	
	        var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
	        return {
	          layout: layout,
	          pixelDimIndex: pixelDimIndex,
	          layoutBase: rect[xy[pixelDimIndex]],
	          layoutLength: layoutLength,
	          axisBase: rect[xy[1 - pixelDimIndex]],
	          axisLength: rect[wh[1 - pixelDimIndex]],
	          axisExpandable: axisExpandable,
	          axisExpandWidth: axisExpandWidth,
	          axisCollapseWidth: axisCollapseWidth,
	          axisExpandWindow: axisExpandWindow,
	          axisCount: axisCount,
	          winInnerIndices: winInnerIndices,
	          axisExpandWindow0Pos: axisExpandWindow0Pos
	        };
	      };
	
	      Parallel.prototype._layoutAxes = function () {
	        var rect = this._rect;
	        var axes = this._axesMap;
	        var dimensions = this.dimensions;
	
	        var layoutInfo = this._makeLayoutInfo();
	
	        var layout = layoutInfo.layout;
	        axes.each(function (axis) {
	          var axisExtent = [0, layoutInfo.axisLength];
	          var idx = axis.inverse ? 1 : 0;
	          axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
	        });
	        each$5(dimensions, function (dim, idx) {
	          var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
	          var positionTable = {
	            horizontal: {
	              x: posInfo.position,
	              y: layoutInfo.axisLength
	            },
	            vertical: {
	              x: 0,
	              y: posInfo.position
	            }
	          };
	          var rotationTable = {
	            horizontal: PI$7 / 2,
	            vertical: 0
	          };
	          var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
	          var rotation = rotationTable[layout];
	          var transform = create$1();
	          rotate(transform, transform, rotation);
	          translate(transform, transform, position); // TODO
	          // tick layout info
	          // TODO
	          // update dimensions info based on axis order.
	
	          this._axesLayout[dim] = {
	            position: position,
	            rotation: rotation,
	            transform: transform,
	            axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
	            axisLabelShow: posInfo.axisLabelShow,
	            nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
	            tickDirection: 1,
	            labelDirection: 1
	          };
	        }, this);
	      };
	      /**
	       * Get axis by dim.
	       */
	
	
	      Parallel.prototype.getAxis = function (dim) {
	        return this._axesMap.get(dim);
	      };
	      /**
	       * Convert a dim value of a single item of series data to Point.
	       */
	
	
	      Parallel.prototype.dataToPoint = function (value, dim) {
	        return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
	      };
	      /**
	       * Travel data for one time, get activeState of each data item.
	       * @param start the start dataIndex that travel from.
	       * @param end the next dataIndex of the last dataIndex will be travel.
	       */
	
	
	      Parallel.prototype.eachActiveState = function (data, callback, start, end) {
	        start == null && (start = 0);
	        end == null && (end = data.count());
	        var axesMap = this._axesMap;
	        var dimensions = this.dimensions;
	        var dataDimensions = [];
	        var axisModels = [];
	        each(dimensions, function (axisDim) {
	          dataDimensions.push(data.mapDimension(axisDim));
	          axisModels.push(axesMap.get(axisDim).model);
	        });
	        var hasActiveSet = this.hasAxisBrushed();
	
	        for (var dataIndex = start; dataIndex < end; dataIndex++) {
	          var activeState = void 0;
	
	          if (!hasActiveSet) {
	            activeState = 'normal';
	          } else {
	            activeState = 'active';
	            var values = data.getValues(dataDimensions, dataIndex);
	
	            for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	              var state = axisModels[j].getActiveState(values[j]);
	
	              if (state === 'inactive') {
	                activeState = 'inactive';
	                break;
	              }
	            }
	          }
	
	          callback(activeState, dataIndex);
	        }
	      };
	      /**
	       * Whether has any activeSet.
	       */
	
	
	      Parallel.prototype.hasAxisBrushed = function () {
	        var dimensions = this.dimensions;
	        var axesMap = this._axesMap;
	        var hasActiveSet = false;
	
	        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	          if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
	            hasActiveSet = true;
	          }
	        }
	
	        return hasActiveSet;
	      };
	      /**
	       * Convert coords of each axis to Point.
	       *  Return point. For example: [10, 20]
	       */
	
	
	      Parallel.prototype.axisCoordToPoint = function (coord, dim) {
	        var axisLayout = this._axesLayout[dim];
	        return applyTransform$1([coord, 0], axisLayout.transform);
	      };
	      /**
	       * Get axis layout.
	       */
	
	
	      Parallel.prototype.getAxisLayout = function (dim) {
	        return clone(this._axesLayout[dim]);
	      };
	      /**
	       * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
	       */
	
	
	      Parallel.prototype.getSlidedAxisExpandWindow = function (point) {
	        var layoutInfo = this._makeLayoutInfo();
	
	        var pixelDimIndex = layoutInfo.pixelDimIndex;
	        var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
	        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	        var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.
	
	        if (!this.containPoint(point)) {
	          return {
	            behavior: 'none',
	            axisExpandWindow: axisExpandWindow
	          };
	        } // Convert the point from global to expand coordinates.
	
	
	        var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
	        // slided when mouse is the center area of the window.
	
	        var delta;
	        var behavior = 'slide';
	        var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	
	        var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.
	
	
	        var useJump = triggerArea[0] != null;
	
	        if (axisCollapseWidth) {
	          if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
	            behavior = 'jump';
	            delta = pointCoord - winSize * triggerArea[2];
	          } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
	            behavior = 'jump';
	            delta = pointCoord - winSize * (1 - triggerArea[2]);
	          } else {
	            (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
	          }
	
	          delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
	          delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
	          : behavior = 'none';
	        } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
	        else {
	            var winSize2 = axisExpandWindow[1] - axisExpandWindow[0];
	            var pos = extent[1] * pointCoord / winSize2;
	            axisExpandWindow = [mathMax$8(0, pos - winSize2 / 2)];
	            axisExpandWindow[1] = mathMin$8(extent[1], axisExpandWindow[0] + winSize2);
	            axisExpandWindow[0] = axisExpandWindow[1] - winSize2;
	          }
	
	        return {
	          axisExpandWindow: axisExpandWindow,
	          behavior: behavior
	        };
	      };
	
	      return Parallel;
	    }();
	
	    function restrict$1(len, extent) {
	      return mathMin$8(mathMax$8(len, extent[0]), extent[1]);
	    }
	
	    function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
	      var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
	      return {
	        position: step * axisIndex,
	        axisNameAvailableWidth: step,
	        axisLabelShow: true
	      };
	    }
	
	    function layoutAxisWithExpand(axisIndex, layoutInfo) {
	      var layoutLength = layoutInfo.layoutLength;
	      var axisExpandWidth = layoutInfo.axisExpandWidth;
	      var axisCount = layoutInfo.axisCount;
	      var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	      var winInnerIndices = layoutInfo.winInnerIndices;
	      var position;
	      var axisNameAvailableWidth = axisCollapseWidth;
	      var axisLabelShow = false;
	      var nameTruncateMaxWidth;
	
	      if (axisIndex < winInnerIndices[0]) {
	        position = axisIndex * axisCollapseWidth;
	        nameTruncateMaxWidth = axisCollapseWidth;
	      } else if (axisIndex <= winInnerIndices[1]) {
	        position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
	        axisNameAvailableWidth = axisExpandWidth;
	        axisLabelShow = true;
	      } else {
	        position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
	        nameTruncateMaxWidth = axisCollapseWidth;
	      }
	
	      return {
	        position: position,
	        axisNameAvailableWidth: axisNameAvailableWidth,
	        axisLabelShow: axisLabelShow,
	        nameTruncateMaxWidth: nameTruncateMaxWidth
	      };
	    }
	
	    function createParallelCoordSys(ecModel, api) {
	      var coordSysList = [];
	      ecModel.eachComponent('parallel', function (parallelModel, idx) {
	        var coordSys = new Parallel(parallelModel, ecModel, api);
	        coordSys.name = 'parallel_' + idx;
	        coordSys.resize(parallelModel, api);
	        parallelModel.coordinateSystem = coordSys;
	        coordSys.model = parallelModel;
	        coordSysList.push(coordSys);
	      }); // Inject the coordinateSystems into seriesModel
	
	      ecModel.eachSeries(function (seriesModel) {
	        if (seriesModel.get('coordinateSystem') === 'parallel') {
	          var parallelModel = seriesModel.getReferringComponents('parallel', SINGLE_REFERRING).models[0];
	          seriesModel.coordinateSystem = parallelModel.coordinateSystem;
	        }
	      });
	      return coordSysList;
	    }
	
	    var parallelCoordSysCreator = {
	      create: createParallelCoordSys
	    };
	
	    var ParallelAxisModel =
	    /** @class */
	    function (_super) {
	      __extends(ParallelAxisModel, _super);
	
	      function ParallelAxisModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ParallelAxisModel.type;
	        /**
	         * @readOnly
	         */
	
	        _this.activeIntervals = [];
	        return _this;
	      }
	
	      ParallelAxisModel.prototype.getAreaSelectStyle = function () {
	        return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
	        // So do not transfer decal directly.
	        ])(this.getModel('areaSelectStyle'));
	      };
	      /**
	       * The code of this feature is put on AxisModel but not ParallelAxis,
	       * because axisModel can be alive after echarts updating but instance of
	       * ParallelAxis having been disposed. this._activeInterval should be kept
	       * when action dispatched (i.e. legend click).
	       *
	       * @param intervals `interval.length === 0` means set all active.
	       */
	
	
	      ParallelAxisModel.prototype.setActiveIntervals = function (intervals) {
	        var activeIntervals = this.activeIntervals = clone(intervals); // Normalize
	
	        if (activeIntervals) {
	          for (var i = activeIntervals.length - 1; i >= 0; i--) {
	            asc(activeIntervals[i]);
	          }
	        }
	      };
	      /**
	       * @param value When only attempting detect whether 'no activeIntervals set',
	       *        `value` is not needed to be input.
	       */
	
	
	      ParallelAxisModel.prototype.getActiveState = function (value) {
	        var activeIntervals = this.activeIntervals;
	
	        if (!activeIntervals.length) {
	          return 'normal';
	        }
	
	        if (value == null || isNaN(+value)) {
	          return 'inactive';
	        } // Simple optimization
	
	
	        if (activeIntervals.length === 1) {
	          var interval = activeIntervals[0];
	
	          if (interval[0] <= value && value <= interval[1]) {
	            return 'active';
	          }
	        } else {
	          for (var i = 0, len = activeIntervals.length; i < len; i++) {
	            if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
	              return 'active';
	            }
	          }
	        }
	
	        return 'inactive';
	      };
	
	      return ParallelAxisModel;
	    }(ComponentModel);
	
	    mixin(ParallelAxisModel, AxisModelCommonMixin);
	
	    var BRUSH_PANEL_GLOBAL = true;
	    var mathMin$9 = Math.min;
	    var mathMax$9 = Math.max;
	    var mathPow$2 = Math.pow;
	    var COVER_Z = 10000;
	    var UNSELECT_THRESHOLD = 6;
	    var MIN_RESIZE_LINE_WIDTH = 6;
	    var MUTEX_RESOURCE_KEY = 'globalPan';
	    var DIRECTION_MAP = {
	      w: [0, 0],
	      e: [0, 1],
	      n: [1, 0],
	      s: [1, 1]
	    };
	    var CURSOR_MAP = {
	      w: 'ew',
	      e: 'ew',
	      n: 'ns',
	      s: 'ns',
	      ne: 'nesw',
	      sw: 'nesw',
	      nw: 'nwse',
	      se: 'nwse'
	    };
	    var DEFAULT_BRUSH_OPT = {
	      brushStyle: {
	        lineWidth: 2,
	        stroke: 'rgba(210,219,238,0.3)',
	        fill: '#D2DBEE'
	      },
	      transformable: true,
	      brushMode: 'single',
	      removeOnClick: false
	    };
	    var baseUID = 0;
	    /**
	     * params:
	     *     areas: Array.<Array>, coord relates to container group,
	     *                             If no container specified, to global.
	     *     opt {
	     *         isEnd: boolean,
	     *         removeOnClick: boolean
	     *     }
	     */
	
	    var BrushController =
	    /** @class */
	    function (_super) {
	      __extends(BrushController, _super);
	
	      function BrushController(zr) {
	        var _this = _super.call(this) || this;
	        /**
	         * @internal
	         */
	
	
	        _this._track = [];
	        /**
	         * @internal
	         */
	
	        _this._covers = [];
	        _this._handlers = {};
	
	        if (true) {
	          assert(zr);
	        }
	
	        _this._zr = zr;
	        _this.group = new Group();
	        _this._uid = 'brushController_' + baseUID++;
	        each(pointerHandlers, function (handler, eventName) {
	          this._handlers[eventName] = bind(handler, this);
	        }, _this);
	        return _this;
	      }
	      /**
	       * If set to `false`, select disabled.
	       */
	
	
	      BrushController.prototype.enableBrush = function (brushOption) {
	        if (true) {
	          assert(this._mounted);
	        }
	
	        this._brushType && this._doDisableBrush();
	        brushOption.brushType && this._doEnableBrush(brushOption);
	        return this;
	      };
	
	      BrushController.prototype._doEnableBrush = function (brushOption) {
	        var zr = this._zr; // Consider roam, which takes globalPan too.
	
	        if (!this._enableGlobalPan) {
	          take(zr, MUTEX_RESOURCE_KEY, this._uid);
	        }
	
	        each(this._handlers, function (handler, eventName) {
	          zr.on(eventName, handler);
	        });
	        this._brushType = brushOption.brushType;
	        this._brushOption = merge(clone(DEFAULT_BRUSH_OPT), brushOption, true);
	      };
	
	      BrushController.prototype._doDisableBrush = function () {
	        var zr = this._zr;
	        release(zr, MUTEX_RESOURCE_KEY, this._uid);
	        each(this._handlers, function (handler, eventName) {
	          zr.off(eventName, handler);
	        });
	        this._brushType = this._brushOption = null;
	      };
	      /**
	       * @param panelOpts If not pass, it is global brush.
	       */
	
	
	      BrushController.prototype.setPanels = function (panelOpts) {
	        if (panelOpts && panelOpts.length) {
	          var panels_1 = this._panels = {};
	          each(panelOpts, function (panelOpts) {
	            panels_1[panelOpts.panelId] = clone(panelOpts);
	          });
	        } else {
	          this._panels = null;
	        }
	
	        return this;
	      };
	
	      BrushController.prototype.mount = function (opt) {
	        opt = opt || {};
	
	        if (true) {
	          this._mounted = true; // should be at first.
	        }
	
	        this._enableGlobalPan = opt.enableGlobalPan;
	        var thisGroup = this.group;
	
	        this._zr.add(thisGroup);
	
	        thisGroup.attr({
	          x: opt.x || 0,
	          y: opt.y || 0,
	          rotation: opt.rotation || 0,
	          scaleX: opt.scaleX || 1,
	          scaleY: opt.scaleY || 1
	        });
	        this._transform = thisGroup.getLocalTransform();
	        return this;
	      }; // eachCover(cb, context): void {
	      //     each(this._covers, cb, context);
	      // }
	
	      /**
	       * Update covers.
	       * @param coverConfigList
	       *        If coverConfigList is null/undefined, all covers removed.
	       */
	
	
	      BrushController.prototype.updateCovers = function (coverConfigList) {
	        if (true) {
	          assert(this._mounted);
	        }
	
	        coverConfigList = map(coverConfigList, function (coverConfig) {
	          return merge(clone(DEFAULT_BRUSH_OPT), coverConfig, true);
	        });
	        var tmpIdPrefix = '\0-brush-index-';
	        var oldCovers = this._covers;
	        var newCovers = this._covers = [];
	        var controller = this;
	        var creatingCover = this._creatingCover;
	        new DataDiffer(oldCovers, coverConfigList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
	        return this;
	
	        function getKey(brushOption, index) {
	          return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
	        }
	
	        function oldGetKey(cover, index) {
	          return getKey(cover.__brushOption, index);
	        }
	
	        function addOrUpdate(newIndex, oldIndex) {
	          var newBrushInternal = coverConfigList[newIndex]; // Consider setOption in event listener of brushSelect,
	          // where updating cover when creating should be forbidden.
	
	          if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
	            newCovers[newIndex] = oldCovers[oldIndex];
	          } else {
	            var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushInternal, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushInternal));
	            updateCoverAfterCreation(controller, cover);
	          }
	        }
	
	        function remove(oldIndex) {
	          if (oldCovers[oldIndex] !== creatingCover) {
	            controller.group.remove(oldCovers[oldIndex]);
	          }
	        }
	      };
	
	      BrushController.prototype.unmount = function () {
	        if (true) {
	          if (!this._mounted) {
	            return;
	          }
	        }
	
	        this.enableBrush(false); // container may 'removeAll' outside.
	
	        clearCovers(this);
	
	        this._zr.remove(this.group);
	
	        if (true) {
	          this._mounted = false; // should be at last.
	        }
	
	        return this;
	      };
	
	      BrushController.prototype.dispose = function () {
	        this.unmount();
	        this.off();
	      };
	
	      return BrushController;
	    }(Eventful);
	
	    function createCover(controller, brushOption) {
	      var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
	      cover.__brushOption = brushOption;
	      updateZ(cover, brushOption);
	      controller.group.add(cover);
	      return cover;
	    }
	
	    function endCreating(controller, creatingCover) {
	      var coverRenderer = getCoverRenderer(creatingCover);
	
	      if (coverRenderer.endCreating) {
	        coverRenderer.endCreating(controller, creatingCover);
	        updateZ(creatingCover, creatingCover.__brushOption);
	      }
	
	      return creatingCover;
	    }
	
	    function updateCoverShape(controller, cover) {
	      var brushOption = cover.__brushOption;
	      getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
	    }
	
	    function updateZ(cover, brushOption) {
	      var z = brushOption.z;
	      z == null && (z = COVER_Z);
	      cover.traverse(function (el) {
	        el.z = z;
	        el.z2 = z; // Consider in given container.
	      });
	    }
	
	    function updateCoverAfterCreation(controller, cover) {
	      getCoverRenderer(cover).updateCommon(controller, cover);
	      updateCoverShape(controller, cover);
	    }
	
	    function getCoverRenderer(cover) {
	      return coverRenderers[cover.__brushOption.brushType];
	    } // return target panel or `true` (means global panel)
	
	
	    function getPanelByPoint(controller, e, localCursorPoint) {
	      var panels = controller._panels;
	
	      if (!panels) {
	        return BRUSH_PANEL_GLOBAL; // Global panel
	      }
	
	      var panel;
	      var transform = controller._transform;
	      each(panels, function (pn) {
	        pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
	      });
	      return panel;
	    } // Return a panel or true
	
	
	    function getPanelByCover(controller, cover) {
	      var panels = controller._panels;
	
	      if (!panels) {
	        return BRUSH_PANEL_GLOBAL; // Global panel
	      }
	
	      var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
	      // which is then treated as global panel.
	
	      return panelId != null ? panels[panelId] : BRUSH_PANEL_GLOBAL;
	    }
	
	    function clearCovers(controller) {
	      var covers = controller._covers;
	      var originalLength = covers.length;
	      each(covers, function (cover) {
	        controller.group.remove(cover);
	      }, controller);
	      covers.length = 0;
	      return !!originalLength;
	    }
	
	    function trigger$1(controller, opt) {
	      var areas = map(controller._covers, function (cover) {
	        var brushOption = cover.__brushOption;
	        var range = clone(brushOption.range);
	        return {
	          brushType: brushOption.brushType,
	          panelId: brushOption.panelId,
	          range: range
	        };
	      });
	      controller.trigger('brush', {
	        areas: areas,
	        isEnd: !!opt.isEnd,
	        removeOnClick: !!opt.removeOnClick
	      });
	    }
	
	    function shouldShowCover(controller) {
	      var track = controller._track;
	
	      if (!track.length) {
	        return false;
	      }
	
	      var p2 = track[track.length - 1];
	      var p1 = track[0];
	      var dx = p2[0] - p1[0];
	      var dy = p2[1] - p1[1];
	      var dist = mathPow$2(dx * dx + dy * dy, 0.5);
	      return dist > UNSELECT_THRESHOLD;
	    }
	
	    function getTrackEnds(track) {
	      var tail = track.length - 1;
	      tail < 0 && (tail = 0);
	      return [track[0], track[tail]];
	    }
	
	    function createBaseRectCover(rectRangeConverter, controller, brushOption, edgeNameSequences) {
	      var cover = new Group();
	      cover.add(new Rect({
	        name: 'main',
	        style: makeStyle(brushOption),
	        silent: true,
	        draggable: true,
	        cursor: 'move',
	        drift: curry(driftRect, rectRangeConverter, controller, cover, ['n', 's', 'w', 'e']),
	        ondragend: curry(trigger$1, controller, {
	          isEnd: true
	        })
	      }));
	      each(edgeNameSequences, function (nameSequence) {
	        cover.add(new Rect({
	          name: nameSequence.join(''),
	          style: {
	            opacity: 0
	          },
	          draggable: true,
	          silent: true,
	          invisible: true,
	          drift: curry(driftRect, rectRangeConverter, controller, cover, nameSequence),
	          ondragend: curry(trigger$1, controller, {
	            isEnd: true
	          })
	        }));
	      });
	      return cover;
	    }
	
	    function updateBaseRect(controller, cover, localRange, brushOption) {
	      var lineWidth = brushOption.brushStyle.lineWidth || 0;
	      var handleSize = mathMax$9(lineWidth, MIN_RESIZE_LINE_WIDTH);
	      var x = localRange[0][0];
	      var y = localRange[1][0];
	      var xa = x - lineWidth / 2;
	      var ya = y - lineWidth / 2;
	      var x2 = localRange[0][1];
	      var y2 = localRange[1][1];
	      var x2a = x2 - handleSize + lineWidth / 2;
	      var y2a = y2 - handleSize + lineWidth / 2;
	      var width = x2 - x;
	      var height = y2 - y;
	      var widtha = width + lineWidth;
	      var heighta = height + lineWidth;
	      updateRectShape(controller, cover, 'main', x, y, width, height);
	
	      if (brushOption.transformable) {
	        updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
	        updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
	        updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
	        updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
	        updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
	        updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
	        updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
	        updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
	      }
	    }
	
	    function updateCommon(controller, cover) {
	      var brushOption = cover.__brushOption;
	      var transformable = brushOption.transformable;
	      var mainEl = cover.childAt(0);
	      mainEl.useStyle(makeStyle(brushOption));
	      mainEl.attr({
	        silent: !transformable,
	        cursor: transformable ? 'move' : 'default'
	      });
	      each([['w'], ['e'], ['n'], ['s'], ['s', 'e'], ['s', 'w'], ['n', 'e'], ['n', 'w']], function (nameSequence) {
	        var el = cover.childOfName(nameSequence.join(''));
	        var globalDir = nameSequence.length === 1 ? getGlobalDirection1(controller, nameSequence[0]) : getGlobalDirection2(controller, nameSequence);
	        el && el.attr({
	          silent: !transformable,
	          invisible: !transformable,
	          cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
	        });
	      });
	    }
	
	    function updateRectShape(controller, cover, name, x, y, w, h) {
	      var el = cover.childOfName(name);
	      el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
	    }
	
	    function makeStyle(brushOption) {
	      return defaults({
	        strokeNoScale: true
	      }, brushOption.brushStyle);
	    }
	
	    function formatRectRange(x, y, x2, y2) {
	      var min = [mathMin$9(x, x2), mathMin$9(y, y2)];
	      var max = [mathMax$9(x, x2), mathMax$9(y, y2)];
	      return [[min[0], max[0]], [min[1], max[1]] // y range
	      ];
	    }
	
	    function getTransform$1(controller) {
	      return getTransform(controller.group);
	    }
	
	    function getGlobalDirection1(controller, localDirName) {
	      var map = {
	        w: 'left',
	        e: 'right',
	        n: 'top',
	        s: 'bottom'
	      };
	      var inverseMap = {
	        left: 'w',
	        right: 'e',
	        top: 'n',
	        bottom: 's'
	      };
	      var dir = transformDirection(map[localDirName], getTransform$1(controller));
	      return inverseMap[dir];
	    }
	
	    function getGlobalDirection2(controller, localDirNameSeq) {
	      var globalDir = [getGlobalDirection1(controller, localDirNameSeq[0]), getGlobalDirection1(controller, localDirNameSeq[1])];
	      (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
	      return globalDir.join('');
	    }
	
	    function driftRect(rectRangeConverter, controller, cover, dirNameSequence, dx, dy) {
	      var brushOption = cover.__brushOption;
	      var rectRange = rectRangeConverter.toRectRange(brushOption.range);
	      var localDelta = toLocalDelta(controller, dx, dy);
	      each(dirNameSequence, function (dirName) {
	        var ind = DIRECTION_MAP[dirName];
	        rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
	      });
	      brushOption.range = rectRangeConverter.fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
	      updateCoverAfterCreation(controller, cover);
	      trigger$1(controller, {
	        isEnd: false
	      });
	    }
	
	    function driftPolygon(controller, cover, dx, dy) {
	      var range = cover.__brushOption.range;
	      var localDelta = toLocalDelta(controller, dx, dy);
	      each(range, function (point) {
	        point[0] += localDelta[0];
	        point[1] += localDelta[1];
	      });
	      updateCoverAfterCreation(controller, cover);
	      trigger$1(controller, {
	        isEnd: false
	      });
	    }
	
	    function toLocalDelta(controller, dx, dy) {
	      var thisGroup = controller.group;
	      var localD = thisGroup.transformCoordToLocal(dx, dy);
	      var localZero = thisGroup.transformCoordToLocal(0, 0);
	      return [localD[0] - localZero[0], localD[1] - localZero[1]];
	    }
	
	    function clipByPanel(controller, cover, data) {
	      var panel = getPanelByCover(controller, cover);
	      return panel && panel !== BRUSH_PANEL_GLOBAL ? panel.clipPath(data, controller._transform) : clone(data);
	    }
	
	    function pointsToRect(points) {
	      var xmin = mathMin$9(points[0][0], points[1][0]);
	      var ymin = mathMin$9(points[0][1], points[1][1]);
	      var xmax = mathMax$9(points[0][0], points[1][0]);
	      var ymax = mathMax$9(points[0][1], points[1][1]);
	      return {
	        x: xmin,
	        y: ymin,
	        width: xmax - xmin,
	        height: ymax - ymin
	      };
	    }
	
	    function resetCursor(controller, e, localCursorPoint) {
	      if ( // Check active
	      !controller._brushType // resetCursor should be always called when mouse is in zr area,
	      // but not called when mouse is out of zr area to avoid bad influence
	      // if `mousemove`, `mouseup` are triggered from `document` event.
	      || isOutsideZrArea(controller, e.offsetX, e.offsetY)) {
	        return;
	      }
	
	      var zr = controller._zr;
	      var covers = controller._covers;
	      var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.
	
	      if (!controller._dragging) {
	        for (var i = 0; i < covers.length; i++) {
	          var brushOption = covers[i].__brushOption;
	
	          if (currPanel && (currPanel === BRUSH_PANEL_GLOBAL || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
	            // Use cursor style set on cover.
	            return;
	          }
	        }
	      }
	
	      currPanel && zr.setCursorStyle('crosshair');
	    }
	
	    function preventDefault(e) {
	      var rawE = e.event;
	      rawE.preventDefault && rawE.preventDefault();
	    }
	
	    function mainShapeContain(cover, x, y) {
	      return cover.childOfName('main').contain(x, y);
	    }
	
	    function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
	      var creatingCover = controller._creatingCover;
	      var panel = controller._creatingPanel;
	      var thisBrushOption = controller._brushOption;
	      var eventParams;
	
	      controller._track.push(localCursorPoint.slice());
	
	      if (shouldShowCover(controller) || creatingCover) {
	        if (panel && !creatingCover) {
	          thisBrushOption.brushMode === 'single' && clearCovers(controller);
	          var brushOption = clone(thisBrushOption);
	          brushOption.brushType = determineBrushType(brushOption.brushType, panel);
	          brushOption.panelId = panel === BRUSH_PANEL_GLOBAL ? null : panel.panelId;
	          creatingCover = controller._creatingCover = createCover(controller, brushOption);
	
	          controller._covers.push(creatingCover);
	        }
	
	        if (creatingCover) {
	          var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
	          var coverBrushOption = creatingCover.__brushOption;
	          coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));
	
	          if (isEnd) {
	            endCreating(controller, creatingCover);
	            coverRenderer.updateCommon(controller, creatingCover);
	          }
	
	          updateCoverShape(controller, creatingCover);
	          eventParams = {
	            isEnd: isEnd
	          };
	        }
	      } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
	        // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
	        // But a single click do not clear covers, because user may have casual
	        // clicks (for example, click on other component and do not expect covers
	        // disappear).
	        // Only some cover removed, trigger action, but not every click trigger action.
	        if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
	          eventParams = {
	            isEnd: isEnd,
	            removeOnClick: true
	          };
	        }
	      }
	
	      return eventParams;
	    }
	
	    function determineBrushType(brushType, panel) {
	      if (brushType === 'auto') {
	        if (true) {
	          assert(panel && panel.defaultBrushType, 'MUST have defaultBrushType when brushType is "atuo"');
	        }
	
	        return panel.defaultBrushType;
	      }
	
	      return brushType;
	    }
	
	    var pointerHandlers = {
	      mousedown: function (e) {
	        if (this._dragging) {
	          // In case some browser do not support globalOut,
	          // and release mouse out side the browser.
	          handleDragEnd(this, e);
	        } else if (!e.target || !e.target.draggable) {
	          preventDefault(e);
	          var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	          this._creatingCover = null;
	          var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);
	
	          if (panel) {
	            this._dragging = true;
	            this._track = [localCursorPoint.slice()];
	          }
	        }
	      },
	      mousemove: function (e) {
	        var x = e.offsetX;
	        var y = e.offsetY;
	        var localCursorPoint = this.group.transformCoordToLocal(x, y);
	        resetCursor(this, e, localCursorPoint);
	
	        if (this._dragging) {
	          preventDefault(e);
	          var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
	          eventParams && trigger$1(this, eventParams);
	        }
	      },
	      mouseup: function (e) {
	        handleDragEnd(this, e);
	      }
	    };
	
	    function handleDragEnd(controller, e) {
	      if (controller._dragging) {
	        preventDefault(e);
	        var x = e.offsetX;
	        var y = e.offsetY;
	        var localCursorPoint = controller.group.transformCoordToLocal(x, y);
	        var eventParams = updateCoverByMouse(controller, e, localCursorPoint, true);
	        controller._dragging = false;
	        controller._track = [];
	        controller._creatingCover = null; // trigger event should be at final, after procedure will be nested.
	
	        eventParams && trigger$1(controller, eventParams);
	      }
	    }
	
	    function isOutsideZrArea(controller, x, y) {
	      var zr = controller._zr;
	      return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
	    }
	    /**
	     * key: brushType
	     */
	
	
	    var coverRenderers = {
	      lineX: getLineRenderer(0),
	      lineY: getLineRenderer(1),
	      rect: {
	        createCover: function (controller, brushOption) {
	          function returnInput(range) {
	            return range;
	          }
	
	          return createBaseRectCover({
	            toRectRange: returnInput,
	            fromRectRange: returnInput
	          }, controller, brushOption, [['w'], ['e'], ['n'], ['s'], ['s', 'e'], ['s', 'w'], ['n', 'e'], ['n', 'w']]);
	        },
	        getCreatingRange: function (localTrack) {
	          var ends = getTrackEnds(localTrack);
	          return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
	        },
	        updateCoverShape: function (controller, cover, localRange, brushOption) {
	          updateBaseRect(controller, cover, localRange, brushOption);
	        },
	        updateCommon: updateCommon,
	        contain: mainShapeContain
	      },
	      polygon: {
	        createCover: function (controller, brushOption) {
	          var cover = new Group(); // Do not use graphic.Polygon because graphic.Polyline do not close the
	          // border of the shape when drawing, which is a better experience for user.
	
	          cover.add(new Polyline({
	            name: 'main',
	            style: makeStyle(brushOption),
	            silent: true
	          }));
	          return cover;
	        },
	        getCreatingRange: function (localTrack) {
	          return localTrack;
	        },
	        endCreating: function (controller, cover) {
	          cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.
	
	          cover.add(new Polygon({
	            name: 'main',
	            draggable: true,
	            drift: curry(driftPolygon, controller, cover),
	            ondragend: curry(trigger$1, controller, {
	              isEnd: true
	            })
	          }));
	        },
	        updateCoverShape: function (controller, cover, localRange, brushOption) {
	          cover.childAt(0).setShape({
	            points: clipByPanel(controller, cover, localRange)
	          });
	        },
	        updateCommon: updateCommon,
	        contain: mainShapeContain
	      }
	    };
	
	    function getLineRenderer(xyIndex) {
	      return {
	        createCover: function (controller, brushOption) {
	          return createBaseRectCover({
	            toRectRange: function (range) {
	              var rectRange = [range, [0, 100]];
	              xyIndex && rectRange.reverse();
	              return rectRange;
	            },
	            fromRectRange: function (rectRange) {
	              return rectRange[xyIndex];
	            }
	          }, controller, brushOption, [[['w'], ['e']], [['n'], ['s']]][xyIndex]);
	        },
	        getCreatingRange: function (localTrack) {
	          var ends = getTrackEnds(localTrack);
	          var min = mathMin$9(ends[0][xyIndex], ends[1][xyIndex]);
	          var max = mathMax$9(ends[0][xyIndex], ends[1][xyIndex]);
	          return [min, max];
	        },
	        updateCoverShape: function (controller, cover, localRange, brushOption) {
	          var otherExtent; // If brushWidth not specified, fit the panel.
	
	          var panel = getPanelByCover(controller, cover);
	
	          if (panel !== BRUSH_PANEL_GLOBAL && panel.getLinearBrushOtherExtent) {
	            otherExtent = panel.getLinearBrushOtherExtent(xyIndex);
	          } else {
	            var zr = controller._zr;
	            otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
	          }
	
	          var rectRange = [localRange, otherExtent];
	          xyIndex && rectRange.reverse();
	          updateBaseRect(controller, cover, rectRange, brushOption);
	        },
	        updateCommon: updateCommon,
	        contain: mainShapeContain
	      };
	    }
	
	    function makeRectPanelClipPath(rect) {
	      rect = normalizeRect(rect);
	      return function (localPoints) {
	        return clipPointsByRect(localPoints, rect);
	      };
	    }
	    function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
	      rect = normalizeRect(rect);
	      return function (xyIndex) {
	        var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
	        var brushWidth = idx ? rect.width : rect.height;
	        var base = idx ? rect.x : rect.y;
	        return [base, base + (brushWidth || 0)];
	      };
	    }
	    function makeRectIsTargetByCursor(rect, api, targetModel) {
	      var boundingRect = normalizeRect(rect);
	      return function (e, localCursorPoint) {
	        return boundingRect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
	      };
	    } // Consider width/height is negative.
	
	    function normalizeRect(rect) {
	      return BoundingRect.create(rect);
	    }
	
	    var elementList = ['axisLine', 'axisTickLabel', 'axisName'];
	
	    var ParallelAxisView =
	    /** @class */
	    function (_super) {
	      __extends(ParallelAxisView, _super);
	
	      function ParallelAxisView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ParallelAxisView.type;
	        return _this;
	      }
	
	      ParallelAxisView.prototype.init = function (ecModel, api) {
	        _super.prototype.init.apply(this, arguments);
	
	        (this._brushController = new BrushController(api.getZr())).on('brush', bind(this._onBrush, this));
	      };
	
	      ParallelAxisView.prototype.render = function (axisModel, ecModel, api, payload) {
	        if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
	          return;
	        }
	
	        this.axisModel = axisModel;
	        this.api = api;
	        this.group.removeAll();
	        var oldAxisGroup = this._axisGroup;
	        this._axisGroup = new Group();
	        this.group.add(this._axisGroup);
	
	        if (!axisModel.get('show')) {
	          return;
	        }
	
	        var coordSysModel = getCoordSysModel(axisModel, ecModel);
	        var coordSys = coordSysModel.coordinateSystem;
	        var areaSelectStyle = axisModel.getAreaSelectStyle();
	        var areaWidth = areaSelectStyle.width;
	        var dim = axisModel.axis.dim;
	        var axisLayout = coordSys.getAxisLayout(dim);
	        var builderOpt = extend({
	          strokeContainThreshold: areaWidth
	        }, axisLayout);
	        var axisBuilder = new AxisBuilder(axisModel, builderOpt);
	        each(elementList, axisBuilder.add, axisBuilder);
	
	        this._axisGroup.add(axisBuilder.getGroup());
	
	        this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
	
	        groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	      }; // /**
	      //  * @override
	      //  */
	      // updateVisual(axisModel, ecModel, api, payload) {
	      //     this._brushController && this._brushController
	      //         .updateCovers(getCoverInfoList(axisModel));
	      // }
	
	
	      ParallelAxisView.prototype._refreshBrushController = function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
	        // After filtering, axis may change, select area needs to be update.
	        var extent = axisModel.axis.getExtent();
	        var extentLen = extent[1] - extent[0];
	        var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
	        // width/height might be negative, which will be
	        // normalized in BoundingRect.
	
	        var rect = BoundingRect.create({
	          x: extent[0],
	          y: -areaWidth / 2,
	          width: extentLen,
	          height: areaWidth
	        });
	        rect.x -= extra;
	        rect.width += 2 * extra;
	
	        this._brushController.mount({
	          enableGlobalPan: true,
	          rotation: builderOpt.rotation,
	          x: builderOpt.position[0],
	          y: builderOpt.position[1]
	        }).setPanels([{
	          panelId: 'pl',
	          clipPath: makeRectPanelClipPath(rect),
	          isTargetByCursor: makeRectIsTargetByCursor(rect, api, coordSysModel),
	          getLinearBrushOtherExtent: makeLinearBrushOtherExtent(rect, 0)
	        }]).enableBrush({
	          brushType: 'lineX',
	          brushStyle: areaSelectStyle,
	          removeOnClick: true
	        }).updateCovers(getCoverInfoList(axisModel));
	      };
	
	      ParallelAxisView.prototype._onBrush = function (eventParam) {
	        var coverInfoList = eventParam.areas; // Do not cache these object, because the mey be changed.
	
	        var axisModel = this.axisModel;
	        var axis = axisModel.axis;
	        var intervals = map(coverInfoList, function (coverInfo) {
	          return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
	        }); // If realtime is true, action is not dispatched on drag end, because
	        // the drag end emits the same params with the last drag move event,
	        // and may have some delay when using touch pad.
	
	        if (!axisModel.option.realtime === eventParam.isEnd || eventParam.removeOnClick) {
	          // jshint ignore:line
	          this.api.dispatchAction({
	            type: 'axisAreaSelect',
	            parallelAxisId: axisModel.id,
	            intervals: intervals
	          });
	        }
	      };
	
	      ParallelAxisView.prototype.dispose = function () {
	        this._brushController.dispose();
	      };
	
	      ParallelAxisView.type = 'parallelAxis';
	      return ParallelAxisView;
	    }(ComponentView);
	
	    function fromAxisAreaSelect(axisModel, ecModel, payload) {
	      return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
	        mainType: 'parallelAxis',
	        query: payload
	      })[0] === axisModel;
	    }
	
	    function getCoverInfoList(axisModel) {
	      var axis = axisModel.axis;
	      return map(axisModel.activeIntervals, function (interval) {
	        return {
	          brushType: 'lineX',
	          panelId: 'pl',
	          range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
	        };
	      });
	    }
	
	    function getCoordSysModel(axisModel, ecModel) {
	      return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var actionInfo$1 = {
	      type: 'axisAreaSelect',
	      event: 'axisAreaSelected' // update: 'updateVisual'
	
	    };
	    function installParallelActions(registers) {
	      registers.registerAction(actionInfo$1, function (payload, ecModel) {
	        ecModel.eachComponent({
	          mainType: 'parallelAxis',
	          query: payload
	        }, function (parallelAxisModel) {
	          parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
	        });
	      });
	      /**
	       * @payload
	       */
	
	      registers.registerAction('parallelAxisExpand', function (payload, ecModel) {
	        ecModel.eachComponent({
	          mainType: 'parallel',
	          query: payload
	        }, function (parallelModel) {
	          parallelModel.setAxisExpand(payload);
	        });
	      });
	    }
	
	    var defaultAxisOption = {
	      type: 'value',
	      areaSelectStyle: {
	        width: 20,
	        borderWidth: 1,
	        borderColor: 'rgba(160,197,232)',
	        color: 'rgba(160,197,232)',
	        opacity: 0.3
	      },
	      realtime: true,
	      z: 10
	    };
	    function install$g(registers) {
	      registers.registerComponentView(ParallelView$1);
	      registers.registerComponentModel(ParallelModel);
	      registers.registerCoordinateSystem('parallel', parallelCoordSysCreator);
	      registers.registerPreprocessor(parallelPreprocessor);
	      registers.registerComponentModel(ParallelAxisModel);
	      registers.registerComponentView(ParallelAxisView);
	      axisModelCreator(registers, 'parallel', ParallelAxisModel, defaultAxisOption);
	      installParallelActions(registers);
	    }
	
	    function install$h(registers) {
	      use(install$g);
	      registers.registerChartView(ParallelView);
	      registers.registerSeriesModel(ParallelSeriesModel);
	      registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, parallelVisual);
	    }
	
	    var SankeyPathShape =
	    /** @class */
	    function () {
	      function SankeyPathShape() {
	        this.x1 = 0;
	        this.y1 = 0;
	        this.x2 = 0;
	        this.y2 = 0;
	        this.cpx1 = 0;
	        this.cpy1 = 0;
	        this.cpx2 = 0;
	        this.cpy2 = 0;
	        this.extent = 0;
	      }
	
	      return SankeyPathShape;
	    }();
	
	    var SankeyPath =
	    /** @class */
	    function (_super) {
	      __extends(SankeyPath, _super);
	
	      function SankeyPath(opts) {
	        return _super.call(this, opts) || this;
	      }
	
	      SankeyPath.prototype.getDefaultShape = function () {
	        return new SankeyPathShape();
	      };
	
	      SankeyPath.prototype.buildPath = function (ctx, shape) {
	        var extent = shape.extent;
	        ctx.moveTo(shape.x1, shape.y1);
	        ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
	
	        if (shape.orient === 'vertical') {
	          ctx.lineTo(shape.x2 + extent, shape.y2);
	          ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
	        } else {
	          ctx.lineTo(shape.x2, shape.y2 + extent);
	          ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
	        }
	
	        ctx.closePath();
	      };
	
	      SankeyPath.prototype.highlight = function () {
	        enterEmphasis(this);
	      };
	
	      SankeyPath.prototype.downplay = function () {
	        leaveEmphasis(this);
	      };
	
	      return SankeyPath;
	    }(Path);
	
	    var SankeyView =
	    /** @class */
	    function (_super) {
	      __extends(SankeyView, _super);
	
	      function SankeyView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SankeyView.type;
	        _this._focusAdjacencyDisabled = false;
	        return _this;
	      }
	
	      SankeyView.prototype.render = function (seriesModel, ecModel, api) {
	        var sankeyView = this;
	        var graph = seriesModel.getGraph();
	        var group = this.group;
	        var layoutInfo = seriesModel.layoutInfo; // view width
	
	        var width = layoutInfo.width; // view height
	
	        var height = layoutInfo.height;
	        var nodeData = seriesModel.getData();
	        var edgeData = seriesModel.getData('edge');
	        var orient = seriesModel.get('orient');
	        this._model = seriesModel;
	        group.removeAll();
	        group.x = layoutInfo.x;
	        group.y = layoutInfo.y; // generate a bezire Curve for each edge
	
	        graph.eachEdge(function (edge) {
	          var curve = new SankeyPath();
	          var ecData = getECData(curve);
	          ecData.dataIndex = edge.dataIndex;
	          ecData.seriesIndex = seriesModel.seriesIndex;
	          ecData.dataType = 'edge';
	          var edgeModel = edge.getModel();
	          var lineStyleModel = edgeModel.getModel('lineStyle');
	          var curvature = lineStyleModel.get('curveness');
	          var n1Layout = edge.node1.getLayout();
	          var node1Model = edge.node1.getModel();
	          var dragX1 = node1Model.get('localX');
	          var dragY1 = node1Model.get('localY');
	          var n2Layout = edge.node2.getLayout();
	          var node2Model = edge.node2.getModel();
	          var dragX2 = node2Model.get('localX');
	          var dragY2 = node2Model.get('localY');
	          var edgeLayout = edge.getLayout();
	          var x1;
	          var y1;
	          var x2;
	          var y2;
	          var cpx1;
	          var cpy1;
	          var cpx2;
	          var cpy2;
	          curve.shape.extent = Math.max(1, edgeLayout.dy);
	          curve.shape.orient = orient;
	
	          if (orient === 'vertical') {
	            x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
	            y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
	            x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
	            y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
	            cpx1 = x1;
	            cpy1 = y1 * (1 - curvature) + y2 * curvature;
	            cpx2 = x2;
	            cpy2 = y1 * curvature + y2 * (1 - curvature);
	          } else {
	            x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
	            y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
	            x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
	            y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
	            cpx1 = x1 * (1 - curvature) + x2 * curvature;
	            cpy1 = y1;
	            cpx2 = x1 * curvature + x2 * (1 - curvature);
	            cpy2 = y2;
	          }
	
	          curve.setShape({
	            x1: x1,
	            y1: y1,
	            x2: x2,
	            y2: y2,
	            cpx1: cpx1,
	            cpy1: cpy1,
	            cpx2: cpx2,
	            cpy2: cpy2
	          });
	          curve.useStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color
	
	          applyCurveStyle(curve.style, orient, edge);
	          var defaultEdgeLabelText = "" + edgeModel.get('value');
	          var edgeLabelStateModels = getLabelStatesModels(edgeModel, 'edgeLabel');
	          setLabelStyle(curve, edgeLabelStateModels, {
	            labelFetcher: {
	              getFormattedLabel: function (dataIndex, stateName, dataType, labelDimIndex, formatter, extendParams) {
	                return seriesModel.getFormattedLabel(dataIndex, stateName, 'edge', labelDimIndex, // ensure edgeLabel formatter is provided
	                // to prevent the inheritance from `label.formatter` of the series
	                retrieve3(formatter, edgeLabelStateModels.normal && edgeLabelStateModels.normal.get('formatter'), defaultEdgeLabelText), extendParams);
	              }
	            },
	            labelDataIndex: edge.dataIndex,
	            defaultText: defaultEdgeLabelText
	          });
	          curve.setTextConfig({
	            position: 'inside'
	          });
	          var emphasisModel = edgeModel.getModel('emphasis');
	          setStatesStylesFromModel(curve, edgeModel, 'lineStyle', function (model) {
	            var style = model.getItemStyle();
	            applyCurveStyle(style, orient, edge);
	            return style;
	          });
	          group.add(curve);
	          edgeData.setItemGraphicEl(edge.dataIndex, curve);
	          var focus = emphasisModel.get('focus');
	          toggleHoverEmphasis(curve, focus === 'adjacency' ? edge.getAdjacentDataIndices() : focus === 'trajectory' ? edge.getTrajectoryDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	        }); // Generate a rect for each node
	
	        graph.eachNode(function (node) {
	          var layout = node.getLayout();
	          var itemModel = node.getModel();
	          var dragX = itemModel.get('localX');
	          var dragY = itemModel.get('localY');
	          var emphasisModel = itemModel.getModel('emphasis');
	          var rect = new Rect({
	            shape: {
	              x: dragX != null ? dragX * width : layout.x,
	              y: dragY != null ? dragY * height : layout.y,
	              width: layout.dx,
	              height: layout.dy
	            },
	            style: itemModel.getModel('itemStyle').getItemStyle(),
	            z2: 10
	          });
	          setLabelStyle(rect, getLabelStatesModels(itemModel), {
	            labelFetcher: {
	              getFormattedLabel: function (dataIndex, stateName) {
	                return seriesModel.getFormattedLabel(dataIndex, stateName, 'node');
	              }
	            },
	            labelDataIndex: node.dataIndex,
	            defaultText: node.id
	          });
	          rect.disableLabelAnimation = true;
	          rect.setStyle('fill', node.getVisual('color'));
	          rect.setStyle('decal', node.getVisual('style').decal);
	          setStatesStylesFromModel(rect, itemModel);
	          group.add(rect);
	          nodeData.setItemGraphicEl(node.dataIndex, rect);
	          getECData(rect).dataType = 'node';
	          var focus = emphasisModel.get('focus');
	          toggleHoverEmphasis(rect, focus === 'adjacency' ? node.getAdjacentDataIndices() : focus === 'trajectory' ? node.getTrajectoryDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	        });
	        nodeData.eachItemGraphicEl(function (el, dataIndex) {
	          var itemModel = nodeData.getItemModel(dataIndex);
	
	          if (itemModel.get('draggable')) {
	            el.drift = function (dx, dy) {
	              sankeyView._focusAdjacencyDisabled = true;
	              this.shape.x += dx;
	              this.shape.y += dy;
	              this.dirty();
	              api.dispatchAction({
	                type: 'dragNode',
	                seriesId: seriesModel.id,
	                dataIndex: nodeData.getRawIndex(dataIndex),
	                localX: this.shape.x / width,
	                localY: this.shape.y / height
	              });
	            };
	
	            el.ondragend = function () {
	              sankeyView._focusAdjacencyDisabled = false;
	            };
	
	            el.draggable = true;
	            el.cursor = 'move';
	          }
	        });
	
	        if (!this._data && seriesModel.isAnimationEnabled()) {
	          group.setClipPath(createGridClipShape$1(group.getBoundingRect(), seriesModel, function () {
	            group.removeClipPath();
	          }));
	        }
	
	        this._data = seriesModel.getData();
	      };
	
	      SankeyView.prototype.dispose = function () {};
	
	      SankeyView.type = 'sankey';
	      return SankeyView;
	    }(ChartView);
	    /**
	     * Special color, use source node color or target node color
	     * @param curveProps curve's style to parse
	     * @param orient direction
	     * @param edge current curve data
	     */
	
	
	    function applyCurveStyle(curveProps, orient, edge) {
	      switch (curveProps.fill) {
	        case 'source':
	          curveProps.fill = edge.node1.getVisual('color');
	          curveProps.decal = edge.node1.getVisual('style').decal;
	          break;
	
	        case 'target':
	          curveProps.fill = edge.node2.getVisual('color');
	          curveProps.decal = edge.node2.getVisual('style').decal;
	          break;
	
	        case 'gradient':
	          var sourceColor = edge.node1.getVisual('color');
	          var targetColor = edge.node2.getVisual('color');
	
	          if (isString(sourceColor) && isString(targetColor)) {
	            curveProps.fill = new LinearGradient(0, 0, +(orient === 'horizontal'), +(orient === 'vertical'), [{
	              color: sourceColor,
	              offset: 0
	            }, {
	              color: targetColor,
	              offset: 1
	            }]);
	          }
	
	      }
	    } // Add animation to the view
	
	
	    function createGridClipShape$1(rect, seriesModel, cb) {
	      var rectEl = new Rect({
	        shape: {
	          x: rect.x - 10,
	          y: rect.y - 10,
	          width: 0,
	          height: rect.height + 20
	        }
	      });
	      initProps(rectEl, {
	        shape: {
	          width: rect.width + 20
	        }
	      }, seriesModel, cb);
	      return rectEl;
	    }
	
	    var SankeySeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(SankeySeriesModel, _super);
	
	      function SankeySeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SankeySeriesModel.type;
	        return _this;
	      }
	      /**
	       * Init a graph data structure from data in option series
	       */
	
	
	      SankeySeriesModel.prototype.getInitialData = function (option, ecModel) {
	        var links = option.edges || option.links;
	        var nodes = option.data || option.nodes;
	        var levels = option.levels;
	        this.levelModels = [];
	        var levelModels = this.levelModels;
	
	        for (var i = 0; i < levels.length; i++) {
	          if (levels[i].depth != null && levels[i].depth >= 0) {
	            levelModels[levels[i].depth] = new Model(levels[i], this, ecModel);
	          } else {
	            if (true) {
	              throw new Error('levels[i].depth is mandatory and should be natural number');
	            }
	          }
	        }
	
	        if (nodes && links) {
	          var graph = createGraphFromNodeEdge(nodes, links, this, true, beforeLink);
	          return graph.data;
	        }
	
	        function beforeLink(nodeData, edgeData) {
	          nodeData.wrapMethod('getItemModel', function (model, idx) {
	            var seriesModel = model.parentModel;
	            var layout = seriesModel.getData().getItemLayout(idx);
	
	            if (layout) {
	              var nodeDepth = layout.depth;
	              var levelModel = seriesModel.levelModels[nodeDepth];
	
	              if (levelModel) {
	                model.parentModel = levelModel;
	              }
	            }
	
	            return model;
	          });
	          edgeData.wrapMethod('getItemModel', function (model, idx) {
	            var seriesModel = model.parentModel;
	            var edge = seriesModel.getGraph().getEdgeByIndex(idx);
	            var layout = edge.node1.getLayout();
	
	            if (layout) {
	              var depth = layout.depth;
	              var levelModel = seriesModel.levelModels[depth];
	
	              if (levelModel) {
	                model.parentModel = levelModel;
	              }
	            }
	
	            return model;
	          });
	        }
	      };
	
	      SankeySeriesModel.prototype.setNodePosition = function (dataIndex, localPosition) {
	        var nodes = this.option.data || this.option.nodes;
	        var dataItem = nodes[dataIndex];
	        dataItem.localX = localPosition[0];
	        dataItem.localY = localPosition[1];
	      };
	      /**
	       * Return the graphic data structure
	       *
	       * @return graphic data structure
	       */
	
	
	      SankeySeriesModel.prototype.getGraph = function () {
	        return this.getData().graph;
	      };
	      /**
	       * Get edge data of graphic data structure
	       *
	       * @return data structure of list
	       */
	
	
	      SankeySeriesModel.prototype.getEdgeData = function () {
	        return this.getGraph().edgeData;
	      };
	
	      SankeySeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        function noValue(val) {
	          return isNaN(val) || val == null;
	        } // dataType === 'node' or empty do not show tooltip by default
	
	
	        if (dataType === 'edge') {
	          var params = this.getDataParams(dataIndex, dataType);
	          var rawDataOpt = params.data;
	          var edgeValue = params.value;
	          var edgeName = rawDataOpt.source + ' -- ' + rawDataOpt.target;
	          return createTooltipMarkup('nameValue', {
	            name: edgeName,
	            value: edgeValue,
	            noValue: noValue(edgeValue)
	          });
	        } // dataType === 'node'
	        else {
	            var node = this.getGraph().getNodeByIndex(dataIndex);
	            var value = node.getLayout().value;
	            var name_1 = this.getDataParams(dataIndex, dataType).data.name;
	            return createTooltipMarkup('nameValue', {
	              name: name_1 != null ? name_1 + '' : null,
	              value: value,
	              noValue: noValue(value)
	            });
	          }
	      };
	
	      SankeySeriesModel.prototype.optionUpdated = function () {}; // Override Series.getDataParams()
	
	
	      SankeySeriesModel.prototype.getDataParams = function (dataIndex, dataType) {
	        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
	
	        if (params.value == null && dataType === 'node') {
	          var node = this.getGraph().getNodeByIndex(dataIndex);
	          var nodeValue = node.getLayout().value;
	          params.value = nodeValue;
	        }
	
	        return params;
	      };
	
	      SankeySeriesModel.type = 'series.sankey';
	      SankeySeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        coordinateSystem: 'view',
	        left: '5%',
	        top: '5%',
	        right: '20%',
	        bottom: '5%',
	        orient: 'horizontal',
	        nodeWidth: 20,
	        nodeGap: 8,
	        draggable: true,
	        layoutIterations: 32,
	        label: {
	          show: true,
	          position: 'right',
	          fontSize: 12
	        },
	        edgeLabel: {
	          show: false,
	          fontSize: 12
	        },
	        levels: [],
	        nodeAlign: 'justify',
	        lineStyle: {
	          color: '#314656',
	          opacity: 0.2,
	          curveness: 0.5
	        },
	        emphasis: {
	          label: {
	            show: true
	          },
	          lineStyle: {
	            opacity: 0.5
	          }
	        },
	        select: {
	          itemStyle: {
	            borderColor: '#212121'
	          }
	        },
	        animationEasing: 'linear',
	        animationDuration: 1000
	      };
	      return SankeySeriesModel;
	    }(SeriesModel);
	
	    function sankeyLayout(ecModel, api) {
	      ecModel.eachSeriesByType('sankey', function (seriesModel) {
	        var nodeWidth = seriesModel.get('nodeWidth');
	        var nodeGap = seriesModel.get('nodeGap');
	        var layoutInfo = getViewRect$4(seriesModel, api);
	        seriesModel.layoutInfo = layoutInfo;
	        var width = layoutInfo.width;
	        var height = layoutInfo.height;
	        var graph = seriesModel.getGraph();
	        var nodes = graph.nodes;
	        var edges = graph.edges;
	        computeNodeValues(nodes);
	        var filteredNodes = filter(nodes, function (node) {
	          return node.getLayout().value === 0;
	        });
	        var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
	        var orient = seriesModel.get('orient');
	        var nodeAlign = seriesModel.get('nodeAlign');
	        layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
	      });
	    }
	    /**
	     * Get the layout position of the whole view
	     */
	
	    function getViewRect$4(seriesModel, api) {
	      return getLayoutRect(seriesModel.getBoxLayoutParams(), {
	        width: api.getWidth(),
	        height: api.getHeight()
	      });
	    }
	
	    function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
	      computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
	      computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
	      computeEdgeDepths(nodes, orient);
	    }
	    /**
	     * Compute the value of each node by summing the associated edge's value
	     */
	
	
	    function computeNodeValues(nodes) {
	      each(nodes, function (node) {
	        var value1 = sum(node.outEdges, getEdgeValue);
	        var value2 = sum(node.inEdges, getEdgeValue);
	        var nodeRawValue = node.getValue() || 0;
	        var value = Math.max(value1, value2, nodeRawValue);
	        node.setLayout({
	          value: value
	        }, true);
	      });
	    }
	    /**
	     * Compute the x-position for each node.
	     *
	     * Here we use Kahn algorithm to detect cycle when we traverse
	     * the node to computer the initial x position.
	     */
	
	
	    function computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
	      // Used to mark whether the edge is deleted. if it is deleted,
	      // the value is 0, otherwise it is 1.
	      var remainEdges = []; // Storage each node's indegree.
	
	      var indegreeArr = []; // Used to storage the node with indegree is equal to 0.
	
	      var zeroIndegrees = [];
	      var nextTargetNode = [];
	      var x = 0; // let kx = 0;
	
	      for (var i = 0; i < edges.length; i++) {
	        remainEdges[i] = 1;
	      }
	
	      for (var i = 0; i < nodes.length; i++) {
	        indegreeArr[i] = nodes[i].inEdges.length;
	
	        if (indegreeArr[i] === 0) {
	          zeroIndegrees.push(nodes[i]);
	        }
	      }
	
	      var maxNodeDepth = -1; // Traversing nodes using topological sorting to calculate the
	      // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
	      // position of the nodes.
	
	      while (zeroIndegrees.length) {
	        for (var idx = 0; idx < zeroIndegrees.length; idx++) {
	          var node = zeroIndegrees[idx];
	          var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	          var isItemDepth = item.depth != null && item.depth >= 0;
	
	          if (isItemDepth && item.depth > maxNodeDepth) {
	            maxNodeDepth = item.depth;
	          }
	
	          node.setLayout({
	            depth: isItemDepth ? item.depth : x
	          }, true);
	          orient === 'vertical' ? node.setLayout({
	            dy: nodeWidth
	          }, true) : node.setLayout({
	            dx: nodeWidth
	          }, true);
	
	          for (var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++) {
	            var edge = node.outEdges[edgeIdx];
	            var indexEdge = edges.indexOf(edge);
	            remainEdges[indexEdge] = 0;
	            var targetNode = edge.node2;
	            var nodeIndex = nodes.indexOf(targetNode);
	
	            if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) {
	              nextTargetNode.push(targetNode);
	            }
	          }
	        }
	
	        ++x;
	        zeroIndegrees = nextTargetNode;
	        nextTargetNode = [];
	      }
	
	      for (var i = 0; i < remainEdges.length; i++) {
	        if (remainEdges[i] === 1) {
	          throw new Error('Sankey is a DAG, the original data has cycle!');
	        }
	      }
	
	      var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
	
	      if (nodeAlign && nodeAlign !== 'left') {
	        adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
	      }
	
	      var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
	      scaleNodeBreadths(nodes, kx, orient);
	    }
	
	    function isNodeDepth(node) {
	      var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	      return item.depth != null && item.depth >= 0;
	    }
	
	    function adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
	      if (nodeAlign === 'right') {
	        var nextSourceNode = [];
	        var remainNodes = nodes;
	        var nodeHeight = 0;
	
	        while (remainNodes.length) {
	          for (var i = 0; i < remainNodes.length; i++) {
	            var node = remainNodes[i];
	            node.setLayout({
	              skNodeHeight: nodeHeight
	            }, true);
	
	            for (var j = 0; j < node.inEdges.length; j++) {
	              var edge = node.inEdges[j];
	
	              if (nextSourceNode.indexOf(edge.node1) < 0) {
	                nextSourceNode.push(edge.node1);
	              }
	            }
	          }
	
	          remainNodes = nextSourceNode;
	          nextSourceNode = [];
	          ++nodeHeight;
	        }
	
	        each(nodes, function (node) {
	          if (!isNodeDepth(node)) {
	            node.setLayout({
	              depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
	            }, true);
	          }
	        });
	      } else if (nodeAlign === 'justify') {
	        moveSinksRight(nodes, maxDepth);
	      }
	    }
	    /**
	     * All the node without outEgdes are assigned maximum x-position and
	     *     be aligned in the last column.
	     *
	     * @param nodes.  node of sankey view.
	     * @param maxDepth.  use to assign to node without outEdges as x-position.
	     */
	
	
	    function moveSinksRight(nodes, maxDepth) {
	      each(nodes, function (node) {
	        if (!isNodeDepth(node) && !node.outEdges.length) {
	          node.setLayout({
	            depth: maxDepth
	          }, true);
	        }
	      });
	    }
	    /**
	     * Scale node x-position to the width
	     *
	     * @param nodes  node of sankey view
	     * @param kx   multiple used to scale nodes
	     */
	
	
	    function scaleNodeBreadths(nodes, kx, orient) {
	      each(nodes, function (node) {
	        var nodeDepth = node.getLayout().depth * kx;
	        orient === 'vertical' ? node.setLayout({
	          y: nodeDepth
	        }, true) : node.setLayout({
	          x: nodeDepth
	        }, true);
	      });
	    }
	    /**
	     * Using Gauss-Seidel iterations method to compute the node depth(y-position)
	     *
	     * @param nodes  node of sankey view
	     * @param edges  edge of sankey view
	     * @param height  the whole height of the area to draw the view
	     * @param nodeGap  the vertical distance between two nodes
	     *     in the same column.
	     * @param iterations  the number of iterations for the algorithm
	     */
	
	
	    function computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
	      var nodesByBreadth = prepareNodesByBreadth(nodes, orient);
	      initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
	      resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	
	      for (var alpha = 1; iterations > 0; iterations--) {
	        // 0.99 is a experience parameter, ensure that each iterations of
	        // changes as small as possible.
	        alpha *= 0.99;
	        relaxRightToLeft(nodesByBreadth, alpha, orient);
	        resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	        relaxLeftToRight(nodesByBreadth, alpha, orient);
	        resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	      }
	    }
	
	    function prepareNodesByBreadth(nodes, orient) {
	      var nodesByBreadth = [];
	      var keyAttr = orient === 'vertical' ? 'y' : 'x';
	      var groupResult = groupData(nodes, function (node) {
	        return node.getLayout()[keyAttr];
	      });
	      groupResult.keys.sort(function (a, b) {
	        return a - b;
	      });
	      each(groupResult.keys, function (key) {
	        nodesByBreadth.push(groupResult.buckets.get(key));
	      });
	      return nodesByBreadth;
	    }
	    /**
	     * Compute the original y-position for each node
	     */
	
	
	    function initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
	      var minKy = Infinity;
	      each(nodesByBreadth, function (nodes) {
	        var n = nodes.length;
	        var sum = 0;
	        each(nodes, function (node) {
	          sum += node.getLayout().value;
	        });
	        var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
	
	        if (ky < minKy) {
	          minKy = ky;
	        }
	      });
	      each(nodesByBreadth, function (nodes) {
	        each(nodes, function (node, i) {
	          var nodeDy = node.getLayout().value * minKy;
	
	          if (orient === 'vertical') {
	            node.setLayout({
	              x: i
	            }, true);
	            node.setLayout({
	              dx: nodeDy
	            }, true);
	          } else {
	            node.setLayout({
	              y: i
	            }, true);
	            node.setLayout({
	              dy: nodeDy
	            }, true);
	          }
	        });
	      });
	      each(edges, function (edge) {
	        var edgeDy = +edge.getValue() * minKy;
	        edge.setLayout({
	          dy: edgeDy
	        }, true);
	      });
	    }
	    /**
	     * Resolve the collision of initialized depth (y-position)
	     */
	
	
	    function resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
	      var keyAttr = orient === 'vertical' ? 'x' : 'y';
	      each(nodesByBreadth, function (nodes) {
	        nodes.sort(function (a, b) {
	          return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
	        });
	        var nodeX;
	        var node;
	        var dy;
	        var y0 = 0;
	        var n = nodes.length;
	        var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';
	
	        for (var i = 0; i < n; i++) {
	          node = nodes[i];
	          dy = y0 - node.getLayout()[keyAttr];
	
	          if (dy > 0) {
	            nodeX = node.getLayout()[keyAttr] + dy;
	            orient === 'vertical' ? node.setLayout({
	              x: nodeX
	            }, true) : node.setLayout({
	              y: nodeX
	            }, true);
	          }
	
	          y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
	        }
	
	        var viewWidth = orient === 'vertical' ? width : height; // If the bottommost node goes outside the bounds, push it back up
	
	        dy = y0 - nodeGap - viewWidth;
	
	        if (dy > 0) {
	          nodeX = node.getLayout()[keyAttr] - dy;
	          orient === 'vertical' ? node.setLayout({
	            x: nodeX
	          }, true) : node.setLayout({
	            y: nodeX
	          }, true);
	          y0 = nodeX;
	
	          for (var i = n - 2; i >= 0; --i) {
	            node = nodes[i];
	            dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
	
	            if (dy > 0) {
	              nodeX = node.getLayout()[keyAttr] - dy;
	              orient === 'vertical' ? node.setLayout({
	                x: nodeX
	              }, true) : node.setLayout({
	                y: nodeX
	              }, true);
	            }
	
	            y0 = node.getLayout()[keyAttr];
	          }
	        }
	      });
	    }
	    /**
	     * Change the y-position of the nodes, except most the right side nodes
	     * @param nodesByBreadth
	     * @param alpha  parameter used to adjust the nodes y-position
	     */
	
	
	    function relaxRightToLeft(nodesByBreadth, alpha, orient) {
	      each(nodesByBreadth.slice().reverse(), function (nodes) {
	        each(nodes, function (node) {
	          if (node.outEdges.length) {
	            var y = sum(node.outEdges, weightedTarget, orient) / sum(node.outEdges, getEdgeValue);
	
	            if (isNaN(y)) {
	              var len = node.outEdges.length;
	              y = len ? sum(node.outEdges, centerTarget, orient) / len : 0;
	            }
	
	            if (orient === 'vertical') {
	              var nodeX = node.getLayout().x + (y - center$1(node, orient)) * alpha;
	              node.setLayout({
	                x: nodeX
	              }, true);
	            } else {
	              var nodeY = node.getLayout().y + (y - center$1(node, orient)) * alpha;
	              node.setLayout({
	                y: nodeY
	              }, true);
	            }
	          }
	        });
	      });
	    }
	
	    function weightedTarget(edge, orient) {
	      return center$1(edge.node2, orient) * edge.getValue();
	    }
	
	    function centerTarget(edge, orient) {
	      return center$1(edge.node2, orient);
	    }
	
	    function weightedSource(edge, orient) {
	      return center$1(edge.node1, orient) * edge.getValue();
	    }
	
	    function centerSource(edge, orient) {
	      return center$1(edge.node1, orient);
	    }
	
	    function center$1(node, orient) {
	      return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
	    }
	
	    function getEdgeValue(edge) {
	      return edge.getValue();
	    }
	
	    function sum(array, cb, orient) {
	      var sum = 0;
	      var len = array.length;
	      var i = -1;
	
	      while (++i < len) {
	        var value = +cb(array[i], orient);
	
	        if (!isNaN(value)) {
	          sum += value;
	        }
	      }
	
	      return sum;
	    }
	    /**
	     * Change the y-position of the nodes, except most the left side nodes
	     */
	
	
	    function relaxLeftToRight(nodesByBreadth, alpha, orient) {
	      each(nodesByBreadth, function (nodes) {
	        each(nodes, function (node) {
	          if (node.inEdges.length) {
	            var y = sum(node.inEdges, weightedSource, orient) / sum(node.inEdges, getEdgeValue);
	
	            if (isNaN(y)) {
	              var len = node.inEdges.length;
	              y = len ? sum(node.inEdges, centerSource, orient) / len : 0;
	            }
	
	            if (orient === 'vertical') {
	              var nodeX = node.getLayout().x + (y - center$1(node, orient)) * alpha;
	              node.setLayout({
	                x: nodeX
	              }, true);
	            } else {
	              var nodeY = node.getLayout().y + (y - center$1(node, orient)) * alpha;
	              node.setLayout({
	                y: nodeY
	              }, true);
	            }
	          }
	        });
	      });
	    }
	    /**
	     * Compute the depth(y-position) of each edge
	     */
	
	
	    function computeEdgeDepths(nodes, orient) {
	      var keyAttr = orient === 'vertical' ? 'x' : 'y';
	      each(nodes, function (node) {
	        node.outEdges.sort(function (a, b) {
	          return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
	        });
	        node.inEdges.sort(function (a, b) {
	          return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
	        });
	      });
	      each(nodes, function (node) {
	        var sy = 0;
	        var ty = 0;
	        each(node.outEdges, function (edge) {
	          edge.setLayout({
	            sy: sy
	          }, true);
	          sy += edge.getLayout().dy;
	        });
	        each(node.inEdges, function (edge) {
	          edge.setLayout({
	            ty: ty
	          }, true);
	          ty += edge.getLayout().dy;
	        });
	      });
	    }
	
	    function sankeyVisual(ecModel) {
	      ecModel.eachSeriesByType('sankey', function (seriesModel) {
	        var graph = seriesModel.getGraph();
	        var nodes = graph.nodes;
	        var edges = graph.edges;
	
	        if (nodes.length) {
	          var minValue_1 = Infinity;
	          var maxValue_1 = -Infinity;
	          each(nodes, function (node) {
	            var nodeValue = node.getLayout().value;
	
	            if (nodeValue < minValue_1) {
	              minValue_1 = nodeValue;
	            }
	
	            if (nodeValue > maxValue_1) {
	              maxValue_1 = nodeValue;
	            }
	          });
	          each(nodes, function (node) {
	            var mapping = new VisualMapping({
	              type: 'color',
	              mappingMethod: 'linear',
	              dataExtent: [minValue_1, maxValue_1],
	              visual: seriesModel.get('color')
	            });
	            var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
	            var customColor = node.getModel().get(['itemStyle', 'color']);
	
	            if (customColor != null) {
	              node.setVisual('color', customColor);
	              node.setVisual('style', {
	                fill: customColor
	              });
	            } else {
	              node.setVisual('color', mapValueToColor);
	              node.setVisual('style', {
	                fill: mapValueToColor
	              });
	            }
	          });
	        }
	
	        if (edges.length) {
	          each(edges, function (edge) {
	            var edgeStyle = edge.getModel().get('lineStyle');
	            edge.setVisual('style', edgeStyle);
	          });
	        }
	      });
	    }
	
	    function install$i(registers) {
	      registers.registerChartView(SankeyView);
	      registers.registerSeriesModel(SankeySeriesModel);
	      registers.registerLayout(sankeyLayout);
	      registers.registerVisual(sankeyVisual);
	      registers.registerAction({
	        type: 'dragNode',
	        event: 'dragnode',
	        // here can only use 'update' now, other value is not support in echarts.
	        update: 'update'
	      }, function (payload, ecModel) {
	        ecModel.eachComponent({
	          mainType: 'series',
	          subType: 'sankey',
	          query: payload
	        }, function (seriesModel) {
	          seriesModel.setNodePosition(payload.dataIndex, [payload.localX, payload.localY]);
	        });
	      });
	    }
	
	    var WhiskerBoxCommonMixin =
	    /** @class */
	    function () {
	      function WhiskerBoxCommonMixin() {}
	      /**
	       * @override
	       */
	
	
	      WhiskerBoxCommonMixin.prototype.getInitialData = function (option, ecModel) {
	        // When both types of xAxis and yAxis are 'value', layout is
	        // needed to be specified by user. Otherwise, layout can be
	        // judged by which axis is category.
	        var ordinalMeta;
	        var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
	        var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
	        var xAxisType = xAxisModel.get('type');
	        var yAxisType = yAxisModel.get('type');
	        var addOrdinal; // FIXME
	        // Consider time axis.
	
	        if (xAxisType === 'category') {
	          option.layout = 'horizontal';
	          ordinalMeta = xAxisModel.getOrdinalMeta();
	          addOrdinal = true;
	        } else if (yAxisType === 'category') {
	          option.layout = 'vertical';
	          ordinalMeta = yAxisModel.getOrdinalMeta();
	          addOrdinal = true;
	        } else {
	          option.layout = option.layout || 'horizontal';
	        }
	
	        var coordDims = ['x', 'y'];
	        var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
	        var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
	        var otherAxisDim = coordDims[1 - baseAxisDimIndex];
	        var axisModels = [xAxisModel, yAxisModel];
	        var baseAxisType = axisModels[baseAxisDimIndex].get('type');
	        var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
	        var data = option.data; // Clone a new data for next setOption({}) usage.
	        // Avoid modifying current data will affect further update.
	
	        if (data && addOrdinal) {
	          var newOptionData_1 = [];
	          each(data, function (item, index) {
	            var newItem;
	
	            if (isArray(item)) {
	              newItem = item.slice(); // Modify current using data.
	
	              item.unshift(index);
	            } else if (isArray(item.value)) {
	              newItem = extend({}, item);
	              newItem.value = newItem.value.slice(); // Modify current using data.
	
	              item.value.unshift(index);
	            } else {
	              newItem = item;
	            }
	
	            newOptionData_1.push(newItem);
	          });
	          option.data = newOptionData_1;
	        }
	
	        var defaultValueDimensions = this.defaultValueDimensions;
	        var coordDimensions = [{
	          name: baseAxisDim,
	          type: getDimensionTypeByAxis(baseAxisType),
	          ordinalMeta: ordinalMeta,
	          otherDims: {
	            tooltip: false,
	            itemName: 0
	          },
	          dimsDef: ['base']
	        }, {
	          name: otherAxisDim,
	          type: getDimensionTypeByAxis(otherAxisType),
	          dimsDef: defaultValueDimensions.slice()
	        }];
	        return createSeriesDataSimply(this, {
	          coordDimensions: coordDimensions,
	          dimensionsCount: defaultValueDimensions.length + 1,
	          encodeDefaulter: curry(makeSeriesEncodeForAxisCoordSys, coordDimensions, this)
	        });
	      };
	      /**
	       * If horizontal, base axis is x, otherwise y.
	       * @override
	       */
	
	
	      WhiskerBoxCommonMixin.prototype.getBaseAxis = function () {
	        var dim = this._baseAxisDim;
	        return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
	      };
	
	      return WhiskerBoxCommonMixin;
	    }();
	
	    var BoxplotSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(BoxplotSeriesModel, _super);
	
	      function BoxplotSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = BoxplotSeriesModel.type; // TODO
	        // box width represents group size, so dimension should have 'size'.
	
	        /**
	         * @see <https://en.wikipedia.org/wiki/Box_plot>
	         * The meanings of 'min' and 'max' depend on user,
	         * and echarts do not need to know it.
	         * @readOnly
	         */
	
	        _this.defaultValueDimensions = [{
	          name: 'min',
	          defaultTooltip: true
	        }, {
	          name: 'Q1',
	          defaultTooltip: true
	        }, {
	          name: 'median',
	          defaultTooltip: true
	        }, {
	          name: 'Q3',
	          defaultTooltip: true
	        }, {
	          name: 'max',
	          defaultTooltip: true
	        }];
	        _this.visualDrawType = 'stroke';
	        return _this;
	      }
	
	      BoxplotSeriesModel.type = 'series.boxplot';
	      BoxplotSeriesModel.dependencies = ['xAxis', 'yAxis', 'grid'];
	      BoxplotSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        coordinateSystem: 'cartesian2d',
	        legendHoverLink: true,
	        layout: null,
	        boxWidth: [7, 50],
	        itemStyle: {
	          color: '#fff',
	          borderWidth: 1
	        },
	        emphasis: {
	          scale: true,
	          itemStyle: {
	            borderWidth: 2,
	            shadowBlur: 5,
	            shadowOffsetX: 1,
	            shadowOffsetY: 1,
	            shadowColor: 'rgba(0,0,0,0.2)'
	          }
	        },
	        animationDuration: 800
	      };
	      return BoxplotSeriesModel;
	    }(SeriesModel);
	
	    mixin(BoxplotSeriesModel, WhiskerBoxCommonMixin, true);
	
	    var BoxplotView =
	    /** @class */
	    function (_super) {
	      __extends(BoxplotView, _super);
	
	      function BoxplotView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = BoxplotView.type;
	        return _this;
	      }
	
	      BoxplotView.prototype.render = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	        var group = this.group;
	        var oldData = this._data; // There is no old data only when first rendering or switching from
	        // stream mode to normal mode, where previous elements should be removed.
	
	        if (!this._data) {
	          group.removeAll();
	        }
	
	        var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
	        data.diff(oldData).add(function (newIdx) {
	          if (data.hasValue(newIdx)) {
	            var itemLayout = data.getItemLayout(newIdx);
	            var symbolEl = createNormalBox(itemLayout, data, newIdx, constDim, true);
	            data.setItemGraphicEl(newIdx, symbolEl);
	            group.add(symbolEl);
	          }
	        }).update(function (newIdx, oldIdx) {
	          var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	          if (!data.hasValue(newIdx)) {
	            group.remove(symbolEl);
	            return;
	          }
	
	          var itemLayout = data.getItemLayout(newIdx);
	
	          if (!symbolEl) {
	            symbolEl = createNormalBox(itemLayout, data, newIdx, constDim);
	          } else {
	            saveOldStyle(symbolEl);
	            updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
	          }
	
	          group.add(symbolEl);
	          data.setItemGraphicEl(newIdx, symbolEl);
	        }).remove(function (oldIdx) {
	          var el = oldData.getItemGraphicEl(oldIdx);
	          el && group.remove(el);
	        }).execute();
	        this._data = data;
	      };
	
	      BoxplotView.prototype.remove = function (ecModel) {
	        var group = this.group;
	        var data = this._data;
	        this._data = null;
	        data && data.eachItemGraphicEl(function (el) {
	          el && group.remove(el);
	        });
	      };
	
	      BoxplotView.type = 'boxplot';
	      return BoxplotView;
	    }(ChartView);
	
	    var BoxPathShape =
	    /** @class */
	    function () {
	      function BoxPathShape() {}
	
	      return BoxPathShape;
	    }();
	
	    var BoxPath =
	    /** @class */
	    function (_super) {
	      __extends(BoxPath, _super);
	
	      function BoxPath(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this.type = 'boxplotBoxPath';
	        return _this;
	      }
	
	      BoxPath.prototype.getDefaultShape = function () {
	        return new BoxPathShape();
	      };
	
	      BoxPath.prototype.buildPath = function (ctx, shape) {
	        var ends = shape.points;
	        var i = 0;
	        ctx.moveTo(ends[i][0], ends[i][1]);
	        i++;
	
	        for (; i < 4; i++) {
	          ctx.lineTo(ends[i][0], ends[i][1]);
	        }
	
	        ctx.closePath();
	
	        for (; i < ends.length; i++) {
	          ctx.moveTo(ends[i][0], ends[i][1]);
	          i++;
	          ctx.lineTo(ends[i][0], ends[i][1]);
	        }
	      };
	
	      return BoxPath;
	    }(Path);
	
	    function createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
	      var ends = itemLayout.ends;
	      var el = new BoxPath({
	        shape: {
	          points: isInit ? transInit(ends, constDim, itemLayout) : ends
	        }
	      });
	      updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
	      return el;
	    }
	
	    function updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
	      var seriesModel = data.hostModel;
	      var updateMethod = graphic[isInit ? 'initProps' : 'updateProps'];
	      updateMethod(el, {
	        shape: {
	          points: itemLayout.ends
	        }
	      }, seriesModel, dataIndex);
	      el.useStyle(data.getItemVisual(dataIndex, 'style'));
	      el.style.strokeNoScale = true;
	      el.z2 = 100;
	      var itemModel = data.getItemModel(dataIndex);
	      var emphasisModel = itemModel.getModel('emphasis');
	      setStatesStylesFromModel(el, itemModel);
	      toggleHoverEmphasis(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	    }
	
	    function transInit(points, dim, itemLayout) {
	      return map(points, function (point) {
	        point = point.slice();
	        point[dim] = itemLayout.initBaseline;
	        return point;
	      });
	    }
	
	    var each$6 = each;
	    function boxplotLayout(ecModel) {
	      var groupResult = groupSeriesByAxis(ecModel);
	      each$6(groupResult, function (groupItem) {
	        var seriesModels = groupItem.seriesModels;
	
	        if (!seriesModels.length) {
	          return;
	        }
	
	        calculateBase(groupItem);
	        each$6(seriesModels, function (seriesModel, idx) {
	          layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
	        });
	      });
	    }
	    /**
	     * Group series by axis.
	     */
	
	    function groupSeriesByAxis(ecModel) {
	      var result = [];
	      var axisList = [];
	      ecModel.eachSeriesByType('boxplot', function (seriesModel) {
	        var baseAxis = seriesModel.getBaseAxis();
	        var idx = indexOf(axisList, baseAxis);
	
	        if (idx < 0) {
	          idx = axisList.length;
	          axisList[idx] = baseAxis;
	          result[idx] = {
	            axis: baseAxis,
	            seriesModels: []
	          };
	        }
	
	        result[idx].seriesModels.push(seriesModel);
	      });
	      return result;
	    }
	    /**
	     * Calculate offset and box width for each series.
	     */
	
	
	    function calculateBase(groupItem) {
	      var baseAxis = groupItem.axis;
	      var seriesModels = groupItem.seriesModels;
	      var seriesCount = seriesModels.length;
	      var boxWidthList = groupItem.boxWidthList = [];
	      var boxOffsetList = groupItem.boxOffsetList = [];
	      var boundList = [];
	      var bandWidth;
	
	      if (baseAxis.type === 'category') {
	        bandWidth = baseAxis.getBandWidth();
	      } else {
	        var maxDataCount_1 = 0;
	        each$6(seriesModels, function (seriesModel) {
	          maxDataCount_1 = Math.max(maxDataCount_1, seriesModel.getData().count());
	        });
	        var extent = baseAxis.getExtent();
	        bandWidth = Math.abs(extent[1] - extent[0]) / maxDataCount_1;
	      }
	
	      each$6(seriesModels, function (seriesModel) {
	        var boxWidthBound = seriesModel.get('boxWidth');
	
	        if (!isArray(boxWidthBound)) {
	          boxWidthBound = [boxWidthBound, boxWidthBound];
	        }
	
	        boundList.push([parsePercent$1(boxWidthBound[0], bandWidth) || 0, parsePercent$1(boxWidthBound[1], bandWidth) || 0]);
	      });
	      var availableWidth = bandWidth * 0.8 - 2;
	      var boxGap = availableWidth / seriesCount * 0.3;
	      var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
	      var base = boxWidth / 2 - availableWidth / 2;
	      each$6(seriesModels, function (seriesModel, idx) {
	        boxOffsetList.push(base);
	        base += boxGap + boxWidth;
	        boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
	      });
	    }
	    /**
	     * Calculate points location for each series.
	     */
	
	
	    function layoutSingleSeries(seriesModel, offset, boxWidth) {
	      var coordSys = seriesModel.coordinateSystem;
	      var data = seriesModel.getData();
	      var halfWidth = boxWidth / 2;
	      var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
	      var vDimIdx = 1 - cDimIdx;
	      var coordDims = ['x', 'y'];
	      var cDim = data.mapDimension(coordDims[cDimIdx]);
	      var vDims = data.mapDimensionsAll(coordDims[vDimIdx]);
	
	      if (cDim == null || vDims.length < 5) {
	        return;
	      }
	
	      for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var median = getPoint(axisDimVal, vDims[2], dataIndex);
	        var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
	        var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
	        var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
	        var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
	        var ends = [];
	        addBodyEnd(ends, end2, false);
	        addBodyEnd(ends, end4, true);
	        ends.push(end1, end2, end5, end4);
	        layEndLine(ends, end1);
	        layEndLine(ends, end5);
	        layEndLine(ends, median);
	        data.setItemLayout(dataIndex, {
	          initBaseline: median[vDimIdx],
	          ends: ends
	        });
	      }
	
	      function getPoint(axisDimVal, dim, dataIndex) {
	        var val = data.get(dim, dataIndex);
	        var p = [];
	        p[cDimIdx] = axisDimVal;
	        p[vDimIdx] = val;
	        var point;
	
	        if (isNaN(axisDimVal) || isNaN(val)) {
	          point = [NaN, NaN];
	        } else {
	          point = coordSys.dataToPoint(p);
	          point[cDimIdx] += offset;
	        }
	
	        return point;
	      }
	
	      function addBodyEnd(ends, point, start) {
	        var point1 = point.slice();
	        var point2 = point.slice();
	        point1[cDimIdx] += halfWidth;
	        point2[cDimIdx] -= halfWidth;
	        start ? ends.push(point1, point2) : ends.push(point2, point1);
	      }
	
	      function layEndLine(ends, endCenter) {
	        var from = endCenter.slice();
	        var to = endCenter.slice();
	        from[cDimIdx] -= halfWidth;
	        to[cDimIdx] += halfWidth;
	        ends.push(from, to);
	      }
	    }
	
	    /**
	     * See:
	     *  <https://en.wikipedia.org/wiki/Box_plot#cite_note-frigge_hoaglin_iglewicz-2>
	     *  <http://stat.ethz.ch/R-manual/R-devel/library/grDevices/html/boxplot.stats.html>
	     *
	     * Helper method for preparing data.
	     *
	     * @param rawData like
	     *        [
	     *            [12,232,443], (raw data set for the first box)
	     *            [3843,5545,1232], (raw data set for the second box)
	     *            ...
	     *        ]
	     * @param opt.boundIQR=1.5 Data less than min bound is outlier.
	     *      default 1.5, means Q1 - 1.5 * (Q3 - Q1).
	     *      If 'none'/0 passed, min bound will not be used.
	     */
	
	    function prepareBoxplotData(rawData, opt) {
	      opt = opt || {};
	      var boxData = [];
	      var outliers = [];
	      var boundIQR = opt.boundIQR;
	      var useExtreme = boundIQR === 'none' || boundIQR === 0;
	
	      for (var i = 0; i < rawData.length; i++) {
	        var ascList = asc(rawData[i].slice());
	        var Q1 = quantile(ascList, 0.25);
	        var Q2 = quantile(ascList, 0.5);
	        var Q3 = quantile(ascList, 0.75);
	        var min = ascList[0];
	        var max = ascList[ascList.length - 1];
	        var bound = (boundIQR == null ? 1.5 : boundIQR) * (Q3 - Q1);
	        var low = useExtreme ? min : Math.max(min, Q1 - bound);
	        var high = useExtreme ? max : Math.min(max, Q3 + bound);
	        var itemNameFormatter = opt.itemNameFormatter;
	        var itemName = isFunction(itemNameFormatter) ? itemNameFormatter({
	          value: i
	        }) : isString(itemNameFormatter) ? itemNameFormatter.replace('{value}', i + '') : i + '';
	        boxData.push([itemName, low, Q1, Q2, Q3, high]);
	
	        for (var j = 0; j < ascList.length; j++) {
	          var dataItem = ascList[j];
	
	          if (dataItem < low || dataItem > high) {
	            var outlier = [itemName, dataItem];
	            outliers.push(outlier);
	          }
	        }
	      }
	
	      return {
	        boxData: boxData,
	        outliers: outliers
	      };
	    }
	
	    var boxplotTransform = {
	      type: 'echarts:boxplot',
	      transform: function transform(params) {
	        var upstream = params.upstream;
	
	        if (upstream.sourceFormat !== SOURCE_FORMAT_ARRAY_ROWS) {
	          var errMsg = '';
	
	          if (true) {
	            errMsg = makePrintable('source data is not applicable for this boxplot transform. Expect number[][].');
	          }
	
	          throwError(errMsg);
	        }
	
	        var result = prepareBoxplotData(upstream.getRawData(), params.config);
	        return [{
	          dimensions: ['ItemName', 'Low', 'Q1', 'Q2', 'Q3', 'High'],
	          data: result.boxData
	        }, {
	          data: result.outliers
	        }];
	      }
	    };
	
	    function install$j(registers) {
	      registers.registerSeriesModel(BoxplotSeriesModel);
	      registers.registerChartView(BoxplotView);
	      registers.registerLayout(boxplotLayout);
	      registers.registerTransform(boxplotTransform);
	    }
	
	    var SKIP_PROPS = ['color', 'borderColor'];
	
	    var CandlestickView =
	    /** @class */
	    function (_super) {
	      __extends(CandlestickView, _super);
	
	      function CandlestickView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = CandlestickView.type;
	        return _this;
	      }
	
	      CandlestickView.prototype.render = function (seriesModel, ecModel, api) {
	        // If there is clipPath created in large mode. Remove it.
	        this.group.removeClipPath(); // Clear previously rendered progressive elements.
	
	        this._progressiveEls = null;
	
	        this._updateDrawMode(seriesModel);
	
	        this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
	      };
	
	      CandlestickView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
	        this._clear();
	
	        this._updateDrawMode(seriesModel);
	      };
	
	      CandlestickView.prototype.incrementalRender = function (params, seriesModel, ecModel, api) {
	        this._progressiveEls = [];
	        this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
	      };
	
	      CandlestickView.prototype.eachRendered = function (cb) {
	        traverseElements(this._progressiveEls || this.group, cb);
	      };
	
	      CandlestickView.prototype._updateDrawMode = function (seriesModel) {
	        var isLargeDraw = seriesModel.pipelineContext.large;
	
	        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
	          this._isLargeDraw = isLargeDraw;
	
	          this._clear();
	        }
	      };
	
	      CandlestickView.prototype._renderNormal = function (seriesModel) {
	        var data = seriesModel.getData();
	        var oldData = this._data;
	        var group = this.group;
	        var isSimpleBox = data.getLayout('isSimpleBox');
	        var needsClip = seriesModel.get('clip', true);
	        var coord = seriesModel.coordinateSystem;
	        var clipArea = coord.getArea && coord.getArea(); // There is no old data only when first rendering or switching from
	        // stream mode to normal mode, where previous elements should be removed.
	
	        if (!this._data) {
	          group.removeAll();
	        }
	
	        data.diff(oldData).add(function (newIdx) {
	          if (data.hasValue(newIdx)) {
	            var itemLayout = data.getItemLayout(newIdx);
	
	            if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	              return;
	            }
	
	            var el = createNormalBox$1(itemLayout, newIdx, true);
	            initProps(el, {
	              shape: {
	                points: itemLayout.ends
	              }
	            }, seriesModel, newIdx);
	            setBoxCommon(el, data, newIdx, isSimpleBox);
	            group.add(el);
	            data.setItemGraphicEl(newIdx, el);
	          }
	        }).update(function (newIdx, oldIdx) {
	          var el = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	          if (!data.hasValue(newIdx)) {
	            group.remove(el);
	            return;
	          }
	
	          var itemLayout = data.getItemLayout(newIdx);
	
	          if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	            group.remove(el);
	            return;
	          }
	
	          if (!el) {
	            el = createNormalBox$1(itemLayout);
	          } else {
	            updateProps(el, {
	              shape: {
	                points: itemLayout.ends
	              }
	            }, seriesModel, newIdx);
	            saveOldStyle(el);
	          }
	
	          setBoxCommon(el, data, newIdx, isSimpleBox);
	          group.add(el);
	          data.setItemGraphicEl(newIdx, el);
	        }).remove(function (oldIdx) {
	          var el = oldData.getItemGraphicEl(oldIdx);
	          el && group.remove(el);
	        }).execute();
	        this._data = data;
	      };
	
	      CandlestickView.prototype._renderLarge = function (seriesModel) {
	        this._clear();
	
	        createLarge$1(seriesModel, this.group);
	        var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
	
	        if (clipPath) {
	          this.group.setClipPath(clipPath);
	        } else {
	          this.group.removeClipPath();
	        }
	      };
	
	      CandlestickView.prototype._incrementalRenderNormal = function (params, seriesModel) {
	        var data = seriesModel.getData();
	        var isSimpleBox = data.getLayout('isSimpleBox');
	        var dataIndex;
	
	        while ((dataIndex = params.next()) != null) {
	          var itemLayout = data.getItemLayout(dataIndex);
	          var el = createNormalBox$1(itemLayout);
	          setBoxCommon(el, data, dataIndex, isSimpleBox);
	          el.incremental = true;
	          this.group.add(el);
	
	          this._progressiveEls.push(el);
	        }
	      };
	
	      CandlestickView.prototype._incrementalRenderLarge = function (params, seriesModel) {
	        createLarge$1(seriesModel, this.group, this._progressiveEls, true);
	      };
	
	      CandlestickView.prototype.remove = function (ecModel) {
	        this._clear();
	      };
	
	      CandlestickView.prototype._clear = function () {
	        this.group.removeAll();
	        this._data = null;
	      };
	
	      CandlestickView.type = 'candlestick';
	      return CandlestickView;
	    }(ChartView);
	
	    var NormalBoxPathShape =
	    /** @class */
	    function () {
	      function NormalBoxPathShape() {}
	
	      return NormalBoxPathShape;
	    }();
	
	    var NormalBoxPath =
	    /** @class */
	    function (_super) {
	      __extends(NormalBoxPath, _super);
	
	      function NormalBoxPath(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this.type = 'normalCandlestickBox';
	        return _this;
	      }
	
	      NormalBoxPath.prototype.getDefaultShape = function () {
	        return new NormalBoxPathShape();
	      };
	
	      NormalBoxPath.prototype.buildPath = function (ctx, shape) {
	        var ends = shape.points;
	
	        if (this.__simpleBox) {
	          ctx.moveTo(ends[4][0], ends[4][1]);
	          ctx.lineTo(ends[6][0], ends[6][1]);
	        } else {
	          ctx.moveTo(ends[0][0], ends[0][1]);
	          ctx.lineTo(ends[1][0], ends[1][1]);
	          ctx.lineTo(ends[2][0], ends[2][1]);
	          ctx.lineTo(ends[3][0], ends[3][1]);
	          ctx.closePath();
	          ctx.moveTo(ends[4][0], ends[4][1]);
	          ctx.lineTo(ends[5][0], ends[5][1]);
	          ctx.moveTo(ends[6][0], ends[6][1]);
	          ctx.lineTo(ends[7][0], ends[7][1]);
	        }
	      };
	
	      return NormalBoxPath;
	    }(Path);
	
	    function createNormalBox$1(itemLayout, dataIndex, isInit) {
	      var ends = itemLayout.ends;
	      return new NormalBoxPath({
	        shape: {
	          points: isInit ? transInit$1(ends, itemLayout) : ends
	        },
	        z2: 100
	      });
	    }
	
	    function isNormalBoxClipped(clipArea, itemLayout) {
	      var clipped = true;
	
	      for (var i = 0; i < itemLayout.ends.length; i++) {
	        // If any point are in the region.
	        if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
	          clipped = false;
	          break;
	        }
	      }
	
	      return clipped;
	    }
	
	    function setBoxCommon(el, data, dataIndex, isSimpleBox) {
	      var itemModel = data.getItemModel(dataIndex);
	      el.useStyle(data.getItemVisual(dataIndex, 'style'));
	      el.style.strokeNoScale = true;
	      el.__simpleBox = isSimpleBox;
	      setStatesStylesFromModel(el, itemModel);
	    }
	
	    function transInit$1(points, itemLayout) {
	      return map(points, function (point) {
	        point = point.slice();
	        point[1] = itemLayout.initBaseline;
	        return point;
	      });
	    }
	
	    var LargeBoxPathShape =
	    /** @class */
	    function () {
	      function LargeBoxPathShape() {}
	
	      return LargeBoxPathShape;
	    }();
	
	    var LargeBoxPath =
	    /** @class */
	    function (_super) {
	      __extends(LargeBoxPath, _super);
	
	      function LargeBoxPath(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this.type = 'largeCandlestickBox';
	        return _this;
	      }
	
	      LargeBoxPath.prototype.getDefaultShape = function () {
	        return new LargeBoxPathShape();
	      };
	
	      LargeBoxPath.prototype.buildPath = function (ctx, shape) {
	        // Drawing lines is more efficient than drawing
	        // a whole line or drawing rects.
	        var points = shape.points;
	
	        for (var i = 0; i < points.length;) {
	          if (this.__sign === points[i++]) {
	            var x = points[i++];
	            ctx.moveTo(x, points[i++]);
	            ctx.lineTo(x, points[i++]);
	          } else {
	            i += 3;
	          }
	        }
	      };
	
	      return LargeBoxPath;
	    }(Path);
	
	    function createLarge$1(seriesModel, group, progressiveEls, incremental) {
	      var data = seriesModel.getData();
	      var largePoints = data.getLayout('largePoints');
	      var elP = new LargeBoxPath({
	        shape: {
	          points: largePoints
	        },
	        __sign: 1,
	        ignoreCoarsePointer: true
	      });
	      group.add(elP);
	      var elN = new LargeBoxPath({
	        shape: {
	          points: largePoints
	        },
	        __sign: -1,
	        ignoreCoarsePointer: true
	      });
	      group.add(elN);
	      var elDoji = new LargeBoxPath({
	        shape: {
	          points: largePoints
	        },
	        __sign: 0,
	        ignoreCoarsePointer: true
	      });
	      group.add(elDoji);
	      setLargeStyle(1, elP, seriesModel);
	      setLargeStyle(-1, elN, seriesModel);
	      setLargeStyle(0, elDoji, seriesModel);
	
	      if (incremental) {
	        elP.incremental = true;
	        elN.incremental = true;
	      }
	
	      if (progressiveEls) {
	        progressiveEls.push(elP, elN);
	      }
	    }
	
	    function setLargeStyle(sign, el, seriesModel, data) {
	      // TODO put in visual?
	      var borderColor = seriesModel.get(['itemStyle', sign > 0 ? 'borderColor' : 'borderColor0']) // Use color for border color by default.
	      || seriesModel.get(['itemStyle', sign > 0 ? 'color' : 'color0']);
	
	      if (sign === 0) {
	        borderColor = seriesModel.get(['itemStyle', 'borderColorDoji']);
	      } // Color must be excluded.
	      // Because symbol provide setColor individually to set fill and stroke
	
	
	      var itemStyle = seriesModel.getModel('itemStyle').getItemStyle(SKIP_PROPS);
	      el.useStyle(itemStyle);
	      el.style.fill = null;
	      el.style.stroke = borderColor;
	    }
	
	    var CandlestickSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(CandlestickSeriesModel, _super);
	
	      function CandlestickSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = CandlestickSeriesModel.type;
	        _this.defaultValueDimensions = [{
	          name: 'open',
	          defaultTooltip: true
	        }, {
	          name: 'close',
	          defaultTooltip: true
	        }, {
	          name: 'lowest',
	          defaultTooltip: true
	        }, {
	          name: 'highest',
	          defaultTooltip: true
	        }];
	        return _this;
	      }
	      /**
	       * Get dimension for shadow in dataZoom
	       * @return dimension name
	       */
	
	
	      CandlestickSeriesModel.prototype.getShadowDim = function () {
	        return 'open';
	      };
	
	      CandlestickSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
	        var itemLayout = data.getItemLayout(dataIndex);
	        return itemLayout && selectors.rect(itemLayout.brushRect);
	      };
	
	      CandlestickSeriesModel.type = 'series.candlestick';
	      CandlestickSeriesModel.dependencies = ['xAxis', 'yAxis', 'grid'];
	      CandlestickSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        coordinateSystem: 'cartesian2d',
	        legendHoverLink: true,
	        // xAxisIndex: 0,
	        // yAxisIndex: 0,
	        layout: null,
	        clip: true,
	        itemStyle: {
	          color: '#eb5454',
	          color0: '#47b262',
	          borderColor: '#eb5454',
	          borderColor0: '#47b262',
	          borderColorDoji: null,
	          // borderColor: '#d24040',
	          // borderColor0: '#398f4f',
	          borderWidth: 1
	        },
	        emphasis: {
	          scale: true,
	          itemStyle: {
	            borderWidth: 2
	          }
	        },
	        barMaxWidth: null,
	        barMinWidth: null,
	        barWidth: null,
	        large: true,
	        largeThreshold: 600,
	        progressive: 3e3,
	        progressiveThreshold: 1e4,
	        progressiveChunkMode: 'mod',
	        animationEasing: 'linear',
	        animationDuration: 300
	      };
	      return CandlestickSeriesModel;
	    }(SeriesModel);
	
	    mixin(CandlestickSeriesModel, WhiskerBoxCommonMixin, true);
	
	    function candlestickPreprocessor(option) {
	      if (!option || !isArray(option.series)) {
	        return;
	      } // Translate 'k' to 'candlestick'.
	
	
	      each(option.series, function (seriesItem) {
	        if (isObject(seriesItem) && seriesItem.type === 'k') {
	          seriesItem.type = 'candlestick';
	        }
	      });
	    }
	
	    var positiveBorderColorQuery = ['itemStyle', 'borderColor'];
	    var negativeBorderColorQuery = ['itemStyle', 'borderColor0'];
	    var dojiBorderColorQuery = ['itemStyle', 'borderColorDoji'];
	    var positiveColorQuery = ['itemStyle', 'color'];
	    var negativeColorQuery = ['itemStyle', 'color0'];
	    var candlestickVisual = {
	      seriesType: 'candlestick',
	      plan: createRenderPlanner(),
	      // For legend.
	      performRawSeries: true,
	      reset: function (seriesModel, ecModel) {
	        function getColor(sign, model) {
	          return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
	        }
	
	        function getBorderColor(sign, model) {
	          return model.get(sign === 0 ? dojiBorderColorQuery : sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery);
	        } // Only visible series has each data be visual encoded
	
	
	        if (ecModel.isSeriesFiltered(seriesModel)) {
	          return;
	        }
	
	        var isLargeRender = seriesModel.pipelineContext.large;
	        return !isLargeRender && {
	          progress: function (params, data) {
	            var dataIndex;
	
	            while ((dataIndex = params.next()) != null) {
	              var itemModel = data.getItemModel(dataIndex);
	              var sign = data.getItemLayout(dataIndex).sign;
	              var style = itemModel.getItemStyle();
	              style.fill = getColor(sign, itemModel);
	              style.stroke = getBorderColor(sign, itemModel) || style.fill;
	              var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
	              extend(existsStyle, style);
	            }
	          }
	        };
	      }
	    };
	
	    var candlestickLayout = {
	      seriesType: 'candlestick',
	      plan: createRenderPlanner(),
	      reset: function (seriesModel) {
	        var coordSys = seriesModel.coordinateSystem;
	        var data = seriesModel.getData();
	        var candleWidth = calculateCandleWidth(seriesModel, data);
	        var cDimIdx = 0;
	        var vDimIdx = 1;
	        var coordDims = ['x', 'y'];
	        var cDimI = data.getDimensionIndex(data.mapDimension(coordDims[cDimIdx]));
	        var vDimsI = map(data.mapDimensionsAll(coordDims[vDimIdx]), data.getDimensionIndex, data);
	        var openDimI = vDimsI[0];
	        var closeDimI = vDimsI[1];
	        var lowestDimI = vDimsI[2];
	        var highestDimI = vDimsI[3];
	        data.setLayout({
	          candleWidth: candleWidth,
	          // The value is experimented visually.
	          isSimpleBox: candleWidth <= 1.3
	        });
	
	        if (cDimI < 0 || vDimsI.length < 4) {
	          return;
	        }
	
	        return {
	          progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
	        };
	
	        function normalProgress(params, data) {
	          var dataIndex;
	          var store = data.getStore();
	
	          while ((dataIndex = params.next()) != null) {
	            var axisDimVal = store.get(cDimI, dataIndex);
	            var openVal = store.get(openDimI, dataIndex);
	            var closeVal = store.get(closeDimI, dataIndex);
	            var lowestVal = store.get(lowestDimI, dataIndex);
	            var highestVal = store.get(highestDimI, dataIndex);
	            var ocLow = Math.min(openVal, closeVal);
	            var ocHigh = Math.max(openVal, closeVal);
	            var ocLowPoint = getPoint(ocLow, axisDimVal);
	            var ocHighPoint = getPoint(ocHigh, axisDimVal);
	            var lowestPoint = getPoint(lowestVal, axisDimVal);
	            var highestPoint = getPoint(highestVal, axisDimVal);
	            var ends = [];
	            addBodyEnd(ends, ocHighPoint, 0);
	            addBodyEnd(ends, ocLowPoint, 1);
	            ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
	            var itemModel = data.getItemModel(dataIndex);
	            var hasDojiColor = !!itemModel.get(['itemStyle', 'borderColorDoji']);
	            data.setItemLayout(dataIndex, {
	              sign: getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor),
	              initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
	              ends: ends,
	              brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
	            });
	          }
	
	          function getPoint(val, axisDimVal) {
	            var p = [];
	            p[cDimIdx] = axisDimVal;
	            p[vDimIdx] = val;
	            return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
	          }
	
	          function addBodyEnd(ends, point, start) {
	            var point1 = point.slice();
	            var point2 = point.slice();
	            point1[cDimIdx] = subPixelOptimize$1(point1[cDimIdx] + candleWidth / 2, 1, false);
	            point2[cDimIdx] = subPixelOptimize$1(point2[cDimIdx] - candleWidth / 2, 1, true);
	            start ? ends.push(point1, point2) : ends.push(point2, point1);
	          }
	
	          function makeBrushRect(lowestVal, highestVal, axisDimVal) {
	            var pmin = getPoint(lowestVal, axisDimVal);
	            var pmax = getPoint(highestVal, axisDimVal);
	            pmin[cDimIdx] -= candleWidth / 2;
	            pmax[cDimIdx] -= candleWidth / 2;
	            return {
	              x: pmin[0],
	              y: pmin[1],
	              width:  candleWidth ,
	              height:  pmax[1] - pmin[1] 
	            };
	          }
	
	          function subPixelOptimizePoint(point) {
	            point[cDimIdx] = subPixelOptimize$1(point[cDimIdx], 1);
	            return point;
	          }
	        }
	
	        function largeProgress(params, data) {
	          // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
	          var points = createFloat32Array(params.count * 4);
	          var offset = 0;
	          var point;
	          var tmpIn = [];
	          var tmpOut = [];
	          var dataIndex;
	          var store = data.getStore();
	          var hasDojiColor = !!seriesModel.get(['itemStyle', 'borderColorDoji']);
	
	          while ((dataIndex = params.next()) != null) {
	            var axisDimVal = store.get(cDimI, dataIndex);
	            var openVal = store.get(openDimI, dataIndex);
	            var closeVal = store.get(closeDimI, dataIndex);
	            var lowestVal = store.get(lowestDimI, dataIndex);
	            var highestVal = store.get(highestDimI, dataIndex);
	
	            if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
	              points[offset++] = NaN;
	              offset += 3;
	              continue;
	            }
	
	            points[offset++] = getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor);
	            tmpIn[cDimIdx] = axisDimVal;
	            tmpIn[vDimIdx] = lowestVal;
	            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	            points[offset++] = point ? point[0] : NaN;
	            points[offset++] = point ? point[1] : NaN;
	            tmpIn[vDimIdx] = highestVal;
	            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	            points[offset++] = point ? point[1] : NaN;
	          }
	
	          data.setLayout('largePoints', points);
	        }
	      }
	    };
	    /**
	     * Get the sign of a single data.
	     *
	     * @returns 0 for doji with hasDojiColor: true,
	     *          1 for positive,
	     *          -1 for negative.
	     */
	
	    function getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor) {
	      var sign;
	
	      if (openVal > closeVal) {
	        sign = -1;
	      } else if (openVal < closeVal) {
	        sign = 1;
	      } else {
	        sign = hasDojiColor // When doji color is set, use it instead of color/color0.
	        ? 0 : dataIndex > 0 // If close === open, compare with close of last record
	        ? store.get(closeDimI, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
	        1;
	      }
	
	      return sign;
	    }
	
	    function calculateCandleWidth(seriesModel, data) {
	      var baseAxis = seriesModel.getBaseAxis();
	      var extent;
	      var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
	      var barMaxWidth = parsePercent$1(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
	      var barMinWidth = parsePercent$1(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
	      var barWidth = seriesModel.get('barWidth');
	      return barWidth != null ? parsePercent$1(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
	      : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
	    }
	
	    function install$k(registers) {
	      registers.registerChartView(CandlestickView);
	      registers.registerSeriesModel(CandlestickSeriesModel);
	      registers.registerPreprocessor(candlestickPreprocessor);
	      registers.registerVisual(candlestickVisual);
	      registers.registerLayout(candlestickLayout);
	    }
	
	    function updateRipplePath(rippleGroup, effectCfg) {
	      var color = effectCfg.rippleEffectColor || effectCfg.color;
	      rippleGroup.eachChild(function (ripplePath) {
	        ripplePath.attr({
	          z: effectCfg.z,
	          zlevel: effectCfg.zlevel,
	          style: {
	            stroke: effectCfg.brushType === 'stroke' ? color : null,
	            fill: effectCfg.brushType === 'fill' ? color : null
	          }
	        });
	      });
	    }
	
	    var EffectSymbol =
	    /** @class */
	    function (_super) {
	      __extends(EffectSymbol, _super);
	
	      function EffectSymbol(data, idx) {
	        var _this = _super.call(this) || this;
	
	        var symbol = new Symbol(data, idx);
	        var rippleGroup = new Group();
	
	        _this.add(symbol);
	
	        _this.add(rippleGroup);
	
	        _this.updateData(data, idx);
	
	        return _this;
	      }
	
	      EffectSymbol.prototype.stopEffectAnimation = function () {
	        this.childAt(1).removeAll();
	      };
	
	      EffectSymbol.prototype.startEffectAnimation = function (effectCfg) {
	        var symbolType = effectCfg.symbolType;
	        var color = effectCfg.color;
	        var rippleNumber = effectCfg.rippleNumber;
	        var rippleGroup = this.childAt(1);
	
	        for (var i = 0; i < rippleNumber; i++) {
	          // If width/height are set too small (e.g., set to 1) on ios10
	          // and macOS Sierra, a circle stroke become a rect, no matter what
	          // the scale is set. So we set width/height as 2. See #4136.
	          var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
	          ripplePath.attr({
	            style: {
	              strokeNoScale: true
	            },
	            z2: 99,
	            silent: true,
	            scaleX: 0.5,
	            scaleY: 0.5
	          });
	          var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
	          ripplePath.animate('', true).when(effectCfg.period, {
	            scaleX: effectCfg.rippleScale / 2,
	            scaleY: effectCfg.rippleScale / 2
	          }).delay(delay).start();
	          ripplePath.animateStyle(true).when(effectCfg.period, {
	            opacity: 0
	          }).delay(delay).start();
	          rippleGroup.add(ripplePath);
	        }
	
	        updateRipplePath(rippleGroup, effectCfg);
	      };
	      /**
	       * Update effect symbol
	       */
	
	
	      EffectSymbol.prototype.updateEffectAnimation = function (effectCfg) {
	        var oldEffectCfg = this._effectCfg;
	        var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed
	
	        var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale', 'rippleNumber'];
	
	        for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
	          var propName = DIFFICULT_PROPS[i];
	
	          if (oldEffectCfg[propName] !== effectCfg[propName]) {
	            this.stopEffectAnimation();
	            this.startEffectAnimation(effectCfg);
	            return;
	          }
	        }
	
	        updateRipplePath(rippleGroup, effectCfg);
	      };
	      /**
	       * Highlight symbol
	       */
	
	
	      EffectSymbol.prototype.highlight = function () {
	        enterEmphasis(this);
	      };
	      /**
	       * Downplay symbol
	       */
	
	
	      EffectSymbol.prototype.downplay = function () {
	        leaveEmphasis(this);
	      };
	
	      EffectSymbol.prototype.getSymbolType = function () {
	        var symbol = this.childAt(0);
	        return symbol && symbol.getSymbolType();
	      };
	      /**
	       * Update symbol properties
	       */
	
	
	      EffectSymbol.prototype.updateData = function (data, idx) {
	        var _this = this;
	
	        var seriesModel = data.hostModel;
	        this.childAt(0).updateData(data, idx);
	        var rippleGroup = this.childAt(1);
	        var itemModel = data.getItemModel(idx);
	        var symbolType = data.getItemVisual(idx, 'symbol');
	        var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	        var symbolStyle = data.getItemVisual(idx, 'style');
	        var color = symbolStyle && symbolStyle.fill;
	        var emphasisModel = itemModel.getModel('emphasis');
	        rippleGroup.setScale(symbolSize);
	        rippleGroup.traverse(function (ripplePath) {
	          ripplePath.setStyle('fill', color);
	        });
	        var symbolOffset = normalizeSymbolOffset(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
	
	        if (symbolOffset) {
	          rippleGroup.x = symbolOffset[0];
	          rippleGroup.y = symbolOffset[1];
	        }
	
	        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	        rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	        var effectCfg = {};
	        effectCfg.showEffectOn = seriesModel.get('showEffectOn');
	        effectCfg.rippleScale = itemModel.get(['rippleEffect', 'scale']);
	        effectCfg.brushType = itemModel.get(['rippleEffect', 'brushType']);
	        effectCfg.period = itemModel.get(['rippleEffect', 'period']) * 1000;
	        effectCfg.effectOffset = idx / data.count();
	        effectCfg.z = seriesModel.getShallow('z') || 0;
	        effectCfg.zlevel = seriesModel.getShallow('zlevel') || 0;
	        effectCfg.symbolType = symbolType;
	        effectCfg.color = color;
	        effectCfg.rippleEffectColor = itemModel.get(['rippleEffect', 'color']);
	        effectCfg.rippleNumber = itemModel.get(['rippleEffect', 'number']);
	
	        if (effectCfg.showEffectOn === 'render') {
	          this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
	          this._effectCfg = effectCfg;
	        } else {
	          // Not keep old effect config
	          this._effectCfg = null;
	          this.stopEffectAnimation();
	
	          this.onHoverStateChange = function (toState) {
	            if (toState === 'emphasis') {
	              if (effectCfg.showEffectOn !== 'render') {
	                _this.startEffectAnimation(effectCfg);
	              }
	            } else if (toState === 'normal') {
	              if (effectCfg.showEffectOn !== 'render') {
	                _this.stopEffectAnimation();
	              }
	            }
	          };
	        }
	
	        this._effectCfg = effectCfg;
	        toggleHoverEmphasis(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	      };
	
	      EffectSymbol.prototype.fadeOut = function (cb) {
	        cb && cb();
	      };
	      return EffectSymbol;
	    }(Group);
	
	    var EffectScatterView =
	    /** @class */
	    function (_super) {
	      __extends(EffectScatterView, _super);
	
	      function EffectScatterView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = EffectScatterView.type;
	        return _this;
	      }
	
	      EffectScatterView.prototype.init = function () {
	        this._symbolDraw = new SymbolDraw(EffectSymbol);
	      };
	
	      EffectScatterView.prototype.render = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	        var effectSymbolDraw = this._symbolDraw;
	        effectSymbolDraw.updateData(data, {
	          clipShape: this._getClipShape(seriesModel)
	        });
	        this.group.add(effectSymbolDraw.group);
	      };
	
	      EffectScatterView.prototype._getClipShape = function (seriesModel) {
	        var coordSys = seriesModel.coordinateSystem;
	        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
	        return seriesModel.get('clip', true) ? clipArea : null;
	      };
	
	      EffectScatterView.prototype.updateTransform = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	        this.group.dirty();
	        var res = pointsLayout('').reset(seriesModel, ecModel, api);
	
	        if (res.progress) {
	          res.progress({
	            start: 0,
	            end: data.count(),
	            count: data.count()
	          }, data);
	        }
	
	        this._symbolDraw.updateLayout();
	      };
	
	      EffectScatterView.prototype._updateGroupTransform = function (seriesModel) {
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (coordSys && coordSys.getRoamTransform) {
	          this.group.transform = clone$2(coordSys.getRoamTransform());
	          this.group.decomposeTransform();
	        }
	      };
	
	      EffectScatterView.prototype.remove = function (ecModel, api) {
	        this._symbolDraw && this._symbolDraw.remove(true);
	      };
	
	      EffectScatterView.type = 'effectScatter';
	      return EffectScatterView;
	    }(ChartView);
	
	    var EffectScatterSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(EffectScatterSeriesModel, _super);
	
	      function EffectScatterSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = EffectScatterSeriesModel.type;
	        _this.hasSymbolVisual = true;
	        return _this;
	      }
	
	      EffectScatterSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return createSeriesData(null, this, {
	          useEncodeDefaulter: true
	        });
	      };
	
	      EffectScatterSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
	        return selectors.point(data.getItemLayout(dataIndex));
	      };
	
	      EffectScatterSeriesModel.type = 'series.effectScatter';
	      EffectScatterSeriesModel.dependencies = ['grid', 'polar'];
	      EffectScatterSeriesModel.defaultOption = {
	        coordinateSystem: 'cartesian2d',
	        // zlevel: 0,
	        z: 2,
	        legendHoverLink: true,
	        effectType: 'ripple',
	        progressive: 0,
	        // When to show the effect, option: 'render'|'emphasis'
	        showEffectOn: 'render',
	        clip: true,
	        // Ripple effect config
	        rippleEffect: {
	          period: 4,
	          // Scale of ripple
	          scale: 2.5,
	          // Brush type can be fill or stroke
	          brushType: 'fill',
	          // Ripple number
	          number: 3
	        },
	        universalTransition: {
	          divideShape: 'clone'
	        },
	        // Cartesian coordinate system
	        // xAxisIndex: 0,
	        // yAxisIndex: 0,
	        // Polar coordinate system
	        // polarIndex: 0,
	        // Geo coordinate system
	        // geoIndex: 0,
	        // symbol: null,        // 图形类型
	        symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	        // symbolRotate: null,  // 图形旋转控制
	        // itemStyle: {
	        //     opacity: 1
	        // }
	
	      };
	      return EffectScatterSeriesModel;
	    }(SeriesModel);
	
	    function install$l(registers) {
	      registers.registerChartView(EffectScatterView);
	      registers.registerSeriesModel(EffectScatterSeriesModel);
	      registers.registerLayout(pointsLayout('effectScatter'));
	    }
	
	    var EffectLine =
	    /** @class */
	    function (_super) {
	      __extends(EffectLine, _super);
	
	      function EffectLine(lineData, idx, seriesScope) {
	        var _this = _super.call(this) || this;
	
	        _this.add(_this.createLine(lineData, idx, seriesScope));
	
	        _this._updateEffectSymbol(lineData, idx);
	
	        return _this;
	      }
	
	      EffectLine.prototype.createLine = function (lineData, idx, seriesScope) {
	        return new Line$1(lineData, idx, seriesScope);
	      };
	
	      EffectLine.prototype._updateEffectSymbol = function (lineData, idx) {
	        var itemModel = lineData.getItemModel(idx);
	        var effectModel = itemModel.getModel('effect');
	        var size = effectModel.get('symbolSize');
	        var symbolType = effectModel.get('symbol');
	
	        if (!isArray(size)) {
	          size = [size, size];
	        }
	
	        var lineStyle = lineData.getItemVisual(idx, 'style');
	        var color = effectModel.get('color') || lineStyle && lineStyle.stroke;
	        var symbol = this.childAt(1);
	
	        if (this._symbolType !== symbolType) {
	          // Remove previous
	          this.remove(symbol);
	          symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
	          symbol.z2 = 100;
	          symbol.culling = true;
	          this.add(symbol);
	        } // Symbol may be removed if loop is false
	
	
	        if (!symbol) {
	          return;
	        } // Shadow color is same with color in default
	
	
	        symbol.setStyle('shadowColor', color);
	        symbol.setStyle(effectModel.getItemStyle(['color']));
	        symbol.scaleX = size[0];
	        symbol.scaleY = size[1];
	        symbol.setColor(color);
	        this._symbolType = symbolType;
	        this._symbolScale = size;
	
	        this._updateEffectAnimation(lineData, effectModel, idx);
	      };
	
	      EffectLine.prototype._updateEffectAnimation = function (lineData, effectModel, idx) {
	        var symbol = this.childAt(1);
	
	        if (!symbol) {
	          return;
	        }
	
	        var points = lineData.getItemLayout(idx);
	        var period = effectModel.get('period') * 1000;
	        var loop = effectModel.get('loop');
	        var roundTrip = effectModel.get('roundTrip');
	        var constantSpeed = effectModel.get('constantSpeed');
	        var delayExpr = retrieve(effectModel.get('delay'), function (idx) {
	          return idx / lineData.count() * period / 3;
	        }); // Ignore when updating
	
	        symbol.ignore = true;
	
	        this._updateAnimationPoints(symbol, points);
	
	        if (constantSpeed > 0) {
	          period = this._getLineLength(symbol) / constantSpeed * 1000;
	        }
	
	        if (period !== this._period || loop !== this._loop || roundTrip !== this._roundTrip) {
	          symbol.stopAnimation();
	          var delayNum = void 0;
	
	          if (isFunction(delayExpr)) {
	            delayNum = delayExpr(idx);
	          } else {
	            delayNum = delayExpr;
	          }
	
	          if (symbol.__t > 0) {
	            delayNum = -period * symbol.__t;
	          }
	
	          this._animateSymbol(symbol, period, delayNum, loop, roundTrip);
	        }
	
	        this._period = period;
	        this._loop = loop;
	        this._roundTrip = roundTrip;
	      };
	
	      EffectLine.prototype._animateSymbol = function (symbol, period, delayNum, loop, roundTrip) {
	        if (period > 0) {
	          symbol.__t = 0;
	          var self_1 = this;
	          var animator = symbol.animate('', loop).when(roundTrip ? period * 2 : period, {
	            __t: roundTrip ? 2 : 1
	          }).delay(delayNum).during(function () {
	            self_1._updateSymbolPosition(symbol);
	          });
	
	          if (!loop) {
	            animator.done(function () {
	              self_1.remove(symbol);
	            });
	          }
	
	          animator.start();
	        }
	      };
	
	      EffectLine.prototype._getLineLength = function (symbol) {
	        // Not so accurate
	        return dist(symbol.__p1, symbol.__cp1) + dist(symbol.__cp1, symbol.__p2);
	      };
	
	      EffectLine.prototype._updateAnimationPoints = function (symbol, points) {
	        symbol.__p1 = points[0];
	        symbol.__p2 = points[1];
	        symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
	      };
	
	      EffectLine.prototype.updateData = function (lineData, idx, seriesScope) {
	        this.childAt(0).updateData(lineData, idx, seriesScope);
	
	        this._updateEffectSymbol(lineData, idx);
	      };
	
	      EffectLine.prototype._updateSymbolPosition = function (symbol) {
	        var p1 = symbol.__p1;
	        var p2 = symbol.__p2;
	        var cp1 = symbol.__cp1;
	        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
	        var pos = [symbol.x, symbol.y];
	        var lastPos = pos.slice();
	        var quadraticAt$1 = quadraticAt;
	        var quadraticDerivativeAt$1 = quadraticDerivativeAt;
	        pos[0] = quadraticAt$1(p1[0], cp1[0], p2[0], t);
	        pos[1] = quadraticAt$1(p1[1], cp1[1], p2[1], t); // Tangent
	
	        var tx = symbol.__t < 1 ? quadraticDerivativeAt$1(p1[0], cp1[0], p2[0], t) : quadraticDerivativeAt$1(p2[0], cp1[0], p1[0], 1 - t);
	        var ty = symbol.__t < 1 ? quadraticDerivativeAt$1(p1[1], cp1[1], p2[1], t) : quadraticDerivativeAt$1(p2[1], cp1[1], p1[1], 1 - t);
	        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2; // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
	
	        if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
	          if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
	            symbol.scaleY = dist(lastPos, pos) * 1.05; // make sure the last segment render within endPoint
	
	            if (t === 1) {
	              pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
	              pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
	            }
	          } else if (symbol.__lastT === 1) {
	            // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
	            symbol.scaleY = 2 * dist(p1, pos);
	          } else {
	            symbol.scaleY = this._symbolScale[1];
	          }
	        }
	
	        symbol.__lastT = symbol.__t;
	        symbol.ignore = false;
	        symbol.x = pos[0];
	        symbol.y = pos[1];
	      };
	
	      EffectLine.prototype.updateLayout = function (lineData, idx) {
	        this.childAt(0).updateLayout(lineData, idx);
	        var effectModel = lineData.getItemModel(idx).getModel('effect');
	
	        this._updateEffectAnimation(lineData, effectModel, idx);
	      };
	
	      return EffectLine;
	    }(Group);
	
	    var Polyline$1 =
	    /** @class */
	    function (_super) {
	      __extends(Polyline$1, _super);
	
	      function Polyline$1(lineData, idx, seriesScope) {
	        var _this = _super.call(this) || this;
	
	        _this._createPolyline(lineData, idx, seriesScope);
	
	        return _this;
	      }
	
	      Polyline$1.prototype._createPolyline = function (lineData, idx, seriesScope) {
	        // let seriesModel = lineData.hostModel;
	        var points = lineData.getItemLayout(idx);
	        var line = new Polyline({
	          shape: {
	            points: points
	          }
	        });
	        this.add(line);
	
	        this._updateCommonStl(lineData, idx, seriesScope);
	      };
	
	      Polyline$1.prototype.updateData = function (lineData, idx, seriesScope) {
	        var seriesModel = lineData.hostModel;
	        var line = this.childAt(0);
	        var target = {
	          shape: {
	            points: lineData.getItemLayout(idx)
	          }
	        };
	        updateProps(line, target, seriesModel, idx);
	
	        this._updateCommonStl(lineData, idx, seriesScope);
	      };
	
	      Polyline$1.prototype._updateCommonStl = function (lineData, idx, seriesScope) {
	        var line = this.childAt(0);
	        var itemModel = lineData.getItemModel(idx);
	        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
	        var focus = seriesScope && seriesScope.focus;
	        var blurScope = seriesScope && seriesScope.blurScope;
	        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
	
	        if (!seriesScope || lineData.hasItemOption) {
	          var emphasisModel = itemModel.getModel('emphasis');
	          emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
	          emphasisDisabled = emphasisModel.get('disabled');
	          focus = emphasisModel.get('focus');
	          blurScope = emphasisModel.get('blurScope');
	        }
	
	        line.useStyle(lineData.getItemVisual(idx, 'style'));
	        line.style.fill = null;
	        line.style.strokeNoScale = true;
	        var lineEmphasisState = line.ensureState('emphasis');
	        lineEmphasisState.style = emphasisLineStyle;
	        toggleHoverEmphasis(this, focus, blurScope, emphasisDisabled);
	      };
	
	      Polyline$1.prototype.updateLayout = function (lineData, idx) {
	        var polyline = this.childAt(0);
	        polyline.setShape('points', lineData.getItemLayout(idx));
	      };
	      return Polyline$1;
	    }(Group);
	
	    var EffectPolyline =
	    /** @class */
	    function (_super) {
	      __extends(EffectPolyline, _super);
	
	      function EffectPolyline() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this._lastFrame = 0;
	        _this._lastFramePercent = 0;
	        return _this;
	      } // Override
	
	
	      EffectPolyline.prototype.createLine = function (lineData, idx, seriesScope) {
	        return new Polyline$1(lineData, idx, seriesScope);
	      };
	
	      EffectPolyline.prototype._updateAnimationPoints = function (symbol, points) {
	        this._points = points;
	        var accLenArr = [0];
	        var len = 0;
	
	        for (var i = 1; i < points.length; i++) {
	          var p1 = points[i - 1];
	          var p2 = points[i];
	          len += dist(p1, p2);
	          accLenArr.push(len);
	        }
	
	        if (len === 0) {
	          this._length = 0;
	          return;
	        }
	
	        for (var i = 0; i < accLenArr.length; i++) {
	          accLenArr[i] /= len;
	        }
	
	        this._offsets = accLenArr;
	        this._length = len;
	      };
	
	      EffectPolyline.prototype._getLineLength = function () {
	        return this._length;
	      };
	
	      EffectPolyline.prototype._updateSymbolPosition = function (symbol) {
	        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
	        var points = this._points;
	        var offsets = this._offsets;
	        var len = points.length;
	
	        if (!offsets) {
	          // Has length 0
	          return;
	        }
	
	        var lastFrame = this._lastFrame;
	        var frame;
	
	        if (t < this._lastFramePercent) {
	          // Start from the next frame
	          // PENDING start from lastFrame ?
	          var start = Math.min(lastFrame + 1, len - 1);
	
	          for (frame = start; frame >= 0; frame--) {
	            if (offsets[frame] <= t) {
	              break;
	            }
	          } // PENDING really need to do this ?
	
	
	          frame = Math.min(frame, len - 2);
	        } else {
	          for (frame = lastFrame; frame < len; frame++) {
	            if (offsets[frame] > t) {
	              break;
	            }
	          }
	
	          frame = Math.min(frame - 1, len - 2);
	        }
	
	        var p = (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]);
	        var p0 = points[frame];
	        var p1 = points[frame + 1];
	        symbol.x = p0[0] * (1 - p) + p * p1[0];
	        symbol.y = p0[1] * (1 - p) + p * p1[1];
	        var tx = symbol.__t < 1 ? p1[0] - p0[0] : p0[0] - p1[0];
	        var ty = symbol.__t < 1 ? p1[1] - p0[1] : p0[1] - p1[1];
	        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
	        this._lastFrame = frame;
	        this._lastFramePercent = t;
	        symbol.ignore = false;
	      };
	      return EffectPolyline;
	    }(EffectLine);
	
	    var LargeLinesPathShape =
	    /** @class */
	    function () {
	      function LargeLinesPathShape() {
	        this.polyline = false;
	        this.curveness = 0;
	        this.segs = [];
	      }
	
	      return LargeLinesPathShape;
	    }();
	
	    var LargeLinesPath =
	    /** @class */
	    function (_super) {
	      __extends(LargeLinesPath, _super);
	
	      function LargeLinesPath(opts) {
	        var _this = _super.call(this, opts) || this;
	
	        _this._off = 0;
	        _this.hoverDataIdx = -1;
	        return _this;
	      }
	
	      LargeLinesPath.prototype.reset = function () {
	        this.notClear = false;
	        this._off = 0;
	      };
	
	      LargeLinesPath.prototype.getDefaultStyle = function () {
	        return {
	          stroke: '#000',
	          fill: null
	        };
	      };
	
	      LargeLinesPath.prototype.getDefaultShape = function () {
	        return new LargeLinesPathShape();
	      };
	
	      LargeLinesPath.prototype.buildPath = function (ctx, shape) {
	        var segs = shape.segs;
	        var curveness = shape.curveness;
	        var i;
	
	        if (shape.polyline) {
	          for (i = this._off; i < segs.length;) {
	            var count = segs[i++];
	
	            if (count > 0) {
	              ctx.moveTo(segs[i++], segs[i++]);
	
	              for (var k = 1; k < count; k++) {
	                ctx.lineTo(segs[i++], segs[i++]);
	              }
	            }
	          }
	        } else {
	          for (i = this._off; i < segs.length;) {
	            var x0 = segs[i++];
	            var y0 = segs[i++];
	            var x1 = segs[i++];
	            var y1 = segs[i++];
	            ctx.moveTo(x0, y0);
	
	            if (curveness > 0) {
	              var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	              var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	              ctx.quadraticCurveTo(x2, y2, x1, y1);
	            } else {
	              ctx.lineTo(x1, y1);
	            }
	          }
	        }
	
	        if (this.incremental) {
	          this._off = i;
	          this.notClear = true;
	        }
	      };
	
	      LargeLinesPath.prototype.findDataIndex = function (x, y) {
	        var shape = this.shape;
	        var segs = shape.segs;
	        var curveness = shape.curveness;
	        var lineWidth = this.style.lineWidth;
	
	        if (shape.polyline) {
	          var dataIndex = 0;
	
	          for (var i = 0; i < segs.length;) {
	            var count = segs[i++];
	
	            if (count > 0) {
	              var x0 = segs[i++];
	              var y0 = segs[i++];
	
	              for (var k = 1; k < count; k++) {
	                var x1 = segs[i++];
	                var y1 = segs[i++];
	
	                if (containStroke(x0, y0, x1, y1, lineWidth, x, y)) {
	                  return dataIndex;
	                }
	              }
	            }
	
	            dataIndex++;
	          }
	        } else {
	          var dataIndex = 0;
	
	          for (var i = 0; i < segs.length;) {
	            var x0 = segs[i++];
	            var y0 = segs[i++];
	            var x1 = segs[i++];
	            var y1 = segs[i++];
	
	            if (curveness > 0) {
	              var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	              var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	
	              if (containStroke$2(x0, y0, x2, y2, x1, y1, lineWidth, x, y)) {
	                return dataIndex;
	              }
	            } else {
	              if (containStroke(x0, y0, x1, y1, lineWidth, x, y)) {
	                return dataIndex;
	              }
	            }
	
	            dataIndex++;
	          }
	        }
	
	        return -1;
	      };
	
	      LargeLinesPath.prototype.contain = function (x, y) {
	        var localPos = this.transformCoordToLocal(x, y);
	        var rect = this.getBoundingRect();
	        x = localPos[0];
	        y = localPos[1];
	
	        if (rect.contain(x, y)) {
	          // Cache found data index.
	          var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
	          return dataIdx >= 0;
	        }
	
	        this.hoverDataIdx = -1;
	        return false;
	      };
	
	      LargeLinesPath.prototype.getBoundingRect = function () {
	        // Ignore stroke for large symbol draw.
	        var rect = this._rect;
	
	        if (!rect) {
	          var shape = this.shape;
	          var points = shape.segs;
	          var minX = Infinity;
	          var minY = Infinity;
	          var maxX = -Infinity;
	          var maxY = -Infinity;
	
	          for (var i = 0; i < points.length;) {
	            var x = points[i++];
	            var y = points[i++];
	            minX = Math.min(x, minX);
	            maxX = Math.max(x, maxX);
	            minY = Math.min(y, minY);
	            maxY = Math.max(y, maxY);
	          }
	
	          rect = this._rect = new BoundingRect(minX, minY, maxX, maxY);
	        }
	
	        return rect;
	      };
	
	      return LargeLinesPath;
	    }(Path);
	
	    var LargeLineDraw =
	    /** @class */
	    function () {
	      function LargeLineDraw() {
	        this.group = new Group();
	      }
	      /**
	       * Update symbols draw by new data
	       */
	
	
	      LargeLineDraw.prototype.updateData = function (data) {
	        this._clear();
	
	        var lineEl = this._create();
	
	        lineEl.setShape({
	          segs: data.getLayout('linesPoints')
	        });
	
	        this._setCommon(lineEl, data);
	      };
	      /**
	       * @override
	       */
	
	      LargeLineDraw.prototype.incrementalPrepareUpdate = function (data) {
	        this.group.removeAll();
	
	        this._clear();
	      };
	      /**
	       * @override
	       */
	
	      LargeLineDraw.prototype.incrementalUpdate = function (taskParams, data) {
	        var lastAdded = this._newAdded[0];
	        var linePoints = data.getLayout('linesPoints');
	        var oldSegs = lastAdded && lastAdded.shape.segs; // Merging the exists. Each element has 1e4 points.
	        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
	
	        if (oldSegs && oldSegs.length < 2e4) {
	          var oldLen = oldSegs.length;
	          var newSegs = new Float32Array(oldLen + linePoints.length); // Concat two array
	
	          newSegs.set(oldSegs);
	          newSegs.set(linePoints, oldLen);
	          lastAdded.setShape({
	            segs: newSegs
	          });
	        } else {
	          // Clear
	          this._newAdded = [];
	
	          var lineEl = this._create();
	
	          lineEl.incremental = true;
	          lineEl.setShape({
	            segs: linePoints
	          });
	
	          this._setCommon(lineEl, data);
	
	          lineEl.__startIndex = taskParams.start;
	        }
	      };
	      /**
	       * @override
	       */
	
	
	      LargeLineDraw.prototype.remove = function () {
	        this._clear();
	      };
	
	      LargeLineDraw.prototype.eachRendered = function (cb) {
	        this._newAdded[0] && cb(this._newAdded[0]);
	      };
	
	      LargeLineDraw.prototype._create = function () {
	        var lineEl = new LargeLinesPath({
	          cursor: 'default',
	          ignoreCoarsePointer: true
	        });
	
	        this._newAdded.push(lineEl);
	
	        this.group.add(lineEl);
	        return lineEl;
	      };
	
	      LargeLineDraw.prototype._setCommon = function (lineEl, data, isIncremental) {
	        var hostModel = data.hostModel;
	        lineEl.setShape({
	          polyline: hostModel.get('polyline'),
	          curveness: hostModel.get(['lineStyle', 'curveness'])
	        });
	        lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
	        lineEl.style.strokeNoScale = true;
	        var style = data.getVisual('style');
	
	        if (style && style.stroke) {
	          lineEl.setStyle('stroke', style.stroke);
	        }
	
	        lineEl.setStyle('fill', null);
	        var ecData = getECData(lineEl); // Enable tooltip
	        // PENDING May have performance issue when path is extremely large
	
	        ecData.seriesIndex = hostModel.seriesIndex;
	        lineEl.on('mousemove', function (e) {
	          ecData.dataIndex = null;
	          var dataIndex = lineEl.hoverDataIdx;
	
	          if (dataIndex > 0) {
	            // Provide dataIndex for tooltip
	            ecData.dataIndex = dataIndex + lineEl.__startIndex;
	          }
	        });
	      };
	
	      LargeLineDraw.prototype._clear = function () {
	        this._newAdded = [];
	        this.group.removeAll();
	      };
	      return LargeLineDraw;
	    }();
	
	    var linesLayout = {
	      seriesType: 'lines',
	      plan: createRenderPlanner(),
	      reset: function (seriesModel) {
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (!coordSys) {
	          if (true) {
	            error('The lines series must have a coordinate system.');
	          }
	
	          return;
	        }
	
	        var isPolyline = seriesModel.get('polyline');
	        var isLarge = seriesModel.pipelineContext.large;
	        return {
	          progress: function (params, lineData) {
	            var lineCoords = [];
	
	            if (isLarge) {
	              var points = void 0;
	              var segCount = params.end - params.start;
	
	              if (isPolyline) {
	                var totalCoordsCount = 0;
	
	                for (var i = params.start; i < params.end; i++) {
	                  totalCoordsCount += seriesModel.getLineCoordsCount(i);
	                }
	
	                points = new Float32Array(segCount + totalCoordsCount * 2);
	              } else {
	                points = new Float32Array(segCount * 4);
	              }
	
	              var offset = 0;
	              var pt = [];
	
	              for (var i = params.start; i < params.end; i++) {
	                var len = seriesModel.getLineCoords(i, lineCoords);
	
	                if (isPolyline) {
	                  points[offset++] = len;
	                }
	
	                for (var k = 0; k < len; k++) {
	                  pt = coordSys.dataToPoint(lineCoords[k], false, pt);
	                  points[offset++] = pt[0];
	                  points[offset++] = pt[1];
	                }
	              }
	
	              lineData.setLayout('linesPoints', points);
	            } else {
	              for (var i = params.start; i < params.end; i++) {
	                var itemModel = lineData.getItemModel(i);
	                var len = seriesModel.getLineCoords(i, lineCoords);
	                var pts = [];
	
	                if (isPolyline) {
	                  for (var j = 0; j < len; j++) {
	                    pts.push(coordSys.dataToPoint(lineCoords[j]));
	                  }
	                } else {
	                  pts[0] = coordSys.dataToPoint(lineCoords[0]);
	                  pts[1] = coordSys.dataToPoint(lineCoords[1]);
	                  var curveness = itemModel.get(['lineStyle', 'curveness']);
	
	                  if (+curveness) {
	                    pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
	                  }
	                }
	
	                lineData.setItemLayout(i, pts);
	              }
	            }
	          }
	        };
	      }
	    };
	
	    var LinesView =
	    /** @class */
	    function (_super) {
	      __extends(LinesView, _super);
	
	      function LinesView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = LinesView.type;
	        return _this;
	      }
	
	      LinesView.prototype.render = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	
	        var lineDraw = this._updateLineDraw(data, seriesModel);
	
	        var zlevel = seriesModel.get('zlevel');
	        var trailLength = seriesModel.get(['effect', 'trailLength']);
	        var zr = api.getZr(); // Avoid the drag cause ghost shadow
	        // FIXME Better way ?
	        // SVG doesn't support
	
	        var isSvg = zr.painter.getType() === 'svg';
	
	        if (!isSvg) {
	          zr.painter.getLayer(zlevel).clear(true);
	        } // Config layer with motion blur
	
	
	        if (this._lastZlevel != null && !isSvg) {
	          zr.configLayer(this._lastZlevel, {
	            motionBlur: false
	          });
	        }
	
	        if (this._showEffect(seriesModel) && trailLength > 0) {
	          if (!isSvg) {
	            zr.configLayer(zlevel, {
	              motionBlur: true,
	              lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
	            });
	          } else if (true) {
	            console.warn('SVG render mode doesn\'t support lines with trail effect');
	          }
	        }
	
	        lineDraw.updateData(data);
	        var clipPath = seriesModel.get('clip', true) && createClipPath(seriesModel.coordinateSystem, false, seriesModel);
	
	        if (clipPath) {
	          this.group.setClipPath(clipPath);
	        } else {
	          this.group.removeClipPath();
	        }
	
	        this._lastZlevel = zlevel;
	        this._finished = true;
	      };
	
	      LinesView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	
	        var lineDraw = this._updateLineDraw(data, seriesModel);
	
	        lineDraw.incrementalPrepareUpdate(data);
	
	        this._clearLayer(api);
	
	        this._finished = false;
	      };
	
	      LinesView.prototype.incrementalRender = function (taskParams, seriesModel, ecModel) {
	        this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
	
	        this._finished = taskParams.end === seriesModel.getData().count();
	      };
	
	      LinesView.prototype.eachRendered = function (cb) {
	        this._lineDraw && this._lineDraw.eachRendered(cb);
	      };
	
	      LinesView.prototype.updateTransform = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	        var pipelineContext = seriesModel.pipelineContext;
	
	        if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) {
	          // TODO Don't have to do update in large mode. Only do it when there are millions of data.
	          return {
	            update: true
	          };
	        } else {
	          // TODO Use same logic with ScatterView.
	          // Manually update layout
	          var res = linesLayout.reset(seriesModel, ecModel, api);
	
	          if (res.progress) {
	            res.progress({
	              start: 0,
	              end: data.count(),
	              count: data.count()
	            }, data);
	          } // Not in large mode
	
	
	          this._lineDraw.updateLayout();
	
	          this._clearLayer(api);
	        }
	      };
	
	      LinesView.prototype._updateLineDraw = function (data, seriesModel) {
	        var lineDraw = this._lineDraw;
	
	        var hasEffect = this._showEffect(seriesModel);
	
	        var isPolyline = !!seriesModel.get('polyline');
	        var pipelineContext = seriesModel.pipelineContext;
	        var isLargeDraw = pipelineContext.large;
	
	        if (true) {
	          if (hasEffect && isLargeDraw) {
	            console.warn('Large lines not support effect');
	          }
	        }
	
	        if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
	          if (lineDraw) {
	            lineDraw.remove();
	          }
	
	          lineDraw = this._lineDraw = isLargeDraw ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline$1 : hasEffect ? EffectLine : Line$1);
	          this._hasEffet = hasEffect;
	          this._isPolyline = isPolyline;
	          this._isLargeDraw = isLargeDraw;
	        }
	
	        this.group.add(lineDraw.group);
	        return lineDraw;
	      };
	
	      LinesView.prototype._showEffect = function (seriesModel) {
	        return !!seriesModel.get(['effect', 'show']);
	      };
	
	      LinesView.prototype._clearLayer = function (api) {
	        // Not use motion when dragging or zooming
	        var zr = api.getZr();
	        var isSvg = zr.painter.getType() === 'svg';
	
	        if (!isSvg && this._lastZlevel != null) {
	          zr.painter.getLayer(this._lastZlevel).clear(true);
	        }
	      };
	
	      LinesView.prototype.remove = function (ecModel, api) {
	        this._lineDraw && this._lineDraw.remove();
	        this._lineDraw = null; // Clear motion when lineDraw is removed
	
	        this._clearLayer(api);
	      };
	
	      LinesView.prototype.dispose = function (ecModel, api) {
	        this.remove(ecModel, api);
	      };
	
	      LinesView.type = 'lines';
	      return LinesView;
	    }(ChartView);
	
	    var Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
	    var Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;
	
	    function compatEc2(seriesOpt) {
	      var data = seriesOpt.data;
	
	      if (data && data[0] && data[0][0] && data[0][0].coord) {
	        if (true) {
	          console.warn('Lines data configuration has been changed to' + ' { coords:[[1,2],[2,3]] }');
	        }
	
	        seriesOpt.data = map(data, function (itemOpt) {
	          var coords = [itemOpt[0].coord, itemOpt[1].coord];
	          var target = {
	            coords: coords
	          };
	
	          if (itemOpt[0].name) {
	            target.fromName = itemOpt[0].name;
	          }
	
	          if (itemOpt[1].name) {
	            target.toName = itemOpt[1].name;
	          }
	
	          return mergeAll([target, itemOpt[0], itemOpt[1]]);
	        });
	      }
	    }
	
	    var LinesSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(LinesSeriesModel, _super);
	
	      function LinesSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = LinesSeriesModel.type;
	        _this.visualStyleAccessPath = 'lineStyle';
	        _this.visualDrawType = 'stroke';
	        return _this;
	      }
	
	      LinesSeriesModel.prototype.init = function (option) {
	        // The input data may be null/undefined.
	        option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type
	
	        compatEc2(option);
	
	        var result = this._processFlatCoordsArray(option.data);
	
	        this._flatCoords = result.flatCoords;
	        this._flatCoordsOffset = result.flatCoordsOffset;
	
	        if (result.flatCoords) {
	          option.data = new Float32Array(result.count);
	        }
	
	        _super.prototype.init.apply(this, arguments);
	      };
	
	      LinesSeriesModel.prototype.mergeOption = function (option) {
	        compatEc2(option);
	
	        if (option.data) {
	          // Only update when have option data to merge.
	          var result = this._processFlatCoordsArray(option.data);
	
	          this._flatCoords = result.flatCoords;
	          this._flatCoordsOffset = result.flatCoordsOffset;
	
	          if (result.flatCoords) {
	            option.data = new Float32Array(result.count);
	          }
	        }
	
	        _super.prototype.mergeOption.apply(this, arguments);
	      };
	
	      LinesSeriesModel.prototype.appendData = function (params) {
	        var result = this._processFlatCoordsArray(params.data);
	
	        if (result.flatCoords) {
	          if (!this._flatCoords) {
	            this._flatCoords = result.flatCoords;
	            this._flatCoordsOffset = result.flatCoordsOffset;
	          } else {
	            this._flatCoords = concatArray(this._flatCoords, result.flatCoords);
	            this._flatCoordsOffset = concatArray(this._flatCoordsOffset, result.flatCoordsOffset);
	          }
	
	          params.data = new Float32Array(result.count);
	        }
	
	        this.getRawData().appendData(params.data);
	      };
	
	      LinesSeriesModel.prototype._getCoordsFromItemModel = function (idx) {
	        var itemModel = this.getData().getItemModel(idx);
	        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
	
	        if (true) {
	          if (!(coords instanceof Array && coords.length > 0 && coords[0] instanceof Array)) {
	            throw new Error('Invalid coords ' + JSON.stringify(coords) + '. Lines must have 2d coords array in data item.');
	          }
	        }
	
	        return coords;
	      };
	
	      LinesSeriesModel.prototype.getLineCoordsCount = function (idx) {
	        if (this._flatCoordsOffset) {
	          return this._flatCoordsOffset[idx * 2 + 1];
	        } else {
	          return this._getCoordsFromItemModel(idx).length;
	        }
	      };
	
	      LinesSeriesModel.prototype.getLineCoords = function (idx, out) {
	        if (this._flatCoordsOffset) {
	          var offset = this._flatCoordsOffset[idx * 2];
	          var len = this._flatCoordsOffset[idx * 2 + 1];
	
	          for (var i = 0; i < len; i++) {
	            out[i] = out[i] || [];
	            out[i][0] = this._flatCoords[offset + i * 2];
	            out[i][1] = this._flatCoords[offset + i * 2 + 1];
	          }
	
	          return len;
	        } else {
	          var coords = this._getCoordsFromItemModel(idx);
	
	          for (var i = 0; i < coords.length; i++) {
	            out[i] = out[i] || [];
	            out[i][0] = coords[i][0];
	            out[i][1] = coords[i][1];
	          }
	
	          return coords.length;
	        }
	      };
	
	      LinesSeriesModel.prototype._processFlatCoordsArray = function (data) {
	        var startOffset = 0;
	
	        if (this._flatCoords) {
	          startOffset = this._flatCoords.length;
	        } // Stored as a typed array. In format
	        // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
	
	
	        if (isNumber(data[0])) {
	          var len = data.length; // Store offset and len of each segment
	
	          var coordsOffsetAndLenStorage = new Uint32Arr(len);
	          var coordsStorage = new Float64Arr(len);
	          var coordsCursor = 0;
	          var offsetCursor = 0;
	          var dataCount = 0;
	
	          for (var i = 0; i < len;) {
	            dataCount++;
	            var count = data[i++]; // Offset
	
	            coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len
	
	            coordsOffsetAndLenStorage[offsetCursor++] = count;
	
	            for (var k = 0; k < count; k++) {
	              var x = data[i++];
	              var y = data[i++];
	              coordsStorage[coordsCursor++] = x;
	              coordsStorage[coordsCursor++] = y;
	
	              if (i > len) {
	                if (true) {
	                  throw new Error('Invalid data format.');
	                }
	              }
	            }
	          }
	
	          return {
	            flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
	            flatCoords: coordsStorage,
	            count: dataCount
	          };
	        }
	
	        return {
	          flatCoordsOffset: null,
	          flatCoords: null,
	          count: data.length
	        };
	      };
	
	      LinesSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        if (true) {
	          var CoordSys = CoordinateSystemManager.get(option.coordinateSystem);
	
	          if (!CoordSys) {
	            throw new Error('Unknown coordinate system ' + option.coordinateSystem);
	          }
	        }
	
	        var lineData = new SeriesData(['value'], this);
	        lineData.hasItemOption = false;
	        lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
	          // dataItem is simply coords
	          if (dataItem instanceof Array) {
	            return NaN;
	          } else {
	            lineData.hasItemOption = true;
	            var value = dataItem.value;
	
	            if (value != null) {
	              return value instanceof Array ? value[dimIndex] : value;
	            }
	          }
	        });
	        return lineData;
	      };
	
	      LinesSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        var data = this.getData();
	        var itemModel = data.getItemModel(dataIndex);
	        var name = itemModel.get('name');
	
	        if (name) {
	          return name;
	        }
	
	        var fromName = itemModel.get('fromName');
	        var toName = itemModel.get('toName');
	        var nameArr = [];
	        fromName != null && nameArr.push(fromName);
	        toName != null && nameArr.push(toName);
	        return createTooltipMarkup('nameValue', {
	          name: nameArr.join(' > ')
	        });
	      };
	
	      LinesSeriesModel.prototype.preventIncremental = function () {
	        return !!this.get(['effect', 'show']);
	      };
	
	      LinesSeriesModel.prototype.getProgressive = function () {
	        var progressive = this.option.progressive;
	
	        if (progressive == null) {
	          return this.option.large ? 1e4 : this.get('progressive');
	        }
	
	        return progressive;
	      };
	
	      LinesSeriesModel.prototype.getProgressiveThreshold = function () {
	        var progressiveThreshold = this.option.progressiveThreshold;
	
	        if (progressiveThreshold == null) {
	          return this.option.large ? 2e4 : this.get('progressiveThreshold');
	        }
	
	        return progressiveThreshold;
	      };
	
	      LinesSeriesModel.prototype.getZLevelKey = function () {
	        var effectModel = this.getModel('effect');
	        var trailLength = effectModel.get('trailLength');
	        return this.getData().count() > this.getProgressiveThreshold() // Each progressive series has individual key.
	        ? this.id : effectModel.get('show') && trailLength > 0 ? trailLength + '' : '';
	      };
	
	      LinesSeriesModel.type = 'series.lines';
	      LinesSeriesModel.dependencies = ['grid', 'polar', 'geo', 'calendar'];
	      LinesSeriesModel.defaultOption = {
	        coordinateSystem: 'geo',
	        // zlevel: 0,
	        z: 2,
	        legendHoverLink: true,
	        // Cartesian coordinate system
	        xAxisIndex: 0,
	        yAxisIndex: 0,
	        symbol: ['none', 'none'],
	        symbolSize: [10, 10],
	        // Geo coordinate system
	        geoIndex: 0,
	        effect: {
	          show: false,
	          period: 4,
	          constantSpeed: 0,
	          symbol: 'circle',
	          symbolSize: 3,
	          loop: true,
	          trailLength: 0.2
	        },
	        large: false,
	        // Available when large is true
	        largeThreshold: 2000,
	        polyline: false,
	        clip: true,
	        label: {
	          show: false,
	          position: 'end' // distance: 5,
	          // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	        },
	        lineStyle: {
	          opacity: 0.5
	        }
	      };
	      return LinesSeriesModel;
	    }(SeriesModel);
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function normalize$3(a) {
	      if (!(a instanceof Array)) {
	        a = [a, a];
	      }
	
	      return a;
	    }
	
	    var linesVisual = {
	      seriesType: 'lines',
	      reset: function (seriesModel) {
	        var symbolType = normalize$3(seriesModel.get('symbol'));
	        var symbolSize = normalize$3(seriesModel.get('symbolSize'));
	        var data = seriesModel.getData();
	        data.setVisual('fromSymbol', symbolType && symbolType[0]);
	        data.setVisual('toSymbol', symbolType && symbolType[1]);
	        data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	        data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	
	        function dataEach(data, idx) {
	          var itemModel = data.getItemModel(idx);
	          var symbolType = normalize$3(itemModel.getShallow('symbol', true));
	          var symbolSize = normalize$3(itemModel.getShallow('symbolSize', true));
	          symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
	          symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
	          symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
	          symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
	        }
	
	        return {
	          dataEach: data.hasItemOption ? dataEach : null
	        };
	      }
	    };
	
	    function install$m(registers) {
	      registers.registerChartView(LinesView);
	      registers.registerSeriesModel(LinesSeriesModel);
	      registers.registerLayout(linesLayout);
	      registers.registerVisual(linesVisual);
	    }
	
	    var GRADIENT_LEVELS = 256;
	
	    var HeatmapLayer =
	    /** @class */
	    function () {
	      function HeatmapLayer() {
	        this.blurSize = 30;
	        this.pointSize = 20;
	        this.maxOpacity = 1;
	        this.minOpacity = 0;
	        this._gradientPixels = {
	          inRange: null,
	          outOfRange: null
	        };
	        var canvas = platformApi.createCanvas();
	        this.canvas = canvas;
	      }
	      /**
	       * Renders Heatmap and returns the rendered canvas
	       * @param data array of data, each has x, y, value
	       * @param width canvas width
	       * @param height canvas height
	       */
	
	
	      HeatmapLayer.prototype.update = function (data, width, height, normalize, colorFunc, isInRange) {
	        var brush = this._getBrush();
	
	        var gradientInRange = this._getGradient(colorFunc, 'inRange');
	
	        var gradientOutOfRange = this._getGradient(colorFunc, 'outOfRange');
	
	        var r = this.pointSize + this.blurSize;
	        var canvas = this.canvas;
	        var ctx = canvas.getContext('2d');
	        var len = data.length;
	        canvas.width = width;
	        canvas.height = height;
	
	        for (var i = 0; i < len; ++i) {
	          var p = data[i];
	          var x = p[0];
	          var y = p[1];
	          var value = p[2]; // calculate alpha using value
	
	          var alpha = normalize(value); // draw with the circle brush with alpha
	
	          ctx.globalAlpha = alpha;
	          ctx.drawImage(brush, x - r, y - r);
	        }
	
	        if (!canvas.width || !canvas.height) {
	          // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
	          // 'CanvasRenderingContext2D': The source height is 0."
	          return canvas;
	        } // colorize the canvas using alpha value and set with gradient
	
	
	        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	        var pixels = imageData.data;
	        var offset = 0;
	        var pixelLen = pixels.length;
	        var minOpacity = this.minOpacity;
	        var maxOpacity = this.maxOpacity;
	        var diffOpacity = maxOpacity - minOpacity;
	
	        while (offset < pixelLen) {
	          var alpha = pixels[offset + 3] / 256;
	          var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data
	
	          if (alpha > 0) {
	            var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
	
	            alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
	            pixels[offset++] = gradient[gradientOffset];
	            pixels[offset++] = gradient[gradientOffset + 1];
	            pixels[offset++] = gradient[gradientOffset + 2];
	            pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
	          } else {
	            offset += 4;
	          }
	        }
	
	        ctx.putImageData(imageData, 0, 0);
	        return canvas;
	      };
	      /**
	       * get canvas of a black circle brush used for canvas to draw later
	       */
	
	
	      HeatmapLayer.prototype._getBrush = function () {
	        var brushCanvas = this._brushCanvas || (this._brushCanvas = platformApi.createCanvas()); // set brush size
	
	        var r = this.pointSize + this.blurSize;
	        var d = r * 2;
	        brushCanvas.width = d;
	        brushCanvas.height = d;
	        var ctx = brushCanvas.getContext('2d');
	        ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
	        // draw the distinct circle in an invisible place,
	        // and use shadowOffset to draw shadow in the center of the canvas
	
	        ctx.shadowOffsetX = d;
	        ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
	        // color in color map
	
	        ctx.shadowColor = '#000'; // draw circle in the left to the canvas
	
	        ctx.beginPath();
	        ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
	        ctx.closePath();
	        ctx.fill();
	        return brushCanvas;
	      };
	      /**
	       * get gradient color map
	       * @private
	       */
	
	
	      HeatmapLayer.prototype._getGradient = function (colorFunc, state) {
	        var gradientPixels = this._gradientPixels;
	        var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
	        var color = [0, 0, 0, 0];
	        var off = 0;
	
	        for (var i = 0; i < 256; i++) {
	          colorFunc[state](i / 255, true, color);
	          pixelsSingleState[off++] = color[0];
	          pixelsSingleState[off++] = color[1];
	          pixelsSingleState[off++] = color[2];
	          pixelsSingleState[off++] = color[3];
	        }
	
	        return pixelsSingleState;
	      };
	
	      return HeatmapLayer;
	    }();
	
	    function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
	      var dataSpan = dataExtent[1] - dataExtent[0];
	      pieceList = map(pieceList, function (piece) {
	        return {
	          interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
	        };
	      });
	      var len = pieceList.length;
	      var lastIndex = 0;
	      return function (val) {
	        var i; // Try to find in the location of the last found
	
	        for (i = lastIndex; i < len; i++) {
	          var interval = pieceList[i].interval;
	
	          if (interval[0] <= val && val <= interval[1]) {
	            lastIndex = i;
	            break;
	          }
	        }
	
	        if (i === len) {
	          // Not found, back interation
	          for (i = lastIndex - 1; i >= 0; i--) {
	            var interval = pieceList[i].interval;
	
	            if (interval[0] <= val && val <= interval[1]) {
	              lastIndex = i;
	              break;
	            }
	          }
	        }
	
	        return i >= 0 && i < len && selected[i];
	      };
	    }
	
	    function getIsInContinuousRange(dataExtent, range) {
	      var dataSpan = dataExtent[1] - dataExtent[0];
	      range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
	      return function (val) {
	        return val >= range[0] && val <= range[1];
	      };
	    }
	
	    function isGeoCoordSys(coordSys) {
	      var dimensions = coordSys.dimensions; // Not use coordSys.type === 'geo' because coordSys maybe extended
	
	      return dimensions[0] === 'lng' && dimensions[1] === 'lat';
	    }
	
	    var HeatmapView =
	    /** @class */
	    function (_super) {
	      __extends(HeatmapView, _super);
	
	      function HeatmapView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = HeatmapView.type;
	        return _this;
	      }
	
	      HeatmapView.prototype.render = function (seriesModel, ecModel, api) {
	        var visualMapOfThisSeries;
	        ecModel.eachComponent('visualMap', function (visualMap) {
	          visualMap.eachTargetSeries(function (targetSeries) {
	            if (targetSeries === seriesModel) {
	              visualMapOfThisSeries = visualMap;
	            }
	          });
	        });
	
	        if (true) {
	          if (!visualMapOfThisSeries) {
	            throw new Error('Heatmap must use with visualMap');
	          }
	        } // Clear previously rendered progressive elements.
	
	
	        this._progressiveEls = null;
	        this.group.removeAll();
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
	          this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
	        } else if (isGeoCoordSys(coordSys)) {
	          this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
	        }
	      };
	
	      HeatmapView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
	        this.group.removeAll();
	      };
	
	      HeatmapView.prototype.incrementalRender = function (params, seriesModel, ecModel, api) {
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (coordSys) {
	          // geo does not support incremental rendering?
	          if (isGeoCoordSys(coordSys)) {
	            this.render(seriesModel, ecModel, api);
	          } else {
	            this._progressiveEls = [];
	
	            this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
	          }
	        }
	      };
	
	      HeatmapView.prototype.eachRendered = function (cb) {
	        traverseElements(this._progressiveEls || this.group, cb);
	      };
	
	      HeatmapView.prototype._renderOnCartesianAndCalendar = function (seriesModel, api, start, end, incremental) {
	        var coordSys = seriesModel.coordinateSystem;
	        var isCartesian2d = isCoordinateSystemType(coordSys, 'cartesian2d');
	        var width;
	        var height;
	        var xAxisExtent;
	        var yAxisExtent;
	
	        if (isCartesian2d) {
	          var xAxis = coordSys.getAxis('x');
	          var yAxis = coordSys.getAxis('y');
	
	          if (true) {
	            if (!(xAxis.type === 'category' && yAxis.type === 'category')) {
	              throw new Error('Heatmap on cartesian must have two category axes');
	            }
	
	            if (!(xAxis.onBand && yAxis.onBand)) {
	              throw new Error('Heatmap on cartesian must have two axes with boundaryGap true');
	            }
	          } // add 0.5px to avoid the gaps
	
	
	          width = xAxis.getBandWidth() + .5;
	          height = yAxis.getBandWidth() + .5;
	          xAxisExtent = xAxis.scale.getExtent();
	          yAxisExtent = yAxis.scale.getExtent();
	        }
	
	        var group = this.group;
	        var data = seriesModel.getData();
	        var emphasisStyle = seriesModel.getModel(['emphasis', 'itemStyle']).getItemStyle();
	        var blurStyle = seriesModel.getModel(['blur', 'itemStyle']).getItemStyle();
	        var selectStyle = seriesModel.getModel(['select', 'itemStyle']).getItemStyle();
	        var borderRadius = seriesModel.get(['itemStyle', 'borderRadius']);
	        var labelStatesModels = getLabelStatesModels(seriesModel);
	        var emphasisModel = seriesModel.getModel('emphasis');
	        var focus = emphasisModel.get('focus');
	        var blurScope = emphasisModel.get('blurScope');
	        var emphasisDisabled = emphasisModel.get('disabled');
	        var dataDims = isCartesian2d ? [data.mapDimension('x'), data.mapDimension('y'), data.mapDimension('value')] : [data.mapDimension('time'), data.mapDimension('value')];
	
	        for (var idx = start; idx < end; idx++) {
	          var rect = void 0;
	          var style = data.getItemVisual(idx, 'style');
	
	          if (isCartesian2d) {
	            var dataDimX = data.get(dataDims[0], idx);
	            var dataDimY = data.get(dataDims[1], idx); // Ignore empty data and out of extent data
	
	            if (isNaN(data.get(dataDims[2], idx)) || isNaN(dataDimX) || isNaN(dataDimY) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) {
	              continue;
	            }
	
	            var point = coordSys.dataToPoint([dataDimX, dataDimY]);
	            rect = new Rect({
	              shape: {
	                x: point[0] - width / 2,
	                y: point[1] - height / 2,
	                width: width,
	                height: height
	              },
	              style: style
	            });
	          } else {
	            // Ignore empty data
	            if (isNaN(data.get(dataDims[1], idx))) {
	              continue;
	            }
	
	            rect = new Rect({
	              z2: 1,
	              shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
	              style: style
	            });
	          } // Optimization for large dataset
	
	
	          if (data.hasItemOption) {
	            var itemModel = data.getItemModel(idx);
	            var emphasisModel_1 = itemModel.getModel('emphasis');
	            emphasisStyle = emphasisModel_1.getModel('itemStyle').getItemStyle();
	            blurStyle = itemModel.getModel(['blur', 'itemStyle']).getItemStyle();
	            selectStyle = itemModel.getModel(['select', 'itemStyle']).getItemStyle(); // Each item value struct in the data would be firstly
	            // {
	            //     itemStyle: { borderRadius: [30, 30] },
	            //     value: [2022, 02, 22]
	            // }
	
	            borderRadius = itemModel.get(['itemStyle', 'borderRadius']);
	            focus = emphasisModel_1.get('focus');
	            blurScope = emphasisModel_1.get('blurScope');
	            emphasisDisabled = emphasisModel_1.get('disabled');
	            labelStatesModels = getLabelStatesModels(itemModel);
	          }
	
	          rect.shape.r = borderRadius;
	          var rawValue = seriesModel.getRawValue(idx);
	          var defaultText = '-';
	
	          if (rawValue && rawValue[2] != null) {
	            defaultText = rawValue[2] + '';
	          }
	
	          setLabelStyle(rect, labelStatesModels, {
	            labelFetcher: seriesModel,
	            labelDataIndex: idx,
	            defaultOpacity: style.opacity,
	            defaultText: defaultText
	          });
	          rect.ensureState('emphasis').style = emphasisStyle;
	          rect.ensureState('blur').style = blurStyle;
	          rect.ensureState('select').style = selectStyle;
	          toggleHoverEmphasis(rect, focus, blurScope, emphasisDisabled);
	          rect.incremental = incremental; // PENDING
	
	          if (incremental) {
	            // Rect must use hover layer if it's incremental.
	            rect.states.emphasis.hoverLayer = true;
	          }
	
	          group.add(rect);
	          data.setItemGraphicEl(idx, rect);
	
	          if (this._progressiveEls) {
	            this._progressiveEls.push(rect);
	          }
	        }
	      };
	
	      HeatmapView.prototype._renderOnGeo = function (geo, seriesModel, visualMapModel, api) {
	        var inRangeVisuals = visualMapModel.targetVisuals.inRange;
	        var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
	        //     throw new Error('Data range must have color visuals');
	        // }
	
	        var data = seriesModel.getData();
	        var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
	        hmLayer.blurSize = seriesModel.get('blurSize');
	        hmLayer.pointSize = seriesModel.get('pointSize');
	        hmLayer.minOpacity = seriesModel.get('minOpacity');
	        hmLayer.maxOpacity = seriesModel.get('maxOpacity');
	        var rect = geo.getViewRect().clone();
	        var roamTransform = geo.getRoamTransform();
	        rect.applyTransform(roamTransform); // Clamp on viewport
	
	        var x = Math.max(rect.x, 0);
	        var y = Math.max(rect.y, 0);
	        var x2 = Math.min(rect.width + rect.x, api.getWidth());
	        var y2 = Math.min(rect.height + rect.y, api.getHeight());
	        var width = x2 - x;
	        var height = y2 - y;
	        var dims = [data.mapDimension('lng'), data.mapDimension('lat'), data.mapDimension('value')];
	        var points = data.mapArray(dims, function (lng, lat, value) {
	          var pt = geo.dataToPoint([lng, lat]);
	          pt[0] -= x;
	          pt[1] -= y;
	          pt.push(value);
	          return pt;
	        });
	        var dataExtent = visualMapModel.getExtent();
	        var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
	        hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
	          inRange: inRangeVisuals.color.getColorMapper(),
	          outOfRange: outOfRangeVisuals.color.getColorMapper()
	        }, isInRange);
	        var img = new ZRImage({
	          style: {
	            width: width,
	            height: height,
	            x: x,
	            y: y,
	            image: hmLayer.canvas
	          },
	          silent: true
	        });
	        this.group.add(img);
	      };
	
	      HeatmapView.type = 'heatmap';
	      return HeatmapView;
	    }(ChartView);
	
	    var HeatmapSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(HeatmapSeriesModel, _super);
	
	      function HeatmapSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = HeatmapSeriesModel.type;
	        return _this;
	      }
	
	      HeatmapSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return createSeriesData(null, this, {
	          generateCoord: 'value'
	        });
	      };
	
	      HeatmapSeriesModel.prototype.preventIncremental = function () {
	        var coordSysCreator = CoordinateSystemManager.get(this.get('coordinateSystem'));
	
	        if (coordSysCreator && coordSysCreator.dimensions) {
	          return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
	        }
	      };
	
	      HeatmapSeriesModel.type = 'series.heatmap';
	      HeatmapSeriesModel.dependencies = ['grid', 'geo', 'calendar'];
	      HeatmapSeriesModel.defaultOption = {
	        coordinateSystem: 'cartesian2d',
	        // zlevel: 0,
	        z: 2,
	        // Cartesian coordinate system
	        // xAxisIndex: 0,
	        // yAxisIndex: 0,
	        // Geo coordinate system
	        geoIndex: 0,
	        blurSize: 30,
	        pointSize: 20,
	        maxOpacity: 1,
	        minOpacity: 0,
	        select: {
	          itemStyle: {
	            borderColor: '#212121'
	          }
	        }
	      };
	      return HeatmapSeriesModel;
	    }(SeriesModel);
	
	    function install$n(registers) {
	      registers.registerChartView(HeatmapView);
	      registers.registerSeriesModel(HeatmapSeriesModel);
	    }
	
	    var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'borderWidth']; // index: +isHorizontal
	
	    var LAYOUT_ATTRS = [{
	      xy: 'x',
	      wh: 'width',
	      index: 0,
	      posDesc: ['left', 'right']
	    }, {
	      xy: 'y',
	      wh: 'height',
	      index: 1,
	      posDesc: ['top', 'bottom']
	    }];
	    var pathForLineWidth = new Circle();
	
	    var PictorialBarView =
	    /** @class */
	    function (_super) {
	      __extends(PictorialBarView, _super);
	
	      function PictorialBarView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = PictorialBarView.type;
	        return _this;
	      }
	
	      PictorialBarView.prototype.render = function (seriesModel, ecModel, api) {
	        var group = this.group;
	        var data = seriesModel.getData();
	        var oldData = this._data;
	        var cartesian = seriesModel.coordinateSystem;
	        var baseAxis = cartesian.getBaseAxis();
	        var isHorizontal = baseAxis.isHorizontal();
	        var coordSysRect = cartesian.master.getRect();
	        var opt = {
	          ecSize: {
	            width: api.getWidth(),
	            height: api.getHeight()
	          },
	          seriesModel: seriesModel,
	          coordSys: cartesian,
	          coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
	          isHorizontal: isHorizontal,
	          valueDim: LAYOUT_ATTRS[+isHorizontal],
	          categoryDim: LAYOUT_ATTRS[1 - +isHorizontal]
	        };
	        data.diff(oldData).add(function (dataIndex) {
	          if (!data.hasValue(dataIndex)) {
	            return;
	          }
	
	          var itemModel = getItemModel(data, dataIndex);
	          var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
	          var bar = createBar(data, opt, symbolMeta);
	          data.setItemGraphicEl(dataIndex, bar);
	          group.add(bar);
	          updateCommon$1(bar, opt, symbolMeta);
	        }).update(function (newIndex, oldIndex) {
	          var bar = oldData.getItemGraphicEl(oldIndex);
	
	          if (!data.hasValue(newIndex)) {
	            group.remove(bar);
	            return;
	          }
	
	          var itemModel = getItemModel(data, newIndex);
	          var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
	          var pictorialShapeStr = getShapeStr(data, symbolMeta);
	
	          if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
	            group.remove(bar);
	            data.setItemGraphicEl(newIndex, null);
	            bar = null;
	          }
	
	          if (bar) {
	            updateBar(bar, opt, symbolMeta);
	          } else {
	            bar = createBar(data, opt, symbolMeta, true);
	          }
	
	          data.setItemGraphicEl(newIndex, bar);
	          bar.__pictorialSymbolMeta = symbolMeta; // Add back
	
	          group.add(bar);
	          updateCommon$1(bar, opt, symbolMeta);
	        }).remove(function (dataIndex) {
	          var bar = oldData.getItemGraphicEl(dataIndex);
	          bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
	        }).execute();
	        this._data = data;
	        return this.group;
	      };
	
	      PictorialBarView.prototype.remove = function (ecModel, api) {
	        var group = this.group;
	        var data = this._data;
	
	        if (ecModel.get('animation')) {
	          if (data) {
	            data.eachItemGraphicEl(function (bar) {
	              removeBar(data, getECData(bar).dataIndex, ecModel, bar);
	            });
	          }
	        } else {
	          group.removeAll();
	        }
	      };
	
	      PictorialBarView.type = 'pictorialBar';
	      return PictorialBarView;
	    }(ChartView); // Set or calculate default value about symbol, and calculate layout info.
	
	
	    function getSymbolMeta(data, dataIndex, itemModel, opt) {
	      var layout = data.getItemLayout(dataIndex);
	      var symbolRepeat = itemModel.get('symbolRepeat');
	      var symbolClip = itemModel.get('symbolClip');
	      var symbolPosition = itemModel.get('symbolPosition') || 'start';
	      var symbolRotate = itemModel.get('symbolRotate');
	      var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	      var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
	      var isAnimationEnabled = itemModel.isAnimationEnabled();
	      var symbolMeta = {
	        dataIndex: dataIndex,
	        layout: layout,
	        itemModel: itemModel,
	        symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
	        style: data.getItemVisual(dataIndex, 'style'),
	        symbolClip: symbolClip,
	        symbolRepeat: symbolRepeat,
	        symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
	        symbolPatternSize: symbolPatternSize,
	        rotation: rotation,
	        animationModel: isAnimationEnabled ? itemModel : null,
	        hoverScale: isAnimationEnabled && itemModel.get(['emphasis', 'scale']),
	        z2: itemModel.getShallow('z', true) || 0
	      };
	      prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
	      prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
	      prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
	      var symbolSize = symbolMeta.symbolSize;
	      var symbolOffset = normalizeSymbolOffset(itemModel.get('symbolOffset'), symbolSize);
	      prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
	      return symbolMeta;
	    } // bar length can be negative.
	
	
	    function prepareBarLength(itemModel, symbolRepeat, layout, opt, outputSymbolMeta) {
	      var valueDim = opt.valueDim;
	      var symbolBoundingData = itemModel.get('symbolBoundingData');
	      var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
	      var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
	      var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
	      var boundingLength;
	
	      if (isArray(symbolBoundingData)) {
	        var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
	        symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
	        boundingLength = symbolBoundingExtent[pxSignIdx];
	      } else if (symbolBoundingData != null) {
	        boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
	      } else if (symbolRepeat) {
	        boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
	      } else {
	        boundingLength = layout[valueDim.wh];
	      }
	
	      outputSymbolMeta.boundingLength = boundingLength;
	
	      if (symbolRepeat) {
	        outputSymbolMeta.repeatCutLength = layout[valueDim.wh];
	      } // if 'pxSign' means sign of pixel,  it can't be zero, or symbolScale will be zero
	      // and when borderWidth be settled, the actual linewidth will be NaN
	
	
	      outputSymbolMeta.pxSign = boundingLength > 0 ? 1 : -1;
	    }
	
	    function convertToCoordOnAxis(axis, value) {
	      return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
	    } // Support ['100%', '100%']
	
	
	    function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, outputSymbolMeta) {
	      var valueDim = opt.valueDim;
	      var categoryDim = opt.categoryDim;
	      var categorySize = Math.abs(layout[categoryDim.wh]);
	      var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
	      var parsedSymbolSize;
	
	      if (isArray(symbolSize)) {
	        parsedSymbolSize = symbolSize.slice();
	      } else {
	        if (symbolSize == null) {
	          // will parse to number below
	          parsedSymbolSize = ['100%', '100%'];
	        } else {
	          parsedSymbolSize = [symbolSize, symbolSize];
	        }
	      } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
	      // to complicated to calculate real percent value if considering scaled lineWidth.
	      // So the actual size will bigger than layout size if lineWidth is bigger than zero,
	      // which can be tolerated in pictorial chart.
	
	
	      parsedSymbolSize[categoryDim.index] = parsePercent$1(parsedSymbolSize[categoryDim.index], categorySize);
	      parsedSymbolSize[valueDim.index] = parsePercent$1(parsedSymbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
	      outputSymbolMeta.symbolSize = parsedSymbolSize; // If x or y is less than zero, show reversed shape.
	
	      var symbolScale = outputSymbolMeta.symbolScale = [parsedSymbolSize[0] / symbolPatternSize, parsedSymbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.
	
	      symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
	    }
	
	    function prepareLineWidth(itemModel, symbolScale, rotation, opt, outputSymbolMeta) {
	      // In symbols are drawn with scale, so do not need to care about the case that width
	      // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
	      // be calculated.
	      var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
	
	      if (valueLineWidth) {
	        pathForLineWidth.attr({
	          scaleX: symbolScale[0],
	          scaleY: symbolScale[1],
	          rotation: rotation
	        });
	        pathForLineWidth.updateTransform();
	        valueLineWidth /= pathForLineWidth.getLineScale();
	        valueLineWidth *= symbolScale[opt.valueDim.index];
	      }
	
	      outputSymbolMeta.valueLineWidth = valueLineWidth || 0;
	    }
	
	    function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, outputSymbolMeta) {
	      var categoryDim = opt.categoryDim;
	      var valueDim = opt.valueDim;
	      var pxSign = outputSymbolMeta.pxSign;
	      var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
	      var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
	      // want symbols to rotate on its center, which should not be translated
	      // when rotating.
	
	      if (symbolRepeat) {
	        var absBoundingLength = Math.abs(boundingLength);
	        var symbolMargin = retrieve(itemModel.get('symbolMargin'), '15%') + '';
	        var hasEndGap = false;
	
	        if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
	          hasEndGap = true;
	          symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
	        }
	
	        var symbolMarginNumeric = parsePercent$1(symbolMargin, symbolSize[valueDim.index]);
	        var uLenWithMargin = Math.max(unitLength + symbolMarginNumeric * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
	        // to ensure that all of the symbols will not be overflow the given area.
	
	        var endFix = hasEndGap ? 0 : symbolMarginNumeric * 2; // Both final repeatTimes and final symbolMarginNumeric area calculated based on
	        // boundingLength.
	
	        var repeatSpecified = isNumeric(symbolRepeat);
	        var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
	        // entirely in the given layout area.
	
	        var mDiff = absBoundingLength - repeatTimes * unitLength;
	        symbolMarginNumeric = mDiff / 2 / (hasEndGap ? repeatTimes : Math.max(repeatTimes - 1, 1));
	        uLenWithMargin = unitLength + symbolMarginNumeric * 2;
	        endFix = hasEndGap ? 0 : symbolMarginNumeric * 2; // Update repeatTimes when not all symbol will be shown.
	
	        if (!repeatSpecified && symbolRepeat !== 'fixed') {
	          repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
	        }
	
	        pathLen = repeatTimes * uLenWithMargin - endFix;
	        outputSymbolMeta.repeatTimes = repeatTimes;
	        outputSymbolMeta.symbolMargin = symbolMarginNumeric;
	      }
	
	      var sizeFix = pxSign * (pathLen / 2);
	      var pathPosition = outputSymbolMeta.pathPosition = [];
	      pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
	      pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
	
	      if (symbolOffset) {
	        pathPosition[0] += symbolOffset[0];
	        pathPosition[1] += symbolOffset[1];
	      }
	
	      var bundlePosition = outputSymbolMeta.bundlePosition = [];
	      bundlePosition[categoryDim.index] = layout[categoryDim.xy];
	      bundlePosition[valueDim.index] = layout[valueDim.xy];
	      var barRectShape = outputSymbolMeta.barRectShape = extend({}, layout);
	      barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
	      barRectShape[categoryDim.wh] = layout[categoryDim.wh];
	      var clipShape = outputSymbolMeta.clipShape = {}; // Consider that symbol may be overflow layout rect.
	
	      clipShape[categoryDim.xy] = -layout[categoryDim.xy];
	      clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
	      clipShape[valueDim.xy] = 0;
	      clipShape[valueDim.wh] = layout[valueDim.wh];
	    }
	
	    function createPath(symbolMeta) {
	      var symbolPatternSize = symbolMeta.symbolPatternSize;
	      var path = createSymbol( // Consider texture img, make a big size.
	      symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize);
	      path.attr({
	        culling: true
	      });
	      path.type !== 'image' && path.setStyle({
	        strokeNoScale: true
	      });
	      return path;
	    }
	
	    function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
	      var bundle = bar.__pictorialBundle;
	      var symbolSize = symbolMeta.symbolSize;
	      var valueLineWidth = symbolMeta.valueLineWidth;
	      var pathPosition = symbolMeta.pathPosition;
	      var valueDim = opt.valueDim;
	      var repeatTimes = symbolMeta.repeatTimes || 0;
	      var index = 0;
	      var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
	      eachPath(bar, function (path) {
	        path.__pictorialAnimationIndex = index;
	        path.__pictorialRepeatTimes = repeatTimes;
	
	        if (index < repeatTimes) {
	          updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
	        } else {
	          updateAttr(path, null, {
	            scaleX: 0,
	            scaleY: 0
	          }, symbolMeta, isUpdate, function () {
	            bundle.remove(path);
	          });
	        } // updateHoverAnimation(path, symbolMeta);
	
	
	        index++;
	      });
	
	      for (; index < repeatTimes; index++) {
	        var path = createPath(symbolMeta);
	        path.__pictorialAnimationIndex = index;
	        path.__pictorialRepeatTimes = repeatTimes;
	        bundle.add(path);
	        var target = makeTarget(index);
	        updateAttr(path, {
	          x: target.x,
	          y: target.y,
	          scaleX: 0,
	          scaleY: 0
	        }, {
	          scaleX: target.scaleX,
	          scaleY: target.scaleY,
	          rotation: target.rotation
	        }, symbolMeta, isUpdate);
	      }
	
	      function makeTarget(index) {
	        var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
	        // Otherwise: i = index;
	
	        var pxSign = symbolMeta.pxSign;
	        var i = index;
	
	        if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
	          i = repeatTimes - 1 - index;
	        }
	
	        position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
	        return {
	          x: position[0],
	          y: position[1],
	          scaleX: symbolMeta.symbolScale[0],
	          scaleY: symbolMeta.symbolScale[1],
	          rotation: symbolMeta.rotation
	        };
	      }
	    }
	
	    function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
	      var bundle = bar.__pictorialBundle;
	      var mainPath = bar.__pictorialMainPath;
	
	      if (!mainPath) {
	        mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
	        bundle.add(mainPath);
	        updateAttr(mainPath, {
	          x: symbolMeta.pathPosition[0],
	          y: symbolMeta.pathPosition[1],
	          scaleX: 0,
	          scaleY: 0,
	          rotation: symbolMeta.rotation
	        }, {
	          scaleX: symbolMeta.symbolScale[0],
	          scaleY: symbolMeta.symbolScale[1]
	        }, symbolMeta, isUpdate);
	      } else {
	        updateAttr(mainPath, null, {
	          x: symbolMeta.pathPosition[0],
	          y: symbolMeta.pathPosition[1],
	          scaleX: symbolMeta.symbolScale[0],
	          scaleY: symbolMeta.symbolScale[1],
	          rotation: symbolMeta.rotation
	        }, symbolMeta, isUpdate);
	      }
	    } // bar rect is used for label.
	
	
	    function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
	      var rectShape = extend({}, symbolMeta.barRectShape);
	      var barRect = bar.__pictorialBarRect;
	
	      if (!barRect) {
	        barRect = bar.__pictorialBarRect = new Rect({
	          z2: 2,
	          shape: rectShape,
	          silent: true,
	          style: {
	            stroke: 'transparent',
	            fill: 'transparent',
	            lineWidth: 0
	          }
	        });
	        barRect.disableMorphing = true;
	        bar.add(barRect);
	      } else {
	        updateAttr(barRect, null, {
	          shape: rectShape
	        }, symbolMeta, isUpdate);
	      }
	    }
	
	    function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
	      // If not clip, symbol will be remove and rebuilt.
	      if (symbolMeta.symbolClip) {
	        var clipPath = bar.__pictorialClipPath;
	        var clipShape = extend({}, symbolMeta.clipShape);
	        var valueDim = opt.valueDim;
	        var animationModel = symbolMeta.animationModel;
	        var dataIndex = symbolMeta.dataIndex;
	
	        if (clipPath) {
	          updateProps(clipPath, {
	            shape: clipShape
	          }, animationModel, dataIndex);
	        } else {
	          clipShape[valueDim.wh] = 0;
	          clipPath = new Rect({
	            shape: clipShape
	          });
	
	          bar.__pictorialBundle.setClipPath(clipPath);
	
	          bar.__pictorialClipPath = clipPath;
	          var target = {};
	          target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
	          graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
	            shape: target
	          }, animationModel, dataIndex);
	        }
	      }
	    }
	
	    function getItemModel(data, dataIndex) {
	      var itemModel = data.getItemModel(dataIndex);
	      itemModel.getAnimationDelayParams = getAnimationDelayParams;
	      itemModel.isAnimationEnabled = isAnimationEnabled;
	      return itemModel;
	    }
	
	    function getAnimationDelayParams(path) {
	      // The order is the same as the z-order, see `symbolRepeatDiretion`.
	      return {
	        index: path.__pictorialAnimationIndex,
	        count: path.__pictorialRepeatTimes
	      };
	    }
	
	    function isAnimationEnabled() {
	      // `animation` prop can be set on itemModel in pictorial bar chart.
	      return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
	    }
	
	    function createBar(data, opt, symbolMeta, isUpdate) {
	      // bar is the main element for each data.
	      var bar = new Group(); // bundle is used for location and clip.
	
	      var bundle = new Group();
	      bar.add(bundle);
	      bar.__pictorialBundle = bundle;
	      bundle.x = symbolMeta.bundlePosition[0];
	      bundle.y = symbolMeta.bundlePosition[1];
	
	      if (symbolMeta.symbolRepeat) {
	        createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
	      } else {
	        createOrUpdateSingleSymbol(bar, opt, symbolMeta);
	      }
	
	      createOrUpdateBarRect(bar, symbolMeta, isUpdate);
	      createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
	      bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
	      bar.__pictorialSymbolMeta = symbolMeta;
	      return bar;
	    }
	
	    function updateBar(bar, opt, symbolMeta) {
	      var animationModel = symbolMeta.animationModel;
	      var dataIndex = symbolMeta.dataIndex;
	      var bundle = bar.__pictorialBundle;
	      updateProps(bundle, {
	        x: symbolMeta.bundlePosition[0],
	        y: symbolMeta.bundlePosition[1]
	      }, animationModel, dataIndex);
	
	      if (symbolMeta.symbolRepeat) {
	        createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
	      } else {
	        createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
	      }
	
	      createOrUpdateBarRect(bar, symbolMeta, true);
	      createOrUpdateClip(bar, opt, symbolMeta, true);
	    }
	
	    function removeBar(data, dataIndex, animationModel, bar) {
	      // Not show text when animating
	      var labelRect = bar.__pictorialBarRect;
	      labelRect && labelRect.removeTextContent();
	      var paths = [];
	      eachPath(bar, function (path) {
	        paths.push(path);
	      });
	      bar.__pictorialMainPath && paths.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.
	
	      bar.__pictorialClipPath && (animationModel = null);
	      each(paths, function (path) {
	        removeElement(path, {
	          scaleX: 0,
	          scaleY: 0
	        }, animationModel, dataIndex, function () {
	          bar.parent && bar.parent.remove(bar);
	        });
	      });
	      data.setItemGraphicEl(dataIndex, null);
	    }
	
	    function getShapeStr(data, symbolMeta) {
	      return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
	    }
	
	    function eachPath(bar, cb, context) {
	      // Do not use Group#eachChild, because it do not support remove.
	      each(bar.__pictorialBundle.children(), function (el) {
	        el !== bar.__pictorialBarRect && cb.call(context, el);
	      });
	    }
	
	    function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
	      immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
	
	      if (symbolMeta.symbolClip && !isUpdate) {
	        animationAttrs && el.attr(animationAttrs);
	      } else {
	        animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
	      }
	    }
	
	    function updateCommon$1(bar, opt, symbolMeta) {
	      var dataIndex = symbolMeta.dataIndex;
	      var itemModel = symbolMeta.itemModel; // Color must be excluded.
	      // Because symbol provide setColor individually to set fill and stroke
	
	      var emphasisModel = itemModel.getModel('emphasis');
	      var emphasisStyle = emphasisModel.getModel('itemStyle').getItemStyle();
	      var blurStyle = itemModel.getModel(['blur', 'itemStyle']).getItemStyle();
	      var selectStyle = itemModel.getModel(['select', 'itemStyle']).getItemStyle();
	      var cursorStyle = itemModel.getShallow('cursor');
	      var focus = emphasisModel.get('focus');
	      var blurScope = emphasisModel.get('blurScope');
	      var hoverScale = emphasisModel.get('scale');
	      eachPath(bar, function (path) {
	        if (path instanceof ZRImage) {
	          var pathStyle = path.style;
	          path.useStyle(extend({
	            // TODO other properties like dx, dy ?
	            image: pathStyle.image,
	            x: pathStyle.x,
	            y: pathStyle.y,
	            width: pathStyle.width,
	            height: pathStyle.height
	          }, symbolMeta.style));
	        } else {
	          path.useStyle(symbolMeta.style);
	        }
	
	        var emphasisState = path.ensureState('emphasis');
	        emphasisState.style = emphasisStyle;
	
	        if (hoverScale) {
	          // NOTE: Must after scale is set after updateAttr
	          emphasisState.scaleX = path.scaleX * 1.1;
	          emphasisState.scaleY = path.scaleY * 1.1;
	        }
	
	        path.ensureState('blur').style = blurStyle;
	        path.ensureState('select').style = selectStyle;
	        cursorStyle && (path.cursor = cursorStyle);
	        path.z2 = symbolMeta.z2;
	      });
	      var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
	      var barRect = bar.__pictorialBarRect;
	      setLabelStyle(barRect, getLabelStatesModels(itemModel), {
	        labelFetcher: opt.seriesModel,
	        labelDataIndex: dataIndex,
	        defaultText: getDefaultLabel(opt.seriesModel.getData(), dataIndex),
	        inheritColor: symbolMeta.style.fill,
	        defaultOpacity: symbolMeta.style.opacity,
	        defaultOutsidePosition: barPositionOutside
	      });
	      toggleHoverEmphasis(bar, focus, blurScope, emphasisModel.get('disabled'));
	    }
	
	    function toIntTimes(times) {
	      var roundedTimes = Math.round(times); // Escapse accurate error
	
	      return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
	    }
	
	    var PictorialBarSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(PictorialBarSeriesModel, _super);
	
	      function PictorialBarSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = PictorialBarSeriesModel.type;
	        _this.hasSymbolVisual = true;
	        _this.defaultSymbol = 'roundRect';
	        return _this;
	      }
	
	      PictorialBarSeriesModel.prototype.getInitialData = function (option) {
	        // Disable stack.
	        option.stack = null;
	        return _super.prototype.getInitialData.apply(this, arguments);
	      };
	
	      PictorialBarSeriesModel.type = 'series.pictorialBar';
	      PictorialBarSeriesModel.dependencies = ['grid'];
	      PictorialBarSeriesModel.defaultOption = inheritDefaultOption(BaseBarSeriesModel.defaultOption, {
	        symbol: 'circle',
	        symbolSize: null,
	        symbolRotate: null,
	        symbolPosition: null,
	        symbolOffset: null,
	        symbolMargin: null,
	        symbolRepeat: false,
	        symbolRepeatDirection: 'end',
	        symbolClip: false,
	        symbolBoundingData: null,
	        symbolPatternSize: 400,
	        barGap: '-100%',
	        // z can be set in data item, which is z2 actually.
	        // Disable progressive
	        progressive: 0,
	        emphasis: {
	          // By default pictorialBar do not hover scale. Hover scale is not suitable
	          // for the case that both has foreground and background.
	          scale: false
	        },
	        select: {
	          itemStyle: {
	            borderColor: '#212121'
	          }
	        }
	      });
	      return PictorialBarSeriesModel;
	    }(BaseBarSeriesModel);
	
	    function install$o(registers) {
	      registers.registerChartView(PictorialBarView);
	      registers.registerSeriesModel(PictorialBarSeriesModel);
	      registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, curry(layout, 'pictorialBar')); // Do layout after other overall layout, which can prepare some information.
	
	      registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, createProgressiveLayout('pictorialBar'));
	    }
	
	    var ThemeRiverView =
	    /** @class */
	    function (_super) {
	      __extends(ThemeRiverView, _super);
	
	      function ThemeRiverView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ThemeRiverView.type;
	        _this._layers = [];
	        return _this;
	      }
	
	      ThemeRiverView.prototype.render = function (seriesModel, ecModel, api) {
	        var data = seriesModel.getData();
	        var self = this;
	        var group = this.group;
	        var layersSeries = seriesModel.getLayerSeries();
	        var layoutInfo = data.getLayout('layoutInfo');
	        var rect = layoutInfo.rect;
	        var boundaryGap = layoutInfo.boundaryGap;
	        group.x = 0;
	        group.y = rect.y + boundaryGap[0];
	
	        function keyGetter(item) {
	          return item.name;
	        }
	
	        var dataDiffer = new DataDiffer(this._layersSeries || [], layersSeries, keyGetter, keyGetter);
	        var newLayersGroups = [];
	        dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();
	
	        function process(status, idx, oldIdx) {
	          var oldLayersGroups = self._layers;
	
	          if (status === 'remove') {
	            group.remove(oldLayersGroups[idx]);
	            return;
	          }
	
	          var points0 = [];
	          var points1 = [];
	          var style;
	          var indices = layersSeries[idx].indices;
	          var j = 0;
	
	          for (; j < indices.length; j++) {
	            var layout = data.getItemLayout(indices[j]);
	            var x = layout.x;
	            var y0 = layout.y0;
	            var y = layout.y;
	            points0.push(x, y0);
	            points1.push(x, y0 + y);
	            style = data.getItemVisual(indices[j], 'style');
	          }
	
	          var polygon;
	          var textLayout = data.getItemLayout(indices[0]);
	          var labelModel = seriesModel.getModel('label');
	          var margin = labelModel.get('margin');
	          var emphasisModel = seriesModel.getModel('emphasis');
	
	          if (status === 'add') {
	            var layerGroup = newLayersGroups[idx] = new Group();
	            polygon = new ECPolygon({
	              shape: {
	                points: points0,
	                stackedOnPoints: points1,
	                smooth: 0.4,
	                stackedOnSmooth: 0.4,
	                smoothConstraint: false
	              },
	              z2: 0
	            });
	            layerGroup.add(polygon);
	            group.add(layerGroup);
	
	            if (seriesModel.isAnimationEnabled()) {
	              polygon.setClipPath(createGridClipShape$2(polygon.getBoundingRect(), seriesModel, function () {
	                polygon.removeClipPath();
	              }));
	            }
	          } else {
	            var layerGroup = oldLayersGroups[oldIdx];
	            polygon = layerGroup.childAt(0);
	            group.add(layerGroup);
	            newLayersGroups[idx] = layerGroup;
	            updateProps(polygon, {
	              shape: {
	                points: points0,
	                stackedOnPoints: points1
	              }
	            }, seriesModel);
	            saveOldStyle(polygon);
	          }
	
	          setLabelStyle(polygon, getLabelStatesModels(seriesModel), {
	            labelDataIndex: indices[j - 1],
	            defaultText: data.getName(indices[j - 1]),
	            inheritColor: style.fill
	          }, {
	            normal: {
	              verticalAlign: 'middle' // align: 'right'
	
	            }
	          });
	          polygon.setTextConfig({
	            position: null,
	            local: true
	          });
	          var labelEl = polygon.getTextContent(); // TODO More label position options.
	
	          if (labelEl) {
	            labelEl.x = textLayout.x - margin;
	            labelEl.y = textLayout.y0 + textLayout.y / 2;
	          }
	
	          polygon.useStyle(style);
	          data.setItemGraphicEl(idx, polygon);
	          setStatesStylesFromModel(polygon, seriesModel);
	          toggleHoverEmphasis(polygon, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	        }
	
	        this._layersSeries = layersSeries;
	        this._layers = newLayersGroups;
	      };
	
	      ThemeRiverView.type = 'themeRiver';
	      return ThemeRiverView;
	    }(ChartView);
	
	    function createGridClipShape$2(rect, seriesModel, cb) {
	      var rectEl = new Rect({
	        shape: {
	          x: rect.x - 10,
	          y: rect.y - 10,
	          width: 0,
	          height: rect.height + 20
	        }
	      });
	      initProps(rectEl, {
	        shape: {
	          x: rect.x - 50,
	          width: rect.width + 100,
	          height: rect.height + 20
	        }
	      }, seriesModel, cb);
	      return rectEl;
	    }
	
	    var DATA_NAME_INDEX = 2;
	
	    var ThemeRiverSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(ThemeRiverSeriesModel, _super);
	
	      function ThemeRiverSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ThemeRiverSeriesModel.type;
	        return _this;
	      }
	      /**
	       * @override
	       */
	
	
	      ThemeRiverSeriesModel.prototype.init = function (option) {
	        // eslint-disable-next-line
	        _super.prototype.init.apply(this, arguments); // Put this function here is for the sake of consistency of code style.
	        // Enable legend selection for each data item
	        // Use a function instead of direct access because data reference may changed
	
	
	        this.legendVisualProvider = new LegendVisualProvider(bind(this.getData, this), bind(this.getRawData, this));
	      };
	      /**
	       * If there is no value of a certain point in the time for some event,set it value to 0.
	       *
	       * @param {Array} data  initial data in the option
	       * @return {Array}
	       */
	
	
	      ThemeRiverSeriesModel.prototype.fixData = function (data) {
	        var rawDataLength = data.length;
	        /**
	         * Make sure every layer data get the same keys.
	         * The value index tells which layer has visited.
	         * {
	         *  2014/01/01: -1
	         * }
	         */
	
	        var timeValueKeys = {}; // grouped data by name
	
	        var groupResult = groupData(data, function (item) {
	          if (!timeValueKeys.hasOwnProperty(item[0] + '')) {
	            timeValueKeys[item[0] + ''] = -1;
	          }
	
	          return item[2];
	        });
	        var layerData = [];
	        groupResult.buckets.each(function (items, key) {
	          layerData.push({
	            name: key,
	            dataList: items
	          });
	        });
	        var layerNum = layerData.length;
	
	        for (var k = 0; k < layerNum; ++k) {
	          var name_1 = layerData[k].name;
	
	          for (var j = 0; j < layerData[k].dataList.length; ++j) {
	            var timeValue = layerData[k].dataList[j][0] + '';
	            timeValueKeys[timeValue] = k;
	          }
	
	          for (var timeValue in timeValueKeys) {
	            if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
	              timeValueKeys[timeValue] = k;
	              data[rawDataLength] = [timeValue, 0, name_1];
	              rawDataLength++;
	            }
	          }
	        }
	
	        return data;
	      };
	      /**
	       * @override
	       * @param  option  the initial option that user gave
	       * @param  ecModel  the model object for themeRiver option
	       */
	
	
	      ThemeRiverSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        var singleAxisModel = this.getReferringComponents('singleAxis', SINGLE_REFERRING).models[0];
	        var axisType = singleAxisModel.get('type'); // filter the data item with the value of label is undefined
	
	        var filterData = filter(option.data, function (dataItem) {
	          return dataItem[2] !== undefined;
	        }); // ??? TODO design a stage to transfer data for themeRiver and lines?
	
	        var data = this.fixData(filterData || []);
	        var nameList = [];
	        var nameMap = this.nameMap = createHashMap();
	        var count = 0;
	
	        for (var i = 0; i < data.length; ++i) {
	          nameList.push(data[i][DATA_NAME_INDEX]);
	
	          if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
	            nameMap.set(data[i][DATA_NAME_INDEX], count);
	            count++;
	          }
	        }
	
	        var dimensions = prepareSeriesDataSchema(data, {
	          coordDimensions: ['single'],
	          dimensionsDefine: [{
	            name: 'time',
	            type: getDimensionTypeByAxis(axisType)
	          }, {
	            name: 'value',
	            type: 'float'
	          }, {
	            name: 'name',
	            type: 'ordinal'
	          }],
	          encodeDefine: {
	            single: 0,
	            value: 1,
	            itemName: 2
	          }
	        }).dimensions;
	        var list = new SeriesData(dimensions, this);
	        list.initData(data);
	        return list;
	      };
	      /**
	       * The raw data is divided into multiple layers and each layer
	       *     has same name.
	       */
	
	
	      ThemeRiverSeriesModel.prototype.getLayerSeries = function () {
	        var data = this.getData();
	        var lenCount = data.count();
	        var indexArr = [];
	
	        for (var i = 0; i < lenCount; ++i) {
	          indexArr[i] = i;
	        }
	
	        var timeDim = data.mapDimension('single'); // data group by name
	
	        var groupResult = groupData(indexArr, function (index) {
	          return data.get('name', index);
	        });
	        var layerSeries = [];
	        groupResult.buckets.each(function (items, key) {
	          items.sort(function (index1, index2) {
	            return data.get(timeDim, index1) - data.get(timeDim, index2);
	          });
	          layerSeries.push({
	            name: key,
	            indices: items
	          });
	        });
	        return layerSeries;
	      };
	      /**
	       * Get data indices for show tooltip content
	       */
	
	
	      ThemeRiverSeriesModel.prototype.getAxisTooltipData = function (dim, value, baseAxis) {
	        if (!isArray(dim)) {
	          dim = dim ? [dim] : [];
	        }
	
	        var data = this.getData();
	        var layerSeries = this.getLayerSeries();
	        var indices = [];
	        var layerNum = layerSeries.length;
	        var nestestValue;
	
	        for (var i = 0; i < layerNum; ++i) {
	          var minDist = Number.MAX_VALUE;
	          var nearestIdx = -1;
	          var pointNum = layerSeries[i].indices.length;
	
	          for (var j = 0; j < pointNum; ++j) {
	            var theValue = data.get(dim[0], layerSeries[i].indices[j]);
	            var dist = Math.abs(theValue - value);
	
	            if (dist <= minDist) {
	              nestestValue = theValue;
	              minDist = dist;
	              nearestIdx = layerSeries[i].indices[j];
	            }
	          }
	
	          indices.push(nearestIdx);
	        }
	
	        return {
	          dataIndices: indices,
	          nestestValue: nestestValue
	        };
	      };
	
	      ThemeRiverSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        var data = this.getData();
	        var name = data.getName(dataIndex);
	        var value = data.get(data.mapDimension('value'), dataIndex);
	        return createTooltipMarkup('nameValue', {
	          name: name,
	          value: value
	        });
	      };
	
	      ThemeRiverSeriesModel.type = 'series.themeRiver';
	      ThemeRiverSeriesModel.dependencies = ['singleAxis'];
	      ThemeRiverSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        colorBy: 'data',
	        coordinateSystem: 'singleAxis',
	        // gap in axis's orthogonal orientation
	        boundaryGap: ['10%', '10%'],
	        // legendHoverLink: true,
	        singleAxisIndex: 0,
	        animationEasing: 'linear',
	        label: {
	          margin: 4,
	          show: true,
	          position: 'left',
	          fontSize: 11
	        },
	        emphasis: {
	          label: {
	            show: true
	          }
	        }
	      };
	      return ThemeRiverSeriesModel;
	    }(SeriesModel);
	
	    function themeRiverLayout(ecModel, api) {
	      ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	        var data = seriesModel.getData();
	        var single = seriesModel.coordinateSystem;
	        var layoutInfo = {}; // use the axis boundingRect for view
	
	        var rect = single.getRect();
	        layoutInfo.rect = rect;
	        var boundaryGap = seriesModel.get('boundaryGap');
	        var axis = single.getAxis();
	        layoutInfo.boundaryGap = boundaryGap;
	
	        if (axis.orient === 'horizontal') {
	          boundaryGap[0] = parsePercent$1(boundaryGap[0], rect.height);
	          boundaryGap[1] = parsePercent$1(boundaryGap[1], rect.height);
	          var height = rect.height - boundaryGap[0] - boundaryGap[1];
	          doThemeRiverLayout(data, seriesModel, height);
	        } else {
	          boundaryGap[0] = parsePercent$1(boundaryGap[0], rect.width);
	          boundaryGap[1] = parsePercent$1(boundaryGap[1], rect.width);
	          var width = rect.width - boundaryGap[0] - boundaryGap[1];
	          doThemeRiverLayout(data, seriesModel, width);
	        }
	
	        data.setLayout('layoutInfo', layoutInfo);
	      });
	    }
	    /**
	     * The layout information about themeriver
	     *
	     * @param data  data in the series
	     * @param seriesModel  the model object of themeRiver series
	     * @param height  value used to compute every series height
	     */
	
	    function doThemeRiverLayout(data, seriesModel, height) {
	      if (!data.count()) {
	        return;
	      }
	
	      var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.
	
	      var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.
	
	      var timeDim = data.mapDimension('single');
	      var valueDim = data.mapDimension('value');
	      var layerPoints = map(layerSeries, function (singleLayer) {
	        return map(singleLayer.indices, function (idx) {
	          var pt = coordSys.dataToPoint(data.get(timeDim, idx));
	          pt[1] = data.get(valueDim, idx);
	          return pt;
	        });
	      });
	      var base = computeBaseline(layerPoints);
	      var baseLine = base.y0;
	      var ky = height / base.max; // set layout information for each item.
	
	      var n = layerSeries.length;
	      var m = layerSeries[0].indices.length;
	      var baseY0;
	
	      for (var j = 0; j < m; ++j) {
	        baseY0 = baseLine[j] * ky;
	        data.setItemLayout(layerSeries[0].indices[j], {
	          layerIndex: 0,
	          x: layerPoints[0][j][0],
	          y0: baseY0,
	          y: layerPoints[0][j][1] * ky
	        });
	
	        for (var i = 1; i < n; ++i) {
	          baseY0 += layerPoints[i - 1][j][1] * ky;
	          data.setItemLayout(layerSeries[i].indices[j], {
	            layerIndex: i,
	            x: layerPoints[i][j][0],
	            y0: baseY0,
	            y: layerPoints[i][j][1] * ky
	          });
	        }
	      }
	    }
	    /**
	     * Compute the baseLine of the rawdata
	     * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
	     *
	     * @param  data  the points in each layer
	     */
	
	
	    function computeBaseline(data) {
	      var layerNum = data.length;
	      var pointNum = data[0].length;
	      var sums = [];
	      var y0 = [];
	      var max = 0;
	
	      for (var i = 0; i < pointNum; ++i) {
	        var temp = 0;
	
	        for (var j = 0; j < layerNum; ++j) {
	          temp += data[j][i][1];
	        }
	
	        if (temp > max) {
	          max = temp;
	        }
	
	        sums.push(temp);
	      }
	
	      for (var k = 0; k < pointNum; ++k) {
	        y0[k] = (max - sums[k]) / 2;
	      }
	
	      max = 0;
	
	      for (var l = 0; l < pointNum; ++l) {
	        var sum = sums[l] + y0[l];
	
	        if (sum > max) {
	          max = sum;
	        }
	      }
	
	      return {
	        y0: y0,
	        max: max
	      };
	    }
	
	    function install$p(registers) {
	      registers.registerChartView(ThemeRiverView);
	      registers.registerSeriesModel(ThemeRiverSeriesModel);
	      registers.registerLayout(themeRiverLayout);
	      registers.registerProcessor(dataFilter('themeRiver'));
	    }
	
	    var DEFAULT_SECTOR_Z = 2;
	    var DEFAULT_TEXT_Z = 4;
	    /**
	     * Sunburstce of Sunburst including Sector, Label, LabelLine
	     */
	
	    var SunburstPiece =
	    /** @class */
	    function (_super) {
	      __extends(SunburstPiece, _super);
	
	      function SunburstPiece(node, seriesModel, ecModel, api) {
	        var _this = _super.call(this) || this;
	
	        _this.z2 = DEFAULT_SECTOR_Z;
	        _this.textConfig = {
	          inside: true
	        };
	        getECData(_this).seriesIndex = seriesModel.seriesIndex;
	        var text = new ZRText({
	          z2: DEFAULT_TEXT_Z,
	          silent: node.getModel().get(['label', 'silent'])
	        });
	
	        _this.setTextContent(text);
	
	        _this.updateData(true, node, seriesModel, ecModel, api);
	
	        return _this;
	      }
	
	      SunburstPiece.prototype.updateData = function (firstCreate, node, // state: 'emphasis' | 'normal' | 'highlight' | 'downplay',
	      seriesModel, ecModel, api) {
	        this.node = node;
	        node.piece = this;
	        seriesModel = seriesModel || this._seriesModel;
	        ecModel = ecModel || this._ecModel;
	        var sector = this;
	        getECData(sector).dataIndex = node.dataIndex;
	        var itemModel = node.getModel();
	        var emphasisModel = itemModel.getModel('emphasis');
	        var layout = node.getLayout();
	        var sectorShape = extend({}, layout);
	        sectorShape.label = null;
	        var normalStyle = node.getVisual('style');
	        normalStyle.lineJoin = 'bevel';
	        var decal = node.getVisual('decal');
	
	        if (decal) {
	          normalStyle.decal = createOrUpdatePatternFromDecal(decal, api);
	        }
	
	        var cornerRadius = getSectorCornerRadius(itemModel.getModel('itemStyle'), sectorShape, true);
	        extend(sectorShape, cornerRadius);
	        each(SPECIAL_STATES, function (stateName) {
	          var state = sector.ensureState(stateName);
	          var itemStyleModel = itemModel.getModel([stateName, 'itemStyle']);
	          state.style = itemStyleModel.getItemStyle(); // border radius
	
	          var cornerRadius = getSectorCornerRadius(itemStyleModel, sectorShape);
	
	          if (cornerRadius) {
	            state.shape = cornerRadius;
	          }
	        });
	
	        if (firstCreate) {
	          sector.setShape(sectorShape);
	          sector.shape.r = layout.r0;
	          initProps(sector, {
	            shape: {
	              r: layout.r
	            }
	          }, seriesModel, node.dataIndex);
	        } else {
	          // Disable animation for gradient since no interpolation method
	          // is supported for gradient
	          updateProps(sector, {
	            shape: sectorShape
	          }, seriesModel);
	          saveOldStyle(sector);
	        }
	
	        sector.useStyle(normalStyle);
	
	        this._updateLabel(seriesModel);
	
	        var cursorStyle = itemModel.getShallow('cursor');
	        cursorStyle && sector.attr('cursor', cursorStyle);
	        this._seriesModel = seriesModel || this._seriesModel;
	        this._ecModel = ecModel || this._ecModel;
	        var focus = emphasisModel.get('focus');
	        var focusOrIndices = focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : focus;
	        toggleHoverEmphasis(this, focusOrIndices, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
	      };
	
	      SunburstPiece.prototype._updateLabel = function (seriesModel) {
	        var _this = this;
	
	        var itemModel = this.node.getModel();
	        var normalLabelModel = itemModel.getModel('label');
	        var layout = this.node.getLayout();
	        var angle = layout.endAngle - layout.startAngle;
	        var midAngle = (layout.startAngle + layout.endAngle) / 2;
	        var dx = Math.cos(midAngle);
	        var dy = Math.sin(midAngle);
	        var sector = this;
	        var label = sector.getTextContent();
	        var dataIndex = this.node.dataIndex;
	        var labelMinAngle = normalLabelModel.get('minAngle') / 180 * Math.PI;
	        var isNormalShown = normalLabelModel.get('show') && !(labelMinAngle != null && Math.abs(angle) < labelMinAngle);
	        label.ignore = !isNormalShown; // TODO use setLabelStyle
	
	        each(DISPLAY_STATES, function (stateName) {
	          var labelStateModel = stateName === 'normal' ? itemModel.getModel('label') : itemModel.getModel([stateName, 'label']);
	          var isNormal = stateName === 'normal';
	          var state = isNormal ? label : label.ensureState(stateName);
	          var text = seriesModel.getFormattedLabel(dataIndex, stateName);
	
	          if (isNormal) {
	            text = text || _this.node.name;
	          }
	
	          state.style = createTextStyle(labelStateModel, {}, null, stateName !== 'normal', true);
	
	          if (text) {
	            state.style.text = text;
	          } // Not displaying text when angle is too small
	
	
	          var isShown = labelStateModel.get('show');
	
	          if (isShown != null && !isNormal) {
	            state.ignore = !isShown;
	          }
	
	          var labelPosition = getLabelAttr(labelStateModel, 'position');
	          var sectorState = isNormal ? sector : sector.states[stateName];
	          var labelColor = sectorState.style.fill;
	          sectorState.textConfig = {
	            outsideFill: labelStateModel.get('color') === 'inherit' ? labelColor : null,
	            inside: labelPosition !== 'outside'
	          };
	          var r;
	          var labelPadding = getLabelAttr(labelStateModel, 'distance') || 0;
	          var textAlign = getLabelAttr(labelStateModel, 'align');
	
	          if (labelPosition === 'outside') {
	            r = layout.r + labelPadding;
	            textAlign = midAngle > Math.PI / 2 ? 'right' : 'left';
	          } else {
	            if (!textAlign || textAlign === 'center') {
	              // Put label in the center if it's a circle
	              if (angle === 2 * Math.PI && layout.r0 === 0) {
	                r = 0;
	              } else {
	                r = (layout.r + layout.r0) / 2;
	              }
	
	              textAlign = 'center';
	            } else if (textAlign === 'left') {
	              r = layout.r0 + labelPadding;
	
	              if (midAngle > Math.PI / 2) {
	                textAlign = 'right';
	              }
	            } else if (textAlign === 'right') {
	              r = layout.r - labelPadding;
	
	              if (midAngle > Math.PI / 2) {
	                textAlign = 'left';
	              }
	            }
	          }
	
	          state.style.align = textAlign;
	          state.style.verticalAlign = getLabelAttr(labelStateModel, 'verticalAlign') || 'middle';
	          state.x = r * dx + layout.cx;
	          state.y = r * dy + layout.cy;
	          var rotateType = getLabelAttr(labelStateModel, 'rotate');
	          var rotate = 0;
	
	          if (rotateType === 'radial') {
	            rotate = normalizeRadian(-midAngle);
	
	            if (rotate > Math.PI / 2 && rotate < Math.PI * 1.5) {
	              rotate += Math.PI;
	            }
	          } else if (rotateType === 'tangential') {
	            rotate = Math.PI / 2 - midAngle;
	
	            if (rotate > Math.PI / 2) {
	              rotate -= Math.PI;
	            } else if (rotate < -Math.PI / 2) {
	              rotate += Math.PI;
	            }
	          } else if (isNumber(rotateType)) {
	            rotate = rotateType * Math.PI / 180;
	          }
	
	          state.rotation = normalizeRadian(rotate);
	        });
	
	        function getLabelAttr(model, name) {
	          var stateAttr = model.get(name);
	
	          if (stateAttr == null) {
	            return normalLabelModel.get(name);
	          }
	
	          return stateAttr;
	        }
	
	        label.dirtyStyle();
	      };
	
	      return SunburstPiece;
	    }(Sector);
	
	    var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	    var HIGHLIGHT_ACTION = 'sunburstHighlight';
	    var UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
	    function installSunburstAction(registers) {
	      registers.registerAction({
	        type: ROOT_TO_NODE_ACTION,
	        update: 'updateView'
	      }, function (payload, ecModel) {
	        ecModel.eachComponent({
	          mainType: 'series',
	          subType: 'sunburst',
	          query: payload
	        }, handleRootToNode);
	
	        function handleRootToNode(model, index) {
	          var targetInfo = retrieveTargetInfo(payload, [ROOT_TO_NODE_ACTION], model);
	
	          if (targetInfo) {
	            var originViewRoot = model.getViewRoot();
	
	            if (originViewRoot) {
	              payload.direction = aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	            }
	
	            model.resetViewRoot(targetInfo.node);
	          }
	        }
	      });
	      registers.registerAction({
	        type: HIGHLIGHT_ACTION,
	        update: 'none'
	      }, function (payload, ecModel, api) {
	        // Clone
	        payload = extend({}, payload);
	        ecModel.eachComponent({
	          mainType: 'series',
	          subType: 'sunburst',
	          query: payload
	        }, handleHighlight);
	
	        function handleHighlight(model) {
	          var targetInfo = retrieveTargetInfo(payload, [HIGHLIGHT_ACTION], model);
	
	          if (targetInfo) {
	            payload.dataIndex = targetInfo.node.dataIndex;
	          }
	        }
	
	        if (true) {
	          deprecateReplaceLog('sunburstHighlight', 'highlight');
	        } // Fast forward action
	
	
	        api.dispatchAction(extend(payload, {
	          type: 'highlight'
	        }));
	      });
	      registers.registerAction({
	        type: UNHIGHLIGHT_ACTION,
	        update: 'updateView'
	      }, function (payload, ecModel, api) {
	        payload = extend({}, payload);
	
	        if (true) {
	          deprecateReplaceLog('sunburstUnhighlight', 'downplay');
	        }
	
	        api.dispatchAction(extend(payload, {
	          type: 'downplay'
	        }));
	      });
	    }
	
	    var SunburstView =
	    /** @class */
	    function (_super) {
	      __extends(SunburstView, _super);
	
	      function SunburstView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SunburstView.type;
	        return _this;
	      }
	
	      SunburstView.prototype.render = function (seriesModel, ecModel, api, // @ts-ignore
	      payload) {
	        var self = this;
	        this.seriesModel = seriesModel;
	        this.api = api;
	        this.ecModel = ecModel;
	        var data = seriesModel.getData();
	        var virtualRoot = data.tree.root;
	        var newRoot = seriesModel.getViewRoot();
	        var group = this.group;
	        var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
	        var newChildren = [];
	        newRoot.eachNode(function (node) {
	          newChildren.push(node);
	        });
	        var oldChildren = this._oldChildren || [];
	        dualTravel(newChildren, oldChildren);
	        renderRollUp(virtualRoot, newRoot);
	
	        this._initEvents();
	
	        this._oldChildren = newChildren;
	
	        function dualTravel(newChildren, oldChildren) {
	          if (newChildren.length === 0 && oldChildren.length === 0) {
	            return;
	          }
	
	          new DataDiffer(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove(curry(processNode, null)).execute();
	
	          function getKey(node) {
	            return node.getId();
	          }
	
	          function processNode(newIdx, oldIdx) {
	            var newNode = newIdx == null ? null : newChildren[newIdx];
	            var oldNode = oldIdx == null ? null : oldChildren[oldIdx];
	            doRenderNode(newNode, oldNode);
	          }
	        }
	
	        function doRenderNode(newNode, oldNode) {
	          if (!renderLabelForZeroData && newNode && !newNode.getValue()) {
	            // Not render data with value 0
	            newNode = null;
	          }
	
	          if (newNode !== virtualRoot && oldNode !== virtualRoot) {
	            if (oldNode && oldNode.piece) {
	              if (newNode) {
	                // Update
	                oldNode.piece.updateData(false, newNode, seriesModel, ecModel, api); // For tooltip
	
	                data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
	              } else {
	                // Remove
	                removeNode(oldNode);
	              }
	            } else if (newNode) {
	              // Add
	              var piece = new SunburstPiece(newNode, seriesModel, ecModel, api);
	              group.add(piece); // For tooltip
	
	              data.setItemGraphicEl(newNode.dataIndex, piece);
	            }
	          }
	        }
	
	        function removeNode(node) {
	          if (!node) {
	            return;
	          }
	
	          if (node.piece) {
	            group.remove(node.piece);
	            node.piece = null;
	          }
	        }
	
	        function renderRollUp(virtualRoot, viewRoot) {
	          if (viewRoot.depth > 0) {
	            // Render
	            if (self.virtualPiece) {
	              // Update
	              self.virtualPiece.updateData(false, virtualRoot, seriesModel, ecModel, api);
	            } else {
	              // Add
	              self.virtualPiece = new SunburstPiece(virtualRoot, seriesModel, ecModel, api);
	              group.add(self.virtualPiece);
	            } // TODO event scope
	
	
	            viewRoot.piece.off('click');
	            self.virtualPiece.on('click', function (e) {
	              self._rootToNode(viewRoot.parentNode);
	            });
	          } else if (self.virtualPiece) {
	            // Remove
	            group.remove(self.virtualPiece);
	            self.virtualPiece = null;
	          }
	        }
	      };
	      /**
	       * @private
	       */
	
	
	      SunburstView.prototype._initEvents = function () {
	        var _this = this;
	
	        this.group.off('click');
	        this.group.on('click', function (e) {
	          var targetFound = false;
	
	          var viewRoot = _this.seriesModel.getViewRoot();
	
	          viewRoot.eachNode(function (node) {
	            if (!targetFound && node.piece && node.piece === e.target) {
	              var nodeClick = node.getModel().get('nodeClick');
	
	              if (nodeClick === 'rootToNode') {
	                _this._rootToNode(node);
	              } else if (nodeClick === 'link') {
	                var itemModel = node.getModel();
	                var link = itemModel.get('link');
	
	                if (link) {
	                  var linkTarget = itemModel.get('target', true) || '_blank';
	                  windowOpen(link, linkTarget);
	                }
	              }
	
	              targetFound = true;
	            }
	          });
	        });
	      };
	      /**
	       * @private
	       */
	
	
	      SunburstView.prototype._rootToNode = function (node) {
	        if (node !== this.seriesModel.getViewRoot()) {
	          this.api.dispatchAction({
	            type: ROOT_TO_NODE_ACTION,
	            from: this.uid,
	            seriesId: this.seriesModel.id,
	            targetNode: node
	          });
	        }
	      };
	      /**
	       * @implement
	       */
	
	
	      SunburstView.prototype.containPoint = function (point, seriesModel) {
	        var treeRoot = seriesModel.getData();
	        var itemLayout = treeRoot.getItemLayout(0);
	
	        if (itemLayout) {
	          var dx = point[0] - itemLayout.cx;
	          var dy = point[1] - itemLayout.cy;
	          var radius = Math.sqrt(dx * dx + dy * dy);
	          return radius <= itemLayout.r && radius >= itemLayout.r0;
	        }
	      };
	
	      SunburstView.type = 'sunburst';
	      return SunburstView;
	    }(ChartView);
	
	    var SunburstSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(SunburstSeriesModel, _super);
	
	      function SunburstSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SunburstSeriesModel.type;
	        _this.ignoreStyleOnData = true;
	        return _this;
	      }
	
	      SunburstSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        // Create a virtual root.
	        var root = {
	          name: option.name,
	          children: option.data
	        };
	        completeTreeValue$1(root);
	        var levelModels = this._levelModels = map(option.levels || [], function (levelDefine) {
	          return new Model(levelDefine, this, ecModel);
	        }, this); // Make sure always a new tree is created when setOption,
	        // in TreemapView, we check whether oldTree === newTree
	        // to choose mappings approach among old shapes and new shapes.
	
	        var tree = Tree.createTree(root, this, beforeLink);
	
	        function beforeLink(nodeData) {
	          nodeData.wrapMethod('getItemModel', function (model, idx) {
	            var node = tree.getNodeByDataIndex(idx);
	            var levelModel = levelModels[node.depth];
	            levelModel && (model.parentModel = levelModel);
	            return model;
	          });
	        }
	
	        return tree.data;
	      };
	
	      SunburstSeriesModel.prototype.optionUpdated = function () {
	        this.resetViewRoot();
	      };
	      /*
	       * @override
	       */
	
	
	      SunburstSeriesModel.prototype.getDataParams = function (dataIndex) {
	        var params = _super.prototype.getDataParams.apply(this, arguments);
	
	        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	        params.treePathInfo = wrapTreePathInfo(node, this);
	        return params;
	      };
	
	      SunburstSeriesModel.prototype.getLevelModel = function (node) {
	        return this._levelModels && this._levelModels[node.depth];
	      };
	
	      SunburstSeriesModel.prototype.getViewRoot = function () {
	        return this._viewRoot;
	      };
	
	      SunburstSeriesModel.prototype.resetViewRoot = function (viewRoot) {
	        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	        var root = this.getRawData().tree.root;
	
	        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	          this._viewRoot = root;
	        }
	      };
	
	      SunburstSeriesModel.prototype.enableAriaDecal = function () {
	        enableAriaDecalForTree(this);
	      };
	
	      SunburstSeriesModel.type = 'series.sunburst';
	      SunburstSeriesModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        // 默认全局居中
	        center: ['50%', '50%'],
	        radius: [0, '75%'],
	        // 默认顺时针
	        clockwise: true,
	        startAngle: 90,
	        // 最小角度改为0
	        minAngle: 0,
	        // If still show when all data zero.
	        stillShowZeroSum: true,
	        // 'rootToNode', 'link', or false
	        nodeClick: 'rootToNode',
	        renderLabelForZeroData: false,
	        label: {
	          // could be: 'radial', 'tangential', or 'none'
	          rotate: 'radial',
	          show: true,
	          opacity: 1,
	          // 'left' is for inner side of inside, and 'right' is for outer
	          // side for inside
	          align: 'center',
	          position: 'inside',
	          distance: 5,
	          silent: true
	        },
	        itemStyle: {
	          borderWidth: 1,
	          borderColor: 'white',
	          borderType: 'solid',
	          shadowBlur: 0,
	          shadowColor: 'rgba(0, 0, 0, 0.2)',
	          shadowOffsetX: 0,
	          shadowOffsetY: 0,
	          opacity: 1
	        },
	        emphasis: {
	          focus: 'descendant'
	        },
	        blur: {
	          itemStyle: {
	            opacity: 0.2
	          },
	          label: {
	            opacity: 0.1
	          }
	        },
	        // Animation type can be expansion, scale.
	        animationType: 'expansion',
	        animationDuration: 1000,
	        animationDurationUpdate: 500,
	        data: [],
	
	        /**
	         * Sort order.
	         *
	         * Valid values: 'desc', 'asc', null, or callback function.
	         * 'desc' and 'asc' for descend and ascendant order;
	         * null for not sorting;
	         * example of callback function:
	         * function(nodeA, nodeB) {
	         *     return nodeA.getValue() - nodeB.getValue();
	         * }
	         */
	        sort: 'desc'
	      };
	      return SunburstSeriesModel;
	    }(SeriesModel);
	
	    function completeTreeValue$1(dataNode) {
	      // Postorder travel tree.
	      // If value of none-leaf node is not set,
	      // calculate it by suming up the value of all children.
	      var sum = 0;
	      each(dataNode.children, function (child) {
	        completeTreeValue$1(child);
	        var childValue = child.value; // TODO First value of array must be a number
	
	        isArray(childValue) && (childValue = childValue[0]);
	        sum += childValue;
	      });
	      var thisValue = dataNode.value;
	
	      if (isArray(thisValue)) {
	        thisValue = thisValue[0];
	      }
	
	      if (thisValue == null || isNaN(thisValue)) {
	        thisValue = sum;
	      } // Value should not less than 0.
	
	
	      if (thisValue < 0) {
	        thisValue = 0;
	      }
	
	      isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	    }
	
	    var RADIAN$2 = Math.PI / 180;
	    function sunburstLayout(seriesType, ecModel, api) {
	      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	        var center = seriesModel.get('center');
	        var radius = seriesModel.get('radius');
	
	        if (!isArray(radius)) {
	          radius = [0, radius];
	        }
	
	        if (!isArray(center)) {
	          center = [center, center];
	        }
	
	        var width = api.getWidth();
	        var height = api.getHeight();
	        var size = Math.min(width, height);
	        var cx = parsePercent$1(center[0], width);
	        var cy = parsePercent$1(center[1], height);
	        var r0 = parsePercent$1(radius[0], size / 2);
	        var r = parsePercent$1(radius[1], size / 2);
	        var startAngle = -seriesModel.get('startAngle') * RADIAN$2;
	        var minAngle = seriesModel.get('minAngle') * RADIAN$2;
	        var virtualRoot = seriesModel.getData().tree.root;
	        var treeRoot = seriesModel.getViewRoot();
	        var rootDepth = treeRoot.depth;
	        var sort = seriesModel.get('sort');
	
	        if (sort != null) {
	          initChildren$1(treeRoot, sort);
	        }
	
	        var validDataCount = 0;
	        each(treeRoot.children, function (child) {
	          !isNaN(child.getValue()) && validDataCount++;
	        });
	        var sum = treeRoot.getValue(); // Sum may be 0
	
	        var unitRadian = Math.PI / (sum || validDataCount) * 2;
	        var renderRollupNode = treeRoot.depth > 0;
	        var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
	        var rPerLevel = (r - r0) / (levels || 1);
	        var clockwise = seriesModel.get('clockwise');
	        var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // In the case some sector angle is smaller than minAngle
	        // let restAngle = PI2;
	        // let valueSumLargerThanMinAngle = 0;
	
	        var dir = clockwise ? 1 : -1;
	        /**
	         * Render a tree
	         * @return increased angle
	         */
	
	        var renderNode = function (node, startAngle) {
	          if (!node) {
	            return;
	          }
	
	          var endAngle = startAngle; // Render self
	
	          if (node !== virtualRoot) {
	            // Tree node is virtual, so it doesn't need to be drawn
	            var value = node.getValue();
	            var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	
	            if (angle < minAngle) {
	              angle = minAngle; // restAngle -= minAngle;
	            } // else {
	            //     valueSumLargerThanMinAngle += value;
	            // }
	
	
	            endAngle = startAngle + dir * angle;
	            var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
	            var rStart = r0 + rPerLevel * depth;
	            var rEnd = r0 + rPerLevel * (depth + 1);
	            var levelModel = seriesModel.getLevelModel(node);
	
	            if (levelModel) {
	              var r0_1 = levelModel.get('r0', true);
	              var r_1 = levelModel.get('r', true);
	              var radius_1 = levelModel.get('radius', true);
	
	              if (radius_1 != null) {
	                r0_1 = radius_1[0];
	                r_1 = radius_1[1];
	              }
	
	              r0_1 != null && (rStart = parsePercent$1(r0_1, size / 2));
	              r_1 != null && (rEnd = parsePercent$1(r_1, size / 2));
	            }
	
	            node.setLayout({
	              angle: angle,
	              startAngle: startAngle,
	              endAngle: endAngle,
	              clockwise: clockwise,
	              cx: cx,
	              cy: cy,
	              r0: rStart,
	              r: rEnd
	            });
	          } // Render children
	
	
	          if (node.children && node.children.length) {
	            // currentAngle = startAngle;
	            var siblingAngle_1 = 0;
	            each(node.children, function (node) {
	              siblingAngle_1 += renderNode(node, startAngle + siblingAngle_1);
	            });
	          }
	
	          return endAngle - startAngle;
	        }; // Virtual root node for roll up
	
	
	        if (renderRollupNode) {
	          var rStart = r0;
	          var rEnd = r0 + rPerLevel;
	          var angle = Math.PI * 2;
	          virtualRoot.setLayout({
	            angle: angle,
	            startAngle: startAngle,
	            endAngle: startAngle + angle,
	            clockwise: clockwise,
	            cx: cx,
	            cy: cy,
	            r0: rStart,
	            r: rEnd
	          });
	        }
	
	        renderNode(treeRoot, startAngle);
	      });
	    }
	    /**
	     * Init node children by order and update visual
	     */
	
	    function initChildren$1(node, sortOrder) {
	      var children = node.children || [];
	      node.children = sort$2(children, sortOrder); // Init children recursively
	
	      if (children.length) {
	        each(node.children, function (child) {
	          initChildren$1(child, sortOrder);
	        });
	      }
	    }
	    /**
	     * Sort children nodes
	     *
	     * @param {TreeNode[]}               children children of node to be sorted
	     * @param {string | function | null} sort sort method
	     *                                   See SunburstSeries.js for details.
	     */
	
	
	    function sort$2(children, sortOrder) {
	      if (isFunction(sortOrder)) {
	        var sortTargets = map(children, function (child, idx) {
	          var value = child.getValue();
	          return {
	            params: {
	              depth: child.depth,
	              height: child.height,
	              dataIndex: child.dataIndex,
	              getValue: function () {
	                return value;
	              }
	            },
	            index: idx
	          };
	        });
	        sortTargets.sort(function (a, b) {
	          return sortOrder(a.params, b.params);
	        });
	        return map(sortTargets, function (target) {
	          return children[target.index];
	        });
	      } else {
	        var isAsc_1 = sortOrder === 'asc';
	        return children.sort(function (a, b) {
	          var diff = (a.getValue() - b.getValue()) * (isAsc_1 ? 1 : -1);
	          return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc_1 ? -1 : 1) : diff;
	        });
	      }
	    }
	
	    function sunburstVisual(ecModel) {
	      var paletteScope = {}; // Default color strategy
	
	      function pickColor(node, seriesModel, treeHeight) {
	        // Choose color from palette based on the first level.
	        var current = node;
	
	        while (current && current.depth > 1) {
	          current = current.parentNode;
	        }
	
	        var color = seriesModel.getColorFromPalette(current.name || current.dataIndex + '', paletteScope);
	
	        if (node.depth > 1 && isString(color)) {
	          // Lighter on the deeper level.
	          color = lift(color, (node.depth - 1) / (treeHeight - 1) * 0.5);
	        }
	
	        return color;
	      }
	
	      ecModel.eachSeriesByType('sunburst', function (seriesModel) {
	        var data = seriesModel.getData();
	        var tree = data.tree;
	        tree.eachNode(function (node) {
	          var model = node.getModel();
	          var style = model.getModel('itemStyle').getItemStyle();
	
	          if (!style.fill) {
	            style.fill = pickColor(node, seriesModel, tree.root.height);
	          }
	
	          var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
	          extend(existsStyle, style);
	        });
	      });
	    }
	
	    function install$q(registers) {
	      registers.registerChartView(SunburstView);
	      registers.registerSeriesModel(SunburstSeriesModel);
	      registers.registerLayout(curry(sunburstLayout, 'sunburst'));
	      registers.registerProcessor(curry(dataFilter, 'sunburst'));
	      registers.registerVisual(sunburstVisual);
	      installSunburstAction(registers);
	    }
	
	    // `visual('color') visual('borderColor')` is supported.
	
	    var STYLE_VISUAL_TYPE = {
	      color: 'fill',
	      borderColor: 'stroke'
	    };
	    var NON_STYLE_VISUAL_PROPS = {
	      symbol: 1,
	      symbolSize: 1,
	      symbolKeepAspect: 1,
	      legendIcon: 1,
	      visualMeta: 1,
	      liftZ: 1,
	      decal: 1
	    };
	    var customInnerStore = makeInner();
	
	    var CustomSeriesModel =
	    /** @class */
	    function (_super) {
	      __extends(CustomSeriesModel, _super);
	
	      function CustomSeriesModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = CustomSeriesModel.type;
	        return _this;
	      }
	
	      CustomSeriesModel.prototype.optionUpdated = function () {
	        this.currentZLevel = this.get('zlevel', true);
	        this.currentZ = this.get('z', true);
	      };
	
	      CustomSeriesModel.prototype.getInitialData = function (option, ecModel) {
	        return createSeriesData(null, this);
	      };
	
	      CustomSeriesModel.prototype.getDataParams = function (dataIndex, dataType, el) {
	        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
	
	        el && (params.info = customInnerStore(el).info);
	        return params;
	      };
	
	      CustomSeriesModel.type = 'series.custom';
	      CustomSeriesModel.dependencies = ['grid', 'polar', 'geo', 'singleAxis', 'calendar'];
	      CustomSeriesModel.defaultOption = {
	        coordinateSystem: 'cartesian2d',
	        // zlevel: 0,
	        z: 2,
	        legendHoverLink: true,
	        // Custom series will not clip by default.
	        // Some case will use custom series to draw label
	        // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
	        clip: false // Cartesian coordinate system
	        // xAxisIndex: 0,
	        // yAxisIndex: 0,
	        // Polar coordinate system
	        // polarIndex: 0,
	        // Geo coordinate system
	        // geoIndex: 0,
	
	      };
	      return CustomSeriesModel;
	    }(SeriesModel);
	
	    function dataToCoordSize(dataSize, dataItem) {
	      // dataItem is necessary in log axis.
	      dataItem = dataItem || [0, 0];
	      return map(['x', 'y'], function (dim, dimIdx) {
	        var axis = this.getAxis(dim);
	        var val = dataItem[dimIdx];
	        var halfSize = dataSize[dimIdx] / 2;
	        return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	      }, this);
	    }
	
	    function cartesianPrepareCustom(coordSys) {
	      var rect = coordSys.master.getRect();
	      return {
	        coordSys: {
	          // The name exposed to user is always 'cartesian2d' but not 'grid'.
	          type: 'cartesian2d',
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        },
	        api: {
	          coord: function (data) {
	            // do not provide "out" param
	            return coordSys.dataToPoint(data);
	          },
	          size: bind(dataToCoordSize, coordSys)
	        }
	      };
	    }
	
	    function dataToCoordSize$1(dataSize, dataItem) {
	      dataItem = dataItem || [0, 0];
	      return map([0, 1], function (dimIdx) {
	        var val = dataItem[dimIdx];
	        var halfSize = dataSize[dimIdx] / 2;
	        var p1 = [];
	        var p2 = [];
	        p1[dimIdx] = val - halfSize;
	        p2[dimIdx] = val + halfSize;
	        p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
	        return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
	      }, this);
	    }
	
	    function geoPrepareCustom(coordSys) {
	      var rect = coordSys.getBoundingRect();
	      return {
	        coordSys: {
	          type: 'geo',
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height,
	          zoom: coordSys.getZoom()
	        },
	        api: {
	          coord: function (data) {
	            // do not provide "out" and noRoam param,
	            // Compatible with this usage:
	            // echarts.util.map(item.points, api.coord)
	            return coordSys.dataToPoint(data);
	          },
	          size: bind(dataToCoordSize$1, coordSys)
	        }
	      };
	    }
	
	    function dataToCoordSize$2(dataSize, dataItem) {
	      // dataItem is necessary in log axis.
	      var axis = this.getAxis();
	      var val = dataItem instanceof Array ? dataItem[0] : dataItem;
	      var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
	      return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	    }
	
	    function singlePrepareCustom(coordSys) {
	      var rect = coordSys.getRect();
	      return {
	        coordSys: {
	          type: 'singleAxis',
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        },
	        api: {
	          coord: function (val) {
	            // do not provide "out" param
	            return coordSys.dataToPoint(val);
	          },
	          size: bind(dataToCoordSize$2, coordSys)
	        }
	      };
	    }
	
	    function dataToCoordSize$3(dataSize, dataItem) {
	      // dataItem is necessary in log axis.
	      dataItem = dataItem || [0, 0];
	      return map(['Radius', 'Angle'], function (dim, dimIdx) {
	        var getterName = 'get' + dim + 'Axis'; // TODO: TYPE Check Angle Axis
	
	        var axis = this[getterName]();
	        var val = dataItem[dimIdx];
	        var halfSize = dataSize[dimIdx] / 2;
	        var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	
	        if (dim === 'Angle') {
	          result = result * Math.PI / 180;
	        }
	
	        return result;
	      }, this);
	    }
	
	    function polarPrepareCustom(coordSys) {
	      var radiusAxis = coordSys.getRadiusAxis();
	      var angleAxis = coordSys.getAngleAxis();
	      var radius = radiusAxis.getExtent();
	      radius[0] > radius[1] && radius.reverse();
	      return {
	        coordSys: {
	          type: 'polar',
	          cx: coordSys.cx,
	          cy: coordSys.cy,
	          r: radius[1],
	          r0: radius[0]
	        },
	        api: {
	          coord: function (data) {
	            var radius = radiusAxis.dataToRadius(data[0]);
	            var angle = angleAxis.dataToAngle(data[1]);
	            var coord = coordSys.coordToPoint([radius, angle]);
	            coord.push(radius, angle * Math.PI / 180);
	            return coord;
	          },
	          size: bind(dataToCoordSize$3, coordSys)
	        }
	      };
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function calendarPrepareCustom(coordSys) {
	      var rect = coordSys.getRect();
	      var rangeInfo = coordSys.getRangeInfo();
	      return {
	        coordSys: {
	          type: 'calendar',
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height,
	          cellWidth: coordSys.getCellWidth(),
	          cellHeight: coordSys.getCellHeight(),
	          rangeInfo: {
	            start: rangeInfo.start,
	            end: rangeInfo.end,
	            weeks: rangeInfo.weeks,
	            dayCount: rangeInfo.allDay
	          }
	        },
	        api: {
	          coord: function (data, clamp) {
	            return coordSys.dataToPoint(data, clamp);
	          }
	        }
	      };
	    }
	
	    var deprecatedLogs = {};
	    /**
	     * Whether need to call `convertEC4CompatibleStyle`.
	     */
	
	    function isEC4CompatibleStyle(style, elType, hasOwnTextContentOption, hasOwnTextConfig) {
	      // Since echarts5, `RectText` is separated from its host element and style.text
	      // does not exist any more. The compat work brings some extra burden on performance.
	      // So we provide:
	      // `legacy: true` force make compat.
	      // `legacy: false`, force do not compat.
	      // `legacy` not set: auto detect whether legacy.
	      //     But in this case we do not compat (difficult to detect and rare case):
	      //     Becuse custom series and graphic component support "merge", users may firstly
	      //     only set `textStrokeWidth` style or secondly only set `text`.
	      return style && (style.legacy || style.legacy !== false && !hasOwnTextContentOption && !hasOwnTextConfig && elType !== 'tspan' // Difficult to detect whether legacy for a "text" el.
	      && (elType === 'text' || hasOwn(style, 'text')));
	    }
	    /**
	     * `EC4CompatibleStyle` is style that might be in echarts4 format or echarts5 format.
	     * @param hostStyle The properties might be modified.
	     * @return If be text el, `textContentStyle` and `textConfig` will not be returned.
	     *         Otherwise a `textContentStyle` and `textConfig` will be created, whose props area
	     *         retried from the `hostStyle`.
	     */
	
	    function convertFromEC4CompatibleStyle(hostStyle, elType, isNormal) {
	      var srcStyle = hostStyle;
	      var textConfig;
	      var textContent;
	      var textContentStyle;
	
	      if (elType === 'text') {
	        textContentStyle = srcStyle;
	      } else {
	        textContentStyle = {};
	        hasOwn(srcStyle, 'text') && (textContentStyle.text = srcStyle.text);
	        hasOwn(srcStyle, 'rich') && (textContentStyle.rich = srcStyle.rich);
	        hasOwn(srcStyle, 'textFill') && (textContentStyle.fill = srcStyle.textFill);
	        hasOwn(srcStyle, 'textStroke') && (textContentStyle.stroke = srcStyle.textStroke);
	        hasOwn(srcStyle, 'fontFamily') && (textContentStyle.fontFamily = srcStyle.fontFamily);
	        hasOwn(srcStyle, 'fontSize') && (textContentStyle.fontSize = srcStyle.fontSize);
	        hasOwn(srcStyle, 'fontStyle') && (textContentStyle.fontStyle = srcStyle.fontStyle);
	        hasOwn(srcStyle, 'fontWeight') && (textContentStyle.fontWeight = srcStyle.fontWeight);
	        textContent = {
	          type: 'text',
	          style: textContentStyle,
	          // ec4 does not support rectText trigger.
	          // And when text position is different in normal and emphasis
	          // => hover text trigger emphasis;
	          // => text position changed, leave mouse pointer immediately;
	          // That might cause incorrect state.
	          silent: true
	        };
	        textConfig = {};
	        var hasOwnPos = hasOwn(srcStyle, 'textPosition');
	
	        if (isNormal) {
	          textConfig.position = hasOwnPos ? srcStyle.textPosition : 'inside';
	        } else {
	          hasOwnPos && (textConfig.position = srcStyle.textPosition);
	        }
	
	        hasOwn(srcStyle, 'textPosition') && (textConfig.position = srcStyle.textPosition);
	        hasOwn(srcStyle, 'textOffset') && (textConfig.offset = srcStyle.textOffset);
	        hasOwn(srcStyle, 'textRotation') && (textConfig.rotation = srcStyle.textRotation);
	        hasOwn(srcStyle, 'textDistance') && (textConfig.distance = srcStyle.textDistance);
	      }
	
	      convertEC4CompatibleRichItem(textContentStyle, hostStyle);
	      each(textContentStyle.rich, function (richItem) {
	        convertEC4CompatibleRichItem(richItem, richItem);
	      });
	      return {
	        textConfig: textConfig,
	        textContent: textContent
	      };
	    }
	    /**
	     * The result will be set to `out`.
	     */
	
	    function convertEC4CompatibleRichItem(out, richItem) {
	      if (!richItem) {
	        return;
	      } // (1) For simplicity, make textXXX properties (deprecated since ec5) has
	      // higher priority. For example, consider in ec4 `borderColor: 5, textBorderColor: 10`
	      // on a rect means `borderColor: 4` on the rect and `borderColor: 10` on an attached
	      // richText in ec5.
	      // (2) `out === richItem` if and only if `out` is text el or rich item.
	      // So we can overwrite existing props in `out` since textXXX has higher priority.
	
	
	      richItem.font = richItem.textFont || richItem.font;
	      hasOwn(richItem, 'textStrokeWidth') && (out.lineWidth = richItem.textStrokeWidth);
	      hasOwn(richItem, 'textAlign') && (out.align = richItem.textAlign);
	      hasOwn(richItem, 'textVerticalAlign') && (out.verticalAlign = richItem.textVerticalAlign);
	      hasOwn(richItem, 'textLineHeight') && (out.lineHeight = richItem.textLineHeight);
	      hasOwn(richItem, 'textWidth') && (out.width = richItem.textWidth);
	      hasOwn(richItem, 'textHeight') && (out.height = richItem.textHeight);
	      hasOwn(richItem, 'textBackgroundColor') && (out.backgroundColor = richItem.textBackgroundColor);
	      hasOwn(richItem, 'textPadding') && (out.padding = richItem.textPadding);
	      hasOwn(richItem, 'textBorderColor') && (out.borderColor = richItem.textBorderColor);
	      hasOwn(richItem, 'textBorderWidth') && (out.borderWidth = richItem.textBorderWidth);
	      hasOwn(richItem, 'textBorderRadius') && (out.borderRadius = richItem.textBorderRadius);
	      hasOwn(richItem, 'textBoxShadowColor') && (out.shadowColor = richItem.textBoxShadowColor);
	      hasOwn(richItem, 'textBoxShadowBlur') && (out.shadowBlur = richItem.textBoxShadowBlur);
	      hasOwn(richItem, 'textBoxShadowOffsetX') && (out.shadowOffsetX = richItem.textBoxShadowOffsetX);
	      hasOwn(richItem, 'textBoxShadowOffsetY') && (out.shadowOffsetY = richItem.textBoxShadowOffsetY);
	    }
	    /**
	     * Convert to pure echarts4 format style.
	     * `itemStyle` will be modified, added with ec4 style properties from
	     * `textStyle` and `textConfig`.
	     *
	     * [Caveat]: For simplicity, `insideRollback` in ec4 does not compat, where
	     * `styleEmphasis: {textFill: 'red'}` will remove the normal auto added stroke.
	     */
	
	
	    function convertToEC4StyleForCustomSerise(itemStl, txStl, txCfg) {
	      var out = itemStl; // See `custom.ts`, a trick to set extra `textPosition` firstly.
	
	      out.textPosition = out.textPosition || txCfg.position || 'inside';
	      txCfg.offset != null && (out.textOffset = txCfg.offset);
	      txCfg.rotation != null && (out.textRotation = txCfg.rotation);
	      txCfg.distance != null && (out.textDistance = txCfg.distance);
	      var isInside = out.textPosition.indexOf('inside') >= 0;
	      var hostFill = itemStl.fill || '#000';
	      convertToEC4RichItem(out, txStl);
	      var textFillNotSet = out.textFill == null;
	
	      if (isInside) {
	        if (textFillNotSet) {
	          out.textFill = txCfg.insideFill || '#fff';
	          !out.textStroke && txCfg.insideStroke && (out.textStroke = txCfg.insideStroke);
	          !out.textStroke && (out.textStroke = hostFill);
	          out.textStrokeWidth == null && (out.textStrokeWidth = 2);
	        }
	      } else {
	        if (textFillNotSet) {
	          out.textFill = itemStl.fill || txCfg.outsideFill || '#000';
	        }
	
	        !out.textStroke && txCfg.outsideStroke && (out.textStroke = txCfg.outsideStroke);
	      }
	
	      out.text = txStl.text;
	      out.rich = txStl.rich;
	      each(txStl.rich, function (richItem) {
	        convertToEC4RichItem(richItem, richItem);
	      });
	      return out;
	    }
	
	    function convertToEC4RichItem(out, richItem) {
	      if (!richItem) {
	        return;
	      }
	
	      hasOwn(richItem, 'fill') && (out.textFill = richItem.fill);
	      hasOwn(richItem, 'stroke') && (out.textStroke = richItem.fill);
	      hasOwn(richItem, 'lineWidth') && (out.textStrokeWidth = richItem.lineWidth);
	      hasOwn(richItem, 'font') && (out.font = richItem.font);
	      hasOwn(richItem, 'fontStyle') && (out.fontStyle = richItem.fontStyle);
	      hasOwn(richItem, 'fontWeight') && (out.fontWeight = richItem.fontWeight);
	      hasOwn(richItem, 'fontSize') && (out.fontSize = richItem.fontSize);
	      hasOwn(richItem, 'fontFamily') && (out.fontFamily = richItem.fontFamily);
	      hasOwn(richItem, 'align') && (out.textAlign = richItem.align);
	      hasOwn(richItem, 'verticalAlign') && (out.textVerticalAlign = richItem.verticalAlign);
	      hasOwn(richItem, 'lineHeight') && (out.textLineHeight = richItem.lineHeight);
	      hasOwn(richItem, 'width') && (out.textWidth = richItem.width);
	      hasOwn(richItem, 'height') && (out.textHeight = richItem.height);
	      hasOwn(richItem, 'backgroundColor') && (out.textBackgroundColor = richItem.backgroundColor);
	      hasOwn(richItem, 'padding') && (out.textPadding = richItem.padding);
	      hasOwn(richItem, 'borderColor') && (out.textBorderColor = richItem.borderColor);
	      hasOwn(richItem, 'borderWidth') && (out.textBorderWidth = richItem.borderWidth);
	      hasOwn(richItem, 'borderRadius') && (out.textBorderRadius = richItem.borderRadius);
	      hasOwn(richItem, 'shadowColor') && (out.textBoxShadowColor = richItem.shadowColor);
	      hasOwn(richItem, 'shadowBlur') && (out.textBoxShadowBlur = richItem.shadowBlur);
	      hasOwn(richItem, 'shadowOffsetX') && (out.textBoxShadowOffsetX = richItem.shadowOffsetX);
	      hasOwn(richItem, 'shadowOffsetY') && (out.textBoxShadowOffsetY = richItem.shadowOffsetY);
	      hasOwn(richItem, 'textShadowColor') && (out.textShadowColor = richItem.textShadowColor);
	      hasOwn(richItem, 'textShadowBlur') && (out.textShadowBlur = richItem.textShadowBlur);
	      hasOwn(richItem, 'textShadowOffsetX') && (out.textShadowOffsetX = richItem.textShadowOffsetX);
	      hasOwn(richItem, 'textShadowOffsetY') && (out.textShadowOffsetY = richItem.textShadowOffsetY);
	    }
	
	    function warnDeprecated(deprecated, insteadApproach) {
	      if (true) {
	        var key = deprecated + '^_^' + insteadApproach;
	
	        if (!deprecatedLogs[key]) {
	          console.warn("[ECharts] DEPRECATED: \"" + deprecated + "\" has been deprecated. " + insteadApproach);
	          deprecatedLogs[key] = true;
	        }
	      }
	    }
	
	    var LEGACY_TRANSFORM_PROPS_MAP = {
	      position: ['x', 'y'],
	      scale: ['scaleX', 'scaleY'],
	      origin: ['originX', 'originY']
	    };
	    var LEGACY_TRANSFORM_PROPS = keys(LEGACY_TRANSFORM_PROPS_MAP);
	    var TRANSFORM_PROPS_MAP = reduce(TRANSFORMABLE_PROPS, function (obj, key) {
	      obj[key] = 1;
	      return obj;
	    }, {});
	    var transformPropNamesStr = TRANSFORMABLE_PROPS.join(', '); // '' means root
	
	    var ELEMENT_ANIMATABLE_PROPS = ['', 'style', 'shape', 'extra'];
	    var transitionInnerStore = makeInner();
	
	    function getElementAnimationConfig(animationType, el, elOption, parentModel, dataIndex) {
	      var animationProp = animationType + "Animation";
	      var config = getAnimationConfig(animationType, parentModel, dataIndex) || {};
	      var userDuring = transitionInnerStore(el).userDuring; // Only set when duration is > 0 and it's need to be animated.
	
	      if (config.duration > 0) {
	        // For simplicity, if during not specified, the previous during will not work any more.
	        config.during = userDuring ? bind(duringCall, {
	          el: el,
	          userDuring: userDuring
	        }) : null;
	        config.setToFinal = true;
	        config.scope = animationType;
	      }
	
	      extend(config, elOption[animationProp]);
	      return config;
	    }
	
	    function applyUpdateTransition(el, elOption, animatableModel, opts) {
	      opts = opts || {};
	      var dataIndex = opts.dataIndex,
	          isInit = opts.isInit,
	          clearStyle = opts.clearStyle;
	      var hasAnimation = animatableModel.isAnimationEnabled(); // Save the meta info for further morphing. Like apply on the sub morphing elements.
	
	      var store = transitionInnerStore(el);
	      var styleOpt = elOption.style;
	      store.userDuring = elOption.during;
	      var transFromProps = {};
	      var propsToSet = {};
	      prepareTransformAllPropsFinal(el, elOption, propsToSet);
	      prepareShapeOrExtraAllPropsFinal('shape', elOption, propsToSet);
	      prepareShapeOrExtraAllPropsFinal('extra', elOption, propsToSet);
	
	      if (!isInit && hasAnimation) {
	        prepareTransformTransitionFrom(el, elOption, transFromProps);
	        prepareShapeOrExtraTransitionFrom('shape', el, elOption, transFromProps);
	        prepareShapeOrExtraTransitionFrom('extra', el, elOption, transFromProps);
	        prepareStyleTransitionFrom(el, elOption, styleOpt, transFromProps);
	      }
	
	      propsToSet.style = styleOpt;
	      applyPropsDirectly(el, propsToSet, clearStyle);
	      applyMiscProps(el, elOption);
	
	      if (hasAnimation) {
	        if (isInit) {
	          var enterFromProps_1 = {};
	          each(ELEMENT_ANIMATABLE_PROPS, function (propName) {
	            var prop = propName ? elOption[propName] : elOption;
	
	            if (prop && prop.enterFrom) {
	              if (propName) {
	                enterFromProps_1[propName] = enterFromProps_1[propName] || {};
	              }
	
	              extend(propName ? enterFromProps_1[propName] : enterFromProps_1, prop.enterFrom);
	            }
	          });
	          var config = getElementAnimationConfig('enter', el, elOption, animatableModel, dataIndex);
	
	          if (config.duration > 0) {
	            el.animateFrom(enterFromProps_1, config);
	          }
	        } else {
	          applyPropsTransition(el, elOption, dataIndex || 0, animatableModel, transFromProps);
	        }
	      } // Store leave to be used in leave transition.
	
	
	      updateLeaveTo(el, elOption);
	      styleOpt ? el.dirty() : el.markRedraw();
	    }
	    function updateLeaveTo(el, elOption) {
	      // Try merge to previous set leaveTo
	      var leaveToProps = transitionInnerStore(el).leaveToProps;
	
	      for (var i = 0; i < ELEMENT_ANIMATABLE_PROPS.length; i++) {
	        var propName = ELEMENT_ANIMATABLE_PROPS[i];
	        var prop = propName ? elOption[propName] : elOption;
	
	        if (prop && prop.leaveTo) {
	          if (!leaveToProps) {
	            leaveToProps = transitionInnerStore(el).leaveToProps = {};
	          }
	
	          if (propName) {
	            leaveToProps[propName] = leaveToProps[propName] || {};
	          }
	
	          extend(propName ? leaveToProps[propName] : leaveToProps, prop.leaveTo);
	        }
	      }
	    }
	    function applyLeaveTransition(el, elOption, animatableModel, onRemove) {
	      if (el) {
	        var parent_1 = el.parent;
	        var leaveToProps = transitionInnerStore(el).leaveToProps;
	
	        if (leaveToProps) {
	          // TODO TODO use leave after leaveAnimation in series is introduced
	          // TODO Data index?
	          var config = getElementAnimationConfig('update', el, elOption, animatableModel, 0);
	
	          config.done = function () {
	            parent_1.remove(el);
	            onRemove && onRemove();
	          };
	
	          el.animateTo(leaveToProps, config);
	        } else {
	          parent_1.remove(el);
	          onRemove && onRemove();
	        }
	      }
	    }
	    function isTransitionAll(transition) {
	      return transition === 'all';
	    }
	
	    function applyPropsDirectly(el, // Can be null/undefined
	    allPropsFinal, clearStyle) {
	      var styleOpt = allPropsFinal.style;
	
	      if (!el.isGroup && styleOpt) {
	        if (clearStyle) {
	          el.useStyle({}); // When style object changed, how to trade the existing animation?
	          // It is probably complicated and not needed to cover all the cases.
	          // But still need consider the case:
	          // (1) When using init animation on `style.opacity`, and before the animation
	          //     ended users triggers an update by mousewhel. At that time the init
	          //     animation should better be continued rather than terminated.
	          //     So after `useStyle` called, we should change the animation target manually
	          //     to continue the effect of the init animation.
	          // (2) PENDING: If the previous animation targeted at a `val1`, and currently we need
	          //     to update the value to `val2` and no animation declared, should be terminate
	          //     the previous animation or just modify the target of the animation?
	          //     Therotically That will happen not only on `style` but also on `shape` and
	          //     `transfrom` props. But we haven't handle this case at present yet.
	          // (3) PENDING: Is it proper to visit `animators` and `targetName`?
	
	          var animators = el.animators;
	
	          for (var i = 0; i < animators.length; i++) {
	            var animator = animators[i]; // targetName is the "topKey".
	
	            if (animator.targetName === 'style') {
	              animator.changeTarget(el.style);
	            }
	          }
	        }
	
	        el.setStyle(styleOpt);
	      }
	
	      if (allPropsFinal) {
	        // Not set style here.
	        allPropsFinal.style = null; // Set el to the final state firstly.
	
	        allPropsFinal && el.attr(allPropsFinal);
	        allPropsFinal.style = styleOpt;
	      }
	    }
	
	    function applyPropsTransition(el, elOption, dataIndex, model, // Can be null/undefined
	    transFromProps) {
	      if (transFromProps) {
	        var config = getElementAnimationConfig('update', el, elOption, model, dataIndex);
	
	        if (config.duration > 0) {
	          el.animateFrom(transFromProps, config);
	        }
	      }
	    }
	
	    function applyMiscProps(el, elOption) {
	      // Merge by default.
	      hasOwn(elOption, 'silent') && (el.silent = elOption.silent);
	      hasOwn(elOption, 'ignore') && (el.ignore = elOption.ignore);
	
	      if (el instanceof Displayable) {
	        hasOwn(elOption, 'invisible') && (el.invisible = elOption.invisible);
	      }
	
	      if (el instanceof Path) {
	        hasOwn(elOption, 'autoBatch') && (el.autoBatch = elOption.autoBatch);
	      }
	    } // Use it to avoid it be exposed to user.
	
	
	    var tmpDuringScope = {};
	    var transitionDuringAPI = {
	      // Usually other props do not need to be changed in animation during.
	      setTransform: function (key, val) {
	        if (true) {
	          assert(hasOwn(TRANSFORM_PROPS_MAP, key), 'Only ' + transformPropNamesStr + ' available in `setTransform`.');
	        }
	
	        tmpDuringScope.el[key] = val;
	        return this;
	      },
	      getTransform: function (key) {
	        if (true) {
	          assert(hasOwn(TRANSFORM_PROPS_MAP, key), 'Only ' + transformPropNamesStr + ' available in `getTransform`.');
	        }
	
	        return tmpDuringScope.el[key];
	      },
	      setShape: function (key, val) {
	        if (true) {
	          assertNotReserved(key);
	        }
	
	        var el = tmpDuringScope.el;
	        var shape = el.shape || (el.shape = {});
	        shape[key] = val;
	        el.dirtyShape && el.dirtyShape();
	        return this;
	      },
	      getShape: function (key) {
	        if (true) {
	          assertNotReserved(key);
	        }
	
	        var shape = tmpDuringScope.el.shape;
	
	        if (shape) {
	          return shape[key];
	        }
	      },
	      setStyle: function (key, val) {
	        if (true) {
	          assertNotReserved(key);
	        }
	
	        var el = tmpDuringScope.el;
	        var style = el.style;
	
	        if (style) {
	          if (true) {
	            if (eqNaN(val)) {
	              warn('style.' + key + ' must not be assigned with NaN.');
	            }
	          }
	
	          style[key] = val;
	          el.dirtyStyle && el.dirtyStyle();
	        }
	
	        return this;
	      },
	      getStyle: function (key) {
	        if (true) {
	          assertNotReserved(key);
	        }
	
	        var style = tmpDuringScope.el.style;
	
	        if (style) {
	          return style[key];
	        }
	      },
	      setExtra: function (key, val) {
	        if (true) {
	          assertNotReserved(key);
	        }
	
	        var extra = tmpDuringScope.el.extra || (tmpDuringScope.el.extra = {});
	        extra[key] = val;
	        return this;
	      },
	      getExtra: function (key) {
	        if (true) {
	          assertNotReserved(key);
	        }
	
	        var extra = tmpDuringScope.el.extra;
	
	        if (extra) {
	          return extra[key];
	        }
	      }
	    };
	
	    function assertNotReserved(key) {
	      if (true) {
	        if (key === 'transition' || key === 'enterFrom' || key === 'leaveTo') {
	          throw new Error('key must not be "' + key + '"');
	        }
	      }
	    }
	
	    function duringCall() {
	      // Do not provide "percent" until some requirements come.
	      // Because consider thies case:
	      // enterFrom: {x: 100, y: 30}, transition: 'x'.
	      // And enter duration is different from update duration.
	      // Thus it might be confused about the meaning of "percent" in during callback.
	      var scope = this;
	      var el = scope.el;
	
	      if (!el) {
	        return;
	      } // If el is remove from zr by reason like legend, during still need to called,
	      // because el will be added back to zr and the prop value should not be incorrect.
	
	
	      var latestUserDuring = transitionInnerStore(el).userDuring;
	      var scopeUserDuring = scope.userDuring; // Ensured a during is only called once in each animation frame.
	      // If a during is called multiple times in one frame, maybe some users' calculation logic
	      // might be wrong (not sure whether this usage exists).
	      // The case of a during might be called twice can be: by default there is a animator for
	      // 'x', 'y' when init. Before the init animation finished, call `setOption` to start
	      // another animators for 'style'/'shape'/'extra'.
	
	      if (latestUserDuring !== scopeUserDuring) {
	        // release
	        scope.el = scope.userDuring = null;
	        return;
	      }
	
	      tmpDuringScope.el = el; // Give no `this` to user in "during" calling.
	
	      scopeUserDuring(transitionDuringAPI); // FIXME: if in future meet the case that some prop will be both modified in `during` and `state`,
	      // consider the issue that the prop might be incorrect when return to "normal" state.
	    }
	
	    function prepareShapeOrExtraTransitionFrom(mainAttr, fromEl, elOption, transFromProps) {
	      var attrOpt = elOption[mainAttr];
	
	      if (!attrOpt) {
	        return;
	      }
	
	      var elPropsInAttr = fromEl[mainAttr];
	      var transFromPropsInAttr;
	
	      if (elPropsInAttr) {
	        var transition = elOption.transition;
	        var attrTransition = attrOpt.transition;
	
	        if (attrTransition) {
	          !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
	
	          if (isTransitionAll(attrTransition)) {
	            extend(transFromPropsInAttr, elPropsInAttr);
	          } else {
	            var transitionKeys = normalizeToArray(attrTransition);
	
	            for (var i = 0; i < transitionKeys.length; i++) {
	              var key = transitionKeys[i];
	              var elVal = elPropsInAttr[key];
	              transFromPropsInAttr[key] = elVal;
	            }
	          }
	        } else if (isTransitionAll(transition) || indexOf(transition, mainAttr) >= 0) {
	          !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
	          var elPropsInAttrKeys = keys(elPropsInAttr);
	
	          for (var i = 0; i < elPropsInAttrKeys.length; i++) {
	            var key = elPropsInAttrKeys[i];
	            var elVal = elPropsInAttr[key];
	
	            if (isNonStyleTransitionEnabled(attrOpt[key], elVal)) {
	              transFromPropsInAttr[key] = elVal;
	            }
	          }
	        }
	      }
	    }
	
	    function prepareShapeOrExtraAllPropsFinal(mainAttr, elOption, allProps) {
	      var attrOpt = elOption[mainAttr];
	
	      if (!attrOpt) {
	        return;
	      }
	
	      var allPropsInAttr = allProps[mainAttr] = {};
	      var keysInAttr = keys(attrOpt);
	
	      for (var i = 0; i < keysInAttr.length; i++) {
	        var key = keysInAttr[i]; // To avoid share one object with different element, and
	        // to avoid user modify the object inexpectedly, have to clone.
	
	        allPropsInAttr[key] = cloneValue(attrOpt[key]);
	      }
	    }
	
	    function prepareTransformTransitionFrom(el, elOption, transFromProps) {
	      var transition = elOption.transition;
	      var transitionKeys = isTransitionAll(transition) ? TRANSFORMABLE_PROPS : normalizeToArray(transition || []);
	
	      for (var i = 0; i < transitionKeys.length; i++) {
	        var key = transitionKeys[i];
	
	        if (key === 'style' || key === 'shape' || key === 'extra') {
	          continue;
	        }
	
	        var elVal = el[key];
	
	        if (true) {
	          checkTransformPropRefer(key, 'el.transition');
	        } // Do not clone, animator will perform that clone.
	
	
	        transFromProps[key] = elVal;
	      }
	    }
	
	    function prepareTransformAllPropsFinal(el, elOption, allProps) {
	      for (var i = 0; i < LEGACY_TRANSFORM_PROPS.length; i++) {
	        var legacyName = LEGACY_TRANSFORM_PROPS[i];
	        var xyName = LEGACY_TRANSFORM_PROPS_MAP[legacyName];
	        var legacyArr = elOption[legacyName];
	
	        if (legacyArr) {
	          allProps[xyName[0]] = legacyArr[0];
	          allProps[xyName[1]] = legacyArr[1];
	        }
	      }
	
	      for (var i = 0; i < TRANSFORMABLE_PROPS.length; i++) {
	        var key = TRANSFORMABLE_PROPS[i];
	
	        if (elOption[key] != null) {
	          allProps[key] = elOption[key];
	        }
	      }
	    }
	
	    function prepareStyleTransitionFrom(fromEl, elOption, styleOpt, transFromProps) {
	      if (!styleOpt) {
	        return;
	      }
	
	      var fromElStyle = fromEl.style;
	      var transFromStyleProps;
	
	      if (fromElStyle) {
	        var styleTransition = styleOpt.transition;
	        var elTransition = elOption.transition;
	
	        if (styleTransition && !isTransitionAll(styleTransition)) {
	          var transitionKeys = normalizeToArray(styleTransition);
	          !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
	
	          for (var i = 0; i < transitionKeys.length; i++) {
	            var key = transitionKeys[i];
	            var elVal = fromElStyle[key]; // Do not clone, see `checkNonStyleTansitionRefer`.
	
	            transFromStyleProps[key] = elVal;
	          }
	        } else if (fromEl.getAnimationStyleProps && (isTransitionAll(elTransition) || isTransitionAll(styleTransition) || indexOf(elTransition, 'style') >= 0)) {
	          var animationProps = fromEl.getAnimationStyleProps();
	          var animationStyleProps = animationProps ? animationProps.style : null;
	
	          if (animationStyleProps) {
	            !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
	            var styleKeys = keys(styleOpt);
	
	            for (var i = 0; i < styleKeys.length; i++) {
	              var key = styleKeys[i];
	
	              if (animationStyleProps[key]) {
	                var elVal = fromElStyle[key];
	                transFromStyleProps[key] = elVal;
	              }
	            }
	          }
	        }
	      }
	    }
	
	    function isNonStyleTransitionEnabled(optVal, elVal) {
	      // The same as `checkNonStyleTansitionRefer`.
	      return !isArrayLike(optVal) ? optVal != null && isFinite(optVal) : optVal !== elVal;
	    }
	
	    var checkTransformPropRefer;
	
	    if (true) {
	      checkTransformPropRefer = function (key, usedIn) {
	        if (!hasOwn(TRANSFORM_PROPS_MAP, key)) {
	          warn('Prop `' + key + '` is not a permitted in `' + usedIn + '`. ' + 'Only `' + keys(TRANSFORM_PROPS_MAP).join('`, `') + '` are permitted.');
	        }
	      };
	    }
	
	    var getStateToRestore = makeInner();
	    var KEYFRAME_EXCLUDE_KEYS = ['percent', 'easing', 'shape', 'style', 'extra'];
	    /**
	     * Stop previous keyframe animation and restore the attributes.
	     * Avoid new keyframe animation starts with wrong internal state when the percent: 0 is not set.
	     */
	
	    function stopPreviousKeyframeAnimationAndRestore(el) {
	      // Stop previous keyframe animation.
	      el.stopAnimation('keyframe'); // Restore
	
	      el.attr(getStateToRestore(el));
	    }
	    function applyKeyframeAnimation(el, animationOpts, animatableModel) {
	      if (!animatableModel.isAnimationEnabled() || !animationOpts) {
	        return;
	      }
	
	      if (isArray(animationOpts)) {
	        each(animationOpts, function (singleAnimationOpts) {
	          applyKeyframeAnimation(el, singleAnimationOpts, animatableModel);
	        });
	        return;
	      }
	
	      var keyframes = animationOpts.keyframes;
	      var duration = animationOpts.duration;
	
	      if (animatableModel && duration == null) {
	        // Default to use duration of config.
	        // NOTE: animation config from payload will be ignored because they are mainly for transitions.
	        var config = getAnimationConfig('enter', animatableModel, 0);
	        duration = config && config.duration;
	      }
	
	      if (!keyframes || !duration) {
	        return;
	      }
	
	      var stateToRestore = getStateToRestore(el);
	      each(ELEMENT_ANIMATABLE_PROPS, function (targetPropName) {
	        if (targetPropName && !el[targetPropName]) {
	          return;
	        }
	
	        var animator;
	        var endFrameIsSet = false; // Sort keyframes by percent.
	
	        keyframes.sort(function (a, b) {
	          return a.percent - b.percent;
	        });
	        each(keyframes, function (kf) {
	          // Stop current animation.
	          var animators = el.animators;
	          var kfValues = targetPropName ? kf[targetPropName] : kf;
	
	          if (true) {
	            if (kf.percent >= 1) {
	              endFrameIsSet = true;
	            }
	          }
	
	          if (!kfValues) {
	            return;
	          }
	
	          var propKeys = keys(kfValues);
	
	          if (!targetPropName) {
	            // PENDING performance?
	            propKeys = filter(propKeys, function (key) {
	              return indexOf(KEYFRAME_EXCLUDE_KEYS, key) < 0;
	            });
	          }
	
	          if (!propKeys.length) {
	            return;
	          }
	
	          if (!animator) {
	            animator = el.animate(targetPropName, animationOpts.loop, true);
	            animator.scope = 'keyframe';
	          }
	
	          for (var i = 0; i < animators.length; i++) {
	            // Stop all other animation that is not keyframe.
	            if (animators[i] !== animator && animators[i].targetName === animator.targetName) {
	              animators[i].stopTracks(propKeys);
	            }
	          }
	
	          targetPropName && (stateToRestore[targetPropName] = stateToRestore[targetPropName] || {});
	          var savedTarget = targetPropName ? stateToRestore[targetPropName] : stateToRestore;
	          each(propKeys, function (key) {
	            // Save original value.
	            savedTarget[key] = ((targetPropName ? el[targetPropName] : el) || {})[key];
	          });
	          animator.whenWithKeys(duration * kf.percent, kfValues, propKeys, kf.easing);
	        });
	
	        if (!animator) {
	          return;
	        }
	
	        if (true) {
	          if (!endFrameIsSet) {
	            warn('End frame with percent: 1 is missing in the keyframeAnimation.', true);
	          }
	        }
	
	        animator.delay(animationOpts.delay || 0).duration(duration).start(animationOpts.easing);
	      });
	    }
	
	    var EMPHASIS = 'emphasis';
	    var NORMAL = 'normal';
	    var BLUR = 'blur';
	    var SELECT = 'select';
	    var STATES = [NORMAL, EMPHASIS, BLUR, SELECT];
	    var PATH_ITEM_STYLE = {
	      normal: ['itemStyle'],
	      emphasis: [EMPHASIS, 'itemStyle'],
	      blur: [BLUR, 'itemStyle'],
	      select: [SELECT, 'itemStyle']
	    };
	    var PATH_LABEL = {
	      normal: ['label'],
	      emphasis: [EMPHASIS, 'label'],
	      blur: [BLUR, 'label'],
	      select: [SELECT, 'label']
	    };
	    var DEFAULT_TRANSITION = ['x', 'y']; // Use prefix to avoid index to be the same as el.name,
	    // which will cause weird update animation.
	
	    var GROUP_DIFF_PREFIX = 'e\0\0';
	    var attachedTxInfoTmp = {
	      normal: {},
	      emphasis: {},
	      blur: {},
	      select: {}
	    };
	    /**
	     * To reduce total package size of each coordinate systems, the modules `prepareCustom`
	     * of each coordinate systems are not required by each coordinate systems directly, but
	     * required by the module `custom`.
	     *
	     * prepareInfoForCustomSeries {Function}: optional
	     *     @return {Object} {coordSys: {...}, api: {
	     *         coord: function (data, clamp) {}, // return point in global.
	     *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
	     *     }}
	     */
	
	    var prepareCustoms = {
	      cartesian2d: cartesianPrepareCustom,
	      geo: geoPrepareCustom,
	      single: singlePrepareCustom,
	      polar: polarPrepareCustom,
	      calendar: calendarPrepareCustom
	    };
	
	    function isPath$1(el) {
	      return el instanceof Path;
	    }
	
	    function isDisplayable(el) {
	      return el instanceof Displayable;
	    }
	
	    function copyElement(sourceEl, targetEl) {
	      targetEl.copyTransform(sourceEl);
	
	      if (isDisplayable(targetEl) && isDisplayable(sourceEl)) {
	        targetEl.setStyle(sourceEl.style);
	        targetEl.z = sourceEl.z;
	        targetEl.z2 = sourceEl.z2;
	        targetEl.zlevel = sourceEl.zlevel;
	        targetEl.invisible = sourceEl.invisible;
	        targetEl.ignore = sourceEl.ignore;
	
	        if (isPath$1(targetEl) && isPath$1(sourceEl)) {
	          targetEl.setShape(sourceEl.shape);
	        }
	      }
	    }
	
	    var CustomChartView =
	    /** @class */
	    function (_super) {
	      __extends(CustomChartView, _super);
	
	      function CustomChartView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = CustomChartView.type;
	        return _this;
	      }
	
	      CustomChartView.prototype.render = function (customSeries, ecModel, api, payload) {
	        // Clear previously rendered progressive elements.
	        this._progressiveEls = null;
	        var oldData = this._data;
	        var data = customSeries.getData();
	        var group = this.group;
	        var renderItem = makeRenderItem(customSeries, data, ecModel, api);
	
	        if (!oldData) {
	          // Previous render is incremental render or first render.
	          // Needs remove the incremental rendered elements.
	          group.removeAll();
	        }
	
	        data.diff(oldData).add(function (newIdx) {
	          createOrUpdateItem(api, null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	        }).remove(function (oldIdx) {
	          var el = oldData.getItemGraphicEl(oldIdx);
	          el && applyLeaveTransition(el, customInnerStore(el).option, customSeries);
	        }).update(function (newIdx, oldIdx) {
	          var oldEl = oldData.getItemGraphicEl(oldIdx);
	          createOrUpdateItem(api, oldEl, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	        }).execute(); // Do clipping
	
	        var clipPath = customSeries.get('clip', true) ? createClipPath(customSeries.coordinateSystem, false, customSeries) : null;
	
	        if (clipPath) {
	          group.setClipPath(clipPath);
	        } else {
	          group.removeClipPath();
	        }
	
	        this._data = data;
	      };
	
	      CustomChartView.prototype.incrementalPrepareRender = function (customSeries, ecModel, api) {
	        this.group.removeAll();
	        this._data = null;
	      };
	
	      CustomChartView.prototype.incrementalRender = function (params, customSeries, ecModel, api, payload) {
	        var data = customSeries.getData();
	        var renderItem = makeRenderItem(customSeries, data, ecModel, api);
	        var progressiveEls = this._progressiveEls = [];
	
	        function setIncrementalAndHoverLayer(el) {
	          if (!el.isGroup) {
	            el.incremental = true;
	            el.ensureState('emphasis').hoverLayer = true;
	          }
	        }
	
	        for (var idx = params.start; idx < params.end; idx++) {
	          var el = createOrUpdateItem(null, null, idx, renderItem(idx, payload), customSeries, this.group, data);
	
	          if (el) {
	            el.traverse(setIncrementalAndHoverLayer);
	            progressiveEls.push(el);
	          }
	        }
	      };
	
	      CustomChartView.prototype.eachRendered = function (cb) {
	        traverseElements(this._progressiveEls || this.group, cb);
	      };
	
	      CustomChartView.prototype.filterForExposedEvent = function (eventType, query, targetEl, packedEvent) {
	        var elementName = query.element;
	
	        if (elementName == null || targetEl.name === elementName) {
	          return true;
	        } // Enable to give a name on a group made by `renderItem`, and listen
	        // events that are triggered by its descendents.
	
	
	        while ((targetEl = targetEl.__hostTarget || targetEl.parent) && targetEl !== this.group) {
	          if (targetEl.name === elementName) {
	            return true;
	          }
	        }
	
	        return false;
	      };
	
	      CustomChartView.type = 'custom';
	      return CustomChartView;
	    }(ChartView);
	
	    function createEl(elOption) {
	      var graphicType = elOption.type;
	      var el; // Those graphic elements are not shapes. They should not be
	      // overwritten by users, so do them first.
	
	      if (graphicType === 'path') {
	        var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.
	
	        var pathRect = shape.width != null && shape.height != null ? {
	          x: shape.x || 0,
	          y: shape.y || 0,
	          width: shape.width,
	          height: shape.height
	        } : null;
	        var pathData = getPathData(shape); // Path is also used for icon, so layout 'center' by default.
	
	        el = makePath(pathData, null, pathRect, shape.layout || 'center');
	        customInnerStore(el).customPathData = pathData;
	      } else if (graphicType === 'image') {
	        el = new ZRImage({});
	        customInnerStore(el).customImagePath = elOption.style.image;
	      } else if (graphicType === 'text') {
	        el = new ZRText({}); // customInnerStore(el).customText = (elOption.style as TextStyleProps).text;
	      } else if (graphicType === 'group') {
	        el = new Group();
	      } else if (graphicType === 'compoundPath') {
	        throw new Error('"compoundPath" is not supported yet.');
	      } else {
	        var Clz = getShapeClass(graphicType);
	
	        if (!Clz) {
	          var errMsg = '';
	
	          if (true) {
	            errMsg = 'graphic type "' + graphicType + '" can not be found.';
	          }
	
	          throwError(errMsg);
	        }
	
	        el = new Clz();
	      }
	
	      customInnerStore(el).customGraphicType = graphicType;
	      el.name = elOption.name; // Compat ec4: the default z2 lift is 1. If changing the number,
	      // some cases probably be broken: hierarchy layout along z, like circle packing,
	      // where emphasis only intending to modify color/border rather than lift z2.
	
	      el.z2EmphasisLift = 1;
	      el.z2SelectLift = 1;
	      return el;
	    }
	
	    function updateElNormal( // Can be null/undefined
	    api, el, dataIndex, elOption, attachedTxInfo, seriesModel, isInit) {
	      // Stop and restore before update any other attributes.
	      stopPreviousKeyframeAnimationAndRestore(el);
	      var txCfgOpt = attachedTxInfo && attachedTxInfo.normal.cfg;
	
	      if (txCfgOpt) {
	        // PENDING: whether use user object directly rather than clone?
	        // TODO:5.0 textConfig transition animation?
	        el.setTextConfig(txCfgOpt);
	      } // Default transition ['x', 'y']
	
	
	      if (elOption && elOption.transition == null) {
	        elOption.transition = DEFAULT_TRANSITION;
	      } // Do some normalization on style.
	
	
	      var styleOpt = elOption && elOption.style;
	
	      if (styleOpt) {
	        if (el.type === 'text') {
	          var textOptionStyle = styleOpt; // Compatible with ec4: if `textFill` or `textStroke` exists use them.
	
	          hasOwn(textOptionStyle, 'textFill') && (textOptionStyle.fill = textOptionStyle.textFill);
	          hasOwn(textOptionStyle, 'textStroke') && (textOptionStyle.stroke = textOptionStyle.textStroke);
	        }
	
	        var decalPattern = void 0;
	        var decalObj = isPath$1(el) ? styleOpt.decal : null;
	
	        if (api && decalObj) {
	          decalObj.dirty = true;
	          decalPattern = createOrUpdatePatternFromDecal(decalObj, api);
	        } // Always overwrite in case user specify this prop.
	
	
	        styleOpt.__decalPattern = decalPattern;
	      }
	
	      if (isDisplayable(el)) {
	        if (styleOpt) {
	          var decalPattern = styleOpt.__decalPattern;
	
	          if (decalPattern) {
	            styleOpt.decal = decalPattern;
	          }
	        }
	      }
	
	      applyUpdateTransition(el, elOption, seriesModel, {
	        dataIndex: dataIndex,
	        isInit: isInit,
	        clearStyle: true
	      });
	      applyKeyframeAnimation(el, elOption.keyframeAnimation, seriesModel);
	    }
	
	    function updateElOnState(state, el, elStateOpt, styleOpt, attachedTxInfo) {
	      var elDisplayable = el.isGroup ? null : el;
	      var txCfgOpt = attachedTxInfo && attachedTxInfo[state].cfg; // PENDING:5.0 support customize scale change and transition animation?
	
	      if (elDisplayable) {
	        // By default support auto lift color when hover whether `emphasis` specified.
	        var stateObj = elDisplayable.ensureState(state);
	
	        if (styleOpt === false) {
	          var existingEmphasisState = elDisplayable.getState(state);
	
	          if (existingEmphasisState) {
	            existingEmphasisState.style = null;
	          }
	        } else {
	          // style is needed to enable default emphasis.
	          stateObj.style = styleOpt || null;
	        } // If `elOption.styleEmphasis` or `elOption.emphasis.style` is `false`,
	        // remove hover style.
	        // If `elOption.textConfig` or `elOption.emphasis.textConfig` is null/undefined, it does not
	        // make sense. So for simplicity, we do not ditinguish `hasOwnProperty` and null/undefined.
	
	
	        if (txCfgOpt) {
	          stateObj.textConfig = txCfgOpt;
	        }
	
	        setDefaultStateProxy(elDisplayable);
	      }
	    }
	
	    function updateZ$1(el, elOption, seriesModel) {
	      // Group not support textContent and not support z yet.
	      if (el.isGroup) {
	        return;
	      }
	
	      var elDisplayable = el;
	      var currentZ = seriesModel.currentZ;
	      var currentZLevel = seriesModel.currentZLevel; // Always erase.
	
	      elDisplayable.z = currentZ;
	      elDisplayable.zlevel = currentZLevel; // z2 must not be null/undefined, otherwise sort error may occur.
	
	      var optZ2 = elOption.z2;
	      optZ2 != null && (elDisplayable.z2 = optZ2 || 0);
	
	      for (var i = 0; i < STATES.length; i++) {
	        updateZForEachState(elDisplayable, elOption, STATES[i]);
	      }
	    }
	
	    function updateZForEachState(elDisplayable, elOption, state) {
	      var isNormal = state === NORMAL;
	      var elStateOpt = isNormal ? elOption : retrieveStateOption(elOption, state);
	      var optZ2 = elStateOpt ? elStateOpt.z2 : null;
	      var stateObj;
	
	      if (optZ2 != null) {
	        // Do not `ensureState` until required.
	        stateObj = isNormal ? elDisplayable : elDisplayable.ensureState(state);
	        stateObj.z2 = optZ2 || 0;
	      }
	    }
	
	    function makeRenderItem(customSeries, data, ecModel, api) {
	      var renderItem = customSeries.get('renderItem');
	      var coordSys = customSeries.coordinateSystem;
	      var prepareResult = {};
	
	      if (coordSys) {
	        if (true) {
	          assert(renderItem, 'series.render is required.');
	          assert(coordSys.prepareCustoms || prepareCustoms[coordSys.type], 'This coordSys does not support custom series.');
	        } // `coordSys.prepareCustoms` is used for external coord sys like bmap.
	
	
	        prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms(coordSys) : prepareCustoms[coordSys.type](coordSys);
	      }
	
	      var userAPI = defaults({
	        getWidth: api.getWidth,
	        getHeight: api.getHeight,
	        getZr: api.getZr,
	        getDevicePixelRatio: api.getDevicePixelRatio,
	        value: value,
	        style: style,
	        ordinalRawValue: ordinalRawValue,
	        styleEmphasis: styleEmphasis,
	        visual: visual,
	        barLayout: barLayout,
	        currentSeriesIndices: currentSeriesIndices,
	        font: font
	      }, prepareResult.api || {});
	      var userParams = {
	        // The life cycle of context: current round of rendering.
	        // The global life cycle is probably not necessary, because
	        // user can store global status by themselves.
	        context: {},
	        seriesId: customSeries.id,
	        seriesName: customSeries.name,
	        seriesIndex: customSeries.seriesIndex,
	        coordSys: prepareResult.coordSys,
	        dataInsideLength: data.count(),
	        encode: wrapEncodeDef(customSeries.getData())
	      }; // If someday intending to refactor them to a class, should consider do not
	      // break change: currently these attribute member are encapsulated in a closure
	      // so that do not need to force user to call these method with a scope.
	      // Do not support call `api` asynchronously without dataIndexInside input.
	
	      var currDataIndexInside;
	      var currItemModel;
	      var currItemStyleModels = {};
	      var currLabelModels = {};
	      var seriesItemStyleModels = {};
	      var seriesLabelModels = {};
	
	      for (var i = 0; i < STATES.length; i++) {
	        var stateName = STATES[i];
	        seriesItemStyleModels[stateName] = customSeries.getModel(PATH_ITEM_STYLE[stateName]);
	        seriesLabelModels[stateName] = customSeries.getModel(PATH_LABEL[stateName]);
	      }
	
	      function getItemModel(dataIndexInside) {
	        return dataIndexInside === currDataIndexInside ? currItemModel || (currItemModel = data.getItemModel(dataIndexInside)) : data.getItemModel(dataIndexInside);
	      }
	
	      function getItemStyleModel(dataIndexInside, state) {
	        return !data.hasItemOption ? seriesItemStyleModels[state] : dataIndexInside === currDataIndexInside ? currItemStyleModels[state] || (currItemStyleModels[state] = getItemModel(dataIndexInside).getModel(PATH_ITEM_STYLE[state])) : getItemModel(dataIndexInside).getModel(PATH_ITEM_STYLE[state]);
	      }
	
	      function getLabelModel(dataIndexInside, state) {
	        return !data.hasItemOption ? seriesLabelModels[state] : dataIndexInside === currDataIndexInside ? currLabelModels[state] || (currLabelModels[state] = getItemModel(dataIndexInside).getModel(PATH_LABEL[state])) : getItemModel(dataIndexInside).getModel(PATH_LABEL[state]);
	      }
	
	      return function (dataIndexInside, payload) {
	        currDataIndexInside = dataIndexInside;
	        currItemModel = null;
	        currItemStyleModels = {};
	        currLabelModels = {};
	        return renderItem && renderItem(defaults({
	          dataIndexInside: dataIndexInside,
	          dataIndex: data.getRawIndex(dataIndexInside),
	          // Can be used for optimization when zoom or roam.
	          actionType: payload ? payload.type : null
	        }, userParams), userAPI);
	      };
	      /**
	       * @public
	       * @param dim by default 0.
	       * @param dataIndexInside by default `currDataIndexInside`.
	       */
	
	      function value(dim, dataIndexInside) {
	        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	        return data.getStore().get(data.getDimensionIndex(dim || 0), dataIndexInside);
	      }
	      /**
	       * @public
	       * @param dim by default 0.
	       * @param dataIndexInside by default `currDataIndexInside`.
	       */
	
	
	      function ordinalRawValue(dim, dataIndexInside) {
	        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	        dim = dim || 0;
	        var dimInfo = data.getDimensionInfo(dim);
	
	        if (!dimInfo) {
	          var dimIndex = data.getDimensionIndex(dim);
	          return dimIndex >= 0 ? data.getStore().get(dimIndex, dataIndexInside) : undefined;
	        }
	
	        var val = data.get(dimInfo.name, dataIndexInside);
	        var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
	        return ordinalMeta ? ordinalMeta.categories[val] : val;
	      }
	      /**
	       * @deprecated The original intention of `api.style` is enable to set itemStyle
	       * like other series. But it is not necessary and not easy to give a strict definition
	       * of what it returns. And since echarts5 it needs to be make compat work. So
	       * deprecates it since echarts5.
	       *
	       * By default, `visual` is applied to style (to support visualMap).
	       * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
	       * it can be implemented as:
	       * `api.style({stroke: api.visual('color'), fill: null})`;
	       *
	       * [Compat]: since ec5, RectText has been separated from its hosts el.
	       * so `api.style()` will only return the style from `itemStyle` but not handle `label`
	       * any more. But `series.label` config is never published in doc.
	       * We still compat it in `api.style()`. But not encourage to use it and will still not
	       * to pulish it to doc.
	       * @public
	       * @param dataIndexInside by default `currDataIndexInside`.
	       */
	
	
	      function style(userProps, dataIndexInside) {
	        if (true) {
	          warnDeprecated('api.style', 'Please write literal style directly instead.');
	        }
	
	        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	        var style = data.getItemVisual(dataIndexInside, 'style');
	        var visualColor = style && style.fill;
	        var opacity = style && style.opacity;
	        var itemStyle = getItemStyleModel(dataIndexInside, NORMAL).getItemStyle();
	        visualColor != null && (itemStyle.fill = visualColor);
	        opacity != null && (itemStyle.opacity = opacity);
	        var opt = {
	          inheritColor: isString(visualColor) ? visualColor : '#000'
	        };
	        var labelModel = getLabelModel(dataIndexInside, NORMAL); // Now that the feature of "auto adjust text fill/stroke" has been migrated to zrender
	        // since ec5, we should set `isAttached` as `false` here and make compat in
	        // `convertToEC4StyleForCustomSerise`.
	
	        var textStyle = createTextStyle(labelModel, null, opt, false, true);
	        textStyle.text = labelModel.getShallow('show') ? retrieve2(customSeries.getFormattedLabel(dataIndexInside, NORMAL), getDefaultLabel(data, dataIndexInside)) : null;
	        var textConfig = createTextConfig(labelModel, opt, false);
	        preFetchFromExtra(userProps, itemStyle);
	        itemStyle = convertToEC4StyleForCustomSerise(itemStyle, textStyle, textConfig);
	        userProps && applyUserPropsAfter(itemStyle, userProps);
	        itemStyle.legacy = true;
	        return itemStyle;
	      }
	      /**
	       * @deprecated The reason see `api.style()`
	       * @public
	       * @param dataIndexInside by default `currDataIndexInside`.
	       */
	
	
	      function styleEmphasis(userProps, dataIndexInside) {
	        if (true) {
	          warnDeprecated('api.styleEmphasis', 'Please write literal style directly instead.');
	        }
	
	        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	        var itemStyle = getItemStyleModel(dataIndexInside, EMPHASIS).getItemStyle();
	        var labelModel = getLabelModel(dataIndexInside, EMPHASIS);
	        var textStyle = createTextStyle(labelModel, null, null, true, true);
	        textStyle.text = labelModel.getShallow('show') ? retrieve3(customSeries.getFormattedLabel(dataIndexInside, EMPHASIS), customSeries.getFormattedLabel(dataIndexInside, NORMAL), getDefaultLabel(data, dataIndexInside)) : null;
	        var textConfig = createTextConfig(labelModel, null, true);
	        preFetchFromExtra(userProps, itemStyle);
	        itemStyle = convertToEC4StyleForCustomSerise(itemStyle, textStyle, textConfig);
	        userProps && applyUserPropsAfter(itemStyle, userProps);
	        itemStyle.legacy = true;
	        return itemStyle;
	      }
	
	      function applyUserPropsAfter(itemStyle, extra) {
	        for (var key in extra) {
	          if (hasOwn(extra, key)) {
	            itemStyle[key] = extra[key];
	          }
	        }
	      }
	
	      function preFetchFromExtra(extra, itemStyle) {
	        // A trick to retrieve those props firstly, which are used to
	        // apply auto inside fill/stroke in `convertToEC4StyleForCustomSerise`.
	        // (It's not reasonable but only for a degree of compat)
	        if (extra) {
	          extra.textFill && (itemStyle.textFill = extra.textFill);
	          extra.textPosition && (itemStyle.textPosition = extra.textPosition);
	        }
	      }
	      /**
	       * @public
	       * @param dataIndexInside by default `currDataIndexInside`.
	       */
	
	
	      function visual(visualType, dataIndexInside) {
	        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	
	        if (hasOwn(STYLE_VISUAL_TYPE, visualType)) {
	          var style_1 = data.getItemVisual(dataIndexInside, 'style');
	          return style_1 ? style_1[STYLE_VISUAL_TYPE[visualType]] : null;
	        } // Only support these visuals. Other visual might be inner tricky
	        // for performance (like `style`), do not expose to users.
	
	
	        if (hasOwn(NON_STYLE_VISUAL_PROPS, visualType)) {
	          return data.getItemVisual(dataIndexInside, visualType);
	        }
	      }
	      /**
	       * @public
	       * @return If not support, return undefined.
	       */
	
	
	      function barLayout(opt) {
	        if (coordSys.type === 'cartesian2d') {
	          var baseAxis = coordSys.getBaseAxis();
	          return getLayoutOnAxis(defaults({
	            axis: baseAxis
	          }, opt));
	        }
	      }
	      /**
	       * @public
	       */
	
	
	      function currentSeriesIndices() {
	        return ecModel.getCurrentSeriesIndices();
	      }
	      /**
	       * @public
	       * @return font string
	       */
	
	
	      function font(opt) {
	        return getFont(opt, ecModel);
	      }
	    }
	
	    function wrapEncodeDef(data) {
	      var encodeDef = {};
	      each(data.dimensions, function (dimName) {
	        var dimInfo = data.getDimensionInfo(dimName);
	
	        if (!dimInfo.isExtraCoord) {
	          var coordDim = dimInfo.coordDim;
	          var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
	          dataDims[dimInfo.coordDimIndex] = data.getDimensionIndex(dimName);
	        }
	      });
	      return encodeDef;
	    }
	
	    function createOrUpdateItem(api, existsEl, dataIndex, elOption, seriesModel, group, data) {
	      // [Rule]
	      // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
	      //     (It seems that violate the "merge" principle, but most of users probably intuitively
	      //     regard "return;" as "show nothing element whatever", so make a exception to meet the
	      //     most cases.)
	      // The rule or "merge" see [STRATEGY_MERGE].
	      // If `elOption` is `null`/`undefined`/`false` (when `renderItem` returns nothing).
	      if (!elOption) {
	        group.remove(existsEl);
	        return;
	      }
	
	      var el = doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group);
	      el && data.setItemGraphicEl(dataIndex, el);
	      el && toggleHoverEmphasis(el, elOption.focus, elOption.blurScope, elOption.emphasisDisabled);
	      return el;
	    }
	
	    function doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group) {
	      if (true) {
	        assert(elOption, 'should not have an null/undefined element setting');
	      }
	
	      var toBeReplacedIdx = -1;
	      var oldEl = existsEl;
	
	      if (existsEl && doesElNeedRecreate(existsEl, elOption, seriesModel) // || (
	      //     // PENDING: even in one-to-one mapping case, if el is marked as morph,
	      //     // do not sure whether the el will be mapped to another el with different
	      //     // hierarchy in Group tree. So always recreate el rather than reuse the el.
	      //     morphHelper && morphHelper.isOneToOneFrom(el)
	      // )
	      ) {
	        // Should keep at the original index, otherwise "merge by index" will be incorrect.
	        toBeReplacedIdx = indexOf(group.childrenRef(), existsEl);
	        existsEl = null;
	      }
	
	      var isInit = !existsEl;
	      var el = existsEl;
	
	      if (!el) {
	        el = createEl(elOption);
	
	        if (oldEl) {
	          copyElement(oldEl, el);
	        }
	      } else {
	        // FIMXE:NEXT unified clearState?
	        // If in some case the performance issue arised, consider
	        // do not clearState but update cached normal state directly.
	        el.clearStates();
	      } // Need to set morph: false explictly to disable automatically morphing.
	
	
	      if (elOption.morph === false) {
	        el.disableMorphing = true;
	      } else if (el.disableMorphing) {
	        el.disableMorphing = false;
	      }
	
	      attachedTxInfoTmp.normal.cfg = attachedTxInfoTmp.normal.conOpt = attachedTxInfoTmp.emphasis.cfg = attachedTxInfoTmp.emphasis.conOpt = attachedTxInfoTmp.blur.cfg = attachedTxInfoTmp.blur.conOpt = attachedTxInfoTmp.select.cfg = attachedTxInfoTmp.select.conOpt = null;
	      attachedTxInfoTmp.isLegacy = false;
	      doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfoTmp);
	      doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit);
	      updateElNormal(api, el, dataIndex, elOption, attachedTxInfoTmp, seriesModel, isInit); // `elOption.info` enables user to mount some info on
	      // elements and use them in event handlers.
	      // Update them only when user specified, otherwise, remain.
	
	      hasOwn(elOption, 'info') && (customInnerStore(el).info = elOption.info);
	
	      for (var i = 0; i < STATES.length; i++) {
	        var stateName = STATES[i];
	
	        if (stateName !== NORMAL) {
	          var otherStateOpt = retrieveStateOption(elOption, stateName);
	          var otherStyleOpt = retrieveStyleOptionOnState(elOption, otherStateOpt, stateName);
	          updateElOnState(stateName, el, otherStateOpt, otherStyleOpt, attachedTxInfoTmp);
	        }
	      }
	
	      updateZ$1(el, elOption, seriesModel);
	
	      if (elOption.type === 'group') {
	        mergeChildren(api, el, dataIndex, elOption, seriesModel);
	      }
	
	      if (toBeReplacedIdx >= 0) {
	        group.replaceAt(el, toBeReplacedIdx);
	      } else {
	        group.add(el);
	      }
	
	      return el;
	    } // `el` must not be null/undefined.
	
	
	    function doesElNeedRecreate(el, elOption, seriesModel) {
	      var elInner = customInnerStore(el);
	      var elOptionType = elOption.type;
	      var elOptionShape = elOption.shape;
	      var elOptionStyle = elOption.style;
	      return (// Always create new if universal transition is enabled.
	        // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
	        seriesModel.isUniversalTransitionEnabled() // If `elOptionType` is `null`, follow the merge principle.
	        || elOptionType != null && elOptionType !== elInner.customGraphicType || elOptionType === 'path' && hasOwnPathData(elOptionShape) && getPathData(elOptionShape) !== elInner.customPathData || elOptionType === 'image' && hasOwn(elOptionStyle, 'image') && elOptionStyle.image !== elInner.customImagePath // // FIXME test and remove this restriction?
	        // || (elOptionType === 'text'
	        //     && hasOwn(elOptionStyle, 'text')
	        //     && (elOptionStyle as TextStyleProps).text !== elInner.customText
	        // )
	
	      );
	    }
	
	    function doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit) {
	      // Based on the "merge" principle, if no clipPath provided,
	      // do nothing. The exists clip will be totally removed only if
	      // `el.clipPath` is `false`. Otherwise it will be merged/replaced.
	      var clipPathOpt = elOption.clipPath;
	
	      if (clipPathOpt === false) {
	        if (el && el.getClipPath()) {
	          el.removeClipPath();
	        }
	      } else if (clipPathOpt) {
	        var clipPath = el.getClipPath();
	
	        if (clipPath && doesElNeedRecreate(clipPath, clipPathOpt, seriesModel)) {
	          clipPath = null;
	        }
	
	        if (!clipPath) {
	          clipPath = createEl(clipPathOpt);
	
	          if (true) {
	            assert(isPath$1(clipPath), 'Only any type of `path` can be used in `clipPath`, rather than ' + clipPath.type + '.');
	          }
	
	          el.setClipPath(clipPath);
	        }
	
	        updateElNormal(null, clipPath, dataIndex, clipPathOpt, null, seriesModel, isInit);
	      } // If not define `clipPath` in option, do nothing unnecessary.
	
	    }
	
	    function doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfo) {
	      // Group does not support textContent temporarily until necessary.
	      if (el.isGroup) {
	        return;
	      } // Normal must be called before emphasis, for `isLegacy` detection.
	
	
	      processTxInfo(elOption, null, attachedTxInfo);
	      processTxInfo(elOption, EMPHASIS, attachedTxInfo); // If `elOption.textConfig` or `elOption.textContent` is null/undefined, it does not make sense.
	      // So for simplicity, if "elOption hasOwnProperty of them but be null/undefined", we do not
	      // trade them as set to null to el.
	      // Especially:
	      // `elOption.textContent: false` means remove textContent.
	      // `elOption.textContent.emphasis.style: false` means remove the style from emphasis state.
	
	      var txConOptNormal = attachedTxInfo.normal.conOpt;
	      var txConOptEmphasis = attachedTxInfo.emphasis.conOpt;
	      var txConOptBlur = attachedTxInfo.blur.conOpt;
	      var txConOptSelect = attachedTxInfo.select.conOpt;
	
	      if (txConOptNormal != null || txConOptEmphasis != null || txConOptSelect != null || txConOptBlur != null) {
	        var textContent = el.getTextContent();
	
	        if (txConOptNormal === false) {
	          textContent && el.removeTextContent();
	        } else {
	          txConOptNormal = attachedTxInfo.normal.conOpt = txConOptNormal || {
	            type: 'text'
	          };
	
	          if (!textContent) {
	            textContent = createEl(txConOptNormal);
	            el.setTextContent(textContent);
	          } else {
	            // If in some case the performance issue arised, consider
	            // do not clearState but update cached normal state directly.
	            textContent.clearStates();
	          }
	
	          updateElNormal(null, textContent, dataIndex, txConOptNormal, null, seriesModel, isInit);
	          var txConStlOptNormal = txConOptNormal && txConOptNormal.style;
	
	          for (var i = 0; i < STATES.length; i++) {
	            var stateName = STATES[i];
	
	            if (stateName !== NORMAL) {
	              var txConOptOtherState = attachedTxInfo[stateName].conOpt;
	              updateElOnState(stateName, textContent, txConOptOtherState, retrieveStyleOptionOnState(txConOptNormal, txConOptOtherState, stateName), null);
	            }
	          }
	
	          txConStlOptNormal ? textContent.dirty() : textContent.markRedraw();
	        }
	      }
	    }
	
	    function processTxInfo(elOption, state, attachedTxInfo) {
	      var stateOpt = !state ? elOption : retrieveStateOption(elOption, state);
	      var styleOpt = !state ? elOption.style : retrieveStyleOptionOnState(elOption, stateOpt, EMPHASIS);
	      var elType = elOption.type;
	      var txCfg = stateOpt ? stateOpt.textConfig : null;
	      var txConOptNormal = elOption.textContent;
	      var txConOpt = !txConOptNormal ? null : !state ? txConOptNormal : retrieveStateOption(txConOptNormal, state);
	
	      if (styleOpt && ( // Because emphasis style has little info to detect legacy,
	      // if normal is legacy, emphasis is trade as legacy.
	      attachedTxInfo.isLegacy || isEC4CompatibleStyle(styleOpt, elType, !!txCfg, !!txConOpt))) {
	        attachedTxInfo.isLegacy = true;
	        var convertResult = convertFromEC4CompatibleStyle(styleOpt, elType, !state); // Explicitly specified `textConfig` and `textContent` has higher priority than
	        // the ones generated by legacy style. Otherwise if users use them and `api.style`
	        // at the same time, they not both work and hardly to known why.
	
	        if (!txCfg && convertResult.textConfig) {
	          txCfg = convertResult.textConfig;
	        }
	
	        if (!txConOpt && convertResult.textContent) {
	          txConOpt = convertResult.textContent;
	        }
	      }
	
	      if (!state && txConOpt) {
	        var txConOptNormal_1 = txConOpt; // `textContent: {type: 'text'}`, the "type" is easy to be missing. So we tolerate it.
	
	        !txConOptNormal_1.type && (txConOptNormal_1.type = 'text');
	
	        if (true) {
	          // Do not tolerate incorrcet type for forward compat.
	          assert(txConOptNormal_1.type === 'text', 'textContent.type must be "text"');
	        }
	      }
	
	      var info = !state ? attachedTxInfo.normal : attachedTxInfo[state];
	      info.cfg = txCfg;
	      info.conOpt = txConOpt;
	    }
	
	    function retrieveStateOption(elOption, state) {
	      return !state ? elOption : elOption ? elOption[state] : null;
	    }
	
	    function retrieveStyleOptionOnState(stateOptionNormal, stateOption, state) {
	      var style = stateOption && stateOption.style;
	
	      if (style == null && state === EMPHASIS && stateOptionNormal) {
	        style = stateOptionNormal.styleEmphasis;
	      }
	
	      return style;
	    } // Usage:
	    // (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates
	    //     that the existing children will not be removed, and enables the feature
	    //     that update some of the props of some of the children simply by construct
	    //     the returned children of `renderItem` like:
	    //     `var children = group.children = []; children[3] = {opacity: 0.5};`
	    // (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
	    //     by child.name. But that might be lower performance.
	    // (3) If `elOption.$mergeChildren` is `false`, the existing children will be
	    //     replaced totally.
	    // (4) If `!elOption.children`, following the "merge" principle, nothing will
	    //     happen.
	    // (5) If `elOption.$mergeChildren` is not `false` neither `'byName'` and the
	    //     `el` is a group, and if any of the new child is null, it means to remove
	    //     the element at the same index, if exists. On the other hand, if the new
	    //     child is and empty object `{}`, it means to keep the element not changed.
	    //
	    // For implementation simpleness, do not provide a direct way to remove single
	    // child (otherwise the total indices of the children array have to be modified).
	    // User can remove a single child by setting its `ignore` to `true`.
	
	
	    function mergeChildren(api, el, dataIndex, elOption, seriesModel) {
	      var newChildren = elOption.children;
	      var newLen = newChildren ? newChildren.length : 0;
	      var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.
	
	      var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
	      var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.
	
	      if (!newLen && !byName && !notMerge) {
	        return;
	      }
	
	      if (byName) {
	        diffGroupChildren({
	          api: api,
	          oldChildren: el.children() || [],
	          newChildren: newChildren || [],
	          dataIndex: dataIndex,
	          seriesModel: seriesModel,
	          group: el
	        });
	        return;
	      }
	
	      notMerge && el.removeAll(); // Mapping children of a group simply by index, which
	      // might be better performance.
	
	      var index = 0;
	
	      for (; index < newLen; index++) {
	        var newChild = newChildren[index];
	        var oldChild = el.childAt(index);
	
	        if (newChild) {
	          if (newChild.ignore == null) {
	            // The old child is set to be ignored if null (see comments
	            // below). So we need to set ignore to be false back.
	            newChild.ignore = false;
	          }
	
	          doCreateOrUpdateEl(api, oldChild, dataIndex, newChild, seriesModel, el);
	        } else {
	          if (true) {
	            assert(oldChild, 'renderItem should not return a group containing elements' + ' as null/undefined/{} if they do not exist before.');
	          } // If the new element option is null, it means to remove the old
	          // element. But we cannot really remove the element from the group
	          // directly, because the element order may not be stable when this
	          // element is added back. So we set the element to be ignored.
	
	
	          oldChild.ignore = true;
	        }
	      }
	
	      for (var i = el.childCount() - 1; i >= index; i--) {
	        var child = el.childAt(i);
	        removeChildFromGroup(el, child, seriesModel);
	      }
	    }
	
	    function removeChildFromGroup(group, child, seriesModel) {
	      // Do not support leave elements that are not mentioned in the latest
	      // `renderItem` return. Otherwise users may not have a clear and simple
	      // concept that how to control all of the elements.
	      child && applyLeaveTransition(child, customInnerStore(group).option, seriesModel);
	    }
	
	    function diffGroupChildren(context) {
	      new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
	    }
	
	    function getKey(item, idx) {
	      var name = item && item.name;
	      return name != null ? name : GROUP_DIFF_PREFIX + idx;
	    }
	
	    function processAddUpdate(newIndex, oldIndex) {
	      var context = this.context;
	      var childOption = newIndex != null ? context.newChildren[newIndex] : null;
	      var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
	      doCreateOrUpdateEl(context.api, child, context.dataIndex, childOption, context.seriesModel, context.group);
	    }
	
	    function processRemove(oldIndex) {
	      var context = this.context;
	      var child = context.oldChildren[oldIndex];
	      child && applyLeaveTransition(child, customInnerStore(child).option, context.seriesModel);
	    }
	    /**
	     * @return SVG Path data.
	     */
	
	
	    function getPathData(shape) {
	      // "d" follows the SVG convention.
	      return shape && (shape.pathData || shape.d);
	    }
	
	    function hasOwnPathData(shape) {
	      return shape && (hasOwn(shape, 'pathData') || hasOwn(shape, 'd'));
	    }
	
	    function install$r(registers) {
	      registers.registerChartView(CustomChartView);
	      registers.registerSeriesModel(CustomSeriesModel);
	    }
	
	    var inner$a = makeInner();
	    var clone$3 = clone;
	    var bind$1 = bind;
	    /**
	     * Base axis pointer class in 2D.
	     */
	
	    var BaseAxisPointer =
	    /** @class */
	    function () {
	      function BaseAxisPointer() {
	        this._dragging = false;
	        /**
	         * In px, arbitrary value. Do not set too small,
	         * no animation is ok for most cases.
	         */
	
	        this.animationThreshold = 15;
	      }
	      /**
	       * @implement
	       */
	
	
	      BaseAxisPointer.prototype.render = function (axisModel, axisPointerModel, api, forceRender) {
	        var value = axisPointerModel.get('value');
	        var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
	        // be replaced when user calling setOption in not merge mode.
	
	        this._axisModel = axisModel;
	        this._axisPointerModel = axisPointerModel;
	        this._api = api; // Optimize: `render` will be called repeatedly during mouse move.
	        // So it is power consuming if performing `render` each time,
	        // especially on mobile device.
	
	        if (!forceRender && this._lastValue === value && this._lastStatus === status) {
	          return;
	        }
	
	        this._lastValue = value;
	        this._lastStatus = status;
	        var group = this._group;
	        var handle = this._handle;
	
	        if (!status || status === 'hide') {
	          // Do not clear here, for animation better.
	          group && group.hide();
	          handle && handle.hide();
	          return;
	        }
	
	        group && group.show();
	        handle && handle.show(); // Otherwise status is 'show'
	
	        var elOption = {};
	        this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
	
	        var graphicKey = elOption.graphicKey;
	
	        if (graphicKey !== this._lastGraphicKey) {
	          this.clear(api);
	        }
	
	        this._lastGraphicKey = graphicKey;
	        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
	
	        if (!group) {
	          group = this._group = new Group();
	          this.createPointerEl(group, elOption, axisModel, axisPointerModel);
	          this.createLabelEl(group, elOption, axisModel, axisPointerModel);
	          api.getZr().add(group);
	        } else {
	          var doUpdateProps = curry(updateProps$1, axisPointerModel, moveAnimation);
	          this.updatePointerEl(group, elOption, doUpdateProps);
	          this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
	        }
	
	        updateMandatoryProps(group, axisPointerModel, true);
	
	        this._renderHandle(value);
	      };
	      /**
	       * @implement
	       */
	
	
	      BaseAxisPointer.prototype.remove = function (api) {
	        this.clear(api);
	      };
	      /**
	       * @implement
	       */
	
	
	      BaseAxisPointer.prototype.dispose = function (api) {
	        this.clear(api);
	      };
	      /**
	       * @protected
	       */
	
	
	      BaseAxisPointer.prototype.determineAnimation = function (axisModel, axisPointerModel) {
	        var animation = axisPointerModel.get('animation');
	        var axis = axisModel.axis;
	        var isCategoryAxis = axis.type === 'category';
	        var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
	
	        if (!useSnap && !isCategoryAxis) {
	          return false;
	        }
	
	        if (animation === 'auto' || animation == null) {
	          var animationThreshold = this.animationThreshold;
	
	          if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
	            return true;
	          } // It is important to auto animation when snap used. Consider if there is
	          // a dataZoom, animation will be disabled when too many points exist, while
	          // it will be enabled for better visual effect when little points exist.
	
	
	          if (useSnap) {
	            var seriesDataCount = getAxisInfo(axisModel).seriesDataCount;
	            var axisExtent = axis.getExtent(); // Approximate band width
	
	            return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
	          }
	
	          return false;
	        }
	
	        return animation === true;
	      };
	      /**
	       * add {pointer, label, graphicKey} to elOption
	       * @protected
	       */
	
	
	      BaseAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {// Should be implemenented by sub-class.
	      };
	      /**
	       * @protected
	       */
	
	
	      BaseAxisPointer.prototype.createPointerEl = function (group, elOption, axisModel, axisPointerModel) {
	        var pointerOption = elOption.pointer;
	
	        if (pointerOption) {
	          var pointerEl = inner$a(group).pointerEl = new graphic[pointerOption.type](clone$3(elOption.pointer));
	          group.add(pointerEl);
	        }
	      };
	      /**
	       * @protected
	       */
	
	
	      BaseAxisPointer.prototype.createLabelEl = function (group, elOption, axisModel, axisPointerModel) {
	        if (elOption.label) {
	          var labelEl = inner$a(group).labelEl = new ZRText(clone$3(elOption.label));
	          group.add(labelEl);
	          updateLabelShowHide(labelEl, axisPointerModel);
	        }
	      };
	      /**
	       * @protected
	       */
	
	
	      BaseAxisPointer.prototype.updatePointerEl = function (group, elOption, updateProps) {
	        var pointerEl = inner$a(group).pointerEl;
	
	        if (pointerEl && elOption.pointer) {
	          pointerEl.setStyle(elOption.pointer.style);
	          updateProps(pointerEl, {
	            shape: elOption.pointer.shape
	          });
	        }
	      };
	      /**
	       * @protected
	       */
	
	
	      BaseAxisPointer.prototype.updateLabelEl = function (group, elOption, updateProps, axisPointerModel) {
	        var labelEl = inner$a(group).labelEl;
	
	        if (labelEl) {
	          labelEl.setStyle(elOption.label.style);
	          updateProps(labelEl, {
	            // Consider text length change in vertical axis, animation should
	            // be used on shape, otherwise the effect will be weird.
	            // TODOTODO
	            // shape: elOption.label.shape,
	            x: elOption.label.x,
	            y: elOption.label.y
	          });
	          updateLabelShowHide(labelEl, axisPointerModel);
	        }
	      };
	      /**
	       * @private
	       */
	
	
	      BaseAxisPointer.prototype._renderHandle = function (value) {
	        if (this._dragging || !this.updateHandleTransform) {
	          return;
	        }
	
	        var axisPointerModel = this._axisPointerModel;
	
	        var zr = this._api.getZr();
	
	        var handle = this._handle;
	        var handleModel = axisPointerModel.getModel('handle');
	        var status = axisPointerModel.get('status');
	
	        if (!handleModel.get('show') || !status || status === 'hide') {
	          handle && zr.remove(handle);
	          this._handle = null;
	          return;
	        }
	
	        var isInit;
	
	        if (!this._handle) {
	          isInit = true;
	          handle = this._handle = createIcon(handleModel.get('icon'), {
	            cursor: 'move',
	            draggable: true,
	            onmousemove: function (e) {
	              // For mobile device, prevent screen slider on the button.
	              stop(e.event);
	            },
	            onmousedown: bind$1(this._onHandleDragMove, this, 0, 0),
	            drift: bind$1(this._onHandleDragMove, this),
	            ondragend: bind$1(this._onHandleDragEnd, this)
	          });
	          zr.add(handle);
	        }
	
	        updateMandatoryProps(handle, axisPointerModel, false); // update style
	
	        handle.setStyle(handleModel.getItemStyle(null, ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'])); // update position
	
	        var handleSize = handleModel.get('size');
	
	        if (!isArray(handleSize)) {
	          handleSize = [handleSize, handleSize];
	        }
	
	        handle.scaleX = handleSize[0] / 2;
	        handle.scaleY = handleSize[1] / 2;
	        createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
	
	        this._moveHandleToValue(value, isInit);
	      };
	
	      BaseAxisPointer.prototype._moveHandleToValue = function (value, isInit) {
	        updateProps$1(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
	      };
	
	      BaseAxisPointer.prototype._onHandleDragMove = function (dx, dy) {
	        var handle = this._handle;
	
	        if (!handle) {
	          return;
	        }
	
	        this._dragging = true; // Persistent for throttle.
	
	        var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
	        this._payloadInfo = trans;
	        handle.stopAnimation();
	        handle.attr(getHandleTransProps(trans));
	        inner$a(handle).lastProp = null;
	
	        this._doDispatchAxisPointer();
	      };
	      /**
	       * Throttled method.
	       */
	
	
	      BaseAxisPointer.prototype._doDispatchAxisPointer = function () {
	        var handle = this._handle;
	
	        if (!handle) {
	          return;
	        }
	
	        var payloadInfo = this._payloadInfo;
	        var axisModel = this._axisModel;
	
	        this._api.dispatchAction({
	          type: 'updateAxisPointer',
	          x: payloadInfo.cursorPoint[0],
	          y: payloadInfo.cursorPoint[1],
	          tooltipOption: payloadInfo.tooltipOption,
	          axesInfo: [{
	            axisDim: axisModel.axis.dim,
	            axisIndex: axisModel.componentIndex
	          }]
	        });
	      };
	
	      BaseAxisPointer.prototype._onHandleDragEnd = function () {
	        this._dragging = false;
	        var handle = this._handle;
	
	        if (!handle) {
	          return;
	        }
	
	        var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
	        // axisPointer. So move handle to align the exact value position when
	        // drag ended.
	
	
	        this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
	        // button, and will be hidden after finger left handle button.
	
	
	        this._api.dispatchAction({
	          type: 'hideTip'
	        });
	      };
	      /**
	       * @private
	       */
	
	
	      BaseAxisPointer.prototype.clear = function (api) {
	        this._lastValue = null;
	        this._lastStatus = null;
	        var zr = api.getZr();
	        var group = this._group;
	        var handle = this._handle;
	
	        if (zr && group) {
	          this._lastGraphicKey = null;
	          group && zr.remove(group);
	          handle && zr.remove(handle);
	          this._group = null;
	          this._handle = null;
	          this._payloadInfo = null;
	        }
	
	        clear(this, '_doDispatchAxisPointer');
	      };
	      /**
	       * @protected
	       */
	
	
	      BaseAxisPointer.prototype.doClear = function () {// Implemented by sub-class if necessary.
	      };
	
	      BaseAxisPointer.prototype.buildLabel = function (xy, wh, xDimIndex) {
	        xDimIndex = xDimIndex || 0;
	        return {
	          x: xy[xDimIndex],
	          y: xy[1 - xDimIndex],
	          width: wh[xDimIndex],
	          height: wh[1 - xDimIndex]
	        };
	      };
	
	      return BaseAxisPointer;
	    }();
	
	    function updateProps$1(animationModel, moveAnimation, el, props) {
	      // Animation optimize.
	      if (!propsEqual(inner$a(el).lastProp, props)) {
	        inner$a(el).lastProp = props;
	        moveAnimation ? updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
	      }
	    }
	
	    function propsEqual(lastProps, newProps) {
	      if (isObject(lastProps) && isObject(newProps)) {
	        var equals_1 = true;
	        each(newProps, function (item, key) {
	          equals_1 = equals_1 && propsEqual(lastProps[key], item);
	        });
	        return !!equals_1;
	      } else {
	        return lastProps === newProps;
	      }
	    }
	
	    function updateLabelShowHide(labelEl, axisPointerModel) {
	      labelEl[axisPointerModel.get(['label', 'show']) ? 'show' : 'hide']();
	    }
	
	    function getHandleTransProps(trans) {
	      return {
	        x: trans.x || 0,
	        y: trans.y || 0,
	        rotation: trans.rotation || 0
	      };
	    }
	
	    function updateMandatoryProps(group, axisPointerModel, silent) {
	      var z = axisPointerModel.get('z');
	      var zlevel = axisPointerModel.get('zlevel');
	      group && group.traverse(function (el) {
	        if (el.type !== 'group') {
	          z != null && (el.z = z);
	          zlevel != null && (el.zlevel = zlevel);
	          el.silent = silent;
	        }
	      });
	    }
	
	    function buildElStyle(axisPointerModel) {
	      var axisPointerType = axisPointerModel.get('type');
	      var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
	      var style;
	
	      if (axisPointerType === 'line') {
	        style = styleModel.getLineStyle();
	        style.fill = null;
	      } else if (axisPointerType === 'shadow') {
	        style = styleModel.getAreaStyle();
	        style.stroke = null;
	      }
	
	      return style;
	    }
	    /**
	     * @param {Function} labelPos {align, verticalAlign, position}
	     */
	
	    function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
	      var value = axisPointerModel.get('value');
	      var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
	        precision: axisPointerModel.get(['label', 'precision']),
	        formatter: axisPointerModel.get(['label', 'formatter'])
	      });
	      var labelModel = axisPointerModel.getModel('label');
	      var paddings = normalizeCssArray$1(labelModel.get('padding') || 0);
	      var font = labelModel.getFont();
	      var textRect = getBoundingRect(text, font);
	      var position = labelPos.position;
	      var width = textRect.width + paddings[1] + paddings[3];
	      var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
	
	      var align = labelPos.align;
	      align === 'right' && (position[0] -= width);
	      align === 'center' && (position[0] -= width / 2);
	      var verticalAlign = labelPos.verticalAlign;
	      verticalAlign === 'bottom' && (position[1] -= height);
	      verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
	
	      confineInContainer(position, width, height, api);
	      var bgColor = labelModel.get('backgroundColor');
	
	      if (!bgColor || bgColor === 'auto') {
	        bgColor = axisModel.get(['axisLine', 'lineStyle', 'color']);
	      }
	
	      elOption.label = {
	        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
	        x: position[0],
	        y: position[1],
	        style: createTextStyle(labelModel, {
	          text: text,
	          font: font,
	          fill: labelModel.getTextColor(),
	          padding: paddings,
	          backgroundColor: bgColor
	        }),
	        // Label should be over axisPointer.
	        z2: 10
	      };
	    } // Do not overflow ec container
	
	    function confineInContainer(position, width, height, api) {
	      var viewWidth = api.getWidth();
	      var viewHeight = api.getHeight();
	      position[0] = Math.min(position[0] + width, viewWidth) - width;
	      position[1] = Math.min(position[1] + height, viewHeight) - height;
	      position[0] = Math.max(position[0], 0);
	      position[1] = Math.max(position[1], 0);
	    }
	
	    function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
	      value = axis.scale.parse(value);
	      var text = axis.scale.getLabel({
	        value: value
	      }, {
	        // If `precision` is set, width can be fixed (like '12.00500'), which
	        // helps to debounce when when moving label.
	        precision: opt.precision
	      });
	      var formatter = opt.formatter;
	
	      if (formatter) {
	        var params_1 = {
	          value: getAxisRawValue(axis, {
	            value: value
	          }),
	          axisDimension: axis.dim,
	          axisIndex: axis.index,
	          seriesData: []
	        };
	        each(seriesDataIndices, function (idxItem) {
	          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	          var dataIndex = idxItem.dataIndexInside;
	          var dataParams = series && series.getDataParams(dataIndex);
	          dataParams && params_1.seriesData.push(dataParams);
	        });
	
	        if (isString(formatter)) {
	          text = formatter.replace('{value}', text);
	        } else if (isFunction(formatter)) {
	          text = formatter(params_1);
	        }
	      }
	
	      return text;
	    }
	    function getTransformedPosition(axis, value, layoutInfo) {
	      var transform = create$1();
	      rotate(transform, transform, layoutInfo.rotation);
	      translate(transform, transform, layoutInfo.position);
	      return applyTransform$1([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
	    }
	    function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
	      // @ts-ignore
	      var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
	      layoutInfo.labelMargin = axisPointerModel.get(['label', 'margin']);
	      buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
	        position: getTransformedPosition(axisModel.axis, value, layoutInfo),
	        align: textLayout.textAlign,
	        verticalAlign: textLayout.textVerticalAlign
	      });
	    }
	    function makeLineShape(p1, p2, xDimIndex) {
	      xDimIndex = xDimIndex || 0;
	      return {
	        x1: p1[xDimIndex],
	        y1: p1[1 - xDimIndex],
	        x2: p2[xDimIndex],
	        y2: p2[1 - xDimIndex]
	      };
	    }
	    function makeRectShape(xy, wh, xDimIndex) {
	      xDimIndex = xDimIndex || 0;
	      return {
	        x: xy[xDimIndex],
	        y: xy[1 - xDimIndex],
	        width: wh[xDimIndex],
	        height: wh[1 - xDimIndex]
	      };
	    }
	    function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
	      return {
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: r,
	        startAngle: startAngle,
	        endAngle: endAngle,
	        clockwise: true
	      };
	    }
	
	    var CartesianAxisPointer =
	    /** @class */
	    function (_super) {
	      __extends(CartesianAxisPointer, _super);
	
	      function CartesianAxisPointer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	      /**
	       * @override
	       */
	
	
	      CartesianAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {
	        var axis = axisModel.axis;
	        var grid = axis.grid;
	        var axisPointerType = axisPointerModel.get('type');
	        var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
	
	        if (axisPointerType && axisPointerType !== 'none') {
	          var elStyle = buildElStyle(axisPointerModel);
	          var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
	          pointerOption.style = elStyle;
	          elOption.graphicKey = pointerOption.type;
	          elOption.pointer = pointerOption;
	        }
	
	        var layoutInfo = layout$1(grid.model, axisModel);
	        buildCartesianSingleLabelElOption( // @ts-ignore
	        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	      };
	      /**
	       * @override
	       */
	
	
	      CartesianAxisPointer.prototype.getHandleTransform = function (value, axisModel, axisPointerModel) {
	        var layoutInfo = layout$1(axisModel.axis.grid.model, axisModel, {
	          labelInside: false
	        }); // @ts-ignore
	
	        layoutInfo.labelMargin = axisPointerModel.get(['handle', 'margin']);
	        var pos = getTransformedPosition(axisModel.axis, value, layoutInfo);
	        return {
	          x: pos[0],
	          y: pos[1],
	          rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	        };
	      };
	      /**
	       * @override
	       */
	
	
	      CartesianAxisPointer.prototype.updateHandleTransform = function (transform, delta, axisModel, axisPointerModel) {
	        var axis = axisModel.axis;
	        var grid = axis.grid;
	        var axisExtent = axis.getGlobalExtent(true);
	        var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	        var dimIndex = axis.dim === 'x' ? 0 : 1;
	        var currPosition = [transform.x, transform.y];
	        currPosition[dimIndex] += delta[dimIndex];
	        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	        var cursorPoint = [cursorOtherValue, cursorOtherValue];
	        cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
	
	        var tooltipOptions = [{
	          verticalAlign: 'middle'
	        }, {
	          align: 'center'
	        }];
	        return {
	          x: currPosition[0],
	          y: currPosition[1],
	          rotation: transform.rotation,
	          cursorPoint: cursorPoint,
	          tooltipOption: tooltipOptions[dimIndex]
	        };
	      };
	
	      return CartesianAxisPointer;
	    }(BaseAxisPointer);
	
	    function getCartesian(grid, axis) {
	      var opt = {};
	      opt[axis.dim + 'AxisIndex'] = axis.index;
	      return grid.getCartesian(opt);
	    }
	
	    var pointerShapeBuilder = {
	      line: function (axis, pixelValue, otherExtent) {
	        var targetShape = makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
	        return {
	          type: 'Line',
	          subPixelOptimize: true,
	          shape: targetShape
	        };
	      },
	      shadow: function (axis, pixelValue, otherExtent) {
	        var bandWidth = Math.max(1, axis.getBandWidth());
	        var span = otherExtent[1] - otherExtent[0];
	        return {
	          type: 'Rect',
	          shape: makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
	        };
	      }
	    };
	
	    function getAxisDimIndex(axis) {
	      return axis.dim === 'x' ? 0 : 1;
	    }
	
	    var AxisPointerModel =
	    /** @class */
	    function (_super) {
	      __extends(AxisPointerModel, _super);
	
	      function AxisPointerModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = AxisPointerModel.type;
	        return _this;
	      }
	
	      AxisPointerModel.type = 'axisPointer';
	      AxisPointerModel.defaultOption = {
	        // 'auto' means that show when triggered by tooltip or handle.
	        show: 'auto',
	        // zlevel: 0,
	        z: 50,
	        type: 'line',
	        // axispointer triggered by tootip determine snap automatically,
	        // see `modelHelper`.
	        snap: false,
	        triggerTooltip: true,
	        triggerEmphasis: true,
	        value: null,
	        status: null,
	        link: [],
	        // Do not set 'auto' here, otherwise global animation: false
	        // will not effect at this axispointer.
	        animation: null,
	        animationDurationUpdate: 200,
	        lineStyle: {
	          color: '#B9BEC9',
	          width: 1,
	          type: 'dashed'
	        },
	        shadowStyle: {
	          color: 'rgba(210,219,238,0.2)'
	        },
	        label: {
	          show: true,
	          formatter: null,
	          precision: 'auto',
	          margin: 3,
	          color: '#fff',
	          padding: [5, 7, 5, 7],
	          backgroundColor: 'auto',
	          borderColor: null,
	          borderWidth: 0,
	          borderRadius: 3
	        },
	        handle: {
	          show: false,
	          // eslint-disable-next-line
	          icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
	          size: 45,
	          // handle margin is from symbol center to axis, which is stable when circular move.
	          margin: 50,
	          // color: '#1b8bbd'
	          // color: '#2f4554'
	          color: '#333',
	          shadowBlur: 3,
	          shadowColor: '#aaa',
	          shadowOffsetX: 0,
	          shadowOffsetY: 2,
	          // For mobile performance
	          throttle: 40
	        }
	      };
	      return AxisPointerModel;
	    }(ComponentModel);
	
	    var inner$b = makeInner();
	    var each$7 = each;
	    /**
	     * @param {string} key
	     * @param {module:echarts/ExtensionAPI} api
	     * @param {Function} handler
	     *      param: {string} currTrigger
	     *      param: {Array.<number>} point
	     */
	
	    function register(key, api, handler) {
	      if (env.node) {
	        return;
	      }
	
	      var zr = api.getZr();
	      inner$b(zr).records || (inner$b(zr).records = {});
	      initGlobalListeners(zr, api);
	      var record = inner$b(zr).records[key] || (inner$b(zr).records[key] = {});
	      record.handler = handler;
	    }
	
	    function initGlobalListeners(zr, api) {
	      if (inner$b(zr).initialized) {
	        return;
	      }
	
	      inner$b(zr).initialized = true;
	      useHandler('click', curry(doEnter, 'click'));
	      useHandler('mousemove', curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
	
	      useHandler('globalout', onLeave);
	
	      function useHandler(eventType, cb) {
	        zr.on(eventType, function (e) {
	          var dis = makeDispatchAction(api);
	          each$7(inner$b(zr).records, function (record) {
	            record && cb(record, e, dis.dispatchAction);
	          });
	          dispatchTooltipFinally(dis.pendings, api);
	        });
	      }
	    }
	
	    function dispatchTooltipFinally(pendings, api) {
	      var showLen = pendings.showTip.length;
	      var hideLen = pendings.hideTip.length;
	      var actuallyPayload;
	
	      if (showLen) {
	        actuallyPayload = pendings.showTip[showLen - 1];
	      } else if (hideLen) {
	        actuallyPayload = pendings.hideTip[hideLen - 1];
	      }
	
	      if (actuallyPayload) {
	        actuallyPayload.dispatchAction = null;
	        api.dispatchAction(actuallyPayload);
	      }
	    }
	
	    function onLeave(record, e, dispatchAction) {
	      record.handler('leave', null, dispatchAction);
	    }
	
	    function doEnter(currTrigger, record, e, dispatchAction) {
	      record.handler(currTrigger, e, dispatchAction);
	    }
	
	    function makeDispatchAction(api) {
	      var pendings = {
	        showTip: [],
	        hideTip: []
	      }; // FIXME
	      // better approach?
	      // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
	      // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
	      // So we have to add "final stage" to merge those dispatched actions.
	
	      var dispatchAction = function (payload) {
	        var pendingList = pendings[payload.type];
	
	        if (pendingList) {
	          pendingList.push(payload);
	        } else {
	          payload.dispatchAction = dispatchAction;
	          api.dispatchAction(payload);
	        }
	      };
	
	      return {
	        dispatchAction: dispatchAction,
	        pendings: pendings
	      };
	    }
	
	    function unregister(key, api) {
	      if (env.node) {
	        return;
	      }
	
	      var zr = api.getZr();
	      var record = (inner$b(zr).records || {})[key];
	
	      if (record) {
	        inner$b(zr).records[key] = null;
	      }
	    }
	
	    var AxisPointerView =
	    /** @class */
	    function (_super) {
	      __extends(AxisPointerView, _super);
	
	      function AxisPointerView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = AxisPointerView.type;
	        return _this;
	      }
	
	      AxisPointerView.prototype.render = function (globalAxisPointerModel, ecModel, api) {
	        var globalTooltipModel = ecModel.getComponent('tooltip');
	        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
	        // AxisPointerView to be independent to Tooltip.
	
	        register('axisPointer', api, function (currTrigger, e, dispatchAction) {
	          // If 'none', it is not controlled by mouse totally.
	          if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
	            dispatchAction({
	              type: 'updateAxisPointer',
	              currTrigger: currTrigger,
	              x: e && e.offsetX,
	              y: e && e.offsetY
	            });
	          }
	        });
	      };
	
	      AxisPointerView.prototype.remove = function (ecModel, api) {
	        unregister('axisPointer', api);
	      };
	
	      AxisPointerView.prototype.dispose = function (ecModel, api) {
	        unregister('axisPointer', api);
	      };
	
	      AxisPointerView.type = 'axisPointer';
	      return AxisPointerView;
	    }(ComponentView);
	
	    /**
	     * @param finder contains {seriesIndex, dataIndex, dataIndexInside}
	     * @param ecModel
	     * @return  {point: [x, y], el: ...} point Will not be null.
	     */
	
	    function findPointFromSeries(finder, ecModel) {
	      var point = [];
	      var seriesIndex = finder.seriesIndex;
	      var seriesModel;
	
	      if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
	        return {
	          point: []
	        };
	      }
	
	      var data = seriesModel.getData();
	      var dataIndex = queryDataIndex(data, finder);
	
	      if (dataIndex == null || dataIndex < 0 || isArray(dataIndex)) {
	        return {
	          point: []
	        };
	      }
	
	      var el = data.getItemGraphicEl(dataIndex);
	      var coordSys = seriesModel.coordinateSystem;
	
	      if (seriesModel.getTooltipPosition) {
	        point = seriesModel.getTooltipPosition(dataIndex) || [];
	      } else if (coordSys && coordSys.dataToPoint) {
	        if (finder.isStacked) {
	          var baseAxis = coordSys.getBaseAxis();
	          var valueAxis = coordSys.getOtherAxis(baseAxis);
	          var valueAxisDim = valueAxis.dim;
	          var baseAxisDim = baseAxis.dim;
	          var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
	          var baseDim = data.mapDimension(baseAxisDim);
	          var stackedData = [];
	          stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
	          stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
	          point = coordSys.dataToPoint(stackedData) || [];
	        } else {
	          point = coordSys.dataToPoint(data.getValues(map(coordSys.dimensions, function (dim) {
	            return data.mapDimension(dim);
	          }), dataIndex)) || [];
	        }
	      } else if (el) {
	        // Use graphic bounding rect
	        var rect = el.getBoundingRect().clone();
	        rect.applyTransform(el.transform);
	        point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	      }
	
	      return {
	        point: point,
	        el: el
	      };
	    }
	
	    var inner$c = makeInner();
	    /**
	     * Basic logic: check all axis, if they do not demand show/highlight,
	     * then hide/downplay them.
	     *
	     * @return content of event obj for echarts.connect.
	     */
	
	    function axisTrigger(payload, ecModel, api) {
	      var currTrigger = payload.currTrigger;
	      var point = [payload.x, payload.y];
	      var finder = payload;
	      var dispatchAction = payload.dispatchAction || bind(api.dispatchAction, api);
	      var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
	      // See #6121. But we are not able to reproduce it yet.
	
	      if (!coordSysAxesInfo) {
	        return;
	      }
	
	      if (illegalPoint(point)) {
	        // Used in the default behavior of `connection`: use the sample seriesIndex
	        // and dataIndex. And also used in the tooltipView trigger.
	        point = findPointFromSeries({
	          seriesIndex: finder.seriesIndex,
	          // Do not use dataIndexInside from other ec instance.
	          // FIXME: auto detect it?
	          dataIndex: finder.dataIndex
	        }, ecModel).point;
	      }
	
	      var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
	      // Notice: In this case, it is difficult to get the `point` (which is necessary to show
	      // tooltip, so if point is not given, we just use the point found by sample seriesIndex
	      // and dataIndex.
	
	      var inputAxesInfo = finder.axesInfo;
	      var axesInfo = coordSysAxesInfo.axesInfo;
	      var shouldHide = currTrigger === 'leave' || illegalPoint(point);
	      var outputPayload = {};
	      var showValueMap = {};
	      var dataByCoordSys = {
	        list: [],
	        map: {}
	      };
	      var updaters = {
	        showPointer: curry(showPointer, showValueMap),
	        showTooltip: curry(showTooltip, dataByCoordSys)
	      }; // Process for triggered axes.
	
	      each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
	        // If a point given, it must be contained by the coordinate system.
	        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
	        each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
	          var axis = axisInfo.axis;
	          var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
	
	          if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
	            var val = inputAxisInfo && inputAxisInfo.value;
	
	            if (val == null && !isIllegalPoint) {
	              val = axis.pointToData(point);
	            }
	
	            val != null && processOnAxis(axisInfo, val, updaters, false, outputPayload);
	          }
	        });
	      }); // Process for linked axes.
	
	      var linkTriggers = {};
	      each(axesInfo, function (tarAxisInfo, tarKey) {
	        var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
	
	        if (linkGroup && !showValueMap[tarKey]) {
	          each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
	            var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
	
	            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
	              var val = srcValItem.value;
	              linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
	              linkTriggers[tarAxisInfo.key] = val;
	            }
	          });
	        }
	      });
	      each(linkTriggers, function (val, tarKey) {
	        processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
	      });
	      updateModelActually(showValueMap, axesInfo, outputPayload);
	      dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
	      dispatchHighDownActually(axesInfo, dispatchAction, api);
	      return outputPayload;
	    }
	
	    function processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
	      var axis = axisInfo.axis;
	
	      if (axis.scale.isBlank() || !axis.containData(newValue)) {
	        return;
	      }
	
	      if (!axisInfo.involveSeries) {
	        updaters.showPointer(axisInfo, newValue);
	        return;
	      } // Heavy calculation. So put it after axis.containData checking.
	
	
	      var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
	      var payloadBatch = payloadInfo.payloadBatch;
	      var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
	      // By default use the first involved series data as a sample to connect.
	
	      if (payloadBatch[0] && outputFinder.seriesIndex == null) {
	        extend(outputFinder, payloadBatch[0]);
	      } // If no linkSource input, this process is for collecting link
	      // target, where snap should not be accepted.
	
	
	      if (!noSnap && axisInfo.snap) {
	        if (axis.containData(snapToValue) && snapToValue != null) {
	          newValue = snapToValue;
	        }
	      }
	
	      updaters.showPointer(axisInfo, newValue, payloadBatch); // Tooltip should always be snapToValue, otherwise there will be
	      // incorrect "axis value ~ series value" mapping displayed in tooltip.
	
	      updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
	    }
	
	    function buildPayloadsBySeries(value, axisInfo) {
	      var axis = axisInfo.axis;
	      var dim = axis.dim;
	      var snapToValue = value;
	      var payloadBatch = [];
	      var minDist = Number.MAX_VALUE;
	      var minDiff = -1;
	      each(axisInfo.seriesModels, function (series, idx) {
	        var dataDim = series.getData().mapDimensionsAll(dim);
	        var seriesNestestValue;
	        var dataIndices;
	
	        if (series.getAxisTooltipData) {
	          var result = series.getAxisTooltipData(dataDim, value, axis);
	          dataIndices = result.dataIndices;
	          seriesNestestValue = result.nestestValue;
	        } else {
	          dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
	          // when data length is not same.
	          // false,
	          axis.type === 'category' ? 0.5 : null);
	
	          if (!dataIndices.length) {
	            return;
	          }
	
	          seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
	        }
	
	        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
	          return;
	        }
	
	        var diff = value - seriesNestestValue;
	        var dist = Math.abs(diff); // Consider category case
	
	        if (dist <= minDist) {
	          if (dist < minDist || diff >= 0 && minDiff < 0) {
	            minDist = dist;
	            minDiff = diff;
	            snapToValue = seriesNestestValue;
	            payloadBatch.length = 0;
	          }
	
	          each(dataIndices, function (dataIndex) {
	            payloadBatch.push({
	              seriesIndex: series.seriesIndex,
	              dataIndexInside: dataIndex,
	              dataIndex: series.getData().getRawIndex(dataIndex)
	            });
	          });
	        }
	      });
	      return {
	        payloadBatch: payloadBatch,
	        snapToValue: snapToValue
	      };
	    }
	
	    function showPointer(showValueMap, axisInfo, value, payloadBatch) {
	      showValueMap[axisInfo.key] = {
	        value: value,
	        payloadBatch: payloadBatch
	      };
	    }
	
	    function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
	      var payloadBatch = payloadInfo.payloadBatch;
	      var axis = axisInfo.axis;
	      var axisModel = axis.model;
	      var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
	      // whose length will be used to judge whether dispatch action.
	
	      if (!axisInfo.triggerTooltip || !payloadBatch.length) {
	        return;
	      }
	
	      var coordSysModel = axisInfo.coordSys.model;
	      var coordSysKey = makeKey(coordSysModel);
	      var coordSysItem = dataByCoordSys.map[coordSysKey];
	
	      if (!coordSysItem) {
	        coordSysItem = dataByCoordSys.map[coordSysKey] = {
	          coordSysId: coordSysModel.id,
	          coordSysIndex: coordSysModel.componentIndex,
	          coordSysType: coordSysModel.type,
	          coordSysMainType: coordSysModel.mainType,
	          dataByAxis: []
	        };
	        dataByCoordSys.list.push(coordSysItem);
	      }
	
	      coordSysItem.dataByAxis.push({
	        axisDim: axis.dim,
	        axisIndex: axisModel.componentIndex,
	        axisType: axisModel.type,
	        axisId: axisModel.id,
	        value: value,
	        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
	        // depends that all models have been updated. So it should not be performed
	        // here. Considering axisPointerModel used here is volatile, which is hard
	        // to be retrieve in TooltipView, we prepare parameters here.
	        valueLabelOpt: {
	          precision: axisPointerModel.get(['label', 'precision']),
	          formatter: axisPointerModel.get(['label', 'formatter'])
	        },
	        seriesDataIndices: payloadBatch.slice()
	      });
	    }
	
	    function updateModelActually(showValueMap, axesInfo, outputPayload) {
	      var outputAxesInfo = outputPayload.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
	
	      each(axesInfo, function (axisInfo, key) {
	        var option = axisInfo.axisPointerModel.option;
	        var valItem = showValueMap[key];
	
	        if (valItem) {
	          !axisInfo.useHandle && (option.status = 'show');
	          option.value = valItem.value; // For label formatter param and highlight.
	
	          option.seriesDataIndices = (valItem.payloadBatch || []).slice();
	        } // When always show (e.g., handle used), remain
	        // original value and status.
	        else {
	            // If hide, value still need to be set, consider
	            // click legend to toggle axis blank.
	            !axisInfo.useHandle && (option.status = 'hide');
	          } // If status is 'hide', should be no info in payload.
	
	
	        option.status === 'show' && outputAxesInfo.push({
	          axisDim: axisInfo.axis.dim,
	          axisIndex: axisInfo.axis.model.componentIndex,
	          value: option.value
	        });
	      });
	    }
	
	    function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
	      // Basic logic: If no showTip required, hideTip will be dispatched.
	      if (illegalPoint(point) || !dataByCoordSys.list.length) {
	        dispatchAction({
	          type: 'hideTip'
	        });
	        return;
	      } // In most case only one axis (or event one series is used). It is
	      // convenient to fetch payload.seriesIndex and payload.dataIndex
	      // directly. So put the first seriesIndex and dataIndex of the first
	      // axis on the payload.
	
	
	      var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
	      dispatchAction({
	        type: 'showTip',
	        escapeConnect: true,
	        x: point[0],
	        y: point[1],
	        tooltipOption: payload.tooltipOption,
	        position: payload.position,
	        dataIndexInside: sampleItem.dataIndexInside,
	        dataIndex: sampleItem.dataIndex,
	        seriesIndex: sampleItem.seriesIndex,
	        dataByCoordSys: dataByCoordSys.list
	      });
	    }
	
	    function dispatchHighDownActually(axesInfo, dispatchAction, api) {
	      // FIXME
	      // highlight status modification should be a stage of main process?
	      // (Consider confilct (e.g., legend and axisPointer) and setOption)
	      var zr = api.getZr();
	      var highDownKey = 'axisPointerLastHighlights';
	      var lastHighlights = inner$c(zr)[highDownKey] || {};
	      var newHighlights = inner$c(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
	      // Build hash map and remove duplicate incidentally.
	
	      each(axesInfo, function (axisInfo, key) {
	        var option = axisInfo.axisPointerModel.option;
	        option.status === 'show' && axisInfo.triggerEmphasis && each(option.seriesDataIndices, function (batchItem) {
	          var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
	          newHighlights[key] = batchItem;
	        });
	      }); // Diff.
	
	      var toHighlight = [];
	      var toDownplay = [];
	      each(lastHighlights, function (batchItem, key) {
	        !newHighlights[key] && toDownplay.push(batchItem);
	      });
	      each(newHighlights, function (batchItem, key) {
	        !lastHighlights[key] && toHighlight.push(batchItem);
	      });
	      toDownplay.length && api.dispatchAction({
	        type: 'downplay',
	        escapeConnect: true,
	        // Not blur others when highlight in axisPointer.
	        notBlur: true,
	        batch: toDownplay
	      });
	      toHighlight.length && api.dispatchAction({
	        type: 'highlight',
	        escapeConnect: true,
	        // Not blur others when highlight in axisPointer.
	        notBlur: true,
	        batch: toHighlight
	      });
	    }
	
	    function findInputAxisInfo(inputAxesInfo, axisInfo) {
	      for (var i = 0; i < (inputAxesInfo || []).length; i++) {
	        var inputAxisInfo = inputAxesInfo[i];
	
	        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
	          return inputAxisInfo;
	        }
	      }
	    }
	
	    function makeMapperParam(axisInfo) {
	      var axisModel = axisInfo.axis.model;
	      var item = {};
	      var dim = item.axisDim = axisInfo.axis.dim;
	      item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
	      item.axisName = item[dim + 'AxisName'] = axisModel.name;
	      item.axisId = item[dim + 'AxisId'] = axisModel.id;
	      return item;
	    }
	
	    function illegalPoint(point) {
	      return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
	    }
	
	    function install$s(registers) {
	      // CartesianAxisPointer is not supposed to be required here. But consider
	      // echarts.simple.js and online build tooltip, which only require gridSimple,
	      // CartesianAxisPointer should be able to required somewhere.
	      AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
	      registers.registerComponentModel(AxisPointerModel);
	      registers.registerComponentView(AxisPointerView);
	      registers.registerPreprocessor(function (option) {
	        // Always has a global axisPointerModel for default setting.
	        if (option) {
	          (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
	          var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
	          // is not set, remain null/undefined, otherwise it will
	          // override existent link setting.
	
	          if (link && !isArray(link)) {
	            option.axisPointer.link = [link];
	          }
	        }
	      }); // This process should proformed after coordinate systems created
	      // and series data processed. So put it on statistic processing stage.
	
	      registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
	        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	        // allAxesInfo should be updated when setOption performed.
	        ecModel.getComponent('axisPointer').coordSysAxesInfo = collect(ecModel, api);
	      }); // Broadcast to all views.
	
	      registers.registerAction({
	        type: 'updateAxisPointer',
	        event: 'updateAxisPointer',
	        update: ':updateAxisPointer'
	      }, axisTrigger);
	    }
	
	    function install$t(registers) {
	      use(install$5);
	      use(install$s);
	    }
	
	    var PolarAxisPointer =
	    /** @class */
	    function (_super) {
	      __extends(PolarAxisPointer, _super);
	
	      function PolarAxisPointer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	      /**
	       * @override
	       */
	
	
	      PolarAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {
	        var axis = axisModel.axis;
	
	        if (axis.dim === 'angle') {
	          this.animationThreshold = Math.PI / 18;
	        }
	
	        var polar = axis.polar;
	        var otherAxis = polar.getOtherAxis(axis);
	        var otherExtent = otherAxis.getExtent();
	        var coordValue = axis.dataToCoord(value);
	        var axisPointerType = axisPointerModel.get('type');
	
	        if (axisPointerType && axisPointerType !== 'none') {
	          var elStyle = buildElStyle(axisPointerModel);
	          var pointerOption = pointerShapeBuilder$1[axisPointerType](axis, polar, coordValue, otherExtent);
	          pointerOption.style = elStyle;
	          elOption.graphicKey = pointerOption.type;
	          elOption.pointer = pointerOption;
	        }
	
	        var labelMargin = axisPointerModel.get(['label', 'margin']);
	        var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
	        buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
	      };
	
	      return PolarAxisPointer;
	    }(BaseAxisPointer);
	
	    function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
	      var axis = axisModel.axis;
	      var coord = axis.dataToCoord(value);
	      var axisAngle = polar.getAngleAxis().getExtent()[0];
	      axisAngle = axisAngle / 180 * Math.PI;
	      var radiusExtent = polar.getRadiusAxis().getExtent();
	      var position;
	      var align;
	      var verticalAlign;
	
	      if (axis.dim === 'radius') {
	        var transform = create$1();
	        rotate(transform, transform, axisAngle);
	        translate(transform, transform, [polar.cx, polar.cy]);
	        position = applyTransform$1([coord, -labelMargin], transform);
	        var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0; // @ts-ignore
	
	        var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
	        align = labelLayout.textAlign;
	        verticalAlign = labelLayout.textVerticalAlign;
	      } else {
	        // angle axis
	        var r = radiusExtent[1];
	        position = polar.coordToPoint([r + labelMargin, coord]);
	        var cx = polar.cx;
	        var cy = polar.cy;
	        align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
	        verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
	      }
	
	      return {
	        position: position,
	        align: align,
	        verticalAlign: verticalAlign
	      };
	    }
	
	    var pointerShapeBuilder$1 = {
	      line: function (axis, polar, coordValue, otherExtent) {
	        return axis.dim === 'angle' ? {
	          type: 'Line',
	          shape: makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
	        } : {
	          type: 'Circle',
	          shape: {
	            cx: polar.cx,
	            cy: polar.cy,
	            r: coordValue
	          }
	        };
	      },
	      shadow: function (axis, polar, coordValue, otherExtent) {
	        var bandWidth = Math.max(1, axis.getBandWidth());
	        var radian = Math.PI / 180;
	        return axis.dim === 'angle' ? {
	          type: 'Sector',
	          shape: makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
	          (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
	        } : {
	          type: 'Sector',
	          shape: makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
	        };
	      }
	    };
	
	    var PolarModel =
	    /** @class */
	    function (_super) {
	      __extends(PolarModel, _super);
	
	      function PolarModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = PolarModel.type;
	        return _this;
	      }
	
	      PolarModel.prototype.findAxisModel = function (axisType) {
	        var foundAxisModel;
	        var ecModel = this.ecModel;
	        ecModel.eachComponent(axisType, function (axisModel) {
	          if (axisModel.getCoordSysModel() === this) {
	            foundAxisModel = axisModel;
	          }
	        }, this);
	        return foundAxisModel;
	      };
	
	      PolarModel.type = 'polar';
	      PolarModel.dependencies = ['radiusAxis', 'angleAxis'];
	      PolarModel.defaultOption = {
	        // zlevel: 0,
	        z: 0,
	        center: ['50%', '50%'],
	        radius: '80%'
	      };
	      return PolarModel;
	    }(ComponentModel);
	
	    var PolarAxisModel =
	    /** @class */
	    function (_super) {
	      __extends(PolarAxisModel, _super);
	
	      function PolarAxisModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      PolarAxisModel.prototype.getCoordSysModel = function () {
	        return this.getReferringComponents('polar', SINGLE_REFERRING).models[0];
	      };
	
	      PolarAxisModel.type = 'polarAxis';
	      return PolarAxisModel;
	    }(ComponentModel);
	
	    mixin(PolarAxisModel, AxisModelCommonMixin);
	
	    var AngleAxisModel =
	    /** @class */
	    function (_super) {
	      __extends(AngleAxisModel, _super);
	
	      function AngleAxisModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = AngleAxisModel.type;
	        return _this;
	      }
	
	      AngleAxisModel.type = 'angleAxis';
	      return AngleAxisModel;
	    }(PolarAxisModel);
	
	    var RadiusAxisModel =
	    /** @class */
	    function (_super) {
	      __extends(RadiusAxisModel, _super);
	
	      function RadiusAxisModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = RadiusAxisModel.type;
	        return _this;
	      }
	
	      RadiusAxisModel.type = 'radiusAxis';
	      return RadiusAxisModel;
	    }(PolarAxisModel);
	
	    var RadiusAxis =
	    /** @class */
	    function (_super) {
	      __extends(RadiusAxis, _super);
	
	      function RadiusAxis(scale, radiusExtent) {
	        return _super.call(this, 'radius', scale, radiusExtent) || this;
	      }
	
	      RadiusAxis.prototype.pointToData = function (point, clamp) {
	        return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	      };
	
	      return RadiusAxis;
	    }(Axis);
	
	    RadiusAxis.prototype.dataToRadius = Axis.prototype.dataToCoord;
	    RadiusAxis.prototype.radiusToData = Axis.prototype.coordToData;
	
	    var inner$d = makeInner();
	
	    var AngleAxis =
	    /** @class */
	    function (_super) {
	      __extends(AngleAxis, _super);
	
	      function AngleAxis(scale, angleExtent) {
	        return _super.call(this, 'angle', scale, angleExtent || [0, 360]) || this;
	      }
	
	      AngleAxis.prototype.pointToData = function (point, clamp) {
	        return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	      };
	      /**
	       * Only be called in category axis.
	       * Angle axis uses text height to decide interval
	       *
	       * @override
	       * @return {number} Auto interval for cateogry axis tick and label
	       */
	
	
	      AngleAxis.prototype.calculateCategoryInterval = function () {
	        var axis = this;
	        var labelModel = axis.getLabelModel();
	        var ordinalScale = axis.scale;
	        var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	        // avoid generating a long array by `getTicks`
	        // in large category data case.
	
	        var tickCount = ordinalScale.count();
	
	        if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	          return 0;
	        }
	
	        var tickValue = ordinalExtent[0];
	        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	        var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
	        // and each distance from axis line yet.
	
	        var rect = getBoundingRect(tickValue == null ? '' : tickValue + '', labelModel.getFont(), 'center', 'top');
	        var maxH = Math.max(rect.height, 7);
	        var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	        isNaN(dh) && (dh = Infinity);
	        var interval = Math.max(0, Math.floor(dh));
	        var cache = inner$d(axis.model);
	        var lastAutoInterval = cache.lastAutoInterval;
	        var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	        // otherwise the calculated interval might jitter when the zoom
	        // window size is close to the interval-changing size.
	
	        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	        // point is not the same when zooming in or zooming out.
	        && lastAutoInterval > interval) {
	          interval = lastAutoInterval;
	        } // Only update cache if cache not used, otherwise the
	        // changing of interval is too insensitive.
	        else {
	            cache.lastTickCount = tickCount;
	            cache.lastAutoInterval = interval;
	          }
	
	        return interval;
	      };
	
	      return AngleAxis;
	    }(Axis);
	
	    AngleAxis.prototype.dataToAngle = Axis.prototype.dataToCoord;
	    AngleAxis.prototype.angleToData = Axis.prototype.coordToData;
	
	    var polarDimensions = ['radius', 'angle'];
	
	    var Polar =
	    /** @class */
	    function () {
	      function Polar(name) {
	        this.dimensions = polarDimensions;
	        this.type = 'polar';
	        /**
	         * x of polar center
	         */
	
	        this.cx = 0;
	        /**
	         * y of polar center
	         */
	
	        this.cy = 0;
	        this._radiusAxis = new RadiusAxis();
	        this._angleAxis = new AngleAxis();
	        this.axisPointerEnabled = true;
	        this.name = name || '';
	        this._radiusAxis.polar = this._angleAxis.polar = this;
	      }
	      /**
	       * If contain coord
	       */
	
	
	      Polar.prototype.containPoint = function (point) {
	        var coord = this.pointToCoord(point);
	        return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
	      };
	      /**
	       * If contain data
	       */
	
	
	      Polar.prototype.containData = function (data) {
	        return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
	      };
	
	      Polar.prototype.getAxis = function (dim) {
	        var key = '_' + dim + 'Axis';
	        return this[key];
	      };
	
	      Polar.prototype.getAxes = function () {
	        return [this._radiusAxis, this._angleAxis];
	      };
	      /**
	       * Get axes by type of scale
	       */
	
	
	      Polar.prototype.getAxesByScale = function (scaleType) {
	        var axes = [];
	        var angleAxis = this._angleAxis;
	        var radiusAxis = this._radiusAxis;
	        angleAxis.scale.type === scaleType && axes.push(angleAxis);
	        radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
	        return axes;
	      };
	
	      Polar.prototype.getAngleAxis = function () {
	        return this._angleAxis;
	      };
	
	      Polar.prototype.getRadiusAxis = function () {
	        return this._radiusAxis;
	      };
	
	      Polar.prototype.getOtherAxis = function (axis) {
	        var angleAxis = this._angleAxis;
	        return axis === angleAxis ? this._radiusAxis : angleAxis;
	      };
	      /**
	       * Base axis will be used on stacking.
	       *
	       */
	
	
	      Polar.prototype.getBaseAxis = function () {
	        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
	      };
	
	      Polar.prototype.getTooltipAxes = function (dim) {
	        var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
	        return {
	          baseAxes: [baseAxis],
	          otherAxes: [this.getOtherAxis(baseAxis)]
	        };
	      };
	      /**
	       * Convert a single data item to (x, y) point.
	       * Parameter data is an array which the first element is radius and the second is angle
	       */
	
	
	      Polar.prototype.dataToPoint = function (data, clamp) {
	        return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
	      };
	      /**
	       * Convert a (x, y) point to data
	       */
	
	
	      Polar.prototype.pointToData = function (point, clamp) {
	        var coord = this.pointToCoord(point);
	        return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
	      };
	      /**
	       * Convert a (x, y) point to (radius, angle) coord
	       */
	
	
	      Polar.prototype.pointToCoord = function (point) {
	        var dx = point[0] - this.cx;
	        var dy = point[1] - this.cy;
	        var angleAxis = this.getAngleAxis();
	        var extent = angleAxis.getExtent();
	        var minAngle = Math.min(extent[0], extent[1]);
	        var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
	        // FIXME
	
	        angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
	        var radius = Math.sqrt(dx * dx + dy * dy);
	        dx /= radius;
	        dy /= radius;
	        var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent
	
	        var dir = radian < minAngle ? 1 : -1;
	
	        while (radian < minAngle || radian > maxAngle) {
	          radian += dir * 360;
	        }
	
	        return [radius, radian];
	      };
	      /**
	       * Convert a (radius, angle) coord to (x, y) point
	       */
	
	
	      Polar.prototype.coordToPoint = function (coord) {
	        var radius = coord[0];
	        var radian = coord[1] / 180 * Math.PI;
	        var x = Math.cos(radian) * radius + this.cx; // Inverse the y
	
	        var y = -Math.sin(radian) * radius + this.cy;
	        return [x, y];
	      };
	      /**
	       * Get ring area of cartesian.
	       * Area will have a contain function to determine if a point is in the coordinate system.
	       */
	
	
	      Polar.prototype.getArea = function () {
	        var angleAxis = this.getAngleAxis();
	        var radiusAxis = this.getRadiusAxis();
	        var radiusExtent = radiusAxis.getExtent().slice();
	        radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
	        var angleExtent = angleAxis.getExtent();
	        var RADIAN = Math.PI / 180;
	        return {
	          cx: this.cx,
	          cy: this.cy,
	          r0: radiusExtent[0],
	          r: radiusExtent[1],
	          startAngle: -angleExtent[0] * RADIAN,
	          endAngle: -angleExtent[1] * RADIAN,
	          clockwise: angleAxis.inverse,
	          contain: function (x, y) {
	            // It's a ring shape.
	            // Start angle and end angle don't matter
	            var dx = x - this.cx;
	            var dy = y - this.cy; // minus a tiny value 1e-4 to avoid being clipped unexpectedly
	
	            var d2 = dx * dx + dy * dy - 1e-4;
	            var r = this.r;
	            var r0 = this.r0;
	            return d2 <= r * r && d2 >= r0 * r0;
	          }
	        };
	      };
	
	      Polar.prototype.convertToPixel = function (ecModel, finder, value) {
	        var coordSys = getCoordSys$2(finder);
	        return coordSys === this ? this.dataToPoint(value) : null;
	      };
	
	      Polar.prototype.convertFromPixel = function (ecModel, finder, pixel) {
	        var coordSys = getCoordSys$2(finder);
	        return coordSys === this ? this.pointToData(pixel) : null;
	      };
	
	      return Polar;
	    }();
	
	    function getCoordSys$2(finder) {
	      var seriesModel = finder.seriesModel;
	      var polarModel = finder.polarModel;
	      return polarModel && polarModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
	    }
	
	    /**
	     * Resize method bound to the polar
	     */
	
	    function resizePolar(polar, polarModel, api) {
	      var center = polarModel.get('center');
	      var width = api.getWidth();
	      var height = api.getHeight();
	      polar.cx = parsePercent$1(center[0], width);
	      polar.cy = parsePercent$1(center[1], height);
	      var radiusAxis = polar.getRadiusAxis();
	      var size = Math.min(width, height) / 2;
	      var radius = polarModel.get('radius');
	
	      if (radius == null) {
	        radius = [0, '100%'];
	      } else if (!isArray(radius)) {
	        // r0 = 0
	        radius = [0, radius];
	      }
	
	      var parsedRadius = [parsePercent$1(radius[0], size), parsePercent$1(radius[1], size)];
	      radiusAxis.inverse ? radiusAxis.setExtent(parsedRadius[1], parsedRadius[0]) : radiusAxis.setExtent(parsedRadius[0], parsedRadius[1]);
	    }
	    /**
	     * Update polar
	     */
	
	
	    function updatePolarScale(ecModel, api) {
	      var polar = this;
	      var angleAxis = polar.getAngleAxis();
	      var radiusAxis = polar.getRadiusAxis(); // Reset scale
	
	      angleAxis.scale.setExtent(Infinity, -Infinity);
	      radiusAxis.scale.setExtent(Infinity, -Infinity);
	      ecModel.eachSeries(function (seriesModel) {
	        if (seriesModel.coordinateSystem === polar) {
	          var data_1 = seriesModel.getData();
	          each(getDataDimensionsOnAxis(data_1, 'radius'), function (dim) {
	            radiusAxis.scale.unionExtentFromData(data_1, dim);
	          });
	          each(getDataDimensionsOnAxis(data_1, 'angle'), function (dim) {
	            angleAxis.scale.unionExtentFromData(data_1, dim);
	          });
	        }
	      });
	      niceScaleExtent(angleAxis.scale, angleAxis.model);
	      niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis
	
	      if (angleAxis.type === 'category' && !angleAxis.onBand) {
	        var extent = angleAxis.getExtent();
	        var diff = 360 / angleAxis.scale.count();
	        angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
	        angleAxis.setExtent(extent[0], extent[1]);
	      }
	    }
	
	    function isAngleAxisModel(axisModel) {
	      return axisModel.mainType === 'angleAxis';
	    }
	    /**
	     * Set common axis properties
	     */
	
	
	    function setAxis(axis, axisModel) {
	      axis.type = axisModel.get('type');
	      axis.scale = createScaleByModel(axisModel);
	      axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
	      axis.inverse = axisModel.get('inverse');
	
	      if (isAngleAxisModel(axisModel)) {
	        axis.inverse = axis.inverse !== axisModel.get('clockwise');
	        var startAngle = axisModel.get('startAngle');
	        axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
	      } // Inject axis instance
	
	
	      axisModel.axis = axis;
	      axis.model = axisModel;
	    }
	
	    var polarCreator = {
	      dimensions: polarDimensions,
	      create: function (ecModel, api) {
	        var polarList = [];
	        ecModel.eachComponent('polar', function (polarModel, idx) {
	          var polar = new Polar(idx + ''); // Inject resize and update method
	
	          polar.update = updatePolarScale;
	          var radiusAxis = polar.getRadiusAxis();
	          var angleAxis = polar.getAngleAxis();
	          var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	          var angleAxisModel = polarModel.findAxisModel('angleAxis');
	          setAxis(radiusAxis, radiusAxisModel);
	          setAxis(angleAxis, angleAxisModel);
	          resizePolar(polar, polarModel, api);
	          polarList.push(polar);
	          polarModel.coordinateSystem = polar;
	          polar.model = polarModel;
	        }); // Inject coordinateSystem to series
	
	        ecModel.eachSeries(function (seriesModel) {
	          if (seriesModel.get('coordinateSystem') === 'polar') {
	            var polarModel = seriesModel.getReferringComponents('polar', SINGLE_REFERRING).models[0];
	
	            if (true) {
	              if (!polarModel) {
	                throw new Error('Polar "' + retrieve(seriesModel.get('polarIndex'), seriesModel.get('polarId'), 0) + '" not found');
	              }
	            }
	
	            seriesModel.coordinateSystem = polarModel.coordinateSystem;
	          }
	        });
	        return polarList;
	      }
	    };
	
	    var elementList$1 = ['axisLine', 'axisLabel', 'axisTick', 'minorTick', 'splitLine', 'minorSplitLine', 'splitArea'];
	
	    function getAxisLineShape(polar, rExtent, angle) {
	      rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
	      var start = polar.coordToPoint([rExtent[0], angle]);
	      var end = polar.coordToPoint([rExtent[1], angle]);
	      return {
	        x1: start[0],
	        y1: start[1],
	        x2: end[0],
	        y2: end[1]
	      };
	    }
	
	    function getRadiusIdx(polar) {
	      var radiusAxis = polar.getRadiusAxis();
	      return radiusAxis.inverse ? 0 : 1;
	    } // Remove the last tick which will overlap the first tick
	
	
	    function fixAngleOverlap(list) {
	      var firstItem = list[0];
	      var lastItem = list[list.length - 1];
	
	      if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) {
	        list.pop();
	      }
	    }
	
	    var AngleAxisView =
	    /** @class */
	    function (_super) {
	      __extends(AngleAxisView, _super);
	
	      function AngleAxisView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = AngleAxisView.type;
	        _this.axisPointerClass = 'PolarAxisPointer';
	        return _this;
	      }
	
	      AngleAxisView.prototype.render = function (angleAxisModel, ecModel) {
	        this.group.removeAll();
	
	        if (!angleAxisModel.get('show')) {
	          return;
	        }
	
	        var angleAxis = angleAxisModel.axis;
	        var polar = angleAxis.polar;
	        var radiusExtent = polar.getRadiusAxis().getExtent();
	        var ticksAngles = angleAxis.getTicksCoords();
	        var minorTickAngles = angleAxis.getMinorTicksCoords();
	        var labels = map(angleAxis.getViewLabels(), function (labelItem) {
	          labelItem = clone(labelItem);
	          var scale = angleAxis.scale;
	          var tickValue = scale.type === 'ordinal' ? scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
	          labelItem.coord = angleAxis.dataToCoord(tickValue);
	          return labelItem;
	        });
	        fixAngleOverlap(labels);
	        fixAngleOverlap(ticksAngles);
	        each(elementList$1, function (name) {
	          if (angleAxisModel.get([name, 'show']) && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
	            angelAxisElementsBuilders[name](this.group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
	          }
	        }, this);
	      };
	
	      AngleAxisView.type = 'angleAxis';
	      return AngleAxisView;
	    }(AxisView);
	
	    var angelAxisElementsBuilders = {
	      axisLine: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	        var lineStyleModel = angleAxisModel.getModel(['axisLine', 'lineStyle']); // extent id of the axis radius (r0 and r)
	
	        var rId = getRadiusIdx(polar);
	        var r0Id = rId ? 0 : 1;
	        var shape;
	
	        if (radiusExtent[r0Id] === 0) {
	          shape = new Circle({
	            shape: {
	              cx: polar.cx,
	              cy: polar.cy,
	              r: radiusExtent[rId]
	            },
	            style: lineStyleModel.getLineStyle(),
	            z2: 1,
	            silent: true
	          });
	        } else {
	          shape = new Ring({
	            shape: {
	              cx: polar.cx,
	              cy: polar.cy,
	              r: radiusExtent[rId],
	              r0: radiusExtent[r0Id]
	            },
	            style: lineStyleModel.getLineStyle(),
	            z2: 1,
	            silent: true
	          });
	        }
	
	        shape.style.fill = null;
	        group.add(shape);
	      },
	      axisTick: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	        var tickModel = angleAxisModel.getModel('axisTick');
	        var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
	        var radius = radiusExtent[getRadiusIdx(polar)];
	        var lines = map(ticksAngles, function (tickAngleItem) {
	          return new Line({
	            shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngleItem.coord)
	          });
	        });
	        group.add(mergePath$1(lines, {
	          style: defaults(tickModel.getModel('lineStyle').getLineStyle(), {
	            stroke: angleAxisModel.get(['axisLine', 'lineStyle', 'color'])
	          })
	        }));
	      },
	      minorTick: function (group, angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
	        if (!minorTickAngles.length) {
	          return;
	        }
	
	        var tickModel = angleAxisModel.getModel('axisTick');
	        var minorTickModel = angleAxisModel.getModel('minorTick');
	        var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
	        var radius = radiusExtent[getRadiusIdx(polar)];
	        var lines = [];
	
	        for (var i = 0; i < minorTickAngles.length; i++) {
	          for (var k = 0; k < minorTickAngles[i].length; k++) {
	            lines.push(new Line({
	              shape: getAxisLineShape(polar, [radius, radius + tickLen], minorTickAngles[i][k].coord)
	            }));
	          }
	        }
	
	        group.add(mergePath$1(lines, {
	          style: defaults(minorTickModel.getModel('lineStyle').getLineStyle(), defaults(tickModel.getLineStyle(), {
	            stroke: angleAxisModel.get(['axisLine', 'lineStyle', 'color'])
	          }))
	        }));
	      },
	      axisLabel: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
	        var rawCategoryData = angleAxisModel.getCategories(true);
	        var commonLabelModel = angleAxisModel.getModel('axisLabel');
	        var labelMargin = commonLabelModel.get('margin');
	        var triggerEvent = angleAxisModel.get('triggerEvent'); // Use length of ticksAngles because it may remove the last tick to avoid overlapping
	
	        each(labels, function (labelItem, idx) {
	          var labelModel = commonLabelModel;
	          var tickValue = labelItem.tickValue;
	          var r = radiusExtent[getRadiusIdx(polar)];
	          var p = polar.coordToPoint([r + labelMargin, labelItem.coord]);
	          var cx = polar.cx;
	          var cy = polar.cy;
	          var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
	          var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
	
	          if (rawCategoryData && rawCategoryData[tickValue]) {
	            var rawCategoryItem = rawCategoryData[tickValue];
	
	            if (isObject(rawCategoryItem) && rawCategoryItem.textStyle) {
	              labelModel = new Model(rawCategoryItem.textStyle, commonLabelModel, commonLabelModel.ecModel);
	            }
	          }
	
	          var textEl = new ZRText({
	            silent: AxisBuilder.isLabelSilent(angleAxisModel),
	            style: createTextStyle(labelModel, {
	              x: p[0],
	              y: p[1],
	              fill: labelModel.getTextColor() || angleAxisModel.get(['axisLine', 'lineStyle', 'color']),
	              text: labelItem.formattedLabel,
	              align: labelTextAlign,
	              verticalAlign: labelTextVerticalAlign
	            })
	          });
	          group.add(textEl); // Pack data for mouse event
	
	          if (triggerEvent) {
	            var eventData = AxisBuilder.makeAxisEventDataBase(angleAxisModel);
	            eventData.targetType = 'axisLabel';
	            eventData.value = labelItem.rawLabel;
	            getECData(textEl).eventData = eventData;
	          }
	        }, this);
	      },
	      splitLine: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	        var splitLineModel = angleAxisModel.getModel('splitLine');
	        var lineStyleModel = splitLineModel.getModel('lineStyle');
	        var lineColors = lineStyleModel.get('color');
	        var lineCount = 0;
	        lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	        var splitLines = [];
	
	        for (var i = 0; i < ticksAngles.length; i++) {
	          var colorIndex = lineCount++ % lineColors.length;
	          splitLines[colorIndex] = splitLines[colorIndex] || [];
	          splitLines[colorIndex].push(new Line({
	            shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
	          }));
	        } // Simple optimization
	        // Batching the lines if color are the same
	
	
	        for (var i = 0; i < splitLines.length; i++) {
	          group.add(mergePath$1(splitLines[i], {
	            style: defaults({
	              stroke: lineColors[i % lineColors.length]
	            }, lineStyleModel.getLineStyle()),
	            silent: true,
	            z: angleAxisModel.get('z')
	          }));
	        }
	      },
	      minorSplitLine: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	        if (!minorTickAngles.length) {
	          return;
	        }
	
	        var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
	        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	        var lines = [];
	
	        for (var i = 0; i < minorTickAngles.length; i++) {
	          for (var k = 0; k < minorTickAngles[i].length; k++) {
	            lines.push(new Line({
	              shape: getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
	            }));
	          }
	        }
	
	        group.add(mergePath$1(lines, {
	          style: lineStyleModel.getLineStyle(),
	          silent: true,
	          z: angleAxisModel.get('z')
	        }));
	      },
	      splitArea: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	        if (!ticksAngles.length) {
	          return;
	        }
	
	        var splitAreaModel = angleAxisModel.getModel('splitArea');
	        var areaStyleModel = splitAreaModel.getModel('areaStyle');
	        var areaColors = areaStyleModel.get('color');
	        var lineCount = 0;
	        areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	        var splitAreas = [];
	        var RADIAN = Math.PI / 180;
	        var prevAngle = -ticksAngles[0].coord * RADIAN;
	        var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
	        var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
	        var clockwise = angleAxisModel.get('clockwise');
	
	        for (var i = 1, len = ticksAngles.length; i <= len; i++) {
	          var coord = i === len ? ticksAngles[0].coord : ticksAngles[i].coord;
	          var colorIndex = lineCount++ % areaColors.length;
	          splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	          splitAreas[colorIndex].push(new Sector({
	            shape: {
	              cx: polar.cx,
	              cy: polar.cy,
	              r0: r0,
	              r: r1,
	              startAngle: prevAngle,
	              endAngle: -coord * RADIAN,
	              clockwise: clockwise
	            },
	            silent: true
	          }));
	          prevAngle = -coord * RADIAN;
	        } // Simple optimization
	        // Batching the lines if color are the same
	
	
	        for (var i = 0; i < splitAreas.length; i++) {
	          group.add(mergePath$1(splitAreas[i], {
	            style: defaults({
	              fill: areaColors[i % areaColors.length]
	            }, areaStyleModel.getAreaStyle()),
	            silent: true
	          }));
	        }
	      }
	    };
	
	    var axisBuilderAttrs$2 = ['axisLine', 'axisTickLabel', 'axisName'];
	    var selfBuilderAttrs$1 = ['splitLine', 'splitArea', 'minorSplitLine'];
	
	    var RadiusAxisView =
	    /** @class */
	    function (_super) {
	      __extends(RadiusAxisView, _super);
	
	      function RadiusAxisView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = RadiusAxisView.type;
	        _this.axisPointerClass = 'PolarAxisPointer';
	        return _this;
	      }
	
	      RadiusAxisView.prototype.render = function (radiusAxisModel, ecModel) {
	        this.group.removeAll();
	
	        if (!radiusAxisModel.get('show')) {
	          return;
	        }
	
	        var oldAxisGroup = this._axisGroup;
	        var newAxisGroup = this._axisGroup = new Group();
	        this.group.add(newAxisGroup);
	        var radiusAxis = radiusAxisModel.axis;
	        var polar = radiusAxis.polar;
	        var angleAxis = polar.getAngleAxis();
	        var ticksCoords = radiusAxis.getTicksCoords();
	        var minorTicksCoords = radiusAxis.getMinorTicksCoords();
	        var axisAngle = angleAxis.getExtent()[0];
	        var radiusExtent = radiusAxis.getExtent();
	        var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
	        var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
	        each(axisBuilderAttrs$2, axisBuilder.add, axisBuilder);
	        newAxisGroup.add(axisBuilder.getGroup());
	        groupTransition(oldAxisGroup, newAxisGroup, radiusAxisModel);
	        each(selfBuilderAttrs$1, function (name) {
	          if (radiusAxisModel.get([name, 'show']) && !radiusAxis.scale.isBlank()) {
	            axisElementBuilders$1[name](this.group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
	          }
	        }, this);
	      };
	
	      RadiusAxisView.type = 'radiusAxis';
	      return RadiusAxisView;
	    }(AxisView);
	
	    var axisElementBuilders$1 = {
	      splitLine: function (group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	        var splitLineModel = radiusAxisModel.getModel('splitLine');
	        var lineStyleModel = splitLineModel.getModel('lineStyle');
	        var lineColors = lineStyleModel.get('color');
	        var lineCount = 0;
	        lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	        var splitLines = [];
	
	        for (var i = 0; i < ticksCoords.length; i++) {
	          var colorIndex = lineCount++ % lineColors.length;
	          splitLines[colorIndex] = splitLines[colorIndex] || [];
	          splitLines[colorIndex].push(new Circle({
	            shape: {
	              cx: polar.cx,
	              cy: polar.cy,
	              // ensure circle radius >= 0
	              r: Math.max(ticksCoords[i].coord, 0)
	            }
	          }));
	        } // Simple optimization
	        // Batching the lines if color are the same
	
	
	        for (var i = 0; i < splitLines.length; i++) {
	          group.add(mergePath$1(splitLines[i], {
	            style: defaults({
	              stroke: lineColors[i % lineColors.length],
	              fill: null
	            }, lineStyleModel.getLineStyle()),
	            silent: true
	          }));
	        }
	      },
	      minorSplitLine: function (group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
	        if (!minorTicksCoords.length) {
	          return;
	        }
	
	        var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
	        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	        var lines = [];
	
	        for (var i = 0; i < minorTicksCoords.length; i++) {
	          for (var k = 0; k < minorTicksCoords[i].length; k++) {
	            lines.push(new Circle({
	              shape: {
	                cx: polar.cx,
	                cy: polar.cy,
	                r: minorTicksCoords[i][k].coord
	              }
	            }));
	          }
	        }
	
	        group.add(mergePath$1(lines, {
	          style: defaults({
	            fill: null
	          }, lineStyleModel.getLineStyle()),
	          silent: true
	        }));
	      },
	      splitArea: function (group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	        if (!ticksCoords.length) {
	          return;
	        }
	
	        var splitAreaModel = radiusAxisModel.getModel('splitArea');
	        var areaStyleModel = splitAreaModel.getModel('areaStyle');
	        var areaColors = areaStyleModel.get('color');
	        var lineCount = 0;
	        areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	        var splitAreas = [];
	        var prevRadius = ticksCoords[0].coord;
	
	        for (var i = 1; i < ticksCoords.length; i++) {
	          var colorIndex = lineCount++ % areaColors.length;
	          splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	          splitAreas[colorIndex].push(new Sector({
	            shape: {
	              cx: polar.cx,
	              cy: polar.cy,
	              r0: prevRadius,
	              r: ticksCoords[i].coord,
	              startAngle: 0,
	              endAngle: Math.PI * 2
	            },
	            silent: true
	          }));
	          prevRadius = ticksCoords[i].coord;
	        } // Simple optimization
	        // Batching the lines if color are the same
	
	
	        for (var i = 0; i < splitAreas.length; i++) {
	          group.add(mergePath$1(splitAreas[i], {
	            style: defaults({
	              fill: areaColors[i % areaColors.length]
	            }, areaStyleModel.getAreaStyle()),
	            silent: true
	          }));
	        }
	      }
	    };
	    /**
	     * @inner
	     */
	
	    function layoutAxis(polar, radiusAxisModel, axisAngle) {
	      return {
	        position: [polar.cx, polar.cy],
	        rotation: axisAngle / 180 * Math.PI,
	        labelDirection: -1,
	        tickDirection: -1,
	        nameDirection: 1,
	        labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
	        // Over splitLine and splitArea
	        z2: 1
	      };
	    }
	
	    function getSeriesStackId$1(seriesModel) {
	      return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
	    }
	
	    function getAxisKey$1(polar, axis) {
	      return axis.dim + polar.model.componentIndex;
	    }
	
	    function barLayoutPolar(seriesType, ecModel, api) {
	      var lastStackCoords = {};
	      var barWidthAndOffset = calRadialBar(filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
	        return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
	      }));
	      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	        // Check series coordinate, do layout for polar only
	        if (seriesModel.coordinateSystem.type !== 'polar') {
	          return;
	        }
	
	        var data = seriesModel.getData();
	        var polar = seriesModel.coordinateSystem;
	        var baseAxis = polar.getBaseAxis();
	        var axisKey = getAxisKey$1(polar, baseAxis);
	        var stackId = getSeriesStackId$1(seriesModel);
	        var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
	        var columnOffset = columnLayoutInfo.offset;
	        var columnWidth = columnLayoutInfo.width;
	        var valueAxis = polar.getOtherAxis(baseAxis);
	        var cx = seriesModel.coordinateSystem.cx;
	        var cy = seriesModel.coordinateSystem.cy;
	        var barMinHeight = seriesModel.get('barMinHeight') || 0;
	        var barMinAngle = seriesModel.get('barMinAngle') || 0;
	        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	        var valueDim = data.mapDimension(valueAxis.dim);
	        var baseDim = data.mapDimension(baseAxis.dim);
	        var stacked = isDimensionStacked(data, valueDim
	        /* , baseDim */
	        );
	        var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
	        var valueAxisStart = valueAxis.dataToCoord(0);
	
	        for (var idx = 0, len = data.count(); idx < len; idx++) {
	          var value = data.get(valueDim, idx);
	          var baseValue = data.get(baseDim, idx);
	          var sign = value >= 0 ? 'p' : 'n';
	          var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	          // stackResultDimension directly.
	          // Only ordinal axis can be stacked.
	
	          if (stacked) {
	            if (!lastStackCoords[stackId][baseValue]) {
	              lastStackCoords[stackId][baseValue] = {
	                p: valueAxisStart,
	                n: valueAxisStart // Negative stack
	
	              };
	            } // Should also consider #4243
	
	
	            baseCoord = lastStackCoords[stackId][baseValue][sign];
	          }
	
	          var r0 = void 0;
	          var r = void 0;
	          var startAngle = void 0;
	          var endAngle = void 0; // radial sector
	
	          if (valueAxis.dim === 'radius') {
	            var radiusSpan = valueAxis.dataToCoord(value) - valueAxisStart;
	            var angle = baseAxis.dataToCoord(baseValue);
	
	            if (Math.abs(radiusSpan) < barMinHeight) {
	              radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
	            }
	
	            r0 = baseCoord;
	            r = baseCoord + radiusSpan;
	            startAngle = angle - columnOffset;
	            endAngle = startAngle - columnWidth;
	            stacked && (lastStackCoords[stackId][baseValue][sign] = r);
	          } // tangential sector
	          else {
	              var angleSpan = valueAxis.dataToCoord(value, clampLayout) - valueAxisStart;
	              var radius = baseAxis.dataToCoord(baseValue);
	
	              if (Math.abs(angleSpan) < barMinAngle) {
	                angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
	              }
	
	              r0 = radius + columnOffset;
	              r = r0 + columnWidth;
	              startAngle = baseCoord;
	              endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
	              // add a round to differentiate it from origin
	              // let extent = angleAxis.getExtent();
	              // let stackCoord = angle;
	              // if (stackCoord === extent[0] && value > 0) {
	              //     stackCoord = extent[1];
	              // }
	              // else if (stackCoord === extent[1] && value < 0) {
	              //     stackCoord = extent[0];
	              // }
	
	              stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
	            }
	
	          data.setItemLayout(idx, {
	            cx: cx,
	            cy: cy,
	            r0: r0,
	            r: r,
	            // Consider that positive angle is anti-clockwise,
	            // while positive radian of sector is clockwise
	            startAngle: -startAngle * Math.PI / 180,
	            endAngle: -endAngle * Math.PI / 180,
	
	            /**
	             * Keep the same logic with bar in catesion: use end value to
	             * control direction. Notice that if clockwise is true (by
	             * default), the sector will always draw clockwisely, no matter
	             * whether endAngle is greater or less than startAngle.
	             */
	            clockwise: startAngle >= endAngle
	          });
	        }
	      });
	    }
	    /**
	     * Calculate bar width and offset for radial bar charts
	     */
	
	
	    function calRadialBar(barSeries) {
	      // Columns info on each category axis. Key is polar name
	      var columnsMap = {};
	      each(barSeries, function (seriesModel, idx) {
	        var data = seriesModel.getData();
	        var polar = seriesModel.coordinateSystem;
	        var baseAxis = polar.getBaseAxis();
	        var axisKey = getAxisKey$1(polar, baseAxis);
	        var axisExtent = baseAxis.getExtent();
	        var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	        var columnsOnAxis = columnsMap[axisKey] || {
	          bandWidth: bandWidth,
	          remainedWidth: bandWidth,
	          autoWidthCount: 0,
	          categoryGap: '20%',
	          gap: '30%',
	          stacks: {}
	        };
	        var stacks = columnsOnAxis.stacks;
	        columnsMap[axisKey] = columnsOnAxis;
	        var stackId = getSeriesStackId$1(seriesModel);
	
	        if (!stacks[stackId]) {
	          columnsOnAxis.autoWidthCount++;
	        }
	
	        stacks[stackId] = stacks[stackId] || {
	          width: 0,
	          maxWidth: 0
	        };
	        var barWidth = parsePercent$1(seriesModel.get('barWidth'), bandWidth);
	        var barMaxWidth = parsePercent$1(seriesModel.get('barMaxWidth'), bandWidth);
	        var barGap = seriesModel.get('barGap');
	        var barCategoryGap = seriesModel.get('barCategoryGap');
	
	        if (barWidth && !stacks[stackId].width) {
	          barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	          stacks[stackId].width = barWidth;
	          columnsOnAxis.remainedWidth -= barWidth;
	        }
	
	        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	        barGap != null && (columnsOnAxis.gap = barGap);
	        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	      });
	      var result = {};
	      each(columnsMap, function (columnsOnAxis, coordSysName) {
	        result[coordSysName] = {};
	        var stacks = columnsOnAxis.stacks;
	        var bandWidth = columnsOnAxis.bandWidth;
	        var categoryGap = parsePercent$1(columnsOnAxis.categoryGap, bandWidth);
	        var barGapPercent = parsePercent$1(columnsOnAxis.gap, 1);
	        var remainedWidth = columnsOnAxis.remainedWidth;
	        var autoWidthCount = columnsOnAxis.autoWidthCount;
	        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	        autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	        each(stacks, function (column, stack) {
	          var maxWidth = column.maxWidth;
	
	          if (maxWidth && maxWidth < autoWidth) {
	            maxWidth = Math.min(maxWidth, remainedWidth);
	
	            if (column.width) {
	              maxWidth = Math.min(maxWidth, column.width);
	            }
	
	            remainedWidth -= maxWidth;
	            column.width = maxWidth;
	            autoWidthCount--;
	          }
	        }); // Recalculate width again
	
	        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	        autoWidth = Math.max(autoWidth, 0);
	        var widthSum = 0;
	        var lastColumn;
	        each(stacks, function (column, idx) {
	          if (!column.width) {
	            column.width = autoWidth;
	          }
	
	          lastColumn = column;
	          widthSum += column.width * (1 + barGapPercent);
	        });
	
	        if (lastColumn) {
	          widthSum -= lastColumn.width * barGapPercent;
	        }
	
	        var offset = -widthSum / 2;
	        each(stacks, function (column, stackId) {
	          result[coordSysName][stackId] = result[coordSysName][stackId] || {
	            offset: offset,
	            width: column.width
	          };
	          offset += column.width * (1 + barGapPercent);
	        });
	      });
	      return result;
	    }
	
	    var angleAxisExtraOption = {
	      startAngle: 90,
	      clockwise: true,
	      splitNumber: 12,
	      axisLabel: {
	        rotate: 0
	      }
	    };
	    var radiusAxisExtraOption = {
	      splitNumber: 5
	    };
	
	    var PolarView =
	    /** @class */
	    function (_super) {
	      __extends(PolarView, _super);
	
	      function PolarView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = PolarView.type;
	        return _this;
	      }
	
	      PolarView.type = 'polar';
	      return PolarView;
	    }(ComponentView);
	
	    function install$u(registers) {
	      use(install$s);
	      AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
	      registers.registerCoordinateSystem('polar', polarCreator);
	      registers.registerComponentModel(PolarModel);
	      registers.registerComponentView(PolarView); // Model and view for angleAxis and radiusAxis
	
	      axisModelCreator(registers, 'angle', AngleAxisModel, angleAxisExtraOption);
	      axisModelCreator(registers, 'radius', RadiusAxisModel, radiusAxisExtraOption);
	      registers.registerComponentView(AngleAxisView);
	      registers.registerComponentView(RadiusAxisView);
	      registers.registerLayout(curry(barLayoutPolar, 'bar'));
	    }
	
	    function layout$2(axisModel, opt) {
	      opt = opt || {};
	      var single = axisModel.coordinateSystem;
	      var axis = axisModel.axis;
	      var layout = {};
	      var axisPosition = axis.position;
	      var orient = axis.orient;
	      var rect = single.getRect();
	      var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	      var positionMap = {
	        horizontal: {
	          top: rectBound[2],
	          bottom: rectBound[3]
	        },
	        vertical: {
	          left: rectBound[0],
	          right: rectBound[1]
	        }
	      };
	      layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
	      var r = {
	        horizontal: 0,
	        vertical: 1
	      };
	      layout.rotation = Math.PI / 2 * r[orient];
	      var directionMap = {
	        top: -1,
	        bottom: 1,
	        right: 1,
	        left: -1
	      };
	      layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
	
	      if (axisModel.get(['axisTick', 'inside'])) {
	        layout.tickDirection = -layout.tickDirection;
	      }
	
	      if (retrieve(opt.labelInside, axisModel.get(['axisLabel', 'inside']))) {
	        layout.labelDirection = -layout.labelDirection;
	      }
	
	      var labelRotation = opt.rotate;
	      labelRotation == null && (labelRotation = axisModel.get(['axisLabel', 'rotate']));
	      layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
	      layout.z2 = 1;
	      return layout;
	    }
	
	    var axisBuilderAttrs$3 = ['axisLine', 'axisTickLabel', 'axisName'];
	    var selfBuilderAttrs$2 = ['splitArea', 'splitLine'];
	
	    var SingleAxisView =
	    /** @class */
	    function (_super) {
	      __extends(SingleAxisView, _super);
	
	      function SingleAxisView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SingleAxisView.type;
	        _this.axisPointerClass = 'SingleAxisPointer';
	        return _this;
	      }
	
	      SingleAxisView.prototype.render = function (axisModel, ecModel, api, payload) {
	        var group = this.group;
	        group.removeAll();
	        var oldAxisGroup = this._axisGroup;
	        this._axisGroup = new Group();
	        var layout = layout$2(axisModel);
	        var axisBuilder = new AxisBuilder(axisModel, layout);
	        each(axisBuilderAttrs$3, axisBuilder.add, axisBuilder);
	        group.add(this._axisGroup);
	        group.add(axisBuilder.getGroup());
	        each(selfBuilderAttrs$2, function (name) {
	          if (axisModel.get([name, 'show'])) {
	            axisElementBuilders$2[name](this, this.group, this._axisGroup, axisModel);
	          }
	        }, this);
	        groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	
	        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
	      };
	
	      SingleAxisView.prototype.remove = function () {
	        rectCoordAxisHandleRemove(this);
	      };
	
	      SingleAxisView.type = 'singleAxis';
	      return SingleAxisView;
	    }(AxisView);
	
	    var axisElementBuilders$2 = {
	      splitLine: function (axisView, group, axisGroup, axisModel) {
	        var axis = axisModel.axis;
	
	        if (axis.scale.isBlank()) {
	          return;
	        }
	
	        var splitLineModel = axisModel.getModel('splitLine');
	        var lineStyleModel = splitLineModel.getModel('lineStyle');
	        var lineColors = lineStyleModel.get('color');
	        lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	        var lineWidth = lineStyleModel.get('width');
	        var gridRect = axisModel.coordinateSystem.getRect();
	        var isHorizontal = axis.isHorizontal();
	        var splitLines = [];
	        var lineCount = 0;
	        var ticksCoords = axis.getTicksCoords({
	          tickModel: splitLineModel
	        });
	        var p1 = [];
	        var p2 = [];
	
	        for (var i = 0; i < ticksCoords.length; ++i) {
	          var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	          if (isHorizontal) {
	            p1[0] = tickCoord;
	            p1[1] = gridRect.y;
	            p2[0] = tickCoord;
	            p2[1] = gridRect.y + gridRect.height;
	          } else {
	            p1[0] = gridRect.x;
	            p1[1] = tickCoord;
	            p2[0] = gridRect.x + gridRect.width;
	            p2[1] = tickCoord;
	          }
	
	          var line = new Line({
	            shape: {
	              x1: p1[0],
	              y1: p1[1],
	              x2: p2[0],
	              y2: p2[1]
	            },
	            silent: true
	          });
	          subPixelOptimizeLine$1(line.shape, lineWidth);
	          var colorIndex = lineCount++ % lineColors.length;
	          splitLines[colorIndex] = splitLines[colorIndex] || [];
	          splitLines[colorIndex].push(line);
	        }
	
	        var lineStyle = lineStyleModel.getLineStyle(['color']);
	
	        for (var i = 0; i < splitLines.length; ++i) {
	          group.add(mergePath$1(splitLines[i], {
	            style: defaults({
	              stroke: lineColors[i % lineColors.length]
	            }, lineStyle),
	            silent: true
	          }));
	        }
	      },
	      splitArea: function (axisView, group, axisGroup, axisModel) {
	        rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, axisModel);
	      }
	    };
	
	    var SingleAxisModel =
	    /** @class */
	    function (_super) {
	      __extends(SingleAxisModel, _super);
	
	      function SingleAxisModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SingleAxisModel.type;
	        return _this;
	      }
	
	      SingleAxisModel.prototype.getCoordSysModel = function () {
	        return this;
	      };
	
	      SingleAxisModel.type = 'singleAxis';
	      SingleAxisModel.layoutMode = 'box';
	      SingleAxisModel.defaultOption = {
	        left: '5%',
	        top: '5%',
	        right: '5%',
	        bottom: '5%',
	        type: 'value',
	        position: 'bottom',
	        orient: 'horizontal',
	        axisLine: {
	          show: true,
	          lineStyle: {
	            width: 1,
	            type: 'solid'
	          }
	        },
	        // Single coordinate system and single axis is the,
	        // which is used as the parent tooltip model.
	        // same model, so we set default tooltip show as true.
	        tooltip: {
	          show: true
	        },
	        axisTick: {
	          show: true,
	          length: 6,
	          lineStyle: {
	            width: 1
	          }
	        },
	        axisLabel: {
	          show: true,
	          interval: 'auto'
	        },
	        splitLine: {
	          show: true,
	          lineStyle: {
	            type: 'dashed',
	            opacity: 0.2
	          }
	        }
	      };
	      return SingleAxisModel;
	    }(ComponentModel);
	
	    mixin(SingleAxisModel, AxisModelCommonMixin.prototype);
	
	    var SingleAxis =
	    /** @class */
	    function (_super) {
	      __extends(SingleAxis, _super);
	
	      function SingleAxis(dim, scale, coordExtent, axisType, position) {
	        var _this = _super.call(this, dim, scale, coordExtent) || this;
	
	        _this.type = axisType || 'value';
	        _this.position = position || 'bottom';
	        return _this;
	      }
	      /**
	       * Judge the orient of the axis.
	       */
	
	
	      SingleAxis.prototype.isHorizontal = function () {
	        var position = this.position;
	        return position === 'top' || position === 'bottom';
	      };
	
	      SingleAxis.prototype.pointToData = function (point, clamp) {
	        return this.coordinateSystem.pointToData(point)[0];
	      };
	
	      return SingleAxis;
	    }(Axis);
	
	    var singleDimensions = ['single'];
	    /**
	     * Create a single coordinates system.
	     */
	
	    var Single =
	    /** @class */
	    function () {
	      function Single(axisModel, ecModel, api) {
	        this.type = 'single';
	        this.dimension = 'single';
	        /**
	         * Add it just for draw tooltip.
	         */
	
	        this.dimensions = singleDimensions;
	        this.axisPointerEnabled = true;
	        this.model = axisModel;
	
	        this._init(axisModel, ecModel, api);
	      }
	      /**
	       * Initialize single coordinate system.
	       */
	
	
	      Single.prototype._init = function (axisModel, ecModel, api) {
	        var dim = this.dimension;
	        var axis = new SingleAxis(dim, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
	        var isCategory = axis.type === 'category';
	        axis.onBand = isCategory && axisModel.get('boundaryGap');
	        axis.inverse = axisModel.get('inverse');
	        axis.orient = axisModel.get('orient');
	        axisModel.axis = axis;
	        axis.model = axisModel;
	        axis.coordinateSystem = this;
	        this._axis = axis;
	      };
	      /**
	       * Update axis scale after data processed
	       */
	
	
	      Single.prototype.update = function (ecModel, api) {
	        ecModel.eachSeries(function (seriesModel) {
	          if (seriesModel.coordinateSystem === this) {
	            var data_1 = seriesModel.getData();
	            each(data_1.mapDimensionsAll(this.dimension), function (dim) {
	              this._axis.scale.unionExtentFromData(data_1, dim);
	            }, this);
	            niceScaleExtent(this._axis.scale, this._axis.model);
	          }
	        }, this);
	      };
	      /**
	       * Resize the single coordinate system.
	       */
	
	
	      Single.prototype.resize = function (axisModel, api) {
	        this._rect = getLayoutRect({
	          left: axisModel.get('left'),
	          top: axisModel.get('top'),
	          right: axisModel.get('right'),
	          bottom: axisModel.get('bottom'),
	          width: axisModel.get('width'),
	          height: axisModel.get('height')
	        }, {
	          width: api.getWidth(),
	          height: api.getHeight()
	        });
	
	        this._adjustAxis();
	      };
	
	      Single.prototype.getRect = function () {
	        return this._rect;
	      };
	
	      Single.prototype._adjustAxis = function () {
	        var rect = this._rect;
	        var axis = this._axis;
	        var isHorizontal = axis.isHorizontal();
	        var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
	        var idx = axis.inverse ? 1 : 0;
	        axis.setExtent(extent[idx], extent[1 - idx]);
	
	        this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
	      };
	
	      Single.prototype._updateAxisTransform = function (axis, coordBase) {
	        var axisExtent = axis.getExtent();
	        var extentSum = axisExtent[0] + axisExtent[1];
	        var isHorizontal = axis.isHorizontal();
	        axis.toGlobalCoord = isHorizontal ? function (coord) {
	          return coord + coordBase;
	        } : function (coord) {
	          return extentSum - coord + coordBase;
	        };
	        axis.toLocalCoord = isHorizontal ? function (coord) {
	          return coord - coordBase;
	        } : function (coord) {
	          return extentSum - coord + coordBase;
	        };
	      };
	      /**
	       * Get axis.
	       */
	
	
	      Single.prototype.getAxis = function () {
	        return this._axis;
	      };
	      /**
	       * Get axis, add it just for draw tooltip.
	       */
	
	
	      Single.prototype.getBaseAxis = function () {
	        return this._axis;
	      };
	
	      Single.prototype.getAxes = function () {
	        return [this._axis];
	      };
	
	      Single.prototype.getTooltipAxes = function () {
	        return {
	          baseAxes: [this.getAxis()],
	          // Empty otherAxes
	          otherAxes: []
	        };
	      };
	      /**
	       * If contain point.
	       */
	
	
	      Single.prototype.containPoint = function (point) {
	        var rect = this.getRect();
	        var axis = this.getAxis();
	        var orient = axis.orient;
	
	        if (orient === 'horizontal') {
	          return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
	        } else {
	          return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
	        }
	      };
	
	      Single.prototype.pointToData = function (point) {
	        var axis = this.getAxis();
	        return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
	      };
	      /**
	       * Convert the series data to concrete point.
	       * Can be [val] | val
	       */
	
	
	      Single.prototype.dataToPoint = function (val) {
	        var axis = this.getAxis();
	        var rect = this.getRect();
	        var pt = [];
	        var idx = axis.orient === 'horizontal' ? 0 : 1;
	
	        if (val instanceof Array) {
	          val = val[0];
	        }
	
	        pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
	        pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
	        return pt;
	      };
	
	      Single.prototype.convertToPixel = function (ecModel, finder, value) {
	        var coordSys = getCoordSys$3(finder);
	        return coordSys === this ? this.dataToPoint(value) : null;
	      };
	
	      Single.prototype.convertFromPixel = function (ecModel, finder, pixel) {
	        var coordSys = getCoordSys$3(finder);
	        return coordSys === this ? this.pointToData(pixel) : null;
	      };
	
	      return Single;
	    }();
	
	    function getCoordSys$3(finder) {
	      var seriesModel = finder.seriesModel;
	      var singleModel = finder.singleAxisModel;
	      return singleModel && singleModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
	    }
	
	    /**
	     * Create single coordinate system and inject it into seriesModel.
	     */
	
	    function create$2(ecModel, api) {
	      var singles = [];
	      ecModel.eachComponent('singleAxis', function (axisModel, idx) {
	        var single = new Single(axisModel, ecModel, api);
	        single.name = 'single_' + idx;
	        single.resize(axisModel, api);
	        axisModel.coordinateSystem = single;
	        singles.push(single);
	      });
	      ecModel.eachSeries(function (seriesModel) {
	        if (seriesModel.get('coordinateSystem') === 'singleAxis') {
	          var singleAxisModel = seriesModel.getReferringComponents('singleAxis', SINGLE_REFERRING).models[0];
	          seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
	        }
	      });
	      return singles;
	    }
	
	    var singleCreator = {
	      create: create$2,
	      dimensions: singleDimensions
	    };
	
	    var XY = ['x', 'y'];
	    var WH = ['width', 'height'];
	
	    var SingleAxisPointer =
	    /** @class */
	    function (_super) {
	      __extends(SingleAxisPointer, _super);
	
	      function SingleAxisPointer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	      /**
	       * @override
	       */
	
	
	      SingleAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {
	        var axis = axisModel.axis;
	        var coordSys = axis.coordinateSystem;
	        var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
	        var pixelValue = coordSys.dataToPoint(value)[0];
	        var axisPointerType = axisPointerModel.get('type');
	
	        if (axisPointerType && axisPointerType !== 'none') {
	          var elStyle = buildElStyle(axisPointerModel);
	          var pointerOption = pointerShapeBuilder$2[axisPointerType](axis, pixelValue, otherExtent);
	          pointerOption.style = elStyle;
	          elOption.graphicKey = pointerOption.type;
	          elOption.pointer = pointerOption;
	        }
	
	        var layoutInfo = layout$2(axisModel);
	        buildCartesianSingleLabelElOption( // @ts-ignore
	        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	      };
	      /**
	       * @override
	       */
	
	
	      SingleAxisPointer.prototype.getHandleTransform = function (value, axisModel, axisPointerModel) {
	        var layoutInfo = layout$2(axisModel, {
	          labelInside: false
	        }); // @ts-ignore
	
	        layoutInfo.labelMargin = axisPointerModel.get(['handle', 'margin']);
	        var position = getTransformedPosition(axisModel.axis, value, layoutInfo);
	        return {
	          x: position[0],
	          y: position[1],
	          rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	        };
	      };
	      /**
	       * @override
	       */
	
	
	      SingleAxisPointer.prototype.updateHandleTransform = function (transform, delta, axisModel, axisPointerModel) {
	        var axis = axisModel.axis;
	        var coordSys = axis.coordinateSystem;
	        var dimIndex = getPointDimIndex(axis);
	        var axisExtent = getGlobalExtent(coordSys, dimIndex);
	        var currPosition = [transform.x, transform.y];
	        currPosition[dimIndex] += delta[dimIndex];
	        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	        var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
	        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	        var cursorPoint = [cursorOtherValue, cursorOtherValue];
	        cursorPoint[dimIndex] = currPosition[dimIndex];
	        return {
	          x: currPosition[0],
	          y: currPosition[1],
	          rotation: transform.rotation,
	          cursorPoint: cursorPoint,
	          tooltipOption: {
	            verticalAlign: 'middle'
	          }
	        };
	      };
	
	      return SingleAxisPointer;
	    }(BaseAxisPointer);
	
	    var pointerShapeBuilder$2 = {
	      line: function (axis, pixelValue, otherExtent) {
	        var targetShape = makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
	        return {
	          type: 'Line',
	          subPixelOptimize: true,
	          shape: targetShape
	        };
	      },
	      shadow: function (axis, pixelValue, otherExtent) {
	        var bandWidth = axis.getBandWidth();
	        var span = otherExtent[1] - otherExtent[0];
	        return {
	          type: 'Rect',
	          shape: makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
	        };
	      }
	    };
	
	    function getPointDimIndex(axis) {
	      return axis.isHorizontal() ? 0 : 1;
	    }
	
	    function getGlobalExtent(coordSys, dimIndex) {
	      var rect = coordSys.getRect();
	      return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
	    }
	
	    var SingleView =
	    /** @class */
	    function (_super) {
	      __extends(SingleView, _super);
	
	      function SingleView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SingleView.type;
	        return _this;
	      }
	
	      SingleView.type = 'single';
	      return SingleView;
	    }(ComponentView);
	
	    function install$v(registers) {
	      use(install$s);
	      AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
	      registers.registerComponentView(SingleView); // Axis
	
	      registers.registerComponentView(SingleAxisView);
	      registers.registerComponentModel(SingleAxisModel);
	      axisModelCreator(registers, 'single', SingleAxisModel, SingleAxisModel.defaultOption);
	      registers.registerCoordinateSystem('single', singleCreator);
	    }
	
	    var CalendarModel =
	    /** @class */
	    function (_super) {
	      __extends(CalendarModel, _super);
	
	      function CalendarModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = CalendarModel.type;
	        return _this;
	      }
	      /**
	       * @override
	       */
	
	
	      CalendarModel.prototype.init = function (option, parentModel, ecModel) {
	        var inputPositionParams = getLayoutParams(option);
	
	        _super.prototype.init.apply(this, arguments);
	
	        mergeAndNormalizeLayoutParams(option, inputPositionParams);
	      };
	      /**
	       * @override
	       */
	
	
	      CalendarModel.prototype.mergeOption = function (option) {
	        _super.prototype.mergeOption.apply(this, arguments);
	
	        mergeAndNormalizeLayoutParams(this.option, option);
	      };
	
	      CalendarModel.prototype.getCellSize = function () {
	        // Has been normalized
	        return this.option.cellSize;
	      };
	
	      CalendarModel.type = 'calendar';
	      CalendarModel.defaultOption = {
	        // zlevel: 0,
	        z: 2,
	        left: 80,
	        top: 60,
	        cellSize: 20,
	        // horizontal vertical
	        orient: 'horizontal',
	        // month separate line style
	        splitLine: {
	          show: true,
	          lineStyle: {
	            color: '#000',
	            width: 1,
	            type: 'solid'
	          }
	        },
	        // rect style  temporarily unused emphasis
	        itemStyle: {
	          color: '#fff',
	          borderWidth: 1,
	          borderColor: '#ccc'
	        },
	        // week text style
	        dayLabel: {
	          show: true,
	          firstDay: 0,
	          // start end
	          position: 'start',
	          margin: '50%',
	          color: '#000'
	        },
	        // month text style
	        monthLabel: {
	          show: true,
	          // start end
	          position: 'start',
	          margin: 5,
	          // center or left
	          align: 'center',
	          formatter: null,
	          color: '#000'
	        },
	        // year text style
	        yearLabel: {
	          show: true,
	          // top bottom left right
	          position: null,
	          margin: 30,
	          formatter: null,
	          color: '#ccc',
	          fontFamily: 'sans-serif',
	          fontWeight: 'bolder',
	          fontSize: 20
	        }
	      };
	      return CalendarModel;
	    }(ComponentModel);
	
	    function mergeAndNormalizeLayoutParams(target, raw) {
	      // Normalize cellSize
	      var cellSize = target.cellSize;
	      var cellSizeArr;
	
	      if (!isArray(cellSize)) {
	        cellSizeArr = target.cellSize = [cellSize, cellSize];
	      } else {
	        cellSizeArr = cellSize;
	      }
	
	      if (cellSizeArr.length === 1) {
	        cellSizeArr[1] = cellSizeArr[0];
	      }
	
	      var ignoreSize = map([0, 1], function (hvIdx) {
	        // If user have set `width` or both `left` and `right`, cellSizeArr
	        // will be automatically set to 'auto', otherwise the default
	        // setting of cellSizeArr will make `width` setting not work.
	        if (sizeCalculable(raw, hvIdx)) {
	          cellSizeArr[hvIdx] = 'auto';
	        }
	
	        return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== 'auto';
	      });
	      mergeLayoutParam(target, raw, {
	        type: 'box',
	        ignoreSize: ignoreSize
	      });
	    }
	
	    var CalendarView =
	    /** @class */
	    function (_super) {
	      __extends(CalendarView, _super);
	
	      function CalendarView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = CalendarView.type;
	        return _this;
	      }
	
	      CalendarView.prototype.render = function (calendarModel, ecModel, api) {
	        var group = this.group;
	        group.removeAll();
	        var coordSys = calendarModel.coordinateSystem; // range info
	
	        var rangeData = coordSys.getRangeInfo();
	        var orient = coordSys.getOrient(); // locale
	
	        var localeModel = ecModel.getLocaleModel();
	
	        this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function
	
	
	        this._renderLines(calendarModel, rangeData, orient, group);
	
	        this._renderYearText(calendarModel, rangeData, orient, group);
	
	        this._renderMonthText(calendarModel, localeModel, orient, group);
	
	        this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
	      }; // render day rect
	
	
	      CalendarView.prototype._renderDayRect = function (calendarModel, rangeData, group) {
	        var coordSys = calendarModel.coordinateSystem;
	        var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
	        var sw = coordSys.getCellWidth();
	        var sh = coordSys.getCellHeight();
	
	        for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
	          var point = coordSys.dataToRect([i], false).tl; // every rect
	
	          var rect = new Rect({
	            shape: {
	              x: point[0],
	              y: point[1],
	              width: sw,
	              height: sh
	            },
	            cursor: 'default',
	            style: itemRectStyleModel
	          });
	          group.add(rect);
	        }
	      }; // render separate line
	
	
	      CalendarView.prototype._renderLines = function (calendarModel, rangeData, orient, group) {
	        var self = this;
	        var coordSys = calendarModel.coordinateSystem;
	        var lineStyleModel = calendarModel.getModel(['splitLine', 'lineStyle']).getLineStyle();
	        var show = calendarModel.get(['splitLine', 'show']);
	        var lineWidth = lineStyleModel.lineWidth;
	        this._tlpoints = [];
	        this._blpoints = [];
	        this._firstDayOfMonth = [];
	        this._firstDayPoints = [];
	        var firstDay = rangeData.start;
	
	        for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
	          addPoints(firstDay.formatedDate);
	
	          if (i === 0) {
	            firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
	          }
	
	          var date = firstDay.date;
	          date.setMonth(date.getMonth() + 1);
	          firstDay = coordSys.getDateInfo(date);
	        }
	
	        addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
	
	        function addPoints(date) {
	          self._firstDayOfMonth.push(coordSys.getDateInfo(date));
	
	          self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);
	
	          var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
	
	          self._tlpoints.push(points[0]);
	
	          self._blpoints.push(points[points.length - 1]);
	
	          show && self._drawSplitline(points, lineStyleModel, group);
	        } // render top/left line
	
	
	        show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line
	
	        show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
	      }; // get points at both ends
	
	
	      CalendarView.prototype._getEdgesPoints = function (points, lineWidth, orient) {
	        var rs = [points[0].slice(), points[points.length - 1].slice()];
	        var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth
	
	        rs[0][idx] = rs[0][idx] - lineWidth / 2;
	        rs[1][idx] = rs[1][idx] + lineWidth / 2;
	        return rs;
	      }; // render split line
	
	
	      CalendarView.prototype._drawSplitline = function (points, lineStyle, group) {
	        var poyline = new Polyline({
	          z2: 20,
	          shape: {
	            points: points
	          },
	          style: lineStyle
	        });
	        group.add(poyline);
	      }; // render month line of one week points
	
	
	      CalendarView.prototype._getLinePointsOfOneWeek = function (calendarModel, date, orient) {
	        var coordSys = calendarModel.coordinateSystem;
	        var parsedDate = coordSys.getDateInfo(date);
	        var points = [];
	
	        for (var i = 0; i < 7; i++) {
	          var tmpD = coordSys.getNextNDay(parsedDate.time, i);
	          var point = coordSys.dataToRect([tmpD.time], false);
	          points[2 * tmpD.day] = point.tl;
	          points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
	        }
	
	        return points;
	      };
	
	      CalendarView.prototype._formatterLabel = function (formatter, params) {
	        if (isString(formatter) && formatter) {
	          return formatTplSimple(formatter, params);
	        }
	
	        if (isFunction(formatter)) {
	          return formatter(params);
	        }
	
	        return params.nameMap;
	      };
	
	      CalendarView.prototype._yearTextPositionControl = function (textEl, point, orient, position, margin) {
	        var x = point[0];
	        var y = point[1];
	        var aligns = ['center', 'bottom'];
	
	        if (position === 'bottom') {
	          y += margin;
	          aligns = ['center', 'top'];
	        } else if (position === 'left') {
	          x -= margin;
	        } else if (position === 'right') {
	          x += margin;
	          aligns = ['center', 'top'];
	        } else {
	          // top
	          y -= margin;
	        }
	
	        var rotate = 0;
	
	        if (position === 'left' || position === 'right') {
	          rotate = Math.PI / 2;
	        }
	
	        return {
	          rotation: rotate,
	          x: x,
	          y: y,
	          style: {
	            align: aligns[0],
	            verticalAlign: aligns[1]
	          }
	        };
	      }; // render year
	
	
	      CalendarView.prototype._renderYearText = function (calendarModel, rangeData, orient, group) {
	        var yearLabel = calendarModel.getModel('yearLabel');
	
	        if (!yearLabel.get('show')) {
	          return;
	        }
	
	        var margin = yearLabel.get('margin');
	        var pos = yearLabel.get('position');
	
	        if (!pos) {
	          pos = orient !== 'horizontal' ? 'top' : 'left';
	        }
	
	        var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
	        var xc = (points[0][0] + points[1][0]) / 2;
	        var yc = (points[0][1] + points[1][1]) / 2;
	        var idx = orient === 'horizontal' ? 0 : 1;
	        var posPoints = {
	          top: [xc, points[idx][1]],
	          bottom: [xc, points[1 - idx][1]],
	          left: [points[1 - idx][0], yc],
	          right: [points[idx][0], yc]
	        };
	        var name = rangeData.start.y;
	
	        if (+rangeData.end.y > +rangeData.start.y) {
	          name = name + '-' + rangeData.end.y;
	        }
	
	        var formatter = yearLabel.get('formatter');
	        var params = {
	          start: rangeData.start.y,
	          end: rangeData.end.y,
	          nameMap: name
	        };
	
	        var content = this._formatterLabel(formatter, params);
	
	        var yearText = new ZRText({
	          z2: 30,
	          style: createTextStyle(yearLabel, {
	            text: content
	          })
	        });
	        yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
	        group.add(yearText);
	      };
	
	      CalendarView.prototype._monthTextPositionControl = function (point, isCenter, orient, position, margin) {
	        var align = 'left';
	        var vAlign = 'top';
	        var x = point[0];
	        var y = point[1];
	
	        if (orient === 'horizontal') {
	          y = y + margin;
	
	          if (isCenter) {
	            align = 'center';
	          }
	
	          if (position === 'start') {
	            vAlign = 'bottom';
	          }
	        } else {
	          x = x + margin;
	
	          if (isCenter) {
	            vAlign = 'middle';
	          }
	
	          if (position === 'start') {
	            align = 'right';
	          }
	        }
	
	        return {
	          x: x,
	          y: y,
	          align: align,
	          verticalAlign: vAlign
	        };
	      }; // render month and year text
	
	
	      CalendarView.prototype._renderMonthText = function (calendarModel, localeModel, orient, group) {
	        var monthLabel = calendarModel.getModel('monthLabel');
	
	        if (!monthLabel.get('show')) {
	          return;
	        }
	
	        var nameMap = monthLabel.get('nameMap');
	        var margin = monthLabel.get('margin');
	        var pos = monthLabel.get('position');
	        var align = monthLabel.get('align');
	        var termPoints = [this._tlpoints, this._blpoints];
	
	        if (!nameMap || isString(nameMap)) {
	          if (nameMap) {
	            // case-sensitive
	            localeModel = getLocaleModel(nameMap) || localeModel;
	          } // PENDING
	          // for ZH locale, original form is `一月` but current form is `1月`
	
	
	          nameMap = localeModel.get(['time', 'monthAbbr']) || [];
	        }
	
	        var idx = pos === 'start' ? 0 : 1;
	        var axis = orient === 'horizontal' ? 0 : 1;
	        margin = pos === 'start' ? -margin : margin;
	        var isCenter = align === 'center';
	
	        for (var i = 0; i < termPoints[idx].length - 1; i++) {
	          var tmp = termPoints[idx][i].slice();
	          var firstDay = this._firstDayOfMonth[i];
	
	          if (isCenter) {
	            var firstDayPoints = this._firstDayPoints[i];
	            tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
	          }
	
	          var formatter = monthLabel.get('formatter');
	          var name_1 = nameMap[+firstDay.m - 1];
	          var params = {
	            yyyy: firstDay.y,
	            yy: (firstDay.y + '').slice(2),
	            MM: firstDay.m,
	            M: +firstDay.m,
	            nameMap: name_1
	          };
	
	          var content = this._formatterLabel(formatter, params);
	
	          var monthText = new ZRText({
	            z2: 30,
	            style: extend(createTextStyle(monthLabel, {
	              text: content
	            }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin))
	          });
	          group.add(monthText);
	        }
	      };
	
	      CalendarView.prototype._weekTextPositionControl = function (point, orient, position, margin, cellSize) {
	        var align = 'center';
	        var vAlign = 'middle';
	        var x = point[0];
	        var y = point[1];
	        var isStart = position === 'start';
	
	        if (orient === 'horizontal') {
	          x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
	          align = isStart ? 'right' : 'left';
	        } else {
	          y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
	          vAlign = isStart ? 'bottom' : 'top';
	        }
	
	        return {
	          x: x,
	          y: y,
	          align: align,
	          verticalAlign: vAlign
	        };
	      }; // render weeks
	
	
	      CalendarView.prototype._renderWeekText = function (calendarModel, localeModel, rangeData, orient, group) {
	        var dayLabel = calendarModel.getModel('dayLabel');
	
	        if (!dayLabel.get('show')) {
	          return;
	        }
	
	        var coordSys = calendarModel.coordinateSystem;
	        var pos = dayLabel.get('position');
	        var nameMap = dayLabel.get('nameMap');
	        var margin = dayLabel.get('margin');
	        var firstDayOfWeek = coordSys.getFirstDayOfWeek();
	
	        if (!nameMap || isString(nameMap)) {
	          if (nameMap) {
	            // case-sensitive
	            localeModel = getLocaleModel(nameMap) || localeModel;
	          } // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file
	
	
	          var dayOfWeekShort = localeModel.get(['time', 'dayOfWeekShort']);
	          nameMap = dayOfWeekShort || map(localeModel.get(['time', 'dayOfWeekAbbr']), function (val) {
	            return val[0];
	          });
	        }
	
	        var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
	        var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
	        margin = parsePercent$1(margin, Math.min(cellSize[1], cellSize[0]));
	
	        if (pos === 'start') {
	          start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
	          margin = -margin;
	        }
	
	        for (var i = 0; i < 7; i++) {
	          var tmpD = coordSys.getNextNDay(start, i);
	          var point = coordSys.dataToRect([tmpD.time], false).center;
	          var day = i;
	          day = Math.abs((i + firstDayOfWeek) % 7);
	          var weekText = new ZRText({
	            z2: 30,
	            style: extend(createTextStyle(dayLabel, {
	              text: nameMap[day]
	            }), this._weekTextPositionControl(point, orient, pos, margin, cellSize))
	          });
	          group.add(weekText);
	        }
	      };
	
	      CalendarView.type = 'calendar';
	      return CalendarView;
	    }(ComponentView);
	
	    var PROXIMATE_ONE_DAY = 86400000;
	
	    var Calendar =
	    /** @class */
	    function () {
	      function Calendar(calendarModel, ecModel, api) {
	        this.type = 'calendar';
	        this.dimensions = Calendar.dimensions; // Required in createListFromData
	
	        this.getDimensionsInfo = Calendar.getDimensionsInfo;
	        this._model = calendarModel;
	      }
	
	      Calendar.getDimensionsInfo = function () {
	        return [{
	          name: 'time',
	          type: 'time'
	        }, 'value'];
	      };
	
	      Calendar.prototype.getRangeInfo = function () {
	        return this._rangeInfo;
	      };
	
	      Calendar.prototype.getModel = function () {
	        return this._model;
	      };
	
	      Calendar.prototype.getRect = function () {
	        return this._rect;
	      };
	
	      Calendar.prototype.getCellWidth = function () {
	        return this._sw;
	      };
	
	      Calendar.prototype.getCellHeight = function () {
	        return this._sh;
	      };
	
	      Calendar.prototype.getOrient = function () {
	        return this._orient;
	      };
	      /**
	       * getFirstDayOfWeek
	       *
	       * @example
	       *     0 : start at Sunday
	       *     1 : start at Monday
	       *
	       * @return {number}
	       */
	
	
	      Calendar.prototype.getFirstDayOfWeek = function () {
	        return this._firstDayOfWeek;
	      };
	      /**
	       * get date info
	       * }
	       */
	
	
	      Calendar.prototype.getDateInfo = function (date) {
	        date = parseDate(date);
	        var y = date.getFullYear();
	        var m = date.getMonth() + 1;
	        var mStr = m < 10 ? '0' + m : '' + m;
	        var d = date.getDate();
	        var dStr = d < 10 ? '0' + d : '' + d;
	        var day = date.getDay();
	        day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
	        return {
	          y: y + '',
	          m: mStr,
	          d: dStr,
	          day: day,
	          time: date.getTime(),
	          formatedDate: y + '-' + mStr + '-' + dStr,
	          date: date
	        };
	      };
	
	      Calendar.prototype.getNextNDay = function (date, n) {
	        n = n || 0;
	
	        if (n === 0) {
	          return this.getDateInfo(date);
	        }
	
	        date = new Date(this.getDateInfo(date).time);
	        date.setDate(date.getDate() + n);
	        return this.getDateInfo(date);
	      };
	
	      Calendar.prototype.update = function (ecModel, api) {
	        this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
	        this._orient = this._model.get('orient');
	        this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
	        this._rangeInfo = this._getRangeInfo(this._initRangeOption());
	        var weeks = this._rangeInfo.weeks || 1;
	        var whNames = ['width', 'height'];
	
	        var cellSize = this._model.getCellSize().slice();
	
	        var layoutParams = this._model.getBoxLayoutParams();
	
	        var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
	        each([0, 1], function (idx) {
	          if (cellSizeSpecified(cellSize, idx)) {
	            layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
	          }
	        });
	        var whGlobal = {
	          width: api.getWidth(),
	          height: api.getHeight()
	        };
	        var calendarRect = this._rect = getLayoutRect(layoutParams, whGlobal);
	        each([0, 1], function (idx) {
	          if (!cellSizeSpecified(cellSize, idx)) {
	            cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
	          }
	        });
	
	        function cellSizeSpecified(cellSize, idx) {
	          return cellSize[idx] != null && cellSize[idx] !== 'auto';
	        } // Has been calculated out number.
	
	
	        this._sw = cellSize[0];
	        this._sh = cellSize[1];
	      };
	      /**
	       * Convert a time data(time, value) item to (x, y) point.
	       */
	      // TODO Clamp of calendar is not same with cartesian coordinate systems.
	      // It will return NaN if data exceeds.
	
	
	      Calendar.prototype.dataToPoint = function (data, clamp) {
	        isArray(data) && (data = data[0]);
	        clamp == null && (clamp = true);
	        var dayInfo = this.getDateInfo(data);
	        var range = this._rangeInfo;
	        var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]
	
	        if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + PROXIMATE_ONE_DAY)) {
	          return [NaN, NaN];
	        }
	
	        var week = dayInfo.day;
	
	        var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;
	
	        if (this._orient === 'vertical') {
	          return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
	        }
	
	        return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
	      };
	      /**
	       * Convert a (x, y) point to time data
	       */
	
	
	      Calendar.prototype.pointToData = function (point) {
	        var date = this.pointToDate(point);
	        return date && date.time;
	      };
	      /**
	       * Convert a time date item to (x, y) four point.
	       */
	
	
	      Calendar.prototype.dataToRect = function (data, clamp) {
	        var point = this.dataToPoint(data, clamp);
	        return {
	          contentShape: {
	            x: point[0] - (this._sw - this._lineWidth) / 2,
	            y: point[1] - (this._sh - this._lineWidth) / 2,
	            width: this._sw - this._lineWidth,
	            height: this._sh - this._lineWidth
	          },
	          center: point,
	          tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
	          tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
	          br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
	          bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
	        };
	      };
	      /**
	       * Convert a (x, y) point to time date
	       *
	       * @param  {Array} point point
	       * @return {Object}       date
	       */
	
	
	      Calendar.prototype.pointToDate = function (point) {
	        var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
	        var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
	        var range = this._rangeInfo.range;
	
	        if (this._orient === 'vertical') {
	          return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
	        }
	
	        return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
	      };
	
	      Calendar.prototype.convertToPixel = function (ecModel, finder, value) {
	        var coordSys = getCoordSys$4(finder);
	        return coordSys === this ? coordSys.dataToPoint(value) : null;
	      };
	
	      Calendar.prototype.convertFromPixel = function (ecModel, finder, pixel) {
	        var coordSys = getCoordSys$4(finder);
	        return coordSys === this ? coordSys.pointToData(pixel) : null;
	      };
	
	      Calendar.prototype.containPoint = function (point) {
	        console.warn('Not implemented.');
	        return false;
	      };
	      /**
	       * initRange
	       * Normalize to an [start, end] array
	       */
	
	
	      Calendar.prototype._initRangeOption = function () {
	        var range = this._model.get('range');
	
	        var normalizedRange; // Convert [1990] to 1990
	
	        if (isArray(range) && range.length === 1) {
	          range = range[0];
	        }
	
	        if (!isArray(range)) {
	          var rangeStr = range.toString(); // One year.
	
	          if (/^\d{4}$/.test(rangeStr)) {
	            normalizedRange = [rangeStr + '-01-01', rangeStr + '-12-31'];
	          } // One month
	
	
	          if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
	            var start = this.getDateInfo(rangeStr);
	            var firstDay = start.date;
	            firstDay.setMonth(firstDay.getMonth() + 1);
	            var end = this.getNextNDay(firstDay, -1);
	            normalizedRange = [start.formatedDate, end.formatedDate];
	          } // One day
	
	
	          if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) {
	            normalizedRange = [rangeStr, rangeStr];
	          }
	        } else {
	          normalizedRange = range;
	        }
	
	        if (!normalizedRange) {
	          if (true) {
	            logError('Invalid date range.');
	          } // Not handling it.
	
	
	          return range;
	        }
	
	        var tmp = this._getRangeInfo(normalizedRange);
	
	        if (tmp.start.time > tmp.end.time) {
	          normalizedRange.reverse();
	        }
	
	        return normalizedRange;
	      };
	      /**
	       * range info
	       *
	       * @private
	       * @param  {Array} range range ['2017-01-01', '2017-07-08']
	       *  If range[0] > range[1], they will not be reversed.
	       * @return {Object}       obj
	       */
	
	
	      Calendar.prototype._getRangeInfo = function (range) {
	        var parsedRange = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
	        var reversed;
	
	        if (parsedRange[0].time > parsedRange[1].time) {
	          reversed = true;
	          parsedRange.reverse();
	        }
	
	        var allDay = Math.floor(parsedRange[1].time / PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case1 (#11677 #10430):
	        // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
	        // Consider case2:
	        // Firstly set system timezone as "Time Zone: America/Toronto",
	        // ```
	        // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
	        // let second = new Date(1478412000000);
	        // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
	        // ```
	        // will get wrong result because of DST. So we should fix it.
	
	        var date = new Date(parsedRange[0].time);
	        var startDateNum = date.getDate();
	        var endDateNum = parsedRange[1].date.getDate();
	        date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.
	
	        var dateNum = date.getDate();
	
	        if (dateNum !== endDateNum) {
	          var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;
	
	          while ((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0) {
	            allDay -= sign;
	            date.setDate(dateNum - sign);
	          }
	        }
	
	        var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
	        var nthWeek = reversed ? -weeks + 1 : weeks - 1;
	        reversed && parsedRange.reverse();
	        return {
	          range: [parsedRange[0].formatedDate, parsedRange[1].formatedDate],
	          start: parsedRange[0],
	          end: parsedRange[1],
	          allDay: allDay,
	          weeks: weeks,
	          // From 0.
	          nthWeek: nthWeek,
	          fweek: parsedRange[0].day,
	          lweek: parsedRange[1].day
	        };
	      };
	      /**
	       * get date by nthWeeks and week day in range
	       *
	       * @private
	       * @param  {number} nthWeek the week
	       * @param  {number} day   the week day
	       * @param  {Array} range [d1, d2]
	       * @return {Object}
	       */
	
	
	      Calendar.prototype._getDateByWeeksAndDay = function (nthWeek, day, range) {
	        var rangeInfo = this._getRangeInfo(range);
	
	        if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
	          return null;
	        }
	
	        var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
	        var date = new Date(rangeInfo.start.time);
	        date.setDate(+rangeInfo.start.d + nthDay);
	        return this.getDateInfo(date);
	      };
	
	      Calendar.create = function (ecModel, api) {
	        var calendarList = [];
	        ecModel.eachComponent('calendar', function (calendarModel) {
	          var calendar = new Calendar(calendarModel, ecModel, api);
	          calendarList.push(calendar);
	          calendarModel.coordinateSystem = calendar;
	        });
	        ecModel.eachSeries(function (calendarSeries) {
	          if (calendarSeries.get('coordinateSystem') === 'calendar') {
	            // Inject coordinate system
	            calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
	          }
	        });
	        return calendarList;
	      };
	
	      Calendar.dimensions = ['time', 'value'];
	      return Calendar;
	    }();
	
	    function getCoordSys$4(finder) {
	      var calendarModel = finder.calendarModel;
	      var seriesModel = finder.seriesModel;
	      var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
	      return coordSys;
	    }
	
	    function install$w(registers) {
	      registers.registerComponentModel(CalendarModel);
	      registers.registerComponentView(CalendarView);
	      registers.registerCoordinateSystem('calendar', Calendar);
	    }
	
	    function setKeyInfoToNewElOption(resultItem, newElOption) {
	      var existElOption = resultItem.existing; // Set id and type after id assigned.
	
	      newElOption.id = resultItem.keyInfo.id;
	      !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified
	
	      if (newElOption.parentId == null) {
	        var newElParentOption = newElOption.parentOption;
	
	        if (newElParentOption) {
	          newElOption.parentId = newElParentOption.id;
	        } else if (existElOption) {
	          newElOption.parentId = existElOption.parentId;
	        }
	      } // Clear
	
	
	      newElOption.parentOption = null;
	    }
	
	    function isSetLoc(obj, props) {
	      var isSet;
	      each(props, function (prop) {
	        obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
	      });
	      return isSet;
	    }
	
	    function mergeNewElOptionToExist(existList, index, newElOption) {
	      // Update existing options, for `getOption` feature.
	      var newElOptCopy = extend({}, newElOption);
	      var existElOption = existList[index];
	      var $action = newElOption.$action || 'merge';
	
	      if ($action === 'merge') {
	        if (existElOption) {
	          if (true) {
	            var newType = newElOption.type;
	            assert(!newType || existElOption.type === newType, 'Please set $action: "replace" to change `type`');
	          } // We can ensure that newElOptCopy and existElOption are not
	          // the same object, so `merge` will not change newElOptCopy.
	
	
	          merge(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.
	
	          mergeLayoutParam(existElOption, newElOptCopy, {
	            ignoreSize: true
	          }); // Will be used in render.
	
	          copyLayoutParams(newElOption, existElOption); // Copy transition info to new option so it can be used in the transition.
	          // DO IT AFTER merge
	
	          copyTransitionInfo(newElOption, existElOption);
	          copyTransitionInfo(newElOption, existElOption, 'shape');
	          copyTransitionInfo(newElOption, existElOption, 'style');
	          copyTransitionInfo(newElOption, existElOption, 'extra'); // Copy clipPath
	
	          newElOption.clipPath = existElOption.clipPath;
	        } else {
	          existList[index] = newElOptCopy;
	        }
	      } else if ($action === 'replace') {
	        existList[index] = newElOptCopy;
	      } else if ($action === 'remove') {
	        // null will be cleaned later.
	        existElOption && (existList[index] = null);
	      }
	    }
	
	    var TRANSITION_PROPS_TO_COPY = ['transition', 'enterFrom', 'leaveTo'];
	    var ROOT_TRANSITION_PROPS_TO_COPY = TRANSITION_PROPS_TO_COPY.concat(['enterAnimation', 'updateAnimation', 'leaveAnimation']);
	
	    function copyTransitionInfo(target, source, targetProp) {
	      if (targetProp) {
	        if (!target[targetProp] && source[targetProp]) {
	          // TODO avoid creating this empty object when there is no transition configuration.
	          target[targetProp] = {};
	        }
	
	        target = target[targetProp];
	        source = source[targetProp];
	      }
	
	      if (!target || !source) {
	        return;
	      }
	
	      var props = targetProp ? TRANSITION_PROPS_TO_COPY : ROOT_TRANSITION_PROPS_TO_COPY;
	
	      for (var i = 0; i < props.length; i++) {
	        var prop = props[i];
	
	        if (target[prop] == null && source[prop] != null) {
	          target[prop] = source[prop];
	        }
	      }
	    }
	
	    function setLayoutInfoToExist(existItem, newElOption) {
	      if (!existItem) {
	        return;
	      }
	
	      existItem.hv = newElOption.hv = [// Rigid body, don't care about `width`.
	      isSetLoc(newElOption, ['left', 'right']), // Rigid body, don't care about `height`.
	      isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.
	
	      if (existItem.type === 'group') {
	        var existingGroupOpt = existItem;
	        var newGroupOpt = newElOption;
	        existingGroupOpt.width == null && (existingGroupOpt.width = newGroupOpt.width = 0);
	        existingGroupOpt.height == null && (existingGroupOpt.height = newGroupOpt.height = 0);
	      }
	    }
	
	    var GraphicComponentModel =
	    /** @class */
	    function (_super) {
	      __extends(GraphicComponentModel, _super);
	
	      function GraphicComponentModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = GraphicComponentModel.type;
	        _this.preventAutoZ = true;
	        return _this;
	      }
	
	      GraphicComponentModel.prototype.mergeOption = function (option, ecModel) {
	        // Prevent default merge to elements
	        var elements = this.option.elements;
	        this.option.elements = null;
	
	        _super.prototype.mergeOption.call(this, option, ecModel);
	
	        this.option.elements = elements;
	      };
	
	      GraphicComponentModel.prototype.optionUpdated = function (newOption, isInit) {
	        var thisOption = this.option;
	        var newList = (isInit ? thisOption : newOption).elements;
	        var existList = thisOption.elements = isInit ? [] : thisOption.elements;
	        var flattenedList = [];
	
	        this._flatten(newList, flattenedList, null);
	
	        var mappingResult = mappingToExists(existList, flattenedList, 'normalMerge'); // Clear elOptionsToUpdate
	
	        var elOptionsToUpdate = this._elOptionsToUpdate = [];
	        each(mappingResult, function (resultItem, index) {
	          var newElOption = resultItem.newOption;
	
	          if (true) {
	            assert(isObject(newElOption) || resultItem.existing, 'Empty graphic option definition');
	          }
	
	          if (!newElOption) {
	            return;
	          }
	
	          elOptionsToUpdate.push(newElOption);
	          setKeyInfoToNewElOption(resultItem, newElOption);
	          mergeNewElOptionToExist(existList, index, newElOption);
	          setLayoutInfoToExist(existList[index], newElOption);
	        }, this); // Clean
	
	        thisOption.elements = filter(existList, function (item) {
	          // $action should be volatile, otherwise option gotten from
	          // `getOption` will contain unexpected $action.
	          item && delete item.$action;
	          return item != null;
	        });
	      };
	      /**
	       * Convert
	       * [{
	       *  type: 'group',
	       *  id: 'xx',
	       *  children: [{type: 'circle'}, {type: 'polygon'}]
	       * }]
	       * to
	       * [
	       *  {type: 'group', id: 'xx'},
	       *  {type: 'circle', parentId: 'xx'},
	       *  {type: 'polygon', parentId: 'xx'}
	       * ]
	       */
	
	
	      GraphicComponentModel.prototype._flatten = function (optionList, result, parentOption) {
	        each(optionList, function (option) {
	          if (!option) {
	            return;
	          }
	
	          if (parentOption) {
	            option.parentOption = parentOption;
	          }
	
	          result.push(option);
	          var children = option.children; // here we don't judge if option.type is `group`
	          // when new option doesn't provide `type`, it will cause that the children can't be updated.
	
	          if (children && children.length) {
	            this._flatten(children, result, option);
	          } // Deleting for JSON output, and for not affecting group creation.
	
	
	          delete option.children;
	        }, this);
	      }; // FIXME
	      // Pass to view using payload? setOption has a payload?
	
	
	      GraphicComponentModel.prototype.useElOptionsToUpdate = function () {
	        var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.
	
	        this._elOptionsToUpdate = null;
	        return els;
	      };
	
	      GraphicComponentModel.type = 'graphic';
	      GraphicComponentModel.defaultOption = {
	        elements: [] // parentId: null
	
	      };
	      return GraphicComponentModel;
	    }(ComponentModel);
	
	    var nonShapeGraphicElements = {
	      // Reserved but not supported in graphic component.
	      path: null,
	      compoundPath: null,
	      // Supported in graphic component.
	      group: Group,
	      image: ZRImage,
	      text: ZRText
	    };
	    var inner$e = makeInner(); // ------------------------
	    // View
	    // ------------------------
	
	    var GraphicComponentView =
	    /** @class */
	    function (_super) {
	      __extends(GraphicComponentView, _super);
	
	      function GraphicComponentView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = GraphicComponentView.type;
	        return _this;
	      }
	
	      GraphicComponentView.prototype.init = function () {
	        this._elMap = createHashMap();
	      };
	
	      GraphicComponentView.prototype.render = function (graphicModel, ecModel, api) {
	        // Having leveraged between use cases and algorithm complexity, a very
	        // simple layout mechanism is used:
	        // The size(width/height) can be determined by itself or its parent (not
	        // implemented yet), but can not by its children. (Top-down travel)
	        // The location(x/y) can be determined by the bounding rect of itself
	        // (can including its descendants or not) and the size of its parent.
	        // (Bottom-up travel)
	        // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
	        // view will be reused.
	        if (graphicModel !== this._lastGraphicModel) {
	          this._clear();
	        }
	
	        this._lastGraphicModel = graphicModel;
	
	        this._updateElements(graphicModel);
	
	        this._relocate(graphicModel, api);
	      };
	      /**
	       * Update graphic elements.
	       */
	
	
	      GraphicComponentView.prototype._updateElements = function (graphicModel) {
	        var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
	
	        if (!elOptionsToUpdate) {
	          return;
	        }
	
	        var elMap = this._elMap;
	        var rootGroup = this.group;
	        var globalZ = graphicModel.get('z');
	        var globalZLevel = graphicModel.get('zlevel'); // Top-down tranverse to assign graphic settings to each elements.
	
	        each(elOptionsToUpdate, function (elOption) {
	          var id = convertOptionIdName(elOption.id, null);
	          var elExisting = id != null ? elMap.get(id) : null;
	          var parentId = convertOptionIdName(elOption.parentId, null);
	          var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
	          var elType = elOption.type;
	          var elOptionStyle = elOption.style;
	
	          if (elType === 'text' && elOptionStyle) {
	            // In top/bottom mode, textVerticalAlign should not be used, which cause
	            // inaccurately locating.
	            if (elOption.hv && elOption.hv[1]) {
	              elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = elOptionStyle.verticalAlign = elOptionStyle.align = null;
	            }
	          }
	
	          var textContentOption = elOption.textContent;
	          var textConfig = elOption.textConfig;
	
	          if (elOptionStyle && isEC4CompatibleStyle(elOptionStyle, elType, !!textConfig, !!textContentOption)) {
	            var convertResult = convertFromEC4CompatibleStyle(elOptionStyle, elType, true);
	
	            if (!textConfig && convertResult.textConfig) {
	              textConfig = elOption.textConfig = convertResult.textConfig;
	            }
	
	            if (!textContentOption && convertResult.textContent) {
	              textContentOption = convertResult.textContent;
	            }
	          } // Remove unnecessary props to avoid potential problems.
	
	
	          var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.
	
	          if (true) {
	            elExisting && assert(targetElParent === elExisting.parent, 'Changing parent is not supported.');
	          }
	
	          var $action = elOption.$action || 'merge';
	          var isMerge = $action === 'merge';
	          var isReplace = $action === 'replace';
	
	          if (isMerge) {
	            var isInit = !elExisting;
	            var el_1 = elExisting;
	
	            if (isInit) {
	              el_1 = createEl$1(id, targetElParent, elOption.type, elMap);
	            } else {
	              el_1 && (inner$e(el_1).isNew = false); // Stop and restore before update any other attributes.
	
	              stopPreviousKeyframeAnimationAndRestore(el_1);
	            }
	
	            if (el_1) {
	              applyUpdateTransition(el_1, elOptionCleaned, graphicModel, {
	                isInit: isInit
	              });
	              updateCommonAttrs(el_1, elOption, globalZ, globalZLevel);
	            }
	          } else if (isReplace) {
	            removeEl(elExisting, elOption, elMap, graphicModel);
	            var el_2 = createEl$1(id, targetElParent, elOption.type, elMap);
	
	            if (el_2) {
	              applyUpdateTransition(el_2, elOptionCleaned, graphicModel, {
	                isInit: true
	              });
	              updateCommonAttrs(el_2, elOption, globalZ, globalZLevel);
	            }
	          } else if ($action === 'remove') {
	            updateLeaveTo(elExisting, elOption);
	            removeEl(elExisting, elOption, elMap, graphicModel);
	          }
	
	          var el = elMap.get(id);
	
	          if (el && textContentOption) {
	            if (isMerge) {
	              var textContentExisting = el.getTextContent();
	              textContentExisting ? textContentExisting.attr(textContentOption) : el.setTextContent(new ZRText(textContentOption));
	            } else if (isReplace) {
	              el.setTextContent(new ZRText(textContentOption));
	            }
	          }
	
	          if (el) {
	            var clipPathOption = elOption.clipPath;
	
	            if (clipPathOption) {
	              var clipPathType = clipPathOption.type;
	              var clipPath = void 0;
	              var isInit = false;
	
	              if (isMerge) {
	                var oldClipPath = el.getClipPath();
	                isInit = !oldClipPath || inner$e(oldClipPath).type !== clipPathType;
	                clipPath = isInit ? newEl(clipPathType) : oldClipPath;
	              } else if (isReplace) {
	                isInit = true;
	                clipPath = newEl(clipPathType);
	              }
	
	              el.setClipPath(clipPath);
	              applyUpdateTransition(clipPath, clipPathOption, graphicModel, {
	                isInit: isInit
	              });
	              applyKeyframeAnimation(clipPath, clipPathOption.keyframeAnimation, graphicModel);
	            }
	
	            var elInner = inner$e(el);
	            el.setTextConfig(textConfig);
	            elInner.option = elOption;
	            setEventData(el, graphicModel, elOption);
	            setTooltipConfig({
	              el: el,
	              componentModel: graphicModel,
	              itemName: el.name,
	              itemTooltipOption: elOption.tooltip
	            });
	            applyKeyframeAnimation(el, elOption.keyframeAnimation, graphicModel);
	          }
	        });
	      };
	      /**
	       * Locate graphic elements.
	       */
	
	
	      GraphicComponentView.prototype._relocate = function (graphicModel, api) {
	        var elOptions = graphicModel.option.elements;
	        var rootGroup = this.group;
	        var elMap = this._elMap;
	        var apiWidth = api.getWidth();
	        var apiHeight = api.getHeight();
	        var xy = ['x', 'y']; // Top-down to calculate percentage width/height of group
	
	        for (var i = 0; i < elOptions.length; i++) {
	          var elOption = elOptions[i];
	          var id = convertOptionIdName(elOption.id, null);
	          var el = id != null ? elMap.get(id) : null;
	
	          if (!el || !el.isGroup) {
	            continue;
	          }
	
	          var parentEl = el.parent;
	          var isParentRoot = parentEl === rootGroup; // Like 'position:absolut' in css, default 0.
	
	          var elInner = inner$e(el);
	          var parentElInner = inner$e(parentEl);
	          elInner.width = parsePercent$1(elInner.option.width, isParentRoot ? apiWidth : parentElInner.width) || 0;
	          elInner.height = parsePercent$1(elInner.option.height, isParentRoot ? apiHeight : parentElInner.height) || 0;
	        } // Bottom-up tranvese all elements (consider ec resize) to locate elements.
	
	
	        for (var i = elOptions.length - 1; i >= 0; i--) {
	          var elOption = elOptions[i];
	          var id = convertOptionIdName(elOption.id, null);
	          var el = id != null ? elMap.get(id) : null;
	
	          if (!el) {
	            continue;
	          }
	
	          var parentEl = el.parent;
	          var parentElInner = inner$e(parentEl);
	          var containerInfo = parentEl === rootGroup ? {
	            width: apiWidth,
	            height: apiHeight
	          } : {
	            width: parentElInner.width,
	            height: parentElInner.height
	          }; // PENDING
	          // Currently, when `bounding: 'all'`, the union bounding rect of the group
	          // does not include the rect of [0, 0, group.width, group.height], which
	          // is probably weird for users. Should we make a break change for it?
	
	          var layoutPos = {};
	          var layouted = positionElement(el, elOption, containerInfo, null, {
	            hv: elOption.hv,
	            boundingMode: elOption.bounding
	          }, layoutPos);
	
	          if (!inner$e(el).isNew && layouted) {
	            var transition = elOption.transition;
	            var animatePos = {};
	
	            for (var k = 0; k < xy.length; k++) {
	              var key = xy[k];
	              var val = layoutPos[key];
	
	              if (transition && (isTransitionAll(transition) || indexOf(transition, key) >= 0)) {
	                animatePos[key] = val;
	              } else {
	                el[key] = val;
	              }
	            }
	
	            updateProps(el, animatePos, graphicModel, 0);
	          } else {
	            el.attr(layoutPos);
	          }
	        }
	      };
	      /**
	       * Clear all elements.
	       */
	
	
	      GraphicComponentView.prototype._clear = function () {
	        var _this = this;
	
	        var elMap = this._elMap;
	        elMap.each(function (el) {
	          removeEl(el, inner$e(el).option, elMap, _this._lastGraphicModel);
	        });
	        this._elMap = createHashMap();
	      };
	
	      GraphicComponentView.prototype.dispose = function () {
	        this._clear();
	      };
	
	      GraphicComponentView.type = 'graphic';
	      return GraphicComponentView;
	    }(ComponentView);
	
	    function newEl(graphicType) {
	      if (true) {
	        assert(graphicType, 'graphic type MUST be set');
	      }
	
	      var Clz = hasOwn(nonShapeGraphicElements, graphicType) // Those graphic elements are not shapes. They should not be
	      // overwritten by users, so do them first.
	      ? nonShapeGraphicElements[graphicType] : getShapeClass(graphicType);
	
	      if (true) {
	        assert(Clz, "graphic type " + graphicType + " can not be found");
	      }
	
	      var el = new Clz({});
	      inner$e(el).type = graphicType;
	      return el;
	    }
	
	    function createEl$1(id, targetElParent, graphicType, elMap) {
	      var el = newEl(graphicType);
	      targetElParent.add(el);
	      elMap.set(id, el);
	      inner$e(el).id = id;
	      inner$e(el).isNew = true;
	      return el;
	    }
	
	    function removeEl(elExisting, elOption, elMap, graphicModel) {
	      var existElParent = elExisting && elExisting.parent;
	
	      if (existElParent) {
	        elExisting.type === 'group' && elExisting.traverse(function (el) {
	          removeEl(el, elOption, elMap, graphicModel);
	        });
	        applyLeaveTransition(elExisting, elOption, graphicModel);
	        elMap.removeKey(inner$e(elExisting).id);
	      }
	    }
	
	    function updateCommonAttrs(el, elOption, defaultZ, defaultZlevel) {
	      if (!el.isGroup) {
	        each([['cursor', Displayable.prototype.cursor], // We should not support configure z and zlevel in the element level.
	        // But seems we didn't limit it previously. So here still use it to avoid breaking.
	        ['zlevel', defaultZlevel || 0], ['z', defaultZ || 0], // z2 must not be null/undefined, otherwise sort error may occur.
	        ['z2', 0]], function (item) {
	          var prop = item[0];
	
	          if (hasOwn(elOption, prop)) {
	            el[prop] = retrieve2(elOption[prop], item[1]);
	          } else if (el[prop] == null) {
	            el[prop] = item[1];
	          }
	        });
	      }
	
	      each(keys(elOption), function (key) {
	        // Assign event handlers.
	        // PENDING: should enumerate all event names or use pattern matching?
	        if (key.indexOf('on') === 0) {
	          var val = elOption[key];
	          el[key] = isFunction(val) ? val : null;
	        }
	      });
	
	      if (hasOwn(elOption, 'draggable')) {
	        el.draggable = elOption.draggable;
	      } // Other attributes
	
	
	      elOption.name != null && (el.name = elOption.name);
	      elOption.id != null && (el.id = elOption.id);
	    } // Remove unnecessary props to avoid potential problems.
	
	
	    function getCleanedElOption(elOption) {
	      elOption = extend({}, elOption);
	      each(['id', 'parentId', '$action', 'hv', 'bounding', 'textContent', 'clipPath'].concat(LOCATION_PARAMS), function (name) {
	        delete elOption[name];
	      });
	      return elOption;
	    }
	
	    function setEventData(el, graphicModel, elOption) {
	      var eventData = getECData(el).eventData; // Simple optimize for large amount of elements that no need event.
	
	      if (!el.silent && !el.ignore && !eventData) {
	        eventData = getECData(el).eventData = {
	          componentType: 'graphic',
	          componentIndex: graphicModel.componentIndex,
	          name: el.name
	        };
	      } // `elOption.info` enables user to mount some info on
	      // elements and use them in event handlers.
	
	
	      if (eventData) {
	        eventData.info = elOption.info;
	      }
	    }
	
	    function install$x(registers) {
	      registers.registerComponentModel(GraphicComponentModel);
	      registers.registerComponentView(GraphicComponentView);
	      registers.registerPreprocessor(function (option) {
	        var graphicOption = option.graphic; // Convert
	        // {graphic: [{left: 10, type: 'circle'}, ...]}
	        // or
	        // {graphic: {left: 10, type: 'circle'}}
	        // to
	        // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
	
	        if (isArray(graphicOption)) {
	          if (!graphicOption[0] || !graphicOption[0].elements) {
	            option.graphic = [{
	              elements: graphicOption
	            }];
	          } else {
	            // Only one graphic instance can be instantiated. (We don't
	            // want that too many views are created in echarts._viewMap.)
	            option.graphic = [option.graphic[0]];
	          }
	        } else if (graphicOption && !graphicOption.elements) {
	          option.graphic = [{
	            elements: [graphicOption]
	          }];
	        }
	      });
	    }
	
	    var DATA_ZOOM_AXIS_DIMENSIONS = ['x', 'y', 'radius', 'angle', 'single']; // Supported coords.
	    // FIXME: polar has been broken (but rarely used).
	
	    var SERIES_COORDS = ['cartesian2d', 'polar', 'singleAxis'];
	    function isCoordSupported(seriesModel) {
	      var coordType = seriesModel.get('coordinateSystem');
	      return indexOf(SERIES_COORDS, coordType) >= 0;
	    }
	    function getAxisMainType(axisDim) {
	      if (true) {
	        assert(axisDim);
	      }
	
	      return axisDim + 'Axis';
	    }
	    /**
	     * If two dataZoomModels has the same axis controlled, we say that they are 'linked'.
	     * This function finds all linked dataZoomModels start from the given payload.
	     */
	
	    function findEffectedDataZooms(ecModel, payload) {
	      // Key: `DataZoomAxisDimension`
	      var axisRecords = createHashMap();
	      var effectedModels = []; // Key: uid of dataZoomModel
	
	      var effectedModelMap = createHashMap(); // Find the dataZooms specified by payload.
	
	      ecModel.eachComponent({
	        mainType: 'dataZoom',
	        query: payload
	      }, function (dataZoomModel) {
	        if (!effectedModelMap.get(dataZoomModel.uid)) {
	          addToEffected(dataZoomModel);
	        }
	      }); // Start from the given dataZoomModels, travel the graph to find
	      // all of the linked dataZoom models.
	
	      var foundNewLink;
	
	      do {
	        foundNewLink = false;
	        ecModel.eachComponent('dataZoom', processSingle);
	      } while (foundNewLink);
	
	      function processSingle(dataZoomModel) {
	        if (!effectedModelMap.get(dataZoomModel.uid) && isLinked(dataZoomModel)) {
	          addToEffected(dataZoomModel);
	          foundNewLink = true;
	        }
	      }
	
	      function addToEffected(dataZoom) {
	        effectedModelMap.set(dataZoom.uid, true);
	        effectedModels.push(dataZoom);
	        markAxisControlled(dataZoom);
	      }
	
	      function isLinked(dataZoomModel) {
	        var isLink = false;
	        dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
	          var axisIdxArr = axisRecords.get(axisDim);
	
	          if (axisIdxArr && axisIdxArr[axisIndex]) {
	            isLink = true;
	          }
	        });
	        return isLink;
	      }
	
	      function markAxisControlled(dataZoomModel) {
	        dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
	          (axisRecords.get(axisDim) || axisRecords.set(axisDim, []))[axisIndex] = true;
	        });
	      }
	
	      return effectedModels;
	    }
	    /**
	     * Find the first target coordinate system.
	     * Available after model built.
	     *
	     * @return Like {
	     *                  grid: [
	     *                      {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
	     *                      {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
	     *                      ...
	     *                  ],  // cartesians must not be null/undefined.
	     *                  polar: [
	     *                      {model: coord0, axisModels: [axis4], coordIndex: 0},
	     *                      ...
	     *                  ],  // polars must not be null/undefined.
	     *                  singleAxis: [
	     *                      {model: coord0, axisModels: [], coordIndex: 0}
	     *                  ]
	     *              }
	     */
	
	    function collectReferCoordSysModelInfo(dataZoomModel) {
	      var ecModel = dataZoomModel.ecModel;
	      var coordSysInfoWrap = {
	        infoList: [],
	        infoMap: createHashMap()
	      };
	      dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
	        var axisModel = ecModel.getComponent(getAxisMainType(axisDim), axisIndex);
	
	        if (!axisModel) {
	          return;
	        }
	
	        var coordSysModel = axisModel.getCoordSysModel();
	
	        if (!coordSysModel) {
	          return;
	        }
	
	        var coordSysUid = coordSysModel.uid;
	        var coordSysInfo = coordSysInfoWrap.infoMap.get(coordSysUid);
	
	        if (!coordSysInfo) {
	          coordSysInfo = {
	            model: coordSysModel,
	            axisModels: []
	          };
	          coordSysInfoWrap.infoList.push(coordSysInfo);
	          coordSysInfoWrap.infoMap.set(coordSysUid, coordSysInfo);
	        }
	
	        coordSysInfo.axisModels.push(axisModel);
	      });
	      return coordSysInfoWrap;
	    }
	
	    var DataZoomAxisInfo =
	    /** @class */
	    function () {
	      function DataZoomAxisInfo() {
	        this.indexList = [];
	        this.indexMap = [];
	      }
	
	      DataZoomAxisInfo.prototype.add = function (axisCmptIdx) {
	        // Remove duplication.
	        if (!this.indexMap[axisCmptIdx]) {
	          this.indexList.push(axisCmptIdx);
	          this.indexMap[axisCmptIdx] = true;
	        }
	      };
	
	      return DataZoomAxisInfo;
	    }();
	
	    var DataZoomModel =
	    /** @class */
	    function (_super) {
	      __extends(DataZoomModel, _super);
	
	      function DataZoomModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = DataZoomModel.type;
	        _this._autoThrottle = true;
	        _this._noTarget = true;
	        /**
	         * It is `[rangeModeForMin, rangeModeForMax]`.
	         * The optional values for `rangeMode`:
	         * + `'value'` mode: the axis extent will always be determined by
	         *     `dataZoom.startValue` and `dataZoom.endValue`, despite
	         *     how data like and how `axis.min` and `axis.max` are.
	         * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
	         *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
	         *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
	         *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
	         *
	         * For example, when users are using dynamic data (update data periodically via `setOption`),
	         * if in `'value`' mode, the window will be kept in a fixed value range despite how
	         * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
	         * the appended data (suppose `axis.min` and `axis.max` are not specified).
	         */
	
	        _this._rangePropMode = ['percent', 'percent'];
	        return _this;
	      }
	
	      DataZoomModel.prototype.init = function (option, parentModel, ecModel) {
	        var inputRawOption = retrieveRawOption(option);
	        /**
	         * Suppose a "main process" start at the point that model prepared (that is,
	         * model initialized or merged or method called in `action`).
	         * We should keep the `main process` idempotent, that is, given a set of values
	         * on `option`, we get the same result.
	         *
	         * But sometimes, values on `option` will be updated for providing users
	         * a "final calculated value" (`dataZoomProcessor` will do that). Those value
	         * should not be the base/input of the `main process`.
	         *
	         * So in that case we should save and keep the input of the `main process`
	         * separately, called `settledOption`.
	         *
	         * For example, consider the case:
	         * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
	         *     where the original input `option.startValue`, `option.endValue` are earsed by
	         *     calculated value.
	         * (Step)2) click the legend to hide and show a series,
	         *     where the new range is calculated by the earsed `startValue` and `endValue`,
	         *     which brings incorrect result.
	         */
	
	        this.settledOption = inputRawOption;
	        this.mergeDefaultAndTheme(option, ecModel);
	
	        this._doInit(inputRawOption);
	      };
	
	      DataZoomModel.prototype.mergeOption = function (newOption) {
	        var inputRawOption = retrieveRawOption(newOption); // FIX #2591
	
	        merge(this.option, newOption, true);
	        merge(this.settledOption, inputRawOption, true);
	
	        this._doInit(inputRawOption);
	      };
	
	      DataZoomModel.prototype._doInit = function (inputRawOption) {
	        var thisOption = this.option;
	
	        this._setDefaultThrottle(inputRawOption);
	
	        this._updateRangeUse(inputRawOption);
	
	        var settledOption = this.settledOption;
	        each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	          // start/end has higher priority over startValue/endValue if they
	          // both set, but we should make chart.setOption({endValue: 1000})
	          // effective, rather than chart.setOption({endValue: 1000, end: null}).
	          if (this._rangePropMode[index] === 'value') {
	            thisOption[names[0]] = settledOption[names[0]] = null;
	          } // Otherwise do nothing and use the merge result.
	
	        }, this);
	
	        this._resetTarget();
	      };
	
	      DataZoomModel.prototype._resetTarget = function () {
	        var optionOrient = this.get('orient', true);
	        var targetAxisIndexMap = this._targetAxisInfoMap = createHashMap();
	
	        var hasAxisSpecified = this._fillSpecifiedTargetAxis(targetAxisIndexMap);
	
	        if (hasAxisSpecified) {
	          this._orient = optionOrient || this._makeAutoOrientByTargetAxis();
	        } else {
	          this._orient = optionOrient || 'horizontal';
	
	          this._fillAutoTargetAxisByOrient(targetAxisIndexMap, this._orient);
	        }
	
	        this._noTarget = true;
	        targetAxisIndexMap.each(function (axisInfo) {
	          if (axisInfo.indexList.length) {
	            this._noTarget = false;
	          }
	        }, this);
	      };
	
	      DataZoomModel.prototype._fillSpecifiedTargetAxis = function (targetAxisIndexMap) {
	        var hasAxisSpecified = false;
	        each(DATA_ZOOM_AXIS_DIMENSIONS, function (axisDim) {
	          var refering = this.getReferringComponents(getAxisMainType(axisDim), MULTIPLE_REFERRING); // When user set axisIndex as a empty array, we think that user specify axisIndex
	          // but do not want use auto mode. Because empty array may be encountered when
	          // some error occurred.
	
	          if (!refering.specified) {
	            return;
	          }
	
	          hasAxisSpecified = true;
	          var axisInfo = new DataZoomAxisInfo();
	          each(refering.models, function (axisModel) {
	            axisInfo.add(axisModel.componentIndex);
	          });
	          targetAxisIndexMap.set(axisDim, axisInfo);
	        }, this);
	        return hasAxisSpecified;
	      };
	
	      DataZoomModel.prototype._fillAutoTargetAxisByOrient = function (targetAxisIndexMap, orient) {
	        var ecModel = this.ecModel;
	        var needAuto = true; // Find axis that parallel to dataZoom as default.
	
	        if (needAuto) {
	          var axisDim = orient === 'vertical' ? 'y' : 'x';
	          var axisModels = ecModel.findComponents({
	            mainType: axisDim + 'Axis'
	          });
	          setParallelAxis(axisModels, axisDim);
	        } // Find axis that parallel to dataZoom as default.
	
	
	        if (needAuto) {
	          var axisModels = ecModel.findComponents({
	            mainType: 'singleAxis',
	            filter: function (axisModel) {
	              return axisModel.get('orient', true) === orient;
	            }
	          });
	          setParallelAxis(axisModels, 'single');
	        }
	
	        function setParallelAxis(axisModels, axisDim) {
	          // At least use the first parallel axis as the target axis.
	          var axisModel = axisModels[0];
	
	          if (!axisModel) {
	            return;
	          }
	
	          var axisInfo = new DataZoomAxisInfo();
	          axisInfo.add(axisModel.componentIndex);
	          targetAxisIndexMap.set(axisDim, axisInfo);
	          needAuto = false; // Find parallel axes in the same grid.
	
	          if (axisDim === 'x' || axisDim === 'y') {
	            var gridModel_1 = axisModel.getReferringComponents('grid', SINGLE_REFERRING).models[0];
	            gridModel_1 && each(axisModels, function (axModel) {
	              if (axisModel.componentIndex !== axModel.componentIndex && gridModel_1 === axModel.getReferringComponents('grid', SINGLE_REFERRING).models[0]) {
	                axisInfo.add(axModel.componentIndex);
	              }
	            });
	          }
	        }
	
	        if (needAuto) {
	          // If no parallel axis, find the first category axis as default. (Also consider polar).
	          each(DATA_ZOOM_AXIS_DIMENSIONS, function (axisDim) {
	            if (!needAuto) {
	              return;
	            }
	
	            var axisModels = ecModel.findComponents({
	              mainType: getAxisMainType(axisDim),
	              filter: function (axisModel) {
	                return axisModel.get('type', true) === 'category';
	              }
	            });
	
	            if (axisModels[0]) {
	              var axisInfo = new DataZoomAxisInfo();
	              axisInfo.add(axisModels[0].componentIndex);
	              targetAxisIndexMap.set(axisDim, axisInfo);
	              needAuto = false;
	            }
	          }, this);
	        }
	      };
	
	      DataZoomModel.prototype._makeAutoOrientByTargetAxis = function () {
	        var dim; // Find the first axis
	
	        this.eachTargetAxis(function (axisDim) {
	          !dim && (dim = axisDim);
	        }, this);
	        return dim === 'y' ? 'vertical' : 'horizontal';
	      };
	
	      DataZoomModel.prototype._setDefaultThrottle = function (inputRawOption) {
	        // When first time user set throttle, auto throttle ends.
	        if (inputRawOption.hasOwnProperty('throttle')) {
	          this._autoThrottle = false;
	        }
	
	        if (this._autoThrottle) {
	          var globalOption = this.ecModel.option;
	          this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
	        }
	      };
	
	      DataZoomModel.prototype._updateRangeUse = function (inputRawOption) {
	        var rangePropMode = this._rangePropMode;
	        var rangeModeInOption = this.get('rangeMode');
	        each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	          var percentSpecified = inputRawOption[names[0]] != null;
	          var valueSpecified = inputRawOption[names[1]] != null;
	
	          if (percentSpecified && !valueSpecified) {
	            rangePropMode[index] = 'percent';
	          } else if (!percentSpecified && valueSpecified) {
	            rangePropMode[index] = 'value';
	          } else if (rangeModeInOption) {
	            rangePropMode[index] = rangeModeInOption[index];
	          } else if (percentSpecified) {
	            // percentSpecified && valueSpecified
	            rangePropMode[index] = 'percent';
	          } // else remain its original setting.
	
	        });
	      };
	
	      DataZoomModel.prototype.noTarget = function () {
	        return this._noTarget;
	      };
	
	      DataZoomModel.prototype.getFirstTargetAxisModel = function () {
	        var firstAxisModel;
	        this.eachTargetAxis(function (axisDim, axisIndex) {
	          if (firstAxisModel == null) {
	            firstAxisModel = this.ecModel.getComponent(getAxisMainType(axisDim), axisIndex);
	          }
	        }, this);
	        return firstAxisModel;
	      };
	      /**
	       * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
	       */
	
	
	      DataZoomModel.prototype.eachTargetAxis = function (callback, context) {
	        this._targetAxisInfoMap.each(function (axisInfo, axisDim) {
	          each(axisInfo.indexList, function (axisIndex) {
	            callback.call(context, axisDim, axisIndex);
	          });
	        });
	      };
	      /**
	       * @return If not found, return null/undefined.
	       */
	
	
	      DataZoomModel.prototype.getAxisProxy = function (axisDim, axisIndex) {
	        var axisModel = this.getAxisModel(axisDim, axisIndex);
	
	        if (axisModel) {
	          return axisModel.__dzAxisProxy;
	        }
	      };
	      /**
	       * @return If not found, return null/undefined.
	       */
	
	
	      DataZoomModel.prototype.getAxisModel = function (axisDim, axisIndex) {
	        if (true) {
	          assert(axisDim && axisIndex != null);
	        }
	
	        var axisInfo = this._targetAxisInfoMap.get(axisDim);
	
	        if (axisInfo && axisInfo.indexMap[axisIndex]) {
	          return this.ecModel.getComponent(getAxisMainType(axisDim), axisIndex);
	        }
	      };
	      /**
	       * If not specified, set to undefined.
	       */
	
	
	      DataZoomModel.prototype.setRawRange = function (opt) {
	        var thisOption = this.option;
	        var settledOption = this.settledOption;
	        each([['start', 'startValue'], ['end', 'endValue']], function (names) {
	          // Consider the pair <start, startValue>:
	          // If one has value and the other one is `null/undefined`, we both set them
	          // to `settledOption`. This strategy enables the feature to clear the original
	          // value in `settledOption` to `null/undefined`.
	          // But if both of them are `null/undefined`, we do not set them to `settledOption`
	          // and keep `settledOption` with the original value. This strategy enables users to
	          // only set <end or endValue> but not set <start or startValue> when calling
	          // `dispatchAction`.
	          // The pair <end, endValue> is treated in the same way.
	          if (opt[names[0]] != null || opt[names[1]] != null) {
	            thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
	            thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
	          }
	        }, this);
	
	        this._updateRangeUse(opt);
	      };
	
	      DataZoomModel.prototype.setCalculatedRange = function (opt) {
	        var option = this.option;
	        each(['start', 'startValue', 'end', 'endValue'], function (name) {
	          option[name] = opt[name];
	        });
	      };
	
	      DataZoomModel.prototype.getPercentRange = function () {
	        var axisProxy = this.findRepresentativeAxisProxy();
	
	        if (axisProxy) {
	          return axisProxy.getDataPercentWindow();
	        }
	      };
	      /**
	       * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
	       *
	       * @return [startValue, endValue] value can only be '-' or finite number.
	       */
	
	
	      DataZoomModel.prototype.getValueRange = function (axisDim, axisIndex) {
	        if (axisDim == null && axisIndex == null) {
	          var axisProxy = this.findRepresentativeAxisProxy();
	
	          if (axisProxy) {
	            return axisProxy.getDataValueWindow();
	          }
	        } else {
	          return this.getAxisProxy(axisDim, axisIndex).getDataValueWindow();
	        }
	      };
	      /**
	       * @param axisModel If axisModel given, find axisProxy
	       *      corresponding to the axisModel
	       */
	
	
	      DataZoomModel.prototype.findRepresentativeAxisProxy = function (axisModel) {
	        if (axisModel) {
	          return axisModel.__dzAxisProxy;
	        } // Find the first hosted axisProxy
	
	
	        var firstProxy;
	
	        var axisDimList = this._targetAxisInfoMap.keys();
	
	        for (var i = 0; i < axisDimList.length; i++) {
	          var axisDim = axisDimList[i];
	
	          var axisInfo = this._targetAxisInfoMap.get(axisDim);
	
	          for (var j = 0; j < axisInfo.indexList.length; j++) {
	            var proxy = this.getAxisProxy(axisDim, axisInfo.indexList[j]);
	
	            if (proxy.hostedBy(this)) {
	              return proxy;
	            }
	
	            if (!firstProxy) {
	              firstProxy = proxy;
	            }
	          }
	        } // If no hosted proxy found, still need to return a proxy.
	        // This case always happens in toolbox dataZoom, where axes are all hosted by
	        // other dataZooms.
	
	
	        return firstProxy;
	      };
	
	      DataZoomModel.prototype.getRangePropMode = function () {
	        return this._rangePropMode.slice();
	      };
	
	      DataZoomModel.prototype.getOrient = function () {
	        if (true) {
	          // Should not be called before initialized.
	          assert(this._orient);
	        }
	
	        return this._orient;
	      };
	
	      DataZoomModel.type = 'dataZoom';
	      DataZoomModel.dependencies = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series', 'toolbox'];
	      DataZoomModel.defaultOption = {
	        // zlevel: 0,
	        z: 4,
	        filterMode: 'filter',
	        start: 0,
	        end: 100
	      };
	      return DataZoomModel;
	    }(ComponentModel);
	    /**
	     * Retrieve those raw params from option, which will be cached separately,
	     * because they will be overwritten by normalized/calculated values in the main
	     * process.
	     */
	
	
	    function retrieveRawOption(option) {
	      var ret = {};
	      each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
	        option.hasOwnProperty(name) && (ret[name] = option[name]);
	      });
	      return ret;
	    }
	
	    var SelectDataZoomModel =
	    /** @class */
	    function (_super) {
	      __extends(SelectDataZoomModel, _super);
	
	      function SelectDataZoomModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SelectDataZoomModel.type;
	        return _this;
	      }
	
	      SelectDataZoomModel.type = 'dataZoom.select';
	      return SelectDataZoomModel;
	    }(DataZoomModel);
	
	    var DataZoomView =
	    /** @class */
	    function (_super) {
	      __extends(DataZoomView, _super);
	
	      function DataZoomView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = DataZoomView.type;
	        return _this;
	      }
	
	      DataZoomView.prototype.render = function (dataZoomModel, ecModel, api, payload) {
	        this.dataZoomModel = dataZoomModel;
	        this.ecModel = ecModel;
	        this.api = api;
	      };
	
	      DataZoomView.type = 'dataZoom';
	      return DataZoomView;
	    }(ComponentView);
	
	    var SelectDataZoomView =
	    /** @class */
	    function (_super) {
	      __extends(SelectDataZoomView, _super);
	
	      function SelectDataZoomView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SelectDataZoomView.type;
	        return _this;
	      }
	
	      SelectDataZoomView.type = 'dataZoom.select';
	      return SelectDataZoomView;
	    }(DataZoomView);
	
	    var each$8 = each;
	    var asc$1 = asc;
	    /**
	     * Operate single axis.
	     * One axis can only operated by one axis operator.
	     * Different dataZoomModels may be defined to operate the same axis.
	     * (i.e. 'inside' data zoom and 'slider' data zoom components)
	     * So dataZoomModels share one axisProxy in that case.
	     */
	
	    var AxisProxy =
	    /** @class */
	    function () {
	      function AxisProxy(dimName, axisIndex, dataZoomModel, ecModel) {
	        this._dimName = dimName;
	        this._axisIndex = axisIndex;
	        this.ecModel = ecModel;
	        this._dataZoomModel = dataZoomModel; // /**
	        //  * @readOnly
	        //  * @private
	        //  */
	        // this.hasSeriesStacked;
	      }
	      /**
	       * Whether the axisProxy is hosted by dataZoomModel.
	       */
	
	
	      AxisProxy.prototype.hostedBy = function (dataZoomModel) {
	        return this._dataZoomModel === dataZoomModel;
	      };
	      /**
	       * @return Value can only be NaN or finite value.
	       */
	
	
	      AxisProxy.prototype.getDataValueWindow = function () {
	        return this._valueWindow.slice();
	      };
	      /**
	       * @return {Array.<number>}
	       */
	
	
	      AxisProxy.prototype.getDataPercentWindow = function () {
	        return this._percentWindow.slice();
	      };
	
	      AxisProxy.prototype.getTargetSeriesModels = function () {
	        var seriesModels = [];
	        this.ecModel.eachSeries(function (seriesModel) {
	          if (isCoordSupported(seriesModel)) {
	            var axisMainType = getAxisMainType(this._dimName);
	            var axisModel = seriesModel.getReferringComponents(axisMainType, SINGLE_REFERRING).models[0];
	
	            if (axisModel && this._axisIndex === axisModel.componentIndex) {
	              seriesModels.push(seriesModel);
	            }
	          }
	        }, this);
	        return seriesModels;
	      };
	
	      AxisProxy.prototype.getAxisModel = function () {
	        return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
	      };
	
	      AxisProxy.prototype.getMinMaxSpan = function () {
	        return clone(this._minMaxSpan);
	      };
	      /**
	       * Only calculate by given range and this._dataExtent, do not change anything.
	       */
	
	
	      AxisProxy.prototype.calculateDataWindow = function (opt) {
	        var dataExtent = this._dataExtent;
	        var axisModel = this.getAxisModel();
	        var scale = axisModel.axis.scale;
	
	        var rangePropMode = this._dataZoomModel.getRangePropMode();
	
	        var percentExtent = [0, 100];
	        var percentWindow = [];
	        var valueWindow = [];
	        var hasPropModeValue;
	        each$8(['start', 'end'], function (prop, idx) {
	          var boundPercent = opt[prop];
	          var boundValue = opt[prop + 'Value']; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
	          // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
	          // but not min/max of axis, which will be calculated by data window then).
	          // The former one is suitable for cases that a dataZoom component controls multiple
	          // axes with different unit or extent, and the latter one is suitable for accurate
	          // zoom by pixel (e.g., in dataZoomSelect).
	          // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
	          // only when setOption or dispatchAction, otherwise it remains its original value.
	          // (Why not only record `percentProp` and always map to `valueProp`? Because
	          // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
	          // `valueProp`. consider two axes constrolled by one dataZoom. They have different
	          // data extent. All of values that are overflow the `dataExtent` will be calculated
	          // to percent '100%').
	
	          if (rangePropMode[idx] === 'percent') {
	            boundPercent == null && (boundPercent = percentExtent[idx]); // Use scale.parse to math round for category or time axis.
	
	            boundValue = scale.parse(linearMap(boundPercent, percentExtent, dataExtent));
	          } else {
	            hasPropModeValue = true;
	            boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue); // Calculating `percent` from `value` may be not accurate, because
	            // This calculation can not be inversed, because all of values that
	            // are overflow the `dataExtent` will be calculated to percent '100%'
	
	            boundPercent = linearMap(boundValue, dataExtent, percentExtent);
	          } // valueWindow[idx] = round(boundValue);
	          // percentWindow[idx] = round(boundPercent);
	          // fallback to extent start/end when parsed value or percent is invalid
	
	
	          valueWindow[idx] = boundValue == null || isNaN(boundValue) ? dataExtent[idx] : boundValue;
	          percentWindow[idx] = boundPercent == null || isNaN(boundPercent) ? percentExtent[idx] : boundPercent;
	        });
	        asc$1(valueWindow);
	        asc$1(percentWindow); // The windows from user calling of `dispatchAction` might be out of the extent,
	        // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we don't restrict window
	        // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
	        // where API is able to initialize/modify the window size even though `zoomLock`
	        // specified.
	
	        var spans = this._minMaxSpan;
	        hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
	
	        function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
	          var suffix = toValue ? 'Span' : 'ValueSpan';
	          sliderMove(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);
	
	          for (var i = 0; i < 2; i++) {
	            toWindow[i] = linearMap(fromWindow[i], fromExtent, toExtent, true);
	            toValue && (toWindow[i] = scale.parse(toWindow[i]));
	          }
	        }
	
	        return {
	          valueWindow: valueWindow,
	          percentWindow: percentWindow
	        };
	      };
	      /**
	       * Notice: reset should not be called before series.restoreData() is called,
	       * so it is recommended to be called in "process stage" but not "model init
	       * stage".
	       */
	
	
	      AxisProxy.prototype.reset = function (dataZoomModel) {
	        if (dataZoomModel !== this._dataZoomModel) {
	          return;
	        }
	
	        var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.
	
	        this._dataExtent = calculateDataExtent(this, this._dimName, targetSeries); // `calculateDataWindow` uses min/maxSpan.
	
	        this._updateMinMaxSpan();
	
	        var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
	        this._valueWindow = dataWindow.valueWindow;
	        this._percentWindow = dataWindow.percentWindow; // Update axis setting then.
	
	        this._setAxisModel();
	      };
	
	      AxisProxy.prototype.filterData = function (dataZoomModel, api) {
	        if (dataZoomModel !== this._dataZoomModel) {
	          return;
	        }
	
	        var axisDim = this._dimName;
	        var seriesModels = this.getTargetSeriesModels();
	        var filterMode = dataZoomModel.get('filterMode');
	        var valueWindow = this._valueWindow;
	
	        if (filterMode === 'none') {
	          return;
	        } // FIXME
	        // Toolbox may has dataZoom injected. And if there are stacked bar chart
	        // with NaN data, NaN will be filtered and stack will be wrong.
	        // So we need to force the mode to be set empty.
	        // In fect, it is not a big deal that do not support filterMode-'filter'
	        // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
	        // selection" some day, which might need "adapt to data extent on the
	        // otherAxis", which is disabled by filterMode-'empty'.
	        // But currently, stack has been fixed to based on value but not index,
	        // so this is not an issue any more.
	        // let otherAxisModel = this.getOtherAxisModel();
	        // if (dataZoomModel.get('$fromToolbox')
	        //     && otherAxisModel
	        //     && otherAxisModel.hasSeriesStacked
	        // ) {
	        //     filterMode = 'empty';
	        // }
	        // TODO
	        // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
	
	
	        each$8(seriesModels, function (seriesModel) {
	          var seriesData = seriesModel.getData();
	          var dataDims = seriesData.mapDimensionsAll(axisDim);
	
	          if (!dataDims.length) {
	            return;
	          }
	
	          if (filterMode === 'weakFilter') {
	            var store_1 = seriesData.getStore();
	            var dataDimIndices_1 = map(dataDims, function (dim) {
	              return seriesData.getDimensionIndex(dim);
	            }, seriesData);
	            seriesData.filterSelf(function (dataIndex) {
	              var leftOut;
	              var rightOut;
	              var hasValue;
	
	              for (var i = 0; i < dataDims.length; i++) {
	                var value = store_1.get(dataDimIndices_1[i], dataIndex);
	                var thisHasValue = !isNaN(value);
	                var thisLeftOut = value < valueWindow[0];
	                var thisRightOut = value > valueWindow[1];
	
	                if (thisHasValue && !thisLeftOut && !thisRightOut) {
	                  return true;
	                }
	
	                thisHasValue && (hasValue = true);
	                thisLeftOut && (leftOut = true);
	                thisRightOut && (rightOut = true);
	              } // If both left out and right out, do not filter.
	
	
	              return hasValue && leftOut && rightOut;
	            });
	          } else {
	            each$8(dataDims, function (dim) {
	              if (filterMode === 'empty') {
	                seriesModel.setData(seriesData = seriesData.map(dim, function (value) {
	                  return !isInWindow(value) ? NaN : value;
	                }));
	              } else {
	                var range = {};
	                range[dim] = valueWindow; // console.time('select');
	
	                seriesData.selectRange(range); // console.timeEnd('select');
	              }
	            });
	          }
	
	          each$8(dataDims, function (dim) {
	            seriesData.setApproximateExtent(valueWindow, dim);
	          });
	        });
	
	        function isInWindow(value) {
	          return value >= valueWindow[0] && value <= valueWindow[1];
	        }
	      };
	
	      AxisProxy.prototype._updateMinMaxSpan = function () {
	        var minMaxSpan = this._minMaxSpan = {};
	        var dataZoomModel = this._dataZoomModel;
	        var dataExtent = this._dataExtent;
	        each$8(['min', 'max'], function (minMax) {
	          var percentSpan = dataZoomModel.get(minMax + 'Span');
	          var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
	          valueSpan != null && (valueSpan = this.getAxisModel().axis.scale.parse(valueSpan)); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
	
	          if (valueSpan != null) {
	            percentSpan = linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
	          } else if (percentSpan != null) {
	            valueSpan = linearMap(percentSpan, [0, 100], dataExtent, true) - dataExtent[0];
	          }
	
	          minMaxSpan[minMax + 'Span'] = percentSpan;
	          minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
	        }, this);
	      };
	
	      AxisProxy.prototype._setAxisModel = function () {
	        var axisModel = this.getAxisModel();
	        var percentWindow = this._percentWindow;
	        var valueWindow = this._valueWindow;
	
	        if (!percentWindow) {
	          return;
	        } // [0, 500]: arbitrary value, guess axis extent.
	
	
	        var precision = getPixelPrecision(valueWindow, [0, 500]);
	        precision = Math.min(precision, 20); // For value axis, if min/max/scale are not set, we just use the extent obtained
	        // by series data, which may be a little different from the extent calculated by
	        // `axisHelper.getScaleExtent`. But the different just affects the experience a
	        // little when zooming. So it will not be fixed until some users require it strongly.
	
	        var rawExtentInfo = axisModel.axis.scale.rawExtentInfo;
	
	        if (percentWindow[0] !== 0) {
	          rawExtentInfo.setDeterminedMinMax('min', +valueWindow[0].toFixed(precision));
	        }
	
	        if (percentWindow[1] !== 100) {
	          rawExtentInfo.setDeterminedMinMax('max', +valueWindow[1].toFixed(precision));
	        }
	
	        rawExtentInfo.freeze();
	      };
	
	      return AxisProxy;
	    }();
	
	    function calculateDataExtent(axisProxy, axisDim, seriesModels) {
	      var dataExtent = [Infinity, -Infinity];
	      each$8(seriesModels, function (seriesModel) {
	        unionAxisExtentFromData(dataExtent, seriesModel.getData(), axisDim);
	      }); // It is important to get "consistent" extent when more then one axes is
	      // controlled by a `dataZoom`, otherwise those axes will not be synchronized
	      // when zooming. But it is difficult to know what is "consistent", considering
	      // axes have different type or even different meanings (For example, two
	      // time axes are used to compare data of the same date in different years).
	      // So basically dataZoom just obtains extent by series.data (in category axis
	      // extent can be obtained from axis.data).
	      // Nevertheless, user can set min/max/scale on axes to make extent of axes
	      // consistent.
	
	      var axisModel = axisProxy.getAxisModel();
	      var rawExtentResult = ensureScaleRawExtentInfo(axisModel.axis.scale, axisModel, dataExtent).calculate();
	      return [rawExtentResult.min, rawExtentResult.max];
	    }
	
	    var dataZoomProcessor = {
	      // `dataZoomProcessor` will only be performed in needed series. Consider if
	      // there is a line series and a pie series, it is better not to update the
	      // line series if only pie series is needed to be updated.
	      getTargetSeries: function (ecModel) {
	        function eachAxisModel(cb) {
	          ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	            dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
	              var axisModel = ecModel.getComponent(getAxisMainType(axisDim), axisIndex);
	              cb(axisDim, axisIndex, axisModel, dataZoomModel);
	            });
	          });
	        } // FIXME: it brings side-effect to `getTargetSeries`.
	        // Prepare axis proxies.
	
	
	        eachAxisModel(function (axisDim, axisIndex, axisModel, dataZoomModel) {
	          // dispose all last axis proxy, in case that some axis are deleted.
	          axisModel.__dzAxisProxy = null;
	        });
	        var proxyList = [];
	        eachAxisModel(function (axisDim, axisIndex, axisModel, dataZoomModel) {
	          // Different dataZooms may constrol the same axis. In that case,
	          // an axisProxy serves both of them.
	          if (!axisModel.__dzAxisProxy) {
	            // Use the first dataZoomModel as the main model of axisProxy.
	            axisModel.__dzAxisProxy = new AxisProxy(axisDim, axisIndex, dataZoomModel, ecModel);
	            proxyList.push(axisModel.__dzAxisProxy);
	          }
	        });
	        var seriesModelMap = createHashMap();
	        each(proxyList, function (axisProxy) {
	          each(axisProxy.getTargetSeriesModels(), function (seriesModel) {
	            seriesModelMap.set(seriesModel.uid, seriesModel);
	          });
	        });
	        return seriesModelMap;
	      },
	      // Consider appendData, where filter should be performed. Because data process is
	      // in block mode currently, it is not need to worry about that the overallProgress
	      // execute every frame.
	      overallReset: function (ecModel, api) {
	        ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	          // We calculate window and reset axis here but not in model
	          // init stage and not after action dispatch handler, because
	          // reset should be called after seriesData.restoreData.
	          dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
	            dataZoomModel.getAxisProxy(axisDim, axisIndex).reset(dataZoomModel);
	          }); // Caution: data zoom filtering is order sensitive when using
	          // percent range and no min/max/scale set on axis.
	          // For example, we have dataZoom definition:
	          // [
	          //      {xAxisIndex: 0, start: 30, end: 70},
	          //      {yAxisIndex: 0, start: 20, end: 80}
	          // ]
	          // In this case, [20, 80] of y-dataZoom should be based on data
	          // that have filtered by x-dataZoom using range of [30, 70],
	          // but should not be based on full raw data. Thus sliding
	          // x-dataZoom will change both ranges of xAxis and yAxis,
	          // while sliding y-dataZoom will only change the range of yAxis.
	          // So we should filter x-axis after reset x-axis immediately,
	          // and then reset y-axis and filter y-axis.
	
	          dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
	            dataZoomModel.getAxisProxy(axisDim, axisIndex).filterData(dataZoomModel, api);
	          });
	        });
	        ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	          // Fullfill all of the range props so that user
	          // is able to get them from chart.getOption().
	          var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	
	          if (axisProxy) {
	            var percentRange = axisProxy.getDataPercentWindow();
	            var valueRange = axisProxy.getDataValueWindow();
	            dataZoomModel.setCalculatedRange({
	              start: percentRange[0],
	              end: percentRange[1],
	              startValue: valueRange[0],
	              endValue: valueRange[1]
	            });
	          }
	        });
	      }
	    };
	
	    function installDataZoomAction(registers) {
	      registers.registerAction('dataZoom', function (payload, ecModel) {
	        var effectedModels = findEffectedDataZooms(ecModel, payload);
	        each(effectedModels, function (dataZoomModel) {
	          dataZoomModel.setRawRange({
	            start: payload.start,
	            end: payload.end,
	            startValue: payload.startValue,
	            endValue: payload.endValue
	          });
	        });
	      });
	    }
	
	    var installed = false;
	    function installCommon(registers) {
	      if (installed) {
	        return;
	      }
	
	      installed = true;
	      registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, dataZoomProcessor);
	      installDataZoomAction(registers);
	      registers.registerSubTypeDefaulter('dataZoom', function () {
	        // Default 'slider' when no type specified.
	        return 'slider';
	      });
	    }
	
	    function install$y(registers) {
	      registers.registerComponentModel(SelectDataZoomModel);
	      registers.registerComponentView(SelectDataZoomView);
	      installCommon(registers);
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    var ToolboxFeature =
	    /** @class */
	    function () {
	      function ToolboxFeature() {}
	
	      return ToolboxFeature;
	    }();
	    var features = {};
	    function registerFeature(name, ctor) {
	      features[name] = ctor;
	    }
	    function getFeature(name) {
	      return features[name];
	    }
	
	    var ToolboxModel =
	    /** @class */
	    function (_super) {
	      __extends(ToolboxModel, _super);
	
	      function ToolboxModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ToolboxModel.type;
	        return _this;
	      }
	
	      ToolboxModel.prototype.optionUpdated = function () {
	        _super.prototype.optionUpdated.apply(this, arguments);
	
	        var ecModel = this.ecModel;
	        each(this.option.feature, function (featureOpt, featureName) {
	          var Feature = getFeature(featureName);
	
	          if (Feature) {
	            if (Feature.getDefaultOption) {
	              Feature.defaultOption = Feature.getDefaultOption(ecModel);
	            }
	
	            merge(featureOpt, Feature.defaultOption);
	          }
	        });
	      };
	
	      ToolboxModel.type = 'toolbox';
	      ToolboxModel.layoutMode = {
	        type: 'box',
	        ignoreSize: true
	      };
	      ToolboxModel.defaultOption = {
	        show: true,
	        z: 6,
	        // zlevel: 0,
	        orient: 'horizontal',
	        left: 'right',
	        top: 'top',
	        // right
	        // bottom
	        backgroundColor: 'transparent',
	        borderColor: '#ccc',
	        borderRadius: 0,
	        borderWidth: 0,
	        padding: 5,
	        itemSize: 15,
	        itemGap: 8,
	        showTitle: true,
	        iconStyle: {
	          borderColor: '#666',
	          color: 'none'
	        },
	        emphasis: {
	          iconStyle: {
	            borderColor: '#3E98C5'
	          }
	        },
	        // textStyle: {},
	        // feature
	        tooltip: {
	          show: false,
	          position: 'bottom'
	        }
	      };
	      return ToolboxModel;
	    }(ComponentModel);
	
	    /**
	     * Layout list like component.
	     * It will box layout each items in group of component and then position the whole group in the viewport
	     * @param {module:zrender/group/Group} group
	     * @param {module:echarts/model/Component} componentModel
	     * @param {module:echarts/ExtensionAPI}
	     */
	
	    function layout$3(group, componentModel, api) {
	      var boxLayoutParams = componentModel.getBoxLayoutParams();
	      var padding = componentModel.get('padding');
	      var viewportSize = {
	        width: api.getWidth(),
	        height: api.getHeight()
	      };
	      var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
	      box(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
	      positionElement(group, boxLayoutParams, viewportSize, padding);
	    }
	    function makeBackground(rect, componentModel) {
	      var padding = normalizeCssArray$1(componentModel.get('padding'));
	      var style = componentModel.getItemStyle(['color', 'opacity']);
	      style.fill = componentModel.get('backgroundColor');
	      rect = new Rect({
	        shape: {
	          x: rect.x - padding[3],
	          y: rect.y - padding[0],
	          width: rect.width + padding[1] + padding[3],
	          height: rect.height + padding[0] + padding[2],
	          r: componentModel.get('borderRadius')
	        },
	        style: style,
	        silent: true,
	        z2: -1
	      }); // FIXME
	      // `subPixelOptimizeRect` may bring some gap between edge of viewpart
	      // and background rect when setting like `left: 0`, `top: 0`.
	      // graphic.subPixelOptimizeRect(rect);
	
	      return rect;
	    }
	
	    var ToolboxView =
	    /** @class */
	    function (_super) {
	      __extends(ToolboxView, _super);
	
	      function ToolboxView() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      ToolboxView.prototype.render = function (toolboxModel, ecModel, api, payload) {
	        var group = this.group;
	        group.removeAll();
	
	        if (!toolboxModel.get('show')) {
	          return;
	        }
	
	        var itemSize = +toolboxModel.get('itemSize');
	        var isVertical = toolboxModel.get('orient') === 'vertical';
	        var featureOpts = toolboxModel.get('feature') || {};
	        var features = this._features || (this._features = {});
	        var featureNames = [];
	        each(featureOpts, function (opt, name) {
	          featureNames.push(name);
	        });
	        new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(curry(processFeature, null)).execute(); // Keep for diff.
	
	        this._featureNames = featureNames;
	
	        function processFeature(newIndex, oldIndex) {
	          var featureName = featureNames[newIndex];
	          var oldName = featureNames[oldIndex];
	          var featureOpt = featureOpts[featureName];
	          var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
	          var feature; // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
	
	          if (payload && payload.newTitle != null && payload.featureName === featureName) {
	            featureOpt.title = payload.newTitle;
	          }
	
	          if (featureName && !oldName) {
	            // Create
	            if (isUserFeatureName(featureName)) {
	              feature = {
	                onclick: featureModel.option.onclick,
	                featureName: featureName
	              };
	            } else {
	              var Feature = getFeature(featureName);
	
	              if (!Feature) {
	                return;
	              }
	
	              feature = new Feature();
	            }
	
	            features[featureName] = feature;
	          } else {
	            feature = features[oldName]; // If feature does not exist.
	
	            if (!feature) {
	              return;
	            }
	          }
	
	          feature.uid = getUID('toolbox-feature');
	          feature.model = featureModel;
	          feature.ecModel = ecModel;
	          feature.api = api;
	          var isToolboxFeature = feature instanceof ToolboxFeature;
	
	          if (!featureName && oldName) {
	            isToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
	            return;
	          }
	
	          if (!featureModel.get('show') || isToolboxFeature && feature.unusable) {
	            isToolboxFeature && feature.remove && feature.remove(ecModel, api);
	            return;
	          }
	
	          createIconPaths(featureModel, feature, featureName);
	
	          featureModel.setIconStatus = function (iconName, status) {
	            var option = this.option;
	            var iconPaths = this.iconPaths;
	            option.iconStatus = option.iconStatus || {};
	            option.iconStatus[iconName] = status;
	
	            if (iconPaths[iconName]) {
	              (status === 'emphasis' ? enterEmphasis : leaveEmphasis)(iconPaths[iconName]);
	            }
	          };
	
	          if (feature instanceof ToolboxFeature) {
	            if (feature.render) {
	              feature.render(featureModel, ecModel, api, payload);
	            }
	          }
	        }
	
	        function createIconPaths(featureModel, feature, featureName) {
	          var iconStyleModel = featureModel.getModel('iconStyle');
	          var iconStyleEmphasisModel = featureModel.getModel(['emphasis', 'iconStyle']); // If one feature has multiple icons, they are organized as
	          // {
	          //     icon: {
	          //         foo: '',
	          //         bar: ''
	          //     },
	          //     title: {
	          //         foo: '',
	          //         bar: ''
	          //     }
	          // }
	
	          var icons = feature instanceof ToolboxFeature && feature.getIcons ? feature.getIcons() : featureModel.get('icon');
	          var titles = featureModel.get('title') || {};
	          var iconsMap;
	          var titlesMap;
	
	          if (isString(icons)) {
	            iconsMap = {};
	            iconsMap[featureName] = icons;
	          } else {
	            iconsMap = icons;
	          }
	
	          if (isString(titles)) {
	            titlesMap = {};
	            titlesMap[featureName] = titles;
	          } else {
	            titlesMap = titles;
	          }
	
	          var iconPaths = featureModel.iconPaths = {};
	          each(iconsMap, function (iconStr, iconName) {
	            var path = createIcon(iconStr, {}, {
	              x: -itemSize / 2,
	              y: -itemSize / 2,
	              width: itemSize,
	              height: itemSize
	            }); // TODO handling image
	
	            path.setStyle(iconStyleModel.getItemStyle());
	            var pathEmphasisState = path.ensureState('emphasis');
	            pathEmphasisState.style = iconStyleEmphasisModel.getItemStyle(); // Text position calculation
	
	            var textContent = new ZRText({
	              style: {
	                text: titlesMap[iconName],
	                align: iconStyleEmphasisModel.get('textAlign'),
	                borderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
	                padding: iconStyleEmphasisModel.get('textPadding'),
	                fill: null
	              },
	              ignore: true
	            });
	            path.setTextContent(textContent);
	            setTooltipConfig({
	              el: path,
	              componentModel: toolboxModel,
	              itemName: iconName,
	              formatterParamsExtra: {
	                title: titlesMap[iconName]
	              }
	            });
	            path.__title = titlesMap[iconName];
	            path.on('mouseover', function () {
	              // Should not reuse above hoverStyle, which might be modified.
	              var hoverStyle = iconStyleEmphasisModel.getItemStyle();
	              var defaultTextPosition = isVertical ? toolboxModel.get('right') == null && toolboxModel.get('left') !== 'right' ? 'right' : 'left' : toolboxModel.get('bottom') == null && toolboxModel.get('top') !== 'bottom' ? 'bottom' : 'top';
	              textContent.setStyle({
	                fill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
	                backgroundColor: iconStyleEmphasisModel.get('textBackgroundColor')
	              });
	              path.setTextConfig({
	                position: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
	              });
	              textContent.ignore = !toolboxModel.get('showTitle'); // Use enterEmphasis and leaveEmphasis provide by ec.
	              // There are flags managed by the echarts.
	
	              api.enterEmphasis(this);
	            }).on('mouseout', function () {
	              if (featureModel.get(['iconStatus', iconName]) !== 'emphasis') {
	                api.leaveEmphasis(this);
	              }
	
	              textContent.hide();
	            });
	            (featureModel.get(['iconStatus', iconName]) === 'emphasis' ? enterEmphasis : leaveEmphasis)(path);
	            group.add(path);
	            path.on('click', bind(feature.onclick, feature, ecModel, api, iconName));
	            iconPaths[iconName] = path;
	          });
	        }
	
	        layout$3(group, toolboxModel, api); // Render background after group is layout
	        // FIXME
	
	        group.add(makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen
	
	        isVertical || group.eachChild(function (icon) {
	          var titleText = icon.__title; // const hoverStyle = icon.hoverStyle;
	          // TODO simplify code?
	
	          var emphasisState = icon.ensureState('emphasis');
	          var emphasisTextConfig = emphasisState.textConfig || (emphasisState.textConfig = {});
	          var textContent = icon.getTextContent();
	          var emphasisTextState = textContent && textContent.ensureState('emphasis'); // May be background element
	
	          if (emphasisTextState && !isFunction(emphasisTextState) && titleText) {
	            var emphasisTextStyle = emphasisTextState.style || (emphasisTextState.style = {});
	            var rect = getBoundingRect(titleText, ZRText.makeFont(emphasisTextStyle));
	            var offsetX = icon.x + group.x;
	            var offsetY = icon.y + group.y + itemSize;
	            var needPutOnTop = false;
	
	            if (offsetY + rect.height > api.getHeight()) {
	              emphasisTextConfig.position = 'top';
	              needPutOnTop = true;
	            }
	
	            var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 10;
	
	            if (offsetX + rect.width / 2 > api.getWidth()) {
	              emphasisTextConfig.position = ['100%', topOffset];
	              emphasisTextStyle.align = 'right';
	            } else if (offsetX - rect.width / 2 < 0) {
	              emphasisTextConfig.position = [0, topOffset];
	              emphasisTextStyle.align = 'left';
	            }
	          }
	        });
	      };
	
	      ToolboxView.prototype.updateView = function (toolboxModel, ecModel, api, payload) {
	        each(this._features, function (feature) {
	          feature instanceof ToolboxFeature && feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
	        });
	      }; // updateLayout(toolboxModel, ecModel, api, payload) {
	      //     zrUtil.each(this._features, function (feature) {
	      //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
	      //     });
	      // },
	
	
	      ToolboxView.prototype.remove = function (ecModel, api) {
	        each(this._features, function (feature) {
	          feature instanceof ToolboxFeature && feature.remove && feature.remove(ecModel, api);
	        });
	        this.group.removeAll();
	      };
	
	      ToolboxView.prototype.dispose = function (ecModel, api) {
	        each(this._features, function (feature) {
	          feature instanceof ToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
	        });
	      };
	
	      ToolboxView.type = 'toolbox';
	      return ToolboxView;
	    }(ComponentView);
	
	    function isUserFeatureName(featureName) {
	      return featureName.indexOf('my') === 0;
	    }
	
	    /* global window, document */
	
	    var SaveAsImage =
	    /** @class */
	    function (_super) {
	      __extends(SaveAsImage, _super);
	
	      function SaveAsImage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      SaveAsImage.prototype.onclick = function (ecModel, api) {
	        var model = this.model;
	        var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
	        var isSvg = api.getZr().painter.getType() === 'svg';
	        var type = isSvg ? 'svg' : model.get('type', true) || 'png';
	        var url = api.getConnectedDataURL({
	          type: type,
	          backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
	          connectedBackgroundColor: model.get('connectedBackgroundColor'),
	          excludeComponents: model.get('excludeComponents'),
	          pixelRatio: model.get('pixelRatio')
	        });
	        var browser = env.browser; // Chrome, Firefox, New Edge
	
	        if (isFunction(MouseEvent) && (browser.newEdge || !browser.ie && !browser.edge)) {
	          var $a = document.createElement('a');
	          $a.download = title + '.' + type;
	          $a.target = '_blank';
	          $a.href = url;
	          var evt = new MouseEvent('click', {
	            // some micro front-end framework， window maybe is a Proxy
	            view: document.defaultView,
	            bubbles: true,
	            cancelable: false
	          });
	          $a.dispatchEvent(evt);
	        } // IE or old Edge
	        else {
	            // @ts-ignore
	            if (window.navigator.msSaveOrOpenBlob || isSvg) {
	              var parts = url.split(','); // data:[<mime type>][;charset=<charset>][;base64],<encoded data>
	
	              var base64Encoded = parts[0].indexOf('base64') > -1;
	              var bstr = isSvg // should decode the svg data uri first
	              ? decodeURIComponent(parts[1]) : parts[1]; // only `atob` when the data uri is encoded with base64
	              // otherwise, like `svg` data uri exported by zrender,
	              // there will be an error, for it's not encoded with base64.
	              // (just a url-encoded string through `encodeURIComponent`)
	
	              base64Encoded && (bstr = window.atob(bstr));
	              var filename = title + '.' + type; // @ts-ignore
	
	              if (window.navigator.msSaveOrOpenBlob) {
	                var n = bstr.length;
	                var u8arr = new Uint8Array(n);
	
	                while (n--) {
	                  u8arr[n] = bstr.charCodeAt(n);
	                }
	
	                var blob = new Blob([u8arr]); // @ts-ignore
	
	                window.navigator.msSaveOrOpenBlob(blob, filename);
	              } else {
	                var frame = document.createElement('iframe');
	                document.body.appendChild(frame);
	                var cw = frame.contentWindow;
	                var doc = cw.document;
	                doc.open('image/svg+xml', 'replace');
	                doc.write(bstr);
	                doc.close();
	                cw.focus();
	                doc.execCommand('SaveAs', true, filename);
	                document.body.removeChild(frame);
	              }
	            } else {
	              var lang = model.get('lang');
	              var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
	              var tab = window.open();
	              tab.document.write(html);
	              tab.document.title = title;
	            }
	          }
	      };
	
	      SaveAsImage.getDefaultOption = function (ecModel) {
	        var defaultOption = {
	          show: true,
	          icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
	          title: ecModel.getLocaleModel().get(['toolbox', 'saveAsImage', 'title']),
	          type: 'png',
	          // Default use option.backgroundColor
	          // backgroundColor: '#fff',
	          connectedBackgroundColor: '#fff',
	          name: '',
	          excludeComponents: ['toolbox'],
	          // use current pixel ratio of device by default
	          // pixelRatio: 1,
	          lang: ecModel.getLocaleModel().get(['toolbox', 'saveAsImage', 'lang'])
	        };
	        return defaultOption;
	      };
	
	      return SaveAsImage;
	    }(ToolboxFeature);
	
	    var INNER_STACK_KEYWORD = '__ec_magicType_stack__';
	    var radioTypes = [['line', 'bar'], ['stack']];
	
	    var MagicType =
	    /** @class */
	    function (_super) {
	      __extends(MagicType, _super);
	
	      function MagicType() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      MagicType.prototype.getIcons = function () {
	        var model = this.model;
	        var availableIcons = model.get('icon');
	        var icons = {};
	        each(model.get('type'), function (type) {
	          if (availableIcons[type]) {
	            icons[type] = availableIcons[type];
	          }
	        });
	        return icons;
	      };
	
	      MagicType.getDefaultOption = function (ecModel) {
	        var defaultOption = {
	          show: true,
	          type: [],
	          // Icon group
	          icon: {
	            line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
	            bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
	            // eslint-disable-next-line
	            stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line
	
	          },
	          // `line`, `bar`, `stack`, `tiled`
	          title: ecModel.getLocaleModel().get(['toolbox', 'magicType', 'title']),
	          option: {},
	          seriesIndex: {}
	        };
	        return defaultOption;
	      };
	
	      MagicType.prototype.onclick = function (ecModel, api, type) {
	        var model = this.model;
	        var seriesIndex = model.get(['seriesIndex', type]); // Not supported magicType
	
	        if (!seriesOptGenreator[type]) {
	          return;
	        }
	
	        var newOption = {
	          series: []
	        };
	
	        var generateNewSeriesTypes = function (seriesModel) {
	          var seriesType = seriesModel.subType;
	          var seriesId = seriesModel.id;
	          var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
	
	          if (newSeriesOpt) {
	            // PENDING If merge original option?
	            defaults(newSeriesOpt, seriesModel.option);
	            newOption.series.push(newSeriesOpt);
	          } // Modify boundaryGap
	
	
	          var coordSys = seriesModel.coordinateSystem;
	
	          if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
	            var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	            if (categoryAxis) {
	              var axisDim = categoryAxis.dim;
	              var axisType = axisDim + 'Axis';
	              var axisModel = seriesModel.getReferringComponents(axisType, SINGLE_REFERRING).models[0];
	              var axisIndex = axisModel.componentIndex;
	              newOption[axisType] = newOption[axisType] || [];
	
	              for (var i = 0; i <= axisIndex; i++) {
	                newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
	              }
	
	              newOption[axisType][axisIndex].boundaryGap = type === 'bar';
	            }
	          }
	        };
	
	        each(radioTypes, function (radio) {
	          if (indexOf(radio, type) >= 0) {
	            each(radio, function (item) {
	              model.setIconStatus(item, 'normal');
	            });
	          }
	        });
	        model.setIconStatus(type, 'emphasis');
	        ecModel.eachComponent({
	          mainType: 'series',
	          query: seriesIndex == null ? null : {
	            seriesIndex: seriesIndex
	          }
	        }, generateNewSeriesTypes);
	        var newTitle;
	        var currentType = type; // Change title of stack
	
	        if (type === 'stack') {
	          // use titles in model instead of ecModel
	          // as stack and tiled appears in pair, just flip them
	          // no need of checking stack state
	          newTitle = merge({
	            stack: model.option.title.tiled,
	            tiled: model.option.title.stack
	          }, model.option.title);
	
	          if (model.get(['iconStatus', type]) !== 'emphasis') {
	            currentType = 'tiled';
	          }
	        }
	
	        api.dispatchAction({
	          type: 'changeMagicType',
	          currentType: currentType,
	          newOption: newOption,
	          newTitle: newTitle,
	          featureName: 'magicType'
	        });
	      };
	
	      return MagicType;
	    }(ToolboxFeature);
	
	    var seriesOptGenreator = {
	      'line': function (seriesType, seriesId, seriesModel, model) {
	        if (seriesType === 'bar') {
	          return merge({
	            id: seriesId,
	            type: 'line',
	            // Preserve data related option
	            data: seriesModel.get('data'),
	            stack: seriesModel.get('stack'),
	            markPoint: seriesModel.get('markPoint'),
	            markLine: seriesModel.get('markLine')
	          }, model.get(['option', 'line']) || {}, true);
	        }
	      },
	      'bar': function (seriesType, seriesId, seriesModel, model) {
	        if (seriesType === 'line') {
	          return merge({
	            id: seriesId,
	            type: 'bar',
	            // Preserve data related option
	            data: seriesModel.get('data'),
	            stack: seriesModel.get('stack'),
	            markPoint: seriesModel.get('markPoint'),
	            markLine: seriesModel.get('markLine')
	          }, model.get(['option', 'bar']) || {}, true);
	        }
	      },
	      'stack': function (seriesType, seriesId, seriesModel, model) {
	        var isStack = seriesModel.get('stack') === INNER_STACK_KEYWORD;
	
	        if (seriesType === 'line' || seriesType === 'bar') {
	          model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
	          return merge({
	            id: seriesId,
	            stack: isStack ? '' : INNER_STACK_KEYWORD
	          }, model.get(['option', 'stack']) || {}, true);
	        }
	      }
	    }; // TODO: SELF REGISTERED.
	
	    registerAction({
	      type: 'changeMagicType',
	      event: 'magicTypeChanged',
	      update: 'prepareAndUpdate'
	    }, function (payload, ecModel) {
	      ecModel.mergeOption(payload.newOption);
	    });
	
	    /* global document */
	
	    var BLOCK_SPLITER = new Array(60).join('-');
	    var ITEM_SPLITER = '\t';
	    /**
	     * Group series into two types
	     *  1. on category axis, like line, bar
	     *  2. others, like scatter, pie
	     */
	
	    function groupSeries(ecModel) {
	      var seriesGroupByCategoryAxis = {};
	      var otherSeries = [];
	      var meta = [];
	      ecModel.eachRawSeries(function (seriesModel) {
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
	          // TODO: TYPE Consider polar? Include polar may increase unecessary bundle size.
	          var baseAxis = coordSys.getBaseAxis();
	
	          if (baseAxis.type === 'category') {
	            var key = baseAxis.dim + '_' + baseAxis.index;
	
	            if (!seriesGroupByCategoryAxis[key]) {
	              seriesGroupByCategoryAxis[key] = {
	                categoryAxis: baseAxis,
	                valueAxis: coordSys.getOtherAxis(baseAxis),
	                series: []
	              };
	              meta.push({
	                axisDim: baseAxis.dim,
	                axisIndex: baseAxis.index
	              });
	            }
	
	            seriesGroupByCategoryAxis[key].series.push(seriesModel);
	          } else {
	            otherSeries.push(seriesModel);
	          }
	        } else {
	          otherSeries.push(seriesModel);
	        }
	      });
	      return {
	        seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
	        other: otherSeries,
	        meta: meta
	      };
	    }
	    /**
	     * Assemble content of series on cateogory axis
	     * @inner
	     */
	
	
	    function assembleSeriesWithCategoryAxis(groups) {
	      var tables = [];
	      each(groups, function (group, key) {
	        var categoryAxis = group.categoryAxis;
	        var valueAxis = group.valueAxis;
	        var valueAxisDim = valueAxis.dim;
	        var headers = [' '].concat(map(group.series, function (series) {
	          return series.name;
	        })); // @ts-ignore TODO Polar
	
	        var columns = [categoryAxis.model.getCategories()];
	        each(group.series, function (series) {
	          var rawData = series.getRawData();
	          columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function (val) {
	            return val;
	          }));
	        }); // Assemble table content
	
	        var lines = [headers.join(ITEM_SPLITER)];
	
	        for (var i = 0; i < columns[0].length; i++) {
	          var items = [];
	
	          for (var j = 0; j < columns.length; j++) {
	            items.push(columns[j][i]);
	          }
	
	          lines.push(items.join(ITEM_SPLITER));
	        }
	
	        tables.push(lines.join('\n'));
	      });
	      return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
	    }
	    /**
	     * Assemble content of other series
	     */
	
	
	    function assembleOtherSeries(series) {
	      return map(series, function (series) {
	        var data = series.getRawData();
	        var lines = [series.name];
	        var vals = [];
	        data.each(data.dimensions, function () {
	          var argLen = arguments.length;
	          var dataIndex = arguments[argLen - 1];
	          var name = data.getName(dataIndex);
	
	          for (var i = 0; i < argLen - 1; i++) {
	            vals[i] = arguments[i];
	          }
	
	          lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
	        });
	        return lines.join('\n');
	      }).join('\n\n' + BLOCK_SPLITER + '\n\n');
	    }
	
	    function getContentFromModel(ecModel) {
	      var result = groupSeries(ecModel);
	      return {
	        value: filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
	          return !!str.replace(/[\n\t\s]/g, '');
	        }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
	        meta: result.meta
	      };
	    }
	
	    function trim$1(str) {
	      return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	    /**
	     * If a block is tsv format
	     */
	
	
	    function isTSVFormat(block) {
	      // Simple method to find out if a block is tsv format
	      var firstLine = block.slice(0, block.indexOf('\n'));
	
	      if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
	        return true;
	      }
	    }
	
	    var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
	    /**
	     * @param {string} tsv
	     * @return {Object}
	     */
	
	    function parseTSVContents(tsv) {
	      var tsvLines = tsv.split(/\n+/g);
	      var headers = trim$1(tsvLines.shift()).split(itemSplitRegex);
	      var categories = [];
	      var series = map(headers, function (header) {
	        return {
	          name: header,
	          data: []
	        };
	      });
	
	      for (var i = 0; i < tsvLines.length; i++) {
	        var items = trim$1(tsvLines[i]).split(itemSplitRegex);
	        categories.push(items.shift());
	
	        for (var j = 0; j < items.length; j++) {
	          series[j] && (series[j].data[i] = items[j]);
	        }
	      }
	
	      return {
	        series: series,
	        categories: categories
	      };
	    }
	
	    function parseListContents(str) {
	      var lines = str.split(/\n+/g);
	      var seriesName = trim$1(lines.shift());
	      var data = [];
	
	      for (var i = 0; i < lines.length; i++) {
	        // if line is empty, ignore it.
	        // there is a case that a user forgot to delete `\n`.
	        var line = trim$1(lines[i]);
	
	        if (!line) {
	          continue;
	        }
	
	        var items = line.split(itemSplitRegex);
	        var name_1 = '';
	        var value = void 0;
	        var hasName = false;
	
	        if (isNaN(items[0])) {
	          // First item is name
	          hasName = true;
	          name_1 = items[0];
	          items = items.slice(1);
	          data[i] = {
	            name: name_1,
	            value: []
	          };
	          value = data[i].value;
	        } else {
	          value = data[i] = [];
	        }
	
	        for (var j = 0; j < items.length; j++) {
	          value.push(+items[j]);
	        }
	
	        if (value.length === 1) {
	          hasName ? data[i].value = value[0] : data[i] = value[0];
	        }
	      }
	
	      return {
	        name: seriesName,
	        data: data
	      };
	    }
	
	    function parseContents(str, blockMetaList) {
	      var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
	      var newOption = {
	        series: []
	      };
	      each(blocks, function (block, idx) {
	        if (isTSVFormat(block)) {
	          var result = parseTSVContents(block);
	          var blockMeta = blockMetaList[idx];
	          var axisKey = blockMeta.axisDim + 'Axis';
	
	          if (blockMeta) {
	            newOption[axisKey] = newOption[axisKey] || [];
	            newOption[axisKey][blockMeta.axisIndex] = {
	              data: result.categories
	            };
	            newOption.series = newOption.series.concat(result.series);
	          }
	        } else {
	          var result = parseListContents(block);
	          newOption.series.push(result);
	        }
	      });
	      return newOption;
	    }
	
	    var DataView =
	    /** @class */
	    function (_super) {
	      __extends(DataView, _super);
	
	      function DataView() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      DataView.prototype.onclick = function (ecModel, api) {
	        // FIXME: better way?
	        setTimeout(function () {
	          api.dispatchAction({
	            type: 'hideTip'
	          });
	        });
	        var container = api.getDom();
	        var model = this.model;
	
	        if (this._dom) {
	          container.removeChild(this._dom);
	        }
	
	        var root = document.createElement('div'); // use padding to avoid 5px whitespace
	
	        root.style.cssText = 'position:absolute;top:0;bottom:0;left:0;right:0;padding:5px';
	        root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements
	
	        var header = document.createElement('h4');
	        var lang = model.get('lang') || [];
	        header.innerHTML = lang[0] || model.get('title');
	        header.style.cssText = 'margin:10px 20px';
	        header.style.color = model.get('textColor');
	        var viewMain = document.createElement('div');
	        var textarea = document.createElement('textarea');
	        viewMain.style.cssText = 'overflow:auto';
	        var optionToContent = model.get('optionToContent');
	        var contentToOption = model.get('contentToOption');
	        var result = getContentFromModel(ecModel);
	
	        if (isFunction(optionToContent)) {
	          var htmlOrDom = optionToContent(api.getOption());
	
	          if (isString(htmlOrDom)) {
	            viewMain.innerHTML = htmlOrDom;
	          } else if (isDom(htmlOrDom)) {
	            viewMain.appendChild(htmlOrDom);
	          }
	        } else {
	          // Use default textarea
	          textarea.readOnly = model.get('readOnly');
	          var style = textarea.style; // eslint-disable-next-line max-len
	
	          style.cssText = 'display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none';
	          style.color = model.get('textColor');
	          style.borderColor = model.get('textareaBorderColor');
	          style.backgroundColor = model.get('textareaColor');
	          textarea.value = result.value;
	          viewMain.appendChild(textarea);
	        }
	
	        var blockMetaList = result.meta;
	        var buttonContainer = document.createElement('div');
	        buttonContainer.style.cssText = 'position:absolute;bottom:5px;left:0;right:0'; // eslint-disable-next-line max-len
	
	        var buttonStyle = 'float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
	        var closeButton = document.createElement('div');
	        var refreshButton = document.createElement('div');
	        buttonStyle += ';background-color:' + model.get('buttonColor');
	        buttonStyle += ';color:' + model.get('buttonTextColor');
	        var self = this;
	
	        function close() {
	          container.removeChild(root);
	          self._dom = null;
	        }
	
	        addEventListener(closeButton, 'click', close);
	        addEventListener(refreshButton, 'click', function () {
	          if (contentToOption == null && optionToContent != null || contentToOption != null && optionToContent == null) {
	            if (true) {
	              // eslint-disable-next-line
	              warn('It seems you have just provided one of `contentToOption` and `optionToContent` functions but missed the other one. Data change is ignored.');
	            }
	
	            close();
	            return;
	          }
	
	          var newOption;
	
	          try {
	            if (isFunction(contentToOption)) {
	              newOption = contentToOption(viewMain, api.getOption());
	            } else {
	              newOption = parseContents(textarea.value, blockMetaList);
	            }
	          } catch (e) {
	            close();
	            throw new Error('Data view format error ' + e);
	          }
	
	          if (newOption) {
	            api.dispatchAction({
	              type: 'changeDataView',
	              newOption: newOption
	            });
	          }
	
	          close();
	        });
	        closeButton.innerHTML = lang[1];
	        refreshButton.innerHTML = lang[2];
	        refreshButton.style.cssText = closeButton.style.cssText = buttonStyle;
	        !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
	        buttonContainer.appendChild(closeButton);
	        root.appendChild(header);
	        root.appendChild(viewMain);
	        root.appendChild(buttonContainer);
	        viewMain.style.height = container.clientHeight - 80 + 'px';
	        container.appendChild(root);
	        this._dom = root;
	      };
	
	      DataView.prototype.remove = function (ecModel, api) {
	        this._dom && api.getDom().removeChild(this._dom);
	      };
	
	      DataView.prototype.dispose = function (ecModel, api) {
	        this.remove(ecModel, api);
	      };
	
	      DataView.getDefaultOption = function (ecModel) {
	        var defaultOption = {
	          show: true,
	          readOnly: false,
	          optionToContent: null,
	          contentToOption: null,
	          // eslint-disable-next-line
	          icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
	          title: ecModel.getLocaleModel().get(['toolbox', 'dataView', 'title']),
	          lang: ecModel.getLocaleModel().get(['toolbox', 'dataView', 'lang']),
	          backgroundColor: '#fff',
	          textColor: '#000',
	          textareaColor: '#fff',
	          textareaBorderColor: '#333',
	          buttonColor: '#c23531',
	          buttonTextColor: '#fff'
	        };
	        return defaultOption;
	      };
	
	      return DataView;
	    }(ToolboxFeature);
	    /**
	     * @inner
	     */
	
	
	    function tryMergeDataOption(newData, originalData) {
	      return map(newData, function (newVal, idx) {
	        var original = originalData && originalData[idx];
	
	        if (isObject(original) && !isArray(original)) {
	          var newValIsObject = isObject(newVal) && !isArray(newVal);
	
	          if (!newValIsObject) {
	            newVal = {
	              value: newVal
	            };
	          } // original data has name but new data has no name
	
	
	          var shouldDeleteName = original.name != null && newVal.name == null; // Original data has option
	
	          newVal = defaults(newVal, original);
	          shouldDeleteName && delete newVal.name;
	          return newVal;
	        } else {
	          return newVal;
	        }
	      });
	    } // TODO: SELF REGISTERED.
	
	
	    registerAction({
	      type: 'changeDataView',
	      event: 'dataViewChanged',
	      update: 'prepareAndUpdate'
	    }, function (payload, ecModel) {
	      var newSeriesOptList = [];
	      each(payload.newOption.series, function (seriesOpt) {
	        var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
	
	        if (!seriesModel) {
	          // New created series
	          // Geuss the series type
	          newSeriesOptList.push(extend({
	            // Default is scatter
	            type: 'scatter'
	          }, seriesOpt));
	        } else {
	          var originalData = seriesModel.get('data');
	          newSeriesOptList.push({
	            name: seriesOpt.name,
	            data: tryMergeDataOption(seriesOpt.data, originalData)
	          });
	        }
	      });
	      ecModel.mergeOption(defaults({
	        series: newSeriesOptList
	      }, payload.newOption));
	    });
	
	    var each$9 = each;
	    var inner$f = makeInner();
	    /**
	     * @param ecModel
	     * @param newSnapshot key is dataZoomId
	     */
	
	    function push(ecModel, newSnapshot) {
	      var storedSnapshots = getStoreSnapshots(ecModel); // If previous dataZoom can not be found,
	      // complete an range with current range.
	
	      each$9(newSnapshot, function (batchItem, dataZoomId) {
	        var i = storedSnapshots.length - 1;
	
	        for (; i >= 0; i--) {
	          var snapshot = storedSnapshots[i];
	
	          if (snapshot[dataZoomId]) {
	            break;
	          }
	        }
	
	        if (i < 0) {
	          // No origin range set, create one by current range.
	          var dataZoomModel = ecModel.queryComponents({
	            mainType: 'dataZoom',
	            subType: 'select',
	            id: dataZoomId
	          })[0];
	
	          if (dataZoomModel) {
	            var percentRange = dataZoomModel.getPercentRange();
	            storedSnapshots[0][dataZoomId] = {
	              dataZoomId: dataZoomId,
	              start: percentRange[0],
	              end: percentRange[1]
	            };
	          }
	        }
	      });
	      storedSnapshots.push(newSnapshot);
	    }
	    function pop(ecModel) {
	      var storedSnapshots = getStoreSnapshots(ecModel);
	      var head = storedSnapshots[storedSnapshots.length - 1];
	      storedSnapshots.length > 1 && storedSnapshots.pop(); // Find top for all dataZoom.
	
	      var snapshot = {};
	      each$9(head, function (batchItem, dataZoomId) {
	        for (var i = storedSnapshots.length - 1; i >= 0; i--) {
	          batchItem = storedSnapshots[i][dataZoomId];
	
	          if (batchItem) {
	            snapshot[dataZoomId] = batchItem;
	            break;
	          }
	        }
	      });
	      return snapshot;
	    }
	    function clear$1(ecModel) {
	      inner$f(ecModel).snapshots = null;
	    }
	    function count(ecModel) {
	      return getStoreSnapshots(ecModel).length;
	    }
	    /**
	     * History length of each dataZoom may be different.
	     * this._history[0] is used to store origin range.
	     */
	
	    function getStoreSnapshots(ecModel) {
	      var store = inner$f(ecModel);
	
	      if (!store.snapshots) {
	        store.snapshots = [{}];
	      }
	
	      return store.snapshots;
	    }
	
	    var RestoreOption =
	    /** @class */
	    function (_super) {
	      __extends(RestoreOption, _super);
	
	      function RestoreOption() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      RestoreOption.prototype.onclick = function (ecModel, api) {
	        clear$1(ecModel);
	        api.dispatchAction({
	          type: 'restore',
	          from: this.uid
	        });
	      };
	
	      RestoreOption.getDefaultOption = function (ecModel) {
	        var defaultOption = {
	          show: true,
	          // eslint-disable-next-line
	          icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
	          title: ecModel.getLocaleModel().get(['toolbox', 'restore', 'title'])
	        };
	        return defaultOption;
	      };
	
	      return RestoreOption;
	    }(ToolboxFeature); // TODO: SELF REGISTERED.
	
	
	    registerAction({
	      type: 'restore',
	      event: 'restore',
	      update: 'prepareAndUpdate'
	    }, function (payload, ecModel) {
	      ecModel.resetOption('recreate');
	    });
	
	    // how to genarialize to more coordinate systems.
	
	    var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];
	
	    var BrushTargetManager =
	    /** @class */
	    function () {
	      /**
	       * @param finder contains Index/Id/Name of xAxis/yAxis/geo/grid
	       *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
	       * @param opt.include include coordinate system types.
	       */
	      function BrushTargetManager(finder, ecModel, opt) {
	        var _this = this;
	
	        this._targetInfoList = [];
	        var foundCpts = parseFinder$1(ecModel, finder);
	        each(targetInfoBuilders, function (builder, type) {
	          if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
	            builder(foundCpts, _this._targetInfoList);
	          }
	        });
	      }
	
	      BrushTargetManager.prototype.setOutputRanges = function (areas, ecModel) {
	        this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	          (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges
	
	          if (!area.coordRange) {
	            area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
	            // rebuild range by coordRange accrately, which may bring trouble when
	            // brushing only one item. So we use __rangeOffset to rebuilding range
	            // by coordRange. And this it only used in brush component so it is no
	            // need to be adapted to coordRanges.
	
	            var result = coordConvert[area.brushType](0, coordSys, coordRange);
	            area.__rangeOffset = {
	              offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
	              xyMinMax: result.xyMinMax
	            };
	          }
	        });
	        return areas;
	      };
	
	      BrushTargetManager.prototype.matchOutputRanges = function (areas, ecModel, cb) {
	        each(areas, function (area) {
	          var targetInfo = this.findTargetInfo(area, ecModel);
	
	          if (targetInfo && targetInfo !== true) {
	            each(targetInfo.coordSyses, function (coordSys) {
	              var result = coordConvert[area.brushType](1, coordSys, area.range, true);
	              cb(area, result.values, coordSys, ecModel);
	            });
	          }
	        }, this);
	      };
	      /**
	       * the `areas` is `BrushModel.areas`.
	       * Called in layout stage.
	       * convert `area.coordRange` to global range and set panelId to `area.range`.
	       */
	
	
	      BrushTargetManager.prototype.setInputRanges = function (areas, ecModel) {
	        each(areas, function (area) {
	          var targetInfo = this.findTargetInfo(area, ecModel);
	
	          if (true) {
	            assert(!targetInfo || targetInfo === true || area.coordRange, 'coordRange must be specified when coord index specified.');
	            assert(!targetInfo || targetInfo !== true || area.range, 'range must be specified in global brush.');
	          }
	
	          area.range = area.range || []; // convert coordRange to global range and set panelId.
	
	          if (targetInfo && targetInfo !== true) {
	            area.panelId = targetInfo.panelId; // (1) area.range should always be calculate from coordRange but does
	            // not keep its original value, for the sake of the dataZoom scenario,
	            // where area.coordRange remains unchanged but area.range may be changed.
	            // (2) Only support converting one coordRange to pixel range in brush
	            // component. So do not consider `coordRanges`.
	            // (3) About __rangeOffset, see comment above.
	
	            var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
	            var rangeOffset = area.__rangeOffset;
	            area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
	          }
	        }, this);
	      };
	
	      BrushTargetManager.prototype.makePanelOpts = function (api, getDefaultBrushType) {
	        return map(this._targetInfoList, function (targetInfo) {
	          var rect = targetInfo.getPanelRect();
	          return {
	            panelId: targetInfo.panelId,
	            defaultBrushType: getDefaultBrushType ? getDefaultBrushType(targetInfo) : null,
	            clipPath: makeRectPanelClipPath(rect),
	            isTargetByCursor: makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
	            getLinearBrushOtherExtent: makeLinearBrushOtherExtent(rect)
	          };
	        });
	      };
	
	      BrushTargetManager.prototype.controlSeries = function (area, seriesModel, ecModel) {
	        // Check whether area is bound in coord, and series do not belong to that coord.
	        // If do not do this check, some brush (like lineX) will controll all axes.
	        var targetInfo = this.findTargetInfo(area, ecModel);
	        return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
	      };
	      /**
	       * If return Object, a coord found.
	       * If return true, global found.
	       * Otherwise nothing found.
	       */
	
	
	      BrushTargetManager.prototype.findTargetInfo = function (area, ecModel) {
	        var targetInfoList = this._targetInfoList;
	        var foundCpts = parseFinder$1(ecModel, area);
	
	        for (var i = 0; i < targetInfoList.length; i++) {
	          var targetInfo = targetInfoList[i];
	          var areaPanelId = area.panelId;
	
	          if (areaPanelId) {
	            if (targetInfo.panelId === areaPanelId) {
	              return targetInfo;
	            }
	          } else {
	            for (var j = 0; j < targetInfoMatchers.length; j++) {
	              if (targetInfoMatchers[j](foundCpts, targetInfo)) {
	                return targetInfo;
	              }
	            }
	          }
	        }
	
	        return true;
	      };
	
	      return BrushTargetManager;
	    }();
	
	    function formatMinMax(minMax) {
	      minMax[0] > minMax[1] && minMax.reverse();
	      return minMax;
	    }
	
	    function parseFinder$1(ecModel, finder) {
	      return parseFinder(ecModel, finder, {
	        includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
	      });
	    }
	
	    var targetInfoBuilders = {
	      grid: function (foundCpts, targetInfoList) {
	        var xAxisModels = foundCpts.xAxisModels;
	        var yAxisModels = foundCpts.yAxisModels;
	        var gridModels = foundCpts.gridModels; // Remove duplicated.
	
	        var gridModelMap = createHashMap();
	        var xAxesHas = {};
	        var yAxesHas = {};
	
	        if (!xAxisModels && !yAxisModels && !gridModels) {
	          return;
	        }
	
	        each(xAxisModels, function (axisModel) {
	          var gridModel = axisModel.axis.grid.model;
	          gridModelMap.set(gridModel.id, gridModel);
	          xAxesHas[gridModel.id] = true;
	        });
	        each(yAxisModels, function (axisModel) {
	          var gridModel = axisModel.axis.grid.model;
	          gridModelMap.set(gridModel.id, gridModel);
	          yAxesHas[gridModel.id] = true;
	        });
	        each(gridModels, function (gridModel) {
	          gridModelMap.set(gridModel.id, gridModel);
	          xAxesHas[gridModel.id] = true;
	          yAxesHas[gridModel.id] = true;
	        });
	        gridModelMap.each(function (gridModel) {
	          var grid = gridModel.coordinateSystem;
	          var cartesians = [];
	          each(grid.getCartesians(), function (cartesian, index) {
	            if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
	              cartesians.push(cartesian);
	            }
	          });
	          targetInfoList.push({
	            panelId: 'grid--' + gridModel.id,
	            gridModel: gridModel,
	            coordSysModel: gridModel,
	            // Use the first one as the representitive coordSys.
	            coordSys: cartesians[0],
	            coordSyses: cartesians,
	            getPanelRect: panelRectBuilders.grid,
	            xAxisDeclared: xAxesHas[gridModel.id],
	            yAxisDeclared: yAxesHas[gridModel.id]
	          });
	        });
	      },
	      geo: function (foundCpts, targetInfoList) {
	        each(foundCpts.geoModels, function (geoModel) {
	          var coordSys = geoModel.coordinateSystem;
	          targetInfoList.push({
	            panelId: 'geo--' + geoModel.id,
	            geoModel: geoModel,
	            coordSysModel: geoModel,
	            coordSys: coordSys,
	            coordSyses: [coordSys],
	            getPanelRect: panelRectBuilders.geo
	          });
	        });
	      }
	    };
	    var targetInfoMatchers = [// grid
	    function (foundCpts, targetInfo) {
	      var xAxisModel = foundCpts.xAxisModel;
	      var yAxisModel = foundCpts.yAxisModel;
	      var gridModel = foundCpts.gridModel;
	      !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
	      !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
	      return gridModel && gridModel === targetInfo.gridModel;
	    }, // geo
	    function (foundCpts, targetInfo) {
	      var geoModel = foundCpts.geoModel;
	      return geoModel && geoModel === targetInfo.geoModel;
	    }];
	    var panelRectBuilders = {
	      grid: function () {
	        // grid is not Transformable.
	        return this.coordSys.master.getRect().clone();
	      },
	      geo: function () {
	        var coordSys = this.coordSys;
	        var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform
	
	        rect.applyTransform(getTransform(coordSys));
	        return rect;
	      }
	    };
	    var coordConvert = {
	      lineX: curry(axisConvert, 0),
	      lineY: curry(axisConvert, 1),
	      rect: function (to, coordSys, rangeOrCoordRange, clamp) {
	        var xminymin = to ? coordSys.pointToData([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]], clamp) : coordSys.dataToPoint([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]], clamp);
	        var xmaxymax = to ? coordSys.pointToData([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]], clamp) : coordSys.dataToPoint([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]], clamp);
	        var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
	        return {
	          values: values,
	          xyMinMax: values
	        };
	      },
	      polygon: function (to, coordSys, rangeOrCoordRange, clamp) {
	        var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
	        var values = map(rangeOrCoordRange, function (item) {
	          var p = to ? coordSys.pointToData(item, clamp) : coordSys.dataToPoint(item, clamp);
	          xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
	          xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
	          xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
	          xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
	          return p;
	        });
	        return {
	          values: values,
	          xyMinMax: xyMinMax
	        };
	      }
	    };
	
	    function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
	      if (true) {
	        assert(coordSys.type === 'cartesian2d', 'lineX/lineY brush is available only in cartesian2d.');
	      }
	
	      var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
	      var values = formatMinMax(map([0, 1], function (i) {
	        return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i]), true) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
	      }));
	      var xyMinMax = [];
	      xyMinMax[axisNameIndex] = values;
	      xyMinMax[1 - axisNameIndex] = [NaN, NaN];
	      return {
	        values: values,
	        xyMinMax: xyMinMax
	      };
	    }
	
	    var diffProcessor = {
	      lineX: curry(axisDiffProcessor, 0),
	      lineY: curry(axisDiffProcessor, 1),
	      rect: function (values, refer, scales) {
	        return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
	      },
	      polygon: function (values, refer, scales) {
	        return map(values, function (item, idx) {
	          return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
	        });
	      }
	    };
	
	    function axisDiffProcessor(axisNameIndex, values, refer, scales) {
	      return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
	    } // We have to process scale caused by dataZoom manually,
	    // although it might be not accurate.
	    // Return [0~1, 0~1]
	
	
	    function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
	      var sizeCurr = getSize$1(xyMinMaxCurr);
	      var sizeOrigin = getSize$1(xyMinMaxOrigin);
	      var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
	      isNaN(scales[0]) && (scales[0] = 1);
	      isNaN(scales[1]) && (scales[1] = 1);
	      return scales;
	    }
	
	    function getSize$1(xyMinMax) {
	      return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
	    }
	
	    var each$a = each;
	    var DATA_ZOOM_ID_BASE = makeInternalComponentId('toolbox-dataZoom_');
	
	    var DataZoomFeature =
	    /** @class */
	    function (_super) {
	      __extends(DataZoomFeature, _super);
	
	      function DataZoomFeature() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      DataZoomFeature.prototype.render = function (featureModel, ecModel, api, payload) {
	        if (!this._brushController) {
	          this._brushController = new BrushController(api.getZr());
	
	          this._brushController.on('brush', bind(this._onBrush, this)).mount();
	        }
	
	        updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
	        updateBackBtnStatus(featureModel, ecModel);
	      };
	
	      DataZoomFeature.prototype.onclick = function (ecModel, api, type) {
	        handlers$1[type].call(this);
	      };
	
	      DataZoomFeature.prototype.remove = function (ecModel, api) {
	        this._brushController && this._brushController.unmount();
	      };
	
	      DataZoomFeature.prototype.dispose = function (ecModel, api) {
	        this._brushController && this._brushController.dispose();
	      };
	
	      DataZoomFeature.prototype._onBrush = function (eventParam) {
	        var areas = eventParam.areas;
	
	        if (!eventParam.isEnd || !areas.length) {
	          return;
	        }
	
	        var snapshot = {};
	        var ecModel = this.ecModel;
	
	        this._brushController.updateCovers([]); // remove cover
	
	
	        var brushTargetManager = new BrushTargetManager(makeAxisFinder(this.model), ecModel, {
	          include: ['grid']
	        });
	        brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	          if (coordSys.type !== 'cartesian2d') {
	            return;
	          }
	
	          var brushType = area.brushType;
	
	          if (brushType === 'rect') {
	            setBatch('x', coordSys, coordRange[0]);
	            setBatch('y', coordSys, coordRange[1]);
	          } else {
	            setBatch({
	              lineX: 'x',
	              lineY: 'y'
	            }[brushType], coordSys, coordRange);
	          }
	        });
	        push(ecModel, snapshot);
	
	        this._dispatchZoomAction(snapshot);
	
	        function setBatch(dimName, coordSys, minMax) {
	          var axis = coordSys.getAxis(dimName);
	          var axisModel = axis.model;
	          var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.
	
	          var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
	
	          if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
	            minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
	          }
	
	          dataZoomModel && (snapshot[dataZoomModel.id] = {
	            dataZoomId: dataZoomModel.id,
	            startValue: minMax[0],
	            endValue: minMax[1]
	          });
	        }
	
	        function findDataZoom(dimName, axisModel, ecModel) {
	          var found;
	          ecModel.eachComponent({
	            mainType: 'dataZoom',
	            subType: 'select'
	          }, function (dzModel) {
	            var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
	            has && (found = dzModel);
	          });
	          return found;
	        }
	      };
	
	      DataZoomFeature.prototype._dispatchZoomAction = function (snapshot) {
	        var batch = []; // Convert from hash map to array.
	
	        each$a(snapshot, function (batchItem, dataZoomId) {
	          batch.push(clone(batchItem));
	        });
	        batch.length && this.api.dispatchAction({
	          type: 'dataZoom',
	          from: this.uid,
	          batch: batch
	        });
	      };
	
	      DataZoomFeature.getDefaultOption = function (ecModel) {
	        var defaultOption = {
	          show: true,
	          filterMode: 'filter',
	          // Icon group
	          icon: {
	            zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
	            back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
	          },
	          // `zoom`, `back`
	          title: ecModel.getLocaleModel().get(['toolbox', 'dataZoom', 'title']),
	          brushStyle: {
	            borderWidth: 0,
	            color: 'rgba(210,219,238,0.2)'
	          }
	        };
	        return defaultOption;
	      };
	
	      return DataZoomFeature;
	    }(ToolboxFeature);
	
	    var handlers$1 = {
	      zoom: function () {
	        var nextActive = !this._isZoomActive;
	        this.api.dispatchAction({
	          type: 'takeGlobalCursor',
	          key: 'dataZoomSelect',
	          dataZoomSelectActive: nextActive
	        });
	      },
	      back: function () {
	        this._dispatchZoomAction(pop(this.ecModel));
	      }
	    };
	
	    function makeAxisFinder(dzFeatureModel) {
	      var setting = {
	        xAxisIndex: dzFeatureModel.get('xAxisIndex', true),
	        yAxisIndex: dzFeatureModel.get('yAxisIndex', true),
	        xAxisId: dzFeatureModel.get('xAxisId', true),
	        yAxisId: dzFeatureModel.get('yAxisId', true)
	      }; // If both `xAxisIndex` `xAxisId` not set, it means 'all'.
	      // If both `yAxisIndex` `yAxisId` not set, it means 'all'.
	      // Some old cases set like this below to close yAxis control but leave xAxis control:
	      // `{ feature: { dataZoom: { yAxisIndex: false } }`.
	
	      if (setting.xAxisIndex == null && setting.xAxisId == null) {
	        setting.xAxisIndex = 'all';
	      }
	
	      if (setting.yAxisIndex == null && setting.yAxisId == null) {
	        setting.yAxisIndex = 'all';
	      }
	
	      return setting;
	    }
	
	    function updateBackBtnStatus(featureModel, ecModel) {
	      featureModel.setIconStatus('back', count(ecModel) > 1 ? 'emphasis' : 'normal');
	    }
	
	    function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
	      var zoomActive = view._isZoomActive;
	
	      if (payload && payload.type === 'takeGlobalCursor') {
	        zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
	      }
	
	      view._isZoomActive = zoomActive;
	      featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
	      var brushTargetManager = new BrushTargetManager(makeAxisFinder(featureModel), ecModel, {
	        include: ['grid']
	      });
	      var panels = brushTargetManager.makePanelOpts(api, function (targetInfo) {
	        return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
	      });
	
	      view._brushController.setPanels(panels).enableBrush(zoomActive && panels.length ? {
	        brushType: 'auto',
	        brushStyle: featureModel.getModel('brushStyle').getItemStyle()
	      } : false);
	    }
	
	    registerInternalOptionCreator('dataZoom', function (ecModel) {
	      var toolboxModel = ecModel.getComponent('toolbox', 0);
	      var featureDataZoomPath = ['feature', 'dataZoom'];
	
	      if (!toolboxModel || toolboxModel.get(featureDataZoomPath) == null) {
	        return;
	      }
	
	      var dzFeatureModel = toolboxModel.getModel(featureDataZoomPath);
	      var dzOptions = [];
	      var finder = makeAxisFinder(dzFeatureModel);
	      var finderResult = parseFinder(ecModel, finder);
	      each$a(finderResult.xAxisModels, function (axisModel) {
	        return buildInternalOptions(axisModel, 'xAxis', 'xAxisIndex');
	      });
	      each$a(finderResult.yAxisModels, function (axisModel) {
	        return buildInternalOptions(axisModel, 'yAxis', 'yAxisIndex');
	      });
	
	      function buildInternalOptions(axisModel, axisMainType, axisIndexPropName) {
	        var axisIndex = axisModel.componentIndex;
	        var newOpt = {
	          type: 'select',
	          $fromToolbox: true,
	          // Default to be filter
	          filterMode: dzFeatureModel.get('filterMode', true) || 'filter',
	          // Id for merge mapping.
	          id: DATA_ZOOM_ID_BASE + axisMainType + axisIndex
	        };
	        newOpt[axisIndexPropName] = axisIndex;
	        dzOptions.push(newOpt);
	      }
	
	      return dzOptions;
	    });
	
	    function install$z(registers) {
	      registers.registerComponentModel(ToolboxModel);
	      registers.registerComponentView(ToolboxView);
	      registerFeature('saveAsImage', SaveAsImage);
	      registerFeature('magicType', MagicType);
	      registerFeature('dataView', DataView);
	      registerFeature('dataZoom', DataZoomFeature);
	      registerFeature('restore', RestoreOption);
	      use(install$y);
	    }
	
	    var TooltipModel =
	    /** @class */
	    function (_super) {
	      __extends(TooltipModel, _super);
	
	      function TooltipModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = TooltipModel.type;
	        return _this;
	      }
	
	      TooltipModel.type = 'tooltip';
	      TooltipModel.dependencies = ['axisPointer'];
	      TooltipModel.defaultOption = {
	        // zlevel: 0,
	        z: 60,
	        show: true,
	        // tooltip main content
	        showContent: true,
	        // 'trigger' only works on coordinate system.
	        // 'item' | 'axis' | 'none'
	        trigger: 'item',
	        // 'click' | 'mousemove' | 'none'
	        triggerOn: 'mousemove|click',
	        alwaysShowContent: false,
	        displayMode: 'single',
	        renderMode: 'auto',
	        // whether restraint content inside viewRect.
	        // If renderMode: 'richText', default true.
	        // If renderMode: 'html', defaut false (for backward compat).
	        confine: null,
	        showDelay: 0,
	        hideDelay: 100,
	        // Animation transition time, unit is second
	        transitionDuration: 0.4,
	        enterable: false,
	        backgroundColor: '#fff',
	        // box shadow
	        shadowBlur: 10,
	        shadowColor: 'rgba(0, 0, 0, .2)',
	        shadowOffsetX: 1,
	        shadowOffsetY: 2,
	        // tooltip border radius, unit is px, default is 4
	        borderRadius: 4,
	        // tooltip border width, unit is px, default is 0 (no border)
	        borderWidth: 1,
	        // Tooltip inside padding, default is 5 for all direction
	        // Array is allowed to set up, right, bottom, left, same with css
	        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
	        padding: null,
	        // Extra css text
	        extraCssText: '',
	        // axis indicator, trigger by axis
	        axisPointer: {
	          // default is line
	          // legal values: 'line' | 'shadow' | 'cross'
	          type: 'line',
	          // Valid when type is line, appoint tooltip line locate on which line. Optional
	          // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
	          // default is 'auto', chose the axis which type is category.
	          // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
	          axis: 'auto',
	          animation: 'auto',
	          animationDurationUpdate: 200,
	          animationEasingUpdate: 'exponentialOut',
	          crossStyle: {
	            color: '#999',
	            width: 1,
	            type: 'dashed',
	            // TODO formatter
	            textStyle: {}
	          } // lineStyle and shadowStyle should not be specified here,
	          // otherwise it will always override those styles on option.axisPointer.
	
	        },
	        textStyle: {
	          color: '#666',
	          fontSize: 14
	        }
	      };
	      return TooltipModel;
	    }(ComponentModel);
	
	    /* global document */
	
	    function shouldTooltipConfine(tooltipModel) {
	      var confineOption = tooltipModel.get('confine');
	      return confineOption != null ? !!confineOption // In richText mode, the outside part can not be visible.
	      : tooltipModel.get('renderMode') === 'richText';
	    }
	
	    function testStyle(styleProps) {
	      if (!env.domSupported) {
	        return;
	      }
	
	      var style = document.documentElement.style;
	
	      for (var i = 0, len = styleProps.length; i < len; i++) {
	        if (styleProps[i] in style) {
	          return styleProps[i];
	        }
	      }
	    }
	
	    var TRANSFORM_VENDOR = testStyle(['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	    var TRANSITION_VENDOR = testStyle(['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	    function toCSSVendorPrefix(styleVendor, styleProp) {
	      if (!styleVendor) {
	        return styleProp;
	      }
	
	      styleProp = toCamelCase(styleProp, true);
	      var idx = styleVendor.indexOf(styleProp);
	      styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
	      return styleVendor.toLowerCase();
	    }
	    function getComputedStyle(el, style) {
	      var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
	      return stl ? style ? stl[style] : stl : null;
	    }
	
	    /* global document, window */
	
	    var CSS_TRANSITION_VENDOR = toCSSVendorPrefix(TRANSITION_VENDOR, 'transition');
	    var CSS_TRANSFORM_VENDOR = toCSSVendorPrefix(TRANSFORM_VENDOR, 'transform'); // eslint-disable-next-line
	
	    var gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + (env.transform3dSupported ? 'will-change:transform;' : '');
	
	    function mirrorPos(pos) {
	      pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
	      return pos;
	    }
	
	    function assembleArrow(tooltipModel, borderColor, arrowPosition) {
	      if (!isString(arrowPosition) || arrowPosition === 'inside') {
	        return '';
	      }
	
	      var backgroundColor = tooltipModel.get('backgroundColor');
	      var borderWidth = tooltipModel.get('borderWidth');
	      borderColor = convertToColorString(borderColor);
	      var arrowPos = mirrorPos(arrowPosition);
	      var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
	      var positionStyle = '';
	      var transformStyle = CSS_TRANSFORM_VENDOR + ':';
	      var rotateDeg;
	
	      if (indexOf(['left', 'right'], arrowPos) > -1) {
	        positionStyle += 'top:50%';
	        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
	      } else {
	        positionStyle += 'left:50%';
	        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
	      }
	
	      var rotateRadian = rotateDeg * Math.PI / 180;
	      var arrowWH = arrowSize + borderWidth;
	      var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
	      var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
	      positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
	      var borderStyle = borderColor + " solid " + borderWidth + "px;";
	      var styleCss = ["position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;", positionStyle + ";" + transformStyle + ";", "border-bottom:" + borderStyle, "border-right:" + borderStyle, "background-color:" + backgroundColor + ";"];
	      return "<div style=\"" + styleCss.join('') + "\"></div>";
	    }
	
	    function assembleTransition(duration, onlyFade) {
	      var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
	      var transitionOption = " " + duration / 2 + "s " + transitionCurve;
	      var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
	
	      if (!onlyFade) {
	        transitionOption = " " + duration + "s " + transitionCurve;
	        transitionText += env.transformSupported ? "," + CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
	      }
	
	      return CSS_TRANSITION_VENDOR + ':' + transitionText;
	    }
	
	    function assembleTransform(x, y, toString) {
	      // If using float on style, the final width of the dom might
	      // keep changing slightly while mouse move. So `toFixed(0)` them.
	      var x0 = x.toFixed(0) + 'px';
	      var y0 = y.toFixed(0) + 'px'; // not support transform, use `left` and `top` instead.
	
	      if (!env.transformSupported) {
	        return toString ? "top:" + y0 + ";left:" + x0 + ";" : [['top', y0], ['left', x0]];
	      } // support transform
	
	
	      var is3d = env.transform3dSupported;
	      var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
	      return toString ? 'top:0;left:0;' + CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [['top', 0], ['left', 0], [TRANSFORM_VENDOR, translate]];
	    }
	    /**
	     * @param {Object} textStyle
	     * @return {string}
	     * @inner
	     */
	
	
	    function assembleFont(textStyleModel) {
	      var cssText = [];
	      var fontSize = textStyleModel.get('fontSize');
	      var color = textStyleModel.getTextColor();
	      color && cssText.push('color:' + color);
	      cssText.push('font:' + textStyleModel.getFont());
	      fontSize // @ts-ignore, leave it to the tooltip refactor.
	      && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
	      var shadowColor = textStyleModel.get('textShadowColor');
	      var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
	      var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
	      var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
	      shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
	      each(['decoration', 'align'], function (name) {
	        var val = textStyleModel.get(name);
	        val && cssText.push('text-' + name + ':' + val);
	      });
	      return cssText.join(';');
	    }
	
	    function assembleCssText(tooltipModel, enableTransition, onlyFade) {
	      var cssText = [];
	      var transitionDuration = tooltipModel.get('transitionDuration');
	      var backgroundColor = tooltipModel.get('backgroundColor');
	      var shadowBlur = tooltipModel.get('shadowBlur');
	      var shadowColor = tooltipModel.get('shadowColor');
	      var shadowOffsetX = tooltipModel.get('shadowOffsetX');
	      var shadowOffsetY = tooltipModel.get('shadowOffsetY');
	      var textStyleModel = tooltipModel.getModel('textStyle');
	      var padding = getPaddingFromTooltipModel(tooltipModel, 'html');
	      var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
	      cssText.push('box-shadow:' + boxShadow); // Animation transition. Do not animate when transitionDuration is 0.
	
	      enableTransition && transitionDuration && cssText.push(assembleTransition(transitionDuration, onlyFade));
	
	      if (backgroundColor) {
	        cssText.push('background-color:' + backgroundColor);
	      } // Border style
	
	
	      each(['width', 'color', 'radius'], function (name) {
	        var borderName = 'border-' + name;
	        var camelCase = toCamelCase(borderName);
	        var val = tooltipModel.get(camelCase);
	        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
	      }); // Text style
	
	      cssText.push(assembleFont(textStyleModel)); // Padding
	
	      if (padding != null) {
	        cssText.push('padding:' + normalizeCssArray$1(padding).join('px ') + 'px');
	      }
	
	      return cssText.join(';') + ';';
	    } // If not able to make, do not modify the input `out`.
	
	
	    function makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
	      var zrPainter = zr && zr.painter;
	
	      if (appendToBody) {
	        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
	
	        if (zrViewportRoot) {
	          // Some APPs might use scale on body, so we support CSS transform here.
	          transformLocalCoord(out, zrViewportRoot, document.body, zrX, zrY);
	        }
	      } else {
	        out[0] = zrX;
	        out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
	        // the sibling of canvas root. So padding of ec container
	        // should be considered here.
	
	        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
	
	        if (viewportRootOffset) {
	          out[0] += viewportRootOffset.offsetLeft;
	          out[1] += viewportRootOffset.offsetTop;
	        }
	      }
	
	      out[2] = out[0] / zr.getWidth();
	      out[3] = out[1] / zr.getHeight();
	    }
	
	    var TooltipHTMLContent =
	    /** @class */
	    function () {
	      function TooltipHTMLContent(container, api, opt) {
	        this._show = false;
	        this._styleCoord = [0, 0, 0, 0];
	        this._enterable = true;
	        this._alwaysShowContent = false;
	        this._firstShow = true;
	        this._longHide = true;
	
	        if (env.wxa) {
	          return null;
	        }
	
	        var el = document.createElement('div'); // TODO: TYPE
	
	        el.domBelongToZr = true;
	        this.el = el;
	        var zr = this._zr = api.getZr();
	        var appendToBody = this._appendToBody = opt && opt.appendToBody;
	        makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
	
	        if (appendToBody) {
	          document.body.appendChild(el);
	        } else {
	          container.appendChild(el);
	        }
	
	        this._container = container; // FIXME
	        // Is it needed to trigger zr event manually if
	        // the browser do not support `pointer-events: none`.
	
	        var self = this;
	
	        el.onmouseenter = function () {
	          // clear the timeout in hideLater and keep showing tooltip
	          if (self._enterable) {
	            clearTimeout(self._hideTimeout);
	            self._show = true;
	          }
	
	          self._inContent = true;
	        };
	
	        el.onmousemove = function (e) {
	          e = e || window.event;
	
	          if (!self._enterable) {
	            // `pointer-events: none` is set to tooltip content div
	            // if `enterable` is set as `false`, and `el.onmousemove`
	            // can not be triggered. But in browser that do not
	            // support `pointer-events`, we need to do this:
	            // Try trigger zrender event to avoid mouse
	            // in and out shape too frequently
	            var handler = zr.handler;
	            var zrViewportRoot = zr.painter.getViewportRoot();
	            normalizeEvent(zrViewportRoot, e, true);
	            handler.dispatch('mousemove', e);
	          }
	        };
	
	        el.onmouseleave = function () {
	          // set `_inContent` to `false` before `hideLater`
	          self._inContent = false;
	
	          if (self._enterable) {
	            if (self._show) {
	              self.hideLater(self._hideDelay);
	            }
	          }
	        };
	      }
	      /**
	       * Update when tooltip is rendered
	       */
	
	
	      TooltipHTMLContent.prototype.update = function (tooltipModel) {
	        // FIXME
	        // Move this logic to ec main?
	        var container = this._container;
	        var position = getComputedStyle(container, 'position');
	        var domStyle = container.style;
	
	        if (domStyle.position !== 'absolute' && position !== 'absolute') {
	          domStyle.position = 'relative';
	        } // move tooltip if chart resized
	
	
	        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	        alwaysShowContent && this._moveIfResized(); // update alwaysShowContent
	
	        this._alwaysShowContent = alwaysShowContent; // update className
	
	        this.el.className = tooltipModel.get('className') || ''; // Hide the tooltip
	        // PENDING
	        // this.hide();
	      };
	
	      TooltipHTMLContent.prototype.show = function (tooltipModel, nearPointColor) {
	        clearTimeout(this._hideTimeout);
	        clearTimeout(this._longHideTimeout);
	        var el = this.el;
	        var style = el.style;
	        var styleCoord = this._styleCoord;
	
	        if (!el.innerHTML) {
	          style.display = 'none';
	        } else {
	          style.cssText = gCssText + assembleCssText(tooltipModel, !this._firstShow, this._longHide) // initial transform
	          + assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + convertToColorString(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') // If mouse occasionally move over the tooltip, a mouseout event will be
	          // triggered by canvas, and cause some unexpectable result like dragging
	          // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
	          // it. Although it is not supported by IE8~IE10, fortunately it is a rare
	          // scenario.
	          + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
	        }
	
	        this._show = true;
	        this._firstShow = false;
	        this._longHide = false;
	      };
	
	      TooltipHTMLContent.prototype.setContent = function (content, markers, tooltipModel, borderColor, arrowPosition) {
	        var el = this.el;
	
	        if (content == null) {
	          el.innerHTML = '';
	          return;
	        }
	
	        var arrow = '';
	
	        if (isString(arrowPosition) && tooltipModel.get('trigger') === 'item' && !shouldTooltipConfine(tooltipModel)) {
	          arrow = assembleArrow(tooltipModel, borderColor, arrowPosition);
	        }
	
	        if (isString(content)) {
	          el.innerHTML = content + arrow;
	        } else if (content) {
	          // Clear previous
	          el.innerHTML = '';
	
	          if (!isArray(content)) {
	            content = [content];
	          }
	
	          for (var i = 0; i < content.length; i++) {
	            if (isDom(content[i]) && content[i].parentNode !== el) {
	              el.appendChild(content[i]);
	            }
	          } // no arrow if empty
	
	
	          if (arrow && el.childNodes.length) {
	            // no need to create a new parent element, but it's not supported by IE 10 and older.
	            // const arrowEl = document.createRange().createContextualFragment(arrow);
	            var arrowEl = document.createElement('div');
	            arrowEl.innerHTML = arrow;
	            el.appendChild(arrowEl);
	          }
	        }
	      };
	
	      TooltipHTMLContent.prototype.setEnterable = function (enterable) {
	        this._enterable = enterable;
	      };
	
	      TooltipHTMLContent.prototype.getSize = function () {
	        var el = this.el;
	        return [el.offsetWidth, el.offsetHeight];
	      };
	
	      TooltipHTMLContent.prototype.moveTo = function (zrX, zrY) {
	        var styleCoord = this._styleCoord;
	        makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
	
	        if (styleCoord[0] != null && styleCoord[1] != null) {
	          var style_1 = this.el.style;
	          var transforms = assembleTransform(styleCoord[0], styleCoord[1]);
	          each(transforms, function (transform) {
	            style_1[transform[0]] = transform[1];
	          });
	        }
	      };
	      /**
	       * when `alwaysShowContent` is true,
	       * move the tooltip after chart resized
	       */
	
	
	      TooltipHTMLContent.prototype._moveIfResized = function () {
	        // The ratio of left to width
	        var ratioX = this._styleCoord[2]; // The ratio of top to height
	
	        var ratioY = this._styleCoord[3];
	        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
	      };
	
	      TooltipHTMLContent.prototype.hide = function () {
	        var _this = this;
	
	        var style = this.el.style;
	        style.visibility = 'hidden';
	        style.opacity = '0';
	        env.transform3dSupported && (style.willChange = '');
	        this._show = false;
	        this._longHideTimeout = setTimeout(function () {
	          return _this._longHide = true;
	        }, 500);
	      };
	
	      TooltipHTMLContent.prototype.hideLater = function (time) {
	        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
	          if (time) {
	            this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	            this._show = false;
	            this._hideTimeout = setTimeout(bind(this.hide, this), time);
	          } else {
	            this.hide();
	          }
	        }
	      };
	
	      TooltipHTMLContent.prototype.isShow = function () {
	        return this._show;
	      };
	
	      TooltipHTMLContent.prototype.dispose = function () {
	        this.el.parentNode.removeChild(this.el);
	      };
	
	      return TooltipHTMLContent;
	    }();
	
	    var TooltipRichContent =
	    /** @class */
	    function () {
	      function TooltipRichContent(api) {
	        this._show = false;
	        this._styleCoord = [0, 0, 0, 0];
	        this._alwaysShowContent = false;
	        this._enterable = true;
	        this._zr = api.getZr();
	        makeStyleCoord$1(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
	      }
	      /**
	       * Update when tooltip is rendered
	       */
	
	
	      TooltipRichContent.prototype.update = function (tooltipModel) {
	        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	        alwaysShowContent && this._moveIfResized(); // update alwaysShowContent
	
	        this._alwaysShowContent = alwaysShowContent;
	      };
	
	      TooltipRichContent.prototype.show = function () {
	        if (this._hideTimeout) {
	          clearTimeout(this._hideTimeout);
	        }
	
	        this.el.show();
	        this._show = true;
	      };
	      /**
	       * Set tooltip content
	       */
	
	
	      TooltipRichContent.prototype.setContent = function (content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
	        var _this = this;
	
	        if (isObject(content)) {
	          throwError( true ? 'Passing DOM nodes as content is not supported in richText tooltip!' : '');
	        }
	
	        if (this.el) {
	          this._zr.remove(this.el);
	        }
	
	        var textStyleModel = tooltipModel.getModel('textStyle');
	        this.el = new ZRText({
	          style: {
	            rich: markupStyleCreator.richTextStyles,
	            text: content,
	            lineHeight: 22,
	            borderWidth: 1,
	            borderColor: borderColor,
	            textShadowColor: textStyleModel.get('textShadowColor'),
	            fill: tooltipModel.get(['textStyle', 'color']),
	            padding: getPaddingFromTooltipModel(tooltipModel, 'richText'),
	            verticalAlign: 'top',
	            align: 'left'
	          },
	          z: tooltipModel.get('z')
	        });
	        each(['backgroundColor', 'borderRadius', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'], function (propName) {
	          _this.el.style[propName] = tooltipModel.get(propName);
	        });
	        each(['textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY'], function (propName) {
	          _this.el.style[propName] = textStyleModel.get(propName) || 0;
	        });
	
	        this._zr.add(this.el);
	
	        var self = this;
	        this.el.on('mouseover', function () {
	          // clear the timeout in hideLater and keep showing tooltip
	          if (self._enterable) {
	            clearTimeout(self._hideTimeout);
	            self._show = true;
	          }
	
	          self._inContent = true;
	        });
	        this.el.on('mouseout', function () {
	          if (self._enterable) {
	            if (self._show) {
	              self.hideLater(self._hideDelay);
	            }
	          }
	
	          self._inContent = false;
	        });
	      };
	
	      TooltipRichContent.prototype.setEnterable = function (enterable) {
	        this._enterable = enterable;
	      };
	
	      TooltipRichContent.prototype.getSize = function () {
	        var el = this.el;
	        var bounding = this.el.getBoundingRect(); // bounding rect does not include shadow. For renderMode richText,
	        // if overflow, it will be cut. So calculate them accurately.
	
	        var shadowOuterSize = calcShadowOuterSize(el.style);
	        return [bounding.width + shadowOuterSize.left + shadowOuterSize.right, bounding.height + shadowOuterSize.top + shadowOuterSize.bottom];
	      };
	
	      TooltipRichContent.prototype.moveTo = function (x, y) {
	        var el = this.el;
	
	        if (el) {
	          var styleCoord = this._styleCoord;
	          makeStyleCoord$1(styleCoord, this._zr, x, y);
	          x = styleCoord[0];
	          y = styleCoord[1];
	          var style = el.style;
	          var borderWidth = mathMaxWith0(style.borderWidth || 0);
	          var shadowOuterSize = calcShadowOuterSize(style); // rich text x, y do not include border.
	
	          el.x = x + borderWidth + shadowOuterSize.left;
	          el.y = y + borderWidth + shadowOuterSize.top;
	          el.markRedraw();
	        }
	      };
	      /**
	       * when `alwaysShowContent` is true,
	       * move the tooltip after chart resized
	       */
	
	
	      TooltipRichContent.prototype._moveIfResized = function () {
	        // The ratio of left to width
	        var ratioX = this._styleCoord[2]; // The ratio of top to height
	
	        var ratioY = this._styleCoord[3];
	        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
	      };
	
	      TooltipRichContent.prototype.hide = function () {
	        if (this.el) {
	          this.el.hide();
	        }
	
	        this._show = false;
	      };
	
	      TooltipRichContent.prototype.hideLater = function (time) {
	        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
	          if (time) {
	            this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	            this._show = false;
	            this._hideTimeout = setTimeout(bind(this.hide, this), time);
	          } else {
	            this.hide();
	          }
	        }
	      };
	
	      TooltipRichContent.prototype.isShow = function () {
	        return this._show;
	      };
	
	      TooltipRichContent.prototype.dispose = function () {
	        this._zr.remove(this.el);
	      };
	
	      return TooltipRichContent;
	    }();
	
	    function mathMaxWith0(val) {
	      return Math.max(0, val);
	    }
	
	    function calcShadowOuterSize(style) {
	      var shadowBlur = mathMaxWith0(style.shadowBlur || 0);
	      var shadowOffsetX = mathMaxWith0(style.shadowOffsetX || 0);
	      var shadowOffsetY = mathMaxWith0(style.shadowOffsetY || 0);
	      return {
	        left: mathMaxWith0(shadowBlur - shadowOffsetX),
	        right: mathMaxWith0(shadowBlur + shadowOffsetX),
	        top: mathMaxWith0(shadowBlur - shadowOffsetY),
	        bottom: mathMaxWith0(shadowBlur + shadowOffsetY)
	      };
	    }
	
	    function makeStyleCoord$1(out, zr, zrX, zrY) {
	      out[0] = zrX;
	      out[1] = zrY;
	      out[2] = out[0] / zr.getWidth();
	      out[3] = out[1] / zr.getHeight();
	    }
	
	    var proxyRect = new Rect({
	      shape: {
	        x: -1,
	        y: -1,
	        width: 2,
	        height: 2
	      }
	    });
	
	    var TooltipView =
	    /** @class */
	    function (_super) {
	      __extends(TooltipView, _super);
	
	      function TooltipView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = TooltipView.type;
	        return _this;
	      }
	
	      TooltipView.prototype.init = function (ecModel, api) {
	        if (env.node || !api.getDom()) {
	          return;
	        }
	
	        var tooltipModel = ecModel.getComponent('tooltip');
	        var renderMode = this._renderMode = getTooltipRenderMode(tooltipModel.get('renderMode'));
	        this._tooltipContent = renderMode === 'richText' ? new TooltipRichContent(api) : new TooltipHTMLContent(api.getDom(), api, {
	          appendToBody: tooltipModel.get('appendToBody', true)
	        });
	      };
	
	      TooltipView.prototype.render = function (tooltipModel, ecModel, api) {
	        if (env.node || !api.getDom()) {
	          return;
	        } // Reset
	
	
	        this.group.removeAll();
	        this._tooltipModel = tooltipModel;
	        this._ecModel = ecModel;
	        this._api = api;
	        var tooltipContent = this._tooltipContent;
	        tooltipContent.update(tooltipModel);
	        tooltipContent.setEnterable(tooltipModel.get('enterable'));
	
	        this._initGlobalListener();
	
	        this._keepShow(); // PENDING
	        // `mousemove` event will be triggered very frequently when the mouse moves fast,
	        // which causes that the `updatePosition` function was also called frequently.
	        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
	        // To avoid frequent triggering,
	        // consider throttling it in 50ms when transition is enabled
	
	
	        if (this._renderMode !== 'richText' && tooltipModel.get('transitionDuration')) {
	          createOrUpdate(this, '_updatePosition', 50, 'fixRate');
	        } else {
	          clear(this, '_updatePosition');
	        }
	      };
	
	      TooltipView.prototype._initGlobalListener = function () {
	        var tooltipModel = this._tooltipModel;
	        var triggerOn = tooltipModel.get('triggerOn');
	        register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
	          // If 'none', it is not controlled by mouse totally.
	          if (triggerOn !== 'none') {
	            if (triggerOn.indexOf(currTrigger) >= 0) {
	              this._tryShow(e, dispatchAction);
	            } else if (currTrigger === 'leave') {
	              this._hide(dispatchAction);
	            }
	          }
	        }, this));
	      };
	
	      TooltipView.prototype._keepShow = function () {
	        var tooltipModel = this._tooltipModel;
	        var ecModel = this._ecModel;
	        var api = this._api;
	        var triggerOn = tooltipModel.get('triggerOn'); // Try to keep the tooltip show when refreshing
	
	        if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
	        // self.manuallyShowTip({x, y}) might cause tooltip hide,
	        // which is not expected.
	        && triggerOn !== 'none' && triggerOn !== 'click') {
	          var self_1 = this;
	          clearTimeout(this._refreshUpdateTimeout);
	          this._refreshUpdateTimeout = setTimeout(function () {
	            // Show tip next tick after other charts are rendered
	            // In case highlight action has wrong result
	            // FIXME
	            !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
	              x: self_1._lastX,
	              y: self_1._lastY,
	              dataByCoordSys: self_1._lastDataByCoordSys
	            });
	          });
	        }
	      };
	      /**
	       * Show tip manually by
	       * dispatchAction({
	       *     type: 'showTip',
	       *     x: 10,
	       *     y: 10
	       * });
	       * Or
	       * dispatchAction({
	       *      type: 'showTip',
	       *      seriesIndex: 0,
	       *      dataIndex or dataIndexInside or name
	       * });
	       *
	       *  TODO Batch
	       */
	
	
	      TooltipView.prototype.manuallyShowTip = function (tooltipModel, ecModel, api, payload) {
	        if (payload.from === this.uid || env.node || !api.getDom()) {
	          return;
	        }
	
	        var dispatchAction = makeDispatchAction$1(payload, api); // Reset ticket
	
	        this._ticket = ''; // When triggered from axisPointer.
	
	        var dataByCoordSys = payload.dataByCoordSys;
	        var cmptRef = findComponentReference(payload, ecModel, api);
	
	        if (cmptRef) {
	          var rect = cmptRef.el.getBoundingRect().clone();
	          rect.applyTransform(cmptRef.el.transform);
	
	          this._tryShow({
	            offsetX: rect.x + rect.width / 2,
	            offsetY: rect.y + rect.height / 2,
	            target: cmptRef.el,
	            position: payload.position,
	            // When manully trigger, the mouse is not on the el, so we'd better to
	            // position tooltip on the bottom of the el and display arrow is possible.
	            positionDefault: 'bottom'
	          }, dispatchAction);
	        } else if (payload.tooltip && payload.x != null && payload.y != null) {
	          var el = proxyRect;
	          el.x = payload.x;
	          el.y = payload.y;
	          el.update();
	          getECData(el).tooltipConfig = {
	            name: null,
	            option: payload.tooltip
	          }; // Manually show tooltip while view is not using zrender elements.
	
	          this._tryShow({
	            offsetX: payload.x,
	            offsetY: payload.y,
	            target: el
	          }, dispatchAction);
	        } else if (dataByCoordSys) {
	          this._tryShow({
	            offsetX: payload.x,
	            offsetY: payload.y,
	            position: payload.position,
	            dataByCoordSys: dataByCoordSys,
	            tooltipOption: payload.tooltipOption
	          }, dispatchAction);
	        } else if (payload.seriesIndex != null) {
	          if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
	            return;
	          }
	
	          var pointInfo = findPointFromSeries(payload, ecModel);
	          var cx = pointInfo.point[0];
	          var cy = pointInfo.point[1];
	
	          if (cx != null && cy != null) {
	            this._tryShow({
	              offsetX: cx,
	              offsetY: cy,
	              target: pointInfo.el,
	              position: payload.position,
	              // When manully trigger, the mouse is not on the el, so we'd better to
	              // position tooltip on the bottom of the el and display arrow is possible.
	              positionDefault: 'bottom'
	            }, dispatchAction);
	          }
	        } else if (payload.x != null && payload.y != null) {
	          // FIXME
	          // should wrap dispatchAction like `axisPointer/globalListener` ?
	          api.dispatchAction({
	            type: 'updateAxisPointer',
	            x: payload.x,
	            y: payload.y
	          });
	
	          this._tryShow({
	            offsetX: payload.x,
	            offsetY: payload.y,
	            position: payload.position,
	            target: api.getZr().findHover(payload.x, payload.y).target
	          }, dispatchAction);
	        }
	      };
	
	      TooltipView.prototype.manuallyHideTip = function (tooltipModel, ecModel, api, payload) {
	        var tooltipContent = this._tooltipContent;
	
	        if (this._tooltipModel) {
	          tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
	        }
	
	        this._lastX = this._lastY = this._lastDataByCoordSys = null;
	
	        if (payload.from !== this.uid) {
	          this._hide(makeDispatchAction$1(payload, api));
	        }
	      }; // Be compatible with previous design, that is, when tooltip.type is 'axis' and
	      // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
	      // and tooltip.
	
	
	      TooltipView.prototype._manuallyAxisShowTip = function (tooltipModel, ecModel, api, payload) {
	        var seriesIndex = payload.seriesIndex;
	        var dataIndex = payload.dataIndex; // @ts-ignore
	
	        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
	
	        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
	          return;
	        }
	
	        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	
	        if (!seriesModel) {
	          return;
	        }
	
	        var data = seriesModel.getData();
	        var tooltipCascadedModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model], this._tooltipModel);
	
	        if (tooltipCascadedModel.get('trigger') !== 'axis') {
	          return;
	        }
	
	        api.dispatchAction({
	          type: 'updateAxisPointer',
	          seriesIndex: seriesIndex,
	          dataIndex: dataIndex,
	          position: payload.position
	        });
	        return true;
	      };
	
	      TooltipView.prototype._tryShow = function (e, dispatchAction) {
	        var el = e.target;
	        var tooltipModel = this._tooltipModel;
	
	        if (!tooltipModel) {
	          return;
	        } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
	
	
	        this._lastX = e.offsetX;
	        this._lastY = e.offsetY;
	        var dataByCoordSys = e.dataByCoordSys;
	
	        if (dataByCoordSys && dataByCoordSys.length) {
	          this._showAxisTooltip(dataByCoordSys, e);
	        } else if (el) {
	          this._lastDataByCoordSys = null;
	          var seriesDispatcher_1;
	          var cmptDispatcher_1;
	          findEventDispatcher(el, function (target) {
	            // Always show item tooltip if mouse is on the element with dataIndex
	            if (getECData(target).dataIndex != null) {
	              seriesDispatcher_1 = target;
	              return true;
	            } // Tooltip provided directly. Like legend.
	
	
	            if (getECData(target).tooltipConfig != null) {
	              cmptDispatcher_1 = target;
	              return true;
	            }
	          }, true);
	
	          if (seriesDispatcher_1) {
	            this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
	          } else if (cmptDispatcher_1) {
	            this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
	          } else {
	            this._hide(dispatchAction);
	          }
	        } else {
	          this._lastDataByCoordSys = null;
	
	          this._hide(dispatchAction);
	        }
	      };
	
	      TooltipView.prototype._showOrMove = function (tooltipModel, cb) {
	        // showDelay is used in this case: tooltip.enterable is set
	        // as true. User intent to move mouse into tooltip and click
	        // something. `showDelay` makes it easier to enter the content
	        // but tooltip do not move immediately.
	        var delay = tooltipModel.get('showDelay');
	        cb = bind(cb, this);
	        clearTimeout(this._showTimout);
	        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
	      };
	
	      TooltipView.prototype._showAxisTooltip = function (dataByCoordSys, e) {
	        var ecModel = this._ecModel;
	        var globalTooltipModel = this._tooltipModel;
	        var point = [e.offsetX, e.offsetY];
	        var singleTooltipModel = buildTooltipModel([e.tooltipOption], globalTooltipModel);
	        var renderMode = this._renderMode;
	        var cbParamsList = [];
	        var articleMarkup = createTooltipMarkup('section', {
	          blocks: [],
	          noHeader: true
	        }); // Only for legacy: `Serise['formatTooltip']` returns a string.
	
	        var markupTextArrLegacy = [];
	        var markupStyleCreator = new TooltipMarkupStyleCreator();
	        each(dataByCoordSys, function (itemCoordSys) {
	          each(itemCoordSys.dataByAxis, function (axisItem) {
	            var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
	            var axisValue = axisItem.value;
	
	            if (!axisModel || axisValue == null) {
	              return;
	            }
	
	            var axisValueLabel = getValueLabel(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
	            var axisSectionMarkup = createTooltipMarkup('section', {
	              header: axisValueLabel,
	              noHeader: !trim(axisValueLabel),
	              sortBlocks: true,
	              blocks: []
	            });
	            articleMarkup.blocks.push(axisSectionMarkup);
	            each(axisItem.seriesDataIndices, function (idxItem) {
	              var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	              var dataIndex = idxItem.dataIndexInside;
	              var cbParams = series.getDataParams(dataIndex); // Can't find data.
	
	              if (cbParams.dataIndex < 0) {
	                return;
	              }
	
	              cbParams.axisDim = axisItem.axisDim;
	              cbParams.axisIndex = axisItem.axisIndex;
	              cbParams.axisType = axisItem.axisType;
	              cbParams.axisId = axisItem.axisId;
	              cbParams.axisValue = getAxisRawValue(axisModel.axis, {
	                value: axisValue
	              });
	              cbParams.axisValueLabel = axisValueLabel; // Pre-create marker style for makers. Users can assemble richText
	              // text in `formatter` callback and use those markers style.
	
	              cbParams.marker = markupStyleCreator.makeTooltipMarker('item', convertToColorString(cbParams.color), renderMode);
	              var seriesTooltipResult = normalizeTooltipFormatResult(series.formatTooltip(dataIndex, true, null));
	              var frag = seriesTooltipResult.frag;
	
	              if (frag) {
	                var valueFormatter = buildTooltipModel([series], globalTooltipModel).get('valueFormatter');
	                axisSectionMarkup.blocks.push(valueFormatter ? extend({
	                  valueFormatter: valueFormatter
	                }, frag) : frag);
	              }
	
	              if (seriesTooltipResult.text) {
	                markupTextArrLegacy.push(seriesTooltipResult.text);
	              }
	
	              cbParamsList.push(cbParams);
	            });
	          });
	        }); // In most cases, the second axis is displays upper on the first one.
	        // So we reverse it to look better.
	
	        articleMarkup.blocks.reverse();
	        markupTextArrLegacy.reverse();
	        var positionExpr = e.position;
	        var orderMode = singleTooltipModel.get('order');
	        var builtMarkupText = buildTooltipMarkup(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
	        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
	        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
	        var allMarkupText = markupTextArrLegacy.join(blockBreak);
	
	        this._showOrMove(singleTooltipModel, function () {
	          if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) {
	            this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
	          } else {
	            this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
	          }
	        }); // Do not trigger events here, because this branch only be entered
	        // from dispatchAction.
	
	      };
	
	      TooltipView.prototype._showSeriesItemTooltip = function (e, dispatcher, dispatchAction) {
	        var ecModel = this._ecModel;
	        var ecData = getECData(dispatcher); // Use dataModel in element if possible
	        // Used when mouseover on a element like markPoint or edge
	        // In which case, the data is not main data in series.
	
	        var seriesIndex = ecData.seriesIndex;
	        var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
	
	        var dataModel = ecData.dataModel || seriesModel;
	        var dataIndex = ecData.dataIndex;
	        var dataType = ecData.dataType;
	        var data = dataModel.getData(dataType);
	        var renderMode = this._renderMode;
	        var positionDefault = e.positionDefault;
	        var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model], this._tooltipModel, positionDefault ? {
	          position: positionDefault
	        } : null);
	        var tooltipTrigger = tooltipModel.get('trigger');
	
	        if (tooltipTrigger != null && tooltipTrigger !== 'item') {
	          return;
	        }
	
	        var params = dataModel.getDataParams(dataIndex, dataType);
	        var markupStyleCreator = new TooltipMarkupStyleCreator(); // Pre-create marker style for makers. Users can assemble richText
	        // text in `formatter` callback and use those markers style.
	
	        params.marker = markupStyleCreator.makeTooltipMarker('item', convertToColorString(params.color), renderMode);
	        var seriesTooltipResult = normalizeTooltipFormatResult(dataModel.formatTooltip(dataIndex, false, dataType));
	        var orderMode = tooltipModel.get('order');
	        var valueFormatter = tooltipModel.get('valueFormatter');
	        var frag = seriesTooltipResult.frag;
	        var markupText = frag ? buildTooltipMarkup(valueFormatter ? extend({
	          valueFormatter: valueFormatter
	        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.text;
	        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
	
	        this._showOrMove(tooltipModel, function () {
	          this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
	        }); // FIXME
	        // duplicated showtip if manuallyShowTip is called from dispatchAction.
	
	
	        dispatchAction({
	          type: 'showTip',
	          dataIndexInside: dataIndex,
	          dataIndex: data.getRawIndex(dataIndex),
	          seriesIndex: seriesIndex,
	          from: this.uid
	        });
	      };
	
	      TooltipView.prototype._showComponentItemTooltip = function (e, el, dispatchAction) {
	        var ecData = getECData(el);
	        var tooltipConfig = ecData.tooltipConfig;
	        var tooltipOpt = tooltipConfig.option || {};
	
	        if (isString(tooltipOpt)) {
	          var content = tooltipOpt;
	          tooltipOpt = {
	            content: content,
	            // Fixed formatter
	            formatter: content
	          };
	        }
	
	        var tooltipModelCascade = [tooltipOpt];
	
	        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
	
	        if (cmpt) {
	          tooltipModelCascade.push(cmpt);
	        } // In most cases, component tooltip formatter has different params with series tooltip formatter,
	        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
	        // by convention, we do not use it as the default formatter for component.
	
	
	        tooltipModelCascade.push({
	          formatter: tooltipOpt.content
	        });
	        var positionDefault = e.positionDefault;
	        var subTooltipModel = buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
	          position: positionDefault
	        } : null);
	        var defaultHtml = subTooltipModel.get('content');
	        var asyncTicket = Math.random() + ''; // PENDING: this case do not support richText style yet.
	
	        var markupStyleCreator = new TooltipMarkupStyleCreator(); // Do not check whether `trigger` is 'none' here, because `trigger`
	        // only works on coordinate system. In fact, we have not found case
	        // that requires setting `trigger` nothing on component yet.
	
	        this._showOrMove(subTooltipModel, function () {
	          // Use formatterParams from element defined in component
	          // Avoid users modify it.
	          var formatterParams = clone(subTooltipModel.get('formatterParams') || {});
	
	          this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
	        }); // If not dispatch showTip, tip may be hide triggered by axis.
	
	
	        dispatchAction({
	          type: 'showTip',
	          from: this.uid
	        });
	      };
	
	      TooltipView.prototype._showTooltipContent = function ( // Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
	      // Instead of top level tooltip.
	      tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
	        // Reset ticket
	        this._ticket = '';
	
	        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
	          return;
	        }
	
	        var tooltipContent = this._tooltipContent;
	        tooltipContent.setEnterable(tooltipModel.get('enterable'));
	        var formatter = tooltipModel.get('formatter');
	        positionExpr = positionExpr || tooltipModel.get('position');
	        var html = defaultHtml;
	
	        var nearPoint = this._getNearestPoint([x, y], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));
	
	        var nearPointColor = nearPoint.color;
	
	        if (formatter) {
	          if (isString(formatter)) {
	            var useUTC = tooltipModel.ecModel.get('useUTC');
	            var params0 = isArray(params) ? params[0] : params;
	            var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
	            html = formatter;
	
	            if (isTimeAxis) {
	              html = format(params0.axisValue, html, useUTC);
	            }
	
	            html = formatTpl(html, params, true);
	          } else if (isFunction(formatter)) {
	            var callback = bind(function (cbTicket, html) {
	              if (cbTicket === this._ticket) {
	                tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
	
	                this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	              }
	            }, this);
	            this._ticket = asyncTicket;
	            html = formatter(params, asyncTicket, callback);
	          } else {
	            html = formatter;
	          }
	        }
	
	        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
	        tooltipContent.show(tooltipModel, nearPointColor);
	
	        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	      };
	
	      TooltipView.prototype._getNearestPoint = function (point, tooltipDataParams, trigger, borderColor) {
	        if (trigger === 'axis' || isArray(tooltipDataParams)) {
	          return {
	            color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
	          };
	        }
	
	        if (!isArray(tooltipDataParams)) {
	          return {
	            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
	          };
	        }
	      };
	
	      TooltipView.prototype._updatePosition = function (tooltipModel, positionExpr, x, // Mouse x
	      y, // Mouse y
	      content, params, el) {
	        var viewWidth = this._api.getWidth();
	
	        var viewHeight = this._api.getHeight();
	
	        positionExpr = positionExpr || tooltipModel.get('position');
	        var contentSize = content.getSize();
	        var align = tooltipModel.get('align');
	        var vAlign = tooltipModel.get('verticalAlign');
	        var rect = el && el.getBoundingRect().clone();
	        el && rect.applyTransform(el.transform);
	
	        if (isFunction(positionExpr)) {
	          // Callback of position can be an array or a string specify the position
	          positionExpr = positionExpr([x, y], params, content.el, rect, {
	            viewSize: [viewWidth, viewHeight],
	            contentSize: contentSize.slice()
	          });
	        }
	
	        if (isArray(positionExpr)) {
	          x = parsePercent$1(positionExpr[0], viewWidth);
	          y = parsePercent$1(positionExpr[1], viewHeight);
	        } else if (isObject(positionExpr)) {
	          var boxLayoutPosition = positionExpr;
	          boxLayoutPosition.width = contentSize[0];
	          boxLayoutPosition.height = contentSize[1];
	          var layoutRect = getLayoutRect(boxLayoutPosition, {
	            width: viewWidth,
	            height: viewHeight
	          });
	          x = layoutRect.x;
	          y = layoutRect.y;
	          align = null; // When positionExpr is left/top/right/bottom,
	          // align and verticalAlign will not work.
	
	          vAlign = null;
	        } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
	        else if (isString(positionExpr) && el) {
	            var pos = calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
	            x = pos[0];
	            y = pos[1];
	          } else {
	            var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
	            x = pos[0];
	            y = pos[1];
	          }
	
	        align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
	        vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
	
	        if (shouldTooltipConfine(tooltipModel)) {
	          var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
	          x = pos[0];
	          y = pos[1];
	        }
	
	        content.moveTo(x, y);
	      }; // FIXME
	      // Should we remove this but leave this to user?
	
	
	      TooltipView.prototype._updateContentNotChangedOnAxis = function (dataByCoordSys, cbParamsList) {
	        var lastCoordSys = this._lastDataByCoordSys;
	        var lastCbParamsList = this._cbParamsList;
	        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
	        contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
	          var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
	          var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
	          var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
	          contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
	          contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
	            var thisItem = thisDataByAxis[indexAxis] || {};
	            var lastIndices = lastItem.seriesDataIndices || [];
	            var newIndices = thisItem.seriesDataIndices || [];
	            contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
	            contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
	              var newIdxItem = newIndices[j];
	              contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
	            }); // check is cbParams data value changed
	
	            lastCbParamsList && each(lastItem.seriesDataIndices, function (idxItem) {
	              var seriesIdx = idxItem.seriesIndex;
	              var cbParams = cbParamsList[seriesIdx];
	              var lastCbParams = lastCbParamsList[seriesIdx];
	
	              if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) {
	                contentNotChanged = false;
	              }
	            });
	          });
	        });
	        this._lastDataByCoordSys = dataByCoordSys;
	        this._cbParamsList = cbParamsList;
	        return !!contentNotChanged;
	      };
	
	      TooltipView.prototype._hide = function (dispatchAction) {
	        // Do not directly hideLater here, because this behavior may be prevented
	        // in dispatchAction when showTip is dispatched.
	        // FIXME
	        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
	        this._lastDataByCoordSys = null;
	        dispatchAction({
	          type: 'hideTip',
	          from: this.uid
	        });
	      };
	
	      TooltipView.prototype.dispose = function (ecModel, api) {
	        if (env.node || !api.getDom()) {
	          return;
	        }
	
	        clear(this, '_updatePosition');
	
	        this._tooltipContent.dispose();
	
	        unregister('itemTooltip', api);
	      };
	
	      TooltipView.type = 'tooltip';
	      return TooltipView;
	    }(ComponentView);
	    /**
	     * From top to bottom. (the last one should be globalTooltipModel);
	     */
	
	
	    function buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
	      // Last is always tooltip model.
	      var ecModel = globalTooltipModel.ecModel;
	      var resultModel;
	
	      if (defaultTooltipOption) {
	        resultModel = new Model(defaultTooltipOption, ecModel, ecModel);
	        resultModel = new Model(globalTooltipModel.option, resultModel, ecModel);
	      } else {
	        resultModel = globalTooltipModel;
	      }
	
	      for (var i = modelCascade.length - 1; i >= 0; i--) {
	        var tooltipOpt = modelCascade[i];
	
	        if (tooltipOpt) {
	          if (tooltipOpt instanceof Model) {
	            tooltipOpt = tooltipOpt.get('tooltip', true);
	          } // In each data item tooltip can be simply write:
	          // {
	          //  value: 10,
	          //  tooltip: 'Something you need to know'
	          // }
	
	
	          if (isString(tooltipOpt)) {
	            tooltipOpt = {
	              formatter: tooltipOpt
	            };
	          }
	
	          if (tooltipOpt) {
	            resultModel = new Model(tooltipOpt, resultModel, ecModel);
	          }
	        }
	      }
	
	      return resultModel;
	    }
	
	    function makeDispatchAction$1(payload, api) {
	      return payload.dispatchAction || bind(api.dispatchAction, api);
	    }
	
	    function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
	      var size = content.getSize();
	      var width = size[0];
	      var height = size[1];
	
	      if (gapH != null) {
	        // Add extra 2 pixels for this case:
	        // At present the "values" in default tooltip are using CSS `float: right`.
	        // When the right edge of the tooltip box is on the right side of the
	        // viewport, the `float` layout might push the "values" to the second line.
	        if (x + width + gapH + 2 > viewWidth) {
	          x -= width + gapH;
	        } else {
	          x += gapH;
	        }
	      }
	
	      if (gapV != null) {
	        if (y + height + gapV > viewHeight) {
	          y -= height + gapV;
	        } else {
	          y += gapV;
	        }
	      }
	
	      return [x, y];
	    }
	
	    function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
	      var size = content.getSize();
	      var width = size[0];
	      var height = size[1];
	      x = Math.min(x + width, viewWidth) - width;
	      y = Math.min(y + height, viewHeight) - height;
	      x = Math.max(x, 0);
	      y = Math.max(y, 0);
	      return [x, y];
	    }
	
	    function calcTooltipPosition(position, rect, contentSize, borderWidth) {
	      var domWidth = contentSize[0];
	      var domHeight = contentSize[1];
	      var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
	      var x = 0;
	      var y = 0;
	      var rectWidth = rect.width;
	      var rectHeight = rect.height;
	
	      switch (position) {
	        case 'inside':
	          x = rect.x + rectWidth / 2 - domWidth / 2;
	          y = rect.y + rectHeight / 2 - domHeight / 2;
	          break;
	
	        case 'top':
	          x = rect.x + rectWidth / 2 - domWidth / 2;
	          y = rect.y - domHeight - offset;
	          break;
	
	        case 'bottom':
	          x = rect.x + rectWidth / 2 - domWidth / 2;
	          y = rect.y + rectHeight + offset;
	          break;
	
	        case 'left':
	          x = rect.x - domWidth - offset;
	          y = rect.y + rectHeight / 2 - domHeight / 2;
	          break;
	
	        case 'right':
	          x = rect.x + rectWidth + offset;
	          y = rect.y + rectHeight / 2 - domHeight / 2;
	      }
	
	      return [x, y];
	    }
	
	    function isCenterAlign(align) {
	      return align === 'center' || align === 'middle';
	    }
	    /**
	     * Find target component by payload like:
	     * ```js
	     * { legendId: 'some_id', name: 'xxx' }
	     * { toolboxIndex: 1, name: 'xxx' }
	     * { geoName: 'some_name', name: 'xxx' }
	     * ```
	     * PENDING: at present only
	     *
	     * If not found, return null/undefined.
	     */
	
	
	    function findComponentReference(payload, ecModel, api) {
	      var queryOptionMap = preParseFinder(payload).queryOptionMap;
	      var componentMainType = queryOptionMap.keys()[0];
	
	      if (!componentMainType || componentMainType === 'series') {
	        return;
	      }
	
	      var queryResult = queryReferringComponents(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
	        useDefault: false,
	        enableAll: false,
	        enableNone: false
	      });
	      var model = queryResult.models[0];
	
	      if (!model) {
	        return;
	      }
	
	      var view = api.getViewOfComponentModel(model);
	      var el;
	      view.group.traverse(function (subEl) {
	        var tooltipConfig = getECData(subEl).tooltipConfig;
	
	        if (tooltipConfig && tooltipConfig.name === payload.name) {
	          el = subEl;
	          return true; // stop
	        }
	      });
	
	      if (el) {
	        return {
	          componentMainType: componentMainType,
	          componentIndex: model.componentIndex,
	          el: el
	        };
	      }
	    }
	
	    function install$A(registers) {
	      use(install$s);
	      registers.registerComponentModel(TooltipModel);
	      registers.registerComponentView(TooltipView);
	      /**
	       * @action
	       * @property {string} type
	       * @property {number} seriesIndex
	       * @property {number} dataIndex
	       * @property {number} [x]
	       * @property {number} [y]
	       */
	
	      registers.registerAction({
	        type: 'showTip',
	        event: 'showTip',
	        update: 'tooltip:manuallyShowTip'
	      }, noop);
	      registers.registerAction({
	        type: 'hideTip',
	        event: 'hideTip',
	        update: 'tooltip:manuallyHideTip'
	      }, noop);
	    }
	
	    var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];
	    function brushPreprocessor(option, isNew) {
	      var brushComponents = normalizeToArray(option ? option.brush : []);
	
	      if (!brushComponents.length) {
	        return;
	      }
	
	      var brushComponentSpecifiedBtns = [];
	      each(brushComponents, function (brushOpt) {
	        var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
	
	        if (tbs instanceof Array) {
	          brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
	        }
	      });
	      var toolbox = option && option.toolbox;
	
	      if (isArray(toolbox)) {
	        toolbox = toolbox[0];
	      }
	
	      if (!toolbox) {
	        toolbox = {
	          feature: {}
	        };
	        option.toolbox = [toolbox];
	      }
	
	      var toolboxFeature = toolbox.feature || (toolbox.feature = {});
	      var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
	      var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
	      brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
	      removeDuplicate(brushTypes);
	
	      if (isNew && !brushTypes.length) {
	        brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
	      }
	    }
	
	    function removeDuplicate(arr) {
	      var map = {};
	      each(arr, function (val) {
	        map[val] = 1;
	      });
	      arr.length = 0;
	      each(map, function (flag, val) {
	        arr.push(val);
	      });
	    }
	
	    var each$b = each;
	
	    function hasKeys(obj) {
	      if (obj) {
	        for (var name_1 in obj) {
	          if (obj.hasOwnProperty(name_1)) {
	            return true;
	          }
	        }
	      }
	    }
	
	    function createVisualMappings(option, stateList, supplementVisualOption) {
	      var visualMappings = {};
	      each$b(stateList, function (state) {
	        var mappings = visualMappings[state] = createMappings();
	        each$b(option[state], function (visualData, visualType) {
	          if (!VisualMapping.isValidType(visualType)) {
	            return;
	          }
	
	          var mappingOption = {
	            type: visualType,
	            visual: visualData
	          };
	          supplementVisualOption && supplementVisualOption(mappingOption, state);
	          mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
	          // is not supported, such as rendering using gradient color.
	
	          if (visualType === 'opacity') {
	            mappingOption = clone(mappingOption);
	            mappingOption.type = 'colorAlpha';
	            mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
	          }
	        });
	      });
	      return visualMappings;
	
	      function createMappings() {
	        var Creater = function () {}; // Make sure hidden fields will not be visited by
	        // object iteration (with hasOwnProperty checking).
	
	
	        Creater.prototype.__hidden = Creater.prototype;
	        var obj = new Creater();
	        return obj;
	      }
	    }
	    function replaceVisualOption(thisOption, newOption, keys) {
	      // Visual attributes merge is not supported, otherwise it
	      // brings overcomplicated merge logic. See #2853. So if
	      // newOption has anyone of these keys, all of these keys
	      // will be reset. Otherwise, all keys remain.
	      var has;
	      each(keys, function (key) {
	        if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	          has = true;
	        }
	      });
	      has && each(keys, function (key) {
	        if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	          thisOption[key] = clone(newOption[key]);
	        } else {
	          delete thisOption[key];
	        }
	      });
	    }
	    /**
	     * @param stateList
	     * @param visualMappings
	     * @param list
	     * @param getValueState param: valueOrIndex, return: state.
	     * @param scope Scope for getValueState
	     * @param dimension Concrete dimension, if used.
	     */
	    // ???! handle brush?
	
	    function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
	      var visualTypesMap = {};
	      each(stateList, function (state) {
	        var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	        visualTypesMap[state] = visualTypes;
	      });
	      var dataIndex;
	
	      function getVisual(key) {
	        return getItemVisualFromData(data, dataIndex, key);
	      }
	
	      function setVisual(key, value) {
	        setItemVisualFromData(data, dataIndex, key, value);
	      }
	
	      if (dimension == null) {
	        data.each(eachItem);
	      } else {
	        data.each([dimension], eachItem);
	      }
	
	      function eachItem(valueOrIndex, index) {
	        dataIndex = dimension == null ? valueOrIndex // First argument is index
	        : index;
	        var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	        // @ts-ignore
	
	        if (rawDataItem && rawDataItem.visualMap === false) {
	          return;
	        }
	
	        var valueState = getValueState.call(scope, valueOrIndex);
	        var mappings = visualMappings[valueState];
	        var visualTypes = visualTypesMap[valueState];
	
	        for (var i = 0, len = visualTypes.length; i < len; i++) {
	          var type = visualTypes[i];
	          mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
	        }
	      }
	    }
	    /**
	     * @param data
	     * @param stateList
	     * @param visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	     * @param getValueState param: valueOrIndex, return: state.
	     * @param dim dimension or dimension index.
	     */
	
	    function incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
	      var visualTypesMap = {};
	      each(stateList, function (state) {
	        var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	        visualTypesMap[state] = visualTypes;
	      });
	      return {
	        progress: function progress(params, data) {
	          var dimIndex;
	
	          if (dim != null) {
	            dimIndex = data.getDimensionIndex(dim);
	          }
	
	          function getVisual(key) {
	            return getItemVisualFromData(data, dataIndex, key);
	          }
	
	          function setVisual(key, value) {
	            setItemVisualFromData(data, dataIndex, key, value);
	          }
	
	          var dataIndex;
	          var store = data.getStore();
	
	          while ((dataIndex = params.next()) != null) {
	            var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	            // @ts-ignore
	
	            if (rawDataItem && rawDataItem.visualMap === false) {
	              continue;
	            }
	
	            var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
	            var valueState = getValueState(value);
	            var mappings = visualMappings[valueState];
	            var visualTypes = visualTypesMap[valueState];
	
	            for (var i = 0, len = visualTypes.length; i < len; i++) {
	              var type = visualTypes[i];
	              mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
	            }
	          }
	        }
	      };
	    }
	
	    function makeBrushCommonSelectorForSeries(area) {
	      var brushType = area.brushType; // Do not use function binding or curry for performance.
	
	      var selectors = {
	        point: function (itemLayout) {
	          return selector[brushType].point(itemLayout, selectors, area);
	        },
	        rect: function (itemLayout) {
	          return selector[brushType].rect(itemLayout, selectors, area);
	        }
	      };
	      return selectors;
	    }
	    var selector = {
	      lineX: getLineSelectors(0),
	      lineY: getLineSelectors(1),
	      rect: {
	        point: function (itemLayout, selectors, area) {
	          return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
	        },
	        rect: function (itemLayout, selectors, area) {
	          return itemLayout && area.boundingRect.intersect(itemLayout);
	        }
	      },
	      polygon: {
	        point: function (itemLayout, selectors, area) {
	          return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && contain$2(area.range, itemLayout[0], itemLayout[1]);
	        },
	        rect: function (itemLayout, selectors, area) {
	          var points = area.range;
	
	          if (!itemLayout || points.length <= 1) {
	            return false;
	          }
	
	          var x = itemLayout.x;
	          var y = itemLayout.y;
	          var width = itemLayout.width;
	          var height = itemLayout.height;
	          var p = points[0];
	
	          if (contain$2(points, x, y) || contain$2(points, x + width, y) || contain$2(points, x, y + height) || contain$2(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || linePolygonIntersect(x, y, x + width, y, points) || linePolygonIntersect(x, y, x, y + height, points) || linePolygonIntersect(x + width, y, x + width, y + height, points) || linePolygonIntersect(x, y + height, x + width, y + height, points)) {
	            return true;
	          }
	        }
	      }
	    };
	
	    function getLineSelectors(xyIndex) {
	      var xy = ['x', 'y'];
	      var wh = ['width', 'height'];
	      return {
	        point: function (itemLayout, selectors, area) {
	          if (itemLayout) {
	            var range = area.range;
	            var p = itemLayout[xyIndex];
	            return inLineRange(p, range);
	          }
	        },
	        rect: function (itemLayout, selectors, area) {
	          if (itemLayout) {
	            var range = area.range;
	            var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
	            layoutRange[1] < layoutRange[0] && layoutRange.reverse();
	            return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
	          }
	        }
	      };
	    }
	
	    function inLineRange(p, range) {
	      return range[0] <= p && p <= range[1];
	    }
	
	    var STATE_LIST = ['inBrush', 'outOfBrush'];
	    var DISPATCH_METHOD = '__ecBrushSelect';
	    var DISPATCH_FLAG = '__ecInBrushSelectEvent';
	    function layoutCovers(ecModel) {
	      ecModel.eachComponent({
	        mainType: 'brush'
	      }, function (brushModel) {
	        var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
	        brushTargetManager.setInputRanges(brushModel.areas, ecModel);
	      });
	    }
	    /**
	     * Register the visual encoding if this modules required.
	     */
	
	    function brushVisual(ecModel, api, payload) {
	      var brushSelected = [];
	      var throttleType;
	      var throttleDelay;
	      ecModel.eachComponent({
	        mainType: 'brush'
	      }, function (brushModel) {
	        payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
	          brushType: false
	        });
	      });
	      layoutCovers(ecModel);
	      ecModel.eachComponent({
	        mainType: 'brush'
	      }, function (brushModel, brushIndex) {
	        var thisBrushSelected = {
	          brushId: brushModel.id,
	          brushIndex: brushIndex,
	          brushName: brushModel.name,
	          areas: clone(brushModel.areas),
	          selected: []
	        }; // Every brush component exists in event params, convenient
	        // for user to find by index.
	
	        brushSelected.push(thisBrushSelected);
	        var brushOption = brushModel.option;
	        var brushLink = brushOption.brushLink;
	        var linkedSeriesMap = [];
	        var selectedDataIndexForLink = [];
	        var rangeInfoBySeries = [];
	        var hasBrushExists = false;
	
	        if (!brushIndex) {
	          // Only the first throttle setting works.
	          throttleType = brushOption.throttleType;
	          throttleDelay = brushOption.throttleDelay;
	        } // Add boundingRect and selectors to range.
	
	
	        var areas = map(brushModel.areas, function (area) {
	          var builder = boundingRectBuilders[area.brushType];
	          var selectableArea = defaults({
	            boundingRect: builder ? builder(area) : void 0
	          }, area);
	          selectableArea.selectors = makeBrushCommonSelectorForSeries(selectableArea);
	          return selectableArea;
	        });
	        var visualMappings = createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
	          mappingOption.mappingMethod = 'fixed';
	        });
	        isArray(brushLink) && each(brushLink, function (seriesIndex) {
	          linkedSeriesMap[seriesIndex] = 1;
	        });
	
	        function linkOthers(seriesIndex) {
	          return brushLink === 'all' || !!linkedSeriesMap[seriesIndex];
	        } // If no supported brush or no brush on the series,
	        // all visuals should be in original state.
	
	
	        function brushed(rangeInfoList) {
	          return !!rangeInfoList.length;
	        }
	        /**
	         * Logic for each series: (If the logic has to be modified one day, do it carefully!)
	         *
	         * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
	         *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
	         *                └!hasBrushExist┘                                              └nothing.
	         * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
	         *                └!hasBrushExist┘                                              └nothing.
	         * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
	         *   !brushed┘                                                                  └nothing.
	         * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
	         */
	        // Step A
	
	
	        ecModel.eachSeries(function (seriesModel, seriesIndex) {
	          var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
	          seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
	        });
	
	        function stepAParallel(seriesModel, seriesIndex) {
	          var coordSys = seriesModel.coordinateSystem;
	          hasBrushExists = hasBrushExists || coordSys.hasAxisBrushed();
	          linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
	            activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
	          });
	        }
	
	        function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
	          if (!seriesModel.brushSelector || brushModelNotControll(brushModel, seriesIndex)) {
	            return;
	          }
	
	          each(areas, function (area) {
	            if (brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel)) {
	              rangeInfoList.push(area);
	            }
	
	            hasBrushExists = hasBrushExists || brushed(rangeInfoList);
	          });
	
	          if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
	            var data_1 = seriesModel.getData();
	            data_1.each(function (dataIndex) {
	              if (checkInRange(seriesModel, rangeInfoList, data_1, dataIndex)) {
	                selectedDataIndexForLink[dataIndex] = 1;
	              }
	            });
	          }
	        } // Step B
	
	
	        ecModel.eachSeries(function (seriesModel, seriesIndex) {
	          var seriesBrushSelected = {
	            seriesId: seriesModel.id,
	            seriesIndex: seriesIndex,
	            seriesName: seriesModel.name,
	            dataIndex: []
	          }; // Every series exists in event params, convenient
	          // for user to find series by seriesIndex.
	
	          thisBrushSelected.selected.push(seriesBrushSelected);
	          var rangeInfoList = rangeInfoBySeries[seriesIndex];
	          var data = seriesModel.getData();
	          var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
	            return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	          } : function (dataIndex) {
	            return checkInRange(seriesModel, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	          }; // If no supported brush or no brush, all visuals are in original state.
	
	          (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && applyVisual(STATE_LIST, visualMappings, data, getValueState);
	        });
	      });
	      dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
	    }
	
	    function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
	      // This event will not be triggered when `setOpion`, otherwise dead lock may
	      // triggered when do `setOption` in event listener, which we do not find
	      // satisfactory way to solve yet. Some considered resolutions:
	      // (a) Diff with prevoius selected data ant only trigger event when changed.
	      // But store previous data and diff precisely (i.e., not only by dataIndex, but
	      // also detect value changes in selected data) might bring complexity or fragility.
	      // (b) Use spectial param like `silent` to suppress event triggering.
	      // But such kind of volatile param may be weird in `setOption`.
	      if (!payload) {
	        return;
	      }
	
	      var zr = api.getZr();
	
	      if (zr[DISPATCH_FLAG]) {
	        return;
	      }
	
	      if (!zr[DISPATCH_METHOD]) {
	        zr[DISPATCH_METHOD] = doDispatch;
	      }
	
	      var fn = createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
	      fn(api, brushSelected);
	    }
	
	    function doDispatch(api, brushSelected) {
	      if (!api.isDisposed()) {
	        var zr = api.getZr();
	        zr[DISPATCH_FLAG] = true;
	        api.dispatchAction({
	          type: 'brushSelect',
	          batch: brushSelected
	        });
	        zr[DISPATCH_FLAG] = false;
	      }
	    }
	
	    function checkInRange(seriesModel, rangeInfoList, data, dataIndex) {
	      for (var i = 0, len = rangeInfoList.length; i < len; i++) {
	        var area = rangeInfoList[i];
	
	        if (seriesModel.brushSelector(dataIndex, data, area.selectors, area)) {
	          return true;
	        }
	      }
	    }
	
	    function brushModelNotControll(brushModel, seriesIndex) {
	      var seriesIndices = brushModel.option.seriesIndex;
	      return seriesIndices != null && seriesIndices !== 'all' && (isArray(seriesIndices) ? indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
	    }
	
	    var boundingRectBuilders = {
	      rect: function (area) {
	        return getBoundingRectFromMinMax(area.range);
	      },
	      polygon: function (area) {
	        var minMax;
	        var range = area.range;
	
	        for (var i = 0, len = range.length; i < len; i++) {
	          minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
	          var rg = range[i];
	          rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
	          rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
	          rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
	          rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
	        }
	
	        return minMax && getBoundingRectFromMinMax(minMax);
	      }
	    };
	
	    function getBoundingRectFromMinMax(minMax) {
	      return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
	    }
	
	    var BrushView =
	    /** @class */
	    function (_super) {
	      __extends(BrushView, _super);
	
	      function BrushView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = BrushView.type;
	        return _this;
	      }
	
	      BrushView.prototype.init = function (ecModel, api) {
	        this.ecModel = ecModel;
	        this.api = api;
	        this.model;
	        (this._brushController = new BrushController(api.getZr())).on('brush', bind(this._onBrush, this)).mount();
	      };
	
	      BrushView.prototype.render = function (brushModel, ecModel, api, payload) {
	        this.model = brushModel;
	
	        this._updateController(brushModel, ecModel, api, payload);
	      };
	
	      BrushView.prototype.updateTransform = function (brushModel, ecModel, api, payload) {
	        // PENDING: `updateTransform` is a little tricky, whose layout need
	        // to be calculate mandatorily and other stages will not be performed.
	        // Take care the correctness of the logic. See #11754 .
	        layoutCovers(ecModel);
	
	        this._updateController(brushModel, ecModel, api, payload);
	      };
	
	      BrushView.prototype.updateVisual = function (brushModel, ecModel, api, payload) {
	        this.updateTransform(brushModel, ecModel, api, payload);
	      };
	
	      BrushView.prototype.updateView = function (brushModel, ecModel, api, payload) {
	        this._updateController(brushModel, ecModel, api, payload);
	      };
	
	      BrushView.prototype._updateController = function (brushModel, ecModel, api, payload) {
	        // Do not update controller when drawing.
	        (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
	      }; // updateLayout: updateController,
	      // updateVisual: updateController,
	
	
	      BrushView.prototype.dispose = function () {
	        this._brushController.dispose();
	      };
	
	      BrushView.prototype._onBrush = function (eventParam) {
	        var modelId = this.model.id;
	        var areas = this.model.brushTargetManager.setOutputRanges(eventParam.areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
	        // emits the same params with the last drag move event, and
	        // may have some delay when using touch pad, which makes
	        // animation not smooth (when using debounce).
	
	        (!eventParam.isEnd || eventParam.removeOnClick) && this.api.dispatchAction({
	          type: 'brush',
	          brushId: modelId,
	          areas: clone(areas),
	          $from: modelId
	        });
	        eventParam.isEnd && this.api.dispatchAction({
	          type: 'brushEnd',
	          brushId: modelId,
	          areas: clone(areas),
	          $from: modelId
	        });
	      };
	
	      BrushView.type = 'brush';
	      return BrushView;
	    }(ComponentView);
	
	    var DEFAULT_OUT_OF_BRUSH_COLOR = '#ddd';
	
	    var BrushModel =
	    /** @class */
	    function (_super) {
	      __extends(BrushModel, _super);
	
	      function BrushModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = BrushModel.type;
	        /**
	         * @readOnly
	         */
	
	        _this.areas = [];
	        /**
	         * Current brush painting area settings.
	         * @readOnly
	         */
	
	        _this.brushOption = {};
	        return _this;
	      }
	
	      BrushModel.prototype.optionUpdated = function (newOption, isInit) {
	        var thisOption = this.option;
	        !isInit && replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
	        var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.
	
	        thisOption.outOfBrush = thisOption.outOfBrush || {
	          color: DEFAULT_OUT_OF_BRUSH_COLOR
	        };
	
	        if (!inBrush.hasOwnProperty('liftZ')) {
	          // Bigger than the highlight z lift, otherwise it will
	          // be effected by the highlight z when brush.
	          inBrush.liftZ = 5;
	        }
	      };
	      /**
	       * If `areas` is null/undefined, range state remain.
	       */
	
	
	      BrushModel.prototype.setAreas = function (areas) {
	        if (true) {
	          assert(isArray(areas));
	          each(areas, function (area) {
	            assert(area.brushType, 'Illegal areas');
	          });
	        } // If areas is null/undefined, range state remain.
	        // This helps user to dispatchAction({type: 'brush'}) with no areas
	        // set but just want to get the current brush select info from a `brush` event.
	
	
	        if (!areas) {
	          return;
	        }
	
	        this.areas = map(areas, function (area) {
	          return generateBrushOption(this.option, area);
	        }, this);
	      };
	      /**
	       * Set the current painting brush option.
	       */
	
	
	      BrushModel.prototype.setBrushOption = function (brushOption) {
	        this.brushOption = generateBrushOption(this.option, brushOption);
	        this.brushType = this.brushOption.brushType;
	      };
	
	      BrushModel.type = 'brush';
	      BrushModel.dependencies = ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'];
	      BrushModel.defaultOption = {
	        seriesIndex: 'all',
	        brushType: 'rect',
	        brushMode: 'single',
	        transformable: true,
	        brushStyle: {
	          borderWidth: 1,
	          color: 'rgba(210,219,238,0.3)',
	          borderColor: '#D2DBEE'
	        },
	        throttleType: 'fixRate',
	        throttleDelay: 0,
	        removeOnClick: true,
	        z: 10000
	      };
	      return BrushModel;
	    }(ComponentModel);
	
	    function generateBrushOption(option, brushOption) {
	      return merge({
	        brushType: option.brushType,
	        brushMode: option.brushMode,
	        transformable: option.transformable,
	        brushStyle: new Model(option.brushStyle).getItemStyle(),
	        removeOnClick: option.removeOnClick,
	        z: option.z
	      }, brushOption, true);
	    }
	
	    var ICON_TYPES = ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'];
	
	    var BrushFeature =
	    /** @class */
	    function (_super) {
	      __extends(BrushFeature, _super);
	
	      function BrushFeature() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      BrushFeature.prototype.render = function (featureModel, ecModel, api) {
	        var brushType;
	        var brushMode;
	        var isBrushed;
	        ecModel.eachComponent({
	          mainType: 'brush'
	        }, function (brushModel) {
	          brushType = brushModel.brushType;
	          brushMode = brushModel.brushOption.brushMode || 'single';
	          isBrushed = isBrushed || !!brushModel.areas.length;
	        });
	        this._brushType = brushType;
	        this._brushMode = brushMode;
	        each(featureModel.get('type', true), function (type) {
	          featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
	        });
	      };
	
	      BrushFeature.prototype.updateView = function (featureModel, ecModel, api) {
	        this.render(featureModel, ecModel, api);
	      };
	
	      BrushFeature.prototype.getIcons = function () {
	        var model = this.model;
	        var availableIcons = model.get('icon', true);
	        var icons = {};
	        each(model.get('type', true), function (type) {
	          if (availableIcons[type]) {
	            icons[type] = availableIcons[type];
	          }
	        });
	        return icons;
	      };
	
	      BrushFeature.prototype.onclick = function (ecModel, api, type) {
	        var brushType = this._brushType;
	        var brushMode = this._brushMode;
	
	        if (type === 'clear') {
	          // Trigger parallel action firstly
	          api.dispatchAction({
	            type: 'axisAreaSelect',
	            intervals: []
	          });
	          api.dispatchAction({
	            type: 'brush',
	            command: 'clear',
	            // Clear all areas of all brush components.
	            areas: []
	          });
	        } else {
	          api.dispatchAction({
	            type: 'takeGlobalCursor',
	            key: 'brush',
	            brushOption: {
	              brushType: type === 'keep' ? brushType : brushType === type ? false : type,
	              brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
	            }
	          });
	        }
	      };
	
	      BrushFeature.getDefaultOption = function (ecModel) {
	        var defaultOption = {
	          show: true,
	          type: ICON_TYPES.slice(),
	          icon: {
	            /* eslint-disable */
	            rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
	            polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
	            lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
	            lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
	            keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
	            clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
	
	            /* eslint-enable */
	
	          },
	          // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
	          title: ecModel.getLocaleModel().get(['toolbox', 'brush', 'title'])
	        };
	        return defaultOption;
	      };
	
	      return BrushFeature;
	    }(ToolboxFeature);
	
	    function install$B(registers) {
	      registers.registerComponentView(BrushView);
	      registers.registerComponentModel(BrushModel);
	      registers.registerPreprocessor(brushPreprocessor);
	      registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, brushVisual);
	      registers.registerAction({
	        type: 'brush',
	        event: 'brush',
	        update: 'updateVisual'
	      }, function (payload, ecModel) {
	        ecModel.eachComponent({
	          mainType: 'brush',
	          query: payload
	        }, function (brushModel) {
	          brushModel.setAreas(payload.areas);
	        });
	      });
	      /**
	       * payload: {
	       *      brushComponents: [
	       *          {
	       *              brushId,
	       *              brushIndex,
	       *              brushName,
	       *              series: [
	       *                  {
	       *                      seriesId,
	       *                      seriesIndex,
	       *                      seriesName,
	       *                      rawIndices: [21, 34, ...]
	       *                  },
	       *                  ...
	       *              ]
	       *          },
	       *          ...
	       *      ]
	       * }
	       */
	
	      registers.registerAction({
	        type: 'brushSelect',
	        event: 'brushSelected',
	        update: 'none'
	      }, noop);
	      registers.registerAction({
	        type: 'brushEnd',
	        event: 'brushEnd',
	        update: 'none'
	      }, noop);
	      registerFeature('brush', BrushFeature);
	    }
	
	    var TitleModel =
	    /** @class */
	    function (_super) {
	      __extends(TitleModel, _super);
	
	      function TitleModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = TitleModel.type;
	        _this.layoutMode = {
	          type: 'box',
	          ignoreSize: true
	        };
	        return _this;
	      }
	
	      TitleModel.type = 'title';
	      TitleModel.defaultOption = {
	        // zlevel: 0,
	        z: 6,
	        show: true,
	        text: '',
	        target: 'blank',
	        subtext: '',
	        subtarget: 'blank',
	        left: 0,
	        top: 0,
	        backgroundColor: 'rgba(0,0,0,0)',
	        borderColor: '#ccc',
	        borderWidth: 0,
	        padding: 5,
	        itemGap: 10,
	        textStyle: {
	          fontSize: 18,
	          fontWeight: 'bold',
	          color: '#464646'
	        },
	        subtextStyle: {
	          fontSize: 12,
	          color: '#6E7079'
	        }
	      };
	      return TitleModel;
	    }(ComponentModel); // View
	
	
	    var TitleView =
	    /** @class */
	    function (_super) {
	      __extends(TitleView, _super);
	
	      function TitleView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = TitleView.type;
	        return _this;
	      }
	
	      TitleView.prototype.render = function (titleModel, ecModel, api) {
	        this.group.removeAll();
	
	        if (!titleModel.get('show')) {
	          return;
	        }
	
	        var group = this.group;
	        var textStyleModel = titleModel.getModel('textStyle');
	        var subtextStyleModel = titleModel.getModel('subtextStyle');
	        var textAlign = titleModel.get('textAlign');
	        var textVerticalAlign = retrieve2(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
	        var textEl = new ZRText({
	          style: createTextStyle(textStyleModel, {
	            text: titleModel.get('text'),
	            fill: textStyleModel.getTextColor()
	          }, {
	            disableBox: true
	          }),
	          z2: 10
	        });
	        var textRect = textEl.getBoundingRect();
	        var subText = titleModel.get('subtext');
	        var subTextEl = new ZRText({
	          style: createTextStyle(subtextStyleModel, {
	            text: subText,
	            fill: subtextStyleModel.getTextColor(),
	            y: textRect.height + titleModel.get('itemGap'),
	            verticalAlign: 'top'
	          }, {
	            disableBox: true
	          }),
	          z2: 10
	        });
	        var link = titleModel.get('link');
	        var sublink = titleModel.get('sublink');
	        var triggerEvent = titleModel.get('triggerEvent', true);
	        textEl.silent = !link && !triggerEvent;
	        subTextEl.silent = !sublink && !triggerEvent;
	
	        if (link) {
	          textEl.on('click', function () {
	            windowOpen(link, '_' + titleModel.get('target'));
	          });
	        }
	
	        if (sublink) {
	          subTextEl.on('click', function () {
	            windowOpen(sublink, '_' + titleModel.get('subtarget'));
	          });
	        }
	
	        getECData(textEl).eventData = getECData(subTextEl).eventData = triggerEvent ? {
	          componentType: 'title',
	          componentIndex: titleModel.componentIndex
	        } : null;
	        group.add(textEl);
	        subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.
	
	        var groupRect = group.getBoundingRect();
	        var layoutOption = titleModel.getBoxLayoutParams();
	        layoutOption.width = groupRect.width;
	        layoutOption.height = groupRect.height;
	        var layoutRect = getLayoutRect(layoutOption, {
	          width: api.getWidth(),
	          height: api.getHeight()
	        }, titleModel.get('padding')); // Adjust text align based on position
	
	        if (!textAlign) {
	          // Align left if title is on the left. center and right is same
	          textAlign = titleModel.get('left') || titleModel.get('right'); // @ts-ignore
	
	          if (textAlign === 'middle') {
	            textAlign = 'center';
	          } // Adjust layout by text align
	
	
	          if (textAlign === 'right') {
	            layoutRect.x += layoutRect.width;
	          } else if (textAlign === 'center') {
	            layoutRect.x += layoutRect.width / 2;
	          }
	        }
	
	        if (!textVerticalAlign) {
	          textVerticalAlign = titleModel.get('top') || titleModel.get('bottom'); // @ts-ignore
	
	          if (textVerticalAlign === 'center') {
	            textVerticalAlign = 'middle';
	          }
	
	          if (textVerticalAlign === 'bottom') {
	            layoutRect.y += layoutRect.height;
	          } else if (textVerticalAlign === 'middle') {
	            layoutRect.y += layoutRect.height / 2;
	          }
	
	          textVerticalAlign = textVerticalAlign || 'top';
	        }
	
	        group.x = layoutRect.x;
	        group.y = layoutRect.y;
	        group.markRedraw();
	        var alignStyle = {
	          align: textAlign,
	          verticalAlign: textVerticalAlign
	        };
	        textEl.setStyle(alignStyle);
	        subTextEl.setStyle(alignStyle); // Render background
	        // Get groupRect again because textAlign has been changed
	
	        groupRect = group.getBoundingRect();
	        var padding = layoutRect.margin;
	        var style = titleModel.getItemStyle(['color', 'opacity']);
	        style.fill = titleModel.get('backgroundColor');
	        var rect = new Rect({
	          shape: {
	            x: groupRect.x - padding[3],
	            y: groupRect.y - padding[0],
	            width: groupRect.width + padding[1] + padding[3],
	            height: groupRect.height + padding[0] + padding[2],
	            r: titleModel.get('borderRadius')
	          },
	          style: style,
	          subPixelOptimize: true,
	          silent: true
	        });
	        group.add(rect);
	      };
	
	      TitleView.type = 'title';
	      return TitleView;
	    }(ComponentView);
	
	    function install$C(registers) {
	      registers.registerComponentModel(TitleModel);
	      registers.registerComponentView(TitleView);
	    }
	
	    var TimelineModel =
	    /** @class */
	    function (_super) {
	      __extends(TimelineModel, _super);
	
	      function TimelineModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = TimelineModel.type;
	        _this.layoutMode = 'box';
	        return _this;
	      }
	      /**
	       * @override
	       */
	
	
	      TimelineModel.prototype.init = function (option, parentModel, ecModel) {
	        this.mergeDefaultAndTheme(option, ecModel);
	
	        this._initData();
	      };
	      /**
	       * @override
	       */
	
	
	      TimelineModel.prototype.mergeOption = function (option) {
	        _super.prototype.mergeOption.apply(this, arguments);
	
	        this._initData();
	      };
	
	      TimelineModel.prototype.setCurrentIndex = function (currentIndex) {
	        if (currentIndex == null) {
	          currentIndex = this.option.currentIndex;
	        }
	
	        var count = this._data.count();
	
	        if (this.option.loop) {
	          currentIndex = (currentIndex % count + count) % count;
	        } else {
	          currentIndex >= count && (currentIndex = count - 1);
	          currentIndex < 0 && (currentIndex = 0);
	        }
	
	        this.option.currentIndex = currentIndex;
	      };
	      /**
	       * @return {number} currentIndex
	       */
	
	
	      TimelineModel.prototype.getCurrentIndex = function () {
	        return this.option.currentIndex;
	      };
	      /**
	       * @return {boolean}
	       */
	
	
	      TimelineModel.prototype.isIndexMax = function () {
	        return this.getCurrentIndex() >= this._data.count() - 1;
	      };
	      /**
	       * @param {boolean} state true: play, false: stop
	       */
	
	
	      TimelineModel.prototype.setPlayState = function (state) {
	        this.option.autoPlay = !!state;
	      };
	      /**
	       * @return {boolean} true: play, false: stop
	       */
	
	
	      TimelineModel.prototype.getPlayState = function () {
	        return !!this.option.autoPlay;
	      };
	      /**
	       * @private
	       */
	
	
	      TimelineModel.prototype._initData = function () {
	        var thisOption = this.option;
	        var dataArr = thisOption.data || [];
	        var axisType = thisOption.axisType;
	        var names = this._names = [];
	        var processedDataArr;
	
	        if (axisType === 'category') {
	          processedDataArr = [];
	          each(dataArr, function (item, index) {
	            var value = convertOptionIdName(getDataItemValue(item), '');
	            var newItem;
	
	            if (isObject(item)) {
	              newItem = clone(item);
	              newItem.value = index;
	            } else {
	              newItem = index;
	            }
	
	            processedDataArr.push(newItem);
	            names.push(value);
	          });
	        } else {
	          processedDataArr = dataArr;
	        }
	
	        var dimType = {
	          category: 'ordinal',
	          time: 'time',
	          value: 'number'
	        }[axisType] || 'number';
	        var data = this._data = new SeriesData([{
	          name: 'value',
	          type: dimType
	        }], this);
	        data.initData(processedDataArr, names);
	      };
	
	      TimelineModel.prototype.getData = function () {
	        return this._data;
	      };
	      /**
	       * @public
	       * @return {Array.<string>} categoreis
	       */
	
	
	      TimelineModel.prototype.getCategories = function () {
	        if (this.get('axisType') === 'category') {
	          return this._names.slice();
	        }
	      };
	
	      TimelineModel.type = 'timeline';
	      /**
	       * @protected
	       */
	
	      TimelineModel.defaultOption = {
	        // zlevel: 0,                  // 一级层叠
	        z: 4,
	        show: true,
	        axisType: 'time',
	        realtime: true,
	        left: '20%',
	        top: null,
	        right: '20%',
	        bottom: 0,
	        width: null,
	        height: 40,
	        padding: 5,
	        controlPosition: 'left',
	        autoPlay: false,
	        rewind: false,
	        loop: true,
	        playInterval: 2000,
	        currentIndex: 0,
	        itemStyle: {},
	        label: {
	          color: '#000'
	        },
	        data: []
	      };
	      return TimelineModel;
	    }(ComponentModel);
	
	    var SliderTimelineModel =
	    /** @class */
	    function (_super) {
	      __extends(SliderTimelineModel, _super);
	
	      function SliderTimelineModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SliderTimelineModel.type;
	        return _this;
	      }
	
	      SliderTimelineModel.type = 'timeline.slider';
	      /**
	       * @protected
	       */
	
	      SliderTimelineModel.defaultOption = inheritDefaultOption(TimelineModel.defaultOption, {
	        backgroundColor: 'rgba(0,0,0,0)',
	        borderColor: '#ccc',
	        borderWidth: 0,
	        orient: 'horizontal',
	        inverse: false,
	        tooltip: {
	          trigger: 'item' // data item may also have tootip attr.
	
	        },
	        symbol: 'circle',
	        symbolSize: 12,
	        lineStyle: {
	          show: true,
	          width: 2,
	          color: '#DAE1F5'
	        },
	        label: {
	          position: 'auto',
	          // When using number, label position is not
	          // restricted by viewRect.
	          // positive: right/bottom, negative: left/top
	          show: true,
	          interval: 'auto',
	          rotate: 0,
	          // formatter: null,
	          // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	          color: '#A4B1D7'
	        },
	        itemStyle: {
	          color: '#A4B1D7',
	          borderWidth: 1
	        },
	        checkpointStyle: {
	          symbol: 'circle',
	          symbolSize: 15,
	          color: '#316bf3',
	          borderColor: '#fff',
	          borderWidth: 2,
	          shadowBlur: 2,
	          shadowOffsetX: 1,
	          shadowOffsetY: 1,
	          shadowColor: 'rgba(0, 0, 0, 0.3)',
	          // borderColor: 'rgba(194,53,49, 0.5)',
	          animation: true,
	          animationDuration: 300,
	          animationEasing: 'quinticInOut'
	        },
	        controlStyle: {
	          show: true,
	          showPlayBtn: true,
	          showPrevBtn: true,
	          showNextBtn: true,
	          itemSize: 24,
	          itemGap: 12,
	          position: 'left',
	          playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
	          stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
	          // eslint-disable-next-line max-len
	          nextIcon: 'M2,18.5A1.52,1.52,0,0,1,.92,18a1.49,1.49,0,0,1,0-2.12L7.81,9.36,1,3.11A1.5,1.5,0,1,1,3,.89l8,7.34a1.48,1.48,0,0,1,.49,1.09,1.51,1.51,0,0,1-.46,1.1L3,18.08A1.5,1.5,0,0,1,2,18.5Z',
	          // eslint-disable-next-line max-len
	          prevIcon: 'M10,.5A1.52,1.52,0,0,1,11.08,1a1.49,1.49,0,0,1,0,2.12L4.19,9.64,11,15.89a1.5,1.5,0,1,1-2,2.22L1,10.77A1.48,1.48,0,0,1,.5,9.68,1.51,1.51,0,0,1,1,8.58L9,.92A1.5,1.5,0,0,1,10,.5Z',
	          prevBtnSize: 18,
	          nextBtnSize: 18,
	          color: '#A4B1D7',
	          borderColor: '#A4B1D7',
	          borderWidth: 1
	        },
	        emphasis: {
	          label: {
	            show: true,
	            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	            color: '#6f778d'
	          },
	          itemStyle: {
	            color: '#316BF3'
	          },
	          controlStyle: {
	            color: '#316BF3',
	            borderColor: '#316BF3',
	            borderWidth: 2
	          }
	        },
	        progress: {
	          lineStyle: {
	            color: '#316BF3'
	          },
	          itemStyle: {
	            color: '#316BF3'
	          },
	          label: {
	            color: '#6f778d'
	          }
	        },
	        data: []
	      });
	      return SliderTimelineModel;
	    }(TimelineModel);
	
	    mixin(SliderTimelineModel, DataFormatMixin.prototype);
	
	    var TimelineView =
	    /** @class */
	    function (_super) {
	      __extends(TimelineView, _super);
	
	      function TimelineView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = TimelineView.type;
	        return _this;
	      }
	
	      TimelineView.type = 'timeline';
	      return TimelineView;
	    }(ComponentView);
	
	    /**
	     * Extend axis 2d
	     */
	
	    var TimelineAxis =
	    /** @class */
	    function (_super) {
	      __extends(TimelineAxis, _super);
	
	      function TimelineAxis(dim, scale, coordExtent, axisType) {
	        var _this = _super.call(this, dim, scale, coordExtent) || this;
	
	        _this.type = axisType || 'value';
	        return _this;
	      }
	      /**
	       * @override
	       */
	
	
	      TimelineAxis.prototype.getLabelModel = function () {
	        // Force override
	        return this.model.getModel('label');
	      };
	      /**
	       * @override
	       */
	
	
	      TimelineAxis.prototype.isHorizontal = function () {
	        return this.model.get('orient') === 'horizontal';
	      };
	
	      return TimelineAxis;
	    }(Axis);
	
	    var PI$8 = Math.PI;
	    var labelDataIndexStore = makeInner();
	
	    var SliderTimelineView =
	    /** @class */
	    function (_super) {
	      __extends(SliderTimelineView, _super);
	
	      function SliderTimelineView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SliderTimelineView.type;
	        return _this;
	      }
	
	      SliderTimelineView.prototype.init = function (ecModel, api) {
	        this.api = api;
	      };
	      /**
	       * @override
	       */
	
	
	      SliderTimelineView.prototype.render = function (timelineModel, ecModel, api) {
	        this.model = timelineModel;
	        this.api = api;
	        this.ecModel = ecModel;
	        this.group.removeAll();
	
	        if (timelineModel.get('show', true)) {
	          var layoutInfo_1 = this._layout(timelineModel, api);
	
	          var mainGroup_1 = this._createGroup('_mainGroup');
	
	          var labelGroup = this._createGroup('_labelGroup');
	
	          var axis_1 = this._axis = this._createAxis(layoutInfo_1, timelineModel);
	
	          timelineModel.formatTooltip = function (dataIndex) {
	            var name = axis_1.scale.getLabel({
	              value: dataIndex
	            });
	            return createTooltipMarkup('nameValue', {
	              noName: true,
	              value: name
	            });
	          };
	
	          each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
	            this['_render' + name](layoutInfo_1, mainGroup_1, axis_1, timelineModel);
	          }, this);
	
	          this._renderAxisLabel(layoutInfo_1, labelGroup, axis_1, timelineModel);
	
	          this._position(layoutInfo_1, timelineModel);
	        }
	
	        this._doPlayStop();
	
	        this._updateTicksStatus();
	      };
	      /**
	       * @override
	       */
	
	
	      SliderTimelineView.prototype.remove = function () {
	        this._clearTimer();
	
	        this.group.removeAll();
	      };
	      /**
	       * @override
	       */
	
	
	      SliderTimelineView.prototype.dispose = function () {
	        this._clearTimer();
	      };
	
	      SliderTimelineView.prototype._layout = function (timelineModel, api) {
	        var labelPosOpt = timelineModel.get(['label', 'position']);
	        var orient = timelineModel.get('orient');
	        var viewRect = getViewRect$5(timelineModel, api);
	        var parsedLabelPos; // Auto label offset.
	
	        if (labelPosOpt == null || labelPosOpt === 'auto') {
	          parsedLabelPos = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
	        } else if (isString(labelPosOpt)) {
	          parsedLabelPos = {
	            horizontal: {
	              top: '-',
	              bottom: '+'
	            },
	            vertical: {
	              left: '-',
	              right: '+'
	            }
	          }[orient][labelPosOpt];
	        } else {
	          // is number
	          parsedLabelPos = labelPosOpt;
	        }
	
	        var labelAlignMap = {
	          horizontal: 'center',
	          vertical: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'left' : 'right'
	        };
	        var labelBaselineMap = {
	          horizontal: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'top' : 'bottom',
	          vertical: 'middle'
	        };
	        var rotationMap = {
	          horizontal: 0,
	          vertical: PI$8 / 2
	        }; // Position
	
	        var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
	        var controlModel = timelineModel.getModel('controlStyle');
	        var showControl = controlModel.get('show', true);
	        var controlSize = showControl ? controlModel.get('itemSize') : 0;
	        var controlGap = showControl ? controlModel.get('itemGap') : 0;
	        var sizePlusGap = controlSize + controlGap; // Special label rotate.
	
	        var labelRotation = timelineModel.get(['label', 'rotate']) || 0;
	        labelRotation = labelRotation * PI$8 / 180; // To radian.
	
	        var playPosition;
	        var prevBtnPosition;
	        var nextBtnPosition;
	        var controlPosition = controlModel.get('position', true);
	        var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
	        var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
	        var showNextBtn = showControl && controlModel.get('showNextBtn', true);
	        var xLeft = 0;
	        var xRight = mainLength; // position[0] means left, position[1] means middle.
	
	        if (controlPosition === 'left' || controlPosition === 'bottom') {
	          showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
	          showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
	          showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	        } else {
	          // 'top' 'right'
	          showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	          showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
	          showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	        }
	
	        var axisExtent = [xLeft, xRight];
	
	        if (timelineModel.get('inverse')) {
	          axisExtent.reverse();
	        }
	
	        return {
	          viewRect: viewRect,
	          mainLength: mainLength,
	          orient: orient,
	          rotation: rotationMap[orient],
	          labelRotation: labelRotation,
	          labelPosOpt: parsedLabelPos,
	          labelAlign: timelineModel.get(['label', 'align']) || labelAlignMap[orient],
	          labelBaseline: timelineModel.get(['label', 'verticalAlign']) || timelineModel.get(['label', 'baseline']) || labelBaselineMap[orient],
	          // Based on mainGroup.
	          playPosition: playPosition,
	          prevBtnPosition: prevBtnPosition,
	          nextBtnPosition: nextBtnPosition,
	          axisExtent: axisExtent,
	          controlSize: controlSize,
	          controlGap: controlGap
	        };
	      };
	
	      SliderTimelineView.prototype._position = function (layoutInfo, timelineModel) {
	        // Position is be called finally, because bounding rect is needed for
	        // adapt content to fill viewRect (auto adapt offset).
	        // Timeline may be not all in the viewRect when 'offset' is specified
	        // as a number, because it is more appropriate that label aligns at
	        // 'offset' but not the other edge defined by viewRect.
	        var mainGroup = this._mainGroup;
	        var labelGroup = this._labelGroup;
	        var viewRect = layoutInfo.viewRect;
	
	        if (layoutInfo.orient === 'vertical') {
	          // transform to horizontal, inverse rotate by left-top point.
	          var m = create$1();
	          var rotateOriginX = viewRect.x;
	          var rotateOriginY = viewRect.y + viewRect.height;
	          translate(m, m, [-rotateOriginX, -rotateOriginY]);
	          rotate(m, m, -PI$8 / 2);
	          translate(m, m, [rotateOriginX, rotateOriginY]);
	          viewRect = viewRect.clone();
	          viewRect.applyTransform(m);
	        }
	
	        var viewBound = getBound(viewRect);
	        var mainBound = getBound(mainGroup.getBoundingRect());
	        var labelBound = getBound(labelGroup.getBoundingRect());
	        var mainPosition = [mainGroup.x, mainGroup.y];
	        var labelsPosition = [labelGroup.x, labelGroup.y];
	        labelsPosition[0] = mainPosition[0] = viewBound[0][0];
	        var labelPosOpt = layoutInfo.labelPosOpt;
	
	        if (labelPosOpt == null || isString(labelPosOpt)) {
	          // '+' or '-'
	          var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
	          toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	          toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
	        } else {
	          var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
	          toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	          labelsPosition[1] = mainPosition[1] + labelPosOpt;
	        }
	
	        mainGroup.setPosition(mainPosition);
	        labelGroup.setPosition(labelsPosition);
	        mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
	        setOrigin(mainGroup);
	        setOrigin(labelGroup);
	
	        function setOrigin(targetGroup) {
	          targetGroup.originX = viewBound[0][0] - targetGroup.x;
	          targetGroup.originY = viewBound[1][0] - targetGroup.y;
	        }
	
	        function getBound(rect) {
	          // [[xmin, xmax], [ymin, ymax]]
	          return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
	        }
	
	        function toBound(fromPos, from, to, dimIdx, boundIdx) {
	          fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
	        }
	      };
	
	      SliderTimelineView.prototype._createAxis = function (layoutInfo, timelineModel) {
	        var data = timelineModel.getData();
	        var axisType = timelineModel.get('axisType');
	        var scale = createScaleByModel$1(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.
	
	        scale.getTicks = function () {
	          return data.mapArray(['value'], function (value) {
	            return {
	              value: value
	            };
	          });
	        };
	
	        var dataExtent = data.getDataExtent('value');
	        scale.setExtent(dataExtent[0], dataExtent[1]);
	        scale.calcNiceTicks();
	        var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
	        axis.model = timelineModel;
	        return axis;
	      };
	
	      SliderTimelineView.prototype._createGroup = function (key) {
	        var newGroup = this[key] = new Group();
	        this.group.add(newGroup);
	        return newGroup;
	      };
	
	      SliderTimelineView.prototype._renderAxisLine = function (layoutInfo, group, axis, timelineModel) {
	        var axisExtent = axis.getExtent();
	
	        if (!timelineModel.get(['lineStyle', 'show'])) {
	          return;
	        }
	
	        var line = new Line({
	          shape: {
	            x1: axisExtent[0],
	            y1: 0,
	            x2: axisExtent[1],
	            y2: 0
	          },
	          style: extend({
	            lineCap: 'round'
	          }, timelineModel.getModel('lineStyle').getLineStyle()),
	          silent: true,
	          z2: 1
	        });
	        group.add(line);
	        var progressLine = this._progressLine = new Line({
	          shape: {
	            x1: axisExtent[0],
	            x2: this._currentPointer ? this._currentPointer.x : axisExtent[0],
	            y1: 0,
	            y2: 0
	          },
	          style: defaults({
	            lineCap: 'round',
	            lineWidth: line.style.lineWidth
	          }, timelineModel.getModel(['progress', 'lineStyle']).getLineStyle()),
	          silent: true,
	          z2: 1
	        });
	        group.add(progressLine);
	      };
	
	      SliderTimelineView.prototype._renderAxisTick = function (layoutInfo, group, axis, timelineModel) {
	        var _this = this;
	
	        var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.
	
	        var ticks = axis.scale.getTicks();
	        this._tickSymbols = []; // The value is dataIndex, see the customized scale.
	
	        each(ticks, function (tick) {
	          var tickCoord = axis.dataToCoord(tick.value);
	          var itemModel = data.getItemModel(tick.value);
	          var itemStyleModel = itemModel.getModel('itemStyle');
	          var hoverStyleModel = itemModel.getModel(['emphasis', 'itemStyle']);
	          var progressStyleModel = itemModel.getModel(['progress', 'itemStyle']);
	          var symbolOpt = {
	            x: tickCoord,
	            y: 0,
	            onclick: bind(_this._changeTimeline, _this, tick.value)
	          };
	          var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
	          el.ensureState('emphasis').style = hoverStyleModel.getItemStyle();
	          el.ensureState('progress').style = progressStyleModel.getItemStyle();
	          enableHoverEmphasis(el);
	          var ecData = getECData(el);
	
	          if (itemModel.get('tooltip')) {
	            ecData.dataIndex = tick.value;
	            ecData.dataModel = timelineModel;
	          } else {
	            ecData.dataIndex = ecData.dataModel = null;
	          }
	
	          _this._tickSymbols.push(el);
	        });
	      };
	
	      SliderTimelineView.prototype._renderAxisLabel = function (layoutInfo, group, axis, timelineModel) {
	        var _this = this;
	
	        var labelModel = axis.getLabelModel();
	
	        if (!labelModel.get('show')) {
	          return;
	        }
	
	        var data = timelineModel.getData();
	        var labels = axis.getViewLabels();
	        this._tickLabels = [];
	        each(labels, function (labelItem) {
	          // The tickValue is dataIndex, see the customized scale.
	          var dataIndex = labelItem.tickValue;
	          var itemModel = data.getItemModel(dataIndex);
	          var normalLabelModel = itemModel.getModel('label');
	          var hoverLabelModel = itemModel.getModel(['emphasis', 'label']);
	          var progressLabelModel = itemModel.getModel(['progress', 'label']);
	          var tickCoord = axis.dataToCoord(labelItem.tickValue);
	          var textEl = new ZRText({
	            x: tickCoord,
	            y: 0,
	            rotation: layoutInfo.labelRotation - layoutInfo.rotation,
	            onclick: bind(_this._changeTimeline, _this, dataIndex),
	            silent: false,
	            style: createTextStyle(normalLabelModel, {
	              text: labelItem.formattedLabel,
	              align: layoutInfo.labelAlign,
	              verticalAlign: layoutInfo.labelBaseline
	            })
	          });
	          textEl.ensureState('emphasis').style = createTextStyle(hoverLabelModel);
	          textEl.ensureState('progress').style = createTextStyle(progressLabelModel);
	          group.add(textEl);
	          enableHoverEmphasis(textEl);
	          labelDataIndexStore(textEl).dataIndex = dataIndex;
	
	          _this._tickLabels.push(textEl);
	        });
	      };
	
	      SliderTimelineView.prototype._renderControl = function (layoutInfo, group, axis, timelineModel) {
	        var controlSize = layoutInfo.controlSize;
	        var rotation = layoutInfo.rotation;
	        var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
	        var hoverStyle = timelineModel.getModel(['emphasis', 'controlStyle']).getItemStyle();
	        var playState = timelineModel.getPlayState();
	        var inverse = timelineModel.get('inverse', true);
	        makeBtn(layoutInfo.nextBtnPosition, 'next', bind(this._changeTimeline, this, inverse ? '-' : '+'));
	        makeBtn(layoutInfo.prevBtnPosition, 'prev', bind(this._changeTimeline, this, inverse ? '+' : '-'));
	        makeBtn(layoutInfo.playPosition, playState ? 'stop' : 'play', bind(this._handlePlayClick, this, !playState), true);
	
	        function makeBtn(position, iconName, onclick, willRotate) {
	          if (!position) {
	            return;
	          }
	
	          var iconSize = parsePercent(retrieve2(timelineModel.get(['controlStyle', iconName + 'BtnSize']), controlSize), controlSize);
	          var rect = [0, -iconSize / 2, iconSize, iconSize];
	          var btn = makeControlIcon(timelineModel, iconName + 'Icon', rect, {
	            x: position[0],
	            y: position[1],
	            originX: controlSize / 2,
	            originY: 0,
	            rotation: willRotate ? -rotation : 0,
	            rectHover: true,
	            style: itemStyle,
	            onclick: onclick
	          });
	          btn.ensureState('emphasis').style = hoverStyle;
	          group.add(btn);
	          enableHoverEmphasis(btn);
	        }
	      };
	
	      SliderTimelineView.prototype._renderCurrentPointer = function (layoutInfo, group, axis, timelineModel) {
	        var data = timelineModel.getData();
	        var currentIndex = timelineModel.getCurrentIndex();
	        var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
	        var me = this;
	        var callback = {
	          onCreate: function (pointer) {
	            pointer.draggable = true;
	            pointer.drift = bind(me._handlePointerDrag, me);
	            pointer.ondragend = bind(me._handlePointerDragend, me);
	            pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel, true);
	          },
	          onUpdate: function (pointer) {
	            pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel);
	          }
	        }; // Reuse when exists, for animation and drag.
	
	        this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
	      };
	
	      SliderTimelineView.prototype._handlePlayClick = function (nextState) {
	        this._clearTimer();
	
	        this.api.dispatchAction({
	          type: 'timelinePlayChange',
	          playState: nextState,
	          from: this.uid
	        });
	      };
	
	      SliderTimelineView.prototype._handlePointerDrag = function (dx, dy, e) {
	        this._clearTimer();
	
	        this._pointerChangeTimeline([e.offsetX, e.offsetY]);
	      };
	
	      SliderTimelineView.prototype._handlePointerDragend = function (e) {
	        this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
	      };
	
	      SliderTimelineView.prototype._pointerChangeTimeline = function (mousePos, trigger) {
	        var toCoord = this._toAxisCoord(mousePos)[0];
	
	        var axis = this._axis;
	        var axisExtent = asc(axis.getExtent().slice());
	        toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
	        toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
	        this._currentPointer.x = toCoord;
	
	        this._currentPointer.markRedraw();
	
	        var progressLine = this._progressLine;
	
	        if (progressLine) {
	          progressLine.shape.x2 = toCoord;
	          progressLine.dirty();
	        }
	
	        var targetDataIndex = this._findNearestTick(toCoord);
	
	        var timelineModel = this.model;
	
	        if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
	          this._changeTimeline(targetDataIndex);
	        }
	      };
	
	      SliderTimelineView.prototype._doPlayStop = function () {
	        var _this = this;
	
	        this._clearTimer();
	
	        if (this.model.getPlayState()) {
	          this._timer = setTimeout(function () {
	            // Do not cache
	            var timelineModel = _this.model;
	
	            _this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
	          }, this.model.get('playInterval'));
	        }
	      };
	
	      SliderTimelineView.prototype._toAxisCoord = function (vertex) {
	        var trans = this._mainGroup.getLocalTransform();
	
	        return applyTransform$1(vertex, trans, true);
	      };
	
	      SliderTimelineView.prototype._findNearestTick = function (axisCoord) {
	        var data = this.model.getData();
	        var dist = Infinity;
	        var targetDataIndex;
	        var axis = this._axis;
	        data.each(['value'], function (value, dataIndex) {
	          var coord = axis.dataToCoord(value);
	          var d = Math.abs(coord - axisCoord);
	
	          if (d < dist) {
	            dist = d;
	            targetDataIndex = dataIndex;
	          }
	        });
	        return targetDataIndex;
	      };
	
	      SliderTimelineView.prototype._clearTimer = function () {
	        if (this._timer) {
	          clearTimeout(this._timer);
	          this._timer = null;
	        }
	      };
	
	      SliderTimelineView.prototype._changeTimeline = function (nextIndex) {
	        var currentIndex = this.model.getCurrentIndex();
	
	        if (nextIndex === '+') {
	          nextIndex = currentIndex + 1;
	        } else if (nextIndex === '-') {
	          nextIndex = currentIndex - 1;
	        }
	
	        this.api.dispatchAction({
	          type: 'timelineChange',
	          currentIndex: nextIndex,
	          from: this.uid
	        });
	      };
	
	      SliderTimelineView.prototype._updateTicksStatus = function () {
	        var currentIndex = this.model.getCurrentIndex();
	        var tickSymbols = this._tickSymbols;
	        var tickLabels = this._tickLabels;
	
	        if (tickSymbols) {
	          for (var i = 0; i < tickSymbols.length; i++) {
	            tickSymbols && tickSymbols[i] && tickSymbols[i].toggleState('progress', i < currentIndex);
	          }
	        }
	
	        if (tickLabels) {
	          for (var i = 0; i < tickLabels.length; i++) {
	            tickLabels && tickLabels[i] && tickLabels[i].toggleState('progress', labelDataIndexStore(tickLabels[i]).dataIndex <= currentIndex);
	          }
	        }
	      };
	
	      SliderTimelineView.type = 'timeline.slider';
	      return SliderTimelineView;
	    }(TimelineView);
	
	    function createScaleByModel$1(model, axisType) {
	      axisType = axisType || model.get('type');
	
	      if (axisType) {
	        switch (axisType) {
	          // Buildin scale
	          case 'category':
	            return new OrdinalScale({
	              ordinalMeta: model.getCategories(),
	              extent: [Infinity, -Infinity]
	            });
	
	          case 'time':
	            return new TimeScale({
	              locale: model.ecModel.getLocaleModel(),
	              useUTC: model.ecModel.get('useUTC')
	            });
	
	          default:
	            // default to be value
	            return new IntervalScale();
	        }
	      }
	    }
	
	    function getViewRect$5(model, api) {
	      return getLayoutRect(model.getBoxLayoutParams(), {
	        width: api.getWidth(),
	        height: api.getHeight()
	      }, model.get('padding'));
	    }
	
	    function makeControlIcon(timelineModel, objPath, rect, opts) {
	      var style = opts.style;
	      var icon = createIcon(timelineModel.get(['controlStyle', objPath]), opts || {}, new BoundingRect(rect[0], rect[1], rect[2], rect[3])); // TODO createIcon won't use style in opt.
	
	      if (style) {
	        icon.setStyle(style);
	      }
	
	      return icon;
	    }
	    /**
	     * Create symbol or update symbol
	     * opt: basic position and event handlers
	     */
	
	
	    function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
	      var color = itemStyleModel.get('color');
	
	      if (!symbol) {
	        var symbolType = hostModel.get('symbol');
	        symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
	        symbol.setStyle('strokeNoScale', true);
	        group.add(symbol);
	        callback && callback.onCreate(symbol);
	      } else {
	        symbol.setColor(color);
	        group.add(symbol); // Group may be new, also need to add.
	
	        callback && callback.onUpdate(symbol);
	      } // Style
	
	
	      var itemStyle = itemStyleModel.getItemStyle(['color']);
	      symbol.setStyle(itemStyle); // Transform and events.
	
	      opt = merge({
	        rectHover: true,
	        z2: 100
	      }, opt, true);
	      var symbolSize = normalizeSymbolSize(hostModel.get('symbolSize'));
	      opt.scaleX = symbolSize[0] / 2;
	      opt.scaleY = symbolSize[1] / 2;
	      var symbolOffset = normalizeSymbolOffset(hostModel.get('symbolOffset'), symbolSize);
	
	      if (symbolOffset) {
	        opt.x = (opt.x || 0) + symbolOffset[0];
	        opt.y = (opt.y || 0) + symbolOffset[1];
	      }
	
	      var symbolRotate = hostModel.get('symbolRotate');
	      opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	      symbol.attr(opt); // FIXME
	      // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
	      // getBoundingRect will return wrong result.
	      // (This is supposed to be resolved in zrender, but it is a little difficult to
	      // leverage performance and auto updateTransform)
	      // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
	
	      symbol.updateTransform();
	      return symbol;
	    }
	
	    function pointerMoveTo(pointer, progressLine, dataIndex, axis, timelineModel, noAnimation) {
	      if (pointer.dragging) {
	        return;
	      }
	
	      var pointerModel = timelineModel.getModel('checkpointStyle');
	      var toCoord = axis.dataToCoord(timelineModel.getData().get('value', dataIndex));
	
	      if (noAnimation || !pointerModel.get('animation', true)) {
	        pointer.attr({
	          x: toCoord,
	          y: 0
	        });
	        progressLine && progressLine.attr({
	          shape: {
	            x2: toCoord
	          }
	        });
	      } else {
	        var animationCfg = {
	          duration: pointerModel.get('animationDuration', true),
	          easing: pointerModel.get('animationEasing', true)
	        };
	        pointer.stopAnimation(null, true);
	        pointer.animateTo({
	          x: toCoord,
	          y: 0
	        }, animationCfg);
	        progressLine && progressLine.animateTo({
	          shape: {
	            x2: toCoord
	          }
	        }, animationCfg);
	      }
	    }
	
	    function installTimelineAction(registers) {
	      registers.registerAction({
	        type: 'timelineChange',
	        event: 'timelineChanged',
	        update: 'prepareAndUpdate'
	      }, function (payload, ecModel, api) {
	        var timelineModel = ecModel.getComponent('timeline');
	
	        if (timelineModel && payload.currentIndex != null) {
	          timelineModel.setCurrentIndex(payload.currentIndex);
	
	          if (!timelineModel.get('loop', true) && timelineModel.isIndexMax() && timelineModel.getPlayState()) {
	            timelineModel.setPlayState(false); // The timeline has played to the end, trigger event
	
	            api.dispatchAction({
	              type: 'timelinePlayChange',
	              playState: false,
	              from: payload.from
	            });
	          }
	        } // Set normalized currentIndex to payload.
	
	
	        ecModel.resetOption('timeline', {
	          replaceMerge: timelineModel.get('replaceMerge', true)
	        });
	        return defaults({
	          currentIndex: timelineModel.option.currentIndex
	        }, payload);
	      });
	      registers.registerAction({
	        type: 'timelinePlayChange',
	        event: 'timelinePlayChanged',
	        update: 'update'
	      }, function (payload, ecModel) {
	        var timelineModel = ecModel.getComponent('timeline');
	
	        if (timelineModel && payload.playState != null) {
	          timelineModel.setPlayState(payload.playState);
	        }
	      });
	    }
	
	    function timelinePreprocessor(option) {
	      var timelineOpt = option && option.timeline;
	
	      if (!isArray(timelineOpt)) {
	        timelineOpt = timelineOpt ? [timelineOpt] : [];
	      }
	
	      each(timelineOpt, function (opt) {
	        if (!opt) {
	          return;
	        }
	
	        compatibleEC2(opt);
	      });
	    }
	
	    function compatibleEC2(opt) {
	      var type = opt.type;
	      var ec2Types = {
	        'number': 'value',
	        'time': 'time'
	      }; // Compatible with ec2
	
	      if (ec2Types[type]) {
	        opt.axisType = ec2Types[type];
	        delete opt.type;
	      }
	
	      transferItem(opt);
	
	      if (has(opt, 'controlPosition')) {
	        var controlStyle = opt.controlStyle || (opt.controlStyle = {});
	
	        if (!has(controlStyle, 'position')) {
	          controlStyle.position = opt.controlPosition;
	        }
	
	        if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
	          controlStyle.show = false;
	          delete controlStyle.position;
	        }
	
	        delete opt.controlPosition;
	      }
	
	      each(opt.data || [], function (dataItem) {
	        if (isObject(dataItem) && !isArray(dataItem)) {
	          if (!has(dataItem, 'value') && has(dataItem, 'name')) {
	            // In ec2, using name as value.
	            dataItem.value = dataItem.name;
	          }
	
	          transferItem(dataItem);
	        }
	      });
	    }
	
	    function transferItem(opt) {
	      var itemStyle = opt.itemStyle || (opt.itemStyle = {});
	      var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out
	
	      var label = opt.label || opt.label || {};
	      var labelNormal = label.normal || (label.normal = {});
	      var excludeLabelAttr = {
	        normal: 1,
	        emphasis: 1
	      };
	      each(label, function (value, name) {
	        if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
	          labelNormal[name] = value;
	        }
	      });
	
	      if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
	        label.emphasis = itemStyleEmphasis.label;
	        delete itemStyleEmphasis.label;
	      }
	    }
	
	    function has(obj, attr) {
	      return obj.hasOwnProperty(attr);
	    }
	
	    function install$D(registers) {
	      registers.registerComponentModel(SliderTimelineModel);
	      registers.registerComponentView(SliderTimelineView);
	      registers.registerSubTypeDefaulter('timeline', function () {
	        // Only slider now.
	        return 'slider';
	      });
	      installTimelineAction(registers);
	      registers.registerPreprocessor(timelinePreprocessor);
	    }
	
	    function checkMarkerInSeries(seriesOpts, markerType) {
	      if (!seriesOpts) {
	        return false;
	      }
	
	      var seriesOptArr = isArray(seriesOpts) ? seriesOpts : [seriesOpts];
	
	      for (var idx = 0; idx < seriesOptArr.length; idx++) {
	        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    function fillLabel(opt) {
	      defaultEmphasis(opt, 'label', ['show']);
	    } // { [componentType]: MarkerModel }
	
	
	    var inner$g = makeInner();
	
	    var MarkerModel =
	    /** @class */
	    function (_super) {
	      __extends(MarkerModel, _super);
	
	      function MarkerModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MarkerModel.type;
	        /**
	         * If marker model is created by self from series
	         */
	
	        _this.createdBySelf = false;
	        return _this;
	      }
	      /**
	       * @overrite
	       */
	
	
	      MarkerModel.prototype.init = function (option, parentModel, ecModel) {
	        if (true) {
	          if (this.type === 'marker') {
	            throw new Error('Marker component is abstract component. Use markLine, markPoint, markArea instead.');
	          }
	        }
	
	        this.mergeDefaultAndTheme(option, ecModel);
	
	        this._mergeOption(option, ecModel, false, true);
	      };
	
	      MarkerModel.prototype.isAnimationEnabled = function () {
	        if (env.node) {
	          return false;
	        }
	
	        var hostSeries = this.__hostSeries;
	        return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
	      };
	      /**
	       * @overrite
	       */
	
	
	      MarkerModel.prototype.mergeOption = function (newOpt, ecModel) {
	        this._mergeOption(newOpt, ecModel, false, false);
	      };
	
	      MarkerModel.prototype._mergeOption = function (newOpt, ecModel, createdBySelf, isInit) {
	        var componentType = this.mainType;
	
	        if (!createdBySelf) {
	          ecModel.eachSeries(function (seriesModel) {
	            // mainType can be markPoint, markLine, markArea
	            var markerOpt = seriesModel.get(this.mainType, true);
	            var markerModel = inner$g(seriesModel)[componentType];
	
	            if (!markerOpt || !markerOpt.data) {
	              inner$g(seriesModel)[componentType] = null;
	              return;
	            }
	
	            if (!markerModel) {
	              if (isInit) {
	                // Default label emphasis `position` and `show`
	                fillLabel(markerOpt);
	              }
	
	              each(markerOpt.data, function (item) {
	                // FIXME Overwrite fillLabel method ?
	                if (item instanceof Array) {
	                  fillLabel(item[0]);
	                  fillLabel(item[1]);
	                } else {
	                  fillLabel(item);
	                }
	              });
	              markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel); // markerModel = new ImplementedMarkerModel(
	              //     markerOpt, this, ecModel
	              // );
	
	              extend(markerModel, {
	                mainType: this.mainType,
	                // Use the same series index and name
	                seriesIndex: seriesModel.seriesIndex,
	                name: seriesModel.name,
	                createdBySelf: true
	              });
	              markerModel.__hostSeries = seriesModel;
	            } else {
	              markerModel._mergeOption(markerOpt, ecModel, true);
	            }
	
	            inner$g(seriesModel)[componentType] = markerModel;
	          }, this);
	        }
	      };
	
	      MarkerModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
	        var data = this.getData();
	        var value = this.getRawValue(dataIndex);
	        var itemName = data.getName(dataIndex);
	        return createTooltipMarkup('section', {
	          header: this.name,
	          blocks: [createTooltipMarkup('nameValue', {
	            name: itemName,
	            value: value,
	            noName: !itemName,
	            noValue: value == null
	          })]
	        });
	      };
	
	      MarkerModel.prototype.getData = function () {
	        return this._data;
	      };
	
	      MarkerModel.prototype.setData = function (data) {
	        this._data = data;
	      };
	
	      MarkerModel.getMarkerModelFromSeries = function (seriesModel, // Support three types of markers. Strict check.
	      componentType) {
	        return inner$g(seriesModel)[componentType];
	      };
	
	      MarkerModel.type = 'marker';
	      MarkerModel.dependencies = ['series', 'grid', 'polar', 'geo'];
	      return MarkerModel;
	    }(ComponentModel);
	
	    mixin(MarkerModel, DataFormatMixin.prototype);
	
	    var MarkPointModel =
	    /** @class */
	    function (_super) {
	      __extends(MarkPointModel, _super);
	
	      function MarkPointModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MarkPointModel.type;
	        return _this;
	      }
	
	      MarkPointModel.prototype.createMarkerModelFromSeries = function (markerOpt, masterMarkerModel, ecModel) {
	        return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
	      };
	
	      MarkPointModel.type = 'markPoint';
	      MarkPointModel.defaultOption = {
	        // zlevel: 0,
	        z: 5,
	        symbol: 'pin',
	        symbolSize: 50,
	        // symbolRotate: 0,
	        // symbolOffset: [0, 0]
	        tooltip: {
	          trigger: 'item'
	        },
	        label: {
	          show: true,
	          position: 'inside'
	        },
	        itemStyle: {
	          borderWidth: 2
	        },
	        emphasis: {
	          label: {
	            show: true
	          }
	        }
	      };
	      return MarkPointModel;
	    }(MarkerModel);
	
	    function hasXOrY(item) {
	      return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
	    }
	
	    function hasXAndY(item) {
	      return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
	    }
	
	    function markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
	      var coordArr = [];
	      var stacked = isDimensionStacked(data, targetDataDim
	      /* , otherDataDim */
	      );
	      var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
	      var value = numCalculate(data, calcDataDim, markerType);
	      var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
	      coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
	      coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
	      var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
	
	      var precision = getPrecision(data.get(targetDataDim, dataIndex));
	      precision = Math.min(precision, 20);
	
	      if (precision >= 0) {
	        coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
	      }
	
	      return [coordArr, coordArrValue];
	    } // TODO Specified percent
	
	
	    var markerTypeCalculator = {
	      min: curry(markerTypeCalculatorWithExtent, 'min'),
	      max: curry(markerTypeCalculatorWithExtent, 'max'),
	      average: curry(markerTypeCalculatorWithExtent, 'average'),
	      median: curry(markerTypeCalculatorWithExtent, 'median')
	    };
	    /**
	     * Transform markPoint data item to format used in List by do the following
	     * 1. Calculate statistic like `max`, `min`, `average`
	     * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
	     */
	
	    function dataTransform(seriesModel, item) {
	      if (!item) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      var coordSys = seriesModel.coordinateSystem;
	      var dims = coordSys && coordSys.dimensions; // 1. If not specify the position with pixel directly
	      // 2. If `coord` is not a data array. Which uses `xAxis`,
	      // `yAxis` to specify the coord on each dimension
	      // parseFloat first because item.x and item.y can be percent string like '20%'
	
	      if (!hasXAndY(item) && !isArray(item.coord) && isArray(dims)) {
	        var axisInfo = getAxisInfo$1(item, data, coordSys, seriesModel); // Clone the option
	        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
	
	        item = clone(item);
	
	        if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
	          var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
	          var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
	          var coordInfo = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
	          item.coord = coordInfo[0]; // Force to use the value of calculated value.
	          // let item use the value without stack.
	
	          item.value = coordInfo[1];
	        } else {
	          // FIXME Only has one of xAxis and yAxis.
	          item.coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis];
	        }
	      } // x y is provided
	
	
	      if (item.coord == null || !isArray(dims)) {
	        item.coord = [];
	      } else {
	        // Each coord support max, min, average
	        var coord = item.coord;
	
	        for (var i = 0; i < 2; i++) {
	          if (markerTypeCalculator[coord[i]]) {
	            coord[i] = numCalculate(data, data.mapDimension(dims[i]), coord[i]);
	          }
	        }
	      }
	
	      return item;
	    }
	    function getAxisInfo$1(item, data, coordSys, seriesModel) {
	      var ret = {};
	
	      if (item.valueIndex != null || item.valueDim != null) {
	        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
	        ret.valueAxis = coordSys.getAxis(dataDimToCoordDim(seriesModel, ret.valueDataDim));
	        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
	        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	      } else {
	        ret.baseAxis = seriesModel.getBaseAxis();
	        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
	        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
	      }
	
	      return ret;
	    }
	
	    function dataDimToCoordDim(seriesModel, dataDim) {
	      var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
	      return dimItem && dimItem.coordDim;
	    }
	    /**
	     * Filter data which is out of coordinateSystem range
	     * [dataFilter description]
	     */
	
	
	    function dataFilter$1( // Currently only polar and cartesian has containData.
	    coordSys, item) {
	      // Always return true if there is no coordSys
	      return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
	    }
	    function zoneFilter( // Currently only polar and cartesian has containData.
	    coordSys, item1, item2) {
	      // Always return true if there is no coordSys
	      return coordSys && coordSys.containZone && item1.coord && item2.coord && !hasXOrY(item1) && !hasXOrY(item2) ? coordSys.containZone(item1.coord, item2.coord) : true;
	    }
	    function createMarkerDimValueGetter(inCoordSys, dims) {
	      return inCoordSys ? function (item, dimName, dataIndex, dimIndex) {
	        var rawVal = dimIndex < 2 // x, y, radius, angle
	        ? item.coord && item.coord[dimIndex] : item.value;
	        return parseDataValue(rawVal, dims[dimIndex]);
	      } : function (item, dimName, dataIndex, dimIndex) {
	        return parseDataValue(item.value, dims[dimIndex]);
	      };
	    }
	    function numCalculate(data, valueDataDim, type) {
	      if (type === 'average') {
	        var sum_1 = 0;
	        var count_1 = 0;
	        data.each(valueDataDim, function (val, idx) {
	          if (!isNaN(val)) {
	            sum_1 += val;
	            count_1++;
	          }
	        });
	        return sum_1 / count_1;
	      } else if (type === 'median') {
	        return data.getMedian(valueDataDim);
	      } else {
	        // max & min
	        return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
	      }
	    }
	
	    var inner$h = makeInner();
	
	    var MarkerView =
	    /** @class */
	    function (_super) {
	      __extends(MarkerView, _super);
	
	      function MarkerView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MarkerView.type;
	        return _this;
	      }
	
	      MarkerView.prototype.init = function () {
	        this.markerGroupMap = createHashMap();
	      };
	
	      MarkerView.prototype.render = function (markerModel, ecModel, api) {
	        var _this = this;
	
	        var markerGroupMap = this.markerGroupMap;
	        markerGroupMap.each(function (item) {
	          inner$h(item).keep = false;
	        });
	        ecModel.eachSeries(function (seriesModel) {
	          var markerModel = MarkerModel.getMarkerModelFromSeries(seriesModel, _this.type);
	          markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
	        });
	        markerGroupMap.each(function (item) {
	          !inner$h(item).keep && _this.group.remove(item.group);
	        });
	      };
	
	      MarkerView.prototype.markKeep = function (drawGroup) {
	        inner$h(drawGroup).keep = true;
	      };
	
	      MarkerView.prototype.toggleBlurSeries = function (seriesModelList, isBlur) {
	        var _this = this;
	
	        each(seriesModelList, function (seriesModel) {
	          var markerModel = MarkerModel.getMarkerModelFromSeries(seriesModel, _this.type);
	
	          if (markerModel) {
	            var data = markerModel.getData();
	            data.eachItemGraphicEl(function (el) {
	              if (el) {
	                isBlur ? enterBlur(el) : leaveBlur(el);
	              }
	            });
	          }
	        });
	      };
	
	      MarkerView.type = 'marker';
	      return MarkerView;
	    }(ComponentView);
	
	    function updateMarkerLayout(mpData, seriesModel, api) {
	      var coordSys = seriesModel.coordinateSystem;
	      mpData.each(function (idx) {
	        var itemModel = mpData.getItemModel(idx);
	        var point;
	        var xPx = parsePercent$1(itemModel.get('x'), api.getWidth());
	        var yPx = parsePercent$1(itemModel.get('y'), api.getHeight());
	
	        if (!isNaN(xPx) && !isNaN(yPx)) {
	          point = [xPx, yPx];
	        } // Chart like bar may have there own marker positioning logic
	        else if (seriesModel.getMarkerPosition) {
	            // Use the getMarkerPosition
	            point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
	          } else if (coordSys) {
	            var x = mpData.get(coordSys.dimensions[0], idx);
	            var y = mpData.get(coordSys.dimensions[1], idx);
	            point = coordSys.dataToPoint([x, y]);
	          } // Use x, y if has any
	
	
	        if (!isNaN(xPx)) {
	          point[0] = xPx;
	        }
	
	        if (!isNaN(yPx)) {
	          point[1] = yPx;
	        }
	
	        mpData.setItemLayout(idx, point);
	      });
	    }
	
	    var MarkPointView =
	    /** @class */
	    function (_super) {
	      __extends(MarkPointView, _super);
	
	      function MarkPointView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MarkPointView.type;
	        return _this;
	      }
	
	      MarkPointView.prototype.updateTransform = function (markPointModel, ecModel, api) {
	        ecModel.eachSeries(function (seriesModel) {
	          var mpModel = MarkerModel.getMarkerModelFromSeries(seriesModel, 'markPoint');
	
	          if (mpModel) {
	            updateMarkerLayout(mpModel.getData(), seriesModel, api);
	            this.markerGroupMap.get(seriesModel.id).updateLayout();
	          }
	        }, this);
	      };
	
	      MarkPointView.prototype.renderSeries = function (seriesModel, mpModel, ecModel, api) {
	        var coordSys = seriesModel.coordinateSystem;
	        var seriesId = seriesModel.id;
	        var seriesData = seriesModel.getData();
	        var symbolDrawMap = this.markerGroupMap;
	        var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
	        var mpData = createData(coordSys, seriesModel, mpModel); // FIXME
	
	        mpModel.setData(mpData);
	        updateMarkerLayout(mpModel.getData(), seriesModel, api);
	        mpData.each(function (idx) {
	          var itemModel = mpData.getItemModel(idx);
	          var symbol = itemModel.getShallow('symbol');
	          var symbolSize = itemModel.getShallow('symbolSize');
	          var symbolRotate = itemModel.getShallow('symbolRotate');
	          var symbolOffset = itemModel.getShallow('symbolOffset');
	          var symbolKeepAspect = itemModel.getShallow('symbolKeepAspect'); // TODO: refactor needed: single data item should not support callback function
	
	          if (isFunction(symbol) || isFunction(symbolSize) || isFunction(symbolRotate) || isFunction(symbolOffset)) {
	            var rawIdx = mpModel.getRawValue(idx);
	            var dataParams = mpModel.getDataParams(idx);
	
	            if (isFunction(symbol)) {
	              symbol = symbol(rawIdx, dataParams);
	            }
	
	            if (isFunction(symbolSize)) {
	              // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
	              symbolSize = symbolSize(rawIdx, dataParams);
	            }
	
	            if (isFunction(symbolRotate)) {
	              symbolRotate = symbolRotate(rawIdx, dataParams);
	            }
	
	            if (isFunction(symbolOffset)) {
	              symbolOffset = symbolOffset(rawIdx, dataParams);
	            }
	          }
	
	          var style = itemModel.getModel('itemStyle').getItemStyle();
	          var color = getVisualFromData(seriesData, 'color');
	
	          if (!style.fill) {
	            style.fill = color;
	          }
	
	          mpData.setItemVisual(idx, {
	            symbol: symbol,
	            symbolSize: symbolSize,
	            symbolRotate: symbolRotate,
	            symbolOffset: symbolOffset,
	            symbolKeepAspect: symbolKeepAspect,
	            style: style
	          });
	        }); // TODO Text are wrong
	
	        symbolDraw.updateData(mpData);
	        this.group.add(symbolDraw.group); // Set host model for tooltip
	        // FIXME
	
	        mpData.eachItemGraphicEl(function (el) {
	          el.traverse(function (child) {
	            getECData(child).dataModel = mpModel;
	          });
	        });
	        this.markKeep(symbolDraw);
	        symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
	      };
	
	      MarkPointView.type = 'markPoint';
	      return MarkPointView;
	    }(MarkerView);
	
	    function createData(coordSys, seriesModel, mpModel) {
	      var coordDimsInfos;
	
	      if (coordSys) {
	        coordDimsInfos = map(coordSys && coordSys.dimensions, function (coordDim) {
	          var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	          return extend(extend({}, info), {
	            name: coordDim,
	            // DON'T use ordinalMeta to parse and collect ordinal.
	            ordinalMeta: null
	          });
	        });
	      } else {
	        coordDimsInfos = [{
	          name: 'value',
	          type: 'float'
	        }];
	      }
	
	      var mpData = new SeriesData(coordDimsInfos, mpModel);
	      var dataOpt = map(mpModel.get('data'), curry(dataTransform, seriesModel));
	
	      if (coordSys) {
	        dataOpt = filter(dataOpt, curry(dataFilter$1, coordSys));
	      }
	
	      var dimValueGetter = createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
	      mpData.initData(dataOpt, null, dimValueGetter);
	      return mpData;
	    }
	
	    function install$E(registers) {
	      registers.registerComponentModel(MarkPointModel);
	      registers.registerComponentView(MarkPointView);
	      registers.registerPreprocessor(function (opt) {
	        if (checkMarkerInSeries(opt.series, 'markPoint')) {
	          // Make sure markPoint component is enabled
	          opt.markPoint = opt.markPoint || {};
	        }
	      });
	    }
	
	    var MarkLineModel =
	    /** @class */
	    function (_super) {
	      __extends(MarkLineModel, _super);
	
	      function MarkLineModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MarkLineModel.type;
	        return _this;
	      }
	
	      MarkLineModel.prototype.createMarkerModelFromSeries = function (markerOpt, masterMarkerModel, ecModel) {
	        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
	      };
	
	      MarkLineModel.type = 'markLine';
	      MarkLineModel.defaultOption = {
	        // zlevel: 0,
	        z: 5,
	        symbol: ['circle', 'arrow'],
	        symbolSize: [8, 16],
	        // symbolRotate: 0,
	        symbolOffset: 0,
	        precision: 2,
	        tooltip: {
	          trigger: 'item'
	        },
	        label: {
	          show: true,
	          position: 'end',
	          distance: 5
	        },
	        lineStyle: {
	          type: 'dashed'
	        },
	        emphasis: {
	          label: {
	            show: true
	          },
	          lineStyle: {
	            width: 3
	          }
	        },
	        animationEasing: 'linear'
	      };
	      return MarkLineModel;
	    }(MarkerModel);
	
	    var inner$i = makeInner();
	
	    var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
	      var data = seriesModel.getData();
	      var itemArray;
	
	      if (!isArray(item)) {
	        // Special type markLine like 'min', 'max', 'average', 'median'
	        var mlType = item.type;
	
	        if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
	        // data: [{
	        //   yAxis: 10
	        // }]
	        || item.xAxis != null || item.yAxis != null) {
	          var valueAxis = void 0;
	          var value = void 0;
	
	          if (item.yAxis != null || item.xAxis != null) {
	            valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
	            value = retrieve(item.yAxis, item.xAxis);
	          } else {
	            var axisInfo = getAxisInfo$1(item, data, coordSys, seriesModel);
	            valueAxis = axisInfo.valueAxis;
	            var valueDataDim = getStackedDimension(data, axisInfo.valueDataDim);
	            value = numCalculate(data, valueDataDim, mlType);
	          }
	
	          var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
	          var baseIndex = 1 - valueIndex; // Normized to 2d data with start and end point
	
	          var mlFrom = clone(item);
	          var mlTo = {
	            coord: []
	          };
	          mlFrom.type = null;
	          mlFrom.coord = [];
	          mlFrom.coord[baseIndex] = -Infinity;
	          mlTo.coord[baseIndex] = Infinity;
	          var precision = mlModel.get('precision');
	
	          if (precision >= 0 && isNumber(value)) {
	            value = +value.toFixed(Math.min(precision, 20));
	          }
	
	          mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
	          itemArray = [mlFrom, mlTo, {
	            type: mlType,
	            valueIndex: item.valueIndex,
	            // Force to use the value of calculated value.
	            value: value
	          }];
	        } else {
	          // Invalid data
	          if (true) {
	            logError('Invalid markLine data.');
	          }
	
	          itemArray = [];
	        }
	      } else {
	        itemArray = item;
	      }
	
	      var normalizedItem = [dataTransform(seriesModel, itemArray[0]), dataTransform(seriesModel, itemArray[1]), extend({}, itemArray[2])]; // Avoid line data type is extended by from(to) data type
	
	      normalizedItem[2].type = normalizedItem[2].type || null; // Merge from option and to option into line option
	
	      merge(normalizedItem[2], normalizedItem[0]);
	      merge(normalizedItem[2], normalizedItem[1]);
	      return normalizedItem;
	    };
	
	    function isInfinity(val) {
	      return !isNaN(val) && !isFinite(val);
	    } // If a markLine has one dim
	
	
	    function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	      var otherDimIndex = 1 - dimIndex;
	      var dimName = coordSys.dimensions[dimIndex];
	      return isInfinity(fromCoord[otherDimIndex]) && isInfinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
	    }
	
	    function markLineFilter(coordSys, item) {
	      if (coordSys.type === 'cartesian2d') {
	        var fromCoord = item[0].coord;
	        var toCoord = item[1].coord; // In case
	        // {
	        //  markLine: {
	        //    data: [{ yAxis: 2 }]
	        //  }
	        // }
	
	        if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	          return true;
	        }
	      }
	
	      return dataFilter$1(coordSys, item[0]) && dataFilter$1(coordSys, item[1]);
	    }
	
	    function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
	      var coordSys = seriesModel.coordinateSystem;
	      var itemModel = data.getItemModel(idx);
	      var point;
	      var xPx = parsePercent$1(itemModel.get('x'), api.getWidth());
	      var yPx = parsePercent$1(itemModel.get('y'), api.getHeight());
	
	      if (!isNaN(xPx) && !isNaN(yPx)) {
	        point = [xPx, yPx];
	      } else {
	        // Chart like bar may have there own marker positioning logic
	        if (seriesModel.getMarkerPosition) {
	          // Use the getMarkerPosition
	          point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
	        } else {
	          var dims = coordSys.dimensions;
	          var x = data.get(dims[0], idx);
	          var y = data.get(dims[1], idx);
	          point = coordSys.dataToPoint([x, y]);
	        } // Expand line to the edge of grid if value on one axis is Inifnity
	        // In case
	        //  markLine: {
	        //    data: [{
	        //      yAxis: 2
	        //      // or
	        //      type: 'average'
	        //    }]
	        //  }
	
	
	        if (isCoordinateSystemType(coordSys, 'cartesian2d')) {
	          // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
	          var xAxis = coordSys.getAxis('x');
	          var yAxis = coordSys.getAxis('y');
	          var dims = coordSys.dimensions;
	
	          if (isInfinity(data.get(dims[0], idx))) {
	            point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
	          } else if (isInfinity(data.get(dims[1], idx))) {
	            point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
	          }
	        } // Use x, y if has any
	
	
	        if (!isNaN(xPx)) {
	          point[0] = xPx;
	        }
	
	        if (!isNaN(yPx)) {
	          point[1] = yPx;
	        }
	      }
	
	      data.setItemLayout(idx, point);
	    }
	
	    var MarkLineView =
	    /** @class */
	    function (_super) {
	      __extends(MarkLineView, _super);
	
	      function MarkLineView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MarkLineView.type;
	        return _this;
	      }
	
	      MarkLineView.prototype.updateTransform = function (markLineModel, ecModel, api) {
	        ecModel.eachSeries(function (seriesModel) {
	          var mlModel = MarkerModel.getMarkerModelFromSeries(seriesModel, 'markLine');
	
	          if (mlModel) {
	            var mlData_1 = mlModel.getData();
	            var fromData_1 = inner$i(mlModel).from;
	            var toData_1 = inner$i(mlModel).to; // Update visual and layout of from symbol and to symbol
	
	            fromData_1.each(function (idx) {
	              updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
	              updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
	            }); // Update layout of line
	
	            mlData_1.each(function (idx) {
	              mlData_1.setItemLayout(idx, [fromData_1.getItemLayout(idx), toData_1.getItemLayout(idx)]);
	            });
	            this.markerGroupMap.get(seriesModel.id).updateLayout();
	          }
	        }, this);
	      };
	
	      MarkLineView.prototype.renderSeries = function (seriesModel, mlModel, ecModel, api) {
	        var coordSys = seriesModel.coordinateSystem;
	        var seriesId = seriesModel.id;
	        var seriesData = seriesModel.getData();
	        var lineDrawMap = this.markerGroupMap;
	        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
	        this.group.add(lineDraw.group);
	        var mlData = createList$1(coordSys, seriesModel, mlModel);
	        var fromData = mlData.from;
	        var toData = mlData.to;
	        var lineData = mlData.line;
	        inner$i(mlModel).from = fromData;
	        inner$i(mlModel).to = toData; // Line data for tooltip and formatter
	
	        mlModel.setData(lineData); // TODO
	        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
	        // But the related logic and type definition are not finished yet.
	        // Finish it if required
	
	        var symbolType = mlModel.get('symbol');
	        var symbolSize = mlModel.get('symbolSize');
	        var symbolRotate = mlModel.get('symbolRotate');
	        var symbolOffset = mlModel.get('symbolOffset'); // TODO: support callback function like markPoint
	
	        if (!isArray(symbolType)) {
	          symbolType = [symbolType, symbolType];
	        }
	
	        if (!isArray(symbolSize)) {
	          symbolSize = [symbolSize, symbolSize];
	        }
	
	        if (!isArray(symbolRotate)) {
	          symbolRotate = [symbolRotate, symbolRotate];
	        }
	
	        if (!isArray(symbolOffset)) {
	          symbolOffset = [symbolOffset, symbolOffset];
	        } // Update visual and layout of from symbol and to symbol
	
	
	        mlData.from.each(function (idx) {
	          updateDataVisualAndLayout(fromData, idx, true);
	          updateDataVisualAndLayout(toData, idx, false);
	        }); // Update visual and layout of line
	
	        lineData.each(function (idx) {
	          var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle(); // lineData.setItemVisual(idx, {
	          //     color: lineColor || fromData.getItemVisual(idx, 'color')
	          // });
	
	          lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	
	          if (lineStyle.stroke == null) {
	            lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
	          }
	
	          lineData.setItemVisual(idx, {
	            fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
	            fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
	            fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
	            fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
	            fromSymbol: fromData.getItemVisual(idx, 'symbol'),
	            toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
	            toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
	            toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
	            toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
	            toSymbol: toData.getItemVisual(idx, 'symbol'),
	            style: lineStyle
	          });
	        });
	        lineDraw.updateData(lineData); // Set host model for tooltip
	        // FIXME
	
	        mlData.line.eachItemGraphicEl(function (el) {
	          getECData(el).dataModel = mlModel;
	          el.traverse(function (child) {
	            getECData(child).dataModel = mlModel;
	          });
	        });
	
	        function updateDataVisualAndLayout(data, idx, isFrom) {
	          var itemModel = data.getItemModel(idx);
	          updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
	          var style = itemModel.getModel('itemStyle').getItemStyle();
	
	          if (style.fill == null) {
	            style.fill = getVisualFromData(seriesData, 'color');
	          }
	
	          data.setItemVisual(idx, {
	            symbolKeepAspect: itemModel.get('symbolKeepAspect'),
	            // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
	            symbolOffset: retrieve2(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
	            symbolRotate: retrieve2(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
	            // TODO: when 2d array is supported, it should ignore parent
	            symbolSize: retrieve2(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
	            symbol: retrieve2(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
	            style: style
	          });
	        }
	
	        this.markKeep(lineDraw);
	        lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
	      };
	
	      MarkLineView.type = 'markLine';
	      return MarkLineView;
	    }(MarkerView);
	
	    function createList$1(coordSys, seriesModel, mlModel) {
	      var coordDimsInfos;
	
	      if (coordSys) {
	        coordDimsInfos = map(coordSys && coordSys.dimensions, function (coordDim) {
	          var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	          return extend(extend({}, info), {
	            name: coordDim,
	            // DON'T use ordinalMeta to parse and collect ordinal.
	            ordinalMeta: null
	          });
	        });
	      } else {
	        coordDimsInfos = [{
	          name: 'value',
	          type: 'float'
	        }];
	      }
	
	      var fromData = new SeriesData(coordDimsInfos, mlModel);
	      var toData = new SeriesData(coordDimsInfos, mlModel); // No dimensions
	
	      var lineData = new SeriesData([], mlModel);
	      var optData = map(mlModel.get('data'), curry(markLineTransform, seriesModel, coordSys, mlModel));
	
	      if (coordSys) {
	        optData = filter(optData, curry(markLineFilter, coordSys));
	      }
	
	      var dimValueGetter = createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
	      fromData.initData(map(optData, function (item) {
	        return item[0];
	      }), null, dimValueGetter);
	      toData.initData(map(optData, function (item) {
	        return item[1];
	      }), null, dimValueGetter);
	      lineData.initData(map(optData, function (item) {
	        return item[2];
	      }));
	      lineData.hasItemOption = true;
	      return {
	        from: fromData,
	        to: toData,
	        line: lineData
	      };
	    }
	
	    function install$F(registers) {
	      registers.registerComponentModel(MarkLineModel);
	      registers.registerComponentView(MarkLineView);
	      registers.registerPreprocessor(function (opt) {
	        if (checkMarkerInSeries(opt.series, 'markLine')) {
	          // Make sure markLine component is enabled
	          opt.markLine = opt.markLine || {};
	        }
	      });
	    }
	
	    var MarkAreaModel =
	    /** @class */
	    function (_super) {
	      __extends(MarkAreaModel, _super);
	
	      function MarkAreaModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MarkAreaModel.type;
	        return _this;
	      }
	
	      MarkAreaModel.prototype.createMarkerModelFromSeries = function (markerOpt, masterMarkerModel, ecModel) {
	        return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
	      };
	
	      MarkAreaModel.type = 'markArea';
	      MarkAreaModel.defaultOption = {
	        // zlevel: 0,
	        // PENDING
	        z: 1,
	        tooltip: {
	          trigger: 'item'
	        },
	        // markArea should fixed on the coordinate system
	        animation: false,
	        label: {
	          show: true,
	          position: 'top'
	        },
	        itemStyle: {
	          // color and borderColor default to use color from series
	          // color: 'auto'
	          // borderColor: 'auto'
	          borderWidth: 0
	        },
	        emphasis: {
	          label: {
	            show: true,
	            position: 'top'
	          }
	        }
	      };
	      return MarkAreaModel;
	    }(MarkerModel);
	
	    var inner$j = makeInner();
	
	    var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
	      // item may be null
	      var item0 = item[0];
	      var item1 = item[1];
	
	      if (!item0 || !item1) {
	        return;
	      }
	
	      var lt = dataTransform(seriesModel, item0);
	      var rb = dataTransform(seriesModel, item1); // FIXME make sure lt is less than rb
	
	      var ltCoord = lt.coord;
	      var rbCoord = rb.coord;
	      ltCoord[0] = retrieve(ltCoord[0], -Infinity);
	      ltCoord[1] = retrieve(ltCoord[1], -Infinity);
	      rbCoord[0] = retrieve(rbCoord[0], Infinity);
	      rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one
	
	      var result = mergeAll([{}, lt, rb]);
	      result.coord = [lt.coord, rb.coord];
	      result.x0 = lt.x;
	      result.y0 = lt.y;
	      result.x1 = rb.x;
	      result.y1 = rb.y;
	      return result;
	    };
	
	    function isInfinity$1(val) {
	      return !isNaN(val) && !isFinite(val);
	    } // If a markArea has one dim
	
	
	    function ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	      var otherDimIndex = 1 - dimIndex;
	      return isInfinity$1(fromCoord[otherDimIndex]) && isInfinity$1(toCoord[otherDimIndex]);
	    }
	
	    function markAreaFilter(coordSys, item) {
	      var fromCoord = item.coord[0];
	      var toCoord = item.coord[1];
	      var item0 = {
	        coord: fromCoord,
	        x: item.x0,
	        y: item.y0
	      };
	      var item1 = {
	        coord: toCoord,
	        x: item.x1,
	        y: item.y1
	      };
	
	      if (isCoordinateSystemType(coordSys, 'cartesian2d')) {
	        // In case
	        // {
	        //  markArea: {
	        //    data: [{ yAxis: 2 }]
	        //  }
	        // }
	        if (fromCoord && toCoord && (ifMarkAreaHasOnlyDim(1, fromCoord, toCoord) || ifMarkAreaHasOnlyDim(0, fromCoord, toCoord))) {
	          return true;
	        } // Directly returning true may also do the work,
	        // because markArea will not be shown automatically
	        // when it's not included in coordinate system.
	        // But filtering ahead can avoid keeping rendering markArea
	        // when there are too many of them.
	
	
	        return zoneFilter(coordSys, item0, item1);
	      }
	
	      return dataFilter$1(coordSys, item0) || dataFilter$1(coordSys, item1);
	    } // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
	
	
	    function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
	      var coordSys = seriesModel.coordinateSystem;
	      var itemModel = data.getItemModel(idx);
	      var point;
	      var xPx = parsePercent$1(itemModel.get(dims[0]), api.getWidth());
	      var yPx = parsePercent$1(itemModel.get(dims[1]), api.getHeight());
	
	      if (!isNaN(xPx) && !isNaN(yPx)) {
	        point = [xPx, yPx];
	      } else {
	        // Chart like bar may have there own marker positioning logic
	        if (seriesModel.getMarkerPosition) {
	          // Consider the case that user input the right-bottom point first
	          // Pick the larger x and y as 'x1' and 'y1'
	          var pointValue0 = data.getValues(['x0', 'y0'], idx);
	          var pointValue1 = data.getValues(['x1', 'y1'], idx);
	          var clampPointValue0 = coordSys.clampData(pointValue0);
	          var clampPointValue1 = coordSys.clampData(pointValue1);
	          var pointValue = [];
	
	          if (dims[0] === 'x0') {
	            pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue1[0] : pointValue0[0];
	          } else {
	            pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue0[0] : pointValue1[0];
	          }
	
	          if (dims[1] === 'y0') {
	            pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue1[1] : pointValue0[1];
	          } else {
	            pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue0[1] : pointValue1[1];
	          } // Use the getMarkerPosition
	
	
	          point = seriesModel.getMarkerPosition(pointValue, dims, true);
	        } else {
	          var x = data.get(dims[0], idx);
	          var y = data.get(dims[1], idx);
	          var pt = [x, y];
	          coordSys.clampData && coordSys.clampData(pt, pt);
	          point = coordSys.dataToPoint(pt, true);
	        }
	
	        if (isCoordinateSystemType(coordSys, 'cartesian2d')) {
	          // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
	          var xAxis = coordSys.getAxis('x');
	          var yAxis = coordSys.getAxis('y');
	          var x = data.get(dims[0], idx);
	          var y = data.get(dims[1], idx);
	
	          if (isInfinity$1(x)) {
	            point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
	          } else if (isInfinity$1(y)) {
	            point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
	          }
	        } // Use x, y if has any
	
	
	        if (!isNaN(xPx)) {
	          point[0] = xPx;
	        }
	
	        if (!isNaN(yPx)) {
	          point[1] = yPx;
	        }
	      }
	
	      return point;
	    }
	
	    var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];
	
	    var MarkAreaView =
	    /** @class */
	    function (_super) {
	      __extends(MarkAreaView, _super);
	
	      function MarkAreaView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = MarkAreaView.type;
	        return _this;
	      }
	
	      MarkAreaView.prototype.updateTransform = function (markAreaModel, ecModel, api) {
	        ecModel.eachSeries(function (seriesModel) {
	          var maModel = MarkerModel.getMarkerModelFromSeries(seriesModel, 'markArea');
	
	          if (maModel) {
	            var areaData_1 = maModel.getData();
	            areaData_1.each(function (idx) {
	              var points = map(dimPermutations, function (dim) {
	                return getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
	              }); // Layout
	
	              areaData_1.setItemLayout(idx, points);
	              var el = areaData_1.getItemGraphicEl(idx);
	              el.setShape('points', points);
	            });
	          }
	        }, this);
	      };
	
	      MarkAreaView.prototype.renderSeries = function (seriesModel, maModel, ecModel, api) {
	        var coordSys = seriesModel.coordinateSystem;
	        var seriesId = seriesModel.id;
	        var seriesData = seriesModel.getData();
	        var areaGroupMap = this.markerGroupMap;
	        var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
	          group: new Group()
	        });
	        this.group.add(polygonGroup.group);
	        this.markKeep(polygonGroup);
	        var areaData = createList$2(coordSys, seriesModel, maModel); // Line data for tooltip and formatter
	
	        maModel.setData(areaData); // Update visual and layout of line
	
	        areaData.each(function (idx) {
	          // Layout
	          var points = map(dimPermutations, function (dim) {
	            return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	          });
	          var xAxisScale = coordSys.getAxis('x').scale;
	          var yAxisScale = coordSys.getAxis('y').scale;
	          var xAxisExtent = xAxisScale.getExtent();
	          var yAxisExtent = yAxisScale.getExtent();
	          var xPointExtent = [xAxisScale.parse(areaData.get('x0', idx)), xAxisScale.parse(areaData.get('x1', idx))];
	          var yPointExtent = [yAxisScale.parse(areaData.get('y0', idx)), yAxisScale.parse(areaData.get('y1', idx))];
	          asc(xPointExtent);
	          asc(yPointExtent);
	          var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]); // If none of the area is inside coordSys, allClipped is set to be true
	          // in layout so that label will not be displayed. See #12591
	
	          var allClipped = !overlapped;
	          areaData.setItemLayout(idx, {
	            points: points,
	            allClipped: allClipped
	          });
	          var style = areaData.getItemModel(idx).getModel('itemStyle').getItemStyle();
	          var color$1 = getVisualFromData(seriesData, 'color');
	
	          if (!style.fill) {
	            style.fill = color$1;
	
	            if (isString(style.fill)) {
	              style.fill = modifyAlpha(style.fill, 0.4);
	            }
	          }
	
	          if (!style.stroke) {
	            style.stroke = color$1;
	          } // Visual
	
	
	          areaData.setItemVisual(idx, 'style', style);
	        });
	        areaData.diff(inner$j(polygonGroup).data).add(function (idx) {
	          var layout = areaData.getItemLayout(idx);
	
	          if (!layout.allClipped) {
	            var polygon = new Polygon({
	              shape: {
	                points: layout.points
	              }
	            });
	            areaData.setItemGraphicEl(idx, polygon);
	            polygonGroup.group.add(polygon);
	          }
	        }).update(function (newIdx, oldIdx) {
	          var polygon = inner$j(polygonGroup).data.getItemGraphicEl(oldIdx);
	          var layout = areaData.getItemLayout(newIdx);
	
	          if (!layout.allClipped) {
	            if (polygon) {
	              updateProps(polygon, {
	                shape: {
	                  points: layout.points
	                }
	              }, maModel, newIdx);
	            } else {
	              polygon = new Polygon({
	                shape: {
	                  points: layout.points
	                }
	              });
	            }
	
	            areaData.setItemGraphicEl(newIdx, polygon);
	            polygonGroup.group.add(polygon);
	          } else if (polygon) {
	            polygonGroup.group.remove(polygon);
	          }
	        }).remove(function (idx) {
	          var polygon = inner$j(polygonGroup).data.getItemGraphicEl(idx);
	          polygonGroup.group.remove(polygon);
	        }).execute();
	        areaData.eachItemGraphicEl(function (polygon, idx) {
	          var itemModel = areaData.getItemModel(idx);
	          var style = areaData.getItemVisual(idx, 'style');
	          polygon.useStyle(areaData.getItemVisual(idx, 'style'));
	          setLabelStyle(polygon, getLabelStatesModels(itemModel), {
	            labelFetcher: maModel,
	            labelDataIndex: idx,
	            defaultText: areaData.getName(idx) || '',
	            inheritColor: isString(style.fill) ? modifyAlpha(style.fill, 1) : '#000'
	          });
	          setStatesStylesFromModel(polygon, itemModel);
	          toggleHoverEmphasis(polygon, null, null, itemModel.get(['emphasis', 'disabled']));
	          getECData(polygon).dataModel = maModel;
	        });
	        inner$j(polygonGroup).data = areaData;
	        polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
	      };
	
	      MarkAreaView.type = 'markArea';
	      return MarkAreaView;
	    }(MarkerView);
	
	    function createList$2(coordSys, seriesModel, maModel) {
	      var areaData;
	      var dataDims;
	      var dims = ['x0', 'y0', 'x1', 'y1'];
	
	      if (coordSys) {
	        var coordDimsInfos_1 = map(coordSys && coordSys.dimensions, function (coordDim) {
	          var data = seriesModel.getData();
	          var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	          return extend(extend({}, info), {
	            name: coordDim,
	            // DON'T use ordinalMeta to parse and collect ordinal.
	            ordinalMeta: null
	          });
	        });
	        dataDims = map(dims, function (dim, idx) {
	          return {
	            name: dim,
	            type: coordDimsInfos_1[idx % 2].type
	          };
	        });
	        areaData = new SeriesData(dataDims, maModel);
	      } else {
	        dataDims = [{
	          name: 'value',
	          type: 'float'
	        }];
	        areaData = new SeriesData(dataDims, maModel);
	      }
	
	      var optData = map(maModel.get('data'), curry(markAreaTransform, seriesModel, coordSys, maModel));
	
	      if (coordSys) {
	        optData = filter(optData, curry(markAreaFilter, coordSys));
	      }
	
	      var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
	        // TODO should convert to ParsedValue?
	        var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
	        return parseDataValue(rawVal, dataDims[dimIndex]);
	      } : function (item, dimName, dataIndex, dimIndex) {
	        return parseDataValue(item.value, dataDims[dimIndex]);
	      };
	      areaData.initData(optData, null, dimValueGetter);
	      areaData.hasItemOption = true;
	      return areaData;
	    }
	
	    function install$G(registers) {
	      registers.registerComponentModel(MarkAreaModel);
	      registers.registerComponentView(MarkAreaView);
	      registers.registerPreprocessor(function (opt) {
	        if (checkMarkerInSeries(opt.series, 'markArea')) {
	          // Make sure markArea component is enabled
	          opt.markArea = opt.markArea || {};
	        }
	      });
	    }
	
	    var getDefaultSelectorOptions = function (ecModel, type) {
	      if (type === 'all') {
	        return {
	          type: 'all',
	          title: ecModel.getLocaleModel().get(['legend', 'selector', 'all'])
	        };
	      } else if (type === 'inverse') {
	        return {
	          type: 'inverse',
	          title: ecModel.getLocaleModel().get(['legend', 'selector', 'inverse'])
	        };
	      }
	    };
	
	    var LegendModel =
	    /** @class */
	    function (_super) {
	      __extends(LegendModel, _super);
	
	      function LegendModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = LegendModel.type;
	        _this.layoutMode = {
	          type: 'box',
	          // legend.width/height are maxWidth/maxHeight actually,
	          // whereas real width/height is calculated by its content.
	          // (Setting {left: 10, right: 10} does not make sense).
	          // So consider the case:
	          // `setOption({legend: {left: 10});`
	          // then `setOption({legend: {right: 10});`
	          // The previous `left` should be cleared by setting `ignoreSize`.
	          ignoreSize: true
	        };
	        return _this;
	      }
	
	      LegendModel.prototype.init = function (option, parentModel, ecModel) {
	        this.mergeDefaultAndTheme(option, ecModel);
	        option.selected = option.selected || {};
	
	        this._updateSelector(option);
	      };
	
	      LegendModel.prototype.mergeOption = function (option, ecModel) {
	        _super.prototype.mergeOption.call(this, option, ecModel);
	
	        this._updateSelector(option);
	      };
	
	      LegendModel.prototype._updateSelector = function (option) {
	        var selector = option.selector;
	        var ecModel = this.ecModel;
	
	        if (selector === true) {
	          selector = option.selector = ['all', 'inverse'];
	        }
	
	        if (isArray(selector)) {
	          each(selector, function (item, index) {
	            isString(item) && (item = {
	              type: item
	            });
	            selector[index] = merge(item, getDefaultSelectorOptions(ecModel, item.type));
	          });
	        }
	      };
	
	      LegendModel.prototype.optionUpdated = function () {
	        this._updateData(this.ecModel);
	
	        var legendData = this._data; // If selectedMode is single, try to select one
	
	        if (legendData[0] && this.get('selectedMode') === 'single') {
	          var hasSelected = false; // If has any selected in option.selected
	
	          for (var i = 0; i < legendData.length; i++) {
	            var name_1 = legendData[i].get('name');
	
	            if (this.isSelected(name_1)) {
	              // Force to unselect others
	              this.select(name_1);
	              hasSelected = true;
	              break;
	            }
	          } // Try select the first if selectedMode is single
	
	
	          !hasSelected && this.select(legendData[0].get('name'));
	        }
	      };
	
	      LegendModel.prototype._updateData = function (ecModel) {
	        var potentialData = [];
	        var availableNames = [];
	        ecModel.eachRawSeries(function (seriesModel) {
	          var seriesName = seriesModel.name;
	          availableNames.push(seriesName);
	          var isPotential;
	
	          if (seriesModel.legendVisualProvider) {
	            var provider = seriesModel.legendVisualProvider;
	            var names = provider.getAllNames();
	
	            if (!ecModel.isSeriesFiltered(seriesModel)) {
	              availableNames = availableNames.concat(names);
	            }
	
	            if (names.length) {
	              potentialData = potentialData.concat(names);
	            } else {
	              isPotential = true;
	            }
	          } else {
	            isPotential = true;
	          }
	
	          if (isPotential && isNameSpecified(seriesModel)) {
	            potentialData.push(seriesModel.name);
	          }
	        });
	        /**
	         * @type {Array.<string>}
	         * @private
	         */
	
	        this._availableNames = availableNames; // If legend.data is not specified in option, use availableNames as data,
	        // which is convenient for user preparing option.
	
	        var rawData = this.get('data') || potentialData;
	        var legendNameMap = createHashMap();
	        var legendData = map(rawData, function (dataItem) {
	          // Can be string or number
	          if (isString(dataItem) || isNumber(dataItem)) {
	            dataItem = {
	              name: dataItem
	            };
	          }
	
	          if (legendNameMap.get(dataItem.name)) {
	            // remove legend name duplicate
	            return null;
	          }
	
	          legendNameMap.set(dataItem.name, true);
	          return new Model(dataItem, this, this.ecModel);
	        }, this);
	        /**
	         * @type {Array.<module:echarts/model/Model>}
	         * @private
	         */
	
	        this._data = filter(legendData, function (item) {
	          return !!item;
	        });
	      };
	
	      LegendModel.prototype.getData = function () {
	        return this._data;
	      };
	
	      LegendModel.prototype.select = function (name) {
	        var selected = this.option.selected;
	        var selectedMode = this.get('selectedMode');
	
	        if (selectedMode === 'single') {
	          var data = this._data;
	          each(data, function (dataItem) {
	            selected[dataItem.get('name')] = false;
	          });
	        }
	
	        selected[name] = true;
	      };
	
	      LegendModel.prototype.unSelect = function (name) {
	        if (this.get('selectedMode') !== 'single') {
	          this.option.selected[name] = false;
	        }
	      };
	
	      LegendModel.prototype.toggleSelected = function (name) {
	        var selected = this.option.selected; // Default is true
	
	        if (!selected.hasOwnProperty(name)) {
	          selected[name] = true;
	        }
	
	        this[selected[name] ? 'unSelect' : 'select'](name);
	      };
	
	      LegendModel.prototype.allSelect = function () {
	        var data = this._data;
	        var selected = this.option.selected;
	        each(data, function (dataItem) {
	          selected[dataItem.get('name', true)] = true;
	        });
	      };
	
	      LegendModel.prototype.inverseSelect = function () {
	        var data = this._data;
	        var selected = this.option.selected;
	        each(data, function (dataItem) {
	          var name = dataItem.get('name', true); // Initially, default value is true
	
	          if (!selected.hasOwnProperty(name)) {
	            selected[name] = true;
	          }
	
	          selected[name] = !selected[name];
	        });
	      };
	
	      LegendModel.prototype.isSelected = function (name) {
	        var selected = this.option.selected;
	        return !(selected.hasOwnProperty(name) && !selected[name]) && indexOf(this._availableNames, name) >= 0;
	      };
	
	      LegendModel.prototype.getOrient = function () {
	        return this.get('orient') === 'vertical' ? {
	          index: 1,
	          name: 'vertical'
	        } : {
	          index: 0,
	          name: 'horizontal'
	        };
	      };
	
	      LegendModel.type = 'legend.plain';
	      LegendModel.dependencies = ['series'];
	      LegendModel.defaultOption = {
	        // zlevel: 0,
	        z: 4,
	        show: true,
	        orient: 'horizontal',
	        left: 'center',
	        // right: 'center',
	        top: 0,
	        // bottom: null,
	        align: 'auto',
	        backgroundColor: 'rgba(0,0,0,0)',
	        borderColor: '#ccc',
	        borderRadius: 0,
	        borderWidth: 0,
	        padding: 5,
	        itemGap: 10,
	        itemWidth: 25,
	        itemHeight: 14,
	        symbolRotate: 'inherit',
	        symbolKeepAspect: true,
	        inactiveColor: '#ccc',
	        inactiveBorderColor: '#ccc',
	        inactiveBorderWidth: 'auto',
	        itemStyle: {
	          color: 'inherit',
	          opacity: 'inherit',
	          borderColor: 'inherit',
	          borderWidth: 'auto',
	          borderCap: 'inherit',
	          borderJoin: 'inherit',
	          borderDashOffset: 'inherit',
	          borderMiterLimit: 'inherit'
	        },
	        lineStyle: {
	          width: 'auto',
	          color: 'inherit',
	          inactiveColor: '#ccc',
	          inactiveWidth: 2,
	          opacity: 'inherit',
	          type: 'inherit',
	          cap: 'inherit',
	          join: 'inherit',
	          dashOffset: 'inherit',
	          miterLimit: 'inherit'
	        },
	        textStyle: {
	          color: '#333'
	        },
	        selectedMode: true,
	        selector: false,
	        selectorLabel: {
	          show: true,
	          borderRadius: 10,
	          padding: [3, 5, 3, 5],
	          fontSize: 12,
	          fontFamily: 'sans-serif',
	          color: '#666',
	          borderWidth: 1,
	          borderColor: '#666'
	        },
	        emphasis: {
	          selectorLabel: {
	            show: true,
	            color: '#eee',
	            backgroundColor: '#666'
	          }
	        },
	        selectorPosition: 'auto',
	        selectorItemGap: 7,
	        selectorButtonGap: 10,
	        tooltip: {
	          show: false
	        }
	      };
	      return LegendModel;
	    }(ComponentModel);
	
	    var curry$1 = curry;
	    var each$c = each;
	    var Group$2 = Group;
	
	    var LegendView =
	    /** @class */
	    function (_super) {
	      __extends(LegendView, _super);
	
	      function LegendView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = LegendView.type;
	        _this.newlineDisabled = false;
	        return _this;
	      }
	
	      LegendView.prototype.init = function () {
	        this.group.add(this._contentGroup = new Group$2());
	        this.group.add(this._selectorGroup = new Group$2());
	        this._isFirstRender = true;
	      };
	      /**
	       * @protected
	       */
	
	
	      LegendView.prototype.getContentGroup = function () {
	        return this._contentGroup;
	      };
	      /**
	       * @protected
	       */
	
	
	      LegendView.prototype.getSelectorGroup = function () {
	        return this._selectorGroup;
	      };
	      /**
	       * @override
	       */
	
	
	      LegendView.prototype.render = function (legendModel, ecModel, api) {
	        var isFirstRender = this._isFirstRender;
	        this._isFirstRender = false;
	        this.resetInner();
	
	        if (!legendModel.get('show', true)) {
	          return;
	        }
	
	        var itemAlign = legendModel.get('align');
	        var orient = legendModel.get('orient');
	
	        if (!itemAlign || itemAlign === 'auto') {
	          itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
	        } // selector has been normalized to an array in model
	
	
	        var selector = legendModel.get('selector', true);
	        var selectorPosition = legendModel.get('selectorPosition', true);
	
	        if (selector && (!selectorPosition || selectorPosition === 'auto')) {
	          selectorPosition = orient === 'horizontal' ? 'end' : 'start';
	        }
	
	        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.
	
	        var positionInfo = legendModel.getBoxLayoutParams();
	        var viewportSize = {
	          width: api.getWidth(),
	          height: api.getHeight()
	        };
	        var padding = legendModel.get('padding');
	        var maxSize = getLayoutRect(positionInfo, viewportSize, padding);
	        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.
	
	        var layoutRect = getLayoutRect(defaults({
	          width: mainRect.width,
	          height: mainRect.height
	        }, positionInfo), viewportSize, padding);
	        this.group.x = layoutRect.x - mainRect.x;
	        this.group.y = layoutRect.y - mainRect.y;
	        this.group.markRedraw(); // Render background after group is layout.
	
	        this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
	      };
	
	      LegendView.prototype.resetInner = function () {
	        this.getContentGroup().removeAll();
	        this._backgroundEl && this.group.remove(this._backgroundEl);
	        this.getSelectorGroup().removeAll();
	      };
	
	      LegendView.prototype.renderInner = function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	        var contentGroup = this.getContentGroup();
	        var legendDrawnMap = createHashMap();
	        var selectMode = legendModel.get('selectedMode');
	        var excludeSeriesId = [];
	        ecModel.eachRawSeries(function (seriesModel) {
	          !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
	        });
	        each$c(legendModel.getData(), function (legendItemModel, dataIndex) {
	          var name = legendItemModel.get('name'); // Use empty string or \n as a newline string
	
	          if (!this.newlineDisabled && (name === '' || name === '\n')) {
	            var g = new Group$2(); // @ts-ignore
	
	            g.newline = true;
	            contentGroup.add(g);
	            return;
	          } // Representitive series.
	
	
	          var seriesModel = ecModel.getSeriesByName(name)[0];
	
	          if (legendDrawnMap.get(name)) {
	            // Have been drawn
	            return;
	          } // Legend to control series.
	
	
	          if (seriesModel) {
	            var data = seriesModel.getData();
	            var lineVisualStyle = data.getVisual('legendLineStyle') || {};
	            var legendIcon = data.getVisual('legendIcon');
	            /**
	             * `data.getVisual('style')` may be the color from the register
	             * in series. For example, for line series,
	             */
	
	            var style = data.getVisual('style');
	
	            var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
	
	            itemGroup.on('click', curry$1(dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', curry$1(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry$1(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
	            legendDrawnMap.set(name, true);
	          } else {
	            // Legend to control data. In pie and funnel.
	            ecModel.eachRawSeries(function (seriesModel) {
	              // In case multiple series has same data name
	              if (legendDrawnMap.get(name)) {
	                return;
	              }
	
	              if (seriesModel.legendVisualProvider) {
	                var provider = seriesModel.legendVisualProvider;
	
	                if (!provider.containName(name)) {
	                  return;
	                }
	
	                var idx = provider.indexOfName(name);
	                var style = provider.getItemVisual(idx, 'style');
	                var legendIcon = provider.getItemVisual(idx, 'legendIcon');
	                var colorArr = parse(style.fill); // Color may be set to transparent in visualMap when data is out of range.
	                // Do not show nothing.
	
	                if (colorArr && colorArr[3] === 0) {
	                  colorArr[3] = 0.2; // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
	
	                  style = extend(extend({}, style), {
	                    fill: stringify(colorArr, 'rgba')
	                  });
	                }
	
	                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api); // FIXME: consider different series has items with the same name.
	
	
	                itemGroup.on('click', curry$1(dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
	                // more than one pie series.
	                .on('mouseover', curry$1(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry$1(dispatchDownplayAction, null, name, api, excludeSeriesId));
	                legendDrawnMap.set(name, true);
	              }
	            }, this);
	          }
	
	          if (true) {
	            if (!legendDrawnMap.get(name)) {
	              console.warn(name + ' series not exists. Legend data should be same with series name or data name.');
	            }
	          }
	        }, this);
	
	        if (selector) {
	          this._createSelector(selector, legendModel, api, orient, selectorPosition);
	        }
	      };
	
	      LegendView.prototype._createSelector = function (selector, legendModel, api, orient, selectorPosition) {
	        var selectorGroup = this.getSelectorGroup();
	        each$c(selector, function createSelectorButton(selectorItem) {
	          var type = selectorItem.type;
	          var labelText = new ZRText({
	            style: {
	              x: 0,
	              y: 0,
	              align: 'center',
	              verticalAlign: 'middle'
	            },
	            onclick: function () {
	              api.dispatchAction({
	                type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect'
	              });
	            }
	          });
	          selectorGroup.add(labelText);
	          var labelModel = legendModel.getModel('selectorLabel');
	          var emphasisLabelModel = legendModel.getModel(['emphasis', 'selectorLabel']);
	          setLabelStyle(labelText, {
	            normal: labelModel,
	            emphasis: emphasisLabelModel
	          }, {
	            defaultText: selectorItem.title
	          });
	          enableHoverEmphasis(labelText);
	        });
	      };
	
	      LegendView.prototype._createItem = function (seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
	        var drawType = seriesModel.visualDrawType;
	        var itemWidth = legendModel.get('itemWidth');
	        var itemHeight = legendModel.get('itemHeight');
	        var isSelected = legendModel.isSelected(name);
	        var iconRotate = legendItemModel.get('symbolRotate');
	        var symbolKeepAspect = legendItemModel.get('symbolKeepAspect');
	        var legendIconType = legendItemModel.get('icon');
	        legendIcon = legendIconType || legendIcon || 'roundRect';
	        var style = getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
	        var itemGroup = new Group$2();
	        var textStyleModel = legendItemModel.getModel('textStyle');
	
	        if (isFunction(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === 'inherit')) {
	          // Series has specific way to define legend icon
	          itemGroup.add(seriesModel.getLegendIcon({
	            itemWidth: itemWidth,
	            itemHeight: itemHeight,
	            icon: legendIcon,
	            iconRotate: iconRotate,
	            itemStyle: style.itemStyle,
	            lineStyle: style.lineStyle,
	            symbolKeepAspect: symbolKeepAspect
	          }));
	        } else {
	          // Use default legend icon policy for most series
	          var rotate = legendIconType === 'inherit' && seriesModel.getData().getVisual('symbol') ? iconRotate === 'inherit' ? seriesModel.getData().getVisual('symbolRotate') : iconRotate : 0; // No rotation for no icon
	
	          itemGroup.add(getDefaultLegendIcon({
	            itemWidth: itemWidth,
	            itemHeight: itemHeight,
	            icon: legendIcon,
	            iconRotate: rotate,
	            itemStyle: style.itemStyle,
	            lineStyle: style.lineStyle,
	            symbolKeepAspect: symbolKeepAspect
	          }));
	        }
	
	        var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
	        var textAlign = itemAlign;
	        var formatter = legendModel.get('formatter');
	        var content = name;
	
	        if (isString(formatter) && formatter) {
	          content = formatter.replace('{name}', name != null ? name : '');
	        } else if (isFunction(formatter)) {
	          content = formatter(name);
	        }
	
	        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get('inactiveColor');
	        itemGroup.add(new ZRText({
	          style: createTextStyle(textStyleModel, {
	            text: content,
	            x: textX,
	            y: itemHeight / 2,
	            fill: textColor,
	            align: textAlign,
	            verticalAlign: 'middle'
	          }, {
	            inheritColor: textColor
	          })
	        })); // Add a invisible rect to increase the area of mouse hover
	
	        var hitRect = new Rect({
	          shape: itemGroup.getBoundingRect(),
	          invisible: true
	        });
	        var tooltipModel = legendItemModel.getModel('tooltip');
	
	        if (tooltipModel.get('show')) {
	          setTooltipConfig({
	            el: hitRect,
	            componentModel: legendModel,
	            itemName: name,
	            itemTooltipOption: tooltipModel.option
	          });
	        }
	
	        itemGroup.add(hitRect);
	        itemGroup.eachChild(function (child) {
	          child.silent = true;
	        });
	        hitRect.silent = !selectMode;
	        this.getContentGroup().add(itemGroup);
	        enableHoverEmphasis(itemGroup); // @ts-ignore
	
	        itemGroup.__legendDataIndex = dataIndex;
	        return itemGroup;
	      };
	
	      LegendView.prototype.layoutInner = function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	        var contentGroup = this.getContentGroup();
	        var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.
	
	        box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
	        var contentRect = contentGroup.getBoundingRect();
	        var contentPos = [-contentRect.x, -contentRect.y];
	        selectorGroup.markRedraw();
	        contentGroup.markRedraw();
	
	        if (selector) {
	          // Place buttons in selectorGroup
	          box( // Buttons in selectorGroup always layout horizontally
	          'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	          var selectorRect = selectorGroup.getBoundingRect();
	          var selectorPos = [-selectorRect.x, -selectorRect.y];
	          var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	          var orientIdx = legendModel.getOrient().index;
	          var wh = orientIdx === 0 ? 'width' : 'height';
	          var hw = orientIdx === 0 ? 'height' : 'width';
	          var yx = orientIdx === 0 ? 'y' : 'x';
	
	          if (selectorPosition === 'end') {
	            selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
	          } else {
	            contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
	          } // Always align selector to content as 'middle'
	
	
	          selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
	          selectorGroup.x = selectorPos[0];
	          selectorGroup.y = selectorPos[1];
	          contentGroup.x = contentPos[0];
	          contentGroup.y = contentPos[1];
	          var mainRect = {
	            x: 0,
	            y: 0
	          };
	          mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
	          mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
	          mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
	          return mainRect;
	        } else {
	          contentGroup.x = contentPos[0];
	          contentGroup.y = contentPos[1];
	          return this.group.getBoundingRect();
	        }
	      };
	      /**
	       * @protected
	       */
	
	
	      LegendView.prototype.remove = function () {
	        this.getContentGroup().removeAll();
	        this._isFirstRender = true;
	      };
	
	      LegendView.type = 'legend.plain';
	      return LegendView;
	    }(ComponentView);
	
	    function getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
	      /**
	       * Use series style if is inherit;
	       * elsewise, use legend style
	       */
	      function handleCommonProps(style, visualStyle) {
	        // If lineStyle.width is 'auto', it is set to be 2 if series has border
	        if (style.lineWidth === 'auto') {
	          style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
	        }
	
	        each$c(style, function (propVal, propName) {
	          style[propName] === 'inherit' && (style[propName] = visualStyle[propName]);
	        });
	      } // itemStyle
	
	
	      var itemStyleModel = legendItemModel.getModel('itemStyle');
	      var itemStyle = itemStyleModel.getItemStyle();
	      var iconBrushType = iconType.lastIndexOf('empty', 0) === 0 ? 'fill' : 'stroke';
	      var decalStyle = itemStyleModel.getShallow('decal');
	      itemStyle.decal = !decalStyle || decalStyle === 'inherit' ? itemVisualStyle.decal : createOrUpdatePatternFromDecal(decalStyle, api);
	
	      if (itemStyle.fill === 'inherit') {
	        /**
	         * Series with visualDrawType as 'stroke' should have
	         * series stroke as legend fill
	         */
	        itemStyle.fill = itemVisualStyle[drawType];
	      }
	
	      if (itemStyle.stroke === 'inherit') {
	        /**
	         * icon type with "emptyXXX" should use fill color
	         * in visual style
	         */
	        itemStyle.stroke = itemVisualStyle[iconBrushType];
	      }
	
	      if (itemStyle.opacity === 'inherit') {
	        /**
	         * Use lineStyle.opacity if drawType is stroke
	         */
	        itemStyle.opacity = (drawType === 'fill' ? itemVisualStyle : lineVisualStyle).opacity;
	      }
	
	      handleCommonProps(itemStyle, itemVisualStyle); // lineStyle
	
	      var legendLineModel = legendItemModel.getModel('lineStyle');
	      var lineStyle = legendLineModel.getLineStyle();
	      handleCommonProps(lineStyle, lineVisualStyle); // Fix auto color to real color
	
	      itemStyle.fill === 'auto' && (itemStyle.fill = itemVisualStyle.fill);
	      itemStyle.stroke === 'auto' && (itemStyle.stroke = itemVisualStyle.fill);
	      lineStyle.stroke === 'auto' && (lineStyle.stroke = itemVisualStyle.fill);
	
	      if (!isSelected) {
	        var borderWidth = legendItemModel.get('inactiveBorderWidth');
	        /**
	         * Since stroke is set to be inactiveBorderColor, it may occur that
	         * there is no border in series but border in legend, so we need to
	         * use border only when series has border if is set to be auto
	         */
	
	        var visualHasBorder = itemStyle[iconBrushType];
	        itemStyle.lineWidth = borderWidth === 'auto' ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
	        itemStyle.fill = legendItemModel.get('inactiveColor');
	        itemStyle.stroke = legendItemModel.get('inactiveBorderColor');
	        lineStyle.stroke = legendLineModel.get('inactiveColor');
	        lineStyle.lineWidth = legendLineModel.get('inactiveWidth');
	      }
	
	      return {
	        itemStyle: itemStyle,
	        lineStyle: lineStyle
	      };
	    }
	
	    function getDefaultLegendIcon(opt) {
	      var symboType = opt.icon || 'roundRect';
	      var icon = createSymbol(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
	      icon.setStyle(opt.itemStyle);
	      icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
	      icon.setOrigin([opt.itemWidth / 2, opt.itemHeight / 2]);
	
	      if (symboType.indexOf('empty') > -1) {
	        icon.style.stroke = icon.style.fill;
	        icon.style.fill = '#fff';
	        icon.style.lineWidth = 2;
	      }
	
	      return icon;
	    }
	
	    function dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
	      // downplay before unselect
	      dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
	      api.dispatchAction({
	        type: 'legendToggleSelect',
	        name: seriesName != null ? seriesName : dataName
	      }); // highlight after select
	      // TODO highlight immediately may cause animation loss.
	
	      dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
	    }
	
	    function isUseHoverLayer(api) {
	      var list = api.getZr().storage.getDisplayList();
	      var emphasisState;
	      var i = 0;
	      var len = list.length;
	
	      while (i < len && !(emphasisState = list[i].states.emphasis)) {
	        i++;
	      }
	
	      return emphasisState && emphasisState.hoverLayer;
	    }
	
	    function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
	      // If element hover will move to a hoverLayer.
	      if (!isUseHoverLayer(api)) {
	        api.dispatchAction({
	          type: 'highlight',
	          seriesName: seriesName,
	          name: dataName,
	          excludeSeriesId: excludeSeriesId
	        });
	      }
	    }
	
	    function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
	      // If element hover will move to a hoverLayer.
	      if (!isUseHoverLayer(api)) {
	        api.dispatchAction({
	          type: 'downplay',
	          seriesName: seriesName,
	          name: dataName,
	          excludeSeriesId: excludeSeriesId
	        });
	      }
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function legendFilter(ecModel) {
	      var legendModels = ecModel.findComponents({
	        mainType: 'legend'
	      });
	
	      if (legendModels && legendModels.length) {
	        ecModel.filterSeries(function (series) {
	          // If in any legend component the status is not selected.
	          // Because in legend series is assumed selected when it is not in the legend data.
	          for (var i = 0; i < legendModels.length; i++) {
	            if (!legendModels[i].isSelected(series.name)) {
	              return false;
	            }
	          }
	
	          return true;
	        });
	      }
	    }
	
	    function legendSelectActionHandler(methodName, payload, ecModel) {
	      var selectedMap = {};
	      var isToggleSelect = methodName === 'toggleSelected';
	      var isSelected; // Update all legend components
	
	      ecModel.eachComponent('legend', function (legendModel) {
	        if (isToggleSelect && isSelected != null) {
	          // Force other legend has same selected status
	          // Or the first is toggled to true and other are toggled to false
	          // In the case one legend has some item unSelected in option. And if other legend
	          // doesn't has the item, they will assume it is selected.
	          legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
	        } else if (methodName === 'allSelect' || methodName === 'inverseSelect') {
	          legendModel[methodName]();
	        } else {
	          legendModel[methodName](payload.name);
	          isSelected = legendModel.isSelected(payload.name);
	        }
	
	        var legendData = legendModel.getData();
	        each(legendData, function (model) {
	          var name = model.get('name'); // Wrap element
	
	          if (name === '\n' || name === '') {
	            return;
	          }
	
	          var isItemSelected = legendModel.isSelected(name);
	
	          if (selectedMap.hasOwnProperty(name)) {
	            // Unselected if any legend is unselected
	            selectedMap[name] = selectedMap[name] && isItemSelected;
	          } else {
	            selectedMap[name] = isItemSelected;
	          }
	        });
	      }); // Return the event explicitly
	
	      return methodName === 'allSelect' || methodName === 'inverseSelect' ? {
	        selected: selectedMap
	      } : {
	        name: payload.name,
	        selected: selectedMap
	      };
	    }
	
	    function installLegendAction(registers) {
	      /**
	       * @event legendToggleSelect
	       * @type {Object}
	       * @property {string} type 'legendToggleSelect'
	       * @property {string} [from]
	       * @property {string} name Series name or data item name
	       */
	      registers.registerAction('legendToggleSelect', 'legendselectchanged', curry(legendSelectActionHandler, 'toggleSelected'));
	      registers.registerAction('legendAllSelect', 'legendselectall', curry(legendSelectActionHandler, 'allSelect'));
	      registers.registerAction('legendInverseSelect', 'legendinverseselect', curry(legendSelectActionHandler, 'inverseSelect'));
	      /**
	       * @event legendSelect
	       * @type {Object}
	       * @property {string} type 'legendSelect'
	       * @property {string} name Series name or data item name
	       */
	
	      registers.registerAction('legendSelect', 'legendselected', curry(legendSelectActionHandler, 'select'));
	      /**
	       * @event legendUnSelect
	       * @type {Object}
	       * @property {string} type 'legendUnSelect'
	       * @property {string} name Series name or data item name
	       */
	
	      registers.registerAction('legendUnSelect', 'legendunselected', curry(legendSelectActionHandler, 'unSelect'));
	    }
	
	    function install$H(registers) {
	      registers.registerComponentModel(LegendModel);
	      registers.registerComponentView(LegendView);
	      registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, legendFilter);
	      registers.registerSubTypeDefaulter('legend', function () {
	        return 'plain';
	      });
	      installLegendAction(registers);
	    }
	
	    var ScrollableLegendModel =
	    /** @class */
	    function (_super) {
	      __extends(ScrollableLegendModel, _super);
	
	      function ScrollableLegendModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ScrollableLegendModel.type;
	        return _this;
	      }
	      /**
	       * @param {number} scrollDataIndex
	       */
	
	
	      ScrollableLegendModel.prototype.setScrollDataIndex = function (scrollDataIndex) {
	        this.option.scrollDataIndex = scrollDataIndex;
	      };
	
	      ScrollableLegendModel.prototype.init = function (option, parentModel, ecModel) {
	        var inputPositionParams = getLayoutParams(option);
	
	        _super.prototype.init.call(this, option, parentModel, ecModel);
	
	        mergeAndNormalizeLayoutParams$1(this, option, inputPositionParams);
	      };
	      /**
	       * @override
	       */
	
	
	      ScrollableLegendModel.prototype.mergeOption = function (option, ecModel) {
	        _super.prototype.mergeOption.call(this, option, ecModel);
	
	        mergeAndNormalizeLayoutParams$1(this, this.option, option);
	      };
	
	      ScrollableLegendModel.type = 'legend.scroll';
	      ScrollableLegendModel.defaultOption = inheritDefaultOption(LegendModel.defaultOption, {
	        scrollDataIndex: 0,
	        pageButtonItemGap: 5,
	        pageButtonGap: null,
	        pageButtonPosition: 'end',
	        pageFormatter: '{current}/{total}',
	        pageIcons: {
	          horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
	          vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
	        },
	        pageIconColor: '#2f4554',
	        pageIconInactiveColor: '#aaa',
	        pageIconSize: 15,
	        pageTextStyle: {
	          color: '#333'
	        },
	        animationDurationUpdate: 800
	      });
	      return ScrollableLegendModel;
	    }(LegendModel);
	
	    function mergeAndNormalizeLayoutParams$1(legendModel, target, raw) {
	      var orient = legendModel.getOrient();
	      var ignoreSize = [1, 1];
	      ignoreSize[orient.index] = 0;
	      mergeLayoutParam(target, raw, {
	        type: 'box',
	        ignoreSize: !!ignoreSize
	      });
	    }
	
	    var Group$3 = Group;
	    var WH$1 = ['width', 'height'];
	    var XY$1 = ['x', 'y'];
	
	    var ScrollableLegendView =
	    /** @class */
	    function (_super) {
	      __extends(ScrollableLegendView, _super);
	
	      function ScrollableLegendView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ScrollableLegendView.type;
	        _this.newlineDisabled = true;
	        _this._currentIndex = 0;
	        return _this;
	      }
	
	      ScrollableLegendView.prototype.init = function () {
	        _super.prototype.init.call(this);
	
	        this.group.add(this._containerGroup = new Group$3());
	
	        this._containerGroup.add(this.getContentGroup());
	
	        this.group.add(this._controllerGroup = new Group$3());
	      };
	      /**
	       * @override
	       */
	
	
	      ScrollableLegendView.prototype.resetInner = function () {
	        _super.prototype.resetInner.call(this);
	
	        this._controllerGroup.removeAll();
	
	        this._containerGroup.removeClipPath();
	
	        this._containerGroup.__rectSize = null;
	      };
	      /**
	       * @override
	       */
	
	
	      ScrollableLegendView.prototype.renderInner = function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	        var self = this; // Render content items.
	
	        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
	
	        var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
	        // e.g., '3/12345' should not overlap with the control arrow button.
	
	        var pageIconSize = legendModel.get('pageIconSize', true);
	        var pageIconSizeArr = isArray(pageIconSize) ? pageIconSize : [pageIconSize, pageIconSize];
	        createPageButton('pagePrev', 0);
	        var pageTextStyleModel = legendModel.getModel('pageTextStyle');
	        controllerGroup.add(new ZRText({
	          name: 'pageText',
	          style: {
	            // Placeholder to calculate a proper layout.
	            text: 'xx/xx',
	            fill: pageTextStyleModel.getTextColor(),
	            font: pageTextStyleModel.getFont(),
	            verticalAlign: 'middle',
	            align: 'center'
	          },
	          silent: true
	        }));
	        createPageButton('pageNext', 1);
	
	        function createPageButton(name, iconIdx) {
	          var pageDataIndexName = name + 'DataIndex';
	          var icon = createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
	            // Buttons will be created in each render, so we do not need
	            // to worry about avoiding using legendModel kept in scope.
	            onclick: bind(self._pageGo, self, pageDataIndexName, legendModel, api)
	          }, {
	            x: -pageIconSizeArr[0] / 2,
	            y: -pageIconSizeArr[1] / 2,
	            width: pageIconSizeArr[0],
	            height: pageIconSizeArr[1]
	          });
	          icon.name = name;
	          controllerGroup.add(icon);
	        }
	      };
	      /**
	       * @override
	       */
	
	
	      ScrollableLegendView.prototype.layoutInner = function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	        var selectorGroup = this.getSelectorGroup();
	        var orientIdx = legendModel.getOrient().index;
	        var wh = WH$1[orientIdx];
	        var xy = XY$1[orientIdx];
	        var hw = WH$1[1 - orientIdx];
	        var yx = XY$1[1 - orientIdx];
	        selector && box( // Buttons in selectorGroup always layout horizontally
	        'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	        var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	        var selectorRect = selectorGroup.getBoundingRect();
	        var selectorPos = [-selectorRect.x, -selectorRect.y];
	        var processMaxSize = clone(maxSize);
	        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
	
	        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
	
	        if (selector) {
	          if (selectorPosition === 'end') {
	            selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
	          } else {
	            var offset = selectorRect[wh] + selectorButtonGap;
	            selectorPos[orientIdx] -= offset;
	            mainRect[xy] -= offset;
	          }
	
	          mainRect[wh] += selectorRect[wh] + selectorButtonGap;
	          selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
	          mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
	          mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
	          selectorGroup.x = selectorPos[0];
	          selectorGroup.y = selectorPos[1];
	          selectorGroup.markRedraw();
	        }
	
	        return mainRect;
	      };
	
	      ScrollableLegendView.prototype._layoutContentAndController = function (legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
	        var contentGroup = this.getContentGroup();
	        var containerGroup = this._containerGroup;
	        var controllerGroup = this._controllerGroup; // Place items in contentGroup.
	
	        box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
	        box( // Buttons in controller are layout always horizontally.
	        'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
	        var contentRect = contentGroup.getBoundingRect();
	        var controllerRect = controllerGroup.getBoundingRect();
	        var showController = this._showController = contentRect[wh] > maxSize[wh]; // In case that the inner elements of contentGroup layout do not based on [0, 0]
	
	        var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
	        // If first rendering, `contentGroup.position` is [0, 0], which
	        // does not make sense and may cause unexepcted animation if adopted.
	
	        if (!isFirstRender) {
	          contentPos[orientIdx] = contentGroup[xy];
	        } // Layout container group based on 0.
	
	
	        var containerPos = [0, 0];
	        var controllerPos = [-controllerRect.x, -controllerRect.y];
	        var pageButtonGap = retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.
	
	        if (showController) {
	          var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.
	
	          if (pageButtonPosition === 'end') {
	            controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
	          } // controller is on the left / top.
	          else {
	              containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
	            }
	        } // Always align controller to content as 'middle'.
	
	
	        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
	        contentGroup.setPosition(contentPos);
	        containerGroup.setPosition(containerPos);
	        controllerGroup.setPosition(controllerPos); // Calculate `mainRect` and set `clipPath`.
	        // mainRect should not be calculated by `this.group.getBoundingRect()`
	        // for sake of the overflow.
	
	        var mainRect = {
	          x: 0,
	          y: 0
	        }; // Consider content may be overflow (should be clipped).
	
	        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
	        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
	
	        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
	        containerGroup.__rectSize = maxSize[wh];
	
	        if (showController) {
	          var clipShape = {
	            x: 0,
	            y: 0
	          };
	          clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
	          clipShape[hw] = mainRect[hw];
	          containerGroup.setClipPath(new Rect({
	            shape: clipShape
	          })); // Consider content may be larger than container, container rect
	          // can not be obtained from `containerGroup.getBoundingRect()`.
	
	          containerGroup.__rectSize = clipShape[wh];
	        } else {
	          // Do not remove or ignore controller. Keep them set as placeholders.
	          controllerGroup.eachChild(function (child) {
	            child.attr({
	              invisible: true,
	              silent: true
	            });
	          });
	        } // Content translate animation.
	
	
	        var pageInfo = this._getPageInfo(legendModel);
	
	        pageInfo.pageIndex != null && updateProps(contentGroup, {
	          x: pageInfo.contentPosition[0],
	          y: pageInfo.contentPosition[1]
	        }, // When switch from "show controller" to "not show controller", view should be
	        // updated immediately without animation, otherwise causes weird effect.
	        showController ? legendModel : null);
	
	        this._updatePageInfoView(legendModel, pageInfo);
	
	        return mainRect;
	      };
	
	      ScrollableLegendView.prototype._pageGo = function (to, legendModel, api) {
	        var scrollDataIndex = this._getPageInfo(legendModel)[to];
	
	        scrollDataIndex != null && api.dispatchAction({
	          type: 'legendScroll',
	          scrollDataIndex: scrollDataIndex,
	          legendId: legendModel.id
	        });
	      };
	
	      ScrollableLegendView.prototype._updatePageInfoView = function (legendModel, pageInfo) {
	        var controllerGroup = this._controllerGroup;
	        each(['pagePrev', 'pageNext'], function (name) {
	          var key = name + 'DataIndex';
	          var canJump = pageInfo[key] != null;
	          var icon = controllerGroup.childOfName(name);
	
	          if (icon) {
	            icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
	            icon.cursor = canJump ? 'pointer' : 'default';
	          }
	        });
	        var pageText = controllerGroup.childOfName('pageText');
	        var pageFormatter = legendModel.get('pageFormatter');
	        var pageIndex = pageInfo.pageIndex;
	        var current = pageIndex != null ? pageIndex + 1 : 0;
	        var total = pageInfo.pageCount;
	        pageText && pageFormatter && pageText.setStyle('text', isString(pageFormatter) ? pageFormatter.replace('{current}', current == null ? '' : current + '').replace('{total}', total == null ? '' : total + '') : pageFormatter({
	          current: current,
	          total: total
	        }));
	      };
	      /**
	       *  contentPosition: Array.<number>, null when data item not found.
	       *  pageIndex: number, null when data item not found.
	       *  pageCount: number, always be a number, can be 0.
	       *  pagePrevDataIndex: number, null when no previous page.
	       *  pageNextDataIndex: number, null when no next page.
	       * }
	       */
	
	
	      ScrollableLegendView.prototype._getPageInfo = function (legendModel) {
	        var scrollDataIndex = legendModel.get('scrollDataIndex', true);
	        var contentGroup = this.getContentGroup();
	        var containerRectSize = this._containerGroup.__rectSize;
	        var orientIdx = legendModel.getOrient().index;
	        var wh = WH$1[orientIdx];
	        var xy = XY$1[orientIdx];
	
	        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
	
	        var children = contentGroup.children();
	        var targetItem = children[targetItemIndex];
	        var itemCount = children.length;
	        var pCount = !itemCount ? 0 : 1;
	        var result = {
	          contentPosition: [contentGroup.x, contentGroup.y],
	          pageCount: pCount,
	          pageIndex: pCount - 1,
	          pagePrevDataIndex: null,
	          pageNextDataIndex: null
	        };
	
	        if (!targetItem) {
	          return result;
	        }
	
	        var targetItemInfo = getItemInfo(targetItem);
	        result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
	        // (1) Always align based on the left/top most item.
	        // (2) It is user-friendly that the last item shown in the
	        // current window is shown at the begining of next window.
	        // Otherwise if half of the last item is cut by the window,
	        // it will have no chance to display entirely.
	        // (3) Consider that item size probably be different, we
	        // have calculate pageIndex by size rather than item index,
	        // and we can not get page index directly by division.
	        // (4) The window is to narrow to contain more than
	        // one item, we should make sure that the page can be fliped.
	
	        for (var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i) {
	          currItemInfo = getItemInfo(children[i]);
	
	          if ( // Half of the last item is out of the window.
	          !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
	          // can be started at the current item or the last item.
	          currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
	            if (winEndItemInfo.i > winStartItemInfo.i) {
	              winStartItemInfo = winEndItemInfo;
	            } else {
	              // e.g., when page size is smaller than item size.
	              winStartItemInfo = currItemInfo;
	            }
	
	            if (winStartItemInfo) {
	              if (result.pageNextDataIndex == null) {
	                result.pageNextDataIndex = winStartItemInfo.i;
	              }
	
	              ++result.pageCount;
	            }
	          }
	
	          winEndItemInfo = currItemInfo;
	        }
	
	        for (var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i) {
	          currItemInfo = getItemInfo(children[i]);
	
	          if ( // If the the end item does not intersect with the window started
	          // from the current item, a page can be settled.
	          (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
	          winStartItemInfo.i < winEndItemInfo.i) {
	            winEndItemInfo = winStartItemInfo;
	
	            if (result.pagePrevDataIndex == null) {
	              result.pagePrevDataIndex = winStartItemInfo.i;
	            }
	
	            ++result.pageCount;
	            ++result.pageIndex;
	          }
	
	          winStartItemInfo = currItemInfo;
	        }
	
	        return result;
	
	        function getItemInfo(el) {
	          if (el) {
	            var itemRect = el.getBoundingRect();
	            var start = itemRect[xy] + el[xy];
	            return {
	              s: start,
	              e: start + itemRect[wh],
	              i: el.__legendDataIndex
	            };
	          }
	        }
	
	        function intersect(itemInfo, winStart) {
	          return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
	        }
	      };
	
	      ScrollableLegendView.prototype._findTargetItemIndex = function (targetDataIndex) {
	        if (!this._showController) {
	          return 0;
	        }
	
	        var index;
	        var contentGroup = this.getContentGroup();
	        var defaultIndex;
	        contentGroup.eachChild(function (child, idx) {
	          var legendDataIdx = child.__legendDataIndex; // FIXME
	          // If the given targetDataIndex (from model) is illegal,
	          // we use defaultIndex. But the index on the legend model and
	          // action payload is still illegal. That case will not be
	          // changed until some scenario requires.
	
	          if (defaultIndex == null && legendDataIdx != null) {
	            defaultIndex = idx;
	          }
	
	          if (legendDataIdx === targetDataIndex) {
	            index = idx;
	          }
	        });
	        return index != null ? index : defaultIndex;
	      };
	
	      ScrollableLegendView.type = 'legend.scroll';
	      return ScrollableLegendView;
	    }(LegendView);
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    function installScrollableLegendAction(registers) {
	      /**
	       * @event legendScroll
	       * @type {Object}
	       * @property {string} type 'legendScroll'
	       * @property {string} scrollDataIndex
	       */
	      registers.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
	        var scrollDataIndex = payload.scrollDataIndex;
	        scrollDataIndex != null && ecModel.eachComponent({
	          mainType: 'legend',
	          subType: 'scroll',
	          query: payload
	        }, function (legendModel) {
	          legendModel.setScrollDataIndex(scrollDataIndex);
	        });
	      });
	    }
	
	    function install$I(registers) {
	      use(install$H);
	      registers.registerComponentModel(ScrollableLegendModel);
	      registers.registerComponentView(ScrollableLegendView);
	      installScrollableLegendAction(registers);
	    }
	
	    function install$J(registers) {
	      use(install$H);
	      use(install$I);
	    }
	
	    var InsideZoomModel =
	    /** @class */
	    function (_super) {
	      __extends(InsideZoomModel, _super);
	
	      function InsideZoomModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = InsideZoomModel.type;
	        return _this;
	      }
	
	      InsideZoomModel.type = 'dataZoom.inside';
	      InsideZoomModel.defaultOption = inheritDefaultOption(DataZoomModel.defaultOption, {
	        disabled: false,
	        zoomLock: false,
	        zoomOnMouseWheel: true,
	        moveOnMouseMove: true,
	        moveOnMouseWheel: false,
	        preventDefaultMouseMove: true
	      });
	      return InsideZoomModel;
	    }(DataZoomModel);
	
	    var inner$k = makeInner();
	    function setViewInfoToCoordSysRecord(api, dataZoomModel, getRange) {
	      inner$k(api).coordSysRecordMap.each(function (coordSysRecord) {
	        var dzInfo = coordSysRecord.dataZoomInfoMap.get(dataZoomModel.uid);
	
	        if (dzInfo) {
	          dzInfo.getRange = getRange;
	        }
	      });
	    }
	    function disposeCoordSysRecordIfNeeded(api, dataZoomModel) {
	      var coordSysRecordMap = inner$k(api).coordSysRecordMap;
	      var coordSysKeyArr = coordSysRecordMap.keys();
	
	      for (var i = 0; i < coordSysKeyArr.length; i++) {
	        var coordSysKey = coordSysKeyArr[i];
	        var coordSysRecord = coordSysRecordMap.get(coordSysKey);
	        var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
	
	        if (dataZoomInfoMap) {
	          var dzUid = dataZoomModel.uid;
	          var dzInfo = dataZoomInfoMap.get(dzUid);
	
	          if (dzInfo) {
	            dataZoomInfoMap.removeKey(dzUid);
	
	            if (!dataZoomInfoMap.keys().length) {
	              disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
	            }
	          }
	        }
	      }
	    }
	
	    function disposeCoordSysRecord(coordSysRecordMap, coordSysRecord) {
	      if (coordSysRecord) {
	        coordSysRecordMap.removeKey(coordSysRecord.model.uid);
	        var controller = coordSysRecord.controller;
	        controller && controller.dispose();
	      }
	    }
	
	    function createCoordSysRecord(api, coordSysModel) {
	      // These init props will never change after record created.
	      var coordSysRecord = {
	        model: coordSysModel,
	        containsPoint: curry(containsPoint, coordSysModel),
	        dispatchAction: curry(dispatchAction$1, api),
	        dataZoomInfoMap: null,
	        controller: null
	      }; // Must not do anything depends on coordSysRecord outside the event handler here,
	      // because coordSysRecord not completed yet.
	
	      var controller = coordSysRecord.controller = new RoamController(api.getZr());
	      each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	        controller.on(eventName, function (event) {
	          var batch = [];
	          coordSysRecord.dataZoomInfoMap.each(function (dzInfo) {
	            // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
	            // moveOnMouseWheel, ...) enabled.
	            if (!event.isAvailableBehavior(dzInfo.model.option)) {
	              return;
	            }
	
	            var method = (dzInfo.getRange || {})[eventName];
	            var range = method && method(dzInfo.dzReferCoordSysInfo, coordSysRecord.model.mainType, coordSysRecord.controller, event);
	            !dzInfo.model.get('disabled', true) && range && batch.push({
	              dataZoomId: dzInfo.model.id,
	              start: range[0],
	              end: range[1]
	            });
	          });
	          batch.length && coordSysRecord.dispatchAction(batch);
	        });
	      });
	      return coordSysRecord;
	    }
	    /**
	     * This action will be throttled.
	     */
	
	
	    function dispatchAction$1(api, batch) {
	      if (!api.isDisposed()) {
	        api.dispatchAction({
	          type: 'dataZoom',
	          animation: {
	            easing: 'cubicOut',
	            duration: 100
	          },
	          batch: batch
	        });
	      }
	    }
	
	    function containsPoint(coordSysModel, e, x, y) {
	      return coordSysModel.coordinateSystem.containPoint([x, y]);
	    }
	    /**
	     * Merge roamController settings when multiple dataZooms share one roamController.
	     */
	
	
	    function mergeControllerParams(dataZoomInfoMap) {
	      var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
	      // as string, it is probably revert to reserved word by compress tool. See #7411.
	
	      var prefix = 'type_';
	      var typePriority = {
	        'type_true': 2,
	        'type_move': 1,
	        'type_false': 0,
	        'type_undefined': -1
	      };
	      var preventDefaultMouseMove = true;
	      dataZoomInfoMap.each(function (dataZoomInfo) {
	        var dataZoomModel = dataZoomInfo.model;
	        var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;
	
	        if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) {
	          controlType = oneType;
	        } // Prevent default move event by default. If one false, do not prevent. Otherwise
	        // users may be confused why it does not work when multiple insideZooms exist.
	
	
	        preventDefaultMouseMove = preventDefaultMouseMove && dataZoomModel.get('preventDefaultMouseMove', true);
	      });
	      return {
	        controlType: controlType,
	        opt: {
	          // RoamController will enable all of these functionalities,
	          // and the final behavior is determined by its event listener
	          // provided by each inside zoom.
	          zoomOnMouseWheel: true,
	          moveOnMouseMove: true,
	          moveOnMouseWheel: true,
	          preventDefaultMouseMove: !!preventDefaultMouseMove
	        }
	      };
	    }
	
	    function installDataZoomRoamProcessor(registers) {
	      registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, function (ecModel, api) {
	        var apiInner = inner$k(api);
	        var coordSysRecordMap = apiInner.coordSysRecordMap || (apiInner.coordSysRecordMap = createHashMap());
	        coordSysRecordMap.each(function (coordSysRecord) {
	          // `coordSysRecordMap` always exists (because it holds the `roam controller`, which should
	          // better not re-create each time), but clear `dataZoomInfoMap` each round of the workflow.
	          coordSysRecord.dataZoomInfoMap = null;
	        });
	        ecModel.eachComponent({
	          mainType: 'dataZoom',
	          subType: 'inside'
	        }, function (dataZoomModel) {
	          var dzReferCoordSysWrap = collectReferCoordSysModelInfo(dataZoomModel);
	          each(dzReferCoordSysWrap.infoList, function (dzCoordSysInfo) {
	            var coordSysUid = dzCoordSysInfo.model.uid;
	            var coordSysRecord = coordSysRecordMap.get(coordSysUid) || coordSysRecordMap.set(coordSysUid, createCoordSysRecord(api, dzCoordSysInfo.model));
	            var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap || (coordSysRecord.dataZoomInfoMap = createHashMap()); // Notice these props might be changed each time for a single dataZoomModel.
	
	            dataZoomInfoMap.set(dataZoomModel.uid, {
	              dzReferCoordSysInfo: dzCoordSysInfo,
	              model: dataZoomModel,
	              getRange: null
	            });
	          });
	        }); // (1) Merge dataZoom settings for each coord sys and set to the roam controller.
	        // (2) Clear coord sys if not refered by any dataZoom.
	
	        coordSysRecordMap.each(function (coordSysRecord) {
	          var controller = coordSysRecord.controller;
	          var firstDzInfo;
	          var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
	
	          if (dataZoomInfoMap) {
	            var firstDzKey = dataZoomInfoMap.keys()[0];
	
	            if (firstDzKey != null) {
	              firstDzInfo = dataZoomInfoMap.get(firstDzKey);
	            }
	          }
	
	          if (!firstDzInfo) {
	            disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
	            return;
	          }
	
	          var controllerParams = mergeControllerParams(dataZoomInfoMap);
	          controller.enable(controllerParams.controlType, controllerParams.opt);
	          controller.setPointerChecker(coordSysRecord.containsPoint);
	          createOrUpdate(coordSysRecord, 'dispatchAction', firstDzInfo.model.get('throttle', true), 'fixRate');
	        });
	      });
	    }
	
	    var InsideZoomView =
	    /** @class */
	    function (_super) {
	      __extends(InsideZoomView, _super);
	
	      function InsideZoomView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = 'dataZoom.inside';
	        return _this;
	      }
	
	      InsideZoomView.prototype.render = function (dataZoomModel, ecModel, api) {
	        _super.prototype.render.apply(this, arguments);
	
	        if (dataZoomModel.noTarget()) {
	          this._clear();
	
	          return;
	        } // Hence the `throttle` util ensures to preserve command order,
	        // here simply updating range all the time will not cause missing
	        // any of the the roam change.
	
	
	        this.range = dataZoomModel.getPercentRange(); // Reset controllers.
	
	        setViewInfoToCoordSysRecord(api, dataZoomModel, {
	          pan: bind(getRangeHandlers.pan, this),
	          zoom: bind(getRangeHandlers.zoom, this),
	          scrollMove: bind(getRangeHandlers.scrollMove, this)
	        });
	      };
	
	      InsideZoomView.prototype.dispose = function () {
	        this._clear();
	
	        _super.prototype.dispose.apply(this, arguments);
	      };
	
	      InsideZoomView.prototype._clear = function () {
	        disposeCoordSysRecordIfNeeded(this.api, this.dataZoomModel);
	        this.range = null;
	      };
	
	      InsideZoomView.type = 'dataZoom.inside';
	      return InsideZoomView;
	    }(DataZoomView);
	
	    var getRangeHandlers = {
	      zoom: function (coordSysInfo, coordSysMainType, controller, e) {
	        var lastRange = this.range;
	        var range = lastRange.slice(); // Calculate transform by the first axis.
	
	        var axisModel = coordSysInfo.axisModels[0];
	
	        if (!axisModel) {
	          return;
	        }
	
	        var directionInfo = getDirectionInfo[coordSysMainType](null, [e.originX, e.originY], axisModel, controller, coordSysInfo);
	        var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
	        var scale = Math.max(1 / e.scale, 0);
	        range[0] = (range[0] - percentPoint) * scale + percentPoint;
	        range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.
	
	        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	        sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
	        this.range = range;
	
	        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	          return range;
	        }
	      },
	      pan: makeMover(function (range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
	        var directionInfo = getDirectionInfo[coordSysMainType]([e.oldX, e.oldY], [e.newX, e.newY], axisModel, controller, coordSysInfo);
	        return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
	      }),
	      scrollMove: makeMover(function (range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
	        var directionInfo = getDirectionInfo[coordSysMainType]([0, 0], [e.scrollDelta, e.scrollDelta], axisModel, controller, coordSysInfo);
	        return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
	      })
	    };
	
	    function makeMover(getPercentDelta) {
	      return function (coordSysInfo, coordSysMainType, controller, e) {
	        var lastRange = this.range;
	        var range = lastRange.slice(); // Calculate transform by the first axis.
	
	        var axisModel = coordSysInfo.axisModels[0];
	
	        if (!axisModel) {
	          return;
	        }
	
	        var percentDelta = getPercentDelta(range, axisModel, coordSysInfo, coordSysMainType, controller, e);
	        sliderMove(percentDelta, range, [0, 100], 'all');
	        this.range = range;
	
	        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	          return range;
	        }
	      };
	    }
	
	    var getDirectionInfo = {
	      grid: function (oldPoint, newPoint, axisModel, controller, coordSysInfo) {
	        var axis = axisModel.axis;
	        var ret = {};
	        var rect = coordSysInfo.model.coordinateSystem.getRect();
	        oldPoint = oldPoint || [0, 0];
	
	        if (axis.dim === 'x') {
	          ret.pixel = newPoint[0] - oldPoint[0];
	          ret.pixelLength = rect.width;
	          ret.pixelStart = rect.x;
	          ret.signal = axis.inverse ? 1 : -1;
	        } else {
	          // axis.dim === 'y'
	          ret.pixel = newPoint[1] - oldPoint[1];
	          ret.pixelLength = rect.height;
	          ret.pixelStart = rect.y;
	          ret.signal = axis.inverse ? -1 : 1;
	        }
	
	        return ret;
	      },
	      polar: function (oldPoint, newPoint, axisModel, controller, coordSysInfo) {
	        var axis = axisModel.axis;
	        var ret = {};
	        var polar = coordSysInfo.model.coordinateSystem;
	        var radiusExtent = polar.getRadiusAxis().getExtent();
	        var angleExtent = polar.getAngleAxis().getExtent();
	        oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
	        newPoint = polar.pointToCoord(newPoint);
	
	        if (axisModel.mainType === 'radiusAxis') {
	          ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
	          // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
	
	          ret.pixelLength = radiusExtent[1] - radiusExtent[0];
	          ret.pixelStart = radiusExtent[0];
	          ret.signal = axis.inverse ? 1 : -1;
	        } else {
	          // 'angleAxis'
	          ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
	          // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
	
	          ret.pixelLength = angleExtent[1] - angleExtent[0];
	          ret.pixelStart = angleExtent[0];
	          ret.signal = axis.inverse ? -1 : 1;
	        }
	
	        return ret;
	      },
	      singleAxis: function (oldPoint, newPoint, axisModel, controller, coordSysInfo) {
	        var axis = axisModel.axis;
	        var rect = coordSysInfo.model.coordinateSystem.getRect();
	        var ret = {};
	        oldPoint = oldPoint || [0, 0];
	
	        if (axis.orient === 'horizontal') {
	          ret.pixel = newPoint[0] - oldPoint[0];
	          ret.pixelLength = rect.width;
	          ret.pixelStart = rect.x;
	          ret.signal = axis.inverse ? 1 : -1;
	        } else {
	          // 'vertical'
	          ret.pixel = newPoint[1] - oldPoint[1];
	          ret.pixelLength = rect.height;
	          ret.pixelStart = rect.y;
	          ret.signal = axis.inverse ? -1 : 1;
	        }
	
	        return ret;
	      }
	    };
	
	    function install$K(registers) {
	      installCommon(registers);
	      registers.registerComponentModel(InsideZoomModel);
	      registers.registerComponentView(InsideZoomView);
	      installDataZoomRoamProcessor(registers);
	    }
	
	    var SliderZoomModel =
	    /** @class */
	    function (_super) {
	      __extends(SliderZoomModel, _super);
	
	      function SliderZoomModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SliderZoomModel.type;
	        return _this;
	      }
	
	      SliderZoomModel.type = 'dataZoom.slider';
	      SliderZoomModel.layoutMode = 'box';
	      SliderZoomModel.defaultOption = inheritDefaultOption(DataZoomModel.defaultOption, {
	        show: true,
	        // deault value can only be drived in view stage.
	        right: 'ph',
	        top: 'ph',
	        width: 'ph',
	        height: 'ph',
	        left: null,
	        bottom: null,
	        borderColor: '#d2dbee',
	        borderRadius: 3,
	        backgroundColor: 'rgba(47,69,84,0)',
	        // dataBackgroundColor: '#ddd',
	        dataBackground: {
	          lineStyle: {
	            color: '#d2dbee',
	            width: 0.5
	          },
	          areaStyle: {
	            color: '#d2dbee',
	            opacity: 0.2
	          }
	        },
	        selectedDataBackground: {
	          lineStyle: {
	            color: '#8fb0f7',
	            width: 0.5
	          },
	          areaStyle: {
	            color: '#8fb0f7',
	            opacity: 0.2
	          }
	        },
	        // Color of selected window.
	        fillerColor: 'rgba(135,175,274,0.2)',
	        handleIcon: 'path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z',
	        // Percent of the slider height
	        handleSize: '100%',
	        handleStyle: {
	          color: '#fff',
	          borderColor: '#ACB8D1'
	        },
	        moveHandleSize: 7,
	        moveHandleIcon: 'path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z',
	        moveHandleStyle: {
	          color: '#D2DBEE',
	          opacity: 0.7
	        },
	        showDetail: true,
	        showDataShadow: 'auto',
	        realtime: true,
	        zoomLock: false,
	        textStyle: {
	          color: '#6E7079'
	        },
	        brushSelect: true,
	        brushStyle: {
	          color: 'rgba(135,175,274,0.15)'
	        },
	        emphasis: {
	          handleStyle: {
	            borderColor: '#8FB0F7'
	          },
	          moveHandleStyle: {
	            color: '#8FB0F7'
	          }
	        }
	      });
	      return SliderZoomModel;
	    }(DataZoomModel);
	
	    var Rect$2 = Rect; // Constants
	
	    var DEFAULT_LOCATION_EDGE_GAP = 7;
	    var DEFAULT_FRAME_BORDER_WIDTH = 1;
	    var DEFAULT_FILLER_SIZE = 30;
	    var DEFAULT_MOVE_HANDLE_SIZE = 7;
	    var HORIZONTAL = 'horizontal';
	    var VERTICAL = 'vertical';
	    var LABEL_GAP = 5;
	    var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
	    var REALTIME_ANIMATION_CONFIG = {
	      easing: 'cubicOut',
	      duration: 100,
	      delay: 0
	    };
	
	    var SliderZoomView =
	    /** @class */
	    function (_super) {
	      __extends(SliderZoomView, _super);
	
	      function SliderZoomView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = SliderZoomView.type;
	        _this._displayables = {};
	        return _this;
	      }
	
	      SliderZoomView.prototype.init = function (ecModel, api) {
	        this.api = api; // A unique handler for each dataZoom component
	
	        this._onBrush = bind(this._onBrush, this);
	        this._onBrushEnd = bind(this._onBrushEnd, this);
	      };
	
	      SliderZoomView.prototype.render = function (dataZoomModel, ecModel, api, payload) {
	        _super.prototype.render.apply(this, arguments);
	
	        createOrUpdate(this, '_dispatchZoomAction', dataZoomModel.get('throttle'), 'fixRate');
	        this._orient = dataZoomModel.getOrient();
	
	        if (dataZoomModel.get('show') === false) {
	          this.group.removeAll();
	          return;
	        }
	
	        if (dataZoomModel.noTarget()) {
	          this._clear();
	
	          this.group.removeAll();
	          return;
	        } // Notice: this._resetInterval() should not be executed when payload.type
	        // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
	        // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
	
	
	        if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
	          this._buildView();
	        }
	
	        this._updateView();
	      };
	
	      SliderZoomView.prototype.dispose = function () {
	        this._clear();
	
	        _super.prototype.dispose.apply(this, arguments);
	      };
	
	      SliderZoomView.prototype._clear = function () {
	        clear(this, '_dispatchZoomAction');
	        var zr = this.api.getZr();
	        zr.off('mousemove', this._onBrush);
	        zr.off('mouseup', this._onBrushEnd);
	      };
	
	      SliderZoomView.prototype._buildView = function () {
	        var thisGroup = this.group;
	        thisGroup.removeAll();
	        this._brushing = false;
	        this._displayables.brushRect = null;
	
	        this._resetLocation();
	
	        this._resetInterval();
	
	        var barGroup = this._displayables.sliderGroup = new Group();
	
	        this._renderBackground();
	
	        this._renderHandle();
	
	        this._renderDataShadow();
	
	        thisGroup.add(barGroup);
	
	        this._positionGroup();
	      };
	
	      SliderZoomView.prototype._resetLocation = function () {
	        var dataZoomModel = this.dataZoomModel;
	        var api = this.api;
	        var showMoveHandle = dataZoomModel.get('brushSelect');
	        var moveHandleSize = showMoveHandle ? DEFAULT_MOVE_HANDLE_SIZE : 0; // If some of x/y/width/height are not specified,
	        // auto-adapt according to target grid.
	
	        var coordRect = this._findCoordRect();
	
	        var ecSize = {
	          width: api.getWidth(),
	          height: api.getHeight()
	        }; // Default align by coordinate system rect.
	
	        var positionInfo = this._orient === HORIZONTAL ? {
	          // Why using 'right', because right should be used in vertical,
	          // and it is better to be consistent for dealing with position param merge.
	          right: ecSize.width - coordRect.x - coordRect.width,
	          top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP - moveHandleSize,
	          width: coordRect.width,
	          height: DEFAULT_FILLER_SIZE
	        } : {
	          right: DEFAULT_LOCATION_EDGE_GAP,
	          top: coordRect.y,
	          width: DEFAULT_FILLER_SIZE,
	          height: coordRect.height
	        }; // Do not write back to option and replace value 'ph', because
	        // the 'ph' value should be recalculated when resize.
	
	        var layoutParams = getLayoutParams(dataZoomModel.option); // Replace the placeholder value.
	
	        each(['right', 'top', 'width', 'height'], function (name) {
	          if (layoutParams[name] === 'ph') {
	            layoutParams[name] = positionInfo[name];
	          }
	        });
	        var layoutRect = getLayoutRect(layoutParams, ecSize);
	        this._location = {
	          x: layoutRect.x,
	          y: layoutRect.y
	        };
	        this._size = [layoutRect.width, layoutRect.height];
	        this._orient === VERTICAL && this._size.reverse();
	      };
	
	      SliderZoomView.prototype._positionGroup = function () {
	        var thisGroup = this.group;
	        var location = this._location;
	        var orient = this._orient; // Just use the first axis to determine mapping.
	
	        var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
	        var inverse = targetAxisModel && targetAxisModel.get('inverse');
	        var sliderGroup = this._displayables.sliderGroup;
	        var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.
	
	        sliderGroup.attr(orient === HORIZONTAL && !inverse ? {
	          scaleY: otherAxisInverse ? 1 : -1,
	          scaleX: 1
	        } : orient === HORIZONTAL && inverse ? {
	          scaleY: otherAxisInverse ? 1 : -1,
	          scaleX: -1
	        } : orient === VERTICAL && !inverse ? {
	          scaleY: otherAxisInverse ? -1 : 1,
	          scaleX: 1,
	          rotation: Math.PI / 2
	        } // Don't use Math.PI, considering shadow direction.
	        : {
	          scaleY: otherAxisInverse ? -1 : 1,
	          scaleX: -1,
	          rotation: Math.PI / 2
	        }); // Position barGroup
	
	        var rect = thisGroup.getBoundingRect([sliderGroup]);
	        thisGroup.x = location.x - rect.x;
	        thisGroup.y = location.y - rect.y;
	        thisGroup.markRedraw();
	      };
	
	      SliderZoomView.prototype._getViewExtent = function () {
	        return [0, this._size[0]];
	      };
	
	      SliderZoomView.prototype._renderBackground = function () {
	        var dataZoomModel = this.dataZoomModel;
	        var size = this._size;
	        var barGroup = this._displayables.sliderGroup;
	        var brushSelect = dataZoomModel.get('brushSelect');
	        barGroup.add(new Rect$2({
	          silent: true,
	          shape: {
	            x: 0,
	            y: 0,
	            width: size[0],
	            height: size[1]
	          },
	          style: {
	            fill: dataZoomModel.get('backgroundColor')
	          },
	          z2: -40
	        })); // Click panel, over shadow, below handles.
	
	        var clickPanel = new Rect$2({
	          shape: {
	            x: 0,
	            y: 0,
	            width: size[0],
	            height: size[1]
	          },
	          style: {
	            fill: 'transparent'
	          },
	          z2: 0,
	          onclick: bind(this._onClickPanel, this)
	        });
	        var zr = this.api.getZr();
	
	        if (brushSelect) {
	          clickPanel.on('mousedown', this._onBrushStart, this);
	          clickPanel.cursor = 'crosshair';
	          zr.on('mousemove', this._onBrush);
	          zr.on('mouseup', this._onBrushEnd);
	        } else {
	          zr.off('mousemove', this._onBrush);
	          zr.off('mouseup', this._onBrushEnd);
	        }
	
	        barGroup.add(clickPanel);
	      };
	
	      SliderZoomView.prototype._renderDataShadow = function () {
	        var info = this._dataShadowInfo = this._prepareDataShadowInfo();
	
	        this._displayables.dataShadowSegs = [];
	
	        if (!info) {
	          return;
	        }
	
	        var size = this._size;
	        var oldSize = this._shadowSize || [];
	        var seriesModel = info.series;
	        var data = seriesModel.getRawData();
	        var candlestickDim = seriesModel.getShadowDim && seriesModel.getShadowDim();
	        var otherDim = candlestickDim && data.getDimensionInfo(candlestickDim) ? seriesModel.getShadowDim() // @see candlestick
	        : info.otherDim;
	
	        if (otherDim == null) {
	          return;
	        }
	
	        var polygonPts = this._shadowPolygonPts;
	        var polylinePts = this._shadowPolylinePts; // Not re-render if data doesn't change.
	
	        if (data !== this._shadowData || otherDim !== this._shadowDim || size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
	          var otherDataExtent_1 = data.getDataExtent(otherDim); // Nice extent.
	
	          var otherOffset = (otherDataExtent_1[1] - otherDataExtent_1[0]) * 0.3;
	          otherDataExtent_1 = [otherDataExtent_1[0] - otherOffset, otherDataExtent_1[1] + otherOffset];
	          var otherShadowExtent_1 = [0, size[1]];
	          var thisShadowExtent = [0, size[0]];
	          var areaPoints_1 = [[size[0], 0], [0, 0]];
	          var linePoints_1 = [];
	          var step_1 = thisShadowExtent[1] / (data.count() - 1);
	          var thisCoord_1 = 0; // Optimize for large data shadow
	
	          var stride_1 = Math.round(data.count() / size[0]);
	          var lastIsEmpty_1;
	          data.each([otherDim], function (value, index) {
	            if (stride_1 > 0 && index % stride_1) {
	              thisCoord_1 += step_1;
	              return;
	            } // FIXME
	            // Should consider axis.min/axis.max when drawing dataShadow.
	            // FIXME
	            // 应该使用统一的空判断？还是在list里进行空判断？
	
	
	            var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.
	
	            var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent_1, otherShadowExtent_1, true); // Attempt to draw data shadow precisely when there are empty value.
	
	            if (isEmpty && !lastIsEmpty_1 && index) {
	              areaPoints_1.push([areaPoints_1[areaPoints_1.length - 1][0], 0]);
	              linePoints_1.push([linePoints_1[linePoints_1.length - 1][0], 0]);
	            } else if (!isEmpty && lastIsEmpty_1) {
	              areaPoints_1.push([thisCoord_1, 0]);
	              linePoints_1.push([thisCoord_1, 0]);
	            }
	
	            areaPoints_1.push([thisCoord_1, otherCoord]);
	            linePoints_1.push([thisCoord_1, otherCoord]);
	            thisCoord_1 += step_1;
	            lastIsEmpty_1 = isEmpty;
	          });
	          polygonPts = this._shadowPolygonPts = areaPoints_1;
	          polylinePts = this._shadowPolylinePts = linePoints_1;
	        }
	
	        this._shadowData = data;
	        this._shadowDim = otherDim;
	        this._shadowSize = [size[0], size[1]];
	        var dataZoomModel = this.dataZoomModel;
	
	        function createDataShadowGroup(isSelectedArea) {
	          var model = dataZoomModel.getModel(isSelectedArea ? 'selectedDataBackground' : 'dataBackground');
	          var group = new Group();
	          var polygon = new Polygon({
	            shape: {
	              points: polygonPts
	            },
	            segmentIgnoreThreshold: 1,
	            style: model.getModel('areaStyle').getAreaStyle(),
	            silent: true,
	            z2: -20
	          });
	          var polyline = new Polyline({
	            shape: {
	              points: polylinePts
	            },
	            segmentIgnoreThreshold: 1,
	            style: model.getModel('lineStyle').getLineStyle(),
	            silent: true,
	            z2: -19
	          });
	          group.add(polygon);
	          group.add(polyline);
	          return group;
	        } // let dataBackgroundModel = dataZoomModel.getModel('dataBackground');
	
	
	        for (var i = 0; i < 3; i++) {
	          var group = createDataShadowGroup(i === 1);
	
	          this._displayables.sliderGroup.add(group);
	
	          this._displayables.dataShadowSegs.push(group);
	        }
	      };
	
	      SliderZoomView.prototype._prepareDataShadowInfo = function () {
	        var dataZoomModel = this.dataZoomModel;
	        var showDataShadow = dataZoomModel.get('showDataShadow');
	
	        if (showDataShadow === false) {
	          return;
	        } // Find a representative series.
	
	
	        var result;
	        var ecModel = this.ecModel;
	        dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
	          var seriesModels = dataZoomModel.getAxisProxy(axisDim, axisIndex).getTargetSeriesModels();
	          each(seriesModels, function (seriesModel) {
	            if (result) {
	              return;
	            }
	
	            if (showDataShadow !== true && indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
	              return;
	            }
	
	            var thisAxis = ecModel.getComponent(getAxisMainType(axisDim), axisIndex).axis;
	            var otherDim = getOtherDim(axisDim);
	            var otherAxisInverse;
	            var coordSys = seriesModel.coordinateSystem;
	
	            if (otherDim != null && coordSys.getOtherAxis) {
	              otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
	            }
	
	            otherDim = seriesModel.getData().mapDimension(otherDim);
	            result = {
	              thisAxis: thisAxis,
	              series: seriesModel,
	              thisDim: axisDim,
	              otherDim: otherDim,
	              otherAxisInverse: otherAxisInverse
	            };
	          }, this);
	        }, this);
	        return result;
	      };
	
	      SliderZoomView.prototype._renderHandle = function () {
	        var thisGroup = this.group;
	        var displayables = this._displayables;
	        var handles = displayables.handles = [null, null];
	        var handleLabels = displayables.handleLabels = [null, null];
	        var sliderGroup = this._displayables.sliderGroup;
	        var size = this._size;
	        var dataZoomModel = this.dataZoomModel;
	        var api = this.api;
	        var borderRadius = dataZoomModel.get('borderRadius') || 0;
	        var brushSelect = dataZoomModel.get('brushSelect');
	        var filler = displayables.filler = new Rect$2({
	          silent: brushSelect,
	          style: {
	            fill: dataZoomModel.get('fillerColor')
	          },
	          textConfig: {
	            position: 'inside'
	          }
	        });
	        sliderGroup.add(filler); // Frame border.
	
	        sliderGroup.add(new Rect$2({
	          silent: true,
	          subPixelOptimize: true,
	          shape: {
	            x: 0,
	            y: 0,
	            width: size[0],
	            height: size[1],
	            r: borderRadius
	          },
	          style: {
	            // deprecated option
	            stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
	            lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
	            fill: 'rgba(0,0,0,0)'
	          }
	        })); // Left and right handle to resize
	
	        each([0, 1], function (handleIndex) {
	          var iconStr = dataZoomModel.get('handleIcon');
	
	          if (!symbolBuildProxies[iconStr] && iconStr.indexOf('path://') < 0 && iconStr.indexOf('image://') < 0) {
	            // Compatitable with the old icon parsers. Which can use a path string without path://
	            iconStr = 'path://' + iconStr;
	
	            if (true) {
	              deprecateLog('handleIcon now needs \'path://\' prefix when using a path string');
	            }
	          }
	
	          var path = createSymbol(iconStr, -1, 0, 2, 2, null, true);
	          path.attr({
	            cursor: getCursor(this._orient),
	            draggable: true,
	            drift: bind(this._onDragMove, this, handleIndex),
	            ondragend: bind(this._onDragEnd, this),
	            onmouseover: bind(this._showDataInfo, this, true),
	            onmouseout: bind(this._showDataInfo, this, false),
	            z2: 5
	          });
	          var bRect = path.getBoundingRect();
	          var handleSize = dataZoomModel.get('handleSize');
	          this._handleHeight = parsePercent$1(handleSize, this._size[1]);
	          this._handleWidth = bRect.width / bRect.height * this._handleHeight;
	          path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
	          path.style.strokeNoScale = true;
	          path.rectHover = true;
	          path.ensureState('emphasis').style = dataZoomModel.getModel(['emphasis', 'handleStyle']).getItemStyle();
	          enableHoverEmphasis(path);
	          var handleColor = dataZoomModel.get('handleColor'); // deprecated option
	          // Compatitable with previous version
	
	          if (handleColor != null) {
	            path.style.fill = handleColor;
	          }
	
	          sliderGroup.add(handles[handleIndex] = path);
	          var textStyleModel = dataZoomModel.getModel('textStyle');
	          thisGroup.add(handleLabels[handleIndex] = new ZRText({
	            silent: true,
	            invisible: true,
	            style: createTextStyle(textStyleModel, {
	              x: 0,
	              y: 0,
	              text: '',
	              verticalAlign: 'middle',
	              align: 'center',
	              fill: textStyleModel.getTextColor(),
	              font: textStyleModel.getFont()
	            }),
	            z2: 10
	          }));
	        }, this); // Handle to move. Only visible when brushSelect is set true.
	
	        var actualMoveZone = filler;
	
	        if (brushSelect) {
	          var moveHandleHeight = parsePercent$1(dataZoomModel.get('moveHandleSize'), size[1]);
	          var moveHandle_1 = displayables.moveHandle = new Rect({
	            style: dataZoomModel.getModel('moveHandleStyle').getItemStyle(),
	            silent: true,
	            shape: {
	              r: [0, 0, 2, 2],
	              y: size[1] - 0.5,
	              height: moveHandleHeight
	            }
	          });
	          var iconSize = moveHandleHeight * 0.8;
	          var moveHandleIcon = displayables.moveHandleIcon = createSymbol(dataZoomModel.get('moveHandleIcon'), -iconSize / 2, -iconSize / 2, iconSize, iconSize, '#fff', true);
	          moveHandleIcon.silent = true;
	          moveHandleIcon.y = size[1] + moveHandleHeight / 2 - 0.5;
	          moveHandle_1.ensureState('emphasis').style = dataZoomModel.getModel(['emphasis', 'moveHandleStyle']).getItemStyle();
	          var moveZoneExpandSize = Math.min(size[1] / 2, Math.max(moveHandleHeight, 10));
	          actualMoveZone = displayables.moveZone = new Rect({
	            invisible: true,
	            shape: {
	              y: size[1] - moveZoneExpandSize,
	              height: moveHandleHeight + moveZoneExpandSize
	            }
	          });
	          actualMoveZone.on('mouseover', function () {
	            api.enterEmphasis(moveHandle_1);
	          }).on('mouseout', function () {
	            api.leaveEmphasis(moveHandle_1);
	          });
	          sliderGroup.add(moveHandle_1);
	          sliderGroup.add(moveHandleIcon);
	          sliderGroup.add(actualMoveZone);
	        }
	
	        actualMoveZone.attr({
	          draggable: true,
	          cursor: getCursor(this._orient),
	          drift: bind(this._onDragMove, this, 'all'),
	          ondragstart: bind(this._showDataInfo, this, true),
	          ondragend: bind(this._onDragEnd, this),
	          onmouseover: bind(this._showDataInfo, this, true),
	          onmouseout: bind(this._showDataInfo, this, false)
	        });
	      };
	
	      SliderZoomView.prototype._resetInterval = function () {
	        var range = this._range = this.dataZoomModel.getPercentRange();
	
	        var viewExtent = this._getViewExtent();
	
	        this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
	      };
	
	      SliderZoomView.prototype._updateInterval = function (handleIndex, delta) {
	        var dataZoomModel = this.dataZoomModel;
	        var handleEnds = this._handleEnds;
	
	        var viewExtend = this._getViewExtent();
	
	        var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	        var percentExtent = [0, 100];
	        sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
	        var lastRange = this._range;
	        var range = this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
	        return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
	      };
	
	      SliderZoomView.prototype._updateView = function (nonRealtime) {
	        var displaybles = this._displayables;
	        var handleEnds = this._handleEnds;
	        var handleInterval = asc(handleEnds.slice());
	        var size = this._size;
	        each([0, 1], function (handleIndex) {
	          // Handles
	          var handle = displaybles.handles[handleIndex];
	          var handleHeight = this._handleHeight;
	          handle.attr({
	            scaleX: handleHeight / 2,
	            scaleY: handleHeight / 2,
	            // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
	            // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
	            x: handleEnds[handleIndex] + (handleIndex ? -1 : 1),
	            y: size[1] / 2 - handleHeight / 2
	          });
	        }, this); // Filler
	
	        displaybles.filler.setShape({
	          x: handleInterval[0],
	          y: 0,
	          width: handleInterval[1] - handleInterval[0],
	          height: size[1]
	        });
	        var viewExtent = {
	          x: handleInterval[0],
	          width: handleInterval[1] - handleInterval[0]
	        }; // Move handle
	
	        if (displaybles.moveHandle) {
	          displaybles.moveHandle.setShape(viewExtent);
	          displaybles.moveZone.setShape(viewExtent); // Force update path on the invisible object
	
	          displaybles.moveZone.getBoundingRect();
	          displaybles.moveHandleIcon && displaybles.moveHandleIcon.attr('x', viewExtent.x + viewExtent.width / 2);
	        } // update clip path of shadow.
	
	
	        var dataShadowSegs = displaybles.dataShadowSegs;
	        var segIntervals = [0, handleInterval[0], handleInterval[1], size[0]];
	
	        for (var i = 0; i < dataShadowSegs.length; i++) {
	          var segGroup = dataShadowSegs[i];
	          var clipPath = segGroup.getClipPath();
	
	          if (!clipPath) {
	            clipPath = new Rect();
	            segGroup.setClipPath(clipPath);
	          }
	
	          clipPath.setShape({
	            x: segIntervals[i],
	            y: 0,
	            width: segIntervals[i + 1] - segIntervals[i],
	            height: size[1]
	          });
	        }
	
	        this._updateDataInfo(nonRealtime);
	      };
	
	      SliderZoomView.prototype._updateDataInfo = function (nonRealtime) {
	        var dataZoomModel = this.dataZoomModel;
	        var displaybles = this._displayables;
	        var handleLabels = displaybles.handleLabels;
	        var orient = this._orient;
	        var labelTexts = ['', '']; // FIXME
	        // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
	
	        if (dataZoomModel.get('showDetail')) {
	          var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	
	          if (axisProxy) {
	            var axis = axisProxy.getAxisModel().axis;
	            var range = this._range;
	            var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
	            ? axisProxy.calculateDataWindow({
	              start: range[0],
	              end: range[1]
	            }).valueWindow : axisProxy.getDataValueWindow();
	            labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
	          }
	        }
	
	        var orderedHandleEnds = asc(this._handleEnds.slice());
	        setLabel.call(this, 0);
	        setLabel.call(this, 1);
	
	        function setLabel(handleIndex) {
	          // Label
	          // Text should not transform by barGroup.
	          // Ignore handlers transform
	          var barTransform = getTransform(displaybles.handles[handleIndex].parent, this.group);
	          var direction = transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
	          var offset = this._handleWidth / 2 + LABEL_GAP;
	          var textPoint = applyTransform$1([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
	          handleLabels[handleIndex].setStyle({
	            x: textPoint[0],
	            y: textPoint[1],
	            verticalAlign: orient === HORIZONTAL ? 'middle' : direction,
	            align: orient === HORIZONTAL ? direction : 'center',
	            text: labelTexts[handleIndex]
	          });
	        }
	      };
	
	      SliderZoomView.prototype._formatLabel = function (value, axis) {
	        var dataZoomModel = this.dataZoomModel;
	        var labelFormatter = dataZoomModel.get('labelFormatter');
	        var labelPrecision = dataZoomModel.get('labelPrecision');
	
	        if (labelPrecision == null || labelPrecision === 'auto') {
	          labelPrecision = axis.getPixelPrecision();
	        }
	
	        var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
	        : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel({
	          value: Math.round(value)
	        }) // param of toFixed should less then 20.
	        : value.toFixed(Math.min(labelPrecision, 20));
	        return isFunction(labelFormatter) ? labelFormatter(value, valueStr) : isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
	      };
	      /**
	       * @param showOrHide true: show, false: hide
	       */
	
	
	      SliderZoomView.prototype._showDataInfo = function (showOrHide) {
	        // Always show when drgging.
	        showOrHide = this._dragging || showOrHide;
	        var displayables = this._displayables;
	        var handleLabels = displayables.handleLabels;
	        handleLabels[0].attr('invisible', !showOrHide);
	        handleLabels[1].attr('invisible', !showOrHide); // Highlight move handle
	
	        displayables.moveHandle && this.api[showOrHide ? 'enterEmphasis' : 'leaveEmphasis'](displayables.moveHandle, 1);
	      };
	
	      SliderZoomView.prototype._onDragMove = function (handleIndex, dx, dy, event) {
	        this._dragging = true; // For mobile device, prevent screen slider on the button.
	
	        stop(event.event); // Transform dx, dy to bar coordination.
	
	        var barTransform = this._displayables.sliderGroup.getLocalTransform();
	
	        var vertex = applyTransform$1([dx, dy], barTransform, true);
	
	        var changed = this._updateInterval(handleIndex, vertex[0]);
	
	        var realtime = this.dataZoomModel.get('realtime');
	
	        this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
	        // which cause bad visual effect when progressive enabled.
	
	
	        changed && realtime && this._dispatchZoomAction(true);
	      };
	
	      SliderZoomView.prototype._onDragEnd = function () {
	        this._dragging = false;
	
	        this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
	        // drag end will cause the whole view rerender, which is unnecessary.
	
	
	        var realtime = this.dataZoomModel.get('realtime');
	        !realtime && this._dispatchZoomAction(false);
	      };
	
	      SliderZoomView.prototype._onClickPanel = function (e) {
	        var size = this._size;
	
	        var localPoint = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);
	
	        if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
	          return;
	        }
	
	        var handleEnds = this._handleEnds;
	        var center = (handleEnds[0] + handleEnds[1]) / 2;
	
	        var changed = this._updateInterval('all', localPoint[0] - center);
	
	        this._updateView();
	
	        changed && this._dispatchZoomAction(false);
	      };
	
	      SliderZoomView.prototype._onBrushStart = function (e) {
	        var x = e.offsetX;
	        var y = e.offsetY;
	        this._brushStart = new Point(x, y);
	        this._brushing = true;
	        this._brushStartTime = +new Date(); // this._updateBrushRect(x, y);
	      };
	
	      SliderZoomView.prototype._onBrushEnd = function (e) {
	        if (!this._brushing) {
	          return;
	        }
	
	        var brushRect = this._displayables.brushRect;
	        this._brushing = false;
	
	        if (!brushRect) {
	          return;
	        }
	
	        brushRect.attr('ignore', true);
	        var brushShape = brushRect.shape;
	        var brushEndTime = +new Date(); // console.log(brushEndTime - this._brushStartTime);
	
	        if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) {
	          // Will treat it as a click
	          return;
	        }
	
	        var viewExtend = this._getViewExtent();
	
	        var percentExtent = [0, 100];
	        this._range = asc([linearMap(brushShape.x, viewExtend, percentExtent, true), linearMap(brushShape.x + brushShape.width, viewExtend, percentExtent, true)]);
	        this._handleEnds = [brushShape.x, brushShape.x + brushShape.width];
	
	        this._updateView();
	
	        this._dispatchZoomAction(false);
	      };
	
	      SliderZoomView.prototype._onBrush = function (e) {
	        if (this._brushing) {
	          // For mobile device, prevent screen slider on the button.
	          stop(e.event);
	
	          this._updateBrushRect(e.offsetX, e.offsetY);
	        }
	      };
	
	      SliderZoomView.prototype._updateBrushRect = function (mouseX, mouseY) {
	        var displayables = this._displayables;
	        var dataZoomModel = this.dataZoomModel;
	        var brushRect = displayables.brushRect;
	
	        if (!brushRect) {
	          brushRect = displayables.brushRect = new Rect$2({
	            silent: true,
	            style: dataZoomModel.getModel('brushStyle').getItemStyle()
	          });
	          displayables.sliderGroup.add(brushRect);
	        }
	
	        brushRect.attr('ignore', false);
	        var brushStart = this._brushStart;
	        var sliderGroup = this._displayables.sliderGroup;
	        var endPoint = sliderGroup.transformCoordToLocal(mouseX, mouseY);
	        var startPoint = sliderGroup.transformCoordToLocal(brushStart.x, brushStart.y);
	        var size = this._size;
	        endPoint[0] = Math.max(Math.min(size[0], endPoint[0]), 0);
	        brushRect.setShape({
	          x: startPoint[0],
	          y: 0,
	          width: endPoint[0] - startPoint[0],
	          height: size[1]
	        });
	      };
	      /**
	       * This action will be throttled.
	       */
	
	
	      SliderZoomView.prototype._dispatchZoomAction = function (realtime) {
	        var range = this._range;
	        this.api.dispatchAction({
	          type: 'dataZoom',
	          from: this.uid,
	          dataZoomId: this.dataZoomModel.id,
	          animation: realtime ? REALTIME_ANIMATION_CONFIG : null,
	          start: range[0],
	          end: range[1]
	        });
	      };
	
	      SliderZoomView.prototype._findCoordRect = function () {
	        // Find the grid corresponding to the first axis referred by dataZoom.
	        var rect;
	        var coordSysInfoList = collectReferCoordSysModelInfo(this.dataZoomModel).infoList;
	
	        if (!rect && coordSysInfoList.length) {
	          var coordSys = coordSysInfoList[0].model.coordinateSystem;
	          rect = coordSys.getRect && coordSys.getRect();
	        }
	
	        if (!rect) {
	          var width = this.api.getWidth();
	          var height = this.api.getHeight();
	          rect = {
	            x: width * 0.2,
	            y: height * 0.2,
	            width: width * 0.6,
	            height: height * 0.6
	          };
	        }
	
	        return rect;
	      };
	
	      SliderZoomView.type = 'dataZoom.slider';
	      return SliderZoomView;
	    }(DataZoomView);
	
	    function getOtherDim(thisDim) {
	      // FIXME
	      // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
	      var map = {
	        x: 'y',
	        y: 'x',
	        radius: 'angle',
	        angle: 'radius'
	      };
	      return map[thisDim];
	    }
	
	    function getCursor(orient) {
	      return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	    }
	
	    function install$L(registers) {
	      registers.registerComponentModel(SliderZoomModel);
	      registers.registerComponentView(SliderZoomView);
	      installCommon(registers);
	    }
	
	    function install$M(registers) {
	      use(install$K);
	      use(install$L); // Do not install './dataZoomSelect',
	      // since it only work for toolbox dataZoom.
	    }
	
	    var visualDefault = {
	      /**
	       * @public
	       */
	      get: function (visualType, key, isCategory) {
	        var value = clone((defaultOption$1[visualType] || {})[key]);
	        return isCategory ? isArray(value) ? value[value.length - 1] : value : value;
	      }
	    };
	    var defaultOption$1 = {
	      color: {
	        active: ['#006edd', '#e0ffff'],
	        inactive: ['rgba(0,0,0,0)']
	      },
	      colorHue: {
	        active: [0, 360],
	        inactive: [0, 0]
	      },
	      colorSaturation: {
	        active: [0.3, 1],
	        inactive: [0, 0]
	      },
	      colorLightness: {
	        active: [0.9, 0.5],
	        inactive: [0, 0]
	      },
	      colorAlpha: {
	        active: [0.3, 1],
	        inactive: [0, 0]
	      },
	      opacity: {
	        active: [0.3, 1],
	        inactive: [0, 0]
	      },
	      symbol: {
	        active: ['circle', 'roundRect', 'diamond'],
	        inactive: ['none']
	      },
	      symbolSize: {
	        active: [10, 50],
	        inactive: [0, 0]
	      }
	    };
	
	    var mapVisual$1 = VisualMapping.mapVisual;
	    var eachVisual = VisualMapping.eachVisual;
	    var isArray$1 = isArray;
	    var each$d = each;
	    var asc$2 = asc;
	    var linearMap$1 = linearMap;
	
	    var VisualMapModel =
	    /** @class */
	    function (_super) {
	      __extends(VisualMapModel, _super);
	
	      function VisualMapModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = VisualMapModel.type;
	        _this.stateList = ['inRange', 'outOfRange'];
	        _this.replacableOptionKeys = ['inRange', 'outOfRange', 'target', 'controller', 'color'];
	        _this.layoutMode = {
	          type: 'box',
	          ignoreSize: true
	        };
	        /**
	         * [lowerBound, upperBound]
	         */
	
	        _this.dataBound = [-Infinity, Infinity];
	        _this.targetVisuals = {};
	        _this.controllerVisuals = {};
	        return _this;
	      }
	
	      VisualMapModel.prototype.init = function (option, parentModel, ecModel) {
	        this.mergeDefaultAndTheme(option, ecModel);
	      };
	      /**
	       * @protected
	       */
	
	
	      VisualMapModel.prototype.optionUpdated = function (newOption, isInit) {
	        var thisOption = this.option;
	        !isInit && replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
	        this.textStyleModel = this.getModel('textStyle');
	        this.resetItemSize();
	        this.completeVisualOption();
	      };
	      /**
	       * @protected
	       */
	
	
	      VisualMapModel.prototype.resetVisual = function (supplementVisualOption) {
	        var stateList = this.stateList;
	        supplementVisualOption = bind(supplementVisualOption, this);
	        this.controllerVisuals = createVisualMappings(this.option.controller, stateList, supplementVisualOption);
	        this.targetVisuals = createVisualMappings(this.option.target, stateList, supplementVisualOption);
	      };
	      /**
	       * @public
	       */
	
	
	      VisualMapModel.prototype.getItemSymbol = function () {
	        return null;
	      };
	      /**
	       * @protected
	       * @return {Array.<number>} An array of series indices.
	       */
	
	
	      VisualMapModel.prototype.getTargetSeriesIndices = function () {
	        var optionSeriesIndex = this.option.seriesIndex;
	        var seriesIndices = [];
	
	        if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
	          this.ecModel.eachSeries(function (seriesModel, index) {
	            seriesIndices.push(index);
	          });
	        } else {
	          seriesIndices = normalizeToArray(optionSeriesIndex);
	        }
	
	        return seriesIndices;
	      };
	      /**
	       * @public
	       */
	
	
	      VisualMapModel.prototype.eachTargetSeries = function (callback, context) {
	        each(this.getTargetSeriesIndices(), function (seriesIndex) {
	          var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);
	
	          if (seriesModel) {
	            callback.call(context, seriesModel);
	          }
	        }, this);
	      };
	      /**
	       * @pubilc
	       */
	
	
	      VisualMapModel.prototype.isTargetSeries = function (seriesModel) {
	        var is = false;
	        this.eachTargetSeries(function (model) {
	          model === seriesModel && (is = true);
	        });
	        return is;
	      };
	      /**
	       * @example
	       * this.formatValueText(someVal); // format single numeric value to text.
	       * this.formatValueText(someVal, true); // format single category value to text.
	       * this.formatValueText([min, max]); // format numeric min-max to text.
	       * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
	       * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
	       *
	       * @param value Real value, or this.dataBound[0 or 1].
	       * @param isCategory Only available when value is number.
	       * @param edgeSymbols Open-close symbol when value is interval.
	       * @protected
	       */
	
	
	      VisualMapModel.prototype.formatValueText = function (value, isCategory, edgeSymbols) {
	        var option = this.option;
	        var precision = option.precision;
	        var dataBound = this.dataBound;
	        var formatter = option.formatter;
	        var isMinMax;
	        edgeSymbols = edgeSymbols || ['<', '>'];
	
	        if (isArray(value)) {
	          value = value.slice();
	          isMinMax = true;
	        }
	
	        var textValue = isCategory ? value // Value is string when isCategory
	        : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);
	
	        if (isString(formatter)) {
	          return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
	        } else if (isFunction(formatter)) {
	          return isMinMax ? formatter(value[0], value[1]) : formatter(value);
	        }
	
	        if (isMinMax) {
	          if (value[0] === dataBound[0]) {
	            return edgeSymbols[0] + ' ' + textValue[1];
	          } else if (value[1] === dataBound[1]) {
	            return edgeSymbols[1] + ' ' + textValue[0];
	          } else {
	            return textValue[0] + ' - ' + textValue[1];
	          }
	        } else {
	          // Format single value (includes category case).
	          return textValue;
	        }
	
	        function toFixed(val) {
	          return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
	        }
	      };
	      /**
	       * @protected
	       */
	
	
	      VisualMapModel.prototype.resetExtent = function () {
	        var thisOption = this.option; // Can not calculate data extent by data here.
	        // Because series and data may be modified in processing stage.
	        // So we do not support the feature "auto min/max".
	
	        var extent = asc$2([thisOption.min, thisOption.max]);
	        this._dataExtent = extent;
	      };
	      /**
	       * PENDING:
	       * delete this method if no outer usage.
	       *
	       * Return  Concrete dimension. If null/undefined is returned, no dimension is used.
	       */
	      // getDataDimension(data: SeriesData) {
	      //     const optDim = this.option.dimension;
	      //     if (optDim != null) {
	      //         return data.getDimension(optDim);
	      //     }
	      //     const dimNames = data.dimensions;
	      //     for (let i = dimNames.length - 1; i >= 0; i--) {
	      //         const dimName = dimNames[i];
	      //         const dimInfo = data.getDimensionInfo(dimName);
	      //         if (!dimInfo.isCalculationCoord) {
	      //             return dimName;
	      //         }
	      //     }
	      // }
	
	
	      VisualMapModel.prototype.getDataDimensionIndex = function (data) {
	        var optDim = this.option.dimension;
	
	        if (optDim != null) {
	          return data.getDimensionIndex(optDim);
	        }
	
	        var dimNames = data.dimensions;
	
	        for (var i = dimNames.length - 1; i >= 0; i--) {
	          var dimName = dimNames[i];
	          var dimInfo = data.getDimensionInfo(dimName);
	
	          if (!dimInfo.isCalculationCoord) {
	            return dimInfo.storeDimIndex;
	          }
	        }
	      };
	
	      VisualMapModel.prototype.getExtent = function () {
	        return this._dataExtent.slice();
	      };
	
	      VisualMapModel.prototype.completeVisualOption = function () {
	        var ecModel = this.ecModel;
	        var thisOption = this.option;
	        var base = {
	          inRange: thisOption.inRange,
	          outOfRange: thisOption.outOfRange
	        };
	        var target = thisOption.target || (thisOption.target = {});
	        var controller = thisOption.controller || (thisOption.controller = {});
	        merge(target, base); // Do not override
	
	        merge(controller, base); // Do not override
	
	        var isCategory = this.isCategory();
	        completeSingle.call(this, target);
	        completeSingle.call(this, controller);
	        completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');
	
	        completeController.call(this, controller);
	
	        function completeSingle(base) {
	          // Compatible with ec2 dataRange.color.
	          // The mapping order of dataRange.color is: [high value, ..., low value]
	          // whereas inRange.color and outOfRange.color is [low value, ..., high value]
	          // Notice: ec2 has no inverse.
	          if (isArray$1(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
	          // So adding color only when no inRange defined.
	          && !base.inRange) {
	            base.inRange = {
	              color: thisOption.color.slice().reverse()
	            };
	          } // Compatible with previous logic, always give a default color, otherwise
	          // simple config with no inRange and outOfRange will not work.
	          // Originally we use visualMap.color as the default color, but setOption at
	          // the second time the default color will be erased. So we change to use
	          // constant DEFAULT_COLOR.
	          // If user do not want the default color, set inRange: {color: null}.
	
	
	          base.inRange = base.inRange || {
	            color: ecModel.get('gradientColor')
	          };
	        }
	
	        function completeInactive(base, stateExist, stateAbsent) {
	          var optExist = base[stateExist];
	          var optAbsent = base[stateAbsent];
	
	          if (optExist && !optAbsent) {
	            optAbsent = base[stateAbsent] = {};
	            each$d(optExist, function (visualData, visualType) {
	              if (!VisualMapping.isValidType(visualType)) {
	                return;
	              }
	
	              var defa = visualDefault.get(visualType, 'inactive', isCategory);
	
	              if (defa != null) {
	                optAbsent[visualType] = defa; // Compatibable with ec2:
	                // Only inactive color to rgba(0,0,0,0) can not
	                // make label transparent, so use opacity also.
	
	                if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
	                  optAbsent.opacity = [0, 0];
	                }
	              }
	            });
	          }
	        }
	
	        function completeController(controller) {
	          var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
	          var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
	          var inactiveColor = this.get('inactiveColor');
	          var itemSymbol = this.getItemSymbol();
	          var defaultSymbol = itemSymbol || 'roundRect';
	          each$d(this.stateList, function (state) {
	            var itemSize = this.itemSize;
	            var visuals = controller[state]; // Set inactive color for controller if no other color
	            // attr (like colorAlpha) specified.
	
	            if (!visuals) {
	              visuals = controller[state] = {
	                color: isCategory ? inactiveColor : [inactiveColor]
	              };
	            } // Consistent symbol and symbolSize if not specified.
	
	
	            if (visuals.symbol == null) {
	              visuals.symbol = symbolExists && clone(symbolExists) || (isCategory ? defaultSymbol : [defaultSymbol]);
	            }
	
	            if (visuals.symbolSize == null) {
	              visuals.symbolSize = symbolSizeExists && clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
	            } // Filter none
	
	
	            visuals.symbol = mapVisual$1(visuals.symbol, function (symbol) {
	              return symbol === 'none' ? defaultSymbol : symbol;
	            }); // Normalize symbolSize
	
	            var symbolSize = visuals.symbolSize;
	
	            if (symbolSize != null) {
	              var max_1 = -Infinity; // symbolSize can be object when categories defined.
	
	              eachVisual(symbolSize, function (value) {
	                value > max_1 && (max_1 = value);
	              });
	              visuals.symbolSize = mapVisual$1(symbolSize, function (value) {
	                return linearMap$1(value, [0, max_1], [0, itemSize[0]], true);
	              });
	            }
	          }, this);
	        }
	      };
	
	      VisualMapModel.prototype.resetItemSize = function () {
	        this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
	      };
	
	      VisualMapModel.prototype.isCategory = function () {
	        return !!this.option.categories;
	      };
	      /**
	       * @public
	       * @abstract
	       */
	
	
	      VisualMapModel.prototype.setSelected = function (selected) {};
	
	      VisualMapModel.prototype.getSelected = function () {
	        return null;
	      };
	      /**
	       * @public
	       * @abstract
	       */
	
	
	      VisualMapModel.prototype.getValueState = function (value) {
	        return null;
	      };
	      /**
	       * FIXME
	       * Do not publish to thirt-part-dev temporarily
	       * util the interface is stable. (Should it return
	       * a function but not visual meta?)
	       *
	       * @pubilc
	       * @abstract
	       * @param getColorVisual
	       *        params: value, valueState
	       *        return: color
	       * @return {Object} visualMeta
	       *        should includes {stops, outerColors}
	       *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
	       */
	
	
	      VisualMapModel.prototype.getVisualMeta = function (getColorVisual) {
	        return null;
	      };
	
	      VisualMapModel.type = 'visualMap';
	      VisualMapModel.dependencies = ['series'];
	      VisualMapModel.defaultOption = {
	        show: true,
	        // zlevel: 0,
	        z: 4,
	        seriesIndex: 'all',
	        min: 0,
	        max: 200,
	        left: 0,
	        right: null,
	        top: null,
	        bottom: 0,
	        itemWidth: null,
	        itemHeight: null,
	        inverse: false,
	        orient: 'vertical',
	        backgroundColor: 'rgba(0,0,0,0)',
	        borderColor: '#ccc',
	        contentColor: '#5793f3',
	        inactiveColor: '#aaa',
	        borderWidth: 0,
	        padding: 5,
	        // 接受数组分别设定上右下左边距，同css
	        textGap: 10,
	        precision: 0,
	        textStyle: {
	          color: '#333' // 值域文字颜色
	
	        }
	      };
	      return VisualMapModel;
	    }(ComponentModel);
	
	    var DEFAULT_BAR_BOUND = [20, 140];
	
	    var ContinuousModel =
	    /** @class */
	    function (_super) {
	      __extends(ContinuousModel, _super);
	
	      function ContinuousModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ContinuousModel.type;
	        return _this;
	      }
	      /**
	       * @override
	       */
	
	
	      ContinuousModel.prototype.optionUpdated = function (newOption, isInit) {
	        _super.prototype.optionUpdated.apply(this, arguments);
	
	        this.resetExtent();
	        this.resetVisual(function (mappingOption) {
	          mappingOption.mappingMethod = 'linear';
	          mappingOption.dataExtent = this.getExtent();
	        });
	
	        this._resetRange();
	      };
	      /**
	       * @protected
	       * @override
	       */
	
	
	      ContinuousModel.prototype.resetItemSize = function () {
	        _super.prototype.resetItemSize.apply(this, arguments);
	
	        var itemSize = this.itemSize;
	        (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
	        (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
	      };
	      /**
	       * @private
	       */
	
	
	      ContinuousModel.prototype._resetRange = function () {
	        var dataExtent = this.getExtent();
	        var range = this.option.range;
	
	        if (!range || range.auto) {
	          // `range` should always be array (so we don't use other
	          // value like 'auto') for user-friend. (consider getOption).
	          dataExtent.auto = 1;
	          this.option.range = dataExtent;
	        } else if (isArray(range)) {
	          if (range[0] > range[1]) {
	            range.reverse();
	          }
	
	          range[0] = Math.max(range[0], dataExtent[0]);
	          range[1] = Math.min(range[1], dataExtent[1]);
	        }
	      };
	      /**
	       * @protected
	       * @override
	       */
	
	
	      ContinuousModel.prototype.completeVisualOption = function () {
	        _super.prototype.completeVisualOption.apply(this, arguments);
	
	        each(this.stateList, function (state) {
	          var symbolSize = this.option.controller[state].symbolSize;
	
	          if (symbolSize && symbolSize[0] !== symbolSize[1]) {
	            symbolSize[0] = symbolSize[1] / 3; // For good looking.
	          }
	        }, this);
	      };
	      /**
	       * @override
	       */
	
	
	      ContinuousModel.prototype.setSelected = function (selected) {
	        this.option.range = selected.slice();
	
	        this._resetRange();
	      };
	      /**
	       * @public
	       */
	
	
	      ContinuousModel.prototype.getSelected = function () {
	        var dataExtent = this.getExtent();
	        var dataInterval = asc((this.get('range') || []).slice()); // Clamp
	
	        dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
	        dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
	        dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
	        dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
	        return dataInterval;
	      };
	      /**
	       * @override
	       */
	
	
	      ContinuousModel.prototype.getValueState = function (value) {
	        var range = this.option.range;
	        var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
	        // range[1] is processed likewise.
	
	        return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
	      };
	
	      ContinuousModel.prototype.findTargetDataIndices = function (range) {
	        var result = [];
	        this.eachTargetSeries(function (seriesModel) {
	          var dataIndices = [];
	          var data = seriesModel.getData();
	          data.each(this.getDataDimensionIndex(data), function (value, dataIndex) {
	            range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
	          }, this);
	          result.push({
	            seriesId: seriesModel.id,
	            dataIndex: dataIndices
	          });
	        }, this);
	        return result;
	      };
	      /**
	       * @implement
	       */
	
	
	      ContinuousModel.prototype.getVisualMeta = function (getColorVisual) {
	        var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
	        var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
	        var stops = [];
	
	        function setStop(value, valueState) {
	          stops.push({
	            value: value,
	            color: getColorVisual(value, valueState)
	          });
	        } // Format to: outOfRange -- inRange -- outOfRange.
	
	
	        var iIdx = 0;
	        var oIdx = 0;
	        var iLen = iVals.length;
	        var oLen = oVals.length;
	
	        for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
	          // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
	          if (oVals[oIdx] < iVals[iIdx]) {
	            setStop(oVals[oIdx], 'outOfRange');
	          }
	        }
	
	        for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
	          // If range is full, value beyond min, max will be clamped.
	          // make a singularity
	          first && stops.length && setStop(iVals[iIdx], 'outOfRange');
	          setStop(iVals[iIdx], 'inRange');
	        }
	
	        for (var first = 1; oIdx < oLen; oIdx++) {
	          if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
	            // make a singularity
	            if (first) {
	              stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
	              first = 0;
	            }
	
	            setStop(oVals[oIdx], 'outOfRange');
	          }
	        }
	
	        var stopsLen = stops.length;
	        return {
	          stops: stops,
	          outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
	        };
	      };
	
	      ContinuousModel.type = 'visualMap.continuous';
	      ContinuousModel.defaultOption = inheritDefaultOption(VisualMapModel.defaultOption, {
	        align: 'auto',
	        calculable: false,
	        hoverLink: true,
	        realtime: true,
	        handleIcon: 'path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z',
	        handleSize: '120%',
	        handleStyle: {
	          borderColor: '#fff',
	          borderWidth: 1
	        },
	        indicatorIcon: 'circle',
	        indicatorSize: '50%',
	        indicatorStyle: {
	          borderColor: '#fff',
	          borderWidth: 2,
	          shadowBlur: 2,
	          shadowOffsetX: 1,
	          shadowOffsetY: 1,
	          shadowColor: 'rgba(0,0,0,0.2)'
	        } // emphasis: {
	        //     handleStyle: {
	        //         shadowBlur: 3,
	        //         shadowOffsetX: 1,
	        //         shadowOffsetY: 1,
	        //         shadowColor: 'rgba(0,0,0,0.2)'
	        //     }
	        // }
	
	      });
	      return ContinuousModel;
	    }(VisualMapModel);
	
	    function getColorStopValues(visualMapModel, valueState, dataExtent) {
	      if (dataExtent[0] === dataExtent[1]) {
	        return dataExtent.slice();
	      } // When using colorHue mapping, it is not linear color any more.
	      // Moreover, canvas gradient seems not to be accurate linear.
	      // FIXME
	      // Should be arbitrary value 100? or based on pixel size?
	
	
	      var count = 200;
	      var step = (dataExtent[1] - dataExtent[0]) / count;
	      var value = dataExtent[0];
	      var stopValues = [];
	
	      for (var i = 0; i <= count && value < dataExtent[1]; i++) {
	        stopValues.push(value);
	        value += step;
	      }
	
	      stopValues.push(dataExtent[1]);
	      return stopValues;
	    }
	
	    var VisualMapView =
	    /** @class */
	    function (_super) {
	      __extends(VisualMapView, _super);
	
	      function VisualMapView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = VisualMapView.type;
	        _this.autoPositionValues = {
	          left: 1,
	          right: 1,
	          top: 1,
	          bottom: 1
	        };
	        return _this;
	      }
	
	      VisualMapView.prototype.init = function (ecModel, api) {
	        this.ecModel = ecModel;
	        this.api = api;
	      };
	      /**
	       * @protected
	       */
	
	
	      VisualMapView.prototype.render = function (visualMapModel, ecModel, api, payload // TODO: TYPE
	      ) {
	        this.visualMapModel = visualMapModel;
	
	        if (visualMapModel.get('show') === false) {
	          this.group.removeAll();
	          return;
	        }
	
	        this.doRender(visualMapModel, ecModel, api, payload);
	      };
	      /**
	       * @protected
	       */
	
	
	      VisualMapView.prototype.renderBackground = function (group) {
	        var visualMapModel = this.visualMapModel;
	        var padding = normalizeCssArray$1(visualMapModel.get('padding') || 0);
	        var rect = group.getBoundingRect();
	        group.add(new Rect({
	          z2: -1,
	          silent: true,
	          shape: {
	            x: rect.x - padding[3],
	            y: rect.y - padding[0],
	            width: rect.width + padding[3] + padding[1],
	            height: rect.height + padding[0] + padding[2]
	          },
	          style: {
	            fill: visualMapModel.get('backgroundColor'),
	            stroke: visualMapModel.get('borderColor'),
	            lineWidth: visualMapModel.get('borderWidth')
	          }
	        }));
	      };
	      /**
	       * @protected
	       * @param targetValue can be Infinity or -Infinity
	       * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
	       * @param opts
	       * @param opts.forceState Specify state, instead of using getValueState method.
	       * @param opts.convertOpacityToAlpha For color gradient in controller widget.
	       * @return {*} Visual value.
	       */
	
	
	      VisualMapView.prototype.getControllerVisual = function (targetValue, visualCluster, opts) {
	        opts = opts || {};
	        var forceState = opts.forceState;
	        var visualMapModel = this.visualMapModel;
	        var visualObj = {}; // Default values.
	
	        if (visualCluster === 'color') {
	          var defaultColor = visualMapModel.get('contentColor');
	          visualObj.color = defaultColor;
	        }
	
	        function getter(key) {
	          return visualObj[key];
	        }
	
	        function setter(key, value) {
	          visualObj[key] = value;
	        }
	
	        var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
	        var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	        each(visualTypes, function (type) {
	          var visualMapping = mappings[type];
	
	          if (opts.convertOpacityToAlpha && type === 'opacity') {
	            type = 'colorAlpha';
	            visualMapping = mappings.__alphaForOpacity;
	          }
	
	          if (VisualMapping.dependsOn(type, visualCluster)) {
	            visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
	          }
	        });
	        return visualObj[visualCluster];
	      };
	
	      VisualMapView.prototype.positionGroup = function (group) {
	        var model = this.visualMapModel;
	        var api = this.api;
	        positionElement(group, model.getBoxLayoutParams(), {
	          width: api.getWidth(),
	          height: api.getHeight()
	        });
	      };
	
	      VisualMapView.prototype.doRender = function (visualMapModel, ecModel, api, payload) {};
	
	      VisualMapView.type = 'visualMap';
	      return VisualMapView;
	    }(ComponentView);
	
	    var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
	    /**
	     * @param visualMapModel
	     * @param api
	     * @param itemSize always [short, long]
	     * @return {string} 'left' or 'right' or 'top' or 'bottom'
	     */
	
	    function getItemAlign(visualMapModel, api, itemSize) {
	      var modelOption = visualMapModel.option;
	      var itemAlign = modelOption.align;
	
	      if (itemAlign != null && itemAlign !== 'auto') {
	        return itemAlign;
	      } // Auto decision align.
	
	
	      var ecSize = {
	        width: api.getWidth(),
	        height: api.getHeight()
	      };
	      var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
	      var reals = paramsSet[realIndex];
	      var fakeValue = [0, null, 10];
	      var layoutInput = {};
	
	      for (var i = 0; i < 3; i++) {
	        layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
	        layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
	      }
	
	      var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
	      var rect = getLayoutRect(layoutInput, ecSize, modelOption.padding);
	      return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
	    }
	    /**
	     * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
	     * dataIndexInside means filtered index.
	     */
	    // TODO: TYPE more specified payload types.
	
	    function makeHighDownBatch(batch, visualMapModel) {
	      each(batch || [], function (batchItem) {
	        if (batchItem.dataIndex != null) {
	          batchItem.dataIndexInside = batchItem.dataIndex;
	          batchItem.dataIndex = null;
	        }
	
	        batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
	      });
	      return batch;
	    }
	
	    var linearMap$2 = linearMap;
	    var each$e = each;
	    var mathMin$a = Math.min;
	    var mathMax$a = Math.max; // Arbitrary value
	
	    var HOVER_LINK_SIZE = 12;
	    var HOVER_LINK_OUT = 6; // Notice:
	    // Any "interval" should be by the order of [low, high].
	    // "handle0" (handleIndex === 0) maps to
	    // low data value: this._dataInterval[0] and has low coord.
	    // "handle1" (handleIndex === 1) maps to
	    // high data value: this._dataInterval[1] and has high coord.
	    // The logic of transform is implemented in this._createBarGroup.
	
	    var ContinuousView =
	    /** @class */
	    function (_super) {
	      __extends(ContinuousView, _super);
	
	      function ContinuousView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = ContinuousView.type;
	        _this._shapes = {};
	        _this._dataInterval = [];
	        _this._handleEnds = [];
	        _this._hoverLinkDataIndices = [];
	        return _this;
	      }
	
	      ContinuousView.prototype.doRender = function (visualMapModel, ecModel, api, payload) {
	        this._api = api;
	
	        if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
	          this._buildView();
	        }
	      };
	
	      ContinuousView.prototype._buildView = function () {
	        this.group.removeAll();
	        var visualMapModel = this.visualMapModel;
	        var thisGroup = this.group;
	        this._orient = visualMapModel.get('orient');
	        this._useHandle = visualMapModel.get('calculable');
	
	        this._resetInterval();
	
	        this._renderBar(thisGroup);
	
	        var dataRangeText = visualMapModel.get('text');
	
	        this._renderEndsText(thisGroup, dataRangeText, 0);
	
	        this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.
	
	
	        this._updateView(true); // After updating view, inner shapes is built completely,
	        // and then background can be rendered.
	
	
	        this.renderBackground(thisGroup); // Real update view
	
	        this._updateView();
	
	        this._enableHoverLinkToSeries();
	
	        this._enableHoverLinkFromSeries();
	
	        this.positionGroup(thisGroup);
	      };
	
	      ContinuousView.prototype._renderEndsText = function (group, dataRangeText, endsIndex) {
	        if (!dataRangeText) {
	          return;
	        } // Compatible with ec2, text[0] map to high value, text[1] map low value.
	
	
	        var text = dataRangeText[1 - endsIndex];
	        text = text != null ? text + '' : '';
	        var visualMapModel = this.visualMapModel;
	        var textGap = visualMapModel.get('textGap');
	        var itemSize = visualMapModel.itemSize;
	        var barGroup = this._shapes.mainGroup;
	
	        var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);
	
	        var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
	
	        var orient = this._orient;
	        var textStyleModel = this.visualMapModel.textStyleModel;
	        this.group.add(new ZRText({
	          style: createTextStyle(textStyleModel, {
	            x: position[0],
	            y: position[1],
	            verticalAlign: orient === 'horizontal' ? 'middle' : align,
	            align: orient === 'horizontal' ? align : 'center',
	            text: text
	          })
	        }));
	      };
	
	      ContinuousView.prototype._renderBar = function (targetGroup) {
	        var visualMapModel = this.visualMapModel;
	        var shapes = this._shapes;
	        var itemSize = visualMapModel.itemSize;
	        var orient = this._orient;
	        var useHandle = this._useHandle;
	        var itemAlign = getItemAlign(visualMapModel, this.api, itemSize);
	
	        var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);
	
	        var gradientBarGroup = new Group();
	        mainGroup.add(gradientBarGroup); // Bar
	
	        gradientBarGroup.add(shapes.outOfRange = createPolygon());
	        gradientBarGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor$1(this._orient) : null, bind(this._dragHandle, this, 'all', false), bind(this._dragHandle, this, 'all', true))); // A border radius clip.
	
	        gradientBarGroup.setClipPath(new Rect({
	          shape: {
	            x: 0,
	            y: 0,
	            width: itemSize[0],
	            height: itemSize[1],
	            r: 3
	          }
	        }));
	        var textRect = visualMapModel.textStyleModel.getTextRect('国');
	        var textSize = mathMax$a(textRect.width, textRect.height); // Handle
	
	        if (useHandle) {
	          shapes.handleThumbs = [];
	          shapes.handleLabels = [];
	          shapes.handleLabelPoints = [];
	
	          this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);
	
	          this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
	        }
	
	        this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);
	
	        targetGroup.add(mainGroup);
	      };
	
	      ContinuousView.prototype._createHandle = function (visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
	        var onDrift = bind(this._dragHandle, this, handleIndex, false);
	        var onDragEnd = bind(this._dragHandle, this, handleIndex, true);
	        var handleSize = parsePercent(visualMapModel.get('handleSize'), itemSize[0]);
	        var handleThumb = createSymbol(visualMapModel.get('handleIcon'), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
	        var cursor = getCursor$1(this._orient);
	        handleThumb.attr({
	          cursor: cursor,
	          draggable: true,
	          drift: onDrift,
	          ondragend: onDragEnd,
	          onmousemove: function (e) {
	            stop(e.event);
	          }
	        });
	        handleThumb.x = itemSize[0] / 2;
	        handleThumb.useStyle(visualMapModel.getModel('handleStyle').getItemStyle());
	        handleThumb.setStyle({
	          strokeNoScale: true,
	          strokeFirst: true
	        });
	        handleThumb.style.lineWidth *= 2;
	        handleThumb.ensureState('emphasis').style = visualMapModel.getModel(['emphasis', 'handleStyle']).getItemStyle();
	        setAsHighDownDispatcher(handleThumb, true);
	        mainGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
	        // transform (orient/inverse). So label is built separately but not
	        // use zrender/graphic/helper/RectText, and is located based on view
	        // group (according to handleLabelPoint) but not barGroup.
	
	        var textStyleModel = this.visualMapModel.textStyleModel;
	        var handleLabel = new ZRText({
	          cursor: cursor,
	          draggable: true,
	          drift: onDrift,
	          onmousemove: function (e) {
	            // For mobile device, prevent screen slider on the button.
	            stop(e.event);
	          },
	          ondragend: onDragEnd,
	          style: createTextStyle(textStyleModel, {
	            x: 0,
	            y: 0,
	            text: ''
	          })
	        });
	        handleLabel.ensureState('blur').style = {
	          opacity: 0.1
	        };
	        handleLabel.stateTransition = {
	          duration: 200
	        };
	        this.group.add(handleLabel);
	        var handleLabelPoint = [handleSize, 0];
	        var shapes = this._shapes;
	        shapes.handleThumbs[handleIndex] = handleThumb;
	        shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
	        shapes.handleLabels[handleIndex] = handleLabel;
	      };
	
	      ContinuousView.prototype._createIndicator = function (visualMapModel, mainGroup, itemSize, textSize, orient) {
	        var scale = parsePercent(visualMapModel.get('indicatorSize'), itemSize[0]);
	        var indicator = createSymbol(visualMapModel.get('indicatorIcon'), -scale / 2, -scale / 2, scale, scale, null, true);
	        indicator.attr({
	          cursor: 'move',
	          invisible: true,
	          silent: true,
	          x: itemSize[0] / 2
	        });
	        var indicatorStyle = visualMapModel.getModel('indicatorStyle').getItemStyle();
	
	        if (indicator instanceof ZRImage) {
	          var pathStyle = indicator.style;
	          indicator.useStyle(extend({
	            // TODO other properties like x, y ?
	            image: pathStyle.image,
	            x: pathStyle.x,
	            y: pathStyle.y,
	            width: pathStyle.width,
	            height: pathStyle.height
	          }, indicatorStyle));
	        } else {
	          indicator.useStyle(indicatorStyle);
	        }
	
	        mainGroup.add(indicator);
	        var textStyleModel = this.visualMapModel.textStyleModel;
	        var indicatorLabel = new ZRText({
	          silent: true,
	          invisible: true,
	          style: createTextStyle(textStyleModel, {
	            x: 0,
	            y: 0,
	            text: ''
	          })
	        });
	        this.group.add(indicatorLabel);
	        var indicatorLabelPoint = [(orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT) + itemSize[0] / 2, 0];
	        var shapes = this._shapes;
	        shapes.indicator = indicator;
	        shapes.indicatorLabel = indicatorLabel;
	        shapes.indicatorLabelPoint = indicatorLabelPoint;
	        this._firstShowIndicator = true;
	      };
	
	      ContinuousView.prototype._dragHandle = function (handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
	      dx, dy) {
	        if (!this._useHandle) {
	          return;
	        }
	
	        this._dragging = !isEnd;
	
	        if (!isEnd) {
	          // Transform dx, dy to bar coordination.
	          var vertex = this._applyTransform([dx, dy], this._shapes.mainGroup, true);
	
	          this._updateInterval(handleIndex, vertex[1]);
	
	          this._hideIndicator(); // Considering realtime, update view should be executed
	          // before dispatch action.
	
	
	          this._updateView();
	        } // dragEnd do not dispatch action when realtime.
	
	
	        if (isEnd === !this.visualMapModel.get('realtime')) {
	          // jshint ignore:line
	          this.api.dispatchAction({
	            type: 'selectDataRange',
	            from: this.uid,
	            visualMapId: this.visualMapModel.id,
	            selected: this._dataInterval.slice()
	          });
	        }
	
	        if (isEnd) {
	          !this._hovering && this._clearHoverLinkToSeries();
	        } else if (useHoverLinkOnHandle(this.visualMapModel)) {
	          this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
	        }
	      };
	
	      ContinuousView.prototype._resetInterval = function () {
	        var visualMapModel = this.visualMapModel;
	        var dataInterval = this._dataInterval = visualMapModel.getSelected();
	        var dataExtent = visualMapModel.getExtent();
	        var sizeExtent = [0, visualMapModel.itemSize[1]];
	        this._handleEnds = [linearMap$2(dataInterval[0], dataExtent, sizeExtent, true), linearMap$2(dataInterval[1], dataExtent, sizeExtent, true)];
	      };
	      /**
	       * @private
	       * @param {(number|string)} handleIndex 0 or 1 or 'all'
	       * @param {number} dx
	       * @param {number} dy
	       */
	
	
	      ContinuousView.prototype._updateInterval = function (handleIndex, delta) {
	        delta = delta || 0;
	        var visualMapModel = this.visualMapModel;
	        var handleEnds = this._handleEnds;
	        var sizeExtent = [0, visualMapModel.itemSize[1]];
	        sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbidden
	        0);
	        var dataExtent = visualMapModel.getExtent(); // Update data interval.
	
	        this._dataInterval = [linearMap$2(handleEnds[0], sizeExtent, dataExtent, true), linearMap$2(handleEnds[1], sizeExtent, dataExtent, true)];
	      };
	
	      ContinuousView.prototype._updateView = function (forSketch) {
	        var visualMapModel = this.visualMapModel;
	        var dataExtent = visualMapModel.getExtent();
	        var shapes = this._shapes;
	        var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
	        var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
	
	        var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
	
	        var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
	
	        shapes.inRange.setStyle({
	          fill: visualInRange.barColor // opacity: visualInRange.opacity
	
	        }).setShape('points', visualInRange.barPoints);
	        shapes.outOfRange.setStyle({
	          fill: visualOutOfRange.barColor // opacity: visualOutOfRange.opacity
	
	        }).setShape('points', visualOutOfRange.barPoints);
	
	        this._updateHandle(inRangeHandleEnds, visualInRange);
	      };
	
	      ContinuousView.prototype._createBarVisual = function (dataInterval, dataExtent, handleEnds, forceState) {
	        var opts = {
	          forceState: forceState,
	          convertOpacityToAlpha: true
	        };
	
	        var colorStops = this._makeColorGradient(dataInterval, opts);
	
	        var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];
	
	        var barPoints = this._createBarPoints(handleEnds, symbolSizes);
	
	        return {
	          barColor: new LinearGradient(0, 0, 0, 1, colorStops),
	          barPoints: barPoints,
	          handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
	        };
	      };
	
	      ContinuousView.prototype._makeColorGradient = function (dataInterval, opts) {
	        // Considering colorHue, which is not linear, so we have to sample
	        // to calculate gradient color stops, but not only calculate head
	        // and tail.
	        var sampleNumber = 100; // Arbitrary value.
	
	        var colorStops = [];
	        var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
	        colorStops.push({
	          color: this.getControllerVisual(dataInterval[0], 'color', opts),
	          offset: 0
	        });
	
	        for (var i = 1; i < sampleNumber; i++) {
	          var currValue = dataInterval[0] + step * i;
	
	          if (currValue > dataInterval[1]) {
	            break;
	          }
	
	          colorStops.push({
	            color: this.getControllerVisual(currValue, 'color', opts),
	            offset: i / sampleNumber
	          });
	        }
	
	        colorStops.push({
	          color: this.getControllerVisual(dataInterval[1], 'color', opts),
	          offset: 1
	        });
	        return colorStops;
	      };
	
	      ContinuousView.prototype._createBarPoints = function (handleEnds, symbolSizes) {
	        var itemSize = this.visualMapModel.itemSize;
	        return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
	      };
	
	      ContinuousView.prototype._createBarGroup = function (itemAlign) {
	        var orient = this._orient;
	        var inverse = this.visualMapModel.get('inverse');
	        return new Group(orient === 'horizontal' && !inverse ? {
	          scaleX: itemAlign === 'bottom' ? 1 : -1,
	          rotation: Math.PI / 2
	        } : orient === 'horizontal' && inverse ? {
	          scaleX: itemAlign === 'bottom' ? -1 : 1,
	          rotation: -Math.PI / 2
	        } : orient === 'vertical' && !inverse ? {
	          scaleX: itemAlign === 'left' ? 1 : -1,
	          scaleY: -1
	        } : {
	          scaleX: itemAlign === 'left' ? 1 : -1
	        });
	      };
	
	      ContinuousView.prototype._updateHandle = function (handleEnds, visualInRange) {
	        if (!this._useHandle) {
	          return;
	        }
	
	        var shapes = this._shapes;
	        var visualMapModel = this.visualMapModel;
	        var handleThumbs = shapes.handleThumbs;
	        var handleLabels = shapes.handleLabels;
	        var itemSize = visualMapModel.itemSize;
	        var dataExtent = visualMapModel.getExtent();
	        each$e([0, 1], function (handleIndex) {
	          var handleThumb = handleThumbs[handleIndex];
	          handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
	          handleThumb.y = handleEnds[handleIndex];
	          var val = linearMap$2(handleEnds[handleIndex], [0, itemSize[1]], dataExtent, true);
	          var symbolSize = this.getControllerVisual(val, 'symbolSize');
	          handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
	          handleThumb.x = itemSize[0] - symbolSize / 2; // Update handle label position.
	
	          var textPoint = applyTransform$1(shapes.handleLabelPoints[handleIndex], getTransform(handleThumb, this.group));
	          handleLabels[handleIndex].setStyle({
	            x: textPoint[0],
	            y: textPoint[1],
	            text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
	            verticalAlign: 'middle',
	            align: this._orient === 'vertical' ? this._applyTransform('left', shapes.mainGroup) : 'center'
	          });
	        }, this);
	      };
	
	      ContinuousView.prototype._showIndicator = function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
	        var visualMapModel = this.visualMapModel;
	        var dataExtent = visualMapModel.getExtent();
	        var itemSize = visualMapModel.itemSize;
	        var sizeExtent = [0, itemSize[1]];
	        var shapes = this._shapes;
	        var indicator = shapes.indicator;
	
	        if (!indicator) {
	          return;
	        }
	
	        indicator.attr('invisible', false);
	        var opts = {
	          convertOpacityToAlpha: true
	        };
	        var color = this.getControllerVisual(cursorValue, 'color', opts);
	        var symbolSize = this.getControllerVisual(cursorValue, 'symbolSize');
	        var y = linearMap$2(cursorValue, dataExtent, sizeExtent, true);
	        var x = itemSize[0] - symbolSize / 2;
	        var oldIndicatorPos = {
	          x: indicator.x,
	          y: indicator.y
	        }; // Update handle label position.
	
	        indicator.y = y;
	        indicator.x = x;
	        var textPoint = applyTransform$1(shapes.indicatorLabelPoint, getTransform(indicator, this.group));
	        var indicatorLabel = shapes.indicatorLabel;
	        indicatorLabel.attr('invisible', false);
	
	        var align = this._applyTransform('left', shapes.mainGroup);
	
	        var orient = this._orient;
	        var isHorizontal = orient === 'horizontal';
	        indicatorLabel.setStyle({
	          text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
	          verticalAlign: isHorizontal ? align : 'middle',
	          align: isHorizontal ? 'center' : align
	        });
	        var indicatorNewProps = {
	          x: x,
	          y: y,
	          style: {
	            fill: color
	          }
	        };
	        var labelNewProps = {
	          style: {
	            x: textPoint[0],
	            y: textPoint[1]
	          }
	        };
	
	        if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
	          var animationCfg = {
	            duration: 100,
	            easing: 'cubicInOut',
	            additive: true
	          };
	          indicator.x = oldIndicatorPos.x;
	          indicator.y = oldIndicatorPos.y;
	          indicator.animateTo(indicatorNewProps, animationCfg);
	          indicatorLabel.animateTo(labelNewProps, animationCfg);
	        } else {
	          indicator.attr(indicatorNewProps);
	          indicatorLabel.attr(labelNewProps);
	        }
	
	        this._firstShowIndicator = false;
	        var handleLabels = this._shapes.handleLabels;
	
	        if (handleLabels) {
	          for (var i = 0; i < handleLabels.length; i++) {
	            // Fade out handle labels.
	            // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
	            this._api.enterBlur(handleLabels[i]);
	          }
	        }
	      };
	
	      ContinuousView.prototype._enableHoverLinkToSeries = function () {
	        var self = this;
	
	        this._shapes.mainGroup.on('mousemove', function (e) {
	          self._hovering = true;
	
	          if (!self._dragging) {
	            var itemSize = self.visualMapModel.itemSize;
	
	            var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.mainGroup, true, true); // For hover link show when hover handle, which might be
	            // below or upper than sizeExtent.
	
	
	            pos[1] = mathMin$a(mathMax$a(0, pos[1]), itemSize[1]);
	
	            self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
	          }
	        }).on('mouseout', function () {
	          // When mouse is out of handle, hoverLink still need
	          // to be displayed when realtime is set as false.
	          self._hovering = false;
	          !self._dragging && self._clearHoverLinkToSeries();
	        });
	      };
	
	      ContinuousView.prototype._enableHoverLinkFromSeries = function () {
	        var zr = this.api.getZr();
	
	        if (this.visualMapModel.option.hoverLink) {
	          zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
	          zr.on('mouseout', this._hideIndicator, this);
	        } else {
	          this._clearHoverLinkFromSeries();
	        }
	      };
	
	      ContinuousView.prototype._doHoverLinkToSeries = function (cursorPos, hoverOnBar) {
	        var visualMapModel = this.visualMapModel;
	        var itemSize = visualMapModel.itemSize;
	
	        if (!visualMapModel.option.hoverLink) {
	          return;
	        }
	
	        var sizeExtent = [0, itemSize[1]];
	        var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.
	
	        cursorPos = mathMin$a(mathMax$a(sizeExtent[0], cursorPos), sizeExtent[1]);
	        var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
	        var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
	        var cursorValue = linearMap$2(cursorPos, sizeExtent, dataExtent, true);
	        var valueRange = [linearMap$2(hoverRange[0], sizeExtent, dataExtent, true), linearMap$2(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
	        // where china and india has very large population.
	
	        hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
	        hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
	        // otherwise labels overlap, especially when dragging.
	
	        if (hoverOnBar) {
	          if (valueRange[0] === -Infinity) {
	            this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
	          } else if (valueRange[1] === Infinity) {
	            this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
	          } else {
	            this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
	          }
	        } // When realtime is set as false, handles, which are in barGroup,
	        // also trigger hoverLink, which help user to realize where they
	        // focus on when dragging. (see test/heatmap-large.html)
	        // When realtime is set as true, highlight will not show when hover
	        // handle, because the label on handle, which displays a exact value
	        // but not range, might mislead users.
	
	
	        var oldBatch = this._hoverLinkDataIndices;
	        var newBatch = [];
	
	        if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
	          newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
	        }
	
	        var resultBatches = compressBatches(oldBatch, newBatch);
	
	        this._dispatchHighDown('downplay', makeHighDownBatch(resultBatches[0], visualMapModel));
	
	        this._dispatchHighDown('highlight', makeHighDownBatch(resultBatches[1], visualMapModel));
	      };
	
	      ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function (e) {
	        var ecData;
	        findEventDispatcher(e.target, function (target) {
	          var currECData = getECData(target);
	
	          if (currECData.dataIndex != null) {
	            ecData = currECData;
	            return true;
	          }
	        }, true);
	
	        if (!ecData) {
	          return;
	        }
	
	        var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);
	        var visualMapModel = this.visualMapModel;
	
	        if (!visualMapModel.isTargetSeries(dataModel)) {
	          return;
	        }
	
	        var data = dataModel.getData(ecData.dataType);
	        var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);
	
	        if (!isNaN(value)) {
	          this._showIndicator(value, value);
	        }
	      };
	
	      ContinuousView.prototype._hideIndicator = function () {
	        var shapes = this._shapes;
	        shapes.indicator && shapes.indicator.attr('invisible', true);
	        shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
	        var handleLabels = this._shapes.handleLabels;
	
	        if (handleLabels) {
	          for (var i = 0; i < handleLabels.length; i++) {
	            // Fade out handle labels.
	            // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
	            this._api.leaveBlur(handleLabels[i]);
	          }
	        }
	      };
	
	      ContinuousView.prototype._clearHoverLinkToSeries = function () {
	        this._hideIndicator();
	
	        var indices = this._hoverLinkDataIndices;
	
	        this._dispatchHighDown('downplay', makeHighDownBatch(indices, this.visualMapModel));
	
	        indices.length = 0;
	      };
	
	      ContinuousView.prototype._clearHoverLinkFromSeries = function () {
	        this._hideIndicator();
	
	        var zr = this.api.getZr();
	        zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
	        zr.off('mouseout', this._hideIndicator);
	      };
	
	      ContinuousView.prototype._applyTransform = function (vertex, element, inverse, global) {
	        var transform = getTransform(element, global ? null : this.group);
	        return isArray(vertex) ? applyTransform$1(vertex, transform, inverse) : transformDirection(vertex, transform, inverse);
	      }; // TODO: TYPE more specified payload types.
	
	
	      ContinuousView.prototype._dispatchHighDown = function (type, batch) {
	        batch && batch.length && this.api.dispatchAction({
	          type: type,
	          batch: batch
	        });
	      };
	      /**
	       * @override
	       */
	
	
	      ContinuousView.prototype.dispose = function () {
	        this._clearHoverLinkFromSeries();
	
	        this._clearHoverLinkToSeries();
	      };
	      /**
	       * @override
	       */
	
	
	      ContinuousView.prototype.remove = function () {
	        this._clearHoverLinkFromSeries();
	
	        this._clearHoverLinkToSeries();
	      };
	
	      ContinuousView.type = 'visualMap.continuous';
	      return ContinuousView;
	    }(VisualMapView);
	
	    function createPolygon(points, cursor, onDrift, onDragEnd) {
	      return new Polygon({
	        shape: {
	          points: points
	        },
	        draggable: !!onDrift,
	        cursor: cursor,
	        drift: onDrift,
	        onmousemove: function (e) {
	          // For mobile device, prevent screen slider on the button.
	          stop(e.event);
	        },
	        ondragend: onDragEnd
	      });
	    }
	
	    function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
	      var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
	      var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
	
	      if (hoverLinkDataSize) {
	        halfHoverLinkSize = linearMap$2(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
	      }
	
	      return halfHoverLinkSize;
	    }
	
	    function useHoverLinkOnHandle(visualMapModel) {
	      var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
	      return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
	    }
	
	    function getCursor$1(orient) {
	      return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	    }
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	
	
	    /**
	     * AUTO-GENERATED FILE. DO NOT MODIFY.
	     */
	
	    /*
	    * Licensed to the Apache Software Foundation (ASF) under one
	    * or more contributor license agreements.  See the NOTICE file
	    * distributed with this work for additional information
	    * regarding copyright ownership.  The ASF licenses this file
	    * to you under the Apache License, Version 2.0 (the
	    * "License"); you may not use this file except in compliance
	    * with the License.  You may obtain a copy of the License at
	    *
	    *   http://www.apache.org/licenses/LICENSE-2.0
	    *
	    * Unless required by applicable law or agreed to in writing,
	    * software distributed under the License is distributed on an
	    * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    * KIND, either express or implied.  See the License for the
	    * specific language governing permissions and limitations
	    * under the License.
	    */
	    var visualMapActionInfo = {
	      type: 'selectDataRange',
	      event: 'dataRangeSelected',
	      // FIXME use updateView appears wrong
	      update: 'update'
	    };
	    var visualMapActionHander = function (payload, ecModel) {
	      ecModel.eachComponent({
	        mainType: 'visualMap',
	        query: payload
	      }, function (model) {
	        model.setSelected(payload.selected);
	      });
	    };
	
	    var visualMapEncodingHandlers = [{
	      createOnAllSeries: true,
	      reset: function (seriesModel, ecModel) {
	        var resetDefines = [];
	        ecModel.eachComponent('visualMap', function (visualMapModel) {
	          var pipelineContext = seriesModel.pipelineContext;
	
	          if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) {
	            return;
	          }
	
	          resetDefines.push(incrementalApplyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, bind(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
	        });
	        return resetDefines;
	      }
	    }, // Only support color.
	    {
	      createOnAllSeries: true,
	      reset: function (seriesModel, ecModel) {
	        var data = seriesModel.getData();
	        var visualMetaList = [];
	        ecModel.eachComponent('visualMap', function (visualMapModel) {
	          if (visualMapModel.isTargetSeries(seriesModel)) {
	            var visualMeta = visualMapModel.getVisualMeta(bind(getColorVisual, null, seriesModel, visualMapModel)) || {
	              stops: [],
	              outerColors: []
	            };
	            var dimIdx = visualMapModel.getDataDimensionIndex(data);
	
	            if (dimIdx >= 0) {
	              // visualMeta.dimension should be dimension index, but not concrete dimension.
	              visualMeta.dimension = dimIdx;
	              visualMetaList.push(visualMeta);
	            }
	          }
	        }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
	
	        seriesModel.getData().setVisual('visualMeta', visualMetaList);
	      }
	    }]; // FIXME
	    // performance and export for heatmap?
	    // value can be Infinity or -Infinity
	
	    function getColorVisual(seriesModel, visualMapModel, value, valueState) {
	      var mappings = visualMapModel.targetVisuals[valueState];
	      var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	      var resultVisual = {
	        color: getVisualFromData(seriesModel.getData(), 'color') // default color.
	
	      };
	
	      for (var i = 0, len = visualTypes.length; i < len; i++) {
	        var type = visualTypes[i];
	        var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
	        mapping && mapping.applyVisual(value, getVisual, setVisual);
	      }
	
	      return resultVisual.color;
	
	      function getVisual(key) {
	        return resultVisual[key];
	      }
	
	      function setVisual(key, value) {
	        resultVisual[key] = value;
	      }
	    }
	
	    var each$f = each;
	    function visualMapPreprocessor(option) {
	      var visualMap = option && option.visualMap;
	
	      if (!isArray(visualMap)) {
	        visualMap = visualMap ? [visualMap] : [];
	      }
	
	      each$f(visualMap, function (opt) {
	        if (!opt) {
	          return;
	        } // rename splitList to pieces
	
	
	        if (has$1(opt, 'splitList') && !has$1(opt, 'pieces')) {
	          opt.pieces = opt.splitList;
	          delete opt.splitList;
	        }
	
	        var pieces = opt.pieces;
	
	        if (pieces && isArray(pieces)) {
	          each$f(pieces, function (piece) {
	            if (isObject(piece)) {
	              if (has$1(piece, 'start') && !has$1(piece, 'min')) {
	                piece.min = piece.start;
	              }
	
	              if (has$1(piece, 'end') && !has$1(piece, 'max')) {
	                piece.max = piece.end;
	              }
	            }
	          });
	        }
	      });
	    }
	
	    function has$1(obj, name) {
	      return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
	    }
	
	    var installed$1 = false;
	    function installCommon$1(registers) {
	      if (installed$1) {
	        return;
	      }
	
	      installed$1 = true;
	      registers.registerSubTypeDefaulter('visualMap', function (option) {
	        // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
	        return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
	      });
	      registers.registerAction(visualMapActionInfo, visualMapActionHander);
	      each(visualMapEncodingHandlers, function (handler) {
	        registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
	      });
	      registers.registerPreprocessor(visualMapPreprocessor);
	    }
	
	    function install$N(registers) {
	      registers.registerComponentModel(ContinuousModel);
	      registers.registerComponentView(ContinuousView);
	      installCommon$1(registers);
	    }
	
	    var PiecewiseModel =
	    /** @class */
	    function (_super) {
	      __extends(PiecewiseModel, _super);
	
	      function PiecewiseModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = PiecewiseModel.type;
	        /**
	         * The order is always [low, ..., high].
	         * [{text: string, interval: Array.<number>}, ...]
	         */
	
	        _this._pieceList = [];
	        return _this;
	      }
	
	      PiecewiseModel.prototype.optionUpdated = function (newOption, isInit) {
	        _super.prototype.optionUpdated.apply(this, arguments);
	
	        this.resetExtent();
	
	        var mode = this._mode = this._determineMode();
	
	        this._pieceList = [];
	
	        resetMethods[this._mode].call(this, this._pieceList);
	
	        this._resetSelected(newOption, isInit);
	
	        var categories = this.option.categories;
	        this.resetVisual(function (mappingOption, state) {
	          if (mode === 'categories') {
	            mappingOption.mappingMethod = 'category';
	            mappingOption.categories = clone(categories);
	          } else {
	            mappingOption.dataExtent = this.getExtent();
	            mappingOption.mappingMethod = 'piecewise';
	            mappingOption.pieceList = map(this._pieceList, function (piece) {
	              piece = clone(piece);
	
	              if (state !== 'inRange') {
	                // FIXME
	                // outOfRange do not support special visual in pieces.
	                piece.visual = null;
	              }
	
	              return piece;
	            });
	          }
	        });
	      };
	      /**
	       * @protected
	       * @override
	       */
	
	
	      PiecewiseModel.prototype.completeVisualOption = function () {
	        // Consider this case:
	        // visualMap: {
	        //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
	        // }
	        // where no inRange/outOfRange set but only pieces. So we should make
	        // default inRange/outOfRange for this case, otherwise visuals that only
	        // appear in `pieces` will not be taken into account in visual encoding.
	        var option = this.option;
	        var visualTypesInPieces = {};
	        var visualTypes = VisualMapping.listVisualTypes();
	        var isCategory = this.isCategory();
	        each(option.pieces, function (piece) {
	          each(visualTypes, function (visualType) {
	            if (piece.hasOwnProperty(visualType)) {
	              visualTypesInPieces[visualType] = 1;
	            }
	          });
	        });
	        each(visualTypesInPieces, function (v, visualType) {
	          var exists = false;
	          each(this.stateList, function (state) {
	            exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
	          }, this);
	          !exists && each(this.stateList, function (state) {
	            (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
	          });
	        }, this);
	
	        function has(obj, state, visualType) {
	          return obj && obj[state] && obj[state].hasOwnProperty(visualType);
	        }
	
	        _super.prototype.completeVisualOption.apply(this, arguments);
	      };
	
	      PiecewiseModel.prototype._resetSelected = function (newOption, isInit) {
	        var thisOption = this.option;
	        var pieceList = this._pieceList; // Selected do not merge but all override.
	
	        var selected = (isInit ? thisOption : newOption).selected || {};
	        thisOption.selected = selected; // Consider 'not specified' means true.
	
	        each(pieceList, function (piece, index) {
	          var key = this.getSelectedMapKey(piece);
	
	          if (!selected.hasOwnProperty(key)) {
	            selected[key] = true;
	          }
	        }, this);
	
	        if (thisOption.selectedMode === 'single') {
	          // Ensure there is only one selected.
	          var hasSel_1 = false;
	          each(pieceList, function (piece, index) {
	            var key = this.getSelectedMapKey(piece);
	
	            if (selected[key]) {
	              hasSel_1 ? selected[key] = false : hasSel_1 = true;
	            }
	          }, this);
	        } // thisOption.selectedMode === 'multiple', default: all selected.
	
	      };
	      /**
	       * @public
	       */
	
	
	      PiecewiseModel.prototype.getItemSymbol = function () {
	        return this.get('itemSymbol');
	      };
	      /**
	       * @public
	       */
	
	
	      PiecewiseModel.prototype.getSelectedMapKey = function (piece) {
	        return this._mode === 'categories' ? piece.value + '' : piece.index + '';
	      };
	      /**
	       * @public
	       */
	
	
	      PiecewiseModel.prototype.getPieceList = function () {
	        return this._pieceList;
	      };
	      /**
	       * @return {string}
	       */
	
	
	      PiecewiseModel.prototype._determineMode = function () {
	        var option = this.option;
	        return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
	      };
	      /**
	       * @override
	       */
	
	
	      PiecewiseModel.prototype.setSelected = function (selected) {
	        this.option.selected = clone(selected);
	      };
	      /**
	       * @override
	       */
	
	
	      PiecewiseModel.prototype.getValueState = function (value) {
	        var index = VisualMapping.findPieceIndex(value, this._pieceList);
	        return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
	      };
	      /**
	       * @public
	       * @param pieceIndex piece index in visualMapModel.getPieceList()
	       */
	
	
	      PiecewiseModel.prototype.findTargetDataIndices = function (pieceIndex) {
	        var result = [];
	        var pieceList = this._pieceList;
	        this.eachTargetSeries(function (seriesModel) {
	          var dataIndices = [];
	          var data = seriesModel.getData();
	          data.each(this.getDataDimensionIndex(data), function (value, dataIndex) {
	            // Should always base on model pieceList, because it is order sensitive.
	            var pIdx = VisualMapping.findPieceIndex(value, pieceList);
	            pIdx === pieceIndex && dataIndices.push(dataIndex);
	          }, this);
	          result.push({
	            seriesId: seriesModel.id,
	            dataIndex: dataIndices
	          });
	        }, this);
	        return result;
	      };
	      /**
	       * @private
	       * @param piece piece.value or piece.interval is required.
	       * @return  Can be Infinity or -Infinity
	       */
	
	
	      PiecewiseModel.prototype.getRepresentValue = function (piece) {
	        var representValue;
	
	        if (this.isCategory()) {
	          representValue = piece.value;
	        } else {
	          if (piece.value != null) {
	            representValue = piece.value;
	          } else {
	            var pieceInterval = piece.interval || [];
	            representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
	          }
	        }
	
	        return representValue;
	      };
	
	      PiecewiseModel.prototype.getVisualMeta = function (getColorVisual) {
	        // Do not support category. (category axis is ordinal, numerical)
	        if (this.isCategory()) {
	          return;
	        }
	
	        var stops = [];
	        var outerColors = ['', ''];
	        var visualMapModel = this;
	
	        function setStop(interval, valueState) {
	          var representValue = visualMapModel.getRepresentValue({
	            interval: interval
	          }); // Not category
	
	          if (!valueState) {
	            valueState = visualMapModel.getValueState(representValue);
	          }
	
	          var color = getColorVisual(representValue, valueState);
	
	          if (interval[0] === -Infinity) {
	            outerColors[0] = color;
	          } else if (interval[1] === Infinity) {
	            outerColors[1] = color;
	          } else {
	            stops.push({
	              value: interval[0],
	              color: color
	            }, {
	              value: interval[1],
	              color: color
	            });
	          }
	        } // Suplement
	
	
	        var pieceList = this._pieceList.slice();
	
	        if (!pieceList.length) {
	          pieceList.push({
	            interval: [-Infinity, Infinity]
	          });
	        } else {
	          var edge = pieceList[0].interval[0];
	          edge !== -Infinity && pieceList.unshift({
	            interval: [-Infinity, edge]
	          });
	          edge = pieceList[pieceList.length - 1].interval[1];
	          edge !== Infinity && pieceList.push({
	            interval: [edge, Infinity]
	          });
	        }
	
	        var curr = -Infinity;
	        each(pieceList, function (piece) {
	          var interval = piece.interval;
	
	          if (interval) {
	            // Fulfill gap.
	            interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
	            setStop(interval.slice());
	            curr = interval[1];
	          }
	        }, this);
	        return {
	          stops: stops,
	          outerColors: outerColors
	        };
	      };
	
	      PiecewiseModel.type = 'visualMap.piecewise';
	      PiecewiseModel.defaultOption = inheritDefaultOption(VisualMapModel.defaultOption, {
	        selected: null,
	        minOpen: false,
	        maxOpen: false,
	        align: 'auto',
	        itemWidth: 20,
	        itemHeight: 14,
	        itemSymbol: 'roundRect',
	        pieces: null,
	        categories: null,
	        splitNumber: 5,
	        selectedMode: 'multiple',
	        itemGap: 10,
	        hoverLink: true // Enable hover highlight.
	
	      });
	      return PiecewiseModel;
	    }(VisualMapModel);
	    /**
	     * Key is this._mode
	     * @type {Object}
	     * @this {module:echarts/component/viusalMap/PiecewiseMode}
	     */
	
	    var resetMethods = {
	      splitNumber: function (outPieceList) {
	        var thisOption = this.option;
	        var precision = Math.min(thisOption.precision, 20);
	        var dataExtent = this.getExtent();
	        var splitNumber = thisOption.splitNumber;
	        splitNumber = Math.max(parseInt(splitNumber, 10), 1);
	        thisOption.splitNumber = splitNumber;
	        var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption
	
	        while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
	          precision++;
	        }
	
	        thisOption.precision = precision;
	        splitStep = +splitStep.toFixed(precision);
	
	        if (thisOption.minOpen) {
	          outPieceList.push({
	            interval: [-Infinity, dataExtent[0]],
	            close: [0, 0]
	          });
	        }
	
	        for (var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++) {
	          var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
	          outPieceList.push({
	            interval: [curr, max],
	            close: [1, 1]
	          });
	        }
	
	        if (thisOption.maxOpen) {
	          outPieceList.push({
	            interval: [dataExtent[1], Infinity],
	            close: [0, 0]
	          });
	        }
	
	        reformIntervals(outPieceList);
	        each(outPieceList, function (piece, index) {
	          piece.index = index;
	          piece.text = this.formatValueText(piece.interval);
	        }, this);
	      },
	      categories: function (outPieceList) {
	        var thisOption = this.option;
	        each(thisOption.categories, function (cate) {
	          // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
	          // 是否改一致。
	          outPieceList.push({
	            text: this.formatValueText(cate, true),
	            value: cate
	          });
	        }, this); // See "Order Rule".
	
	        normalizeReverse(thisOption, outPieceList);
	      },
	      pieces: function (outPieceList) {
	        var thisOption = this.option;
	        each(thisOption.pieces, function (pieceListItem, index) {
	          if (!isObject(pieceListItem)) {
	            pieceListItem = {
	              value: pieceListItem
	            };
	          }
	
	          var item = {
	            text: '',
	            index: index
	          };
	
	          if (pieceListItem.label != null) {
	            item.text = pieceListItem.label;
	          }
	
	          if (pieceListItem.hasOwnProperty('value')) {
	            var value = item.value = pieceListItem.value;
	            item.interval = [value, value];
	            item.close = [1, 1];
	          } else {
	            // `min` `max` is legacy option.
	            // `lt` `gt` `lte` `gte` is recommended.
	            var interval = item.interval = [];
	            var close_1 = item.close = [0, 0];
	            var closeList = [1, 0, 1];
	            var infinityList = [-Infinity, Infinity];
	            var useMinMax = [];
	
	            for (var lg = 0; lg < 2; lg++) {
	              var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];
	
	              for (var i = 0; i < 3 && interval[lg] == null; i++) {
	                interval[lg] = pieceListItem[names[i]];
	                close_1[lg] = closeList[i];
	                useMinMax[lg] = i === 2;
	              }
	
	              interval[lg] == null && (interval[lg] = infinityList[lg]);
	            }
	
	            useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
	            useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);
	
	            if (true) {
	              if (interval[0] > interval[1]) {
	                console.warn('Piece ' + index + 'is illegal: ' + interval + ' lower bound should not greater then uppper bound.');
	              }
	            }
	
	            if (interval[0] === interval[1] && close_1[0] && close_1[1]) {
	              // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
	              // we use value to lift the priority when min === max
	              item.value = interval[0];
	            }
	          }
	
	          item.visual = VisualMapping.retrieveVisuals(pieceListItem);
	          outPieceList.push(item);
	        }, this); // See "Order Rule".
	
	        normalizeReverse(thisOption, outPieceList); // Only pieces
	
	        reformIntervals(outPieceList);
	        each(outPieceList, function (piece) {
	          var close = piece.close;
	          var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
	          piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
	        }, this);
	      }
	    };
	
	    function normalizeReverse(thisOption, pieceList) {
	      var inverse = thisOption.inverse;
	
	      if (thisOption.orient === 'vertical' ? !inverse : inverse) {
	        pieceList.reverse();
	      }
	    }
	
	    var PiecewiseVisualMapView =
	    /** @class */
	    function (_super) {
	      __extends(PiecewiseVisualMapView, _super);
	
	      function PiecewiseVisualMapView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = PiecewiseVisualMapView.type;
	        return _this;
	      }
	
	      PiecewiseVisualMapView.prototype.doRender = function () {
	        var thisGroup = this.group;
	        thisGroup.removeAll();
	        var visualMapModel = this.visualMapModel;
	        var textGap = visualMapModel.get('textGap');
	        var textStyleModel = visualMapModel.textStyleModel;
	        var textFont = textStyleModel.getFont();
	        var textFill = textStyleModel.getTextColor();
	
	        var itemAlign = this._getItemAlign();
	
	        var itemSize = visualMapModel.itemSize;
	
	        var viewData = this._getViewData();
	
	        var endsText = viewData.endsText;
	        var showLabel = retrieve(visualMapModel.get('showLabel', true), !endsText);
	        endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
	        each(viewData.viewPieceList, function (item) {
	          var piece = item.piece;
	          var itemGroup = new Group();
	          itemGroup.onclick = bind(this._onItemClick, this, piece);
	
	          this._enableHoverLink(itemGroup, item.indexInModelPieceList); // TODO Category
	
	
	          var representValue = visualMapModel.getRepresentValue(piece);
	
	          this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);
	
	          if (showLabel) {
	            var visualState = this.visualMapModel.getValueState(representValue);
	            itemGroup.add(new ZRText({
	              style: {
	                x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
	                y: itemSize[1] / 2,
	                text: piece.text,
	                verticalAlign: 'middle',
	                align: itemAlign,
	                font: textFont,
	                fill: textFill,
	                opacity: visualState === 'outOfRange' ? 0.5 : 1
	              }
	            }));
	          }
	
	          thisGroup.add(itemGroup);
	        }, this);
	        endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
	        box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
	        this.renderBackground(thisGroup);
	        this.positionGroup(thisGroup);
	      };
	
	      PiecewiseVisualMapView.prototype._enableHoverLink = function (itemGroup, pieceIndex) {
	        var _this = this;
	
	        itemGroup.on('mouseover', function () {
	          return onHoverLink('highlight');
	        }).on('mouseout', function () {
	          return onHoverLink('downplay');
	        });
	
	        var onHoverLink = function (method) {
	          var visualMapModel = _this.visualMapModel; // TODO: TYPE More detailed action types
	
	          visualMapModel.option.hoverLink && _this.api.dispatchAction({
	            type: method,
	            batch: makeHighDownBatch(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
	          });
	        };
	      };
	
	      PiecewiseVisualMapView.prototype._getItemAlign = function () {
	        var visualMapModel = this.visualMapModel;
	        var modelOption = visualMapModel.option;
	
	        if (modelOption.orient === 'vertical') {
	          return getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
	        } else {
	          // horizontal, most case left unless specifying right.
	          var align = modelOption.align;
	
	          if (!align || align === 'auto') {
	            align = 'left';
	          }
	
	          return align;
	        }
	      };
	
	      PiecewiseVisualMapView.prototype._renderEndsText = function (group, text, itemSize, showLabel, itemAlign) {
	        if (!text) {
	          return;
	        }
	
	        var itemGroup = new Group();
	        var textStyleModel = this.visualMapModel.textStyleModel;
	        itemGroup.add(new ZRText({
	          style: createTextStyle(textStyleModel, {
	            x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
	            y: itemSize[1] / 2,
	            verticalAlign: 'middle',
	            align: showLabel ? itemAlign : 'center',
	            text: text
	          })
	        }));
	        group.add(itemGroup);
	      };
	      /**
	       * @private
	       * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
	       */
	
	
	      PiecewiseVisualMapView.prototype._getViewData = function () {
	        var visualMapModel = this.visualMapModel;
	        var viewPieceList = map(visualMapModel.getPieceList(), function (piece, index) {
	          return {
	            piece: piece,
	            indexInModelPieceList: index
	          };
	        });
	        var endsText = visualMapModel.get('text'); // Consider orient and inverse.
	
	        var orient = visualMapModel.get('orient');
	        var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]
	
	        if (orient === 'horizontal' ? inverse : !inverse) {
	          viewPieceList.reverse();
	        } // Origin order of endsText is [high, low]
	        else if (endsText) {
	            endsText = endsText.slice().reverse();
	          }
	
	        return {
	          viewPieceList: viewPieceList,
	          endsText: endsText
	        };
	      };
	
	      PiecewiseVisualMapView.prototype._createItemSymbol = function (group, representValue, shapeParam) {
	        group.add(createSymbol( // symbol will be string
	        this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
	        this.getControllerVisual(representValue, 'color')));
	      };
	
	      PiecewiseVisualMapView.prototype._onItemClick = function (piece) {
	        var visualMapModel = this.visualMapModel;
	        var option = visualMapModel.option;
	        var selectedMode = option.selectedMode;
	
	        if (!selectedMode) {
	          return;
	        }
	
	        var selected = clone(option.selected);
	        var newKey = visualMapModel.getSelectedMapKey(piece);
	
	        if (selectedMode === 'single' || selectedMode === true) {
	          selected[newKey] = true;
	          each(selected, function (o, key) {
	            selected[key] = key === newKey;
	          });
	        } else {
	          selected[newKey] = !selected[newKey];
	        }
	
	        this.api.dispatchAction({
	          type: 'selectDataRange',
	          from: this.uid,
	          visualMapId: this.visualMapModel.id,
	          selected: selected
	        });
	      };
	
	      PiecewiseVisualMapView.type = 'visualMap.piecewise';
	      return PiecewiseVisualMapView;
	    }(VisualMapView);
	
	    function install$O(registers) {
	      registers.registerComponentModel(PiecewiseModel);
	      registers.registerComponentView(PiecewiseVisualMapView);
	      installCommon$1(registers);
	    }
	
	    function install$P(registers) {
	      use(install$N);
	      use(install$O); // Do not install './dataZoomSelect',
	      // since it only work for toolbox dataZoom.
	    }
	
	    var DEFAULT_OPTION = {
	      label: {
	        enabled: true
	      },
	      decal: {
	        show: false
	      }
	    };
	    var inner$l = makeInner();
	    var decalPaletteScope = {};
	    function ariaVisual(ecModel, api) {
	      var ariaModel = ecModel.getModel('aria'); // See "area enabled" detection code in `GlobalModel.ts`.
	
	      if (!ariaModel.get('enabled')) {
	        return;
	      }
	
	      var defaultOption = clone(DEFAULT_OPTION);
	      merge(defaultOption.label, ecModel.getLocaleModel().get('aria'), false);
	      merge(ariaModel.option, defaultOption, false);
	      setDecal();
	      setLabel();
	
	      function setDecal() {
	        var decalModel = ariaModel.getModel('decal');
	        var useDecal = decalModel.get('show');
	
	        if (useDecal) {
	          // Each type of series use one scope.
	          // Pie and funnel are using different scopes.
	          var paletteScopeGroupByType_1 = createHashMap();
	          ecModel.eachSeries(function (seriesModel) {
	            if (seriesModel.isColorBySeries()) {
	              return;
	            }
	
	            var decalScope = paletteScopeGroupByType_1.get(seriesModel.type);
	
	            if (!decalScope) {
	              decalScope = {};
	              paletteScopeGroupByType_1.set(seriesModel.type, decalScope);
	            }
	
	            inner$l(seriesModel).scope = decalScope;
	          });
	          ecModel.eachRawSeries(function (seriesModel) {
	            if (ecModel.isSeriesFiltered(seriesModel)) {
	              return;
	            }
	
	            if (isFunction(seriesModel.enableAriaDecal)) {
	              // Let series define how to use decal palette on data
	              seriesModel.enableAriaDecal();
	              return;
	            }
	
	            var data = seriesModel.getData();
	
	            if (!seriesModel.isColorBySeries()) {
	              var dataAll_1 = seriesModel.getRawData();
	              var idxMap_1 = {};
	              var decalScope_1 = inner$l(seriesModel).scope;
	              data.each(function (idx) {
	                var rawIdx = data.getRawIndex(idx);
	                idxMap_1[rawIdx] = idx;
	              });
	              var dataCount_1 = dataAll_1.count();
	              dataAll_1.each(function (rawIdx) {
	                var idx = idxMap_1[rawIdx];
	                var name = dataAll_1.getName(rawIdx) || rawIdx + '';
	                var paletteDecal = getDecalFromPalette(seriesModel.ecModel, name, decalScope_1, dataCount_1);
	                var specifiedDecal = data.getItemVisual(idx, 'decal');
	                data.setItemVisual(idx, 'decal', mergeDecal(specifiedDecal, paletteDecal));
	              });
	            } else {
	              var paletteDecal = getDecalFromPalette(seriesModel.ecModel, seriesModel.name, decalPaletteScope, ecModel.getSeriesCount());
	              var specifiedDecal = data.getVisual('decal');
	              data.setVisual('decal', mergeDecal(specifiedDecal, paletteDecal));
	            }
	
	            function mergeDecal(specifiedDecal, paletteDecal) {
	              // Merge decal from palette to decal from itemStyle.
	              // User do not need to specify all of the decal props.
	              var resultDecal = specifiedDecal ? extend(extend({}, paletteDecal), specifiedDecal) : paletteDecal;
	              resultDecal.dirty = true;
	              return resultDecal;
	            }
	          });
	        }
	      }
	
	      function setLabel() {
	        var labelLocale = ecModel.getLocaleModel().get('aria');
	        var labelModel = ariaModel.getModel('label');
	        labelModel.option = defaults(labelModel.option, labelLocale);
	
	        if (!labelModel.get('enabled')) {
	          return;
	        }
	
	        var dom = api.getZr().dom;
	
	        if (labelModel.get('description')) {
	          dom.setAttribute('aria-label', labelModel.get('description'));
	          return;
	        }
	
	        var seriesCnt = ecModel.getSeriesCount();
	        var maxDataCnt = labelModel.get(['data', 'maxCount']) || 10;
	        var maxSeriesCnt = labelModel.get(['series', 'maxCount']) || 10;
	        var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
	        var ariaLabel;
	
	        if (seriesCnt < 1) {
	          // No series, no aria label
	          return;
	        } else {
	          var title = getTitle();
	
	          if (title) {
	            var withTitle = labelModel.get(['general', 'withTitle']);
	            ariaLabel = replace(withTitle, {
	              title: title
	            });
	          } else {
	            ariaLabel = labelModel.get(['general', 'withoutTitle']);
	          }
	
	          var seriesLabels_1 = [];
	          var prefix = seriesCnt > 1 ? labelModel.get(['series', 'multiple', 'prefix']) : labelModel.get(['series', 'single', 'prefix']);
	          ariaLabel += replace(prefix, {
	            seriesCount: seriesCnt
	          });
	          ecModel.eachSeries(function (seriesModel, idx) {
	            if (idx < displaySeriesCnt) {
	              var seriesLabel = void 0;
	              var seriesName = seriesModel.get('name');
	              var withName = seriesName ? 'withName' : 'withoutName';
	              seriesLabel = seriesCnt > 1 ? labelModel.get(['series', 'multiple', withName]) : labelModel.get(['series', 'single', withName]);
	              seriesLabel = replace(seriesLabel, {
	                seriesId: seriesModel.seriesIndex,
	                seriesName: seriesModel.get('name'),
	                seriesType: getSeriesTypeName(seriesModel.subType)
	              });
	              var data = seriesModel.getData();
	
	              if (data.count() > maxDataCnt) {
	                // Show part of data
	                var partialLabel = labelModel.get(['data', 'partialData']);
	                seriesLabel += replace(partialLabel, {
	                  displayCnt: maxDataCnt
	                });
	              } else {
	                seriesLabel += labelModel.get(['data', 'allData']);
	              }
	
	              var middleSeparator_1 = labelModel.get(['data', 'separator', 'middle']);
	              var endSeparator_1 = labelModel.get(['data', 'separator', 'end']);
	              var dataLabels = [];
	
	              for (var i = 0; i < data.count(); i++) {
	                if (i < maxDataCnt) {
	                  var name_1 = data.getName(i);
	                  var value = data.getValues(i);
	                  var dataLabel = labelModel.get(['data', name_1 ? 'withName' : 'withoutName']);
	                  dataLabels.push(replace(dataLabel, {
	                    name: name_1,
	                    value: value.join(middleSeparator_1)
	                  }));
	                }
	              }
	
	              seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
	              seriesLabels_1.push(seriesLabel);
	            }
	          });
	          var separatorModel = labelModel.getModel(['series', 'multiple', 'separator']);
	          var middleSeparator = separatorModel.get('middle');
	          var endSeparator = separatorModel.get('end');
	          ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
	          dom.setAttribute('aria-label', ariaLabel);
	        }
	      }
	
	      function replace(str, keyValues) {
	        if (!isString(str)) {
	          return str;
	        }
	
	        var result = str;
	        each(keyValues, function (value, key) {
	          result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
	        });
	        return result;
	      }
	
	      function getTitle() {
	        var title = ecModel.get('title');
	
	        if (title && title.length) {
	          title = title[0];
	        }
	
	        return title && title.text;
	      }
	
	      function getSeriesTypeName(type) {
	        return ecModel.getLocaleModel().get(['series', 'typeNames'])[type] || '自定义图';
	      }
	    }
	
	    function ariaPreprocessor(option) {
	      if (!option || !option.aria) {
	        return;
	      }
	
	      var aria = option.aria; // aria.show is deprecated and should use aria.enabled instead
	
	      if (aria.show != null) {
	        aria.enabled = aria.show;
	      }
	
	      aria.label = aria.label || {}; // move description, general, series, data to be under aria.label
	
	      each(['description', 'general', 'series', 'data'], function (name) {
	        if (aria[name] != null) {
	          aria.label[name] = aria[name];
	        }
	      });
	    }
	
	    function install$Q(registers) {
	      registers.registerPreprocessor(ariaPreprocessor);
	      registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, ariaVisual);
	    }
	
	    var RELATIONAL_EXPRESSION_OP_ALIAS_MAP = {
	      value: 'eq',
	      // PENDING: not good for literal semantic?
	      '<': 'lt',
	      '<=': 'lte',
	      '>': 'gt',
	      '>=': 'gte',
	      '=': 'eq',
	      '!=': 'ne',
	      '<>': 'ne' // Might be misleading for sake of the difference between '==' and '===',
	      // so don't support them.
	      // '==': 'eq',
	      // '===': 'seq',
	      // '!==': 'sne'
	      // PENDING: Whether support some common alias "ge", "le", "neq"?
	      // ge: 'gte',
	      // le: 'lte',
	      // neq: 'ne',
	
	    }; // type RelationalExpressionOpEvaluate = (tarVal: unknown, condVal: unknown) => boolean;
	
	    var RegExpEvaluator =
	    /** @class */
	    function () {
	      function RegExpEvaluator(rVal) {
	        // Support condVal: RegExp | string
	        var condValue = this._condVal = isString(rVal) ? new RegExp(rVal) : isRegExp(rVal) ? rVal : null;
	
	        if (condValue == null) {
	          var errMsg = '';
	
	          if (true) {
	            errMsg = makePrintable('Illegal regexp', rVal, 'in');
	          }
	
	          throwError(errMsg);
	        }
	      }
	
	      RegExpEvaluator.prototype.evaluate = function (lVal) {
	        var type = typeof lVal;
	        return isString(type) ? this._condVal.test(lVal) : isNumber(type) ? this._condVal.test(lVal + '') : false;
	      };
	
	      return RegExpEvaluator;
	    }();
	
	    var ConstConditionInternal =
	    /** @class */
	    function () {
	      function ConstConditionInternal() {}
	
	      ConstConditionInternal.prototype.evaluate = function () {
	        return this.value;
	      };
	
	      return ConstConditionInternal;
	    }();
	
	    var AndConditionInternal =
	    /** @class */
	    function () {
	      function AndConditionInternal() {}
	
	      AndConditionInternal.prototype.evaluate = function () {
	        var children = this.children;
	
	        for (var i = 0; i < children.length; i++) {
	          if (!children[i].evaluate()) {
	            return false;
	          }
	        }
	
	        return true;
	      };
	
	      return AndConditionInternal;
	    }();
	
	    var OrConditionInternal =
	    /** @class */
	    function () {
	      function OrConditionInternal() {}
	
	      OrConditionInternal.prototype.evaluate = function () {
	        var children = this.children;
	
	        for (var i = 0; i < children.length; i++) {
	          if (children[i].evaluate()) {
	            return true;
	          }
	        }
	
	        return false;
	      };
	
	      return OrConditionInternal;
	    }();
	
	    var NotConditionInternal =
	    /** @class */
	    function () {
	      function NotConditionInternal() {}
	
	      NotConditionInternal.prototype.evaluate = function () {
	        return !this.child.evaluate();
	      };
	
	      return NotConditionInternal;
	    }();
	
	    var RelationalConditionInternal =
	    /** @class */
	    function () {
	      function RelationalConditionInternal() {}
	
	      RelationalConditionInternal.prototype.evaluate = function () {
	        var needParse = !!this.valueParser; // Call getValue with no `this`.
	
	        var getValue = this.getValue;
	        var tarValRaw = getValue(this.valueGetterParam);
	        var tarValParsed = needParse ? this.valueParser(tarValRaw) : null; // Relational cond follow "and" logic internally.
	
	        for (var i = 0; i < this.subCondList.length; i++) {
	          if (!this.subCondList[i].evaluate(needParse ? tarValParsed : tarValRaw)) {
	            return false;
	          }
	        }
	
	        return true;
	      };
	
	      return RelationalConditionInternal;
	    }();
	
	    function parseOption(exprOption, getters) {
	      if (exprOption === true || exprOption === false) {
	        var cond = new ConstConditionInternal();
	        cond.value = exprOption;
	        return cond;
	      }
	
	      var errMsg = '';
	
	      if (!isObjectNotArray(exprOption)) {
	        if (true) {
	          errMsg = makePrintable('Illegal config. Expect a plain object but actually', exprOption);
	        }
	
	        throwError(errMsg);
	      }
	
	      if (exprOption.and) {
	        return parseAndOrOption('and', exprOption, getters);
	      } else if (exprOption.or) {
	        return parseAndOrOption('or', exprOption, getters);
	      } else if (exprOption.not) {
	        return parseNotOption(exprOption, getters);
	      }
	
	      return parseRelationalOption(exprOption, getters);
	    }
	
	    function parseAndOrOption(op, exprOption, getters) {
	      var subOptionArr = exprOption[op];
	      var errMsg = '';
	
	      if (true) {
	        errMsg = makePrintable('"and"/"or" condition should only be `' + op + ': [...]` and must not be empty array.', 'Illegal condition:', exprOption);
	      }
	
	      if (!isArray(subOptionArr)) {
	        throwError(errMsg);
	      }
	
	      if (!subOptionArr.length) {
	        throwError(errMsg);
	      }
	
	      var cond = op === 'and' ? new AndConditionInternal() : new OrConditionInternal();
	      cond.children = map(subOptionArr, function (subOption) {
	        return parseOption(subOption, getters);
	      });
	
	      if (!cond.children.length) {
	        throwError(errMsg);
	      }
	
	      return cond;
	    }
	
	    function parseNotOption(exprOption, getters) {
	      var subOption = exprOption.not;
	      var errMsg = '';
	
	      if (true) {
	        errMsg = makePrintable('"not" condition should only be `not: {}`.', 'Illegal condition:', exprOption);
	      }
	
	      if (!isObjectNotArray(subOption)) {
	        throwError(errMsg);
	      }
	
	      var cond = new NotConditionInternal();
	      cond.child = parseOption(subOption, getters);
	
	      if (!cond.child) {
	        throwError(errMsg);
	      }
	
	      return cond;
	    }
	
	    function parseRelationalOption(exprOption, getters) {
	      var errMsg = '';
	      var valueGetterParam = getters.prepareGetValue(exprOption);
	      var subCondList = [];
	      var exprKeys = keys(exprOption);
	      var parserName = exprOption.parser;
	      var valueParser = parserName ? getRawValueParser(parserName) : null;
	
	      for (var i = 0; i < exprKeys.length; i++) {
	        var keyRaw = exprKeys[i];
	
	        if (keyRaw === 'parser' || getters.valueGetterAttrMap.get(keyRaw)) {
	          continue;
	        }
	
	        var op = hasOwn(RELATIONAL_EXPRESSION_OP_ALIAS_MAP, keyRaw) ? RELATIONAL_EXPRESSION_OP_ALIAS_MAP[keyRaw] : keyRaw;
	        var condValueRaw = exprOption[keyRaw];
	        var condValueParsed = valueParser ? valueParser(condValueRaw) : condValueRaw;
	        var evaluator = createFilterComparator(op, condValueParsed) || op === 'reg' && new RegExpEvaluator(condValueParsed);
	
	        if (!evaluator) {
	          if (true) {
	            errMsg = makePrintable('Illegal relational operation: "' + keyRaw + '" in condition:', exprOption);
	          }
	
	          throwError(errMsg);
	        }
	
	        subCondList.push(evaluator);
	      }
	
	      if (!subCondList.length) {
	        if (true) {
	          errMsg = makePrintable('Relational condition must have at least one operator.', 'Illegal condition:', exprOption);
	        } // No relational operator always disabled in case of dangers result.
	
	
	        throwError(errMsg);
	      }
	
	      var cond = new RelationalConditionInternal();
	      cond.valueGetterParam = valueGetterParam;
	      cond.valueParser = valueParser;
	      cond.getValue = getters.getValue;
	      cond.subCondList = subCondList;
	      return cond;
	    }
	
	    function isObjectNotArray(val) {
	      return isObject(val) && !isArrayLike(val);
	    }
	
	    var ConditionalExpressionParsed =
	    /** @class */
	    function () {
	      function ConditionalExpressionParsed(exprOption, getters) {
	        this._cond = parseOption(exprOption, getters);
	      }
	
	      ConditionalExpressionParsed.prototype.evaluate = function () {
	        return this._cond.evaluate();
	      };
	
	      return ConditionalExpressionParsed;
	    }();
	    function parseConditionalExpression(exprOption, getters) {
	      return new ConditionalExpressionParsed(exprOption, getters);
	    }
	
	    var filterTransform = {
	      type: 'echarts:filter',
	      // PENDING: enhance to filter by index rather than create new data
	      transform: function (params) {
	        // [Caveat] Fail-Fast:
	        // Do not return the whole dataset unless user config indicates it explicitly.
	        // For example, if no condition is specified by mistake, returning an empty result
	        // is better than returning the entire raw source for the user to find the mistake.
	        var upstream = params.upstream;
	        var rawItem;
	        var condition = parseConditionalExpression(params.config, {
	          valueGetterAttrMap: createHashMap({
	            dimension: true
	          }),
	          prepareGetValue: function (exprOption) {
	            var errMsg = '';
	            var dimLoose = exprOption.dimension;
	
	            if (!hasOwn(exprOption, 'dimension')) {
	              if (true) {
	                errMsg = makePrintable('Relation condition must has prop "dimension" specified.', 'Illegal condition:', exprOption);
	              }
	
	              throwError(errMsg);
	            }
	
	            var dimInfo = upstream.getDimensionInfo(dimLoose);
	
	            if (!dimInfo) {
	              if (true) {
	                errMsg = makePrintable('Can not find dimension info via: ' + dimLoose + '.\n', 'Existing dimensions: ', upstream.cloneAllDimensionInfo(), '.\n', 'Illegal condition:', exprOption, '.\n');
	              }
	
	              throwError(errMsg);
	            }
	
	            return {
	              dimIdx: dimInfo.index
	            };
	          },
	          getValue: function (param) {
	            return upstream.retrieveValueFromItem(rawItem, param.dimIdx);
	          }
	        });
	        var resultData = [];
	
	        for (var i = 0, len = upstream.count(); i < len; i++) {
	          rawItem = upstream.getRawDataItem(i);
	
	          if (condition.evaluate()) {
	            resultData.push(rawItem);
	          }
	        }
	
	        return {
	          data: resultData
	        };
	      }
	    };
	
	    var sampleLog = '';
	
	    if (true) {
	      sampleLog = ['Valid config is like:', '{ dimension: "age", order: "asc" }', 'or [{ dimension: "age", order: "asc"], { dimension: "date", order: "desc" }]'].join(' ');
	    }
	
	    var sortTransform = {
	      type: 'echarts:sort',
	      transform: function (params) {
	        var upstream = params.upstream;
	        var config = params.config;
	        var errMsg = ''; // Normalize
	        // const orderExprList: OrderExpression[] = isArray(config[0])
	        //     ? config as OrderExpression[]
	        //     : [config as OrderExpression];
	
	        var orderExprList = normalizeToArray(config);
	
	        if (!orderExprList.length) {
	          if (true) {
	            errMsg = 'Empty `config` in sort transform.';
	          }
	
	          throwError(errMsg);
	        }
	
	        var orderDefList = [];
	        each(orderExprList, function (orderExpr) {
	          var dimLoose = orderExpr.dimension;
	          var order = orderExpr.order;
	          var parserName = orderExpr.parser;
	          var incomparable = orderExpr.incomparable;
	
	          if (dimLoose == null) {
	            if (true) {
	              errMsg = 'Sort transform config must has "dimension" specified.' + sampleLog;
	            }
	
	            throwError(errMsg);
	          }
	
	          if (order !== 'asc' && order !== 'desc') {
	            if (true) {
	              errMsg = 'Sort transform config must has "order" specified.' + sampleLog;
	            }
	
	            throwError(errMsg);
	          }
	
	          if (incomparable && incomparable !== 'min' && incomparable !== 'max') {
	            var errMsg_1 = '';
	
	            if (true) {
	              errMsg_1 = 'incomparable must be "min" or "max" rather than "' + incomparable + '".';
	            }
	
	            throwError(errMsg_1);
	          }
	
	          if (order !== 'asc' && order !== 'desc') {
	            var errMsg_2 = '';
	
	            if (true) {
	              errMsg_2 = 'order must be "asc" or "desc" rather than "' + order + '".';
	            }
	
	            throwError(errMsg_2);
	          }
	
	          var dimInfo = upstream.getDimensionInfo(dimLoose);
	
	          if (!dimInfo) {
	            if (true) {
	              errMsg = makePrintable('Can not find dimension info via: ' + dimLoose + '.\n', 'Existing dimensions: ', upstream.cloneAllDimensionInfo(), '.\n', 'Illegal config:', orderExpr, '.\n');
	            }
	
	            throwError(errMsg);
	          }
	
	          var parser = parserName ? getRawValueParser(parserName) : null;
	
	          if (parserName && !parser) {
	            if (true) {
	              errMsg = makePrintable('Invalid parser name ' + parserName + '.\n', 'Illegal config:', orderExpr, '.\n');
	            }
	
	            throwError(errMsg);
	          }
	
	          orderDefList.push({
	            dimIdx: dimInfo.index,
	            parser: parser,
	            comparator: new SortOrderComparator(order, incomparable)
	          });
	        }); // TODO: support it?
	
	        var sourceFormat = upstream.sourceFormat;
	
	        if (sourceFormat !== SOURCE_FORMAT_ARRAY_ROWS && sourceFormat !== SOURCE_FORMAT_OBJECT_ROWS) {
	          if (true) {
	            errMsg = 'sourceFormat "' + sourceFormat + '" is not supported yet';
	          }
	
	          throwError(errMsg);
	        } // Other upstream format are all array.
	
	
	        var resultData = [];
	
	        for (var i = 0, len = upstream.count(); i < len; i++) {
	          resultData.push(upstream.getRawDataItem(i));
	        }
	
	        resultData.sort(function (item0, item1) {
	          for (var i = 0; i < orderDefList.length; i++) {
	            var orderDef = orderDefList[i];
	            var val0 = upstream.retrieveValueFromItem(item0, orderDef.dimIdx);
	            var val1 = upstream.retrieveValueFromItem(item1, orderDef.dimIdx);
	
	            if (orderDef.parser) {
	              val0 = orderDef.parser(val0);
	              val1 = orderDef.parser(val1);
	            }
	
	            var result = orderDef.comparator.evaluate(val0, val1);
	
	            if (result !== 0) {
	              return result;
	            }
	          }
	
	          return 0;
	        });
	        return {
	          data: resultData
	        };
	      }
	    };
	
	    function install$R(registers) {
	      registers.registerTransform(filterTransform);
	      registers.registerTransform(sortTransform);
	    }
	
	    var DatasetModel =
	    /** @class */
	    function (_super) {
	      __extends(DatasetModel, _super);
	
	      function DatasetModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = 'dataset';
	        return _this;
	      }
	
	      DatasetModel.prototype.init = function (option, parentModel, ecModel) {
	        _super.prototype.init.call(this, option, parentModel, ecModel);
	
	        this._sourceManager = new SourceManager(this);
	        disableTransformOptionMerge(this);
	      };
	
	      DatasetModel.prototype.mergeOption = function (newOption, ecModel) {
	        _super.prototype.mergeOption.call(this, newOption, ecModel);
	
	        disableTransformOptionMerge(this);
	      };
	
	      DatasetModel.prototype.optionUpdated = function () {
	        this._sourceManager.dirty();
	      };
	
	      DatasetModel.prototype.getSourceManager = function () {
	        return this._sourceManager;
	      };
	
	      DatasetModel.type = 'dataset';
	      DatasetModel.defaultOption = {
	        seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN
	      };
	      return DatasetModel;
	    }(ComponentModel);
	
	    var DatasetView =
	    /** @class */
	    function (_super) {
	      __extends(DatasetView, _super);
	
	      function DatasetView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	
	        _this.type = 'dataset';
	        return _this;
	      }
	
	      DatasetView.type = 'dataset';
	      return DatasetView;
	    }(ComponentView);
	
	    function install$S(registers) {
	      registers.registerComponentModel(DatasetModel);
	      registers.registerComponentView(DatasetView);
	    }
	
	    var CMD$4 = PathProxy.CMD;
	    function aroundEqual(a, b) {
	        return Math.abs(a - b) < 1e-5;
	    }
	    function pathToBezierCurves(path) {
	        var data = path.data;
	        var len = path.len();
	        var bezierArrayGroups = [];
	        var currentSubpath;
	        var xi = 0;
	        var yi = 0;
	        var x0 = 0;
	        var y0 = 0;
	        function createNewSubpath(x, y) {
	            if (currentSubpath && currentSubpath.length > 2) {
	                bezierArrayGroups.push(currentSubpath);
	            }
	            currentSubpath = [x, y];
	        }
	        function addLine(x0, y0, x1, y1) {
	            if (!(aroundEqual(x0, x1) && aroundEqual(y0, y1))) {
	                currentSubpath.push(x0, y0, x1, y1, x1, y1);
	            }
	        }
	        function addArc(startAngle, endAngle, cx, cy, rx, ry) {
	            var delta = Math.abs(endAngle - startAngle);
	            var len = Math.tan(delta / 4) * 4 / 3;
	            var dir = endAngle < startAngle ? -1 : 1;
	            var c1 = Math.cos(startAngle);
	            var s1 = Math.sin(startAngle);
	            var c2 = Math.cos(endAngle);
	            var s2 = Math.sin(endAngle);
	            var x1 = c1 * rx + cx;
	            var y1 = s1 * ry + cy;
	            var x4 = c2 * rx + cx;
	            var y4 = s2 * ry + cy;
	            var hx = rx * len * dir;
	            var hy = ry * len * dir;
	            currentSubpath.push(x1 - hx * s1, y1 + hy * c1, x4 + hx * s2, y4 - hy * c2, x4, y4);
	        }
	        var x1;
	        var y1;
	        var x2;
	        var y2;
	        for (var i = 0; i < len;) {
	            var cmd = data[i++];
	            var isFirst = i === 1;
	            if (isFirst) {
	                xi = data[i];
	                yi = data[i + 1];
	                x0 = xi;
	                y0 = yi;
	                if (cmd === CMD$4.L || cmd === CMD$4.C || cmd === CMD$4.Q) {
	                    currentSubpath = [x0, y0];
	                }
	            }
	            switch (cmd) {
	                case CMD$4.M:
	                    xi = x0 = data[i++];
	                    yi = y0 = data[i++];
	                    createNewSubpath(x0, y0);
	                    break;
	                case CMD$4.L:
	                    x1 = data[i++];
	                    y1 = data[i++];
	                    addLine(xi, yi, x1, y1);
	                    xi = x1;
	                    yi = y1;
	                    break;
	                case CMD$4.C:
	                    currentSubpath.push(data[i++], data[i++], data[i++], data[i++], xi = data[i++], yi = data[i++]);
	                    break;
	                case CMD$4.Q:
	                    x1 = data[i++];
	                    y1 = data[i++];
	                    x2 = data[i++];
	                    y2 = data[i++];
	                    currentSubpath.push(xi + 2 / 3 * (x1 - xi), yi + 2 / 3 * (y1 - yi), x2 + 2 / 3 * (x1 - x2), y2 + 2 / 3 * (y1 - y2), x2, y2);
	                    xi = x2;
	                    yi = y2;
	                    break;
	                case CMD$4.A:
	                    var cx = data[i++];
	                    var cy = data[i++];
	                    var rx = data[i++];
	                    var ry = data[i++];
	                    var startAngle = data[i++];
	                    var endAngle = data[i++] + startAngle;
	                    i += 1;
	                    var anticlockwise = !data[i++];
	                    x1 = Math.cos(startAngle) * rx + cx;
	                    y1 = Math.sin(startAngle) * ry + cy;
	                    if (isFirst) {
	                        x0 = x1;
	                        y0 = y1;
	                        createNewSubpath(x0, y0);
	                    }
	                    else {
	                        addLine(xi, yi, x1, y1);
	                    }
	                    xi = Math.cos(endAngle) * rx + cx;
	                    yi = Math.sin(endAngle) * ry + cy;
	                    var step = (anticlockwise ? -1 : 1) * Math.PI / 2;
	                    for (var angle = startAngle; anticlockwise ? angle > endAngle : angle < endAngle; angle += step) {
	                        var nextAngle = anticlockwise ? Math.max(angle + step, endAngle)
	                            : Math.min(angle + step, endAngle);
	                        addArc(angle, nextAngle, cx, cy, rx, ry);
	                    }
	                    break;
	                case CMD$4.R:
	                    x0 = xi = data[i++];
	                    y0 = yi = data[i++];
	                    x1 = x0 + data[i++];
	                    y1 = y0 + data[i++];
	                    createNewSubpath(x1, y0);
	                    addLine(x1, y0, x1, y1);
	                    addLine(x1, y1, x0, y1);
	                    addLine(x0, y1, x0, y0);
	                    addLine(x0, y0, x1, y0);
	                    break;
	                case CMD$4.Z:
	                    currentSubpath && addLine(xi, yi, x0, y0);
	                    xi = x0;
	                    yi = y0;
	                    break;
	            }
	        }
	        if (currentSubpath && currentSubpath.length > 2) {
	            bezierArrayGroups.push(currentSubpath);
	        }
	        return bezierArrayGroups;
	    }
	    function adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, out, scale) {
	        if (aroundEqual(x0, x1) && aroundEqual(y0, y1) && aroundEqual(x2, x3) && aroundEqual(y2, y3)) {
	            out.push(x3, y3);
	            return;
	        }
	        var PIXEL_DISTANCE = 2 / scale;
	        var PIXEL_DISTANCE_SQR = PIXEL_DISTANCE * PIXEL_DISTANCE;
	        var dx = x3 - x0;
	        var dy = y3 - y0;
	        var d = Math.sqrt(dx * dx + dy * dy);
	        dx /= d;
	        dy /= d;
	        var dx1 = x1 - x0;
	        var dy1 = y1 - y0;
	        var dx2 = x2 - x3;
	        var dy2 = y2 - y3;
	        var cp1LenSqr = dx1 * dx1 + dy1 * dy1;
	        var cp2LenSqr = dx2 * dx2 + dy2 * dy2;
	        if (cp1LenSqr < PIXEL_DISTANCE_SQR && cp2LenSqr < PIXEL_DISTANCE_SQR) {
	            out.push(x3, y3);
	            return;
	        }
	        var projLen1 = dx * dx1 + dy * dy1;
	        var projLen2 = -dx * dx2 - dy * dy2;
	        var d1Sqr = cp1LenSqr - projLen1 * projLen1;
	        var d2Sqr = cp2LenSqr - projLen2 * projLen2;
	        if (d1Sqr < PIXEL_DISTANCE_SQR && projLen1 >= 0
	            && d2Sqr < PIXEL_DISTANCE_SQR && projLen2 >= 0) {
	            out.push(x3, y3);
	            return;
	        }
	        var tmpSegX = [];
	        var tmpSegY = [];
	        cubicSubdivide(x0, x1, x2, x3, 0.5, tmpSegX);
	        cubicSubdivide(y0, y1, y2, y3, 0.5, tmpSegY);
	        adpativeBezier(tmpSegX[0], tmpSegY[0], tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], tmpSegX[3], tmpSegY[3], out, scale);
	        adpativeBezier(tmpSegX[4], tmpSegY[4], tmpSegX[5], tmpSegY[5], tmpSegX[6], tmpSegY[6], tmpSegX[7], tmpSegY[7], out, scale);
	    }
	    function pathToPolygons(path, scale) {
	        var bezierArrayGroups = pathToBezierCurves(path);
	        var polygons = [];
	        scale = scale || 1;
	        for (var i = 0; i < bezierArrayGroups.length; i++) {
	            var beziers = bezierArrayGroups[i];
	            var polygon = [];
	            var x0 = beziers[0];
	            var y0 = beziers[1];
	            polygon.push(x0, y0);
	            for (var k = 2; k < beziers.length;) {
	                var x1 = beziers[k++];
	                var y1 = beziers[k++];
	                var x2 = beziers[k++];
	                var y2 = beziers[k++];
	                var x3 = beziers[k++];
	                var y3 = beziers[k++];
	                adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, polygon, scale);
	                x0 = x3;
	                y0 = y3;
	            }
	            polygons.push(polygon);
	        }
	        return polygons;
	    }
	
	    function getDividingGrids(dimSize, rowDim, count) {
	        var rowSize = dimSize[rowDim];
	        var columnSize = dimSize[1 - rowDim];
	        var ratio = Math.abs(rowSize / columnSize);
	        var rowCount = Math.ceil(Math.sqrt(ratio * count));
	        var columnCount = Math.floor(count / rowCount);
	        if (columnCount === 0) {
	            columnCount = 1;
	            rowCount = count;
	        }
	        var grids = [];
	        for (var i = 0; i < rowCount; i++) {
	            grids.push(columnCount);
	        }
	        var currentCount = rowCount * columnCount;
	        var remained = count - currentCount;
	        if (remained > 0) {
	            for (var i = 0; i < remained; i++) {
	                grids[i % rowCount] += 1;
	            }
	        }
	        return grids;
	    }
	    function divideSector(sectorShape, count, outShapes) {
	        var r0 = sectorShape.r0;
	        var r = sectorShape.r;
	        var startAngle = sectorShape.startAngle;
	        var endAngle = sectorShape.endAngle;
	        var angle = Math.abs(endAngle - startAngle);
	        var arcLen = angle * r;
	        var deltaR = r - r0;
	        var isAngleRow = arcLen > Math.abs(deltaR);
	        var grids = getDividingGrids([arcLen, deltaR], isAngleRow ? 0 : 1, count);
	        var rowSize = (isAngleRow ? angle : deltaR) / grids.length;
	        for (var row = 0; row < grids.length; row++) {
	            var columnSize = (isAngleRow ? deltaR : angle) / grids[row];
	            for (var column = 0; column < grids[row]; column++) {
	                var newShape = {};
	                if (isAngleRow) {
	                    newShape.startAngle = startAngle + rowSize * row;
	                    newShape.endAngle = startAngle + rowSize * (row + 1);
	                    newShape.r0 = r0 + columnSize * column;
	                    newShape.r = r0 + columnSize * (column + 1);
	                }
	                else {
	                    newShape.startAngle = startAngle + columnSize * column;
	                    newShape.endAngle = startAngle + columnSize * (column + 1);
	                    newShape.r0 = r0 + rowSize * row;
	                    newShape.r = r0 + rowSize * (row + 1);
	                }
	                newShape.clockwise = sectorShape.clockwise;
	                newShape.cx = sectorShape.cx;
	                newShape.cy = sectorShape.cy;
	                outShapes.push(newShape);
	            }
	        }
	    }
	    function divideRect(rectShape, count, outShapes) {
	        var width = rectShape.width;
	        var height = rectShape.height;
	        var isHorizontalRow = width > height;
	        var grids = getDividingGrids([width, height], isHorizontalRow ? 0 : 1, count);
	        var rowSizeDim = isHorizontalRow ? 'width' : 'height';
	        var columnSizeDim = isHorizontalRow ? 'height' : 'width';
	        var rowDim = isHorizontalRow ? 'x' : 'y';
	        var columnDim = isHorizontalRow ? 'y' : 'x';
	        var rowSize = rectShape[rowSizeDim] / grids.length;
	        for (var row = 0; row < grids.length; row++) {
	            var columnSize = rectShape[columnSizeDim] / grids[row];
	            for (var column = 0; column < grids[row]; column++) {
	                var newShape = {};
	                newShape[rowDim] = row * rowSize;
	                newShape[columnDim] = column * columnSize;
	                newShape[rowSizeDim] = rowSize;
	                newShape[columnSizeDim] = columnSize;
	                newShape.x += rectShape.x;
	                newShape.y += rectShape.y;
	                outShapes.push(newShape);
	            }
	        }
	    }
	    function crossProduct2d$1(x1, y1, x2, y2) {
	        return x1 * y2 - x2 * y1;
	    }
	    function lineLineIntersect$1(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
	        var mx = a2x - a1x;
	        var my = a2y - a1y;
	        var nx = b2x - b1x;
	        var ny = b2y - b1y;
	        var nmCrossProduct = crossProduct2d$1(nx, ny, mx, my);
	        if (Math.abs(nmCrossProduct) < 1e-6) {
	            return null;
	        }
	        var b1a1x = a1x - b1x;
	        var b1a1y = a1y - b1y;
	        var p = crossProduct2d$1(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
	        if (p < 0 || p > 1) {
	            return null;
	        }
	        return new Point(p * mx + a1x, p * my + a1y);
	    }
	    function projPtOnLine(pt, lineA, lineB) {
	        var dir = new Point();
	        Point.sub(dir, lineB, lineA);
	        dir.normalize();
	        var dir2 = new Point();
	        Point.sub(dir2, pt, lineA);
	        var len = dir2.dot(dir);
	        return len;
	    }
	    function addToPoly(poly, pt) {
	        var last = poly[poly.length - 1];
	        if (last && last[0] === pt[0] && last[1] === pt[1]) {
	            return;
	        }
	        poly.push(pt);
	    }
	    function splitPolygonByLine(points, lineA, lineB) {
	        var len = points.length;
	        var intersections = [];
	        for (var i = 0; i < len; i++) {
	            var p0 = points[i];
	            var p1 = points[(i + 1) % len];
	            var intersectionPt = lineLineIntersect$1(p0[0], p0[1], p1[0], p1[1], lineA.x, lineA.y, lineB.x, lineB.y);
	            if (intersectionPt) {
	                intersections.push({
	                    projPt: projPtOnLine(intersectionPt, lineA, lineB),
	                    pt: intersectionPt,
	                    idx: i
	                });
	            }
	        }
	        if (intersections.length < 2) {
	            return [{ points: points }, { points: points }];
	        }
	        intersections.sort(function (a, b) {
	            return a.projPt - b.projPt;
	        });
	        var splitPt0 = intersections[0];
	        var splitPt1 = intersections[intersections.length - 1];
	        if (splitPt1.idx < splitPt0.idx) {
	            var tmp = splitPt0;
	            splitPt0 = splitPt1;
	            splitPt1 = tmp;
	        }
	        var splitPt0Arr = [splitPt0.pt.x, splitPt0.pt.y];
	        var splitPt1Arr = [splitPt1.pt.x, splitPt1.pt.y];
	        var newPolyA = [splitPt0Arr];
	        var newPolyB = [splitPt1Arr];
	        for (var i = splitPt0.idx + 1; i <= splitPt1.idx; i++) {
	            addToPoly(newPolyA, points[i].slice());
	        }
	        addToPoly(newPolyA, splitPt1Arr);
	        addToPoly(newPolyA, splitPt0Arr);
	        for (var i = splitPt1.idx + 1; i <= splitPt0.idx + len; i++) {
	            addToPoly(newPolyB, points[i % len].slice());
	        }
	        addToPoly(newPolyB, splitPt0Arr);
	        addToPoly(newPolyB, splitPt1Arr);
	        return [{
	                points: newPolyA
	            }, {
	                points: newPolyB
	            }];
	    }
	    function binaryDividePolygon(polygonShape) {
	        var points = polygonShape.points;
	        var min = [];
	        var max = [];
	        fromPoints(points, min, max);
	        var boundingRect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	        var width = boundingRect.width;
	        var height = boundingRect.height;
	        var x = boundingRect.x;
	        var y = boundingRect.y;
	        var pt0 = new Point();
	        var pt1 = new Point();
	        if (width > height) {
	            pt0.x = pt1.x = x + width / 2;
	            pt0.y = y;
	            pt1.y = y + height;
	        }
	        else {
	            pt0.y = pt1.y = y + height / 2;
	            pt0.x = x;
	            pt1.x = x + width;
	        }
	        return splitPolygonByLine(points, pt0, pt1);
	    }
	    function binaryDivideRecursive(divider, shape, count, out) {
	        if (count === 1) {
	            out.push(shape);
	        }
	        else {
	            var mid = Math.floor(count / 2);
	            var sub = divider(shape);
	            binaryDivideRecursive(divider, sub[0], mid, out);
	            binaryDivideRecursive(divider, sub[1], count - mid, out);
	        }
	        return out;
	    }
	    function clone$4(path, count) {
	        var paths = [];
	        for (var i = 0; i < count; i++) {
	            paths.push(clonePath(path));
	        }
	        return paths;
	    }
	    function copyPathProps(source, target) {
	        target.setStyle(source.style);
	        target.z = source.z;
	        target.z2 = source.z2;
	        target.zlevel = source.zlevel;
	    }
	    function polygonConvert(points) {
	        var out = [];
	        for (var i = 0; i < points.length;) {
	            out.push([points[i++], points[i++]]);
	        }
	        return out;
	    }
	    function split(path, count) {
	        var outShapes = [];
	        var shape = path.shape;
	        var OutShapeCtor;
	        switch (path.type) {
	            case 'rect':
	                divideRect(shape, count, outShapes);
	                OutShapeCtor = Rect;
	                break;
	            case 'sector':
	                divideSector(shape, count, outShapes);
	                OutShapeCtor = Sector;
	                break;
	            case 'circle':
	                divideSector({
	                    r0: 0, r: shape.r, startAngle: 0, endAngle: Math.PI * 2,
	                    cx: shape.cx, cy: shape.cy
	                }, count, outShapes);
	                OutShapeCtor = Sector;
	                break;
	            default:
	                var m = path.getComputedTransform();
	                var scale = m ? Math.sqrt(Math.max(m[0] * m[0] + m[1] * m[1], m[2] * m[2] + m[3] * m[3])) : 1;
	                var polygons = map(pathToPolygons(path.getUpdatedPathProxy(), scale), function (poly) { return polygonConvert(poly); });
	                var polygonCount = polygons.length;
	                if (polygonCount === 0) {
	                    binaryDivideRecursive(binaryDividePolygon, {
	                        points: polygons[0]
	                    }, count, outShapes);
	                }
	                else if (polygonCount === count) {
	                    for (var i = 0; i < polygonCount; i++) {
	                        outShapes.push({
	                            points: polygons[i]
	                        });
	                    }
	                }
	                else {
	                    var totalArea_1 = 0;
	                    var items = map(polygons, function (poly) {
	                        var min = [];
	                        var max = [];
	                        fromPoints(poly, min, max);
	                        var area = (max[1] - min[1]) * (max[0] - min[0]);
	                        totalArea_1 += area;
	                        return { poly: poly, area: area };
	                    });
	                    items.sort(function (a, b) { return b.area - a.area; });
	                    var left = count;
	                    for (var i = 0; i < polygonCount; i++) {
	                        var item = items[i];
	                        if (left <= 0) {
	                            break;
	                        }
	                        var selfCount = i === polygonCount - 1
	                            ? left
	                            : Math.ceil(item.area / totalArea_1 * count);
	                        if (selfCount < 0) {
	                            continue;
	                        }
	                        binaryDivideRecursive(binaryDividePolygon, {
	                            points: item.poly
	                        }, selfCount, outShapes);
	                        left -= selfCount;
	                    }
	                }
	                OutShapeCtor = Polygon;
	                break;
	        }
	        if (!OutShapeCtor) {
	            return clone$4(path, count);
	        }
	        var out = [];
	        for (var i = 0; i < outShapes.length; i++) {
	            var subPath = new OutShapeCtor();
	            subPath.setShape(outShapes[i]);
	            copyPathProps(path, subPath);
	            out.push(subPath);
	        }
	        return out;
	    }
	
	    function alignSubpath(subpath1, subpath2) {
	        var len1 = subpath1.length;
	        var len2 = subpath2.length;
	        if (len1 === len2) {
	            return [subpath1, subpath2];
	        }
	        var tmpSegX = [];
	        var tmpSegY = [];
	        var shorterPath = len1 < len2 ? subpath1 : subpath2;
	        var shorterLen = Math.min(len1, len2);
	        var diff = Math.abs(len2 - len1) / 6;
	        var shorterBezierCount = (shorterLen - 2) / 6;
	        var eachCurveSubDivCount = Math.ceil(diff / shorterBezierCount) + 1;
	        var newSubpath = [shorterPath[0], shorterPath[1]];
	        var remained = diff;
	        for (var i = 2; i < shorterLen;) {
	            var x0 = shorterPath[i - 2];
	            var y0 = shorterPath[i - 1];
	            var x1 = shorterPath[i++];
	            var y1 = shorterPath[i++];
	            var x2 = shorterPath[i++];
	            var y2 = shorterPath[i++];
	            var x3 = shorterPath[i++];
	            var y3 = shorterPath[i++];
	            if (remained <= 0) {
	                newSubpath.push(x1, y1, x2, y2, x3, y3);
	                continue;
	            }
	            var actualSubDivCount = Math.min(remained, eachCurveSubDivCount - 1) + 1;
	            for (var k = 1; k <= actualSubDivCount; k++) {
	                var p = k / actualSubDivCount;
	                cubicSubdivide(x0, x1, x2, x3, p, tmpSegX);
	                cubicSubdivide(y0, y1, y2, y3, p, tmpSegY);
	                x0 = tmpSegX[3];
	                y0 = tmpSegY[3];
	                newSubpath.push(tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], x0, y0);
	                x1 = tmpSegX[5];
	                y1 = tmpSegY[5];
	                x2 = tmpSegX[6];
	                y2 = tmpSegY[6];
	            }
	            remained -= actualSubDivCount - 1;
	        }
	        return shorterPath === subpath1 ? [newSubpath, subpath2] : [subpath1, newSubpath];
	    }
	    function createSubpath(lastSubpathSubpath, otherSubpath) {
	        var len = lastSubpathSubpath.length;
	        var lastX = lastSubpathSubpath[len - 2];
	        var lastY = lastSubpathSubpath[len - 1];
	        var newSubpath = [];
	        for (var i = 0; i < otherSubpath.length;) {
	            newSubpath[i++] = lastX;
	            newSubpath[i++] = lastY;
	        }
	        return newSubpath;
	    }
	    function alignBezierCurves(array1, array2) {
	        var _a;
	        var lastSubpath1;
	        var lastSubpath2;
	        var newArray1 = [];
	        var newArray2 = [];
	        for (var i = 0; i < Math.max(array1.length, array2.length); i++) {
	            var subpath1 = array1[i];
	            var subpath2 = array2[i];
	            var newSubpath1 = void 0;
	            var newSubpath2 = void 0;
	            if (!subpath1) {
	                newSubpath1 = createSubpath(lastSubpath1 || subpath2, subpath2);
	                newSubpath2 = subpath2;
	            }
	            else if (!subpath2) {
	                newSubpath2 = createSubpath(lastSubpath2 || subpath1, subpath1);
	                newSubpath1 = subpath1;
	            }
	            else {
	                _a = alignSubpath(subpath1, subpath2), newSubpath1 = _a[0], newSubpath2 = _a[1];
	                lastSubpath1 = newSubpath1;
	                lastSubpath2 = newSubpath2;
	            }
	            newArray1.push(newSubpath1);
	            newArray2.push(newSubpath2);
	        }
	        return [newArray1, newArray2];
	    }
	    function centroid$1(array) {
	        var signedArea = 0;
	        var cx = 0;
	        var cy = 0;
	        var len = array.length;
	        for (var i = 0, j = len - 2; i < len; j = i, i += 2) {
	            var x0 = array[j];
	            var y0 = array[j + 1];
	            var x1 = array[i];
	            var y1 = array[i + 1];
	            var a = x0 * y1 - x1 * y0;
	            signedArea += a;
	            cx += (x0 + x1) * a;
	            cy += (y0 + y1) * a;
	        }
	        if (signedArea === 0) {
	            return [array[0] || 0, array[1] || 0];
	        }
	        return [cx / signedArea / 3, cy / signedArea / 3, signedArea];
	    }
	    function findBestRingOffset(fromSubBeziers, toSubBeziers, fromCp, toCp) {
	        var bezierCount = (fromSubBeziers.length - 2) / 6;
	        var bestScore = Infinity;
	        var bestOffset = 0;
	        var len = fromSubBeziers.length;
	        var len2 = len - 2;
	        for (var offset = 0; offset < bezierCount; offset++) {
	            var cursorOffset = offset * 6;
	            var score = 0;
	            for (var k = 0; k < len; k += 2) {
	                var idx = k === 0 ? cursorOffset : ((cursorOffset + k - 2) % len2 + 2);
	                var x0 = fromSubBeziers[idx] - fromCp[0];
	                var y0 = fromSubBeziers[idx + 1] - fromCp[1];
	                var x1 = toSubBeziers[k] - toCp[0];
	                var y1 = toSubBeziers[k + 1] - toCp[1];
	                var dx = x1 - x0;
	                var dy = y1 - y0;
	                score += dx * dx + dy * dy;
	            }
	            if (score < bestScore) {
	                bestScore = score;
	                bestOffset = offset;
	            }
	        }
	        return bestOffset;
	    }
	    function reverse(array) {
	        var newArr = [];
	        var len = array.length;
	        for (var i = 0; i < len; i += 2) {
	            newArr[i] = array[len - i - 2];
	            newArr[i + 1] = array[len - i - 1];
	        }
	        return newArr;
	    }
	    function findBestMorphingRotation(fromArr, toArr, searchAngleIteration, searchAngleRange) {
	        var result = [];
	        var fromNeedsReverse;
	        for (var i = 0; i < fromArr.length; i++) {
	            var fromSubpathBezier = fromArr[i];
	            var toSubpathBezier = toArr[i];
	            var fromCp = centroid$1(fromSubpathBezier);
	            var toCp = centroid$1(toSubpathBezier);
	            if (fromNeedsReverse == null) {
	                fromNeedsReverse = fromCp[2] < 0 !== toCp[2] < 0;
	            }
	            var newFromSubpathBezier = [];
	            var newToSubpathBezier = [];
	            var bestAngle = 0;
	            var bestScore = Infinity;
	            var tmpArr = [];
	            var len = fromSubpathBezier.length;
	            if (fromNeedsReverse) {
	                fromSubpathBezier = reverse(fromSubpathBezier);
	            }
	            var offset = findBestRingOffset(fromSubpathBezier, toSubpathBezier, fromCp, toCp) * 6;
	            var len2 = len - 2;
	            for (var k = 0; k < len2; k += 2) {
	                var idx = (offset + k) % len2 + 2;
	                newFromSubpathBezier[k + 2] = fromSubpathBezier[idx] - fromCp[0];
	                newFromSubpathBezier[k + 3] = fromSubpathBezier[idx + 1] - fromCp[1];
	            }
	            newFromSubpathBezier[0] = fromSubpathBezier[offset] - fromCp[0];
	            newFromSubpathBezier[1] = fromSubpathBezier[offset + 1] - fromCp[1];
	            if (searchAngleIteration > 0) {
	                var step = searchAngleRange / searchAngleIteration;
	                for (var angle = -searchAngleRange / 2; angle <= searchAngleRange / 2; angle += step) {
	                    var sa = Math.sin(angle);
	                    var ca = Math.cos(angle);
	                    var score = 0;
	                    for (var k = 0; k < fromSubpathBezier.length; k += 2) {
	                        var x0 = newFromSubpathBezier[k];
	                        var y0 = newFromSubpathBezier[k + 1];
	                        var x1 = toSubpathBezier[k] - toCp[0];
	                        var y1 = toSubpathBezier[k + 1] - toCp[1];
	                        var newX1 = x1 * ca - y1 * sa;
	                        var newY1 = x1 * sa + y1 * ca;
	                        tmpArr[k] = newX1;
	                        tmpArr[k + 1] = newY1;
	                        var dx = newX1 - x0;
	                        var dy = newY1 - y0;
	                        score += dx * dx + dy * dy;
	                    }
	                    if (score < bestScore) {
	                        bestScore = score;
	                        bestAngle = angle;
	                        for (var m = 0; m < tmpArr.length; m++) {
	                            newToSubpathBezier[m] = tmpArr[m];
	                        }
	                    }
	                }
	            }
	            else {
	                for (var i_1 = 0; i_1 < len; i_1 += 2) {
	                    newToSubpathBezier[i_1] = toSubpathBezier[i_1] - toCp[0];
	                    newToSubpathBezier[i_1 + 1] = toSubpathBezier[i_1 + 1] - toCp[1];
	                }
	            }
	            result.push({
	                from: newFromSubpathBezier,
	                to: newToSubpathBezier,
	                fromCp: fromCp,
	                toCp: toCp,
	                rotation: -bestAngle
	            });
	        }
	        return result;
	    }
	    function isCombineMorphing(path) {
	        return path.__isCombineMorphing;
	    }
	    var SAVED_METHOD_PREFIX = '__mOriginal_';
	    function saveAndModifyMethod(obj, methodName, modifiers) {
	        var savedMethodName = SAVED_METHOD_PREFIX + methodName;
	        var originalMethod = obj[savedMethodName] || obj[methodName];
	        if (!obj[savedMethodName]) {
	            obj[savedMethodName] = obj[methodName];
	        }
	        var replace = modifiers.replace;
	        var after = modifiers.after;
	        var before = modifiers.before;
	        obj[methodName] = function () {
	            var args = arguments;
	            var res;
	            before && before.apply(this, args);
	            if (replace) {
	                res = replace.apply(this, args);
	            }
	            else {
	                res = originalMethod.apply(this, args);
	            }
	            after && after.apply(this, args);
	            return res;
	        };
	    }
	    function restoreMethod(obj, methodName) {
	        var savedMethodName = SAVED_METHOD_PREFIX + methodName;
	        if (obj[savedMethodName]) {
	            obj[methodName] = obj[savedMethodName];
	            obj[savedMethodName] = null;
	        }
	    }
	    function applyTransformOnBeziers(bezierCurves, mm) {
	        for (var i = 0; i < bezierCurves.length; i++) {
	            var subBeziers = bezierCurves[i];
	            for (var k = 0; k < subBeziers.length;) {
	                var x = subBeziers[k];
	                var y = subBeziers[k + 1];
	                subBeziers[k++] = mm[0] * x + mm[2] * y + mm[4];
	                subBeziers[k++] = mm[1] * x + mm[3] * y + mm[5];
	            }
	        }
	    }
	    function prepareMorphPath(fromPath, toPath) {
	        var fromPathProxy = fromPath.getUpdatedPathProxy();
	        var toPathProxy = toPath.getUpdatedPathProxy();
	        var _a = alignBezierCurves(pathToBezierCurves(fromPathProxy), pathToBezierCurves(toPathProxy)), fromBezierCurves = _a[0], toBezierCurves = _a[1];
	        var fromPathTransform = fromPath.getComputedTransform();
	        var toPathTransform = toPath.getComputedTransform();
	        function updateIdentityTransform() {
	            this.transform = null;
	        }
	        fromPathTransform && applyTransformOnBeziers(fromBezierCurves, fromPathTransform);
	        toPathTransform && applyTransformOnBeziers(toBezierCurves, toPathTransform);
	        saveAndModifyMethod(toPath, 'updateTransform', { replace: updateIdentityTransform });
	        toPath.transform = null;
	        var morphingData = findBestMorphingRotation(fromBezierCurves, toBezierCurves, 10, Math.PI);
	        var tmpArr = [];
	        saveAndModifyMethod(toPath, 'buildPath', { replace: function (path) {
	                var t = toPath.__morphT;
	                var onet = 1 - t;
	                var newCp = [];
	                for (var i = 0; i < morphingData.length; i++) {
	                    var item = morphingData[i];
	                    var from = item.from;
	                    var to = item.to;
	                    var angle = item.rotation * t;
	                    var fromCp = item.fromCp;
	                    var toCp = item.toCp;
	                    var sa = Math.sin(angle);
	                    var ca = Math.cos(angle);
	                    lerp(newCp, fromCp, toCp, t);
	                    for (var m = 0; m < from.length; m += 2) {
	                        var x0_1 = from[m];
	                        var y0_1 = from[m + 1];
	                        var x1 = to[m];
	                        var y1 = to[m + 1];
	                        var x = x0_1 * onet + x1 * t;
	                        var y = y0_1 * onet + y1 * t;
	                        tmpArr[m] = (x * ca - y * sa) + newCp[0];
	                        tmpArr[m + 1] = (x * sa + y * ca) + newCp[1];
	                    }
	                    var x0 = tmpArr[0];
	                    var y0 = tmpArr[1];
	                    path.moveTo(x0, y0);
	                    for (var m = 2; m < from.length;) {
	                        var x1 = tmpArr[m++];
	                        var y1 = tmpArr[m++];
	                        var x2 = tmpArr[m++];
	                        var y2 = tmpArr[m++];
	                        var x3 = tmpArr[m++];
	                        var y3 = tmpArr[m++];
	                        if (x0 === x1 && y0 === y1 && x2 === x3 && y2 === y3) {
	                            path.lineTo(x3, y3);
	                        }
	                        else {
	                            path.bezierCurveTo(x1, y1, x2, y2, x3, y3);
	                        }
	                        x0 = x3;
	                        y0 = y3;
	                    }
	                }
	            } });
	    }
	    function morphPath(fromPath, toPath, animationOpts) {
	        if (!fromPath || !toPath) {
	            return toPath;
	        }
	        var oldDone = animationOpts.done;
	        var oldDuring = animationOpts.during;
	        prepareMorphPath(fromPath, toPath);
	        toPath.__morphT = 0;
	        function restoreToPath() {
	            restoreMethod(toPath, 'buildPath');
	            restoreMethod(toPath, 'updateTransform');
	            toPath.__morphT = -1;
	            toPath.createPathProxy();
	            toPath.dirtyShape();
	        }
	        toPath.animateTo({
	            __morphT: 1
	        }, defaults({
	            during: function (p) {
	                toPath.dirtyShape();
	                oldDuring && oldDuring(p);
	            },
	            done: function () {
	                restoreToPath();
	                oldDone && oldDone();
	            }
	        }, animationOpts));
	        return toPath;
	    }
	    function hilbert(x, y, minX, minY, maxX, maxY) {
	        var bits = 16;
	        x = (maxX === minX) ? 0 : Math.round(32767 * (x - minX) / (maxX - minX));
	        y = (maxY === minY) ? 0 : Math.round(32767 * (y - minY) / (maxY - minY));
	        var d = 0;
	        var tmp;
	        for (var s = (1 << bits) / 2; s > 0; s /= 2) {
	            var rx = 0;
	            var ry = 0;
	            if ((x & s) > 0) {
	                rx = 1;
	            }
	            if ((y & s) > 0) {
	                ry = 1;
	            }
	            d += s * s * ((3 * rx) ^ ry);
	            if (ry === 0) {
	                if (rx === 1) {
	                    x = s - 1 - x;
	                    y = s - 1 - y;
	                }
	                tmp = x;
	                x = y;
	                y = tmp;
	            }
	        }
	        return d;
	    }
	    function sortPaths(pathList) {
	        var xMin = Infinity;
	        var yMin = Infinity;
	        var xMax = -Infinity;
	        var yMax = -Infinity;
	        var cps = map(pathList, function (path) {
	            var rect = path.getBoundingRect();
	            var m = path.getComputedTransform();
	            var x = rect.x + rect.width / 2 + (m ? m[4] : 0);
	            var y = rect.y + rect.height / 2 + (m ? m[5] : 0);
	            xMin = Math.min(x, xMin);
	            yMin = Math.min(y, yMin);
	            xMax = Math.max(x, xMax);
	            yMax = Math.max(y, yMax);
	            return [x, y];
	        });
	        var items = map(cps, function (cp, idx) {
	            return {
	                cp: cp,
	                z: hilbert(cp[0], cp[1], xMin, yMin, xMax, yMax),
	                path: pathList[idx]
	            };
	        });
	        return items.sort(function (a, b) { return a.z - b.z; }).map(function (item) { return item.path; });
	    }
	    function defaultDividePath(param) {
	        return split(param.path, param.count);
	    }
	    function createEmptyReturn() {
	        return {
	            fromIndividuals: [],
	            toIndividuals: [],
	            count: 0
	        };
	    }
	    function combineMorph(fromList, toPath, animationOpts) {
	        var fromPathList = [];
	        function addFromPath(fromList) {
	            for (var i = 0; i < fromList.length; i++) {
	                var from = fromList[i];
	                if (isCombineMorphing(from)) {
	                    addFromPath(from.childrenRef());
	                }
	                else if (from instanceof Path) {
	                    fromPathList.push(from);
	                }
	            }
	        }
	        addFromPath(fromList);
	        var separateCount = fromPathList.length;
	        if (!separateCount) {
	            return createEmptyReturn();
	        }
	        var dividePath = animationOpts.dividePath || defaultDividePath;
	        var toSubPathList = dividePath({
	            path: toPath, count: separateCount
	        });
	        if (toSubPathList.length !== separateCount) {
	            console.error('Invalid morphing: unmatched splitted path');
	            return createEmptyReturn();
	        }
	        fromPathList = sortPaths(fromPathList);
	        toSubPathList = sortPaths(toSubPathList);
	        var oldDone = animationOpts.done;
	        var oldDuring = animationOpts.during;
	        var individualDelay = animationOpts.individualDelay;
	        var identityTransform = new Transformable();
	        for (var i = 0; i < separateCount; i++) {
	            var from = fromPathList[i];
	            var to = toSubPathList[i];
	            to.parent = toPath;
	            to.copyTransform(identityTransform);
	            if (!individualDelay) {
	                prepareMorphPath(from, to);
	            }
	        }
	        toPath.__isCombineMorphing = true;
	        toPath.childrenRef = function () {
	            return toSubPathList;
	        };
	        function addToSubPathListToZr(zr) {
	            for (var i = 0; i < toSubPathList.length; i++) {
	                toSubPathList[i].addSelfToZr(zr);
	            }
	        }
	        saveAndModifyMethod(toPath, 'addSelfToZr', {
	            after: function (zr) {
	                addToSubPathListToZr(zr);
	            }
	        });
	        saveAndModifyMethod(toPath, 'removeSelfFromZr', {
	            after: function (zr) {
	                for (var i = 0; i < toSubPathList.length; i++) {
	                    toSubPathList[i].removeSelfFromZr(zr);
	                }
	            }
	        });
	        function restoreToPath() {
	            toPath.__isCombineMorphing = false;
	            toPath.__morphT = -1;
	            toPath.childrenRef = null;
	            restoreMethod(toPath, 'addSelfToZr');
	            restoreMethod(toPath, 'removeSelfFromZr');
	        }
	        var toLen = toSubPathList.length;
	        if (individualDelay) {
	            var animating_1 = toLen;
	            var eachDone = function () {
	                animating_1--;
	                if (animating_1 === 0) {
	                    restoreToPath();
	                    oldDone && oldDone();
	                }
	            };
	            for (var i = 0; i < toLen; i++) {
	                var indivdualAnimationOpts = individualDelay ? defaults({
	                    delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toSubPathList[i]),
	                    done: eachDone
	                }, animationOpts) : animationOpts;
	                morphPath(fromPathList[i], toSubPathList[i], indivdualAnimationOpts);
	            }
	        }
	        else {
	            toPath.__morphT = 0;
	            toPath.animateTo({
	                __morphT: 1
	            }, defaults({
	                during: function (p) {
	                    for (var i = 0; i < toLen; i++) {
	                        var child = toSubPathList[i];
	                        child.__morphT = toPath.__morphT;
	                        child.dirtyShape();
	                    }
	                    oldDuring && oldDuring(p);
	                },
	                done: function () {
	                    restoreToPath();
	                    for (var i = 0; i < fromList.length; i++) {
	                        restoreMethod(fromList[i], 'updateTransform');
	                    }
	                    oldDone && oldDone();
	                }
	            }, animationOpts));
	        }
	        if (toPath.__zr) {
	            addToSubPathListToZr(toPath.__zr);
	        }
	        return {
	            fromIndividuals: fromPathList,
	            toIndividuals: toSubPathList,
	            count: toLen
	        };
	    }
	    function separateMorph(fromPath, toPathList, animationOpts) {
	        var toLen = toPathList.length;
	        var fromPathList = [];
	        var dividePath = animationOpts.dividePath || defaultDividePath;
	        function addFromPath(fromList) {
	            for (var i = 0; i < fromList.length; i++) {
	                var from = fromList[i];
	                if (isCombineMorphing(from)) {
	                    addFromPath(from.childrenRef());
	                }
	                else if (from instanceof Path) {
	                    fromPathList.push(from);
	                }
	            }
	        }
	        if (isCombineMorphing(fromPath)) {
	            addFromPath(fromPath.childrenRef());
	            var fromLen = fromPathList.length;
	            if (fromLen < toLen) {
	                var k = 0;
	                for (var i = fromLen; i < toLen; i++) {
	                    fromPathList.push(clonePath(fromPathList[k++ % fromLen]));
	                }
	            }
	            fromPathList.length = toLen;
	        }
	        else {
	            fromPathList = dividePath({ path: fromPath, count: toLen });
	            var fromPathTransform = fromPath.getComputedTransform();
	            for (var i = 0; i < fromPathList.length; i++) {
	                fromPathList[i].setLocalTransform(fromPathTransform);
	            }
	            if (fromPathList.length !== toLen) {
	                console.error('Invalid morphing: unmatched splitted path');
	                return createEmptyReturn();
	            }
	        }
	        fromPathList = sortPaths(fromPathList);
	        toPathList = sortPaths(toPathList);
	        var individualDelay = animationOpts.individualDelay;
	        for (var i = 0; i < toLen; i++) {
	            var indivdualAnimationOpts = individualDelay ? defaults({
	                delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toPathList[i])
	            }, animationOpts) : animationOpts;
	            morphPath(fromPathList[i], toPathList[i], indivdualAnimationOpts);
	        }
	        return {
	            fromIndividuals: fromPathList,
	            toIndividuals: toPathList,
	            count: toPathList.length
	        };
	    }
	
	    function isMultiple(elements) {
	      return isArray(elements[0]);
	    }
	
	    function prepareMorphBatches(one, many) {
	      var batches = [];
	      var batchCount = one.length;
	
	      for (var i = 0; i < batchCount; i++) {
	        batches.push({
	          one: one[i],
	          many: []
	        });
	      }
	
	      for (var i = 0; i < many.length; i++) {
	        var len = many[i].length;
	        var k = void 0;
	
	        for (k = 0; k < len; k++) {
	          batches[k % batchCount].many.push(many[i][k]);
	        }
	      }
	
	      var off = 0; // If one has more paths than each one of many. average them.
	
	      for (var i = batchCount - 1; i >= 0; i--) {
	        if (!batches[i].many.length) {
	          var moveFrom = batches[off].many;
	
	          if (moveFrom.length <= 1) {
	            // Not enough
	            // Start from the first one.
	            if (off) {
	              off = 0;
	            } else {
	              return batches;
	            }
	          }
	
	          var len = moveFrom.length;
	          var mid = Math.ceil(len / 2);
	          batches[i].many = moveFrom.slice(mid, len);
	          batches[off].many = moveFrom.slice(0, mid);
	          off++;
	        }
	      }
	
	      return batches;
	    }
	
	    var pathDividers = {
	      clone: function (params) {
	        var ret = []; // Fitting the alpha
	
	        var approxOpacity = 1 - Math.pow(1 - params.path.style.opacity, 1 / params.count);
	
	        for (var i = 0; i < params.count; i++) {
	          var cloned = clonePath(params.path);
	          cloned.setStyle('opacity', approxOpacity);
	          ret.push(cloned);
	        }
	
	        return ret;
	      },
	      // Use the default divider
	      split: null
	    };
	    function applyMorphAnimation(from, to, divideShape, seriesModel, dataIndex, animateOtherProps) {
	      if (!from.length || !to.length) {
	        return;
	      }
	
	      var updateAnimationCfg = getAnimationConfig('update', seriesModel, dataIndex);
	
	      if (!(updateAnimationCfg && updateAnimationCfg.duration > 0)) {
	        return;
	      }
	
	      var animationDelay = seriesModel.getModel('universalTransition').get('delay');
	      var animationCfg = Object.assign({
	        // Need to setToFinal so the further calculation based on the style can be correct.
	        // Like emphasis color.
	        setToFinal: true
	      }, updateAnimationCfg);
	      var many;
	      var one;
	
	      if (isMultiple(from)) {
	        // manyToOne
	        many = from;
	        one = to;
	      }
	
	      if (isMultiple(to)) {
	        // oneToMany
	        many = to;
	        one = from;
	      }
	
	      function morphOneBatch(batch, fromIsMany, animateIndex, animateCount, forceManyOne) {
	        var batchMany = batch.many;
	        var batchOne = batch.one;
	
	        if (batchMany.length === 1 && !forceManyOne) {
	          // Is one to one
	          var batchFrom = fromIsMany ? batchMany[0] : batchOne;
	          var batchTo = fromIsMany ? batchOne : batchMany[0];
	
	          if (isCombineMorphing(batchFrom)) {
	            // Keep doing combine animation.
	            morphOneBatch({
	              many: [batchFrom],
	              one: batchTo
	            }, true, animateIndex, animateCount, true);
	          } else {
	            var individualAnimationCfg = animationDelay ? defaults({
	              delay: animationDelay(animateIndex, animateCount)
	            }, animationCfg) : animationCfg;
	            morphPath(batchFrom, batchTo, individualAnimationCfg);
	            animateOtherProps(batchFrom, batchTo, batchFrom, batchTo, individualAnimationCfg);
	          }
	        } else {
	          var separateAnimationCfg = defaults({
	            dividePath: pathDividers[divideShape],
	            individualDelay: animationDelay && function (idx, count, fromPath, toPath) {
	              return animationDelay(idx + animateIndex, animateCount);
	            }
	          }, animationCfg);
	
	          var _a = fromIsMany ? combineMorph(batchMany, batchOne, separateAnimationCfg) : separateMorph(batchOne, batchMany, separateAnimationCfg),
	              fromIndividuals = _a.fromIndividuals,
	              toIndividuals = _a.toIndividuals;
	
	          var count = fromIndividuals.length;
	
	          for (var k = 0; k < count; k++) {
	            var individualAnimationCfg = animationDelay ? defaults({
	              delay: animationDelay(k, count)
	            }, animationCfg) : animationCfg;
	            animateOtherProps(fromIndividuals[k], toIndividuals[k], fromIsMany ? batchMany[k] : batch.one, fromIsMany ? batch.one : batchMany[k], individualAnimationCfg);
	          }
	        }
	      }
	
	      var fromIsMany = many ? many === from // Is one to one. If the path number not match. also needs do merge and separate morphing.
	      : from.length > to.length;
	      var morphBatches = many ? prepareMorphBatches(one, many) : prepareMorphBatches(fromIsMany ? to : from, [fromIsMany ? from : to]);
	      var animateCount = 0;
	
	      for (var i = 0; i < morphBatches.length; i++) {
	        animateCount += morphBatches[i].many.length;
	      }
	
	      var animateIndex = 0;
	
	      for (var i = 0; i < morphBatches.length; i++) {
	        morphOneBatch(morphBatches[i], fromIsMany, animateIndex, animateCount);
	        animateIndex += morphBatches[i].many.length;
	      }
	    }
	    function getPathList(elements) {
	      if (!elements) {
	        return [];
	      }
	
	      if (isArray(elements)) {
	        var pathList_1 = [];
	
	        for (var i = 0; i < elements.length; i++) {
	          pathList_1.push(getPathList(elements[i]));
	        }
	
	        return pathList_1;
	      }
	
	      var pathList = [];
	      elements.traverse(function (el) {
	        if (el instanceof Path && !el.disableMorphing && !el.invisible && !el.ignore) {
	          pathList.push(el);
	        }
	      });
	      return pathList;
	    }
	
	    var DATA_COUNT_THRESHOLD = 1e4;
	    var getUniversalTransitionGlobalStore = makeInner();
	
	    function getGroupIdDimension(data) {
	      var dimensions = data.dimensions;
	
	      for (var i = 0; i < dimensions.length; i++) {
	        var dimInfo = data.getDimensionInfo(dimensions[i]);
	
	        if (dimInfo && dimInfo.otherDims.itemGroupId === 0) {
	          return dimensions[i];
	        }
	      }
	    }
	
	    function flattenDataDiffItems(list) {
	      var items = [];
	      each(list, function (seriesInfo) {
	        var data = seriesInfo.data;
	
	        if (data.count() > DATA_COUNT_THRESHOLD) {
	          if (true) {
	            warn('Universal transition is disabled on large data > 10k.');
	          }
	
	          return;
	        }
	
	        var indices = data.getIndices();
	        var groupDim = getGroupIdDimension(data);
	
	        for (var dataIndex = 0; dataIndex < indices.length; dataIndex++) {
	          items.push({
	            dataGroupId: seriesInfo.dataGroupId,
	            data: data,
	            dim: seriesInfo.dim || groupDim,
	            divide: seriesInfo.divide,
	            dataIndex: dataIndex
	          });
	        }
	      });
	      return items;
	    }
	
	    function fadeInElement(newEl, newSeries, newIndex) {
	      newEl.traverse(function (el) {
	        if (el instanceof Path) {
	          // TODO use fade in animation for target element.
	          initProps(el, {
	            style: {
	              opacity: 0
	            }
	          }, newSeries, {
	            dataIndex: newIndex,
	            isFrom: true
	          });
	        }
	      });
	    }
	
	    function removeEl$1(el) {
	      if (el.parent) {
	        // Bake parent transform to element.
	        // So it can still have proper transform to transition after it's removed.
	        var computedTransform = el.getComputedTransform();
	        el.setLocalTransform(computedTransform);
	        el.parent.remove(el);
	      }
	    }
	
	    function stopAnimation(el) {
	      el.stopAnimation();
	
	      if (el.isGroup) {
	        el.traverse(function (child) {
	          child.stopAnimation();
	        });
	      }
	    }
	
	    function animateElementStyles(el, dataIndex, seriesModel) {
	      var animationConfig = getAnimationConfig('update', seriesModel, dataIndex);
	      animationConfig && el.traverse(function (child) {
	        if (child instanceof Displayable) {
	          var oldStyle = getOldStyle(child);
	
	          if (oldStyle) {
	            child.animateFrom({
	              style: oldStyle
	            }, animationConfig);
	          }
	        }
	      });
	    }
	
	    function isAllIdSame(oldDiffItems, newDiffItems) {
	      var len = oldDiffItems.length;
	
	      if (len !== newDiffItems.length) {
	        return false;
	      }
	
	      for (var i = 0; i < len; i++) {
	        var oldItem = oldDiffItems[i];
	        var newItem = newDiffItems[i];
	
	        if (oldItem.data.getId(oldItem.dataIndex) !== newItem.data.getId(newItem.dataIndex)) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    function transitionBetween(oldList, newList, api) {
	      var oldDiffItems = flattenDataDiffItems(oldList);
	      var newDiffItems = flattenDataDiffItems(newList);
	
	      function updateMorphingPathProps(from, to, rawFrom, rawTo, animationCfg) {
	        if (rawFrom || from) {
	          to.animateFrom({
	            style: rawFrom && rawFrom !== from ? // dividingMethod like clone may override the style(opacity)
	            // So extend it to raw style.
	            extend(extend({}, rawFrom.style), from.style) : from.style
	          }, animationCfg);
	        }
	      }
	
	      function findKeyDim(items) {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].dim) {
	            return items[i].dim;
	          }
	        }
	      }
	
	      var oldKeyDim = findKeyDim(oldDiffItems);
	      var newKeyDim = findKeyDim(newDiffItems);
	      var hasMorphAnimation = false;
	
	      function createKeyGetter(isOld, onlyGetId) {
	        return function (diffItem) {
	          var data = diffItem.data;
	          var dataIndex = diffItem.dataIndex; // TODO if specified dim
	
	          if (onlyGetId) {
	            return data.getId(dataIndex);
	          } // Use group id as transition key by default.
	          // So we can achieve multiple to multiple animation like drilldown / up naturally.
	          // If group id not exits. Use id instead. If so, only one to one transition will be applied.
	
	
	          var dataGroupId = diffItem.dataGroupId; // If specified key dimension(itemGroupId by default). Use this same dimension from other data.
	          // PENDING: If only use key dimension of newData.
	
	          var keyDim = isOld ? oldKeyDim || newKeyDim : newKeyDim || oldKeyDim;
	          var dimInfo = keyDim && data.getDimensionInfo(keyDim);
	          var dimOrdinalMeta = dimInfo && dimInfo.ordinalMeta;
	
	          if (dimInfo) {
	            // Get from encode.itemGroupId.
	            var key = data.get(dimInfo.name, dataIndex);
	
	            if (dimOrdinalMeta) {
	              return dimOrdinalMeta.categories[key] || key + '';
	            }
	
	            return key + '';
	          } // Get groupId from raw item. { groupId: '' }
	
	
	          var itemVal = data.getRawDataItem(dataIndex);
	
	          if (itemVal && itemVal.groupId) {
	            return itemVal.groupId + '';
	          }
	
	          return dataGroupId || data.getId(dataIndex);
	        };
	      } // Use id if it's very likely to be an one to one animation
	      // It's more robust than groupId
	      // TODO Check if key dimension is specified.
	
	
	      var useId = isAllIdSame(oldDiffItems, newDiffItems);
	      var isElementStillInChart = {};
	
	      if (!useId) {
	        // We may have different diff strategy with basicTransition if we use other dimension as key.
	        // If so, we can't simply check if oldEl is same with newEl. We need a map to check if oldEl is still being used in the new chart.
	        // We can't use the elements that already being morphed. Let it keep it's original basic transition.
	        for (var i = 0; i < newDiffItems.length; i++) {
	          var newItem = newDiffItems[i];
	          var el = newItem.data.getItemGraphicEl(newItem.dataIndex);
	
	          if (el) {
	            isElementStillInChart[el.id] = true;
	          }
	        }
	      }
	
	      function updateOneToOne(newIndex, oldIndex) {
	        var oldItem = oldDiffItems[oldIndex];
	        var newItem = newDiffItems[newIndex];
	        var newSeries = newItem.data.hostModel; // TODO Mark this elements is morphed and don't morph them anymore
	
	        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
	        var newEl = newItem.data.getItemGraphicEl(newItem.dataIndex); // Can't handle same elements.
	
	        if (oldEl === newEl) {
	          newEl && animateElementStyles(newEl, newItem.dataIndex, newSeries);
	          return;
	        }
	
	        if ( // We can't use the elements that already being morphed
	        oldEl && isElementStillInChart[oldEl.id]) {
	          return;
	        }
	
	        if (newEl) {
	          // TODO: If keep animating the group in case
	          // some of the elements don't want to be morphed.
	          // TODO Label?
	          stopAnimation(newEl);
	
	          if (oldEl) {
	            stopAnimation(oldEl); // If old element is doing leaving animation. stop it and remove it immediately.
	
	            removeEl$1(oldEl);
	            hasMorphAnimation = true;
	            applyMorphAnimation(getPathList(oldEl), getPathList(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
	          } else {
	            fadeInElement(newEl, newSeries, newIndex);
	          }
	        } // else keep oldEl leaving animation.
	
	      }
	
	      new DataDiffer(oldDiffItems, newDiffItems, createKeyGetter(true, useId), createKeyGetter(false, useId), null, 'multiple').update(updateOneToOne).updateManyToOne(function (newIndex, oldIndices) {
	        var newItem = newDiffItems[newIndex];
	        var newData = newItem.data;
	        var newSeries = newData.hostModel;
	        var newEl = newData.getItemGraphicEl(newItem.dataIndex);
	        var oldElsList = filter(map(oldIndices, function (idx) {
	          return oldDiffItems[idx].data.getItemGraphicEl(oldDiffItems[idx].dataIndex);
	        }), function (oldEl) {
	          return oldEl && oldEl !== newEl && !isElementStillInChart[oldEl.id];
	        });
	
	        if (newEl) {
	          stopAnimation(newEl);
	
	          if (oldElsList.length) {
	            // If old element is doing leaving animation. stop it and remove it immediately.
	            each(oldElsList, function (oldEl) {
	              stopAnimation(oldEl);
	              removeEl$1(oldEl);
	            });
	            hasMorphAnimation = true;
	            applyMorphAnimation(getPathList(oldElsList), getPathList(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
	          } else {
	            fadeInElement(newEl, newSeries, newItem.dataIndex);
	          }
	        } // else keep oldEl leaving animation.
	
	      }).updateOneToMany(function (newIndices, oldIndex) {
	        var oldItem = oldDiffItems[oldIndex];
	        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex); // We can't use the elements that already being morphed
	
	        if (oldEl && isElementStillInChart[oldEl.id]) {
	          return;
	        }
	
	        var newElsList = filter(map(newIndices, function (idx) {
	          return newDiffItems[idx].data.getItemGraphicEl(newDiffItems[idx].dataIndex);
	        }), function (el) {
	          return el && el !== oldEl;
	        });
	        var newSeris = newDiffItems[newIndices[0]].data.hostModel;
	
	        if (newElsList.length) {
	          each(newElsList, function (newEl) {
	            return stopAnimation(newEl);
	          });
	
	          if (oldEl) {
	            stopAnimation(oldEl); // If old element is doing leaving animation. stop it and remove it immediately.
	
	            removeEl$1(oldEl);
	            hasMorphAnimation = true;
	            applyMorphAnimation(getPathList(oldEl), getPathList(newElsList), oldItem.divide, // Use divide on old.
	            newSeris, newIndices[0], updateMorphingPathProps);
	          } else {
	            each(newElsList, function (newEl) {
	              return fadeInElement(newEl, newSeris, newIndices[0]);
	            });
	          }
	        } // else keep oldEl leaving animation.
	
	      }).updateManyToMany(function (newIndices, oldIndices) {
	        // If two data are same and both have groupId.
	        // Normally they should be diff by id.
	        new DataDiffer(oldIndices, newIndices, function (rawIdx) {
	          return oldDiffItems[rawIdx].data.getId(oldDiffItems[rawIdx].dataIndex);
	        }, function (rawIdx) {
	          return newDiffItems[rawIdx].data.getId(newDiffItems[rawIdx].dataIndex);
	        }).update(function (newIndex, oldIndex) {
	          // Use the original index
	          updateOneToOne(newIndices[newIndex], oldIndices[oldIndex]);
	        }).execute();
	      }).execute();
	
	      if (hasMorphAnimation) {
	        each(newList, function (_a) {
	          var data = _a.data;
	          var seriesModel = data.hostModel;
	          var view = seriesModel && api.getViewOfSeriesModel(seriesModel);
	          var animationCfg = getAnimationConfig('update', seriesModel, 0); // use 0 index.
	
	          if (view && seriesModel.isAnimationEnabled() && animationCfg && animationCfg.duration > 0) {
	            view.group.traverse(function (el) {
	              if (el instanceof Path && !el.animators.length) {
	                // We can't accept there still exists element that has no animation
	                // if universalTransition is enabled
	                el.animateFrom({
	                  style: {
	                    opacity: 0
	                  }
	                }, animationCfg);
	              }
	            });
	          }
	        });
	      }
	    }
	
	    function getSeriesTransitionKey(series) {
	      var seriesKey = series.getModel('universalTransition').get('seriesKey');
	
	      if (!seriesKey) {
	        // Use series id by default.
	        return series.id;
	      }
	
	      return seriesKey;
	    }
	
	    function convertArraySeriesKeyToString(seriesKey) {
	      if (isArray(seriesKey)) {
	        // Order independent.
	        return seriesKey.sort().join(',');
	      }
	
	      return seriesKey;
	    }
	
	    function getDivideShapeFromData(data) {
	      if (data.hostModel) {
	        return data.hostModel.getModel('universalTransition').get('divideShape');
	      }
	    }
	
	    function findTransitionSeriesBatches(globalStore, params) {
	      var updateBatches = createHashMap();
	      var oldDataMap = createHashMap(); // Map that only store key in array seriesKey.
	      // Which is used to query the old data when transition from one to multiple series.
	
	      var oldDataMapForSplit = createHashMap();
	      each(globalStore.oldSeries, function (series, idx) {
	        var oldDataGroupId = globalStore.oldDataGroupIds[idx];
	        var oldData = globalStore.oldData[idx];
	        var transitionKey = getSeriesTransitionKey(series);
	        var transitionKeyStr = convertArraySeriesKeyToString(transitionKey);
	        oldDataMap.set(transitionKeyStr, {
	          dataGroupId: oldDataGroupId,
	          data: oldData
	        });
	
	        if (isArray(transitionKey)) {
	          // Same key can't in different array seriesKey.
	          each(transitionKey, function (key) {
	            oldDataMapForSplit.set(key, {
	              key: transitionKeyStr,
	              dataGroupId: oldDataGroupId,
	              data: oldData
	            });
	          });
	        }
	      });
	
	      function checkTransitionSeriesKeyDuplicated(transitionKeyStr) {
	        if (updateBatches.get(transitionKeyStr)) {
	          warn("Duplicated seriesKey in universalTransition " + transitionKeyStr);
	        }
	      }
	
	      each(params.updatedSeries, function (series) {
	        if (series.isUniversalTransitionEnabled() && series.isAnimationEnabled()) {
	          var newDataGroupId = series.get('dataGroupId');
	          var newData = series.getData();
	          var transitionKey = getSeriesTransitionKey(series);
	          var transitionKeyStr = convertArraySeriesKeyToString(transitionKey); // Only transition between series with same id.
	
	          var oldData = oldDataMap.get(transitionKeyStr); // string transition key is the best match.
	
	          if (oldData) {
	            if (true) {
	              checkTransitionSeriesKeyDuplicated(transitionKeyStr);
	            } // TODO check if data is same?
	
	
	            updateBatches.set(transitionKeyStr, {
	              oldSeries: [{
	                dataGroupId: oldData.dataGroupId,
	                divide: getDivideShapeFromData(oldData.data),
	                data: oldData.data
	              }],
	              newSeries: [{
	                dataGroupId: newDataGroupId,
	                divide: getDivideShapeFromData(newData),
	                data: newData
	              }]
	            });
	          } else {
	            // Transition from multiple series.
	            if (isArray(transitionKey)) {
	              if (true) {
	                checkTransitionSeriesKeyDuplicated(transitionKeyStr);
	              }
	
	              var oldSeries_1 = [];
	              each(transitionKey, function (key) {
	                var oldData = oldDataMap.get(key);
	
	                if (oldData.data) {
	                  oldSeries_1.push({
	                    dataGroupId: oldData.dataGroupId,
	                    divide: getDivideShapeFromData(oldData.data),
	                    data: oldData.data
	                  });
	                }
	              });
	
	              if (oldSeries_1.length) {
	                updateBatches.set(transitionKeyStr, {
	                  oldSeries: oldSeries_1,
	                  newSeries: [{
	                    dataGroupId: newDataGroupId,
	                    data: newData,
	                    divide: getDivideShapeFromData(newData)
	                  }]
	                });
	              }
	            } else {
	              // Try transition to multiple series.
	              var oldData_1 = oldDataMapForSplit.get(transitionKey);
	
	              if (oldData_1) {
	                var batch = updateBatches.get(oldData_1.key);
	
	                if (!batch) {
	                  batch = {
	                    oldSeries: [{
	                      dataGroupId: oldData_1.dataGroupId,
	                      data: oldData_1.data,
	                      divide: getDivideShapeFromData(oldData_1.data)
	                    }],
	                    newSeries: []
	                  };
	                  updateBatches.set(oldData_1.key, batch);
	                }
	
	                batch.newSeries.push({
	                  dataGroupId: newDataGroupId,
	                  data: newData,
	                  divide: getDivideShapeFromData(newData)
	                });
	              }
	            }
	          }
	        }
	      });
	      return updateBatches;
	    }
	
	    function querySeries(series, finder) {
	      for (var i = 0; i < series.length; i++) {
	        var found = finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id;
	
	        if (found) {
	          return i;
	        }
	      }
	    }
	
	    function transitionSeriesFromOpt(transitionOpt, globalStore, params, api) {
	      var from = [];
	      var to = [];
	      each(normalizeToArray(transitionOpt.from), function (finder) {
	        var idx = querySeries(globalStore.oldSeries, finder);
	
	        if (idx >= 0) {
	          from.push({
	            dataGroupId: globalStore.oldDataGroupIds[idx],
	            data: globalStore.oldData[idx],
	            // TODO can specify divideShape in transition.
	            divide: getDivideShapeFromData(globalStore.oldData[idx]),
	            dim: finder.dimension
	          });
	        }
	      });
	      each(normalizeToArray(transitionOpt.to), function (finder) {
	        var idx = querySeries(params.updatedSeries, finder);
	
	        if (idx >= 0) {
	          var data = params.updatedSeries[idx].getData();
	          to.push({
	            dataGroupId: globalStore.oldDataGroupIds[idx],
	            data: data,
	            divide: getDivideShapeFromData(data),
	            dim: finder.dimension
	          });
	        }
	      });
	
	      if (from.length > 0 && to.length > 0) {
	        transitionBetween(from, to, api);
	      }
	    }
	
	    function installUniversalTransition(registers) {
	      registers.registerUpdateLifecycle('series:beforeupdate', function (ecMOdel, api, params) {
	        each(normalizeToArray(params.seriesTransition), function (transOpt) {
	          each(normalizeToArray(transOpt.to), function (finder) {
	            var series = params.updatedSeries;
	
	            for (var i = 0; i < series.length; i++) {
	              if (finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id) {
	                series[i][SERIES_UNIVERSAL_TRANSITION_PROP] = true;
	              }
	            }
	          });
	        });
	      });
	      registers.registerUpdateLifecycle('series:transition', function (ecModel, api, params) {
	        // TODO api provide an namespace that can save stuff per instance
	        var globalStore = getUniversalTransitionGlobalStore(api); // TODO multiple to multiple series.
	
	        if (globalStore.oldSeries && params.updatedSeries && params.optionChanged) {
	          // Use give transition config if its' give;
	          var transitionOpt = params.seriesTransition;
	
	          if (transitionOpt) {
	            each(normalizeToArray(transitionOpt), function (opt) {
	              transitionSeriesFromOpt(opt, globalStore, params, api);
	            });
	          } else {
	            // Else guess from series based on transition series key.
	            var updateBatches_1 = findTransitionSeriesBatches(globalStore, params);
	            each(updateBatches_1.keys(), function (key) {
	              var batch = updateBatches_1.get(key);
	              transitionBetween(batch.oldSeries, batch.newSeries, api);
	            });
	          } // Reset
	
	
	          each(params.updatedSeries, function (series) {
	            // Reset;
	            if (series[SERIES_UNIVERSAL_TRANSITION_PROP]) {
	              series[SERIES_UNIVERSAL_TRANSITION_PROP] = false;
	            }
	          });
	        } // Save all series of current update. Not only the updated one.
	
	
	        var allSeries = ecModel.getSeries();
	        var savedSeries = globalStore.oldSeries = [];
	        var savedDataGroupIds = globalStore.oldDataGroupIds = [];
	        var savedData = globalStore.oldData = [];
	
	        for (var i = 0; i < allSeries.length; i++) {
	          var data = allSeries[i].getData(); // Only save the data that can have transition.
	          // Avoid large data costing too much extra memory
	
	          if (data.count() < DATA_COUNT_THRESHOLD) {
	            savedSeries.push(allSeries[i]);
	            savedDataGroupIds.push(allSeries[i].get('dataGroupId'));
	            savedData.push(data);
	          }
	        }
	      });
	    }
	
	    // Render engines
	    // -----------------
	    // Render via Canvas.
	    // echarts.init(dom, null, { renderer: 'canvas' })
	
	    use([install$1]); // Render via SVG.
	    // echarts.init(dom, null, { renderer: 'svg' })
	
	    use([install]); // ----------------
	    // Charts (series)
	    // ----------------
	    // All of the series types, for example:
	    // chart.setOption({
	    //     series: [{
	    //         type: 'line' // or 'bar', 'pie', ...
	    //     }]
	    // });
	
	    use([install$2, install$3, install$4, install$6, install$8, install$a, install$b, install$c, install$d, install$e, install$f, install$h, install$i, install$j, install$k, install$l, install$m, install$n, install$o, install$p, install$q, install$r]); // -------------------
	    // Coordinate systems
	    // -------------------
	    // All of the axis modules have been included in the
	    // coordinate system module below, do not need to
	    // make extra import.
	    // `cartesian` coordinate system. For some historical
	    // reasons, it is named as grid, for example:
	    // chart.setOption({
	    //     grid: {...},
	    //     xAxis: {...},
	    //     yAxis: {...},
	    //     series: [{...}]
	    // });
	
	    use(install$t); // `polar` coordinate system, for example:
	    // chart.setOption({
	    //     polar: {...},
	    //     radiusAxis: {...},
	    //     angleAxis: {...},
	    //     series: [{
	    //         coordinateSystem: 'polar'
	    //     }]
	    // });
	
	    use(install$u); // `geo` coordinate system, for example:
	    // chart.setOption({
	    //     geo: {...},
	    //     series: [{
	    //         coordinateSystem: 'geo'
	    //     }]
	    // });
	
	    use(install$9); // `singleAxis` coordinate system (notice, it is a coordinate system
	    // with only one axis, work for chart like theme river), for example:
	    // chart.setOption({
	    //     singleAxis: {...}
	    //     series: [{type: 'themeRiver', ...}]
	    // });
	
	    use(install$v); // `parallel` coordinate system, only work for parallel series, for example:
	    // chart.setOption({
	    //     parallel: {...},
	    //     parallelAxis: [{...}, ...],
	    //     series: [{
	    //         type: 'parallel'
	    //     }]
	    // });
	
	    use(install$g); // `calendar` coordinate system. for example,
	    // chart.setOption({
	    //     calendar: {...},
	    //     series: [{
	    //         coordinateSystem: 'calendar'
	    //     }]
	    // );
	
	    use(install$w); // ------------------
	    // Other components
	    // ------------------
	    // `graphic` component, for example:
	    // chart.setOption({
	    //     graphic: {...}
	    // });
	
	    use(install$x); // `toolbox` component, for example:
	    // chart.setOption({
	    //     toolbox: {...}
	    // });
	
	    use(install$z); // `tooltip` component, for example:
	    // chart.setOption({
	    //     tooltip: {...}
	    // });
	
	    use(install$A); // `axisPointer` component, for example:
	    // chart.setOption({
	    //     tooltip: {axisPointer: {...}, ...}
	    // });
	    // Or
	    // chart.setOption({
	    //     axisPointer: {...}
	    // });
	
	    use(install$s); // `brush` component, for example:
	    // chart.setOption({
	    //     brush: {...}
	    // });
	    // Or
	    // chart.setOption({
	    //     tooltip: {feature: {brush: {...}}
	    // })
	
	    use(install$B); // `title` component, for example:
	    // chart.setOption({
	    //     title: {...}
	    // });
	
	    use(install$C); // `timeline` component, for example:
	    // chart.setOption({
	    //     timeline: {...}
	    // });
	
	    use(install$D); // `markPoint` component, for example:
	    // chart.setOption({
	    //     series: [{markPoint: {...}}]
	    // });
	
	    use(install$E); // `markLine` component, for example:
	    // chart.setOption({
	    //     series: [{markLine: {...}}]
	    // });
	
	    use(install$F); // `markArea` component, for example:
	    // chart.setOption({
	    //     series: [{markArea: {...}}]
	    // });
	
	    use(install$G); // `legend` component not scrollable. for example:
	    // chart.setOption({
	    //     legend: {...}
	    // });
	
	    use(install$J); // `dataZoom` component including both `dataZoomInside` and `dataZoomSlider`.
	
	    use(install$M); // `dataZoom` component providing drag, pinch, wheel behaviors
	    // inside coordinate system, for example:
	    // chart.setOption({
	    //     dataZoom: {type: 'inside'}
	    // });
	
	    use(install$K); // `dataZoom` component providing a slider bar, for example:
	    // chart.setOption({
	    //     dataZoom: {type: 'slider'}
	    // });
	
	    use(install$L); // `visualMap` component including both `visualMapContinuous` and `visualMapPiecewise`.
	
	    use(install$P); // `visualMap` component providing continuous bar, for example:
	    // chart.setOption({
	    //     visualMap: {type: 'continuous'}
	    // });
	
	    use(install$N); // `visualMap` component providing pieces bar, for example:
	    // chart.setOption({
	    //     visualMap: {type: 'piecewise'}
	    // });
	
	    use(install$O); // `aria` component providing aria, for example:
	    // chart.setOption({
	    //     aria: {...}
	    // });
	
	    use(install$Q); // dataset transform
	    // chart.setOption({
	    //     dataset: {
	    //          transform: []
	    //     }
	    // });
	
	    use(install$R);
	    use(install$S); // universal transition
	    // chart.setOption({
	    //     series: {
	    //         universalTransition: { enabled: true }
	    //     }
	    // })
	
	    use(installUniversalTransition); // label layout
	    // chart.setOption({
	    //     series: {
	    //         labelLayout: { hideOverlap: true }
	    //     }
	    // })
	
	    use(installLabelLayout);
	
	    exports.Axis = Axis;
	    exports.ChartView = ChartView;
	    exports.ComponentModel = ComponentModel;
	    exports.ComponentView = ComponentView;
	    exports.List = SeriesData;
	    exports.Model = Model;
	    exports.PRIORITY = PRIORITY;
	    exports.SeriesModel = SeriesModel;
	    exports.color = color;
	    exports.connect = connect;
	    exports.dataTool = dataTool;
	    exports.dependencies = dependencies;
	    exports.disConnect = disConnect;
	    exports.disconnect = disconnect;
	    exports.dispose = dispose$1;
	    exports.env = env;
	    exports.extendChartView = extendChartView;
	    exports.extendComponentModel = extendComponentModel;
	    exports.extendComponentView = extendComponentView;
	    exports.extendSeriesModel = extendSeriesModel;
	    exports.format = format$1;
	    exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
	    exports.getInstanceByDom = getInstanceByDom;
	    exports.getInstanceById = getInstanceById;
	    exports.getMap = getMap;
	    exports.graphic = graphic$1;
	    exports.helper = helper;
	    exports.init = init$1;
	    exports.innerDrawElementOnCanvas = brushSingle;
	    exports.matrix = matrix;
	    exports.number = number;
	    exports.parseGeoJSON = parseGeoJSON;
	    exports.parseGeoJson = parseGeoJSON;
	    exports.registerAction = registerAction;
	    exports.registerCoordinateSystem = registerCoordinateSystem;
	    exports.registerLayout = registerLayout;
	    exports.registerLoading = registerLoading;
	    exports.registerLocale = registerLocale;
	    exports.registerMap = registerMap;
	    exports.registerPostInit = registerPostInit;
	    exports.registerPostUpdate = registerPostUpdate;
	    exports.registerPreprocessor = registerPreprocessor;
	    exports.registerProcessor = registerProcessor;
	    exports.registerTheme = registerTheme;
	    exports.registerTransform = registerTransform;
	    exports.registerUpdateLifecycle = registerUpdateLifecycle;
	    exports.registerVisual = registerVisual;
	    exports.setCanvasCreator = setCanvasCreator;
	    exports.setPlatformAPI = setPlatformAPI;
	    exports.throttle = throttle;
	    exports.time = time;
	    exports.use = use;
	    exports.util = util$1;
	    exports.vector = vector;
	    exports.version = version$1;
	    exports.zrUtil = util;
	    exports.zrender = zrender;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=echarts.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2013).Buffer, (function() { return this; }()), __webpack_require__(170)))

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(1353);
	var each = __webpack_require__(512).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(1351);
	var Util = __webpack_require__(512);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(1352);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(1987);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(165),
	    root = __webpack_require__(123);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1735),
	    hashDelete = __webpack_require__(1736),
	    hashGet = __webpack_require__(1737),
	    hashHas = __webpack_require__(1738),
	    hashSet = __webpack_require__(1739);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1751),
	    mapCacheDelete = __webpack_require__(1752),
	    mapCacheGet = __webpack_require__(1753),
	    mapCacheHas = __webpack_require__(1754),
	    mapCacheSet = __webpack_require__(1755);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(165),
	    root = __webpack_require__(123);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(165),
	    root = __webpack_require__(123);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(256),
	    stackClear = __webpack_require__(1759),
	    stackDelete = __webpack_require__(1760),
	    stackGet = __webpack_require__(1761),
	    stackHas = __webpack_require__(1762),
	    stackSet = __webpack_require__(1763);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(123);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(165),
	    root = __webpack_require__(123);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 1707 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 1708 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(258),
	    keys = __webpack_require__(350);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(258),
	    keysIn = __webpack_require__(351);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(1704),
	    arrayEach = __webpack_require__(1707),
	    assignValue = __webpack_require__(524),
	    baseAssign = __webpack_require__(1709),
	    baseAssignIn = __webpack_require__(1710),
	    cloneBuffer = __webpack_require__(1721),
	    copyArray = __webpack_require__(1726),
	    copySymbols = __webpack_require__(1727),
	    copySymbolsIn = __webpack_require__(1728),
	    getAllKeys = __webpack_require__(1731),
	    getAllKeysIn = __webpack_require__(1732),
	    getTag = __webpack_require__(345),
	    initCloneArray = __webpack_require__(1740),
	    initCloneByTag = __webpack_require__(1741),
	    initCloneObject = __webpack_require__(1742),
	    isArray = __webpack_require__(348),
	    isBuffer = __webpack_require__(534),
	    isMap = __webpack_require__(1765),
	    isObject = __webpack_require__(212),
	    isSet = __webpack_require__(1766),
	    keys = __webpack_require__(350),
	    keysIn = __webpack_require__(351);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(212);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(211),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(345),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(535),
	    isMasked = __webpack_require__(1745),
	    isObject = __webpack_require__(212),
	    toSource = __webpack_require__(530);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(345),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(211),
	    isLength = __webpack_require__(536),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(346),
	    nativeKeys = __webpack_require__(1756);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(212),
	    isPrototype = __webpack_require__(346),
	    nativeKeysIn = __webpack_require__(1757);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(123);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(342);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 1723 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(340);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(342);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 1726 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(258),
	    getSymbols = __webpack_require__(344);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(258),
	    getSymbolsIn = __webpack_require__(528);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(123);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(165);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(526),
	    getSymbols = __webpack_require__(344),
	    keys = __webpack_require__(350);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(526),
	    getSymbolsIn = __webpack_require__(528),
	    keysIn = __webpack_require__(351);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(340);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1734 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(260);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1736 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(260);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(260);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(260);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1740 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(342),
	    cloneDataView = __webpack_require__(1722),
	    cloneRegExp = __webpack_require__(1723),
	    cloneSymbol = __webpack_require__(1724),
	    cloneTypedArray = __webpack_require__(1725);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1712),
	    getPrototype = __webpack_require__(343),
	    isPrototype = __webpack_require__(346);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 1743 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1729);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1746 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(257);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(257);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(257);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(257);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1700),
	    ListCache = __webpack_require__(256),
	    Map = __webpack_require__(339);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(259);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(259);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(259);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(259);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(529);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1757 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1758 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(256);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1761 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1762 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(256),
	    Map = __webpack_require__(339),
	    MapCache = __webpack_require__(1701);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1713),
	    isObjectLike = __webpack_require__(183);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1714),
	    baseUnary = __webpack_require__(341),
	    nodeUtil = __webpack_require__(347);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1716),
	    baseUnary = __webpack_require__(341),
	    nodeUtil = __webpack_require__(347);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1717),
	    baseUnary = __webpack_require__(341),
	    nodeUtil = __webpack_require__(347);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 1768 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 539,
		"./af.js": 539,
		"./ar": 546,
		"./ar-dz": 540,
		"./ar-dz.js": 540,
		"./ar-kw": 541,
		"./ar-kw.js": 541,
		"./ar-ly": 542,
		"./ar-ly.js": 542,
		"./ar-ma": 543,
		"./ar-ma.js": 543,
		"./ar-sa": 544,
		"./ar-sa.js": 544,
		"./ar-tn": 545,
		"./ar-tn.js": 545,
		"./ar.js": 546,
		"./az": 547,
		"./az.js": 547,
		"./be": 548,
		"./be.js": 548,
		"./bg": 549,
		"./bg.js": 549,
		"./bm": 550,
		"./bm.js": 550,
		"./bn": 551,
		"./bn.js": 551,
		"./bo": 552,
		"./bo.js": 552,
		"./br": 553,
		"./br.js": 553,
		"./bs": 554,
		"./bs.js": 554,
		"./ca": 555,
		"./ca.js": 555,
		"./cs": 556,
		"./cs.js": 556,
		"./cv": 557,
		"./cv.js": 557,
		"./cy": 558,
		"./cy.js": 558,
		"./da": 352,
		"./da.js": 352,
		"./de": 561,
		"./de-at": 559,
		"./de-at.js": 559,
		"./de-ch": 560,
		"./de-ch.js": 560,
		"./de.js": 561,
		"./dv": 562,
		"./dv.js": 562,
		"./el": 563,
		"./el.js": 563,
		"./en-au": 564,
		"./en-au.js": 564,
		"./en-ca": 565,
		"./en-ca.js": 565,
		"./en-gb": 353,
		"./en-gb.js": 353,
		"./en-ie": 566,
		"./en-ie.js": 566,
		"./en-nz": 567,
		"./en-nz.js": 567,
		"./eo": 568,
		"./eo.js": 568,
		"./es": 571,
		"./es-do": 569,
		"./es-do.js": 569,
		"./es-us": 570,
		"./es-us.js": 570,
		"./es.js": 571,
		"./et": 572,
		"./et.js": 572,
		"./eu": 573,
		"./eu.js": 573,
		"./fa": 574,
		"./fa.js": 574,
		"./fi": 575,
		"./fi.js": 575,
		"./fo": 576,
		"./fo.js": 576,
		"./fr": 579,
		"./fr-ca": 577,
		"./fr-ca.js": 577,
		"./fr-ch": 578,
		"./fr-ch.js": 578,
		"./fr.js": 579,
		"./fy": 580,
		"./fy.js": 580,
		"./gd": 581,
		"./gd.js": 581,
		"./gl": 582,
		"./gl.js": 582,
		"./gom-latn": 583,
		"./gom-latn.js": 583,
		"./gu": 584,
		"./gu.js": 584,
		"./he": 585,
		"./he.js": 585,
		"./hi": 586,
		"./hi.js": 586,
		"./hr": 587,
		"./hr.js": 587,
		"./hu": 588,
		"./hu.js": 588,
		"./hy-am": 589,
		"./hy-am.js": 589,
		"./id": 590,
		"./id.js": 590,
		"./is": 591,
		"./is.js": 591,
		"./it": 592,
		"./it.js": 592,
		"./ja": 593,
		"./ja.js": 593,
		"./jv": 594,
		"./jv.js": 594,
		"./ka": 595,
		"./ka.js": 595,
		"./kk": 596,
		"./kk.js": 596,
		"./km": 597,
		"./km.js": 597,
		"./kn": 598,
		"./kn.js": 598,
		"./ko": 599,
		"./ko.js": 599,
		"./ky": 600,
		"./ky.js": 600,
		"./lb": 601,
		"./lb.js": 601,
		"./lo": 602,
		"./lo.js": 602,
		"./lt": 603,
		"./lt.js": 603,
		"./lv": 604,
		"./lv.js": 604,
		"./me": 605,
		"./me.js": 605,
		"./mi": 606,
		"./mi.js": 606,
		"./mk": 607,
		"./mk.js": 607,
		"./ml": 608,
		"./ml.js": 608,
		"./mr": 609,
		"./mr.js": 609,
		"./ms": 611,
		"./ms-my": 610,
		"./ms-my.js": 610,
		"./ms.js": 611,
		"./my": 612,
		"./my.js": 612,
		"./nb": 613,
		"./nb.js": 613,
		"./ne": 614,
		"./ne.js": 614,
		"./nl": 616,
		"./nl-be": 615,
		"./nl-be.js": 615,
		"./nl.js": 616,
		"./nn": 354,
		"./nn.js": 354,
		"./pa-in": 617,
		"./pa-in.js": 617,
		"./pl": 618,
		"./pl.js": 618,
		"./pt": 620,
		"./pt-br": 619,
		"./pt-br.js": 619,
		"./pt.js": 620,
		"./ro": 621,
		"./ro.js": 621,
		"./ru": 622,
		"./ru.js": 622,
		"./sd": 623,
		"./sd.js": 623,
		"./se": 624,
		"./se.js": 624,
		"./si": 625,
		"./si.js": 625,
		"./sk": 626,
		"./sk.js": 626,
		"./sl": 627,
		"./sl.js": 627,
		"./sq": 628,
		"./sq.js": 628,
		"./sr": 630,
		"./sr-cyrl": 629,
		"./sr-cyrl.js": 629,
		"./sr.js": 630,
		"./ss": 631,
		"./ss.js": 631,
		"./sv": 355,
		"./sv.js": 355,
		"./sw": 632,
		"./sw.js": 632,
		"./ta": 633,
		"./ta.js": 633,
		"./te": 634,
		"./te.js": 634,
		"./tet": 635,
		"./tet.js": 635,
		"./th": 636,
		"./th.js": 636,
		"./tl-ph": 637,
		"./tl-ph.js": 637,
		"./tlh": 638,
		"./tlh.js": 638,
		"./tr": 639,
		"./tr.js": 639,
		"./tzl": 640,
		"./tzl.js": 640,
		"./tzm": 642,
		"./tzm-latn": 641,
		"./tzm-latn.js": 641,
		"./tzm.js": 642,
		"./uk": 643,
		"./uk.js": 643,
		"./ur": 644,
		"./ur.js": 644,
		"./uz": 646,
		"./uz-latn": 645,
		"./uz-latn.js": 645,
		"./uz.js": 646,
		"./vi": 647,
		"./vi.js": 647,
		"./x-pseudo": 648,
		"./x-pseudo.js": 648,
		"./yo": 649,
		"./yo.js": 649,
		"./zh-cn": 650,
		"./zh-cn.js": 650,
		"./zh-hk": 651,
		"./zh-hk.js": 651,
		"./zh-tw": 652,
		"./zh-tw.js": 652
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1769;


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(170)))

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1772);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1772 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1770)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(653),
		PropTypes = __webpack_require__(1780),
		createClass = __webpack_require__(184),
		moment = __webpack_require__(4),
		React = __webpack_require__(1),
		CalendarContainer = __webpack_require__(1784)
		;
	
	var TYPES = PropTypes;
	var Datetime = createClass({
		propTypes: {
			// value: TYPES.object | TYPES.string,
			// defaultValue: TYPES.object | TYPES.string,
			onFocus: TYPES.func,
			onBlur: TYPES.func,
			onChange: TYPES.func,
			onViewModeChange: TYPES.func,
			locale: TYPES.string,
			utc: TYPES.bool,
			input: TYPES.bool,
			// dateFormat: TYPES.string | TYPES.bool,
			// timeFormat: TYPES.string | TYPES.bool,
			inputProps: TYPES.object,
			timeConstraints: TYPES.object,
			viewMode: TYPES.oneOf(['years', 'months', 'days', 'time']),
			isValidDate: TYPES.func,
			open: TYPES.bool,
			strictParsing: TYPES.bool,
			closeOnSelect: TYPES.bool,
			closeOnTab: TYPES.bool
		},
	
		getDefaultProps: function() {
			var nof = function() {};
			return {
				className: '',
				defaultValue: '',
				inputProps: {},
				input: true,
				onFocus: nof,
				onBlur: nof,
				onChange: nof,
				onViewModeChange: nof,
				timeFormat: true,
				timeConstraints: {},
				dateFormat: true,
				strictParsing: true,
				closeOnSelect: false,
				closeOnTab: true,
				utc: false
			};
		},
	
		getInitialState: function() {
			var state = this.getStateFromProps( this.props );
	
			if ( state.open === undefined )
				state.open = !this.props.input;
	
			state.currentView = this.props.dateFormat ? (this.props.viewMode || state.updateOn || 'days') : 'time';
	
			return state;
		},
	
		getStateFromProps: function( props ) {
			var formats = this.getFormats( props ),
				date = props.value || props.defaultValue,
				selectedDate, viewDate, updateOn, inputValue
				;
	
			if ( date && typeof date === 'string' )
				selectedDate = this.localMoment( date, formats.datetime );
			else if ( date )
				selectedDate = this.localMoment( date );
	
			if ( selectedDate && !selectedDate.isValid() )
				selectedDate = null;
	
			viewDate = selectedDate ?
				selectedDate.clone().startOf('month') :
				this.localMoment().startOf('month')
			;
	
			updateOn = this.getUpdateOn(formats);
	
			if ( selectedDate )
				inputValue = selectedDate.format(formats.datetime);
			else if ( date.isValid && !date.isValid() )
				inputValue = '';
			else
				inputValue = date || '';
	
			return {
				updateOn: updateOn,
				inputFormat: formats.datetime,
				viewDate: viewDate,
				selectedDate: selectedDate,
				inputValue: inputValue,
				open: props.open
			};
		},
	
		getUpdateOn: function( formats ) {
			if ( formats.date.match(/[lLD]/) ) {
				return 'days';
			} else if ( formats.date.indexOf('M') !== -1 ) {
				return 'months';
			} else if ( formats.date.indexOf('Y') !== -1 ) {
				return 'years';
			}
	
			return 'days';
		},
	
		getFormats: function( props ) {
			var formats = {
					date: props.dateFormat || '',
					time: props.timeFormat || ''
				},
				locale = this.localMoment( props.date, null, props ).localeData()
				;
	
			if ( formats.date === true ) {
				formats.date = locale.longDateFormat('L');
			}
			else if ( this.getUpdateOn(formats) !== 'days' ) {
				formats.time = '';
			}
	
			if ( formats.time === true ) {
				formats.time = locale.longDateFormat('LT');
			}
	
			formats.datetime = formats.date && formats.time ?
				formats.date + ' ' + formats.time :
				formats.date || formats.time
			;
	
			return formats;
		},
	
		componentWillReceiveProps: function( nextProps ) {
			var formats = this.getFormats( nextProps ),
				updatedState = {}
			;
	
			if ( nextProps.value !== this.props.value ||
				formats.datetime !== this.getFormats( this.props ).datetime ) {
				updatedState = this.getStateFromProps( nextProps );
			}
	
			if ( updatedState.open === undefined ) {
				if ( typeof nextProps.open !== 'undefined' ) {
					updatedState.open = nextProps.open;
				} else if ( this.props.closeOnSelect && this.state.currentView !== 'time' ) {
					updatedState.open = false;
				} else {
					updatedState.open = this.state.open;
				}
			}
	
			if ( nextProps.viewMode !== this.props.viewMode ) {
				updatedState.currentView = nextProps.viewMode;
			}
	
			if ( nextProps.locale !== this.props.locale ) {
				if ( this.state.viewDate ) {
					var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
					updatedState.viewDate = updatedViewDate;
				}
				if ( this.state.selectedDate ) {
					var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
					updatedState.selectedDate = updatedSelectedDate;
					updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
				}
			}
	
			if ( nextProps.utc !== this.props.utc ) {
				if ( nextProps.utc ) {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().utc();
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().utc();
						updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
					}
				} else {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().local();
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().local();
						updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
					}
				}
			}
			//we should only show a valid date if we are provided a isValidDate function. Removed in 2.10.3
			/*if (this.props.isValidDate) {
				updatedState.viewDate = updatedState.viewDate || this.state.viewDate;
				while (!this.props.isValidDate(updatedState.viewDate)) {
					updatedState.viewDate = updatedState.viewDate.add(1, 'day');
				}
			}*/
			this.setState( updatedState );
		},
	
		onInputChange: function( e ) {
			var value = e.target === null ? e : e.target.value,
				localMoment = this.localMoment( value, this.state.inputFormat ),
				update = { inputValue: value }
				;
	
			if ( localMoment.isValid() && !this.props.value ) {
				update.selectedDate = localMoment;
				update.viewDate = localMoment.clone().startOf('month');
			} else {
				update.selectedDate = null;
			}
	
			return this.setState( update, function() {
				return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
			});
		},
	
		onInputKey: function( e ) {
			if ( e.which === 9 && this.props.closeOnTab ) {
				this.closeCalendar();
			}
		},
	
		showView: function( view ) {
			var me = this;
			return function() {
				me.state.currentView !== view && me.props.onViewModeChange( view );
				me.setState({ currentView: view });
			};
		},
	
		setDate: function( type ) {
			var me = this,
				nextViews = {
					month: 'days',
					year: 'months'
				}
			;
			return function( e ) {
				me.setState({
					viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
					currentView: nextViews[ type ]
				});
				me.props.onViewModeChange( nextViews[ type ] );
			};
		},
	
		addTime: function( amount, type, toSelected ) {
			return this.updateTime( 'add', amount, type, toSelected );
		},
	
		subtractTime: function( amount, type, toSelected ) {
			return this.updateTime( 'subtract', amount, type, toSelected );
		},
	
		updateTime: function( op, amount, type, toSelected ) {
			var me = this;
	
			return function() {
				var update = {},
					date = toSelected ? 'selectedDate' : 'viewDate'
				;
	
				update[ date ] = me.state[ date ].clone()[ op ]( amount, type );
	
				me.setState( update );
			};
		},
	
		allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
		setTime: function( type, value ) {
			var index = this.allowedSetTime.indexOf( type ) + 1,
				state = this.state,
				date = (state.selectedDate || state.viewDate).clone(),
				nextType
				;
	
			// It is needed to set all the time properties
			// to not to reset the time
			date[ type ]( value );
			for (; index < this.allowedSetTime.length; index++) {
				nextType = this.allowedSetTime[index];
				date[ nextType ]( date[nextType]() );
			}
	
			if ( !this.props.value ) {
				this.setState({
					selectedDate: date,
					inputValue: date.format( state.inputFormat )
				});
			}
			this.props.onChange( date );
		},
	
		updateSelectedDate: function( e, close ) {
			var target = e.target,
				modifier = 0,
				viewDate = this.state.viewDate,
				currentDate = this.state.selectedDate || viewDate,
				date
				;
	
			if (target.className.indexOf('rdtDay') !== -1) {
				if (target.className.indexOf('rdtNew') !== -1)
					modifier = 1;
				else if (target.className.indexOf('rdtOld') !== -1)
					modifier = -1;
	
				date = viewDate.clone()
					.month( viewDate.month() + modifier )
					.date( parseInt( target.getAttribute('data-value'), 10 ) );
			} else if (target.className.indexOf('rdtMonth') !== -1) {
				date = viewDate.clone()
					.month( parseInt( target.getAttribute('data-value'), 10 ) )
					.date( currentDate.date() );
			} else if (target.className.indexOf('rdtYear') !== -1) {
				date = viewDate.clone()
					.month( currentDate.month() )
					.date( currentDate.date() )
					.year( parseInt( target.getAttribute('data-value'), 10 ) );
			}
	
			date.hours( currentDate.hours() )
				.minutes( currentDate.minutes() )
				.seconds( currentDate.seconds() )
				.milliseconds( currentDate.milliseconds() );
	
			if ( !this.props.value ) {
				var open = !( this.props.closeOnSelect && close );
				if ( !open ) {
					this.props.onBlur( date );
				}
	
				this.setState({
					selectedDate: date,
					viewDate: date.clone().startOf('month'),
					inputValue: date.format( this.state.inputFormat ),
					open: open
				});
			} else {
				if ( this.props.closeOnSelect && close ) {
					this.closeCalendar();
				}
			}
	
			this.props.onChange( date );
		},
	
		openCalendar: function( e ) {
			if ( !this.state.open ) {
				this.setState({ open: true }, function() {
					this.props.onFocus( e );
				});
			}
		},
	
		closeCalendar: function() {
			this.setState({ open: false }, function () {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		},
	
		handleClickOutside: function() {
			if ( this.props.input && this.state.open && !this.props.open ) {
				this.setState({ open: false }, function() {
					this.props.onBlur( this.state.selectedDate || this.state.inputValue );
				});
			}
		},
	
		localMoment: function( date, format, props ) {
			props = props || this.props;
			var momentFn = props.utc ? moment.utc : moment;
			var m = momentFn( date, format, props.strictParsing );
			if ( props.locale )
				m.locale( props.locale );
			return m;
		},
	
		componentProps: {
			fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
			fromState: ['viewDate', 'selectedDate', 'updateOn'],
			fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
		},
	
		getComponentProps: function() {
			var me = this,
				formats = this.getFormats( this.props ),
				props = {dateFormat: formats.date, timeFormat: formats.time}
				;
	
			this.componentProps.fromProps.forEach( function( name ) {
				props[ name ] = me.props[ name ];
			});
			this.componentProps.fromState.forEach( function( name ) {
				props[ name ] = me.state[ name ];
			});
			this.componentProps.fromThis.forEach( function( name ) {
				props[ name ] = me[ name ];
			});
	
			return props;
		},
	
		render: function() {
			// TODO: Make a function or clean up this code,
			// logic right now is really hard to follow
			var className = 'rdt' + (this.props.className ?
	                  ( Array.isArray( this.props.className ) ?
	                  ' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
				children = [];
	
			if ( this.props.input ) {
				var finalInputProps = assign({
					type: 'text',
					className: 'form-control',
					onClick: this.openCalendar,
					onFocus: this.openCalendar,
					onChange: this.onInputChange,
					onKeyDown: this.onInputKey,
					value: this.state.inputValue,
				}, this.props.inputProps);
				if ( this.props.renderInput ) {
					children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar )) ];
				} else {
					children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
				}
			} else {
				className += ' rdtStatic';
			}
	
			if ( this.state.open )
				className += ' rdtOpen';
	
			return React.createElement( 'div', { className: className }, children.concat(
				React.createElement( 'div',
					{ key: 'dt', className: 'rdtPicker' },
					React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps(), onClickOutside: this.handleClickOutside })
				)
			));
		}
	});
	
	// Make moment accessible through the Datetime class
	Datetime.moment = moment;
	
	module.exports = Datetime;


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(1778);
	
	var emptyObject = __webpack_require__(1776);
	var _invariant = __webpack_require__(1777);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1782);
	var invariant = __webpack_require__(1783);
	var ReactPropTypesSecret = __webpack_require__(1781);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1779)();
	}


/***/ }),
/* 1781 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1782 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(184),
		DaysView = __webpack_require__(1785),
		MonthsView = __webpack_require__(1786),
		YearsView = __webpack_require__(1788),
		TimeView = __webpack_require__(1787)
		;
	
	var CalendarContainer = createClass({
		viewComponents: {
			days: DaysView,
			months: MonthsView,
			years: YearsView,
			time: TimeView
		},
	
		render: function() {
			return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
		}
	});
	
	module.exports = CalendarContainer;


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(184),
		moment = __webpack_require__(4),
		onClickOutside = __webpack_require__(261).default
		;
	
	var DateTimePickerDays = onClickOutside( createClass({
		render: function() {
			var footer = this.renderFooter(),
				date = this.props.viewDate,
				locale = date.localeData(),
				tableChildren
				;
	
			tableChildren = [
				React.createElement('thead', { key: 'th' }, [
					React.createElement('tr', { key: 'h' }, [
						React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
						React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
						React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
					]),
					React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
				]),
				React.createElement('tbody', { key: 'tb' }, this.renderDays())
			];
	
			if ( footer )
				tableChildren.push( footer );
	
			return React.createElement('div', { className: 'rdtDays' },
				React.createElement('table', {}, tableChildren )
			);
		},
	
		/**
		 * Get a list of the days of the week
		 * depending on the current locale
		 * @return {array} A list with the shortname of the days
		 */
		getDaysOfWeek: function( locale ) {
			var days = locale._weekdaysMin,
				first = locale.firstDayOfWeek(),
				dow = [],
				i = 0
				;
	
			days.forEach( function( day ) {
				dow[ (7 + ( i++ ) - first) % 7 ] = day;
			});
	
			return dow;
		},
	
		renderDays: function() {
			var date = this.props.viewDate,
				selected = this.props.selectedDate && this.props.selectedDate.clone(),
				prevMonth = date.clone().subtract( 1, 'months' ),
				currentYear = date.year(),
				currentMonth = date.month(),
				weeks = [],
				days = [],
				renderer = this.props.renderDay || this.renderDay,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, isDisabled, dayProps, currentDate
				;
	
			// Go to the last week of the previous month
			prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
			var lastDay = prevMonth.clone().add( 42, 'd' );
	
			while ( prevMonth.isBefore( lastDay ) ) {
				classes = 'rdtDay';
				currentDate = prevMonth.clone();
	
				if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
					classes += ' rdtOld';
				else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
					classes += ' rdtNew';
	
				if ( selected && prevMonth.isSame( selected, 'day' ) )
					classes += ' rdtActive';
	
				if ( prevMonth.isSame( moment(), 'day' ) )
					classes += ' rdtToday';
	
				isDisabled = !isValid( currentDate, selected );
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				dayProps = {
					key: prevMonth.format( 'M_D' ),
					'data-value': prevMonth.date(),
					className: classes
				};
	
				if ( !isDisabled )
					dayProps.onClick = this.updateSelectedDate;
	
				days.push( renderer( dayProps, currentDate, selected ) );
	
				if ( days.length === 7 ) {
					weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
					days = [];
				}
	
				prevMonth.add( 1, 'd' );
			}
	
			return weeks;
		},
	
		updateSelectedDate: function( event ) {
			this.props.updateSelectedDate( event, true );
		},
	
		renderDay: function( props, currentDate ) {
			return React.createElement('td',  props, currentDate.date() );
		},
	
		renderFooter: function() {
			if ( !this.props.timeFormat )
				return '';
	
			var date = this.props.selectedDate || this.props.viewDate;
	
			return React.createElement('tfoot', { key: 'tf'},
				React.createElement('tr', {},
					React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
				)
			);
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	
		handleClickOutside: function() {
			this.props.handleClickOutside();
		}
	}));
	
	module.exports = DateTimePickerDays;


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(184),
		onClickOutside = __webpack_require__(261).default
		;
	
	var DateTimePickerMonths = onClickOutside( createClass({
		render: function() {
			return React.createElement('div', { className: 'rdtMonths' }, [
				React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
					React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
					React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
				]))),
				React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
			]);
		},
	
		renderMonths: function() {
			var date = this.props.selectedDate,
				month = this.props.viewDate.month(),
				year = this.props.viewDate.year(),
				rows = [],
				i = 0,
				months = [],
				renderer = this.props.renderMonth || this.renderMonth,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
				// Date is irrelevant because we're only interested in month
				irrelevantDate = 1
				;
	
			while (i < 12) {
				classes = 'rdtMonth';
				currentMonth =
					this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });
	
				noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
				daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
					return i + 1;
				});
	
				validDay = daysInMonth.find(function( d ) {
					var day = currentMonth.clone().set( 'date', d );
					return isValid( day );
				});
	
				isDisabled = ( validDay === undefined );
	
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				if ( date && i === date.month() && year === date.year() )
					classes += ' rdtActive';
	
				props = {
					key: i,
					'data-value': i,
					className: classes
				};
	
				if ( !isDisabled )
					props.onClick = ( this.props.updateOn === 'months' ?
						this.updateSelectedMonth : this.props.setDate( 'month' ) );
	
				months.push( renderer( props, i, year, date && date.clone() ) );
	
				if ( months.length === 4 ) {
					rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
					months = [];
				}
	
				i++;
			}
	
			return rows;
		},
	
		updateSelectedMonth: function( event ) {
			this.props.updateSelectedDate( event );
		},
	
		renderMonth: function( props, month ) {
			var localMoment = this.props.viewDate;
			var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
			var strLength = 3;
			// Because some months are up to 5 characters long, we want to
			// use a fixed string length for consistency
			var monthStrFixedLength = monthStr.substring( 0, strLength );
			return React.createElement('td', props, capitalize( monthStrFixedLength ) );
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	
		handleClickOutside: function() {
			this.props.handleClickOutside();
		}
	}));
	
	function capitalize( str ) {
		return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
	}
	
	module.exports = DateTimePickerMonths;


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(184),
		assign = __webpack_require__(653),
		onClickOutside = __webpack_require__(261).default
		;
	
	var DateTimePickerTime = onClickOutside( createClass({
		getInitialState: function() {
			return this.calculateState( this.props );
		},
	
		calculateState: function( props ) {
			var date = props.selectedDate || props.viewDate,
				format = props.timeFormat,
				counters = []
				;
	
			if ( format.toLowerCase().indexOf('h') !== -1 ) {
				counters.push('hours');
				if ( format.indexOf('m') !== -1 ) {
					counters.push('minutes');
					if ( format.indexOf('s') !== -1 ) {
						counters.push('seconds');
					}
				}
			}
	
			var hours = date.format( 'H' );
			
			var daypart = false;
			if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
					daypart = ( hours >= 12 ) ? 'PM' : 'AM';
				} else {
					daypart = ( hours >= 12 ) ? 'pm' : 'am';
				}
			}
	
			return {
				hours: hours,
				minutes: date.format( 'mm' ),
				seconds: date.format( 'ss' ),
				milliseconds: date.format( 'SSS' ),
				daypart: daypart,
				counters: counters
			};
		},
	
		renderCounter: function( type ) {
			if ( type !== 'daypart' ) {
				var value = this.state[ type ];
				if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
					value = ( value - 1 ) % 12 + 1;
	
					if ( value === 0 ) {
						value = 12;
					}
				}
				return React.createElement('div', { key: type, className: 'rdtCounter' }, [
					React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
					React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
					React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
				]);
			}
			return '';
		},
	
		renderDayPart: function() {
			return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		},
	
		render: function() {
			var me = this,
				counters = []
			;
	
			this.state.counters.forEach( function( c ) {
				if ( counters.length )
					counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
				counters.push( me.renderCounter( c ) );
			});
	
			if ( this.state.daypart !== false ) {
				counters.push( me.renderDayPart() );
			}
	
			if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
				counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
				counters.push(
					React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
						React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
						)
					);
			}
	
			return React.createElement('div', { className: 'rdtTime' },
				React.createElement('table', {}, [
					this.renderHeader(),
					React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
						React.createElement('div', { className: 'rdtCounters' }, counters )
					)))
				])
			);
		},
	
		componentWillMount: function() {
			var me = this;
			me.timeConstraints = {
				hours: {
					min: 0,
					max: 23,
					step: 1
				},
				minutes: {
					min: 0,
					max: 59,
					step: 1
				},
				seconds: {
					min: 0,
					max: 59,
					step: 1
				},
				milliseconds: {
					min: 0,
					max: 999,
					step: 1
				}
			};
			['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
				assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
			});
			this.setState( this.calculateState( this.props ) );
		},
	
		componentWillReceiveProps: function( nextProps ) {
			this.setState( this.calculateState( nextProps ) );
		},
	
		updateMilli: function( e ) {
			var milli = parseInt( e.target.value, 10 );
			if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
				this.props.setTime( 'milliseconds', milli );
				this.setState( { milliseconds: milli } );
			}
		},
	
		renderHeader: function() {
			if ( !this.props.dateFormat )
				return null;
	
			var date = this.props.selectedDate || this.props.viewDate;
			return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
				React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
			));
		},
	
		onStartClicking: function( action, type ) {
			var me = this;
	
			return function() {
				var update = {};
				update[ type ] = me[ action ]( type );
				me.setState( update );
	
				me.timer = setTimeout( function() {
					me.increaseTimer = setInterval( function() {
						update[ type ] = me[ action ]( type );
						me.setState( update );
					}, 70);
				}, 500);
	
				me.mouseUpListener = function() {
					clearTimeout( me.timer );
					clearInterval( me.increaseTimer );
					me.props.setTime( type, me.state[ type ] );
					document.body.removeEventListener( 'mouseup', me.mouseUpListener );
				};
	
				document.body.addEventListener( 'mouseup', me.mouseUpListener );
			};
		},
	
		disableContextMenu: function( event ) {
			event.preventDefault();
			return false;
		},
	
		padValues: {
			hours: 1,
			minutes: 2,
			seconds: 2,
			milliseconds: 3
		},
	
		toggleDayPart: function( type ) { // type is always 'hours'
			var value = parseInt( this.state[ type ], 10) + 12;
			if ( value > this.timeConstraints[ type ].max )
				value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
			return this.pad( type, value );
		},
	
		increase: function( type ) {
			var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
			if ( value > this.timeConstraints[ type ].max )
				value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
			return this.pad( type, value );
		},
	
		decrease: function( type ) {
			var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
			if ( value < this.timeConstraints[ type ].min )
				value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
			return this.pad( type, value );
		},
	
		pad: function( type, value ) {
			var str = value + '';
			while ( str.length < this.padValues[ type ] )
				str = '0' + str;
			return str;
		},
	
		handleClickOutside: function() {
			this.props.handleClickOutside();
		}
	}));
	
	module.exports = DateTimePickerTime;


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(184),
		onClickOutside = __webpack_require__(261).default
		;
	
	var DateTimePickerYears = onClickOutside( createClass({
		render: function() {
			var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;
	
			return React.createElement('div', { className: 'rdtYears' }, [
				React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
					React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
					React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
				]))),
				React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
			]);
		},
	
		renderYears: function( year ) {
			var years = [],
				i = -1,
				rows = [],
				renderer = this.props.renderYear || this.renderYear,
				selectedDate = this.props.selectedDate,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
				// Month and date are irrelevant here because
				// we're only interested in the year
				irrelevantMonth = 0,
				irrelevantDate = 1
				;
	
			year--;
			while (i < 11) {
				classes = 'rdtYear';
				currentYear = this.props.viewDate.clone().set(
					{ year: year, month: irrelevantMonth, date: irrelevantDate } );
	
				// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
				// if ( i === -1 | i === 10 )
					// classes += ' rdtOld';
	
				noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
				daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
					return i + 1;
				});
	
				validDay = daysInYear.find(function( d ) {
					var day = currentYear.clone().dayOfYear( d );
					return isValid( day );
				});
	
				isDisabled = ( validDay === undefined );
	
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				if ( selectedDate && selectedDate.year() === year )
					classes += ' rdtActive';
	
				props = {
					key: year,
					'data-value': year,
					className: classes
				};
	
				if ( !isDisabled )
					props.onClick = ( this.props.updateOn === 'years' ?
						this.updateSelectedYear : this.props.setDate('year') );
	
				years.push( renderer( props, year, selectedDate && selectedDate.clone() ));
	
				if ( years.length === 4 ) {
					rows.push( React.createElement('tr', { key: i }, years ) );
					years = [];
				}
	
				year++;
				i++;
			}
	
			return rows;
		},
	
		updateSelectedYear: function( event ) {
			this.props.updateSelectedDate( event );
		},
	
		renderYear: function( props, year ) {
			return React.createElement('td',  props, year );
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	
		handleClickOutside: function() {
			this.props.handleClickOutside();
		}
	}));
	
	module.exports = DateTimePickerYears;


/***/ }),
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(661);
	var ReactServerRendering = __webpack_require__(1824);
	var ReactVersion = __webpack_require__(670);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ }),
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(48);
	
	var React = __webpack_require__(168);
	var ReactDOMContainerInfo = __webpack_require__(658);
	var ReactDefaultBatchingStrategy = __webpack_require__(660);
	var ReactInstrumentation = __webpack_require__(106);
	var ReactMarkupChecksum = __webpack_require__(666);
	var ReactReconciler = __webpack_require__(167);
	var ReactServerBatchingStrategy = __webpack_require__(1823);
	var ReactServerRenderingTransaction = __webpack_require__(669);
	var ReactUpdates = __webpack_require__(112);
	
	var emptyObject = __webpack_require__(373);
	var instantiateReactComponent = __webpack_require__(369);
	var invariant = __webpack_require__(42);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ }),
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {};

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * object.omit <https://github.com/jonschlinkert/object.omit>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(1868);
	
	module.exports = function omit(obj, props, fn) {
	  if (!isObject(obj)) return {};
	
	  if (typeof props === 'function') {
	    fn = props;
	    props = [];
	  }
	
	  if (typeof props === 'string') {
	    props = [props];
	  }
	
	  var isFunction = typeof fn === 'function';
	  var keys = Object.keys(obj);
	  var res = {};
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var val = obj[key];
	
	    if (!props || (props.indexOf(key) === -1 && (!isFunction || fn(val, key, obj)))) {
	      res[key] = val;
	    }
	  }
	  return res;
	};


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * is-extendable <https://github.com/jonschlinkert/is-extendable>
	 *
	 * Copyright (c) 2015-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isPlainObject = __webpack_require__(1869);
	
	module.exports = function isExtendable(val) {
	  return isPlainObject(val) || typeof val === 'function' || Array.isArray(val);
	};


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(1870);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ }),
/* 1870 */
/***/ (function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1874);
	var invariant = __webpack_require__(1875);
	var ReactPropTypesSecret = __webpack_require__(1873);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1871)();
	}


/***/ }),
/* 1873 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1874 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1880);
	var invariant = __webpack_require__(1881);
	var ReactPropTypesSecret = __webpack_require__(1879);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1877)();
	}


/***/ }),
/* 1879 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1880 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1878), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(module, require('prop-types'), require('react'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod, global.PropTypes, global.React);
	    global.ReactList = mod.exports;
	  }
	})(this, function (_module2, _propTypes, _react) {
	  'use strict';
	
	  var _module3 = _interopRequireDefault(_module2);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  var _react2 = _interopRequireDefault(_react);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var _class, _temp;
	
	  var CLIENT_SIZE_KEYS = { x: 'clientWidth', y: 'clientHeight' };
	  var CLIENT_START_KEYS = { x: 'clientTop', y: 'clientLeft' };
	  var INNER_SIZE_KEYS = { x: 'innerWidth', y: 'innerHeight' };
	  var OFFSET_SIZE_KEYS = { x: 'offsetWidth', y: 'offsetHeight' };
	  var OFFSET_START_KEYS = { x: 'offsetLeft', y: 'offsetTop' };
	  var OVERFLOW_KEYS = { x: 'overflowX', y: 'overflowY' };
	  var SCROLL_SIZE_KEYS = { x: 'scrollWidth', y: 'scrollHeight' };
	  var SCROLL_START_KEYS = { x: 'scrollLeft', y: 'scrollTop' };
	  var SIZE_KEYS = { x: 'width', y: 'height' };
	
	  var NOOP = function NOOP() {};
	
	  // If a browser doesn't support the `options` argument to
	  // add/removeEventListener, we need to check, otherwise we will
	  // accidentally set `capture` with a truthy value.
	  var PASSIVE = function () {
	    if (typeof window === 'undefined') return false;
	    var hasSupport = false;
	    try {
	      document.createElement('div').addEventListener('test', NOOP, {
	        get passive() {
	          hasSupport = true;
	          return false;
	        }
	      });
	    } catch (e) {}
	    return hasSupport;
	  }() ? { passive: true } : false;
	
	  var UNSTABLE_MESSAGE = 'ReactList failed to reach a stable state.';
	  var MAX_SYNC_UPDATES = 100;
	
	  var isEqualSubset = function isEqualSubset(a, b) {
	    for (var key in b) {
	      if (a[key] !== b[key]) return false;
	    }return true;
	  };
	
	  _module3.default.exports = (_temp = _class = function (_Component) {
	    _inherits(ReactList, _Component);
	
	    function ReactList(props) {
	      _classCallCheck(this, ReactList);
	
	      var _this = _possibleConstructorReturn(this, (ReactList.__proto__ || Object.getPrototypeOf(ReactList)).call(this, props));
	
	      var initialIndex = props.initialIndex;
	
	      var itemsPerRow = 1;
	
	      var _this$constrain = _this.constrain(initialIndex, 0, itemsPerRow, props),
	          from = _this$constrain.from,
	          size = _this$constrain.size;
	
	      _this.state = { from: from, size: size, itemsPerRow: itemsPerRow };
	      _this.cache = {};
	      _this.prevPrevState = {};
	      _this.unstable = false;
	      _this.updateCounter = 0;
	      return _this;
	    }
	
	    _createClass(ReactList, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(next) {
	        var _state = this.state,
	            from = _state.from,
	            size = _state.size,
	            itemsPerRow = _state.itemsPerRow;
	
	        this.maybeSetState(this.constrain(from, size, itemsPerRow, next), NOOP);
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.updateFrame = this.updateFrame.bind(this);
	        window.addEventListener('resize', this.updateFrame);
	        this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        var _this2 = this;
	
	        // If the list has reached an unstable state, prevent an infinite loop.
	        if (this.unstable) return;
	
	        if (++this.updateCounter > MAX_SYNC_UPDATES) {
	          this.unstable = true;
	          return console.error(UNSTABLE_MESSAGE);
	        }
	
	        if (!this.updateCounterTimeoutId) {
	          this.updateCounterTimeoutId = setTimeout(function () {
	            _this2.updateCounter = 0;
	            delete _this2.updateCounterTimeoutId;
	          }, 0);
	        }
	
	        this.updateFrame();
	      }
	    }, {
	      key: 'maybeSetState',
	      value: function maybeSetState(b, cb) {
	        if (isEqualSubset(this.state, b)) return cb();
	
	        this.setState(b, cb);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.updateFrame);
	        this.scrollParent.removeEventListener('scroll', this.updateFrame, PASSIVE);
	        this.scrollParent.removeEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: 'getOffset',
	      value: function getOffset(el) {
	        var axis = this.props.axis;
	
	        var offset = el[CLIENT_START_KEYS[axis]] || 0;
	        var offsetKey = OFFSET_START_KEYS[axis];
	        do {
	          offset += el[offsetKey] || 0;
	        } while (el = el.offsetParent);
	        return offset;
	      }
	    }, {
	      key: 'getEl',
	      value: function getEl() {
	        return this.el || this.items;
	      }
	    }, {
	      key: 'getScrollParent',
	      value: function getScrollParent() {
	        var _props = this.props,
	            axis = _props.axis,
	            scrollParentGetter = _props.scrollParentGetter;
	
	        if (scrollParentGetter) return scrollParentGetter();
	        var el = this.getEl();
	        var overflowKey = OVERFLOW_KEYS[axis];
	        while (el = el.parentElement) {
	          switch (window.getComputedStyle(el)[overflowKey]) {
	            case 'auto':case 'scroll':case 'overlay':
	              return el;
	          }
	        }
	        return window;
	      }
	    }, {
	      key: 'getScroll',
	      value: function getScroll() {
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	
	        var scrollKey = SCROLL_START_KEYS[axis];
	        var actual = scrollParent === window ?
	        // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
	        // always return document.documentElement[scrollKey] as 0, so take
	        // whichever has a value.
	        document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
	        var max = this.getScrollSize() - this.getViewportSize();
	        var scroll = Math.max(0, Math.min(actual, max));
	        var el = this.getEl();
	        return this.getOffset(scrollParent) + scroll - this.getOffset(el);
	      }
	    }, {
	      key: 'setScroll',
	      value: function setScroll(offset) {
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	
	        offset += this.getOffset(this.getEl());
	        if (scrollParent === window) return window.scrollTo(0, offset);
	
	        offset -= this.getOffset(this.scrollParent);
	        scrollParent[SCROLL_START_KEYS[axis]] = offset;
	      }
	    }, {
	      key: 'getViewportSize',
	      value: function getViewportSize() {
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	
	        return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
	      }
	    }, {
	      key: 'getScrollSize',
	      value: function getScrollSize() {
	        var scrollParent = this.scrollParent;
	        var _document = document,
	            body = _document.body,
	            documentElement = _document.documentElement;
	
	        var key = SCROLL_SIZE_KEYS[this.props.axis];
	        return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
	      }
	    }, {
	      key: 'hasDeterminateSize',
	      value: function hasDeterminateSize() {
	        var _props2 = this.props,
	            itemSizeGetter = _props2.itemSizeGetter,
	            type = _props2.type;
	
	        return type === 'uniform' || itemSizeGetter;
	      }
	    }, {
	      key: 'getStartAndEnd',
	      value: function getStartAndEnd() {
	        var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.threshold;
	
	        var scroll = this.getScroll();
	        var start = Math.max(0, scroll - threshold);
	        var end = scroll + this.getViewportSize() + threshold;
	        if (this.hasDeterminateSize()) {
	          end = Math.min(end, this.getSpaceBefore(this.props.length));
	        }
	        return { start: start, end: end };
	      }
	    }, {
	      key: 'getItemSizeAndItemsPerRow',
	      value: function getItemSizeAndItemsPerRow() {
	        var _props3 = this.props,
	            axis = _props3.axis,
	            useStaticSize = _props3.useStaticSize;
	        var _state2 = this.state,
	            itemSize = _state2.itemSize,
	            itemsPerRow = _state2.itemsPerRow;
	
	        if (useStaticSize && itemSize && itemsPerRow) {
	          return { itemSize: itemSize, itemsPerRow: itemsPerRow };
	        }
	
	        var itemEls = this.items.children;
	        if (!itemEls.length) return {};
	
	        var firstEl = itemEls[0];
	
	        // Firefox has a problem where it will return a *slightly* (less than
	        // thousandths of a pixel) different size for the same element between
	        // renders. This can cause an infinite render loop, so only change the
	        // itemSize when it is significantly different.
	        var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
	        var delta = Math.abs(firstElSize - itemSize);
	        if (isNaN(delta) || delta >= 1) itemSize = firstElSize;
	
	        if (!itemSize) return {};
	
	        var startKey = OFFSET_START_KEYS[axis];
	        var firstStart = firstEl[startKey];
	        itemsPerRow = 1;
	        for (var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow]) {
	          ++itemsPerRow;
	        }return { itemSize: itemSize, itemsPerRow: itemsPerRow };
	      }
	    }, {
	      key: 'updateFrame',
	      value: function updateFrame(cb) {
	        this.updateScrollParent();
	        if (typeof cb != 'function') cb = NOOP;
	        switch (this.props.type) {
	          case 'simple':
	            return this.updateSimpleFrame(cb);
	          case 'variable':
	            return this.updateVariableFrame(cb);
	          case 'uniform':
	            return this.updateUniformFrame(cb);
	        }
	      }
	    }, {
	      key: 'updateScrollParent',
	      value: function updateScrollParent() {
	        var prev = this.scrollParent;
	        this.scrollParent = this.getScrollParent();
	        if (prev === this.scrollParent) return;
	        if (prev) {
	          prev.removeEventListener('scroll', this.updateFrame);
	          prev.removeEventListener('mousewheel', NOOP);
	        }
	        this.scrollParent.addEventListener('scroll', this.updateFrame, PASSIVE);
	        this.scrollParent.addEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: 'updateSimpleFrame',
	      value: function updateSimpleFrame(cb) {
	        var _getStartAndEnd = this.getStartAndEnd(),
	            end = _getStartAndEnd.end;
	
	        var itemEls = this.items.children;
	        var elEnd = 0;
	
	        if (itemEls.length) {
	          var axis = this.props.axis;
	
	          var firstItemEl = itemEls[0];
	          var lastItemEl = itemEls[itemEls.length - 1];
	          elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
	        }
	
	        if (elEnd > end) return cb();
	
	        var _props4 = this.props,
	            pageSize = _props4.pageSize,
	            length = _props4.length;
	
	        var size = Math.min(this.state.size + pageSize, length);
	        this.maybeSetState({ size: size }, cb);
	      }
	    }, {
	      key: 'updateVariableFrame',
	      value: function updateVariableFrame(cb) {
	        if (!this.props.itemSizeGetter) this.cacheSizes();
	
	        var _getStartAndEnd2 = this.getStartAndEnd(),
	            start = _getStartAndEnd2.start,
	            end = _getStartAndEnd2.end;
	
	        var _props5 = this.props,
	            length = _props5.length,
	            pageSize = _props5.pageSize;
	
	        var space = 0;
	        var from = 0;
	        var size = 0;
	        var maxFrom = length - 1;
	
	        while (from < maxFrom) {
	          var itemSize = this.getSizeOf(from);
	          if (itemSize == null || space + itemSize > start) break;
	          space += itemSize;
	          ++from;
	        }
	
	        var maxSize = length - from;
	
	        while (size < maxSize && space < end) {
	          var _itemSize = this.getSizeOf(from + size);
	          if (_itemSize == null) {
	            size = Math.min(size + pageSize, maxSize);
	            break;
	          }
	          space += _itemSize;
	          ++size;
	        }
	
	        this.maybeSetState({ from: from, size: size }, cb);
	      }
	    }, {
	      key: 'updateUniformFrame',
	      value: function updateUniformFrame(cb) {
	        var _getItemSizeAndItemsP = this.getItemSizeAndItemsPerRow(),
	            itemSize = _getItemSizeAndItemsP.itemSize,
	            itemsPerRow = _getItemSizeAndItemsP.itemsPerRow;
	
	        if (!itemSize || !itemsPerRow) return cb();
	
	        var _getStartAndEnd3 = this.getStartAndEnd(),
	            start = _getStartAndEnd3.start,
	            end = _getStartAndEnd3.end;
	
	        var _constrain = this.constrain(Math.floor(start / itemSize) * itemsPerRow, (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow, itemsPerRow, this.props),
	            from = _constrain.from,
	            size = _constrain.size;
	
	        return this.maybeSetState({ itemsPerRow: itemsPerRow, from: from, itemSize: itemSize, size: size }, cb);
	      }
	    }, {
	      key: 'getSpaceBefore',
	      value: function getSpaceBefore(index) {
	        var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (cache[index] != null) return cache[index];
	
	        // Try the static itemSize.
	        var _state3 = this.state,
	            itemSize = _state3.itemSize,
	            itemsPerRow = _state3.itemsPerRow;
	
	        if (itemSize) {
	          return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
	        }
	
	        // Find the closest space to index there is a cached value for.
	        var from = index;
	        while (from > 0 && cache[--from] == null) {}
	
	        // Finally, accumulate sizes of items from - index.
	        var space = cache[from] || 0;
	        for (var i = from; i < index; ++i) {
	          cache[i] = space;
	          var _itemSize2 = this.getSizeOf(i);
	          if (_itemSize2 == null) break;
	          space += _itemSize2;
	        }
	
	        return cache[index] = space;
	      }
	    }, {
	      key: 'cacheSizes',
	      value: function cacheSizes() {
	        var cache = this.cache;
	        var from = this.state.from;
	
	        var itemEls = this.items.children;
	        var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
	        for (var i = 0, l = itemEls.length; i < l; ++i) {
	          cache[from + i] = itemEls[i][sizeKey];
	        }
	      }
	    }, {
	      key: 'getSizeOf',
	      value: function getSizeOf(index) {
	        var cache = this.cache,
	            items = this.items;
	        var _props6 = this.props,
	            axis = _props6.axis,
	            itemSizeGetter = _props6.itemSizeGetter,
	            itemSizeEstimator = _props6.itemSizeEstimator,
	            type = _props6.type;
	        var _state4 = this.state,
	            from = _state4.from,
	            itemSize = _state4.itemSize,
	            size = _state4.size;
	
	
	        // Try the static itemSize.
	        if (itemSize) return itemSize;
	
	        // Try the itemSizeGetter.
	        if (itemSizeGetter) return itemSizeGetter(index);
	
	        // Try the cache.
	        if (index in cache) return cache[index];
	
	        // Try the DOM.
	        if (type === 'simple' && index >= from && index < from + size && items) {
	          var itemEl = items.children[index - from];
	          if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
	        }
	
	        // Try the itemSizeEstimator.
	        if (itemSizeEstimator) return itemSizeEstimator(index, cache);
	      }
	    }, {
	      key: 'constrain',
	      value: function constrain(from, size, itemsPerRow, _ref) {
	        var length = _ref.length,
	            minSize = _ref.minSize,
	            type = _ref.type;
	
	        size = Math.max(size, minSize);
	        var mod = size % itemsPerRow;
	        if (mod) size += itemsPerRow - mod;
	        if (size > length) size = length;
	        from = type === 'simple' || !from ? 0 : Math.max(Math.min(from, length - size), 0);
	
	        if (mod = from % itemsPerRow) {
	          from -= mod;
	          size += mod;
	        }
	
	        return { from: from, size: size };
	      }
	    }, {
	      key: 'scrollTo',
	      value: function scrollTo(index) {
	        if (index != null) this.setScroll(this.getSpaceBefore(index));
	      }
	    }, {
	      key: 'scrollAround',
	      value: function scrollAround(index) {
	        var current = this.getScroll();
	        var bottom = this.getSpaceBefore(index);
	        var top = bottom - this.getViewportSize() + this.getSizeOf(index);
	        var min = Math.min(top, bottom);
	        var max = Math.max(top, bottom);
	        if (current <= min) return this.setScroll(min);
	        if (current > max) return this.setScroll(max);
	      }
	    }, {
	      key: 'getVisibleRange',
	      value: function getVisibleRange() {
	        var _state5 = this.state,
	            from = _state5.from,
	            size = _state5.size;
	
	        var _getStartAndEnd4 = this.getStartAndEnd(0),
	            start = _getStartAndEnd4.start,
	            end = _getStartAndEnd4.end;
	
	        var cache = {};
	        var first = void 0,
	            last = void 0;
	        for (var i = from; i < from + size; ++i) {
	          var itemStart = this.getSpaceBefore(i, cache);
	          var itemEnd = itemStart + this.getSizeOf(i);
	          if (first == null && itemEnd > start) first = i;
	          if (first != null && itemStart < end) last = i;
	        }
	        return [first, last];
	      }
	    }, {
	      key: 'renderItems',
	      value: function renderItems() {
	        var _this3 = this;
	
	        var _props7 = this.props,
	            itemRenderer = _props7.itemRenderer,
	            itemsRenderer = _props7.itemsRenderer;
	        var _state6 = this.state,
	            from = _state6.from,
	            size = _state6.size;
	
	        var items = [];
	        for (var i = 0; i < size; ++i) {
	          items.push(itemRenderer(from + i, i));
	        }return itemsRenderer(items, function (c) {
	          return _this3.items = c;
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props8 = this.props,
	            axis = _props8.axis,
	            length = _props8.length,
	            type = _props8.type,
	            useTranslate3d = _props8.useTranslate3d;
	        var _state7 = this.state,
	            from = _state7.from,
	            itemsPerRow = _state7.itemsPerRow;
	
	
	        var items = this.renderItems();
	        if (type === 'simple') return items;
	
	        var style = { position: 'relative' };
	        var cache = {};
	        var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
	        var size = this.getSpaceBefore(bottom, cache);
	        if (size) {
	          style[SIZE_KEYS[axis]] = size;
	          if (axis === 'x') style.overflowX = 'hidden';
	        }
	        var offset = this.getSpaceBefore(from, cache);
	        var x = axis === 'x' ? offset : 0;
	        var y = axis === 'y' ? offset : 0;
	        var transform = useTranslate3d ? 'translate3d(' + x + 'px, ' + y + 'px, 0)' : 'translate(' + x + 'px, ' + y + 'px)';
	        var listStyle = {
	          msTransform: transform,
	          WebkitTransform: transform,
	          transform: transform
	        };
	        return _react2.default.createElement(
	          'div',
	          _extends({ style: style }, { ref: function ref(c) {
	              return _this4.el = c;
	            } }),
	          _react2.default.createElement(
	            'div',
	            { style: listStyle },
	            items
	          )
	        );
	      }
	    }]);
	
	    return ReactList;
	  }(_react.Component), _class.displayName = 'ReactList', _class.propTypes = {
	    axis: _propTypes2.default.oneOf(['x', 'y']),
	    initialIndex: _propTypes2.default.number,
	    itemRenderer: _propTypes2.default.func,
	    itemSizeEstimator: _propTypes2.default.func,
	    itemSizeGetter: _propTypes2.default.func,
	    itemsRenderer: _propTypes2.default.func,
	    length: _propTypes2.default.number,
	    minSize: _propTypes2.default.number,
	    pageSize: _propTypes2.default.number,
	    scrollParentGetter: _propTypes2.default.func,
	    threshold: _propTypes2.default.number,
	    type: _propTypes2.default.oneOf(['simple', 'variable', 'uniform']),
	    useStaticSize: _propTypes2.default.bool,
	    useTranslate3d: _propTypes2.default.bool
	  }, _class.defaultProps = {
	    axis: 'y',
	    itemRenderer: function itemRenderer(index, key) {
	      return _react2.default.createElement(
	        'div',
	        { key: key },
	        index
	      );
	    },
	    itemsRenderer: function itemsRenderer(items, ref) {
	      return _react2.default.createElement(
	        'div',
	        { ref: ref },
	        items
	      );
	    },
	    length: 0,
	    minSize: 1,
	    pageSize: 10,
	    threshold: 100,
	    type: 'simple',
	    useStaticSize: false,
	    useTranslate3d: false
	  }, _temp);
	});


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(45);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(731);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _utils = __webpack_require__(1885);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-debugger: "warn" */
	
	
	/**
	 * Predefined constants
	 * @type {Object}
	 */
	var constants = {
	  orientation: {
	    horizontal: {
	      dimension: 'width',
	      direction: 'left',
	      reverseDirection: 'right',
	      coordinate: 'x'
	    },
	    vertical: {
	      dimension: 'height',
	      direction: 'top',
	      reverseDirection: 'bottom',
	      coordinate: 'y'
	    }
	  }
	};
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider(props, context) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props, context));
	
	    _this.handleFormat = function (value) {
	      var format = _this.props.format;
	
	      return format ? format(value) : value;
	    };
	
	    _this.handleUpdate = function () {
	      if (!_this.slider) {
	        // for shallow rendering
	        return;
	      }
	      var orientation = _this.props.orientation;
	
	      var dimension = (0, _utils.capitalize)(constants.orientation[orientation].dimension);
	      var sliderPos = _this.slider['offset' + dimension];
	      var handlePos = _this.handle['offset' + dimension];
	
	      _this.setState({
	        limit: sliderPos - handlePos,
	        grab: handlePos / 2
	      });
	    };
	
	    _this.handleStart = function (e) {
	      var onChangeStart = _this.props.onChangeStart;
	
	      document.addEventListener('mousemove', _this.handleDrag);
	      document.addEventListener('mouseup', _this.handleEnd);
	      _this.setState({
	        active: true
	      }, function () {
	        onChangeStart && onChangeStart(e);
	      });
	    };
	
	    _this.handleDrag = function (e) {
	      e.stopPropagation();
	      var onChange = _this.props.onChange;
	      var _e$target = e.target,
	          className = _e$target.className,
	          classList = _e$target.classList,
	          dataset = _e$target.dataset;
	
	      if (!onChange || className === 'rangeslider__labels') return;
	
	      var value = _this.position(e);
	
	      if (classList && classList.contains('rangeslider__label-item') && dataset.value) {
	        value = parseFloat(dataset.value);
	      }
	
	      onChange && onChange(value, e);
	    };
	
	    _this.handleEnd = function (e) {
	      var onChangeComplete = _this.props.onChangeComplete;
	
	      _this.setState({
	        active: false
	      }, function () {
	        onChangeComplete && onChangeComplete(e);
	      });
	      document.removeEventListener('mousemove', _this.handleDrag);
	      document.removeEventListener('mouseup', _this.handleEnd);
	    };
	
	    _this.handleKeyDown = function (e) {
	      e.preventDefault();
	      var keyCode = e.keyCode;
	      var _this$props = _this.props,
	          value = _this$props.value,
	          min = _this$props.min,
	          max = _this$props.max,
	          step = _this$props.step,
	          onChange = _this$props.onChange;
	
	      var sliderValue = void 0;
	
	      switch (keyCode) {
	        case 38:
	        case 39:
	          sliderValue = value + step > max ? max : value + step;
	          onChange && onChange(sliderValue, e);
	          break;
	        case 37:
	        case 40:
	          sliderValue = value - step < min ? min : value - step;
	          onChange && onChange(sliderValue, e);
	          break;
	      }
	    };
	
	    _this.getPositionFromValue = function (value) {
	      var limit = _this.state.limit;
	      var _this$props2 = _this.props,
	          min = _this$props2.min,
	          max = _this$props2.max;
	
	      var diffMaxMin = max - min;
	      var diffValMin = value - min;
	      var percentage = diffValMin / diffMaxMin;
	      var pos = Math.round(percentage * limit);
	
	      return pos;
	    };
	
	    _this.getValueFromPosition = function (pos) {
	      var limit = _this.state.limit;
	      var _this$props3 = _this.props,
	          orientation = _this$props3.orientation,
	          min = _this$props3.min,
	          max = _this$props3.max,
	          step = _this$props3.step;
	
	      var percentage = (0, _utils.clamp)(pos, 0, limit) / (limit || 1);
	      var baseVal = step * Math.round(percentage * (max - min) / step);
	      var value = orientation === 'horizontal' ? baseVal + min : max - baseVal;
	
	      return (0, _utils.clamp)(value, min, max);
	    };
	
	    _this.position = function (e) {
	      var grab = _this.state.grab;
	      var _this$props4 = _this.props,
	          orientation = _this$props4.orientation,
	          reverse = _this$props4.reverse;
	
	
	      var node = _this.slider;
	      var coordinateStyle = constants.orientation[orientation].coordinate;
	      var directionStyle = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
	      var clientCoordinateStyle = 'client' + (0, _utils.capitalize)(coordinateStyle);
	      var coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];
	      var direction = node.getBoundingClientRect()[directionStyle];
	      var pos = reverse ? direction - coordinate - grab : coordinate - direction - grab;
	      var value = _this.getValueFromPosition(pos);
	
	      return value;
	    };
	
	    _this.coordinates = function (pos) {
	      var _this$state = _this.state,
	          limit = _this$state.limit,
	          grab = _this$state.grab;
	      var orientation = _this.props.orientation;
	
	      var value = _this.getValueFromPosition(pos);
	      var position = _this.getPositionFromValue(value);
	      var handlePos = orientation === 'horizontal' ? position + grab : position;
	      var fillPos = orientation === 'horizontal' ? handlePos : limit - handlePos;
	
	      return {
	        fill: fillPos,
	        handle: handlePos,
	        label: handlePos
	      };
	    };
	
	    _this.renderLabels = function (labels) {
	      return _react2.default.createElement(
	        'ul',
	        {
	          ref: function ref(sl) {
	            _this.labels = sl;
	          },
	          className: (0, _classnames2.default)('rangeslider__labels')
	        },
	        labels
	      );
	    };
	
	    _this.state = {
	      active: false,
	      limit: 0,
	      grab: 0
	    };
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleUpdate();
	      var resizeObserver = new _resizeObserverPolyfill2.default(this.handleUpdate);
	      resizeObserver.observe(this.slider);
	    }
	
	    /**
	     * Format label/tooltip value
	     * @param  {Number} - value
	     * @return {Formatted Number}
	     */
	
	
	    /**
	     * Update slider state on change
	     * @return {void}
	     */
	
	
	    /**
	     * Attach event listeners to mousemove/mouseup events
	     * @return {void}
	     */
	
	
	    /**
	     * Handle drag/mousemove event
	     * @param  {Object} e - Event object
	     * @return {void}
	     */
	
	
	    /**
	     * Detach event listeners to mousemove/mouseup events
	     * @return {void}
	     */
	
	
	    /**
	     * Support for key events on the slider handle
	     * @param  {Object} e - Event object
	     * @return {void}
	     */
	
	
	    /**
	     * Calculate position of slider based on its value
	     * @param  {number} value - Current value of slider
	     * @return {position} pos - Calculated position of slider based on value
	     */
	
	
	    /**
	     * Translate position of slider to slider value
	     * @param  {number} pos - Current position/coordinates of slider
	     * @return {number} value - Slider value
	     */
	
	
	    /**
	     * Calculate position of slider based on value
	     * @param  {Object} e - Event object
	     * @return {number} value - Slider value
	     */
	
	
	    /**
	     * Grab coordinates of slider
	     * @param  {Object} pos - Position object
	     * @return {Object} - Slider fill/handle coordinates
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          orientation = _props.orientation,
	          className = _props.className,
	          tooltip = _props.tooltip,
	          reverse = _props.reverse,
	          labels = _props.labels,
	          min = _props.min,
	          max = _props.max,
	          handleLabel = _props.handleLabel;
	      var active = this.state.active;
	
	      var dimension = constants.orientation[orientation].dimension;
	      var direction = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
	      var position = this.getPositionFromValue(value);
	      var coords = this.coordinates(position);
	      var fillStyle = _defineProperty({}, dimension, coords.fill + 'px');
	      var handleStyle = _defineProperty({}, direction, coords.handle + 'px');
	      var showTooltip = tooltip && active;
	
	      var labelItems = [];
	      var labelKeys = Object.keys(labels);
	
	      if (labelKeys.length > 0) {
	        labelKeys = labelKeys.sort(function (a, b) {
	          return reverse ? a - b : b - a;
	        });
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = labelKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var key = _step.value;
	
	            var labelPosition = this.getPositionFromValue(key);
	            var labelCoords = this.coordinates(labelPosition);
	            var labelStyle = _defineProperty({}, direction, labelCoords.label + 'px');
	
	            labelItems.push(_react2.default.createElement(
	              'li',
	              {
	                key: key,
	                className: (0, _classnames2.default)('rangeslider__label-item'),
	                'data-value': key,
	                onMouseDown: this.handleDrag,
	                onTouchStart: this.handleStart,
	                onTouchEnd: this.handleEnd,
	                style: labelStyle
	              },
	              this.props.labels[key]
	            ));
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(s) {
	            _this2.slider = s;
	          },
	          className: (0, _classnames2.default)('rangeslider', 'rangeslider-' + orientation, { 'rangeslider-reverse': reverse }, className),
	          onMouseDown: this.handleDrag,
	          onMouseUp: this.handleEnd,
	          onTouchStart: this.handleStart,
	          onTouchEnd: this.handleEnd,
	          'aria-valuemin': min,
	          'aria-valuemax': max,
	          'aria-valuenow': value,
	          'aria-orientation': orientation
	        },
	        _react2.default.createElement('div', { className: 'rangeslider__fill', style: fillStyle }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(sh) {
	              _this2.handle = sh;
	            },
	            className: 'rangeslider__handle',
	            onMouseDown: this.handleStart,
	            onTouchMove: this.handleDrag,
	            onTouchEnd: this.handleEnd,
	            onKeyDown: this.handleKeyDown,
	            style: handleStyle,
	            tabIndex: 0
	          },
	          showTooltip ? _react2.default.createElement(
	            'div',
	            {
	              ref: function ref(st) {
	                _this2.tooltip = st;
	              },
	              className: 'rangeslider__handle-tooltip'
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.handleFormat(value)
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'rangeslider__handle-label' },
	            handleLabel
	          )
	        ),
	        labels ? this.renderLabels(labelItems) : null
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react.Component);
	
	Slider.propTypes = {
	  min: _propTypes2.default.number,
	  max: _propTypes2.default.number,
	  step: _propTypes2.default.number,
	  value: _propTypes2.default.number,
	  orientation: _propTypes2.default.string,
	  tooltip: _propTypes2.default.bool,
	  reverse: _propTypes2.default.bool,
	  labels: _propTypes2.default.object,
	  handleLabel: _propTypes2.default.string,
	  format: _propTypes2.default.func,
	  onChangeStart: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onChangeComplete: _propTypes2.default.func
	};
	Slider.defaultProps = {
	  min: 0,
	  max: 100,
	  step: 1,
	  value: 0,
	  orientation: 'horizontal',
	  tooltip: true,
	  reverse: false,
	  labels: {},
	  handleLabel: ''
	};
	exports.default = Slider;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Rangeslider = __webpack_require__(1883);
	
	var _Rangeslider2 = _interopRequireDefault(_Rangeslider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Rangeslider2.default;

/***/ }),
/* 1885 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.capitalize = capitalize;
	exports.clamp = clamp;
	/**
	 * Capitalize first letter of string
	 * @private
	 * @param  {string} - String
	 * @return {string} - String with first letter capitalized
	 */
	function capitalize(str) {
	  return str.charAt(0).toUpperCase() + str.substr(1);
	}
	
	/**
	 * Clamp position between a range
	 * @param  {number} - Value to be clamped
	 * @param  {number} - Minimum value in range
	 * @param  {number} - Maximum value in range
	 * @return {number} - Clamped value
	 */
	function clamp(value, min, max) {
	  return Math.min(Math.max(value, min), max);
	}

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(688);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(686);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(687);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(686);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(1888);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(1889);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(687);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(349);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(1890);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(1891);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(389);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1894);
	var invariant = __webpack_require__(1895);
	var ReactPropTypesSecret = __webpack_require__(1893);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1893 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1894 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(689);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(691);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(136);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(692);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(136);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(125);
	
	var _routerWarning = __webpack_require__(188);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(694);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(136);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(125);
	
	var _routerWarning = __webpack_require__(188);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(143);
	
	var _InternalPropTypes = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(136);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(125);
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(143);
	
	var _InternalPropTypes = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(136);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(125);
	
	var _createTransitionManager2 = __webpack_require__(698);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(217);
	
	var _RouterContext = __webpack_require__(378);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(143);
	
	var _RouterUtils = __webpack_require__(695);
	
	var _routerWarning = __webpack_require__(188);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	
	  /**
	   * A <Router> is a high-level API for automatically setting up
	   * a router that renders a <RouterContext> with all the props
	   * it needs each time the URL changes.
	   */
	};var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(375);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(378);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(188);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1921);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(697);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(187);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(375);
	
	var _PromiseUtils = __webpack_require__(693);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(187);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1922);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(697);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(187);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(267);
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(696);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(698);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(143);
	
	var _RouterUtils = __webpack_require__(695);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(375);
	
	var _PromiseUtils = __webpack_require__(693);
	
	var _PatternUtils = __webpack_require__(187);
	
	var _routerWarning = __webpack_require__(188);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(136);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(1927);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(376);
	
	var _PropTypes = __webpack_require__(377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(1917);
	
	var emptyObject = __webpack_require__(1915);
	var _invariant = __webpack_require__(1916);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 1917 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 1918 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(379);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(189);
	
	var _DOMUtils = __webpack_require__(268);
	
	var _DOMStateStorage = __webpack_require__(700);
	
	var _PathUtils = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(379);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(189);
	
	var _PathUtils = __webpack_require__(144);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(380);
	
	var _BrowserProtocol = __webpack_require__(379);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(1920);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(268);
	
	var _createHistory = __webpack_require__(381);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(380);
	
	var _DOMUtils = __webpack_require__(268);
	
	var _HashProtocol = __webpack_require__(1919);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(381);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(94);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(189);
	
	var _PathUtils = __webpack_require__(144);
	
	var _createHistory = __webpack_require__(381);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(267);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1926);
	var objectAssign = __webpack_require__(1925);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 1925 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 1926 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 1927 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1930);
	var invariant = __webpack_require__(1931);
	var ReactPropTypesSecret = __webpack_require__(1929);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1929 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1930 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _Async = __webpack_require__(703);
	
	var _Creatable = __webpack_require__(704);
	
	var _stateManager = _interopRequireDefault(__webpack_require__(270));
	
	var _Select = _interopRequireDefault(__webpack_require__(269));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectCreatable = (0, _Creatable.makeCreatableSelect)(_Select.default);
	var SelectCreatableState = (0, _stateManager.default)(SelectCreatable);
	
	var _default = (0, _Async.makeAsyncSelect)(SelectCreatableState);
	
	exports.default = _default;

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resultsAriaMessage = exports.optionFocusAriaMessage = exports.valueFocusAriaMessage = exports.valueEventAriaMessage = exports.instructionsAriaMessage = void 0;
	
	var instructionsAriaMessage = function instructionsAriaMessage(event) {
	  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isSearchable = context.isSearchable,
	      isMulti = context.isMulti,
	      label = context.label,
	      isDisabled = context.isDisabled;
	
	  switch (event) {
	    case 'menu':
	      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");
	
	    case 'input':
	      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
	
	    case 'value':
	      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
	  }
	};
	
	exports.instructionsAriaMessage = instructionsAriaMessage;
	
	var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
	  var value = context.value,
	      isDisabled = context.isDisabled;
	  if (!value) return;
	
	  switch (event) {
	    case 'deselect-option':
	    case 'pop-value':
	    case 'remove-value':
	      return "option ".concat(value, ", deselected.");
	
	    case 'select-option':
	      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
	  }
	};
	
	exports.valueEventAriaMessage = valueEventAriaMessage;
	
	var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
	  var focusedValue = _ref.focusedValue,
	      getOptionLabel = _ref.getOptionLabel,
	      selectValue = _ref.selectValue;
	  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
	};
	
	exports.valueFocusAriaMessage = valueFocusAriaMessage;
	
	var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
	  var focusedOption = _ref2.focusedOption,
	      getOptionLabel = _ref2.getOptionLabel,
	      options = _ref2.options;
	  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
	};
	
	exports.optionFocusAriaMessage = optionFocusAriaMessage;
	
	var resultsAriaMessage = function resultsAriaMessage(_ref3) {
	  var inputValue = _ref3.inputValue,
	      screenReaderMessage = _ref3.screenReaderMessage;
	  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
	};
	
	exports.resultsAriaMessage = resultsAriaMessage;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// strip transition props off before spreading onto select component
	// note we need to be explicit about innerRef for flow
	var AnimatedInput = function AnimatedInput(WrappedComponent) {
	  return function (_ref) {
	    var inProp = _ref.in,
	        onExited = _ref.onExited,
	        appear = _ref.appear,
	        enter = _ref.enter,
	        exit = _ref.exit,
	        props = _objectWithoutProperties(_ref, ["in", "onExited", "appear", "enter", "exit"]);
	
	    return _react.default.createElement(WrappedComponent, props);
	  };
	};
	
	var _default = AnimatedInput;
	exports.default = _default;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _transitions = __webpack_require__(383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// strip transition props off before spreading onto actual component
	var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
	  return function (_ref) {
	    var inProp = _ref.in,
	        onExited = _ref.onExited,
	        props = _objectWithoutProperties(_ref, ["in", "onExited"]);
	
	    return _react.default.createElement(_transitions.Collapse, {
	      in: inProp,
	      onExited: onExited
	    }, _react.default.createElement(WrappedComponent, _extends({
	      cropWithEllipsis: inProp
	    }, props)));
	  };
	};
	
	var _default = AnimatedMultiValue;
	exports.default = _default;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _transitions = __webpack_require__(383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// fade in when last multi-value removed, otherwise instant
	var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
	  return function (props) {
	    return _react.default.createElement(_transitions.Fade, _extends({
	      component: WrappedComponent,
	      duration: props.isMulti ? _transitions.collapseDuration : 1
	    }, props));
	  };
	};
	
	var _default = AnimatedPlaceholder;
	exports.default = _default;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _transitions = __webpack_require__(383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// instant fade; all transition-group children must be transitions
	var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
	  return function (props) {
	    return _react.default.createElement(_transitions.Fade, _extends({
	      component: WrappedComponent
	    }, props));
	  };
	};
	
	var _default = AnimatedSingleValue;
	exports.default = _default;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// make ValueContainer a transition group
	var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
	  return function (props) {
	    return _react.default.createElement(_reactTransitionGroup.TransitionGroup, _extends({
	      component: WrappedComponent
	    }, props));
	  };
	};
	
	var _default = AnimatedValueContainer;
	exports.default = _default;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ValueContainer = exports.SingleValue = exports.Placeholder = exports.MultiValue = exports.Input = void 0;
	
	var _memoizeOne = _interopRequireDefault(__webpack_require__(538));
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(715));
	
	var _index = __webpack_require__(385);
	
	var _Input = _interopRequireDefault(__webpack_require__(1934));
	
	var _MultiValue = _interopRequireDefault(__webpack_require__(1935));
	
	var _Placeholder = _interopRequireDefault(__webpack_require__(1936));
	
	var _SingleValue = _interopRequireDefault(__webpack_require__(1937));
	
	var _ValueContainer = _interopRequireDefault(__webpack_require__(1938));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var makeAnimated = function makeAnimated() {
	  var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var components = (0, _index.defaultComponents)({
	    components: externalComponents
	  });
	
	  var Input = components.Input,
	      MultiValue = components.MultiValue,
	      Placeholder = components.Placeholder,
	      SingleValue = components.SingleValue,
	      ValueContainer = components.ValueContainer,
	      rest = _objectWithoutProperties(components, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);
	
	  return _objectSpread({
	    Input: (0, _Input.default)(Input),
	    MultiValue: (0, _MultiValue.default)(MultiValue),
	    Placeholder: (0, _Placeholder.default)(Placeholder),
	    SingleValue: (0, _SingleValue.default)(SingleValue),
	    ValueContainer: (0, _ValueContainer.default)(ValueContainer)
	  }, rest);
	};
	
	var AnimatedComponents = makeAnimated();
	var Input = AnimatedComponents.Input;
	exports.Input = Input;
	var MultiValue = AnimatedComponents.MultiValue;
	exports.MultiValue = MultiValue;
	var Placeholder = AnimatedComponents.Placeholder;
	exports.Placeholder = Placeholder;
	var SingleValue = AnimatedComponents.SingleValue;
	exports.SingleValue = SingleValue;
	var ValueContainer = AnimatedComponents.ValueContainer;
	exports.ValueContainer = ValueContainer;
	
	var _default = (0, _memoizeOne.default)(makeAnimated, _reactFastCompare.default);
	
	exports.default = _default;

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isOptionDisabled = exports.getOptionValue = exports.getOptionLabel = exports.formatGroupLabel = void 0;
	
	var formatGroupLabel = function formatGroupLabel(group) {
	  return group.label;
	};
	
	exports.formatGroupLabel = formatGroupLabel;
	
	var getOptionLabel = function getOptionLabel(option) {
	  return option.label;
	};
	
	exports.getOptionLabel = getOptionLabel;
	
	var getOptionValue = function getOptionValue(option) {
	  return option.value;
	};
	
	exports.getOptionValue = getOptionValue;
	
	var isOptionDisabled = function isOptionDisabled(option) {
	  return !!option.isDisabled;
	};
	
	exports.isOptionDisabled = isOptionDisabled;

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripDiacritics = void 0;
	var diacritics = [{
	  base: 'A',
	  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
	}, {
	  base: 'AA',
	  letters: /[\uA732]/g
	}, {
	  base: 'AE',
	  letters: /[\u00C6\u01FC\u01E2]/g
	}, {
	  base: 'AO',
	  letters: /[\uA734]/g
	}, {
	  base: 'AU',
	  letters: /[\uA736]/g
	}, {
	  base: 'AV',
	  letters: /[\uA738\uA73A]/g
	}, {
	  base: 'AY',
	  letters: /[\uA73C]/g
	}, {
	  base: 'B',
	  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
	}, {
	  base: 'C',
	  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
	}, {
	  base: 'D',
	  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
	}, {
	  base: 'DZ',
	  letters: /[\u01F1\u01C4]/g
	}, {
	  base: 'Dz',
	  letters: /[\u01F2\u01C5]/g
	}, {
	  base: 'E',
	  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
	}, {
	  base: 'F',
	  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
	}, {
	  base: 'G',
	  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
	}, {
	  base: 'H',
	  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
	}, {
	  base: 'I',
	  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
	}, {
	  base: 'J',
	  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
	}, {
	  base: 'K',
	  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
	}, {
	  base: 'L',
	  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
	}, {
	  base: 'LJ',
	  letters: /[\u01C7]/g
	}, {
	  base: 'Lj',
	  letters: /[\u01C8]/g
	}, {
	  base: 'M',
	  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
	}, {
	  base: 'N',
	  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
	}, {
	  base: 'NJ',
	  letters: /[\u01CA]/g
	}, {
	  base: 'Nj',
	  letters: /[\u01CB]/g
	}, {
	  base: 'O',
	  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
	}, {
	  base: 'OI',
	  letters: /[\u01A2]/g
	}, {
	  base: 'OO',
	  letters: /[\uA74E]/g
	}, {
	  base: 'OU',
	  letters: /[\u0222]/g
	}, {
	  base: 'P',
	  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
	}, {
	  base: 'Q',
	  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
	}, {
	  base: 'R',
	  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
	}, {
	  base: 'S',
	  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
	}, {
	  base: 'T',
	  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
	}, {
	  base: 'TZ',
	  letters: /[\uA728]/g
	}, {
	  base: 'U',
	  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
	}, {
	  base: 'V',
	  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
	}, {
	  base: 'VY',
	  letters: /[\uA760]/g
	}, {
	  base: 'W',
	  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
	}, {
	  base: 'X',
	  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
	}, {
	  base: 'Y',
	  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
	}, {
	  base: 'Z',
	  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
	}, {
	  base: 'a',
	  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
	}, {
	  base: 'aa',
	  letters: /[\uA733]/g
	}, {
	  base: 'ae',
	  letters: /[\u00E6\u01FD\u01E3]/g
	}, {
	  base: 'ao',
	  letters: /[\uA735]/g
	}, {
	  base: 'au',
	  letters: /[\uA737]/g
	}, {
	  base: 'av',
	  letters: /[\uA739\uA73B]/g
	}, {
	  base: 'ay',
	  letters: /[\uA73D]/g
	}, {
	  base: 'b',
	  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
	}, {
	  base: 'c',
	  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
	}, {
	  base: 'd',
	  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
	}, {
	  base: 'dz',
	  letters: /[\u01F3\u01C6]/g
	}, {
	  base: 'e',
	  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
	}, {
	  base: 'f',
	  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
	}, {
	  base: 'g',
	  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
	}, {
	  base: 'h',
	  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
	}, {
	  base: 'hv',
	  letters: /[\u0195]/g
	}, {
	  base: 'i',
	  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
	}, {
	  base: 'j',
	  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
	}, {
	  base: 'k',
	  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
	}, {
	  base: 'l',
	  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
	}, {
	  base: 'lj',
	  letters: /[\u01C9]/g
	}, {
	  base: 'm',
	  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
	}, {
	  base: 'n',
	  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
	}, {
	  base: 'nj',
	  letters: /[\u01CC]/g
	}, {
	  base: 'o',
	  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
	}, {
	  base: 'oi',
	  letters: /[\u01A3]/g
	}, {
	  base: 'ou',
	  letters: /[\u0223]/g
	}, {
	  base: 'oo',
	  letters: /[\uA74F]/g
	}, {
	  base: 'p',
	  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
	}, {
	  base: 'q',
	  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
	}, {
	  base: 'r',
	  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
	}, {
	  base: 's',
	  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
	}, {
	  base: 't',
	  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
	}, {
	  base: 'tz',
	  letters: /[\uA729]/g
	}, {
	  base: 'u',
	  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
	}, {
	  base: 'v',
	  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
	}, {
	  base: 'vy',
	  letters: /[\uA761]/g
	}, {
	  base: 'w',
	  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
	}, {
	  base: 'x',
	  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
	}, {
	  base: 'y',
	  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
	}, {
	  base: 'z',
	  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
	}];
	
	var stripDiacritics = function stripDiacritics(str) {
	  for (var i = 0; i < diacritics.length; i++) {
	    str = str.replace(diacritics[i].letters, diacritics[i].base);
	  }
	
	  return str;
	};
	
	exports.stripDiacritics = stripDiacritics;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// Assistive text to describe visual elements. Hidden for sighted users.
	var A11yText = function A11yText(props) {
	  return _react.default.createElement("span", _extends({
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)({
	      label: 'a11yText',
	      zIndex: 9999,
	      border: 0,
	      clip: 'rect(1px, 1px, 1px, 1px)',
	      height: 1,
	      width: 1,
	      position: 'absolute',
	      overflow: 'hidden',
	      padding: 0,
	      whiteSpace: 'nowrap',
	      backgroundColor: 'red',
	      color: 'blue'
	    })
	  }, props));
	};
	
	var _default = A11yText;
	exports.default = _default;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var DummyInput =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DummyInput, _Component);
	
	  function DummyInput() {
	    _classCallCheck(this, DummyInput);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DummyInput).apply(this, arguments));
	  }
	
	  _createClass(DummyInput, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          inProp = _this$props.in,
	          out = _this$props.out,
	          onExited = _this$props.onExited,
	          appear = _this$props.appear,
	          enter = _this$props.enter,
	          exit = _this$props.exit,
	          innerRef = _this$props.innerRef,
	          emotion = _this$props.emotion,
	          props = _objectWithoutProperties(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
	
	      return _react.default.createElement("input", _extends({
	        ref: innerRef
	      }, props, {
	        className:
	        /*#__PURE__*/
	
	        /*#__PURE__*/
	        (0, _emotion.css)({
	          label: 'dummyInput',
	          // get rid of any default styles
	          background: 0,
	          border: 0,
	          fontSize: 'inherit',
	          outline: 0,
	          padding: 0,
	          // important! without `width` browsers won't allow focus
	          width: 1,
	          // remove cursor on desktop
	          color: 'transparent',
	          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
	          left: -100,
	          opacity: 0,
	          position: 'relative',
	          transform: 'scale(0)'
	        })
	      }));
	    }
	  }]);
	
	  return DummyInput;
	}(_react.Component);
	
	exports.default = DummyInput;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(100);
	
	var _NodeResolver = _interopRequireDefault(__webpack_require__(387));
	
	var _index = _interopRequireDefault(__webpack_require__(1947));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// NOTE:
	// We shouldn't need this after updating to React v16.3.0, which introduces:
	// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
	// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
	var ScrollBlock =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ScrollBlock, _PureComponent);
	
	  function ScrollBlock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollBlock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      touchScrollTarget: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      if (ref === _this.state.touchScrollTarget) return;
	
	      _this.setState({
	        touchScrollTarget: ref
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurSelectInput", function () {
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollBlock, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          isEnabled = _this$props.isEnabled;
	      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
	
	      if (!isEnabled) return children;
	      /*
	       * Div
	       * ------------------------------
	       * blocks scrolling on non-body elements behind the menu
	        * NodeResolver
	       * ------------------------------
	       * we need a reference to the scrollable element to "unlock" scroll on
	       * mobile devices
	        * ScrollLock
	       * ------------------------------
	       * actually does the scroll locking
	       */
	
	      return _react.default.createElement("div", null, _react.default.createElement("div", {
	        onClick: this.blurSelectInput,
	        className:
	        /*#__PURE__*/
	
	        /*#__PURE__*/
	        (0, _emotion.css)({
	          position: 'fixed',
	          left: 0,
	          bottom: 0,
	          right: 0,
	          top: 0
	        })
	      }), _react.default.createElement(_NodeResolver.default, {
	        innerRef: this.getScrollTarget
	      }, children), touchScrollTarget ? _react.default.createElement(_index.default, {
	        touchScrollTarget: touchScrollTarget
	      }) : null);
	    }
	  }]);
	
	  return ScrollBlock;
	}(_react.PureComponent);
	
	exports.default = ScrollBlock;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _NodeResolver = _interopRequireDefault(__webpack_require__(387));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ScrollCaptor =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollCaptor, _Component);
	
	  function ScrollCaptor() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollCaptor);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isBottom", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTop", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTarget", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "touchStart", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelScroll", function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEventDelta", function (event, delta) {
	      var _this$props = _this.props,
	          onBottomArrive = _this$props.onBottomArrive,
	          onBottomLeave = _this$props.onBottomLeave,
	          onTopArrive = _this$props.onTopArrive,
	          onTopLeave = _this$props.onTopLeave;
	      var _this$scrollTarget = _this.scrollTarget,
	          scrollTop = _this$scrollTarget.scrollTop,
	          scrollHeight = _this$scrollTarget.scrollHeight,
	          clientHeight = _this$scrollTarget.clientHeight;
	      var target = _this.scrollTarget;
	      var isDeltaPositive = delta > 0;
	      var availableScroll = scrollHeight - clientHeight - scrollTop;
	      var shouldCancelScroll = false; // reset bottom/top flags
	
	      if (availableScroll > delta && _this.isBottom) {
	        if (onBottomLeave) onBottomLeave(event);
	        _this.isBottom = false;
	      }
	
	      if (isDeltaPositive && _this.isTop) {
	        if (onTopLeave) onTopLeave(event);
	        _this.isTop = false;
	      } // bottom limit
	
	
	      if (isDeltaPositive && delta > availableScroll) {
	        if (onBottomArrive && !_this.isBottom) {
	          onBottomArrive(event);
	        }
	
	        target.scrollTop = scrollHeight;
	        shouldCancelScroll = true;
	        _this.isBottom = true; // top limit
	      } else if (!isDeltaPositive && -delta > scrollTop) {
	        if (onTopArrive && !_this.isTop) {
	          onTopArrive(event);
	        }
	
	        target.scrollTop = 0;
	        shouldCancelScroll = true;
	        _this.isTop = true;
	      } // cancel scroll
	
	
	      if (shouldCancelScroll) {
	        _this.cancelScroll(event);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWheel", function (event) {
	      _this.handleEventDelta(event, event.deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (event) {
	      // set touch start so we can calculate touchmove delta
	      _this.touchStart = event.changedTouches[0].clientY;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (event) {
	      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
	
	      _this.handleEventDelta(event, deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      _this.scrollTarget = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollCaptor, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListening(this.scrollTarget);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListening(this.scrollTarget);
	    }
	  }, {
	    key: "startListening",
	    value: function startListening(el) {
	      // bail early if no scroll available
	      if (!el) return;
	      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "stopListening",
	    value: function stopListening(el) {
	      // bail early if no scroll available
	      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react.default.createElement(_NodeResolver.default, {
	        innerRef: this.getScrollTarget
	      }, this.props.children);
	    }
	  }]);
	
	  return ScrollCaptor;
	}(_react.Component);
	
	var ScrollCaptorSwitch =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(ScrollCaptorSwitch, _Component2);
	
	  function ScrollCaptorSwitch() {
	    _classCallCheck(this, ScrollCaptorSwitch);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollCaptorSwitch).apply(this, arguments));
	  }
	
	  _createClass(ScrollCaptorSwitch, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          isEnabled = _this$props2.isEnabled,
	          props = _objectWithoutProperties(_this$props2, ["isEnabled"]);
	
	      return isEnabled ? _react.default.createElement(ScrollCaptor, props) : this.props.children;
	    }
	  }]);
	
	  return ScrollCaptorSwitch;
	}(_react.Component);
	
	exports.default = ScrollCaptorSwitch;
	
	_defineProperty(ScrollCaptorSwitch, "defaultProps", {
	  isEnabled: true
	});

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LOCK_STYLES = exports.STYLE_KEYS = void 0;
	var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
	exports.STYLE_KEYS = STYLE_KEYS;
	var LOCK_STYLES = {
	  boxSizing: 'border-box',
	  // account for possible declaration `width: 100%;` on body
	  overflow: 'hidden',
	  position: 'relative',
	  height: '100%'
	};
	exports.LOCK_STYLES = LOCK_STYLES;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(1946);
	
	var _utils = __webpack_require__(1948);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	var activeScrollLocks = 0;
	
	var ScrollLock =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollLock, _Component);
	
	  function ScrollLock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollLock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalStyles", {});
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listenerOptions", {
	      capture: false,
	      passive: false
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollLock, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!canUseDOM) return;
	      var _this$props = this.props,
	          accountForScrollbars = _this$props.accountForScrollbars,
	          touchScrollTarget = _this$props.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style;
	
	      if (accountForScrollbars) {
	        // store any styles already applied to the body
	        _constants.STYLE_KEYS.forEach(function (key) {
	          var val = targetStyle && targetStyle[key];
	          _this2.originalStyles[key] = val;
	        });
	      } // apply the lock styles and padding if this is the first scroll lock
	
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
	        var clientWidth = document.body ? document.body.clientWidth : 0;
	        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	        Object.keys(_constants.LOCK_STYLES).forEach(function (key) {
	          var val = _constants.LOCK_STYLES[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	
	        if (targetStyle) {
	          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
	        }
	      } // account for touch devices
	
	
	      if (target && (0, _utils.isTouchDevice)()) {
	        // Mobile Safari ignores { overflow: hidden } declaration on the body.
	        target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions); // Allow scroll on provided target
	
	        if (touchScrollTarget) {
	          touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	        }
	      } // increment active scroll locks
	
	
	      activeScrollLocks += 1;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (!canUseDOM) return;
	      var _this$props2 = this.props,
	          accountForScrollbars = _this$props2.accountForScrollbars,
	          touchScrollTarget = _this$props2.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style; // safely decrement active scroll locks
	
	      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        _constants.STYLE_KEYS.forEach(function (key) {
	          var val = _this3.originalStyles[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	      } // remove touch listeners
	
	
	      if (target && (0, _utils.isTouchDevice)()) {
	        target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	        if (touchScrollTarget) {
	          touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ScrollLock;
	}(_react.Component);
	
	exports.default = ScrollLock;
	
	_defineProperty(ScrollLock, "defaultProps", {
	  accountForScrollbars: true
	});

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preventTouchMove = preventTouchMove;
	exports.allowTouchMove = allowTouchMove;
	exports.preventInertiaScroll = preventInertiaScroll;
	exports.isTouchDevice = isTouchDevice;
	
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	} // `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	
	
	function isTouchDevice() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "A11yText", {
	  enumerable: true,
	  get: function get() {
	    return _A11yText.default;
	  }
	});
	Object.defineProperty(exports, "DummyInput", {
	  enumerable: true,
	  get: function get() {
	    return _DummyInput.default;
	  }
	});
	Object.defineProperty(exports, "NodeResolver", {
	  enumerable: true,
	  get: function get() {
	    return _NodeResolver.default;
	  }
	});
	Object.defineProperty(exports, "ScrollBlock", {
	  enumerable: true,
	  get: function get() {
	    return _ScrollBlock.default;
	  }
	});
	Object.defineProperty(exports, "ScrollCaptor", {
	  enumerable: true,
	  get: function get() {
	    return _ScrollCaptor.default;
	  }
	});
	
	var _A11yText = _interopRequireDefault(__webpack_require__(1942));
	
	var _DummyInput = _interopRequireDefault(__webpack_require__(1943));
	
	var _NodeResolver = _interopRequireDefault(__webpack_require__(387));
	
	var _ScrollBlock = _interopRequireDefault(__webpack_require__(1944));
	
	var _ScrollCaptor = _interopRequireDefault(__webpack_require__(1945));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrevArrow = exports.NextArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _innerSliderUtils = __webpack_require__(218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  var _super = _createSuper(PrevArrow);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames["default"])(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
	      } else {
	        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react["default"].PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  var _super2 = _createSuper(NextArrow);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames["default"])(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
	      } else {
	        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react["default"].PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return /*#__PURE__*/_react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _innerSliderUtils = __webpack_require__(218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  var _super = _createSuper(Dots);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave,
	          infinite = _this$props.infinite,
	          slidesToScroll = _this$props.slidesToScroll,
	          slidesToShow = _this$props.slidesToShow,
	          slideCount = _this$props.slideCount,
	          currentSlide = _this$props.currentSlide;
	      var dotCount = getDotCount({
	        slideCount: slideCount,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        infinite: infinite
	      });
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = [];
	
	      for (var i = 0; i < dotCount; i++) {
	        var _rightBound = (i + 1) * slidesToScroll - 1;
	
	        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);
	
	        var _leftBound = rightBound - (slidesToScroll - 1);
	
	        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
	        var className = (0, _classnames["default"])({
	          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: slidesToScroll,
	          currentSlide: currentSlide
	        };
	        var onClick = this.clickHandler.bind(this, dotOptions);
	        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
	          key: i,
	          className: className
	        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
	          onClick: onClick
	        })));
	      }
	
	      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react["default"].PureComponent);
	
	exports.Dots = Dots;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(1956));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _slider["default"];
	exports["default"] = _default;

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0,
	  targetSlide: 0
	};
	var _default = initialState;
	exports["default"] = _default;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _initialState = _interopRequireDefault(__webpack_require__(1954));
	
	var _lodash = _interopRequireDefault(__webpack_require__(1698));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _innerSliderUtils = __webpack_require__(218);
	
	var _track = __webpack_require__(1957);
	
	var _dots = __webpack_require__(1952);
	
	var _arrows = __webpack_require__(1950);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(731));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  var _super = _createSuper(InnerSlider);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill["default"](function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      _this.ro.disconnect();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      var setTrackStyle = _this.didPropsChange(prevProps);
	
	      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (_this.props.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash["default"])(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)
	
	      if (!isTrackMounted) return;
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread(_objectSpread({}, spec), {}, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i = 0; _i < postClones; _i++) {
	          _trackWidth += childrenWidths[_i];
	        }
	
	        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
	          _trackLeft += childrenWidths[_i2];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        return {
	          trackStyle: _trackStyle
	        };
	      }
	
	      var childrenCount = _react["default"].Children.count(_this.props.children);
	
	      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      return {
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
	      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
	        index: index
	      }, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	        afterChange && afterChange(currentSlide);
	        delete _this.animationEndCallback;
	      }
	
	      _this.setState(state, function () {
	        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
	        if (asNavFor && _this.asNavForIndex !== index) {
	          _this.asNavForIndex = index;
	          asNavFor.innerSlider.slideHandler(index);
	        }
	
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	
	      _this.props.autoplay && _this.autoPlay("update");
	
	      if (_this.props.focusOnSelect) {
	        var nodes = _this.list.querySelectorAll(".slick-current");
	
	        nodes[0] && nodes[0].focus();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
	      _this.swipeEnd(e);
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "render", function () {
	      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.touchEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr",
	        style: _this.props.style
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react["default"].Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	
	    var ssrState = _this.ssrInit();
	
	    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
	    return _this;
	  }
	
	  _createClass(InnerSlider, [{
	    key: "didPropsChange",
	    value: function didPropsChange(prevProps) {
	      var setTrackStyle = false;
	
	      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
	        var key = _Object$keys[_i3];
	
	        if (!prevProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
	          continue;
	        }
	
	        if (prevProps[key] !== this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
	    }
	  }]);
	
	  return InnerSlider;
	}(_react["default"].Component);
	
	exports.InnerSlider = InnerSlider;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _innerSlider = __webpack_require__(1955);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(1697));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(1951));
	
	var _innerSliderUtils = __webpack_require__(218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(1354);
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  var _super = _createSuper(Slider);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
	      } else {
	        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          className: className
	        }, children);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react["default"].Component);
	
	exports["default"] = Slider;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _innerSliderUtils = __webpack_require__(218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var focusedSlide;
	
	  if (spec.targetSlide < 0) {
	    focusedSlide = spec.targetSlide + spec.slideCount;
	  } else if (spec.targetSlide >= spec.slideCount) {
	    focusedSlide = spec.targetSlide - spec.slideCount;
	  } else {
	    focusedSlide = spec.targetSlide;
	  }
	
	  var slickCurrent = index === focusedSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	
	    if (spec.useCSS) {
	      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react["default"].Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react["default"].Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = /*#__PURE__*/_react["default"].createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames["default"])(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread(_objectSpread({
	        outline: "none"
	      }, child.props.style || {}), childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  var _super = _createSuper(Track);
	
	  function Track() {
	    var _this;
	
	    _classCallCheck(this, Track);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "node", null);
	
	    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
	      _this.node = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: this.handleRef,
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react["default"].PureComponent);
	
	exports.Track = Track;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(1959)
	} else {
	  module.exports = require('./react-svg.cjs.development.js')
	}


/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}var _objectWithoutPropertiesLoose=_interopDefault(__webpack_require__(394)),_inheritsLoose=_interopDefault(__webpack_require__(762)),svgInjector=__webpack_require__(771),React=__webpack_require__(1),ReactDOMServer=_interopDefault(__webpack_require__(683)),shallowDiffers=function(e,t){for(var r in e)if(!(r in t))return!0;for(var n in t)if(e[n]!==t[n])return!0;return!1},ReactSVG=function(e){function t(){var t;return(t=e.apply(this,arguments)||this).initialState={hasError:!1,isLoading:!0},t.state=t.initialState,t._isMounted=!1,t.refCallback=function(e){t.container=e},t}_inheritsLoose(t,e);var r=t.prototype;return r.renderSVG=function(){var e=this;if(this.container instanceof Node){var t=this.props,r=t.beforeInjection,n=t.evalScripts,i=t.renumerateIRIElements,o=t.src,a=this.props.afterInjection,s=this.props.wrapper,c=document.createElement(s);c.innerHTML=ReactDOMServer.renderToStaticMarkup(React.createElement(s,null,React.createElement(s,{"data-src":o}))),this.svgWrapper=this.container.appendChild(c.firstChild);svgInjector.SVGInjector(this.svgWrapper.firstChild,{afterEach:function(t,r){t&&e.removeSVG(),e._isMounted&&e.setState(function(){return{hasError:!!t,isLoading:!1}},function(){a(t,r)})},beforeEach:r,evalScripts:n,renumerateIRIElements:i})}},r.removeSVG=function(){this.container instanceof Node&&this.svgWrapper instanceof Node&&(this.container.removeChild(this.svgWrapper),this.svgWrapper=null)},r.componentDidMount=function(){this._isMounted=!0,this.renderSVG()},r.componentDidUpdate=function(e){var t=this;shallowDiffers(e,this.props)&&this.setState(function(){return t.initialState},function(){t.removeSVG(),t.renderSVG()})},r.componentWillUnmount=function(){this._isMounted=!1,this.removeSVG()},r.render=function(){var e=this.props,t=e.fallback,r=e.loading,n=e.wrapper,i=_objectWithoutPropertiesLoose(e,["afterInjection","beforeInjection","evalScripts","fallback","loading","renumerateIRIElements","src","wrapper"]);return React.createElement(n,Object.assign({},i,{ref:this.refCallback}),this.state.isLoading&&r&&React.createElement(r,null),this.state.hasError&&t&&React.createElement(t,null))},t}(React.Component);ReactSVG.defaultProps={afterInjection:function(){},beforeInjection:function(){},evalScripts:"never",fallback:null,loading:null,renumerateIRIElements:!0,wrapper:"div"},module.exports=ReactSVG;
	//# sourceMappingURL=react-svg.cjs.production.js.map


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(7));
	
	var _addClass = _interopRequireDefault(__webpack_require__(1347));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1349));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(718));
	
	var _PropTypes = __webpack_require__(721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(77);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(719));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(728);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(729);
	
	var _isPlainObject = __webpack_require__(349);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(730);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1985);


/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1986);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(146)(module)))

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(1990);
	var v4 = __webpack_require__(1991);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(733);
	var bytesToUuid = __webpack_require__(732);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/uuidjs/uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(733);
	var bytesToUuid = __webpack_require__(732);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(138));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _redux = __webpack_require__(2008);
	
	var _reducers = _interopRequireDefault(__webpack_require__(757));
	
	var playerActions = _interopRequireWildcard(__webpack_require__(272));
	
	var videoActions = _interopRequireWildcard(__webpack_require__(390));
	
	var Manager =
	/*#__PURE__*/
	function () {
	  function Manager(store) {
	    (0, _classCallCheck2["default"])(this, Manager);
	    this.store = store || (0, _redux.createStore)(_reducers["default"]);
	    this.video = null;
	    this.rootElement = null;
	  }
	
	  (0, _createClass2["default"])(Manager, [{
	    key: "getActions",
	    value: function getActions() {
	      var manager = this;
	      var dispatch = this.store.dispatch;
	      var actions = (0, _objectSpread2["default"])({}, playerActions, videoActions);
	
	      function bindActionCreator(actionCreator) {
	        return function bindAction() {
	          // eslint-disable-next-line prefer-rest-params
	          var action = actionCreator.apply(manager, arguments);
	
	          if (typeof action !== 'undefined') {
	            dispatch(action);
	          }
	        };
	      }
	
	      return Object.keys(actions).filter(function (key) {
	        return typeof actions[key] === 'function';
	      }).reduce(function (boundActions, key) {
	        boundActions[key] = bindActionCreator(actions[key]);
	        return boundActions;
	      }, {});
	    }
	  }, {
	    key: "getState",
	    value: function getState() {
	      return this.store.getState();
	    } // subscribe state change
	
	  }, {
	    key: "subscribeToStateChange",
	    value: function subscribeToStateChange(listener, getState) {
	      if (!getState) {
	        getState = this.getState.bind(this);
	      }
	
	      var prevState = getState();
	
	      var handleChange = function handleChange() {
	        var state = getState();
	
	        if (state === prevState) {
	          return;
	        }
	
	        var prevStateCopy = prevState;
	        prevState = state;
	        listener(state, prevStateCopy);
	      };
	
	      return this.store.subscribe(handleChange);
	    } // subscribe to operation state change
	
	  }, {
	    key: "subscribeToOperationStateChange",
	    value: function subscribeToOperationStateChange(listener) {
	      var _this = this;
	
	      return this.subscribeToStateChange(listener, function () {
	        return _this.getState().operation;
	      });
	    } // subscribe to player state change
	
	  }, {
	    key: "subscribeToPlayerStateChange",
	    value: function subscribeToPlayerStateChange(listener) {
	      var _this2 = this;
	
	      return this.subscribeToStateChange(listener, function () {
	        return _this2.getState().player;
	      });
	    }
	  }]);
	  return Manager;
	}();
	
	exports["default"] = Manager;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(138));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(274));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(275));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _Manager = _interopRequireDefault(__webpack_require__(1992));
	
	var _BigPlayButton = _interopRequireDefault(__webpack_require__(735));
	
	var _LoadingSpinner = _interopRequireDefault(__webpack_require__(737));
	
	var _PosterImage = _interopRequireDefault(__webpack_require__(738));
	
	var _Video = _interopRequireDefault(__webpack_require__(740));
	
	var _Bezel = _interopRequireDefault(__webpack_require__(734));
	
	var _Shortcut = _interopRequireDefault(__webpack_require__(739));
	
	var _ControlBar = _interopRequireDefault(__webpack_require__(741));
	
	var browser = _interopRequireWildcard(__webpack_require__(2005));
	
	var _dom = __webpack_require__(273);
	
	var _utils = __webpack_require__(126);
	
	var _fullscreen = _interopRequireDefault(__webpack_require__(758));
	
	var propTypes = {
	  children: _propTypes["default"].any,
	  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  fluid: _propTypes["default"].bool,
	  muted: _propTypes["default"].bool,
	  playsInline: _propTypes["default"].bool,
	  aspectRatio: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  videoId: _propTypes["default"].string,
	  startTime: _propTypes["default"].number,
	  loop: _propTypes["default"].bool,
	  autoPlay: _propTypes["default"].bool,
	  src: _propTypes["default"].string,
	  poster: _propTypes["default"].string,
	  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
	  onLoadStart: _propTypes["default"].func,
	  onWaiting: _propTypes["default"].func,
	  onCanPlay: _propTypes["default"].func,
	  onCanPlayThrough: _propTypes["default"].func,
	  onPlaying: _propTypes["default"].func,
	  onEnded: _propTypes["default"].func,
	  onSeeking: _propTypes["default"].func,
	  onSeeked: _propTypes["default"].func,
	  onPlay: _propTypes["default"].func,
	  onPause: _propTypes["default"].func,
	  onProgress: _propTypes["default"].func,
	  onDurationChange: _propTypes["default"].func,
	  onError: _propTypes["default"].func,
	  onSuspend: _propTypes["default"].func,
	  onAbort: _propTypes["default"].func,
	  onEmptied: _propTypes["default"].func,
	  onStalled: _propTypes["default"].func,
	  onLoadedMetadata: _propTypes["default"].func,
	  onLoadedData: _propTypes["default"].func,
	  onTimeUpdate: _propTypes["default"].func,
	  onRateChange: _propTypes["default"].func,
	  onVolumeChange: _propTypes["default"].func,
	  store: _propTypes["default"].object
	};
	var defaultProps = {
	  fluid: true,
	  muted: false,
	  playsInline: false,
	  preload: 'auto',
	  aspectRatio: 'auto'
	};
	
	var Player =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Player, _Component);
	
	  function Player(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Player);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Player).call(this, props));
	    _this.controlsHideTimer = null;
	    _this.video = null; // the Video component
	
	    _this.manager = new _Manager["default"](props.store);
	    _this.actions = _this.manager.getActions();
	
	    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
	
	    _this.getStyle = _this.getStyle.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getChildren = _this.getChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this)), 250);
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.startControlsTimer = _this.startControlsTimer.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFullScreenChange = _this.handleFullScreenChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Player, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.handleResize();
	      window.addEventListener('resize', this.handleResize);
	
	      _fullscreen["default"].addEventListener(this.handleFullScreenChange);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // Remove event listener
	      window.removeEventListener('resize', this.handleResize);
	
	      _fullscreen["default"].removeEventListener(this.handleFullScreenChange);
	
	      if (this.controlsHideTimer) {
	        window.clearTimeout(this.controlsHideTimer);
	      }
	    }
	  }, {
	    key: "getDefaultChildren",
	    value: function getDefaultChildren(originalChildren) {
	      var _this2 = this;
	
	      return [_react["default"].createElement(_Video["default"], {
	        ref: function ref(c) {
	          _this2.video = c;
	          _this2.manager.video = _this2.video;
	        },
	        key: "video",
	        order: 0.0
	      }, originalChildren), _react["default"].createElement(_PosterImage["default"], {
	        key: "poster-image",
	        order: 1.0
	      }), _react["default"].createElement(_LoadingSpinner["default"], {
	        key: "loading-spinner",
	        order: 2.0
	      }), _react["default"].createElement(_Bezel["default"], {
	        key: "bezel",
	        order: 3.0
	      }), _react["default"].createElement(_BigPlayButton["default"], {
	        key: "big-play-button",
	        order: 4.0
	      }), _react["default"].createElement(_ControlBar["default"], {
	        key: "control-bar",
	        order: 5.0
	      }), _react["default"].createElement(_Shortcut["default"], {
	        key: "shortcut",
	        order: 99.0
	      })];
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren(props) {
	      var _ = props.className,
	          originalChildren = props.children,
	          propsWithoutChildren = (0, _objectWithoutProperties2["default"])(props, ["className", "children"]);
	
	      var children = _react["default"].Children.toArray(this.props.children).filter(function (e) {
	        return !(0, _utils.isVideoChild)(e);
	      });
	
	      var defaultChildren = this.getDefaultChildren(originalChildren);
	      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
	    }
	  }, {
	    key: "setWidthOrHeight",
	    value: function setWidthOrHeight(style, name, value) {
	      var styleVal;
	
	      if (typeof value === 'string') {
	        if (value === 'auto') {
	          styleVal = 'auto';
	        } else if (value.match(/\d+%/)) {
	          styleVal = value;
	        }
	      } else if (typeof value === 'number') {
	        styleVal = "".concat(value, "px");
	      }
	
	      Object.assign(style, (0, _defineProperty2["default"])({}, name, styleVal));
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle() {
	      var _this$props = this.props,
	          fluid = _this$props.fluid,
	          propsAspectRatio = _this$props.aspectRatio,
	          propsHeight = _this$props.height,
	          propsWidth = _this$props.width;
	
	      var _this$manager$getStat = this.manager.getState(),
	          player = _this$manager$getStat.player;
	
	      var style = {};
	      var width;
	      var height;
	      var aspectRatio; // The aspect ratio is either used directly or to calculate width and height.
	
	      if (propsAspectRatio !== undefined && propsAspectRatio !== 'auto') {
	        // Use any aspectRatio that's been specifically set
	        aspectRatio = propsAspectRatio;
	      } else if (player.videoWidth) {
	        // Otherwise try to get the aspect ratio from the video metadata
	        aspectRatio = "".concat(player.videoWidth, ":").concat(player.videoHeight);
	      } else {
	        // Or use a default. The video element's is 2:1, but 16:9 is more common.
	        aspectRatio = '16:9';
	      } // Get the ratio as a decimal we can use to calculate dimensions
	
	
	      var ratioParts = aspectRatio.split(':');
	      var ratioMultiplier = ratioParts[1] / ratioParts[0];
	
	      if (propsWidth !== undefined) {
	        // Use any width that's been specifically set
	        width = propsWidth;
	      } else if (propsHeight !== undefined) {
	        // Or calulate the width from the aspect ratio if a height has been set
	        width = propsHeight / ratioMultiplier;
	      } else {
	        // Or use the video's metadata, or use the video el's default of 300
	        width = player.videoWidth || 400;
	      }
	
	      if (propsHeight !== undefined) {
	        // Use any height that's been specifically set
	        height = propsHeight;
	      } else {
	        // Otherwise calculate the height from the ratio and the width
	        height = width * ratioMultiplier;
	      }
	
	      if (fluid) {
	        style.paddingTop = "".concat(ratioMultiplier * 100, "%");
	      } else {
	        // If Width contains "auto", set "auto" in style
	        this.setWidthOrHeight(style, 'width', width);
	        this.setWidthOrHeight(style, 'height', height);
	      }
	
	      return style;
	    } // get redux state
	    // { player, operation }
	
	  }, {
	    key: "getState",
	    value: function getState() {
	      return this.manager.getState();
	    } // get playback rate
	
	  }, {
	    key: "play",
	    // play the video
	    value: function play() {
	      this.video.play();
	    } // pause the video
	
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.video.pause();
	    } // Change the video source and re-load the video:
	
	  }, {
	    key: "load",
	    value: function load() {
	      this.video.load();
	    } // Add a new text track to the video
	
	  }, {
	    key: "addTextTrack",
	    value: function addTextTrack() {
	      var _this$video;
	
	      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
	    } // Check if your browser can play different types of video:
	
	  }, {
	    key: "canPlayType",
	    value: function canPlayType() {
	      var _this$video2;
	
	      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
	    } // seek video by time
	
	  }, {
	    key: "seek",
	    value: function seek(time) {
	      this.video.seek(time);
	    } // jump forward x seconds
	
	  }, {
	    key: "forward",
	    value: function forward(seconds) {
	      this.video.forward(seconds);
	    } // jump back x seconds
	
	  }, {
	    key: "replay",
	    value: function replay(seconds) {
	      this.video.replay(seconds);
	    } // enter or exist full screen
	
	  }, {
	    key: "toggleFullscreen",
	    value: function toggleFullscreen() {
	      this.video.toggleFullscreen();
	    } // subscribe to player state change
	
	  }, {
	    key: "subscribeToStateChange",
	    value: function subscribeToStateChange(listener) {
	      return this.manager.subscribeToPlayerStateChange(listener);
	    } // player resize
	
	  }, {
	    key: "handleResize",
	    value: function handleResize() {}
	  }, {
	    key: "handleFullScreenChange",
	    value: function handleFullScreenChange(event) {
	      if (event.target === this.manager.rootElement) {
	        this.actions.handleFullscreenChange(_fullscreen["default"].isFullscreen);
	      }
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: "startControlsTimer",
	    value: function startControlsTimer() {
	      var _this3 = this;
	
	      var controlBarActiveTime = 3000;
	
	      _react["default"].Children.forEach(this.props.children, function (element) {
	        if (!_react["default"].isValidElement(element) || element.type !== _ControlBar["default"]) {
	          return;
	        }
	
	        var autoHideTime = element.props.autoHideTime;
	
	        if (typeof autoHideTime === 'number') {
	          controlBarActiveTime = autoHideTime;
	        }
	      });
	
	      this.actions.userActivate(true);
	      clearTimeout(this.controlsHideTimer);
	      this.controlsHideTimer = setTimeout(function () {
	        _this3.actions.userActivate(false);
	      }, controlBarActiveTime);
	    }
	  }, {
	    key: "handleStateChange",
	    value: function handleStateChange(state, prevState) {
	      if (state.isFullscreen !== prevState.isFullscreen) {
	        this.handleResize(); // focus root when switching fullscreen mode to avoid confusion #276
	
	        (0, _dom.focusNode)(this.manager.rootElement);
	      }
	
	      this.forceUpdate(); // re-render
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      this.actions.activate(true);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.actions.activate(false);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var fluid = this.props.fluid;
	
	      var _this$manager$getStat2 = this.manager.getState(),
	          player = _this$manager$getStat2.player;
	
	      var paused = player.paused,
	          hasStarted = player.hasStarted,
	          waiting = player.waiting,
	          seeking = player.seeking,
	          isFullscreen = player.isFullscreen,
	          userActivity = player.userActivity;
	      var props = (0, _objectSpread2["default"])({}, this.props, {
	        player: player,
	        actions: this.actions,
	        manager: this.manager,
	        store: this.manager.store,
	        video: this.video ? this.video.video : null
	      });
	      var children = this.getChildren(props);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])({
	          'video-react-controls-enabled': true,
	          'video-react-has-started': hasStarted,
	          'video-react-paused': paused,
	          'video-react-playing': !paused,
	          'video-react-waiting': waiting,
	          'video-react-seeking': seeking,
	          'video-react-fluid': fluid,
	          'video-react-fullscreen': isFullscreen,
	          'video-react-user-inactive': !userActivity,
	          'video-react-user-active': userActivity,
	          'video-react-workinghover': !browser.IS_IOS
	        }, 'video-react', this.props.className),
	        style: this.getStyle(),
	        ref: function ref(c) {
	          _this4.manager.rootElement = c;
	        },
	        role: "region",
	        onTouchStart: this.handleMouseDown,
	        onMouseDown: this.handleMouseDown,
	        onTouchMove: this.handleMouseMove,
	        onMouseMove: this.handleMouseMove,
	        onKeyDown: this.handleKeyDown,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        tabIndex: "-1"
	      }, children);
	    }
	  }, {
	    key: "playbackRate",
	    get: function get() {
	      return this.video.playbackRate;
	    } // set playback rate
	    // speed of video
	    ,
	    set: function set(rate) {
	      this.video.playbackRate = rate;
	    }
	  }, {
	    key: "muted",
	    get: function get() {
	      return this.video.muted;
	    },
	    set: function set(val) {
	      this.video.muted = val;
	    }
	  }, {
	    key: "volume",
	    get: function get() {
	      return this.video.volume;
	    },
	    set: function set(val) {
	      this.video.volume = val;
	    } // video width
	
	  }, {
	    key: "videoWidth",
	    get: function get() {
	      return this.video.videoWidth;
	    } // video height
	
	  }, {
	    key: "videoHeight",
	    get: function get() {
	      return this.video.videoHeight;
	    }
	  }]);
	  return Player;
	}(_react.Component);
	
	exports["default"] = Player;
	Player.contextTypes = {
	  store: _propTypes["default"].object
	};
	Player.propTypes = propTypes;
	Player.defaultProps = defaultProps;
	Player.displayName = 'Player';

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _MenuButton = _interopRequireDefault(__webpack_require__(393));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  offMenuText: _propTypes["default"].string,
	  showOffMenu: _propTypes["default"].bool,
	  kinds: _propTypes["default"].array
	};
	var defaultProps = {
	  offMenuText: 'Off',
	  showOffMenu: true,
	  kinds: ['captions', 'subtitles'] // `kind`s of TextTrack to look for to associate it with this menu.
	
	};
	
	var ClosedCaptionButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ClosedCaptionButton, _Component);
	
	  function ClosedCaptionButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ClosedCaptionButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClosedCaptionButton).call(this, props, context));
	    _this.getTextTrackItems = _this.getTextTrackItems.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.updateState = _this.updateState.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.state = _this.getTextTrackItems();
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ClosedCaptionButton, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateState();
	    }
	  }, {
	    key: "getTextTrackItems",
	    value: function getTextTrackItems() {
	      var _this$props = this.props,
	          kinds = _this$props.kinds,
	          player = _this$props.player,
	          offMenuText = _this$props.offMenuText,
	          showOffMenu = _this$props.showOffMenu;
	      var textTracks = player.textTracks,
	          activeTextTrack = player.activeTextTrack;
	      var textTrackItems = {
	        items: [],
	        selectedIndex: 0
	      };
	      var tracks = Array.from(textTracks || []);
	
	      if (tracks.length === 0) {
	        return textTrackItems;
	      }
	
	      if (showOffMenu) {
	        textTrackItems.items.push({
	          label: offMenuText || 'Off',
	          value: null
	        });
	      }
	
	      tracks.forEach(function (textTrack) {
	        // ignore invalid text track kind
	        if (kinds.length && !kinds.includes(textTrack.kind)) {
	          return;
	        }
	
	        textTrackItems.items.push({
	          label: textTrack.label,
	          value: textTrack.language
	        });
	      });
	      textTrackItems.selectedIndex = textTrackItems.items.findIndex(function (item) {
	        return activeTextTrack && activeTextTrack.language === item.value;
	      });
	
	      if (textTrackItems.selectedIndex === -1) {
	        textTrackItems.selectedIndex = 0;
	      }
	
	      return textTrackItems;
	    }
	  }, {
	    key: "updateState",
	    value: function updateState() {
	      var textTrackItems = this.getTextTrackItems();
	
	      if (textTrackItems.selectedIndex !== this.state.selectedIndex || !this.textTrackItemsAreEqual(textTrackItems.items, this.state.items)) {
	        this.setState(textTrackItems);
	      }
	    }
	  }, {
	    key: "textTrackItemsAreEqual",
	    value: function textTrackItemsAreEqual(items1, items2) {
	      if (items1.length !== items2.length) {
	        return false;
	      }
	
	      for (var i = 0; i < items1.length; i++) {
	        if (!items2[i] || items1[i].label !== items2[i].label || items1[i].value !== items2[i].value) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: "handleSelectItem",
	    value: function handleSelectItem(index) {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions,
	          showOffMenu = _this$props2.showOffMenu;
	      var textTracks = player.textTracks; // For the 'subtitles-off' button, the first condition will never match
	      // so all subtitles will be turned off
	
	      Array.from(textTracks).forEach(function (textTrack, i) {
	        // if it shows the `Off` menu, the first item is `Off`
	        if (index === (showOffMenu ? i + 1 : i)) {
	          textTrack.mode = 'showing';
	          actions.activateTextTrack(textTrack);
	        } else {
	          textTrack.mode = 'hidden';
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$state = this.state,
	          items = _this$state.items,
	          selectedIndex = _this$state.selectedIndex;
	      return _react["default"].createElement(_MenuButton["default"], {
	        className: (0, _classnames["default"])('video-react-closed-caption', this.props.className),
	        onSelectItem: this.handleSelectItem,
	        items: items,
	        selectedIndex: selectedIndex
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Closed Caption"));
	    }
	  }]);
	  return ClosedCaptionButton;
	}(_react.Component);
	
	ClosedCaptionButton.propTypes = propTypes;
	ClosedCaptionButton.defaultProps = defaultProps;
	ClosedCaptionButton.displayName = 'ClosedCaptionButton';
	var _default = ClosedCaptionButton;
	exports["default"] = _default;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(392));
	
	var _utils = __webpack_require__(126);
	
	var PlaybackRate =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PlaybackRate, _Component);
	
	  function PlaybackRate(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PlaybackRate);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRate).call(this, props, context));
	    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PlaybackRate, [{
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(_PlaybackRateMenuButton["default"], this.props);
	    }
	  }]);
	  return PlaybackRate;
	}(_react.Component);
	
	exports["default"] = PlaybackRate;
	PlaybackRate.displayName = 'PlaybackRate';

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var propTypes = {
	  children: _propTypes["default"].any
	};
	
	var Menu =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Menu, _Component);
	
	  function Menu(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Menu);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Menu, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault(); // event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement("div", {
	        className: "video-react-menu video-react-lock-showing",
	        role: "presentation",
	        onClick: this.handleClick
	      }, _react["default"].createElement("ul", {
	        className: "video-react-menu-content"
	      }, this.props.children));
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	exports["default"] = Menu;
	Menu.propTypes = propTypes;
	Menu.displayName = 'Menu';

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  item: _propTypes["default"].object,
	  index: _propTypes["default"].number,
	  activateIndex: _propTypes["default"].number,
	  onSelectItem: _propTypes["default"].func
	};
	
	var MenuItem =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(MenuItem, _Component);
	
	  function MenuItem(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, MenuItem);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(MenuItem, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          index = _this$props.index,
	          onSelectItem = _this$props.onSelectItem;
	      onSelectItem(index);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          item = _this$props2.item,
	          index = _this$props2.index,
	          activateIndex = _this$props2.activateIndex;
	      return _react["default"].createElement("li", {
	        className: (0, _classnames["default"])({
	          'video-react-menu-item': true,
	          'video-react-selected': index === activateIndex
	        }),
	        role: "menuitem",
	        onClick: this.handleClick
	      }, item.label, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }));
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	exports["default"] = MenuItem;
	MenuItem.propTypes = propTypes;
	MenuItem.displayName = 'MenuItem';

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  children: _propTypes["default"].any
	};
	
	var Popup =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Popup, _Component);
	
	  function Popup(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Popup);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Popup).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Popup, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault(); // event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return _react["default"].createElement("div", {
	        className: "video-react-menu",
	        onClick: this.handleClick
	      }, _react["default"].createElement("div", {
	        className: "video-react-menu-content"
	      }, children));
	    }
	  }]);
	  return Popup;
	}(_react.Component);
	
	exports["default"] = Popup;
	Popup.propTypes = propTypes;
	Popup.displayName = 'Popup';

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = PopupButton;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(191));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(138));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _ClickableComponent = _interopRequireDefault(__webpack_require__(736));
	
	var _Popup = _interopRequireDefault(__webpack_require__(1998));
	
	var propTypes = {
	  inline: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func.isRequired,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  inline: true
	};
	
	function PopupButton(props) {
	  var inline = props.inline,
	      className = props.className;
	  var ps = (0, _objectSpread2["default"])({}, props);
	  delete ps.children;
	  delete ps.inline;
	  delete ps.className;
	  return _react["default"].createElement(_ClickableComponent["default"], (0, _extends2["default"])({
	    className: (0, _classnames["default"])(className, {
	      'video-react-menu-button-inline': !!inline,
	      'video-react-menu-button-popup': !inline
	    }, 'video-react-control video-react-button video-react-menu-button')
	  }, ps), _react["default"].createElement(_Popup["default"], props));
	}
	
	PopupButton.propTypes = propTypes;
	PopupButton.defaultProps = defaultProps;
	PopupButton.displayName = 'PopupButton';

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(191));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(58));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(59));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(67));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(65));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(64));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(66));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var _Slider = _interopRequireDefault(__webpack_require__(391));
	
	var _VolumeLevel = _interopRequireDefault(__webpack_require__(2001));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func
	};
	
	var VolumeBar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(VolumeBar, _Component);
	
	  function VolumeBar(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, VolumeBar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeBar).call(this, props, context));
	    _this.state = {
	      percentage: '0%'
	    };
	    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.checkMuted = _this.checkMuted.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(VolumeBar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "getPercent",
	    value: function getPercent() {
	      var player = this.props.player;
	
	      if (player.muted) {
	        return 0;
	      }
	
	      return player.volume;
	    }
	  }, {
	    key: "checkMuted",
	    value: function checkMuted() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	
	      if (player.muted) {
	        actions.mute(false);
	      }
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      var actions = this.props.actions;
	      this.checkMuted();
	      var distance = this.slider.calculateDistance(event);
	      actions.changeVolume(distance);
	    }
	  }, {
	    key: "stepForward",
	    value: function stepForward() {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions;
	      this.checkMuted();
	      actions.changeVolume(player.volume + 0.1);
	    }
	  }, {
	    key: "stepBack",
	    value: function stepBack() {
	      var _this$props3 = this.props,
	          player = _this$props3.player,
	          actions = _this$props3.actions;
	      this.checkMuted();
	      actions.changeVolume(player.volume - 0.1);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(e) {
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(e) {
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: "handlePercentageChange",
	    value: function handlePercentageChange(percentage) {
	      if (percentage !== this.state.percentage) {
	        this.setState({
	          percentage: percentage
	        });
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          player = _this$props4.player,
	          className = _this$props4.className;
	      var volume = (player.volume * 100).toFixed(2);
	      return _react["default"].createElement(_Slider["default"], (0, _extends2["default"])({
	        ref: function ref(c) {
	          _this2.slider = c;
	        },
	        label: "volume level",
	        valuenow: volume,
	        valuetext: "".concat(volume, "%"),
	        onMouseMove: this.handleMouseMove,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        sliderActive: this.handleFocus,
	        sliderInactive: this.handleBlur,
	        getPercent: this.getPercent,
	        onPercentageChange: this.handlePercentageChange,
	        stepForward: this.stepForward,
	        stepBack: this.stepBack
	      }, this.props, {
	        className: (0, _classnames["default"])(className, 'video-react-volume-bar video-react-slider-bar')
	      }), _react["default"].createElement(_VolumeLevel["default"], this.props));
	    }
	  }]);
	  return VolumeBar;
	}(_react.Component);
	
	VolumeBar.propTypes = propTypes;
	VolumeBar.displayName = 'VolumeBar';
	var _default = VolumeBar;
	exports["default"] = _default;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(46));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  percentage: _propTypes["default"].string,
	  vertical: _propTypes["default"].bool,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  percentage: '100%',
	  vertical: false
	};
	
	function VolumeLevel(_ref) {
	  var percentage = _ref.percentage,
	      vertical = _ref.vertical,
	      className = _ref.className;
	  var style = {};
	
	  if (vertical) {
	    style.height = percentage;
	  } else {
	    style.width = percentage;
	  }
	
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])(className, 'video-react-volume-level'),
	    style: style
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }));
	}
	
	VolumeLevel.propTypes = propTypes;
	VolumeLevel.defaultProps = defaultProps;
	VolumeLevel.displayName = 'VolumeLevel';
	var _default = VolumeLevel;
	exports["default"] = _default;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(61);
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Player", {
	  enumerable: true,
	  get: function get() {
	    return _Player["default"];
	  }
	});
	Object.defineProperty(exports, "Video", {
	  enumerable: true,
	  get: function get() {
	    return _Video["default"];
	  }
	});
	Object.defineProperty(exports, "BigPlayButton", {
	  enumerable: true,
	  get: function get() {
	    return _BigPlayButton["default"];
	  }
	});
	Object.defineProperty(exports, "LoadingSpinner", {
	  enumerable: true,
	  get: function get() {
	    return _LoadingSpinner["default"];
	  }
	});
	Object.defineProperty(exports, "PosterImage", {
	  enumerable: true,
	  get: function get() {
	    return _PosterImage["default"];
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider["default"];
	  }
	});
	Object.defineProperty(exports, "Bezel", {
	  enumerable: true,
	  get: function get() {
	    return _Bezel["default"];
	  }
	});
	Object.defineProperty(exports, "Shortcut", {
	  enumerable: true,
	  get: function get() {
	    return _Shortcut["default"];
	  }
	});
	Object.defineProperty(exports, "ControlBar", {
	  enumerable: true,
	  get: function get() {
	    return _ControlBar["default"];
	  }
	});
	Object.defineProperty(exports, "PlayToggle", {
	  enumerable: true,
	  get: function get() {
	    return _PlayToggle["default"];
	  }
	});
	Object.defineProperty(exports, "ForwardControl", {
	  enumerable: true,
	  get: function get() {
	    return _ForwardControl["default"];
	  }
	});
	Object.defineProperty(exports, "ReplayControl", {
	  enumerable: true,
	  get: function get() {
	    return _ReplayControl["default"];
	  }
	});
	Object.defineProperty(exports, "FullscreenToggle", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenToggle["default"];
	  }
	});
	Object.defineProperty(exports, "ProgressControl", {
	  enumerable: true,
	  get: function get() {
	    return _ProgressControl["default"];
	  }
	});
	Object.defineProperty(exports, "SeekBar", {
	  enumerable: true,
	  get: function get() {
	    return _SeekBar["default"];
	  }
	});
	Object.defineProperty(exports, "PlayProgressBar", {
	  enumerable: true,
	  get: function get() {
	    return _PlayProgressBar["default"];
	  }
	});
	Object.defineProperty(exports, "LoadProgressBar", {
	  enumerable: true,
	  get: function get() {
	    return _LoadProgressBar["default"];
	  }
	});
	Object.defineProperty(exports, "MouseTimeDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _MouseTimeDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "VolumeMenuButton", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeMenuButton["default"];
	  }
	});
	Object.defineProperty(exports, "PlaybackRateMenuButton", {
	  enumerable: true,
	  get: function get() {
	    return _PlaybackRateMenuButton["default"];
	  }
	});
	Object.defineProperty(exports, "PlaybackRate", {
	  enumerable: true,
	  get: function get() {
	    return _PlaybackRate["default"];
	  }
	});
	Object.defineProperty(exports, "ClosedCaptionButton", {
	  enumerable: true,
	  get: function get() {
	    return _ClosedCaptionButton["default"];
	  }
	});
	Object.defineProperty(exports, "RemainingTimeDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _RemainingTimeDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "CurrentTimeDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _CurrentTimeDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "DurationDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _DurationDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "TimeDivider", {
	  enumerable: true,
	  get: function get() {
	    return _TimeDivider["default"];
	  }
	});
	Object.defineProperty(exports, "MenuButton", {
	  enumerable: true,
	  get: function get() {
	    return _MenuButton["default"];
	  }
	});
	Object.defineProperty(exports, "playerReducer", {
	  enumerable: true,
	  get: function get() {
	    return _reducers.playerReducer;
	  }
	});
	Object.defineProperty(exports, "operationReducer", {
	  enumerable: true,
	  get: function get() {
	    return _reducers.operationReducer;
	  }
	});
	exports.videoActions = exports.playerActions = void 0;
	
	var _Player = _interopRequireDefault(__webpack_require__(1993));
	
	var _Video = _interopRequireDefault(__webpack_require__(740));
	
	var _BigPlayButton = _interopRequireDefault(__webpack_require__(735));
	
	var _LoadingSpinner = _interopRequireDefault(__webpack_require__(737));
	
	var _PosterImage = _interopRequireDefault(__webpack_require__(738));
	
	var _Slider = _interopRequireDefault(__webpack_require__(391));
	
	var _Bezel = _interopRequireDefault(__webpack_require__(734));
	
	var _Shortcut = _interopRequireDefault(__webpack_require__(739));
	
	var _ControlBar = _interopRequireDefault(__webpack_require__(741));
	
	var _PlayToggle = _interopRequireDefault(__webpack_require__(748));
	
	var _ForwardControl = _interopRequireDefault(__webpack_require__(742));
	
	var _ReplayControl = _interopRequireDefault(__webpack_require__(750));
	
	var _FullscreenToggle = _interopRequireDefault(__webpack_require__(744));
	
	var _ProgressControl = _interopRequireDefault(__webpack_require__(749));
	
	var _SeekBar = _interopRequireDefault(__webpack_require__(751));
	
	var _PlayProgressBar = _interopRequireDefault(__webpack_require__(747));
	
	var _LoadProgressBar = _interopRequireDefault(__webpack_require__(745));
	
	var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(746));
	
	var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(752));
	
	var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(392));
	
	var _PlaybackRate = _interopRequireDefault(__webpack_require__(1995));
	
	var _ClosedCaptionButton = _interopRequireDefault(__webpack_require__(1994));
	
	var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(755));
	
	var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(753));
	
	var _DurationDisplay = _interopRequireDefault(__webpack_require__(754));
	
	var _TimeDivider = _interopRequireDefault(__webpack_require__(756));
	
	var _MenuButton = _interopRequireDefault(__webpack_require__(393));
	
	var playerActions = _interopRequireWildcard(__webpack_require__(272));
	
	exports.playerActions = playerActions;
	
	var videoActions = _interopRequireWildcard(__webpack_require__(390));
	
	exports.videoActions = videoActions;
	
	var _reducers = __webpack_require__(757);

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = operation;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(138));
	
	var _player = __webpack_require__(272);
	
	var initialState = {
	  count: 0,
	  operation: {
	    action: '',
	    source: ''
	  }
	};
	
	function operation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	
	  switch (action.type) {
	    case _player.OPERATE:
	      return (0, _objectSpread2["default"])({}, state, {
	        count: state.count + 1,
	        operation: (0, _objectSpread2["default"])({}, state.operation, action.operation)
	      });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(34);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = player;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(138));
	
	var _video = __webpack_require__(390);
	
	var _player = __webpack_require__(272);
	
	var initialState = {
	  currentSrc: null,
	  duration: 0,
	  currentTime: 0,
	  seekingTime: 0,
	  buffered: null,
	  waiting: false,
	  seeking: false,
	  paused: true,
	  autoPaused: false,
	  ended: false,
	  playbackRate: 1,
	  muted: false,
	  volume: 1,
	  readyState: 0,
	  networkState: 0,
	  videoWidth: 0,
	  videoHeight: 0,
	  hasStarted: false,
	  userActivity: true,
	  isActive: false,
	  isFullscreen: false,
	  activeTextTrack: null
	};
	
	function player() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	
	  switch (action.type) {
	    case _player.USER_ACTIVATE:
	      return (0, _objectSpread2["default"])({}, state, {
	        userActivity: action.activity
	      });
	
	    case _player.PLAYER_ACTIVATE:
	      return (0, _objectSpread2["default"])({}, state, {
	        isActive: action.activity
	      });
	
	    case _player.FULLSCREEN_CHANGE:
	      return (0, _objectSpread2["default"])({}, state, {
	        isFullscreen: !!action.isFullscreen
	      });
	
	    case _video.SEEKING_TIME:
	      return (0, _objectSpread2["default"])({}, state, {
	        seekingTime: action.time
	      });
	
	    case _video.END_SEEKING:
	      return (0, _objectSpread2["default"])({}, state, {
	        seekingTime: 0
	      });
	
	    case _video.LOAD_START:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        hasStarted: false,
	        ended: false
	      });
	
	    case _video.CAN_PLAY:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        waiting: false
	      });
	
	    case _video.WAITING:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        waiting: true
	      });
	
	    case _video.CAN_PLAY_THROUGH:
	    case _video.PLAYING:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        waiting: false
	      });
	
	    case _video.PLAY:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        ended: false,
	        paused: false,
	        autoPaused: false,
	        waiting: false,
	        hasStarted: true
	      });
	
	    case _video.PAUSE:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        paused: true
	      });
	
	    case _video.END:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        ended: true
	      });
	
	    case _video.SEEKING:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        seeking: true
	      });
	
	    case _video.SEEKED:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        seeking: false
	      });
	
	    case _video.ERROR:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        error: 'UNKNOWN ERROR',
	        ended: true
	      });
	
	    case _video.DURATION_CHANGE:
	    case _video.TIME_UPDATE:
	    case _video.VOLUME_CHANGE:
	    case _video.PROGRESS_CHANGE:
	    case _video.RATE_CHANGE:
	    case _video.SUSPEND:
	    case _video.ABORT:
	    case _video.EMPTIED:
	    case _video.STALLED:
	    case _video.LOADED_META_DATA:
	    case _video.LOADED_DATA:
	    case _video.RESIZE:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps);
	
	    case _video.ACTIVATE_TEXT_TRACK:
	      return (0, _objectSpread2["default"])({}, state, {
	        activeTextTrack: action.textTrack
	      });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = void 0;
	var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : ''; // const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
	// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
	
	/*
	 * Device is an iPhone
	 *
	 * @type {Boolean}
	 * @constant
	 * @private
	 */
	
	var IS_IPAD = /iPad/i.test(USER_AGENT); // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
	// to identify iPhones, we need to exclude iPads.
	// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
	
	exports.IS_IPAD = IS_IPAD;
	var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	exports.IS_IPHONE = IS_IPHONE;
	var IS_IPOD = /iPod/i.test(USER_AGENT);
	exports.IS_IPOD = IS_IPOD;
	var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
	exports.IS_IOS = IS_IOS;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(2007);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 2007 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _objectSpread = __webpack_require__(2010);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
	
	/**
	 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
	 *
	 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
	 * during build.
	 * @param {number} code
	 */
	function formatProdErrorMessage(code) {
	  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
	}
	
	// Inlined version of the `symbol-observable` polyfill
	var $$observable = (function () {
	  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
	})();
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
	function miniKindOf(val) {
	  if (val === void 0) return 'undefined';
	  if (val === null) return 'null';
	  var type = typeof val;
	
	  switch (type) {
	    case 'boolean':
	    case 'string':
	    case 'number':
	    case 'symbol':
	    case 'function':
	      {
	        return type;
	      }
	  }
	
	  if (Array.isArray(val)) return 'array';
	  if (isDate(val)) return 'date';
	  if (isError(val)) return 'error';
	  var constructorName = ctorName(val);
	
	  switch (constructorName) {
	    case 'Symbol':
	    case 'Promise':
	    case 'WeakMap':
	    case 'WeakSet':
	    case 'Map':
	    case 'Set':
	      return constructorName;
	  } // other
	
	
	  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
	}
	
	function ctorName(val) {
	  return typeof val.constructor === 'function' ? val.constructor.name : null;
	}
	
	function isError(val) {
	  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
	}
	
	function isDate(val) {
	  if (val instanceof Date) return true;
	  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
	}
	
	function kindOf(val) {
	  var typeOfVal = typeof val;
	
	  if (false) {
	    typeOfVal = miniKindOf(val);
	  }
	
	  return typeOfVal;
	}
	
	/**
	 * @deprecated
	 *
	 * **We recommend using the `configureStore` method
	 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
	 *
	 * Redux Toolkit is our recommended approach for writing Redux logic today,
	 * including store setup, reducers, data fetching, and more.
	 *
	 * **For more details, please read this Redux docs page:**
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
	 * simplifies setup and helps avoid common bugs.
	 *
	 * You should not be using the `redux` core package by itself today, except for learning purposes.
	 * The `createStore` method from the core `redux` package will not be removed, but we encourage
	 * all users to migrate to using Redux Toolkit for all Redux code.
	 *
	 * If you want to use `createStore` without this visual deprecation warning, use
	 * the `legacy_createStore` import instead:
	 *
	 * `import { legacy_createStore as createStore} from 'redux'`
	 *
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	/**
	 * Creates a Redux store that holds the state tree.
	 *
	 * **We recommend using `configureStore` from the
	 * `@reduxjs/toolkit` package**, which replaces `createStore`:
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	var legacy_createStore = createStore;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var actionType = action && action.type;
	        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread__default['default'](_objectSpread__default['default']({}, store), {}, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;
	exports.legacy_createStore = legacy_createStore;


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(2012);
	function _defineProperty(obj, key, value) {
	  key = toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(2009);
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    enumerableOnly && (symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    })), keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = null != arguments[i] ? arguments[i] : {};
	    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
	      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	    });
	  }
	  return target;
	}
	module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(759)["default"];
	function _toPrimitive(input, hint) {
	  if (_typeof(input) !== "object" || input === null) return input;
	  var prim = input[Symbol.toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}
	module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(759)["default"];
	var toPrimitive = __webpack_require__(2011);
	function _toPropertyKey(arg) {
	  var key = toPrimitive(arg, "string");
	  return _typeof(key) === "symbol" ? key : String(key);
	}
	module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(2014)
	var ieee754 = __webpack_require__(2015)
	var isArray = __webpack_require__(2016)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2014 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ }),
/* 2015 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 2016 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 2017 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(170)))

/***/ })
]);


// WEBPACK FOOTER //
// js/bundle.55df402639e23be1cc22.js